
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("6kSlS", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "IssueCreateAppWithApolloProviderEntrypoint", () => $cee6ecf70658ed7d$export$bdacb64dcf3c214f);
$parcel$export(module.exports, "default", () => $cee6ecf70658ed7d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "ApolloClientProvider", () => (parcelRequire("eU7vk")).ApolloClientProvider);
$parcel$export(module.exports, "IssueCreateModal", () => (parcelRequire("gyxWD")).default);
$parcel$export(module.exports, "messages", () => (parcelRequire("bSiPa")).default);

var $eJOHy = parcelRequire("eJOHy");


var $eU7vk = parcelRequire("eU7vk");

var $4NEt5 = parcelRequire("4NEt5");

var $7H819 = parcelRequire("7H819");

var $1Qu1D = parcelRequire("1Qu1D");

var $jipjz = parcelRequire("jipjz");

var $gtCj5 = parcelRequire("gtCj5");

var $7jTnu = parcelRequire("7jTnu");

var $bSiPa = parcelRequire("bSiPa");

var $5mlja = parcelRequire("5mlja");

var $7ZURF = parcelRequire("7ZURF");

var $kIDUp = parcelRequire("kIDUp");

var $fEXnq = parcelRequire("fEXnq");

var $gyxWD = parcelRequire("gyxWD");
const $cee6ecf70658ed7d$var$onResetApolloCache = ()=>(0, $eU7vk.resetCache)((0, $bd25ba88693dbfbe$export$9c9ee93e509f8666));
const $cee6ecf70658ed7d$var$IssueCreateAppWithApolloProvider = ({ onError: onError, shouldForceCheckIsModalOpen: shouldForceCheckIsModalOpen = false })=>{
    const [{ isModalOpen: isModalOpen }] = (0, $jipjz.useTriggerIssueCreateModal)();
    const { deleteIssueRestoreMeta: deleteIssueRestoreMeta } = (0, $1Qu1D.useIssueRestoreMetaService)();
    const _onError = (0, $eJOHy.useCallback)(()=>{
        onError?.();
        deleteIssueRestoreMeta();
    }, [
        onError,
        deleteIssueRestoreMeta
    ]);
    const { giraClient: giraClient } = (0, $7ZURF.useIssueCreateFromAnywhereContext)();
    (0, $kIDUp.usePublishUseTriggerIssueCreateModalChange)();
    (0, $7H819.usePublishFormContext)();
    const renderIssueCreateModal = ({ onTransformCreateFormProps: onTransformCreateFormProps, setShouldRestore: setShouldRestore } = {})=>{
        if (isModalOpen) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gyxWD.default), {
            onTransformCreateFormProps: onTransformCreateFormProps,
            setShouldRestore: setShouldRestore,
            onResetApolloCache: $cee6ecf70658ed7d$var$onResetApolloCache
        });
        return null;
    };
    const attributes = (0, $eJOHy.useMemo)(()=>({
            isModalOpen: isModalOpen,
            shouldForceCheckIsModalOpen: shouldForceCheckIsModalOpen
        }), [
        isModalOpen,
        shouldForceCheckIsModalOpen
    ]);
    if (// don't render IssueCreate unless the modal is open
    // this fixes problems with loading the correct data for pre-selected sites
    // this is a hot fix to prevent the modal from not opening when it should (you read that right, see HOT-113496)
    shouldForceCheckIsModalOpen && !isModalOpen) return;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4NEt5.JiraIssueCreateErrorBoundary), {
        id: "issue-create-app",
        packageName: "jiraIssueCreate",
        fallback: "flag",
        onError: _onError,
        sendToPrivacyUnsafeSplunk: true,
        attributes: ()=>({
                ...(0, $gtCj5.getAdditionalAttributes)(),
                ...(0, $7jTnu.fg)('jira-issue-create-error-boundary-enabled') ? attributes : {}
            }),
        taskName: "viewGlobalIssueCreateModal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eU7vk.ApolloClientProvider), {
        client: giraClient
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5mlja.NavigationDiscardChangesContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fEXnq.IssueRestoreWrapper), null, ({ onTransformCreateFormProps: onTransformCreateFormProps, setShouldRestore: setShouldRestore })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4NEt5.JiraIssueCreateErrorBoundary), {
            id: "issue-create-app-children",
            packageName: "jiraIssueCreate",
            fallback: "flag",
            onError: _onError,
            sendToPrivacyUnsafeSplunk: true,
            attributes: ()=>({
                    ...(0, $gtCj5.getAdditionalAttributes)(),
                    ...(0, $7jTnu.fg)('jira-issue-create-error-boundary-enabled') ? attributes : {}
                }),
            taskName: "viewGlobalIssueCreateModal"
        }, renderIssueCreateModal({
            onTransformCreateFormProps: onTransformCreateFormProps,
            setShouldRestore: setShouldRestore
        }))))));
};
const $cee6ecf70658ed7d$export$bdacb64dcf3c214f = ({ props: props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cee6ecf70658ed7d$var$IssueCreateAppWithApolloProvider, props);
};
var $cee6ecf70658ed7d$export$2e2bcd8739ae039 = $cee6ecf70658ed7d$var$IssueCreateAppWithApolloProvider;

});
const $bd25ba88693dbfbe$export$2eeebb625d70ae49 = 'SWAG';
const $bd25ba88693dbfbe$export$9c9ee93e509f8666 = 'gira';
const $bd25ba88693dbfbe$export$14a05c678c2af272 = 'REST';
const $bd25ba88693dbfbe$export$b19c7b383ca04a4d = 'POLARIS';

parcelRegister("eU7vk", function(module, exports) {

$parcel$export(module.exports, "resetCache", () => $fbd5fc7ffb4125dd$export$6e5dca841bdf93e3);
$parcel$export(module.exports, "resetCacheAsync", () => $fbd5fc7ffb4125dd$export$cd62f60830f74ae2);
$parcel$export(module.exports, "getClient", () => $fbd5fc7ffb4125dd$export$6bb76d6eba7e258c);
$parcel$export(module.exports, "ApolloClientProvider", () => $fbd5fc7ffb4125dd$export$8e363dbef886ff17);

var $eJOHy = parcelRequire("eJOHy");

var $9Dhvc = parcelRequire("9Dhvc");

var $688i3 = parcelRequire("688i3");
const $fbd5fc7ffb4125dd$var$CLIENTS_CACHE = {};
const $fbd5fc7ffb4125dd$export$6e5dca841bdf93e3 = (clientId)=>{
    // we need to `clearStore` directly to the InMemoryCache instance
    $fbd5fc7ffb4125dd$var$CLIENTS_CACHE[clientId]?.clearStore();
    delete $fbd5fc7ffb4125dd$var$CLIENTS_CACHE[clientId];
};
const $fbd5fc7ffb4125dd$export$cd62f60830f74ae2 = async (clientId)=>{
    // we need to `clearStore` directly to the InMemoryCache instance
    const client = $fbd5fc7ffb4125dd$var$CLIENTS_CACHE[clientId];
    delete $fbd5fc7ffb4125dd$var$CLIENTS_CACHE[clientId];
    await client?.clearStore();
};
const $fbd5fc7ffb4125dd$export$44dd3e9494f887fc = ()=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys($fbd5fc7ffb4125dd$var$CLIENTS_CACHE).reduce((acc, key)=>Object.assign(acc, {
            [`apollo-cache/${key}`]: $fbd5fc7ffb4125dd$var$CLIENTS_CACHE[key].extract()
        }), {});
const $fbd5fc7ffb4125dd$export$6bb76d6eba7e258c = ({ clientId: clientId, clientCreator: clientCreator })=>{
    let client = $fbd5fc7ffb4125dd$var$CLIENTS_CACHE[clientId];
    if (!client) {
        client = clientCreator();
        $fbd5fc7ffb4125dd$var$CLIENTS_CACHE[clientId] = client;
    }
    return client;
};
class $fbd5fc7ffb4125dd$export$8e363dbef886ff17 extends (0, $eJOHy.Component) {
    getClient() {
        return $fbd5fc7ffb4125dd$export$6bb76d6eba7e258c(this.props.client);
    }
    render() {
        const { children: children } = this.props;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(this.props, 'client.clientId')) throw new Error('Please provide a client configuration');
        const client = this.getClient();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $688i3.ApolloProvider), {
            client: client
        }, children);
    }
}

});
parcelRegister("688i3", function(module, exports) {

$parcel$export(module.exports, "getApolloContext", () => $4769ebafec57fcc9$export$a47505d961ee3a1);
$parcel$export(module.exports, "ApolloProvider", () => $4769ebafec57fcc9$export$c16b04c8a9956446);
$parcel$export(module.exports, "DocumentType", () => $4769ebafec57fcc9$export$d1d99cf900472499);
$parcel$export(module.exports, "operationName", () => $4769ebafec57fcc9$export$5db520940cf00715);
$parcel$export(module.exports, "parser", () => $4769ebafec57fcc9$export$8f49e4af10703ce3);

var $eJOHy = parcelRequire("eJOHy");

var $lDEi6 = parcelRequire("lDEi6");
var $4769ebafec57fcc9$var$apolloContext;
function $4769ebafec57fcc9$export$a47505d961ee3a1() {
    if (!$4769ebafec57fcc9$var$apolloContext) $4769ebafec57fcc9$var$apolloContext = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext({});
    return $4769ebafec57fcc9$var$apolloContext;
}
function $4769ebafec57fcc9$export$c2ee824bcc89ca6a() {
    $4769ebafec57fcc9$var$apolloContext = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext({});
}
var $4769ebafec57fcc9$export$c16b04c8a9956446 = function(_a) {
    var client = _a.client, children = _a.children;
    var ApolloContext = $4769ebafec57fcc9$export$a47505d961ee3a1();
    return (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ApolloContext.Consumer, null, function(context) {
        if (context === void 0) context = {};
        if (client && context.client !== client) context = Object.assign({}, context, {
            client: client
        });
        (0, $lDEi6.invariant)(context.client, 5);
        return (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ApolloContext.Provider, {
            value: context
        }, children);
    });
};
var $4769ebafec57fcc9$export$ed5ceab8c2bb5ce4 = function(props) {
    var ApolloContext = $4769ebafec57fcc9$export$a47505d961ee3a1();
    return (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ApolloContext.Consumer, null, function(context) {
        (0, $lDEi6.invariant)(context && context.client, 6);
        return props.children(context.client);
    });
};
var $4769ebafec57fcc9$export$d1d99cf900472499;
(function(DocumentType) {
    DocumentType[DocumentType["Query"] = 0] = "Query";
    DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
    DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
})($4769ebafec57fcc9$export$d1d99cf900472499 || ($4769ebafec57fcc9$export$d1d99cf900472499 = {}));
var $4769ebafec57fcc9$var$cache = new Map();
function $4769ebafec57fcc9$export$5db520940cf00715(type) {
    var name;
    switch(type){
        case $4769ebafec57fcc9$export$d1d99cf900472499.Query:
            name = 'Query';
            break;
        case $4769ebafec57fcc9$export$d1d99cf900472499.Mutation:
            name = 'Mutation';
            break;
        case $4769ebafec57fcc9$export$d1d99cf900472499.Subscription:
            name = 'Subscription';
            break;
    }
    return name;
}
function $4769ebafec57fcc9$export$8f49e4af10703ce3(document) {
    var cached = $4769ebafec57fcc9$var$cache.get(document);
    if (cached) return cached;
    var variables, type, name;
    (0, $lDEi6.invariant)(!!document && !!document.kind, 1);
    var fragments = document.definitions.filter(function(x) {
        return x.kind === 'FragmentDefinition';
    });
    var queries = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'query';
    });
    var mutations = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'mutation';
    });
    var subscriptions = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'subscription';
    });
    (0, $lDEi6.invariant)(!fragments.length || queries.length || mutations.length || subscriptions.length, 2);
    (0, $lDEi6.invariant)(queries.length + mutations.length + subscriptions.length <= 1, 3);
    type = queries.length ? $4769ebafec57fcc9$export$d1d99cf900472499.Query : $4769ebafec57fcc9$export$d1d99cf900472499.Mutation;
    if (!queries.length && !mutations.length) type = $4769ebafec57fcc9$export$d1d99cf900472499.Subscription;
    var definitions = queries.length ? queries : mutations.length ? mutations : subscriptions;
    (0, $lDEi6.invariant)(definitions.length === 1, 4);
    var definition = definitions[0];
    variables = definition.variableDefinitions || [];
    if (definition.name && definition.name.kind === 'Name') name = definition.name.value;
    else name = 'data';
    var payload = {
        name: name,
        type: type,
        variables: variables
    };
    $4769ebafec57fcc9$var$cache.set(document, payload);
    return payload;
}

});


parcelRegister("7H819", function(module, exports) {

$parcel$export(module.exports, "usePublishFormContext", () => $de6418ad6327e6f7$export$9454401a65fa3f6c);

var $eJOHy = parcelRequire("eJOHy");

var $xMjNG = parcelRequire("xMjNG");

var $4PKlm = parcelRequire("4PKlm");

var $jQUoP = parcelRequire("jQUoP");
const $de6418ad6327e6f7$export$9454401a65fa3f6c = ()=>{
    const [state] = (0, $jQUoP.useFormContext)();
    const { publish: publish } = (0, $4PKlm.useGICLifeCycleEvents)();
    (0, $eJOHy.useEffect)(()=>{
        publish((0, $xMjNG.GIC_LIFECYCLE_EVENTS).FORM_CONTEXT_STATE_CHANGE, state);
    }, [
        publish,
        state
    ]);
};

});
parcelRegister("xMjNG", function(module, exports) {

$parcel$export(module.exports, "GIC_LIFECYCLE_EVENTS", () => $6988db3fd722d63c$export$876003a5b887f37e);
const $6988db3fd722d63c$export$876003a5b887f37e = {
    MODAL_OPENED: 'MODAL_OPENED',
    MODAL_CLOSED: 'MODAL_CLOSED',
    MODAL_KEEP_EDITING_EXISTING_ISSUE: 'MODAL_KEEP_EDITING',
    MODAL_DISCARD_EXISTING_IN_PROGRESS_ISSUE: 'MODAL_DISCARD',
    MODAL_DISCARD_SUGGESTED_ISSUE: 'MODAL_DISCARD_SUGGESTED_ISSUE',
    MODAL_DISCARD_SUGGESTED_ISSUE_CHANGES: 'MODAL_DISCARD_SUGGESTED_ISSUE_CHANGES',
    MODAL_DISCARD_ALL_SUGGESTED_ISSUES: 'MODAL_DISCARD_ALL_SUGGESTED_ISSUES',
    CREATE_FORM_FIELD_CONFIG_UPDATE: 'CREATE_FORM_FIELD_CONFIG_UPDATE',
    CREATE_FORM_FIELD_VALUE_CHANGE: 'CREATE_FORM_FIELD_VALUE_CHANGE',
    ISSUE_CREATE_SUCCESS: 'ISSUE_CREATE_SUCCESS',
    PROJECT_FIELD_VALUE_CHANGE: 'PROJECT_FIELD_VALUE_CHANGE',
    ISSUE_TYPE_FIELD_VALUE_CHANGE: 'ISSUE_TYPE_FIELD_VALUE_CHANGE',
    RESET_FORM_FIELDS_FOR_CREATE_ANOTHER: 'RESET_FORM_FIELDS_FOR_CREATE_ANOTHER',
    USE_TRIGGER_ISSUE_CREATE_MODAL_STATE_CHANGE: 'USE_TRIGGER_ISSUE_CREATE_MODAL_STATE_CHANGE',
    STATUS_FIELD_STATE_CHANGE: 'STATUS_FIELD_STATE_CHANGE',
    CREATE_FORM_FIELD_BLUR: 'CREATE_FORM_FIELD_BLUR',
    CLASSIFICATION_LEVEL_FIELD_CHANGE: 'CLASSIFICATION_LEVEL_FIELD_CHANGE',
    FORM_CONTEXT_STATE_CHANGE: 'FORM_CONTEXT_STATE_CHANGE'
};

});

parcelRegister("4PKlm", function(module, exports) {

$parcel$export(module.exports, "useGICLifeCycleEvents", () => $8e36a2abc6a32ec2$export$e3ff72f196296fcc);

var $8Urkc = parcelRequire("8Urkc");
const $8e36a2abc6a32ec2$var$GICLifeCycleEventsService = new (0, $8Urkc.PubSubHub)();
const $8e36a2abc6a32ec2$export$e3ff72f196296fcc = ()=>({
        ...$8e36a2abc6a32ec2$var$GICLifeCycleEventsService
    });

});
parcelRegister("8Urkc", function(module, exports) {

$parcel$export(module.exports, "PubSubHub", () => $ef124bfbd3a417bb$export$e3607828f8f2c01e);
class $ef124bfbd3a417bb$export$e3607828f8f2c01e {
    constructor(){
        this.subscribers = {};
        this.subscribe = (event, subscriber)=>{
            let subs = this.subscribers[event];
            if (!subs) {
                subs = [];
                this.subscribers[event] = subs;
            }
            subs?.push(subscriber);
            return ()=>this.unsubscribe(event, subscriber);
        };
        this.unsubscribe = (event, subscriber)=>{
            const subs = this.subscribers[event];
            if (subs) this.subscribers[event] = subs.filter((subscription)=>subscription !== subscriber);
        };
        this.publish = (event, data)=>{
            const subs = this.subscribers[event];
            if (subs?.length) subs?.forEach((subscriber)=>subscriber(data));
        };
        this.clearAll = ()=>{
            this.subscribers = {};
        };
    }
}

});


parcelRegister("jQUoP", function(module, exports) {

$parcel$export(module.exports, "useCreateFormState", () => $c9f1792eeeb99d8a$export$64ff4e8b244effca);
$parcel$export(module.exports, "useFormContext", () => $c9f1792eeeb99d8a$export$4d957a5e1be13b03);
$parcel$export(module.exports, "useFormContextActions", () => $c9f1792eeeb99d8a$export$8b2a836c011f987c);
$parcel$export(module.exports, "useFormContextInteractedFields", () => $c9f1792eeeb99d8a$export$43c5716796c2329e);
$parcel$export(module.exports, "useIsCollapsedAreaExpanded", () => $c9f1792eeeb99d8a$export$ee8f126c0e25d653);
$parcel$export(module.exports, "useIsSmartFieldsNew", () => $c9f1792eeeb99d8a$export$52b9b0c902b0ae2b);
$parcel$export(module.exports, "useIssueType", () => $c9f1792eeeb99d8a$export$6c4c9b3e84687e41);

var $jFHCE = parcelRequire("jFHCE");

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $c9f1792eeeb99d8a$export$d4c72bab9d6cc13a = {
    selectedProject: null,
    selectedIssueType: null,
    requestBackedIssueType: null,
    isEpicLinkSelected: false,
    isSubmitting: false,
    isOperationInProgress: false,
    shouldShowConfigureFieldModal: false,
    shouldShowFindFieldModal: false,
    meta: {
        areRequiredFieldsSupported: true,
        queryErrorMessage: '',
        submitErrorMessage: '',
        submitFieldwiseErrors: {},
        inlineCreateError: null
    },
    dataFetchError: null,
    isFormDirty: false,
    areConfiguredFieldsModified: false,
    timeTrackingValue: '',
    ecosystem: {
        forge: {
            customFields: [],
            filteredOutModules: [],
            hasFinishedLoading: false
        }
    },
    currentActiveTabIndex: 0,
    shouldAutoFocus: true,
    resetFormAction: null,
    isForgeFieldsDetected: false,
    canCreateAnotherIssue: false,
    createdIssues: [],
    watchers: [],
    interactedFields: {},
    expandedCollapsedAreas: [],
    isSmartFieldsNew: undefined,
    isSmartFieldsToggled: false,
    isFormLoaded: false
};
const $c9f1792eeeb99d8a$export$e324594224ef24da = {
    restoreState: (state)=>({ setState: setState })=>{
            setState((0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(state, [
                'isSubmitting',
                'isOperationInProgress'
            ]));
        },
    setCurrentActiveTabIndex: (tabIndex)=>({ setState: setState, getState: getState })=>{
            const { currentActiveTabIndex: currentActiveTabIndex } = getState();
            if (tabIndex >= 0 && currentActiveTabIndex !== tabIndex) setState({
                currentActiveTabIndex: tabIndex
            });
        },
    // To enable/disable autofocus of the "create issue" form element - https://a11y.atlassian.net/browse/JCA11Y-318
    setShouldAutoFocus: (shouldAutoFocus)=>({ setState: setState })=>{
            setState({
                shouldAutoFocus: shouldAutoFocus
            });
        },
    setSelectedProject: (project)=>({ setState: setState })=>{
            setState({
                selectedProject: project
            });
        },
    setSelectedIssueType: (issueType)=>({ setState: setState })=>{
            setState({
                selectedIssueType: issueType
            });
        },
    setRequestBackedIssueType: (issueType)=>({ setState: setState })=>{
            setState({
                requestBackedIssueType: issueType
            });
        },
    setIsEpicLinkSelected: (isEpicLinkSelected)=>({ setState: setState })=>{
            setState({
                isEpicLinkSelected: isEpicLinkSelected
            });
        },
    setMeta: (meta)=>({ setState: setState })=>{
            setState({
                meta: meta
            });
        },
    setSubmitErrorMessage: (submitErrorMessage)=>({ setState: setState, getState: getState })=>{
            const { meta: meta } = getState();
            setState({
                meta: {
                    ...meta,
                    submitErrorMessage: submitErrorMessage
                }
            });
        },
    setTimeTrackingValue: (timeTrackingValue)=>({ setState: setState })=>{
            setState({
                timeTrackingValue: timeTrackingValue
            });
        },
    setSubmitFieldwiseErrors: (fieldwiseErrors)=>({ setState: setState, getState: getState })=>{
            const { meta: meta } = getState();
            setState({
                meta: {
                    ...meta,
                    submitFieldwiseErrors: fieldwiseErrors
                }
            });
        },
    setInlineErrorMessage: (inlineCreateError)=>({ setState: setState, getState: getState })=>{
            const { meta: meta } = getState();
            setState({
                meta: {
                    ...meta,
                    inlineCreateError: inlineCreateError
                }
            });
        },
    setSubmitting: (isSubmitting)=>({ setState: setState })=>{
            setState({
                isSubmitting: isSubmitting
            });
        },
    setIsOperationInProgress: (isOperationInProgress)=>({ setState: setState })=>{
            setState({
                isOperationInProgress: isOperationInProgress
            });
        },
    toggleConfigureFieldsModalVisibility: (shouldShowConfigureFieldModal)=>({ setState: setState })=>{
            setState({
                shouldShowConfigureFieldModal: shouldShowConfigureFieldModal
            });
        },
    toggleFindFieldsModalVisibility: (shouldShowFindFieldModal)=>({ setState: setState })=>{
            setState({
                shouldShowFindFieldModal: shouldShowFindFieldModal
            });
        },
    resetFormContext: ()=>({ setState: setState })=>{
            setState({
                ...$c9f1792eeeb99d8a$export$d4c72bab9d6cc13a
            });
        },
    setDataFetchError: (error)=>({ setState: setState })=>{
            setState({
                dataFetchError: error
            });
        },
    setIsFormDirty: (isFormDirty)=>({ setState: setState })=>{
            setState({
                isFormDirty: isFormDirty
            });
        },
    setAreConfiguredFieldsModified: (areConfiguredFieldsModified)=>({ setState: setState })=>{
            setState({
                areConfiguredFieldsModified: areConfiguredFieldsModified
            });
        },
    setForgeModules: (customFields, filteredOutModules, hasFinishedLoading)=>({ setState: setState, getState: getState })=>{
            const { ecosystem: ecosystem } = getState();
            setState({
                ecosystem: {
                    ...ecosystem,
                    forge: {
                        customFields: customFields,
                        hasFinishedLoading: !!hasFinishedLoading,
                        filteredOutModules: filteredOutModules
                    }
                }
            });
        },
    setResetFormAction: (resetFormAction)=>({ setState: setState })=>{
            setState({
                resetFormAction: resetFormAction
            });
        },
    setIsForgeFieldsDetected: (isForgeFieldsDetected)=>({ setState: setState })=>{
            setState({
                isForgeFieldsDetected: isForgeFieldsDetected
            });
        },
    setCanCreateAnotherIssue: (canCreateAnotherIssue)=>({ setState: setState })=>{
            setState({
                canCreateAnotherIssue: canCreateAnotherIssue
            });
        },
    addCreatedIssue: (createdIssue)=>({ getState: getState, setState: setState })=>{
            const { createdIssues: createdIssues } = getState();
            const mergedCreatedIssues = [
                ...createdIssues,
                createdIssue
            ];
            setState({
                createdIssues: mergedCreatedIssues
            });
            return mergedCreatedIssues;
        },
    setWatchers: (watchers)=>({ setState: setState })=>{
            setState({
                watchers: watchers
            });
        },
    setInteractedWithField: (fieldId)=>({ setState: setState, getState: getState })=>{
            const { interactedFields: interactedFields } = getState();
            setState({
                interactedFields: {
                    ...interactedFields,
                    [fieldId]: true
                }
            });
        },
    setExpandedCollapsedArea: (index, shouldExpand)=>({ setState: setState, getState: getState })=>{
            const { expandedCollapsedAreas: expandedCollapsedAreas } = getState();
            const newExpandedCollapsedAreas = expandedCollapsedAreas.slice(0);
            const isCurrentExpanded = expandedCollapsedAreas.includes(index);
            let shouldUpdate = false;
            if (!isCurrentExpanded && shouldExpand) {
                newExpandedCollapsedAreas.push(index);
                shouldUpdate = true;
            }
            if (isCurrentExpanded && !shouldExpand) {
                newExpandedCollapsedAreas.splice(newExpandedCollapsedAreas.indexOf(index), 1);
                shouldUpdate = true;
            }
            if (shouldUpdate) setState({
                expandedCollapsedAreas: newExpandedCollapsedAreas
            });
        },
    resetExpandedCollapsedArea: ()=>({ setState: setState })=>{
            setState({
                expandedCollapsedAreas: []
            });
        },
    setIsSmartFieldsNew: (isSmartFieldsNew)=>({ setState: setState })=>{
            setState({
                isSmartFieldsNew: isSmartFieldsNew
            });
        },
    setIsSmartFieldsToggled: (isSmartFieldsToggled)=>({ setState: setState })=>{
            setState({
                isSmartFieldsToggled: isSmartFieldsToggled
            });
        },
    setIsFormLoaded: (isFormLoaded)=>({ setState: setState })=>{
            setState({
                isFormLoaded: isFormLoaded
            });
        }
};
const $c9f1792eeeb99d8a$var$store = (0, $GtRbT.createStore)({
    name: 'issue-create.issue-create-form.form-context',
    initialState: $c9f1792eeeb99d8a$export$d4c72bab9d6cc13a,
    actions: $c9f1792eeeb99d8a$export$e324594224ef24da
});
const $c9f1792eeeb99d8a$export$e6a162613d6e6e63 = (state)=>{
    const { selectedProject: selectedProject, selectedIssueType: selectedIssueType, meta: meta, areConfiguredFieldsModified: areConfiguredFieldsModified, requestBackedIssueType: requestBackedIssueType, isFormDirty: isFormDirty } = state;
    return {
        selectedProject: selectedProject,
        selectedIssueType: selectedIssueType,
        requestBackedIssueType: requestBackedIssueType,
        meta: meta,
        areConfiguredFieldsModified: areConfiguredFieldsModified,
        isFormDirty: isFormDirty
    };
};
const $c9f1792eeeb99d8a$export$64ff4e8b244effca = (0, $iJq0l.createHook)($c9f1792eeeb99d8a$var$store, {
    selector: $c9f1792eeeb99d8a$export$e6a162613d6e6e63
});
const $c9f1792eeeb99d8a$export$4d957a5e1be13b03 = (0, $iJq0l.createHook)($c9f1792eeeb99d8a$var$store);
const $c9f1792eeeb99d8a$export$8b2a836c011f987c = (0, $iJq0l.createActionsHook)($c9f1792eeeb99d8a$var$store);
const $c9f1792eeeb99d8a$var$getInteractedFieldsSelector = (state)=>state.interactedFields;
const $c9f1792eeeb99d8a$export$43c5716796c2329e = (0, $iJq0l.createHook)($c9f1792eeeb99d8a$var$store, {
    selector: $c9f1792eeeb99d8a$var$getInteractedFieldsSelector
});
const $c9f1792eeeb99d8a$var$getIsCollapsedAreaExpandedSelector = (state, index)=>state.expandedCollapsedAreas.includes(index);
const $c9f1792eeeb99d8a$export$ee8f126c0e25d653 = (0, $iJq0l.createHook)($c9f1792eeeb99d8a$var$store, {
    selector: (state, index)=>$c9f1792eeeb99d8a$var$getIsCollapsedAreaExpandedSelector(state, index)
});
const $c9f1792eeeb99d8a$export$52b9b0c902b0ae2b = (0, $iJq0l.createHook)($c9f1792eeeb99d8a$var$store, {
    selector: (state)=>state.isSmartFieldsNew
});
const $c9f1792eeeb99d8a$export$6c4c9b3e84687e41 = (0, $iJq0l.createHook)($c9f1792eeeb99d8a$var$store, {
    selector: (state)=>state.selectedIssueType
});

});


parcelRegister("1Qu1D", function(module, exports) {

$parcel$export(module.exports, "useIssueRestoreMetaService", () => $47ed4ed647205795$export$8f688cfe533ab228);

var $eJOHy = parcelRequire("eJOHy");

var $4elgJ = parcelRequire("4elgJ");

const $47ed4ed647205795$var$KEY = 'issue-restore-meta';
const $47ed4ed647205795$export$8f688cfe533ab228 = ()=>{
    const [storage] = (0, $eJOHy.useState)((0, $4elgJ.createSessionStorageProvider)(`${(0, $156089ffb832620f$export$8fa5032778cf7801)}`));
    return {
        getIssueRestoreMeta: async ()=>storage.get($47ed4ed647205795$var$KEY),
        createIssueRestoreMeta: async (data)=>{
            storage.set($47ed4ed647205795$var$KEY, data);
            return data;
        },
        updateIssueRestoreMeta: async (data)=>{
            storage.set($47ed4ed647205795$var$KEY, data);
            return data;
        },
        deleteIssueRestoreMeta: async ()=>{
            storage.remove($47ed4ed647205795$var$KEY);
        }
    };
};

});
const $156089ffb832620f$export$8fa5032778cf7801 = 'jira-issue-create-restore-';


parcelRegister("gtCj5", function(module, exports) {

$parcel$export(module.exports, "getAdditionalAttributes", () => $366a643a55d1deec$export$f10870c4dfdab6a9);

var $hWeHP = parcelRequire("hWeHP");

var $lopBx = parcelRequire("lopBx");
const $366a643a55d1deec$export$f10870c4dfdab6a9 = ()=>{
    const shard = (0, $hWeHP.default)('ajs-shard');
    const region = (0, $hWeHP.default)('ajs-region');
    return {
        shard: shard,
        region: region,
        isFedRamp: (0, $lopBx.isFedRamp)()
    };
};

});

parcelRegister("bSiPa", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd25f7dd98d53bb6$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $cd25f7dd98d53bb6$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    noSummary: {
        "id": "issue-create.common.no-summary",
        "defaultMessage": "(No summary)"
    },
    noSummaryWithIssueType: {
        "id": "issue-create.common.no-summary-with-issue-type",
        "defaultMessage": "{issueType, select,\n            Task {New task}\n            Subtask {New subtask}\n            Story {New story}\n            Bug {New bug}\n            Epic {New epic}\n            Idea {New idea}\n            Request {New request}\n            other {{issueType}}\n        }"
    },
    resizeSpotlightMessage: {
        "id": "issue-create.common.resize-spotlight-message",
        "defaultMessage": "Resize or minimize your issue to pause editing and navigate around Jira."
    },
    resizeSpotlightMessageIssueTermRefresh: {
        "id": "issue-create.common.resize-spotlight-message-issue-term-refresh",
        "defaultMessage": "Resize or minimize your work item to pause editing and navigate around Jira."
    },
    miniModalSpotlightMessage: {
        "id": "issue-create.common.mini-modal-spotlight-message",
        "defaultMessage": "Create work in context and navigate your project without losing progress using the new create experience.{br}Expand to see the full view, or minimize to revisit it later. "
    },
    miniModalSpotlightActionMessage: {
        "id": "issue-create.common.mini-modal-spotlight-action-message",
        "defaultMessage": "Got it"
    },
    miniModalSpotlightHeading: {
        "id": "issue-create.common.mini-modal-spotlight-heading",
        "defaultMessage": "Multitasking made easy"
    },
    noSummaryWithIssueTypeIssueTermRefresh: {
        "id": "issue-create.common.no-summary-with-issue-type-issue-term-refresh",
        "defaultMessage": "{issueType, select,\n            Task {New task}\n            Subtask {New subtask}\n            Story {New story}\n            Bug {New bug}\n            Epic {New epic}\n            Idea {New idea}\n            Request {New request}\n            other {{issueType}}\n        }"
    }
});

});

parcelRegister("5mlja", function(module, exports) {

$parcel$export(module.exports, "NavigationDiscardChangesContainer", () => $abd21d994e7247b3$export$6b9c176805b3c455);
$parcel$export(module.exports, "useNavigationDiscardChanges", () => $abd21d994e7247b3$export$bf0dbeb75772072);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");

var $iHS1Q = parcelRequire("iHS1Q");
const $abd21d994e7247b3$export$d4c72bab9d6cc13a = {
    deferredNavigationLink: ''
};
const $abd21d994e7247b3$var$store = (0, $GtRbT.createStore)({
    name: 'NavigationDiscardChanges',
    initialState: $abd21d994e7247b3$export$d4c72bab9d6cc13a,
    actions: $iHS1Q.actions
});
const $abd21d994e7247b3$export$6b9c176805b3c455 = (0, $6E16M.createContainer)($abd21d994e7247b3$var$store);
const $abd21d994e7247b3$export$bf0dbeb75772072 = (0, $iJq0l.createHook)($abd21d994e7247b3$var$store);
const $abd21d994e7247b3$export$9f61952484b5dffe = (0, $iJq0l.createActionsHook)($abd21d994e7247b3$var$store);

});
parcelRegister("iHS1Q", function(module, exports) {

$parcel$export(module.exports, "actions", () => $5e8c8423ee966418$export$e324594224ef24da);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $5e8c8423ee966418$export$a750007c2edb3b26 = (deferredNavigationLink)=>({ setState: setState })=>setState({
            deferredNavigationLink: deferredNavigationLink
        });
const $5e8c8423ee966418$export$e324594224ef24da = {
    setDeferredNavigationLink: $5e8c8423ee966418$export$a750007c2edb3b26
};

});


parcelRegister("7ZURF", function(module, exports) {

$parcel$export(module.exports, "useIssueCreateFromAnywhereContext", () => $d4b9e90d7a1d3096$export$f99899ced542f49a);

var $eJOHy = parcelRequire("eJOHy");

var $5Q8dn = parcelRequire("5Q8dn");

var $5acEa = parcelRequire("5acEa");

var $bitlK = parcelRequire("bitlK");
const $d4b9e90d7a1d3096$export$4cea60a165c59df0 = ()=>(0, $5Q8dn.default);
const $d4b9e90d7a1d3096$export$f99899ced542f49a = ()=>{
    const cloudIdRef = (0, $eJOHy.useRef)('');
    const [{ selectedCloudId: selectedCloudId }] = (0, $bitlK.useSitePickerContext)();
    (0, $eJOHy.useEffect)(()=>{
        if (selectedCloudId && cloudIdRef.current !== selectedCloudId) cloudIdRef.current = selectedCloudId;
    }, [
        selectedCloudId
    ]);
    const originUrl = (0, $eJOHy.useMemo)(()=>(0, $5acEa.transformOriginUrl)(selectedCloudId), [
        selectedCloudId
    ]);
    return {
        giraClient: {
            ...$d4b9e90d7a1d3096$export$4cea60a165c59df0(),
            ...originUrl && {
                clientCreator: ()=>$d4b9e90d7a1d3096$export$4cea60a165c59df0()?.clientCreator(originUrl)
            }
        },
        resetAndReloadCreateForm: cloudIdRef.current !== selectedCloudId
    };
};

});
parcelRegister("5Q8dn", function(module, exports) {

$parcel$export(module.exports, "default", () => $2939e4856f212b8f$export$2e2bcd8739ae039);

var $9Dhvc = parcelRequire("9Dhvc");

var $ifBQy = parcelRequire("ifBQy");

var $eezJL = parcelRequire("eezJL");

var $7oe8F = parcelRequire("7oe8F");

var $i8eSF = parcelRequire("i8eSF");

var $eHpnE = parcelRequire("eHpnE");

var $a6bRt = parcelRequire("a6bRt");

var $g4okI = parcelRequire("g4okI");

var $eSnSE = parcelRequire("eSnSE");

var $1fQNI = parcelRequire("1fQNI");

var $dk1mg = parcelRequire("dk1mg");

var $gLqE0 = parcelRequire("gLqE0");


const $2939e4856f212b8f$var$GIRA_APOLLO_CLIENT_ID = 'gira';
const $2939e4856f212b8f$var$CACHE_NAME = `apollo-cache/${$2939e4856f212b8f$var$GIRA_APOLLO_CLIENT_ID}`;
const $2939e4856f212b8f$var$LOG_NAMESPACE = `apollo.${$2939e4856f212b8f$var$GIRA_APOLLO_CLIENT_ID}.error.graphql`;
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $2939e4856f212b8f$var$isSsrSuccessful = ()=>false ? true : !window || !window.SPA_STATE;
const $2939e4856f212b8f$var$NETWORK_ERRORS_COUNTER_KEY = 'networkErrorsCounter';
const $2939e4856f212b8f$export$851a7159daf49c89 = new (0, $ifBQy.IntrospectionFragmentMatcher)({
    introspectionQueryResultData: (/*@__PURE__*/$parcel$interopDefault($dk1mg))
});
const $2939e4856f212b8f$var$errorLink = (0, $i8eSF.onError)(({ graphQLErrors: graphQLErrors, networkError: networkError, operation: operation })=>{
    // Ignore network errors as they will be logged in the retry link
    (0, $gLqE0.reportErrors)({
        graphQLErrors: graphQLErrors,
        operation: operation
    });
    // Skip default error logging if analytics context data is defined for the query.
    const errorAnalytics = (0, $gLqE0.getErrorAnalyticsContext)(operation.getContext());
    if (errorAnalytics !== undefined) return;
    if (graphQLErrors) {
        if (Array.isArray(graphQLErrors)) graphQLErrors.map(({ message: message, locations: locations, path: path })=>(0, $eSnSE.default).safeErrorWithoutCustomerData($2939e4856f212b8f$var$LOG_NAMESPACE, `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`, {
                message: JSON.stringify(message),
                path: JSON.stringify(path),
                locations: JSON.stringify(locations)
            }));
        else (0, $eSnSE.default).safeErrorWithoutCustomerData($2939e4856f212b8f$var$LOG_NAMESPACE, '[GraphQL error]: Unexpected error message format', {
            message: JSON.stringify(graphQLErrors)
        });
    }
    if (networkError) {
        const occuredNetworkErrorsBefore = (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(operation.getContext(), [
            $2939e4856f212b8f$var$NETWORK_ERRORS_COUNTER_KEY
        ], 0);
        (0, $eSnSE.default).safeErrorWithoutCustomerData($2939e4856f212b8f$var$LOG_NAMESPACE, `[Network error]: ${networkError}, attempt ${occuredNetworkErrorsBefore + 1}`);
        operation.setContext({
            [$2939e4856f212b8f$var$NETWORK_ERRORS_COUNTER_KEY]: occuredNetworkErrorsBefore + 1
        });
    }
});
const $2939e4856f212b8f$var$retryLinkWithFama = new (0, $a6bRt.RetryLink)({
    delay: {
        initial: 300,
        max: 120000,
        jitter: true
    },
    attempts: (count, operation, networkError)=>{
        const retry = count < 5 && networkError && !networkError.statusCode;
        // Don't report any error if we're going to attempt a retry
        if (!retry) (0, $gLqE0.reportErrors)({
            networkError: networkError,
            operation: operation
        });
        return retry;
    }
});
class $2939e4856f212b8f$var$CancelableRequestLink extends (0, $7oe8F.ApolloLink) {
    constructor(){
        super();
        this.inFlightRequestControllers = {};
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    request(operation, forward) {
        const context = operation.getContext();
        if (!context.cancelable) return forward(operation);
        const key = JSON.stringify([
            operation.operationName,
            operation.query
        ]); // Equivalent to `operation.toKey` less the _actual_ variables
        this.inFlightRequestControllers[key]?.abort(); // Always abort the previous request
        const abortController = new AbortController();
        operation.setContext({
            ...context,
            fetchOptions: {
                signal: abortController.signal
            } // HttpLink passes this directly to fetch implementation
        });
        this.inFlightRequestControllers[key] = abortController;
        const cleanup = ()=>{
            // This callback may be called long after the request is replaced
            if (this.inFlightRequestControllers[key] === abortController) delete this.inFlightRequestControllers[key];
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return new (0, $7oe8F.Observable)((observer)=>{
            const subscription = forward(operation).subscribe({
                next: observer.next.bind(observer),
                // @ts-expect-error - TS7006 - Parameter 'error' implicitly has an 'any' type.
                error: (error)=>{
                    observer.error(error);
                    cleanup();
                },
                complete: observer.complete.bind(observer)
            });
            return ()=>{
                subscription?.unsubscribe();
                cleanup();
            };
        });
    }
}
const $2939e4856f212b8f$var$cache = new (0, $ifBQy.InMemoryCache)({
    cacheRedirects: {
        Query: {
            ...(0, $g4okI.fragmentCacheRedirect)()
        }
    },
    fragmentMatcher: $2939e4856f212b8f$export$851a7159daf49c89,
    dataIdFromObject: (object)=>object.id && `${object.id}${object.__typename}`
})// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
.restore(!$2939e4856f212b8f$var$isSsrSuccessful() && window.SPA_STATE[$2939e4856f212b8f$var$CACHE_NAME] || {});
const $2939e4856f212b8f$export$de66868aab9e79ea = (originUrl = '')=>new (0, $eezJL.ApolloClient)({
        name: $2939e4856f212b8f$var$GIRA_APOLLO_CLIENT_ID,
        ssrMode: $2939e4856f212b8f$var$isSsrSuccessful(),
        // @ts-expect-error - TS2345 - Argument of type '{ name: string; ssrMode: boolean; addTypename: boolean; link: ApolloLink; cache: InMemoryCache; connectToDevTools: boolean; }' is not assignable to parameter of type 'ApolloClientOptions<NormalizedCacheObject>'.
        addTypename: true,
        link: (0, $7oe8F.ApolloLink).from([
            $2939e4856f212b8f$var$retryLinkWithFama,
            $2939e4856f212b8f$var$errorLink,
            (0, $1fQNI.UFOLoggerLink),
            (0, $g4okI.fragmentLinkState)($2939e4856f212b8f$var$cache),
            ...!$2939e4856f212b8f$var$isSsrSuccessful() ? [
                new $2939e4856f212b8f$var$CancelableRequestLink()
            ] : [],
            new (0, $eHpnE.HttpLink)({
                uri: ({ operationName: operationName })=>`${originUrl}/rest/${$2939e4856f212b8f$var$GIRA_APOLLO_CLIENT_ID}/1/?operation=${encodeURIComponent(operationName)}`,
                credentials: 'same-origin',
                // @ts-expect-error - TS2345 - Argument of type '{ uri: ({ operationName }: Operation) => string; credentials: string; abortErrorDoesNotCauseError: boolean; }' is not assignable to parameter of type 'Options'.
                abortErrorDoesNotCauseError: !$2939e4856f212b8f$var$isSsrSuccessful()
            })
        ].filter(Boolean)),
        cache: $2939e4856f212b8f$var$cache,
        connectToDevTools: false
    });
var $2939e4856f212b8f$export$2e2bcd8739ae039 = {
    clientId: $2939e4856f212b8f$var$GIRA_APOLLO_CLIENT_ID,
    clientCreator: $2939e4856f212b8f$export$de66868aab9e79ea
};

});
parcelRegister("ifBQy", function(module, exports) {

$parcel$export(module.exports, "IntrospectionFragmentMatcher", () => $d496fc3ebf2f1ece$export$3b71c6b829c99d21);
$parcel$export(module.exports, "defaultDataIdFromObject", () => $d496fc3ebf2f1ece$export$bd03c5a9c99d6bce);
$parcel$export(module.exports, "InMemoryCache", () => $d496fc3ebf2f1ece$export$467265324939f47f);

var $dnskZ = parcelRequire("dnskZ");

var $8haCz = parcelRequire("8haCz");

var $jFDfc = parcelRequire("jFDfc");
var $hR4hP = parcelRequire("hR4hP");

var $9WJrj = parcelRequire("9WJrj");

var $lDEi6 = parcelRequire("lDEi6");
var $d496fc3ebf2f1ece$var$haveWarned = false;
function $d496fc3ebf2f1ece$var$shouldWarn() {
    var answer = !$d496fc3ebf2f1ece$var$haveWarned;
    if (!(0, $jFDfc.isTest)()) $d496fc3ebf2f1ece$var$haveWarned = true;
    return answer;
}
var $d496fc3ebf2f1ece$export$5d3fcf53267091de = function() {
    function HeuristicFragmentMatcher() {}
    HeuristicFragmentMatcher.prototype.ensureReady = function() {
        return Promise.resolve();
    };
    HeuristicFragmentMatcher.prototype.canBypassInit = function() {
        return true;
    };
    HeuristicFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
        var obj = context.store.get(idValue.id);
        var isRootQuery = idValue.id === 'ROOT_QUERY';
        if (!obj) return isRootQuery;
        var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
        if (!__typename) {
            $d496fc3ebf2f1ece$var$shouldWarn();
            return 'heuristic';
        }
        if (__typename === typeCondition) return true;
        $d496fc3ebf2f1ece$var$shouldWarn();
        return 'heuristic';
    };
    return HeuristicFragmentMatcher;
}();
var $d496fc3ebf2f1ece$export$3b71c6b829c99d21 = function() {
    function IntrospectionFragmentMatcher(options) {
        if (options && options.introspectionQueryResultData) {
            this.possibleTypesMap = this.parseIntrospectionResult(options.introspectionQueryResultData);
            this.isReady = true;
        } else this.isReady = false;
        this.match = this.match.bind(this);
    }
    IntrospectionFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
        (0, $lDEi6.invariant)(this.isReady, 1);
        var obj = context.store.get(idValue.id);
        var isRootQuery = idValue.id === 'ROOT_QUERY';
        if (!obj) return isRootQuery;
        var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
        (0, $lDEi6.invariant)(__typename, 2);
        if (__typename === typeCondition) return true;
        var implementingTypes = this.possibleTypesMap[typeCondition];
        if (__typename && implementingTypes && implementingTypes.indexOf(__typename) > -1) return true;
        return false;
    };
    IntrospectionFragmentMatcher.prototype.parseIntrospectionResult = function(introspectionResultData) {
        var typeMap = {};
        introspectionResultData.__schema.types.forEach(function(type) {
            if (type.kind === 'UNION' || type.kind === 'INTERFACE') typeMap[type.name] = type.possibleTypes.map(function(implementingType) {
                return implementingType.name;
            });
        });
        return typeMap;
    };
    return IntrospectionFragmentMatcher;
}();
var $d496fc3ebf2f1ece$var$hasOwn = Object.prototype.hasOwnProperty;
var $d496fc3ebf2f1ece$var$DepTrackingCache = function() {
    function DepTrackingCache(data) {
        var _this = this;
        if (data === void 0) data = Object.create(null);
        this.data = data;
        this.depend = (0, $9WJrj.wrap)(function(dataId) {
            return _this.data[dataId];
        }, {
            disposable: true,
            makeCacheKey: function(dataId) {
                return dataId;
            }
        });
    }
    DepTrackingCache.prototype.toObject = function() {
        return this.data;
    };
    DepTrackingCache.prototype.get = function(dataId) {
        this.depend(dataId);
        return this.data[dataId];
    };
    DepTrackingCache.prototype.set = function(dataId, value) {
        var oldValue = this.data[dataId];
        if (value !== oldValue) {
            this.data[dataId] = value;
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.delete = function(dataId) {
        if ($d496fc3ebf2f1ece$var$hasOwn.call(this.data, dataId)) {
            delete this.data[dataId];
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.clear = function() {
        this.replace(null);
    };
    DepTrackingCache.prototype.replace = function(newData) {
        var _this = this;
        if (newData) {
            Object.keys(newData).forEach(function(dataId) {
                _this.set(dataId, newData[dataId]);
            });
            Object.keys(this.data).forEach(function(dataId) {
                if (!$d496fc3ebf2f1ece$var$hasOwn.call(newData, dataId)) _this.delete(dataId);
            });
        } else Object.keys(this.data).forEach(function(dataId) {
            _this.delete(dataId);
        });
    };
    return DepTrackingCache;
}();
function $d496fc3ebf2f1ece$var$defaultNormalizedCacheFactory(seed) {
    return new $d496fc3ebf2f1ece$var$DepTrackingCache(seed);
}
var $d496fc3ebf2f1ece$export$628ef07ba8965f12 = function() {
    function StoreReader(_a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, _c = _b.cacheKeyRoot, cacheKeyRoot = _c === void 0 ? new (0, $9WJrj.KeyTrie)((0, $jFDfc.canUseWeakMap)) : _c, _d = _b.freezeResults, freezeResults = _d === void 0 ? false : _d;
        var _e = this, executeStoreQuery = _e.executeStoreQuery, executeSelectionSet = _e.executeSelectionSet, executeSubSelectedArray = _e.executeSubSelectedArray;
        this.freezeResults = freezeResults;
        this.executeStoreQuery = (0, $9WJrj.wrap)(function(options) {
            return executeStoreQuery.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, fragmentMatcher = _a.fragmentMatcher;
                if (contextValue.store instanceof $d496fc3ebf2f1ece$var$DepTrackingCache) return cacheKeyRoot.lookup(contextValue.store, query, fragmentMatcher, JSON.stringify(variableValues), rootValue.id);
            }
        });
        this.executeSelectionSet = (0, $9WJrj.wrap)(function(options) {
            return executeSelectionSet.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof $d496fc3ebf2f1ece$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, selectionSet, execContext.fragmentMatcher, JSON.stringify(execContext.variableValues), rootValue.id);
            }
        });
        this.executeSubSelectedArray = (0, $9WJrj.wrap)(function(options) {
            return executeSubSelectedArray.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var field = _a.field, array = _a.array, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof $d496fc3ebf2f1ece$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, field, array, JSON.stringify(execContext.variableValues));
            }
        });
    }
    StoreReader.prototype.readQueryFromStore = function(options) {
        return this.diffQueryAgainstStore((0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, options), {
            returnPartialData: false
        })).result;
    };
    StoreReader.prototype.diffQueryAgainstStore = function(_a) {
        var store = _a.store, query = _a.query, variables = _a.variables, previousResult = _a.previousResult, _b = _a.returnPartialData, returnPartialData = _b === void 0 ? true : _b, _c = _a.rootId, rootId = _c === void 0 ? 'ROOT_QUERY' : _c, fragmentMatcherFunction = _a.fragmentMatcherFunction, config = _a.config;
        var queryDefinition = (0, $jFDfc.getQueryDefinition)(query);
        variables = (0, $jFDfc.assign)({}, (0, $jFDfc.getDefaultValues)(queryDefinition), variables);
        var context = {
            store: store,
            dataIdFromObject: config && config.dataIdFromObject,
            cacheRedirects: config && config.cacheRedirects || {}
        };
        var execResult = this.executeStoreQuery({
            query: query,
            rootValue: {
                type: 'id',
                id: rootId,
                generated: true,
                typename: 'Query'
            },
            contextValue: context,
            variableValues: variables,
            fragmentMatcher: fragmentMatcherFunction
        });
        var hasMissingFields = execResult.missing && execResult.missing.length > 0;
        if (hasMissingFields && !returnPartialData) execResult.missing.forEach(function(info) {
            if (info.tolerable) return;
            throw new (0, $lDEi6.InvariantError)(8);
        });
        if (previousResult) {
            if ((0, $hR4hP.equal)(previousResult, execResult.result)) execResult.result = previousResult;
        }
        return {
            result: execResult.result,
            complete: !hasMissingFields
        };
    };
    StoreReader.prototype.executeStoreQuery = function(_a) {
        var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, _b = _a.fragmentMatcher, fragmentMatcher = _b === void 0 ? $d496fc3ebf2f1ece$var$defaultFragmentMatcher : _b;
        var mainDefinition = (0, $jFDfc.getMainDefinition)(query);
        var fragments = (0, $jFDfc.getFragmentDefinitions)(query);
        var fragmentMap = (0, $jFDfc.createFragmentMap)(fragments);
        var execContext = {
            query: query,
            fragmentMap: fragmentMap,
            contextValue: contextValue,
            variableValues: variableValues,
            fragmentMatcher: fragmentMatcher
        };
        return this.executeSelectionSet({
            selectionSet: mainDefinition.selectionSet,
            rootValue: rootValue,
            execContext: execContext
        });
    };
    StoreReader.prototype.executeSelectionSet = function(_a) {
        var _this = this;
        var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
        var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
        var finalResult = {
            result: null
        };
        var objectsToMerge = [];
        var object = contextValue.store.get(rootValue.id);
        var typename = object && object.__typename || rootValue.id === 'ROOT_QUERY' && 'Query' || void 0;
        function handleMissing(result) {
            var _a;
            if (result.missing) {
                finalResult.missing = finalResult.missing || [];
                (_a = finalResult.missing).push.apply(_a, result.missing);
            }
            return result.result;
        }
        selectionSet.selections.forEach(function(selection) {
            var _a;
            if (!(0, $jFDfc.shouldInclude)(selection, variables)) return;
            if ((0, $jFDfc.isField)(selection)) {
                var fieldResult = handleMissing(_this.executeField(object, typename, selection, execContext));
                if (typeof fieldResult !== 'undefined') objectsToMerge.push((_a = {}, _a[(0, $jFDfc.resultKeyNameFromField)(selection)] = fieldResult, _a));
            } else {
                var fragment = void 0;
                if ((0, $jFDfc.isInlineFragment)(selection)) fragment = selection;
                else {
                    fragment = fragmentMap[selection.name.value];
                    if (!fragment) throw new (0, $lDEi6.InvariantError)(9);
                }
                var typeCondition = fragment.typeCondition && fragment.typeCondition.name.value;
                var match = !typeCondition || execContext.fragmentMatcher(rootValue, typeCondition, contextValue);
                if (match) {
                    var fragmentExecResult = _this.executeSelectionSet({
                        selectionSet: fragment.selectionSet,
                        rootValue: rootValue,
                        execContext: execContext
                    });
                    if (match === 'heuristic' && fragmentExecResult.missing) fragmentExecResult = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, fragmentExecResult), {
                        missing: fragmentExecResult.missing.map(function(info) {
                            return (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, info), {
                                tolerable: true
                            });
                        })
                    });
                    objectsToMerge.push(handleMissing(fragmentExecResult));
                }
            }
        });
        finalResult.result = (0, $jFDfc.mergeDeepArray)(objectsToMerge);
        this.freezeResults;
        return finalResult;
    };
    StoreReader.prototype.executeField = function(object, typename, field, execContext) {
        var variables = execContext.variableValues, contextValue = execContext.contextValue;
        var fieldName = field.name.value;
        var args = (0, $jFDfc.argumentsObjectFromField)(field, variables);
        var info = {
            resultKey: (0, $jFDfc.resultKeyNameFromField)(field),
            directives: (0, $jFDfc.getDirectiveInfoFromField)(field, variables)
        };
        var readStoreResult = $d496fc3ebf2f1ece$var$readStoreResolver(object, typename, fieldName, args, contextValue, info);
        if (Array.isArray(readStoreResult.result)) return this.combineExecResults(readStoreResult, this.executeSubSelectedArray({
            field: field,
            array: readStoreResult.result,
            execContext: execContext
        }));
        if (!field.selectionSet) {
            $d496fc3ebf2f1ece$var$assertSelectionSetForIdValue(field, readStoreResult.result);
            this.freezeResults;
            return readStoreResult;
        }
        if (readStoreResult.result == null) return readStoreResult;
        return this.combineExecResults(readStoreResult, this.executeSelectionSet({
            selectionSet: field.selectionSet,
            rootValue: readStoreResult.result,
            execContext: execContext
        }));
    };
    StoreReader.prototype.combineExecResults = function() {
        var execResults = [];
        for(var _i = 0; _i < arguments.length; _i++)execResults[_i] = arguments[_i];
        var missing;
        execResults.forEach(function(execResult) {
            if (execResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, execResult.missing);
            }
        });
        return {
            result: execResults.pop().result,
            missing: missing
        };
    };
    StoreReader.prototype.executeSubSelectedArray = function(_a) {
        var _this = this;
        var field = _a.field, array = _a.array, execContext = _a.execContext;
        var missing;
        function handleMissing(childResult) {
            if (childResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, childResult.missing);
            }
            return childResult.result;
        }
        array = array.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return handleMissing(_this.executeSubSelectedArray({
                field: field,
                array: item,
                execContext: execContext
            }));
            if (field.selectionSet) return handleMissing(_this.executeSelectionSet({
                selectionSet: field.selectionSet,
                rootValue: item,
                execContext: execContext
            }));
            $d496fc3ebf2f1ece$var$assertSelectionSetForIdValue(field, item);
            return item;
        });
        this.freezeResults;
        return {
            result: array,
            missing: missing
        };
    };
    return StoreReader;
}();
function $d496fc3ebf2f1ece$var$assertSelectionSetForIdValue(field, value) {
    if (!field.selectionSet && (0, $jFDfc.isIdValue)(value)) throw new (0, $lDEi6.InvariantError)(10);
}
function $d496fc3ebf2f1ece$var$defaultFragmentMatcher() {
    return true;
}
function $d496fc3ebf2f1ece$export$7a4899fe13f33235(idValue) {
    (0, $lDEi6.invariant)((0, $jFDfc.isIdValue)(idValue), 11);
}
function $d496fc3ebf2f1ece$var$readStoreResolver(object, typename, fieldName, args, context, _a) {
    var resultKey = _a.resultKey, directives = _a.directives;
    var storeKeyName = fieldName;
    if (args || directives) storeKeyName = (0, $jFDfc.getStoreKeyName)(storeKeyName, args, directives);
    var fieldValue = void 0;
    if (object) {
        fieldValue = object[storeKeyName];
        if (typeof fieldValue === 'undefined' && context.cacheRedirects && typeof typename === 'string') {
            var type = context.cacheRedirects[typename];
            if (type) {
                var resolver = type[fieldName];
                if (resolver) fieldValue = resolver(object, args, {
                    getCacheKey: function(storeObj) {
                        var id = context.dataIdFromObject(storeObj);
                        return id && (0, $jFDfc.toIdValue)({
                            id: id,
                            typename: storeObj.__typename
                        });
                    }
                });
            }
        }
    }
    if (typeof fieldValue === 'undefined') return {
        result: fieldValue,
        missing: [
            {
                object: object,
                fieldName: storeKeyName,
                tolerable: false
            }
        ]
    };
    if ((0, $jFDfc.isJsonValue)(fieldValue)) fieldValue = fieldValue.json;
    return {
        result: fieldValue
    };
}
var $d496fc3ebf2f1ece$export$ee7258b8691956a3 = function() {
    function ObjectCache(data) {
        if (data === void 0) data = Object.create(null);
        this.data = data;
    }
    ObjectCache.prototype.toObject = function() {
        return this.data;
    };
    ObjectCache.prototype.get = function(dataId) {
        return this.data[dataId];
    };
    ObjectCache.prototype.set = function(dataId, value) {
        this.data[dataId] = value;
    };
    ObjectCache.prototype.delete = function(dataId) {
        this.data[dataId] = void 0;
    };
    ObjectCache.prototype.clear = function() {
        this.data = Object.create(null);
    };
    ObjectCache.prototype.replace = function(newData) {
        this.data = newData || Object.create(null);
    };
    return ObjectCache;
}();
function $d496fc3ebf2f1ece$export$7e2b40d1002de152(seed) {
    return new $d496fc3ebf2f1ece$export$ee7258b8691956a3(seed);
}
var $d496fc3ebf2f1ece$export$de4e6870dc6ac801 = function(_super) {
    (0, $dnskZ.__extends)(WriteError, _super);
    function WriteError() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'WriteError';
        return _this;
    }
    return WriteError;
}(Error);
function $d496fc3ebf2f1ece$export$fb86e3236e77e3(error, document) {
    var enhancedError = new $d496fc3ebf2f1ece$export$de4e6870dc6ac801("Error writing result to store for query:\n " + JSON.stringify(document));
    enhancedError.message += '\n' + error.message;
    enhancedError.stack = error.stack;
    return enhancedError;
}
var $d496fc3ebf2f1ece$export$eb8361c5d132fb8f = function() {
    function StoreWriter() {}
    StoreWriter.prototype.writeQueryToStore = function(_a) {
        var query = _a.query, result = _a.result, _b = _a.store, store = _b === void 0 ? $d496fc3ebf2f1ece$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        return this.writeResultToStore({
            dataId: 'ROOT_QUERY',
            result: result,
            document: query,
            store: store,
            variables: variables,
            dataIdFromObject: dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction
        });
    };
    StoreWriter.prototype.writeResultToStore = function(_a) {
        var dataId = _a.dataId, result = _a.result, document = _a.document, _b = _a.store, store = _b === void 0 ? $d496fc3ebf2f1ece$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        var operationDefinition = (0, $jFDfc.getOperationDefinition)(document);
        try {
            return this.writeSelectionSetToStore({
                result: result,
                dataId: dataId,
                selectionSet: operationDefinition.selectionSet,
                context: {
                    store: store,
                    processedData: {},
                    variables: (0, $jFDfc.assign)({}, (0, $jFDfc.getDefaultValues)(operationDefinition), variables),
                    dataIdFromObject: dataIdFromObject,
                    fragmentMap: (0, $jFDfc.createFragmentMap)((0, $jFDfc.getFragmentDefinitions)(document)),
                    fragmentMatcherFunction: fragmentMatcherFunction
                }
            });
        } catch (e) {
            throw $d496fc3ebf2f1ece$export$fb86e3236e77e3(e, document);
        }
    };
    StoreWriter.prototype.writeSelectionSetToStore = function(_a) {
        var _this = this;
        var result = _a.result, dataId = _a.dataId, selectionSet = _a.selectionSet, context = _a.context;
        var variables = context.variables, store = context.store, fragmentMap = context.fragmentMap;
        selectionSet.selections.forEach(function(selection) {
            var _a;
            if (!(0, $jFDfc.shouldInclude)(selection, variables)) return;
            if ((0, $jFDfc.isField)(selection)) {
                var resultFieldKey = (0, $jFDfc.resultKeyNameFromField)(selection);
                var value = result[resultFieldKey];
                if (typeof value !== 'undefined') _this.writeFieldToStore({
                    dataId: dataId,
                    value: value,
                    field: selection,
                    context: context
                });
                else {
                    var isDefered = false;
                    var isClient = false;
                    if (selection.directives && selection.directives.length) {
                        isDefered = selection.directives.some(function(directive) {
                            return directive.name && directive.name.value === 'defer';
                        });
                        isClient = selection.directives.some(function(directive) {
                            return directive.name && directive.name.value === 'client';
                        });
                    }
                    !isDefered && !isClient && context.fragmentMatcherFunction;
                }
            } else {
                var fragment = void 0;
                if ((0, $jFDfc.isInlineFragment)(selection)) fragment = selection;
                else {
                    fragment = (fragmentMap || {})[selection.name.value];
                    (0, $lDEi6.invariant)(fragment, 3);
                }
                var matches = true;
                if (context.fragmentMatcherFunction && fragment.typeCondition) {
                    var id = dataId || 'self';
                    var idValue = (0, $jFDfc.toIdValue)({
                        id: id,
                        typename: undefined
                    });
                    var fakeContext = {
                        store: new $d496fc3ebf2f1ece$export$ee7258b8691956a3((_a = {}, _a[id] = result, _a)),
                        cacheRedirects: {}
                    };
                    var match = context.fragmentMatcherFunction(idValue, fragment.typeCondition.name.value, fakeContext);
                    !(0, $jFDfc.isProduction)() && match;
                    matches = !!match;
                }
                if (matches) _this.writeSelectionSetToStore({
                    result: result,
                    selectionSet: fragment.selectionSet,
                    dataId: dataId,
                    context: context
                });
            }
        });
        return store;
    };
    StoreWriter.prototype.writeFieldToStore = function(_a) {
        var _b;
        var field = _a.field, value = _a.value, dataId = _a.dataId, context = _a.context;
        var variables = context.variables, dataIdFromObject = context.dataIdFromObject, store = context.store;
        var storeValue;
        var storeObject;
        var storeFieldName = (0, $jFDfc.storeKeyNameFromField)(field, variables);
        if (!field.selectionSet || value === null) storeValue = value != null && typeof value === 'object' ? {
            type: 'json',
            json: value
        } : value;
        else if (Array.isArray(value)) {
            var generatedId = dataId + "." + storeFieldName;
            storeValue = this.processArrayValue(value, generatedId, field.selectionSet, context);
        } else {
            var valueDataId = dataId + "." + storeFieldName;
            var generated = true;
            if (!$d496fc3ebf2f1ece$var$isGeneratedId(valueDataId)) valueDataId = '$' + valueDataId;
            if (dataIdFromObject) {
                var semanticId = dataIdFromObject(value);
                (0, $lDEi6.invariant)(!semanticId || !$d496fc3ebf2f1ece$var$isGeneratedId(semanticId), 4);
                if (semanticId || typeof semanticId === 'number' && semanticId === 0) {
                    valueDataId = semanticId;
                    generated = false;
                }
            }
            if (!$d496fc3ebf2f1ece$var$isDataProcessed(valueDataId, field, context.processedData)) this.writeSelectionSetToStore({
                dataId: valueDataId,
                result: value,
                selectionSet: field.selectionSet,
                context: context
            });
            var typename = value.__typename;
            storeValue = (0, $jFDfc.toIdValue)({
                id: valueDataId,
                typename: typename
            }, generated);
            storeObject = store.get(dataId);
            var escapedId = storeObject && storeObject[storeFieldName];
            if (escapedId !== storeValue && (0, $jFDfc.isIdValue)(escapedId)) {
                var hadTypename = escapedId.typename !== undefined;
                var hasTypename = typename !== undefined;
                var typenameChanged = hadTypename && hasTypename && escapedId.typename !== typename;
                (0, $lDEi6.invariant)(!generated || escapedId.generated || typenameChanged, 5);
                (0, $lDEi6.invariant)(!hadTypename || hasTypename, 6);
                if (escapedId.generated) {
                    if (typenameChanged) {
                        if (!generated) store.delete(escapedId.id);
                    } else $d496fc3ebf2f1ece$var$mergeWithGenerated(escapedId.id, storeValue.id, store);
                }
            }
        }
        storeObject = store.get(dataId);
        if (!storeObject || !(0, $hR4hP.equal)(storeValue, storeObject[storeFieldName])) store.set(dataId, (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, storeObject), (_b = {}, _b[storeFieldName] = storeValue, _b)));
    };
    StoreWriter.prototype.processArrayValue = function(value, generatedId, selectionSet, context) {
        var _this = this;
        return value.map(function(item, index) {
            if (item === null) return null;
            var itemDataId = generatedId + "." + index;
            if (Array.isArray(item)) return _this.processArrayValue(item, itemDataId, selectionSet, context);
            var generated = true;
            if (context.dataIdFromObject) {
                var semanticId = context.dataIdFromObject(item);
                if (semanticId) {
                    itemDataId = semanticId;
                    generated = false;
                }
            }
            if (!$d496fc3ebf2f1ece$var$isDataProcessed(itemDataId, selectionSet, context.processedData)) _this.writeSelectionSetToStore({
                dataId: itemDataId,
                result: item,
                selectionSet: selectionSet,
                context: context
            });
            return (0, $jFDfc.toIdValue)({
                id: itemDataId,
                typename: item.__typename
            }, generated);
        });
    };
    return StoreWriter;
}();
function $d496fc3ebf2f1ece$var$isGeneratedId(id) {
    return id[0] === '$';
}
function $d496fc3ebf2f1ece$var$mergeWithGenerated(generatedKey, realKey, cache) {
    if (generatedKey === realKey) return false;
    var generated = cache.get(generatedKey);
    var real = cache.get(realKey);
    var madeChanges = false;
    Object.keys(generated).forEach(function(key) {
        var value = generated[key];
        var realValue = real[key];
        if ((0, $jFDfc.isIdValue)(value) && $d496fc3ebf2f1ece$var$isGeneratedId(value.id) && (0, $jFDfc.isIdValue)(realValue) && !(0, $hR4hP.equal)(value, realValue) && $d496fc3ebf2f1ece$var$mergeWithGenerated(value.id, realValue.id, cache)) madeChanges = true;
    });
    cache.delete(generatedKey);
    var newRealValue = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, generated), real);
    if ((0, $hR4hP.equal)(newRealValue, real)) return madeChanges;
    cache.set(realKey, newRealValue);
    return true;
}
function $d496fc3ebf2f1ece$var$isDataProcessed(dataId, field, processedData) {
    if (!processedData) return false;
    if (processedData[dataId]) {
        if (processedData[dataId].indexOf(field) >= 0) return true;
        else processedData[dataId].push(field);
    } else processedData[dataId] = [
        field
    ];
    return false;
}
var $d496fc3ebf2f1ece$var$defaultConfig = {
    fragmentMatcher: new $d496fc3ebf2f1ece$export$5d3fcf53267091de(),
    dataIdFromObject: $d496fc3ebf2f1ece$export$bd03c5a9c99d6bce,
    addTypename: true,
    resultCaching: true,
    freezeResults: false
};
function $d496fc3ebf2f1ece$export$bd03c5a9c99d6bce(result) {
    if (result.__typename) {
        if (result.id !== undefined) return result.__typename + ":" + result.id;
        if (result._id !== undefined) return result.__typename + ":" + result._id;
    }
    return null;
}
var $d496fc3ebf2f1ece$var$hasOwn$1 = Object.prototype.hasOwnProperty;
var $d496fc3ebf2f1ece$var$OptimisticCacheLayer = function(_super) {
    (0, $dnskZ.__extends)(OptimisticCacheLayer, _super);
    function OptimisticCacheLayer(optimisticId, parent, transaction) {
        var _this = _super.call(this, Object.create(null)) || this;
        _this.optimisticId = optimisticId;
        _this.parent = parent;
        _this.transaction = transaction;
        return _this;
    }
    OptimisticCacheLayer.prototype.toObject = function() {
        return (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, this.parent.toObject()), this.data);
    };
    OptimisticCacheLayer.prototype.get = function(dataId) {
        return $d496fc3ebf2f1ece$var$hasOwn$1.call(this.data, dataId) ? this.data[dataId] : this.parent.get(dataId);
    };
    return OptimisticCacheLayer;
}($d496fc3ebf2f1ece$export$ee7258b8691956a3);
var $d496fc3ebf2f1ece$export$467265324939f47f = function(_super) {
    (0, $dnskZ.__extends)(InMemoryCache, _super);
    function InMemoryCache(config) {
        if (config === void 0) config = {};
        var _this = _super.call(this) || this;
        _this.watches = new Set();
        _this.typenameDocumentCache = new Map();
        _this.cacheKeyRoot = new (0, $9WJrj.KeyTrie)((0, $jFDfc.canUseWeakMap));
        _this.silenceBroadcast = false;
        _this.config = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, $d496fc3ebf2f1ece$var$defaultConfig), config);
        if (_this.config.customResolvers) _this.config.cacheRedirects = _this.config.customResolvers;
        if (_this.config.cacheResolvers) _this.config.cacheRedirects = _this.config.cacheResolvers;
        _this.addTypename = !!_this.config.addTypename;
        _this.data = _this.config.resultCaching ? new $d496fc3ebf2f1ece$var$DepTrackingCache() : new $d496fc3ebf2f1ece$export$ee7258b8691956a3();
        _this.optimisticData = _this.data;
        _this.storeWriter = new $d496fc3ebf2f1ece$export$eb8361c5d132fb8f();
        _this.storeReader = new $d496fc3ebf2f1ece$export$628ef07ba8965f12({
            cacheKeyRoot: _this.cacheKeyRoot,
            freezeResults: config.freezeResults
        });
        var cache = _this;
        var maybeBroadcastWatch = cache.maybeBroadcastWatch;
        _this.maybeBroadcastWatch = (0, $9WJrj.wrap)(function(c) {
            return maybeBroadcastWatch.call(_this, c);
        }, {
            makeCacheKey: function(c) {
                if (c.optimistic) return;
                if (c.previousResult) return;
                if (cache.data instanceof $d496fc3ebf2f1ece$var$DepTrackingCache) return cache.cacheKeyRoot.lookup(c.query, JSON.stringify(c.variables));
            }
        });
        return _this;
    }
    InMemoryCache.prototype.restore = function(data) {
        if (data) this.data.replace(data);
        return this;
    };
    InMemoryCache.prototype.extract = function(optimistic) {
        if (optimistic === void 0) optimistic = false;
        return (optimistic ? this.optimisticData : this.data).toObject();
    };
    InMemoryCache.prototype.read = function(options) {
        if (typeof options.rootId === 'string' && typeof this.data.get(options.rootId) === 'undefined') return null;
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        return this.storeReader.readQueryFromStore({
            store: options.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(options.query),
            variables: options.variables,
            rootId: options.rootId,
            fragmentMatcherFunction: fragmentMatcherFunction,
            previousResult: options.previousResult,
            config: this.config
        }) || null;
    };
    InMemoryCache.prototype.write = function(write) {
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        this.storeWriter.writeResultToStore({
            dataId: write.dataId,
            result: write.result,
            variables: write.variables,
            document: this.transformDocument(write.query),
            store: this.data,
            dataIdFromObject: this.config.dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction
        });
        this.broadcastWatches();
    };
    InMemoryCache.prototype.diff = function(query) {
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        return this.storeReader.diffQueryAgainstStore({
            store: query.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(query.query),
            variables: query.variables,
            returnPartialData: query.returnPartialData,
            previousResult: query.previousResult,
            fragmentMatcherFunction: fragmentMatcherFunction,
            config: this.config
        });
    };
    InMemoryCache.prototype.watch = function(watch) {
        var _this = this;
        this.watches.add(watch);
        return function() {
            _this.watches.delete(watch);
        };
    };
    InMemoryCache.prototype.evict = function(query) {
        throw new (0, $lDEi6.InvariantError)(7);
    };
    InMemoryCache.prototype.reset = function() {
        this.data.clear();
        this.broadcastWatches();
        return Promise.resolve();
    };
    InMemoryCache.prototype.removeOptimistic = function(idToRemove) {
        var toReapply = [];
        var removedCount = 0;
        var layer = this.optimisticData;
        while(layer instanceof $d496fc3ebf2f1ece$var$OptimisticCacheLayer){
            if (layer.optimisticId === idToRemove) ++removedCount;
            else toReapply.push(layer);
            layer = layer.parent;
        }
        if (removedCount > 0) {
            this.optimisticData = layer;
            while(toReapply.length > 0){
                var layer_1 = toReapply.pop();
                this.performTransaction(layer_1.transaction, layer_1.optimisticId);
            }
            this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.performTransaction = function(transaction, optimisticId) {
        var _a = this, data = _a.data, silenceBroadcast = _a.silenceBroadcast;
        this.silenceBroadcast = true;
        if (typeof optimisticId === 'string') this.data = this.optimisticData = new $d496fc3ebf2f1ece$var$OptimisticCacheLayer(optimisticId, this.optimisticData, transaction);
        try {
            transaction(this);
        } finally{
            this.silenceBroadcast = silenceBroadcast;
            this.data = data;
        }
        this.broadcastWatches();
    };
    InMemoryCache.prototype.recordOptimisticTransaction = function(transaction, id) {
        return this.performTransaction(transaction, id);
    };
    InMemoryCache.prototype.transformDocument = function(document) {
        if (this.addTypename) {
            var result = this.typenameDocumentCache.get(document);
            if (!result) {
                result = (0, $jFDfc.addTypenameToDocument)(document);
                this.typenameDocumentCache.set(document, result);
                this.typenameDocumentCache.set(result, result);
            }
            return result;
        }
        return document;
    };
    InMemoryCache.prototype.broadcastWatches = function() {
        var _this = this;
        if (!this.silenceBroadcast) this.watches.forEach(function(c) {
            return _this.maybeBroadcastWatch(c);
        });
    };
    InMemoryCache.prototype.maybeBroadcastWatch = function(c) {
        c.callback(this.diff({
            query: c.query,
            variables: c.variables,
            previousResult: c.previousResult && c.previousResult(),
            optimistic: c.optimistic
        }));
    };
    return InMemoryCache;
}((0, $8haCz.ApolloCache));

});
parcelRegister("8haCz", function(module, exports) {

$parcel$export(module.exports, "ApolloCache", () => $60682668fc3daa4e$export$5fc74f25506aa9c);

var $jFDfc = parcelRequire("jFDfc");
function $60682668fc3daa4e$var$queryFromPojo(obj) {
    var op = {
        kind: 'OperationDefinition',
        operation: 'query',
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery'
        },
        selectionSet: $60682668fc3daa4e$var$selectionSetFromObj(obj)
    };
    var out = {
        kind: 'Document',
        definitions: [
            op
        ]
    };
    return out;
}
function $60682668fc3daa4e$var$fragmentFromPojo(obj, typename) {
    var frag = {
        kind: 'FragmentDefinition',
        typeCondition: {
            kind: 'NamedType',
            name: {
                kind: 'Name',
                value: typename || '__FakeType'
            }
        },
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery'
        },
        selectionSet: $60682668fc3daa4e$var$selectionSetFromObj(obj)
    };
    var out = {
        kind: 'Document',
        definitions: [
            frag
        ]
    };
    return out;
}
function $60682668fc3daa4e$var$selectionSetFromObj(obj) {
    if (typeof obj === 'number' || typeof obj === 'boolean' || typeof obj === 'string' || typeof obj === 'undefined' || obj === null) return null;
    if (Array.isArray(obj)) return $60682668fc3daa4e$var$selectionSetFromObj(obj[0]);
    var selections = [];
    Object.keys(obj).forEach(function(key) {
        var nestedSelSet = $60682668fc3daa4e$var$selectionSetFromObj(obj[key]);
        var field = {
            kind: 'Field',
            name: {
                kind: 'Name',
                value: key
            },
            selectionSet: nestedSelSet || undefined
        };
        selections.push(field);
    });
    var selectionSet = {
        kind: 'SelectionSet',
        selections: selections
    };
    return selectionSet;
}
var $60682668fc3daa4e$var$justTypenameQuery = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: null,
            variableDefinitions: null,
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: null,
                        name: {
                            kind: 'Name',
                            value: '__typename'
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: null
                    }
                ]
            }
        }
    ]
};
var $60682668fc3daa4e$export$5fc74f25506aa9c = function() {
    function ApolloCache() {}
    ApolloCache.prototype.transformDocument = function(document) {
        return document;
    };
    ApolloCache.prototype.transformForLink = function(document) {
        return document;
    };
    ApolloCache.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.read({
            query: options.query,
            variables: options.variables,
            optimistic: optimistic
        });
    };
    ApolloCache.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.read({
            query: (0, $jFDfc.getFragmentQueryDocument)(options.fragment, options.fragmentName),
            variables: options.variables,
            rootId: options.id,
            optimistic: optimistic
        });
    };
    ApolloCache.prototype.writeQuery = function(options) {
        this.write({
            dataId: 'ROOT_QUERY',
            result: options.data,
            query: options.query,
            variables: options.variables
        });
    };
    ApolloCache.prototype.writeFragment = function(options) {
        this.write({
            dataId: options.id,
            result: options.data,
            variables: options.variables,
            query: (0, $jFDfc.getFragmentQueryDocument)(options.fragment, options.fragmentName)
        });
    };
    ApolloCache.prototype.writeData = function(_a) {
        var id = _a.id, data = _a.data;
        if (typeof id !== 'undefined') {
            var typenameResult = null;
            try {
                typenameResult = this.read({
                    rootId: id,
                    optimistic: false,
                    query: $60682668fc3daa4e$var$justTypenameQuery
                });
            } catch (e) {}
            var __typename = typenameResult && typenameResult.__typename || '__ClientData';
            var dataToWrite = Object.assign({
                __typename: __typename
            }, data);
            this.writeFragment({
                id: id,
                fragment: $60682668fc3daa4e$var$fragmentFromPojo(dataToWrite, __typename),
                data: dataToWrite
            });
        } else this.writeQuery({
            query: $60682668fc3daa4e$var$queryFromPojo(data),
            data: data
        });
    };
    return ApolloCache;
}();
var $60682668fc3daa4e$export$94affb487e701bf2;
$60682668fc3daa4e$export$94affb487e701bf2 || ($60682668fc3daa4e$export$94affb487e701bf2 = {});

});

parcelRegister("9WJrj", function(module, exports) {

$parcel$export(module.exports, "KeyTrie", () => $73dcc72a68d15397$export$6bd8d8299be3ac82);
$parcel$export(module.exports, "wrap", () => $73dcc72a68d15397$export$4997ffc0176396a6);

var $hUWo2 = parcelRequire("hUWo2");
function $73dcc72a68d15397$var$defaultDispose() {}
var $73dcc72a68d15397$var$Cache = /** @class */ function() {
    function Cache(max, dispose) {
        if (max === void 0) max = Infinity;
        if (dispose === void 0) dispose = $73dcc72a68d15397$var$defaultDispose;
        this.max = max;
        this.dispose = dispose;
        this.map = new Map();
        this.newest = null;
        this.oldest = null;
    }
    Cache.prototype.has = function(key) {
        return this.map.has(key);
    };
    Cache.prototype.get = function(key) {
        var entry = this.getEntry(key);
        return entry && entry.value;
    };
    Cache.prototype.getEntry = function(key) {
        var entry = this.map.get(key);
        if (entry && entry !== this.newest) {
            var older = entry.older, newer = entry.newer;
            if (newer) newer.older = older;
            if (older) older.newer = newer;
            entry.older = this.newest;
            entry.older.newer = entry;
            entry.newer = null;
            this.newest = entry;
            if (entry === this.oldest) this.oldest = newer;
        }
        return entry;
    };
    Cache.prototype.set = function(key, value) {
        var entry = this.getEntry(key);
        if (entry) return entry.value = value;
        entry = {
            key: key,
            value: value,
            newer: null,
            older: this.newest
        };
        if (this.newest) this.newest.newer = entry;
        this.newest = entry;
        this.oldest = this.oldest || entry;
        this.map.set(key, entry);
        return entry.value;
    };
    Cache.prototype.clean = function() {
        while(this.oldest && this.map.size > this.max)this.delete(this.oldest.key);
    };
    Cache.prototype.delete = function(key) {
        var entry = this.map.get(key);
        if (entry) {
            if (entry === this.newest) this.newest = entry.older;
            if (entry === this.oldest) this.oldest = entry.newer;
            if (entry.newer) entry.newer.older = entry.older;
            if (entry.older) entry.older.newer = entry.newer;
            this.map.delete(key);
            this.dispose(entry.value, key);
            return true;
        }
        return false;
    };
    return Cache;
}();
var $73dcc72a68d15397$var$parentEntrySlot = new (0, $hUWo2.Slot)();
var $73dcc72a68d15397$var$reusableEmptyArray = [];
var $73dcc72a68d15397$var$emptySetPool = [];
var $73dcc72a68d15397$var$POOL_TARGET_SIZE = 100;
// Since this package might be used browsers, we should avoid using the
// Node built-in assert module.
function $73dcc72a68d15397$var$assert(condition, optionalMessage) {
    if (!condition) throw new Error(optionalMessage || "assertion failure");
}
function $73dcc72a68d15397$var$valueIs(a, b) {
    var len = a.length;
    return(// Unknown values are not equal to each other.
    len > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    len === b.length && // The underlying value or exception must be the same.
    a[len - 1] === b[len - 1]);
}
function $73dcc72a68d15397$var$valueGet(value) {
    switch(value.length){
        case 0:
            throw new Error("unknown value");
        case 1:
            return value[0];
        case 2:
            throw value[1];
    }
}
function $73dcc72a68d15397$var$valueCopy(value) {
    return value.slice(0);
}
var $73dcc72a68d15397$var$Entry = /** @class */ function() {
    function Entry(fn, args) {
        this.fn = fn;
        this.args = args;
        this.parents = new Set();
        this.childValues = new Map();
        // When this Entry has children that are dirty, this property becomes
        // a Set containing other Entry objects, borrowed from emptySetPool.
        // When the set becomes empty, it gets recycled back to emptySetPool.
        this.dirtyChildren = null;
        this.dirty = true;
        this.recomputing = false;
        this.value = [];
        ++Entry.count;
    }
    // This is the most important method of the Entry API, because it
    // determines whether the cached this.value can be returned immediately,
    // or must be recomputed. The overall performance of the caching system
    // depends on the truth of the following observations: (1) this.dirty is
    // usually false, (2) this.dirtyChildren is usually null/empty, and thus
    // (3) valueGet(this.value) is usually returned without recomputation.
    Entry.prototype.recompute = function() {
        $73dcc72a68d15397$var$assert(!this.recomputing, "already recomputing");
        if (!$73dcc72a68d15397$var$rememberParent(this) && $73dcc72a68d15397$var$maybeReportOrphan(this)) // The recipient of the entry.reportOrphan callback decided to dispose
        // of this orphan entry by calling entry.dispose(), so we don't need to
        // (and should not) proceed with the recomputation.
        return void 0;
        return $73dcc72a68d15397$var$mightBeDirty(this) ? $73dcc72a68d15397$var$reallyRecompute(this) : $73dcc72a68d15397$var$valueGet(this.value);
    };
    Entry.prototype.setDirty = function() {
        if (this.dirty) return;
        this.dirty = true;
        this.value.length = 0;
        $73dcc72a68d15397$var$reportDirty(this);
        // We can go ahead and unsubscribe here, since any further dirty
        // notifications we receive will be redundant, and unsubscribing may
        // free up some resources, e.g. file watchers.
        $73dcc72a68d15397$var$maybeUnsubscribe(this);
    };
    Entry.prototype.dispose = function() {
        var _this = this;
        $73dcc72a68d15397$var$forgetChildren(this).forEach($73dcc72a68d15397$var$maybeReportOrphan);
        $73dcc72a68d15397$var$maybeUnsubscribe(this);
        // Because this entry has been kicked out of the cache (in index.js),
        // we've lost the ability to find out if/when this entry becomes dirty,
        // whether that happens through a subscription, because of a direct call
        // to entry.setDirty(), or because one of its children becomes dirty.
        // Because of this loss of future information, we have to assume the
        // worst (that this entry might have become dirty very soon), so we must
        // immediately mark this entry's parents as dirty. Normally we could
        // just call entry.setDirty() rather than calling parent.setDirty() for
        // each parent, but that would leave this entry in parent.childValues
        // and parent.dirtyChildren, which would prevent the child from being
        // truly forgotten.
        this.parents.forEach(function(parent) {
            parent.setDirty();
            $73dcc72a68d15397$var$forgetChild(parent, _this);
        });
    };
    Entry.count = 0;
    return Entry;
}();
function $73dcc72a68d15397$var$rememberParent(child) {
    var parent = $73dcc72a68d15397$var$parentEntrySlot.getValue();
    if (parent) {
        child.parents.add(parent);
        if (!parent.childValues.has(child)) parent.childValues.set(child, []);
        if ($73dcc72a68d15397$var$mightBeDirty(child)) $73dcc72a68d15397$var$reportDirtyChild(parent, child);
        else $73dcc72a68d15397$var$reportCleanChild(parent, child);
        return parent;
    }
}
function $73dcc72a68d15397$var$reallyRecompute(entry) {
    // Since this recomputation is likely to re-remember some of this
    // entry's children, we forget our children here but do not call
    // maybeReportOrphan until after the recomputation finishes.
    var originalChildren = $73dcc72a68d15397$var$forgetChildren(entry);
    // Set entry as the parent entry while calling recomputeNewValue(entry).
    $73dcc72a68d15397$var$parentEntrySlot.withValue(entry, $73dcc72a68d15397$var$recomputeNewValue, [
        entry
    ]);
    if ($73dcc72a68d15397$var$maybeSubscribe(entry)) // If we successfully recomputed entry.value and did not fail to
    // (re)subscribe, then this Entry is no longer explicitly dirty.
    $73dcc72a68d15397$var$setClean(entry);
    // Now that we've had a chance to re-remember any children that were
    // involved in the recomputation, we can safely report any orphan
    // children that remain.
    originalChildren.forEach($73dcc72a68d15397$var$maybeReportOrphan);
    return $73dcc72a68d15397$var$valueGet(entry.value);
}
function $73dcc72a68d15397$var$recomputeNewValue(entry) {
    entry.recomputing = true;
    // Set entry.value as unknown.
    entry.value.length = 0;
    try {
        // If entry.fn succeeds, entry.value will become a normal Value.
        entry.value[0] = entry.fn.apply(null, entry.args);
    } catch (e) {
        // If entry.fn throws, entry.value will become exceptional.
        entry.value[1] = e;
    }
    // Either way, this line is always reached.
    entry.recomputing = false;
}
function $73dcc72a68d15397$var$mightBeDirty(entry) {
    return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
}
function $73dcc72a68d15397$var$setClean(entry) {
    entry.dirty = false;
    if ($73dcc72a68d15397$var$mightBeDirty(entry)) // This Entry may still have dirty children, in which case we can't
    // let our parents know we're clean just yet.
    return;
    $73dcc72a68d15397$var$reportClean(entry);
}
function $73dcc72a68d15397$var$reportDirty(child) {
    child.parents.forEach(function(parent) {
        return $73dcc72a68d15397$var$reportDirtyChild(parent, child);
    });
}
function $73dcc72a68d15397$var$reportClean(child) {
    child.parents.forEach(function(parent) {
        return $73dcc72a68d15397$var$reportCleanChild(parent, child);
    });
}
// Let a parent Entry know that one of its children may be dirty.
function $73dcc72a68d15397$var$reportDirtyChild(parent, child) {
    // Must have called rememberParent(child) before calling
    // reportDirtyChild(parent, child).
    $73dcc72a68d15397$var$assert(parent.childValues.has(child));
    $73dcc72a68d15397$var$assert($73dcc72a68d15397$var$mightBeDirty(child));
    if (!parent.dirtyChildren) parent.dirtyChildren = $73dcc72a68d15397$var$emptySetPool.pop() || new Set;
    else if (parent.dirtyChildren.has(child)) // If we already know this child is dirty, then we must have already
    // informed our own parents that we are dirty, so we can terminate
    // the recursion early.
    return;
    parent.dirtyChildren.add(child);
    $73dcc72a68d15397$var$reportDirty(parent);
}
// Let a parent Entry know that one of its children is no longer dirty.
function $73dcc72a68d15397$var$reportCleanChild(parent, child) {
    // Must have called rememberChild(child) before calling
    // reportCleanChild(parent, child).
    $73dcc72a68d15397$var$assert(parent.childValues.has(child));
    $73dcc72a68d15397$var$assert(!$73dcc72a68d15397$var$mightBeDirty(child));
    var childValue = parent.childValues.get(child);
    if (childValue.length === 0) parent.childValues.set(child, $73dcc72a68d15397$var$valueCopy(child.value));
    else if (!$73dcc72a68d15397$var$valueIs(childValue, child.value)) parent.setDirty();
    $73dcc72a68d15397$var$removeDirtyChild(parent, child);
    if ($73dcc72a68d15397$var$mightBeDirty(parent)) return;
    $73dcc72a68d15397$var$reportClean(parent);
}
function $73dcc72a68d15397$var$removeDirtyChild(parent, child) {
    var dc = parent.dirtyChildren;
    if (dc) {
        dc.delete(child);
        if (dc.size === 0) {
            if ($73dcc72a68d15397$var$emptySetPool.length < $73dcc72a68d15397$var$POOL_TARGET_SIZE) $73dcc72a68d15397$var$emptySetPool.push(dc);
            parent.dirtyChildren = null;
        }
    }
}
// If the given entry has a reportOrphan method, and no remaining parents,
// call entry.reportOrphan and return true iff it returns true. The
// reportOrphan function should return true to indicate entry.dispose()
// has been called, and the entry has been removed from any other caches
// (see index.js for the only current example).
function $73dcc72a68d15397$var$maybeReportOrphan(entry) {
    return entry.parents.size === 0 && typeof entry.reportOrphan === "function" && entry.reportOrphan() === true;
}
// Removes all children from this entry and returns an array of the
// removed children.
function $73dcc72a68d15397$var$forgetChildren(parent) {
    var children = $73dcc72a68d15397$var$reusableEmptyArray;
    if (parent.childValues.size > 0) {
        children = [];
        parent.childValues.forEach(function(_value, child) {
            $73dcc72a68d15397$var$forgetChild(parent, child);
            children.push(child);
        });
    }
    // After we forget all our children, this.dirtyChildren must be empty
    // and therefore must have been reset to null.
    $73dcc72a68d15397$var$assert(parent.dirtyChildren === null);
    return children;
}
function $73dcc72a68d15397$var$forgetChild(parent, child) {
    child.parents.delete(parent);
    parent.childValues.delete(child);
    $73dcc72a68d15397$var$removeDirtyChild(parent, child);
}
function $73dcc72a68d15397$var$maybeSubscribe(entry) {
    if (typeof entry.subscribe === "function") try {
        $73dcc72a68d15397$var$maybeUnsubscribe(entry); // Prevent double subscriptions.
        entry.unsubscribe = entry.subscribe.apply(null, entry.args);
    } catch (e) {
        // If this Entry has a subscribe function and it threw an exception
        // (or an unsubscribe function it previously returned now throws),
        // return false to indicate that we were not able to subscribe (or
        // unsubscribe), and this Entry should remain dirty.
        entry.setDirty();
        return false;
    }
    // Returning true indicates either that there was no entry.subscribe
    // function or that it succeeded.
    return true;
}
function $73dcc72a68d15397$var$maybeUnsubscribe(entry) {
    var unsubscribe = entry.unsubscribe;
    if (typeof unsubscribe === "function") {
        entry.unsubscribe = void 0;
        unsubscribe();
    }
}
// A trie data structure that holds object keys weakly, yet can also hold
// non-object keys, unlike the native `WeakMap`.
var $73dcc72a68d15397$export$6bd8d8299be3ac82 = /** @class */ function() {
    function KeyTrie(weakness) {
        this.weakness = weakness;
    }
    KeyTrie.prototype.lookup = function() {
        var array = [];
        for(var _i = 0; _i < arguments.length; _i++)array[_i] = arguments[_i];
        return this.lookupArray(array);
    };
    KeyTrie.prototype.lookupArray = function(array) {
        var node = this;
        array.forEach(function(key) {
            return node = node.getChildTrie(key);
        });
        return node.data || (node.data = Object.create(null));
    };
    KeyTrie.prototype.getChildTrie = function(key) {
        var map = this.weakness && $73dcc72a68d15397$var$isObjRef(key) ? this.weak || (this.weak = new WeakMap()) : this.strong || (this.strong = new Map());
        var child = map.get(key);
        if (!child) map.set(key, child = new KeyTrie(this.weakness));
        return child;
    };
    return KeyTrie;
}();
function $73dcc72a68d15397$var$isObjRef(value) {
    switch(typeof value){
        case "object":
            if (value === null) break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}
// The defaultMakeCacheKey function is remarkably powerful, because it gives
// a unique object for any shallow-identical list of arguments. If you need
// to implement a custom makeCacheKey function, you may find it helpful to
// delegate the final work to defaultMakeCacheKey, which is why we export it
// here. However, you may want to avoid defaultMakeCacheKey if your runtime
// does not support WeakMap, or you have the ability to return a string key.
// In those cases, just write your own custom makeCacheKey functions.
var $73dcc72a68d15397$var$keyTrie = new $73dcc72a68d15397$export$6bd8d8299be3ac82(typeof WeakMap === "function");
function $73dcc72a68d15397$export$cd3144f8dd136006() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return $73dcc72a68d15397$var$keyTrie.lookupArray(args);
}
var $73dcc72a68d15397$var$caches = new Set();
function $73dcc72a68d15397$export$4997ffc0176396a6(originalFunction, options) {
    if (options === void 0) options = Object.create(null);
    var cache = new $73dcc72a68d15397$var$Cache(options.max || Math.pow(2, 16), function(entry) {
        return entry.dispose();
    });
    var disposable = !!options.disposable;
    var makeCacheKey = options.makeCacheKey || $73dcc72a68d15397$export$cd3144f8dd136006;
    function optimistic() {
        if (disposable && !$73dcc72a68d15397$var$parentEntrySlot.hasValue()) // If there's no current parent computation, and this wrapped
        // function is disposable (meaning we don't care about entry.value,
        // just dependency tracking), then we can short-cut everything else
        // in this function, because entry.recompute() is going to recycle
        // the entry object without recomputing anything, anyway.
        return void 0;
        var key = makeCacheKey.apply(null, arguments);
        if (key === void 0) return originalFunction.apply(null, arguments);
        var args = Array.prototype.slice.call(arguments);
        var entry = cache.get(key);
        if (entry) entry.args = args;
        else {
            entry = new $73dcc72a68d15397$var$Entry(originalFunction, args);
            cache.set(key, entry);
            entry.subscribe = options.subscribe;
            if (disposable) entry.reportOrphan = function() {
                return cache.delete(key);
            };
        }
        var value = entry.recompute();
        // Move this entry to the front of the least-recently used queue,
        // since we just finished computing its value.
        cache.set(key, entry);
        $73dcc72a68d15397$var$caches.add(cache);
        // Clean up any excess entries in the cache, but only if there is no
        // active parent entry, meaning we're not in the middle of a larger
        // computation that might be flummoxed by the cleaning.
        if (!$73dcc72a68d15397$var$parentEntrySlot.hasValue()) {
            $73dcc72a68d15397$var$caches.forEach(function(cache) {
                return cache.clean();
            });
            $73dcc72a68d15397$var$caches.clear();
        }
        // If options.disposable is truthy, the caller of wrap is telling us
        // they don't care about the result of entry.recompute(), so we should
        // avoid returning the value, so it won't be accidentally used.
        return disposable ? void 0 : value;
    }
    optimistic.dirty = function() {
        var key = makeCacheKey.apply(null, arguments);
        var child = key !== void 0 && cache.get(key);
        if (child) child.setDirty();
    };
    return optimistic;
}

});
parcelRegister("hUWo2", function(module, exports) {

$parcel$export(module.exports, "Slot", () => $d0b4f509668bceb7$export$8c6ed5c666ac1360);
// This currentContext variable will only be used if the makeSlotClass
// function is called, which happens only if this is the first copy of the
// @wry/context package to be imported.
var $d0b4f509668bceb7$var$currentContext = null;
// This unique internal object is used to denote the absence of a value
// for a given Slot, and is never exposed to outside code.
var $d0b4f509668bceb7$var$MISSING_VALUE = {};
var $d0b4f509668bceb7$var$idCounter = 1;
// Although we can't do anything about the cost of duplicated code from
// accidentally bundling multiple copies of the @wry/context package, we can
// avoid creating the Slot class more than once using makeSlotClass.
var $d0b4f509668bceb7$var$makeSlotClass = function() {
    return /** @class */ function() {
        function Slot() {
            // If you have a Slot object, you can find out its slot.id, but you cannot
            // guess the slot.id of a Slot you don't have access to, thanks to the
            // randomized suffix.
            this.id = [
                "slot",
                $d0b4f509668bceb7$var$idCounter++,
                Date.now(),
                Math.random().toString(36).slice(2)
            ].join(":");
        }
        Slot.prototype.hasValue = function() {
            for(var context_1 = $d0b4f509668bceb7$var$currentContext; context_1; context_1 = context_1.parent)// We use the Slot object iself as a key to its value, which means the
            // value cannot be obtained without a reference to the Slot object.
            if (this.id in context_1.slots) {
                var value = context_1.slots[this.id];
                if (value === $d0b4f509668bceb7$var$MISSING_VALUE) break;
                if (context_1 !== $d0b4f509668bceb7$var$currentContext) // Cache the value in currentContext.slots so the next lookup will
                // be faster. This caching is safe because the tree of contexts and
                // the values of the slots are logically immutable.
                $d0b4f509668bceb7$var$currentContext.slots[this.id] = value;
                return true;
            }
            if ($d0b4f509668bceb7$var$currentContext) // If a value was not found for this Slot, it's never going to be found
            // no matter how many times we look it up, so we might as well cache
            // the absence of the value, too.
            $d0b4f509668bceb7$var$currentContext.slots[this.id] = $d0b4f509668bceb7$var$MISSING_VALUE;
            return false;
        };
        Slot.prototype.getValue = function() {
            if (this.hasValue()) return $d0b4f509668bceb7$var$currentContext.slots[this.id];
        };
        Slot.prototype.withValue = function(value, callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            var _a;
            var slots = (_a = {
                __proto__: null
            }, _a[this.id] = value, _a);
            var parent = $d0b4f509668bceb7$var$currentContext;
            $d0b4f509668bceb7$var$currentContext = {
                parent: parent,
                slots: slots
            };
            try {
                // Function.prototype.apply allows the arguments array argument to be
                // omitted or undefined, so args! is fine here.
                return callback.apply(thisArg, args);
            } finally{
                $d0b4f509668bceb7$var$currentContext = parent;
            }
        };
        // Capture the current context and wrap a callback function so that it
        // reestablishes the captured context when called.
        Slot.bind = function(callback) {
            var context = $d0b4f509668bceb7$var$currentContext;
            return function() {
                var saved = $d0b4f509668bceb7$var$currentContext;
                try {
                    $d0b4f509668bceb7$var$currentContext = context;
                    return callback.apply(this, arguments);
                } finally{
                    $d0b4f509668bceb7$var$currentContext = saved;
                }
            };
        };
        // Immediately run a callback function without any captured context.
        Slot.noContext = function(callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            if ($d0b4f509668bceb7$var$currentContext) {
                var saved = $d0b4f509668bceb7$var$currentContext;
                try {
                    $d0b4f509668bceb7$var$currentContext = null;
                    // Function.prototype.apply allows the arguments array argument to be
                    // omitted or undefined, so args! is fine here.
                    return callback.apply(thisArg, args);
                } finally{
                    $d0b4f509668bceb7$var$currentContext = saved;
                }
            } else return callback.apply(thisArg, args);
        };
        return Slot;
    }();
};
// We store a single global implementation of the Slot class as a permanent
// non-enumerable symbol property of the Array constructor. This obfuscation
// does nothing to prevent access to the Slot class, but at least it ensures
// the implementation (i.e. currentContext) cannot be tampered with, and all
// copies of the @wry/context package (hopefully just one) will share the
// same Slot implementation. Since the first copy of the @wry/context package
// to be imported wins, this technique imposes a very high cost for any
// future breaking changes to the Slot class.
var $d0b4f509668bceb7$var$globalKey = "@wry/context:Slot";
var $d0b4f509668bceb7$var$host = Array;
var $d0b4f509668bceb7$export$8c6ed5c666ac1360 = $d0b4f509668bceb7$var$host[$d0b4f509668bceb7$var$globalKey] || function() {
    var Slot = $d0b4f509668bceb7$var$makeSlotClass();
    try {
        Object.defineProperty($d0b4f509668bceb7$var$host, $d0b4f509668bceb7$var$globalKey, {
            value: $d0b4f509668bceb7$var$host[$d0b4f509668bceb7$var$globalKey] = Slot,
            enumerable: false,
            writable: false,
            configurable: false
        });
    } finally{
        return Slot;
    }
}();
var $d0b4f509668bceb7$export$2385a24977818dd0 = $d0b4f509668bceb7$export$8c6ed5c666ac1360.bind, $d0b4f509668bceb7$export$9fa6f2e300a97f8 = $d0b4f509668bceb7$export$8c6ed5c666ac1360.noContext;
function $d0b4f509668bceb7$export$831dc9f2ab0a617b(callback, delay) {
    return setTimeout($d0b4f509668bceb7$export$2385a24977818dd0(callback), delay);
}
// Turn any generator function into an async function (using yield instead
// of await), with context automatically preserved across yields.
function $d0b4f509668bceb7$export$d5d7536e965c82da(genFn) {
    return function() {
        var gen = genFn.apply(this, arguments);
        var boundNext = $d0b4f509668bceb7$export$2385a24977818dd0(gen.next);
        var boundThrow = $d0b4f509668bceb7$export$2385a24977818dd0(gen.throw);
        return new Promise(function(resolve, reject) {
            function invoke(method, argument) {
                try {
                    var result = method.call(gen, argument);
                } catch (error) {
                    return reject(error);
                }
                var next = result.done ? resolve : invokeNext;
                if ($d0b4f509668bceb7$var$isPromiseLike(result.value)) result.value.then(next, result.done ? reject : invokeThrow);
                else next(result.value);
            }
            var invokeNext = function(value) {
                return invoke(boundNext, value);
            };
            var invokeThrow = function(error) {
                return invoke(boundThrow, error);
            };
            invokeNext();
        });
    };
}
function $d0b4f509668bceb7$var$isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// If you use the fibers npm package to implement coroutines in Node.js,
// you should call this function at least once to ensure context management
// remains coherent across any yields.
var $d0b4f509668bceb7$var$wrappedFibers = [];
function $d0b4f509668bceb7$export$14794f6e0a4dc6a0(Fiber) {
    // There can be only one implementation of Fiber per process, so this array
    // should never grow longer than one element.
    if ($d0b4f509668bceb7$var$wrappedFibers.indexOf(Fiber) < 0) {
        var wrap = function(obj, method) {
            var fn = obj[method];
            obj[method] = function() {
                return $d0b4f509668bceb7$export$9fa6f2e300a97f8(fn, arguments, this);
            };
        };
        // These methods can yield, according to
        // https://github.com/laverdet/node-fibers/blob/ddebed9b8ae3883e57f822e2108e6943e5c8d2a8/fibers.js#L97-L100
        wrap(Fiber, "yield");
        wrap(Fiber.prototype, "run");
        wrap(Fiber.prototype, "throwInto");
        $d0b4f509668bceb7$var$wrappedFibers.push(Fiber);
    }
    return Fiber;
}

});



parcelRegister("i8eSF", function(module, exports) {

$parcel$export(module.exports, "onError", () => $d334845f424573c9$export$2288787135a8f66e);

var $dnskZ = parcelRequire("dnskZ");

var $7oe8F = parcelRequire("7oe8F");
function $d334845f424573c9$export$2288787135a8f66e(errorHandler) {
    return new (0, $7oe8F.ApolloLink)(function(operation, forward) {
        return new (0, $7oe8F.Observable)(function(observer) {
            var sub;
            var retriedSub;
            var retriedResult;
            try {
                sub = forward(operation).subscribe({
                    next: function(result) {
                        if (result.errors) {
                            retriedResult = errorHandler({
                                graphQLErrors: result.errors,
                                response: result,
                                operation: operation,
                                forward: forward
                            });
                            if (retriedResult) {
                                retriedSub = retriedResult.subscribe({
                                    next: observer.next.bind(observer),
                                    error: observer.error.bind(observer),
                                    complete: observer.complete.bind(observer)
                                });
                                return;
                            }
                        }
                        observer.next(result);
                    },
                    error: function(networkError) {
                        retriedResult = errorHandler({
                            operation: operation,
                            networkError: networkError,
                            graphQLErrors: networkError && networkError.result && networkError.result.errors,
                            forward: forward
                        });
                        if (retriedResult) {
                            retriedSub = retriedResult.subscribe({
                                next: observer.next.bind(observer),
                                error: observer.error.bind(observer),
                                complete: observer.complete.bind(observer)
                            });
                            return;
                        }
                        observer.error(networkError);
                    },
                    complete: function() {
                        if (!retriedResult) observer.complete.bind(observer)();
                    }
                });
            } catch (e) {
                errorHandler({
                    networkError: e,
                    operation: operation,
                    forward: forward
                });
                observer.error(e);
            }
            return function() {
                if (sub) sub.unsubscribe();
                if (retriedSub) sub.unsubscribe();
            };
        });
    });
}
var $d334845f424573c9$export$d2c8415987899609 = function(_super) {
    (0, $dnskZ.__extends)(ErrorLink, _super);
    function ErrorLink(errorHandler) {
        var _this = _super.call(this) || this;
        _this.link = $d334845f424573c9$export$2288787135a8f66e(errorHandler);
        return _this;
    }
    ErrorLink.prototype.request = function(operation, forward) {
        return this.link.request(operation, forward);
    };
    return ErrorLink;
}((0, $7oe8F.ApolloLink));

});

parcelRegister("eHpnE", function(module, exports) {

$parcel$export(module.exports, "HttpLink", () => $ab38c4d93356db03$export$f4bbf1aec241cc1);

var $dnskZ = parcelRequire("dnskZ");

var $7oe8F = parcelRequire("7oe8F");

var $1pDgh = parcelRequire("1pDgh");
var $ab38c4d93356db03$export$95180a16573d6675 = function(linkOptions) {
    if (linkOptions === void 0) linkOptions = {};
    var _a = linkOptions.uri, uri = _a === void 0 ? '/graphql' : _a, fetcher = linkOptions.fetch, includeExtensions = linkOptions.includeExtensions, useGETForQueries = linkOptions.useGETForQueries, abortErrorDoesNotCauseError = linkOptions.abortErrorDoesNotCauseError, requestOptions = (0, $dnskZ.__rest)(linkOptions, [
        "uri",
        "fetch",
        "includeExtensions",
        "useGETForQueries",
        "abortErrorDoesNotCauseError"
    ]);
    (0, $1pDgh.checkFetcher)(fetcher);
    if (!fetcher) fetcher = fetch;
    var linkConfig = {
        http: {
            includeExtensions: includeExtensions
        },
        options: requestOptions.fetchOptions,
        credentials: requestOptions.credentials,
        headers: requestOptions.headers
    };
    return new (0, $7oe8F.ApolloLink)(function(operation) {
        var chosenURI = (0, $1pDgh.selectURI)(operation, uri);
        var context = operation.getContext();
        var clientAwarenessHeaders = {};
        if (context.clientAwareness) {
            var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
            if (name_1) clientAwarenessHeaders['apollographql-client-name'] = name_1;
            if (version) clientAwarenessHeaders['apollographql-client-version'] = version;
        }
        var contextHeaders = (0, $dnskZ.__assign)({}, clientAwarenessHeaders, context.headers);
        var contextConfig = {
            http: context.http,
            options: context.fetchOptions,
            credentials: context.credentials,
            headers: contextHeaders
        };
        var _b = (0, $1pDgh.selectHttpOptionsAndBody)(operation, (0, $1pDgh.fallbackHttpConfig), linkConfig, contextConfig), options = _b.options, body = _b.body;
        var controller;
        if (!options.signal) {
            var _c = (0, $1pDgh.createSignalIfSupported)(), _controller = _c.controller, signal = _c.signal;
            controller = _controller;
            if (controller) options.signal = signal;
        }
        var definitionIsMutation = function(d) {
            return d.kind === 'OperationDefinition' && d.operation === 'mutation';
        };
        if (useGETForQueries && !operation.query.definitions.some(definitionIsMutation)) options.method = 'GET';
        if (options.method === 'GET') {
            var _d = $ab38c4d93356db03$var$rewriteURIForGET(chosenURI, body), newURI = _d.newURI, parseError = _d.parseError;
            if (parseError) return (0, $7oe8F.fromError)(parseError);
            chosenURI = newURI;
        } else try {
            options.body = (0, $1pDgh.serializeFetchParameter)(body, 'Payload');
        } catch (parseError) {
            return (0, $7oe8F.fromError)(parseError);
        }
        return new (0, $7oe8F.Observable)(function(observer) {
            fetcher(chosenURI, options).then(function(response) {
                operation.setContext({
                    response: response
                });
                return response;
            }).then((0, $1pDgh.parseAndCheckHttpResponse)(operation)).then(function(result) {
                observer.next(result);
                observer.complete();
                return result;
            }).catch(function(err) {
                if (err.name === 'AbortError' && !abortErrorDoesNotCauseError) return;
                if (err.result && err.result.errors && err.result.data) observer.next(err.result);
                observer.error(err);
            });
            return function() {
                if (controller) controller.abort();
            };
        });
    });
};
function $ab38c4d93356db03$var$rewriteURIForGET(chosenURI, body) {
    var queryParams = [];
    var addQueryParam = function(key, value) {
        queryParams.push(key + "=" + encodeURIComponent(value));
    };
    if ('query' in body) addQueryParam('query', body.query);
    if (body.operationName) addQueryParam('operationName', body.operationName);
    if (body.variables) {
        var serializedVariables = void 0;
        try {
            serializedVariables = (0, $1pDgh.serializeFetchParameter)(body.variables, 'Variables map');
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam('variables', serializedVariables);
    }
    if (body.extensions) {
        var serializedExtensions = void 0;
        try {
            serializedExtensions = (0, $1pDgh.serializeFetchParameter)(body.extensions, 'Extensions map');
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam('extensions', serializedExtensions);
    }
    var fragment = '', preFragment = chosenURI;
    var fragmentStart = chosenURI.indexOf('#');
    if (fragmentStart !== -1) {
        fragment = chosenURI.substr(fragmentStart);
        preFragment = chosenURI.substr(0, fragmentStart);
    }
    var queryParamsPrefix = preFragment.indexOf('?') === -1 ? '?' : '&';
    var newURI = preFragment + queryParamsPrefix + queryParams.join('&') + fragment;
    return {
        newURI: newURI
    };
}
var $ab38c4d93356db03$export$f4bbf1aec241cc1 = function(_super) {
    (0, $dnskZ.__extends)(HttpLink, _super);
    function HttpLink(opts) {
        return _super.call(this, $ab38c4d93356db03$export$95180a16573d6675(opts).request) || this;
    }
    return HttpLink;
}((0, $7oe8F.ApolloLink));

});
parcelRegister("1pDgh", function(module, exports) {

$parcel$export(module.exports, "fallbackHttpConfig", () => $107694c730f3c7b9$export$dd86f00dc866e75d);
$parcel$export(module.exports, "parseAndCheckHttpResponse", () => $107694c730f3c7b9$export$d4051215bea0639f);
$parcel$export(module.exports, "checkFetcher", () => $107694c730f3c7b9$export$8423f0cd3773115e);
$parcel$export(module.exports, "createSignalIfSupported", () => $107694c730f3c7b9$export$f5853cd1fc39aea6);
$parcel$export(module.exports, "selectHttpOptionsAndBody", () => $107694c730f3c7b9$export$a00ebfd5f1eebfb1);
$parcel$export(module.exports, "serializeFetchParameter", () => $107694c730f3c7b9$export$5f8e80ac52052e28);
$parcel$export(module.exports, "selectURI", () => $107694c730f3c7b9$export$63ccc2571850f81a);

var $dnskZ = parcelRequire("dnskZ");

var $6NFTG = parcelRequire("6NFTG");

var $lDEi6 = parcelRequire("lDEi6");
var $107694c730f3c7b9$var$defaultHttpOptions = {
    includeQuery: true,
    includeExtensions: false
};
var $107694c730f3c7b9$var$defaultHeaders = {
    accept: '*/*',
    'content-type': 'application/json'
};
var $107694c730f3c7b9$var$defaultOptions = {
    method: 'POST'
};
var $107694c730f3c7b9$export$dd86f00dc866e75d = {
    http: $107694c730f3c7b9$var$defaultHttpOptions,
    headers: $107694c730f3c7b9$var$defaultHeaders,
    options: $107694c730f3c7b9$var$defaultOptions
};
var $107694c730f3c7b9$export$c33ef9219f27efd7 = function(response, result, message) {
    var error = new Error(message);
    error.name = 'ServerError';
    error.response = response;
    error.statusCode = response.status;
    error.result = result;
    throw error;
};
var $107694c730f3c7b9$export$d4051215bea0639f = function(operations) {
    return function(response) {
        return response.text().then(function(bodyText) {
            try {
                return JSON.parse(bodyText);
            } catch (err) {
                var parseError = err;
                parseError.name = 'ServerParseError';
                parseError.response = response;
                parseError.statusCode = response.status;
                parseError.bodyText = bodyText;
                return Promise.reject(parseError);
            }
        }).then(function(result) {
            if (response.status >= 300) $107694c730f3c7b9$export$c33ef9219f27efd7(response, result, "Response not successful: Received status code " + response.status);
            if (!Array.isArray(result) && !result.hasOwnProperty('data') && !result.hasOwnProperty('errors')) $107694c730f3c7b9$export$c33ef9219f27efd7(response, result, "Server response was missing for query '" + (Array.isArray(operations) ? operations.map(function(op) {
                return op.operationName;
            }) : operations.operationName) + "'.");
            return result;
        });
    };
};
var $107694c730f3c7b9$export$8423f0cd3773115e = function(fetcher) {
    if (!fetcher && typeof fetch === 'undefined') {
        var library = 'unfetch';
        if (typeof window === 'undefined') library = 'node-fetch';
        throw new (0, $lDEi6.InvariantError)(1);
    }
};
var $107694c730f3c7b9$export$f5853cd1fc39aea6 = function() {
    if (typeof AbortController === 'undefined') return {
        controller: false,
        signal: false
    };
    var controller = new AbortController();
    var signal = controller.signal;
    return {
        controller: controller,
        signal: signal
    };
};
var $107694c730f3c7b9$export$a00ebfd5f1eebfb1 = function(operation, fallbackConfig) {
    var configs = [];
    for(var _i = 2; _i < arguments.length; _i++)configs[_i - 2] = arguments[_i];
    var options = (0, $dnskZ.__assign)({}, fallbackConfig.options, {
        headers: fallbackConfig.headers,
        credentials: fallbackConfig.credentials
    });
    var http = fallbackConfig.http;
    configs.forEach(function(config) {
        options = (0, $dnskZ.__assign)({}, options, config.options, {
            headers: (0, $dnskZ.__assign)({}, options.headers, config.headers)
        });
        if (config.credentials) options.credentials = config.credentials;
        http = (0, $dnskZ.__assign)({}, http, config.http);
    });
    var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
    var body = {
        operationName: operationName,
        variables: variables
    };
    if (http.includeExtensions) body.extensions = extensions;
    if (http.includeQuery) body.query = (0, $6NFTG.print)(query);
    return {
        options: options,
        body: body
    };
};
var $107694c730f3c7b9$export$5f8e80ac52052e28 = function(p, label) {
    var serialized;
    try {
        serialized = JSON.stringify(p);
    } catch (e) {
        var parseError = new (0, $lDEi6.InvariantError)(2);
        parseError.parseError = e;
        throw parseError;
    }
    return serialized;
};
var $107694c730f3c7b9$export$63ccc2571850f81a = function(operation, fallbackURI) {
    var context = operation.getContext();
    var contextURI = context.uri;
    if (contextURI) return contextURI;
    else if (typeof fallbackURI === 'function') return fallbackURI(operation);
    else return fallbackURI || '/graphql';
};

});


parcelRegister("a6bRt", function(module, exports) {

$parcel$export(module.exports, "RetryLink", () => $75a3aa60951dc58d$export$943d544ad120494a);

var $dnskZ = parcelRequire("dnskZ");

var $7oe8F = parcelRequire("7oe8F");
function $75a3aa60951dc58d$var$buildDelayFunction(delayOptions) {
    var _a = delayOptions || {}, _b = _a.initial, initial = _b === void 0 ? 300 : _b, _c = _a.jitter, jitter = _c === void 0 ? true : _c, _d = _a.max, max = _d === void 0 ? Infinity : _d;
    var baseDelay = jitter ? initial : initial / 2;
    return function delayFunction(count) {
        var delay = Math.min(max, baseDelay * Math.pow(2, count));
        if (jitter) delay = Math.random() * delay;
        return delay;
    };
}
function $75a3aa60951dc58d$var$buildRetryFunction(retryOptions) {
    var _a = retryOptions || {}, retryIf = _a.retryIf, _b = _a.max, max = _b === void 0 ? 5 : _b;
    return function retryFunction(count, operation, error) {
        if (count >= max) return false;
        return retryIf ? retryIf(error, operation) : !!error;
    };
}
var $75a3aa60951dc58d$var$RetryableOperation = function() {
    function RetryableOperation(operation, nextLink, delayFor, retryIf) {
        var _this = this;
        this.operation = operation;
        this.nextLink = nextLink;
        this.delayFor = delayFor;
        this.retryIf = retryIf;
        this.retryCount = 0;
        this.values = [];
        this.complete = false;
        this.canceled = false;
        this.observers = [];
        this.currentSubscription = null;
        this.onNext = function(value) {
            _this.values.push(value);
            for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                var observer = _a[_i];
                if (!observer) continue;
                observer.next(value);
            }
        };
        this.onComplete = function() {
            _this.complete = true;
            for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                var observer = _a[_i];
                if (!observer) continue;
                observer.complete();
            }
        };
        this.onError = function(error) {
            return (0, $dnskZ.__awaiter)(_this, void 0, void 0, function() {
                var shouldRetry, _i, _a, observer;
                return (0, $dnskZ.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            this.retryCount += 1;
                            return [
                                4,
                                this.retryIf(this.retryCount, this.operation, error)
                            ];
                        case 1:
                            shouldRetry = _b.sent();
                            if (shouldRetry) {
                                this.scheduleRetry(this.delayFor(this.retryCount, this.operation, error));
                                return [
                                    2
                                ];
                            }
                            this.error = error;
                            for(_i = 0, _a = this.observers; _i < _a.length; _i++){
                                observer = _a[_i];
                                if (!observer) continue;
                                observer.error(error);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
        };
    }
    RetryableOperation.prototype.subscribe = function(observer) {
        if (this.canceled) throw new Error("Subscribing to a retryable link that was canceled is not supported");
        this.observers.push(observer);
        for(var _i = 0, _a = this.values; _i < _a.length; _i++){
            var value = _a[_i];
            observer.next(value);
        }
        if (this.complete) observer.complete();
        else if (this.error) observer.error(this.error);
    };
    RetryableOperation.prototype.unsubscribe = function(observer) {
        var index = this.observers.indexOf(observer);
        if (index < 0) throw new Error("RetryLink BUG! Attempting to unsubscribe unknown observer!");
        this.observers[index] = null;
        if (this.observers.every(function(o) {
            return o === null;
        })) this.cancel();
    };
    RetryableOperation.prototype.start = function() {
        if (this.currentSubscription) return;
        this.try();
    };
    RetryableOperation.prototype.cancel = function() {
        if (this.currentSubscription) this.currentSubscription.unsubscribe();
        clearTimeout(this.timerId);
        this.timerId = null;
        this.currentSubscription = null;
        this.canceled = true;
    };
    RetryableOperation.prototype.try = function() {
        this.currentSubscription = this.nextLink(this.operation).subscribe({
            next: this.onNext,
            error: this.onError,
            complete: this.onComplete
        });
    };
    RetryableOperation.prototype.scheduleRetry = function(delay) {
        var _this = this;
        if (this.timerId) throw new Error("RetryLink BUG! Encountered overlapping retries");
        this.timerId = setTimeout(function() {
            _this.timerId = null;
            _this.try();
        }, delay);
    };
    return RetryableOperation;
}();
var $75a3aa60951dc58d$export$943d544ad120494a = function(_super) {
    (0, $dnskZ.__extends)(RetryLink, _super);
    function RetryLink(options) {
        var _this = _super.call(this) || this;
        var _a = options || {}, attempts = _a.attempts, delay = _a.delay;
        _this.delayFor = typeof delay === 'function' ? delay : $75a3aa60951dc58d$var$buildDelayFunction(delay);
        _this.retryIf = typeof attempts === 'function' ? attempts : $75a3aa60951dc58d$var$buildRetryFunction(attempts);
        return _this;
    }
    RetryLink.prototype.request = function(operation, nextLink) {
        var retryable = new $75a3aa60951dc58d$var$RetryableOperation(operation, nextLink, this.delayFor, this.retryIf);
        retryable.start();
        return new (0, $7oe8F.Observable)(function(observer) {
            retryable.subscribe(observer);
            return function() {
                retryable.unsubscribe(observer);
            };
        });
    };
    return RetryLink;
}((0, $7oe8F.ApolloLink));

});

parcelRegister("g4okI", function(module, exports) {

$parcel$export(module.exports, "fragmentCacheRedirect", () => $bb2fe5188907aceb$export$5133c88128301697);
$parcel$export(module.exports, "fragmentLinkState", () => $bb2fe5188907aceb$export$3f9ecfb4d42ab23d);

var $jFDfc = parcelRequire("jFDfc");

var $fT6ea = parcelRequire("fT6ea");

var $ifBQy = parcelRequire("ifBQy");
function $bb2fe5188907aceb$export$5133c88128301697(dataIdFromObject) {
    if (dataIdFromObject === void 0) dataIdFromObject = (0, $ifBQy.defaultDataIdFromObject);
    return {
        getFragment: function(_, _a) {
            var id = _a.id, __typename = _a.__typename;
            return (0, $jFDfc.toIdValue)(dataIdFromObject({
                __typename: __typename,
                id: id
            }));
        }
    };
}
function $bb2fe5188907aceb$export$3f9ecfb4d42ab23d(apolloCache) {
    return (0, $fT6ea.withClientState)({
        cache: apolloCache,
        resolvers: {
            Query: {
                getFragment: function(_, _a, _b) {
                    var __typename = _a.__typename, id = _a.id;
                    var cache = _b.cache;
                    var fragmentId = cache.config.dataIdFromObject({
                        __typename: __typename,
                        id: id
                    });
                    return cache.data.data[fragmentId];
                }
            }
        }
    });
}

});
parcelRegister("fT6ea", function(module, exports) {

$parcel$export(module.exports, "withClientState", () => $b910d2b7906fe912$export$a13f755900e15d9e);

var $7oe8F = parcelRequire("7oe8F");

var $jFDfc = parcelRequire("jFDfc");

var $aW6ai = parcelRequire("aW6ai");

var $fhjWZ = parcelRequire("fhjWZ");
var $b910d2b7906fe912$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $b910d2b7906fe912$var$graphql = $aW6ai.graphql;
var $b910d2b7906fe912$var$capitalizeFirstLetter = function(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
};
var $b910d2b7906fe912$export$a13f755900e15d9e = function(clientStateConfig) {
    if (clientStateConfig === void 0) clientStateConfig = {
        resolvers: {},
        defaults: {}
    };
    var defaults = clientStateConfig.defaults, cache = clientStateConfig.cache, typeDefs = clientStateConfig.typeDefs, fragmentMatcher = clientStateConfig.fragmentMatcher;
    if (cache && defaults) cache.writeData({
        data: defaults
    });
    return new (function(_super) {
        $b910d2b7906fe912$var$__extends(StateLink, _super);
        function StateLink() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        StateLink.prototype.writeDefaults = function() {
            if (cache && defaults) cache.writeData({
                data: defaults
            });
        };
        StateLink.prototype.request = function(operation, forward) {
            if (forward === void 0) forward = function() {
                return (0, $7oe8F.Observable).of({
                    data: {}
                });
            };
            if (typeDefs) {
                var directives_1 = 'directive @client on FIELD';
                var definition_1 = (0, $fhjWZ.normalizeTypeDefs)(typeDefs);
                operation.setContext(function(_a) {
                    var _b = _a.schemas, schemas = _b === void 0 ? [] : _b;
                    return {
                        schemas: schemas.concat([
                            {
                                definition: definition_1,
                                directives: directives_1
                            }
                        ])
                    };
                });
            }
            var isClient = (0, $jFDfc.hasDirectives)([
                'client'
            ], operation.query);
            if (!isClient) return forward(operation);
            var resolvers = typeof clientStateConfig.resolvers === 'function' ? clientStateConfig.resolvers() : clientStateConfig.resolvers;
            var server = (0, $fhjWZ.removeClientSetsFromDocument)(operation.query);
            var query = operation.query;
            var type = $b910d2b7906fe912$var$capitalizeFirstLetter(((0, $jFDfc.getMainDefinition)(query) || {}).operation) || 'Query';
            var resolver = function(fieldName, rootValue, args, context, info) {
                if (rootValue === void 0) rootValue = {};
                var resultKey = info.resultKey;
                var aliasedNode = rootValue[resultKey];
                var preAliasingNode = rootValue[fieldName];
                var aliasNeeded = resultKey !== fieldName;
                if (aliasedNode !== undefined || preAliasingNode !== undefined) return aliasedNode || preAliasingNode;
                var resolverMap = resolvers[rootValue.__typename || type];
                if (resolverMap) {
                    var resolve = resolverMap[fieldName];
                    if (resolve) return resolve(rootValue, args, context, info);
                }
                return (aliasNeeded ? aliasedNode : preAliasingNode) || (defaults || {})[fieldName];
            };
            if (server) operation.query = server;
            var obs = server && forward ? forward(operation) : (0, $7oe8F.Observable).of({
                data: {}
            });
            return new (0, $7oe8F.Observable)(function(observer) {
                var complete = false;
                var handlingNext = false;
                obs.subscribe({
                    next: function(_a) {
                        var data = _a.data, errors = _a.errors;
                        var observerErrorHandler = observer.error.bind(observer);
                        var context = operation.getContext();
                        handlingNext = true;
                        $b910d2b7906fe912$var$graphql(resolver, query, data, context, operation.variables, {
                            fragmentMatcher: fragmentMatcher
                        }).then(function(nextData) {
                            observer.next({
                                data: nextData,
                                errors: errors
                            });
                            if (complete) observer.complete();
                            handlingNext = false;
                        }).catch(observerErrorHandler);
                    },
                    error: observer.error.bind(observer),
                    complete: function() {
                        if (!handlingNext) observer.complete();
                        complete = true;
                    }
                });
            });
        };
        return StateLink;
    }((0, $7oe8F.ApolloLink)))();
};

});
parcelRegister("aW6ai", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dnskZ = parcelRequire("dnskZ");

var $jFDfc = parcelRequire("jFDfc");

var $mY9dA = parcelRequire("mY9dA");
function $7f641a6fdcb80040$var$graphql(resolver, document, rootValue, contextValue, variableValues, execOptions) {
    if (execOptions === void 0) execOptions = {};
    var mainDefinition = $jFDfc.getMainDefinition(document);
    var fragments = $jFDfc.getFragmentDefinitions(document);
    var fragmentMap = $jFDfc.createFragmentMap(fragments);
    var resultMapper = execOptions.resultMapper;
    var fragmentMatcher = execOptions.fragmentMatcher || function() {
        return true;
    };
    var execContext = {
        fragmentMap: fragmentMap,
        contextValue: contextValue,
        variableValues: variableValues,
        resultMapper: resultMapper,
        resolver: resolver,
        fragmentMatcher: fragmentMatcher
    };
    return $7f641a6fdcb80040$var$executeSelectionSet(mainDefinition.selectionSet, rootValue, execContext);
}
module.exports.graphql = $7f641a6fdcb80040$var$graphql;
function $7f641a6fdcb80040$var$executeSelectionSet(selectionSet, rootValue, execContext) {
    return $dnskZ.__awaiter(this, void 0, void 0, function() {
        var fragmentMap, contextValue, variables, result, execute;
        var _this = this;
        return $dnskZ.__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
                    result = {};
                    execute = function(selection) {
                        return $dnskZ.__awaiter(_this, void 0, void 0, function() {
                            var fieldResult, resultFieldKey, fragment, typeCondition, fragmentResult;
                            return $dnskZ.__generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        if (!$jFDfc.shouldInclude(selection, variables)) return [
                                            2
                                        ];
                                        if (!$jFDfc.isField(selection)) return [
                                            3,
                                            2
                                        ];
                                        return [
                                            4,
                                            $7f641a6fdcb80040$var$executeField(selection, rootValue, execContext)
                                        ];
                                    case 1:
                                        fieldResult = _a.sent();
                                        resultFieldKey = $jFDfc.resultKeyNameFromField(selection);
                                        if (fieldResult !== undefined) {
                                            if (result[resultFieldKey] === undefined) result[resultFieldKey] = fieldResult;
                                            else $mY9dA.merge(result[resultFieldKey], fieldResult);
                                        }
                                        return [
                                            2
                                        ];
                                    case 2:
                                        if ($jFDfc.isInlineFragment(selection)) fragment = selection;
                                        else {
                                            fragment = fragmentMap[selection.name.value];
                                            if (!fragment) throw new Error("No fragment named " + selection.name.value);
                                        }
                                        typeCondition = fragment.typeCondition.name.value;
                                        if (!execContext.fragmentMatcher(rootValue, typeCondition, contextValue)) return [
                                            3,
                                            4
                                        ];
                                        return [
                                            4,
                                            $7f641a6fdcb80040$var$executeSelectionSet(fragment.selectionSet, rootValue, execContext)
                                        ];
                                    case 3:
                                        fragmentResult = _a.sent();
                                        $mY9dA.merge(result, fragmentResult);
                                        _a.label = 4;
                                    case 4:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                    };
                    return [
                        4,
                        Promise.all(selectionSet.selections.map(execute))
                    ];
                case 1:
                    _a.sent();
                    if (execContext.resultMapper) return [
                        2,
                        execContext.resultMapper(result, rootValue)
                    ];
                    return [
                        2,
                        result
                    ];
            }
        });
    });
}
function $7f641a6fdcb80040$var$executeField(field, rootValue, execContext) {
    return $dnskZ.__awaiter(this, void 0, void 0, function() {
        var variables, contextValue, resolver, fieldName, args, info, result;
        return $dnskZ.__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    variables = execContext.variableValues, contextValue = execContext.contextValue, resolver = execContext.resolver;
                    fieldName = field.name.value;
                    args = $jFDfc.argumentsObjectFromField(field, variables);
                    info = {
                        isLeaf: !field.selectionSet,
                        resultKey: $jFDfc.resultKeyNameFromField(field),
                        directives: $jFDfc.getDirectiveInfoFromField(field, variables),
                        field: field
                    };
                    return [
                        4,
                        resolver(fieldName, rootValue, args, contextValue, info)
                    ];
                case 1:
                    result = _a.sent();
                    if (!field.selectionSet) return [
                        2,
                        result
                    ];
                    if (result == null) return [
                        2,
                        result
                    ];
                    if (Array.isArray(result)) return [
                        2,
                        $7f641a6fdcb80040$var$executeSubSelectedArray(field, result, execContext)
                    ];
                    return [
                        2,
                        $7f641a6fdcb80040$var$executeSelectionSet(field.selectionSet, result, execContext)
                    ];
            }
        });
    });
}
function $7f641a6fdcb80040$var$executeSubSelectedArray(field, result, execContext) {
    return Promise.all(result.map(function(item) {
        if (item === null) return null;
        if (Array.isArray(item)) return $7f641a6fdcb80040$var$executeSubSelectedArray(field, item, execContext);
        return $7f641a6fdcb80040$var$executeSelectionSet(field.selectionSet, item, execContext);
    }));
}

});
parcelRegister("mY9dA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $jFDfc = parcelRequire("jFDfc");
function $0450b643c808decc$var$graphql(resolver, document, rootValue, contextValue, variableValues, execOptions) {
    if (variableValues === void 0) variableValues = {};
    if (execOptions === void 0) execOptions = {};
    var mainDefinition = $jFDfc.getMainDefinition(document);
    var fragments = $jFDfc.getFragmentDefinitions(document);
    var fragmentMap = $jFDfc.createFragmentMap(fragments);
    var resultMapper = execOptions.resultMapper;
    var fragmentMatcher = execOptions.fragmentMatcher || function() {
        return true;
    };
    var execContext = {
        fragmentMap: fragmentMap,
        contextValue: contextValue,
        variableValues: variableValues,
        resultMapper: resultMapper,
        resolver: resolver,
        fragmentMatcher: fragmentMatcher
    };
    return $0450b643c808decc$var$executeSelectionSet(mainDefinition.selectionSet, rootValue, execContext);
}
module.exports.graphql = $0450b643c808decc$var$graphql;
function $0450b643c808decc$var$executeSelectionSet(selectionSet, rootValue, execContext) {
    var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
    var result = {};
    selectionSet.selections.forEach(function(selection) {
        if (variables && !$jFDfc.shouldInclude(selection, variables)) return;
        if ($jFDfc.isField(selection)) {
            var fieldResult = $0450b643c808decc$var$executeField(selection, rootValue, execContext);
            var resultFieldKey = $jFDfc.resultKeyNameFromField(selection);
            if (fieldResult !== undefined) {
                if (result[resultFieldKey] === undefined) result[resultFieldKey] = fieldResult;
                else $0450b643c808decc$var$merge(result[resultFieldKey], fieldResult);
            }
        } else {
            var fragment = void 0;
            if ($jFDfc.isInlineFragment(selection)) fragment = selection;
            else {
                fragment = fragmentMap[selection.name.value];
                if (!fragment) throw new Error("No fragment named " + selection.name.value);
            }
            var typeCondition = fragment.typeCondition.name.value;
            if (execContext.fragmentMatcher(rootValue, typeCondition, contextValue)) {
                var fragmentResult = $0450b643c808decc$var$executeSelectionSet(fragment.selectionSet, rootValue, execContext);
                $0450b643c808decc$var$merge(result, fragmentResult);
            }
        }
    });
    if (execContext.resultMapper) return execContext.resultMapper(result, rootValue);
    return result;
}
function $0450b643c808decc$var$executeField(field, rootValue, execContext) {
    var variables = execContext.variableValues, contextValue = execContext.contextValue, resolver = execContext.resolver;
    var fieldName = field.name.value;
    var args = $jFDfc.argumentsObjectFromField(field, variables);
    var info = {
        isLeaf: !field.selectionSet,
        resultKey: $jFDfc.resultKeyNameFromField(field),
        directives: $jFDfc.getDirectiveInfoFromField(field, variables),
        field: field
    };
    var result = resolver(fieldName, rootValue, args, contextValue, info);
    if (!field.selectionSet) return result;
    if (result == null) return result;
    if (Array.isArray(result)) return $0450b643c808decc$var$executeSubSelectedArray(field, result, execContext);
    return $0450b643c808decc$var$executeSelectionSet(field.selectionSet, result, execContext);
}
function $0450b643c808decc$var$executeSubSelectedArray(field, result, execContext) {
    return result.map(function(item) {
        if (item === null) return null;
        if (Array.isArray(item)) return $0450b643c808decc$var$executeSubSelectedArray(field, item, execContext);
        return $0450b643c808decc$var$executeSelectionSet(field.selectionSet, item, execContext);
    });
}
var $0450b643c808decc$var$hasOwn = Object.prototype.hasOwnProperty;
function $0450b643c808decc$var$merge(dest, src) {
    if (src !== null && typeof src === 'object') Object.keys(src).forEach(function(key) {
        var srcVal = src[key];
        if (!$0450b643c808decc$var$hasOwn.call(dest, key)) dest[key] = srcVal;
        else $0450b643c808decc$var$merge(dest[key], srcVal);
    });
}
module.exports.merge = $0450b643c808decc$var$merge;

});


parcelRegister("fhjWZ", function(module, exports) {

$parcel$export(module.exports, "removeClientSetsFromDocument", () => $b1f7eb4fa92dcb3d$export$8eae69e876ee321e);
$parcel$export(module.exports, "normalizeTypeDefs", () => $b1f7eb4fa92dcb3d$export$467f9c465e4ace4e);

var $6NFTG = parcelRequire("6NFTG");

var $jFDfc = parcelRequire("jFDfc");
var $b1f7eb4fa92dcb3d$var$connectionRemoveConfig = {
    test: function(directive) {
        return directive.name.value === 'client';
    },
    remove: true
};
var $b1f7eb4fa92dcb3d$var$removed = new Map();
function $b1f7eb4fa92dcb3d$export$8eae69e876ee321e(query) {
    var cached = $b1f7eb4fa92dcb3d$var$removed.get(query);
    if (cached) return cached;
    (0, $jFDfc.checkDocument)(query);
    var docClone = (0, $jFDfc.removeDirectivesFromDocument)([
        $b1f7eb4fa92dcb3d$var$connectionRemoveConfig
    ], query);
    $b1f7eb4fa92dcb3d$var$removed.set(query, docClone);
    return docClone;
}
function $b1f7eb4fa92dcb3d$export$467f9c465e4ace4e(typeDefs) {
    var defs = Array.isArray(typeDefs) ? typeDefs : [
        typeDefs
    ];
    return defs.map(function(typeDef) {
        return typeof typeDef === 'string' ? typeDef : (0, $6NFTG.print)(typeDef);
    }).map(function(str) {
        return str.trim();
    }).join('\n');
}

});



parcelRegister("1fQNI", function(module, exports) {

$parcel$export(module.exports, "UFOLoggerLink", () => $a01de03b371744d9$export$fb326ed954631f3f);

var $7oe8F = parcelRequire("7oe8F");

var $2QO3b = parcelRequire("2QO3b");
const $a01de03b371744d9$export$fb326ed954631f3f = new (0, $7oe8F.ApolloLink)((operation, forward)=>{
    const networkStart = performance.now();
    return forward(operation).map((response)=>{
        const networkComplete = performance.now();
        const operationName = operation.operationName ?? 'unnamed';
        (0, $2QO3b.addSpanToAll)('graphql', operationName, [
            {
                name: 'network'
            }
        ], networkStart, networkComplete);
        return response;
    });
});

});

parcelRegister("dk1mg", function(module, exports) {
module.exports = JSON.parse("{\"__schema\":{\"types\":[{\"kind\":\"UNION\",\"name\":\"AllActivityFeedItemUnion\",\"possibleTypes\":[{\"name\":\"HistoryItem\"},{\"name\":\"CommentItem\"},{\"name\":\"WorklogItem\"},{\"name\":\"IncidentItem\"},{\"name\":\"ApprovalItem\"},{\"name\":\"HiddenCommentItem\"}]},{\"kind\":\"UNION\",\"name\":\"ApprovalActivityValueUnion\",\"possibleTypes\":[{\"name\":\"ApprovalCreated\"},{\"name\":\"ApproverDecision\"},{\"name\":\"ApprovalCompleted\"}]},{\"kind\":\"UNION\",\"name\":\"ConfluencePageUnion\",\"possibleTypes\":[{\"name\":\"ConfluencePage\"},{\"name\":\"FailedRemoteLink\"}]},{\"kind\":\"UNION\",\"name\":\"GQLCategorizedField\",\"possibleTypes\":[{\"name\":\"GQLSortableField\"},{\"name\":\"GQLSearchableField\"}]},{\"kind\":\"UNION\",\"name\":\"GadgetParameters\",\"possibleTypes\":[{\"name\":\"VotedGadgetParameters\"},{\"name\":\"AssignedToMeGadgetParameters\"},{\"name\":\"WatchedGadgetParameters\"},{\"name\":\"InProgressGadgetParameters\"},{\"name\":\"FilterResultsGadgetParameters\"},{\"name\":\"TwoDimensionalStatisticsParameters\"},{\"name\":\"PieChartParameters\"},{\"name\":\"IssueStatisticsParameters\"},{\"name\":\"WorkloadPieChartParameters\"},{\"name\":\"ActivityStreamGadgetParameters\"},{\"name\":\"CreatedVsResolvedGadgetParameters\"},{\"name\":\"SprintGadgetParameters\"},{\"name\":\"ProjectsGadgetParameters\"},{\"name\":\"ConnectGadgetParameters\"},{\"name\":\"NotConfiguredGadgetParameters\"},{\"name\":\"UnsupportedGadgetParameters\"}]},{\"kind\":\"UNION\",\"name\":\"GroupByFieldUnion\",\"possibleTypes\":[{\"name\":\"PriorityField\"},{\"name\":\"StatusField\"},{\"name\":\"UserField\"},{\"name\":\"LabelsField\"},{\"name\":\"SelectCustomField\"},{\"name\":\"JWMCategoryCustomField\"},{\"name\":\"IssueTypeField\"},{\"name\":\"StoryPointsField\"},{\"name\":\"SprintCustomField\"},{\"name\":\"FloatCustomField\"}]},{\"kind\":\"UNION\",\"name\":\"GroupSectionItem\",\"possibleTypes\":[{\"name\":\"FieldSectionItem\"},{\"name\":\"EcosystemSectionItem\"},{\"name\":\"ForgeSectionItem\"},{\"name\":\"PanelSectionItem\"}]},{\"kind\":\"UNION\",\"name\":\"HistoryValue\",\"possibleTypes\":[{\"name\":\"AssigneeFieldValue\"},{\"name\":\"PriorityFieldValue\"},{\"name\":\"StatusFieldValue\"},{\"name\":\"WorkLogFieldValue\"},{\"name\":\"RespondersFieldValue\"},{\"name\":\"GenericFieldValue\"}]},{\"kind\":\"UNION\",\"name\":\"IncidentActivityValueUnion\",\"possibleTypes\":[{\"name\":\"ResponderAlertAssignedValue\"},{\"name\":\"AlertValue\"},{\"name\":\"ResponderAlertPriorityChangedValue\"},{\"name\":\"IccSessionValue\"},{\"name\":\"IccSessionInvitationValue\"},{\"name\":\"StakeholderUpdatedValue\"},{\"name\":\"IncidentStakeholderActionValue\"}]},{\"kind\":\"UNION\",\"name\":\"IssueFieldUnion\",\"possibleTypes\":[{\"name\":\"PriorityField\"},{\"name\":\"StatusField\"},{\"name\":\"IssueTypeField\"},{\"name\":\"ProjectComponentsField\"},{\"name\":\"LabelsField\"},{\"name\":\"WatchersField\"},{\"name\":\"UserField\"},{\"name\":\"TextField\"},{\"name\":\"VersionsField\"},{\"name\":\"DateField\"},{\"name\":\"DateTimeField\"},{\"name\":\"IssueKeyField\"},{\"name\":\"ProjectField\"},{\"name\":\"ResolutionField\"},{\"name\":\"TimeTrackingField\"},{\"name\":\"TimeOriginalEstimateField\"},{\"name\":\"TimeEstimateField\"},{\"name\":\"TimeSpentField\"},{\"name\":\"StoryPointsField\"},{\"name\":\"EpicLinkField\"},{\"name\":\"EpicNameField\"},{\"name\":\"ColorField\"},{\"name\":\"EpicColorField\"},{\"name\":\"SprintCustomField\"},{\"name\":\"SelectCustomField\"},{\"name\":\"FlaggedCustomField\"},{\"name\":\"UserPickerCustomField\"},{\"name\":\"TextAreaCustomField\"},{\"name\":\"FloatCustomField\"},{\"name\":\"DatePickerCustomField\"},{\"name\":\"TextFieldCustomField\"},{\"name\":\"MultiSelectCustomField\"},{\"name\":\"LabelsCustomField\"},{\"name\":\"MultiUserPickerCustomField\"},{\"name\":\"PeopleCustomField\"},{\"name\":\"UrlCustomField\"},{\"name\":\"VersionCustomField\"},{\"name\":\"GroupPickerCustomField\"},{\"name\":\"MultiVersionCustomField\"},{\"name\":\"MultiGroupPickerCustomField\"},{\"name\":\"CheckBoxesCustomField\"},{\"name\":\"RadioButtonsCustomField\"},{\"name\":\"DateTimeCustomField\"},{\"name\":\"SeverityField\"},{\"name\":\"AffectedServicesField\"},{\"name\":\"TechLeadField\"},{\"name\":\"AttachmentsField\"},{\"name\":\"GlancesField\"},{\"name\":\"SecurityLevelField\"},{\"name\":\"IssueLinksField\"},{\"name\":\"IssuesInEpicField\"},{\"name\":\"SubtasksField\"},{\"name\":\"ChildIssuesField\"},{\"name\":\"CascadingSelectCustomField\"},{\"name\":\"CmdbField\"},{\"name\":\"SLACustomField\"},{\"name\":\"ProjectCustomField\"},{\"name\":\"EpicStatusField\"},{\"name\":\"ParentField\"},{\"name\":\"JWMCategoryCustomField\"},{\"name\":\"CommentSummaryField\"}]},{\"kind\":\"UNION\",\"name\":\"IssueSections\",\"possibleTypes\":[{\"name\":\"PrimarySecondaryContextSections\"},{\"name\":\"JsdSections\"}]},{\"kind\":\"UNION\",\"name\":\"JiraActiveBackgroundDetailsResult\",\"possibleTypes\":[{\"name\":\"JiraColorBackground\"},{\"name\":\"JiraGradientBackground\"},{\"name\":\"JiraMediaBackground\"},{\"name\":\"JiraAttachmentBackground\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraAtlassianIntelligenceAction\",\"possibleTypes\":[{\"name\":\"JiraAccessAtlassianIntelligenceFeature\"},{\"name\":\"JiraEnableAtlassianIntelligenceDeepLink\"},{\"name\":\"JiraContactOrgAdminToEnableAtlassianIntelligence\"}]},{\"kind\":\"UNION\",\"name\":\"JiraBackgroundUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraBackgroundUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraBoardResult\",\"possibleTypes\":[{\"name\":\"JiraBoard\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraChildIssues\",\"possibleTypes\":[{\"name\":\"JiraChildIssuesWithinLimit\"},{\"name\":\"JiraChildIssuesExceedingLimit\"}]},{\"kind\":\"UNION\",\"name\":\"JiraCommentVisibility\",\"possibleTypes\":[{\"name\":\"JiraRoleVisibility\"},{\"name\":\"JiraGroupVisibility\"}]},{\"kind\":\"UNION\",\"name\":\"JiraConfluencePageContent\",\"possibleTypes\":[{\"name\":\"JiraConfluencePageContentDetails\"},{\"name\":\"JiraConfluencePageContentError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraContainerNavigationResult\",\"possibleTypes\":[{\"name\":\"JiraContainerNavigation\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraDefaultUnsplashImagesPageResult\",\"possibleTypes\":[{\"name\":\"JiraDefaultUnsplashImagesPage\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFavourite\",\"possibleTypes\":[{\"name\":\"JiraProject\"},{\"name\":\"JiraSystemFilter\"},{\"name\":\"JiraCustomFilter\"},{\"name\":\"JiraDashboard\"},{\"name\":\"JiraPlan\"},{\"name\":\"JiraBoard\"},{\"name\":\"JiraServiceManagementQueue\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFieldFormatConfig\",\"possibleTypes\":[{\"name\":\"JiraNumberFieldFormatConfig\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFieldSetViewResult\",\"possibleTypes\":[{\"name\":\"JiraFieldSetView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFormattingExpression\",\"possibleTypes\":[{\"name\":\"JiraFormattingSingleValueOperand\"},{\"name\":\"JiraFormattingTwoValueOperand\"},{\"name\":\"JiraFormattingMultipleValueOperand\"},{\"name\":\"JiraFormattingNoValueOperand\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGlobalPermissionGrantsResult\",\"possibleTypes\":[{\"name\":\"JiraGlobalPermissionGrantsList\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGrantTypeValue\",\"possibleTypes\":[{\"name\":\"JiraDefaultGrantTypeValue\"},{\"name\":\"JiraUserGrantTypeValue\"},{\"name\":\"JiraProjectRoleGrantTypeValue\"},{\"name\":\"JiraGroupGrantTypeValue\"},{\"name\":\"JiraIssueFieldGrantTypeValue\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGroupLayoutItem\",\"possibleTypes\":[{\"name\":\"JiraFieldLayoutItem\"},{\"name\":\"JiraEcosystemLayoutItem\"},{\"name\":\"JiraForgeLayoutItem\"},{\"name\":\"JiraPanelLayoutItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateAdditionalServicesResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateAdditionalServices\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateFieldsResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateFields\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateLayoutResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateLayout\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueExportEvent\",\"possibleTypes\":[{\"name\":\"JiraIssueExportTaskSubmitted\"},{\"name\":\"JiraIssueExportTaskProgress\"},{\"name\":\"JiraIssueExportTaskCompleted\"},{\"name\":\"JiraIssueExportTaskTerminated\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"},{\"name\":\"JiraIssueItemPanelItem\"},{\"name\":\"JiraIssueItemGroupContainer\"},{\"name\":\"JiraIssueItemTabContainer\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemContainersResult\",\"possibleTypes\":[{\"name\":\"JiraIssueItemContainers\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemGroupContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"},{\"name\":\"JiraIssueItemPanelItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemTabContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayout\",\"possibleTypes\":[{\"name\":\"JiraDefaultIssueLayout\"},{\"name\":\"JiraIssueCreateLayout\"},{\"name\":\"JiraLegacyIssueLayout\"},{\"name\":\"JsdDefaultIssueLayout\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutConfigurationResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutFieldConfigurationHiddenIn\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutFieldConfigurationHiddenInGlobal\"},{\"name\":\"JiraIssueLayoutFieldConfigurationHiddenInLayoutOwner\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutFieldPanelItemConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutFieldItemConfiguration\"},{\"name\":\"JiraIssueLayoutPanelItemConfiguration\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutItemConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutContainerConfiguration\"},{\"name\":\"JiraIssueLayoutFieldItemConfiguration\"},{\"name\":\"JiraIssueLayoutGroupContainerConfiguration\"},{\"name\":\"JiraIssueLayoutTabContainerConfiguration\"},{\"name\":\"JiraIssueLayoutPanelItemConfiguration\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutOwner\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutIssueTypeOwner\"},{\"name\":\"JiraIssueLayoutRequestTypeOwner\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutOwners\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutOwnersResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueResult\",\"possibleTypes\":[{\"name\":\"JiraIssue\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchByFilterResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchByFilter\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchByJqlResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchByJql\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchError\",\"possibleTypes\":[{\"name\":\"JiraInvalidJqlError\"},{\"name\":\"JiraInvalidSyntaxError\"},{\"name\":\"JiraServerError\"},{\"name\":\"JiraCustomIssueSearchError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchViewResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJQLGenerationError\",\"possibleTypes\":[{\"name\":\"JiraInvalidJqlError\"},{\"name\":\"JiraInvalidSyntaxError\"},{\"name\":\"JiraServerError\"},{\"name\":\"JiraUIExposedError\"},{\"name\":\"JiraUsageLimitExceededError\"},{\"name\":\"JiraUnsupportedLanguageError\"},{\"name\":\"JiraGeneratedJqlInvalidError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJourneyItem\",\"possibleTypes\":[{\"name\":\"JiraJourneyWorkItem\"},{\"name\":\"JiraJourneyStatusDependency\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJourneyParentIssueValueType\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementRequestType\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJourneyTriggerConfiguration\",\"possibleTypes\":[{\"name\":\"JiraJourneyWorkdayIntegrationTriggerConfiguration\"},{\"name\":\"JiraJourneyParentIssueTriggerConfiguration\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlFieldConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraJqlFieldConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlHydratedQueryResult\",\"possibleTypes\":[{\"name\":\"JiraJqlHydratedQuery\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlQueryHydratedFieldResult\",\"possibleTypes\":[{\"name\":\"JiraJqlQueryHydratedField\"},{\"name\":\"JiraJqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlQueryHydratedValueResult\",\"possibleTypes\":[{\"name\":\"JiraJqlQueryHydratedValue\"},{\"name\":\"JiraJqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraMediaUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraMediaUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraNavigationItemResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementSavedView\"},{\"name\":\"JiraSoftwareBuiltInNavigationItem\"},{\"name\":\"JiraAppNavigationItem\"},{\"name\":\"JiraShortcutNavigationItem\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraOnSuggestedChildIssueResult\",\"possibleTypes\":[{\"name\":\"JiraSuggestedIssue\"},{\"name\":\"JiraSuggestedChildIssueStatus\"},{\"name\":\"JiraSuggestedChildIssueError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraOverviewPlanMigrationStateResult\",\"possibleTypes\":[{\"name\":\"JiraOverviewPlanMigrationState\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraPermissionSchemeViewResult\",\"possibleTypes\":[{\"name\":\"JiraPermissionSchemeView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectConfiguration\",\"possibleTypes\":[{\"name\":\"JiraProjectConfigurationResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectNavigationMetadata\",\"possibleTypes\":[{\"name\":\"JiraSoftwareProjectNavigationMetadata\"},{\"name\":\"JiraServiceManagementProjectNavigationMetadata\"},{\"name\":\"JiraWorkManagementProjectNavigationMetadata\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectsUsingField\",\"possibleTypes\":[{\"name\":\"JiraProjectsUsingFieldResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraRemoteIssueLink\",\"possibleTypes\":[{\"name\":\"JiraIssueRemoteIssueLink\"},{\"name\":\"JiraConfluenceRemoteIssueLink\"},{\"name\":\"JiraWebRemoteIssueLink\"},{\"name\":\"JiraCustomRemoteIssueLink\"}]},{\"kind\":\"UNION\",\"name\":\"JiraSearchableEntity\",\"possibleTypes\":[{\"name\":\"JiraProject\"},{\"name\":\"JiraSystemFilter\"},{\"name\":\"JiraCustomFilter\"},{\"name\":\"JiraBoard\"},{\"name\":\"JiraDashboard\"},{\"name\":\"JiraIssue\"},{\"name\":\"JiraServiceManagementQueue\"},{\"name\":\"JiraPlan\"}]},{\"kind\":\"UNION\",\"name\":\"JiraSectionLayoutItem\",\"possibleTypes\":[{\"name\":\"JiraGroupLayout\"},{\"name\":\"JiraTabLayout\"},{\"name\":\"JiraFieldLayoutItem\"},{\"name\":\"JiraEcosystemLayoutItem\"},{\"name\":\"JiraForgeLayoutItem\"},{\"name\":\"JiraPanelLayoutItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementApproverPrincipal\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementUserApproverPrincipal\"},{\"name\":\"JiraServiceManagementGroupApproverPrincipal\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementEntitledEntity\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementEntitlementCustomer\"},{\"name\":\"JiraServiceManagementEntitlementOrganization\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementRequestTypePreviewField\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementTextPreviewField\"},{\"name\":\"JiraServiceManagementTextAreaPreviewField\"},{\"name\":\"JiraServiceManagementDueDatePreviewField\"},{\"name\":\"JiraServiceManagementDatePreviewField\"},{\"name\":\"JiraServiceManagementDateTimePreviewField\"},{\"name\":\"JiraServiceManagementAttachmentPreviewField\"},{\"name\":\"JiraServiceManagementSelectPreviewField\"},{\"name\":\"JiraServiceManagementMultiSelectPreviewField\"},{\"name\":\"JiraServiceManagementMultiUserPickerPreviewField\"},{\"name\":\"JiraServiceManagementMultiServicePickerPreviewField\"},{\"name\":\"JiraServiceManagementMultiCheckboxesPreviewField\"},{\"name\":\"JiraServiceManagementPeoplePreviewField\"},{\"name\":\"JiraServiceManagementUnknownPreviewField\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementResponder\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementUserResponder\"},{\"name\":\"JiraServiceManagementTeamResponder\"}]},{\"kind\":\"UNION\",\"name\":\"JiraShareableEntityEditGrant\",\"possibleTypes\":[{\"name\":\"JiraShareableEntityGroupGrant\"},{\"name\":\"JiraShareableEntityProjectRoleGrant\"},{\"name\":\"JiraShareableEntityUserGrant\"},{\"name\":\"JiraShareableEntityProjectGrant\"},{\"name\":\"JiraShareableEntityUnknownProjectGrant\"}]},{\"kind\":\"UNION\",\"name\":\"JiraShareableEntityShareGrant\",\"possibleTypes\":[{\"name\":\"JiraShareableEntityGroupGrant\"},{\"name\":\"JiraShareableEntityProjectRoleGrant\"},{\"name\":\"JiraShareableEntityProjectGrant\"},{\"name\":\"JiraShareableEntityAnonymousAccessGrant\"},{\"name\":\"JiraShareableEntityAnyLoggedInUserGrant\"},{\"name\":\"JiraShareableEntityUnknownProjectGrant\"},{\"name\":\"JiraShareableEntityUserGrant\"}]},{\"kind\":\"UNION\",\"name\":\"JiraSpreadsheetGroupFieldValue\",\"possibleTypes\":[{\"name\":\"AtlassianAccountUser\"},{\"name\":\"JiraOption\"},{\"name\":\"JiraStatus\"},{\"name\":\"JiraPriority\"},{\"name\":\"JiraStoryPoint\"},{\"name\":\"JiraGoal\"}]},{\"kind\":\"UNION\",\"name\":\"JiraUnsplashImageSearchPageResult\",\"possibleTypes\":[{\"name\":\"JiraUnsplashImageSearchPage\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraVersionConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraVersionConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraVersionResult\",\"possibleTypes\":[{\"name\":\"JiraVersion\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementActiveBackgroundDetailsResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementColorBackground\"},{\"name\":\"JiraWorkManagementGradientBackground\"},{\"name\":\"JiraWorkManagementMediaBackground\"},{\"name\":\"JiraWorkManagementAttachmentBackground\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementBackgroundUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementBackgroundUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementCategoryOptionConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementCategoryOptionConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementFieldConfigurationConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementFieldConfigurationConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementFilterConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementFilterConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementGiraOverviewResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementGiraOverview\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementSavedViewResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementSavedView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementViewItemConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementViewItemConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlFieldConnectionResult\",\"possibleTypes\":[{\"name\":\"JqlFieldConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlHydratedQueryResult\",\"possibleTypes\":[{\"name\":\"JqlHydratedQuery\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlQueryHydratedFieldResult\",\"possibleTypes\":[{\"name\":\"JqlQueryHydratedField\"},{\"name\":\"JqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlQueryHydratedValueResult\",\"possibleTypes\":[{\"name\":\"JqlQueryHydratedValue\"},{\"name\":\"JqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"LayoutDefiner\",\"possibleTypes\":[{\"name\":\"FieldLayoutScreen\"},{\"name\":\"JiraRequestType\"}]},{\"kind\":\"UNION\",\"name\":\"MediaUploadTokenUnion\",\"possibleTypes\":[{\"name\":\"MediaUploadToken\"},{\"name\":\"FailedMediaUploadToken\"}]},{\"kind\":\"UNION\",\"name\":\"MergedFieldUnion\",\"possibleTypes\":[{\"name\":\"IssueTypeField\"},{\"name\":\"StatusField\"}]},{\"kind\":\"UNION\",\"name\":\"ProjectCategoryGadgetUnion\",\"possibleTypes\":[{\"name\":\"ProjectsGadgetItem\"},{\"name\":\"CategoriesGadgetItem\"}]},{\"kind\":\"UNION\",\"name\":\"RemoteIssueDetailsUnion\",\"possibleTypes\":[{\"name\":\"AssociatedIssueWrapper\"},{\"name\":\"FailedRemoteIssue\"}]},{\"kind\":\"UNION\",\"name\":\"SectionItem\",\"possibleTypes\":[{\"name\":\"GroupLayout\"},{\"name\":\"TabLayout\"},{\"name\":\"FieldSectionItem\"},{\"name\":\"EcosystemSectionItem\"},{\"name\":\"ForgeSectionItem\"},{\"name\":\"PanelSectionItem\"}]},{\"kind\":\"UNION\",\"name\":\"TimeSeriesChartAdditionalPropertiesUnion\",\"possibleTypes\":[{\"name\":\"CreatedVsResolvedProperties\"}]}]}}");

});

parcelRegister("gLqE0", function(module, exports) {

$parcel$export(module.exports, "getErrorAnalyticsContext", () => $b5b943618371ee76$export$bd030713895ed5e2);
$parcel$export(module.exports, "reportErrors", () => $b5b943618371ee76$export$a78ebe1911f50d41);

var $9Dhvc = parcelRequire("9Dhvc");

var $eezJL = parcelRequire("eezJL");

var $gYnSx = parcelRequire("gYnSx");
const $b5b943618371ee76$export$15d632fe38832073 = 'giraErrorAnalytics';
const $b5b943618371ee76$export$fc6a71db0f9a33f9 = (errorAnalytics, context = {})=>({
        ...context,
        [$b5b943618371ee76$export$15d632fe38832073]: errorAnalytics
    });
const $b5b943618371ee76$export$bd030713895ed5e2 = (context)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const errorAnalytics = (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(context, [
        $b5b943618371ee76$export$15d632fe38832073
    ], undefined);
    if (typeof errorAnalytics === 'object' && typeof errorAnalytics.id === 'string' && (errorAnalytics.packageName === undefined || typeof errorAnalytics.packageName === 'string') && (errorAnalytics.teamName === undefined || typeof errorAnalytics.teamName === 'string') && (errorAnalytics.attributes === undefined || typeof errorAnalytics.attributes === 'object') && (errorAnalytics.sendToPrivacyUnsafeSplunk === undefined || typeof errorAnalytics.sendToPrivacyUnsafeSplunk === 'boolean')) return {
        id: errorAnalytics.id,
        packageName: errorAnalytics.packageName,
        teamName: errorAnalytics.teamName,
        attributes: errorAnalytics.attributes,
        sendToPrivacyUnsafeSplunk: errorAnalytics.sendToPrivacyUnsafeSplunk
    };
    return undefined;
};
const $b5b943618371ee76$export$a78ebe1911f50d41 = ({ graphQLErrors: graphQLErrors, networkError: networkError, operation: operation })=>{
    const errorAnalytics = $b5b943618371ee76$export$bd030713895ed5e2(operation.getContext());
    // Refine mixed type to Array | void
    if (graphQLErrors !== undefined && !Array.isArray(graphQLErrors)) return;
    const hasGraphQLError = graphQLErrors !== undefined && graphQLErrors.length > 0;
    const hasNetworkError = networkError !== undefined;
    // Only report errors using the JFE analytics pipeline if analytics context data is defined for the query.
    if (errorAnalytics === undefined || !hasGraphQLError && !hasNetworkError) return;
    const { id: id, packageName: packageName, teamName: teamName, attributes: attributes, sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk } = errorAnalytics;
    const error = new (0, $eezJL.ApolloError)({
        // Above Array.isArray check will refine the type to a read-only array. We need this spread to keep flow happy.
        graphQLErrors: graphQLErrors ? [
            ...graphQLErrors
        ] : undefined,
        networkError: networkError
    });
    const attributesWithOperationName = {
        ...attributes,
        operationName: operation.operationName,
        hasGraphQLError: hasGraphQLError,
        hasNetworkError: hasNetworkError
    };
    (0, $gYnSx.default)({
        error: error,
        meta: {
            id: id,
            packageName: packageName,
            teamName: teamName
        },
        attributes: attributesWithOperationName,
        sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk
    });
};

});


parcelRegister("5acEa", function(module, exports) {

$parcel$export(module.exports, "transformStargateUrl", () => $adb591f2e2c686ec$export$96f8b7181eacc12a);
$parcel$export(module.exports, "transformCreateIssueUrl", () => $adb591f2e2c686ec$export$3092c86dfb3d9d95);
$parcel$export(module.exports, "transformOriginUrl", () => $adb591f2e2c686ec$export$e32687a94f0c0d0c);
const $adb591f2e2c686ec$export$96f8b7181eacc12a = (url)=>{
    try {
        if (url && url.includes('ex/jira') && !url.includes('gateway/api')) {
            const urlObject = new URL(url);
            let urlPathArray = urlObject.pathname.split('/');
            urlPathArray = [
                'gateway',
                'api',
                ...urlPathArray.slice(1)
            ];
            return `${urlObject.origin}/${urlPathArray.join('/')}${urlObject.search}`;
        }
    } catch (e) {
        return url;
    }
    return url;
};
const $adb591f2e2c686ec$export$3092c86dfb3d9d95 = ({ issueUrl: issueUrl, selectedCloudId: selectedCloudId })=>{
    if (!selectedCloudId) return issueUrl;
    return `/gateway/api/ex/jira/${selectedCloudId}${issueUrl}`;
};
const $adb591f2e2c686ec$export$e32687a94f0c0d0c = (selectedCloudId)=>// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    selectedCloudId ? `${window.origin}/gateway/api/ex/jira/${selectedCloudId}` : null;

});


parcelRegister("kIDUp", function(module, exports) {

$parcel$export(module.exports, "usePublishUseTriggerIssueCreateModalChange", () => $b44cb19b3f876e04$export$def8d994aa8d00f4);

var $eJOHy = parcelRequire("eJOHy");

var $xMjNG = parcelRequire("xMjNG");

var $4PKlm = parcelRequire("4PKlm");

var $jipjz = parcelRequire("jipjz");
const $b44cb19b3f876e04$export$def8d994aa8d00f4 = ()=>{
    const [state] = (0, $jipjz.useTriggerIssueCreateModal)();
    const { publish: publish } = (0, $4PKlm.useGICLifeCycleEvents)();
    (0, $eJOHy.useEffect)(()=>publish((0, $xMjNG.GIC_LIFECYCLE_EVENTS).USE_TRIGGER_ISSUE_CREATE_MODAL_STATE_CHANGE, state), [
        publish,
        state
    ]);
};

});

parcelRegister("fEXnq", function(module, exports) {

$parcel$export(module.exports, "IssueRestoreWrapper", () => $ea0705533d870cb5$export$c5abd224bc075aa5);

var $eJOHy = parcelRequire("eJOHy");

var $jQUoP = parcelRequire("jQUoP");

var $48zkg = parcelRequire("48zkg");

var $jipjz = parcelRequire("jipjz");

var $8ivLn = parcelRequire("8ivLn");

var $95O7y = parcelRequire("95O7y");
const $ea0705533d870cb5$export$c5abd224bc075aa5 = ({ children: children })=>{
    const [, { restoreState: restoreTriggerIssueCreateModalState }] = (0, $jipjz.useTriggerIssueCreateModal)();
    const [, { restoreState: restoreFormContext }] = (0, $jQUoP.useFormContext)();
    const isEmbedded = (0, $8ivLn.useIsEmbedded)();
    const [createIncidentModalState] = (0, $95O7y.useQueryParam)('open_create_incident_modal');
    const isCreateIncidentModal = createIncidentModalState !== undefined;
    return isEmbedded || isCreateIncidentModal ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children?.({})) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $48zkg.IssueRestore), {
        onRestoreTriggerIssueCreateModalState: restoreTriggerIssueCreateModalState,
        onRestoreFormContext: restoreFormContext
    }, children);
};

});
parcelRegister("48zkg", function(module, exports) {

$parcel$export(module.exports, "IssueRestore", () => $5e6ced748c38f2b3$export$20995982965fe5e9);

var $eJOHy = parcelRequire("eJOHy");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $2bdtd = parcelRequire("2bdtd");

var $j3BzM = parcelRequire("j3BzM");

var $gNiyv = parcelRequire("gNiyv");

var $1Qu1D = parcelRequire("1Qu1D");

var $hbKGH = parcelRequire("hbKGH");

var $h39xx = parcelRequire("h39xx");
const $5e6ced748c38f2b3$var$IssueRestoreInner = ({ children: children, ...rest })=>{
    const [{ inProgressIssueMetas: inProgressIssueMetas, isInitialised: isInitialised }, { init: init }] = (0, $j3BzM.useIssueRestoreMeta)();
    const inProgressIssueService = (0, $gNiyv.useInProgressIssueService)();
    (0, $eJOHy.useEffect)(()=>{
        if (!isInitialised) init();
    }, [
        isInitialised,
        init
    ]);
    // To future proof for bulk issue create
    const activeInProgressIssueID = inProgressIssueMetas?.[0]?.inProgressIssueID;
    const activeShouldRestore = inProgressIssueMetas?.[0]?.shouldRestore;
    if (isInitialised) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2bdtd.InProgressIssueStoreContainer), {
        inProgressIssueService: inProgressIssueService
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hbKGH.InProgressIssueInitialiser), {
        inProgressIssueID: activeInProgressIssueID,
        shouldRestore: activeShouldRestore,
        ...rest
    }, children));
    return null;
};
const $5e6ced748c38f2b3$export$20995982965fe5e9 = ({ children: children, ...rest })=>{
    const issueRestoreMetaService = (0, $1Qu1D.useIssueRestoreMetaService)();
    const [indexedDBAvailable] = (0, $eJOHy.useState)((0, $h39xx.isIndexedDBAvailable)());
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        if (!indexedDBAvailable) (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), 'indexedDB missing');
    }, [
        createAnalyticsEvent,
        indexedDBAvailable
    ]);
    if (!indexedDBAvailable) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children?.({}));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j3BzM.IssueRestoreMetaContainer), {
        issueRestoreMetaService: issueRestoreMetaService
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5e6ced748c38f2b3$var$IssueRestoreInner, rest, children));
};

});
parcelRegister("2bdtd", function(module, exports) {

$parcel$export(module.exports, "useInProgressIssue", () => $6363f3e683448aa0$export$4b6bb26ceba91de6);
$parcel$export(module.exports, "InProgressIssueStoreContainer", () => $6363f3e683448aa0$export$bd3e62a8e8bf35);
$parcel$export(module.exports, "useInProgressIssueActions", () => $6363f3e683448aa0$export$74b9a754a809ff62);
$parcel$export(module.exports, "useIsFormDirty", () => $6363f3e683448aa0$export$99feafa9b9955d05);
$parcel$export(module.exports, "useIsModalOpen", () => $6363f3e683448aa0$export$c09953967ff9ffea);

var $cSmYj = parcelRequire("cSmYj");

var $eDBhy = parcelRequire("eDBhy");

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");

var $5E4N4 = parcelRequire("5E4N4");
const $6363f3e683448aa0$export$d4c72bab9d6cc13a = {
    isInitialised: false,
    isSavingCounter: 0,
    id: '',
    formData: {},
    formDataDefaultValues: {},
    formContext: {},
    triggerIssueCreateModalState: undefined,
    statusField: {},
    restoreError: undefined
};
let $6363f3e683448aa0$var$hasFiredUnexpectedEventErrorAnalytics = false;
const $6363f3e683448aa0$export$2cd70be39fa29781 = ()=>{
    $6363f3e683448aa0$var$hasFiredUnexpectedEventErrorAnalytics = false;
};
const $6363f3e683448aa0$var$fireUnexpectedEventErrorAnalytics = (eventName, state)=>{
    // Prevent errors from firing too often, otherwise we mind fire this on each keypress of field update by accident
    if ($6363f3e683448aa0$var$hasFiredUnexpectedEventErrorAnalytics) return;
    $6363f3e683448aa0$var$hasFiredUnexpectedEventErrorAnalytics = true;
    (0, $eDBhy.fireIssueCreateErrorAnalytics)({
        meta: {
            id: 'useInProgressIssueService',
            packageName: 'jiraIssueCreateRestore'
        },
        attributes: {
            inProgressIssueID: state?.id,
            isModalOpen: state?.triggerIssueCreateModalState?.isModalOpen,
            wasStateRestored: state?.triggerIssueCreateModalState?.wasStateRestored,
            minimizableModalView: state?.triggerIssueCreateModalState?.minimizableModalView,
            eventName: eventName
        },
        error: new Error('InProgressIssue - unexpected event fired'),
        sendToPrivacyUnsafeSplunk: true,
        skipSentry: true
    });
};
const $6363f3e683448aa0$var$THROTTLE_DELAY = 250;
const $6363f3e683448aa0$export$e324594224ef24da = {
    onTriggerIssueCreateModalStateChange: (triggerIssueCreateModalState)=>async ({ setState: setState, getState: getState }, { inProgressIssueService: inProgressIssueService })=>{
            const currentState = getState();
            if (!(currentState.id || triggerIssueCreateModalState.inProgressIssueID) || !(currentState?.triggerIssueCreateModalState?.isModalOpen || triggerIssueCreateModalState?.isModalOpen)) return;
            // Preventing Project, Issue type and Request type from being updated
            const overridePayload = {
                project: currentState?.triggerIssueCreateModalState?.payload?.project,
                issueType: currentState?.triggerIssueCreateModalState?.payload?.issueType,
                requestType: currentState?.triggerIssueCreateModalState?.payload?.requestType
            };
            const newPayload = {
                ...triggerIssueCreateModalState.payload || {},
                ...overridePayload
            };
            setState({
                id: triggerIssueCreateModalState.inProgressIssueID,
                isSavingCounter: currentState.isSavingCounter + 1,
                triggerIssueCreateModalState: {
                    ...triggerIssueCreateModalState,
                    payload: newPayload
                }
            });
            const { updateInProgressIssue: updateInProgressIssue } = inProgressIssueService;
            const newState = getState();
            try {
                await updateInProgressIssue(newState.id, (0, $5E4N4.convertStateToInProgressIssueForStorage)(newState));
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $eDBhy.fireIssueCreateErrorAnalytics)({
                    meta: {
                        id: 'useInProgressIssueService',
                        packageName: 'jiraIssueCreateRestore'
                    },
                    error: error,
                    attributes: {
                        eventName: 'onTriggerIssueCreateModalStateChange'
                    },
                    sendToPrivacyUnsafeSplunk: true,
                    skipSentry: true
                });
                setState({
                    restoreError: error
                });
            }
            setState({
                isSavingCounter: getState().isSavingCounter - 1
            });
        },
    onFormFieldUpdate: ({ fieldId: fieldId, value: value })=>async ({ setState: setState, getState: getState }, { inProgressIssueService: inProgressIssueService })=>{
            const currentState = getState();
            if (!currentState?.id || !currentState?.triggerIssueCreateModalState?.isModalOpen) {
                $6363f3e683448aa0$var$fireUnexpectedEventErrorAnalytics(`onFormFieldUpdate - ${fieldId}`, currentState);
                return;
            }
            const newFormData = {
                ...currentState.formData,
                [fieldId]: value
            };
            setState({
                isSavingCounter: currentState.isSavingCounter + 1,
                formData: newFormData
            });
            const { updateInProgressIssue: updateInProgressIssue } = inProgressIssueService;
            try {
                await updateInProgressIssue(currentState.id, (0, $5E4N4.convertStateToInProgressIssueForStorage)(getState()));
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $eDBhy.fireIssueCreateErrorAnalytics)({
                    meta: {
                        id: 'useInProgressIssueService',
                        packageName: 'jiraIssueCreateRestore'
                    },
                    error: error,
                    attributes: {
                        eventName: 'onFormFieldUpdate'
                    },
                    sendToPrivacyUnsafeSplunk: true,
                    skipSentry: true
                });
                setState({
                    restoreError: error
                });
            }
            // Resetting is saving counter should be delayed until after throttle
            // execution to allow us to show a prompt if page unloads in between
            // invocations
            setTimeout(()=>{
                setState({
                    isSavingCounter: getState().isSavingCounter - 1
                });
            }, $6363f3e683448aa0$var$THROTTLE_DELAY + 1);
        },
    onClassificationLevelFieldChange: (classificationLevelField)=>async ({ setState: setState, getState: getState }, { inProgressIssueService: inProgressIssueService })=>{
            const currentState = getState();
            if (!currentState?.id || !currentState?.triggerIssueCreateModalState?.isModalOpen) {
                $6363f3e683448aa0$var$fireUnexpectedEventErrorAnalytics('onClassificationLevelFieldChange', currentState);
                return;
            }
            setState({
                isSavingCounter: getState().isSavingCounter + 1,
                classificationLevelField: classificationLevelField
            });
            const { updateInProgressIssue: updateInProgressIssue } = inProgressIssueService;
            const newState = getState();
            try {
                await updateInProgressIssue(newState.id, (0, $5E4N4.convertStateToInProgressIssueForStorage)(newState));
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $eDBhy.fireIssueCreateErrorAnalytics)({
                    meta: {
                        id: 'useInProgressIssueService',
                        packageName: 'jiraIssueCreateRestore'
                    },
                    error: error,
                    attributes: {
                        eventName: 'onClassificationLevelFieldChange'
                    },
                    sendToPrivacyUnsafeSplunk: true,
                    skipSentry: true
                });
                setState({
                    restoreError: error
                });
            }
            setState({
                isSavingCounter: getState().isSavingCounter - 1
            });
        },
    onStatusFieldChange: (statusField)=>async ({ setState: setState, getState: getState }, { inProgressIssueService: inProgressIssueService })=>{
            const currentState = getState();
            if (!currentState?.id || !currentState?.triggerIssueCreateModalState?.isModalOpen) {
                $6363f3e683448aa0$var$fireUnexpectedEventErrorAnalytics('onStatusFieldChange', currentState);
                return;
            }
            setState({
                isSavingCounter: getState().isSavingCounter + 1,
                statusField: statusField
            });
            const { updateInProgressIssue: updateInProgressIssue } = inProgressIssueService;
            const newState = getState();
            try {
                await updateInProgressIssue(newState.id, (0, $5E4N4.convertStateToInProgressIssueForStorage)(newState));
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $eDBhy.fireIssueCreateErrorAnalytics)({
                    meta: {
                        id: 'useInProgressIssueService',
                        packageName: 'jiraIssueCreateRestore'
                    },
                    error: error,
                    attributes: {
                        eventName: 'onStatusFieldChange'
                    },
                    sendToPrivacyUnsafeSplunk: true,
                    skipSentry: true
                });
                setState({
                    restoreError: error
                });
            }
            setState({
                isSavingCounter: getState().isSavingCounter - 1
            });
        },
    onFormContextUpdate: (formContext)=>async ({ setState: setState, getState: getState }, { inProgressIssueService: inProgressIssueService })=>{
            const currentState = getState();
            const { id: id, triggerIssueCreateModalState: triggerIssueCreateModalState, isSavingCounter: isSavingCounter } = currentState;
            if (!id || !triggerIssueCreateModalState || !triggerIssueCreateModalState.isModalOpen) return;
            const currentFormContext = currentState.formContext;
            const newFormContext = formContext;
            if (triggerIssueCreateModalState && !(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(newFormContext, currentFormContext)) {
                const currentPayload = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                triggerIssueCreateModalState.payload;
                const selectedIssueAndRequestType = newFormContext.selectedIssueType ? {
                    issueType: {
                        issueTypeId: (0, $5E4N4.isRequestType)(newFormContext.selectedIssueType) ? newFormContext.selectedIssueType.issueTypeId : newFormContext.selectedIssueType?.value
                    },
                    requestType: (0, $5E4N4.isRequestType)(newFormContext.selectedIssueType) ? {
                        key: newFormContext.selectedIssueType.requestTypeKey
                    } : undefined
                } : undefined;
                const newTriggerIssueCreateModalState = {
                    ...triggerIssueCreateModalState,
                    payload: {
                        ...currentPayload,
                        project: {
                            projectId: newFormContext.selectedProject?.value
                        },
                        ...selectedIssueAndRequestType
                    }
                };
                const newState = {
                    isSavingCounter: isSavingCounter + 1,
                    formContext: newFormContext,
                    triggerIssueCreateModalState: newTriggerIssueCreateModalState
                };
                setState(newState);
                const { updateInProgressIssue: updateInProgressIssue } = inProgressIssueService;
                try {
                    await updateInProgressIssue(id, (0, $5E4N4.convertStateToInProgressIssueForStorage)(getState()));
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (error) {
                    (0, $eDBhy.fireIssueCreateErrorAnalytics)({
                        meta: {
                            id: 'useInProgressIssueService',
                            packageName: 'jiraIssueCreateRestore'
                        },
                        error: error,
                        attributes: {
                            eventName: 'onFormContextUpdate'
                        },
                        sendToPrivacyUnsafeSplunk: true,
                        skipSentry: true
                    });
                    setState({
                        restoreError: error
                    });
                }
                setState({
                    isSavingCounter: getState().isSavingCounter - 1
                });
            }
        },
    onModalOpened: ({ inProgressIssueID: inProgressIssueID })=>async ({ setState: setState, getState: getState }, { inProgressIssueService: inProgressIssueService })=>{
            const { createInProgressIssue: createInProgressIssue } = inProgressIssueService;
            const newState = {
                ...getState(),
                id: inProgressIssueID
            };
            setState(newState);
            try {
                await createInProgressIssue(inProgressIssueID, (0, $5E4N4.convertStateToInProgressIssueForStorage)(newState));
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $eDBhy.fireIssueCreateErrorAnalytics)({
                    meta: {
                        id: 'useInProgressIssueService',
                        packageName: 'jiraIssueCreateRestore'
                    },
                    error: error,
                    attributes: {
                        eventName: 'onModalOpened'
                    },
                    sendToPrivacyUnsafeSplunk: true,
                    skipSentry: true
                });
                setState({
                    restoreError: error
                });
            }
        },
    onModalClosed: ({ inProgressIssueID: inProgressIssueID })=>async ({ setState: setState, getState: getState }, { inProgressIssueService: inProgressIssueService })=>{
            if (inProgressIssueID === getState().id) {
                setState({
                    ...$6363f3e683448aa0$export$d4c72bab9d6cc13a,
                    isInitialised: true,
                    restoreError: undefined
                });
                const { deleteInProgressIssue: deleteInProgressIssue } = inProgressIssueService;
                try {
                    await deleteInProgressIssue(inProgressIssueID);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (error) {
                    (0, $eDBhy.fireIssueCreateErrorAnalytics)({
                        meta: {
                            id: 'useInProgressIssueService',
                            packageName: 'jiraIssueCreateRestore'
                        },
                        error: error,
                        attributes: {
                            eventName: 'onModalClosed'
                        },
                        sendToPrivacyUnsafeSplunk: true,
                        skipSentry: true
                    });
                    setState({
                        restoreError: error
                    });
                }
            }
        },
    onModalDiscardExistingInProgressIssue: ()=>async ({ setState: setState, getState: getState }, { inProgressIssueService: inProgressIssueService })=>{
            const state = getState();
            setState({
                ...$6363f3e683448aa0$export$d4c72bab9d6cc13a,
                isSavingCounter: state.isSavingCounter + 1,
                id: state.id,
                triggerIssueCreateModalState: state.triggerIssueCreateModalState,
                formContext: state.formContext,
                isInitialised: true,
                restoreError: undefined
            });
            const { updateInProgressIssue: updateInProgressIssue } = inProgressIssueService;
            try {
                await updateInProgressIssue(state.id, (0, $5E4N4.convertStateToInProgressIssueForStorage)(getState()));
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $eDBhy.fireIssueCreateErrorAnalytics)({
                    meta: {
                        id: 'useInProgressIssueService',
                        packageName: 'jiraIssueCreateRestore'
                    },
                    error: error,
                    attributes: {
                        eventName: 'onModalDiscardExistingInProgressIssue'
                    },
                    sendToPrivacyUnsafeSplunk: true,
                    skipSentry: true
                });
                setState({
                    restoreError: error
                });
            }
            setState({
                isSavingCounter: getState().isSavingCounter - 1
            });
        },
    onResetFormFieldsForCreateAnother: (fieldsReset)=>async ({ setState: setState, getState: getState }, { inProgressIssueService: inProgressIssueService })=>{
            const currentState = getState();
            if (!currentState?.id || !currentState?.triggerIssueCreateModalState?.isModalOpen) {
                $6363f3e683448aa0$var$fireUnexpectedEventErrorAnalytics('onResetFormFieldsForCreateAnother', currentState);
                return;
            }
            const newFormData = {
                ...currentState.formData,
                ...fieldsReset.fieldsReset
            };
            setState({
                isSavingCounter: currentState.isSavingCounter + 1,
                formData: newFormData
            });
            const { updateInProgressIssue: updateInProgressIssue } = inProgressIssueService;
            try {
                await updateInProgressIssue(currentState.id, (0, $5E4N4.convertStateToInProgressIssueForStorage)(getState()));
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $eDBhy.fireIssueCreateErrorAnalytics)({
                    meta: {
                        id: 'useInProgressIssueService',
                        packageName: 'jiraIssueCreateRestore'
                    },
                    error: error,
                    attributes: {
                        eventName: 'onResetFormFieldsForCreateAnother'
                    },
                    sendToPrivacyUnsafeSplunk: true,
                    skipSentry: true
                });
                setState({
                    restoreError: error
                });
            }
            setState({
                isSavingCounter: getState().isSavingCounter - 1
            });
        },
    onReinsertIntoBrowserStorage: ()=>async ({ setState: setState, getState: getState }, { inProgressIssueService: inProgressIssueService })=>{
            const currentState = getState();
            if (!currentState?.id || !currentState?.triggerIssueCreateModalState?.isModalOpen) {
                $6363f3e683448aa0$var$fireUnexpectedEventErrorAnalytics('onReinsertIntoBrowserStorage', currentState);
                return;
            }
            setState({
                isSavingCounter: currentState.isSavingCounter + 1
            });
            const { createInProgressIssue: createInProgressIssue } = inProgressIssueService;
            try {
                await createInProgressIssue(currentState.id, (0, $5E4N4.convertStateToInProgressIssueForStorage)(currentState));
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $eDBhy.fireIssueCreateErrorAnalytics)({
                    meta: {
                        id: 'useInProgressIssueService',
                        packageName: 'jiraIssueCreateRestore'
                    },
                    error: error,
                    attributes: {
                        eventName: 'onReinsertIntoBrowserStorage'
                    },
                    sendToPrivacyUnsafeSplunk: true,
                    skipSentry: true
                });
                setState({
                    restoreError: error
                });
            }
            setState({
                isSavingCounter: getState().isSavingCounter - 1
            });
        },
    init: (inProgressIssueID)=>async ({ setState: setState, getState: getState }, { inProgressIssueService: inProgressIssueService })=>{
            if (inProgressIssueID) {
                // Get useTriggerIssueCreateModalState from storage
                const { getInProgressIssue: getInProgressIssue } = inProgressIssueService;
                try {
                    const inProgressIssue = await getInProgressIssue(inProgressIssueID);
                    setState({
                        ...inProgressIssue,
                        triggerIssueCreateModalState: inProgressIssue?.triggerIssueCreateModalState ? {
                            ...inProgressIssue?.triggerIssueCreateModalState,
                            wasStateRestored: true
                        } : undefined,
                        isInitialised: true
                    });
                } catch (error) {
                    setState({
                        restoreError: error
                    });
                }
                return getState();
            }
            setState({
                isInitialised: true
            });
            return getState();
        },
    onFormFieldConfigUpdate: ({ fieldConfig: fieldConfig })=>async ({ setState: setState, getState: getState }, { inProgressIssueService: inProgressIssueService })=>{
            const currentState = getState();
            if (!currentState.id) return;
            let newFormDataDefaultValues = {};
            Object.values(fieldConfig).forEach((fieldData)=>{
                const { fieldId: fieldId, defaultValue: defaultValue } = fieldData;
                newFormDataDefaultValues = {
                    ...newFormDataDefaultValues,
                    [fieldId]: defaultValue
                };
            });
            setState({
                isSavingCounter: currentState.isSavingCounter + 1,
                formDataDefaultValues: newFormDataDefaultValues
            });
            const { updateInProgressIssue: updateInProgressIssue } = inProgressIssueService;
            try {
                await updateInProgressIssue(currentState.id, (0, $5E4N4.convertStateToInProgressIssueForStorage)(getState()));
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $eDBhy.fireIssueCreateErrorAnalytics)({
                    meta: {
                        id: 'useInProgressIssueService',
                        packageName: 'jiraIssueCreateRestore'
                    },
                    error: error,
                    attributes: {
                        eventName: 'onFormFieldConfigUpdate'
                    },
                    sendToPrivacyUnsafeSplunk: true,
                    skipSentry: true
                });
                setState({
                    restoreError: error
                });
            }
            setState({
                isSavingCounter: getState().isSavingCounter - 1
            });
        },
    onIssueTypeChange: (_)=>async ({ setState: setState, getState: getState }, { inProgressIssueService: inProgressIssueService })=>{
            const currentState = getState();
            if (!currentState?.id || !currentState?.triggerIssueCreateModalState?.isModalOpen) {
                $6363f3e683448aa0$var$fireUnexpectedEventErrorAnalytics('onIssueTypeChange', currentState);
                return;
            }
            // reset form fields default values
            const newFormDataDefaultValues = {};
            setState({
                isSavingCounter: currentState.isSavingCounter + 1,
                formDataDefaultValues: newFormDataDefaultValues
            });
            const { updateInProgressIssue: updateInProgressIssue } = inProgressIssueService;
            try {
                await updateInProgressIssue(currentState.id, (0, $5E4N4.convertStateToInProgressIssueForStorage)(getState()));
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $eDBhy.fireIssueCreateErrorAnalytics)({
                    meta: {
                        id: 'useInProgressIssueService',
                        packageName: 'jiraIssueCreateRestore'
                    },
                    error: error,
                    attributes: {
                        eventName: 'onIssueTypeChange'
                    },
                    sendToPrivacyUnsafeSplunk: true,
                    skipSentry: true
                });
                setState({
                    restoreError: error
                });
            }
            setState({
                isSavingCounter: getState().isSavingCounter - 1
            });
        },
    onProjectFieldChange: (_)=>async ({ setState: setState, getState: getState }, { inProgressIssueService: inProgressIssueService })=>{
            const currentState = getState();
            if (!currentState?.id || !currentState?.triggerIssueCreateModalState?.isModalOpen) {
                $6363f3e683448aa0$var$fireUnexpectedEventErrorAnalytics('onProjectFieldChange', currentState);
                return;
            }
            // reset form fields default values
            const newFormDataDefaultValues = {};
            setState({
                isSavingCounter: currentState.isSavingCounter + 1,
                formDataDefaultValues: newFormDataDefaultValues
            });
            const { updateInProgressIssue: updateInProgressIssue } = inProgressIssueService;
            try {
                await updateInProgressIssue(currentState.id, (0, $5E4N4.convertStateToInProgressIssueForStorage)(getState()));
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $eDBhy.fireIssueCreateErrorAnalytics)({
                    meta: {
                        id: 'useInProgressIssueService',
                        packageName: 'jiraIssueCreateRestore'
                    },
                    error: error,
                    attributes: {
                        eventName: 'onProjectFieldChange'
                    },
                    sendToPrivacyUnsafeSplunk: true,
                    skipSentry: true
                });
                setState({
                    restoreError: error
                });
            }
            setState({
                isSavingCounter: getState().isSavingCounter - 1
            });
        },
    setRestoreError: (// eslint-disable-next-line @typescript-eslint/no-explicit-any
    restoreError)=>async ({ setState: setState })=>{
            setState({
                restoreError: restoreError
            });
        }
};
const $6363f3e683448aa0$var$Store = (0, $GtRbT.createStore)({
    initialState: $6363f3e683448aa0$export$d4c72bab9d6cc13a,
    actions: $6363f3e683448aa0$export$e324594224ef24da
});
const $6363f3e683448aa0$export$4b6bb26ceba91de6 = (0, $iJq0l.createHook)($6363f3e683448aa0$var$Store);
const $6363f3e683448aa0$export$bd3e62a8e8bf35 = (0, $6E16M.createContainer)($6363f3e683448aa0$var$Store);
const $6363f3e683448aa0$export$74b9a754a809ff62 = (0, $iJq0l.createActionsHook)($6363f3e683448aa0$var$Store);
// Selectors
const $6363f3e683448aa0$var$getIsFormDirty = (state)=>state?.formContext?.isFormDirty;
const $6363f3e683448aa0$export$99feafa9b9955d05 = (0, $iJq0l.createHook)($6363f3e683448aa0$var$Store, {
    selector: $6363f3e683448aa0$var$getIsFormDirty
});
const $6363f3e683448aa0$var$getIsModalOpen = (state)=>Boolean(state?.id && state?.triggerIssueCreateModalState?.isModalOpen);
const $6363f3e683448aa0$export$c09953967ff9ffea = (0, $iJq0l.createHook)($6363f3e683448aa0$var$Store, {
    selector: $6363f3e683448aa0$var$getIsModalOpen
});

});
parcelRegister("eDBhy", function(module, exports) {

$parcel$export(module.exports, "fireIssueCreateErrorAnalytics", () => $7521412fa2e04cd6$export$fffbd8c0e67dbb84);

var $eezJL = parcelRequire("eezJL");

var $gYnSx = parcelRequire("gYnSx");

var $7jTnu = parcelRequire("7jTnu");

var $bguQO = parcelRequire("bguQO");

var $dqT1s = parcelRequire("dqT1s");
const $7521412fa2e04cd6$export$fffbd8c0e67dbb84 = (payload)=>{
    if (!(0, $7jTnu.fg)('issue-create-fire-error-analytics-refactor')) return (0, $gYnSx.default)(payload);
    const { attributes: attributes = {}, error: error, ...otherPayload } = payload;
    (0, $bguQO.fireErrorAnalyticsCommon)({
        ...otherPayload,
        attributes: {
            ...attributes,
            ...error && (0, $eezJL.isApolloError)(error) ? {
                errorType: (0, $dqT1s.handleApolloError)(error)
            } : {}
        },
        error: error
    });
};

});
parcelRegister("dqT1s", function(module, exports) {

$parcel$export(module.exports, "handleApolloError", () => $66011c8af62c00c5$export$31b755cdc25616f2);
const $66011c8af62c00c5$export$31b755cdc25616f2 = (error)=>{
    let errorType = 'unknown';
    if (error.networkError != null) errorType = 'networkError';
    else if (error.graphQLErrors && error.graphQLErrors.length > 0) errorType = 'graphQLError';
    // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'ErrorType'.
    return errorType;
};

});


parcelRegister("5E4N4", function(module, exports) {

$parcel$export(module.exports, "convertStateToInProgressIssueForStorage", () => $fd2f7250dd888197$export$2f809a820073cf71);
$parcel$export(module.exports, "isRequestType", () => $fd2f7250dd888197$export$ff3afd1b5536cfed);

var $jFHCE = parcelRequire("jFHCE");

var $7jTnu = parcelRequire("7jTnu");
function $fd2f7250dd888197$export$2f809a820073cf71(state) {
    try {
        return {
            // removing these since they are only in InProgressIssueControllerState not InProgressIssue
            ...(0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(state, [
                'isInitialised',
                'isSavingCounter'
            ]),
            // We need to do this to remove fields that are functions etc that we can't store in indexed-db
            formContext: state?.formContext ? JSON.parse(JSON.stringify(state.formContext)) : undefined,
            ...(0, $7jTnu.fg)('fix-gryf-a11y-issues') ? {
                triggerIssueCreateModalState: state?.triggerIssueCreateModalState ? JSON.parse(JSON.stringify({
                    ...state.triggerIssueCreateModalState,
                    triggerButtonRef: null
                })) : undefined
            } : {
                triggerIssueCreateModalState: state?.triggerIssueCreateModalState ? JSON.parse(JSON.stringify(state.triggerIssueCreateModalState)) : undefined
            }
        };
    } catch  {
        return state;
    }
}
function $fd2f7250dd888197$export$ff3afd1b5536cfed(type) {
    if (!type) return false;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return type.issueTypeId !== undefined;
}

});


parcelRegister("j3BzM", function(module, exports) {

$parcel$export(module.exports, "useIssueRestoreMeta", () => $90b0a07e9d6bb32c$export$bad3a2f4726801fb);
$parcel$export(module.exports, "IssueRestoreMetaContainer", () => $90b0a07e9d6bb32c$export$e670c4748122991);
$parcel$export(module.exports, "useIssueRestoreMetaActions", () => $90b0a07e9d6bb32c$export$2a548b3d17373434);
$parcel$export(module.exports, "useIssueRestoreMetaSubscriptions", () => $90b0a07e9d6bb32c$export$270e0095f4e57380);

var $eJOHy = parcelRequire("eJOHy");

var $eDBhy = parcelRequire("eDBhy");

var $xMjNG = parcelRequire("xMjNG");

var $4PKlm = parcelRequire("4PKlm");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");

var $8POiJ = parcelRequire("8POiJ");
const $90b0a07e9d6bb32c$export$d4c72bab9d6cc13a = {
    isInitialised: false,
    isSavingCounter: 0,
    inProgressIssueMetas: [],
    restoreMetaError: undefined
};
const $90b0a07e9d6bb32c$export$e324594224ef24da = {
    init: ()=>async ({ setState: setState, getState: getState }, { issueRestoreMetaService: issueRestoreMetaService })=>{
            if (!getState().isInitialised) try {
                const { getIssueRestoreMeta: getIssueRestoreMeta, createIssueRestoreMeta: createIssueRestoreMeta } = issueRestoreMetaService;
                let issueRestoreMeta = await getIssueRestoreMeta();
                if (!issueRestoreMeta) issueRestoreMeta = await createIssueRestoreMeta({
                    inProgressIssueMetas: []
                });
                if (issueRestoreMeta.inProgressIssueMetas !== undefined) {
                    // filter out inProgressIssueMetas that shouldn't be restored
                    const filteredinProgressIssueMetas = issueRestoreMeta.inProgressIssueMetas.filter((inProgressIssueMeta)=>inProgressIssueMeta.shouldRestore === true);
                    issueRestoreMeta.inProgressIssueMetas = filteredinProgressIssueMetas;
                }
                setState({
                    ...issueRestoreMeta,
                    isInitialised: true
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $eDBhy.fireIssueCreateErrorAnalytics)({
                    meta: {
                        id: 'useIssueCreateMetaService',
                        packageName: 'jiraIssueCreateRestore'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
                setState({
                    restoreMetaError: error
                });
            }
        },
    onModalOpened: ({ inProgressIssueID: inProgressIssueID, analyticsEvent: analyticsEvent })=>async ({ setState: setState, getState: getState }, { issueRestoreMetaService: issueRestoreMetaService })=>{
            const currentState = getState();
            if (currentState.inProgressIssueMetas !== undefined) {
                if (!currentState.isInitialised || currentState.inProgressIssueMetas.map((inProgressIssueMeta)=>inProgressIssueMeta.inProgressIssueID).includes(inProgressIssueID)) return;
                // TODO this needs to be updated for bulk create
                if (currentState.inProgressIssueMetas.find((inProgressIssueMeta)=>inProgressIssueMeta.shouldRestore)) analyticsEvent ? (0, $gCeeo.fireTrackAnalytics)(analyticsEvent, 'ExistingInProgressIssue onModalOpened', {
                    id: 'issueRestoreMetaOnModalOpened',
                    packageName: 'jiraIssueCreateRestore'
                }) : (0, $eDBhy.fireIssueCreateErrorAnalytics)({
                    error: new Error('Existing inProgressIssue onModalOpened'),
                    meta: {
                        id: 'issueRestoreMetaOnModalOpened',
                        packageName: 'jiraIssueCreateRestore'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                setState({
                    isSavingCounter: currentState.isSavingCounter + 1,
                    inProgressIssueMetas: [
                        {
                            inProgressIssueID: inProgressIssueID,
                            shouldRestore: true
                        }
                    ]
                });
            }
            const { updateIssueRestoreMeta: updateIssueRestoreMeta } = issueRestoreMetaService;
            try {
                await updateIssueRestoreMeta((0, $8POiJ.convertStateToIssueRestoreMeta)(getState()));
                setState({
                    isSavingCounter: getState().isSavingCounter - 1
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $eDBhy.fireIssueCreateErrorAnalytics)({
                    meta: {
                        id: 'useIssueCreateMetaService',
                        packageName: 'jiraIssueCreateRestore'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
                setState({
                    restoreMetaError: error
                });
            }
        },
    onModalClosed: ({ inProgressIssueID: inProgressIssueIDToBeRemoved })=>async ({ setState: setState, getState: getState }, { issueRestoreMetaService: issueRestoreMetaService })=>{
            const currentState = getState();
            const newInProgressIssueMetas = currentState.inProgressIssueMetas.filter((inProgressIssueMeta)=>inProgressIssueMeta.inProgressIssueID !== inProgressIssueIDToBeRemoved);
            setState({
                isSavingCounter: currentState.isSavingCounter + 1,
                restoreMetaError: undefined,
                inProgressIssueMetas: newInProgressIssueMetas
            });
            const { updateIssueRestoreMeta: updateIssueRestoreMeta } = issueRestoreMetaService;
            try {
                await updateIssueRestoreMeta((0, $8POiJ.convertStateToIssueRestoreMeta)(getState()));
                setState({
                    isSavingCounter: getState().isSavingCounter - 1
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $eDBhy.fireIssueCreateErrorAnalytics)({
                    meta: {
                        id: 'useIssueCreateMetaService',
                        packageName: 'jiraIssueCreateRestore'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
                setState({
                    restoreMetaError: error
                });
            }
        },
    setShouldRestore: (inProgressIssueID, newShouldRestore)=>async ({ getState: getState, setState: setState }, { issueRestoreMetaService: issueRestoreMetaService })=>{
            const currentState = getState();
            const inProgressIssueMetaIndex = currentState.inProgressIssueMetas.findIndex((inProgressIssueMeta)=>inProgressIssueMeta.inProgressIssueID === inProgressIssueID);
            if (inProgressIssueMetaIndex < 0) return;
            const newInProgressIssueMetas = [
                ...currentState.inProgressIssueMetas
            ];
            newInProgressIssueMetas[inProgressIssueMetaIndex] = {
                ...newInProgressIssueMetas[inProgressIssueMetaIndex],
                shouldRestore: newShouldRestore
            };
            setState({
                isSavingCounter: currentState.isSavingCounter + 1,
                inProgressIssueMetas: newInProgressIssueMetas
            });
            const { updateIssueRestoreMeta: updateIssueRestoreMeta } = issueRestoreMetaService;
            try {
                await updateIssueRestoreMeta((0, $8POiJ.convertStateToIssueRestoreMeta)(getState()));
                setState({
                    isSavingCounter: getState().isSavingCounter - 1
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $eDBhy.fireIssueCreateErrorAnalytics)({
                    meta: {
                        id: 'useIssueCreateMetaService',
                        packageName: 'jiraIssueCreateRestore'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
                setState({
                    restoreMetaError: error
                });
            }
        }
};
const $90b0a07e9d6bb32c$var$Store = (0, $GtRbT.createStore)({
    initialState: $90b0a07e9d6bb32c$export$d4c72bab9d6cc13a,
    actions: $90b0a07e9d6bb32c$export$e324594224ef24da
});
const $90b0a07e9d6bb32c$export$bad3a2f4726801fb = (0, $iJq0l.createHook)($90b0a07e9d6bb32c$var$Store);
const $90b0a07e9d6bb32c$export$e670c4748122991 = (0, $6E16M.createContainer)($90b0a07e9d6bb32c$var$Store);
const $90b0a07e9d6bb32c$export$2a548b3d17373434 = (0, $iJq0l.createActionsHook)($90b0a07e9d6bb32c$var$Store);
const $90b0a07e9d6bb32c$export$270e0095f4e57380 = ()=>{
    const { onModalOpened: onModalOpened, onModalClosed: onModalClosed } = $90b0a07e9d6bb32c$export$2a548b3d17373434();
    const { subscribe: subscribe } = (0, $4PKlm.useGICLifeCycleEvents)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        const analyticsEvent = createAnalyticsEvent({});
        const onOpenModal = (params)=>onModalOpened({
                ...params,
                analyticsEvent: analyticsEvent
            });
        return subscribe((0, $xMjNG.GIC_LIFECYCLE_EVENTS).MODAL_OPENED, onOpenModal);
    }, [
        createAnalyticsEvent,
        onModalOpened,
        subscribe
    ]);
    (0, $eJOHy.useEffect)(()=>subscribe((0, $xMjNG.GIC_LIFECYCLE_EVENTS).MODAL_CLOSED, onModalClosed), [
        onModalClosed,
        subscribe
    ]);
};

});
parcelRegister("8POiJ", function(module, exports) {

$parcel$export(module.exports, "convertStateToIssueRestoreMeta", () => $951a6aa13a1fd1bb$export$4494f626031edfc9);

var $jFHCE = parcelRequire("jFHCE");
function $951a6aa13a1fd1bb$export$4494f626031edfc9(state) {
    // removing these since they are only in IssueRestoreMetaControllerState not IssueRestoreMeta
    return (0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(state, [
        'isInitialised',
        'isSavingCounter',
        'restoreMetaError'
    ]);
}

});


parcelRegister("gNiyv", function(module, exports) {

$parcel$export(module.exports, "useInProgressIssueService", () => $21059ea1cd74bc48$export$6fc1ebae2c6a92c1);

var $eJOHy = parcelRequire("eJOHy");

var $fclB9 = parcelRequire("fclB9");

var $eDBhy = parcelRequire("eDBhy");

const $21059ea1cd74bc48$export$6fc1ebae2c6a92c1 = ()=>{
    const [storage] = (0, $eJOHy.useState)(()=>(0, $fclB9.createIndexedDBStorageProvider)(`${(0, $156089ffb832620f$export$8fa5032778cf7801)}in-progress-issue`, {
            shouldAutoReconnect: true
        }));
    return {
        getInProgressIssue: async (inProgressIssueID)=>storage.get(inProgressIssueID),
        createInProgressIssue: async (inProgressIssueID, data)=>{
            await storage.set(inProgressIssueID, data);
            return data;
        },
        updateInProgressIssue: async (inProgressIssueID, data)=>{
            if (await storage.get(inProgressIssueID)) await storage.set(inProgressIssueID, data);
            else {
                (0, $eDBhy.fireIssueCreateErrorAnalytics)({
                    meta: {
                        id: 'updateInProgressIssue',
                        packageName: 'jiraIssueCreateRestore',
                        teamName: 'gryffindor'
                    },
                    attributes: {
                        message: "Tried to updateInProgressIssue with an inProgressIssueID that doesn't exist in indexed-db"
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                return data;
            }
            return data;
        },
        deleteInProgressIssue: async (inProgressIssueID)=>{
            await storage.remove(inProgressIssueID);
        }
    };
};

});
parcelRegister("fclB9", function(module, exports) {

$parcel$export(module.exports, "createIndexedDBStorageProvider", () => $c1555772a5bddb48$export$6ba36c4f5fb8919d);

var $5PQOA = parcelRequire("5PQOA");

var $czeV6 = parcelRequire("czeV6");
const $c1555772a5bddb48$export$6ba36c4f5fb8919d = (0, (/*@__PURE__*/$parcel$interopDefault($5PQOA)))((appPrefix, options)=>{
    if (!appPrefix) throw Error("appPrefix can not be empty. It's used to separate apps");
    const provider = (0, $czeV6.createStorageProvider)(appPrefix);
    if (options?.shouldAutoReconnect) return (0, $czeV6.withAutoReconnect)(provider);
    return provider;
});

});
parcelRegister("czeV6", function(module, exports) {

$parcel$export(module.exports, "createStorageProvider", () => $83715273b7a8b6ec$export$8441605555fbd60c);
$parcel$export(module.exports, "withAutoReconnect", () => $83715273b7a8b6ec$export$8432fe49db7d8865);

var $98dDj = parcelRequire("98dDj");
const $83715273b7a8b6ec$export$7382f85ef4ff4314 = (prefix, key)=>`${prefix.replace(/_*$/, '')}__${key || ''}`;
const $83715273b7a8b6ec$var$createCustomStore = ()=>(0, $98dDj.createStore)('keyval-store', 'keyval');
let $83715273b7a8b6ec$var$customStore;
const $83715273b7a8b6ec$var$getStore = ()=>{
    let store = $83715273b7a8b6ec$var$customStore;
    if (!store) {
        $83715273b7a8b6ec$var$customStore = $83715273b7a8b6ec$var$createCustomStore();
        store = $83715273b7a8b6ec$var$customStore;
    }
    return store;
};
const $83715273b7a8b6ec$export$8441605555fbd60c = (appPrefix)=>{
    const KEYS_STORE_PREFIX = $83715273b7a8b6ec$export$7382f85ef4ff4314(appPrefix);
    const prefix = (key)=>$83715273b7a8b6ec$export$7382f85ef4ff4314(appPrefix, key);
    // Runtime check to ensure a key is provided as the prefix without a key
    // holds an array of all the keys that are prefixed by this store
    const assertKey = (key)=>{
        if (!key) throw Error('You must provide a key');
    };
    // Calling `clearAll` would require us to iterate over every key in the
    // indexed-db, filtering by this instance's prefix and subsequently deleting
    // all the filtered keys. As indexed-db gains traction within Jira, this
    // will quickly become an expensive operation. To counteract this, we
    // instead store all the keys that this instance has created so that when it
    // comes time to clear them all, we simply just have to clear every key in
    // this store. This removes the need for iterating and filtering all
    // together.
    const updateStoreKeys = async (key, remove = false)=>(0, $98dDj.update)(KEYS_STORE_PREFIX, (currentKeys)=>{
            const storeKeys = new Set(currentKeys);
            if (remove) {
                storeKeys.delete(key);
                return Array.from(storeKeys.values());
            }
            storeKeys.add(key);
            return Array.from(storeKeys.values());
        }, $83715273b7a8b6ec$var$getStore());
    return {
        async get (key) {
            assertKey(key);
            return (0, $98dDj.get)(prefix(key), $83715273b7a8b6ec$var$getStore());
        },
        async remove (key) {
            assertKey(key);
            const prefixedKey = prefix(key);
            await (0, $98dDj.del)(prefixedKey, $83715273b7a8b6ec$var$getStore());
            return updateStoreKeys(prefixedKey, true);
        },
        async clearAll () {
            const prefixedKeys = await (0, $98dDj.get)(KEYS_STORE_PREFIX, $83715273b7a8b6ec$var$getStore());
            if (!prefixedKeys || prefixedKeys.length === 0) return undefined;
            return (0, $98dDj.delMany)(prefixedKeys.concat(KEYS_STORE_PREFIX));
        },
        async set (key, value) {
            assertKey(key);
            const prefixedKey = prefix(key);
            if (typeof value === 'function') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            (0, $98dDj.update)(prefixedKey, value);
            else (0, $98dDj.set)(prefixedKey, value, $83715273b7a8b6ec$var$getStore());
            return updateStoreKeys(prefixedKey);
        },
        async reconnect () {
            $83715273b7a8b6ec$var$customStore = $83715273b7a8b6ec$var$createCustomStore();
        }
    };
};
const $83715273b7a8b6ec$export$8432fe49db7d8865 = (storageProvider)=>({
        async get (...args) {
            try {
                return await storageProvider.get(...args);
            } catch (e) {
                if (e instanceof Error) {
                    await storageProvider.reconnect?.();
                    return storageProvider.get(...args);
                }
                throw e;
            }
        },
        async set (...args) {
            try {
                return await storageProvider.set(...args);
            } catch (e) {
                if (e instanceof Error) {
                    await storageProvider.reconnect?.();
                    return storageProvider.set(...args);
                }
                throw e;
            }
        },
        async remove (...args) {
            try {
                return await storageProvider.remove(...args);
            } catch (e) {
                if (e instanceof Error) {
                    await storageProvider.reconnect?.();
                    return storageProvider.remove(...args);
                }
                throw e;
            }
        },
        async clearAll (...args) {
            try {
                return await storageProvider.clearAll(...args);
            } catch (e) {
                if (e instanceof Error) {
                    await storageProvider.reconnect?.();
                    return storageProvider.clearAll(...args);
                }
                throw e;
            }
        },
        async reconnect () {
            await storageProvider.reconnect?.();
        }
    });

});
parcelRegister("98dDj", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $6a5f6fa33a187ce0$export$f51a9068ac82ea43);
$parcel$export(module.exports, "get", () => $6a5f6fa33a187ce0$export$3988ae62b71be9a3);
$parcel$export(module.exports, "set", () => $6a5f6fa33a187ce0$export$adaa4cf7ef1b65be);
$parcel$export(module.exports, "update", () => $6a5f6fa33a187ce0$export$722fbec263ad908a);
$parcel$export(module.exports, "del", () => $6a5f6fa33a187ce0$export$1d2f21e549771e67);
$parcel$export(module.exports, "delMany", () => $6a5f6fa33a187ce0$export$c8aa84257229cac8);
function $6a5f6fa33a187ce0$export$b327150396135fe7(request) {
    return new Promise((resolve, reject)=>{
        // @ts-ignore - file size hacks
        request.oncomplete = request.onsuccess = ()=>resolve(request.result);
        // @ts-ignore - file size hacks
        request.onabort = request.onerror = ()=>reject(request.error);
    });
}
function $6a5f6fa33a187ce0$export$f51a9068ac82ea43(dbName, storeName) {
    const request = indexedDB.open(dbName);
    request.onupgradeneeded = ()=>request.result.createObjectStore(storeName);
    const dbp = $6a5f6fa33a187ce0$export$b327150396135fe7(request);
    return (txMode, callback)=>dbp.then((db)=>callback(db.transaction(storeName, txMode).objectStore(storeName)));
}
let $6a5f6fa33a187ce0$var$defaultGetStoreFunc;
function $6a5f6fa33a187ce0$var$defaultGetStore() {
    if (!$6a5f6fa33a187ce0$var$defaultGetStoreFunc) $6a5f6fa33a187ce0$var$defaultGetStoreFunc = $6a5f6fa33a187ce0$export$f51a9068ac82ea43('keyval-store', 'keyval');
    return $6a5f6fa33a187ce0$var$defaultGetStoreFunc;
}
/**
 * Get a value by its key.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $6a5f6fa33a187ce0$export$3988ae62b71be9a3(key, customStore = $6a5f6fa33a187ce0$var$defaultGetStore()) {
    return customStore('readonly', (store)=>$6a5f6fa33a187ce0$export$b327150396135fe7(store.get(key)));
}
/**
 * Set a value with a key.
 *
 * @param key
 * @param value
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $6a5f6fa33a187ce0$export$adaa4cf7ef1b65be(key, value, customStore = $6a5f6fa33a187ce0$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        store.put(value, key);
        return $6a5f6fa33a187ce0$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Set multiple values at once. This is faster than calling set() multiple times.
 * It's also atomic – if one of the pairs can't be added, none will be added.
 *
 * @param entries Array of entries, where each entry is an array of `[key, value]`.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $6a5f6fa33a187ce0$export$daa0a5170277c7a8(entries, customStore = $6a5f6fa33a187ce0$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        entries.forEach((entry)=>store.put(entry[1], entry[0]));
        return $6a5f6fa33a187ce0$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Get multiple values by their keys
 *
 * @param keys
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $6a5f6fa33a187ce0$export$5df405cccea42673(keys, customStore = $6a5f6fa33a187ce0$var$defaultGetStore()) {
    return customStore('readonly', (store)=>Promise.all(keys.map((key)=>$6a5f6fa33a187ce0$export$b327150396135fe7(store.get(key)))));
}
/**
 * Update a value. This lets you see the old value and update it as an atomic operation.
 *
 * @param key
 * @param updater A callback that takes the old value and returns a new value.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $6a5f6fa33a187ce0$export$722fbec263ad908a(key, updater, customStore = $6a5f6fa33a187ce0$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>// Need to create the promise manually.
        // If I try to chain promises, the transaction closes in browsers
        // that use a promise polyfill (IE10/11).
        new Promise((resolve, reject)=>{
            store.get(key).onsuccess = function() {
                try {
                    store.put(updater(this.result), key);
                    resolve($6a5f6fa33a187ce0$export$b327150396135fe7(store.transaction));
                } catch (err) {
                    reject(err);
                }
            };
        }));
}
/**
 * Delete a particular key from the store.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $6a5f6fa33a187ce0$export$1d2f21e549771e67(key, customStore = $6a5f6fa33a187ce0$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        store.delete(key);
        return $6a5f6fa33a187ce0$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Delete multiple keys at once.
 *
 * @param keys List of keys to delete.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $6a5f6fa33a187ce0$export$c8aa84257229cac8(keys, customStore = $6a5f6fa33a187ce0$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        keys.forEach((key)=>store.delete(key));
        return $6a5f6fa33a187ce0$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Clear all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $6a5f6fa33a187ce0$export$42ffd38884aecdac(customStore = $6a5f6fa33a187ce0$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        store.clear();
        return $6a5f6fa33a187ce0$export$b327150396135fe7(store.transaction);
    });
}
function $6a5f6fa33a187ce0$var$eachCursor(store, callback) {
    store.openCursor().onsuccess = function() {
        if (!this.result) return;
        callback(this.result);
        this.result.continue();
    };
    return $6a5f6fa33a187ce0$export$b327150396135fe7(store.transaction);
}
/**
 * Get all keys in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $6a5f6fa33a187ce0$export$ed97f33186d4b816(customStore = $6a5f6fa33a187ce0$var$defaultGetStore()) {
    return customStore('readonly', (store)=>{
        // Fast path for modern browsers
        if (store.getAllKeys) return $6a5f6fa33a187ce0$export$b327150396135fe7(store.getAllKeys());
        const items = [];
        return $6a5f6fa33a187ce0$var$eachCursor(store, (cursor)=>items.push(cursor.key)).then(()=>items);
    });
}
/**
 * Get all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $6a5f6fa33a187ce0$export$68c286be0e7e55b7(customStore = $6a5f6fa33a187ce0$var$defaultGetStore()) {
    return customStore('readonly', (store)=>{
        // Fast path for modern browsers
        if (store.getAll) return $6a5f6fa33a187ce0$export$b327150396135fe7(store.getAll());
        const items = [];
        return $6a5f6fa33a187ce0$var$eachCursor(store, (cursor)=>items.push(cursor.value)).then(()=>items);
    });
}
/**
 * Get all entries in the store. Each entry is an array of `[key, value]`.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $6a5f6fa33a187ce0$export$3e9f948b41964866(customStore = $6a5f6fa33a187ce0$var$defaultGetStore()) {
    return customStore('readonly', (store)=>{
        // Fast path for modern browsers
        // (although, hopefully we'll get a simpler path some day)
        if (store.getAll && store.getAllKeys) return Promise.all([
            $6a5f6fa33a187ce0$export$b327150396135fe7(store.getAllKeys()),
            $6a5f6fa33a187ce0$export$b327150396135fe7(store.getAll())
        ]).then(([keys, values])=>keys.map((key, i)=>[
                    key,
                    values[i]
                ]));
        const items = [];
        return customStore('readonly', (store)=>$6a5f6fa33a187ce0$var$eachCursor(store, (cursor)=>items.push([
                    cursor.key,
                    cursor.value
                ])).then(()=>items));
    });
}

});




parcelRegister("hbKGH", function(module, exports) {

$parcel$export(module.exports, "InProgressIssueInitialiser", () => $a2f3176a99cc3c67$export$ee6dd146d425cafc);

var $eJOHy = parcelRequire("eJOHy");

var $2bdtd = parcelRequire("2bdtd");

var $j3BzM = parcelRequire("j3BzM");

var $fnIeC = parcelRequire("fnIeC");

var $fLLPN = parcelRequire("fLLPN");
const $a2f3176a99cc3c67$export$ee6dd146d425cafc = ({ onRestoreTriggerIssueCreateModalState: onRestoreTriggerIssueCreateModalState, onRestoreFormContext: onRestoreFormContext, inProgressIssueID: inProgressIssueID, shouldRestore: shouldRestore, children: children })=>{
    const { init: init } = (0, $2bdtd.useInProgressIssueActions)();
    const [isInitialised, setIsInitialised] = (0, $eJOHy.useState)(false);
    const { setShouldRestore: setShouldRestore } = (0, $j3BzM.useIssueRestoreMetaActions)();
    /**
	 * We are storing initialInProgressIssue in state and passing it to IssueModalWrapper to reduce re-renders
	 * so that we don't get a re-render when the InProgressIssueController state changes
	 */ const [initialInProgressIssue, setInitialInProgressIssue] = (0, $eJOHy.useState)();
    const initialiseInProgressIssues = (0, $eJOHy.useCallback)(async ()=>{
        if (!isInitialised) {
            const inProgressIssue = await init(inProgressIssueID);
            if (shouldRestore) {
                if (inProgressIssueID && inProgressIssue) {
                    const { triggerIssueCreateModalState: triggerIssueCreateModalState, formContext: formContext } = inProgressIssue;
                    if (triggerIssueCreateModalState) onRestoreTriggerIssueCreateModalState(triggerIssueCreateModalState);
                    if (formContext) onRestoreFormContext(formContext);
                    setInitialInProgressIssue(inProgressIssue);
                }
            }
            setIsInitialised(true);
        }
    }, [
        isInitialised,
        shouldRestore,
        init,
        inProgressIssueID,
        onRestoreTriggerIssueCreateModalState,
        onRestoreFormContext
    ]);
    const setShouldRestoreForInProgressIssue = (0, $eJOHy.useCallback)((newShouldRestore)=>{
        inProgressIssueID && setShouldRestore(inProgressIssueID, newShouldRestore);
    }, [
        inProgressIssueID,
        setShouldRestore
    ]);
    (0, $eJOHy.useEffect)(()=>{
        initialiseInProgressIssues();
    }, [
        initialiseInProgressIssues
    ]);
    // transform create form props in order to set new default values
    const { onTransformCreateFormProps: onTransformCreateFormProps } = (0, $fnIeC.useRestoreFormFields)(initialInProgressIssue);
    if (!isInitialised) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fLLPN.BackgroundActions), null), children?.({
        onTransformCreateFormProps: onTransformCreateFormProps,
        setShouldRestore: setShouldRestoreForInProgressIssue
    }));
};

});
parcelRegister("fnIeC", function(module, exports) {

$parcel$export(module.exports, "useRestoreFormFields", () => $963925e795cd4152$export$c698b427f6c94ae8);

var $eJOHy = parcelRequire("eJOHy");

var $8dH3d = parcelRequire("8dH3d");

var $xMjNG = parcelRequire("xMjNG");

var $4PKlm = parcelRequire("4PKlm");

var $5HRBo = parcelRequire("5HRBo");
function $963925e795cd4152$export$c698b427f6c94ae8(initialInProgressIssue) {
    const { subscribe: subscribe } = (0, $4PKlm.useGICLifeCycleEvents)();
    const inProgressIssue = (0, $eJOHy.useRef)();
    const fieldConfig = (0, $eJOHy.useRef)();
    (0, $eJOHy.useEffect)(()=>{
        inProgressIssue.current = initialInProgressIssue;
    }, [
        initialInProgressIssue
    ]);
    const onTransformCreateFormProps = (0, $eJOHy.useCallback)((createFormProps)=>{
        if (!inProgressIssue?.current) return createFormProps;
        if (inProgressIssue?.current?.formData && (0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(fieldConfig.current)) {
            const transformedData = (0, $5HRBo.transformFieldConfigAndDirtyFieldsCurrentSession)(inProgressIssue?.current?.formData, inProgressIssue?.current?.formDataDefaultValues, createFormProps);
            fieldConfig.current = transformedData?.fieldConfig;
        }
        return {
            ...createFormProps,
            fieldConfig: fieldConfig.current || createFormProps.fieldConfig,
            classificationFieldProps: (0, $5HRBo.transformClassificationLevelFieldProps)(inProgressIssue?.current?.classificationLevelField, createFormProps?.classificationFieldProps),
            statusFieldProps: (0, $5HRBo.transformStatusFieldProps)(inProgressIssue?.current?.statusField, createFormProps?.statusFieldProps)
        };
    }, []);
    const onReset = (0, $eJOHy.useCallback)(()=>{
        inProgressIssue.current = undefined;
        fieldConfig.current = undefined;
    }, []);
    // TODO handle for multiple GIC
    (0, $eJOHy.useEffect)(()=>subscribe((0, $xMjNG.GIC_LIFECYCLE_EVENTS).MODAL_CLOSED, onReset), [
        onReset,
        subscribe
    ]);
    (0, $eJOHy.useEffect)(()=>subscribe((0, $xMjNG.GIC_LIFECYCLE_EVENTS).MODAL_DISCARD_EXISTING_IN_PROGRESS_ISSUE, onReset), [
        onReset,
        subscribe
    ]);
    (0, $eJOHy.useEffect)(()=>subscribe((0, $xMjNG.GIC_LIFECYCLE_EVENTS).PROJECT_FIELD_VALUE_CHANGE, onReset), [
        onReset,
        subscribe
    ]);
    (0, $eJOHy.useEffect)(()=>subscribe((0, $xMjNG.GIC_LIFECYCLE_EVENTS).ISSUE_TYPE_FIELD_VALUE_CHANGE, onReset), [
        onReset,
        subscribe
    ]);
    const resp = (0, $eJOHy.useMemo)(()=>({
            onTransformCreateFormProps: onTransformCreateFormProps
        }), [
        onTransformCreateFormProps
    ]);
    return resp;
}

});
parcelRegister("5HRBo", function(module, exports) {

$parcel$export(module.exports, "transformFieldConfigAndDirtyFieldsCurrentSession", () => $f8b92241965fb14e$export$9c7389800790524c);
$parcel$export(module.exports, "transformStatusFieldProps", () => $f8b92241965fb14e$export$561febabfe3c6361);
$parcel$export(module.exports, "transformClassificationLevelFieldProps", () => $f8b92241965fb14e$export$6c4d1d5181504079);
const $f8b92241965fb14e$export$9c7389800790524c = (formData, formDataDefaultValues, createFormProps)=>{
    const { fieldConfig: fieldConfig = {}, dirtyFieldsCurrentSession: dirtyFieldsCurrentSession } = createFormProps;
    const newFieldConfig = {
        ...fieldConfig
    };
    const newDirtyFieldsCurrentSession = {
        ...dirtyFieldsCurrentSession?.current || {}
    };
    if (formDataDefaultValues) // adding all default values that don't already exist to the field config - defaultValueDontTransform false
    Object.keys(formDataDefaultValues).forEach((key)=>{
        // TODO what do if fieldConfig doesn't have the key? eg schema change
        if (newFieldConfig[key]) newFieldConfig[key] = {
            ...newFieldConfig[key],
            defaultValue: formDataDefaultValues[key],
            defaultValueDontTransform: false
        };
    });
    if (formData) // adding/overwriting all changed field values to the field config - defaultValueDontTransform true
    Object.keys(formData).forEach((key)=>{
        // TODO what do if fieldConfig doesn't have the key? eg schema change
        if (newFieldConfig[key]) {
            newFieldConfig[key] = {
                ...newFieldConfig[key],
                defaultValue: formData[key],
                defaultValueDontTransform: true
            };
            newDirtyFieldsCurrentSession[key] = true;
        }
    });
    dirtyFieldsCurrentSession.current = newDirtyFieldsCurrentSession;
    return {
        fieldConfig: newFieldConfig,
        dirtyFieldsCurrentSession: dirtyFieldsCurrentSession
    };
};
const $f8b92241965fb14e$export$561febabfe3c6361 = (statusField, statusFieldProps)=>{
    if (statusField?.selectedTransition) {
        const newStatusFieldProps = {
            ...statusFieldProps
        };
        newStatusFieldProps.initialTransition = statusField.selectedTransition;
        return newStatusFieldProps;
    }
    return statusFieldProps;
};
const $f8b92241965fb14e$export$6c4d1d5181504079 = (classificationLevelField, classificationFieldProps)=>{
    if (classificationLevelField?.selectedClassification) {
        const newClassificationFieldProps = {
            ...classificationFieldProps
        };
        newClassificationFieldProps.initialClassification = classificationLevelField.selectedClassification;
        return newClassificationFieldProps;
    }
    return classificationFieldProps;
};

});


parcelRegister("fLLPN", function(module, exports) {

$parcel$export(module.exports, "BackgroundActions", () => $326cd5d4269ea740$export$30e6eb305b44f25b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $9sINg = parcelRequire("9sINg");

var $7daL6 = parcelRequire("7daL6");

var $j3BzM = parcelRequire("j3BzM");

var $796gC = parcelRequire("796gC");

var $26C5f = parcelRequire("26C5f");
const $326cd5d4269ea740$export$30e6eb305b44f25b = ()=>{
    // Initialise subscriptions
    (0, $26C5f.useInProgressIssueSubscriptions)();
    (0, $j3BzM.useIssueRestoreMetaSubscriptions)();
    (0, $9sINg.useBrowserStorageCleanup)();
    (0, $796gC.useShouldShowBrowserWarning)();
    const isSaving = (0, $7daL6.useIsIssueRestoreSaving)();
    /**
   * This invisible div is to allow cypress tests to know whether or not we are saving data
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($326cd5d4269ea740$var$InvisibleDiv, {
        "data-testid": isSaving ? 'issue-create-restore.ui.issue-restore.in-progress-initialiser.saving' : 'issue-create-restore.ui.issue-restore.in-progress-initialiser.not-saving'
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $326cd5d4269ea740$var$InvisibleDiv = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0cglyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9sINg", function(module, exports) {

$parcel$export(module.exports, "useBrowserStorageCleanup", () => $b65c19dac6858359$export$bbca530fb1561128);

var $eJOHy = parcelRequire("eJOHy");

var $jvwCK = parcelRequire("jvwCK");

var $eDBhy = parcelRequire("eDBhy");

var $xMjNG = parcelRequire("xMjNG");

var $4PKlm = parcelRequire("4PKlm");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $fBSyq = parcelRequire("fBSyq");

var $gNiyv = parcelRequire("gNiyv");

var $2bdtd = parcelRequire("2bdtd");

var $j3BzM = parcelRequire("j3BzM");

var $d0D27 = parcelRequire("d0D27");
function $b65c19dac6858359$export$95b1d08316d5a401() {
    const browserStorageCleanupService = (0, $fBSyq.useBrowserStorageCleanupService)();
    const [{ inProgressIssueMetas: inProgressIssueMetas }] = (0, $j3BzM.useIssueRestoreMeta)();
    const { setRestoreError: setRestoreError } = (0, $2bdtd.useInProgressIssueActions)();
    const sessionInProgressIssueIDs = (0, $eJOHy.useMemo)(()=>inProgressIssueMetas?.filter((item)=>item.shouldRestore).map((item)=>item.inProgressIssueID) || [], [
        inProgressIssueMetas
    ]);
    const [, { onReinsertIntoBrowserStorage: onReinsertIntoBrowserStorage }] = (0, $2bdtd.useInProgressIssue)();
    const inProgressIssueService = (0, $gNiyv.useInProgressIssueService)();
    const [isOpen] = (0, $2bdtd.useIsModalOpen)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const onModalOpened = (0, $eJOHy.useCallback)(async ({ inProgressIssueID: inProgressIssueID })=>{
        const browserStorageCleanup = await browserStorageCleanupService.getBrowserStorageCleanup() // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .catch((error)=>{
            (0, $eDBhy.fireIssueCreateErrorAnalytics)({
                meta: {
                    id: 'useBrowserStorageCleanupController',
                    packageName: 'jiraIssueCreateRestore'
                },
                error: error,
                attributes: {
                    eventName: 'onModalOpened',
                    stage: 'getBrowserStorageCleanup'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            setRestoreError && setRestoreError(error);
        });
        const newBrowserStorageCleanup = {
            ...browserStorageCleanup || {},
            inProgressIssueIDs: (0, (/*@__PURE__*/$parcel$interopDefault($jvwCK)))([
                ...browserStorageCleanup?.inProgressIssueIDs || [],
                inProgressIssueID
            ])
        };
        if (browserStorageCleanup) await browserStorageCleanupService.updateBrowserStorageCleanup(newBrowserStorageCleanup) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .catch((error)=>{
            (0, $eDBhy.fireIssueCreateErrorAnalytics)({
                meta: {
                    id: 'useBrowserStorageCleanupController',
                    packageName: 'jiraIssueCreateRestore'
                },
                error: error,
                attributes: {
                    eventName: 'onModalOpened',
                    stage: 'updateBrowserStorageCleanup'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            setRestoreError && setRestoreError(error);
        });
        else await browserStorageCleanupService.createBrowserStorageCleanup(newBrowserStorageCleanup) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .catch((error)=>{
            (0, $eDBhy.fireIssueCreateErrorAnalytics)({
                meta: {
                    id: 'useBrowserStorageCleanupController',
                    packageName: 'jiraIssueCreateRestore'
                },
                error: error,
                attributes: {
                    eventName: 'onModalOpened',
                    stage: 'createBrowserStorageCleanup'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            setRestoreError && setRestoreError(error);
        });
    }, [
        browserStorageCleanupService,
        setRestoreError
    ]);
    const onModalClosed = (0, $eJOHy.useCallback)(async ({ inProgressIssueID: inProgressIssueID })=>{
        const browserStorageCleanup = await browserStorageCleanupService.getBrowserStorageCleanup() // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .catch((error)=>{
            (0, $eDBhy.fireIssueCreateErrorAnalytics)({
                meta: {
                    id: 'useBrowserStorageCleanupController',
                    packageName: 'jiraIssueCreateRestore'
                },
                error: error,
                attributes: {
                    eventName: 'onModalClosed',
                    stage: 'getBrowserStorageCleanup'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            setRestoreError && setRestoreError(error);
        });
        if (!browserStorageCleanup) return;
        const newBrowserStorageCleanup = {
            ...browserStorageCleanup,
            inProgressIssueIDs: sessionInProgressIssueIDs.filter((id)=>id !== inProgressIssueID)
        };
        // The inProgressIssueID from the onModalClosed event will be cleaned up by the standard in-progress-issue onModalClosed
        const inProgressIssueIDsToRemove = browserStorageCleanup.inProgressIssueIDs.filter((id)=>!sessionInProgressIssueIDs.includes(id));
        await Promise.all([
            browserStorageCleanupService.updateBrowserStorageCleanup(newBrowserStorageCleanup),
            ...inProgressIssueIDsToRemove.map((id)=>inProgressIssueService.deleteInProgressIssue(id))
        ]) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .catch((error)=>{
            (0, $eDBhy.fireIssueCreateErrorAnalytics)({
                meta: {
                    id: 'useBrowserStorageCleanupController',
                    packageName: 'jiraIssueCreateRestore'
                },
                error: error,
                attributes: {
                    eventName: 'onModalClosed',
                    stage: 'promiseAll'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            setRestoreError && setRestoreError(error);
        });
        (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), 'browserStorageCleanup onModalClosed', {
            inProgressIssueIDsToRemoveLength: inProgressIssueIDsToRemove.length
        });
    }, [
        browserStorageCleanupService,
        createAnalyticsEvent,
        inProgressIssueService,
        sessionInProgressIssueIDs,
        setRestoreError
    ]);
    const onFocusWindow = (0, $eJOHy.useCallback)(async ()=>{
        if (!isOpen) return;
        // Bulk Create will need to update this for multiple
        const browserStorageCleanup = await browserStorageCleanupService.getBrowserStorageCleanup().catch((error)=>{
            (0, $eDBhy.fireIssueCreateErrorAnalytics)({
                meta: {
                    id: 'useBrowserStorageCleanupController',
                    packageName: 'jiraIssueCreateRestore'
                },
                error: error,
                attributes: {
                    eventName: 'onFocusWindow',
                    stage: 'getBrowserStorageCleanup'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            setRestoreError && setRestoreError(error);
        });
        const missingInProgressIssueIDs = browserStorageCleanup && sessionInProgressIssueIDs.length ? sessionInProgressIssueIDs.filter((id)=>!browserStorageCleanup.inProgressIssueIDs.includes(id)) : [];
        if (missingInProgressIssueIDs.length) {
            await onReinsertIntoBrowserStorage();
            const newBrowserStorageCleanup = {
                ...browserStorageCleanup,
                inProgressIssueIDs: (0, (/*@__PURE__*/$parcel$interopDefault($jvwCK)))([
                    ...browserStorageCleanup?.inProgressIssueIDs || [],
                    ...missingInProgressIssueIDs
                ])
            };
            await browserStorageCleanupService.updateBrowserStorageCleanup(newBrowserStorageCleanup) // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .catch((error)=>{
                (0, $eDBhy.fireIssueCreateErrorAnalytics)({
                    meta: {
                        id: 'useBrowserStorageCleanupController',
                        packageName: 'jiraIssueCreateRestore'
                    },
                    error: error,
                    attributes: {
                        eventName: 'onFocusWindow',
                        stage: 'updateBrowserStorageCleanup'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                setRestoreError && setRestoreError(error);
            });
        }
        if (missingInProgressIssueIDs.length) (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), 'browserStorageCleanup onFocusWindow', {
            missingInProgressIssueIDsLength: missingInProgressIssueIDs.length
        });
    }, [
        browserStorageCleanupService,
        sessionInProgressIssueIDs,
        setRestoreError,
        onReinsertIntoBrowserStorage,
        createAnalyticsEvent,
        isOpen
    ]);
    return {
        onModalOpened: onModalOpened,
        onModalClosed: onModalClosed,
        onFocusWindow: onFocusWindow
    };
}
function $b65c19dac6858359$export$bbca530fb1561128() {
    const { subscribe: subscribe } = (0, $4PKlm.useGICLifeCycleEvents)();
    const { onModalOpened: onModalOpened, onModalClosed: onModalClosed, onFocusWindow: onFocusWindow } = $b65c19dac6858359$export$95b1d08316d5a401();
    (0, $eJOHy.useEffect)(()=>subscribe((0, $xMjNG.GIC_LIFECYCLE_EVENTS).MODAL_OPENED, onModalOpened), [
        onModalOpened,
        subscribe
    ]);
    (0, $eJOHy.useEffect)(()=>subscribe((0, $xMjNG.GIC_LIFECYCLE_EVENTS).MODAL_CLOSED, onModalClosed), [
        onModalClosed,
        subscribe
    ]);
    (0, $d0D27.useOnWindowFocus)(onFocusWindow);
}

});
parcelRegister("fBSyq", function(module, exports) {

$parcel$export(module.exports, "useBrowserStorageCleanupService", () => $5616da81639be8b3$export$7129d99907775838);

var $eJOHy = parcelRequire("eJOHy");

var $fclB9 = parcelRequire("fclB9");

const $5616da81639be8b3$var$KEY = 'browser-storage-cleanup';
const $5616da81639be8b3$export$7129d99907775838 = ()=>{
    const [storage] = (0, $eJOHy.useState)((0, $fclB9.createIndexedDBStorageProvider)(`${(0, $156089ffb832620f$export$8fa5032778cf7801)}${$5616da81639be8b3$var$KEY}`, {
        shouldAutoReconnect: true
    }));
    return {
        getBrowserStorageCleanup: async ()=>storage.get($5616da81639be8b3$var$KEY),
        createBrowserStorageCleanup: async (data)=>{
            await storage.set($5616da81639be8b3$var$KEY, data);
            return data;
        },
        updateBrowserStorageCleanup: async (data)=>{
            await storage.set($5616da81639be8b3$var$KEY, data);
            return data;
        },
        deleteBrowserStorageCleanup: async ()=>{
            await storage.remove($5616da81639be8b3$var$KEY);
        }
    };
};

});

parcelRegister("d0D27", function(module, exports) {

$parcel$export(module.exports, "useOnWindowFocus", () => $fea832e6f554f582$export$921321d14c966d8f);

var $eJOHy = parcelRequire("eJOHy");
function $fea832e6f554f582$export$921321d14c966d8f(onFocus) {
    const onVisibilityChange = (0, $eJOHy.useCallback)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (document.visibilityState === 'visible') onFocus();
    }, [
        onFocus
    ]);
    (0, $eJOHy.useEffect)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (window?.addEventListener) {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.addEventListener('visibilitychange', onVisibilityChange, false);
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.addEventListener('focus', onFocus, false);
        }
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            if (window?.removeEventListener) {
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                window.removeEventListener('visibilitychange', onVisibilityChange);
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                window.removeEventListener('focus', onFocus);
            }
        };
    });
}

});


parcelRegister("7daL6", function(module, exports) {

$parcel$export(module.exports, "useIsIssueRestoreSaving", () => $4ff7f754fc0647d9$export$c3cd53fd21626217);

var $2bdtd = parcelRequire("2bdtd");

var $j3BzM = parcelRequire("j3BzM");
const $4ff7f754fc0647d9$export$c3cd53fd21626217 = ()=>{
    const [{ isSavingCounter: isSavingCounterInProgressIssue }] = (0, $2bdtd.useInProgressIssue)();
    const [{ isSavingCounter: isSavingCounterIssueRestoreMeta }] = (0, $j3BzM.useIssueRestoreMeta)();
    return !(isSavingCounterInProgressIssue === 0 && isSavingCounterIssueRestoreMeta === 0);
};

});

parcelRegister("796gC", function(module, exports) {

$parcel$export(module.exports, "useShouldShowBrowserWarning", () => $c8a2b585931eddfd$export$b44a00b70df66767);

var $eKEzo = parcelRequire("eKEzo");

var $2bdtd = parcelRequire("2bdtd");

var $7daL6 = parcelRequire("7daL6");

var $gfYUE = parcelRequire("gfYUE");
const $c8a2b585931eddfd$export$b44a00b70df66767 = ()=>{
    const [isModalOpen] = (0, $2bdtd.useIsModalOpen)();
    const [isFormDirty] = (0, $2bdtd.useIsFormDirty)();
    const isFormSavingIssueRestore = (0, $7daL6.useIsIssueRestoreSaving)();
    const hasRestoreFailed = (0, $eKEzo.useHasRestoreFailed)();
    const shouldForceBlock = isModalOpen && (hasRestoreFailed || isFormSavingIssueRestore);
    (0, $gfYUE.useNavigationBlock)({
        forceBlock: shouldForceBlock,
        shouldAttemptNavigationBlock: Boolean(isModalOpen && isFormDirty)
    });
};

});
parcelRegister("eKEzo", function(module, exports) {

$parcel$export(module.exports, "useHasRestoreFailed", () => $4e7adbebff7b3a94$export$2f3853c4298a8e98);

var $2bdtd = parcelRequire("2bdtd");

var $j3BzM = parcelRequire("j3BzM");
const $4e7adbebff7b3a94$export$2f3853c4298a8e98 = ()=>{
    const [{ restoreError: restoreError }] = (0, $2bdtd.useInProgressIssue)();
    const [{ restoreMetaError: restoreMetaError }] = (0, $j3BzM.useIssueRestoreMeta)();
    return Boolean(restoreError || restoreMetaError);
};

});

parcelRegister("gfYUE", function(module, exports) {

$parcel$export(module.exports, "useNavigationBlock", () => $942f5a969da4a079$export$6948be8e76411f59);
/**
 * See https://hello.atlassian.net/wiki/spaces/JSDee/pages/2143585806/Faux+Spa+-+Closing+the+tab
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");
function $942f5a969da4a079$var$isSameOrigin(destination) {
    const destinationOrigin = new URL(destination).origin;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.location.origin === destinationOrigin;
}
const $942f5a969da4a079$var$useIsSameOriginNavigationAPI = ({ isNavigatingWithinSameOrigin: isNavigatingWithinSameOrigin, isEnabled: isEnabled })=>{
    const onNavigate = (0, $eJOHy.useCallback)((e)=>{
        if (e.destination.sameDocument) // when we navigate through the same document (spa -> spa) onBeforeUnload won't be called, so we can instead reset isNavigatingWithinSameOrigin
        // eslint-disable-next-line no-param-reassign, react-hooks/react-compiler
        isNavigatingWithinSameOrigin.current = false; // reset
        else // eslint-disable-next-line no-param-reassign
        isNavigatingWithinSameOrigin.current = $942f5a969da4a079$var$isSameOrigin(e.destination.url);
        return isNavigatingWithinSameOrigin.current;
    }, [
        isNavigatingWithinSameOrigin
    ]);
    (0, $eJOHy.useEffect)(()=>{
        // only available in newer versions of chrome, opera, and edge
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        const { navigation: navigation } = window;
        if (isEnabled && navigation) {
            navigation.addEventListener('navigate', onNavigate);
            return ()=>navigation.removeEventListener('navigate', onNavigate);
        }
        return undefined;
    }, [
        isEnabled,
        onNavigate
    ]);
    // for testing
    return {
        onNavigate: onNavigate
    };
};
const $942f5a969da4a079$export$6948be8e76411f59 = ({ forceBlock: forceBlock = false, shouldAttemptNavigationBlock: shouldAttemptNavigationBlock })=>{
    const isNavigatingWithinSameOrigin = (0, $eJOHy.useRef)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    const hasNavigationApi = Boolean(window.navigation);
    const { onNavigate: onNavigate } = $942f5a969da4a079$var$useIsSameOriginNavigationAPI({
        isEnabled: hasNavigationApi,
        isNavigatingWithinSameOrigin: isNavigatingWithinSameOrigin
    });
    const onBeforeUnload = (0, $eJOHy.useCallback)((e)=>{
        const analyticsPayload = {
            hasNavigationApi: hasNavigationApi,
            forceBlock: forceBlock,
            isNavigatingWithinSameOrigin: isNavigatingWithinSameOrigin.current,
            shouldAttemptNavigationBlock: shouldAttemptNavigationBlock
        };
        const shouldBlockNavigation = forceBlock || shouldAttemptNavigationBlock && !isNavigatingWithinSameOrigin.current;
        isNavigatingWithinSameOrigin.current = false; // reset
        if (shouldBlockNavigation) {
            (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), 'useNavigationBlock showBrowserUnloadPrompt', analyticsPayload);
            e.preventDefault(); // Firefox
            const message = '';
            // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'boolean'.
            e.returnValue = message; // Chrome
            return message; // IE
        }
        (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), 'useNavigationBlock dontShowBrowserUnloadPrompt', analyticsPayload);
        return undefined;
    }, [
        createAnalyticsEvent,
        forceBlock,
        hasNavigationApi,
        shouldAttemptNavigationBlock
    ]);
    /**
	 * Note: beforeunload will not block user closing the tab if
	 * the user has not interacted with the page
	 */ (0, $eJOHy.useEffect)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('beforeunload', onBeforeUnload);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        return ()=>window.removeEventListener('beforeunload', onBeforeUnload);
    }, [
        onBeforeUnload
    ]);
    /**
	 * Returning these functions to expose them for unit testing
	 */ return {
        onBeforeUnload: onBeforeUnload,
        onNavigate: onNavigate
    };
};

});


parcelRegister("26C5f", function(module, exports) {

$parcel$export(module.exports, "useInProgressIssueSubscriptions", () => $823133199b744e92$export$9b41c2cd5817917a);

var $eJOHy = parcelRequire("eJOHy");

var $6DCNy = parcelRequire("6DCNy");

var $xMjNG = parcelRequire("xMjNG");

var $4PKlm = parcelRequire("4PKlm");

var $eKEzo = parcelRequire("eKEzo");

var $2bdtd = parcelRequire("2bdtd");
const $823133199b744e92$var$THROTTLE_DELAY = 250;
const $823133199b744e92$export$9b41c2cd5817917a = ()=>{
    const [, { onFormFieldUpdate: onFormFieldUpdate, onModalOpened: onModalOpened, onModalClosed: onModalClosed, onModalDiscardExistingInProgressIssue: onModalDiscardExistingInProgressIssue, onFormContextUpdate: onFormContextUpdate, onTriggerIssueCreateModalStateChange: onTriggerIssueCreateModalStateChange, onStatusFieldChange: onStatusFieldChange, onClassificationLevelFieldChange: onClassificationLevelFieldChange, onResetFormFieldsForCreateAnother: onResetFormFieldsForCreateAnother, onFormFieldConfigUpdate: onFormFieldConfigUpdate, onIssueTypeChange: onIssueTypeChange, onProjectFieldChange: onProjectFieldChange }] = (0, $2bdtd.useInProgressIssue)();
    const hasRestoreFailed = (0, $eKEzo.useHasRestoreFailed)();
    const shouldSubscribe = !hasRestoreFailed;
    const { subscribe: subscribe } = (0, $4PKlm.useGICLifeCycleEvents)();
    const throttledOnFormFieldUpdate = (0, $eJOHy.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($6DCNy)))(onFormFieldUpdate, $823133199b744e92$var$THROTTLE_DELAY, {
            leading: true,
            trailing: true
        }), [
        onFormFieldUpdate
    ]);
    (0, $eJOHy.useEffect)(()=>shouldSubscribe ? subscribe((0, $xMjNG.GIC_LIFECYCLE_EVENTS).CREATE_FORM_FIELD_VALUE_CHANGE, throttledOnFormFieldUpdate) : undefined, [
        throttledOnFormFieldUpdate,
        subscribe,
        shouldSubscribe
    ]);
    (0, $eJOHy.useEffect)(()=>shouldSubscribe ? subscribe((0, $xMjNG.GIC_LIFECYCLE_EVENTS).FORM_CONTEXT_STATE_CHANGE, onFormContextUpdate) : undefined, [
        onFormContextUpdate,
        subscribe,
        shouldSubscribe
    ]);
    (0, $eJOHy.useEffect)(()=>shouldSubscribe ? subscribe((0, $xMjNG.GIC_LIFECYCLE_EVENTS).MODAL_OPENED, onModalOpened) : undefined, [
        onModalOpened,
        subscribe,
        shouldSubscribe
    ]);
    (0, $eJOHy.useEffect)(()=>shouldSubscribe ? subscribe((0, $xMjNG.GIC_LIFECYCLE_EVENTS).MODAL_CLOSED, onModalClosed) : undefined, [
        onModalClosed,
        shouldSubscribe,
        subscribe
    ]);
    (0, $eJOHy.useEffect)(()=>shouldSubscribe ? subscribe((0, $xMjNG.GIC_LIFECYCLE_EVENTS).RESET_FORM_FIELDS_FOR_CREATE_ANOTHER, onResetFormFieldsForCreateAnother) : undefined, [
        onResetFormFieldsForCreateAnother,
        subscribe,
        shouldSubscribe
    ]);
    (0, $eJOHy.useEffect)(()=>{
        shouldSubscribe ? subscribe((0, $xMjNG.GIC_LIFECYCLE_EVENTS).USE_TRIGGER_ISSUE_CREATE_MODAL_STATE_CHANGE, onTriggerIssueCreateModalStateChange) : undefined;
    }, [
        onTriggerIssueCreateModalStateChange,
        subscribe,
        shouldSubscribe
    ]);
    (0, $eJOHy.useEffect)(()=>shouldSubscribe ? subscribe((0, $xMjNG.GIC_LIFECYCLE_EVENTS).STATUS_FIELD_STATE_CHANGE, onStatusFieldChange) : undefined, [
        onStatusFieldChange,
        subscribe,
        shouldSubscribe
    ]);
    (0, $eJOHy.useEffect)(()=>shouldSubscribe ? subscribe((0, $xMjNG.GIC_LIFECYCLE_EVENTS).CLASSIFICATION_LEVEL_FIELD_CHANGE, onClassificationLevelFieldChange) : undefined, [
        onClassificationLevelFieldChange,
        subscribe,
        shouldSubscribe
    ]);
    (0, $eJOHy.useEffect)(()=>shouldSubscribe ? subscribe((0, $xMjNG.GIC_LIFECYCLE_EVENTS).CREATE_FORM_FIELD_CONFIG_UPDATE, onFormFieldConfigUpdate) : undefined, [
        onFormFieldConfigUpdate,
        subscribe,
        shouldSubscribe
    ]);
    (0, $eJOHy.useEffect)(()=>shouldSubscribe ? subscribe((0, $xMjNG.GIC_LIFECYCLE_EVENTS).ISSUE_TYPE_FIELD_VALUE_CHANGE, onIssueTypeChange) : undefined, [
        onIssueTypeChange,
        subscribe,
        shouldSubscribe
    ]);
    (0, $eJOHy.useEffect)(()=>shouldSubscribe ? subscribe((0, $xMjNG.GIC_LIFECYCLE_EVENTS).PROJECT_FIELD_VALUE_CHANGE, onProjectFieldChange) : undefined, [
        onProjectFieldChange,
        subscribe,
        shouldSubscribe
    ]);
    (0, $eJOHy.useEffect)(()=>shouldSubscribe ? subscribe((0, $xMjNG.GIC_LIFECYCLE_EVENTS).MODAL_DISCARD_EXISTING_IN_PROGRESS_ISSUE, onModalDiscardExistingInProgressIssue) : undefined, [
        onModalDiscardExistingInProgressIssue,
        shouldSubscribe,
        subscribe
    ]);
};

});



parcelRegister("h39xx", function(module, exports) {

$parcel$export(module.exports, "isIndexedDBAvailable", () => $89f00530d5289d1b$export$3865db50535c2055);
function $89f00530d5289d1b$export$3865db50535c2055() {
    try {
        // Do a indexedDB.databases check for Firefox incognito (indexedDB will exist but fail to open databases)
        return Boolean('indexedDB' in window) && Boolean(indexedDB?.databases());
    } catch (e) {
        return false;
    }
}

});


parcelRegister("8ivLn", function(module, exports) {

$parcel$export(module.exports, "useIsEmbedded", () => $c2eb960aef4b180e$export$77140ffa938f9fd1);

var $gCY1z = parcelRequire("gCY1z");
const $c2eb960aef4b180e$export$77140ffa938f9fd1 = ()=>{
    const [{ location: { pathname: pathname } }] = (0, $gCY1z.useRouter)();
    return pathname.endsWith('/embed');
};

});


parcelRegister("gyxWD", function(module, exports) {

$parcel$export(module.exports, "default", () => $14ca63a54abf4ed1$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8dH3d = parcelRequire("8dH3d");

var $aXKmr = parcelRequire("aXKmr");

var $gjeS9 = parcelRequire("gjeS9");

var $eDBhy = parcelRequire("eDBhy");

var $7jTnu = parcelRequire("7jTnu");

var $hrodw = parcelRequire("hrodw");
var $bILK0 = parcelRequire("bILK0");

var $6hw9S = parcelRequire("6hw9S");

var $21XCU = parcelRequire("21XCU");

var $hGlZi = parcelRequire("hGlZi");

var $bVObd = parcelRequire("bVObd");


var $3UrQk = parcelRequire("3UrQk");

var $5PjYq = parcelRequire("5PjYq");

var $2lqpf = parcelRequire("2lqpf");

var $6M13s = parcelRequire("6M13s");

var $xMjNG = parcelRequire("xMjNG");

var $4PKlm = parcelRequire("4PKlm");

var $jQUoP = parcelRequire("jQUoP");

var $fYeTG = parcelRequire("fYeTG");

var $f7Yza = parcelRequire("f7Yza");

var $bitlK = parcelRequire("bitlK");

var $jipjz = parcelRequire("jipjz");

var $hBHUL = parcelRequire("hBHUL");

var $hih5V = parcelRequire("hih5V");

var $4xbv3 = parcelRequire("4xbv3");
var $gCeeo = parcelRequire("gCeeo");
var $8Plmb = parcelRequire("8Plmb");
var $ftN6c = parcelRequire("ftN6c");

var $2aY2d = parcelRequire("2aY2d");

var $80UiT = parcelRequire("80UiT");

var $RxDRv = parcelRequire("RxDRv");

var $lvKO5 = parcelRequire("lvKO5");

var $2U3xv = parcelRequire("2U3xv");

var $50UkK = parcelRequire("50UkK");

var $epTsa = parcelRequire("epTsa");

var $gtCj5 = parcelRequire("gtCj5");

var $dSpUw = parcelRequire("dSpUw");

var $19IK4 = parcelRequire("19IK4");

var $c3eoY = parcelRequire("c3eoY");

var $cFxTI = parcelRequire("cFxTI");

var $73QLY = parcelRequire("73QLY");

var $9DD83 = parcelRequire("9DD83");

var $6u3jg = parcelRequire("6u3jg");

var $5mlja = parcelRequire("5mlja");

var $fV6Ej = parcelRequire("fV6Ej");

var $7ZURF = parcelRequire("7ZURF");

var $fbTM0 = parcelRequire("fbTM0");

var $9QRTY = parcelRequire("9QRTY");

var $lwTSQ = parcelRequire("lwTSQ");

var $lHs35 = parcelRequire("lHs35");

var $9H0bo = parcelRequire("9H0bo");

var $bbvEo = parcelRequire("bbvEo");

var $jQAhS = parcelRequire("jQAhS");

var $8xFHy = parcelRequire("8xFHy");

var $cyr99 = parcelRequire("cyr99");

var $70BpF = parcelRequire("70BpF");

var $jldA8 = parcelRequire("jldA8");

var $ibQsy = parcelRequire("ibQsy");

var $7caPf = parcelRequire("7caPf");
const $14ca63a54abf4ed1$var$DisabledRestoreNavigationPrompt = ({ setShouldRestore: setShouldRestore })=>{
    const [{ deferredNavigationLink: deferredNavigationLink }, { setDeferredNavigationLink: setDeferredNavigationLink }] = (0, $5mlja.useNavigationDiscardChanges)();
    const [{ isFormDirty: isFormDirty }] = (0, $jQUoP.useFormContext)();
    const onConfirmHandler = (0, $eJOHy.useCallback)(()=>{
        setShouldRestore && setShouldRestore(false);
    }, [
        setShouldRestore
    ]);
    const onCancelHandler = (0, $eJOHy.useCallback)(()=>{
        setDeferredNavigationLink('');
    }, [
        setDeferredNavigationLink
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f7Yza.ModalEntryPointPressableTrigger), {
        entryPoint: (0, $19IK4.navigationDiscardChangesPromptEntrypoint),
        entryPointProps: {
            navigateLink: isFormDirty ? deferredNavigationLink : '',
            onConfirm: onConfirmHandler,
            onCancel: onCancelHandler
        },
        interactionName: "navigateWithoutRestorePrompt",
        useInternalModal: false
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jldA8.NavigateWithoutRestorePrompt), {
            setShouldRestore: setShouldRestore,
            ref: ref
        }));
};
const $14ca63a54abf4ed1$var$DismissModalEntryPointWrapper = ({ children: children, entryPointProps: entryPointProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f7Yza.ModalEntryPointPressableTrigger), {
        entryPoint: (0, $lHs35.createIssueDismissModalEntryPoint),
        entryPointProps: entryPointProps,
        interactionName: "create-issue-dismiss-modal",
        modalProps: {
            width: 'small'
        },
        useInternalModal: true
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ref: ref
        }, children));
const $14ca63a54abf4ed1$var$CreateModal = ({ onTransformCreateFormProps: onTransformCreateFormProps, setShouldRestore: setShouldRestore, onResetApolloCache: onResetApolloCache })=>{
    const sessionIdRef = (0, $eJOHy.useRef)((0, $aXKmr.v4)());
    const [{ payload: triggerIssueCreatePayload, displayOnlyRequiredFields: displayOnlyRequiredFields, disableCreationSuccessFlag: disableCreationSuccessFlag, isSubTaskCreationOpen: isSubTaskCreationOpen, isCreateLinkedIssue: isCreateLinkedIssue = false, isModalLoadInContext: isModalLoadInContext, triggerPointKey: triggerPointKey, interactedWithModalChangerButtons: interactedWithModalChangerButtons, inProgressIssueID: inProgressIssueID, sessionId: sessionId, wasStateRestored: wasStateRestored, isCustomBoardWithIcc: isCustomBoardWithIcc, jqlSwimlaneId: jqlSwimlaneId, swimlaneMode: swimlaneMode, ecosystemCallback: ecosystemCallback, product: product, actionSource: actionSource, triggeredViaHotKey: triggeredViaHotKey }, { setSessionId: setSessionId }] = (0, $jipjz.useTriggerIssueCreateModal)();
    (0, $eJOHy.useEffect)(()=>{
        if (!sessionId) setSessionId(sessionIdRef.current);
    }, [
        sessionId,
        setSessionId
    ]);
    const { showEnforcementIfPendingToShow: showEnforcementIfPendingToShow } = (0, $RxDRv.useStorageEnforcement)();
    const [{ isLoading: isModalLoading, fieldConfig: modalFieldConfig, fieldTabs: modalFieldTabs, contextFields: modalContextFields, meta: modalFieldsDataMeta, error: modalFieldsDataError, apiLatency: modalApiLatency, additionalServices: modalAdditionalServices }, fetchModalConfig] = (0, $lwTSQ.default)({
        displayOnlyRequiredFields: displayOnlyRequiredFields,
        triggerPointKey: triggerPointKey,
        isSubTaskCreationOpen: isSubTaskCreationOpen,
        triggerIssueCreatePayload: triggerIssueCreatePayload,
        isModalLoadInContext: isModalLoadInContext,
        ...(0, $7jTnu.fg)('create_linked_issues_trigger_point_issue_view') ? {
            isCreateLinkedIssue: isCreateLinkedIssue
        } : {}
    });
    const classificationFieldId = Object.keys(modalFieldConfig).find((key)=>modalFieldConfig[key].gqlType === 'JiraDataClassificationField');
    const classificationFieldConfig = classificationFieldId ? modalFieldConfig[classificationFieldId] : undefined;
    const proformaConfiguration = modalAdditionalServices?.proformaConfiguration;
    const { publish: publish } = (0, $4PKlm.useGICLifeCycleEvents)();
    const dirtyFieldsCurrentSession = (0, $eJOHy.useRef)({});
    const getFormState = (0, $eJOHy.useRef)(()=>null);
    const { data: projectContext } = (0, $2aY2d.useProjectContext)();
    const [{ isSubmitting: isSubmitting, isOperationInProgress: isOperationInProgress, shouldShowConfigureFieldModal: shouldShowConfigureFieldModal, shouldShowFindFieldModal: shouldShowFindFieldModal, selectedProject: selectedProject, selectedIssueType: selectedIssueType, meta: meta, dataFetchError: dataFetchError, isFormDirty: isCreateFormDirty, canCreateAnotherIssue: canCreateAnotherIssue, createdIssues: createdIssues }, { resetFormContext: resetFormContext, toggleConfigureFieldsModalVisibility: toggleConfigureFieldsModalVisibility, toggleFindFieldsModalVisibility: toggleFindFieldsModalVisibility, setAreConfiguredFieldsModified: setAreConfiguredFieldsModified, setForgeModules: setForgeModules, setCurrentActiveTabIndex: setCurrentActiveTabIndex, setCanCreateAnotherIssue: setCanCreateAnotherIssue, addCreatedIssue: addCreatedIssue }] = (0, $jQUoP.useFormContext)();
    const [, { resetState: resetState }] = (0, $6hw9S.useInlineFieldsActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const isGICPositioningEnabled = (0, $6u3jg.useIsGICPositioningEnabled)();
    const { withMachineLearning: withMachineLearning } = (0, $73QLY.useSmartFieldsMachineLearning)();
    const shouldDisableActions = dataFetchError !== null;
    (0, $eJOHy.useEffect)(()=>{
        if (shouldDisableActions && setShouldRestore) {
            if (selectedProject === null) {
                const analyticsEvent = createAnalyticsEvent({
                    actionSubject: 'noselectedproject',
                    action: 'error'
                });
                (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'createIssueViewError');
            }
            setShouldRestore(false);
        }
    }, [
        shouldDisableActions,
        setShouldRestore,
        selectedProject,
        createAnalyticsEvent
    ]);
    const initFetchConfig = (0, $eJOHy.useCallback)(()=>{
        // ideally the change should be for all queries, but limitting the scope of change for now. The variable is defaulted to "STANDARD" in the BE.
        const issueCreateType = isCreateLinkedIssue && isModalLoadInContext && (0, $7jTnu.fg)('create_linked_issues_trigger_point_issue_view') ? {
            issueCreateType: isCreateLinkedIssue ? (0, $3UrQk.ISSUE_CREATE_TYPE).linkedIssue : (0, $3UrQk.ISSUE_CREATE_TYPE).standard
        } : {};
        if (!triggerIssueCreatePayload) fetchModalConfig({
            variables: (0, $bbvEo.getQueryVariables)((0, $bbvEo.getIssueCreateProjectForMount)(projectContext), null)
        });
        else {
            const { customFieldsToPreserveOnFormRecreation: customFieldsToPreserveOnFormRecreation = [], ...mainPayload } = triggerIssueCreatePayload;
            const parentId = mainPayload.parentId || null;
            const additionalContext = mainPayload.additionalContext || null;
            const projectPayload = (0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(mainPayload.project) ? null : mainPayload.project;
            fetchModalConfig({
                variables: {
                    project: projectPayload,
                    issueType: mainPayload.issueType || null,
                    requestType: mainPayload.requestType || null,
                    defaultValues: mainPayload.defaultValues || null,
                    issueTypes: mainPayload.issueTypes || null,
                    requestTypes: mainPayload.requestTypes || null,
                    parentId: parentId,
                    additionalContext: additionalContext,
                    ...issueCreateType
                }
            });
            dirtyFieldsCurrentSession.current = {
                ...dirtyFieldsCurrentSession.current,
                ...Object.fromEntries(// eslint-disable-next-line @typescript-eslint/no-explicit-any
                customFieldsToPreserveOnFormRecreation.map((k)=>[
                        k,
                        true
                    ]))
            };
        }
    }, [
        isCreateLinkedIssue,
        isModalLoadInContext,
        triggerIssueCreatePayload,
        fetchModalConfig,
        projectContext
    ]);
    const [{ siteDomain: siteDomain, selectedCloudId: selectedCloudId }] = (0, $bitlK.useSitePickerContext)();
    const [{ isLoading: isTransitionsLoading, error: transitionsError, transitions: transitions }, fetchTransitions] = (0, $9QRTY.default)();
    const shouldShowStatus = (0, $eJOHy.useMemo)(()=>(0, $bbvEo.shouldShowStatusField)(selectedProject?.projectType, modalFieldConfig), [
        selectedProject,
        modalFieldConfig
    ]);
    const { resetAndReloadCreateForm: resetAndReloadCreateForm } = (0, $7ZURF.useIssueCreateFromAnywhereContext)();
    const refetchTransitions = (0, $eJOHy.useCallback)(async ()=>{
        if (shouldShowStatus && selectedProject && selectedIssueType && !resetAndReloadCreateForm) await fetchTransitions({
            projectId: selectedProject.value,
            issueTypeId: selectedIssueType.type === (0, $4246188a36de9908$export$92ab80c1dc9baf44) ? selectedIssueType.issueTypeId : selectedIssueType.value,
            selectedCloudId: selectedCloudId
        });
    }, [
        fetchTransitions,
        resetAndReloadCreateForm,
        selectedCloudId,
        selectedIssueType,
        selectedProject,
        shouldShowStatus
    ]);
    (0, $eJOHy.useEffect)(()=>{
        refetchTransitions();
    }, [
        fetchTransitions,
        selectedProject,
        selectedIssueType,
        shouldShowStatus,
        selectedCloudId,
        resetAndReloadCreateForm,
        refetchTransitions
    ]);
    const extraContext = (0, $eJOHy.useMemo)(()=>({
            issueType: selectedIssueType?.label,
            projectKey: selectedProject?.projectKey,
            classificationTags: selectedProject?.classificationTags
        }), [
        selectedProject,
        selectedIssueType
    ]);
    const { customFields: customFields, filteredOutModules: filteredOutModules, loadingStatus: loadingStatus } = (0, $fbTM0.useFetchForgeModules)(extraContext);
    const hasForgeFinishedLoading = loadingStatus === 'success' || loadingStatus === 'error';
    (0, $eJOHy.useEffect)(()=>{
        if (selectedProject && selectedIssueType) setForgeModules(customFields, filteredOutModules, hasForgeFinishedLoading);
    }, [
        setForgeModules,
        customFields,
        hasForgeFinishedLoading,
        filteredOutModules,
        selectedProject,
        selectedIssueType,
        shouldShowStatus
    ]);
    const [showIssuesCreated, setShowIssuesCreated] = (0, $eJOHy.useState)(false);
    const isApiCallTriggered = (0, $eJOHy.useRef)(false);
    if (!isApiCallTriggered.current) {
        initFetchConfig();
        inProgressIssueID && publish((0, $xMjNG.GIC_LIFECYCLE_EVENTS).MODAL_OPENED, {
            inProgressIssueID: inProgressIssueID
        });
        const restoredCreatedIssuesExists = createdIssues?.length > 0;
        restoredCreatedIssuesExists && setShowIssuesCreated(restoredCreatedIssuesExists);
        isApiCallTriggered.current = true;
    }
    const [{ globalEventNamespaces: globalEventNamespaces, fieldsToAddInPublishedData: fieldsToAddInPublishedData, alertsToBeLinked: alertsToBeLinked, onIssueCreate: onIssueCreate, onSiteSelection: onSiteSelection, onProjectSelection: onProjectSelection, onClose: onClose, displayCreateAnotherIssueToggle: displayCreateAnotherIssueToggle, callbackPayload: callbackPayload, triggerButtonRef: triggerButtonRef }, { closeIssueCreateModal: closeIssueCreateModal }] = (0, $jipjz.useTriggerIssueCreateModal)();
    const route = (0, $hih5V.useCurrentRoute)();
    const isCompanyManagedBoard = route?.name === 'rapidboard-board' || route?.name === 'rapidboard-board-settings' || route?.name === 'rapidboard-user-board' || route?.name === 'rapidboard-user-board-settings' || route?.name === 'servicedesk-boards';
    const isCompanyManagedBacklog = route?.name === 'rapidboard-backlog';
    const isCompanyManagedBoardOrBacklog = (0, $7jTnu.fg)('show-create-success-flag-once-in-backlog-page') ? isCompanyManagedBoard || isCompanyManagedBacklog : isCompanyManagedBoard;
    const closeIssueCreateModalNew = (0, $eJOHy.useCallback)((issuesCreated)=>{
        closeIssueCreateModal(Boolean(issuesCreated?.length));
        inProgressIssueID && publish((0, $xMjNG.GIC_LIFECYCLE_EVENTS).MODAL_CLOSED, {
            callbackPayload: callbackPayload,
            inProgressIssueID: inProgressIssueID,
            createdIssues: issuesCreated
        });
        if (isCompanyManagedBoardOrBacklog && (0, $7jTnu.fg)('fix-gryf-a11y-issues-2')) setTimeout(()=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, jira/jira-ssr/no-unchecked-globals-usage
            const activeElement = document.activeElement;
            if (activeElement) activeElement.blur();
        }, 0);
    }, [
        callbackPayload,
        closeIssueCreateModal,
        inProgressIssueID,
        isCompanyManagedBoardOrBacklog,
        publish
    ]);
    if (isGICPositioningEnabled()) {
        // combine hook with above when cleaning up gic-refetch-on-discard_cxard
        const [{ shouldInitFetchConfig: shouldInitFetchConfig }, { resetShouldInitFetchConfig: resetShouldInitFetchConfig }] = // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $jipjz.useTriggerIssueCreateModal)();
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $eJOHy.useEffect)(()=>{
            if (shouldInitFetchConfig || resetAndReloadCreateForm) {
                resetShouldInitFetchConfig();
                initFetchConfig();
            }
        }, [
            initFetchConfig,
            resetShouldInitFetchConfig,
            shouldInitFetchConfig,
            resetAndReloadCreateForm
        ]);
    }
    (0, $eJOHy.useEffect)(()=>{
        if (resetAndReloadCreateForm) resetFormContext();
    }, [
        resetAndReloadCreateForm,
        resetFormContext
    ]);
    const sourceThatFiredModalDismiss = (0, $eJOHy.useRef)(null);
    const [objectId, setObjectId] = (0, $eJOHy.useState)(undefined);
    const { showFlag: showFlag } = (0, $bILK0.useFlagsService)();
    const showSuccessFlag = (0, $eJOHy.useCallback)((issueList, successFlagParams)=>{
        if (issueList?.length && !disableCreationSuccessFlag) {
            const flagId = (0, $hrodw.toFlagId)((0, $aXKmr.v4)());
            const issueDiscoveryUrl = (0, $cFxTI.getIssueDiscoveryUrl)(issueList);
            showFlag({
                id: flagId,
                render: (flagProps)=>{
                    const successFlagProps = {
                        key: flagProps.key,
                        flagKey: flagProps.key,
                        id: flagId,
                        issueList: issueList,
                        issueDiscoveryUrl: issueDiscoveryUrl
                    };
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ibQsy.default), {
                        ...successFlagProps,
                        successFlagParams: successFlagParams
                    });
                }
            });
            const analyticsEvent = createAnalyticsEvent({
                actionSubject: 'flag',
                action: 'viewed'
            });
            (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'createIssueSuccessNotification');
            if ((0, $7jTnu.fg)('fix-gryf-a11y-issues-2')) setTimeout(()=>{
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage, @typescript-eslint/consistent-type-assertions
                const succeessFlagDismissButton = document.querySelector('[data-testid="platform.ui.flags.common.ui.common-flag-v2-dismiss"]');
                succeessFlagDismissButton?.focus();
            }, 0);
        }
    }, [
        createAnalyticsEvent,
        disableCreationSuccessFlag,
        showFlag
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const api = {
            // @ts-expect-error - TS7006 - Parameter 'params' implicitly has an 'any' type.
            renderSuccessFlag: (params)=>{
                // @ts-expect-error - TS7006 - Parameter 'issue' implicitly has an 'any' type.
                const issueList = params.issues.map((issue)=>({
                        issueId: issue.issueId,
                        issueKey: issue.issueKey
                    }));
                (0, $bVObd.successFlagDisplay).stop();
                showSuccessFlag(issueList, params);
            }
        };
        if (isCompanyManagedBoardOrBacklog) // eslint-disable-next-line jira/wrm/no-load-bridge
        (0, $gjeS9.loadBridge)({
            name: 'jira-agile/rapid/ui/gic-success-flag/bridge'
        }).then((bridge)=>// @ts-expect-error - TS2571 - Object is of type 'unknown'.
            bridge(api));
    }, [
        showSuccessFlag,
        isCompanyManagedBoardOrBacklog
    ]);
    // combine this with above when cleaning up gic.positioning
    const [{ minimizableModalView: minimizableModalView }] = isGICPositioningEnabled() ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jipjz.useTriggerIssueCreateModal)() : [
        {
            minimizableModalView: undefined
        }
    ];
    const [{ shouldPushMiniModalDiscoverability: shouldPushMiniModalDiscoverability }] = (0, $jipjz.useTriggerIssueCreateModal)();
    const { updateView: updateView } = (0, $80UiT.usePersistentIssueCreateModalViewResource)();
    const performCleanUp = (0, $eJOHy.useCallback)((shouldPublishCreatedIssues = false, issuesCreated)=>{
        const issueList = issuesCreated ?? createdIssues ?? [];
        if (!isCompanyManagedBoardOrBacklog) showSuccessFlag(issueList);
        else (0, $bVObd.successFlagDisplay).start();
        const isMobileExperienceEnabled = (0, $fYeTG.isMobileAndInMvpOrExistingUsersExperiment)();
        closeIssueCreateModalNew(issueList);
        if (issuesCreated && !isMobileExperienceEnabled) updateView(minimizableModalView === 'mini' ? 'mini' : 'modal');
        if (isCompanyManagedBoardOrBacklog && (0, $7jTnu.fg)('fix-gryf-a11y-issues-2')) setTimeout(()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage, @typescript-eslint/consistent-type-assertions
            const succeessFlagDismissButton = document.querySelector('[data-testid="platform.ui.flags.common.ui.common-flag-v2-dismiss"]');
            succeessFlagDismissButton?.focus();
        }, isCompanyManagedBoard ? 2000 : 1000);
        if (shouldPublishCreatedIssues) (0, $7caPf.publishCreatedIssues)({
            createdIssues: issueList,
            globalEventNamespaces: globalEventNamespaces,
            fieldsToAddInPublishedData: fieldsToAddInPublishedData,
            alertsToBeLinked: alertsToBeLinked,
            isSessionComplete: true,
            onIssueCreate: null,
            onClose: onClose,
            triggerPointKey: triggerPointKey,
            publishGICLifecycle: publish,
            inProgressIssueID: inProgressIssueID,
            callbackPayload: callbackPayload,
            selectedCloudId: selectedCloudId,
            jqlSwimlaneId: jqlSwimlaneId,
            ecosystemCallback: ecosystemCallback
        });
    }, [
        createdIssues,
        isCompanyManagedBoardOrBacklog,
        closeIssueCreateModalNew,
        showSuccessFlag,
        updateView,
        minimizableModalView,
        isCompanyManagedBoard,
        globalEventNamespaces,
        fieldsToAddInPublishedData,
        alertsToBeLinked,
        onClose,
        triggerPointKey,
        publish,
        inProgressIssueID,
        callbackPayload,
        selectedCloudId,
        jqlSwimlaneId,
        ecosystemCallback
    ]);
    const onCreateAnotherChange = (_, analyticsEvent)=>{
        setCanCreateAnotherIssue(!canCreateAnotherIssue);
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'createAnotherIssue', {
            projectType: selectedProject ? (0, $5PjYq.transformProjectType)(selectedProject.projectType) : 'none'
        });
    };
    const handleTabIndexEmptyContainingRequiredField = ()=>{
        try {
            const fieldValues = getFormState.current()?.values || null;
            const tabIndex = (0, $7caPf.getTabIndexWithError)(modalFieldTabs, fieldValues, modalFieldConfig);
            setCurrentActiveTabIndex(tabIndex);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $eDBhy.fireIssueCreateErrorAnalytics)({
                meta: {
                    packageName: 'jiraIssueCreate',
                    id: 'gicModalTabChangeOnSubmit',
                    teamName: 'gryffindor'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    };
    const handleEmptyAndRequiredFields = ()=>{
        try {
            const fieldValues = getFormState.current()?.values || null;
            let emptyRequiredFields = [];
            if (modalFieldConfig) emptyRequiredFields = Object.keys(modalFieldConfig)?.filter((fieldId)=>Boolean(modalFieldConfig[fieldId].isRequired) && fieldValues && (0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(fieldValues[fieldId]));
            const firstFieldIdWithError = (0, $7caPf.getFirstFieldIdWithError)({
                fields: Object.keys(fieldValues || {}),
                emptyRequiredFields: emptyRequiredFields
            });
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            (0, $c3eoY.scrollToField)(firstFieldIdWithError);
            firstFieldIdWithError && (0, $7jTnu.fg)('gryf_accessibility_issue_focus_field_in_gic') && (0, $c3eoY.setFocusOnField)(firstFieldIdWithError);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $eDBhy.fireIssueCreateErrorAnalytics)({
                meta: {
                    packageName: 'jiraIssueCreate',
                    id: 'gicModalNextRequiredFieldFocusOnSubmit',
                    teamName: 'gryffindor'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    };
    const { atlassianAccountId: atlassianAccountId } = (0, $lvKO5.useTenantContext)();
    const onSubmit = (_, analyticsEvent)=>{
        handleTabIndexEmptyContainingRequiredField();
        handleEmptyAndRequiredFields();
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'createIssue', {
            projectType: selectedProject ? (0, $5PjYq.transformProjectType)(selectedProject.projectType) : 'none',
            gicSessionId: sessionIdRef.current
        });
    };
    const showWatchersWarningOrErrorFlag = (0, $eJOHy.useCallback)((createdIssue, response)=>{
        const config = (0, $7caPf.getWatchersFlagConfigFromResponse)(response, createdIssue.issueKey, selectedIssueType?.label);
        if (config) /**
				 * Showing the watchers warning/error flag slightly after the issue-create-success-flag
				 * so they visually appear one after another in order and the user would be able to
				 * actually see the success flag sliding in first and then being pushed down.
				 */ setTimeout(()=>{
            showFlag(config);
        }, 600);
    }, [
        showFlag,
        selectedIssueType
    ]);
    const onIssueCreateSuccess = (0, $eJOHy.useCallback)((createdIssue, watchersResponse)=>{
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const issuesCreated = addCreatedIssue(createdIssue);
        setObjectId(String(createdIssue?.issueId));
        setShowIssuesCreated(showIssuesCreated || canCreateAnotherIssue);
        (0, $7caPf.publishCreatedIssues)({
            createdIssues: [
                createdIssue
            ],
            globalEventNamespaces: globalEventNamespaces,
            fieldsToAddInPublishedData: fieldsToAddInPublishedData,
            alertsToBeLinked: alertsToBeLinked,
            onIssueCreate: onIssueCreate,
            siteDomain: siteDomain,
            selectedCloudId: selectedCloudId,
            onClose: onClose,
            inProgressIssueID: inProgressIssueID,
            publishGICLifecycle: publish,
            isIssueCreateSuccess: true,
            callbackPayload: callbackPayload,
            jqlSwimlaneId: jqlSwimlaneId,
            ecosystemCallback: ecosystemCallback
        });
        if (!canCreateAnotherIssue) performCleanUp(true, issuesCreated);
        showWatchersWarningOrErrorFlag(createdIssue, watchersResponse);
    }, [
        addCreatedIssue,
        showIssuesCreated,
        canCreateAnotherIssue,
        globalEventNamespaces,
        fieldsToAddInPublishedData,
        alertsToBeLinked,
        onIssueCreate,
        siteDomain,
        selectedCloudId,
        onClose,
        inProgressIssueID,
        publish,
        callbackPayload,
        jqlSwimlaneId,
        ecosystemCallback,
        showWatchersWarningOrErrorFlag,
        performCleanUp
    ]);
    const showConfirmDismissModal = (source)=>{
        sourceThatFiredModalDismiss.current = source;
    };
    const hideConfirmDismissModal = ()=>{
        sourceThatFiredModalDismiss.current = null;
    };
    const onModalClose = (_, analyticsEvent, source)=>{
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, source, {
            projectType: selectedProject ? (0, $5PjYq.transformProjectType)(selectedProject.projectType) : 'none'
        });
        showEnforcementIfPendingToShow();
        performCleanUp(true);
        resetState();
    };
    const onModalCloseWithConfirm = (source)=>(_, analyticsEvent)=>{
            if (!isCreateFormDirty) {
                setTimeout(()=>{
                    const activeElement = globalThis.document.activeElement;
                    if (activeElement instanceof HTMLElement) activeElement.blur();
                    triggerButtonRef?.focus();
                }, 500);
                onModalClose(_, analyticsEvent, source);
                return;
            }
            showConfirmDismissModal(source);
        };
    const onConfirmDismissModalCancel = ()=>{
        hideConfirmDismissModal();
    };
    const onConfirmDismissModalConfirm = (_, analyticsEvent)=>{
        const source = sourceThatFiredModalDismiss && sourceThatFiredModalDismiss.current || '';
        // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'string'.
        onModalClose(_, analyticsEvent, source);
        if ((0, $7jTnu.fg)('fix-gryf-a11y-issues')) setTimeout(()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage, @typescript-eslint/consistent-type-assertions
            const activeElement = document.activeElement;
            if (activeElement) activeElement?.blur?.();
            triggerButtonRef?.focus?.();
        }, 500);
    };
    const [resetFormFieldsCounter, setResetFormFieldsCounter] = (0, $eJOHy.useState)(0);
    const incrementResetCounter = (0, $eJOHy.useCallback)(()=>{
        setResetFormFieldsCounter((n)=>n + 1);
    }, []);
    const hideConfigureFieldsModal = ()=>{
        toggleConfigureFieldsModalVisibility(false);
    };
    const hideFindFieldModal = ()=>{
        toggleFindFieldsModalVisibility(false);
    };
    // @ts-expect-error - TS2525 - Initializer provides no value for this binding element and the binding element has no default value. | TS7031 - Binding element 'shouldShowChangerSpotlight' implicitly has an 'any' type. | TS2525 - Initializer provides no value for this binding element and the binding element has no default value. | TS7031 - Binding element 'onOpenSpotlight' implicitly has an 'any' type. | TS2525 - Initializer provides no value for this binding element and the binding element has no default value. | TS7031 - Binding element 'onCloseSpotlight' implicitly has an 'any' type.
    const { shouldShowChangerSpotlight: shouldShowChangerSpotlight, onOpenSpotlight: onOpenSpotlight, onCloseSpotlight: onCloseSpotlight } = isGICPositioningEnabled() ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $9DD83.useChangerSpotlight)(minimizableModalView) : {};
    // resetting form context should happen after the component is unmounted (if done before, certain components/fields were throwing error)
    // @ts-expect-error - TS2322 - Type '() => void | Promise<void>' is not assignable to type 'void | Destructor'.
    (0, $eJOHy.useEffect)(()=>resetFormContext, [
        resetFormContext
    ]);
    // add sprint field to published data to enable dynamic success flags for scrum projects
    (0, $eJOHy.useEffect)(()=>{
        const sprintFieldId = Object.keys(modalFieldConfig).find((key)=>modalFieldConfig[key].gqlType === 'JiraSprintField');
        if (sprintFieldId !== undefined) fieldsToAddInPublishedData.push(sprintFieldId);
    }, [
        fieldsToAddInPublishedData,
        modalFieldConfig
    ]);
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const fieldPropsExtensions = isGICPositioningEnabled() ? {
        description: {
            onFocus: onOpenSpotlight,
            onBlur: onCloseSpotlight
        }
    } : undefined;
    const preselectedStatus = triggerIssueCreatePayload?.status?.statusId;
    const classificationFieldProps = (0, $2lqpf.useClassificationFieldProps)(classificationFieldConfig);
    const combinedInlineConfigurationExperiment = (0, $dSpUw.useCombinedInlineConfigurationExperiment)();
    const [expConfig] = (0, $epTsa.UNSAFE_noExposureExp)('inline_status_add_and_rename_in_gic');
    const isInlineStatusConfigEnabled = expConfig.get('isInlineStatusConfigEnabled', false);
    const buildCreateFormProps = (0, $eJOHy.useCallback)(()=>({
            isLoading: isModalLoading,
            fieldConfig: modalFieldConfig,
            fieldTabs: modalFieldTabs,
            contextFields: modalContextFields,
            meta: modalFieldsDataMeta,
            error: modalFieldsDataError,
            apiLatency: modalApiLatency,
            onFetchConfig: fetchModalConfig,
            onIssueCreateSuccess: onIssueCreateSuccess,
            onSiteSelection: onSiteSelection,
            onProjectSelection: onProjectSelection,
            canCreateAnotherIssue: canCreateAnotherIssue,
            dirtyFieldsCurrentSession: dirtyFieldsCurrentSession,
            getFormState: getFormState,
            onFormFieldsReset: incrementResetCounter,
            fieldPropsExtensions: fieldPropsExtensions,
            onResetApolloCache: onResetApolloCache,
            filteredOutModules: filteredOutModules,
            ...classificationFieldConfig && Array.isArray(classificationFieldConfig?.allowedValues) && classificationFieldConfig.allowedValues.length > 0 ? {
                classificationFieldProps: classificationFieldProps
            } : {},
            ...shouldShowStatus ? {
                statusFieldProps: {
                    preselectedTransition: transitions?.find((transition)=>transition.to.id === preselectedStatus),
                    initialTransition: transitions?.find((it)=>it.isInitial),
                    availableTransitions: transitions,
                    isTransitionsLoading: isTransitionsLoading,
                    transitionsError: transitionsError
                }
            } : Object.freeze({}),
            proformaConfiguration: proformaConfiguration,
            watchersConfigurations: modalAdditionalServices.watchersConfigurations,
            onStatusCreatedOrUpdated: combinedInlineConfigurationExperiment.isEnabled || isInlineStatusConfigEnabled ? refetchTransitions : undefined
        }), [
        isModalLoading,
        modalFieldConfig,
        modalFieldTabs,
        modalContextFields,
        modalFieldsDataMeta,
        modalFieldsDataError,
        modalApiLatency,
        fetchModalConfig,
        onIssueCreateSuccess,
        onSiteSelection,
        onProjectSelection,
        canCreateAnotherIssue,
        incrementResetCounter,
        fieldPropsExtensions,
        onResetApolloCache,
        filteredOutModules,
        classificationFieldConfig,
        classificationFieldProps,
        shouldShowStatus,
        transitions,
        isTransitionsLoading,
        transitionsError,
        proformaConfiguration,
        modalAdditionalServices.watchersConfigurations,
        combinedInlineConfigurationExperiment.isEnabled,
        isInlineStatusConfigEnabled,
        refetchTransitions,
        preselectedStatus
    ]);
    const createFormProps = (0, $eJOHy.useMemo)(()=>{
        let formProps = buildCreateFormProps();
        if (onTransformCreateFormProps) formProps = onTransformCreateFormProps(formProps);
        return formProps;
    }, [
        buildCreateFormProps,
        onTransformCreateFormProps
    ]);
    const renderFormOrError = ()=>{
        if (shouldDisableActions) {
            (0, $eDBhy.fireIssueCreateErrorAnalytics)({
                meta: {
                    packageName: 'jiraIssueCreate',
                    id: 'errorScreenRendered',
                    teamName: 'gryffindor'
                },
                attributes: {
                    ...(0, $gtCj5.getAdditionalAttributes)()
                },
                sendToPrivacyUnsafeSplunk: true
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jQAhS.default), null);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9H0bo.default), createFormProps);
    };
    const currentUIModificationsConsentState = (0, $21XCU.useUIModificationsConsentStatus)();
    const getShouldDisableSubmit = ()=>currentUIModificationsConsentState === (0, $5b46c372089c1d7d$export$d67d63332ce3ce38) || !meta.areRequiredFieldsSupported || shouldDisableActions || !(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(meta.queryErrorMessage);
    // initialise the request type fields layout preference on modal load
    // internally, this will not re-fetch if previously done
    const [{ data: isRequestTypeFieldsLayoutEnabled }, { initialise: initialise }] = (0, $fV6Ej.useRequestTypeFieldsLayoutPreference)();
    (0, $eJOHy.useEffect)(()=>{
        if (atlassianAccountId) initialise(atlassianAccountId, createAnalyticsEvent);
    }, [
        atlassianAccountId,
        createAnalyticsEvent,
        initialise
    ]);
    const isRequestTypeSelected = selectedIssueType?.type === (0, $4246188a36de9908$export$92ab80c1dc9baf44);
    const renderConfigureFieldsModal = ()=>shouldShowConfigureFieldModal && selectedProject && selectedIssueType ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6M13s.default), {
            onCancel: hideConfigureFieldsModal,
            project: {
                projectId: selectedProject.value,
                projectType: selectedProject.projectType
            },
            issueTypeId: isRequestTypeSelected ? selectedIssueType.issueTypeId : selectedIssueType.value,
            requestTypeKey: isRequestTypeSelected ? selectedIssueType.requestTypeKey : undefined,
            parentId: triggerIssueCreatePayload?.parentId?.parentId,
            setAreConfiguredFieldsModified: setAreConfiguredFieldsModified,
            onlyDisplayAllFieldsOption: isRequestTypeFieldsLayoutEnabled && isRequestTypeSelected,
            messageContent: isRequestTypeSelected ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cyr99.JsmRequestTypeFieldsChangeboarding), null) : undefined
        }) : null;
    const renderFindFieldModal = ()=>shouldShowFindFieldModal && selectedProject && selectedIssueType ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hGlZi.default), {
            project: {
                projectId: selectedProject.value,
                nextGenProject: selectedProject.isSimplified,
                projectType: selectedProject.projectType
            },
            issueTypeId: selectedIssueType.type === (0, $4246188a36de9908$export$92ab80c1dc9baf44) ? selectedIssueType.issueTypeId : selectedIssueType.value,
            operation: "CREATE",
            onCancel: hideFindFieldModal
        }) : null;
    const renderExistingGicWarningModal = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8xFHy.ExistingGICWarning), null);
    const renderDisabledRestoreNavigationPrompt = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($14ca63a54abf4ed1$var$DisabledRestoreNavigationPrompt, {
            setShouldRestore: setShouldRestore
        });
    const modalWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $70BpF.ModalWrapper), {
        onModalCloseWithConfirm: onModalCloseWithConfirm,
        shouldDisableActions: shouldDisableActions,
        onSubmit: onSubmit,
        isSubmitting: isSubmitting,
        isOperationInProgress: isOperationInProgress,
        canCreateAnotherIssue: canCreateAnotherIssue,
        onCreateAnotherChange: onCreateAnotherChange,
        getShouldDisableSubmit: getShouldDisableSubmit,
        createdIssues: createdIssues,
        displayCreateAnotherIssueToggle: displayCreateAnotherIssueToggle,
        shouldShowChangerSpotlight: isGICPositioningEnabled() ? !interactedWithModalChangerButtons && shouldShowChangerSpotlight : undefined,
        showIssuesCreated: showIssuesCreated,
        initialSummaryValue: (0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(createFormProps.fieldConfig) ? null : createFormProps.fieldConfig?.summary?.defaultValue || '',
        projectType: selectedProject?.projectType,
        selectedIssueType: selectedIssueType,
        setShouldRestore: setShouldRestore,
        watchersConfigurations: modalAdditionalServices.watchersConfigurations,
        ...isCreateFormDirty && selectedProject ? {
            dismissModalEntryPointWrapper: (p)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($14ca63a54abf4ed1$var$DismissModalEntryPointWrapper, {
                    ...p,
                    entryPointProps: {
                        project: {
                            projectId: selectedProject.value,
                            projectType: selectedProject.projectType
                        },
                        sessionId: sessionIdRef.current,
                        onClose: onConfirmDismissModalCancel,
                        onConfirm: onConfirmDismissModalConfirm
                    }
                })
        } : {}
    }, !isGICPositioningEnabled() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Plmb.MountEvent), {
        onMount: (0, $gCeeo.fireScreenAnalyticsDeferred)
    }), renderFormOrError(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $50UkK.UiModificationsEntryPoint), {
        issueTypeFieldType: modalContextFields.issuetype?.type || '',
        modalFieldConfig: modalFieldConfig,
        resetFormFieldsCounter: resetFormFieldsCounter,
        selectedIssueType: selectedIssueType,
        selectedProject: selectedProject,
        triggerPointKey: triggerPointKey
    }), renderConfigureFieldsModal(), renderFindFieldModal(), isGICPositioningEnabled() && renderExistingGicWarningModal(), renderDisabledRestoreNavigationPrompt());
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        sourceType: (0, $466f60259c330878$export$1171103ea9083ffa),
        sourceName: "createIssue",
        containerType: "project",
        objectType: "issue",
        objectId: objectId,
        containerId: selectedProject ? selectedProject.value : '',
        attributes: {
            isNewGIC: true,
            isCreatingAnotherIssue: canCreateAnotherIssue,
            isSubtask: isSubTaskCreationOpen,
            triggerPointKey: triggerPointKey,
            projectType: selectedProject?.projectType,
            ...selectedProject ? {
                nextGenProject: selectedProject.isSimplified
            } : {},
            ...isGICPositioningEnabled() ? {
                gicViewState: minimizableModalView
            } : {},
            ...(0, $7jTnu.fg)('create_linked_issues_trigger_point_issue_view') ? {
                isCreateLinkedIssue: isCreateLinkedIssue
            } : {},
            hasProformaForm: !!proformaConfiguration?.hasProformaForm,
            wasStateRestored: wasStateRestored,
            isDiscoverabilityPush: !!shouldPushMiniModalDiscoverability && (0, $hBHUL.isPartOfDiscoverabilityTriggers)(triggerPointKey),
            smartFieldsEnabled: withMachineLearning,
            sessionId: !sessionId ? sessionIdRef.current : sessionId,
            isCustomBoardWithIcc: isCustomBoardWithIcc,
            swimlaneMode: swimlaneMode,
            ...(0, $7jTnu.fg)('quick_actions_with_hotkeys_ga') ? {
                triggeredViaHotKey: triggeredViaHotKey
            } : {},
            ...product ? {
                product: product
            } : {},
            ...actionSource ? {
                actionSource: actionSource
            } : {},
            ...(0, $gtCj5.getAdditionalAttributes)()
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2U3xv.UiModificationsContainer), null, modalWrapper));
};
var $14ca63a54abf4ed1$export$2e2bcd8739ae039 = $14ca63a54abf4ed1$var$CreateModal;

});
const $5b46c372089c1d7d$export$39d15f3568f5a72c = 'unknown';
const $5b46c372089c1d7d$export$d67d63332ce3ce38 = 'required';
const $5b46c372089c1d7d$export$45ca911896c5084f = 'consented';

parcelRegister("21XCU", function(module, exports) {

$parcel$export(module.exports, "useUIModificationsConsentStatus", () => $284b3ff9ef6387ec$export$e2c526d2c1843a0e);
$parcel$export(module.exports, "useUIModificationsConsentStatusForApp", () => $284b3ff9ef6387ec$export$7700bb22109a011e);
$parcel$export(module.exports, "useUIModificationsConsentStatusForApps", () => $284b3ff9ef6387ec$export$2a5a8f1570c161c6);

var $4MchI = parcelRequire("4MchI");
var $iJq0l = parcelRequire("iJq0l");

var $i7n3g = parcelRequire("i7n3g");

const $284b3ff9ef6387ec$var$selectOverallConsentStatus = (0, $4MchI.createSelector)((state)=>state.uiModificationsConsentStatus, (consentMap)=>Object.values(consentMap).includes((0, $5b46c372089c1d7d$export$d67d63332ce3ce38)) ? (0, $5b46c372089c1d7d$export$d67d63332ce3ce38) : (0, $5b46c372089c1d7d$export$45ca911896c5084f));
const $284b3ff9ef6387ec$export$e2c526d2c1843a0e = (0, $iJq0l.createStateHook)((0, $i7n3g.store), {
    selector: $284b3ff9ef6387ec$var$selectOverallConsentStatus
});
const $284b3ff9ef6387ec$export$7700bb22109a011e = (0, $iJq0l.createStateHook)((0, $i7n3g.store), {
    selector: (state, { appId: appId })=>state.uiModificationsConsentStatus[appId] || (0, $5b46c372089c1d7d$export$39d15f3568f5a72c)
});
const $284b3ff9ef6387ec$export$2a5a8f1570c161c6 = (0, $iJq0l.createStateHook)((0, $i7n3g.store), {
    selector: (state)=>state.uiModificationsConsentStatus
});

});
parcelRegister("i7n3g", function(module, exports) {

$parcel$export(module.exports, "store", () => $35b1fa370eb6f514$export$6f57813fe9f31bf9);
$parcel$export(module.exports, "useAdjustmentsEnabled", () => $35b1fa370eb6f514$export$358ad850b2f6d6fe);
$parcel$export(module.exports, "useAdjustmentsContextActions", () => $35b1fa370eb6f514$export$4f2729981f4b81d2);
$parcel$export(module.exports, "UiModificationContextContainer", () => $35b1fa370eb6f514$export$5eb9c167b683d125);

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");
const $35b1fa370eb6f514$var$initialState = {
    shouldUiModificationsLoad: 'unknown',
    hasFinishedLoading: false,
    adjustmentsAreEnabled: false,
    uiModificationsConsentStatus: {}
};
const $35b1fa370eb6f514$export$e324594224ef24da = {
    resetAdjustmentContext: ()=>({ setState: setState })=>{
            setState($35b1fa370eb6f514$var$initialState);
        },
    setShouldUiModificationsLoad: (status)=>({ setState: setState })=>{
            setState({
                shouldUiModificationsLoad: status
            });
        },
    setHasFinishedLoading: (hasFinishedLoading)=>({ setState: setState })=>{
            setState({
                hasFinishedLoading: hasFinishedLoading
            });
        },
    setAdjustmentsAreEnabled: (enabled)=>({ setState: setState })=>{
            setState({
                adjustmentsAreEnabled: enabled
            });
        },
    setUIModificationsConsentStatus: ({ appId: appId, status: status })=>({ setState: setState, getState: getState })=>{
            const currentConsentState = getState().uiModificationsConsentStatus;
            setState({
                uiModificationsConsentStatus: {
                    ...currentConsentState,
                    [appId]: status
                }
            });
        }
};
const $35b1fa370eb6f514$export$6f57813fe9f31bf9 = (0, $GtRbT.createStore)({
    name: 'issue-adjustments-context',
    initialState: $35b1fa370eb6f514$var$initialState,
    actions: $35b1fa370eb6f514$export$e324594224ef24da
});
const $35b1fa370eb6f514$export$a12f82a132dee079 = (0, $iJq0l.createHook)($35b1fa370eb6f514$export$6f57813fe9f31bf9);
const $35b1fa370eb6f514$export$358ad850b2f6d6fe = (0, $iJq0l.createStateHook)($35b1fa370eb6f514$export$6f57813fe9f31bf9, {
    selector: (state)=>state.adjustmentsAreEnabled
});
const $35b1fa370eb6f514$export$4f2729981f4b81d2 = (0, $iJq0l.createActionsHook)($35b1fa370eb6f514$export$6f57813fe9f31bf9);
const $35b1fa370eb6f514$export$5eb9c167b683d125 = (0, $6E16M.createContainer)($35b1fa370eb6f514$export$6f57813fe9f31bf9, {
    displayName: 'UiModificationContextContainer'
});

});


parcelRegister("hGlZi", function(module, exports) {

$parcel$export(module.exports, "default", () => $e937aa3ef6b07842$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $4NEt5 = parcelRequire("4NEt5");

var $ch9En = parcelRequire("ch9En");

var $bQWwW = parcelRequire("bQWwW");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $e937aa3ef6b07842$var$FindFieldModal = (0, $bQWwW.lazy)(()=>(parcelRequire("iGZQS")), {
    ssr: false,
    moduleId: "./src/packages/issue-create/find-field/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e937aa3ef6b07842$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4NEt5.JiraIssueCreateErrorBoundary), {
        id: "AsyncFindFieldModal",
        packageName: "jiraIssueConfigFindField",
        fallback: "flag",
        sendToPrivacyUnsafeSplunk: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "config-find-field-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e937aa3ef6b07842$var$FindFieldModal, props)));

});
parcelRegister("iGZQS", function(module, exports) {

let $d9bc20beb7ab3625$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $d9bc20beb7ab3625$var$load("9sR8I").then(()=>parcelRequire('fhwvH'));

});


// error types
const $4246188a36de9908$export$6c8cb487d6ffc522 = 'QueryError';
const $4246188a36de9908$export$b171488d52070cb3 = 'JiraIssueFieldUnsupportedErrorExtension';
const $4246188a36de9908$export$14b50ab9fbf2d370 = 'JiraIssueFieldValueValidationErrorExtension';
const $4246188a36de9908$export$3d1cda9bd50505e8 = 'SERVICE_REQUEST';
const $4246188a36de9908$export$48c144830383423 = 'INCIDENT_MANAGEMENT';
const $4246188a36de9908$export$1ea6ead7bcee4494 = 'PROBLEM_MANAGEMENT';
const $4246188a36de9908$export$b92ccb6dc3cdb548 = 'CHANGE_MANAGEMENT';
const $4246188a36de9908$export$a4a741b969f6509c = 'POST_INCIDENT_REVIEW';
const $4246188a36de9908$export$81e62964cc725098 = 'DEVELOPER_ESCALATION';
const $4246188a36de9908$export$92ab80c1dc9baf44 = 'REQUEST_TYPE';
const $4246188a36de9908$export$ebb48b08205007c5 = 'ISSUE_TYPE';
const $4246188a36de9908$export$c835df30ebbd529d = 'UNASSIGNED_REQUEST_TYPE';

parcelRegister("5PjYq", function(module, exports) {

$parcel$export(module.exports, "transformProjectType", () => $5650c41bee4ab4e7$export$bd65219b3dd7789d);

var $ln6Iy = parcelRequire("ln6Iy");
const $5650c41bee4ab4e7$export$bd65219b3dd7789d = (projectType)=>{
    if (!projectType) return 'none';
    if (projectType === (0, $ln6Iy.SERVICE_DESK_PROJECT)) return 'serviceManagement';
    if (projectType === (0, $ln6Iy.CORE_PROJECT)) return 'workManagement';
    return projectType;
};

});

parcelRegister("2lqpf", function(module, exports) {

$parcel$export(module.exports, "useClassificationState", () => $0e74e7fdddca72b7$export$4404b0743b8ee564);
$parcel$export(module.exports, "useClassificationFieldProps", () => $0e74e7fdddca72b7$export$e2bccade312f8);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $5qN75 = parcelRequire("5qN75");

var $xMjNG = parcelRequire("xMjNG");

var $4PKlm = parcelRequire("4PKlm");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $4frAn = parcelRequire("4frAn");
const $0e74e7fdddca72b7$export$4404b0743b8ee564 = (classificationOption)=>{
    const [selectedClassification, setSelectedClassification] = (0, $eJOHy.useState)(classificationOption);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { publish: publish } = (0, $4PKlm.useGICLifeCycleEvents)();
    const onClassificationOptionChange = (0, $eJOHy.useCallback)((option)=>{
        setSelectedClassification(option);
        const analyticsEvent = createAnalyticsEvent({});
        (0, $gCeeo.fireTrackAnalyticsDeferred)(analyticsEvent, 'ClassificationInGIC changed');
        publish((0, $xMjNG.GIC_LIFECYCLE_EVENTS).CLASSIFICATION_LEVEL_FIELD_CHANGE, {
            selectedClassification: option
        });
    }, [
        createAnalyticsEvent,
        publish
    ]);
    return [
        selectedClassification,
        setSelectedClassification,
        onClassificationOptionChange
    ];
};
const $0e74e7fdddca72b7$export$e2a389820b14b290 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return (0, $eJOHy.useCallback)((value)=>{
        if (!value) {
            const noClassificationOption = {
                id: undefined,
                definition: formatMessage((0, $4frAn.default).noClassificationOption),
                color: undefined,
                includeIcon: false
            };
            return noClassificationOption;
        }
        return (0, $5qN75.getProjectDefaultClassificationOption)(formatMessage((0, $4frAn.default).projectDefaultClassificationOption), value);
    }, [
        formatMessage
    ]);
};
const $0e74e7fdddca72b7$export$cdada88ebf1ccd9 = (classificationFieldConfig)=>{
    const allowedClassifications = classificationFieldConfig?.allowedValues?.map((value)=>$0e74e7fdddca72b7$export$a30f3e09b4b8e281(value.node));
    return allowedClassifications;
};
const $0e74e7fdddca72b7$export$a30f3e09b4b8e281 = (defaultValue)=>{
    const defaultClassification = defaultValue ? {
        id: defaultValue?.id,
        name: defaultValue?.name,
        definition: defaultValue?.definition,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        color: defaultValue?.color?.colorKey
    } : undefined;
    return defaultClassification;
};
const $0e74e7fdddca72b7$export$e2bccade312f8 = (classificationFieldConfig)=>{
    const getCreateClassificationLevel = $0e74e7fdddca72b7$export$e2a389820b14b290();
    return (0, $eJOHy.useMemo)(()=>{
        let classificationFieldProps = {
            availableClassifications: undefined,
            initialClassification: undefined,
            isDisabled: false,
            nonEditableMessage: undefined
        };
        const allowedClassifications = $0e74e7fdddca72b7$export$cdada88ebf1ccd9(classificationFieldConfig);
        const initialDefaultClassification = $0e74e7fdddca72b7$export$a30f3e09b4b8e281(classificationFieldConfig?.defaultValue?.[0]);
        const projectDefaultClassification = $0e74e7fdddca72b7$export$a30f3e09b4b8e281(classificationFieldConfig?.defaultValue?.[1]);
        const projectLevelClassification = getCreateClassificationLevel(projectDefaultClassification);
        const isFieldEditable = classificationFieldConfig?.isEditable;
        if (allowedClassifications) classificationFieldProps = {
            availableClassifications: allowedClassifications.concat(projectLevelClassification),
            initialClassification: initialDefaultClassification || projectLevelClassification,
            isDisabled: isFieldEditable === false,
            nonEditableMessage: classificationFieldConfig?.nonEditableReason
        };
        return classificationFieldProps;
    }, [
        classificationFieldConfig,
        getCreateClassificationLevel
    ]);
};

});
parcelRegister("5qN75", function(module, exports) {

$parcel$export(module.exports, "getProjectDefaultClassificationOption", () => $34b5019a6884d5ba$export$1f0ddb93897fde19);
/* utils.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $dL9bk = parcelRequire("dL9bk");
const $34b5019a6884d5ba$export$d890d332bbf5844a = (classifications)=>classifications ? {
        edges: classifications.map((classification)=>({
                node: {
                    id: classification.id,
                    name: classification.name,
                    definition: classification.definition,
                    color: {
                        colorKey: classification.color
                    }
                }
            }))
    } : classifications;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $34b5019a6884d5ba$var$OverflowWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});
const $34b5019a6884d5ba$var$ProjectDefaultTextWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswh2mm _154i1i6y",
            __cmplp.className
        ])
    });
});
const $34b5019a6884d5ba$export$1f0ddb93897fde19 = (message, defaultClassificationLevel)=>{
    const color = typeof defaultClassificationLevel?.color === 'string' ? defaultClassificationLevel?.color : defaultClassificationLevel?.color?.colorKey;
    return {
        id: undefined,
        nameFormatter: (classification)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($34b5019a6884d5ba$var$OverflowWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($34b5019a6884d5ba$var$ProjectDefaultTextWrapper, null, message, " - "), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dL9bk.ClassificationLozenge), {
                ...classification,
                name: defaultClassificationLevel?.name || ''
            })),
        // The below lint error is because Color type expects string, whereas the graphQL type expects { colorKey: string }. This has been handled in variable definition for color.
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        color: color,
        definition: ''
    };
};

});
parcelRegister("dL9bk", function(module, exports) {

$parcel$export(module.exports, "ClassificationLozenge", () => $af6e9d39ba0ce2c7$export$f31d135f91971ac4);
$parcel$export(module.exports, "DataClassificationDropdown", () => $af6e9d39ba0ce2c7$export$37a6278f2f470b5e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $fqICx = parcelRequire("fqICx");

var $cSmYj = parcelRequire("cSmYj");

var $d3cA1 = parcelRequire("d3cA1");

var $lmgo6 = parcelRequire("lmgo6");
var $dW738 = parcelRequire("dW738");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $6XEne = parcelRequire("6XEne");
var $c4OV1 = parcelRequire("c4OV1");

var $k71qx = parcelRequire("k71qx");

var $BFIzX = parcelRequire("BFIzX");

var $lBWdS = parcelRequire("lBWdS");

var $bGIeQ = parcelRequire("bGIeQ");
/**
 * The options in the select dropdown are quite customizable, and achieves different use-cases.
 * Options are identified (i.e. how an option in the dropdown is selected) by the "name", "label", and "definition" properties.
 * Typeof "option" prop is "ClassificationOption", which has requires at least one of the properties to exist, therefore it is safe to assume that an option will always be identifiable.
 * Obviously there can be duplicates, but that is a user error.
 *
 * Since only one of these identifying properties is required, there are 7 different combinations of these properties that will render a different option.
 *
 * (1) name
 *    - renders: name with icon (if includeIcon is true) in the icon container
 * (2) name, label
 *    - renders: name with icon (if includeIcon is true) in the icon container, and an inline label outside of the icon container
 * (3) name, definition
 *    - renders: name with icon (if includeIcon is true) in the icon container, and a definition below the icon container
 * (4) name, label, definition
 *    - renders: name with icon (if includeIcon is true) in the icon container, an inline label outside of the icon container, and a definition below the icon container
 * (5) label
 *    - renders: icon container with only an icon, and an inline label outside of the icon container
 *    - note: if includeIcon is false, then the icon container will not render (i.e. only an inline label will render)
 * (6) label, definition
 *    - renders: similar to (5) but with a definition below the icon container
 * (7) definition
 *    - renders: icon container with only an icon (conditionally rendered based on includeIcon), and a definition below the icon container
 *
 * Use cases:
 *    For space/project defaults we don't want to render a name.
 *    Instead we want to render a label: "Use space/project default".
 *    We also want to render a definition defining what the space/project default is.
 *    In this case, we'll use (6).
 *
 *    For resetting a classification (i.e. selecting the "No classification" option), we don't want to render a name or label.
 *    Instead we want to render only a definition and without an icon.
 *    In this case, we'll use (7) and pass in includeIcon={false}.
 */ const $af6e9d39ba0ce2c7$var$dangerTextStyles = (0, $1DXK0.xcss)({
    color: 'color.text.danger',
    paddingInlineStart: 'space.025'
});
const $af6e9d39ba0ce2c7$var$selectOptionStyles = {
    root: "_ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi"
};
const $af6e9d39ba0ce2c7$var$selectMenuPortalStyles = {
    root: "_1pbydx66"
};
const $af6e9d39ba0ce2c7$var$CustomSingleValue = ({ children: children, ...props })=>{
    const { data: data } = props;
    const { name: name, nameLabel: nameLabel, definition: definition, color: color = 'GREY', includeIcon: includeIcon = true, classificationOverride: classificationOverride, nameFormatter: nameFormatter } = data || {};
    const inputName = classificationOverride?.name ?? name ?? nameLabel ?? definition;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6XEne.components).SingleValue, {
        ...props,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bGIeQ.ContainerLabel), {
            children: nameFormatter ? nameFormatter(data) : /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bGIeQ.ContainerIcon), {
                colorsConfig: (0, $BFIzX.colorsConfig)[color],
                isIconOnly: includeIcon && !inputName,
                children: [
                    includeIcon && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lBWdS.ClassificationIcon), {
                        width: 14,
                        height: 14,
                        color: (0, $BFIzX.colorsConfig)[color].iconColor
                    }),
                    inputName && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bGIeQ.Name), {
                        children: inputName
                    })
                ]
            })
        })
    });
};
/**
 * CustomOption component is used to render each option in the dropdown.
 **/ const $af6e9d39ba0ce2c7$var$CustomOption = (props)=>{
    const { data: data } = props;
    const { name: name, definition: definition, nameLabel: nameLabel, includeIcon: includeIcon = true, nameFormatter: nameFormatter } = data || {};
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6XEne.components).Option, {
        ...props,
        xcss: $af6e9d39ba0ce2c7$var$selectOptionStyles.root,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $dW738.default), {
            space: "space.050",
            children: [
                (name || nameLabel || includeIcon) && /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bGIeQ.ContainerLabel), {
                    definitionExists: Boolean(definition),
                    children: [
                        nameFormatter ? nameFormatter(data) : /*#__PURE__*/ (0, $gt9Am.jsx)($af6e9d39ba0ce2c7$export$f31d135f91971ac4, {
                            ...data
                        }),
                        nameLabel && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bGIeQ.NameLabel), {
                            children: nameLabel
                        })
                    ]
                }),
                definition && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bGIeQ.Definition), {
                    children: definition
                })
            ]
        })
    });
};
const $af6e9d39ba0ce2c7$export$f31d135f91971ac4 = (data)=>{
    const { name: name, nameLabel: nameLabel, includeIcon: includeIcon = true, color: color = 'GREY', colorOnlyIconBackground: colorOnlyIconBackground = false } = data || {};
    // if name and label are both present, trim name to fit nameLabel in the same row
    const shouldTrimBothNameAndLabel = Boolean(name && nameLabel);
    const iconComponent = includeIcon && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lBWdS.ClassificationIcon), {
        width: 14,
        height: 14,
        color: (0, $BFIzX.colorsConfig)[color].iconColor
    });
    /* name inside a lozenge will only be a string and not a reactNode */ const nameComponent = name && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bGIeQ.Name), {
        children: name.substring(0, (0, $BFIzX.nameMaxLength) / (shouldTrimBothNameAndLabel ? 2 : 1))
    });
    return colorOnlyIconBackground ? /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bGIeQ.ContainerIcon), {
                colorsConfig: (0, $BFIzX.colorsConfig)[color],
                isIconOnly: includeIcon && !name,
                children: iconComponent
            }),
            nameComponent
        ]
    }) : /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bGIeQ.ContainerIcon), {
        colorsConfig: (0, $BFIzX.colorsConfig)[color],
        isIconOnly: includeIcon && !name,
        children: [
            iconComponent,
            nameComponent
        ]
    });
};
const $af6e9d39ba0ce2c7$export$37a6278f2f470b5e = ({ label: label, options: options, value: value, errorMessage: errorMessage, disabledTooltipMessage: disabledTooltipMessage, isDisabled: isDisabled, onChange: onChange, onInputChange: onInputChange, menuShouldScrollIntoView: menuShouldScrollIntoView, menuPosition: menuPosition = 'absolute' })=>{
    // find selected classification in options
    const onSelectChange = (option)=>{
        // we want to identify the selected option by these properties
        const selectedOption = {
            name: option?.name,
            definition: option?.definition,
            label: option?.nameLabel
        };
        // find corresponding classification in options based on identifying properties
        const selectedClassification = options.find((opt)=>(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))({
                name: opt.name,
                definition: opt.definition,
                label: opt.label
            }, selectedOption));
        if (!selectedOption || !selectedClassification) return;
        if (onChange) onChange(selectedClassification);
    };
    /*
     Since select component requires label & value props in list of options, we'll transform "options" prop to include these values.
   */ const transformToOptionType = (0, $eJOHy.useCallback)((classification)=>({
            ...(0, (/*@__PURE__*/$parcel$interopDefault($fqICx)))(classification),
            // either name, label, or definition must exist, so we can safely use ! here
            label: classification.name ?? classification.label ?? classification.definition,
            // Asserting this as a string to keep lint happy. This wont be an issue, since CustomOption component will handle scenarios where name is a ReactNode.
            value: classification.name ?? classification.label ?? classification.definition,
            nameLabel: classification.label // since label is reserved for an option, we'll use nameLabel
        }), []);
    const transformedOptions = (0, $eJOHy.useMemo)(()=>options.map(transformToOptionType), [
        options,
        transformToOptionType
    ]);
    const renderDropdown = ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $c4OV1.default), {
            label: "data-classification-select",
            inputId: "data-classification-dropdown-input",
            options: transformedOptions,
            value: !value || errorMessage ? null : transformToOptionType(value),
            onChange: onSelectChange,
            onInputChange: onInputChange,
            isInvalid: Boolean(errorMessage),
            isDisabled: isDisabled,
            components: {
                Option: $af6e9d39ba0ce2c7$var$CustomOption,
                SingleValue: $af6e9d39ba0ce2c7$var$CustomSingleValue,
                MenuPortal: (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $6XEne.components).MenuPortal, {
                        ...props,
                        xcss: $af6e9d39ba0ce2c7$var$selectMenuPortalStyles.root
                    })
            },
            menuShouldScrollIntoView: menuShouldScrollIntoView,
            menuPosition: menuPosition,
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
            styles: {
                option: (baseStyles)=>({
                        ...baseStyles,
                        padding: "var(--ds-space-200, 16px)"
                    }),
                menuPortal: (base)=>({
                        ...base,
                        zIndex: 9999
                    })
            },
            menuPortalTarget: document.body
        });
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $dW738.default), {
        space: "space.100",
        children: [
            label && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bGIeQ.DropdownLabel), {
                htmlFor: "data-classification-dropdown-input",
                children: label
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $dW738.default), {
                space: "space.050",
                children: [
                    isDisabled ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
                        content: disabledTooltipMessage,
                        children: renderDropdown()
                    }) : renderDropdown(),
                    errorMessage && /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $lmgo6.default), {
                        alignItems: "center",
                        gap: "space.050",
                        xcss: $af6e9d39ba0ce2c7$var$dangerTextStyles,
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d3cA1))), {
                                color: "currentColor",
                                LEGACY_size: "small",
                                LEGACY_margin: `0 ${"var(--ds-space-negative-025, -2px)"}`,
                                label: "",
                                size: "small"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5qJVF.default), {
                                as: "p",
                                size: "small",
                                color: "inherit",
                                children: errorMessage
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("BFIzX", function(module, exports) {

$parcel$export(module.exports, "nameMaxLength", () => $9c5f64135a6f9722$export$253bdad208569777);
$parcel$export(module.exports, "guidelineMaxLength", () => $9c5f64135a6f9722$export$e1444e5b0a63d793);
$parcel$export(module.exports, "colorsConfig", () => $9c5f64135a6f9722$export$fb2992e82b83582a);
$parcel$export(module.exports, "disabledColorConfig", () => $9c5f64135a6f9722$export$9cdea53b8993b139);

var $4nehu = parcelRequire("4nehu");

var $4KIEv = parcelRequire("4KIEv");
const { formatMessage: $9c5f64135a6f9722$var$formatMessage } = (0, $4nehu.createIntl)({
    locale: 'en'
});
const $9c5f64135a6f9722$export$89b67151eed9295a = {
    definition: $9c5f64135a6f9722$var$formatMessage((0, $4KIEv.messages).noClassification),
    includeIcon: false
};
const $9c5f64135a6f9722$export$253bdad208569777 = 50;
const $9c5f64135a6f9722$export$cbc3cef853d1014b = 1000;
const $9c5f64135a6f9722$export$e1444e5b0a63d793 = 1000;
const $9c5f64135a6f9722$export$fb2992e82b83582a = {
    YELLOW: {
        iconColor: "var(--ds-icon-accent-yellow, #B38600)",
        bgColor: "var(--ds-background-accent-yellow-subtlest, #FFF7D6)",
        fontColor: "var(--ds-text, #172B4D)"
    },
    ORANGE: {
        iconColor: "var(--ds-icon-accent-orange, #E56910)",
        bgColor: "var(--ds-background-accent-orange-subtle, #FEA362)",
        fontColor: "var(--ds-text, #172B4D)"
    },
    RED: {
        iconColor: "var(--ds-icon-accent-red, #C9372C)",
        bgColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
        fontColor: "var(--ds-text, #172B4D)"
    },
    RED_BOLD: {
        iconColor: "var(--ds-icon-inverse, #FFFFFF)",
        bgColor: "var(--ds-background-accent-red-bolder, #C9372C)",
        fontColor: "var(--ds-text-inverse, #FFFFFF)"
    },
    PURPLE: {
        iconColor: "var(--ds-icon-accent-purple, #8270DB)",
        bgColor: "var(--ds-background-accent-purple-subtlest, #F3F0FF)",
        fontColor: "var(--ds-text, #172B4D)"
    },
    BLUE: {
        iconColor: "var(--ds-icon-accent-blue, #1D7AFC)",
        bgColor: "var(--ds-background-accent-blue-subtler, #CCE0FF)",
        fontColor: "var(--ds-text, #172B4D)"
    },
    TEAL: {
        iconColor: "var(--ds-icon-accent-teal, #2898BD)",
        bgColor: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
        fontColor: "var(--ds-text, #172B4D)"
    },
    GREEN: {
        iconColor: "var(--ds-icon-accent-green, #22A06B)",
        bgColor: "var(--ds-background-accent-green-subtlest, #DCFFF1)",
        fontColor: "var(--ds-text, #172B4D)"
    },
    GREY: {
        iconColor: "var(--ds-icon-accent-gray, #758195)",
        bgColor: "var(--ds-background-accent-gray-subtlest, #F1F2F4)",
        fontColor: "var(--ds-text, #172B4D)"
    },
    LIME: {
        iconColor: "var(--ds-icon-accent-lime, #6A9A23)",
        bgColor: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
        fontColor: "var(--ds-text, #172B4D)"
    }
};
const $9c5f64135a6f9722$export$9cdea53b8993b139 = {
    iconColor: "var(--ds-icon-disabled, #091E424F)",
    bgColor: "var(--ds-background-disabled, #091E4208)",
    fontColor: "var(--ds-text-disabled, #091E424F)"
};

});
parcelRegister("4KIEv", function(module, exports) {

$parcel$export(module.exports, "messages", () => $5a8a69079aba0ab6$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $5a8a69079aba0ab6$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    noClassification: {
        id: 'data-classification-level.no-classification',
        defaultMessage: 'No classification',
        description: 'Text for the no classification option'
    },
    classifyContent: {
        id: 'data-classification-level.edit-popup.classify-content',
        defaultMessage: 'Classify content',
        description: 'Text for the header of the edit popup'
    },
    selectClassification: {
        id: 'data-classification-level.edit-popup.select-classification',
        defaultMessage: 'Select classification',
        description: 'Text for the label of the select dropdown to select a classification'
    },
    updateButton: {
        id: 'data-classification-level.edit-popup.update-button',
        defaultMessage: 'Update',
        description: 'Text for the update button'
    },
    cancelButton: {
        id: 'data-classification-level.edit-popup.cancel-button',
        defaultMessage: 'Cancel',
        description: 'Text for the cancel button'
    },
    changeLevel: {
        id: 'data-classification-level.read-popup.change-level',
        defaultMessage: 'Change level',
        description: 'Text for the button that changes the level of the selected classification'
    },
    rules: {
        id: 'data-classification-level.rules',
        defaultMessage: '({associatedPoliciesCount, plural, one {# rule} other {# rules}})',
        description: 'Text next to the title of the classification describing the number of rules associated'
    },
    dataClassificationLevel: {
        id: 'data-classification-level.data-classification-level',
        defaultMessage: 'Data classification level',
        description: 'Aria label for data classification level'
    },
    dataClassificationLevelDialog: {
        id: 'data-classification-level.read-popup.data-classification-level',
        defaultMessage: 'Data classification level Dialog',
        description: 'Aria label for data classification level read popup dialog'
    }
});

});


parcelRegister("lBWdS", function(module, exports) {

$parcel$export(module.exports, "ClassificationIcon", () => $2850dd898764d6bc$export$d2e14829910b9b7d);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
const $2850dd898764d6bc$export$d2e14829910b9b7d = ({ color: color, width: width, height: height })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 20 22",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M10.6309 0.724217L10.6368 0.729015L10.6564 0.744926C10.674 0.759116 10.7003 0.780345 10.7346 0.807883C10.8033 0.86297 10.9038 0.94325 11.03 1.04291C11.2825 1.24238 11.637 1.51872 12.0437 1.82565C12.8662 2.44636 13.8693 3.16677 14.6721 3.63718C15.3586 4.03945 16.2922 4.34531 17.1042 4.55315C17.5006 4.65463 17.8498 4.72824 18.0989 4.7763C18.2232 4.80028 18.3219 4.81775 18.3882 4.82904C18.4214 4.83469 18.4464 4.83877 18.4625 4.84135L18.4797 4.84408L18.4828 4.84456C18.9716 4.91866 19.3332 5.33888 19.3332 5.8333C19.3332 11.6129 17.1353 15.5513 14.9124 18.041C13.8065 19.2797 12.6995 20.1547 11.8642 20.7227C11.4461 21.0071 11.0944 21.2155 10.8427 21.3551C10.7168 21.4249 10.6157 21.4775 10.5435 21.5139C10.5074 21.5321 10.4785 21.5462 10.4574 21.5564C10.4469 21.5615 10.4382 21.5655 10.4316 21.5687L10.4231 21.5726L10.4201 21.5741L10.4188 21.5746C10.4183 21.5749 10.4177 21.5751 9.99984 20.6666C9.58193 21.5751 9.58142 21.5749 9.58087 21.5746L9.57961 21.5741L9.57653 21.5726L9.56808 21.5687C9.56477 21.5671 9.56096 21.5653 9.55666 21.5633C9.55235 21.5612 9.54754 21.5589 9.54226 21.5564C9.52113 21.5462 9.49227 21.5321 9.45618 21.5139C9.38402 21.4775 9.2829 21.4249 9.15697 21.3551C8.90523 21.2155 8.55357 21.0071 8.13544 20.7227C7.30013 20.1547 6.19319 19.2797 5.08723 18.041C2.86434 15.5513 0.666504 11.6129 0.666504 5.8333C0.666504 5.56667 0.772986 5.31108 0.962294 5.12331C1.15074 4.9364 1.40573 4.8321 1.67105 4.83331L1.67917 4.83324C1.68856 4.83313 1.70565 4.83282 1.72992 4.832C1.77849 4.83035 1.85559 4.82664 1.9571 4.81831C2.1605 4.80162 2.45966 4.76655 2.82229 4.69315C3.55079 4.5457 4.51413 4.24791 5.47072 3.65142C6.36007 3.09685 7.32664 2.37311 8.08223 1.77725C8.45737 1.48141 8.77527 1.22127 8.99892 1.03546C9.11068 0.942624 9.1987 0.868514 9.25835 0.817986C9.28817 0.792727 9.31088 0.773375 9.3259 0.760538L9.3426 0.74625L9.34728 0.742228C9.7143 0.426181 10.2551 0.418601 10.6309 0.724217ZM2.68698 6.74634C2.9006 11.4629 4.75094 14.6614 6.57911 16.709C7.55649 17.8036 8.53288 18.5744 9.26006 19.0689C9.55402 19.2688 9.80621 19.4228 9.99984 19.5342C10.1935 19.4228 10.4457 19.2688 10.7396 19.0689C11.4668 18.5744 12.4432 17.8036 13.4206 16.709C15.2602 14.6486 17.1222 11.4228 17.3165 6.65758C17.106 6.61216 16.8662 6.55674 16.6082 6.49068C15.741 6.26872 14.5913 5.90791 13.6609 5.36276C12.7521 4.83022 11.6718 4.05063 10.8389 3.42208C10.5278 3.18731 10.2466 2.97006 10.0155 2.78938C9.81835 2.95079 9.58294 3.14086 9.32067 3.34769C8.544 3.96016 7.51057 4.73642 6.52896 5.34851C5.31888 6.10307 4.11556 6.47195 3.21905 6.6534C3.02778 6.69212 2.84951 6.7225 2.68698 6.74634ZM9.99984 20.6666L9.58087 21.5746C9.84611 21.6966 10.1536 21.6966 10.4188 21.5746L9.99984 20.6666Z",
            fill: color
        })
    });
};

});

parcelRegister("bGIeQ", function(module, exports) {

$parcel$export(module.exports, "DropdownLabel", () => $80f0226e3045e7e6$export$bef68440ec6a6159);
$parcel$export(module.exports, "NameLabel", () => $80f0226e3045e7e6$export$63077572f44eb437);
$parcel$export(module.exports, "ContainerLabel", () => $80f0226e3045e7e6$export$3944a9dffaf20407);
$parcel$export(module.exports, "ContainerIcon", () => $80f0226e3045e7e6$export$6d6da6edaddd5876);
$parcel$export(module.exports, "Name", () => $80f0226e3045e7e6$export$c7bd411105e2dec3);
$parcel$export(module.exports, "Definition", () => $80f0226e3045e7e6$export$cf0290ef4b5a4f61);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");
const $80f0226e3045e7e6$export$bef68440ec6a6159 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "label", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c82smr _k48p1pd9",
            __cmplp.className
        ])
    });
});
const $80f0226e3045e7e6$export$63077572f44eb437 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _18u0u2gc _syaz15xy _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
});
const $80f0226e3045e7e6$export$3944a9dffaf20407 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { definitionExists: definitionExists, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, $gt9Am.jsx)(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_t9f321": (0, $awdRS.default)(__cmplp.definitionExists ? "var(--ds-space-100, 8px)" : "var(--ds-space-0, 0px)")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _otyrmjfo",
            __cmplp.className
        ])
    });
});
const $80f0226e3045e7e6$export$6d6da6edaddd5876 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isIconOnly: isIconOnly, colorsConfig: colorsConfig, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, $gt9Am.jsx)(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_139b6h8": (0, $awdRS.default)(__cmplp.isIconOnly ? "var(--ds-space-025, 2px)" : "var(--ds-space-050, 4px)"),
            "--_1udd052": (0, $awdRS.default)(__cmplp.colorsConfig.fontColor),
            "--_s8jg64": (0, $awdRS.default)(__cmplp.colorsConfig.bgColor)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1yt4v77o _2rko1sit _11q71iaf _1e0c116y _p12f1osq _o5721q9c _1bsb1wug _4cvr1h6o _u5f31gh9 _syaz1tdf _uiztglyw",
            __cmplp.className
        ])
    });
});
const $80f0226e3045e7e6$export$c7bd411105e2dec3 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c82smr _1reo15vq _18m915vq _1e0c1txw _4cvr1h6o _k48p19lj _vwz4dlk8 _18u0v77o _1bto1l2s _o5721q9c",
            __cmplp.className
        ])
    });
});
const $80f0226e3045e7e6$export$cf0290ef4b5a4f61 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_syaz15xy _o5721jtm _1i4q1hna _slp31hna",
            __cmplp.className
        ])
    });
});

});



parcelRegister("4frAn", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2902790adf62895$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $d2902790adf62895$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    classificationFieldLabel: {
        "id": "issue-create-commons.data-classification-field.classification-field-label",
        "defaultMessage": "Classification level"
    },
    projectDefaultClassificationOption: {
        "id": "issue-create-commons.data-classification-field.project-default-classification-option",
        "defaultMessage": "Project default"
    },
    noClassificationOption: {
        "id": "issue-create-commons.data-classification-field.no-classification-option",
        "defaultMessage": "Project default - No classification"
    }
});

});


parcelRegister("6M13s", function(module, exports) {

$parcel$export(module.exports, "default", () => $5814bb02885fac4a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $h47gY = parcelRequire("h47gY");

var $ch9En = parcelRequire("ch9En");

var $bQWwW = parcelRequire("bQWwW");

var $4NEt5 = parcelRequire("4NEt5");

var $7jTnu = parcelRequire("7jTnu");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $5814bb02885fac4a$var$ConfigureFieldsModal = (0, $bQWwW.lazy)(()=>(parcelRequire("ge0S8")), {
    ssr: false,
    moduleId: "./src/packages/issue-create/configure-fields/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5814bb02885fac4a$export$2e2bcd8739ae039 = (props)=>(0, $7jTnu.fg)('error_boundaries_to_common_package') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4NEt5.JiraIssueCreateErrorBoundary), {
        id: "async.jira.issue-create.configure-fields",
        packageName: "jiraIssueCreateConfigureFields"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "create-configure-fields-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5814bb02885fac4a$var$ConfigureFieldsModal, props))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
        id: "async.jira.issue-create.configure-fields",
        packageName: "jiraIssueCreateConfigureFields"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "create-configure-fields-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5814bb02885fac4a$var$ConfigureFieldsModal, props)));

});
parcelRegister("ge0S8", function(module, exports) {

let $bcfea15999db7610$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $bcfea15999db7610$var$load("aE9k6").then(()=>parcelRequire('6sSrW'));

});


// SCREENS
const $466f60259c330878$export$f636b5b56f1d624a = 'Screen';
const $466f60259c330878$export$9d2de6eebf7462b5 = 'Drawer';
const $466f60259c330878$export$1171103ea9083ffa = 'Modal';
const $466f60259c330878$export$cae2783c9279926 = 'InlineDialog';
const $466f60259c330878$export$d1123261ca8831d2 = 'Dropdown';
const $466f60259c330878$export$238d30785c4bca84 = 'Banner';
const $466f60259c330878$export$a1562d08625f5d7e = 'UI';
const $466f60259c330878$export$947dac6c72b26f81 = 'TRACK';
const $466f60259c330878$export$f1d537d508d2945a = 'SCREEN';
const $466f60259c330878$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("RxDRv", function(module, exports) {

$parcel$export(module.exports, "useStorageEnforcement", () => $e497a812fe2a563f$export$fa2c25e1ed13a1a8);

var $eJOHy = parcelRequire("eJOHy");

var $ln6Iy = parcelRequire("ln6Iy");

var $bmoS1 = parcelRequire("bmoS1");

var $2aY2d = parcelRequire("2aY2d");


var $8BZZt = parcelRequire("8BZZt");

var $jZn5j = parcelRequire("jZn5j");
const $e497a812fe2a563f$var$MODAL_COOLDOWN_MS = 86400000; // 1 day in ms
const $e497a812fe2a563f$export$fa2c25e1ed13a1a8 = ()=>{
    const [currentState, { setIsOpen: setEnforceStorageModalIsOpen }] = (0, $jZn5j.useEnforceStorageModal)();
    const issueViewMode = (0, $bmoS1.useViewMode)();
    const { data: projectContextData } = (0, $2aY2d.useProjectContext)();
    const isInJSWProject = projectContextData?.projectType === (0, $ln6Iy.SOFTWARE_PROJECT);
    const openModalIfNotOnCooldown = (0, $eJOHy.useCallback)((touchpoint)=>{
        const isOnCooldown = Date.now() - ((0, $8BZZt.localStorage).get((0, $808bbaf5f2b41f58$export$ed785d2382d0101d)) || 0) < $e497a812fe2a563f$var$MODAL_COOLDOWN_MS;
        if (isOnCooldown) {
            if (currentState.isOpen === 'pending') // Reset pending state if modal is on cooldown when it should be shown
            setEnforceStorageModalIsOpen({
                isOpen: 'closed',
                touchpoint: undefined
            });
        } else setEnforceStorageModalIsOpen({
            isOpen: 'open',
            touchpoint: touchpoint
        });
    }, [
        setEnforceStorageModalIsOpen,
        currentState.isOpen
    ]);
    const showEnforcementIfStorageIsFull = (0, $eJOHy.useCallback)(({ delayShow: delayShow = false, shouldOnlyShowInJSWContext: shouldOnlyShowInJSWContext = true, touchpoint: touchpoint })=>{
        if (shouldOnlyShowInJSWContext && !isInJSWProject) return;
        // Issue view use case is checked internally here rather than passed in, to avoid polluting consumer code
        if (delayShow || issueViewMode === 'MODAL') setEnforceStorageModalIsOpen({
            isOpen: 'pending',
            touchpoint: touchpoint
        });
        else openModalIfNotOnCooldown(touchpoint);
    }, [
        isInJSWProject,
        issueViewMode,
        setEnforceStorageModalIsOpen,
        openModalIfNotOnCooldown
    ]);
    // Used to show enforcement modal after modals are dismissed, to avoid modal on modal UX
    const showEnforcementIfPendingToShow = (0, $eJOHy.useCallback)(()=>{
        if (currentState.isOpen === 'pending') // Use the trigger from created the JSW issue
        openModalIfNotOnCooldown(currentState.touchpoint);
    }, [
        currentState.isOpen,
        openModalIfNotOnCooldown,
        currentState.touchpoint
    ]);
    return {
        showEnforcementIfStorageIsFull: showEnforcementIfStorageIsFull,
        showEnforcementIfPendingToShow: showEnforcementIfPendingToShow
    };
};

});
const $808bbaf5f2b41f58$export$b8b9d90f9e5bd72b = 'jira-enforce-storage-limits';
const $808bbaf5f2b41f58$export$ed785d2382d0101d = 'lastStorageEnforcement';

parcelRegister("8BZZt", function(module, exports) {

$parcel$export(module.exports, "localStorage", () => $f8301179366d148d$export$c2ed3351cac403d1);

var $dnU6V = parcelRequire("dnU6V");
const $f8301179366d148d$export$c2ed3351cac403d1 = (0, $dnU6V.createLocalStorageProvider)('enforce-storage-limits');

});


parcelRegister("2U3xv", function(module, exports) {

$parcel$export(module.exports, "UiModificationsContainer", () => $b091d15e22109a87$export$1834060b93715de7);

var $eJOHy = parcelRequire("eJOHy");

var $dAhU7 = parcelRequire("dAhU7");


var $bEJi6 = parcelRequire("bEJi6");
const $b091d15e22109a87$export$1834060b93715de7 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dAhU7.BaseUiModificationsContainer), {
        scope: (0, $6d500eb1fc6bc124$export$e615b7e9b8fb4715),
        viewType: (0, $6d500eb1fc6bc124$export$e615b7e9b8fb4715),
        viewConfiguration: (0, $bEJi6.GICViewConfiguration)
    }, children);

});
parcelRegister("dAhU7", function(module, exports) {

$parcel$export(module.exports, "BaseUiModificationsContainer", () => $b72c991d669ae537$export$8b7a045f60eb9797);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");

var $ftN6c = parcelRequire("ftN6c");

var $i7n3g = parcelRequire("i7n3g");

var $4ZW9p = parcelRequire("4ZW9p");

var $6beFf = parcelRequire("6beFf");
const $b72c991d669ae537$export$8b7a045f60eb9797 = ({ children: children, scope: scope, viewType: viewType, viewConfiguration: viewConfiguration })=>{
    (0, $gRw8I.di)((0, $4ZW9p.LoadedUiModificationsContainer), (0, $i7n3g.UiModificationContextContainer), (0, $ftN6c.useAnalyticsEvents));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    (0, $6beFf.useLoadViewConfiguration)(viewType, viewConfiguration);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4ZW9p.LoadedUiModificationsContainer), {
        scope: scope,
        viewType: viewType,
        createAnalyticsEvent: createAnalyticsEvent,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $i7n3g.UiModificationContextContainer), {
            scope: scope,
            children: children
        })
    });
};

});
parcelRegister("4ZW9p", function(module, exports) {

$parcel$export(module.exports, "LoadedUiModificationsContainer", () => $4bcdbcadbc569d5e$export$b087a12fbb84e8ac);

var $6E16M = parcelRequire("6E16M");

var $ixrOr = parcelRequire("ixrOr");
const $4bcdbcadbc569d5e$export$b087a12fbb84e8ac = (0, $6E16M.createContainer)((0, $ixrOr.store), {
    displayName: 'LoadedUiModificationsContainer',
    onInit: ()=>({ setState: setState }, { viewType: viewType })=>{
            setState({
                viewType: viewType
            });
        }
});

});
parcelRegister("ixrOr", function(module, exports) {

$parcel$export(module.exports, "store", () => $3142574379bc5921$export$6f57813fe9f31bf9);
$parcel$export(module.exports, "useAdjustedField", () => $3142574379bc5921$export$df4b0714e8177e0e);
$parcel$export(module.exports, "useIssueAdjustmentsActions", () => $3142574379bc5921$export$cb9a014ec14556d8);
$parcel$export(module.exports, "useAdjustedScreenTabs", () => $3142574379bc5921$export$677b3e34bd14c681);

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $4XahM = parcelRequire("4XahM");

var $4CM51 = parcelRequire("4CM51");

var $aub9z = parcelRequire("aub9z");

var $cJU1r = parcelRequire("cJU1r");

var $2A1rz = parcelRequire("2A1rz");

var $jfSsT = parcelRequire("jfSsT");

var $hUz0e = parcelRequire("hUz0e");

var $8ZmJu = parcelRequire("8ZmJu");

var $cXMA2 = parcelRequire("cXMA2");

var $5qpxn = parcelRequire("5qpxn");

var $9w3dh = parcelRequire("9w3dh");

var $fkUIk = parcelRequire("fkUIk");

var $bfBqP = parcelRequire("bfBqP");

var $fY47y = parcelRequire("fY47y");

var $dmz3j = parcelRequire("dmz3j");
const $3142574379bc5921$var$name = 'issue-adjustments';
const $3142574379bc5921$export$d4c72bab9d6cc13a = {
    formData: null,
    screenTabs: null,
    appliedChanges: null,
    error: null,
    registeredFieldsDeprecated: {},
    registeredFields: {},
    triggerFieldInitializationKey: 0,
    // Selector checks if this is not equal 0 in the useFieldReady
    numberOfSupportedFields: 0,
    internalFormMetadata: {},
    viewType: null,
    experienceDataIsLoading: false,
    lastProcessedChange: null,
    fieldsInitialization: {
        startTime: null,
        timeoutId: undefined,
        status: 'notStarted'
    },
    appliedChangesHistory: {},
    appsErrors: {},
    notification: null
};
// triggerFieldInitializationKey, viewType and numberOfSupportedFields should not be reset on project or issue type change
const { triggerFieldInitializationKey: $3142574379bc5921$var$triggerFieldInitializationKey, viewType: $3142574379bc5921$var$scopedViewType, numberOfSupportedFields: $3142574379bc5921$var$numberOfSupportedFields, ...$3142574379bc5921$var$stateForResetAllFields } = $3142574379bc5921$export$d4c72bab9d6cc13a;
const $3142574379bc5921$export$e324594224ef24da = {
    triggerFieldInitialization: ()=>({ getState: getState, setState: setState })=>{
            setState({
                triggerFieldInitializationKey: getState().triggerFieldInitializationKey + 1
            });
        },
    processChange: $5qpxn.processChange,
    setFieldValue: $fkUIk.setFieldValue,
    initializeField: $jfSsT.initializeField,
    initializeFields: $jfSsT.initializeFields,
    startFieldsInitialisationTimeout: $2A1rz.startFieldsInitialisationTimeout,
    successFieldsInitalisation: $2A1rz.successFieldsInitalisation,
    registerFields: $9w3dh.registerFields,
    unregisterFields: $9w3dh.unregisterFields,
    updateFields: $fY47y.updateFields,
    clearAppliedValue: (fieldId)=>({ setState: setState, getState: getState })=>{
            const previousState = getState().appliedChanges || {};
            if (previousState[fieldId]) {
                const { value: value, ...otherFieldChanges } = previousState[fieldId];
                setState({
                    appliedChanges: {
                        ...previousState,
                        [fieldId]: otherFieldChanges
                    }
                });
            }
        },
    resetAllFields: ()=>({ setState: setState, getState: getState })=>{
            // Clear the fieldsInitialization timeout to avoid potetianl side effects.
            clearTimeout(getState().fieldsInitialization.timeoutId);
            setState($3142574379bc5921$var$stateForResetAllFields);
        },
    setError: $cJU1r.setError,
    resetError: $cJU1r.resetError,
    setNumberOfSupportedFields: (numberOfAllSupportedFields)=>({ setState: setState })=>{
            setState({
                numberOfSupportedFields: numberOfAllSupportedFields
            });
        },
    /**
	 * This is used to block onInit for specific case like Issue View background refresh loading.
	 */ setExperienceDataIsLoading: (experienceDataIsLoading)=>({ setState: setState })=>{
            setState({
                experienceDataIsLoading: experienceDataIsLoading
            });
        },
    setAppErrors: $4XahM.setAppErrors,
    resetAppErrors: $4XahM.resetAppErrors,
    addAppsErrors: $4XahM.addAppsErrors,
    initializeNoScreenTab: $hUz0e.initializeNoScreenTab,
    initializeScreenTabs: $8ZmJu.initializeScreenTabs,
    updateScreenTabs: $dmz3j.updateScreenTabs,
    updateActiveScreenTab: $bfBqP.updateActiveScreenTab,
    detectAppliedChangesConflicts: $4CM51.detectAppliedChangesConflicts,
    collectScreenTabsAppliedChangesHistory: $aub9z.collectScreenTabsAppliedChangesHistory,
    collectFieldsAppliedChangesHistory: $aub9z.collectFieldsAppliedChangesHistory,
    setNotification: $cXMA2.setNotification,
    resetNotification: $cXMA2.resetNotification
};
const $3142574379bc5921$export$6f57813fe9f31bf9 = (0, $GtRbT.createStore)({
    name: $3142574379bc5921$var$name,
    initialState: $3142574379bc5921$export$d4c72bab9d6cc13a,
    actions: $3142574379bc5921$export$e324594224ef24da
});
const $3142574379bc5921$export$37792a602e748c08 = (0, $iJq0l.createHook)($3142574379bc5921$export$6f57813fe9f31bf9);
const $3142574379bc5921$var$stableEmptyFieldFromIframe = {};
const $3142574379bc5921$export$c76e674a29843e21 = (0, $iJq0l.createHook)($3142574379bc5921$export$6f57813fe9f31bf9, {
    selector: (state)=>state.appliedChanges
});
const $3142574379bc5921$export$df4b0714e8177e0e = (0, $iJq0l.createHook)($3142574379bc5921$export$6f57813fe9f31bf9, {
    selector: (state, fieldId)=>state.appliedChanges?.[fieldId] || $3142574379bc5921$var$stableEmptyFieldFromIframe
});
const $3142574379bc5921$export$cb9a014ec14556d8 = (0, $iJq0l.createActionsHook)($3142574379bc5921$export$6f57813fe9f31bf9);
const $3142574379bc5921$export$677b3e34bd14c681 = (0, $iJq0l.createHook)($3142574379bc5921$export$6f57813fe9f31bf9, {
    selector: (state)=>state.screenTabs
});

});
parcelRegister("4XahM", function(module, exports) {

$parcel$export(module.exports, "setAppErrors", () => $5579267a84760bc0$export$7054e2f8e68cf0dd);
$parcel$export(module.exports, "addAppsErrors", () => $5579267a84760bc0$export$903d525e420c7d00);
$parcel$export(module.exports, "resetAppErrors", () => $5579267a84760bc0$export$24c821207687a907);
const $5579267a84760bc0$export$7054e2f8e68cf0dd = ({ errors: errors, appId: appId })=>({ setState: setState, getState: getState })=>{
        const previousState = getState().appsErrors ?? {};
        setState({
            appsErrors: {
                ...previousState,
                [appId]: errors
            }
        });
    };
const $5579267a84760bc0$export$903d525e420c7d00 = ({ errors: errors })=>({ setState: setState, getState: getState })=>{
        const previousState = getState().appsErrors ?? {};
        const appsErrors = Object.entries(errors).reduce((acc, [appId, appErrors])=>{
            acc[appId] = [
                ...acc[appId] ?? [],
                ...appErrors
            ];
            return acc;
        }, {
            ...previousState
        });
        setState({
            appsErrors: appsErrors
        });
    };
const $5579267a84760bc0$export$24c821207687a907 = ({ appId: appId })=>({ setState: setState, getState: getState })=>{
        const previousState = getState().appsErrors ?? {};
        setState({
            appsErrors: {
                ...previousState,
                [appId]: null
            }
        });
    };

});

parcelRegister("4CM51", function(module, exports) {

$parcel$export(module.exports, "detectAppliedChangesConflicts", () => $8731ff5311f46f9c$export$90d94f20d157e756);

var $gRw8I = parcelRequire("gRw8I");

var $jgvEH = parcelRequire("jgvEH");


var $4XahM = parcelRequire("4XahM");

var $cXMA2 = parcelRequire("cXMA2");

var $7Agw7 = parcelRequire("7Agw7");
const $8731ff5311f46f9c$var$HISTORY_LOG_TTL = 60000;
/**
 * Tidies up applied changes history by removing old entries by TTL.
 * It keeps the current changeId in history.
 */ const $8731ff5311f46f9c$var$tidyUpAppliedChangesHistory = (appliedChangesHistory, changeId)=>Object.fromEntries(Object.entries(appliedChangesHistory).filter(([existingChangeId, history])=>{
        return Date.now() - history.createdAt <= $8731ff5311f46f9c$var$HISTORY_LOG_TTL || existingChangeId === changeId;
    }));
const $8731ff5311f46f9c$export$90d94f20d157e756 = ({ appId: appId, changeId: changeId })=>({ setState: setState, getState: getState, dispatch: dispatch }, { viewType: viewType, createAnalyticsEvent: createAnalyticsEvent })=>{
        (0, $gRw8I.di)((0, $jgvEH.fireOperationalEvent));
        const { appliedChangesHistory: appliedChangesHistory } = getState();
        const tidyAppliedChangesHistory = $8731ff5311f46f9c$var$tidyUpAppliedChangesHistory(appliedChangesHistory, changeId);
        setState({
            appliedChangesHistory: tidyAppliedChangesHistory
        });
        const appliedChangesHistoryChangeId = tidyAppliedChangesHistory[changeId];
        const newChanges = appliedChangesHistoryChangeId?.apps[appId];
        if (!appliedChangesHistoryChangeId || !newChanges || // No need to run conflicts checks for the first item in history
        Object.keys(appliedChangesHistoryChangeId.apps).length <= 1) return;
        const lifecycleHook = changeId === (0, $e65702a72ab5ec3d$export$415cc1afa6445f90) ? 'onInit' : 'onChange';
        const { appErrorsMap: appErrorsMap, conflicts: conflicts } = (0, $7Agw7.collectConflicts)({
            appliedChangesHistory: appliedChangesHistoryChangeId.apps,
            newChanges: newChanges,
            appIdOfNewChanges: appId,
            lifecycleHook: lifecycleHook
        });
        if (conflicts.length) {
            (0, $jgvEH.fireOperationalEvent)(createAnalyticsEvent, {
                action: 'conflicted',
                actionSubject: 'jiraUiModifications.appliedChangesHistory',
                attributes: {
                    conflictsCount: conflicts.length,
                    conflicts: conflicts,
                    conflictedApps: Object.keys(appErrorsMap),
                    viewType: viewType
                }
            });
            dispatch((0, $4XahM.addAppsErrors)({
                errors: appErrorsMap
            }));
            dispatch((0, $cXMA2.setNotification)({
                type: 'MULTIPLE_APPS_CONFLICTS'
            }));
        }
    };

});
parcelRegister("jgvEH", function(module, exports) {

$parcel$export(module.exports, "fireOperationalEvent", () => $cbc5413d6b6dbcfa$export$a1fb57756f0de62b);

var $5fWw9 = parcelRequire("5fWw9");


const $cbc5413d6b6dbcfa$export$a1fb57756f0de62b = (createAnalyticsEvent, eventPayload)=>{
    (0, $5fWw9.default)((0, $0390845c0b61b1a1$export$8280e5c6104c5b40))({
        ...eventPayload,
        analyticsType: (0, $e9db81972dce4ebc$export$12346a674644c156)
    })(createAnalyticsEvent);
};

});
const $e9db81972dce4ebc$export$f636b5b56f1d624a = 'Screen';
const $e9db81972dce4ebc$export$9d2de6eebf7462b5 = 'Drawer';
const $e9db81972dce4ebc$export$1171103ea9083ffa = 'Modal';
const $e9db81972dce4ebc$export$cae2783c9279926 = 'InlineDialog';
const $e9db81972dce4ebc$export$d1123261ca8831d2 = 'Dropdown';
const $e9db81972dce4ebc$export$a1562d08625f5d7e = 'UI';
const $e9db81972dce4ebc$export$947dac6c72b26f81 = 'TRACK';
const $e9db81972dce4ebc$export$f1d537d508d2945a = 'SCREEN';
const $e9db81972dce4ebc$export$12346a674644c156 = 'OPERATIONAL';
const $e9db81972dce4ebc$export$2ceccf177fae277c = 'analyticsBridge';

const $0390845c0b61b1a1$export$8280e5c6104c5b40 = 'ui-modifications';


const $e65702a72ab5ec3d$export$415cc1afa6445f90 = 'onInitChangeId';
const $e65702a72ab5ec3d$export$811b7f067a43b422 = 'jira:uiModifications';

parcelRegister("cXMA2", function(module, exports) {

$parcel$export(module.exports, "setNotification", () => $c89e780a89ca3c37$export$b9c5e783593ff01d);
$parcel$export(module.exports, "resetNotification", () => $c89e780a89ca3c37$export$caafa3945f199bc7);
const $c89e780a89ca3c37$export$b9c5e783593ff01d = (notificationProperties)=>({ setState: setState })=>{
        setState({
            notification: {
                type: notificationProperties.type
            }
        });
    };
const $c89e780a89ca3c37$export$caafa3945f199bc7 = ()=>({ setState: setState })=>{
        setState({
            notification: null
        });
    };

});

parcelRegister("7Agw7", function(module, exports) {

$parcel$export(module.exports, "collectConflicts", () => $6ecf22ae7e9f4956$export$a06103ec99e4e394);

var $jFHCE = parcelRequire("jFHCE");


var $5sAot = parcelRequire("5sAot");

const $6ecf22ae7e9f4956$var$MESSAGE_SUFFIX = 'Modifications have been applied, but it may lead to inconsistency for the user.';
const $6ecf22ae7e9f4956$var$mapToAppErrors = ({ conflicts: conflicts, lifecycleHook: lifecycleHook })=>{
    const appErrors = conflicts.map((change)=>{
        if (change.type === (0, $702a64456849b1c0$export$f674b7a3bbd94b5)) return {
            type: (0, $585e8f7167f61808$export$2a3fdceaae2188d5),
            cause: (0, $585e8f7167f61808$export$877da1000325f8b5),
            lifecycleHook: lifecycleHook,
            message: `Your and other app modified screen tabs in the '${lifecycleHook}' at the same trigger. ${$6ecf22ae7e9f4956$var$MESSAGE_SUFFIX}`
        };
        const { fieldId: fieldId, fieldType: fieldType, property: property } = change;
        const method = (0, $5sAot.mapFieldPropertyToApiMethod)(property);
        return {
            type: (0, $585e8f7167f61808$export$2a3fdceaae2188d5),
            cause: (0, $585e8f7167f61808$export$e4ac32edd5da2ee7),
            fieldId: fieldId,
            fieldType: fieldType,
            method: method,
            lifecycleHook: lifecycleHook,
            message: `Your and other app modified the same field: '${fieldId}' by its method: '${method}' in the '${lifecycleHook}' at the same trigger. ${$6ecf22ae7e9f4956$var$MESSAGE_SUFFIX}`
        };
    });
    return appErrors;
};
const $6ecf22ae7e9f4956$export$a06103ec99e4e394 = ({ appliedChangesHistory: appliedChangesHistory, newChanges: newChanges, appIdOfNewChanges: appIdOfNewChanges, lifecycleHook: lifecycleHook })=>{
    return Object.entries((0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(appliedChangesHistory, appIdOfNewChanges)).reduce((acc, [appId, previousChanges])=>{
        const previousChangesKeys = Object.keys(previousChanges);
        // Compares previous changes with new changes keys
        const conflicts = Object.entries(newChanges).filter(([changeKey, _])=>previousChangesKeys.includes(changeKey)).map(([_, change])=>({
                ...change,
                lifecycleHook: lifecycleHook,
                appIds: [
                    appId,
                    appIdOfNewChanges
                ]
            }));
        acc.conflicts.push(...conflicts);
        // Maps conflicts to app errors
        const appErrors = $6ecf22ae7e9f4956$var$mapToAppErrors({
            conflicts: conflicts,
            lifecycleHook: lifecycleHook
        });
        if (appErrors.length > 0) {
            acc.appErrorsMap[appId] = appErrors;
            // App errors for `appIdOfNewChanges` may already exists from the previous iteration.
            // We need to merge them to avoid overwriting and keep all errors.
            acc.appErrorsMap[appIdOfNewChanges] = [
                ...acc.appErrorsMap[appIdOfNewChanges] ?? [],
                ...appErrors
            ];
        }
        return acc;
    }, {
        appErrorsMap: {},
        conflicts: []
    });
};

});
const $585e8f7167f61808$export$fd26696d109785a0 = 'SCREENTABS_VALIDATION_FAILED';
const $585e8f7167f61808$export$d1996cb46a690190 = 'FIELD_VALIDATION_FAILED';
const $585e8f7167f61808$export$8042247b663edbcc = 'APPLY_CHANGES_FOR_UNREGISTERED_FIELD';
const $585e8f7167f61808$export$2a3fdceaae2188d5 = 'MULTIPLE_APPS_CONFLICT';
const $585e8f7167f61808$export$e4ac32edd5da2ee7 = 'FIELD';
const $585e8f7167f61808$export$877da1000325f8b5 = 'SCREENTABS';

parcelRegister("5sAot", function(module, exports) {

$parcel$export(module.exports, "mapFieldPropertyToApiMethod", () => $2728f69de31c50a0$export$e1cc7da28a1c4bb7);
const $2728f69de31c50a0$var$SET_NAME_METHOD = 'setName';
const $2728f69de31c50a0$var$SET_DESCRIPTION_METHOD = 'setDescription';
const $2728f69de31c50a0$var$SET_VISIBLE_METHOD = 'setVisible';
const $2728f69de31c50a0$var$SET_READ_ONLY_METHOD = 'setReadOnly';
const $2728f69de31c50a0$var$SET_VALUE_METHOD = 'setValue';
const $2728f69de31c50a0$var$SET_REQUIRED_METHOD = 'setRequired';
const $2728f69de31c50a0$var$SET_OPTIONS_VISIBILITY_METHOD = 'setOptionsVisibility';
const $2728f69de31c50a0$export$8325709d137b2606 = {
    fieldName: $2728f69de31c50a0$var$SET_NAME_METHOD,
    description: $2728f69de31c50a0$var$SET_DESCRIPTION_METHOD,
    isVisible: $2728f69de31c50a0$var$SET_VISIBLE_METHOD,
    isReadOnly: $2728f69de31c50a0$var$SET_READ_ONLY_METHOD,
    value: $2728f69de31c50a0$var$SET_VALUE_METHOD,
    isRequired: $2728f69de31c50a0$var$SET_REQUIRED_METHOD,
    optionsVisibility: $2728f69de31c50a0$var$SET_OPTIONS_VISIBILITY_METHOD
};
const $2728f69de31c50a0$export$e1cc7da28a1c4bb7 = (fieldProperty)=>{
    const method = $2728f69de31c50a0$export$8325709d137b2606[fieldProperty];
    if (!method) throw new Error(`No method found for field property: ${fieldProperty}`);
    return method;
};

});

const $702a64456849b1c0$export$f674b7a3bbd94b5 = 'SCREEN_TABS';
const $702a64456849b1c0$export$4a9f236a0db33834 = 'FIELD';



parcelRegister("aub9z", function(module, exports) {

$parcel$export(module.exports, "collectScreenTabsAppliedChangesHistory", () => $94bb1a042906c320$export$1d2b7abeeea36239);
$parcel$export(module.exports, "collectFieldsAppliedChangesHistory", () => $94bb1a042906c320$export$7d0f534e5b16dcc9);


var $gD9lZ = parcelRequire("gD9lZ");
const $94bb1a042906c320$var$prepareAppliedChangesHistoryForSingleChange = ({ currentAppliedChangesHistory: currentAppliedChangesHistory, appId: appId, changeId: changeId, newSingleAppChange: newSingleAppChange })=>{
    const appliedChangesHistoryChangeId = currentAppliedChangesHistory[changeId] ?? {};
    const appliedChangesHistoryChangeIdApp = appliedChangesHistoryChangeId.apps?.[appId] ?? {};
    return {
        ...currentAppliedChangesHistory,
        [changeId]: {
            apps: {
                ...appliedChangesHistoryChangeId.apps,
                [appId]: {
                    ...appliedChangesHistoryChangeIdApp,
                    ...newSingleAppChange
                }
            },
            createdAt: appliedChangesHistoryChangeId.createdAt ?? Date.now()
        }
    };
};
const $94bb1a042906c320$export$1d2b7abeeea36239 = ({ appId: appId, changeId: changeId, screenTabs: screenTabs })=>({ setState: setState, getState: getState })=>{
        const { appliedChangesHistory: appliedChangesHistory } = getState();
        if (!screenTabs.length) return;
        const newAppliedChangesHistory = $94bb1a042906c320$var$prepareAppliedChangesHistoryForSingleChange({
            currentAppliedChangesHistory: appliedChangesHistory,
            appId: appId,
            changeId: changeId,
            newSingleAppChange: {
                tabs: {
                    type: (0, $702a64456849b1c0$export$f674b7a3bbd94b5)
                }
            }
        });
        setState({
            appliedChangesHistory: newAppliedChangesHistory
        });
    };
const $94bb1a042906c320$export$7d0f534e5b16dcc9 = ({ appId: appId, changeId: changeId, fieldsChanges: fieldsChanges })=>({ setState: setState, getState: getState })=>{
        const { appliedChangesHistory: appliedChangesHistory, internalFormMetadata: internalFormMetadata } = getState();
        const singleAppChange = (0, $gD9lZ.normalizeFieldsAppliedChangesForHistory)({
            fieldsChanges: fieldsChanges,
            internalFormMetadata: internalFormMetadata
        });
        const newAppliedChangesHistory = $94bb1a042906c320$var$prepareAppliedChangesHistoryForSingleChange({
            currentAppliedChangesHistory: appliedChangesHistory,
            appId: appId,
            changeId: changeId,
            newSingleAppChange: singleAppChange
        });
        setState({
            appliedChangesHistory: newAppliedChangesHistory
        });
    };

});
parcelRegister("gD9lZ", function(module, exports) {

$parcel$export(module.exports, "normalizeFieldsAppliedChangesForHistory", () => $b80c31bd414cd9d4$export$8a23b3e9a1749620);

const $b80c31bd414cd9d4$var$normalizeFieldForHistory = (fieldId, fieldChanges, fieldMetadata)=>{
    // Can't type Object.keys in a better way
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return Object.keys(fieldChanges).reduce((acc, property)=>{
        const normalizedKey = `${fieldId}|${property}`;
        acc[normalizedKey] = {
            fieldId: fieldId,
            fieldType: fieldMetadata.fieldType,
            property: property,
            type: (0, $702a64456849b1c0$export$4a9f236a0db33834)
        };
        return acc;
    }, {});
};
const $b80c31bd414cd9d4$export$8a23b3e9a1749620 = ({ fieldsChanges: fieldsChanges, internalFormMetadata: internalFormMetadata })=>{
    return Object.entries(fieldsChanges).reduce((acc, [fieldId, fieldChanges])=>{
        const fieldMetadata = internalFormMetadata[fieldId];
        if (!fieldMetadata) return acc;
        const normalizedFieldHistory = $b80c31bd414cd9d4$var$normalizeFieldForHistory(fieldId, fieldChanges, fieldMetadata);
        Object.assign(acc, normalizedFieldHistory);
        return acc;
    }, {});
};

});


parcelRegister("cJU1r", function(module, exports) {

$parcel$export(module.exports, "setError", () => $60a309f31f0bb435$export$b8d0bb2aa0adefe5);
$parcel$export(module.exports, "resetError", () => $60a309f31f0bb435$export$7e5930c6217b1d4e);
const $60a309f31f0bb435$export$b8d0bb2aa0adefe5 = (errorProperties)=>({ setState: setState })=>{
        setState({
            error: {
                errorCode: errorProperties.errorCode,
                fieldName: errorProperties.fieldName
            }
        });
    };
const $60a309f31f0bb435$export$7e5930c6217b1d4e = ()=>({ setState: setState })=>{
        setState({
            error: null
        });
    };

});

parcelRegister("2A1rz", function(module, exports) {

$parcel$export(module.exports, "startFieldsInitialisationTimeout", () => $601c25cd313fe741$export$2c0f020b89dfa30b);
$parcel$export(module.exports, "successFieldsInitalisation", () => $601c25cd313fe741$export$cf768a695e83eefa);

var $gRw8I = parcelRequire("gRw8I");

var $jgvEH = parcelRequire("jgvEH");

var $ieQ0v = parcelRequire("ieQ0v");

var $cJU1r = parcelRequire("cJU1r");
const $601c25cd313fe741$var$getTimeout = ()=>50000;
const $601c25cd313fe741$var$getFieldsInitializationTime = (startTime)=>startTime !== null ? performance.now() - startTime : null;
const $601c25cd313fe741$var$isFieldInitialisationComplete = (status)=>status === 'success' || status === 'timedOut';
const $601c25cd313fe741$export$2c0f020b89dfa30b = ({ createAnalyticsEvent: createAnalyticsEvent })=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
        const { fieldsInitialization: fieldsInitialization } = getState();
        if (fieldsInitialization.timeoutId === undefined && fieldsInitialization.status === 'notStarted') {
            const timeoutId = setTimeout(()=>dispatch($601c25cd313fe741$export$8ce83a9201590a5e({
                    createAnalyticsEvent: createAnalyticsEvent
                })), $601c25cd313fe741$var$getTimeout());
            setState({
                fieldsInitialization: {
                    startTime: performance.now(),
                    timeoutId: timeoutId,
                    status: 'inProgress'
                }
            });
        }
    };
const $601c25cd313fe741$export$8ce83a9201590a5e = ({ createAnalyticsEvent: createAnalyticsEvent })=>({ getState: getState, setState: setState, dispatch: dispatch }, { viewType: viewType })=>{
        (0, $gRw8I.di)((0, $jgvEH.fireOperationalEvent));
        const { formData: formData, experienceDataIsLoading: experienceDataIsLoading, numberOfSupportedFields: numberOfSupportedFields, fieldsInitialization: fieldsInitialization } = getState();
        const { startTime: startTime, status: status } = fieldsInitialization;
        if ($601c25cd313fe741$var$isFieldInitialisationComplete(status) || (0, $ieQ0v.selectReadyPublicDataForOnInit)(getState(), {
            viewType: viewType
        }) !== null) return;
        dispatch((0, $cJU1r.setError)({
            errorCode: 'ON_INIT_FIELDS_INITIALIZATION_TIMEOUT'
        }));
        (0, $jgvEH.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'timedOut',
            actionSubject: 'jiraUiModifications.fieldsInitialization',
            attributes: {
                previousStatus: status,
                configuredTimeout: $601c25cd313fe741$var$getTimeout(),
                fieldsInitializationTime: $601c25cd313fe741$var$getFieldsInitializationTime(startTime),
                initalizedFieldsCount: Object.keys(formData ?? {}).length,
                experienceDataIsLoading: experienceDataIsLoading,
                supportedFieldsCount: numberOfSupportedFields,
                viewType: viewType
            }
        });
        setState({
            fieldsInitialization: {
                ...fieldsInitialization,
                status: 'timedOut'
            }
        });
    };
const $601c25cd313fe741$export$cf768a695e83eefa = ({ createAnalyticsEvent: createAnalyticsEvent })=>({ getState: getState, setState: setState }, { viewType: viewType })=>{
        (0, $gRw8I.di)((0, $jgvEH.fireOperationalEvent));
        const { status: status } = getState().fieldsInitialization;
        if ($601c25cd313fe741$var$isFieldInitialisationComplete(status)) return;
        const { numberOfSupportedFields: numberOfSupportedFields, fieldsInitialization: fieldsInitialization } = getState();
        const { timeoutId: timeoutId, startTime: startTime } = fieldsInitialization;
        clearTimeout(timeoutId);
        (0, $jgvEH.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'success',
            actionSubject: 'jiraUiModifications.fieldsInitialization',
            attributes: {
                previousStatus: status,
                fieldsInitializationTime: $601c25cd313fe741$var$getFieldsInitializationTime(startTime),
                initalizedFieldsCount: numberOfSupportedFields,
                viewType: viewType
            }
        });
        setState({
            fieldsInitialization: {
                ...fieldsInitialization,
                status: 'success'
            }
        });
    };

});
parcelRegister("ieQ0v", function(module, exports) {

$parcel$export(module.exports, "selectReadyPublicDataForOnInit", () => $d3350efc4111ec81$export$4cadeedb8c3f31f7);

var $4MchI = parcelRequire("4MchI");
const $d3350efc4111ec81$export$4cadeedb8c3f31f7 = (0, $4MchI.createSelector)((state)=>state.formData, (state)=>state.numberOfSupportedFields, (state)=>state.screenTabs, (state)=>state.experienceDataIsLoading, (formData, numberOfSupportedFields, screenTabsData, experienceDataIsLoading)=>{
    if (formData !== null && screenTabsData !== null && numberOfSupportedFields !== 0 && experienceDataIsLoading === false && Object.keys(formData).length === numberOfSupportedFields) return {
        formData: formData,
        screenTabsData: screenTabsData
    };
    return null;
});

});


parcelRegister("jfSsT", function(module, exports) {

$parcel$export(module.exports, "initializeField", () => $a40b94674a995fd7$export$6b51e123e61a9615);
$parcel$export(module.exports, "initializeFields", () => $a40b94674a995fd7$export$4a6b4707110b0552);

var $37MnT = parcelRequire("37MnT");
const $a40b94674a995fd7$export$6b51e123e61a9615 = ({ field: field, metadata: metadata })=>({ getState: getState, setState: setState }, { viewType: viewType })=>{
        const { internalFormMetadata: internalFormMetadata, formData: formData = {} } = getState();
        const fieldMetadata = {
            allowedValues: field.allowedValues,
            isReadOnlyBySystem: field.isReadOnly,
            isRequiredBySystem: field.isRequired,
            fieldRenderer: metadata?.fieldRenderer,
            fieldType: field.fieldType
        };
        const publicValue = (0, $37MnT.mapFieldValueFromInternalToPublic)({
            fieldMetadata: fieldMetadata,
            internalFieldValue: field.value,
            fieldType: field.fieldType,
            viewType: viewType
        });
        setState({
            formData: {
                ...formData,
                [field.fieldId]: {
                    fieldId: field.fieldId,
                    fieldName: field.fieldName,
                    description: field.description,
                    isVisible: field.isVisible,
                    fieldType: field.fieldType,
                    isReadOnly: field.isReadOnly,
                    isRequired: field.isRequired,
                    value: publicValue,
                    optionsVisibility: undefined
                }
            },
            internalFormMetadata: {
                ...internalFormMetadata,
                [field.fieldId]: fieldMetadata
            }
        });
    };
const $a40b94674a995fd7$export$4a6b4707110b0552 = (fields)=>({ setState: setState }, { viewType: viewType })=>{
        const { formData: formData, internalFormMetadata: internalFormMetadata } = fields.reduce((acc, { field: field, metadata: metadata })=>{
            const fieldMetadata = {
                allowedValues: field.allowedValues,
                isReadOnlyBySystem: field.isReadOnly,
                isRequiredBySystem: field.isRequired,
                fieldRenderer: metadata?.fieldRenderer,
                fieldType: field.fieldType
            };
            const publicValue = (0, $37MnT.mapFieldValueFromInternalToPublic)({
                fieldMetadata: fieldMetadata,
                internalFieldValue: field.value,
                fieldType: field.fieldType,
                viewType: viewType
            });
            acc.formData[field.fieldId] = {
                fieldId: field.fieldId,
                fieldName: field.fieldName,
                description: field.description,
                isVisible: field.isVisible,
                fieldType: field.fieldType,
                isReadOnly: field.isReadOnly,
                isRequired: field.isRequired,
                value: publicValue,
                optionsVisibility: undefined
            };
            acc.internalFormMetadata[field.fieldId] = fieldMetadata;
            return acc;
        }, {
            internalFormMetadata: {},
            formData: {}
        });
        setState({
            formData: formData,
            internalFormMetadata: internalFormMetadata,
            numberOfSupportedFields: fields.length
        });
    };

});
parcelRegister("37MnT", function(module, exports) {

$parcel$export(module.exports, "mapFieldValueFromInternalToPublic", () => $cc8ab347810a3948$export$50806045b617d116);

var $gRw8I = parcelRequire("gRw8I");

var $1qarT = parcelRequire("1qarT");

var $82wKS = parcelRequire("82wKS");
const $cc8ab347810a3948$export$50806045b617d116 = ({ fieldMetadata: fieldMetadata, internalFieldValue: internalFieldValue, fieldType: fieldType, viewType: viewType })=>{
    (0, $gRw8I.di)((0, $1qarT.fireErrorAnalytics), (0, $82wKS.getSupportedFieldConfiguration));
    if (fieldMetadata === undefined) throw new Error('Attempt to set value for the uninitialized field');
    let value = internalFieldValue;
    try {
        const valueTransformer = (0, $82wKS.getSupportedFieldConfiguration)(viewType, fieldType)?.internalToPublicTransformers.value;
        if (valueTransformer) /**
			 * We trust that the internal field data is in the correct shape.
			 * Data that is in the incorrect shape will result in error events
			 * being logged for further investigation. In this error case we will
			 * pass `null` as the value to unblock onInit for the apps
			 *
			 * The `fieldRenderer` passed to the `valueTransformer` is used only for
			 * rich text fields and will be `undefined` for most of the executions
			 */ value = valueTransformer(internalFieldValue, fieldMetadata?.fieldRenderer);
    } catch (error) {
        value = null;
        (0, $1qarT.fireErrorAnalytics)({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: error,
            id: 'internalToPublicValueTransformer',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
    }
    return value;
};

});
parcelRegister("1qarT", function(module, exports) {

$parcel$export(module.exports, "fireErrorAnalytics", () => $7486f28a569b9ec0$export$a27c21aa3ed8f0f1);

var $7U6OJ = parcelRequire("7U6OJ");

var $cMdIN = parcelRequire("cMdIN");
const $7486f28a569b9ec0$export$1bee4e6be783dd26 = (message)=>message.replaceAll(/\w+@[\w.]+/gi, '***@***');
const $7486f28a569b9ec0$export$a27c21aa3ed8f0f1 = ({ error: error, id: id, viewType: viewType, attributes: attributes = {}, event: event })=>{
    const errorType = (0, $cMdIN.getErrorType)(error);
    const packageName = `${viewType}jiraUiModifications`;
    (0, $7U6OJ.fireErrorAnalytics)({
        event: event,
        meta: {
            id: id,
            packageName: packageName,
            teamName: 'unbox'
        },
        error: error,
        attributes: {
            errorType: errorType,
            errorMessage: typeof error.message === 'string' ? $7486f28a569b9ec0$export$1bee4e6be783dd26(error.message) : error.message,
            ...attributes
        }
    });
};

});
parcelRegister("cMdIN", function(module, exports) {

$parcel$export(module.exports, "getErrorType", () => $c511a0dff3897a12$export$e19f9f08a6d79fd2);

var $l58EO = parcelRequire("l58EO");
const $c511a0dff3897a12$var$commonErrors = {
    MUST_INCLUDE_ACCOUNT_ID: 'Response ended with an error message: Requests from this source must include an accountId',
    OPERATION_ABORTED: 'The operation was aborted. ',
    CANCELLED: 'cancelled',
    UNEXPECTED_ERROR_OCCURRED: 'Response ended with an error message: An unexpected error occurred',
    NETWORK_CONNECTION_LOST: 'The network connection was lost.',
    TIMEOUT: 'The request timed out.',
    AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS: 'Response ended with an error message: Authorization failed: Principal has insufficient permissions',
    GATEWAY_TIMEOUT: 'Response ended with an error message: The underlying service call failed. The underlying service cs_extensions status code is : 504'
};
const $c511a0dff3897a12$export$23de3198bfe70090 = 'DATA_CLASSIFICATION_NO_ACCESS';
const $c511a0dff3897a12$export$f52aa41ccd776f01 = 'FAILED_TO_FETCH';
const $c511a0dff3897a12$export$31d2ab0be67934f0 = 'AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS';
const $c511a0dff3897a12$export$7a1bd8c001e7e9c = 'RATE_LIMITING';
const $c511a0dff3897a12$export$89a175d4190df42e = 'Invoke value functions failed:';
const $c511a0dff3897a12$export$215c097832f3122d = 'AGG_UNDERLYING_SERVICE_TIMEOUT';
const $c511a0dff3897a12$export$dddade71b333c01d = new RegExp('The user did not consent to use the app', 'i');
const $c511a0dff3897a12$var$BAD_REQUEST = 400;
const $c511a0dff3897a12$var$REQUEST_TIMEOUT = 408;
const $c511a0dff3897a12$export$8a5d666d6e5b82fc = (error)=>{
    // React loosely lazy chunk load error type
    if (typeof error === 'object' && error.name === 'ChunkLoadError') return true;
    // Other chunk load error types
    // In theory it should be handled by a common isClientFetchError, but it ignores TypeError error types
    const KNOWN_NETWORK_ERRORS = [
        'Failed to fetch dynamically imported module',
        'error loading dynamically imported module',
        'Importing a module script failed',
        'Cannot find module'
    ];
    const isClientFetchErrorMessage = (message)=>Boolean(message) && !!KNOWN_NETWORK_ERRORS.find((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
            // are sometimes wrapped to provide additional context, e.g.
            // "Something went wrong: ${error.message}"
            message.includes(networkErrorMessage));
    return Boolean(error) && typeof error === 'object' && (isClientFetchErrorMessage(error.message) || typeof error.cause === 'object' && error.cause && 'message' in error.cause && isClientFetchErrorMessage(String(error.cause.message)));
};
const $c511a0dff3897a12$export$e19f9f08a6d79fd2 = (_error)=>{
    if (_error == null) return 'NULL_OR_UNDEFINED';
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const error = _error;
    const message = String(error instanceof Error ? error.message : error).trim();
    const isTimeoutError = (timedOutResource)=>Boolean(typeof error === 'object' && error.name === 'TimeoutError' && error.stack?.includes(timedOutResource));
    if (message === "A hidden extension shouldn't be rendered") return 'HIDDEN_EXTENSION_RENDER_ATTEMPT';
    const circuitBreakerErrorRegex = new RegExp("We couldn't show this extension", 'i');
    if (circuitBreakerErrorRegex.test(message)) return 'CIRCUIT_BREAKER_ERROR';
    const rateLimitingRegex = new RegExp("Response ended with an error message: You are trying to access '.*' too often", 'i');
    const rateLimitingDataClassificationRegex = new RegExp('Data classification request failed: Error server response: 429');
    if (rateLimitingRegex.test(message) || rateLimitingDataClassificationRegex.test(message)) return $c511a0dff3897a12$export$7a1bd8c001e7e9c;
    const serverErrorRegex = new RegExp('^Error server response: (\\d+)$', 'i');
    if (serverErrorRegex.test(message)) {
        const match = message.match(serverErrorRegex);
        const statusCode = match ? match[1] : 'NO_STATUS_CODE';
        return `ERROR_SERVER_RESPONSE_${statusCode}`;
    }
    const aggGiraServerErrorRegex = new RegExp('The underlying service gira status code is: (\\d+)$', 'im');
    if (aggGiraServerErrorRegex.test(message)) {
        const match = message.match(aggGiraServerErrorRegex);
        const statusCode = match?.[1] ?? 'NO_STATUS_CODE';
        return `AGG_GIRA_ERROR_${statusCode}`;
    }
    const dataClassification404ErrorRegex = new RegExp('Data classification request failed: Error server response: 404', 'i');
    const dataClassification401ErrorRegex = new RegExp('Data classification request failed: Error server response: 401', 'i');
    if (dataClassification401ErrorRegex.test(message) || dataClassification404ErrorRegex.test(message)) return $c511a0dff3897a12$export$23de3198bfe70090;
    // Add here errors related to a broken app configuration/manifest
    if (message.startsWith('Function definition is invalid.')) return 'APP_DEV_ERROR';
    const graphqlErrorRegex = new RegExp('^GraphQL error', 'i');
    if (graphqlErrorRegex.test(message)) return 'GRAPHQL_ERROR';
    if ($c511a0dff3897a12$export$dddade71b333c01d.test(message)) return 'USER_DIDNT_CONSENT_ERROR';
    const aggUnderlyingServiceTimeoutRegex = new RegExp('The underlying service call timed out', 'i');
    if (aggUnderlyingServiceTimeoutRegex.test(message)) return $c511a0dff3897a12$export$215c097832f3122d;
    const appValueFunction = new RegExp("The app's value function failed", 'i');
    const serverValueFunction408ErrorRegex = new RegExp('Invoke value functions failed: Error server response: 408', 'i');
    const invokeValueFunctionFailed = new RegExp($c511a0dff3897a12$export$89a175d4190df42e, 'i');
    /**
	 * In case when we get bad request(400) from the BE it should be treated as an app error as there
	 * are many ways to fail the value function
	 */ const valueFunctionAppsBadRequest = invokeValueFunctionFailed.test(message) && 'statusCode' in error && error.statusCode === $c511a0dff3897a12$var$BAD_REQUEST;
    /**
	 * In case when we get request timeout(408) from the XIS invocation it should be treated as an app error.
	 * Error occurs when invocation exceeds 25s threshold e.g.too long time to execute request to external API
	 */ const valueFunctionTimeoutError = serverValueFunction408ErrorRegex.test(message) && 'statusCode' in error && error.statusCode === $c511a0dff3897a12$var$REQUEST_TIMEOUT;
    if (appValueFunction.test(message) || valueFunctionTimeoutError || valueFunctionAppsBadRequest) return 'VALUE_FUNCTION_APP_ERROR';
    /*
	 * 	Whole message:
	 *	Fetching formatted value after edit failed: FetchError: Fetch call failed with status code: 429
	 */ const valueFunctionEditRateLimitedRegex = new RegExp('Fetch call failed with status code: 429', 'i');
    /*
	 * 	Whole message:
	 *	Invoke value functions failed: Error server response: 429
	 */ const valueFunctionInvokeRateLimitedRegex = new RegExp('Error server response: 429', 'i');
    if (valueFunctionEditRateLimitedRegex.test(message) || valueFunctionInvokeRateLimitedRegex.test(message)) return $c511a0dff3897a12$export$7a1bd8c001e7e9c;
    // The full message states:
    // Extension "extension name" does not exist, the app may have changed or no longer be installed in this context
    const extensionDoesntExistRegex = new RegExp('^Extension "(.*)" does not exist', 'i');
    if (extensionDoesntExistRegex.test(message)) return 'EXTENSION_DOESNT_EXIST';
    // In case of React error message:
    // Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node.
    const removeChildOnNodeRegex = new RegExp("^Failed to execute 'removeChild' on 'Node'", 'i');
    if (removeChildOnNodeRegex.test(message)) return 'REMOVE_CHILD_ERROR';
    if ($c511a0dff3897a12$export$8a5d666d6e5b82fc(error)) return 'CHUNK_LOAD';
    if (isTimeoutError('FORGE_PROJECT_MODULE')) return 'TIMEOUT_PROJECT_MODULE';
    if (isTimeoutError('FORGE_PROJECT_SETTINGS_MODULE')) return 'TIMEOUT_PROJECT_SETTINGS_MODULE';
    if (isTimeoutError('PROJECT_CONTEXT')) return 'TIMEOUT_PROJECT_CONTEXT';
    const entry = Object.entries($c511a0dff3897a12$var$commonErrors).find((arrayItem)=>String(arrayItem[1]).toLowerCase() === message.toLowerCase());
    if (entry) return entry[0];
    if ((0, $l58EO.isClientFetchError)(error)) return $c511a0dff3897a12$export$f52aa41ccd776f01;
    if (error != null && 'statusCode' in error && error.statusCode === 429) return 'RATE_LIMITING';
    return 'OTHER';
};

});
parcelRegister("l58EO", function(module, exports) {

$parcel$export(module.exports, "isClientFetchError", () => $cd5265fc67dbb6eb$export$2e7adc44463c3f4f);
// Copied from jira/src/packages/platform/utils/fetch/src/utils/is-error.tsx
// Exclude client connectivity and HTTP client network errors as a SLO failure
// e.g. during quick SPA transition when a network call haven't finished yet,
// or when the user's internet connection drops out.
const $cd5265fc67dbb6eb$export$c748438cec453c9f = [
    '... is not valid JSON',
    'server with the specified hostname could not be found',
    'cannot parse response',
    'connection failure',
    'Failed to fetch',
    'in JSON at position 0',
    'JSON.parse: unexpected character at line 1 column 1 of the JSON data',
    'JSON.parse: unexpected end of data at line 1 column 1 of the JSON data',
    'Load failed',
    'Network request failed',
    'NetworkError',
    'Syntax or http error',
    'The request timed out',
    'The network connection was lost',
    'The operation was aborted',
    'Unable to fetch manifest',
    'Unexpected end of input',
    'Unexpected end of JSON input',
    'dynamically imported module',
    'Importing a module script failed'
];
const $cd5265fc67dbb6eb$export$3876cb851aa46193 = [
    'AbortError',
    'AuthError',
    'ChunkLoadError',
    'NetworkError'
];
const $cd5265fc67dbb6eb$var$isClientFetchErrorMessage = (message)=>Boolean(message) && $cd5265fc67dbb6eb$export$c748438cec453c9f.some((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
        // are sometimes wrapped to provide additional context, e.g.
        // "Something went wrong: ${error.message}"
        message.includes(networkErrorMessage));
const $cd5265fc67dbb6eb$export$2e7adc44463c3f4f = (error)=>Boolean(error) && typeof error === 'object' && ($cd5265fc67dbb6eb$export$3876cb851aa46193.includes(error.name) || $cd5265fc67dbb6eb$var$isClientFetchErrorMessage(error.message) || typeof error.cause === 'object' && ($cd5265fc67dbb6eb$export$3876cb851aa46193.includes(error.cause.name) || $cd5265fc67dbb6eb$var$isClientFetchErrorMessage(error.cause.message)));

});



parcelRegister("82wKS", function(module, exports) {

$parcel$export(module.exports, "getSupportedFieldConfiguration", () => $0757a5b98ef450f3$export$8fc8d6775f1842b8);
$parcel$export(module.exports, "isFieldTypeSupported", () => $0757a5b98ef450f3$export$b47920a5dd99844f);
$parcel$export(module.exports, "getConsentMessage", () => $0757a5b98ef450f3$export$20eabd2b3ada6bf3);
$parcel$export(module.exports, "isExecutionContextSupported", () => $0757a5b98ef450f3$export$b768d6a95f7a930);
$parcel$export(module.exports, "getAnalytics", () => $0757a5b98ef450f3$export$b0297573c90085aa);
$parcel$export(module.exports, "isTriggerPointSupported", () => $0757a5b98ef450f3$export$ef45e4471aa21b27);

var $1qarT = parcelRequire("1qarT");

var $6beFf = parcelRequire("6beFf");
const $0757a5b98ef450f3$var$isKeyOf = (key, object)=>object[key] !== undefined;
const $0757a5b98ef450f3$var$getConfigurationByViewType = ({ viewType: viewType })=>{
    const viewConfiguration = (0, $6beFf.getViewConfiguration)(viewType);
    if (!viewConfiguration) throw new Error(`Unsupported view type ${viewType} in getConfigurationByViewType.`);
    return viewConfiguration;
};
function $0757a5b98ef450f3$export$8fc8d6775f1842b8(viewType, fieldType) {
    const fieldsConfiguration = $0757a5b98ef450f3$var$getConfigurationByViewType({
        viewType: viewType
    }).getSupportedFieldsConfiguration();
    if (!$0757a5b98ef450f3$var$isKeyOf(fieldType, fieldsConfiguration)) {
        (0, $1qarT.fireErrorAnalytics)({
            error: new Error('Unsupported field type.'),
            id: 'getSupportedFieldConfiguration',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
        return undefined;
    }
    return fieldsConfiguration[fieldType];
}
const $0757a5b98ef450f3$export$e4330d77fd93d1de = (viewType)=>$0757a5b98ef450f3$var$getConfigurationByViewType({
        viewType: viewType
    }).getSupportedFieldTypes();
function $0757a5b98ef450f3$export$b47920a5dd99844f(viewType, fieldType) {
    return fieldType !== undefined && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $0757a5b98ef450f3$export$e4330d77fd93d1de(viewType).includes(fieldType);
}
function $0757a5b98ef450f3$export$20eabd2b3ada6bf3(viewType) {
    return $0757a5b98ef450f3$var$getConfigurationByViewType({
        viewType: viewType
    }).getConsentMessage();
}
function $0757a5b98ef450f3$export$b768d6a95f7a930(context) {
    return $0757a5b98ef450f3$var$getConfigurationByViewType({
        viewType: context.viewType
    }).isExecutionContextSupported({
        context: context
    });
}
function $0757a5b98ef450f3$export$b0297573c90085aa(viewType) {
    return $0757a5b98ef450f3$var$getConfigurationByViewType({
        viewType: viewType
    }).getAnalytics();
}
function $0757a5b98ef450f3$export$c0728caa743a409e(viewType) {
    return $0757a5b98ef450f3$var$getConfigurationByViewType({
        viewType: viewType
    }).getSupportedTriggerPointsConfiguration();
}
const $0757a5b98ef450f3$export$ef45e4471aa21b27 = (viewType, triggerPoint)=>triggerPoint !== undefined && $0757a5b98ef450f3$export$c0728caa743a409e(viewType).has(triggerPoint);

});
parcelRegister("6beFf", function(module, exports) {

$parcel$export(module.exports, "getViewConfiguration", () => $9cd8cd98b7c2eeee$export$176b6e68da08ffa2);
$parcel$export(module.exports, "useLoadViewConfiguration", () => $9cd8cd98b7c2eeee$export$f0022a21ccd1f6be);

var $eJOHy = parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");
const $9cd8cd98b7c2eeee$var$VIEW_CONFIGURATIONS = new Map();
const $9cd8cd98b7c2eeee$export$cda1ad403b37fe70 = (viewType, configuration)=>{
    if (!$9cd8cd98b7c2eeee$var$VIEW_CONFIGURATIONS.has(viewType)) $9cd8cd98b7c2eeee$var$VIEW_CONFIGURATIONS.set(viewType, configuration);
};
const $9cd8cd98b7c2eeee$export$176b6e68da08ffa2 = (viewType)=>$9cd8cd98b7c2eeee$var$VIEW_CONFIGURATIONS.get(viewType);
const $9cd8cd98b7c2eeee$export$e8091eff40c4f16e = ()=>{
    $9cd8cd98b7c2eeee$var$VIEW_CONFIGURATIONS.clear();
};
const $9cd8cd98b7c2eeee$export$f0022a21ccd1f6be = (viewType, configurationClass)=>{
    (0, $gRw8I.di)($9cd8cd98b7c2eeee$export$cda1ad403b37fe70);
    /**
	 * Uses useState to load view configuration on component mount, before rendering.
	 */ (0, $eJOHy.useState)(()=>{
        $9cd8cd98b7c2eeee$export$cda1ad403b37fe70(viewType, new configurationClass());
    });
};

});




parcelRegister("hUz0e", function(module, exports) {

$parcel$export(module.exports, "initializeNoScreenTab", () => $7faac090c61abadc$export$93459ad9bfd6c380);
const $7faac090c61abadc$export$93459ad9bfd6c380 = ()=>({ setState: setState })=>{
        setState({
            screenTabs: []
        });
    };

});

parcelRegister("8ZmJu", function(module, exports) {

$parcel$export(module.exports, "initializeScreenTabs", () => $5faefcecd8cba222$export$7f7be235f64f029b);
const $5faefcecd8cba222$export$7f7be235f64f029b = ({ tabs: tabs, selected: selected })=>({ getState: getState, setState: setState })=>{
        const { screenTabs: internalScreenTabs } = getState();
        const previouslySelected = internalScreenTabs?.findIndex((tab)=>tab.isActive);
        setState({
            screenTabs: tabs.map(({ id: id }, index)=>({
                    id: id,
                    isVisible: true,
                    isActive: index === selected || index === previouslySelected
                }))
        });
    };

});

parcelRegister("5qpxn", function(module, exports) {

$parcel$export(module.exports, "processChange", () => $bbbbfc09b273134e$export$352dfcce04d66748);

var $9UJzd = parcelRequire("9UJzd");

var $gRw8I = parcelRequire("gRw8I");

var $82wKS = parcelRequire("82wKS");

var $5ldku = parcelRequire("5ldku");
const $bbbbfc09b273134e$export$352dfcce04d66748 = ({ fieldId: fieldId, fieldValue: fieldValue, eventType: eventType })=>({ setState: setState, getState: getState }, { viewType: viewType })=>{
        (0, $gRw8I.di)((0, (/*@__PURE__*/$parcel$interopDefault($9UJzd))));
        const { internalFormMetadata: internalFormMetadata, formData: formData } = getState();
        const fieldType = internalFormMetadata[fieldId]?.fieldType;
        if (!fieldType) return;
        const emitChangeOn = (0, $82wKS.getSupportedFieldConfiguration)(viewType, fieldType)?.emitChangeOn;
        if (emitChangeOn !== eventType) return;
        const nextFormData = (0, $5ldku.calculateNextFormValue)({
            internalFormMetadata: internalFormMetadata,
            formData: formData,
            fieldType: fieldType,
            fieldId: fieldId,
            fieldValue: fieldValue,
            viewType: viewType
        });
        if (nextFormData === null) return;
        /**
		 * setTimeout justification - we need to delay the state update to the next tick to avoid batched updates.
		 * Otherwise, UIM app may not be notified about every single change.
		 */ setTimeout(()=>{
            const changeId = (0, (/*@__PURE__*/$parcel$interopDefault($9UJzd)))();
            setState({
                lastProcessedChange: {
                    fieldId: fieldId,
                    changeId: changeId
                },
                formData: nextFormData
            });
        }, 0);
    };

});
parcelRegister("9UJzd", function(module, exports) {

var $cz1WF = parcelRequire("cz1WF");
/** Used to generate unique IDs. */ var $737cb0a939387270$var$idCounter = 0;
/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */ function $737cb0a939387270$var$uniqueId(prefix) {
    var id = ++$737cb0a939387270$var$idCounter;
    return $cz1WF(prefix) + id;
}
module.exports = $737cb0a939387270$var$uniqueId;

});

parcelRegister("5ldku", function(module, exports) {

$parcel$export(module.exports, "calculateNextFormValue", () => $e9fdc7a6e4eab5b9$export$25441a03bb8f1cb0);

var $cSmYj = parcelRequire("cSmYj");

var $37MnT = parcelRequire("37MnT");
const $e9fdc7a6e4eab5b9$export$25441a03bb8f1cb0 = ({ internalFormMetadata: internalFormMetadata, formData: formData, fieldId: fieldId, fieldValue: fieldValue, fieldType: fieldType, viewType: viewType })=>{
    if (formData === null) return null;
    let newPublicValue;
    try {
        newPublicValue = (0, $37MnT.mapFieldValueFromInternalToPublic)({
            fieldMetadata: internalFormMetadata[fieldId],
            internalFieldValue: fieldValue,
            fieldType: fieldType,
            viewType: viewType
        });
    } catch (e) {
        return null;
    }
    const currentPublicValue = formData[fieldId]?.value;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(newPublicValue, currentPublicValue)) return null;
    return {
        ...formData,
        [fieldId]: {
            ...formData[fieldId],
            value: newPublicValue
        }
    };
};

});


parcelRegister("9w3dh", function(module, exports) {

$parcel$export(module.exports, "registerFields", () => $60e092cfdd3e6be9$export$d4eb181b231cf88d);
$parcel$export(module.exports, "unregisterFields", () => $60e092cfdd3e6be9$export$1ca69a85bb7273de);

var $jFHCE = parcelRequire("jFHCE");

var $jvwCK = parcelRequire("jvwCK");
const $60e092cfdd3e6be9$export$d4eb181b231cf88d = ({ changeId: changeId, fieldsToBeRegistered: fieldsToBeRegistered, appId: appId })=>({ setState: setState, getState: getState })=>{
        if (!Array.isArray(fieldsToBeRegistered)) return;
        const { registeredFields: registeredFields } = getState();
        const appFields = registeredFields[appId] ?? {};
        const appChangeIdFields = appFields[changeId] ?? [];
        const nextRegisteredFields = {
            ...registeredFields,
            [appId]: {
                ...appFields,
                [changeId]: (0, (/*@__PURE__*/$parcel$interopDefault($jvwCK)))([
                    ...appChangeIdFields,
                    ...fieldsToBeRegistered
                ])
            }
        };
        setState({
            registeredFields: nextRegisteredFields
        });
    };
const $60e092cfdd3e6be9$export$1ca69a85bb7273de = ({ changeId: changeId, appId: appId })=>({ setState: setState, getState: getState })=>{
        const { registeredFields: registeredFields } = getState();
        const registeredAppFields = registeredFields[appId] ?? {};
        const nextRegisteredAppFields = (0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(registeredAppFields, changeId);
        setState({
            registeredFields: {
                ...registeredFields,
                [appId]: nextRegisteredAppFields
            }
        });
    };

});

parcelRegister("fkUIk", function(module, exports) {

$parcel$export(module.exports, "setFieldValue", () => $adb039aa861139a2$export$6556d46d2662453c);

var $5ldku = parcelRequire("5ldku");
const $adb039aa861139a2$export$6556d46d2662453c = ({ fieldId: fieldId, fieldType: fieldType, fieldValue: fieldValue })=>({ getState: getState, setState: setState }, { viewType: viewType })=>{
        const { internalFormMetadata: internalFormMetadata, formData: formData } = getState();
        /**
		 * We can set new field value only if the field was initialized.
		 * This checks the field metedata that indicates the successfull initialization.
		 */ if (!internalFormMetadata[fieldId]) return;
        const nextFormData = (0, $5ldku.calculateNextFormValue)({
            internalFormMetadata: internalFormMetadata,
            formData: formData,
            fieldType: fieldType,
            fieldId: fieldId,
            fieldValue: fieldValue,
            viewType: viewType
        });
        if (nextFormData === null) return;
        setState({
            formData: nextFormData
        });
    };

});

parcelRegister("bfBqP", function(module, exports) {

$parcel$export(module.exports, "updateActiveScreenTab", () => $910f8611d1056e54$export$21363496760d39cd);
const $910f8611d1056e54$export$21363496760d39cd = ({ selected: selected })=>({ getState: getState, setState: setState })=>{
        const { screenTabs: screenTabs } = getState();
        if (screenTabs) setState({
            screenTabs: screenTabs.map((tab, index)=>({
                    ...tab,
                    isActive: index === selected
                }))
        });
    };

});

parcelRegister("fY47y", function(module, exports) {

$parcel$export(module.exports, "updateFields", () => $e5c83e79d4f29b58$export$cceae62fd4d1ef0a);

var $8dH3d = parcelRequire("8dH3d");

var $gRw8I = parcelRequire("gRw8I");

var $jgvEH = parcelRequire("jgvEH");


var $81O8J = parcelRequire("81O8J");

var $cfL5m = parcelRequire("cfL5m");

var $3JMvu = parcelRequire("3JMvu");

var $82idB = parcelRequire("82idB");

var $lKslV = parcelRequire("lKslV");

var $4XahM = parcelRequire("4XahM");

var $aub9z = parcelRequire("aub9z");

var $TiFiE = parcelRequire("TiFiE");
const $e5c83e79d4f29b58$export$cceae62fd4d1ef0a = ({ changeId: changeId, fieldsChanges: fieldsChanges, lookupDataFromApi: lookupDataFromApi, tenantContext: tenantContext, executionContext: executionContext, environment: environment, appId: appId, intl: intl, createAnalyticsEvent: createAnalyticsEvent })=>async ({ setState: setState, getState: getState, dispatch: dispatch }, { viewType: viewType })=>{
        (0, $gRw8I.di)((0, $aub9z.collectFieldsAppliedChangesHistory));
        const appliedChanges = getState().appliedChanges ?? {};
        const formData = getState().formData ?? {};
        const { internalFormMetadata: internalFormMetadata, registeredFields: registeredFields } = getState();
        const { changesToApply: changesToApply, incomingFormData: incomingFormData, errorsByField: errorsByField, newAppliedChangesPublic: newAppliedChangesPublic } = await Object.keys(fieldsChanges).reduce(async (acc, fieldId)=>{
            // Do not update fields that are not inside initialized data.
            // Validates if the field that comes from Iframe is supported
            // - because we add to formData only the supported ones.
            const fieldData = formData[fieldId];
            const internalMetadata = internalFormMetadata[fieldId];
            const fieldIsRegistered = (0, $cfL5m.fieldWasRegistered)(registeredFields, changeId, fieldId, appId);
            // Only registered field Ids can be updated.
            if (!fieldIsRegistered || !fieldData) {
                const { fieldType: fieldType } = fieldData ?? {};
                dispatch((0, $4XahM.addAppsErrors)({
                    errors: {
                        [appId]: [
                            {
                                fieldType: fieldType,
                                fieldId: fieldId,
                                type: 'APPLY_CHANGES_FOR_UNREGISTERED_FIELD',
                                message: 'Application tried to apply changes to unregistered field'
                            }
                        ]
                    }
                }));
                (0, $jgvEH.fireOperationalEvent)(createAnalyticsEvent, {
                    action: 'unregisteredField',
                    actionSubject: 'jiraUiModifications.applyChanges',
                    attributes: {
                        message: 'Attempt to apply changes to a field that was not registered',
                        fieldId: fieldId,
                        viewType: viewType
                    }
                });
                return acc;
            }
            const lookupData = {
                [(0, $7f80bdb4337734ff$export$a1cacdcf198da901)]: internalMetadata.allowedValues,
                [(0, $7f80bdb4337734ff$export$3a106242c8f57ac2)]: lookupDataFromApi[0, $7f80bdb4337734ff$export$3a106242c8f57ac2]
            };
            // It updates properties in each field to avoid removing unchanged props for
            // selected field by another app or another onChange update.
            // Only supported properties are allowed.
            const supportedFieldChanges = await (0, $TiFiE.transformFieldChangesToInternalShape)({
                fieldType: fieldData.fieldType,
                fieldId: fieldId,
                fieldFromIframe: fieldsChanges?.[fieldId],
                lookupData: lookupData,
                viewType: viewType,
                tenantContext: tenantContext,
                executionContext: executionContext,
                environment: environment,
                intl: intl
            });
            if (supportedFieldChanges.isValid === false) {
                (await acc).errorsByField[fieldId] = supportedFieldChanges.errors;
                return acc;
            }
            // It converts changes to 'public' format to update the formData
            const publicShapeChanges = (0, $lKslV.transformFieldToIframe)(supportedFieldChanges.data, viewType, fieldData.fieldType, lookupData, fieldsChanges?.[fieldId], internalMetadata);
            const transformedFieldChanges = (0, $3JMvu.mapFieldPropertyNamesToInternal)(supportedFieldChanges.data, viewType, fieldData.fieldType);
            const combinedChangesToApply = {
                ...appliedChanges[fieldId],
                ...transformedFieldChanges
            };
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(combinedChangesToApply)) {
                (await acc).newAppliedChangesPublic[fieldId] = publicShapeChanges;
                (await acc).changesToApply[fieldId] = combinedChangesToApply;
                (await acc).incomingFormData[fieldId] = {
                    ...formData[fieldId],
                    ...publicShapeChanges
                };
            }
            return acc;
        }, Promise.resolve({
            changesToApply: {
                ...appliedChanges
            },
            incomingFormData: {
                ...formData
            },
            newAppliedChangesPublic: {},
            errorsByField: {}
        }));
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(errorsByField)) throw new (0, $81O8J.UiModificationsFieldsValidationError)('Transformation failed', {
            errors: (0, $82idB.prepareErrorsArray)(errorsByField)
        });
        setState({
            appliedChanges: changesToApply,
            formData: incomingFormData
        });
        dispatch((0, $aub9z.collectFieldsAppliedChangesHistory)({
            appId: appId,
            changeId: changeId,
            fieldsChanges: newAppliedChangesPublic
        }));
    };

});
const $7f80bdb4337734ff$export$a1cacdcf198da901 = 'LOOKUP_SOURCE_ALLOWED_VALUES_PROPERTY';
const $7f80bdb4337734ff$export$3a106242c8f57ac2 = 'LOOKUP_SOURCE_USERS_ASYNC_DATA';
const $7f80bdb4337734ff$export$f5d5f6bb902f1027 = '-1';
const $7f80bdb4337734ff$export$106087dcfd4fb129 = 100;

parcelRegister("81O8J", function(module, exports) {

$parcel$export(module.exports, "UiModificationsFieldsValidationError", () => $b784ee4f71bce498$export$9e8b5e552e255163);

var $607Dw = parcelRequire("607Dw");
class $b784ee4f71bce498$export$9e8b5e552e255163 extends (0, $607Dw.UiModificationsValidationError) {
    constructor(message, attributes, cause){
        super(message, attributes, 'fields', cause);
    }
}

});
parcelRegister("607Dw", function(module, exports) {

$parcel$export(module.exports, "UiModificationsValidationError", () => $8683b9e27ffb2718$export$6e8165c81a6a65df);
class $8683b9e27ffb2718$export$6e8165c81a6a65df extends Error {
    constructor(message, attributes, validationErrorType, cause){
        super(message, cause);
        this.attributes = attributes;
        this.validationErrorType = validationErrorType;
    }
}

});


parcelRegister("cfL5m", function(module, exports) {

$parcel$export(module.exports, "fieldWasRegistered", () => $84902f345f4d9ec2$export$fbe9157c12cb4e7b);
const $84902f345f4d9ec2$export$fbe9157c12cb4e7b = (registeredFields, changeId, fieldId, appId)=>!!registeredFields[appId]?.[changeId]?.includes(fieldId);

});

parcelRegister("3JMvu", function(module, exports) {

$parcel$export(module.exports, "mapFieldPropertyNamesToInternal", () => $7a07bba1139035a5$export$460820f27643954e);

var $82wKS = parcelRequire("82wKS");
const $7a07bba1139035a5$export$460820f27643954e = (properties, viewType, fieldType)=>{
    const fieldConfiguration = (0, $82wKS.getSupportedFieldConfiguration)(viewType, fieldType);
    const propertyMapping = fieldConfiguration?.propertyMapping;
    if (!propertyMapping) return properties;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return Object.keys(properties).reduce((acc, propertyName)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const propertyMappingValue = propertyMapping[propertyName];
        acc[propertyMappingValue ?? propertyName] = properties[propertyName];
        return acc;
    }, {});
};

});

parcelRegister("82idB", function(module, exports) {

$parcel$export(module.exports, "prepareErrorsArray", () => $b396c3e05312c1f7$export$e1fce51bc5be90b7);
const $b396c3e05312c1f7$export$e1fce51bc5be90b7 = (errorsById)=>Object.values(errorsById).flat();

});

parcelRegister("lKslV", function(module, exports) {

$parcel$export(module.exports, "transformFieldToIframe", () => $fb1c6d2f11d8a679$export$aa453854f74fab);

var $1qarT = parcelRequire("1qarT");

var $82wKS = parcelRequire("82wKS");
const $fb1c6d2f11d8a679$export$aa453854f74fab = (fieldChanges, viewType, fieldType, lookupData, fieldFromIframe, fieldMetadata)=>{
    const fieldConfiguration = (0, $82wKS.getSupportedFieldConfiguration)(viewType, fieldType);
    const fieldInternalToPublicTransformers = fieldConfiguration?.internalToPublicTransformers;
    const publicShapeField = {
        ...fieldChanges
    };
    if (publicShapeField.value !== undefined && fieldInternalToPublicTransformers?.value) try {
        publicShapeField.value = fieldInternalToPublicTransformers?.value(fieldChanges.value, fieldMetadata.fieldRenderer);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $1qarT.fireErrorAnalytics)({
            error: err,
            id: 'internalToPublicValueTransformer',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
    }
    if (fieldFromIframe.optionsVisibility !== undefined && fieldInternalToPublicTransformers?.optionsVisibility) try {
        const lookupSource = fieldConfiguration?.lookupSource;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore - lookupData is not types on CI somehow
        const lookupValues = lookupSource ? lookupData[lookupSource] : undefined;
        publicShapeField.optionsVisibility = fieldInternalToPublicTransformers?.optionsVisibility(fieldFromIframe.optionsVisibility, lookupValues);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $1qarT.fireErrorAnalytics)({
            error: err,
            id: 'internalToPublicOptionsVisibilityTransformer',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
    }
    return publicShapeField;
};

});

parcelRegister("TiFiE", function(module, exports) {

$parcel$export(module.exports, "transformFieldChangesToInternalShape", () => $0fdd9846971f3713$export$d14f85c01e334a1);

var $8dH3d = parcelRequire("8dH3d");

var $gRw8I = parcelRequire("gRw8I");

var $6rtzq = parcelRequire("6rtzq");

var $82wKS = parcelRequire("82wKS");


var $5sAot = parcelRequire("5sAot");

var $gOp4r = parcelRequire("gOp4r");

var $i9dWk = parcelRequire("i9dWk");
const $0fdd9846971f3713$export$d14f85c01e334a1 = async ({ fieldType: fieldType, fieldId: fieldId, fieldFromIframe: fieldFromIframe, lookupData: lookupData, viewType: viewType, tenantContext: tenantContext, executionContext: executionContext, environment: environment, intl: intl })=>{
    (0, $gRw8I.di)((0, $82wKS.getSupportedFieldConfiguration));
    const fieldConfiguration = (0, $82wKS.getSupportedFieldConfiguration)(viewType, fieldType);
    const fieldTransformers = fieldConfiguration?.publicToInternalTransformers;
    const fieldValidators = fieldConfiguration?.publicShapeValidators;
    if (!fieldFromIframe || !fieldTransformers || !fieldValidators) return {
        ...(0, $gOp4r.VALID_RESULT),
        data: {}
    };
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const validatorsArray = Object.keys(fieldValidators);
    const lookupSource = fieldConfiguration?.lookupSource;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore - lookupData is not types on CI somehow
    const lookupValues = lookupSource ? lookupData[lookupSource] : undefined;
    const fieldTransformationResults = await Promise.all(validatorsArray.map(async (propertyName)=>{
        if (!Object.prototype.hasOwnProperty.call(fieldFromIframe, propertyName)) return 0, $gOp4r.VALID_RESULT;
        const propertyValue = fieldFromIframe[propertyName];
        const transformer = fieldTransformers[propertyName];
        const fieldContext = {
            fieldId: fieldId
        };
        // We need to catch lookup values discrepancies and react accordingly
        // to how we react to validation errors - throw an error
        // if the set value wasn't found in the array of lookupValues
        try {
            const data = transformer ? await transformer(propertyValue, lookupValues, {
                tenantContext: tenantContext,
                executionContext: executionContext,
                environment: environment,
                fieldContext: fieldContext,
                intl: intl
            }) : propertyValue;
            return {
                isValid: true,
                data: {
                    [propertyName]: data
                }
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            // FieldValueLookupError will be thrown from the transformer
            // when the lookup value wasn't found
            if (err instanceof (0, $6rtzq.FieldValueLookupError)) {
                // For single value fields its straightforward to just pass
                // the faulty propertyValue into error message,
                // but for multi value fields we should find out the faulty values from the array
                // thats why we should propagate the faulty values as a comma separated string
                // by using the error's message
                const faultyValue = err.message || propertyValue;
                return {
                    isValid: false,
                    error: {
                        fieldId: fieldId,
                        fieldType: fieldType,
                        type: (0, $585e8f7167f61808$export$d1996cb46a690190),
                        method: (0, $5sAot.mapFieldPropertyToApiMethod)(propertyName),
                        message: `Invalid IDs provided: ${faultyValue}`
                    }
                };
            }
            throw err;
        }
    }));
    const invalidTransformationResults = (0, $i9dWk.filterInvalidResults)(fieldTransformationResults);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(invalidTransformationResults)) return {
        isValid: false,
        errors: invalidTransformationResults.map((result)=>result.error)
    };
    return (0, $i9dWk.mapValidResultsToFieldInternalShape)(fieldTransformationResults);
};

});
parcelRegister("6rtzq", function(module, exports) {

$parcel$export(module.exports, "FieldValueLookupError", () => $2f73a6dce6bcf96a$export$73c2f0689b6c4a5a);
class $2f73a6dce6bcf96a$export$73c2f0689b6c4a5a extends Error {
}

});

parcelRegister("gOp4r", function(module, exports) {

$parcel$export(module.exports, "VALID_RESULT", () => $af0c126b48130091$export$ee79e3ab53b8db79);
const $af0c126b48130091$export$ee79e3ab53b8db79 = {
    isValid: true
};

});

parcelRegister("i9dWk", function(module, exports) {

$parcel$export(module.exports, "mapValidResultsToFieldInternalShape", () => $d76dab7db88ac392$export$a60dd8f1b025f23d);
$parcel$export(module.exports, "filterInvalidResults", () => $d76dab7db88ac392$export$ddd005554aecd409);
const $d76dab7db88ac392$export$a60dd8f1b025f23d = (results)=>results.reduce((acc, result)=>{
        if (result.isValid === true && Object.prototype.hasOwnProperty.call(result, 'data')) acc.data = {
            ...acc.data,
            ...result.data
        };
        return acc;
    }, {
        isValid: true,
        data: {}
    });
const $d76dab7db88ac392$export$ddd005554aecd409 = (validationResults)=>validationResults.reduce((acc, result)=>{
        if (result.isValid === false) acc.push(result);
        return acc;
    }, []);

});



parcelRegister("dmz3j", function(module, exports) {

$parcel$export(module.exports, "updateScreenTabs", () => $d4a266f6d4506eb1$export$131c67fd312b8a11);

var $gRw8I = parcelRequire("gRw8I");

var $9WNAv = parcelRequire("9WNAv");

var $iGhbB = parcelRequire("iGhbB");

var $aub9z = parcelRequire("aub9z");

var $2TFQ7 = parcelRequire("2TFQ7");
const $d4a266f6d4506eb1$export$131c67fd312b8a11 = ({ screenTabsChanges: screenTabsFromIframe, changeId: changeId, appId: appId })=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
        (0, $gRw8I.di)((0, $aub9z.collectScreenTabsAppliedChangesHistory), (0, $2TFQ7.getScreenTabsPublicToInternalValidationErrors));
        const { screenTabs: internalScreenTabs } = getState();
        // If screenTabsFromIframe is empty it means that the app does not provide srceenTabs changes.
        if (Array.isArray(screenTabsFromIframe) && !screenTabsFromIframe.length) return;
        if (internalScreenTabs && (0, $2TFQ7.screenTabsPublicToInternalValidator)(internalScreenTabs, screenTabsFromIframe)) {
            const newScreenTabs = (0, $2TFQ7.screenTabsPublicToInternalTransformer)(internalScreenTabs, screenTabsFromIframe);
            setState({
                screenTabs: newScreenTabs
            });
            dispatch((0, $aub9z.collectScreenTabsAppliedChangesHistory)({
                appId: appId,
                changeId: changeId,
                screenTabs: newScreenTabs
            }));
        } else throw new (0, $9WNAv.UiModificationsScreenTabsValidationError)('Transformation failed', {
            errors: (0, $2TFQ7.getScreenTabsPublicToInternalValidationErrors)(internalScreenTabs, screenTabsFromIframe).map((0, $iGhbB.toScreenTabsValidationError))
        });
    };

});
parcelRegister("9WNAv", function(module, exports) {

$parcel$export(module.exports, "UiModificationsScreenTabsValidationError", () => $5a1018b8bae0ac45$export$faf1f1824ee0a136);

var $607Dw = parcelRequire("607Dw");
class $5a1018b8bae0ac45$export$faf1f1824ee0a136 extends (0, $607Dw.UiModificationsValidationError) {
    constructor(message, attributes, cause){
        super(message, attributes, 'screenTabs', cause);
    }
}

});

parcelRegister("iGhbB", function(module, exports) {

$parcel$export(module.exports, "toScreenTabsValidationError", () => $609355188438e567$export$b2675440ade984fb);

const $609355188438e567$export$b2675440ade984fb = (message)=>({
        message: message,
        type: (0, $585e8f7167f61808$export$fd26696d109785a0)
    });

});

parcelRegister("2TFQ7", function(module, exports) {

$parcel$export(module.exports, "screenTabsPublicToInternalTransformer", () => $e157d25468b560b0$export$9ca9b35e7b6a8bbc);
$parcel$export(module.exports, "screenTabsPublicToInternalValidator", () => $e157d25468b560b0$export$e7a91e7e430e691a);
$parcel$export(module.exports, "getScreenTabsPublicToInternalValidationErrors", () => $e157d25468b560b0$export$62d63af83dac7315);
const $e157d25468b560b0$export$582443c7ead02173 = (value)=>typeof value === 'string' && value !== '';
const $e157d25468b560b0$var$isValidScreenTabId = (internalScreenTabs, id)=>$e157d25468b560b0$export$582443c7ead02173(id) && internalScreenTabs.find((tab)=>tab.id === id) !== undefined;
const $e157d25468b560b0$var$isValidScreenTabIsActive = (isActive)=>typeof isActive === 'boolean' || typeof isActive === 'undefined';
const $e157d25468b560b0$var$isValidScreenTabIsVisible = (isVisible)=>typeof isVisible === 'boolean' || typeof isVisible === 'undefined';
const $e157d25468b560b0$var$isValidScreenTabData = (internalScreenTabs, { id: id, isVisible: isVisible, isActive: isActive })=>$e157d25468b560b0$var$isValidScreenTabId(internalScreenTabs, id) && $e157d25468b560b0$var$isValidScreenTabIsVisible(isVisible) && $e157d25468b560b0$var$isValidScreenTabIsActive(isActive);
const $e157d25468b560b0$var$countNumberOfActiveScreenTabs = (acc, { isActive: isActive })=>{
    if ($e157d25468b560b0$var$isValidScreenTabIsActive(isActive) && isActive) return acc + 1;
    return acc;
};
const $e157d25468b560b0$var$countNumberOfHiddenActiveScreenTabs = (acc, { isActive: isActive, isVisible: isVisible })=>{
    if ($e157d25468b560b0$var$isValidScreenTabIsActive(isActive) && isActive && $e157d25468b560b0$var$isValidScreenTabIsVisible(isVisible) && !isVisible) return acc + 1;
    return acc;
};
const $e157d25468b560b0$export$9ca9b35e7b6a8bbc = (internalScreenTabs, screenTabsFromApp)=>{
    let numberOfActiveScreenTabs = 0;
    const internalActiveScreenTabIndex = internalScreenTabs.findIndex((tab)=>tab.isActive === true);
    const screenTabsInternalUpdated = internalScreenTabs.map((screenTabInternal)=>{
        const screenTabFromApp = screenTabsFromApp.find((tab)=>tab.id === screenTabInternal.id);
        if (!screenTabFromApp) return screenTabInternal;
        numberOfActiveScreenTabs += screenTabFromApp.isActive === true ? 1 : 0;
        return {
            id: screenTabInternal.id,
            isVisible: screenTabFromApp.isVisible ?? true,
            isActive: screenTabFromApp.isActive
        };
    });
    // if no active tab is specified. default to the first
    if (numberOfActiveScreenTabs === 0 && internalActiveScreenTabIndex === -1 && typeof screenTabsInternalUpdated[0]?.isActive !== 'undefined') screenTabsInternalUpdated[0].isActive = true;
    return screenTabsInternalUpdated;
};
const $e157d25468b560b0$export$e7a91e7e430e691a = (internalScreenTabs, screenTabsFromApp)=>{
    if (!Array.isArray(screenTabsFromApp)) return false;
    const screenTabsFromAppFiltered = screenTabsFromApp.filter((data)=>$e157d25468b560b0$var$isValidScreenTabData(internalScreenTabs, data));
    const numberOfActiveScreenTabs = screenTabsFromApp.reduce($e157d25468b560b0$var$countNumberOfActiveScreenTabs, 0);
    const numberOfHiddenActiveScreenTabs = screenTabsFromApp.reduce($e157d25468b560b0$var$countNumberOfHiddenActiveScreenTabs, 0);
    return numberOfActiveScreenTabs <= 1 && screenTabsFromApp.length === screenTabsFromAppFiltered.length && numberOfHiddenActiveScreenTabs === 0;
};
const $e157d25468b560b0$export$62d63af83dac7315 = (internalScreenTabs, screenTabsFromApp)=>{
    if (!internalScreenTabs) return [
        'There are no screen tabs in the current view.'
    ];
    if (!Array.isArray(screenTabsFromApp)) return [
        'Your app must return screen tabs as an array.'
    ];
    const errors = [];
    if (screenTabsFromApp.reduce($e157d25468b560b0$var$countNumberOfActiveScreenTabs, 0) > 1) errors.push('Only one screen tab can be in focus.');
    if (screenTabsFromApp.reduce($e157d25468b560b0$var$countNumberOfHiddenActiveScreenTabs, 0) > 0) errors.push("You can't hide a screen tab that's currently in focus.");
    return errors;
};

});





const $6d500eb1fc6bc124$export$e615b7e9b8fb4715 = 'GIC';

parcelRegister("bEJi6", function(module, exports) {

$parcel$export(module.exports, "GICViewConfiguration", () => $7140503f3fd0ae81$export$99b59685fcab4ee);

var $ln6Iy = parcelRequire("ln6Iy");

var $7jTnu = parcelRequire("7jTnu");


var $84DOT = parcelRequire("84DOT");

var $814y1 = parcelRequire("814y1");

var $Gb6hR = parcelRequire("Gb6hR");

var $8guiH = parcelRequire("8guiH");

var $g2Dfs = parcelRequire("g2Dfs");

var $617QW = parcelRequire("617QW");

var $gUgNl = parcelRequire("gUgNl");

var $isBNo = parcelRequire("isBNo");

var $5N8Mq = parcelRequire("5N8Mq");

var $jm0ph = parcelRequire("jm0ph");

var $lELZM = parcelRequire("lELZM");

var $avA6T = parcelRequire("avA6T");

var $hCYJC = parcelRequire("hCYJC");

var $a3r90 = parcelRequire("a3r90");

var $lT0nv = parcelRequire("lT0nv");

var $fZNR8 = parcelRequire("fZNR8");

var $8FDN0 = parcelRequire("8FDN0");

var $kyAb0 = parcelRequire("kyAb0");

var $9NjWc = parcelRequire("9NjWc");

var $kBumK = parcelRequire("kBumK");

var $fneAA = parcelRequire("fneAA");

var $gxLrk = parcelRequire("gxLrk");

var $fzAHE = parcelRequire("fzAHE");

var $jhkOZ = parcelRequire("jhkOZ");

var $Mcbkf = parcelRequire("Mcbkf");

var $3tlEm = parcelRequire("3tlEm");

var $adFnB = parcelRequire("adFnB");

var $dybgk = parcelRequire("dybgk");

var $ambuz = parcelRequire("ambuz");

var $iy91c = parcelRequire("iy91c");

var $5GGn5 = parcelRequire("5GGn5");

var $9clC9 = parcelRequire("9clC9");

var $fKJdV = parcelRequire("fKJdV");

var $3TV7H = parcelRequire("3TV7H");

var $18aUF = parcelRequire("18aUF");

var $H6cPi = parcelRequire("H6cPi");

var $6AzNh = parcelRequire("6AzNh");

var $9OdvY = parcelRequire("9OdvY");

var $iQnYo = parcelRequire("iQnYo");
class $7140503f3fd0ae81$export$99b59685fcab4ee {
    getSupportedFieldsConfiguration() {
        const commonFieldValidators = (0, $kyAb0.getCommonFieldValidators)();
        return {
            [(0, $814y1.SUMMARY_TYPE)]: {
                // It contains also supported field properties.
                // Validator MUST be added here to make given property supported.
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $kBumK.validateSingleLineTextValue)
                },
                // Transformers are optional per property, if missing the value will be used as is
                publicToInternalTransformers: {},
                internalToPublicTransformers: {
                    value: (0, $H6cPi.singleLineTextFieldGetValueTransformer)
                },
                emitChangeOn: 'blur'
            },
            [(0, $814y1.PRIORITY_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $hCYJC.validatePrioritySetValue),
                    optionsVisibility: (0, $9NjWc.validateSetOptionsVisibilityRule)
                },
                publicToInternalTransformers: {
                    value: (0, $9clC9.prioritySetValueTransformer),
                    optionsVisibility: (0, $9clC9.transformPrioritySetOptionsVisibility)
                },
                internalToPublicTransformers: {
                    value: (0, $9clC9.transformPriorityGetValue),
                    optionsVisibility: (0, $9clC9.transformPriorityGetOptionsVisibility)
                },
                emitChangeOn: 'change',
                lookupSource: (0, $7f80bdb4337734ff$export$a1cacdcf198da901),
                propertyMapping: {
                    optionsVisibility: 'allowedValues'
                }
            },
            [(0, $814y1.ASSIGNEE_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $8guiH.assigneeSetValueValidator)
                },
                publicToInternalTransformers: {
                    value: (0, $8guiH.assigneeSetValueTransformer)
                },
                internalToPublicTransformers: {
                    value: (0, $8guiH.assigneeGetValueTransformer)
                },
                emitChangeOn: 'change',
                lookupSource: (0, $7f80bdb4337734ff$export$3a106242c8f57ac2)
            },
            [(0, $814y1.USER_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $fZNR8.userPickerSetValueValidator)
                },
                publicToInternalTransformers: {
                    value: (0, $6AzNh.userPickerSetValueTransformer)
                },
                internalToPublicTransformers: {
                    value: (0, $6AzNh.userPickerGetValueTransformer)
                },
                emitChangeOn: 'change',
                lookupSource: (0, $7f80bdb4337734ff$export$3a106242c8f57ac2)
            },
            [(0, $814y1.LABELS_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $jm0ph.labelsSetValueValidator)
                },
                publicToInternalTransformers: {
                    value: (0, $jm0ph.labelsSetValueTransformer)
                },
                internalToPublicTransformers: {
                    value: (0, $jm0ph.labelsGetValueTransformer)
                },
                emitChangeOn: 'change'
            },
            [(0, $814y1.DESCRIPTION_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $jhkOZ.validateDescriptionAndParagraphSetValue)
                },
                publicToInternalTransformers: {
                    value: (0, $jhkOZ.descriptionAndParagraphSetValueTransformer)
                },
                internalToPublicTransformers: {
                    value: (0, $jhkOZ.descriptionAndParagraphGetValueTransformer)
                },
                emitChangeOn: 'blur'
            },
            [(0, $814y1.SELECT_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $fneAA.selectSetValueValidator),
                    optionsVisibility: (0, $9NjWc.validateSetOptionsVisibilityRule)
                },
                publicToInternalTransformers: {
                    value: (0, $18aUF.selectSetValueTransformer),
                    optionsVisibility: (0, $18aUF.transformSelectSetOptionsVisibility)
                },
                internalToPublicTransformers: {
                    value: (0, $18aUF.selectGetValueTransformer),
                    optionsVisibility: (0, $18aUF.transformSelectGetOptionsVisibility)
                },
                emitChangeOn: 'change',
                lookupSource: (0, $7f80bdb4337734ff$export$a1cacdcf198da901),
                propertyMapping: {
                    optionsVisibility: 'allowedValues'
                }
            },
            [(0, $814y1.TEXT_AREA_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $jhkOZ.validateDescriptionAndParagraphSetValue)
                },
                publicToInternalTransformers: {
                    value: (0, $jhkOZ.descriptionAndParagraphSetValueTransformer)
                },
                internalToPublicTransformers: {
                    value: (0, $jhkOZ.descriptionAndParagraphGetValueTransformer)
                },
                emitChangeOn: 'blur'
            },
            [(0, $814y1.MULTI_SELECT_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $adFnB.validateMultiSelectSetValue),
                    optionsVisibility: (0, $9NjWc.validateSetOptionsVisibilityRule)
                },
                publicToInternalTransformers: {
                    value: (0, $adFnB.multiSelectSetValueTransformer),
                    optionsVisibility: (0, $adFnB.transformMultiSelectSetOptionsVisibility)
                },
                internalToPublicTransformers: {
                    value: (0, $adFnB.multiSelectGetValueTransformer),
                    optionsVisibility: (0, $adFnB.transformMultiSelectGetOptionsVisibility)
                },
                emitChangeOn: 'change',
                lookupSource: (0, $7f80bdb4337734ff$export$a1cacdcf198da901),
                propertyMapping: {
                    optionsVisibility: 'allowedValues'
                }
            },
            [(0, $814y1.PEOPLE_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $5GGn5.peopleSetValueValidator)
                },
                publicToInternalTransformers: {
                    value: (0, $5GGn5.peopleSetValueTransformer)
                },
                internalToPublicTransformers: {
                    value: (0, $5GGn5.peopleGetValueTransformer)
                },
                emitChangeOn: 'change',
                lookupSource: (0, $7f80bdb4337734ff$export$3a106242c8f57ac2)
            },
            [(0, $814y1.MULTI_USER_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $dybgk.multiUserPickerSetValueValidator)
                },
                publicToInternalTransformers: {
                    value: (0, $dybgk.multiUserPickerSetValueTransformer)
                },
                internalToPublicTransformers: {
                    value: (0, $dybgk.multiUserPickerGetValueTransformer)
                },
                emitChangeOn: 'change',
                lookupSource: (0, $7f80bdb4337734ff$export$3a106242c8f57ac2)
            },
            [(0, $814y1.TEXT_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $kBumK.validateSingleLineTextValue)
                },
                publicToInternalTransformers: {},
                internalToPublicTransformers: {
                    value: (0, $H6cPi.singleLineTextFieldGetValueTransformer)
                },
                emitChangeOn: 'blur'
            },
            [(0, $814y1.MULTI_CHECKBOXES_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $3tlEm.validateMultiCheckboxSetValue),
                    optionsVisibility: (0, $9NjWc.validateSetOptionsVisibilityRule)
                },
                publicToInternalTransformers: {
                    value: (0, $3tlEm.multiCheckboxSetValueTransformer),
                    optionsVisibility: (0, $3tlEm.transformMultiCheckboxSetOptionsVisibility)
                },
                internalToPublicTransformers: {
                    value: (0, $3tlEm.multiCheckboxGetValueTransformer),
                    optionsVisibility: (0, $3tlEm.transformMultiCheckboxGetOptionsVisibility)
                },
                emitChangeOn: 'change',
                lookupSource: (0, $7f80bdb4337734ff$export$a1cacdcf198da901),
                propertyMapping: {
                    optionsVisibility: 'allowedValues'
                }
            },
            [(0, $814y1.COMPONENTS_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $fzAHE.validateComponentsSetValue)
                },
                publicToInternalTransformers: {
                    value: (0, $fzAHE.componentsSetValueTransformer)
                },
                internalToPublicTransformers: {
                    value: (0, $fzAHE.componentsGetValueTransformer)
                },
                emitChangeOn: 'change',
                lookupSource: (0, $7f80bdb4337734ff$export$a1cacdcf198da901),
                requiredScopes: (0, $617QW.componentsRequiredScopes)
            },
            [(0, $814y1.REPORTER_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $lT0nv.reporterSetValueValidator)
                },
                publicToInternalTransformers: {
                    value: (0, $3TV7H.reporterSetValueTransformer)
                },
                internalToPublicTransformers: {
                    value: (0, $3TV7H.reporterGetValueTransformer)
                },
                emitChangeOn: 'change',
                lookupSource: (0, $7f80bdb4337734ff$export$3a106242c8f57ac2)
            },
            [(0, $814y1.FIX_VERSIONS_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $9OdvY.fixVersionsSetValueValidator)
                },
                publicToInternalTransformers: {
                    value: (0, $9OdvY.transformVersionsSetValue)
                },
                internalToPublicTransformers: {
                    value: (0, $9OdvY.transformVersionsGetValue)
                },
                emitChangeOn: 'change',
                lookupSource: (0, $7f80bdb4337734ff$export$a1cacdcf198da901),
                requiredScopes: (0, $9OdvY.versionsRequiredScopes)
            },
            [(0, $814y1.ISSUE_TYPE)]: {
                publicShapeValidators: {
                    value: (0, $5N8Mq.issueTypeSetValueValidator),
                    optionsVisibility: (0, $9NjWc.validateSetOptionsVisibilityRule)
                },
                publicToInternalTransformers: {
                    value: (0, $Mcbkf.issueTypeSetValueTransformer),
                    optionsVisibility: (0, $Mcbkf.transformIssueTypeSetOptionsVisibility)
                },
                internalToPublicTransformers: {
                    value: (0, $Mcbkf.issueTypeGetValueTransformer),
                    optionsVisibility: (0, $Mcbkf.transformIssueTypeGetOptionsVisibility)
                },
                emitChangeOn: 'change',
                lookupSource: (0, $7f80bdb4337734ff$export$a1cacdcf198da901),
                propertyMapping: {
                    optionsVisibility: 'allowedValues'
                }
            },
            [(0, $814y1.URL_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $kBumK.validateSingleLineTextValue)
                },
                publicToInternalTransformers: {},
                internalToPublicTransformers: {
                    value: (0, $H6cPi.singleLineTextFieldGetValueTransformer)
                },
                emitChangeOn: 'blur'
            },
            [(0, $814y1.DATE_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $gUgNl.datePickerSetValueValidator)
                },
                publicToInternalTransformers: {
                    value: (0, $gUgNl.datePickerSetValueTransformer)
                },
                internalToPublicTransformers: {
                    value: (0, $gUgNl.datePickerGetValueTransformer)
                },
                emitChangeOn: 'change'
            },
            [(0, $814y1.DATETIME_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $isBNo.validateDateTimePickerSetValue)
                },
                publicToInternalTransformers: {
                    value: (0, $isBNo.transformDateTimePickerSetValue)
                },
                internalToPublicTransformers: {
                    value: (0, $isBNo.transformDateTimePickerGetValue)
                },
                emitChangeOn: 'change'
            },
            [(0, $814y1.RADIO_BUTTONS_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $a3r90.radioButtonsSetValueValidator),
                    optionsVisibility: (0, $9NjWc.validateSetOptionsVisibilityRule)
                },
                publicToInternalTransformers: {
                    value: (0, $fKJdV.radioButtonsSetValueTransformer),
                    optionsVisibility: (0, $fKJdV.transformRadioButtonsSetOptionsVisibility)
                },
                internalToPublicTransformers: {
                    value: (0, $fKJdV.radioButtonsGetValueTransformer),
                    optionsVisibility: (0, $fKJdV.transformRadioButtonsGetOptionsVisibility)
                },
                emitChangeOn: 'change',
                lookupSource: (0, $7f80bdb4337734ff$export$a1cacdcf198da901),
                propertyMapping: {
                    optionsVisibility: 'allowedValues'
                }
            },
            [(0, $814y1.NUMBER_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $lELZM.validateNumberValue)
                },
                publicToInternalTransformers: {
                    value: (0, $ambuz.transformNumberToInternalValue)
                },
                internalToPublicTransformers: {
                    value: (0, $ambuz.transformNumberToPublicValue)
                },
                emitChangeOn: 'blur',
                requiredScopes: (0, $ambuz.numberIssueGicScopes)
            },
            [(0, $814y1.PARENT_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $avA6T.validateParentWithAriSetValue)
                },
                publicToInternalTransformers: {
                    value: (0, $iy91c.parentSetValueTransformer)
                },
                internalToPublicTransformers: {
                    value: (0, $iy91c.parentGetValueTransformer)
                },
                emitChangeOn: 'change'
            },
            [(0, $814y1.CASCADING_SELECT_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $g2Dfs.validateCascadingSelectSetValue)
                },
                publicToInternalTransformers: {
                    value: (0, $gxLrk.transformSetValueCascadingSelect)
                },
                internalToPublicTransformers: {
                    value: (0, $gxLrk.transformGetValueCascadingSelect)
                },
                emitChangeOn: 'change',
                lookupSource: (0, $7f80bdb4337734ff$export$a1cacdcf198da901)
            },
            [(0, $814y1.AFFECTS_VERSIONS_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $8FDN0.validateVersionValue)
                },
                publicToInternalTransformers: {
                    value: (0, $9OdvY.transformVersionsSetValue)
                },
                internalToPublicTransformers: {
                    value: (0, $9OdvY.transformVersionsGetValue)
                },
                emitChangeOn: 'change',
                lookupSource: (0, $7f80bdb4337734ff$export$a1cacdcf198da901),
                requiredScopes: (0, $9OdvY.versionsRequiredScopes)
            },
            [(0, $814y1.DUE_DATE_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $gUgNl.datePickerSetValueValidator)
                },
                publicToInternalTransformers: {
                    value: (0, $gUgNl.datePickerSetValueTransformer)
                },
                internalToPublicTransformers: {
                    value: (0, $gUgNl.datePickerGetValueTransformer)
                },
                emitChangeOn: 'change'
            },
            [(0, $814y1.BASELINE_START_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $gUgNl.datePickerSetValueValidator)
                },
                publicToInternalTransformers: {
                    value: (0, $gUgNl.datePickerSetValueTransformer)
                },
                internalToPublicTransformers: {
                    value: (0, $gUgNl.datePickerGetValueTransformer)
                },
                emitChangeOn: 'change'
            },
            [(0, $814y1.BASELINE_END_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $gUgNl.datePickerSetValueValidator)
                },
                publicToInternalTransformers: {
                    value: (0, $gUgNl.datePickerSetValueTransformer)
                },
                internalToPublicTransformers: {
                    value: (0, $gUgNl.datePickerGetValueTransformer)
                },
                emitChangeOn: 'change'
            }
        };
    }
    getSupportedFieldTypes() {
        const supportedFieldTypes = [
            (0, $814y1.SUMMARY_TYPE),
            (0, $814y1.PRIORITY_TYPE),
            (0, $814y1.ASSIGNEE_TYPE),
            (0, $814y1.LABELS_TYPE),
            (0, $814y1.DESCRIPTION_TYPE),
            (0, $814y1.SELECT_CF_TYPE),
            (0, $814y1.TEXT_AREA_CF_TYPE),
            (0, $814y1.MULTI_SELECT_CF_TYPE),
            (0, $814y1.USER_CF_TYPE),
            (0, $814y1.TEXT_CF_TYPE),
            (0, $814y1.MULTI_USER_CF_TYPE),
            (0, $814y1.PEOPLE_CF_TYPE),
            (0, $814y1.MULTI_CHECKBOXES_CF_TYPE),
            (0, $814y1.REPORTER_TYPE),
            (0, $814y1.COMPONENTS_TYPE),
            (0, $814y1.FIX_VERSIONS_TYPE),
            (0, $814y1.ISSUE_TYPE),
            (0, $814y1.DATE_CF_TYPE),
            (0, $814y1.DATETIME_CF_TYPE),
            (0, $814y1.URL_CF_TYPE),
            (0, $814y1.RADIO_BUTTONS_CF_TYPE),
            (0, $814y1.NUMBER_CF_TYPE),
            (0, $814y1.PARENT_TYPE),
            (0, $814y1.AFFECTS_VERSIONS_TYPE),
            (0, $814y1.DUE_DATE_TYPE),
            (0, $814y1.BASELINE_START_CF_TYPE),
            (0, $814y1.BASELINE_END_CF_TYPE),
            (0, $814y1.CASCADING_SELECT_CF_TYPE)
        ];
        return supportedFieldTypes;
    }
    isExecutionContextSupported({ context: context }) {
        if (!context.project) return false;
        return this.supportedProjectTypes.includes(context.project.type);
    }
    getConsentMessage() {
        return (0, $7jTnu.fg)('jira-issue-terminology-refresh-m3') ? (0, $iQnYo.default).obligatoryUimGicConsentMessageIssueTermRefresh : (0, $iQnYo.default).obligatoryUimGicConsentMessage;
    }
    getAnalytics() {
        return this.analytics;
    }
    getSupportedTriggerPointsConfiguration() {
        return new Set([
            (0, $84DOT.GENERIC_FORGE_USE_PRODUCT_MODALS),
            (0, $84DOT.GENERIC_GLOBAL_CREATE_BUTTON),
            (0, $84DOT.GENERIC_KEYBOARD_SHORTCUT),
            (0, $84DOT.JSW_ISSUE_VIEW_CREATE_ISSUE_IN_EPIC),
            (0, $84DOT.JSW_CREATE_EPIC_ISSUE),
            (0, $84DOT.JSW_ISSUE_VIEW_CREATE_SUBTASK)
        ]);
    }
    constructor(){
        this.analytics = {
            stopTTI: $Gb6hR.stopTTI,
            cancelTTI: $Gb6hR.cancelTTI,
            markIframeLoad: $Gb6hR.markIframeLoad,
            markFieldsRegistered: $Gb6hR.markFieldsRegistered,
            markOnInitResolved: $Gb6hR.markOnInitResolved
        };
        this.supportedProjectTypes = [
            (0, $ln6Iy.SOFTWARE_PROJECT),
            (0, $ln6Iy.CORE_PROJECT)
        ];
    }
}

});
parcelRegister("8guiH", function(module, exports) {

$parcel$export(module.exports, "assigneeSetValueValidator", () => $5f5a63575b4fe05a$export$a1b37d5eeb401ad6);
$parcel$export(module.exports, "assigneeSetValueTransformer", () => $5f5a63575b4fe05a$export$d1aadee23fc64b9d);
$parcel$export(module.exports, "assigneeGetValueTransformer", () => $5f5a63575b4fe05a$export$166948efaac892d3);
$parcel$export(module.exports, "assigneeScopes", () => $5f5a63575b4fe05a$export$3c9d4db6ddd2a8e6);

var $agwg4 = parcelRequire("agwg4");

var $6rtzq = parcelRequire("6rtzq");

var $30Vch = parcelRequire("30Vch");

var $ellWq = parcelRequire("ellWq");

var $biM1w = parcelRequire("biM1w");
const $5f5a63575b4fe05a$export$a1b37d5eeb401ad6 = (value)=>value === null || (0, $ellWq.isNotEmptyString)(value);
const $5f5a63575b4fe05a$export$d1aadee23fc64b9d = (value, lookupValues, context)=>{
    if (value === null) return null;
    const { intl: intl } = context;
    if (value === (0, $7f80bdb4337734ff$export$f5d5f6bb902f1027) && intl) {
        // @ts-expect-error deprecated intl shape in getAutomaticUserOption
        const automaticUserOption = (0, $30Vch.getAutomaticUserOption)(intl);
        return {
            accountId: automaticUserOption.accountId ?? (0, $7f80bdb4337734ff$export$f5d5f6bb902f1027),
            displayName: automaticUserOption.displayName,
            avatarUrls: {
                '48x48': ''
            }
        };
    }
    const foundValue = (0, $biM1w.singleValueLookup)(value, lookupValues, 'accountId');
    if (!foundValue) throw new (0, $6rtzq.FieldValueLookupError)();
    const { accountId: accountId, name: displayName, picture: picture } = foundValue;
    return {
        accountId: accountId,
        displayName: displayName,
        avatarUrls: {
            '48x48': picture
        }
    };
};
const $5f5a63575b4fe05a$export$166948efaac892d3 = (value)=>{
    if (value === null) return null;
    const { accountId: accountId } = value;
    return {
        accountId: accountId
    };
};
const $5f5a63575b4fe05a$export$3c9d4db6ddd2a8e6 = {
    ...(0, $agwg4.baseScopesRequiredPerField),
    granular: [
        ...(0, $agwg4.baseScopesRequiredPerField).granular,
        'read:user:jira'
    ],
    coarse: [
        ...(0, $agwg4.baseScopesRequiredPerField).coarse,
        'read:jira-user'
    ]
};

});
parcelRegister("agwg4", function(module, exports) {

$parcel$export(module.exports, "baseScopesRequiredPerField", () => $0f36db6ebd81951d$export$ec1ba7c44413935f);
const $0f36db6ebd81951d$export$ec1ba7c44413935f = {
    granular: [
        'read:field:jira',
        'write:field:jira',
        'read:field-configuration:jira',
        'write:field-configuration:jira'
    ],
    coarse: [
        'read:jira-work',
        'write:jira-work',
        'manage:jira-configuration'
    ]
};

});

parcelRegister("30Vch", function(module, exports) {

$parcel$export(module.exports, "getUnassignedUser", () => $099fe508ffcd564f$export$42c5a0b65ef9ee80);
$parcel$export(module.exports, "getAutomaticUserOption", () => $099fe508ffcd564f$export$8d7a63500893c8c);
$parcel$export(module.exports, "getInvitePeopleOption", () => $099fe508ffcd564f$export$84a82764cf0a696e);
$parcel$export(module.exports, "getUserOptionFromUser", () => $099fe508ffcd564f$export$16086438354dcc85);
$parcel$export(module.exports, "getUserFromUserOption", () => $099fe508ffcd564f$export$78a8bcc5bd21caa2);
$parcel$export(module.exports, "getUserAvatarUrl", () => $099fe508ffcd564f$export$7d801d84202c7743);
$parcel$export(module.exports, "getUserShape", () => $099fe508ffcd564f$export$322b6ab8c29a006e);

var $75erM = parcelRequire("75erM");

var $khZGg = parcelRequire("khZGg");

const $099fe508ffcd564f$export$42c5a0b65ef9ee80 = ({ formatMessage: formatMessage })=>({
        accountId: (0, $ee8519ef4d8fa2c0$export$bdab9bfb39981463),
        displayName: formatMessage((0, $75erM.default).unassignedOption),
        avatarUrls: {}
    });
const $099fe508ffcd564f$export$8d7a63500893c8c = ({ formatMessage: formatMessage })=>({
        accountId: (0, $ee8519ef4d8fa2c0$export$f5d5f6bb902f1027),
        displayName: formatMessage((0, $75erM.default).automaticOption),
        avatarUrls: {}
    });
const $099fe508ffcd564f$export$84a82764cf0a696e = ({ formatMessage: formatMessage }, isAdmin)=>({
        accountId: (0, $ee8519ef4d8fa2c0$export$d875316cb0cd94f7),
        displayName: formatMessage(isAdmin ? (0, $75erM.default).invitePeopleOptionAdmin : (0, $75erM.default).invitePeopleOption),
        avatarUrls: {
            '48x48': (0, (/*@__PURE__*/$parcel$interopDefault($khZGg)))
        }
    });
const $099fe508ffcd564f$export$16086438354dcc85 = ({ accountId: accountId, displayName: displayName, avatarUrls: avatarUrls, emailAddress: emailAddress })=>({
        id: accountId || '',
        name: displayName,
        avatarUrl: avatarUrls['48x48'],
        // @ts-expect-error Will be part of JIV-13488; `user.emailAddress` returned by the REST API can be null depending on their privacy settings
        byline: emailAddress
    });
const $099fe508ffcd564f$export$78a8bcc5bd21caa2 = ({ id: id, name: name, avatarUrl: avatarUrl })=>({
        accountId: id,
        displayName: name,
        avatarUrls: {
            '48x48': avatarUrl
        }
    });
const $099fe508ffcd564f$export$7d801d84202c7743 = ({ avatarUrls: avatarUrls })=>avatarUrls['48x48'];
const $099fe508ffcd564f$export$322b6ab8c29a006e = (accountId, displayName, avatarUrl)=>({
        accountId: accountId,
        displayName: displayName,
        avatarUrls: {
            '48x48': avatarUrl
        }
    });

});
parcelRegister("75erM", function(module, exports) {

$parcel$export(module.exports, "default", () => $7306fd7bf3880cfd$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $7306fd7bf3880cfd$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    unassignedOption: {
        "id": "issue-field-assignee.unassigned-option",
        "defaultMessage": "Unassigned"
    },
    automaticOption: {
        "id": "issue-field-assignee.automatic-option",
        "defaultMessage": "Automatic"
    },
    assignToMe: {
        "id": "issue-field-assignee.assign-to-me",
        "defaultMessage": "Assign to me"
    },
    searchForAssignee: {
        "id": "issue-field-assignee.search-for-assignee",
        "defaultMessage": "Search for assignee"
    },
    invitePeopleOption: {
        "id": "issue-field-assignee.invite-people-option",
        "defaultMessage": "Add teammate to Jira"
    },
    invitePeopleOptionAdmin: {
        "id": "issue-field-assignee.invite-people-option-admin",
        "defaultMessage": "Invite teammate to Jira"
    }
});

});

parcelRegister("khZGg", function(module, exports) {
module.exports = new URL("add.b8fea212.png", import.meta.url).toString();

});

const $ee8519ef4d8fa2c0$export$bdab9bfb39981463 = '__UNASSIGNED_ID__';
const $ee8519ef4d8fa2c0$export$d875316cb0cd94f7 = '__INVITE_PEOPLE_ID__';
const $ee8519ef4d8fa2c0$export$f5d5f6bb902f1027 = '-1';


parcelRegister("ellWq", function(module, exports) {

$parcel$export(module.exports, "isNotEmptyString", () => $8c912a05aac1e6fb$export$582443c7ead02173);
const $8c912a05aac1e6fb$export$582443c7ead02173 = (value)=>typeof value === 'string' && value !== '';

});

parcelRegister("biM1w", function(module, exports) {

$parcel$export(module.exports, "singleValueLookup", () => $c49dee719933c0ad$export$93a99fc9939aad85);
/**
 * Finds a single entity from a provided list of entities
 *
 * @param value - the value search being made by
 * @param lookupValues - list of entities where search is being made
 * @param lookupKey - property name of the entity from the lookupValues list with which value will be compared
 */ const $c49dee719933c0ad$export$93a99fc9939aad85 = (value, // eslint-disable-next-line @typescript-eslint/no-explicit-any
lookupValues = [], lookupKey)=>lookupValues.find((option)=>option[lookupKey] === value);

});


parcelRegister("g2Dfs", function(module, exports) {

$parcel$export(module.exports, "validateCascadingSelectSetValue", () => $f6a9b6a7adb30a09$export$2d586ab6ce4d7126);
$parcel$export(module.exports, "validateCascadingSelectWithAriSetValue", () => $f6a9b6a7adb30a09$export$1e029e8cc721ad5e);

var $i8ELT = parcelRequire("i8ELT");

var $ellWq = parcelRequire("ellWq");
const $f6a9b6a7adb30a09$export$2d586ab6ce4d7126 = (value)=>value === null || typeof value === 'object' && 'parentId' in value && 'childId' in value && (0, $ellWq.isNotEmptyString)(value.parentId) && ((0, $ellWq.isNotEmptyString)(value.childId) || value.childId === null);
const $f6a9b6a7adb30a09$export$1e029e8cc721ad5e = (value)=>value === null || typeof value === 'object' && 'parentId' in value && 'childId' in value && (0, $ellWq.isNotEmptyString)(value.parentId) && (0, $i8ELT.isAriResourceIdValid)(value.parentId) && (value.childId === null || (0, $ellWq.isNotEmptyString)(value.childId) && (0, $i8ELT.isAriResourceIdValid)(value.childId));

});
parcelRegister("i8ELT", function(module, exports) {

$parcel$export(module.exports, "isAriResourceIdValid", () => $6ecca2b91916ba31$export$4d1e9901084f3bf6);

var $wufAv = parcelRequire("wufAv");
const $6ecca2b91916ba31$var$CLOUD_ID_MOCK = 'cloud-id';
const $6ecca2b91916ba31$var$ACTIVATION_ID_MOCK = 'activation-id';
const $6ecca2b91916ba31$var$FIELD_ID_MOCK = 'field-1';
const $6ecca2b91916ba31$export$4d1e9901084f3bf6 = (optionId)=>{
    try {
        (0, $wufAv.JiraIssueFieldOptionAri).create({
            siteId: $6ecca2b91916ba31$var$CLOUD_ID_MOCK,
            activationId: $6ecca2b91916ba31$var$ACTIVATION_ID_MOCK,
            fieldId: $6ecca2b91916ba31$var$FIELD_ID_MOCK,
            optionId: optionId
        });
        return true;
    } catch (e) {
        return false;
    }
};

});
parcelRegister("wufAv", function(module, exports) {

$parcel$export(module.exports, "JiraIssueFieldOptionAri", () => $061a7460522c266a$export$e3bc1ec22f941fbe);

var $4gJvn = parcelRequire("4gJvn");

var $3TJ9u = parcelRequire("3TJ9u");

var $cSeYX = parcelRequire("cSeYX");
// src/jira/issue-field-option/manifest.ts
var $061a7460522c266a$var$jiraIssueFieldOptionAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $4gJvn.JiraIssueFieldOptionAriResourceOwner),
    resourceType: (0, $4gJvn.JiraIssueFieldOptionAriResourceType),
    resourceIdSlug: "activation/{activationId}/{fieldId}/{optionId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        fieldId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/,
        // eslint-disable-line no-useless-escape
        optionId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/jira/issue-field-option/index.ts
var $061a7460522c266a$export$e3bc1ec22f941fbe = class _JiraIssueFieldOptionAri extends (0, $3TJ9u.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._fieldId = opts.resourceIdSegmentValues.fieldId, this._optionId = opts.resourceIdSegmentValues.optionId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get fieldId() {
        return this._fieldId;
    }
    get optionId() {
        return this._optionId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $061a7460522c266a$var$jiraIssueFieldOptionAriStaticOpts.qualifier,
            platformQualifier: $061a7460522c266a$var$jiraIssueFieldOptionAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $061a7460522c266a$var$jiraIssueFieldOptionAriStaticOpts.resourceOwner,
            resourceType: $061a7460522c266a$var$jiraIssueFieldOptionAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.fieldId}/${opts.optionId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                fieldId: opts.fieldId,
                optionId: opts.optionId
            }
        }, ariOpts = (0, $cSeYX.AriParser).fromOpts(derivedOpts, $061a7460522c266a$var$jiraIssueFieldOptionAriStaticOpts);
        return new _JiraIssueFieldOptionAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $cSeYX.AriParser).fromString(maybeAri, $061a7460522c266a$var$jiraIssueFieldOptionAriStaticOpts);
        return new _JiraIssueFieldOptionAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            fieldId: this.fieldId,
            optionId: this.optionId
        };
    }
};

});
parcelRegister("4gJvn", function(module, exports) {

$parcel$export(module.exports, "JiraIssueFieldOptionAriResourceOwner", () => $31bbf461f55c01f8$export$eb4f4cf0880fe5a8);
$parcel$export(module.exports, "JiraIssueFieldOptionAriResourceType", () => $31bbf461f55c01f8$export$4bec333360908e78);
// src/jira/issue-field-option/types.ts
var $31bbf461f55c01f8$export$eb4f4cf0880fe5a8 = "jira", $31bbf461f55c01f8$export$4bec333360908e78 = "issue-field-option";

});




parcelRegister("617QW", function(module, exports) {

$parcel$export(module.exports, "validateComponentsSetValue", () => $d8897869254bf9cd$export$c65e64c3a855d5d2);
$parcel$export(module.exports, "componentsRequiredScopes", () => $d8897869254bf9cd$export$a818a96eabdabcb);

var $agwg4 = parcelRequire("agwg4");

var $ellWq = parcelRequire("ellWq");
const $d8897869254bf9cd$export$c65e64c3a855d5d2 = (value)=>Array.isArray(value) && value.length <= (0, $7f80bdb4337734ff$export$106087dcfd4fb129) && value.every((0, $ellWq.isNotEmptyString));
const $d8897869254bf9cd$export$a818a96eabdabcb = {
    ...(0, $agwg4.baseScopesRequiredPerField),
    granular: [
        'read:project.component:jira',
        ...(0, $agwg4.baseScopesRequiredPerField).granular,
        'write:field.default-value:jira'
    ]
};

});

parcelRegister("gUgNl", function(module, exports) {

$parcel$export(module.exports, "datePickerSetValueValidator", () => $fc51baa01bcc55d9$export$c003579a97a2459e);
$parcel$export(module.exports, "datePickerSetValueTransformer", () => $fc51baa01bcc55d9$export$cfb5350c1b8d2150);
$parcel$export(module.exports, "datePickerGetValueTransformer", () => $fc51baa01bcc55d9$export$e844c6ac3a5cbef7);

var $57raR = parcelRequire("57raR");
var $dBLX0 = parcelRequire("dBLX0");
var $cT05m = parcelRequire("cT05m");
var $kQ82p = parcelRequire("kQ82p");
// Date picker accepts only date string in format yyyy-MM-dd, so we need to validate it
// The date format is consistent with API contract
const $fc51baa01bcc55d9$var$dateHasExpectedFormat = (date)=>{
    const dateFormat = 'yyyy-MM-dd';
    // `parse` doesn't respect strict format, see known issue https://github.com/date-fns/date-fns/issues/942
    // where format yyyy-MM-dd date 2022-10-2 is parsed successfully but shouldn't
    if (typeof date !== 'string' || dateFormat.length !== date.length) return false;
    const parsedDate = (0, $cT05m.default)(date, dateFormat, new Date());
    return (0, $dBLX0.default)(parsedDate);
};
const $fc51baa01bcc55d9$export$c003579a97a2459e = (value)=>value === null || $fc51baa01bcc55d9$var$dateHasExpectedFormat(value);
const $fc51baa01bcc55d9$export$cfb5350c1b8d2150 = (publicValue)=>publicValue === null ? '' : publicValue;
const $fc51baa01bcc55d9$export$e844c6ac3a5cbef7 = (value)=>{
    if (!value) return null;
    const parsedDate = (0, $kQ82p.default)(value);
    if ((0, $dBLX0.default)(parsedDate)) return (0, $57raR.default)(parsedDate, 'yyyy-MM-dd');
    return null;
};

});

parcelRegister("isBNo", function(module, exports) {

$parcel$export(module.exports, "validateDateTimePickerSetValue", () => $dc606ca358795c25$export$7930ddff407505cc);
$parcel$export(module.exports, "transformDateTimePickerSetValue", () => $dc606ca358795c25$export$e81204f19744e19f);
$parcel$export(module.exports, "transformDateTimePickerGetValue", () => $dc606ca358795c25$export$4cb6c79fda4a9c74);

var $57raR = parcelRequire("57raR");
var $b6xhe = parcelRequire("b6xhe");
var $dBLX0 = parcelRequire("dBLX0");
var $kQ82p = parcelRequire("kQ82p");
// Date time picker accepts only date string in format YYYY-MM-DDThh:mm:ssTZD
const $dc606ca358795c25$var$formatString = "yyyy-MM-dd'T'HH:mmxxx";
const $dc606ca358795c25$export$a886f5166a4d311e = (fullDate)=>{
    if (typeof fullDate !== 'string') return false;
    return (0, $b6xhe.default)(fullDate, $dc606ca358795c25$var$formatString) && (0, $dBLX0.default)((0, $kQ82p.default)(fullDate));
};
const $dc606ca358795c25$export$7930ddff407505cc = (value)=>value === null || $dc606ca358795c25$export$a886f5166a4d311e(value);
const $dc606ca358795c25$export$e81204f19744e19f = (publicValue)=>publicValue === null ? '' : publicValue;
const $dc606ca358795c25$export$4cb6c79fda4a9c74 = (value)=>{
    if (!value) return null;
    const parsedDate = (0, $kQ82p.default)(value);
    if ((0, $dBLX0.default)(parsedDate)) return (0, $57raR.default)(parsedDate, $dc606ca358795c25$var$formatString);
    return null;
};

});

parcelRegister("5N8Mq", function(module, exports) {

$parcel$export(module.exports, "issueTypeSetValueValidator", () => $4c694ac006da52ba$export$19e9b52e41260d79);
$parcel$export(module.exports, "validateIssueTypeWithAriSetValue", () => $4c694ac006da52ba$export$91780d7591f86a1d);

var $i8ELT = parcelRequire("i8ELT");

var $ellWq = parcelRequire("ellWq");
const $4c694ac006da52ba$export$19e9b52e41260d79 = (value)=>(0, $ellWq.isNotEmptyString)(value);
const $4c694ac006da52ba$export$91780d7591f86a1d = (value)=>(0, $ellWq.isNotEmptyString)(value) && (0, $i8ELT.isAriResourceIdValid)(value);

});

parcelRegister("jm0ph", function(module, exports) {

$parcel$export(module.exports, "labelsRequiredScopes", () => $d4b9924142d4a0cd$export$5397fc4189b6d690);
$parcel$export(module.exports, "labelsSetValueValidator", () => $d4b9924142d4a0cd$export$e67b5652c846b5f);
$parcel$export(module.exports, "labelsSetValueTransformer", () => $d4b9924142d4a0cd$export$861e9d180b68fea1);
$parcel$export(module.exports, "labelsGetValueTransformer", () => $d4b9924142d4a0cd$export$b0b12fd0b1cd9d3a);

var $agwg4 = parcelRequire("agwg4");
const $d4b9924142d4a0cd$export$5397fc4189b6d690 = {
    granular: [
        ...(0, $agwg4.baseScopesRequiredPerField).granular,
        'read:label:jira'
    ],
    coarse: [
        ...(0, $agwg4.baseScopesRequiredPerField).coarse
    ]
};
const $d4b9924142d4a0cd$export$e67b5652c846b5f = (value)=>typeof value === 'object' && value !== null && Array.isArray(value) && value.every((label)=>typeof label === 'string' && label !== '');
const $d4b9924142d4a0cd$export$861e9d180b68fea1 = (publicValue)=>publicValue.map((label)=>({
            value: label,
            label: label
        }));
const $d4b9924142d4a0cd$export$b0b12fd0b1cd9d3a = (internalValue)=>internalValue.map(({ value: value })=>value);

});

parcelRegister("lELZM", function(module, exports) {

$parcel$export(module.exports, "validateNumberValue", () => $47b587d42a9a5d83$export$aeb074bfcd7963bd);
$parcel$export(module.exports, "numberScopes", () => $47b587d42a9a5d83$export$2ddc76933cd1391c);

var $agwg4 = parcelRequire("agwg4");
const $47b587d42a9a5d83$export$aeb074bfcd7963bd = (value)=>value === null || typeof value === 'number';
const $47b587d42a9a5d83$export$2ddc76933cd1391c = (0, $agwg4.baseScopesRequiredPerField);

});

parcelRegister("avA6T", function(module, exports) {

$parcel$export(module.exports, "parentSetValueValidator", () => $0df1333dc17b6205$export$ada98fdbc0faa607);
$parcel$export(module.exports, "validateParentWithAriSetValue", () => $0df1333dc17b6205$export$e3aab6ae1b4e9174);
$parcel$export(module.exports, "validateParentSetOptionsVisibilityAri", () => $0df1333dc17b6205$export$8cdcca29a2b25e60);
$parcel$export(module.exports, "parentScopes", () => $0df1333dc17b6205$export$bdc8bd505789b6e8);

var $2ApNu = parcelRequire("2ApNu");

var $agwg4 = parcelRequire("agwg4");

var $ellWq = parcelRequire("ellWq");

var $9NjWc = parcelRequire("9NjWc");
const $0df1333dc17b6205$var$CLOUD_ID_MOCK = 'cloud-id';
const $0df1333dc17b6205$export$9603e65f1e714629 = (optionId)=>{
    try {
        (0, $2ApNu.JiraIssueAri).create({
            siteId: $0df1333dc17b6205$var$CLOUD_ID_MOCK,
            issueId: optionId
        });
        return true;
    } catch (e) {
        return false;
    }
};
const $0df1333dc17b6205$export$ada98fdbc0faa607 = (value)=>value === null || (0, $ellWq.isNotEmptyString)(value);
const $0df1333dc17b6205$export$e3aab6ae1b4e9174 = (value)=>value === null || (0, $ellWq.isNotEmptyString)(value) && $0df1333dc17b6205$export$9603e65f1e714629(value);
const $0df1333dc17b6205$export$8cdcca29a2b25e60 = (optionsVisibility)=>(0, $9NjWc.validateSetOptionsVisibility)(optionsVisibility) && optionsVisibility.options.every((optionId)=>$0df1333dc17b6205$export$9603e65f1e714629(optionId));
const $0df1333dc17b6205$export$bdc8bd505789b6e8 = (0, $agwg4.baseScopesRequiredPerField);

});
parcelRegister("2ApNu", function(module, exports) {

$parcel$export(module.exports, "JiraIssueAri", () => $1e22f45952f0c501$export$1da6808e89ee03e);

var $dhskT = parcelRequire("dhskT");

var $3TJ9u = parcelRequire("3TJ9u");

var $cSeYX = parcelRequire("cSeYX");
// src/jira/issue/manifest.ts
var $1e22f45952f0c501$var$jiraIssueAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $dhskT.JiraIssueAriResourceOwner),
    resourceType: (0, $dhskT.JiraIssueAriResourceType),
    resourceIdSlug: "{issueId}",
    resourceIdSegmentFormats: {
        issueId: /[0-9]+/
    }
};
// src/jira/issue/index.ts
var $1e22f45952f0c501$export$1da6808e89ee03e = class _JiraIssueAri extends (0, $3TJ9u.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._issueId = opts.resourceIdSegmentValues.issueId;
    }
    get siteId() {
        return this._siteId;
    }
    get issueId() {
        return this._issueId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $1e22f45952f0c501$var$jiraIssueAriStaticOpts.qualifier,
            platformQualifier: $1e22f45952f0c501$var$jiraIssueAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $1e22f45952f0c501$var$jiraIssueAriStaticOpts.resourceOwner,
            resourceType: $1e22f45952f0c501$var$jiraIssueAriStaticOpts.resourceType,
            resourceId: `${opts.issueId}`,
            resourceIdSegmentValues: {
                issueId: opts.issueId
            }
        }, ariOpts = (0, $cSeYX.AriParser).fromOpts(derivedOpts, $1e22f45952f0c501$var$jiraIssueAriStaticOpts);
        return new _JiraIssueAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $cSeYX.AriParser).fromString(maybeAri, $1e22f45952f0c501$var$jiraIssueAriStaticOpts);
        return new _JiraIssueAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            issueId: this.issueId
        };
    }
};

});
parcelRegister("dhskT", function(module, exports) {

$parcel$export(module.exports, "JiraIssueAriResourceOwner", () => $9ab2d7d34ec0a003$export$665a39f1b4e29e0a);
$parcel$export(module.exports, "JiraIssueAriResourceType", () => $9ab2d7d34ec0a003$export$76beb4d0da177ad4);
// src/jira/issue/types.ts
var $9ab2d7d34ec0a003$export$665a39f1b4e29e0a = "jira", $9ab2d7d34ec0a003$export$76beb4d0da177ad4 = "issue";

});


parcelRegister("9NjWc", function(module, exports) {

$parcel$export(module.exports, "transformSelectSetOptionsVisibility", () => $ace8efe078950c49$export$81990085f8ab114b);
$parcel$export(module.exports, "transformSetOptionsVisibilityForFrontendFilteringWithARIs", () => $ace8efe078950c49$export$19d00b5cfa21ccb4);
$parcel$export(module.exports, "transformOptionIdsToARI", () => $ace8efe078950c49$export$aaa1909c16b4bd2c);
$parcel$export(module.exports, "transformSetOptionsVisibilityAri", () => $ace8efe078950c49$export$a68e1c2d1192287c);
$parcel$export(module.exports, "transformSelectGetOptionsVisibility", () => $ace8efe078950c49$export$7c7ca81813eb0f65);
$parcel$export(module.exports, "validateSetOptionsVisibilityRule", () => $ace8efe078950c49$export$cb8a43658ea03ec7);
$parcel$export(module.exports, "validateSetOptionsVisibility", () => $ace8efe078950c49$export$973aead813665e25);
$parcel$export(module.exports, "validateSetOptionsVisibilityAri", () => $ace8efe078950c49$export$979d55c1d0a17c97);

var $wufAv = parcelRequire("wufAv");

var $i8ELT = parcelRequire("i8ELT");

var $ellWq = parcelRequire("ellWq");

var $gZsU5 = parcelRequire("gZsU5");
const $ace8efe078950c49$export$81990085f8ab114b = ({ isVisible: isVisible, options: options })=>({
        operation: isVisible ? 'ALLOW' : 'EXCLUDE',
        ids: options
    });
const $ace8efe078950c49$export$19d00b5cfa21ccb4 = ({ isVisible: isVisible, options: options }, _lookupValues, context)=>({
        operation: isVisible ? 'ALLOW' : 'EXCLUDE',
        ids: $ace8efe078950c49$export$aaa1909c16b4bd2c(options, context)
    });
const $ace8efe078950c49$export$aaa1909c16b4bd2c = (optionIds, { tenantContext: tenantContext, fieldContext: fieldContext })=>optionIds.reduce((acc, optionId)=>{
        try {
            const optionAri = (0, $wufAv.JiraIssueFieldOptionAri).create({
                siteId: tenantContext.cloudId,
                activationId: tenantContext.activationId,
                fieldId: fieldContext.fieldId,
                optionId: optionId
            }).toString();
            acc.push(optionAri);
        } catch (e) {
        // do nothing
        }
        return acc;
    }, []);
const $ace8efe078950c49$export$a68e1c2d1192287c = ({ isVisible: isVisible, options: options }, _lookupValues, context)=>({
        operation: isVisible ? 'ALLOW' : 'EXCLUDE',
        optionIds: $ace8efe078950c49$export$aaa1909c16b4bd2c(options, context)
    });
const $ace8efe078950c49$export$7c7ca81813eb0f65 = ({ isVisible: isVisible, options: options })=>({
        isVisible: isVisible,
        options: options
    });
const $ace8efe078950c49$export$cb8a43658ea03ec7 = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
optionsVisibility)=>(0, $gZsU5.isObject)(optionsVisibility) && typeof optionsVisibility.isVisible === 'boolean' && Array.isArray(optionsVisibility.options) && optionsVisibility.options.every((0, $ellWq.isNotEmptyString));
const $ace8efe078950c49$export$914c7f5212c4c649 = (optionsVisibility)=>optionsVisibility.options.length <= 100;
const $ace8efe078950c49$export$973aead813665e25 = (optionsVisibility)=>$ace8efe078950c49$export$cb8a43658ea03ec7(optionsVisibility) && $ace8efe078950c49$export$914c7f5212c4c649(optionsVisibility);
const $ace8efe078950c49$export$979d55c1d0a17c97 = (optionsVisibility)=>$ace8efe078950c49$export$973aead813665e25(optionsVisibility) && optionsVisibility.options.every((optionId)=>(0, $i8ELT.isAriResourceIdValid)(optionId));

});
parcelRegister("gZsU5", function(module, exports) {

$parcel$export(module.exports, "isObject", () => $e3a36d8f09bbb085$export$a6cdc56e425d0d0a);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $e3a36d8f09bbb085$export$a6cdc56e425d0d0a = (value)=>typeof value === 'object' && value !== null;

});



parcelRegister("hCYJC", function(module, exports) {

$parcel$export(module.exports, "validatePrioritySetValue", () => $8a3bf62bfc005613$export$feb916d6d9ca4953);
$parcel$export(module.exports, "validatePriorityWithAriSetValue", () => $8a3bf62bfc005613$export$d41ad24763f49041);
$parcel$export(module.exports, "priorityScopes", () => $8a3bf62bfc005613$export$de5c165bee5efef2);

var $agwg4 = parcelRequire("agwg4");

var $i8ELT = parcelRequire("i8ELT");

var $ellWq = parcelRequire("ellWq");
const $8a3bf62bfc005613$export$feb916d6d9ca4953 = (value)=>(0, $ellWq.isNotEmptyString)(value);
const $8a3bf62bfc005613$export$d41ad24763f49041 = (value)=>(0, $ellWq.isNotEmptyString)(value) && (0, $i8ELT.isAriResourceIdValid)(value);
const $8a3bf62bfc005613$export$de5c165bee5efef2 = {
    ...(0, $agwg4.baseScopesRequiredPerField),
    granular: [
        ...(0, $agwg4.baseScopesRequiredPerField).granular,
        'read:priority:jira'
    ]
};

});

parcelRegister("a3r90", function(module, exports) {

$parcel$export(module.exports, "radioButtonsSetValueValidator", () => $c7170b8069b0d982$export$fd2e39ca7399c512);
$parcel$export(module.exports, "validateRadioButtonsWithAriSetValue", () => $c7170b8069b0d982$export$5fe5484755d2d441);
$parcel$export(module.exports, "radioButtonsScopes", () => $c7170b8069b0d982$export$baef9137cbf80a51);

var $agwg4 = parcelRequire("agwg4");

var $i8ELT = parcelRequire("i8ELT");

var $ellWq = parcelRequire("ellWq");
const $c7170b8069b0d982$export$fd2e39ca7399c512 = (value)=>value === null || (0, $ellWq.isNotEmptyString)(value);
const $c7170b8069b0d982$export$5fe5484755d2d441 = (value)=>value === null || (0, $ellWq.isNotEmptyString)(value) && (0, $i8ELT.isAriResourceIdValid)(value);
const $c7170b8069b0d982$export$baef9137cbf80a51 = (0, $agwg4.baseScopesRequiredPerField);

});

parcelRegister("lT0nv", function(module, exports) {

$parcel$export(module.exports, "reporterSetValueValidator", () => $459b0c4fdef899fa$export$b8b018eb25bdb4d8);

var $faPX6 = parcelRequire("faPX6");

var $ellWq = parcelRequire("ellWq");
const $459b0c4fdef899fa$export$b8b018eb25bdb4d8 = (value)=>// We should omit automatic id special value so it won't be picked up by this field
    // It is only applicable to the assignee field
    value === null || (0, $ellWq.isNotEmptyString)(value) && (0, $faPX6.isNotAutomaticId)(value);

});
parcelRegister("faPX6", function(module, exports) {

$parcel$export(module.exports, "isNotAutomaticId", () => $83e3e8cdf234220e$export$ab4c3a3c49d7add);

const $83e3e8cdf234220e$export$ab4c3a3c49d7add = (value)=>value !== (0, $7f80bdb4337734ff$export$f5d5f6bb902f1027);

});


parcelRegister("fZNR8", function(module, exports) {

$parcel$export(module.exports, "userPickerSetValueValidator", () => $787114bdac0452dc$export$e01dbe42b757ec);

var $faPX6 = parcelRequire("faPX6");

var $ellWq = parcelRequire("ellWq");
const $787114bdac0452dc$export$e01dbe42b757ec = (value)=>// We should omit automatic id special value, so it won't be picked up by this field
    // It is only applicable to the assignee field
    value === null || (0, $ellWq.isNotEmptyString)(value) && (0, $faPX6.isNotAutomaticId)(value);

});

parcelRegister("8FDN0", function(module, exports) {

$parcel$export(module.exports, "validateVersionValue", () => $679cc55aede7624a$export$f3e581e8b1e2479a);
$parcel$export(module.exports, "validateVersionWithAriSetValue", () => $679cc55aede7624a$export$7b83966d45a2bceb);
$parcel$export(module.exports, "versionsRequiredScopes", () => $679cc55aede7624a$export$60db61c485973ad9);

var $agwg4 = parcelRequire("agwg4");

var $i8ELT = parcelRequire("i8ELT");

var $ellWq = parcelRequire("ellWq");
const $679cc55aede7624a$export$f3e581e8b1e2479a = (value)=>Array.isArray(value) && value.every((0, $ellWq.isNotEmptyString)) && value.length <= (0, $7f80bdb4337734ff$export$106087dcfd4fb129);
const $679cc55aede7624a$export$7b83966d45a2bceb = (value)=>Array.isArray(value) && value.every((val)=>(0, $ellWq.isNotEmptyString)(val) && (0, $i8ELT.isAriResourceIdValid)(val)) && value.length <= (0, $7f80bdb4337734ff$export$106087dcfd4fb129);
const $679cc55aede7624a$export$60db61c485973ad9 = {
    granular: [
        ...(0, $agwg4.baseScopesRequiredPerField).granular,
        'read:project-version:jira'
    ],
    coarse: [
        ...(0, $agwg4.baseScopesRequiredPerField).coarse
    ]
};

});

parcelRegister("kyAb0", function(module, exports) {

$parcel$export(module.exports, "getCommonFieldValidators", () => $088bb662cafd15b3$export$68248012b0fecf7d);

var $0mclG = parcelRequire("0mclG");

var $67ldU = parcelRequire("67ldU");
var $gPXOi = parcelRequire("gPXOi");

var $1qarT = parcelRequire("1qarT");

var $6jG5m = parcelRequire("6jG5m");
const $088bb662cafd15b3$var$validateDescription = async (value)=>{
    if (typeof value !== 'string') return false;
    if (value === '') return true;
    // turn into ADF
    try {
        const adfValue = await (0, $67ldU.convertWikiToAdfAsync)(value);
        if (!adfValue) return false;
        // find image nodes that contain external URLs.
        (0, $0mclG.traverse)(adfValue, {
            media: (node)=>{
                if (node.attrs?.type === 'external' && node.attrs.url !== undefined) // ADF cannot contain external urls due to the possibility of data egress.
                throw new (0, $6jG5m.ExternalImageValidationError)('Cannot contain external images');
            }
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        // ExternalImageValidationError will be thrown if there is an external image
        if (!(err instanceof (0, $6jG5m.ExternalImageValidationError))) // TODO: use valid value of issueType instead of undefined in fireIAErrorAnalytics call. There is a task for it - https://ecosystem-platform.atlassian.net/browse/UIM-1651;
        (0, $1qarT.fireErrorAnalytics)({
            error: err,
            id: 'descriptionWikiValidationException',
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/consistent-type-assertions
            viewType: undefined,
            attributes: {
                errorCause: err?.cause,
                message: err.message
            }
        });
        return false;
    }
    return true;
};
const $088bb662cafd15b3$export$68248012b0fecf7d = ()=>({
        ...(0, $gPXOi.getCommonFieldValidators)(),
        description: $088bb662cafd15b3$var$validateDescription
    });

});
parcelRegister("0mclG", function(module, exports) {

$parcel$export(module.exports, "traverse", () => $9495d7eb76b80944$export$df3f009e3d155b20);
function $9495d7eb76b80944$export$735cfea22ce30f58(_visitors) {
    return true;
}
function $9495d7eb76b80944$export$df3f009e3d155b20(adf, visitors) {
    if (!$9495d7eb76b80944$export$735cfea22ce30f58(visitors)) throw new Error(`Visitors are not valid: "${Object.keys(visitors).join(', ')}"`);
    return $9495d7eb76b80944$var$traverseNode(adf, {
        node: undefined
    }, visitors, 0, 0);
}
function $9495d7eb76b80944$var$traverseNode(adfNode, parent, visitors, index, depth) {
    const visitor = visitors[adfNode.type] || visitors['any'];
    let newNode = {
        ...adfNode
    };
    if (visitor) {
        const processedNode = visitor({
            ...newNode
        }, parent, index, depth);
        if (processedNode === false) return false;
        newNode = processedNode || adfNode;
    }
    if (newNode.content) newNode.content = newNode.content.reduce((acc, node, idx)=>{
        if (!node) return acc;
        const processedNode = $9495d7eb76b80944$var$traverseNode(node, {
            node: newNode,
            parent: parent
        }, visitors, idx, depth + 1);
        if (processedNode !== false) acc.push(processedNode);
        return acc;
    }, []);
    return newNode;
}

});

parcelRegister("67ldU", function(module, exports) {

$parcel$export(module.exports, "convertWikiToAdfAsync", () => $06790da685aaf846$export$8e1b3b0130ee3556);

var $8DB98 = parcelRequire("8DB98");

var $lovmf = parcelRequire("lovmf");

var $dmYzn = parcelRequire("dmYzn");
const $06790da685aaf846$var$wikiTransformer = new (0, $dmYzn.WikiMarkupTransformer)((0, $8DB98.defaultSchema));
const $06790da685aaf846$var$adfTransformer = new (0, $lovmf.JSONTransformer)();
const $06790da685aaf846$export$3dfdef94497f0395 = (wiki)=>{
    if (wiki == null || wiki === '') return null;
    const pmNode = $06790da685aaf846$var$wikiTransformer.parse(wiki);
    return $06790da685aaf846$var$adfTransformer.encode(pmNode);
};



const $06790da685aaf846$export$8e1b3b0130ee3556 = async (wiki)=>{
    if (wiki == null || wiki === '') return Promise.resolve(null);
    const wikiPromise = Promise.resolve((parcelRequire("dmYzn")));
    const schemaPromise = Promise.resolve((parcelRequire("8DB98")));
    const jsonPromise = Promise.resolve((parcelRequire("lovmf")));
    const [{ defaultSchema: defaultSchema }, { WikiMarkupTransformer: WikiMarkupTransformer }, { JSONTransformer: JSONTransformer }] = await Promise.all([
        schemaPromise,
        wikiPromise,
        jsonPromise
    ]);
    const wikiTransformer = new WikiMarkupTransformer(defaultSchema);
    const adfTransformer = new JSONTransformer();
    const pmNode = wikiTransformer.parse(wiki);
    return adfTransformer.encode(pmNode);
};

});
parcelRegister("8DB98", function(module, exports) {

$parcel$export(module.exports, "defaultSchemaConfig", () => $649ec7bd1a149376$export$e4e3ac1fa64862db);
$parcel$export(module.exports, "getSchemaBasedOnStage", () => $649ec7bd1a149376$export$fd147e7d448dea03);
$parcel$export(module.exports, "defaultSchema", () => $649ec7bd1a149376$export$1db618b7b2275ea1);

var $LFmXM = parcelRequire("LFmXM");

var $eSKW9 = parcelRequire("eSKW9");
var $6C9Qx = parcelRequire("6C9Qx");
var $jSvxD = parcelRequire("jSvxD");
var $gkLMH = parcelRequire("gkLMH");
var $e6HpD = parcelRequire("e6HpD");

var $g7Jv8 = parcelRequire("g7Jv8");
const $649ec7bd1a149376$var$getDefaultSchemaConfig = ()=>{
    const defaultSchemaConfig = {
        nodes: [
            'doc',
            'paragraph',
            'text',
            'bulletList',
            'orderedList',
            'listItem',
            'heading',
            'blockquote',
            'codeBlock',
            'panel',
            'rule',
            'image',
            'caption',
            'mention',
            'media',
            'mediaGroup',
            'mediaSingle',
            'mediaInline',
            'confluenceUnsupportedBlock',
            'confluenceUnsupportedInline',
            'confluenceJiraIssue',
            'expand',
            'nestedExpand',
            'extension',
            'inlineExtension',
            'bodiedExtension',
            'hardBreak',
            'emoji',
            'table',
            'tableCell',
            'tableHeader',
            'tableRow',
            'decisionList',
            'decisionItem',
            'taskList',
            'taskItem',
            'unknownBlock',
            'date',
            'status',
            'placeholder',
            'layoutSection',
            'layoutColumn',
            'inlineCard',
            'blockCard',
            'embedCard',
            'unsupportedBlock',
            'unsupportedInline'
        ],
        marks: [
            'link',
            'em',
            'strong',
            'strike',
            'subsup',
            'underline',
            'code',
            'textColor',
            'backgroundColor',
            'confluenceInlineComment',
            'breakout',
            'alignment',
            'indentation',
            'annotation',
            'dataConsumer',
            'border',
            'unsupportedMark',
            'unsupportedNodeAttribute',
            'typeAheadQuery',
            // https://product-fabric.atlassian.net/browse/ED-10214,
            'fragment'
        ]
    };
    return defaultSchemaConfig;
};
const $649ec7bd1a149376$export$e4e3ac1fa64862db = $649ec7bd1a149376$var$getDefaultSchemaConfig();
const $649ec7bd1a149376$export$fd147e7d448dea03 = (0, $LFmXM.default)((stage = 'final')=>{
    const defaultSchemaConfig = $649ec7bd1a149376$var$getDefaultSchemaConfig();
    if (stage === 'stage0') defaultSchemaConfig.customNodeSpecs = {
        layoutSection: (0, $jSvxD.layoutSectionWithSingleColumn),
        multiBodiedExtension: (0, $6C9Qx.multiBodiedExtension),
        extensionFrame: (0, $6C9Qx.extensionFrame),
        expand: (0, $eSKW9.expandWithNestedExpand),
        listItem: (0, $gkLMH.listItemWithDecisionStage0),
        table: (0, $e6HpD.tableWithNestedTable),
        tableRow: (0, $e6HpD.tableRowWithNestedTable),
        tableCell: (0, $e6HpD.tableCellWithNestedTable),
        tableHeader: (0, $e6HpD.tableHeaderWithNestedTable)
    };
    return (0, $g7Jv8.createSchema)(defaultSchemaConfig);
});
const $649ec7bd1a149376$export$1db618b7b2275ea1 = $649ec7bd1a149376$export$fd147e7d448dea03();

});
parcelRegister("eSKW9", function(module, exports) {

$parcel$export(module.exports, "expandWithNestedExpand", () => $ad5a848656ebe869$export$7b80cba28d10b2c1);
$parcel$export(module.exports, "toJSON", () => $ad5a848656ebe869$export$54fd2c36b5cc6731);

var $nJVLW = parcelRequire("nJVLW");
/**
 * @name expand_node
 */ /**
 * @name expand_with_no_mark_node
 */ /**
 * @name expand_root_only_node
 */ function $ad5a848656ebe869$var$getExpandAttrs(domNode) {
    const dom = domNode;
    return {
        title: dom.getAttribute('data-title'),
        __expanded: true
    };
}
const $ad5a848656ebe869$var$nodeSpecOptions = {
    parseDOM: [
        {
            context: 'table//',
            tag: 'div[data-node-type="expand"]',
            getAttrs: $ad5a848656ebe869$var$getExpandAttrs
        },
        {
            context: 'expand//',
            tag: '[data-node-type="expand"]',
            getAttrs: $ad5a848656ebe869$var$getExpandAttrs
        },
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="expand"]',
            getAttrs: $ad5a848656ebe869$var$getExpandAttrs
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="expand"]',
            getAttrs: $ad5a848656ebe869$var$getExpandAttrs
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'expand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};
const $ad5a848656ebe869$export$7b80cba28d10b2c1 = (0, $nJVLW.expand)($ad5a848656ebe869$var$nodeSpecOptions);
const $ad5a848656ebe869$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs).filter((key)=>!key.startsWith('__')).reduce((obj, key)=>{
            return {
                ...obj,
                [key]: node.attrs[key]
            };
        }, {})
    });

});
parcelRegister("nJVLW", function(module, exports) {

$parcel$export(module.exports, "blockCard", () => $0475c6ffc1ba526d$export$c4c2f833baaebdb8);
$parcel$export(module.exports, "blockquote", () => $0475c6ffc1ba526d$export$67dc04e652a298ca);
$parcel$export(module.exports, "blockquoteLegacy", () => $0475c6ffc1ba526d$export$199922e5af8e9a6);
$parcel$export(module.exports, "bodiedExtension", () => $0475c6ffc1ba526d$export$27903d543b563e39);
$parcel$export(module.exports, "bulletList", () => $0475c6ffc1ba526d$export$a140c94e5ea26bee);
$parcel$export(module.exports, "caption", () => $0475c6ffc1ba526d$export$8e3c2dfdc4f0453d);
$parcel$export(module.exports, "codeBlock", () => $0475c6ffc1ba526d$export$7bb0d5c671655cc4);
$parcel$export(module.exports, "confluenceJiraIssue", () => $0475c6ffc1ba526d$export$daf889beb5092f95);
$parcel$export(module.exports, "confluenceUnsupportedBlock", () => $0475c6ffc1ba526d$export$e6e4878f43c27cab);
$parcel$export(module.exports, "confluenceUnsupportedInline", () => $0475c6ffc1ba526d$export$3e6d667072febc87);
$parcel$export(module.exports, "date", () => $0475c6ffc1ba526d$export$324d90190a8b822a);
$parcel$export(module.exports, "decisionItem", () => $0475c6ffc1ba526d$export$6959e16eeff859b4);
$parcel$export(module.exports, "decisionList", () => $0475c6ffc1ba526d$export$62d45a65fb43d95e);
$parcel$export(module.exports, "doc", () => $0475c6ffc1ba526d$export$2a111da947c407d2);
$parcel$export(module.exports, "embedCard", () => $0475c6ffc1ba526d$export$be4283d9a1cb1ff6);
$parcel$export(module.exports, "emoji", () => $0475c6ffc1ba526d$export$a19185d1233fc4b2);
$parcel$export(module.exports, "expand", () => $0475c6ffc1ba526d$export$9f77e0932fb78f72);
$parcel$export(module.exports, "extension", () => $0475c6ffc1ba526d$export$1b45514b112dd749);
$parcel$export(module.exports, "extensionFrameStage0", () => $0475c6ffc1ba526d$export$b555be60c7703afb);
$parcel$export(module.exports, "hardBreak", () => $0475c6ffc1ba526d$export$371da9dd35aba193);
$parcel$export(module.exports, "heading", () => $0475c6ffc1ba526d$export$46e4a324ac90507f);
$parcel$export(module.exports, "image", () => $0475c6ffc1ba526d$export$5c452ff88e35e47d);
$parcel$export(module.exports, "inlineCard", () => $0475c6ffc1ba526d$export$cbf8224b64e0d942);
$parcel$export(module.exports, "inlineExtensionWithMarks", () => $0475c6ffc1ba526d$export$b3b1e36c2105006d);
$parcel$export(module.exports, "layoutColumn", () => $0475c6ffc1ba526d$export$ab76e7c03cd6f650);
$parcel$export(module.exports, "layoutSection", () => $0475c6ffc1ba526d$export$b3b6a70a7fa4a5be);
$parcel$export(module.exports, "layoutSectionFull", () => $0475c6ffc1ba526d$export$cdae19acb0a520fd);
$parcel$export(module.exports, "layoutSectionWithSingleColumnStage0", () => $0475c6ffc1ba526d$export$206007566ca0aca5);
$parcel$export(module.exports, "listItem", () => $0475c6ffc1ba526d$export$76c7e83ecc9cdf05);
$parcel$export(module.exports, "listItemWithNestedDecisionStage0", () => $0475c6ffc1ba526d$export$df876f0305235056);
$parcel$export(module.exports, "media", () => $0475c6ffc1ba526d$export$987d49ffe1b0900f);
$parcel$export(module.exports, "mediaGroup", () => $0475c6ffc1ba526d$export$2855e964765eac9);
$parcel$export(module.exports, "mediaInline", () => $0475c6ffc1ba526d$export$38bab695e3f720f1);
$parcel$export(module.exports, "mediaSingle", () => $0475c6ffc1ba526d$export$969fe3781ca15058);
$parcel$export(module.exports, "mediaSingleCaption", () => $0475c6ffc1ba526d$export$8d067f22dc2d1254);
$parcel$export(module.exports, "mediaSingleFull", () => $0475c6ffc1ba526d$export$7e767666f2ce108a);
$parcel$export(module.exports, "mediaSingleWidthType", () => $0475c6ffc1ba526d$export$4bd9a38995f6bf50);
$parcel$export(module.exports, "mention", () => $0475c6ffc1ba526d$export$db83999c14438df4);
$parcel$export(module.exports, "multiBodiedExtensionStage0", () => $0475c6ffc1ba526d$export$750e45819f66d9d0);
$parcel$export(module.exports, "nestedExpand", () => $0475c6ffc1ba526d$export$63cadbf5f4296627);
$parcel$export(module.exports, "orderedList", () => $0475c6ffc1ba526d$export$a5dc81035676e7a);
$parcel$export(module.exports, "panel", () => $0475c6ffc1ba526d$export$21f42ab9b6679f44);
$parcel$export(module.exports, "paragraph", () => $0475c6ffc1ba526d$export$9c206ddddb32a9b);
$parcel$export(module.exports, "placeholder", () => $0475c6ffc1ba526d$export$c7187bbd1a7a9244);
$parcel$export(module.exports, "rule", () => $0475c6ffc1ba526d$export$fbeb3a3956e8a3c7);
$parcel$export(module.exports, "status", () => $0475c6ffc1ba526d$export$471f7ae5c4103ae1);
$parcel$export(module.exports, "table", () => $0475c6ffc1ba526d$export$9852986a3ec5f6a0);
$parcel$export(module.exports, "tableWithNestedTable", () => $0475c6ffc1ba526d$export$ce086a560a1d05f5);
$parcel$export(module.exports, "tableCell", () => $0475c6ffc1ba526d$export$e1e720e5f4603e6a);
$parcel$export(module.exports, "tableCellWithNestedTable", () => $0475c6ffc1ba526d$export$abf39ca178940ff3);
$parcel$export(module.exports, "tableHeader", () => $0475c6ffc1ba526d$export$48884d2a5190dc73);
$parcel$export(module.exports, "tableHeaderWithNestedTable", () => $0475c6ffc1ba526d$export$2a5a518232fa1a97);
$parcel$export(module.exports, "tableRow", () => $0475c6ffc1ba526d$export$ce666bf02318c957);
$parcel$export(module.exports, "tableRowWithNestedTable", () => $0475c6ffc1ba526d$export$7d657479499397);
$parcel$export(module.exports, "taskItem", () => $0475c6ffc1ba526d$export$6d8b0ef52e2e6390);
$parcel$export(module.exports, "taskList", () => $0475c6ffc1ba526d$export$375b6afcc5f4d291);
$parcel$export(module.exports, "text", () => $0475c6ffc1ba526d$export$6f093cfa640b7166);
$parcel$export(module.exports, "unsupportedBlock", () => $0475c6ffc1ba526d$export$44b79b0979d0f0f7);
$parcel$export(module.exports, "unsupportedInline", () => $0475c6ffc1ba526d$export$310ebe0d80122e9b);
/**
 * This file was automatically generated by @atlaskit/adf-schema-generator
 * DO NOT MODIFY IT BY HAND. Instead, modify the source files in "packages/adf-schema/src/next-schema" ,
 * and run "yarn workspace @atlaskit/adf-schema build:schema:all" to regenerate this file.
 */ 
var $1zhCF = parcelRequire("1zhCF");
const $0475c6ffc1ba526d$export$c4c2f833baaebdb8 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        url: {
            default: null
        },
        datasource: {
            default: null
        },
        width: {
            default: null
        },
        layout: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
const $0475c6ffc1ba526d$export$67dc04e652a298ca = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(paragraph | orderedList | bulletList | unsupportedBlock | codeBlock | mediaSingle | mediaGroup | extension)+',
    marks: 'unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    group: 'block',
    selectable: true,
    defining: true
});
const $0475c6ffc1ba526d$export$199922e5af8e9a6 = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(paragraph | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    selectable: true,
    defining: true
});
const $0475c6ffc1ba526d$export$27903d543b563e39 = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock)+',
    marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true,
    isolating: true
});
const $0475c6ffc1ba526d$export$e7320d153c538837 = (0, $1zhCF.createPMNodeSpecFactory)({
    marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true,
    isolating: true
});
const $0475c6ffc1ba526d$export$a140c94e5ea26bee = (0, $1zhCF.createPMNodeSpecFactory)({
    content: 'listItem+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    selectable: false
});
const $0475c6ffc1ba526d$export$8e3c2dfdc4f0453d = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(hardBreak | mention | emoji | date | placeholder | inlineCard | status | text | unsupportedInline)*',
    marks: '_',
    selectable: false,
    isolating: true
});
const $0475c6ffc1ba526d$export$7bb0d5c671655cc4 = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(text | unsupportedInline)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        language: {
            default: null
        },
        uniqueId: {
            default: null
        }
    },
    code: true,
    defining: true
});
const $0475c6ffc1ba526d$export$e4f1c66d84049f8b = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(text | unsupportedInline)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        language: {
            default: null
        },
        uniqueId: {
            default: null
        }
    },
    code: true,
    defining: true
});
const $0475c6ffc1ba526d$export$daf889beb5092f95 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    atom: true,
    attrs: {
        issueKey: {
            default: ''
        },
        macroId: {
            default: null
        },
        schemaVersion: {
            default: null
        },
        server: {
            default: null
        },
        serverId: {
            default: null
        }
    }
});
const $0475c6ffc1ba526d$export$e6e4878f43c27cab = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        cxhtml: {
            default: null
        }
    }
});
const $0475c6ffc1ba526d$export$3e6d667072febc87 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    atom: true,
    attrs: {
        cxhtml: {
            default: null
        }
    }
});
const $0475c6ffc1ba526d$export$324d90190a8b822a = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        timestamp: {
            default: ''
        }
    },
    selectable: true
});
const $0475c6ffc1ba526d$export$47988d68fe575725 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        timestamp: {
            default: ''
        }
    },
    selectable: true
});
const $0475c6ffc1ba526d$export$6959e16eeff859b4 = (0, $1zhCF.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: '_',
    attrs: {
        localId: {
            default: ''
        },
        state: {
            default: 'DECIDED'
        }
    },
    defining: true
});
const $0475c6ffc1ba526d$export$62d45a65fb43d95e = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(decisionItem | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: ''
        }
    },
    selectable: false,
    defining: true
});
const $0475c6ffc1ba526d$export$2a111da947c407d2 = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(block | codeBlock | layoutSection | blockRootOnly | expand)+',
    marks: 'unsupportedMark unsupportedNodeAttribute alignment indentation dataConsumer fragment breakout'
});
const $0475c6ffc1ba526d$export$be4283d9a1cb1ff6 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        url: {
            default: ''
        },
        layout: {
            default: 'center'
        },
        width: {
            default: 100
        },
        originalHeight: {
            default: null
        },
        originalWidth: {
            default: null
        }
    },
    selectable: true
});
const $0475c6ffc1ba526d$export$a19185d1233fc4b2 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        shortName: {
            default: ''
        },
        id: {
            default: ''
        },
        text: {
            default: ''
        }
    },
    selectable: true
});
const $0475c6ffc1ba526d$export$f5574b5d45fc2112 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        shortName: {
            default: ''
        },
        id: {
            default: ''
        },
        text: {
            default: ''
        }
    },
    selectable: true
});
const $0475c6ffc1ba526d$export$9f77e0932fb78f72 = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock | nestedExpand)+',
    marks: 'unsupportedMark unsupportedNodeAttribute fragment dataConsumer',
    group: 'block',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        }
    },
    selectable: true,
    isolating: true
});
const $0475c6ffc1ba526d$export$7e3788972005cc72 = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock | nestedExpand)+',
    marks: 'unsupportedMark unsupportedNodeAttribute fragment dataConsumer',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        }
    },
    selectable: true,
    isolating: true
});
const $0475c6ffc1ba526d$export$1b45514b112dd749 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $0475c6ffc1ba526d$export$a8baf338431a691 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $0475c6ffc1ba526d$export$b555be60c7703afb = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | extension | bodiedExtension | unsupportedBlock | blockCard | embedCard)+',
    marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    attrs: {},
    selectable: false,
    definingAsContext: false,
    definingForContent: true,
    isolating: true
});
const $0475c6ffc1ba526d$export$371da9dd35aba193 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: '\n'
        }
    },
    selectable: false,
    linebreakReplacement: true
});
const $0475c6ffc1ba526d$export$46e4a324ac90507f = (0, $1zhCF.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: 'link em strong strike subsup underline textColor annotation backgroundColor typeAheadQuery confluenceInlineComment unsupportedNodeAttribute unsupportedMark code dataConsumer fragment border',
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $0475c6ffc1ba526d$export$1b0c1557b234fa00 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $0475c6ffc1ba526d$export$85461f751c457cc2 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $0475c6ffc1ba526d$export$2b380a0f7e250af1 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $0475c6ffc1ba526d$export$5c452ff88e35e47d = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        src: {
            default: ''
        },
        alt: {
            default: ''
        },
        title: {
            default: null
        }
    },
    draggable: true
});
const $0475c6ffc1ba526d$export$cbf8224b64e0d942 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        url: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
const $0475c6ffc1ba526d$export$2f4e72b9459914ad = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        url: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
const $0475c6ffc1ba526d$export$16b353b2649bd8d9 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $0475c6ffc1ba526d$export$b3b1e36c2105006d = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $0475c6ffc1ba526d$export$ab76e7c03cd6f650 = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(block | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute alignment indentation dataConsumer fragment',
    attrs: {
        width: {
            default: undefined
        }
    },
    selectable: false,
    isolating: true
});
const $0475c6ffc1ba526d$export$b3b6a70a7fa4a5be = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){1,3} unsupportedBlock*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    isolating: true
});
const $0475c6ffc1ba526d$export$cdae19acb0a520fd = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){2,3}',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    isolating: true
});
const $0475c6ffc1ba526d$export$206007566ca0aca5 = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){1,5} unsupportedBlock*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        columnRuleStyle: {
            default: null
        }
    },
    isolating: true
});
const $0475c6ffc1ba526d$export$76c7e83ecc9cdf05 = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(paragraph | mediaSingle | codeBlock | unsupportedBlock | extension) (paragraph | bulletList | orderedList | taskList | mediaSingle | codeBlock | unsupportedBlock | extension)*',
    marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    selectable: false,
    defining: true
});
const $0475c6ffc1ba526d$export$df876f0305235056 = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(paragraph | mediaSingle | codeBlock | unsupportedBlock | decisionList | extension) (paragraph | bulletList | orderedList | taskList | mediaSingle | codeBlock | unsupportedBlock | decisionList | extension)*',
    marks: 'unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    selectable: false,
    defining: true
});
const $0475c6ffc1ba526d$export$987d49ffe1b0900f = (0, $1zhCF.createPMNodeSpecFactory)({
    attrs: {
        type: {
            default: 'file'
        },
        id: {
            default: ''
        },
        alt: {
            default: ''
        },
        collection: {
            default: ''
        },
        height: {
            default: null
        },
        occurrenceKey: {
            default: null
        },
        width: {
            default: null
        },
        __contextId: {
            default: null
        },
        __displayType: {
            default: null
        },
        __external: {
            default: false
        },
        __fileMimeType: {
            default: null
        },
        __fileName: {
            default: null
        },
        __fileSize: {
            default: null
        },
        __mediaTraceId: {
            default: null
        },
        url: {
            default: null
        }
    },
    selectable: true
});
const $0475c6ffc1ba526d$export$2855e964765eac9 = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(media | unsupportedBlock)+',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {},
    selectable: false
});
const $0475c6ffc1ba526d$export$38bab695e3f720f1 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        type: {
            default: 'file'
        },
        url: {
            default: null
        },
        id: {
            default: ''
        },
        alt: {
            default: ''
        },
        collection: {
            default: ''
        },
        occurrenceKey: {
            default: null
        },
        width: {
            default: null
        },
        height: {
            default: null
        },
        __fileName: {
            default: null
        },
        __fileSize: {
            default: null
        },
        __fileMimeType: {
            default: null
        },
        __displayType: {
            default: null
        },
        __contextId: {
            default: null
        },
        __mediaTraceId: {
            default: null
        },
        __external: {
            default: false
        }
    },
    selectable: true
});
const $0475c6ffc1ba526d$export$969fe3781ca15058 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        layout: {
            default: 'center'
        },
        width: {
            default: null
        }
    },
    selectable: true,
    content: 'media|unsupportedBlock+|media unsupportedBlock+',
    marks: 'annotation border link unsupportedMark unsupportedNodeAttribute'
});
const $0475c6ffc1ba526d$export$8d067f22dc2d1254 = (0, $1zhCF.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media (caption|unsupportedBlock) unsupportedBlock*',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: false,
    attrs: {
        layout: {
            default: 'center'
        },
        width: {
            default: null
        }
    },
    selectable: true
});
const $0475c6ffc1ba526d$export$7e767666f2ce108a = (0, $1zhCF.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media (caption|unsupportedBlock) unsupportedBlock*',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: false,
    attrs: {
        width: {
            default: null
        },
        layout: {
            default: 'center'
        },
        widthType: {
            default: null
        }
    },
    selectable: true
});
const $0475c6ffc1ba526d$export$4bd9a38995f6bf50 = (0, $1zhCF.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media unsupportedBlock+',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: true,
    attrs: {
        width: {
            default: null
        },
        layout: {
            default: 'center'
        },
        widthType: {
            default: null
        }
    },
    selectable: true
});
const $0475c6ffc1ba526d$export$db83999c14438df4 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        id: {
            default: ''
        },
        localId: {
            default: null
        },
        text: {
            default: ''
        },
        accessLevel: {
            default: ''
        },
        userType: {
            default: null
        }
    },
    selectable: true
});
const $0475c6ffc1ba526d$export$46f790bd65f760d0 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        id: {
            default: ''
        },
        localId: {
            default: null
        },
        text: {
            default: ''
        },
        accessLevel: {
            default: ''
        },
        userType: {
            default: null
        }
    },
    selectable: true
});
const $0475c6ffc1ba526d$export$750e45819f66d9d0 = (0, $1zhCF.createPMNodeSpecFactory)({
    content: 'extensionFrame+',
    marks: 'unsupportedNodeAttribute unsupportedMark',
    group: 'blockRootOnly',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    definingAsContext: true
});
const $0475c6ffc1ba526d$export$63cadbf5f4296627 = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(paragraph | heading | mediaSingle | mediaGroup | codeBlock | bulletList | orderedList | taskList | decisionList | rule | panel | blockquote | unsupportedBlock | extension)+',
    marks: 'unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        }
    },
    selectable: true,
    isolating: true
});
const $0475c6ffc1ba526d$export$f03786aa6312d1e4 = (0, $1zhCF.createPMNodeSpecFactory)({
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        }
    },
    selectable: true,
    isolating: true
});
const $0475c6ffc1ba526d$export$a5dc81035676e7a = (0, $1zhCF.createPMNodeSpecFactory)({
    content: 'listItem+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        order: {
            default: 1
        }
    },
    selectable: false
});
const $0475c6ffc1ba526d$export$21f42ab9b6679f44 = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(paragraph | heading | bulletList | orderedList | blockCard | mediaGroup | mediaSingle | codeBlock | taskList | rule | decisionList | unsupportedBlock | extension)+',
    marks: 'unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    group: 'block',
    attrs: {
        panelType: {
            default: 'info'
        },
        panelIcon: {
            default: null
        },
        panelIconId: {
            default: null
        },
        panelIconText: {
            default: null
        },
        panelColor: {
            default: null
        }
    },
    selectable: true
});
const $0475c6ffc1ba526d$export$9c206ddddb32a9b = (0, $1zhCF.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: 'link em strong strike subsup underline textColor annotation backgroundColor typeAheadQuery confluenceInlineComment unsupportedNodeAttribute unsupportedMark code dataConsumer fragment border',
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $0475c6ffc1ba526d$export$4f98472e6dc14293 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $0475c6ffc1ba526d$export$ea332b61641b0588 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $0475c6ffc1ba526d$export$a1f41dc4901771f8 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $0475c6ffc1ba526d$export$c7187bbd1a7a9244 = (0, $1zhCF.createPMNodeSpecFactory)({
    marks: '',
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        }
    },
    selectable: false
});
const $0475c6ffc1ba526d$export$fbeb3a3956e8a3c7 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'block'
});
const $0475c6ffc1ba526d$export$471f7ae5c4103ae1 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        },
        color: {
            default: ''
        },
        localId: {
            default: ''
        },
        style: {
            default: ''
        }
    },
    selectable: true
});
const $0475c6ffc1ba526d$export$b6ce52be8d7a261 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        },
        color: {
            default: ''
        },
        localId: {
            default: ''
        },
        style: {
            default: ''
        }
    },
    selectable: true
});
const $0475c6ffc1ba526d$export$9852986a3ec5f6a0 = (0, $1zhCF.createPMNodeSpecFactory)({
    content: 'tableRow+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        displayMode: {
            default: null
        },
        isNumberColumnEnabled: {
            default: false
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: ''
        },
        width: {
            default: null
        },
        __autoSize: {
            default: false
        }
    },
    selectable: true,
    isolating: true,
    tableRole: 'table'
});
const $0475c6ffc1ba526d$export$ce086a560a1d05f5 = (0, $1zhCF.createPMNodeSpecFactory)({
    content: 'tableRow+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        displayMode: {
            default: null
        },
        isNumberColumnEnabled: {
            default: false
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: ''
        },
        width: {
            default: null
        },
        __autoSize: {
            default: false
        }
    },
    selectable: true,
    isolating: true,
    tableRole: 'table'
});
const $0475c6ffc1ba526d$export$e1e720e5f4603e6a = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | unsupportedBlock)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'cell'
});
const $0475c6ffc1ba526d$export$abf39ca178940ff3 = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | unsupportedBlock | table)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'cell'
});
const $0475c6ffc1ba526d$export$48884d2a5190dc73 = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'header_cell'
});
const $0475c6ffc1ba526d$export$2a5a518232fa1a97 = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | table)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'header_cell'
});
const $0475c6ffc1ba526d$export$ce666bf02318c957 = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(tableCell | tableHeader)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    selectable: false,
    tableRole: 'row'
});
const $0475c6ffc1ba526d$export$7d657479499397 = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(tableCell | tableHeader)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    selectable: false,
    tableRole: 'row'
});
const $0475c6ffc1ba526d$export$6d8b0ef52e2e6390 = (0, $1zhCF.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: '_',
    attrs: {
        localId: {
            default: ''
        },
        state: {
            default: 'TODO'
        }
    },
    selectable: false,
    defining: true
});
const $0475c6ffc1ba526d$export$375b6afcc5f4d291 = (0, $1zhCF.createPMNodeSpecFactory)({
    content: '(taskItem | unsupportedBlock)+ (taskItem | taskList | unsupportedBlock)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: ''
        }
    },
    selectable: false,
    defining: true
});
const $0475c6ffc1ba526d$export$6f093cfa640b7166 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'inline'
});
const $0475c6ffc1ba526d$export$5ea06bc686c59dc2 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'inline'
});
const $0475c6ffc1ba526d$export$93256a4c17b33a82 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'inline'
});
const $0475c6ffc1ba526d$export$a12828d0f14a2762 = (0, $1zhCF.createPMNodeSpecFactory)({});
const $0475c6ffc1ba526d$export$44b79b0979d0f0f7 = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        originalValue: {
            default: {}
        }
    },
    selectable: true
});
const $0475c6ffc1ba526d$export$310ebe0d80122e9b = (0, $1zhCF.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        originalValue: {
            default: {}
        }
    },
    selectable: true
});

});
parcelRegister("1zhCF", function(module, exports) {

$parcel$export(module.exports, "createPMNodeSpecFactory", () => $1246bacc7b1ceffa$export$bf0a80f00e2b8ff6);
$parcel$export(module.exports, "createPMMarkSpecFactory", () => $1246bacc7b1ceffa$export$cf5823ed4e9f4c6f);
/**
 * Factory method to attach custom parseDOM and/or toDOM for nodeSpec
 *
 * @example
 * createPMNodeSpecFactory<SomeNode>(node)({parseDOM: {}, toDOM: (node) => {} });
 *
 * @param nodeSpec - NodeSpec without toDom and parseDom
 * @returns A function for a node which allows the consumer to define toDom and parseDom
 */ const $1246bacc7b1ceffa$export$bf0a80f00e2b8ff6 = (nodeSpec)=>({ parseDOM: parseDOM, toDOM: toDOM, toDebugString: toDebugString })=>{
        return {
            ...nodeSpec,
            ...parseDOM && {
                parseDOM: parseDOM
            },
            ...toDOM && {
                toDOM: toDOM
            },
            ...toDebugString && {
                toDebugString: toDebugString
            }
        };
    };
const $1246bacc7b1ceffa$export$cf5823ed4e9f4c6f = (markSpec)=>({ parseDOM: parseDOM, toDOM: toDOM, toDebugString: toDebugString })=>{
        return {
            ...markSpec,
            ...parseDOM && {
                parseDOM: parseDOM
            },
            ...toDOM && {
                toDOM: toDOM
            },
            ...toDebugString && {
                toDebugString: toDebugString
            }
        };
    };

});



parcelRegister("6C9Qx", function(module, exports) {

$parcel$export(module.exports, "extensionFrame", () => $4d0dedfce6d8a509$export$4fdcae991fd743e7);
$parcel$export(module.exports, "multiBodiedExtension", () => $4d0dedfce6d8a509$export$c3c04d555a8b9013);

var $fPSlo = parcelRequire("fPSlo");

var $nJVLW = parcelRequire("nJVLW");
const $4d0dedfce6d8a509$export$4fdcae991fd743e7 = (0, $nJVLW.extensionFrameStage0)({
    parseDOM: [
        {
            context: 'extensionFrame//',
            tag: 'div[data-extension-frame]',
            skip: true
        },
        {
            tag: 'div[data-extension-frame]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-extension-frame': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $4d0dedfce6d8a509$export$c3c04d555a8b9013 = (0, $nJVLW.multiBodiedExtensionStage0)({
    parseDOM: [
        {
            context: 'multiBodiedExtension//',
            tag: '[data-node-type="multi-bodied-extension"]',
            skip: true
        },
        {
            tag: '[data-node-type="multi-bodied-extension"]',
            getAttrs: (domNode)=>(0, $fPSlo.getExtensionAttrs)(domNode)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'multi-bodied-extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});
parcelRegister("fPSlo", function(module, exports) {

$parcel$export(module.exports, "getExtensionAttrs", () => $b875c609076dd72b$export$1765e2758fc47004);
const $b875c609076dd72b$export$d5f21755dc782a4a = (name)=>{
    return !!name && [
        'default',
        'wide',
        'full-width'
    ].includes(name);
};
const $b875c609076dd72b$export$1765e2758fc47004 = (dom, isInline = false)=>{
    const extensionType = dom.getAttribute('data-extension-type');
    const extensionKey = dom.getAttribute('data-extension-key');
    if (!extensionType || !extensionKey) return false;
    const attrs = {
        extensionType: extensionType,
        extensionKey: extensionKey,
        text: dom.getAttribute('data-text') || undefined,
        parameters: JSON.parse(dom.getAttribute('data-parameters') || '{}'),
        localId: dom.getAttribute('data-local-id') || undefined
    };
    if (!isInline) {
        const rawLayout = dom.getAttribute('data-layout');
        attrs.layout = $b875c609076dd72b$export$d5f21755dc782a4a(rawLayout) ? rawLayout : 'default';
    }
    return attrs;
};

});


parcelRegister("jSvxD", function(module, exports) {

$parcel$export(module.exports, "layoutSection", () => $e78b86f811605f22$export$b3b6a70a7fa4a5be);
$parcel$export(module.exports, "layoutSectionWithSingleColumn", () => $e78b86f811605f22$export$4f9d8f623ff17117);

var $nJVLW = parcelRequire("nJVLW");
const $e78b86f811605f22$export$b3b6a70a7fa4a5be = (0, $nJVLW.layoutSection)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-layout-section': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $e78b86f811605f22$export$cdae19acb0a520fd = (0, $nJVLW.layoutSectionFull)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-layout-section': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $e78b86f811605f22$export$4f9d8f623ff17117 = (0, $nJVLW.layoutSectionWithSingleColumnStage0)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]',
            getAttrs: (dom)=>{
                const columnRuleStyle = dom.getAttribute('data-column-rule-style');
                return columnRuleStyle ? {
                    columnRuleStyle: columnRuleStyle
                } : {};
            }
        }
    ],
    toDOM (node) {
        const { columnRuleStyle: columnRuleStyle } = node.attrs;
        const attrs = {
            'data-layout-section': 'true',
            'data-column-rule-style': columnRuleStyle || undefined
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("gkLMH", function(module, exports) {

$parcel$export(module.exports, "listItem", () => $be43949bca9723a7$export$76c7e83ecc9cdf05);
$parcel$export(module.exports, "listItemWithDecisionStage0", () => $be43949bca9723a7$export$b2cd54d5ce935ddb);

var $nJVLW = parcelRequire("nJVLW");
const $be43949bca9723a7$export$76c7e83ecc9cdf05 = (0, $nJVLW.listItem)({
    parseDOM: [
        {
            tag: 'li'
        }
    ],
    toDOM () {
        return [
            'li',
            0
        ];
    }
});
const $be43949bca9723a7$export$b2cd54d5ce935ddb = (0, $nJVLW.listItemWithNestedDecisionStage0)({
    parseDOM: [
        {
            tag: 'li'
        }
    ],
    toDOM () {
        return [
            'li',
            0
        ];
    }
});

});

parcelRegister("e6HpD", function(module, exports) {

$parcel$export(module.exports, "tablePrefixSelector", () => $a4534d0d8902e0f9$export$9cfceb893b24742a);
$parcel$export(module.exports, "tableCellSelector", () => $a4534d0d8902e0f9$export$69cb4c3f80383763);
$parcel$export(module.exports, "tableHeaderSelector", () => $a4534d0d8902e0f9$export$7b07d37d879c957f);
$parcel$export(module.exports, "tableCellContentWrapperSelector", () => $a4534d0d8902e0f9$export$8dd42a84cd52da07);
$parcel$export(module.exports, "tableCellContentDomSelector", () => $a4534d0d8902e0f9$export$5e26a5c19f0865d8);
$parcel$export(module.exports, "getCellAttrs", () => $a4534d0d8902e0f9$export$43977bde391e007);
$parcel$export(module.exports, "getCellDomAttrs", () => $a4534d0d8902e0f9$export$363c8dda799bfe9c);
$parcel$export(module.exports, "tableBackgroundColorNames", () => $a4534d0d8902e0f9$export$8cc2833b5b349a1e);
$parcel$export(module.exports, "tableBackgroundColorPalette", () => $a4534d0d8902e0f9$export$219b7f492ad209f8);
$parcel$export(module.exports, "tableBackgroundBorderColor", () => $a4534d0d8902e0f9$export$95e9c925fbf01d1c);
$parcel$export(module.exports, "table", () => $a4534d0d8902e0f9$export$9852986a3ec5f6a0);
$parcel$export(module.exports, "tableWithCustomWidth", () => $a4534d0d8902e0f9$export$90e634fbace1f0c4);
$parcel$export(module.exports, "tableStage0", () => $a4534d0d8902e0f9$export$3862de5c8c9098cf);
$parcel$export(module.exports, "tableToJSON", () => $a4534d0d8902e0f9$export$1f92a2f429e06fa8);
$parcel$export(module.exports, "tableRow", () => $a4534d0d8902e0f9$export$ce666bf02318c957);
$parcel$export(module.exports, "tableCell", () => $a4534d0d8902e0f9$export$e1e720e5f4603e6a);
$parcel$export(module.exports, "toJSONTableCell", () => $a4534d0d8902e0f9$export$2ac34c099660f1a8);
$parcel$export(module.exports, "tableHeader", () => $a4534d0d8902e0f9$export$48884d2a5190dc73);
$parcel$export(module.exports, "toJSONTableHeader", () => $a4534d0d8902e0f9$export$2af48797a1010bb1);
$parcel$export(module.exports, "tableWithNestedTable", () => $a4534d0d8902e0f9$export$ce086a560a1d05f5);
$parcel$export(module.exports, "tableRowWithNestedTable", () => $a4534d0d8902e0f9$export$7d657479499397);
$parcel$export(module.exports, "tableCellWithNestedTable", () => $a4534d0d8902e0f9$export$abf39ca178940ff3);
$parcel$export(module.exports, "tableHeaderWithNestedTable", () => $a4534d0d8902e0f9$export$2a5a518232fa1a97);

var $dyyJM = parcelRequire("dyyJM");

var $51dYk = parcelRequire("51dYk");

var $2OrIX = parcelRequire("2OrIX");

var $4PpDP = parcelRequire("4PpDP");

var $nJVLW = parcelRequire("nJVLW");
const $a4534d0d8902e0f9$export$9cfceb893b24742a = 'pm-table';
const $a4534d0d8902e0f9$export$69cb4c3f80383763 = `${$a4534d0d8902e0f9$export$9cfceb893b24742a}-cell-content-wrap`;
const $a4534d0d8902e0f9$export$7b07d37d879c957f = `${$a4534d0d8902e0f9$export$9cfceb893b24742a}-header-content-wrap`;
const $a4534d0d8902e0f9$export$8dd42a84cd52da07 = `${$a4534d0d8902e0f9$export$9cfceb893b24742a}-cell-nodeview-wrapper`;
const $a4534d0d8902e0f9$export$5e26a5c19f0865d8 = `${$a4534d0d8902e0f9$export$9cfceb893b24742a}-cell-nodeview-content-dom`;
const $a4534d0d8902e0f9$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND = (0, $51dYk.N20).toLocaleLowerCase();
const $a4534d0d8902e0f9$export$43977bde391e007 = (dom, defaultValues = {})=>{
    const widthAttr = dom.getAttribute('data-colwidth');
    const width = widthAttr && /^\d+(,\d+)*$/.test(widthAttr) ? widthAttr.split(',').map((str)=>Number(str)) : null;
    const colspan = Number(dom.getAttribute('colspan') || 1);
    let { backgroundColor: backgroundColor } = dom.style;
    /**
   * We have pivoted to store background color information in
   *  data-cell-background.
   * We will have original hex code (which we map to DST token)
   *  stored in data-cell-background, use that.
   * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
   */ const dataCellBackground = dom.getAttribute('data-cell-background');
    const dataCellBackgroundHexCode = dataCellBackground && (0, $51dYk.isHex)(dataCellBackground) ? dataCellBackground : undefined;
    // ignore setting background attr if ds neutral token is detected
    if (backgroundColor.includes('--ds-background-neutral')) backgroundColor = '';
    else if (backgroundColor && (0, $51dYk.isRgb)(backgroundColor)) {
        const result = (0, $51dYk.rgbToHex)(backgroundColor);
        if (result !== null) backgroundColor = result;
    }
    const backgroundHexCode = dataCellBackgroundHexCode || (backgroundColor && backgroundColor !== defaultValues['background'] ? backgroundColor : null);
    return {
        colspan: colspan,
        rowspan: Number(dom.getAttribute('rowspan') || 1),
        colwidth: width && width.length === colspan ? width : null,
        background: backgroundHexCode
    };
};
// these are for test only
let $a4534d0d8902e0f9$var$testGlobalTheme;
const $a4534d0d8902e0f9$export$fd7e0dd2b74807f7 = (theme)=>{
    $a4534d0d8902e0f9$var$testGlobalTheme = theme;
};
// This is a minimal duplication of the method from @atlaskit/tokens
// to minimise the number of dependencies required as these changes are expected
// to be patched onto CR8.
const $a4534d0d8902e0f9$var$getGlobalTheme = ()=>{
    // This should only be hit during tests.
    //
    // At time of writing Jest mocks are not working in this repository.
    if ($a4534d0d8902e0f9$var$testGlobalTheme) return {
        colorMode: $a4534d0d8902e0f9$var$testGlobalTheme
    };
    const element = document.documentElement;
    const colorMode = element.getAttribute('data-color-mode') || '';
    return {
        colorMode: colorMode
    };
};
const $a4534d0d8902e0f9$var$cssVariablePattern = /^var\(--.*\)$/;
const $a4534d0d8902e0f9$export$363c8dda799bfe9c = (node)=>{
    const attrs = {};
    const nodeType = node.type.name;
    if (node.attrs.colspan !== 1) attrs.colspan = node.attrs.colspan;
    if (node.attrs.rowspan !== 1) attrs.rowspan = node.attrs.rowspan;
    if (node.attrs.colwidth) attrs['data-colwidth'] = node.attrs.colwidth.join(',');
    if (node.attrs.background) {
        const { background: background } = node.attrs;
        // to ensure that we don't overwrite product's style:
        // - it clears background color for <th> if its set to gray
        // - it clears background color for <td> if its set to white
        // - it clears background color for <th> if ds neutral token is detected
        const ignored = nodeType === 'tableHeader' && background === $a4534d0d8902e0f9$export$8cc2833b5b349a1e.get('light gray') || nodeType === 'tableCell' && background === $a4534d0d8902e0f9$export$8cc2833b5b349a1e.get('white') || nodeType === 'tableHeader' && background.includes('--ds-background-neutral');
        if (ignored) attrs.style = '';
        else {
            const color = (0, $51dYk.isRgb)(background) && (0, $51dYk.rgbToHex)(background) ? (0, $51dYk.rgbToHex)(background) : background;
            /**
       * The Editor supports users pasting content from external sources with custom table cell backgrounds and having those
       * backgrounds persisted.
       *
       * This feature predates the introduction of dark mode.
       *
       * Without the inversion logic below, tokenised content (ie. text), can be hard to read when the user loads the page in dark mode.
       *
       * This introduces inversion of the presentation of the custom background color when the user is in dark mode.
       *
       * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
       * how we detect table cell background colors copied from external editor sources. Where we load the background color from a
       * seperate attribute (data-cell-background), instead of the inline style.
       *
       * See the following document for more details on this behaviour
       * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2892247168/Unsupported+custom+table+cell+background+colors+in+dark+theme+Editor+Job+Story
       */ const tokenColor = (0, $dyyJM.hexToEditorBackgroundPaletteRawValue)(color);
            if (tokenColor) attrs.style = `background-color: ${tokenColor};`;
            else if (/**
       * There was previously a bug in dark mode where we would attempt to invert
       * a design token in `getDarkModeLCHColor` causing issues.
       * If it's a design token we should return it as is.
       */ $a4534d0d8902e0f9$var$cssVariablePattern.test(color)) attrs.style = `background-color: ${color};`;
            else // if we have a custom color, we need to check if we are in dark mode
            if ($a4534d0d8902e0f9$var$getGlobalTheme().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
            attrs.style = `background-color: ${(0, $4PpDP.getDarkModeLCHColor)(color)};`;
            else // if we are in light mode, we can just set the color
            attrs.style = `background-color: ${background};`;
            /**
       * Storing hex code in data-cell-background because
       *  we want to have DST token (css variable) or
       *  DST token value (value (hex code) of css variable) in
       *  inline style to correct render table cell background
       *  based on selected theme.
       * Currently we rely on background color hex code stored in
       *  inline style.
       * Because of that when we copy and paste table, we end up
       *  having DST token or DST token value in ADF instead of
       *  original hex code which we map to DST token.
       * So, introducing data-cell-background.
       * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
       */ if (color) attrs['data-cell-background'] = color;
            attrs.colorname = $a4534d0d8902e0f9$export$219b7f492ad209f8.get(color);
        }
    }
    if (nodeType === 'tableHeader') attrs.class = $a4534d0d8902e0f9$export$7b07d37d879c957f;
    else attrs.class = $a4534d0d8902e0f9$export$69cb4c3f80383763;
    return attrs;
};
const $a4534d0d8902e0f9$export$219b7f492ad209f8 = new Map();
const $a4534d0d8902e0f9$export$95e9c925fbf01d1c = (0, $51dYk.hexToRgba)((0, $51dYk.N800), 0.12) || (0, $51dYk.N0);
const $a4534d0d8902e0f9$export$8cc2833b5b349a1e = new Map();
[
    [
        (0, $51dYk.N0),
        'White'
    ],
    [
        (0, $51dYk.B50),
        'Light blue'
    ],
    [
        (0, $51dYk.T50),
        'Light teal'
    ],
    [
        (0, $51dYk.G50),
        'Light green'
    ],
    [
        (0, $51dYk.Y50),
        'Light yellow'
    ],
    [
        (0, $51dYk.R50),
        'Light red'
    ],
    [
        (0, $51dYk.P50),
        'Light purple'
    ],
    [
        (0, $51dYk.N20),
        'Light gray'
    ],
    [
        (0, $51dYk.B75),
        'Blue'
    ],
    [
        (0, $51dYk.T75),
        'Teal'
    ],
    [
        (0, $51dYk.G75),
        'Green'
    ],
    [
        (0, $51dYk.Y75),
        'Yellow'
    ],
    [
        (0, $51dYk.R75),
        'Red'
    ],
    [
        (0, $51dYk.P75),
        'Purple'
    ],
    [
        (0, $51dYk.N60),
        'Gray'
    ],
    [
        (0, $51dYk.B100),
        'Dark blue'
    ],
    [
        (0, $51dYk.T100),
        'Dark teal'
    ],
    [
        (0, $51dYk.G200),
        'Dark green'
    ],
    [
        (0, $51dYk.Y200),
        'Dark yellow'
    ],
    [
        (0, $51dYk.R100),
        'Dark red'
    ],
    [
        (0, $51dYk.P100),
        'Dark purple'
    ]
].forEach(([colorValue, colorName])=>{
    $a4534d0d8902e0f9$export$219b7f492ad209f8.set(colorValue.toLowerCase(), colorName);
    $a4534d0d8902e0f9$export$8cc2833b5b349a1e.set(colorName.toLowerCase(), colorValue.toLowerCase());
});
/**
 * @name table_node
 */ /**
 * @name table_row_node
 */ /**
 * @name table_cell_content
 * @minItems 1
 * @allowUnsupportedBlock true
 */ /**
 * @name table_cell_node
 */ /**
 * @name table_header_node
 */ // table nodes with nested tables support
const $a4534d0d8902e0f9$var$tableNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'table',
            getAttrs: (node)=>{
                var _dom$parentElement;
                const dom = node;
                const breakoutWrapper = (_dom$parentElement = dom.parentElement) === null || _dom$parentElement === void 0 ? void 0 : _dom$parentElement.parentElement;
                return {
                    isNumberColumnEnabled: dom.getAttribute('data-number-column') === 'true',
                    layout: // copying from editor
                    dom.getAttribute('data-layout') || (breakoutWrapper === null || breakoutWrapper === void 0 ? void 0 : breakoutWrapper.getAttribute('data-layout')) || 'default',
                    __autoSize: dom.getAttribute('data-autosize') === 'true',
                    localId: dom.getAttribute('data-table-local-id') || (0, $2OrIX.uuid).generate(),
                    width: Number(dom.getAttribute('data-table-width')) || null,
                    displayMode: dom.getAttribute('data-table-display-mode') || null
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-number-column': node.attrs.isNumberColumnEnabled,
            'data-layout': node.attrs.layout,
            'data-autosize': node.attrs.__autoSize,
            'data-table-local-id': node.attrs.localId,
            'data-table-width': node.attrs.width,
            'data-table-display-mode': node.attrs.displayMode
        };
        return [
            'table',
            attrs,
            [
                'tbody',
                0
            ]
        ];
    }
};
// TODO: Fix any, potential issue. ED-5048
const $a4534d0d8902e0f9$var$createTableSpec = ()=>(0, $nJVLW.table)($a4534d0d8902e0f9$var$tableNodeSpecOptions);
const $a4534d0d8902e0f9$export$9852986a3ec5f6a0 = $a4534d0d8902e0f9$var$createTableSpec();
const $a4534d0d8902e0f9$export$90e634fbace1f0c4 = $a4534d0d8902e0f9$var$createTableSpec();
const $a4534d0d8902e0f9$export$3862de5c8c9098cf = $a4534d0d8902e0f9$var$createTableSpec();
const $a4534d0d8902e0f9$var$shouldIncludeAttribute = (key, value)=>!key.startsWith('__') && (key !== 'localId' || !!value);
const $a4534d0d8902e0f9$export$1f92a2f429e06fa8 = (node)=>({
        attrs: Object.keys(node.attrs).filter((key)=>$a4534d0d8902e0f9$var$shouldIncludeAttribute(key, node.attrs[key])).reduce((obj, key)=>{
            return {
                ...obj,
                [key]: node.attrs[key]
            };
        }, {})
    });
const $a4534d0d8902e0f9$var$tableRowNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'tr'
        }
    ],
    toDOM () {
        return [
            'tr',
            0
        ];
    }
};
const $a4534d0d8902e0f9$export$ce666bf02318c957 = (0, $nJVLW.tableRow)($a4534d0d8902e0f9$var$tableRowNodeSpecOptions);
const $a4534d0d8902e0f9$var$cellAttrs = {
    colspan: {
        default: 1
    },
    rowspan: {
        default: 1
    },
    colwidth: {
        default: null
    },
    background: {
        default: null
    }
};
const $a4534d0d8902e0f9$var$tableCellNodeSpecOptions = {
    parseDOM: [
        // Ignore number cell copied from renderer
        {
            tag: '.ak-renderer-table-number-column',
            ignore: true
        },
        {
            tag: 'td',
            getAttrs: (dom)=>$a4534d0d8902e0f9$export$43977bde391e007(dom)
        }
    ],
    toDOM: (node)=>[
            'td',
            $a4534d0d8902e0f9$export$363c8dda799bfe9c(node),
            0
        ]
};
const $a4534d0d8902e0f9$export$e1e720e5f4603e6a = (0, $nJVLW.tableCell)($a4534d0d8902e0f9$var$tableCellNodeSpecOptions);
const $a4534d0d8902e0f9$export$2ac34c099660f1a8 = (node)=>({
        attrs: Object.keys(node.attrs).reduce((obj, key)=>{
            if ($a4534d0d8902e0f9$var$cellAttrs[key].default !== node.attrs[key]) obj[key] = node.attrs[key];
            return obj;
        }, {})
    });
const $a4534d0d8902e0f9$var$tableHeaderNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'th',
            getAttrs: (dom)=>$a4534d0d8902e0f9$export$43977bde391e007(dom, {
                    background: $a4534d0d8902e0f9$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND
                })
        }
    ],
    toDOM: (node)=>[
            'th',
            $a4534d0d8902e0f9$export$363c8dda799bfe9c(node),
            0
        ]
};
const $a4534d0d8902e0f9$export$48884d2a5190dc73 = (0, $nJVLW.tableHeader)($a4534d0d8902e0f9$var$tableHeaderNodeSpecOptions);
const $a4534d0d8902e0f9$export$2af48797a1010bb1 = $a4534d0d8902e0f9$export$2ac34c099660f1a8;
const $a4534d0d8902e0f9$export$ce086a560a1d05f5 = (0, $nJVLW.tableWithNestedTable)($a4534d0d8902e0f9$var$tableNodeSpecOptions);
const $a4534d0d8902e0f9$export$7d657479499397 = (0, $nJVLW.tableRowWithNestedTable)($a4534d0d8902e0f9$var$tableRowNodeSpecOptions);
const $a4534d0d8902e0f9$export$abf39ca178940ff3 = (0, $nJVLW.tableCellWithNestedTable)($a4534d0d8902e0f9$var$tableCellNodeSpecOptions);
const $a4534d0d8902e0f9$export$2a5a518232fa1a97 = (0, $nJVLW.tableHeaderWithNestedTable)($a4534d0d8902e0f9$var$tableHeaderNodeSpecOptions);

});
parcelRegister("dyyJM", function(module, exports) {

$parcel$export(module.exports, "hexToEditorBorderPaletteColor", () => $028c05c3f3022d58$export$bad3c41dd33cb4bc);
$parcel$export(module.exports, "hexToEditorTextPaletteColor", () => $028c05c3f3022d58$export$9c2f408d391feb93);
$parcel$export(module.exports, "hexToEditorTextBackgroundPaletteColor", () => $028c05c3f3022d58$export$8b58ff1b36bb75e0);
$parcel$export(module.exports, "hexToEditorBackgroundPaletteRawValue", () => $028c05c3f3022d58$export$a270511a0e7fd61a);

var $59rsN = parcelRequire("59rsN");
function $028c05c3f3022d58$export$bad3c41dd33cb4bc(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    return hexColor ? $028c05c3f3022d58$export$aa000893c5e2b9c2[hexColor.toUpperCase()] : undefined;
}
const $028c05c3f3022d58$export$aa000893c5e2b9c2 = {
    /** gray - subtle */ '#091E4224': 'var(--ds-border, #091E4224)',
    /** gray */ '#758195': 'var(--ds-border-bold, #758195)',
    /** gray - bold */ '#172B4D': 'var(--ds-text, #172B4D)'
};
function $028c05c3f3022d58$export$9c2f408d391feb93(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    return hexColor ? $028c05c3f3022d58$export$57fa5089caad992[hexColor.toUpperCase()] : undefined;
}
const $028c05c3f3022d58$export$57fa5089caad992 = {
    /** blue - light */ '#B3D4FF': 'var(--ds-background-accent-blue-subtler, #B3D4FF)',
    /** blue - medium */ '#4C9AFF': 'var(--ds-icon-accent-blue, #4C9AFF)',
    /** blue - strong */ '#0747A6': 'var(--ds-text-accent-blue, #0747A6)',
    /** teal - light */ '#B3F5FF': 'var(--ds-background-accent-teal-subtler, #B3F5FF)',
    /** teal - medium */ '#00B8D9': 'var(--ds-icon-accent-teal, #00B8D9)',
    /** teal - strong */ '#008DA6': 'var(--ds-text-accent-teal, #008DA6)',
    /** green - light */ '#ABF5D1': 'var(--ds-background-accent-green-subtler, #ABF5D1)',
    /** green - medium */ '#36B37E': 'var(--ds-icon-accent-green, #36B37E)',
    /** green - strong */ '#006644': 'var(--ds-text-accent-green, #006644)',
    /** yellowOrange - light */ '#FFF0B3': 'var(--ds-background-accent-yellow-subtler, #FFF0B3)',
    /** yellowOrange - medium */ '#FFC400': 'var(--ds-background-accent-orange-subtle, #FFC400)',
    /** yellowOrange - strong */ '#FF991F': 'var(--ds-icon-accent-orange, #FF991F)',
    /** red - light */ '#FFBDAD': 'var(--ds-background-accent-red-subtler, #FFBDAD)',
    /** red - medium */ '#FF5630': 'var(--ds-icon-accent-red, #FF5630)',
    /** red - strong */ '#BF2600': 'var(--ds-text-accent-red, #BF2600)',
    /** purple - light */ '#EAE6FF': 'var(--ds-background-accent-purple-subtler, #EAE6FF)',
    /** purple - medium */ '#6554C0': 'var(--ds-icon-accent-purple, #6554C0)',
    /** purple - strong */ '#403294': 'var(--ds-text-accent-purple, #403294)',
    /** whiteGray - light */ '#FFFFFF': 'var(--ds-text-inverse, #FFFFFF)',
    /** whiteGray - medium */ '#97A0AF': 'var(--ds-icon-accent-gray, #97A0AF)',
    /** whiteGray - strong */ '#172B4D': 'var(--ds-text, #172B4D)'
};
function $028c05c3f3022d58$export$8b58ff1b36bb75e0(hexColor) {
    if ((0, $59rsN.default).getExperimentValue('platform_editor_add_orange_highlight_color', 'cohort', 'control') !== 'test') $028c05c3f3022d58$export$12a518ff137dd389['#FEDEC8'] = 'var(--ds-background-accent-yellow-subtler, #F8E6A0)';
    // Ts ignore was used to allow use of conditional return type
    // (preferring better type on consumption over safety in implementation)
    return hexColor ? $028c05c3f3022d58$export$12a518ff137dd389[hexColor.toUpperCase()] : undefined;
}
const $028c05c3f3022d58$export$12a518ff137dd389 = {
    /** Gray - light */ '#DCDFE4': 'var(--ds-background-accent-gray-subtler, #DCDFE4)',
    /** Teal - light */ '#C6EDFB': 'var(--ds-background-accent-teal-subtler, #C6EDFB)',
    /** Lime - light */ '#D3F1A7': 'var(--ds-background-accent-lime-subtler, #D3F1A7)',
    /** Yellow - light */ '#F8E6A0': 'var(--ds-background-accent-yellow-subtler, #F8E6A0)',
    /** Orange - light */ '#FEDEC8': 'var(--ds-background-accent-orange-subtler, #FEDEC8)',
    /** Magenta - light */ '#FDD0EC': 'var(--ds-background-accent-magenta-subtler, #FDD0EC)',
    /** Purple - light */ '#DFD8FD': 'var(--ds-background-accent-purple-subtler, #DFD8FD)'
};
function $028c05c3f3022d58$export$a270511a0e7fd61a(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    const tokenData = hexColor ? $028c05c3f3022d58$export$2462741d70e6a62f[hexColor.toUpperCase()] : undefined;
    return tokenData ? tokenData.getValue(hexColor) : undefined;
}
const $028c05c3f3022d58$export$2462741d70e6a62f = {
    /** blue - light */ '#DEEBFF': {
        getValue: ()=>'#DEEBFF',
        token: 'var(--ds-background-accent-blue-subtlest, #DEEBFF)'
    },
    /** blue - medium */ '#B3D4FF': {
        getValue: ()=>'#B3D4FF',
        token: 'var(--ds-background-accent-blue-subtler, #B3D4FF)'
    },
    /** blue - strong */ '#4C9AFF': {
        getValue: ()=>'#4C9AFF',
        token: 'var(--ds-background-accent-blue-subtle, #4C9AFF)'
    },
    /** teal - light */ '#E6FCFF': {
        getValue: ()=>'#E6FCFF',
        token: 'var(--ds-background-accent-teal-subtlest, #E6FCFF)'
    },
    /** teal - medium */ '#B3F5FF': {
        getValue: ()=>'#B3F5FF',
        token: 'var(--ds-background-accent-teal-subtler, #B3F5FF)'
    },
    /** teal - strong */ '#79E2F2': {
        getValue: ()=>'#79E2F2',
        token: 'var(--ds-background-accent-teal-subtle, #79E2F2)'
    },
    /** green - light */ '#E3FCEF': {
        getValue: ()=>'#E3FCEF',
        token: 'var(--ds-background-accent-green-subtlest, #E3FCEF)'
    },
    /** green - medium */ '#ABF5D1': {
        getValue: ()=>'#ABF5D1',
        token: 'var(--ds-background-accent-green-subtler, #ABF5D1)'
    },
    /** green - strong */ '#57D9A3': {
        getValue: ()=>'#57D9A3',
        token: 'var(--ds-background-accent-green-subtle, #57D9A3)'
    },
    /** yellowOrange - light */ '#FFFAE6': {
        getValue: ()=>'#FFFAE6',
        token: 'var(--ds-background-accent-yellow-subtlest, #FFFAE6)'
    },
    /** yellowOrange - medium */ '#FFF0B3': {
        getValue: ()=>'#FFF0B3',
        token: 'var(--ds-background-accent-yellow-subtler, #FFF0B3)'
    },
    /** yellowOrange - strong */ '#FFC400': {
        getValue: ()=>'#FFC400',
        token: 'var(--ds-background-accent-orange-subtle, #FFC400)'
    },
    /** red - light */ '#FFEBE6': {
        getValue: ()=>'#FFEBE6',
        token: 'var(--ds-background-accent-red-subtlest, #FFEBE6)'
    },
    /** red - medium */ '#FFBDAD': {
        getValue: ()=>'#FFBDAD',
        token: 'var(--ds-background-accent-red-subtler, #FFBDAD)'
    },
    /** red - strong */ '#FF8F73': {
        getValue: ()=>'#FF8F73',
        token: 'var(--ds-background-accent-red-subtle, #FF8F73)'
    },
    /** purple - light */ '#EAE6FF': {
        getValue: ()=>'#EAE6FF',
        token: 'var(--ds-background-accent-purple-subtlest, #EAE6FF)'
    },
    /** purple - medium */ '#C0B6F2': {
        getValue: ()=>'#C0B6F2',
        token: 'var(--ds-background-accent-purple-subtler, #C0B6F2)'
    },
    /** purple - strong */ '#998DD9': {
        getValue: ()=>'#998DD9',
        token: 'var(--ds-background-accent-purple-subtle, #998DD9)'
    },
    /** whiteGray - light */ '#FFFFFF': {
        getValue: ()=>'#FFFFFF',
        token: 'var(--ds-surface, #FFFFFF)'
    },
    /** whiteGray - medium */ '#F4F5F7': {
        getValue: ()=>'#F4F5F7',
        token: 'var(--ds-background-accent-gray-subtlest, #F4F5F7)'
    },
    /** whiteGray - strong */ '#B3BAC5': {
        getValue: ()=>'#B3BAC5',
        token: 'var(--ds-background-accent-gray-subtle, #B3BAC5)'
    }
};

});

parcelRegister("51dYk", function(module, exports) {

$parcel$export(module.exports, "R50", () => $3a77e248cfc93706$export$4b84fd0e2c617bd);
$parcel$export(module.exports, "R75", () => $3a77e248cfc93706$export$b34b069eff244586);
$parcel$export(module.exports, "R100", () => $3a77e248cfc93706$export$be802dd0d8b57f35);
$parcel$export(module.exports, "R300", () => $3a77e248cfc93706$export$4a7404f376229999);
$parcel$export(module.exports, "R500", () => $3a77e248cfc93706$export$2837b5a1a71d5c02);
$parcel$export(module.exports, "Y50", () => $3a77e248cfc93706$export$8d9596b529bbb9cf);
$parcel$export(module.exports, "Y75", () => $3a77e248cfc93706$export$41060a744ab0b7ae);
$parcel$export(module.exports, "Y200", () => $3a77e248cfc93706$export$5aae31392d72caaa);
$parcel$export(module.exports, "Yellow200", () => $3a77e248cfc93706$export$fc857b6f8771648a);
$parcel$export(module.exports, "Y400", () => $3a77e248cfc93706$export$59619663aa6500fb);
$parcel$export(module.exports, "G50", () => $3a77e248cfc93706$export$8a6341c32b6a3ee6);
$parcel$export(module.exports, "G75", () => $3a77e248cfc93706$export$69a3bf21b9686c2b);
$parcel$export(module.exports, "G200", () => $3a77e248cfc93706$export$747d86715d4175de);
$parcel$export(module.exports, "G300", () => $3a77e248cfc93706$export$940e1f69e873f202);
$parcel$export(module.exports, "G500", () => $3a77e248cfc93706$export$6fa04827ac68a4fb);
$parcel$export(module.exports, "B50", () => $3a77e248cfc93706$export$226de0355ed012f8);
$parcel$export(module.exports, "B75", () => $3a77e248cfc93706$export$8c13c2ee36917869);
$parcel$export(module.exports, "B100", () => $3a77e248cfc93706$export$ecfc1dff386a3e7a);
$parcel$export(module.exports, "B400", () => $3a77e248cfc93706$export$b3de0ae08da2ce64);
$parcel$export(module.exports, "B500", () => $3a77e248cfc93706$export$a6ee3d71bc067634);
$parcel$export(module.exports, "L200", () => $3a77e248cfc93706$export$f72948ef771f6f15);
$parcel$export(module.exports, "N0", () => $3a77e248cfc93706$export$29a4f05edc054374);
$parcel$export(module.exports, "N20", () => $3a77e248cfc93706$export$9fdfb749e33cdf97);
$parcel$export(module.exports, "N30", () => $3a77e248cfc93706$export$3e51e8f1440314ba);
$parcel$export(module.exports, "N40", () => $3a77e248cfc93706$export$1ce2d1575d444ceb);
$parcel$export(module.exports, "N50", () => $3a77e248cfc93706$export$8754fc7e6d8b3000);
$parcel$export(module.exports, "N60", () => $3a77e248cfc93706$export$c2e91cbeada39b8b);
$parcel$export(module.exports, "N80", () => $3a77e248cfc93706$export$eaa8c8a70ac22806);
$parcel$export(module.exports, "N200", () => $3a77e248cfc93706$export$f563ee71e9ee74cd);
$parcel$export(module.exports, "N300", () => $3a77e248cfc93706$export$e2ef2124cf4024b1);
$parcel$export(module.exports, "Neutral300", () => $3a77e248cfc93706$export$1ae1cebe22dcedb4);
$parcel$export(module.exports, "N300A", () => $3a77e248cfc93706$export$13609db0e6812ab8);
$parcel$export(module.exports, "N500", () => $3a77e248cfc93706$export$c39c0fe0f26207ae);
$parcel$export(module.exports, "N600", () => $3a77e248cfc93706$export$7090862dc3038a9f);
$parcel$export(module.exports, "N800", () => $3a77e248cfc93706$export$7d61b15e0da132af);
$parcel$export(module.exports, "N1000", () => $3a77e248cfc93706$export$f78789c8b01753cd);
$parcel$export(module.exports, "M200", () => $3a77e248cfc93706$export$a19f0c33186f7767);
$parcel$export(module.exports, "O200", () => $3a77e248cfc93706$export$51716a84e62e022c);
$parcel$export(module.exports, "P50", () => $3a77e248cfc93706$export$363e4475840015bb);
$parcel$export(module.exports, "P75", () => $3a77e248cfc93706$export$4b0a4417ed59760f);
$parcel$export(module.exports, "P100", () => $3a77e248cfc93706$export$6011520a64d9a187);
$parcel$export(module.exports, "P200", () => $3a77e248cfc93706$export$a7175d4e9206bc80);
$parcel$export(module.exports, "P300", () => $3a77e248cfc93706$export$b48405b95304b5a1);
$parcel$export(module.exports, "P500", () => $3a77e248cfc93706$export$147899de772240ec);
$parcel$export(module.exports, "T50", () => $3a77e248cfc93706$export$2cf711fe14c66f06);
$parcel$export(module.exports, "T75", () => $3a77e248cfc93706$export$7a8f4d33f6f9772c);
$parcel$export(module.exports, "T100", () => $3a77e248cfc93706$export$776c9c497ef08533);
$parcel$export(module.exports, "T200", () => $3a77e248cfc93706$export$69cb3ca10c1e330e);
$parcel$export(module.exports, "T300", () => $3a77e248cfc93706$export$9dc1ef0f3f48059b);
$parcel$export(module.exports, "T500", () => $3a77e248cfc93706$export$6036577f95c3877e);
$parcel$export(module.exports, "normalizeHexColor", () => $3a77e248cfc93706$export$b61655071712e690);
$parcel$export(module.exports, "isHex", () => $3a77e248cfc93706$export$8a9b6341a7c96bc);
$parcel$export(module.exports, "isRgb", () => $3a77e248cfc93706$export$e698776ec826343);
$parcel$export(module.exports, "rgbToHex", () => $3a77e248cfc93706$export$34d09c4a771c46ef);
$parcel$export(module.exports, "hexToRgb", () => $3a77e248cfc93706$export$5a544e13ad4e1fa5);
$parcel$export(module.exports, "hexToRgba", () => $3a77e248cfc93706$export$9665a07d9187b414);

var $k9rAg = parcelRequire("k9rAg");
const $3a77e248cfc93706$export$4b84fd0e2c617bd = '#FFEBE6';
const $3a77e248cfc93706$export$b34b069eff244586 = '#FFBDAD';
const $3a77e248cfc93706$export$be802dd0d8b57f35 = '#FF8F73';
const $3a77e248cfc93706$export$4a7404f376229999 = '#FF5630';
const $3a77e248cfc93706$export$2010d0fb4295b346 = '#DE350B';
const $3a77e248cfc93706$export$2837b5a1a71d5c02 = '#BF2600';
const $3a77e248cfc93706$export$8d9596b529bbb9cf = '#FFFAE6';
const $3a77e248cfc93706$export$41060a744ab0b7ae = '#FFF0B3';
const $3a77e248cfc93706$export$5aae31392d72caaa = '#FFC400';
const $3a77e248cfc93706$export$fc857b6f8771648a = '#F8E6A0';
const $3a77e248cfc93706$export$59619663aa6500fb = '#FF991F';
const $3a77e248cfc93706$export$874739ea9e379ab6 = '#FF8B00';
const $3a77e248cfc93706$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $3a77e248cfc93706$export$69a3bf21b9686c2b = '#ABF5D1';
const $3a77e248cfc93706$export$747d86715d4175de = '#57D9A3';
const $3a77e248cfc93706$export$940e1f69e873f202 = '#36B37E';
const $3a77e248cfc93706$export$a49394138f7b8e85 = '#00875A';
const $3a77e248cfc93706$export$6fa04827ac68a4fb = '#006644';
const $3a77e248cfc93706$export$226de0355ed012f8 = '#DEEBFF';
const $3a77e248cfc93706$export$8c13c2ee36917869 = '#B3D4FF';
const $3a77e248cfc93706$export$ecfc1dff386a3e7a = '#4C9AFF';
const $3a77e248cfc93706$export$b3de0ae08da2ce64 = '#0052CC';
const $3a77e248cfc93706$export$a6ee3d71bc067634 = '#0747A6';
const $3a77e248cfc93706$export$f72948ef771f6f15 = '#D3F1A7';
const $3a77e248cfc93706$export$29a4f05edc054374 = '#FFFFFF';
const $3a77e248cfc93706$export$9fdfb749e33cdf97 = '#F4F5F7';
const $3a77e248cfc93706$export$3e51e8f1440314ba = '#EBECF0';
const $3a77e248cfc93706$export$1ce2d1575d444ceb = '#DFE1E6';
const $3a77e248cfc93706$export$8754fc7e6d8b3000 = '#C1C7D0';
const $3a77e248cfc93706$export$c2e91cbeada39b8b = '#B3BAC5';
const $3a77e248cfc93706$export$eaa8c8a70ac22806 = '#97A0AF';
const $3a77e248cfc93706$export$7c87d337fb91a97d = '#8993A4';
const $3a77e248cfc93706$export$f563ee71e9ee74cd = '#6B778C';
const $3a77e248cfc93706$export$e2ef2124cf4024b1 = '#5E6C84';
const $3a77e248cfc93706$export$1ae1cebe22dcedb4 = '#DCDFE4';
const $3a77e248cfc93706$export$13609db0e6812ab8 = '#091E4224';
const $3a77e248cfc93706$export$c39c0fe0f26207ae = '#42526E';
const $3a77e248cfc93706$export$7090862dc3038a9f = '#758195';
const $3a77e248cfc93706$export$7d61b15e0da132af = '#172B4D';
const $3a77e248cfc93706$export$f78789c8b01753cd = '#172B4D';
const $3a77e248cfc93706$export$a19f0c33186f7767 = '#FDD0EC';
const $3a77e248cfc93706$export$51716a84e62e022c = '#FEDEC8';
const $3a77e248cfc93706$export$363e4475840015bb = '#EAE6FF';
const $3a77e248cfc93706$export$4b0a4417ed59760f = '#C0B6F2';
const $3a77e248cfc93706$export$6011520a64d9a187 = '#998DD9';
const $3a77e248cfc93706$export$a7175d4e9206bc80 = '#DFD8FD';
const $3a77e248cfc93706$export$b48405b95304b5a1 = '#6554C0';
const $3a77e248cfc93706$export$c71e4279dd54a18d = '#5243AA';
const $3a77e248cfc93706$export$147899de772240ec = '#403294';
const $3a77e248cfc93706$export$2cf711fe14c66f06 = '#E6FCFF';
const $3a77e248cfc93706$export$7a8f4d33f6f9772c = '#B3F5FF';
const $3a77e248cfc93706$export$776c9c497ef08533 = '#79E2F2';
const $3a77e248cfc93706$export$69cb3ca10c1e330e = '#C6EDFB';
const $3a77e248cfc93706$export$9dc1ef0f3f48059b = '#00B8D9';
const $3a77e248cfc93706$export$6036577f95c3877e = '#008DA6';
function $3a77e248cfc93706$export$b61655071712e690(color, defaultColor) {
    if (!color) return null;
    // Normalize to hex
    color = color.trim().toLowerCase();
    if ($3a77e248cfc93706$export$8a9b6341a7c96bc(color)) // Normalize 3-hex to 6-hex colours
    {
        if (color.length === 4) color = color.split('').map((c)=>c === '#' ? '#' : `${c}${c}`).join('');
    } else if ($3a77e248cfc93706$export$e698776ec826343(color)) return $3a77e248cfc93706$export$34d09c4a771c46ef(color);
    else {
        // http://dev.w3.org/csswg/css-color/#named-colors
        if (color === 'default') return null;
        else if ($k9rAg.default && $k9rAg.default[color]) color = $k9rAg.default[color];
        else if ($k9rAg && $k9rAg[color]) color = $k9rAg[color];
        else return null;
    }
    if (color === defaultColor) return null;
    return color;
}
function $3a77e248cfc93706$export$5a544e13ad4e1fa5(color) {
    if (!$3a77e248cfc93706$export$8a9b6341a7c96bc(color)) return null;
    let colorBits = color.substring(1).split('');
    if (colorBits.length === 3) colorBits = [
        colorBits[0],
        colorBits[0],
        colorBits[1],
        colorBits[1],
        colorBits[2],
        colorBits[2]
    ];
    const rgb = Number(`0x${colorBits.join('')}`);
    // eslint-disable-next-line no-bitwise
    return `rgb(${rgb >> 16 & 255},${rgb >> 8 & 255},${rgb & 255})`;
}
function $3a77e248cfc93706$export$9665a07d9187b414(rawColor, alpha) {
    const color = $3a77e248cfc93706$export$b61655071712e690(rawColor);
    if (!color) return null;
    const hex2rgb = (color)=>color.match(/[a-z0-9]{2}/gi).map((hex)=>parseInt(hex, 16));
    return `rgba(${hex2rgb(color).concat(alpha).join(',')})`;
}
function $3a77e248cfc93706$export$34d09c4a771c46ef(value) {
    const matches = value.match(/(0?\.?\d{1,3})%?\b/g);
    if (matches && matches.length >= 3) {
        const [red, green, blue] = matches.map(Number);
        return '#' + (blue | green << 8 | red << 16 | 16777216).toString(16).slice(1) // eslint-disable-line no-bitwise
        ;
    }
    return null;
}
function $3a77e248cfc93706$export$e698776ec826343(color) {
    return /rgba?\(/.test(color);
}
function $3a77e248cfc93706$export$8a9b6341a7c96bc(color) {
    return /^#([A-Fa-f0-9]{3}){1,2}$/.test(color);
}

});
parcelRegister("k9rAg", function(module, exports) {
module.exports = JSON.parse("{\"aliceblue\":\"#f0f8ff\",\"antiquewhite\":\"#faebd7\",\"aqua\":\"#00ffff\",\"aquamarine\":\"#7fffd4\",\"azure\":\"#f0ffff\",\"beige\":\"#f5f5dc\",\"bisque\":\"#ffe4c4\",\"black\":\"#000000\",\"blanchedalmond\":\"#ffebcd\",\"blue\":\"#0000ff\",\"blueviolet\":\"#8a2be2\",\"brown\":\"#a52a2a\",\"burlywood\":\"#deb887\",\"cadetblue\":\"#5f9ea0\",\"chartreuse\":\"#7fff00\",\"chocolate\":\"#d2691e\",\"coral\":\"#ff7f50\",\"cornflowerblue\":\"#6495ed\",\"cornsilk\":\"#fff8dc\",\"crimson\":\"#dc143c\",\"cyan\":\"#00ffff\",\"darkblue\":\"#00008b\",\"darkcyan\":\"#008b8b\",\"darkgoldenrod\":\"#b8860b\",\"darkgray\":\"#a9a9a9\",\"darkgreen\":\"#006400\",\"darkgrey\":\"#a9a9a9\",\"darkkhaki\":\"#bdb76b\",\"darkmagenta\":\"#8b008b\",\"darkolivegreen\":\"#556b2f\",\"darkorange\":\"#ff8c00\",\"darkorchid\":\"#9932cc\",\"darkred\":\"#8b0000\",\"darksalmon\":\"#e9967a\",\"darkseagreen\":\"#8fbc8f\",\"darkslateblue\":\"#483d8b\",\"darkslategray\":\"#2f4f4f\",\"darkslategrey\":\"#2f4f4f\",\"darkturquoise\":\"#00ced1\",\"darkviolet\":\"#9400d3\",\"deeppink\":\"#ff1493\",\"deepskyblue\":\"#00bfff\",\"dimgray\":\"#696969\",\"dimgrey\":\"#696969\",\"dodgerblue\":\"#1e90ff\",\"firebrick\":\"#b22222\",\"floralwhite\":\"#fffaf0\",\"forestgreen\":\"#228b22\",\"fuchsia\":\"#ff00ff\",\"gainsboro\":\"#dcdcdc\",\"ghostwhite\":\"#f8f8ff\",\"gold\":\"#ffd700\",\"goldenrod\":\"#daa520\",\"gray\":\"#808080\",\"green\":\"#008000\",\"greenyellow\":\"#adff2f\",\"grey\":\"#808080\",\"honeydew\":\"#f0fff0\",\"hotpink\":\"#ff69b4\",\"indianred\":\"#cd5c5c\",\"indigo\":\"#4b0082\",\"ivory\":\"#fffff0\",\"khaki\":\"#f0e68c\",\"lavender\":\"#e6e6fa\",\"lavenderblush\":\"#fff0f5\",\"lawngreen\":\"#7cfc00\",\"lemonchiffon\":\"#fffacd\",\"lightblue\":\"#add8e6\",\"lightcoral\":\"#f08080\",\"lightcyan\":\"#e0ffff\",\"lightgoldenrodyellow\":\"#fafad2\",\"lightgray\":\"#d3d3d3\",\"lightgreen\":\"#90ee90\",\"lightgrey\":\"#d3d3d3\",\"lightpink\":\"#ffb6c1\",\"lightsalmon\":\"#ffa07a\",\"lightseagreen\":\"#20b2aa\",\"lightskyblue\":\"#87cefa\",\"lightslategray\":\"#778899\",\"lightslategrey\":\"#778899\",\"lightsteelblue\":\"#b0c4de\",\"lightyellow\":\"#ffffe0\",\"lime\":\"#00ff00\",\"limegreen\":\"#32cd32\",\"linen\":\"#faf0e6\",\"magenta\":\"#ff00ff\",\"maroon\":\"#800000\",\"mediumaquamarine\":\"#66cdaa\",\"mediumblue\":\"#0000cd\",\"mediumorchid\":\"#ba55d3\",\"mediumpurple\":\"#9370db\",\"mediumseagreen\":\"#3cb371\",\"mediumslateblue\":\"#7b68ee\",\"mediumspringgreen\":\"#00fa9a\",\"mediumturquoise\":\"#48d1cc\",\"mediumvioletred\":\"#c71585\",\"midnightblue\":\"#191970\",\"mintcream\":\"#f5fffa\",\"mistyrose\":\"#ffe4e1\",\"moccasin\":\"#ffe4b5\",\"navajowhite\":\"#ffdead\",\"navy\":\"#000080\",\"oldlace\":\"#fdf5e6\",\"olive\":\"#808000\",\"olivedrab\":\"#6b8e23\",\"orange\":\"#ffa500\",\"orangered\":\"#ff4500\",\"orchid\":\"#da70d6\",\"palegoldenrod\":\"#eee8aa\",\"palegreen\":\"#98fb98\",\"paleturquoise\":\"#afeeee\",\"palevioletred\":\"#db7093\",\"papayawhip\":\"#ffefd5\",\"peachpuff\":\"#ffdab9\",\"peru\":\"#cd853f\",\"pink\":\"#ffc0cb\",\"plum\":\"#dda0dd\",\"powderblue\":\"#b0e0e6\",\"purple\":\"#800080\",\"rebeccapurple\":\"#663399\",\"red\":\"#ff0000\",\"rosybrown\":\"#bc8f8f\",\"royalblue\":\"#4169e1\",\"saddlebrown\":\"#8b4513\",\"salmon\":\"#fa8072\",\"sandybrown\":\"#f4a460\",\"seagreen\":\"#2e8b57\",\"seashell\":\"#fff5ee\",\"sienna\":\"#a0522d\",\"silver\":\"#c0c0c0\",\"skyblue\":\"#87ceeb\",\"slateblue\":\"#6a5acd\",\"slategray\":\"#708090\",\"slategrey\":\"#708090\",\"snow\":\"#fffafa\",\"springgreen\":\"#00ff7f\",\"steelblue\":\"#4682b4\",\"tan\":\"#d2b48c\",\"teal\":\"#008080\",\"thistle\":\"#d8bfd8\",\"tomato\":\"#ff6347\",\"turquoise\":\"#40e0d0\",\"violet\":\"#ee82ee\",\"wheat\":\"#f5deb3\",\"white\":\"#ffffff\",\"whitesmoke\":\"#f5f5f5\",\"yellow\":\"#ffff00\",\"yellowgreen\":\"#9acd32\"}");

});


parcelRegister("2OrIX", function(module, exports) {

$parcel$export(module.exports, "generateUuid", () => $20c5c1b68bce331d$export$1c3aefb711c3a4cc);
$parcel$export(module.exports, "uuid", () => $20c5c1b68bce331d$export$31b40729666a4ae0);
/* eslint-disable no-bitwise */ const $20c5c1b68bce331d$export$1c3aefb711c3a4cc = ()=>'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
        const r = Math.random() * 16 | 0;
        return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
    });
/* eslint-enable no-bitwise */ let $20c5c1b68bce331d$var$staticValue = false;
const $20c5c1b68bce331d$export$31b40729666a4ae0 = {
    setStatic (value) {
        $20c5c1b68bce331d$var$staticValue = value;
    },
    generate () {
        return $20c5c1b68bce331d$var$staticValue || $20c5c1b68bce331d$export$1c3aefb711c3a4cc();
    }
};

});

parcelRegister("4PpDP", function(module, exports) {

$parcel$export(module.exports, "getDarkModeLCHColor", () => $383fd0b1d61f7ae7$export$a5065c3b8aacaf99);
// https://en.wikipedia.org/wiki/HCL_color_space
// https://en.wikipedia.org/wiki/CIE_1931_color_space#CIE_xy_chromaticity_diagram_and_the_CIE_xyY_color_space
// https://en.wikipedia.org/wiki/CIELAB_color_space
const $383fd0b1d61f7ae7$var$clamp = (i, min, max)=>Math.round(Math.min(Math.max(i, min), max));
const $383fd0b1d61f7ae7$var$expandShorthandHex = (input)=>input.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b)=>r + r + g + g + b + b);
const $383fd0b1d61f7ae7$var$rgbFromHex = (input)=>{
    const fullHex = $383fd0b1d61f7ae7$var$expandShorthandHex(input);
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(fullHex);
    return result === null ? null : {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    };
};
const $383fd0b1d61f7ae7$var$rgbToHex = ({ r: r, g: g, b: b })=>{
    const convertComponent = (c)=>{
        const cBase16 = c.toString(16);
        return cBase16.length === 1 ? `0${cBase16}` : cBase16;
    };
    return `#${convertComponent(r)}${convertComponent(g)}${convertComponent(b)}`;
};
const $383fd0b1d61f7ae7$var$rgbToXyz = (rgb)=>{
    const convertRgbComponent = (c)=>c > 0.04045 ? Math.pow((c + 0.055) / 1.055, 2.4) : c / 12.92;
    const convertXyzComponent = (c)=>c > 0.008856452 ? Math.pow(c, 1 / 3) : c / 0.12841855 + 0.137931034;
    const r = convertRgbComponent(rgb.r / 255);
    const g = convertRgbComponent(rgb.g / 255);
    const b = convertRgbComponent(rgb.b / 255);
    return {
        x: convertXyzComponent((0.4124564 * r + 0.3575761 * g + 0.1804375 * b) / 0.95047),
        y: convertXyzComponent(0.2126729 * r + 0.7151522 * g + 0.072175 * b),
        z: convertXyzComponent((0.0193339 * r + 0.119192 * g + 0.9503041 * b) / 1.08883)
    };
};
const $383fd0b1d61f7ae7$var$xyzToLab = ({ x: x, y: y, z: z })=>({
        l: Math.max(116 * y - 16, 0),
        a: 500 * (x - y),
        b: 200 * (y - z)
    });
const $383fd0b1d61f7ae7$var$labToLch = ({ l: l, a: a, b: b })=>{
    let h = (Math.atan2(b, a) * (180 / Math.PI) + 360) % 360;
    const c = Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2));
    if (Math.round(c * 10000) === 0) h = Number.NaN;
    return {
        l: l,
        c: c,
        h: h
    };
};
const $383fd0b1d61f7ae7$var$lchToLab = ({ l: l, c: c, h: h })=>{
    const convertH = Number.isNaN(h) ? 0 : h * (Math.PI / 180);
    return {
        l: l,
        a: Math.cos(convertH) * c,
        b: Math.sin(convertH) * c
    };
};
const $383fd0b1d61f7ae7$var$labToXyz = ({ l: l, a: a, b: b })=>{
    const convertComponent = (c)=>c > 0.206896552 ? Math.pow(c, 3) : 0.12841855 * (c - 0.137931034);
    const y = (l + 16) / 116;
    const x = a / 500 + y;
    const z = y - b / 200;
    return {
        x: convertComponent(x) * 0.95047,
        y: convertComponent(y),
        z: convertComponent(z) * 1.08883
    };
};
const $383fd0b1d61f7ae7$var$xyzToRgb = ({ x: x, y: y, z: z })=>{
    const convertComponent = (c)=>255 * (c <= 0.00304 ? 12.92 * c : 1.055 * Math.pow(c, 1 / 2.4) - 0.055);
    return {
        r: $383fd0b1d61f7ae7$var$clamp(convertComponent(3.2404542 * x - 1.5371385 * y - 0.4985314 * z), 0, 255),
        g: $383fd0b1d61f7ae7$var$clamp(convertComponent(-0.969266 * x + 1.8760108 * y + 0.041556 * z), 0, 255),
        b: $383fd0b1d61f7ae7$var$clamp(convertComponent(0.0556434 * x - 0.2040259 * y + 1.0572252 * z), 0, 255)
    };
};
const $383fd0b1d61f7ae7$var$rgbToLch = (rgb)=>$383fd0b1d61f7ae7$var$labToLch($383fd0b1d61f7ae7$var$xyzToLab($383fd0b1d61f7ae7$var$rgbToXyz(rgb)));
const $383fd0b1d61f7ae7$var$lchToRgb = (lch)=>$383fd0b1d61f7ae7$var$xyzToRgb($383fd0b1d61f7ae7$var$labToXyz($383fd0b1d61f7ae7$var$lchToLab(lch)));
const $383fd0b1d61f7ae7$export$313b8a8fcb34c3b8 = (color, newPercent)=>{
    const rgb = $383fd0b1d61f7ae7$var$rgbFromHex(color);
    if (rgb === null) return color;
    // LCH (rather than HSL) gives the best results here as the L component in LCH is based on human color perception
    const lch = $383fd0b1d61f7ae7$var$rgbToLch(rgb);
    lch.l = $383fd0b1d61f7ae7$var$clamp(newPercent, 0, 100);
    return $383fd0b1d61f7ae7$var$rgbToHex($383fd0b1d61f7ae7$var$lchToRgb(lch));
};
const $383fd0b1d61f7ae7$var$getLightness = (color)=>{
    const rgb = $383fd0b1d61f7ae7$var$rgbFromHex(color);
    if (rgb === null) return 0;
    const lch = $383fd0b1d61f7ae7$var$rgbToLch(rgb);
    return lch.l;
};
const $383fd0b1d61f7ae7$export$a5065c3b8aacaf99 = (currentBackgroundColor)=>{
    const lightness = $383fd0b1d61f7ae7$var$getLightness(currentBackgroundColor);
    const newLightness = Math.abs(100 - lightness);
    return $383fd0b1d61f7ae7$export$313b8a8fcb34c3b8(currentBackgroundColor, newLightness).toUpperCase();
};

});


parcelRegister("g7Jv8", function(module, exports) {

$parcel$export(module.exports, "createSchema", () => $bbd098624269520c$export$5f4ce795563f4211);

var $3xw6l = parcelRequire("3xw6l");


var $mYA6R = parcelRequire("mYA6R");

var $fRfD8 = parcelRequire("fRfD8");
var $jxPcD = parcelRequire("jxPcD");
var $7i9jz = parcelRequire("7i9jz");
var $3Pxk9 = parcelRequire("3Pxk9");
var $7uhRT = parcelRequire("7uhRT");
var $eA6GD = parcelRequire("eA6GD");
var $04SjV = parcelRequire("04SjV");
var $dHJym = parcelRequire("dHJym");
var $eonww = parcelRequire("eonww");
var $6Ymtk = parcelRequire("6Ymtk");
var $7GG3N = parcelRequire("7GG3N");
var $h9kgv = parcelRequire("h9kgv");
var $f4V9T = parcelRequire("f4V9T");
var $YKDO7 = parcelRequire("YKDO7");
var $hI6rl = parcelRequire("hI6rl");
var $abZsg = parcelRequire("abZsg");
var $anaPs = parcelRequire("anaPs");
var $b7o0x = parcelRequire("b7o0x");
var $kdb0W = parcelRequire("kdb0W");
var $3pgGD = parcelRequire("3pgGD");

var $5sqgz = parcelRequire("5sqgz");
var $kuVVV = parcelRequire("kuVVV");
var $7T1su = parcelRequire("7T1su");
var $l2o3P = parcelRequire("l2o3P");
var $02BNy = parcelRequire("02BNy");
var $itOTx = parcelRequire("itOTx");
var $99RFR = parcelRequire("99RFR");
var $4LGm1 = parcelRequire("4LGm1");
var $s7CHM = parcelRequire("s7CHM");
var $eblOZ = parcelRequire("eblOZ");
var $9FkNK = parcelRequire("9FkNK");
var $gjQyF = parcelRequire("gjQyF");
var $YIci7 = parcelRequire("YIci7");
var $foHUC = parcelRequire("foHUC");
var $eSKW9 = parcelRequire("eSKW9");
var $iBSvH = parcelRequire("iBSvH");
var $ePdnq = parcelRequire("ePdnq");
var $6r1B4 = parcelRequire("6r1B4");
var $6C9Qx = parcelRequire("6C9Qx");
var $ewUmv = parcelRequire("ewUmv");
var $8FGKL = parcelRequire("8FGKL");
var $lM0g9 = parcelRequire("lM0g9");
var $3MHOZ = parcelRequire("3MHOZ");
var $5Ufvu = parcelRequire("5Ufvu");
var $gNk91 = parcelRequire("gNk91");
var $jSvxD = parcelRequire("jSvxD");
var $gkLMH = parcelRequire("gkLMH");
var $bTlUc = parcelRequire("bTlUc");
var $goVGV = parcelRequire("goVGV");
var $5RVMs = parcelRequire("5RVMs");
var $8Mfla = parcelRequire("8Mfla");
var $7axvl = parcelRequire("7axvl");
var $6UEeD = parcelRequire("6UEeD");
var $a4ifE = parcelRequire("a4ifE");
var $bK3tx = parcelRequire("bK3tx");
var $hbObi = parcelRequire("hbObi");
var $jC4KP = parcelRequire("jC4KP");
var $c2Gqu = parcelRequire("c2Gqu");
var $e6HpD = parcelRequire("e6HpD");
var $5iuEY = parcelRequire("5iuEY");
var $6Yq90 = parcelRequire("6Yq90");
var $53i5t = parcelRequire("53i5t");
var $bffKB = parcelRequire("bffKB");
var $e1kFZ = parcelRequire("e1kFZ");
var $5blh0 = parcelRequire("5blh0");
function $bbd098624269520c$var$addItems(builtInItems, config, customSpecs = {}) {
    if (!config) return {};
    /**
   * Add built-in Node / Mark specs
   */ const items = builtInItems.reduce((items, { name: name, spec: spec })=>{
        if (config.indexOf(name) !== -1) items[name] = customSpecs[name] || spec;
        return items;
    }, {});
    /**
   * Add Custom Node / Mark specs
   */ return Object.keys(customSpecs).reduce((items, name)=>{
        if (items[name]) return items;
        items[name] = customSpecs[name];
        return items;
    }, items);
}
// We use groups to allow schemas to be constructed in different shapes without changing node/mark
// specs, but this means nodes/marks are defined with groups that might never be used in the schema.
// In this scenario ProseMirror will complain and prevent the schema from being constructed.
//
// To avoid the problem, we include items that serve to "declare" the groups in the schema. This
// approach unfortunately leaves unused items in the schema, but has the benefit of avoiding the
// need to manipulate `exclude` or content expression values for potentially every schema item.
function $bbd098624269520c$var$groupDeclaration(name) {
    return {
        name: `__${name}GroupDeclaration`,
        spec: {
            group: name
        }
    };
}
const $bbd098624269520c$var$markGroupDeclarations = [
    $bbd098624269520c$var$groupDeclaration((0, $212f88bb056bb83b$export$9b982809044276a6)),
    $bbd098624269520c$var$groupDeclaration((0, $212f88bb056bb83b$export$4498a6080fed604c)),
    $bbd098624269520c$var$groupDeclaration((0, $212f88bb056bb83b$export$f8e8a5f34f6ea725)),
    $bbd098624269520c$var$groupDeclaration((0, $212f88bb056bb83b$export$b395009ca7f092c7))
];
const $bbd098624269520c$var$markGroupDeclarationsNames = $bbd098624269520c$var$markGroupDeclarations.map((groupMark)=>groupMark.name);
const $bbd098624269520c$var$nodesInOrder = [
    {
        name: 'doc',
        spec: (0, $gjQyF.doc)
    },
    {
        name: 'paragraph',
        spec: (0, $bK3tx.paragraph)
    },
    {
        name: 'text',
        spec: (0, $53i5t.text)
    },
    {
        name: 'bulletList',
        spec: (0, $7T1su.bulletList)
    },
    {
        name: 'orderedList',
        spec: (0, $a4ifE.orderedListWithOrder)
    },
    {
        name: 'listItem',
        spec: (0, $gkLMH.listItem)
    },
    {
        name: 'heading',
        spec: (0, $8FGKL.heading)
    },
    {
        name: 'blockquote',
        spec: (0, $iBSvH.extendedBlockquote)
    },
    {
        name: 'codeBlock',
        spec: (0, $02BNy.codeBlock)
    },
    {
        name: 'panel',
        spec: (0, $ePdnq.extendedPanel)(true)
    },
    {
        name: 'rule',
        spec: (0, $jC4KP.rule)
    },
    {
        name: 'image',
        spec: (0, $lM0g9.image)
    },
    {
        name: 'mention',
        spec: (0, $7axvl.mention)
    },
    {
        name: 'caption',
        spec: (0, $l2o3P.caption)
    },
    {
        name: 'media',
        spec: (0, $bTlUc.media)
    },
    {
        name: 'mediaGroup',
        spec: (0, $goVGV.mediaGroup)
    },
    {
        name: 'mediaSingle',
        spec: (0, $8Mfla.mediaSingleFull)
    },
    {
        name: 'mediaInline',
        spec: (0, $5RVMs.mediaInline)
    },
    {
        name: 'placeholder',
        spec: (0, $hbObi.placeholder)
    },
    {
        name: 'layoutSection',
        spec: (0, $jSvxD.layoutSection)
    },
    {
        name: 'layoutColumn',
        spec: (0, $gNk91.layoutColumn)
    },
    {
        name: 'hardBreak',
        spec: (0, $ewUmv.hardBreak)
    },
    {
        name: 'emoji',
        spec: (0, $foHUC.emoji)
    },
    {
        name: 'table',
        spec: (0, $e6HpD.table)
    },
    {
        name: 'tableCell',
        spec: (0, $e6HpD.tableCell)
    },
    {
        name: 'tableRow',
        spec: (0, $e6HpD.tableRow)
    },
    {
        name: 'tableHeader',
        spec: (0, $e6HpD.tableHeader)
    },
    {
        name: 'confluenceJiraIssue',
        spec: (0, $itOTx.confluenceJiraIssue)
    },
    {
        name: 'confluenceUnsupportedInline',
        spec: (0, $4LGm1.confluenceUnsupportedInline)
    },
    {
        name: 'confluenceUnsupportedBlock',
        spec: (0, $99RFR.confluenceUnsupportedBlock)
    },
    {
        name: 'decisionList',
        spec: (0, $9FkNK.decisionList)
    },
    {
        name: 'decisionItem',
        spec: (0, $eblOZ.decisionItem)
    },
    {
        name: 'taskList',
        spec: (0, $6Yq90.taskList)
    },
    {
        name: 'taskItem',
        spec: (0, $5iuEY.taskItem)
    },
    {
        name: 'date',
        spec: (0, $s7CHM.date)
    },
    {
        name: 'status',
        spec: (0, $c2Gqu.status)
    },
    {
        name: 'expand',
        spec: (0, $eSKW9.expandWithNestedExpand)
    },
    {
        name: 'nestedExpand',
        spec: (0, $6UEeD.nestedExpand)
    },
    {
        name: 'extension',
        spec: (0, $6r1B4.extension)
    },
    {
        name: 'inlineExtension',
        spec: (0, $5Ufvu.inlineExtension)
    },
    {
        name: 'bodiedExtension',
        spec: (0, $kuVVV.bodiedExtension)
    },
    {
        name: 'multiBodiedExtension',
        spec: (0, $6C9Qx.multiBodiedExtension)
    },
    {
        name: 'extensionFrame',
        spec: (0, $6C9Qx.extensionFrame)
    },
    {
        name: 'inlineCard',
        spec: (0, $3MHOZ.inlineCard)
    },
    {
        name: 'blockCard',
        spec: (0, $5sqgz.blockCard)
    },
    {
        name: 'embedCard',
        spec: (0, $YIci7.embedCard)
    },
    {
        name: 'unknownBlock',
        spec: (0, $bffKB.default)
    },
    {
        name: 'unsupportedBlock',
        spec: (0, $e1kFZ.unsupportedBlock)
    },
    {
        name: 'unsupportedInline',
        spec: (0, $5blh0.unsupportedInline)
    }
];
const $bbd098624269520c$var$marksInOrder = [
    {
        name: 'link',
        spec: (0, $h9kgv.link)
    },
    {
        name: 'em',
        spec: (0, $eonww.em)
    },
    {
        name: 'strong',
        spec: (0, $YKDO7.strong)
    },
    {
        name: 'textColor',
        spec: (0, $abZsg.textColor)
    },
    {
        name: 'backgroundColor',
        spec: (0, $7i9jz.backgroundColor)
    },
    {
        name: 'strike',
        spec: (0, $f4V9T.strike)
    },
    {
        name: 'subsup',
        spec: (0, $hI6rl.subsup)
    },
    {
        name: 'underline',
        spec: (0, $b7o0x.underline)
    },
    {
        name: 'code',
        spec: (0, $eA6GD.code)
    },
    {
        name: 'typeAheadQuery',
        spec: (0, $anaPs.typeAheadQuery)
    },
    {
        name: 'alignment',
        spec: (0, $fRfD8.alignment)
    },
    {
        name: 'annotation',
        spec: (0, $jxPcD.annotation)
    },
    {
        name: 'confluenceInlineComment',
        spec: (0, $04SjV.confluenceInlineComment)
    },
    ...$bbd098624269520c$var$markGroupDeclarations,
    {
        name: 'breakout',
        spec: (0, $7uhRT.breakout)
    },
    {
        name: 'dataConsumer',
        spec: (0, $dHJym.dataConsumer)
    },
    {
        name: 'fragment',
        spec: (0, $6Ymtk.fragment)
    },
    {
        name: 'indentation',
        spec: (0, $7GG3N.indentation)
    },
    {
        name: 'border',
        spec: (0, $3Pxk9.border)
    },
    {
        name: 'unsupportedMark',
        spec: (0, $kdb0W.unsupportedMark)
    },
    {
        name: 'unsupportedNodeAttribute',
        spec: (0, $3pgGD.unsupportedNodeAttribute)
    }
];
function $bbd098624269520c$export$2d0c32a809131488() {
    const nodes = $bbd098624269520c$var$nodesInOrder.reduce((acc, { name: name, spec: spec })=>{
        // @ts-expect-error - Type for SchemaBuiltInItem is not correct
        acc[name] = spec;
        return acc;
    }, {});
    const marks = $bbd098624269520c$var$marksInOrder.reduce((acc, { name: name, spec: spec })=>{
        // @ts-expect-error - Type for SchemaBuiltInItem is not correct
        acc[name] = spec;
        return acc;
    }, {});
    return {
        nodes: nodes,
        marks: marks
    };
}
function $bbd098624269520c$export$5f4ce795563f4211(config) {
    const { customNodeSpecs: customNodeSpecs, customMarkSpecs: customMarkSpecs } = config;
    const nodesConfig = Object.keys(customNodeSpecs || {}).concat(config.nodes);
    const marksConfig = Object.keys(customMarkSpecs || {}).concat(config.marks || []).concat($bbd098624269520c$var$markGroupDeclarationsNames);
    let nodes = $bbd098624269520c$var$addItems($bbd098624269520c$var$nodesInOrder, nodesConfig, customNodeSpecs);
    const marks = $bbd098624269520c$var$addItems($bbd098624269520c$var$marksInOrder, marksConfig, customMarkSpecs);
    nodes = (0, $mYA6R.sanitizeNodes)(nodes, marks);
    return new (0, $3xw6l.Schema)({
        nodes: nodes,
        marks: marks
    });
}
const $bbd098624269520c$export$c77b6d30da5276a1 = true;

});
parcelRegister("3xw6l", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $293d5acde922b5fe$export$ffb0004e005737fa);
$parcel$export(module.exports, "Mark", () => $293d5acde922b5fe$export$c9d15bcfc6d42044);
$parcel$export(module.exports, "ReplaceError", () => $293d5acde922b5fe$export$6de0e778727af3f2);
$parcel$export(module.exports, "Slice", () => $293d5acde922b5fe$export$b3f2e2de3a8baa1e);
$parcel$export(module.exports, "ResolvedPos", () => $293d5acde922b5fe$export$b2a42f82e59e4b19);
$parcel$export(module.exports, "NodeRange", () => $293d5acde922b5fe$export$7bc461ceb770fb16);
$parcel$export(module.exports, "Node", () => $293d5acde922b5fe$export$85c928794f8d04d4);
$parcel$export(module.exports, "MarkType", () => $293d5acde922b5fe$export$b6a78689043c6521);
$parcel$export(module.exports, "Schema", () => $293d5acde922b5fe$export$19342e026b58ebb7);
$parcel$export(module.exports, "DOMParser", () => $293d5acde922b5fe$export$1059c6e7d2ce5669);
$parcel$export(module.exports, "DOMSerializer", () => $293d5acde922b5fe$export$3476b78f8f5a8b72);

var $b22x6 = parcelRequire("b22x6");
function $293d5acde922b5fe$var$findDiffStart(a, b, pos) {
    for(let i = 0;; i++){
        if (i == a.childCount || i == b.childCount) return a.childCount == b.childCount ? null : pos;
        let childA = a.child(i), childB = b.child(i);
        if (childA == childB) {
            pos += childA.nodeSize;
            continue;
        }
        if (!childA.sameMarkup(childB)) return pos;
        if (childA.isText && childA.text != childB.text) {
            for(let j = 0; childA.text[j] == childB.text[j]; j++)pos++;
            return pos;
        }
        if (childA.content.size || childB.content.size) {
            let inner = $293d5acde922b5fe$var$findDiffStart(childA.content, childB.content, pos + 1);
            if (inner != null) return inner;
        }
        pos += childA.nodeSize;
    }
}
function $293d5acde922b5fe$var$findDiffEnd(a, b, posA, posB) {
    for(let iA = a.childCount, iB = b.childCount;;){
        if (iA == 0 || iB == 0) return iA == iB ? null : {
            a: posA,
            b: posB
        };
        let childA = a.child(--iA), childB = b.child(--iB), size = childA.nodeSize;
        if (childA == childB) {
            posA -= size;
            posB -= size;
            continue;
        }
        if (!childA.sameMarkup(childB)) return {
            a: posA,
            b: posB
        };
        if (childA.isText && childA.text != childB.text) {
            let same = 0, minSize = Math.min(childA.text.length, childB.text.length);
            while(same < minSize && childA.text[childA.text.length - same - 1] == childB.text[childB.text.length - same - 1]){
                same++;
                posA--;
                posB--;
            }
            return {
                a: posA,
                b: posB
            };
        }
        if (childA.content.size || childB.content.size) {
            let inner = $293d5acde922b5fe$var$findDiffEnd(childA.content, childB.content, posA - 1, posB - 1);
            if (inner) return inner;
        }
        posA -= size;
        posB -= size;
    }
}
/**
A fragment represents a node's collection of child nodes.

Like nodes, fragments are persistent data structures, and you
should not mutate them or their content. Rather, you create new
instances whenever needed. The API tries to make this easy.
*/ class $293d5acde922b5fe$export$ffb0004e005737fa {
    /**
    @internal
    */ constructor(/**
    The child nodes in this fragment.
    */ content, size){
        this.content = content;
        this.size = size || 0;
        if (size == null) for(let i = 0; i < content.length; i++)this.size += content[i].nodeSize;
    }
    /**
    Invoke a callback for all descendant nodes between the given two
    positions (relative to start of this fragment). Doesn't descend
    into a node when the callback returns `false`.
    */ nodesBetween(from, to, f, nodeStart = 0, parent) {
        for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from && f(child, nodeStart + pos, parent || null, i) !== false && child.content.size) {
                let start = pos + 1;
                child.nodesBetween(Math.max(0, from - start), Math.min(child.content.size, to - start), f, nodeStart + start);
            }
            pos = end;
        }
    }
    /**
    Call the given callback for every descendant node. `pos` will be
    relative to the start of the fragment. The callback may return
    `false` to prevent traversal of a given node's children.
    */ descendants(f) {
        this.nodesBetween(0, this.size, f);
    }
    /**
    Extract the text between `from` and `to`. See the same method on
    [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
    */ textBetween(from, to, blockSeparator, leafText) {
        let text = "", first = true;
        this.nodesBetween(from, to, (node, pos)=>{
            let nodeText = node.isText ? node.text.slice(Math.max(from, pos) - pos, to - pos) : !node.isLeaf ? "" : leafText ? typeof leafText === "function" ? leafText(node) : leafText : node.type.spec.leafText ? node.type.spec.leafText(node) : "";
            if (node.isBlock && (node.isLeaf && nodeText || node.isTextblock) && blockSeparator) {
                if (first) first = false;
                else text += blockSeparator;
            }
            text += nodeText;
        }, 0);
        return text;
    }
    /**
    Create a new fragment containing the combined content of this
    fragment and the other.
    */ append(other) {
        if (!other.size) return this;
        if (!this.size) return other;
        let last = this.lastChild, first = other.firstChild, content = this.content.slice(), i = 0;
        if (last.isText && last.sameMarkup(first)) {
            content[content.length - 1] = last.withText(last.text + first.text);
            i = 1;
        }
        for(; i < other.content.length; i++)content.push(other.content[i]);
        return new $293d5acde922b5fe$export$ffb0004e005737fa(content, this.size + other.size);
    }
    /**
    Cut out the sub-fragment between the two given positions.
    */ cut(from, to = this.size) {
        if (from == 0 && to == this.size) return this;
        let result = [], size = 0;
        if (to > from) for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from) {
                if (pos < from || end > to) {
                    if (child.isText) child = child.cut(Math.max(0, from - pos), Math.min(child.text.length, to - pos));
                    else child = child.cut(Math.max(0, from - pos - 1), Math.min(child.content.size, to - pos - 1));
                }
                result.push(child);
                size += child.nodeSize;
            }
            pos = end;
        }
        return new $293d5acde922b5fe$export$ffb0004e005737fa(result, size);
    }
    /**
    @internal
    */ cutByIndex(from, to) {
        if (from == to) return $293d5acde922b5fe$export$ffb0004e005737fa.empty;
        if (from == 0 && to == this.content.length) return this;
        return new $293d5acde922b5fe$export$ffb0004e005737fa(this.content.slice(from, to));
    }
    /**
    Create a new fragment in which the node at the given index is
    replaced by the given node.
    */ replaceChild(index, node) {
        let current = this.content[index];
        if (current == node) return this;
        let copy = this.content.slice();
        let size = this.size + node.nodeSize - current.nodeSize;
        copy[index] = node;
        return new $293d5acde922b5fe$export$ffb0004e005737fa(copy, size);
    }
    /**
    Create a new fragment by prepending the given node to this
    fragment.
    */ addToStart(node) {
        return new $293d5acde922b5fe$export$ffb0004e005737fa([
            node
        ].concat(this.content), this.size + node.nodeSize);
    }
    /**
    Create a new fragment by appending the given node to this
    fragment.
    */ addToEnd(node) {
        return new $293d5acde922b5fe$export$ffb0004e005737fa(this.content.concat(node), this.size + node.nodeSize);
    }
    /**
    Compare this fragment to another one.
    */ eq(other) {
        if (this.content.length != other.content.length) return false;
        for(let i = 0; i < this.content.length; i++)if (!this.content[i].eq(other.content[i])) return false;
        return true;
    }
    /**
    The first child of the fragment, or `null` if it is empty.
    */ get firstChild() {
        return this.content.length ? this.content[0] : null;
    }
    /**
    The last child of the fragment, or `null` if it is empty.
    */ get lastChild() {
        return this.content.length ? this.content[this.content.length - 1] : null;
    }
    /**
    The number of child nodes in this fragment.
    */ get childCount() {
        return this.content.length;
    }
    /**
    Get the child node at the given index. Raise an error when the
    index is out of range.
    */ child(index) {
        let found = this.content[index];
        if (!found) throw new RangeError("Index " + index + " out of range for " + this);
        return found;
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content[index] || null;
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        for(let i = 0, p = 0; i < this.content.length; i++){
            let child = this.content[i];
            f(child, p, i);
            p += child.nodeSize;
        }
    }
    /**
    Find the first position at which this fragment and another
    fragment differ, or `null` if they are the same.
    */ findDiffStart(other, pos = 0) {
        return $293d5acde922b5fe$var$findDiffStart(this, other, pos);
    }
    /**
    Find the first position, searching from the end, at which this
    fragment and the given fragment differ, or `null` if they are
    the same. Since this position will not be the same in both
    nodes, an object with two separate positions is returned.
    */ findDiffEnd(other, pos = this.size, otherPos = other.size) {
        return $293d5acde922b5fe$var$findDiffEnd(this, other, pos, otherPos);
    }
    /**
    Find the index and inner offset corresponding to a given relative
    position in this fragment. The result object will be reused
    (overwritten) the next time the function is called. @internal
    */ findIndex(pos, round = -1) {
        if (pos == 0) return $293d5acde922b5fe$var$retIndex(0, pos);
        if (pos == this.size) return $293d5acde922b5fe$var$retIndex(this.content.length, pos);
        if (pos > this.size || pos < 0) throw new RangeError(`Position ${pos} outside of fragment (${this})`);
        for(let i = 0, curPos = 0;; i++){
            let cur = this.child(i), end = curPos + cur.nodeSize;
            if (end >= pos) {
                if (end == pos || round > 0) return $293d5acde922b5fe$var$retIndex(i + 1, end);
                return $293d5acde922b5fe$var$retIndex(i, curPos);
            }
            curPos = end;
        }
    }
    /**
    Return a debugging string that describes this fragment.
    */ toString() {
        return "<" + this.toStringInner() + ">";
    }
    /**
    @internal
    */ toStringInner() {
        return this.content.join(", ");
    }
    /**
    Create a JSON-serializeable representation of this fragment.
    */ toJSON() {
        return this.content.length ? this.content.map((n)=>n.toJSON()) : null;
    }
    /**
    Deserialize a fragment from its JSON representation.
    */ static fromJSON(schema, value) {
        if (!value) return $293d5acde922b5fe$export$ffb0004e005737fa.empty;
        if (!Array.isArray(value)) throw new RangeError("Invalid input for Fragment.fromJSON");
        return new $293d5acde922b5fe$export$ffb0004e005737fa(value.map(schema.nodeFromJSON));
    }
    /**
    Build a fragment from an array of nodes. Ensures that adjacent
    text nodes with the same marks are joined together.
    */ static fromArray(array) {
        if (!array.length) return $293d5acde922b5fe$export$ffb0004e005737fa.empty;
        let joined, size = 0;
        for(let i = 0; i < array.length; i++){
            let node = array[i];
            size += node.nodeSize;
            if (i && node.isText && array[i - 1].sameMarkup(node)) {
                if (!joined) joined = array.slice(0, i);
                joined[joined.length - 1] = node.withText(joined[joined.length - 1].text + node.text);
            } else if (joined) joined.push(node);
        }
        return new $293d5acde922b5fe$export$ffb0004e005737fa(joined || array, size);
    }
    /**
    Create a fragment from something that can be interpreted as a
    set of nodes. For `null`, it returns the empty fragment. For a
    fragment, the fragment itself. For a node or array of nodes, a
    fragment containing those nodes.
    */ static from(nodes) {
        if (!nodes) return $293d5acde922b5fe$export$ffb0004e005737fa.empty;
        if (nodes instanceof $293d5acde922b5fe$export$ffb0004e005737fa) return nodes;
        if (Array.isArray(nodes)) return this.fromArray(nodes);
        if (nodes.attrs) return new $293d5acde922b5fe$export$ffb0004e005737fa([
            nodes
        ], nodes.nodeSize);
        throw new RangeError("Can not convert " + nodes + " to a Fragment" + (nodes.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
    }
}
/**
An empty fragment. Intended to be reused whenever a node doesn't
contain anything (rather than allocating a new empty fragment for
each leaf node).
*/ $293d5acde922b5fe$export$ffb0004e005737fa.empty = new $293d5acde922b5fe$export$ffb0004e005737fa([], 0);
const $293d5acde922b5fe$var$found = {
    index: 0,
    offset: 0
};
function $293d5acde922b5fe$var$retIndex(index, offset) {
    $293d5acde922b5fe$var$found.index = index;
    $293d5acde922b5fe$var$found.offset = offset;
    return $293d5acde922b5fe$var$found;
}
function $293d5acde922b5fe$var$compareDeep(a, b) {
    if (a === b) return true;
    if (!(a && typeof a == "object") || !(b && typeof b == "object")) return false;
    let array = Array.isArray(a);
    if (Array.isArray(b) != array) return false;
    if (array) {
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!$293d5acde922b5fe$var$compareDeep(a[i], b[i])) return false;
    } else {
        for(let p in a)if (!(p in b) || !$293d5acde922b5fe$var$compareDeep(a[p], b[p])) return false;
        for(let p in b)if (!(p in a)) return false;
    }
    return true;
}
/**
A mark is a piece of information that can be attached to a node,
such as it being emphasized, in code font, or a link. It has a
type and optionally a set of attributes that provide further
information (such as the target of the link). Marks are created
through a `Schema`, which controls which types exist and which
attributes they have.
*/ class $293d5acde922b5fe$export$c9d15bcfc6d42044 {
    /**
    @internal
    */ constructor(/**
    The type of this mark.
    */ type, /**
    The attributes associated with this mark.
    */ attrs){
        this.type = type;
        this.attrs = attrs;
    }
    /**
    Given a set of marks, create a new set which contains this one as
    well, in the right position. If this mark is already in the set,
    the set itself is returned. If any marks that are set to be
    [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
    those are replaced by this one.
    */ addToSet(set) {
        let copy, placed = false;
        for(let i = 0; i < set.length; i++){
            let other = set[i];
            if (this.eq(other)) return set;
            if (this.type.excludes(other.type)) {
                if (!copy) copy = set.slice(0, i);
            } else if (other.type.excludes(this.type)) return set;
            else {
                if (!placed && other.type.rank > this.type.rank) {
                    if (!copy) copy = set.slice(0, i);
                    copy.push(this);
                    placed = true;
                }
                if (copy) copy.push(other);
            }
        }
        if (!copy) copy = set.slice();
        if (!placed) copy.push(this);
        return copy;
    }
    /**
    Remove this mark from the given set, returning a new set. If this
    mark is not in the set, the set itself is returned.
    */ removeFromSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return set.slice(0, i).concat(set.slice(i + 1));
        return set;
    }
    /**
    Test whether this mark is in the given set of marks.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return true;
        return false;
    }
    /**
    Test whether this mark has the same type and attributes as
    another mark.
    */ eq(other) {
        return this == other || this.type == other.type && $293d5acde922b5fe$var$compareDeep(this.attrs, other.attrs);
    }
    /**
    Convert this mark to a JSON-serializeable representation.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        return obj;
    }
    /**
    Deserialize a mark from JSON.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Mark.fromJSON");
        let type = schema.marks[json.type];
        if (!type) throw new RangeError(`There is no mark type ${json.type} in this schema`);
        let mark = type.create(json.attrs);
        type.checkAttrs(mark.attrs);
        return mark;
    }
    /**
    Test whether two sets of marks are identical.
    */ static sameSet(a, b) {
        if (a == b) return true;
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!a[i].eq(b[i])) return false;
        return true;
    }
    /**
    Create a properly sorted mark set from null, a single mark, or an
    unsorted array of marks.
    */ static setFrom(marks) {
        if (!marks || Array.isArray(marks) && marks.length == 0) return $293d5acde922b5fe$export$c9d15bcfc6d42044.none;
        if (marks instanceof $293d5acde922b5fe$export$c9d15bcfc6d42044) return [
            marks
        ];
        let copy = marks.slice();
        copy.sort((a, b)=>a.type.rank - b.type.rank);
        return copy;
    }
}
/**
The empty set of marks.
*/ $293d5acde922b5fe$export$c9d15bcfc6d42044.none = [];
/**
Error type raised by [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) when
given an invalid replacement.
*/ class $293d5acde922b5fe$export$6de0e778727af3f2 extends Error {
}
/*
ReplaceError = function(this: any, message: string) {
  let err = Error.call(this, message)
  ;(err as any).__proto__ = ReplaceError.prototype
  return err
} as any

ReplaceError.prototype = Object.create(Error.prototype)
ReplaceError.prototype.constructor = ReplaceError
ReplaceError.prototype.name = "ReplaceError"
*/ /**
A slice represents a piece cut out of a larger document. It
stores not only a fragment, but also the depth up to which nodes on
both side are ‘open’ (cut through).
*/ class $293d5acde922b5fe$export$b3f2e2de3a8baa1e {
    /**
    Create a slice. When specifying a non-zero open depth, you must
    make sure that there are nodes of at least that depth at the
    appropriate side of the fragment—i.e. if the fragment is an
    empty paragraph node, `openStart` and `openEnd` can't be greater
    than 1.
    
    It is not necessary for the content of open nodes to conform to
    the schema's content constraints, though it should be a valid
    start/end/middle for such a node, depending on which sides are
    open.
    */ constructor(/**
    The slice's content.
    */ content, /**
    The open depth at the start of the fragment.
    */ openStart, /**
    The open depth at the end.
    */ openEnd){
        this.content = content;
        this.openStart = openStart;
        this.openEnd = openEnd;
    }
    /**
    The size this slice would add when inserted into a document.
    */ get size() {
        return this.content.size - this.openStart - this.openEnd;
    }
    /**
    @internal
    */ insertAt(pos, fragment) {
        let content = $293d5acde922b5fe$var$insertInto(this.content, pos + this.openStart, fragment);
        return content && new $293d5acde922b5fe$export$b3f2e2de3a8baa1e(content, this.openStart, this.openEnd);
    }
    /**
    @internal
    */ removeBetween(from, to) {
        return new $293d5acde922b5fe$export$b3f2e2de3a8baa1e($293d5acde922b5fe$var$removeRange(this.content, from + this.openStart, to + this.openStart), this.openStart, this.openEnd);
    }
    /**
    Tests whether this slice is equal to another slice.
    */ eq(other) {
        return this.content.eq(other.content) && this.openStart == other.openStart && this.openEnd == other.openEnd;
    }
    /**
    @internal
    */ toString() {
        return this.content + "(" + this.openStart + "," + this.openEnd + ")";
    }
    /**
    Convert a slice to a JSON-serializable representation.
    */ toJSON() {
        if (!this.content.size) return null;
        let json = {
            content: this.content.toJSON()
        };
        if (this.openStart > 0) json.openStart = this.openStart;
        if (this.openEnd > 0) json.openEnd = this.openEnd;
        return json;
    }
    /**
    Deserialize a slice from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) return $293d5acde922b5fe$export$b3f2e2de3a8baa1e.empty;
        let openStart = json.openStart || 0, openEnd = json.openEnd || 0;
        if (typeof openStart != "number" || typeof openEnd != "number") throw new RangeError("Invalid input for Slice.fromJSON");
        return new $293d5acde922b5fe$export$b3f2e2de3a8baa1e($293d5acde922b5fe$export$ffb0004e005737fa.fromJSON(schema, json.content), openStart, openEnd);
    }
    /**
    Create a slice from a fragment by taking the maximum possible
    open value on both side of the fragment.
    */ static maxOpen(fragment, openIsolating = true) {
        let openStart = 0, openEnd = 0;
        for(let n = fragment.firstChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.firstChild)openStart++;
        for(let n = fragment.lastChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.lastChild)openEnd++;
        return new $293d5acde922b5fe$export$b3f2e2de3a8baa1e(fragment, openStart, openEnd);
    }
}
/**
The empty slice.
*/ $293d5acde922b5fe$export$b3f2e2de3a8baa1e.empty = new $293d5acde922b5fe$export$b3f2e2de3a8baa1e($293d5acde922b5fe$export$ffb0004e005737fa.empty, 0, 0);
function $293d5acde922b5fe$var$removeRange(content, from, to) {
    let { index: index, offset: offset } = content.findIndex(from), child = content.maybeChild(index);
    let { index: indexTo, offset: offsetTo } = content.findIndex(to);
    if (offset == from || child.isText) {
        if (offsetTo != to && !content.child(indexTo).isText) throw new RangeError("Removing non-flat range");
        return content.cut(0, from).append(content.cut(to));
    }
    if (index != indexTo) throw new RangeError("Removing non-flat range");
    return content.replaceChild(index, child.copy($293d5acde922b5fe$var$removeRange(child.content, from - offset - 1, to - offset - 1)));
}
function $293d5acde922b5fe$var$insertInto(content, dist, insert, parent) {
    let { index: index, offset: offset } = content.findIndex(dist), child = content.maybeChild(index);
    if (offset == dist || child.isText) {
        if (parent && !parent.canReplace(index, index, insert)) return null;
        return content.cut(0, dist).append(insert).append(content.cut(dist));
    }
    let inner = $293d5acde922b5fe$var$insertInto(child.content, dist - offset - 1, insert);
    return inner && content.replaceChild(index, child.copy(inner));
}
function $293d5acde922b5fe$var$replace($from, $to, slice) {
    if (slice.openStart > $from.depth) throw new $293d5acde922b5fe$export$6de0e778727af3f2("Inserted content deeper than insertion position");
    if ($from.depth - slice.openStart != $to.depth - slice.openEnd) throw new $293d5acde922b5fe$export$6de0e778727af3f2("Inconsistent open depths");
    return $293d5acde922b5fe$var$replaceOuter($from, $to, slice, 0);
}
function $293d5acde922b5fe$var$replaceOuter($from, $to, slice, depth) {
    let index = $from.index(depth), node = $from.node(depth);
    if (index == $to.index(depth) && depth < $from.depth - slice.openStart) {
        let inner = $293d5acde922b5fe$var$replaceOuter($from, $to, slice, depth + 1);
        return node.copy(node.content.replaceChild(index, inner));
    } else if (!slice.content.size) return $293d5acde922b5fe$var$close(node, $293d5acde922b5fe$var$replaceTwoWay($from, $to, depth));
    else if (!slice.openStart && !slice.openEnd && $from.depth == depth && $to.depth == depth) {
        let parent = $from.parent, content = parent.content;
        return $293d5acde922b5fe$var$close(parent, content.cut(0, $from.parentOffset).append(slice.content).append(content.cut($to.parentOffset)));
    } else {
        let { start: start, end: end } = $293d5acde922b5fe$var$prepareSliceForReplace(slice, $from);
        return $293d5acde922b5fe$var$close(node, $293d5acde922b5fe$var$replaceThreeWay($from, start, end, $to, depth));
    }
}
function $293d5acde922b5fe$var$checkJoin(main, sub) {
    if (!sub.type.compatibleContent(main.type)) throw new $293d5acde922b5fe$export$6de0e778727af3f2("Cannot join " + sub.type.name + " onto " + main.type.name);
}
function $293d5acde922b5fe$var$joinable($before, $after, depth) {
    let node = $before.node(depth);
    $293d5acde922b5fe$var$checkJoin(node, $after.node(depth));
    return node;
}
function $293d5acde922b5fe$var$addNode(child, target) {
    let last = target.length - 1;
    if (last >= 0 && child.isText && child.sameMarkup(target[last])) target[last] = child.withText(target[last].text + child.text);
    else target.push(child);
}
function $293d5acde922b5fe$var$addRange($start, $end, depth, target) {
    let node = ($end || $start).node(depth);
    let startIndex = 0, endIndex = $end ? $end.index(depth) : node.childCount;
    if ($start) {
        startIndex = $start.index(depth);
        if ($start.depth > depth) startIndex++;
        else if ($start.textOffset) {
            $293d5acde922b5fe$var$addNode($start.nodeAfter, target);
            startIndex++;
        }
    }
    for(let i = startIndex; i < endIndex; i++)$293d5acde922b5fe$var$addNode(node.child(i), target);
    if ($end && $end.depth == depth && $end.textOffset) $293d5acde922b5fe$var$addNode($end.nodeBefore, target);
}
function $293d5acde922b5fe$var$close(node, content) {
    node.type.checkContent(content);
    return node.copy(content);
}
function $293d5acde922b5fe$var$replaceThreeWay($from, $start, $end, $to, depth) {
    let openStart = $from.depth > depth && $293d5acde922b5fe$var$joinable($from, $start, depth + 1);
    let openEnd = $to.depth > depth && $293d5acde922b5fe$var$joinable($end, $to, depth + 1);
    let content = [];
    $293d5acde922b5fe$var$addRange(null, $from, depth, content);
    if (openStart && openEnd && $start.index(depth) == $end.index(depth)) {
        $293d5acde922b5fe$var$checkJoin(openStart, openEnd);
        $293d5acde922b5fe$var$addNode($293d5acde922b5fe$var$close(openStart, $293d5acde922b5fe$var$replaceThreeWay($from, $start, $end, $to, depth + 1)), content);
    } else {
        if (openStart) $293d5acde922b5fe$var$addNode($293d5acde922b5fe$var$close(openStart, $293d5acde922b5fe$var$replaceTwoWay($from, $start, depth + 1)), content);
        $293d5acde922b5fe$var$addRange($start, $end, depth, content);
        if (openEnd) $293d5acde922b5fe$var$addNode($293d5acde922b5fe$var$close(openEnd, $293d5acde922b5fe$var$replaceTwoWay($end, $to, depth + 1)), content);
    }
    $293d5acde922b5fe$var$addRange($to, null, depth, content);
    return new $293d5acde922b5fe$export$ffb0004e005737fa(content);
}
function $293d5acde922b5fe$var$replaceTwoWay($from, $to, depth) {
    let content = [];
    $293d5acde922b5fe$var$addRange(null, $from, depth, content);
    if ($from.depth > depth) {
        let type = $293d5acde922b5fe$var$joinable($from, $to, depth + 1);
        $293d5acde922b5fe$var$addNode($293d5acde922b5fe$var$close(type, $293d5acde922b5fe$var$replaceTwoWay($from, $to, depth + 1)), content);
    }
    $293d5acde922b5fe$var$addRange($to, null, depth, content);
    return new $293d5acde922b5fe$export$ffb0004e005737fa(content);
}
function $293d5acde922b5fe$var$prepareSliceForReplace(slice, $along) {
    let extra = $along.depth - slice.openStart, parent = $along.node(extra);
    let node = parent.copy(slice.content);
    for(let i = extra - 1; i >= 0; i--)node = $along.node(i).copy($293d5acde922b5fe$export$ffb0004e005737fa.from(node));
    return {
        start: node.resolveNoCache(slice.openStart + extra),
        end: node.resolveNoCache(node.content.size - slice.openEnd - extra)
    };
}
/**
You can [_resolve_](https://prosemirror.net/docs/ref/#model.Node.resolve) a position to get more
information about it. Objects of this class represent such a
resolved position, providing various pieces of context
information, and some helper methods.

Throughout this interface, methods that take an optional `depth`
parameter will interpret undefined as `this.depth` and negative
numbers as `this.depth + value`.
*/ class $293d5acde922b5fe$export$b2a42f82e59e4b19 {
    /**
    @internal
    */ constructor(/**
    The position that was resolved.
    */ pos, /**
    @internal
    */ path, /**
    The offset this position has into its parent node.
    */ parentOffset){
        this.pos = pos;
        this.path = path;
        this.parentOffset = parentOffset;
        this.depth = path.length / 3 - 1;
    }
    /**
    @internal
    */ resolveDepth(val) {
        if (val == null) return this.depth;
        if (val < 0) return this.depth + val;
        return val;
    }
    /**
    The parent node that the position points into. Note that even if
    a position points into a text node, that node is not considered
    the parent—text nodes are ‘flat’ in this model, and have no content.
    */ get parent() {
        return this.node(this.depth);
    }
    /**
    The root node in which the position was resolved.
    */ get doc() {
        return this.node(0);
    }
    /**
    The ancestor node at the given level. `p.node(p.depth)` is the
    same as `p.parent`.
    */ node(depth) {
        return this.path[this.resolveDepth(depth) * 3];
    }
    /**
    The index into the ancestor at the given level. If this points
    at the 3rd node in the 2nd paragraph on the top level, for
    example, `p.index(0)` is 1 and `p.index(1)` is 2.
    */ index(depth) {
        return this.path[this.resolveDepth(depth) * 3 + 1];
    }
    /**
    The index pointing after this position into the ancestor at the
    given level.
    */ indexAfter(depth) {
        depth = this.resolveDepth(depth);
        return this.index(depth) + (depth == this.depth && !this.textOffset ? 0 : 1);
    }
    /**
    The (absolute) position at the start of the node at the given
    level.
    */ start(depth) {
        depth = this.resolveDepth(depth);
        return depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
    }
    /**
    The (absolute) position at the end of the node at the given
    level.
    */ end(depth) {
        depth = this.resolveDepth(depth);
        return this.start(depth) + this.node(depth).content.size;
    }
    /**
    The (absolute) position directly before the wrapping node at the
    given level, or, when `depth` is `this.depth + 1`, the original
    position.
    */ before(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position before the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1];
    }
    /**
    The (absolute) position directly after the wrapping node at the
    given level, or the original position when `depth` is `this.depth + 1`.
    */ after(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position after the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1] + this.path[depth * 3].nodeSize;
    }
    /**
    When this position points into a text node, this returns the
    distance between the position and the start of the text node.
    Will be zero for positions that point between nodes.
    */ get textOffset() {
        return this.pos - this.path[this.path.length - 1];
    }
    /**
    Get the node directly after the position, if any. If the position
    points into a text node, only the part of that node after the
    position is returned.
    */ get nodeAfter() {
        let parent = this.parent, index = this.index(this.depth);
        if (index == parent.childCount) return null;
        let dOff = this.pos - this.path[this.path.length - 1], child = parent.child(index);
        return dOff ? parent.child(index).cut(dOff) : child;
    }
    /**
    Get the node directly before the position, if any. If the
    position points into a text node, only the part of that node
    before the position is returned.
    */ get nodeBefore() {
        let index = this.index(this.depth);
        let dOff = this.pos - this.path[this.path.length - 1];
        if (dOff) return this.parent.child(index).cut(0, dOff);
        return index == 0 ? null : this.parent.child(index - 1);
    }
    /**
    Get the position at the given index in the parent node at the
    given depth (which defaults to `this.depth`).
    */ posAtIndex(index, depth) {
        depth = this.resolveDepth(depth);
        let node = this.path[depth * 3], pos = depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
        for(let i = 0; i < index; i++)pos += node.child(i).nodeSize;
        return pos;
    }
    /**
    Get the marks at this position, factoring in the surrounding
    marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
    position is at the start of a non-empty node, the marks of the
    node after it (if any) are returned.
    */ marks() {
        let parent = this.parent, index = this.index();
        // In an empty parent, return the empty array
        if (parent.content.size == 0) return $293d5acde922b5fe$export$c9d15bcfc6d42044.none;
        // When inside a text node, just return the text node's marks
        if (this.textOffset) return parent.child(index).marks;
        let main = parent.maybeChild(index - 1), other = parent.maybeChild(index);
        // If the `after` flag is true of there is no node before, make
        // the node after this position the main reference.
        if (!main) {
            let tmp = main;
            main = other;
            other = tmp;
        }
        // Use all marks in the main node, except those that have
        // `inclusive` set to false and are not present in the other node.
        let marks = main.marks;
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!other || !marks[i].isInSet(other.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    Get the marks after the current position, if any, except those
    that are non-inclusive and not present at position `$end`. This
    is mostly useful for getting the set of marks to preserve after a
    deletion. Will return `null` if this position is at the end of
    its parent node or its parent node isn't a textblock (in which
    case no marks should be preserved).
    */ marksAcross($end) {
        let after = this.parent.maybeChild(this.index());
        if (!after || !after.isInline) return null;
        let marks = after.marks, next = $end.parent.maybeChild($end.index());
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!next || !marks[i].isInSet(next.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    The depth up to which this position and the given (non-resolved)
    position share the same parent nodes.
    */ sharedDepth(pos) {
        for(let depth = this.depth; depth > 0; depth--)if (this.start(depth) <= pos && this.end(depth) >= pos) return depth;
        return 0;
    }
    /**
    Returns a range based on the place where this position and the
    given position diverge around block content. If both point into
    the same textblock, for example, a range around that textblock
    will be returned. If they point into different blocks, the range
    around those blocks in their shared ancestor is returned. You can
    pass in an optional predicate that will be called with a parent
    node to see if a range into that parent is acceptable.
    */ blockRange(other = this, pred) {
        if (other.pos < this.pos) return other.blockRange(this);
        for(let d = this.depth - (this.parent.inlineContent || this.pos == other.pos ? 1 : 0); d >= 0; d--)if (other.pos <= this.end(d) && (!pred || pred(this.node(d)))) return new $293d5acde922b5fe$export$7bc461ceb770fb16(this, other, d);
        return null;
    }
    /**
    Query whether the given position shares the same parent node.
    */ sameParent(other) {
        return this.pos - this.parentOffset == other.pos - other.parentOffset;
    }
    /**
    Return the greater of this and the given position.
    */ max(other) {
        return other.pos > this.pos ? other : this;
    }
    /**
    Return the smaller of this and the given position.
    */ min(other) {
        return other.pos < this.pos ? other : this;
    }
    /**
    @internal
    */ toString() {
        let str = "";
        for(let i = 1; i <= this.depth; i++)str += (str ? "/" : "") + this.node(i).type.name + "_" + this.index(i - 1);
        return str + ":" + this.parentOffset;
    }
    /**
    @internal
    */ static resolve(doc, pos) {
        if (!(pos >= 0 && pos <= doc.content.size)) throw new RangeError("Position " + pos + " out of range");
        let path = [];
        let start = 0, parentOffset = pos;
        for(let node = doc;;){
            let { index: index, offset: offset } = node.content.findIndex(parentOffset);
            let rem = parentOffset - offset;
            path.push(node, index, start + offset);
            if (!rem) break;
            node = node.child(index);
            if (node.isText) break;
            parentOffset = rem - 1;
            start += offset + 1;
        }
        return new $293d5acde922b5fe$export$b2a42f82e59e4b19(pos, path, parentOffset);
    }
    /**
    @internal
    */ static resolveCached(doc, pos) {
        let cache = $293d5acde922b5fe$var$resolveCache.get(doc);
        if (cache) for(let i = 0; i < cache.elts.length; i++){
            let elt = cache.elts[i];
            if (elt.pos == pos) return elt;
        }
        else $293d5acde922b5fe$var$resolveCache.set(doc, cache = new $293d5acde922b5fe$var$ResolveCache);
        let result = cache.elts[cache.i] = $293d5acde922b5fe$export$b2a42f82e59e4b19.resolve(doc, pos);
        cache.i = (cache.i + 1) % $293d5acde922b5fe$var$resolveCacheSize;
        return result;
    }
}
class $293d5acde922b5fe$var$ResolveCache {
    constructor(){
        this.elts = [];
        this.i = 0;
    }
}
const $293d5acde922b5fe$var$resolveCacheSize = 12, $293d5acde922b5fe$var$resolveCache = new WeakMap();
/**
Represents a flat range of content, i.e. one that starts and
ends in the same node.
*/ class $293d5acde922b5fe$export$7bc461ceb770fb16 {
    /**
    Construct a node range. `$from` and `$to` should point into the
    same node until at least the given `depth`, since a node range
    denotes an adjacent set of nodes in a single parent node.
    */ constructor(/**
    A resolved position along the start of the content. May have a
    `depth` greater than this object's `depth` property, since
    these are the positions that were used to compute the range,
    not re-resolved positions directly at its boundaries.
    */ $from, /**
    A position along the end of the content. See
    caveat for [`$from`](https://prosemirror.net/docs/ref/#model.NodeRange.$from).
    */ $to, /**
    The depth of the node that this range points into.
    */ depth){
        this.$from = $from;
        this.$to = $to;
        this.depth = depth;
    }
    /**
    The position at the start of the range.
    */ get start() {
        return this.$from.before(this.depth + 1);
    }
    /**
    The position at the end of the range.
    */ get end() {
        return this.$to.after(this.depth + 1);
    }
    /**
    The parent node that the range points into.
    */ get parent() {
        return this.$from.node(this.depth);
    }
    /**
    The start index of the range in the parent node.
    */ get startIndex() {
        return this.$from.index(this.depth);
    }
    /**
    The end index of the range in the parent node.
    */ get endIndex() {
        return this.$to.indexAfter(this.depth);
    }
}
const $293d5acde922b5fe$var$emptyAttrs = Object.create(null);
/**
This class represents a node in the tree that makes up a
ProseMirror document. So a document is an instance of `Node`, with
children that are also instances of `Node`.

Nodes are persistent data structures. Instead of changing them, you
create new ones with the content you want. Old ones keep pointing
at the old document shape. This is made cheaper by sharing
structure between the old and new data as much as possible, which a
tree shape like this (without back pointers) makes easy.

**Do not** directly mutate the properties of a `Node` object. See
[the guide](/docs/guide/#doc) for more information.
*/ class $293d5acde922b5fe$export$85c928794f8d04d4 {
    /**
    @internal
    */ constructor(/**
    The type of node that this is.
    */ type, /**
    An object mapping attribute names to values. The kind of
    attributes allowed and required are
    [determined](https://prosemirror.net/docs/ref/#model.NodeSpec.attrs) by the node type.
    */ attrs, // A fragment holding the node's children.
    content, /**
    The marks (things like whether it is emphasized or part of a
    link) applied to this node.
    */ marks = $293d5acde922b5fe$export$c9d15bcfc6d42044.none){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.content = content || $293d5acde922b5fe$export$ffb0004e005737fa.empty;
    }
    /**
    The array of this node's child nodes.
    */ get children() {
        return this.content.content;
    }
    /**
    The size of this node, as defined by the integer-based [indexing
    scheme](/docs/guide/#doc.indexing). For text nodes, this is the
    amount of characters. For other leaf nodes, it is one. For
    non-leaf nodes, it is the size of the content plus two (the
    start and end token).
    */ get nodeSize() {
        return this.isLeaf ? 1 : 2 + this.content.size;
    }
    /**
    The number of children that the node has.
    */ get childCount() {
        return this.content.childCount;
    }
    /**
    Get the child node at the given index. Raises an error when the
    index is out of range.
    */ child(index) {
        return this.content.child(index);
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content.maybeChild(index);
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        this.content.forEach(f);
    }
    /**
    Invoke a callback for all descendant nodes recursively between
    the given two positions that are relative to start of this
    node's content. The callback is invoked with the node, its
    position relative to the original node (method receiver),
    its parent node, and its child index. When the callback returns
    false for a given node, that node's children will not be
    recursed over. The last parameter can be used to specify a
    starting position to count from.
    */ nodesBetween(from, to, f, startPos = 0) {
        this.content.nodesBetween(from, to, f, startPos, this);
    }
    /**
    Call the given callback for every descendant node. Doesn't
    descend into a node when the callback returns `false`.
    */ descendants(f) {
        this.nodesBetween(0, this.content.size, f);
    }
    /**
    Concatenates all the text nodes found in this fragment and its
    children.
    */ get textContent() {
        return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
    }
    /**
    Get all text between positions `from` and `to`. When
    `blockSeparator` is given, it will be inserted to separate text
    from different block nodes. If `leafText` is given, it'll be
    inserted for every non-text leaf node encountered, otherwise
    [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec^leafText) will be used.
    */ textBetween(from, to, blockSeparator, leafText) {
        return this.content.textBetween(from, to, blockSeparator, leafText);
    }
    /**
    Returns this node's first child, or `null` if there are no
    children.
    */ get firstChild() {
        return this.content.firstChild;
    }
    /**
    Returns this node's last child, or `null` if there are no
    children.
    */ get lastChild() {
        return this.content.lastChild;
    }
    /**
    Test whether two nodes represent the same piece of document.
    */ eq(other) {
        return this == other || this.sameMarkup(other) && this.content.eq(other.content);
    }
    /**
    Compare the markup (type, attributes, and marks) of this node to
    those of another. Returns `true` if both have the same markup.
    */ sameMarkup(other) {
        return this.hasMarkup(other.type, other.attrs, other.marks);
    }
    /**
    Check whether this node's markup correspond to the given type,
    attributes, and marks.
    */ hasMarkup(type, attrs, marks) {
        return this.type == type && $293d5acde922b5fe$var$compareDeep(this.attrs, attrs || type.defaultAttrs || $293d5acde922b5fe$var$emptyAttrs) && $293d5acde922b5fe$export$c9d15bcfc6d42044.sameSet(this.marks, marks || $293d5acde922b5fe$export$c9d15bcfc6d42044.none);
    }
    /**
    Create a new node with the same markup as this node, containing
    the given content (or empty, if no content is given).
    */ copy(content = null) {
        if (content == this.content) return this;
        return new $293d5acde922b5fe$export$85c928794f8d04d4(this.type, this.attrs, content, this.marks);
    }
    /**
    Create a copy of this node, with the given set of marks instead
    of the node's own marks.
    */ mark(marks) {
        return marks == this.marks ? this : new $293d5acde922b5fe$export$85c928794f8d04d4(this.type, this.attrs, this.content, marks);
    }
    /**
    Create a copy of this node with only the content between the
    given positions. If `to` is not given, it defaults to the end of
    the node.
    */ cut(from, to = this.content.size) {
        if (from == 0 && to == this.content.size) return this;
        return this.copy(this.content.cut(from, to));
    }
    /**
    Cut out the part of the document between the given positions, and
    return it as a `Slice` object.
    */ slice(from, to = this.content.size, includeParents = false) {
        if (from == to) return $293d5acde922b5fe$export$b3f2e2de3a8baa1e.empty;
        let $from = this.resolve(from), $to = this.resolve(to);
        let depth = includeParents ? 0 : $from.sharedDepth(to);
        let start = $from.start(depth), node = $from.node(depth);
        let content = node.content.cut($from.pos - start, $to.pos - start);
        return new $293d5acde922b5fe$export$b3f2e2de3a8baa1e(content, $from.depth - depth, $to.depth - depth);
    }
    /**
    Replace the part of the document between the given positions with
    the given slice. The slice must 'fit', meaning its open sides
    must be able to connect to the surrounding content, and its
    content nodes must be valid children for the node they are placed
    into. If any of this is violated, an error of type
    [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
    */ replace(from, to, slice) {
        return $293d5acde922b5fe$var$replace(this.resolve(from), this.resolve(to), slice);
    }
    /**
    Find the node directly after the given position.
    */ nodeAt(pos) {
        for(let node = this;;){
            let { index: index, offset: offset } = node.content.findIndex(pos);
            node = node.maybeChild(index);
            if (!node) return null;
            if (offset == pos || node.isText) return node;
            pos -= offset + 1;
        }
    }
    /**
    Find the (direct) child node after the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childAfter(pos) {
        let { index: index, offset: offset } = this.content.findIndex(pos);
        return {
            node: this.content.maybeChild(index),
            index: index,
            offset: offset
        };
    }
    /**
    Find the (direct) child node before the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childBefore(pos) {
        if (pos == 0) return {
            node: null,
            index: 0,
            offset: 0
        };
        let { index: index, offset: offset } = this.content.findIndex(pos);
        if (offset < pos) return {
            node: this.content.child(index),
            index: index,
            offset: offset
        };
        let node = this.content.child(index - 1);
        return {
            node: node,
            index: index - 1,
            offset: offset - node.nodeSize
        };
    }
    /**
    Resolve the given position in the document, returning an
    [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
    */ resolve(pos) {
        return $293d5acde922b5fe$export$b2a42f82e59e4b19.resolveCached(this, pos);
    }
    /**
    @internal
    */ resolveNoCache(pos) {
        return $293d5acde922b5fe$export$b2a42f82e59e4b19.resolve(this, pos);
    }
    /**
    Test whether a given mark or mark type occurs in this document
    between the two given positions.
    */ rangeHasMark(from, to, type) {
        let found = false;
        if (to > from) this.nodesBetween(from, to, (node)=>{
            if (type.isInSet(node.marks)) found = true;
            return !found;
        });
        return found;
    }
    /**
    True when this is a block (non-inline node)
    */ get isBlock() {
        return this.type.isBlock;
    }
    /**
    True when this is a textblock node, a block node with inline
    content.
    */ get isTextblock() {
        return this.type.isTextblock;
    }
    /**
    True when this node allows inline content.
    */ get inlineContent() {
        return this.type.inlineContent;
    }
    /**
    True when this is an inline node (a text node or a node that can
    appear among text).
    */ get isInline() {
        return this.type.isInline;
    }
    /**
    True when this is a text node.
    */ get isText() {
        return this.type.isText;
    }
    /**
    True when this is a leaf node.
    */ get isLeaf() {
        return this.type.isLeaf;
    }
    /**
    True when this is an atom, i.e. when it does not have directly
    editable content. This is usually the same as `isLeaf`, but can
    be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
    on a node's spec (typically used when the node is displayed as
    an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
    */ get isAtom() {
        return this.type.isAtom;
    }
    /**
    Return a string representation of this node for debugging
    purposes.
    */ toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        let name = this.type.name;
        if (this.content.size) name += "(" + this.content.toStringInner() + ")";
        return $293d5acde922b5fe$var$wrapMarks(this.marks, name);
    }
    /**
    Get the content match in this node at the given index.
    */ contentMatchAt(index) {
        let match = this.type.contentMatch.matchFragment(this.content, 0, index);
        if (!match) throw new Error("Called contentMatchAt on a node with invalid content");
        return match;
    }
    /**
    Test whether replacing the range between `from` and `to` (by
    child index) with the given replacement fragment (which defaults
    to the empty fragment) would leave the node's content valid. You
    can optionally pass `start` and `end` indices into the
    replacement fragment.
    */ canReplace(from, to, replacement = $293d5acde922b5fe$export$ffb0004e005737fa.empty, start = 0, end = replacement.childCount) {
        let one = this.contentMatchAt(from).matchFragment(replacement, start, end);
        let two = one && one.matchFragment(this.content, to);
        if (!two || !two.validEnd) return false;
        for(let i = start; i < end; i++)if (!this.type.allowsMarks(replacement.child(i).marks)) return false;
        return true;
    }
    /**
    Test whether replacing the range `from` to `to` (by index) with
    a node of the given type would leave the node's content valid.
    */ canReplaceWith(from, to, type, marks) {
        if (marks && !this.type.allowsMarks(marks)) return false;
        let start = this.contentMatchAt(from).matchType(type);
        let end = start && start.matchFragment(this.content, to);
        return end ? end.validEnd : false;
    }
    /**
    Test whether the given node's content could be appended to this
    node. If that node is empty, this will only return true if there
    is at least one node type that can appear in both nodes (to avoid
    merging completely incompatible nodes).
    */ canAppend(other) {
        if (other.content.size) return this.canReplace(this.childCount, this.childCount, other.content);
        else return this.type.compatibleContent(other.type);
    }
    /**
    Check whether this node and its descendants conform to the
    schema, and raise an exception when they do not.
    */ check() {
        this.type.checkContent(this.content);
        this.type.checkAttrs(this.attrs);
        let copy = $293d5acde922b5fe$export$c9d15bcfc6d42044.none;
        for(let i = 0; i < this.marks.length; i++){
            let mark = this.marks[i];
            mark.type.checkAttrs(mark.attrs);
            copy = mark.addToSet(copy);
        }
        if (!$293d5acde922b5fe$export$c9d15bcfc6d42044.sameSet(copy, this.marks)) throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((m)=>m.type.name)}`);
        this.content.forEach((node)=>node.check());
    }
    /**
    Return a JSON-serializeable representation of this node.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        if (this.content.size) obj.content = this.content.toJSON();
        if (this.marks.length) obj.marks = this.marks.map((n)=>n.toJSON());
        return obj;
    }
    /**
    Deserialize a node from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Node.fromJSON");
        let marks = undefined;
        if (json.marks) {
            if (!Array.isArray(json.marks)) throw new RangeError("Invalid mark data for Node.fromJSON");
            marks = json.marks.map(schema.markFromJSON);
        }
        if (json.type == "text") {
            if (typeof json.text != "string") throw new RangeError("Invalid text node in JSON");
            return schema.text(json.text, marks);
        }
        let content = $293d5acde922b5fe$export$ffb0004e005737fa.fromJSON(schema, json.content);
        let node = schema.nodeType(json.type).create(json.attrs, content, marks);
        node.type.checkAttrs(node.attrs);
        return node;
    }
}
$293d5acde922b5fe$export$85c928794f8d04d4.prototype.text = undefined;
class $293d5acde922b5fe$var$TextNode extends $293d5acde922b5fe$export$85c928794f8d04d4 {
    /**
    @internal
    */ constructor(type, attrs, content, marks){
        super(type, attrs, null, marks);
        if (!content) throw new RangeError("Empty text nodes are not allowed");
        this.text = content;
    }
    toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        return $293d5acde922b5fe$var$wrapMarks(this.marks, JSON.stringify(this.text));
    }
    get textContent() {
        return this.text;
    }
    textBetween(from, to) {
        return this.text.slice(from, to);
    }
    get nodeSize() {
        return this.text.length;
    }
    mark(marks) {
        return marks == this.marks ? this : new $293d5acde922b5fe$var$TextNode(this.type, this.attrs, this.text, marks);
    }
    withText(text) {
        if (text == this.text) return this;
        return new $293d5acde922b5fe$var$TextNode(this.type, this.attrs, text, this.marks);
    }
    cut(from = 0, to = this.text.length) {
        if (from == 0 && to == this.text.length) return this;
        return this.withText(this.text.slice(from, to));
    }
    eq(other) {
        return this.sameMarkup(other) && this.text == other.text;
    }
    toJSON() {
        let base = super.toJSON();
        base.text = this.text;
        return base;
    }
}
function $293d5acde922b5fe$var$wrapMarks(marks, str) {
    for(let i = marks.length - 1; i >= 0; i--)str = marks[i].type.name + "(" + str + ")";
    return str;
}
/**
Instances of this class represent a match state of a node type's
[content expression](https://prosemirror.net/docs/ref/#model.NodeSpec.content), and can be used to
find out whether further content matches here, and whether a given
position is a valid end of the node.
*/ class $293d5acde922b5fe$export$364ed450558d7ec4 {
    /**
    @internal
    */ constructor(/**
    True when this match state represents a valid end of the node.
    */ validEnd){
        this.validEnd = validEnd;
        /**
        @internal
        */ this.next = [];
        /**
        @internal
        */ this.wrapCache = [];
    }
    /**
    @internal
    */ static parse(string, nodeTypes) {
        let stream = new $293d5acde922b5fe$var$TokenStream(string, nodeTypes);
        if (stream.next == null) return $293d5acde922b5fe$export$364ed450558d7ec4.empty;
        let expr = $293d5acde922b5fe$var$parseExpr(stream);
        if (stream.next) stream.err("Unexpected trailing text");
        let match = $293d5acde922b5fe$var$dfa($293d5acde922b5fe$var$nfa(expr));
        $293d5acde922b5fe$var$checkForDeadEnds(match, stream);
        return match;
    }
    /**
    Match a node type, returning a match after that node if
    successful.
    */ matchType(type) {
        for(let i = 0; i < this.next.length; i++)if (this.next[i].type == type) return this.next[i].next;
        return null;
    }
    /**
    Try to match a fragment. Returns the resulting match when
    successful.
    */ matchFragment(frag, start = 0, end = frag.childCount) {
        let cur = this;
        for(let i = start; cur && i < end; i++)cur = cur.matchType(frag.child(i).type);
        return cur;
    }
    /**
    @internal
    */ get inlineContent() {
        return this.next.length != 0 && this.next[0].type.isInline;
    }
    /**
    Get the first matching node type at this match position that can
    be generated.
    */ get defaultType() {
        for(let i = 0; i < this.next.length; i++){
            let { type: type } = this.next[i];
            if (!(type.isText || type.hasRequiredAttrs())) return type;
        }
        return null;
    }
    /**
    @internal
    */ compatible(other) {
        for(let i = 0; i < this.next.length; i++)for(let j = 0; j < other.next.length; j++)if (this.next[i].type == other.next[j].type) return true;
        return false;
    }
    /**
    Try to match the given fragment, and if that fails, see if it can
    be made to match by inserting nodes in front of it. When
    successful, return a fragment of inserted nodes (which may be
    empty if nothing had to be inserted). When `toEnd` is true, only
    return a fragment if the resulting match goes to the end of the
    content expression.
    */ fillBefore(after, toEnd = false, startIndex = 0) {
        let seen = [
            this
        ];
        function search(match, types) {
            let finished = match.matchFragment(after, startIndex);
            if (finished && (!toEnd || finished.validEnd)) return $293d5acde922b5fe$export$ffb0004e005737fa.from(types.map((tp)=>tp.createAndFill()));
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!(type.isText || type.hasRequiredAttrs()) && seen.indexOf(next) == -1) {
                    seen.push(next);
                    let found = search(next, types.concat(type));
                    if (found) return found;
                }
            }
            return null;
        }
        return search(this, []);
    }
    /**
    Find a set of wrapping node types that would allow a node of the
    given type to appear at this position. The result may be empty
    (when it fits directly) and will be null when no such wrapping
    exists.
    */ findWrapping(target) {
        for(let i = 0; i < this.wrapCache.length; i += 2)if (this.wrapCache[i] == target) return this.wrapCache[i + 1];
        let computed = this.computeWrapping(target);
        this.wrapCache.push(target, computed);
        return computed;
    }
    /**
    @internal
    */ computeWrapping(target) {
        let seen = Object.create(null), active = [
            {
                match: this,
                type: null,
                via: null
            }
        ];
        while(active.length){
            let current = active.shift(), match = current.match;
            if (match.matchType(target)) {
                let result = [];
                for(let obj = current; obj.type; obj = obj.via)result.push(obj.type);
                return result.reverse();
            }
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!type.isLeaf && !type.hasRequiredAttrs() && !(type.name in seen) && (!current.type || next.validEnd)) {
                    active.push({
                        match: type.contentMatch,
                        type: type,
                        via: current
                    });
                    seen[type.name] = true;
                }
            }
        }
        return null;
    }
    /**
    The number of outgoing edges this node has in the finite
    automaton that describes the content expression.
    */ get edgeCount() {
        return this.next.length;
    }
    /**
    Get the _n_​th outgoing edge from this node in the finite
    automaton that describes the content expression.
    */ edge(n) {
        if (n >= this.next.length) throw new RangeError(`There's no ${n}th edge in this content match`);
        return this.next[n];
    }
    /**
    @internal
    */ toString() {
        let seen = [];
        function scan(m) {
            seen.push(m);
            for(let i = 0; i < m.next.length; i++)if (seen.indexOf(m.next[i].next) == -1) scan(m.next[i].next);
        }
        scan(this);
        return seen.map((m, i)=>{
            let out = i + (m.validEnd ? "*" : " ") + " ";
            for(let i = 0; i < m.next.length; i++)out += (i ? ", " : "") + m.next[i].type.name + "->" + seen.indexOf(m.next[i].next);
            return out;
        }).join("\n");
    }
}
/**
@internal
*/ $293d5acde922b5fe$export$364ed450558d7ec4.empty = new $293d5acde922b5fe$export$364ed450558d7ec4(true);
class $293d5acde922b5fe$var$TokenStream {
    constructor(string, nodeTypes){
        this.string = string;
        this.nodeTypes = nodeTypes;
        this.inline = null;
        this.pos = 0;
        this.tokens = string.split(/\s*(?=\b|\W|$)/);
        if (this.tokens[this.tokens.length - 1] == "") this.tokens.pop();
        if (this.tokens[0] == "") this.tokens.shift();
    }
    get next() {
        return this.tokens[this.pos];
    }
    eat(tok) {
        return this.next == tok && (this.pos++ || true);
    }
    err(str) {
        throw new SyntaxError(str + " (in content expression '" + this.string + "')");
    }
}
function $293d5acde922b5fe$var$parseExpr(stream) {
    let exprs = [];
    do exprs.push($293d5acde922b5fe$var$parseExprSeq(stream));
    while (stream.eat("|"));
    return exprs.length == 1 ? exprs[0] : {
        type: "choice",
        exprs: exprs
    };
}
function $293d5acde922b5fe$var$parseExprSeq(stream) {
    let exprs = [];
    do exprs.push($293d5acde922b5fe$var$parseExprSubscript(stream));
    while (stream.next && stream.next != ")" && stream.next != "|");
    return exprs.length == 1 ? exprs[0] : {
        type: "seq",
        exprs: exprs
    };
}
function $293d5acde922b5fe$var$parseExprSubscript(stream) {
    let expr = $293d5acde922b5fe$var$parseExprAtom(stream);
    for(;;){
        if (stream.eat("+")) expr = {
            type: "plus",
            expr: expr
        };
        else if (stream.eat("*")) expr = {
            type: "star",
            expr: expr
        };
        else if (stream.eat("?")) expr = {
            type: "opt",
            expr: expr
        };
        else if (stream.eat("{")) expr = $293d5acde922b5fe$var$parseExprRange(stream, expr);
        else break;
    }
    return expr;
}
function $293d5acde922b5fe$var$parseNum(stream) {
    if (/\D/.test(stream.next)) stream.err("Expected number, got '" + stream.next + "'");
    let result = Number(stream.next);
    stream.pos++;
    return result;
}
function $293d5acde922b5fe$var$parseExprRange(stream, expr) {
    let min = $293d5acde922b5fe$var$parseNum(stream), max = min;
    if (stream.eat(",")) {
        if (stream.next != "}") max = $293d5acde922b5fe$var$parseNum(stream);
        else max = -1;
    }
    if (!stream.eat("}")) stream.err("Unclosed braced range");
    return {
        type: "range",
        min: min,
        max: max,
        expr: expr
    };
}
function $293d5acde922b5fe$var$resolveName(stream, name) {
    let types = stream.nodeTypes, type = types[name];
    if (type) return [
        type
    ];
    let result = [];
    for(let typeName in types){
        let type = types[typeName];
        if (type.isInGroup(name)) result.push(type);
    }
    if (result.length == 0) stream.err("No node type or group '" + name + "' found");
    return result;
}
function $293d5acde922b5fe$var$parseExprAtom(stream) {
    if (stream.eat("(")) {
        let expr = $293d5acde922b5fe$var$parseExpr(stream);
        if (!stream.eat(")")) stream.err("Missing closing paren");
        return expr;
    } else if (!/\W/.test(stream.next)) {
        let exprs = $293d5acde922b5fe$var$resolveName(stream, stream.next).map((type)=>{
            if (stream.inline == null) stream.inline = type.isInline;
            else if (stream.inline != type.isInline) stream.err("Mixing inline and block content");
            return {
                type: "name",
                value: type
            };
        });
        stream.pos++;
        return exprs.length == 1 ? exprs[0] : {
            type: "choice",
            exprs: exprs
        };
    } else stream.err("Unexpected token '" + stream.next + "'");
}
// Construct an NFA from an expression as returned by the parser. The
// NFA is represented as an array of states, which are themselves
// arrays of edges, which are `{term, to}` objects. The first state is
// the entry state and the last node is the success state.
//
// Note that unlike typical NFAs, the edge ordering in this one is
// significant, in that it is used to contruct filler content when
// necessary.
function $293d5acde922b5fe$var$nfa(expr) {
    let nfa = [
        []
    ];
    connect(compile(expr, 0), node());
    return nfa;
    function node() {
        return nfa.push([]) - 1;
    }
    function edge(from, to, term) {
        let edge = {
            term: term,
            to: to
        };
        nfa[from].push(edge);
        return edge;
    }
    function connect(edges, to) {
        edges.forEach((edge)=>edge.to = to);
    }
    function compile(expr, from) {
        if (expr.type == "choice") return expr.exprs.reduce((out, expr)=>out.concat(compile(expr, from)), []);
        else if (expr.type == "seq") for(let i = 0;; i++){
            let next = compile(expr.exprs[i], from);
            if (i == expr.exprs.length - 1) return next;
            connect(next, from = node());
        }
        else if (expr.type == "star") {
            let loop = node();
            edge(from, loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "plus") {
            let loop = node();
            connect(compile(expr.expr, from), loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "opt") return [
            edge(from)
        ].concat(compile(expr.expr, from));
        else if (expr.type == "range") {
            let cur = from;
            for(let i = 0; i < expr.min; i++){
                let next = node();
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            if (expr.max == -1) connect(compile(expr.expr, cur), cur);
            else for(let i = expr.min; i < expr.max; i++){
                let next = node();
                edge(cur, next);
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            return [
                edge(cur)
            ];
        } else if (expr.type == "name") return [
            edge(from, undefined, expr.value)
        ];
        else throw new Error("Unknown expr type");
    }
}
function $293d5acde922b5fe$var$cmp(a, b) {
    return b - a;
}
// Get the set of nodes reachable by null edges from `node`. Omit
// nodes with only a single null-out-edge, since they may lead to
// needless duplicated nodes.
function $293d5acde922b5fe$var$nullFrom(nfa, node) {
    let result = [];
    scan(node);
    return result.sort($293d5acde922b5fe$var$cmp);
    function scan(node) {
        let edges = nfa[node];
        if (edges.length == 1 && !edges[0].term) return scan(edges[0].to);
        result.push(node);
        for(let i = 0; i < edges.length; i++){
            let { term: term, to: to } = edges[i];
            if (!term && result.indexOf(to) == -1) scan(to);
        }
    }
}
// Compiles an NFA as produced by `nfa` into a DFA, modeled as a set
// of state objects (`ContentMatch` instances) with transitions
// between them.
function $293d5acde922b5fe$var$dfa(nfa) {
    let labeled = Object.create(null);
    return explore($293d5acde922b5fe$var$nullFrom(nfa, 0));
    function explore(states) {
        let out = [];
        states.forEach((node)=>{
            nfa[node].forEach(({ term: term, to: to })=>{
                if (!term) return;
                let set;
                for(let i = 0; i < out.length; i++)if (out[i][0] == term) set = out[i][1];
                $293d5acde922b5fe$var$nullFrom(nfa, to).forEach((node)=>{
                    if (!set) out.push([
                        term,
                        set = []
                    ]);
                    if (set.indexOf(node) == -1) set.push(node);
                });
            });
        });
        let state = labeled[states.join(",")] = new $293d5acde922b5fe$export$364ed450558d7ec4(states.indexOf(nfa.length - 1) > -1);
        for(let i = 0; i < out.length; i++){
            let states = out[i][1].sort($293d5acde922b5fe$var$cmp);
            state.next.push({
                type: out[i][0],
                next: labeled[states.join(",")] || explore(states)
            });
        }
        return state;
    }
}
function $293d5acde922b5fe$var$checkForDeadEnds(match, stream) {
    for(let i = 0, work = [
        match
    ]; i < work.length; i++){
        let state = work[i], dead = !state.validEnd, nodes = [];
        for(let j = 0; j < state.next.length; j++){
            let { type: type, next: next } = state.next[j];
            nodes.push(type.name);
            if (dead && !(type.isText || type.hasRequiredAttrs())) dead = false;
            if (work.indexOf(next) == -1) work.push(next);
        }
        if (dead) stream.err("Only non-generatable nodes (" + nodes.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
    }
}
// For node types where all attrs have a default value (or which don't
// have any attributes), build up a single reusable default attribute
// object, and use it for all nodes that don't specify specific
// attributes.
function $293d5acde922b5fe$var$defaultAttrs(attrs) {
    let defaults = Object.create(null);
    for(let attrName in attrs){
        let attr = attrs[attrName];
        if (!attr.hasDefault) return null;
        defaults[attrName] = attr.default;
    }
    return defaults;
}
function $293d5acde922b5fe$var$computeAttrs(attrs, value) {
    let built = Object.create(null);
    for(let name in attrs){
        let given = value && value[name];
        if (given === undefined) {
            let attr = attrs[name];
            if (attr.hasDefault) given = attr.default;
            else throw new RangeError("No value supplied for attribute " + name);
        }
        built[name] = given;
    }
    return built;
}
function $293d5acde922b5fe$var$checkAttrs(attrs, values, type, name) {
    for(let name in values)if (!(name in attrs)) throw new RangeError(`Unsupported attribute ${name} for ${type} of type ${name}`);
    for(let name in attrs){
        let attr = attrs[name];
        if (attr.validate) attr.validate(values[name]);
    }
}
function $293d5acde922b5fe$var$initAttrs(typeName, attrs) {
    let result = Object.create(null);
    if (attrs) for(let name in attrs)result[name] = new $293d5acde922b5fe$var$Attribute(typeName, name, attrs[name]);
    return result;
}
/**
Node types are objects allocated once per `Schema` and used to
[tag](https://prosemirror.net/docs/ref/#model.Node.type) `Node` instances. They contain information
about the node type, such as its name and what kind of node it
represents.
*/ class $293d5acde922b5fe$export$f06e977173f1857c {
    /**
    @internal
    */ constructor(/**
    The name the node type has in this schema.
    */ name, /**
    A link back to the `Schema` the node type belongs to.
    */ schema, /**
    The spec that this type is based on
    */ spec){
        this.name = name;
        this.schema = schema;
        this.spec = spec;
        /**
        The set of marks allowed in this node. `null` means all marks
        are allowed.
        */ this.markSet = null;
        this.groups = spec.group ? spec.group.split(" ") : [];
        this.attrs = $293d5acde922b5fe$var$initAttrs(name, spec.attrs);
        this.defaultAttrs = $293d5acde922b5fe$var$defaultAttrs(this.attrs);
        this.contentMatch = null;
        this.inlineContent = null;
        this.isBlock = !(spec.inline || name == "text");
        this.isText = name == "text";
    }
    /**
    True if this is an inline type.
    */ get isInline() {
        return !this.isBlock;
    }
    /**
    True if this is a textblock type, a block that contains inline
    content.
    */ get isTextblock() {
        return this.isBlock && this.inlineContent;
    }
    /**
    True for node types that allow no content.
    */ get isLeaf() {
        return this.contentMatch == $293d5acde922b5fe$export$364ed450558d7ec4.empty;
    }
    /**
    True when this node is an atom, i.e. when it does not have
    directly editable content.
    */ get isAtom() {
        return this.isLeaf || !!this.spec.atom;
    }
    /**
    Return true when this node type is part of the given
    [group](https://prosemirror.net/docs/ref/#model.NodeSpec.group).
    */ isInGroup(group) {
        return this.groups.indexOf(group) > -1;
    }
    /**
    The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
    */ get whitespace() {
        return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
    }
    /**
    Tells you whether this node type has any required attributes.
    */ hasRequiredAttrs() {
        for(let n in this.attrs)if (this.attrs[n].isRequired) return true;
        return false;
    }
    /**
    Indicates whether this node allows some of the same content as
    the given node type.
    */ compatibleContent(other) {
        return this == other || this.contentMatch.compatible(other.contentMatch);
    }
    /**
    @internal
    */ computeAttrs(attrs) {
        if (!attrs && this.defaultAttrs) return this.defaultAttrs;
        else return $293d5acde922b5fe$var$computeAttrs(this.attrs, attrs);
    }
    /**
    Create a `Node` of this type. The given attributes are
    checked and defaulted (you can pass `null` to use the type's
    defaults entirely, if no required attributes exist). `content`
    may be a `Fragment`, a node, an array of nodes, or
    `null`. Similarly `marks` may be `null` to default to the empty
    set of marks.
    */ create(attrs = null, content, marks) {
        if (this.isText) throw new Error("NodeType.create can't construct text nodes");
        return new $293d5acde922b5fe$export$85c928794f8d04d4(this, this.computeAttrs(attrs), $293d5acde922b5fe$export$ffb0004e005737fa.from(content), $293d5acde922b5fe$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
    against the node type's content restrictions, and throw an error
    if it doesn't match.
    */ createChecked(attrs = null, content, marks) {
        content = $293d5acde922b5fe$export$ffb0004e005737fa.from(content);
        this.checkContent(content);
        return new $293d5acde922b5fe$export$85c928794f8d04d4(this, this.computeAttrs(attrs), content, $293d5acde922b5fe$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
    necessary to add nodes to the start or end of the given fragment
    to make it fit the node. If no fitting wrapping can be found,
    return null. Note that, due to the fact that required nodes can
    always be created, this will always succeed if you pass null or
    `Fragment.empty` as content.
    */ createAndFill(attrs = null, content, marks) {
        attrs = this.computeAttrs(attrs);
        content = $293d5acde922b5fe$export$ffb0004e005737fa.from(content);
        if (content.size) {
            let before = this.contentMatch.fillBefore(content);
            if (!before) return null;
            content = before.append(content);
        }
        let matched = this.contentMatch.matchFragment(content);
        let after = matched && matched.fillBefore($293d5acde922b5fe$export$ffb0004e005737fa.empty, true);
        if (!after) return null;
        return new $293d5acde922b5fe$export$85c928794f8d04d4(this, attrs, content.append(after), $293d5acde922b5fe$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Returns true if the given fragment is valid content for this node
    type.
    */ validContent(content) {
        let result = this.contentMatch.matchFragment(content);
        if (!result || !result.validEnd) return false;
        for(let i = 0; i < content.childCount; i++)if (!this.allowsMarks(content.child(i).marks)) return false;
        return true;
    }
    /**
    Throws a RangeError if the given fragment is not valid content for this
    node type.
    @internal
    */ checkContent(content) {
        if (!this.validContent(content)) throw new RangeError(`Invalid content for node ${this.name}: ${content.toString().slice(0, 50)}`);
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $293d5acde922b5fe$var$checkAttrs(this.attrs, attrs, "node", this.name);
    }
    /**
    Check whether the given mark type is allowed in this node.
    */ allowsMarkType(markType) {
        return this.markSet == null || this.markSet.indexOf(markType) > -1;
    }
    /**
    Test whether the given set of marks are allowed in this node.
    */ allowsMarks(marks) {
        if (this.markSet == null) return true;
        for(let i = 0; i < marks.length; i++)if (!this.allowsMarkType(marks[i].type)) return false;
        return true;
    }
    /**
    Removes the marks that are not allowed in this node from the given set.
    */ allowedMarks(marks) {
        if (this.markSet == null) return marks;
        let copy;
        for(let i = 0; i < marks.length; i++){
            if (!this.allowsMarkType(marks[i].type)) {
                if (!copy) copy = marks.slice(0, i);
            } else if (copy) copy.push(marks[i]);
        }
        return !copy ? marks : copy.length ? copy : $293d5acde922b5fe$export$c9d15bcfc6d42044.none;
    }
    /**
    @internal
    */ static compile(nodes, schema) {
        let result = Object.create(null);
        nodes.forEach((name, spec)=>result[name] = new $293d5acde922b5fe$export$f06e977173f1857c(name, schema, spec));
        let topType = schema.spec.topNode || "doc";
        if (!result[topType]) throw new RangeError("Schema is missing its top node type ('" + topType + "')");
        if (!result.text) throw new RangeError("Every schema needs a 'text' type");
        for(let _ in result.text.attrs)throw new RangeError("The text node type should not have attributes");
        return result;
    }
}
function $293d5acde922b5fe$var$validateType(typeName, attrName, type) {
    let types = type.split("|");
    return (value)=>{
        let name = value === null ? "null" : typeof value;
        if (types.indexOf(name) < 0) throw new RangeError(`Expected value of type ${types} for attribute ${attrName} on type ${typeName}, got ${name}`);
    };
}
// Attribute descriptors
class $293d5acde922b5fe$var$Attribute {
    constructor(typeName, attrName, options){
        this.hasDefault = Object.prototype.hasOwnProperty.call(options, "default");
        this.default = options.default;
        this.validate = typeof options.validate == "string" ? $293d5acde922b5fe$var$validateType(typeName, attrName, options.validate) : options.validate;
    }
    get isRequired() {
        return !this.hasDefault;
    }
}
// Marks
/**
Like nodes, marks (which are associated with nodes to signify
things like emphasis or being part of a link) are
[tagged](https://prosemirror.net/docs/ref/#model.Mark.type) with type objects, which are
instantiated once per `Schema`.
*/ class $293d5acde922b5fe$export$b6a78689043c6521 {
    /**
    @internal
    */ constructor(/**
    The name of the mark type.
    */ name, /**
    @internal
    */ rank, /**
    The schema that this mark type instance is part of.
    */ schema, /**
    The spec on which the type is based.
    */ spec){
        this.name = name;
        this.rank = rank;
        this.schema = schema;
        this.spec = spec;
        this.attrs = $293d5acde922b5fe$var$initAttrs(name, spec.attrs);
        this.excluded = null;
        let defaults = $293d5acde922b5fe$var$defaultAttrs(this.attrs);
        this.instance = defaults ? new $293d5acde922b5fe$export$c9d15bcfc6d42044(this, defaults) : null;
    }
    /**
    Create a mark of this type. `attrs` may be `null` or an object
    containing only some of the mark's attributes. The others, if
    they have defaults, will be added.
    */ create(attrs = null) {
        if (!attrs && this.instance) return this.instance;
        return new $293d5acde922b5fe$export$c9d15bcfc6d42044(this, $293d5acde922b5fe$var$computeAttrs(this.attrs, attrs));
    }
    /**
    @internal
    */ static compile(marks, schema) {
        let result = Object.create(null), rank = 0;
        marks.forEach((name, spec)=>result[name] = new $293d5acde922b5fe$export$b6a78689043c6521(name, rank++, schema, spec));
        return result;
    }
    /**
    When there is a mark of this type in the given set, a new set
    without it is returned. Otherwise, the input set is returned.
    */ removeFromSet(set) {
        for(var i = 0; i < set.length; i++)if (set[i].type == this) {
            set = set.slice(0, i).concat(set.slice(i + 1));
            i--;
        }
        return set;
    }
    /**
    Tests whether there is a mark of this type in the given set.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (set[i].type == this) return set[i];
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $293d5acde922b5fe$var$checkAttrs(this.attrs, attrs, "mark", this.name);
    }
    /**
    Queries whether a given mark type is
    [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
    */ excludes(other) {
        return this.excluded.indexOf(other) > -1;
    }
}
/**
A document schema. Holds [node](https://prosemirror.net/docs/ref/#model.NodeType) and [mark
type](https://prosemirror.net/docs/ref/#model.MarkType) objects for the nodes and marks that may
occur in conforming documents, and provides functionality for
creating and deserializing such documents.

When given, the type parameters provide the names of the nodes and
marks in this schema.
*/ class $293d5acde922b5fe$export$19342e026b58ebb7 {
    /**
    Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
    */ constructor(spec){
        /**
        The [linebreak
        replacement](https://prosemirror.net/docs/ref/#model.NodeSpec.linebreakReplacement) node defined
        in this schema, if any.
        */ this.linebreakReplacement = null;
        /**
        An object for storing whatever values modules may want to
        compute and cache per schema. (If you want to store something
        in it, try to use property names unlikely to clash.)
        */ this.cached = Object.create(null);
        let instanceSpec = this.spec = {};
        for(let prop in spec)instanceSpec[prop] = spec[prop];
        instanceSpec.nodes = (0, $b22x6.default).from(spec.nodes), instanceSpec.marks = (0, $b22x6.default).from(spec.marks || {}), this.nodes = $293d5acde922b5fe$export$f06e977173f1857c.compile(this.spec.nodes, this);
        this.marks = $293d5acde922b5fe$export$b6a78689043c6521.compile(this.spec.marks, this);
        let contentExprCache = Object.create(null);
        for(let prop in this.nodes){
            if (prop in this.marks) throw new RangeError(prop + " can not be both a node and a mark");
            let type = this.nodes[prop], contentExpr = type.spec.content || "", markExpr = type.spec.marks;
            type.contentMatch = contentExprCache[contentExpr] || (contentExprCache[contentExpr] = $293d5acde922b5fe$export$364ed450558d7ec4.parse(contentExpr, this.nodes));
            type.inlineContent = type.contentMatch.inlineContent;
            if (type.spec.linebreakReplacement) {
                if (this.linebreakReplacement) throw new RangeError("Multiple linebreak nodes defined");
                if (!type.isInline || !type.isLeaf) throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
                this.linebreakReplacement = type;
            }
            type.markSet = markExpr == "_" ? null : markExpr ? $293d5acde922b5fe$var$gatherMarks(this, markExpr.split(" ")) : markExpr == "" || !type.inlineContent ? [] : null;
        }
        for(let prop in this.marks){
            let type = this.marks[prop], excl = type.spec.excludes;
            type.excluded = excl == null ? [
                type
            ] : excl == "" ? [] : $293d5acde922b5fe$var$gatherMarks(this, excl.split(" "));
        }
        this.nodeFromJSON = this.nodeFromJSON.bind(this);
        this.markFromJSON = this.markFromJSON.bind(this);
        this.topNodeType = this.nodes[this.spec.topNode || "doc"];
        this.cached.wrappings = Object.create(null);
    }
    /**
    Create a node in this schema. The `type` may be a string or a
    `NodeType` instance. Attributes will be extended with defaults,
    `content` may be a `Fragment`, `null`, a `Node`, or an array of
    nodes.
    */ node(type, attrs = null, content, marks) {
        if (typeof type == "string") type = this.nodeType(type);
        else if (!(type instanceof $293d5acde922b5fe$export$f06e977173f1857c)) throw new RangeError("Invalid node type: " + type);
        else if (type.schema != this) throw new RangeError("Node type from different schema used (" + type.name + ")");
        return type.createChecked(attrs, content, marks);
    }
    /**
    Create a text node in the schema. Empty text nodes are not
    allowed.
    */ text(text, marks) {
        let type = this.nodes.text;
        return new $293d5acde922b5fe$var$TextNode(type, type.defaultAttrs, text, $293d5acde922b5fe$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Create a mark with the given type and attributes.
    */ mark(type, attrs) {
        if (typeof type == "string") type = this.marks[type];
        return type.create(attrs);
    }
    /**
    Deserialize a node from its JSON representation. This method is
    bound.
    */ nodeFromJSON(json) {
        return $293d5acde922b5fe$export$85c928794f8d04d4.fromJSON(this, json);
    }
    /**
    Deserialize a mark from its JSON representation. This method is
    bound.
    */ markFromJSON(json) {
        return $293d5acde922b5fe$export$c9d15bcfc6d42044.fromJSON(this, json);
    }
    /**
    @internal
    */ nodeType(name) {
        let found = this.nodes[name];
        if (!found) throw new RangeError("Unknown node type: " + name);
        return found;
    }
}
function $293d5acde922b5fe$var$gatherMarks(schema, marks) {
    let found = [];
    for(let i = 0; i < marks.length; i++){
        let name = marks[i], mark = schema.marks[name], ok = mark;
        if (mark) found.push(mark);
        else for(let prop in schema.marks){
            let mark = schema.marks[prop];
            if (name == "_" || mark.spec.group && mark.spec.group.split(" ").indexOf(name) > -1) found.push(ok = mark);
        }
        if (!ok) throw new SyntaxError("Unknown mark type: '" + marks[i] + "'");
    }
    return found;
}
function $293d5acde922b5fe$var$isTagRule(rule) {
    return rule.tag != null;
}
function $293d5acde922b5fe$var$isStyleRule(rule) {
    return rule.style != null;
}
/**
A DOM parser represents a strategy for parsing DOM content into a
ProseMirror document conforming to a given schema. Its behavior is
defined by an array of [rules](https://prosemirror.net/docs/ref/#model.ParseRule).
*/ class $293d5acde922b5fe$export$1059c6e7d2ce5669 {
    /**
    Create a parser that targets the given schema, using the given
    parsing rules.
    */ constructor(/**
    The schema into which the parser parses.
    */ schema, /**
    The set of [parse rules](https://prosemirror.net/docs/ref/#model.ParseRule) that the parser
    uses, in order of precedence.
    */ rules){
        this.schema = schema;
        this.rules = rules;
        /**
        @internal
        */ this.tags = [];
        /**
        @internal
        */ this.styles = [];
        let matchedStyles = this.matchedStyles = [];
        rules.forEach((rule)=>{
            if ($293d5acde922b5fe$var$isTagRule(rule)) this.tags.push(rule);
            else if ($293d5acde922b5fe$var$isStyleRule(rule)) {
                let prop = /[^=]*/.exec(rule.style)[0];
                if (matchedStyles.indexOf(prop) < 0) matchedStyles.push(prop);
                this.styles.push(rule);
            }
        });
        // Only normalize list elements when lists in the schema can't directly contain themselves
        this.normalizeLists = !this.tags.some((r)=>{
            if (!/^(ul|ol)\b/.test(r.tag) || !r.node) return false;
            let node = schema.nodes[r.node];
            return node.contentMatch.matchType(node);
        });
    }
    /**
    Parse a document from the content of a DOM node.
    */ parse(dom, options = {}) {
        let context = new $293d5acde922b5fe$var$ParseContext(this, options, false);
        context.addAll(dom, $293d5acde922b5fe$export$c9d15bcfc6d42044.none, options.from, options.to);
        return context.finish();
    }
    /**
    Parses the content of the given DOM node, like
    [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
    options. But unlike that method, which produces a whole node,
    this one returns a slice that is open at the sides, meaning that
    the schema constraints aren't applied to the start of nodes to
    the left of the input and the end of nodes at the end.
    */ parseSlice(dom, options = {}) {
        let context = new $293d5acde922b5fe$var$ParseContext(this, options, true);
        context.addAll(dom, $293d5acde922b5fe$export$c9d15bcfc6d42044.none, options.from, options.to);
        return $293d5acde922b5fe$export$b3f2e2de3a8baa1e.maxOpen(context.finish());
    }
    /**
    @internal
    */ matchTag(dom, context, after) {
        for(let i = after ? this.tags.indexOf(after) + 1 : 0; i < this.tags.length; i++){
            let rule = this.tags[i];
            if ($293d5acde922b5fe$var$matches(dom, rule.tag) && (rule.namespace === undefined || dom.namespaceURI == rule.namespace) && (!rule.context || context.matchesContext(rule.context))) {
                if (rule.getAttrs) {
                    let result = rule.getAttrs(dom);
                    if (result === false) continue;
                    rule.attrs = result || undefined;
                }
                return rule;
            }
        }
    }
    /**
    @internal
    */ matchStyle(prop, value, context, after) {
        for(let i = after ? this.styles.indexOf(after) + 1 : 0; i < this.styles.length; i++){
            let rule = this.styles[i], style = rule.style;
            if (style.indexOf(prop) != 0 || rule.context && !context.matchesContext(rule.context) || // Test that the style string either precisely matches the prop,
            // or has an '=' sign after the prop, followed by the given
            // value.
            style.length > prop.length && (style.charCodeAt(prop.length) != 61 || style.slice(prop.length + 1) != value)) continue;
            if (rule.getAttrs) {
                let result = rule.getAttrs(value);
                if (result === false) continue;
                rule.attrs = result || undefined;
            }
            return rule;
        }
    }
    /**
    @internal
    */ static schemaRules(schema) {
        let result = [];
        function insert(rule) {
            let priority = rule.priority == null ? 50 : rule.priority, i = 0;
            for(; i < result.length; i++){
                let next = result[i], nextPriority = next.priority == null ? 50 : next.priority;
                if (nextPriority < priority) break;
            }
            result.splice(i, 0, rule);
        }
        for(let name in schema.marks){
            let rules = schema.marks[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $293d5acde922b5fe$var$copy(rule));
                if (!(rule.mark || rule.ignore || rule.clearMark)) rule.mark = name;
            });
        }
        for(let name in schema.nodes){
            let rules = schema.nodes[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $293d5acde922b5fe$var$copy(rule));
                if (!(rule.node || rule.ignore || rule.mark)) rule.node = name;
            });
        }
        return result;
    }
    /**
    Construct a DOM parser using the parsing rules listed in a
    schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
    [priority](https://prosemirror.net/docs/ref/#model.ParseRule.priority).
    */ static fromSchema(schema) {
        return schema.cached.domParser || (schema.cached.domParser = new $293d5acde922b5fe$export$1059c6e7d2ce5669(schema, $293d5acde922b5fe$export$1059c6e7d2ce5669.schemaRules(schema)));
    }
}
const $293d5acde922b5fe$var$blockTags = {
    address: true,
    article: true,
    aside: true,
    blockquote: true,
    canvas: true,
    dd: true,
    div: true,
    dl: true,
    fieldset: true,
    figcaption: true,
    figure: true,
    footer: true,
    form: true,
    h1: true,
    h2: true,
    h3: true,
    h4: true,
    h5: true,
    h6: true,
    header: true,
    hgroup: true,
    hr: true,
    li: true,
    noscript: true,
    ol: true,
    output: true,
    p: true,
    pre: true,
    section: true,
    table: true,
    tfoot: true,
    ul: true
};
const $293d5acde922b5fe$var$ignoreTags = {
    head: true,
    noscript: true,
    object: true,
    script: true,
    style: true,
    title: true
};
const $293d5acde922b5fe$var$listTags = {
    ol: true,
    ul: true
};
// Using a bitfield for node context options
const $293d5acde922b5fe$var$OPT_PRESERVE_WS = 1, $293d5acde922b5fe$var$OPT_PRESERVE_WS_FULL = 2, $293d5acde922b5fe$var$OPT_OPEN_LEFT = 4;
function $293d5acde922b5fe$var$wsOptionsFor(type, preserveWhitespace, base) {
    if (preserveWhitespace != null) return (preserveWhitespace ? $293d5acde922b5fe$var$OPT_PRESERVE_WS : 0) | (preserveWhitespace === "full" ? $293d5acde922b5fe$var$OPT_PRESERVE_WS_FULL : 0);
    return type && type.whitespace == "pre" ? $293d5acde922b5fe$var$OPT_PRESERVE_WS | $293d5acde922b5fe$var$OPT_PRESERVE_WS_FULL : base & ~$293d5acde922b5fe$var$OPT_OPEN_LEFT;
}
class $293d5acde922b5fe$var$NodeContext {
    constructor(type, attrs, marks, solid, match, options){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.solid = solid;
        this.options = options;
        this.content = [];
        // Marks applied to the node's children
        this.activeMarks = $293d5acde922b5fe$export$c9d15bcfc6d42044.none;
        this.match = match || (options & $293d5acde922b5fe$var$OPT_OPEN_LEFT ? null : type.contentMatch);
    }
    findWrapping(node) {
        if (!this.match) {
            if (!this.type) return [];
            let fill = this.type.contentMatch.fillBefore($293d5acde922b5fe$export$ffb0004e005737fa.from(node));
            if (fill) this.match = this.type.contentMatch.matchFragment(fill);
            else {
                let start = this.type.contentMatch, wrap;
                if (wrap = start.findWrapping(node.type)) {
                    this.match = start;
                    return wrap;
                } else return null;
            }
        }
        return this.match.findWrapping(node.type);
    }
    finish(openEnd) {
        if (!(this.options & $293d5acde922b5fe$var$OPT_PRESERVE_WS)) {
            let last = this.content[this.content.length - 1], m;
            if (last && last.isText && (m = /[ \t\r\n\u000c]+$/.exec(last.text))) {
                let text = last;
                if (last.text.length == m[0].length) this.content.pop();
                else this.content[this.content.length - 1] = text.withText(text.text.slice(0, text.text.length - m[0].length));
            }
        }
        let content = $293d5acde922b5fe$export$ffb0004e005737fa.from(this.content);
        if (!openEnd && this.match) content = content.append(this.match.fillBefore($293d5acde922b5fe$export$ffb0004e005737fa.empty, true));
        return this.type ? this.type.create(this.attrs, content, this.marks) : content;
    }
    inlineContext(node) {
        if (this.type) return this.type.inlineContent;
        if (this.content.length) return this.content[0].isInline;
        return node.parentNode && !$293d5acde922b5fe$var$blockTags.hasOwnProperty(node.parentNode.nodeName.toLowerCase());
    }
}
class $293d5acde922b5fe$var$ParseContext {
    constructor(// The parser we are using.
    parser, // The options passed to this parse.
    options, isOpen){
        this.parser = parser;
        this.options = options;
        this.isOpen = isOpen;
        this.open = 0;
        this.localPreserveWS = false;
        let topNode = options.topNode, topContext;
        let topOptions = $293d5acde922b5fe$var$wsOptionsFor(null, options.preserveWhitespace, 0) | (isOpen ? $293d5acde922b5fe$var$OPT_OPEN_LEFT : 0);
        if (topNode) topContext = new $293d5acde922b5fe$var$NodeContext(topNode.type, topNode.attrs, $293d5acde922b5fe$export$c9d15bcfc6d42044.none, true, options.topMatch || topNode.type.contentMatch, topOptions);
        else if (isOpen) topContext = new $293d5acde922b5fe$var$NodeContext(null, null, $293d5acde922b5fe$export$c9d15bcfc6d42044.none, true, null, topOptions);
        else topContext = new $293d5acde922b5fe$var$NodeContext(parser.schema.topNodeType, null, $293d5acde922b5fe$export$c9d15bcfc6d42044.none, true, null, topOptions);
        this.nodes = [
            topContext
        ];
        this.find = options.findPositions;
        this.needsBlock = false;
    }
    get top() {
        return this.nodes[this.open];
    }
    // Add a DOM node to the content. Text is inserted as text node,
    // otherwise, the node is passed to `addElement` or, if it has a
    // `style` attribute, `addElementWithStyles`.
    addDOM(dom, marks) {
        if (dom.nodeType == 3) this.addTextNode(dom, marks);
        else if (dom.nodeType == 1) this.addElement(dom, marks);
    }
    addTextNode(dom, marks) {
        let value = dom.nodeValue;
        let top = this.top, preserveWS = top.options & $293d5acde922b5fe$var$OPT_PRESERVE_WS_FULL ? "full" : this.localPreserveWS || (top.options & $293d5acde922b5fe$var$OPT_PRESERVE_WS) > 0;
        if (preserveWS === "full" || top.inlineContext(dom) || /[^ \t\r\n\u000c]/.test(value)) {
            if (!preserveWS) {
                value = value.replace(/[ \t\r\n\u000c]+/g, " ");
                // If this starts with whitespace, and there is no node before it, or
                // a hard break, or a text node that ends with whitespace, strip the
                // leading space.
                if (/^[ \t\r\n\u000c]/.test(value) && this.open == this.nodes.length - 1) {
                    let nodeBefore = top.content[top.content.length - 1];
                    let domNodeBefore = dom.previousSibling;
                    if (!nodeBefore || domNodeBefore && domNodeBefore.nodeName == 'BR' || nodeBefore.isText && /[ \t\r\n\u000c]$/.test(nodeBefore.text)) value = value.slice(1);
                }
            } else if (preserveWS !== "full") value = value.replace(/\r?\n|\r/g, " ");
            else value = value.replace(/\r\n?/g, "\n");
            if (value) this.insertNode(this.parser.schema.text(value), marks);
            this.findInText(dom);
        } else this.findInside(dom);
    }
    // Try to find a handler for the given tag and use that to parse. If
    // none is found, the element's content nodes are added directly.
    addElement(dom, marks, matchAfter) {
        let outerWS = this.localPreserveWS, top = this.top;
        if (dom.tagName == "PRE" || /pre/.test(dom.style && dom.style.whiteSpace)) this.localPreserveWS = true;
        let name = dom.nodeName.toLowerCase(), ruleID;
        if ($293d5acde922b5fe$var$listTags.hasOwnProperty(name) && this.parser.normalizeLists) $293d5acde922b5fe$var$normalizeList(dom);
        let rule = this.options.ruleFromNode && this.options.ruleFromNode(dom) || (ruleID = this.parser.matchTag(dom, this, matchAfter));
        out: if (rule ? rule.ignore : $293d5acde922b5fe$var$ignoreTags.hasOwnProperty(name)) {
            this.findInside(dom);
            this.ignoreFallback(dom, marks);
        } else if (!rule || rule.skip || rule.closeParent) {
            if (rule && rule.closeParent) this.open = Math.max(0, this.open - 1);
            else if (rule && rule.skip.nodeType) dom = rule.skip;
            let sync, oldNeedsBlock = this.needsBlock;
            if ($293d5acde922b5fe$var$blockTags.hasOwnProperty(name)) {
                if (top.content.length && top.content[0].isInline && this.open) {
                    this.open--;
                    top = this.top;
                }
                sync = true;
                if (!top.type) this.needsBlock = true;
            } else if (!dom.firstChild) {
                this.leafFallback(dom, marks);
                break out;
            }
            let innerMarks = rule && rule.skip ? marks : this.readStyles(dom, marks);
            if (innerMarks) this.addAll(dom, innerMarks);
            if (sync) this.sync(top);
            this.needsBlock = oldNeedsBlock;
        } else {
            let innerMarks = this.readStyles(dom, marks);
            if (innerMarks) this.addElementByRule(dom, rule, innerMarks, rule.consuming === false ? ruleID : undefined);
        }
        this.localPreserveWS = outerWS;
    }
    // Called for leaf DOM nodes that would otherwise be ignored
    leafFallback(dom, marks) {
        if (dom.nodeName == "BR" && this.top.type && this.top.type.inlineContent) this.addTextNode(dom.ownerDocument.createTextNode("\n"), marks);
    }
    // Called for ignored nodes
    ignoreFallback(dom, marks) {
        // Ignored BR nodes should at least create an inline context
        if (dom.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent)) this.findPlace(this.parser.schema.text("-"), marks);
    }
    // Run any style parser associated with the node's styles. Either
    // return an updated array of marks, or null to indicate some of the
    // styles had a rule with `ignore` set.
    readStyles(dom, marks) {
        let styles = dom.style;
        // Because many properties will only show up in 'normalized' form
        // in `style.item` (i.e. text-decoration becomes
        // text-decoration-line, text-decoration-color, etc), we directly
        // query the styles mentioned in our rules instead of iterating
        // over the items.
        if (styles && styles.length) for(let i = 0; i < this.parser.matchedStyles.length; i++){
            let name = this.parser.matchedStyles[i], value = styles.getPropertyValue(name);
            if (value) for(let after = undefined;;){
                let rule = this.parser.matchStyle(name, value, this, after);
                if (!rule) break;
                if (rule.ignore) return null;
                if (rule.clearMark) marks = marks.filter((m)=>!rule.clearMark(m));
                else marks = marks.concat(this.parser.schema.marks[rule.mark].create(rule.attrs));
                if (rule.consuming === false) after = rule;
                else break;
            }
        }
        return marks;
    }
    // Look up a handler for the given node. If none are found, return
    // false. Otherwise, apply it, use its return value to drive the way
    // the node's content is wrapped, and return true.
    addElementByRule(dom, rule, marks, continueAfter) {
        let sync, nodeType;
        if (rule.node) {
            nodeType = this.parser.schema.nodes[rule.node];
            if (!nodeType.isLeaf) {
                let inner = this.enter(nodeType, rule.attrs || null, marks, rule.preserveWhitespace);
                if (inner) {
                    sync = true;
                    marks = inner;
                }
            } else if (!this.insertNode(nodeType.create(rule.attrs), marks)) this.leafFallback(dom, marks);
        } else {
            let markType = this.parser.schema.marks[rule.mark];
            marks = marks.concat(markType.create(rule.attrs));
        }
        let startIn = this.top;
        if (nodeType && nodeType.isLeaf) this.findInside(dom);
        else if (continueAfter) this.addElement(dom, marks, continueAfter);
        else if (rule.getContent) {
            this.findInside(dom);
            rule.getContent(dom, this.parser.schema).forEach((node)=>this.insertNode(node, marks));
        } else {
            let contentDOM = dom;
            if (typeof rule.contentElement == "string") contentDOM = dom.querySelector(rule.contentElement);
            else if (typeof rule.contentElement == "function") contentDOM = rule.contentElement(dom);
            else if (rule.contentElement) contentDOM = rule.contentElement;
            this.findAround(dom, contentDOM, true);
            this.addAll(contentDOM, marks);
            this.findAround(dom, contentDOM, false);
        }
        if (sync && this.sync(startIn)) this.open--;
    }
    // Add all child nodes between `startIndex` and `endIndex` (or the
    // whole node, if not given). If `sync` is passed, use it to
    // synchronize after every block element.
    addAll(parent, marks, startIndex, endIndex) {
        let index = startIndex || 0;
        for(let dom = startIndex ? parent.childNodes[startIndex] : parent.firstChild, end = endIndex == null ? null : parent.childNodes[endIndex]; dom != end; dom = dom.nextSibling, ++index){
            this.findAtPoint(parent, index);
            this.addDOM(dom, marks);
        }
        this.findAtPoint(parent, index);
    }
    // Try to find a way to fit the given node type into the current
    // context. May add intermediate wrappers and/or leave non-solid
    // nodes that we're in.
    findPlace(node, marks) {
        let route, sync;
        for(let depth = this.open; depth >= 0; depth--){
            let cx = this.nodes[depth];
            let found = cx.findWrapping(node);
            if (found && (!route || route.length > found.length)) {
                route = found;
                sync = cx;
                if (!found.length) break;
            }
            if (cx.solid) break;
        }
        if (!route) return null;
        this.sync(sync);
        for(let i = 0; i < route.length; i++)marks = this.enterInner(route[i], null, marks, false);
        return marks;
    }
    // Try to insert the given node, adjusting the context when needed.
    insertNode(node, marks) {
        if (node.isInline && this.needsBlock && !this.top.type) {
            let block = this.textblockFromContext();
            if (block) marks = this.enterInner(block, null, marks);
        }
        let innerMarks = this.findPlace(node, marks);
        if (innerMarks) {
            this.closeExtra();
            let top = this.top;
            if (top.match) top.match = top.match.matchType(node.type);
            let nodeMarks = $293d5acde922b5fe$export$c9d15bcfc6d42044.none;
            for (let m of innerMarks.concat(node.marks))if (top.type ? top.type.allowsMarkType(m.type) : $293d5acde922b5fe$var$markMayApply(m.type, node.type)) nodeMarks = m.addToSet(nodeMarks);
            top.content.push(node.mark(nodeMarks));
            return true;
        }
        return false;
    }
    // Try to start a node of the given type, adjusting the context when
    // necessary.
    enter(type, attrs, marks, preserveWS) {
        let innerMarks = this.findPlace(type.create(attrs), marks);
        if (innerMarks) innerMarks = this.enterInner(type, attrs, marks, true, preserveWS);
        return innerMarks;
    }
    // Open a node of the given type
    enterInner(type, attrs, marks, solid = false, preserveWS) {
        this.closeExtra();
        let top = this.top;
        top.match = top.match && top.match.matchType(type);
        let options = $293d5acde922b5fe$var$wsOptionsFor(type, preserveWS, top.options);
        if (top.options & $293d5acde922b5fe$var$OPT_OPEN_LEFT && top.content.length == 0) options |= $293d5acde922b5fe$var$OPT_OPEN_LEFT;
        let applyMarks = $293d5acde922b5fe$export$c9d15bcfc6d42044.none;
        marks = marks.filter((m)=>{
            if (top.type ? top.type.allowsMarkType(m.type) : $293d5acde922b5fe$var$markMayApply(m.type, type)) {
                applyMarks = m.addToSet(applyMarks);
                return false;
            }
            return true;
        });
        this.nodes.push(new $293d5acde922b5fe$var$NodeContext(type, attrs, applyMarks, solid, null, options));
        this.open++;
        return marks;
    }
    // Make sure all nodes above this.open are finished and added to
    // their parents
    closeExtra(openEnd = false) {
        let i = this.nodes.length - 1;
        if (i > this.open) {
            for(; i > this.open; i--)this.nodes[i - 1].content.push(this.nodes[i].finish(openEnd));
            this.nodes.length = this.open + 1;
        }
    }
    finish() {
        this.open = 0;
        this.closeExtra(this.isOpen);
        return this.nodes[0].finish(!!(this.isOpen || this.options.topOpen));
    }
    sync(to) {
        for(let i = this.open; i >= 0; i--){
            if (this.nodes[i] == to) {
                this.open = i;
                return true;
            } else if (this.localPreserveWS) this.nodes[i].options |= $293d5acde922b5fe$var$OPT_PRESERVE_WS;
        }
        return false;
    }
    get currentPos() {
        this.closeExtra();
        let pos = 0;
        for(let i = this.open; i >= 0; i--){
            let content = this.nodes[i].content;
            for(let j = content.length - 1; j >= 0; j--)pos += content[j].nodeSize;
            if (i) pos++;
        }
        return pos;
    }
    findAtPoint(parent, offset) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == parent && this.find[i].offset == offset) this.find[i].pos = this.currentPos;
        }
    }
    findInside(parent) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) this.find[i].pos = this.currentPos;
        }
    }
    findAround(parent, content, before) {
        if (parent != content && this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) {
                let pos = content.compareDocumentPosition(this.find[i].node);
                if (pos & (before ? 2 : 4)) this.find[i].pos = this.currentPos;
            }
        }
    }
    findInText(textNode) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == textNode) this.find[i].pos = this.currentPos - (textNode.nodeValue.length - this.find[i].offset);
        }
    }
    // Determines whether the given context string matches this context.
    matchesContext(context) {
        if (context.indexOf("|") > -1) return context.split(/\s*\|\s*/).some(this.matchesContext, this);
        let parts = context.split("/");
        let option = this.options.context;
        let useRoot = !this.isOpen && (!option || option.parent.type == this.nodes[0].type);
        let minDepth = -(option ? option.depth + 1 : 0) + (useRoot ? 0 : 1);
        let match = (i, depth)=>{
            for(; i >= 0; i--){
                let part = parts[i];
                if (part == "") {
                    if (i == parts.length - 1 || i == 0) continue;
                    for(; depth >= minDepth; depth--)if (match(i - 1, depth)) return true;
                    return false;
                } else {
                    let next = depth > 0 || depth == 0 && useRoot ? this.nodes[depth].type : option && depth >= minDepth ? option.node(depth - minDepth).type : null;
                    if (!next || next.name != part && !next.isInGroup(part)) return false;
                    depth--;
                }
            }
            return true;
        };
        return match(parts.length - 1, this.open);
    }
    textblockFromContext() {
        let $context = this.options.context;
        if ($context) for(let d = $context.depth; d >= 0; d--){
            let deflt = $context.node(d).contentMatchAt($context.indexAfter(d)).defaultType;
            if (deflt && deflt.isTextblock && deflt.defaultAttrs) return deflt;
        }
        for(let name in this.parser.schema.nodes){
            let type = this.parser.schema.nodes[name];
            if (type.isTextblock && type.defaultAttrs) return type;
        }
    }
}
// Kludge to work around directly nested list nodes produced by some
// tools and allowed by browsers to mean that the nested list is
// actually part of the list item above it.
function $293d5acde922b5fe$var$normalizeList(dom) {
    for(let child = dom.firstChild, prevItem = null; child; child = child.nextSibling){
        let name = child.nodeType == 1 ? child.nodeName.toLowerCase() : null;
        if (name && $293d5acde922b5fe$var$listTags.hasOwnProperty(name) && prevItem) {
            prevItem.appendChild(child);
            child = prevItem;
        } else if (name == "li") prevItem = child;
        else if (name) prevItem = null;
    }
}
// Apply a CSS selector.
function $293d5acde922b5fe$var$matches(dom, selector) {
    return (dom.matches || dom.msMatchesSelector || dom.webkitMatchesSelector || dom.mozMatchesSelector).call(dom, selector);
}
function $293d5acde922b5fe$var$copy(obj) {
    let copy = {};
    for(let prop in obj)copy[prop] = obj[prop];
    return copy;
}
// Used when finding a mark at the top level of a fragment parse.
// Checks whether it would be reasonable to apply a given mark type to
// a given node, by looking at the way the mark occurs in the schema.
function $293d5acde922b5fe$var$markMayApply(markType, nodeType) {
    let nodes = nodeType.schema.nodes;
    for(let name in nodes){
        let parent = nodes[name];
        if (!parent.allowsMarkType(markType)) continue;
        let seen = [], scan = (match)=>{
            seen.push(match);
            for(let i = 0; i < match.edgeCount; i++){
                let { type: type, next: next } = match.edge(i);
                if (type == nodeType) return true;
                if (seen.indexOf(next) < 0 && scan(next)) return true;
            }
        };
        if (scan(parent.contentMatch)) return true;
    }
}
/**
A DOM serializer knows how to convert ProseMirror nodes and
marks of various types to DOM nodes.
*/ class $293d5acde922b5fe$export$3476b78f8f5a8b72 {
    /**
    Create a serializer. `nodes` should map node names to functions
    that take a node and return a description of the corresponding
    DOM. `marks` does the same for mark names, but also gets an
    argument that tells it whether the mark's content is block or
    inline content (for typical use, it'll always be inline). A mark
    serializer may be `null` to indicate that marks of that type
    should not be serialized.
    */ constructor(/**
    The node serialization functions.
    */ nodes, /**
    The mark serialization functions.
    */ marks){
        this.nodes = nodes;
        this.marks = marks;
    }
    /**
    Serialize the content of this fragment to a DOM fragment. When
    not in the browser, the `document` option, containing a DOM
    document, should be passed so that the serializer can create
    nodes.
    */ serializeFragment(fragment, options = {}, target) {
        if (!target) target = $293d5acde922b5fe$var$doc(options).createDocumentFragment();
        let top = target, active = [];
        fragment.forEach((node)=>{
            if (active.length || node.marks.length) {
                let keep = 0, rendered = 0;
                while(keep < active.length && rendered < node.marks.length){
                    let next = node.marks[rendered];
                    if (!this.marks[next.type.name]) {
                        rendered++;
                        continue;
                    }
                    if (!next.eq(active[keep][0]) || next.type.spec.spanning === false) break;
                    keep++;
                    rendered++;
                }
                while(keep < active.length)top = active.pop()[1];
                while(rendered < node.marks.length){
                    let add = node.marks[rendered++];
                    let markDOM = this.serializeMark(add, node.isInline, options);
                    if (markDOM) {
                        active.push([
                            add,
                            top
                        ]);
                        top.appendChild(markDOM.dom);
                        top = markDOM.contentDOM || markDOM.dom;
                    }
                }
            }
            top.appendChild(this.serializeNodeInner(node, options));
        });
        return target;
    }
    /**
    @internal
    */ serializeNodeInner(node, options) {
        let { dom: dom, contentDOM: contentDOM } = $293d5acde922b5fe$var$renderSpec($293d5acde922b5fe$var$doc(options), this.nodes[node.type.name](node), null, node.attrs);
        if (contentDOM) {
            if (node.isLeaf) throw new RangeError("Content hole not allowed in a leaf node spec");
            this.serializeFragment(node.content, options, contentDOM);
        }
        return dom;
    }
    /**
    Serialize this node to a DOM node. This can be useful when you
    need to serialize a part of a document, as opposed to the whole
    document. To serialize a whole document, use
    [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
    its [content](https://prosemirror.net/docs/ref/#model.Node.content).
    */ serializeNode(node, options = {}) {
        let dom = this.serializeNodeInner(node, options);
        for(let i = node.marks.length - 1; i >= 0; i--){
            let wrap = this.serializeMark(node.marks[i], node.isInline, options);
            if (wrap) {
                (wrap.contentDOM || wrap.dom).appendChild(dom);
                dom = wrap.dom;
            }
        }
        return dom;
    }
    /**
    @internal
    */ serializeMark(mark, inline, options = {}) {
        let toDOM = this.marks[mark.type.name];
        return toDOM && $293d5acde922b5fe$var$renderSpec($293d5acde922b5fe$var$doc(options), toDOM(mark, inline), null, mark.attrs);
    }
    static renderSpec(doc, structure, xmlNS = null, blockArraysIn) {
        return $293d5acde922b5fe$var$renderSpec(doc, structure, xmlNS, blockArraysIn);
    }
    /**
    Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
    properties in a schema's node and mark specs.
    */ static fromSchema(schema) {
        return schema.cached.domSerializer || (schema.cached.domSerializer = new $293d5acde922b5fe$export$3476b78f8f5a8b72(this.nodesFromSchema(schema), this.marksFromSchema(schema)));
    }
    /**
    Gather the serializers in a schema's node specs into an object.
    This can be useful as a base to build a custom serializer from.
    */ static nodesFromSchema(schema) {
        let result = $293d5acde922b5fe$var$gatherToDOM(schema.nodes);
        if (!result.text) result.text = (node)=>node.text;
        return result;
    }
    /**
    Gather the serializers in a schema's mark specs into an object.
    */ static marksFromSchema(schema) {
        return $293d5acde922b5fe$var$gatherToDOM(schema.marks);
    }
}
function $293d5acde922b5fe$var$gatherToDOM(obj) {
    let result = {};
    for(let name in obj){
        let toDOM = obj[name].spec.toDOM;
        if (toDOM) result[name] = toDOM;
    }
    return result;
}
function $293d5acde922b5fe$var$doc(options) {
    return options.document || window.document;
}
const $293d5acde922b5fe$var$suspiciousAttributeCache = new WeakMap();
function $293d5acde922b5fe$var$suspiciousAttributes(attrs) {
    let value = $293d5acde922b5fe$var$suspiciousAttributeCache.get(attrs);
    if (value === undefined) $293d5acde922b5fe$var$suspiciousAttributeCache.set(attrs, value = $293d5acde922b5fe$var$suspiciousAttributesInner(attrs));
    return value;
}
function $293d5acde922b5fe$var$suspiciousAttributesInner(attrs) {
    let result = null;
    function scan(value) {
        if (value && typeof value == "object") {
            if (Array.isArray(value)) {
                if (typeof value[0] == "string") {
                    if (!result) result = [];
                    result.push(value);
                } else for(let i = 0; i < value.length; i++)scan(value[i]);
            } else for(let prop in value)scan(value[prop]);
        }
    }
    scan(attrs);
    return result;
}
function $293d5acde922b5fe$var$renderSpec(doc, structure, xmlNS, blockArraysIn) {
    if (typeof structure == "string") return {
        dom: doc.createTextNode(structure)
    };
    if (structure.nodeType != null) return {
        dom: structure
    };
    if (structure.dom && structure.dom.nodeType != null) return structure;
    let tagName = structure[0], suspicious;
    if (typeof tagName != "string") throw new RangeError("Invalid array passed to renderSpec");
    if (blockArraysIn && (suspicious = $293d5acde922b5fe$var$suspiciousAttributes(blockArraysIn)) && suspicious.indexOf(structure) > -1) throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
    let space = tagName.indexOf(" ");
    if (space > 0) {
        xmlNS = tagName.slice(0, space);
        tagName = tagName.slice(space + 1);
    }
    let contentDOM;
    let dom = xmlNS ? doc.createElementNS(xmlNS, tagName) : doc.createElement(tagName);
    let attrs = structure[1], start = 1;
    if (attrs && typeof attrs == "object" && attrs.nodeType == null && !Array.isArray(attrs)) {
        start = 2;
        for(let name in attrs)if (attrs[name] != null) {
            let space = name.indexOf(" ");
            if (space > 0) dom.setAttributeNS(name.slice(0, space), name.slice(space + 1), attrs[name]);
            else dom.setAttribute(name, attrs[name]);
        }
    }
    for(let i = start; i < structure.length; i++){
        let child = structure[i];
        if (child === 0) {
            if (i < structure.length - 1 || i > start) throw new RangeError("Content hole must be the only child of its parent node");
            return {
                dom: dom,
                contentDOM: dom
            };
        } else {
            let { dom: inner, contentDOM: innerContent } = $293d5acde922b5fe$var$renderSpec(doc, child, xmlNS, blockArraysIn);
            dom.appendChild(inner);
            if (innerContent) {
                if (contentDOM) throw new RangeError("Multiple content holes");
                contentDOM = innerContent;
            }
        }
    }
    return {
        dom: dom,
        contentDOM: contentDOM
    };
}

});
parcelRegister("b22x6", function(module, exports) {

$parcel$export(module.exports, "default", () => $8081d8961ff8b83a$export$2e2bcd8739ae039);
// ::- Persistent data structure representing an ordered mapping from
// strings to values, with some convenient update methods.
function $8081d8961ff8b83a$var$OrderedMap(content) {
    this.content = content;
}
$8081d8961ff8b83a$var$OrderedMap.prototype = {
    constructor: $8081d8961ff8b83a$var$OrderedMap,
    find: function(key) {
        for(var i = 0; i < this.content.length; i += 2)if (this.content[i] === key) return i;
        return -1;
    },
    // :: (string) → ?any
    // Retrieve the value stored under `key`, or return undefined when
    // no such key exists.
    get: function(key) {
        var found = this.find(key);
        return found == -1 ? undefined : this.content[found + 1];
    },
    // :: (string, any, ?string) → OrderedMap
    // Create a new map by replacing the value of `key` with a new
    // value, or adding a binding to the end of the map. If `newKey` is
    // given, the key of the binding will be replaced with that key.
    update: function(key, value, newKey) {
        var self = newKey && newKey != key ? this.remove(newKey) : this;
        var found = self.find(key), content = self.content.slice();
        if (found == -1) content.push(newKey || key, value);
        else {
            content[found + 1] = value;
            if (newKey) content[found] = newKey;
        }
        return new $8081d8961ff8b83a$var$OrderedMap(content);
    },
    // :: (string) → OrderedMap
    // Return a map with the given key removed, if it existed.
    remove: function(key) {
        var found = this.find(key);
        if (found == -1) return this;
        var content = this.content.slice();
        content.splice(found, 2);
        return new $8081d8961ff8b83a$var$OrderedMap(content);
    },
    // :: (string, any) → OrderedMap
    // Add a new key to the start of the map.
    addToStart: function(key, value) {
        return new $8081d8961ff8b83a$var$OrderedMap([
            key,
            value
        ].concat(this.remove(key).content));
    },
    // :: (string, any) → OrderedMap
    // Add a new key to the end of the map.
    addToEnd: function(key, value) {
        var content = this.remove(key).content.slice();
        content.push(key, value);
        return new $8081d8961ff8b83a$var$OrderedMap(content);
    },
    // :: (string, string, any) → OrderedMap
    // Add a key after the given key. If `place` is not found, the new
    // key is added to the end.
    addBefore: function(place, key, value) {
        var without = this.remove(key), content = without.content.slice();
        var found = without.find(place);
        content.splice(found == -1 ? content.length : found, 0, key, value);
        return new $8081d8961ff8b83a$var$OrderedMap(content);
    },
    // :: ((key: string, value: any))
    // Call the given function for each key/value pair in the map, in
    // order.
    forEach: function(f) {
        for(var i = 0; i < this.content.length; i += 2)f(this.content[i], this.content[i + 1]);
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a new map by prepending the keys in this map that don't
    // appear in `map` before the keys in `map`.
    prepend: function(map) {
        map = $8081d8961ff8b83a$var$OrderedMap.from(map);
        if (!map.size) return this;
        return new $8081d8961ff8b83a$var$OrderedMap(map.content.concat(this.subtract(map).content));
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a new map by appending the keys in this map that don't
    // appear in `map` after the keys in `map`.
    append: function(map) {
        map = $8081d8961ff8b83a$var$OrderedMap.from(map);
        if (!map.size) return this;
        return new $8081d8961ff8b83a$var$OrderedMap(this.subtract(map).content.concat(map.content));
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a map containing all the keys in this map that don't
    // appear in `map`.
    subtract: function(map) {
        var result = this;
        map = $8081d8961ff8b83a$var$OrderedMap.from(map);
        for(var i = 0; i < map.content.length; i += 2)result = result.remove(map.content[i]);
        return result;
    },
    // :: () → Object
    // Turn ordered map into a plain object.
    toObject: function() {
        var result = {};
        this.forEach(function(key, value) {
            result[key] = value;
        });
        return result;
    },
    // :: number
    // The amount of keys in this map.
    get size () {
        return this.content.length >> 1;
    }
};
// :: (?union<Object, OrderedMap>) → OrderedMap
// Return a map with the given content. If null, create an empty
// map. If given an ordered map, return that map itself. If given an
// object, create a map from the object's properties.
$8081d8961ff8b83a$var$OrderedMap.from = function(value) {
    if (value instanceof $8081d8961ff8b83a$var$OrderedMap) return value;
    var content = [];
    if (value) for(var prop in value)content.push(prop, value[prop]);
    return new $8081d8961ff8b83a$var$OrderedMap(content);
};
var $8081d8961ff8b83a$export$2e2bcd8739ae039 = $8081d8961ff8b83a$var$OrderedMap;

});


// # What do marks exist?
//
// Marks are categorised into different groups. One motivation for this was to allow the `code` mark
// to exclude other marks, without needing to explicitly name them. Explicit naming requires the
// named mark to exist in the schema. This is undesirable because we want to construct different
// schemas that have different sets of nodes/marks.
//
// Groups provide a level of indirection, and solve this problem. For the immediate use-case, one
// group called "not_code" would have sufficed, but this an ultra-specialised to code.
// Mark group for font styling (e.g. bold, italic, underline, superscript).
const $212f88bb056bb83b$export$4498a6080fed604c = 'fontStyle';
const $212f88bb056bb83b$export$f8e8a5f34f6ea725 = 'searchQuery';
const $212f88bb056bb83b$export$b395009ca7f092c7 = 'link';
const $212f88bb056bb83b$export$9b982809044276a6 = 'color';
const $212f88bb056bb83b$export$470d0905851e47a1 = 'alignment';
const $212f88bb056bb83b$export$bacb7f4b06a06b22 = 'indentation';

parcelRegister("mYA6R", function(module, exports) {

$parcel$export(module.exports, "sanitizeNodes", () => $04510c65475a01e5$export$daf54fed04c8fb77);
function $04510c65475a01e5$export$daf54fed04c8fb77(nodes, supportedMarks) {
    const nodeNames = Object.keys(nodes);
    nodeNames.forEach((nodeKey)=>{
        const nodeSpec = {
            ...nodes[nodeKey]
        };
        if (nodeSpec.marks && nodeSpec.marks !== '_') nodeSpec.marks = nodeSpec.marks.split(' ').filter((mark)=>!!supportedMarks[mark]).join(' ');
        if (nodeSpec.content) nodeSpec.content = $04510c65475a01e5$var$sanitizeNodeSpecContent(nodes, nodeSpec.content);
        nodes[nodeKey] = nodeSpec;
    });
    return nodes;
}
function $04510c65475a01e5$var$sanitizeNodeSpecContent(nodes, rawContent) {
    const content = rawContent.replace(/\W/g, ' ');
    const contentKeys = content.split(' ');
    const unsupportedContentKeys = contentKeys.filter((contentKey)=>!$04510c65475a01e5$var$isContentSupported(nodes, contentKey));
    return unsupportedContentKeys.reduce((newContent, nodeName)=>$04510c65475a01e5$var$sanitizedContent(newContent, nodeName), rawContent);
}
function $04510c65475a01e5$var$sanitizedContent(content, invalidContent) {
    if (!invalidContent.length) return content || '';
    if (!content || !content.match(/\w/)) return '';
    const pattern = `(${invalidContent}((\\s)*\\|)+)|((\\|(\\s)*)+${invalidContent}(\\+|\\*)?)|(${invalidContent}$)|(${invalidContent}(\\+|\\*))`;
    return content.replace(new RegExp(pattern, 'g'), '').replace('  ', ' ').trim();
}
function $04510c65475a01e5$var$isContentSupported(nodes, contentKey) {
    const nodeKeys = Object.keys(nodes);
    // content is with valid node
    if (nodeKeys.indexOf(contentKey) > -1) return true;
    // content is with valid group
    for(const supportedKey in nodes){
        const nodeSpec = nodes[supportedKey];
        if (nodeSpec && nodeSpec.group === contentKey) return true;
    }
    return false;
}

});

parcelRegister("fRfD8", function(module, exports) {

$parcel$export(module.exports, "alignmentPositionMap", () => $b8b7ee14906d8946$export$be9cf49015769bbd);
$parcel$export(module.exports, "alignment", () => $b8b7ee14906d8946$export$8e53000a4ec837);

var $dpWhK = parcelRequire("dpWhK");
const $b8b7ee14906d8946$export$be9cf49015769bbd = {
    end: 'right',
    right: 'end',
    center: 'center'
};
const $b8b7ee14906d8946$export$8e53000a4ec837 = (0, $dpWhK.alignment)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-block-mark',
            getAttrs: (dom)=>{
                const align = dom.getAttribute('data-align');
                return align ? {
                    align: align
                } : false;
            }
        }
    ],
    toDOM (mark) {
        return [
            'div',
            {
                class: `fabric-editor-block-mark fabric-editor-alignment fabric-editor-align-${mark.attrs.align}`,
                'data-align': mark.attrs.align
            },
            0
        ];
    }
});

});
parcelRegister("dpWhK", function(module, exports) {

$parcel$export(module.exports, "alignment", () => $9c4ad26098e14d16$export$8e53000a4ec837);
$parcel$export(module.exports, "annotation", () => $9c4ad26098e14d16$export$8512c9afa7b24c3b);
$parcel$export(module.exports, "backgroundColor", () => $9c4ad26098e14d16$export$8c5a050822fd698c);
$parcel$export(module.exports, "border", () => $9c4ad26098e14d16$export$1edee58a52776cd9);
$parcel$export(module.exports, "breakout", () => $9c4ad26098e14d16$export$89015c65f1c75e3f);
$parcel$export(module.exports, "code", () => $9c4ad26098e14d16$export$6565f9f03506010b);
$parcel$export(module.exports, "confluenceInlineComment", () => $9c4ad26098e14d16$export$f3b72f8fc4684ecd);
$parcel$export(module.exports, "dataConsumer", () => $9c4ad26098e14d16$export$3024f02c495408d6);
$parcel$export(module.exports, "em", () => $9c4ad26098e14d16$export$c63c6f932822f543);
$parcel$export(module.exports, "fragment", () => $9c4ad26098e14d16$export$f00aeb236b6f05af);
$parcel$export(module.exports, "indentation", () => $9c4ad26098e14d16$export$480c699bd4ec0d86);
$parcel$export(module.exports, "link", () => $9c4ad26098e14d16$export$9c30223ca0a664fb);
$parcel$export(module.exports, "strike", () => $9c4ad26098e14d16$export$4899a95d70ec5056);
$parcel$export(module.exports, "strong", () => $9c4ad26098e14d16$export$59ae2c325a998f89);
$parcel$export(module.exports, "subsup", () => $9c4ad26098e14d16$export$b3401ee80eb31041);
$parcel$export(module.exports, "textColor", () => $9c4ad26098e14d16$export$32f78bffcd82ff28);
$parcel$export(module.exports, "typeAheadQuery", () => $9c4ad26098e14d16$export$20af3dabbb5538df);
$parcel$export(module.exports, "underline", () => $9c4ad26098e14d16$export$425327af25286e5e);
$parcel$export(module.exports, "unsupportedMark", () => $9c4ad26098e14d16$export$30d78d5eb6719bb8);
$parcel$export(module.exports, "unsupportedNodeAttribute", () => $9c4ad26098e14d16$export$a316dc07ff5182a2);
/**
 * This file was automatically generated by @atlaskit/adf-schema-generator
 * DO NOT MODIFY IT BY HAND. Instead, modify the source files in "packages/adf-schema/src/next-schema" ,
 * and run "yarn workspace @atlaskit/adf-schema build:schema:all" to regenerate this file.
 */ 
var $1zhCF = parcelRequire("1zhCF");
const $9c4ad26098e14d16$export$8e53000a4ec837 = (0, $1zhCF.createPMMarkSpecFactory)({
    attrs: {
        align: {}
    },
    excludes: 'alignment indentation',
    group: 'alignment'
});
const $9c4ad26098e14d16$export$8512c9afa7b24c3b = (0, $1zhCF.createPMMarkSpecFactory)({
    attrs: {
        id: {
            default: ''
        },
        annotationType: {
            default: 'inlineComment'
        }
    },
    inclusive: true,
    excludes: '',
    group: 'annotation'
});
const $9c4ad26098e14d16$export$8c5a050822fd698c = (0, $1zhCF.createPMMarkSpecFactory)({
    attrs: {
        color: {}
    },
    inclusive: true,
    excludes: 'color',
    group: 'color'
});
const $9c4ad26098e14d16$export$1edee58a52776cd9 = (0, $1zhCF.createPMMarkSpecFactory)({
    attrs: {
        size: {},
        color: {}
    },
    inclusive: false
});
const $9c4ad26098e14d16$export$89015c65f1c75e3f = (0, $1zhCF.createPMMarkSpecFactory)({
    attrs: {
        mode: {
            default: 'wide'
        },
        width: {
            default: null
        }
    },
    inclusive: false,
    spanning: false
});
const $9c4ad26098e14d16$export$6565f9f03506010b = (0, $1zhCF.createPMMarkSpecFactory)({
    inclusive: true,
    excludes: 'fontStyle link searchQuery color'
});
const $9c4ad26098e14d16$export$f3b72f8fc4684ecd = (0, $1zhCF.createPMMarkSpecFactory)({
    attrs: {
        reference: {
            default: ''
        }
    },
    inclusive: false,
    excludes: ''
});
const $9c4ad26098e14d16$export$3024f02c495408d6 = (0, $1zhCF.createPMMarkSpecFactory)({
    attrs: {
        sources: {
            default: []
        }
    }
});
const $9c4ad26098e14d16$export$c63c6f932822f543 = (0, $1zhCF.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
const $9c4ad26098e14d16$export$f00aeb236b6f05af = (0, $1zhCF.createPMMarkSpecFactory)({
    attrs: {
        localId: {
            default: ''
        },
        name: {
            default: null
        }
    },
    inclusive: false,
    excludes: ''
});
const $9c4ad26098e14d16$export$480c699bd4ec0d86 = (0, $1zhCF.createPMMarkSpecFactory)({
    attrs: {
        level: {}
    },
    excludes: 'indentation alignment',
    group: 'indentation'
});
const $9c4ad26098e14d16$export$9c30223ca0a664fb = (0, $1zhCF.createPMMarkSpecFactory)({
    attrs: {
        href: {},
        __confluenceMetadata: {
            default: null
        }
    },
    inclusive: false,
    excludes: 'link',
    group: 'link'
});
const $9c4ad26098e14d16$export$4899a95d70ec5056 = (0, $1zhCF.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
const $9c4ad26098e14d16$export$59ae2c325a998f89 = (0, $1zhCF.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
const $9c4ad26098e14d16$export$b3401ee80eb31041 = (0, $1zhCF.createPMMarkSpecFactory)({
    attrs: {
        type: {
            default: 'sub'
        }
    },
    inclusive: true,
    group: 'fontStyle'
});
const $9c4ad26098e14d16$export$32f78bffcd82ff28 = (0, $1zhCF.createPMMarkSpecFactory)({
    attrs: {
        color: {}
    },
    inclusive: true,
    group: 'color'
});
const $9c4ad26098e14d16$export$20af3dabbb5538df = (0, $1zhCF.createPMMarkSpecFactory)({
    attrs: {
        trigger: {
            default: ''
        }
    },
    inclusive: true,
    group: 'searchQuery'
});
const $9c4ad26098e14d16$export$425327af25286e5e = (0, $1zhCF.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
const $9c4ad26098e14d16$export$30d78d5eb6719bb8 = (0, $1zhCF.createPMMarkSpecFactory)({
    attrs: {
        originalValue: {}
    },
    excludes: ''
});
const $9c4ad26098e14d16$export$a316dc07ff5182a2 = (0, $1zhCF.createPMMarkSpecFactory)({
    attrs: {
        unsupported: {},
        type: {}
    }
});

});


parcelRegister("jxPcD", function(module, exports) {

$parcel$export(module.exports, "AnnotationTypes", () => $e3a8d12fb24e7751$export$94aa2fc69ad33d19);
$parcel$export(module.exports, "AnnotationMarkStates", () => $e3a8d12fb24e7751$export$4bab14797673da9f);
$parcel$export(module.exports, "buildDataAttributes", () => $e3a8d12fb24e7751$export$93a98caa8bc6cb07);
$parcel$export(module.exports, "annotation", () => $e3a8d12fb24e7751$export$8512c9afa7b24c3b);

var $dpWhK = parcelRequire("dpWhK");
let $e3a8d12fb24e7751$export$94aa2fc69ad33d19 = /*#__PURE__*/ function(AnnotationTypes) {
    AnnotationTypes["INLINE_COMMENT"] = "inlineComment";
    return AnnotationTypes;
}({});
let $e3a8d12fb24e7751$export$4bab14797673da9f = /*#__PURE__*/ function(AnnotationMarkStates) {
    AnnotationMarkStates["RESOLVED"] = "resolved";
    AnnotationMarkStates["ACTIVE"] = "active";
    return AnnotationMarkStates;
}({});
function $e3a8d12fb24e7751$export$93a98caa8bc6cb07({ id: id, annotationType: annotationType, state: state }) {
    const data = {
        'data-mark-type': 'annotation',
        'data-mark-annotation-type': annotationType,
        'data-id': id
    };
    if (state) return {
        ...data,
        'data-mark-annotation-state': state
    };
    return data;
}
const $e3a8d12fb24e7751$export$8512c9afa7b24c3b = (0, $dpWhK.annotation)({
    parseDOM: [
        {
            tag: 'span[data-mark-type="annotation"]',
            mark: 'annotation',
            getAttrs: (domNode)=>{
                const dom = domNode;
                const attrs = {
                    id: dom.getAttribute('data-id'),
                    annotationType: dom.getAttribute('data-mark-annotation-type')
                };
                return attrs;
            }
        }
    ],
    toDOM (node) {
        /*
      Data attributes on the DOM node are a temporary means of
      incrementally switching over to the Annotation mark. Once renderer
      provides native support for inline comments the data attributes on the
      DOM nodes will be removed.
    */ return [
            'span',
            {
                // Prettier will remove the quotes around class. This would cause some browsers
                // to not add this attribute properly, as its a reserved word.
                // prettier-ignore
                'class': 'fabric-editor-annotation',
                ...$e3a8d12fb24e7751$export$93a98caa8bc6cb07({
                    id: node.attrs.id,
                    annotationType: node.attrs.annotationType
                })
            },
            0
        ];
    }
});

});

parcelRegister("7i9jz", function(module, exports) {

$parcel$export(module.exports, "backgroundColor", () => $54f1708b23d22a73$export$8c5a050822fd698c);

var $dpWhK = parcelRequire("dpWhK");

var $dyyJM = parcelRequire("dyyJM");

var $51dYk = parcelRequire("51dYk");

var $abZsg = parcelRequire("abZsg");

var $4PpDP = parcelRequire("4PpDP");
/**
 * @name backgroundColor_mark
 */ // Remove this when cleaning up platform_editor_add_orange_highlight_color
const $54f1708b23d22a73$var$colorArrayPalette = [
    [
        (0, $51dYk.Neutral300),
        'Gray'
    ],
    // token: color.background.accent.gray.subtler
    [
        (0, $51dYk.T200),
        'Teal'
    ],
    // token: color.background.accent.teal.subtler
    [
        (0, $51dYk.L200),
        'Lime'
    ],
    // token: color.background.accent.lime.subtler
    [
        (0, $51dYk.O200),
        'Orange'
    ],
    // token: color.background.accent.orange.subtler
    [
        (0, $51dYk.M200),
        'Magenta'
    ],
    // token: color.background.accent.magenta.subtler
    [
        (0, $51dYk.P200),
        'Purple'
    ] // token: color.background.accent.purple.subtler
];
const $54f1708b23d22a73$var$colorArrayPaletteNext = [
    [
        (0, $51dYk.Neutral300),
        'Gray'
    ],
    // token: color.background.accent.gray.subtler
    [
        (0, $51dYk.T200),
        'Teal'
    ],
    // token: color.background.accent.teal.subtler
    [
        (0, $51dYk.L200),
        'Lime'
    ],
    // token: color.background.accent.lime.subtler
    [
        (0, $51dYk.Yellow200),
        'Yellow'
    ],
    // token: color.background.accent.yellow.subtler
    [
        (0, $51dYk.O200),
        'Orange'
    ],
    // token: color.background.accent.orange.subtler
    [
        (0, $51dYk.M200),
        'Magenta'
    ],
    // token: color.background.accent.magenta.subtler
    [
        (0, $51dYk.P200),
        'Purple'
    ] // token: color.background.accent.purple.subtler
];
const $54f1708b23d22a73$export$14ec3f21a268e497 = new Map();
$54f1708b23d22a73$var$colorArrayPalette.forEach(([color, label])=>$54f1708b23d22a73$export$14ec3f21a268e497.set(color.toLowerCase(), label));
const $54f1708b23d22a73$export$7ab6fa38cecaeee2 = new Map();
$54f1708b23d22a73$var$colorArrayPaletteNext.forEach(([color, label])=>$54f1708b23d22a73$export$7ab6fa38cecaeee2.set(color.toLowerCase(), label));
const $54f1708b23d22a73$export$8c5a050822fd698c = (0, $dpWhK.backgroundColor)({
    parseDOM: [
        {
            style: 'background-color',
            getAttrs: (maybeValue)=>{
                const value = maybeValue;
                let hexColor;
                if (value.match(/^rgb/i)) hexColor = (0, $51dYk.rgbToHex)(value);
                else if (value[0] === '#') hexColor = value.toLowerCase();
                // else handle other colour formats
                return hexColor && $54f1708b23d22a73$export$14ec3f21a268e497.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        },
        // This rule ensures when loading from a renderer or editor where the
        // presented text color does not match the stored hex color -- that the
        // text color is preserved.
        //
        // This is used to support the work-around that converts the hex color to
        // a design system token to enable light / dark mode (through a CSS variable --custom-palette-color)
        {
            tag: '.fabric-background-color-mark',
            getAttrs: (maybeElement)=>{
                if (!(maybeElement instanceof HTMLElement)) return false;
                const hexColor = maybeElement.dataset.backgroundCustomColor;
                return hexColor && $54f1708b23d22a73$export$14ec3f21a268e497.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        }
    ],
    toDOM (mark) {
        let paletteColorValue;
        /**
     * Documents can contain custom colors when content has been migrated from the old editor, or created via APIs.
     *
     * This behaviour predates the introduction of dark mode.
     *
     * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect text colors copied from external editor sources. Where we load the background color from a
     * separate attribute (data-text-custom-color), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
     */ const tokenColor = (0, $dyyJM.hexToEditorTextBackgroundPaletteColor)(mark.attrs.color);
        if (tokenColor) paletteColorValue = tokenColor;
        else if ((0, $abZsg.getGlobalTheme)().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
        paletteColorValue = (0, $4PpDP.getDarkModeLCHColor)(mark.attrs.color);
        else // if we are in light mode, we can just set the color
        paletteColorValue = mark.attrs.color;
        return [
            'span',
            {
                class: 'fabric-background-color-mark',
                // Editor common has a common style which uses this css variable as the value for
                // the color property using the `fabric-text-background-color-mark` selector applied above.
                style: `--custom-palette-color: ${paletteColorValue}`,
                ['data-background-custom-color']: mark.attrs.color
            }
        ];
    }
});

});
parcelRegister("abZsg", function(module, exports) {

$parcel$export(module.exports, "colorPalette", () => $76ba9a217de88ec9$export$569885e57444f84a);
$parcel$export(module.exports, "getGlobalTheme", () => $76ba9a217de88ec9$export$813ecdf77207a053);
$parcel$export(module.exports, "textColor", () => $76ba9a217de88ec9$export$32f78bffcd82ff28);

var $dpWhK = parcelRequire("dpWhK");

var $dyyJM = parcelRequire("dyyJM");

var $51dYk = parcelRequire("51dYk");

var $4PpDP = parcelRequire("4PpDP");
/**
 * @name textColor_mark
 */ // used for extended palette in text color picker
const $76ba9a217de88ec9$var$colorArrayPalette = [
    // default row - first color is added programatically
    // [N800, 'Squid ink'], // default dark gray
    [
        (0, $51dYk.B500),
        'Dark blue'
    ],
    // Chore coat
    [
        (0, $51dYk.T500),
        'Dark teal'
    ],
    // Shabby chic
    [
        (0, $51dYk.G500),
        'Dark green'
    ],
    // Keen green
    [
        (0, $51dYk.Y400),
        'Orange'
    ],
    // Cheezy blasters
    [
        (0, $51dYk.R500),
        'Dark red'
    ],
    // Dragon's blood
    [
        (0, $51dYk.P500),
        'Dark purple'
    ],
    // Prince
    // row 2
    [
        (0, $51dYk.N80),
        'Light gray'
    ],
    // Spooky ghost
    [
        (0, $51dYk.B100),
        'Blue'
    ],
    // Arvo breeze
    [
        (0, $51dYk.T300),
        'Teal'
    ],
    // Tamarama
    [
        (0, $51dYk.G300),
        'Green'
    ],
    // Fine pine
    [
        (0, $51dYk.Y200),
        'Yellow'
    ],
    // Pub mix
    [
        (0, $51dYk.R300),
        'Red'
    ],
    // Poppy surprise
    [
        (0, $51dYk.P300),
        'Purple'
    ],
    // Da' juice
    // row 3
    [
        (0, $51dYk.N0),
        'White'
    ],
    [
        (0, $51dYk.B75),
        'Light blue'
    ],
    // Schwag
    [
        (0, $51dYk.T75),
        'Light teal'
    ],
    // Arctic chill
    [
        (0, $51dYk.G75),
        'Light green'
    ],
    // Mintie
    [
        (0, $51dYk.Y75),
        'Light yellow'
    ],
    // Dandelion whisper
    [
        (0, $51dYk.R75),
        'Light red'
    ],
    // Bondi sunburn
    [
        (0, $51dYk.P50),
        'Light purple'
    ] // Lavender secret
];
const $76ba9a217de88ec9$export$569885e57444f84a = new Map();
const $76ba9a217de88ec9$export$81e5ed9e84fe2e28 = $76ba9a217de88ec9$export$569885e57444f84a;
$76ba9a217de88ec9$var$colorArrayPalette.forEach(([color, label])=>$76ba9a217de88ec9$export$569885e57444f84a.set(color.toLowerCase(), label));
// these are for test only
let $76ba9a217de88ec9$var$testGlobalTheme;
const $76ba9a217de88ec9$export$fd7e0dd2b74807f7 = (theme)=>{
    $76ba9a217de88ec9$var$testGlobalTheme = theme;
};
const $76ba9a217de88ec9$export$813ecdf77207a053 = ()=>{
    // This should only be hit during tests.
    //
    // At time of writing Jest mocks are not working in this repository.
    if ($76ba9a217de88ec9$var$testGlobalTheme) return {
        colorMode: $76ba9a217de88ec9$var$testGlobalTheme
    };
    const element = document.documentElement;
    const colorMode = element.getAttribute('data-color-mode') || '';
    return {
        colorMode: colorMode
    };
};
const $76ba9a217de88ec9$export$32f78bffcd82ff28 = (0, $dpWhK.textColor)({
    parseDOM: [
        {
            style: 'color',
            getAttrs: (maybeValue)=>{
                const value = maybeValue;
                let hexColor;
                if (value.match(/^rgb/i)) hexColor = (0, $51dYk.rgbToHex)(value);
                else if (value[0] === '#') hexColor = value.toLowerCase();
                // else handle other colour formats
                return hexColor && $76ba9a217de88ec9$export$569885e57444f84a.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        },
        // This rule ensures when loading from a renderer or editor where the
        // presented text color does not match the stored hex color -- that the
        // text color is preserved.
        //
        // This was initially introduced to ensure text-color marks were not lost
        // when text-color was used inside a link, and is now also used to support
        // where the hex color stored in ADF is used as an ID for a design system
        // token (and based on theme mode -- the presented color will change).
        {
            tag: '.fabric-text-color-mark',
            getAttrs: (maybeElement)=>{
                if (!(maybeElement instanceof HTMLElement)) return false;
                const hexColor = maybeElement.dataset.textCustomColor;
                return hexColor && $76ba9a217de88ec9$export$569885e57444f84a.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        }
    ],
    toDOM (mark) {
        let paletteColorValue;
        // Note -- while there is no way to create custom colors using default tooling
        // the editor does supported ad hoc color values -- and there may be content
        // which has been migrated or created via apis which use such values.
        /**
     * The Editor persists custom text colors when content has been migrated from the old editor, or created via
     * apis.
     *
     * This behaviour predates the introduction of dark mode.
     *
     * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect text colors copied from external editor sources. Where we load the background color from a
     * seperate attribute (data-text-custom-color), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
     */ const tokenColor = (0, $dyyJM.hexToEditorTextPaletteColor)(mark.attrs.color);
        if (tokenColor) paletteColorValue = tokenColor;
        else if ($76ba9a217de88ec9$export$813ecdf77207a053().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
        paletteColorValue = (0, $4PpDP.getDarkModeLCHColor)(mark.attrs.color);
        else // if we are in light mode, we can just set the color
        paletteColorValue = mark.attrs.color;
        return [
            'span',
            {
                class: 'fabric-text-color-mark',
                // Editor common has a common style which uses this css variable as the value for
                // the color property using the `fabric-text-color-mark` selector applied above.
                style: `--custom-palette-color: ${paletteColorValue}`,
                ['data-text-custom-color']: mark.attrs.color
            }
        ];
    }
});

});


parcelRegister("3Pxk9", function(module, exports) {

$parcel$export(module.exports, "borderColorPalette", () => $2c9ffbf60e7d1542$export$e4e044c989c86ca7);
$parcel$export(module.exports, "border", () => $2c9ffbf60e7d1542$export$1edee58a52776cd9);

var $dpWhK = parcelRequire("dpWhK");

var $dyyJM = parcelRequire("dyyJM");

var $51dYk = parcelRequire("51dYk");
/**
 * @name border_mark
 * @description This mark adds decoration to an element, and any element decorated with it will also have a border style.
 */ const $2c9ffbf60e7d1542$var$borderColorArrayPalette = [
    [
        (0, $51dYk.N300A),
        'Subtle gray'
    ],
    [
        (0, $51dYk.N600),
        'Gray'
    ],
    [
        (0, $51dYk.N1000),
        'Bold gray'
    ]
];
const $2c9ffbf60e7d1542$export$e4e044c989c86ca7 = new Map();
$2c9ffbf60e7d1542$var$borderColorArrayPalette.forEach(([color, label])=>$2c9ffbf60e7d1542$export$e4e044c989c86ca7.set(color.toLowerCase(), label));
const $2c9ffbf60e7d1542$export$1edee58a52776cd9 = (0, $dpWhK.border)({
    parseDOM: [
        {
            tag: '[data-mark-type="border"]',
            getAttrs: (domNode)=>{
                var _dom$getAttribute, _dom$getAttribute2;
                const dom = domNode;
                const color = ((_dom$getAttribute = dom.getAttribute('data-color')) !== null && _dom$getAttribute !== void 0 ? _dom$getAttribute : '').toLowerCase();
                const size = +((_dom$getAttribute2 = dom.getAttribute('data-size')) !== null && _dom$getAttribute2 !== void 0 ? _dom$getAttribute2 : '0');
                return {
                    size: size > 3 ? 3 : size < 1 ? false : size,
                    color: $2c9ffbf60e7d1542$export$e4e044c989c86ca7.has(color) ? color : false
                };
            }
        }
    ],
    toDOM (mark, isInline) {
        const wrapperStyle = isInline ? 'span' : 'div';
        // Note -- while there is no way to create custom colors using default tooling
        // the editor does supported ad hoc color values -- and there may be content
        // which has been migrated or created via apis which use such values.
        const paletteColorValue = (0, $dyyJM.hexToEditorBorderPaletteColor)(mark.attrs.color) || mark.attrs.color;
        return [
            wrapperStyle,
            {
                'data-mark-type': 'border',
                'data-color': mark.attrs.color,
                'data-size': mark.attrs.size,
                style: `--custom-palette-color: ${paletteColorValue}`
            }
        ];
    }
});

});

parcelRegister("7uhRT", function(module, exports) {

$parcel$export(module.exports, "breakout", () => $573931fdaecc07f5$export$89015c65f1c75e3f);

var $dpWhK = parcelRequire("dpWhK");
const $573931fdaecc07f5$var$allowedTypes = [
    'wide',
    'full-width'
];
const $573931fdaecc07f5$export$89015c65f1c75e3f = (0, $dpWhK.breakout)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-breakout-mark',
            getAttrs (dom) {
                const mode = dom.getAttribute('data-mode');
                const width = dom.getAttribute('data-width');
                return {
                    mode: $573931fdaecc07f5$var$allowedTypes.indexOf(mode || '') === -1 ? 'wide' : mode,
                    width: width ? parseInt(width) : null
                };
            }
        }
    ],
    toDOM (mark) {
        var _mark$attrs;
        return [
            'div',
            {
                class: 'fabric-editor-breakout-mark',
                'data-mode': mark.attrs.mode,
                'data-width': (_mark$attrs = mark.attrs) === null || _mark$attrs === void 0 ? void 0 : _mark$attrs.width
            },
            0
        ];
    }
});

});

parcelRegister("eA6GD", function(module, exports) {

$parcel$export(module.exports, "code", () => $a9d99d50afe8568a$export$6565f9f03506010b);

var $dpWhK = parcelRequire("dpWhK");
const $a9d99d50afe8568a$export$6565f9f03506010b = (0, $dpWhK.code)({
    parseDOM: [
        {
            tag: 'span.code',
            preserveWhitespace: true
        },
        {
            tag: 'code',
            preserveWhitespace: true
        },
        {
            tag: 'tt',
            preserveWhitespace: true
        },
        {
            tag: 'span',
            preserveWhitespace: true,
            getAttrs: (domNode)=>{
                const dom = domNode;
                if (dom.style.whiteSpace === 'pre') return {};
                if (dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') >= 0) return {};
                return false;
            }
        }
    ],
    toDOM () {
        return [
            'span',
            {
                class: 'code',
                spellcheck: 'false'
            }
        ];
    }
});

});

parcelRegister("04SjV", function(module, exports) {

$parcel$export(module.exports, "confluenceInlineComment", () => $00ea82b899b17721$export$f3b72f8fc4684ecd);

var $dpWhK = parcelRequire("dpWhK");
const $00ea82b899b17721$export$f3b72f8fc4684ecd = (0, $dpWhK.confluenceInlineComment)({
    parseDOM: [
        {
            tag: 'span[data-mark-type="confluenceInlineComment"]'
        }
    ],
    toDOM (node) {
        return [
            'span',
            {
                'data-mark-type': 'confluenceInlineComment',
                'data-reference': node.attrs.reference
            }
        ];
    }
});

});

parcelRegister("dHJym", function(module, exports) {

$parcel$export(module.exports, "dataConsumer", () => $9fa2a06e539a28ed$export$3024f02c495408d6);
$parcel$export(module.exports, "toJSON", () => $9fa2a06e539a28ed$export$54fd2c36b5cc6731);

var $dpWhK = parcelRequire("dpWhK");

var $j783N = parcelRequire("j783N");
/**
 * This annotation is purely for reference, & does _nothing_ given annotating
 * `minLength` on an array of strings is not supported with our schema+spec
 * generator.
 *
 * We're keeping it to signal that data consumer `sources` shouldn't be empty
 * strings
 *
 * // @minLength 1
 */ /**
 * @name dataConsumer_mark
 * @description This mark is used for metadata surrounding a node consuming data
 * from a given source node
 */ const $9fa2a06e539a28ed$var$parseDataConsumer = (maybeValue)=>{
    const sources = (0, $j783N.isDOMElement)(maybeValue) && maybeValue.getAttribute('data-sources');
    try {
        return sources ? {
            sources: JSON.parse(sources)
        } : false;
    } catch  {
        return false;
    }
};
const $9fa2a06e539a28ed$export$3024f02c495408d6 = (0, $dpWhK.dataConsumer)({
    parseDOM: [
        {
            tag: '[data-mark-type="dataConsumer"]',
            getAttrs: (maybeValue)=>$9fa2a06e539a28ed$var$parseDataConsumer(maybeValue)
        }
    ],
    toDOM (mark, inline) {
        const wrapperStyle = inline ? 'span' : 'div';
        return [
            wrapperStyle,
            {
                'data-mark-type': 'dataConsumer',
                'data-sources': JSON.stringify(mark.attrs.sources)
            }
        ];
    }
});
const $9fa2a06e539a28ed$export$54fd2c36b5cc6731 = (mark)=>{
    // // Remove intemediary state if we don't have any sources on data consumer
    // if (mark.attrs?.sources?.length < 1) {
    //   return null;
    // }
    return {
        type: mark.type.name,
        attrs: Object.keys(mark.attrs).filter((key)=>key === 'sources' && mark.attrs[key].length > 0 && mark.attrs[key] !== null).reduce((acc, key)=>{
            return {
                ...acc,
                [key]: mark.attrs[key]
            };
        }, {})
    };
};

});
parcelRegister("j783N", function(module, exports) {

$parcel$export(module.exports, "isDOMElement", () => $dea4ec58c68501e8$export$c296e2d4365c37a5);
const $dea4ec58c68501e8$export$c296e2d4365c37a5 = (maybeNode)=>maybeNode instanceof Node && maybeNode.nodeType === Node.ELEMENT_NODE;

});


parcelRegister("eonww", function(module, exports) {

$parcel$export(module.exports, "em", () => $a7a58ddd4fa9ccdc$export$c63c6f932822f543);

var $dpWhK = parcelRequire("dpWhK");
/**
 * @name em_mark
 */ const $a7a58ddd4fa9ccdc$var$emDOM = [
    'em'
];
const $a7a58ddd4fa9ccdc$export$c63c6f932822f543 = (0, $dpWhK.em)({
    parseDOM: [
        {
            tag: 'i'
        },
        {
            tag: 'em'
        },
        {
            style: 'font-style=italic'
        }
    ],
    toDOM () {
        return $a7a58ddd4fa9ccdc$var$emDOM;
    }
});

});

parcelRegister("6Ymtk", function(module, exports) {

$parcel$export(module.exports, "fragment", () => $5139c72ca03c3689$export$f00aeb236b6f05af);
$parcel$export(module.exports, "toJSON", () => $5139c72ca03c3689$export$54fd2c36b5cc6731);

var $dpWhK = parcelRequire("dpWhK");

var $j783N = parcelRequire("j783N");
/**
 * @name fragment_mark
 * @description Indicates that the elements decorated with this mark belong to a "fragment" entity, which represents a collection of ADF nodes.
 * This entity can be referred to later by its `localId` attribute.
 */ const $5139c72ca03c3689$var$parseFragment = (maybeValue)=>{
    var _maybeValue$getAttrib;
    if (!(0, $j783N.isDOMElement)(maybeValue)) return false;
    const name = (_maybeValue$getAttrib = maybeValue.getAttribute('data-name')) !== null && _maybeValue$getAttrib !== void 0 ? _maybeValue$getAttrib : undefined;
    const localId = maybeValue.getAttribute('data-localId');
    if (!localId) return false;
    return {
        localId: localId,
        name: name
    };
};
const $5139c72ca03c3689$export$f00aeb236b6f05af = (0, $dpWhK.fragment)({
    parseDOM: [
        {
            tag: '[data-mark-type="fragment"]',
            getAttrs: (maybeValue)=>$5139c72ca03c3689$var$parseFragment(maybeValue)
        }
    ],
    toDOM (mark, inline) {
        const wrapperStyle = inline ? 'span' : 'div';
        return [
            wrapperStyle,
            {
                'data-mark-type': 'fragment',
                'data-name': mark.attrs.name,
                'data-localId': mark.attrs.localId
            }
        ];
    }
});
const $5139c72ca03c3689$export$54fd2c36b5cc6731 = (mark)=>{
    return {
        type: mark.type.name,
        attrs: {
            localId: mark.attrs.localId,
            ...mark.attrs.name ? {
                name: mark.attrs.name
            } : {}
        }
    };
};

});

parcelRegister("7GG3N", function(module, exports) {

$parcel$export(module.exports, "indentation", () => $598d14eba71ad958$export$480c699bd4ec0d86);

var $dpWhK = parcelRequire("dpWhK");
const $598d14eba71ad958$export$480c699bd4ec0d86 = (0, $dpWhK.indentation)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-indentation-mark',
            getAttrs (dom) {
                const level = +(dom.getAttribute('data-level') || '0');
                return {
                    level: level > 6 ? 6 : level < 1 ? false : level
                };
            }
        }
    ],
    toDOM (mark) {
        return [
            'div',
            {
                class: 'fabric-editor-block-mark fabric-editor-indentation-mark',
                'data-level': mark.attrs.level
            },
            0
        ];
    }
});

});

parcelRegister("h9kgv", function(module, exports) {

$parcel$export(module.exports, "link", () => $c7c2ff29c44bed75$export$9c30223ca0a664fb);
$parcel$export(module.exports, "toJSON", () => $c7c2ff29c44bed75$export$54fd2c36b5cc6731);

var $dpWhK = parcelRequire("dpWhK");

var $iKozC = parcelRequire("iKozC");
const $c7c2ff29c44bed75$export$b5f67017585d1431 = (attribute)=>(domNode)=>{
        const dom = domNode;
        const href = dom.getAttribute(attribute) || '';
        const attrs = {
            __confluenceMetadata: dom.hasAttribute('__confluenceMetadata') ? JSON.parse(dom.getAttribute('__confluenceMetadata') || '') : undefined
        };
        if (!(0, $iKozC.isSafeUrl)(href)) return false;
        if ((0, $iKozC.isRootRelative)(href)) {
            attrs.href = href;
            return attrs;
        }
        attrs.href = (0, $iKozC.normalizeUrl)(href);
        return attrs;
    };
const $c7c2ff29c44bed75$export$9c30223ca0a664fb = (0, $dpWhK.link)({
    parseDOM: [
        {
            tag: '[data-block-link]',
            getAttrs: $c7c2ff29c44bed75$export$b5f67017585d1431('data-block-link'),
            contentElement: (node)=>{
                const clone = node.cloneNode(true);
                clone.removeAttribute('data-block-link');
                clone.setAttribute('data-skip-paste', 'true');
                const wrapper = document.createElement('div');
                wrapper.appendChild(clone);
                return wrapper;
            }
        },
        {
            tag: 'a[href]',
            getAttrs: $c7c2ff29c44bed75$export$b5f67017585d1431('href')
        }
    ],
    toDOM (node, isInline) {
        const attrs = Object.keys(node.attrs).reduce((attrs, key)=>{
            if (key === '__confluenceMetadata') {
                if (node.attrs[key] !== null) attrs[key] = JSON.stringify(node.attrs[key]);
            } else if (key === 'href') attrs[key] = (0, $iKozC.isSafeUrl)(node.attrs[key]) ? node.attrs[key] : undefined;
            else attrs[key] = node.attrs[key];
            return attrs;
        }, {});
        if (isInline) return [
            'a',
            attrs
        ];
        return [
            'a',
            {
                ...attrs,
                ['data-block-link']: 'true',
                class: 'blockLink'
            },
            0
        ];
    }
});
const $c7c2ff29c44bed75$var$OPTIONAL_ATTRS = [
    'title',
    'id',
    'collection',
    'occurrenceKey',
    '__confluenceMetadata'
];
const $c7c2ff29c44bed75$export$54fd2c36b5cc6731 = (mark)=>({
        type: mark.type.name,
        attrs: Object.keys(mark.attrs).reduce((attrs, key)=>{
            if ($c7c2ff29c44bed75$var$OPTIONAL_ATTRS.indexOf(key) === -1 || mark.attrs[key] !== null) attrs[key] = mark.attrs[key];
            return attrs;
        }, {})
    });

});
parcelRegister("iKozC", function(module, exports) {

$parcel$export(module.exports, "isSafeUrl", () => $da5f95a938306985$export$c9f92f5469372e0f);
$parcel$export(module.exports, "linkify", () => $da5f95a938306985$export$8ccbde94d5c7f8e7);
$parcel$export(module.exports, "linkifyMatch", () => $da5f95a938306985$export$6f7d7761b97f967);
$parcel$export(module.exports, "getLinkMatch", () => $da5f95a938306985$export$ce9ae45aed3e4ec);
$parcel$export(module.exports, "normalizeUrl", () => $da5f95a938306985$export$6535eb414fa2c8b6);
$parcel$export(module.exports, "isRootRelative", () => $da5f95a938306985$export$23579274a7a24f7b);
/**
 * This file has been partially duplicated in packages/linking-platform/linking-common/src/url.ts
 * Any changes made here should be mirrored there.
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $agOHY = parcelRequire("agOHY");
const $da5f95a938306985$var$whitelistedURLPatterns = [
    /^https?:\/\//im,
    /^ftps?:\/\//im,
    /^gopher:\/\//im,
    /^integrity:\/\//im,
    /^file:\/\//im,
    /^smb:\/\//im,
    /^dynamicsnav:\/\//im,
    /^jamfselfservice:\/\//im,
    /^\//im,
    /^mailto:/im,
    /^skype:/im,
    /^callto:/im,
    /^facetime:/im,
    /^git:/im,
    /^irc6?:/im,
    /^news:/im,
    /^nntp:/im,
    /^feed:/im,
    /^cvs:/im,
    /^svn:/im,
    /^mvn:/im,
    /^ssh:/im,
    /^scp:\/\//im,
    /^sftp:\/\//im,
    /^itms:/im,
    // This is not a valid notes link, but we support this pattern for backwards compatibility
    /^notes:/im,
    /^notes:\/\//im,
    /^hipchat:\/\//im,
    // This is not a valid sourcetree link, but we support this pattern for backwards compatibility
    /^sourcetree:/im,
    /^sourcetree:\/\//im,
    /^urn:/im,
    /^tel:/im,
    /^xmpp:/im,
    /^telnet:/im,
    /^vnc:/im,
    /^rdp:/im,
    /^whatsapp:/im,
    /^slack:/im,
    /^sips?:/im,
    /^magnet:/im,
    /^#/im
];
const $da5f95a938306985$export$c9f92f5469372e0f = (url)=>{
    const urlTrimmed = url.trim();
    if (urlTrimmed.length === 0) return true;
    return $da5f95a938306985$var$whitelistedURLPatterns.some((p)=>p.test(urlTrimmed));
};
const $da5f95a938306985$export$8ccbde94d5c7f8e7 = (0, (/*@__PURE__*/$parcel$interopDefault($agOHY)))();
$da5f95a938306985$export$8ccbde94d5c7f8e7.add('sourcetree:', 'http:');
$da5f95a938306985$export$8ccbde94d5c7f8e7.add('jamfselfservice:', 'http:');
const $da5f95a938306985$var$urlWithoutSpacesValidator = {
    validate: /[^\s]+/
};
// `tel:` URI spec is https://datatracker.ietf.org/doc/html/rfc3966
// We're not validating the phone number or separators - but if there's a space it definitely isn't a valid `tel:` URI
$da5f95a938306985$export$8ccbde94d5c7f8e7.add('tel:', $da5f95a938306985$var$urlWithoutSpacesValidator);
// https://datatracker.ietf.org/doc/html/rfc8089
$da5f95a938306985$export$8ccbde94d5c7f8e7.add('file:', $da5f95a938306985$var$urlWithoutSpacesValidator);
$da5f95a938306985$export$8ccbde94d5c7f8e7.add('notes:', 'http:');
const $da5f95a938306985$var$tlds = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
const $da5f95a938306985$var$tlds2Char = 'a[cdefgilmnoqrtuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrtuvwxyz]|n[acefgilopruz]|om|p[aefghkmnrtw]|qa|r[eosuw]|s[abcdegijklmnrtuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
$da5f95a938306985$var$tlds.push($da5f95a938306985$var$tlds2Char);
$da5f95a938306985$export$8ccbde94d5c7f8e7.tlds($da5f95a938306985$var$tlds, false);
const $da5f95a938306985$export$746d02eae03c72e1 = /(https?|ftp|jamfselfservice|gopher|dynamicsnav|integrity|file|smb):\/\/[^\s]+/;
const $da5f95a938306985$export$6f7d7761b97f967 = (text)=>{
    if (!$da5f95a938306985$export$746d02eae03c72e1.test(text)) return [];
    const matches = [];
    let startpos = 0;
    let substr;
    while(substr = text.substr(startpos)){
        const link = (substr.match($da5f95a938306985$export$746d02eae03c72e1) || [
            ''
        ])[0];
        if (link) {
            const index = substr.search($da5f95a938306985$export$746d02eae03c72e1);
            const start = index >= 0 ? index + startpos : index;
            const end = start + link.length;
            matches.push({
                index: start,
                lastIndex: end,
                raw: link,
                url: link,
                text: link,
                schema: ''
            });
            startpos += end;
        } else break;
    }
    return matches;
};
function $da5f95a938306985$export$ce9ae45aed3e4ec(str) {
    if (!str) return null;
    // linkify-it mishandles closing braces on long urls, so we preference using our own regex first:
    // https://product-fabric.atlassian.net/browse/ED-13669
    let match = $da5f95a938306985$export$6f7d7761b97f967(str);
    if (!match.length) match = $da5f95a938306985$export$8ccbde94d5c7f8e7.match(str);
    return match && match[0];
}
function $da5f95a938306985$export$6535eb414fa2c8b6(url) {
    const match = $da5f95a938306985$export$ce9ae45aed3e4ec(url);
    return match && match.url || '';
}
function $da5f95a938306985$export$23579274a7a24f7b(url) {
    // Support `#top` and `#` special references as per:
    // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#linking_to_an_element_on_the_same_page
    return url.startsWith('/') || url === '#top' || url === '#';
}

});
parcelRegister("agOHY", function(module, exports) {
'use strict';
////////////////////////////////////////////////////////////////////////////////
// Helpers
// Merge objects
//
function $77a2bb99974301ae$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $77a2bb99974301ae$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $77a2bb99974301ae$var$isString(obj) {
    return $77a2bb99974301ae$var$_class(obj) === '[object String]';
}
function $77a2bb99974301ae$var$isObject(obj) {
    return $77a2bb99974301ae$var$_class(obj) === '[object Object]';
}
function $77a2bb99974301ae$var$isRegExp(obj) {
    return $77a2bb99974301ae$var$_class(obj) === '[object RegExp]';
}
function $77a2bb99974301ae$var$isFunction(obj) {
    return $77a2bb99974301ae$var$_class(obj) === '[object Function]';
}
function $77a2bb99974301ae$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
}
////////////////////////////////////////////////////////////////////////////////
var $77a2bb99974301ae$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $77a2bb99974301ae$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        return acc || $77a2bb99974301ae$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
var $77a2bb99974301ae$var$defaultSchemas = {
    'http:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp('^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i');
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    'https:': 'http:',
    'ftp:': 'http:',
    '//': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp('^' + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' + self.re.src_port + self.re.src_host_terminator + self.re.src_path, 'i');
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ':') return 0;
                if (pos >= 3 && text[pos - 3] === '/') return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    'mailto:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp('^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i');
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
/*eslint-disable max-len*/ // RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
var $77a2bb99974301ae$var$tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
var $77a2bb99974301ae$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
/*eslint-enable max-len*/ ////////////////////////////////////////////////////////////////////////////////
function $77a2bb99974301ae$var$resetScanCache(self) {
    self.__index__ = -1;
    self.__text_cache__ = '';
}
function $77a2bb99974301ae$var$createValidator(re) {
    return function(text, pos) {
        var tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $77a2bb99974301ae$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}

// Schemas compiler. Build regexps.
//
function $77a2bb99974301ae$var$compile(self) {
    // Load & clone RE patterns.
    var re = self.re = (parcelRequire("dZNb9"))(self.__opts__);
    // Define dynamic patterns
    var tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($77a2bb99974301ae$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join('|');
    function untpl(tpl) {
        return tpl.replace('%TLDS%', re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), 'i');
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), 'i');
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');
    //
    // Compile each schema
    //
    var aliases = [];
    self.__compiled__ = {}; // Reset compiled data
    function schemaError(name, val) {
        throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        var val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        var compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($77a2bb99974301ae$var$isObject(val)) {
            if ($77a2bb99974301ae$var$isRegExp(val.validate)) compiled.validate = $77a2bb99974301ae$var$createValidator(val.validate);
            else if ($77a2bb99974301ae$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($77a2bb99974301ae$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $77a2bb99974301ae$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($77a2bb99974301ae$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[''] = {
        validate: null,
        normalize: $77a2bb99974301ae$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    var slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($77a2bb99974301ae$var$escapeRE).join('|');
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
    self.re.schema_search = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');
    self.re.pretest = RegExp('(' + self.re.schema_test.source + ')|' + '(' + self.re.host_fuzzy_test.source + ')|' + '@', 'i');
    //
    // Cleanup
    //
    $77a2bb99974301ae$var$resetScanCache(self);
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $77a2bb99974301ae$var$Match(self, shift) {
    var start = self.__index__, end = self.__last_index__, text = self.__text_cache__.slice(start, end);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = self.__schema__.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = start + shift;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = end + shift;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = text;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = text;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = text;
}
function $77a2bb99974301ae$var$createMatch(self, shift) {
    var match = new $77a2bb99974301ae$var$Match(self, shift);
    self.__compiled__[match.schema].normalize(match, self);
    return match;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $77a2bb99974301ae$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $77a2bb99974301ae$var$LinkifyIt)) return new $77a2bb99974301ae$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($77a2bb99974301ae$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $77a2bb99974301ae$var$assign({}, $77a2bb99974301ae$var$defaultOptions, options);
    // Cache last tested result. Used to skip repeating steps on next `match` call.
    this.__index__ = -1;
    this.__last_index__ = -1; // Next scan position
    this.__schema__ = '';
    this.__text_cache__ = '';
    this.__schemas__ = $77a2bb99974301ae$var$assign({}, $77a2bb99974301ae$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $77a2bb99974301ae$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $77a2bb99974301ae$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $77a2bb99974301ae$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $77a2bb99974301ae$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $77a2bb99974301ae$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $77a2bb99974301ae$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $77a2bb99974301ae$var$LinkifyIt.prototype.test = function test(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return false;
    var m, ml, me, len, shift, next, re, tld_pos, at_pos;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) {
                this.__schema__ = m[2];
                this.__index__ = m.index + m[1].length;
                this.__last_index__ = m.index + m[0].length + len;
                break;
            }
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
        // guess schemaless links
        tld_pos = text.search(this.re.host_fuzzy_test);
        if (tld_pos >= 0) {
            // if tld is located after found link - no need to check fuzzy pattern
            if (this.__index__ < 0 || tld_pos < this.__index__) {
                if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                    shift = ml.index + ml[1].length;
                    if (this.__index__ < 0 || shift < this.__index__) {
                        this.__schema__ = '';
                        this.__index__ = shift;
                        this.__last_index__ = ml.index + ml[0].length;
                    }
                }
            }
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
        // guess schemaless emails
        at_pos = text.indexOf('@');
        if (at_pos >= 0) // We can't skip this check, because this cases are possible:
        // 192.168.1.1@gmail.com, my.in@example.com
        {
            if ((me = text.match(this.re.email_fuzzy)) !== null) {
                shift = me.index + me[1].length;
                next = me.index + me[0].length;
                if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                    this.__schema__ = 'mailto:';
                    this.__index__ = shift;
                    this.__last_index__ = next;
                }
            }
        }
    }
    return this.__index__ >= 0;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $77a2bb99974301ae$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $77a2bb99974301ae$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $77a2bb99974301ae$var$LinkifyIt.prototype.match = function match(text) {
    var shift = 0, result = [];
    // Try to take previous element from cache, if .test() called before
    if (this.__index__ >= 0 && this.__text_cache__ === text) {
        result.push($77a2bb99974301ae$var$createMatch(this, shift));
        shift = this.__last_index__;
    }
    // Cut head if cache was used
    var tail = shift ? text.slice(shift) : text;
    // Scan string until end reached
    while(this.test(tail)){
        result.push($77a2bb99974301ae$var$createMatch(this, shift));
        tail = tail.slice(this.__last_index__);
        shift += this.__last_index__;
    }
    if (result.length) return result;
    return null;
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $77a2bb99974301ae$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $77a2bb99974301ae$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $77a2bb99974301ae$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $77a2bb99974301ae$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = 'http://' + match.url;
    if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) match.url = 'mailto:' + match.url;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $77a2bb99974301ae$var$LinkifyIt.prototype.onCompile = function onCompile() {};
module.exports = $77a2bb99974301ae$var$LinkifyIt;

});
parcelRegister("dZNb9", function(module, exports) {
'use strict';




module.exports = function(opts) {
    var re = {};
    // Use direct extract instead of `regenerate` to reduse browserified size
    re.src_Any = (parcelRequire("hZcCd")).source;
    re.src_Cc = (parcelRequire("iNnZB")).source;
    re.src_Z = (parcelRequire("23KJ1")).source;
    re.src_P = (parcelRequire("dDBFM")).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join('|');
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join('|');
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    var text_separators = '[><\uff5c]';
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    ////////////////////////////////////////////////////////////////////////////////
    re.src_ip4 = '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    re.src_auth = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';
    re.src_port = '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
    re.src_host_terminator = '(?=$|' + text_separators + '|' + re.src_ZPCc + ')(?!-|_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';
    re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-]).|' + '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' + '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' + '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + "\\'(?=" + re.src_pseudo_letter + '|[-]).|' + // allow `I'm_king` if no pair found
    '\\.{2,3}[a-zA-Z0-9%/]|' + // github has ... in commit range links. Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // until more examples found.
    '\\.(?!' + re.src_ZCc + '|[.]).|' + (opts && opts['---'] ? '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
     : '\\-+|') + '\\,(?!' + re.src_ZCc + ').|' + // allow `,,,` in paths
    '\\!(?!' + re.src_ZCc + '|[!]).|' + '\\?(?!' + re.src_ZCc + '|[?]).' + ')+' + '|\\/' + ')?';
    re.src_email_name = '[\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]+';
    re.src_xn = 'xn--[a-z0-9\\-]{1,59}';
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    '(?:' + re.src_xn + '|' + re.src_pseudo_letter + '{1,63}' + ')';
    re.src_domain = '(?:' + re.src_xn + '|' + '(?:' + re.src_pseudo_letter + ')' + '|' + // don't allow `--` in domain names, because:
    // - that can conflict with markdown &mdash; / &ndash;
    // - nobody use those anyway
    '(?:' + re.src_pseudo_letter + '(?:-(?!-)|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' + ')';
    re.src_host = "(?:(?:(?:(?:" + re.src_domain + ')\\.)*' + re.src_domain /*_root*/  + ')' + ')';
    re.tpl_host_fuzzy = '(?:' + re.src_ip4 + '|' + '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' + ')';
    re.tpl_host_no_ip_fuzzy = '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    ////////////////////////////////////////////////////////////////////////////////
    // Main rules
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = 'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';
    re.tpl_email_fuzzy = '(^|' + text_separators + '|\\(|' + re.src_ZCc + ')(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';
    return re;
};

});
parcelRegister("hZcCd", function(module, exports) {
module.exports = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;

});

parcelRegister("iNnZB", function(module, exports) {
module.exports = /[\0-\x1F\x7F-\x9F]/;

});

parcelRegister("23KJ1", function(module, exports) {
module.exports = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;

});

parcelRegister("dDBFM", function(module, exports) {
module.exports = /[!-#%-\*,-/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E49\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC9\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3E]|\uD806[\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2]|\uD807[\uDC41-\uDC45\uDC70\uDC71]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/;

});





parcelRegister("f4V9T", function(module, exports) {

$parcel$export(module.exports, "strike", () => $afa39141d5f07f7e$export$4899a95d70ec5056);

var $dpWhK = parcelRequire("dpWhK");
const $afa39141d5f07f7e$export$4899a95d70ec5056 = (0, $dpWhK.strike)({
    parseDOM: [
        {
            tag: 'strike'
        },
        {
            tag: 's'
        },
        {
            tag: 'del'
        },
        {
            style: 'text-decoration',
            getAttrs: (value)=>value === 'line-through' && null
        }
    ],
    toDOM () {
        return [
            's'
        ];
    }
});

});

parcelRegister("YKDO7", function(module, exports) {

$parcel$export(module.exports, "strong", () => $0b69c8a71c20472c$export$59ae2c325a998f89);

var $dpWhK = parcelRequire("dpWhK");
/**
 * @name strong_mark
 */ const $0b69c8a71c20472c$var$strongDOM = [
    'strong'
];
const $0b69c8a71c20472c$export$59ae2c325a998f89 = (0, $dpWhK.strong)({
    parseDOM: [
        {
            tag: 'strong'
        },
        // This works around a Google Docs misbehavior where
        // pasted content will be inexplicably wrapped in `<b>`
        // tags with a font-weight normal.
        {
            tag: 'b',
            getAttrs (node) {
                const element = node;
                return element.style.fontWeight !== 'normal' && null;
            }
        },
        {
            tag: 'span',
            getAttrs (node) {
                const element = node;
                const { fontWeight: fontWeight } = element.style;
                return typeof fontWeight === 'string' && (fontWeight === 'bold' || fontWeight === 'bolder' || /^(bold(er)?|[5-9]\d{2,})$/.test(fontWeight)) && null;
            }
        }
    ],
    toDOM () {
        return $0b69c8a71c20472c$var$strongDOM;
    }
});

});

parcelRegister("hI6rl", function(module, exports) {

$parcel$export(module.exports, "subsup", () => $ce4b8a96280c3122$export$b3401ee80eb31041);

var $dpWhK = parcelRequire("dpWhK");
/**
 * @name subsup_mark
 */ function $ce4b8a96280c3122$var$getAttrFromVerticalAlign(node) {
    if (node === 'sub') return {
        type: 'sub'
    };
    if (node === 'super') return {
        type: 'sup'
    };
    return false;
}
const $ce4b8a96280c3122$export$b3401ee80eb31041 = (0, $dpWhK.subsup)({
    parseDOM: [
        {
            tag: 'sub',
            attrs: {
                type: 'sub'
            }
        },
        {
            tag: 'sup',
            attrs: {
                type: 'sup'
            }
        },
        {
            // Special case for pasting from Google Docs
            // Google Docs uses vertical align to denote subscript and super script
            style: 'vertical-align=super',
            getAttrs: (node)=>$ce4b8a96280c3122$var$getAttrFromVerticalAlign(node)
        },
        {
            style: 'vertical-align=sub',
            getAttrs: (node)=>$ce4b8a96280c3122$var$getAttrFromVerticalAlign(node)
        }
    ],
    toDOM (mark) {
        return [
            mark.attrs.type
        ];
    }
});

});

parcelRegister("anaPs", function(module, exports) {

$parcel$export(module.exports, "typeAheadQuery", () => $78d473cb65f0df79$export$20af3dabbb5538df);

var $dpWhK = parcelRequire("dpWhK");

var $51dYk = parcelRequire("51dYk");
const $78d473cb65f0df79$export$20af3dabbb5538df = (0, $dpWhK.typeAheadQuery)({
    parseDOM: [
        {
            tag: 'span[data-type-ahead-query]'
        }
    ],
    toDOM (node) {
        return [
            'span',
            {
                'data-type-ahead-query': 'true',
                'data-trigger': node.attrs.trigger,
                style: `color: ${(0, $51dYk.B400)}`
            }
        ];
    }
});

});

parcelRegister("b7o0x", function(module, exports) {

$parcel$export(module.exports, "underline", () => $8182f89abb2f8453$export$425327af25286e5e);

var $dpWhK = parcelRequire("dpWhK");
const $8182f89abb2f8453$export$425327af25286e5e = (0, $dpWhK.underline)({
    parseDOM: [
        {
            tag: 'u'
        },
        {
            style: 'text-decoration',
            getAttrs: (value)=>value === 'underline' && null
        }
    ],
    toDOM () {
        return [
            'u'
        ];
    }
});

});

parcelRegister("kdb0W", function(module, exports) {

$parcel$export(module.exports, "unsupportedMark", () => $eb6d90b5414d615f$export$30d78d5eb6719bb8);

var $dpWhK = parcelRequire("dpWhK");
const $eb6d90b5414d615f$export$30d78d5eb6719bb8 = (0, $dpWhK.unsupportedMark)({
    toDOM () {
        return [
            'span'
        ];
    }
});

});

parcelRegister("3pgGD", function(module, exports) {

$parcel$export(module.exports, "unsupportedNodeAttribute", () => $27b0a68621bb260d$export$a316dc07ff5182a2);

var $dpWhK = parcelRequire("dpWhK");
const $27b0a68621bb260d$export$a316dc07ff5182a2 = (0, $dpWhK.unsupportedNodeAttribute)({
    toDOM () {
        return [
            'span'
        ];
    }
});

});

parcelRegister("5sqgz", function(module, exports) {

$parcel$export(module.exports, "blockCard", () => $3f93f1394abd8f36$export$c4c2f833baaebdb8);

var $nJVLW = parcelRequire("nJVLW");
/**
 * @name blockCard_node
 */ const $3f93f1394abd8f36$var$getCommonAttributesFromDom = (dom)=>{
    const anchor = dom;
    const data = anchor.getAttribute('data-card-data');
    const datasource = anchor.getAttribute('data-datasource');
    return {
        data: data ? JSON.parse(data) : undefined,
        layout: datasource ? dom.getAttribute('data-layout') || undefined : undefined,
        width: Number(dom.getAttribute('data-width')) || undefined,
        datasource: datasource ? JSON.parse(datasource) : undefined
    };
};
const $3f93f1394abd8f36$export$c4c2f833baaebdb8 = (0, $nJVLW.blockCard)({
    parseDOM: [
        {
            tag: 'a[data-block-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: (dom)=>{
                const anchor = dom;
                return {
                    url: anchor.getAttribute('href') || undefined,
                    ...$3f93f1394abd8f36$var$getCommonAttributesFromDom(dom)
                };
            }
        },
        {
            tag: 'div[data-block-card]',
            getAttrs: (dom)=>{
                const anchor = dom;
                return {
                    url: anchor.getAttribute('data-card-url') || undefined,
                    ...$3f93f1394abd8f36$var$getCommonAttributesFromDom(dom)
                };
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const { url: url } = node.attrs;
        const { data: data } = node.attrs;
        const { layout: layout, width: width, datasource: datasource } = node.attrs;
        const attrs = {
            'data-block-card': '',
            href: url || '',
            'data-card-data': data ? JSON.stringify(data) : '',
            'data-datasource': datasource ? JSON.stringify(datasource) : '',
            'data-layout': layout,
            'data-width': `${width}`
        };
        return [
            'a',
            attrs,
            (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.url) || ' '
        ];
    }
});

});

parcelRegister("kuVVV", function(module, exports) {

$parcel$export(module.exports, "bodiedExtension", () => $eec38c5829cd5cfe$export$27903d543b563e39);

var $fPSlo = parcelRequire("fPSlo");

var $nJVLW = parcelRequire("nJVLW");
const $eec38c5829cd5cfe$export$27903d543b563e39 = (0, $nJVLW.bodiedExtension)({
    parseDOM: [
        {
            context: 'bodiedExtension//',
            tag: '[data-node-type="bodied-extension"]',
            skip: true
        },
        {
            tag: '[data-node-type="bodied-extension"]',
            getAttrs: (domNode)=>(0, $fPSlo.getExtensionAttrs)(domNode)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'bodied-extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("7T1su", function(module, exports) {

$parcel$export(module.exports, "bulletListSelector", () => $5bdecd1b7c926ffc$export$5f25a39efab3b58b);
$parcel$export(module.exports, "bulletList", () => $5bdecd1b7c926ffc$export$a140c94e5ea26bee);

var $nJVLW = parcelRequire("nJVLW");
const $5bdecd1b7c926ffc$export$5f25a39efab3b58b = '.ak-ul';
const $5bdecd1b7c926ffc$export$a140c94e5ea26bee = (0, $nJVLW.bulletList)({
    parseDOM: [
        {
            tag: 'ul'
        }
    ],
    toDOM () {
        const attrs = {
            class: $5bdecd1b7c926ffc$export$5f25a39efab3b58b.substr(1)
        };
        return [
            'ul',
            attrs,
            0
        ];
    }
});

});

parcelRegister("l2o3P", function(module, exports) {

$parcel$export(module.exports, "caption", () => $f50c72db8a29084b$export$8e3c2dfdc4f0453d);

var $nJVLW = parcelRequire("nJVLW");
const $f50c72db8a29084b$export$8e3c2dfdc4f0453d = (0, $nJVLW.caption)({
    parseDOM: [
        {
            tag: 'figcaption[data-caption]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-caption': 'true'
        };
        return [
            'figcaption',
            attrs,
            0
        ];
    }
});

});

parcelRegister("02BNy", function(module, exports) {

$parcel$export(module.exports, "codeBlock", () => $007d81fc2959166a$export$7bb0d5c671655cc4);
$parcel$export(module.exports, "toJSON", () => $007d81fc2959166a$export$54fd2c36b5cc6731);

var $3xw6l = parcelRequire("3xw6l");

var $nJVLW = parcelRequire("nJVLW");
/**
 * @name codeBlock_with_no_marks_node
 */ /**
 * @name codeBlock_node
 */ const $007d81fc2959166a$var$getLanguageFromEditorStyle = (dom)=>{
    return dom.getAttribute('data-language') || undefined;
};
// example of BB style:
// <div class="codehilite language-javascript"><pre><span>hello world</span><span>\n</span></pre></div>
const $007d81fc2959166a$var$getLanguageFromBitbucketStyle = (dom)=>{
    if (dom && dom.classList.contains('codehilite')) // code block html from Bitbucket always contains an extra new line
    return $007d81fc2959166a$var$extractLanguageFromClass(dom.className);
    return;
};
// If there is a child code element, check that for data-language
const $007d81fc2959166a$var$getLanguageFromCode = (dom)=>{
    const firstChild = dom.firstElementChild;
    if (firstChild && firstChild.nodeName === 'CODE') return firstChild.getAttribute('data-language') || undefined;
};
const $007d81fc2959166a$var$extractLanguageFromClass = (className)=>{
    const languageRegex = /(?:^|\s)language-([^\s]+)/;
    const result = languageRegex.exec(className);
    if (result && result[1]) return result[1];
    return;
};
const $007d81fc2959166a$var$removeLastNewLine = (dom)=>{
    const parent = dom && dom.parentElement;
    if (parent && parent.classList.contains('codehilite')) dom.textContent = dom.textContent.replace(/\n$/, '');
    return dom;
};
function $007d81fc2959166a$var$parseCodeFromHtml(node) {
    let code = '';
    node.childNodes.forEach((child)=>{
        if (child.nodeType === Node.TEXT_NODE) // append text
        code += child.nodeValue;
        else if (child.nodeType === Node.ELEMENT_NODE && child instanceof Element) {
            const tagName = child.tagName.toLowerCase();
            if (tagName === 'div' || tagName === 'p') // add a newline before its content, unless it's the first child to avoid leading newlines
            {
                if (child.previousElementSibling !== null) code += '\n';
            }
            if (tagName === 'br') code += '\n';
            else code += $007d81fc2959166a$var$parseCodeFromHtml(child);
        }
    });
    return code;
}
const $007d81fc2959166a$export$7bb0d5c671655cc4 = (0, $nJVLW.codeBlock)({
    parseDOM: [
        {
            tag: 'pre',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                let dom = domNode;
                const language = $007d81fc2959166a$var$getLanguageFromBitbucketStyle(dom.parentElement) || $007d81fc2959166a$var$getLanguageFromEditorStyle(dom.parentElement) || $007d81fc2959166a$var$getLanguageFromCode(dom) || dom.getAttribute('data-language');
                dom = $007d81fc2959166a$var$removeLastNewLine(dom);
                return {
                    language: language
                };
            }
        },
        // Handle VSCode, Android Studio paste
        // Checking `white-space: pre-wrap` is too aggressive @see ED-2627
        {
            tag: 'div[style]',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                const dom = domNode;
                if (dom.style.whiteSpace === 'pre' || dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') > -1) return {};
                return false;
            },
            getContent: (domNode, schema)=>{
                const code = $007d81fc2959166a$var$parseCodeFromHtml(domNode);
                return code ? (0, $3xw6l.Fragment).from(schema.text(code)) : (0, $3xw6l.Fragment).empty;
            }
        },
        // Handle GitHub/Gist paste
        {
            tag: 'table[style]',
            preserveWhitespace: 'full',
            getAttrs: (dom)=>{
                if (dom.querySelector('td[class*="blob-code"]')) return {};
                return false;
            }
        },
        {
            tag: 'div.code-block',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                const dom = domNode;
                // TODO: ED-5604 Fix it inside `react-syntax-highlighter`
                // Remove line numbers
                const lineNumber = dom.querySelectorAll('.react-syntax-highlighter-line-number');
                if (lineNumber.length > 0) // It's possible to copy without the line numbers too hence this
                // `react-syntax-highlighter-line-number` check, so that we don't remove real code
                lineNumber.forEach((line)=>line.remove());
                return {};
            }
        }
    ],
    toDOM (node) {
        return [
            'pre',
            [
                'code',
                {
                    'data-language': node.attrs.language
                },
                0
            ]
        ];
    }
});
const $007d81fc2959166a$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs).reduce((memo, key)=>{
            if (key === 'uniqueId') return memo;
            if (key === 'language' && node.attrs.language === null) return memo;
            memo[key] = node.attrs[key];
            return memo;
        }, {})
    });

});

parcelRegister("itOTx", function(module, exports) {

$parcel$export(module.exports, "confluenceJiraIssue", () => $d7426a112a1f91a3$export$daf889beb5092f95);

var $nJVLW = parcelRequire("nJVLW");
const $d7426a112a1f91a3$var$name = 'confluenceJiraIssue';
const $d7426a112a1f91a3$export$daf889beb5092f95 = (0, $nJVLW.confluenceJiraIssue)({
    parseDOM: [
        {
            tag: `span[data-node-type="${$d7426a112a1f91a3$var$name}"]`,
            getAttrs: (domNode)=>{
                const dom = domNode;
                return {
                    issueKey: dom.textContent,
                    macroId: dom.dataset && dom.dataset.macroId,
                    schemaVersion: dom.dataset && dom.dataset.schemaVersion,
                    server: dom.dataset && dom.dataset.server,
                    serverId: dom.dataset && dom.dataset.serverId
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': $d7426a112a1f91a3$var$name,
            'data-macro-id': node.attrs.macroId,
            'data-schema-version': node.attrs.schemaVersion,
            'data-server': node.attrs.server,
            'data-server-id': node.attrs.serverId,
            'data-jira-issue': node.attrs.issueKey
        };
        return [
            'span',
            attrs,
            node.attrs.issueKey
        ];
    }
});

});

parcelRegister("99RFR", function(module, exports) {

$parcel$export(module.exports, "confluenceUnsupportedBlock", () => $01b87e4e18733712$export$e6e4878f43c27cab);

var $nJVLW = parcelRequire("nJVLW");
const $01b87e4e18733712$var$name = 'confluenceUnsupportedBlock';
const $01b87e4e18733712$export$e6e4878f43c27cab = (0, $nJVLW.confluenceUnsupportedBlock)({
    toDOM (node) {
        // NOTE: This node cannot be "contenteditable: false". If it's the only node in a document, PM throws an error because there's nowhere to put the cursor.
        const attrs = {
            'data-node-type': $01b87e4e18733712$var$name,
            'data-confluence-unsupported': 'block',
            'data-confluence-unsupported-block-cxhtml': node.attrs['cxhtml']
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    },
    parseDOM: [
        {
            tag: `div[data-node-type="${$01b87e4e18733712$var$name}"]`,
            getAttrs (dom) {
                return {
                    cxhtml: dom.getAttribute('data-confluence-unsupported-block-cxhtml')
                };
            }
        }
    ]
});

});

parcelRegister("4LGm1", function(module, exports) {

$parcel$export(module.exports, "confluenceUnsupportedInline", () => $378c67d877621958$export$3e6d667072febc87);

var $nJVLW = parcelRequire("nJVLW");
const $378c67d877621958$var$name = 'confluenceUnsupportedInline';
const $378c67d877621958$export$3e6d667072febc87 = (0, $nJVLW.confluenceUnsupportedInline)({
    toDOM (node) {
        const attrs = {
            'data-node-type': $378c67d877621958$var$name,
            'data-confluence-unsupported': 'inline',
            'data-confluence-unsupported-inline-cxhtml': node.attrs['cxhtml']
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    },
    parseDOM: [
        {
            tag: `div[data-node-type="${$378c67d877621958$var$name}"]`,
            getAttrs (dom) {
                return {
                    cxhtml: dom.getAttribute('data-confluence-unsupported-inline-cxhtml')
                };
            }
        }
    ]
});

});

parcelRegister("s7CHM", function(module, exports) {

$parcel$export(module.exports, "date", () => $0548877699ee10bf$export$324d90190a8b822a);

var $nJVLW = parcelRequire("nJVLW");
const $0548877699ee10bf$export$324d90190a8b822a = (0, $nJVLW.date)({
    parseDOM: [
        {
            tag: 'span[data-node-type="date"]',
            getAttrs: (dom)=>({
                    timestamp: dom.getAttribute('data-timestamp')
                })
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'date',
            'data-timestamp': node.attrs.timestamp
        };
        return [
            'span',
            attrs
        ];
    }
});

});

parcelRegister("eblOZ", function(module, exports) {

$parcel$export(module.exports, "decisionItem", () => $a533050aace96451$export$6959e16eeff859b4);

var $2OrIX = parcelRequire("2OrIX");

var $nJVLW = parcelRequire("nJVLW");
const $a533050aace96451$export$6959e16eeff859b4 = (0, $nJVLW.decisionItem)({
    parseDOM: [
        {
            tag: 'li[data-decision-local-id]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: (dom)=>({
                    localId: (0, $2OrIX.uuid).generate(),
                    state: dom.getAttribute('data-decision-state')
                })
        }
    ],
    toDOM (node) {
        const { localId: localId, state: state } = node.attrs;
        const attrs = {
            'data-decision-local-id': localId || 'local-decision',
            'data-decision-state': state
        };
        return [
            'li',
            attrs,
            0
        ];
    }
});

});

parcelRegister("9FkNK", function(module, exports) {

$parcel$export(module.exports, "decisionListSelector", () => $70981417a2cd0f7b$export$a5393ce68c2ff601);
$parcel$export(module.exports, "decisionList", () => $70981417a2cd0f7b$export$62d45a65fb43d95e);

var $2OrIX = parcelRequire("2OrIX");

var $nJVLW = parcelRequire("nJVLW");
/**
 * @name decisionList_node
 */ const $70981417a2cd0f7b$var$name = 'decisionList';
const $70981417a2cd0f7b$export$a5393ce68c2ff601 = `[data-node-type="${$70981417a2cd0f7b$var$name}"]`;
const $70981417a2cd0f7b$export$62d45a65fb43d95e = (0, $nJVLW.decisionList)({
    parseDOM: [
        {
            tag: `ol${$70981417a2cd0f7b$export$a5393ce68c2ff601}`,
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by ordered-list we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: ()=>({
                    localId: (0, $2OrIX.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        const { localId: localId } = node.attrs;
        const attrs = {
            'data-node-type': $70981417a2cd0f7b$var$name,
            'data-decision-list-local-id': localId || 'local-decision-list',
            style: 'list-style: none; padding-left: 0'
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});

});

parcelRegister("gjQyF", function(module, exports) {

$parcel$export(module.exports, "doc", () => $be1730a7caadbb4e$export$2a111da947c407d2);

var $nJVLW = parcelRequire("nJVLW");
const $be1730a7caadbb4e$export$2a111da947c407d2 = (0, $nJVLW.doc)({});

});

parcelRegister("YIci7", function(module, exports) {

$parcel$export(module.exports, "embedCard", () => $0b67e35d143af9e6$export$be4283d9a1cb1ff6);

var $nJVLW = parcelRequire("nJVLW");
const $0b67e35d143af9e6$export$be4283d9a1cb1ff6 = (0, $nJVLW.embedCard)({
    parseDOM: [
        {
            tag: 'div[data-embed-card]',
            getAttrs: (dom)=>({
                    url: dom.getAttribute('data-card-url'),
                    layout: dom.getAttribute('data-layout') || 'center',
                    width: Number(dom.getAttribute('data-width')) || null,
                    originalWidth: Number(dom.getAttribute('data-card-original-width')) || null,
                    originalHeight: Number(dom.getAttribute('data-card-original-height')) || null
                })
        }
    ],
    toDOM (node) {
        const { url: url, layout: layout, width: width, originalWidth: originalWidth, originalHeight: originalHeight } = node.attrs;
        const attrs = {
            'data-embed-card': '',
            'data-card-url': url,
            'data-layout': layout,
            'data-width': width,
            'data-original-width': originalWidth,
            'data-original-height': originalHeight
        };
        return [
            'div',
            attrs
        ];
    }
});

});

parcelRegister("foHUC", function(module, exports) {

$parcel$export(module.exports, "emoji", () => $b35b28eecd7e0f91$export$a19185d1233fc4b2);

var $4Dhy7 = parcelRequire("4Dhy7");

var $nJVLW = parcelRequire("nJVLW");
const $b35b28eecd7e0f91$export$a19185d1233fc4b2 = (0, $nJVLW.emoji)({
    parseDOM: [
        // Handle copy/paste beautiful panel from renderer />
        {
            tag: 'div.ak-editor-panel__icon span',
            ignore: true
        },
        {
            tag: 'span[data-emoji-short-name]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                return {
                    shortName: dom.getAttribute('data-emoji-short-name') || $b35b28eecd7e0f91$export$a19185d1233fc4b2.attrs.shortName.default,
                    id: dom.getAttribute('data-emoji-id') || $b35b28eecd7e0f91$export$a19185d1233fc4b2.attrs.id.default,
                    text: dom.getAttribute('data-emoji-text') || $b35b28eecd7e0f91$export$a19185d1233fc4b2.attrs.text.default
                };
            }
        },
        // Handle copy/paste from old <ac:emoticon />
        {
            tag: 'img[data-emoticon-name]',
            getAttrs: (dom)=>(0, $4Dhy7.acNameToEmoji)(dom.getAttribute('data-emoticon-name'))
        },
        // Handle copy/paste from old <ac:hipchat-emoticons />
        {
            tag: 'img[data-hipchat-emoticon]',
            getAttrs: (dom)=>(0, $4Dhy7.acShortcutToEmoji)(dom.getAttribute('data-hipchat-emoticon'))
        },
        // Handle copy/paste from bitbucket's <img class="emoji" />
        {
            tag: 'img.emoji[data-emoji-short-name]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                return {
                    shortName: dom.getAttribute('data-emoji-short-name') || $b35b28eecd7e0f91$export$a19185d1233fc4b2.attrs.shortName.default,
                    id: dom.getAttribute('data-emoji-id') || $b35b28eecd7e0f91$export$a19185d1233fc4b2.attrs.id.default,
                    text: dom.getAttribute('data-emoji-text') || $b35b28eecd7e0f91$export$a19185d1233fc4b2.attrs.text.default
                };
            }
        }
    ],
    toDOM (node) {
        const { shortName: shortName, id: id, text: text } = node.attrs;
        const attrs = {
            'data-emoji-short-name': shortName,
            'data-emoji-id': id,
            'data-emoji-text': text,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});

});
parcelRegister("4Dhy7", function(module, exports) {

$parcel$export(module.exports, "acNameToEmoji", () => $35f86add2efe8d16$export$f61e93bda2a8b420);
$parcel$export(module.exports, "acShortcutToEmoji", () => $35f86add2efe8d16$export$441f8b58f5790a68);
$parcel$export(module.exports, "getEmojiAcName", () => $35f86add2efe8d16$export$880a2465992fbbe);
// Default emoji id for Confluence glyphs that has no match to Fabric Emoji
const $35f86add2efe8d16$var$DEFAULT_EMOJI_ID = '2b50';
// Default ac:name for emoticons as a fallback is `blue-star`
const $35f86add2efe8d16$var$DEFAULT_EMOJI_ACNAME = 'blue-star';
// ac:hipchat-emoticon prefix when converting to Emoji ID
const $35f86add2efe8d16$var$HC_EMOTICON_PREFIX = 'atlassian-';
/**
 * Confluence glyphs ac:name of <ac:emoticon /> map to new emojis
 * {
 *   [ac:name] : ['emoji-id', 'emoji-shortName', 'emoji-fallback']
 *   ...
 * }
 * Glyphs that do not map to Fabric Emoji
 * will be mapped to Emoji Id '2b50' (:star:) with preserving ac:name as shortName attribute;
 */ const $35f86add2efe8d16$var$acNameToEmojiMap = {
    smile: [
        '1f642',
        ':slight_smile:',
        '\uD83D\uDE42'
    ],
    sad: [
        '1f641',
        ':slight_frown:',
        '\uD83D\uDE41'
    ],
    cheeky: [
        '1f61b',
        ':stuck_out_tongue:',
        '\uD83D\uDE1B'
    ],
    laugh: [
        '1f600',
        ':grinning:',
        '\uD83D\uDE00'
    ],
    wink: [
        '1f609',
        ':wink:',
        '\uD83D\uDE09'
    ],
    information: [
        '2139',
        ':information_source:',
        '\u2139'
    ],
    tick: [
        '2705',
        ':white_check_mark:',
        '\u2705'
    ],
    cross: [
        '274c',
        ':x:',
        '\u274C'
    ],
    warning: [
        '26a0',
        ':warning:',
        '\u26A0'
    ],
    plus: [
        '2795',
        ':heavy_plus_sign:',
        '\u2795'
    ],
    minus: [
        '2796',
        ':heavy_minus_sign:',
        '\u2796'
    ],
    question: [
        '2753',
        ':question:',
        '\u003F'
    ],
    'thumbs-up': [
        '1f44d',
        ':thumbsup:',
        '\uD83D\uDC4D'
    ],
    'thumbs-down': [
        '1f44e',
        ':thumbsdown:',
        '\uD83D\uDC4E'
    ],
    'light-on': [
        '1f4a1',
        ':bulb:',
        '\uD83D\uDCA1'
    ],
    'yellow-star': [
        '2b50',
        ':star:',
        '\uD83D\uDC9B'
    ],
    'light-off': [
        '1f6ab',
        ':no_entry_sign:',
        '\uD83D\uDEAB'
    ],
    'red-star': [
        '2764',
        ':heart:',
        '\u2764\uFE0F'
    ],
    'green-star': [
        '1f49a',
        ':green_heart:',
        '\uD83D\uDC9A'
    ],
    'blue-star': [
        '1f499',
        ':blue_heart:',
        '\uD83D\uDC99'
    ],
    heart: [
        '2764',
        ':heart:',
        '\u2764\uFE0F'
    ],
    'broken-heart': [
        '1f494',
        ':broken_heart:',
        '\uD83D\uDC94'
    ]
};
function $35f86add2efe8d16$export$f61e93bda2a8b420(acName) {
    const emojiData = $35f86add2efe8d16$var$acNameToEmojiMap[acName];
    return emojiData ? {
        id: emojiData[0],
        shortName: emojiData[1],
        text: emojiData[2]
    } : {
        id: $35f86add2efe8d16$var$DEFAULT_EMOJI_ID,
        shortName: `:${acName}:`,
        text: ''
    };
}
function $35f86add2efe8d16$export$bc94e44ec0e7bd82(emojiId) {
    const filterEmojis = (acName)=>$35f86add2efe8d16$var$acNameToEmojiMap[acName] ? $35f86add2efe8d16$var$acNameToEmojiMap[acName][0] === emojiId : false;
    return Object.keys($35f86add2efe8d16$var$acNameToEmojiMap).filter(filterEmojis)[0];
}
function $35f86add2efe8d16$export$441f8b58f5790a68(hipchatEmoticonShortName) {
    return {
        id: `${$35f86add2efe8d16$var$HC_EMOTICON_PREFIX}${hipchatEmoticonShortName}`,
        shortName: `:${hipchatEmoticonShortName}:`,
        text: ''
    };
}
function $35f86add2efe8d16$var$getAcNameFromShortName(shortName) {
    return shortName.slice(shortName[0] === ':' ? 1 : 0, shortName[shortName.length - 1] === ':' ? -1 : shortName.length);
}
function $35f86add2efe8d16$export$880a2465992fbbe({ id: id, shortName: shortName }) {
    if ($35f86add2efe8d16$var$DEFAULT_EMOJI_ID === id) {
        const possibleName = $35f86add2efe8d16$var$getAcNameFromShortName(shortName);
        if (possibleName in $35f86add2efe8d16$var$acNameToEmojiMap) return possibleName;
    }
    return $35f86add2efe8d16$export$bc94e44ec0e7bd82(id) || $35f86add2efe8d16$var$DEFAULT_EMOJI_ACNAME;
}

});


parcelRegister("iBSvH", function(module, exports) {

$parcel$export(module.exports, "blockquote", () => $d8c5f74ef3d86bcc$export$67dc04e652a298ca);
$parcel$export(module.exports, "extendedBlockquote", () => $d8c5f74ef3d86bcc$export$70a64939da3e8455);

var $nJVLW = parcelRequire("nJVLW");
/**
 * @name blockquote_node
 */ const $d8c5f74ef3d86bcc$var$nodeSpecOptions = {
    parseDOM: [
        {
            tag: 'blockquote'
        }
    ],
    toDOM () {
        return [
            'blockquote',
            0
        ];
    }
};
const $d8c5f74ef3d86bcc$export$67dc04e652a298ca = (0, $nJVLW.blockquoteLegacy)($d8c5f74ef3d86bcc$var$nodeSpecOptions);
const $d8c5f74ef3d86bcc$export$70a64939da3e8455 = (0, $nJVLW.blockquote)($d8c5f74ef3d86bcc$var$nodeSpecOptions);

});

parcelRegister("ePdnq", function(module, exports) {

$parcel$export(module.exports, "PanelType", () => $acb0347d33162113$export$969277cf61e5a7aa);
$parcel$export(module.exports, "extendedPanel", () => $acb0347d33162113$export$ce20b13564211141);

var $nJVLW = parcelRequire("nJVLW");
let $acb0347d33162113$export$969277cf61e5a7aa = /*#__PURE__*/ function(PanelType) {
    PanelType["INFO"] = "info";
    PanelType["NOTE"] = "note";
    PanelType["TIP"] = "tip";
    PanelType["WARNING"] = "warning";
    PanelType["ERROR"] = "error";
    PanelType["SUCCESS"] = "success";
    PanelType["CUSTOM"] = "custom";
    return PanelType;
}({});
/**
 * @name panel_node
 */ const $acb0347d33162113$var$getDomAttrs = (nodeAttrs)=>{
    const attrs = {
        'data-panel-type': nodeAttrs.panelType,
        'data-panel-icon': nodeAttrs.panelIcon,
        'data-panel-icon-id': nodeAttrs.panelIconId,
        'data-panel-icon-text': nodeAttrs.panelIconText,
        'data-panel-color': nodeAttrs.panelColor
    };
    return attrs;
};
const $acb0347d33162113$var$getParseDOMAttrs = (allowCustomPanel, dom)=>{
    let parseDOMAttrs = {
        panelType: dom.getAttribute('data-panel-type')
    };
    if (allowCustomPanel) parseDOMAttrs = {
        ...parseDOMAttrs,
        panelIcon: dom.getAttribute('data-panel-icon'),
        panelIconId: dom.getAttribute('data-panel-icon-id'),
        panelIconText: dom.getAttribute('data-panel-icon-text'),
        panelColor: dom.getAttribute('data-panel-color')
    };
    else parseDOMAttrs.panelType = parseDOMAttrs.panelType === $acb0347d33162113$export$969277cf61e5a7aa.CUSTOM ? $acb0347d33162113$export$969277cf61e5a7aa.INFO : parseDOMAttrs.panelType;
    return parseDOMAttrs;
};
const $acb0347d33162113$var$createPanelNodeSpecOptions = (allowCustomPanel)=>({
        parseDOM: [
            {
                tag: 'div[data-panel-type]',
                getAttrs: (dom)=>$acb0347d33162113$var$getParseDOMAttrs(allowCustomPanel, dom)
            }
        ],
        toDOM (node) {
            const attrs = $acb0347d33162113$var$getDomAttrs(node.attrs);
            const contentAttrs = {
                'data-panel-content': 'true'
            };
            return [
                'div',
                attrs,
                [
                    'div',
                    contentAttrs,
                    0
                ]
            ];
        }
    });
const $acb0347d33162113$export$ce20b13564211141 = (allowCustomPanel)=>(0, $nJVLW.panel)($acb0347d33162113$var$createPanelNodeSpecOptions(allowCustomPanel));

});

parcelRegister("6r1B4", function(module, exports) {

$parcel$export(module.exports, "extension", () => $01358634d8baf68a$export$1b45514b112dd749);

var $fPSlo = parcelRequire("fPSlo");

var $nJVLW = parcelRequire("nJVLW");
const $01358634d8baf68a$export$1b45514b112dd749 = (0, $nJVLW.extension)({
    parseDOM: [
        {
            tag: '[data-node-type="extension"]',
            getAttrs: (domNode)=>(0, $fPSlo.getExtensionAttrs)(domNode)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs
        ];
    }
});

});

parcelRegister("ewUmv", function(module, exports) {

$parcel$export(module.exports, "hardBreak", () => $a93fc62957e42117$export$371da9dd35aba193);

var $nJVLW = parcelRequire("nJVLW");
const $a93fc62957e42117$export$371da9dd35aba193 = (0, $nJVLW.hardBreak)({
    parseDOM: [
        {
            tag: 'br'
        }
    ],
    toDOM () {
        return [
            'br'
        ];
    }
});

});

parcelRegister("8FGKL", function(module, exports) {

$parcel$export(module.exports, "heading", () => $650350f97a125578$export$46e4a324ac90507f);

var $nJVLW = parcelRequire("nJVLW");
/**
 * @name heading_node
 */ /**
 * @name heading_with_no_marks_node
 */ // Check `paragraph` node for why we are doing things like this
/**
 * @name heading_with_alignment_node
 */ /**
 * @name heading_with_indentation_node
 */ const $650350f97a125578$var$getAttrs = (level)=>(domNode)=>{
        var _heading$attrs, _heading$attrs$localI;
        return {
            level: level,
            localId: domNode.getAttribute('data-local-id') || ((_heading$attrs = $650350f97a125578$export$46e4a324ac90507f.attrs) === null || _heading$attrs === void 0 ? void 0 : (_heading$attrs$localI = _heading$attrs.localId) === null || _heading$attrs$localI === void 0 ? void 0 : _heading$attrs$localI.default)
        };
    };
const $650350f97a125578$export$46e4a324ac90507f = (0, $nJVLW.heading)({
    parseDOM: [
        {
            tag: 'h1',
            getAttrs: $650350f97a125578$var$getAttrs(1)
        },
        {
            tag: 'h2',
            getAttrs: $650350f97a125578$var$getAttrs(2)
        },
        {
            tag: 'h3',
            getAttrs: $650350f97a125578$var$getAttrs(3)
        },
        {
            tag: 'h4',
            getAttrs: $650350f97a125578$var$getAttrs(4)
        },
        {
            tag: 'h5',
            getAttrs: $650350f97a125578$var$getAttrs(5)
        },
        {
            tag: 'h6',
            getAttrs: $650350f97a125578$var$getAttrs(6)
        }
    ],
    toDOM (node) {
        const { level: level, localId: localId } = node.attrs;
        const name = 'h' + level;
        const attrs = localId !== undefined && localId !== null ? [
            {
                'data-local-id': localId
            }
        ] : [];
        return [
            name,
            ...attrs,
            0
        ];
    }
});

});

parcelRegister("lM0g9", function(module, exports) {

$parcel$export(module.exports, "image", () => $fd9e48320ef47dab$export$5c452ff88e35e47d);

var $nJVLW = parcelRequire("nJVLW");
const $fd9e48320ef47dab$export$5c452ff88e35e47d = (0, $nJVLW.image)({
    parseDOM: [
        {
            tag: 'img[src^="data:image/"]',
            ignore: true
        },
        {
            tag: 'img[src]',
            getAttrs (domNode) {
                const dom = domNode;
                return {
                    src: dom.getAttribute('src'),
                    alt: dom.getAttribute('alt'),
                    title: dom.getAttribute('title')
                };
            }
        }
    ],
    toDOM (node) {
        return [
            'img',
            node.attrs
        ];
    }
});

});

parcelRegister("3MHOZ", function(module, exports) {

$parcel$export(module.exports, "inlineCard", () => $2c17d8cd4306fb03$export$cbf8224b64e0d942);

var $nJVLW = parcelRequire("nJVLW");
const $2c17d8cd4306fb03$export$cbf8224b64e0d942 = (0, $nJVLW.inlineCard)({
    parseDOM: [
        {
            tag: 'a[data-inline-card], span[data-inline-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: (dom)=>{
                const anchor = dom;
                const data = anchor.getAttribute('data-card-data');
                /* Support attrs from Editor and Renderer */ return {
                    url: anchor.getAttribute('href') || anchor.getAttribute('data-card-url') || null,
                    data: data ? JSON.parse(data) : null
                };
            }
        },
        // for renderer
        {
            tag: 'div[data-inline-card]',
            getAttrs: (dom)=>{
                const anchor = dom;
                const data = anchor.getAttribute('data-card-data');
                return {
                    url: anchor.getAttribute('data-card-url'),
                    data: data ? JSON.parse(data) : null
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-inline-card': '',
            href: node.attrs.url || '',
            'data-card-data': node.attrs.data ? JSON.stringify(node.attrs.data) : ''
        };
        if (node.attrs.url) return [
            'a',
            attrs,
            node.attrs.url
        ];
        else return [
            'a',
            attrs
        ];
    }
});

});

parcelRegister("5Ufvu", function(module, exports) {

$parcel$export(module.exports, "inlineExtension", () => $44ce3609d5dda29d$export$16b353b2649bd8d9);

var $fPSlo = parcelRequire("fPSlo");

var $nJVLW = parcelRequire("nJVLW");
const $44ce3609d5dda29d$export$16b353b2649bd8d9 = (0, $nJVLW.inlineExtensionWithMarks)({
    parseDOM: [
        {
            tag: 'span[data-extension-type]',
            getAttrs: (domNode)=>(0, $fPSlo.getExtensionAttrs)(domNode, true)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-local-id:': node.attrs.localId,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs
        ];
    }
});

});

parcelRegister("gNk91", function(module, exports) {

$parcel$export(module.exports, "layoutColumn", () => $c3a0d938bf65ffc4$export$ab76e7c03cd6f650);

var $nJVLW = parcelRequire("nJVLW");
const $c3a0d938bf65ffc4$export$ab76e7c03cd6f650 = (0, $nJVLW.layoutColumn)({
    parseDOM: [
        {
            context: 'layoutColumn//',
            tag: 'div[data-layout-column]',
            skip: true
        },
        {
            tag: 'div[data-layout-column]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                return {
                    width: Number(dom.getAttribute('data-column-width')) || undefined
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-layout-column': 'true'
        };
        const { width: width } = node.attrs;
        if (width) {
            attrs['style'] = `flex-basis: ${width}%`;
            attrs['data-column-width'] = `${width}`;
        }
        // We need to apply a attribute to the inner most child to help
        // ProseMirror identify its boundaries better.
        const contentAttrs = {
            'data-layout-content': 'true'
        };
        return [
            'div',
            attrs,
            [
                'div',
                contentAttrs,
                0
            ]
        ];
    }
});

});

parcelRegister("bTlUc", function(module, exports) {

$parcel$export(module.exports, "createMediaSpec", () => $8a85d2bbd938d1a8$export$35bdbf5bc8caa677);
$parcel$export(module.exports, "copyPrivateAttributes", () => $8a85d2bbd938d1a8$export$111130fa8968d741);
$parcel$export(module.exports, "media", () => $8a85d2bbd938d1a8$export$987d49ffe1b0900f);
$parcel$export(module.exports, "toJSON", () => $8a85d2bbd938d1a8$export$54fd2c36b5cc6731);

var $51dYk = parcelRequire("51dYk");

var $nJVLW = parcelRequire("nJVLW");
const $8a85d2bbd938d1a8$export$bb3fe706be61f640 = (0, $nJVLW.media)({}).attrs;
const $8a85d2bbd938d1a8$export$35bdbf5bc8caa677 = (attributes, inline = false)=>{
    const domNodeType = inline ? 'span' : 'div';
    const nodeName = inline ? 'mediaInline' : 'media';
    const parseDOM = [
        {
            tag: `${domNodeType}[data-node-type="${nodeName}"]`,
            getAttrs: (dom)=>{
                const attrs = {};
                if (attributes) Object.keys(attributes).forEach((k)=>{
                    const key = $8a85d2bbd938d1a8$export$f84fdfb973c05bd8(k).replace(/^__/, '');
                    const value = dom.getAttribute(`data-${key}`) || '';
                    if (value) attrs[k] = value;
                });
                // Need to do validation & type conversion manually
                if (attrs.__fileSize) attrs.__fileSize = +attrs.__fileSize;
                const width = Number(attrs.width);
                if (typeof width !== 'undefined' && !isNaN(width)) attrs.width = width;
                const height = Number(attrs.height);
                if (typeof height !== 'undefined' && !isNaN(height)) attrs.height = height;
                return attrs;
            }
        },
        // Don't match data URI
        {
            tag: 'img[src^="data:image"]',
            ignore: true
        }
    ];
    const toDOM = (node)=>{
        const attrs = {
            'data-id': node.attrs.id,
            'data-node-type': `${nodeName}`,
            'data-type': node.attrs.type,
            'data-collection': node.attrs.collection,
            'data-occurrence-key': node.attrs.occurrenceKey,
            'data-width': node.attrs.width,
            'data-height': node.attrs.height,
            'data-url': node.attrs.url,
            'data-alt': node.attrs.alt,
            // toDOM is used for static rendering as well as editor rendering. This comes into play for
            // emails, copy/paste, etc, so the title and styling here *is* useful (despite a React-based
            // node view being used for editing).
            title: 'Attachment',
            // Manually kept in sync with the style of media cards. The goal is to render a plain gray
            // rectangle that provides an affordance for media.
            style: `display: inline-block; border-radius: 3px; background: ${(0, $51dYk.N30)}; box-shadow: 0 1px 1px rgba(9, 30, 66, 0.2), 0 0 1px 0 rgba(9, 30, 66, 0.24);`
        };
        $8a85d2bbd938d1a8$export$111130fa8968d741(node.attrs, attrs, (key)=>`data-${$8a85d2bbd938d1a8$export$f84fdfb973c05bd8(key.slice(2))}`);
        return [
            `${domNodeType}`,
            attrs
        ];
    };
    if (inline) return (0, $nJVLW.mediaInline)({
        parseDOM: parseDOM,
        toDOM: toDOM
    });
    return (0, $nJVLW.media)({
        parseDOM: [
            ...parseDOM,
            {
                // media-inline.ts uses this same function to generate the nodespec
                // this ensures that we don't make a media inline out of a copied image
                // https://product-fabric.atlassian.net/browse/EDM-2996
                tag: 'img:not(.smart-link-icon)',
                getAttrs: (dom)=>{
                    return {
                        type: 'external',
                        url: dom.getAttribute('src') || '',
                        alt: dom.getAttribute('alt') || ''
                    };
                }
            }
        ],
        toDOM: toDOM
    });
};
const $8a85d2bbd938d1a8$export$987d49ffe1b0900f = $8a85d2bbd938d1a8$export$35bdbf5bc8caa677($8a85d2bbd938d1a8$export$bb3fe706be61f640, false);
const $8a85d2bbd938d1a8$export$f84fdfb973c05bd8 = (str)=>str.replace(/([^A-Z]+)([A-Z])/g, (_, x, y)=>`${x}-${y.toLowerCase()}`);
const $8a85d2bbd938d1a8$export$111130fa8968d741 = (from, to, map)=>{
    if ($8a85d2bbd938d1a8$export$987d49ffe1b0900f.attrs) Object.keys($8a85d2bbd938d1a8$export$987d49ffe1b0900f.attrs).forEach((key)=>{
        if (key[0] === '_' && key[1] === '_' && from[key]) to[map ? map(key) : key] = from[key];
    });
};
/**
 * There's no concept of optional property in ProseMirror. It sets value as `null`
 * when there's no use of any property. We are filtering out all private & optional attrs here.
 */ const $8a85d2bbd938d1a8$var$optionalAttributes = [
    'occurrenceKey',
    'width',
    'height',
    'url',
    'alt'
];
const $8a85d2bbd938d1a8$var$externalOnlyAttributes = [
    'type',
    'url',
    'width',
    'height',
    'alt'
];
const $8a85d2bbd938d1a8$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs)// Strip private attributes e.g. __fileName, __fileSize, __fileMimeType, etc.
        .filter((key)=>!(key[0] === '_' && key[1] === '_')).reduce((obj, key)=>{
            if (node.attrs.type === 'external' && $8a85d2bbd938d1a8$var$externalOnlyAttributes.indexOf(key) === -1) return obj;
            if ($8a85d2bbd938d1a8$var$optionalAttributes.indexOf(key) > -1 && (node.attrs[key] === null || node.attrs[key] === '')) return obj;
            if ([
                'width',
                'height'
            ].indexOf(key) !== -1) {
                obj[key] = Number(node.attrs[key]);
                return obj;
            }
            obj[key] = node.attrs[key];
            return obj;
        }, {})
    });

});

parcelRegister("goVGV", function(module, exports) {

$parcel$export(module.exports, "mediaGroup", () => $bf0ba381e6b14c0b$export$2855e964765eac9);

var $nJVLW = parcelRequire("nJVLW");
const $bf0ba381e6b14c0b$export$2855e964765eac9 = (0, $nJVLW.mediaGroup)({
    parseDOM: [
        {
            tag: 'div[data-node-type="mediaGroup"]'
        },
        {
            tag: 'div[class="MediaGroup"]'
        }
    ],
    toDOM () {
        return [
            'div',
            {
                'data-node-type': 'mediaGroup'
            },
            0
        ];
    }
});

});

parcelRegister("5RVMs", function(module, exports) {

$parcel$export(module.exports, "mediaInline", () => $445eb905c73a8551$export$38bab695e3f720f1);

var $bTlUc = parcelRequire("bTlUc");

var $nJVLW = parcelRequire("nJVLW");
const $445eb905c73a8551$export$38bab695e3f720f1 = (0, $bTlUc.createMediaSpec)((0, $nJVLW.mediaInline)({}).attrs, true);

});

parcelRegister("8Mfla", function(module, exports) {

$parcel$export(module.exports, "mediaSingleSpec", () => $663eb4b9329f7335$export$5a1e124099b60c6b);
$parcel$export(module.exports, "mediaSingle", () => $663eb4b9329f7335$export$969fe3781ca15058);
$parcel$export(module.exports, "mediaSingleWithCaption", () => $663eb4b9329f7335$export$d35e6c006d4abdfb);
$parcel$export(module.exports, "mediaSingleWithWidthType", () => $663eb4b9329f7335$export$9c58e19811ce4cf5);
$parcel$export(module.exports, "mediaSingleFull", () => $663eb4b9329f7335$export$7e767666f2ce108a);
$parcel$export(module.exports, "toJSON", () => $663eb4b9329f7335$export$54fd2c36b5cc6731);

var $QD9UD = parcelRequire("QD9UD");

var $j783N = parcelRequire("j783N");

var $nJVLW = parcelRequire("nJVLW");
const $663eb4b9329f7335$export$bb3fe706be61f640 = {
    width: {
        default: null
    },
    // null makes small images to have original size by default
    layout: {
        default: 'center'
    }
};
const $663eb4b9329f7335$export$5a1e124099b60c6b = ({ withCaption: withCaption = false, withExtendedWidthTypes: withExtendedWidthTypes = false })=>{
    const getAttrs = (dom)=>{
        if (!(0, $j783N.isDOMElement)(dom)) // this should never happen
        return {
            layout: 'center'
        };
        const layout = dom.getAttribute('data-layout') || 'center';
        const width = Number(dom.getAttribute('data-width')) || null;
        const widthType = dom.getAttribute('data-width-type');
        if (withExtendedWidthTypes) return {
            layout: layout,
            width: width,
            widthType: widthType
        };
        else if (widthType === (0, $QD9UD.WidthType).PIXEL) // if editor does not support widthType attribute.
        // We ignore width and widthType together.
        return {
            layout: layout
        };
        else return {
            layout: layout,
            width: width
        };
    };
    const getAttrsFromNode = (node)=>{
        const { layout: layout, width: width } = node.attrs;
        const attrs = {
            'data-node-type': 'mediaSingle',
            'data-layout': layout,
            'data-width': ''
        };
        if (width) attrs['data-width'] = isFinite(width) && Math.floor(width) === width ? width : width.toFixed(2);
        if (withExtendedWidthTypes && node.attrs.widthType) {
            const { widthType: widthType } = node.attrs;
            return {
                ...attrs,
                'data-width-type': widthType || (0, $QD9UD.WidthType).PERCENTAGE
            };
        }
        return attrs;
    };
    if (withExtendedWidthTypes && withCaption) return (0, $nJVLW.mediaSingleFull)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    if (withExtendedWidthTypes && !withCaption) return (0, $nJVLW.mediaSingleWidthType)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    if (!withExtendedWidthTypes && withCaption) return (0, $nJVLW.mediaSingleCaption)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    return (0, $nJVLW.mediaSingle)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
};
const $663eb4b9329f7335$export$969fe3781ca15058 = $663eb4b9329f7335$export$5a1e124099b60c6b({
    withCaption: false,
    withExtendedWidthTypes: false
});
const $663eb4b9329f7335$export$d35e6c006d4abdfb = $663eb4b9329f7335$export$5a1e124099b60c6b({
    withCaption: true,
    withExtendedWidthTypes: false
});
const $663eb4b9329f7335$export$9c58e19811ce4cf5 = $663eb4b9329f7335$export$5a1e124099b60c6b({
    withCaption: false,
    withExtendedWidthTypes: true
});
const $663eb4b9329f7335$export$7e767666f2ce108a = $663eb4b9329f7335$export$5a1e124099b60c6b({
    withCaption: true,
    withExtendedWidthTypes: true
});
const $663eb4b9329f7335$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs).reduce((obj, key)=>{
            if (node.attrs[key] !== null) obj[key] = node.attrs[key];
            return obj;
        }, {})
    });

});
parcelRegister("QD9UD", function(module, exports) {

$parcel$export(module.exports, "WidthType", () => $09e33b94b508f894$export$4d41558722ac7eed);
/**
 * @description The widthType attribute is used to support fixed with media single
 */ let $09e33b94b508f894$export$4d41558722ac7eed = /*#__PURE__*/ function(WidthType) {
    WidthType["PIXEL"] = "pixel";
    WidthType["PERCENTAGE"] = "percentage";
    return WidthType;
}({});

});


parcelRegister("7axvl", function(module, exports) {

$parcel$export(module.exports, "mention", () => $538374e55dff7f13$export$db83999c14438df4);
$parcel$export(module.exports, "toJSON", () => $538374e55dff7f13$export$54fd2c36b5cc6731);

var $2OrIX = parcelRequire("2OrIX");

var $nJVLW = parcelRequire("nJVLW");
let $538374e55dff7f13$export$abebb208988c258 = /*#__PURE__*/ function(USER_TYPES) {
    USER_TYPES["DEFAULT"] = "DEFAULT";
    USER_TYPES["SPECIAL"] = "SPECIAL";
    USER_TYPES["APP"] = "APP";
    return USER_TYPES;
}({});
const $538374e55dff7f13$export$db83999c14438df4 = (0, $nJVLW.mention)({
    parseDOM: [
        {
            tag: 'span[data-mention-id]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                const attrs = {
                    id: dom.getAttribute('data-mention-id') || $538374e55dff7f13$export$db83999c14438df4.attrs.id.default,
                    text: dom.textContent || $538374e55dff7f13$export$db83999c14438df4.attrs.text.default,
                    accessLevel: dom.getAttribute('data-access-level') || $538374e55dff7f13$export$db83999c14438df4.attrs.accessLevel.default,
                    localId: (0, $2OrIX.uuid).generate()
                };
                const userType = dom.getAttribute('data-user-type');
                if ($538374e55dff7f13$export$abebb208988c258[userType]) attrs.userType = userType;
                return attrs;
            }
        }
    ],
    toDOM (node) {
        const { id: id, accessLevel: accessLevel, text: text, userType: userType, localId: localId } = node.attrs;
        const attrs = {
            'data-mention-id': id,
            'data-access-level': accessLevel,
            contenteditable: 'false'
        };
        if (localId) attrs['data-local-id'] = localId;
        if (userType) attrs['data-user-type'] = userType;
        return [
            'span',
            attrs,
            text
        ];
    }
});
const $538374e55dff7f13$var$isOptional = (key)=>{
    return [
        'userType',
        'localId'
    ].indexOf(key) > -1;
};
const $538374e55dff7f13$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs).reduce((obj, key)=>{
            if ($538374e55dff7f13$var$isOptional(key) && !node.attrs[key]) return obj;
            return {
                ...obj,
                [key]: node.attrs[key]
            };
        }, {})
    });

});

parcelRegister("6UEeD", function(module, exports) {

$parcel$export(module.exports, "nestedExpand", () => $50872edefbef1f48$export$63cadbf5f4296627);

var $nJVLW = parcelRequire("nJVLW");
/**
 * @name nestedExpand_content
 * @minItems 1
 * @allowUnsupportedBlock true
 */ /**
 * @name nestedExpand_node
 */ /**
 * @name nestedExpand_with_no_marks_node
 */ function $50872edefbef1f48$var$getExpandAttrs(domNode) {
    const dom = domNode;
    return {
        title: dom.getAttribute('data-title'),
        __expanded: true
    };
}
const $50872edefbef1f48$var$nestedExpandFactoryOptions = {
    parseDOM: [
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="nestedExpand"]',
            getAttrs: $50872edefbef1f48$var$getExpandAttrs
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="nestedExpand"]',
            getAttrs: $50872edefbef1f48$var$getExpandAttrs
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'nestedExpand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};
const $50872edefbef1f48$export$63cadbf5f4296627 = (0, $nJVLW.nestedExpand)($50872edefbef1f48$var$nestedExpandFactoryOptions);

});

parcelRegister("a4ifE", function(module, exports) {

$parcel$export(module.exports, "orderedListSelector", () => $75486f772c8c4cf6$export$4e7125c7ff595be5);
$parcel$export(module.exports, "orderedList", () => $75486f772c8c4cf6$export$a5dc81035676e7a);
$parcel$export(module.exports, "orderedListWithOrder", () => $75486f772c8c4cf6$export$b9ab759e8298198f);

var $nJVLW = parcelRequire("nJVLW");
const $75486f772c8c4cf6$export$4e7125c7ff595be5 = '.ak-ol';
const $75486f772c8c4cf6$export$a5dc81035676e7a = (0, $nJVLW.orderedList)({
    parseDOM: [
        {
            tag: 'ol'
        }
    ],
    toDOM () {
        const attrs = {
            class: $75486f772c8c4cf6$export$4e7125c7ff595be5.substr(1)
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});
// resolve "start" to a safe, 0+ integer, otherwise return undefined
// Note: Any changes to this function should also be made to "resolveOrder"
// in packages/editor/editor-common/src/utils/list.ts
const $75486f772c8c4cf6$var$resolveStart = (start)=>{
    const num = Number(start);
    if (Number.isNaN(num)) return;
    if (num < 0) return;
    return Math.floor(Math.max(num, 0));
};
const $75486f772c8c4cf6$export$b9ab759e8298198f = (0, $nJVLW.orderedList)({
    parseDOM: [
        {
            tag: 'ol',
            getAttrs: (domNode)=>{
                const dom = domNode;
                const startDOMAttr = dom.getAttribute('start');
                if (startDOMAttr) {
                    const start = $75486f772c8c4cf6$var$resolveStart(startDOMAttr);
                    if (typeof start === 'number') return {
                        order: start
                    };
                }
                return null;
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const start = $75486f772c8c4cf6$var$resolveStart(node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.order);
        const attrs = {
            start: typeof start === 'number' ? String(start) : undefined,
            class: $75486f772c8c4cf6$export$4e7125c7ff595be5.substr(1)
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});

});

parcelRegister("bK3tx", function(module, exports) {

$parcel$export(module.exports, "paragraph", () => $88c6afc1badc0455$export$9c206ddddb32a9b);

var $nJVLW = parcelRequire("nJVLW");
const $88c6afc1badc0455$export$9c206ddddb32a9b = (0, $nJVLW.paragraph)({
    parseDOM: [
        {
            tag: 'p',
            getAttrs: (domNode)=>{
                var _paragraph$attrs, _paragraph$attrs$loca;
                const dom = domNode;
                const attrs = {
                    localId: dom.getAttribute('data-local-id') || ((_paragraph$attrs = $88c6afc1badc0455$export$9c206ddddb32a9b.attrs) === null || _paragraph$attrs === void 0 ? void 0 : (_paragraph$attrs$loca = _paragraph$attrs.localId) === null || _paragraph$attrs$loca === void 0 ? void 0 : _paragraph$attrs$loca.default)
                };
                return attrs;
            }
        }
    ],
    toDOM (node) {
        const { localId: localId } = node.attrs;
        const name = 'p';
        const attrs = localId !== undefined && localId !== null ? [
            {
                'data-local-id': localId
            }
        ] : [];
        return [
            name,
            ...attrs,
            0
        ];
    }
});

});

parcelRegister("hbObi", function(module, exports) {

$parcel$export(module.exports, "placeholder", () => $c83a63aa944f66a1$export$c7187bbd1a7a9244);

var $nJVLW = parcelRequire("nJVLW");
const $c83a63aa944f66a1$export$c7187bbd1a7a9244 = (0, $nJVLW.placeholder)({
    parseDOM: [
        {
            tag: 'span[data-placeholder]',
            getAttrs: (dom)=>({
                    text: dom.getAttribute('data-placeholder') || $c83a63aa944f66a1$export$c7187bbd1a7a9244.attrs.text.default
                })
        }
    ],
    toDOM (node) {
        const { text: text } = node.attrs;
        const attrs = {
            'data-placeholder': text,
            // Needs to be edtiable for mobile to not close keyboard
            contenteditable: 'true'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});

});

parcelRegister("jC4KP", function(module, exports) {

$parcel$export(module.exports, "rule", () => $e475410b583b636d$export$fbeb3a3956e8a3c7);

var $nJVLW = parcelRequire("nJVLW");
/**
 * @name rule_node
 */ const $e475410b583b636d$var$hrDOM = [
    'hr'
];
const $e475410b583b636d$export$fbeb3a3956e8a3c7 = (0, $nJVLW.rule)({
    parseDOM: [
        {
            tag: 'hr'
        }
    ],
    toDOM () {
        return $e475410b583b636d$var$hrDOM;
    }
});

});

parcelRegister("c2Gqu", function(module, exports) {

$parcel$export(module.exports, "status", () => $8c4694e34f16e8bc$export$471f7ae5c4103ae1);

var $2OrIX = parcelRequire("2OrIX");

var $nJVLW = parcelRequire("nJVLW");
const $8c4694e34f16e8bc$export$471f7ae5c4103ae1 = (0, $nJVLW.status)({
    parseDOM: [
        {
            tag: 'span[data-node-type="status"]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                return {
                    text: dom.textContent.replace(/\n/, '').trim(),
                    color: dom.getAttribute('data-color'),
                    localId: (0, $2OrIX.uuid).generate(),
                    style: dom.getAttribute('data-style')
                };
            }
        }
    ],
    toDOM (node) {
        const { text: text, color: color, localId: localId, style: style } = node.attrs;
        const attrs = {
            'data-node-type': 'status',
            'data-color': color,
            'data-local-id': localId,
            'data-style': style,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});

});

parcelRegister("5iuEY", function(module, exports) {

$parcel$export(module.exports, "taskItem", () => $3db66a9f0ad7bab5$export$6d8b0ef52e2e6390);

var $2OrIX = parcelRequire("2OrIX");

var $nJVLW = parcelRequire("nJVLW");
const $3db66a9f0ad7bab5$export$6d8b0ef52e2e6390 = (0, $nJVLW.taskItem)({
    parseDOM: [
        {
            tag: 'div[data-task-local-id]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: (dom)=>({
                    localId: (0, $2OrIX.uuid).generate(),
                    state: dom.getAttribute('data-task-state') || 'TODO'
                })
        }
    ],
    toDOM (node) {
        const { localId: localId, state: state } = node.attrs;
        const attrs = {
            'data-task-local-id': localId || 'local-task',
            'data-task-state': state || 'TODO'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("6Yq90", function(module, exports) {

$parcel$export(module.exports, "taskListSelector", () => $014f6df118f8d370$export$c0ec71adb7a18fb2);
$parcel$export(module.exports, "taskList", () => $014f6df118f8d370$export$375b6afcc5f4d291);

var $2OrIX = parcelRequire("2OrIX");

var $nJVLW = parcelRequire("nJVLW");
/**
 * @name taskList_node
 */ const $014f6df118f8d370$var$name = 'actionList';
const $014f6df118f8d370$export$c0ec71adb7a18fb2 = `[data-node-type="${$014f6df118f8d370$var$name}"]`;
const $014f6df118f8d370$export$375b6afcc5f4d291 = (0, $nJVLW.taskList)({
    parseDOM: [
        {
            tag: `div${$014f6df118f8d370$export$c0ec71adb7a18fb2}`,
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by ordered-list we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: ()=>({
                    localId: (0, $2OrIX.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        const { localId: localId } = node.attrs;
        const attrs = {
            'data-node-type': $014f6df118f8d370$var$name,
            'data-task-list-local-id': localId || 'local-task-list',
            style: 'list-style: none; padding-left: 0'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("53i5t", function(module, exports) {

$parcel$export(module.exports, "text", () => $3adb434dc421ab11$export$6f093cfa640b7166);

var $nJVLW = parcelRequire("nJVLW");
const $3adb434dc421ab11$export$6f093cfa640b7166 = (0, $nJVLW.text)({
    toDebugString: ()=>'text_node'
});

});

parcelRegister("bffKB", function(module, exports) {

$parcel$export(module.exports, "default", () => $82fd5027b66be343$export$2e2bcd8739ae039);
const $82fd5027b66be343$var$name = 'unknownBlock';
var $82fd5027b66be343$export$2e2bcd8739ae039 = {
    group: 'block',
    content: 'inline+',
    marks: '_',
    toDOM () {
        return [
            'div',
            {
                'data-node-type': $82fd5027b66be343$var$name
            },
            0
        ];
    },
    parseDOM: [
        {
            tag: `div[data-node-type="${$82fd5027b66be343$var$name}"]`
        }
    ]
};

});

parcelRegister("e1kFZ", function(module, exports) {

$parcel$export(module.exports, "unsupportedBlock", () => $a3513293b95ecc1d$export$44b79b0979d0f0f7);

var $nJVLW = parcelRequire("nJVLW");
const $a3513293b95ecc1d$export$44b79b0979d0f0f7 = (0, $nJVLW.unsupportedBlock)({
    parseDOM: [
        {
            tag: '[data-node-type="unsupportedBlock"]',
            getAttrs: (dom)=>({
                    originalValue: JSON.parse(dom.getAttribute('data-original-value') || '{}')
                })
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'unsupportedBlock',
            'data-original-value': JSON.stringify(node.attrs.originalValue)
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    }
});

});

parcelRegister("5blh0", function(module, exports) {

$parcel$export(module.exports, "unsupportedInline", () => $3c5e7b4352f31e0d$export$310ebe0d80122e9b);

var $nJVLW = parcelRequire("nJVLW");
const $3c5e7b4352f31e0d$export$310ebe0d80122e9b = (0, $nJVLW.unsupportedInline)({
    parseDOM: [
        {
            tag: '[data-node-type="unsupportedInline"]',
            getAttrs: (dom)=>({
                    originalValue: JSON.parse(dom.getAttribute('data-original-value') || '{}')
                })
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'unsupportedInline',
            'data-original-value': JSON.stringify(node.attrs.originalValue)
        };
        return [
            'span',
            attrs,
            'Unsupported content'
        ];
    }
});

});



parcelRegister("lovmf", function(module, exports) {

$parcel$export(module.exports, "SchemaStage", () => $452aa29341178512$export$933e6445c497ffd5);
$parcel$export(module.exports, "JSONTransformer", () => $452aa29341178512$export$98cb1d9308d0944d);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $cSmYj = parcelRequire("cSmYj");

var $02BNy = parcelRequire("02BNy");
var $dHJym = parcelRequire("dHJym");
var $eSKW9 = parcelRequire("eSKW9");
var $6Ymtk = parcelRequire("6Ymtk");
var $h9kgv = parcelRequire("h9kgv");
var $8Mfla = parcelRequire("8Mfla");
var $bTlUc = parcelRequire("bTlUc");
var $7axvl = parcelRequire("7axvl");
var $e6HpD = parcelRequire("e6HpD");

var $8DB98 = parcelRequire("8DB98");

var $5RXjG = parcelRequire("5RXjG");

var $lGx2C = parcelRequire("lGx2C");
var $452aa29341178512$export$933e6445c497ffd5 = /*#__PURE__*/ function(SchemaStage) {
    SchemaStage["FINAL"] = "final";
    SchemaStage["STAGE_0"] = "stage0";
    return SchemaStage;
}({});
const $452aa29341178512$var$isType = (type)=>(node)=>node.type.name === type;
const $452aa29341178512$var$isCodeBlock = $452aa29341178512$var$isType('codeBlock');
const $452aa29341178512$var$isMediaNode = $452aa29341178512$var$isType('media');
const $452aa29341178512$var$isMediaInline = $452aa29341178512$var$isType('mediaInline');
const $452aa29341178512$var$isMediaSingleNode = $452aa29341178512$var$isType('mediaSingle');
const $452aa29341178512$var$isMentionNode = $452aa29341178512$var$isType('mention');
const $452aa29341178512$var$isParagraph = $452aa29341178512$var$isType('paragraph');
const $452aa29341178512$var$isHeading = $452aa29341178512$var$isType('heading');
const $452aa29341178512$var$isTable = $452aa29341178512$var$isType('table');
const $452aa29341178512$var$isTableCell = $452aa29341178512$var$isType('tableCell');
const $452aa29341178512$var$isTableHeader = $452aa29341178512$var$isType('tableHeader');
const $452aa29341178512$var$isLinkMark = $452aa29341178512$var$isType('link');
const $452aa29341178512$var$isUnsupportedMark = $452aa29341178512$var$isType('unsupportedMark');
const $452aa29341178512$var$isUnsupportedNodeAttributeMark = $452aa29341178512$var$isType('unsupportedNodeAttribute');
const $452aa29341178512$var$isExpand = $452aa29341178512$var$isType('expand');
const $452aa29341178512$var$isNestedExpand = $452aa29341178512$var$isType('nestedExpand');
const $452aa29341178512$var$isUnsupportedNode = (node)=>$452aa29341178512$var$isType('unsupportedBlock')(node) || $452aa29341178512$var$isType('unsupportedInline')(node);
const $452aa29341178512$var$isDataConsumer = $452aa29341178512$var$isType('dataConsumer');
const $452aa29341178512$var$isFragmentMark = $452aa29341178512$var$isType('fragment');
const $452aa29341178512$var$isHardBreak = $452aa29341178512$var$isType('hardBreak');
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $452aa29341178512$var$filterNull = (subject)=>{
    let output = {
        ...subject
    };
    // eslint-disable-next-line guard-for-in
    for(const key in output){
        const current = output[key];
        if (current === null) {
            const { [key]: unusedKey, ...filteredObj } = output;
            output = filteredObj;
        } else if (typeof current === 'object' && !Array.isArray(current)) output[key] = $452aa29341178512$var$filterNull(current);
    }
    return output;
};
const $452aa29341178512$var$createDocFromContent = (content)=>{
    return {
        version: 1,
        type: 'doc',
        content: content || []
    };
};
const $452aa29341178512$var$emptyDoc = $452aa29341178512$var$createDocFromContent([
    {
        type: 'paragraph',
        content: []
    }
]);
const $452aa29341178512$var$toJSON = (node, mentionMap)=>{
    const obj = {
        type: node.type.name
    };
    if ($452aa29341178512$var$isUnsupportedNode(node)) return node.attrs.originalValue;
    else if ($452aa29341178512$var$isMediaNode(node)) obj.attrs = (0, $bTlUc.toJSON)(node).attrs;
    else if ($452aa29341178512$var$isMediaSingleNode(node)) obj.attrs = (0, $8Mfla.toJSON)(node).attrs;
    else if ($452aa29341178512$var$isMediaInline(node)) obj.attrs = (0, $bTlUc.toJSON)(node).attrs;
    else if ($452aa29341178512$var$isMentionNode(node)) obj.attrs = (0, $7axvl.toJSON)(node).attrs;
    else if ($452aa29341178512$var$isCodeBlock(node)) obj.attrs = (0, $02BNy.toJSON)(node).attrs;
    else if ($452aa29341178512$var$isTable(node)) obj.attrs = (0, $e6HpD.tableToJSON)(node).attrs;
    else if ($452aa29341178512$var$isTableCell(node)) obj.attrs = (0, $e6HpD.toJSONTableCell)(node).attrs;
    else if ($452aa29341178512$var$isTableHeader(node)) obj.attrs = (0, $e6HpD.toJSONTableHeader)(node).attrs;
    else if ($452aa29341178512$var$isExpand(node) || $452aa29341178512$var$isNestedExpand(node)) obj.attrs = (0, $eSKW9.toJSON)(node).attrs;
    else if (node.attrs && Object.keys(node.attrs).length) obj.attrs = node.attrs;
    if (obj.attrs) obj.attrs = $452aa29341178512$var$filterNull(obj.attrs);
    if ($452aa29341178512$var$isMentionNode(node) && mentionMap) {
        // If the mentionMap exists and has a name defined then we should use it and prepend @ to the begining of it.
        const name = !!mentionMap?.[node.attrs.id] ? `@${mentionMap[node.attrs.id]}` : '';
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const text = obj.attrs?.text ?? '';
        obj.attrs = {
            ...obj.attrs,
            // If an explicit text value is set on the mention then that should take priority over the mentionMap value.
            text: !!text ? text : name
        };
    }
    // Remove the attrs property if it's empty, this is currently limited to paragraph nodes.
    if ($452aa29341178512$var$isParagraph(node) && obj.attrs && !Object.keys(obj.attrs).length) delete obj.attrs;
    // Hard break has optional attr.text which was added for PM <-> ADF compatibility.
    // No need to preserve it.
    if ($452aa29341178512$var$isHardBreak(node)) delete obj.attrs;
    if (node.isText) obj.text = node.textContent;
    else node.content.forEach((child)=>{
        obj.content = obj.content || [];
        obj.content.push($452aa29341178512$var$toJSON(child, mentionMap));
    });
    if ($452aa29341178512$var$isParagraph(node) || $452aa29341178512$var$isHeading(node)) obj.content = obj.content || [];
    if (node.marks.length) {
        // Run any custom mark serialisers
        const parsedMarks = node.marks.map((mark)=>{
            if ($452aa29341178512$var$isUnsupportedMark(mark)) return $452aa29341178512$var$canOverrideMark(mark, node.marks) ? null : mark.attrs.originalValue;
            else if ($452aa29341178512$var$isUnsupportedNodeAttributeMark(mark)) return null;
            else if ($452aa29341178512$var$isLinkMark(mark)) return (0, $h9kgv.toJSON)(mark);
            else if ($452aa29341178512$var$isDataConsumer(mark)) {
                const serialised = (0, $dHJym.toJSON)(mark);
                return !serialised.attrs.sources || serialised.attrs.sources?.length === 0 ? null : serialised;
            } else if ($452aa29341178512$var$isFragmentMark(mark)) {
                const fragmentMark = (0, $6Ymtk.toJSON)(mark);
                if (!fragmentMark.attrs.localId) return null;
                return fragmentMark;
            } else return mark.toJSON();
        }).filter((maybeMark)=>maybeMark !== null);
        // Only set if we have a non-empty array, otherwise explicitly undefine it (as we only run this path if `node.marks.length`)
        obj.marks = parsedMarks?.length > 0 ? parsedMarks : undefined;
        const nodeAttributeMark = node.marks.find($452aa29341178512$var$isUnsupportedNodeAttributeMark);
        if (nodeAttributeMark && nodeAttributeMark.attrs.type.nodeType === obj.type) obj.attrs = {
            ...$452aa29341178512$var$getUnwrappedNodeAttributes(node, nodeAttributeMark, obj)
        };
    }
    return obj;
};
const $452aa29341178512$var$canOverrideMark = (mark, existingMarks)=>{
    if (existingMarks.some((e)=>mark.attrs.originalValue.type === e.type.name)) return (0, $5RXjG.markOverrideRuleFor)(mark.attrs.originalValue.type).canOverrideUnsupportedMark();
    return false;
};
const $452aa29341178512$var$getUnwrappedNodeAttributes = (node, mark, obj)=>{
    const nodeAttributes = node.type.spec.attrs;
    const attributes = {
        ...mark.attrs.unsupported,
        ...obj.attrs
    };
    // Ignored via go/ees005
    // eslint-disable-next-line no-var
    for(var key in obj.attrs)if (obj.attrs.hasOwnProperty(key)) {
        const attribute = nodeAttributes ? nodeAttributes[key] : null;
        if (attribute) {
            if (attribute.default === node.attrs[key] && mark.attrs.unsupported[key]) return {
                ...attributes,
                [key]: mark.attrs.unsupported[key]
            };
        }
    }
    return attributes;
};
class $452aa29341178512$export$98cb1d9308d0944d {
    /**
	 * @param schema The current editor schema
	 * @param mentionMap An optional mapping of user IDs to mention names. This is used by the encoder to substitute empty
	 * mention node.attr.text values with mapped names.
	 */ constructor(schema = (0, $8DB98.defaultSchema), mentionMap){
        this.schema = schema;
        this.mentionMap = mentionMap;
    }
    encode(node) {
        const content = [];
        node.content.forEach((child)=>{
            content.push((0, $lGx2C.sanitizeNode)($452aa29341178512$var$toJSON(child, this.mentionMap)));
        });
        if (!content || (0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(content, $452aa29341178512$var$emptyDoc.content)) return $452aa29341178512$var$createDocFromContent([]);
        return $452aa29341178512$var$createDocFromContent(content);
    }
    internalParse(content, schema) {
        const doc = schema.nodeFromJSON(content);
        doc.check();
        return doc;
    }
    parse(content, stage) {
        if (content.type !== 'doc') throw new Error('Expected content format to be ADF');
        const schema = !!stage ? (0, $8DB98.getSchemaBasedOnStage)(stage) : this.schema;
        if (!content.content || content.content.length === 0) return this.internalParse($452aa29341178512$var$emptyDoc, schema);
        return this.internalParse(content, schema);
    }
    /**
	 * This method is used to encode a single node
	 */ encodeNode(node) {
        return (0, $lGx2C.sanitizeNode)($452aa29341178512$var$toJSON(node, this.mentionMap));
    }
}

});
parcelRegister("5RXjG", function(module, exports) {

$parcel$export(module.exports, "markOverrideRuleFor", () => $dde2fa0263905fa8$export$28e4e3c024cce988);
const $dde2fa0263905fa8$var$defaultAllowOverrideBehaviour = {
    canOverrideUnsupportedMark: ()=>{
        return true;
    }
};
const $dde2fa0263905fa8$var$defaultDoNotAllowOverrideBehaviour = {
    canOverrideUnsupportedMark: ()=>{
        return false;
    }
};
const $dde2fa0263905fa8$export$28e4e3c024cce988 = (type)=>{
    switch(type){
        case 'link':
        case 'em':
        case 'strong':
        case 'strike':
        case 'subsup':
        case 'underline':
        case 'code':
        case 'textColor':
        case 'backgroundColor':
        case 'confluenceInlineComment':
        case 'breakout':
        case 'alignment':
        case 'indentation':
        case 'border':
            return $dde2fa0263905fa8$var$defaultAllowOverrideBehaviour;
        default:
            return $dde2fa0263905fa8$var$defaultDoNotAllowOverrideBehaviour;
    }
};

});

parcelRegister("lGx2C", function(module, exports) {

$parcel$export(module.exports, "sanitizeNode", () => $6129054bcfac353f$export$48b382180baf8e88);

var $jF4Mi = parcelRequire("jF4Mi");

var $0mclG = parcelRequire("0mclG");

var $jME2s = parcelRequire("jME2s");
const $6129054bcfac353f$var$hasNestedTable = (tableCellNode)=>tableCellNode.content?.some((node)=>node?.type === 'table');
function $6129054bcfac353f$export$48b382180baf8e88(json) {
    const sanitizedJSON = (0, $0mclG.traverse)(json, {
        text: (node)=>{
            if (!node || !Array.isArray(node.marks)) return node;
            return {
                ...node,
                marks: node.marks.filter((mark)=>mark.type !== 'typeAheadQuery')
            };
        },
        status: (node)=>{
            if (node.attrs && !!node.attrs.text) return (0, $jME2s.removeNonAnnotationMarks)(node);
            return false; // empty status
        },
        caption: (node)=>{
            if (node.content) return node;
            return false; // empty caption
        },
        tableCell: (node)=>{
            if ($6129054bcfac353f$var$hasNestedTable(node)) return (0, $jF4Mi.transformNestedTableNodeOutgoingDocument)(node);
        },
        tableHeader: (node)=>{
            if ($6129054bcfac353f$var$hasNestedTable(node)) return (0, $jF4Mi.transformNestedTableNodeOutgoingDocument)(node);
        },
        emoji: (0, $jME2s.removeNonAnnotationMarks),
        mention: (0, $jME2s.removeNonAnnotationMarks),
        date: (0, $jME2s.removeNonAnnotationMarks),
        hardBreak: (0, $jME2s.removeMarks),
        inlineCard: (0, $jME2s.removeNonAnnotationMarks)
    });
    return sanitizedJSON;
}

});
parcelRegister("jF4Mi", function(module, exports) {

$parcel$export(module.exports, "transformNestedTablesIncomingDocument", () => $7043dab3dcfeb1cc$export$18544d0b5f43e4a1);
$parcel$export(module.exports, "transformNestedTableNodeOutgoingDocument", () => $7043dab3dcfeb1cc$export$8a334a7d9fe120ec);

var $0mclG = parcelRequire("0mclG");

var $8zW2f = parcelRequire("8zW2f");

var $lmGkG = parcelRequire("lmGkG");
const $7043dab3dcfeb1cc$var$NESTED_TABLE_EXTENSION_TYPE = 'com.atlassian.confluence.migration', $7043dab3dcfeb1cc$var$NESTED_TABLE_EXTENSION_KEY = 'nested-table';
const $7043dab3dcfeb1cc$export$f45e7335ec874bfe = (extensionNode)=>extensionNode.attrs?.extensionType === $7043dab3dcfeb1cc$var$NESTED_TABLE_EXTENSION_TYPE && extensionNode.attrs?.extensionKey === $7043dab3dcfeb1cc$var$NESTED_TABLE_EXTENSION_KEY;
const $7043dab3dcfeb1cc$var$transformNestedTableExtension = (nestedTableExtension)=>{
    // No content - drop the extension node
    if (!nestedTableExtension.attrs?.parameters?.adf) return false;
    try {
        const adf = JSON.parse(nestedTableExtension.attrs?.parameters?.adf);
        if (!adf.content || adf.content.length === 0) return false;
        return adf.content[0];
    } catch (e) {
        throw new (0, $lmGkG.NodeNestingTransformError)('Failed to parse nested table content');
    }
};
// TODO: EDITOR-806 - Remove when cleaning feature gate platform_editor_nested_table_extension_comment_fix
function $7043dab3dcfeb1cc$var$isInsideBodiedExtension(parent) {
    if (parent.node === undefined) return false;
    if (parent.node.type === 'bodiedExtension') return true;
    if (parent?.parent?.node) return $7043dab3dcfeb1cc$var$isInsideBodiedExtension(parent.parent);
    return false;
}
const $7043dab3dcfeb1cc$export$18544d0b5f43e4a1 = (adf, // TODO: EDITOR-806 - Remove options when cleaning feature gate platform_editor_nested_table_extension_comment_fix as no longer needed
options = {})=>{
    let isTransformed = false;
    const transformedAdf = (0, $0mclG.traverse)(adf, {
        extension: (node, parent)=>{
            if ($7043dab3dcfeb1cc$export$f45e7335ec874bfe(node)) {
                // TODO: EDITOR-806 - Remove this block when cleaning feature gate platform_editor_nested_table_extension_comment_fix
                // Bodied extensions in renderer use their own nested renderer to render the content.
                // This results in the document being validated/transformed twice, once with untransformed content and again with transformed content.
                // Since the untransformed content is valid ADF (table as extension in table) but the transformed content is not valid ADF, (table in table)
                // we need to skip transforming nested tables inside bodied extensions in renderer on the first pass or else it will fail validation and render an unsupported block.
                if (options.environment === 'renderer' && $7043dab3dcfeb1cc$var$isInsideBodiedExtension(parent) && !options.disableNestedRendererTreatment) return undefined;
                isTransformed = true;
                return $7043dab3dcfeb1cc$var$transformNestedTableExtension(node);
            }
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};
const $7043dab3dcfeb1cc$export$8a334a7d9fe120ec = (tableCellNode)=>{
    try {
        return {
            ...tableCellNode,
            content: tableCellNode.content?.map((childNode)=>{
                // wrap nested table in an extension node
                if (childNode?.type === 'table') return (0, $8zW2f.extension)({
                    extensionType: $7043dab3dcfeb1cc$var$NESTED_TABLE_EXTENSION_TYPE,
                    extensionKey: $7043dab3dcfeb1cc$var$NESTED_TABLE_EXTENSION_KEY,
                    parameters: {
                        adf: JSON.stringify({
                            type: 'doc',
                            version: 1,
                            content: [
                                childNode
                            ]
                        })
                    }
                });
                return childNode;
            })
        };
    } catch (e) {
        throw new (0, $lmGkG.NodeNestingTransformError)('Failed to encode nested table node');
    }
};

});
parcelRegister("8zW2f", function(module, exports) {

$parcel$export(module.exports, "extension", () => $5a200accbce47c41$export$1b45514b112dd749);
const $5a200accbce47c41$export$1b45514b112dd749 = (attrs)=>({
        type: 'extension',
        attrs: attrs
    });

});

parcelRegister("lmGkG", function(module, exports) {

$parcel$export(module.exports, "NodeNestingTransformError", () => $e75bb52268bda547$export$3d8e8d2182f13924);
/** NodeNestingTransformError  */ class $e75bb52268bda547$export$3d8e8d2182f13924 extends Error {
    /**
	 * @param message - Error message - Do not use any UGC in this message
	 */ constructor(message){
        super(message);
        this.name = 'NodeNestingTransformError';
    }
}

});


parcelRegister("jME2s", function(module, exports) {

$parcel$export(module.exports, "removeMarks", () => $7ddfde3dbc93f214$export$9bf001d8ef76e497);
$parcel$export(module.exports, "removeNonAnnotationMarks", () => $7ddfde3dbc93f214$export$8cae9126fc577085);
function $7ddfde3dbc93f214$export$9bf001d8ef76e497(node) {
    const newNode = {
        ...node
    };
    delete newNode.marks;
    return newNode;
}
function $7ddfde3dbc93f214$export$8cae9126fc577085(node) {
    const newNode = {
        ...node
    };
    if (node.marks) newNode.marks = node.marks.filter((mark)=>mark.type === 'annotation');
    return newNode;
}

});



parcelRegister("dmYzn", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "WikiMarkupTransformer", () => $685f128345263d5b$export$caaa00407b56b900);
$parcel$export(module.exports, "default", () => $685f128345263d5b$export$2e2bcd8739ae039);

var $8DB98 = parcelRequire("8DB98");

var $5MLoD = parcelRequire("5MLoD");

var $202j2 = parcelRequire("202j2");

var $7Bypb = parcelRequire("7Bypb");
class $685f128345263d5b$export$caaa00407b56b900 {
    constructor(schema = (0, $8DB98.defaultSchema)){
        this.schema = schema;
    }
    // [ADFS-725] Jira breaks if there are null chars it is easier to remove them here
    // The following has to be a regex to remove all instances of null instead of the first
    sanitizeWikiMarkup(wikiMarkup) {
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        return wikiMarkup.replace(/\0/g, '');
    }
    encode(node, context) {
        const wikiMarkup = (0, $5MLoD.encode)(node, $685f128345263d5b$var$normalizeContextObject(context));
        // [ADFS-725] Jira breaks if there are null chars it is easier to remove them here
        const sanitizedWikiMarkup = this.sanitizeWikiMarkup(wikiMarkup);
        return sanitizedWikiMarkup;
    }
    parse(wikiMarkup, context) {
        // [ADFS-725] Jira breaks if there are null chars it is easier to remove them here
        const sanitizedWikiMarkup = this.sanitizeWikiMarkup(wikiMarkup);
        const tree = new (0, $202j2.default)(this.schema, sanitizedWikiMarkup);
        return tree.getProseMirrorModel(this.buildContext($685f128345263d5b$var$normalizeContextObject(context)));
    }
    buildContext(context) {
        return context ? {
            ...context,
            issueKeyRegex: context.conversion ? (0, $7Bypb.buildIssueKeyRegex)(context.conversion.inlineCardConversion) : undefined
        } : {};
    }
}
/**
 * Turns mentionConversion object keys to lowercase for case insensitivity matching
 * This is okay, because conversion context object contains mapping and that should be case insensitive
 */ const $685f128345263d5b$var$normalizeContextObject = (context)=>{
    if (!context || !context.conversion || !context.conversion.mentionConversion) // nothing to normalize, return original object
    return context;
    const mentionConversion = {};
    // eslint-disable-next-line guard-for-in
    for(const key in context.conversion.mentionConversion)mentionConversion[key.toLowerCase()] = context.conversion.mentionConversion[key];
    context.conversion.mentionConversion = mentionConversion;
    return context;
};
var $685f128345263d5b$export$2e2bcd8739ae039 = $685f128345263d5b$export$caaa00407b56b900;

});
parcelRegister("5MLoD", function(module, exports) {

$parcel$export(module.exports, "encode", () => $5d4d101956af53d5$export$c564cdbbe6da493);

var $6M0sB = parcelRequire("6M0sB");

var $iJyzC = parcelRequire("iJyzC");

var $jcd8q = parcelRequire("jcd8q");

var $cXLg9 = parcelRequire("cXLg9");

var $5VDmd = parcelRequire("5VDmd");

var $1yHJY = parcelRequire("1yHJY");

var $fSFQG = parcelRequire("fSFQG");

var $iudS0 = parcelRequire("iudS0");

var $dVCxi = parcelRequire("dVCxi");

var $ioL87 = parcelRequire("ioL87");

var $kqHGX = parcelRequire("kqHGX");

var $gStGs = parcelRequire("gStGs");

var $7lTqS = parcelRequire("7lTqS");

var $1axEu = parcelRequire("1axEu");

var $2X1OA = parcelRequire("2X1OA");

var $dU28O = parcelRequire("dU28O");

var $clZfW = parcelRequire("clZfW");

var $ceUKV = parcelRequire("ceUKV");

var $4KRVw = parcelRequire("4KRVw");
const $5d4d101956af53d5$var$nodeEncoderMapping = {
    blockquote: $6M0sB.blockquote,
    bulletList: $iJyzC.bulletList,
    taskList: $jcd8q.taskList,
    decisionList: $cXLg9.decisionList,
    codeBlock: $5VDmd.codeBlock,
    doc: $1yHJY.doc,
    heading: $iudS0.heading,
    caption: $4KRVw.caption,
    mediaGroup: $dVCxi.mediaGroup,
    mediaInline: $ioL87.mediaInline,
    mediaSingle: (0, $dVCxi.mediaGroup),
    orderedList: $kqHGX.orderedList,
    panel: $gStGs.panel,
    paragraph: $7lTqS.paragraph,
    rule: $1axEu.rule,
    table: $2X1OA.table,
    blockCard: $clZfW.blockCard,
    embedCard: $ceUKV.embedCard,
    expand: $fSFQG.expand
};
function $5d4d101956af53d5$export$c564cdbbe6da493(node, context) {
    const encoder = $5d4d101956af53d5$var$nodeEncoderMapping[node.type.name];
    try {
        if (encoder) return encoder(node, {
            context: context
        });
        return (0, $dU28O.unknown)(node);
    } catch (err) {
        return (0, $dU28O.unknown)(node);
    }
}

});
parcelRegister("6M0sB", function(module, exports) {

$parcel$export(module.exports, "blockquote", () => $8014b150027a07ae$export$67dc04e652a298ca);

var $5MLoD = parcelRequire("5MLoD");
const $8014b150027a07ae$export$67dc04e652a298ca = (node, { context: context } = {})=>{
    const result = [];
    node.forEach((n)=>{
        result.push((0, $5MLoD.encode)(n, context));
    });
    return `{quote}${result.join('\n\n')}{quote}`;
};

});

parcelRegister("iJyzC", function(module, exports) {

$parcel$export(module.exports, "bulletList", () => $3f2384532894ff63$export$a140c94e5ea26bee);

var $lfeRz = parcelRequire("lfeRz");
const $3f2384532894ff63$export$a140c94e5ea26bee = (node, { context: context } = {})=>{
    const result = [];
    node.forEach((item)=>{
        result.push((0, $lfeRz.listItem)(item, '*', context));
    });
    return result.join('\n');
};

});
parcelRegister("lfeRz", function(module, exports) {

$parcel$export(module.exports, "listItem", () => $f1b804e8ba127a93$export$76c7e83ecc9cdf05);

var $5MLoD = parcelRequire("5MLoD");

var $7lTqS = parcelRequire("7lTqS");

var $dU28O = parcelRequire("dU28O");

var $5VDmd = parcelRequire("5VDmd");

var $dVCxi = parcelRequire("dVCxi");

var $ioL87 = parcelRequire("ioL87");
const $f1b804e8ba127a93$export$76c7e83ecc9cdf05 = (node, prefix, context)=>{
    const result = [];
    let contentBuffer = [];
    node.forEach((n)=>{
        switch(n.type.name){
            case 'paragraph':
                contentBuffer.push((0, $7lTqS.paragraph)(n, {
                    context: context
                }));
                break;
            case 'bulletList':
            case 'orderedList':
                {
                    if (contentBuffer.length) {
                        result.push(`${prefix} ${contentBuffer.join('\n')}`);
                        contentBuffer = [];
                    }
                    const nestedList = (0, $5MLoD.encode)(n, context).split('\n').map((line)=>{
                        if ([
                            '#',
                            '*'
                        ].indexOf(line.substr(0, 1)) !== -1) return `${prefix}${line}`;
                        return line;
                    }).join('\n');
                    result.push(nestedList);
                    break;
                }
            case 'codeBlock':
                contentBuffer.push((0, $5VDmd.codeBlock)(n));
                break;
            case 'mediaInline':
                contentBuffer.push((0, $ioL87.mediaInline)(n, {
                    context: context
                }));
                break;
            case 'mediaSingle':
                // mediaSingle and mediaGroup are holding the same conversion logic
                contentBuffer.push((0, $dVCxi.mediaGroup)(n, {
                    context: context
                }));
                break;
            default:
                contentBuffer.push((0, $dU28O.unknown)(n));
        }
    });
    if (contentBuffer.length) result.push(`${prefix} ${contentBuffer.join('\n')}`);
    return result.join('\n');
};

});
parcelRegister("7lTqS", function(module, exports) {

$parcel$export(module.exports, "paragraph", () => $4a2c89e8017f62a6$export$9c206ddddb32a9b);

var $k9glG = parcelRequire("k9glG");
const $4a2c89e8017f62a6$export$9c206ddddb32a9b = (node, { context: context } = {})=>{
    let result = '';
    node.forEach((n)=>{
        result += (0, $k9glG.inlines)(n, {
            context: context
        });
    });
    return result;
};

});
parcelRegister("k9glG", function(module, exports) {

$parcel$export(module.exports, "inlines", () => $08928eace054d2bc$export$96c94bfc00b85760);

var $htD5p = parcelRequire("htD5p");

var $gz6Fj = parcelRequire("gz6Fj");

var $ioL87 = parcelRequire("ioL87");

var $8yZcU = parcelRequire("8yZcU");

var $eHUs8 = parcelRequire("eHUs8");

var $cQf6S = parcelRequire("cQf6S");

var $9wDTJ = parcelRequire("9wDTJ");

var $dU28O = parcelRequire("dU28O");

var $lCUKb = parcelRequire("lCUKb");
const $08928eace054d2bc$var$inlinesEncoderMapping = {
    emoji: $htD5p.emoji,
    hardBreak: $gz6Fj.hardBreak,
    mediaInline: $ioL87.mediaInline,
    mention: $8yZcU.mention,
    text: $eHUs8.text,
    inlineCard: $cQf6S.inlineCard,
    status: $9wDTJ.status,
    date: $lCUKb.date
};
const $08928eace054d2bc$export$96c94bfc00b85760 = (node, opts)=>{
    const encoder = $08928eace054d2bc$var$inlinesEncoderMapping[node.type.name];
    if (encoder) return encoder(node, opts);
    return (0, $dU28O.unknown)(node);
};

});
parcelRegister("htD5p", function(module, exports) {

$parcel$export(module.exports, "emoji", () => $8186d3728ceefa90$export$a19185d1233fc4b2);

var $5W1n4 = parcelRequire("5W1n4");

var $dU28O = parcelRequire("dU28O");
const $8186d3728ceefa90$export$a19185d1233fc4b2 = (node)=>{
    const value = (0, $5W1n4.mapping)[node.attrs.id];
    if (value) return value;
    if (node.attrs.shortName) return node.attrs.shortName;
    return (0, $dU28O.unknown)(node);
};

});
parcelRegister("5W1n4", function(module, exports) {

$parcel$export(module.exports, "mapping", () => $352f1d0339298b32$export$83e1f26587c4acd2);
const $352f1d0339298b32$export$83e1f26587c4acd2 = {
    '1f600': "\uD83D\uDE00",
    '1f603': "\uD83D\uDE03",
    '1f604': "\uD83D\uDE04",
    '1f601': "\uD83D\uDE01",
    '1f606': "\uD83D\uDE06",
    '1f605': "\uD83D\uDE05",
    '1f602': "\uD83D\uDE02",
    '1f923': "\uD83E\uDD23",
    '263a': "\u263A\uFE0F",
    '1f60a': "\uD83D\uDE0A",
    '1f607': "\uD83D\uDE07",
    '1f642': "\uD83D\uDE42",
    '1f643': "\uD83D\uDE43",
    '1f609': "\uD83D\uDE09",
    '1f60c': "\uD83D\uDE0C",
    '1f60d': "\uD83D\uDE0D",
    '1f618': "\uD83D\uDE18",
    '1f617': "\uD83D\uDE17",
    '1f619': "\uD83D\uDE19",
    '1f61a': "\uD83D\uDE1A",
    '1f60b': "\uD83D\uDE0B",
    '1f61c': "\uD83D\uDE1C",
    '1f61d': "\uD83D\uDE1D",
    '1f61b': "\uD83D\uDE1B",
    '1f911': "\uD83E\uDD11",
    '1f917': "\uD83E\uDD17",
    '1f913': "\uD83E\uDD13",
    '1f60e': "\uD83D\uDE0E",
    '1f921': "\uD83E\uDD21",
    '1f920': "\uD83E\uDD20",
    '1f60f': "\uD83D\uDE0F",
    '1f612': "\uD83D\uDE12",
    '1f61e': "\uD83D\uDE1E",
    '1f614': "\uD83D\uDE14",
    '1f61f': "\uD83D\uDE1F",
    '1f615': "\uD83D\uDE15",
    '1f641': "\uD83D\uDE41",
    '2639': "\u2639\uFE0F",
    '1f623': "\uD83D\uDE23",
    '1f616': "\uD83D\uDE16",
    '1f62b': "\uD83D\uDE2B",
    '1f629': "\uD83D\uDE29",
    '1f624': "\uD83D\uDE24",
    '1f620': "\uD83D\uDE20",
    '1f621': "\uD83D\uDE21",
    '1f636': "\uD83D\uDE36",
    '1f610': "\uD83D\uDE10",
    '1f611': "\uD83D\uDE11",
    '1f62f': "\uD83D\uDE2F",
    '1f626': "\uD83D\uDE26",
    '1f627': "\uD83D\uDE27",
    '1f62e': "\uD83D\uDE2E",
    '1f632': "\uD83D\uDE32",
    '1f635': "\uD83D\uDE35",
    '1f633': "\uD83D\uDE33",
    '1f631': "\uD83D\uDE31",
    '1f628': "\uD83D\uDE28",
    '1f630': "\uD83D\uDE30",
    '1f622': "\uD83D\uDE22",
    '1f625': "\uD83D\uDE25",
    '1f924': "\uD83E\uDD24",
    '1f62d': "\uD83D\uDE2D",
    '1f613': "\uD83D\uDE13",
    '1f62a': "\uD83D\uDE2A",
    '1f634': "\uD83D\uDE34",
    '1f644': "\uD83D\uDE44",
    '1f914': "\uD83E\uDD14",
    '1f925': "\uD83E\uDD25",
    '1f62c': "\uD83D\uDE2C",
    '1f910': "\uD83E\uDD10",
    '1f922': "\uD83E\uDD22",
    '1f927': "\uD83E\uDD27",
    '1f637': "\uD83D\uDE37",
    '1f912': "\uD83E\uDD12",
    '1f915': "\uD83E\uDD15",
    '1f608': "\uD83D\uDE08",
    '1f47f': "\uD83D\uDC7F",
    '1f479': "\uD83D\uDC79",
    '1f47a': "\uD83D\uDC7A",
    '1f4a9': "\uD83D\uDCA9",
    '1f47b': "\uD83D\uDC7B",
    '1f480': "\uD83D\uDC80",
    '2620': "\u2620\uFE0F",
    '1f47d': "\uD83D\uDC7D",
    '1f47e': "\uD83D\uDC7E",
    '1f916': "\uD83E\uDD16",
    '1f383': "\uD83C\uDF83",
    '1f63a': "\uD83D\uDE3A",
    '1f638': "\uD83D\uDE38",
    '1f639': "\uD83D\uDE39",
    '1f63b': "\uD83D\uDE3B",
    '1f63c': "\uD83D\uDE3C",
    '1f63d': "\uD83D\uDE3D",
    '1f640': "\uD83D\uDE40",
    '1f63f': "\uD83D\uDE3F",
    '1f63e': "\uD83D\uDE3E",
    '1f450': "\uD83D\uDC50",
    '1f64c': "\uD83D\uDE4C",
    '1f44f': "\uD83D\uDC4F",
    '1f64f': "\uD83D\uDE4F",
    '1f91d': "\uD83E\uDD1D",
    '1f44d': "\uD83D\uDC4D",
    '1f44e': "\uD83D\uDC4E",
    '1f44a': "\uD83D\uDC4A",
    '270a': "\u270A",
    '1f91b': "\uD83E\uDD1B",
    '1f91c': "\uD83E\uDD1C",
    '1f91e': "\uD83E\uDD1E",
    '270c': "\u270C\uFE0F",
    '1f918': "\uD83E\uDD18",
    '1f44c': "\uD83D\uDC4C",
    '1f448': "\uD83D\uDC48",
    '1f449': "\uD83D\uDC49",
    '1f446': "\uD83D\uDC46",
    '1f447': "\uD83D\uDC47",
    '261d': "\u261D\uFE0F",
    '270b': "\u270B",
    '1f91a': "\uD83E\uDD1A",
    '1f590': "\uD83D\uDD90\uFE0F",
    '1f596': "\uD83D\uDD96",
    '1f44b': "\uD83D\uDC4B",
    '1f919': "\uD83E\uDD19",
    '1f4aa': "\uD83D\uDCAA",
    '1f595': "\uD83D\uDD95",
    '270d': "\u270D\uFE0F",
    '1f933': "\uD83E\uDD33",
    '1f485': "\uD83D\uDC85",
    '1f48d': "\uD83D\uDC8D",
    '1f484': "\uD83D\uDC84",
    '1f48b': "\uD83D\uDC8B",
    '1f444': "\uD83D\uDC44",
    '1f445': "\uD83D\uDC45",
    '1f442': "\uD83D\uDC42",
    '1f443': "\uD83D\uDC43",
    '1f463': "\uD83D\uDC63",
    '1f441': "\uD83D\uDC41\uFE0F",
    '1f440': "\uD83D\uDC40",
    '1f5e3': "\uD83D\uDDE3\uFE0F",
    '1f464': "\uD83D\uDC64",
    '1f465': "\uD83D\uDC65",
    '1f476': "\uD83D\uDC76",
    '1f466': "\uD83D\uDC66",
    '1f467': "\uD83D\uDC67",
    '1f468': "\uD83D\uDC68",
    '1f469': "\uD83D\uDC69",
    '1f471-200d-2640-fe0f': "\uD83D\uDC71\u200D\u2640\uFE0F",
    '1f471': "\uD83D\uDC71",
    '1f471-200d-2642-fe0f': "\uD83D\uDC71\u200D\u2642\uFE0F",
    '1f474': "\uD83D\uDC74",
    '1f475': "\uD83D\uDC75",
    '1f472': "\uD83D\uDC72",
    '1f473-200d-2640-fe0f': "\uD83D\uDC73\u200D\u2640\uFE0F",
    '1f473': "\uD83D\uDC73",
    '1f473-200d-2642-fe0f': "\uD83D\uDC73\u200D\u2642\uFE0F",
    '1f46e-200d-2640-fe0f': "\uD83D\uDC6E\u200D\u2640\uFE0F",
    '1f46e': "\uD83D\uDC6E",
    '1f46e-200d-2642-fe0f': "\uD83D\uDC6E\u200D\u2642\uFE0F",
    '1f477-200d-2640-fe0f': "\uD83D\uDC77\u200D\u2640\uFE0F",
    '1f477': "\uD83D\uDC77",
    '1f477-200d-2642-fe0f': "\uD83D\uDC77\u200D\u2642\uFE0F",
    '1f482-200d-2640-fe0f': "\uD83D\uDC82\u200D\u2640\uFE0F",
    '1f482': "\uD83D\uDC82",
    '1f482-200d-2642-fe0f': "\uD83D\uDC82\u200D\u2642\uFE0F",
    '1f575-fe0f-200d-2640-fe0f': "\uD83D\uDD75\uFE0F\u200D\u2640\uFE0F",
    '1f575': "\uD83D\uDD75\uFE0F",
    '1f575-fe0f-200d-2642-fe0f': "\uD83D\uDD75\uFE0F\u200D\u2642\uFE0F",
    '1f469-200d-2695-fe0f': "\uD83D\uDC69\u200D\u2695\uFE0F",
    '1f468-200d-2695-fe0f': "\uD83D\uDC68\u200D\u2695\uFE0F",
    '1f469-200d-1f33e': "\uD83D\uDC69\u200D\uD83C\uDF3E",
    '1f468-200d-1f33e': "\uD83D\uDC68\u200D\uD83C\uDF3E",
    '1f469-200d-1f373': "\uD83D\uDC69\u200D\uD83C\uDF73",
    '1f468-200d-1f373': "\uD83D\uDC68\u200D\uD83C\uDF73",
    '1f469-200d-1f393': "\uD83D\uDC69\u200D\uD83C\uDF93",
    '1f468-200d-1f393': "\uD83D\uDC68\u200D\uD83C\uDF93",
    '1f469-200d-1f3a4': "\uD83D\uDC69\u200D\uD83C\uDFA4",
    '1f468-200d-1f3a4': "\uD83D\uDC68\u200D\uD83C\uDFA4",
    '1f469-200d-1f3eb': "\uD83D\uDC69\u200D\uD83C\uDFEB",
    '1f468-200d-1f3eb': "\uD83D\uDC68\u200D\uD83C\uDFEB",
    '1f469-200d-1f3ed': "\uD83D\uDC69\u200D\uD83C\uDFED",
    '1f468-200d-1f3ed': "\uD83D\uDC68\u200D\uD83C\uDFED",
    '1f469-200d-1f4bb': "\uD83D\uDC69\u200D\uD83D\uDCBB",
    '1f468-200d-1f4bb': "\uD83D\uDC68\u200D\uD83D\uDCBB",
    '1f469-200d-1f4bc': "\uD83D\uDC69\u200D\uD83D\uDCBC",
    '1f468-200d-1f4bc': "\uD83D\uDC68\u200D\uD83D\uDCBC",
    '1f469-200d-1f527': "\uD83D\uDC69\u200D\uD83D\uDD27",
    '1f468-200d-1f527': "\uD83D\uDC68\u200D\uD83D\uDD27",
    '1f469-200d-1f52c': "\uD83D\uDC69\u200D\uD83D\uDD2C",
    '1f468-200d-1f52c': "\uD83D\uDC68\u200D\uD83D\uDD2C",
    '1f469-200d-1f3a8': "\uD83D\uDC69\u200D\uD83C\uDFA8",
    '1f468-200d-1f3a8': "\uD83D\uDC68\u200D\uD83C\uDFA8",
    '1f469-200d-1f692': "\uD83D\uDC69\u200D\uD83D\uDE92",
    '1f468-200d-1f692': "\uD83D\uDC68\u200D\uD83D\uDE92",
    '1f469-200d-2708-fe0f': "\uD83D\uDC69\u200D\u2708\uFE0F",
    '1f468-200d-2708-fe0f': "\uD83D\uDC68\u200D\u2708\uFE0F",
    '1f469-200d-1f680': "\uD83D\uDC69\u200D\uD83D\uDE80",
    '1f468-200d-1f680': "\uD83D\uDC68\u200D\uD83D\uDE80",
    '1f469-200d-2696-fe0f': "\uD83D\uDC69\u200D\u2696\uFE0F",
    '1f468-200d-2696-fe0f': "\uD83D\uDC68\u200D\u2696\uFE0F",
    '1f936': "\uD83E\uDD36",
    '1f385': "\uD83C\uDF85",
    '1f478': "\uD83D\uDC78",
    '1f934': "\uD83E\uDD34",
    '1f470': "\uD83D\uDC70",
    '1f935': "\uD83E\uDD35",
    '1f47c': "\uD83D\uDC7C",
    '1f930': "\uD83E\uDD30",
    '1f647-200d-2640-fe0f': "\uD83D\uDE47\u200D\u2640\uFE0F",
    '1f647': "\uD83D\uDE47",
    '1f647-200d-2642-fe0f': "\uD83D\uDE47\u200D\u2642\uFE0F",
    '1f481': "\uD83D\uDC81",
    '1f481-200d-2642-fe0f': "\uD83D\uDC81\u200D\u2642\uFE0F",
    '1f481-200d-2640-fe0f': "\uD83D\uDC81\u200D\u2640\uFE0F",
    '1f645': "\uD83D\uDE45",
    '1f645-200d-2642-fe0f': "\uD83D\uDE45\u200D\u2642\uFE0F",
    '1f645-200d-2640-fe0f': "\uD83D\uDE45\u200D\u2640\uFE0F",
    '1f646': "\uD83D\uDE46",
    '1f646-200d-2642-fe0f': "\uD83D\uDE46\u200D\u2642\uFE0F",
    '1f646-200d-2640-fe0f': "\uD83D\uDE46\u200D\u2640\uFE0F",
    '1f64b': "\uD83D\uDE4B",
    '1f64b-200d-2642-fe0f': "\uD83D\uDE4B\u200D\u2642\uFE0F",
    '1f64b-200d-2640-fe0f': "\uD83D\uDE4B\u200D\u2640\uFE0F",
    '1f926-200d-2640-fe0f': "\uD83E\uDD26\u200D\u2640\uFE0F",
    '1f926-200d-2642-fe0f': "\uD83E\uDD26\u200D\u2642\uFE0F",
    '1f926': "\uD83E\uDD26",
    '1f937-200d-2640-fe0f': "\uD83E\uDD37\u200D\u2640\uFE0F",
    '1f937-200d-2642-fe0f': "\uD83E\uDD37\u200D\u2642\uFE0F",
    '1f937': "\uD83E\uDD37",
    '1f64e': "\uD83D\uDE4E",
    '1f64e-200d-2642-fe0f': "\uD83D\uDE4E\u200D\u2642\uFE0F",
    '1f64e-200d-2640-fe0f': "\uD83D\uDE4E\u200D\u2640\uFE0F",
    '1f64d': "\uD83D\uDE4D",
    '1f64d-200d-2642-fe0f': "\uD83D\uDE4D\u200D\u2642\uFE0F",
    '1f64d-200d-2640-fe0f': "\uD83D\uDE4D\u200D\u2640\uFE0F",
    '1f487': "\uD83D\uDC87",
    '1f487-200d-2642-fe0f': "\uD83D\uDC87\u200D\u2642\uFE0F",
    '1f487-200d-2640-fe0f': "\uD83D\uDC87\u200D\u2640\uFE0F",
    '1f486': "\uD83D\uDC86",
    '1f486-200d-2642-fe0f': "\uD83D\uDC86\u200D\u2642\uFE0F",
    '1f486-200d-2640-fe0f': "\uD83D\uDC86\u200D\u2640\uFE0F",
    '1f574': "\uD83D\uDD74\uFE0F",
    '1f483': "\uD83D\uDC83",
    '1f57a': "\uD83D\uDD7A",
    '1f46f': "\uD83D\uDC6F",
    '1f46f-200d-2642-fe0f': "\uD83D\uDC6F\u200D\u2642\uFE0F",
    '1f46f-200d-2640-fe0f': "\uD83D\uDC6F\u200D\u2640\uFE0F",
    '1f6b6-200d-2640-fe0f': "\uD83D\uDEB6\u200D\u2640\uFE0F",
    '1f6b6': "\uD83D\uDEB6",
    '1f6b6-200d-2642-fe0f': "\uD83D\uDEB6\u200D\u2642\uFE0F",
    '1f3c3-200d-2640-fe0f': "\uD83C\uDFC3\u200D\u2640\uFE0F",
    '1f3c3': "\uD83C\uDFC3",
    '1f3c3-200d-2642-fe0f': "\uD83C\uDFC3\u200D\u2642\uFE0F",
    '1f46b': "\uD83D\uDC6B",
    '1f46d': "\uD83D\uDC6D",
    '1f46c': "\uD83D\uDC6C",
    '1f491': "\uD83D\uDC91",
    '1f469-200d-2764-fe0f-200d-1f469': "\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC69",
    '1f468-200d-2764-fe0f-200d-1f468': "\uD83D\uDC68\u200D\u2764\uFE0F\u200D\uD83D\uDC68",
    '1f48f': "\uD83D\uDC8F",
    '1f469-200d-2764-fe0f-200d-1f48b-200d-1f469': "\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69",
    '1f468-200d-2764-fe0f-200d-1f48b-200d-1f468': "\uD83D\uDC68\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68",
    '1f46a': "\uD83D\uDC6A",
    '1f468-200d-1f469-200d-1f467': "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67",
    '1f468-200d-1f469-200d-1f467-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
    '1f468-200d-1f469-200d-1f466-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66",
    '1f468-200d-1f469-200d-1f467-200d-1f467': "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC67",
    '1f469-200d-1f469-200d-1f466': "\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC66",
    '1f469-200d-1f469-200d-1f467': "\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC67",
    '1f469-200d-1f469-200d-1f467-200d-1f466': "\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
    '1f469-200d-1f469-200d-1f466-200d-1f466': "\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66",
    '1f469-200d-1f469-200d-1f467-200d-1f467': "\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC67",
    '1f468-200d-1f468-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC66",
    '1f468-200d-1f468-200d-1f467': "\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC67",
    '1f468-200d-1f468-200d-1f467-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
    '1f468-200d-1f468-200d-1f466-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC66\u200D\uD83D\uDC66",
    '1f468-200d-1f468-200d-1f467-200d-1f467': "\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC67",
    '1f469-200d-1f466': "\uD83D\uDC69\u200D\uD83D\uDC66",
    '1f469-200d-1f467': "\uD83D\uDC69\u200D\uD83D\uDC67",
    '1f469-200d-1f467-200d-1f466': "\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
    '1f469-200d-1f466-200d-1f466': "\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66",
    '1f469-200d-1f467-200d-1f467': "\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC67",
    '1f468-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC66",
    '1f468-200d-1f467': "\uD83D\uDC68\u200D\uD83D\uDC67",
    '1f468-200d-1f467-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
    '1f468-200d-1f466-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC66\u200D\uD83D\uDC66",
    '1f468-200d-1f467-200d-1f467': "\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC67",
    '1f45a': "\uD83D\uDC5A",
    '1f455': "\uD83D\uDC55",
    '1f456': "\uD83D\uDC56",
    '1f454': "\uD83D\uDC54",
    '1f457': "\uD83D\uDC57",
    '1f459': "\uD83D\uDC59",
    '1f458': "\uD83D\uDC58",
    '1f460': "\uD83D\uDC60",
    '1f461': "\uD83D\uDC61",
    '1f462': "\uD83D\uDC62",
    '1f45e': "\uD83D\uDC5E",
    '1f45f': "\uD83D\uDC5F",
    '1f452': "\uD83D\uDC52",
    '1f3a9': "\uD83C\uDFA9",
    '1f393': "\uD83C\uDF93",
    '1f451': "\uD83D\uDC51",
    '26d1': "\u26D1\uFE0F",
    '1f392': "\uD83C\uDF92",
    '1f45d': "\uD83D\uDC5D",
    '1f45b': "\uD83D\uDC5B",
    '1f45c': "\uD83D\uDC5C",
    '1f4bc': "\uD83D\uDCBC",
    '1f453': "\uD83D\uDC53",
    '1f576': "\uD83D\uDD76\uFE0F",
    '1f302': "\uD83C\uDF02",
    '2602': "\u2602\uFE0F",
    '1f436': "\uD83D\uDC36",
    '1f431': "\uD83D\uDC31",
    '1f42d': "\uD83D\uDC2D",
    '1f439': "\uD83D\uDC39",
    '1f430': "\uD83D\uDC30",
    '1f98a': "\uD83E\uDD8A",
    '1f43b': "\uD83D\uDC3B",
    '1f43c': "\uD83D\uDC3C",
    '1f428': "\uD83D\uDC28",
    '1f42f': "\uD83D\uDC2F",
    '1f981': "\uD83E\uDD81",
    '1f42e': "\uD83D\uDC2E",
    '1f437': "\uD83D\uDC37",
    '1f43d': "\uD83D\uDC3D",
    '1f438': "\uD83D\uDC38",
    '1f435': "\uD83D\uDC35",
    '1f648': "\uD83D\uDE48",
    '1f649': "\uD83D\uDE49",
    '1f64a': "\uD83D\uDE4A",
    '1f412': "\uD83D\uDC12",
    '1f414': "\uD83D\uDC14",
    '1f427': "\uD83D\uDC27",
    '1f426': "\uD83D\uDC26",
    '1f424': "\uD83D\uDC24",
    '1f423': "\uD83D\uDC23",
    '1f425': "\uD83D\uDC25",
    '1f986': "\uD83E\uDD86",
    '1f985': "\uD83E\uDD85",
    '1f989': "\uD83E\uDD89",
    '1f987': "\uD83E\uDD87",
    '1f43a': "\uD83D\uDC3A",
    '1f417': "\uD83D\uDC17",
    '1f434': "\uD83D\uDC34",
    '1f984': "\uD83E\uDD84",
    '1f41d': "\uD83D\uDC1D",
    '1f41b': "\uD83D\uDC1B",
    '1f98b': "\uD83E\uDD8B",
    '1f40c': "\uD83D\uDC0C",
    '1f41a': "\uD83D\uDC1A",
    '1f41e': "\uD83D\uDC1E",
    '1f41c': "\uD83D\uDC1C",
    '1f577': "\uD83D\uDD77\uFE0F",
    '1f578': "\uD83D\uDD78\uFE0F",
    '1f422': "\uD83D\uDC22",
    '1f40d': "\uD83D\uDC0D",
    '1f98e': "\uD83E\uDD8E",
    '1f982': "\uD83E\uDD82",
    '1f980': "\uD83E\uDD80",
    '1f991': "\uD83E\uDD91",
    '1f419': "\uD83D\uDC19",
    '1f990': "\uD83E\uDD90",
    '1f420': "\uD83D\uDC20",
    '1f41f': "\uD83D\uDC1F",
    '1f421': "\uD83D\uDC21",
    '1f42c': "\uD83D\uDC2C",
    '1f988': "\uD83E\uDD88",
    '1f433': "\uD83D\uDC33",
    '1f40b': "\uD83D\uDC0B",
    '1f40a': "\uD83D\uDC0A",
    '1f406': "\uD83D\uDC06",
    '1f405': "\uD83D\uDC05",
    '1f403': "\uD83D\uDC03",
    '1f402': "\uD83D\uDC02",
    '1f404': "\uD83D\uDC04",
    '1f98c': "\uD83E\uDD8C",
    '1f42a': "\uD83D\uDC2A",
    '1f42b': "\uD83D\uDC2B",
    '1f418': "\uD83D\uDC18",
    '1f98f': "\uD83E\uDD8F",
    '1f98d': "\uD83E\uDD8D",
    '1f40e': "\uD83D\uDC0E",
    '1f416': "\uD83D\uDC16",
    '1f410': "\uD83D\uDC10",
    '1f40f': "\uD83D\uDC0F",
    '1f411': "\uD83D\uDC11",
    '1f415': "\uD83D\uDC15",
    '1f429': "\uD83D\uDC29",
    '1f408': "\uD83D\uDC08",
    '1f413': "\uD83D\uDC13",
    '1f983': "\uD83E\uDD83",
    '1f54a': "\uD83D\uDD4A\uFE0F",
    '1f407': "\uD83D\uDC07",
    '1f401': "\uD83D\uDC01",
    '1f400': "\uD83D\uDC00",
    '1f43f': "\uD83D\uDC3F\uFE0F",
    '1f43e': "\uD83D\uDC3E",
    '1f409': "\uD83D\uDC09",
    '1f432': "\uD83D\uDC32",
    '1f335': "\uD83C\uDF35",
    '1f384': "\uD83C\uDF84",
    '1f332': "\uD83C\uDF32",
    '1f333': "\uD83C\uDF33",
    '1f334': "\uD83C\uDF34",
    '1f331': "\uD83C\uDF31",
    '1f33f': "\uD83C\uDF3F",
    '2618': "\u2618\uFE0F",
    '1f340': "\uD83C\uDF40",
    '1f38d': "\uD83C\uDF8D",
    '1f38b': "\uD83C\uDF8B",
    '1f343': "\uD83C\uDF43",
    '1f342': "\uD83C\uDF42",
    '1f341': "\uD83C\uDF41",
    '1f344': "\uD83C\uDF44",
    '1f33e': "\uD83C\uDF3E",
    '1f490': "\uD83D\uDC90",
    '1f337': "\uD83C\uDF37",
    '1f339': "\uD83C\uDF39",
    '1f940': "\uD83E\uDD40",
    '1f33b': "\uD83C\uDF3B",
    '1f33c': "\uD83C\uDF3C",
    '1f338': "\uD83C\uDF38",
    '1f33a': "\uD83C\uDF3A",
    '1f30e': "\uD83C\uDF0E",
    '1f30d': "\uD83C\uDF0D",
    '1f30f': "\uD83C\uDF0F",
    '1f315': "\uD83C\uDF15",
    '1f316': "\uD83C\uDF16",
    '1f317': "\uD83C\uDF17",
    '1f318': "\uD83C\uDF18",
    '1f311': "\uD83C\uDF11",
    '1f312': "\uD83C\uDF12",
    '1f313': "\uD83C\uDF13",
    '1f314': "\uD83C\uDF14",
    '1f31a': "\uD83C\uDF1A",
    '1f31d': "\uD83C\uDF1D",
    '1f31e': "\uD83C\uDF1E",
    '1f31b': "\uD83C\uDF1B",
    '1f31c': "\uD83C\uDF1C",
    '1f319': "\uD83C\uDF19",
    '1f4ab': "\uD83D\uDCAB",
    '2b50': "\u2B50",
    '1f31f': "\uD83C\uDF1F",
    '2728': "\u2728",
    '26a1': "\u26A1",
    '1f525': "\uD83D\uDD25",
    '1f4a5': "\uD83D\uDCA5",
    '2604': "\u2604\uFE0F",
    '2600': "\u2600\uFE0F",
    '1f324': "\uD83C\uDF24\uFE0F",
    '26c5': "\u26C5",
    '1f325': "\uD83C\uDF25\uFE0F",
    '1f326': "\uD83C\uDF26\uFE0F",
    '1f308': "\uD83C\uDF08",
    '2601': "\u2601\uFE0F",
    '1f327': "\uD83C\uDF27\uFE0F",
    '26c8': "\u26C8\uFE0F",
    '1f329': "\uD83C\uDF29\uFE0F",
    '1f328': "\uD83C\uDF28\uFE0F",
    '2603': "\u2603\uFE0F",
    '26c4': "\u26C4",
    '2744': "\u2744\uFE0F",
    '1f32c': "\uD83C\uDF2C\uFE0F",
    '1f4a8': "\uD83D\uDCA8",
    '1f32a': "\uD83C\uDF2A\uFE0F",
    '1f32b': "\uD83C\uDF2B\uFE0F",
    '1f30a': "\uD83C\uDF0A",
    '1f4a7': "\uD83D\uDCA7",
    '1f4a6': "\uD83D\uDCA6",
    '2614': "\u2614",
    '1f992': "\uD83E\uDD92",
    '1f993': "\uD83E\uDD93",
    '1f994': "\uD83E\uDD94",
    '1f995': "\uD83E\uDD95",
    '1f996': "\uD83E\uDD96",
    '1f997': "\uD83E\uDD97",
    '1f34f': "\uD83C\uDF4F",
    '1f34e': "\uD83C\uDF4E",
    '1f350': "\uD83C\uDF50",
    '1f34a': "\uD83C\uDF4A",
    '1f34b': "\uD83C\uDF4B",
    '1f34c': "\uD83C\uDF4C",
    '1f349': "\uD83C\uDF49",
    '1f347': "\uD83C\uDF47",
    '1f353': "\uD83C\uDF53",
    '1f348': "\uD83C\uDF48",
    '1f352': "\uD83C\uDF52",
    '1f351': "\uD83C\uDF51",
    '1f34d': "\uD83C\uDF4D",
    '1f95d': "\uD83E\uDD5D",
    '1f951': "\uD83E\uDD51",
    '1f345': "\uD83C\uDF45",
    '1f346': "\uD83C\uDF46",
    '1f952': "\uD83E\uDD52",
    '1f955': "\uD83E\uDD55",
    '1f33d': "\uD83C\uDF3D",
    '1f336': "\uD83C\uDF36\uFE0F",
    '1f954': "\uD83E\uDD54",
    '1f360': "\uD83C\uDF60",
    '1f330': "\uD83C\uDF30",
    '1f95c': "\uD83E\uDD5C",
    '1f36f': "\uD83C\uDF6F",
    '1f950': "\uD83E\uDD50",
    '1f35e': "\uD83C\uDF5E",
    '1f956': "\uD83E\uDD56",
    '1f9c0': "\uD83E\uDDC0",
    '1f95a': "\uD83E\uDD5A",
    '1f373': "\uD83C\uDF73",
    '1f953': "\uD83E\uDD53",
    '1f95e': "\uD83E\uDD5E",
    '1f364': "\uD83C\uDF64",
    '1f357': "\uD83C\uDF57",
    '1f356': "\uD83C\uDF56",
    '1f355': "\uD83C\uDF55",
    '1f32d': "\uD83C\uDF2D",
    '1f354': "\uD83C\uDF54",
    '1f35f': "\uD83C\uDF5F",
    '1f959': "\uD83E\uDD59",
    '1f32e': "\uD83C\uDF2E",
    '1f32f': "\uD83C\uDF2F",
    '1f957': "\uD83E\uDD57",
    '1f958': "\uD83E\uDD58",
    '1f35d': "\uD83C\uDF5D",
    '1f35c': "\uD83C\uDF5C",
    '1f372': "\uD83C\uDF72",
    '1f365': "\uD83C\uDF65",
    '1f363': "\uD83C\uDF63",
    '1f371': "\uD83C\uDF71",
    '1f35b': "\uD83C\uDF5B",
    '1f359': "\uD83C\uDF59",
    '1f35a': "\uD83C\uDF5A",
    '1f358': "\uD83C\uDF58",
    '1f362': "\uD83C\uDF62",
    '1f361': "\uD83C\uDF61",
    '1f367': "\uD83C\uDF67",
    '1f368': "\uD83C\uDF68",
    '1f366': "\uD83C\uDF66",
    '1f370': "\uD83C\uDF70",
    '1f382': "\uD83C\uDF82",
    '1f36e': "\uD83C\uDF6E",
    '1f36d': "\uD83C\uDF6D",
    '1f36c': "\uD83C\uDF6C",
    '1f36b': "\uD83C\uDF6B",
    '1f37f': "\uD83C\uDF7F",
    '1f369': "\uD83C\uDF69",
    '1f36a': "\uD83C\uDF6A",
    '1f95b': "\uD83E\uDD5B",
    '1f37c': "\uD83C\uDF7C",
    '2615': "\u2615",
    '1f375': "\uD83C\uDF75",
    '1f376': "\uD83C\uDF76",
    '1f37a': "\uD83C\uDF7A",
    '1f37b': "\uD83C\uDF7B",
    '1f942': "\uD83E\uDD42",
    '1f377': "\uD83C\uDF77",
    '1f943': "\uD83E\uDD43",
    '1f378': "\uD83C\uDF78",
    '1f379': "\uD83C\uDF79",
    '1f37e': "\uD83C\uDF7E",
    '1f944': "\uD83E\uDD44",
    '1f374': "\uD83C\uDF74",
    '1f37d': "\uD83C\uDF7D\uFE0F",
    '1f95f': "\uD83E\uDD5F",
    '1f960': "\uD83E\uDD60",
    '1f961': "\uD83E\uDD61",
    '1f962': "\uD83E\uDD62",
    '1f963': "\uD83E\uDD63",
    '1f964': "\uD83E\uDD64",
    '1f965': "\uD83E\uDD65",
    '1f966': "\uD83E\uDD66",
    '1f967': "\uD83E\uDD67",
    '1f968': "\uD83E\uDD68",
    '1f969': "\uD83E\uDD69",
    '1f96a': "\uD83E\uDD6A",
    '1f96b': "\uD83E\uDD6B",
    '26bd': "\u26BD",
    '1f3c0': "\uD83C\uDFC0",
    '1f3c8': "\uD83C\uDFC8",
    '26be': "\u26BE",
    '1f3be': "\uD83C\uDFBE",
    '1f3d0': "\uD83C\uDFD0",
    '1f3c9': "\uD83C\uDFC9",
    '1f3b1': "\uD83C\uDFB1",
    '1f3d3': "\uD83C\uDFD3",
    '1f3f8': "\uD83C\uDFF8",
    '1f945': "\uD83E\uDD45",
    '1f3d2': "\uD83C\uDFD2",
    '1f3d1': "\uD83C\uDFD1",
    '1f3cf': "\uD83C\uDFCF",
    '26f3': "\u26F3",
    '1f3f9': "\uD83C\uDFF9",
    '1f3a3': "\uD83C\uDFA3",
    '1f94a': "\uD83E\uDD4A",
    '1f94b': "\uD83E\uDD4B",
    '26f8': "\u26F8\uFE0F",
    '1f3bf': "\uD83C\uDFBF",
    '26f7': "\u26F7\uFE0F",
    '1f3c2': "\uD83C\uDFC2",
    '1f3cb-fe0f-200d-2640-fe0f': "\uD83C\uDFCB\uFE0F\u200D\u2640\uFE0F",
    '1f3cb': "\uD83C\uDFCB\uFE0F",
    '1f3cb-fe0f-200d-2642-fe0f': "\uD83C\uDFCB\uFE0F\u200D\u2642\uFE0F",
    '1f93a': "\uD83E\uDD3A",
    '1f93c-200d-2640-fe0f': "\uD83E\uDD3C\u200D\u2640\uFE0F",
    '1f93c-200d-2642-fe0f': "\uD83E\uDD3C\u200D\u2642\uFE0F",
    '1f93c': "\uD83E\uDD3C",
    '1f938-200d-2640-fe0f': "\uD83E\uDD38\u200D\u2640\uFE0F",
    '1f938-200d-2642-fe0f': "\uD83E\uDD38\u200D\u2642\uFE0F",
    '1f938': "\uD83E\uDD38",
    '26f9-fe0f-200d-2640-fe0f': "\u26F9\uFE0F\u200D\u2640\uFE0F",
    '26f9': "\u26F9\uFE0F",
    '26f9-fe0f-200d-2642-fe0f': "\u26F9\uFE0F\u200D\u2642\uFE0F",
    '1f93e-200d-2640-fe0f': "\uD83E\uDD3E\u200D\u2640\uFE0F",
    '1f93e-200d-2642-fe0f': "\uD83E\uDD3E\u200D\u2642\uFE0F",
    '1f93e': "\uD83E\uDD3E",
    '1f3cc-fe0f-200d-2640-fe0f': "\uD83C\uDFCC\uFE0F\u200D\u2640\uFE0F",
    '1f3cc': "\uD83C\uDFCC\uFE0F",
    '1f3cc-fe0f-200d-2642-fe0f': "\uD83C\uDFCC\uFE0F\u200D\u2642\uFE0F",
    '1f3c4-200d-2640-fe0f': "\uD83C\uDFC4\u200D\u2640\uFE0F",
    '1f3c4': "\uD83C\uDFC4",
    '1f3c4-200d-2642-fe0f': "\uD83C\uDFC4\u200D\u2642\uFE0F",
    '1f3ca-200d-2640-fe0f': "\uD83C\uDFCA\u200D\u2640\uFE0F",
    '1f3ca': "\uD83C\uDFCA",
    '1f3ca-200d-2642-fe0f': "\uD83C\uDFCA\u200D\u2642\uFE0F",
    '1f93d-200d-2640-fe0f': "\uD83E\uDD3D\u200D\u2640\uFE0F",
    '1f93d-200d-2642-fe0f': "\uD83E\uDD3D\u200D\u2642\uFE0F",
    '1f93d': "\uD83E\uDD3D",
    '1f6a3-200d-2640-fe0f': "\uD83D\uDEA3\u200D\u2640\uFE0F",
    '1f6a3': "\uD83D\uDEA3",
    '1f6a3-200d-2642-fe0f': "\uD83D\uDEA3\u200D\u2642\uFE0F",
    '1f3c7': "\uD83C\uDFC7",
    '1f6b4-200d-2640-fe0f': "\uD83D\uDEB4\u200D\u2640\uFE0F",
    '1f6b4': "\uD83D\uDEB4",
    '1f6b4-200d-2642-fe0f': "\uD83D\uDEB4\u200D\u2642\uFE0F",
    '1f6b5-200d-2640-fe0f': "\uD83D\uDEB5\u200D\u2640\uFE0F",
    '1f6b5': "\uD83D\uDEB5",
    '1f6b5-200d-2642-fe0f': "\uD83D\uDEB5\u200D\u2642\uFE0F",
    '1f3bd': "\uD83C\uDFBD",
    '1f3c5': "\uD83C\uDFC5",
    '1f396': "\uD83C\uDF96\uFE0F",
    '1f947': "\uD83E\uDD47",
    '1f948': "\uD83E\uDD48",
    '1f949': "\uD83E\uDD49",
    '1f3c6': "\uD83C\uDFC6",
    '1f3f5': "\uD83C\uDFF5\uFE0F",
    '1f397': "\uD83C\uDF97\uFE0F",
    '1f3ab': "\uD83C\uDFAB",
    '1f39f': "\uD83C\uDF9F\uFE0F",
    '1f3aa': "\uD83C\uDFAA",
    '1f939-200d-2640-fe0f': "\uD83E\uDD39\u200D\u2640\uFE0F",
    '1f939-200d-2642-fe0f': "\uD83E\uDD39\u200D\u2642\uFE0F",
    '1f939': "\uD83E\uDD39",
    '1f3ad': "\uD83C\uDFAD",
    '1f3a8': "\uD83C\uDFA8",
    '1f3ac': "\uD83C\uDFAC",
    '1f3a4': "\uD83C\uDFA4",
    '1f3a7': "\uD83C\uDFA7",
    '1f3bc': "\uD83C\uDFBC",
    '1f3b9': "\uD83C\uDFB9",
    '1f941': "\uD83E\uDD41",
    '1f3b7': "\uD83C\uDFB7",
    '1f3ba': "\uD83C\uDFBA",
    '1f3b8': "\uD83C\uDFB8",
    '1f3bb': "\uD83C\uDFBB",
    '1f3b2': "\uD83C\uDFB2",
    '1f3af': "\uD83C\uDFAF",
    '1f3b3': "\uD83C\uDFB3",
    '1f3ae': "\uD83C\uDFAE",
    '1f3b0': "\uD83C\uDFB0",
    '1f6f7': "\uD83D\uDEF7",
    '1f931': "\uD83E\uDD31",
    '1f94c': "\uD83E\uDD4C",
    '1f9d6': "\uD83E\uDDD6",
    '1f9d7': "\uD83E\uDDD7",
    '1f9d8': "\uD83E\uDDD8",
    '1f9d6-200d-2640-fe0f': "\uD83E\uDDD6\u200D\u2640\uFE0F",
    '1f9d6-200d-2642-fe0f': "\uD83E\uDDD6\u200D\u2642\uFE0F",
    '1f9d7-200d-2640-fe0f': "\uD83E\uDDD7\u200D\u2640\uFE0F",
    '1f9d7-200d-2642-fe0f': "\uD83E\uDDD7\u200D\u2642\uFE0F",
    '1f9d8-200d-2640-fe0f': "\uD83E\uDDD8\u200D\u2640\uFE0F",
    '1f9d8-200d-2642-fe0f': "\uD83E\uDDD8\u200D\u2642\uFE0F",
    '1f697': "\uD83D\uDE97",
    '1f695': "\uD83D\uDE95",
    '1f699': "\uD83D\uDE99",
    '1f68c': "\uD83D\uDE8C",
    '1f68e': "\uD83D\uDE8E",
    '1f3ce': "\uD83C\uDFCE\uFE0F",
    '1f693': "\uD83D\uDE93",
    '1f691': "\uD83D\uDE91",
    '1f692': "\uD83D\uDE92",
    '1f690': "\uD83D\uDE90",
    '1f69a': "\uD83D\uDE9A",
    '1f69b': "\uD83D\uDE9B",
    '1f69c': "\uD83D\uDE9C",
    '1f6f4': "\uD83D\uDEF4",
    '1f6b2': "\uD83D\uDEB2",
    '1f6f5': "\uD83D\uDEF5",
    '1f3cd': "\uD83C\uDFCD\uFE0F",
    '1f6a8': "\uD83D\uDEA8",
    '1f694': "\uD83D\uDE94",
    '1f68d': "\uD83D\uDE8D",
    '1f698': "\uD83D\uDE98",
    '1f696': "\uD83D\uDE96",
    '1f6a1': "\uD83D\uDEA1",
    '1f6a0': "\uD83D\uDEA0",
    '1f69f': "\uD83D\uDE9F",
    '1f683': "\uD83D\uDE83",
    '1f68b': "\uD83D\uDE8B",
    '1f69e': "\uD83D\uDE9E",
    '1f69d': "\uD83D\uDE9D",
    '1f684': "\uD83D\uDE84",
    '1f685': "\uD83D\uDE85",
    '1f688': "\uD83D\uDE88",
    '1f682': "\uD83D\uDE82",
    '1f686': "\uD83D\uDE86",
    '1f687': "\uD83D\uDE87",
    '1f68a': "\uD83D\uDE8A",
    '1f689': "\uD83D\uDE89",
    '1f681': "\uD83D\uDE81",
    '1f6e9': "\uD83D\uDEE9\uFE0F",
    '2708': "\u2708\uFE0F",
    '1f6eb': "\uD83D\uDEEB",
    '1f6ec': "\uD83D\uDEEC",
    '1f680': "\uD83D\uDE80",
    '1f6f0': "\uD83D\uDEF0\uFE0F",
    '1f4ba': "\uD83D\uDCBA",
    '1f6f6': "\uD83D\uDEF6",
    '26f5': "\u26F5",
    '1f6e5': "\uD83D\uDEE5\uFE0F",
    '1f6a4': "\uD83D\uDEA4",
    '1f6f3': "\uD83D\uDEF3\uFE0F",
    '26f4': "\u26F4\uFE0F",
    '1f6a2': "\uD83D\uDEA2",
    '2693': "\u2693",
    '1f6a7': "\uD83D\uDEA7",
    '26fd': "\u26FD",
    '1f68f': "\uD83D\uDE8F",
    '1f6a6': "\uD83D\uDEA6",
    '1f6a5': "\uD83D\uDEA5",
    '1f5fa': "\uD83D\uDDFA\uFE0F",
    '1f5ff': "\uD83D\uDDFF",
    '1f5fd': "\uD83D\uDDFD",
    '26f2': "\u26F2",
    '1f5fc': "\uD83D\uDDFC",
    '1f3f0': "\uD83C\uDFF0",
    '1f3ef': "\uD83C\uDFEF",
    '1f3df': "\uD83C\uDFDF\uFE0F",
    '1f3a1': "\uD83C\uDFA1",
    '1f3a2': "\uD83C\uDFA2",
    '1f3a0': "\uD83C\uDFA0",
    '26f1': "\u26F1\uFE0F",
    '1f3d6': "\uD83C\uDFD6\uFE0F",
    '1f3dd': "\uD83C\uDFDD\uFE0F",
    '26f0': "\u26F0\uFE0F",
    '1f3d4': "\uD83C\uDFD4\uFE0F",
    '1f5fb': "\uD83D\uDDFB",
    '1f30b': "\uD83C\uDF0B",
    '1f3dc': "\uD83C\uDFDC\uFE0F",
    '1f3d5': "\uD83C\uDFD5\uFE0F",
    '26fa': "\u26FA",
    '1f6e4': "\uD83D\uDEE4\uFE0F",
    '1f6e3': "\uD83D\uDEE3\uFE0F",
    '1f3d7': "\uD83C\uDFD7\uFE0F",
    '1f3ed': "\uD83C\uDFED",
    '1f3e0': "\uD83C\uDFE0",
    '1f3e1': "\uD83C\uDFE1",
    '1f3d8': "\uD83C\uDFD8\uFE0F",
    '1f3da': "\uD83C\uDFDA\uFE0F",
    '1f3e2': "\uD83C\uDFE2",
    '1f3ec': "\uD83C\uDFEC",
    '1f3e3': "\uD83C\uDFE3",
    '1f3e4': "\uD83C\uDFE4",
    '1f3e5': "\uD83C\uDFE5",
    '1f3e6': "\uD83C\uDFE6",
    '1f3e8': "\uD83C\uDFE8",
    '1f3ea': "\uD83C\uDFEA",
    '1f3eb': "\uD83C\uDFEB",
    '1f3e9': "\uD83C\uDFE9",
    '1f492': "\uD83D\uDC92",
    '1f3db': "\uD83C\uDFDB\uFE0F",
    '26ea': "\u26EA",
    '1f54c': "\uD83D\uDD4C",
    '1f54d': "\uD83D\uDD4D",
    '1f54b': "\uD83D\uDD4B",
    '26e9': "\u26E9\uFE0F",
    '1f5fe': "\uD83D\uDDFE",
    '1f391': "\uD83C\uDF91",
    '1f3de': "\uD83C\uDFDE\uFE0F",
    '1f305': "\uD83C\uDF05",
    '1f304': "\uD83C\uDF04",
    '1f320': "\uD83C\uDF20",
    '1f387': "\uD83C\uDF87",
    '1f386': "\uD83C\uDF86",
    '1f307': "\uD83C\uDF07",
    '1f306': "\uD83C\uDF06",
    '1f3d9': "\uD83C\uDFD9\uFE0F",
    '1f303': "\uD83C\uDF03",
    '1f30c': "\uD83C\uDF0C",
    '1f309': "\uD83C\uDF09",
    '1f301': "\uD83C\uDF01",
    '1f6f8': "\uD83D\uDEF8",
    '231a': "\u231A",
    '1f4f1': "\uD83D\uDCF1",
    '1f4f2': "\uD83D\uDCF2",
    '1f4bb': "\uD83D\uDCBB",
    '2328': "\u2328\uFE0F",
    '1f5a5': "\uD83D\uDDA5\uFE0F",
    '1f5a8': "\uD83D\uDDA8\uFE0F",
    '1f5b1': "\uD83D\uDDB1\uFE0F",
    '1f5b2': "\uD83D\uDDB2\uFE0F",
    '1f579': "\uD83D\uDD79\uFE0F",
    '1f5dc': "\uD83D\uDDDC\uFE0F",
    '1f4bd': "\uD83D\uDCBD",
    '1f4be': "\uD83D\uDCBE",
    '1f4bf': "\uD83D\uDCBF",
    '1f4c0': "\uD83D\uDCC0",
    '1f4fc': "\uD83D\uDCFC",
    '1f4f7': "\uD83D\uDCF7",
    '1f4f8': "\uD83D\uDCF8",
    '1f4f9': "\uD83D\uDCF9",
    '1f3a5': "\uD83C\uDFA5",
    '1f4fd': "\uD83D\uDCFD\uFE0F",
    '1f39e': "\uD83C\uDF9E\uFE0F",
    '1f4de': "\uD83D\uDCDE",
    '260e': "\u260E\uFE0F",
    '1f4df': "\uD83D\uDCDF",
    '1f4e0': "\uD83D\uDCE0",
    '1f4fa': "\uD83D\uDCFA",
    '1f4fb': "\uD83D\uDCFB",
    '1f399': "\uD83C\uDF99\uFE0F",
    '1f39a': "\uD83C\uDF9A\uFE0F",
    '1f39b': "\uD83C\uDF9B\uFE0F",
    '23f1': "\u23F1\uFE0F",
    '23f2': "\u23F2\uFE0F",
    '23f0': "\u23F0",
    '1f570': "\uD83D\uDD70\uFE0F",
    '231b': "\u231B",
    '23f3': "\u23F3",
    '1f4e1': "\uD83D\uDCE1",
    '1f50b': "\uD83D\uDD0B",
    '1f50c': "\uD83D\uDD0C",
    '1f4a1': "\uD83D\uDCA1",
    '1f526': "\uD83D\uDD26",
    '1f56f': "\uD83D\uDD6F\uFE0F",
    '1f5d1': "\uD83D\uDDD1\uFE0F",
    '1f6e2': "\uD83D\uDEE2\uFE0F",
    '1f4b8': "\uD83D\uDCB8",
    '1f4b5': "\uD83D\uDCB5",
    '1f4b4': "\uD83D\uDCB4",
    '1f4b6': "\uD83D\uDCB6",
    '1f4b7': "\uD83D\uDCB7",
    '1f4b0': "\uD83D\uDCB0",
    '1f4b3': "\uD83D\uDCB3",
    '1f48e': "\uD83D\uDC8E",
    '2696': "\u2696\uFE0F",
    '1f527': "\uD83D\uDD27",
    '1f528': "\uD83D\uDD28",
    '2692': "\u2692\uFE0F",
    '1f6e0': "\uD83D\uDEE0\uFE0F",
    '26cf': "\u26CF\uFE0F",
    '1f529': "\uD83D\uDD29",
    '2699': "\u2699\uFE0F",
    '26d3': "\u26D3\uFE0F",
    '1f52b': "\uD83D\uDD2B",
    '1f4a3': "\uD83D\uDCA3",
    '1f52a': "\uD83D\uDD2A",
    '1f5e1': "\uD83D\uDDE1\uFE0F",
    '2694': "\u2694\uFE0F",
    '1f6e1': "\uD83D\uDEE1\uFE0F",
    '1f6ac': "\uD83D\uDEAC",
    '26b0': "\u26B0\uFE0F",
    '26b1': "\u26B1\uFE0F",
    '1f3fa': "\uD83C\uDFFA",
    '1f52e': "\uD83D\uDD2E",
    '1f4ff': "\uD83D\uDCFF",
    '1f488': "\uD83D\uDC88",
    '2697': "\u2697\uFE0F",
    '1f52d': "\uD83D\uDD2D",
    '1f52c': "\uD83D\uDD2C",
    '1f573': "\uD83D\uDD73\uFE0F",
    '1f48a': "\uD83D\uDC8A",
    '1f489': "\uD83D\uDC89",
    '1f321': "\uD83C\uDF21\uFE0F",
    '1f6bd': "\uD83D\uDEBD",
    '1f6b0': "\uD83D\uDEB0",
    '1f6bf': "\uD83D\uDEBF",
    '1f6c1': "\uD83D\uDEC1",
    '1f6c0': "\uD83D\uDEC0",
    '1f6ce': "\uD83D\uDECE\uFE0F",
    '1f511': "\uD83D\uDD11",
    '1f5dd': "\uD83D\uDDDD\uFE0F",
    '1f6aa': "\uD83D\uDEAA",
    '1f6cb': "\uD83D\uDECB\uFE0F",
    '1f6cf': "\uD83D\uDECF\uFE0F",
    '1f6cc': "\uD83D\uDECC",
    '1f5bc': "\uD83D\uDDBC\uFE0F",
    '1f6cd': "\uD83D\uDECD\uFE0F",
    '1f6d2': "\uD83D\uDED2",
    '1f381': "\uD83C\uDF81",
    '1f388': "\uD83C\uDF88",
    '1f38f': "\uD83C\uDF8F",
    '1f380': "\uD83C\uDF80",
    '1f38a': "\uD83C\uDF8A",
    '1f389': "\uD83C\uDF89",
    '1f38e': "\uD83C\uDF8E",
    '1f3ee': "\uD83C\uDFEE",
    '1f390': "\uD83C\uDF90",
    '2709': "\u2709\uFE0F",
    '1f4e9': "\uD83D\uDCE9",
    '1f4e8': "\uD83D\uDCE8",
    '1f4e7': "\uD83D\uDCE7",
    '1f48c': "\uD83D\uDC8C",
    '1f4e5': "\uD83D\uDCE5",
    '1f4e4': "\uD83D\uDCE4",
    '1f4e6': "\uD83D\uDCE6",
    '1f3f7': "\uD83C\uDFF7\uFE0F",
    '1f4ea': "\uD83D\uDCEA",
    '1f4eb': "\uD83D\uDCEB",
    '1f4ec': "\uD83D\uDCEC",
    '1f4ed': "\uD83D\uDCED",
    '1f4ee': "\uD83D\uDCEE",
    '1f4ef': "\uD83D\uDCEF",
    '1f4dc': "\uD83D\uDCDC",
    '1f4c3': "\uD83D\uDCC3",
    '1f4c4': "\uD83D\uDCC4",
    '1f4d1': "\uD83D\uDCD1",
    '1f4ca': "\uD83D\uDCCA",
    '1f4c8': "\uD83D\uDCC8",
    '1f4c9': "\uD83D\uDCC9",
    '1f5d2': "\uD83D\uDDD2\uFE0F",
    '1f5d3': "\uD83D\uDDD3\uFE0F",
    '1f4c6': "\uD83D\uDCC6",
    '1f4c5': "\uD83D\uDCC5",
    '1f4c7': "\uD83D\uDCC7",
    '1f5c3': "\uD83D\uDDC3\uFE0F",
    '1f5f3': "\uD83D\uDDF3\uFE0F",
    '1f5c4': "\uD83D\uDDC4\uFE0F",
    '1f4cb': "\uD83D\uDCCB",
    '1f4c1': "\uD83D\uDCC1",
    '1f4c2': "\uD83D\uDCC2",
    '1f5c2': "\uD83D\uDDC2\uFE0F",
    '1f5de': "\uD83D\uDDDE\uFE0F",
    '1f4f0': "\uD83D\uDCF0",
    '1f4d3': "\uD83D\uDCD3",
    '1f4d4': "\uD83D\uDCD4",
    '1f4d2': "\uD83D\uDCD2",
    '1f4d5': "\uD83D\uDCD5",
    '1f4d7': "\uD83D\uDCD7",
    '1f4d8': "\uD83D\uDCD8",
    '1f4d9': "\uD83D\uDCD9",
    '1f4da': "\uD83D\uDCDA",
    '1f4d6': "\uD83D\uDCD6",
    '1f516': "\uD83D\uDD16",
    '1f517': "\uD83D\uDD17",
    '1f4ce': "\uD83D\uDCCE",
    '1f587': "\uD83D\uDD87\uFE0F",
    '1f4d0': "\uD83D\uDCD0",
    '1f4cf': "\uD83D\uDCCF",
    '1f4cc': "\uD83D\uDCCC",
    '1f4cd': "\uD83D\uDCCD",
    '2702': "\u2702\uFE0F",
    '1f58a': "\uD83D\uDD8A\uFE0F",
    '1f58b': "\uD83D\uDD8B\uFE0F",
    '2712': "\u2712\uFE0F",
    '1f58c': "\uD83D\uDD8C\uFE0F",
    '1f58d': "\uD83D\uDD8D\uFE0F",
    '1f4dd': "\uD83D\uDCDD",
    '270f': "\u270F\uFE0F",
    '1f50d': "\uD83D\uDD0D",
    '1f50e': "\uD83D\uDD0E",
    '1f50f': "\uD83D\uDD0F",
    '1f510': "\uD83D\uDD10",
    '1f512': "\uD83D\uDD12",
    '1f513': "\uD83D\uDD13",
    '1f9e1': "\uD83E\uDDE1",
    '2764': "\u2764\uFE0F",
    '1f49b': "\uD83D\uDC9B",
    '1f49a': "\uD83D\uDC9A",
    '1f499': "\uD83D\uDC99",
    '1f49c': "\uD83D\uDC9C",
    '1f5a4': "\uD83D\uDDA4",
    '1f494': "\uD83D\uDC94",
    '2763': "\u2763\uFE0F",
    '1f495': "\uD83D\uDC95",
    '1f49e': "\uD83D\uDC9E",
    '1f493': "\uD83D\uDC93",
    '1f497': "\uD83D\uDC97",
    '1f496': "\uD83D\uDC96",
    '1f498': "\uD83D\uDC98",
    '1f49d': "\uD83D\uDC9D",
    '1f49f': "\uD83D\uDC9F",
    '262e': "\u262E\uFE0F",
    '271d': "\u271D\uFE0F",
    '262a': "\u262A\uFE0F",
    '1f549': "\uD83D\uDD49\uFE0F",
    '2638': "\u2638\uFE0F",
    '2721': "\u2721\uFE0F",
    '1f52f': "\uD83D\uDD2F",
    '1f54e': "\uD83D\uDD4E",
    '262f': "\u262F\uFE0F",
    '2626': "\u2626\uFE0F",
    '1f6d0': "\uD83D\uDED0",
    '26ce': "\u26CE",
    '2648': "\u2648",
    '2649': "\u2649",
    '264a': "\u264A",
    '264b': "\u264B",
    '264c': "\u264C",
    '264d': "\u264D",
    '264e': "\u264E",
    '264f': "\u264F",
    '2650': "\u2650",
    '2651': "\u2651",
    '2652': "\u2652",
    '2653': "\u2653",
    '1f194': "\uD83C\uDD94",
    '269b': "\u269B\uFE0F",
    '1f251': "\uD83C\uDE51",
    '2622': "\u2622\uFE0F",
    '2623': "\u2623\uFE0F",
    '1f4f4': "\uD83D\uDCF4",
    '1f4f3': "\uD83D\uDCF3",
    '1f236': "\uD83C\uDE36",
    '1f21a': "\uD83C\uDE1A",
    '1f238': "\uD83C\uDE38",
    '1f23a': "\uD83C\uDE3A",
    '1f237': "\uD83C\uDE37\uFE0F",
    '2734': "\u2734\uFE0F",
    '1f19a': "\uD83C\uDD9A",
    '1f4ae': "\uD83D\uDCAE",
    '1f250': "\uD83C\uDE50",
    '3299': "\u3299\uFE0F",
    '3297': "\u3297\uFE0F",
    '1f234': "\uD83C\uDE34",
    '1f235': "\uD83C\uDE35",
    '1f239': "\uD83C\uDE39",
    '1f232': "\uD83C\uDE32",
    '1f170': "\uD83C\uDD70\uFE0F",
    '1f171': "\uD83C\uDD71\uFE0F",
    '1f18e': "\uD83C\uDD8E",
    '1f191': "\uD83C\uDD91",
    '1f17e': "\uD83C\uDD7E\uFE0F",
    '1f198': "\uD83C\uDD98",
    '274c': "\u274C",
    '2b55': "\u2B55",
    '1f6d1': "\uD83D\uDED1",
    '26d4': "\u26D4",
    '1f4db': "\uD83D\uDCDB",
    '1f6ab': "\uD83D\uDEAB",
    '1f4af': "\uD83D\uDCAF",
    '1f4a2': "\uD83D\uDCA2",
    '2668': "\u2668\uFE0F",
    '1f6b7': "\uD83D\uDEB7",
    '1f6af': "\uD83D\uDEAF",
    '1f6b3': "\uD83D\uDEB3",
    '1f6b1': "\uD83D\uDEB1",
    '1f51e': "\uD83D\uDD1E",
    '1f4f5': "\uD83D\uDCF5",
    '1f6ad': "\uD83D\uDEAD",
    '2757': "\u2757",
    '2755': "\u2755",
    '2753': "\u2753",
    '2754': "\u2754",
    '203c': "\u203C\uFE0F",
    '2049': "\u2049\uFE0F",
    '1f505': "\uD83D\uDD05",
    '1f506': "\uD83D\uDD06",
    '303d': "\u303D\uFE0F",
    '26a0': "\u26A0\uFE0F",
    '1f6b8': "\uD83D\uDEB8",
    '1f531': "\uD83D\uDD31",
    '269c': "\u269C\uFE0F",
    '1f530': "\uD83D\uDD30",
    '267b': "\u267B\uFE0F",
    '2705': "\u2705",
    '1f22f': "\uD83C\uDE2F",
    '1f4b9': "\uD83D\uDCB9",
    '2747': "\u2747\uFE0F",
    '2733': "\u2733\uFE0F",
    '274e': "\u274E",
    '1f310': "\uD83C\uDF10",
    '1f4a0': "\uD83D\uDCA0",
    '24c2': "\u24C2\uFE0F",
    '1f300': "\uD83C\uDF00",
    '1f4a4': "\uD83D\uDCA4",
    '1f3e7': "\uD83C\uDFE7",
    '1f6be': "\uD83D\uDEBE",
    '267f': "\u267F",
    '1f17f': "\uD83C\uDD7F\uFE0F",
    '1f233': "\uD83C\uDE33",
    '1f202': "\uD83C\uDE02\uFE0F",
    '1f6c2': "\uD83D\uDEC2",
    '1f6c3': "\uD83D\uDEC3",
    '1f6c4': "\uD83D\uDEC4",
    '1f6c5': "\uD83D\uDEC5",
    '1f6b9': "\uD83D\uDEB9",
    '1f6ba': "\uD83D\uDEBA",
    '1f6bc': "\uD83D\uDEBC",
    '1f6bb': "\uD83D\uDEBB",
    '1f6ae': "\uD83D\uDEAE",
    '1f3a6': "\uD83C\uDFA6",
    '1f4f6': "\uD83D\uDCF6",
    '1f201': "\uD83C\uDE01",
    '1f523': "\uD83D\uDD23",
    '2139': "\u2139\uFE0F",
    '1f524': "\uD83D\uDD24",
    '1f521': "\uD83D\uDD21",
    '1f520': "\uD83D\uDD20",
    '1f196': "\uD83C\uDD96",
    '1f197': "\uD83C\uDD97",
    '1f199': "\uD83C\uDD99",
    '1f192': "\uD83C\uDD92",
    '1f195': "\uD83C\uDD95",
    '1f193': "\uD83C\uDD93",
    '30-20e3': "0\uFE0F\u20E3",
    '31-20e3': "1\uFE0F\u20E3",
    '32-20e3': "2\uFE0F\u20E3",
    '33-20e3': "3\uFE0F\u20E3",
    '34-20e3': "4\uFE0F\u20E3",
    '35-20e3': "5\uFE0F\u20E3",
    '36-20e3': "6\uFE0F\u20E3",
    '37-20e3': "7\uFE0F\u20E3",
    '38-20e3': "8\uFE0F\u20E3",
    '39-20e3': "9\uFE0F\u20E3",
    '1f51f': "\uD83D\uDD1F",
    '1f522': "\uD83D\uDD22",
    '23-20e3': "#\uFE0F\u20E3",
    '2a-20e3': "*\uFE0F\u20E3",
    '25b6': "\u25B6\uFE0F",
    '23f8': "\u23F8\uFE0F",
    '23ef': "\u23EF\uFE0F",
    '23f9': "\u23F9\uFE0F",
    '23fa': "\u23FA\uFE0F",
    '23cf': "\u23CF\uFE0F",
    '23ed': "\u23ED\uFE0F",
    '23ee': "\u23EE\uFE0F",
    '23e9': "\u23E9",
    '23ea': "\u23EA",
    '23eb': "\u23EB",
    '23ec': "\u23EC",
    '25c0': "\u25C0\uFE0F",
    '1f53c': "\uD83D\uDD3C",
    '1f53d': "\uD83D\uDD3D",
    '27a1': "\u27A1\uFE0F",
    '2b05': "\u2B05\uFE0F",
    '2b06': "\u2B06\uFE0F",
    '2b07': "\u2B07\uFE0F",
    '2197': "\u2197\uFE0F",
    '2198': "\u2198\uFE0F",
    '2199': "\u2199\uFE0F",
    '2196': "\u2196\uFE0F",
    '2195': "\u2195\uFE0F",
    '2194': "\u2194\uFE0F",
    '21aa': "\u21AA\uFE0F",
    '21a9': "\u21A9\uFE0F",
    '2934': "\u2934\uFE0F",
    '2935': "\u2935\uFE0F",
    '1f500': "\uD83D\uDD00",
    '1f501': "\uD83D\uDD01",
    '1f502': "\uD83D\uDD02",
    '1f504': "\uD83D\uDD04",
    '1f503': "\uD83D\uDD03",
    '1f3b5': "\uD83C\uDFB5",
    '1f3b6': "\uD83C\uDFB6",
    '2795': "\u2795",
    '2796': "\u2796",
    '2797': "\u2797",
    '2716': "\u2716\uFE0F",
    '1f4b2': "\uD83D\uDCB2",
    '1f4b1': "\uD83D\uDCB1",
    '2122': "\u2122\uFE0F",
    a9: "\xa9\uFE0F",
    ae: "\xae\uFE0F",
    '3030': "\u3030\uFE0F",
    '27b0': "\u27B0",
    '27bf': "\u27BF",
    '1f51a': "\uD83D\uDD1A",
    '1f519': "\uD83D\uDD19",
    '1f51b': "\uD83D\uDD1B",
    '1f51d': "\uD83D\uDD1D",
    '1f51c': "\uD83D\uDD1C",
    '2714': "\u2714\uFE0F",
    '2611': "\u2611\uFE0F",
    '1f518': "\uD83D\uDD18",
    '26aa': "\u26AA",
    '26ab': "\u26AB",
    '1f534': "\uD83D\uDD34",
    '1f535': "\uD83D\uDD35",
    '1f53a': "\uD83D\uDD3A",
    '1f53b': "\uD83D\uDD3B",
    '1f538': "\uD83D\uDD38",
    '1f539': "\uD83D\uDD39",
    '1f536': "\uD83D\uDD36",
    '1f537': "\uD83D\uDD37",
    '1f533': "\uD83D\uDD33",
    '1f532': "\uD83D\uDD32",
    '25aa': "\u25AA\uFE0F",
    '25ab': "\u25AB\uFE0F",
    '25fe': "\u25FE",
    '25fd': "\u25FD",
    '25fc': "\u25FC\uFE0F",
    '25fb': "\u25FB\uFE0F",
    '2b1b': "\u2B1B",
    '2b1c': "\u2B1C",
    '1f508': "\uD83D\uDD08",
    '1f507': "\uD83D\uDD07",
    '1f509': "\uD83D\uDD09",
    '1f50a': "\uD83D\uDD0A",
    '1f514': "\uD83D\uDD14",
    '1f515': "\uD83D\uDD15",
    '1f4e3': "\uD83D\uDCE3",
    '1f4e2': "\uD83D\uDCE2",
    '1f5e8': "\uD83D\uDDE8\uFE0F",
    '1f441-fe0f-200d-1f5e8-fe0f': "\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8\uFE0F",
    '1f4ac': "\uD83D\uDCAC",
    '1f4ad': "\uD83D\uDCAD",
    '1f5ef': "\uD83D\uDDEF\uFE0F",
    '2660': "\u2660\uFE0F",
    '2663': "\u2663\uFE0F",
    '2665': "\u2665\uFE0F",
    '2666': "\u2666\uFE0F",
    '1f0cf': "\uD83C\uDCCF",
    '1f3b4': "\uD83C\uDFB4",
    '1f004': "\uD83C\uDC04",
    '1f550': "\uD83D\uDD50",
    '1f551': "\uD83D\uDD51",
    '1f552': "\uD83D\uDD52",
    '1f553': "\uD83D\uDD53",
    '1f554': "\uD83D\uDD54",
    '1f555': "\uD83D\uDD55",
    '1f556': "\uD83D\uDD56",
    '1f557': "\uD83D\uDD57",
    '1f558': "\uD83D\uDD58",
    '1f559': "\uD83D\uDD59",
    '1f55a': "\uD83D\uDD5A",
    '1f55b': "\uD83D\uDD5B",
    '1f55c': "\uD83D\uDD5C",
    '1f55d': "\uD83D\uDD5D",
    '1f55e': "\uD83D\uDD5E",
    '1f55f': "\uD83D\uDD5F",
    '1f560': "\uD83D\uDD60",
    '1f561': "\uD83D\uDD61",
    '1f562': "\uD83D\uDD62",
    '1f563': "\uD83D\uDD63",
    '1f564': "\uD83D\uDD64",
    '1f565': "\uD83D\uDD65",
    '1f566': "\uD83D\uDD66",
    '1f567': "\uD83D\uDD67",
    '1f3f3': "\uD83C\uDFF3\uFE0F",
    '1f3f4': "\uD83C\uDFF4",
    '1f3c1': "\uD83C\uDFC1",
    '1f6a9': "\uD83D\uDEA9",
    '1f3f3-fe0f-200d-1f308': "\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08",
    '1f1e6-1f1eb': "\uD83C\uDDE6\uD83C\uDDEB",
    '1f1e6-1f1fd': "\uD83C\uDDE6\uD83C\uDDFD",
    '1f1e6-1f1f1': "\uD83C\uDDE6\uD83C\uDDF1",
    '1f1e9-1f1ff': "\uD83C\uDDE9\uD83C\uDDFF",
    '1f1e6-1f1f8': "\uD83C\uDDE6\uD83C\uDDF8",
    '1f1e6-1f1e9': "\uD83C\uDDE6\uD83C\uDDE9",
    '1f1e6-1f1f4': "\uD83C\uDDE6\uD83C\uDDF4",
    '1f1e6-1f1ee': "\uD83C\uDDE6\uD83C\uDDEE",
    '1f1e6-1f1f6': "\uD83C\uDDE6\uD83C\uDDF6",
    '1f1e6-1f1ec': "\uD83C\uDDE6\uD83C\uDDEC",
    '1f1e6-1f1f7': "\uD83C\uDDE6\uD83C\uDDF7",
    '1f1e6-1f1f2': "\uD83C\uDDE6\uD83C\uDDF2",
    '1f1e6-1f1fc': "\uD83C\uDDE6\uD83C\uDDFC",
    '1f1e6-1f1fa': "\uD83C\uDDE6\uD83C\uDDFA",
    '1f1e6-1f1f9': "\uD83C\uDDE6\uD83C\uDDF9",
    '1f1e6-1f1ff': "\uD83C\uDDE6\uD83C\uDDFF",
    '1f1e7-1f1f8': "\uD83C\uDDE7\uD83C\uDDF8",
    '1f1e7-1f1ed': "\uD83C\uDDE7\uD83C\uDDED",
    '1f1e7-1f1e9': "\uD83C\uDDE7\uD83C\uDDE9",
    '1f1e7-1f1e7': "\uD83C\uDDE7\uD83C\uDDE7",
    '1f1e7-1f1fe': "\uD83C\uDDE7\uD83C\uDDFE",
    '1f1e7-1f1ea': "\uD83C\uDDE7\uD83C\uDDEA",
    '1f1e7-1f1ff': "\uD83C\uDDE7\uD83C\uDDFF",
    '1f1e7-1f1ef': "\uD83C\uDDE7\uD83C\uDDEF",
    '1f1e7-1f1f2': "\uD83C\uDDE7\uD83C\uDDF2",
    '1f1e7-1f1f9': "\uD83C\uDDE7\uD83C\uDDF9",
    '1f1e7-1f1f4': "\uD83C\uDDE7\uD83C\uDDF4",
    '1f1e7-1f1e6': "\uD83C\uDDE7\uD83C\uDDE6",
    '1f1e7-1f1fc': "\uD83C\uDDE7\uD83C\uDDFC",
    '1f1e7-1f1f7': "\uD83C\uDDE7\uD83C\uDDF7",
    '1f1ee-1f1f4': "\uD83C\uDDEE\uD83C\uDDF4",
    '1f1fb-1f1ec': "\uD83C\uDDFB\uD83C\uDDEC",
    '1f1e7-1f1f3': "\uD83C\uDDE7\uD83C\uDDF3",
    '1f1e7-1f1ec': "\uD83C\uDDE7\uD83C\uDDEC",
    '1f1e7-1f1eb': "\uD83C\uDDE7\uD83C\uDDEB",
    '1f1e7-1f1ee': "\uD83C\uDDE7\uD83C\uDDEE",
    '1f1f0-1f1ed': "\uD83C\uDDF0\uD83C\uDDED",
    '1f1e8-1f1f2': "\uD83C\uDDE8\uD83C\uDDF2",
    '1f1e8-1f1e6': "\uD83C\uDDE8\uD83C\uDDE6",
    '1f1ee-1f1e8': "\uD83C\uDDEE\uD83C\uDDE8",
    '1f1e8-1f1fb': "\uD83C\uDDE8\uD83C\uDDFB",
    '1f1e7-1f1f6': "\uD83C\uDDE7\uD83C\uDDF6",
    '1f1f0-1f1fe': "\uD83C\uDDF0\uD83C\uDDFE",
    '1f1e8-1f1eb': "\uD83C\uDDE8\uD83C\uDDEB",
    '1f1f9-1f1e9': "\uD83C\uDDF9\uD83C\uDDE9",
    '1f1e8-1f1f1': "\uD83C\uDDE8\uD83C\uDDF1",
    '1f1e8-1f1f3': "\uD83C\uDDE8\uD83C\uDDF3",
    '1f1e8-1f1fd': "\uD83C\uDDE8\uD83C\uDDFD",
    '1f1e8-1f1e8': "\uD83C\uDDE8\uD83C\uDDE8",
    '1f1e8-1f1f4': "\uD83C\uDDE8\uD83C\uDDF4",
    '1f1f0-1f1f2': "\uD83C\uDDF0\uD83C\uDDF2",
    '1f1e8-1f1ec': "\uD83C\uDDE8\uD83C\uDDEC",
    '1f1e8-1f1e9': "\uD83C\uDDE8\uD83C\uDDE9",
    '1f1e8-1f1f0': "\uD83C\uDDE8\uD83C\uDDF0",
    '1f1e8-1f1f7': "\uD83C\uDDE8\uD83C\uDDF7",
    '1f1e8-1f1ee': "\uD83C\uDDE8\uD83C\uDDEE",
    '1f1ed-1f1f7': "\uD83C\uDDED\uD83C\uDDF7",
    '1f1e8-1f1fa': "\uD83C\uDDE8\uD83C\uDDFA",
    '1f1e8-1f1fc': "\uD83C\uDDE8\uD83C\uDDFC",
    '1f1e8-1f1fe': "\uD83C\uDDE8\uD83C\uDDFE",
    '1f1e8-1f1ff': "\uD83C\uDDE8\uD83C\uDDFF",
    '1f1e9-1f1f0': "\uD83C\uDDE9\uD83C\uDDF0",
    '1f1e9-1f1ef': "\uD83C\uDDE9\uD83C\uDDEF",
    '1f1e9-1f1f2': "\uD83C\uDDE9\uD83C\uDDF2",
    '1f1e9-1f1f4': "\uD83C\uDDE9\uD83C\uDDF4",
    '1f1ea-1f1e8': "\uD83C\uDDEA\uD83C\uDDE8",
    '1f1ea-1f1ec': "\uD83C\uDDEA\uD83C\uDDEC",
    '1f1f8-1f1fb': "\uD83C\uDDF8\uD83C\uDDFB",
    '1f1ec-1f1f6': "\uD83C\uDDEC\uD83C\uDDF6",
    '1f1ea-1f1f7': "\uD83C\uDDEA\uD83C\uDDF7",
    '1f1ea-1f1ea': "\uD83C\uDDEA\uD83C\uDDEA",
    '1f1ea-1f1f9': "\uD83C\uDDEA\uD83C\uDDF9",
    '1f1ea-1f1fa': "\uD83C\uDDEA\uD83C\uDDFA",
    '1f1eb-1f1f0': "\uD83C\uDDEB\uD83C\uDDF0",
    '1f1eb-1f1f4': "\uD83C\uDDEB\uD83C\uDDF4",
    '1f1eb-1f1ef': "\uD83C\uDDEB\uD83C\uDDEF",
    '1f1eb-1f1ee': "\uD83C\uDDEB\uD83C\uDDEE",
    '1f1eb-1f1f7': "\uD83C\uDDEB\uD83C\uDDF7",
    '1f1ec-1f1eb': "\uD83C\uDDEC\uD83C\uDDEB",
    '1f1f5-1f1eb': "\uD83C\uDDF5\uD83C\uDDEB",
    '1f1f9-1f1eb': "\uD83C\uDDF9\uD83C\uDDEB",
    '1f1ec-1f1e6': "\uD83C\uDDEC\uD83C\uDDE6",
    '1f1ec-1f1f2': "\uD83C\uDDEC\uD83C\uDDF2",
    '1f1ec-1f1ea': "\uD83C\uDDEC\uD83C\uDDEA",
    '1f1e9-1f1ea': "\uD83C\uDDE9\uD83C\uDDEA",
    '1f1ec-1f1ed': "\uD83C\uDDEC\uD83C\uDDED",
    '1f1ec-1f1ee': "\uD83C\uDDEC\uD83C\uDDEE",
    '1f1ec-1f1f7': "\uD83C\uDDEC\uD83C\uDDF7",
    '1f1ec-1f1f1': "\uD83C\uDDEC\uD83C\uDDF1",
    '1f1ec-1f1e9': "\uD83C\uDDEC\uD83C\uDDE9",
    '1f1ec-1f1f5': "\uD83C\uDDEC\uD83C\uDDF5",
    '1f1ec-1f1fa': "\uD83C\uDDEC\uD83C\uDDFA",
    '1f1ec-1f1f9': "\uD83C\uDDEC\uD83C\uDDF9",
    '1f1ec-1f1ec': "\uD83C\uDDEC\uD83C\uDDEC",
    '1f1ec-1f1f3': "\uD83C\uDDEC\uD83C\uDDF3",
    '1f1ec-1f1fc': "\uD83C\uDDEC\uD83C\uDDFC",
    '1f1ec-1f1fe': "\uD83C\uDDEC\uD83C\uDDFE",
    '1f1ed-1f1f9': "\uD83C\uDDED\uD83C\uDDF9",
    '1f1ed-1f1f3': "\uD83C\uDDED\uD83C\uDDF3",
    '1f1ed-1f1f0': "\uD83C\uDDED\uD83C\uDDF0",
    '1f1ed-1f1fa': "\uD83C\uDDED\uD83C\uDDFA",
    '1f1ee-1f1f8': "\uD83C\uDDEE\uD83C\uDDF8",
    '1f1ee-1f1f3': "\uD83C\uDDEE\uD83C\uDDF3",
    '1f1ee-1f1e9': "\uD83C\uDDEE\uD83C\uDDE9",
    '1f1ee-1f1f7': "\uD83C\uDDEE\uD83C\uDDF7",
    '1f1ee-1f1f6': "\uD83C\uDDEE\uD83C\uDDF6",
    '1f1ee-1f1ea': "\uD83C\uDDEE\uD83C\uDDEA",
    '1f1ee-1f1f2': "\uD83C\uDDEE\uD83C\uDDF2",
    '1f1ee-1f1f1': "\uD83C\uDDEE\uD83C\uDDF1",
    '1f1ee-1f1f9': "\uD83C\uDDEE\uD83C\uDDF9",
    '1f1ef-1f1f2': "\uD83C\uDDEF\uD83C\uDDF2",
    '1f1ef-1f1f5': "\uD83C\uDDEF\uD83C\uDDF5",
    '1f38c': "\uD83C\uDF8C",
    '1f1ef-1f1ea': "\uD83C\uDDEF\uD83C\uDDEA",
    '1f1ef-1f1f4': "\uD83C\uDDEF\uD83C\uDDF4",
    '1f1f0-1f1ff': "\uD83C\uDDF0\uD83C\uDDFF",
    '1f1f0-1f1ea': "\uD83C\uDDF0\uD83C\uDDEA",
    '1f1f0-1f1ee': "\uD83C\uDDF0\uD83C\uDDEE",
    '1f1fd-1f1f0': "\uD83C\uDDFD\uD83C\uDDF0",
    '1f1f0-1f1fc': "\uD83C\uDDF0\uD83C\uDDFC",
    '1f1f0-1f1ec': "\uD83C\uDDF0\uD83C\uDDEC",
    '1f1f1-1f1e6': "\uD83C\uDDF1\uD83C\uDDE6",
    '1f1f1-1f1fb': "\uD83C\uDDF1\uD83C\uDDFB",
    '1f1f1-1f1e7': "\uD83C\uDDF1\uD83C\uDDE7",
    '1f1f1-1f1f8': "\uD83C\uDDF1\uD83C\uDDF8",
    '1f1f1-1f1f7': "\uD83C\uDDF1\uD83C\uDDF7",
    '1f1f1-1f1fe': "\uD83C\uDDF1\uD83C\uDDFE",
    '1f1f1-1f1ee': "\uD83C\uDDF1\uD83C\uDDEE",
    '1f1f1-1f1f9': "\uD83C\uDDF1\uD83C\uDDF9",
    '1f1f1-1f1fa': "\uD83C\uDDF1\uD83C\uDDFA",
    '1f1f2-1f1f4': "\uD83C\uDDF2\uD83C\uDDF4",
    '1f1f2-1f1f0': "\uD83C\uDDF2\uD83C\uDDF0",
    '1f1f2-1f1ec': "\uD83C\uDDF2\uD83C\uDDEC",
    '1f1f2-1f1fc': "\uD83C\uDDF2\uD83C\uDDFC",
    '1f1f2-1f1fe': "\uD83C\uDDF2\uD83C\uDDFE",
    '1f1f2-1f1fb': "\uD83C\uDDF2\uD83C\uDDFB",
    '1f1f2-1f1f1': "\uD83C\uDDF2\uD83C\uDDF1",
    '1f1f2-1f1f9': "\uD83C\uDDF2\uD83C\uDDF9",
    '1f1f2-1f1ed': "\uD83C\uDDF2\uD83C\uDDED",
    '1f1f2-1f1f6': "\uD83C\uDDF2\uD83C\uDDF6",
    '1f1f2-1f1f7': "\uD83C\uDDF2\uD83C\uDDF7",
    '1f1f2-1f1fa': "\uD83C\uDDF2\uD83C\uDDFA",
    '1f1fe-1f1f9': "\uD83C\uDDFE\uD83C\uDDF9",
    '1f1f2-1f1fd': "\uD83C\uDDF2\uD83C\uDDFD",
    '1f1eb-1f1f2': "\uD83C\uDDEB\uD83C\uDDF2",
    '1f1f2-1f1e9': "\uD83C\uDDF2\uD83C\uDDE9",
    '1f1f2-1f1e8': "\uD83C\uDDF2\uD83C\uDDE8",
    '1f1f2-1f1f3': "\uD83C\uDDF2\uD83C\uDDF3",
    '1f1f2-1f1ea': "\uD83C\uDDF2\uD83C\uDDEA",
    '1f1f2-1f1f8': "\uD83C\uDDF2\uD83C\uDDF8",
    '1f1f2-1f1e6': "\uD83C\uDDF2\uD83C\uDDE6",
    '1f1f2-1f1ff': "\uD83C\uDDF2\uD83C\uDDFF",
    '1f1f2-1f1f2': "\uD83C\uDDF2\uD83C\uDDF2",
    '1f1f3-1f1e6': "\uD83C\uDDF3\uD83C\uDDE6",
    '1f1f3-1f1f7': "\uD83C\uDDF3\uD83C\uDDF7",
    '1f1f3-1f1f5': "\uD83C\uDDF3\uD83C\uDDF5",
    '1f1f3-1f1f1': "\uD83C\uDDF3\uD83C\uDDF1",
    '1f1f3-1f1e8': "\uD83C\uDDF3\uD83C\uDDE8",
    '1f1f3-1f1ff': "\uD83C\uDDF3\uD83C\uDDFF",
    '1f1f3-1f1ee': "\uD83C\uDDF3\uD83C\uDDEE",
    '1f1f3-1f1ea': "\uD83C\uDDF3\uD83C\uDDEA",
    '1f1f3-1f1ec': "\uD83C\uDDF3\uD83C\uDDEC",
    '1f1f3-1f1fa': "\uD83C\uDDF3\uD83C\uDDFA",
    '1f1f3-1f1eb': "\uD83C\uDDF3\uD83C\uDDEB",
    '1f1f0-1f1f5': "\uD83C\uDDF0\uD83C\uDDF5",
    '1f1f2-1f1f5': "\uD83C\uDDF2\uD83C\uDDF5",
    '1f1f3-1f1f4': "\uD83C\uDDF3\uD83C\uDDF4",
    '1f1f4-1f1f2': "\uD83C\uDDF4\uD83C\uDDF2",
    '1f1f5-1f1f0': "\uD83C\uDDF5\uD83C\uDDF0",
    '1f1f5-1f1fc': "\uD83C\uDDF5\uD83C\uDDFC",
    '1f1f5-1f1f8': "\uD83C\uDDF5\uD83C\uDDF8",
    '1f1f5-1f1e6': "\uD83C\uDDF5\uD83C\uDDE6",
    '1f1f5-1f1ec': "\uD83C\uDDF5\uD83C\uDDEC",
    '1f1f5-1f1fe': "\uD83C\uDDF5\uD83C\uDDFE",
    '1f1f5-1f1ea': "\uD83C\uDDF5\uD83C\uDDEA",
    '1f1f5-1f1ed': "\uD83C\uDDF5\uD83C\uDDED",
    '1f1f5-1f1f3': "\uD83C\uDDF5\uD83C\uDDF3",
    '1f1f5-1f1f1': "\uD83C\uDDF5\uD83C\uDDF1",
    '1f1f5-1f1f9': "\uD83C\uDDF5\uD83C\uDDF9",
    '1f1f5-1f1f7': "\uD83C\uDDF5\uD83C\uDDF7",
    '1f1f6-1f1e6': "\uD83C\uDDF6\uD83C\uDDE6",
    '1f1f7-1f1ea': "\uD83C\uDDF7\uD83C\uDDEA",
    '1f1f7-1f1f4': "\uD83C\uDDF7\uD83C\uDDF4",
    '1f1f7-1f1fa': "\uD83C\uDDF7\uD83C\uDDFA",
    '1f1f7-1f1fc': "\uD83C\uDDF7\uD83C\uDDFC",
    '1f1fc-1f1f8': "\uD83C\uDDFC\uD83C\uDDF8",
    '1f1f8-1f1f2': "\uD83C\uDDF8\uD83C\uDDF2",
    '1f1f8-1f1f9': "\uD83C\uDDF8\uD83C\uDDF9",
    '1f1f8-1f1e6': "\uD83C\uDDF8\uD83C\uDDE6",
    '1f1f8-1f1f3': "\uD83C\uDDF8\uD83C\uDDF3",
    '1f1f7-1f1f8': "\uD83C\uDDF7\uD83C\uDDF8",
    '1f1f8-1f1e8': "\uD83C\uDDF8\uD83C\uDDE8",
    '1f1f8-1f1f1': "\uD83C\uDDF8\uD83C\uDDF1",
    '1f1f8-1f1ec': "\uD83C\uDDF8\uD83C\uDDEC",
    '1f1f8-1f1fd': "\uD83C\uDDF8\uD83C\uDDFD",
    '1f1f8-1f1f0': "\uD83C\uDDF8\uD83C\uDDF0",
    '1f1f8-1f1ee': "\uD83C\uDDF8\uD83C\uDDEE",
    '1f1ec-1f1f8': "\uD83C\uDDEC\uD83C\uDDF8",
    '1f1f8-1f1e7': "\uD83C\uDDF8\uD83C\uDDE7",
    '1f1f8-1f1f4': "\uD83C\uDDF8\uD83C\uDDF4",
    '1f1ff-1f1e6': "\uD83C\uDDFF\uD83C\uDDE6",
    '1f1f0-1f1f7': "\uD83C\uDDF0\uD83C\uDDF7",
    '1f1f8-1f1f8': "\uD83C\uDDF8\uD83C\uDDF8",
    '1f1ea-1f1f8': "\uD83C\uDDEA\uD83C\uDDF8",
    '1f1f1-1f1f0': "\uD83C\uDDF1\uD83C\uDDF0",
    '1f1e7-1f1f1': "\uD83C\uDDE7\uD83C\uDDF1",
    '1f1f8-1f1ed': "\uD83C\uDDF8\uD83C\uDDED",
    '1f1f0-1f1f3': "\uD83C\uDDF0\uD83C\uDDF3",
    '1f1f1-1f1e8': "\uD83C\uDDF1\uD83C\uDDE8",
    '1f1f5-1f1f2': "\uD83C\uDDF5\uD83C\uDDF2",
    '1f1fb-1f1e8': "\uD83C\uDDFB\uD83C\uDDE8",
    '1f1f8-1f1e9': "\uD83C\uDDF8\uD83C\uDDE9",
    '1f1f8-1f1f7': "\uD83C\uDDF8\uD83C\uDDF7",
    '1f1f8-1f1ff': "\uD83C\uDDF8\uD83C\uDDFF",
    '1f1f8-1f1ea': "\uD83C\uDDF8\uD83C\uDDEA",
    '1f1e8-1f1ed': "\uD83C\uDDE8\uD83C\uDDED",
    '1f1f8-1f1fe': "\uD83C\uDDF8\uD83C\uDDFE",
    '1f1f9-1f1fc': "\uD83C\uDDF9\uD83C\uDDFC",
    '1f1f9-1f1ef': "\uD83C\uDDF9\uD83C\uDDEF",
    '1f1f9-1f1ff': "\uD83C\uDDF9\uD83C\uDDFF",
    '1f1f9-1f1ed': "\uD83C\uDDF9\uD83C\uDDED",
    '1f1f9-1f1f1': "\uD83C\uDDF9\uD83C\uDDF1",
    '1f1f9-1f1ec': "\uD83C\uDDF9\uD83C\uDDEC",
    '1f1f9-1f1f0': "\uD83C\uDDF9\uD83C\uDDF0",
    '1f1f9-1f1f4': "\uD83C\uDDF9\uD83C\uDDF4",
    '1f1f9-1f1f9': "\uD83C\uDDF9\uD83C\uDDF9",
    '1f1f9-1f1f3': "\uD83C\uDDF9\uD83C\uDDF3",
    '1f1f9-1f1f7': "\uD83C\uDDF9\uD83C\uDDF7",
    '1f1f9-1f1f2': "\uD83C\uDDF9\uD83C\uDDF2",
    '1f1f9-1f1e8': "\uD83C\uDDF9\uD83C\uDDE8",
    '1f1f9-1f1fb': "\uD83C\uDDF9\uD83C\uDDFB",
    '1f1fb-1f1ee': "\uD83C\uDDFB\uD83C\uDDEE",
    '1f1fa-1f1ec': "\uD83C\uDDFA\uD83C\uDDEC",
    '1f1fa-1f1e6': "\uD83C\uDDFA\uD83C\uDDE6",
    '1f1e6-1f1ea': "\uD83C\uDDE6\uD83C\uDDEA",
    '1f1ec-1f1e7': "\uD83C\uDDEC\uD83C\uDDE7",
    '1f1fa-1f1f8': "\uD83C\uDDFA\uD83C\uDDF8",
    '1f1fa-1f1fe': "\uD83C\uDDFA\uD83C\uDDFE",
    '1f1fa-1f1ff': "\uD83C\uDDFA\uD83C\uDDFF",
    '1f1fb-1f1fa': "\uD83C\uDDFB\uD83C\uDDFA",
    '1f1fb-1f1e6': "\uD83C\uDDFB\uD83C\uDDE6",
    '1f1fb-1f1ea': "\uD83C\uDDFB\uD83C\uDDEA",
    '1f1fb-1f1f3': "\uD83C\uDDFB\uD83C\uDDF3",
    '1f1fc-1f1eb': "\uD83C\uDDFC\uD83C\uDDEB",
    '1f1ea-1f1ed': "\uD83C\uDDEA\uD83C\uDDED",
    '1f1fe-1f1ea': "\uD83C\uDDFE\uD83C\uDDEA",
    '1f1ff-1f1f2': "\uD83C\uDDFF\uD83C\uDDF2",
    '1f1ff-1f1fc': "\uD83C\uDDFF\uD83C\uDDFC",
    '1f1e6-1f1e8': "\uD83C\uDDE6\uD83C\uDDE8",
    '1f1f9-1f1e6': "\uD83C\uDDF9\uD83C\uDDE6",
    '1f1e7-1f1fb': "\uD83C\uDDE7\uD83C\uDDFB",
    '1f1ed-1f1f2': "\uD83C\uDDED\uD83C\uDDF2",
    '1f1f8-1f1ef': "\uD83C\uDDF8\uD83C\uDDEF",
    '1f1fa-1f1f2': "\uD83C\uDDFA\uD83C\uDDF2",
    '1f1ea-1f1e6': "\uD83C\uDDEA\uD83C\uDDE6",
    '1f1e8-1f1f5': "\uD83C\uDDE8\uD83C\uDDF5",
    '1f1e9-1f1ec': "\uD83C\uDDE9\uD83C\uDDEC",
    '1f1f2-1f1eb': "\uD83C\uDDF2\uD83C\uDDEB",
    '1f1fa-1f1f3': "\uD83C\uDDFA\uD83C\uDDF3",
    '1f3f4-e0067-e0062-e0065-e006e-e0067-e007f': "\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67\uDB40\uDC7F",
    '1f3f4-e0067-e0062-e0073-e0063-e0074-e007f': "\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74\uDB40\uDC7F",
    '1f3f4-e0067-e0062-e0077-e006c-e0073-e007f': "\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73\uDB40\uDC7F",
    '1f1ff': "\uD83C\uDDFF",
    '1f1fe': "\uD83C\uDDFE",
    '1f1fd': "\uD83C\uDDFD",
    '1f3fb': "\uD83C\uDFFB",
    '1f3fc': "\uD83C\uDFFC",
    '1f3fd': "\uD83C\uDFFD",
    '1f3fe': "\uD83C\uDFFE",
    '1f3ff': "\uD83C\uDFFF",
    '1f1fc': "\uD83C\uDDFC",
    '1f1fb': "\uD83C\uDDFB",
    '1f1fa': "\uD83C\uDDFA",
    '1f1f9': "\uD83C\uDDF9",
    '1f1f8': "\uD83C\uDDF8",
    '1f1f7': "\uD83C\uDDF7",
    '1f1f6': "\uD83C\uDDF6",
    '1f1f5': "\uD83C\uDDF5",
    '1f1f4': "\uD83C\uDDF4",
    '1f1f3': "\uD83C\uDDF3",
    '1f1f2': "\uD83C\uDDF2",
    '1f1f1': "\uD83C\uDDF1",
    '1f1f0': "\uD83C\uDDF0",
    '1f1ef': "\uD83C\uDDEF",
    '1f1ee': "\uD83C\uDDEE",
    '1f1ed': "\uD83C\uDDED",
    '1f1ec': "\uD83C\uDDEC",
    '1f1eb': "\uD83C\uDDEB",
    '1f1ea': "\uD83C\uDDEA",
    '1f1e9': "\uD83C\uDDE9",
    '1f1e8': "\uD83C\uDDE8",
    '1f1e7': "\uD83C\uDDE7",
    '1f1e6': "\uD83C\uDDE6",
    '2640': "\u2640\uFE0F",
    '2642': "\u2642\uFE0F",
    '2695': "\u2695\uFE0F",
    '1f468-200d-1f469-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC66",
    '1f469-200d-2764-fe0f-200d-1f468': "\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC68",
    '1f469-200d-2764-fe0f-200d-1f48b-200d-1f468': "\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68",
    '1f928': "\uD83E\uDD28",
    '1f929': "\uD83E\uDD29",
    '1f92a': "\uD83E\uDD2A",
    '1f92b': "\uD83E\uDD2B",
    '1f92c': "\uD83E\uDD2C",
    '1f92d': "\uD83E\uDD2D",
    '1f92e': "\uD83E\uDD2E",
    '1f92f': "\uD83E\uDD2F",
    '1f9d0': "\uD83E\uDDD0",
    '1f9d1': "\uD83E\uDDD1",
    '1f9d2': "\uD83E\uDDD2",
    '1f9d3': "\uD83E\uDDD3",
    '1f9d4': "\uD83E\uDDD4",
    '1f9d5': "\uD83E\uDDD5",
    '1f9e0': "\uD83E\uDDE0",
    '1f9e2': "\uD83E\uDDE2",
    '1f9d9': "\uD83E\uDDD9",
    '1f9da': "\uD83E\uDDDA",
    '1f9db': "\uD83E\uDDDB",
    '1f9dc': "\uD83E\uDDDC",
    '1f9dd': "\uD83E\uDDDD",
    '1f9de': "\uD83E\uDDDE",
    '1f9df': "\uD83E\uDDDF",
    '1f9e3': "\uD83E\uDDE3",
    '1f9e4': "\uD83E\uDDE4",
    '1f9e5': "\uD83E\uDDE5",
    '1f9e6': "\uD83E\uDDE6",
    '1f91f': "\uD83E\uDD1F",
    '1f932': "\uD83E\uDD32",
    '1f9d9-200d-2640-fe0f': "\uD83E\uDDD9\u200D\u2640\uFE0F",
    '1f9d9-200d-2642-fe0f': "\uD83E\uDDD9\u200D\u2642\uFE0F",
    '1f9da-200d-2640-fe0f': "\uD83E\uDDDA\u200D\u2640\uFE0F",
    '1f9da-200d-2642-fe0f': "\uD83E\uDDDA\u200D\u2642\uFE0F",
    '1f9db-200d-2640-fe0f': "\uD83E\uDDDB\u200D\u2640\uFE0F",
    '1f9db-200d-2642-fe0f': "\uD83E\uDDDB\u200D\u2642\uFE0F",
    '1f9dc-200d-2640-fe0f': "\uD83E\uDDDC\u200D\u2640\uFE0F",
    '1f9dc-200d-2642-fe0f': "\uD83E\uDDDC\u200D\u2642\uFE0F",
    '1f9dd-200d-2640-fe0f': "\uD83E\uDDDD\u200D\u2640\uFE0F",
    '1f9dd-200d-2642-fe0f': "\uD83E\uDDDD\u200D\u2642\uFE0F",
    '1f9de-200d-2640-fe0f': "\uD83E\uDDDE\u200D\u2640\uFE0F",
    '1f9de-200d-2642-fe0f': "\uD83E\uDDDE\u200D\u2642\uFE0F",
    '1f9df-200d-2640-fe0f': "\uD83E\uDDDF\u200D\u2640\uFE0F",
    '1f9df-200d-2642-fe0f': "\uD83E\uDDDF\u200D\u2642\uFE0F",
    'atlassian-check_mark': '(/)',
    'atlassian-cross_mark': '(x)',
    'atlassian-plus': '(+)',
    'atlassian-minus': '(-)',
    'atlassian-light_bulb_on': '(on)',
    'atlassian-light_bulb_off': '(off)',
    'atlassian-flag_on': '(flag)',
    'atlassian-flag_off': '(flagoff)',
    'atlassian-warning': '(!)',
    'atlassian-question_mark': '(?)',
    'atlassian-info': '(i)',
    'atlassian-yellow_star': '(*y)',
    'atlassian-blue_star': '(*b)',
    'atlassian-green_star': '(*g)',
    'atlassian-red_star': '(*r)'
};

});

parcelRegister("dU28O", function(module, exports) {

$parcel$export(module.exports, "unknown", () => $8290d734758a9b00$export$19282c40b967aec6);

var $lovmf = parcelRequire("lovmf");
const $8290d734758a9b00$var$jsonTransformer = new (0, $lovmf.JSONTransformer)();
const $8290d734758a9b00$export$19282c40b967aec6 = (node)=>{
    const content = JSON.stringify($8290d734758a9b00$var$jsonTransformer.encodeNode(node));
    return node.isBlock ? `{adf:display=block}
${content}
{adf}` : `{adf:display=inline}${content}{adf}`;
};

});


parcelRegister("gz6Fj", function(module, exports) {

$parcel$export(module.exports, "hardBreak", () => $de6406ceb93b4791$export$371da9dd35aba193);
const $de6406ceb93b4791$export$371da9dd35aba193 = (_node)=>{
    return '\n';
};

});

parcelRegister("ioL87", function(module, exports) {

$parcel$export(module.exports, "mediaInline", () => $c041c137211c1b06$export$38bab695e3f720f1);
const $c041c137211c1b06$export$38bab695e3f720f1 = (node, { context: context } = {})=>{
    const fileName = context?.conversion?.mediaConversion?.[node.attrs.id]?.transform ?? node.attrs.id;
    return `[^${fileName}]`;
};

});

parcelRegister("8yZcU", function(module, exports) {

$parcel$export(module.exports, "mention", () => $3e020b8baa704485$export$db83999c14438df4);
const $3e020b8baa704485$var$PREFIX = 'accountid:';
const $3e020b8baa704485$var$UNKNOWN_USER = 'UNKNOWN_USER';
const $3e020b8baa704485$var$addPrefix = (content)=>content.toLowerCase().startsWith($3e020b8baa704485$var$PREFIX) ? content : `${$3e020b8baa704485$var$PREFIX}${content}`;
const $3e020b8baa704485$export$db83999c14438df4 = (node, { context: context } = {})=>{
    if (node.attrs.id === $3e020b8baa704485$var$UNKNOWN_USER) return `[~${node.attrs.id}]`;
    const mentionKey = node.attrs.id.toLowerCase();
    const content = context && context.conversion && context.conversion.mentionConversion && context.conversion.mentionConversion[mentionKey] ? context.conversion.mentionConversion[mentionKey] : $3e020b8baa704485$var$addPrefix(node.attrs.id);
    return `[~${content}]`;
};

});

parcelRegister("eHUs8", function(module, exports) {

$parcel$export(module.exports, "text", () => $e222e75565819272$export$6f093cfa640b7166);

var $8o4RP = parcelRequire("8o4RP");

var $fzBOR = parcelRequire("fzBOR");

var $6buUG = parcelRequire("6buUG");

var $iYqCx = parcelRequire("iYqCx");

var $1Nw9m = parcelRequire("1Nw9m");

var $acg2R = parcelRequire("acg2R");

var $bD4xF = parcelRequire("bD4xF");

var $1NAvE = parcelRequire("1NAvE");

var $fy5C0 = parcelRequire("fy5C0");
/**
 * The order of the mapping matters.
 * For example, textColor will be a macro {color} so
 * we want to process other marks before it.
 */ const $e222e75565819272$var$markEncoderMapping = new Map([
    [
        'em',
        (0, $iYqCx.em)
    ],
    [
        'strike',
        (0, $acg2R.strike)
    ],
    [
        'strong',
        (0, $bD4xF.strong)
    ],
    [
        'subsup',
        (0, $1NAvE.subsup)
    ],
    [
        'underline',
        (0, $fy5C0.underline)
    ],
    [
        'textColor',
        (0, $6buUG.textColor)
    ],
    [
        'link',
        (0, $1Nw9m.link)
    ],
    [
        'code',
        (0, $fzBOR.code)
    ]
]);
/**
 * ADFEXP-131: Improved logic for escaping metacharacters "[" and "!"
 * Before this change, any instance of "[" and "!" was being escaped
 * "[" is used for mentions
 * "!" is used for media
 */ const $e222e75565819272$var$MENTION_ESCAPE_PATTERN = '(\\[~)'; // Matches pattern like [~
const $e222e75565819272$var$MEDIA_ESCAPE_PATTERN = '(![^ !]+)(!)'; // Matches non space content between two consecutive "!" e.g. !filename.txt!
const $e222e75565819272$var$MEDIA_GROUP_ESCAPE_PATTERN = '(\\[\\^[^ ]+)(\\])'; // Matches non space content between two consecutive "[^" "]" e.g. [^filename.txt]
/**
 * Checks if the node's content needs to be escaped before continuing processing.
 * Currently, the `code` mark and `codeBlock` nodes handle their own escaping, and
 * therefore, should not be escaped here.
 *
 * @param node the current node to encode
 * @param parent the parent node, if exist
 * @returns true if the node should have its text escaped when encoding to wikimarkup.
 */ const $e222e75565819272$var$isEscapeNeeded = (node, parent)=>{
    return !(parent && parent.type.name === 'codeBlock' || node.marks.find((m)=>m.type.name === 'code') !== undefined);
};
/**
 * ESS-2569: Removing the backsalshes from the regex
 * ADFEXP-131: Improved logic for escaping metacharacters "[" and "!"
 */ function $e222e75565819272$var$escapingWikiFormatter(text) {
    const pattern = [
        $e222e75565819272$var$MENTION_ESCAPE_PATTERN,
        ...(0, $8o4RP.macroKeywordTokenMap).map((macro)=>`(${macro.regex.source.replace('^', '')})`)
    ].join('|');
    return text// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    .replace(new RegExp(pattern, 'g'), '\\$&')// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    .replace(new RegExp($e222e75565819272$var$MEDIA_ESCAPE_PATTERN, 'g'), '\\$1\\$2') // Extra step required for media as currently both ends need to be escaped e.q. !filename.txt!
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    .replace(new RegExp($e222e75565819272$var$MEDIA_GROUP_ESCAPE_PATTERN, 'g'), '\\$1\\$2');
}
const $e222e75565819272$export$6f093cfa640b7166 = (node, { parent: parent } = {})=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    let result = $e222e75565819272$var$isEscapeNeeded(node, parent) ? $e222e75565819272$var$escapingWikiFormatter(node.text) : node.text;
    $e222e75565819272$var$markEncoderMapping.forEach((encoder, markName)=>{
        const mark = node.marks.find((m)=>m.type.name === markName);
        if (mark) result = encoder(result, mark.attrs);
    });
    return result;
};

});
parcelRegister("8o4RP", function(module, exports) {

$parcel$export(module.exports, "macroKeywordTokenMap", () => $fb9cc3ff938f3197$export$afcd7edeca61ca93);
$parcel$export(module.exports, "parseMacroKeyword", () => $fb9cc3ff938f3197$export$39c29c0b4f759e52);
$parcel$export(module.exports, "parseOtherKeyword", () => $fb9cc3ff938f3197$export$ce89e528658ee2ac);
$parcel$export(module.exports, "parseLeadingKeyword", () => $fb9cc3ff938f3197$export$68162fc57528b560);
$parcel$export(module.exports, "parseIssueKeyword", () => $fb9cc3ff938f3197$export$bcec6d03770b152c);

var $6eGMp = parcelRequire("6eGMp");

var $aYbjO = parcelRequire("aYbjO");
const $fb9cc3ff938f3197$export$afcd7edeca61ca93 = [
    {
        type: (0, $6eGMp.TokenType).ADF_MACRO,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^{adf/i
    },
    {
        type: (0, $6eGMp.TokenType).ANCHOR_MACRO,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^{anchor/i
    },
    {
        type: (0, $6eGMp.TokenType).CODE_MACRO,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^{code/i
    },
    {
        type: (0, $6eGMp.TokenType).QUOTE_MACRO,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^{quote/i
    },
    {
        type: (0, $6eGMp.TokenType).NOFORMAT_MACRO,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^{noformat/i
    },
    {
        type: (0, $6eGMp.TokenType).PANEL_MACRO,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^{panel/i
    },
    {
        type: (0, $6eGMp.TokenType).COLOR_MACRO,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^{color/
    },
    {
        type: (0, $6eGMp.TokenType).LOREM_MACRO,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^{loremipsum/i
    }
];
/**
 * The order of this mapping determind which keyword
 * will be checked first, so it matters.
 */ const $fb9cc3ff938f3197$var$keywordTokenMap = {
    '[': (0, $6eGMp.TokenType).LINK_FORMAT,
    http: (0, $6eGMp.TokenType).LINK_TEXT,
    ftp: (0, $6eGMp.TokenType).LINK_TEXT,
    jamfselfservice: (0, $6eGMp.TokenType).LINK_TEXT,
    irc: (0, $6eGMp.TokenType).LINK_TEXT,
    mailto: (0, $6eGMp.TokenType).LINK_TEXT,
    '\\\\': (0, $6eGMp.TokenType).FORCE_LINE_BREAK,
    '\r': (0, $6eGMp.TokenType).HARD_BREAK,
    '\n': (0, $6eGMp.TokenType).HARD_BREAK,
    '\r\n': (0, $6eGMp.TokenType).HARD_BREAK,
    '!': (0, $6eGMp.TokenType).MEDIA,
    '----': (0, $6eGMp.TokenType).QUADRUPLE_DASH_SYMBOL,
    '---': (0, $6eGMp.TokenType).TRIPLE_DASH_SYMBOL,
    '--': (0, $6eGMp.TokenType).DOUBLE_DASH_SYMBOL,
    '{-}': (0, $6eGMp.TokenType).DELETED,
    '{+}': (0, $6eGMp.TokenType).INSERTED,
    '{*}': (0, $6eGMp.TokenType).STRONG,
    '{^}': (0, $6eGMp.TokenType).SUPERSCRIPT,
    '{~}': (0, $6eGMp.TokenType).SUBSCRIPT,
    '{_}': (0, $6eGMp.TokenType).EMPHASIS,
    '{{{}': (0, $6eGMp.TokenType).MONOSPACE,
    '{??}': (0, $6eGMp.TokenType).CITATION,
    '-': (0, $6eGMp.TokenType).DELETED,
    '+': (0, $6eGMp.TokenType).INSERTED,
    '*': (0, $6eGMp.TokenType).STRONG,
    '^': (0, $6eGMp.TokenType).SUPERSCRIPT,
    '~': (0, $6eGMp.TokenType).SUBSCRIPT,
    _: (0, $6eGMp.TokenType).EMPHASIS,
    '{{': (0, $6eGMp.TokenType).MONOSPACE,
    '??': (0, $6eGMp.TokenType).CITATION
};
const $fb9cc3ff938f3197$var$keywordTokenMapKeys = Object.keys($fb9cc3ff938f3197$var$keywordTokenMap);
function $fb9cc3ff938f3197$export$39c29c0b4f759e52(input) {
    for(let i = 0; i < $fb9cc3ff938f3197$export$afcd7edeca61ca93.length; i++){
        const keyword = $fb9cc3ff938f3197$export$afcd7edeca61ca93[i];
        if (keyword.regex.test(input)) return {
            type: keyword.type
        };
    }
    return null;
}
function $fb9cc3ff938f3197$export$ce89e528658ee2ac(input) {
    for(let i = 0; i < $fb9cc3ff938f3197$var$keywordTokenMapKeys.length; i++){
        if (input.startsWith($fb9cc3ff938f3197$var$keywordTokenMapKeys[i])) return {
            type: $fb9cc3ff938f3197$var$keywordTokenMap[$fb9cc3ff938f3197$var$keywordTokenMapKeys[i]]
        };
    }
    // Look for a emoji
    const char = input.charAt(0);
    if ([
        ':',
        '(',
        ';'
    ].indexOf(char) !== -1) return {
        // This potentially can be a emoji. The emoji parser will fail out if it's not
        type: (0, $6eGMp.TokenType).EMOJI
    };
    return null;
}
/**
 * These keywords only take effect when it's at the
 * beginning of the line
 * The order of the mapping matters. We should not put
 * LIST in front of RULER for example.
 */ const $fb9cc3ff938f3197$var$leadingKeywordTokenMap = [
    {
        type: (0, $6eGMp.TokenType).QUOTE,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^bq\./
    },
    {
        type: (0, $6eGMp.TokenType).HEADING,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^h[1-6]\./
    },
    {
        type: (0, $6eGMp.TokenType).RULER,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^-{4,5}(\s|$)/
    },
    {
        type: (0, $6eGMp.TokenType).TRIPLE_DASH_SYMBOL,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^-{3}\s/
    },
    {
        type: (0, $6eGMp.TokenType).DOUBLE_DASH_SYMBOL,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^-{2}\s/
    },
    {
        // Lists are limited to max 20 levels of depth
        type: (0, $6eGMp.TokenType).LIST,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: new RegExp(`^([*#]{1,${(0, $aYbjO.MAX_LIST_DEPTH)}}|-) `)
    },
    {
        type: (0, $6eGMp.TokenType).TABLE,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        regex: /^\|{1,2}/
    }
];
function $fb9cc3ff938f3197$export$68162fc57528b560(input) {
    for(let i = 0; i < $fb9cc3ff938f3197$var$leadingKeywordTokenMap.length; i++){
        const keyword = $fb9cc3ff938f3197$var$leadingKeywordTokenMap[i];
        if (keyword.regex.test(input)) return {
            type: keyword.type
        };
    }
    return null;
}
function $fb9cc3ff938f3197$export$bcec6d03770b152c(input, issueKeyRegex) {
    if (issueKeyRegex && issueKeyRegex.test(input)) return {
        type: (0, $6eGMp.TokenType).ISSUE_KEY
    };
    return null;
}

});
parcelRegister("6eGMp", function(module, exports) {

$parcel$export(module.exports, "TokenType", () => $f9f73ecaf3be81f2$export$f435f793048e7a0f);
$parcel$export(module.exports, "parseToken", () => $f9f73ecaf3be81f2$export$af8f4e8328578827);

var $gMpyu = parcelRequire("gMpyu");

var $2Wwr6 = parcelRequire("2Wwr6");

var $1LFn0 = parcelRequire("1LFn0");

var $6ZPSP = parcelRequire("6ZPSP");

var $i7Qrh = parcelRequire("i7Qrh");

var $2nkrY = parcelRequire("2nkrY");

var $iMFmQ = parcelRequire("iMFmQ");

var $gx4M9 = parcelRequire("gx4M9");

var $lUxPt = parcelRequire("lUxPt");

var $4lUX8 = parcelRequire("4lUX8");

var $kUybZ = parcelRequire("kUybZ");

var $lrHLU = parcelRequire("lrHLU");

var $aYbjO = parcelRequire("aYbjO");

var $jXlfv = parcelRequire("jXlfv");

var $bl5kn = parcelRequire("bl5kn");

var $jJXo9 = parcelRequire("jJXo9");

var $lGhDo = parcelRequire("lGhDo");

var $ivs9h = parcelRequire("ivs9h");

var $jmitX = parcelRequire("jmitX");

var $lp73Q = parcelRequire("lp73Q");

var $1wKJY = parcelRequire("1wKJY");

var $kTQgu = parcelRequire("kTQgu");

var $5p9sl = parcelRequire("5p9sl");

var $iTZfs = parcelRequire("iTZfs");

var $cvIOA = parcelRequire("cvIOA");

var $aT9xc = parcelRequire("aT9xc");

var $uOwOo = parcelRequire("uOwOo");

var $7uwJx = parcelRequire("7uwJx");

var $4Oxfk = parcelRequire("4Oxfk");

var $7Bypb = parcelRequire("7Bypb");
var $f9f73ecaf3be81f2$export$f435f793048e7a0f = /*#__PURE__*/ function(TokenType) {
    TokenType["ADF_MACRO"] = "ADF_MACRO";
    TokenType["ANCHOR_MACRO"] = "ANCHOR_MACRO";
    TokenType["CODE_MACRO"] = "CODE_MACRO";
    TokenType["QUOTE_MACRO"] = "QUOTE_MACRO";
    TokenType["NOFORMAT_MACRO"] = "NOFORMAT_MACRO";
    TokenType["PANEL_MACRO"] = "PANEL_MACRO";
    TokenType["COLOR_MACRO"] = "COLOR_MACRO";
    TokenType["LOREM_MACRO"] = "LOREM_MACRO";
    TokenType["QUOTE"] = "QUOTE";
    TokenType["STRING"] = "STRING";
    TokenType["ISSUE_KEY"] = "ISSUE_KEY";
    TokenType["LINK_FORMAT"] = "LINK_FORMAT";
    TokenType["LINK_TEXT"] = "LINK_TEXT";
    TokenType["MEDIA"] = "MEDIA";
    TokenType["HEADING"] = "HEADING";
    TokenType["LIST"] = "LIST";
    TokenType["TABLE"] = "TABLE";
    TokenType["RULER"] = "RULER";
    TokenType["HARD_BREAK"] = "HARD_BREAK";
    TokenType["DOUBLE_DASH_SYMBOL"] = "DOUBLE_DASH_SYMBOL";
    TokenType["TRIPLE_DASH_SYMBOL"] = "TRIPLE_DASH_SYMBOL";
    TokenType["QUADRUPLE_DASH_SYMBOL"] = "QUADRUPLE_DASH_SYMBOL";
    TokenType["STRONG"] = "STRONG";
    TokenType["MONOSPACE"] = "MONOSPACE";
    TokenType["SUPERSCRIPT"] = "SUPERSCRIPT";
    TokenType["SUBSCRIPT"] = "SUBSCRIPT";
    TokenType["EMPHASIS"] = "EMPHASIS";
    TokenType["CITATION"] = "CITATION";
    TokenType["DELETED"] = "DELETED";
    TokenType["INSERTED"] = "INSERTED";
    TokenType["EMOJI"] = "EMOJI";
    TokenType["FORCE_LINE_BREAK"] = "FORCE_LINE_BREAK";
    return TokenType;
}({});
const $f9f73ecaf3be81f2$var$tokenToTokenParserMapping = {
    ["DOUBLE_DASH_SYMBOL"]: (0, $i7Qrh.doubleDashSymbol),
    ["TRIPLE_DASH_SYMBOL"]: (0, $1wKJY.tripleDashSymbol),
    ["QUADRUPLE_DASH_SYMBOL"]: (0, $bl5kn.quadrupleDashSymbol),
    ["RULER"]: (0, $jJXo9.ruler),
    ["STRONG"]: (0, $lGhDo.strong),
    ["MONOSPACE"]: (0, $jXlfv.monospace),
    ["SUPERSCRIPT"]: (0, $jmitX.superscript),
    ["SUBSCRIPT"]: (0, $ivs9h.subscript),
    ["EMPHASIS"]: (0, $iMFmQ.emphasis),
    ["CITATION"]: (0, $1LFn0.citation),
    ["DELETED"]: (0, $6ZPSP.deleted),
    ["INSERTED"]: (0, $4lUX8.inserted),
    ["HARD_BREAK"]: (0, $gx4M9.hardbreak),
    ["LINK_FORMAT"]: (0, $kUybZ.linkFormat),
    ["LINK_TEXT"]: (0, $lrHLU.linkText),
    ["HEADING"]: (0, $lUxPt.heading),
    ["MEDIA"]: (0, $gMpyu.media),
    ["LIST"]: (0, $aYbjO.list),
    ["QUOTE"]: (0, $2Wwr6.blockquote),
    ["TABLE"]: (0, $lp73Q.table),
    ["EMOJI"]: (0, $2nkrY.emoji),
    ["ADF_MACRO"]: (0, $5p9sl.adfMacro),
    ["ANCHOR_MACRO"]: (0, $iTZfs.anchorMacro),
    ["CODE_MACRO"]: (0, $cvIOA.codeMacro),
    ["QUOTE_MACRO"]: (0, $aT9xc.quoteMacro),
    ["NOFORMAT_MACRO"]: (0, $7uwJx.noformatMacro),
    ["PANEL_MACRO"]: (0, $kTQgu.panelMacro),
    ["COLOR_MACRO"]: (0, $uOwOo.colorMacro),
    ["FORCE_LINE_BREAK"]: (0, $4Oxfk.forceLineBreak),
    ["ISSUE_KEY"]: (0, $7Bypb.issueKey)
};
function $f9f73ecaf3be81f2$export$af8f4e8328578827(input, type, position, schema, context) {
    const tokenParser = $f9f73ecaf3be81f2$var$tokenToTokenParserMapping[type];
    if (tokenParser) try {
        return tokenParser({
            input: input,
            position: position,
            schema: schema,
            context: context
        });
    } catch (err) {
        if (context.tokenErrCallback && err instanceof Error) context.tokenErrCallback(err, type);
        return $f9f73ecaf3be81f2$var$fallback(input, position);
    }
    return $f9f73ecaf3be81f2$var$fallback(input, position);
}
function $f9f73ecaf3be81f2$var$fallback(input, position) {
    return {
        type: 'text',
        text: input.substr(position, 1),
        length: 1
    };
}

});
parcelRegister("gMpyu", function(module, exports) {

$parcel$export(module.exports, "media", () => $a74b82de5ea994a7$export$987d49ffe1b0900f);

var $bcJec = parcelRequire("bcJec");

var $dV4GB = parcelRequire("dV4GB");

var $fhRGb = parcelRequire("fhRGb");
const $a74b82de5ea994a7$export$987d49ffe1b0900f = ({ input: input, position: position, schema: schema, context: context })=>{
    const rawContentProcessor = (raw, length)=>{
        /**
		 * !image.gif|align=right, vspace=4|ignore-this!
		 * If it splits into more than 2 items, we ignore the rest
		 */ const [rawContent, rawAttrs = ''] = raw.split('|');
        const node = (0, $bcJec.default)(schema, rawContent, (0, $dV4GB.parseAttrs)(rawAttrs, ','), context);
        return {
            type: 'pmnode',
            nodes: [
                node
            ],
            length: length
        };
    };
    return (0, $fhRGb.commonFormatter)(input, position, schema, {
        opening: '!',
        closing: '!',
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});
parcelRegister("bcJec", function(module, exports) {

$parcel$export(module.exports, "default", () => $59baf75911e77fcb$export$2e2bcd8739ae039);

var $lrHLU = parcelRequire("lrHLU");
const $59baf75911e77fcb$var$defaultWidth = 200;
const $59baf75911e77fcb$var$defaultHeight = 183;
const $59baf75911e77fcb$var$clamp = (input, lower, upper)=>{
    if (upper !== undefined) input = input <= upper ? input : upper;
    if (lower !== undefined) input = input >= lower ? input : lower;
    return input;
};
function $59baf75911e77fcb$export$2e2bcd8739ae039(schema, filename, attrs, context = {}) {
    const { media: media, mediaSingle: mediaSingle } = schema.nodes;
    const { link: link } = schema.marks;
    const mediaMarks = [];
    let mediaNodeAttrs = {};
    if (context?.defaults?.media?.width !== null) mediaNodeAttrs.width = context?.defaults?.media?.width ?? $59baf75911e77fcb$var$defaultWidth;
    if (context?.defaults?.media?.height !== null) mediaNodeAttrs.height = context?.defaults?.media?.height ?? $59baf75911e77fcb$var$defaultHeight;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const mediaSingleAttrs = {
        layout: 'center'
    };
    if (attrs.width && attrs.width.endsWith('%')) {
        const parsed = parseInt(attrs.width, 10);
        if (!isNaN(parsed)) mediaSingleAttrs.width = $59baf75911e77fcb$var$clamp(parsed, 0, 100);
        mediaNodeAttrs = {};
    } else {
        if (attrs.width) {
            const parsed = parseInt(attrs.width, 10);
            if (!isNaN(parsed)) mediaNodeAttrs.width = parsed;
        }
        if (attrs.height) {
            const parsed = parseInt(attrs.height, 10);
            if (!isNaN(parsed)) mediaNodeAttrs.height = parsed;
        }
    }
    if (attrs.href) {
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        const href = attrs.href.replace(/^"(.+)"$/, '$1');
        mediaMarks.push(link.create({
            href: href
        }));
    }
    if (attrs.alt) {
        // strip wrapping quotes if they exist
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        const altText = attrs.alt.replace(/^"(.+)"$/, '$1');
        mediaNodeAttrs.alt = altText;
    }
    if (filename.match((0, $lrHLU.LINK_TEXT_REGEXP))) {
        const externalMediaNode = media.createChecked({
            type: 'external',
            url: filename,
            ...mediaNodeAttrs
        }, undefined, mediaMarks);
        return mediaSingle.createChecked(mediaSingleAttrs, externalMediaNode);
    } else {
        // try to look up media ID from conversion context
        const id = context?.conversion?.mediaConversion?.[filename]?.transform ?? filename;
        // try to look up collection from media context
        const collection = context.hydration && context.hydration.media && context.hydration.media.targetCollectionId;
        const mediaNode = media.createChecked({
            id: id,
            type: 'file',
            collection: collection || '',
            ...mediaNodeAttrs
        }, undefined, mediaMarks);
        return mediaSingle.createChecked(mediaSingleAttrs, mediaNode);
    }
}

});
parcelRegister("lrHLU", function(module, exports) {

$parcel$export(module.exports, "LINK_TEXT_REGEXP", () => $0e1adacf637e04b9$export$f69d1dce349473aa);
$parcel$export(module.exports, "linkText", () => $0e1adacf637e04b9$export$cb7bcf09a05b7705);

var $iKozC = parcelRequire("iKozC");

var $aT3ol = parcelRequire("aT3ol");
const $0e1adacf637e04b9$export$f69d1dce349473aa = // Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
/^((?:(?:https?|ftps?):\/\/)|irc:\/\/|mailto:)([\w?!~^\/\\#$%&'()*+,\-.\/:;<=@]*[\w~^\/\\#$%&'()*+,\-\/:;<=@])/i;
const $0e1adacf637e04b9$export$cb7bcf09a05b7705 = ({ input: input, position: position, schema: schema })=>{
    const matches = input.substring(position).match($0e1adacf637e04b9$export$f69d1dce349473aa);
    if (!matches) return $0e1adacf637e04b9$var$fallback(input, position);
    const match = $0e1adacf637e04b9$var$trimBadEndChar(matches);
    // Remove mailto:
    const textRepresentation = match[1] === 'mailto:' ? match[2] : match[0];
    // parse and correctly encode any illegal characters, and
    // so no longer need to be encoded when used below
    const url = (0, $aT3ol.decode)($0e1adacf637e04b9$var$unescape(match[0]));
    if (!(0, $iKozC.isSafeUrl)(url)) return $0e1adacf637e04b9$var$fallback(input, position);
    const mark = schema.marks.link.create({
        href: url
    });
    const textNode = schema.text(textRepresentation, [
        mark
    ]);
    return {
        type: 'pmnode',
        nodes: [
            textNode
        ],
        length: match[0].length
    };
};
function $0e1adacf637e04b9$var$unescape(url) {
    let result = '';
    for(let i = 0; i < url.length; i++){
        const char = url[i];
        if (char !== '\\') {
            result += char;
            continue;
        }
        const nextChar = url[i + 1];
        if (nextChar) {
            result += nextChar;
            i++;
        }
    }
    return result;
}
function $0e1adacf637e04b9$var$fallback(input, position) {
    return {
        type: 'text',
        text: input.substr(position, 1),
        length: 1
    };
}
// removes bad characters from the end of regex match
function $0e1adacf637e04b9$var$trimBadEndChar(input) {
    return [
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        input[0].replace(/[.,>)\];}"\'!]*$/, ''),
        input[1],
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        input[2].replace(/[.,>)\];}"\'!]*$/, '')
    ];
}

});
parcelRegister("aT3ol", function(module, exports) {

$parcel$export(module.exports, "decode", () => $e1947ec832680a4c$export$2f872c0f2117be69);
/**
 * returns a correctly percent-encoded & sanitized url.
 * Will fallback to using a DOM based implementation if the `URL` class
 * doesn't exist.
 *
 * @param raw a 'raw' url (possibly mixed percent-encoded).
 */ function $e1947ec832680a4c$export$2f872c0f2117be69(raw) {
    if (typeof URL === 'function') {
        const decoded = new URL(raw);
        // IE11 doesn't support the `href` property in the `URL` class.
        // Fallback to the DOM below if it doesn't exist.
        if (decoded.href) return decoded.href;
    }
    // no `URL` class - pollyfill using the dom to parse and
    // decode. This should only be needed for IE11 or lower...
    const anchor = document.createElement('a');
    anchor.href = raw; // The DOM will parses even mixed %-encoded segments of a url when set.
    return anchor.href;
}

});



parcelRegister("dV4GB", function(module, exports) {

$parcel$export(module.exports, "parseAttrs", () => $8a3c502808323aac$export$e1a9355cfd8f6c64);
function $8a3c502808323aac$export$e1a9355cfd8f6c64(str, sep = '|') {
    const output = {};
    if (!str) return output;
    const attributesStr = str.split(sep);
    attributesStr.forEach((attributeStr)=>{
        const [key, ...value] = attributeStr.split('=');
        // take only first value of the same keys
        if (!output[key]) output[key] = value.join('=');
    });
    return output;
}

});

parcelRegister("fhRGb", function(module, exports) {

$parcel$export(module.exports, "commonFormatter", () => $29d56cbbc60af849$export$a71d57024d3da1c5);

var $6eGMp = parcelRequire("6eGMp");

var $kUybZ = parcelRequire("kUybZ");

var $8215W = parcelRequire("8215W");

var $8o4RP = parcelRequire("8o4RP");

var $iQTaT = parcelRequire("iQTaT");
const $29d56cbbc60af849$var$processState = {
    START: 0,
    BUFFER: 1,
    END: 2,
    INLINE_MACRO: 3,
    LINK_FORMAT: 4,
    ESCAPE: 5
};
function $29d56cbbc60af849$export$a71d57024d3da1c5(input, position, schema, opt) {
    let index = position;
    let state = $29d56cbbc60af849$var$processState.START;
    const buffer = [];
    const openingSymbolLength = opt.opening.length;
    const closingSymbolLength = opt.closing.length;
    const openingWrapped = opt.opening.startsWith('{') && opt.opening.endsWith('}');
    const closingWrapped = opt.closing.startsWith('{') && opt.closing.endsWith('}');
    while(index < input.length){
        const char = input.charAt(index);
        const twoChar = input.substr(index, 2);
        const charsMatchClosingSymbol = input.substr(index, closingSymbolLength);
        switch(state){
            case $29d56cbbc60af849$var$processState.START:
                {
                    if (position > 0) {
                        /**
					 * If the previous char is a alphanumeric, then it's not a valid
					 * formatter
					 */ const charBeforeOpening = input.charAt(position - 1);
                        if (!openingWrapped && // Ignored via go/ees005
                        // eslint-disable-next-line require-unicode-regexp
                        /[a-zA-Z0-9]|[^\u0000-\u007F]/.test(charBeforeOpening) && charBeforeOpening !== '\u00A0') return $29d56cbbc60af849$var$fallback(input, index, openingSymbolLength);
                    }
                    const charAfterOpening = input.charAt(index + openingSymbolLength);
                    if (!input.substring(position).startsWith(opt.opening) || charAfterOpening === ' ') // this is not a valid formatter mark
                    return $29d56cbbc60af849$var$fallback(input, position, openingSymbolLength);
                    state = $29d56cbbc60af849$var$processState.BUFFER;
                    index += openingSymbolLength;
                    continue;
                }
            case $29d56cbbc60af849$var$processState.BUFFER:
                {
                    // the linebreak would break the strong marks
                    const length = (0, $8215W.parseNewlineOnly)(input.substring(index));
                    if (length) return $29d56cbbc60af849$var$fallback(input, position, openingSymbolLength);
                    if (charsMatchClosingSymbol === opt.closing) {
                        state = $29d56cbbc60af849$var$processState.END;
                        continue;
                    } else if (twoChar === '{{') {
                        // this is a monospace
                        buffer.push(twoChar);
                        index += 2;
                        continue;
                    } else if (char === '{') {
                        state = $29d56cbbc60af849$var$processState.INLINE_MACRO;
                        continue;
                    } else if (char === '[') {
                        state = $29d56cbbc60af849$var$processState.LINK_FORMAT;
                        continue;
                    } else if (char === '\\') {
                        state = $29d56cbbc60af849$var$processState.ESCAPE;
                        continue;
                    } else buffer.push(char);
                    break;
                }
            case $29d56cbbc60af849$var$processState.END:
                index += closingSymbolLength;
                // empty formatter mark is treated as normal text
                if (buffer.length === 0) return $29d56cbbc60af849$var$fallback(input, position, openingSymbolLength);
                /**
				 * If the closing symbol is followed by a alphanumeric, it's
				 * not a valid formatter, and we keep looking for
				 * next valid closing formatter.
				 * ESS-1402: checking for the non-breaking space after closing symbol.
				 */ if (index < input.length) {
                    const charAfterEnd = input.charAt(index);
                    if (!closingWrapped && // Ignored via go/ees005
                    // eslint-disable-next-line require-unicode-regexp
                    /[a-zA-Z0-9]|[^\u0000-\u007F]/.test(charAfterEnd) && charAfterEnd !== '\u00A0') {
                        buffer.push(charsMatchClosingSymbol);
                        state = $29d56cbbc60af849$var$processState.BUFFER;
                        continue;
                    }
                }
                /**
				 * If the closing symbol has an empty space before it,
				 * it's not a valid formatter
				 */ if (buffer.length > 0 && buffer[buffer.length - 1].endsWith(' ')) return $29d56cbbc60af849$var$fallback(input, position, openingSymbolLength);
                return opt.rawContentProcessor(buffer.join(''), index - position);
            case $29d56cbbc60af849$var$processState.INLINE_MACRO:
                {
                    const match = (0, $8o4RP.parseMacroKeyword)(input.substring(index));
                    if (!match) {
                        buffer.push(char);
                        state = $29d56cbbc60af849$var$processState.BUFFER;
                        break;
                    }
                    /**
				 * Is not a problem send an empty context because we're only checking
				 * if it has a nested macro inside.
				 */ const token = (0, $6eGMp.parseToken)(input, match.type, index, schema, {});
                    if (token.type === 'text') {
                        buffer.push(token.text);
                        index += token.length;
                        state = $29d56cbbc60af849$var$processState.BUFFER;
                        continue;
                    } else if (match.type === (0, $6eGMp.TokenType).COLOR_MACRO) {
                        /**
					 * {color} is valid in formatter, we simply jump over the length
					 */ buffer.push(input.substr(index, token.length));
                        index += token.length;
                        state = $29d56cbbc60af849$var$processState.BUFFER;
                        continue;
                    } else // No macro are accepted in formater
                    return $29d56cbbc60af849$var$fallback(input, position, openingSymbolLength);
                }
            case $29d56cbbc60af849$var$processState.LINK_FORMAT:
                {
                    /**
				 * We should "fly over" the link format and we dont want
				 * -awesome [link|https://www.atlass-ian.com] nice
				 * to be a strike through because of the '-' in link
				 *
				 * Also, is not a problem send an empty context because we're only
				 * checking if it has a nested macro inside.
				 */ const token = (0, $kUybZ.linkFormat)({
                        input: input,
                        schema: schema,
                        position: index,
                        context: {}
                    });
                    if (token.type === 'text') {
                        buffer.push(token.text);
                        index += token.length;
                        state = $29d56cbbc60af849$var$processState.BUFFER;
                        continue;
                    } else if (token.type === 'pmnode') {
                        buffer.push(input.substr(index, token.length));
                        index += token.length;
                        state = $29d56cbbc60af849$var$processState.BUFFER;
                        continue;
                    }
                    return $29d56cbbc60af849$var$fallback(input, position, openingSymbolLength);
                }
            case $29d56cbbc60af849$var$processState.ESCAPE:
                {
                    const token = (0, $iQTaT.escapeHandler)(input, index);
                    buffer.push(token.text);
                    index += token.length;
                    state = $29d56cbbc60af849$var$processState.BUFFER;
                    continue;
                }
            default:
        }
        index++;
    }
    return $29d56cbbc60af849$var$fallback(input, position, openingSymbolLength);
}
function $29d56cbbc60af849$var$fallback(input, position, length) {
    return {
        type: 'text',
        text: input.substr(position, length),
        length: length
    };
}

});
parcelRegister("kUybZ", function(module, exports) {

$parcel$export(module.exports, "linkFormat", () => $a5bb3261d03f31ed$export$e1f888a4b6f2ee53);

var $6eGMp = parcelRequire("6eGMp");

var $dhzNc = parcelRequire("dhzNc");

var $936Ge = parcelRequire("936Ge");

var $q8ZzP = parcelRequire("q8ZzP");
// [http://www.example.com] and [Example|http://www.example.com]
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $a5bb3261d03f31ed$var$LINK_FORMAT_REGEXP = /^\[([^\[\]\n]+)]/;
const $a5bb3261d03f31ed$export$e1f888a4b6f2ee53 = ({ input: input, position: position, schema: schema, context: context })=>{
    const match = input.substring(position).match($a5bb3261d03f31ed$var$LINK_FORMAT_REGEXP);
    /**
	 * The following token types will be ignored in parsing
	 * the content of a table cell
	 */ const ignoreTokenTypes = [
        (0, $6eGMp.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $6eGMp.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $6eGMp.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $6eGMp.TokenType).TABLE,
        (0, $6eGMp.TokenType).RULER,
        // We want to avoid recursion
        (0, $6eGMp.TokenType).LINK_TEXT,
        (0, $6eGMp.TokenType).LINK_FORMAT
    ];
    if (!match) return $a5bb3261d03f31ed$var$fallback();
    const content = (0, $q8ZzP.parseContentLink)(match[1]);
    const resolvedLink = (0, $936Ge.resolveLink)(content, schema, context);
    if (resolvedLink) return resolvedLink;
    const nodes = (0, $dhzNc.parseString)({
        schema: schema,
        context: context,
        ignoreTokenTypes: ignoreTokenTypes,
        input: match[0]
    });
    return {
        type: 'pmnode',
        nodes: nodes,
        length: match[0].length
    };
};
function $a5bb3261d03f31ed$var$fallback() {
    return {
        type: 'text',
        text: '[',
        length: 1
    };
}

});
parcelRegister("dhzNc", function(module, exports) {

$parcel$export(module.exports, "parseString", () => $909b29637189f2b5$export$960addfb9e5a0cde);

var $6XEWb = parcelRequire("6XEWb");

var $8o4RP = parcelRequire("8o4RP");

var $6eGMp = parcelRequire("6eGMp");

var $8215W = parcelRequire("8215W");

var $iQTaT = parcelRequire("iQTaT");

var $fCm0w = parcelRequire("fCm0w");
const $909b29637189f2b5$var$processState = {
    NEWLINE: 0,
    BUFFER: 1,
    TOKEN: 2,
    ESCAPE: 3
};
function $909b29637189f2b5$export$960addfb9e5a0cde({ input: input, schema: schema, ignoreTokenTypes: ignoreTokenTypes = [], context: context, includeLeadingSpace: includeLeadingSpace = false }) {
    let index = 0;
    let state = $909b29637189f2b5$var$processState.NEWLINE;
    let buffer = [];
    let tokenType = (0, $6eGMp.TokenType).STRING;
    let newLines = [];
    const output = [];
    let inlineNodes = [];
    while(index < input.length){
        const char = input.charAt(index);
        switch(state){
            case $909b29637189f2b5$var$processState.NEWLINE:
                {
                    /**
				 * During this state, the parser will trim leading
				 * spaces and looking for any leading keywords.
				 */ const substring = input.substring(index);
                    const length = (0, $8215W.parseWhitespaceOnly)(substring);
                    if (length) {
                        index += length;
                        if (includeLeadingSpace) buffer.push(char);
                        continue;
                    }
                    const match = (0, $8o4RP.parseLeadingKeyword)(substring) || (0, $8o4RP.parseMacroKeyword)(substring) || (0, $8o4RP.parseOtherKeyword)(substring) || (0, $8o4RP.parseIssueKeyword)(substring, context.issueKeyRegex);
                    if (match && ignoreTokenTypes.indexOf(match.type) === -1) {
                        tokenType = match.type;
                        state = $909b29637189f2b5$var$processState.TOKEN;
                        continue;
                    } else {
                        state = $909b29637189f2b5$var$processState.BUFFER;
                        continue;
                    }
                }
            case $909b29637189f2b5$var$processState.BUFFER:
                {
                    /**
				 * During this state, the parser will start
				 * saving plaintext into the buffer until it hits
				 * a keyword
				 */ const substring = input.substring(index);
                    /**
				 * If the previous char is not a alphanumeric, we will parse
				 * format keywords.
				 * If the previous char is '{', we need to skip parse macro
				 * keyword
				 */ let match = null;
                    if (buffer.length > 0 && buffer[buffer.length - 1].endsWith('{')) match = (0, $8o4RP.parseOtherKeyword)(substring);
                    else match = (0, $8o4RP.parseMacroKeyword)(substring) || (0, $8o4RP.parseOtherKeyword)(substring) || (0, $8o4RP.parseIssueKeyword)(substring, context.issueKeyRegex);
                    if (match && ignoreTokenTypes.indexOf(match.type) === -1) {
                        tokenType = match.type;
                        state = $909b29637189f2b5$var$processState.TOKEN;
                        continue;
                    }
                    if (char === '\\') {
                        state = $909b29637189f2b5$var$processState.ESCAPE;
                        continue;
                    }
                    buffer.push(char);
                    break;
                }
            case $909b29637189f2b5$var$processState.TOKEN:
                {
                    const token = (0, $6eGMp.parseToken)(input, tokenType, index, schema, context);
                    if (token.type === 'text') buffer.push(token.text);
                    else if (token.type === 'pmnode') {
                        /*ESS-2539 We are keeping track of consecutive newLines in the newLines array
            Whenever more than two consecutive newLines are encountered, we start a new paragraph
          */ if (newLines.length >= 2 && (tokenType !== (0, $6eGMp.TokenType).HARD_BREAK || buffer.length > 0)) {
                            output.push(...(0, $fCm0w.normalizePMNodes)(inlineNodes, schema));
                            // push newLines to the buffer as a separator between media nodes
                            inlineNodes = $909b29637189f2b5$var$isConsecutiveMediaGroups(inlineNodes, token.nodes) ? [
                                ...newLines
                            ] : [];
                            newLines = [];
                        }
                        if (inlineNodes.length === 0) newLines = [];
                        if (newLines.length > 0 && $909b29637189f2b5$var$isNewLineRequiredBetweenNodes(inlineNodes, buffer, token.nodes)) {
                            inlineNodes.push(...newLines);
                            newLines = [];
                        }
                        inlineNodes.push(...(0, $6XEWb.createTextNode)(buffer.join(''), schema));
                        if (tokenType === (0, $6eGMp.TokenType).HARD_BREAK) newLines.push(...token.nodes);
                        else {
                            inlineNodes.push(...token.nodes);
                            if (token.nodes.length > 0) newLines = [];
                        }
                        buffer = []; // clear the buffer
                    }
                    index += token.length;
                    if (tokenType === (0, $6eGMp.TokenType).HARD_BREAK) state = $909b29637189f2b5$var$processState.NEWLINE;
                    else state = $909b29637189f2b5$var$processState.BUFFER;
                    continue;
                }
            case $909b29637189f2b5$var$processState.ESCAPE:
                {
                    const token = (0, $iQTaT.escapeHandler)(input, index);
                    buffer.push(token.text);
                    index += token.length;
                    state = $909b29637189f2b5$var$processState.BUFFER;
                    continue;
                }
            default:
        }
        index++;
    }
    const bufferedStr = buffer.join('');
    if (bufferedStr.length > 0) {
        // Wrapping the rest of the buffer into a text node
        if (newLines.length >= 2) {
            // normalize the nodes already parsed if more than two consecutive newLines are encountered
            output.push(...(0, $fCm0w.normalizePMNodes)(inlineNodes, schema));
            inlineNodes = [];
            newLines = [];
        }
        if (newLines.length > 0 && inlineNodes.length > 0 && !inlineNodes[inlineNodes.length - 1].isBlock) inlineNodes.push(...newLines);
        inlineNodes.push(...(0, $6XEWb.createTextNode)(bufferedStr, schema));
    }
    return [
        ...output,
        ...inlineNodes
    ];
}
/* checks whether a newLine is required between two consecutive nodes
   Returns true for inline nodes, false for block nodes
*/ function $909b29637189f2b5$var$isNewLineRequiredBetweenNodes(currentNodes, buffer, nextNodes) {
    if (currentNodes.length === 0) return false;
    if (buffer.length > 0 && currentNodes[currentNodes.length - 1]?.isBlock) return false;
    if (buffer.length === 0) {
        if (nextNodes.length === 0) return false;
        if (nextNodes[0]?.type.name === 'hardBreak') return false;
        if (nextNodes[0]?.isBlock || currentNodes[currentNodes.length - 1]?.isBlock) return false;
    }
    return true;
}
function $909b29637189f2b5$var$isConsecutiveMediaGroups(currentNodes, nextNodes) {
    return currentNodes.length > 0 && currentNodes[currentNodes.length - 1]?.type.name === 'mediaGroup' && nextNodes[0]?.type.name === 'mediaGroup';
}

});
parcelRegister("6XEWb", function(module, exports) {

$parcel$export(module.exports, "createTextNode", () => $9688ed8712e6fc28$export$b2ce9ad90858ed7a);
function $9688ed8712e6fc28$export$b2ce9ad90858ed7a(input, schema, marks) {
    if (input === '') return [];
    const node = schema.text(input, marks || []);
    return [
        node
    ];
}

});

parcelRegister("8215W", function(module, exports) {

$parcel$export(module.exports, "parseNewlineOnly", () => $80a2ca41ac136ede$export$1b7a83d725c8acf);
$parcel$export(module.exports, "parseWhitespaceOnly", () => $80a2ca41ac136ede$export$9c597b035e16623b);
function $80a2ca41ac136ede$export$877995a80ec11782(input) {
    const newlineLength = $80a2ca41ac136ede$export$1b7a83d725c8acf(input);
    if (newlineLength) return newlineLength;
    const whitespaceLength = $80a2ca41ac136ede$export$9c597b035e16623b(input);
    if (whitespaceLength) return whitespaceLength;
    // There is nether whitespace nor newline
    return 0;
}
function $80a2ca41ac136ede$export$9c597b035e16623b(input) {
    let index = 0;
    const char = input.charAt(index);
    if (char === '\t' || char === ' ') index++;
    return index;
}
function $80a2ca41ac136ede$export$1b7a83d725c8acf(input) {
    let index = 0;
    const char = input.charAt(index);
    if (char === '\r') {
        // CR (Unix)
        index++;
        if (input.charAt(index) === '\n') // CRLF (Windows)
        index++;
    } else if (char === '\n') // LF (MacOS)
    index++;
    return index;
}

});

parcelRegister("iQTaT", function(module, exports) {

$parcel$export(module.exports, "escapeHandler", () => $fd20fccb3ac7927b$export$d16e8e6cf9622f9a);
/**
 * In Jira, following characters are escaped
 * private static final Pattern ESCAPING_PATTERN = Pattern.compile("(^|(?<!\\\\))\\\\([\\-\\#\\*\\_\\+\\?\\^\\~\\|\\%\\{\\}\\[\\]\\(\\)\\!\\@])");
 * https://stash.atlassian.com/projects/JIRACLOUD/repos/jira/browse/jira-components/jira-renderer/src/main/java/com/atlassian/renderer/v2/components/BackslashEscapeRendererComponent.java
 */ const $fd20fccb3ac7927b$var$escapedChar = [
    '-',
    '#',
    '*',
    '_',
    '+',
    '?',
    '^',
    '~',
    '|',
    '%',
    '{',
    '}',
    '[',
    ']',
    '(',
    ')',
    '!',
    '@'
];
function $fd20fccb3ac7927b$export$d16e8e6cf9622f9a(input, position) {
    const buffer = [];
    const char = input.charAt(position);
    const prevChar = input.charAt(position - 1);
    const nextChar = input.charAt(position + 1);
    /**
	 * Ported from Jira:
	 * If previous char is also a backslash, then this is not a valid escape
	 */ if ($fd20fccb3ac7927b$var$escapedChar.indexOf(nextChar) === -1 || prevChar === '\\') // Insert \ in buffer mode
    buffer.push(char);
    buffer.push(nextChar);
    return {
        type: 'text',
        text: buffer.join(''),
        length: 2
    };
}

});

parcelRegister("fCm0w", function(module, exports) {

$parcel$export(module.exports, "normalizePMNodes", () => $e1f2cb3080dcb52f$export$e21f6b7efdaf8b5d);

var $4kZfz = parcelRequire("4kZfz");
function $e1f2cb3080dcb52f$export$e21f6b7efdaf8b5d(nodes, schema, parentNode) {
    return [
        $e1f2cb3080dcb52f$var$normalizeMediaGroups,
        $e1f2cb3080dcb52f$export$2cef2a4c047f9887,
        $e1f2cb3080dcb52f$export$cd936b894f116ed8
    ].reduce((currentNodes, normFunc)=>normFunc(currentNodes, schema, parentNode), nodes);
}
function $e1f2cb3080dcb52f$export$2cef2a4c047f9887(nodes, schema, parentNode) {
    // When we round-trip through ADF - WikiMarkup - ADF, expands get replaced by strong text.
    // That would result in the nested expand being in an invalid situation as it's no longer
    // nested in either a table or expand
    // This solves the issue for nested expands that sit in the root, which should cover every
    // case for Jira software
    const output = [];
    for (const node of nodes)if (node?.type?.name === 'nestedExpand' && parentNode === 'doc') output.push($e1f2cb3080dcb52f$var$convertNodeToExpand(node, schema));
    else output.push(node);
    return output;
}
function $e1f2cb3080dcb52f$export$cd936b894f116ed8(nodes, schema, _parentNode) {
    const output = [];
    let inlineNodeBuffer = [];
    for (const node of nodes){
        if (!node.isBlock) {
            inlineNodeBuffer.push(node);
            continue;
        }
        if (inlineNodeBuffer.length > 0) output.push(...(0, $4kZfz.createParagraphNodeFromInlineNodes)(inlineNodeBuffer, schema));
        inlineNodeBuffer = []; // clear buffer
        output.push(node);
    }
    if (inlineNodeBuffer.length > 0) output.push(...(0, $4kZfz.createParagraphNodeFromInlineNodes)(inlineNodeBuffer, schema));
    if (output.length === 0) return [
        (0, $4kZfz.createEmptyParagraphNode)(schema)
    ];
    return output;
}
/**
 * Normalize the list of the given nodes for media groups.
 * The rule is: if there are consecutive media group nodes (each with a single child media
 * node) separated by any space or a single newline, then merge them into one media group
 * with multiple child media nodes.
 * @param nodes list of nodes to normalize. Must not be null
 * @param schema
 */ function $e1f2cb3080dcb52f$var$normalizeMediaGroups(nodes, schema, _parentNode) {
    const output = [];
    let mediaGroupBuffer = [];
    let separatorBuffer = [];
    for (const n of nodes){
        if (n.type.name === 'mediaGroup' && n.childCount === 1) {
            mediaGroupBuffer.push(n);
            //separator buffer keeps track of the seperator(s) between each mediaGroup nodes,
            //so needs resetting every time we encounter a new mediaGroup node
            separatorBuffer = [];
            continue;
        }
        if (mediaGroupBuffer.length > 0) {
            if ($e1f2cb3080dcb52f$var$isSignificantSeparatorNode(n, separatorBuffer)) {
                output.push($e1f2cb3080dcb52f$var$createMergedMediaGroup(mediaGroupBuffer, schema));
                output.push(...separatorBuffer);
                output.push(n);
                mediaGroupBuffer = [];
                separatorBuffer = [];
            } else separatorBuffer.push(n);
            continue;
        }
        output.push(n);
    }
    if (mediaGroupBuffer.length > 0) output.push($e1f2cb3080dcb52f$var$createMergedMediaGroup(mediaGroupBuffer, schema));
    // Dump everything else from separator buffer if anything is left
    output.push(...separatorBuffer);
    return output;
}
/**
 * Creates a single mediaGroup whose children are the single media elements from the given mediaGroupNodes.
 * @param mediaGroupNodes list of mediaGroups that have a single child each
 * @param schema the schema
 */ function $e1f2cb3080dcb52f$var$createMergedMediaGroup(mediaGroupNodes, schema) {
    const { mediaGroup: mediaGroup } = schema.nodes;
    const mediaNodes = mediaGroupNodes.map((v)=>v.child(0));
    return mediaGroup.createChecked({}, mediaNodes);
}
function $e1f2cb3080dcb52f$var$isSignificantSeparatorNode(n, separatorBuffer) {
    return $e1f2cb3080dcb52f$var$isHardBreak(n, separatorBuffer) || !$e1f2cb3080dcb52f$var$isEmptyTextNode(n) || $e1f2cb3080dcb52f$var$isMediaGroupWithMultipleChildren(n);
}
/**
 * Existing media groups with more than one child is considered as a significant separator.
 */ function $e1f2cb3080dcb52f$var$isMediaGroupWithMultipleChildren(n) {
    return n.type.name === 'mediaGroup' && n.childCount > 1;
}
/**
 * If the current node is a hard break, AND there's already at least
 * one hard break in the separator buffer, then we want to return true.
 * @param n the current node to examine
 * @param separatorBuffer the existing separator buffer.
 */ function $e1f2cb3080dcb52f$var$isHardBreak(n, separatorBuffer) {
    return n.type.name === 'hardBreak' && separatorBuffer.map((v)=>v.type.name).indexOf('hardBreak') !== -1;
}
function $e1f2cb3080dcb52f$var$isEmptyTextNode(n) {
    return n.textContent !== undefined && n.textContent.trim().length === 0;
}
function $e1f2cb3080dcb52f$export$19b6d0f3f1dd6ddf(input) {
    // Line with only spaces is considered an empty line
    return input.trim().length === 0;
}
function $e1f2cb3080dcb52f$var$convertNodeToExpand(node, schema) {
    const { expand: expand } = schema.nodes;
    return expand.createChecked(node.attrs, node.content);
}

});
parcelRegister("4kZfz", function(module, exports) {

$parcel$export(module.exports, "createEmptyParagraphNode", () => $8361800671bdc65e$export$e930a5cfe8596ea0);
$parcel$export(module.exports, "createParagraphNodeFromInlineNodes", () => $8361800671bdc65e$export$f0eaed48ea684567);
function $8361800671bdc65e$export$e930a5cfe8596ea0(schema) {
    const { paragraph: paragraph } = schema.nodes;
    return paragraph.createChecked({}, []);
}
function $8361800671bdc65e$export$f0eaed48ea684567(inlineNodes, schema) {
    const { paragraph: paragraph } = schema.nodes;
    const result = [];
    const textNodes = inlineNodes.filter((node)=>node.type.name !== 'hardBreak');
    if (textNodes.length > 0) result.push(paragraph.createChecked({}, inlineNodes));
    return result;
}

});



parcelRegister("936Ge", function(module, exports) {

$parcel$export(module.exports, "resolveLink", () => $82625a5dd8090b2d$export$c2baa561eb017101);

var $36bOX = parcelRequire("36bOX");

var $czcbQ = parcelRequire("czcbQ");

var $iHrEw = parcelRequire("iHrEw");

var $5fery = parcelRequire("5fery");
// jira-components/jira-core/src/main/resources/system-contentlinkresolvers-plugin.xml
// attachment resolver: 10
// anchor resolver: 20 - unsupported
// jiraissue resolver: 30 - unsupported
// user profile: 40
//
// Fall back to url link resolver
const $82625a5dd8090b2d$var$linkResolverStrategies = [
    (0, $czcbQ.attachmentLinkResolver),
    (0, $36bOX.mentionLinkResolver),
    (0, $5fery.issueLinkResolver),
    (0, $iHrEw.urlLinkResolver)
];
function $82625a5dd8090b2d$export$c2baa561eb017101(link, schema, context) {
    const length = link.originalLinkText.length + 2;
    for (const resolver of $82625a5dd8090b2d$var$linkResolverStrategies){
        const resolvedLink = resolver(link, schema, context);
        if (resolvedLink) return {
            length: length,
            nodes: resolvedLink,
            type: 'pmnode'
        };
    }
    return undefined;
}

});
parcelRegister("36bOX", function(module, exports) {

$parcel$export(module.exports, "mentionLinkResolver", () => $9ec66bc53ffbd1dd$export$1da3b34e38fc6ca8);
function $9ec66bc53ffbd1dd$export$1da3b34e38fc6ca8(link, schema, context) {
    // [CS-1896] Empty mention nodes should fallback to plaintext
    if (link.notLinkBody.toLowerCase() === '~accountid:' || link.notLinkBody === '~') return [
        schema.nodes.paragraph.createChecked({}, [
            schema.nodes.text.create({})
        ])
    ];
    if (link.notLinkBody.startsWith('~')) {
        const mentionText = link.notLinkBody.substring(1);
        const mentionKey = mentionText.toLowerCase();
        const id = context.conversion && context.conversion.mentionConversion && context.conversion.mentionConversion[mentionKey] ? context.conversion.mentionConversion[mentionKey] : mentionText;
        return [
            schema.nodes.mention.createChecked({
                id: id
            })
        ];
    }
    return;
}

});

parcelRegister("czcbQ", function(module, exports) {

$parcel$export(module.exports, "attachmentLinkResolver", () => $7974fcb7fd331dc1$export$ce918f41a76b8445);

var $1lEx1 = parcelRequire("1lEx1");
function $7974fcb7fd331dc1$export$ce918f41a76b8445(link, schema, context) {
    if (link.attachmentName) return [
        (0, $1lEx1.default)(schema, link.attachmentName, context)
    ];
    return;
}

});
parcelRegister("1lEx1", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff813afdf141d94f$export$2e2bcd8739ae039);
function $ff813afdf141d94f$export$2e2bcd8739ae039(schema, filename, context = {}) {
    const { media: media, mediaGroup: mediaGroup } = schema.nodes;
    // try to look up media ID from conversion context
    const id = context?.conversion?.mediaConversion?.[filename]?.transform ?? filename;
    // try to look up collection from media context
    const collection = context.hydration && context.hydration.media && context.hydration.media.targetCollectionId;
    const mediaNode = media.createChecked({
        id: id,
        type: 'file',
        collection: collection || ''
    });
    return mediaGroup.createChecked({}, mediaNode);
}

});


parcelRegister("iHrEw", function(module, exports) {

$parcel$export(module.exports, "urlLinkResolver", () => $d73a285410490b5d$export$b737d556d2167f9);

var $6eGMp = parcelRequire("6eGMp");

var $iKozC = parcelRequire("iKozC");

var $dhzNc = parcelRequire("dhzNc");

var $1WGKr = parcelRequire("1WGKr");
function $d73a285410490b5d$export$b737d556d2167f9(link, schema, context) {
    const output = [];
    const url = link.notLinkBody;
    const textRepresentation = link.linkBody || link.notLinkBody;
    if (!(0, $iKozC.isSafeUrl)(url)) return;
    const ignoreTokenTypes = [
        (0, $6eGMp.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $6eGMp.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $6eGMp.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $6eGMp.TokenType).LINK_TEXT,
        (0, $6eGMp.TokenType).ISSUE_KEY
    ];
    const rawContent = (0, $dhzNc.parseString)({
        ignoreTokenTypes: ignoreTokenTypes,
        schema: schema,
        context: context,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        input: textRepresentation.replace(/^mailto:/, '')
    });
    const decoratedContent = rawContent.map((n)=>{
        const mark = schema.marks.link.create({
            href: url
        });
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !(0, $1WGKr.hasAnyOfMarks)(n, [
            'link',
            'code'
        ])) return n.mark([
            ...n.marks,
            mark
        ]);
        return n;
    });
    output.push(...decoratedContent);
    if (!$d73a285410490b5d$var$hasTextNode(rawContent)) {
        const mark = schema.marks.link.create({
            href: url
        });
        const linkTextNode = schema.text(textRepresentation, [
            mark
        ]);
        output.push(linkTextNode);
    }
    return output;
}
function $d73a285410490b5d$var$hasTextNode(nodes) {
    return nodes.find((n)=>{
        return n.type.name === 'text';
    });
}

});
parcelRegister("1WGKr", function(module, exports) {

$parcel$export(module.exports, "hasAnyOfMarks", () => $fd16f982b072f943$export$30c14ec359b8cbf0);
$parcel$export(module.exports, "isDigit", () => $fd16f982b072f943$export$727d9dbc4fbb948f);
$parcel$export(module.exports, "isBlank", () => $fd16f982b072f943$export$7ee701e290d9865);
$parcel$export(module.exports, "isNotBlank", () => $fd16f982b072f943$export$4d9e7a1c098df5e2);
$parcel$export(module.exports, "getSurroundingSymbols", () => $fd16f982b072f943$export$ddec3d40bf5e3693);
$parcel$export(module.exports, "StringBuffer", () => $fd16f982b072f943$export$83347051c3437dc9);
function $fd16f982b072f943$export$30c14ec359b8cbf0(node, types) {
    return node.marks.findIndex((m)=>types.findIndex((t)=>m.type.name === t) !== -1) !== -1;
}
function $fd16f982b072f943$export$727d9dbc4fbb948f(value) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return !!value.match(/^\d$/);
}
function $fd16f982b072f943$export$7ee701e290d9865(value) {
    return value === null || value.trim() === '';
}
function $fd16f982b072f943$export$4d9e7a1c098df5e2(value) {
    return !$fd16f982b072f943$export$7ee701e290d9865(value);
}
const $fd16f982b072f943$export$ddec3d40bf5e3693 = (trimmedInput, openingText, closingText)=>{
    const openingSymbol = trimmedInput.startsWith(`{${openingText}}`) ? `{${openingText}}` : openingText;
    const endIndex = trimmedInput.indexOf(closingText, openingSymbol === `{${openingText}}` ? openingText.length + 2 : openingText.length);
    const closingSymbol = endIndex > -1 && trimmedInput.charAt(endIndex - 1) === '{' && trimmedInput.charAt(endIndex + closingText.length) === '}' ? `{${closingText}}` : closingText;
    return {
        openingSymbol: openingSymbol,
        closingSymbol: closingSymbol
    };
};
class $fd16f982b072f943$export$83347051c3437dc9 {
    constructor(buffer = ''){
        this.buffer = buffer;
    }
    indexOf(value) {
        return this.buffer.indexOf(value);
    }
    lastIndexOf(value) {
        return this.buffer.lastIndexOf(value);
    }
    charAt(index) {
        return this.buffer.charAt(index);
    }
    length() {
        return this.buffer.length;
    }
    delete(start, end) {
        this.buffer = this.buffer.substring(0, start) + this.buffer.substring(end);
    }
    append(value) {
        this.buffer += value;
    }
    substring(start, end) {
        return this.buffer.substring(start, end);
    }
    deleteCharAt(index) {
        this.delete(index, index + 1);
    }
    toString() {
        return this.buffer;
    }
}

});


parcelRegister("5fery", function(module, exports) {

$parcel$export(module.exports, "issueLinkResolver", () => $73c29fa1311941b8$export$f40ed0efa65d4e8);

var $7Bypb = parcelRequire("7Bypb");
function $73c29fa1311941b8$export$f40ed0efa65d4e8(link, schema, context) {
    const { originalLinkText: originalLinkText, linkTitle: linkTitle, notLinkBody: notLinkBody } = link;
    if (linkTitle === 'smart-card' || // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: Depricated should be removed in the next major release
    linkTitle === 'block-link') return [
        schema.nodes.blockCard.createChecked({
            url: notLinkBody
        })
    ];
    if (linkTitle === 'smart-link') return [
        schema.nodes.inlineCard.createChecked({
            url: notLinkBody
        })
    ];
    if (linkTitle === 'smart-embed') return [
        schema.nodes.embedCard.createChecked({
            url: notLinkBody
        })
    ];
    const issue = (0, $7Bypb.getIssue)(context, originalLinkText);
    if (issue) return (0, $7Bypb.buildInlineCard)(schema, issue);
    return undefined;
}

});
parcelRegister("7Bypb", function(module, exports) {

$parcel$export(module.exports, "INLINE_CARD_FROM_TEXT_STAMP", () => $b2ba8815709d1afa$export$a1a15f4d91e860d9);
$parcel$export(module.exports, "issueKey", () => $b2ba8815709d1afa$export$a0d841e329cebd91);
$parcel$export(module.exports, "getIssue", () => $b2ba8815709d1afa$export$34403cb88b30d33b);
$parcel$export(module.exports, "buildInlineCard", () => $b2ba8815709d1afa$export$cdebb4bc59c595a);
$parcel$export(module.exports, "buildIssueKeyRegex", () => $b2ba8815709d1afa$export$cd8701ad7512efee);

var $1WGKr = parcelRequire("1WGKr");
const $b2ba8815709d1afa$export$a1a15f4d91e860d9 = /(#icft=)([A-Z][A-Z]+-[0-9]+)/;
const $b2ba8815709d1afa$export$a0d841e329cebd91 = ({ input: input, position: position, schema: schema, context: context })=>{
    // This scenario happens when context is empty
    if (!context.issueKeyRegex) return $b2ba8815709d1afa$var$fallback(input, position);
    const match = input.substring(position).match(context.issueKeyRegex);
    if (!match) return $b2ba8815709d1afa$var$fallback(input, position);
    const issue = $b2ba8815709d1afa$export$34403cb88b30d33b(context, match[0]);
    // This scenario happens when context doesn't has all the issues inside a markup
    if (!issue) return $b2ba8815709d1afa$var$fallback(input, position);
    const charBefore = input.charAt(position - 1);
    const charAfter = input.charAt(position + issue.key.length);
    if ((0, $1WGKr.isNotBlank)(charBefore) && $b2ba8815709d1afa$var$isNotAllowedChars(charBefore) || (0, $1WGKr.isNotBlank)(charAfter) && $b2ba8815709d1afa$var$isNotAllowedChars(charAfter)) return $b2ba8815709d1afa$var$fallback(input, position);
    return {
        type: 'pmnode',
        nodes: $b2ba8815709d1afa$export$cdebb4bc59c595a(schema, issue),
        length: match[0].length
    };
};
const $b2ba8815709d1afa$var$fallback = (input, position)=>({
        type: 'text',
        text: input.substr(position, 1),
        length: 1
    });
const $b2ba8815709d1afa$export$34403cb88b30d33b = (context, key)=>context.conversion && context.conversion.inlineCardConversion && context.conversion.inlineCardConversion[key] ? {
        key: key,
        url: context.conversion.inlineCardConversion[key]
    } : null;
const $b2ba8815709d1afa$export$cdebb4bc59c595a = (schema, issue)=>{
    return [
        schema.nodes.inlineCard.createChecked({
            url: $b2ba8815709d1afa$var$withInlineCardFromTextStamp(issue)
        })
    ];
};
const $b2ba8815709d1afa$var$withInlineCardFromTextStamp = (issue)=>$b2ba8815709d1afa$export$a1a15f4d91e860d9.test(issue.url) ? issue.url : `${issue.url}#icft=${issue.key}`;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $b2ba8815709d1afa$var$isNotAllowedChars = (char)=>!/\s|\(|\)|!|\.|\,|\/|\:/.test(char);
const $b2ba8815709d1afa$export$cd8701ad7512efee = (inlineCardConversion)=>{
    if (!inlineCardConversion) return undefined;
    const pattern = Object.keys(inlineCardConversion).join('|');
    if (!pattern) return undefined;
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return new RegExp(`^(${pattern})`);
};

});



parcelRegister("q8ZzP", function(module, exports) {

$parcel$export(module.exports, "parseContentLink", () => $c394b3dcb4bc485b$export$3a250a08d37b0eae);

var $1WGKr = parcelRequire("1WGKr");
/*
 * This implementation is ported from JIRA with minimal modifications
 * It uses a mutable "StringBuffer" to parse links. It would be ideal to
 *  move this to operating on immutable strings instead if possible
 *
 * TODO: CS-596 Replace string buffer usage with strings
 */ function $c394b3dcb4bc485b$var$trimIfPossible(s) {
    if (s === null) return null;
    return s.trim();
}
function $c394b3dcb4bc485b$var$extractLinkBody(buffer) {
    const indexOfBang = buffer.indexOf('!');
    const indexOfPipe = buffer.indexOf('|');
    const lastIndexOfBang = buffer.lastIndexOf('!');
    const notEscaped = indexOfBang === -1 || indexOfBang > indexOfPipe || indexOfBang === lastIndexOfBang;
    if (notEscaped) return $c394b3dcb4bc485b$var$divideOn(buffer, '|');
    const body = new (0, $1WGKr.StringBuffer)();
    let inEscape = false;
    for(let i = 0; i < buffer.length(); i++){
        const c = buffer.charAt(i);
        if (c === '!') inEscape = !inEscape;
        if (c === '|' && !inEscape) {
            buffer.delete(0, i + 1);
            return body.toString();
        }
        body.append(c);
    }
    return null;
}
function $c394b3dcb4bc485b$var$divideAfterLast(buffer, divider) {
    if (buffer.length() === 0) return null;
    return $c394b3dcb4bc485b$var$divideAfter(buffer, buffer.lastIndexOf(divider));
}
function $c394b3dcb4bc485b$var$divideAfter(buffer, index) {
    if (typeof index === 'string') index = buffer.indexOf(index);
    if (index < 0) return null;
    else if (index === buffer.length() - 1) {
        buffer.deleteCharAt(buffer.length() - 1);
        return null;
    } else {
        const body = buffer.substring(index + 1);
        buffer.delete(index, buffer.length());
        return body;
    }
}
/**
 * Split a StringBuffer on some dividing character. Return everything before the divider,
 * and remove that prefix _and_ the divider from the StringBuffer. If there is no divider,
 * return null.
 * <p/>
 * If the buffer begins with the divider, then the divider will be removed _and_ null returned.
 * If the buffer ends with the divider, everything before the divider is returned and the buffer
 * will remain empty.
 *
 * @param buffer  the text we want to divide. Will be modified during the operation
 * @param divider the character to divide the buffer on
 * @return the characters before the divider, or the default if there are none
 */ function $c394b3dcb4bc485b$var$divideOn(buffer, divider) {
    if (buffer.length() === 0) return null;
    const i = buffer.indexOf(divider);
    if (i < 0) return null;
    else if (i === 0) {
        buffer.deleteCharAt(0);
        return null;
    } else {
        const body = buffer.substring(0, i);
        buffer.delete(0, i + 1);
        return body;
    }
}
function $c394b3dcb4bc485b$var$extractNumber(buf) {
    const digits = new (0, $1WGKr.StringBuffer)();
    let i = 0;
    for(; i < buf.length() && (0, $1WGKr.isDigit)(buf.charAt(i)); i++)digits.append(buf.charAt(i));
    if (i > 0) buf.delete(0, i);
    try {
        return parseInt(digits.toString(), 10);
    } catch (e) {
        return 0;
    }
}
function $c394b3dcb4bc485b$export$2d20cd44728d07a1(linkText) {
    const originalLinkText = linkText;
    // we want to decode single quotes (represented by &#039;) back before parsing the link test
    if (linkText.indexOf('&#039;') !== -1) linkText = linkText.replace('&#039;', "'");
    const buf = new (0, $1WGKr.StringBuffer)(linkText);
    const linkBody = $c394b3dcb4bc485b$var$extractLinkBody(buf);
    const linkTitle = $c394b3dcb4bc485b$var$trimIfPossible($c394b3dcb4bc485b$var$divideAfter(buf, '|'));
    const notLinkBody = buf.toString().trim();
    return {
        originalLinkText: originalLinkText,
        linkBody: linkBody,
        linkTitle: linkTitle,
        notLinkBody: notLinkBody
    };
}
function $c394b3dcb4bc485b$export$3a250a08d37b0eae(link) {
    if (typeof link === 'string') link = $c394b3dcb4bc485b$export$2d20cd44728d07a1(link);
    const { notLinkBody: notLinkBody } = link;
    let shortcutName = null;
    let shortcutValue = null;
    let spaceKey = null;
    let attachmentName = null;
    let anchor = null;
    let destinationTitle = '';
    let contentId = 0;
    // Don't treat it as a short link when it starts with "~"
    if (!notLinkBody.startsWith('~')) {
        const shortcutBuf = new (0, $1WGKr.StringBuffer)(notLinkBody);
        shortcutName = $c394b3dcb4bc485b$var$trimIfPossible($c394b3dcb4bc485b$var$divideAfterLast(shortcutBuf, '@'));
        if ((0, $1WGKr.isNotBlank)(shortcutName)) shortcutValue = shortcutBuf.toString();
    }
    const buf = new (0, $1WGKr.StringBuffer)(notLinkBody);
    if ((0, $1WGKr.isBlank)(shortcutName)) {
        spaceKey = $c394b3dcb4bc485b$var$trimIfPossible($c394b3dcb4bc485b$var$divideOn(buf, ':'));
        if (buf.indexOf('$') === 0) {
            buf.deleteCharAt(0);
            contentId = $c394b3dcb4bc485b$var$extractNumber(buf);
            if (contentId === 0) return {
                ...link,
                shortcutName: shortcutName,
                shortcutValue: shortcutValue,
                spaceKey: spaceKey,
                contentId: contentId,
                attachmentName: attachmentName,
                anchor: anchor,
                destinationTitle: destinationTitle
            };
        }
        attachmentName = $c394b3dcb4bc485b$var$trimIfPossible($c394b3dcb4bc485b$var$divideAfter(buf, '^'));
        anchor = $c394b3dcb4bc485b$var$trimIfPossible($c394b3dcb4bc485b$var$divideAfter(buf, '#'));
    }
    if (contentId === 0) destinationTitle = buf.toString().trim();
    return {
        ...link,
        shortcutName: shortcutName,
        shortcutValue: shortcutValue,
        spaceKey: spaceKey,
        contentId: contentId,
        attachmentName: attachmentName,
        anchor: anchor,
        destinationTitle: destinationTitle
    };
}

});




parcelRegister("2Wwr6", function(module, exports) {

$parcel$export(module.exports, "blockquote", () => $8c726923dc55fcf7$export$67dc04e652a298ca);

var $aT9xc = parcelRequire("aT9xc");
// bq. foobarbaz
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $8c726923dc55fcf7$var$BLOCKQUOTE_REGEXP = /^bq\.(.*)/;
const $8c726923dc55fcf7$export$67dc04e652a298ca = ({ input: input, position: position, schema: schema, context: context })=>{
    const match = input.substring(position).match($8c726923dc55fcf7$var$BLOCKQUOTE_REGEXP);
    if (!match) return $8c726923dc55fcf7$var$fallback(input, position);
    const [, rawContent] = match;
    return (0, $aT9xc.rawContentProcessor)('', rawContent, match[0].length, schema, context);
};
function $8c726923dc55fcf7$var$fallback(input, position) {
    return {
        type: 'text',
        text: input.substr(position, 1),
        length: 1
    };
}

});
parcelRegister("aT9xc", function(module, exports) {

$parcel$export(module.exports, "quoteMacro", () => $4c29530f9ab53258$export$8f9545cee64b3251);
$parcel$export(module.exports, "rawContentProcessor", () => $4c29530f9ab53258$export$c2a5e4612254bfa);

var $5z9yB = parcelRequire("5z9yB");

var $1WGKr = parcelRequire("1WGKr");

var $fCm0w = parcelRequire("fCm0w");

var $dhzNc = parcelRequire("dhzNc");
const $4c29530f9ab53258$export$8f9545cee64b3251 = ({ input: input, position: position, schema: schema, context: context })=>{
    return (0, $5z9yB.commonMacro)(input.substring(position), schema, {
        keyword: 'quote',
        paired: true,
        rawContentProcessor: $4c29530f9ab53258$export$c2a5e4612254bfa,
        context: context
    });
};
const $4c29530f9ab53258$export$c2a5e4612254bfa = (_rawAttrs, rawContent, length, schema, context)=>{
    if (!rawContent.length) {
        const emptyQuote = $4c29530f9ab53258$var$emptyBlockquote(schema);
        return {
            type: 'pmnode',
            nodes: [
                emptyQuote
            ],
            length: length
        };
    }
    const parsedContent = (0, $dhzNc.parseString)({
        schema: schema,
        context: context,
        ignoreTokenTypes: [],
        input: rawContent
    });
    const normalizedContent = (0, $fCm0w.normalizePMNodes)(parsedContent, schema);
    return {
        type: 'pmnode',
        nodes: $4c29530f9ab53258$var$sanitize(normalizedContent, schema),
        length: length
    };
};
function $4c29530f9ab53258$var$emptyBlockquote(schema) {
    const p = schema.nodes.paragraph.createChecked({}, []);
    return schema.nodes.blockquote.createChecked({}, p);
}
function $4c29530f9ab53258$var$sanitize(nodes, schema) {
    const output = [];
    let contentBuffer = [];
    for (const n of nodes)switch(n.type.name){
        case 'paragraph':
        case 'bulletList':
        case 'orderedList':
        case 'codeBlock':
        case 'mediaSingle':
        case 'mediaGroup':
            /**
				 * blockquote supports nesting paragraphs, lists, codeblocks and media nodes
				 */ contentBuffer.push(n);
            break;
        case 'heading':
            /**
				 * If a heading is inside a list item
				 * - h1. Bold, Uppercase
				 * - h2. Bold, Italic
				 * - h3. Bold
				 * - h4. Bold, Gray
				 * - h5. Gray, Italic
				 * - h6. Gray
				 */ contentBuffer.push($4c29530f9ab53258$var$transformHeading(n, schema));
            break;
        default:
            /**
				 * Anything else should be lifted
				 */ if (contentBuffer.length) {
                const blockquote = schema.nodes.blockquote.createChecked({}, contentBuffer);
                output.push(blockquote);
                contentBuffer = [];
            }
            output.push(n);
    }
    if (contentBuffer.length) {
        const blockquote = schema.nodes.blockquote.createChecked({}, contentBuffer);
        output.push(blockquote);
    }
    return output;
}
function $4c29530f9ab53258$var$transformHeading(heading, schema) {
    const contentBuffer = [];
    heading.content.forEach((n)=>{
        const strong = schema.marks.strong.create();
        const italic = schema.marks.em.create();
        const gray = schema.marks.textColor.create({
            color: '#97a0af'
        });
        if (n.type.name === 'text') {
            if (n.text && heading.attrs.level === 1) // @ts-ignore assigning to readonly prop to transform text
            n.text = n.text.toUpperCase();
            if (heading.attrs.level <= 4 && !(0, $1WGKr.hasAnyOfMarks)(n, [
                'strong',
                'code'
            ])) n = n.mark([
                ...n.marks,
                strong
            ]);
            if ((heading.attrs.level === 5 || heading.attrs.level === 2) && !(0, $1WGKr.hasAnyOfMarks)(n, [
                'em',
                'code'
            ])) n = n.mark([
                ...n.marks,
                italic
            ]);
            if (heading.attrs.level > 3 && !(0, $1WGKr.hasAnyOfMarks)(n, [
                'textColor',
                'code'
            ])) n = n.mark([
                ...n.marks,
                gray
            ]);
        }
        contentBuffer.push(n);
    });
    return schema.nodes.paragraph.createChecked({}, contentBuffer);
}

});
parcelRegister("5z9yB", function(module, exports) {

$parcel$export(module.exports, "commonMacro", () => $c1bba8c2982977b1$export$b6a12943ac1bb1ba);
function $c1bba8c2982977b1$export$b6a12943ac1bb1ba(input, schema, opt) {
    /**
	 * Forging the opening regex, the result would look something like
	 * /^\{(quote)(?::([^\{\n\}]*))?\}/i
	 */ // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const opening = new RegExp(`^\{(${opt.keyword})(?::([^\{\n\}]*))?\}`, 'i');
    const matchOpening = input.match(opening);
    if (!matchOpening) return $c1bba8c2982977b1$var$fallback(input);
    const [, name, rawAttrs] = matchOpening;
    const openingLength = matchOpening[0].length;
    if (!opt.paired) /**
		 * Some macros do not have a closing symbol, for example
		 * {anchor:here} {loremipsum}
		 */ return opt.rawContentProcessor(rawAttrs, '', openingLength, schema, opt.context);
    /**
	 * Forging the closing regex, the result would look something like
	 * /\{quote\}/
	 */ // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const closing = new RegExp(`\{${name}\}`);
    const matchClosing = closing.exec(input.substring(openingLength));
    let rawContent = '';
    if (matchClosing) rawContent = input.substring(openingLength, openingLength + matchClosing.index);
    const length = matchClosing ? openingLength + matchClosing.index + matchClosing[0].length : openingLength;
    return opt.rawContentProcessor(rawAttrs, rawContent, length, schema, opt.context);
}
function $c1bba8c2982977b1$var$fallback(input) {
    return {
        type: 'text',
        text: input.substr(0, 1),
        length: 1
    };
}

});



parcelRegister("1LFn0", function(module, exports) {

$parcel$export(module.exports, "citation", () => $2604934bd49e3a17$export$258632c953c109e9);

var $6eGMp = parcelRequire("6eGMp");

var $1WGKr = parcelRequire("1WGKr");

var $fhRGb = parcelRequire("fhRGb");

var $dhzNc = parcelRequire("dhzNc");

const $2604934bd49e3a17$export$258632c953c109e9 = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content
	 */ const ignoreTokenTypes = [
        (0, $6eGMp.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $6eGMp.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $6eGMp.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $6eGMp.TokenType).ISSUE_KEY
    ];
    // Add code mark to each text
    const contentDecorator = (n, index)=>{
        const mark = schema.marks.em.create();
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !(0, $1WGKr.hasAnyOfMarks)(n, [
            'em',
            'code'
        ])) {
            if (index === 0) // @ts-ignore - [unblock prosemirror bump] allow assign to readonly
            n.text = `${0, $26bff8506c0ca8f4$export$3bca9fae3002bd9b} ${n.text}`;
            return n.mark([
                ...n.marks,
                mark
            ]);
        }
        return n;
    };
    const rawContentProcessor = (raw, length)=>{
        const content = (0, $dhzNc.parseString)({
            ignoreTokenTypes: ignoreTokenTypes,
            schema: schema,
            context: context,
            input: raw
        });
        const decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
    const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, $1WGKr.getSurroundingSymbols)(input.substring(position), '??', '??');
    return (0, $fhRGb.commonFormatter)(input, position, schema, {
        opening: openingSymbol,
        closing: closingSymbol,
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});
const $26bff8506c0ca8f4$export$3bca9fae3002bd9b = "\u2014";


parcelRegister("6ZPSP", function(module, exports) {

$parcel$export(module.exports, "deleted", () => $59bc4962356319db$export$bccbf0c716f226f4);

var $6eGMp = parcelRequire("6eGMp");

var $1WGKr = parcelRequire("1WGKr");

var $fhRGb = parcelRequire("fhRGb");

var $dhzNc = parcelRequire("dhzNc");
const $59bc4962356319db$export$bccbf0c716f226f4 = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content
	 */ const ignoreTokenTypes = [
        (0, $6eGMp.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $6eGMp.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $6eGMp.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $6eGMp.TokenType).ISSUE_KEY,
        (0, $6eGMp.TokenType).TABLE
    ];
    /** Add strike mark to each text */ const contentDecorator = (n)=>{
        const mark = schema.marks.strike.create();
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !(0, $1WGKr.hasAnyOfMarks)(n, [
            'strike',
            'code'
        ])) return n.mark([
            ...n.marks,
            mark
        ]);
        return n;
    };
    const rawContentProcessor = (raw, length)=>{
        const content = (0, $dhzNc.parseString)({
            ignoreTokenTypes: ignoreTokenTypes,
            schema: schema,
            context: context,
            input: raw
        });
        const decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
    const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, $1WGKr.getSurroundingSymbols)(input.substring(position), '-', '-');
    return (0, $fhRGb.commonFormatter)(input, position, schema, {
        opening: openingSymbol,
        closing: closingSymbol,
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});

parcelRegister("i7Qrh", function(module, exports) {

$parcel$export(module.exports, "doubleDashSymbol", () => $8d516de7e4d522ce$export$65e3ca7c95899a2d);

var $bpFts = parcelRequire("bpFts");
const $8d516de7e4d522ce$var$token = {
    type: 'text',
    text: '\u2013',
    length: 2
};
const $8d516de7e4d522ce$var$fallback = {
    ...$8d516de7e4d522ce$var$token,
    text: '--'
};
const $8d516de7e4d522ce$export$65e3ca7c95899a2d = (0, $bpFts.createDashTokenParser)($8d516de7e4d522ce$var$token, $8d516de7e4d522ce$var$fallback);

});
parcelRegister("bpFts", function(module, exports) {

$parcel$export(module.exports, "createDashTokenParser", () => $a225e8c1f912adb3$export$d43b58865d429e3c);
const $a225e8c1f912adb3$export$d43b58865d429e3c = (token, fallback)=>({ input: input, position: position })=>{
        /**
		 * From Jira https://stash.atlassian.com/projects/JIRACLOUD/repos/jira/browse/jira-components/jira-renderer/src/main/java/com/atlassian/renderer/v2/components/phrase/DashRendererComponent.java
		 *  public static final Replacer EN_DASH = new Replacer(Pattern.compile("(^|\\s)--(\\s|$)"), "$1&#8211;$2", "--");
		 *  public static final Replacer EM_DASH = new Replacer(Pattern.compile("(^|\\s)---(\\s|$)"), "$1&#8212;$2", "---");
		 */ if (position > 0) {
            const charBeforeToken = input.charAt(position - 1);
            if (!$a225e8c1f912adb3$var$isSpace(charBeforeToken)) return fallback;
        }
        if (position + token.length < input.length) {
            const charAfterToken = input.charAt(position + token.length);
            if (!$a225e8c1f912adb3$var$isSpace(charAfterToken)) return fallback;
        }
        return token;
    };
const $a225e8c1f912adb3$var$isSpace = (char)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return /\s/.test(char);
};

});


parcelRegister("2nkrY", function(module, exports) {

$parcel$export(module.exports, "emoji", () => $49aaa13af4f2e50b$export$a19185d1233fc4b2);
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $49aaa13af4f2e50b$var$emptyOrSpecialCharRegex = new RegExp(/^$|[^A-Za-z0-9]/);
const $49aaa13af4f2e50b$export$a19185d1233fc4b2 = ({ input: input, position: position, schema: schema })=>{
    const substring = input.substring(position);
    /**
	 * The length of wikimakrup emoji test ranges from 2 to 9 characters at the time of writing.
	 */ for(let i = 2; i <= 9 && i <= substring.length; ++i){
        const candidateText = substring.substring(0, i);
        const emojiId = $49aaa13af4f2e50b$export$fabd2c9504f5bf35[candidateText];
        // Is current candidate an emoji AND next character empty string any special character?
        if (emojiId && $49aaa13af4f2e50b$var$emptyOrSpecialCharRegex.test(substring.charAt(i))) return {
            type: 'pmnode',
            nodes: [
                schema.nodes.emoji.createChecked($49aaa13af4f2e50b$export$797c048dfde076a1[emojiId])
            ],
            length: i
        };
    }
    return {
        type: 'text',
        text: substring.substr(0, 1),
        length: 1
    };
};
const $49aaa13af4f2e50b$export$797c048dfde076a1 = {
    '1f642': {
        id: '1f642',
        shortName: ':slight_smile:',
        text: "\uD83D\uDE42"
    },
    '1f61e': {
        id: '1f61e',
        shortName: ':disappointed:',
        text: "\uD83D\uDE1E"
    },
    '1f61b': {
        id: '1f61b',
        shortName: ':stuck_out_tongue:',
        text: "\uD83D\uDE1B"
    },
    '1f603': {
        id: '1f603',
        shortName: ':smiley:',
        text: "\uD83D\uDE03"
    },
    '1f609': {
        id: '1f609',
        shortName: ':wink:',
        text: "\uD83D\uDE09"
    },
    '1f44d': {
        id: '1f44d',
        shortName: ':thumbsup:',
        text: "\uD83D\uDC4D"
    },
    '1f44e': {
        id: '1f44e',
        shortName: ':thumbsdown:',
        text: "\uD83D\uDC4E"
    },
    'atlassian-info': {
        id: 'atlassian-info',
        shortName: ':info:',
        text: ':info:'
    },
    'atlassian-check_mark': {
        id: 'atlassian-check_mark',
        shortName: ':check_mark:',
        text: ':check_mark:'
    },
    'atlassian-cross_mark': {
        id: 'atlassian-cross_mark',
        shortName: ':cross_mark:',
        text: ':cross_mark:'
    },
    'atlassian-warning': {
        id: 'atlassian-warning',
        shortName: ':warning:',
        text: ':warning:'
    },
    'atlassian-plus': {
        id: 'atlassian-plus',
        shortName: ':plus:',
        text: ':plus:'
    },
    'atlassian-minus': {
        id: 'atlassian-minus',
        shortName: ':minus:',
        text: ':minus:'
    },
    'atlassian-question_mark': {
        id: 'atlassian-question_mark',
        shortName: ':question:',
        text: ':question:'
    },
    'atlassian-light_bulb_on': {
        id: 'atlassian-light_bulb_on',
        shortName: ':light_bulb_on:',
        text: ':light_bulb_on:'
    },
    'atlassian-light_bulb_off': {
        id: 'atlassian-light_bulb_off',
        shortName: ':light_bulb_off:',
        text: ':light_bulb_off:'
    },
    'atlassian-yellow_star': {
        id: 'atlassian-yellow_star',
        shortName: ':yellow_star:',
        text: ':yellow_star:'
    },
    'atlassian-red_star': {
        id: 'atlassian-red_star',
        shortName: ':red_star:',
        text: ':red_star:'
    },
    'atlassian-green_star': {
        id: 'atlassian-green_star',
        shortName: ':green_star:',
        text: ':green_star:'
    },
    'atlassian-blue_star': {
        id: 'atlassian-blue_star',
        shortName: ':blue_star:',
        text: ':blue_star:'
    },
    'atlassian-flag_on': {
        id: 'atlassian-flag_on',
        shortName: ':flag_on:',
        text: ':flag_on:'
    },
    'atlassian-flag_off': {
        id: 'atlassian-flag_off',
        shortName: ':flag_off:',
        text: ':flag_off:'
    }
};
const $49aaa13af4f2e50b$export$fabd2c9504f5bf35 = {
    ':)': '1f642',
    ':-)': '1f642',
    ':(': '1f61e',
    ':-(': '1f61e',
    ':P': '1f61b',
    ':-P': '1f61b',
    ':p': '1f61b',
    ':-p': '1f61b',
    ':D': '1f603',
    ':-D': '1f603',
    ';)': '1f609',
    ';-)': '1f609',
    '(y)': '1f44d',
    '(n)': '1f44e',
    '(i)': 'atlassian-info',
    '(/)': 'atlassian-check_mark',
    '(x)': 'atlassian-cross_mark',
    '(!)': 'atlassian-warning',
    '(+)': 'atlassian-plus',
    '(-)': 'atlassian-minus',
    '(?)': 'atlassian-question_mark',
    '(on)': 'atlassian-light_bulb_on',
    '(off)': 'atlassian-light_bulb_off',
    '(*)': 'atlassian-yellow_star',
    '(*y)': 'atlassian-yellow_star',
    '(*r)': 'atlassian-red_star',
    '(*g)': 'atlassian-green_star',
    '(*b)': 'atlassian-blue_star',
    '(flag)': 'atlassian-flag_on',
    '(flagoff)': 'atlassian-flag_off'
};

});

parcelRegister("iMFmQ", function(module, exports) {

$parcel$export(module.exports, "emphasis", () => $56c8572e84f48056$export$bef81ba411953b51);

var $6eGMp = parcelRequire("6eGMp");

var $1WGKr = parcelRequire("1WGKr");

var $fhRGb = parcelRequire("fhRGb");

var $dhzNc = parcelRequire("dhzNc");
const $56c8572e84f48056$export$bef81ba411953b51 = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content of a  mark
	 */ const ignoreTokenTypes = [
        (0, $6eGMp.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $6eGMp.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $6eGMp.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $6eGMp.TokenType).ISSUE_KEY,
        (0, $6eGMp.TokenType).TABLE
    ];
    // Add underline mark to each text
    const contentDecorator = (n)=>{
        const mark = schema.marks.em.create();
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !(0, $1WGKr.hasAnyOfMarks)(n, [
            'em',
            'code'
        ])) return n.mark([
            ...n.marks,
            mark
        ]);
        return n;
    };
    const rawContentProcessor = (raw, length)=>{
        const content = (0, $dhzNc.parseString)({
            ignoreTokenTypes: ignoreTokenTypes,
            schema: schema,
            context: context,
            input: raw
        });
        const decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
    const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, $1WGKr.getSurroundingSymbols)(input.substring(position), '_', '_');
    return (0, $fhRGb.commonFormatter)(input, position, schema, {
        opening: openingSymbol,
        closing: closingSymbol,
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});

parcelRegister("gx4M9", function(module, exports) {

$parcel$export(module.exports, "hardbreak", () => $25ab1944cee5ed27$export$ac55bb44695749c1);

var $8215W = parcelRequire("8215W");
const $25ab1944cee5ed27$export$ac55bb44695749c1 = ({ input: input, position: position, schema: schema })=>{
    // Look for normal hardbreak \r, \n, \r\n
    const length = (0, $8215W.parseNewlineOnly)(input.substring(position));
    if (length === 0) // not a valid hardbreak
    return {
        type: 'text',
        text: input.substr(position, 1),
        length: 1
    };
    return {
        type: 'pmnode',
        nodes: [
            schema.nodes.hardBreak.createChecked()
        ],
        length: length
    };
};

});

parcelRegister("lUxPt", function(module, exports) {

$parcel$export(module.exports, "heading", () => $0817ed432dfca260$export$46e4a324ac90507f);

var $dhzNc = parcelRequire("dhzNc");

var $6eGMp = parcelRequire("6eGMp");
// h1. HEADING
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $0817ed432dfca260$var$HEADING_REGEXP = /^h([1-6])\.(.*)/;
const $0817ed432dfca260$export$46e4a324ac90507f = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content of a strong mark
	 */ const ignoreTokenTypes = [
        (0, $6eGMp.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $6eGMp.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $6eGMp.TokenType).QUADRUPLE_DASH_SYMBOL
    ];
    const match = input.substring(position).match($0817ed432dfca260$var$HEADING_REGEXP);
    if (!match) return $0817ed432dfca260$var$fallback(input, position);
    const level = parseInt(match[1], 10);
    const content = (0, $dhzNc.parseString)({
        schema: schema,
        ignoreTokenTypes: ignoreTokenTypes,
        context: context,
        input: match[2]
    });
    try {
        const headingNode = schema.nodes.heading.createChecked({
            level: level
        }, content);
        return {
            type: 'pmnode',
            nodes: [
                headingNode
            ],
            length: match[0].length
        };
    } catch (err) {
        /**
		 * If the heading fails to rendering, we want to skip the text
		 * "h1."
		 */ return {
            type: 'text',
            text: '',
            length: 4
        };
    }
};
function $0817ed432dfca260$var$fallback(input, position) {
    return {
        type: 'text',
        text: input.substr(position, 1),
        length: 1
    };
}

});

parcelRegister("4lUX8", function(module, exports) {

$parcel$export(module.exports, "inserted", () => $4ece8c64dac2da19$export$744ba74fb86b8ca7);

var $6eGMp = parcelRequire("6eGMp");

var $1WGKr = parcelRequire("1WGKr");

var $fhRGb = parcelRequire("fhRGb");

var $dhzNc = parcelRequire("dhzNc");
const $4ece8c64dac2da19$export$744ba74fb86b8ca7 = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content
	 */ const ignoreTokenTypes = [
        (0, $6eGMp.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $6eGMp.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $6eGMp.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $6eGMp.TokenType).ISSUE_KEY,
        (0, $6eGMp.TokenType).TABLE
    ];
    // Add underline mark to each text
    const contentDecorator = (n)=>{
        const mark = schema.marks.underline.create();
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !(0, $1WGKr.hasAnyOfMarks)(n, [
            'underline',
            'code'
        ])) return n.mark([
            ...n.marks,
            mark
        ]);
        return n;
    };
    const rawContentProcessor = (raw, length)=>{
        const content = (0, $dhzNc.parseString)({
            ignoreTokenTypes: ignoreTokenTypes,
            schema: schema,
            context: context,
            input: raw
        });
        const decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
    const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, $1WGKr.getSurroundingSymbols)(input.substring(position), '+', '+');
    return (0, $fhRGb.commonFormatter)(input, position, schema, {
        opening: openingSymbol,
        closing: closingSymbol,
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});

parcelRegister("aYbjO", function(module, exports) {

$parcel$export(module.exports, "MAX_LIST_DEPTH", () => $73a3f639dabbaa30$export$d2a2f0ec33d903e1);
$parcel$export(module.exports, "list", () => $73a3f639dabbaa30$export$8837f4fc672e936d);

var $klj9R = parcelRequire("klj9R");

var $dhzNc = parcelRequire("dhzNc");

var $fCm0w = parcelRequire("fCm0w");

var $8o4RP = parcelRequire("8o4RP");

var $6eGMp = parcelRequire("6eGMp");

var $8215W = parcelRequire("8215W");

var $1WGKr = parcelRequire("1WGKr");
const $73a3f639dabbaa30$export$d2a2f0ec33d903e1 = 20;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $73a3f639dabbaa30$var$LIST_ITEM_REGEXP = new RegExp(`^ *([*\\-#]{1,${$73a3f639dabbaa30$export$d2a2f0ec33d903e1}}) `);
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $73a3f639dabbaa30$var$EMPTY_LINE_REGEXP = /^[ \t]*\r?\n/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $73a3f639dabbaa30$var$RULER_SYMBOL_REGEXP = /^-{4,5}/;
const $73a3f639dabbaa30$var$processState = {
    NEW_LINE: 0,
    BUFFER: 1,
    END: 2,
    MACRO: 3
};
const $73a3f639dabbaa30$export$8837f4fc672e936d = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content of a listItem
	 */ const ignoreTokenTypes = [
        (0, $6eGMp.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $6eGMp.TokenType).LIST,
        (0, $6eGMp.TokenType).TABLE
    ];
    let index = position;
    let state = $73a3f639dabbaa30$var$processState.NEW_LINE;
    let buffer = [];
    let lastListSymbols = null;
    let builder = null;
    let contentBuffer = [];
    const output = [];
    while(index < input.length){
        const char = input.charAt(index);
        switch(state){
            case $73a3f639dabbaa30$var$processState.NEW_LINE:
                {
                    const substring = input.substring(index);
                    const listMatch = substring.match($73a3f639dabbaa30$var$LIST_ITEM_REGEXP);
                    if (listMatch) {
                        const [, symbols] = listMatch;
                        // Handle ruler in list
                        const rulerMatch = symbols.match($73a3f639dabbaa30$var$RULER_SYMBOL_REGEXP);
                        if (rulerMatch) {
                            const remainingAfterSymbol = input.substring(index + rulerMatch[0].length);
                            const emptyLineMatch = remainingAfterSymbol.match($73a3f639dabbaa30$var$EMPTY_LINE_REGEXP);
                            // If this is an empty line skip to the buffering step rather than match as a list element
                            if (emptyLineMatch) {
                                state = $73a3f639dabbaa30$var$processState.BUFFER;
                                continue;
                            }
                        }
                        if (!builder) {
                            // It happens because this is the first item of the list
                            builder = new (0, $klj9R.ListBuilder)(schema, symbols);
                            lastListSymbols = symbols;
                        } else {
                            /**
						 * There is a builder, so we are in the middle of building a list
						 * and now there is a new list item
						 */ if (buffer.length > 0) {
                                // Wrap up previous list item and clear buffer
                                const content = (0, $dhzNc.parseString)({
                                    ignoreTokenTypes: ignoreTokenTypes,
                                    schema: schema,
                                    context: context,
                                    input: buffer.join(''),
                                    includeLeadingSpace: true
                                });
                                contentBuffer.push(...content);
                                builder.add([
                                    {
                                        style: lastListSymbols,
                                        content: $73a3f639dabbaa30$var$sanitize((0, $fCm0w.normalizePMNodes)(contentBuffer, schema), schema)
                                    }
                                ]);
                                buffer = [];
                                contentBuffer = [];
                            }
                            // We finished last list item here, going to the new one
                            lastListSymbols = symbols;
                            const type = (0, $klj9R.getType)(symbols);
                            // If it's top level and doesn't match, create a new list
                            if (type !== builder.type && symbols.length === 1) {
                                output.push(...builder.buildPMNode());
                                builder = new (0, $klj9R.ListBuilder)(schema, symbols);
                            }
                        }
                        index += listMatch[0].length;
                    }
                    // If we encounter an empty line, we should end the list
                    const emptyLineMatch = substring.match($73a3f639dabbaa30$var$EMPTY_LINE_REGEXP);
                    if (emptyLineMatch) {
                        state = $73a3f639dabbaa30$var$processState.END;
                        continue;
                    }
                    state = $73a3f639dabbaa30$var$processState.BUFFER;
                    continue;
                }
            case $73a3f639dabbaa30$var$processState.BUFFER:
                {
                    const length = (0, $8215W.parseNewlineOnly)(input.substring(index));
                    if (length) {
                        buffer.push(input.substr(index, length));
                        state = $73a3f639dabbaa30$var$processState.NEW_LINE;
                        index += length;
                        continue;
                    }
                    if (char === '{') {
                        state = $73a3f639dabbaa30$var$processState.MACRO;
                        continue;
                    } else buffer.push(char);
                    break;
                }
            case $73a3f639dabbaa30$var$processState.MACRO:
                {
                    const match = (0, $8o4RP.parseMacroKeyword)(input.substring(index));
                    if (!match) {
                        buffer.push(char);
                        state = $73a3f639dabbaa30$var$processState.BUFFER;
                        break;
                    }
                    const token = (0, $6eGMp.parseToken)(input, match.type, index, schema, context);
                    buffer.push(input.substr(index, token.length));
                    index += token.length;
                    state = $73a3f639dabbaa30$var$processState.BUFFER;
                    continue;
                }
            case $73a3f639dabbaa30$var$processState.END:
                if (!builder) // Something is really wrong here
                return $73a3f639dabbaa30$var$fallback(input, position);
                if (buffer.length > 0) {
                    // Wrap up previous list item and clear buffer
                    const content = (0, $dhzNc.parseString)({
                        ignoreTokenTypes: ignoreTokenTypes,
                        schema: schema,
                        context: context,
                        input: buffer.join(''),
                        includeLeadingSpace: true
                    });
                    contentBuffer.push(...content);
                }
                builder.add([
                    {
                        style: lastListSymbols,
                        content: $73a3f639dabbaa30$var$sanitize((0, $fCm0w.normalizePMNodes)(contentBuffer, schema), schema)
                    }
                ]);
                output.push(...builder.buildPMNode());
                return {
                    type: 'pmnode',
                    nodes: output,
                    length: index - position
                };
        }
        index++;
    }
    if (buffer.length > 0) {
        // Wrap up what's left in the buffer
        const content = (0, $dhzNc.parseString)({
            ignoreTokenTypes: ignoreTokenTypes,
            schema: schema,
            context: context,
            input: buffer.join(''),
            includeLeadingSpace: true
        });
        contentBuffer.push(...content);
    }
    if (builder) {
        builder.add([
            {
                style: lastListSymbols,
                content: $73a3f639dabbaa30$var$sanitize((0, $fCm0w.normalizePMNodes)(contentBuffer, schema), schema)
            }
        ]);
        output.push(...builder.buildPMNode());
    }
    return {
        type: 'pmnode',
        nodes: output,
        length: index - position
    };
};
function $73a3f639dabbaa30$var$sanitize(nodes, schema) {
    return nodes.reduce((result, curr)=>{
        switch(curr.type.name){
            case 'blockquote':
                /**
				 * If a blockquote is inside a list item
				 * - Convert it to paragraph
				 */ curr.content.forEach((n)=>{
                    result.push(n);
                });
                break;
            case 'heading':
                {
                    /**
				 * If a heading is inside a list item
				 * - Convert the heading to paragraph
				 * - Convert text to upper case
				 * - Mark text with strong.
				 */ const contentBuffer = [];
                    curr.content.forEach((n)=>{
                        const mark = schema.marks.strong.create();
                        if (n.type.name === 'text') {
                            if (n.text) // @ts-ignore - [unblock prosemirror bump] allow assign to readonly
                            n.text = n.text.toUpperCase();
                            if (n.type.name === 'text' && !(0, $1WGKr.hasAnyOfMarks)(n, [
                                'strong',
                                'code'
                            ])) contentBuffer.push(n.mark([
                                ...n.marks,
                                mark
                            ]));
                            else contentBuffer.push(n);
                        } else contentBuffer.push(n);
                    });
                    const p = schema.nodes.paragraph.createChecked({}, contentBuffer);
                    result.push(p);
                    break;
                }
            default:
                result.push(curr);
        }
        return result;
    }, []);
}
function $73a3f639dabbaa30$var$fallback(input, position) {
    return {
        type: 'text',
        text: input.substr(position, 1),
        length: 1
    };
}

});
parcelRegister("klj9R", function(module, exports) {

$parcel$export(module.exports, "getType", () => $75244595026c201e$export$e2b5c5db9e2009fd);
$parcel$export(module.exports, "ListBuilder", () => $75244595026c201e$export$876cfa3161bef296);
const $75244595026c201e$var$supportedContentType = [
    'paragraph',
    'orderedList',
    'bulletList',
    'mediaSingle',
    'codeBlock'
];
function $75244595026c201e$export$e2b5c5db9e2009fd(bullets) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return /#$/.test(bullets) ? 'orderedList' : 'bulletList';
}
class $75244595026c201e$export$876cfa3161bef296 {
    constructor(schema, bullets){
        /**
	 * Build prosemirror bulletList or orderedList node
	 * @param {List} list
	 * @returns {PMNode}
	 */ this.parseList = (list)=>{
            const listNode = this.schema.nodes[list.type];
            const output = [];
            let listItemsBuffer = [];
            for(let i = 0; i < list.children.length; i++){
                const parsedContent = this.parseListItem(list.children[i]);
                for(let j = 0; j < parsedContent.length; j++){
                    const parsedNode = parsedContent[j];
                    if (parsedNode.type.name === 'listItem') {
                        listItemsBuffer.push(parsedNode);
                        continue;
                    }
                    /**
				 * If the node is not a listItem, then we need to
				 * wrap exisintg list and break out
				 */ if (listItemsBuffer.length) {
                        const list = listNode.createChecked({}, listItemsBuffer);
                        output.push(list);
                    }
                    output.push(parsedNode); // This is the break out node
                    listItemsBuffer = [];
                }
            }
            if (listItemsBuffer.length) {
                const list = listNode.createChecked({}, listItemsBuffer);
                output.push(list);
            }
            return output;
        };
        /**
	 * Build prosemirror listItem node
	 * This function would possibly return non listItem nodes
	 * which we need to break out later
	 * @param {ListItem} item
	 */ this.parseListItem = (item)=>{
            const output = [];
            if (!item.content) item.content = [];
            // Parse nested list
            const parsedChildren = item.children.reduce((result, list)=>{
                const parsedList = this.parseList(list);
                result.push(...parsedList);
                return result;
            }, []);
            // Append children to the content
            item.content.push(...parsedChildren);
            let contentBuffer = [];
            for(let i = 0; i < item.content.length; i++){
                const pmNode = item.content[i];
                /**
			 * Skip empty paragraph
			 */ if (pmNode.type.name === 'paragraph' && pmNode.childCount === 0) continue;
                /* Skip Empty spaces after rule */ if (this.isParagraphEmptyTextNode(pmNode)) continue;
                if ($75244595026c201e$var$supportedContentType.indexOf(pmNode.type.name) === -1) {
                    const listItem = this.createListItem(contentBuffer, this.schema);
                    output.push(listItem);
                    output.push(pmNode);
                    contentBuffer = [];
                    continue;
                }
                contentBuffer.push(pmNode);
            }
            if (contentBuffer.length) {
                const listItem = this.createListItem(contentBuffer, this.schema);
                output.push(listItem);
            }
            return output;
        };
        this.schema = schema;
        this.root = {
            children: [],
            type: $75244595026c201e$export$e2b5c5db9e2009fd(bullets)
        };
        this.lastDepth = 1;
        this.lastList = this.root;
    }
    /**
	 * Return the type of the base list
	 * @returns {ListType}
	 */ get type() {
        return this.root.type;
    }
    /**
	 * Add a list item to the builder
	 * @param {AddArgs[]} items
	 */ add(items) {
        for (const item of items){
            const { style: style, content: content } = item;
            // If there's no style, add to previous list item as multiline
            if (style === null) {
                this.appendToLastItem(content);
                continue;
            }
            const depth = style.length;
            const type = $75244595026c201e$export$e2b5c5db9e2009fd(style);
            if (depth > this.lastDepth) {
                // Add children starting from last node
                this.createNest(depth - this.lastDepth, type);
                this.lastDepth = depth;
                this.lastList = this.addListItem(type, content);
            } else if (depth === this.lastDepth) // Add list item to current node
            this.lastList = this.addListItem(type, content);
            else {
                // Find node at depth and add list item
                this.lastList = this.findAncestor(this.lastDepth - depth);
                this.lastDepth = depth;
                this.lastList = this.addListItem(type, content);
            }
        }
    }
    /**
	 * Compile a prosemirror node from the root list
	 * @returns {PMNode[]}
	 */ buildPMNode() {
        return this.parseList(this.root);
    }
    /* Check if all paragraph's children nodes are text and empty */ isParagraphEmptyTextNode(node) {
        if (node.type.name !== 'paragraph' || !node.childCount) return false;
        for(let i = 0; i < node.childCount; i++){
            const n = node.content.child(i);
            if (n.type.name !== 'text') // Paragraph contains non-text node, so not empty
            return false;
            else if (n.textContent.trim() !== '') return false;
        }
        return true;
    }
    createListItem(content, schema) {
        if (content.length === 0 || [
            'paragraph',
            'mediaSingle'
        ].indexOf(content[0].type.name) === -1) // If the content is empty or the first element is not paragraph or mediaSingle.
        // this likely to be a nested list where the toplevel list is empty
        // For example: *# item 1
        // In this case we create an empty paragraph for the top level listNode
        content.unshift(this.schema.nodes.paragraph.createChecked());
        return schema.nodes.listItem.createChecked({}, content);
    }
    /**
	 * Add an item at the same level as the current list item
	 * @param {ListType} type
	 * @param {PMNode} content
	 * @returns {PMNode}
	 */ addListItem(type, content) {
        let list = this.lastList;
        // If the list is a different type, create a new list and add it to the parent node
        if (list.type !== type) {
            const parent = list.parent;
            const newList = {
                children: [],
                type: type,
                parent: parent
            };
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            parent.children.push(newList);
            this.lastList = list = newList;
        }
        const listItem = {
            content: content,
            parent: list,
            children: []
        };
        list.children = [
            ...list.children,
            listItem
        ];
        return list;
    }
    /**
	 * Append the past content to the last accessed list node (multiline entries)
	 * @param {PMNode[]} content
	 */ appendToLastItem(content) {
        const { children: children } = this.lastList;
        const lastItem = children[children.length - 1];
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        lastItem.content.push(...content);
    }
    /**
	 * Created a nested list structure of N depth under the current node
	 * @param {number} depth
	 * @param {ListType} type
	 */ createNest(depth, type) {
        while(depth-- > 0){
            if (this.lastList.children.length === 0) {
                const listItem = {
                    parent: this.lastList,
                    children: []
                };
                this.lastList.children = [
                    listItem
                ];
            }
            const nextItem = this.lastList.children[this.lastList.children.length - 1];
            nextItem.children = [
                {
                    children: [],
                    parent: nextItem,
                    type: type
                }
            ];
            this.lastList = nextItem.children[0];
        }
    }
    /**
	 * Find the Nth list ancestor of the current list
	 * @param {number} depth
	 */ findAncestor(depth) {
        let list = this.lastList;
        while(depth-- > 0 && list.parent){
            const listItem = list.parent;
            if (listItem && listItem.parent) list = listItem.parent;
        }
        return list;
    }
}

});


parcelRegister("jXlfv", function(module, exports) {

$parcel$export(module.exports, "monospace", () => $2fe019392c12f2b0$export$2b90969bbc9ff4c9);

var $6eGMp = parcelRequire("6eGMp");

var $1WGKr = parcelRequire("1WGKr");

var $fhRGb = parcelRequire("fhRGb");

var $dhzNc = parcelRequire("dhzNc");
const $2fe019392c12f2b0$export$2b90969bbc9ff4c9 = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content
	 */ const ignoreTokenTypes = [
        (0, $6eGMp.TokenType).ADF_MACRO,
        (0, $6eGMp.TokenType).ANCHOR_MACRO,
        (0, $6eGMp.TokenType).CODE_MACRO,
        (0, $6eGMp.TokenType).QUOTE_MACRO,
        (0, $6eGMp.TokenType).NOFORMAT_MACRO,
        (0, $6eGMp.TokenType).PANEL_MACRO,
        (0, $6eGMp.TokenType).COLOR_MACRO,
        (0, $6eGMp.TokenType).LOREM_MACRO,
        (0, $6eGMp.TokenType).QUOTE,
        (0, $6eGMp.TokenType).STRING,
        (0, $6eGMp.TokenType).ISSUE_KEY,
        (0, $6eGMp.TokenType).LINK_FORMAT,
        (0, $6eGMp.TokenType).LINK_TEXT,
        (0, $6eGMp.TokenType).MEDIA,
        (0, $6eGMp.TokenType).HEADING,
        (0, $6eGMp.TokenType).LIST,
        (0, $6eGMp.TokenType).TABLE,
        (0, $6eGMp.TokenType).RULER,
        (0, $6eGMp.TokenType).HARD_BREAK,
        (0, $6eGMp.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $6eGMp.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $6eGMp.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $6eGMp.TokenType).STRONG,
        (0, $6eGMp.TokenType).MONOSPACE,
        (0, $6eGMp.TokenType).SUPERSCRIPT,
        (0, $6eGMp.TokenType).SUBSCRIPT,
        (0, $6eGMp.TokenType).EMPHASIS,
        (0, $6eGMp.TokenType).CITATION,
        (0, $6eGMp.TokenType).DELETED,
        (0, $6eGMp.TokenType).INSERTED,
        (0, $6eGMp.TokenType).EMOJI,
        (0, $6eGMp.TokenType).FORCE_LINE_BREAK
    ];
    // Add code mark to each text
    const contentDecorator = (n)=>{
        const mark = schema.marks.code.create();
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && n.marks.length) return n;
        return n.mark([
            mark
        ]);
    };
    const rawContentProcessor = (raw, length)=>{
        const content = (0, $dhzNc.parseString)({
            ignoreTokenTypes: ignoreTokenTypes,
            schema: schema,
            context: context,
            input: raw
        });
        const decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
    const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, $1WGKr.getSurroundingSymbols)(input.substring(position), '{{', '}}');
    return (0, $fhRGb.commonFormatter)(input, position, schema, {
        opening: openingSymbol,
        closing: closingSymbol,
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});

parcelRegister("bl5kn", function(module, exports) {

$parcel$export(module.exports, "quadrupleDashSymbol", () => $8d712c55d42257b6$export$95a7907a71f31921);
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $8d712c55d42257b6$var$MULTI_DASH_REGEX = /^-{4,}(\s|$)/;
const $8d712c55d42257b6$export$95a7907a71f31921 = ({ input: input, position: position })=>{
    // This won't be a ruler because ruler has been checked at leadingKeywordMapping
    const match = input.substring(position).match($8d712c55d42257b6$var$MULTI_DASH_REGEX);
    if (!match) return {
        type: 'text',
        text: '----',
        length: 4
    };
    return {
        type: 'text',
        text: input.substr(position, match[0].length),
        length: match[0].length
    };
};

});

parcelRegister("jJXo9", function(module, exports) {

$parcel$export(module.exports, "ruler", () => $995256ed7c798194$export$f9adada2013e846e);

var $aEQuT = parcelRequire("aEQuT");
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $995256ed7c798194$var$RULER_REGEX = /^-{4,5}(\s|$)/;
const $995256ed7c798194$export$f9adada2013e846e = ({ input: input, position: position, schema: schema })=>{
    const match = input.substring(position).match($995256ed7c798194$var$RULER_REGEX);
    if (match) return {
        type: 'pmnode',
        nodes: (0, $aEQuT.createRuleNode)(schema),
        length: match[0].length
    };
    return {
        type: 'text',
        text: input.substring(position, 1),
        length: 1
    };
};

});
parcelRegister("aEQuT", function(module, exports) {

$parcel$export(module.exports, "createRuleNode", () => $364b894b544f4121$export$4267f2e5716b018a);
const $364b894b544f4121$var$HORIZONTAL_LINE_INSIDE_MACRO = '---';
function $364b894b544f4121$export$2e2bcd8739ae039(schema, containerNodeType) {
    const { paragraph: paragraph, rule: rule } = schema.nodes;
    if (containerNodeType) {
        const textNode = schema.text($364b894b544f4121$var$HORIZONTAL_LINE_INSIDE_MACRO);
        return paragraph.createChecked({}, textNode);
    } else return rule.createChecked();
}
function $364b894b544f4121$export$4267f2e5716b018a(schema) {
    const { rule: rule } = schema.nodes;
    const ruleNode = rule.createChecked();
    return [
        ruleNode
    ];
}

});


parcelRegister("lGhDo", function(module, exports) {

$parcel$export(module.exports, "strong", () => $167d606b9e171d3f$export$59ae2c325a998f89);

var $6eGMp = parcelRequire("6eGMp");

var $1WGKr = parcelRequire("1WGKr");

var $fhRGb = parcelRequire("fhRGb");

var $dhzNc = parcelRequire("dhzNc");
const $167d606b9e171d3f$export$59ae2c325a998f89 = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content of a strong mark
	 */ const ignoreTokenTypes = [
        (0, $6eGMp.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $6eGMp.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $6eGMp.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $6eGMp.TokenType).ISSUE_KEY,
        (0, $6eGMp.TokenType).TABLE
    ];
    // Adding strong mark to all text
    const contentDecorator = (pmNode)=>{
        const mark = schema.marks.strong.create();
        // We don't want to mix `code` mark with others
        if (pmNode.type.name === 'text' && !(0, $1WGKr.hasAnyOfMarks)(pmNode, [
            'strong',
            'code'
        ])) return pmNode.mark([
            ...pmNode.marks,
            mark
        ]);
        return pmNode;
    };
    const rawContentProcessor = (raw, length)=>{
        const content = (0, $dhzNc.parseString)({
            schema: schema,
            context: context,
            ignoreTokenTypes: ignoreTokenTypes,
            input: raw
        });
        const decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
    const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, $1WGKr.getSurroundingSymbols)(input.substring(position), '*', '*');
    return (0, $fhRGb.commonFormatter)(input, position, schema, {
        opening: openingSymbol,
        closing: closingSymbol,
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});

parcelRegister("ivs9h", function(module, exports) {

$parcel$export(module.exports, "subscript", () => $898d22adaf513a8f$export$bc5390e4688d2822);

var $6eGMp = parcelRequire("6eGMp");

var $1WGKr = parcelRequire("1WGKr");

var $fhRGb = parcelRequire("fhRGb");

var $dhzNc = parcelRequire("dhzNc");
const $898d22adaf513a8f$export$bc5390e4688d2822 = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content of a  mark
	 */ const ignoreTokenTypes = [
        (0, $6eGMp.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $6eGMp.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $6eGMp.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $6eGMp.TokenType).ISSUE_KEY,
        (0, $6eGMp.TokenType).TABLE
    ];
    // Adding subsup mark to all text
    const contentDecorator = (n)=>{
        const mark = schema.marks.subsup.create({
            type: 'sub'
        });
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !(0, $1WGKr.hasAnyOfMarks)(n, [
            'subsup',
            'code'
        ])) return n.mark([
            ...n.marks,
            mark
        ]);
        return n;
    };
    const rawContentProcessor = (raw, length)=>{
        const content = (0, $dhzNc.parseString)({
            schema: schema,
            context: context,
            ignoreTokenTypes: ignoreTokenTypes,
            input: raw
        });
        const decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
    const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, $1WGKr.getSurroundingSymbols)(input.substring(position), '~', '~');
    return (0, $fhRGb.commonFormatter)(input, position, schema, {
        opening: openingSymbol,
        closing: closingSymbol,
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});

parcelRegister("jmitX", function(module, exports) {

$parcel$export(module.exports, "superscript", () => $7f9284f78382bbaa$export$b4aab94a5fcfcead);

var $6eGMp = parcelRequire("6eGMp");

var $1WGKr = parcelRequire("1WGKr");

var $fhRGb = parcelRequire("fhRGb");

var $dhzNc = parcelRequire("dhzNc");
const $7f9284f78382bbaa$export$b4aab94a5fcfcead = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content of a  mark
	 */ const ignoreTokenTypes = [
        (0, $6eGMp.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $6eGMp.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $6eGMp.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $6eGMp.TokenType).ISSUE_KEY,
        (0, $6eGMp.TokenType).TABLE
    ];
    // Adding subsup mark to all text
    const contentDecorator = (n)=>{
        const mark = schema.marks.subsup.create({
            type: 'sup'
        });
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !(0, $1WGKr.hasAnyOfMarks)(n, [
            'subsup',
            'code'
        ])) return n.mark([
            ...n.marks,
            mark
        ]);
        return n;
    };
    const rawContentProcessor = (raw, length)=>{
        const content = (0, $dhzNc.parseString)({
            schema: schema,
            context: context,
            ignoreTokenTypes: ignoreTokenTypes,
            input: raw
        });
        const decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
    const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, $1WGKr.getSurroundingSymbols)(input.substring(position), '^', '^');
    return (0, $fhRGb.commonFormatter)(input, position, schema, {
        opening: openingSymbol,
        closing: closingSymbol,
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});

parcelRegister("lp73Q", function(module, exports) {

$parcel$export(module.exports, "table", () => $5485b08cb1b76d1f$export$9852986a3ec5f6a0);

var $czkKR = parcelRequire("czkKR");

var $dhzNc = parcelRequire("dhzNc");

var $fCm0w = parcelRequire("fCm0w");

var $kUybZ = parcelRequire("kUybZ");

var $gMpyu = parcelRequire("gMpyu");

var $2nkrY = parcelRequire("2nkrY");

var $6eGMp = parcelRequire("6eGMp");

var $8215W = parcelRequire("8215W");

var $8o4RP = parcelRequire("8o4RP");

var $1WGKr = parcelRequire("1WGKr");
/*
  The following are currently NOT supported
  1. Macros
  2. Escape |
  3. Table of table
*/ // Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $5485b08cb1b76d1f$var$CELL_REGEXP = /^([ \t]*)([|]+)([ \t]*)/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $5485b08cb1b76d1f$var$EMPTY_LINE_REGEXP = /^[ \t]*\r?\n/;
const $5485b08cb1b76d1f$var$processState = {
    END_TABLE: 2,
    BUFFER: 4,
    CLOSE_ROW: 5,
    NEW_ROW: 6,
    LINE_BREAK: 7,
    LINK: 8,
    MEDIA: 9,
    MACRO: 10,
    EMOJI: 11
};
const $5485b08cb1b76d1f$export$9852986a3ec5f6a0 = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content of a table cell
	 */ const ignoreTokenTypes = [
        (0, $6eGMp.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $6eGMp.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $6eGMp.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $6eGMp.TokenType).TABLE,
        (0, $6eGMp.TokenType).RULER
    ];
    const output = [];
    let index = position;
    let currentState = $5485b08cb1b76d1f$var$processState.NEW_ROW;
    let buffer = [];
    let cellsBuffer = [];
    let cellStyle = '';
    let builder = null;
    while(index < input.length){
        const char = input.charAt(index);
        const substring = input.substring(index);
        switch(currentState){
            case $5485b08cb1b76d1f$var$processState.NEW_ROW:
                {
                    const tableMatch = substring.match($5485b08cb1b76d1f$var$CELL_REGEXP);
                    if (tableMatch) {
                        if (!builder) builder = new (0, $czkKR.TableBuilder)(schema);
                        // Capture empty spaces
                        index += tableMatch[1].length;
                        cellStyle = tableMatch[2];
                        index += tableMatch[2].length;
                        currentState = $5485b08cb1b76d1f$var$processState.BUFFER;
                        continue;
                    }
                    currentState = $5485b08cb1b76d1f$var$processState.END_TABLE;
                    continue;
                }
            case $5485b08cb1b76d1f$var$processState.LINE_BREAK:
                {
                    const emptyLineMatch = substring.match($5485b08cb1b76d1f$var$EMPTY_LINE_REGEXP);
                    if (emptyLineMatch) {
                        // If we encounter an empty line, we should end the table
                        $5485b08cb1b76d1f$var$bufferToCells(cellStyle, buffer.join(''), cellsBuffer, schema, ignoreTokenTypes, context);
                        currentState = $5485b08cb1b76d1f$var$processState.END_TABLE;
                        continue;
                    }
                    // If we enconter a new row
                    const cellMatch = substring.match($5485b08cb1b76d1f$var$CELL_REGEXP);
                    if (cellMatch) currentState = $5485b08cb1b76d1f$var$processState.CLOSE_ROW;
                    else currentState = $5485b08cb1b76d1f$var$processState.BUFFER;
                    continue;
                }
            case $5485b08cb1b76d1f$var$processState.BUFFER:
                {
                    const length = (0, $8215W.parseNewlineOnly)(substring);
                    if (length) {
                        // Calculate the index of the end of the current cell,
                        // upto and including the new line
                        const endIndex = index;
                        // Calculate the index of the start of the current cell
                        const startIndex = input.lastIndexOf('|', endIndex) + 1;
                        const charsBefore = input.substring(startIndex, endIndex);
                        if (charsBefore === '' || charsBefore.match($5485b08cb1b76d1f$var$EMPTY_LINE_REGEXP)) currentState = $5485b08cb1b76d1f$var$processState.CLOSE_ROW;
                        else {
                            currentState = $5485b08cb1b76d1f$var$processState.LINE_BREAK;
                            buffer.push(input.substr(index, length));
                        }
                        index += length;
                        continue;
                    }
                    switch(char){
                        case '|':
                            {
                                // This is now end of a cell, we should wrap the buffer into a cell
                                $5485b08cb1b76d1f$var$bufferToCells(cellStyle, buffer.join(''), cellsBuffer, schema, ignoreTokenTypes, context);
                                buffer = [];
                                // Update cells tyle
                                const cellMatch = substring.match($5485b08cb1b76d1f$var$CELL_REGEXP);
                                // The below if statement should aways be true, we leave it here to prevent any future code changes fall into infinite loop
                                if (cellMatch) {
                                    cellStyle = cellMatch[2];
                                    // Move into the cell content
                                    index += cellMatch[2].length;
                                    continue;
                                }
                                break;
                            }
                        case ':':
                        case ';':
                        case '(':
                            currentState = $5485b08cb1b76d1f$var$processState.EMOJI;
                            continue;
                        case '[':
                            currentState = $5485b08cb1b76d1f$var$processState.LINK;
                            continue;
                        case '!':
                            currentState = $5485b08cb1b76d1f$var$processState.MEDIA;
                            continue;
                        case '{':
                            currentState = $5485b08cb1b76d1f$var$processState.MACRO;
                            continue;
                        default:
                            buffer.push(char);
                            index++;
                            continue;
                    }
                    break;
                }
            case $5485b08cb1b76d1f$var$processState.CLOSE_ROW:
                {
                    const bufferOutput = buffer.join('');
                    if (bufferOutput.trim().length > 0) {
                        $5485b08cb1b76d1f$var$bufferToCells(cellStyle, bufferOutput, cellsBuffer, schema, ignoreTokenTypes, context);
                        buffer = [];
                    }
                    if (builder) {
                        builder.add(cellsBuffer);
                        cellsBuffer = [];
                    }
                    currentState = $5485b08cb1b76d1f$var$processState.NEW_ROW;
                    continue;
                }
            case $5485b08cb1b76d1f$var$processState.END_TABLE:
                if (builder) {
                    if (cellsBuffer.length) builder.add(cellsBuffer);
                    output.push(builder.buildPMNode());
                }
                return {
                    type: 'pmnode',
                    nodes: output,
                    length: index - position
                };
            case $5485b08cb1b76d1f$var$processState.MEDIA:
                {
                    const token = (0, $gMpyu.media)({
                        input: input,
                        schema: schema,
                        context: context,
                        position: index
                    });
                    buffer.push(input.substr(index, token.length));
                    index += token.length;
                    currentState = $5485b08cb1b76d1f$var$processState.BUFFER;
                    continue;
                }
            case $5485b08cb1b76d1f$var$processState.EMOJI:
                {
                    const token = (0, $2nkrY.emoji)({
                        input: input,
                        schema: schema,
                        context: context,
                        position: index
                    });
                    buffer.push(input.substr(index, token.length));
                    index += token.length;
                    currentState = $5485b08cb1b76d1f$var$processState.BUFFER;
                    continue;
                }
            case $5485b08cb1b76d1f$var$processState.LINK:
                {
                    /**
				 * We should "fly over" the link format and we dont want
				 * -awesome [link|https://www.atlass-ian.com] nice
				 * to be a strike through because of the '-' in link
				 */ const token = (0, $kUybZ.linkFormat)({
                        input: input,
                        schema: schema,
                        context: context,
                        position: index
                    });
                    if (token.type === 'text') {
                        buffer.push(token.text);
                        index += token.length;
                        currentState = $5485b08cb1b76d1f$var$processState.BUFFER;
                        continue;
                    } else if (token.type === 'pmnode') {
                        buffer.push(input.substr(index, token.length));
                        index += token.length;
                        currentState = $5485b08cb1b76d1f$var$processState.BUFFER;
                        continue;
                    }
                    break;
                }
            case $5485b08cb1b76d1f$var$processState.MACRO:
                {
                    const match = (0, $8o4RP.parseMacroKeyword)(input.substring(index));
                    if (!match) {
                        buffer.push(char);
                        currentState = $5485b08cb1b76d1f$var$processState.BUFFER;
                        break;
                    }
                    const token = (0, $6eGMp.parseToken)(input, match.type, index, schema, context);
                    buffer.push(input.substr(index, token.length));
                    index += token.length;
                    currentState = $5485b08cb1b76d1f$var$processState.BUFFER;
                    continue;
                }
        }
        index++;
    }
    /**
	 * If there are left over content which didn't have a closing |
	 * For example
	 * |cell1|cell2|cell3
	 * we still want to create a new cell for the last cell3 if it's
	 * not empty.
	 */ const bufferOutput = buffer.join('');
    if (bufferOutput.trim().length > 0) $5485b08cb1b76d1f$var$bufferToCells(cellStyle, bufferOutput, cellsBuffer, schema, ignoreTokenTypes, context);
    if (builder) {
        if (cellsBuffer.length) builder.add(cellsBuffer);
        output.push(builder.buildPMNode());
    }
    return {
        type: 'pmnode',
        nodes: output,
        length: index - position
    };
};
function $5485b08cb1b76d1f$var$bufferToCells(style, buffer, cellsBuffer, schema, ignoreTokenTypes, context) {
    if (buffer.length) {
        let contentNode = (0, $dhzNc.parseString)({
            schema: schema,
            context: context,
            ignoreTokenTypes: ignoreTokenTypes,
            input: buffer
        });
        if (style === '||') contentNode = contentNode.map((e)=>{
            return $5485b08cb1b76d1f$var$createTableHeader(e, schema);
        });
        cellsBuffer.push({
            style: style,
            content: (0, $fCm0w.normalizePMNodes)(contentNode, schema)
        });
    }
}
function $5485b08cb1b76d1f$var$createTableHeader(node, schema) {
    const mark = schema.marks.strong.create();
    return $5485b08cb1b76d1f$var$traverseNodeAndAddMarks(node, mark, schema);
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $5485b08cb1b76d1f$var$traverseContent(node, mark, schema) {
    if (node.content.childCount === 0 || !node.content.child(0) || !node.content.firstChild || node.type.name === 'codeBlock') return node;
    for(let i = 0; i < node.content.childCount; i++){
        const child = node.content.child(i);
        const markedChild = $5485b08cb1b76d1f$var$traverseNodeAndAddMarks(child, mark, schema);
        const updatedContent = node.content.replaceChild(i, markedChild);
        node = node.copy(updatedContent);
    }
    return node;
}
function $5485b08cb1b76d1f$var$traverseNodeAndAddMarks(node, mark, schema) {
    if (node.type.name === 'text' && !(0, $1WGKr.hasAnyOfMarks)(node, [
        'strong',
        'code'
    ])) {
        const newNode = node.mark([
            ...node.marks,
            mark
        ]);
        return newNode;
    }
    return $5485b08cb1b76d1f$var$traverseContent(node, mark, schema);
}

});
parcelRegister("czkKR", function(module, exports) {

$parcel$export(module.exports, "TableBuilder", () => $235ad170768a11f4$export$9e18c07f56f31a89);
/**
 * Return the cell type based on the delimeter
 */ function $235ad170768a11f4$var$getType(style) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return /\|\|/.test(style) ? 'tableHeader' : 'tableCell';
}
class $235ad170768a11f4$export$9e18c07f56f31a89 {
    constructor(schema){
        this.emptyTableCell = ()=>{
            const { tableCell: tableCell, paragraph: paragraph } = this.schema.nodes;
            return tableCell.createChecked({}, paragraph.createChecked());
        };
        this.emptyTableRow = ()=>{
            const { tableRow: tableRow } = this.schema.nodes;
            return tableRow.createChecked({}, this.emptyTableCell());
        };
        /**
	 * Build prosemirror table node
	 * @returns {PMNode}
	 */ this.buildTableNode = ()=>{
            const { root: root } = this;
            const { table: table } = this.schema.nodes;
            const content = root.rows.map(this.buildTableRowNode);
            if (content.length === 0) content.push(this.emptyTableRow());
            return table.createChecked({}, content);
        };
        /**
	 * Build prosemirror tr node
	 * @returns {PMNode}
	 */ this.buildTableRowNode = (row)=>{
            const { tableRow: tableRow } = this.schema.nodes;
            return tableRow.createChecked({}, row.cells.map(this.buildTableCellNode));
        };
        /**
	 * Build prosemirror td/th node
	 * @param {TableCell} cell
	 * @returns {PMNode}
	 */ this.buildTableCellNode = (cell)=>{
            const { type: type, content: content } = cell;
            if (content.length === 0) content.push(this.schema.nodes.paragraph.createChecked());
            const cellNode = this.schema.nodes[type];
            return cellNode.createChecked({}, content);
        };
        this.schema = schema;
        this.root = {
            rows: []
        };
    }
    /**
	 * Return the type of the base element
	 * @returns {string}
	 */ get type() {
        return 'table';
    }
    /**
	 * Add new cells to the table
	 * @param {AddCellArgs[]} cells
	 */ add(cells) {
        if (!cells.length) return;
        // Iterate the cells and create TH/TD based on the delimeter
        let index = 0;
        for (const cell of cells){
            const { content: content, style: style } = cell;
            const cellType = $235ad170768a11f4$var$getType(style);
            // For the first item, determine if it's a new row or not
            if (index === 0) this.addRow();
            const newCell = {
                type: cellType,
                content: content
            };
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            this.lastRow.cells.push(newCell);
            index += 1;
        }
    }
    /**
	 * Build a prosemirror table from the data
	 * @returns {PMNode}
	 */ buildPMNode() {
        return this.buildTableNode();
    }
    /**
	 * Add a new row to the table
	 */ addRow() {
        const { rows: rows } = this.root;
        const row = {
            cells: []
        };
        rows.push(row);
        this.lastRow = row;
    }
}

});


parcelRegister("1wKJY", function(module, exports) {

$parcel$export(module.exports, "tripleDashSymbol", () => $a6cd56b361fb5de0$export$edbcd749367de060);

var $bpFts = parcelRequire("bpFts");
const $a6cd56b361fb5de0$var$token = {
    type: 'text',
    text: '\u2014',
    length: 3
};
const $a6cd56b361fb5de0$var$fallback = {
    ...$a6cd56b361fb5de0$var$token,
    text: '---'
};
const $a6cd56b361fb5de0$export$edbcd749367de060 = (0, $bpFts.createDashTokenParser)($a6cd56b361fb5de0$var$token, $a6cd56b361fb5de0$var$fallback);

});

parcelRegister("kTQgu", function(module, exports) {

$parcel$export(module.exports, "panelMacro", () => $5e3c516f79242606$export$5d7bf7e31a674541);

var $5z9yB = parcelRequire("5z9yB");

var $dhzNc = parcelRequire("dhzNc");

var $dV4GB = parcelRequire("dV4GB");

var $fCm0w = parcelRequire("fCm0w");

var $b2b2Q = parcelRequire("b2b2Q");

var $igAce = parcelRequire("igAce");
const $5e3c516f79242606$var$allowedNodeType = [
    'paragraph',
    'heading',
    'orderedList',
    'bulletList'
];
const $5e3c516f79242606$export$5d7bf7e31a674541 = ({ input: input, position: position, schema: schema, context: context })=>{
    return (0, $5z9yB.commonMacro)(input.substring(position), schema, {
        keyword: 'panel',
        paired: true,
        context: context,
        rawContentProcessor: $5e3c516f79242606$var$rawContentProcessor
    });
};
const $5e3c516f79242606$var$rawContentProcessor = (rawAttrs, rawContent, length, schema, context)=>{
    const output = [];
    const parsedAttrs = (0, $dV4GB.parseAttrs)(rawAttrs);
    const nodeAttrs = {
        ...parsedAttrs,
        panelType: (0, $b2b2Q.getPanelType)(parsedAttrs)
    };
    const parsedContent = (0, $dhzNc.parseString)({
        schema: schema,
        context: context,
        ignoreTokenTypes: [],
        input: rawContent
    });
    const normalizedContent = (0, $fCm0w.normalizePMNodes)(parsedContent, schema);
    let contentBuffer = parsedAttrs.title ? [
        (0, $igAce.title)(parsedAttrs.title, schema)
    ] : [];
    for (const n of normalizedContent)if ($5e3c516f79242606$var$allowedNodeType.indexOf(n.type.name) !== -1) contentBuffer.push(n);
    else {
        const panelNode = schema.nodes.panel.createChecked(nodeAttrs, contentBuffer.length ? contentBuffer : schema.nodes.paragraph.createChecked());
        contentBuffer = [];
        output.push(panelNode);
        output.push(n);
    }
    if (contentBuffer.length > 0) {
        const panelNode = schema.nodes.panel.createChecked(nodeAttrs, contentBuffer);
        output.push(panelNode);
    }
    return {
        type: 'pmnode',
        nodes: output.length ? output : [
            $5e3c516f79242606$var$emptyPanel(schema)
        ],
        length: length
    };
};
function $5e3c516f79242606$var$emptyPanel(schema) {
    const p = schema.nodes.paragraph.createChecked();
    return schema.nodes.panel.createChecked({}, p);
}

});
parcelRegister("b2b2Q", function(module, exports) {

$parcel$export(module.exports, "getPanelType", () => $d3dab73f3b28534e$export$fa00fa3d6c22a747);

var $eOrG3 = parcelRequire("eOrG3");
const $d3dab73f3b28534e$var$COLOR_TYPE_REGEX = {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    hexShort: /^#?([a-f\d])([a-f\d])([a-f\d])$/i,
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    hexLong: /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i,
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    rgb: /^#?rgb\((\d+),\s*(\d+),\s*(\d+)\)$/,
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    prgb: /^#?rgb\((\d+)%,\s*(\d+)%,\s*(\d+)%\)$/
};
const $d3dab73f3b28534e$var$PANEL_TYPE_TO_RGB = {
    info: {
        r: 222,
        g: 235,
        b: 255
    },
    note: {
        r: 234,
        g: 230,
        b: 255
    },
    success: {
        r: 227,
        g: 252,
        b: 239
    },
    warning: {
        r: 255,
        g: 250,
        b: 230
    },
    error: {
        r: 255,
        g: 235,
        b: 230
    }
};
function $d3dab73f3b28534e$export$fa00fa3d6c22a747(attrs) {
    const rgb = $d3dab73f3b28534e$var$generateRgb(attrs.bgColor);
    if (!rgb) return 'info';
    let mapTo = 'info';
    let smallestDistance = Infinity;
    Object.keys($d3dab73f3b28534e$var$PANEL_TYPE_TO_RGB).forEach((panelType)=>{
        const distance = $d3dab73f3b28534e$var$distanceOfRgb($d3dab73f3b28534e$var$PANEL_TYPE_TO_RGB[panelType], rgb);
        if (distance < smallestDistance) {
            smallestDistance = distance;
            mapTo = panelType;
        }
    });
    return mapTo;
}
function $d3dab73f3b28534e$var$distanceOfRgb(a, b) {
    // https://en.wikipedia.org/wiki/Color_difference
    return Math.pow(a.r - b.r, 2) + Math.pow(a.g - b.g, 2) + Math.pow(a.b - b.b, 2);
}
function $d3dab73f3b28534e$var$generateRgb(color) {
    switch(true){
        case $d3dab73f3b28534e$var$COLOR_TYPE_REGEX.hexShort.test(color) || $d3dab73f3b28534e$var$COLOR_TYPE_REGEX.hexLong.test(color):
            return $d3dab73f3b28534e$var$parseHex(color);
        case $d3dab73f3b28534e$var$COLOR_TYPE_REGEX.rgb.test(color):
            return $d3dab73f3b28534e$var$parseRgb(color);
        case $d3dab73f3b28534e$var$COLOR_TYPE_REGEX.prgb.test(color):
            return $d3dab73f3b28534e$var$parsePrgb(color);
        default:
            return $d3dab73f3b28534e$var$parseColorName(color);
    }
}
function $d3dab73f3b28534e$var$parseHex(hex) {
    // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
    hex = hex.replace($d3dab73f3b28534e$var$COLOR_TYPE_REGEX.hexShort, (_m, r, g, b)=>{
        return r + r + g + g + b + b;
    });
    const result = $d3dab73f3b28534e$var$COLOR_TYPE_REGEX.hexLong.exec(hex);
    return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    } : null;
}
function $d3dab73f3b28534e$var$parseRgb(rgb) {
    const result = rgb.match($d3dab73f3b28534e$var$COLOR_TYPE_REGEX.rgb);
    return result ? {
        r: parseInt(result[1], 10),
        g: parseInt(result[2], 10),
        b: parseInt(result[3], 10)
    } : null;
}
function $d3dab73f3b28534e$var$parsePrgb(prgb) {
    const result = prgb.match($d3dab73f3b28534e$var$COLOR_TYPE_REGEX.prgb);
    return result ? {
        r: Math.floor(255 * parseInt(result[1], 10) / 100),
        g: Math.floor(255 * parseInt(result[2], 10) / 100),
        b: Math.floor(255 * parseInt(result[4], 10) / 100)
    } : null;
}
function $d3dab73f3b28534e$var$parseColorName(color) {
    return (0, $eOrG3.default)[color];
}

});
parcelRegister("eOrG3", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b65c497afba79dc$export$2e2bcd8739ae039);
const $5b65c497afba79dc$var$mapping = {
    crimson: {
        r: 220,
        g: 20,
        b: 60
    },
    lightpink: {
        r: 255,
        g: 182,
        b: 193
    },
    pink: {
        r: 255,
        g: 192,
        b: 203
    },
    palevioletred: {
        r: 219,
        g: 112,
        b: 147
    },
    lavenderblush: {
        r: 255,
        g: 240,
        b: 245
    },
    hotpink: {
        r: 255,
        g: 105,
        b: 180
    },
    deeppink: {
        r: 255,
        g: 20,
        b: 147
    },
    mediumvioletred: {
        r: 199,
        g: 21,
        b: 133
    },
    orchid: {
        r: 218,
        g: 112,
        b: 214
    },
    thistle: {
        r: 216,
        g: 191,
        b: 216
    },
    plum: {
        r: 221,
        g: 160,
        b: 221
    },
    violet: {
        r: 238,
        g: 130,
        b: 238
    },
    fuchsia: {
        r: 255,
        g: 0,
        b: 255
    },
    darkmagenta: {
        r: 139,
        g: 0,
        b: 139
    },
    purple: {
        r: 128,
        g: 0,
        b: 128
    },
    mediumorchid: {
        r: 186,
        g: 85,
        b: 211
    },
    darkviolet: {
        r: 148,
        g: 0,
        b: 211
    },
    darkorchid: {
        r: 153,
        g: 50,
        b: 204
    },
    indigo: {
        r: 75,
        g: 0,
        b: 130
    },
    blueviolet: {
        r: 138,
        g: 43,
        b: 226
    },
    mediumpurple: {
        r: 147,
        g: 112,
        b: 219
    },
    darkslateblue: {
        r: 72,
        g: 61,
        b: 139
    },
    mediumslateblue: {
        r: 123,
        g: 104,
        b: 238
    },
    slateblue: {
        r: 106,
        g: 90,
        b: 205
    },
    ghostwhite: {
        r: 248,
        g: 248,
        b: 255
    },
    lavender: {
        r: 230,
        g: 230,
        b: 250
    },
    blue: {
        r: 0,
        g: 0,
        b: 255
    },
    mediumblue: {
        r: 0,
        g: 0,
        b: 205
    },
    darkblue: {
        r: 0,
        g: 0,
        b: 139
    },
    navy: {
        r: 0,
        g: 0,
        b: 128
    },
    midnightblue: {
        r: 25,
        g: 25,
        b: 112
    },
    royalblue: {
        r: 65,
        g: 105,
        b: 225
    },
    cornflowerblue: {
        r: 100,
        g: 149,
        b: 237
    },
    lightsteelblue: {
        r: 176,
        g: 196,
        b: 222
    },
    lightslategray: {
        r: 119,
        g: 136,
        b: 153
    },
    slategray: {
        r: 112,
        g: 128,
        b: 144
    },
    dodgerblue: {
        r: 30,
        g: 144,
        b: 255
    },
    aliceblue: {
        r: 240,
        g: 248,
        b: 255
    },
    steelblue: {
        r: 70,
        g: 130,
        b: 180
    },
    lightskyblue: {
        r: 135,
        g: 206,
        b: 250
    },
    skyblue: {
        r: 135,
        g: 206,
        b: 235
    },
    deepskyblue: {
        r: 0,
        g: 191,
        b: 255
    },
    lightblue: {
        r: 173,
        g: 216,
        b: 230
    },
    powderblue: {
        r: 176,
        g: 224,
        b: 230
    },
    cadetblue: {
        r: 95,
        g: 158,
        b: 160
    },
    darkturquoise: {
        r: 0,
        g: 206,
        b: 209
    },
    azure: {
        r: 240,
        g: 255,
        b: 255
    },
    lightcyan: {
        r: 224,
        g: 255,
        b: 255
    },
    paleturquoise: {
        r: 174,
        g: 238,
        b: 238
    },
    darkslategray: {
        r: 47,
        g: 79,
        b: 79
    },
    aqua: {
        r: 0,
        g: 255,
        b: 255
    },
    darkcyan: {
        r: 0,
        g: 139,
        b: 139
    },
    teal: {
        r: 0,
        g: 128,
        b: 128
    },
    mediumturquoise: {
        r: 72,
        g: 209,
        b: 204
    },
    lightseagreen: {
        r: 32,
        g: 178,
        b: 170
    },
    turquoise: {
        r: 64,
        g: 224,
        b: 208
    },
    aquamarine: {
        r: 127,
        g: 255,
        b: 212
    },
    mediumaquamarine: {
        r: 102,
        g: 205,
        b: 170
    },
    mediumspringgreen: {
        r: 0,
        g: 250,
        b: 154
    },
    mintcream: {
        r: 245,
        g: 255,
        b: 250
    },
    springgreen: {
        r: 0,
        g: 255,
        b: 127
    },
    mediumseagreen: {
        r: 60,
        g: 179,
        b: 113
    },
    seagreen: {
        r: 46,
        g: 139,
        b: 87
    },
    honeydew: {
        r: 240,
        g: 255,
        b: 240
    },
    darkseagreen: {
        r: 143,
        g: 188,
        b: 143
    },
    palegreen: {
        r: 152,
        g: 251,
        b: 152
    },
    lightgreen: {
        r: 144,
        g: 238,
        b: 144
    },
    limegreen: {
        r: 50,
        g: 205,
        b: 50
    },
    forestgreen: {
        r: 34,
        g: 139,
        b: 34
    },
    lime: {
        r: 0,
        g: 255,
        b: 0
    },
    green: {
        r: 0,
        g: 128,
        b: 0
    },
    darkgreen: {
        r: 0,
        g: 100,
        b: 0
    },
    lawngreen: {
        r: 124,
        g: 252,
        b: 0
    },
    chartreuse: {
        r: 127,
        g: 255,
        b: 0
    },
    greenyellow: {
        r: 173,
        g: 255,
        b: 47
    },
    darkolivegreen: {
        r: 85,
        g: 107,
        b: 47
    },
    olivedrab: {
        r: 107,
        g: 142,
        b: 35
    },
    yellowgreen: {
        r: 154,
        g: 205,
        b: 50
    },
    ivory: {
        r: 255,
        g: 255,
        b: 240
    },
    beige: {
        r: 245,
        g: 245,
        b: 220
    },
    lightyellow: {
        r: 255,
        g: 255,
        b: 224
    },
    lightgoldenrodyellow: {
        r: 250,
        g: 250,
        b: 210
    },
    yellow: {
        r: 255,
        g: 255,
        b: 0
    },
    olive: {
        r: 128,
        g: 128,
        b: 0
    },
    darkkhaki: {
        r: 189,
        g: 183,
        b: 107
    },
    khaki: {
        r: 240,
        g: 230,
        b: 140
    },
    palegoldenrod: {
        r: 238,
        g: 232,
        b: 170
    },
    lemonchiffon: {
        r: 255,
        g: 250,
        b: 205
    },
    gold: {
        r: 255,
        g: 215,
        b: 0
    },
    cornsilk: {
        r: 255,
        g: 248,
        b: 220
    },
    goldenrod: {
        r: 218,
        g: 165,
        b: 32
    },
    darkgoldenrod: {
        r: 184,
        g: 134,
        b: 11
    },
    orange: {
        r: 255,
        g: 128,
        b: 0
    },
    floralwhite: {
        r: 255,
        g: 250,
        b: 240
    },
    oldlace: {
        r: 253,
        g: 245,
        b: 230
    },
    wheat: {
        r: 245,
        g: 222,
        b: 179
    },
    moccasin: {
        r: 255,
        g: 228,
        b: 181
    },
    papayawhip: {
        r: 255,
        g: 239,
        b: 213
    },
    blanchedalmond: {
        r: 255,
        g: 235,
        b: 205
    },
    navajowhite: {
        r: 255,
        g: 222,
        b: 173
    },
    tan: {
        r: 210,
        g: 180,
        b: 140
    },
    antiquewhite: {
        r: 250,
        g: 235,
        b: 215
    },
    burlywood: {
        r: 222,
        g: 184,
        b: 135
    },
    bisque: {
        r: 255,
        g: 228,
        b: 196
    },
    darkorange: {
        r: 255,
        g: 140,
        b: 0
    },
    peru: {
        r: 205,
        g: 133,
        b: 63
    },
    linen: {
        r: 250,
        g: 240,
        b: 230
    },
    peachpuff: {
        r: 255,
        g: 218,
        b: 185
    },
    seashell: {
        r: 255,
        g: 245,
        b: 238
    },
    sandybrown: {
        r: 244,
        g: 164,
        b: 96
    },
    chocolate: {
        r: 210,
        g: 105,
        b: 30
    },
    saddlebrown: {
        r: 139,
        g: 69,
        b: 19
    },
    sienna: {
        r: 160,
        g: 82,
        b: 45
    },
    lightsalmon: {
        r: 255,
        g: 160,
        b: 122
    },
    coral: {
        r: 255,
        g: 127,
        b: 80
    },
    orangered: {
        r: 255,
        g: 69,
        b: 0
    },
    darksalmon: {
        r: 233,
        g: 150,
        b: 122
    },
    tomato: {
        r: 255,
        g: 99,
        b: 71
    },
    salmon: {
        r: 250,
        g: 128,
        b: 114
    },
    mistyrose: {
        r: 255,
        g: 228,
        b: 225
    },
    snow: {
        r: 255,
        g: 250,
        b: 250
    },
    rosybrown: {
        r: 188,
        g: 143,
        b: 143
    },
    lightcoral: {
        r: 240,
        g: 128,
        b: 128
    },
    indianred: {
        r: 205,
        g: 92,
        b: 92
    },
    brown: {
        r: 165,
        g: 42,
        b: 42
    },
    firebrick: {
        r: 178,
        g: 34,
        b: 34
    },
    red: {
        r: 255,
        g: 0,
        b: 0
    },
    darkred: {
        r: 139,
        g: 0,
        b: 0
    },
    maroon: {
        r: 128,
        g: 0,
        b: 0
    },
    white: {
        r: 255,
        g: 255,
        b: 255
    },
    gainsboro: {
        r: 220,
        g: 220,
        b: 220
    },
    lightgray: {
        r: 211,
        g: 211,
        b: 211
    },
    silver: {
        r: 192,
        g: 192,
        b: 192
    },
    darkgray: {
        r: 169,
        g: 169,
        b: 169
    },
    gray: {
        r: 128,
        g: 128,
        b: 128
    },
    dimgray: {
        r: 105,
        g: 105,
        b: 105
    },
    black: {
        r: 0,
        g: 0,
        b: 0
    },
    whitesmoke: {
        r: 245,
        g: 245,
        b: 245
    }
};
var $5b65c497afba79dc$export$2e2bcd8739ae039 = $5b65c497afba79dc$var$mapping;

});


parcelRegister("igAce", function(module, exports) {

$parcel$export(module.exports, "title", () => $aa17e0c3708027fe$export$fb184b623420d9be);
function $aa17e0c3708027fe$export$fb184b623420d9be(text, schema) {
    const mark = schema.marks.strong.create();
    const title = schema.text(text, [
        mark
    ]);
    return schema.nodes.paragraph.createChecked({}, [
        title
    ]);
}

});


parcelRegister("5p9sl", function(module, exports) {

$parcel$export(module.exports, "adfMacro", () => $559fecd7b4f7a552$export$8fb4b58db8f664fb);

var $5z9yB = parcelRequire("5z9yB");
const $559fecd7b4f7a552$export$8fb4b58db8f664fb = ({ input: input, position: position, schema: schema, context: context })=>{
    return (0, $5z9yB.commonMacro)(input.substring(position), schema, {
        keyword: 'adf',
        paired: true,
        context: context,
        rawContentProcessor: $559fecd7b4f7a552$var$rawContentProcessor
    });
};
const $559fecd7b4f7a552$var$rawContentProcessor = (_rawAttrs, rawContent, length, schema, _context)=>{
    try {
        const json = JSON.parse(rawContent);
        const node = schema.nodeFromJSON(json);
        return {
            type: 'pmnode',
            nodes: [
                node
            ],
            length: length
        };
    } catch (_e) {
        const textContent = `Invalid ADF Macro: ${rawContent}`;
        const textNode = rawContent.length ? schema.text(textContent) : undefined;
        const { codeBlock: codeBlock } = schema.nodes;
        const node = codeBlock.create({
            language: undefined
        }, textNode);
        return {
            type: 'pmnode',
            nodes: [
                node
            ],
            length: length
        };
    }
};

});

parcelRegister("iTZfs", function(module, exports) {

$parcel$export(module.exports, "anchorMacro", () => $74f99b5c92410a29$export$e660dadc21580fa2);

var $5z9yB = parcelRequire("5z9yB");
const $74f99b5c92410a29$export$e660dadc21580fa2 = ({ input: input, position: position, schema: schema, context: context })=>{
    return (0, $5z9yB.commonMacro)(input.substring(position), schema, {
        keyword: 'anchor',
        paired: false,
        context: context,
        rawContentProcessor: $74f99b5c92410a29$var$rawContentProcessor
    });
};
const $74f99b5c92410a29$var$rawContentProcessor = (_rawAttrs, _rawContent, length, _schema, _context)=>{
    return {
        type: 'text',
        text: '',
        length: length
    };
};

});

parcelRegister("cvIOA", function(module, exports) {

$parcel$export(module.exports, "codeMacro", () => $3574b6d0567a6cbd$export$db6c131ac26c7700);

var $5z9yB = parcelRequire("5z9yB");

var $dV4GB = parcelRequire("dV4GB");

var $igAce = parcelRequire("igAce");
const $3574b6d0567a6cbd$var$SUPPORTED_CODEBOCK_LANGUAGES = [
    'abap',
    'actionscript',
    'ada',
    'arduino',
    'autoit',
    'c',
    'c++',
    'clojure',
    'coffeescript',
    'csharp',
    'css',
    'cuda',
    'd',
    'dart',
    'delphi',
    'elixir',
    'erlang',
    'fortran',
    'foxpro',
    'go',
    'groovy',
    'haskell',
    'haxe',
    'html',
    'java',
    'javascript',
    'json',
    'julia',
    'kotlin',
    'latex',
    'livescript',
    'lua',
    'mathematica',
    'matlab',
    'objective-c',
    'objective-j',
    'objectpascal',
    'ocaml',
    'octave',
    'perl',
    'php',
    'powershell',
    'prolog',
    'puppet',
    'python',
    'qml',
    'r',
    'racket',
    'restructuredtext',
    'ruby',
    'rust',
    'sass',
    'scala',
    'scheme',
    'shell',
    'smalltalk',
    'sql',
    'standardml',
    'swift',
    'tcl',
    'tex',
    'typescript',
    'vala',
    'vbnet',
    'verilog',
    'vhdl',
    'xml',
    'xquery'
];
const $3574b6d0567a6cbd$export$db6c131ac26c7700 = ({ input: input, position: position, schema: schema, context: context })=>{
    return (0, $5z9yB.commonMacro)(input.substring(position), schema, {
        keyword: 'code',
        paired: true,
        context: context,
        rawContentProcessor: $3574b6d0567a6cbd$var$rawContentProcessor
    });
};
const $3574b6d0567a6cbd$var$rawContentProcessor = (rawAttrs, rawContent, length, schema)=>{
    const output = [];
    const { codeBlock: codeBlock } = schema.nodes;
    const parsedAttrs = (0, $dV4GB.parseAttrs)(rawAttrs);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const trimedContent = rawContent.replace(/^\s+|\s+$/g, '');
    const textNode = trimedContent.length ? schema.text(trimedContent) : undefined;
    if (parsedAttrs.title) output.push((0, $igAce.title)(parsedAttrs.title, schema));
    const nodeAttrs = {
        ...parsedAttrs,
        language: $3574b6d0567a6cbd$var$getCodeLanguage(parsedAttrs)
    };
    output.push(codeBlock.createChecked(nodeAttrs, textNode));
    return {
        type: 'pmnode',
        nodes: output,
        length: length
    };
};
function $3574b6d0567a6cbd$var$getCodeLanguage(attrs) {
    const keys = Object.keys(attrs).map((key)=>key.toLowerCase());
    for (const language of $3574b6d0567a6cbd$var$SUPPORTED_CODEBOCK_LANGUAGES){
        if (keys.indexOf(language) !== -1) return language;
    }
    if (keys.indexOf('objc') !== -1) return 'objective-c';
    return 'java';
}

});

parcelRegister("uOwOo", function(module, exports) {

$parcel$export(module.exports, "colorMacro", () => $de2bf45389b7e855$export$b557be495948d995);

var $6eGMp = parcelRequire("6eGMp");

var $5z9yB = parcelRequire("5z9yB");

var $dV4GB = parcelRequire("dV4GB");

var $dhzNc = parcelRequire("dhzNc");

var $fQLvH = parcelRequire("fQLvH");

var $1WGKr = parcelRequire("1WGKr");
const $de2bf45389b7e855$export$b557be495948d995 = ({ input: input, position: position, schema: schema, context: context })=>{
    return (0, $5z9yB.commonMacro)(input.substring(position), schema, {
        keyword: 'color',
        paired: true,
        context: context,
        rawContentProcessor: $de2bf45389b7e855$var$rawContentProcessor
    });
};
const $de2bf45389b7e855$var$rawContentProcessor = (rawAttrs, rawContent, length, schema, context)=>{
    // Removed ISSUE_KEY for https://getsupport.atlassian.com/browse/MOVE-1738018
    // Issue keys were not being migrated correctly if they were inside the color macro.
    const ignoreTokenTypes = [
        (0, $6eGMp.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $6eGMp.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $6eGMp.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $6eGMp.TokenType).TABLE
    ];
    const parsedAttrs = (0, $dV4GB.parseAttrs)(rawAttrs);
    const content = (0, $dhzNc.parseString)({
        ignoreTokenTypes: ignoreTokenTypes,
        schema: schema,
        context: context,
        input: rawContent
    });
    const decoratedContent = content.map((n)=>{
        const mark = schema.marks.textColor.create({
            color: (0, $fQLvH.getEditorColor)(parsedAttrs) || '#000000'
        });
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !(0, $1WGKr.hasAnyOfMarks)(n, [
            'textColor',
            'code'
        ])) return n.mark([
            ...n.marks,
            mark
        ]);
        return n;
    });
    return {
        type: 'pmnode',
        nodes: decoratedContent,
        length: length
    };
};

});
parcelRegister("fQLvH", function(module, exports) {

$parcel$export(module.exports, "getEditorColor", () => $5a7368e34948fb41$export$c0cfc6f23e0b7578);

var $51dYk = parcelRequire("51dYk");
function $5a7368e34948fb41$export$c0cfc6f23e0b7578(attrs) {
    const keys = Object.keys(attrs);
    return (0, $51dYk.normalizeHexColor)(keys[0]);
}

});


parcelRegister("7uwJx", function(module, exports) {

$parcel$export(module.exports, "noformatMacro", () => $18dfaae2bead55a6$export$9199752eb9b2d5b4);

var $5z9yB = parcelRequire("5z9yB");

var $dV4GB = parcelRequire("dV4GB");

var $igAce = parcelRequire("igAce");
const $18dfaae2bead55a6$export$9199752eb9b2d5b4 = ({ input: input, position: position, schema: schema, context: context })=>{
    return (0, $5z9yB.commonMacro)(input.substring(position), schema, {
        keyword: 'noformat',
        paired: true,
        context: context,
        rawContentProcessor: $18dfaae2bead55a6$var$rawContentProcessor
    });
};
const $18dfaae2bead55a6$var$rawContentProcessor = (rawAttrs, rawContent, length, schema, _context)=>{
    const output = [];
    const { codeBlock: codeBlock } = schema.nodes;
    const parsedAttrs = (0, $dV4GB.parseAttrs)(rawAttrs);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const trimedContent = rawContent.replace(/^\s+|\s+$/g, '');
    const textNode = trimedContent.length ? schema.text(trimedContent) : undefined;
    if (parsedAttrs.title) output.push((0, $igAce.title)(parsedAttrs.title, schema));
    output.push(codeBlock.createChecked({}, textNode));
    return {
        type: 'pmnode',
        nodes: output,
        length: length
    };
};

});

parcelRegister("4Oxfk", function(module, exports) {

$parcel$export(module.exports, "forceLineBreak", () => $025978418d33039b$export$2de3d7fd25cbc36);
/**
 * Jira is using the following regex to match force line break
 * private static final Pattern FORCE_NEWLINE = Pattern.compile("(?<!\\\\)\\\\{2}(?!\\S*\\\\)");
 */ // Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $025978418d33039b$var$FORCE_LINE_BREAK_REGEX = /^\\{2}(?!\S*\\)/;
const $025978418d33039b$export$2de3d7fd25cbc36 = ({ input: input, position: position, schema: schema })=>{
    if (position > 0) {
        const charBefore = input.charAt(position - 1);
        if (charBefore === '\\') return $025978418d33039b$var$fallback(input, position);
    }
    const match = input.substring(position).match($025978418d33039b$var$FORCE_LINE_BREAK_REGEX);
    if (match) return {
        type: 'pmnode',
        nodes: [
            schema.nodes.hardBreak.createChecked()
        ],
        length: 2
    };
    return $025978418d33039b$var$fallback(input, position);
};
function $025978418d33039b$var$fallback(input, position) {
    return {
        type: 'text',
        text: input.substr(position, 2),
        length: 2
    };
}

});



parcelRegister("fzBOR", function(module, exports) {

$parcel$export(module.exports, "code", () => $42154a3c17ce006a$export$6565f9f03506010b);
const $42154a3c17ce006a$export$6565f9f03506010b = (text)=>{
    return `{{${text}}}`;
};

});

parcelRegister("6buUG", function(module, exports) {

$parcel$export(module.exports, "textColor", () => $1451bc812d6b91fd$export$32f78bffcd82ff28);
const $1451bc812d6b91fd$export$32f78bffcd82ff28 = (text, attrs)=>{
    return `{color:${attrs.color}}${text}{color}`;
};

});

parcelRegister("iYqCx", function(module, exports) {

$parcel$export(module.exports, "em", () => $04352c21aff3e351$export$c63c6f932822f543);

var $7grvE = parcelRequire("7grvE");
const $04352c21aff3e351$export$c63c6f932822f543 = (text)=>{
    if (text.startsWith("\u2014 ")) // This is a citation
    return (0, $7grvE.baseMarkPattern)(text.substring(2), '??');
    return (0, $7grvE.baseMarkPattern)(text, '_');
};

});
parcelRegister("7grvE", function(module, exports) {

$parcel$export(module.exports, "baseMarkPattern", () => $d4104010fe88fa49$export$3d8aed7830783c75);
/**
 * For text that has leading and ending space. We don't want to
 * convert it to `* strong *. Instead, we need it to be ` *strong* `
 */ const $d4104010fe88fa49$export$3d8aed7830783c75 = (text, token)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    if (/^\s*$/.test(text)) /**
		 * If it's a string with only whitespaces, wiki renderer
		 * will behave incorrect if we apply format on it
		 */ return text;
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return text.replace(/^\s*/, `$&${token}`).replace(/\s*$/, `${token}$&`);
};

});


parcelRegister("1Nw9m", function(module, exports) {

$parcel$export(module.exports, "link", () => $64f1e6288df88d4e$export$9c30223ca0a664fb);
const $64f1e6288df88d4e$export$9c30223ca0a664fb = (text, attrs)=>{
    return `[${text}|${attrs.href}]`;
};

});

parcelRegister("acg2R", function(module, exports) {

$parcel$export(module.exports, "strike", () => $84dcde05935f416f$export$4899a95d70ec5056);

var $7grvE = parcelRequire("7grvE");
const $84dcde05935f416f$export$4899a95d70ec5056 = (text)=>{
    return (0, $7grvE.baseMarkPattern)(text, '-');
};

});

parcelRegister("bD4xF", function(module, exports) {

$parcel$export(module.exports, "strong", () => $6e63ab7e29547740$export$59ae2c325a998f89);

var $7grvE = parcelRequire("7grvE");
const $6e63ab7e29547740$export$59ae2c325a998f89 = (text)=>{
    return (0, $7grvE.baseMarkPattern)(text, '*');
};

});

parcelRegister("1NAvE", function(module, exports) {

$parcel$export(module.exports, "subsup", () => $d1931fbdb7823663$export$b3401ee80eb31041);

var $7grvE = parcelRequire("7grvE");
const $d1931fbdb7823663$export$b3401ee80eb31041 = (text, attrs)=>{
    if (attrs.type === 'sub') return (0, $7grvE.baseMarkPattern)(text, '~');
    else return (0, $7grvE.baseMarkPattern)(text, '^');
};

});

parcelRegister("fy5C0", function(module, exports) {

$parcel$export(module.exports, "underline", () => $aa36c7f2c5fc2ce7$export$425327af25286e5e);

var $7grvE = parcelRequire("7grvE");
const $aa36c7f2c5fc2ce7$export$425327af25286e5e = (text)=>{
    return (0, $7grvE.baseMarkPattern)(text, '+');
};

});


parcelRegister("cQf6S", function(module, exports) {

$parcel$export(module.exports, "inlineCard", () => $1e1642d7e8d13d61$export$cbf8224b64e0d942);

var $dU28O = parcelRequire("dU28O");

var $7Bypb = parcelRequire("7Bypb");
const $1e1642d7e8d13d61$export$cbf8224b64e0d942 = (node)=>{
    if (!node.attrs.url) return (0, $dU28O.unknown)(node);
    const match = node.attrs.url.match((0, $7Bypb.INLINE_CARD_FROM_TEXT_STAMP));
    if (!match) return `[${node.attrs.url}|${node.attrs.url}|smart-link]`;
    return `[${match[2]}]`;
};

});

parcelRegister("9wDTJ", function(module, exports) {

$parcel$export(module.exports, "status", () => $566d6761c6b581d9$export$471f7ae5c4103ae1);

var $6buUG = parcelRequire("6buUG");

const $566d6761c6b581d9$var$color = {
    grey: (0, $7bb4c1736002a04a$export$eaa8c8a70ac22806),
    purple: (0, $7bb4c1736002a04a$export$b48405b95304b5a1),
    blue: (0, $7bb4c1736002a04a$export$9dc1ef0f3f48059b),
    red: (0, $7bb4c1736002a04a$export$4a7404f376229999),
    yellow: (0, $7bb4c1736002a04a$export$59619663aa6500fb),
    green: (0, $7bb4c1736002a04a$export$940e1f69e873f202)
};
const $566d6761c6b581d9$export$471f7ae5c4103ae1 = (node)=>{
    const text = `*[ ${node.attrs.text.toUpperCase()} ]*`;
    const newAttrs = {
        ...node.attrs
    };
    if ($566d6761c6b581d9$var$color[node.attrs.color]) newAttrs.color = $566d6761c6b581d9$var$color[node.attrs.color];
    else newAttrs.color = $566d6761c6b581d9$var$color['grey'];
    return (0, $6buUG.textColor)(text, newAttrs);
};

});
var $7bb4c1736002a04a$exports = {};

$parcel$export($7bb4c1736002a04a$exports, "R50", () => $7bb4c1736002a04a$export$4b84fd0e2c617bd);
$parcel$export($7bb4c1736002a04a$exports, "R75", () => $7bb4c1736002a04a$export$b34b069eff244586);
$parcel$export($7bb4c1736002a04a$exports, "R100", () => $7bb4c1736002a04a$export$be802dd0d8b57f35);
$parcel$export($7bb4c1736002a04a$exports, "R200", () => $7bb4c1736002a04a$export$60847d42f9da92a6);
$parcel$export($7bb4c1736002a04a$exports, "R300", () => $7bb4c1736002a04a$export$4a7404f376229999);
$parcel$export($7bb4c1736002a04a$exports, "R400", () => $7bb4c1736002a04a$export$2010d0fb4295b346);
$parcel$export($7bb4c1736002a04a$exports, "R500", () => $7bb4c1736002a04a$export$2837b5a1a71d5c02);
$parcel$export($7bb4c1736002a04a$exports, "Y50", () => $7bb4c1736002a04a$export$8d9596b529bbb9cf);
$parcel$export($7bb4c1736002a04a$exports, "Y75", () => $7bb4c1736002a04a$export$41060a744ab0b7ae);
$parcel$export($7bb4c1736002a04a$exports, "Y100", () => $7bb4c1736002a04a$export$1cc05bbbf340e559);
$parcel$export($7bb4c1736002a04a$exports, "Y200", () => $7bb4c1736002a04a$export$5aae31392d72caaa);
$parcel$export($7bb4c1736002a04a$exports, "Y300", () => $7bb4c1736002a04a$export$c6930421db9fa514);
$parcel$export($7bb4c1736002a04a$exports, "Y400", () => $7bb4c1736002a04a$export$59619663aa6500fb);
$parcel$export($7bb4c1736002a04a$exports, "Y500", () => $7bb4c1736002a04a$export$874739ea9e379ab6);
$parcel$export($7bb4c1736002a04a$exports, "G50", () => $7bb4c1736002a04a$export$8a6341c32b6a3ee6);
$parcel$export($7bb4c1736002a04a$exports, "G75", () => $7bb4c1736002a04a$export$69a3bf21b9686c2b);
$parcel$export($7bb4c1736002a04a$exports, "G100", () => $7bb4c1736002a04a$export$afbce1382ec95f73);
$parcel$export($7bb4c1736002a04a$exports, "G200", () => $7bb4c1736002a04a$export$747d86715d4175de);
$parcel$export($7bb4c1736002a04a$exports, "G300", () => $7bb4c1736002a04a$export$940e1f69e873f202);
$parcel$export($7bb4c1736002a04a$exports, "G400", () => $7bb4c1736002a04a$export$a49394138f7b8e85);
$parcel$export($7bb4c1736002a04a$exports, "G500", () => $7bb4c1736002a04a$export$6fa04827ac68a4fb);
$parcel$export($7bb4c1736002a04a$exports, "B50", () => $7bb4c1736002a04a$export$226de0355ed012f8);
$parcel$export($7bb4c1736002a04a$exports, "B75", () => $7bb4c1736002a04a$export$8c13c2ee36917869);
$parcel$export($7bb4c1736002a04a$exports, "B100", () => $7bb4c1736002a04a$export$ecfc1dff386a3e7a);
$parcel$export($7bb4c1736002a04a$exports, "B200", () => $7bb4c1736002a04a$export$215b7063051591f1);
$parcel$export($7bb4c1736002a04a$exports, "B300", () => $7bb4c1736002a04a$export$e62e8919cca44969);
$parcel$export($7bb4c1736002a04a$exports, "B400", () => $7bb4c1736002a04a$export$b3de0ae08da2ce64);
$parcel$export($7bb4c1736002a04a$exports, "B500", () => $7bb4c1736002a04a$export$a6ee3d71bc067634);
$parcel$export($7bb4c1736002a04a$exports, "B600", () => $7bb4c1736002a04a$export$67f15409e87642a1);
$parcel$export($7bb4c1736002a04a$exports, "B700", () => $7bb4c1736002a04a$export$f0539dbc42dbb067);
$parcel$export($7bb4c1736002a04a$exports, "P50", () => $7bb4c1736002a04a$export$363e4475840015bb);
$parcel$export($7bb4c1736002a04a$exports, "P75", () => $7bb4c1736002a04a$export$4b0a4417ed59760f);
$parcel$export($7bb4c1736002a04a$exports, "P100", () => $7bb4c1736002a04a$export$6011520a64d9a187);
$parcel$export($7bb4c1736002a04a$exports, "P200", () => $7bb4c1736002a04a$export$a7175d4e9206bc80);
$parcel$export($7bb4c1736002a04a$exports, "P300", () => $7bb4c1736002a04a$export$b48405b95304b5a1);
$parcel$export($7bb4c1736002a04a$exports, "P400", () => $7bb4c1736002a04a$export$c71e4279dd54a18d);
$parcel$export($7bb4c1736002a04a$exports, "P500", () => $7bb4c1736002a04a$export$147899de772240ec);
$parcel$export($7bb4c1736002a04a$exports, "T50", () => $7bb4c1736002a04a$export$2cf711fe14c66f06);
$parcel$export($7bb4c1736002a04a$exports, "T75", () => $7bb4c1736002a04a$export$7a8f4d33f6f9772c);
$parcel$export($7bb4c1736002a04a$exports, "T100", () => $7bb4c1736002a04a$export$776c9c497ef08533);
$parcel$export($7bb4c1736002a04a$exports, "T200", () => $7bb4c1736002a04a$export$69cb3ca10c1e330e);
$parcel$export($7bb4c1736002a04a$exports, "T300", () => $7bb4c1736002a04a$export$9dc1ef0f3f48059b);
$parcel$export($7bb4c1736002a04a$exports, "T400", () => $7bb4c1736002a04a$export$7c835c78b6fcdef8);
$parcel$export($7bb4c1736002a04a$exports, "T500", () => $7bb4c1736002a04a$export$6036577f95c3877e);
$parcel$export($7bb4c1736002a04a$exports, "N0", () => $7bb4c1736002a04a$export$29a4f05edc054374);
$parcel$export($7bb4c1736002a04a$exports, "N10", () => $7bb4c1736002a04a$export$e655ef011c4aa1a2);
$parcel$export($7bb4c1736002a04a$exports, "N20", () => $7bb4c1736002a04a$export$9fdfb749e33cdf97);
$parcel$export($7bb4c1736002a04a$exports, "N30", () => $7bb4c1736002a04a$export$3e51e8f1440314ba);
$parcel$export($7bb4c1736002a04a$exports, "N40", () => $7bb4c1736002a04a$export$1ce2d1575d444ceb);
$parcel$export($7bb4c1736002a04a$exports, "N50", () => $7bb4c1736002a04a$export$8754fc7e6d8b3000);
$parcel$export($7bb4c1736002a04a$exports, "N60", () => $7bb4c1736002a04a$export$c2e91cbeada39b8b);
$parcel$export($7bb4c1736002a04a$exports, "N70", () => $7bb4c1736002a04a$export$5f71e19f3a7ad9de);
$parcel$export($7bb4c1736002a04a$exports, "N80", () => $7bb4c1736002a04a$export$eaa8c8a70ac22806);
$parcel$export($7bb4c1736002a04a$exports, "N90", () => $7bb4c1736002a04a$export$7c87d337fb91a97d);
$parcel$export($7bb4c1736002a04a$exports, "N100", () => $7bb4c1736002a04a$export$d6447c357493214f);
$parcel$export($7bb4c1736002a04a$exports, "N200", () => $7bb4c1736002a04a$export$f563ee71e9ee74cd);
$parcel$export($7bb4c1736002a04a$exports, "N300", () => $7bb4c1736002a04a$export$e2ef2124cf4024b1);
$parcel$export($7bb4c1736002a04a$exports, "N400", () => $7bb4c1736002a04a$export$eece5f492e429f08);
$parcel$export($7bb4c1736002a04a$exports, "N500", () => $7bb4c1736002a04a$export$c39c0fe0f26207ae);
$parcel$export($7bb4c1736002a04a$exports, "N600", () => $7bb4c1736002a04a$export$7090862dc3038a9f);
$parcel$export($7bb4c1736002a04a$exports, "N700", () => $7bb4c1736002a04a$export$ad0bacf983b7ddaa);
$parcel$export($7bb4c1736002a04a$exports, "N800", () => $7bb4c1736002a04a$export$7d61b15e0da132af);
$parcel$export($7bb4c1736002a04a$exports, "N900", () => $7bb4c1736002a04a$export$fbda843f0a27fe96);
$parcel$export($7bb4c1736002a04a$exports, "N10A", () => $7bb4c1736002a04a$export$791e57b27ca738ef);
$parcel$export($7bb4c1736002a04a$exports, "N20A", () => $7bb4c1736002a04a$export$8d43898f60b96a82);
$parcel$export($7bb4c1736002a04a$exports, "N30A", () => $7bb4c1736002a04a$export$920c0d5c49070351);
$parcel$export($7bb4c1736002a04a$exports, "N40A", () => $7bb4c1736002a04a$export$46987b49aab6d1a8);
$parcel$export($7bb4c1736002a04a$exports, "N50A", () => $7bb4c1736002a04a$export$7d3359664e8bb0e5);
$parcel$export($7bb4c1736002a04a$exports, "N60A", () => $7bb4c1736002a04a$export$d2d3bedfb276cac0);
$parcel$export($7bb4c1736002a04a$exports, "N70A", () => $7bb4c1736002a04a$export$6e5e7499ff054f6d);
$parcel$export($7bb4c1736002a04a$exports, "N80A", () => $7bb4c1736002a04a$export$59264b346c877fa7);
$parcel$export($7bb4c1736002a04a$exports, "N90A", () => $7bb4c1736002a04a$export$d092757d7c64925c);
$parcel$export($7bb4c1736002a04a$exports, "N100A", () => $7bb4c1736002a04a$export$486ab785e4bac3c6);
$parcel$export($7bb4c1736002a04a$exports, "N200A", () => $7bb4c1736002a04a$export$fba592bbc6419fea);
$parcel$export($7bb4c1736002a04a$exports, "N300A", () => $7bb4c1736002a04a$export$13609db0e6812ab8);
$parcel$export($7bb4c1736002a04a$exports, "N400A", () => $7bb4c1736002a04a$export$fbae4efaa892d883);
$parcel$export($7bb4c1736002a04a$exports, "N500A", () => $7bb4c1736002a04a$export$f13946d26f440ce6);
$parcel$export($7bb4c1736002a04a$exports, "N600A", () => $7bb4c1736002a04a$export$19f58225ac52a306);
$parcel$export($7bb4c1736002a04a$exports, "N700A", () => $7bb4c1736002a04a$export$6384f09da70e7b62);
$parcel$export($7bb4c1736002a04a$exports, "N800A", () => $7bb4c1736002a04a$export$d0dccc730683edc2);
$parcel$export($7bb4c1736002a04a$exports, "DN900", () => $7bb4c1736002a04a$export$2f6319cf7d736c2a);
$parcel$export($7bb4c1736002a04a$exports, "DN800", () => $7bb4c1736002a04a$export$95126bc8884d6634);
$parcel$export($7bb4c1736002a04a$exports, "DN700", () => $7bb4c1736002a04a$export$8338d8c35d44ff1);
$parcel$export($7bb4c1736002a04a$exports, "DN600", () => $7bb4c1736002a04a$export$5368d76ae4fbbda7);
$parcel$export($7bb4c1736002a04a$exports, "DN500", () => $7bb4c1736002a04a$export$9f0a771d16ec8d36);
$parcel$export($7bb4c1736002a04a$exports, "DN400", () => $7bb4c1736002a04a$export$abcf8c38338b4aa5);
$parcel$export($7bb4c1736002a04a$exports, "DN300", () => $7bb4c1736002a04a$export$97e81faa16a182c7);
$parcel$export($7bb4c1736002a04a$exports, "DN200", () => $7bb4c1736002a04a$export$bfe21c59123ecf33);
$parcel$export($7bb4c1736002a04a$exports, "DN100", () => $7bb4c1736002a04a$export$ee82aa2ea6a1558);
$parcel$export($7bb4c1736002a04a$exports, "DN90", () => $7bb4c1736002a04a$export$682927c6ed76be02);
$parcel$export($7bb4c1736002a04a$exports, "DN80", () => $7bb4c1736002a04a$export$91fd9994c5be9757);
$parcel$export($7bb4c1736002a04a$exports, "DN70", () => $7bb4c1736002a04a$export$d281fbfe3cff2df6);
$parcel$export($7bb4c1736002a04a$exports, "DN60", () => $7bb4c1736002a04a$export$3902c91d8b98a753);
$parcel$export($7bb4c1736002a04a$exports, "DN50", () => $7bb4c1736002a04a$export$8e8133c1ba5845b5);
$parcel$export($7bb4c1736002a04a$exports, "DN40", () => $7bb4c1736002a04a$export$33ff357f6620b39);
$parcel$export($7bb4c1736002a04a$exports, "DN30", () => $7bb4c1736002a04a$export$633847cf062b69e0);
$parcel$export($7bb4c1736002a04a$exports, "DN20", () => $7bb4c1736002a04a$export$9776a6e503bdbf76);
$parcel$export($7bb4c1736002a04a$exports, "DN10", () => $7bb4c1736002a04a$export$6c813d5160dff5db);
$parcel$export($7bb4c1736002a04a$exports, "DN0", () => $7bb4c1736002a04a$export$3d4f271a500072a);
$parcel$export($7bb4c1736002a04a$exports, "DN800A", () => $7bb4c1736002a04a$export$fe151285c22759ec);
$parcel$export($7bb4c1736002a04a$exports, "DN700A", () => $7bb4c1736002a04a$export$a101c6190d0da34);
$parcel$export($7bb4c1736002a04a$exports, "DN600A", () => $7bb4c1736002a04a$export$4b16f52932fda51);
$parcel$export($7bb4c1736002a04a$exports, "DN500A", () => $7bb4c1736002a04a$export$a74bcd7b9845b0d8);
$parcel$export($7bb4c1736002a04a$exports, "DN400A", () => $7bb4c1736002a04a$export$9209c179316d1751);
$parcel$export($7bb4c1736002a04a$exports, "DN300A", () => $7bb4c1736002a04a$export$88f55133f636c8dd);
$parcel$export($7bb4c1736002a04a$exports, "DN200A", () => $7bb4c1736002a04a$export$51126f85d1009512);
$parcel$export($7bb4c1736002a04a$exports, "DN100A", () => $7bb4c1736002a04a$export$a069b547bd23af78);
$parcel$export($7bb4c1736002a04a$exports, "DN90A", () => $7bb4c1736002a04a$export$40cce05af3b2600a);
$parcel$export($7bb4c1736002a04a$exports, "DN80A", () => $7bb4c1736002a04a$export$b78942185925a0d);
$parcel$export($7bb4c1736002a04a$exports, "DN70A", () => $7bb4c1736002a04a$export$e058fb44b8eaafca);
$parcel$export($7bb4c1736002a04a$exports, "DN60A", () => $7bb4c1736002a04a$export$92b0b8de26920c18);
$parcel$export($7bb4c1736002a04a$exports, "DN50A", () => $7bb4c1736002a04a$export$67564f7459d3fc9e);
$parcel$export($7bb4c1736002a04a$exports, "DN40A", () => $7bb4c1736002a04a$export$77868e1ca884ffa3);
$parcel$export($7bb4c1736002a04a$exports, "DN30A", () => $7bb4c1736002a04a$export$2afd71d7d3ea2cd5);
$parcel$export($7bb4c1736002a04a$exports, "DN20A", () => $7bb4c1736002a04a$export$f2a0acaab9972c70);
$parcel$export($7bb4c1736002a04a$exports, "DN10A", () => $7bb4c1736002a04a$export$9ab70e67d6475361);
$parcel$export($7bb4c1736002a04a$exports, "T30", () => $7bb4c1736002a04a$export$d2adc5dedf09fced);
$parcel$export($7bb4c1736002a04a$exports, "L50", () => $7bb4c1736002a04a$export$f51762073d2bb381);
$parcel$export($7bb4c1736002a04a$exports, "L75", () => $7bb4c1736002a04a$export$95e26d54def96891);
// Reds
const $7bb4c1736002a04a$export$4b84fd0e2c617bd = '#FFEBE6';
const $7bb4c1736002a04a$export$b34b069eff244586 = '#FFBDAD';
const $7bb4c1736002a04a$export$be802dd0d8b57f35 = '#FF8F73';
const $7bb4c1736002a04a$export$60847d42f9da92a6 = '#FF7452';
const $7bb4c1736002a04a$export$4a7404f376229999 = '#FF5630';
const $7bb4c1736002a04a$export$2010d0fb4295b346 = '#DE350B';
const $7bb4c1736002a04a$export$2837b5a1a71d5c02 = '#BF2600';
const $7bb4c1736002a04a$export$8d9596b529bbb9cf = '#FFFAE6';
const $7bb4c1736002a04a$export$41060a744ab0b7ae = '#FFF0B3';
const $7bb4c1736002a04a$export$1cc05bbbf340e559 = '#FFE380';
const $7bb4c1736002a04a$export$5aae31392d72caaa = '#FFC400';
const $7bb4c1736002a04a$export$c6930421db9fa514 = '#FFAB00';
const $7bb4c1736002a04a$export$59619663aa6500fb = '#FF991F';
const $7bb4c1736002a04a$export$874739ea9e379ab6 = '#FF8B00';
const $7bb4c1736002a04a$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $7bb4c1736002a04a$export$69a3bf21b9686c2b = '#ABF5D1';
const $7bb4c1736002a04a$export$afbce1382ec95f73 = '#79F2C0';
const $7bb4c1736002a04a$export$747d86715d4175de = '#57D9A3';
const $7bb4c1736002a04a$export$940e1f69e873f202 = '#36B37E';
const $7bb4c1736002a04a$export$a49394138f7b8e85 = '#00875A';
const $7bb4c1736002a04a$export$6fa04827ac68a4fb = '#006644';
const $7bb4c1736002a04a$export$226de0355ed012f8 = '#DEEBFF';
const $7bb4c1736002a04a$export$8c13c2ee36917869 = '#B3D4FF';
const $7bb4c1736002a04a$export$ecfc1dff386a3e7a = '#4C9AFF';
const $7bb4c1736002a04a$export$215b7063051591f1 = '#2684FF';
const $7bb4c1736002a04a$export$e62e8919cca44969 = '#0065FF';
const $7bb4c1736002a04a$export$b3de0ae08da2ce64 = '#0052CC';
const $7bb4c1736002a04a$export$a6ee3d71bc067634 = '#0747A6';
const $7bb4c1736002a04a$export$67f15409e87642a1 = '#669DF1';
const $7bb4c1736002a04a$export$f0539dbc42dbb067 = '#8FB8F6';
const $7bb4c1736002a04a$export$363e4475840015bb = '#EAE6FF';
const $7bb4c1736002a04a$export$4b0a4417ed59760f = '#C0B6F2';
const $7bb4c1736002a04a$export$6011520a64d9a187 = '#998DD9';
const $7bb4c1736002a04a$export$a7175d4e9206bc80 = '#8777D9';
const $7bb4c1736002a04a$export$b48405b95304b5a1 = '#6554C0';
const $7bb4c1736002a04a$export$c71e4279dd54a18d = '#5243AA';
const $7bb4c1736002a04a$export$147899de772240ec = '#403294';
const $7bb4c1736002a04a$export$2cf711fe14c66f06 = '#E6FCFF';
const $7bb4c1736002a04a$export$7a8f4d33f6f9772c = '#B3F5FF';
const $7bb4c1736002a04a$export$776c9c497ef08533 = '#79E2F2';
const $7bb4c1736002a04a$export$69cb3ca10c1e330e = '#00C7E6';
const $7bb4c1736002a04a$export$9dc1ef0f3f48059b = '#00B8D9';
const $7bb4c1736002a04a$export$7c835c78b6fcdef8 = '#00A3BF';
const $7bb4c1736002a04a$export$6036577f95c3877e = '#008DA6';
const $7bb4c1736002a04a$export$29a4f05edc054374 = '#FFFFFF';
const $7bb4c1736002a04a$export$e655ef011c4aa1a2 = '#FAFBFC';
const $7bb4c1736002a04a$export$9fdfb749e33cdf97 = '#F4F5F7';
const $7bb4c1736002a04a$export$3e51e8f1440314ba = '#EBECF0';
const $7bb4c1736002a04a$export$1ce2d1575d444ceb = '#DFE1E6';
const $7bb4c1736002a04a$export$8754fc7e6d8b3000 = '#C1C7D0';
const $7bb4c1736002a04a$export$c2e91cbeada39b8b = '#B3BAC5';
const $7bb4c1736002a04a$export$5f71e19f3a7ad9de = '#A5ADBA';
const $7bb4c1736002a04a$export$eaa8c8a70ac22806 = '#97A0AF';
const $7bb4c1736002a04a$export$7c87d337fb91a97d = '#8993A4';
const $7bb4c1736002a04a$export$d6447c357493214f = '#7A869A';
const $7bb4c1736002a04a$export$f563ee71e9ee74cd = '#6B778C';
const $7bb4c1736002a04a$export$e2ef2124cf4024b1 = '#5E6C84';
const $7bb4c1736002a04a$export$eece5f492e429f08 = '#505F79';
const $7bb4c1736002a04a$export$c39c0fe0f26207ae = '#42526E';
const $7bb4c1736002a04a$export$7090862dc3038a9f = '#344563';
const $7bb4c1736002a04a$export$ad0bacf983b7ddaa = '#253858';
const $7bb4c1736002a04a$export$7d61b15e0da132af = '#172B4D';
const $7bb4c1736002a04a$export$fbda843f0a27fe96 = '#091E42';
const $7bb4c1736002a04a$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $7bb4c1736002a04a$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $7bb4c1736002a04a$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $7bb4c1736002a04a$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $7bb4c1736002a04a$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $7bb4c1736002a04a$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $7bb4c1736002a04a$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $7bb4c1736002a04a$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $7bb4c1736002a04a$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $7bb4c1736002a04a$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $7bb4c1736002a04a$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $7bb4c1736002a04a$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $7bb4c1736002a04a$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $7bb4c1736002a04a$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $7bb4c1736002a04a$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $7bb4c1736002a04a$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $7bb4c1736002a04a$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $7bb4c1736002a04a$export$2f6319cf7d736c2a = '#E6EDFA';
const $7bb4c1736002a04a$export$95126bc8884d6634 = '#DCE5F5';
const $7bb4c1736002a04a$export$8338d8c35d44ff1 = '#CED9EB';
const $7bb4c1736002a04a$export$5368d76ae4fbbda7 = '#B8C7E0';
const $7bb4c1736002a04a$export$9f0a771d16ec8d36 = '#ABBBD6';
const $7bb4c1736002a04a$export$abcf8c38338b4aa5 = '#9FB0CC';
const $7bb4c1736002a04a$export$97e81faa16a182c7 = '#8C9CB8';
const $7bb4c1736002a04a$export$bfe21c59123ecf33 = '#7988A3';
const $7bb4c1736002a04a$export$ee82aa2ea6a1558 = '#67758F';
const $7bb4c1736002a04a$export$682927c6ed76be02 = '#56637A';
const $7bb4c1736002a04a$export$91fd9994c5be9757 = '#455166';
const $7bb4c1736002a04a$export$d281fbfe3cff2df6 = '#3B475C';
const $7bb4c1736002a04a$export$3902c91d8b98a753 = '#313D52';
const $7bb4c1736002a04a$export$8e8133c1ba5845b5 = '#283447';
const $7bb4c1736002a04a$export$33ff357f6620b39 = '#202B3D';
const $7bb4c1736002a04a$export$633847cf062b69e0 = '#1B2638';
const $7bb4c1736002a04a$export$9776a6e503bdbf76 = '#121A29';
const $7bb4c1736002a04a$export$6c813d5160dff5db = '#0E1624';
const $7bb4c1736002a04a$export$3d4f271a500072a = '#0D1424';
const $7bb4c1736002a04a$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $7bb4c1736002a04a$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $7bb4c1736002a04a$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $7bb4c1736002a04a$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $7bb4c1736002a04a$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $7bb4c1736002a04a$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $7bb4c1736002a04a$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $7bb4c1736002a04a$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $7bb4c1736002a04a$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $7bb4c1736002a04a$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $7bb4c1736002a04a$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $7bb4c1736002a04a$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $7bb4c1736002a04a$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $7bb4c1736002a04a$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $7bb4c1736002a04a$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $7bb4c1736002a04a$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $7bb4c1736002a04a$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $7bb4c1736002a04a$export$d2adc5dedf09fced = '#292A2E';
const $7bb4c1736002a04a$export$f51762073d2bb381 = '#94C748';
const $7bb4c1736002a04a$export$95e26d54def96891 = '#B3DF72';


parcelRegister("lCUKb", function(module, exports) {

$parcel$export(module.exports, "date", () => $9b740dd689445824$export$324d90190a8b822a);
const $9b740dd689445824$export$324d90190a8b822a = (node)=>{
    const addLeadingZero = (val)=>{
        if (val < 10) return `0${val}`;
        return val;
    };
    const result = new Date(Number(node.attrs.timestamp));
    return `{{${result.getUTCFullYear()}-${addLeadingZero(result.getUTCMonth() + 1)}-${addLeadingZero(result.getUTCDate())}}}`;
};

});



parcelRegister("5VDmd", function(module, exports) {

$parcel$export(module.exports, "codeBlock", () => $9ac55407d8612889$export$7bb0d5c671655cc4);

var $k9glG = parcelRequire("k9glG");
const $9ac55407d8612889$var$supportedLanguageInWiki = [
    'actionscript',
    'ada',
    'applescript',
    'bash',
    'c',
    'c#',
    'c++',
    'cpp',
    'css',
    'erlang',
    'go',
    'groovy',
    'haskell',
    'html',
    'java',
    'javascript',
    'js',
    'json',
    'lua',
    'none',
    'nyan',
    'objc',
    'perl',
    'php',
    'python',
    'r',
    'rainbow',
    'ruby',
    'scala',
    'sh',
    'sql',
    'swift',
    'visualbasic',
    'xml',
    'yaml'
];
const $9ac55407d8612889$export$7bb0d5c671655cc4 = (node)=>{
    let result = '';
    node.forEach((n)=>{
        result += (0, $k9glG.inlines)(n, {
            parent: node
        });
    });
    if ($9ac55407d8612889$var$supportedLanguageInWiki.indexOf(node.attrs.language) !== -1) return `{code:${node.attrs.language}}${result}{code}`;
    else return `{noformat}${result}{noformat}`;
};

});

parcelRegister("dVCxi", function(module, exports) {

$parcel$export(module.exports, "mediaGroup", () => $ebebb1344f541e78$export$2855e964765eac9);

var $4KRVw = parcelRequire("4KRVw");

var $8O04F = parcelRequire("8O04F");

var $dU28O = parcelRequire("dU28O");
const $ebebb1344f541e78$export$2855e964765eac9 = (node, opts = {})=>{
    const result = [];
    node.forEach((n)=>{
        switch(n.type.name){
            case 'media':
                result.push((0, $8O04F.media)(n, {
                    ...opts,
                    parent: node
                }));
                break;
            case 'caption':
                result.push((0, $4KRVw.caption)(n, opts));
                break;
            default:
                result.push((0, $dU28O.unknown)(n));
                break;
        }
    });
    return result.join('\n');
};

});
parcelRegister("4KRVw", function(module, exports) {

$parcel$export(module.exports, "caption", () => $af02be4902789fb9$export$8e3c2dfdc4f0453d);

var $k9glG = parcelRequire("k9glG");
const $af02be4902789fb9$export$8e3c2dfdc4f0453d = (node, { context: context } = {})=>{
    let result = '';
    node.forEach((n)=>{
        result += (0, $k9glG.inlines)(n, {
            context: context
        });
    });
    return result;
};

});

parcelRegister("8O04F", function(module, exports) {

$parcel$export(module.exports, "media", () => $3071da261f155449$export$987d49ffe1b0900f);
const $3071da261f155449$export$987d49ffe1b0900f = (node, { context: context, parent: parent } = {})=>{
    const wikiAttrs = [];
    // Parent width takes precedence over internal dimension attributes
    if (parent && parent.attrs.width) // Parent width is defined in percents
    wikiAttrs.push(`width=${parent.attrs.width}%`);
    else {
        if (node.attrs.width) wikiAttrs.push(`width=${node.attrs.width}`);
        if (node.attrs.height) wikiAttrs.push(`height=${node.attrs.height}`);
    }
    if (node.attrs.alt) wikiAttrs.push(`alt="${node.attrs.alt}"`);
    if (node.marks.length) {
        const linkMark = node.marks.find((mark)=>mark.type.name === 'link');
        if (linkMark) wikiAttrs.push(`href="${linkMark?.attrs.href}"`);
    }
    let fileName;
    if (node.attrs.type === 'external') fileName = node.attrs.url;
    else fileName = context?.conversion?.mediaConversion?.[node.attrs.id]?.transform ?? node.attrs.id;
    if (context?.conversion?.mediaConversion?.[node.attrs.id]?.embed === false) return `[^${fileName}]`;
    if (wikiAttrs.length) return `!${fileName}|${wikiAttrs.join(',')}!`;
    // default to thumbnail if no width or height is set
    return `!${fileName}|thumbnail!`;
};

});




parcelRegister("jcd8q", function(module, exports) {

$parcel$export(module.exports, "taskList", () => $83eabc62b7fe88a5$export$375b6afcc5f4d291);

var $2BYEZ = parcelRequire("2BYEZ");
const $83eabc62b7fe88a5$var$nestedNode = (node, depth = 1)=>{
    const result = [];
    node.forEach((item)=>{
        if (item.type.name === 'taskList') result.push($83eabc62b7fe88a5$var$nestedNode(item, depth + 1));
        else result.push((0, $2BYEZ.taskItem)(item, depth));
    });
    return result.join('\n');
};
const $83eabc62b7fe88a5$export$375b6afcc5f4d291 = (node)=>{
    return $83eabc62b7fe88a5$var$nestedNode(node);
};

});
parcelRegister("2BYEZ", function(module, exports) {

$parcel$export(module.exports, "taskItem", () => $9ca5d49206b661e0$export$6d8b0ef52e2e6390);

var $k9glG = parcelRequire("k9glG");
const $9ca5d49206b661e0$export$6d8b0ef52e2e6390 = (node, nestedLevel, { context: context } = {})=>{
    let result = '';
    node.forEach((n)=>{
        // Generate stars based on depth
        const prefix = Array(nestedLevel).fill('*').join('');
        if (node.attrs.state === 'DONE') result += `${prefix} -${(0, $k9glG.inlines)(n, {
            context: context
        })}-`;
        else result += `${prefix} ${(0, $k9glG.inlines)(n, {
            context: context
        })}`;
    });
    return result;
};

});


parcelRegister("cXLg9", function(module, exports) {

$parcel$export(module.exports, "decisionList", () => $65fcfcb52ab042ad$export$62d45a65fb43d95e);

var $l72eV = parcelRequire("l72eV");
const $65fcfcb52ab042ad$export$62d45a65fb43d95e = (node)=>{
    const result = [];
    node.forEach((item)=>{
        result.push((0, $l72eV.decisionItem)(item));
    });
    return result.join('\n');
};

});
parcelRegister("l72eV", function(module, exports) {

$parcel$export(module.exports, "decisionItem", () => $55bfdc8eb8a33aba$export$6959e16eeff859b4);

var $k9glG = parcelRequire("k9glG");
const $55bfdc8eb8a33aba$export$6959e16eeff859b4 = (node, { context: context } = {})=>{
    let result = '';
    node.forEach((n)=>{
        result += `* <> ${(0, $k9glG.inlines)(n, {
            context: context
        })}`;
    });
    return result;
};

});


parcelRegister("1yHJY", function(module, exports) {

$parcel$export(module.exports, "doc", () => $4fb0ef8538ca80f0$export$2a111da947c407d2);

var $5MLoD = parcelRequire("5MLoD");
const $4fb0ef8538ca80f0$export$2a111da947c407d2 = (node, { context: context } = {})=>{
    const result = [];
    node.forEach((n)=>{
        result.push((0, $5MLoD.encode)(n, context));
    });
    return result.join('\n\n');
};

});

parcelRegister("fSFQG", function(module, exports) {

$parcel$export(module.exports, "expand", () => $d015d7cd58cdfac3$export$9f77e0932fb78f72);

var $5MLoD = parcelRequire("5MLoD");
const $d015d7cd58cdfac3$export$9f77e0932fb78f72 = (node, { context: context } = {})=>{
    // Title of expand appears as a bold text, followed by empty line
    const result = [
        `*${node.attrs.title}*`,
        ''
    ];
    node.forEach((n)=>{
        result.push((0, $5MLoD.encode)(n, context));
    });
    return result.join('\n');
};

});

parcelRegister("iudS0", function(module, exports) {

$parcel$export(module.exports, "heading", () => $54d424c64527d422$export$46e4a324ac90507f);

var $k9glG = parcelRequire("k9glG");
const $54d424c64527d422$export$46e4a324ac90507f = (node)=>{
    let result = '';
    node.forEach((n)=>{
        result += (0, $k9glG.inlines)(n);
    });
    return `h${node.attrs.level}. ${result}`;
};

});

parcelRegister("kqHGX", function(module, exports) {

$parcel$export(module.exports, "orderedList", () => $833269e0e0e2a7f6$export$a5dc81035676e7a);

var $lfeRz = parcelRequire("lfeRz");
const $833269e0e0e2a7f6$export$a5dc81035676e7a = (node, { context: context } = {})=>{
    const result = [];
    node.forEach((item)=>{
        result.push((0, $lfeRz.listItem)(item, '#', context));
    });
    return result.join('\n');
};

});

parcelRegister("gStGs", function(module, exports) {

$parcel$export(module.exports, "panel", () => $5d21bd5c09176e13$export$21f42ab9b6679f44);

var $5MLoD = parcelRequire("5MLoD");
const $5d21bd5c09176e13$var$panelTypeColorMapping = {
    info: '#deebff',
    note: '#eae6ff',
    success: '#e3fcef',
    warning: '#fffae6',
    error: '#ffebe6'
};
const $5d21bd5c09176e13$export$21f42ab9b6679f44 = (node, { context: context } = {})=>{
    const result = [];
    node.forEach((n)=>{
        result.push((0, $5MLoD.encode)(n, context));
    });
    return `{panel:bgColor=${$5d21bd5c09176e13$var$panelTypeColorMapping[node.attrs.panelType] || ''}}
${result.join('\n\n')}
{panel}`;
};

});

parcelRegister("1axEu", function(module, exports) {

$parcel$export(module.exports, "rule", () => $aa5f812f0e71fb41$export$fbeb3a3956e8a3c7);
const $aa5f812f0e71fb41$export$fbeb3a3956e8a3c7 = (_node)=>{
    return '----';
};

});

parcelRegister("2X1OA", function(module, exports) {

$parcel$export(module.exports, "table", () => $2f0b818c15dc8899$export$9852986a3ec5f6a0);

var $5MLoD = parcelRequire("5MLoD");

var $dU28O = parcelRequire("dU28O");
const $2f0b818c15dc8899$export$9852986a3ec5f6a0 = (node, opts = {})=>{
    try {
        const result = [];
        node.forEach((n)=>{
            result.push($2f0b818c15dc8899$var$tableRow(n, opts));
        });
        return result.join('\n');
    } catch (err) {
        return (0, $dU28O.unknown)(node);
    }
};
const $2f0b818c15dc8899$var$tableRow = (node, opts = {})=>{
    let result = '';
    let separator = '|';
    node.forEach((n)=>{
        if (n.type.name === 'tableHeader') separator = '||';
        else separator = '|';
        result = `${result}${separator}${$2f0b818c15dc8899$var$tableCell(n, opts)}`;
    });
    return `${result}${separator}`;
};
const $2f0b818c15dc8899$var$tableCell = (node, { context: context } = {})=>{
    if ($2f0b818c15dc8899$var$hasMergedCell(node)) // This is an advanced table
    throw new Error('Advanced feature of table is not supported');
    const result = [];
    node.forEach((n)=>{
        result.push((0, $5MLoD.encode)(n, context));
    });
    const output = result.join('\n').trim();
    // Return single whitespace if content of cell is empty
    // to preserve correct empty cell rendering in wiki
    return output === '' ? ' ' : output;
};
const $2f0b818c15dc8899$var$hasMergedCell = (node)=>{
    if (!node.attrs) return false;
    if (node.attrs.colspan && node.attrs.colspan !== 1) return true;
    if (node.attrs.rowspan && node.attrs.rowspan !== 1) return true;
    return false;
};

});

parcelRegister("clZfW", function(module, exports) {

$parcel$export(module.exports, "blockCard", () => $ea56f1c43a4eedcc$export$c4c2f833baaebdb8);

var $dU28O = parcelRequire("dU28O");
const $ea56f1c43a4eedcc$export$c4c2f833baaebdb8 = (node)=>{
    if (!node.attrs.url) return (0, $dU28O.unknown)(node);
    return `[${node.attrs.url}|${node.attrs.url}|smart-card]`;
};

});

parcelRegister("ceUKV", function(module, exports) {

$parcel$export(module.exports, "embedCard", () => $f399a542f4b0468c$export$be4283d9a1cb1ff6);

var $dU28O = parcelRequire("dU28O");
const $f399a542f4b0468c$export$be4283d9a1cb1ff6 = (node)=>{
    if (!node.attrs.url) return (0, $dU28O.unknown)(node);
    return `[${node.attrs.url}|${node.attrs.url}|smart-embed]`;
};

});


parcelRegister("202j2", function(module, exports) {

$parcel$export(module.exports, "default", () => $f86240e6c339871f$export$2e2bcd8739ae039);

var $dhzNc = parcelRequire("dhzNc");

var $fCm0w = parcelRequire("fCm0w");
class $f86240e6c339871f$export$2e2bcd8739ae039 {
    constructor(schema, wikiMarkup){
        this.schema = schema;
        this.wikiMarkup = wikiMarkup;
    }
    /**
	 * Convert reduced macros tree into prosemirror model tree
	 */ getProseMirrorModel(context) {
        const content = (0, $dhzNc.parseString)({
            context: context,
            ignoreTokenTypes: [],
            input: this.wikiMarkup,
            schema: this.schema
        });
        return this.schema.nodes.doc.createChecked({}, (0, $fCm0w.normalizePMNodes)(content, this.schema, 'doc'));
    }
}

});



parcelRegister("gPXOi", function(module, exports) {

$parcel$export(module.exports, "getCommonFieldValidators", () => $c1ae37589e6d4fcd$export$68248012b0fecf7d);
const $c1ae37589e6d4fcd$export$68248012b0fecf7d = ()=>({
        fieldName: (value)=>typeof value === 'string',
        isVisible: (value)=>typeof value === 'boolean',
        description: $c1ae37589e6d4fcd$export$b5ccb7b3af83de7e,
        isReadOnly: (value, { isReadOnlyBySystem: isReadOnlyBySystem })=>typeof value === 'boolean' && (value || !value && !isReadOnlyBySystem),
        isRequired: (value, { isRequiredBySystem: isRequiredBySystem })=>typeof value === 'boolean' && (value || !value && !isRequiredBySystem)
    });
const $c1ae37589e6d4fcd$export$b5ccb7b3af83de7e = async (value)=>{
    if (typeof value !== 'string') return false;
    return true;
};

});

parcelRegister("6jG5m", function(module, exports) {

$parcel$export(module.exports, "ExternalImageValidationError", () => $50df40ad12f01e24$export$af6b052883945124);
class $50df40ad12f01e24$export$af6b052883945124 extends Error {
}

});


parcelRegister("kBumK", function(module, exports) {

$parcel$export(module.exports, "validateSingleLineTextValue", () => $0f821e497060b6ae$export$88db43fe998a9953);
const $0f821e497060b6ae$export$88db43fe998a9953 = (value)=>typeof value === 'string';

});

parcelRegister("fneAA", function(module, exports) {

$parcel$export(module.exports, "selectSetValueValidator", () => $da52eafe5ccbf2f4$export$c02b1c2a574ca4c7);
$parcel$export(module.exports, "selectWithAriSetValueValidator", () => $da52eafe5ccbf2f4$export$f22935386c756879);

var $i8ELT = parcelRequire("i8ELT");

var $ellWq = parcelRequire("ellWq");
const $da52eafe5ccbf2f4$export$c02b1c2a574ca4c7 = (value)=>value === null || (0, $ellWq.isNotEmptyString)(value);
const $da52eafe5ccbf2f4$export$f22935386c756879 = (value)=>value === null || (0, $ellWq.isNotEmptyString)(value) && (0, $i8ELT.isAriResourceIdValid)(value);

});

parcelRegister("gxLrk", function(module, exports) {

$parcel$export(module.exports, "transformSetValueCascadingSelect", () => $1f74b546a7adb5f9$export$905a8d55c641a71e);
$parcel$export(module.exports, "transformGetValueCascadingSelect", () => $1f74b546a7adb5f9$export$47e9770ed0d1c344);

var $6rtzq = parcelRequire("6rtzq");

var $ellWq = parcelRequire("ellWq");

var $biM1w = parcelRequire("biM1w");
const $1f74b546a7adb5f9$var$findCascadingSelectLookupValues = (lookupData, parentId, childId)=>{
    const foundOption = lookupData.find((currentOption)=>currentOption.parentOptionValue.id === parentId);
    if (!foundOption) throw new (0, $6rtzq.FieldValueLookupError)();
    const value = {
        parent: foundOption.parentOptionValue,
        child: childId !== null ? (0, $biM1w.singleValueLookup)(childId, foundOption.childOptionValues, 'id') : childId
    };
    return value;
};
const $1f74b546a7adb5f9$export$905a8d55c641a71e = (value, allowedValues)=>{
    if (value === null) return null;
    const cascadingSelectValue = $1f74b546a7adb5f9$var$findCascadingSelectLookupValues(allowedValues, value.parentId, value.childId);
    if (!(0, $ellWq.isNotEmptyString)(cascadingSelectValue.parent.value)) throw new (0, $6rtzq.FieldValueLookupError)();
    return {
        label: cascadingSelectValue.parent.value,
        value: cascadingSelectValue.parent.id,
        child: cascadingSelectValue.child ? {
            label: cascadingSelectValue.child.value,
            value: cascadingSelectValue.child.id
        } : null
    };
};
const $1f74b546a7adb5f9$export$47e9770ed0d1c344 = (cascadingValue)=>{
    if (!cascadingValue) return null;
    const { label: label, value: value, child: child } = cascadingValue;
    return child?.label && child?.value ? {
        parent: {
            id: value,
            value: label
        },
        child: {
            id: child.value,
            value: child.label
        }
    } : {
        parent: {
            id: value,
            value: label
        },
        child: null
    };
};

});

parcelRegister("fzAHE", function(module, exports) {

$parcel$export(module.exports, "validateComponentsSetValue", () => $b518faa441c9fd69$export$c65e64c3a855d5d2);
$parcel$export(module.exports, "componentsGetValueTransformer", () => $b518faa441c9fd69$export$b6f14754491cc7aa);
$parcel$export(module.exports, "componentsSetValueTransformer", () => $b518faa441c9fd69$export$777b614991f65d18);

var $6rtzq = parcelRequire("6rtzq");

var $ajm6I = parcelRequire("ajm6I");

var $ellWq = parcelRequire("ellWq");

var $fzmSm = parcelRequire("fzmSm");
const $b518faa441c9fd69$export$c65e64c3a855d5d2 = (value)=>Array.isArray(value) && value.every((0, $ellWq.isNotEmptyString));
const $b518faa441c9fd69$export$b6f14754491cc7aa = (internalValue)=>{
    if (!internalValue) return [];
    return internalValue.map(({ value: id, label: name })=>({
            id: id,
            name: name
        }));
};
const $b518faa441c9fd69$export$777b614991f65d18 = (publicValue, lookupValues)=>{
    if (!publicValue.length) return [];
    const filteredLookupValues = (0, $fzmSm.multiValueLookup)(publicValue, lookupValues, 'id');
    if (publicValue.length !== filteredLookupValues.length) {
        const notFoundValues = (0, $ajm6I.getValueLookupValuesDiff)(publicValue, lookupValues, 'id');
        throw new (0, $6rtzq.FieldValueLookupError)(notFoundValues.join());
    }
    return filteredLookupValues.map(({ id: value, name: label })=>({
            value: value,
            label: label
        }));
};

});
parcelRegister("ajm6I", function(module, exports) {

$parcel$export(module.exports, "getValueLookupValuesDiff", () => $58ae16a82652ca9a$export$6ebcd48e99f6b85);
/**
 * Finds the difference between provided ids and the list of available entities, by returning a list of
 * ids that weren't found in that entities list
 *
 * @param value - the list of values search being made by
 * @param lookupValues - list of entities with full information about all valid ids
 * @param lookupKey - property name of the entity from the lookupValues list with which value will be compared
 */ const $58ae16a82652ca9a$export$6ebcd48e99f6b85 = (value, // eslint-disable-next-line @typescript-eslint/no-explicit-any
lookupValues = [], lookupKey)=>value.filter((id)=>!lookupValues.some((option)=>option[lookupKey] === id));

});

parcelRegister("fzmSm", function(module, exports) {

$parcel$export(module.exports, "multiValueLookup", () => $f697f6e16e0aa49d$export$12a8af52bc9e513e);
/**
 * Finds multiple entities from a provided list of entities
 *
 * @param value - the list of values search being made by
 * @param lookupValues - list of entities where search is being made
 * @param lookupKey - property name of the entity from the lookupValues list with which value will be compared
 */ const $f697f6e16e0aa49d$export$12a8af52bc9e513e = (value, // eslint-disable-next-line @typescript-eslint/no-explicit-any
lookupValues = [], lookupKey)=>lookupValues.filter((option)=>value.includes(option[lookupKey]));

});


parcelRegister("jhkOZ", function(module, exports) {

$parcel$export(module.exports, "validateDescriptionAndParagraphSetValue", () => $0fc0f80981fb474e$export$55c0a47975b0f67);
$parcel$export(module.exports, "descriptionAndParagraphSetValueTransformer", () => $0fc0f80981fb474e$export$8596d284a0b8650f);
$parcel$export(module.exports, "descriptionAndParagraphGetValueTransformer", () => $0fc0f80981fb474e$export$736f124bc0a7d673);

var $jFHCE = parcelRequire("jFHCE");

var $d6NRs = parcelRequire("d6NRs");

var $cERCt = parcelRequire("cERCt");
const $0fc0f80981fb474e$export$95433ac963f4aebe = 'JiraTextAreaField';
const $0fc0f80981fb474e$export$31a6c27df1f927b2 = 'JiraRichTextField';
const $0fc0f80981fb474e$export$55c0a47975b0f67 = (value, { fieldRenderer: fieldRenderer }, _createAnalyticsEvent, extra)=>{
    switch(fieldRenderer){
        case $0fc0f80981fb474e$export$31a6c27df1f927b2:
            return (0, $d6NRs.isValidADF)({
                newValue: value,
                currentValue: extra.currentField?.value
            });
        case $0fc0f80981fb474e$export$95433ac963f4aebe:
            return Promise.resolve(typeof value === 'string');
        default:
            return Promise.resolve(false);
    }
};
const $0fc0f80981fb474e$export$8596d284a0b8650f = (value)=>{
    if (typeof value === 'string') return value;
    return {
        ...value,
        overrideRequired: true
    };
};
const $0fc0f80981fb474e$export$736f124bc0a7d673 = (value, fieldRenderer)=>{
    if (value === undefined) // The `convertTextToAdf` call will give us an "empty ADF object":
    // {
    //   "type": "doc",
    //   "version": 1,
    //   "content": [
    //     {
    //       "type": "paragraph",
    //       "content": []
    //     }
    //   ]
    // }
    return fieldRenderer === $0fc0f80981fb474e$export$31a6c27df1f927b2 ? (0, $cERCt.convertTextToAdf)('') : '';
    if (typeof value === 'string') return value;
    return (0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(value, 'overrideRequired');
};

});
parcelRegister("d6NRs", function(module, exports) {

$parcel$export(module.exports, "isValidADF", () => $4e5f51f959489da6$export$94ea512f7afe62e4);

var $5Mipf = parcelRequire("5Mipf");

var $cSmYj = parcelRequire("cSmYj");

var $4GHTb = parcelRequire("4GHTb");

var $0mclG = parcelRequire("0mclG");

const $4e5f51f959489da6$var$getADFValidator = async ()=>{
    const { validator: validator } = await (parcelRequire("dSvNJ"));
    return validator;
};
const $4e5f51f959489da6$var$validateAdfExternalUrls = (adf)=>{
    try {
        (0, $0mclG.traverse)(adf, {
            media: (node)=>{
                if (node.attrs?.type === 'external' && node.attrs?.url !== undefined) throw new Error('Cannot contain external images');
            },
            blockCard: ()=>{
                throw new Error('Cannot contain blockCard');
            },
            embedCard: ()=>{
                throw new Error('Cannot contain embedCard');
            }
        });
        return true;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        return false;
    }
};
const $4e5f51f959489da6$export$6f13dd7501a16a00 = (newValue, currentValue)=>{
    // If there is no user input or defaultValue set, we just validate the `externalValue` directly
    if (!currentValue || !currentValue.content.length) return $4e5f51f959489da6$var$validateAdfExternalUrls(newValue);
    // Find the diff nodes between the new value and the current value
    const foundDiffNodes = (0, (/*@__PURE__*/$parcel$interopDefault($5Mipf)))(newValue.content, currentValue.content, (0, (/*@__PURE__*/$parcel$interopDefault($cSmYj))));
    // Format `foundDiffNodes` into a valid ADF doc
    const formattedDiffAdf = (0, $4GHTb.doc)(...foundDiffNodes);
    return $4e5f51f959489da6$var$validateAdfExternalUrls(formattedDiffAdf);
};
const $4e5f51f959489da6$export$94ea512f7afe62e4 = async ({ newValue: newValue, currentValue: currentValue })=>{
    const validator = await $4e5f51f959489da6$var$getADFValidator();
    const validate = validator();
    try {
        const isValidAdfNewValue = // Additionaly to ADF validator it chekcs version property since ADF validator checks only existance of it.
        Object.hasOwnProperty.call(newValue, 'version') && typeof newValue.version === 'number' && !Number.isNaN(newValue.version) && validate(newValue).valid;
        const isValidAdf = isValidAdfNewValue && $4e5f51f959489da6$export$6f13dd7501a16a00(newValue, currentValue);
        return isValidAdf;
    } catch (e) {
        return false;
    }
};

});
parcelRegister("5Mipf", function(module, exports) {

var $leN9Q = parcelRequire("leN9Q");

var $72Qfa = parcelRequire("72Qfa");

var $l76qh = parcelRequire("l76qh");

var $d1ShJ = parcelRequire("d1ShJ");

var $1ilzu = parcelRequire("1ilzu");
/**
 * This method is like `_.difference` except that it accepts `comparator`
 * which is invoked to compare elements of `array` to `values`. The order and
 * references of result values are determined by the first array. The comparator
 * is invoked with two arguments: (arrVal, othVal).
 *
 * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
 *
 * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
 * // => [{ 'x': 2, 'y': 1 }]
 */ var $434fb68dd08edf97$var$differenceWith = $l76qh(function(array, values) {
    var comparator = $1ilzu(values);
    if ($d1ShJ(comparator)) comparator = undefined;
    return $d1ShJ(array) ? $leN9Q(array, $72Qfa(values, 1, $d1ShJ, true), undefined, comparator) : [];
});
module.exports = $434fb68dd08edf97$var$differenceWith;

});

parcelRegister("4GHTb", function(module, exports) {

$parcel$export(module.exports, "doc", () => $1d8dc02bf6b8500a$export$2a111da947c407d2);
const $1d8dc02bf6b8500a$export$2a111da947c407d2 = (...content)=>({
        type: 'doc',
        version: 1,
        content: content
    });

});

parcelRegister("dSvNJ", function(module, exports) {

let $a1a8fc9175d7dcb5$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $a1a8fc9175d7dcb5$var$load("MtNhM").then(()=>parcelRequire('8m4v2'));

});


parcelRegister("cERCt", function(module, exports) {

$parcel$export(module.exports, "convertTextToAdf", () => $236bb9d362bbb2c5$export$c10cf32c4acc1d57);

var $4GHTb = parcelRequire("4GHTb");
var $h9WvI = parcelRequire("h9WvI");

var $clRM1 = parcelRequire("clRM1");
const $236bb9d362bbb2c5$export$c10cf32c4acc1d57 = (text)=>{
    if (text === '') return (0, $clRM1.getEmptyADF)();
    return (0, $4GHTb.doc)((0, $h9WvI.paragraph)(text));
};

});
parcelRegister("h9WvI", function(module, exports) {

$parcel$export(module.exports, "paragraph", () => $a115ad2cfdf9cafd$export$9c206ddddb32a9b);

var $adSqf = parcelRequire("adSqf");
const $a115ad2cfdf9cafd$export$9c206ddddb32a9b = (...content)=>({
        type: 'paragraph',
        content: (0, $adSqf.createTextNodes)(content)
    });

});
parcelRegister("adSqf", function(module, exports) {

$parcel$export(module.exports, "createTextNodes", () => $945ad05c4de9a74c$export$3a269a5941b62f04);

var $2XNdt = parcelRequire("2XNdt");
function $945ad05c4de9a74c$export$3a269a5941b62f04(nodes) {
    return nodes.map($945ad05c4de9a74c$export$72b9432ea0656b50);
}
function $945ad05c4de9a74c$export$72b9432ea0656b50(str) {
    return typeof str === 'string' ? (0, $2XNdt.text)(str) : str;
}

});
parcelRegister("2XNdt", function(module, exports) {

$parcel$export(module.exports, "text", () => $dace89db06dc46be$export$6f093cfa640b7166);
const $dace89db06dc46be$export$6f093cfa640b7166 = (text)=>({
        type: 'text',
        text: text
    });

});





parcelRegister("Mcbkf", function(module, exports) {

$parcel$export(module.exports, "issueTypeSetValueTransformer", () => $43ba60c82cc92d00$export$93e4fd33c48f4977);
$parcel$export(module.exports, "issueTypeGetValueTransformer", () => $43ba60c82cc92d00$export$391657d4e7f81237);
$parcel$export(module.exports, "transformIssueTypeSetOptionsVisibility", () => $43ba60c82cc92d00$export$db493bcecec5fb56);
$parcel$export(module.exports, "transformIssueTypeGetOptionsVisibility", () => $43ba60c82cc92d00$export$3a886340b0f20858);

var $6rtzq = parcelRequire("6rtzq");

var $h6fC1 = parcelRequire("h6fC1");

var $ZP4Rf = parcelRequire("ZP4Rf");

var $biM1w = parcelRequire("biM1w");
const $43ba60c82cc92d00$export$93e4fd33c48f4977 = (value, lookupValues)=>{
    const lookupValue = (0, $biM1w.singleValueLookup)(value, lookupValues, 'value');
    if (!lookupValue) throw new (0, $6rtzq.FieldValueLookupError)();
    return {
        iconUrl: lookupValue.iconUrl,
        label: lookupValue.label,
        value: lookupValue.value
    };
};
const $43ba60c82cc92d00$export$391657d4e7f81237 = (value)=>{
    /**
	 * Switching between projects with UIM context doesn't reset the IA context in a timely
	 * manner, that's why we still have `adjustmentsAreEnabled` resulting in `true` even
	 * though the context should have been reset and the undecorated component should have rendered first.
	 * As a result, issue type field sends `null` as a value to the value decorator just
	 * before the context reset is being triggered.
	 * `null` won't be sent to jira-bridge because after the context is reset, the actual issue type option is being set.
	 */ if (!value) return null;
    return {
        id: value.value,
        name: value.label
    };
};
const $43ba60c82cc92d00$export$db493bcecec5fb56 = (optionsVisibility, lookupValues)=>(0, $h6fC1.applyOptionsVisibilityRule)(optionsVisibility, lookupValues, 'value');
const $43ba60c82cc92d00$export$3a886340b0f20858 = (optionsVisibility, lookupValues)=>(0, $ZP4Rf.getAvailableOptionsVisibilityRule)(optionsVisibility, lookupValues, 'value');

});
parcelRegister("h6fC1", function(module, exports) {

$parcel$export(module.exports, "applyOptionsVisibilityRule", () => $6391325f0d6ff505$export$642f3f0b0177721e);
const $6391325f0d6ff505$export$642f3f0b0177721e = ({ options: options, isVisible: isVisible }, lookupValues = [], optionKey)=>isVisible ? lookupValues.filter((value)=>options.includes(value[optionKey])) : lookupValues.filter((value)=>!options.includes(value[optionKey]));

});

parcelRegister("ZP4Rf", function(module, exports) {

$parcel$export(module.exports, "getAvailableOptionsVisibilityRule", () => $43adbdce8ad4dcab$export$d614c43ae91f42cd);
const $43adbdce8ad4dcab$export$d614c43ae91f42cd = ({ options: options, isVisible: isVisible }, lookupValues = [], optionKey)=>({
        isVisible: isVisible,
        options: options.filter((option)=>lookupValues.some((value)=>value[optionKey] === option))
    });

});


parcelRegister("3tlEm", function(module, exports) {

$parcel$export(module.exports, "transformMultiCheckboxSetOptionsVisibility", () => $cff14abe9a23db73$export$115a0b8c81087c2c);
$parcel$export(module.exports, "transformMultiCheckboxGetOptionsVisibility", () => $cff14abe9a23db73$export$4471ab017a7abd7);
$parcel$export(module.exports, "validateMultiCheckboxSetValue", () => $cff14abe9a23db73$export$56639f1c650d9ba5);
$parcel$export(module.exports, "multiCheckboxSetValueTransformer", () => $cff14abe9a23db73$export$9ba1ee83cc9456ba);
$parcel$export(module.exports, "multiCheckboxGetValueTransformer", () => $cff14abe9a23db73$export$6d15ce1cc0bdffe7);

var $6rtzq = parcelRequire("6rtzq");

var $h6fC1 = parcelRequire("h6fC1");

var $ZP4Rf = parcelRequire("ZP4Rf");

var $ajm6I = parcelRequire("ajm6I");

var $ellWq = parcelRequire("ellWq");

var $fzmSm = parcelRequire("fzmSm");
const $cff14abe9a23db73$export$115a0b8c81087c2c = (optionsVisibility, lookupValues)=>(0, $h6fC1.applyOptionsVisibilityRule)(optionsVisibility, lookupValues, 'id');
const $cff14abe9a23db73$export$4471ab017a7abd7 = (optionsVisibility, lookupValues)=>(0, $ZP4Rf.getAvailableOptionsVisibilityRule)(optionsVisibility, lookupValues, 'id');
const $cff14abe9a23db73$export$56639f1c650d9ba5 = (value)=>Array.isArray(value) && value.every((0, $ellWq.isNotEmptyString));
const $cff14abe9a23db73$export$9ba1ee83cc9456ba = (publicValue, allowedValues)=>{
    if (!publicValue.length) return [];
    const foundValue = (0, $fzmSm.multiValueLookup)(publicValue, allowedValues, 'id');
    if (foundValue.length !== publicValue.length) {
        const notFoundValues = (0, $ajm6I.getValueLookupValuesDiff)(publicValue, foundValue, 'id');
        throw new (0, $6rtzq.FieldValueLookupError)(notFoundValues.join());
    }
    return foundValue.map(({ value: value, id: id })=>({
            label: value,
            value: id
        }));
};
const $cff14abe9a23db73$export$6d15ce1cc0bdffe7 = (internalValue)=>{
    if (!internalValue) return [];
    return internalValue.map(({ value: value, label: label })=>({
            id: value,
            value: label
        }));
};

});

parcelRegister("adFnB", function(module, exports) {

$parcel$export(module.exports, "transformMultiSelectSetOptionsVisibility", () => $2039de7af080f68b$export$464f5c048bb44fae);
$parcel$export(module.exports, "transformMultiSelectGetOptionsVisibility", () => $2039de7af080f68b$export$16ec76c8ef15bfca);
$parcel$export(module.exports, "validateMultiSelectSetValue", () => $2039de7af080f68b$export$7002ea8d8a6dd444);
$parcel$export(module.exports, "multiSelectSetValueTransformer", () => $2039de7af080f68b$export$87ccfa5280a3288f);
$parcel$export(module.exports, "multiSelectGetValueTransformer", () => $2039de7af080f68b$export$9992ce1903b64c5);

var $6rtzq = parcelRequire("6rtzq");

var $h6fC1 = parcelRequire("h6fC1");

var $ZP4Rf = parcelRequire("ZP4Rf");

var $ajm6I = parcelRequire("ajm6I");

var $ellWq = parcelRequire("ellWq");

var $fzmSm = parcelRequire("fzmSm");
const $2039de7af080f68b$export$464f5c048bb44fae = (optionsVisibility, lookupValues)=>(0, $h6fC1.applyOptionsVisibilityRule)(optionsVisibility, lookupValues, 'id');
const $2039de7af080f68b$export$16ec76c8ef15bfca = (optionsVisibility, lookupValues)=>(0, $ZP4Rf.getAvailableOptionsVisibilityRule)(optionsVisibility, lookupValues, 'id');
const $2039de7af080f68b$export$7002ea8d8a6dd444 = (value)=>Array.isArray(value) && value.every((0, $ellWq.isNotEmptyString));
const $2039de7af080f68b$export$87ccfa5280a3288f = (values, lookupValues)=>{
    if (!values.length) return [];
    const filteredValues = (0, $fzmSm.multiValueLookup)(values, lookupValues, 'id');
    if (filteredValues.length !== values.length) {
        const notFoundValues = (0, $ajm6I.getValueLookupValuesDiff)(values, filteredValues, 'id');
        throw new (0, $6rtzq.FieldValueLookupError)(notFoundValues.join());
    }
    return filteredValues.map((val)=>({
            label: val.value,
            value: val.id
        }));
};
const $2039de7af080f68b$export$9992ce1903b64c5 = (internalValue)=>{
    if (!internalValue) return [];
    return internalValue.map(({ value: value, label: label })=>({
            id: value,
            value: label
        }));
};

});

parcelRegister("dybgk", function(module, exports) {

$parcel$export(module.exports, "multiUserPickerSetValueValidator", () => $113ed25337ce4749$export$161337c705ff4d65);
$parcel$export(module.exports, "multiUserPickerSetValueTransformer", () => $113ed25337ce4749$export$206658c0c308733e);
$parcel$export(module.exports, "multiUserPickerGetValueTransformer", () => $113ed25337ce4749$export$68e3fe5737fc7137);

var $6rtzq = parcelRequire("6rtzq");
var $faPX6 = parcelRequire("faPX6");

var $ajm6I = parcelRequire("ajm6I");

var $ellWq = parcelRequire("ellWq");

var $fzmSm = parcelRequire("fzmSm");
const $113ed25337ce4749$export$161337c705ff4d65 = (value)=>Array.isArray(value) && // We should omit automatic id special value so it won't be picked up by this field
    // It is only applicable to the assignee field
    value.every((option)=>(0, $ellWq.isNotEmptyString)(option) && (0, $faPX6.isNotAutomaticId)(option));
const $113ed25337ce4749$export$206658c0c308733e = (values, lookupValues)=>{
    if (!values.length) return [];
    const filteredLookupValues = (0, $fzmSm.multiValueLookup)(values, lookupValues, 'accountId');
    if (values.length !== filteredLookupValues.length) {
        const notFoundValues = (0, $ajm6I.getValueLookupValuesDiff)(values, filteredLookupValues, 'accountId');
        throw new (0, $6rtzq.FieldValueLookupError)(notFoundValues.join());
    }
    return filteredLookupValues.map(({ accountId: id, name: name, picture: avatarUrl })=>({
            id: id,
            name: name,
            avatarUrl: avatarUrl
        }));
};
const $113ed25337ce4749$export$68e3fe5737fc7137 = (value)=>{
    if (!value) return [];
    return value.map(({ id: id })=>({
            accountId: id
        }));
};

});

parcelRegister("ambuz", function(module, exports) {

$parcel$export(module.exports, "transformNumberToInternalValue", () => $31dc35898d935201$export$bdbd8c4d6c9c2efe);
$parcel$export(module.exports, "transformNumberToPublicValue", () => $31dc35898d935201$export$8bdc28b51a4acc44);
$parcel$export(module.exports, "numberIssueGicScopes", () => $31dc35898d935201$export$b7e1c026b8f78970);

var $lELZM = parcelRequire("lELZM");
const $31dc35898d935201$export$bdbd8c4d6c9c2efe = (publicValue)=>publicValue === null ? '' : String(publicValue);
const $31dc35898d935201$export$8bdc28b51a4acc44 = (internalValue)=>[
        undefined,
        ''
    ].includes(internalValue) ? null : Number(internalValue);
const $31dc35898d935201$export$b7e1c026b8f78970 = {
    ...(0, $lELZM.numberScopes),
    granular: [
        ...(0, $lELZM.numberScopes).granular,
        'write:field.default-value:jira'
    ]
};

});

parcelRegister("iy91c", function(module, exports) {

$parcel$export(module.exports, "parentSetValueTransformer", () => $abead29d3d43665f$export$a65d296b5d388a59);
$parcel$export(module.exports, "parentGetValueTransformer", () => $abead29d3d43665f$export$ea591224dc3a0141);

var $6rtzq = parcelRequire("6rtzq");

var $1wTTU = parcelRequire("1wTTU");


var $aUnLt = parcelRequire("aUnLt");
async function $abead29d3d43665f$export$a65d296b5d388a59(value, _lookupValues, { tenantContext: tenantContext }) {
    if (value === null) return null;
    try {
        const parentIssueDetails = await (0, $aUnLt.fetchParentIssueDetails)(tenantContext.cloudId, value);
        if (!parentIssueDetails) throw new (0, $6rtzq.FieldValueLookupError)(`Parent issue with issueId "${value}" not found`, {
            cause: (0, $b1390050e18cf57c$export$4a4db137834138dd)
        });
        const issue = parentIssueDetails.jira?.issueById;
        const fields = issue?.fieldsById?.edges;
        if (!issue || !issue.issueId || !issue.key || !fields) throw new (0, $6rtzq.FieldValueLookupError)(`Error fetching data for parent issue with issueId "${value}"`, {
            cause: (0, $b1390050e18cf57c$export$aa7d91b2fd1ba261)
        });
        let issueTypeField = null;
        let summaryField = null;
        let statusField = null;
        for (const field of fields){
            if ((0, $aUnLt.isJiraIssueTypeFieldNode)(field?.node)) issueTypeField = field?.node ?? null;
            else if ((0, $aUnLt.isJiraSingleLineTextFieldNode)(field?.node)) summaryField = field?.node ?? null;
            else if ((0, $aUnLt.isJiraStatusFieldNode)(field?.node)) statusField = field?.node ?? null;
        }
        if (!issueTypeField || !summaryField || !statusField) throw new (0, $6rtzq.FieldValueLookupError)(`Error fetching data for parent issue with issueId "${value}"`, {
            cause: (0, $b1390050e18cf57c$export$aa7d91b2fd1ba261)
        });
        return {
            color: (0, $1wTTU.asColor)(parentIssueDetails.jira.issueById.issueColorField?.color?.colorKey) ?? undefined,
            value: parentIssueDetails.jira.issueById.issueId,
            isDone: (0, $aUnLt.checkParentIssueIsDone)(statusField),
            key: parentIssueDetails.jira.issueById.key,
            label: `${parentIssueDetails.jira.issueById.key} ${summaryField.text}`,
            fields: {
                summary: summaryField.text ?? '',
                issuetype: {
                    id: issueTypeField.issueType?.issueTypeId ?? undefined,
                    name: issueTypeField.issueType?.name ?? undefined,
                    iconUrl: issueTypeField.issueType?.avatar?.xsmall ?? ''
                }
            }
        };
    } catch (error) {
        if (error instanceof Error && !('cause' in error)) error.cause = (0, $b1390050e18cf57c$export$494a54d93664524d);
        if (error instanceof Error) throw new (0, $6rtzq.FieldValueLookupError)(error.message, {
            cause: error.cause
        });
        throw error;
    }
}
function $abead29d3d43665f$export$ea591224dc3a0141(intervalValue) {
    if (!intervalValue) return null;
    return {
        id: intervalValue.value.toString(),
        key: intervalValue.key
    };
}

});
parcelRegister("1wTTU", function(module, exports) {

$parcel$export(module.exports, "asColor", () => $b36086cea9eb1a24$export$b74af6529f09947);
$parcel$export(module.exports, "asServerColor", () => $b36086cea9eb1a24$export$442690a499ee9598);
$parcel$export(module.exports, "asClassicEpicColor", () => $b36086cea9eb1a24$export$eb754032c0b9698c);
$parcel$export(module.exports, "transformColorToTheme", () => $b36086cea9eb1a24$export$37c9bd72afe7f286);
$parcel$export(module.exports, "getValueFromColor", () => $b36086cea9eb1a24$export$a00423580059ae28);
$parcel$export(module.exports, "getColorFromValue", () => $b36086cea9eb1a24$export$6d14528e40cbe34b);
$parcel$export(module.exports, "toFrontendColor", () => $b36086cea9eb1a24$export$574e4dbf3c01f0ad);
$parcel$export(module.exports, "toBackendColor", () => $b36086cea9eb1a24$export$47af25386a01de1);
$parcel$export(module.exports, "classicToFrontendColor", () => $b36086cea9eb1a24$export$8f81207f7ac5fb9a);
$parcel$export(module.exports, "classicToBackendColor", () => $b36086cea9eb1a24$export$28fb68bb1de025d5);
$parcel$export(module.exports, "getDefaultColorPalette", () => $b36086cea9eb1a24$export$f6e067d5c418081a);
$parcel$export(module.exports, "getLozengeThemeByColor", () => $b36086cea9eb1a24$export$949dc67535a8ff2);
$parcel$export(module.exports, "getRandomColor", () => $b36086cea9eb1a24$export$e4369cabd7e84cd9);

var $2IQEX = parcelRequire("2IQEX");

var $38IWH = parcelRequire("38IWH");

var $8URAw = parcelRequire("8URAw");

var $efpPR = parcelRequire("efpPR");
const $b36086cea9eb1a24$export$b74af6529f09947 = (color)=>{
    if (color == null) return (0, $38IWH.Colors).PURPLE;
    if (color in (0, $38IWH.Colors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $8URAw.MAP_FROM_SERVER_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $8URAw.MAP_FROM_SERVER_COLOR)[color];
    if (color in (0, $8URAw.MAP_FROM_AGILE_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $8URAw.MAP_FROM_AGILE_COLOR)[color];
    if (color in (0, $8URAw.MAP_FROM_SERVER_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $8URAw.MAP_FROM_SERVER_CLASSIC_COLOR)[color];
    return (0, $38IWH.Colors).PURPLE;
};
const $b36086cea9eb1a24$export$442690a499ee9598 = (color)=>{
    if (color == null) return (0, $38IWH.ServerColors).SERVER_PURPLE;
    if (color in (0, $38IWH.ServerColors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $8URAw.MAP_FROM_CLIENT_SERVER_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $8URAw.MAP_FROM_CLIENT_SERVER_COLOR)[color];
    if (color in (0, $8URAw.MAP_FROM_AGILE_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $8URAw.MAP_FROM_AGILE_COLOR)[color] in (0, $8URAw.MAP_FROM_CLIENT_SERVER_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $8URAw.MAP_FROM_CLIENT_SERVER_COLOR)[(0, $8URAw.MAP_FROM_AGILE_COLOR)[color]];
    if (color in (0, $8URAw.MAP_FROM_SERVER_CLASSIC_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $8URAw.MAP_FROM_SERVER_CLASSIC_COLOR)[color] in (0, $8URAw.MAP_FROM_CLIENT_SERVER_COLOR)) return (0, $8URAw.MAP_FROM_CLIENT_SERVER_COLOR)[// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $8URAw.MAP_FROM_SERVER_CLASSIC_COLOR)[color]];
    return (0, $38IWH.ServerColors).SERVER_PURPLE;
};
const $b36086cea9eb1a24$export$eb754032c0b9698c = (color)=>{
    if (color === null) return (0, $8URAw.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $38IWH.Colors).PURPLE];
    if (color in (0, $38IWH.ClassicEpicColors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $8URAw.MAP_FROM_CLIENT_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $8URAw.MAP_FROM_CLIENT_CLASSIC_COLOR)[color];
    if (color in (0, $8URAw.MAP_FROM_SERVER_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $8URAw.MAP_FROM_SERVER_COLOR)[color] in (0, $8URAw.MAP_FROM_CLIENT_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $8URAw.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $8URAw.MAP_FROM_SERVER_COLOR)[color]];
    if (color in (0, $8URAw.MAP_FROM_AGILE_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $8URAw.MAP_FROM_AGILE_COLOR)[color] in (0, $8URAw.MAP_FROM_CLIENT_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $8URAw.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $8URAw.MAP_FROM_AGILE_COLOR)[color]];
    // i.e: ghx-label-7
    return (0, $8URAw.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $38IWH.Colors).PURPLE];
};
const $b36086cea9eb1a24$export$1a0a4af71e00cea4 = (color)=>{
    if (color === null) return (0, $8URAw.MAP_FROM_CLIENT_AGILE_COLOR)[(0, $38IWH.Colors).PURPLE];
    if (color in (0, $38IWH.AgileColors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $8URAw.MAP_FROM_CLIENT_AGILE_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $8URAw.MAP_FROM_CLIENT_AGILE_COLOR)[color];
    if (color in (0, $8URAw.MAP_FROM_SERVER_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $8URAw.MAP_FROM_SERVER_COLOR)[color] in (0, $8URAw.MAP_FROM_CLIENT_AGILE_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $8URAw.MAP_FROM_CLIENT_AGILE_COLOR)[(0, $8URAw.MAP_FROM_SERVER_COLOR)[color]];
    if (color in (0, $8URAw.MAP_FROM_SERVER_CLASSIC_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $8URAw.MAP_FROM_SERVER_CLASSIC_COLOR)[color] in (0, $8URAw.MAP_FROM_CLIENT_AGILE_COLOR)) return (0, $8URAw.MAP_FROM_CLIENT_AGILE_COLOR)[// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $8URAw.MAP_FROM_SERVER_CLASSIC_COLOR)[color]];
    // i.e: color_7
    return (0, $8URAw.MAP_FROM_CLIENT_AGILE_COLOR)[(0, $38IWH.Colors).PURPLE];
};
const $b36086cea9eb1a24$export$37c9bd72afe7f286 = (transformation, colorSchemaExtension)=>{
    const newColorSchema = {
        ...(0, $8URAw.BASE_COLOR_SCHEMA),
        ...colorSchemaExtension
    };
    const extendedColors = (colorSchemaExtension ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    Object.keys(colorSchemaExtension) : []).concat(Object.keys((0, $38IWH.Colors)));
    return extendedColors.reduce((obj, color)=>Object.assign(obj, {
            [color]: transformation(newColorSchema[color])
        }), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    {});
};
const $b36086cea9eb1a24$export$a00423580059ae28 = (color)=>(0, $8URAw.MAP_COLORS_TO_VALUE)[color] || (0, $8URAw.MAP_COLORS_TO_VALUE)[0, $38IWH.PURPLE];
const $b36086cea9eb1a24$export$6d14528e40cbe34b = (value)=>// NOTE: lodash invert coerce the output to Dictionary<string> instead of using a polymorphic type
    // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'Color'.
    (0, (/*@__PURE__*/$parcel$interopDefault($2IQEX)))((0, $8URAw.MAP_COLORS_TO_VALUE))[value] || (0, $38IWH.PURPLE);
const $b36086cea9eb1a24$export$574e4dbf3c01f0ad = (colorStr)=>colorStr !== '' && colorStr !== undefined && colorStr !== null && colorStr in (0, $8URAw.MAP_FROM_SERVER_COLOR) ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $8URAw.MAP_FROM_SERVER_COLOR)[colorStr] : (0, $38IWH.PURPLE);
const $b36086cea9eb1a24$export$47af25386a01de1 = (color)=>(0, $8URAw.MAP_FROM_CLIENT_SERVER_COLOR)[color];
const $b36086cea9eb1a24$export$8f81207f7ac5fb9a = (colorStr)=>colorStr !== '' && colorStr !== undefined && colorStr !== null && colorStr in (0, $8URAw.MAP_FROM_SERVER_CLASSIC_COLOR) ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $8URAw.MAP_FROM_SERVER_CLASSIC_COLOR)[colorStr] : (0, $38IWH.PURPLE);
const $b36086cea9eb1a24$export$28fb68bb1de025d5 = (color)=>(0, $8URAw.MAP_FROM_CLIENT_CLASSIC_COLOR)[color];
/**
 * Return default color palette
 */ const $b36086cea9eb1a24$var$paletteColorValues = $b36086cea9eb1a24$export$37c9bd72afe7f286((colorSchema)=>colorSchema.primary);
const $b36086cea9eb1a24$export$f6e067d5c418081a = (formatMessage)=>[
        {
            label: formatMessage((0, $efpPR.default).purpleLabel),
            value: $b36086cea9eb1a24$var$paletteColorValues[(0, $38IWH.Colors).PURPLE]
        },
        {
            label: formatMessage((0, $efpPR.default).blueLabel),
            value: $b36086cea9eb1a24$var$paletteColorValues[(0, $38IWH.Colors).BLUE]
        },
        {
            label: formatMessage((0, $efpPR.default).greenLabel),
            value: $b36086cea9eb1a24$var$paletteColorValues[(0, $38IWH.Colors).GREEN]
        },
        {
            label: formatMessage((0, $efpPR.default).tealLabel),
            value: $b36086cea9eb1a24$var$paletteColorValues[(0, $38IWH.Colors).TEAL]
        },
        {
            label: formatMessage((0, $efpPR.default).yellowLabel),
            value: $b36086cea9eb1a24$var$paletteColorValues[(0, $38IWH.Colors).YELLOW]
        },
        {
            label: formatMessage((0, $efpPR.default).orangeLabel),
            value: $b36086cea9eb1a24$var$paletteColorValues[(0, $38IWH.Colors).ORANGE]
        },
        {
            label: formatMessage((0, $efpPR.default).greyLabel),
            value: $b36086cea9eb1a24$var$paletteColorValues[(0, $38IWH.Colors).GREY]
        },
        {
            label: formatMessage((0, $efpPR.default).darkPurpleLabel),
            value: $b36086cea9eb1a24$var$paletteColorValues[(0, $38IWH.Colors).DARK_PURPLE]
        },
        {
            label: formatMessage((0, $efpPR.default).darkBlueLabel),
            value: $b36086cea9eb1a24$var$paletteColorValues[(0, $38IWH.Colors).DARK_BLUE]
        },
        {
            label: formatMessage((0, $efpPR.default).darkGreenLabel),
            value: $b36086cea9eb1a24$var$paletteColorValues[(0, $38IWH.Colors).DARK_GREEN]
        },
        {
            label: formatMessage((0, $efpPR.default).darkTealLabel),
            value: $b36086cea9eb1a24$var$paletteColorValues[(0, $38IWH.Colors).DARK_TEAL]
        },
        {
            label: formatMessage((0, $efpPR.default).darkYellowLabel),
            value: $b36086cea9eb1a24$var$paletteColorValues[(0, $38IWH.Colors).DARK_YELLOW]
        },
        {
            label: formatMessage((0, $efpPR.default).darkOrangeLabel),
            value: $b36086cea9eb1a24$var$paletteColorValues[(0, $38IWH.Colors).DARK_ORANGE]
        },
        {
            label: formatMessage((0, $efpPR.default).darkGreyLabel),
            value: $b36086cea9eb1a24$var$paletteColorValues[(0, $38IWH.Colors).DARK_GREY]
        }
    ];
const $b36086cea9eb1a24$export$9b822862d986dfdf = $b36086cea9eb1a24$export$37c9bd72afe7f286((colorSchema)=>({
        color: colorSchema.text,
        backgroundColor: colorSchema.textBackground
    }));
const $b36086cea9eb1a24$export$949dc67535a8ff2 = (color = (0, $8URAw.DEFAULT_EPIC_COLOR))=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $b36086cea9eb1a24$export$9b822862d986dfdf[color] ?? $b36086cea9eb1a24$export$9b822862d986dfdf[0, $8URAw.DEFAULT_EPIC_COLOR];
const $b36086cea9eb1a24$export$e4369cabd7e84cd9 = ()=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const colorKeys = Object.keys((0, $38IWH.Colors));
    return colorKeys[Math.floor(Math.random() * colorKeys.length)];
};

});
parcelRegister("2IQEX", function(module, exports) {

var $9hKkF = parcelRequire("9hKkF");

var $h3TKx = parcelRequire("h3TKx");

var $d7YnM = parcelRequire("d7YnM");
/** Used for built-in method references. */ var $1fb889f558f23ac4$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $1fb889f558f23ac4$var$nativeObjectToString = $1fb889f558f23ac4$var$objectProto.toString;
/**
 * Creates an object composed of the inverted keys and values of `object`.
 * If `object` contains duplicate values, subsequent values overwrite
 * property assignments of previous values.
 *
 * @static
 * @memberOf _
 * @since 0.7.0
 * @category Object
 * @param {Object} object The object to invert.
 * @returns {Object} Returns the new inverted object.
 * @example
 *
 * var object = { 'a': 1, 'b': 2, 'c': 1 };
 *
 * _.invert(object);
 * // => { '1': 'c', '2': 'b' }
 */ var $1fb889f558f23ac4$var$invert = $h3TKx(function(result, value, key) {
    if (value != null && typeof value.toString != 'function') value = $1fb889f558f23ac4$var$nativeObjectToString.call(value);
    result[value] = key;
}, $9hKkF($d7YnM));
module.exports = $1fb889f558f23ac4$var$invert;

});
parcelRegister("h3TKx", function(module, exports) {

var $8uipj = parcelRequire("8uipj");
/**
 * Creates a function like `_.invertBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} toIteratee The function to resolve iteratees.
 * @returns {Function} Returns the new inverter function.
 */ function $c6bdf63192b21f8e$var$createInverter(setter, toIteratee) {
    return function(object, iteratee) {
        return $8uipj(object, setter, toIteratee(iteratee), {});
    };
}
module.exports = $c6bdf63192b21f8e$var$createInverter;

});
parcelRegister("8uipj", function(module, exports) {

var $75Jcs = parcelRequire("75Jcs");
/**
 * The base implementation of `_.invert` and `_.invertBy` which inverts
 * `object` with values transformed by `iteratee` and set by `setter`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform values.
 * @param {Object} accumulator The initial inverted object.
 * @returns {Function} Returns `accumulator`.
 */ function $62df67589f85c449$var$baseInverter(object, setter, iteratee, accumulator) {
    $75Jcs(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
    });
    return accumulator;
}
module.exports = $62df67589f85c449$var$baseInverter;

});



parcelRegister("38IWH", function(module, exports) {

$parcel$export(module.exports, "PURPLE", () => $92f22b7535e1838e$export$7ffdeca4b2f927a2);
$parcel$export(module.exports, "DARK_PURPLE", () => $92f22b7535e1838e$export$c815fe495e8174a0);
$parcel$export(module.exports, "BLUE", () => $92f22b7535e1838e$export$738c3b9a44c87ecc);
$parcel$export(module.exports, "DARK_BLUE", () => $92f22b7535e1838e$export$1225f83626261b80);
$parcel$export(module.exports, "GREEN", () => $92f22b7535e1838e$export$48d4b2cd5bc0e88b);
$parcel$export(module.exports, "DARK_GREEN", () => $92f22b7535e1838e$export$c6f4cf2e5768eb78);
$parcel$export(module.exports, "TEAL", () => $92f22b7535e1838e$export$d0446fe88325854e);
$parcel$export(module.exports, "DARK_TEAL", () => $92f22b7535e1838e$export$bb848c92687e69dc);
$parcel$export(module.exports, "YELLOW", () => $92f22b7535e1838e$export$aab610c505c06a8f);
$parcel$export(module.exports, "DARK_YELLOW", () => $92f22b7535e1838e$export$466af87757d343a2);
$parcel$export(module.exports, "ORANGE", () => $92f22b7535e1838e$export$3de5e29ed1757f9b);
$parcel$export(module.exports, "DARK_ORANGE", () => $92f22b7535e1838e$export$da02e4820b6ab753);
$parcel$export(module.exports, "GREY", () => $92f22b7535e1838e$export$7d278ca694634874);
$parcel$export(module.exports, "DARK_GREY", () => $92f22b7535e1838e$export$26453300bfc61cb8);
$parcel$export(module.exports, "COLORS", () => $92f22b7535e1838e$export$56d196d2844d1ca1);
$parcel$export(module.exports, "SERVER_PURPLE", () => $92f22b7535e1838e$export$792af22a0198af8d);
$parcel$export(module.exports, "SERVER_DARK_PURPLE", () => $92f22b7535e1838e$export$588af712afdcb006);
$parcel$export(module.exports, "SERVER_BLUE", () => $92f22b7535e1838e$export$84c4918645391802);
$parcel$export(module.exports, "SERVER_DARK_BLUE", () => $92f22b7535e1838e$export$b8f1f5838352a33a);
$parcel$export(module.exports, "SERVER_GREEN", () => $92f22b7535e1838e$export$9384b7e350ee6542);
$parcel$export(module.exports, "SERVER_DARK_GREEN", () => $92f22b7535e1838e$export$87d3fb8d8656d38b);
$parcel$export(module.exports, "SERVER_TEAL", () => $92f22b7535e1838e$export$b0b4ce3e99e66aae);
$parcel$export(module.exports, "SERVER_DARK_TEAL", () => $92f22b7535e1838e$export$a89b77a449bd223e);
$parcel$export(module.exports, "SERVER_YELLOW", () => $92f22b7535e1838e$export$9a33b5e3cde94885);
$parcel$export(module.exports, "SERVER_DARK_YELLOW", () => $92f22b7535e1838e$export$33253d7862bceb8a);
$parcel$export(module.exports, "SERVER_ORANGE", () => $92f22b7535e1838e$export$6609c2b23fc42f39);
$parcel$export(module.exports, "SERVER_DARK_ORANGE", () => $92f22b7535e1838e$export$cd994662b5911917);
$parcel$export(module.exports, "SERVER_GREY", () => $92f22b7535e1838e$export$1793d43e13e078c5);
$parcel$export(module.exports, "SERVER_DARK_GREY", () => $92f22b7535e1838e$export$487a6e9145526564);
$parcel$export(module.exports, "GHX_LABEL_1", () => $92f22b7535e1838e$export$e4bdf2d4c4bbb15e);
$parcel$export(module.exports, "GHX_LABEL_2", () => $92f22b7535e1838e$export$8f5c1c5512278dc6);
$parcel$export(module.exports, "GHX_LABEL_3", () => $92f22b7535e1838e$export$94ac87c81ed074a7);
$parcel$export(module.exports, "GHX_LABEL_4", () => $92f22b7535e1838e$export$6bc9ab1f489f76f7);
$parcel$export(module.exports, "GHX_LABEL_5", () => $92f22b7535e1838e$export$610a2c132b6fcf96);
$parcel$export(module.exports, "GHX_LABEL_6", () => $92f22b7535e1838e$export$8e4997dba71f1c40);
$parcel$export(module.exports, "GHX_LABEL_7", () => $92f22b7535e1838e$export$18a545b4e69b27b4);
$parcel$export(module.exports, "GHX_LABEL_8", () => $92f22b7535e1838e$export$27fff1a0d295292a);
$parcel$export(module.exports, "GHX_LABEL_9", () => $92f22b7535e1838e$export$e57aa662a56724e1);
$parcel$export(module.exports, "GHX_LABEL_10", () => $92f22b7535e1838e$export$4b0d63e2c3be2072);
$parcel$export(module.exports, "GHX_LABEL_11", () => $92f22b7535e1838e$export$457ecb9560f2bf83);
$parcel$export(module.exports, "GHX_LABEL_12", () => $92f22b7535e1838e$export$a866db37165a696c);
$parcel$export(module.exports, "GHX_LABEL_13", () => $92f22b7535e1838e$export$9b18447c1168a1b6);
$parcel$export(module.exports, "GHX_LABEL_14", () => $92f22b7535e1838e$export$93b9ad4020e271b7);
$parcel$export(module.exports, "AGILE_COLOR_1", () => $92f22b7535e1838e$export$5cd2af17b34de3e3);
$parcel$export(module.exports, "AGILE_COLOR_2", () => $92f22b7535e1838e$export$987671fa69482a7b);
$parcel$export(module.exports, "AGILE_COLOR_3", () => $92f22b7535e1838e$export$70ba8a5b1f4c7446);
$parcel$export(module.exports, "AGILE_COLOR_4", () => $92f22b7535e1838e$export$fcd1c42d8d3ebd36);
$parcel$export(module.exports, "AGILE_COLOR_5", () => $92f22b7535e1838e$export$f80a5bd2fa0ba256);
$parcel$export(module.exports, "AGILE_COLOR_6", () => $92f22b7535e1838e$export$37ad5ce8d2aeaf78);
$parcel$export(module.exports, "AGILE_COLOR_7", () => $92f22b7535e1838e$export$9dc62d5d151cb355);
$parcel$export(module.exports, "AGILE_COLOR_8", () => $92f22b7535e1838e$export$1ed15b30f5663f92);
$parcel$export(module.exports, "AGILE_COLOR_9", () => $92f22b7535e1838e$export$5d23a84d55ac1644);
$parcel$export(module.exports, "AGILE_COLOR_10", () => $92f22b7535e1838e$export$bf08c9a6ed42e349);
$parcel$export(module.exports, "AGILE_COLOR_11", () => $92f22b7535e1838e$export$66c5d8f0b5ff279c);
$parcel$export(module.exports, "AGILE_COLOR_12", () => $92f22b7535e1838e$export$da30755a37c3a597);
$parcel$export(module.exports, "AGILE_COLOR_13", () => $92f22b7535e1838e$export$721cf84faff6bf19);
$parcel$export(module.exports, "AGILE_COLOR_14", () => $92f22b7535e1838e$export$4b8f8666bd7b61dd);
$parcel$export(module.exports, "Colors", () => $92f22b7535e1838e$export$c537fa0d021d010b);
$parcel$export(module.exports, "ServerColors", () => $92f22b7535e1838e$export$d33d39828a18210a);
$parcel$export(module.exports, "ClassicEpicColors", () => $92f22b7535e1838e$export$f476e6e43e0101e7);
$parcel$export(module.exports, "AgileColors", () => $92f22b7535e1838e$export$4b7407b8700035bd);
/**
 * @fileoverview This file was moved from `@atlassian/jira-issue-epic-color-types`
 * so that these types do not require atlaskit dependencies.
 *
 * Color constants
 */ const $92f22b7535e1838e$export$7ffdeca4b2f927a2 = 'PURPLE';
const $92f22b7535e1838e$export$c815fe495e8174a0 = 'DARK_PURPLE';
const $92f22b7535e1838e$export$738c3b9a44c87ecc = 'BLUE';
const $92f22b7535e1838e$export$1225f83626261b80 = 'DARK_BLUE';
const $92f22b7535e1838e$export$48d4b2cd5bc0e88b = 'GREEN';
const $92f22b7535e1838e$export$c6f4cf2e5768eb78 = 'DARK_GREEN';
const $92f22b7535e1838e$export$d0446fe88325854e = 'TEAL';
const $92f22b7535e1838e$export$bb848c92687e69dc = 'DARK_TEAL';
const $92f22b7535e1838e$export$aab610c505c06a8f = 'YELLOW';
const $92f22b7535e1838e$export$466af87757d343a2 = 'DARK_YELLOW';
const $92f22b7535e1838e$export$3de5e29ed1757f9b = 'ORANGE';
const $92f22b7535e1838e$export$da02e4820b6ab753 = 'DARK_ORANGE';
const $92f22b7535e1838e$export$7d278ca694634874 = 'GREY';
const $92f22b7535e1838e$export$26453300bfc61cb8 = 'DARK_GREY';
const $92f22b7535e1838e$export$56d196d2844d1ca1 = [
    $92f22b7535e1838e$export$7ffdeca4b2f927a2,
    $92f22b7535e1838e$export$c815fe495e8174a0,
    $92f22b7535e1838e$export$738c3b9a44c87ecc,
    $92f22b7535e1838e$export$1225f83626261b80,
    $92f22b7535e1838e$export$48d4b2cd5bc0e88b,
    $92f22b7535e1838e$export$c6f4cf2e5768eb78,
    $92f22b7535e1838e$export$d0446fe88325854e,
    $92f22b7535e1838e$export$bb848c92687e69dc,
    $92f22b7535e1838e$export$aab610c505c06a8f,
    $92f22b7535e1838e$export$466af87757d343a2,
    $92f22b7535e1838e$export$3de5e29ed1757f9b,
    $92f22b7535e1838e$export$da02e4820b6ab753,
    $92f22b7535e1838e$export$7d278ca694634874,
    $92f22b7535e1838e$export$26453300bfc61cb8
];
const $92f22b7535e1838e$export$792af22a0198af8d = 'purple';
const $92f22b7535e1838e$export$588af712afdcb006 = 'dark_purple';
const $92f22b7535e1838e$export$84c4918645391802 = 'blue';
const $92f22b7535e1838e$export$b8f1f5838352a33a = 'dark_blue';
const $92f22b7535e1838e$export$9384b7e350ee6542 = 'green';
const $92f22b7535e1838e$export$87d3fb8d8656d38b = 'dark_green';
const $92f22b7535e1838e$export$b0b4ce3e99e66aae = 'teal';
const $92f22b7535e1838e$export$a89b77a449bd223e = 'dark_teal';
const $92f22b7535e1838e$export$9a33b5e3cde94885 = 'yellow';
const $92f22b7535e1838e$export$33253d7862bceb8a = 'dark_yellow';
const $92f22b7535e1838e$export$6609c2b23fc42f39 = 'orange';
const $92f22b7535e1838e$export$cd994662b5911917 = 'dark_orange';
const $92f22b7535e1838e$export$1793d43e13e078c5 = 'grey';
const $92f22b7535e1838e$export$487a6e9145526564 = 'dark_grey';
const $92f22b7535e1838e$export$e4bdf2d4c4bbb15e = 'ghx-label-1';
const $92f22b7535e1838e$export$8f5c1c5512278dc6 = 'ghx-label-2';
const $92f22b7535e1838e$export$94ac87c81ed074a7 = 'ghx-label-3';
const $92f22b7535e1838e$export$6bc9ab1f489f76f7 = 'ghx-label-4';
const $92f22b7535e1838e$export$610a2c132b6fcf96 = 'ghx-label-5';
const $92f22b7535e1838e$export$8e4997dba71f1c40 = 'ghx-label-6';
const $92f22b7535e1838e$export$18a545b4e69b27b4 = 'ghx-label-7';
const $92f22b7535e1838e$export$27fff1a0d295292a = 'ghx-label-8';
const $92f22b7535e1838e$export$e57aa662a56724e1 = 'ghx-label-9';
const $92f22b7535e1838e$export$4b0d63e2c3be2072 = 'ghx-label-10';
const $92f22b7535e1838e$export$457ecb9560f2bf83 = 'ghx-label-11';
const $92f22b7535e1838e$export$a866db37165a696c = 'ghx-label-12';
const $92f22b7535e1838e$export$9b18447c1168a1b6 = 'ghx-label-13';
const $92f22b7535e1838e$export$93b9ad4020e271b7 = 'ghx-label-14';
const $92f22b7535e1838e$export$5cd2af17b34de3e3 = 'color_1';
const $92f22b7535e1838e$export$987671fa69482a7b = 'color_2';
const $92f22b7535e1838e$export$70ba8a5b1f4c7446 = 'color_3';
const $92f22b7535e1838e$export$fcd1c42d8d3ebd36 = 'color_4';
const $92f22b7535e1838e$export$f80a5bd2fa0ba256 = 'color_5';
const $92f22b7535e1838e$export$37ad5ce8d2aeaf78 = 'color_6';
const $92f22b7535e1838e$export$9dc62d5d151cb355 = 'color_7';
const $92f22b7535e1838e$export$1ed15b30f5663f92 = 'color_8';
const $92f22b7535e1838e$export$5d23a84d55ac1644 = 'color_9';
const $92f22b7535e1838e$export$bf08c9a6ed42e349 = 'color_10';
const $92f22b7535e1838e$export$66c5d8f0b5ff279c = 'color_11';
const $92f22b7535e1838e$export$da30755a37c3a597 = 'color_12';
const $92f22b7535e1838e$export$721cf84faff6bf19 = 'color_13';
const $92f22b7535e1838e$export$4b8f8666bd7b61dd = 'color_14';
const $92f22b7535e1838e$export$c537fa0d021d010b = {
    PURPLE: $92f22b7535e1838e$export$7ffdeca4b2f927a2,
    DARK_PURPLE: $92f22b7535e1838e$export$c815fe495e8174a0,
    BLUE: $92f22b7535e1838e$export$738c3b9a44c87ecc,
    DARK_BLUE: $92f22b7535e1838e$export$1225f83626261b80,
    GREEN: $92f22b7535e1838e$export$48d4b2cd5bc0e88b,
    DARK_GREEN: $92f22b7535e1838e$export$c6f4cf2e5768eb78,
    TEAL: $92f22b7535e1838e$export$d0446fe88325854e,
    DARK_TEAL: $92f22b7535e1838e$export$bb848c92687e69dc,
    YELLOW: $92f22b7535e1838e$export$aab610c505c06a8f,
    DARK_YELLOW: $92f22b7535e1838e$export$466af87757d343a2,
    ORANGE: $92f22b7535e1838e$export$3de5e29ed1757f9b,
    DARK_ORANGE: $92f22b7535e1838e$export$da02e4820b6ab753,
    GREY: $92f22b7535e1838e$export$7d278ca694634874,
    DARK_GREY: $92f22b7535e1838e$export$26453300bfc61cb8
};
const $92f22b7535e1838e$export$d33d39828a18210a = {
    SERVER_PURPLE: $92f22b7535e1838e$export$792af22a0198af8d,
    SERVER_DARK_PURPLE: $92f22b7535e1838e$export$588af712afdcb006,
    SERVER_BLUE: $92f22b7535e1838e$export$84c4918645391802,
    SERVER_DARK_BLUE: $92f22b7535e1838e$export$b8f1f5838352a33a,
    SERVER_GREEN: $92f22b7535e1838e$export$9384b7e350ee6542,
    SERVER_DARK_GREEN: $92f22b7535e1838e$export$87d3fb8d8656d38b,
    SERVER_TEAL: $92f22b7535e1838e$export$b0b4ce3e99e66aae,
    SERVER_DARK_TEAL: $92f22b7535e1838e$export$a89b77a449bd223e,
    SERVER_YELLOW: $92f22b7535e1838e$export$9a33b5e3cde94885,
    SERVER_DARK_YELLOW: $92f22b7535e1838e$export$33253d7862bceb8a,
    SERVER_ORANGE: $92f22b7535e1838e$export$6609c2b23fc42f39,
    SERVER_DARK_ORANGE: $92f22b7535e1838e$export$cd994662b5911917,
    SERVER_GREY: $92f22b7535e1838e$export$1793d43e13e078c5,
    SERVER_DARK_GREY: $92f22b7535e1838e$export$487a6e9145526564
};
const $92f22b7535e1838e$export$f476e6e43e0101e7 = {
    GHX_LABEL_1: $92f22b7535e1838e$export$e4bdf2d4c4bbb15e,
    GHX_LABEL_2: $92f22b7535e1838e$export$8f5c1c5512278dc6,
    GHX_LABEL_3: $92f22b7535e1838e$export$94ac87c81ed074a7,
    GHX_LABEL_4: $92f22b7535e1838e$export$6bc9ab1f489f76f7,
    GHX_LABEL_5: $92f22b7535e1838e$export$610a2c132b6fcf96,
    GHX_LABEL_6: $92f22b7535e1838e$export$8e4997dba71f1c40,
    GHX_LABEL_7: $92f22b7535e1838e$export$18a545b4e69b27b4,
    GHX_LABEL_8: $92f22b7535e1838e$export$27fff1a0d295292a,
    GHX_LABEL_9: $92f22b7535e1838e$export$e57aa662a56724e1,
    GHX_LABEL_10: $92f22b7535e1838e$export$4b0d63e2c3be2072,
    GHX_LABEL_11: $92f22b7535e1838e$export$457ecb9560f2bf83,
    GHX_LABEL_12: $92f22b7535e1838e$export$a866db37165a696c,
    GHX_LABEL_13: $92f22b7535e1838e$export$9b18447c1168a1b6,
    GHX_LABEL_14: $92f22b7535e1838e$export$93b9ad4020e271b7
};
const $92f22b7535e1838e$export$4b7407b8700035bd = {
    AGILE_COLOR_1: $92f22b7535e1838e$export$5cd2af17b34de3e3,
    AGILE_COLOR_2: $92f22b7535e1838e$export$987671fa69482a7b,
    AGILE_COLOR_3: $92f22b7535e1838e$export$70ba8a5b1f4c7446,
    AGILE_COLOR_4: $92f22b7535e1838e$export$fcd1c42d8d3ebd36,
    AGILE_COLOR_5: $92f22b7535e1838e$export$f80a5bd2fa0ba256,
    AGILE_COLOR_6: $92f22b7535e1838e$export$37ad5ce8d2aeaf78,
    AGILE_COLOR_7: $92f22b7535e1838e$export$9dc62d5d151cb355,
    AGILE_COLOR_8: $92f22b7535e1838e$export$1ed15b30f5663f92,
    AGILE_COLOR_9: $92f22b7535e1838e$export$5d23a84d55ac1644,
    AGILE_COLOR_10: $92f22b7535e1838e$export$bf08c9a6ed42e349,
    AGILE_COLOR_11: $92f22b7535e1838e$export$66c5d8f0b5ff279c,
    AGILE_COLOR_12: $92f22b7535e1838e$export$da30755a37c3a597,
    AGILE_COLOR_13: $92f22b7535e1838e$export$721cf84faff6bf19,
    AGILE_COLOR_14: $92f22b7535e1838e$export$4b8f8666bd7b61dd
};

});

parcelRegister("8URAw", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_EPIC_COLOR", () => $f89c7f0e34657bc4$export$c2357bec51c5cf5b);
$parcel$export(module.exports, "MAP_COLORS_TO_VALUE", () => $f89c7f0e34657bc4$export$db33d74b098e3da9);
$parcel$export(module.exports, "MAP_COLORS_TO_TOKEN", () => $f89c7f0e34657bc4$export$fc5fe4213a5703f1);
$parcel$export(module.exports, "MAP_VALUE_TO_COLOR", () => $f89c7f0e34657bc4$export$a6cb26e106674600);
$parcel$export(module.exports, "MAP_FROM_SERVER_COLOR", () => $f89c7f0e34657bc4$export$43264b0781f10167);
$parcel$export(module.exports, "MAP_FROM_CLIENT_SERVER_COLOR", () => $f89c7f0e34657bc4$export$aedca9f3a1ee43d7);
$parcel$export(module.exports, "MAP_FROM_SERVER_CLASSIC_COLOR", () => $f89c7f0e34657bc4$export$fb5d051fe1b2bccc);
$parcel$export(module.exports, "MAP_FROM_CLIENT_CLASSIC_COLOR", () => $f89c7f0e34657bc4$export$c13af2d9629c53d8);
$parcel$export(module.exports, "MAP_FROM_AGILE_COLOR", () => $f89c7f0e34657bc4$export$994d3ffa39be04fd);
$parcel$export(module.exports, "MAP_FROM_CLIENT_AGILE_COLOR", () => $f89c7f0e34657bc4$export$db17671bf37971e7);
$parcel$export(module.exports, "MAP_COLOR_TO_AK_COLOR", () => $f89c7f0e34657bc4$export$82fc3b0b98905453);
$parcel$export(module.exports, "BASE_COLOR_SCHEMA", () => $f89c7f0e34657bc4$export$92b6aebfb522f0d9);

var $2IQEX = parcelRequire("2IQEX");


var $38IWH = parcelRequire("38IWH");
const $f89c7f0e34657bc4$export$c2357bec51c5cf5b = 'PURPLE';
const $f89c7f0e34657bc4$export$db33d74b098e3da9 = {
    [(0, $38IWH.PURPLE)]: "var(--ds-background-accent-purple-subtle, #9F8FEF)",
    [(0, $38IWH.BLUE)]: "var(--ds-background-accent-blue-subtle, #579DFF)",
    [(0, $38IWH.GREEN)]: "var(--ds-background-accent-green-subtle, #4BCE97)",
    [(0, $38IWH.TEAL)]: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    [(0, $38IWH.YELLOW)]: "var(--ds-background-accent-yellow-subtle, #F5CD47)",
    [(0, $38IWH.ORANGE)]: "var(--ds-background-accent-red-subtle, #F87168)",
    [(0, $38IWH.GREY)]: "var(--ds-background-accent-gray-subtle, #8590A2)",
    [(0, $38IWH.DARK_PURPLE)]: "var(--ds-background-accent-purple-bolder, #6E5DC6)",
    [(0, $38IWH.DARK_BLUE)]: "var(--ds-background-accent-blue-bolder, #0C66E4)",
    [(0, $38IWH.DARK_GREEN)]: "var(--ds-background-accent-green-bolder, #1F845A)",
    [(0, $38IWH.DARK_TEAL)]: "var(--ds-background-accent-teal-bolder, #227D9B)",
    [(0, $38IWH.DARK_YELLOW)]: "var(--ds-background-accent-orange-bolder, #C25100)",
    [(0, $38IWH.DARK_ORANGE)]: "var(--ds-background-accent-red-bolder, #C9372C)",
    [(0, $38IWH.DARK_GREY)]: "var(--ds-background-accent-gray-bolder, #626F86)"
};
const $f89c7f0e34657bc4$export$fc5fe4213a5703f1 = {
    [(0, $7bb4c1736002a04a$exports).P200]: "var(--ds-background-accent-purple-subtle, #9F8FEF)",
    [(0, $7bb4c1736002a04a$exports).B200]: "var(--ds-background-accent-blue-subtle, #579DFF)",
    [(0, $7bb4c1736002a04a$exports).G200]: "var(--ds-background-accent-green-subtle, #4BCE97)",
    [(0, $7bb4c1736002a04a$exports).T200]: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    [(0, $7bb4c1736002a04a$exports).Y200]: "var(--ds-background-accent-yellow-subtle, #F5CD47)",
    [(0, $7bb4c1736002a04a$exports).R200]: "var(--ds-background-accent-red-subtle, #F87168)",
    [(0, $7bb4c1736002a04a$exports).N200]: "var(--ds-background-accent-gray-subtle, #8590A2)",
    [(0, $7bb4c1736002a04a$exports).P400]: "var(--ds-background-accent-purple-bolder, #6E5DC6)",
    [(0, $7bb4c1736002a04a$exports).B400]: "var(--ds-background-accent-blue-bolder, #0C66E4)",
    [(0, $7bb4c1736002a04a$exports).G400]: "var(--ds-background-accent-green-bolder, #1F845A)",
    [(0, $7bb4c1736002a04a$exports).T400]: "var(--ds-background-accent-teal-bolder, #227D9B)",
    [(0, $7bb4c1736002a04a$exports).Y400]: "var(--ds-background-accent-orange-bolder, #C25100)",
    [(0, $7bb4c1736002a04a$exports).R400]: "var(--ds-background-accent-red-bolder, #C9372C)",
    [(0, $7bb4c1736002a04a$exports).N700]: "var(--ds-background-accent-gray-bolder, #626F86)"
};
const $f89c7f0e34657bc4$export$a6cb26e106674600 = (0, (/*@__PURE__*/$parcel$interopDefault($2IQEX)))($f89c7f0e34657bc4$export$db33d74b098e3da9);
const $f89c7f0e34657bc4$export$43264b0781f10167 = {
    [(0, $38IWH.SERVER_PURPLE)]: (0, $38IWH.PURPLE),
    [(0, $38IWH.SERVER_DARK_PURPLE)]: (0, $38IWH.DARK_PURPLE),
    [(0, $38IWH.SERVER_BLUE)]: (0, $38IWH.BLUE),
    [(0, $38IWH.SERVER_DARK_BLUE)]: (0, $38IWH.DARK_BLUE),
    [(0, $38IWH.SERVER_GREEN)]: (0, $38IWH.GREEN),
    [(0, $38IWH.SERVER_DARK_GREEN)]: (0, $38IWH.DARK_GREEN),
    [(0, $38IWH.SERVER_TEAL)]: (0, $38IWH.TEAL),
    [(0, $38IWH.SERVER_DARK_TEAL)]: (0, $38IWH.DARK_TEAL),
    [(0, $38IWH.SERVER_YELLOW)]: (0, $38IWH.YELLOW),
    [(0, $38IWH.SERVER_DARK_YELLOW)]: (0, $38IWH.DARK_YELLOW),
    [(0, $38IWH.SERVER_ORANGE)]: (0, $38IWH.ORANGE),
    [(0, $38IWH.SERVER_DARK_ORANGE)]: (0, $38IWH.DARK_ORANGE),
    [(0, $38IWH.SERVER_GREY)]: (0, $38IWH.GREY),
    [(0, $38IWH.SERVER_DARK_GREY)]: (0, $38IWH.DARK_GREY)
};
const $f89c7f0e34657bc4$export$aedca9f3a1ee43d7 = (0, (/*@__PURE__*/$parcel$interopDefault($2IQEX)))($f89c7f0e34657bc4$export$43264b0781f10167);
const $f89c7f0e34657bc4$export$fb5d051fe1b2bccc = {
    [(0, $38IWH.GHX_LABEL_1)]: (0, $38IWH.DARK_GREY),
    [(0, $38IWH.GHX_LABEL_2)]: (0, $38IWH.DARK_YELLOW),
    [(0, $38IWH.GHX_LABEL_3)]: (0, $38IWH.YELLOW),
    [(0, $38IWH.GHX_LABEL_4)]: (0, $38IWH.DARK_BLUE),
    [(0, $38IWH.GHX_LABEL_5)]: (0, $38IWH.DARK_TEAL),
    [(0, $38IWH.GHX_LABEL_6)]: (0, $38IWH.GREEN),
    [(0, $38IWH.GHX_LABEL_7)]: (0, $38IWH.PURPLE),
    [(0, $38IWH.GHX_LABEL_8)]: (0, $38IWH.DARK_PURPLE),
    [(0, $38IWH.GHX_LABEL_9)]: (0, $38IWH.ORANGE),
    [(0, $38IWH.GHX_LABEL_10)]: (0, $38IWH.BLUE),
    [(0, $38IWH.GHX_LABEL_11)]: (0, $38IWH.TEAL),
    [(0, $38IWH.GHX_LABEL_12)]: (0, $38IWH.GREY),
    [(0, $38IWH.GHX_LABEL_13)]: (0, $38IWH.DARK_GREEN),
    [(0, $38IWH.GHX_LABEL_14)]: (0, $38IWH.DARK_ORANGE)
};
const $f89c7f0e34657bc4$export$c13af2d9629c53d8 = (0, (/*@__PURE__*/$parcel$interopDefault($2IQEX)))($f89c7f0e34657bc4$export$fb5d051fe1b2bccc);
const $f89c7f0e34657bc4$export$994d3ffa39be04fd = {
    [(0, $38IWH.AGILE_COLOR_1)]: (0, $38IWH.DARK_GREY),
    [(0, $38IWH.AGILE_COLOR_2)]: (0, $38IWH.DARK_YELLOW),
    [(0, $38IWH.AGILE_COLOR_3)]: (0, $38IWH.YELLOW),
    [(0, $38IWH.AGILE_COLOR_4)]: (0, $38IWH.DARK_BLUE),
    [(0, $38IWH.AGILE_COLOR_5)]: (0, $38IWH.DARK_TEAL),
    [(0, $38IWH.AGILE_COLOR_6)]: (0, $38IWH.GREEN),
    [(0, $38IWH.AGILE_COLOR_7)]: (0, $38IWH.PURPLE),
    [(0, $38IWH.AGILE_COLOR_8)]: (0, $38IWH.DARK_PURPLE),
    [(0, $38IWH.AGILE_COLOR_9)]: (0, $38IWH.ORANGE),
    [(0, $38IWH.AGILE_COLOR_10)]: (0, $38IWH.BLUE),
    [(0, $38IWH.AGILE_COLOR_11)]: (0, $38IWH.TEAL),
    [(0, $38IWH.AGILE_COLOR_12)]: (0, $38IWH.GREY),
    [(0, $38IWH.AGILE_COLOR_13)]: (0, $38IWH.DARK_GREEN),
    [(0, $38IWH.AGILE_COLOR_14)]: (0, $38IWH.DARK_ORANGE)
};
const $f89c7f0e34657bc4$export$db17671bf37971e7 = (0, (/*@__PURE__*/$parcel$interopDefault($2IQEX)))($f89c7f0e34657bc4$export$994d3ffa39be04fd);
const $f89c7f0e34657bc4$export$1fdd5a248b5f697c = {
    [(0, $38IWH.GHX_LABEL_1)]: (0, $38IWH.AGILE_COLOR_1),
    [(0, $38IWH.GHX_LABEL_2)]: (0, $38IWH.AGILE_COLOR_2),
    [(0, $38IWH.GHX_LABEL_3)]: (0, $38IWH.AGILE_COLOR_3),
    [(0, $38IWH.GHX_LABEL_4)]: (0, $38IWH.AGILE_COLOR_4),
    [(0, $38IWH.GHX_LABEL_5)]: (0, $38IWH.AGILE_COLOR_5),
    [(0, $38IWH.GHX_LABEL_6)]: (0, $38IWH.AGILE_COLOR_6),
    [(0, $38IWH.GHX_LABEL_7)]: (0, $38IWH.AGILE_COLOR_7),
    [(0, $38IWH.GHX_LABEL_8)]: (0, $38IWH.AGILE_COLOR_8),
    [(0, $38IWH.GHX_LABEL_9)]: (0, $38IWH.AGILE_COLOR_9),
    [(0, $38IWH.GHX_LABEL_10)]: (0, $38IWH.AGILE_COLOR_10),
    [(0, $38IWH.GHX_LABEL_11)]: (0, $38IWH.AGILE_COLOR_11),
    [(0, $38IWH.GHX_LABEL_12)]: (0, $38IWH.AGILE_COLOR_12),
    [(0, $38IWH.GHX_LABEL_13)]: (0, $38IWH.AGILE_COLOR_13),
    [(0, $38IWH.GHX_LABEL_14)]: (0, $38IWH.AGILE_COLOR_14)
};
const $f89c7f0e34657bc4$export$82fc3b0b98905453 = {
    [(0, $38IWH.DARK_GREY)]: 'grey',
    [(0, $38IWH.DARK_YELLOW)]: 'yellow',
    [(0, $38IWH.YELLOW)]: 'yellowLight',
    [(0, $38IWH.DARK_BLUE)]: 'blue',
    [(0, $38IWH.DARK_TEAL)]: 'teal',
    [(0, $38IWH.GREEN)]: 'greenLight',
    [(0, $38IWH.PURPLE)]: 'purpleLight',
    [(0, $38IWH.DARK_PURPLE)]: 'purple',
    [(0, $38IWH.ORANGE)]: 'redLight',
    [(0, $38IWH.BLUE)]: 'blueLight',
    [(0, $38IWH.TEAL)]: 'tealLight',
    [(0, $38IWH.GREY)]: 'greyLight',
    [(0, $38IWH.DARK_GREEN)]: 'green',
    [(0, $38IWH.DARK_ORANGE)]: 'red'
};
const $f89c7f0e34657bc4$export$703aca53c431bb88 = {
    [(0, $38IWH.AGILE_COLOR_1)]: 'grey',
    [(0, $38IWH.AGILE_COLOR_2)]: 'yellow',
    [(0, $38IWH.AGILE_COLOR_3)]: 'yellowLight',
    [(0, $38IWH.AGILE_COLOR_4)]: 'blue',
    [(0, $38IWH.AGILE_COLOR_5)]: 'teal',
    [(0, $38IWH.AGILE_COLOR_6)]: 'greenLight',
    [(0, $38IWH.AGILE_COLOR_7)]: 'purpleLight',
    [(0, $38IWH.AGILE_COLOR_8)]: 'purple',
    [(0, $38IWH.AGILE_COLOR_9)]: 'redLight',
    [(0, $38IWH.AGILE_COLOR_10)]: 'blueLight',
    [(0, $38IWH.AGILE_COLOR_11)]: 'tealLight',
    [(0, $38IWH.AGILE_COLOR_12)]: 'greyLight',
    [(0, $38IWH.AGILE_COLOR_13)]: 'green',
    [(0, $38IWH.AGILE_COLOR_14)]: 'red'
};
const $f89c7f0e34657bc4$export$92b6aebfb522f0d9 = {
    [(0, $38IWH.PURPLE)]: {
        primary: "var(--ds-background-accent-purple-subtle, #9F8FEF)",
        secondary: "var(--ds-background-accent-purple-bolder, #6E5DC6)",
        text: "var(--ds-text-accent-purple, #5E4DB2)",
        textBackground: "var(--ds-background-accent-purple-subtler, #DFD8FD)",
        border: "var(--ds-border-accent-purple, #8270DB)",
        line: "var(--ds-border-accent-purple, #8270DB)",
        primaryGradient: "var(--ds-background-accent-purple-subtler, #DFD8FD)",
        hasContrastSecondaryGradient: true
    },
    [(0, $38IWH.BLUE)]: {
        primary: "var(--ds-background-accent-blue-subtle, #579DFF)",
        secondary: "var(--ds-background-accent-blue-bolder, #0C66E4)",
        text: "var(--ds-text-accent-blue, #0055CC)",
        textBackground: "var(--ds-background-accent-blue-subtler, #CCE0FF)",
        border: "var(--ds-border-accent-blue, #1D7AFC)",
        line: "var(--ds-border-accent-blue, #1D7AFC)",
        primaryGradient: "var(--ds-background-accent-blue-subtler, #CCE0FF)",
        hasContrastSecondaryGradient: true
    },
    [(0, $38IWH.GREEN)]: {
        primary: "var(--ds-background-accent-green-subtle, #4BCE97)",
        secondary: "var(--ds-background-accent-green-bolder, #1F845A)",
        text: "var(--ds-text-accent-green, #216E4E)",
        textBackground: "var(--ds-background-accent-green-subtler, #BAF3DB)",
        border: "var(--ds-border-accent-green, #22A06B)",
        line: "var(--ds-border-accent-green, #22A06B)",
        primaryGradient: "var(--ds-background-accent-green-subtler, #BAF3DB)",
        hasContrastSecondaryGradient: true
    },
    [(0, $38IWH.TEAL)]: {
        primary: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
        secondary: "var(--ds-background-accent-teal-bolder, #227D9B)",
        text: "var(--ds-text-accent-teal, #206A83)",
        textBackground: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
        border: "var(--ds-border-accent-teal, #2898BD)",
        line: "var(--ds-border-accent-teal, #2898BD)",
        primaryGradient: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
        hasContrastSecondaryGradient: true
    },
    [(0, $38IWH.YELLOW)]: {
        primary: "var(--ds-background-accent-yellow-subtle, #F5CD47)",
        secondary: "var(--ds-background-accent-yellow-bolder, #946F00)",
        text: "var(--ds-text-accent-yellow, #7F5F01)",
        textBackground: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
        border: "var(--ds-border-accent-yellow, #B38600)",
        line: "var(--ds-border-accent-yellow, #B38600)",
        primaryGradient: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
        hasContrastSecondaryGradient: true
    },
    [(0, $38IWH.ORANGE)]: {
        primary: "var(--ds-background-accent-red-subtle, #F87168)",
        secondary: "var(--ds-background-accent-red-bolder, #C9372C)",
        text: "var(--ds-text-accent-red, #AE2E24)",
        textBackground: "var(--ds-background-accent-red-subtler, #FFD5D2)",
        border: "var(--ds-border-accent-red, #E2483D)",
        line: "var(--ds-border-accent-red, #E2483D)",
        primaryGradient: "var(--ds-background-accent-red-subtler, #FFD5D2)",
        hasContrastSecondaryGradient: true
    },
    [(0, $38IWH.GREY)]: {
        primary: "var(--ds-background-accent-gray-subtle, #8590A2)",
        secondary: "var(--ds-background-accent-gray-bolder, #626F86)",
        text: "var(--ds-text-accent-gray, #44546F)",
        textBackground: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
        border: "var(--ds-border-accent-gray, #758195)",
        line: "var(--ds-border-accent-gray, #758195)",
        primaryGradient: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
        hasContrastSecondaryGradient: true
    },
    [(0, $38IWH.DARK_PURPLE)]: {
        primary: "var(--ds-background-accent-purple-bolder, #6E5DC6)",
        secondary: "var(--ds-background-accent-purple-subtle, #9F8FEF)",
        text: "var(--ds-text-inverse, #FFFFFF)",
        textBackground: "var(--ds-background-accent-purple-bolder, #6E5DC6)",
        border: "var(--ds-border-accent-purple, #8270DB)",
        line: "var(--ds-border-accent-purple, #8270DB)",
        primaryGradient: "var(--ds-background-accent-purple-subtle, #9F8FEF)",
        hasContrastSecondaryGradient: false
    },
    [(0, $38IWH.DARK_BLUE)]: {
        primary: "var(--ds-background-accent-blue-bolder, #0C66E4)",
        secondary: "var(--ds-background-accent-blue-subtle, #579DFF)",
        text: "var(--ds-text-inverse, #FFFFFF)",
        textBackground: "var(--ds-background-accent-blue-bolder, #0C66E4)",
        border: "var(--ds-border-accent-blue, #1D7AFC)",
        line: "var(--ds-border-accent-blue, #1D7AFC)",
        primaryGradient: "var(--ds-background-accent-blue-subtle, #579DFF)",
        hasContrastSecondaryGradient: false
    },
    [(0, $38IWH.DARK_GREEN)]: {
        primary: "var(--ds-background-accent-green-bolder, #1F845A)",
        secondary: "var(--ds-background-accent-green-subtle, #4BCE97)",
        text: "var(--ds-text-inverse, #FFFFFF)",
        textBackground: "var(--ds-background-accent-green-bolder, #1F845A)",
        border: "var(--ds-border-accent-green, #22A06B)",
        line: "var(--ds-border-accent-green, #22A06B)",
        primaryGradient: "var(--ds-background-accent-green-subtle, #4BCE97)",
        hasContrastSecondaryGradient: false
    },
    [(0, $38IWH.DARK_TEAL)]: {
        primary: "var(--ds-background-accent-teal-bolder, #227D9B)",
        secondary: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
        text: "var(--ds-text-inverse, #FFFFFF)",
        textBackground: "var(--ds-background-accent-teal-bolder, #227D9B)",
        border: "var(--ds-border-accent-teal, #2898BD)",
        line: "var(--ds-border-accent-teal, #2898BD)",
        primaryGradient: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
        hasContrastSecondaryGradient: false
    },
    [(0, $38IWH.DARK_YELLOW)]: {
        primary: "var(--ds-background-accent-orange-bolder, #C25100)",
        secondary: "var(--ds-background-accent-orange-subtle, #FEA362)",
        text: "var(--ds-text-inverse, #FFFFFF)",
        textBackground: "var(--ds-background-accent-orange-bolder, #C25100)",
        border: "var(--ds-background-accent-orange-subtle, #FEA362)",
        line: "var(--ds-border-accent-orange, #E56910)",
        primaryGradient: "var(--ds-background-accent-orange-subtle, #FEA362)",
        hasContrastSecondaryGradient: false
    },
    [(0, $38IWH.DARK_ORANGE)]: {
        primary: "var(--ds-background-accent-red-bolder, #C9372C)",
        secondary: "var(--ds-background-accent-red-subtle, #F87168)",
        text: "var(--ds-text-inverse, #FFFFFF)",
        textBackground: "var(--ds-background-accent-red-bolder, #C9372C)",
        border: "var(--ds-background-accent-red-subtle, #F87168)",
        line: "var(--ds-border-accent-red, #E2483D)",
        primaryGradient: "var(--ds-background-accent-red-subtle, #F87168)",
        hasContrastSecondaryGradient: false
    },
    [(0, $38IWH.DARK_GREY)]: {
        primary: "var(--ds-background-accent-gray-bolder, #626F86)",
        secondary: "var(--ds-background-accent-gray-subtle, #8590A2)",
        text: "var(--ds-text-inverse, #FFFFFF)",
        textBackground: "var(--ds-background-accent-gray-bolder, #626F86)",
        border: "var(--ds-background-accent-gray-subtle, #8590A2)",
        line: "var(--ds-border-accent-gray, #758195)",
        primaryGradient: "var(--ds-background-accent-gray-subtle, #8590A2)",
        hasContrastSecondaryGradient: false
    }
};

});

parcelRegister("efpPR", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5a8789e55bcd8e1$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $f5a8789e55bcd8e1$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    purpleLabel: {
        "id": "issue-epic-color.common.purple-label",
        "defaultMessage": "purple"
    },
    blueLabel: {
        "id": "issue-epic-color.common.blue-label",
        "defaultMessage": "blue"
    },
    greenLabel: {
        "id": "issue-epic-color.common.green-label",
        "defaultMessage": "green"
    },
    tealLabel: {
        "id": "issue-epic-color.common.teal-label",
        "defaultMessage": "teal"
    },
    yellowLabel: {
        "id": "issue-epic-color.common.yellow-label",
        "defaultMessage": "yellow"
    },
    orangeLabel: {
        "id": "issue-epic-color.common.orange-label",
        "defaultMessage": "orange"
    },
    greyLabel: {
        "id": "issue-epic-color.common.grey-label",
        "defaultMessage": "grey"
    },
    darkPurpleLabel: {
        "id": "issue-epic-color.common.dark-purple-label",
        "defaultMessage": "dark purple"
    },
    darkBlueLabel: {
        "id": "issue-epic-color.common.dark-blue-label",
        "defaultMessage": "dark blue"
    },
    darkGreenLabel: {
        "id": "issue-epic-color.common.dark-green-label",
        "defaultMessage": "dark green"
    },
    darkTealLabel: {
        "id": "issue-epic-color.common.dark-teal-label",
        "defaultMessage": "dark teal"
    },
    darkYellowLabel: {
        "id": "issue-epic-color.common.dark-yellow-label",
        "defaultMessage": "dark yellow"
    },
    darkOrangeLabel: {
        "id": "issue-epic-color.common.dark-orange-label",
        "defaultMessage": "dark orange"
    },
    darkGreyLabel: {
        "id": "issue-epic-color.common.dark-grey-label",
        "defaultMessage": "dark grey"
    }
});

});


const $b1390050e18cf57c$export$4a4db137834138dd = 'FETCH_PARENT_FIELD_NOT_FOUND';
const $b1390050e18cf57c$export$aa7d91b2fd1ba261 = 'FETCH_PARENT_FIELD_DETAILS_MISSING_DATA';
const $b1390050e18cf57c$export$494a54d93664524d = 'FETCH_PARENT_FIELD_UNKNOWN_ERROR';
const $b1390050e18cf57c$export$db8af5ee2c36776e = 'FETCH_PARENT_FIELD_DETAILS_REQUEST_FAILED';

parcelRegister("aUnLt", function(module, exports) {

$parcel$export(module.exports, "isJiraIssueTypeFieldNode", () => $4d11db0490f2481e$export$57eda1f5ad7133c3);
$parcel$export(module.exports, "isJiraSingleLineTextFieldNode", () => $4d11db0490f2481e$export$ea2b75e2537cbccf);
$parcel$export(module.exports, "isJiraStatusFieldNode", () => $4d11db0490f2481e$export$1a148ec51054fc5a);
$parcel$export(module.exports, "fetchParentIssueDetails", () => $4d11db0490f2481e$export$ef5c4d73a6136d96);
$parcel$export(module.exports, "checkParentIssueIsDone", () => $4d11db0490f2481e$export$2b30e3fdda29f6);

var $2ApNu = parcelRequire("2ApNu");

var $7keuM = parcelRequire("7keuM");

var $l6Jfp = parcelRequire("l6Jfp");

var $fVpjy = parcelRequire("fVpjy");

const $4d11db0490f2481e$export$57eda1f5ad7133c3 = (node)=>node?.__typename === 'JiraIssueTypeField';
const $4d11db0490f2481e$export$ea2b75e2537cbccf = (node)=>node?.__typename === 'JiraSingleLineTextField';
const $4d11db0490f2481e$export$1a148ec51054fc5a = (node)=>node?.__typename === 'JiraStatusField';
const $4d11db0490f2481e$export$6ba84cffc20b9772 = (0, $l6Jfp.gqlTagGira)`
  query ParentIssueDetailsQuery($ari: ID!) {
    jira {
      issueById(id: $ari) {
        issueId
        key
        issueColorField {
          color {
            colorKey
          }
        }
        fieldsById(ids: ["summary", "issuetype", "status"]) {
          edges {
            node {
              __typename
              ... on JiraIssueTypeField {
                fieldId
                issueType {
                  issueTypeId
                  name
                  avatar {
                    xsmall
                  }
                }
              }
              ... on JiraSingleLineTextField {
                fieldId
                text
              }
              ... on JiraStatusField {
                fieldId
                status {
                  statusCategory {
                    statusCategoryId
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
async function $4d11db0490f2481e$export$ef5c4d73a6136d96(siteId, issueId) {
    try {
        const variables = {
            ari: (0, $2ApNu.JiraIssueAri).create({
                siteId: siteId,
                issueId: issueId
            }).toString()
        };
        const { data: data } = await (0, $fVpjy.getClient)().query({
            query: $4d11db0490f2481e$export$6ba84cffc20b9772,
            variables: variables,
            operationName: 'ParentIssueDetailsQuery'
        });
        return data;
    } catch (error) {
        throw new Error(`Error fetching data for parent issue with issueId "${issueId}"`, {
            cause: (0, $b1390050e18cf57c$export$db8af5ee2c36776e)
        });
    }
}
const $4d11db0490f2481e$export$2b30e3fdda29f6 = (node)=>{
    const doneStatusCategoryId = (0, $7keuM).StatusCategoryIds[(0, $7keuM).StatusCategoryTypes.DONE];
    return doneStatusCategoryId && String(doneStatusCategoryId) === node.status?.statusCategory?.statusCategoryId;
};

});
parcelRegister("7keuM", function(module, exports) {

$parcel$export(module.exports, "UNDEFINED", () => $e9fafd5bde6d9f47$export$6db089fe7b26f5b6);
$parcel$export(module.exports, "TODO", () => $e9fafd5bde6d9f47$export$aa456a5030160740);
$parcel$export(module.exports, "IN_PROGRESS", () => $e9fafd5bde6d9f47$export$5a9ac66c2785cc13);
$parcel$export(module.exports, "DONE", () => $e9fafd5bde6d9f47$export$71efb3495f6084f2);
$parcel$export(module.exports, "STATUS_CATEGORIES", () => $e9fafd5bde6d9f47$export$d9119300f9d9a815);
$parcel$export(module.exports, "StatusCategoryTypes", () => $e9fafd5bde6d9f47$export$5d42a08d46cffe7);
$parcel$export(module.exports, "StatusCategoryIds", () => $e9fafd5bde6d9f47$export$3f42f49c284d5b58);
$parcel$export(module.exports, "statusCategoryKeys", () => $e9fafd5bde6d9f47$export$f3f919dc0f56d9eb);
$parcel$export(module.exports, "statusCategoryForId", () => $e9fafd5bde6d9f47$export$3e9e3002956ff4fb);
$parcel$export(module.exports, "categoryIdForStatusCategory", () => $e9fafd5bde6d9f47$export$7b16b0022aac2d46);
$parcel$export(module.exports, "isValidStatusCategoryKey", () => $e9fafd5bde6d9f47$export$d928f247c903643a);
const $e9fafd5bde6d9f47$export$6db089fe7b26f5b6 = 'UNDEFINED';
const $e9fafd5bde6d9f47$export$aa456a5030160740 = 'TODO';
const $e9fafd5bde6d9f47$export$5a9ac66c2785cc13 = 'IN_PROGRESS';
const $e9fafd5bde6d9f47$export$71efb3495f6084f2 = 'DONE';
const $e9fafd5bde6d9f47$export$d9119300f9d9a815 = [
    $e9fafd5bde6d9f47$export$6db089fe7b26f5b6,
    $e9fafd5bde6d9f47$export$aa456a5030160740,
    $e9fafd5bde6d9f47$export$5a9ac66c2785cc13,
    $e9fafd5bde6d9f47$export$71efb3495f6084f2
];
const $e9fafd5bde6d9f47$var$statusCategories = [
    {
        id: '1',
        statusCategory: $e9fafd5bde6d9f47$export$6db089fe7b26f5b6
    },
    {
        id: '2',
        statusCategory: $e9fafd5bde6d9f47$export$aa456a5030160740
    },
    {
        id: '4',
        statusCategory: $e9fafd5bde6d9f47$export$5a9ac66c2785cc13
    },
    {
        id: '3',
        statusCategory: $e9fafd5bde6d9f47$export$71efb3495f6084f2
    }
];
const $e9fafd5bde6d9f47$export$5d42a08d46cffe7 = Object.freeze({
    NEW: 'new',
    INDETERMINATE: 'indeterminate',
    DONE: 'done',
    UNDEFINED: 'undefined'
});
const $e9fafd5bde6d9f47$export$3f42f49c284d5b58 = Object.freeze({
    [$e9fafd5bde6d9f47$export$5d42a08d46cffe7.UNDEFINED]: 1,
    [$e9fafd5bde6d9f47$export$5d42a08d46cffe7.NEW]: 2,
    [$e9fafd5bde6d9f47$export$5d42a08d46cffe7.DONE]: 3,
    [$e9fafd5bde6d9f47$export$5d42a08d46cffe7.INDETERMINATE]: 4
});
const $e9fafd5bde6d9f47$export$f3f919dc0f56d9eb = Object.values($e9fafd5bde6d9f47$export$5d42a08d46cffe7);
const $e9fafd5bde6d9f47$export$3e9e3002956ff4fb = (statusCategoryId)=>{
    const value = $e9fafd5bde6d9f47$var$statusCategories.find((sc)=>sc.id === String(statusCategoryId));
    return value ? value.statusCategory : $e9fafd5bde6d9f47$export$6db089fe7b26f5b6;
};
const $e9fafd5bde6d9f47$export$7b16b0022aac2d46 = (statusCategory)=>{
    const value = $e9fafd5bde6d9f47$var$statusCategories.find((sc)=>sc.statusCategory === statusCategory);
    return Number(value ? value.id : '1');
};
const $e9fafd5bde6d9f47$export$d928f247c903643a = (key)=>$e9fafd5bde6d9f47$export$f3f919dc0f56d9eb.some((statusCategoryKey)=>statusCategoryKey === key);

});

parcelRegister("l6Jfp", function(module, exports) {

$parcel$export(module.exports, "NUM_INITIAL_COMMENTS_TO_LOAD", () => $bba965161d9cb764$export$c46d621c29194aa4);
$parcel$export(module.exports, "NUM_INITIAL_WORKLOGS_TO_LOAD", () => $bba965161d9cb764$export$b2e398ce246f55b3);
$parcel$export(module.exports, "gqlTagGira", () => $bba965161d9cb764$export$aeae6fc40846cf9f);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports














const $bba965161d9cb764$export$c46d621c29194aa4 = 5;
const $bba965161d9cb764$export$304a6c004edb30d8 = '-created';
const $bba965161d9cb764$export$b2e398ce246f55b3 = 5;
const $bba965161d9cb764$export$1c36ecc9afd61c73 = '-started';
const $bba965161d9cb764$export$aeae6fc40846cf9f = (literals, ...substitutions)=>{
    let result = '';
    // run the loop only for the substitution count
    substitutions.forEach((key, i)=>{
        result += literals[i];
        result += key.toString();
    });
    // add the last literal
    result += literals[literals.length - 1];
    return result;
};

});

parcelRegister("fVpjy", function(module, exports) {

$parcel$export(module.exports, "getClient", () => $ef8531d5e19bae40$export$6bb76d6eba7e258c);

var $1Ozm9 = parcelRequire("1Ozm9");

var $8DQlA = parcelRequire("8DQlA");
const $ef8531d5e19bae40$var$makeFetchClient = ()=>({
        query: ({ query: query, variables: variables, signal: signal, operationName: operationName })=>(0, $1Ozm9.default)((0, $8DQlA.getGiraUrl)(operationName), {
                method: 'POST',
                body: JSON.stringify({
                    query: query,
                    variables: variables,
                    operationName: operationName
                }),
                signal: signal
            })
    });
let $ef8531d5e19bae40$var$client;
const $ef8531d5e19bae40$export$6bb76d6eba7e258c = ()=>{
    if (!$ef8531d5e19bae40$var$client) $ef8531d5e19bae40$var$client = $ef8531d5e19bae40$var$makeFetchClient();
    return $ef8531d5e19bae40$var$client;
};

});
parcelRegister("8DQlA", function(module, exports) {

$parcel$export(module.exports, "ISSUE_VIEW_INTERACTIVE_QUERY", () => $2f4d1124325e51fb$export$1780a132c0453fee);
$parcel$export(module.exports, "getGiraUrl", () => $2f4d1124325e51fb$export$aefb19023b2eda55);
$parcel$export(module.exports, "getJiraQueryEcosystemFirstSeenOnIssueView", () => $2f4d1124325e51fb$export$79eba9bf6dc9960d);
$parcel$export(module.exports, "buildIssueQuery", () => $2f4d1124325e51fb$export$222ae9aca08830f0);
$parcel$export(module.exports, "getGiraRequestOptions", () => $2f4d1124325e51fb$export$e1542dc7ff749de8);
/**
 * ╔═══════════════╗
 * ║ !!IMPORTANT!! ║
 * ╚═══════════════╝
 * Please do not use statsig feature gating in this file.
 * Read https://hello.atlassian.net/wiki/spaces/JIE/pages/2858513117/Blockers+for+Statsig+in+the+issue-view
 * for why and to follow the fix.
 */ 
var $cTI7h = parcelRequire("cTI7h");

var $f8B5B = parcelRequire("f8B5B");

var $c6t82 = parcelRequire("c6t82");

var $lGt35 = parcelRequire("lGt35");

var $l6Jfp = parcelRequire("l6Jfp");

var $avnia = parcelRequire("avnia");

var $efm76 = parcelRequire("efm76");

var $cEdKD = parcelRequire("cEdKD");

var $g6Y30 = parcelRequire("g6Y30");

var $hif4C = parcelRequire("hif4C");

var $7JZFE = parcelRequire("7JZFE");

var $cvLHO = parcelRequire("cvLHO");
const $2f4d1124325e51fb$var$CREATED_ORDER_DESCENDING = '-created';
const $2f4d1124325e51fb$export$1780a132c0453fee = 'issueViewInteractiveQuery';
const $2f4d1124325e51fb$export$aefb19023b2eda55 = (operation)=>`/rest/gira/1/${(0, $cTI7h.appendOperationQuery)(operation)}`;
// JIV-19906: retrieve query string from URL -- only expected to be used by client side code
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $2f4d1124325e51fb$var$getURLFromWindow = ()=>new URL(window.location.href);
const $2f4d1124325e51fb$var$viewIssueQuery = (url = $2f4d1124325e51fb$var$getURLFromWindow())=>`
    viewIssue(issueKey: $issueKey) {
        canCreateSubTask
        canExportIssue
        ${/**
					 * THIS QUERY ONLY FETCHES TOTAL COUNT OF COMMENTS
					 * For all other comment related data, use AGG endpoints
					 * Note: When activity sorting feature is enabled, we do not
					 * want to fetch with sort order passed through; we should defer
					 * to the saved sort order in the backend to return the correct
					 * sort order
					 */ (0, $f8B5B.default)({
        maxResults: (0, $l6Jfp.NUM_INITIAL_COMMENTS_TO_LOAD),
        startAt: 0,
        orderBy: $2f4d1124325e51fb$var$CREATED_ORDER_DESCENDING,
        commentAmount: Math.floor((0, $l6Jfp.NUM_INITIAL_COMMENTS_TO_LOAD)),
        url: url
    })}
        ${/**
					 * Note: When activity sorting feature is enabled, we do not
					 * want to fetch with sort order passed through; we should defer
					 * to the saved sort order in the backend to return the correct
					 * sort order
					 */ (0, $cvLHO.default)({
        startAt: 0,
        worklogAmount: Math.floor((0, $l6Jfp.NUM_INITIAL_WORKLOGS_TO_LOAD)),
        url: url
    })}
        ${(0, $lGt35.getEcosystemQuery)()}
        ${(0, $c6t82.getContentPanelsQuery)()}
        ${(0, $lGt35.getLegacyRightWebPanelsQuery)()}
        totalAttachmentsCount
        ${(0, $efm76.getContainersByTypeQuery)()}
        ${(0, $7JZFE.getRemoteLinksQuery)()}
    }
`;
const $2f4d1124325e51fb$export$79eba9bf6dc9960d = ()=>`
    jira {
        ecosystemFirstSeenOnIssueView
    }
`;
const $2f4d1124325e51fb$export$58eaa2ae4a5a410a = ()=>`
    jira {
        ecosystemFirstSeenOnIssueView
        hasAdministerPermission: hasGlobalPermission(key: ADMINISTER)
        hasUserPickerPermission: hasGlobalPermission(key: USER_PICKER)
    }
`;
const $2f4d1124325e51fb$export$222ae9aca08830f0 = (url)=>`
query ${$2f4d1124325e51fb$export$1780a132c0453fee}($issueKey: String!, $projectKey: String)  {
        ${$2f4d1124325e51fb$export$58eaa2ae4a5a410a()}
        ${(0, $cEdKD.default)()}
        ${$2f4d1124325e51fb$var$viewIssueQuery(url)}
        ${(0, $avnia.getJiraSettingsQuery)()}
        ${(0, $g6Y30.default)()}
        ${(0, $hif4C.default)()}
    }

`;
const $2f4d1124325e51fb$export$e1542dc7ff749de8 = (issueKey, projectKey, url)=>{
    const payload = {
        operationName: $2f4d1124325e51fb$export$1780a132c0453fee,
        query: $2f4d1124325e51fb$export$222ae9aca08830f0(url),
        variables: {
            issueKey: issueKey,
            projectKey: projectKey
        }
    };
    return {
        method: 'POST',
        body: JSON.stringify(payload)
    };
};

});
parcelRegister("cTI7h", function(module, exports) {

$parcel$export(module.exports, "appendOperationQuery", () => $237ed4c9607e5b1c$export$69694c3add0f6058);
const $237ed4c9607e5b1c$export$69694c3add0f6058 = (operation)=>operation ? `?operation=${operation}` : '';

});

parcelRegister("f8B5B", function(module, exports) {

$parcel$export(module.exports, "default", () => $53da8aef2f05bd3c$export$2e2bcd8739ae039);

var $d60Hm = parcelRequire("d60Hm");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$53da8aef2f05bd3c$export$2e2bcd8739ae039 = ({ maxResults: maxResults, startAt: startAt, orderBy: orderBy, commentAmount: commentAmount, url: url })=>{
    const commentPermalinkId = url ? (0, $d60Hm.getPermalinkIdFromURL)((0, $d60Hm.COMMENTS), url) : (0, $d60Hm.getPermalinkId)((0, $d60Hm.COMMENTS));
    const orderByParameter = orderBy !== null && orderBy !== undefined ? `, orderBy: "${orderBy}"` : '';
    const commentParameter = commentPermalinkId !== null && commentPermalinkId !== undefined ? `, commentId: ${commentPermalinkId}` : '';
    const commentAmountParameter = commentParameter !== '' && commentAmount !== null && commentAmount !== undefined ? `, commentAmount: ${commentAmount}` : '';
    const maxResultsParameter = commentParameter === '' && maxResults !== null && maxResults !== undefined ? `, maxResults: ${maxResults}` : '';
    return `
        comments (first: ${startAt}${maxResultsParameter}${orderByParameter}${commentParameter}${commentAmountParameter}) {
            totalCount
        }
    `;
};

});
parcelRegister("d60Hm", function(module, exports) {

$parcel$export(module.exports, "COMMENTS", () => $795b06e1e9a5d895$export$4cab9dfa8fc858f4);
$parcel$export(module.exports, "WORKLOG", () => $795b06e1e9a5d895$export$df36fc05622c402);
$parcel$export(module.exports, "getAllUrlParams", () => $795b06e1e9a5d895$export$dca91ad250f6b082);
$parcel$export(module.exports, "getPermalinkId", () => $795b06e1e9a5d895$export$bf42dbba4c31080e);
$parcel$export(module.exports, "getPermalinkIdFromURL", () => $795b06e1e9a5d895$export$87557f913748dcff);

var $gRw8I = parcelRequire("gRw8I");

var $eSnSE = parcelRequire("eSnSE");
const $795b06e1e9a5d895$export$b18d061fc042df1a = {
    COMMENTS: 'focusedCommentId',
    WORKLOG: 'focusedWorklogId'
};
const $795b06e1e9a5d895$export$4cab9dfa8fc858f4 = 'COMMENTS';
const $795b06e1e9a5d895$export$df36fc05622c402 = 'WORKLOG';
/**
 * @deprecated this function is unsafe for using on server side code due to `window` object usage
 */ const $795b06e1e9a5d895$export$dca91ad250f6b082 = ()=>{
    (0, $gRw8I.di)(window);
    // get query string from  window
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    let queryString = window.location.search.slice(1);
    // we'll store the parameters here
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const obj = {};
    // if query string exists
    if (queryString) {
        // stuff after # is not part of query string, so get rid of it
        queryString = queryString.split('#')[0];
        // split our query string into its component parts
        const arr = queryString.split('&');
        for(let i = 0; i < arr.length; i += 1){
            // separate the keys and the values
            const a = arr[i].split('=');
            // set parameter name and value (use 'true' if empty)
            const paramName = a[0];
            try {
                const paramValue = typeof a[1] === 'undefined' ? true : decodeURIComponent(a[1]);
                obj[paramName] = paramValue;
            } catch (error) {
                (0, $eSnSE.default).safeErrorWithoutCustomerData('getAllUrlParams', `Malformed value was obtained from the query string for ${paramName}`);
            }
        }
    }
    return obj;
};
const $795b06e1e9a5d895$export$bf42dbba4c31080e = (targetPermalinkType)=>{
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly COMMENTS: "focusedCommentId"; readonly WORKLOG: "focusedWorklogId"; }'.
    if (!$795b06e1e9a5d895$export$b18d061fc042df1a[targetPermalinkType]) return null;
    const urlParams = $795b06e1e9a5d895$export$dca91ad250f6b082();
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly COMMENTS: "focusedCommentId"; readonly WORKLOG: "focusedWorklogId"; }'.
    return urlParams[$795b06e1e9a5d895$export$b18d061fc042df1a[targetPermalinkType]];
};
const $795b06e1e9a5d895$export$87557f913748dcff = (targetPermalinkType, url)=>{
    const queryParamKey = $795b06e1e9a5d895$export$b18d061fc042df1a[targetPermalinkType];
    if (!queryParamKey) return null;
    return url.searchParams.get(queryParamKey);
};

});


parcelRegister("c6t82", function(module, exports) {

$parcel$export(module.exports, "getContentPanelsQuery", () => $4249a4b796c65712$export$e6f14eac549b679d);
const $4249a4b796c65712$var$getContentPanelNode = ()=>`
    name
    addonKey
    moduleKey
    options
    iconUrl
    tooltip
    type
    isShownByDefault
    wasManuallyAddedToIssue
`;
const $4249a4b796c65712$var$getContentPanelsConnectionQuery = ()=>`
    contentPanels {
        edges {
            node {
                ${$4249a4b796c65712$var$getContentPanelNode()}
            }
        }
    }
`;
const $4249a4b796c65712$var$getLegacyContentPanelsConnectionQuery = ()=>`
    legacyContentPanels {
        edges {
            node {
                ${$4249a4b796c65712$var$getContentPanelNode()}
            }
        }
    }
`;
const $4249a4b796c65712$export$e6f14eac549b679d = ()=>`
    ${$4249a4b796c65712$var$getContentPanelsConnectionQuery()}
    ${$4249a4b796c65712$var$getLegacyContentPanelsConnectionQuery()}
    hasCustomisedContentPanels
`;

});

parcelRegister("lGt35", function(module, exports) {

$parcel$export(module.exports, "getEcosystemQuery", () => $5d3bcfb4ca889012$export$edefef8c65e08bd2);
$parcel$export(module.exports, "getLegacyRightWebPanelsQuery", () => $5d3bcfb4ca889012$export$92c9a3dc7076af51);
const $5d3bcfb4ca889012$var$getForgeQuery = ()=>`forge {
        panels {
          id
          instances {
            id
            collapsed
            added
          }
        }
      }`;
const $5d3bcfb4ca889012$export$edefef8c65e08bd2 = ()=>`
    ecosystem {
      activityPanels {
        name
        iframe {
          addonKey
          moduleKey
          options
        }
      }
      contextPanels {
        name
        iframe {
          addonKey
          moduleKey
          options
        }
        icon {
          url
        }
        content
        status
        type
      }
      ${$5d3bcfb4ca889012$var$getForgeQuery()}
    }
`;
const $5d3bcfb4ca889012$export$92c9a3dc7076af51 = ()=>`
        legacyRightWebPanels {
          edges {
            node {
              name
              status
              addonKey
              moduleKey
              options
              content
            }
          }
        }
      `;

});

parcelRegister("avnia", function(module, exports) {

$parcel$export(module.exports, "getJiraSettingsQuery", () => $0d65d613f30838ca$export$191f50c0f86b85ec);
const $0d65d613f30838ca$export$e302502f14e3f203 = ()=>`
          timeTracking {
            isTimeTrackingEnabled
            hoursPerDay
            daysPerWeek
            defaultUnit
            format
          }
    `;
const $0d65d613f30838ca$export$65e7d3d1915962da = ()=>`
          subtasks {
            enabled
          }
    `;
const $0d65d613f30838ca$export$191f50c0f86b85ec = ()=>`
    jiraSettings {
      newIssueViewTransitionSettings {
        shouldDelayChangeboarding
        newIssueViewTransitionLockingStatus
     }
    }
`;

});

parcelRegister("efm76", function(module, exports) {

$parcel$export(module.exports, "getContainersByTypeQuery", () => $ce3bfce6001e529c$export$63131b2831854cc);

var $hbF3h = parcelRequire("hbF3h");

var $7jTnu = parcelRequire("7jTnu");
const $ce3bfce6001e529c$export$e30f32dd3fd26efd = ()=>`
containersByType(input:{systemContainerTypes: [CONTENT, PRIMARY, SECONDARY, REQUEST_PORTAL], supportDefaultTab: true}) {
__typename
... on JiraIssueItemContainers {
containers {
  containerType
  items {
    nodes {
      type: __typename
      ... on JiraIssueItemFieldItem {
        fieldItemId        
      }
      ... on JiraIssueItemPanelItem {
        panelItemId
      }
      ... on JiraIssueItemTabContainer {
        name
        tabContainerId              
        items {
          nodes {
            type: __typename
            ... on JiraIssueItemFieldItem {
              fieldItemId
            }
          }
        }
      }
    }
  }
}
}
}
`;
const $ce3bfce6001e529c$export$842411c0b98baa9c = ()=>`
containersByType(input:{systemContainerTypes: [CONTENT, PRIMARY, SECONDARY, REQUEST_PORTAL, CUSTOMER_CONTEXT], supportDefaultTab: true}) {
__typename
... on JiraIssueItemContainers {
containers {
  containerType
  items {
    nodes {
      type: __typename
      ... on JiraIssueItemFieldItem {
        fieldItemId        
      }
      ... on JiraIssueItemPanelItem {
        panelItemId
      }
      ... on JiraIssueItemTabContainer {
        name
        tabContainerId              
        items {
          nodes {
            type: __typename
            ... on JiraIssueItemFieldItem {
              fieldItemId
            }
          }
        }
      }
    }
  }
}
}
}
`;
const $ce3bfce6001e529c$export$63131b2831854cc = (0, $hbF3h.functionWithCondition)(()=>(0, $7jTnu.fg)('jcs_master_flag'), $ce3bfce6001e529c$export$842411c0b98baa9c, $ce3bfce6001e529c$export$e30f32dd3fd26efd);

});

parcelRegister("cEdKD", function(module, exports) {

$parcel$export(module.exports, "default", () => $8daa13ccb825551d$export$2e2bcd8739ae039);

var $cGVqS = parcelRequire("cGVqS");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8daa13ccb825551d$export$2e2bcd8739ae039 = ()=>`mediaContext(issueKey: $issueKey) {
    userToken {
      token
      id
      issueId
      tokenDurationInMins
    }
    uploadToken {
      __typename
      ... on MediaUploadToken {
        endpointUrl
        token
        targetCollection
        tokenDurationInMins
        clientId
      }
      ... on FailedMediaUploadToken {
        error
      }
    }
    readToken(maxTokenLength: ${(0, $cGVqS.getMaxTokenLength)()}) {
      clientId
      endpointUrl
      tokensWithFiles {
        files {
          issueId
          attachmentId
          attachmentMediaApiId
        }
        token
      }
      tokenLifespanInSeconds
    }
  }`;

});
parcelRegister("cGVqS", function(module, exports) {

$parcel$export(module.exports, "getMaxTokenLength", () => $fda68ad41e642ef5$export$e40f2acaf1a50b00);
// Low enough such that it shouldn't cause problems for non-IE11 browsers, and high
// enough such that it shouldn't be encountered in practice very often.
const $fda68ad41e642ef5$var$nonIE11MaxTokenLength = 2 ** 16;
const $fda68ad41e642ef5$export$e40f2acaf1a50b00 = ()=>$fda68ad41e642ef5$var$nonIE11MaxTokenLength;

});


parcelRegister("g6Y30", function(module, exports) {

$parcel$export(module.exports, "default", () => $58c20a5fb285246a$export$2e2bcd8739ae039);
// A list of all keys of permissions that this transformer supports.
const $58c20a5fb285246a$export$9fc40cb6f3529ef = ()=>[
        'ADMINISTER_PROJECTS',
        'ASSIGN_ISSUES',
        'EDIT_ISSUES',
        'SCHEDULE_ISSUES',
        'ADD_COMMENTS',
        'DELETE_ALL_COMMENTS',
        'DELETE_OWN_COMMENTS',
        'EDIT_ALL_COMMENTS',
        'EDIT_OWN_COMMENTS',
        'CREATE_ISSUES',
        'DELETE_ISSUES',
        'MOVE_ISSUES',
        'MODIFY_REPORTER',
        'CREATE_ATTACHMENTS',
        'DELETE_ALL_ATTACHMENTS',
        'DELETE_OWN_ATTACHMENTS',
        'WORK_ON_ISSUES',
        'ASSIGNABLE_USER',
        'LINK_ISSUES',
        'VIEW_VOTERS_AND_WATCHERS',
        'MANAGE_WATCHERS',
        'EDIT_ALL_WORKLOGS',
        'EDIT_OWN_WORKLOGS',
        'DELETE_ALL_WORKLOGS',
        'DELETE_OWN_WORKLOGS',
        'VIEW_DEV_TOOLS',
        'SERVICEDESK_AGENT',
        'RESOLVE_ISSUES',
        'CLONE_ISSUE',
        'ARCHIVE_ISSUES',
        'UNARCHIVE_ISSUES'
    ];
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$58c20a5fb285246a$export$2e2bcd8739ae039 = ()=>`

    permissions(issueKey:$issueKey, keys:["${$58c20a5fb285246a$export$9fc40cb6f3529ef().join('","')}"]) {
        key
        havePermission
    }
`;

});

parcelRegister("hif4C", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ce89c5fc46ec8e1$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import/no-anonymous-default-export
var $7ce89c5fc46ec8e1$export$2e2bcd8739ae039 = ()=>`
    project(projectKey: $projectKey) {
        id
        newIssueViewLockedIn
        issueTypes {
            id
            name
            iconUrl
            subtask
        }
    }
`;

});

parcelRegister("7JZFE", function(module, exports) {

$parcel$export(module.exports, "getRemoteLinksQuery", () => $c94d2c74482f6654$export$6bbc6b72b0b57f25);

var $7jTnu = parcelRequire("7jTnu");
const $c94d2c74482f6654$var$getRemoteLinkedIssuesPreviewFragment = ()=>`
    id
    issueId
    globalId
    href
    applicationType
    applicationName
    relationship
    title
`;
const $c94d2c74482f6654$var$getAssociatedIssueFragment = ()=>`
    issueId
    issueKey {
        stringValue
    }
    summary {
        textValue
    }
    status {
        statusCategoryId
        name
        statusId
    }
    priority {
        iconUrl
        name
    }
    issueType {
        iconUrl
        name
    }
    assignee {
        userValue
        {
            displayName
            avatarUrl
        }
    }
   isResolved
`;
const $c94d2c74482f6654$var$getRemoteLinkedIssuesDetailsFragment = ()=>`
    ... on AssociatedIssueWrapper {
        associatedIssue {
            ${$c94d2c74482f6654$var$getAssociatedIssueFragment()}
        }
    }
    ... on FailedRemoteIssue {
        error
        repairLink { href }
    }
`;
const $c94d2c74482f6654$var$getRemoteLinkedIssuesFragment = ()=>`
    remoteLinkedIssues {
        preview {
            ${$c94d2c74482f6654$var$getRemoteLinkedIssuesPreviewFragment()}
        }
        details {
            ${$c94d2c74482f6654$var$getRemoteLinkedIssuesDetailsFragment()}
        }
    }
`;
const $c94d2c74482f6654$var$getWebLinksFragment = ()=>`
    webLinks(allowThirdParties: true, orderBy: "-id") {
        linkCount
        links {
            id
            href
            linkText
            iconUrl
            summary
            resolved
            relationship
            applicationName
            applicationType
        }
    }
`;
const $c94d2c74482f6654$var$getRemoteLinksQueryNew = ()=>`
    remoteLinks {
        isLinkingEnabled
        confluencePages {
            linkedPages {
				pageCount
				pages {
					... on ConfluencePage {
						id
						globalId
						href
						title
						type
					}
					... on FailedRemoteLink {
						id
						error
						link {
							id
							globalId
							href
						}
						repairLink { href }
					}
				}
            }
        }
        ${$c94d2c74482f6654$var$getWebLinksFragment()}
        ${$c94d2c74482f6654$var$getRemoteLinkedIssuesFragment()}
    }
`;
const $c94d2c74482f6654$var$getRemoteLinksQueryOld = ()=>`
    remoteLinks {
        isLinkingEnabled
        remoteLinkedIssues {
            preview {
                id
                issueId
                globalId
                href
                applicationType
                applicationName
                relationship
                title
            }
        }
    }
`;
const $c94d2c74482f6654$export$6bbc6b72b0b57f25 = ()=>(0, $7jTnu.fg)('jiv-19125-fetch-remote-links-in-interactive-query') ? $c94d2c74482f6654$var$getRemoteLinksQueryNew() : $c94d2c74482f6654$var$getRemoteLinksQueryOld();

});

parcelRegister("cvLHO", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b69391f765eb53b$export$2e2bcd8739ae039);

var $d60Hm = parcelRequire("d60Hm");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5b69391f765eb53b$export$2e2bcd8739ae039 = ({ startAt: startAt, orderBy: orderBy, worklogAmount: worklogAmount, url: url })=>{
    const orderByParameter = orderBy !== null && orderBy !== undefined ? `, orderBy: "${orderBy}"` : '';
    const worklogPermalinkId = url ? (0, $d60Hm.getPermalinkIdFromURL)((0, $d60Hm.WORKLOG), url) : (0, $d60Hm.getPermalinkId)((0, $d60Hm.WORKLOG));
    if (worklogPermalinkId === null || worklogPermalinkId === undefined) return '';
    const worklogParameter = `, worklogId: ${worklogPermalinkId}`;
    const worklogAmountParameter = worklogAmount !== null && worklogAmount !== undefined ? `, worklogAmount: ${worklogAmount}` : '';
    return `
        worklogs (startAt: ${startAt}${orderByParameter}${worklogParameter}${worklogAmountParameter}) {
            nodes {
                id
                author {
                    accountId
                    displayName
                    avatarUrl
                }
                updateAuthor {
                    accountId
                    displayName
                    avatarUrl
                }
                created
                started
                updated
                comment
                timeSpent
                timeSpentSeconds
            }
            totalCount
            startIndex
        }
    `;
};

});





parcelRegister("5GGn5", function(module, exports) {

$parcel$export(module.exports, "peopleSetValueValidator", () => $d42b8f3fc77fca9f$export$b553dcd60e54b2da);
$parcel$export(module.exports, "peopleSetValueTransformer", () => $d42b8f3fc77fca9f$export$6262031046230bac);
$parcel$export(module.exports, "peopleGetValueTransformer", () => $d42b8f3fc77fca9f$export$34e69b3ea0fd6308);

var $6rtzq = parcelRequire("6rtzq");
var $faPX6 = parcelRequire("faPX6");

var $ajm6I = parcelRequire("ajm6I");

var $ellWq = parcelRequire("ellWq");

var $fzmSm = parcelRequire("fzmSm");
const $d42b8f3fc77fca9f$export$b553dcd60e54b2da = (value)=>Array.isArray(value) && // We should omit automatic id special value so it won't be picked up by this field
    // It is only applicable to the assignee field
    value.every((userId)=>(0, $ellWq.isNotEmptyString)(userId) && (0, $faPX6.isNotAutomaticId)(userId));
const $d42b8f3fc77fca9f$export$6262031046230bac = (value, lookupValues)=>{
    if (!value.length) return [];
    const filteredLookupValues = (0, $fzmSm.multiValueLookup)(value, lookupValues, 'accountId');
    if (value.length !== filteredLookupValues.length) {
        const notFoundValues = (0, $ajm6I.getValueLookupValuesDiff)(value, filteredLookupValues, 'accountId');
        throw new (0, $6rtzq.FieldValueLookupError)(notFoundValues.join());
    }
    return filteredLookupValues.map(({ accountId: id, name: name, picture: avatarUrl })=>({
            id: id,
            name: name,
            avatarUrl: avatarUrl
        }));
};
const $d42b8f3fc77fca9f$export$34e69b3ea0fd6308 = (value)=>{
    if (!value) return [];
    // can be an object in case of people field with isMulti: false
    const valueArray = Array.isArray(value) ? value : [
        value
    ];
    return valueArray.map(({ id: accountId })=>({
            accountId: accountId
        }));
};

});

parcelRegister("9clC9", function(module, exports) {

$parcel$export(module.exports, "transformPrioritySetOptionsVisibility", () => $1a284362e377f684$export$722da4484009d687);
$parcel$export(module.exports, "transformPriorityGetOptionsVisibility", () => $1a284362e377f684$export$3cc1c0d9b27ad517);
$parcel$export(module.exports, "prioritySetValueTransformer", () => $1a284362e377f684$export$c6ef424ead917b72);
$parcel$export(module.exports, "transformPriorityGetValue", () => $1a284362e377f684$export$95a791a89befdf91);

var $6rtzq = parcelRequire("6rtzq");

var $h6fC1 = parcelRequire("h6fC1");

var $ZP4Rf = parcelRequire("ZP4Rf");

var $biM1w = parcelRequire("biM1w");
const $1a284362e377f684$export$722da4484009d687 = (optionsVisibility, lookupValues)=>(0, $h6fC1.applyOptionsVisibilityRule)(optionsVisibility, lookupValues, 'id');
const $1a284362e377f684$export$3cc1c0d9b27ad517 = (optionsVisibility, lookupValues)=>(0, $ZP4Rf.getAvailableOptionsVisibilityRule)(optionsVisibility, lookupValues, 'id');
const $1a284362e377f684$export$c6ef424ead917b72 = (value, lookupValues)=>{
    const lookupValue = (0, $biM1w.singleValueLookup)(value, lookupValues, 'id');
    if (!lookupValue) throw new (0, $6rtzq.FieldValueLookupError)();
    return {
        label: lookupValue.name,
        value: lookupValue.id,
        iconUrl: lookupValue.iconUrl
    };
};
const $1a284362e377f684$export$95a791a89befdf91 = (priority)=>{
    if (!priority) return null;
    const { label: label, value: value, iconUrl: iconUrl } = priority;
    return {
        name: label,
        id: value,
        iconUrl: iconUrl
    };
};

});

parcelRegister("fKJdV", function(module, exports) {

$parcel$export(module.exports, "transformRadioButtonsSetOptionsVisibility", () => $e19389e967ae3017$export$825e2dc660c855a0);
$parcel$export(module.exports, "transformRadioButtonsGetOptionsVisibility", () => $e19389e967ae3017$export$149e6a6e5e31219);
$parcel$export(module.exports, "radioButtonsSetValueTransformer", () => $e19389e967ae3017$export$d23713245ea192a9);
$parcel$export(module.exports, "radioButtonsGetValueTransformer", () => $e19389e967ae3017$export$624bfe758f4ad3c6);

var $6rtzq = parcelRequire("6rtzq");

var $h6fC1 = parcelRequire("h6fC1");

var $ZP4Rf = parcelRequire("ZP4Rf");

var $biM1w = parcelRequire("biM1w");
const $e19389e967ae3017$export$825e2dc660c855a0 = (optionsVisibility, lookupValues)=>(0, $h6fC1.applyOptionsVisibilityRule)(optionsVisibility, lookupValues, 'id');
const $e19389e967ae3017$export$149e6a6e5e31219 = (optionsVisibility, lookupValues)=>(0, $ZP4Rf.getAvailableOptionsVisibilityRule)(optionsVisibility, lookupValues, 'id');
const $e19389e967ae3017$export$d23713245ea192a9 = (value, allowedValues)=>{
    if (value === null) return null;
    const foundValue = (0, $biM1w.singleValueLookup)(value, allowedValues, 'id');
    if (!foundValue) throw new (0, $6rtzq.FieldValueLookupError)();
    return {
        value: foundValue.id,
        label: foundValue.value
    };
};
const $e19389e967ae3017$export$624bfe758f4ad3c6 = (value)=>{
    if (!value) return null;
    const { label: label, value: id } = value;
    return {
        id: id,
        value: label
    };
};

});

parcelRegister("3TV7H", function(module, exports) {

$parcel$export(module.exports, "reporterSetValueTransformer", () => $e82b1dae9c4a820a$export$610accc7edd3f281);
$parcel$export(module.exports, "reporterGetValueTransformer", () => $e82b1dae9c4a820a$export$2c1706dd36f54bb3);

var $6rtzq = parcelRequire("6rtzq");

var $biM1w = parcelRequire("biM1w");
const $e82b1dae9c4a820a$export$610accc7edd3f281 = (value, lookupValues)=>{
    if (value === null) return null;
    const foundValue = (0, $biM1w.singleValueLookup)(value, lookupValues, 'accountId');
    if (!foundValue) throw new (0, $6rtzq.FieldValueLookupError)();
    return {
        id: foundValue.accountId,
        name: foundValue.name,
        avatarUrl: foundValue.picture
    };
};
const $e82b1dae9c4a820a$export$2c1706dd36f54bb3 = (value)=>{
    if (!value) return null;
    const { id: accountId } = value;
    return {
        accountId: accountId
    };
};

});

parcelRegister("18aUF", function(module, exports) {

$parcel$export(module.exports, "transformSelectSetOptionsVisibility", () => $8b6276ea31ca6669$export$81990085f8ab114b);
$parcel$export(module.exports, "transformSelectGetOptionsVisibility", () => $8b6276ea31ca6669$export$7c7ca81813eb0f65);
$parcel$export(module.exports, "selectSetValueTransformer", () => $8b6276ea31ca6669$export$136c42b919fdec83);
$parcel$export(module.exports, "selectGetValueTransformer", () => $8b6276ea31ca6669$export$fd4db924c90bd0e2);

var $6rtzq = parcelRequire("6rtzq");

var $h6fC1 = parcelRequire("h6fC1");

var $ZP4Rf = parcelRequire("ZP4Rf");

var $biM1w = parcelRequire("biM1w");
const $8b6276ea31ca6669$export$81990085f8ab114b = (optionsVisibility, lookupValues)=>(0, $h6fC1.applyOptionsVisibilityRule)(optionsVisibility, lookupValues, 'id');
const $8b6276ea31ca6669$export$7c7ca81813eb0f65 = (optionsVisibility, lookupValues)=>(0, $ZP4Rf.getAvailableOptionsVisibilityRule)(optionsVisibility, lookupValues, 'id');
const $8b6276ea31ca6669$export$136c42b919fdec83 = (value, allowedValues)=>{
    if (value === null) return null;
    const foundValue = (0, $biM1w.singleValueLookup)(value, allowedValues, 'id');
    if (!foundValue) throw new (0, $6rtzq.FieldValueLookupError)();
    return {
        value: foundValue.id,
        label: foundValue.value
    };
};
const $8b6276ea31ca6669$export$fd4db924c90bd0e2 = (value)=>{
    if (!value) return null;
    const { label: label, value: id } = value;
    return {
        id: id,
        value: label
    };
};

});

parcelRegister("H6cPi", function(module, exports) {

$parcel$export(module.exports, "singleLineTextFieldGetValueTransformer", () => $f60994b5fdc1c37e$export$161c77b6b09fc494);
const $f60994b5fdc1c37e$export$161c77b6b09fc494 = (internalValue)=>internalValue !== undefined ? internalValue : '';

});

parcelRegister("6AzNh", function(module, exports) {

$parcel$export(module.exports, "userPickerSetValueTransformer", () => $3591ef5f6d411a2b$export$890d33cc39835486);
$parcel$export(module.exports, "userPickerGetValueTransformer", () => $3591ef5f6d411a2b$export$e87b0f36be178543);

var $6rtzq = parcelRequire("6rtzq");

var $biM1w = parcelRequire("biM1w");
const $3591ef5f6d411a2b$export$890d33cc39835486 = (value, lookupValues)=>{
    if (value === null) return null;
    const foundValue = (0, $biM1w.singleValueLookup)(value, lookupValues, 'accountId');
    if (!foundValue) throw new (0, $6rtzq.FieldValueLookupError)();
    return {
        id: foundValue.accountId,
        name: foundValue.name,
        avatarUrl: foundValue.picture
    };
};
const $3591ef5f6d411a2b$export$e87b0f36be178543 = (value)=>{
    if (!value) return null;
    const { id: accountId } = value;
    return {
        accountId: accountId
    };
};

});

parcelRegister("9OdvY", function(module, exports) {

$parcel$export(module.exports, "fixVersionsSetValueValidator", () => $2628a9dbe1137cad$export$423303d5750f732c);
$parcel$export(module.exports, "transformVersionsSetValue", () => $2628a9dbe1137cad$export$5706ac863a06e5ed);
$parcel$export(module.exports, "transformVersionsGetValue", () => $2628a9dbe1137cad$export$360c4edb055d9cb4);
$parcel$export(module.exports, "versionsRequiredScopes", () => $2628a9dbe1137cad$export$60db61c485973ad9);

var $6rtzq = parcelRequire("6rtzq");

var $8FDN0 = parcelRequire("8FDN0");

var $ajm6I = parcelRequire("ajm6I");

var $ellWq = parcelRequire("ellWq");

var $fzmSm = parcelRequire("fzmSm");
const $2628a9dbe1137cad$export$423303d5750f732c = (value)=>Array.isArray(value) && value.every((0, $ellWq.isNotEmptyString));
const $2628a9dbe1137cad$export$5706ac863a06e5ed = (values, lookupValues)=>{
    if (!values.length) return [];
    const filteredLookupValues = (0, $fzmSm.multiValueLookup)(values, lookupValues, 'id');
    if (values.length !== filteredLookupValues.length) {
        const notFoundValues = (0, $ajm6I.getValueLookupValuesDiff)(values, filteredLookupValues, 'id');
        throw new (0, $6rtzq.FieldValueLookupError)(notFoundValues.join());
    }
    return filteredLookupValues.map(({ name: name, id: id })=>({
            label: name,
            value: id
        }));
};
const $2628a9dbe1137cad$export$360c4edb055d9cb4 = (internalValue)=>{
    if (!internalValue) return [];
    return internalValue.map(({ value: value, label: label })=>({
            id: value,
            name: label
        }));
};
const $2628a9dbe1137cad$export$60db61c485973ad9 = {
    ...(0, $8FDN0.versionsRequiredScopes),
    granular: [
        ...(0, $8FDN0.versionsRequiredScopes).granular,
        'write:field.default-value:jira'
    ]
};

});

parcelRegister("iQnYo", function(module, exports) {

$parcel$export(module.exports, "default", () => $837953699865a416$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $837953699865a416$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    obligatoryUimGicConsentMessage: {
        "id": "ui-modifications-fields-configuration.common.utils.views.gic.obligatory-uim-gic-consent-message",
        "defaultMessage": "You must allow \"{appTitle}\" to access your Atlassian products to create this issue."
    },
    obligatoryUimGicConsentMessageIssueTermRefresh: {
        "id": "ui-modifications-fields-configuration.common.utils.views.gic.obligatory-uim-gic-consent-message-issue-term-refresh",
        "defaultMessage": "You must allow \"{appTitle}\" to access your Atlassian products to create this work item."
    }
});

});



parcelRegister("50UkK", function(module, exports) {

$parcel$export(module.exports, "UiModificationsEntryPoint", () => $ea534b60c6d5e863$export$c89b83ae4e6840b3);

var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");

var $7jTnu = parcelRequire("7jTnu");

var $bYusI = parcelRequire("bYusI");

var $814y1 = parcelRequire("814y1");

var $2VjLE = parcelRequire("2VjLE");
var $cMdIN = parcelRequire("cMdIN");

var $2Mqjh = parcelRequire("2Mqjh");

var $fjH52 = parcelRequire("fjH52");

var $kEUB1 = parcelRequire("kEUB1");

var $kJMbw = parcelRequire("kJMbw");
var $3osLr = parcelRequire("3osLr");


var $lub6R = parcelRequire("lub6R");
const $ea534b60c6d5e863$var$UiModificationsEntryPointLoaded = ({ issueTypeFieldType: issueTypeFieldType, modalFieldConfig: modalFieldConfig, resetFormFieldsCounter: resetFormFieldsCounter, selectedIssueType: selectedIssueType, selectedProject: selectedProject, triggerPointKey: triggerPointKey })=>{
    const cloudId = (0, $kEUB1.useCloudId)();
    const executionContext = (0, $eJOHy.useMemo)(()=>{
        if (selectedProject && selectedIssueType) return {
            project: {
                id: selectedProject.value,
                key: selectedProject.projectKey,
                type: selectedProject.projectType
            },
            issueType: {
                id: selectedIssueType.value,
                name: selectedIssueType.label
            },
            viewType: (0, $6d500eb1fc6bc124$export$e615b7e9b8fb4715)
        };
        return null;
    }, [
        selectedIssueType,
        selectedProject
    ]);
    const fieldsCount = (0, $eJOHy.useMemo)(()=>(0, $lub6R.getSupportedFieldsCount)({
            ...modalFieldConfig,
            [(0, $814y1.ISSUE_TYPE)]: {
                fieldType: issueTypeFieldType
            }
        }), [
        issueTypeFieldType,
        modalFieldConfig
    ]);
    const queryParams = (0, $eJOHy.useMemo)(()=>{
        if (!executionContext?.project.id || !executionContext?.issueType.id) return null;
        return {
            cloudId: cloudId,
            forgeExtensionRenderingContext: {
                projectKey: executionContext?.project.key
            },
            uiModificationsContext: {
                projectId: (0, $3osLr.JiraProjectAri).create({
                    siteId: cloudId,
                    projectId: executionContext?.project.id
                }).toString(),
                issueTypeId: (0, $kJMbw.JiraIssueTypeAri).create({
                    siteId: cloudId,
                    issueTypeId: executionContext?.issueType.id
                }).toString(),
                viewType: (0, $6d500eb1fc6bc124$export$e615b7e9b8fb4715)
            },
            includeUserAccessEnabledForge: (0, $7jTnu.fg)('forge_query_include_user_access_enabled')
        };
    }, [
        cloudId,
        executionContext?.issueType.id,
        executionContext?.project.id,
        executionContext?.project.key
    ]);
    const executionContextKey = (0, $eJOHy.useMemo)(()=>selectedIssueType?.value && selectedProject?.value ? `${selectedProject.value}-${selectedIssueType.value}` : null, [
        selectedIssueType?.value,
        selectedProject?.value
    ]);
    if (!executionContext || !queryParams) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fjH52.UiModificationsJiraRoot), {
        containerId: "uiModifications",
        containerPackageName: "jiraUiModificationsViewGic",
        queryParams: queryParams,
        resetFormFieldsCounter: resetFormFieldsCounter,
        executionContextKey: executionContextKey,
        executionContext: executionContext,
        numberOfSupportedFields: fieldsCount,
        triggerPointKey: triggerPointKey
    });
};
const $ea534b60c6d5e863$export$c89b83ae4e6840b3 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "uiModifications",
        packageName: "jiraUiModificationsViewGic",
        fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bYusI.ErrorHandler), null),
        attributes: (error)=>({
                errorType: (0, $cMdIN.getErrorType)(error),
                viewType: (0, $6d500eb1fc6bc124$export$e615b7e9b8fb4715)
            }),
        sendToPrivacyUnsafeSplunk: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2VjLE.AnalyticsListener), {
        analyticsWebClient: (0, $2Mqjh.getAnalyticsWebClientPromise)().then((client)=>client.getInstance())
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ea534b60c6d5e863$var$UiModificationsEntryPointLoaded, props)));

});
parcelRegister("bYusI", function(module, exports) {

$parcel$export(module.exports, "ErrorHandler", () => $3bc72803e09920b4$export$f42bc933f51d0006);

var $eJOHy = parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");

var $ixrOr = parcelRequire("ixrOr");
const $3bc72803e09920b4$export$f42bc933f51d0006 = ()=>{
    (0, $gRw8I.di)((0, $ixrOr.useIssueAdjustmentsActions));
    const { setError: setError, resetError: resetError } = (0, $ixrOr.useIssueAdjustmentsActions)();
    (0, $eJOHy.useEffect)(()=>{
        setError({
            errorCode: 'ERROR_BOUNDARY_HANDLER_ERROR_CODE'
        });
        return ()=>resetError();
    }, [
        setError,
        resetError
    ]);
    return null;
};

});

parcelRegister("2VjLE", function(module, exports) {

$parcel$export(module.exports, "AnalyticsListener", () => $7fbe52e1ff7871d3$export$22edec767217cd60);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8QoO2 = parcelRequire("8QoO2");

var $8dFVw = parcelRequire("8dFVw");

var $7U6OJ = parcelRequire("7U6OJ");

const $7fbe52e1ff7871d3$export$7329bcdc3edcd90e = (event, client)=>{
    switch(event.type){
        case 0, $e9db81972dce4ebc$export$12346a674644c156:
            Promise.resolve(client).then((c)=>c.sendOperationalEvent(event));
            break;
        case 0, $e9db81972dce4ebc$export$947dac6c72b26f81:
            Promise.resolve(client).then((c)=>c.sendTrackEvent(event));
            break;
    }
};
const $7fbe52e1ff7871d3$export$eee20638634729b3 = (analyticsWebClient)=>(event)=>{
        const eventData = (0, $8dFVw.extractAWCDataFromEvent)(event);
        $7fbe52e1ff7871d3$export$7329bcdc3edcd90e({
            type: eventData.type,
            ...eventData.payload
        }, analyticsWebClient);
    };
const $7fbe52e1ff7871d3$export$22edec767217cd60 = ({ children: children, analyticsWebClient: analyticsWebClient })=>{
    const onEvent = (0, $eJOHy.useMemo)(()=>$7fbe52e1ff7871d3$export$eee20638634729b3(analyticsWebClient), [
        analyticsWebClient
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const initClient = async ()=>{
            const client = await analyticsWebClient;
            (0, $7U6OJ.initialiseErrorAnalyticsClient)(client);
        };
        initClient();
    }, [
        analyticsWebClient
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8QoO2.default), {
        onEvent: onEvent,
        channel: (0, $0390845c0b61b1a1$export$8280e5c6104c5b40),
        children: children
    });
};

});

parcelRegister("fjH52", function(module, exports) {

$parcel$export(module.exports, "UiModificationsJiraRoot", () => $4069a135305fbc58$export$281f97be92d49a08);

var $eJOHy = parcelRequire("eJOHy");

var $cBavF = parcelRequire("cBavF");

var $bbdV2 = parcelRequire("bbdV2");

var $cMdIN = parcelRequire("cMdIN");

var $i7n3g = parcelRequire("i7n3g");

var $kEUB1 = parcelRequire("kEUB1");

var $4ihOZ = parcelRequire("4ihOZ");

var $bYusI = parcelRequire("bYusI");

var $82wKS = parcelRequire("82wKS");

var $8iFlD = parcelRequire("8iFlD");

var $bSPJs = parcelRequire("bSPJs");
const $4069a135305fbc58$var$defaultErrorFallback = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bYusI.ErrorHandler), null);
const $4069a135305fbc58$export$281f97be92d49a08 = ({ containerId: containerId, containerPackageName: containerPackageName, errorFallback: errorFallback, queryParams: queryParams, executionContextKey: executionContextKey, executionContext: executionContext, triggerPointKey: triggerPointKey, numberOfSupportedFields: numberOfSupportedFields, resetFormFieldsCounter: resetFormFieldsCounter })=>{
    const cloudId = (0, $kEUB1.useCloudId)();
    const activationId = (0, $4ihOZ.useActivationId)();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $bSPJs.uiModificationsRootEntrypoint), queryParams);
    const { setShouldUiModificationsLoad: setShouldUiModificationsLoad } = (0, $i7n3g.useAdjustmentsContextActions)();
    const shouldUiModificationsLoad = executionContext && (0, $82wKS.isExecutionContextSupported)(executionContext) && (0, $82wKS.isTriggerPointSupported)(queryParams.uiModificationsContext.viewType, triggerPointKey);
    // In case that the UI modifications are not supposed to load,
    // we need to set the shouldUiModificationsLoad to 'no' to have proper context state
    // otherwise the context state will be set to 'yes' by the root component
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eJOHy.useEffect)(()=>{
        shouldUiModificationsLoad ? entryPointActions.load() : setShouldUiModificationsLoad('no');
    }, [
        entryPointActions,
        queryParams,
        executionContextKey,
        shouldUiModificationsLoad,
        setShouldUiModificationsLoad
    ]);
    const runtimeProps = (0, $eJOHy.useMemo)(()=>({
            cloudId: cloudId,
            activationId: activationId,
            executionContextKey: executionContextKey,
            executionContext: executionContext,
            triggerPointKey: triggerPointKey,
            numberOfSupportedFields: numberOfSupportedFields,
            resetFormFieldsCounter: resetFormFieldsCounter,
            ForgeAppRenderer: $8iFlD.ForgeAppRenderer
        }), [
        activationId,
        cloudId,
        executionContextKey,
        executionContext,
        triggerPointKey,
        numberOfSupportedFields,
        resetFormFieldsCounter
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: containerId,
        packageName: containerPackageName,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null),
        errorFallback: errorFallback ?? $4069a135305fbc58$var$defaultErrorFallback,
        errorAttributes: (error)=>({
                errorType: (0, $cMdIN.getErrorType)(error),
                viewType: queryParams.uiModificationsContext.viewType
            }),
        runtimeProps: runtimeProps
    });
};

});
parcelRegister("8iFlD", function(module, exports) {

$parcel$export(module.exports, "ForgeAppRenderer", () => $775cf6c655fb6150$export$6eef17fe5fde390c);

var $eJOHy = parcelRequire("eJOHy");

var $aeOhE = parcelRequire("aeOhE");

var $fohjD = parcelRequire("fohjD");

var $bQWwW = parcelRequire("bQWwW");

const $775cf6c655fb6150$var$getModule = ()=>(parcelRequire("ccyuA"));
const $775cf6c655fb6150$export$7ef2c8aa7b731b0c = (0, $aeOhE.withMetrics)(// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $bQWwW.lazyForPaint)(()=>$775cf6c655fb6150$var$getModule().then((module)=>module.ForgeUIExtension), {
    ssr: false
}));
const $775cf6c655fb6150$export$6eef17fe5fde390c = ({ extension: extension, extensionData: extensionData, customBridgeMethods: customBridgeMethods, onIframeLoad: onIframeLoad, isIframeHidden: isIframeHidden, isIframeResizable: isIframeResizable, onConsentSuccess: onConsentSuccess, onConsentInitialization: onConsentInitialization, consentMessage: consentMessage })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($775cf6c655fb6150$export$7ef2c8aa7b731b0c, {
        contextToken: (0, $fohjD.CONTEXT_TOKEN_TYPE_JIRA),
        module: (0, $fohjD.UI_MODIFICATIONS_MODULE),
        extension: extension,
        customBridgeMethods: customBridgeMethods,
        onLoad: onIframeLoad,
        extensionData: extensionData,
        isIframeResizable: isIframeResizable,
        isIframeHidden: isIframeHidden,
        onConsentSuccess: onConsentSuccess,
        onConsentInitialization: onConsentInitialization,
        consentMessage: consentMessage
    });
};

});
parcelRegister("ccyuA", function(module, exports) {

let $8e215c7e689f0e02$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $8e215c7e689f0e02$var$load("3yAl4"),
    $8e215c7e689f0e02$var$load("76n7a"),
    $8e215c7e689f0e02$var$load("l253H"),
    $8e215c7e689f0e02$var$load("ffQaD"),
    $8e215c7e689f0e02$var$load("kvRbA"),
    $8e215c7e689f0e02$var$load("kNFvF"),
    $8e215c7e689f0e02$var$load("aSWtc")
]).then(()=>parcelRequire('4PimS'));

});


parcelRegister("bSPJs", function(module, exports) {

$parcel$export(module.exports, "uiModificationsRootEntrypoint", () => $eb5efe3dda515f2d$export$a12f4912b9018c15);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

var $7jTnu = parcelRequire("7jTnu");

var $jqSom = parcelRequire("jqSom");

const $eb5efe3dda515f2d$export$a12f4912b9018c15 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("1vmcR")).then((module)=>module.RootEntrypointWrapper), {
        moduleId: "3c08c19c",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId, forgeExtensionRenderingContext: forgeExtensionRenderingContext, uiModificationsContext: uiModificationsContext })=>{
        return {
            queries: {
                rootUiModificationsQuery: {
                    parameters: (0, $jqSom.default),
                    variables: {
                        cloudId: cloudId,
                        forgeExtensionRenderingContext: forgeExtensionRenderingContext,
                        uiModificationsContext: uiModificationsContext,
                        includeUserAccessEnabledForge: (0, $7jTnu.fg)('forge_query_include_user_access_enabled')
                    },
                    options: {
                        fetchPolicy: 'network-only'
                    }
                }
            }
        };
    }
});

});
parcelRegister("jqSom", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e242242bf034750$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ec0b94f88560447175b1ccb20b7defe6>>
 * @relayHash 1d70004f81af7e3ef36582e9adbdc3a2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ee867250c831b7e922770a0802bcb7f05f92d770c56600d10321c5d6cce76c10
const $0e242242bf034750$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "forgeExtensionRenderingContext"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeUserAccessEnabledForge"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "uiModificationsContext"
    }, v4 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "type"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "rootUiModificationsQuery",
            "selections": [
                {
                    "args": [
                        v4 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "forgeExtensionRenderingContext",
                            "variableName": "forgeExtensionRenderingContext"
                        },
                        {
                            "kind": "Variable",
                            "name": "includeUserAccessEnabledForge",
                            "variableName": "includeUserAccessEnabledForge"
                        },
                        {
                            "kind": "Variable",
                            "name": "uiModificationsContext",
                            "variableName": "uiModificationsContext"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "fragment_AtlassianUiModificationsCore_RootFragment"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "rootUiModificationsQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "context",
                                    "variableName": "uiModificationsContext"
                                }
                            ],
                            "concreteType": "JiraAppUiModifications",
                            "kind": "LinkedField",
                            "name": "uiModifications",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "appEnvId"
                                },
                                {
                                    "concreteType": "JiraUiModification",
                                    "kind": "LinkedField",
                                    "name": "uiModifications",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "data"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "JiraForgeQuery",
                            "kind": "LinkedField",
                            "name": "forge",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": "uiModificationsExtensions",
                                    "args": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "Variable",
                                            "name": "context",
                                            "variableName": "forgeExtensionRenderingContext"
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "types",
                                            "value": [
                                                "jira:uiModifications"
                                            ]
                                        }
                                    ],
                                    "concreteType": "JiraForgeExtension",
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "appVersion"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "installationId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "environmentId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "environmentType"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "environmentKey"
                                        },
                                        {
                                            "concreteType": "JiraForgeExtensionLicense",
                                            "kind": "LinkedField",
                                            "name": "license",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "active"
                                                },
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "supportEntitlementNumber"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "trialEndDate"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "subscriptionEndDate"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isEvaluation"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "billingPeriod"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "ccpEntitlementId"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "ccpEntitlementSlug"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "capabilitySet"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "properties"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "scopes"
                                        },
                                        v6 /*: any*/ ,
                                        {
                                            "concreteType": "JiraForgeAppEgressDeclaration",
                                            "kind": "LinkedField",
                                            "name": "egress",
                                            "plural": true,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "addresses"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "category"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "inScopeEUD"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "JiraForgeInstallationConfigExtension",
                                            "kind": "LinkedField",
                                            "name": "installationConfig",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "key"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "value"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "consentUrl"
                                        },
                                        {
                                            "concreteType": "JiraUserAppAccess",
                                            "kind": "LinkedField",
                                            "name": "userAccess",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasAccess"
                                                },
                                                {
                                                    "condition": "includeUserAccessEnabledForge",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "enabled"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hiddenBy"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "ee867250c831b7e922770a0802bcb7f05f92d770c56600d10321c5d6cce76c10",
            "metadata": {},
            "name": "rootUiModificationsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$0e242242bf034750$var$node.hash = "3523ce52d19fd01f19dfac0992685134";
var $0e242242bf034750$export$2e2bcd8739ae039 = $0e242242bf034750$var$node;

});

parcelRegister("1vmcR", function(module, exports) {

let $1189e96b8e09f131$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $1189e96b8e09f131$var$load("6B0zl").then(()=>parcelRequire('hYhFV'));

});



parcelRegister("kJMbw", function(module, exports) {

$parcel$export(module.exports, "JiraIssueTypeAri", () => $f18d631ee8a373ce$export$931e4419330c3862);

var $jvnY8 = parcelRequire("jvnY8");

var $3TJ9u = parcelRequire("3TJ9u");

var $cSeYX = parcelRequire("cSeYX");
// src/jira/issue-type/manifest.ts
var $f18d631ee8a373ce$var$jiraIssueTypeAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $jvnY8.JiraIssueTypeAriResourceOwner),
    resourceType: (0, $jvnY8.JiraIssueTypeAriResourceType),
    resourceIdSlug: "{issueTypeId}",
    resourceIdSegmentFormats: {
        issueTypeId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/jira/issue-type/index.ts
var $f18d631ee8a373ce$export$931e4419330c3862 = class _JiraIssueTypeAri extends (0, $3TJ9u.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._issueTypeId = opts.resourceIdSegmentValues.issueTypeId;
    }
    get siteId() {
        return this._siteId;
    }
    get issueTypeId() {
        return this._issueTypeId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $f18d631ee8a373ce$var$jiraIssueTypeAriStaticOpts.qualifier,
            platformQualifier: $f18d631ee8a373ce$var$jiraIssueTypeAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $f18d631ee8a373ce$var$jiraIssueTypeAriStaticOpts.resourceOwner,
            resourceType: $f18d631ee8a373ce$var$jiraIssueTypeAriStaticOpts.resourceType,
            resourceId: `${opts.issueTypeId}`,
            resourceIdSegmentValues: {
                issueTypeId: opts.issueTypeId
            }
        }, ariOpts = (0, $cSeYX.AriParser).fromOpts(derivedOpts, $f18d631ee8a373ce$var$jiraIssueTypeAriStaticOpts);
        return new _JiraIssueTypeAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $cSeYX.AriParser).fromString(maybeAri, $f18d631ee8a373ce$var$jiraIssueTypeAriStaticOpts);
        return new _JiraIssueTypeAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            issueTypeId: this.issueTypeId
        };
    }
};

});
parcelRegister("jvnY8", function(module, exports) {

$parcel$export(module.exports, "JiraIssueTypeAriResourceOwner", () => $e333814a45700002$export$a40271de8e7c8a70);
$parcel$export(module.exports, "JiraIssueTypeAriResourceType", () => $e333814a45700002$export$70e5e6fc47f1a2cc);
// src/jira/issue-type/types.ts
var $e333814a45700002$export$a40271de8e7c8a70 = "jira", $e333814a45700002$export$70e5e6fc47f1a2cc = "issue-type";

});


parcelRegister("lub6R", function(module, exports) {

$parcel$export(module.exports, "getSupportedFieldsCount", () => $f0e23705010881eb$export$11f15170229125b6);

var $82wKS = parcelRequire("82wKS");

const $f0e23705010881eb$export$11f15170229125b6 = (fields)=>{
    if (!fields) return 0;
    return Object.values(fields).filter(({ fieldType: fieldType })=>(0, $82wKS.isFieldTypeSupported)((0, $6d500eb1fc6bc124$export$e615b7e9b8fb4715), fieldType)).length;
};

});


parcelRegister("dSpUw", function(module, exports) {

$parcel$export(module.exports, "OptionComponent", () => $9eb50420c12428cc$export$3e92eb7b7644ac65);
$parcel$export(module.exports, "useSelectOptions", () => $9eb50420c12428cc$export$338e37f345f318fa);
$parcel$export(module.exports, "useCombinedInlineConfigurationExperiment", () => $9eb50420c12428cc$export$f7858f4c698ccb67);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $fAZgY = parcelRequire("fAZgY");

var $7jTnu = parcelRequire("7jTnu");

var $ipnsI = parcelRequire("ipnsI");

var $cfGlq = parcelRequire("cfGlq");

var $lXDnY = parcelRequire("lXDnY");

var $epTsa = parcelRequire("epTsa");


var $aY0vM = parcelRequire("aY0vM");
const $9eb50420c12428cc$export$3e92eb7b7644ac65 = ({ children: children, ...optionProps })=>{
    if ([
        (0, $559e2d0f325c757f$export$bbd08ee543ba8cc3),
        (0, $559e2d0f325c757f$export$bc1622166baa0162),
        (0, $559e2d0f325c757f$export$4f9299d0cd8b6a8b)
    ].includes(optionProps.data.type)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ipnsI.OptionWithButtonStyle), optionProps, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lXDnY.OptionWithAutoKeyboardScroll), optionProps, children);
};
const $9eb50420c12428cc$export$338e37f345f318fa = (targetOptions, hasFooter)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const footerOptions = (0, $eJOHy.useMemo)(()=>{
        return [
            {
                label: formatMessage((0, $aY0vM.default).createStatus),
                type: (0, $559e2d0f325c757f$export$bbd08ee543ba8cc3),
                value: (0, $559e2d0f325c757f$export$bbd08ee543ba8cc3)
            },
            {
                label: formatMessage((0, $aY0vM.default).editStatus),
                type: (0, $559e2d0f325c757f$export$bc1622166baa0162),
                value: (0, $559e2d0f325c757f$export$bc1622166baa0162)
            },
            {
                label: formatMessage((0, $aY0vM.default).manageWorkflow),
                type: (0, $559e2d0f325c757f$export$4f9299d0cd8b6a8b),
                value: (0, $559e2d0f325c757f$export$4f9299d0cd8b6a8b)
            }
        ];
    }, [
        formatMessage
    ]);
    const optionsWithFooter = (0, $cfGlq.appendStickyFooterOptions)(targetOptions, footerOptions);
    if (hasFooter) return optionsWithFooter;
    return targetOptions;
};
const $9eb50420c12428cc$export$f7858f4c698ccb67 = (isEligible = true)=>{
    const [combinedInlineConfigurationExperiment, fireCombinedInlineConfigurationExperimentExposure] = (0, $epTsa.UNSAFE_noExposureExp)('combined_adoption_configuration_experiment');
    const isEnabled = Boolean(isEligible && combinedInlineConfigurationExperiment.get('isEnabled', false));
    const fireExposure = (0, $fAZgY.useCallbackWithCondition)(()=>{
        if (isEligible) fireCombinedInlineConfigurationExperimentExposure();
    }, [
        fireCombinedInlineConfigurationExperimentExposure,
        isEligible
    ], ()=>(0, $7jTnu.fg)('jfp_magma_issue-stability-phase1'));
    return (0, $fAZgY.useMemoWithCondition)(()=>({
            isEnabled: isEnabled,
            fireExposure: fireExposure
        }), [
        fireExposure,
        isEnabled
    ], ()=>(0, $7jTnu.fg)('jfp_magma_issue-stability-phase1'));
};

});
parcelRegister("ipnsI", function(module, exports) {

$parcel$export(module.exports, "OptionWithButtonStyle", () => $84e1dd1785575259$export$b3382093e45b6db9);

var $eJOHy = parcelRequire("eJOHy");

var $6XEne = parcelRequire("6XEne");

var $8IeH1 = parcelRequire("8IeH1");
const $84e1dd1785575259$export$b3382093e45b6db9 = ({ children: children, onHover: onHover, testId: testId, ...optionProps })=>{
    const customisedGetStyles = (propertyName, props)=>{
        return {
            ...optionProps.getStyles(propertyName, props),
            boxShadow: 'none',
            cursor: 'pointer',
            padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-150, 12px)"}`
        };
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        onMouseOver: onHover,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6XEne.components).Option, {
        ...optionProps,
        getStyles: customisedGetStyles
    }, children));
};

});

parcelRegister("cfGlq", function(module, exports) {

$parcel$export(module.exports, "appendStickyFooterOptions", () => $a6c5dd9f83b8973c$export$870da2f71d38aa94);
$parcel$export(module.exports, "useAppendStickyFooterOptions", () => $a6c5dd9f83b8973c$export$9ef0653bfb9844e7);
$parcel$export(module.exports, "scrollIntoView", () => $a6c5dd9f83b8973c$export$53a0910f038337bd);

var $eJOHy = parcelRequire("eJOHy");

const $a6c5dd9f83b8973c$export$870da2f71d38aa94 = (options, footerOptions)=>{
    return [
        ...options,
        {
            options: footerOptions.map((footerOption)=>{
                return {
                    ...footerOption,
                    groupType: (0, $2a68cf016118f389$export$e13d614fc55c6ce9)
                };
            })
        }
    ];
};
const $a6c5dd9f83b8973c$export$9ef0653bfb9844e7 = (options, footerOptions)=>{
    return (0, $eJOHy.useMemo)(()=>$a6c5dd9f83b8973c$export$870da2f71d38aa94(options, footerOptions), [
        footerOptions,
        options
    ]);
};
function $a6c5dd9f83b8973c$export$53a0910f038337bd(menuEl, focusedEl, bottomOffset = 0) {
    const menuRect = menuEl.getBoundingClientRect();
    const focusedRect = focusedEl.getBoundingClientRect();
    const overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom - bottomOffset) // eslint-disable-next-line no-param-reassign
    menuEl.scrollTop = Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + bottomOffset + overScroll, menuEl.scrollHeight - bottomOffset);
    else if (focusedRect.top - overScroll < menuRect.top) // eslint-disable-next-line no-param-reassign
    menuEl.scrollTop = Math.max(focusedEl.offsetTop - overScroll, 0);
}

});
const $2a68cf016118f389$export$e13d614fc55c6ce9 = 'STICKY_FOOTER_GROUP_TYPE';
const $2a68cf016118f389$export$1ae91d219a8713ac = 'select-sticky-footer';


parcelRegister("lXDnY", function(module, exports) {

$parcel$export(module.exports, "OptionWithAutoKeyboardScroll", () => $9fea550d435eb0a8$export$39118cd824d8af0b);

var $eJOHy = parcelRequire("eJOHy");

var $6XEne = parcelRequire("6XEne");

var $jd93d = parcelRequire("jd93d");

var $cfGlq = parcelRequire("cfGlq");

const $9fea550d435eb0a8$export$39118cd824d8af0b = ({ children: children, containerRef: containerRef, ...optionProps })=>{
    const focusedOptionRef = (0, $eJOHy.useRef)();
    (0, $eJOHy.useEffect)(()=>{
        if (optionProps.isFocused) {
            // We only auto scroll for focus with keyboard only, not for focus with mouse hover
            // because mouse users will manual scroll when browsing options
            if (!focusedOptionRef.current?.parentElement || focusedOptionRef.current?.matches(':hover')) return;
            // We need to add bottom offset when scrolling which is the current height of sticky footer options group
            const stickFooterBottomOffset = globalThis?.document.querySelector(`.${(0, $2a68cf016118f389$export$1ae91d219a8713ac)}`)?.clientHeight ?? 0;
            (0, $cfGlq.scrollIntoView)(containerRef?.current ?? focusedOptionRef.current.parentElement, focusedOptionRef.current, stickFooterBottomOffset);
        }
    }, [
        containerRef,
        optionProps.isFocused
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6XEne.components).Option, {
        ...optionProps,
        innerRef: (0, $jd93d.mergeRefs)(optionProps.innerRef, focusedOptionRef)
    }, children);
};

});

const $559e2d0f325c757f$export$bbd08ee543ba8cc3 = 'createStatus';
const $559e2d0f325c757f$export$bc1622166baa0162 = 'editStatus';
const $559e2d0f325c757f$export$4f9299d0cd8b6a8b = 'manageWorkflow';

parcelRegister("aY0vM", function(module, exports) {

$parcel$export(module.exports, "default", () => $99e1b73ebbb9da2d$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $99e1b73ebbb9da2d$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    noPermission: {
        "id": "issue-field-status.status-view.no-permission",
        "defaultMessage": "You don't have permission to transition this issue"
    },
    cannotLoadTransitions: {
        "id": "issue-field-status.status-view.cannot-load-transitions",
        "defaultMessage": "We couldn't load the statuses and transitions"
    },
    changeStatus: {
        "id": "issue-field-status.status-view.change-status",
        "defaultMessage": "Change status"
    },
    selectStatus: {
        "id": "issue-field-status.status-view.select-status",
        "defaultMessage": "Select status"
    },
    transitionTo: {
        "id": "issue-field-status.status-view.transition-to",
        "defaultMessage": "Transition to {statusName}"
    },
    noPermissionIssueTermRefresh: {
        "id": "issue-field-status.status-view.no-permission-issue-term-refresh",
        "defaultMessage": "You don't have permission to transition this work item"
    },
    status: {
        "id": "issue-field-status.status-view.status",
        "defaultMessage": "Status"
    },
    createStatus: {
        "id": "issue-field-status.status-view.create-status",
        "defaultMessage": "Create status"
    },
    editStatus: {
        "id": "issue-field-status.status-view.edit-status",
        "defaultMessage": "Edit status"
    },
    manageWorkflow: {
        "id": "issue-field-status.status-view.manage-workflow",
        "defaultMessage": "Manage workflow"
    }
});

});


parcelRegister("19IK4", function(module, exports) {

$parcel$export(module.exports, "navigationDiscardChangesPromptEntrypoint", () => $80cba1b23dde79b9$export$e3fb8f8e2efee889);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $80cba1b23dde79b9$export$e3fb8f8e2efee889 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>Promise.resolve((parcelRequire("8Ltc3"))), {
        moduleId: "5b0a027b",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("8Ltc3", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "NavigationDiscardChangesPrompt", () => $d8d6a804dee6b1c1$export$80c1951973f41e27);
$parcel$export(module.exports, "default", () => $d8d6a804dee6b1c1$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $cA0Y2 = parcelRequire("cA0Y2");

var $ik0CA = parcelRequire("ik0CA");
var $kseeK = parcelRequire("kseeK");
var $2qG7I = parcelRequire("2qG7I");
var $5a9Ro = parcelRequire("5a9Ro");

var $aC4Bh = parcelRequire("aC4Bh");

var $2ZGUP = parcelRequire("2ZGUP");

var $lRq8t = parcelRequire("lRq8t");

var $4xbv3 = parcelRequire("4xbv3");
var $gCeeo = parcelRequire("gCeeo");
var $8Plmb = parcelRequire("8Plmb");

var $83DiZ = parcelRequire("83DiZ");

var $fYSdU = parcelRequire("fYSdU");
const $d8d6a804dee6b1c1$export$80c1951973f41e27 = ({ navigateLink: navigateLink, onConfirm: onConfirm, onCancel: onCancel })=>{
    const [isNavigating, setIsNavigating] = (0, $eJOHy.useState)(false);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { push: push } = (0, $83DiZ.useRouterActions)();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onCancelHandler = (_, analyticsEvent)=>{
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'cancelNavigationDisardChangesPrompt', {
            navigateLink: navigateLink
        });
        onCancel?.();
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onConfirmHandler = (_, analyticsEvent)=>{
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'confirmNavigationDisardChangesPrompt', {
            navigateLink: navigateLink
        });
        onConfirm && onConfirm();
        setIsNavigating(true);
        push(navigateLink);
    };
    if (!navigateLink) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        sourceType: (0, $466f60259c330878$export$1171103ea9083ffa),
        sourceName: "navigateWithoutRestore"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Plmb.MountEvent), {
        onMount: (0, $gCeeo.fireScreenAnalyticsDeferred)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2ZGUP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aC4Bh.JiraModal), {
        onClose: onCancelHandler,
        width: "small",
        shouldCloseOnOverlayClick: !isNavigating,
        shouldCloseOnEscapePress: !isNavigating,
        testId: "issue-create.common.ui.navigation-discard-changes-prompt.modal-dialog",
        messageId: "issue-create.common.ui.navigation-discard-changes-prompt.modal-dialog",
        messageType: "transactional"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2qG7I.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5a9Ro.default), null, formatMessage((0, $fYSdU.default).title))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ik0CA.default), null, formatMessage((0, $fYSdU.default).description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kseeK.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        testId: "issue-create.common.ui.navigation-discard-changes-prompt.button",
        appearance: "subtle-link",
        onClick: onCancelHandler,
        isDisabled: isNavigating
    }, formatMessage((0, $fYSdU.default).cancelButtonLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cA0Y2.default), {
        testId: "issue-create.common.ui.navigation-discard-changes-prompt.loading-button",
        appearance: "primary",
        onClick: onConfirmHandler,
        isDisabled: isNavigating,
        isLoading: isNavigating
    }, formatMessage((0, $fYSdU.default).confirmLabel))))));
};
function $d8d6a804dee6b1c1$export$2e2bcd8739ae039({ props: props }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d8d6a804dee6b1c1$export$80c1951973f41e27, props);
}

});
parcelRegister("fYSdU", function(module, exports) {

$parcel$export(module.exports, "default", () => $55799612447dde8c$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $55799612447dde8c$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    title: {
        "id": "issue-create.common.navigation-discard-changes-prompt.title",
        "defaultMessage": "Your changes won\u2019t be saved"
    },
    cancelButtonLabel: {
        "id": "issue-create.common.navigation-discard-changes-prompt.cancel-button-label",
        "defaultMessage": "Go back"
    },
    confirmLabel: {
        "id": "issue-create.common.navigation-discard-changes-prompt.confirm-label",
        "defaultMessage": "Discard"
    },
    description: {
        "id": "issue-create.common.navigation-discard-changes-prompt.description",
        "defaultMessage": "We won\u2019t be able to save your data if you move away from this page."
    }
});

});



parcelRegister("c3eoY", function(module, exports) {

$parcel$export(module.exports, "scrollToElement", () => $cf03a0716874f0b1$export$2353115f31f4d15);
$parcel$export(module.exports, "preventEscKeyPropagationKeyPressHandler", () => $cf03a0716874f0b1$export$feb08457bf70a411);
$parcel$export(module.exports, "scrollToField", () => $cf03a0716874f0b1$export$a3f522e44642cd81);
$parcel$export(module.exports, "setFocusOnField", () => $cf03a0716874f0b1$export$6d4af31966a73868);

var $a7rgl = parcelRequire("a7rgl");

var $3UrQk = parcelRequire("3UrQk");

var $lVUBx = parcelRequire("lVUBx");

var $3qIbb = parcelRequire("3qIbb");



const $cf03a0716874f0b1$export$2353115f31f4d15 = (elementId)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const fieldRef = document.getElementById(elementId);
    if (fieldRef) (0, $a7rgl.default)(fieldRef, (0, $3UrQk.DEFAULT_SCROLL_OPTIONS));
};
const $cf03a0716874f0b1$export$feb08457bf70a411 = (event)=>{
    if (event?.keyCode === (0, $3qIbb.ESC_KEY_KEYCODE)) event?.nativeEvent?.stopImmediatePropagation();
};
const $cf03a0716874f0b1$export$a3f522e44642cd81 = (fieldId)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const fieldWithErrorRef = document.getElementById((0, $lVUBx.getFieldContainerId)(fieldId));
    if (fieldWithErrorRef) (0, $a7rgl.default)(fieldWithErrorRef, (0, $3UrQk.DEFAULT_SCROLL_OPTIONS));
};
const $cf03a0716874f0b1$var$getFieldId = (fieldId)=>`${fieldId}-field`;
const $cf03a0716874f0b1$export$6d4af31966a73868 = (fieldId)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const fieldWithErrorRef = document.getElementById($cf03a0716874f0b1$var$getFieldId(fieldId));
    if (fieldWithErrorRef) fieldWithErrorRef.focus?.();
};

});
parcelRegister("lVUBx", function(module, exports) {

$parcel$export(module.exports, "getFieldContainerId", () => $b086e21bef4ab9c9$export$10904a5319f8077);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports








const $b086e21bef4ab9c9$export$10904a5319f8077 = (fieldId)=>`${fieldId}-container`;

});

parcelRegister("3qIbb", function(module, exports) {

$parcel$export(module.exports, "FIELDS_LEARN_MORE_LINKS", () => $34c3eb289048be4e$export$629cb7e52dfd594b);
$parcel$export(module.exports, "USER_GIC_POSITIONING_SPOTLIGHT", () => $34c3eb289048be4e$export$1056c1e726f183f9);
$parcel$export(module.exports, "ESC_KEY_KEYCODE", () => $34c3eb289048be4e$export$53016e09dd7d4dca);

const $34c3eb289048be4e$export$483ce8a526ee009f = 'https://support.atlassian.com/jira-core-cloud/docs/create-and-work-with-issues/';
const $34c3eb289048be4e$export$d807a38e79102eb0 = 'https://support.atlassian.com/jira-work-management/docs/what-is-the-new-jira-issue-create-experience/';
const $34c3eb289048be4e$export$629cb7e52dfd594b = {
    [(0, $af620ae3ac843a8a$export$252fb981af0e2e4e)]: '/secure/ShowConstantsHelp.jspa?decorator=popup#ResolutionTypes',
    [(0, $af620ae3ac843a8a$export$909ba97f4a791588)]: '/secure/ShowConstantsHelp.jspa?decorator=popup#SecurityLevels',
    [(0, $af620ae3ac843a8a$export$de14210faa5f2099)]: '/secure/ShowConstantsHelp.jspa?decorator=popup#PriorityLevels'
};
const $34c3eb289048be4e$export$1056c1e726f183f9 = 'jira.user.gic.positioning.spotlight';
const $34c3eb289048be4e$export$53016e09dd7d4dca = 27;

});
// graphql __typename
const $af620ae3ac843a8a$export$aa5680ad8f8be9fc = 'JiraProjectField';
const $af620ae3ac843a8a$export$2d5a62a3515ad4c6 = 'JiraIssueTypeField';
const $af620ae3ac843a8a$export$a12a4b25ab12710c = 'JsmRequestTypeField';
const $af620ae3ac843a8a$export$23ca38ad884e35f1 = 'JiraSingleLineTextField';
const $af620ae3ac843a8a$export$31a6c27df1f927b2 = 'JiraRichTextField';
const $af620ae3ac843a8a$export$30b2c2de5e3007a4 = 'JiraComponentsField';
const $af620ae3ac843a8a$export$f10e53e8928b61bd = 'JiraDataClassificationField';
const $af620ae3ac843a8a$export$3849bb04b4eee607 = 'JiraSingleSelectUserPickerField';
const $af620ae3ac843a8a$export$eca94ae30cb92d8 = 'JiraMultipleSelectUserPickerField';
const $af620ae3ac843a8a$export$2bb9d057bad89bfa = 'JiraPeopleField';
const $af620ae3ac843a8a$export$b1ac879bb5cdf30a = 'JsmPeopleField';
const $af620ae3ac843a8a$export$e4d5e04bc56680dc = 'JiraNumberField';
const $af620ae3ac843a8a$export$d8312cdfa02c100d = 'JiraDateTimePickerField';
const $af620ae3ac843a8a$export$8723b724f0b3ac65 = 'JiraEpicLinkField';
const $af620ae3ac843a8a$export$64c7789e86344de5 = 'JiraLabelsField';
const $af620ae3ac843a8a$export$f4f101295d5cc151 = 'JiraSingleVersionPickerField';
const $af620ae3ac843a8a$export$5bb498d4f2f54799 = 'JiraMultipleVersionPickerField';
const $af620ae3ac843a8a$export$de14210faa5f2099 = 'JiraPriorityField';
const $af620ae3ac843a8a$export$47af4d6f62c134cf = 'JiraIssueLinkField';
const $af620ae3ac843a8a$export$e0b268941120d761 = 'JiraDatePickerField';
const $af620ae3ac843a8a$export$909ba97f4a791588 = 'JiraSecurityLevelField';
const $af620ae3ac843a8a$export$f2b56433dc0af401 = 'JiraUrlField';
const $af620ae3ac843a8a$export$d10237d945259f96 = 'JiraCheckboxesField';
const $af620ae3ac843a8a$export$27854f490d658fc4 = 'JiraRadioSelectField';
const $af620ae3ac843a8a$export$fb8861017089d392 = 'JiraSingleSelectField';
const $af620ae3ac843a8a$export$2055419ff013de79 = 'JiraMultipleSelectField';
const $af620ae3ac843a8a$export$16fe78a07e97f2ad = 'JiraSingleGroupPickerField';
const $af620ae3ac843a8a$export$3a1ae3e0f2d9b1b9 = 'JiraMultipleGroupPickerField';
const $af620ae3ac843a8a$export$64238d76a1dc0703 = 'JiraSprintField';
const $af620ae3ac843a8a$export$1070aada56fcaec9 = 'JiraColorField';
const $af620ae3ac843a8a$export$a9b3195cbef5c5ad = 'JiraAttachmentsField';
const $af620ae3ac843a8a$export$76d811609080a7aa = 'JiraIssueRestrictionField';
const $af620ae3ac843a8a$export$252fb981af0e2e4e = 'JiraResolutionField';
const $af620ae3ac843a8a$export$a36509fae9e84682 = 'JiraCascadingSelectField';
const $af620ae3ac843a8a$export$79443fedd031b437 = 'JiraTeamField';
const $af620ae3ac843a8a$export$5e56d79dfe9be3d = 'JiraAffectedServicesField';
const $af620ae3ac843a8a$export$d41ae99ff05f5cda = 'JsmMultipleSelectUserPickerField';
const $af620ae3ac843a8a$export$597fa240de2bfd92 = 'JiraCMDBField';
const $af620ae3ac843a8a$export$864384797e544339 = 'JsmOrganizationField';
const $af620ae3ac843a8a$export$7e5590c7c7a403c0 = 'JiraConnectTextField';
const $af620ae3ac843a8a$export$d854193d90dc547d = 'JiraConnectNumberField';
const $af620ae3ac843a8a$export$985c14eb8f3f0309 = 'JiraConnectSingleSelectField';
const $af620ae3ac843a8a$export$9f6f73ea02649f83 = 'JiraConnectMultipleSelectField';
const $af620ae3ac843a8a$export$aecc734a7c3591d7 = 'JiraTimeTrackingField';
const $af620ae3ac843a8a$export$d9861709f0b70c10 = 'JiraWorkLogField';
const $af620ae3ac843a8a$export$7a583e2ae9052377 = 'JiraConnectRichTextField';
const $af620ae3ac843a8a$export$8643f0b9cefed538 = 'JiraForgeStringField';
const $af620ae3ac843a8a$export$e0ece81bd398c799 = 'JiraForgeNumberField';
const $af620ae3ac843a8a$export$745c8245fea49a34 = 'JiraForgeUserField';
const $af620ae3ac843a8a$export$bbc6b85844b0ade5 = 'JiraForgeUsersField';
const $af620ae3ac843a8a$export$fd24d37af44fe736 = 'JiraForgeGroupField';
const $af620ae3ac843a8a$export$3027db6317a2a8ea = 'JiraForgeGroupsField';
const $af620ae3ac843a8a$export$f596336c24b128f5 = 'JiraForgeStringsField';
const $af620ae3ac843a8a$export$70ff025076e5fb13 = 'JiraForgeDatetimeField';
const $af620ae3ac843a8a$export$111f32c51678063a = 'JiraForgeDateField';
const $af620ae3ac843a8a$export$67aca33725b6a717 = 'JiraForgeObjectField';
const $af620ae3ac843a8a$export$1c7f7cfd2029442f = 'JiraAtlassianTeamField';
const $af620ae3ac843a8a$export$670384150af5f49e = 'JiraParentIssueField';
const $af620ae3ac843a8a$export$bf9df74e065af482 = 'JiraParentField';
const $af620ae3ac843a8a$export$33f8a9cb608132ba = 'JiraServiceManagementRespondersField';
const $af620ae3ac843a8a$export$fc69de49ba08ae77 = 'JiraServiceManagementEntitlementField';
const $af620ae3ac843a8a$export$ede7166f44cc4bd6 = 'JiraCustomerServiceOrganizationField';
const $af620ae3ac843a8a$export$a138d5648dda03f0 = 'JiraMessageEditField';
const $af620ae3ac843a8a$export$f7a08bf17a7ac661 = 'JiraAssigneeField';
const $af620ae3ac843a8a$export$d64150fd9c66969c = 'JiraReporterField';
const $af620ae3ac843a8a$export$95433ac963f4aebe = 'JiraTextAreaField';
const $af620ae3ac843a8a$export$f57941b9c1949a82 = 'JiraEpicColorField';
const $af620ae3ac843a8a$export$3e8dded8d83b5d95 = 'JiraAssetField';



parcelRegister("cFxTI", function(module, exports) {

$parcel$export(module.exports, "getIssueDiscoveryUrl", () => $6f5eb32ca668450c$export$852450339fdb3b37);
const $6f5eb32ca668450c$export$852450339fdb3b37 = (createdIssues)=>{
    if (createdIssues.length > 1) {
        const issueKeys = createdIssues.map((issue)=>issue.issueKey).join(',');
        const jqlSearch = encodeURIComponent(`issueKey in (${issueKeys})`);
        return `/issues/?jql=${jqlSearch}`;
    }
    return `/browse/${createdIssues[0].issueKey}`;
};

});

parcelRegister("73QLY", function(module, exports) {

$parcel$export(module.exports, "useSmartFieldsMachineLearning", () => $43faf3cac4c15402$export$2d70bc5538735402);

var $7JXbP = parcelRequire("7JXbP");

var $eJrcF = parcelRequire("eJrcF");
const $43faf3cac4c15402$export$f66e1f764818b2e = ()=>(0, $eJrcF.useResource)((0, $7JXbP.gicSmartFieldsFeatureResource));
const $43faf3cac4c15402$export$2d70bc5538735402 = ()=>{
    const { loading: loadingJiraLabsSmartFields, data: jiraLabsSmartFieldsData } = $43faf3cac4c15402$export$f66e1f764818b2e();
    const hasUserOptedOut = jiraLabsSmartFieldsData?.hasUserOptedOut;
    const withMachineLearning = !loadingJiraLabsSmartFields && !hasUserOptedOut;
    return {
        withMachineLearning: withMachineLearning
    };
};

});

parcelRegister("9DD83", function(module, exports) {

$parcel$export(module.exports, "useChangerSpotlight", () => $1e1a87c5072e8eda$export$6e0f4554859c42e9);

var $eJOHy = parcelRequire("eJOHy");

var $fYeTG = parcelRequire("fYeTG");

var $3qIbb = parcelRequire("3qIbb");

var $aH5JD = parcelRequire("aH5JD");
const $1e1a87c5072e8eda$export$6e0f4554859c42e9 = (minimizableModalView)=>{
    const [allowShowingChangerSpotlight, setAllowShowingChangerSpotlight] = (0, $eJOHy.useState)(false);
    const [userPreferenceSpotlight, setUserPreferences] = (0, $aH5JD.useUserPreferences)((0, $3qIbb.USER_GIC_POSITIONING_SPOTLIGHT), false);
    const hasSeenGicPositioningSpotlight = userPreferenceSpotlight;
    const isMobileExperienceEnabled = (0, $fYeTG.isMobileAndInMvpOrExistingUsersExperiment)();
    const shouldShowChangerSpotlight = !hasSeenGicPositioningSpotlight && allowShowingChangerSpotlight && !isMobileExperienceEnabled;
    const onCloseChangerSpotlight = (0, $eJOHy.useCallback)(()=>{
        if (!hasSeenGicPositioningSpotlight) {
            setAllowShowingChangerSpotlight(false);
            setUserPreferences(true);
        }
    }, [
        setAllowShowingChangerSpotlight,
        hasSeenGicPositioningSpotlight,
        setUserPreferences
    ]);
    const isModalView = minimizableModalView === 'modal';
    (0, $eJOHy.useEffect)(()=>{
        if (!isModalView && shouldShowChangerSpotlight) onCloseChangerSpotlight();
    }, [
        onCloseChangerSpotlight,
        isModalView,
        shouldShowChangerSpotlight
    ]);
    const onOpenSpotlight = ()=>{
        if (isModalView) setAllowShowingChangerSpotlight(true);
    };
    const onCloseSpotlight = ()=>{
        if (isModalView) onCloseChangerSpotlight();
    };
    return {
        shouldShowChangerSpotlight: shouldShowChangerSpotlight,
        onOpenSpotlight: onOpenSpotlight,
        onCloseSpotlight: onCloseSpotlight
    };
};

});
parcelRegister("aH5JD", function(module, exports) {

$parcel$export(module.exports, "useUserPreferences", () => $8b2f314781bc9f3a$export$b6472e0d8983f5f5);

var $eJOHy = parcelRequire("eJOHy");

var $exWdq = parcelRequire("exWdq");

var $eDBhy = parcelRequire("eDBhy");

var $jGzN3 = parcelRequire("jGzN3");
const $8b2f314781bc9f3a$var$setGICUserPreferences = async (key, value)=>{
    try {
        await (0, $jGzN3.performPutRequest)(`/rest/api/3/mypreferences?key=${key}`, {
            body: JSON.stringify({
                value: value
            })
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $eDBhy.fireIssueCreateErrorAnalytics)({
            meta: {
                id: 'getAPI3MyPreferences',
                packageName: 'jiraIssueCreate',
                teamName: 'gryffindor'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }
};
const $8b2f314781bc9f3a$export$b6472e0d8983f5f5 = (key, fallbackState)=>{
    const [state, setState] = (0, $eJOHy.useState)(fallbackState);
    (0, $eJOHy.useEffect)(()=>{
        const run = async ()=>{
            try {
                const apiResult = await (0, $jGzN3.performGetRequest)(`/rest/api/3/mypreferences?key=${key}`);
                if (typeof apiResult !== 'object' || !(0, (/*@__PURE__*/$parcel$interopDefault($exWdq)))(apiResult, 'value')) {
                    const error = new Error('Invalid preference value');
                    (0, $eDBhy.fireIssueCreateErrorAnalytics)({
                        meta: {
                            id: 'getAPI3MyPreferences',
                            packageName: 'jiraIssueCreate',
                            teamName: 'gryffindor'
                        },
                        error: error,
                        sendToPrivacyUnsafeSplunk: true
                    });
                    return;
                }
                setState(apiResult.value);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                if (error.statusCode === 404) // Error 404 is acceptable as the first time the key does not exist in the user profile.
                return;
                (0, $eDBhy.fireIssueCreateErrorAnalytics)({
                    meta: {
                        id: 'getAPI3MyPreferences',
                        packageName: 'jiraIssueCreate',
                        teamName: 'gryffindor'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        };
        run();
    }, [
        key
    ]);
    const setUserPreferences = (0, $eJOHy.useCallback)((value)=>{
        $8b2f314781bc9f3a$var$setGICUserPreferences(key, value);
        setState(value);
    }, [
        key
    ]);
    return [
        state,
        setUserPreferences
    ];
};

});


parcelRegister("6u3jg", function(module, exports) {

$parcel$export(module.exports, "useIsGICPositioningEnabled", () => $c8a4c0149a435516$export$a782e9359ada4cd3);

var $eJOHy = parcelRequire("eJOHy");

var $9UgK2 = parcelRequire("9UgK2");
const $c8a4c0149a435516$export$a782e9359ada4cd3 = ()=>{
    const [{ disableGICPositioning: disableGICPositioning }] = (0, $9UgK2.useGICPositioningEnabledController)();
    const isGICPositioningEnabled = (0, $eJOHy.useCallback)(()=>!disableGICPositioning, [
        disableGICPositioning
    ]);
    return isGICPositioningEnabled;
};

});
parcelRegister("9UgK2", function(module, exports) {

$parcel$export(module.exports, "useGICPositioningEnabledController", () => $3bc959ae5c53f92f$export$9cc1c859181a0ff4);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $3bc959ae5c53f92f$var$initialState = {
    disableGICPositioning: false
};
const $3bc959ae5c53f92f$var$actions = {
    setDisableGICPositioning: (disableGICPositioning)=>({ setState: setState })=>{
            setState({
                disableGICPositioning: disableGICPositioning
            });
        }
};
const $3bc959ae5c53f92f$var$Store = (0, $GtRbT.createStore)({
    initialState: $3bc959ae5c53f92f$var$initialState,
    actions: $3bc959ae5c53f92f$var$actions,
    name: 'GICPositioningEnabledController'
});
const $3bc959ae5c53f92f$export$4bfa4009172d242 = (0, $6E16M.createContainer)($3bc959ae5c53f92f$var$Store);
const $3bc959ae5c53f92f$export$9cc1c859181a0ff4 = (0, $iJq0l.createHook)($3bc959ae5c53f92f$var$Store);

});


parcelRegister("fV6Ej", function(module, exports) {

$parcel$export(module.exports, "useRequestTypeFieldsLayoutPreference", () => $ec2db889137f5ea2$export$7f6ea71dfb4ea52b);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $eJGlj = parcelRequire("eJGlj");

var $52z6a = parcelRequire("52z6a");
const $ec2db889137f5ea2$export$d4c72bab9d6cc13a = {
    isInitialised: false,
    data: (0, $52z6a.fallbackValue),
    isLoading: false
};
const $ec2db889137f5ea2$var$store = (0, $GtRbT.createStore)({
    name: 'RequestTypeFieldsLayoutUserPreference',
    initialState: $ec2db889137f5ea2$export$d4c72bab9d6cc13a,
    actions: $eJGlj.actions
});
const $ec2db889137f5ea2$export$7f6ea71dfb4ea52b = (0, $iJq0l.createHook)($ec2db889137f5ea2$var$store);

});
parcelRegister("eJGlj", function(module, exports) {

$parcel$export(module.exports, "actions", () => $1ba653a50b94c507$export$e324594224ef24da);


var $FppkK = parcelRequire("FppkK");

var $eDBhy = parcelRequire("eDBhy");

var $1uIew = parcelRequire("1uIew");

var $8KUFq = parcelRequire("8KUFq");

var $gCeeo = parcelRequire("gCeeo");

var $52z6a = parcelRequire("52z6a");
const $1ba653a50b94c507$var$initialise = (accountId, createAnalyticsEvent)=>async ({ setState: setState, getState: getState })=>{
        const state = getState();
        if (!state.isInitialised && accountId !== null) {
            setState({
                isLoading: true
            });
            await (0, $FppkK.getUserProperty)(accountId, (0, $52z6a.propertyKey)).then((value)=>{
                setState({
                    isInitialised: true,
                    data: value === (0, $52z6a.UserPreference).RequestFormFields,
                    isLoading: false
                });
                (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), 'getRequestTypesLayoutPreference succeeded', {});
            }).catch((error)=>{
                if (error.statusCode === (0, $44ccf6b895337c89$export$8bca792d963eb0ef)) {
                    // user preference has not been set
                    setState({
                        isLoading: false,
                        data: (0, $52z6a.fallbackValue)
                    });
                    (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), 'getRequestTypesLayoutPreference succeeded', {});
                } else {
                    setState({
                        isLoading: false
                    });
                    (0, $eDBhy.fireIssueCreateErrorAnalytics)({
                        meta: {
                            id: 'getRequestTypesLayoutPreference',
                            packageName: 'jiraIssueCreate',
                            teamName: 'gryffindor'
                        },
                        error: error,
                        attributes: {
                            isClientFetchError: (0, $8KUFq.isClientFetchError)(error)
                        },
                        sendToPrivacyUnsafeSplunk: true
                    });
                }
            });
        }
    };
const $1ba653a50b94c507$var$setPreference = (accountId, isEnabled, createAnalyticsEvent, callback)=>async ({ setState: setState, getState: getState })=>{
        const { isLoading: isLoading, data: oldValue } = getState();
        if (accountId && !isLoading) {
            setState({
                data: isEnabled,
                isLoading: true
            });
            await (0, $FppkK.setUserProperties)(accountId, (0, $52z6a.propertyKey), JSON.stringify(isEnabled ? (0, $52z6a.UserPreference).RequestFormFields : (0, $52z6a.UserPreference).ScreenFields)).then((res)=>{
                if (!res.ok) return res.text().then((errResp)=>{
                    throw new (0, $1uIew.default)(res.status, errResp);
                });
                setState({
                    data: isEnabled,
                    isLoading: false
                });
                (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'setRequestTypesLayoutPreference succeeded', {
                    isEnabled: isEnabled
                });
                return callback();
            }).catch((error)=>{
                setState({
                    data: oldValue,
                    isLoading: false
                });
                (0, $eDBhy.fireIssueCreateErrorAnalytics)({
                    meta: {
                        id: 'setRequestTypesLayoutPreference',
                        packageName: 'jiraIssueCreate',
                        teamName: 'gryffindor'
                    },
                    error: error,
                    attributes: {
                        isClientFetchError: (0, $8KUFq.isClientFetchError)(error)
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            });
        }
    };
const $1ba653a50b94c507$export$e324594224ef24da = {
    setPreference: $1ba653a50b94c507$var$setPreference,
    initialise: $1ba653a50b94c507$var$initialise
};

});
const $44ccf6b895337c89$export$ff39ebd4bb12b718 = 201;
const $44ccf6b895337c89$export$3288b14b6745c572 = 204;
const $44ccf6b895337c89$export$9de493bcd9b1d977 = 400;
const $44ccf6b895337c89$export$67d19e9a991baa07 = 401;
const $44ccf6b895337c89$export$a3269a3914b007e3 = 403;
const $44ccf6b895337c89$export$8bca792d963eb0ef = 404;
const $44ccf6b895337c89$export$4a3cb39801694eee = 407;
const $44ccf6b895337c89$export$fa405bbf47d510e2 = 408;
const $44ccf6b895337c89$export$c09e7ea0fc79f34f = 409;
const $44ccf6b895337c89$export$5244030134e99 = 412;
const $44ccf6b895337c89$export$f90ac1df0b60853d = 413;
const $44ccf6b895337c89$export$a447d0a965e16776 = 422;
const $44ccf6b895337c89$export$3b48aba8957000cd = 426;
const $44ccf6b895337c89$export$6763168a631449a2 = 429;
const $44ccf6b895337c89$export$e813cd7045fcc98d = 500;
const $44ccf6b895337c89$export$2ce38d41a306034e = 502;
const $44ccf6b895337c89$export$974c37534b0191b1 = 503;
const $44ccf6b895337c89$export$5400e8dddac3fcf3 = 504;

parcelRegister("52z6a", function(module, exports) {

$parcel$export(module.exports, "fallbackValue", () => $df3b7b6e9f0ddb3c$export$91cd7f5c38b6ba2);
$parcel$export(module.exports, "propertyKey", () => $df3b7b6e9f0ddb3c$export$52266bfa96e3a752);
$parcel$export(module.exports, "UserPreference", () => $df3b7b6e9f0ddb3c$export$9eb786c5fec4a558);
const $df3b7b6e9f0ddb3c$export$91cd7f5c38b6ba2 = true;
const $df3b7b6e9f0ddb3c$export$52266bfa96e3a752 = 'gic-jsm-fields-layout-preference';
const $df3b7b6e9f0ddb3c$export$9eb786c5fec4a558 = {
    ScreenFields: 'SCREEN_FIELDS',
    RequestFormFields: 'REQUEST_FORM_FIELDS'
};

});



parcelRegister("fbTM0", function(module, exports) {

$parcel$export(module.exports, "useFetchForgeModules", () => $4ddacf5c9659cbf5$export$36c81308105ff728);

var $eJOHy = parcelRequire("eJOHy");

var $7mF43 = parcelRequire("7mF43");

var $6Abnv = parcelRequire("6Abnv");

var $8V8so = parcelRequire("8V8so");

var $1O6Yz = parcelRequire("1O6Yz");

var $kU13U = parcelRequire("kU13U");

var $hPZg4 = parcelRequire("hPZg4");

var $fohjD = parcelRequire("fohjD");

var $dhAnj = parcelRequire("dhAnj");

var $ap5IR = parcelRequire("ap5IR");

var $lvKO5 = parcelRequire("lvKO5");

var $jkiQK = parcelRequire("jkiQK");

var $7jTnu = parcelRequire("7jTnu");
const $4ddacf5c9659cbf5$var$moduleToVariableKey = (module)=>(0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))(module);
const $4ddacf5c9659cbf5$export$44097e02a91cd11a = (extensions)=>{
    const groupedExtensions = (0, (/*@__PURE__*/$parcel$interopDefault($6Abnv)))(extensions, 'type');
    const groupedExtensionsWithMappedKeys = (0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, (/*@__PURE__*/$parcel$interopDefault($8V8so)))(groupedExtensions, (_, key)=>$4ddacf5c9659cbf5$var$moduleToVariableKey(key)), (0, $fohjD.getEmptyExtensionsObject)());
    const filteredOutDuplicatedExtensions = (0, $ap5IR.filterOutDuplicatedExtensions)(groupedExtensionsWithMappedKeys);
    const allowedExtensions = (0, $fohjD.getEmptyExtensionsObject)();
    const accessNarrowedExtensions = (0, $fohjD.getEmptyExtensionsObject)();
    Object.entries(filteredOutDuplicatedExtensions).forEach(([key, module])=>{
        const allowedExtensionsMap = new Map();
        const accessNarrowedExtensionsMap = new Map();
        module.forEach((moduleItem)=>{
            if ((0, $kU13U.isExtensionHiddenByAppAccessRules)(moduleItem)) accessNarrowedExtensionsMap.set(moduleItem.id, moduleItem);
            else allowedExtensionsMap.set(moduleItem.id, moduleItem);
        });
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        allowedExtensions[key] = [
            ...allowedExtensionsMap.values()
        ];
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        accessNarrowedExtensions[key] = [
            ...accessNarrowedExtensionsMap.values()
        ];
    });
    return {
        extensions: allowedExtensions,
        accessNarrowedExtensions: accessNarrowedExtensions
    };
};
const $4ddacf5c9659cbf5$export$281dc5a8fd9afe5a = async (cloudId, isAnonymous, projectKey)=>{
    const extensionsData = await (0, $dhAnj.fetchModules)({
        cloudId: cloudId,
        isAnonymous: isAnonymous,
        context: {
            projectKey: projectKey
        },
        includeHidden: true,
        includeScopes: true,
        types: [
            (0, $fohjD.CUSTOM_FIELD_MODULE),
            (0, $fohjD.CUSTOM_FIELD_TYPE_MODULE)
        ],
        source: (0, $fohjD.SOURCE_GLOBAL_ISSUE_CREATE)
    });
    const extensionsFlat = Object.values(extensionsData).flat();
    return $4ddacf5c9659cbf5$export$44097e02a91cd11a(extensionsFlat);
};
const $4ddacf5c9659cbf5$export$36c81308105ff728 = (extraContext = {})=>{
    const { cloudId: cloudId, isAnonymous: isAnonymous } = (0, $lvKO5.useTenantContext)();
    const request = (0, $eJOHy.useCallback)(()=>{
        return $4ddacf5c9659cbf5$export$281dc5a8fd9afe5a(cloudId, isAnonymous, extraContext.projectKey);
    }, [
        cloudId,
        isAnonymous,
        extraContext.projectKey
    ]);
    const { data: data, error: error, fetch: fetch, loadingStatus: loadingStatus } = (0, $hPZg4.useLoadingStatusService)(request, {
        loading: true
    });
    (0, $eJOHy.useEffect)(()=>{
        if (extraContext.projectKey) fetch();
    }, [
        fetch,
        extraContext.projectKey
    ]);
    return (0, $eJOHy.useMemo)(()=>{
        const customFields = [];
        const filteredOutModules = [];
        const modules = data?.extensions;
        const accessNarrowedModules = data?.accessNarrowedExtensions;
        accessNarrowedModules?.jiraCustomField?.forEach((module)=>{
            filteredOutModules.push(module);
        });
        accessNarrowedModules?.jiraCustomFieldType?.forEach((module)=>{
            filteredOutModules.push(module);
        });
        modules?.jiraCustomField?.forEach((module)=>{
            if ((0, $kU13U.isExtensionVisible)(module)) {
                if ((0, $7jTnu.fg)('ditto-fcf-support-new-manifest-on-frontend')) {
                    const transformedModule = (0, $jkiQK.transformExtension)(module);
                    if (transformedModule) customFields.push(transformedModule);
                } else customFields.push(module);
            } else filteredOutModules.push(module);
        });
        modules?.jiraCustomFieldType?.forEach((module)=>{
            if ((0, $kU13U.isExtensionVisible)(module)) {
                if ((0, $7jTnu.fg)('ditto-fcf-support-new-manifest-on-frontend')) {
                    const transformedModule = (0, $jkiQK.transformExtension)(module);
                    if (transformedModule) customFields.push(transformedModule);
                } else customFields.push(module);
            } else filteredOutModules.push(module);
        });
        return {
            customFields: customFields,
            filteredOutModules: filteredOutModules,
            error: error,
            loadingStatus: loadingStatus
        };
    }, [
        data,
        loadingStatus,
        error
    ]);
};

});
parcelRegister("6Abnv", function(module, exports) {

var $iBJlb = parcelRequire("iBJlb");

var $a9KaZ = parcelRequire("a9KaZ");
/** Used for built-in method references. */ var $4caeee4f6c048b0e$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $4caeee4f6c048b0e$var$hasOwnProperty = $4caeee4f6c048b0e$var$objectProto.hasOwnProperty;
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The order of grouped values
 * is determined by the order they occur in `collection`. The corresponding
 * value of each key is an array of elements responsible for generating the
 * key. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': [4.2], '6': [6.1, 6.3] }
 *
 * // The `_.property` iteratee shorthand.
 * _.groupBy(['one', 'two', 'three'], 'length');
 * // => { '3': ['one', 'two'], '5': ['three'] }
 */ var $4caeee4f6c048b0e$var$groupBy = $a9KaZ(function(result, value, key) {
    if ($4caeee4f6c048b0e$var$hasOwnProperty.call(result, key)) result[key].push(value);
    else $iBJlb(result, key, [
        value
    ]);
});
module.exports = $4caeee4f6c048b0e$var$groupBy;

});

parcelRegister("8V8so", function(module, exports) {

var $iBJlb = parcelRequire("iBJlb");

var $75Jcs = parcelRequire("75Jcs");

var $1lM9j = parcelRequire("1lM9j");
/**
 * The opposite of `_.mapValues`; this method creates an object with the
 * same values as `object` and keys generated by running each own enumerable
 * string keyed property of `object` thru `iteratee`. The iteratee is invoked
 * with three arguments: (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapValues
 * @example
 *
 * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
 *   return key + value;
 * });
 * // => { 'a1': 1, 'b2': 2 }
 */ function $67ea34f606cb6857$var$mapKeys(object, iteratee) {
    var result = {};
    iteratee = $1lM9j(iteratee, 3);
    $75Jcs(object, function(value, key, object) {
        $iBJlb(result, iteratee(value, key, object), value);
    });
    return result;
}
module.exports = $67ea34f606cb6857$var$mapKeys;

});

parcelRegister("ap5IR", function(module, exports) {

$parcel$export(module.exports, "filterOutDuplicatedExtensions", () => $1b89af60c86de9f4$export$e0393e97f15a28a5);

var $5spib = parcelRequire("5spib");

var $fohjD = parcelRequire("fohjD");
const $1b89af60c86de9f4$export$e0393e97f15a28a5 = (modules)=>{
    const filteredModules = (0, $fohjD.getEmptyExtensionsObject)();
    (0, (/*@__PURE__*/$parcel$interopDefault($5spib)))(modules, (module, propName)=>{
        const moduleExtensions = new Map();
        (0, (/*@__PURE__*/$parcel$interopDefault($5spib)))(module, (moduleItem)=>{
            const moduleExtension = moduleExtensions.get(moduleItem.id);
            const appVersion = moduleItem?.appVersion || '0.0.0';
            const moduleAppVersion = moduleExtension?.appVersion || '0.0.0';
            if (!moduleExtension || moduleExtension && appVersion >= moduleAppVersion) moduleExtensions.set(moduleItem.id, moduleItem);
        });
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        filteredModules[propName] = [
            ...moduleExtensions.values()
        ];
    });
    return filteredModules;
};

});

parcelRegister("jkiQK", function(module, exports) {

$parcel$export(module.exports, "transformExtension", () => $91c740c9f1108498$export$39ee489473821fbd);

var $8dH3d = parcelRequire("8dH3d");
function $91c740c9f1108498$var$isCustomFieldSchemaNew(obj) {
    if (typeof obj === 'object' && obj !== null && 'properties' in obj && typeof obj.properties === 'object' && obj.properties !== null) return 'view' in obj.properties || 'edit' in obj.properties && typeof obj.properties.edit === 'object' && obj.properties.edit !== null && ('validation' in obj.properties.edit || 'experience' in obj.properties.edit);
    return false;
}
function $91c740c9f1108498$export$39ee489473821fbd(extension) {
    if (!extension) return null;
    if ($91c740c9f1108498$var$isCustomFieldSchemaNew(extension)) return extension;
    const { key: key, type: type, name: name, description: description, readOnly: readOnly, collection: collection, resourceUploadId: resourceUploadId, formatter: formatter, validation: validation, edit: edit, value: value, render: render, resource: resource, function: viewFunction } = extension.properties;
    let newEdit;
    if (edit) {
        if ('resource' in edit) {
            const { resource: editResource, render: editRender, isInline: isInline } = edit;
            newEdit = {
                resource: editResource,
                ...editRender && {
                    render: editRender
                },
                ...validation && {
                    validation: validation
                },
                ...isInline && {
                    isInline: isInline
                }
            };
            newEdit.experience = [
                'issue-create',
                'issue-view',
                'issue-transition'
            ];
        } else {
            const { function: editFunction } = edit;
            newEdit = {
                ...editFunction && {
                    function: editFunction
                },
                ...validation && {
                    validation: validation
                }
            };
        }
    } else newEdit = {
        ...validation && {
            validation: validation
        }
    };
    let newView;
    if (viewFunction) newView = {
        function: viewFunction,
        ...formatter && {
            formatter: formatter
        },
        ...value && {
            value: value
        }
    };
    else {
        newView = {
            ...formatter && {
                formatter: formatter
            },
            ...value && {
                value: value
            },
            ...render && {
                render: render
            },
            ...resource && {
                resource: resource
            }
        };
        if (newView.resource) newView.experience = [
            'issue-view'
        ];
    }
    const transformed = {
        key: key,
        type: type,
        name: name,
        description: description,
        ...resourceUploadId && {
            resourceUploadId: resourceUploadId
        },
        ...readOnly && {
            readOnly: readOnly
        },
        ...collection && {
            collection: collection
        },
        ...!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(newEdit) && {
            edit: newEdit
        },
        ...!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(newView) && {
            view: newView
        }
    };
    const newExtension = {
        ...extension,
        properties: transformed
    };
    return newExtension;
}

});


parcelRegister("9QRTY", function(module, exports) {

$parcel$export(module.exports, "default", () => $ece100c4f3c02012$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $hPZg4 = parcelRequire("hPZg4");

var $lvKO5 = parcelRequire("lvKO5");

var $3fFrR = parcelRequire("3fFrR");
const $ece100c4f3c02012$var$useFetchTransitionsService = ()=>{
    const { cloudId: cloudId } = (0, $lvKO5.useTenantContext)();
    const fetchTransitions = (0, $eJOHy.useCallback)(({ projectId: projectId, issueTypeId: issueTypeId, selectedCloudId: selectedCloudId })=>(0, $3fFrR.default)(selectedCloudId || cloudId, projectId, issueTypeId), [
        cloudId
    ]);
    const { loading: loading, error: error, data: data, fetch: fetch } = (0, $hPZg4.useService)(fetchTransitions);
    return [
        {
            isLoading: loading,
            error: error,
            transitions: data
        },
        fetch
    ];
};
var $ece100c4f3c02012$export$2e2bcd8739ae039 = $ece100c4f3c02012$var$useFetchTransitionsService;

});
parcelRegister("3fFrR", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2ddb64346c6f2d4$export$2e2bcd8739ae039);

var $eDBhy = parcelRequire("eDBhy");

var $jGzN3 = parcelRequire("jGzN3");

var $iIqFO = parcelRequire("iIqFO");

var $8W2Eb = parcelRequire("8W2Eb");
const $d2ddb64346c6f2d4$var$constructEndpoint = (cloudId)=>`/gateway/api/jira/project-configuration/query/${cloudId}/2/transition/initial`;
const $d2ddb64346c6f2d4$var$getTransitions = async (cloudId, projectId, issueTypeId)=>{
    const url = $d2ddb64346c6f2d4$var$constructEndpoint(cloudId);
    (0, $iIqFO.StatusFieldLoad).start();
    try {
        const resp = await (0, $jGzN3.performPostRequest)(url, {
            body: JSON.stringify({
                projectId: projectId,
                issueTypeId: issueTypeId
            })
        });
        (0, $iIqFO.StatusFieldLoad).success();
        return (0, $8W2Eb.transformData)(resp);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $iIqFO.StatusFieldLoad).failure();
        (0, $eDBhy.fireIssueCreateErrorAnalytics)({
            meta: {
                id: 'getTransitions',
                packageName: 'jiraIssueCreate',
                teamName: 'gryffindor'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};
var $d2ddb64346c6f2d4$export$2e2bcd8739ae039 = $d2ddb64346c6f2d4$var$getTransitions;

});
parcelRegister("8W2Eb", function(module, exports) {

$parcel$export(module.exports, "transformData", () => $d3fe11a6a7bdd0a8$export$3ceb62baab058c6b);
const $d3fe11a6a7bdd0a8$var$shouldReplace = (existing, replacement)=>!existing.isInitial && replacement.isInitial || existing.isDisabled === true && !replacement.isDisabled;
const $d3fe11a6a7bdd0a8$export$3ceb62baab058c6b = (data)=>{
    const transitionMap = data.reduce((acc, val)=>{
        if (acc.has(val.to.id) && !$d3fe11a6a7bdd0a8$var$shouldReplace(acc.get(val.to.id), val)) return acc;
        return acc.set(val.to.id, val);
    }, new Map());
    return Array.from(transitionMap.values());
};

});



parcelRegister("lwTSQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d957f19bd549a73b$export$2e2bcd8739ae039);

var $7jTnu = parcelRequire("7jTnu");

var $8pdiB = parcelRequire("8pdiB");

var $kIKDZ = parcelRequire("kIKDZ");

var $aPJiL = parcelRequire("aPJiL");

var $e1yMd = parcelRequire("e1yMd");
const $d957f19bd549a73b$var$useModalLoadQuery = (props)=>{
    const { displayOnlyRequiredFields: displayOnlyRequiredFields = false, triggerPointKey: triggerPointKey, isSubTaskCreationOpen: isSubTaskCreationOpen = false, triggerIssueCreatePayload: triggerIssueCreatePayload, isModalLoadInContext: isModalLoadInContext = false, isCreateLinkedIssue: isCreateLinkedIssue } = props;
    const [{ isLoading: isLoading, fieldConfig: fieldConfigInitial, fieldTabs: fieldTabs, contextFields: contextFields, meta: meta, error: error, apiLatency: apiLatency, additionalServices: additionalServices }, fetchConfig] = (0, $kIKDZ.default)({
        displayOnlyRequiredFields: displayOnlyRequiredFields,
        triggerPointKey: triggerPointKey
    });
    const fieldConfig = (0, $e1yMd.usePrefillCustomFields)(fieldConfigInitial);
    const [{ isLoading: isSubtaskLoading, fieldConfig: subtaskFieldConfig, fieldTabs: subtaskFieldTabs, contextFields: subtaskContextFields, meta: subtaskFieldsDataMeta, error: subtaskFieldsDataError, apiLatency: subtaskApiLatency, additionalServices: subtaskAdditionalServices }, fetchSubtaskConfig] = (0, $aPJiL.default)({
        displayOnlyRequiredFields: displayOnlyRequiredFields,
        triggerPointKey: triggerPointKey
    });
    const [{ isLoading: isLoadingInContext, fieldConfig: fieldConfigInContext, fieldTabs: fieldTabsInContext, contextFields: contextFieldsInContext, meta: fieldsDataMetaInContext, error: fieldsDataErrorInContext, apiLatency: apiLatencyInContext, additionalServices: additionalServicesInContext }, fetchConfigInContext] = (0, $8pdiB.default)({
        displayOnlyRequiredFields: displayOnlyRequiredFields,
        triggerPointKey: triggerPointKey,
        ...(0, $7jTnu.fg)('create_linked_issues_trigger_point_issue_view') ? {
            isCreateLinkedIssue: isCreateLinkedIssue
        } : {}
    });
    const parentId = triggerIssueCreatePayload?.parentId || null;
    const additionalContext = triggerIssueCreatePayload?.additionalContext || null;
    if (isModalLoadInContext && additionalContext) return [
        {
            isLoading: isLoadingInContext,
            fieldConfig: fieldConfigInContext,
            fieldTabs: fieldTabsInContext,
            contextFields: contextFieldsInContext,
            meta: fieldsDataMetaInContext,
            error: fieldsDataErrorInContext,
            apiLatency: apiLatencyInContext,
            additionalServices: additionalServicesInContext
        },
        fetchConfigInContext
    ];
    if (isSubTaskCreationOpen && parentId) return [
        {
            isLoading: isSubtaskLoading,
            fieldConfig: subtaskFieldConfig,
            fieldTabs: subtaskFieldTabs,
            contextFields: subtaskContextFields,
            meta: subtaskFieldsDataMeta,
            error: subtaskFieldsDataError,
            apiLatency: subtaskApiLatency,
            additionalServices: subtaskAdditionalServices
        },
        fetchSubtaskConfig
    ];
    return [
        {
            isLoading: isLoading,
            fieldConfig: fieldConfig,
            fieldTabs: fieldTabs,
            contextFields: contextFields,
            meta: meta,
            error: error,
            apiLatency: apiLatency,
            additionalServices: additionalServices
        },
        fetchConfig
    ];
};
var $d957f19bd549a73b$export$2e2bcd8739ae039 = $d957f19bd549a73b$var$useModalLoadQuery;

});
parcelRegister("8pdiB", function(module, exports) {

$parcel$export(module.exports, "default", () => $589402edbb8ca312$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1fMqv = parcelRequire("1fMqv");

var $eDBhy = parcelRequire("eDBhy");

var $7jTnu = parcelRequire("7jTnu");

var $2ho4j = parcelRequire("2ho4j");

var $4CDQT = parcelRequire("4CDQT");

var $73QLY = parcelRequire("73QLY");

var $bSxlM = parcelRequire("bSxlM");

var $fAieL = parcelRequire("fAieL");

var $7mJUz = parcelRequire("7mJUz");
const $589402edbb8ca312$var$useFetchCreateConfigQueryInContext = (props = {})=>{
    const { fireModalLoadTaskFailEvent: fireModalLoadTaskFailEvent, fireModalLoadTaskAbortEvent: fireModalLoadTaskAbortEvent } = (0, $fAieL.useModalLoadUiTaskEvents)();
    const { displayOnlyRequiredFields: displayOnlyRequiredFields = false, triggerPointKey: triggerPointKey, isCreateLinkedIssue: isCreateLinkedIssue = false } = props;
    const [loading, setLoading] = (0, $eJOHy.useState)(false);
    const [fetchError, setFetchError] = (0, $eJOHy.useState)(null);
    const apiStartTime = (0, $eJOHy.useRef)(0);
    const [apiLatency, setApiLatency] = (0, $eJOHy.useState)(0);
    const [data, setData] = (0, $eJOHy.useState)({
        fieldTabs: [],
        fieldConfig: {},
        contextFields: {},
        meta: {
            areRequiredFieldsSupported: true,
            queryErrorMessage: ''
        },
        additionalServices: {}
    });
    const { withMachineLearning: withMachineLearning } = (0, $73QLY.useSmartFieldsMachineLearning)();
    const createConfigQuery = (0, $7jTnu.fg)('new-issue-create-fetch-config-query') ? (0, $bSxlM.getCreateConfigQuery)({
        isInContext: true,
        withML: withMachineLearning,
        isCreateLinkedIssue: isCreateLinkedIssue,
        isCreateLinkedIssueFromIssueViewFGOn: !!(0, $7jTnu.fg)('create_linked_issues_trigger_point_issue_view'),
        isJsmRespondersFieldEnabled: (0, $7jTnu.fg)('jsm-responders-field-in-gicx-ui')
    }) : (0, $7mJUz.getCreateConfigUserPreferredQueryInContext)(withMachineLearning, isCreateLinkedIssue);
    const [fetchConfigInContext] = (0, $1fMqv.useLazyQuery)(createConfigQuery, {
        fetchPolicy: 'no-cache',
        onCompleted: (queryData)=>{
            setApiLatency(Math.floor(performance.now() - apiStartTime.current));
            setData((0, $4CDQT.transformQueryResults)((0, $4CDQT.tranformModalLoadDataInContext)(queryData), displayOnlyRequiredFields));
            setLoading(false);
        },
        onError: (error)=>{
            setFetchError(error);
            const errorType = (0, $2ho4j.handleApolloError)(error);
            (0, $eDBhy.fireIssueCreateErrorAnalytics)({
                meta: {
                    id: 'useFetchCreateConfigQueryInContext',
                    packageName: 'jiraIssueCreate',
                    teamName: 'gryffindor'
                },
                error: error,
                attributes: {
                    errorType: // TODO: clean up after rollout of FG issue-create-fire-error-analytics-refactor
                    errorType,
                    triggerPointKey: // TODO: look to get this into common hook and populate it everywhere.
                    triggerPointKey
                },
                sendToPrivacyUnsafeSplunk: true
            });
            if (errorType === 'graphQLError' && (0, $7jTnu.fg)('global_issue_create_modal_view_task_fail_event')) fireModalLoadTaskFailEvent();
            else if ((0, $7jTnu.fg)('global_issue_create_modal_view_task_abort_event')) fireModalLoadTaskAbortEvent();
        }
    });
    const handleFetch = (0, $eJOHy.useRef)((queryVariables)=>{
        setLoading(true);
        apiStartTime.current = performance.now();
        fetchConfigInContext(queryVariables);
    });
    return [
        {
            isLoading: loading,
            fieldTabs: data.fieldTabs,
            fieldConfig: data.fieldConfig,
            contextFields: data.contextFields,
            meta: data.meta,
            error: fetchError,
            apiLatency: apiLatency,
            additionalServices: data.additionalServices
        },
        handleFetch.current
    ];
};
var $589402edbb8ca312$export$2e2bcd8739ae039 = $589402edbb8ca312$var$useFetchCreateConfigQueryInContext;

});
parcelRegister("1fMqv", function(module, exports) {

$parcel$export(module.exports, "useQuery", () => $0e9cc1ab166e5529$export$dd0a697e1782aedd);
$parcel$export(module.exports, "useLazyQuery", () => $0e9cc1ab166e5529$export$fd83eea6ecd2d8fa);
$parcel$export(module.exports, "useMutation", () => $0e9cc1ab166e5529$export$609860bf8b0084c);
$parcel$export(module.exports, "useApolloClient", () => $0e9cc1ab166e5529$export$eb9a56e7a29e494);

var $688i3 = parcelRequire("688i3");

var $dnskZ = parcelRequire("dnskZ");

var $eJOHy = parcelRequire("eJOHy");

var $eezJL = parcelRequire("eezJL");

var $hR4hP = parcelRequire("hR4hP");

var $lDEi6 = parcelRequire("lDEi6");
var $0e9cc1ab166e5529$var$OperationData = function() {
    function OperationData(options, context) {
        this.isMounted = false;
        this.previousOptions = {};
        this.context = {};
        this.options = {};
        this.options = options || {};
        this.context = context || {};
    }
    OperationData.prototype.getOptions = function() {
        return this.options;
    };
    OperationData.prototype.setOptions = function(newOptions, storePrevious) {
        if (storePrevious === void 0) storePrevious = false;
        if (storePrevious && !(0, $hR4hP.equal)(this.options, newOptions)) this.previousOptions = this.options;
        this.options = newOptions;
    };
    OperationData.prototype.unmount = function() {
        this.isMounted = false;
    };
    OperationData.prototype.refreshClient = function() {
        var client = this.options && this.options.client || this.context && this.context.client;
        (0, $lDEi6.invariant)(!!client, 2);
        var isNew = false;
        if (client !== this.client) {
            isNew = true;
            this.client = client;
            this.cleanup();
        }
        return {
            client: this.client,
            isNew: isNew
        };
    };
    OperationData.prototype.verifyDocumentType = function(document, type) {
        var operation = (0, $688i3.parser)(document);
        var requiredOperationName = (0, $688i3.operationName)(type);
        var usedOperationName = (0, $688i3.operationName)(operation.type);
        (0, $lDEi6.invariant)(operation.type === type, 3);
    };
    return OperationData;
}();
var $0e9cc1ab166e5529$var$QueryData = function(_super) {
    (0, $dnskZ.__extends)(QueryData, _super);
    function QueryData(_a) {
        var options = _a.options, context = _a.context, forceUpdate = _a.forceUpdate;
        var _this = _super.call(this, options, context) || this;
        _this.previousData = {};
        _this.currentObservable = {};
        _this.runLazy = false;
        _this.runLazyQuery = function(options) {
            _this.cleanup();
            _this.runLazy = true;
            _this.lazyOptions = options;
            _this.forceUpdate();
        };
        _this.getExecuteResult = function() {
            var result = _this.getQueryResult();
            _this.startQuerySubscription();
            return result;
        };
        _this.obsRefetch = function(variables) {
            return _this.currentObservable.query.refetch(variables);
        };
        _this.obsFetchMore = function(fetchMoreOptions) {
            return _this.currentObservable.query.fetchMore(fetchMoreOptions);
        };
        _this.obsUpdateQuery = function(mapFn) {
            return _this.currentObservable.query.updateQuery(mapFn);
        };
        _this.obsStartPolling = function(pollInterval) {
            _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.startPolling(pollInterval);
        };
        _this.obsStopPolling = function() {
            _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.stopPolling();
        };
        _this.obsSubscribeToMore = function(options) {
            return _this.currentObservable.query.subscribeToMore(options);
        };
        _this.forceUpdate = forceUpdate;
        return _this;
    }
    QueryData.prototype.execute = function() {
        this.refreshClient();
        var _a = this.getOptions(), skip = _a.skip, query = _a.query;
        if (skip || query !== this.previousData.query) {
            this.removeQuerySubscription();
            this.previousData.query = query;
        }
        this.updateObservableQuery();
        if (this.isMounted) this.startQuerySubscription();
        return this.getExecuteSsrResult() || this.getExecuteResult();
    };
    QueryData.prototype.executeLazy = function() {
        return !this.runLazy ? [
            this.runLazyQuery,
            {
                loading: false,
                networkStatus: (0, $eezJL.NetworkStatus).ready,
                called: false,
                data: undefined
            }
        ] : [
            this.runLazyQuery,
            this.execute()
        ];
    };
    QueryData.prototype.fetchData = function() {
        var options = this.getOptions();
        if (options.skip || options.ssr === false) return false;
        var obs = this.currentObservable.query;
        var currentResult = obs.getCurrentResult();
        return currentResult.loading ? obs.result() : false;
    };
    QueryData.prototype.afterExecute = function(_a) {
        var _this = this;
        var _b = (_a === void 0 ? {} : _a).lazy, lazy = _b === void 0 ? false : _b;
        this.isMounted = true;
        if (!lazy || this.runLazy) {
            this.handleErrorOrCompleted();
            setTimeout(function() {
                _this.currentObservable.query && _this.currentObservable.query.resetQueryStoreErrors();
            });
        }
        this.previousOptions = this.getOptions();
        return this.unmount.bind(this);
    };
    QueryData.prototype.cleanup = function() {
        this.removeQuerySubscription();
        delete this.currentObservable.query;
        delete this.previousData.result;
    };
    QueryData.prototype.getOptions = function() {
        var options = _super.prototype.getOptions.call(this);
        if (this.lazyOptions) {
            options.variables = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, options.variables), this.lazyOptions.variables);
            options.context = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, options.context), this.lazyOptions.context);
        }
        if (this.runLazy) delete options.skip;
        return options;
    };
    QueryData.prototype.getExecuteSsrResult = function() {
        var treeRenderingInitiated = this.context && this.context.renderPromises;
        var ssrDisabled = this.getOptions().ssr === false;
        var fetchDisabled = this.refreshClient().client.disableNetworkFetches;
        var ssrLoading = {
            loading: true,
            networkStatus: (0, $eezJL.NetworkStatus).loading,
            called: true,
            data: undefined
        };
        if (ssrDisabled && (treeRenderingInitiated || fetchDisabled)) return ssrLoading;
        var result;
        if (treeRenderingInitiated) result = this.context.renderPromises.addQueryPromise(this, this.getExecuteResult) || ssrLoading;
        return result;
    };
    QueryData.prototype.prepareObservableQueryOptions = function() {
        var options = this.getOptions();
        this.verifyDocumentType(options.query, (0, $688i3.DocumentType).Query);
        var displayName = options.displayName || 'Query';
        if (this.context && this.context.renderPromises && (options.fetchPolicy === 'network-only' || options.fetchPolicy === 'cache-and-network')) options.fetchPolicy = 'cache-first';
        return (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, options), {
            displayName: displayName,
            context: options.context,
            metadata: {
                reactComponent: {
                    displayName: displayName
                }
            }
        });
    };
    QueryData.prototype.initializeObservableQuery = function() {
        if (this.context && this.context.renderPromises) this.currentObservable.query = this.context.renderPromises.getSSRObservable(this.getOptions());
        if (!this.currentObservable.query) {
            var observableQueryOptions = this.prepareObservableQueryOptions();
            this.previousData.observableQueryOptions = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, observableQueryOptions), {
                children: null
            });
            this.currentObservable.query = this.refreshClient().client.watchQuery((0, $dnskZ.__assign)({}, observableQueryOptions));
            if (this.context && this.context.renderPromises) this.context.renderPromises.registerSSRObservable(this.currentObservable.query, observableQueryOptions);
        }
    };
    QueryData.prototype.updateObservableQuery = function() {
        if (!this.currentObservable.query) {
            this.initializeObservableQuery();
            return;
        }
        var newObservableQueryOptions = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, this.prepareObservableQueryOptions()), {
            children: null
        });
        if (!(0, $hR4hP.equal)(newObservableQueryOptions, this.previousData.observableQueryOptions)) {
            this.previousData.observableQueryOptions = newObservableQueryOptions;
            this.currentObservable.query.setOptions(newObservableQueryOptions).catch(function() {});
        }
    };
    QueryData.prototype.startQuerySubscription = function() {
        var _this = this;
        if (this.currentObservable.subscription || this.getOptions().skip) return;
        var obsQuery = this.currentObservable.query;
        this.currentObservable.subscription = obsQuery.subscribe({
            next: function(_a) {
                var loading = _a.loading, networkStatus = _a.networkStatus, data = _a.data;
                var previousResult = _this.previousData.result;
                if (previousResult && previousResult.loading === loading && previousResult.networkStatus === networkStatus && (0, $hR4hP.equal)(previousResult.data, data)) return;
                _this.forceUpdate();
            },
            error: function(error) {
                _this.resubscribeToQuery();
                if (!error.hasOwnProperty('graphQLErrors')) throw error;
                var previousResult = _this.previousData.result;
                if (previousResult && previousResult.loading || !(0, $hR4hP.equal)(error, _this.previousData.error)) {
                    _this.previousData.error = error;
                    _this.forceUpdate();
                }
            }
        });
    };
    QueryData.prototype.resubscribeToQuery = function() {
        this.removeQuerySubscription();
        var lastError = this.currentObservable.query.getLastError();
        var lastResult = this.currentObservable.query.getLastResult();
        this.currentObservable.query.resetLastResults();
        this.startQuerySubscription();
        Object.assign(this.currentObservable.query, {
            lastError: lastError,
            lastResult: lastResult
        });
    };
    QueryData.prototype.getQueryResult = function() {
        var result = this.observableQueryFields();
        var options = this.getOptions();
        if (options.skip) result = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, result), {
            data: undefined,
            error: undefined,
            loading: false,
            called: true
        });
        else {
            var currentResult = this.currentObservable.query.getCurrentResult();
            var loading = currentResult.loading, partial = currentResult.partial, networkStatus = currentResult.networkStatus, errors = currentResult.errors;
            var error = currentResult.error, data = currentResult.data;
            if (errors && errors.length > 0) error = new (0, $eezJL.ApolloError)({
                graphQLErrors: errors
            });
            result = (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, result), {
                loading: loading,
                networkStatus: networkStatus,
                error: error,
                called: true
            });
            if (loading) {
                var previousData = this.previousData.result && this.previousData.result.data;
                result.data = previousData && data ? (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, previousData), data) : previousData || data;
            } else if (error) Object.assign(result, {
                data: (this.currentObservable.query.getLastResult() || {}).data
            });
            else {
                var fetchPolicy = this.currentObservable.query.options.fetchPolicy;
                var partialRefetch = options.partialRefetch;
                if (partialRefetch && !data && partial && fetchPolicy !== 'cache-only') {
                    Object.assign(result, {
                        loading: true,
                        networkStatus: (0, $eezJL.NetworkStatus).loading
                    });
                    result.refetch();
                    return result;
                }
                result.data = data;
            }
        }
        result.client = this.client;
        this.previousData.loading = this.previousData.result && this.previousData.result.loading || false;
        this.previousData.result = result;
        return result;
    };
    QueryData.prototype.handleErrorOrCompleted = function() {
        var obsQuery = this.currentObservable.query;
        if (!obsQuery) return;
        var _a = obsQuery.getCurrentResult(), data = _a.data, loading = _a.loading, error = _a.error;
        if (!loading) {
            var _b = this.getOptions(), query = _b.query, variables = _b.variables, onCompleted = _b.onCompleted, onError = _b.onError;
            if (this.previousOptions && !this.previousData.loading && (0, $hR4hP.equal)(this.previousOptions.query, query) && (0, $hR4hP.equal)(this.previousOptions.variables, variables)) return;
            if (onCompleted && !error) onCompleted(data);
            else if (onError && error) onError(error);
        }
    };
    QueryData.prototype.removeQuerySubscription = function() {
        if (this.currentObservable.subscription) {
            this.currentObservable.subscription.unsubscribe();
            delete this.currentObservable.subscription;
        }
    };
    QueryData.prototype.observableQueryFields = function() {
        var observable = this.currentObservable.query;
        return {
            variables: observable.variables,
            refetch: this.obsRefetch,
            fetchMore: this.obsFetchMore,
            updateQuery: this.obsUpdateQuery,
            startPolling: this.obsStartPolling,
            stopPolling: this.obsStopPolling,
            subscribeToMore: this.obsSubscribeToMore
        };
    };
    return QueryData;
}($0e9cc1ab166e5529$var$OperationData);
function $0e9cc1ab166e5529$var$useDeepMemo(memoFn, key) {
    var ref = (0, $eJOHy.useRef)();
    if (!ref.current || !(0, $hR4hP.equal)(key, ref.current.key)) ref.current = {
        key: key,
        value: memoFn()
    };
    return ref.current.value;
}
function $0e9cc1ab166e5529$var$useBaseQuery(query, options, lazy) {
    if (lazy === void 0) lazy = false;
    var context = (0, $eJOHy.useContext)((0, $688i3.getApolloContext)());
    var _a = (0, $eJOHy.useReducer)(function(x) {
        return x + 1;
    }, 0), tick = _a[0], forceUpdate = _a[1];
    var updatedOptions = options ? (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, options), {
        query: query
    }) : {
        query: query
    };
    var queryDataRef = (0, $eJOHy.useRef)();
    if (!queryDataRef.current) queryDataRef.current = new $0e9cc1ab166e5529$var$QueryData({
        options: updatedOptions,
        context: context,
        forceUpdate: forceUpdate
    });
    var queryData = queryDataRef.current;
    queryData.setOptions(updatedOptions);
    queryData.context = context;
    var memo = {
        options: (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, updatedOptions), {
            onError: undefined,
            onCompleted: undefined
        }),
        context: context,
        tick: tick
    };
    var result = $0e9cc1ab166e5529$var$useDeepMemo(function() {
        return lazy ? queryData.executeLazy() : queryData.execute();
    }, memo);
    var queryResult = lazy ? result[1] : result;
    (0, $eJOHy.useEffect)(function() {
        return queryData.afterExecute({
            lazy: lazy
        });
    }, [
        queryResult.loading,
        queryResult.networkStatus,
        queryResult.error,
        queryResult.data
    ]);
    (0, $eJOHy.useEffect)(function() {
        return function() {
            return queryData.cleanup();
        };
    }, []);
    return result;
}
function $0e9cc1ab166e5529$export$dd0a697e1782aedd(query, options) {
    return $0e9cc1ab166e5529$var$useBaseQuery(query, options, false);
}
function $0e9cc1ab166e5529$export$fd83eea6ecd2d8fa(query, options) {
    return $0e9cc1ab166e5529$var$useBaseQuery(query, options, true);
}
var $0e9cc1ab166e5529$var$MutationData = function(_super) {
    (0, $dnskZ.__extends)(MutationData, _super);
    function MutationData(_a) {
        var options = _a.options, context = _a.context, result = _a.result, setResult = _a.setResult;
        var _this = _super.call(this, options, context) || this;
        _this.runMutation = function(mutationFunctionOptions) {
            if (mutationFunctionOptions === void 0) mutationFunctionOptions = {};
            _this.onMutationStart();
            var mutationId = _this.generateNewMutationId();
            return _this.mutate(mutationFunctionOptions).then(function(response) {
                _this.onMutationCompleted(response, mutationId);
                return response;
            }).catch(function(error) {
                _this.onMutationError(error, mutationId);
                if (!_this.getOptions().onError) throw error;
            });
        };
        _this.verifyDocumentType(options.mutation, (0, $688i3.DocumentType).Mutation);
        _this.result = result;
        _this.setResult = setResult;
        _this.mostRecentMutationId = 0;
        return _this;
    }
    MutationData.prototype.execute = function(result) {
        this.isMounted = true;
        this.verifyDocumentType(this.getOptions().mutation, (0, $688i3.DocumentType).Mutation);
        result.client = this.refreshClient().client;
        return [
            this.runMutation,
            result
        ];
    };
    MutationData.prototype.afterExecute = function() {
        this.isMounted = true;
        return this.unmount.bind(this);
    };
    MutationData.prototype.cleanup = function() {};
    MutationData.prototype.mutate = function(mutationFunctionOptions) {
        var _a = this.getOptions(), mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, update = _a.update, _b = _a.context, mutationContext = _b === void 0 ? {} : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, fetchPolicy = _a.fetchPolicy;
        var mutateOptions = (0, $dnskZ.__assign)({}, mutationFunctionOptions);
        var mutateVariables = Object.assign({}, variables, mutateOptions.variables);
        delete mutateOptions.variables;
        return this.refreshClient().client.mutate((0, $dnskZ.__assign)({
            mutation: mutation,
            optimisticResponse: optimisticResponse,
            refetchQueries: mutateOptions.refetchQueries || this.getOptions().refetchQueries,
            awaitRefetchQueries: awaitRefetchQueries,
            update: update,
            context: mutationContext,
            fetchPolicy: fetchPolicy,
            variables: mutateVariables
        }, mutateOptions));
    };
    MutationData.prototype.onMutationStart = function() {
        if (!this.result.loading && !this.getOptions().ignoreResults) this.updateResult({
            loading: true,
            error: undefined,
            data: undefined,
            called: true
        });
    };
    MutationData.prototype.onMutationCompleted = function(response, mutationId) {
        var _a = this.getOptions(), onCompleted = _a.onCompleted, ignoreResults = _a.ignoreResults;
        var data = response.data, errors = response.errors;
        var error = errors && errors.length > 0 ? new (0, $eezJL.ApolloError)({
            graphQLErrors: errors
        }) : undefined;
        var callOncomplete = function() {
            return onCompleted ? onCompleted(data) : null;
        };
        if (this.isMostRecentMutation(mutationId) && !ignoreResults) this.updateResult({
            called: true,
            loading: false,
            data: data,
            error: error
        });
        callOncomplete();
    };
    MutationData.prototype.onMutationError = function(error, mutationId) {
        var onError = this.getOptions().onError;
        if (this.isMostRecentMutation(mutationId)) this.updateResult({
            loading: false,
            error: error,
            data: undefined,
            called: true
        });
        if (onError) onError(error);
    };
    MutationData.prototype.generateNewMutationId = function() {
        return ++this.mostRecentMutationId;
    };
    MutationData.prototype.isMostRecentMutation = function(mutationId) {
        return this.mostRecentMutationId === mutationId;
    };
    MutationData.prototype.updateResult = function(result) {
        if (this.isMounted && (!this.previousResult || !(0, $hR4hP.equal)(this.previousResult, result))) {
            this.setResult(result);
            this.previousResult = result;
        }
    };
    return MutationData;
}($0e9cc1ab166e5529$var$OperationData);
function $0e9cc1ab166e5529$export$609860bf8b0084c(mutation, options) {
    var context = (0, $eJOHy.useContext)((0, $688i3.getApolloContext)());
    var _a = (0, $eJOHy.useState)({
        called: false,
        loading: false
    }), result = _a[0], setResult = _a[1];
    var updatedOptions = options ? (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, options), {
        mutation: mutation
    }) : {
        mutation: mutation
    };
    var mutationDataRef = (0, $eJOHy.useRef)();
    function getMutationDataRef() {
        if (!mutationDataRef.current) mutationDataRef.current = new $0e9cc1ab166e5529$var$MutationData({
            options: updatedOptions,
            context: context,
            result: result,
            setResult: setResult
        });
        return mutationDataRef.current;
    }
    var mutationData = getMutationDataRef();
    mutationData.setOptions(updatedOptions);
    mutationData.context = context;
    (0, $eJOHy.useEffect)(function() {
        return mutationData.afterExecute();
    });
    return mutationData.execute(result);
}
var $0e9cc1ab166e5529$var$SubscriptionData = function(_super) {
    (0, $dnskZ.__extends)(SubscriptionData, _super);
    function SubscriptionData(_a) {
        var options = _a.options, context = _a.context, setResult = _a.setResult;
        var _this = _super.call(this, options, context) || this;
        _this.currentObservable = {};
        _this.setResult = setResult;
        _this.initialize(options);
        return _this;
    }
    SubscriptionData.prototype.execute = function(result) {
        if (this.getOptions().skip === true) {
            this.cleanup();
            return {
                loading: false,
                error: undefined,
                data: undefined,
                variables: this.getOptions().variables
            };
        }
        var currentResult = result;
        if (this.refreshClient().isNew) currentResult = this.getLoadingResult();
        var shouldResubscribe = this.getOptions().shouldResubscribe;
        if (typeof shouldResubscribe === 'function') shouldResubscribe = !!shouldResubscribe(this.getOptions());
        if (shouldResubscribe !== false && this.previousOptions && Object.keys(this.previousOptions).length > 0 && (this.previousOptions.subscription !== this.getOptions().subscription || !(0, $hR4hP.equal)(this.previousOptions.variables, this.getOptions().variables) || this.previousOptions.skip !== this.getOptions().skip)) {
            this.cleanup();
            currentResult = this.getLoadingResult();
        }
        this.initialize(this.getOptions());
        this.startSubscription();
        this.previousOptions = this.getOptions();
        return (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, currentResult), {
            variables: this.getOptions().variables
        });
    };
    SubscriptionData.prototype.afterExecute = function() {
        this.isMounted = true;
    };
    SubscriptionData.prototype.cleanup = function() {
        this.endSubscription();
        delete this.currentObservable.query;
    };
    SubscriptionData.prototype.initialize = function(options) {
        if (this.currentObservable.query || this.getOptions().skip === true) return;
        this.currentObservable.query = this.refreshClient().client.subscribe({
            query: options.subscription,
            variables: options.variables,
            fetchPolicy: options.fetchPolicy
        });
    };
    SubscriptionData.prototype.startSubscription = function() {
        if (this.currentObservable.subscription) return;
        this.currentObservable.subscription = this.currentObservable.query.subscribe({
            next: this.updateCurrentData.bind(this),
            error: this.updateError.bind(this),
            complete: this.completeSubscription.bind(this)
        });
    };
    SubscriptionData.prototype.getLoadingResult = function() {
        return {
            loading: true,
            error: undefined,
            data: undefined
        };
    };
    SubscriptionData.prototype.updateResult = function(result) {
        if (this.isMounted) this.setResult(result);
    };
    SubscriptionData.prototype.updateCurrentData = function(result) {
        var onSubscriptionData = this.getOptions().onSubscriptionData;
        this.updateResult({
            data: result.data,
            loading: false,
            error: undefined
        });
        if (onSubscriptionData) onSubscriptionData({
            client: this.refreshClient().client,
            subscriptionData: result
        });
    };
    SubscriptionData.prototype.updateError = function(error) {
        this.updateResult({
            error: error,
            loading: false
        });
    };
    SubscriptionData.prototype.completeSubscription = function() {
        var onSubscriptionComplete = this.getOptions().onSubscriptionComplete;
        if (onSubscriptionComplete) onSubscriptionComplete();
        this.endSubscription();
    };
    SubscriptionData.prototype.endSubscription = function() {
        if (this.currentObservable.subscription) {
            this.currentObservable.subscription.unsubscribe();
            delete this.currentObservable.subscription;
        }
    };
    return SubscriptionData;
}($0e9cc1ab166e5529$var$OperationData);
function $0e9cc1ab166e5529$export$368b4214baeb914c(subscription, options) {
    var context = (0, $eJOHy.useContext)((0, $688i3.getApolloContext)());
    var updatedOptions = options ? (0, $dnskZ.__assign)((0, $dnskZ.__assign)({}, options), {
        subscription: subscription
    }) : {
        subscription: subscription
    };
    var _a = (0, $eJOHy.useState)({
        loading: !updatedOptions.skip,
        error: undefined,
        data: undefined
    }), result = _a[0], setResult = _a[1];
    var subscriptionDataRef = (0, $eJOHy.useRef)();
    function getSubscriptionDataRef() {
        if (!subscriptionDataRef.current) subscriptionDataRef.current = new $0e9cc1ab166e5529$var$SubscriptionData({
            options: updatedOptions,
            context: context,
            setResult: setResult
        });
        return subscriptionDataRef.current;
    }
    var subscriptionData = getSubscriptionDataRef();
    subscriptionData.setOptions(updatedOptions, true);
    subscriptionData.context = context;
    (0, $eJOHy.useEffect)(function() {
        return subscriptionData.afterExecute();
    });
    (0, $eJOHy.useEffect)(function() {
        return subscriptionData.cleanup.bind(subscriptionData);
    }, []);
    return subscriptionData.execute(result);
}
function $0e9cc1ab166e5529$export$eb9a56e7a29e494() {
    var client = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useContext((0, $688i3.getApolloContext)()).client;
    (0, $lDEi6.invariant)(client, 1);
    return client;
}
function $0e9cc1ab166e5529$var$makeDefaultQueryInfo() {
    return {
        seen: false,
        observable: null
    };
}
var $0e9cc1ab166e5529$export$260e90e395a79974 = function() {
    function RenderPromises() {
        this.queryPromises = new Map();
        this.queryInfoTrie = new Map();
    }
    RenderPromises.prototype.registerSSRObservable = function(observable, props) {
        this.lookupQueryInfo(props).observable = observable;
    };
    RenderPromises.prototype.getSSRObservable = function(props) {
        return this.lookupQueryInfo(props).observable;
    };
    RenderPromises.prototype.addQueryPromise = function(queryInstance, finish) {
        var info = this.lookupQueryInfo(queryInstance.getOptions());
        if (!info.seen) {
            this.queryPromises.set(queryInstance.getOptions(), new Promise(function(resolve) {
                resolve(queryInstance.fetchData());
            }));
            return null;
        }
        return finish();
    };
    RenderPromises.prototype.hasPromises = function() {
        return this.queryPromises.size > 0;
    };
    RenderPromises.prototype.consumeAndAwaitPromises = function() {
        var _this = this;
        var promises = [];
        this.queryPromises.forEach(function(promise, queryInstance) {
            _this.lookupQueryInfo(queryInstance).seen = true;
            promises.push(promise);
        });
        this.queryPromises.clear();
        return Promise.all(promises);
    };
    RenderPromises.prototype.lookupQueryInfo = function(props) {
        var queryInfoTrie = this.queryInfoTrie;
        var query = props.query, variables = props.variables;
        var varMap = queryInfoTrie.get(query) || new Map();
        if (!queryInfoTrie.has(query)) queryInfoTrie.set(query, varMap);
        var variablesString = JSON.stringify(variables);
        var info = varMap.get(variablesString) || $0e9cc1ab166e5529$var$makeDefaultQueryInfo();
        if (!varMap.has(variablesString)) varMap.set(variablesString, info);
        return info;
    };
    return RenderPromises;
}();

});

parcelRegister("2ho4j", function(module, exports) {

$parcel$export(module.exports, "handleApolloError", () => $83757049321d362a$export$31b755cdc25616f2);
const $83757049321d362a$export$31b755cdc25616f2 = (error)=>{
    let errorType = 'unknown';
    if (error.networkError != null) errorType = 'networkError';
    else if (error.graphQLErrors && error.graphQLErrors.length > 0) errorType = 'graphQLError';
    // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'ErrorType'.
    return errorType;
};

});

parcelRegister("4CDQT", function(module, exports) {

$parcel$export(module.exports, "transformQueryResults", () => $2297dce4833baf3e$export$142cac81f59c4a2b);
$parcel$export(module.exports, "transformQueryData", () => $2297dce4833baf3e$export$e87b478b11690bbe);
$parcel$export(module.exports, "tranformSubtaskData", () => $2297dce4833baf3e$export$2406de70fd65131a);
$parcel$export(module.exports, "tranformModalLoadDataInContext", () => $2297dce4833baf3e$export$6f0b5e0a42086cba);

var $9Dhvc = parcelRequire("9Dhvc");

var $jPROM = parcelRequire("jPROM");

var $eDBhy = parcelRequire("eDBhy");

var $7jTnu = parcelRequire("7jTnu");

var $3UrQk = parcelRequire("3UrQk");

var $5acEa = parcelRequire("5acEa");

var $814y1 = parcelRequire("814y1");

var $1eq5t = parcelRequire("1eq5t");


var $ka5CK = parcelRequire("ka5CK");

var $TPbEE = parcelRequire("TPbEE");

var $7igAz = parcelRequire("7igAz");
const $2297dce4833baf3e$export$1da66c24c878ae7 = ({ data: data, onlyRequiredField: onlyRequiredField = false, allFieldIds: allFieldIds = [] })=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const fieldTabs = (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(data, 'jiraIssueCreateLayout.contentSection.items', []);
    return fieldTabs.map(({ id: id, name: name, items: items, collapsedItems: collapsedItems, tabId: tabId })=>{
        const filterItems = (itemsToFilter)=>itemsToFilter.filter(({ fieldId: fieldId })=>allFieldIds.includes(fieldId)).map(({ fieldId: fieldId })=>fieldId);
        const filteredItems = filterItems(items || []);
        const filteredCollapsedItems = filterItems(collapsedItems || []);
        const result = {
            id: id,
            name: name,
            items: filteredItems,
            tabId: tabId
        };
        result.collapsedItems = filteredCollapsedItems;
        if (onlyRequiredField && result.items.length === 0 && result.collapsedItems.length === 0) return null;
        return result;
    }).filter((tab)=>!!tab);
};
const $2297dce4833baf3e$export$da99f019bcffa6fb = (timeTrackingSettings)=>{
    if (timeTrackingSettings) {
        const { defaultFormat: defaultFormat, workingDaysPerWeek: workingDaysPerWeek, workingHoursPerDay: workingHoursPerDay, defaultUnit: defaultUnit, isJiraConfiguredTimeTrackingEnabled: isJiraConfiguredTimeTrackingEnabled } = timeTrackingSettings;
        let format = '';
        if (defaultFormat === 'DAYS') format = 'days';
        else if (defaultFormat === 'HOURS') format = 'hours';
        else format = 'pretty';
        let unit = '';
        if (defaultUnit === 'DAY') unit = 'day';
        else if (defaultUnit === 'HOUR') unit = 'hour';
        else if (defaultUnit === 'MINUTE') unit = 'minute';
        else unit = 'week';
        return {
            daysPerWeek: workingDaysPerWeek,
            hoursPerDay: workingHoursPerDay,
            format: // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'Format | undefined'.
            format,
            // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'DefaultUnit'.
            defaultUnit: unit,
            isTimeTrackingEnabled: isJiraConfiguredTimeTrackingEnabled
        };
    }
    return undefined;
};
const $2297dce4833baf3e$export$603097abf044854 = (data, onlyRequiredField = false)=>{
    const fields = (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(data, 'jiraIssueCreateFields.fields.nodes', []);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const contextFields = {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const fieldConfigData = {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const requiredFieldConfigData = {};
    let isRequiredFieldComponentSupported = true;
    let gqlTypeBeingProcessed;
    fields.forEach((fieldData)=>{
        try {
            const { __typename: gqlType, fieldId: fieldId, name: name, type: type, description: description, fieldConfig: fieldConfig = {}, searchUrl: searchUrl, mediaContext: mediaContext, adminRichTextConfig: adminRichTextConfig, isMulti: isMulti, attributesIncludedInAutoCompleteSearch: attributesIncludedInAutoCompleteSearch, timeTrackingSettings: timeTrackingSettings, maxAllowedTotalAttachmentsSize: maxAllowedTotalAttachmentsSize } = fieldData;
            gqlTypeBeingProcessed = gqlType;
            if (fieldId && !(0, $3UrQk.UNSUPPORTED_FIELD_TYPES_IN_GIC).includes(type)) {
                if ((0, $1eq5t.CONTEXT_FIELD_TYPES).includes(gqlType) && type !== (0, $814y1.PROJECT_PICKER_CF_TYPE)) {
                    let transformedData;
                    if (gqlType === (0, $af620ae3ac843a8a$export$aa5680ad8f8be9fc)) {
                        transformedData = (0, $ka5CK.transformProjectField)(fieldData);
                        contextFields[fieldId] = transformedData;
                    }
                    if (gqlType === (0, $af620ae3ac843a8a$export$2d5a62a3515ad4c6)) {
                        transformedData = (0, $ka5CK.transformIssueTypeField)(fieldData);
                        contextFields[fieldId] = transformedData;
                    }
                    if (gqlType === (0, $af620ae3ac843a8a$export$a12a4b25ab12710c)) {
                        const requestTypeFieldData = fieldData;
                        // @ts-expect-error - TS2339 Property 'requestType' does not exist on type 'never'.
                        if (requestTypeFieldData?.requestType?.issueType) // @ts-expect-error - TS2339 Property 'requestType' does not exist on type 'never'.
                        requestTypeFieldData.requestType.issueType.issueTypeName = contextFields?.issuetype?.selectedIssueType?.label;
                        transformedData = (0, $ka5CK.transformRequestTypeField)(requestTypeFieldData);
                        contextFields.requestType = transformedData;
                    }
                } else {
                    const gqlTypeWithOverride = (0, $7igAz.overrideGqlTypes)(fieldData);
                    const gqlFieldConfig = // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly JiraAffectedServicesField: { readonly Component: AbstractComponent<ReturnComponentProps<AffectedServicesFieldConfig>, any>; readonly defaultValueKey: "selectedAffectedServices"; readonly submitTransform: (options: AffectedServiceOption[]) => ServiceEntity[]; readonly retainUserInputTransform: (selectedAff...'.
                    (0, $1eq5t.getGqlFieldMap)()[gqlTypeWithOverride] || {};
                    const { defaultValueKey: defaultValueKey, allowedValuesKey: allowedValuesKey } = gqlFieldConfig;
                    let defaultValue;
                    if (Array.isArray(defaultValueKey)) defaultValue = defaultValueKey.map((key)=>key && (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(fieldData, key, undefined));
                    else defaultValue = defaultValueKey && (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(fieldData, defaultValueKey, undefined);
                    const allowedValues = allowedValuesKey && (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(fieldData, allowedValuesKey, undefined);
                    // @ts-expect-error - TS2339 Property 'isRequired' does not exist on type '{}'.
                    const isRequired = fieldConfig?.isRequired || false;
                    // @ts-expect-error - TS2339 Property 'isEditable' does not exist on type '{}'.
                    const isEditable = fieldConfig?.isEditable;
                    // @ts-expect-error - TS2339 Property 'nonEditableReason' does not exist on type '{}'.
                    const nonEditableReason = fieldConfig?.nonEditableReason || {};
                    const copyLinksAndAttachments = gqlTypeWithOverride === (0, $af620ae3ac843a8a$export$47af4d6f62c134cf) && (0, $7jTnu.fg)('create_linked_issues_trigger_point_issue_view') ? fieldData?.copyLinksAndAttachments : undefined;
                    fieldConfigData[fieldId] = {
                        gqlType: gqlTypeWithOverride,
                        fieldId: fieldId,
                        fieldName: name,
                        fieldType: type,
                        description: description,
                        isRequired: isRequired,
                        isEditable: isEditable,
                        nonEditableReason: nonEditableReason,
                        autoCompleteUrl: (0, $5acEa.transformStargateUrl)(searchUrl || ''),
                        defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(defaultValue) ? undefined : defaultValue,
                        allowedValues: allowedValues,
                        additionalData: {
                            mediaContext: mediaContext,
                            isMulti: isMulti,
                            attributesIncludedInAutoCompleteSearch: attributesIncludedInAutoCompleteSearch,
                            timeTrackingSettings: $2297dce4833baf3e$export$da99f019bcffa6fb(timeTrackingSettings),
                            maxAllowedTotalAttachmentsSize: maxAllowedTotalAttachmentsSize,
                            ...(0, $7jTnu.fg)('create_linked_issues_trigger_point_issue_view') ? {
                                copyLinksAndAttachments: copyLinksAndAttachments
                            } : {}
                        }
                    };
                    if (adminRichTextConfig) fieldConfigData[fieldId].additionalData.adminRichTextConfig = adminRichTextConfig;
                    if (onlyRequiredField && isRequired) requiredFieldConfigData[fieldId] = fieldConfigData[fieldId];
                    if (isRequired && !('Component' in gqlFieldConfig)) isRequiredFieldComponentSupported = false;
                }
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $eDBhy.fireIssueCreateErrorAnalytics)({
                meta: {
                    id: 'processingApiFieldData',
                    packageName: 'jiraIssueCreate',
                    teamName: 'gryffindor'
                },
                error: error,
                attributes: {
                    error: `processing ${gqlTypeBeingProcessed} failed`
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
    });
    // process fields which are not supported in graphql layer
    const errors = (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(data, 'jiraIssueCreateFields.errors', []);
    const { unsupportedFields: unsupportedFields, isRequiredFieldTypeSupported: isRequiredFieldTypeSupported } = (0, $TPbEE.getGqlUnsupportedFields)(errors);
    return {
        fieldConfig: onlyRequiredField ? {
            ...requiredFieldConfigData
        } : {
            ...fieldConfigData,
            ...unsupportedFields
        },
        contextFields: contextFields,
        meta: {
            areRequiredFieldsSupported: isRequiredFieldTypeSupported && isRequiredFieldComponentSupported
        }
    };
};
const $2297dce4833baf3e$export$5fe007c334fc070a = (data)=>{
    const nodes = (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(data, 'jiraIssueCreateAdditionalServices.services.edges', []);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const services = {};
    nodes.forEach(({ node: node })=>{
        services[node.serviceId] = node;
    });
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return services;
};
const $2297dce4833baf3e$export$142cac81f59c4a2b = (data, onlyRequiredField = false)=>{
    const fieldKeyedById = $2297dce4833baf3e$export$603097abf044854(data, onlyRequiredField);
    const { watchers: watchers, proforma: proforma } = $2297dce4833baf3e$export$5fe007c334fc070a(data);
    const result = {
        fieldTabs: $2297dce4833baf3e$export$1da66c24c878ae7({
            data: data,
            onlyRequiredField: onlyRequiredField,
            allFieldIds: Object.keys(fieldKeyedById.fieldConfig)
        }),
        ...fieldKeyedById,
        meta: {
            ...fieldKeyedById.meta,
            queryErrorMessage: (0, $TPbEE.getQueryErrorMessage)(data)
        },
        additionalServices: {
            watchersConfigurations: watchers?.permissions,
            proformaConfiguration: proforma?.proforma
        }
    };
    return $2297dce4833baf3e$var$validateRequiredFieldsFromTransformQueryResults(result);
};
const $2297dce4833baf3e$var$validateRequiredFieldsFromTransformQueryResults = (result)=>{
    const { fieldTabs: fieldTabs, fieldConfig: fieldConfig } = result;
    const newFieldTabs = fieldTabs.map((tab)=>{
        if (!tab.collapsedItems) return tab;
        const collapsedItems = tab.collapsedItems.filter((fieldId)=>{
            const field = fieldConfig[fieldId];
            if (field?.isRequired || fieldId === 'summary') return false;
            return true;
        });
        return {
            ...tab,
            collapsedItems: collapsedItems
        };
    });
    return {
        ...result,
        fieldTabs: newFieldTabs
    };
};
const $2297dce4833baf3e$export$e87b478b11690bbe = (data)=>({
        jiraIssueCreateFields: {
            ...data.jiraIssueCreateFields
        },
        ...data.jiraIssueCreateAdditionalServices ? {
            jiraIssueCreateAdditionalServices: {
                ...data.jiraIssueCreateAdditionalServices
            }
        } : {},
        jiraIssueCreateLayout: Object.prototype.hasOwnProperty.call(data, 'jiraIssueCreateLayoutWithML') ? {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ...data.jiraIssueCreateLayoutWithML
        } : {
            ...data.jiraIssueCreateLayout
        }
    });
const $2297dce4833baf3e$export$2406de70fd65131a = (data)=>({
        jiraIssueCreateFields: {
            ...data.jiraSubtaskCreationFields
        },
        jiraIssueCreateAdditionalServices: {
            ...data.jiraSubtaskCreationAdditionalServices
        },
        jiraIssueCreateLayout: Object.prototype.hasOwnProperty.call(data, 'jiraSubtaskCreationLayoutWithML') ? {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ...data.jiraSubtaskCreationLayoutWithML
        } : {
            ...data.jiraSubtaskCreationLayout
        }
    });
const $2297dce4833baf3e$export$6f0b5e0a42086cba = (data)=>({
        jiraIssueCreateFields: {
            ...data.jiraIssueCreateFieldsInContext
        },
        jiraIssueCreateAdditionalServices: {
            ...data.jiraIssueCreateAdditionalServices
        },
        jiraIssueCreateLayout: Object.prototype.hasOwnProperty.call(data, 'jiraIssueCreateLayoutInContextWithML') ? {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ...data.jiraIssueCreateLayoutInContextWithML
        } : {
            ...data.jiraIssueCreateLayoutInContext
        }
    });

});
parcelRegister("1eq5t", function(module, exports) {

$parcel$export(module.exports, "getGqlFieldMap", () => $34b952dbec37e9e1$export$472717ed4aec82f1);
$parcel$export(module.exports, "UPDATE_FIELDS_CREATE_LINKED_ISSUE", () => $34b952dbec37e9e1$export$aed6a8ebeb442f9);
$parcel$export(module.exports, "UPDATE_FIELDS", () => $34b952dbec37e9e1$export$e7c3e130e221f1f1);
$parcel$export(module.exports, "CONTEXT_FIELD_TYPES", () => $34b952dbec37e9e1$export$ccf7c75b07963f11);

var $LFmXM = parcelRequire("LFmXM");

var $7jTnu = parcelRequire("7jTnu");

var $d706p = parcelRequire("d706p");

var $hmGAR = parcelRequire("hmGAR");

var $f2oiD = parcelRequire("f2oiD");

var $gfbId = parcelRequire("gfbId");

var $1pZVv = parcelRequire("1pZVv");

var $9P44V = parcelRequire("9P44V");

var $5ub3a = parcelRequire("5ub3a");

var $9qb2X = parcelRequire("9qb2X");

var $035EY = parcelRequire("035EY");

var $24FkK = parcelRequire("24FkK");

var $8D65g = parcelRequire("8D65g");

var $7BqUP = parcelRequire("7BqUP");

var $6FMuz = parcelRequire("6FMuz");

var $eLd2G = parcelRequire("eLd2G");

var $jjsF0 = parcelRequire("jjsF0");

var $37Tnh = parcelRequire("37Tnh");

var $bVuLX = parcelRequire("bVuLX");

var $egbID = parcelRequire("egbID");

var $dUh12 = parcelRequire("dUh12");

var $ktkwO = parcelRequire("ktkwO");

var $4fwkr = parcelRequire("4fwkr");

var $c0mzI = parcelRequire("c0mzI");

var $kljID = parcelRequire("kljID");

var $5vmYB = parcelRequire("5vmYB");

var $fSik2 = parcelRequire("fSik2");

var $cD5DT = parcelRequire("cD5DT");

var $8eZP2 = parcelRequire("8eZP2");

var $lumDD = parcelRequire("lumDD");

var $cDYPA = parcelRequire("cDYPA");

var $93gMe = parcelRequire("93gMe");

var $5fZlk = parcelRequire("5fZlk");

var $jANxQ = parcelRequire("jANxQ");

var $2me76 = parcelRequire("2me76");

var $4zIi4 = parcelRequire("4zIi4");

var $jFPx3 = parcelRequire("jFPx3");

var $eskjo = parcelRequire("eskjo");

var $26AI2 = parcelRequire("26AI2");

var $jKaE2 = parcelRequire("jKaE2");

var $fS2Sv = parcelRequire("fS2Sv");

var $6nvAz = parcelRequire("6nvAz");

var $dOwo2 = parcelRequire("dOwo2");

var $fAftm = parcelRequire("fAftm");

var $1VP2V = parcelRequire("1VP2V");

var $ko1zK = parcelRequire("ko1zK");

var $p3R5y = parcelRequire("p3R5y");

var $OOOvs = parcelRequire("OOOvs");

var $kmGOd = parcelRequire("kmGOd");

var $8cifA = parcelRequire("8cifA");

var $1m1S4 = parcelRequire("1m1S4");

var $bVgiW = parcelRequire("bVgiW");

var $gkRdD = parcelRequire("gkRdD");

var $hf2Er = parcelRequire("hf2Er");

var $9bfcI = parcelRequire("9bfcI");

var $iYBjh = parcelRequire("iYBjh");

var $lpUJE = parcelRequire("lpUJE");

var $4CDpZ = parcelRequire("4CDpZ");

var $jM4kG = parcelRequire("jM4kG");

var $7aP7Z = parcelRequire("7aP7Z");

var $a2hP6 = parcelRequire("a2hP6");

var $6aO03 = parcelRequire("6aO03");

var $7zPNF = parcelRequire("7zPNF");

var $aDcwy = parcelRequire("aDcwy");

var $etqwZ = parcelRequire("etqwZ");

var $86yhe = parcelRequire("86yhe");

var $8Cejx = parcelRequire("8Cejx");

var $7I9yO = parcelRequire("7I9yO");

var $5ujfv = parcelRequire("5ujfv");

var $kTnLR = parcelRequire("kTnLR");

var $aixH0 = parcelRequire("aixH0");

var $imx16 = parcelRequire("imx16");

var $f9vi5 = parcelRequire("f9vi5");

var $cO7jo = parcelRequire("cO7jo");

var $7sscC = parcelRequire("7sscC");

var $aCPP2 = parcelRequire("aCPP2");

var $5R3KZ = parcelRequire("5R3KZ");

var $1wTTU = parcelRequire("1wTTU");

var $fGxxD = parcelRequire("fGxxD");

var $9cLf3 = parcelRequire("9cLf3");

var $3DY4w = parcelRequire("3DY4w");

var $ecSnb = parcelRequire("ecSnb");

var $cictW = parcelRequire("cictW");

var $30SZQ = parcelRequire("30SZQ");

var $cCjAH = parcelRequire("cCjAH");

var $dXi8G = parcelRequire("dXi8G");

var $3JeUC = parcelRequire("3JeUC");

var $i4diV = parcelRequire("i4diV");

var $Gh5XP = parcelRequire("Gh5XP");

var $2F5Ok = parcelRequire("2F5Ok");

var $lxTUS = parcelRequire("lxTUS");

var $jpZmU = parcelRequire("jpZmU");

var $kYBcr = parcelRequire("kYBcr");

var $JKlhd = parcelRequire("JKlhd");

var $clLhb = parcelRequire("clLhb");

var $6KapF = parcelRequire("6KapF");

var $15azN = parcelRequire("15azN");

var $cERCt = parcelRequire("cERCt");

var $dOI9z = parcelRequire("dOI9z");

var $814y1 = parcelRequire("814y1");

var $caiim = parcelRequire("caiim");

var $86m8P = parcelRequire("86m8P");

var $kXkAy = parcelRequire("kXkAy");

var $i2Yqr = parcelRequire("i2Yqr");

var $epTsa = parcelRequire("epTsa");

var $38tHc = parcelRequire("38tHc");

var $lUlE5 = parcelRequire("lUlE5");

var $7OfzM = parcelRequire("7OfzM");

var $h2Cf3 = parcelRequire("h2Cf3");

var $eQSWD = parcelRequire("eQSWD");

var $2RNNL = parcelRequire("2RNNL");

var $6zGZo = parcelRequire("6zGZo");

var $62HU2 = parcelRequire("62HU2");

var $9Lt0p = parcelRequire("9Lt0p");

var $7fkTS = parcelRequire("7fkTS");

var $cRn23 = parcelRequire("cRn23");

const $34b952dbec37e9e1$var$createFieldMapItems = ()=>({
        [(0, $af620ae3ac843a8a$export$5e56d79dfe9be3d)]: {
            Component: (0, $f2oiD.default),
            defaultValueKey: 'selectedAffectedServices',
            submitTransform: (0, $fGxxD.mapOptionsToServiceEntities),
            retainUserInputTransform: (0, $gfbId.mutateAffectedServicesField)
        },
        [(0, $af620ae3ac843a8a$export$23ca38ad884e35f1)]: {
            Component: (0, $imx16.default),
            defaultValueKey: 'text',
            retainUserInputTransform: (0, $f9vi5.mutateTextField)
        },
        [(0, $af620ae3ac843a8a$export$7e5590c7c7a403c0)]: {
            Component: (0, $imx16.default),
            defaultValueKey: 'text',
            retainUserInputTransform: (0, $f9vi5.mutateTextField)
        },
        [(0, $af620ae3ac843a8a$export$8643f0b9cefed538)]: {
            Component: (0, $imx16.default),
            defaultValueKey: 'text',
            retainUserInputTransform: (0, $f9vi5.mutateTextField)
        },
        [(0, $af620ae3ac843a8a$export$31a6c27df1f927b2)]: {
            Component: (0, $lUlE5.default),
            defaultValueKey: 'richText.adfValue.json',
            submitTransform: (0, $7OfzM.sanitizeADFField),
            retainUserInputTransform: (0, $7OfzM.mutateADFField)
        },
        [(0, $af620ae3ac843a8a$export$30b2c2de5e3007a4)]: {
            Component: (0, $ktkwO.default),
            defaultValueKey: 'selectedComponents',
            allowedValuesKey: 'components.nodes',
            submitTransform: (0, $ecSnb.mapOptionsToData),
            retainUserInputTransform: (0, $4fwkr.mutateComponentsField)
        },
        [(0, $af620ae3ac843a8a$export$f10e53e8928b61bd)]: {
            Component: (0, $5vmYB.default),
            defaultValueKey: [
                'classificationLevel',
                'defaultClassificationLevel'
            ],
            allowedValuesKey: 'classificationLevels.edges'
        },
        [(0, $af620ae3ac843a8a$export$3849bb04b4eee607)]: {
            Component: (0, $8Cejx.default),
            defaultValueKey: 'user',
            submitTransform: (0, $d706p.mapUserOptionsToIds),
            retainUserInputTransform: (0, $d706p.mutateSingleUserPicker)
        },
        [(0, $af620ae3ac843a8a$export$745c8245fea49a34)]: {
            Component: (0, $8Cejx.default),
            defaultValueKey: 'user',
            submitTransform: (0, $d706p.mapUserOptionsToAccountIds),
            retainUserInputTransform: (0, $d706p.mutateSingleUserPicker)
        },
        [(0, $af620ae3ac843a8a$export$eca94ae30cb92d8)]: {
            Component: (0, $6nvAz.default),
            defaultValueKey: 'selectedUsers',
            submitTransform: (0, $d706p.mapUserOptionsToIds),
            retainUserInputTransform: (0, $d706p.mutateMultiUserPicker)
        },
        [(0, $af620ae3ac843a8a$export$d41ae99ff05f5cda)]: {
            Component: (0, $6nvAz.default),
            defaultValueKey: 'selectedUsers',
            submitTransform: (0, $d706p.mapUserOptionsToIds),
            retainUserInputTransform: (0, $d706p.mutateMultiUserPicker)
        },
        [(0, $af620ae3ac843a8a$export$bbc6b85844b0ade5)]: {
            Component: (0, $6nvAz.default),
            defaultValueKey: 'selectedUsers',
            submitTransform: (0, $d706p.mapUserOptionsToAccountIds),
            retainUserInputTransform: (0, $d706p.mutateMultiUserPicker)
        },
        [(0, $af620ae3ac843a8a$export$2bb9d057bad89bfa)]: {
            Component: (0, $1m1S4.default),
            defaultValueKey: 'selectedUsers',
            submitTransform: (0, $bVgiW.mapUserOptionOrOptionsToIds),
            retainUserInputTransform: (0, $bVgiW.mutatePeopleField)
        },
        [(0, $af620ae3ac843a8a$export$b1ac879bb5cdf30a)]: {
            Component: (0, $1m1S4.default),
            defaultValueKey: 'selectedUsers',
            submitTransform: (0, $bVgiW.mapUserOptionOrOptionsToIds),
            retainUserInputTransform: (0, $bVgiW.mutatePeopleField)
        },
        [(0, $af620ae3ac843a8a$export$e4d5e04bc56680dc)]: {
            Component: (0, $1VP2V.default),
            defaultValueKey: 'number',
            submitTransform: (0, $ko1zK.transformAsNumber),
            retainUserInputTransform: (0, $ko1zK.mutateNumberField)
        },
        [(0, $af620ae3ac843a8a$export$d854193d90dc547d)]: {
            Component: (0, $1VP2V.default),
            defaultValueKey: 'number',
            submitTransform: (0, $ko1zK.transformAsNumber),
            retainUserInputTransform: (0, $ko1zK.mutateNumberField)
        },
        [(0, $af620ae3ac843a8a$export$e0ece81bd398c799)]: {
            Component: (0, $1VP2V.default),
            defaultValueKey: 'number',
            submitTransform: (0, $ko1zK.transformAsNumber),
            retainUserInputTransform: (0, $ko1zK.mutateNumberField)
        },
        [(0, $af620ae3ac843a8a$export$d8312cdfa02c100d)]: {
            Component: (0, $8eZP2.default),
            defaultValueKey: 'dateTime',
            submitTransform: (0, $cD5DT.transformDate),
            retainUserInputTransform: (0, $lumDD.mutateDateTimeField)
        },
        [(0, $af620ae3ac843a8a$export$70ff025076e5fb13)]: {
            Component: (0, $8eZP2.default),
            defaultValueKey: 'dateTime',
            submitTransform: (0, $cD5DT.transformDate),
            retainUserInputTransform: (0, $lumDD.mutateDateTimeField)
        },
        [(0, $af620ae3ac843a8a$export$8723b724f0b3ac65)]: {
            Component: (0, $h2Cf3.EpicLinkField),
            defaultValueKey: 'epic',
            submitTransform: (0, $30SZQ.mapEpicLinkOptionToData),
            retainUserInputTransform: (0, $cDYPA.mutateEpicLinkField)
        },
        [(0, $af620ae3ac843a8a$export$64c7789e86344de5)]: {
            Component: (0, $jANxQ.default),
            defaultValueKey: 'selectedLabels',
            submitTransform: (0, $epTsa.expVal)('adding-color-to-labels-field-experiment-milestone2', 'isColorfulNewLabelsEnabled', false) ? (0, $3JeUC.mapLabelOptionsToLabelData) : (0, $3JeUC.mapLabelOptionsToData),
            retainUserInputTransform: (0, $2me76.mutateLabelsFields)
        },
        [(0, $af620ae3ac843a8a$export$f596336c24b128f5)]: {
            Component: (0, $jANxQ.ForgeLabelsField),
            defaultValueKey: 'selectedLabels',
            submitTransform: (0, $3JeUC.mapLabelOptionsToData),
            retainUserInputTransform: (0, $2me76.mutateLabelsFields)
        },
        [(0, $af620ae3ac843a8a$export$3e8dded8d83b5d95)]: {
            Component: (0, $1pZVv.default),
            defaultValueKey: 'selectedAssets',
            submitTransform: (0, $9P44V.mapAssetOptionsToAssetEntity),
            retainUserInputTransform: (0, $9P44V.mutateAssetsFields)
        },
        [(0, $af620ae3ac843a8a$export$f4f101295d5cc151)]: {
            Component: (0, $7I9yO.default),
            defaultValueKey: 'version',
            allowedValuesKey: 'versions.nodes',
            submitTransform: (0, $dOI9z.getVersionId),
            retainUserInputTransform: (0, $5ujfv.mutateSingleVersionField)
        },
        [(0, $af620ae3ac843a8a$export$5bb498d4f2f54799)]: {
            Component: (0, $dOwo2.default),
            defaultValueKey: 'selectedVersions',
            allowedValuesKey: 'versions.nodes',
            submitTransform: (0, $dOI9z.getVersionsIds),
            retainUserInputTransform: (0, $fAftm.mutateMultiVersionsField)
        },
        [(0, $af620ae3ac843a8a$export$de14210faa5f2099)]: {
            Component: (0, $gkRdD.default),
            defaultValueKey: 'priority',
            allowedValuesKey: 'priorities.nodes',
            submitTransform: (0, $lxTUS.mapOptionToData),
            retainUserInputTransform: (0, $hf2Er.mutatePriorityField)
        },
        [(0, $af620ae3ac843a8a$export$e0b268941120d761)]: {
            Component: (0, $fSik2.default),
            defaultValueKey: 'date',
            submitTransform: (0, $cD5DT.transformDate),
            retainUserInputTransform: (0, $cD5DT.mutateDateField)
        },
        [(0, $af620ae3ac843a8a$export$111f32c51678063a)]: {
            Component: (0, $fSik2.default),
            defaultValueKey: 'date',
            submitTransform: (0, $cD5DT.transformDate),
            retainUserInputTransform: (0, $cD5DT.mutateDateField)
        },
        [(0, $af620ae3ac843a8a$export$909ba97f4a791588)]: {
            Component: (0, $62HU2.default),
            defaultValueKey: 'securityLevel',
            allowedValuesKey: 'securityLevels.nodes',
            submitTransform: (0, $9Lt0p.transformOnSubmit),
            retainUserInputTransform: (0, $9Lt0p.mutateSecurityLevelField)
        },
        [(0, $af620ae3ac843a8a$export$76d811609080a7aa)]: {
            Component: (0, $eQSWD.default),
            defaultValueKey: 'selectedRoles',
            submitTransform: (0, $clLhb.mapRoleToRestrictionValue)
        },
        [(0, $af620ae3ac843a8a$export$f2b56433dc0af401)]: {
            Component: (0, $aCPP2.default),
            defaultValueKey: 'url',
            retainUserInputTransform: (0, $5R3KZ.mutateUrlField)
        },
        [(0, $af620ae3ac843a8a$export$fb8861017089d392)]: {
            Component: (0, $etqwZ.default),
            defaultValueKey: 'fieldOption',
            allowedValuesKey: 'fieldOptions.nodes',
            submitTransform: (0, $6KapF.mapSelectOptionsToData),
            retainUserInputTransform: (0, $86yhe.mutateSingleSelectField)
        },
        [(0, $af620ae3ac843a8a$export$985c14eb8f3f0309)]: {
            Component: (0, $etqwZ.default),
            defaultValueKey: 'fieldOption',
            allowedValuesKey: 'fieldOptions.nodes',
            submitTransform: (0, $86yhe.mapSelectOptionsToConnectData),
            retainUserInputTransform: (0, $86yhe.mutateSingleSelectField)
        },
        [(0, $af620ae3ac843a8a$export$2055419ff013de79)]: {
            Component: (0, $jKaE2.default),
            defaultValueKey: 'selectedFieldOptions',
            allowedValuesKey: 'fieldOptions.nodes',
            submitTransform: (0, $6KapF.mapMultiSelectOptionsToData),
            retainUserInputTransform: (0, $fS2Sv.mutateMultiSelectField)
        },
        [(0, $af620ae3ac843a8a$export$9f6f73ea02649f83)]: {
            Component: (0, $jKaE2.default),
            defaultValueKey: 'selectedFieldOptions',
            allowedValuesKey: 'fieldOptions.nodes',
            submitTransform: (0, $fS2Sv.mapMultiSelectOptionsToConnectData),
            retainUserInputTransform: (0, $fS2Sv.mutateMultiSelectField)
        },
        [(0, $af620ae3ac843a8a$export$16fe78a07e97f2ad)]: {
            Component: (0, $7zPNF.default),
            defaultValueKey: 'selectedGroup',
            submitTransform: (0, $cCjAH.transformGroupToName),
            retainUserInputTransform: (0, $aDcwy.mutateSingleGroupPickerField)
        },
        [(0, $af620ae3ac843a8a$export$fd24d37af44fe736)]: {
            Component: (0, $7zPNF.default),
            defaultValueKey: 'selectedGroup',
            submitTransform: (0, $cCjAH.transformGroupToName),
            retainUserInputTransform: (0, $aDcwy.mutateSingleGroupPickerField)
        },
        [(0, $af620ae3ac843a8a$export$3a1ae3e0f2d9b1b9)]: {
            Component: (0, $eskjo.default),
            defaultValueKey: 'selectedGroups',
            submitTransform: (0, $cCjAH.transformGroupsToNames),
            retainUserInputTransform: (0, $26AI2.mutateMultipleGroupPickerField)
        },
        [(0, $af620ae3ac843a8a$export$3027db6317a2a8ea)]: {
            Component: (0, $eskjo.default),
            defaultValueKey: 'selectedGroups',
            submitTransform: (0, $cCjAH.transformGroupsToNames),
            retainUserInputTransform: (0, $26AI2.mutateMultipleGroupPickerField)
        },
        [(0, $af620ae3ac843a8a$export$64238d76a1dc0703)]: {
            Component: (0, $kTnLR.default),
            defaultValueKey: 'selectedSprints',
            submitTransform: (0, $15azN.mapSprintOptionToData),
            retainUserInputTransform: (0, $aixH0.mutateJiraSprintField)
        },
        [(0, $af620ae3ac843a8a$export$47af4d6f62c134cf)]: {
            Component: (0, $93gMe.default),
            submitTransform: (0, $dXi8G.mapOptionsToData),
            defaultValueKey: 'issueLinks',
            allowedValuesKey: 'issueLinkTypeRelations.nodes',
            retainUserInputTransform: (0, $5fZlk.mutateIssueLinksField)
        },
        [(0, $af620ae3ac843a8a$export$1070aada56fcaec9)]: {
            Component: (0, $egbID.default),
            defaultValueKey: 'color.colorKey',
            submitTransform: (0, $1wTTU.asServerColor),
            retainUserInputTransform: (0, $dUh12.mutateIssueColorField)
        },
        [(0, $af620ae3ac843a8a$export$f57941b9c1949a82)]: {
            Component: (0, $egbID.default),
            defaultValueKey: 'color.colorKey',
            submitTransform: (0, $1wTTU.asClassicEpicColor),
            retainUserInputTransform: (0, $dUh12.mutateEpicColorField)
        },
        [(0, $af620ae3ac843a8a$export$95433ac963f4aebe)]: {
            Component: (0, $cO7jo.default),
            defaultValueKey: 'richText.plainText',
            submitTransform: (0, $cERCt.convertTextToAdf),
            retainUserInputTransform: (0, $7sscC.mutateTextAreaField)
        },
        [(0, $af620ae3ac843a8a$export$67aca33725b6a717)]: {
            Component: (0, $cO7jo.default),
            defaultValueKey: 'object',
            submitTransform: (0, $hmGAR.transformJSONStringToObject),
            retainUserInputTransform: (0, $7sscC.mutateTextAreaField)
        },
        [(0, $af620ae3ac843a8a$export$f7a08bf17a7ac661)]: {
            Component: (0, $5ub3a.default),
            defaultValueKey: 'user',
            submitTransform: (0, $9qb2X.mapUserToAssigneeValue),
            retainUserInputTransform: (0, $9qb2X.mutateAssigneeUserPicker)
        },
        [(0, $af620ae3ac843a8a$export$d64150fd9c66969c)]: {
            Component: (0, $4CDpZ.default),
            defaultValueKey: 'user',
            submitTransform: (0, $d706p.mapUserOptionsToIds),
            retainUserInputTransform: (0, $d706p.mutateSingleUserPicker)
        },
        [(0, $af620ae3ac843a8a$export$252fb981af0e2e4e)]: {
            Component: (0, $jM4kG.default),
            defaultValueKey: 'resolution',
            allowedValuesKey: 'resolutions.nodes',
            submitTransform: (0, $JKlhd.mapOptionToResolutionOption),
            retainUserInputTransform: (0, $7aP7Z.mutateResolutionField)
        },
        [(0, $af620ae3ac843a8a$export$a9b3195cbef5c5ad)]: {
            Component: (0, $38tHc.default),
            submitTransform: (0, $8D65g.getFileIdsFromFiles)
        },
        [(0, $af620ae3ac843a8a$export$a36509fae9e84682)]: {
            Component: (0, $7BqUP.default),
            defaultValueKey: 'cascadingOption',
            allowedValuesKey: 'cascadingOptions.nodes',
            submitTransform: (0, $9cLf3.transformToServerValue),
            retainUserInputTransform: (0, $6FMuz.mutateCascadingSelectField)
        },
        [(0, $af620ae3ac843a8a$export$79443fedd031b437)]: {
            Component: (0, $c0mzI.default),
            defaultValueKey: 'selectedTeam',
            submitTransform: (0, $cictW.transformTeamFieldTypeString),
            retainUserInputTransform: (0, $kljID.mutateTeamField)
        },
        [(0, $af620ae3ac843a8a$export$1c7f7cfd2029442f)]: {
            Component: (0, $035EY.default),
            defaultValueKey: 'JiraAtlassianTeamField',
            submitTransform: (0, $24FkK.transformAtlassianTeamFieldTypeString),
            retainUserInputTransform: (0, $24FkK.mutateAtlassianTeamField)
        },
        [(0, $af620ae3ac843a8a$export$597fa240de2bfd92)]: {
            Component: (0, $37Tnh.default),
            defaultValueKey: 'selectedCmdbObjects',
            submitTransform: (0, $bVuLX.transformCmdbField),
            retainUserInputTransform: null
        },
        [(0, $af620ae3ac843a8a$export$864384797e544339)]: {
            Component: (0, $p3R5y.default),
            defaultValueKey: 'selectedOrganizations',
            submitTransform: (0, $i4diV.mapOrganizationOptionsToData),
            retainUserInputTransform: (0, $OOOvs.mutateOrganizationsField)
        },
        [(0, $af620ae3ac843a8a$export$a138d5648dda03f0)]: {
            Component: (0, $jFPx3.default),
            defaultValueKey: 'richText.adfValue.json'
        },
        [(0, $af620ae3ac843a8a$export$aa5680ad8f8be9fc)]: {
            Component: (0, $9bfcI.default),
            defaultValueKey: 'project',
            submitTransform: (0, $jpZmU.mapOptionToData),
            retainUserInputTransform: (0, $iYBjh.mutateProjectField)
        },
        [(0, $af620ae3ac843a8a$export$aecc734a7c3591d7)]: {
            Component: (0, $7fkTS.default),
            submitTransform: (0, $cRn23.transformTimeTrackingValueToSubmitFormat),
            retainUserInputTransform: (0, $cRn23.mutateTimeTrackingField),
            defaultValueKey: 'originalEstimate'
        },
        [(0, $af620ae3ac843a8a$export$d9861709f0b70c10)]: {
            Component: (0, $2RNNL.default),
            submitTransform: (0, $4zIi4.getLogWorkSubmitValue)
        },
        [(0, $af620ae3ac843a8a$export$d10237d945259f96)]: {
            Component: (0, $eLd2G.default),
            allowedValuesKey: 'fieldOptions.nodes',
            defaultValueKey: 'selectedFieldOptions',
            submitTransform: (0, $3DY4w.mapOptionsToData),
            retainUserInputTransform: (0, $jjsF0.mutateCheckboxField)
        },
        [(0, $af620ae3ac843a8a$export$670384150af5f49e)]: {
            Component: (0, $6zGZo.ParentLinkField),
            defaultValueKey: 'parentIssue',
            submitTransform: (0, $Gh5XP.mapOptionToData)
        },
        [(0, $af620ae3ac843a8a$export$bf9df74e065af482)]: {
            Component: (0, $kmGOd.default),
            defaultValueKey: 'parentIssue',
            submitTransform: (0, $2F5Ok.mapOptionToData),
            retainUserInputTransform: (0, $8cifA.mutateParentField)
        },
        ...(0, $7jTnu.fg)('jsm-responders-field-in-gicx-ui') ? {
            [(0, $af620ae3ac843a8a$export$33f8a9cb608132ba)]: {
                Component: (0, $a2hP6.default),
                defaultValueKey: 'selectedUsers',
                submitTransform: (0, $6aO03.mapUserOptionsToAris)
            }
        } : {},
        [(0, $af620ae3ac843a8a$export$27854f490d658fc4)]: {
            Component: (0, $lpUJE.default),
            defaultValueKey: 'selectedOption',
            allowedValuesKey: 'fieldOptions.nodes',
            submitTransform: (0, $kYBcr.mapOptionToData),
            retainUserInputTransform: (0, $86yhe.mutateSingleSelectField)
        },
        [(0, $af620ae3ac843a8a$export$fc69de49ba08ae77)]: {
            Component: (0, $kXkAy.IssueCreateEntitlementField),
            defaultValueKey: 'selectedEntitlement',
            submitTransform: (0, $i2Yqr.mapEntitlementOptionToData),
            retainUserInputTransform: undefined
        },
        ...(0, $7jTnu.fg)('jcs_master_flag') ? {
            [(0, $af620ae3ac843a8a$export$ede7166f44cc4bd6)]: {
                Component: (0, $caiim.IssueCreateOrganizationField),
                defaultValueKey: 'selectedOrganization',
                submitTransform: (0, $86m8P.mapOrganizationOptionToData),
                retainUserInputTransform: undefined
            }
        } : {}
    });
const $34b952dbec37e9e1$export$472717ed4aec82f1 = (0, $LFmXM.default)($34b952dbec37e9e1$var$createFieldMapItems);
const $34b952dbec37e9e1$export$aed6a8ebeb442f9 = [
    (0, $814y1.ISSUE_LINKS_TYPE),
    (0, $814y1.WORK_LOG_TYPE),
    (0, $814y1.ATTACHMENT_TYPE)
];
const $34b952dbec37e9e1$export$e7c3e130e221f1f1 = [
    (0, $814y1.ISSUE_LINKS_TYPE),
    (0, $814y1.WORK_LOG_TYPE)
];
const $34b952dbec37e9e1$export$ccf7c75b07963f11 = [
    (0, $af620ae3ac843a8a$export$aa5680ad8f8be9fc),
    (0, $af620ae3ac843a8a$export$2d5a62a3515ad4c6),
    (0, $af620ae3ac843a8a$export$a12a4b25ab12710c)
];

});
parcelRegister("d706p", function(module, exports) {

$parcel$export(module.exports, "transformJiraUserToUserOption", () => $2036a126345eed57$export$3e406786572c35b0);
$parcel$export(module.exports, "transformDefaultUserValues", () => $2036a126345eed57$export$26760e7b66ccf1e1);
$parcel$export(module.exports, "mapUserOptionsToIds", () => $2036a126345eed57$export$2482a6858a4714ad);
$parcel$export(module.exports, "mapUserOptionsToAccountIds", () => $2036a126345eed57$export$e4490ea0dfe4173f);
$parcel$export(module.exports, "mutateSingleUserPicker", () => $2036a126345eed57$export$7937ee6404102aff);
$parcel$export(module.exports, "mutateMultiUserPicker", () => $2036a126345eed57$export$53e350638c0acebc);

const $2036a126345eed57$export$3e406786572c35b0 = (userData)=>({
        id: userData.accountId || '',
        name: userData.name || '',
        avatarUrl: userData.picture || ''
    });
const $2036a126345eed57$export$26760e7b66ccf1e1 = (defaultValue)=>{
    if (Array.isArray(defaultValue)) return defaultValue.map($2036a126345eed57$export$3e406786572c35b0);
    return $2036a126345eed57$export$3e406786572c35b0(defaultValue);
};
const $2036a126345eed57$export$2482a6858a4714ad = (userOption)=>{
    if (Array.isArray(userOption)) return userOption.map((option)=>({
            id: option.id
        }));
    return {
        id: userOption.id
    };
};
const $2036a126345eed57$export$e4490ea0dfe4173f = (userOption)=>{
    if (Array.isArray(userOption)) return userOption.map((option)=>({
            accountId: option.id
        }));
    return {
        accountId: userOption.id
    };
};
const $2036a126345eed57$export$7937ee6404102aff = (selectedUser, fieldId)=>({
        fieldId: fieldId,
        mutationGroup: (0, $1e24dbdd7b63ae9f$export$6684456d545bf498),
        user: {
            accountId: selectedUser.id
        }
    });
const $2036a126345eed57$export$53e350638c0acebc = (selectedUsers, fieldId)=>({
        fieldId: fieldId,
        mutationGroup: (0, $1e24dbdd7b63ae9f$export$52003ca9b6035e0c),
        users: selectedUsers.map((user)=>({
                accountId: user.id
            }))
    });

});
const $1e24dbdd7b63ae9f$export$6684456d545bf498 = 'singleSelectUserPickerFields';
const $1e24dbdd7b63ae9f$export$52003ca9b6035e0c = 'multipleSelectUserPickerFields';


parcelRegister("hmGAR", function(module, exports) {

$parcel$export(module.exports, "transformJSONStringToObject", () => $1196f8dab24a3d60$export$2de59005e10fd82);

var $l5Z0K = parcelRequire("l5Z0K");
const $1196f8dab24a3d60$export$2de59005e10fd82 = (value)=>{
    try {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($l5Z0K)))(value) && JSON.parse(value)) return JSON.parse(value);
    } catch (e) {
        return value;
    }
    return value;
};

});
parcelRegister("l5Z0K", function(module, exports) {

var $1O9y6 = parcelRequire("1O9y6");

var $4sprp = parcelRequire("4sprp");

var $7gKgM = parcelRequire("7gKgM");
/** `Object#toString` result references. */ var $f5b964216372e7cd$var$stringTag = '[object String]';
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $f5b964216372e7cd$var$isString(value) {
    return typeof value == 'string' || !$4sprp(value) && $7gKgM(value) && $1O9y6(value) == $f5b964216372e7cd$var$stringTag;
}
module.exports = $f5b964216372e7cd$var$isString;

});


parcelRegister("f2oiD", function(module, exports) {

$parcel$export(module.exports, "AffectedServicesField", () => $cbcc67c88628ac4a$export$dbde2fdac14e77d6);
$parcel$export(module.exports, "default", () => $cbcc67c88628ac4a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $k71qx = parcelRequire("k71qx");

var $13LgO = parcelRequire("13LgO");

var $fE4zR = parcelRequire("fE4zR");

var $l9vfc = parcelRequire("l9vfc");

var $2nXHu = parcelRequire("2nXHu");

var $ixdDB = parcelRequire("ixdDB");

var $gfbId = parcelRequire("gfbId");

const $cbcc67c88628ac4a$export$dbde2fdac14e77d6 = (props)=>{
    const { width: width, fieldProps: { value: value, onChange: onChange, ...fieldProps }, fieldId: fieldId, error: error, autoCompleteUrl: autoCompleteUrl = '', isEditable: isEditable = true, nonEditableReason: nonEditableReason, onCloseMenuOnScroll: // @ts-expect-error - TS2339 - Property 'onCloseMenuOnScroll' does not exist on type 'Props'.
    onCloseMenuOnScroll = (0, $ixdDB.closeMenuOnScroll), isDropdownMenuFixedAndLayered: // @ts-expect-error - TS2339 - Property 'isDropdownMenuFixedAndLayered' does not exist on type 'Props'.
    isDropdownMenuFixedAndLayered = false, defaultValue: defaultValue } = props;
    const [shouldFetchServiceName, setShouldFetchServiceName] = (0, $eJOHy.useState)(true);
    const [selectedOptions, setSelectedOptions] = (0, $eJOHy.useState)([]);
    const [{ isLoading: isLoading }, fetchAffectedServicesName] = (0, $gfbId.useFetchAffectedServicesName)();
    (0, $eJOHy.useEffect)(()=>{
        if (shouldFetchServiceName && defaultValue && defaultValue.length > 0) {
            /*
            const ids = defaultValue.map((service) => service.serviceId);
            Simply extracting serviceId above causes Flow error as 'service'
            is of type (JiraAffectedService | AffectedServiceOption).
            See TURTLE-89 for more details.
             */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const ids = defaultValue.reduce((serviceIds, service)=>// @ts-expect-error - TS2339 - Property 'serviceId' does not exist on type 'AffectedServiceOption'. | TS2339 - Property 'serviceId' does not exist on type 'AffectedServiceOption'.
                service.serviceId != null ? serviceIds.concat(service.serviceId) : serviceIds, []);
            if (ids.length > 0) fetchAffectedServicesName(ids, setSelectedOptions);
            setShouldFetchServiceName(false);
        } else setSelectedOptions(value);
    }, [
        defaultValue,
        fetchAffectedServicesName,
        setSelectedOptions,
        shouldFetchServiceName,
        value
    ]);
    const getAffectedServicesEdit = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $13LgO.default), {
            ...fieldProps,
            autoCompleteUrl: autoCompleteUrl,
            onChange: onChange,
            value: selectedOptions,
            fieldId: fieldId,
            isInvalid: Boolean(error),
            isDisabled: !isEditable,
            isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
            onCloseMenuOnScroll: onCloseMenuOnScroll,
            fetchSuggestionsOnFocus: true
        });
    if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $l9vfc.StyledFieldSkeleton), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fE4zR.FieldContainer), {
        width: width
    }, isEditable === false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: nonEditableReason?.message || ''
    }, getAffectedServicesEdit()) : getAffectedServicesEdit());
};
var $cbcc67c88628ac4a$export$2e2bcd8739ae039 = (0, $2nXHu.withFormField)({
    transformDefaultValue: (0, $gfbId.transformDefaultAffectedServices)
})($cbcc67c88628ac4a$export$dbde2fdac14e77d6);

});
parcelRegister("13LgO", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ca4ed3cbd9ab004$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $gWITR = parcelRequire("gWITR");

var $lRq8t = parcelRequire("lRq8t");

var $aUMMA = parcelRequire("aUMMA");

var $5fIxl = parcelRequire("5fIxl");

var $8E59C = parcelRequire("8E59C");

var $kvnsn = parcelRequire("kvnsn");

var $fGxxD = parcelRequire("fGxxD");
const $6ca4ed3cbd9ab004$var$LOAD_OPTIONS_DEBOUNCE_TIMER = 300;
const $6ca4ed3cbd9ab004$var$AffectedServicesPickerEdit = (props)=>{
    const { fieldId: fieldId, value: value, onChange: onChange, autoCompleteUrl: autoCompleteUrl, isInvalid: isInvalid, isDisabled: isDisabled, placeholder: placeholder = '', isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, onCloseMenuOnScroll: onCloseMenuOnScroll, fetchSuggestionsOnFocus: fetchSuggestionsOnFocus = false, ...fieldProps } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [lastFetchFailed, setLastFetchFailed] = (0, $eJOHy.useState)(false);
    const [defaultOptions, setDefaultOptions] = (0, $eJOHy.useState)([]);
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(false);
    const shouldFetchDefaultOptions = (0, $eJOHy.useRef)(true);
    const searchAffectedServices = async (query = '')=>{
        setLastFetchFailed(false);
        try {
            (0, $8E59C.fetchAffectedServicesExperience).start();
            const affectedServices = await (0, $fGxxD.fetchAffectedServices)(query, autoCompleteUrl);
            (0, $8E59C.fetchAffectedServicesExperience).success();
            return affectedServices;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setLastFetchFailed(true);
            (0, $8E59C.fetchAffectedServicesExperience).failure();
            return [];
        }
    };
    const onFocus = async ()=>{
        if (shouldFetchDefaultOptions && defaultOptions && shouldFetchDefaultOptions.current && !defaultOptions.length) {
            shouldFetchDefaultOptions.current = false;
            setIsLoading && setIsLoading(true);
            const options = await searchAffectedServices();
            setDefaultOptions && setDefaultOptions(options);
            setIsLoading && setIsLoading(false);
        }
    };
    const loadOptionsDebounced = (0, $5fIxl.default)(searchAffectedServices, $6ca4ed3cbd9ab004$var$LOAD_OPTIONS_DEBOUNCE_TIMER);
    const noOptionsMessage = (0, $eJOHy.useCallback)(()=>formatMessage(lastFetchFailed ? (0, $kvnsn.default).failedFetch : (0, $kvnsn.default).noMatches), [
        formatMessage,
        lastFetchFailed
    ]);
    const defaultOptionsProps = ()=>{
        if (fetchSuggestionsOnFocus) return {
            onFocus: onFocus,
            isLoading: isLoading,
            defaultOptions: defaultOptions
        };
        return {};
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gWITR.default), {
        ...fieldProps,
        classNamePrefix: "affected-services-picker",
        fieldId: fieldId,
        loadOptions: loadOptionsDebounced,
        // @ts-expect-error - TS2322 - Type '(value: AffectedServiceOption[]) => void' is not assignable to type '(value: OptionsType<AffectedServiceOption>, action: ActionMeta<AffectedServiceOption>) => void'.
        onChange: onChange,
        autoFocus: false,
        ...defaultOptionsProps(),
        isClearable: Boolean(value),
        isMulti: true,
        value: value,
        // @ts-expect-error - TS2322 - Type '"error" | null' is not assignable to type 'ValidationState | undefined'.
        validationState: isInvalid === true ? 'error' : null,
        noOptionsMessage: noOptionsMessage,
        placeholder: placeholder,
        isDisabled: isDisabled,
        // @ts-expect-error - TS2322 - Type '((e: ChangeEvent<HTMLElement>) => boolean) | undefined' is not assignable to type 'boolean | EventListener | undefined'.
        closeMenuOnScroll: onCloseMenuOnScroll,
        menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
        styles: (0, $aUMMA.defaultSelectStyles),
        "data-testid": "issue-field-affected-services.ui.edit.async-select"
    });
};
var $6ca4ed3cbd9ab004$export$2e2bcd8739ae039 = $6ca4ed3cbd9ab004$var$AffectedServicesPickerEdit;

});
parcelRegister("5fIxl", function(module, exports) {

$parcel$export(module.exports, "default", () => $dcd33f3c06975801$export$2e2bcd8739ae039);
const $dcd33f3c06975801$var$defer = ()=>{
    const deferred = {};
    deferred.promise = new Promise((resolve, reject)=>{
        deferred.resolve = resolve;
        deferred.reject = reject;
    });
    return deferred;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $dcd33f3c06975801$var$debounce(fn, wait = 0) {
    let deferred;
    let timer;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let lastArgs;
    function flush() {
        const thisDeferred = deferred;
        clearTimeout(timer);
        if (thisDeferred) // @ts-expect-error - TS2683 - 'this' implicitly has type 'any' because it does not have a type annotation. | TS7005 - Variable 'lastArgs' implicitly has an 'any' type.
        // eslint-disable-next-line @typescript-eslint/no-invalid-this
        Promise.resolve(fn.apply(this, lastArgs)).then(thisDeferred.resolve, thisDeferred.reject);
        lastArgs = [];
        deferred = null;
    }
    // @ts-expect-error - TS2322 - Type '(...args: readonly any[]) => any' is not assignable to type 'F'.
    return function debounced(...args) {
        if (deferred) clearTimeout(timer);
        else deferred = $dcd33f3c06975801$var$defer();
        lastArgs = args;
        // @ts-expect-error - TS2683 - 'this' implicitly has type 'any' because it does not have a type annotation.
        // eslint-disable-next-line @typescript-eslint/no-invalid-this
        timer = setTimeout(flush.bind(this), wait);
        return deferred.promise;
    };
}
var $dcd33f3c06975801$export$2e2bcd8739ae039 = $dcd33f3c06975801$var$debounce;

});

parcelRegister("8E59C", function(module, exports) {

$parcel$export(module.exports, "graphModalExperience", () => $79a3682474cbe191$export$1b179afadba799dc);
$parcel$export(module.exports, "rapidSearchExperience", () => $79a3682474cbe191$export$1a90deecc86e78f8);
$parcel$export(module.exports, "autocompleteInsightFieldExperience", () => $79a3682474cbe191$export$94337fa170a193d2);
$parcel$export(module.exports, "fetchAffectedServicesExperience", () => $79a3682474cbe191$export$ce8d2a860f4e0316);
$parcel$export(module.exports, "objectDetailsViewExperience", () => $79a3682474cbe191$export$8e0a16d0fc0feba3);
$parcel$export(module.exports, "objectViewInlineEditSwitchFromReadToEditModeExperience", () => $79a3682474cbe191$export$5ae0e1bbe443c52b);
$parcel$export(module.exports, "objectViewInlineEditSwitchFromEditToReadModeExperience", () => $79a3682474cbe191$export$b9c9c5e92fa6a3a4);
$parcel$export(module.exports, "createObjectTypeExperience", () => $79a3682474cbe191$export$15a29f6e079c9b3d);
$parcel$export(module.exports, "createObjectExperience", () => $79a3682474cbe191$export$aaf507c87c29ab22);
$parcel$export(module.exports, "loadSchemaObjectListExperience", () => $79a3682474cbe191$export$6f02ba4c2b1e3f5f);
$parcel$export(module.exports, "loadAttributesConfigurationExperience", () => $79a3682474cbe191$export$8f63f06b0486e498);
$parcel$export(module.exports, "updateObjectFilterExperience", () => $79a3682474cbe191$export$967859e6be8e6f4b);
$parcel$export(module.exports, "getUpdateGlobalConfigInlineEditExperience", () => $79a3682474cbe191$export$e4deb66475dfa46b);
$parcel$export(module.exports, "loadObjectDetailExperience", () => $79a3682474cbe191$export$3f1da23c065671d2);

var $2lxLk = parcelRequire("2lxLk");
var $f39LL = parcelRequire("f39LL");
const $79a3682474cbe191$export$1b179afadba799dc = new (0, $f39LL.UFOExperience)('service-management.insight-cmdb.display-graph-modal', {
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult,
    type: (0, $2lxLk.ExperienceTypes).Experience
});
const $79a3682474cbe191$export$1a90deecc86e78f8 = new (0, $f39LL.UFOExperience)('service-management.insight-cmdb.display-rapid-search-results', {
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult,
    type: (0, $2lxLk.ExperienceTypes).Experience
});
const $79a3682474cbe191$export$94337fa170a193d2 = new (0, $f39LL.UFOExperience)('service-management.insight-cmdb.autocomplete-search-insight-field', {
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult,
    type: (0, $2lxLk.ExperienceTypes).Experience,
    featureFlags: [
        'jsm-insight-field-performance-improvements_fplgq'
    ]
});
const $79a3682474cbe191$export$ce8d2a860f4e0316 = new (0, $f39LL.UFOExperience)('service-management.insight-cmdb.fetch-affected-services', {
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult,
    type: (0, $2lxLk.ExperienceTypes).Experience
});
const $79a3682474cbe191$export$8e0a16d0fc0feba3 = new (0, $f39LL.UFOExperience)('jsm-cmdb-object-details-view', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).PageSegmentLoad
});
const $79a3682474cbe191$export$5ae0e1bbe443c52b = new (0, $f39LL.UFOExperience)('service-management.insight-cmdb.object-view-inline-edit.switch-from-read-to-edit-mode', {
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult,
    type: (0, $2lxLk.ExperienceTypes).Experience
});
const $79a3682474cbe191$export$b9c9c5e92fa6a3a4 = new (0, $f39LL.UFOExperience)('service-management.insight-cmdb.object-view-inline-edit.switch-from-edit-to-read-mode', {
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult,
    type: (0, $2lxLk.ExperienceTypes).Experience
});
const $79a3682474cbe191$export$15a29f6e079c9b3d = new (0, $f39LL.UFOExperience)('jsm-cmdb-create-object-type', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).Custom,
    timings: [
        {
            key: 'created-on-server',
            endMark: 'object-type-created-on-server'
        }
    ]
});
const $79a3682474cbe191$export$aaf507c87c29ab22 = new (0, $f39LL.UFOExperience)('service-management.insight-cmdb.create-object', {
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult,
    type: (0, $2lxLk.ExperienceTypes).Experience
});
const $79a3682474cbe191$export$6f02ba4c2b1e3f5f = new (0, $f39LL.UFOExperience)('jsm-cmdb-load-object-list', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).PageSegmentLoad
});
const $79a3682474cbe191$export$8f63f06b0486e498 = new (0, $f39LL.UFOExperience)('jsm-cmdb-load-attributes-tab', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).PageSegmentLoad
});
const $79a3682474cbe191$export$967859e6be8e6f4b = new (0, $f39LL.UFOExperience)('jsm-cmdb-object-filter', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).Custom,
    timings: [
        {
            key: 'response-received',
            endMark: 'server-response-received'
        },
        {
            key: 'object-table-rendered',
            endMark: 'object-table-rendered'
        },
        {
            key: 'object-list-rendered',
            endMark: 'object-list-rendered'
        },
        {
            key: 'no-filter-results-rendered',
            endMark: 'no-filter-results-rendered'
        }
    ]
});
const $79a3682474cbe191$export$e4deb66475dfa46b = ()=>new (0, $f39LL.UFOExperience)('service-management.insight-cmdb.global-config-inline-edit.update', {
        performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult,
        type: (0, $2lxLk.ExperienceTypes).Experience
    });
const $79a3682474cbe191$export$3f1da23c065671d2 = new (0, $f39LL.UFOExperience)('service-management.insight-cmdb.embedded-object-details-view', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).PageSegmentLoad
});

});

parcelRegister("kvnsn", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6e9499691dcaaf5$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $e6e9499691dcaaf5$var$messages = (0, $7qGN1.defineMessages)({
    noMatches: {
        "id": "issue-field-affected-services.edit.no-matches",
        "defaultMessage": "No Matches"
    },
    failedFetch: {
        "id": "issue-field-affected-services.edit.failed-fetch",
        "defaultMessage": "Search failed. Please try again."
    }
});
var $e6e9499691dcaaf5$export$2e2bcd8739ae039 = $e6e9499691dcaaf5$var$messages;

});

parcelRegister("fGxxD", function(module, exports) {

$parcel$export(module.exports, "mapServiceEntitiesToOptions", () => $e4720ab26e8f8f9b$export$23b96a30f377b741);
$parcel$export(module.exports, "mapOptionsToServiceEntities", () => $e4720ab26e8f8f9b$export$7dcfc49587479fac);
$parcel$export(module.exports, "fetchAffectedServices", () => $e4720ab26e8f8f9b$export$66d34216c85d32cb);

var $b5RwB = parcelRequire("b5RwB");

var $gYnSx = parcelRequire("gYnSx");

var $1uIew = parcelRequire("1uIew");

var $jGzN3 = parcelRequire("jGzN3");
const $e4720ab26e8f8f9b$export$23b96a30f377b741 = (services)=>services.map(({ id: id, name: name })=>({
            label: name,
            value: id
        }));
const $e4720ab26e8f8f9b$export$7dcfc49587479fac = (options)=>options.map(({ label: label, value: value })=>({
            id: value,
            name: label
        }));
const $e4720ab26e8f8f9b$export$66d34216c85d32cb = async (inputValue, autoCompleteUrl)=>{
    const query = (0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).stringify({
        query: inputValue
    });
    return (0, $jGzN3.performGetRequest)(`${autoCompleteUrl}?${query}`).then((response)=>$e4720ab26e8f8f9b$export$23b96a30f377b741(response.services)).catch((error)=>{
        (0, $gYnSx.trackFetchErrors)({
            error: error,
            id: 'fetchAffectedServices',
            packageName: 'jiraIssueFieldAffectedServices',
            logToSentry: !(0, $1uIew.isValidationError)(error),
            sendToPrivacyUnsafeSplunk: true,
            attributes: {
                errorMessage: error.message
            }
        });
        throw error;
    });
};

});


parcelRegister("fE4zR", function(module, exports) {

$parcel$export(module.exports, "FieldContainer", () => $8df78d2f8333d798$export$b5c4b0e7cd7f148b);
$parcel$export(module.exports, "Description", () => $8df78d2f8333d798$export$393edc798c47379d);
$parcel$export(module.exports, "SelectContainer", () => $8df78d2f8333d798$export$446eebadefe1123b);
$parcel$export(module.exports, "Divider", () => $8df78d2f8333d798$export$2e0a83ec2e27ecbb);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $fYeTG = parcelRequire("fYeTG");
const $8df78d2f8333d798$export$b5c4b0e7cd7f148b = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { marginTop: marginTop, paddingBottom: paddingBottom, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1ebfkjq": (0, $awdRS.default)((()=>{
                return typeof (__cmplp.width ?? ((0, $fYeTG.isMobileAndInMvpOrExistingUsersExperiment)() ? '100%' : 350)) === 'number' ? `${__cmplp.width ?? ((0, $fYeTG.isMobileAndInMvpOrExistingUsersExperiment)() ? '100%' : 350)}px` : __cmplp.width ?? ((0, $fYeTG.isMobileAndInMvpOrExistingUsersExperiment)() ? '100%' : 350);
            })()),
            "--_1glwpqj": (0, $awdRS.default)(`${__cmplp.marginTop ?? 0}px`),
            "--_1i3s0vn": (0, $awdRS.default)(`${__cmplp.paddingBottom ?? 0}px`)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsbhi17 _19pknek2 _n3td11zn",
            __cmplp.className
        ])
    });
});
const $8df78d2f8333d798$export$393edc798c47379d = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_otyru2gc",
            __cmplp.className
        ])
    });
});
const $8df78d2f8333d798$export$446eebadefe1123b = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsb1mjv",
            __cmplp.className
        ])
    });
});
const $8df78d2f8333d798$export$2e0a83ec2e27ecbb = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4t3it94y _1bsb1osq _bfhkmuej _19pk1ejb _2hwxidpf _otyr1ejb _18u0idpf",
            __cmplp.className
        ])
    });
});
const $8df78d2f8333d798$export$32dd8f1956fe77b1 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_18u01wug _2hwxu2gc",
            __cmplp.className
        ])
    });
});

});

parcelRegister("l9vfc", function(module, exports) {

$parcel$export(module.exports, "StyledFieldSkeleton", () => $e183003746ed588c$export$ed5de990fe261b7b);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $9A8Wt = parcelRequire("9A8Wt");
const $e183003746ed588c$export$ed5de990fe261b7b = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $9A8Wt.Skeleton), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4t3i1ylp _1bsb1edt _otyr12x7",
            __cmplp.className
        ])
    });
});
$e183003746ed588c$export$ed5de990fe261b7b.displayName = 'FieldSkeleton';

});
parcelRegister("9A8Wt", function(module, exports) {

$parcel$export(module.exports, "getKeyframes", () => $72d4b536fea173c6$export$b2b5e866b2fbf2ec);
$parcel$export(module.exports, "SkeletonCompiled", () => $72d4b536fea173c6$export$dc84d515085190e);
$parcel$export(module.exports, "SpacerCompiled", () => $72d4b536fea173c6$export$e477bb7d17087f28);
$parcel$export(module.exports, "Skeleton", () => $72d4b536fea173c6$export$8f31e4c4a37b8e9c);
$parcel$export(module.exports, "Spacer", () => $72d4b536fea173c6$export$d7a54cba636a8cd6);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $cdbP5 = parcelRequire("cdbP5");

var $f2JN3 = parcelRequire("f2JN3");

var $7jTnu = parcelRequire("7jTnu");
const $72d4b536fea173c6$export$b2b5e866b2fbf2ec = (offsetX = 0)=>{
    const fromPositionX = -Math.abs(offsetX) - 300;
    const toPositionX = fromPositionX + 2000;
    return (0, $cdbP5.keyframes)({
        '0%': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundPosition: `${fromPositionX}px 0`
        },
        '100%': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundPosition: `${toPositionX}px 0`
        }
    });
};
const $72d4b536fea173c6$var$shimmer = $72d4b536fea173c6$export$b2b5e866b2fbf2ec();
const $72d4b536fea173c6$export$1d2144641222f3bd = /*#__PURE__*/ (0, $cdbP5.default).div.withConfig({
    componentId: "ieqbub-0"
})(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        animationDelay: props.theme.animationDelay || '0s',
        animationDuration: '1s',
        animationFillMode: 'forwards',
        animationIterationCount: 'infinite',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        animationName: props.theme.animationName || $72d4b536fea173c6$var$shimmer,
        animationTimingFunction: 'linear',
        backgroundColor: "var(--ds-skeleton, #091E420F)",
        backgroundImage: `linear-gradient( to right, ${"var(--ds-skeleton, #091E420F)"} 10%, ${"var(--ds-skeleton-subtle, #091E4208)"} 30%, ${"var(--ds-skeleton, #091E420F)"} 50% )`,
        backgroundRepeat: 'no-repeat',
        borderRadius: '2px',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: props.height,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: props.width
    }));
const $72d4b536fea173c6$export$b1deee0d21f1be36 = /*#__PURE__*/ (0, $cdbP5.default).div.withConfig({
    componentId: "ieqbub-1"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: props.height
    }));
const $72d4b536fea173c6$export$dc84d515085190e = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_8jvb0j": (0, $awdRS.default)(__cmplp.height),
            "--_1gljcou": (0, $awdRS.default)(__cmplp.width)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkoyh40 _ju25ru3m _5sag9cwz _1o51q7pw _tip812c5 _j7hq1245 _1pglp3kn _bfhkn82g _1itk1kpv _12vemgnk _4t3i1474 _1bsb1rkg",
            __cmplp.className
        ])
    });
});
const $72d4b536fea173c6$export$e477bb7d17087f28 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_8jvb0j": (0, $awdRS.default)(__cmplp.height)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4t3i1474",
            __cmplp.className
        ])
    });
});
const $72d4b536fea173c6$export$8f31e4c4a37b8e9c = (0, $f2JN3.componentWithCondition)(()=>(0, $7jTnu.fg)('enghealth-4756-migrate-complex-styled-component-v2'), $72d4b536fea173c6$export$dc84d515085190e, $72d4b536fea173c6$export$1d2144641222f3bd);
const $72d4b536fea173c6$export$d7a54cba636a8cd6 = (0, $f2JN3.componentWithCondition)(()=>(0, $7jTnu.fg)('enghealth-4756-migrate-complex-styled-component-v2'), $72d4b536fea173c6$export$e477bb7d17087f28, $72d4b536fea173c6$export$b1deee0d21f1be36);

});


parcelRegister("2nXHu", function(module, exports) {

$parcel$export(module.exports, "withFormField", () => $53008e3917c2202a$export$17bf6386ac4a43ba);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $6svxr = parcelRequire("6svxr");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $4NEt5 = parcelRequire("4NEt5");

var $eDBhy = parcelRequire("eDBhy");

var $7jTnu = parcelRequire("7jTnu");

var $4BrPs = parcelRequire("4BrPs");

var $fSIfd = parcelRequire("fSIfd");

var $duCer = parcelRequire("duCer");

var $ldwED = parcelRequire("ldwED");

var $gPU3b = parcelRequire("gPU3b");

var $a1pDt = parcelRequire("a1pDt");

var $iMZxW = parcelRequire("iMZxW");

var $a8VxX = parcelRequire("a8VxX");

var $dxW4o = parcelRequire("dxW4o");
var $mWfDl = parcelRequire("mWfDl");
var $bYusI = parcelRequire("bYusI");

var $xMjNG = parcelRequire("xMjNG");

var $4PKlm = parcelRequire("4PKlm");


var $enLyD = parcelRequire("enLyD");

var $6XJko = parcelRequire("6XJko");

var $aeOhE = parcelRequire("aeOhE");

var $52lsd = parcelRequire("52lsd");

var $jHG59 = parcelRequire("jHG59");

var $coifs = parcelRequire("coifs");

var $4rsU2 = parcelRequire("4rsU2");

var $jq3eA = parcelRequire("jq3eA");
const $53008e3917c2202a$export$17bf6386ac4a43ba = (options)=>(Component)=>// @ts-expect-error - TS2322 - Type '(ownProps: ReturnComponentProps<Config>) => JSX.Element | null' is not assignable to type 'AbstractComponent<ReturnComponentProps<Config>, any>'.
        (ownProps)=>{
            const { fieldId: fieldId, fieldName: fieldName, fieldType: fieldType, description: descriptionRaw, isRequired: isRequired = false, defaultValue: // @ts-expect-error - TS2339 - Property 'defaultValue' does not exist on type '{ areUiModificationsBusy?: boolean | undefined; } & BaseField & { componentKey?: string | undefined; fieldType?: string | undefined; forge?: { selectedProject: SelectedProject; selectedIssueType: IssueOrRequestType; modules: ForgeModules; } | undefined; fieldHelpTextUrl?: string | undefined; onLayoutDone?: (() => vo...'.
            defaultValue, componentKey: componentKey, forge: forge, onLayoutDone: onLayoutDone, fieldHelpTextUrl: fieldHelpTextUrl, areUiModificationsBusy: areUiModificationsBusy, defaultValueDontTransform: defaultValueDontTransform, isRequiredFromUIM: isRequiredFromUIM, onLinkClickEvent: onLinkClickEvent, isMini: isMini, isCollapsed: isCollapsed, isFieldResponsive: isFieldResponsive, fieldWrapperElement: fieldWrapperElement, ...ownPropsRest } = ownProps;
            const { publish: publish } = (0, $4PKlm.useGICLifeCycleEvents)();
            const { transformDefaultValue: transformDefaultValue, validator: validator, shouldRenderFieldMessage: shouldRenderFieldMessage = true, shouldHideLabel: shouldHideLabel = false } = options;
            const description = (0, $gPU3b.isForgeCustomField)(fieldType) ? (0, $a8VxX.extractEnvFromFieldDescription)(descriptionRaw).description : descriptionRaw;
            const hasSentTransformDefaultValueError = (0, $eJOHy.useRef)(false);
            let transformedDefaultValue;
            try {
                /**
     * The transformDefaultValue function is generally used to transform a defaultValue
     * that is passed from the backend, which is in a different data format to the
     * frontend data format.
     *
     * In some situations, we want to set the defaultValue using data that is already
     * in the frontend data format instead of the backend data format. In these cases
     * we want to ignore the transformDefaultValue and just use the defaultValue from props.
     *
     * To do this, we are using the defaultValueDontTransform prop to know that we
     * can safely not run transformDefaultValue.
     */ if (defaultValueDontTransform) transformedDefaultValue = defaultValue; // this can be merged into the below on ff cleanup
                else transformedDefaultValue = defaultValue !== undefined && typeof transformDefaultValue === 'function' ? transformDefaultValue(defaultValue) : defaultValue;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                if (hasSentTransformDefaultValueError.current === false) {
                    hasSentTransformDefaultValueError.current = true;
                    (0, $eDBhy.fireIssueCreateErrorAnalytics)({
                        meta: {
                            id: 'defaultValueTransformation',
                            packageName: 'jiraIssueCreateCommons',
                            teamName: 'gryffindor'
                        },
                        error: error,
                        attributes: {
                            fieldType: fieldType
                        },
                        sendToPrivacyUnsafeSplunk: true
                    });
                }
            }
            (0, $eJOHy.useLayoutEffect)(()=>{
                onLayoutDone && onLayoutDone();
            }, [
                onLayoutDone
            ]);
            const shouldSetWidth = isMini || isFieldResponsive;
            const renderComponent = (fieldProps, error)=>// @ts-expect-error Type 'Omit<ReturnComponentProps<Config>, "fieldId" | "fieldName" | "description" | "isRequired" | "defaultValue" | "areUiModificationsBusy" | "componentKey" | "fieldType" | "forge" | "fieldHelpTextUrl" | "onLayoutDone"> & { ...; }' is not assignable to type 'IntrinsicAttributes & PropsWithoutRef<ComponentProps<Config, FieldValue>> & RefAttributes<any> & { ...; }'.
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Component, {
                    ...ownPropsRest,
                    fieldId: fieldId,
                    fieldName: fieldName,
                    isRequired: isRequired,
                    fieldProps: fieldProps,
                    width: shouldSetWidth ? '100%' : undefined,
                    isMini: isMini,
                    description: description,
                    defaultValue: defaultValue,
                    error: error,
                    key: componentKey,
                    ariaLabelledBy: `${fieldId}-field-label`
                });
            const renderFieldMessage = (0, $eJOHy.useCallback)((error)=>{
                if (shouldRenderFieldMessage) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $coifs.FieldMessage), {
                    fieldId: fieldId,
                    description: description,
                    error: error,
                    fieldName: fieldName,
                    fieldHelpTextUrl: fieldHelpTextUrl,
                    onLinkClickEvent: onLinkClickEvent,
                    isMini: isMini
                });
                return null;
            }, [
                description,
                fieldHelpTextUrl,
                fieldId,
                fieldName,
                isMini,
                onLinkClickEvent,
                shouldRenderFieldMessage
            ]);
            const extension = (0, $eJOHy.useMemo)(()=>{
                if (typeof fieldType === 'string' && (0, $gPU3b.isForgeCustomField)(fieldType) && forge?.modules && forge?.hasFinishedLoading) return (0, $ldwED.getExtension)(fieldType, forge?.modules);
                return null;
            }, [
                fieldType,
                forge?.modules,
                forge?.hasFinishedLoading
            ]);
            (0, $eJOHy.useEffect)(()=>{
                const shouldReportFailure = typeof fieldType === 'string' && (0, $gPU3b.isForgeCustomField)(fieldType) && forge?.hasFinishedLoading && !extension && forge?.modules && forge?.filteredOutModules;
                if (shouldReportFailure) (0, $duCer.reportForgeFailure)(fieldType, forge?.modules, forge?.filteredOutModules);
            }, [
                fieldType,
                extension,
                forge?.modules,
                forge?.filteredOutModules,
                forge?.hasFinishedLoading
            ]);
            let issueExtensionData;
            if ((0, $7jTnu.fg)('issue-create-new-forge-field')) issueExtensionData = (0, $eJOHy.useMemo)(()=>{
                if (!forge?.selectedProject || !forge?.selectedIssueType) return undefined;
                const { selectedProject: selectedProject, selectedIssueType: selectedIssueType } = forge;
                return {
                    project: {
                        id: selectedProject.value,
                        key: selectedProject.projectKey,
                        type: selectedProject.projectType
                    },
                    issue: {
                        type: selectedIssueType.label,
                        typeId: selectedIssueType.value
                    }
                };
            }, [
                forge
            ]);
            let isBuiltinEdit = false;
            if (extension && (0, $7jTnu.fg)('issue-create-new-forge-field')) isBuiltinEdit = (0, $7jTnu.fg)('ditto-fcf-support-new-manifest-on-frontend') ? (0, $gPU3b.isBuiltInJiraFieldRender)(extension, 'edit', 'issue-create') : !extension?.properties.edit;
            const renderFieldContent = (fieldProps, error)=>{
                if (isCollapsed) return null;
                const fieldPropsWithPublish = {
                    ...fieldProps,
                    onChange: (value, ...rest)=>{
                        fieldProps.onChange(value, ...rest);
                        publish((0, $xMjNG.GIC_LIFECYCLE_EVENTS).CREATE_FORM_FIELD_VALUE_CHANGE, {
                            fieldId: fieldId,
                            fieldName: fieldName,
                            fieldType: fieldType,
                            value: (0, $jHG59.getValueFromEventOrValue)(value)
                        });
                    }
                };
                if (isBuiltinEdit && fieldType !== undefined && (0, $gPU3b.isForgeCustomField)(fieldType) && (0, $7jTnu.fg)('issue-create-new-forge-field')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, renderComponent(fieldProps, error), renderFieldMessage(error), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aeOhE.ForgeScreenEvent), {
                    attributes: {
                        renderContext: 'issue-create',
                        fieldType: extension?.properties.type,
                        module: extension?.type,
                        ...extension ? (0, $52lsd.getAnalyticsAttributesFromExtension)(extension) : {},
                        renderMode: 'default'
                    }
                }));
                if (!(0, $7jTnu.fg)('issue-create-new-forge-field')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, fieldType !== undefined && (0, $gPU3b.isForgeCustomField)(fieldType) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fSIfd.ForgeField), {
                    fieldId: fieldId,
                    fieldName: fieldName,
                    fieldType: fieldType,
                    fieldProps: fieldPropsWithPublish,
                    error: error,
                    selectedProject: forge?.selectedProject,
                    selectedIssueType: forge?.selectedIssueType,
                    extension: extension,
                    renderFieldMessage: renderFieldMessage,
                    renderDefaultComponent: renderComponent
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, fieldWrapperElement ? /*#__PURE__*/ (0, $eJOHy.cloneElement)(fieldWrapperElement, {}, [
                    renderComponent(fieldPropsWithPublish, error),
                    renderFieldMessage(error)
                ]) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, renderComponent(fieldPropsWithPublish, error), renderFieldMessage(error))));
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, fieldType !== undefined && (0, $gPU3b.isForgeCustomField)(fieldType) && issueExtensionData ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4BrPs.ForgeField), {
                    fieldId: fieldId,
                    fieldName: fieldName,
                    fieldType: fieldType,
                    fieldProps: fieldPropsWithPublish,
                    description: descriptionRaw,
                    issueExtensionData: issueExtensionData,
                    extension: extension ?? null,
                    renderContext: "issue-create",
                    experience: (0, $7jTnu.fg)('ditto-fcf-support-new-manifest-on-frontend') ? 'issue-create' : undefined
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, fieldWrapperElement ? /*#__PURE__*/ (0, $eJOHy.cloneElement)(fieldWrapperElement, {}, [
                    renderComponent(fieldPropsWithPublish, error),
                    renderFieldMessage(error)
                ]) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, renderComponent(fieldPropsWithPublish, error), renderFieldMessage(error))));
            };
            const renderFieldLabel = (0, $7jTnu.fg)('issue-create-new-forge-field') ? (0, $eJOHy.useCallback)(()=>{
                if (isCollapsed || shouldHideLabel || (0, $gPU3b.isForgeCustomField)(fieldType) && !isBuiltinEdit && (0, $7jTnu.fg)('issue-create-new-forge-field')) return ''; // one off case only expected in case of worklog where we want to show the label inside the component code
                if ((0, $gPU3b.isForgeCustomField)(fieldType)) {
                    const { environment: environment } = (0, $a8VxX.extractEnvFromFieldDescription)(descriptionRaw);
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($53008e3917c2202a$var$ForgeLabel, null, fieldName, " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iMZxW.EnvironmentLozenge), {
                        environmentType: environment
                    }));
                }
                return fieldName;
            }, [
                fieldName,
                fieldType,
                shouldHideLabel,
                descriptionRaw,
                isCollapsed,
                isBuiltinEdit
            ]) : (0, $eJOHy.useCallback)(()=>{
                if (isCollapsed || shouldHideLabel) return ''; // one off case only expected in case of worklog where we want to show the label inside the component code
                if ((0, $gPU3b.isForgeCustomField)(fieldType)) {
                    const { environment: environment } = (0, $a8VxX.extractEnvFromFieldDescription)(descriptionRaw);
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($53008e3917c2202a$var$ForgeLabel, null, fieldName, " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iMZxW.EnvironmentLozenge), {
                        environmentType: environment
                    }));
                }
                return fieldName;
            }, [
                fieldName,
                fieldType,
                shouldHideLabel,
                descriptionRaw,
                isCollapsed
            ]);
            if ((0, $gPU3b.isForgeCustomField)(fieldType) && !forge?.hasFinishedLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4rsU2.FieldSkeleton), null);
            if ((0, $gPU3b.isForgeCustomField)(fieldType) && !extension) return null;
            const renderField = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6svxr.default), {
                id: `${fieldId}-field`,
                label: renderFieldLabel(),
                elementAfterLabel: areUiModificationsBusy ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $mWfDl.FieldBusyIndicator), {
                    fieldId: fieldId
                }) : undefined,
                isRequired: isRequired,
                name: fieldId,
                defaultValue: transformedDefaultValue,
                key: (0, $jq3eA.generateKeyForRequiredFromUIM)({
                    fieldId: fieldId,
                    isRequiredFromUIM: isRequiredFromUIM === true
                }),
                validate: (value, _formState, { dirty: dirty })=>{
                    try {
                        const { type: type } = ownPropsRest;
                        if ((0, $gPU3b.isForgeCustomField)(fieldType) && isRequired) // Dirty check is required for the forge custom fields that haven't yet populated the value because it haven't lost a focus
                        return dirty && typeof validator === 'function' ? validator(value, isRequired, type) : undefined;
                        return typeof validator === 'function' ? validator(value, isRequired, type) : undefined;
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    } catch (error) {
                        (0, $eDBhy.fireIssueCreateErrorAnalytics)({
                            meta: {
                                id: 'fieldValidationIssue',
                                packageName: 'jiraIssueCreateCommons',
                                teamName: 'gryffindor'
                            },
                            error: error,
                            sendToPrivacyUnsafeSplunk: true
                        });
                        return undefined;
                    }
                }
            }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dxW4o.ErrorBoundaryBypassProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dxW4o.ErrorBoundaryBypassOutput), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4NEt5.JiraIssueCreateErrorBoundary), {
                    id: "issueAdjustmentsFieldValueDecorator",
                    packageName: "jiraIssueCreateModal",
                    fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bYusI.ErrorHandler), null), renderFieldContent(fieldProps, error)),
                    sendToPrivacyUnsafeSplunk: true,
                    attributes: (err)=>({
                            errorType: (0, $a1pDt.getErrorType)(err),
                            viewType: (0, $6d500eb1fc6bc124$export$e615b7e9b8fb4715),
                            fieldId: fieldId,
                            fieldType: fieldType
                        })
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $enLyD.FieldValueDecoratorAsync), {
                    fieldId: fieldId,
                    fieldType: fieldType,
                    fieldProps: fieldProps
                }, (interceptedFieldProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dxW4o.ErrorBoundaryBypassInput), null, renderFieldContent(interceptedFieldProps, error))))));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4NEt5.JiraIssueCreateErrorBoundary), {
                id: "withFormField",
                packageName: "jiraIssueCreateModal",
                fallback: "unmount",
                sendToPrivacyUnsafeSplunk: true,
                attributes: {
                    fieldId: fieldId,
                    fieldType: fieldType
                }
            }, (0, $6XJko.isVisualRefreshEnabled)() && fieldId === 'assignee' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                xcss: $53008e3917c2202a$var$fieldStyles
            }, " ", renderField, " ") : renderField);
        };
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $53008e3917c2202a$var$ForgeLabel = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c8140y _zulpu2gc _1e0c116y _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $53008e3917c2202a$var$fieldStyles = (0, $1DXK0.xcss)({
    position: 'relative'
});

});
parcelRegister("4BrPs", function(module, exports) {

$parcel$export(module.exports, "ForgeField", () => $b70bc7fb78fce255$export$34a15d6027142c62);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $cDJ0f = parcelRequire("cDJ0f");

var $52lsd = parcelRequire("52lsd");

var $efBOp = parcelRequire("efBOp");

var $iMZxW = parcelRequire("iMZxW");

var $a8VxX = parcelRequire("a8VxX");

var $cO6Bh = parcelRequire("cO6Bh");

var $7jTnu = parcelRequire("7jTnu");

var $gPU3b = parcelRequire("gPU3b");

var $hdJ4q = parcelRequire("hdJ4q");

var $aXssw = parcelRequire("aXssw");

var $g2eay = parcelRequire("g2eay");
const $b70bc7fb78fce255$export$4f0175d9150f8767 = ({ fieldType: fieldType, fieldName: fieldName, fieldId: fieldId, fieldProps: fieldProps, issueExtensionData: issueExtensionData, renderContext: renderContext, extension: extension, description: rawDescription, experience: experience })=>{
    const { onChange: onChange, value: value, error: error } = fieldProps;
    const extensionPayload = (0, $eJOHy.useMemo)(()=>{
        if (value === undefined) return {
            fieldValue: null
        };
        return {
            fieldValue: (0, $g2eay.transformValueToExtensionData)(value, extension)
        };
    }, [
        extension,
        value
    ]);
    const extensionData = (0, $7jTnu.fg)('ditto-fcf-support-new-manifest-on-frontend') ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eJOHy.useMemo)(()=>{
        const defaultExtensionData = {
            fieldId: fieldId,
            fieldType: (0, $gPU3b.isForgeLegacyFieldType)(fieldType) ? (0, $gPU3b.getExtensionIdFromLegacyFieldType)(fieldType) ?? fieldType : fieldType,
            fieldName: fieldName,
            renderContext: renderContext,
            experience: experience
        };
        if (!issueExtensionData) return defaultExtensionData;
        return {
            ...defaultExtensionData,
            ...issueExtensionData
        };
    }, [
        issueExtensionData,
        fieldId,
        fieldName,
        fieldType,
        renderContext,
        experience
    ]) : // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eJOHy.useMemo)(()=>{
        const defaultExtensionData = {
            fieldId: fieldId,
            fieldType: (0, $gPU3b.isForgeLegacyFieldType)(fieldType) ? (0, $gPU3b.getExtensionIdFromLegacyFieldType)(fieldType) ?? fieldType : fieldType,
            fieldName: fieldName,
            renderContext: renderContext
        };
        if (!issueExtensionData) return defaultExtensionData;
        return {
            ...defaultExtensionData,
            ...issueExtensionData
        };
    }, [
        issueExtensionData,
        fieldId,
        fieldName,
        fieldType,
        renderContext
    ]);
    const analyticsAttributes = (0, $eJOHy.useMemo)(()=>({
            renderContext: renderContext,
            fieldType: extension?.properties.type,
            module: extension?.type,
            ...extension ? (0, $52lsd.getAnalyticsAttributesFromExtension)(extension) : {}
        }), [
        extension,
        renderContext
    ]);
    if (!extension) return null;
    const { environment: environment, description: description } = (0, $a8VxX.extractEnvFromFieldDescription)(rawDescription || '');
    const renderFieldMessage = (err)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cO6Bh.FieldMessage), {
            description: description,
            error: err,
            fieldName: fieldName
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cDJ0f.Label), {
        htmlFor: `${fieldId}-field`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b70bc7fb78fce255$var$ForgeLabel, null, fieldName, " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iMZxW.EnvironmentLozenge), {
        environmentType: environment
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hdJ4q.EditMode), {
        extension: extension,
        extensionData: extensionData,
        extensionPayload: extensionPayload,
        analyticsAttributes: analyticsAttributes,
        onChange: onChange
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aXssw.ForgeFieldMessage), {
        error: error,
        fieldId: fieldId,
        renderFieldMessage: renderFieldMessage
    }));
};
const $b70bc7fb78fce255$export$34a15d6027142c62 = (props)=>{
    const { extension: extension } = props;
    const analyticsAttributes = (0, $eJOHy.useMemo)(()=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        ({
            renderContext: props.renderContext,
            ...extension && (0, $52lsd.getAnalyticsAttributesFromExtension)(extension)
        }), [
        extension,
        props.renderContext
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $efBOp.EditAnalyticsWrapper), {
        attributes: analyticsAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        paddingBlockEnd: "space.075",
        xcss: $b70bc7fb78fce255$var$fieldContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b70bc7fb78fce255$export$4f0175d9150f8767, props)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b70bc7fb78fce255$var$ForgeLabel = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c8140y _zulpu2gc _1e0c116y _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $b70bc7fb78fce255$var$fieldContainerStyles = (0, $1DXK0.xcss)({
    width: '100%'
});

});
parcelRegister("efBOp", function(module, exports) {

$parcel$export(module.exports, "ViewAnalyticsWrapper", () => $1a197a670eb630fd$export$c794eb4124961145);
$parcel$export(module.exports, "EditAnalyticsWrapper", () => $1a197a670eb630fd$export$947ae3996b2bc000);

var $eJOHy = parcelRequire("eJOHy");

var $fohjD = parcelRequire("fohjD");

var $aeOhE = parcelRequire("aeOhE");
const $1a197a670eb630fd$export$c794eb4124961145 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aeOhE.ForgeAnalyticsWrapper), {
        module: (0, $fohjD.CUSTOM_FIELD_MODULE),
        shouldFireInitializedEvent: true,
        ...props
    });
const $1a197a670eb630fd$export$947ae3996b2bc000 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aeOhE.ForgeAnalyticsWrapper), {
        module: (0, $fohjD.CUSTOM_FIELD_MODULE),
        entryPoint: (0, $fohjD.ENTRY_POINT_EDIT),
        ...props
    });

});

parcelRegister("a8VxX", function(module, exports) {

$parcel$export(module.exports, "extractEnvFromFieldDescription", () => $cb121d8aaa0a2b7e$export$dfa36573f3bd00af);
const $cb121d8aaa0a2b7e$var$DEV_PREFIX = '(DEVELOPMENT) ';
const $cb121d8aaa0a2b7e$var$STG_PREFIX = '(STAGING) ';
const $cb121d8aaa0a2b7e$export$dfa36573f3bd00af = (descriptionWithEnv = '')=>{
    if (descriptionWithEnv?.startsWith($cb121d8aaa0a2b7e$var$DEV_PREFIX)) return {
        environment: 'DEVELOPMENT',
        description: descriptionWithEnv.replace($cb121d8aaa0a2b7e$var$DEV_PREFIX, '')
    };
    if (descriptionWithEnv?.startsWith($cb121d8aaa0a2b7e$var$STG_PREFIX)) return {
        environment: 'STAGING',
        description: descriptionWithEnv.replace($cb121d8aaa0a2b7e$var$STG_PREFIX, '')
    };
    return {
        environment: 'PRODUCTION',
        description: descriptionWithEnv ?? ''
    };
};

});

parcelRegister("cO6Bh", function(module, exports) {

$parcel$export(module.exports, "FieldMessage", () => $325225ea53f53c39$export$eb5013679a5d3f69);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $8DB98 = parcelRequire("8DB98");

var $fKXve = parcelRequire("fKXve");

var $eJ9f5 = parcelRequire("eJ9f5");

var $ix0Ab = parcelRequire("ix0Ab");

var $c9lZd = parcelRequire("c9lZd");

var $lRq8t = parcelRequire("lRq8t");

var $l7iSF = parcelRequire("l7iSF");

var $eF6kk = parcelRequire("eF6kk");
const $325225ea53f53c39$var$featureFlags = {
    codeBidiWarnings: true,
    'code-bidi-warnings': true,
    'renderer-tti-tracking': true,
    'allow-windowed-code-block': true
};
const $325225ea53f53c39$var$FieldHelpLink = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldHelpTextUrl: fieldHelpTextUrl, onLinkClickEvent: onLinkClickEvent })=>{
    const learnMoreMessage = (0, $eF6kk.getLearnMoreMessage)(fieldHelpTextUrl);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
        href: fieldHelpTextUrl,
        target: "_blank",
        onClick: (e)=>onLinkClickEvent(e, fieldHelpTextUrl)
    }, formatMessage(learnMoreMessage));
});
const $325225ea53f53c39$export$eb5013679a5d3f69 = (props)=>{
    const emojiProvider = (0, $c9lZd.useEmojiProvider)();
    const { error: error, fieldName: fieldName, description: description = '', fieldHelpTextUrl: fieldHelpTextUrl = '', onLinkClickEvent: onLinkClickEvent } = props;
    const { formatMessage: formatMessage, formatNumber: formatNumber } = (0, $lRq8t.default)();
    const eventHandlers = (0, $eJOHy.useMemo)(()=>({
            smartCard: {
                onClick: (0, $l7iSF.onLinkClick)
            },
            link: {
                onClick: onLinkClickEvent || ((event, url)=>{
                    const eventTarget = event.target;
                    if ((0, $eF6kk.getLearnMoreMessage)(fieldHelpTextUrl) && url === fieldHelpTextUrl && eventTarget instanceof HTMLAnchorElement) {
                        eventTarget.target = '_blank';
                        return;
                    }
                    (0, $l7iSF.onLinkClick)(event, url);
                })
            }
        }), [
        fieldHelpTextUrl,
        onLinkClickEvent
    ]);
    const document = (0, $eJOHy.useMemo)(()=>{
        if (error) return null;
         // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return (0, $eF6kk.adfDocument)({
            description: description
        });
    }, [
        description,
        error
    ]);
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fKXve.ErrorMessage), null, (0, $eF6kk.getErrorMessage)(error, fieldName, formatMessage, formatNumber));
    if (!document && !fieldHelpTextUrl) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($325225ea53f53c39$var$Description, {
        key: `${fieldName}-field-message`
    }, document && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ix0Ab.default // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    ), {
        document: document,
        dataProviders: emojiProvider,
        schema: (0, $8DB98.defaultSchema),
        disableHeadingIDs: true,
        featureFlags: $325225ea53f53c39$var$featureFlags,
        truncated: false,
        eventHandlers: eventHandlers,
        smartLinks: (0, $l7iSF.smartLinksDefault)
    }), fieldHelpTextUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($325225ea53f53c39$var$FieldHelpLink, {
        fieldHelpTextUrl: fieldHelpTextUrl,
        onLinkClickEvent: eventHandlers.link.onClick
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $325225ea53f53c39$var$Description = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1f1hdcr7 _woio131l _13od1b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ix0Ab", function(module, exports) {

$parcel$export(module.exports, "default", () => $7653122e837526a6$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $8DB98 = parcelRequire("8DB98");

var $1RDZV = parcelRequire("1RDZV");
var $6Ramj = parcelRequire("6Ramj");

var $iZVrE = parcelRequire("iZVrE");
var $jjlK8 = parcelRequire("jjlK8");
var $93FVZ = parcelRequire("93FVZ");
var $2bEPZ = parcelRequire("2bEPZ");
var $lilfD = parcelRequire("lilfD");

var $92xoS = parcelRequire("92xoS");

var $1NIU8 = parcelRequire("1NIU8");

var $7EdFW = parcelRequire("7EdFW");

var $hvjqZ = parcelRequire("hvjqZ");

var $65rqJ = parcelRequire("65rqJ");

var $Sk9g1 = parcelRequire("Sk9g1");

var $dyNYh = parcelRequire("dyNYh");
var $LjYWw = parcelRequire("LjYWw");

var $eGOwo = parcelRequire("eGOwo");

var $bgewf = parcelRequire("bgewf");

var $eUaD0 = parcelRequire("eUaD0");

var $bMFKb = parcelRequire("bMFKb");

var $jgFE8 = parcelRequire("jgFE8");

var $8KLBw = parcelRequire("8KLBw");

var $aYybS = parcelRequire("aYybS");
var $fjfmN = parcelRequire("fjfmN");

var $bdjbf = parcelRequire("bdjbf");

var $7ueoK = parcelRequire("7ueoK");

var $4SRvD = parcelRequire("4SRvD");

var $iOvh6 = parcelRequire("iOvh6");

var $RTnFt = parcelRequire("RTnFt");

var $g9wjI = parcelRequire("g9wjI");

var $4Z9bh = parcelRequire("4Z9bh");

var $dZ1mQ = parcelRequire("dZ1mQ");

var $jzI2h = parcelRequire("jzI2h");

var $csUn2 = parcelRequire("csUn2");

var $7DXmb = parcelRequire("7DXmb");

var $khi07 = parcelRequire("khi07");

var $hQy2y = parcelRequire("hQy2y");

var $86V7W = parcelRequire("86V7W");


var $fC4S5 = parcelRequire("fC4S5");

var $2uPUs = parcelRequire("2uPUs");

var $bVKVd = parcelRequire("bVKVd");

var $c3ajv = parcelRequire("c3ajv");

var $goISJ = parcelRequire("goISJ");

var $8AF0U = parcelRequire("8AF0U");

var $jWNZR = parcelRequire("jWNZR");
function $7653122e837526a6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7653122e837526a6$export$47b2879ca9bbf67a = 2000;
const $7653122e837526a6$export$1b622068be977101 = 3000;
const $7653122e837526a6$var$packageName = "platform-pkg";
const $7653122e837526a6$var$packageVersion = "0.0.0-use.local";
const $7653122e837526a6$var$setAsQueryContainerStyles = {
    name: "3qfej8",
    styles: "container-name:ak-renderer-wrapper;container-type:inline-size"
};
const $7653122e837526a6$var$handleMouseTripleClickInTables = (event)=>{
    if ((0, $7EdFW.browser).ios || (0, $7EdFW.browser).android) return;
    const badBrowser = (0, $7EdFW.browser).chrome || (0, $7EdFW.browser).safari;
    const tripleClick = event.detail >= 3;
    if (!(badBrowser && tripleClick)) return;
    const selection = window.getSelection();
    if (!selection) return;
    const { type: type, anchorNode: anchorNode, focusNode: focusNode } = selection;
    const rangeSelection = Boolean(type === 'Range' && anchorNode && focusNode);
    if (!rangeSelection) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const target = event.target;
    const tableCell = target.closest('td,th');
    const clickedInCell = Boolean(tableCell);
    if (!clickedInCell) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const anchorInCell = tableCell.contains(anchorNode);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const focusInCell = tableCell.contains(focusNode);
    const selectionStartsOrEndsOutsideClickedCell = !(anchorInCell && focusInCell);
    if (!selectionStartsOrEndsOutsideClickedCell) return;
    // Ensure that selecting text in the renderer doesn't trigger onUnhandledClick
    // This logic originated in jira-frontend:
    // src/packages/issue/issue-view/src/views/field/rich-text/rich-text-inline-edit-view.js
    // The selection is required to be checked in `onMouseDown` and here. If not here, a new
    // selection isn't reported; if not in `onMouseDown`, a click outside the selection will
    // return an empty selection, which will erroneously fire onUnhandledClick.
    const elementToSelect = anchorInCell ? // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    anchorNode.parentElement?.closest('div,p') : focusInCell ? // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    focusNode.parentElement?.closest('div,p') : tableCell;
    if (elementToSelect) selection.selectAllChildren(elementToSelect);
};
/**
 * Handle clicks inside renderer. If the click isn't on media, in the media picker, or on a
 * link, call the onUnhandledClick eventHandler (which in Jira for example, may switch the
 * renderer out for the editor).
 * @param event Click event anywhere inside renderer
 * @param props
 * @param mouseDownSelection
 * @example
 */ const $7653122e837526a6$var$handleWrapperOnClick = (event, props, mouseDownSelection)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const targetElement = event.target;
    $7653122e837526a6$var$handleMouseTripleClickInTables(event);
    // ED-14862: When a user triple clicks to select a line of content inside a
    // a table cell, but the browser incorrectly moves the selection start or end into
    // a different table cell, we manually set the selection back to within the original
    // table cell the user intended to target
    if (!props.eventHandlers?.onUnhandledClick) return;
    if (!(targetElement instanceof window.Element)) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const rendererWrapper = event.currentTarget;
    const isInteractiveElementInTree = (0, $g9wjI.findInTree)(targetElement, rendererWrapper, (0, $hQy2y.isInteractiveElement));
    if (isInteractiveElementInTree) return;
    // Ensure that selecting text in the renderer doesn't trigger onUnhandledClick
    // This logic originated in jira-frontend:
    // src/packages/issue/issue-view/src/views/field/rich-text/rich-text-inline-edit-view.js
    // The selection is required to be checked in `onMouseDown` and here. If not here, a new
    // selection isn't reported; if not in `onMouseDown`, a click outside the selection will
    // return an empty selection, which will erroneously fire onUnhandledClick.
    const windowSelection = window.getSelection();
    const selection = windowSelection !== null ? windowSelection.toString() : undefined;
    const hasSelection = selection && selection.length !== 0;
    const hasSelectionMouseDown = mouseDownSelection.current && mouseDownSelection.current.length !== 0;
    const allowEditBasedOnSelection = !hasSelection && !hasSelectionMouseDown;
    if (allowEditBasedOnSelection) props.eventHandlers.onUnhandledClick(event);
};
const $7653122e837526a6$export$c49fe2316038f3c2 = (props)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = props;
    const mouseDownSelection = (0, $eJOHy.useRef)(undefined);
    const providerFactory = (0, $eJOHy.useMemo)(()=>props.dataProviders || new (0, $1RDZV.default)(), [
        props.dataProviders
    ]);
    const createRendererContext = (0, $eJOHy.useMemo)(()=>(featureFlags, isTopLevelRenderer)=>{
            const normalizedFeatureFlags = (0, $jgFE8.normalizeFeatureFlags)(featureFlags);
            return {
                featureFlags: normalizedFeatureFlags,
                isTopLevelRenderer: isTopLevelRenderer === undefined
            };
        }, []);
    const fireAnalyticsEventOld = (0, $eJOHy.useCallback)((event)=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = props;
        if (createAnalyticsEvent) {
            const channel = (0, $bgewf.FabricChannel).editor;
            createAnalyticsEvent(event).fire(channel);
        }
    }, [
        props
    ]);
    const fireAnalyticsEventNew = (0, $eJOHy.useCallback)((event)=>{
        if (createAnalyticsEvent) {
            const channel = (0, $bgewf.FabricChannel).editor;
            createAnalyticsEvent(event).fire(channel);
        }
    }, [
        createAnalyticsEvent
    ]);
    const fireAnalyticsEvent = (0, $92xoS.editorExperiment)('platform_renderer_fix_analytics_memo_callback', true, {
        exposure: true
    }) ? fireAnalyticsEventNew : fireAnalyticsEventOld;
    const deriveSerializerProps = (0, $eJOHy.useCallback)((props)=>{
        const stickyHeaders = props.stickyHeaders ? props.stickyHeaders === true ? {} : props.stickyHeaders : undefined;
        const { annotationProvider: annotationProvider } = props;
        const allowAnnotationsDraftMode = Boolean(annotationProvider && annotationProvider.inlineComment && annotationProvider.inlineComment.allowDraftMode);
        const { featureFlags: featureFlags } = createRendererContext(props.featureFlags, props.isTopLevelRenderer);
        return {
            startPos: props.startPos ?? 0,
            providers: providerFactory,
            eventHandlers: props.eventHandlers,
            extensionHandlers: props.extensionHandlers,
            portal: props.portal,
            objectContext: {
                adDoc: props.shouldRemoveEmptySpaceAroundContent ? (0, $goISJ.removeEmptySpaceAroundContent)(props.document) : props.document,
                schema: props.schema,
                ...props.rendererContext
            },
            appearance: props.appearance,
            disableHeadingIDs: props.disableHeadingIDs,
            disableActions: props.disableActions,
            allowHeadingAnchorLinks: props.allowHeadingAnchorLinks,
            allowColumnSorting: props.allowColumnSorting,
            fireAnalyticsEvent: fireAnalyticsEvent,
            shouldOpenMediaViewer: props.shouldOpenMediaViewer,
            allowAltTextOnImages: props.allowAltTextOnImages,
            stickyHeaders: stickyHeaders,
            allowMediaLinking: props.media && props.media.allowLinking,
            surroundTextNodesWithTextWrapper: allowAnnotationsDraftMode,
            media: props.media,
            emojiResourceConfig: props.emojiResourceConfig,
            smartLinks: props.smartLinks,
            extensionViewportSizes: props.extensionViewportSizes,
            allowCopyToClipboard: props.allowCopyToClipboard,
            allowWrapCodeBlock: props.allowWrapCodeBlock,
            allowCustomPanels: props.allowCustomPanels,
            allowAnnotations: props.allowAnnotations,
            allowSelectAllTrap: props.allowSelectAllTrap,
            allowPlaceholderText: props.allowPlaceholderText,
            nodeComponents: props.nodeComponents,
            allowWindowedCodeBlock: featureFlags?.allowWindowedCodeBlock,
            isInsideOfInlineExtension: props.isInsideOfInlineExtension,
            isPresentational: props.UNSTABLE_isPresentational,
            textHighlighter: props.textHighlighter || props.UNSTABLE_textHighlighter,
            allowTableAlignment: props.UNSTABLE_allowTableAlignment,
            allowTableResizing: props.UNSTABLE_allowTableResizing,
            disableTableOverflowShadow: props.disableTableOverflowShadow
        };
    }, [
        createRendererContext,
        providerFactory,
        fireAnalyticsEvent
    ]);
    const serializer = (0, $8AF0U.useMemoFromPropsDerivative)((serializerProps)=>{
        // If progressive rendering is enabled, create a new serializer
        if ((0, $eGOwo.fg)('cc_complexit_fe_progressive_adf_rendering')) {
            const newSerializer = props.createSerializer?.(serializerProps);
            if (newSerializer) return newSerializer;
        }
        return new (0, $aYybS.default)(serializerProps);
    }, deriveSerializerProps, props);
    const localRef = (0, $eJOHy.useRef)(null);
    const editorRef = props.innerRef || localRef;
    const id = (0, $eJOHy.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($8KLBw)))(), []);
    const renderedMeasurementDistortedDurationMonitor = (0, $eJOHy.useMemo)(()=>(0, $65rqJ.getDistortedDurationMonitor)(), []);
    // we are doing this to ensure it runs as
    // early as possible in the React lifecycle
    // to avoid any other side effects
    const measureStarted = (0, $eJOHy.useRef)(false);
    const startAnalyticsMeasure = ()=>{
        (0, $hvjqZ.startMeasure)(`Renderer Render Time: ${id}`);
    };
    if (!measureStarted.current) {
        startAnalyticsMeasure();
        measureStarted.current = true;
    }
    const anchorLinkAnalytics = (0, $eJOHy.useCallback)(()=>{
        const hash = window.location.hash && decodeURIComponent(window.location.hash.slice(1));
        const disableHeadingIDs = props.disableHeadingIDs;
        if (!disableHeadingIDs && hash && editorRef && editorRef.current instanceof HTMLElement) {
            const anchorLinkElement = document.getElementById(hash);
            if (anchorLinkElement && editorRef.current.contains(anchorLinkElement)) fireAnalyticsEvent({
                action: (0, $bMFKb.ACTION).VIEWED,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).ANCHOR_LINK,
                attributes: {
                    platform: (0, $7ueoK.PLATFORM).WEB,
                    mode: (0, $7ueoK.MODE).RENDERER
                },
                eventType: (0, $bMFKb.EVENT_TYPE).UI
            });
        }
    }, [
        props.disableHeadingIDs,
        editorRef,
        fireAnalyticsEvent
    ]);
    const getSchema = (0, $eJOHy.useMemo)(()=>{
        return (schema, adfStage)=>{
            if (schema) return schema;
            return (0, $8DB98.getSchemaBasedOnStage)(adfStage);
        };
    }, []);
    const onMouseDownEditView = ()=>{
        const windowSelection = window.getSelection();
        mouseDownSelection.current = windowSelection !== null ? windowSelection.toString() : undefined;
    };
    const { dataProviders: dataProviders, analyticsEventSeverityTracking: analyticsEventSeverityTracking } = props;
    (0, $eJOHy.useEffect)(()=>{
        let rafID;
        const handleAnalytics = ()=>{
            fireAnalyticsEvent({
                action: (0, $bMFKb.ACTION).STARTED,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).RENDERER,
                attributes: {
                    platform: (0, $7ueoK.PLATFORM).WEB
                },
                eventType: (0, $bMFKb.EVENT_TYPE).UI
            });
            rafID = requestAnimationFrame(()=>{
                (0, $hvjqZ.stopMeasure)(`Renderer Render Time: ${id}`, (duration)=>{
                    const forceSeverityTracking = typeof analyticsEventSeverityTracking === 'undefined' && (0, $LjYWw.shouldForceTracking)();
                    const severity = !!forceSeverityTracking || analyticsEventSeverityTracking?.enabled ? (0, $dyNYh.getAnalyticsEventSeverity)(duration, analyticsEventSeverityTracking?.severityNormalThreshold ?? $7653122e837526a6$export$47b2879ca9bbf67a, analyticsEventSeverityTracking?.severityDegradedThreshold ?? $7653122e837526a6$export$1b622068be977101) : undefined;
                    const isTTRTrackingExplicitlyDisabled = analyticsEventSeverityTracking?.enabled === false;
                    if (!isTTRTrackingExplicitlyDisabled) fireAnalyticsEvent({
                        action: (0, $bMFKb.ACTION).RENDERED,
                        actionSubject: (0, $bMFKb.ACTION_SUBJECT).RENDERER,
                        attributes: {
                            platform: (0, $7ueoK.PLATFORM).WEB,
                            duration: duration,
                            // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            distortedDuration: renderedMeasurementDistortedDurationMonitor.distortedDuration,
                            ttfb: (0, $Sk9g1.getResponseEndTime)(),
                            nodes: (0, $86V7W.countNodes)(props.document),
                            severity: severity
                        },
                        eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL
                    });
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    renderedMeasurementDistortedDurationMonitor.cleanup();
                });
                anchorLinkAnalytics();
            });
        };
        handleAnalytics();
        return ()=>{
            if (rafID) window.cancelAnimationFrame(rafID);
            // if this is the ProviderFactory which was created in constructor
            // it's safe to destroy it on Renderer unmount
            // updated to match existing class component
            if (!dataProviders) providerFactory.destroy();
        };
    // we are going to ignore this because I'm doing this on purpose
    // having a dependency array means we run stopMeasure twice per render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const rendererContext = (0, $eJOHy.useMemo)(()=>createRendererContext(props.featureFlags, props.isTopLevelRenderer), [
        props.featureFlags,
        props.isTopLevelRenderer,
        createRendererContext
    ]);
    try {
        const schema = getSchema(props.schema, props.adfStage);
        const { result: result, stat: stat, pmDoc: pmDoc } = (0, $fjfmN.renderDocument)(props.shouldRemoveEmptySpaceAroundContent ? (0, $goISJ.removeEmptySpaceAroundContent)(props.document) : props.document, serializer, schema, props.adfStage, props.useSpecBasedValidator, id, fireAnalyticsEvent, props.unsupportedContentLevelsTracking, props.appearance, props.includeNodesCountInStats, props.skipValidation, props.validationOverrides);
        if (props.onComplete) props.onComplete(stat);
        const rendererOutput = /*#__PURE__*/ (0, $1NIU8.jsx)((0, $RTnFt.RendererContextProvider), {
            value: rendererContext
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $jzI2h.ActiveHeaderIdProvider), {
            value: (0, $iOvh6.getActiveHeadingId)(props.allowHeadingAnchorLinks)
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $bdjbf.default).Provider, {
            value: {
                fireAnalyticsEvent: (event)=>fireAnalyticsEvent(event)
            }
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $dZ1mQ.Provider), null, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $6Ramj.ProviderFactoryProvider), {
            value: providerFactory
        }, /*#__PURE__*/ (0, $1NIU8.jsx)($7653122e837526a6$var$RendererWrapper, {
            allowAnnotations: props.allowAnnotations,
            appearance: props.appearance,
            allowNestedHeaderLinks: (0, $iOvh6.isNestedHeaderLinksEnabled)(props.allowHeadingAnchorLinks),
            allowColumnSorting: props.allowColumnSorting,
            allowCopyToClipboard: props.allowCopyToClipboard,
            allowWrapCodeBlock: props.allowWrapCodeBlock,
            allowCustomPanels: props.allowCustomPanels,
            allowPlaceholderText: props.allowPlaceholderText,
            useBlockRenderForCodeBlock: rendererContext.featureFlags.useBlockRenderForCodeBlock ?? true,
            addTelepointer: props.addTelepointer,
            innerRef: editorRef,
            onClick: (event)=>$7653122e837526a6$var$handleWrapperOnClick(event, props, mouseDownSelection),
            onMouseDown: onMouseDownEditView,
            ssr: props.media?.ssr,
            isInsideOfInlineExtension: props.isInsideOfInlineExtension,
            isTopLevelRenderer: rendererContext.isTopLevelRenderer,
            shouldRemoveEmptySpaceAroundContent: props.shouldRemoveEmptySpaceAroundContent,
            allowRendererContainerStyles: props.allowRendererContainerStyles
        }, props.enableSsrInlineScripts || props.noOpSSRInlineScript ? /*#__PURE__*/ (0, $1NIU8.jsx)((0, $khi07.BreakoutSSRInlineScript), {
            noOpSSRInlineScript: Boolean(props.noOpSSRInlineScript)
        }) : null, /*#__PURE__*/ (0, $1NIU8.jsx)($7653122e837526a6$var$RendererActionsInternalUpdater, {
            doc: pmDoc,
            schema: schema,
            onAnalyticsEvent: fireAnalyticsEvent
        }, result)))))));
        const rendererResult = props.truncated ? /*#__PURE__*/ (0, $1NIU8.jsx)((0, $fC4S5.TruncatedWrapper), {
            height: props.maxHeight,
            fadeHeight: props.fadeOutHeight
        }, rendererOutput) : rendererOutput;
        return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Fragment), null, rendererResult);
    } catch (e) {
        if (props.onError) props.onError(e);
        return /*#__PURE__*/ (0, $1NIU8.jsx)($7653122e837526a6$var$RendererWrapper, {
            allowAnnotations: props.allowAnnotations,
            appearance: props.appearance,
            allowCopyToClipboard: props.allowCopyToClipboard,
            allowWrapCodeBlock: props.allowWrapCodeBlock,
            allowPlaceholderText: props.allowPlaceholderText,
            allowColumnSorting: props.allowColumnSorting,
            allowNestedHeaderLinks: (0, $iOvh6.isNestedHeaderLinksEnabled)(props.allowHeadingAnchorLinks),
            useBlockRenderForCodeBlock: rendererContext.featureFlags.useBlockRenderForCodeBlock ?? true,
            addTelepointer: props.addTelepointer,
            onClick: (event)=>$7653122e837526a6$var$handleWrapperOnClick(event, props, mouseDownSelection),
            isTopLevelRenderer: rendererContext.isTopLevelRenderer,
            allowRendererContainerStyles: props.allowRendererContainerStyles
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $93FVZ.default), null));
    }
};
const $7653122e837526a6$var$RendererFunctionalComponentMemoized = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo($7653122e837526a6$export$c49fe2316038f3c2);
const $7653122e837526a6$var$RendererFunctionalComponentWithPortalContext = (props)=>{
    const { portal: portal, ...propsWithoutPortal } = props;
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $jWNZR.PortalContext).Provider, {
        value: portal
    }, /*#__PURE__*/ (0, $1NIU8.jsx)($7653122e837526a6$export$c49fe2316038f3c2, propsWithoutPortal));
};
const $7653122e837526a6$var$RendererFunctionalComponentWithPortalContextMemoized = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo($7653122e837526a6$var$RendererFunctionalComponentWithPortalContext);
const $7653122e837526a6$var$getRendererComponent = (nodeComponents)=>{
    // If nodeComponents are provided, for now we don't want to remove portal from props
    // and use context instead because at this time we cannot guarantee that existing
    // consumers of Atlaskit Renderer will update to use the new portal context.
    if (!Boolean(nodeComponents) && (0, $eGOwo.fg)('cc_complexit_reduce_portal_rerenders')) return $7653122e837526a6$var$RendererFunctionalComponentWithPortalContextMemoized;
    return $7653122e837526a6$var$RendererFunctionalComponentMemoized;
};
function $7653122e837526a6$export$88530751e3977073(props) {
    const { startPos: startPos } = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useContext((0, $csUn2.AnnotationsPositionContext));
    const { isTopLevelRenderer: isTopLevelRenderer } = (0, $RTnFt.useRendererContext)();
    const { skipValidation: skipValidation, allowNestedTables: allowNestedTables } = (0, $eJOHy.useContext)((0, $2uPUs.ValidationContext)) || {};
    const validationOverrides = (0, $eJOHy.useMemo)(()=>({
            allowNestedTables: allowNestedTables
        }), [
        allowNestedTables
    ]);
    const RendererComponent = $7653122e837526a6$var$getRendererComponent(props.nodeComponents);
    return /*#__PURE__*/ (0, $1NIU8.jsx)(RendererComponent, {
        ...props,
        startPos: startPos,
        isTopLevelRenderer: // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        (0, $eGOwo.fg)('issue_table_single_line_row_height_fast_follows') ? props.isTopLevelRenderer ?? isTopLevelRenderer : isTopLevelRenderer,
        skipValidation: skipValidation,
        validationOverrides: (0, $eGOwo.fg)('cc_complexit_fe_reduce_rerender_2') ? validationOverrides : {
            allowNestedTables: allowNestedTables
        }
    });
}
const $7653122e837526a6$export$af81ffb59b6ef0dd = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo((props)=>/*#__PURE__*/ (0, $1NIU8.jsx)((0, $eUaD0.FabricEditorAnalyticsContext), {
        data: {
            appearance: (0, $dyNYh.getAnalyticsAppearance)(props.appearance),
            packageName: $7653122e837526a6$var$packageName,
            packageVersion: $7653122e837526a6$var$packageVersion,
            componentName: 'renderer',
            editorSessionId: (0, (/*@__PURE__*/$parcel$interopDefault($8KLBw)))()
        }
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $lilfD.WithCreateAnalyticsEvent), {
        render: (createAnalyticsEvent)=>{
            // `IntlErrorBoundary` only captures Internationalisation errors, leaving others for `ErrorBoundary`.
            return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $7DXmb.ErrorBoundary), {
                component: (0, $bMFKb.ACTION_SUBJECT).RENDERER,
                rethrowError: true,
                fallbackComponent: null,
                createAnalyticsEvent: createAnalyticsEvent
            }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $jjlK8.IntlErrorBoundary), null, /*#__PURE__*/ (0, $1NIU8.jsx)($7653122e837526a6$export$88530751e3977073, {
                ...props,
                createAnalyticsEvent: createAnalyticsEvent
            })));
        }
    })));
const $7653122e837526a6$var$RendererWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo((props)=>{
    const { allowColumnSorting: allowColumnSorting, allowNestedHeaderLinks: allowNestedHeaderLinks, innerRef: innerRef, appearance: appearance, children: children, onClick: onClick, onMouseDown: onMouseDown, useBlockRenderForCodeBlock: useBlockRenderForCodeBlock, addTelepointer: addTelepointer, ssr: ssr, isInsideOfInlineExtension: isInsideOfInlineExtension, allowTableResizing: allowTableResizing, isTopLevelRenderer: isTopLevelRenderer, allowRendererContainerStyles: allowRendererContainerStyles } = props;
    const createTelepointer = ()=>{
        const telepointer = document.createElement('span');
        telepointer.textContent = '\u200b';
        telepointer.id = (0, $9a762f515f769003$export$74b525449cc7cbd1);
        return telepointer;
    };
    const initialUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef(true);
    (0, $eJOHy.useEffect)(()=>{
        // We must check if window is defined, if it isn't we are in a SSR environment
        // and we don't want to add the telepointer
        if (typeof window !== 'undefined' && addTelepointer && innerRef?.current) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const renderer = innerRef.current.querySelector('.ak-renderer-document');
            if (initialUpdate.current) {
                const lastChild = renderer.lastChild;
                lastChild && lastChild.appendChild(createTelepointer());
            }
            const mutateTelepointer = (mutations)=>{
                mutations.forEach((mutation)=>{
                    if (initialUpdate.current) {
                        const oldTelepointer = renderer.querySelector(`#${(0, $9a762f515f769003$export$74b525449cc7cbd1)}`);
                        if (oldTelepointer) oldTelepointer.remove();
                        const lastChild = renderer.lastChild;
                        lastChild && lastChild.appendChild(createTelepointer());
                        initialUpdate.current = false;
                    }
                    if (mutation.type === 'characterData') {
                        const parentNode = mutation.target.parentElement;
                        if (parentNode) {
                            const oldTelepointer = renderer.querySelector(`#${(0, $9a762f515f769003$export$74b525449cc7cbd1)}`);
                            if (oldTelepointer) oldTelepointer.remove();
                            // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            parentNode.appendChild(createTelepointer());
                        }
                    }
                });
            };
            const observer = new MutationObserver(mutateTelepointer);
            observer.observe(innerRef.current, {
                characterData: true,
                attributes: false,
                childList: true,
                subtree: true
            });
            return ()=>observer.disconnect();
        }
    }, [
        innerRef,
        addTelepointer
    ]);
    const renderer = /*#__PURE__*/ (0, $1NIU8.jsx)((0, $2bEPZ.WidthProvider), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `ak-renderer-wrapper is-${appearance}`,
        "data-appearance": appearance,
        shouldCheckExistingValue: isInsideOfInlineExtension
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $iZVrE.BaseTheme), {
        baseFontSize: (0, $c3ajv.getBaseFontSize)(appearance)
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $4SRvD.EditorMediaClientProvider), {
        ssr: ssr
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $bVKVd.RendererStyleContainer), {
        innerRef: innerRef,
        onClick: onClick,
        onMouseDown: onMouseDown,
        appearance: appearance,
        allowNestedHeaderLinks: allowNestedHeaderLinks,
        allowColumnSorting: !!allowColumnSorting,
        useBlockRenderForCodeBlock: useBlockRenderForCodeBlock,
        allowAnnotations: props.allowAnnotations,
        allowTableResizing: allowTableResizing,
        allowRendererContainerStyles: allowRendererContainerStyles
    }, children))));
    // We can only make the wrapper div query container when we have a known width.
    // This is also required for SSR to work correctly. As WidthProvider/WithConsumer will not have the correct width during SSR.
    //
    // allowRendererContainerStyles is not needed for comment container styling as container should always be set for comments
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if (appearance === 'comment' && isTopLevelRenderer && (0, $eGOwo.fg)('platform-ssr-table-resize')) return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $7653122e837526a6$var$setAsQueryContainerStyles
    }, renderer);
    // We are setting this wrapper div as query container conditionally.
    // Only apply container-type = inline-size when having a known width in full-page/full-width/comment mode.
    // Otherwise when appearance is unspecified the renderer size is decided by the content.
    // In this case we can't set the container-type = inline-size as it will collapse width to 0.
    return (appearance === 'full-page' || appearance === 'full-width') && // In case of having excerpt-include on page there are multiple renderers nested.
    // Make sure only the root renderer is set to be query container.
    isTopLevelRenderer && allowRendererContainerStyles && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    (0, $eGOwo.fg)('platform-ssr-table-resize') ? /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $7653122e837526a6$var$setAsQueryContainerStyles
    }, renderer) : renderer;
});
const $7653122e837526a6$var$RootRendererContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext(null);
function $7653122e837526a6$var$RendererActionsInternalUpdater({ children: children, doc: doc, schema: schema, onAnalyticsEvent: onAnalyticsEvent }) {
    const rootRendererContextValue = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useContext($7653122e837526a6$var$RootRendererContext);
    const actions = (0, $eJOHy.useContext)((0, $4Z9bh.RendererContext));
    const rendererRef = (0, $eJOHy.useRef)(null);
    // This doc is used by the renderer actions when applying comments to the document.
    // (via hand crafted steps based on non prosemirror based position calculations)
    // It is set to the root renderer's doc as otherwise the resulting document will
    // be incorrect (nested renderers use a fake document which represents a subset
    // of the actual document).
    let _doc;
    if ((0, $92xoS.editorExperiment)('comment_on_bodied_extensions', true) && rootRendererContextValue) // If rootRendererContextValue is set -- we are inside a nested renderer
    // and should always use the doc from the root renderer
    _doc = rootRendererContextValue.doc;
    else // If rootRendererContextValue is not set -- we are in the root renderer
    // and set the doc to the current doc.
    _doc = doc;
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (_doc) actions._privateRegisterRenderer(rendererRef, _doc, schema, onAnalyticsEvent);
        else actions._privateUnregisterRenderer();
        return ()=>actions._privateUnregisterRenderer();
    }, [
        actions,
        schema,
        _doc,
        onAnalyticsEvent
    ]);
    if ((0, $92xoS.editorExperiment)('comment_on_bodied_extensions', true)) return /*#__PURE__*/ (0, $1NIU8.jsx)($7653122e837526a6$var$RootRendererContext.Provider, {
        value: {
            doc: _doc
        }
    }, children);
    return children;
}
// Usage notes:
// Used by Confluence for nested renderers
// For the View page renderer - see RendererWithAnalytics
const $7653122e837526a6$var$RendererWithAnnotationSelection = (props)=>{
    const { allowAnnotations: allowAnnotations, document: adfDocument } = props;
    const localRef = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef(null);
    const innerRef = props.innerRef || localRef;
    if (!allowAnnotations) // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $1NIU8.jsx)($7653122e837526a6$export$af81ffb59b6ef0dd, {
        innerRef: innerRef,
        ...props
    });
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $4Z9bh.RendererActionsContext), null, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $csUn2.AnnotationsWrapper), {
        rendererRef: innerRef,
        adfDocument: adfDocument,
        annotationProvider: props.annotationProvider,
        isNestedRender: true
    }, /*#__PURE__*/ (0, $1NIU8.jsx)($7653122e837526a6$export$af81ffb59b6ef0dd, {
        innerRef: innerRef,
        ...props,
        featureFlags: props.featureFlags
    })));
};
var // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
/* @deprecated using this version of the renderer causes the RendererActions to inaccessible from any consumers */ $7653122e837526a6$export$2e2bcd8739ae039 = $7653122e837526a6$var$RendererWithAnnotationSelection;

});
parcelRegister("1RDZV", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0fcdaf71392d1b2$export$2e2bcd8739ae039);
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $d0fcdaf71392d1b2$var$isUndefined(x) {
    return x === undefined;
}
class $d0fcdaf71392d1b2$export$2e2bcd8739ae039 {
    static create(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    providers) {
        const providerFactory = new $d0fcdaf71392d1b2$export$2e2bcd8739ae039();
        const keys = Object.keys(providers);
        keys.forEach((name)=>{
            providerFactory.setProvider(name, providers[name]);
        });
        return providerFactory;
    }
    destroy() {
        this.providers.clear();
        this.subscribers.clear();
    }
    isEmpty() {
        return !this.providers.size && !this.subscribers.size;
    }
    setProvider(name, provider) {
        // Do not trigger notifyUpdate if provider is the same.
        if (this.providers.get(name) === provider) return;
        if (!$d0fcdaf71392d1b2$var$isUndefined(provider)) this.providers.set(name, provider);
        else this.providers.delete(name);
        this.notifyUpdated(name, provider);
    }
    removeProvider(name) {
        this.providers.delete(name);
        this.notifyUpdated(name);
    }
    subscribe(name, handler) {
        const handlers = this.subscribers.get(name) || [];
        handlers.push(handler);
        this.subscribers.set(name, handlers);
        const provider = this.providers.get(name);
        if (provider) handler(name, provider);
        return provider;
    }
    unsubscribe(name, handler) {
        const handlers = this.subscribers.get(name);
        if (!handlers) return;
        const index = handlers.indexOf(handler);
        if (index !== -1) handlers.splice(index, 1);
        if (handlers.length === 0) this.subscribers.delete(name);
        else this.subscribers.set(name, handlers);
    }
    unsubscribeAll(name) {
        const handlers = this.subscribers.get(name);
        if (!handlers) return;
        this.subscribers.delete(name);
    }
    hasProvider(name) {
        return this.providers.has(name);
    }
    notifyUpdated(name, provider) {
        const handlers = this.subscribers.get(name);
        if (!handlers) return;
        handlers.forEach((handler)=>{
            handler(name, provider);
        });
    }
    constructor(){
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.providers = new Map();
        this.subscribers = new Map();
    }
}

});

parcelRegister("6Ramj", function(module, exports) {

$parcel$export(module.exports, "ProviderFactoryProvider", () => $7ba0a7c04681d272$export$617c134b25cc4265);
$parcel$export(module.exports, "useProvider", () => $7ba0a7c04681d272$export$693cdb10cec23617);
$parcel$export(module.exports, "useProviderLayout", () => $7ba0a7c04681d272$export$6fde1d0d81db98e1);

var $eJOHy = parcelRequire("eJOHy");

var $1RDZV = parcelRequire("1RDZV");
const $7ba0a7c04681d272$var$ProviderFactoryContext = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext(new (0, $1RDZV.default)());
const $7ba0a7c04681d272$export$617c134b25cc4265 = $7ba0a7c04681d272$var$ProviderFactoryContext.Provider;
const $7ba0a7c04681d272$export$a3af4b6980aa23b5 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useContext($7ba0a7c04681d272$var$ProviderFactoryContext);
const $7ba0a7c04681d272$export$693cdb10cec23617 = (name)=>{
    const [provider, setProvider] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState();
    const providerFactory = $7ba0a7c04681d272$export$a3af4b6980aa23b5();
    (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useEffect(()=>{
        const providerHandler = (_, provider)=>{
            setProvider(provider);
        };
        providerFactory.subscribe(name, providerHandler);
        return ()=>{
            providerFactory.unsubscribe(name, providerHandler);
        };
    }, [
        name,
        providerFactory
    ]);
    return provider;
};
const $7ba0a7c04681d272$export$6fde1d0d81db98e1 = (name)=>{
    const [provider, setProvider] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState();
    const providerFactory = $7ba0a7c04681d272$export$a3af4b6980aa23b5();
    (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useLayoutEffect(()=>{
        const providerHandler = (_, provider)=>{
            setProvider(provider);
        };
        providerFactory.subscribe(name, providerHandler);
        return ()=>{
            providerFactory.unsubscribe(name, providerHandler);
        };
    }, [
        name,
        providerFactory
    ]);
    return provider;
};

});

parcelRegister("iZVrE", function(module, exports) {

$parcel$export(module.exports, "mapBreakpointToLayoutMaxWidth", () => $697937b55cdec847$export$b5ccf4d25d2c5af1);
$parcel$export(module.exports, "BaseTheme", () => $697937b55cdec847$export$a1a213d350ca51ca);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $loabE = parcelRequire("loabE");

var $7yBx7 = parcelRequire("7yBx7");

var $2bEPZ = parcelRequire("2bEPZ");
function $697937b55cdec847$export$b5ccf4d25d2c5af1(breakpoint) {
    switch(breakpoint){
        case 'M':
        case 'L':
            return 760;
        default:
            return 680;
    }
}
function $697937b55cdec847$export$3de34996b814f0f0({ baseFontSize: baseFontSize, children: children }) {
    const memoizedTheme = (0, $eJOHy.useMemo)(()=>({
            baseFontSize: baseFontSize || 14,
            layoutMaxWidth: (0, $7yBx7.akEditorDefaultLayoutWidth)
        }), [
        baseFontSize
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $loabE.a), {
        theme: memoizedTheme,
        children: children
    });
}
function $697937b55cdec847$export$a1a213d350ca51ca({ children: children, baseFontSize: baseFontSize }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2bEPZ.WidthConsumer), {
        children: ({ breakpoint: breakpoint })=>/*#__PURE__*/ (0, $gt9Am.jsx)($697937b55cdec847$export$3de34996b814f0f0, {
                breakpoint: breakpoint,
                baseFontSize: baseFontSize,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
                    children: children
                })
            })
    });
}

});
parcelRegister("7yBx7", function(module, exports) {

$parcel$export(module.exports, "akEditorFullPageDefaultFontSize", () => $12e0df67293c076b$export$fe6b0b821a0e9067);
$parcel$export(module.exports, "akEditorCodeFontFamily", () => $12e0df67293c076b$export$9a7c520c39e1f0aa);
$parcel$export(module.exports, "akEditorSubtleAccent", () => $12e0df67293c076b$export$1d762aef048d30f9);
$parcel$export(module.exports, "akEditorBlockquoteBorderColor", () => $12e0df67293c076b$export$a7a75e50ae62d0a8);
$parcel$export(module.exports, "akEditorDeleteBackground", () => $12e0df67293c076b$export$ef95eb6ef0fd0a4a);
$parcel$export(module.exports, "akEditorDeleteBackgroundWithOpacity", () => $12e0df67293c076b$export$8f7d2d784079e274);
$parcel$export(module.exports, "akEditorDeleteBorder", () => $12e0df67293c076b$export$3c108a6bc41bb5f2);
$parcel$export(module.exports, "akEditorDeleteIconColor", () => $12e0df67293c076b$export$bf3aaa2106c119fd);
$parcel$export(module.exports, "akEditorCustomIconSize", () => $12e0df67293c076b$export$d2715266dd4a1fd1);
$parcel$export(module.exports, "akEditorSelectedBorderColor", () => $12e0df67293c076b$export$cf524c1b49838a49);
$parcel$export(module.exports, "akEditorSelectedBorderSize", () => $12e0df67293c076b$export$8dac549e32469ac4);
$parcel$export(module.exports, "akEditorSelectedBorderBoldSize", () => $12e0df67293c076b$export$befaaae517e3d864);
$parcel$export(module.exports, "akEditorSelectedBorder", () => $12e0df67293c076b$export$6e1e1996c4e8cc51);
$parcel$export(module.exports, "akEditorSelectedBoxShadow", () => $12e0df67293c076b$export$b6a59ac3a19b6343);
$parcel$export(module.exports, "akEditorSelectedBoldBoxShadow", () => $12e0df67293c076b$export$37e178ca41c198ca);
$parcel$export(module.exports, "akEditorUnitZIndex", () => $12e0df67293c076b$export$f35cc48f3398ab79);
$parcel$export(module.exports, "akEditorShadowZIndex", () => $12e0df67293c076b$export$b46cda584c619451);
$parcel$export(module.exports, "akEditorStickyHeaderZIndex", () => $12e0df67293c076b$export$6bed85de54b5de42);
$parcel$export(module.exports, "akEditorSmallZIndex", () => $12e0df67293c076b$export$321ddd2f049dd12);
$parcel$export(module.exports, "akEditorGridLineZIndex", () => $12e0df67293c076b$export$daeac9b8422ac3c2);
$parcel$export(module.exports, "akEditorMenuZIndex", () => $12e0df67293c076b$export$501d46e11ed5bf73);
$parcel$export(module.exports, "akEditorFloatingPanelZIndex", () => $12e0df67293c076b$export$6817b4b6a5ef78f1);
$parcel$export(module.exports, "akEditorFloatingDialogZIndex", () => $12e0df67293c076b$export$93768eb72dec48ce);
$parcel$export(module.exports, "akEditorTableCellOnStickyHeaderZIndex", () => $12e0df67293c076b$export$c0aec4e0896849a0);
$parcel$export(module.exports, "akEditorFloatingOverlapPanelZIndex", () => $12e0df67293c076b$export$5886f057e4f21fe4);
$parcel$export(module.exports, "akEditorTableToolbarSize", () => $12e0df67293c076b$export$6e85faa46d537a3f);
$parcel$export(module.exports, "akEditorTableBorder", () => $12e0df67293c076b$export$36ba77fba4a62d5f);
$parcel$export(module.exports, "akEditorTableToolbar", () => $12e0df67293c076b$export$640eef769748f78f);
$parcel$export(module.exports, "akEditorTableHeaderCellBackground", () => $12e0df67293c076b$export$4c6f61fb4b9ae93);
$parcel$export(module.exports, "akEditorTableBorderSelected", () => $12e0df67293c076b$export$f7bbcec54ff5bc47);
$parcel$export(module.exports, "akEditorFullPageMaxWidth", () => $12e0df67293c076b$export$fad19f16d3f953a3);
$parcel$export(module.exports, "akEditorDefaultLayoutWidth", () => $12e0df67293c076b$export$9db045950eedb49f);
$parcel$export(module.exports, "akEditorWideLayoutWidth", () => $12e0df67293c076b$export$74c442132af16a);
$parcel$export(module.exports, "akEditorFullWidthLayoutWidth", () => $12e0df67293c076b$export$f580e3d28d0986de);
$parcel$export(module.exports, "akEditorTableNumberColumnWidth", () => $12e0df67293c076b$export$37df10057d36a0e5);
$parcel$export(module.exports, "akEditorBreakoutPadding", () => $12e0df67293c076b$export$437293c5e9fc2703);
$parcel$export(module.exports, "akEditorGutterPadding", () => $12e0df67293c076b$export$6e0f4d52efd3d2d);
$parcel$export(module.exports, "akEditorGutterPaddingDynamic", () => $12e0df67293c076b$export$f222e0c7a2dc5324);
$parcel$export(module.exports, "akEditorMobileBreakoutPoint", () => $12e0df67293c076b$export$efe8561bbd3f74d2);
$parcel$export(module.exports, "akEditorTableCellMinWidth", () => $12e0df67293c076b$export$e4d39a9e8607c1d3);
$parcel$export(module.exports, "akEditorTableLegacyCellMinWidth", () => $12e0df67293c076b$export$43946f2400ab6f1f);
$parcel$export(module.exports, "akEditorMediaResizeHandlerPaddingWide", () => $12e0df67293c076b$export$558438ae7fd4b8ce);
$parcel$export(module.exports, "akEditorMediaResizeHandlerPadding", () => $12e0df67293c076b$export$6beb98d32d4ca149);
$parcel$export(module.exports, "akEditorSwoopCubicBezier", () => $12e0df67293c076b$export$3b24948cd5dbb087);
$parcel$export(module.exports, "gridMediumMaxWidth", () => $12e0df67293c076b$export$5edb4f38c3eacb1a);
$parcel$export(module.exports, "breakoutWideScaleRatio", () => $12e0df67293c076b$export$e60820063058ed59);
$parcel$export(module.exports, "akEditorCalculatedWideLayoutWidthSmallViewport", () => $12e0df67293c076b$export$60da500206e2ceec);
$parcel$export(module.exports, "akEditorCalculatedWideLayoutWidth", () => $12e0df67293c076b$export$c0e6648ae1bb2fac);
$parcel$export(module.exports, "akRichMediaResizeZIndex", () => $12e0df67293c076b$export$fb15fade89f67217);
$parcel$export(module.exports, "akLayoutGutterOffset", () => $12e0df67293c076b$export$847030921e9d5a40);
$parcel$export(module.exports, "akEditorLineHeight", () => $12e0df67293c076b$export$40eb41ab799f0329);
$parcel$export(module.exports, "akEditorContextPanelWidth", () => $12e0df67293c076b$export$688a6dc01e760755);
$parcel$export(module.exports, "akEditorTableCellBlanketSelected", () => $12e0df67293c076b$export$e736f2caf3b39eb3);
$parcel$export(module.exports, "akEditorTableCellBlanketDeleted", () => $12e0df67293c076b$export$de3cef07cda55645);
$parcel$export(module.exports, "akEditorWrappedNodeZIndex", () => $12e0df67293c076b$export$e88f6c898960b391);
$parcel$export(module.exports, "blockNodesVerticalMargin", () => $12e0df67293c076b$export$1d0d506416d457f1);
$parcel$export(module.exports, "DEFAULT_EMBED_CARD_WIDTH", () => $12e0df67293c076b$export$e683ef42725d1713);
$parcel$export(module.exports, "DEFAULT_EMBED_CARD_HEIGHT", () => $12e0df67293c076b$export$226c784ba04bd04b);
$parcel$export(module.exports, "MAX_BROWSER_SCROLLBAR_HEIGHT", () => $12e0df67293c076b$export$214ff00e5618d86c);
$parcel$export(module.exports, "FULL_PAGE_EDITOR_TOOLBAR_HEIGHT", () => $12e0df67293c076b$export$d7726a000ae2d7c);
$parcel$export(module.exports, "akEditorSelectedNodeClassName", () => $12e0df67293c076b$export$a02a3f1515c2e21a);
$parcel$export(module.exports, "editorFontSize", () => $12e0df67293c076b$export$58a725ff69bda73a);
$parcel$export(module.exports, "relativeFontSizeToBase16", () => $12e0df67293c076b$export$59733a9f61449b25);
$parcel$export(module.exports, "VIEWPORT_SIZES", () => $12e0df67293c076b$export$96b72b7f243fa693);
$parcel$export(module.exports, "akEditorMobileMaxWidth", () => $12e0df67293c076b$export$9369fd010fa0ddd6);
$parcel$export(module.exports, "participantColors", () => $12e0df67293c076b$export$42608c013398a830);

var $eGOwo = parcelRequire("eGOwo");

var $92xoS = parcelRequire("92xoS");
const $12e0df67293c076b$export$fe6b0b821a0e9067 = 16;
const $12e0df67293c076b$export$9a7c520c39e1f0aa = "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)";
const $12e0df67293c076b$export$1d762aef048d30f9 = "var(--ds-background-accent-gray-subtler, #DCDFE4)";
const $12e0df67293c076b$export$a7a75e50ae62d0a8 = "var(--ds-border, #091E4224)";
const $12e0df67293c076b$export$b9864494c2608629 = "var(--ds-background-accent-gray-subtlest, #F1F2F4)";
const $12e0df67293c076b$export$f0e953d95429ca1 = '12px';
const $12e0df67293c076b$export$a309dbdeca0adb1a = '2px 4px';
const $12e0df67293c076b$export$ef95eb6ef0fd0a4a = "var(--ds-background-danger, #FFECEB)";
const $12e0df67293c076b$export$8f7d2d784079e274 = 'rgba(255, 189, 173, 0.5)'; // R75 with 50% opacity
const $12e0df67293c076b$export$3c108a6bc41bb5f2 = "var(--ds-border-danger, #E2483D)";
const $12e0df67293c076b$export$bf3aaa2106c119fd = "var(--ds-icon-danger, #C9372C)";
const $12e0df67293c076b$export$d2715266dd4a1fd1 = 20;
const $12e0df67293c076b$export$cf524c1b49838a49 = "var(--ds-border-selected, #0C66E4)";
const $12e0df67293c076b$export$8dac549e32469ac4 = 1;
const $12e0df67293c076b$export$befaaae517e3d864 = 2;
const $12e0df67293c076b$export$6e1e1996c4e8cc51 = `${$12e0df67293c076b$export$8dac549e32469ac4}px solid ${"var(--ds-border-selected, #0C66E4)"}`;
const $12e0df67293c076b$export$b6a59ac3a19b6343 = `0 0 0 ${$12e0df67293c076b$export$8dac549e32469ac4}px ${"var(--ds-border-selected, #0C66E4)"}`;
const $12e0df67293c076b$export$37e178ca41c198ca = `0 0 0 ${$12e0df67293c076b$export$befaaae517e3d864}px ${"var(--ds-border-selected, #0C66E4)"}`;
const $12e0df67293c076b$export$4a007c22e25e31f6 = 0.3;
const $12e0df67293c076b$export$f35cc48f3398ab79 = 1;
const $12e0df67293c076b$export$b46cda584c619451 = 2;
const $12e0df67293c076b$export$6bed85de54b5de42 = 11; // filmstrip uses 10 for its shadow
const $12e0df67293c076b$export$321ddd2f049dd12 = $12e0df67293c076b$export$6bed85de54b5de42 + 1;
const $12e0df67293c076b$export$daeac9b8422ac3c2 = 2;
const $12e0df67293c076b$export$501d46e11ed5bf73 = 500;
const $12e0df67293c076b$export$6817b4b6a5ef78f1 = 400;
const $12e0df67293c076b$export$93768eb72dec48ce = $12e0df67293c076b$export$501d46e11ed5bf73 + 10;
const $12e0df67293c076b$export$c0aec4e0896849a0 = $12e0df67293c076b$export$93768eb72dec48ce - 5;
const $12e0df67293c076b$export$5886f057e4f21fe4 = $12e0df67293c076b$export$6817b4b6a5ef78f1 + 5;
const $12e0df67293c076b$export$6e85faa46d537a3f = 11;
const $12e0df67293c076b$export$36ba77fba4a62d5f = "var(--ds-background-accent-gray-subtler, #DCDFE4)";
const $12e0df67293c076b$export$640eef769748f78f = "var(--ds-background-accent-gray-subtlest, #F1F2F4)";
const $12e0df67293c076b$export$4c6f61fb4b9ae93 = '#F1F2F4';
const $12e0df67293c076b$export$95e9a0285b97474d = '#2C333A';
const $12e0df67293c076b$export$f7bbcec54ff5bc47 = "var(--ds-border-focused, #388BFF)";
const $12e0df67293c076b$export$76b5e653883e5290 = '3px';
const $12e0df67293c076b$export$6d85fe8177a50c0c = 0.5;
const $12e0df67293c076b$export$fad19f16d3f953a3 = 680;
const $12e0df67293c076b$export$9db045950eedb49f = 760;
const $12e0df67293c076b$export$74c442132af16a = 960; // This value is used for tables with breakouts and is used to calculate `breakoutWidthPx`
const $12e0df67293c076b$export$f580e3d28d0986de = 1800;
const $12e0df67293c076b$export$9d5488b5afad62bf = 1792;
const $12e0df67293c076b$export$37df10057d36a0e5 = 42;
const $12e0df67293c076b$export$437293c5e9fc2703 = 96;
const $12e0df67293c076b$export$6e0f4d52efd3d2d = 32;
const $12e0df67293c076b$export$f222e0c7a2dc5324 = ()=>// eslint-disable-next-line @atlaskit/platform/no-preconditioning
    (0, $eGOwo.fg)('platform_editor_controls_increase_full_page_gutter') && (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1') ? 72 : 52;
const $12e0df67293c076b$export$efe8561bbd3f74d2 = 720;
const $12e0df67293c076b$export$e4d39a9e8607c1d3 = 48;
const $12e0df67293c076b$export$43946f2400ab6f1f = 128;
const $12e0df67293c076b$export$558438ae7fd4b8ce = 12;
const $12e0df67293c076b$export$6beb98d32d4ca149 = 4;
const $12e0df67293c076b$export$3b24948cd5dbb087 = `cubic-bezier(0.15, 1, 0.3, 1)`;
const $12e0df67293c076b$export$5edb4f38c3eacb1a = 1024;
const $12e0df67293c076b$export$e60820063058ed59 = 1.33;
const $12e0df67293c076b$export$60da500206e2ceec = 905; // from breakoutConsts.calcWideWidth, layoutMaxWidth * breakoutConsts.wideScaleRatio = 904.8 ~ 905 This is a resulting width value that is applied to nodes that currently use breakouts (except table) and are set to `wide` when the viewport's width is <= 1266px.
const $12e0df67293c076b$export$c0e6648ae1bb2fac = 1011; // = akEditorDefaultLayoutWidth * breakoutWideScaleRatio = 1010.8 ~ 1011 This is a resulting width value that is applied to nodes that currently use breakouts (except table) and are set to `wide` when the viewport's width is > 1329px.
const $12e0df67293c076b$export$fb15fade89f67217 = $12e0df67293c076b$export$f35cc48f3398ab79 * 99;
const $12e0df67293c076b$export$847030921e9d5a40 = 12;
const $12e0df67293c076b$export$40eb41ab799f0329 = 1.714;
const $12e0df67293c076b$export$e271312fc7124aec = '1px';
const $12e0df67293c076b$export$d29cb2c31fcbb7c5 = 2;
const $12e0df67293c076b$export$688a6dc01e760755 = 320;
const $12e0df67293c076b$export$e736f2caf3b39eb3 = 'rgba(179, 212, 255, 0.3)';
const $12e0df67293c076b$export$de3cef07cda55645 = 'rgba(255, 235, 230, 0.3)';
const $12e0df67293c076b$export$e88f6c898960b391 = $12e0df67293c076b$export$f35cc48f3398ab79 * 2; //prevent paragraph nodes from rendering above wrapped nodes
const $12e0df67293c076b$export$e5c605f2b2a12b00 = {
    SMALL: 550,
    MEDIUM: 760
};
const $12e0df67293c076b$export$1d0d506416d457f1 = '0.75rem';
const $12e0df67293c076b$export$e683ef42725d1713 = 680;
const $12e0df67293c076b$export$226c784ba04bd04b = 480;
const $12e0df67293c076b$export$214ff00e5618d86c = 20;
const $12e0df67293c076b$export$c82675fa56f2eefd = '56px';
const $12e0df67293c076b$var$DEFAULT_FONT_SIZE = 14;
const $12e0df67293c076b$export$d7726a000ae2d7c = ()=>{
    if ((0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1', {
        exposure: true
    })) return "var(--ds-space-500, 40px)";
    return "var(--ds-space-500, 40px)";
};
const $12e0df67293c076b$export$a02a3f1515c2e21a = 'ak-editor-selected-node';
const $12e0df67293c076b$export$58a725ff69bda73a = ({ theme: theme })=>theme && theme.baseFontSize ? theme.baseFontSize : $12e0df67293c076b$var$DEFAULT_FONT_SIZE;
const $12e0df67293c076b$export$945a9e125632354d = (multiplier)=>({ theme: theme })=>$12e0df67293c076b$export$58a725ff69bda73a({
            theme: theme
        }) * multiplier;
const $12e0df67293c076b$export$59733a9f61449b25 = (px)=>{
    if (typeof px === 'string') px = parseInt(px);
    if (isNaN(px)) throw new Error(`Invalid font size: '${px}'`);
    return `${px / 16}rem`;
};
const $12e0df67293c076b$export$96b72b7f243fa693 = {
    laptopHiDPI: {
        width: 1440,
        height: 900
    },
    laptopMDPI: {
        width: 1280,
        height: 800
    },
    tabletL: {
        width: 1024,
        height: 1366
    },
    tabletS: {
        width: 768,
        height: 1024
    },
    mobileM: {
        width: 414,
        height: 736
    },
    mobileS: {
        width: 375,
        height: 667
    },
    mobileXS: {
        width: 320,
        height: 568
    }
};
const $12e0df67293c076b$export$9369fd010fa0ddd6 = 0;
const $12e0df67293c076b$export$846a716e9e69a8df = [
    [
        'White',
        '#000000'
    ],
    [
        'Light blue',
        '#0C294F'
    ],
    [
        'Light teal',
        '#0C343B'
    ],
    [
        'Light green',
        '#052E21'
    ],
    [
        'Light yellow',
        '#484123'
    ],
    [
        'Light red',
        '#441C13'
    ],
    [
        'Light purple',
        '#282249'
    ],
    [
        'Light gray',
        '#202328'
    ],
    [
        'Blue',
        '#0B3165'
    ],
    [
        'Teal',
        '#044853'
    ],
    [
        'Green',
        '#053927'
    ],
    [
        'Yellow',
        '#6F5C25'
    ],
    [
        'Red',
        '#582013'
    ],
    [
        'Purple',
        '#3E327B'
    ],
    [
        'Gray',
        '#475262'
    ],
    [
        'Dark blue',
        '#003884'
    ],
    [
        'Dark teal',
        '#055866'
    ],
    [
        'Dark green',
        '#044932'
    ],
    [
        'Dark yellow',
        '#82641C'
    ],
    [
        'Dark red',
        '#6B2A19'
    ],
    [
        'Dark purple',
        '#4D38B2'
    ]
].map(([colorName, colorValue])=>$12e0df67293c076b$export$5f2dade43b841301(colorName, colorValue)).join('\n');
function $12e0df67293c076b$export$5f2dade43b841301(colorName, colorValue) {
    return `
  &[colorname="${colorName}"] {
    background-color: ${colorValue} !important; // !important to override default style color
  }
  `;
}
const $12e0df67293c076b$export$312e1e71424c4aa1 = [
    "var(--ds-icon-accent-red, #C9372C)",
    "var(--ds-background-accent-red-bolder-hovered, #AE2E24)",
    "var(--ds-icon-accent-magenta, #CD519D)",
    "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "var(--ds-icon-accent-orange, #E56910)",
    "var(--ds-background-accent-orange-bolder-hovered, #A54800)",
    "var(--ds-icon-accent-green, #22A06B)",
    "var(--ds-background-accent-green-bolder-hovered, #216E4E)",
    "var(--ds-icon-accent-blue, #1D7AFC)",
    "var(--ds-background-accent-blue-bolder-hovered, #0055CC)",
    "var(--ds-icon-accent-teal, #2898BD)",
    "var(--ds-background-accent-teal-bolder-hovered, #206A83)",
    "var(--ds-icon-accent-lime, #6A9A23)",
    "var(--ds-background-accent-lime-bolder-hovered, #4C6B1F)",
    "var(--ds-icon-accent-purple, #8270DB)",
    "var(--ds-background-accent-purple-bolder-hovered, #5E4DB2)",
    "var(--ds-icon-accent-gray, #758195)",
    "var(--ds-background-accent-gray-bolder-hovered, #44546F)",
    "var(--ds-icon-accent-yellow, #B38600)",
    "var(--ds-background-accent-yellow-bolder-hovered, #7F5F01)",
    "var(--ds-background-accent-yellow-bolder-pressed, #533F04)"
];
const $12e0df67293c076b$export$42608c013398a830 = [
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-red-bolder, #C9372C)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-blue-bolder, #0C66E4)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-green-bolder, #1F845A)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-yellow-bolder, #946F00)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-purple-bolder, #6E5DC6)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-magenta-bolder, #AE4787)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-teal-bolder, #227D9B)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-orange-bolder, #C25100)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-lime-bolder, #5B7F24)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-gray-bolder, #626F86)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-blue-subtle, #579DFF)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-red-subtle, #F87168)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-orange-subtle, #FEA362)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-yellow-subtle, #F5CD47)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-green-subtle, #4BCE97)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-teal-subtle, #6CC3E0)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-purple-subtle, #9F8FEF)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-magenta-subtle, #E774BB)"
    }
];

});
parcelRegister("92xoS", function(module, exports) {

$parcel$export(module.exports, "editorExperiment", () => $19fb77b8a89e4410$export$9b7cf3b74f250027);
$parcel$export(module.exports, "unstable_editorExperimentParam", () => $19fb77b8a89e4410$export$92316ae898e357eb);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $59rsN = parcelRequire("59rsN");

var $dpRNR = parcelRequire("dpRNR");

var $bfW07 = parcelRequire("bfW07");
function $19fb77b8a89e4410$export$9b7cf3b74f250027(experimentName, expectedExperimentValue, options = {
    exposure: false
}) {
    const experimentConfig = (0, $dpRNR.editorExperimentsConfig)[experimentName];
    if ((0, $bfW07._overrides)[experimentName] !== undefined) // This will be hit in the case of a test setting an override
    return (0, $bfW07._overrides)[experimentName] === expectedExperimentValue;
    if (experimentConfig === undefined) // Warning! If a product is improperly configured (ie. their editor packages are misaligned)
    // it can cause the editor to crash here or if the experiment does not exist.
    // We will definitely crash via any code path later in this function - this just makes the error explicit and clear.
    throw new Error(`Editor experiment configuration is not defined ${experimentName}. Likely the experiment does not exist or editor package versions are misaligned`);
    if (!(0, $bfW07._product)) // This will be hit in the case of a product not having setup the editor experiment tooling
    return experimentConfig.defaultValue === expectedExperimentValue;
    // Typescript is complaining here about accessing the productKeys property
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const experimentKey = experimentConfig?.productKeys?.[0, $bfW07._product];
    if (!experimentKey) // This will be hit in the case of an experiment not being set up for the product
    return (0, $dpRNR.editorExperimentsConfig)[experimentName]?.defaultValue === expectedExperimentValue;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $59rsN.default).getExperimentValue(// @ts-ignore
    experimentKey, experimentConfig.param, experimentConfig.defaultValue, {
        typeGuard: experimentConfig.typeGuard,
        fireExperimentExposure: options.exposure
    });
    return expectedExperimentValue === experimentValue;
}
function $19fb77b8a89e4410$export$92316ae898e357eb(experimentName, paramName, options) {
    if ((0, $bfW07._paramOverrides)[experimentName]?.[paramName] !== undefined) // This will be hit in the case of a test setting an override
    return (0, $bfW07._paramOverrides)[experimentName][paramName];
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $59rsN.default).getExperimentValue(experimentName, paramName, options.defaultValue, {
        typeGuard: options.typeGuard,
        fireExperimentExposure: options.exposure ?? false
    });
    return experimentValue;
}

});
parcelRegister("dpRNR", function(module, exports) {

$parcel$export(module.exports, "editorExperimentsConfig", () => $91e9175ec4c776be$export$6cbb856f286b07ef);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $9M2Eg = parcelRequire("9M2Eg");
const $91e9175ec4c776be$export$6cbb856f286b07ef = {
    // Added 2025-05-27
    platform_editor_reduce_noisy_steps_ncs: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_reduce_noisy_steps_ncs'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_memoized_node_check: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_memoized_node_check'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_media_card_vc_wrapper_attribute: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_media_card_vc_wrapper_attribute'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-02
    platform_editor_block_control_optimise_render: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_block_control_optimise_render'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-08-08
    'example-boolean': (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package_boolean'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-08-08
    'example-multivariate': (0, $9M2Eg.createMultivariateExperiment)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package_multivariate'
        },
        param: 'variant',
        values: [
            'one',
            'two',
            'three'
        ],
        defaultValue: 'one'
    }),
    // Added 2024-08-08
    'test-new-experiments-package': (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package',
            jira: 'jira_editor_experiment_test_new_package'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-09-05
    support_table_in_comment: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_support_table_in_comment_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-09-07
    platform_editor_exp_lazy_node_views: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_exp_lazy_node_views'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-09-18
    platform_renderer_table_sticky_scrollbar: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_renderer_table_sticky_scrollbar'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-28
    platform_editor_controls_performance_fixes: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_controls_performance_fixes'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-26
    platform_editor_prevent_toolbar_layout_shifts: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_prevent_toolbar_layout_shifts'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-10-01
    comment_on_bodied_extensions: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_comment_on_bodied_extensions'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-10-14
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_advanced_layouts/setup
    advanced_layouts: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_advanced_layouts'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-3-15
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_single_column_layout/setup
    single_column_layouts: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_single_column_layout'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-10-08
    support_table_in_comment_jira: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            jira: 'platform_editor_support_table_in_comment_jira'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    'platform_editor_ai-prompts-placeholder': (0, $9M2Eg.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai-prompts-placeholder'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // added 2024-11-06
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_nested_tables/setup
    'nested-tables-in-tables': (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_nested_tables'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-11-26
    platform_editor_ai_unsplash_page_header: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_unsplash_page_header'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-12-05
    platform_editor_blockquote_in_text_formatting_menu: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_blockquote_in_text_formatting_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-01-09
    platform_editor_advanced_code_blocks: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_advanced_code_blocks'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-01-13
    platform_editor_element_drag_and_drop_multiselect: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_element_drag_and_drop_multiselect'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-01-19
    platform_editor_ai_edit_response_in_preview: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_edit_response_in_preview'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-02-10
    platform_editor_controls: (0, $9M2Eg.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_controls'
        },
        param: 'cohort',
        values: [
            'control',
            'variant1'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-06-02
    platform_editor_smart_link_cmd_ctrl_click: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_smart_link_cmd_ctrl_click'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 28-02-2025
    platform_editor_insertion: (0, $9M2Eg.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_insertion'
        },
        param: 'cohort',
        values: [
            'control',
            'variant1'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-04-01
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_vanilla_dom/setup
    platform_editor_vanilla_dom: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_vanilla_dom'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-03-28
    platform_editor_ai_proactive_ai_nudge_parameters: (0, $9M2Eg.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_proactive_ai_nudge_parameters'
        },
        param: 'cohort',
        values: [
            'control',
            'variant1'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-04-14
    // https://switcheroo.atlassian.com/ui/gates/b159b45a-86d9-4f4b-b482-f9aca5b615d6/key/platform_editor_offline_editing_web
    platform_editor_offline_editing_web: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_offline_editing_web'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-14
    editor_ai_inline_suggestion_date_v2: (0, $9M2Eg.createMultivariateExperiment)({
        productKeys: {
            confluence: 'editor_ai_inline_suggestion_date_v2'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-04-17
    platform_editor_tables_drag_and_drop: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_tables_drag_and_drop'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-17
    platform_editor_tables_table_selector: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_tables_table_selector'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-23
    platform_editor_usesharedpluginstateselector: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_usesharedpluginstateselector'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-14
    platform_editor_media_floating_toolbar_early_exit: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_media_floating_toolbar_early_exit'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-23
    platform_renderer_fix_analytics_memo_callback: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_renderer_fix_analytics_memo_callback'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-08
    editor_ai_converge_free_gen_on_rovo: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_ai_converge_free_gen_on_rovo'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-26
    platform_editor_stop_width_reflows: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_stop_width_reflows'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-08
    platform_editor_core_static_emotion: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_core_static_emotion'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-11
    platform_editor_core_static_emotion_non_central: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_core_static_emotion_non_central'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-10
    platform_editor_no_cursor_on_edit_page_init: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_no_cursor_on_edit_page_init'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-08 - Jira work sync description comment summary
    'jira-work-sync-desc-comment-summary': (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            jira: 'jira-work-sync-desc-comment-summary'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-21
    platform_editor_nodevisibility: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_nodevisibility'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-15
    platform_editor_breakout_resizing: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_breakout_resizing'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-07
    platform_editor_ai_quickstart_command: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_quickstart_command'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-28
    platform_editor_toolbar_rerender_optimization_exp: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_rerender_optimization_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-30
    platform_editor_controls_toolbar_pinning_exp: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_controls_toolbar_pinning_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-05
    platform_editor_block_controls_perf_optimization: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_block_controls_perf_optimization'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-16
    platform_editor_enable_single_player_step_merging: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_enable_single_player_step_merging'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-18
    platform_editor_ai_iw_adf_streaming: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_iw_adf_streaming'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-07
    platform_editor_ai_remove_trivial_prompts_cc: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_remove_trivial_prompts_cc'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-20
    confluence_whiteboards_quick_insert_aa: (0, $9M2Eg.createMultivariateExperiment)({
        productKeys: {
            confluence: 'confluence_whiteboards_quick_insert_aa'
        },
        param: 'cohort',
        values: [
            'control',
            'test_blank',
            'test_diagram'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-06-24
    platform_editor_find_and_replace_improvements: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_find_and_replace_improvements'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-24
    confluence_whiteboards_quick_insert: (0, $9M2Eg.createMultivariateExperiment)({
        productKeys: {
            confluence: 'confluence_whiteboards_quick_insert'
        },
        param: 'cohort',
        values: [
            'control',
            'test_blank',
            'test_diagram'
        ],
        defaultValue: 'control'
    }),
    // added out of order to avoid known conflict that will occur otherwise
    // Added 2025-07-11
    cc_editor_ufo_hold_table_till_resize_complete: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_editor_ufo_hold_table_till_resize_complete'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-07
    platform_editor_toggle_expand_on_match_found: (0, $9M2Eg.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toggle_expand_on_match_found'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-011
    cc_editor_interactions_trigger_traceufointeraction: (0, $9M2Eg.createMultivariateExperiment)({
        productKeys: {
            confluence: 'cc_editor_interactions_trigger_traceufointeraction'
        },
        param: 'cohort',
        values: [
            'control',
            'all_events',
            'only_mousedown_event'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-07-14
    platform_editor_add_orange_highlight_color: (0, $9M2Eg.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_add_orange_highlight_color'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    })
};

});
parcelRegister("9M2Eg", function(module, exports) {

$parcel$export(module.exports, "createBooleanExperiment", () => $99d69a3554c71d9e$export$456f1587c9c92021);
$parcel$export(module.exports, "createMultivariateExperiment", () => $99d69a3554c71d9e$export$fb89e8a786694d1);

var $cFacD = parcelRequire("cFacD");
function $99d69a3554c71d9e$export$456f1587c9c92021(config) {
    return {
        ...config,
        typeGuard: (0, $cFacD.isBoolean),
        defaultValue: config.defaultValue
    };
}
function $99d69a3554c71d9e$export$fb89e8a786694d1(config) {
    const { values: values } = config;
    return {
        ...config,
        values: [
            ...values
        ],
        typeGuard: (0, $cFacD.oneOf)(config.values),
        defaultValue: config.defaultValue
    };
}

});
parcelRegister("cFacD", function(module, exports) {

$parcel$export(module.exports, "isBoolean", () => $ae50fe7194104c61$export$f9ce7b637dfbe238);
$parcel$export(module.exports, "oneOf", () => $ae50fe7194104c61$export$a9a18ae5ba42aeab);
function $ae50fe7194104c61$export$f9ce7b637dfbe238(value) {
    return typeof value === 'boolean';
}
function $ae50fe7194104c61$export$a9a18ae5ba42aeab(values) {
    function typeGuard(value) {
        return values.includes(value);
    }
    /**
	 * This is used by test utils to get the variants when running describe.each
	 */ if ($ae50fe7194104c61$var$IS_TESTING_ENV) typeGuard.values = values;
    return typeGuard;
}
const $ae50fe7194104c61$var$IS_TESTING_ENV = false;

});



parcelRegister("bfW07", function(module, exports) {

$parcel$export(module.exports, "_overrides", () => $98b68f42908704b3$export$e5d73bf4f8e2ae96);
$parcel$export(module.exports, "_paramOverrides", () => $98b68f42908704b3$export$4e849416bb5c5b52);
$parcel$export(module.exports, "_product", () => $98b68f42908704b3$export$cf7305fc65acbf0d);
$parcel$export(module.exports, "setupEditorExperiments", () => $98b68f42908704b3$export$1c2b6dbf79eb3560);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $dpRNR = parcelRequire("dpRNR");
let $98b68f42908704b3$export$e5d73bf4f8e2ae96 = {};
let $98b68f42908704b3$export$4e849416bb5c5b52 = {};
let $98b68f42908704b3$export$cf7305fc65acbf0d;
function $98b68f42908704b3$export$1c2b6dbf79eb3560(product, /**
	 * Overrides are used to set the group of an experiment for testing purposes.
	 * This is useful when you want to test a specific experiment group.
	 */ groupOverrides, /**
	 * Param overrides are used to set the experiment parameters for testing purposes.
	 * This is useful when you want to tweak the experiment parameters for testing.
	 */ paramOverrides) {
    if (groupOverrides) {
        // When setting up overrides, we want to ensure that experiments don't end up with invalid
        // values.
        // For production usage -- this is done via the feature flag client which takes the type
        // and performs equivalent logic.
        // @ts-ignore
        groupOverrides = Object.entries(groupOverrides).reduce((acc, [key, value])=>{
            const config = (0, $dpRNR.editorExperimentsConfig)[key];
            if (config) acc = {
                ...acc,
                [key]: config.typeGuard(value) ? value : config.defaultValue
            };
            return acc;
        }, {});
        $98b68f42908704b3$export$e5d73bf4f8e2ae96 = groupOverrides;
    }
    $98b68f42908704b3$export$cf7305fc65acbf0d = product;
    if (paramOverrides) $98b68f42908704b3$export$4e849416bb5c5b52 = paramOverrides;
}

});



parcelRegister("2bEPZ", function(module, exports) {

$parcel$export(module.exports, "getBreakpoint", () => $7765fd643b71afb3$export$1eb095b00b926404);
$parcel$export(module.exports, "createWidthContext", () => $7765fd643b71afb3$export$31a4966bffb9ac98);
$parcel$export(module.exports, "WidthContext", () => $7765fd643b71afb3$export$27e39f636459b9f);
$parcel$export(module.exports, "WidthConsumer", () => $7765fd643b71afb3$export$5d8538aa831b6ebb);
$parcel$export(module.exports, "WidthProvider", () => $7765fd643b71afb3$export$7921e18173e8c666);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $LFmXM = parcelRequire("LFmXM");

var $bRPNB = parcelRequire("bRPNB");

var $gMRLG = parcelRequire("gMRLG");

var $fNh22 = parcelRequire("fNh22");
function $7765fd643b71afb3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7765fd643b71afb3$var$styles = {
    name: "pw7jst",
    styles: "position:relative;width:100%"
};
const $7765fd643b71afb3$var$SCROLLBAR_WIDTH = 30;
function $7765fd643b71afb3$export$1eb095b00b926404(width = 0) {
    const MAX_S = 1266;
    const MAX_M = 2146;
    if (width >= MAX_S && width < MAX_M) return 'M';
    else if (width >= MAX_M) return 'L';
    return 'S';
}
function $7765fd643b71afb3$export$31a4966bffb9ac98(width = 0) {
    return {
        width: width,
        breakpoint: $7765fd643b71afb3$export$1eb095b00b926404(width)
    };
}
const $7765fd643b71afb3$export$27e39f636459b9f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext($7765fd643b71afb3$export$31a4966bffb9ac98());
const { Provider: $7765fd643b71afb3$var$Provider, Consumer: $7765fd643b71afb3$export$5d8538aa831b6ebb } = $7765fd643b71afb3$export$27e39f636459b9f;
const $7765fd643b71afb3$export$df154c49e93b2ac2 = (0, $LFmXM.default)(()=>{
    return (0, $fNh22.isSSR)() ? 0 : document.body?.offsetWidth ?? 0;
});
const $7765fd643b71afb3$export$7921e18173e8c666 = ({ className: className, shouldCheckExistingValue: shouldCheckExistingValue, children: children })=>{
    const existingContextValue = (0, $eJOHy.useContext)($7765fd643b71afb3$export$27e39f636459b9f);
    const [width, setWidth] = (0, $eJOHy.useState)($7765fd643b71afb3$export$df154c49e93b2ac2);
    const widthRef = (0, $eJOHy.useRef)(width);
    const isMountedRef = (0, $eJOHy.useRef)(true);
    const providerValue = (0, $eJOHy.useMemo)(()=>$7765fd643b71afb3$export$31a4966bffb9ac98(width), [
        width
    ]);
    const updateWidth = (0, $eJOHy.useMemo)(()=>{
        return (0, $bRPNB.default)((nextWidth)=>{
            const currentWidth = widthRef.current || 0;
            // Ignore changes that are less than SCROLLBAR_WIDTH, otherwise it can cause infinite re-scaling
            if (Math.abs(currentWidth - nextWidth) < $7765fd643b71afb3$var$SCROLLBAR_WIDTH) return;
            // Avoid React memory leak by checking if the component is still mounted
            if (!isMountedRef.current) return;
            widthRef.current = nextWidth;
            setWidth(nextWidth);
        });
    }, []);
    const skipWidthDetection = shouldCheckExistingValue && existingContextValue.width > 0;
    (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useLayoutEffect(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $7765fd643b71afb3$var$styles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className
    }, !skipWidthDetection && /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Fragment), null, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $gMRLG.WidthObserver), {
        setWidth: updateWidth,
        offscreen: true
    }), /*#__PURE__*/ (0, $1NIU8.jsx)($7765fd643b71afb3$var$Provider, {
        value: providerValue
    }, children)), skipWidthDetection && children);
};

});
parcelRegister("gMRLG", function(module, exports) {

$parcel$export(module.exports, "WidthObserver", () => $fc07c79ce5b93db8$export$b2ad68b9bc407b80);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $ghv3t = parcelRequire("ghv3t");
const $fc07c79ce5b93db8$export$b2ad68b9bc407b80 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo((props)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ghv3t.WidthDetectorObserver), {
        setWidth: props.setWidth,
        offscreen: props.offscreen
    });
});
var $fc07c79ce5b93db8$export$2e2bcd8739ae039 = $fc07c79ce5b93db8$export$b2ad68b9bc407b80;

});
parcelRegister("ghv3t", function(module, exports) {

$parcel$export(module.exports, "WidthDetectorObserver", () => $8fd70c84fe96dcaa$export$ff983d2a2b6112ea);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $1DXAa = parcelRequire("1DXAa");
const $8fd70c84fe96dcaa$export$ff983d2a2b6112ea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo(({ setWidth: setWidth, offscreen: offscreen })=>{
    const [inViewRef, inView, target] = (0, $1DXAa.useInView)({
        /* Optional options */ threshold: 0
    });
    const observer = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef(()=>{
        if (typeof window === 'undefined') return null;
        // https://github.com/DefinitelyTyped/DefinitelyTyped/pull/40909
        // @ts-ignore
        return new ResizeObserver((entries)=>{
            if (!Array.isArray(entries) || !entries.length) return;
            const { width: width } = entries[0].contentRect;
            setWidth(Math.round(width));
        });
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useEffect(()=>{
        const { current: currentObserver } = observer;
        const resizeObserver = currentObserver();
        if (resizeObserver === null) return;
        if (target) {
            if (inView || offscreen) resizeObserver.observe(target);
            else resizeObserver.unobserve(target);
        }
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        target,
        inView,
        offscreen
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute'
        },
        ref: inViewRef
    });
});

});
parcelRegister("1DXAa", function(module, exports) {

$parcel$export(module.exports, "useInView", () => $cca7bb4179e40d90$export$2f62ee6831462844);

var $eJOHy = parcelRequire("eJOHy");
function $cca7bb4179e40d90$export$2f62ee6831462844(options = {}) {
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef();
    const observerInstance = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef();
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState({
        inView: false,
        entry: undefined,
        target: undefined
    });
    const { threshold: threshold, root: root, rootMargin: rootMargin } = options;
    const setRef = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((node)=>{
        observerInstance.current = new IntersectionObserver((entries)=>{
            if (entries && entries.length) {
                const intersection = entries[0];
                const { isIntersecting: isIntersecting, intersectionRatio: intersectionRatio } = intersection;
                if (intersectionRatio >= 0) {
                    // Note: `0` will be used here when an array of numbers is passed as the threshold, which doesn't feel right
                    const numericThreshold = typeof threshold === 'number' ? threshold : 0;
                    let inView = intersectionRatio >= numericThreshold;
                    if (isIntersecting !== undefined) inView = inView && isIntersecting;
                    setState({
                        inView: inView,
                        entry: intersection,
                        target: node
                    });
                }
            }
        }, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin
        });
        if (ref.current) observerInstance.current.unobserve(ref.current);
        if (node) observerInstance.current.observe(node);
        // Store a reference to the node
        ref.current = node;
    }, [
        threshold,
        root,
        rootMargin
    ]);
    /**
	 * Unsubscribe IntersectionObserver before unmounting a component.
	 */ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useEffect(()=>{
        return ()=>{
            if (observerInstance.current && ref.current) observerInstance.current.unobserve(ref.current);
        };
    }, []);
    return [
        setRef,
        state.inView,
        state.target,
        state.entry
    ];
}

});



parcelRegister("fNh22", function(module, exports) {

$parcel$export(module.exports, "isSSR", () => $8d37e6f7c6dd916d$export$48d7c418edadb60c);

var $igDjg = parcelRequire("igDjg");
function $8d37e6f7c6dd916d$export$48d7c418edadb60c() {
    try {
        return Boolean(// In most places there is no document when running on server-side
        typeof document === 'undefined' || // When SSRing editor with full cycle mode we define the document
        // Check Confluence specific environment variable
        typeof $igDjg !== 'undefined' && undefined);
    } catch (e) {
        // Catch possible error that might occur and just return false
        return false;
    }
}

});



parcelRegister("jjlK8", function(module, exports) {

$parcel$export(module.exports, "IntlErrorBoundary", () => $e2aede23e89d0b7e$export$7df0749115d18d19);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $4nehu = parcelRequire("4nehu");
const $e2aede23e89d0b7e$export$c7ef921528e1d279 = '<IntlProvider> needs to exist in the component ancestry';
const $e2aede23e89d0b7e$var$isMissingIntlProviderInAncestryError = (err)=>err?.toString()?.includes('<IntlProvider> needs to exist in the component ancestry');
class $e2aede23e89d0b7e$export$7df0749115d18d19 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    componentDidCatch(error, errorInfo) {
        // if missing IntlProvider in ancestry, we setup a fallback IntlProvider ourselves
        if ($e2aede23e89d0b7e$var$isMissingIntlProviderInAncestryError(error)) this.setState({
            missingIntlProviderInAncestry: true
        });
        else // else we re-propagate the non-react-intl-next error
        throw error;
    }
    render() {
        if (this.state.missingIntlProviderInAncestry) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4nehu.default), {
            locale: "en",
            children: this.props.children
        });
        return this.props.children;
    }
    constructor(...args){
        super(...args), this.state = {
            missingIntlProviderInAncestry: false
        };
    }
}

});

parcelRegister("93FVZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $6999eed130dec5d2$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $6YFG2 = parcelRequire("6YFG2");

var $7yBx7 = parcelRequire("7yBx7");

var $k9Gmz = parcelRequire("k9Gmz");

var $k71qx = parcelRequire("k71qx");

var $bMFKb = parcelRequire("bMFKb");

var $gPpAv = parcelRequire("gPpAv");

var $3mTkR = parcelRequire("3mTkR");

var $z9Bay = parcelRequire("z9Bay");
const $6999eed130dec5d2$var$blockNodeStyle = /*#__PURE__*/ (0, $1NIU8.css)({
    background: "var(--ds-background-disabled, #091E4208)",
    border: `1px dashed ${"var(--ds-border-disabled, #091E420F)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: "var(--ds-border-radius, 3px)",
    boxSizing: 'border-box',
    cursor: 'default',
    display: 'flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: (0, $7yBx7.relativeFontSizeToBase16)(14),
    margin: `${"var(--ds-space-100, 8px)"} 0`,
    minHeight: '24px',
    padding: "var(--ds-space-150, 12px)",
    textAlign: 'center',
    verticalAlign: 'text-bottom',
    minWidth: '120px',
    alignItems: 'center',
    justifyContent: 'center'
});
const $6999eed130dec5d2$var$UnsupportedBlockNode = ({ node: node, intl: intl, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
    const message = (0, $z9Bay.getUnsupportedContent)((0, $gPpAv.unsupportedContentMessages).unsupportedBlockContent, (0, $gPpAv.unsupportedContentMessages).unsupportedBlockContent.defaultMessage + ':', node, intl);
    const tooltipContent = intl.formatMessage((0, $gPpAv.unsupportedContentMessages).unsupportedContentTooltip);
    const { current: style } = (0, $eJOHy.useRef)({
        padding: '4px'
    });
    const originalNodeType = node?.attrs.originalValue.type;
    const tooltipOnShowHandler = (0, $eJOHy.useCallback)(()=>dispatchAnalyticsEvent && (0, $3mTkR.trackUnsupportedContentTooltipDisplayedFor)(dispatchAnalyticsEvent, (0, $bMFKb.ACTION_SUBJECT_ID).ON_UNSUPPORTED_BLOCK, originalNodeType), [
        dispatchAnalyticsEvent,
        originalNodeType
    ]);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $6999eed130dec5d2$var$blockNodeStyle,
        className: "unsupported"
    }, message, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $k71qx.default), {
        content: tooltipContent,
        hideTooltipOnClick: false,
        position: "bottom",
        onShow: tooltipOnShowHandler,
        strategy: "absolute"
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        style: style
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($k9Gmz))), {
        label: "?",
        LEGACY_size: "small"
    })))));
};
var $6999eed130dec5d2$export$2e2bcd8739ae039 = (0, $6YFG2.default)($6999eed130dec5d2$var$UnsupportedBlockNode);

});
parcelRegister("bMFKb", function(module, exports) {

$parcel$export(module.exports, "EVENT_TYPE", () => $17b833dfd922470c$export$76a2e4c433c23bb9);
$parcel$export(module.exports, "ACTION", () => $17b833dfd922470c$export$9523889e0a5da4ba);
$parcel$export(module.exports, "INPUT_METHOD", () => $17b833dfd922470c$export$85f107b1fcc9d96f);
$parcel$export(module.exports, "INSERT_MEDIA_VIA", () => $17b833dfd922470c$export$9b31fa32ae3f8051);
$parcel$export(module.exports, "TRIGGER_METHOD", () => $17b833dfd922470c$export$81a8b7dba1aa8f75);
$parcel$export(module.exports, "ACTION_SUBJECT", () => $17b833dfd922470c$export$7525482b5931e326);
$parcel$export(module.exports, "ACTION_SUBJECT_ID", () => $17b833dfd922470c$export$9957974f8b4d8f74);
$parcel$export(module.exports, "CONTENT_COMPONENT", () => $17b833dfd922470c$export$9f0b2adf3cfd71b7);
var $17b833dfd922470c$export$76a2e4c433c23bb9 = /*#__PURE__*/ function(EVENT_TYPE) {
    EVENT_TYPE["OPERATIONAL"] = "operational";
    EVENT_TYPE["SCREEN"] = "screen";
    EVENT_TYPE["TRACK"] = "track";
    EVENT_TYPE["UI"] = "ui";
    return EVENT_TYPE;
}({});
var $17b833dfd922470c$export$9523889e0a5da4ba = /*#__PURE__*/ function(ACTION) {
    ACTION["ACTIONED"] = "actioned";
    ACTION["ACTIVATED"] = "activated";
    ACTION["ADDED"] = "added";
    ACTION["API_ERROR"] = "apiError";
    ACTION["API_RECEIVED"] = "apiReceived";
    ACTION["API_PURGED"] = "apiPurged";
    ACTION["BROWSER_FREEZE"] = "browserFreeze";
    ACTION["CANCELLED"] = "cancelled";
    ACTION["CAUGHT_DOM_ERROR"] = "caughtDomError";
    ACTION["CHANGED_BACKGROUND_COLOR"] = "changedBackgroundColor";
    ACTION["CHANGED_ICON"] = "changedIcon";
    ACTION["CHANGED_FULL_WIDTH_MODE"] = "changedFullWidthMode";
    ACTION["CHANGED_LAYOUT"] = "changedLayout";
    ACTION["CHANGED_BREAKOUT_MODE"] = "changedBreakoutMode";
    ACTION["CHANGED_REPLACEMENT_TEXT"] = "changedReplacementText";
    ACTION["CHANGED_TYPE"] = "changedType";
    ACTION["CHANGED_URL"] = "changedUrl";
    ACTION["CLEARED"] = "cleared";
    ACTION["CLICK"] = "click";
    ACTION["CLICKED"] = "clicked";
    ACTION["CLOSED"] = "closed";
    ACTION["COMMITTED"] = "committed";
    /** used in @atlassian/editor-referentiality */ ACTION["CONNECTED_NODES"] = "connectedNodes";
    ACTION["CONVERTED"] = "converted";
    ACTION["COPIED"] = "copied";
    ACTION["CUT"] = "cut";
    ACTION["DEACTIVATED"] = "deactivated";
    ACTION["DECREMENTED"] = "decremented";
    ACTION["DELETED"] = "deleted";
    ACTION["DISCARDED_INVALID_STEPS_FROM_TRANSACTION"] = "discardedInvalidStepsFromTransaction";
    /** used in @atlassian/editor-referentiality */ ACTION["DISCONNECTED_SOURCE"] = "disconnectedSource";
    /** used in @atlassian/editor-referentiality */ ACTION["DISCONNECTED_TARGET"] = "disconnectedTarget";
    ACTION["DISMISSED"] = "dismissed";
    ACTION["DISPATCHED_INVALID_TRANSACTION"] = "dispatchedInvalidTransaction";
    ACTION["DISPATCHED_VALID_TRANSACTION"] = "dispatchedValidTransaction";
    ACTION["DOUBLE_CLICKED"] = "doubleClicked";
    ACTION["DRAGGED"] = "dragged";
    ACTION["EDITED"] = "edited";
    ACTION["EDITOR_CRASHED"] = "unhandledErrorCaught";
    ACTION["EDITOR_CRASHED_ADDITIONAL_INFORMATION"] = "unhandledErrorCaughtAdditionalInfov2";
    ACTION["EDITOR_MOUNTED"] = "mounted";
    ACTION["EDITOR_CONTENT_RETRIEVAL_PERFORMED"] = "contentRetrievalPerformed";
    ACTION["RE_RENDERED"] = "reRendered";
    ACTION["ENDED"] = "ended";
    ACTION["ENTERED"] = "entered";
    ACTION["ERROR"] = "error";
    ACTION["ERRORED"] = "errored";
    ACTION["EXPOSED"] = "exposed";
    ACTION["FAILED_TO_UNMOUNT"] = "failedToUnmount";
    ACTION["FAILED_TO_INSERT"] = "failedToInsert";
    ACTION["FIND_NEXT_PERFORMED"] = "findNextPerformed";
    ACTION["FIND_PERFORMED"] = "findPerformed";
    ACTION["FIND_PREV_PERFORMED"] = "findPrevPerformed";
    ACTION["UNDO_PERFORMED"] = "undo";
    ACTION["REDO_PERFORMED"] = "redo";
    ACTION["FORMATTED"] = "formatted";
    ACTION["HELP_OPENED"] = "helpOpened";
    ACTION["HIGHLIGHTED"] = "highlighted";
    ACTION["INCREMENTED"] = "incremented";
    ACTION["INDENTED"] = "indented";
    ACTION["INITIALISED"] = "initialised";
    ACTION["INITIATED"] = "initiated";
    /** used in @atlassian/editor-referentiality */ ACTION["INITIALISED_FRAGMENT_MARK"] = "initialisedFragmentMark";
    ACTION["INPUT_PERF_SAMPLING"] = "inputPerfSampling";
    ACTION["INPUT_PERF_SAMPLING_AVG"] = "inputPerfSamplingAvg";
    ACTION["INSERTED"] = "inserted";
    ACTION["INVALID_DOCUMENT_ENCOUNTERED"] = "invalidDocumentEncountered";
    ACTION["INVOKED"] = "invoked";
    /** used in @atlassian/editor-referentiality */ ACTION["GOT_CONNECTIONS"] = "gotConnections";
    ACTION["LANGUAGE_SELECTED"] = "languageSelected";
    ACTION["LIST_ITEM_JOINED"] = "listItemJoined";
    ACTION["MATCHED"] = "matched";
    ACTION["MEDIA_LINK_TRANSFORMED"] = "mediaLinkTransformed";
    ACTION["NODE_CONTENT_SANITIZED"] = "nodeContentSanitized";
    ACTION["OFFLINE_STORAGE_TOO_MANY_RETRIES_ERROR"] = "offlineStorageTooManyRetriesError";
    ACTION["OFFLINE_STORAGE_FAILED_STEPS"] = "offlineStorageFailedSteps";
    ACTION["OFFLINE_STORAGE_STEPS_DATABASE_ERROR"] = "offlineStorageStepsDatabaseError";
    ACTION["OFFLINE_STORAGE_RESYNC_ONLINE"] = "offlineStorageResyncOnline";
    ACTION["OFFLINE_STORAGE_BROADCAST_CHANNEL_FIRST_UPDATE"] = "offlineStorageBroadcastChannelFirstUpdate";
    ACTION["OPENED"] = "opened";
    ACTION["OUTDENTED"] = "outdented";
    ACTION["PASTED"] = "pasted";
    ACTION["PASTED_AS_PLAIN"] = "pastedAsPlain";
    ACTION["PASTED_TIMED"] = "pastedTimed";
    ACTION["PRESSED"] = "pressed";
    ACTION["PROSEMIRROR_RENDERED"] = "proseMirrorRendered";
    ACTION["REACT_NODEVIEW_RENDERED"] = "reactNodeViewRendered";
    ACTION["REPLACED_ALL"] = "replacedAll";
    ACTION["REPLACED_ONE"] = "replacedOne";
    ACTION["RESOLVED"] = "resolved";
    ACTION["REQUEST_TO_EDIT"] = "requestToEdit";
    ACTION["SELECTED"] = "selected";
    ACTION["SHOWN"] = "shown";
    ACTION["SLOW_INPUT"] = "slowInput";
    ACTION["STARTED"] = "started";
    ACTION["STOPPED"] = "stopped";
    ACTION["SUBMITTED"] = "submitted";
    ACTION["SUBSTITUTED"] = "autoSubstituted";
    ACTION["SYNCHRONY_DISCONNECTED"] = "synchronyDisconnected";
    ACTION["SYNCHRONY_ENTITY_ERROR"] = "synchronyEntityError";
    ACTION["SYNCHRONY_ERROR"] = "synchronyError";
    ACTION["TEXT_LINK_MARK_TRANSFORMED"] = "textLinkMarkTransformed";
    ACTION["TOGGLED"] = "toggled";
    ACTION["DEDUPE_MARKS_TRANSFORMED_V2"] = "dedupeMarksTransformedV2";
    ACTION["NODES_MISSING_CONTENT_TRANSFORMED"] = "nodesMissingContentTransformed";
    ACTION["INDENTATION_MARKS_TRANSFORMED"] = "indentationMarksTransformed";
    ACTION["INVALID_MEDIA_CONTENT_TRANSFORMED"] = "invalidMediaContentTransformed";
    ACTION["TOGGLE_EXPAND"] = "toggleExpand";
    ACTION["TRANSACTION_MUTATED_AFTER_DISPATCH"] = "transactionMutatedAfterDispatched";
    ACTION["TYPING_FINISHED"] = "typingFinished";
    ACTION["TYPING_STARTED"] = "typingStarted";
    ACTION["UNHANDLED_ERROR_CAUGHT"] = "unhandledErrorCaught";
    ACTION["UNLINK"] = "unlinked";
    ACTION["UNSUPPORTED_CONTENT_ENCOUNTERED"] = "unsupportedContentEncounteredV2";
    ACTION["UPDATED"] = "updated";
    /** used in @atlassian/editor-referentiality */ ACTION["UPDATED_FRAGMENT_MARK_NAME"] = "updatedFragmentMarkName";
    /** used in @atlassian/editor-referentiality */ ACTION["UPDATED_SOURCE"] = "updatedSource";
    /** used in @atlassian/editor-referentiality */ ACTION["UPDATED_TARGET"] = "updatedTarget";
    ACTION["UPLOAD_EXTERNAL_FAIL"] = "uploadExternalFailed";
    ACTION["VIEWED"] = "viewed";
    ACTION["VISITED"] = "visited";
    ACTION["WITH_PLUGIN_STATE_CALLED"] = "withPluginStateCalled";
    ACTION["RENDERED"] = "rendered";
    ACTION["ON_EDITOR_READY_CALLBACK"] = "onEditorReadyCallback";
    /**
	 * @private
	 * @deprecated
	 *
	 * This is no longer used and can be removed at a later date
	 */ ACTION["ON_CHANGE_CALLBACK"] = "onChangeCalled";
    ACTION["NESTED_TABLE_TRANSFORMED"] = "nestedTableTransformed";
    ACTION["NEW_COLLAB_SYNC_UP_ERROR_NO_STEPS"] = "newCollabSyncUpErrorNoSteps";
    ACTION["REMOVE_ICON"] = "removedIcon";
    ACTION["INVALID_PROSEMIRROR_DOCUMENT"] = "invalidProsemirrorDocument";
    ACTION["DOCUMENT_PROCESSING_ERROR"] = "documentProcessingErrorV2";
    ACTION["CRASHED"] = "unhandledErrorCaughtV2";
    ACTION["SELECT_ALL_CAUGHT"] = "selectAllCaught";
    ACTION["SELECT_ALL_ESCAPED"] = "selectAllEscaped";
    ACTION["SORT_COLUMN"] = "sortedColumn";
    ACTION["SORT_COLUMN_NOT_ALLOWED"] = "sortColumnNotAllowed";
    ACTION["NCS_SESSION_STEP_METRICS"] = "ncsSessionStepMetrics";
    ACTION["STEPS_TRACKED"] = "stepsTracked";
    ACTION["STEPS_FILTERED"] = "stepsFiltered";
    ACTION["CREATE_NOT_ALLOWED"] = "createNotAllowed";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_SUCCEEDED"] = "unsupportedContentLevelsTrackingSucceeded";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_ERRORED"] = "unsupportedContentLevelsTrackingErrored";
    ACTION["UNSUPPORTED_TOOLTIP_VIEWED"] = "viewed";
    ACTION["RECORD_VIDEO"] = "recordVideo";
    ACTION["INSERT_VIDEO"] = "insertVideo";
    ACTION["RECORD_VIDEO_FAILED"] = "recordVideoFailed";
    ACTION["ADD_CHILD"] = "addChild";
    ACTION["CHANGE_ACTIVE"] = "changeActive";
    ACTION["REMOVE_CHILD"] = "removeChild";
    ACTION["UPDATE_PARAMETERS"] = "updateParameters";
    ACTION["GET_CHILDREN"] = "getChildren";
    ACTION["GET_CHILDREN_CONTAINER"] = "getChildrenContainer";
    ACTION["MOVED"] = "moved";
    ACTION["UPLOAD_COMMENCED"] = "uploadCommenced";
    ACTION["UPLOAD_SUCCEEDED"] = "uploadSucceeded";
    ACTION["UPLOAD_FAILED"] = "uploadFailed";
    ACTION["TOGGLE_CODE_BLOCK_WRAP"] = "toggleCodeBlockWrap";
    ACTION["RESIZED"] = "resized";
    ACTION["RESIZED_PERF_SAMPLING"] = "resizedPerfSampling";
    ACTION["BLOCKS_DRAG_INIT"] = "blocksDragInit";
    ACTION["SINGLE_COL_LAYOUT_DETECTED"] = "singleColumLayoutDetected";
    ACTION["VIEW_MORE"] = "viewMore";
    /**
	 * used in Editor AI inline suggestion for a track event when a suggestion is inserted
	 * previously tracked events being used by Editor AI proactive suggestion
	 *
	 */ ACTION["SUGGESTION_INSERTED"] = "suggestionInserted";
    ACTION["SUGGESTION_DISMISSED"] = "suggestionDismissed";
    ACTION["SUGGESTION_VIEWED"] = "suggestionViewed";
    return ACTION;
}({});
var $17b833dfd922470c$export$85f107b1fcc9d96f = /*#__PURE__*/ function(INPUT_METHOD) {
    INPUT_METHOD["ASCII"] = "ascii";
    INPUT_METHOD["AUTO"] = "auto";
    INPUT_METHOD["AUTO_DETECT"] = "autoDetect";
    INPUT_METHOD["BUTTON"] = "button";
    INPUT_METHOD["BLUR"] = "blur";
    INPUT_METHOD["CARD"] = "card";
    INPUT_METHOD["CLIPBOARD"] = "clipboard";
    INPUT_METHOD["CONFIG_PANEL"] = "configPanel";
    INPUT_METHOD["CONTEXT_MENU"] = "contextMenu";
    INPUT_METHOD["DRAG_AND_DROP"] = "dragAndDrop";
    INPUT_METHOD["DRAG"] = "drag";
    INPUT_METHOD["EXTERNAL"] = "external";
    INPUT_METHOD["EXTENSION_API"] = "extensionApi";
    INPUT_METHOD["FLOATING_TB"] = "floatingToolbar";
    INPUT_METHOD["FORMATTING"] = "autoformatting";
    INPUT_METHOD["INSERT_MENU"] = "insertMenu";
    INPUT_METHOD["INSERT_MENU_RIGHT_RAIL"] = "insertMenuRightRail";
    INPUT_METHOD["KEYBOARD"] = "keyboard";
    INPUT_METHOD["MEDIA_PICKER"] = "mediaPicker";
    INPUT_METHOD["MACRO_BROWSER"] = "macroBrowser";
    INPUT_METHOD["MANUAL"] = "manual";
    INPUT_METHOD["PICKER"] = "picker";
    INPUT_METHOD["PICKER_CLOUD"] = "cloudPicker";
    INPUT_METHOD["PREFILL"] = "prefill";
    INPUT_METHOD["QUICK_INSERT"] = "quickInsert";
    INPUT_METHOD["SHORTCUT"] = "shortcut";
    INPUT_METHOD["TOOLBAR"] = "toolbar";
    INPUT_METHOD["TYPEAHEAD"] = "typeAhead";
    INPUT_METHOD["DATASOURCE"] = "datasource_config";
    INPUT_METHOD["TABLE_CONTEXT_MENU"] = "tableContextMenu";
    INPUT_METHOD["MOUSE"] = "mouse";
    INPUT_METHOD["BROWSER"] = "browser";
    INPUT_METHOD["DOUBLE_CLICK"] = "doubleClick";
    INPUT_METHOD["META_CLICK"] = "metaClick";
    INPUT_METHOD["INLINE_SUGGESTION_FLOATING_TB"] = "inlineSuggestionFloatingToolbar";
    return INPUT_METHOD;
}({});
var $17b833dfd922470c$export$9b31fa32ae3f8051 = /*#__PURE__*/ function(INSERT_MEDIA_VIA) {
    INSERT_MEDIA_VIA["LOCAL_UPLOAD"] = "localUpload";
    INSERT_MEDIA_VIA["EXTERNAL_URL"] = "externalUrl";
    INSERT_MEDIA_VIA["EXTERNAL_UPLOAD"] = "externalUpload";
    return INSERT_MEDIA_VIA;
}({});
var $17b833dfd922470c$export$81a8b7dba1aa8f75 = /*#__PURE__*/ function(TRIGGER_METHOD) {
    TRIGGER_METHOD["BUTTON"] = "button";
    TRIGGER_METHOD["KEYBOARD"] = "keyboard";
    TRIGGER_METHOD["SHORTCUT"] = "shortcut";
    TRIGGER_METHOD["TOOLBAR"] = "toolbar";
    TRIGGER_METHOD["EXTERNAL"] = "external";
    return TRIGGER_METHOD;
}({});
var $17b833dfd922470c$export$7525482b5931e326 = /*#__PURE__*/ function(ACTION_SUBJECT) {
    ACTION_SUBJECT["AI_INTERACTION"] = "aiInteraction";
    ACTION_SUBJECT["AI_RESULT"] = "aiResult";
    ACTION_SUBJECT["AI_FEEDBACK"] = "aiFeedback";
    ACTION_SUBJECT["COLLAB"] = "collab";
    ACTION_SUBJECT["TOOLBAR_BUTTON"] = "toolbarButton";
    ACTION_SUBJECT["BUTTON"] = "button";
    ACTION_SUBJECT["CONFIG_PANEL"] = "configPanel";
    ACTION_SUBJECT["CONTENT_COMPONENT"] = "contentComponent";
    ACTION_SUBJECT["DATE"] = "date";
    ACTION_SUBJECT["DATE_SEGMENT"] = "dateSegment";
    ACTION_SUBJECT["DOCUMENT"] = "document";
    ACTION_SUBJECT["EDITOR"] = "editor";
    ACTION_SUBJECT["ACTIVITY_SESSION"] = "activitySession";
    ACTION_SUBJECT["ELEMENT_BROWSER"] = "elementBrowser";
    ACTION_SUBJECT["EMBEDS"] = "embeds";
    ACTION_SUBJECT["EXPAND"] = "expand";
    ACTION_SUBJECT["EXTENSION"] = "extension";
    ACTION_SUBJECT["FEATURE"] = "feature";
    ACTION_SUBJECT["FEEDBACK_DIALOG"] = "feedbackDialog";
    ACTION_SUBJECT["FIND_REPLACE_DIALOG"] = "findReplaceDialog";
    ACTION_SUBJECT["FLOATING_CONTEXTUAL_BUTTON"] = "floatingContextualButton";
    ACTION_SUBJECT["FLOATING_TOOLBAR_PLUGIN"] = "floatingToolbarPlugin";
    ACTION_SUBJECT["HELP"] = "help";
    ACTION_SUBJECT["INVITE_ITEM"] = "inviteItem";
    ACTION_SUBJECT["LAYOUT"] = "layout";
    ACTION_SUBJECT["LIST"] = "list";
    ACTION_SUBJECT["MEDIA"] = "media";
    ACTION_SUBJECT["MEDIA_GROUP"] = "mediaGroup";
    ACTION_SUBJECT["MEDIA_INLINE"] = "mediaInline";
    ACTION_SUBJECT["MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT["MENTION"] = "mention";
    ACTION_SUBJECT["MENTION_TYPEAHEAD"] = "mentionTypeahead";
    ACTION_SUBJECT["NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT["PANEL"] = "panel";
    ACTION_SUBJECT["PICKER"] = "picker";
    ACTION_SUBJECT["PLUS_MENU"] = "plusMenu";
    ACTION_SUBJECT["PLUGIN_SLOT"] = "pluginSlot";
    ACTION_SUBJECT["REQUEST_TO_EDIT_POP_UP"] = "requestToEditPopUp";
    ACTION_SUBJECT["REACT_NODE_VIEW"] = "reactNodeView";
    ACTION_SUBJECT["SELECTION"] = "selection";
    ACTION_SUBJECT["SMART_LINK"] = "smartLink";
    ACTION_SUBJECT["HYPERLINK"] = "hyperlink";
    ACTION_SUBJECT["TABLE"] = "table";
    ACTION_SUBJECT["TABLES_PLUGIN"] = "tablesPlugin";
    ACTION_SUBJECT["TEAM_MENTION_TYPEAHEAD"] = "teamMentionTypeahead";
    ACTION_SUBJECT["TELEPOINTER"] = "telepointer";
    ACTION_SUBJECT["TEXT"] = "text";
    ACTION_SUBJECT["TOOLBAR"] = "toolbar";
    ACTION_SUBJECT["TYPEAHEAD"] = "typeAhead";
    ACTION_SUBJECT["TYPEAHEAD_ITEM"] = "typeAheadItem";
    ACTION_SUBJECT["ANNOTATION"] = "annotation";
    ACTION_SUBJECT["SEARCH_RESULT"] = "searchResult";
    ACTION_SUBJECT["CREATE_LINK_INLINE_DIALOG"] = "createLinkInlineDialog";
    ACTION_SUBJECT["CODE_BLOCK"] = "codeBlock";
    ACTION_SUBJECT["REACT_EDITOR_VIEW"] = "reactEditorView";
    ACTION_SUBJECT["RENDERER"] = "renderer";
    ACTION_SUBJECT["ANCHOR_LINK"] = "anchorLink";
    ACTION_SUBJECT["LINK"] = "link";
    ACTION_SUBJECT["TOOLTIP"] = "tooltip";
    ACTION_SUBJECT["LOOM"] = "loom";
    ACTION_SUBJECT["MULTI_BODIED_EXTENSION"] = "multiBodiedExtension";
    ACTION_SUBJECT["BODIED_EXTENSION"] = "bodiedExtension";
    ACTION_SUBJECT["DROP_TARGET"] = "dropTarget";
    ACTION_SUBJECT["DRAG"] = "drag";
    ACTION_SUBJECT["ELEMENT"] = "element";
    ACTION_SUBJECT["INLINE_DIALOG"] = "inlineDialog";
    ACTION_SUBJECT["ENGAGEMENT_PLATFORM"] = "engagementPlatform";
    ACTION_SUBJECT["MEDIA_VIEWER"] = "mediaViewer";
    ACTION_SUBJECT["DECORATION"] = "decoration";
    ACTION_SUBJECT["EDITOR_PLUGIN_AI"] = "editorPluginAI";
    ACTION_SUBJECT["EDITOR_PLUGIN_SELECTION_EXTENSION"] = "editorPluginSelectionExtension";
    ACTION_SUBJECT["AI_DEFINITIONS"] = "aiDefinitions";
    ACTION_SUBJECT["USER_PREFERENCES"] = "userPreferences";
    ACTION_SUBJECT["ALIGNMENT"] = "alignment";
    ACTION_SUBJECT["OFFLINE_EDITING"] = "offlineEditing";
    return ACTION_SUBJECT;
}({});
var $17b833dfd922470c$export$9957974f8b4d8f74 = /*#__PURE__*/ function(ACTION_SUBJECT_ID) {
    ACTION_SUBJECT_ID["ACTION"] = "action";
    ACTION_SUBJECT_ID["ACTIVITY"] = "activity";
    ACTION_SUBJECT_ID["AI_DEFINITIONS_DEFINE_BUTTON"] = "aiDefinitionsDefineButton";
    ACTION_SUBJECT_ID["AI_DEFINITIONS_AUTO_HIGHLIGHT"] = "aiDefinitionsAutoHighlight";
    ACTION_SUBJECT_ID["AI_INLINE_SUGGESTION"] = "aiInlineSuggestion";
    ACTION_SUBJECT_ID["AI_PANELS_BODIED_EXTENSION"] = "aiPanelsBodiedExtension";
    ACTION_SUBJECT_ID["AI_PROMPT_LINK_PICKER_BUTTON"] = "aiPromptLinkPickerButton";
    ACTION_SUBJECT_ID["AI_PROMPT_MENTION_BUTTON"] = "aiPromptMentionButton";
    ACTION_SUBJECT_ID["AI_PROACTIVE_FEEDBACK_DIALOG"] = "aiProactiveFeedbackDialog";
    ACTION_SUBJECT_ID["ALL"] = "all";
    ACTION_SUBJECT_ID["ALT_TEXT"] = "altText";
    ACTION_SUBJECT_ID["ANNOTATE_BUTTON"] = "annotateButton";
    ACTION_SUBJECT_ID["AVATAR_GROUP_PLUGIN"] = "AvatarGroupInPlugin";
    ACTION_SUBJECT_ID["BLOCK_QUOTE"] = "blockQuote";
    ACTION_SUBJECT_ID["BORDER"] = "border";
    ACTION_SUBJECT_ID["BUTTON_CATEGORY"] = "categoryButton";
    ACTION_SUBJECT_ID["BUTTON_FEEDBACK"] = "feedbackButton";
    ACTION_SUBJECT_ID["BUTTON_HELP"] = "helpButton";
    ACTION_SUBJECT_ID["CANCEL"] = "cancel";
    ACTION_SUBJECT_ID["CAPTION"] = "caption";
    ACTION_SUBJECT_ID["CARD_BLOCK"] = "blockCard";
    ACTION_SUBJECT_ID["CARD_INLINE"] = "inlineCard";
    ACTION_SUBJECT_ID["CELL"] = "cell";
    ACTION_SUBJECT_ID["CODE_BLOCK"] = "codeBlock";
    ACTION_SUBJECT_ID["CODEBLOCK_COPY"] = "codeBlockCopy";
    ACTION_SUBJECT_ID["CODEBLOCK_WRAP"] = "codeBlockWrap";
    ACTION_SUBJECT_ID["COPY_BUTTON"] = "copyButton";
    ACTION_SUBJECT_ID["COPY_LINK_TO_ANCHOR"] = "copyLinkToAnchor";
    ACTION_SUBJECT_ID["CREATE_INLINE_COMMENT_FROM_HIGHLIGHT_ACTIONS_MENU"] = "createInlineCommentFromHighlightActionsMenu";
    ACTION_SUBJECT_ID["DATE"] = "date";
    ACTION_SUBJECT_ID["DATE_DAY"] = "day";
    ACTION_SUBJECT_ID["DATE_MONTH"] = "month";
    ACTION_SUBJECT_ID["DATE_YEAR"] = "year";
    ACTION_SUBJECT_ID["DECISION"] = "decision";
    ACTION_SUBJECT_ID["DIVIDER"] = "divider";
    ACTION_SUBJECT_ID["EDIT_LINK"] = "editLink";
    ACTION_SUBJECT_ID["EDIT_DATASOURCE"] = "editDatasource";
    ACTION_SUBJECT_ID["EDITOR_PLUGIN_AI"] = "editorPluginAI";
    ACTION_SUBJECT_ID["ELEMENT_DRAG_HANDLE"] = "elementDragHandle";
    ACTION_SUBJECT_ID["ELEMENT_DROP_TARGET"] = "elementDropTarget";
    ACTION_SUBJECT_ID["EMBEDS"] = "embeds";
    ACTION_SUBJECT_ID["EMOJI"] = "emoji";
    ACTION_SUBJECT_ID["EXPAND"] = "expand";
    ACTION_SUBJECT_ID["EXPERIENCE_APPLICATION"] = "experienceApplication";
    ACTION_SUBJECT_ID["EXTENSION"] = "extension";
    ACTION_SUBJECT_ID["EXTENSION_API"] = "extensionApi";
    ACTION_SUBJECT_ID["EXTENSION_BLOCK"] = "extension";
    ACTION_SUBJECT_ID["EXTENSION_BODIED"] = "bodiedExtension";
    ACTION_SUBJECT_ID["EXTENSION_INLINE"] = "inlineExtension";
    ACTION_SUBJECT_ID["FLOATING_TOOLBAR_OVERFLOW"] = "floatingToolbarOverflow";
    ACTION_SUBJECT_ID["FORMAT_BACKGROUND_COLOR"] = "backgroundColor";
    ACTION_SUBJECT_ID["FORMAT_BLOCK_QUOTE"] = "blockQuote";
    ACTION_SUBJECT_ID["FORMAT_CLEAR"] = "clearFormatting";
    ACTION_SUBJECT_ID["FORMAT_CODE"] = "code";
    ACTION_SUBJECT_ID["FORMAT_COLOR"] = "color";
    ACTION_SUBJECT_ID["FORMAT_HEADING"] = "heading";
    ACTION_SUBJECT_ID["FORMAT_INDENT"] = "indentation";
    ACTION_SUBJECT_ID["FORMAT_ITALIC"] = "italic";
    ACTION_SUBJECT_ID["FORMAT_LIST_BULLET"] = "bulletedList";
    ACTION_SUBJECT_ID["FORMAT_LIST_NUMBER"] = "numberedList";
    ACTION_SUBJECT_ID["FORMAT_STRIKE"] = "strike";
    ACTION_SUBJECT_ID["FORMAT_STRONG"] = "strong";
    ACTION_SUBJECT_ID["FORMAT_SUB"] = "subscript";
    ACTION_SUBJECT_ID["FORMAT_SUPER"] = "superscript";
    ACTION_SUBJECT_ID["FORMAT_UNDERLINE"] = "underline";
    ACTION_SUBJECT_ID["FRAGMENT_MARK"] = "fragmentMark";
    ACTION_SUBJECT_ID["GOTO_SMART_LINK_SETTINGS"] = "goToSmartLinkSettings";
    ACTION_SUBJECT_ID["HELP_QUICK_INSERT"] = "helpQuickInsert";
    ACTION_SUBJECT_ID["HYPERLINK"] = "hyperlink";
    ACTION_SUBJECT_ID["INLINE_COMMENT"] = "inlineComment";
    ACTION_SUBJECT_ID["LAYOUT"] = "layout";
    ACTION_SUBJECT_ID["LINE_BREAK"] = "lineBreak";
    ACTION_SUBJECT_ID["LINK"] = "link";
    ACTION_SUBJECT_ID["LINK_PREVIEW"] = "linkPreview";
    ACTION_SUBJECT_ID["LINK_SEARCH_INPUT"] = "linkSearchInput";
    ACTION_SUBJECT_ID["MEDIA"] = "media";
    ACTION_SUBJECT_ID["MEDIA_GROUP"] = "mediaGroup";
    ACTION_SUBJECT_ID["MEDIA_INLINE"] = "mediaInline";
    ACTION_SUBJECT_ID["MEDIA_INLINE_IMAGE"] = "mediaInlineImage";
    ACTION_SUBJECT_ID["MEDIA_LINK"] = "mediaLink";
    ACTION_SUBJECT_ID["MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT_ID["MENTION"] = "mention";
    ACTION_SUBJECT_ID["MENTION_PROVIDER"] = "mentionProvider";
    ACTION_SUBJECT_ID["NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT_ID["NODE"] = "node";
    ACTION_SUBJECT_ID["OPEN_LINK"] = "openLink";
    ACTION_SUBJECT_ID["OFFLINE_EDITING"] = "offlineEditing";
    ACTION_SUBJECT_ID["PANEL"] = "panel";
    ACTION_SUBJECT_ID["PASTE_BLOCK_CARD"] = "blockCard";
    ACTION_SUBJECT_ID["PASTE_BLOCKQUOTE"] = "blockQuote";
    ACTION_SUBJECT_ID["PASTE_BODIED_EXTENSION"] = "bodiedExtension";
    ACTION_SUBJECT_ID["PASTE_BULLET_LIST"] = "bulletList";
    ACTION_SUBJECT_ID["PASTE_CODE_BLOCK"] = "codeBlock";
    ACTION_SUBJECT_ID["PASTE_DECISION_LIST"] = "decisionList";
    ACTION_SUBJECT_ID["PASTE_EXPAND"] = "expand";
    ACTION_SUBJECT_ID["PASTE_EXTENSION"] = "extension";
    ACTION_SUBJECT_ID["PASTE_HEADING"] = "heading";
    ACTION_SUBJECT_ID["PASTE_MEDIA_GROUP"] = "mediaGroup";
    ACTION_SUBJECT_ID["PASTE_MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT_ID["PASTE_NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT_ID["PASTE_ORDERED_LIST"] = "orderedList";
    ACTION_SUBJECT_ID["PASTE_PANEL"] = "panel";
    ACTION_SUBJECT_ID["PASTE_PARAGRAPH"] = "paragraph";
    ACTION_SUBJECT_ID["PASTE_RULE"] = "rule";
    ACTION_SUBJECT_ID["PASTE_TABLE"] = "table";
    ACTION_SUBJECT_ID["PASTE_TABLE_CELL"] = "tableCell";
    ACTION_SUBJECT_ID["PASTE_TABLE_HEADER"] = "tableHeader";
    ACTION_SUBJECT_ID["PASTE_TABLE_ROW"] = "tableRow";
    ACTION_SUBJECT_ID["PASTE_TASK_LIST"] = "taskList";
    ACTION_SUBJECT_ID["PICKER_CLOUD"] = "cloudPicker";
    ACTION_SUBJECT_ID["PICKER_MEDIA"] = "mediaPicker";
    ACTION_SUBJECT_ID["PICKER_COLOR"] = "colorPicker";
    ACTION_SUBJECT_ID["PICKER_EMOJI"] = "emojiPicker";
    ACTION_SUBJECT_ID["PICKER_TABLE_SIZE"] = "tableSizePicker";
    ACTION_SUBJECT_ID["DOCKED_PRIMARY_TOOLBAR"] = "dockedPrimaryToolbar";
    ACTION_SUBJECT_ID["PLACEHOLDER_TEXT"] = "placeholderText";
    ACTION_SUBJECT_ID["POST_QUERY_SEARCH_RESULTS"] = "postQuerySearchResults";
    ACTION_SUBJECT_ID["PRE_QUERY_SEARCH_RESULTS"] = "preQuerySearchResults";
    ACTION_SUBJECT_ID["PROACTIVE_SUGGESTION"] = "proactiveSuggestion";
    ACTION_SUBJECT_ID["PRODUCT_NAME"] = "productName";
    ACTION_SUBJECT_ID["PUNC"] = "punctuation";
    ACTION_SUBJECT_ID["QUICK_SEARCH"] = "quickSearch";
    ACTION_SUBJECT_ID["RANGE"] = "range";
    ACTION_SUBJECT_ID["REACT_NODE_VIEW"] = "reactNodeView";
    ACTION_SUBJECT_ID["RECENT_ACTIVITIES"] = "recentActivities";
    ACTION_SUBJECT_ID["RESIZED"] = "resized";
    ACTION_SUBJECT_ID["RESPONSE_FEEDBACK_BUTTON"] = "responseFeedbackButton";
    ACTION_SUBJECT_ID["RICH_MEDIA_LAYOUT"] = "richMediaLayout";
    ACTION_SUBJECT_ID["SAVE"] = "save";
    ACTION_SUBJECT_ID["SECTION"] = "section";
    ACTION_SUBJECT_ID["SMART_LINK"] = "smartLink";
    ACTION_SUBJECT_ID["SMART_LINK_TOOLBAR"] = "smartLinkToolbar";
    ACTION_SUBJECT_ID["STATUS"] = "status";
    ACTION_SUBJECT_ID["SYMBOL"] = "symbol";
    ACTION_SUBJECT_ID["TABLE"] = "table";
    ACTION_SUBJECT_ID["TELEPOINTER"] = "telepointer";
    ACTION_SUBJECT_ID["TEXT"] = "text";
    ACTION_SUBJECT_ID["TYPEAHEAD_EMOJI"] = "emojiTypeAhead";
    ACTION_SUBJECT_ID["TYPEAHEAD_LINK"] = "linkTypeAhead";
    ACTION_SUBJECT_ID["TYPEAHEAD_MENTION"] = "mentionTypeAhead";
    ACTION_SUBJECT_ID["TYPEAHEAD_QUICK_INSERT"] = "quickInsertTypeAhead";
    ACTION_SUBJECT_ID["UNKNOWN_NODE"] = "unknownNode";
    ACTION_SUBJECT_ID["UNLINK"] = "unlink";
    ACTION_SUBJECT_ID["HEADING_ANCHOR_LINK"] = "headingAnchorLink";
    ACTION_SUBJECT_ID["UNSUPPORTED_ERROR"] = "unsupportedUnhandled";
    ACTION_SUBJECT_ID["UNSUPPORTED_NODE_ATTRIBUTE"] = "unsupportedNodeAttribute";
    ACTION_SUBJECT_ID["UNSUPPORTED_BLOCK"] = "unsupportedBlock";
    ACTION_SUBJECT_ID["UNSUPPORTED_INLINE"] = "unsupportedInline";
    ACTION_SUBJECT_ID["UNSUPPORTED_MARK"] = "unsupportedMark";
    ACTION_SUBJECT_ID["ON_UNSUPPORTED_INLINE"] = "onUnsupportedInline";
    ACTION_SUBJECT_ID["ON_UNSUPPORTED_BLOCK"] = "onUnsupportedBlock";
    ACTION_SUBJECT_ID["MULTI_BODIED_EXTENSION"] = "multiBodiedExtension";
    ACTION_SUBJECT_ID["UPLOAD_MEDIA"] = "uploadMedia";
    ACTION_SUBJECT_ID["SELECTION_TOOLBAR_PREFERENCES"] = "selectionToolbarPreferences";
    ACTION_SUBJECT_ID["EDITOR_PLUGIN_SELECTION_EXTENSION_DROPDOWN"] = "editorPluginSelectionExtensionDropdown";
    ACTION_SUBJECT_ID["EDITOR_PLUGIN_SELECTION_EXTENSION_ITEM"] = "editorPluginSelectionExtensionItem";
    ACTION_SUBJECT_ID["EDITOR_PLUGIN_SELECTION_EXTENSION_COMPONENT"] = "editorPluginSelectionExtensionComponent";
    return ACTION_SUBJECT_ID;
}({});
var $17b833dfd922470c$export$75ef928acd21e35b = /*#__PURE__*/ function(FLOATING_CONTROLS_TITLE) {
    FLOATING_CONTROLS_TITLE["CODE_BLOCK"] = "codeBlockFloatingControls";
    FLOATING_CONTROLS_TITLE["EXTENSION"] = "extensionFloatingControls";
    FLOATING_CONTROLS_TITLE["HYPERLINK"] = "hyperlinkFloatingControls";
    FLOATING_CONTROLS_TITLE["MEDIA"] = "mediaFloatingControls";
    FLOATING_CONTROLS_TITLE["PANEL"] = "panelFloatingControls";
    FLOATING_CONTROLS_TITLE["TABLE"] = "tableFloatingControls";
    FLOATING_CONTROLS_TITLE["EXPAND"] = "expandToolbar";
    return FLOATING_CONTROLS_TITLE;
}({});
var $17b833dfd922470c$export$9f0b2adf3cfd71b7 = /*#__PURE__*/ function(CONTENT_COMPONENT) {
    CONTENT_COMPONENT["INLINE_COMMENT"] = "inlineComment";
    CONTENT_COMPONENT["FLOATING_CONTEXTUAL_BUTTON"] = "floatingContextualButton";
    CONTENT_COMPONENT["FLOATING_INSERT_BUTTON"] = "floatingInsertButton";
    CONTENT_COMPONENT["FLOATING_TOOLBAR"] = "floatingToolbar";
    return CONTENT_COMPONENT;
}({});

});

parcelRegister("gPpAv", function(module, exports) {

$parcel$export(module.exports, "unsupportedContentMessages", () => $240a9a996e10d4f5$export$32ec96484dd3ba39);

var $7qGN1 = parcelRequire("7qGN1");
const $240a9a996e10d4f5$export$32ec96484dd3ba39 = (0, $7qGN1.defineMessages)({
    unsupportedInlineContent: {
        id: 'fabric.editor.unsupportedInlineContent',
        defaultMessage: 'Unsupported content',
        description: 'Unsupported content'
    },
    unsupportedBlockContent: {
        id: 'fabric.editor.unsupportedBlockContent',
        defaultMessage: 'This editor does not support displaying this content',
        description: 'This editor does not support displaying this content'
    },
    unsupportedContentTooltip: {
        id: 'fabric.editor.unsupportedContentTooltip',
        defaultMessage: 'Content is not available in this editor, this will be preserved when you edit and save',
        description: 'Content is not available in this editor, this will be preserved when you edit and save'
    }
});

});

parcelRegister("3mTkR", function(module, exports) {

$parcel$export(module.exports, "findAndTrackUnsupportedContentNodes", () => $66b6d13af08c068e$export$d343369b8f25914);
$parcel$export(module.exports, "fireUnsupportedEvent", () => $66b6d13af08c068e$export$e1051b410945e4d4);
$parcel$export(module.exports, "trackUnsupportedContentTooltipDisplayedFor", () => $66b6d13af08c068e$export$3a34598135e7219b);

var $bMFKb = parcelRequire("bMFKb");
const $66b6d13af08c068e$var$whitelistedAttributes = [
    'align',
    'annotationType',
    'extensionKey',
    'extensionType',
    'layout',
    'type',
    'localId',
    'mode',
    'language',
    'timestamp',
    'state',
    'originalWidth',
    'originalHeight',
    'height',
    'width',
    'shortName',
    'level',
    'userType',
    'order',
    'panelType',
    'color',
    'style',
    'isNumberColumnEnabled',
    'colspan',
    'rowspan',
    'colwidth',
    'background'
];
function $66b6d13af08c068e$var$concatAncestorHierarchy(node, ancestoryHierarchy) {
    const { name: name } = node.type;
    // Space concatenator used to reduce analytics payload size
    return ancestoryHierarchy ? `${ancestoryHierarchy} ${name}` : name;
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $66b6d13af08c068e$var$sanitizeMarks = (marks = [])=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const sanitizedMarks = [];
    marks.forEach((mark)=>{
        if (mark.attrs) {
            const attrs = $66b6d13af08c068e$var$sanitizeAttributes(mark.attrs);
            sanitizedMarks.push({
                ...mark,
                attrs: attrs
            });
        } else sanitizedMarks.push({
            ...mark
        });
    });
    return sanitizedMarks;
};
const $66b6d13af08c068e$var$sanitizeAttributes = (attrs = {})=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const sanitizedAttrs = Object.assign({}, attrs);
    Object.keys(attrs).filter((key)=>!$66b6d13af08c068e$var$whitelistedAttributes.includes(key)).forEach((key)=>{
        sanitizedAttrs[key] !== null ? sanitizedAttrs[key] = '' : sanitizedAttrs[key] = 'null';
    });
    return sanitizedAttrs;
};
const $66b6d13af08c068e$var$trackUnsupportedContentTooltipActionFor = (action, dispatchAnalyticsEvent, unsupportedContentType, originalNodeType)=>{
    dispatchAnalyticsEvent({
        action: action,
        actionSubjectId: unsupportedContentType,
        actionSubject: (0, $bMFKb.ACTION_SUBJECT).TOOLTIP,
        eventType: (0, $bMFKb.EVENT_TYPE).UI,
        attributes: {
            unsupportedNodeType: originalNodeType
        }
    });
};
const $66b6d13af08c068e$export$d343369b8f25914 = (node, schema, dispatchAnalyticsEvent, ancestorHierarchy = '')=>{
    const { type: nodeType, marks: nodeMarks } = node;
    const { unsupportedMark: unsupportedMark, unsupportedNodeAttribute: unsupportedNodeAttribute } = schema.marks;
    const { unsupportedInline: unsupportedInline, unsupportedBlock: unsupportedBlock } = schema.nodes;
    const parentType = ancestorHierarchy.split(' ').pop() || '';
    if (nodeMarks.length) nodeMarks.forEach((mark)=>{
        if (mark.type === unsupportedMark) {
            const { originalValue: originalValue } = mark.attrs || {};
            const { type: type } = originalValue || {};
            const unsupportedNode = {
                type: type || '',
                ancestry: ancestorHierarchy,
                parentType: parentType,
                marks: [],
                attrs: originalValue.attrs || {}
            };
            $66b6d13af08c068e$export$e1051b410945e4d4(dispatchAnalyticsEvent, (0, $bMFKb.ACTION_SUBJECT_ID).UNSUPPORTED_MARK, unsupportedNode);
        } else if (mark.type === unsupportedNodeAttribute) {
            const { unsupported: unsupported } = mark.attrs || {};
            const unsupportedNodeAttribute = {
                type: nodeType.name || '',
                ancestry: ancestorHierarchy,
                parentType: parentType,
                marks: [],
                attrs: unsupported || {}
            };
            $66b6d13af08c068e$export$e1051b410945e4d4(dispatchAnalyticsEvent, (0, $bMFKb.ACTION_SUBJECT_ID).UNSUPPORTED_NODE_ATTRIBUTE, unsupportedNodeAttribute);
        }
    });
    if (nodeType === unsupportedInline || nodeType === unsupportedBlock) {
        const { originalValue: originalValue } = node.attrs || {};
        const { marks: marks } = originalValue || [];
        const { attrs: attrs } = originalValue || {};
        const { type: type } = originalValue || {};
        const unsupportedNode = {
            type: type || '',
            ancestry: ancestorHierarchy,
            parentType: parentType,
            marks: marks || [],
            attrs: attrs || {}
        };
        const actionSubjectId = nodeType === unsupportedInline ? (0, $bMFKb.ACTION_SUBJECT_ID).UNSUPPORTED_INLINE : (0, $bMFKb.ACTION_SUBJECT_ID).UNSUPPORTED_BLOCK;
        $66b6d13af08c068e$export$e1051b410945e4d4(dispatchAnalyticsEvent, actionSubjectId, unsupportedNode);
    } else // Recursive check for nested content
    node.content.forEach((childNode)=>$66b6d13af08c068e$export$d343369b8f25914(childNode, schema, dispatchAnalyticsEvent, $66b6d13af08c068e$var$concatAncestorHierarchy(node, ancestorHierarchy)));
};
const $66b6d13af08c068e$export$e1051b410945e4d4 = (dispatchAnalyticsEvent, actionSubjectId, unsupportedNode, errorCode)=>{
    const sanitizedAttrs = $66b6d13af08c068e$var$sanitizeAttributes(unsupportedNode.attrs);
    const sanitizedMarks = $66b6d13af08c068e$var$sanitizeMarks(unsupportedNode.marks);
    const sanitizedUnsupportedNode = {
        type: unsupportedNode.type,
        ancestry: unsupportedNode.ancestry,
        parentType: unsupportedNode.parentType,
        attrs: sanitizedAttrs,
        marks: sanitizedMarks
    };
    const payload = {
        action: (0, $bMFKb.ACTION).UNSUPPORTED_CONTENT_ENCOUNTERED,
        actionSubject: (0, $bMFKb.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: actionSubjectId,
        attributes: {
            unsupportedNode: sanitizedUnsupportedNode,
            ...!!errorCode && {
                errorCode: errorCode
            }
        },
        eventType: (0, $bMFKb.EVENT_TYPE).TRACK
    };
    dispatchAnalyticsEvent(payload);
};
const $66b6d13af08c068e$export$3a34598135e7219b = (dispatchAnalyticsEvent, unsupportedContentType, originalNodeType)=>{
    $66b6d13af08c068e$var$trackUnsupportedContentTooltipActionFor((0, $bMFKb.ACTION).UNSUPPORTED_TOOLTIP_VIEWED, dispatchAnalyticsEvent, unsupportedContentType, originalNodeType);
};

});

parcelRegister("z9Bay", function(module, exports) {

$parcel$export(module.exports, "getUnsupportedContent", () => $bea0a1ed5ad48e2f$export$d4ded51d0f0bd2df);
function $bea0a1ed5ad48e2f$export$d4ded51d0f0bd2df(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
message, prefix, node, intl) {
    const defaultLocale = 'en';
    let canTranslateToLocale = true;
    const locale = intl ? intl.locale : defaultLocale;
    let finalMessage = message.defaultMessage;
    if (node && locale.startsWith(defaultLocale)) {
        const { originalValue: originalValue } = node.attrs;
        if (originalValue.text || originalValue.attrs && originalValue.attrs.text) {
            finalMessage = originalValue.text ? originalValue.text : originalValue.attrs.text;
            canTranslateToLocale = false;
        } else if (originalValue.type) {
            finalMessage = `${prefix} ${originalValue.type}`;
            canTranslateToLocale = false;
        }
    }
    if (intl && canTranslateToLocale) return intl.formatMessage(message);
    return finalMessage;
}

});


parcelRegister("lilfD", function(module, exports) {

$parcel$export(module.exports, "WithCreateAnalyticsEvent", () => $7560959cd315952a$export$9ac3d19711324187);

var $eJOHy = parcelRequire("eJOHy");

var $4J0ad = parcelRequire("4J0ad");
const $7560959cd315952a$export$9ac3d19711324187 = (0, $4J0ad.default)()(class WithCreateAnalyticsEvent extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    render() {
        const { render: render, createAnalyticsEvent: createAnalyticsEvent } = this.props;
        return render(createAnalyticsEvent);
    }
});

});

parcelRegister("7EdFW", function(module, exports) {

$parcel$export(module.exports, "browser", () => $4f85d3430881614f$export$3f2684e5d7cb1006);
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $4f85d3430881614f$export$3f2684e5d7cb1006 = {
    mac: false,
    windows: false,
    ie: false,
    ie_version: 0,
    gecko: false,
    gecko_version: 0,
    chrome: false,
    chrome_version: 0,
    android: false,
    ios: false,
    webkit: false,
    safari: false,
    safari_version: 0,
    supportsIntersectionObserver: false,
    supportsResizeObserver: false
};
if (typeof navigator !== 'undefined') {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const ieEdge = /(?:Edge|Edg)\/(\d+)/.exec(navigator.userAgent);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const ieUpTo10 = /MSIE \d/.test(navigator.userAgent);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const ie11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    $4f85d3430881614f$export$3f2684e5d7cb1006.mac = /Mac/.test(navigator.platform);
    $4f85d3430881614f$export$3f2684e5d7cb1006.windows = // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    navigator.userAgentData?.platform === 'Windows' || // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    /Windows|Win\d+/i.test(navigator.userAgent);
    const ie = $4f85d3430881614f$export$3f2684e5d7cb1006.ie = !!(ieUpTo10 || ie11up || ieEdge);
    $4f85d3430881614f$export$3f2684e5d7cb1006.ie_version = ieUpTo10 ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
    document.documentMode || 6 : ie11up ? +ie11up[1] : ieEdge ? +ieEdge[1] : null;
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    $4f85d3430881614f$export$3f2684e5d7cb1006.gecko = !ie && /gecko\/\d/i.test(navigator.userAgent);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    $4f85d3430881614f$export$3f2684e5d7cb1006.gecko_version = parseInt((navigator.userAgent.match(/Firefox\/(\d+)/) || [])[1], 10);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    $4f85d3430881614f$export$3f2684e5d7cb1006.chrome = !ie && /Chrome\//.test(navigator.userAgent);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    $4f85d3430881614f$export$3f2684e5d7cb1006.chrome_version = parseInt((navigator.userAgent.match(/Chrome\/(\d+)/) || [])[1], 10);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    $4f85d3430881614f$export$3f2684e5d7cb1006.android = /Android \d/.test(navigator.userAgent);
    $4f85d3430881614f$export$3f2684e5d7cb1006.ios = // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    !ie && /AppleWebKit/.test(navigator.userAgent) && /Mobile\/\w+/.test(navigator.userAgent);
    $4f85d3430881614f$export$3f2684e5d7cb1006.webkit = !ie && !!document.documentElement && 'WebkitAppearance' in document.documentElement.style;
    $4f85d3430881614f$export$3f2684e5d7cb1006.safari = Boolean(navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && navigator.userAgent.indexOf('CriOS') === -1 && navigator.userAgent.indexOf('FxiOS') === -1);
    $4f85d3430881614f$export$3f2684e5d7cb1006.safari_version = parseInt(// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    (navigator.userAgent.match(/Version\/([0-9\._]+).*Safari/) || [])[1], 10);
    $4f85d3430881614f$export$3f2684e5d7cb1006.supportsIntersectionObserver = typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    'intersectionRatio' in window.IntersectionObserverEntry.prototype;
    $4f85d3430881614f$export$3f2684e5d7cb1006.supportsResizeObserver = typeof window !== 'undefined' && 'ResizeObserver' in window && 'ResizeObserverEntry' in window;
}

});

parcelRegister("hvjqZ", function(module, exports) {

$parcel$export(module.exports, "startMeasure", () => $7524b3b31c9b447b$export$b62aa2130c86b59b);
$parcel$export(module.exports, "stopMeasure", () => $7524b3b31c9b447b$export$37c25be427bec097);
$parcel$export(module.exports, "clearMeasure", () => $7524b3b31c9b447b$export$6f766653554dac02);

var $8LHnV = parcelRequire("8LHnV");
const $7524b3b31c9b447b$var$measureMap = new Map();
function $7524b3b31c9b447b$export$b62aa2130c86b59b(measureName) {
    if (!(0, $8LHnV.isPerformanceAPIAvailable)()) return;
    performance.mark(`${measureName}::start`);
    $7524b3b31c9b447b$var$measureMap.set(measureName, performance.now());
}
function $7524b3b31c9b447b$export$37c25be427bec097(measureName, onMeasureComplete) {
    if (!(0, $8LHnV.isPerformanceAPIAvailable)()) return;
    performance.mark(`${measureName}::end`);
    const start = onMeasureComplete ? $7524b3b31c9b447b$var$measureMap.get(measureName) : undefined;
    try {
        performance.measure(measureName, `${measureName}::start`, `${measureName}::end`);
    } catch (error) {} finally{
        if (onMeasureComplete) {
            const entry = performance.getEntriesByName(measureName).pop();
            if (entry) onMeasureComplete(entry.duration, entry.startTime);
            else if (start) onMeasureComplete(performance.now() - start, start);
        }
        $7524b3b31c9b447b$export$6f766653554dac02(measureName);
    }
}
function $7524b3b31c9b447b$export$6f766653554dac02(measureName) {
    if (!(0, $8LHnV.isPerformanceAPIAvailable)()) return;
    $7524b3b31c9b447b$var$measureMap.delete(measureName);
    performance.clearMarks(`${measureName}::start`);
    performance.clearMarks(`${measureName}::end`);
    performance.clearMeasures(measureName);
}
function $7524b3b31c9b447b$export$b0a51f9f0047ea32(measureName) {
    if (!(0, $8LHnV.isPerformanceAPIAvailable)()) return false;
    return $7524b3b31c9b447b$var$measureMap.get(measureName) !== undefined;
}

});
parcelRegister("8LHnV", function(module, exports) {

$parcel$export(module.exports, "isPerformanceAPIAvailable", () => $25dcd805afa5e07f$export$b5717a625dd4a3eb);
$parcel$export(module.exports, "isPerformanceObserverAvailable", () => $25dcd805afa5e07f$export$48995af1e77d8643);
let $25dcd805afa5e07f$var$hasRequiredPerformanceAPIs;
function $25dcd805afa5e07f$export$b5717a625dd4a3eb() {
    if ($25dcd805afa5e07f$var$hasRequiredPerformanceAPIs === undefined) $25dcd805afa5e07f$var$hasRequiredPerformanceAPIs = typeof window !== 'undefined' && 'performance' in window && [
        'measure',
        'clearMeasures',
        'clearMarks',
        'getEntriesByName',
        'getEntriesByType',
        'now'
    ].every((api)=>!!performance[api]);
    return $25dcd805afa5e07f$var$hasRequiredPerformanceAPIs;
}
function $25dcd805afa5e07f$export$48995af1e77d8643() {
    return !!(typeof window !== 'undefined' && 'PerformanceObserver' in window);
}
function $25dcd805afa5e07f$export$4370ec0f52022f66() {
    return $25dcd805afa5e07f$export$48995af1e77d8643() && PerformanceObserver.supportedEntryTypes && PerformanceObserver.supportedEntryTypes.includes('longtask');
}

});


parcelRegister("65rqJ", function(module, exports) {

$parcel$export(module.exports, "getDistortedDurationMonitor", () => $bca630d6f152961c$export$70f7d127254a90c);
$parcel$export(module.exports, "measureRender", () => $bca630d6f152961c$export$267ed650a5d21ae6);

var $8LHnV = parcelRequire("8LHnV");
const $bca630d6f152961c$export$70f7d127254a90c = ()=>{
    if (typeof document === 'undefined') return {
        distortedDuration: false,
        cleanup () {}
    };
    // If an editor is rendered when the document is not visible -- the callback passed to
    // requestAnimationFrame will not fire until the document becomes visible again.
    //
    // For the purposes of using performance measurement -- this behaviour means the events
    // which have been fired in the background are not useful -- and lead to other events
    // being hard to draw conclusions from.
    //
    // To mitigate this -- we detect this state -- and fire a separate callback when the
    // measurement has occurred when the render was in the background
    let distortedDuration = document.visibilityState !== 'visible';
    function handleVisibilityChange() {
        if (document.visibilityState !== 'visible') distortedDuration = true;
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return {
        distortedDuration: distortedDuration,
        /**
		 * Cleans up the document visibility event listener
		 */ cleanup () {
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        }
    };
};
function $bca630d6f152961c$export$267ed650a5d21ae6(/**
	 * Unique name for the measurement
	 *
	 * Important: if multiple measureRender events are fired at the same time
	 * with the same measure name -- the result will not be correct.
	 */ measureName, /**
	 * Call back fired when the measurement completes.
	 *
	 * Note: when this function is called when the Document.visibilityState is not
	 * visible -- the duration is likely to be misleading/inaccurate. This is due
	 * to the measurements use of the `requestAnimationFrame` api which only fires
	 * when the Document.visibilityState is visible.
	 */ onMeasureComplete) {
    if (!(0, $8LHnV.isPerformanceAPIAvailable)()) return;
    const startMark = `[START]: ${measureName}`;
    const endMark = `[END]: ${measureName}`;
    const startTime = performance.now();
    performance.mark(startMark);
    const distortedDurationMonitor = $bca630d6f152961c$export$70f7d127254a90c();
    requestAnimationFrame(()=>{
        requestAnimationFrame(()=>{
            performance.mark(endMark);
            distortedDurationMonitor.cleanup();
            const duration = performance.now() - startTime;
            try {
                performance.measure(measureName, startMark, endMark);
                const entry = performance.getEntriesByName(measureName).pop();
                if (!entry) onMeasureComplete({
                    duration: duration,
                    startTime: startTime,
                    distortedDuration: distortedDurationMonitor.distortedDuration
                });
                else onMeasureComplete({
                    duration: entry.duration,
                    startTime: entry.startTime,
                    distortedDuration: distortedDurationMonitor.distortedDuration
                });
            } catch (e) {
                onMeasureComplete({
                    duration: duration,
                    startTime: startTime,
                    distortedDuration: distortedDurationMonitor.distortedDuration
                });
            }
            performance.clearMeasures(measureName);
            performance.clearMarks(startMark);
            performance.clearMarks(endMark);
        });
    });
}

});

parcelRegister("Sk9g1", function(module, exports) {

$parcel$export(module.exports, "getResponseEndTime", () => $ac2e032b774c2f79$export$92d097a1155bbe27);

var $8LHnV = parcelRequire("8LHnV");
function $ac2e032b774c2f79$export$92d097a1155bbe27() {
    if (!(0, $8LHnV.isPerformanceAPIAvailable)()) return;
    const nav = performance.getEntriesByType('navigation')[0];
    if (nav) return nav.responseEnd;
    return;
}

});

parcelRegister("dyNYh", function(module, exports) {

$parcel$export(module.exports, "getAnalyticsAppearance", () => $6098e217e78ad5fc$export$be87849653b93e6b);
$parcel$export(module.exports, "getAnalyticsEditorAppearance", () => $6098e217e78ad5fc$export$31ae53e002edded0);
$parcel$export(module.exports, "getAnalyticsEventSeverity", () => $6098e217e78ad5fc$export$f8edd689e8b20f3a);
$parcel$export(module.exports, "findInsertLocation", () => $6098e217e78ad5fc$export$d770b562ead089d8);
$parcel$export(module.exports, "analyticsEventKey", () => $6098e217e78ad5fc$export$288273ee3e3b6132);

var $457Jo = parcelRequire("457Jo");

var $3lIcL = parcelRequire("3lIcL");

var $BmspC = parcelRequire("BmspC");

var $cwzAY = parcelRequire("cwzAY");
const $6098e217e78ad5fc$export$be87849653b93e6b = (appearance)=>{
    switch(appearance){
        case 'full-page':
            return (0, $457Jo.EDITOR_APPEARANCE_CONTEXT).FIXED_WIDTH;
        case 'full-width':
            return (0, $457Jo.EDITOR_APPEARANCE_CONTEXT).FULL_WIDTH;
        case 'comment':
            return (0, $457Jo.EDITOR_APPEARANCE_CONTEXT).COMMENT;
        case 'chromeless':
            return (0, $457Jo.EDITOR_APPEARANCE_CONTEXT).CHROMELESS;
        case 'mobile':
            return (0, $457Jo.EDITOR_APPEARANCE_CONTEXT).MOBILE;
    }
};
const $6098e217e78ad5fc$export$31ae53e002edded0 = (editorAppearance)=>editorAppearance ? `editor_${$6098e217e78ad5fc$export$be87849653b93e6b(editorAppearance)}` : '_unknown';
const $6098e217e78ad5fc$export$f8edd689e8b20f3a = (duration, normalThreshold, degradedThreshold)=>{
    if (duration > normalThreshold && duration <= degradedThreshold) return "degraded";
    if (duration > degradedThreshold) return "blocking";
    return "normal";
};
function $6098e217e78ad5fc$export$d770b562ead089d8(selection) {
    const { schema: schema, name: name } = selection.$from.doc.type;
    if (selection instanceof (0, $3lIcL.NodeSelection)) return selection.node.type.name;
    if (selection instanceof (0, $cwzAY.CellSelection)) return schema.nodes.table.name;
    // Text selection
    const parentNodeInfo = (0, $BmspC.findParentNode)((node)=>node.type !== schema.nodes.paragraph)(selection);
    return parentNodeInfo ? parentNodeInfo.node.type.name : name;
}
var $6098e217e78ad5fc$export$6a6bef12562cd865 = /*#__PURE__*/ function(SEVERITY) {
    SEVERITY["NORMAL"] = "normal";
    SEVERITY["DEGRADED"] = "degraded";
    SEVERITY["BLOCKING"] = "blocking";
    return SEVERITY;
}({});
const $6098e217e78ad5fc$export$288273ee3e3b6132 = 'EDITOR_ANALYTICS_EVENT';

});
parcelRegister("3lIcL", function(module, exports) {

$parcel$export(module.exports, "Selection", () => $27059f7464a1d1f5$export$52baac22726c72bf);
$parcel$export(module.exports, "SelectionRange", () => $27059f7464a1d1f5$export$7bd1839c3c5d5bd4);
$parcel$export(module.exports, "TextSelection", () => $27059f7464a1d1f5$export$c2b25f346d19bcbb);
$parcel$export(module.exports, "AllSelection", () => $27059f7464a1d1f5$export$c15d9ba76bdbcd95);
$parcel$export(module.exports, "NodeSelection", () => $27059f7464a1d1f5$export$e2940151ac854c0b);
$parcel$export(module.exports, "Transaction", () => $27059f7464a1d1f5$export$febc5573c75cefb0);
$parcel$export(module.exports, "EditorState", () => $27059f7464a1d1f5$export$afa855cbfaff27f2);
$parcel$export(module.exports, "Plugin", () => $27059f7464a1d1f5$export$901cf72dabf2112a);
$parcel$export(module.exports, "PluginKey", () => $27059f7464a1d1f5$export$1692d8b0e89cecc3);

var $3xw6l = parcelRequire("3xw6l");

var $lzEKq = parcelRequire("lzEKq");
const $27059f7464a1d1f5$var$classesById = Object.create(null);
/**
Superclass for editor selections. Every selection type should
extend this. Should not be instantiated directly.
*/ class $27059f7464a1d1f5$export$52baac22726c72bf {
    /**
    Initialize a selection with the head and anchor and ranges. If no
    ranges are given, constructs a single range across `$anchor` and
    `$head`.
    */ constructor(/**
    The resolved anchor of the selection (the side that stays in
    place when the selection is modified).
    */ $anchor, /**
    The resolved head of the selection (the side that moves when
    the selection is modified).
    */ $head, ranges){
        this.$anchor = $anchor;
        this.$head = $head;
        this.ranges = ranges || [
            new $27059f7464a1d1f5$export$7bd1839c3c5d5bd4($anchor.min($head), $anchor.max($head))
        ];
    }
    /**
    The selection's anchor, as an unresolved position.
    */ get anchor() {
        return this.$anchor.pos;
    }
    /**
    The selection's head.
    */ get head() {
        return this.$head.pos;
    }
    /**
    The lower bound of the selection's main range.
    */ get from() {
        return this.$from.pos;
    }
    /**
    The upper bound of the selection's main range.
    */ get to() {
        return this.$to.pos;
    }
    /**
    The resolved lower  bound of the selection's main range.
    */ get $from() {
        return this.ranges[0].$from;
    }
    /**
    The resolved upper bound of the selection's main range.
    */ get $to() {
        return this.ranges[0].$to;
    }
    /**
    Indicates whether the selection contains any content.
    */ get empty() {
        let ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++)if (ranges[i].$from.pos != ranges[i].$to.pos) return false;
        return true;
    }
    /**
    Get the content of this selection as a slice.
    */ content() {
        return this.$from.doc.slice(this.from, this.to, true);
    }
    /**
    Replace the selection with a slice or, if no slice is given,
    delete the selection. Will append to the given transaction.
    */ replace(tr, content = (0, $3xw6l.Slice).empty) {
        // Put the new selection at the position after the inserted
        // content. When that ended in an inline node, search backwards,
        // to get the position after that node. If not, search forward.
        let lastNode = content.content.lastChild, lastParent = null;
        for(let i = 0; i < content.openEnd; i++){
            lastParent = lastNode;
            lastNode = lastNode.lastChild;
        }
        let mapFrom = tr.steps.length, ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++){
            let { $from: $from, $to: $to } = ranges[i], mapping = tr.mapping.slice(mapFrom);
            tr.replaceRange(mapping.map($from.pos), mapping.map($to.pos), i ? (0, $3xw6l.Slice).empty : content);
            if (i == 0) $27059f7464a1d1f5$var$selectionToInsertionEnd(tr, mapFrom, (lastNode ? lastNode.isInline : lastParent && lastParent.isTextblock) ? -1 : 1);
        }
    }
    /**
    Replace the selection with the given node, appending the changes
    to the given transaction.
    */ replaceWith(tr, node) {
        let mapFrom = tr.steps.length, ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++){
            let { $from: $from, $to: $to } = ranges[i], mapping = tr.mapping.slice(mapFrom);
            let from = mapping.map($from.pos), to = mapping.map($to.pos);
            if (i) tr.deleteRange(from, to);
            else {
                tr.replaceRangeWith(from, to, node);
                $27059f7464a1d1f5$var$selectionToInsertionEnd(tr, mapFrom, node.isInline ? -1 : 1);
            }
        }
    }
    /**
    Find a valid cursor or leaf node selection starting at the given
    position and searching back if `dir` is negative, and forward if
    positive. When `textOnly` is true, only consider cursor
    selections. Will return null when no valid selection position is
    found.
    */ static findFrom($pos, dir, textOnly = false) {
        let inner = $pos.parent.inlineContent ? new $27059f7464a1d1f5$export$c2b25f346d19bcbb($pos) : $27059f7464a1d1f5$var$findSelectionIn($pos.node(0), $pos.parent, $pos.pos, $pos.index(), dir, textOnly);
        if (inner) return inner;
        for(let depth = $pos.depth - 1; depth >= 0; depth--){
            let found = dir < 0 ? $27059f7464a1d1f5$var$findSelectionIn($pos.node(0), $pos.node(depth), $pos.before(depth + 1), $pos.index(depth), dir, textOnly) : $27059f7464a1d1f5$var$findSelectionIn($pos.node(0), $pos.node(depth), $pos.after(depth + 1), $pos.index(depth) + 1, dir, textOnly);
            if (found) return found;
        }
        return null;
    }
    /**
    Find a valid cursor or leaf node selection near the given
    position. Searches forward first by default, but if `bias` is
    negative, it will search backwards first.
    */ static near($pos, bias = 1) {
        return this.findFrom($pos, bias) || this.findFrom($pos, -bias) || new $27059f7464a1d1f5$export$c15d9ba76bdbcd95($pos.node(0));
    }
    /**
    Find the cursor or leaf node selection closest to the start of
    the given document. Will return an
    [`AllSelection`](https://prosemirror.net/docs/ref/#state.AllSelection) if no valid position
    exists.
    */ static atStart(doc) {
        return $27059f7464a1d1f5$var$findSelectionIn(doc, doc, 0, 0, 1) || new $27059f7464a1d1f5$export$c15d9ba76bdbcd95(doc);
    }
    /**
    Find the cursor or leaf node selection closest to the end of the
    given document.
    */ static atEnd(doc) {
        return $27059f7464a1d1f5$var$findSelectionIn(doc, doc, doc.content.size, doc.childCount, -1) || new $27059f7464a1d1f5$export$c15d9ba76bdbcd95(doc);
    }
    /**
    Deserialize the JSON representation of a selection. Must be
    implemented for custom classes (as a static class method).
    */ static fromJSON(doc, json) {
        if (!json || !json.type) throw new RangeError("Invalid input for Selection.fromJSON");
        let cls = $27059f7464a1d1f5$var$classesById[json.type];
        if (!cls) throw new RangeError(`No selection type ${json.type} defined`);
        return cls.fromJSON(doc, json);
    }
    /**
    To be able to deserialize selections from JSON, custom selection
    classes must register themselves with an ID string, so that they
    can be disambiguated. Try to pick something that's unlikely to
    clash with classes from other modules.
    */ static jsonID(id, selectionClass) {
        if (id in $27059f7464a1d1f5$var$classesById) throw new RangeError("Duplicate use of selection JSON ID " + id);
        $27059f7464a1d1f5$var$classesById[id] = selectionClass;
        selectionClass.prototype.jsonID = id;
        return selectionClass;
    }
    /**
    Get a [bookmark](https://prosemirror.net/docs/ref/#state.SelectionBookmark) for this selection,
    which is a value that can be mapped without having access to a
    current document, and later resolved to a real selection for a
    given document again. (This is used mostly by the history to
    track and restore old selections.) The default implementation of
    this method just converts the selection to a text selection and
    returns the bookmark for that.
    */ getBookmark() {
        return $27059f7464a1d1f5$export$c2b25f346d19bcbb.between(this.$anchor, this.$head).getBookmark();
    }
}
$27059f7464a1d1f5$export$52baac22726c72bf.prototype.visible = true;
/**
Represents a selected range in a document.
*/ class $27059f7464a1d1f5$export$7bd1839c3c5d5bd4 {
    /**
    Create a range.
    */ constructor(/**
    The lower bound of the range.
    */ $from, /**
    The upper bound of the range.
    */ $to){
        this.$from = $from;
        this.$to = $to;
    }
}
let $27059f7464a1d1f5$var$warnedAboutTextSelection = false;
function $27059f7464a1d1f5$var$checkTextSelection($pos) {
    if (!$27059f7464a1d1f5$var$warnedAboutTextSelection && !$pos.parent.inlineContent) {
        $27059f7464a1d1f5$var$warnedAboutTextSelection = true;
        console["warn"]("TextSelection endpoint not pointing into a node with inline content (" + $pos.parent.type.name + ")");
    }
}
/**
A text selection represents a classical editor selection, with a
head (the moving side) and anchor (immobile side), both of which
point into textblock nodes. It can be empty (a regular cursor
position).
*/ class $27059f7464a1d1f5$export$c2b25f346d19bcbb extends $27059f7464a1d1f5$export$52baac22726c72bf {
    /**
    Construct a text selection between the given points.
    */ constructor($anchor, $head = $anchor){
        $27059f7464a1d1f5$var$checkTextSelection($anchor);
        $27059f7464a1d1f5$var$checkTextSelection($head);
        super($anchor, $head);
    }
    /**
    Returns a resolved position if this is a cursor selection (an
    empty text selection), and null otherwise.
    */ get $cursor() {
        return this.$anchor.pos == this.$head.pos ? this.$head : null;
    }
    map(doc, mapping) {
        let $head = doc.resolve(mapping.map(this.head));
        if (!$head.parent.inlineContent) return $27059f7464a1d1f5$export$52baac22726c72bf.near($head);
        let $anchor = doc.resolve(mapping.map(this.anchor));
        return new $27059f7464a1d1f5$export$c2b25f346d19bcbb($anchor.parent.inlineContent ? $anchor : $head, $head);
    }
    replace(tr, content = (0, $3xw6l.Slice).empty) {
        super.replace(tr, content);
        if (content == (0, $3xw6l.Slice).empty) {
            let marks = this.$from.marksAcross(this.$to);
            if (marks) tr.ensureMarks(marks);
        }
    }
    eq(other) {
        return other instanceof $27059f7464a1d1f5$export$c2b25f346d19bcbb && other.anchor == this.anchor && other.head == this.head;
    }
    getBookmark() {
        return new $27059f7464a1d1f5$var$TextBookmark(this.anchor, this.head);
    }
    toJSON() {
        return {
            type: "text",
            anchor: this.anchor,
            head: this.head
        };
    }
    /**
    @internal
    */ static fromJSON(doc, json) {
        if (typeof json.anchor != "number" || typeof json.head != "number") throw new RangeError("Invalid input for TextSelection.fromJSON");
        return new $27059f7464a1d1f5$export$c2b25f346d19bcbb(doc.resolve(json.anchor), doc.resolve(json.head));
    }
    /**
    Create a text selection from non-resolved positions.
    */ static create(doc, anchor, head = anchor) {
        let $anchor = doc.resolve(anchor);
        return new this($anchor, head == anchor ? $anchor : doc.resolve(head));
    }
    /**
    Return a text selection that spans the given positions or, if
    they aren't text positions, find a text selection near them.
    `bias` determines whether the method searches forward (default)
    or backwards (negative number) first. Will fall back to calling
    [`Selection.near`](https://prosemirror.net/docs/ref/#state.Selection^near) when the document
    doesn't contain a valid text position.
    */ static between($anchor, $head, bias) {
        let dPos = $anchor.pos - $head.pos;
        if (!bias || dPos) bias = dPos >= 0 ? 1 : -1;
        if (!$head.parent.inlineContent) {
            let found = $27059f7464a1d1f5$export$52baac22726c72bf.findFrom($head, bias, true) || $27059f7464a1d1f5$export$52baac22726c72bf.findFrom($head, -bias, true);
            if (found) $head = found.$head;
            else return $27059f7464a1d1f5$export$52baac22726c72bf.near($head, bias);
        }
        if (!$anchor.parent.inlineContent) {
            if (dPos == 0) $anchor = $head;
            else {
                $anchor = ($27059f7464a1d1f5$export$52baac22726c72bf.findFrom($anchor, -bias, true) || $27059f7464a1d1f5$export$52baac22726c72bf.findFrom($anchor, bias, true)).$anchor;
                if ($anchor.pos < $head.pos != dPos < 0) $anchor = $head;
            }
        }
        return new $27059f7464a1d1f5$export$c2b25f346d19bcbb($anchor, $head);
    }
}
$27059f7464a1d1f5$export$52baac22726c72bf.jsonID("text", $27059f7464a1d1f5$export$c2b25f346d19bcbb);
class $27059f7464a1d1f5$var$TextBookmark {
    constructor(anchor, head){
        this.anchor = anchor;
        this.head = head;
    }
    map(mapping) {
        return new $27059f7464a1d1f5$var$TextBookmark(mapping.map(this.anchor), mapping.map(this.head));
    }
    resolve(doc) {
        return $27059f7464a1d1f5$export$c2b25f346d19bcbb.between(doc.resolve(this.anchor), doc.resolve(this.head));
    }
}
/**
A node selection is a selection that points at a single node. All
nodes marked [selectable](https://prosemirror.net/docs/ref/#model.NodeSpec.selectable) can be the
target of a node selection. In such a selection, `from` and `to`
point directly before and after the selected node, `anchor` equals
`from`, and `head` equals `to`..
*/ class $27059f7464a1d1f5$export$e2940151ac854c0b extends $27059f7464a1d1f5$export$52baac22726c72bf {
    /**
    Create a node selection. Does not verify the validity of its
    argument.
    */ constructor($pos){
        let node = $pos.nodeAfter;
        let $end = $pos.node(0).resolve($pos.pos + node.nodeSize);
        super($pos, $end);
        this.node = node;
    }
    map(doc, mapping) {
        let { deleted: deleted, pos: pos } = mapping.mapResult(this.anchor);
        let $pos = doc.resolve(pos);
        if (deleted) return $27059f7464a1d1f5$export$52baac22726c72bf.near($pos);
        return new $27059f7464a1d1f5$export$e2940151ac854c0b($pos);
    }
    content() {
        return new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).from(this.node), 0, 0);
    }
    eq(other) {
        return other instanceof $27059f7464a1d1f5$export$e2940151ac854c0b && other.anchor == this.anchor;
    }
    toJSON() {
        return {
            type: "node",
            anchor: this.anchor
        };
    }
    getBookmark() {
        return new $27059f7464a1d1f5$var$NodeBookmark(this.anchor);
    }
    /**
    @internal
    */ static fromJSON(doc, json) {
        if (typeof json.anchor != "number") throw new RangeError("Invalid input for NodeSelection.fromJSON");
        return new $27059f7464a1d1f5$export$e2940151ac854c0b(doc.resolve(json.anchor));
    }
    /**
    Create a node selection from non-resolved positions.
    */ static create(doc, from) {
        return new $27059f7464a1d1f5$export$e2940151ac854c0b(doc.resolve(from));
    }
    /**
    Determines whether the given node may be selected as a node
    selection.
    */ static isSelectable(node) {
        return !node.isText && node.type.spec.selectable !== false;
    }
}
$27059f7464a1d1f5$export$e2940151ac854c0b.prototype.visible = false;
$27059f7464a1d1f5$export$52baac22726c72bf.jsonID("node", $27059f7464a1d1f5$export$e2940151ac854c0b);
class $27059f7464a1d1f5$var$NodeBookmark {
    constructor(anchor){
        this.anchor = anchor;
    }
    map(mapping) {
        let { deleted: deleted, pos: pos } = mapping.mapResult(this.anchor);
        return deleted ? new $27059f7464a1d1f5$var$TextBookmark(pos, pos) : new $27059f7464a1d1f5$var$NodeBookmark(pos);
    }
    resolve(doc) {
        let $pos = doc.resolve(this.anchor), node = $pos.nodeAfter;
        if (node && $27059f7464a1d1f5$export$e2940151ac854c0b.isSelectable(node)) return new $27059f7464a1d1f5$export$e2940151ac854c0b($pos);
        return $27059f7464a1d1f5$export$52baac22726c72bf.near($pos);
    }
}
/**
A selection type that represents selecting the whole document
(which can not necessarily be expressed with a text selection, when
there are for example leaf block nodes at the start or end of the
document).
*/ class $27059f7464a1d1f5$export$c15d9ba76bdbcd95 extends $27059f7464a1d1f5$export$52baac22726c72bf {
    /**
    Create an all-selection over the given document.
    */ constructor(doc){
        super(doc.resolve(0), doc.resolve(doc.content.size));
    }
    replace(tr, content = (0, $3xw6l.Slice).empty) {
        if (content == (0, $3xw6l.Slice).empty) {
            tr.delete(0, tr.doc.content.size);
            let sel = $27059f7464a1d1f5$export$52baac22726c72bf.atStart(tr.doc);
            if (!sel.eq(tr.selection)) tr.setSelection(sel);
        } else super.replace(tr, content);
    }
    toJSON() {
        return {
            type: "all"
        };
    }
    /**
    @internal
    */ static fromJSON(doc) {
        return new $27059f7464a1d1f5$export$c15d9ba76bdbcd95(doc);
    }
    map(doc) {
        return new $27059f7464a1d1f5$export$c15d9ba76bdbcd95(doc);
    }
    eq(other) {
        return other instanceof $27059f7464a1d1f5$export$c15d9ba76bdbcd95;
    }
    getBookmark() {
        return $27059f7464a1d1f5$var$AllBookmark;
    }
}
$27059f7464a1d1f5$export$52baac22726c72bf.jsonID("all", $27059f7464a1d1f5$export$c15d9ba76bdbcd95);
const $27059f7464a1d1f5$var$AllBookmark = {
    map () {
        return this;
    },
    resolve (doc) {
        return new $27059f7464a1d1f5$export$c15d9ba76bdbcd95(doc);
    }
};
// FIXME we'll need some awareness of text direction when scanning for selections
// Try to find a selection inside the given node. `pos` points at the
// position where the search starts. When `text` is true, only return
// text selections.
function $27059f7464a1d1f5$var$findSelectionIn(doc, node, pos, index, dir, text = false) {
    if (node.inlineContent) return $27059f7464a1d1f5$export$c2b25f346d19bcbb.create(doc, pos);
    for(let i = index - (dir > 0 ? 0 : 1); dir > 0 ? i < node.childCount : i >= 0; i += dir){
        let child = node.child(i);
        if (!child.isAtom) {
            let inner = $27059f7464a1d1f5$var$findSelectionIn(doc, child, pos + dir, dir < 0 ? child.childCount : 0, dir, text);
            if (inner) return inner;
        } else if (!text && $27059f7464a1d1f5$export$e2940151ac854c0b.isSelectable(child)) return $27059f7464a1d1f5$export$e2940151ac854c0b.create(doc, pos - (dir < 0 ? child.nodeSize : 0));
        pos += child.nodeSize * dir;
    }
    return null;
}
function $27059f7464a1d1f5$var$selectionToInsertionEnd(tr, startLen, bias) {
    let last = tr.steps.length - 1;
    if (last < startLen) return;
    let step = tr.steps[last];
    if (!(step instanceof (0, $lzEKq.ReplaceStep) || step instanceof (0, $lzEKq.ReplaceAroundStep))) return;
    let map = tr.mapping.maps[last], end;
    map.forEach((_from, _to, _newFrom, newTo)=>{
        if (end == null) end = newTo;
    });
    tr.setSelection($27059f7464a1d1f5$export$52baac22726c72bf.near(tr.doc.resolve(end), bias));
}
const $27059f7464a1d1f5$var$UPDATED_SEL = 1, $27059f7464a1d1f5$var$UPDATED_MARKS = 2, $27059f7464a1d1f5$var$UPDATED_SCROLL = 4;
/**
An editor state transaction, which can be applied to a state to
create an updated state. Use
[`EditorState.tr`](https://prosemirror.net/docs/ref/#state.EditorState.tr) to create an instance.

Transactions track changes to the document (they are a subclass of
[`Transform`](https://prosemirror.net/docs/ref/#transform.Transform)), but also other state changes,
like selection updates and adjustments of the set of [stored
marks](https://prosemirror.net/docs/ref/#state.EditorState.storedMarks). In addition, you can store
metadata properties in a transaction, which are extra pieces of
information that client code or plugins can use to describe what a
transaction represents, so that they can update their [own
state](https://prosemirror.net/docs/ref/#state.StateField) accordingly.

The [editor view](https://prosemirror.net/docs/ref/#view.EditorView) uses a few metadata
properties: it will attach a property `"pointer"` with the value
`true` to selection transactions directly caused by mouse or touch
input, a `"composition"` property holding an ID identifying the
composition that caused it to transactions caused by composed DOM
input, and a `"uiEvent"` property of that may be `"paste"`,
`"cut"`, or `"drop"`.
*/ class $27059f7464a1d1f5$export$febc5573c75cefb0 extends (0, $lzEKq.Transform) {
    /**
    @internal
    */ constructor(state){
        super(state.doc);
        // The step count for which the current selection is valid.
        this.curSelectionFor = 0;
        // Bitfield to track which aspects of the state were updated by
        // this transaction.
        this.updated = 0;
        // Object used to store metadata properties for the transaction.
        this.meta = Object.create(null);
        this.time = Date.now();
        this.curSelection = state.selection;
        this.storedMarks = state.storedMarks;
    }
    /**
    The transaction's current selection. This defaults to the editor
    selection [mapped](https://prosemirror.net/docs/ref/#state.Selection.map) through the steps in the
    transaction, but can be overwritten with
    [`setSelection`](https://prosemirror.net/docs/ref/#state.Transaction.setSelection).
    */ get selection() {
        if (this.curSelectionFor < this.steps.length) {
            this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor));
            this.curSelectionFor = this.steps.length;
        }
        return this.curSelection;
    }
    /**
    Update the transaction's current selection. Will determine the
    selection that the editor gets when the transaction is applied.
    */ setSelection(selection) {
        if (selection.$from.doc != this.doc) throw new RangeError("Selection passed to setSelection must point at the current document");
        this.curSelection = selection;
        this.curSelectionFor = this.steps.length;
        this.updated = (this.updated | $27059f7464a1d1f5$var$UPDATED_SEL) & ~$27059f7464a1d1f5$var$UPDATED_MARKS;
        this.storedMarks = null;
        return this;
    }
    /**
    Whether the selection was explicitly updated by this transaction.
    */ get selectionSet() {
        return (this.updated & $27059f7464a1d1f5$var$UPDATED_SEL) > 0;
    }
    /**
    Set the current stored marks.
    */ setStoredMarks(marks) {
        this.storedMarks = marks;
        this.updated |= $27059f7464a1d1f5$var$UPDATED_MARKS;
        return this;
    }
    /**
    Make sure the current stored marks or, if that is null, the marks
    at the selection, match the given set of marks. Does nothing if
    this is already the case.
    */ ensureMarks(marks) {
        if (!(0, $3xw6l.Mark).sameSet(this.storedMarks || this.selection.$from.marks(), marks)) this.setStoredMarks(marks);
        return this;
    }
    /**
    Add a mark to the set of stored marks.
    */ addStoredMark(mark) {
        return this.ensureMarks(mark.addToSet(this.storedMarks || this.selection.$head.marks()));
    }
    /**
    Remove a mark or mark type from the set of stored marks.
    */ removeStoredMark(mark) {
        return this.ensureMarks(mark.removeFromSet(this.storedMarks || this.selection.$head.marks()));
    }
    /**
    Whether the stored marks were explicitly set for this transaction.
    */ get storedMarksSet() {
        return (this.updated & $27059f7464a1d1f5$var$UPDATED_MARKS) > 0;
    }
    /**
    @internal
    */ addStep(step, doc) {
        super.addStep(step, doc);
        this.updated = this.updated & ~$27059f7464a1d1f5$var$UPDATED_MARKS;
        this.storedMarks = null;
    }
    /**
    Update the timestamp for the transaction.
    */ setTime(time) {
        this.time = time;
        return this;
    }
    /**
    Replace the current selection with the given slice.
    */ replaceSelection(slice) {
        this.selection.replace(this, slice);
        return this;
    }
    /**
    Replace the selection with the given node. When `inheritMarks` is
    true and the content is inline, it inherits the marks from the
    place where it is inserted.
    */ replaceSelectionWith(node, inheritMarks = true) {
        let selection = this.selection;
        if (inheritMarks) node = node.mark(this.storedMarks || (selection.empty ? selection.$from.marks() : selection.$from.marksAcross(selection.$to) || (0, $3xw6l.Mark).none));
        selection.replaceWith(this, node);
        return this;
    }
    /**
    Delete the selection.
    */ deleteSelection() {
        this.selection.replace(this);
        return this;
    }
    /**
    Replace the given range, or the selection if no range is given,
    with a text node containing the given string.
    */ insertText(text, from, to) {
        let schema = this.doc.type.schema;
        if (from == null) {
            if (!text) return this.deleteSelection();
            return this.replaceSelectionWith(schema.text(text), true);
        } else {
            if (to == null) to = from;
            to = to == null ? from : to;
            if (!text) return this.deleteRange(from, to);
            let marks = this.storedMarks;
            if (!marks) {
                let $from = this.doc.resolve(from);
                marks = to == from ? $from.marks() : $from.marksAcross(this.doc.resolve(to));
            }
            this.replaceRangeWith(from, to, schema.text(text, marks));
            if (!this.selection.empty) this.setSelection($27059f7464a1d1f5$export$52baac22726c72bf.near(this.selection.$to));
            return this;
        }
    }
    /**
    Store a metadata property in this transaction, keyed either by
    name or by plugin.
    */ setMeta(key, value) {
        this.meta[typeof key == "string" ? key : key.key] = value;
        return this;
    }
    /**
    Retrieve a metadata property for a given name or plugin.
    */ getMeta(key) {
        return this.meta[typeof key == "string" ? key : key.key];
    }
    /**
    Returns true if this transaction doesn't contain any metadata,
    and can thus safely be extended.
    */ get isGeneric() {
        for(let _ in this.meta)return false;
        return true;
    }
    /**
    Indicate that the editor should scroll the selection into view
    when updated to the state produced by this transaction.
    */ scrollIntoView() {
        this.updated |= $27059f7464a1d1f5$var$UPDATED_SCROLL;
        return this;
    }
    /**
    True when this transaction has had `scrollIntoView` called on it.
    */ get scrolledIntoView() {
        return (this.updated & $27059f7464a1d1f5$var$UPDATED_SCROLL) > 0;
    }
}
function $27059f7464a1d1f5$var$bind(f, self) {
    return !self || !f ? f : f.bind(self);
}
class $27059f7464a1d1f5$var$FieldDesc {
    constructor(name, desc, self){
        this.name = name;
        this.init = $27059f7464a1d1f5$var$bind(desc.init, self);
        this.apply = $27059f7464a1d1f5$var$bind(desc.apply, self);
    }
}
const $27059f7464a1d1f5$var$baseFields = [
    new $27059f7464a1d1f5$var$FieldDesc("doc", {
        init (config) {
            return config.doc || config.schema.topNodeType.createAndFill();
        },
        apply (tr) {
            return tr.doc;
        }
    }),
    new $27059f7464a1d1f5$var$FieldDesc("selection", {
        init (config, instance) {
            return config.selection || $27059f7464a1d1f5$export$52baac22726c72bf.atStart(instance.doc);
        },
        apply (tr) {
            return tr.selection;
        }
    }),
    new $27059f7464a1d1f5$var$FieldDesc("storedMarks", {
        init (config) {
            return config.storedMarks || null;
        },
        apply (tr, _marks, _old, state) {
            return state.selection.$cursor ? tr.storedMarks : null;
        }
    }),
    new $27059f7464a1d1f5$var$FieldDesc("scrollToSelection", {
        init () {
            return 0;
        },
        apply (tr, prev) {
            return tr.scrolledIntoView ? prev + 1 : prev;
        }
    })
];
// Object wrapping the part of a state object that stays the same
// across transactions. Stored in the state's `config` property.
class $27059f7464a1d1f5$var$Configuration {
    constructor(schema, plugins){
        this.schema = schema;
        this.plugins = [];
        this.pluginsByKey = Object.create(null);
        this.fields = $27059f7464a1d1f5$var$baseFields.slice();
        if (plugins) plugins.forEach((plugin)=>{
            if (this.pluginsByKey[plugin.key]) throw new RangeError("Adding different instances of a keyed plugin (" + plugin.key + ")");
            this.plugins.push(plugin);
            this.pluginsByKey[plugin.key] = plugin;
            if (plugin.spec.state) this.fields.push(new $27059f7464a1d1f5$var$FieldDesc(plugin.key, plugin.spec.state, plugin));
        });
    }
}
/**
The state of a ProseMirror editor is represented by an object of
this type. A state is a persistent data structure—it isn't
updated, but rather a new state value is computed from an old one
using the [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) method.

A state holds a number of built-in fields, and plugins can
[define](https://prosemirror.net/docs/ref/#state.PluginSpec.state) additional fields.
*/ class $27059f7464a1d1f5$export$afa855cbfaff27f2 {
    /**
    @internal
    */ constructor(/**
    @internal
    */ config){
        this.config = config;
    }
    /**
    The schema of the state's document.
    */ get schema() {
        return this.config.schema;
    }
    /**
    The plugins that are active in this state.
    */ get plugins() {
        return this.config.plugins;
    }
    /**
    Apply the given transaction to produce a new state.
    */ apply(tr) {
        return this.applyTransaction(tr).state;
    }
    /**
    @internal
    */ filterTransaction(tr, ignore = -1) {
        for(let i = 0; i < this.config.plugins.length; i++)if (i != ignore) {
            let plugin = this.config.plugins[i];
            if (plugin.spec.filterTransaction && !plugin.spec.filterTransaction.call(plugin, tr, this)) return false;
        }
        return true;
    }
    /**
    Verbose variant of [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) that
    returns the precise transactions that were applied (which might
    be influenced by the [transaction
    hooks](https://prosemirror.net/docs/ref/#state.PluginSpec.filterTransaction) of
    plugins) along with the new state.
    */ applyTransaction(rootTr) {
        if (!this.filterTransaction(rootTr)) return {
            state: this,
            transactions: []
        };
        let trs = [
            rootTr
        ], newState = this.applyInner(rootTr), seen = null;
        // This loop repeatedly gives plugins a chance to respond to
        // transactions as new transactions are added, making sure to only
        // pass the transactions the plugin did not see before.
        for(;;){
            let haveNew = false;
            for(let i = 0; i < this.config.plugins.length; i++){
                let plugin = this.config.plugins[i];
                if (plugin.spec.appendTransaction) {
                    let n = seen ? seen[i].n : 0, oldState = seen ? seen[i].state : this;
                    let tr = n < trs.length && plugin.spec.appendTransaction.call(plugin, n ? trs.slice(n) : trs, oldState, newState);
                    if (tr && newState.filterTransaction(tr, i)) {
                        tr.setMeta("appendedTransaction", rootTr);
                        if (!seen) {
                            seen = [];
                            for(let j = 0; j < this.config.plugins.length; j++)seen.push(j < i ? {
                                state: newState,
                                n: trs.length
                            } : {
                                state: this,
                                n: 0
                            });
                        }
                        trs.push(tr);
                        newState = newState.applyInner(tr);
                        haveNew = true;
                    }
                    if (seen) seen[i] = {
                        state: newState,
                        n: trs.length
                    };
                }
            }
            if (!haveNew) return {
                state: newState,
                transactions: trs
            };
        }
    }
    /**
    @internal
    */ applyInner(tr) {
        if (!tr.before.eq(this.doc)) throw new RangeError("Applying a mismatched transaction");
        let newInstance = new $27059f7464a1d1f5$export$afa855cbfaff27f2(this.config), fields = this.config.fields;
        for(let i = 0; i < fields.length; i++){
            let field = fields[i];
            newInstance[field.name] = field.apply(tr, this[field.name], this, newInstance);
        }
        return newInstance;
    }
    /**
    Start a [transaction](https://prosemirror.net/docs/ref/#state.Transaction) from this state.
    */ get tr() {
        return new $27059f7464a1d1f5$export$febc5573c75cefb0(this);
    }
    /**
    Create a new state.
    */ static create(config) {
        let $config = new $27059f7464a1d1f5$var$Configuration(config.doc ? config.doc.type.schema : config.schema, config.plugins);
        let instance = new $27059f7464a1d1f5$export$afa855cbfaff27f2($config);
        for(let i = 0; i < $config.fields.length; i++)instance[$config.fields[i].name] = $config.fields[i].init(config, instance);
        return instance;
    }
    /**
    Create a new state based on this one, but with an adjusted set
    of active plugins. State fields that exist in both sets of
    plugins are kept unchanged. Those that no longer exist are
    dropped, and those that are new are initialized using their
    [`init`](https://prosemirror.net/docs/ref/#state.StateField.init) method, passing in the new
    configuration object..
    */ reconfigure(config) {
        let $config = new $27059f7464a1d1f5$var$Configuration(this.schema, config.plugins);
        let fields = $config.fields, instance = new $27059f7464a1d1f5$export$afa855cbfaff27f2($config);
        for(let i = 0; i < fields.length; i++){
            let name = fields[i].name;
            instance[name] = this.hasOwnProperty(name) ? this[name] : fields[i].init(config, instance);
        }
        return instance;
    }
    /**
    Serialize this state to JSON. If you want to serialize the state
    of plugins, pass an object mapping property names to use in the
    resulting JSON object to plugin objects. The argument may also be
    a string or number, in which case it is ignored, to support the
    way `JSON.stringify` calls `toString` methods.
    */ toJSON(pluginFields) {
        let result = {
            doc: this.doc.toJSON(),
            selection: this.selection.toJSON()
        };
        if (this.storedMarks) result.storedMarks = this.storedMarks.map((m)=>m.toJSON());
        if (pluginFields && typeof pluginFields == 'object') for(let prop in pluginFields){
            if (prop == "doc" || prop == "selection") throw new RangeError("The JSON fields `doc` and `selection` are reserved");
            let plugin = pluginFields[prop], state = plugin.spec.state;
            if (state && state.toJSON) result[prop] = state.toJSON.call(plugin, this[plugin.key]);
        }
        return result;
    }
    /**
    Deserialize a JSON representation of a state. `config` should
    have at least a `schema` field, and should contain array of
    plugins to initialize the state with. `pluginFields` can be used
    to deserialize the state of plugins, by associating plugin
    instances with the property names they use in the JSON object.
    */ static fromJSON(config, json, pluginFields) {
        if (!json) throw new RangeError("Invalid input for EditorState.fromJSON");
        if (!config.schema) throw new RangeError("Required config field 'schema' missing");
        let $config = new $27059f7464a1d1f5$var$Configuration(config.schema, config.plugins);
        let instance = new $27059f7464a1d1f5$export$afa855cbfaff27f2($config);
        $config.fields.forEach((field)=>{
            if (field.name == "doc") instance.doc = (0, $3xw6l.Node).fromJSON(config.schema, json.doc);
            else if (field.name == "selection") instance.selection = $27059f7464a1d1f5$export$52baac22726c72bf.fromJSON(instance.doc, json.selection);
            else if (field.name == "storedMarks") {
                if (json.storedMarks) instance.storedMarks = json.storedMarks.map(config.schema.markFromJSON);
            } else {
                if (pluginFields) for(let prop in pluginFields){
                    let plugin = pluginFields[prop], state = plugin.spec.state;
                    if (plugin.key == field.name && state && state.fromJSON && Object.prototype.hasOwnProperty.call(json, prop)) {
                        instance[field.name] = state.fromJSON.call(plugin, config, json[prop], instance);
                        return;
                    }
                }
                instance[field.name] = field.init(config, instance);
            }
        });
        return instance;
    }
}
function $27059f7464a1d1f5$var$bindProps(obj, self, target) {
    for(let prop in obj){
        let val = obj[prop];
        if (val instanceof Function) val = val.bind(self);
        else if (prop == "handleDOMEvents") val = $27059f7464a1d1f5$var$bindProps(val, self, {});
        target[prop] = val;
    }
    return target;
}
/**
Plugins bundle functionality that can be added to an editor.
They are part of the [editor state](https://prosemirror.net/docs/ref/#state.EditorState) and
may influence that state and the view that contains it.
*/ class $27059f7464a1d1f5$export$901cf72dabf2112a {
    /**
    Create a plugin.
    */ constructor(/**
    The plugin's [spec object](https://prosemirror.net/docs/ref/#state.PluginSpec).
    */ spec){
        this.spec = spec;
        /**
        The [props](https://prosemirror.net/docs/ref/#view.EditorProps) exported by this plugin.
        */ this.props = {};
        if (spec.props) $27059f7464a1d1f5$var$bindProps(spec.props, this, this.props);
        this.key = spec.key ? spec.key.key : $27059f7464a1d1f5$var$createKey("plugin");
    }
    /**
    Extract the plugin's state field from an editor state.
    */ getState(state) {
        return state[this.key];
    }
}
const $27059f7464a1d1f5$var$keys = Object.create(null);
function $27059f7464a1d1f5$var$createKey(name) {
    if (name in $27059f7464a1d1f5$var$keys) return name + "$" + ++$27059f7464a1d1f5$var$keys[name];
    $27059f7464a1d1f5$var$keys[name] = 0;
    return name + "$";
}
/**
A key is used to [tag](https://prosemirror.net/docs/ref/#state.PluginSpec.key) plugins in a way
that makes it possible to find them, given an editor state.
Assigning a key does mean only one plugin of that type can be
active in a state.
*/ class $27059f7464a1d1f5$export$1692d8b0e89cecc3 {
    /**
    Create a plugin key.
    */ constructor(name = "key"){
        this.key = $27059f7464a1d1f5$var$createKey(name);
    }
    /**
    Get the active plugin with this key, if any, from an editor
    state.
    */ get(state) {
        return state.config.pluginsByKey[this.key];
    }
    /**
    Get the plugin's state from an editor state.
    */ getState(state) {
        return state[this.key];
    }
}

});
parcelRegister("lzEKq", function(module, exports) {

$parcel$export(module.exports, "StepMap", () => $040d9edd1880ca83$export$c53d01c3ab9721b3);
$parcel$export(module.exports, "Mapping", () => $040d9edd1880ca83$export$f5f785078011b62);
$parcel$export(module.exports, "Step", () => $040d9edd1880ca83$export$fd55ce593607084a);
$parcel$export(module.exports, "StepResult", () => $040d9edd1880ca83$export$8ebf1578a4199c09);
$parcel$export(module.exports, "AddMarkStep", () => $040d9edd1880ca83$export$d24ba56b0e3464a9);
$parcel$export(module.exports, "RemoveMarkStep", () => $040d9edd1880ca83$export$94150db1311f67a9);
$parcel$export(module.exports, "AddNodeMarkStep", () => $040d9edd1880ca83$export$adefd16c402fee4e);
$parcel$export(module.exports, "RemoveNodeMarkStep", () => $040d9edd1880ca83$export$fdf7d1dc10724da2);
$parcel$export(module.exports, "ReplaceStep", () => $040d9edd1880ca83$export$5c860b2e74034756);
$parcel$export(module.exports, "ReplaceAroundStep", () => $040d9edd1880ca83$export$444ba800d6024a98);
$parcel$export(module.exports, "liftTarget", () => $040d9edd1880ca83$export$f1508b72cc76a09e);
$parcel$export(module.exports, "findWrapping", () => $040d9edd1880ca83$export$118cb9a83e81ba37);
$parcel$export(module.exports, "canSplit", () => $040d9edd1880ca83$export$5aaf008897aef029);
$parcel$export(module.exports, "canJoin", () => $040d9edd1880ca83$export$f15f89fd9d8cc98a);
$parcel$export(module.exports, "joinPoint", () => $040d9edd1880ca83$export$41b1d4cb5ceb3147);
$parcel$export(module.exports, "insertPoint", () => $040d9edd1880ca83$export$64cb316d02de1dd1);
$parcel$export(module.exports, "dropPoint", () => $040d9edd1880ca83$export$2819d598d048fc9c);
$parcel$export(module.exports, "replaceStep", () => $040d9edd1880ca83$export$ed6ac67359824afd);
$parcel$export(module.exports, "AttrStep", () => $040d9edd1880ca83$export$626399c38172f669);
$parcel$export(module.exports, "DocAttrStep", () => $040d9edd1880ca83$export$f50707b396300ac9);
$parcel$export(module.exports, "Transform", () => $040d9edd1880ca83$export$563a914cafbdc389);

var $3xw6l = parcelRequire("3xw6l");
// Recovery values encode a range index and an offset. They are
// represented as numbers, because tons of them will be created when
// mapping, for example, a large number of decorations. The number's
// lower 16 bits provide the index, the remaining bits the offset.
//
// Note: We intentionally don't use bit shift operators to en- and
// decode these, since those clip to 32 bits, which we might in rare
// cases want to overflow. A 64-bit float can represent 48-bit
// integers precisely.
const $040d9edd1880ca83$var$lower16 = 0xffff;
const $040d9edd1880ca83$var$factor16 = Math.pow(2, 16);
function $040d9edd1880ca83$var$makeRecover(index, offset) {
    return index + offset * $040d9edd1880ca83$var$factor16;
}
function $040d9edd1880ca83$var$recoverIndex(value) {
    return value & $040d9edd1880ca83$var$lower16;
}
function $040d9edd1880ca83$var$recoverOffset(value) {
    return (value - (value & $040d9edd1880ca83$var$lower16)) / $040d9edd1880ca83$var$factor16;
}
const $040d9edd1880ca83$var$DEL_BEFORE = 1, $040d9edd1880ca83$var$DEL_AFTER = 2, $040d9edd1880ca83$var$DEL_ACROSS = 4, $040d9edd1880ca83$var$DEL_SIDE = 8;
/**
An object representing a mapped position with extra
information.
*/ class $040d9edd1880ca83$export$c77c9be41668e9b4 {
    /**
    @internal
    */ constructor(/**
    The mapped version of the position.
    */ pos, /**
    @internal
    */ delInfo, /**
    @internal
    */ recover){
        this.pos = pos;
        this.delInfo = delInfo;
        this.recover = recover;
    }
    /**
    Tells you whether the position was deleted, that is, whether the
    step removed the token on the side queried (via the `assoc`)
    argument from the document.
    */ get deleted() {
        return (this.delInfo & $040d9edd1880ca83$var$DEL_SIDE) > 0;
    }
    /**
    Tells you whether the token before the mapped position was deleted.
    */ get deletedBefore() {
        return (this.delInfo & ($040d9edd1880ca83$var$DEL_BEFORE | $040d9edd1880ca83$var$DEL_ACROSS)) > 0;
    }
    /**
    True when the token after the mapped position was deleted.
    */ get deletedAfter() {
        return (this.delInfo & ($040d9edd1880ca83$var$DEL_AFTER | $040d9edd1880ca83$var$DEL_ACROSS)) > 0;
    }
    /**
    Tells whether any of the steps mapped through deletes across the
    position (including both the token before and after the
    position).
    */ get deletedAcross() {
        return (this.delInfo & $040d9edd1880ca83$var$DEL_ACROSS) > 0;
    }
}
/**
A map describing the deletions and insertions made by a step, which
can be used to find the correspondence between positions in the
pre-step version of a document and the same position in the
post-step version.
*/ class $040d9edd1880ca83$export$c53d01c3ab9721b3 {
    /**
    Create a position map. The modifications to the document are
    represented as an array of numbers, in which each group of three
    represents a modified chunk as `[start, oldSize, newSize]`.
    */ constructor(/**
    @internal
    */ ranges, /**
    @internal
    */ inverted = false){
        this.ranges = ranges;
        this.inverted = inverted;
        if (!ranges.length && $040d9edd1880ca83$export$c53d01c3ab9721b3.empty) return $040d9edd1880ca83$export$c53d01c3ab9721b3.empty;
    }
    /**
    @internal
    */ recover(value) {
        let diff = 0, index = $040d9edd1880ca83$var$recoverIndex(value);
        if (!this.inverted) for(let i = 0; i < index; i++)diff += this.ranges[i * 3 + 2] - this.ranges[i * 3 + 1];
        return this.ranges[index * 3] + diff + $040d9edd1880ca83$var$recoverOffset(value);
    }
    mapResult(pos, assoc = 1) {
        return this._map(pos, assoc, false);
    }
    map(pos, assoc = 1) {
        return this._map(pos, assoc, true);
    }
    /**
    @internal
    */ _map(pos, assoc, simple) {
        let diff = 0, oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i] - (this.inverted ? diff : 0);
            if (start > pos) break;
            let oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex], end = start + oldSize;
            if (pos <= end) {
                let side = !oldSize ? assoc : pos == start ? -1 : pos == end ? 1 : assoc;
                let result = start + diff + (side < 0 ? 0 : newSize);
                if (simple) return result;
                let recover = pos == (assoc < 0 ? start : end) ? null : $040d9edd1880ca83$var$makeRecover(i / 3, pos - start);
                let del = pos == start ? $040d9edd1880ca83$var$DEL_AFTER : pos == end ? $040d9edd1880ca83$var$DEL_BEFORE : $040d9edd1880ca83$var$DEL_ACROSS;
                if (assoc < 0 ? pos != start : pos != end) del |= $040d9edd1880ca83$var$DEL_SIDE;
                return new $040d9edd1880ca83$export$c77c9be41668e9b4(result, del, recover);
            }
            diff += newSize - oldSize;
        }
        return simple ? pos + diff : new $040d9edd1880ca83$export$c77c9be41668e9b4(pos + diff, 0, null);
    }
    /**
    @internal
    */ touches(pos, recover) {
        let diff = 0, index = $040d9edd1880ca83$var$recoverIndex(recover);
        let oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i] - (this.inverted ? diff : 0);
            if (start > pos) break;
            let oldSize = this.ranges[i + oldIndex], end = start + oldSize;
            if (pos <= end && i == index * 3) return true;
            diff += this.ranges[i + newIndex] - oldSize;
        }
        return false;
    }
    /**
    Calls the given function on each of the changed ranges included in
    this map.
    */ forEach(f) {
        let oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0, diff = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i], oldStart = start - (this.inverted ? diff : 0), newStart = start + (this.inverted ? 0 : diff);
            let oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex];
            f(oldStart, oldStart + oldSize, newStart, newStart + newSize);
            diff += newSize - oldSize;
        }
    }
    /**
    Create an inverted version of this map. The result can be used to
    map positions in the post-step document to the pre-step document.
    */ invert() {
        return new $040d9edd1880ca83$export$c53d01c3ab9721b3(this.ranges, !this.inverted);
    }
    /**
    @internal
    */ toString() {
        return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
    }
    /**
    Create a map that moves all positions by offset `n` (which may be
    negative). This can be useful when applying steps meant for a
    sub-document to a larger document, or vice-versa.
    */ static offset(n) {
        return n == 0 ? $040d9edd1880ca83$export$c53d01c3ab9721b3.empty : new $040d9edd1880ca83$export$c53d01c3ab9721b3(n < 0 ? [
            0,
            -n,
            0
        ] : [
            0,
            0,
            n
        ]);
    }
}
/**
A StepMap that contains no changed ranges.
*/ $040d9edd1880ca83$export$c53d01c3ab9721b3.empty = new $040d9edd1880ca83$export$c53d01c3ab9721b3([]);
/**
A mapping represents a pipeline of zero or more [step
maps](https://prosemirror.net/docs/ref/#transform.StepMap). It has special provisions for losslessly
handling mapping positions through a series of steps in which some
steps are inverted versions of earlier steps. (This comes up when
‘[rebasing](/docs/guide/#transform.rebasing)’ steps for
collaboration or history management.)
*/ class $040d9edd1880ca83$export$f5f785078011b62 {
    /**
    Create a new mapping with the given position maps.
    */ constructor(/**
    The step maps in this mapping.
    */ maps = [], /**
    @internal
    */ mirror, /**
    The starting position in the `maps` array, used when `map` or
    `mapResult` is called.
    */ from = 0, /**
    The end position in the `maps` array.
    */ to = maps.length){
        this.maps = maps;
        this.mirror = mirror;
        this.from = from;
        this.to = to;
    }
    /**
    Create a mapping that maps only through a part of this one.
    */ slice(from = 0, to = this.maps.length) {
        return new $040d9edd1880ca83$export$f5f785078011b62(this.maps, this.mirror, from, to);
    }
    /**
    @internal
    */ copy() {
        return new $040d9edd1880ca83$export$f5f785078011b62(this.maps.slice(), this.mirror && this.mirror.slice(), this.from, this.to);
    }
    /**
    Add a step map to the end of this mapping. If `mirrors` is
    given, it should be the index of the step map that is the mirror
    image of this one.
    */ appendMap(map, mirrors) {
        this.to = this.maps.push(map);
        if (mirrors != null) this.setMirror(this.maps.length - 1, mirrors);
    }
    /**
    Add all the step maps in a given mapping to this one (preserving
    mirroring information).
    */ appendMapping(mapping) {
        for(let i = 0, startSize = this.maps.length; i < mapping.maps.length; i++){
            let mirr = mapping.getMirror(i);
            this.appendMap(mapping.maps[i], mirr != null && mirr < i ? startSize + mirr : undefined);
        }
    }
    /**
    Finds the offset of the step map that mirrors the map at the
    given offset, in this mapping (as per the second argument to
    `appendMap`).
    */ getMirror(n) {
        if (this.mirror) {
            for(let i = 0; i < this.mirror.length; i++)if (this.mirror[i] == n) return this.mirror[i + (i % 2 ? -1 : 1)];
        }
    }
    /**
    @internal
    */ setMirror(n, m) {
        if (!this.mirror) this.mirror = [];
        this.mirror.push(n, m);
    }
    /**
    Append the inverse of the given mapping to this one.
    */ appendMappingInverted(mapping) {
        for(let i = mapping.maps.length - 1, totalSize = this.maps.length + mapping.maps.length; i >= 0; i--){
            let mirr = mapping.getMirror(i);
            this.appendMap(mapping.maps[i].invert(), mirr != null && mirr > i ? totalSize - mirr - 1 : undefined);
        }
    }
    /**
    Create an inverted version of this mapping.
    */ invert() {
        let inverse = new $040d9edd1880ca83$export$f5f785078011b62;
        inverse.appendMappingInverted(this);
        return inverse;
    }
    /**
    Map a position through this mapping.
    */ map(pos, assoc = 1) {
        if (this.mirror) return this._map(pos, assoc, true);
        for(let i = this.from; i < this.to; i++)pos = this.maps[i].map(pos, assoc);
        return pos;
    }
    /**
    Map a position through this mapping, returning a mapping
    result.
    */ mapResult(pos, assoc = 1) {
        return this._map(pos, assoc, false);
    }
    /**
    @internal
    */ _map(pos, assoc, simple) {
        let delInfo = 0;
        for(let i = this.from; i < this.to; i++){
            let map = this.maps[i], result = map.mapResult(pos, assoc);
            if (result.recover != null) {
                let corr = this.getMirror(i);
                if (corr != null && corr > i && corr < this.to) {
                    i = corr;
                    pos = this.maps[corr].recover(result.recover);
                    continue;
                }
            }
            delInfo |= result.delInfo;
            pos = result.pos;
        }
        return simple ? pos : new $040d9edd1880ca83$export$c77c9be41668e9b4(pos, delInfo, null);
    }
}
const $040d9edd1880ca83$var$stepsByID = Object.create(null);
/**
A step object represents an atomic change. It generally applies
only to the document it was created for, since the positions
stored in it will only make sense for that document.

New steps are defined by creating classes that extend `Step`,
overriding the `apply`, `invert`, `map`, `getMap` and `fromJSON`
methods, and registering your class with a unique
JSON-serialization identifier using
[`Step.jsonID`](https://prosemirror.net/docs/ref/#transform.Step^jsonID).
*/ class $040d9edd1880ca83$export$fd55ce593607084a {
    /**
    Get the step map that represents the changes made by this step,
    and which can be used to transform between positions in the old
    and the new document.
    */ getMap() {
        return $040d9edd1880ca83$export$c53d01c3ab9721b3.empty;
    }
    /**
    Try to merge this step with another one, to be applied directly
    after it. Returns the merged step when possible, null if the
    steps can't be merged.
    */ merge(other) {
        return null;
    }
    /**
    Deserialize a step from its JSON representation. Will call
    through to the step class' own implementation of this method.
    */ static fromJSON(schema, json) {
        if (!json || !json.stepType) throw new RangeError("Invalid input for Step.fromJSON");
        let type = $040d9edd1880ca83$var$stepsByID[json.stepType];
        if (!type) throw new RangeError(`No step type ${json.stepType} defined`);
        return type.fromJSON(schema, json);
    }
    /**
    To be able to serialize steps to JSON, each step needs a string
    ID to attach to its JSON representation. Use this method to
    register an ID for your step classes. Try to pick something
    that's unlikely to clash with steps from other modules.
    */ static jsonID(id, stepClass) {
        if (id in $040d9edd1880ca83$var$stepsByID) throw new RangeError("Duplicate use of step JSON ID " + id);
        $040d9edd1880ca83$var$stepsByID[id] = stepClass;
        stepClass.prototype.jsonID = id;
        return stepClass;
    }
}
/**
The result of [applying](https://prosemirror.net/docs/ref/#transform.Step.apply) a step. Contains either a
new document or a failure value.
*/ class $040d9edd1880ca83$export$8ebf1578a4199c09 {
    /**
    @internal
    */ constructor(/**
    The transformed document, if successful.
    */ doc, /**
    The failure message, if unsuccessful.
    */ failed){
        this.doc = doc;
        this.failed = failed;
    }
    /**
    Create a successful step result.
    */ static ok(doc) {
        return new $040d9edd1880ca83$export$8ebf1578a4199c09(doc, null);
    }
    /**
    Create a failed step result.
    */ static fail(message) {
        return new $040d9edd1880ca83$export$8ebf1578a4199c09(null, message);
    }
    /**
    Call [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) with the given
    arguments. Create a successful result if it succeeds, and a
    failed one if it throws a `ReplaceError`.
    */ static fromReplace(doc, from, to, slice) {
        try {
            return $040d9edd1880ca83$export$8ebf1578a4199c09.ok(doc.replace(from, to, slice));
        } catch (e) {
            if (e instanceof (0, $3xw6l.ReplaceError)) return $040d9edd1880ca83$export$8ebf1578a4199c09.fail(e.message);
            throw e;
        }
    }
}
function $040d9edd1880ca83$var$mapFragment(fragment, f, parent) {
    let mapped = [];
    for(let i = 0; i < fragment.childCount; i++){
        let child = fragment.child(i);
        if (child.content.size) child = child.copy($040d9edd1880ca83$var$mapFragment(child.content, f, child));
        if (child.isInline) child = f(child, parent, i);
        mapped.push(child);
    }
    return (0, $3xw6l.Fragment).fromArray(mapped);
}
/**
Add a mark to all inline content between two positions.
*/ class $040d9edd1880ca83$export$d24ba56b0e3464a9 extends $040d9edd1880ca83$export$fd55ce593607084a {
    /**
    Create a mark step.
    */ constructor(/**
    The start of the marked range.
    */ from, /**
    The end of the marked range.
    */ to, /**
    The mark to add.
    */ mark){
        super();
        this.from = from;
        this.to = to;
        this.mark = mark;
    }
    apply(doc) {
        let oldSlice = doc.slice(this.from, this.to), $from = doc.resolve(this.from);
        let parent = $from.node($from.sharedDepth(this.to));
        let slice = new (0, $3xw6l.Slice)($040d9edd1880ca83$var$mapFragment(oldSlice.content, (node, parent)=>{
            if (!node.isAtom || !parent.type.allowsMarkType(this.mark.type)) return node;
            return node.mark(this.mark.addToSet(node.marks));
        }, parent), oldSlice.openStart, oldSlice.openEnd);
        return $040d9edd1880ca83$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, slice);
    }
    invert() {
        return new $040d9edd1880ca83$export$94150db1311f67a9(this.from, this.to, this.mark);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deleted && to.deleted || from.pos >= to.pos) return null;
        return new $040d9edd1880ca83$export$d24ba56b0e3464a9(from.pos, to.pos, this.mark);
    }
    merge(other) {
        if (other instanceof $040d9edd1880ca83$export$d24ba56b0e3464a9 && other.mark.eq(this.mark) && this.from <= other.to && this.to >= other.from) return new $040d9edd1880ca83$export$d24ba56b0e3464a9(Math.min(this.from, other.from), Math.max(this.to, other.to), this.mark);
        return null;
    }
    toJSON() {
        return {
            stepType: "addMark",
            mark: this.mark.toJSON(),
            from: this.from,
            to: this.to
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for AddMarkStep.fromJSON");
        return new $040d9edd1880ca83$export$d24ba56b0e3464a9(json.from, json.to, schema.markFromJSON(json.mark));
    }
}
$040d9edd1880ca83$export$fd55ce593607084a.jsonID("addMark", $040d9edd1880ca83$export$d24ba56b0e3464a9);
/**
Remove a mark from all inline content between two positions.
*/ class $040d9edd1880ca83$export$94150db1311f67a9 extends $040d9edd1880ca83$export$fd55ce593607084a {
    /**
    Create a mark-removing step.
    */ constructor(/**
    The start of the unmarked range.
    */ from, /**
    The end of the unmarked range.
    */ to, /**
    The mark to remove.
    */ mark){
        super();
        this.from = from;
        this.to = to;
        this.mark = mark;
    }
    apply(doc) {
        let oldSlice = doc.slice(this.from, this.to);
        let slice = new (0, $3xw6l.Slice)($040d9edd1880ca83$var$mapFragment(oldSlice.content, (node)=>{
            return node.mark(this.mark.removeFromSet(node.marks));
        }, doc), oldSlice.openStart, oldSlice.openEnd);
        return $040d9edd1880ca83$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, slice);
    }
    invert() {
        return new $040d9edd1880ca83$export$d24ba56b0e3464a9(this.from, this.to, this.mark);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deleted && to.deleted || from.pos >= to.pos) return null;
        return new $040d9edd1880ca83$export$94150db1311f67a9(from.pos, to.pos, this.mark);
    }
    merge(other) {
        if (other instanceof $040d9edd1880ca83$export$94150db1311f67a9 && other.mark.eq(this.mark) && this.from <= other.to && this.to >= other.from) return new $040d9edd1880ca83$export$94150db1311f67a9(Math.min(this.from, other.from), Math.max(this.to, other.to), this.mark);
        return null;
    }
    toJSON() {
        return {
            stepType: "removeMark",
            mark: this.mark.toJSON(),
            from: this.from,
            to: this.to
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
        return new $040d9edd1880ca83$export$94150db1311f67a9(json.from, json.to, schema.markFromJSON(json.mark));
    }
}
$040d9edd1880ca83$export$fd55ce593607084a.jsonID("removeMark", $040d9edd1880ca83$export$94150db1311f67a9);
/**
Add a mark to a specific node.
*/ class $040d9edd1880ca83$export$adefd16c402fee4e extends $040d9edd1880ca83$export$fd55ce593607084a {
    /**
    Create a node mark step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The mark to add.
    */ mark){
        super();
        this.pos = pos;
        this.mark = mark;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $040d9edd1880ca83$export$8ebf1578a4199c09.fail("No node at mark step's position");
        let updated = node.type.create(node.attrs, null, this.mark.addToSet(node.marks));
        return $040d9edd1880ca83$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    invert(doc) {
        let node = doc.nodeAt(this.pos);
        if (node) {
            let newSet = this.mark.addToSet(node.marks);
            if (newSet.length == node.marks.length) {
                for(let i = 0; i < node.marks.length; i++)if (!node.marks[i].isInSet(newSet)) return new $040d9edd1880ca83$export$adefd16c402fee4e(this.pos, node.marks[i]);
                return new $040d9edd1880ca83$export$adefd16c402fee4e(this.pos, this.mark);
            }
        }
        return new $040d9edd1880ca83$export$fdf7d1dc10724da2(this.pos, this.mark);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $040d9edd1880ca83$export$adefd16c402fee4e(pos.pos, this.mark);
    }
    toJSON() {
        return {
            stepType: "addNodeMark",
            pos: this.pos,
            mark: this.mark.toJSON()
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.pos != "number") throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
        return new $040d9edd1880ca83$export$adefd16c402fee4e(json.pos, schema.markFromJSON(json.mark));
    }
}
$040d9edd1880ca83$export$fd55ce593607084a.jsonID("addNodeMark", $040d9edd1880ca83$export$adefd16c402fee4e);
/**
Remove a mark from a specific node.
*/ class $040d9edd1880ca83$export$fdf7d1dc10724da2 extends $040d9edd1880ca83$export$fd55ce593607084a {
    /**
    Create a mark-removing step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The mark to remove.
    */ mark){
        super();
        this.pos = pos;
        this.mark = mark;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $040d9edd1880ca83$export$8ebf1578a4199c09.fail("No node at mark step's position");
        let updated = node.type.create(node.attrs, null, this.mark.removeFromSet(node.marks));
        return $040d9edd1880ca83$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    invert(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node || !this.mark.isInSet(node.marks)) return this;
        return new $040d9edd1880ca83$export$adefd16c402fee4e(this.pos, this.mark);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $040d9edd1880ca83$export$fdf7d1dc10724da2(pos.pos, this.mark);
    }
    toJSON() {
        return {
            stepType: "removeNodeMark",
            pos: this.pos,
            mark: this.mark.toJSON()
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.pos != "number") throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
        return new $040d9edd1880ca83$export$fdf7d1dc10724da2(json.pos, schema.markFromJSON(json.mark));
    }
}
$040d9edd1880ca83$export$fd55ce593607084a.jsonID("removeNodeMark", $040d9edd1880ca83$export$fdf7d1dc10724da2);
/**
Replace a part of the document with a slice of new content.
*/ class $040d9edd1880ca83$export$5c860b2e74034756 extends $040d9edd1880ca83$export$fd55ce593607084a {
    /**
    The given `slice` should fit the 'gap' between `from` and
    `to`—the depths must line up, and the surrounding nodes must be
    able to be joined with the open sides of the slice. When
    `structure` is true, the step will fail if the content between
    from and to is not just a sequence of closing and then opening
    tokens (this is to guard against rebased replace steps
    overwriting something they weren't supposed to).
    */ constructor(/**
    The start position of the replaced range.
    */ from, /**
    The end position of the replaced range.
    */ to, /**
    The slice to insert.
    */ slice, /**
    @internal
    */ structure = false){
        super();
        this.from = from;
        this.to = to;
        this.slice = slice;
        this.structure = structure;
    }
    apply(doc) {
        if (this.structure && $040d9edd1880ca83$var$contentBetween(doc, this.from, this.to)) return $040d9edd1880ca83$export$8ebf1578a4199c09.fail("Structure replace would overwrite content");
        return $040d9edd1880ca83$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, this.slice);
    }
    getMap() {
        return new $040d9edd1880ca83$export$c53d01c3ab9721b3([
            this.from,
            this.to - this.from,
            this.slice.size
        ]);
    }
    invert(doc) {
        return new $040d9edd1880ca83$export$5c860b2e74034756(this.from, this.from + this.slice.size, doc.slice(this.from, this.to));
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deletedAcross && to.deletedAcross) return null;
        return new $040d9edd1880ca83$export$5c860b2e74034756(from.pos, Math.max(from.pos, to.pos), this.slice);
    }
    merge(other) {
        if (!(other instanceof $040d9edd1880ca83$export$5c860b2e74034756) || other.structure || this.structure) return null;
        if (this.from + this.slice.size == other.from && !this.slice.openEnd && !other.slice.openStart) {
            let slice = this.slice.size + other.slice.size == 0 ? (0, $3xw6l.Slice).empty : new (0, $3xw6l.Slice)(this.slice.content.append(other.slice.content), this.slice.openStart, other.slice.openEnd);
            return new $040d9edd1880ca83$export$5c860b2e74034756(this.from, this.to + (other.to - other.from), slice, this.structure);
        } else if (other.to == this.from && !this.slice.openStart && !other.slice.openEnd) {
            let slice = this.slice.size + other.slice.size == 0 ? (0, $3xw6l.Slice).empty : new (0, $3xw6l.Slice)(other.slice.content.append(this.slice.content), other.slice.openStart, this.slice.openEnd);
            return new $040d9edd1880ca83$export$5c860b2e74034756(other.from, this.to, slice, this.structure);
        } else return null;
    }
    toJSON() {
        let json = {
            stepType: "replace",
            from: this.from,
            to: this.to
        };
        if (this.slice.size) json.slice = this.slice.toJSON();
        if (this.structure) json.structure = true;
        return json;
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for ReplaceStep.fromJSON");
        return new $040d9edd1880ca83$export$5c860b2e74034756(json.from, json.to, (0, $3xw6l.Slice).fromJSON(schema, json.slice), !!json.structure);
    }
}
$040d9edd1880ca83$export$fd55ce593607084a.jsonID("replace", $040d9edd1880ca83$export$5c860b2e74034756);
/**
Replace a part of the document with a slice of content, but
preserve a range of the replaced content by moving it into the
slice.
*/ class $040d9edd1880ca83$export$444ba800d6024a98 extends $040d9edd1880ca83$export$fd55ce593607084a {
    /**
    Create a replace-around step with the given range and gap.
    `insert` should be the point in the slice into which the content
    of the gap should be moved. `structure` has the same meaning as
    it has in the [`ReplaceStep`](https://prosemirror.net/docs/ref/#transform.ReplaceStep) class.
    */ constructor(/**
    The start position of the replaced range.
    */ from, /**
    The end position of the replaced range.
    */ to, /**
    The start of preserved range.
    */ gapFrom, /**
    The end of preserved range.
    */ gapTo, /**
    The slice to insert.
    */ slice, /**
    The position in the slice where the preserved range should be
    inserted.
    */ insert, /**
    @internal
    */ structure = false){
        super();
        this.from = from;
        this.to = to;
        this.gapFrom = gapFrom;
        this.gapTo = gapTo;
        this.slice = slice;
        this.insert = insert;
        this.structure = structure;
    }
    apply(doc) {
        if (this.structure && ($040d9edd1880ca83$var$contentBetween(doc, this.from, this.gapFrom) || $040d9edd1880ca83$var$contentBetween(doc, this.gapTo, this.to))) return $040d9edd1880ca83$export$8ebf1578a4199c09.fail("Structure gap-replace would overwrite content");
        let gap = doc.slice(this.gapFrom, this.gapTo);
        if (gap.openStart || gap.openEnd) return $040d9edd1880ca83$export$8ebf1578a4199c09.fail("Gap is not a flat range");
        let inserted = this.slice.insertAt(this.insert, gap.content);
        if (!inserted) return $040d9edd1880ca83$export$8ebf1578a4199c09.fail("Content does not fit in gap");
        return $040d9edd1880ca83$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, inserted);
    }
    getMap() {
        return new $040d9edd1880ca83$export$c53d01c3ab9721b3([
            this.from,
            this.gapFrom - this.from,
            this.insert,
            this.gapTo,
            this.to - this.gapTo,
            this.slice.size - this.insert
        ]);
    }
    invert(doc) {
        let gap = this.gapTo - this.gapFrom;
        return new $040d9edd1880ca83$export$444ba800d6024a98(this.from, this.from + this.slice.size + gap, this.from + this.insert, this.from + this.insert + gap, doc.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        let gapFrom = this.from == this.gapFrom ? from.pos : mapping.map(this.gapFrom, -1);
        let gapTo = this.to == this.gapTo ? to.pos : mapping.map(this.gapTo, 1);
        if (from.deletedAcross && to.deletedAcross || gapFrom < from.pos || gapTo > to.pos) return null;
        return new $040d9edd1880ca83$export$444ba800d6024a98(from.pos, to.pos, gapFrom, gapTo, this.slice, this.insert, this.structure);
    }
    toJSON() {
        let json = {
            stepType: "replaceAround",
            from: this.from,
            to: this.to,
            gapFrom: this.gapFrom,
            gapTo: this.gapTo,
            insert: this.insert
        };
        if (this.slice.size) json.slice = this.slice.toJSON();
        if (this.structure) json.structure = true;
        return json;
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number" || typeof json.gapFrom != "number" || typeof json.gapTo != "number" || typeof json.insert != "number") throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
        return new $040d9edd1880ca83$export$444ba800d6024a98(json.from, json.to, json.gapFrom, json.gapTo, (0, $3xw6l.Slice).fromJSON(schema, json.slice), json.insert, !!json.structure);
    }
}
$040d9edd1880ca83$export$fd55ce593607084a.jsonID("replaceAround", $040d9edd1880ca83$export$444ba800d6024a98);
function $040d9edd1880ca83$var$contentBetween(doc, from, to) {
    let $from = doc.resolve(from), dist = to - from, depth = $from.depth;
    while(dist > 0 && depth > 0 && $from.indexAfter(depth) == $from.node(depth).childCount){
        depth--;
        dist--;
    }
    if (dist > 0) {
        let next = $from.node(depth).maybeChild($from.indexAfter(depth));
        while(dist > 0){
            if (!next || next.isLeaf) return true;
            next = next.firstChild;
            dist--;
        }
    }
    return false;
}
function $040d9edd1880ca83$var$addMark(tr, from, to, mark) {
    let removed = [], added = [];
    let removing, adding;
    tr.doc.nodesBetween(from, to, (node, pos, parent)=>{
        if (!node.isInline) return;
        let marks = node.marks;
        if (!mark.isInSet(marks) && parent.type.allowsMarkType(mark.type)) {
            let start = Math.max(pos, from), end = Math.min(pos + node.nodeSize, to);
            let newSet = mark.addToSet(marks);
            for(let i = 0; i < marks.length; i++)if (!marks[i].isInSet(newSet)) {
                if (removing && removing.to == start && removing.mark.eq(marks[i])) removing.to = end;
                else removed.push(removing = new $040d9edd1880ca83$export$94150db1311f67a9(start, end, marks[i]));
            }
            if (adding && adding.to == start) adding.to = end;
            else added.push(adding = new $040d9edd1880ca83$export$d24ba56b0e3464a9(start, end, mark));
        }
    });
    removed.forEach((s)=>tr.step(s));
    added.forEach((s)=>tr.step(s));
}
function $040d9edd1880ca83$var$removeMark(tr, from, to, mark) {
    let matched = [], step = 0;
    tr.doc.nodesBetween(from, to, (node, pos)=>{
        if (!node.isInline) return;
        step++;
        let toRemove = null;
        if (mark instanceof (0, $3xw6l.MarkType)) {
            let set = node.marks, found;
            while(found = mark.isInSet(set)){
                (toRemove || (toRemove = [])).push(found);
                set = found.removeFromSet(set);
            }
        } else if (mark) {
            if (mark.isInSet(node.marks)) toRemove = [
                mark
            ];
        } else toRemove = node.marks;
        if (toRemove && toRemove.length) {
            let end = Math.min(pos + node.nodeSize, to);
            for(let i = 0; i < toRemove.length; i++){
                let style = toRemove[i], found;
                for(let j = 0; j < matched.length; j++){
                    let m = matched[j];
                    if (m.step == step - 1 && style.eq(matched[j].style)) found = m;
                }
                if (found) {
                    found.to = end;
                    found.step = step;
                } else matched.push({
                    style: style,
                    from: Math.max(pos, from),
                    to: end,
                    step: step
                });
            }
        }
    });
    matched.forEach((m)=>tr.step(new $040d9edd1880ca83$export$94150db1311f67a9(m.from, m.to, m.style)));
}
function $040d9edd1880ca83$var$clearIncompatible(tr, pos, parentType, match = parentType.contentMatch, clearNewlines = true) {
    let node = tr.doc.nodeAt(pos);
    let replSteps = [], cur = pos + 1;
    for(let i = 0; i < node.childCount; i++){
        let child = node.child(i), end = cur + child.nodeSize;
        let allowed = match.matchType(child.type);
        if (!allowed) replSteps.push(new $040d9edd1880ca83$export$5c860b2e74034756(cur, end, (0, $3xw6l.Slice).empty));
        else {
            match = allowed;
            for(let j = 0; j < child.marks.length; j++)if (!parentType.allowsMarkType(child.marks[j].type)) tr.step(new $040d9edd1880ca83$export$94150db1311f67a9(cur, end, child.marks[j]));
            if (clearNewlines && child.isText && parentType.whitespace != "pre") {
                let m, newline = /\r?\n|\r/g, slice;
                while(m = newline.exec(child.text)){
                    if (!slice) slice = new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).from(parentType.schema.text(" ", parentType.allowedMarks(child.marks))), 0, 0);
                    replSteps.push(new $040d9edd1880ca83$export$5c860b2e74034756(cur + m.index, cur + m.index + m[0].length, slice));
                }
            }
        }
        cur = end;
    }
    if (!match.validEnd) {
        let fill = match.fillBefore((0, $3xw6l.Fragment).empty, true);
        tr.replace(cur, cur, new (0, $3xw6l.Slice)(fill, 0, 0));
    }
    for(let i = replSteps.length - 1; i >= 0; i--)tr.step(replSteps[i]);
}
function $040d9edd1880ca83$var$canCut(node, start, end) {
    return (start == 0 || node.canReplace(start, node.childCount)) && (end == node.childCount || node.canReplace(0, end));
}
/**
Try to find a target depth to which the content in the given range
can be lifted. Will not go across
[isolating](https://prosemirror.net/docs/ref/#model.NodeSpec.isolating) parent nodes.
*/ function $040d9edd1880ca83$export$f1508b72cc76a09e(range) {
    let parent = range.parent;
    let content = parent.content.cutByIndex(range.startIndex, range.endIndex);
    for(let depth = range.depth;; --depth){
        let node = range.$from.node(depth);
        let index = range.$from.index(depth), endIndex = range.$to.indexAfter(depth);
        if (depth < range.depth && node.canReplace(index, endIndex, content)) return depth;
        if (depth == 0 || node.type.spec.isolating || !$040d9edd1880ca83$var$canCut(node, index, endIndex)) break;
    }
    return null;
}
function $040d9edd1880ca83$var$lift(tr, range, target) {
    let { $from: $from, $to: $to, depth: depth } = range;
    let gapStart = $from.before(depth + 1), gapEnd = $to.after(depth + 1);
    let start = gapStart, end = gapEnd;
    let before = (0, $3xw6l.Fragment).empty, openStart = 0;
    for(let d = depth, splitting = false; d > target; d--)if (splitting || $from.index(d) > 0) {
        splitting = true;
        before = (0, $3xw6l.Fragment).from($from.node(d).copy(before));
        openStart++;
    } else start--;
    let after = (0, $3xw6l.Fragment).empty, openEnd = 0;
    for(let d = depth, splitting = false; d > target; d--)if (splitting || $to.after(d + 1) < $to.end(d)) {
        splitting = true;
        after = (0, $3xw6l.Fragment).from($to.node(d).copy(after));
        openEnd++;
    } else end++;
    tr.step(new $040d9edd1880ca83$export$444ba800d6024a98(start, end, gapStart, gapEnd, new (0, $3xw6l.Slice)(before.append(after), openStart, openEnd), before.size - openStart, true));
}
/**
Try to find a valid way to wrap the content in the given range in a
node of the given type. May introduce extra nodes around and inside
the wrapper node, if necessary. Returns null if no valid wrapping
could be found. When `innerRange` is given, that range's content is
used as the content to fit into the wrapping, instead of the
content of `range`.
*/ function $040d9edd1880ca83$export$118cb9a83e81ba37(range, nodeType, attrs = null, innerRange = range) {
    let around = $040d9edd1880ca83$var$findWrappingOutside(range, nodeType);
    let inner = around && $040d9edd1880ca83$var$findWrappingInside(innerRange, nodeType);
    if (!inner) return null;
    return around.map($040d9edd1880ca83$var$withAttrs).concat({
        type: nodeType,
        attrs: attrs
    }).concat(inner.map($040d9edd1880ca83$var$withAttrs));
}
function $040d9edd1880ca83$var$withAttrs(type) {
    return {
        type: type,
        attrs: null
    };
}
function $040d9edd1880ca83$var$findWrappingOutside(range, type) {
    let { parent: parent, startIndex: startIndex, endIndex: endIndex } = range;
    let around = parent.contentMatchAt(startIndex).findWrapping(type);
    if (!around) return null;
    let outer = around.length ? around[0] : type;
    return parent.canReplaceWith(startIndex, endIndex, outer) ? around : null;
}
function $040d9edd1880ca83$var$findWrappingInside(range, type) {
    let { parent: parent, startIndex: startIndex, endIndex: endIndex } = range;
    let inner = parent.child(startIndex);
    let inside = type.contentMatch.findWrapping(inner.type);
    if (!inside) return null;
    let lastType = inside.length ? inside[inside.length - 1] : type;
    let innerMatch = lastType.contentMatch;
    for(let i = startIndex; innerMatch && i < endIndex; i++)innerMatch = innerMatch.matchType(parent.child(i).type);
    if (!innerMatch || !innerMatch.validEnd) return null;
    return inside;
}
function $040d9edd1880ca83$var$wrap(tr, range, wrappers) {
    let content = (0, $3xw6l.Fragment).empty;
    for(let i = wrappers.length - 1; i >= 0; i--){
        if (content.size) {
            let match = wrappers[i].type.contentMatch.matchFragment(content);
            if (!match || !match.validEnd) throw new RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper");
        }
        content = (0, $3xw6l.Fragment).from(wrappers[i].type.create(wrappers[i].attrs, content));
    }
    let start = range.start, end = range.end;
    tr.step(new $040d9edd1880ca83$export$444ba800d6024a98(start, end, start, end, new (0, $3xw6l.Slice)(content, 0, 0), wrappers.length, true));
}
function $040d9edd1880ca83$var$setBlockType(tr, from, to, type, attrs) {
    if (!type.isTextblock) throw new RangeError("Type given to setBlockType should be a textblock");
    let mapFrom = tr.steps.length;
    tr.doc.nodesBetween(from, to, (node, pos)=>{
        let attrsHere = typeof attrs == "function" ? attrs(node) : attrs;
        if (node.isTextblock && !node.hasMarkup(type, attrsHere) && $040d9edd1880ca83$var$canChangeType(tr.doc, tr.mapping.slice(mapFrom).map(pos), type)) {
            let convertNewlines = null;
            if (type.schema.linebreakReplacement) {
                let pre = type.whitespace == "pre", supportLinebreak = !!type.contentMatch.matchType(type.schema.linebreakReplacement);
                if (pre && !supportLinebreak) convertNewlines = false;
                else if (!pre && supportLinebreak) convertNewlines = true;
            }
            // Ensure all markup that isn't allowed in the new node type is cleared
            if (convertNewlines === false) $040d9edd1880ca83$var$replaceLinebreaks(tr, node, pos, mapFrom);
            $040d9edd1880ca83$var$clearIncompatible(tr, tr.mapping.slice(mapFrom).map(pos, 1), type, undefined, convertNewlines === null);
            let mapping = tr.mapping.slice(mapFrom);
            let startM = mapping.map(pos, 1), endM = mapping.map(pos + node.nodeSize, 1);
            tr.step(new $040d9edd1880ca83$export$444ba800d6024a98(startM, endM, startM + 1, endM - 1, new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).from(type.create(attrsHere, null, node.marks)), 0, 0), 1, true));
            if (convertNewlines === true) $040d9edd1880ca83$var$replaceNewlines(tr, node, pos, mapFrom);
            return false;
        }
    });
}
function $040d9edd1880ca83$var$replaceNewlines(tr, node, pos, mapFrom) {
    node.forEach((child, offset)=>{
        if (child.isText) {
            let m, newline = /\r?\n|\r/g;
            while(m = newline.exec(child.text)){
                let start = tr.mapping.slice(mapFrom).map(pos + 1 + offset + m.index);
                tr.replaceWith(start, start + 1, node.type.schema.linebreakReplacement.create());
            }
        }
    });
}
function $040d9edd1880ca83$var$replaceLinebreaks(tr, node, pos, mapFrom) {
    node.forEach((child, offset)=>{
        if (child.type == child.type.schema.linebreakReplacement) {
            let start = tr.mapping.slice(mapFrom).map(pos + 1 + offset);
            tr.replaceWith(start, start + 1, node.type.schema.text("\n"));
        }
    });
}
function $040d9edd1880ca83$var$canChangeType(doc, pos, type) {
    let $pos = doc.resolve(pos), index = $pos.index();
    return $pos.parent.canReplaceWith(index, index + 1, type);
}
/**
Change the type, attributes, and/or marks of the node at `pos`.
When `type` isn't given, the existing node type is preserved,
*/ function $040d9edd1880ca83$var$setNodeMarkup(tr, pos, type, attrs, marks) {
    let node = tr.doc.nodeAt(pos);
    if (!node) throw new RangeError("No node at given position");
    if (!type) type = node.type;
    let newNode = type.create(attrs, null, marks || node.marks);
    if (node.isLeaf) return tr.replaceWith(pos, pos + node.nodeSize, newNode);
    if (!type.validContent(node.content)) throw new RangeError("Invalid content for node type " + type.name);
    tr.step(new $040d9edd1880ca83$export$444ba800d6024a98(pos, pos + node.nodeSize, pos + 1, pos + node.nodeSize - 1, new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).from(newNode), 0, 0), 1, true));
}
/**
Check whether splitting at the given position is allowed.
*/ function $040d9edd1880ca83$export$5aaf008897aef029(doc, pos, depth = 1, typesAfter) {
    let $pos = doc.resolve(pos), base = $pos.depth - depth;
    let innerType = typesAfter && typesAfter[typesAfter.length - 1] || $pos.parent;
    if (base < 0 || $pos.parent.type.spec.isolating || !$pos.parent.canReplace($pos.index(), $pos.parent.childCount) || !innerType.type.validContent($pos.parent.content.cutByIndex($pos.index(), $pos.parent.childCount))) return false;
    for(let d = $pos.depth - 1, i = depth - 2; d > base; d--, i--){
        let node = $pos.node(d), index = $pos.index(d);
        if (node.type.spec.isolating) return false;
        let rest = node.content.cutByIndex(index, node.childCount);
        let overrideChild = typesAfter && typesAfter[i + 1];
        if (overrideChild) rest = rest.replaceChild(0, overrideChild.type.create(overrideChild.attrs));
        let after = typesAfter && typesAfter[i] || node;
        if (!node.canReplace(index + 1, node.childCount) || !after.type.validContent(rest)) return false;
    }
    let index = $pos.indexAfter(base);
    let baseType = typesAfter && typesAfter[0];
    return $pos.node(base).canReplaceWith(index, index, baseType ? baseType.type : $pos.node(base + 1).type);
}
function $040d9edd1880ca83$var$split(tr, pos, depth = 1, typesAfter) {
    let $pos = tr.doc.resolve(pos), before = (0, $3xw6l.Fragment).empty, after = (0, $3xw6l.Fragment).empty;
    for(let d = $pos.depth, e = $pos.depth - depth, i = depth - 1; d > e; d--, i--){
        before = (0, $3xw6l.Fragment).from($pos.node(d).copy(before));
        let typeAfter = typesAfter && typesAfter[i];
        after = (0, $3xw6l.Fragment).from(typeAfter ? typeAfter.type.create(typeAfter.attrs, after) : $pos.node(d).copy(after));
    }
    tr.step(new $040d9edd1880ca83$export$5c860b2e74034756(pos, pos, new (0, $3xw6l.Slice)(before.append(after), depth, depth), true));
}
/**
Test whether the blocks before and after a given position can be
joined.
*/ function $040d9edd1880ca83$export$f15f89fd9d8cc98a(doc, pos) {
    let $pos = doc.resolve(pos), index = $pos.index();
    return $040d9edd1880ca83$var$joinable($pos.nodeBefore, $pos.nodeAfter) && $pos.parent.canReplace(index, index + 1);
}
function $040d9edd1880ca83$var$canAppendWithSubstitutedLinebreaks(a, b) {
    if (!b.content.size) a.type.compatibleContent(b.type);
    let match = a.contentMatchAt(a.childCount);
    let { linebreakReplacement: linebreakReplacement } = a.type.schema;
    for(let i = 0; i < b.childCount; i++){
        let child = b.child(i);
        let type = child.type == linebreakReplacement ? a.type.schema.nodes.text : child.type;
        match = match.matchType(type);
        if (!match) return false;
        if (!a.type.allowsMarks(child.marks)) return false;
    }
    return match.validEnd;
}
function $040d9edd1880ca83$var$joinable(a, b) {
    return !!(a && b && !a.isLeaf && $040d9edd1880ca83$var$canAppendWithSubstitutedLinebreaks(a, b));
}
/**
Find an ancestor of the given position that can be joined to the
block before (or after if `dir` is positive). Returns the joinable
point, if any.
*/ function $040d9edd1880ca83$export$41b1d4cb5ceb3147(doc, pos, dir = -1) {
    let $pos = doc.resolve(pos);
    for(let d = $pos.depth;; d--){
        let before, after, index = $pos.index(d);
        if (d == $pos.depth) {
            before = $pos.nodeBefore;
            after = $pos.nodeAfter;
        } else if (dir > 0) {
            before = $pos.node(d + 1);
            index++;
            after = $pos.node(d).maybeChild(index);
        } else {
            before = $pos.node(d).maybeChild(index - 1);
            after = $pos.node(d + 1);
        }
        if (before && !before.isTextblock && $040d9edd1880ca83$var$joinable(before, after) && $pos.node(d).canReplace(index, index + 1)) return pos;
        if (d == 0) break;
        pos = dir < 0 ? $pos.before(d) : $pos.after(d);
    }
}
function $040d9edd1880ca83$var$join(tr, pos, depth) {
    let convertNewlines = null;
    let { linebreakReplacement: linebreakReplacement } = tr.doc.type.schema;
    let $before = tr.doc.resolve(pos - depth), beforeType = $before.node().type;
    if (linebreakReplacement && beforeType.inlineContent) {
        let pre = beforeType.whitespace == "pre";
        let supportLinebreak = !!beforeType.contentMatch.matchType(linebreakReplacement);
        if (pre && !supportLinebreak) convertNewlines = false;
        else if (!pre && supportLinebreak) convertNewlines = true;
    }
    let mapFrom = tr.steps.length;
    if (convertNewlines === false) {
        let $after = tr.doc.resolve(pos + depth);
        $040d9edd1880ca83$var$replaceLinebreaks(tr, $after.node(), $after.before(), mapFrom);
    }
    if (beforeType.inlineContent) $040d9edd1880ca83$var$clearIncompatible(tr, pos + depth - 1, beforeType, $before.node().contentMatchAt($before.index()), convertNewlines == null);
    let mapping = tr.mapping.slice(mapFrom), start = mapping.map(pos - depth);
    tr.step(new $040d9edd1880ca83$export$5c860b2e74034756(start, mapping.map(pos + depth, -1), (0, $3xw6l.Slice).empty, true));
    if (convertNewlines === true) {
        let $full = tr.doc.resolve(start);
        $040d9edd1880ca83$var$replaceNewlines(tr, $full.node(), $full.before(), tr.steps.length);
    }
    return tr;
}
/**
Try to find a point where a node of the given type can be inserted
near `pos`, by searching up the node hierarchy when `pos` itself
isn't a valid place but is at the start or end of a node. Return
null if no position was found.
*/ function $040d9edd1880ca83$export$64cb316d02de1dd1(doc, pos, nodeType) {
    let $pos = doc.resolve(pos);
    if ($pos.parent.canReplaceWith($pos.index(), $pos.index(), nodeType)) return pos;
    if ($pos.parentOffset == 0) for(let d = $pos.depth - 1; d >= 0; d--){
        let index = $pos.index(d);
        if ($pos.node(d).canReplaceWith(index, index, nodeType)) return $pos.before(d + 1);
        if (index > 0) return null;
    }
    if ($pos.parentOffset == $pos.parent.content.size) for(let d = $pos.depth - 1; d >= 0; d--){
        let index = $pos.indexAfter(d);
        if ($pos.node(d).canReplaceWith(index, index, nodeType)) return $pos.after(d + 1);
        if (index < $pos.node(d).childCount) return null;
    }
    return null;
}
/**
Finds a position at or around the given position where the given
slice can be inserted. Will look at parent nodes' nearest boundary
and try there, even if the original position wasn't directly at the
start or end of that node. Returns null when no position was found.
*/ function $040d9edd1880ca83$export$2819d598d048fc9c(doc, pos, slice) {
    let $pos = doc.resolve(pos);
    if (!slice.content.size) return pos;
    let content = slice.content;
    for(let i = 0; i < slice.openStart; i++)content = content.firstChild.content;
    for(let pass = 1; pass <= (slice.openStart == 0 && slice.size ? 2 : 1); pass++)for(let d = $pos.depth; d >= 0; d--){
        let bias = d == $pos.depth ? 0 : $pos.pos <= ($pos.start(d + 1) + $pos.end(d + 1)) / 2 ? -1 : 1;
        let insertPos = $pos.index(d) + (bias > 0 ? 1 : 0);
        let parent = $pos.node(d), fits = false;
        if (pass == 1) fits = parent.canReplace(insertPos, insertPos, content);
        else {
            let wrapping = parent.contentMatchAt(insertPos).findWrapping(content.firstChild.type);
            fits = wrapping && parent.canReplaceWith(insertPos, insertPos, wrapping[0]);
        }
        if (fits) return bias == 0 ? $pos.pos : bias < 0 ? $pos.before(d + 1) : $pos.after(d + 1);
    }
    return null;
}
/**
‘Fit’ a slice into a given position in the document, producing a
[step](https://prosemirror.net/docs/ref/#transform.Step) that inserts it. Will return null if
there's no meaningful way to insert the slice here, or inserting it
would be a no-op (an empty slice over an empty range).
*/ function $040d9edd1880ca83$export$ed6ac67359824afd(doc, from, to = from, slice = (0, $3xw6l.Slice).empty) {
    if (from == to && !slice.size) return null;
    let $from = doc.resolve(from), $to = doc.resolve(to);
    // Optimization -- avoid work if it's obvious that it's not needed.
    if ($040d9edd1880ca83$var$fitsTrivially($from, $to, slice)) return new $040d9edd1880ca83$export$5c860b2e74034756(from, to, slice);
    return new $040d9edd1880ca83$var$Fitter($from, $to, slice).fit();
}
function $040d9edd1880ca83$var$fitsTrivially($from, $to, slice) {
    return !slice.openStart && !slice.openEnd && $from.start() == $to.start() && $from.parent.canReplace($from.index(), $to.index(), slice.content);
}
// Algorithm for 'placing' the elements of a slice into a gap:
//
// We consider the content of each node that is open to the left to be
// independently placeable. I.e. in <p("foo"), p("bar")>, when the
// paragraph on the left is open, "foo" can be placed (somewhere on
// the left side of the replacement gap) independently from p("bar").
//
// This class tracks the state of the placement progress in the
// following properties:
//
//  - `frontier` holds a stack of `{type, match}` objects that
//    represent the open side of the replacement. It starts at
//    `$from`, then moves forward as content is placed, and is finally
//    reconciled with `$to`.
//
//  - `unplaced` is a slice that represents the content that hasn't
//    been placed yet.
//
//  - `placed` is a fragment of placed content. Its open-start value
//    is implicit in `$from`, and its open-end value in `frontier`.
class $040d9edd1880ca83$var$Fitter {
    constructor($from, $to, unplaced){
        this.$from = $from;
        this.$to = $to;
        this.unplaced = unplaced;
        this.frontier = [];
        this.placed = (0, $3xw6l.Fragment).empty;
        for(let i = 0; i <= $from.depth; i++){
            let node = $from.node(i);
            this.frontier.push({
                type: node.type,
                match: node.contentMatchAt($from.indexAfter(i))
            });
        }
        for(let i = $from.depth; i > 0; i--)this.placed = (0, $3xw6l.Fragment).from($from.node(i).copy(this.placed));
    }
    get depth() {
        return this.frontier.length - 1;
    }
    fit() {
        // As long as there's unplaced content, try to place some of it.
        // If that fails, either increase the open score of the unplaced
        // slice, or drop nodes from it, and then try again.
        while(this.unplaced.size){
            let fit = this.findFittable();
            if (fit) this.placeNodes(fit);
            else this.openMore() || this.dropNode();
        }
        // When there's inline content directly after the frontier _and_
        // directly after `this.$to`, we must generate a `ReplaceAround`
        // step that pulls that content into the node after the frontier.
        // That means the fitting must be done to the end of the textblock
        // node after `this.$to`, not `this.$to` itself.
        let moveInline = this.mustMoveInline(), placedSize = this.placed.size - this.depth - this.$from.depth;
        let $from = this.$from, $to = this.close(moveInline < 0 ? this.$to : $from.doc.resolve(moveInline));
        if (!$to) return null;
        // If closing to `$to` succeeded, create a step
        let content = this.placed, openStart = $from.depth, openEnd = $to.depth;
        while(openStart && openEnd && content.childCount == 1){
            content = content.firstChild.content;
            openStart--;
            openEnd--;
        }
        let slice = new (0, $3xw6l.Slice)(content, openStart, openEnd);
        if (moveInline > -1) return new $040d9edd1880ca83$export$444ba800d6024a98($from.pos, moveInline, this.$to.pos, this.$to.end(), slice, placedSize);
        if (slice.size || $from.pos != this.$to.pos) return new $040d9edd1880ca83$export$5c860b2e74034756($from.pos, $to.pos, slice);
        return null;
    }
    // Find a position on the start spine of `this.unplaced` that has
    // content that can be moved somewhere on the frontier. Returns two
    // depths, one for the slice and one for the frontier.
    findFittable() {
        let startDepth = this.unplaced.openStart;
        for(let cur = this.unplaced.content, d = 0, openEnd = this.unplaced.openEnd; d < startDepth; d++){
            let node = cur.firstChild;
            if (cur.childCount > 1) openEnd = 0;
            if (node.type.spec.isolating && openEnd <= d) {
                startDepth = d;
                break;
            }
            cur = node.content;
        }
        // Only try wrapping nodes (pass 2) after finding a place without
        // wrapping failed.
        for(let pass = 1; pass <= 2; pass++)for(let sliceDepth = pass == 1 ? startDepth : this.unplaced.openStart; sliceDepth >= 0; sliceDepth--){
            let fragment, parent = null;
            if (sliceDepth) {
                parent = $040d9edd1880ca83$var$contentAt(this.unplaced.content, sliceDepth - 1).firstChild;
                fragment = parent.content;
            } else fragment = this.unplaced.content;
            let first = fragment.firstChild;
            for(let frontierDepth = this.depth; frontierDepth >= 0; frontierDepth--){
                let { type: type, match: match } = this.frontier[frontierDepth], wrap, inject = null;
                // In pass 1, if the next node matches, or there is no next
                // node but the parents look compatible, we've found a
                // place.
                if (pass == 1 && (first ? match.matchType(first.type) || (inject = match.fillBefore((0, $3xw6l.Fragment).from(first), false)) : parent && type.compatibleContent(parent.type))) return {
                    sliceDepth: sliceDepth,
                    frontierDepth: frontierDepth,
                    parent: parent,
                    inject: inject
                };
                else if (pass == 2 && first && (wrap = match.findWrapping(first.type))) return {
                    sliceDepth: sliceDepth,
                    frontierDepth: frontierDepth,
                    parent: parent,
                    wrap: wrap
                };
                // Don't continue looking further up if the parent node
                // would fit here.
                if (parent && match.matchType(parent.type)) break;
            }
        }
    }
    openMore() {
        let { content: content, openStart: openStart, openEnd: openEnd } = this.unplaced;
        let inner = $040d9edd1880ca83$var$contentAt(content, openStart);
        if (!inner.childCount || inner.firstChild.isLeaf) return false;
        this.unplaced = new (0, $3xw6l.Slice)(content, openStart + 1, Math.max(openEnd, inner.size + openStart >= content.size - openEnd ? openStart + 1 : 0));
        return true;
    }
    dropNode() {
        let { content: content, openStart: openStart, openEnd: openEnd } = this.unplaced;
        let inner = $040d9edd1880ca83$var$contentAt(content, openStart);
        if (inner.childCount <= 1 && openStart > 0) {
            let openAtEnd = content.size - openStart <= openStart + inner.size;
            this.unplaced = new (0, $3xw6l.Slice)($040d9edd1880ca83$var$dropFromFragment(content, openStart - 1, 1), openStart - 1, openAtEnd ? openStart - 1 : openEnd);
        } else this.unplaced = new (0, $3xw6l.Slice)($040d9edd1880ca83$var$dropFromFragment(content, openStart, 1), openStart, openEnd);
    }
    // Move content from the unplaced slice at `sliceDepth` to the
    // frontier node at `frontierDepth`. Close that frontier node when
    // applicable.
    placeNodes({ sliceDepth: sliceDepth, frontierDepth: frontierDepth, parent: parent, inject: inject, wrap: wrap }) {
        while(this.depth > frontierDepth)this.closeFrontierNode();
        if (wrap) for(let i = 0; i < wrap.length; i++)this.openFrontierNode(wrap[i]);
        let slice = this.unplaced, fragment = parent ? parent.content : slice.content;
        let openStart = slice.openStart - sliceDepth;
        let taken = 0, add = [];
        let { match: match, type: type } = this.frontier[frontierDepth];
        if (inject) {
            for(let i = 0; i < inject.childCount; i++)add.push(inject.child(i));
            match = match.matchFragment(inject);
        }
        // Computes the amount of (end) open nodes at the end of the
        // fragment. When 0, the parent is open, but no more. When
        // negative, nothing is open.
        let openEndCount = fragment.size + sliceDepth - (slice.content.size - slice.openEnd);
        // Scan over the fragment, fitting as many child nodes as
        // possible.
        while(taken < fragment.childCount){
            let next = fragment.child(taken), matches = match.matchType(next.type);
            if (!matches) break;
            taken++;
            if (taken > 1 || openStart == 0 || next.content.size) {
                match = matches;
                add.push($040d9edd1880ca83$var$closeNodeStart(next.mark(type.allowedMarks(next.marks)), taken == 1 ? openStart : 0, taken == fragment.childCount ? openEndCount : -1));
            }
        }
        let toEnd = taken == fragment.childCount;
        if (!toEnd) openEndCount = -1;
        this.placed = $040d9edd1880ca83$var$addToFragment(this.placed, frontierDepth, (0, $3xw6l.Fragment).from(add));
        this.frontier[frontierDepth].match = match;
        // If the parent types match, and the entire node was moved, and
        // it's not open, close this frontier node right away.
        if (toEnd && openEndCount < 0 && parent && parent.type == this.frontier[this.depth].type && this.frontier.length > 1) this.closeFrontierNode();
        // Add new frontier nodes for any open nodes at the end.
        for(let i = 0, cur = fragment; i < openEndCount; i++){
            let node = cur.lastChild;
            this.frontier.push({
                type: node.type,
                match: node.contentMatchAt(node.childCount)
            });
            cur = node.content;
        }
        // Update `this.unplaced`. Drop the entire node from which we
        // placed it we got to its end, otherwise just drop the placed
        // nodes.
        this.unplaced = !toEnd ? new (0, $3xw6l.Slice)($040d9edd1880ca83$var$dropFromFragment(slice.content, sliceDepth, taken), slice.openStart, slice.openEnd) : sliceDepth == 0 ? (0, $3xw6l.Slice).empty : new (0, $3xw6l.Slice)($040d9edd1880ca83$var$dropFromFragment(slice.content, sliceDepth - 1, 1), sliceDepth - 1, openEndCount < 0 ? slice.openEnd : sliceDepth - 1);
    }
    mustMoveInline() {
        if (!this.$to.parent.isTextblock) return -1;
        let top = this.frontier[this.depth], level;
        if (!top.type.isTextblock || !$040d9edd1880ca83$var$contentAfterFits(this.$to, this.$to.depth, top.type, top.match, false) || this.$to.depth == this.depth && (level = this.findCloseLevel(this.$to)) && level.depth == this.depth) return -1;
        let { depth: depth } = this.$to, after = this.$to.after(depth);
        while(depth > 1 && after == this.$to.end(--depth))++after;
        return after;
    }
    findCloseLevel($to) {
        scan: for(let i = Math.min(this.depth, $to.depth); i >= 0; i--){
            let { match: match, type: type } = this.frontier[i];
            let dropInner = i < $to.depth && $to.end(i + 1) == $to.pos + ($to.depth - (i + 1));
            let fit = $040d9edd1880ca83$var$contentAfterFits($to, i, type, match, dropInner);
            if (!fit) continue;
            for(let d = i - 1; d >= 0; d--){
                let { match: match, type: type } = this.frontier[d];
                let matches = $040d9edd1880ca83$var$contentAfterFits($to, d, type, match, true);
                if (!matches || matches.childCount) continue scan;
            }
            return {
                depth: i,
                fit: fit,
                move: dropInner ? $to.doc.resolve($to.after(i + 1)) : $to
            };
        }
    }
    close($to) {
        let close = this.findCloseLevel($to);
        if (!close) return null;
        while(this.depth > close.depth)this.closeFrontierNode();
        if (close.fit.childCount) this.placed = $040d9edd1880ca83$var$addToFragment(this.placed, close.depth, close.fit);
        $to = close.move;
        for(let d = close.depth + 1; d <= $to.depth; d++){
            let node = $to.node(d), add = node.type.contentMatch.fillBefore(node.content, true, $to.index(d));
            this.openFrontierNode(node.type, node.attrs, add);
        }
        return $to;
    }
    openFrontierNode(type, attrs = null, content) {
        let top = this.frontier[this.depth];
        top.match = top.match.matchType(type);
        this.placed = $040d9edd1880ca83$var$addToFragment(this.placed, this.depth, (0, $3xw6l.Fragment).from(type.create(attrs, content)));
        this.frontier.push({
            type: type,
            match: type.contentMatch
        });
    }
    closeFrontierNode() {
        let open = this.frontier.pop();
        let add = open.match.fillBefore((0, $3xw6l.Fragment).empty, true);
        if (add.childCount) this.placed = $040d9edd1880ca83$var$addToFragment(this.placed, this.frontier.length, add);
    }
}
function $040d9edd1880ca83$var$dropFromFragment(fragment, depth, count) {
    if (depth == 0) return fragment.cutByIndex(count, fragment.childCount);
    return fragment.replaceChild(0, fragment.firstChild.copy($040d9edd1880ca83$var$dropFromFragment(fragment.firstChild.content, depth - 1, count)));
}
function $040d9edd1880ca83$var$addToFragment(fragment, depth, content) {
    if (depth == 0) return fragment.append(content);
    return fragment.replaceChild(fragment.childCount - 1, fragment.lastChild.copy($040d9edd1880ca83$var$addToFragment(fragment.lastChild.content, depth - 1, content)));
}
function $040d9edd1880ca83$var$contentAt(fragment, depth) {
    for(let i = 0; i < depth; i++)fragment = fragment.firstChild.content;
    return fragment;
}
function $040d9edd1880ca83$var$closeNodeStart(node, openStart, openEnd) {
    if (openStart <= 0) return node;
    let frag = node.content;
    if (openStart > 1) frag = frag.replaceChild(0, $040d9edd1880ca83$var$closeNodeStart(frag.firstChild, openStart - 1, frag.childCount == 1 ? openEnd - 1 : 0));
    if (openStart > 0) {
        frag = node.type.contentMatch.fillBefore(frag).append(frag);
        if (openEnd <= 0) frag = frag.append(node.type.contentMatch.matchFragment(frag).fillBefore((0, $3xw6l.Fragment).empty, true));
    }
    return node.copy(frag);
}
function $040d9edd1880ca83$var$contentAfterFits($to, depth, type, match, open) {
    let node = $to.node(depth), index = open ? $to.indexAfter(depth) : $to.index(depth);
    if (index == node.childCount && !type.compatibleContent(node.type)) return null;
    let fit = match.fillBefore(node.content, true, index);
    return fit && !$040d9edd1880ca83$var$invalidMarks(type, node.content, index) ? fit : null;
}
function $040d9edd1880ca83$var$invalidMarks(type, fragment, start) {
    for(let i = start; i < fragment.childCount; i++)if (!type.allowsMarks(fragment.child(i).marks)) return true;
    return false;
}
function $040d9edd1880ca83$var$definesContent(type) {
    return type.spec.defining || type.spec.definingForContent;
}
function $040d9edd1880ca83$var$replaceRange(tr, from, to, slice) {
    if (!slice.size) return tr.deleteRange(from, to);
    let $from = tr.doc.resolve(from), $to = tr.doc.resolve(to);
    if ($040d9edd1880ca83$var$fitsTrivially($from, $to, slice)) return tr.step(new $040d9edd1880ca83$export$5c860b2e74034756(from, to, slice));
    let targetDepths = $040d9edd1880ca83$var$coveredDepths($from, tr.doc.resolve(to));
    // Can't replace the whole document, so remove 0 if it's present
    if (targetDepths[targetDepths.length - 1] == 0) targetDepths.pop();
    // Negative numbers represent not expansion over the whole node at
    // that depth, but replacing from $from.before(-D) to $to.pos.
    let preferredTarget = -($from.depth + 1);
    targetDepths.unshift(preferredTarget);
    // This loop picks a preferred target depth, if one of the covering
    // depths is not outside of a defining node, and adds negative
    // depths for any depth that has $from at its start and does not
    // cross a defining node.
    for(let d = $from.depth, pos = $from.pos - 1; d > 0; d--, pos--){
        let spec = $from.node(d).type.spec;
        if (spec.defining || spec.definingAsContext || spec.isolating) break;
        if (targetDepths.indexOf(d) > -1) preferredTarget = d;
        else if ($from.before(d) == pos) targetDepths.splice(1, 0, -d);
    }
    // Try to fit each possible depth of the slice into each possible
    // target depth, starting with the preferred depths.
    let preferredTargetIndex = targetDepths.indexOf(preferredTarget);
    let leftNodes = [], preferredDepth = slice.openStart;
    for(let content = slice.content, i = 0;; i++){
        let node = content.firstChild;
        leftNodes.push(node);
        if (i == slice.openStart) break;
        content = node.content;
    }
    // Back up preferredDepth to cover defining textblocks directly
    // above it, possibly skipping a non-defining textblock.
    for(let d = preferredDepth - 1; d >= 0; d--){
        let leftNode = leftNodes[d], def = $040d9edd1880ca83$var$definesContent(leftNode.type);
        if (def && !leftNode.sameMarkup($from.node(Math.abs(preferredTarget) - 1))) preferredDepth = d;
        else if (def || !leftNode.type.isTextblock) break;
    }
    for(let j = slice.openStart; j >= 0; j--){
        let openDepth = (j + preferredDepth + 1) % (slice.openStart + 1);
        let insert = leftNodes[openDepth];
        if (!insert) continue;
        for(let i = 0; i < targetDepths.length; i++){
            // Loop over possible expansion levels, starting with the
            // preferred one
            let targetDepth = targetDepths[(i + preferredTargetIndex) % targetDepths.length], expand = true;
            if (targetDepth < 0) {
                expand = false;
                targetDepth = -targetDepth;
            }
            let parent = $from.node(targetDepth - 1), index = $from.index(targetDepth - 1);
            if (parent.canReplaceWith(index, index, insert.type, insert.marks)) return tr.replace($from.before(targetDepth), expand ? $to.after(targetDepth) : to, new (0, $3xw6l.Slice)($040d9edd1880ca83$var$closeFragment(slice.content, 0, slice.openStart, openDepth), openDepth, slice.openEnd));
        }
    }
    let startSteps = tr.steps.length;
    for(let i = targetDepths.length - 1; i >= 0; i--){
        tr.replace(from, to, slice);
        if (tr.steps.length > startSteps) break;
        let depth = targetDepths[i];
        if (depth < 0) continue;
        from = $from.before(depth);
        to = $to.after(depth);
    }
}
function $040d9edd1880ca83$var$closeFragment(fragment, depth, oldOpen, newOpen, parent) {
    if (depth < oldOpen) {
        let first = fragment.firstChild;
        fragment = fragment.replaceChild(0, first.copy($040d9edd1880ca83$var$closeFragment(first.content, depth + 1, oldOpen, newOpen, first)));
    }
    if (depth > newOpen) {
        let match = parent.contentMatchAt(0);
        let start = match.fillBefore(fragment).append(fragment);
        fragment = start.append(match.matchFragment(start).fillBefore((0, $3xw6l.Fragment).empty, true));
    }
    return fragment;
}
function $040d9edd1880ca83$var$replaceRangeWith(tr, from, to, node) {
    if (!node.isInline && from == to && tr.doc.resolve(from).parent.content.size) {
        let point = $040d9edd1880ca83$export$64cb316d02de1dd1(tr.doc, from, node.type);
        if (point != null) from = to = point;
    }
    tr.replaceRange(from, to, new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).from(node), 0, 0));
}
function $040d9edd1880ca83$var$deleteRange(tr, from, to) {
    let $from = tr.doc.resolve(from), $to = tr.doc.resolve(to);
    let covered = $040d9edd1880ca83$var$coveredDepths($from, $to);
    for(let i = 0; i < covered.length; i++){
        let depth = covered[i], last = i == covered.length - 1;
        if (last && depth == 0 || $from.node(depth).type.contentMatch.validEnd) return tr.delete($from.start(depth), $to.end(depth));
        if (depth > 0 && (last || $from.node(depth - 1).canReplace($from.index(depth - 1), $to.indexAfter(depth - 1)))) return tr.delete($from.before(depth), $to.after(depth));
    }
    for(let d = 1; d <= $from.depth && d <= $to.depth; d++){
        if (from - $from.start(d) == $from.depth - d && to > $from.end(d) && $to.end(d) - to != $to.depth - d && $from.start(d - 1) == $to.start(d - 1) && $from.node(d - 1).canReplace($from.index(d - 1), $to.index(d - 1))) return tr.delete($from.before(d), to);
    }
    tr.delete(from, to);
}
// Returns an array of all depths for which $from - $to spans the
// whole content of the nodes at that depth.
function $040d9edd1880ca83$var$coveredDepths($from, $to) {
    let result = [], minDepth = Math.min($from.depth, $to.depth);
    for(let d = minDepth; d >= 0; d--){
        let start = $from.start(d);
        if (start < $from.pos - ($from.depth - d) || $to.end(d) > $to.pos + ($to.depth - d) || $from.node(d).type.spec.isolating || $to.node(d).type.spec.isolating) break;
        if (start == $to.start(d) || d == $from.depth && d == $to.depth && $from.parent.inlineContent && $to.parent.inlineContent && d && $to.start(d - 1) == start - 1) result.push(d);
    }
    return result;
}
/**
Update an attribute in a specific node.
*/ class $040d9edd1880ca83$export$626399c38172f669 extends $040d9edd1880ca83$export$fd55ce593607084a {
    /**
    Construct an attribute step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The attribute to set.
    */ attr, // The attribute's new value.
    value){
        super();
        this.pos = pos;
        this.attr = attr;
        this.value = value;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $040d9edd1880ca83$export$8ebf1578a4199c09.fail("No node at attribute step's position");
        let attrs = Object.create(null);
        for(let name in node.attrs)attrs[name] = node.attrs[name];
        attrs[this.attr] = this.value;
        let updated = node.type.create(attrs, null, node.marks);
        return $040d9edd1880ca83$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    getMap() {
        return $040d9edd1880ca83$export$c53d01c3ab9721b3.empty;
    }
    invert(doc) {
        return new $040d9edd1880ca83$export$626399c38172f669(this.pos, this.attr, doc.nodeAt(this.pos).attrs[this.attr]);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $040d9edd1880ca83$export$626399c38172f669(pos.pos, this.attr, this.value);
    }
    toJSON() {
        return {
            stepType: "attr",
            pos: this.pos,
            attr: this.attr,
            value: this.value
        };
    }
    static fromJSON(schema, json) {
        if (typeof json.pos != "number" || typeof json.attr != "string") throw new RangeError("Invalid input for AttrStep.fromJSON");
        return new $040d9edd1880ca83$export$626399c38172f669(json.pos, json.attr, json.value);
    }
}
$040d9edd1880ca83$export$fd55ce593607084a.jsonID("attr", $040d9edd1880ca83$export$626399c38172f669);
/**
Update an attribute in the doc node.
*/ class $040d9edd1880ca83$export$f50707b396300ac9 extends $040d9edd1880ca83$export$fd55ce593607084a {
    /**
    Construct an attribute step.
    */ constructor(/**
    The attribute to set.
    */ attr, // The attribute's new value.
    value){
        super();
        this.attr = attr;
        this.value = value;
    }
    apply(doc) {
        let attrs = Object.create(null);
        for(let name in doc.attrs)attrs[name] = doc.attrs[name];
        attrs[this.attr] = this.value;
        let updated = doc.type.create(attrs, doc.content, doc.marks);
        return $040d9edd1880ca83$export$8ebf1578a4199c09.ok(updated);
    }
    getMap() {
        return $040d9edd1880ca83$export$c53d01c3ab9721b3.empty;
    }
    invert(doc) {
        return new $040d9edd1880ca83$export$f50707b396300ac9(this.attr, doc.attrs[this.attr]);
    }
    map(mapping) {
        return this;
    }
    toJSON() {
        return {
            stepType: "docAttr",
            attr: this.attr,
            value: this.value
        };
    }
    static fromJSON(schema, json) {
        if (typeof json.attr != "string") throw new RangeError("Invalid input for DocAttrStep.fromJSON");
        return new $040d9edd1880ca83$export$f50707b396300ac9(json.attr, json.value);
    }
}
$040d9edd1880ca83$export$fd55ce593607084a.jsonID("docAttr", $040d9edd1880ca83$export$f50707b396300ac9);
/**
@internal
*/ let $040d9edd1880ca83$export$88cc3a1dfce48dd3 = class extends Error {
};
$040d9edd1880ca83$export$88cc3a1dfce48dd3 = function TransformError(message) {
    let err = Error.call(this, message);
    err.__proto__ = TransformError.prototype;
    return err;
};
$040d9edd1880ca83$export$88cc3a1dfce48dd3.prototype = Object.create(Error.prototype);
$040d9edd1880ca83$export$88cc3a1dfce48dd3.prototype.constructor = $040d9edd1880ca83$export$88cc3a1dfce48dd3;
$040d9edd1880ca83$export$88cc3a1dfce48dd3.prototype.name = "TransformError";
/**
Abstraction to build up and track an array of
[steps](https://prosemirror.net/docs/ref/#transform.Step) representing a document transformation.

Most transforming methods return the `Transform` object itself, so
that they can be chained.
*/ class $040d9edd1880ca83$export$563a914cafbdc389 {
    /**
    Create a transform that starts with the given document.
    */ constructor(/**
    The current document (the result of applying the steps in the
    transform).
    */ doc){
        this.doc = doc;
        /**
        The steps in this transform.
        */ this.steps = [];
        /**
        The documents before each of the steps.
        */ this.docs = [];
        /**
        A mapping with the maps for each of the steps in this transform.
        */ this.mapping = new $040d9edd1880ca83$export$f5f785078011b62;
    }
    /**
    The starting document.
    */ get before() {
        return this.docs.length ? this.docs[0] : this.doc;
    }
    /**
    Apply a new step in this transform, saving the result. Throws an
    error when the step fails.
    */ step(step) {
        let result = this.maybeStep(step);
        if (result.failed) throw new $040d9edd1880ca83$export$88cc3a1dfce48dd3(result.failed);
        return this;
    }
    /**
    Try to apply a step in this transformation, ignoring it if it
    fails. Returns the step result.
    */ maybeStep(step) {
        let result = step.apply(this.doc);
        if (!result.failed) this.addStep(step, result.doc);
        return result;
    }
    /**
    True when the document has been changed (when there are any
    steps).
    */ get docChanged() {
        return this.steps.length > 0;
    }
    /**
    @internal
    */ addStep(step, doc) {
        this.docs.push(this.doc);
        this.steps.push(step);
        this.mapping.appendMap(step.getMap());
        this.doc = doc;
    }
    /**
    Replace the part of the document between `from` and `to` with the
    given `slice`.
    */ replace(from, to = from, slice = (0, $3xw6l.Slice).empty) {
        let step = $040d9edd1880ca83$export$ed6ac67359824afd(this.doc, from, to, slice);
        if (step) this.step(step);
        return this;
    }
    /**
    Replace the given range with the given content, which may be a
    fragment, node, or array of nodes.
    */ replaceWith(from, to, content) {
        return this.replace(from, to, new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).from(content), 0, 0));
    }
    /**
    Delete the content between the given positions.
    */ delete(from, to) {
        return this.replace(from, to, (0, $3xw6l.Slice).empty);
    }
    /**
    Insert the given content at the given position.
    */ insert(pos, content) {
        return this.replaceWith(pos, pos, content);
    }
    /**
    Replace a range of the document with a given slice, using
    `from`, `to`, and the slice's
    [`openStart`](https://prosemirror.net/docs/ref/#model.Slice.openStart) property as hints, rather
    than fixed start and end points. This method may grow the
    replaced area or close open nodes in the slice in order to get a
    fit that is more in line with WYSIWYG expectations, by dropping
    fully covered parent nodes of the replaced region when they are
    marked [non-defining as
    context](https://prosemirror.net/docs/ref/#model.NodeSpec.definingAsContext), or including an
    open parent node from the slice that _is_ marked as [defining
    its content](https://prosemirror.net/docs/ref/#model.NodeSpec.definingForContent).
    
    This is the method, for example, to handle paste. The similar
    [`replace`](https://prosemirror.net/docs/ref/#transform.Transform.replace) method is a more
    primitive tool which will _not_ move the start and end of its given
    range, and is useful in situations where you need more precise
    control over what happens.
    */ replaceRange(from, to, slice) {
        $040d9edd1880ca83$var$replaceRange(this, from, to, slice);
        return this;
    }
    /**
    Replace the given range with a node, but use `from` and `to` as
    hints, rather than precise positions. When from and to are the same
    and are at the start or end of a parent node in which the given
    node doesn't fit, this method may _move_ them out towards a parent
    that does allow the given node to be placed. When the given range
    completely covers a parent node, this method may completely replace
    that parent node.
    */ replaceRangeWith(from, to, node) {
        $040d9edd1880ca83$var$replaceRangeWith(this, from, to, node);
        return this;
    }
    /**
    Delete the given range, expanding it to cover fully covered
    parent nodes until a valid replace is found.
    */ deleteRange(from, to) {
        $040d9edd1880ca83$var$deleteRange(this, from, to);
        return this;
    }
    /**
    Split the content in the given range off from its parent, if there
    is sibling content before or after it, and move it up the tree to
    the depth specified by `target`. You'll probably want to use
    [`liftTarget`](https://prosemirror.net/docs/ref/#transform.liftTarget) to compute `target`, to make
    sure the lift is valid.
    */ lift(range, target) {
        $040d9edd1880ca83$var$lift(this, range, target);
        return this;
    }
    /**
    Join the blocks around the given position. If depth is 2, their
    last and first siblings are also joined, and so on.
    */ join(pos, depth = 1) {
        $040d9edd1880ca83$var$join(this, pos, depth);
        return this;
    }
    /**
    Wrap the given [range](https://prosemirror.net/docs/ref/#model.NodeRange) in the given set of wrappers.
    The wrappers are assumed to be valid in this position, and should
    probably be computed with [`findWrapping`](https://prosemirror.net/docs/ref/#transform.findWrapping).
    */ wrap(range, wrappers) {
        $040d9edd1880ca83$var$wrap(this, range, wrappers);
        return this;
    }
    /**
    Set the type of all textblocks (partly) between `from` and `to` to
    the given node type with the given attributes.
    */ setBlockType(from, to = from, type, attrs = null) {
        $040d9edd1880ca83$var$setBlockType(this, from, to, type, attrs);
        return this;
    }
    /**
    Change the type, attributes, and/or marks of the node at `pos`.
    When `type` isn't given, the existing node type is preserved,
    */ setNodeMarkup(pos, type, attrs = null, marks) {
        $040d9edd1880ca83$var$setNodeMarkup(this, pos, type, attrs, marks);
        return this;
    }
    /**
    Set a single attribute on a given node to a new value.
    The `pos` addresses the document content. Use `setDocAttribute`
    to set attributes on the document itself.
    */ setNodeAttribute(pos, attr, value) {
        this.step(new $040d9edd1880ca83$export$626399c38172f669(pos, attr, value));
        return this;
    }
    /**
    Set a single attribute on the document to a new value.
    */ setDocAttribute(attr, value) {
        this.step(new $040d9edd1880ca83$export$f50707b396300ac9(attr, value));
        return this;
    }
    /**
    Add a mark to the node at position `pos`.
    */ addNodeMark(pos, mark) {
        this.step(new $040d9edd1880ca83$export$adefd16c402fee4e(pos, mark));
        return this;
    }
    /**
    Remove a mark (or a mark of the given type) from the node at
    position `pos`.
    */ removeNodeMark(pos, mark) {
        if (!(mark instanceof (0, $3xw6l.Mark))) {
            let node = this.doc.nodeAt(pos);
            if (!node) throw new RangeError("No node at position " + pos);
            mark = mark.isInSet(node.marks);
            if (!mark) return this;
        }
        this.step(new $040d9edd1880ca83$export$fdf7d1dc10724da2(pos, mark));
        return this;
    }
    /**
    Split the node at the given position, and optionally, if `depth` is
    greater than one, any number of nodes above that. By default, the
    parts split off will inherit the node type of the original node.
    This can be changed by passing an array of types and attributes to
    use after the split.
    */ split(pos, depth = 1, typesAfter) {
        $040d9edd1880ca83$var$split(this, pos, depth, typesAfter);
        return this;
    }
    /**
    Add the given mark to the inline content between `from` and `to`.
    */ addMark(from, to, mark) {
        $040d9edd1880ca83$var$addMark(this, from, to, mark);
        return this;
    }
    /**
    Remove marks from inline nodes between `from` and `to`. When
    `mark` is a single mark, remove precisely that mark. When it is
    a mark type, remove all marks of that type. When it is null,
    remove all marks of any type.
    */ removeMark(from, to, mark) {
        $040d9edd1880ca83$var$removeMark(this, from, to, mark);
        return this;
    }
    /**
    Removes all marks and nodes from the content of the node at
    `pos` that don't match the given new parent node type. Accepts
    an optional starting [content match](https://prosemirror.net/docs/ref/#model.ContentMatch) as
    third argument.
    */ clearIncompatible(pos, parentType, match) {
        $040d9edd1880ca83$var$clearIncompatible(this, pos, parentType, match);
        return this;
    }
}

});


parcelRegister("BmspC", function(module, exports) {

$parcel$export(module.exports, "removeParentNodeOfType", () => $0704e05c57d80c1d$export$5dd18664fe8bcbde);
$parcel$export(module.exports, "findParentNodeOfType", () => $0704e05c57d80c1d$export$1a3a74094b9968e);
$parcel$export(module.exports, "replaceParentNodeOfType", () => $0704e05c57d80c1d$export$b72cc612b642c071);
$parcel$export(module.exports, "removeSelectedNode", () => $0704e05c57d80c1d$export$7d6e4e6663186878);
$parcel$export(module.exports, "isNodeSelection", () => $0704e05c57d80c1d$export$a8c1d2c13abf8822);
$parcel$export(module.exports, "replaceSelectedNode", () => $0704e05c57d80c1d$export$39874bca494f9ba3);
$parcel$export(module.exports, "setTextSelection", () => $0704e05c57d80c1d$export$1df6d14df6b0b758);
$parcel$export(module.exports, "safeInsert", () => $0704e05c57d80c1d$export$5fe92db78385e37c);
$parcel$export(module.exports, "canInsert", () => $0704e05c57d80c1d$export$b4d1262a40ad21d4);
$parcel$export(module.exports, "removeNodeBefore", () => $0704e05c57d80c1d$export$ffb1550ab6c3d03c);
$parcel$export(module.exports, "findPositionOfNodeBefore", () => $0704e05c57d80c1d$export$f8088819b1e2c2dc);
$parcel$export(module.exports, "findParentNode", () => $0704e05c57d80c1d$export$dc159056ffdb4c76);
$parcel$export(module.exports, "findParentNodeClosestToPos", () => $0704e05c57d80c1d$export$fe09644e3bc6166b);
$parcel$export(module.exports, "findDomRefAtPos", () => $0704e05c57d80c1d$export$666ce65defe9ad6e);
$parcel$export(module.exports, "hasParentNode", () => $0704e05c57d80c1d$export$178ecaf80f45fdb6);
$parcel$export(module.exports, "findParentNodeOfTypeClosestToPos", () => $0704e05c57d80c1d$export$8bf0d019bde85d18);
$parcel$export(module.exports, "hasParentNodeOfType", () => $0704e05c57d80c1d$export$14f438bb7227ce63);
$parcel$export(module.exports, "findParentDomRefOfType", () => $0704e05c57d80c1d$export$faeafc1151740116);
$parcel$export(module.exports, "findSelectedNodeOfType", () => $0704e05c57d80c1d$export$924aa2dd4d9a67fa);
$parcel$export(module.exports, "flatten", () => $0704e05c57d80c1d$export$bffa455ba8c619a6);
$parcel$export(module.exports, "findChildren", () => $0704e05c57d80c1d$export$f94ca194e830789c);
$parcel$export(module.exports, "findChildrenByType", () => $0704e05c57d80c1d$export$96bb9476c7c69f39);
$parcel$export(module.exports, "contains", () => $0704e05c57d80c1d$export$2344b14b097df817);
// src/selection.ts

var $3lIcL = parcelRequire("3lIcL");

var $3xw6l = parcelRequire("3xw6l");
var $0704e05c57d80c1d$export$5dd18664fe8bcbde = (nodeType)=>(tr)=>{
        const parent = $0704e05c57d80c1d$export$1a3a74094b9968e(nodeType)(tr.selection);
        if (parent) return $0704e05c57d80c1d$var$removeNodeAtPos(parent.pos)(tr);
        return tr;
    };
var $0704e05c57d80c1d$export$b72cc612b642c071 = (nodeType, content)=>(tr)=>{
        if (!Array.isArray(nodeType)) nodeType = [
            nodeType
        ];
        for(let i = 0, count = nodeType.length; i < count; i++){
            const parent = $0704e05c57d80c1d$export$1a3a74094b9968e(nodeType[i])(tr.selection);
            if (parent) {
                const newTr = $0704e05c57d80c1d$var$replaceNodeAtPos(parent.pos, content)(tr);
                if (newTr !== tr) return newTr;
            }
        }
        return tr;
    };
var $0704e05c57d80c1d$export$7d6e4e6663186878 = (tr)=>{
    if ($0704e05c57d80c1d$export$a8c1d2c13abf8822(tr.selection)) {
        const from = tr.selection.$from.pos;
        const to = tr.selection.$to.pos;
        return $0704e05c57d80c1d$var$cloneTr(tr.delete(from, to));
    }
    return tr;
};
var $0704e05c57d80c1d$export$39874bca494f9ba3 = (content)=>(tr)=>{
        if ($0704e05c57d80c1d$export$a8c1d2c13abf8822(tr.selection)) {
            const { $from: $from, $to: $to } = tr.selection;
            if (content instanceof (0, $3xw6l.Fragment) && $from.parent.canReplace($from.index(), $from.indexAfter(), content) || content instanceof (0, $3xw6l.Node) && $from.parent.canReplaceWith($from.index(), $from.indexAfter(), content.type)) return $0704e05c57d80c1d$var$cloneTr(tr.replaceWith($from.pos, $to.pos, content).setSelection(new (0, $3lIcL.NodeSelection)(tr.doc.resolve($from.pos))));
        }
        return tr;
    };
var $0704e05c57d80c1d$export$1df6d14df6b0b758 = (position, dir = 1)=>(tr)=>{
        const nextSelection = (0, $3lIcL.Selection).findFrom(tr.doc.resolve(position), dir, true);
        if (nextSelection) return tr.setSelection(nextSelection);
        return tr;
    };
var $0704e05c57d80c1d$var$isSelectableNode = (node)=>Boolean(node instanceof (0, $3xw6l.Node) && node.type && node.type.spec.selectable);
var $0704e05c57d80c1d$var$shouldSelectNode = (node)=>$0704e05c57d80c1d$var$isSelectableNode(node) && node.type.isLeaf;
var $0704e05c57d80c1d$var$setSelection = (node, pos, tr)=>{
    if ($0704e05c57d80c1d$var$shouldSelectNode(node)) return tr.setSelection(new (0, $3lIcL.NodeSelection)(tr.doc.resolve(pos)));
    return $0704e05c57d80c1d$export$1df6d14df6b0b758(pos)(tr);
};
var $0704e05c57d80c1d$export$5fe92db78385e37c = (content, position, tryToReplace)=>(tr)=>{
        const hasPosition = typeof position === "number";
        const { $from: $from } = tr.selection;
        const $insertPos = hasPosition ? tr.doc.resolve(position) : $0704e05c57d80c1d$export$a8c1d2c13abf8822(tr.selection) ? tr.doc.resolve($from.pos + 1) : $from;
        const { parent: parent } = $insertPos;
        if ($0704e05c57d80c1d$export$a8c1d2c13abf8822(tr.selection) && tryToReplace) {
            const oldTr = tr;
            tr = $0704e05c57d80c1d$export$39874bca494f9ba3(content)(tr);
            if (oldTr !== tr) return tr;
        }
        if ($0704e05c57d80c1d$var$isEmptyParagraph(parent)) {
            const oldTr = tr;
            tr = $0704e05c57d80c1d$export$b72cc612b642c071(parent.type, content)(tr);
            if (oldTr !== tr) {
                const pos = $0704e05c57d80c1d$var$isSelectableNode(content) ? // for selectable node, selection position would be the position of the replaced parent
                $insertPos.before($insertPos.depth) : $insertPos.pos;
                return $0704e05c57d80c1d$var$setSelection(content, pos, tr);
            }
        }
        if ($0704e05c57d80c1d$export$b4d1262a40ad21d4($insertPos, content)) {
            tr.insert($insertPos.pos, content);
            const pos = hasPosition ? $insertPos.pos : $0704e05c57d80c1d$var$isSelectableNode(content) ? // for atom nodes selection position after insertion is the previous pos
            tr.selection.$anchor.pos - 1 : tr.selection.$anchor.pos;
            return $0704e05c57d80c1d$var$cloneTr($0704e05c57d80c1d$var$setSelection(content, pos, tr));
        }
        for(let i = $insertPos.depth; i > 0; i--){
            const pos = $insertPos.after(i);
            const $pos = tr.doc.resolve(pos);
            if ($0704e05c57d80c1d$export$b4d1262a40ad21d4($pos, content)) {
                tr.insert(pos, content);
                return $0704e05c57d80c1d$var$cloneTr($0704e05c57d80c1d$var$setSelection(content, pos, tr));
            }
        }
        return tr;
    };
var $0704e05c57d80c1d$export$36491a9ea218d882 = (nodeType, type, attrs, marks)=>(tr)=>{
        const parent = $0704e05c57d80c1d$export$1a3a74094b9968e(nodeType)(tr.selection);
        if (parent) return $0704e05c57d80c1d$var$cloneTr(tr.setNodeMarkup(parent.pos, type, Object.assign({}, parent.node.attrs, attrs), marks));
        return tr;
    };
var $0704e05c57d80c1d$export$7f11cc48adfe3aed = (nodeType)=>(tr)=>{
        if (!$0704e05c57d80c1d$export$a8c1d2c13abf8822(tr.selection)) {
            const parent = $0704e05c57d80c1d$export$1a3a74094b9968e(nodeType)(tr.selection);
            if (parent) return $0704e05c57d80c1d$var$cloneTr(tr.setSelection((0, $3lIcL.NodeSelection).create(tr.doc, parent.pos)));
        }
        return tr;
    };
var $0704e05c57d80c1d$export$ffb1550ab6c3d03c = (tr)=>{
    const position = $0704e05c57d80c1d$export$f8088819b1e2c2dc(tr.selection);
    if (typeof position === "number") return $0704e05c57d80c1d$var$removeNodeAtPos(position)(tr);
    return tr;
};
// src/helpers.ts
var $0704e05c57d80c1d$export$a8c1d2c13abf8822 = (selection)=>{
    return selection instanceof (0, $3lIcL.NodeSelection);
};
var $0704e05c57d80c1d$var$equalNodeType = (nodeType, node)=>{
    return Array.isArray(nodeType) && nodeType.indexOf(node.type) > -1 || node.type === nodeType;
};
var $0704e05c57d80c1d$var$cloneTr = (tr)=>{
    return Object.assign(Object.create(tr), tr).setTime(Date.now());
};
var $0704e05c57d80c1d$var$replaceNodeAtPos = (position, content)=>(tr)=>{
        const node = tr.doc.nodeAt(position);
        const $pos = tr.doc.resolve(position);
        if (!node) return tr;
        if ($0704e05c57d80c1d$var$canReplace($pos, content)) {
            tr = tr.replaceWith(position, position + node.nodeSize, content);
            const start = tr.selection.$from.pos - 1;
            tr = $0704e05c57d80c1d$export$1df6d14df6b0b758(Math.max(start, 0), -1)(tr);
            tr = $0704e05c57d80c1d$export$1df6d14df6b0b758(tr.selection.$from.start())(tr);
            return $0704e05c57d80c1d$var$cloneTr(tr);
        }
        return tr;
    };
var $0704e05c57d80c1d$var$canReplace = ($pos, content)=>{
    const node = $pos.node($pos.depth);
    return node && node.type.validContent(content instanceof (0, $3xw6l.Fragment) ? content : (0, $3xw6l.Fragment).from(content));
};
var $0704e05c57d80c1d$var$removeNodeAtPos = (position)=>(tr)=>{
        const node = tr.doc.nodeAt(position);
        if (!node) return tr;
        return $0704e05c57d80c1d$var$cloneTr(tr.delete(position, position + node.nodeSize));
    };
var $0704e05c57d80c1d$export$b4d1262a40ad21d4 = ($pos, content)=>{
    const index = $pos.index();
    if (content instanceof (0, $3xw6l.Fragment)) return $pos.parent.canReplace(index, index, content);
    else if (content instanceof (0, $3xw6l.Node)) return $pos.parent.canReplaceWith(index, index, content.type);
    return false;
};
var $0704e05c57d80c1d$var$isEmptyParagraph = (node)=>{
    return !node || node.type.name === "paragraph" && node.nodeSize === 2;
};
// src/selection.ts
var $0704e05c57d80c1d$export$dc159056ffdb4c76 = (predicate)=>({ $from: $from, $to: $to }, validateSameParent = false)=>{
        if (validateSameParent && !$from.sameParent($to)) {
            let depth = Math.min($from.depth, $to.depth);
            while(depth >= 0){
                const fromNode = $from.node(depth);
                const toNode = $to.node(depth);
                if (toNode === fromNode) {
                    if (predicate(fromNode)) return {
                        // Return the resolved pos
                        pos: depth > 0 ? $from.before(depth) : 0,
                        start: $from.start(depth),
                        depth: depth,
                        node: fromNode
                    };
                }
                depth = depth - 1;
            }
            return;
        }
        return $0704e05c57d80c1d$export$fe09644e3bc6166b($from, predicate);
    };
var $0704e05c57d80c1d$export$fe09644e3bc6166b = ($pos, predicate)=>{
    for(let i = $pos.depth; i > 0; i--){
        const node = $pos.node(i);
        if (predicate(node)) return {
            pos: i > 0 ? $pos.before(i) : 0,
            start: $pos.start(i),
            depth: i,
            node: node
        };
    }
};
var $0704e05c57d80c1d$export$8556d79fa8189214 = (predicate, domAtPos)=>(selection)=>{
        const parent = $0704e05c57d80c1d$export$dc159056ffdb4c76(predicate)(selection);
        if (parent) return $0704e05c57d80c1d$export$666ce65defe9ad6e(parent.pos, domAtPos);
    };
var $0704e05c57d80c1d$export$178ecaf80f45fdb6 = (predicate)=>(selection)=>{
        return !!$0704e05c57d80c1d$export$dc159056ffdb4c76(predicate)(selection);
    };
var $0704e05c57d80c1d$export$1a3a74094b9968e = (nodeType)=>(selection)=>{
        return $0704e05c57d80c1d$export$dc159056ffdb4c76((node)=>$0704e05c57d80c1d$var$equalNodeType(nodeType, node))(selection);
    };
var $0704e05c57d80c1d$export$8bf0d019bde85d18 = ($pos, nodeType)=>{
    return $0704e05c57d80c1d$export$fe09644e3bc6166b($pos, (node)=>$0704e05c57d80c1d$var$equalNodeType(nodeType, node));
};
var $0704e05c57d80c1d$export$14f438bb7227ce63 = (nodeType)=>(selection)=>{
        return $0704e05c57d80c1d$export$178ecaf80f45fdb6((node)=>$0704e05c57d80c1d$var$equalNodeType(nodeType, node))(selection);
    };
var $0704e05c57d80c1d$export$faeafc1151740116 = (nodeType, domAtPos)=>(selection)=>{
        return $0704e05c57d80c1d$export$8556d79fa8189214((node)=>$0704e05c57d80c1d$var$equalNodeType(nodeType, node), domAtPos)(selection);
    };
var $0704e05c57d80c1d$export$924aa2dd4d9a67fa = (nodeType)=>(selection)=>{
        if ($0704e05c57d80c1d$export$a8c1d2c13abf8822(selection)) {
            const { node: node, $from: $from } = selection;
            if ($0704e05c57d80c1d$var$equalNodeType(nodeType, node)) return {
                node: node,
                start: $from.start(),
                pos: $from.pos,
                depth: $from.depth
            };
        }
    };
var $0704e05c57d80c1d$export$f8088819b1e2c2dc = (selection)=>{
    const { nodeBefore: nodeBefore } = selection.$from;
    const maybeSelection = (0, $3lIcL.Selection).findFrom(selection.$from, -1);
    if (maybeSelection && nodeBefore) {
        const parent = $0704e05c57d80c1d$export$1a3a74094b9968e(nodeBefore.type)(maybeSelection);
        if (parent) return parent.pos;
        return maybeSelection.$from.pos;
    }
};
var $0704e05c57d80c1d$export$666ce65defe9ad6e = (position, domAtPos)=>{
    const dom = domAtPos(position);
    const node = dom.node.childNodes[dom.offset];
    if (dom.node.nodeType === Node.TEXT_NODE && dom.node.parentNode) return dom.node.parentNode;
    if (!node || node.nodeType === Node.TEXT_NODE) return dom.node;
    return node;
};
// src/node.ts
var $0704e05c57d80c1d$export$bffa455ba8c619a6 = (node, descend = true)=>{
    if (!node) throw new Error('Invalid "node" parameter');
    const result = [];
    node.descendants((child, pos)=>{
        result.push({
            node: child,
            pos: pos
        });
        if (!descend) return false;
    });
    return result;
};
var $0704e05c57d80c1d$export$f94ca194e830789c = (node, predicate, descend = true)=>{
    if (!node) throw new Error('Invalid "node" parameter');
    else if (!predicate) throw new Error('Invalid "predicate" parameter');
    return $0704e05c57d80c1d$export$bffa455ba8c619a6(node, descend).filter((child)=>predicate(child.node));
};
var $0704e05c57d80c1d$export$53418710fbc2d8cc = (node, descend = true)=>{
    return $0704e05c57d80c1d$export$f94ca194e830789c(node, (child)=>child.isText, descend);
};
var $0704e05c57d80c1d$export$ddc1620722e25671 = (node, descend = true)=>{
    return $0704e05c57d80c1d$export$f94ca194e830789c(node, (child)=>child.isInline, descend);
};
var $0704e05c57d80c1d$export$cae8d7f259e5bbe9 = (node, descend = true)=>{
    return $0704e05c57d80c1d$export$f94ca194e830789c(node, (child)=>child.isBlock, descend);
};
var $0704e05c57d80c1d$export$a836476a7f9de5b4 = (node, predicate, descend = true)=>{
    return $0704e05c57d80c1d$export$f94ca194e830789c(node, (child)=>!!predicate(child.attrs), descend);
};
var $0704e05c57d80c1d$export$96bb9476c7c69f39 = (node, nodeType, descend = true)=>{
    return $0704e05c57d80c1d$export$f94ca194e830789c(node, (child)=>child.type === nodeType, descend);
};
var $0704e05c57d80c1d$export$c01a9e7ec615e821 = (node, markType, descend = true)=>{
    return $0704e05c57d80c1d$export$f94ca194e830789c(node, (child)=>Boolean(markType.isInSet(child.marks)), descend);
};
var $0704e05c57d80c1d$export$2344b14b097df817 = (node, nodeType)=>{
    return !!$0704e05c57d80c1d$export$96bb9476c7c69f39(node, nodeType).length;
};

});

parcelRegister("cwzAY", function(module, exports) {

$parcel$export(module.exports, "CellSelection", () => $d2163c16df8aab18$export$831cc7e2a83afa94);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
// Was copied from https://github.com/ProseMirror/prosemirror-tables/blob/master/src/cellselection.js
// This file defines a ProseMirror selection subclass that models
// table cell selections. The table plugin needs to be active to wire
// in the user interaction part of table selections (so that you
// actually get such selections when you select across cells).

var $3xw6l = parcelRequire("3xw6l");

var $3lIcL = parcelRequire("3lIcL");

var $9sdKa = parcelRequire("9sdKa");

var $2vA54 = parcelRequire("2vA54");

var $cSPHa = parcelRequire("cSPHa");

var $9K0SW = parcelRequire("9K0SW");

var $7VjxU = parcelRequire("7VjxU");

var $7lSnz = parcelRequire("7lSnz");
class $d2163c16df8aab18$export$831cc7e2a83afa94 extends (0, $3lIcL.Selection) {
    constructor($anchorCell, $headCell = $anchorCell){
        const ranges = (0, $7VjxU.getCellSelectionRanges)($anchorCell, $headCell);
        super(ranges[0].$from, ranges[0].$to, ranges);
        // :: ResolvedPos
        // A resolved position pointing _in front of_ the anchor cell (the one
        // that doesn't move when extending the selection).
        this.$anchorCell = $anchorCell;
        // :: ResolvedPos
        // A resolved position pointing in front of the head cell (the one
        // moves when extending the selection).
        this.$headCell = $headCell;
        this.visible = false;
    }
    map(doc, mapping) {
        const $anchorCell = doc.resolve(mapping.map(this.$anchorCell.pos));
        const $headCell = doc.resolve(mapping.map(this.$headCell.pos));
        if ((0, $cSPHa.pointsAtCell)($anchorCell) && (0, $cSPHa.pointsAtCell)($headCell) && (0, $7lSnz.inSameTable)($anchorCell, $headCell)) {
            const tableChanged = this.$anchorCell.node(-1) !== $anchorCell.node(-1);
            if (tableChanged && this.isRowSelection()) return $d2163c16df8aab18$export$831cc7e2a83afa94.rowSelection($anchorCell, $headCell);
            if (tableChanged && this.isColSelection()) return $d2163c16df8aab18$export$831cc7e2a83afa94.colSelection($anchorCell, $headCell);
            return new $d2163c16df8aab18$export$831cc7e2a83afa94($anchorCell, $headCell);
        }
        return (0, $3lIcL.TextSelection).between($anchorCell, $headCell);
    }
    // :: () → Slice
    // Returns a rectangular slice of table rows containing the selected
    // cells.
    content() {
        const table = this.$anchorCell.node(-1);
        const map = (0, $2vA54.TableMap).get(table);
        const start = this.$anchorCell.start(-1);
        const rect = map.rectBetween(this.$anchorCell.pos - start, this.$headCell.pos - start);
        const seen = {};
        const rows = [];
        for(let row = rect.top; row < rect.bottom; row++){
            const rowContent = [];
            for(let index = row * map.width + rect.left, col = rect.left; col < rect.right; col++, index++){
                const pos = map.map[index];
                if (!seen[pos]) {
                    seen[pos] = true;
                    const cellRect = map.findCell(pos);
                    let cell = table.nodeAt(pos);
                    if (cell === null || cell === undefined) throw new Error(`No cell at position ${pos}`);
                    const extraLeft = rect.left - cellRect.left;
                    const extraRight = cellRect.right - rect.right;
                    if (extraLeft > 0 || extraRight > 0) {
                        let { attrs: attrs } = cell;
                        if (!attrs) throw new Error(`No cell at position ${pos}`);
                        if (extraLeft > 0) attrs = (0, $9K0SW.removeColSpan)(attrs, 0, extraLeft);
                        if (extraRight > 0) // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        attrs = (0, $9K0SW.removeColSpan)(attrs, attrs.colspan - extraRight, extraRight);
                        if (cellRect.left < rect.left) cell = cell.type.createAndFill(attrs);
                        else cell = cell.type.create(attrs, cell.content);
                    }
                    if (cell === null || cell === undefined) throw new Error(`No cell at position after create/createAndFill`);
                    if (cellRect.top < rect.top || cellRect.bottom > rect.bottom) {
                        const attrs = {
                            ...cell.attrs,
                            rowspan: Math.min(cellRect.bottom, rect.bottom) - Math.max(cellRect.top, rect.top)
                        };
                        if (cellRect.top < rect.top) cell = cell.type.createAndFill(attrs);
                        else cell = cell.type.create(attrs, cell.content);
                    }
                    if (cell === null || cell === undefined) throw new Error(`No cell at position before rowContent.push`);
                    rowContent.push(cell);
                }
            }
            rows.push(table.child(row).copy((0, $3xw6l.Fragment).from(rowContent)));
        }
        const fragment = this.isColSelection() && this.isRowSelection() ? table : rows;
        return new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).from(fragment), 1, 1);
    }
    replace(tr, content = (0, $3xw6l.Slice).empty) {
        const mapFrom = tr.steps.length;
        const { ranges: ranges } = this;
        for(let i = 0; i < ranges.length; i++){
            const { $from: $from, $to: $to } = ranges[i];
            const mapping = tr.mapping.slice(mapFrom);
            tr.replace(mapping.map($from.pos), mapping.map($to.pos), i ? (0, $3xw6l.Slice).empty : content);
        }
        const sel = (0, $3lIcL.Selection).findFrom(tr.doc.resolve(tr.mapping.slice(mapFrom).map(this.to)), -1);
        if (sel) tr.setSelection(sel);
    }
    replaceWith(tr, node) {
        this.replace(tr, new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).from(node), 0, 0));
    }
    forEachCell(f) {
        const table = this.$anchorCell.node(-1);
        const map = (0, $2vA54.TableMap).get(table);
        const start = this.$anchorCell.start(-1);
        const cells = map.cellsInRect(map.rectBetween(this.$anchorCell.pos - start, this.$headCell.pos - start));
        for(let i = 0; i < cells.length; i++){
            const cell = table.nodeAt(cells[i]);
            if (cell === null || cell === undefined) throw new Error(`undefined cell at pos ${cells[i]}`);
            f(cell, start + cells[i]);
        }
    }
    // :: () → bool
    // True if this selection goes all the way from the top to the
    // bottom of the table.
    isColSelection() {
        if (!this.$anchorCell || !this.$headCell) throw new Error('invalid $anchorCell or $headCell');
        const anchorTop = this.$anchorCell.index(-1);
        const headTop = this.$headCell.index(-1);
        if (Math.min(anchorTop, headTop) > 0) return false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const anchorBot = anchorTop + this.$anchorCell.nodeAfter.attrs.rowspan;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const headBot = headTop + this.$headCell.nodeAfter.attrs.rowspan;
        return Math.max(anchorBot, headBot) === this.$headCell.node(-1).childCount;
    }
    // :: (ResolvedPos, ?ResolvedPos) → CellSelection
    // Returns the smallest column selection that covers the given anchor
    // and head cell.
    static colSelection($anchorCell, $headCell = $anchorCell) {
        let $calculatedAnchorCell = $anchorCell;
        let $calculatedHeadCell = $headCell;
        const map = (0, $2vA54.TableMap).get($calculatedAnchorCell.node(-1));
        const start = $calculatedAnchorCell.start(-1);
        const anchorRect = map.findCell($calculatedAnchorCell.pos - start);
        const headRect = map.findCell($calculatedHeadCell.pos - start);
        const doc = $calculatedAnchorCell.node(0);
        if (anchorRect.top <= headRect.top) {
            if (anchorRect.top > 0) $calculatedAnchorCell = doc.resolve(start + map.map[anchorRect.left]);
            if (headRect.bottom < map.height) $calculatedHeadCell = doc.resolve(start + map.map[map.width * (map.height - 1) + headRect.right - 1]);
        } else {
            if (headRect.top > 0) $calculatedHeadCell = doc.resolve(start + map.map[headRect.left]);
            if (anchorRect.bottom < map.height) $calculatedAnchorCell = doc.resolve(start + map.map[map.width * (map.height - 1) + anchorRect.right - 1]);
        }
        return new $d2163c16df8aab18$export$831cc7e2a83afa94($calculatedAnchorCell, $calculatedHeadCell);
    }
    // :: () → bool
    // True if this selection goes all the way from the left to the
    // right of the table.
    isRowSelection() {
        if (!this.$anchorCell || !this.$headCell) return false;
        const start = this.$anchorCell.start(-1);
        const map = (0, $2vA54.TableMap).get(this.$anchorCell.node(-1));
        const rowAtAnchorCell = map.rowCount(this.$anchorCell.pos - start);
        const rowAtHeadCell = map.rowCount(this.$headCell.pos - start);
        const isSelectionSameRow = rowAtAnchorCell === rowAtHeadCell;
        // if anchor and head in the same line, counting how many cells
        // should be in the row except merged cell
        const maxColumnInSelectedRow = map.getMaxColInRow(this.$anchorCell);
        // if selected cells less than table max column amount, and
        // the anchor/head not in a merged cell
        // it should be select maxColumnInSelectedRow to be TRUE
        if (isSelectionSameRow && this.ranges.length <= map.width && !map.isPosMerged(this.$anchorCell.pos - start) && !map.isPosMerged(this.$headCell.pos - start)) return this.ranges.length === maxColumnInSelectedRow;
        // If anchor and head in different row, it should be always in first and
        // last column to select the whole row.
        const anchorLeft = map.colCount(this.$anchorCell.pos - start);
        const headLeft = map.colCount(this.$headCell.pos - start);
        if (Math.min(anchorLeft, headLeft) > 0) return false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const anchorRight = anchorLeft + this.$anchorCell.nodeAfter.attrs.colspan;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const headRight = headLeft + this.$headCell.nodeAfter.attrs.colspan;
        return Math.max(anchorRight, headRight) === map.width;
    }
    eq(other) {
        return other instanceof $d2163c16df8aab18$export$831cc7e2a83afa94 && other.$anchorCell.pos === this.$anchorCell.pos && other.$headCell.pos === this.$headCell.pos;
    }
    // :: (ResolvedPos, ?ResolvedPos) → CellSelection
    // Returns the smallest row selection that covers the given anchor
    // and head cell.
    static rowSelection($anchorCell, $headCell = $anchorCell) {
        let $calculatedAnchorCell = $anchorCell;
        let $calculatedHeadCell = $headCell;
        const map = (0, $2vA54.TableMap).get($calculatedAnchorCell.node(-1));
        const start = $calculatedAnchorCell.start(-1);
        const anchorRect = map.findCell($calculatedAnchorCell.pos - start);
        const headRect = map.findCell($calculatedHeadCell.pos - start);
        const doc = $calculatedAnchorCell.node(0);
        if (anchorRect.left <= headRect.left) {
            if (anchorRect.left > 0) $calculatedAnchorCell = doc.resolve(start + map.map[anchorRect.top * map.width]);
            if (headRect.right < map.width) $calculatedHeadCell = doc.resolve(start + map.map[map.width * (headRect.top + 1) - 1]);
        } else {
            if (headRect.left > 0) $calculatedHeadCell = doc.resolve(start + map.map[headRect.top * map.width]);
            if (anchorRect.right < map.width) $calculatedAnchorCell = doc.resolve(start + map.map[map.width * (anchorRect.top + 1) - 1]);
        }
        return new $d2163c16df8aab18$export$831cc7e2a83afa94($calculatedAnchorCell, $calculatedHeadCell);
    }
    toJSON() {
        return {
            type: 'cell',
            anchor: this.$anchorCell.pos,
            head: this.$headCell.pos
        };
    }
    static fromJSON(doc, json) {
        return new $d2163c16df8aab18$export$831cc7e2a83afa94(doc.resolve(json.anchor), doc.resolve(json.head));
    }
    // :: (Node, number, ?number) → CellSelection
    static create(doc, anchorCell, headCell = anchorCell) {
        return new $d2163c16df8aab18$export$831cc7e2a83afa94(doc.resolve(anchorCell), doc.resolve(headCell));
    }
    getBookmark() {
        return new (0, $9sdKa.CellBookmark)(this.$anchorCell.pos, this.$headCell.pos);
    }
}
(0, $3lIcL.Selection).jsonID('cell', $d2163c16df8aab18$export$831cc7e2a83afa94);

});
parcelRegister("9sdKa", function(module, exports) {

$parcel$export(module.exports, "CellBookmark", () => $261b53ebec41e3a8$export$ca751a6394ad160e);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $3lIcL = parcelRequire("3lIcL");

var $7lSnz = parcelRequire("7lSnz");
class $261b53ebec41e3a8$export$ca751a6394ad160e {
    constructor(anchor, head){
        this.anchor = anchor;
        this.head = head;
    }
    map(mapping) {
        return new $261b53ebec41e3a8$export$ca751a6394ad160e(mapping.map(this.anchor), mapping.map(this.head));
    }
    resolve(doc) {
        const $anchorCell = doc.resolve(this.anchor);
        const $headCell = doc.resolve(this.head);
        if ($anchorCell.parent.type.spec.tableRole === 'row' && $headCell.parent.type.spec.tableRole === 'row' && $anchorCell.index() < $anchorCell.parent.childCount && $headCell.index() < $headCell.parent.childCount && (0, $7lSnz.inSameTable)($anchorCell, $headCell)) {
            const data = {
                type: 'cell',
                anchor: $anchorCell.pos,
                head: $headCell.pos
            };
            return (0, $3lIcL.Selection).fromJSON(doc, data);
        }
        return (0, $3lIcL.Selection).near($headCell, 1);
    }
}

});
parcelRegister("7lSnz", function(module, exports) {

$parcel$export(module.exports, "isInTable", () => $03a54050b67a9b6d$export$217a88ad224d1b11);
$parcel$export(module.exports, "inSameTable", () => $03a54050b67a9b6d$export$debd62b44eb7e281);
function $03a54050b67a9b6d$export$217a88ad224d1b11(state) {
    const { $head: $head } = state.selection;
    for(let d = $head.depth; d > 0; d--){
        if ($head.node(d).type.spec.tableRole === 'row') return true;
    }
    return false;
}
function $03a54050b67a9b6d$export$debd62b44eb7e281($a, $b) {
    return $a.depth === $b.depth && $a.pos >= $b.start(-1) && $a.pos <= $b.end(-1);
}

});


parcelRegister("2vA54", function(module, exports) {

$parcel$export(module.exports, "Rect", () => $92f17257f5177c44$export$c79fc6492f3af13d);
$parcel$export(module.exports, "TableProblemTypes", () => $92f17257f5177c44$export$d8cd393a71edca79);
$parcel$export(module.exports, "TableMap", () => $92f17257f5177c44$export$493da463fed0a57a);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
// Because working with row and column-spanning cells is not quite
// trivial, this code builds up a descriptive structure for a given
// table node. The structures are cached with the (persistent) table
// nodes as key, so that they only have to be recomputed when the
// content of the table changes.
//
// This does mean that they have to store table-relative, not
// document-relative positions. So code that uses them will typically
// compute the start position of the table and offset positions passed
// to or gotten from this structure by that amount.
let $92f17257f5177c44$var$readFromCache, $92f17257f5177c44$var$addToCache;
// Prefer using a weak map to cache table maps. Fall back on a
// fixed-size cache if that's not supported.
if (typeof WeakMap !== 'undefined') {
    const cache = new WeakMap();
    $92f17257f5177c44$var$readFromCache = (key)=>cache.get(key);
    $92f17257f5177c44$var$addToCache = (key, value)=>{
        cache.set(key, value);
        return value;
    };
} else {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cache = [];
    const cacheSize = 10;
    let cachePos = 0;
    $92f17257f5177c44$var$readFromCache = (key)=>{
        for(let i = 0; i < cache.length; i += 2){
            if (cache[i] === key) return cache[i + 1];
        }
    };
    $92f17257f5177c44$var$addToCache = (key, value)=>{
        if (cachePos === cacheSize) cachePos = 0;
        cache[cachePos++] = key;
        return cache[cachePos++] = value;
    };
}
class $92f17257f5177c44$export$c79fc6492f3af13d {
    constructor(left, top, right, bottom){
        this.left = left;
        this.top = top;
        this.right = right;
        this.bottom = bottom;
    }
}
var $92f17257f5177c44$export$d8cd393a71edca79 = /*#__PURE__*/ function(TableProblemTypes) {
    TableProblemTypes["COLLISION"] = "collision";
    TableProblemTypes["OVERLONG_ROWSPAN"] = "overlong_rowspan";
    TableProblemTypes["MISSING"] = "missing";
    TableProblemTypes["COLWIDTH_MISMATCH"] = "colwidth mismatch";
    return TableProblemTypes;
}({});
const $92f17257f5177c44$export$c60fae4049791eae = 140;
class $92f17257f5177c44$export$493da463fed0a57a {
    constructor(width, height, map, problems, mapByColumn, mapByRow){
        this.mapByColumn = [];
        this.mapByRow = [];
        this.width = width;
        this.height = height;
        this.mapByColumn = mapByColumn || [];
        this.mapByRow = mapByRow || [];
        // :: [number] A width * height array with the start position of
        // the cell covering that part of the table in each slot
        this.map = map;
        // An optional array of problems (cell overlap or non-rectangular
        // shape) for the table, used by the table normalizer.
        this.problems = problems;
    }
    // :: (number) → Rect
    // Find the dimensions of the cell at the given position.
    findCell(pos) {
        for(let i = 0; i < this.map.length; i++){
            const curPos = this.map[i];
            if (curPos !== pos) continue;
            const left = i % this.width;
            const top = i / this.width | 0;
            let right = left + 1;
            let bottom = top + 1;
            for(let j = 1; right < this.width && this.map[i + j] === curPos; j++)right++;
            for(let j = 1; bottom < this.height && this.map[i + this.width * j] === curPos; j++)bottom++;
            return new $92f17257f5177c44$export$c79fc6492f3af13d(left, top, right, bottom);
        }
        throw new RangeError('No cell with offset ' + pos + ' found');
    }
    // Find the left side of the cell at the given position.
    colCount(pos) {
        for(let i = 0; i < this.map.length; i++){
            if (this.map[i] === pos) return i % this.width;
        }
        throw new RangeError('No cell with offset ' + pos + ' found');
    }
    // Find the top side of the cell at the given position.
    rowCount(pos) {
        if (this.width <= 0) throw new RangeError('Wrong table width found');
        for(let i = 0; i < this.map.length; i++){
            if (this.map[i] === pos) return Math.floor(i / this.width);
        }
        throw new RangeError('No cell with offset ' + pos + ' found');
    }
    isPosMerged(pos) {
        return this.map.includes(pos, this.map.indexOf(pos) + 1);
    }
    isCellMerged(row, col) {
        return this.isCellMergedTopLeft(row, col) || this.isCellMergedBottomRight(row, col);
    }
    isCellMergedTopLeft(row, col) {
        const pos = this.map[row * this.width + col];
        return(// top
        row > 0 && pos === this.map[(row - 1) * this.width + col] || // left
        col > 0 && pos === this.map[row * this.width + (col - 1)]);
    }
    isCellMergedBottomRight(row, col) {
        const pos = this.map[row * this.width + col];
        return(// bottom
        row < this.height - 1 && pos === this.map[(row + 1) * this.width + col] || // right
        col < this.width - 1 && pos === this.map[row * this.width + (col + 1)]);
    }
    // :: (number, string, number) → ?number
    // Find the next cell in the given direction, starting from the cell
    // at `pos`, if any.
    nextCell(pos, axis, dir) {
        const { left: left, right: right, top: top, bottom: bottom } = this.findCell(pos);
        if (axis === 'horiz') {
            if (dir < 0 ? left === 0 : right === this.width) return null;
            return this.map[top * this.width + (dir < 0 ? left - 1 : right)];
        } else {
            if (dir < 0 ? top === 0 : bottom === this.height) return null;
            return this.map[left + this.width * (dir < 0 ? top - 1 : bottom)];
        }
    }
    // :: (number, number) → Rect
    // Get the rectangle spanning the two given cells.
    rectBetween(a, b) {
        const { left: leftA, right: rightA, top: topA, bottom: bottomA } = this.findCell(a);
        const { left: leftB, right: rightB, top: topB, bottom: bottomB } = this.findCell(b);
        return new $92f17257f5177c44$export$c79fc6492f3af13d(Math.min(leftA, leftB), Math.min(topA, topB), Math.max(rightA, rightB), Math.max(bottomA, bottomB));
    }
    // :: (Rect) → [number]
    // Return the position of all cells that have the top left corner in
    // the given rectangle.
    cellsInRect(rect) {
        const result = [];
        const seen = {};
        for(let row = rect.top; row < rect.bottom; row++)for(let col = rect.left; col < rect.right; col++){
            const index = row * this.width + col;
            const pos = this.map[index];
            if (seen[pos]) continue;
            seen[pos] = true;
            if ((col !== rect.left || !col || this.map[index - 1] !== pos) && (row !== rect.top || !row || this.map[index - this.width] !== pos)) result.push(pos);
        }
        return result;
    }
    // :: (number, number, Node) → number
    // Return the position at which the cell at the given row and column
    // starts, or would start, if a cell started there.
    positionAt(row, col, table) {
        for(let i = 0, rowStart = 0;; i++){
            const rowEnd = rowStart + table.child(i).nodeSize;
            if (i === row) {
                let index = col + row * this.width;
                const rowEndIndex = (row + 1) * this.width;
                // Skip past cells from previous rows (via rowspan)
                while(index < rowEndIndex && this.map[index] < rowStart)index++;
                return index === rowEndIndex ? rowEnd - 1 : this.map[index];
            }
            rowStart = rowEnd;
        }
    }
    getMaxColInRow(pos) {
        const parentRowNode = pos.parent;
        if (parentRowNode.type.name === 'tableRow') return parentRowNode.childCount;
    }
    hasMergedCells() {
        const uniquePositions = new Set(this.map);
        return uniquePositions.size !== this.map.length;
    }
    // :: (Node) → TableMap
    // Find the table map for the given table node.
    static get(table) {
        return $92f17257f5177c44$var$readFromCache(table) || $92f17257f5177c44$var$addToCache(table, $92f17257f5177c44$var$computeMap(table));
    }
}
// Compute a table map.
function $92f17257f5177c44$var$computeMap(table) {
    if (table.type.spec.tableRole !== 'table') throw new RangeError('Not a table node: ' + table.type.name);
    const width = $92f17257f5177c44$var$findWidth(table);
    const height = table.childCount;
    const map = [];
    const colWidths = [];
    let mapPos = 0, problems = null;
    for(let i = 0, e = width * height; i < e; i++)map[i] = 0;
    for(let row = 0, pos = 0; row < height; row++){
        const rowNode = table.child(row);
        pos++;
        for(let i = 0;; i++){
            while(mapPos < map.length && map[mapPos] !== 0)mapPos++;
            if (i === rowNode.childCount) break;
            const cellNode = rowNode.child(i), { colspan: colspan, rowspan: rowspan, colwidth: colwidth } = cellNode.attrs;
            for(let h = 0; h < rowspan; h++){
                if (h + row >= height) {
                    (problems || (problems = [])).push({
                        type: "overlong_rowspan",
                        pos: pos,
                        n: rowspan - h
                    });
                    break;
                }
                const start = mapPos + h * width;
                for(let w = 0; w < colspan; w++){
                    if (map[start + w] === 0) map[start + w] = pos;
                    else (problems || (problems = [])).push({
                        type: "collision",
                        row: row,
                        pos: pos,
                        n: colspan - w
                    });
                    const colW = colwidth && colwidth[w];
                    if (colW) {
                        const widthIndex = (start + w) % width * 2, prev = colWidths[widthIndex];
                        if (prev == null || prev !== colW && colWidths[widthIndex + 1] === 1) {
                            colWidths[widthIndex] = colW;
                            colWidths[widthIndex + 1] = 1;
                        } else if (prev === colW) colWidths[widthIndex + 1]++;
                    }
                }
            }
            mapPos += colspan;
            pos += cellNode.nodeSize;
        }
        const expectedPos = (row + 1) * width;
        let missing = 0;
        while(mapPos < expectedPos)if (map[mapPos++] === 0) missing++;
        if (missing) (problems || (problems = [])).push({
            type: "missing",
            row: row,
            n: missing
        });
        pos++;
    }
    const mapByRow = Array(height);
    const mapByColumn = Array(width);
    for(let i = 0; i < map.length; i++){
        const columnIndex = i % width;
        mapByColumn[columnIndex] = mapByColumn[columnIndex] ?? [];
        mapByColumn[columnIndex].push(map[i]);
        const rowIndex = Math.trunc(i / width);
        mapByRow[rowIndex] = mapByRow[rowIndex] ?? [];
        mapByRow[rowIndex].push(map[i]);
    }
    const tableMap = new $92f17257f5177c44$export$493da463fed0a57a(width, height, map, problems, mapByColumn, mapByRow);
    let badWidths = false;
    // For columns that have defined widths, but whose widths disagree
    // between rows, fix up the cells whose width doesn't match the
    // computed one.
    for(let i = 0; !badWidths && i < colWidths.length; i += 2)if (colWidths[i] != null && colWidths[i + 1] < height) badWidths = true;
    // colWidths is an array of numbers, it can look like this
    // const colWidths = [255, 3, 125, 3, 150, 2, 130, 1];
    // 255 is a colWidth and 3 is a number of cells with this colwidth.
    // This check exists to make sure that the table has been resized,
    // which means there will be elements in the colWidths array.
    if (colWidths.length > 0 && colWidths.length !== width * 2) {
        for(let i = 0; i < width * 2 - colWidths.length; i++)colWidths.push($92f17257f5177c44$export$c60fae4049791eae, 0);
        badWidths = true;
    }
    if (badWidths) $92f17257f5177c44$var$findBadColWidths(tableMap, colWidths, table);
    return tableMap;
}
function $92f17257f5177c44$var$findWidth(table) {
    let width = -1;
    let hasRowSpan = false;
    for(let row = 0; row < table.childCount; row++){
        const rowNode = table.child(row);
        let rowWidth = 0;
        if (hasRowSpan) for(let j = 0; j < row; j++){
            const prevRow = table.child(j);
            for(let i = 0; i < prevRow.childCount; i++){
                const cell = prevRow.child(i);
                if (j + cell.attrs.rowspan > row) rowWidth += cell.attrs.colspan;
            }
        }
        for(let i = 0; i < rowNode.childCount; i++){
            const cell = rowNode.child(i);
            rowWidth += cell.attrs.colspan;
            if (cell.attrs.rowspan > 1) hasRowSpan = true;
        }
        if (width === -1) width = rowWidth;
        else if (width !== rowWidth) width = Math.max(width, rowWidth);
    }
    return width;
}
function $92f17257f5177c44$var$findBadColWidths(map, colWidths, table) {
    if (!map.problems) map.problems = [];
    const seen = {};
    for(let i = 0; i < map.map.length; i++){
        const pos = map.map[i];
        if (seen[pos]) continue;
        seen[pos] = true;
        const node = table.nodeAt(pos);
        let updated = null;
        for(let j = 0; j < node.attrs.colspan; j++){
            const col = (i + j) % map.width, colWidth = colWidths[col * 2];
            if (colWidth != null && (!node.attrs.colwidth || node.attrs.colwidth[j] !== colWidth)) (updated || (updated = $92f17257f5177c44$var$freshColWidth(node.attrs)))[j] = colWidth;
        }
        if (updated) map.problems.unshift({
            type: "colwidth mismatch",
            pos: pos,
            colwidth: updated
        });
    }
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $92f17257f5177c44$var$freshColWidth(attrs) {
    if (attrs.colwidth) return attrs.colwidth.slice();
    const result = [];
    for(let i = 0; i < attrs.colspan; i++)result.push(0);
    return result;
}

});

parcelRegister("cSPHa", function(module, exports) {

$parcel$export(module.exports, "pointsAtCell", () => $2dfed9e7e05b2316$export$3c89e45c7dff9619);
$parcel$export(module.exports, "cellNear", () => $2dfed9e7e05b2316$export$7a283ef453dbae9e);
$parcel$export(module.exports, "cellAround", () => $2dfed9e7e05b2316$export$1f482d92c57578ce);
$parcel$export(module.exports, "nextCell", () => $2dfed9e7e05b2316$export$172699367bb25225);

var $2vA54 = parcelRequire("2vA54");
function $2dfed9e7e05b2316$export$3c89e45c7dff9619($pos) {
    return $pos.parent.type.spec.tableRole === 'row' && $pos.nodeAfter;
}
function $2dfed9e7e05b2316$export$7a283ef453dbae9e($pos) {
    for(let after = $pos.nodeAfter, { pos: pos } = $pos; after; after = after.firstChild, pos++){
        const role = after.type.spec.tableRole;
        if (role === 'cell' || role === 'header_cell') return $pos.doc.resolve(pos);
    }
    for(let before = $pos.nodeBefore, { pos: pos } = $pos; before; before = before.lastChild, pos--){
        const role = before.type.spec.tableRole;
        if (role === 'cell' || role === 'header_cell') return $pos.doc.resolve(pos - before.nodeSize);
    }
    return null;
}
function $2dfed9e7e05b2316$export$1f482d92c57578ce($pos) {
    for(let d = $pos.depth - 1; d > 0; d--){
        if ($pos.node(d).type.spec.tableRole === 'row') return $pos.node(0).resolve($pos.before(d + 1));
    }
    return null;
}
function $2dfed9e7e05b2316$export$172699367bb25225($pos, axis, dir) {
    const start = $pos.start(-1);
    const map = (0, $2vA54.TableMap).get($pos.node(-1));
    const moved = map.nextCell($pos.pos - start, axis, dir);
    return moved == null ? null : $pos.node(0).resolve(start + moved);
}

});

parcelRegister("9K0SW", function(module, exports) {

$parcel$export(module.exports, "removeColSpan", () => $786bf010e3609b18$export$b24d9c3cc95412e0);
$parcel$export(module.exports, "assertColspan", () => $786bf010e3609b18$export$6fccdf7cee1b5201);
$parcel$export(module.exports, "addColSpan", () => $786bf010e3609b18$export$147ee78a1321ac36);
function $786bf010e3609b18$export$b24d9c3cc95412e0(attrs, pos, n = 1) {
    if (!attrs.colspan) throw new Error('removeColSpan(): attrs.colspan not defined');
    const result = {
        ...attrs,
        colspan: attrs.colspan - n
    };
    if (result.colwidth) {
        result.colwidth = result.colwidth.slice();
        result.colwidth.splice(pos, n);
        if (!result.colwidth.some((w)=>w > 0)) result.colwidth = undefined;
    }
    return result;
}
function $786bf010e3609b18$export$6fccdf7cee1b5201(attrs) {
    if (typeof attrs.colspan === 'undefined') throw new Error('addColSpan: attrs.colspan is not defined');
    if (typeof attrs.colspan !== 'number' || Number.isNaN(attrs.colspan) || attrs.colspan < 1) throw new Error(`addColSpan: attrs.colspan must be number >= 1, received: ${attrs.colspan}`);
}
function $786bf010e3609b18$export$147ee78a1321ac36(attrs, pos, n = 1) {
    $786bf010e3609b18$export$6fccdf7cee1b5201(attrs);
    const result = {
        ...attrs,
        colspan: attrs.colspan + n
    };
    if (result.colwidth) {
        result.colwidth = result.colwidth.slice();
        for(let i = 0; i < n; i++)result.colwidth.splice(pos, 0, 0);
    }
    return result;
}

});

parcelRegister("7VjxU", function(module, exports) {

$parcel$export(module.exports, "getCellSelectionRanges", () => $c774abe147af6cb9$export$a60a444208fd5099);

var $3lIcL = parcelRequire("3lIcL");

var $2vA54 = parcelRequire("2vA54");
function $c774abe147af6cb9$export$a60a444208fd5099($anchorCell, $headCell) {
    const table = $anchorCell.node(-1);
    const map = (0, $2vA54.TableMap).get(table);
    const start = $anchorCell.start(-1);
    const rect = map.rectBetween($anchorCell.pos - start, $headCell.pos - start);
    const doc = $anchorCell.node(0);
    const cells = map.cellsInRect(rect).filter((p)=>p !== $headCell.pos - start);
    // Make the head cell the first range, so that it counts as the
    // primary part of the selection
    cells.unshift($headCell.pos - start);
    return cells.map((pos)=>{
        const cell = table.nodeAt(pos);
        if (cell === null) throw new Error(`No cell at position ${pos}`);
        const from = pos + start + 1;
        return new (0, $3lIcL.SelectionRange)(doc.resolve(from), doc.resolve(from + cell.content.size));
    });
}

});



parcelRegister("LjYWw", function(module, exports) {

$parcel$export(module.exports, "shouldForceTracking", () => $c2e457fcbc1453ce$export$5b59d3e9e22dbdc6);
// START: temporary code https://product-fabric.atlassian.net/browse/ED-10260
const $c2e457fcbc1453ce$export$5b59d3e9e22dbdc6 = ()=>{
    try {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const { FRONTEND_VERSION: FRONTEND_VERSION = '' } = window.__buildInfo || {};
        return window.location.hostname === 'product-fabric.atlassian.net' && FRONTEND_VERSION.includes('branch-deploy');
    } catch (err) {
        // eslint-disable-next-line no-console
        console.warn(err);
        return false;
    }
}; // END:  temporary code  https://product-fabric.atlassian.net/browse/ED-10260

});

parcelRegister("jgFE8", function(module, exports) {

$parcel$export(module.exports, "normalizeFeatureFlags", () => $36675c30e06e1565$export$f1485fc4974593c0);
$parcel$export(module.exports, "getEnabledFeatureFlagKeys", () => $36675c30e06e1565$export$6d018dd0f6cbebcb);

var $7mF43 = parcelRequire("7mF43");

var $4CEkC = parcelRequire("4CEkC");
const $36675c30e06e1565$var$EMPTY = {};
function $36675c30e06e1565$var$isObjectFlagKey(key, // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
value, objectFlagKeys) {
    return Boolean(typeof value === 'string' && objectFlagKeys?.includes(key));
}
function $36675c30e06e1565$var$isValidJSONObject(value) {
    try {
        const result = JSON.parse(value);
        if (typeof result === 'object' && result !== null) return true;
        return false;
    } catch (err) {
        return false;
    }
}
function $36675c30e06e1565$export$f1485fc4974593c0(rawFeatureFlags, options) {
    if (!rawFeatureFlags) return $36675c30e06e1565$var$EMPTY;
    return Object.entries(rawFeatureFlags).filter((e)=>{
        if (typeof e[1] === 'boolean') return true;
        if ($36675c30e06e1565$var$isObjectFlagKey((0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))(e[0]), e[1], options?.objectFlagKeys) && $36675c30e06e1565$var$isValidJSONObject(e[1])) return true;
        return false;
    }).filter(([key])=>(0, (/*@__PURE__*/$parcel$interopDefault($4CEkC)))(key) === key).map(([key, value])=>[
            (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))(key),
            value
        ]).reduce((flags, [key, value])=>{
        if ($36675c30e06e1565$var$isObjectFlagKey(key, value, options?.objectFlagKeys)) flags[key] = JSON.parse(value);
        if (typeof value === 'boolean') flags[key] = value;
        return flags;
    }, {});
}
function $36675c30e06e1565$export$6d018dd0f6cbebcb(featureFlags) {
    return Object.keys(featureFlags).filter((key)=>featureFlags[key] === true);
}

});

parcelRegister("aYybS", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e23e48a41f0e258$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $3xw6l = parcelRequire("3xw6l");

var $92xoS = parcelRequire("92xoS");

var $iOvh6 = parcelRequire("iOvh6");
parcelRequire("lOeyo");
var $lbGwd = parcelRequire("lbGwd");
var $lOeyo = parcelRequire("lOeyo");

var $fB6mC = parcelRequire("fB6mC");

var $fpMtm = parcelRequire("fpMtm");
var $QAAiN = parcelRequire("QAAiN");

var $cRsRn = parcelRequire("cRsRn");

var $bTpHi = parcelRequire("bTpHi");

var $g9wjI = parcelRequire("g9wjI");

var $BmspC = parcelRequire("BmspC");

var $eGOwo = parcelRequire("eGOwo");

var $fftJQ = parcelRequire("fftJQ");

var $37UKp = parcelRequire("37UKp");

var $bRAXN = parcelRequire("bRAXN");

var $7Uu7t = parcelRequire("7Uu7t");
function $2e23e48a41f0e258$var$mergeMarks(marksAndNodes) {
    return marksAndNodes.reduce((acc, markOrNode)=>{
        const prev = acc.length && acc[acc.length - 1] || null;
        if (markOrNode.type instanceof (0, $3xw6l.MarkType) && prev && prev.type instanceof (0, $3xw6l.MarkType) && Array.isArray(prev.content) && (0, $cRsRn.isSameMark)(prev, markOrNode)) prev.content = $2e23e48a41f0e258$var$mergeMarks(prev.content.concat(markOrNode.content));
        else acc.push(markOrNode);
        return acc;
    }, []);
}
class $2e23e48a41f0e258$export$2e2bcd8739ae039 {
    constructor(init){
        this.headingIds = [];
        /**
	 * The reason we have this extra array here is because we need to generate the same unique
	 * heading id for 2 different nodes: headers and expands (check the implementation of
	 * `getUniqueHeadingId` for more info).
	 *
	 * We will eventually need to refactor the current approach to generate unique ids
	 * for headers under this ticket -> https://product-fabric.atlassian.net/browse/ED-9668
	 */ this.expandHeadingIds = [];
        this.allowCopyToClipboard = false;
        this.allowWrapCodeBlock = false;
        this.allowPlaceholderText = true;
        this.allowCustomPanels = false;
        this.surroundTextNodesWithTextWrapper = false;
        this.allowAnnotations = false;
        this.serializeFragmentChild = (node, { index: index, parentInfo: parentInfo })=>{
            const pos = this.startPos;
            const currentPath = parentInfo && parentInfo.path || [];
            const parentIsIncompleteTask = node.type.name === 'taskItem' && node.attrs.state !== 'DONE';
            const nodeKey = `${node.type.name}__${this.startPos}`;
            const serializedContent = this.serializeFragment(node.content, this.getNodeProps(node, parentInfo), (0, $lOeyo.toReact)(node, {
                allowSelectAllTrap: this.allowSelectAllTrap,
                allowWindowedCodeBlock: this.allowWindowedCodeBlock
            }, this.nodeComponents), nodeKey, {
                parentIsIncompleteTask: parentIsIncompleteTask,
                path: [
                    ...currentPath,
                    node
                ],
                pos: this.startPos
            });
            this.startPos = pos + node.nodeSize;
            const marks = node.marks ? [
                ...node.marks
            ] : [];
            const isMedia = node.type.name === 'media';
            const shouldSkipBorderMark = (mark)=>currentPath.some((n)=>n.type?.name !== 'mediaSingle') && isMedia && mark.type.name === 'border';
            const shouldSkipLinkMark = (mark)=>this.allowMediaLinking !== true && isMedia && mark.type.name === 'link';
            return marks.reduceRight((content, mark)=>{
                if (shouldSkipLinkMark(mark) || shouldSkipBorderMark(mark)) return content;
                return this.renderMark((0, $QAAiN.toReact)(mark), this.withMediaMarkProps(node, mark, this.getMarkProps(mark, [], node)), `${mark.type.name}-${index}`, content);
            }, serializedContent);
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.withMediaMarkProps = (node, mark, defaultProps)=>{
            if (mark.type.name === 'link' && node.type.name === 'media') return {
                ...defaultProps,
                isMediaLink: true
            };
            if (node.type.name === 'mediaInline' && mark.type.name === 'annotation') return {
                ...defaultProps,
                isMediaInline: true
            };
            return defaultProps;
        };
        this.getUnsupportedContentProps = (node)=>{
            return {
                node: node,
                dispatchAnalyticsEvent: this.fireAnalyticsEvent
            };
        };
        this.getAnnotationMarkProps = (mark, marksParentPath)=>{
            const annotationParentIds = (marksParentPath || []).reduce((acc, parent)=>{
                if ((0, $fpMtm.isAnnotationMark)(parent)) return [
                    ...acc,
                    parent.attrs.id
                ];
                return acc;
            }, []);
            return {
                id: mark.attrs.id,
                annotationType: mark.attrs.annotationType,
                annotationParentIds: annotationParentIds,
                allowAnnotations: this.allowAnnotations,
                dataAttributes: {
                    'data-renderer-mark': true
                }
            };
        };
        this.getMarkProps = (mark, marksParentPath, node)=>{
            if ((0, $fpMtm.isAnnotationMark)(mark)) return this.getAnnotationMarkProps(mark, marksParentPath);
            const { key: key, ...otherAttrs } = mark.attrs;
            const extraProps = {
                isInline: node?.isInline
            };
            // currently the only mark which has custom props is the code mark
            const markSpecificProps = (0, $37UKp.isCodeMark)(mark) ? {
                // The appearance being mobile indicates we are in an renderer being
                // rendered by mobile bridge in a web view.
                // The tooltip is likely to have unexpected behaviour there, with being cut
                // off, so we disable it. This is also to keep the behaviour consistent with
                // the rendering in the mobile Native Renderer.
                codeBidiWarningTooltipEnabled: false
            } : {};
            const props = {
                eventHandlers: this.eventHandlers,
                fireAnalyticsEvent: this.fireAnalyticsEvent,
                markKey: key,
                ...otherAttrs,
                ...extraProps,
                ...markSpecificProps,
                dataAttributes: {
                    'data-renderer-mark': true
                }
            };
            return props;
        };
        if ((0, $92xoS.editorExperiment)('comment_on_bodied_extensions', true)) {
            this.initStartPos = init.startPos || 1;
            this.startPos = init.startPos || 1;
        } else {
            this.initStartPos = 1;
            this.startPos = 1;
        }
        this.providers = init.providers;
        this.eventHandlers = init.eventHandlers;
        this.extensionHandlers = init.extensionHandlers;
        this.portal = init.portal;
        this.rendererContext = init.objectContext;
        this.appearance = init.appearance;
        this.disableHeadingIDs = init.disableHeadingIDs;
        this.disableActions = init.disableActions;
        this.allowHeadingAnchorLinks = init.allowHeadingAnchorLinks;
        this.allowCopyToClipboard = init.allowCopyToClipboard;
        this.allowWrapCodeBlock = init.allowWrapCodeBlock;
        this.allowPlaceholderText = init.allowPlaceholderText;
        this.allowCustomPanels = init.allowCustomPanels;
        this.allowColumnSorting = init.allowColumnSorting;
        this.fireAnalyticsEvent = init.fireAnalyticsEvent;
        this.shouldOpenMediaViewer = init.shouldOpenMediaViewer;
        this.allowAltTextOnImages = init.allowAltTextOnImages;
        this.stickyHeaders = init.stickyHeaders;
        this.allowMediaLinking = init.allowMediaLinking;
        this.allowAnnotations = Boolean(init.allowAnnotations);
        this.surroundTextNodesWithTextWrapper = Boolean(init.surroundTextNodesWithTextWrapper);
        this.media = init.media;
        this.emojiResourceConfig = init.emojiResourceConfig;
        this.smartLinks = init.smartLinks;
        this.extensionViewportSizes = init.extensionViewportSizes;
        this.allowSelectAllTrap = init.allowSelectAllTrap;
        this.nodeComponents = init.nodeComponents;
        this.allowWindowedCodeBlock = init.allowWindowedCodeBlock;
        this.isInsideOfInlineExtension = init.isInsideOfInlineExtension;
        this.textHighlighter = init.textHighlighter;
        this.allowTableAlignment = init.allowTableAlignment;
        this.allowTableResizing = init.allowTableResizing;
        this.isPresentational = init.isPresentational;
        this.disableTableOverflowShadow = init.disableTableOverflowShadow;
    }
    resetState() {
        this.headingIds = [];
        this.expandHeadingIds = [];
        this.startPos = this.initStartPos;
    }
    getNodeProps(node, parentInfo) {
        const path = parentInfo ? parentInfo.path : undefined;
        switch(node.type.name){
            case 'date':
                return this.getDateProps(node, parentInfo, path);
            case 'hardBreak':
                return this.getHardBreakProps(node, path);
            case 'heading':
                return this.getHeadingProps(node, path);
            case 'media':
                return this.getMediaProps(node, path);
            case 'emoji':
                return this.getEmojiProps(node);
            case 'extension':
            case 'bodiedExtension':
                return this.getExtensionProps(node, path);
            case 'mediaGroup':
                return this.getMediaGroupProps(node);
            case 'mediaInline':
                return this.getMediaInlineProps(node);
            case 'mediaSingle':
                return this.getMediaSingleProps(node, path);
            case 'table':
                return this.getTableProps(node, path);
            case 'tableHeader':
            case 'tableRow':
                return this.getTableChildrenProps(node);
            case 'taskItem':
                return this.getTaskItemProps(node, path);
            case 'embedCard':
                return this.getEmbedCardProps(node, path);
            case 'blockCard':
                return this.getBlockCardProps(node, path);
            case 'expand':
                return this.getExpandProps(node, path);
            case 'unsupportedBlock':
            case 'unsupportedInline':
                return this.getUnsupportedContentProps(node);
            case 'codeBlock':
                return this.getCodeBlockProps(node);
            case 'panel':
                return this.getPanelProps(node);
            default:
                return this.getProps(node, path);
        }
    }
    serializeFragment(fragment, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    props = {}, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    target = this.allowSelectAllTrap ? (0, $lbGwd.DocWithSelectAllTrap) : (0, $lbGwd.default), key = 'root-0', parentInfo) {
        // This makes sure that we reset internal state on re-render.
        if (key === 'root-0') this.resetState();
        return this.renderNode(target, props, key, $2e23e48a41f0e258$export$2e2bcd8739ae039.getChildNodes(fragment).map((node, index)=>{
            if ((0, $lOeyo.isTextWrapper)(node)) return this.serializeTextWrapper(node.content, {
                index: index,
                parentInfo: parentInfo
            });
            return this.serializeFragmentChild(node, {
                index: index,
                parentInfo: parentInfo
            });
        }));
    }
    serializeTextWrapper(content, { index: index, parentInfo: parentInfo }) {
        const currentPath = parentInfo && parentInfo.path || [];
        const nodePosition = parentInfo && parentInfo.pos || 1;
        return $2e23e48a41f0e258$export$2e2bcd8739ae039.buildMarkStructure(content).map((mark, index)=>{
            return this.serializeMark({
                mark: mark,
                parentNode: {
                    path: currentPath,
                    pos: nodePosition
                },
                parentMark: {
                    path: [
                        mark
                    ]
                }
            });
        });
    }
    serializeMark({ mark: mark, parentNode: parentNode, parentMark: parentMark }) {
        if (!(0, $lOeyo.isTextNode)(mark)) {
            const serializeContent = (childMark, index)=>this.serializeMark({
                    mark: childMark,
                    parentNode: parentNode,
                    parentMark: {
                        path: [
                            ...parentMark.path,
                            childMark
                        ]
                    }
                });
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const content = (mark.content || []).map(serializeContent);
            const markKey = `${mark.type.name}-component__${this.startPos}__${parentMark.path.length}`;
            return this.renderMark((0, $QAAiN.toReact)(mark), this.getMarkProps(mark, parentMark.path), markKey, content);
        }
        const startPos = this.startPos;
        const endPos = startPos + mark.nodeSize;
        this.startPos = endPos;
        const textKey = `text-wrapper_${this.startPos}`;
        if (this.surroundTextNodesWithTextWrapper) {
            const parentDepth = Math.max(parentNode.path.length - 1, 0);
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fB6mC.default), {
                startPos: startPos + parentDepth,
                endPos: endPos + parentDepth,
                textHighlighter: this.textHighlighter,
                marks: mark.marks,
                children: mark.text
            }, textKey);
        }
        const segments = (0, $bRAXN.segmentText)(mark.text, this.textHighlighter);
        return (0, $7Uu7t.renderTextSegments)(segments, this.textHighlighter, mark.marks, startPos);
    }
    renderNode(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    NodeComponent, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    props, key, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    content) {
        return(// Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        /*#__PURE__*/ (0, $gt9Am.jsx)(NodeComponent, {
            ...props,
            children: content
        }, key));
    }
    renderMark(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    MarkComponent, props, key, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    content) {
        return(// Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        /*#__PURE__*/ (0, $gt9Am.jsx)(MarkComponent, {
            ...props,
            children: content
        }, key));
    }
    getTableChildrenProps(node) {
        return {
            ...this.getProps(node),
            allowColumnSorting: this.allowColumnSorting
        };
    }
    getTableProps(node, path = []) {
        const isInsideOfBlockNode = (0, $fftJQ.insideBlockNode)(path, node.type.schema);
        const isInsideMultiBodiedExtension = (0, $fftJQ.insideMultiBodiedExtension)(path, node.type.schema);
        const isInsideOfTable = (0, $fftJQ.insideTable)(path, node.type.schema);
        // TODO: CEMS-1048 - Support sticky headers inside breakout + layout
        const stickyHeaders = !isInsideOfTable && !(0, $fftJQ.insideBreakoutLayout)(path) ? this.stickyHeaders : undefined;
        return {
            ...this.getProps(node),
            allowColumnSorting: this.allowColumnSorting,
            columnWidths: (0, $bTpHi.getColumnWidths)(node),
            tableNode: node,
            stickyHeaders: stickyHeaders,
            isInsideOfBlockNode: isInsideOfBlockNode,
            isInsideOfTable: isInsideOfTable,
            isInsideMultiBodiedExtension: isInsideMultiBodiedExtension,
            allowTableAlignment: this.allowTableAlignment,
            allowTableResizing: this.allowTableResizing,
            isPresentational: (0, $eGOwo.fg)('platform_renderer_isPresentational') ? this.isPresentational : false,
            disableTableOverflowShadow: this.disableTableOverflowShadow
        };
    }
    getDateProps(node, parentInfo, path = []) {
        return {
            timestamp: node.attrs && node.attrs.timestamp,
            parentIsIncompleteTask: parentInfo && parentInfo.parentIsIncompleteTask,
            dataAttributes: {
                // We need to account for depth (path.length gives up depth) here
                // but depth doesnt increment the pos, only accounted for.
                'data-renderer-start-pos': this.startPos + path.length
            }
        };
    }
    getMediaSingleProps(node, path = []) {
        const { marks: { link: link } } = node.type.schema;
        const isInsideOfBlockNode = (0, $fftJQ.insideBlockNode)(path, node.type.schema);
        const isLinkMark = (mark)=>mark.type === link;
        const childHasLink = node.firstChild && node.firstChild.marks.filter((m)=>isLinkMark(m) || this.allowMediaLinking === true).length;
        return {
            ...this.getProps(node, path),
            isInsideOfBlockNode: isInsideOfBlockNode,
            childHasLink: childHasLink,
            allowCaptions: this.media && this.media.allowCaptions,
            featureFlags: this.media && this.media.featureFlags
        };
    }
    getMediaProps(node, path = []) {
        const { marks: { annotation: annotation, link: link, border: border } } = node.type.schema;
        const isChildOfMediaSingle = path.some((n)=>n.type?.name === 'mediaSingle');
        const isAnnotationMark = (mark)=>mark.type === annotation;
        const isLinkMark = (mark)=>mark.type === link;
        const isBorderMark = (mark)=>isChildOfMediaSingle && mark.type === border;
        return {
            ...this.getProps(node, path),
            marks: node.marks.filter((m)=>!isLinkMark(m) || this.allowMediaLinking === true),
            isLinkMark: isLinkMark,
            isBorderMark: isBorderMark,
            isAnnotationMark: isAnnotationMark,
            allowAltTextOnImages: this.allowAltTextOnImages,
            featureFlags: this.media && this.media.featureFlags,
            shouldOpenMediaViewer: this.shouldOpenMediaViewer,
            ssr: this.media?.ssr,
            // surroundTextNodesWithTextWrapper checks inlineComment.allowDraftMode
            allowAnnotationsDraftMode: this.surroundTextNodesWithTextWrapper
        };
    }
    getExtensionProps(node, path = []) {
        return {
            ...this.getProps(node, path),
            extensionViewportSizes: this.extensionViewportSizes
        };
    }
    getEmojiProps(node) {
        return {
            ...this.getProps(node),
            resourceConfig: this.emojiResourceConfig
        };
    }
    getEmbedCardProps(node, path = []) {
        const isInsideOfBlockNode = (0, $fftJQ.insideBlockNode)(path, node.type.schema);
        return {
            ...this.getProps(node),
            isInsideOfBlockNode: isInsideOfBlockNode
        };
    }
    getBlockCardProps(node, path = []) {
        return {
            ...this.getProps(node),
            isNodeNested: path.length > 0
        };
    }
    getMediaGroupProps(node) {
        return {
            ...this.getProps(node),
            shouldOpenMediaViewer: this.shouldOpenMediaViewer,
            allowAltTextOnImages: this.allowAltTextOnImages,
            featureFlags: this.media && this.media.featureFlags,
            enableDownloadButton: this.media?.enableDownloadButton,
            ssr: this.media?.ssr
        };
    }
    getMediaInlineProps(node) {
        return {
            ...this.getProps(node),
            ssr: this.media?.ssr
        };
    }
    getTaskItemProps(node, path = []) {
        return {
            ...this.getProps(node, path),
            disabled: this.disableActions
        };
    }
    getHardBreakProps(node, path = []) {
        let forceNewLine = false;
        const parentNode = path.length > 0 ? path[path.length - 1] : null;
        if (parentNode && parentNode.lastChild === node) forceNewLine = true;
        return {
            ...this.getProps(node),
            forceNewLine: forceNewLine
        };
    }
    getCodeBlockProps(node) {
        // The appearance being mobile indicates we are in an renderer being
        // rendered by mobile bridge in a web view.
        // The tooltip is likely to have unexpected behaviour there, with being cut
        // off, so we disable it. This is also to keep the behaviour consistent with
        // the rendering in the mobile Native Renderer.
        const codeBidiWarningTooltipEnabled = false;
        return {
            ...this.getProps(node),
            text: node.textContent,
            codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
        };
    }
    getPanelProps(node) {
        return {
            ...this.getProps(node),
            allowCustomPanels: this.allowCustomPanels
        };
    }
    getProps(node, path = []) {
        const startPos = this.startPos + path.length;
        return {
            text: node.text,
            providers: this.providers,
            eventHandlers: this.eventHandlers,
            extensionHandlers: this.extensionHandlers,
            portal: this.portal,
            rendererContext: this.rendererContext,
            serializer: this,
            content: node.content ? node.content.toJSON() : undefined,
            allowHeadingAnchorLinks: this.allowHeadingAnchorLinks,
            allowCopyToClipboard: this.allowCopyToClipboard,
            allowWrapCodeBlock: this.allowWrapCodeBlock,
            allowPlaceholderText: this.allowPlaceholderText,
            rendererAppearance: this.appearance,
            fireAnalyticsEvent: this.fireAnalyticsEvent,
            nodeType: node.type.name,
            marks: node.marks,
            smartLinks: this.smartLinks,
            isInsideOfInlineExtension: this.isInsideOfInlineExtension,
            dataAttributes: {
                // We need to account for depth (path.length gives up depth) here
                // but depth doesnt increment the pos, only accounted for.
                'data-renderer-start-pos': startPos
            },
            startPos: startPos,
            path: path,
            ...node.attrs
        };
    }
    headingAnchorSupported(path = []) {
        const isImmediateParent = (path, nodeName)=>{
            return path.length > 0 && path[path.length - 1].type.name === nodeName;
        };
        return (0, $iOvh6.isNestedHeaderLinksEnabled)(this.allowHeadingAnchorLinks) || path.length === 0 || isImmediateParent(path, 'layoutColumn');
    }
    getHeadingProps(node, path = []) {
        return {
            ...this.getProps(node, path),
            content: node.content ? node.content.toJSON() : undefined,
            headingId: this.getHeadingId(node, this.headingIds),
            showAnchorLink: this.appearance !== 'comment' && this.allowHeadingAnchorLinks && !this.disableHeadingIDs && this.headingAnchorSupported(path)
        };
    }
    getExpandProps(node, path = []) {
        if (!(0, $iOvh6.isNestedHeaderLinksEnabled)(this.allowHeadingAnchorLinks)) return this.getProps(node);
        const nestedHeaderIds = (0, $BmspC.findChildrenByType)(node, node.type.schema.nodes.heading).map(({ node: node })=>this.getHeadingId(node, this.expandHeadingIds));
        return {
            ...this.getProps(node),
            nestedHeaderIds: nestedHeaderIds
        };
    }
    // The return value of this function is NOT url encoded,
    // In HTML5 standard, id can contain any characters, encoding is no necessary.
    // Plus we trying to avoid double encoding, therefore we leave the value as is.
    // Remember to use encodeURIComponent when generating url from the id value.
    getHeadingId(node, headingIds) {
        if (this.disableHeadingIDs || !node.content.size) return;
        // We are not use node.textContent here, because we would like to handle cases where
        // headings only contain inline blocks like emoji, status and date.
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const nodeContent = node.content.toJSON()// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .reduce((acc, node)=>acc.concat((0, $g9wjI.getText)(node) || ''), '').trim()// Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        .replace(/\s/g, '-');
        if (!nodeContent) return;
        return this.getUniqueHeadingId(nodeContent, headingIds);
    }
    getUniqueHeadingId(baseId, headingIds, counter = 0) {
        if (counter === 0 && headingIds.indexOf(baseId) === -1) {
            headingIds.push(baseId);
            return baseId;
        } else if (counter !== 0) {
            const headingId = `${baseId}.${counter}`;
            if (headingIds.indexOf(headingId) === -1) {
                headingIds.push(headingId);
                return headingId;
            }
        }
        return this.getUniqueHeadingId(baseId, headingIds, ++counter);
    }
    static getChildNodes(fragment) {
        const children = [];
        fragment.forEach((node)=>{
            children.push(node);
        });
        return (0, $lOeyo.mergeTextNodes)(children);
    }
    static getMarks(node) {
        if (!node.marks || node.marks.length === 0) return [];
        return (0, $cRsRn.getMarksByOrder)(node.marks);
    }
    static buildMarkStructure(content) {
        return $2e23e48a41f0e258$var$mergeMarks(content.map((node)=>{
            const nodeMarks = this.getMarks(node);
            if (nodeMarks.length === 0) return node;
            return nodeMarks.reverse().reduce((acc, mark)=>{
                const { eq: eq } = mark;
                return {
                    ...mark,
                    eq: eq,
                    content: [
                        acc
                    ]
                };
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            }, node);
        }));
    }
    // TODO: ED-9004 - Remove unused ReactSerializer.fromSchema in renderer
    // https://sourcegraph-frontend.internal.shared-prod.us-west-2.kitt-inf.net/search?q=ReactSerializer.fromSchema&patternType=literal
    static fromSchema(_, init) {
        return new $2e23e48a41f0e258$export$2e2bcd8739ae039(init);
    }
}

});
parcelRegister("iOvh6", function(module, exports) {

$parcel$export(module.exports, "isNestedHeaderLinksEnabled", () => $8e65b6dd74371a42$export$7aa7587d1ce9583c);
$parcel$export(module.exports, "getActiveHeadingId", () => $8e65b6dd74371a42$export$acb253d79d72af92);
function $8e65b6dd74371a42$export$7aa7587d1ce9583c(allowHeadingAnchorLinks) {
    // If it's a boolean or undefined, then we don't support nesting.
    if (!allowHeadingAnchorLinks || typeof allowHeadingAnchorLinks === 'boolean') return false;
    const { allowNestedHeaderLinks: allowNestedHeaderLinks } = allowHeadingAnchorLinks;
    // Explicit cast to a boolean to cover scenario where it's undefined.
    return !!allowNestedHeaderLinks;
}
function $8e65b6dd74371a42$export$acb253d79d72af92(allowHeadingAnchorLinks) {
    if (!$8e65b6dd74371a42$export$7aa7587d1ce9583c(allowHeadingAnchorLinks)) return undefined;
    return allowHeadingAnchorLinks.activeHeadingId;
}

});

parcelRegister("lOeyo", function(module, exports) {

$parcel$export(module.exports, "InlineCard", () => $c1924200614751bb$export$aff6291803939b05);
$parcel$export(module.exports, "nodeToReact", () => $c1924200614751bb$export$3931063f6a5f290e);
$parcel$export(module.exports, "toReact", () => $c1924200614751bb$export$d4334b129116aad7);
$parcel$export(module.exports, "mergeTextNodes", () => $c1924200614751bb$export$8045509d14b5046f);
$parcel$export(module.exports, "isTextWrapper", () => $c1924200614751bb$export$d4ebd3557ee7fac1);
$parcel$export(module.exports, "isTextNode", () => $c1924200614751bb$export$ccbedd67ef6e9417);
$parcel$export(module.exports, "Doc", () => (parcelRequire("lbGwd")).default);
$parcel$export(module.exports, "DocWithSelectAllTrap", () => (parcelRequire("lbGwd")).DocWithSelectAllTrap);
/* eslint-disable @atlaskit/editor/no-re-export */ // Mapping file

var $joSn0 = parcelRequire("joSn0");

var $93FVZ = parcelRequire("93FVZ");
var $dfCRV = parcelRequire("dfCRV");

var $eGOwo = parcelRequire("eGOwo");

var $jduyI = parcelRequire("jduyI");

var $fNF2S = parcelRequire("fNF2S");

var $bDynL = parcelRequire("bDynL");

var $9DR0p = parcelRequire("9DR0p");

var $gzcAo = parcelRequire("gzcAo");

var $53tmQ = parcelRequire("53tmQ");

var $lbGwd = parcelRequire("lbGwd");

var $fsEil = parcelRequire("fsEil");

var $3OwO2 = parcelRequire("3OwO2");

var $5v0qs = parcelRequire("5v0qs");

var $dnybp = parcelRequire("dnybp");

var $j3a3j = parcelRequire("j3a3j");

var $5YAb6 = parcelRequire("5YAb6");

var $lLYaS = parcelRequire("lLYaS");

var $9WY2n = parcelRequire("9WY2n");

var $fF9eS = parcelRequire("fF9eS");

var $lwXex = parcelRequire("lwXex");

var $gtUUa = parcelRequire("gtUUa");

var $aYUex = parcelRequire("aYUex");

var $idsFq = parcelRequire("idsFq");

var $lzf9g = parcelRequire("lzf9g");

var $eACId = parcelRequire("eACId");

var $eoMJq = parcelRequire("eoMJq");

const $c1924200614751bb$export$a22ee8f907eecb5f = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("dcc5P")).then((mod)=>mod.default),
    loading: ()=>null
});

const $c1924200614751bb$export$6c415d1fdae3dfdb = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("5JvF6")).then((mod)=>mod.default),
    loading: ()=>null
});

const $c1924200614751bb$export$771a55a10b0a40ae = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("e0VbS")).then((mod)=>mod.default),
    loading: ()=>null
});

const $c1924200614751bb$export$27c4189b8be1bf93 = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("2XR3X")).then((mod)=>mod.default),
    loading: ()=>null
});

const $c1924200614751bb$export$b458dfa720128865 = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("cRokE")).then((mod)=>mod.default),
    loading: ()=>null
});

const $c1924200614751bb$export$b6f73a2b0b0de599 = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("8uCPq")).then((mod)=>mod.default),
    loading: ()=>null
});

const $c1924200614751bb$export$6341f9a885713487 = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("bBs2k")).then((mod)=>mod.default),
    loading: ()=>null
});

const $c1924200614751bb$export$96e9906d6d93a972 = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("5mDbU")).then((mod)=>mod.default),
    loading: ()=>null
});

const $c1924200614751bb$export$56cc48506ff790a = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("lNpN3")).then((mod)=>mod.default),
    loading: ()=>null
});

const $c1924200614751bb$export$2ddb90ad54e5f587 = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("gIrm0")).then((mod)=>mod.default),
    loading: ()=>null
});

const $c1924200614751bb$export$6789d7ecdc77631b = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("l4dZQ")).then((mod)=>mod.default),
    loading: ()=>null
});

const $c1924200614751bb$export$aff6291803939b05 = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("jtlbv")).then((mod)=>mod.default),
    loading: ()=>null
});

const $c1924200614751bb$export$d18ccd25c0d2c6b0 = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("lk57E")).then((mod)=>mod.default),
    loading: ()=>null
});

const $c1924200614751bb$export$7fc53215244aec38 = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("gFtpo")).then((mod)=>mod.default),
    loading: ()=>null
});

const $c1924200614751bb$export$d7858be3df00d59 = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("dd8Sn")).then((mod)=>mod.default),
    loading: ()=>null
});

const $c1924200614751bb$export$462ea7c2a1c4cb1f = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("jeFNX")).then((mod)=>mod.default),
    loading: ()=>null
});

const $c1924200614751bb$export$888d74bc001c3a5d = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("3woGh")).then((mod)=>mod.default),
    loading: ()=>null
});

const $c1924200614751bb$export$e891316fea657d90 = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("jDPm9")).then((mod)=>mod.default),
    loading: ()=>null
});

const $c1924200614751bb$export$49bd1dfb0ad29c40 = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("cmA9s")).then((mod)=>mod.default),
    loading: ()=>null
});
const $c1924200614751bb$export$3931063f6a5f290e = {
    blockquote: (0, $jduyI.default),
    bulletList: (0, $53tmQ.default),
    blockCard: $c1924200614751bb$export$d18ccd25c0d2c6b0,
    caption: (0, $9WY2n.default),
    date: $c1924200614751bb$export$6341f9a885713487,
    decisionItem: $c1924200614751bb$export$b6f73a2b0b0de599,
    decisionList: $c1924200614751bb$export$b458dfa720128865,
    doc: (0, $lbGwd.default),
    emoji: $c1924200614751bb$export$56cc48506ff790a,
    extension: (0, $fsEil.default),
    bodiedExtension: (0, $fNF2S.default),
    multiBodiedExtension: (0, $9DR0p.default),
    extensionFrame: (0, $gzcAo.default),
    hardBreak: (0, $3OwO2.default),
    heading: (0, $5v0qs.default),
    inlineCard: $c1924200614751bb$export$aff6291803939b05,
    inlineExtension: (0, $dnybp.default),
    layoutSection: (0, $j3a3j.default),
    layoutColumn: (0, $5YAb6.default),
    listItem: (0, $lLYaS.default),
    media: $c1924200614751bb$export$7fc53215244aec38,
    mediaGroup: $c1924200614751bb$export$d7858be3df00d59,
    mediaInline: $c1924200614751bb$export$462ea7c2a1c4cb1f,
    mediaSingle: $c1924200614751bb$export$888d74bc001c3a5d,
    mention: $c1924200614751bb$export$e891316fea657d90,
    orderedList: (0, $fF9eS.default),
    panel: $c1924200614751bb$export$2ddb90ad54e5f587,
    paragraph: (0, $lwXex.default),
    placeholder: (0, $gtUUa.default),
    rule: (0, $aYUex.default),
    status: $c1924200614751bb$export$96e9906d6d93a972,
    taskItem: $c1924200614751bb$export$27c4189b8be1bf93,
    taskList: $c1924200614751bb$export$771a55a10b0a40ae,
    table: (0, $idsFq.default),
    tableCell: (0, $lzf9g.TableCell),
    tableHeader: (0, $lzf9g.TableHeader),
    tableRow: (0, $eACId.default),
    unknownBlock: (0, $eoMJq.default),
    unsupportedBlock: (0, $93FVZ.default),
    unsupportedInline: (0, $dfCRV.default),
    expand: $c1924200614751bb$export$49bd1dfb0ad29c40,
    nestedExpand: $c1924200614751bb$export$49bd1dfb0ad29c40,
    embedCard: $c1924200614751bb$export$6789d7ecdc77631b
};
const $c1924200614751bb$export$d4334b129116aad7 = (node, flags, nodeComponents)=>{
    if (node.type.name === 'doc' && flags?.allowSelectAllTrap === true) return 0, $lbGwd.DocWithSelectAllTrap;
    if (node.type.name === 'codeBlock') {
        if (flags?.allowWindowedCodeBlock === true) return $c1924200614751bb$export$a22ee8f907eecb5f;
        return $c1924200614751bb$export$6c415d1fdae3dfdb;
    }
    // Allowing custom components to override those provided in nodeToReact
    const nodes = {
        ...$c1924200614751bb$export$3931063f6a5f290e,
        ...nodeComponents
    };
    nodes['multiBodiedExtension'] = (0, $eGOwo.fg)('platform_editor_multi_body_extension_extensibility') ? (0, $9DR0p.default) : (0, $bDynL.default);
    return nodes[node.type.name];
};
const $c1924200614751bb$export$8045509d14b5046f = (nodes)=>{
    return nodes.reduce((acc, current)=>{
        if (!$c1924200614751bb$export$1879817ac5c922b7(current.type.name)) {
            acc.push(current);
            return acc;
        }
        // Append node to previous node, if it was a text wrapper
        if (acc.length > 0 && $c1924200614751bb$export$d4ebd3557ee7fac1(acc[acc.length - 1])) {
            const textWrapper = acc[acc.length - 1];
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            textWrapper.content.push(current);
            textWrapper.nodeSize += current.nodeSize;
        } else acc.push({
            type: {
                name: 'textWrapper'
            },
            content: [
                current
            ],
            nodeSize: current.nodeSize
        });
        return acc;
    }, []);
};
const $c1924200614751bb$export$1879817ac5c922b7 = (type)=>{
    return type === 'text';
};
const $c1924200614751bb$export$d4ebd3557ee7fac1 = (node)=>{
    return node.type.name === 'textWrapper';
};
function $c1924200614751bb$export$ccbedd67ef6e9417(node) {
    return node.type.name === 'text';
}
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $c1924200614751bb$var$whitespaceRegex = /^\s*$/;
const $c1924200614751bb$export$dd0c7365db1f79a5 = (doc)=>{
    if (doc.childCount !== 1) return false;
    const parentNodes = [];
    doc.forEach((child)=>parentNodes.push(child));
    const node = parentNodes[0];
    return node.type.name === 'paragraph' && $c1924200614751bb$var$isEmojiBlock(node.content);
};
const $c1924200614751bb$var$isEmojiBlock = (pnode)=>{
    const content = [];
    // Optimisation for long documents - worst case block will be space-emoji-space
    if (pnode.childCount > 7) return false;
    pnode.forEach((child)=>content.push(child));
    let emojiCount = 0;
    for(let i = 0; i < content.length; ++i){
        const node = content[i];
        switch(node.type.name){
            case 'text':
                if (node.text && !node.text.match($c1924200614751bb$var$whitespaceRegex)) return false;
                continue;
            case 'emoji':
                if (++emojiCount > 3) return false;
                continue;
            default:
                // Only text and emoji nodes are allowed
                return false;
        }
    }
    return emojiCount > 0;
};

});
parcelRegister("joSn0", function(module, exports) {
"use strict";
var $e1fa6eff9b7fbc13$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
function $e1fa6eff9b7fbc13$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e1fa6eff9b7fbc13$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $e1fa6eff9b7fbc13$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var $eJOHy = parcelRequire("eJOHy");

var $cT3Ey = parcelRequire("cT3Ey");
var $e1fa6eff9b7fbc13$var$ALL_INITIALIZERS = [];
var $e1fa6eff9b7fbc13$var$READY_INITIALIZERS = [];
function $e1fa6eff9b7fbc13$var$isWebpackReady(getModuleIds) {
    if ((typeof __webpack_modules__ === "undefined" ? "undefined" : $e1fa6eff9b7fbc13$var$_typeof(__webpack_modules__)) !== "object") return false;
    return getModuleIds().every(function(moduleId) {
        return typeof moduleId !== "undefined" && typeof __webpack_modules__[moduleId] !== "undefined";
    });
}
function $e1fa6eff9b7fbc13$var$load(loader) {
    var promise = loader();
    var state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then(function(loaded) {
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch(function(err) {
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function $e1fa6eff9b7fbc13$var$loadMap(obj) {
    var state = {
        loading: false,
        loaded: {},
        error: null
    };
    var promises = [];
    try {
        Object.keys(obj).forEach(function(key) {
            var result = $e1fa6eff9b7fbc13$var$load(obj[key]);
            if (!result.loading) {
                state.loaded[key] = result.loaded;
                state.error = result.error;
            } else state.loading = true;
            promises.push(result.promise);
            result.promise.then(function(res) {
                state.loaded[key] = res;
            }).catch(function(err) {
                state.error = err;
            });
        });
    } catch (err) {
        state.error = err;
    }
    state.promise = Promise.all(promises).then(function(res) {
        state.loading = false;
        return res;
    }).catch(function(err) {
        state.loading = false;
        throw err;
    });
    return state;
}
function $e1fa6eff9b7fbc13$var$resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function $e1fa6eff9b7fbc13$var$render(loaded, props) {
    return $eJOHy.createElement($e1fa6eff9b7fbc13$var$resolve(loaded), props);
}
function $e1fa6eff9b7fbc13$var$createLoadableComponent(loadFn, options) {
    var _class, _temp;
    if (!options.loading) throw new Error("react-loadable requires a `loading` component");
    var opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        render: $e1fa6eff9b7fbc13$var$render,
        webpack: null,
        modules: null
    }, options);
    var res = null;
    function init() {
        if (!res) res = loadFn(opts.loader);
        return res.promise;
    }
    $e1fa6eff9b7fbc13$var$ALL_INITIALIZERS.push(init);
    if (typeof opts.webpack === "function") $e1fa6eff9b7fbc13$var$READY_INITIALIZERS.push(function() {
        if ($e1fa6eff9b7fbc13$var$isWebpackReady(opts.webpack)) return init();
    });
    return _temp = _class = function(_React$Component) {
        $e1fa6eff9b7fbc13$var$_inherits(LoadableComponent, _React$Component);
        function LoadableComponent(props) {
            $e1fa6eff9b7fbc13$var$_classCallCheck(this, LoadableComponent);
            var _this = $e1fa6eff9b7fbc13$var$_possibleConstructorReturn(this, _React$Component.call(this, props));
            _this.retry = function() {
                _this.setState({
                    error: null,
                    loading: true,
                    timedOut: false
                });
                res = loadFn(opts.loader);
                _this._loadModule();
            };
            init();
            _this.state = {
                error: res.error,
                pastDelay: false,
                timedOut: false,
                loading: res.loading,
                loaded: res.loaded
            };
            return _this;
        }
        LoadableComponent.preload = function preload() {
            return init();
        };
        LoadableComponent.prototype.componentWillMount = function componentWillMount() {
            this._mounted = true;
            this._loadModule();
        };
        LoadableComponent.prototype._loadModule = function _loadModule() {
            var _this2 = this;
            if (this.context.loadable && Array.isArray(opts.modules)) opts.modules.forEach(function(moduleName) {
                _this2.context.loadable.report(moduleName);
            });
            if (!res.loading) return;
            if (typeof opts.delay === "number") {
                if (opts.delay === 0) this.setState({
                    pastDelay: true
                });
                else this._delay = setTimeout(function() {
                    _this2.setState({
                        pastDelay: true
                    });
                }, opts.delay);
            }
            if (typeof opts.timeout === "number") this._timeout = setTimeout(function() {
                _this2.setState({
                    timedOut: true
                });
            }, opts.timeout);
            var update = function update() {
                if (!_this2._mounted) return;
                _this2.setState({
                    error: res.error,
                    loaded: res.loaded,
                    loading: res.loading
                });
                _this2._clearTimeouts();
            };
            res.promise.then(function() {
                update();
            }).catch(function(err) {
                update();
            });
        };
        LoadableComponent.prototype.componentWillUnmount = function componentWillUnmount() {
            this._mounted = false;
            this._clearTimeouts();
        };
        LoadableComponent.prototype._clearTimeouts = function _clearTimeouts() {
            clearTimeout(this._delay);
            clearTimeout(this._timeout);
        };
        LoadableComponent.prototype.render = function render() {
            if (this.state.loading || this.state.error) return $eJOHy.createElement(opts.loading, {
                isLoading: this.state.loading,
                pastDelay: this.state.pastDelay,
                timedOut: this.state.timedOut,
                error: this.state.error,
                retry: this.retry
            });
            else if (this.state.loaded) return opts.render(this.state.loaded, this.props);
            else return null;
        };
        return LoadableComponent;
    }($eJOHy.Component), _class.contextTypes = {
        loadable: $cT3Ey.shape({
            report: $cT3Ey.func.isRequired
        })
    }, _temp;
}
function $e1fa6eff9b7fbc13$var$Loadable(opts) {
    return $e1fa6eff9b7fbc13$var$createLoadableComponent($e1fa6eff9b7fbc13$var$load, opts);
}
function $e1fa6eff9b7fbc13$var$LoadableMap(opts) {
    if (typeof opts.render !== "function") throw new Error("LoadableMap requires a `render(loaded, props)` function");
    return $e1fa6eff9b7fbc13$var$createLoadableComponent($e1fa6eff9b7fbc13$var$loadMap, opts);
}
$e1fa6eff9b7fbc13$var$Loadable.Map = $e1fa6eff9b7fbc13$var$LoadableMap;
var $e1fa6eff9b7fbc13$var$Capture = function(_React$Component2) {
    $e1fa6eff9b7fbc13$var$_inherits(Capture, _React$Component2);
    function Capture() {
        $e1fa6eff9b7fbc13$var$_classCallCheck(this, Capture);
        return $e1fa6eff9b7fbc13$var$_possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
    }
    Capture.prototype.getChildContext = function getChildContext() {
        return {
            loadable: {
                report: this.props.report
            }
        };
    };
    Capture.prototype.render = function render() {
        return $eJOHy.Children.only(this.props.children);
    };
    return Capture;
}($eJOHy.Component);
$e1fa6eff9b7fbc13$var$Capture.propTypes = {
    report: $cT3Ey.func.isRequired
};
$e1fa6eff9b7fbc13$var$Capture.childContextTypes = {
    loadable: $cT3Ey.shape({
        report: $cT3Ey.func.isRequired
    }).isRequired
};
$e1fa6eff9b7fbc13$var$Loadable.Capture = $e1fa6eff9b7fbc13$var$Capture;
function $e1fa6eff9b7fbc13$var$flushInitializers(initializers) {
    var promises = [];
    while(initializers.length){
        var init = initializers.pop();
        promises.push(init());
    }
    return Promise.all(promises).then(function() {
        if (initializers.length) return $e1fa6eff9b7fbc13$var$flushInitializers(initializers);
    });
}
$e1fa6eff9b7fbc13$var$Loadable.preloadAll = function() {
    return new Promise(function(resolve, reject) {
        $e1fa6eff9b7fbc13$var$flushInitializers($e1fa6eff9b7fbc13$var$ALL_INITIALIZERS).then(resolve, reject);
    });
};
$e1fa6eff9b7fbc13$var$Loadable.preloadReady = function() {
    return new Promise(function(resolve, reject) {
        // We always will resolve, errors should be handled within loading UIs.
        $e1fa6eff9b7fbc13$var$flushInitializers($e1fa6eff9b7fbc13$var$READY_INITIALIZERS).then(resolve, resolve);
    });
};
module.exports = $e1fa6eff9b7fbc13$var$Loadable;

});

parcelRegister("dfCRV", function(module, exports) {

$parcel$export(module.exports, "default", () => $e072a79986bfd933$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $6YFG2 = parcelRequire("6YFG2");

var $7yBx7 = parcelRequire("7yBx7");

var $k9Gmz = parcelRequire("k9Gmz");

var $k71qx = parcelRequire("k71qx");

var $bMFKb = parcelRequire("bMFKb");

var $gPpAv = parcelRequire("gPpAv");

var $3mTkR = parcelRequire("3mTkR");

var $z9Bay = parcelRequire("z9Bay");
const $e072a79986bfd933$var$inlineNodeStyle = /*#__PURE__*/ (0, $1NIU8.css)({
    alignItems: 'center',
    background: "var(--ds-background-disabled, #091E4208)",
    border: `1px dashed ${"var(--ds-border-disabled, #091E420F)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: "var(--ds-border-radius, 3px)",
    boxSizing: 'border-box',
    cursor: 'default',
    display: 'inline-flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: (0, $7yBx7.relativeFontSizeToBase16)(14),
    margin: `0 ${"var(--ds-space-025, 2px)"}`,
    minHeight: '24px',
    padding: `0 ${"var(--ds-space-100, 8px)"}`,
    verticalAlign: 'middle',
    whiteSpace: 'nowrap'
});
const $e072a79986bfd933$var$UnsupportedInlineNode = ({ node: node, intl: intl, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
    const message = (0, $z9Bay.getUnsupportedContent)((0, $gPpAv.unsupportedContentMessages).unsupportedInlineContent, 'Unsupported', node, intl);
    const tooltipContent = intl.formatMessage((0, $gPpAv.unsupportedContentMessages).unsupportedContentTooltip);
    const { current: style } = (0, $eJOHy.useRef)({
        padding: '4px'
    });
    const originalNodeType = node?.attrs.originalValue.type;
    const tooltipOnShowHandler = (0, $eJOHy.useCallback)(()=>dispatchAnalyticsEvent && (0, $3mTkR.trackUnsupportedContentTooltipDisplayedFor)(dispatchAnalyticsEvent, (0, $bMFKb.ACTION_SUBJECT_ID).ON_UNSUPPORTED_INLINE, originalNodeType), [
        dispatchAnalyticsEvent,
        originalNodeType
    ]);
    return /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        css: $e072a79986bfd933$var$inlineNodeStyle
    }, message, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $k71qx.default), {
        content: tooltipContent,
        hideTooltipOnClick: false,
        position: "bottom",
        onShow: tooltipOnShowHandler,
        strategy: "absolute"
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        style: style
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($k9Gmz))), {
        label: "?",
        LEGACY_size: "small"
    }))));
};
var $e072a79986bfd933$export$2e2bcd8739ae039 = (0, $6YFG2.default)($e072a79986bfd933$var$UnsupportedInlineNode);

});

parcelRegister("jduyI", function(module, exports) {

$parcel$export(module.exports, "default", () => $74062e18b3abf97d$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
function $74062e18b3abf97d$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)("blockquote", {
        children: props.children
    });
}

});

parcelRegister("fNF2S", function(module, exports) {

$parcel$export(module.exports, "default", () => $4efcd8b6a9f6e056$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $fsEil = parcelRequire("fsEil");

var $7DXmb = parcelRequire("7DXmb");

var $cZRB0 = parcelRequire("cZRB0");

var $ex5uO = parcelRequire("ex5uO");

var $bMFKb = parcelRequire("bMFKb");

var $csUn2 = parcelRequire("csUn2");

var $2uPUs = parcelRequire("2uPUs");

var $eGOwo = parcelRequire("eGOwo");
const $4efcd8b6a9f6e056$var$ValidationContextWrapper = ({ children: children })=>{
    // We override validation of nested tables in nested renderers as invalid ADF (but valid Prosemirror)
    // may have been introduced in the parent renderer's render and subsequent transformations.
    // For example - nested tables which are transformed from an extension node in ADF
    // to native Prosemirror nested table nodes in and this is invalid ADF.
    const validationContextValue = (0, $eJOHy.useMemo)(()=>({
            allowNestedTables: true
        }), []);
    if (!(0, $eGOwo.fg)('platform_editor_nested_table_extension_comment_fix')) return children;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2uPUs.ValidationContextProvider), {
        value: validationContextValue,
        children: children
    });
};
const $4efcd8b6a9f6e056$var$BodiedExtension = (props)=>{
    const { children: children, layout: layout = 'default', path: path = [], extensionKey: extensionKey, extensionType: extensionType, parameters: parameters, extensionViewportSizes: extensionViewportSizes } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const removeOverflow = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.toArray(children)// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .map((child)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(child) ? child.props.nodeType === 'table' : false).every(Boolean);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7DXmb.ErrorBoundary), {
        component: (0, $ex5uO.ACTION_SUBJECT).RENDERER,
        componentId: (0, $bMFKb.ACTION_SUBJECT_ID).EXTENSION_BODIED,
        createAnalyticsEvent: createAnalyticsEvent,
        additionalInfo: `${extensionType}: ${extensionKey} `,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $csUn2.AnnotationsPositionContext).Provider, {
            value: {
                startPos: props.startPos + 1
            },
            children: /*#__PURE__*/ (0, $gt9Am.jsx)($4efcd8b6a9f6e056$var$ValidationContextWrapper, {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cZRB0.default), {
                    ...props,
                    type: "bodiedExtension",
                    children: ({ result: result })=>{
                        try {
                            if (result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(result)) // Return the content directly if it's a valid JSX.Element
                            return (0, $fsEil.renderExtension)(result, layout, {
                                isTopLevel: path.length < 1
                            }, removeOverflow, parameters?.extensionId, extensionViewportSizes);
                        } catch (e) {
                        /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
                        // Always return default content if anything goes wrong
                        return (0, $fsEil.renderExtension)(children, layout, {
                            isTopLevel: path.length < 1
                        }, removeOverflow, parameters?.extensionId, extensionViewportSizes);
                    }
                })
            })
        })
    });
};
var $4efcd8b6a9f6e056$export$2e2bcd8739ae039 = $4efcd8b6a9f6e056$var$BodiedExtension;

});
parcelRegister("fsEil", function(module, exports) {

$parcel$export(module.exports, "renderExtension", () => $ad9414b9d01e2717$export$b7482bdc8aff85e4);
$parcel$export(module.exports, "default", () => $ad9414b9d01e2717$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $cZRB0 = parcelRequire("cZRB0");

var $k6yTf = parcelRequire("k6yTf");
var $2bEPZ = parcelRequire("2bEPZ");

var $bnh3n = parcelRequire("bnh3n");

var $iRC0e = parcelRequire("iRC0e");
const $ad9414b9d01e2717$var$viewportSizes = [
    'small',
    'medium',
    'default',
    'large',
    'xlarge'
];
// Mirrors sizes from https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/browse/platform/packages/forge/xen-editor-provider/src/render/renderers/ForgeUIExtension.tsx
const $ad9414b9d01e2717$var$macroHeights = {
    small: '112px',
    medium: '262px',
    default: '262px',
    large: '524px',
    xlarge: '1048px'
};
const $ad9414b9d01e2717$var$getViewportSize = (extensionId, extensionViewportSizes)=>{
    if (!Array.isArray(extensionViewportSizes) || !extensionId) return;
    const extension = extensionViewportSizes.find((extension)=>extension.extensionId === extensionId);
    if (extension) {
        const viewportSize = extension.viewportSize && $ad9414b9d01e2717$var$viewportSizes.includes(extension.viewportSize) ? extension.viewportSize : 'default';
        return $ad9414b9d01e2717$var$macroHeights[viewportSize];
    }
};
const $ad9414b9d01e2717$export$b7482bdc8aff85e4 = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
content, layout, options = {}, removeOverflow, extensionId, extensionViewportSizes)=>{
    const overflowContainerClass = !removeOverflow ? (0, $iRC0e.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER : '';
    // by default, we assume the extension is at top level, (direct child of doc node)
    const { isTopLevel: isTopLevel = true } = options || {};
    const centerAlignClass = isTopLevel && [
        'wide',
        'full-width'
    ].includes(layout) ? (0, $iRC0e.RendererCssClassName).EXTENSION_CENTER_ALIGN : '';
    const viewportSize = $ad9414b9d01e2717$var$getViewportSize(extensionId, extensionViewportSizes);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2bEPZ.WidthConsumer), {
        children: ({ width: width })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                ref: options.handleRef,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: `${(0, $iRC0e.RendererCssClassName).EXTENSION} ${options.shadowClassNames} ${centerAlignClass}`,
                style: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    width: isTopLevel ? (0, $bnh3n.calcBreakoutWidth)(layout, width) : '100%',
                    minHeight: viewportSize
                },
                "data-layout": layout,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    className: overflowContainerClass,
                    children: content
                })
            })
    });
};
const $ad9414b9d01e2717$var$Extension = (props)=>{
    const { text: text, layout: layout = 'default', handleRef: handleRef, shadowClassNames: shadowClassNames, path: path = [], extensionViewportSizes: extensionViewportSizes, parameters: parameters } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cZRB0.default), {
        ...props,
        type: "extension",
        children: ({ result: result })=>{
            try {
                // Return the result directly if it's a valid JSX.Element
                if (result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(result)) return $ad9414b9d01e2717$export$b7482bdc8aff85e4(result, layout, {
                    isTopLevel: path.length < 1,
                    handleRef: handleRef,
                    shadowClassNames: shadowClassNames
                }, undefined, parameters?.extensionId, extensionViewportSizes);
            } catch (e) {
            /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
            // Always return default content if anything goes wrong
            return $ad9414b9d01e2717$export$b7482bdc8aff85e4(text || 'extension', layout, {
                isTopLevel: path.length < 1,
                handleRef: handleRef,
                shadowClassNames: shadowClassNames
            }, undefined, parameters?.extensionId, extensionViewportSizes);
        }
    });
};
var $ad9414b9d01e2717$export$2e2bcd8739ae039 = (0, $k6yTf.default)($ad9414b9d01e2717$var$Extension, {
    overflowSelector: `.${(0, $iRC0e.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER}`
});

});
parcelRegister("cZRB0", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e283c99cb64abbd$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $eJOHy = parcelRequire("eJOHy");

var $LFmXM = parcelRequire("LFmXM");

var $fvGDQ = parcelRequire("fvGDQ");

var $4sxxB = parcelRequire("4sxxB");

var $3AGQm = parcelRequire("3AGQm");
const $6e283c99cb64abbd$var$inlineExtensionStyle = /*#__PURE__*/ (0, $1NIU8.css)({
    display: 'inline-block',
    maxWidth: '100%',
    verticalAlign: 'middle',
    // 0px margin top is important here.
    // When running on server-side emotion will generate style tags before elements.
    // This caused packages/editor/editor-common/src/styles/shared/block-marks.ts to override the margin-top.
    // However as soon as the styles are extracted to <head> it adds back the margin.
    // The timing is tricky as it happens to be when UFO collects the dimension for the placeholder for TTVC calculation.
    // This resulted 1px mismatch on the image. Further cause everything on page to shift by 1px.
    // es-lint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    margin: `0px 1px ${"var(--ds-space-050, 4px)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& .rich-media-item': {
        maxWidth: '100%'
    }
});
function $6e283c99cb64abbd$export$2e2bcd8739ae039(props) {
    const { extensionHandlers: extensionHandlers, rendererContext: rendererContext, extensionType: extensionType, extensionKey: extensionKey, parameters: parameters, content: content, text: text, type: type, localId: localId, marks: marks, actions: actions, children: children } = props;
    const isMounted = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef(true);
    const localGetNodeRenderer = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useMemo(()=>(0, $LFmXM.default)((0, $fvGDQ.getNodeRenderer)), []);
    const [extensionProvider, setExtensionProvider] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState(null);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleProvider = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((name, providerPromise)=>{
        providerPromise && providerPromise.then((provider)=>{
            if (isMounted.current) setExtensionProvider(provider);
        });
    }, []);
    const renderExtensionNode = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((extensionProvider)=>{
        const fragmentLocalId = marks?.find((m)=>m.type.name === 'fragment')?.attrs?.localId;
        const node = {
            type: type,
            extensionKey: extensionKey,
            extensionType: extensionType,
            parameters: parameters,
            content: content || text,
            localId: localId,
            fragmentLocalId: fragmentLocalId
        };
        let result = null;
        try {
            if (extensionHandlers && extensionHandlers[extensionType]) {
                const render = (0, $3AGQm.getExtensionRenderer)(extensionHandlers[extensionType]);
                result = render(node, rendererContext.adDoc);
            }
            if (!result && extensionProvider) {
                const NodeRenderer = localGetNodeRenderer(extensionProvider, extensionType, extensionKey);
                if (node.type === 'multiBodiedExtension') result = /*#__PURE__*/ (0, $1NIU8.jsx)(NodeRenderer, {
                    node: node,
                    actions: actions
                });
                else if (node.type === 'inlineExtension') result = /*#__PURE__*/ (0, $1NIU8.jsx)($6e283c99cb64abbd$export$f41ccc3bd3324832, null, /*#__PURE__*/ (0, $1NIU8.jsx)(NodeRenderer, {
                    node: node
                }));
                else result = /*#__PURE__*/ (0, $1NIU8.jsx)(NodeRenderer, {
                    node: node
                });
            }
        } catch (e) {
        /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
        return children({
            result: result
        });
    }, [
        actions,
        children,
        content,
        extensionHandlers,
        extensionKey,
        extensionType,
        localGetNodeRenderer,
        localId,
        marks,
        parameters,
        rendererContext?.adDoc,
        text,
        type
    ]);
    const setupAndRenderExtensionNode = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((providers)=>{
        if (!extensionProvider && providers.extensionProvider) handleProvider('extensionProvider', providers.extensionProvider);
        return renderExtensionNode(extensionProvider);
    }, [
        extensionProvider,
        handleProvider,
        renderExtensionNode
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useEffect(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    if (!props.providers) return setupAndRenderExtensionNode({});
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $4sxxB.WithProviders), {
        providers: [
            'extensionProvider'
        ],
        providerFactory: props.providers,
        renderNode: setupAndRenderExtensionNode
    });
}
const $6e283c99cb64abbd$export$f41ccc3bd3324832 = ({ children: children, ssrPlaceholder: ssrPlaceholder, ssrPlaceholderReplace: ssrPlaceholderReplace })=>{
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "inline-extension-renderer",
        css: $6e283c99cb64abbd$var$inlineExtensionStyle,
        "data-ssr-placeholder": ssrPlaceholder,
        "data-ssr-placeholder-replace": ssrPlaceholderReplace
    }, children);
};

});
parcelRegister("fvGDQ", function(module, exports) {

$parcel$export(module.exports, "getExtensionModuleNode", () => $9bf604c19126813a$export$82dd45c2db936caf);
$parcel$export(module.exports, "getExtensionModuleNodePrivateProps", () => $9bf604c19126813a$export$426f8efd8690d8aa);
$parcel$export(module.exports, "getNodeRenderer", () => $9bf604c19126813a$export$67a7d49db68d30a0);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $joSn0 = parcelRequire("joSn0");

var $eGOwo = parcelRequire("eGOwo");

var $l3kPA = parcelRequire("l3kPA");
function $9bf604c19126813a$var$getNodeFromManifest(// eslint-disable-next-line @typescript-eslint/no-explicit-any
manifest, extKey, nodeKey, extensionType, extensionKey) {
    if (!manifest) throw new Error(`Extension with key "${extKey}" and type "${extensionType}" not found!`);
    if (!manifest.modules.nodes) throw new Error(`Couldn't find any node for extension type "${extensionType}" and key "${extensionKey}"!`);
    const node = manifest.modules.nodes[nodeKey];
    if (!node) throw new Error(`Node with key "${extensionKey}" not found on manifest for extension type "${extensionType}" and key "${extensionKey}"!`);
    return node;
}
async function $9bf604c19126813a$export$82dd45c2db936caf(extensionProvider, extensionType, extensionKey) {
    const [extKey, nodeKey] = (0, $l3kPA.getExtensionKeyAndNodeKey)(extensionKey, extensionType);
    const manifest = await extensionProvider.getExtension(extensionType, extKey);
    return $9bf604c19126813a$var$getNodeFromManifest(manifest, extKey, nodeKey, extensionType, extensionKey);
}
function $9bf604c19126813a$export$903681ffb5af37a7(extensionProvider, extensionType, extensionKey) {
    const [extKey, nodeKey] = (0, $l3kPA.getExtensionKeyAndNodeKey)(extensionKey, extensionType);
    const manifest = extensionProvider?.getPreloadedExtension?.(extensionType, extKey);
    if (manifest) return $9bf604c19126813a$var$getNodeFromManifest(manifest, extKey, nodeKey, extensionType, extensionKey);
    else return extensionProvider.getExtension(extensionType, extKey).then((manifest)=>$9bf604c19126813a$var$getNodeFromManifest(manifest, extKey, nodeKey, extensionType, extensionKey));
}
async function $9bf604c19126813a$export$426f8efd8690d8aa(extensionProvider, extensionType, extensionKey) {
    const moduleNode = await $9bf604c19126813a$export$82dd45c2db936caf(extensionProvider, extensionType, extensionKey);
    return Object.keys(moduleNode).filter((key)=>key.startsWith('__')).reduce((acc, key)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        acc[key] = moduleNode[key];
        return acc;
    }, {});
}
function $9bf604c19126813a$var$ExtensionLoading(props) {
    if (props.error || props.timedOut) {
        // eslint-disable-next-line no-console
        console.error('Error rendering extension', props.error);
        return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            children: "Error loading the extension!"
        });
    } else return null;
}
function $9bf604c19126813a$export$67a7d49db68d30a0(extensionProvider, extensionType, extensionKey) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
        loader: ()=>{
            if ((0, $eGOwo.fg)('confluence_preload_extension_providers')) {
                const maybePromise = $9bf604c19126813a$export$903681ffb5af37a7(extensionProvider, extensionType, extensionKey);
                if (maybePromise instanceof Promise) return maybePromise.then((node)=>(0, $l3kPA.resolveImport)(node.render()));
                else {
                    const preloaded = maybePromise?.renderSync?.();
                    // Only product implemented preloading will return sync result
                    // However the out-of-box won't handle this. Confluence uses a custom implementation
                    return preloaded ? (0, $l3kPA.resolveImportSync)(preloaded) : (0, $l3kPA.resolveImport)(maybePromise.render());
                }
            } else return $9bf604c19126813a$export$82dd45c2db936caf(extensionProvider, extensionType, extensionKey).then((node)=>(0, $l3kPA.resolveImport)(node.render()));
        },
        loading: $9bf604c19126813a$var$ExtensionLoading
    });
}

});
parcelRegister("l3kPA", function(module, exports) {

$parcel$export(module.exports, "getExtensionKeyAndNodeKey", () => $258d69c4789a7f77$export$8a49818572e1d105);
$parcel$export(module.exports, "buildAction", () => $258d69c4789a7f77$export$bb33bcdd9a10a608);
$parcel$export(module.exports, "resolveImportSync", () => $258d69c4789a7f77$export$dca2026e63034304);
$parcel$export(module.exports, "resolveImport", () => $258d69c4789a7f77$export$d69c9b451c47653b);
const $258d69c4789a7f77$export$a7d04c836550045a = 'com.atlassian.ecosystem';
const $258d69c4789a7f77$export$8a49818572e1d105 = (extensionKey, extensionType)=>{
    // Forge macro extensionKey has a user generated string, so splitting on
    // a colon is unstable for their particular use case. They only have one
    // node in the relevant manifest so we can hardcode nodeKey to 'default'.
    if (extensionType === $258d69c4789a7f77$export$a7d04c836550045a) return [
        extensionKey,
        'default'
    ];
    const [extKey, nodeKey = 'default'] = extensionKey.split(':');
    return [
        extKey,
        nodeKey
    ];
};
const $258d69c4789a7f77$export$5f3eb042babacbbd = (extensionKey, nodeKey)=>{
    if (!nodeKey || nodeKey === 'default') return extensionKey;
    return `${extensionKey}:${nodeKey}`;
};
function $258d69c4789a7f77$export$bb33bcdd9a10a608(action, manifest) {
    if (typeof action === 'function') return action;
    if (action.type === 'node' && manifest.modules.nodes) return $258d69c4789a7f77$export$33863d887d6f4bfd(action, manifest);
}
const $258d69c4789a7f77$export$dca2026e63034304 = (importedModule)=>{
    return importedModule && importedModule.__esModule ? importedModule.default : importedModule;
};
const $258d69c4789a7f77$export$d69c9b451c47653b = async (importPromise)=>{
    return $258d69c4789a7f77$export$dca2026e63034304(await importPromise);
};
function $258d69c4789a7f77$export$33863d887d6f4bfd(action, manifest) {
    if (!manifest.modules.nodes) return;
    const node = manifest.modules.nodes[action.key];
    const extensionKey = $258d69c4789a7f77$export$5f3eb042babacbbd(manifest.key, action.key);
    const extension = {
        type: node.type,
        attrs: {
            extensionType: manifest.type,
            extensionKey: extensionKey,
            parameters: action.parameters
        }
    };
    if (node.type === 'bodiedExtension') return {
        ...extension,
        content: [
            {
                type: 'paragraph',
                content: []
            }
        ]
    };
    else if (node.type === 'multiBodiedExtension') return {
        ...extension,
        content: [
            {
                type: 'extensionFrame',
                content: [
                    {
                        type: 'paragraph',
                        content: []
                    }
                ]
            }
        ]
    };
    return extension;
}

});


parcelRegister("4sxxB", function(module, exports) {

$parcel$export(module.exports, "WithProviders", () => $b2c1f4a7501c3351$export$d498ee8be33e096f);
/* eslint-disable @repo/internal/react/no-class-components */ 
var $eJOHy = parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");
class $b2c1f4a7501c3351$export$d498ee8be33e096f extends (0, $eJOHy.PureComponent) {
    static{
        this.displayName = 'WithProviders';
    }
    constructor(props){
        super(props), this.mounted = false, // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.handleProviderIfMounted = (name, provider)=>{
            if (!this.mounted) return;
            this.handleProvider(name, provider);
        }, // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.handleProvider = (name, provider)=>{
            this.setState(({ providers: providers })=>{
                return {
                    providers: {
                        ...providers,
                        [name]: provider
                    }
                };
            });
        };
        this.mounted = false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const providers = {};
        this.props.providers.forEach((name)=>{
            const providerPromise = props.providerFactory.subscribe(name, this.handleProviderIfMounted);
            providers[name] = providerPromise;
        });
        this.state = {
            providers: providers
        };
    }
    componentDidMount() {
        this.mounted = true;
    }
    componentWillUnmount() {
        const { providers: providers, providerFactory: providerFactory } = this.props;
        providers.forEach((name)=>{
            providerFactory.unsubscribe(name, (0, $eGOwo.fg)('platform_editor_fix_unsubscribe_of_provider') ? this.handleProviderIfMounted : this.handleProvider);
        });
    }
    render() {
        const { state: state, props: props } = this;
        const { renderNode: renderNode } = props;
        return renderNode(state.providers);
    }
}

});

parcelRegister("3AGQm", function(module, exports) {

$parcel$export(module.exports, "getExtensionRenderer", () => $4754977c03885da7$export$9214452ef07eda7);
function $4754977c03885da7$export$9214452ef07eda7(extensionHandler) {
    if (typeof extensionHandler === 'object') return extensionHandler.render;
    else return extensionHandler;
}

});


parcelRegister("k6yTf", function(module, exports) {

$parcel$export(module.exports, "shadowClassNames", () => $da606684968a05e6$export$4735dd2b0fa88aa5);
$parcel$export(module.exports, "default", () => $da606684968a05e6$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $3gw29 = parcelRequire("3gw29");
const $da606684968a05e6$export$4735dd2b0fa88aa5 = {
    RIGHT_SHADOW: 'right-shadow',
    LEFT_SHADOW: 'left-shadow'
};
function $da606684968a05e6$export$2e2bcd8739ae039(Component, options) {
    return class OverflowShadow extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
        componentWillUnmount() {
            if (options.useShadowObserver) return this.shadowObserver && this.shadowObserver.dispose();
            if (this.overflowContainer) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowContainer.removeEventListener('scroll', this.handleScroll);
            this.updateShadows();
        }
        componentDidUpdate() {
            if (!options.useShadowObserver) this.updateShadows();
        }
        initShadowObserver() {
            if (this.shadowObserver || !this.overflowContainer) return;
            this.shadowObserver = new (0, $3gw29.ShadowObserver)({
                scrollContainer: this.overflowContainer,
                onUpdateShadows: (shadowStates)=>{
                    this.setState((prevState)=>{
                        const { showLeftShadow: showLeftShadow, showRightShadow: showRightShadow } = shadowStates;
                        if (showLeftShadow !== prevState.showLeftShadow || showRightShadow !== prevState.showRightShadow) return {
                            showLeftShadow: showLeftShadow,
                            showRightShadow: showRightShadow
                        };
                        return null;
                    });
                }
            });
        }
        render() {
            const { showLeftShadow: showLeftShadow, showRightShadow: showRightShadow } = this.state;
            const classNames = [
                !this.props?.disableTableOverflowShadow && showRightShadow && $da606684968a05e6$export$4735dd2b0fa88aa5.RIGHT_SHADOW,
                !this.props?.disableTableOverflowShadow && showLeftShadow && $da606684968a05e6$export$4735dd2b0fa88aa5.LEFT_SHADOW,
                options.useShadowObserver && (0, $3gw29.shadowObserverClassNames).SHADOW_CONTAINER
            ].filter(Boolean).join(' ');
            return(// Ignored via go/ees005
            // eslint-disable-next-line react/jsx-props-no-spreading
            /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
                handleRef: this.handleContainer,
                shadowClassNames: classNames,
                ...this.props
            }));
        }
        constructor(...args){
            super(...args), this.overflowContainerWidth = 0, this.state = {
                showLeftShadow: false,
                showRightShadow: false
            }, this.handleScroll = (event)=>{
                if (!this.overflowContainer || event.target !== this.overflowContainer || options.useShadowObserver) return;
                this.updateShadows();
            }, this.updateShadows = ()=>{
                if (options.useShadowObserver) return;
                this.setState((prevState)=>{
                    if (!this.overflowContainer) return;
                    const diff = this.calcOverflowDiff();
                    const showRightShadow = diff > 0 && diff > this.overflowContainer.scrollLeft;
                    const showLeftShadow = this.showLeftShadow(this.overflowContainer);
                    if (showLeftShadow !== prevState.showLeftShadow || showRightShadow !== this.state.showRightShadow) return {
                        showLeftShadow: showLeftShadow,
                        showRightShadow: showRightShadow
                    };
                    return null;
                });
            }, this.showLeftShadow = (overflowContainer)=>{
                return !!overflowContainer && overflowContainer.scrollLeft > 0;
            }, this.calcOverflowDiff = ()=>{
                if (!this.overflowContainer) return 0;
                this.diff = this.calcScrollableWidth();
                return this.diff - this.overflowContainer.offsetWidth;
            }, this.calcScrollableWidth = ()=>{
                if (!this.scrollable && this.overflowContainer) return this.overflowContainer.scrollWidth;
                if (!this.scrollable) return 0;
                let width = 0;
                for(let i = 0; i < this.scrollable.length; i++){
                    // Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    const scrollableElement = this.scrollable[i];
                    width += scrollableElement.scrollWidth;
                }
                return width;
            }, this.handleContainer = (container)=>{
                if (!container || this.container) return;
                this.container = container;
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                this.overflowContainer = container.querySelector(options.overflowSelector);
                if (!this.overflowContainer) this.overflowContainer = container;
                if (options.useShadowObserver) {
                    this.initShadowObserver();
                    return;
                }
                this.updateShadows();
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                this.overflowContainer.addEventListener('scroll', this.handleScroll);
            };
        }
    };
}

});
parcelRegister("3gw29", function(module, exports) {

$parcel$export(module.exports, "shadowObserverClassNames", () => $035d40e16bddbfa4$export$1cbe0bb16052178d);
$parcel$export(module.exports, "ShadowObserver", () => $035d40e16bddbfa4$export$51a5b28e4fb2dba2);
var $035d40e16bddbfa4$export$ebeea2fe2e93862e = /*#__PURE__*/ function(ShadowKeys) {
    ShadowKeys["SHOW_LEFT_SHADOW"] = "showLeftShadow";
    ShadowKeys["SHOW_RIGHT_SHADOW"] = "showRightShadow";
    return ShadowKeys;
}({});
const $035d40e16bddbfa4$export$1cbe0bb16052178d = {
    SENTINEL_LEFT: 'sentinel-left',
    SENTINEL_RIGHT: 'sentinel-right',
    SHADOW_CONTAINER: 'with-shadow-observer'
};
const $035d40e16bddbfa4$var$requestIdleCallback = (fn)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return window.requestIdleCallback ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.requestIdleCallback(fn) : window.requestAnimationFrame(fn);
};
const $035d40e16bddbfa4$var$cancelIdleCallback = (id)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return window.cancelIdleCallback ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.cancelIdleCallback(id) : window.cancelAnimationFrame(id);
};
class $035d40e16bddbfa4$export$51a5b28e4fb2dba2 {
    constructor({ scrollContainer: scrollContainer, onUpdateShadows: onUpdateShadows }){
        this.sentinels = {};
        this.shadowStates = {
            ["showLeftShadow"]: false,
            ["showRightShadow"]: false
        };
        this.init = ()=>{
            if (!this.scrollContainer || this.intersectionObserver) return;
            this.sentinels.right = document.createElement('div');
            this.sentinels.right.classList.add($035d40e16bddbfa4$export$1cbe0bb16052178d.SENTINEL_RIGHT);
            this.scrollContainer.appendChild(this.sentinels.right);
            this.sentinels.left = document.createElement('div');
            this.sentinels.left.classList.add($035d40e16bddbfa4$export$1cbe0bb16052178d.SENTINEL_LEFT);
            this.scrollContainer.prepend(this.sentinels.left);
            this.intersectionObserver = new IntersectionObserver((entries, _)=>{
                entries.forEach(this.onIntersect);
            }, {
                root: this.scrollContainer,
                rootMargin: '1px'
            });
            this.intersectionObserver.observe(this.sentinels.left);
            this.intersectionObserver.observe(this.sentinels.right);
        };
        this.onIntersect = (entry)=>{
            this.requestCallbackId = $035d40e16bddbfa4$var$requestIdleCallback(()=>{
                if (entry.target.classList.contains($035d40e16bddbfa4$export$1cbe0bb16052178d.SENTINEL_LEFT)) this.shadowStates["showLeftShadow"] = !entry.isIntersecting;
                if (entry.target.classList.contains($035d40e16bddbfa4$export$1cbe0bb16052178d.SENTINEL_RIGHT)) this.shadowStates["showRightShadow"] = !entry.isIntersecting;
                this.onUpdateShadows(this.shadowStates);
            });
        };
        this.scrollContainer = scrollContainer;
        this.onUpdateShadows = onUpdateShadows;
        this.init();
    }
    dispose() {
        if (this.intersectionObserver) {
            this.intersectionObserver.disconnect();
            this.intersectionObserver = undefined;
            this.requestCallbackId && $035d40e16bddbfa4$var$cancelIdleCallback(this.requestCallbackId);
        }
    }
}

});


parcelRegister("bnh3n", function(module, exports) {

$parcel$export(module.exports, "breakoutConsts", () => $a68a669b79a16fde$export$ead1fecec2ecf57c);
$parcel$export(module.exports, "absoluteBreakoutWidth", () => $a68a669b79a16fde$export$b34ea040d1533a3);
$parcel$export(module.exports, "calcWideWidth", () => $a68a669b79a16fde$export$86325001fe8f3adc);
$parcel$export(module.exports, "calcBreakoutWidth", () => $a68a669b79a16fde$export$5f4502874a28dfce);
$parcel$export(module.exports, "calcBreakoutWithCustomWidth", () => $a68a669b79a16fde$export$ccc0a02edddeed39);
$parcel$export(module.exports, "calculateBreakoutStyles", () => $a68a669b79a16fde$export$c377853ecdd53e5b);
$parcel$export(module.exports, "getNextBreakoutMode", () => $a68a669b79a16fde$export$7eb758567e6644fd);
$parcel$export(module.exports, "getTitle", () => $a68a669b79a16fde$export$70d1bf7729efff40);

var $7yBx7 = parcelRequire("7yBx7");

var $h2yqz = parcelRequire("h2yqz");

var $iZVrE = parcelRequire("iZVrE");

var $2bEPZ = parcelRequire("2bEPZ");

var $7SIsS = parcelRequire("7SIsS");
const $a68a669b79a16fde$export$ead1fecec2ecf57c = {
    padding: (0, $7yBx7.akEditorBreakoutPadding),
    defaultLayoutWidth: (0, $7yBx7.akEditorDefaultLayoutWidth),
    wideScaleRatio: (0, $7yBx7.breakoutWideScaleRatio),
    fullWidthLayoutWidth: (0, $7yBx7.akEditorFullWidthLayoutWidth),
    wideLayoutWidth: (0, $7yBx7.akEditorWideLayoutWidth),
    mapBreakpointToLayoutMaxWidth: $iZVrE.mapBreakpointToLayoutMaxWidth,
    getBreakpoint: $2bEPZ.getBreakpoint,
    /**
	 * This function can return percentage value or px value depending upon the inputs
	 */ calcBreakoutWidth: (breakoutConsts)=>(layout, containerWidth, padding)=>{
            const effectiveFullWidth = containerWidth - (padding ?? breakoutConsts.padding);
            switch(layout){
                case 'full-width':
                    return `${Math.min(effectiveFullWidth, breakoutConsts.fullWidthLayoutWidth)}px`;
                case 'wide':
                    if (effectiveFullWidth <= 0) return '100%';
                    const wideWidth = breakoutConsts.calcWideWidth(breakoutConsts)(containerWidth, undefined, undefined, padding);
                    if (wideWidth.endsWith('%')) return `${Math.min(effectiveFullWidth, breakoutConsts.fullWidthLayoutWidth)}px`;
                    return wideWidth;
                default:
                    return '100%';
            }
        },
    calcBreakoutWithCustomWidth: (breakoutConsts)=>(mode, width, editorContainerWidth)=>{
            if (width !== null && width > 0) {
                const effectiveFullWidth = editorContainerWidth - breakoutConsts.padding;
                // if below 0 then expect we're rendering in SSR
                return `${Math.min(width, effectiveFullWidth)}px`;
            }
            return breakoutConsts.calcBreakoutWidth(breakoutConsts)(mode, editorContainerWidth);
        },
    calcLineLength: (breakoutConsts)=>()=>breakoutConsts.defaultLayoutWidth,
    calcWideWidth: (breakoutConsts)=>(containerWidth = breakoutConsts.defaultLayoutWidth, maxWidth = Infinity, fallback = '100%', padding)=>{
            const effectiveFullWidth = containerWidth - (padding ?? breakoutConsts.padding);
            const layoutMaxWidth = breakoutConsts.mapBreakpointToLayoutMaxWidth(breakoutConsts.getBreakpoint(containerWidth));
            const wideWidth = Math.min(Math.ceil(layoutMaxWidth * breakoutConsts.wideScaleRatio), effectiveFullWidth);
            return layoutMaxWidth > wideWidth ? fallback : `${Math.min(maxWidth, wideWidth)}px`;
        }
};
const $a68a669b79a16fde$export$b34ea040d1533a3 = (layout, containerWidth)=>{
    const breakoutWidth = $a68a669b79a16fde$export$ead1fecec2ecf57c.calcBreakoutWidth($a68a669b79a16fde$export$ead1fecec2ecf57c)(layout, containerWidth);
    // If it's percent, map to max layout size
    if (breakoutWidth.endsWith('%')) switch(layout){
        case 'full-width':
            return 0, $7yBx7.akEditorFullWidthLayoutWidth;
        case 'wide':
            return 0, $7yBx7.akEditorWideLayoutWidth;
        default:
            return $a68a669b79a16fde$export$ead1fecec2ecf57c.mapBreakpointToLayoutMaxWidth($a68a669b79a16fde$export$ead1fecec2ecf57c.getBreakpoint(containerWidth));
    }
    return parseInt(breakoutWidth, 10);
};
const $a68a669b79a16fde$export$86325001fe8f3adc = $a68a669b79a16fde$export$ead1fecec2ecf57c.calcWideWidth($a68a669b79a16fde$export$ead1fecec2ecf57c);
const $a68a669b79a16fde$export$5f4502874a28dfce = $a68a669b79a16fde$export$ead1fecec2ecf57c.calcBreakoutWidth($a68a669b79a16fde$export$ead1fecec2ecf57c);
const $a68a669b79a16fde$export$ccc0a02edddeed39 = $a68a669b79a16fde$export$ead1fecec2ecf57c.calcBreakoutWithCustomWidth($a68a669b79a16fde$export$ead1fecec2ecf57c);
function $a68a669b79a16fde$export$c377853ecdd53e5b({ mode: mode, widthStateLineLength: widthStateLineLength, widthStateWidth: widthStateWidth }) {
    const breakoutWidth = $a68a669b79a16fde$export$5f4502874a28dfce(mode, widthStateWidth);
    const breakoutWidthPx = (0, $7SIsS.parsePx)(breakoutWidth);
    if (!widthStateLineLength) // lineLength is not normally undefined when this is run for,
    // consumers but can be in SSR, initial render or test (jsdom)
    // environments.
    //
    // this approach doesn't work well with position: fixed, so
    // it breaks things like sticky headers.
    //
    // It can also cause bluriness for some child content (such as iframes)
    return {
        type: 'line-length-unknown',
        width: breakoutWidth,
        minWidth: breakoutWidthPx,
        display: 'flex',
        justifyContent: 'center',
        transform: 'none',
        transition: `min-width 0.5s ${0, $7yBx7.akEditorSwoopCubicBezier}`
    };
    // NOTE
    // At time of writing -- when toggling between full-width and
    // full-page appearance modes. There is a slight delay before
    // the widthState is updated.
    // During this period -- the marginLeftPx will be incorrect.
    // const marginLeftPx = -(breakoutWidthPx - widthStateLineLength) / 2;
    return {
        type: 'line-length-known',
        width: breakoutWidth,
        minWidth: breakoutWidthPx,
        transition: `min-width 0.5s ${0, $7yBx7.akEditorSwoopCubicBezier}`,
        transform: `translateX(-50%)`,
        marginLeft: `50%`
    };
}
function $a68a669b79a16fde$export$586300c53bd298dd(mode, widthStateWidth, padding) {
    return (0, $7SIsS.parsePx)($a68a669b79a16fde$export$5f4502874a28dfce(mode, widthStateWidth, padding));
}
const $a68a669b79a16fde$export$7eb758567e6644fd = (currentMode)=>{
    if (currentMode === 'full-width') return 'center';
    else if (currentMode === 'wide') return 'full-width';
    return 'wide';
};
const $a68a669b79a16fde$export$70d1bf7729efff40 = (layout)=>{
    switch(layout){
        case 'full-width':
            return (0, $h2yqz.default).layoutFixedWidth;
        case 'wide':
            return (0, $h2yqz.default).layoutFullWidth;
        default:
            return (0, $h2yqz.default).layoutWide;
    }
};

});
parcelRegister("h2yqz", function(module, exports) {

$parcel$export(module.exports, "default", () => $a862382972fced25$export$2e2bcd8739ae039);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $7qGN1 = parcelRequire("7qGN1");

var $7Lz9d = parcelRequire("7Lz9d");

var $80t1d = parcelRequire("80t1d");

var $j0yUU = parcelRequire("j0yUU");

var $TgnAJ = parcelRequire("TgnAJ");

var $brgNx = parcelRequire("brgNx");


var $53A9i = parcelRequire("53A9i");

var $4AqYB = parcelRequire("4AqYB");


var $ehejR = parcelRequire("ehejR");

var $46A2h = parcelRequire("46A2h");

var $jSSd5 = parcelRequire("jSSd5");

var $6dRXt = parcelRequire("6dRXt");

var $1LIK6 = parcelRequire("1LIK6");

var $1D5wE = parcelRequire("1D5wE");

var $fJeGS = parcelRequire("fJeGS");

var $eCOhn = parcelRequire("eCOhn");

var $iW8Cl = parcelRequire("iW8Cl");

var $2EHqK = parcelRequire("2EHqK");

var $cINgv = parcelRequire("cINgv");

var $iRGZx = parcelRequire("iRGZx");

var $7g31l = parcelRequire("7g31l");

var $cfB8F = parcelRequire("cfB8F");

var $cDtOg = parcelRequire("cDtOg");

var $4DFTL = parcelRequire("4DFTL");

var $DGjKK = parcelRequire("DGjKK");

var $fbDBV = parcelRequire("fbDBV");

var $dfJR8 = parcelRequire("dfJR8");

var $dH8bz = parcelRequire("dH8bz");

var $gjx6N = parcelRequire("gjx6N");

var $h6V7a = parcelRequire("h6V7a");

var $gYWwp = parcelRequire("gYWwp");



var $jlbSP = parcelRequire("jlbSP");


var $ee8QX = parcelRequire("ee8QX");

var $dTBhg = parcelRequire("dTBhg");
var $a862382972fced25$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    layoutFixedWidth: {
        id: 'fabric.editor.layoutFixedWidth',
        defaultMessage: 'Back to center',
        description: 'Display your element (image, table, extension, etc) as standard width'
    },
    layoutStateFixedWidth: {
        id: 'fabric.editor.layoutStateFixedWidth',
        defaultMessage: 'Centered',
        description: 'Displaying your element (image, table, extension, etc) as standard width'
    },
    layoutWide: {
        id: 'fabric.editor.layoutWide',
        defaultMessage: 'Go wide',
        description: 'Display your element (image, table, extension, etc) wider than normal'
    },
    layoutStateWide: {
        id: 'fabric.editor.layoutStateWide',
        defaultMessage: 'Wide',
        description: 'Displaying your element (image, table, extension, etc) wider than normal'
    },
    layoutFullWidth: {
        id: 'fabric.editor.layoutFullWidth',
        defaultMessage: 'Go full width',
        description: 'Display your element (image, table, extension, etc) as full width'
    },
    layoutStateFullWidth: {
        id: 'fabric.editor.layoutStateFullWidth',
        defaultMessage: 'Full width',
        description: 'Displaying your element (image, table, extension, etc) as full width'
    },
    alignImageRight: {
        id: 'fabric.editor.alignImageRight',
        defaultMessage: 'Align right',
        description: 'Aligns image to the right'
    },
    alignImageCenter: {
        id: 'fabric.editor.alignImageCenter',
        defaultMessage: 'Align center',
        description: 'Aligns image to the center'
    },
    alignImageLeft: {
        id: 'fabric.editor.alignImageLeft',
        defaultMessage: 'Align left',
        description: 'Aligns image to the left'
    },
    delete: {
        id: 'fabric.editor.delete',
        defaultMessage: 'Delete',
        description: 'Delete the element (image, panel, table, etc.) from your document'
    },
    remove: {
        id: 'fabric.editor.remove',
        defaultMessage: 'Remove',
        description: 'Delete the element (image, panel, table, etc.) from your document'
    },
    removeEmoji: {
        id: 'fabric.editor.removeEmoji',
        defaultMessage: 'Remove emoji',
        description: 'Remove the emoji panel icon from custom panel'
    },
    visit: {
        id: 'fabric.editor.visit',
        defaultMessage: 'Open link in a new window',
        description: 'Open the link in a new window'
    },
    inviteToEditButtonTitle: {
        id: 'fabric.editor.editMode.inviteToEditButton.title',
        defaultMessage: 'Invite to edit',
        description: 'Invite another user to edit the current document'
    },
    saveButton: {
        id: 'fabric.editor.saveButton',
        defaultMessage: 'Save',
        description: 'Submit and save a comment or document'
    },
    cancelButton: {
        id: 'fabric.editor.cancelButton',
        defaultMessage: 'Cancel',
        description: 'Discard the current comment or document'
    },
    taskList: {
        id: 'fabric.editor.tooltip.taskList',
        defaultMessage: 'an action item',
        description: 'an action item in the Editor'
    },
    bulletList: {
        id: 'fabric.editor.tooltip.bulletList',
        defaultMessage: 'a list',
        description: 'a list item in the Editor'
    },
    nestedExpand: {
        id: 'fabric.editor.tooltip.nestedExpand',
        defaultMessage: 'a nested expand',
        description: 'expand node which is nested'
    },
    decisionList: {
        id: 'fabric.editor.tooltip.decisionList',
        defaultMessage: 'a decision list',
        description: 'a list of decisions'
    },
    defaultBlockNode: {
        id: 'fabric.editor.tooltip.defaultBlockNode',
        defaultMessage: 'a block node',
        description: 'a block node element'
    },
    panel: {
        id: 'fabric.editor.tooltip.blockPanel',
        defaultMessage: 'a panel',
        description: 'Panel node in the Editor'
    },
    blockquote: {
        id: 'fabric.editor.blockquote',
        defaultMessage: 'a quote',
        description: 'a quote node'
    },
    timeUpdated: {
        id: 'fabric.editor.time.updated',
        defaultMessage: 'Updated',
        description: 'Time last updated'
    },
    timeViewed: {
        id: 'fabric.editor.time.viewed',
        defaultMessage: 'Viewed',
        description: 'Time last viewed'
    },
    timeAgo: {
        id: 'fabric.editor.time.ago',
        defaultMessage: 'ago',
        description: 'Some time ago'
    },
    copyToClipboard: {
        id: 'fabric.editor.copyToClipboard',
        defaultMessage: 'Copy',
        description: 'Copy the whole content of the element to your clipboard'
    },
    copiedToClipboard: {
        id: 'fabric.editor.copiedToClipboard',
        defaultMessage: 'Copied!',
        description: 'Copied the whole content of the element to clipboard'
    },
    viewMore: {
        id: 'fabric.editor.overflowMenuViewMore',
        defaultMessage: 'View more',
        description: 'View more options in toolbar'
    }
});

});
parcelRegister("7Lz9d", function(module, exports) {

$parcel$export(module.exports, "alignmentMessages", () => $dc92283c73543884$export$5229ffea355cfdf6);

var $7qGN1 = parcelRequire("7qGN1");
const $dc92283c73543884$export$5229ffea355cfdf6 = (0, $7qGN1.defineMessages)({
    alignment: {
        id: 'fabric.editor.alignment',
        defaultMessage: 'Text alignment',
        description: 'Opens drop down menu of options to configure text alignment'
    },
    alignLeft: {
        id: 'fabric.editor.alignLeft',
        defaultMessage: 'Align left',
        description: 'label stating that text is aligned left'
    },
    alignCenter: {
        id: 'fabric.editor.alignCenter',
        defaultMessage: 'Align center',
        description: 'label stating that text is aligned center'
    },
    alignRight: {
        id: 'fabric.editor.alignRight',
        defaultMessage: 'Align right',
        description: 'label stating that text is aligned right'
    }
});

});

parcelRegister("80t1d", function(module, exports) {

$parcel$export(module.exports, "annotationMessages", () => $21f2c1c46f6d0e21$export$ff612ca71703201d);

var $7qGN1 = parcelRequire("7qGN1");
const $21f2c1c46f6d0e21$export$ff612ca71703201d = (0, $7qGN1.defineMessages)({
    createComment: {
        id: 'fabric.editor.createComment',
        defaultMessage: 'Comment',
        description: 'Create/add an inline comment based on the users selection'
    },
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: Remove this message when the editor_inline_comments_on_inline_nodes FF is removed
    createCommentInvalid: {
        id: 'fabric.editor.createCommentInvalid',
        defaultMessage: 'You can only comment on text and headings',
        description: 'Error message to communicate to the user they can only do the current action in certain contexts'
    },
    createCommentDisabled: {
        id: 'fabric.editor.createCommentDisabled',
        defaultMessage: 'You can only comment on text, headings, emojis, dates, mentions, links, and statuses.',
        description: 'Error message to communicate to the user they can only do the current action in certain contexts'
    },
    toolbar: {
        id: 'fabric.editor.annotationToolbar',
        defaultMessage: 'Annotation toolbar',
        description: 'A label for a toolbar (UI element) that creates annotations/comments in the document'
    },
    createCommentOnInlineNodeSpotlightBody: {
        id: 'fabric.editor.createCommentOnInlineNodeSpotlight.body',
        defaultMessage: 'You can now leave comments on inline elements like links, dates, statuses and mentions.',
        description: 'The body content of the spotlight message that appears when the user can leave comments on inline nodes'
    },
    createCommentOnInlineNodeSpotlightAction: {
        id: 'fabric.editor.createCommentOnInlineNodeSpotlight.action',
        defaultMessage: 'Got it',
        description: 'The content of the action button that closes the spotlight'
    }
});

});

parcelRegister("j0yUU", function(module, exports) {

$parcel$export(module.exports, "messages", () => $b492bc7e7de477dd$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $b492bc7e7de477dd$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    fullWidthLabel: {
        id: 'fabric.editor.breakoutFullWidthLabel',
        defaultMessage: 'Full-width',
        description: 'Resize current element to full-width mode'
    },
    wideWidthLabel: {
        id: 'fabric.editor.breakoutWideWidthLabel',
        defaultMessage: 'Wide',
        description: 'Resize current element to wide mode'
    },
    resizeHandle: {
        id: 'fabric.editor.resizeHandle',
        defaultMessage: 'Resize handle',
        description: 'Resize handle'
    },
    resizeExpand: {
        id: 'fabric.editor.breakout.resizeExpand',
        defaultMessage: 'Resize expand',
        description: 'Tooltip displayed on custom expand width resize handle'
    },
    resizeCodeBlock: {
        id: 'fabric.editor.breakout.resizeCodeBlock',
        defaultMessage: 'Resize code snippet',
        description: 'Tooltip displayed on custom code block width resize handle'
    },
    resizeLayout: {
        id: 'fabric.editor.breakout.resizeLayout',
        defaultMessage: 'Resize layout',
        description: 'Tooltip displayed on custom layout width resize handle'
    },
    resizeElement: {
        id: 'fabric.editor.breakout.resizeElement',
        defaultMessage: 'Resize element',
        description: 'Tooltip displayed on custom element (node) width resize handle'
    }
});

});

parcelRegister("TgnAJ", function(module, exports) {

$parcel$export(module.exports, "messages", () => $3e5e298fb8fde602$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $3e5e298fb8fde602$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    normal: {
        id: 'fabric.editor.normal',
        defaultMessage: 'Normal text',
        description: 'This is the default text style'
    },
    heading1: {
        id: 'fabric.editor.heading1',
        defaultMessage: 'Heading 1',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading1Description: {
        id: 'fabric.editor.heading1Description',
        defaultMessage: 'Use this for a top level heading',
        description: 'Description of the main heading, heading 1'
    },
    heading2: {
        id: 'fabric.editor.heading2',
        defaultMessage: 'Heading 2',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading2Description: {
        id: 'fabric.editor.heading2Description',
        defaultMessage: 'Use this for key sections',
        description: 'Description of a subtitle heading or secondary heading'
    },
    heading3: {
        id: 'fabric.editor.heading3',
        defaultMessage: 'Heading 3',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading3Description: {
        id: 'fabric.editor.heading3Description',
        defaultMessage: 'Use this for sub sections and group headings',
        description: ''
    },
    heading4: {
        id: 'fabric.editor.heading4',
        defaultMessage: 'Heading 4',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading4Description: {
        id: 'fabric.editor.heading4Description',
        defaultMessage: 'Use this for deep headings',
        description: ''
    },
    heading5: {
        id: 'fabric.editor.heading5',
        defaultMessage: 'Heading 5',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading5Description: {
        id: 'fabric.editor.heading5Description',
        defaultMessage: 'Use this for grouping list items',
        description: ''
    },
    heading6: {
        id: 'fabric.editor.heading6',
        defaultMessage: 'Heading 6',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading6Description: {
        id: 'fabric.editor.heading6Description',
        defaultMessage: 'Use this for low level headings',
        description: ''
    },
    blockquote: {
        id: 'fabric.editor.blockquote2',
        defaultMessage: 'Quote',
        description: 'Quote some text'
    },
    blockquoteDescription: {
        id: 'fabric.editor.blockquote.description',
        defaultMessage: 'Insert a quote or citation',
        description: 'Quote some text'
    },
    codeblock: {
        id: 'fabric.editor.codeblock',
        defaultMessage: 'Code snippet',
        description: 'Insert a snippet/segment of code (code block)'
    },
    codeblockDescription: {
        id: 'fabric.editor.codeblock.description',
        defaultMessage: 'Display code with syntax highlighting',
        description: 'Insert a snippet/segment of code (code block)'
    },
    infoPanel: {
        id: 'fabric.editor.infoPanel',
        defaultMessage: 'Info panel',
        description: 'Visually distinguishes your text by adding a background colour (blue, purple, yellow, green, red)'
    },
    infoPanelDescription: {
        id: 'fabric.editor.infoPanel.description',
        defaultMessage: 'Highlight information in a colored panel',
        description: 'Visually distinguishes your text by adding a background colour (blue, purple, yellow, green, red)'
    },
    notePanel: {
        id: 'fabric.editor.notePanel',
        defaultMessage: 'Note panel',
        description: 'Visually distinguishes your text by adding a note panel'
    },
    notePanelDescription: {
        id: 'fabric.editor.notePanel.description',
        defaultMessage: 'Add a note in a colored panel',
        description: 'Visually distinguishes your text by adding a note panel'
    },
    successPanel: {
        id: 'fabric.editor.successPanel',
        defaultMessage: 'Success panel',
        description: 'Visually distinguishes your text by adding a success panel'
    },
    successPanelDescription: {
        id: 'fabric.editor.successPanel.description',
        defaultMessage: 'Add tips in a colored panel',
        description: 'Visually distinguishes your text by adding a success panel'
    },
    warningPanel: {
        id: 'fabric.editor.warningPanel',
        defaultMessage: 'Warning panel',
        description: 'Visually distinguishes your text by adding a warning panel'
    },
    warningPanelDescription: {
        id: 'fabric.editor.warningPanel.description',
        defaultMessage: 'Add a note of caution in a colored panel',
        description: 'Visually distinguishes your text by adding a warning panel'
    },
    errorPanel: {
        id: 'fabric.editor.errorPanel',
        defaultMessage: 'Error panel',
        description: 'Visually distinguishes your text by adding a error panel'
    },
    errorPanelDescription: {
        id: 'fabric.editor.errorPanel.description',
        defaultMessage: 'Call out errors in a colored panel',
        description: 'Visually distinguishes your text by adding a error panel'
    },
    customPanel: {
        id: 'fabric.editor.customPanel',
        defaultMessage: 'Custom panel',
        description: 'Visually distinguishes your panel by adding a emoji icon and background color'
    },
    customPanelDescription: {
        id: 'fabric.editor.customPanel.description',
        defaultMessage: 'Add a note with an emoji and colored background',
        description: 'Visually distinguishes your panel by adding a emoji icon and background color '
    },
    panel: {
        id: 'fabric.editor.panel',
        defaultMessage: 'Panel',
        description: 'Visually distinguishes your text by adding a panel'
    },
    other: {
        id: 'fabric.editor.other',
        defaultMessage: 'Others...',
        description: 'Other text formatting'
    }
});

});

parcelRegister("brgNx", function(module, exports) {

$parcel$export(module.exports, "codeBidiWarningMessages", () => $7ab4004aea737315$export$42bb270d1224182);

var $7qGN1 = parcelRequire("7qGN1");
const $7ab4004aea737315$export$42bb270d1224182 = (0, $7qGN1.defineMessages)({
    /**
	 * Message taken from
	 * https://hello.atlassian.net/wiki/spaces/~tswan/pages/1366555782/PSHELP-2943+Investigate+Trojan+Source+Attack+Vulnerability+design
	 */ label: {
        id: 'fabric.editor.codeBidiWarningLabel',
        defaultMessage: 'Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code.',
        description: 'Tooltip message to present to users when a bidirectional character is encountered in code.'
    }
});

});

parcelRegister("53A9i", function(module, exports) {

$parcel$export(module.exports, "linkMessages", () => $fc6681fa190cc7ad$export$4ce3884394d6d9);

var $7qGN1 = parcelRequire("7qGN1");
const $fc6681fa190cc7ad$export$4ce3884394d6d9 = (0, $7qGN1.defineMessages)({
    openLink: {
        id: 'fabric.editor.openLink',
        defaultMessage: 'Open link in a new tab',
        description: 'Opens the link in a new tab'
    }
});

});

parcelRegister("4AqYB", function(module, exports) {

$parcel$export(module.exports, "linkToolbarMessages", () => $e531378f6ee78f93$export$2d7676d841c8ae9);

var $7qGN1 = parcelRequire("7qGN1");
const $e531378f6ee78f93$export$2d7676d841c8ae9 = (0, $7qGN1.defineMessages)({
    addLink: {
        id: 'fabric.editor.mediaAddLink',
        defaultMessage: 'Add link',
        description: 'Add link'
    },
    unableToOpenLink: {
        id: 'fabric.editor.unableToOpenLink',
        defaultMessage: 'Unable to open this link',
        description: 'Unable to open this link'
    },
    unlink: {
        id: 'fabric.editor.unlink',
        defaultMessage: 'Unlink',
        description: 'Removes the hyperlink but keeps your text.'
    },
    editDatasourceStandalone: {
        id: 'fabric.editor.editDatasourceStandalone',
        defaultMessage: 'Edit',
        description: 'A standalone edit button to edit the datasource via a config modal'
    },
    editDatasourceStandaloneTooltip: {
        id: 'fabric.editor.editDatasourceStandaloneTooltip',
        defaultMessage: 'Edit search query',
        description: 'A standalone edit button tooltip to hint at editing the datasource via a config modal'
    },
    editLink: {
        id: 'fabric.editor.editLink',
        defaultMessage: 'Edit link',
        description: 'Edit the link, update display text'
    },
    placeholder: {
        id: 'fabric.editor.hyperlinkToolbarPlaceholder',
        defaultMessage: 'Paste or search for link',
        description: 'Paste or search for link'
    },
    linkPlaceholder: {
        id: 'fabric.editor.linkPlaceholder',
        defaultMessage: 'Paste link',
        description: 'Create a new link by pasting a URL.'
    },
    linkAddress: {
        id: 'fabric.editor.linkAddress',
        defaultMessage: 'Link address',
        description: 'Insert the address of the link'
    },
    invalidLink: {
        id: 'fabric.editor.invalidLink',
        defaultMessage: 'Please enter a valid link.',
        description: 'Please enter a valid link.'
    },
    emptyLink: {
        id: 'fabric.editor.emptyLink',
        defaultMessage: 'Please enter a link.',
        description: 'Please enter a link.'
    },
    settingsLink: {
        id: 'fabric.editor.settingsLinks',
        defaultMessage: 'Go to Link Preferences',
        description: 'Go to Link Preferences'
    },
    preferencesLink: {
        id: 'fabric.editor.preferencesLink',
        defaultMessage: 'Link preferences',
        description: 'Go to link preferences'
    },
    editDatasource: {
        id: 'fabric.editor.edit.datasource',
        defaultMessage: 'Edit search query',
        description: 'Datasource toolbar edit button'
    },
    searchInput: {
        id: 'fabric.editor.edit.searchInput',
        defaultMessage: 'Add a link',
        description: 'Label for the search media input'
    }
});

});

parcelRegister("ehejR", function(module, exports) {

$parcel$export(module.exports, "codeBlockButtonMessages", () => $3a5f51fb91bec33b$export$74e304339778e94d);

var $7qGN1 = parcelRequire("7qGN1");
const $3a5f51fb91bec33b$export$74e304339778e94d = (0, $7qGN1.defineMessages)({
    copyCodeToClipboard: {
        id: 'fabric.editor.codeBlockCopyButton.copyToClipboard',
        defaultMessage: 'Copy as text',
        description: 'Copy the content of the code block as text to your clipboard'
    },
    copiedCodeToClipboard: {
        id: 'fabric.editor.codeBlockCopyButton.copiedToClipboard',
        defaultMessage: 'Copied!',
        description: 'Copied the content of the code block as text to clipboard'
    },
    wrapCode: {
        id: 'fabric.editor.codeBlockWrapButton.wrapCodeBlock',
        defaultMessage: 'Turn on wrap',
        description: 'Wrap the content of the code block'
    },
    unwrapCode: {
        id: 'fabric.editor.codeBlockWrapButton.unwrapCodeBlock',
        defaultMessage: 'Turn off wrap',
        description: 'Wrap the content of the code block'
    },
    selectLanguage: {
        id: 'fabric.editor.selectLanguage',
        defaultMessage: 'Select language',
        description: 'Code blocks display software code. A prompt to select the software language the code is written in.'
    }
});

});

parcelRegister("46A2h", function(module, exports) {

$parcel$export(module.exports, "toolbarInsertBlockMessages", () => $33ecf47745d659ba$export$70c8a7203d95247);

var $7qGN1 = parcelRequire("7qGN1");
const $33ecf47745d659ba$export$70c8a7203d95247 = (0, $7qGN1.defineMessages)({
    action: {
        id: 'fabric.editor.action',
        defaultMessage: 'Action item',
        description: "Also known as a \u201Ctask\u201D, \u201Cto do item\u201D, or a checklist"
    },
    actionDescription: {
        id: 'fabric.editor.action.description',
        defaultMessage: 'Create and assign action items',
        description: ''
    },
    closeInsertRightRail: {
        id: 'fabric.editor.insertRightRail.close',
        defaultMessage: 'Close',
        description: 'Close button label'
    },
    link: {
        id: 'fabric.editor.link',
        defaultMessage: 'Link',
        description: 'Insert a hyperlink'
    },
    linkDescription: {
        id: 'fabric.editor.link.description',
        defaultMessage: 'Insert a link',
        description: 'Insert a hyperlink'
    },
    mediaFiles: {
        id: 'fabric.editor.mediaFiles',
        defaultMessage: 'Image, video, or file',
        description: 'Insert one or more files, videos or images'
    },
    addMediaFiles: {
        id: 'fabric.editor.addMediaFiles',
        defaultMessage: 'Add image, video, or file',
        description: 'Insert one or more files, videos or images'
    },
    insertRightRailTitle: {
        id: 'fabric.editor.insertRightRail.title',
        defaultMessage: 'Insert',
        description: 'Insert a node into the document'
    },
    mediaFilesDescription: {
        id: 'fabric.editor.mediaFiles.description',
        defaultMessage: 'Add images and other files to your page',
        description: 'Insert one or more files or images'
    },
    image: {
        id: 'fabric.editor.image',
        defaultMessage: 'Image',
        description: 'Insert an image.'
    },
    mention: {
        id: 'fabric.editor.mention',
        defaultMessage: 'Mention',
        description: 'Reference another person in your document'
    },
    mentionDescription: {
        id: 'fabric.editor.mention.description',
        defaultMessage: 'Mention someone to send them a notification',
        description: 'Reference another person in your document'
    },
    emoji: {
        id: 'fabric.editor.emoji',
        defaultMessage: 'Emoji',
        description: 'Insert an emoticon or smiley :-)'
    },
    emojiDescription: {
        id: 'fabric.editor.emoji.description',
        defaultMessage: "Use emojis to express ideas \uD83C\uDF89 and emotions \uD83D\uDE04",
        description: 'Insert an emoticon or smiley :-)'
    },
    table: {
        id: 'fabric.editor.table',
        defaultMessage: 'Table',
        description: 'Inserts a table in the document'
    },
    tableDescription: {
        id: 'fabric.editor.table.description',
        defaultMessage: 'Insert a table',
        description: 'Inserts a table in the document'
    },
    tableSelector: {
        id: 'fabric.editor.tableSelector',
        defaultMessage: 'Table size',
        description: 'Opens a table selector that lets you insert a table of custom size'
    },
    tableSelectorDescription: {
        id: 'fabric.editor.tableSelector.description',
        defaultMessage: 'Add a table using popup to select a custom size',
        description: 'Opens a table selector that lets you insert a table of a custom size'
    },
    tableSizeSelectorButton: {
        id: 'fabric.editor.tableSizeSelectorButton',
        defaultMessage: '{numberOfColumns} by {numberOfRows}',
        description: 'Creates a table of custom size'
    },
    tableSizeSelectorPopup: {
        id: 'fabric.editor.tableSizeSelectorPopup',
        defaultMessage: 'Table size selector',
        description: 'Table selector popup to create table of custom size'
    },
    expand: {
        id: 'fabric.editor.expand',
        defaultMessage: 'Expand',
        description: 'Inserts an expand in the document'
    },
    expandDescription: {
        id: 'fabric.editor.expand.description',
        defaultMessage: 'Insert an expand',
        description: 'Inserts an expand in the document'
    },
    decision: {
        id: 'fabric.editor.decision',
        defaultMessage: 'Decision',
        description: "Capture a decision you\u2019ve made"
    },
    decisionDescription: {
        id: 'fabric.editor.decision.description',
        defaultMessage: "Capture decisions so they\u2019re easy to track",
        description: "Capture a decision you\u2019ve made"
    },
    feedbackDialog: {
        id: 'fabric.editor.feedbackDialog',
        defaultMessage: 'Give feedback',
        description: 'Open the feedback dialog from editor'
    },
    feedbackDialogDescription: {
        id: 'fabric.editor.feedbackDialog.description',
        defaultMessage: 'Tell us about your experience using the cloud editor',
        description: 'Description for feedback option under quick insert dropdown'
    },
    horizontalRule: {
        id: 'fabric.editor.horizontalRule',
        defaultMessage: 'Divider',
        description: 'A horizontal rule or divider'
    },
    horizontalRuleDescription: {
        id: 'fabric.editor.horizontalRule.description',
        defaultMessage: 'Separate content with a horizontal line',
        description: 'A horizontal rule or divider'
    },
    date: {
        id: 'fabric.editor.date',
        defaultMessage: 'Date',
        description: 'Opens a date picker that lets you select a date'
    },
    dateDescription: {
        id: 'fabric.editor.date.description',
        defaultMessage: 'Add a date using a calendar',
        description: 'Opens a date picker that lets you select a date'
    },
    placeholderText: {
        id: 'fabric.editor.placeholderText',
        defaultMessage: 'Placeholder text',
        description: 'Inserts a text placeholder into the page'
    },
    placeholderTextDescription: {
        id: 'fabric.editor.placeholderText.description',
        defaultMessage: 'Insert a text placeholder into the page',
        description: 'Inserts a text placeholder into the page'
    },
    columns: {
        id: 'fabric.editor.columns',
        defaultMessage: 'Layouts',
        description: 'Create a multi column section or layout'
    },
    columnsDescription: {
        id: 'fabric.editor.columns.description',
        defaultMessage: 'Structure your page using sections',
        description: 'Create a multi column section or layout'
    },
    columnsDescriptionAdvancedLayout: {
        id: 'fabric.editor.columns.advanced.layout.description',
        defaultMessage: 'Insert {numberOfColumns} equal {numberOfColumns, plural, one {column} other {columns}}',
        description: 'Create a multi column section or layout'
    },
    singleColumnsDescriptionAdvancedLayout: {
        id: 'fabric.editor.columns.advanced.layout.single.description',
        defaultMessage: 'Insert a single column layout',
        description: 'Create a multi column section or layout'
    },
    status: {
        id: 'fabric.editor.status',
        defaultMessage: 'Status',
        description: 'Inserts an item representing the status of an activity to task.'
    },
    statusDescription: {
        id: 'fabric.editor.status.description',
        defaultMessage: 'Add a custom status label',
        description: 'Inserts an item representing the status of an activity to task.'
    },
    viewMore: {
        id: 'fabric.editor.viewMore',
        defaultMessage: 'View more',
        description: 'View more elements that can be inserted'
    },
    viewMoreAriaLabel: {
        id: 'fabric.editor.viewMoreAriaLabel',
        defaultMessage: 'View all elements',
        description: 'A more descriptive aria label describing that users can view all the elements to be inserted.'
    },
    insertMenu: {
        id: 'fabric.editor.insertMenu',
        defaultMessage: 'Insert elements',
        description: 'Opens a menu of additional items that can be inserted into your document.'
    },
    help: {
        id: 'fabric.editor.help',
        defaultMessage: 'Help',
        description: 'Opens up the help dialog'
    },
    helpDescription: {
        id: 'fabric.editor.help.description',
        defaultMessage: 'Browse all the keyboard shortcuts and markdown options',
        description: 'Browse all the keyboard shortcuts and markdown options'
    },
    recordVideo: {
        id: 'fabric.editor.recordVideo',
        defaultMessage: 'Record a Loom video',
        description: 'Record a Loom video'
    },
    addLoomVideo: {
        id: 'fabric.editor.addLoomVideo',
        defaultMessage: 'Record a Loom video',
        description: 'Record a Loom video'
    },
    addLoomVideoComment: {
        id: 'fabric.editor.addLoomVideoComment',
        defaultMessage: 'Record a Loom video comment',
        description: 'Record a Loom video comment'
    },
    recordVideoDescription: {
        id: 'fabric.editor.recordVideo.description',
        defaultMessage: 'Record and share your screen and thoughts',
        description: 'Record and share your screen and thoughts'
    },
    recordLoomShortTitle: {
        id: 'fabric.editor.recordLoomShortTitle',
        defaultMessage: 'Record',
        description: 'Record'
    },
    turnInto: {
        id: 'fabric.editor.turnInto',
        defaultMessage: 'Turn into',
        description: 'Turn selected texts into another element containing those texts'
    }
});

});

parcelRegister("jSSd5", function(module, exports) {

$parcel$export(module.exports, "toolbarMessages", () => $ee2b3acd8c035b8b$export$81b075fd34c2f0bb);

var $7qGN1 = parcelRequire("7qGN1");
const $ee2b3acd8c035b8b$export$81b075fd34c2f0bb = (0, $7qGN1.defineMessages)({
    wrapLeft: {
        id: 'fabric.editor.wrapLeft',
        defaultMessage: 'Wrap left',
        description: 'Aligns your image to the left and wraps text around it.'
    },
    wrapRight: {
        id: 'fabric.editor.wrapRight',
        defaultMessage: 'Wrap right',
        description: 'Aligns your image to the right and wraps text around it.'
    },
    changeToMediaSingle: {
        id: 'fabric.editor.media_change_mediasingle',
        defaultMessage: 'Original size',
        description: 'In the context of a media inline image, it allows the user to convert it to media single'
    },
    changeToMediaInlineImage: {
        id: 'fabric.editor.media_change_mediainline_default',
        defaultMessage: 'Inline',
        description: 'In the context of media single contains media node, it allows the user to convert media single to media inline image'
    },
    changeToMediaInlineImageCaptionWarning: {
        id: 'fabric.editor.media_change_mediainline_caption_warn',
        defaultMessage: 'Inline (caption will be removed)',
        description: 'In the context of media single contains media node, it allows the user to convert media single to media inline image and warn user about caption being removed'
    }
});

});

parcelRegister("6dRXt", function(module, exports) {

$parcel$export(module.exports, "messages", () => $c19b855dc4027d63$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $c19b855dc4027d63$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    url: {
        id: 'fabric.editor.url',
        defaultMessage: 'Display URL',
        description: 'Convert the card to become a regular text-based hyperlink.'
    },
    block: {
        id: 'fabric.editor.displayBlock',
        defaultMessage: 'Display card',
        description: 'Display link as a card with a rich preview similar to in a Facebook feed with page title, description, and potentially an image.'
    },
    inline: {
        id: 'fabric.editor.displayInline',
        defaultMessage: 'Display inline',
        description: 'Display link with the title only.'
    },
    embed: {
        id: 'fabric.editor.displayEmbed',
        defaultMessage: 'Display embed',
        description: 'Display link as an embedded object'
    },
    link: {
        id: 'fabric.editor.displayLink',
        defaultMessage: 'Display as text',
        description: 'Convert the card to become a regular text-based hyperlink.'
    },
    card: {
        id: 'fabric.editor.cardFloatingControls',
        defaultMessage: 'Card options',
        description: 'Options to change card type'
    },
    blockCardUnavailable: {
        id: 'fabric.editor.blockCardUnavailable',
        defaultMessage: 'The inline link is inside {node} and cannot have its view changed',
        description: 'Warning message to show the user that this node cannot change its view'
    },
    displayOptionUnavailableInParentNode: {
        id: 'fabric.editor.displayOptionUnavailableInParentNode',
        defaultMessage: "This display option isn't available inside {node}",
        description: 'Warning message to show the user that this node option is not available inside a parent node type'
    },
    urlTitle: {
        id: 'fabric.editor.urlTitle',
        defaultMessage: 'URL',
        description: 'Title for option to convert the card to become a regular text-based hyperlink.'
    },
    blockTitle: {
        id: 'fabric.editor.blockTitle',
        defaultMessage: 'Card',
        description: 'Title for option to display link in the card view.'
    },
    inlineTitle: {
        id: 'fabric.editor.inlineTitle',
        defaultMessage: 'Inline',
        description: 'Title for option to display link in the inline view.'
    },
    openButtonTitle: {
        id: 'fabric.editor.openButtonTitle',
        defaultMessage: 'Open',
        description: 'Title for a button that opens a link when clicked.'
    },
    embedTitle: {
        id: 'fabric.editor.embedTitle',
        defaultMessage: 'Embed',
        description: 'Title for option to display link as an embedded object.'
    },
    urlDescription: {
        id: 'fabric.editor.urlDescription',
        defaultMessage: 'Display link as URL',
        description: 'Description for option to convert the card to become a regular text-based hyperlink.'
    },
    blockDescription: {
        id: 'fabric.editor.blockDescription',
        defaultMessage: 'Display more information about a link, including a summary and actions',
        description: 'Description for option to display link in the card view.'
    },
    inlineDescription: {
        id: 'fabric.editor.inlineDescription',
        defaultMessage: 'Display link as inline text',
        description: 'Description for option to display link in the inline view.'
    },
    embedDescription: {
        id: 'fabric.editor.ecombedDescription',
        defaultMessage: 'Display an interactive preview of a link',
        description: 'Description for option to display link as an embedded object.'
    },
    editDropdownExpandIconLabel: {
        id: 'fabric.editor.editDropdownExpandIconLabel',
        defaultMessage: 'Expand dropdown menu',
        description: 'Text of an icon to expand the dropdown'
    },
    editDropdownTriggerTitle: {
        id: 'fabric.editor.editDropdownTriggerTitle',
        defaultMessage: 'Edit',
        description: 'Text of a button to trigger opening an edit dropdown'
    },
    editDropdownEditLinkTitle: {
        id: 'fabric.editor.editDropdownEditLinkTitle',
        defaultMessage: 'Edit link',
        description: 'Edit dropdown edit link button text'
    },
    editDropdownEditDatasourceTitle: {
        id: 'fabric.editor.editDropdownEditDatasourceTitle',
        defaultMessage: 'Edit search query',
        description: 'Edit dropdown edit datasource button text'
    },
    datasourceTitle: {
        id: 'fabric.editor.datasourceTitle',
        defaultMessage: 'Edit search query',
        description: 'Tooltip of button to edit a card into a datasource'
    },
    datasourceAppearanceTitle: {
        id: 'fabric.editor.datasourceAppearanceTitle',
        defaultMessage: 'List',
        description: 'Tooltip of button to change to datasource appearance'
    },
    datasourceJiraIssue: {
        id: 'fabric.editor.datasource.jiraIssue',
        defaultMessage: 'Jira Issues',
        description: 'Insert a jira datasource table'
    },
    datasourceJiraIssueDescription: {
        id: 'fabric.editor.datasource.jiraIssue.description',
        defaultMessage: 'Insert Jira issues from Jira Cloud with enhanced search, filtering, and configuration.',
        description: 'Insert a jira datasource table'
    },
    datasourceAssetsObjectsGeneralAvailability: {
        id: 'fabric.editor.datasource.assetsObjectsGeneralAvailability',
        defaultMessage: 'Assets',
        description: 'Text displayed when selecting the type of data to include onto the page, in this case: JSM Assets objects.'
    },
    datasourceAssetsObjectsDescription: {
        id: 'fabric.editor.datasource.assetsObjects.description',
        defaultMessage: 'Insert objects from Assets in Jira Service Management with search and filtering',
        description: 'Description text displayed when selecting the type of data to include onto the page, in this case: JSM Assets objects'
    },
    inlineOverlay: {
        id: 'fabric.editor.inlineOverlay',
        defaultMessage: 'Configure',
        description: 'An overlay shown when hover over inline smart link to inform user that they can click the link to edit the links appearance.'
    },
    inlineConfigureLink: {
        id: 'fabric.editor.inlineConfigureLink',
        defaultMessage: 'Configure link',
        description: 'An icon shown when hovering over inline smart link to inform user they can click the icon to configure the links appearance.'
    },
    inlineGoToLink: {
        id: 'fabric.editor.inlineGoToLink',
        defaultMessage: 'Go to link',
        description: 'An option in the configure link dropdown that informs the user they can click the option to open the link'
    },
    datasourceConfluenceSearch: {
        id: 'fabric.editor.datasource.confluenceSearch',
        defaultMessage: 'Insert Confluence list',
        description: 'Title shown for Confluence Search datasource on QuickInsert options'
    },
    datasourceConfluenceSearchDescription: {
        id: 'fabric.editor.datasource.confluenceSearch.description',
        defaultMessage: 'Insert list of search results from Confluence with enhanced search, filtering, and configuration.',
        description: 'Description text displayed when selecting the type of data to include onto the page, in this case: Confluence Search objects'
    },
    datasourceJiraIssueIssueTermRefresh: {
        id: 'fabric.editor.datasource.jiraIssue.issue-term-refresh',
        defaultMessage: 'Jira Work Items',
        description: 'Insert a jira datasource table (Issue Terminology Refresh)'
    },
    datasourceJiraIssueDescriptionIssueTermRefresh: {
        id: 'fabric.editor.datasource.jiraIssue.description.issue-term-refresh',
        defaultMessage: 'Insert Jira work items from Jira Cloud with enhanced search, filtering, and configuration.',
        description: 'Insert a jira datasource table (Issue Terminology Refresh)'
    }
});

});

parcelRegister("1LIK6", function(module, exports) {

$parcel$export(module.exports, "messages", () => $b60a8f86e9d01be8$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $b60a8f86e9d01be8$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    toolbarLabel: {
        id: 'fabric.editor.toolbarLabel',
        defaultMessage: 'Editor',
        description: 'Label for the ARIA region landmark'
    },
    pageActionsLabel: {
        id: 'fabric.editor.pageActionsLabel',
        defaultMessage: 'Page actions',
        description: 'Label for the ARIA region landmark'
    },
    editableContentLabel: {
        id: 'fabric.editor.editableContentLabel',
        defaultMessage: 'Editable content',
        description: 'Label for the ARIA region landmark'
    }
});

});

parcelRegister("1D5wE", function(module, exports) {

$parcel$export(module.exports, "toolbarMessages", () => $ce22d229c4242f60$export$81b075fd34c2f0bb);

var $7qGN1 = parcelRequire("7qGN1");
const $ce22d229c4242f60$export$81b075fd34c2f0bb = (0, $7qGN1.defineMessages)({
    underline: {
        id: 'fabric.editor.underline',
        defaultMessage: 'Underline',
        description: 'Whether the text selection has underlined text'
    },
    strike: {
        id: 'fabric.editor.strike',
        defaultMessage: 'Strikethrough',
        description: 'Whether the text selection has crossed out text'
    },
    code: {
        id: 'fabric.editor.code',
        defaultMessage: 'Code',
        description: 'Whether the text selection has monospaced/code font'
    },
    codeOn: {
        id: 'fabric.editor.code.on',
        defaultMessage: '{textFormattingOff}, Code On',
        description: 'Reports that code formatting has been turned on'
    },
    subscript: {
        id: 'fabric.editor.subscript',
        defaultMessage: 'Subscript',
        description: 'Whether the text selection is written below the line in a slightly smaller size'
    },
    subscriptOffSuperscriptOn: {
        id: 'fabric.editor.subscript.off.superscript.on',
        defaultMessage: 'Subscript Off, Superscript On',
        description: 'Reports text formatting in case when subscript off and superscript on'
    },
    superscript: {
        id: 'fabric.editor.superscript',
        defaultMessage: 'Superscript',
        description: 'Whether the text selection is written above the line in a slightly smaller size'
    },
    superscriptOffSubscriptOn: {
        id: 'fabric.editor.superscript.off.subscript.on',
        defaultMessage: 'Superscript Off, Subscript On',
        description: 'Describe text formatting in case when Superscript Off and Subscript on'
    },
    clearFormatting: {
        id: 'fabric.editor.clearFormatting',
        defaultMessage: 'Clear formatting',
        description: 'Remove all rich text formatting from the selected text'
    },
    moreFormatting: {
        id: 'fabric.editor.moreFormatting',
        defaultMessage: 'More formatting',
        description: 'Clicking this will show a menu with additional formatting options'
    },
    textFormatting: {
        id: 'fabric.editor.textFormatting',
        defaultMessage: 'Text formatting',
        description: 'Aria label for the wrapper of text format buttons'
    },
    textFormat: {
        id: 'fabric.editor.textFormat',
        defaultMessage: 'Format text',
        description: 'Aria label for the wrapper of text format buttons'
    },
    bold: {
        id: 'fabric.editor.bold',
        defaultMessage: 'Bold',
        description: "This refers to bold or \u201Cstrong\u201D formatting, indicates that its contents have strong importance, seriousness, or urgency."
    },
    italic: {
        id: 'fabric.editor.italic',
        defaultMessage: 'Italic',
        description: 'This refers to italics or emphasized formatting.'
    },
    on: {
        id: 'fabric.editor.on',
        defaultMessage: '{formattingType} On',
        description: 'Reports that text formatting has been turned on'
    },
    off: {
        id: 'fabric.editor.off',
        defaultMessage: '{formattingType} Off',
        description: 'Reports that text formatting has been turned off'
    },
    textStyles: {
        id: 'fabric.editor.textStyles',
        defaultMessage: '{blockTypeName} Text styles',
        description: 'Menu label that provides access to various heading styles or normal text. For example: normal text styles, heading 1 text styles.'
    },
    textStylesTooltip: {
        id: 'fabric.editor.textStylesTooltip',
        defaultMessage: 'Text styles',
        description: 'Tooltip text for menu that provides access to various heading styles or normal text.'
    },
    textFormattingOff: {
        id: 'fabric.editor.text.formatting.off',
        defaultMessage: 'Text formatting Off',
        description: 'Reports that text formatting has been turned off'
    },
    navigateToEditorToolbar: {
        id: 'fabric.editor.navigate.toolbar.editor',
        defaultMessage: 'Navigate to editor toolbar',
        description: 'Navigate to the main editor toolbar.'
    },
    navigateToFloatingToolbar: {
        id: 'fabric.editor.navigate.toolbar.floating',
        defaultMessage: 'Navigate to floating toolbar',
        description: 'Navigate to a floating toolbar for relevant nodes (e.g. tables or panels).'
    },
    askAI: {
        id: 'fabric.editor.navigate.toolbar.askAI',
        defaultMessage: 'Ask AI',
        description: 'Open the AI panel to ask a question or generate content.'
    }
});

});

parcelRegister("fJeGS", function(module, exports) {

$parcel$export(module.exports, "messages", () => $d71b619850badb35$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $d71b619850badb35$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    tableOptions: {
        id: 'fabric.editor.tableOptions',
        defaultMessage: 'Table options',
        description: 'Opens a menu with additional table options'
    },
    tableSizeIncreaseScreenReaderInformation: {
        id: 'fabric.editor.tableResizeIncreaseScreenReaderInformation',
        defaultMessage: 'Table width increased to {newWidth, plural, one {# pixel} other {# pixels}}.',
        description: 'Information for screen reader users about increasing the table size by a certain number of pixels.'
    },
    tableSizeDecreaseScreenReaderInformation: {
        id: 'fabric.editor.tableResizeDecreaseScreenReaderInformation',
        defaultMessage: 'Table width decreased to {newWidth, plural, one {# pixel} other {# pixels}}.',
        description: 'Information for screen reader users about decreasing the table size by a certain number of pixels.'
    },
    headerRow: {
        id: 'fabric.editor.headerRow',
        defaultMessage: 'Header row',
        description: 'Marks the first table row as a header row'
    },
    headerColumn: {
        id: 'fabric.editor.headerColumn',
        defaultMessage: 'Header column',
        description: 'Marks the first table column as a header row'
    },
    numberedColumn: {
        id: 'fabric.editor.numberedColumn',
        defaultMessage: 'Numbered column',
        description: 'Adds an auto-numbering column to your table'
    },
    collapseTable: {
        id: 'fabric.editor.collapseTable',
        defaultMessage: 'Collapse table',
        description: 'Wraps table in an expand'
    },
    resizeTable: {
        id: 'fabric.editor.tables.resizeTable',
        defaultMessage: 'Resize table',
        description: 'Tooltip displayed on custom table width resize hande'
    },
    insertColumn: {
        id: 'fabric.editor.insertColumn',
        defaultMessage: 'Insert column right',
        description: 'Inserts a new column to the right of selected column.'
    },
    addColumnLeft: {
        id: 'fabric.editor.addColumnLeft',
        defaultMessage: 'Add column left',
        description: 'Adds a new column to the left of selected column.'
    },
    addColumnRight: {
        id: 'fabric.editor.addColumnRight',
        defaultMessage: 'Add column right',
        description: 'Adds a new column to the right of selected column.'
    },
    insertColumnDrag: {
        id: 'fabric.editor.insertColumnDrag',
        defaultMessage: 'Insert column',
        description: 'Inserts a new column to the right of selected column.'
    },
    removeColumns: {
        id: 'fabric.editor.removeColumns',
        defaultMessage: 'Delete {0, plural, one {column} other {columns}}',
        description: 'Deletes a table column.'
    },
    insertRow: {
        id: 'fabric.editor.insertRow',
        defaultMessage: 'Insert row below',
        description: 'Inserts a new row below the selected row.'
    },
    addRowAbove: {
        id: 'fabric.editor.addRowAbove',
        defaultMessage: 'Add row above',
        description: 'Adds a new row above the selected row.'
    },
    addRowBelow: {
        id: 'fabric.editor.addRowBelow',
        defaultMessage: 'Add row below',
        description: 'Adds a new row below the selected row.'
    },
    moveColumnLeft: {
        id: 'fabric.editor.moveColumnLeft',
        defaultMessage: 'Move {0, plural, one {column} other {columns}} left',
        description: 'Moves a column or columns to the left.'
    },
    moveColumnRight: {
        id: 'fabric.editor.moveColumnRight',
        defaultMessage: 'Move {0, plural, one {column} other {columns}} right',
        description: 'Moves a column or columns to the right.'
    },
    moveRowUp: {
        id: 'fabric.editor.moveRowUp',
        defaultMessage: 'Move {0, plural, one {row} other {rows}} up',
        description: 'Moves a row or selected rows up.'
    },
    moveRowDown: {
        id: 'fabric.editor.moveDownDown',
        defaultMessage: 'Move {0, plural, one {row} other {rows}} down',
        description: 'Moves a row or selected rows down.'
    },
    insertRowDrag: {
        id: 'fabric.editor.insertRowDrag',
        defaultMessage: 'Insert row',
        description: 'Inserts a new row below the selected row.'
    },
    removeRows: {
        id: 'fabric.editor.removeRows',
        defaultMessage: 'Delete {0, plural, one {row} other {rows}}',
        description: 'Deletes a table row.'
    },
    rowNumbers: {
        id: 'fabrid.editor.rowNumbers',
        defaultMessage: 'Row numbers',
        desciption: 'Adds a number to each row except header row'
    },
    rowsAreInserted: {
        id: 'fabric.editor.rowsAreInserted',
        defaultMessage: '{count, plural, one {A row has been} other {{count} rows have been}} inserted',
        description: 'Assistive message following the insertion of row(s)'
    },
    rowsAreRemoved: {
        id: 'fabric.editor.rowsAreRemoved',
        defaultMessage: '{count, plural, one {The row has been} other {{count} rows have been}} removed',
        description: 'Assistive message following the removal of row(s)'
    },
    rowSelected: {
        id: 'fabric.editor.rowSelected',
        defaultMessage: 'Row {index} of {total} selected',
        description: 'Assistive message following the selection of a row'
    },
    rowMovedUp: {
        id: 'fabric.editor.rowMovedUp',
        defaultMessage: 'Row moved up to {index} of {total}',
        description: 'Assistive message following the upward movement of a row'
    },
    rowMovedDown: {
        id: 'fabric.editor.rowMovedDown',
        defaultMessage: 'Row moved down to {index} of {total}',
        description: 'Assistive message following the downward movement of a row'
    },
    columnsAreInserted: {
        id: 'fabric.editor.columnsAreInserted',
        defaultMessage: '{count, plural, one {A column has been} other {{count} columns have been}} inserted',
        description: 'Assistive message following the insertion of column(s)'
    },
    columnsAreRemoved: {
        id: 'fabric.editor.columnsAreRemoved',
        defaultMessage: '{count, plural, one {The column has been} other {{count} columns have been}} removed',
        description: 'Assistive message following the removal of column(s)'
    },
    columnSelected: {
        id: 'fabric.editor.columnSelected',
        defaultMessage: 'Column {index} of {total} selected',
        description: 'Assistive message following the selection of a column'
    },
    columnMovedLeft: {
        id: 'fabric.editor.columnMovedLeft',
        defaultMessage: 'Column moved left to {index} of {total}',
        description: 'Assistive message following the left movement of a column'
    },
    columnMovedRight: {
        id: 'fabric.editor.columnMovedRight',
        defaultMessage: 'Column moved right to {index} of {total}',
        description: 'Assistive message following the right movement of a column'
    },
    cellOptions: {
        id: 'fabric.editor.cellOptions',
        defaultMessage: 'Cell options',
        description: 'Opens a menu with options for the current table cell.'
    },
    confirmDeleteLinkedModalOKButton: {
        id: 'fabric.editor.tables.confirmDeleteLinkedModalOKButton',
        defaultMessage: 'Delete',
        description: 'Action button label for confirm modal when deleting a table linked to an extension.'
    },
    confirmDeleteLinkedModalMessage: {
        id: 'fabric.editor.tables.confirmDeleteLinkedModalMessage',
        defaultMessage: 'Deleting {nodeName} will break anything connected to it.',
        description: 'Message for confirm modal when deleting a table linked to an extension.'
    },
    confirmDeleteLinkedModalMessagePrefix: {
        id: 'fabric.editor.extension.confirmDeleteLinkedModalMessagePrefix',
        defaultMessage: 'Deleting',
        description: 'prefix for confirmation dialog text'
    },
    confirmModalCheckboxLabel: {
        id: 'fabric.editor.floatingToolbar.confirmModalCheckboxLabel',
        defaultMessage: 'Also delete connected elements',
        description: 'checkbox label text'
    },
    deleteElementTitle: {
        id: 'fabric.editor.extension.deleteElementTitle',
        defaultMessage: 'Delete element',
        description: 'Title text for confirm modal when deleting an extension linked to a data consumer.'
    },
    unnamedSource: {
        id: 'fabric.editor.extension.sourceNoTitledName',
        defaultMessage: 'this element',
        description: 'The current element without preset name been selected'
    },
    adjustColumns: {
        id: 'fabric.editor.tables.adjustColumn',
        defaultMessage: 'Adjust column',
        description: 'Tooltip displayed on table column resize handle'
    },
    cornerControl: {
        id: 'fabric.editor.cornerControl',
        defaultMessage: 'Highlight table',
        description: 'A button on the upper left corner of the table that shows up when the table is in focus. Clicking on it will select the entire table.'
    },
    cellBackground: {
        id: 'fabric.editor.cellBackground',
        defaultMessage: 'Cell background',
        description: 'Change the background color of a table cell.'
    },
    backgroundColor: {
        id: 'fabric.editor.backgroundColor',
        defaultMessage: 'Background color',
        description: 'Change the background color of a table cell.'
    },
    mergeCells: {
        id: 'fabric.editor.mergeCells',
        defaultMessage: 'Merge cells',
        description: 'Merge tables cells together.'
    },
    splitCell: {
        id: 'fabric.editor.splitCell',
        defaultMessage: 'Split cell',
        description: 'Split a merged table cell.'
    },
    clearCells: {
        id: 'fabric.editor.clearCells',
        defaultMessage: 'Clear {0, plural, one {cell} other {cells}}',
        description: 'Clears the contents of the selected cells (this does not delete the cells themselves).'
    },
    sortColumnASC: {
        id: 'fabric.editor.sortColumnASC',
        defaultMessage: "Sort column A \u2192 Z",
        description: 'Sort column in ascending order'
    },
    sortColumnDESC: {
        id: 'fabric.editor.sortColumnDESC',
        defaultMessage: "Sort column Z \u2192 A",
        description: 'Sort column in descending order'
    },
    sortColumnIncreasing: {
        id: 'fabric.editor.sortColumnIncreasing',
        defaultMessage: 'Sort increasing',
        description: 'Sort column in ascending order'
    },
    sortColumnDecreasing: {
        id: 'fabric.editor.sortColumnDecreasing',
        defaultMessage: 'Sort decreasing',
        description: 'Sort column in descending order'
    },
    canNotSortTable: {
        id: 'fabric.editor.canNotSortTable',
        defaultMessage: `\u{26A0}\u{FE0F} You can't sort a table with merged cells`,
        description: `Split your cells to enable this feature`
    },
    distributeColumns: {
        id: 'fabric.editor.distributeColumns',
        defaultMessage: `Distribute columns`,
        description: `Distribute widths between selected columns`
    },
    lockColumnWidths: {
        id: 'fabric.editor.lockColumns',
        defaultMessage: 'Fixed column widths',
        description: 'Toggle button to enable fixed column widths'
    },
    rowControl: {
        id: 'fabric.editor.rowControl',
        defaultMessage: 'Highlight row',
        description: 'A button on the left of each row that shows up when the table is in focus. Clicking on it will select the entire row.'
    },
    rowDragHandle: {
        id: 'fabric.editor.rowDragHandle',
        defaultMessage: 'Row options',
        description: 'The row drag handle to move the row within the table. Click to open a menu for more row options.'
    },
    columnDragHandle: {
        id: 'fabric.editor.columnDragHandle',
        defaultMessage: 'Column options',
        description: 'The column drag handle to move the column within the table. Click to open a menu for more column options.'
    },
    fullWidthLabel: {
        id: 'fabric.editor.tableFullWidthLabel',
        defaultMessage: 'Full-width',
        description: 'Trigger table width to full-width mode'
    },
    startedColumnResize: {
        id: 'fabric.editor.tables.startedColumnResize',
        defaultMessage: 'Started column resize',
        description: 'Screen Reader announces when the user engages the column resizer'
    },
    focusedOtherResize: {
        id: 'fabric.editor.tables.otherResize',
        defaultMessage: '{direction, select, left {Switched to the left column resize} right {Switched to the right column resize} other {}}',
        description: 'Screen Reader announces when the user switches to the left or right column resizer'
    },
    changedColumnWidth: {
        id: 'fabric.editor.tables.columnWidth',
        defaultMessage: '{width, plural, one {Column width was changed to {width} pixel} other {Column width was changed to {width} pixels}}',
        description: 'Screen Reader announces when the user modifies the column width'
    },
    columnResizeStop: {
        id: 'fabric.editor.tables.resizeStop',
        defaultMessage: 'Stopped resize',
        description: 'Screen Reader announces when the user discontinues the resizing operation'
    },
    columnResizeOverflow: {
        id: 'fabric.editor.tables.columnResizeOverflow',
        defaultMessage: 'You can only resize this column while the table has a scroll bar.',
        description: 'Screen Reader announces when the user attempts to resize the last column without the table being in overflow state'
    },
    columnResizeLast: {
        id: 'fabric.editor.tables.columnResizeLast',
        defaultMessage: 'You can only resize this column to the left.',
        description: 'Screen Reader announces when the user attempts to resize the last column when only the previous one is available for resizing'
    },
    tableAlignmentOptions: {
        id: 'fabric.editor.tableAlignmentOptions',
        defaultMessage: 'Alignment options',
        description: 'Opens a menu with additional table alignment options'
    },
    alignTableCenter: {
        id: 'fabric.editor.alignTableCenter',
        defaultMessage: 'Align center',
        description: 'Aligns table to the center'
    },
    alignTableLeft: {
        id: 'fabric.editor.alignTableLeft',
        defaultMessage: 'Align left',
        description: 'Aligns table to the left'
    }
});

});

parcelRegister("eCOhn", function(module, exports) {

$parcel$export(module.exports, "messages", () => $45c2fe7a1b237ebb$export$defe85febe8b728c);
// Common Translations will live here

var $7qGN1 = parcelRequire("7qGN1");
const $45c2fe7a1b237ebb$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    unorderedList: {
        id: 'fabric.editor.unorderedList',
        defaultMessage: 'Bullet list',
        description: "A list with bullets. Also known as an \u201Cunordered\u201D list"
    },
    unorderedListDescription: {
        id: 'fabric.editor.unorderedList.description',
        defaultMessage: 'Create an unordered list',
        description: ''
    },
    orderedList: {
        id: 'fabric.editor.orderedList',
        defaultMessage: 'Numbered list',
        description: "A list with ordered items 1\u2026 2\u2026 3\u2026"
    },
    orderedListDescription: {
        id: 'fabric.editor.orderedList.description',
        defaultMessage: 'Create an ordered list',
        description: ''
    },
    lists: {
        id: 'fabric.editor.lists',
        defaultMessage: 'Lists',
        description: 'Menu shows ordered/bullet list and unordered/numbered lists'
    },
    listsFormat: {
        id: 'fabric.editor.listsFormat',
        defaultMessage: 'List formatting',
        description: 'Aria label for the wrapper of list buttons'
    }
});

});

parcelRegister("iW8Cl", function(module, exports) {

$parcel$export(module.exports, "messages", () => $8bb64a7e24bfadd9$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $8bb64a7e24bfadd9$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    undo: {
        id: 'fabric.editor.undo',
        defaultMessage: 'Undo',
        description: 'Undo the previously performed action.'
    },
    redo: {
        id: 'fabric.editor.redo',
        defaultMessage: 'Redo',
        description: 'Redo the previously undone action.'
    }
});

});

parcelRegister("2EHqK", function(module, exports) {

$parcel$export(module.exports, "messages", () => $fd160dd2be67857e$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $fd160dd2be67857e$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    statusEditorLabel: {
        id: 'fabric.editor.statusEditorLabel',
        defaultMessage: 'Status editor',
        description: 'Label for the status element editor'
    },
    placeholder: {
        id: 'fabric.editor.statusPlaceholder',
        defaultMessage: 'Set a status',
        description: 'Placeholder description for an empty (new) status item in the editor'
    },
    editText: {
        id: 'fabric.editor.editStatusText',
        defaultMessage: 'Edit Status',
        description: 'Title for the input that changes the status text'
    },
    editColor: {
        id: 'fabric.editor.editStatusColor',
        defaultMessage: 'Edit Status Color',
        description: 'Title for the color picker that changes the status color'
    },
    statusPickerOpenedAlert: {
        id: 'fabric.editor.statusPickerOpenedAlert',
        defaultMessage: 'Status editor popup opened, press Tab to access popup',
        description: 'Screen reader alert when the status picker is opened, letting the user know they can press the Tab button to access the status picker'
    }
});

});

parcelRegister("cINgv", function(module, exports) {

$parcel$export(module.exports, "messages", () => $1eca0ac9b99404a8$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $1eca0ac9b99404a8$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    editText: {
        id: 'fabric.editor.editDateText',
        defaultMessage: 'Edit Date',
        description: 'Title for the input that changes the date'
    },
    invalidDateError: {
        id: 'fabric.editor.invalidDateError',
        defaultMessage: 'Enter a valid date',
        description: 'Error message when the date typed in is invalid, requesting they inputs a new date'
    },
    onKeyUpDownText: {
        id: 'fabric.editor.upDown',
        defaultMessage: 'On the use of up and down arrow keys into the following input field, the date will update below',
        description: 'The text for the date input informs the user that using the arrow keys (up and down) will update the date picker below'
    },
    datePickerOpenedAlert: {
        id: 'fabric.editor.datePickerOpenedAlert',
        defaultMessage: 'Date editor popup opened, press Tab to access popup',
        description: 'Screen reader alert when the date picker is opened, letting the user know they can press the Tab button to access the date picker'
    }
});

});

parcelRegister("iRGZx", function(module, exports) {

$parcel$export(module.exports, "toolbarMessages", () => $4c7e049146e1f690$export$81b075fd34c2f0bb);

var $7qGN1 = parcelRequire("7qGN1");
const $4c7e049146e1f690$export$81b075fd34c2f0bb = (0, $7qGN1.defineMessages)({
    singleColumn: {
        id: 'fabric.editor.single',
        defaultMessage: 'Single column layout',
        description: 'Layout with one single column'
    },
    twoColumns: {
        id: 'fabric.editor.twoColumns',
        defaultMessage: 'Two columns layout',
        description: 'Layout with two columns of equal width'
    },
    singleColumnAdvancedLayout: {
        id: 'fabric.editor.singleColumns',
        defaultMessage: '1 Column layout',
        description: 'Layout with one column of equal width'
    },
    twoColumnsAdvancedLayout: {
        id: 'fabric.editor.twoColumns',
        defaultMessage: '2 Column layout',
        description: 'Layout with two columns of equal width'
    },
    threeColumns: {
        id: 'fabric.editor.threeColumns',
        defaultMessage: 'Three columns layout',
        description: 'Layout with three columns of equal width'
    },
    threeColumnsAdvancedLayout: {
        id: 'fabric.editor.threeColumns',
        defaultMessage: '3 Column layout',
        description: 'Layout with three columns of equal width'
    },
    fourColumns: {
        id: 'fabric.editor.fourColumns',
        defaultMessage: '4 Column layout',
        description: 'Layout with four columns of equal width'
    },
    fiveColumns: {
        id: 'fabric.editor.fiveColumns',
        defaultMessage: '5 Column layout',
        description: 'Layout with five columns of equal width'
    },
    rightSidebar: {
        id: 'fabric.editor.rightSidebar',
        defaultMessage: 'Right sidebar layout',
        description: 'Layout with two columns, left column is 2/3 and right is 1/3 of page'
    },
    leftSidebar: {
        id: 'fabric.editor.leftSidebar',
        defaultMessage: 'Left sidebar layout',
        description: 'Layout with two columns, left column is 1/3 and right is 2/3 of page'
    },
    threeColumnsWithSidebars: {
        id: 'fabric.editor.threeColumnsWithSidebars',
        defaultMessage: 'Three columns with sidebars layout',
        description: 'Layout with 3 columns laid out as 25% - 50% - 25%'
    },
    threeColumnsWithLeftSidebars: {
        id: 'fabric.editor.threeColumnsWithLeftSidebars',
        defaultMessage: 'Three columns with left sidebar layout',
        description: 'Layout with 3 columns laid out as 25% - 25% - 50%'
    },
    threeColumnsWithRightSidebars: {
        id: 'fabric.editor.threeColumnsWithRightSidebars',
        defaultMessage: 'Three columns with right sidebar layout',
        description: 'Layout with 3 columns laid out as 50% - 25% - 25%'
    },
    floatingToolbarRadioGroupAriaLabel: {
        id: 'fabric.editor.floatingToolbar.floatingToolbarRadioGroupAriaLabel',
        defaultMessage: 'Layout options',
        description: "a floating toolbar radiogroup's aria label"
    },
    layoutPlaceholder: {
        id: 'fabric.editor.layout.placeholder',
        defaultMessage: 'Add content',
        description: 'Add placeholder text for empty layout'
    },
    controlslayoutPlaceholder: {
        id: 'fabric.editor.layout.controls.placeholder',
        defaultMessage: '/ to insert',
        description: 'Add placeholder text for empty layout'
    },
    columnOption: {
        id: 'fabric.editor.layout.columnOption',
        defaultMessage: '{count, plural, one {{count} Column} other {{count} Columns}}',
        description: 'column option text for layout'
    },
    resizeLayout: {
        id: 'fabric.editor.layout.resizeLayout',
        defaultMessage: 'Resize layout',
        description: 'resize layout'
    }
});

});

parcelRegister("7g31l", function(module, exports) {

$parcel$export(module.exports, "messages", () => $7bbed4c82e53e478$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $7bbed4c82e53e478$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    indent: {
        id: 'fabric.editor.indent',
        defaultMessage: 'Indent',
        description: 'Indent a list item, paragraph or heading'
    },
    outdent: {
        id: 'fabric.editor.outdent',
        defaultMessage: 'Outdent',
        description: 'Outdent a list item, paragraph or heading'
    }
});

});

parcelRegister("cfB8F", function(module, exports) {

$parcel$export(module.exports, "avatarGroupMessages", () => $a6cec650fc40f0ef$export$8a0e7c3f8f5b8868);

var $7qGN1 = parcelRequire("7qGN1");
const $a6cec650fc40f0ef$export$8a0e7c3f8f5b8868 = (0, $7qGN1.defineMessages)({
    editors: {
        id: 'fabric.editor.editors',
        defaultMessage: 'Editors',
        description: 'classifying the people that are currently editing the document'
    }
});

});

parcelRegister("cDtOg", function(module, exports) {

$parcel$export(module.exports, "findReplaceMessages", () => $a66c45e29fd21165$export$b46a930e1a386b2e);

var $7qGN1 = parcelRequire("7qGN1");
const $a66c45e29fd21165$export$b46a930e1a386b2e = (0, $7qGN1.defineMessages)({
    find: {
        id: 'fabric.editor.find',
        defaultMessage: 'Find',
        description: 'The word or phrase to search for on the document'
    },
    matchCase: {
        id: 'fabric.editor.matchCase',
        defaultMessage: 'Match case',
        description: 'Toggle whether should also match case when searching for text'
    },
    findNext: {
        id: 'fabric.editor.findNext',
        defaultMessage: 'Find next',
        description: 'Locate the next occurrence of the word or phrase that was searched for'
    },
    findPrevious: {
        id: 'fabric.editor.findPrevious',
        defaultMessage: 'Find previous',
        description: 'Locate the previous occurrence of the word or phrase that was searched for'
    },
    closeFindReplaceDialog: {
        id: 'fabric.editor.closeFindReplaceDialog',
        defaultMessage: 'Close',
        description: 'Cancel search and close the "Find and Replace" dialog'
    },
    noResultsFound: {
        id: 'fabric.editor.noResultsFound',
        defaultMessage: 'No results',
        description: 'No matches were found for the word or phrase that was searched for'
    },
    resultsCount: {
        id: 'fabric.editor.resultsCount',
        description: 'Text for selected search match position and total results count',
        defaultMessage: '{selectedMatchPosition} of {totalResultsCount}'
    },
    findReplaceToolbarButton: {
        id: 'fabric.editor.findReplaceToolbarButton',
        defaultMessage: 'Find and replace',
        description: '"Find" highlights all instances of a word or phrase on the document, and "Replace" changes one or all of those instances to something else'
    },
    replaceWith: {
        id: 'fabric.editor.replaceWith',
        defaultMessage: 'Replace with',
        description: 'The value that will replace the word or phrase that was searched for'
    },
    replace: {
        id: 'fabric.editor.replace',
        defaultMessage: 'Replace',
        description: 'Replace only the currently selected instance of the word or phrase'
    },
    replaceAll: {
        id: 'fabric.editor.replaceAll',
        defaultMessage: 'Replace all',
        description: 'Replace all instances of the word or phrase throughout the entire document'
    },
    replaceSuccess: {
        id: 'fabric.editor.replaceSuccess',
        defaultMessage: '{numberOfMatches, plural, one {# match replaced} other {# matches replaced}}',
        description: 'Text when replacement succesfully done'
    }
});

});

parcelRegister("4DFTL", function(module, exports) {

$parcel$export(module.exports, "elementInsertSidePanel", () => $d008cf8ca1405ef2$export$276a218f93338b76);

var $7qGN1 = parcelRequire("7qGN1");
const $d008cf8ca1405ef2$export$276a218f93338b76 = (0, $7qGN1.defineMessages)({
    title: {
        id: 'fabric.editor.elementInsertSidePanel.title',
        defaultMessage: 'Insert',
        description: 'Title of a panel that opens on the side'
    }
});

});

parcelRegister("DGjKK", function(module, exports) {

$parcel$export(module.exports, "textColorMessages", () => $d285b988275b721e$export$effb4ee8b6f74abe);

var $7qGN1 = parcelRequire("7qGN1");
const $d285b988275b721e$export$effb4ee8b6f74abe = (0, $7qGN1.defineMessages)({
    textColor: {
        id: 'fabric.editor.textColor',
        defaultMessage: '{selectedColorName} Text color',
        description: 'Label of menu that provides access to various colors of text. For example: green Text color, dark blue Text color'
    },
    textColorTooltip: {
        id: 'fabric.editor.textColorTooltip',
        defaultMessage: 'Text color',
        description: 'Toolip of menu that provides access to various colors of text.'
    }
});

});

parcelRegister("fbDBV", function(module, exports) {

$parcel$export(module.exports, "tasksAndDecisionsMessages", () => $7a785933fd3c87cb$export$273d864e9e6d0b1f);

var $7qGN1 = parcelRequire("7qGN1");
const $7a785933fd3c87cb$export$273d864e9e6d0b1f = (0, $7qGN1.defineMessages)({
    taskPlaceholder: {
        id: 'fabric.editor.taskPlaceholder',
        defaultMessage: "Type your action, use '@' to assign to someone.",
        description: 'Placeholder description for an empty action/task in the editor'
    },
    decisionPlaceholder: {
        id: 'fabric.editor.decisionPlaceholder',
        defaultMessage: "Add a decision\u2026",
        description: 'Placeholder description for an empty decision in the editor'
    },
    editAccessTitle: {
        id: 'fabric.editor.editAccessTitle',
        defaultMessage: 'You need edit access',
        description: 'Title in the popup when we click on action item checkbox without edit permission'
    },
    requestToEditDescription: {
        id: 'fabric.editor.requestToEditDescription',
        defaultMessage: 'When you request access, the page owner will receive a notification.',
        description: 'Description in the popup when we click on action item checkbox without edit permission'
    },
    requestToEdit: {
        id: 'fabric.editor.requestToEdit',
        defaultMessage: 'Request to edit',
        description: 'Button in the popup when we click on action item checkbox without edit permission'
    },
    dismiss: {
        id: 'fabric.editor.requestToEditDismiss',
        defaultMessage: 'Dismiss',
        description: 'Button in the popup when we click on dismiss without edit permission'
    },
    markTaskAsCompleted: {
        id: 'fabric.editor.taskDecision.markTaskAsCompleted',
        defaultMessage: 'Mark task as completed',
        description: 'Button to mark a task as complete in the editor'
    },
    markTaskAsNotCompleted: {
        id: 'fabric.editor.taskDecision.markTaskAsNotCompleted',
        defaultMessage: 'Mark task as not completed',
        description: 'Button to mark a task as not complete in the editor'
    }
});

});

parcelRegister("dfJR8", function(module, exports) {

$parcel$export(module.exports, "placeholderTextMessages", () => $61bb10fca263c45e$export$ee8ab8a034b5a8bd);

var $7qGN1 = parcelRequire("7qGN1");
const $61bb10fca263c45e$export$ee8ab8a034b5a8bd = (0, $7qGN1.defineMessages)({
    placeholderTextPlaceholder: {
        id: 'fabric.editor.placeholderTextPlaceholder',
        defaultMessage: 'Add placeholder text',
        description: ''
    },
    shortEmptyNodePlaceholderText: {
        id: 'fabric.editor.shortEmptyNodePlaceholderText',
        defaultMessage: '/ to insert',
        description: 'Short placeholder text for empty nodes'
    },
    longEmptyNodePlaceholderText: {
        id: 'fabric.editor.longEmptyNodePlaceholderText',
        defaultMessage: 'Type / to insert elements',
        description: 'Long placeholder text for empty nodes'
    }
});

});

parcelRegister("dH8bz", function(module, exports) {

$parcel$export(module.exports, "pasteOptionsToolbarMessages", () => $403965a26c78acdb$export$703e803e9cb0cea4);

var $7qGN1 = parcelRequire("7qGN1");
const $403965a26c78acdb$export$703e803e9cb0cea4 = (0, $7qGN1.defineMessages)({
    pasteOptions: {
        id: 'fabric.editor.pasteOptions',
        defaultMessage: 'Paste options',
        description: 'Opens a menu with additional paste options'
    },
    plainText: {
        id: 'fabric.editor.plainText',
        defaultMessage: 'Use plain text',
        description: 'Converts pasted text into plain text'
    },
    markdown: {
        id: 'fabric.editor.useMarkdown',
        defaultMessage: 'Use Markdown',
        description: 'Converts pasted text into Markdown'
    },
    richText: {
        id: 'fabric.editor.richText',
        defaultMessage: 'Use rich text',
        description: 'Converts pasted text into Rich text'
    }
});

});

parcelRegister("gjx6N", function(module, exports) {

$parcel$export(module.exports, "panelMessages", () => $972b12a409cadd14$export$7bb18eb6f9170174);

var $7qGN1 = parcelRequire("7qGN1");
const $972b12a409cadd14$export$7bb18eb6f9170174 = (0, $7qGN1.defineMessages)({
    info: {
        id: 'fabric.editor.info',
        defaultMessage: 'Info',
        description: 'Panels provide a way to highlight text. The info panel has a blue background.'
    },
    note: {
        id: 'fabric.editor.note',
        defaultMessage: 'Note',
        description: 'Panels provide a way to highlight text. The note panel has a purple background.'
    },
    success: {
        id: 'fabric.editor.success',
        defaultMessage: 'Success',
        description: 'Panels provide a way to highlight text. The success panel has a green background.'
    },
    warning: {
        id: 'fabric.editor.warning',
        defaultMessage: 'Warning',
        description: 'Panels provide a way to highlight text. The warning panel has a yellow background.'
    },
    error: {
        id: 'fabric.editor.error',
        defaultMessage: 'Error',
        description: 'Panels provide a way to highlight text. The error panel has a red background.'
    },
    emoji: {
        id: 'fabric.editor.panel.emoji',
        defaultMessage: 'Add emoji',
        description: 'Select the panel icon'
    },
    custom: {
        id: 'fabric.editor.panel.custom',
        defaultMessage: 'Custom',
        description: 'Custom panels where user has selected custom emoji and background color'
    },
    backgroundColor: {
        id: 'fabric.editor.panel.backgroundColor',
        defaultMessage: 'Background color',
        description: 'Select the panel background color.'
    },
    panelsGroup: {
        id: 'fabric.editor.panel.panelsGroup',
        defaultMessage: 'Panel Types',
        description: 'aria-label for group of panels the floating toolbar'
    }
});

});

parcelRegister("h6V7a", function(module, exports) {

$parcel$export(module.exports, "mentionMessages", () => $2c98be67879905c5$export$33aafd5ccbbbd00a);

var $7qGN1 = parcelRequire("7qGN1");
const $2c98be67879905c5$export$33aafd5ccbbbd00a = (0, $7qGN1.defineMessages)({
    inviteItemTitle: {
        id: 'fabric.editor.inviteItem.title',
        defaultMessage: '{userRole, select, admin {Invite} trusted {Invite} other {Add}} teammate to {productName}',
        description: 'Title of the invite teammate item in typeahead plugin'
    },
    mentionsAddLabel: {
        id: 'fabric.editor.mentionsAddLabel',
        defaultMessage: 'add-icon',
        description: 'icon label to describe adding a new mention'
    },
    mentionsIconLabel: {
        id: 'fabric.editor.mentionsIconLabel',
        defaultMessage: 'Mention',
        description: 'icon label to describe the mention icon'
    },
    mentionsNodeLabel: {
        id: 'fabric.editor.mentionNode.label',
        defaultMessage: 'Tagged user',
        description: 'Label to indicate mention node to Screen reader users, that preceeds with user name ex: "Tagged user @XXX'
    },
    unknownLabel: {
        id: 'fabric.editor.unknown.label',
        defaultMessage: 'Unknown',
        description: 'Label to indicate unknown mention node'
    }
});

});

parcelRegister("gYWwp", function(module, exports) {

$parcel$export(module.exports, "helpDialogMessages", () => $899ee4221ade9631$export$83c85447c71428ba);

var $7qGN1 = parcelRequire("7qGN1");
const $899ee4221ade9631$export$83c85447c71428ba = (0, $7qGN1.defineMessages)({
    editorHelp: {
        id: 'fabric.editor.editorHelp',
        defaultMessage: 'Editor help',
        description: 'Title of editor help dialog.'
    },
    helpDialogTips: {
        id: 'fabric.editor.helpDialogTips',
        defaultMessage: 'Press {keyMap} to quickly open this dialog at any time',
        description: 'Hint about how to open a dialog quickly using a shortcut.'
    },
    keyboardShortcuts: {
        id: 'fabric.editor.keyboardShortcuts',
        defaultMessage: 'Keyboard shortcuts',
        description: ''
    },
    markdown: {
        id: 'fabric.editor.markdown',
        defaultMessage: 'Markdown',
        description: 'It is a name of popular markup language.'
    },
    pastePlainText: {
        id: 'fabric.editor.pastePlainText',
        defaultMessage: 'Paste plain text',
        description: ''
    },
    CheckUncheckActionItem: {
        id: 'fabric.editor.checkUncheckActionItem',
        defaultMessage: 'Toggle action item',
        description: 'For Check/Uncheck Action item use shortcut'
    },
    InsertTableColumn: {
        id: 'fabric.editor.insertTableColumn',
        defaultMessage: 'Insert table column',
        description: 'For insert table column'
    },
    InsertTableRow: {
        id: 'fabric.editor.insertTableRow',
        defaultMessage: 'Insert table row',
        description: 'For insert table row'
    },
    altText: {
        id: 'fabric.editor.altText',
        defaultMessage: 'Alt text',
        description: 'Alternative text for image.'
    },
    selectTableRow: {
        id: 'fabric.editor.selectTableRow',
        defaultMessage: 'Select table row',
        description: 'Hint for selecting a table row using a shortcut'
    },
    selectTableColumn: {
        id: 'fabric.editor.selectTableColumn',
        defaultMessage: 'Select table column',
        description: 'Hint for selecting a table column using a shortcut'
    },
    selectColumnResize: {
        id: 'fabric.editor.selectColumnResize',
        defaultMessage: 'Select column resize',
        description: 'Hint for selecting a column resize a shortcut'
    },
    increaseSize: {
        id: 'fabric.editor.increaseSize',
        defaultMessage: 'Increase table or media size',
        description: 'The text is shown as an shortcut description in help dialog modal, when the user uses the described shortcut, he is able to increase the width of the selected element. Optimal characters less than 21.'
    },
    increaseElementSize: {
        id: 'fabric.editor.increaseElementSize',
        defaultMessage: 'Increase element size',
        description: 'The text is shown as an shortcut description in help dialog modal, when the user uses the described shortcut, he is able to increase the width of the selected element. Optimal characters less than 21.'
    },
    decreaseSize: {
        id: 'fabric.editor.decreaseSize',
        defaultMessage: 'Decrease table or media size',
        description: 'The text is shown as an shortcut description in help dialog modal, when the user uses the described shortcut, he is able to decrease the width of the selected element. Optimal characters less than 21.'
    },
    decreaseElementSize: {
        id: 'fabric.editor.decreaseElementSize',
        defaultMessage: 'Decrease element size',
        description: 'The text is shown as an shortcut description in help dialog modal, when the user uses the described shortcut, he is able to decrease the width of the selected element. Optimal characters less than 21.'
    },
    openCellOptions: {
        id: 'fabric.editor.openCellOptions',
        defaultMessage: 'Open cell options',
        description: 'Keyboard shortcut to open cell options.'
    },
    focusTableResizeHandle: {
        id: 'fabric.editor.focusTableResizeHandle',
        defaultMessage: 'Focus table resize handle',
        description: 'Focus table resize handle'
    },
    closeHelpDialog: {
        id: 'fabric.editor.closeHelpDialog',
        defaultMessage: 'Close help dialog',
        description: ''
    },
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: Move it inside quick insert plugin
    quickInsert: {
        id: 'fabric.editor.quickInsert',
        defaultMessage: 'Quick insert',
        description: 'Name of a feature, which let you insert items quickly.'
    },
    highlightColor: {
        id: 'fabric.editor.highlightColor',
        defaultMessage: 'Toggle highlight color palette',
        description: 'Keyboard shortcut to toggle highlight color palette.'
    }
});

});

parcelRegister("jlbSP", function(module, exports) {

$parcel$export(module.exports, "mediaInsertMessages", () => $0b0f92edf766e88d$export$7eb9dc59242bbc45);

var $7qGN1 = parcelRequire("7qGN1");
const $0b0f92edf766e88d$export$7eb9dc59242bbc45 = (0, $7qGN1.defineMessages)({
    loadPreview: {
        id: 'fabric.editor.media.insert.loadPreview',
        defaultMessage: 'Load preview',
        description: 'Text on a button that loads a preview of a media file that has been linked to from a URL'
    },
    insert: {
        id: 'fabric.editor.media.insert.insert',
        defaultMessage: 'Insert',
        description: 'Text on the modal action button that inserts the linked media file into the editor document'
    },
    pasteLinkToUpload: {
        id: 'fabric.editor.media.insert.pasteLinkToUpload',
        defaultMessage: 'Paste link to upload',
        description: 'Placeholder text for the input field where a user can paste (as in copy-paste) a URL to upload a media file'
    },
    cancel: {
        id: 'fabric.editor.media.insert.cancel',
        defaultMessage: 'Cancel',
        description: 'Text on the modal action button that cancels the media file insertion and closes the modal'
    },
    fromUrlErrorMessage: {
        id: 'fabric.editor.media.insert.fromUrlErrorMessage',
        defaultMessage: "Unfortunately, we can\u2019t add this image link. Download the image, then drag and drop onto the page.",
        description: 'Error message displayed when a user tries to insert an image from a URL that cannot be loaded. This may be because the URL is invalid, there is a network error or any other reason the preview upload does not succeed. When this occurs the suggestion is to attempt downloading the linked file manually and using a local upload instead.'
    },
    fromUrlWarning: {
        id: 'fabric.editor.media.insert.fromUrlWarning',
        defaultMessage: 'This image might not be visible to others due to source restrictions. Consider uploading the file instead.',
        description: 'Warning message displayed when a user tries to insert an image from a URL that may not be visible to others due to source restrictions such as not having permissions/authentication to load the image. The suggestion is to upload the file instead.'
    },
    localFileNetworkErrorMessage: {
        id: 'fabric.editor.media.insert.localFileNetworkErrorMessage',
        defaultMessage: 'File upload error. Check file path or network.',
        description: 'Error message displayed when a network error occurs during file upload'
    },
    localFileErrorMessage: {
        id: 'fabric.editor.media.insert.localFileErrorMessage',
        defaultMessage: "This file couldn\u2019t be uploaded.",
        description: 'Generic catch-all error message displayed when file upload fails'
    },
    mediaAlt: {
        id: 'fabric.editor.media.insert.mediaAlt',
        defaultMessage: 'Preview for uploaded image or video file',
        description: 'Alt text describing a preview of an image uploaded.'
    },
    upload: {
        id: 'fabric.editor.media.insert.upload',
        defaultMessage: 'Upload',
        description: 'Text on a button that opens a file picker dialog to upload a media file'
    },
    linkTabTitle: {
        id: 'fabric.editor.media.insert.linkTabTitle',
        defaultMessage: 'Link',
        description: 'Title of the navigation tab that allows users to insert media from a URL or link'
    },
    fileTabTitle: {
        id: 'fabric.editor.media.insert.fileTabTitle',
        defaultMessage: 'File',
        description: 'Title of the navigation tab that allows users to upload local media files'
    },
    mediaPickerPopupAriaLabel: {
        id: 'fabric.editor.media.insert.mediaPickerPopupAriaLabel',
        defaultMessage: 'Media picker',
        description: 'Accessibility label for the media picker popup'
    },
    invalidUrlErrorMessage: {
        id: 'fabric.editor.media.insert.invalidUrlErrorMessage',
        defaultMessage: 'Invalid link',
        description: 'Error message displayed when a user tries to insert media from an invalid URL'
    }
});

});

parcelRegister("ee8QX", function(module, exports) {

$parcel$export(module.exports, "selectionToolbarMessages", () => $e86aaeaae7fd5cd3$export$b0226831bf5c0d3e);

var $7qGN1 = parcelRequire("7qGN1");
const $e86aaeaae7fd5cd3$export$b0226831bf5c0d3e = (0, $7qGN1.defineMessages)({
    toolbarAppears: {
        id: 'fabric.editor.toolbarAppears',
        defaultMessage: 'Toolbar appears',
        description: 'Label for toolbar position options'
    },
    toolbarPositionInline: {
        id: 'fabric.editor.toolbarPositionInline',
        defaultMessage: 'In-line with text',
        description: 'Label for in-line toolbar position option'
    },
    toolbarPositionFixedAtTop: {
        id: 'fabric.editor.toolbarPositionFixedAtTop',
        defaultMessage: 'Fixed at top',
        description: 'Label for fixed at top toolbar position option'
    },
    toolbarPositionUnpined: {
        id: 'fabric.editor.toolbarPositionUnpined',
        defaultMessage: 'Pin the toolbar at the top',
        description: 'Label for in-line toolbar position option'
    },
    toolbarPositionPinedAtTop: {
        id: 'fabric.editor.toolbarPositionPinedAtTop',
        defaultMessage: 'Unpin the toolbar',
        description: 'Label for fixed at top toolbar position option'
    }
});

});

parcelRegister("dTBhg", function(module, exports) {

$parcel$export(module.exports, "contextPanelMessages", () => $392c7c9da540e229$export$8ea7f7e979b71fa5);

var $7qGN1 = parcelRequire("7qGN1");
const $392c7c9da540e229$export$8ea7f7e979b71fa5 = (0, $7qGN1.defineMessages)({
    panelLabel: {
        id: 'fabric.editor.contextPanel.panelLabel',
        defaultMessage: 'Context panel',
        description: 'Label for the context panel'
    }
});

});


parcelRegister("7SIsS", function(module, exports) {

$parcel$export(module.exports, "walkUpTreeUntil", () => $303e888fda8630d4$export$df14aaf7a527ab0c);
$parcel$export(module.exports, "unwrap", () => $303e888fda8630d4$export$debb760848ca95a);
$parcel$export(module.exports, "removeNestedEmptyEls", () => $303e888fda8630d4$export$5b66dc78851adb5e);
$parcel$export(module.exports, "containsClassName", () => $303e888fda8630d4$export$c8913a477cc44663);
$parcel$export(module.exports, "closest", () => $303e888fda8630d4$export$ff7f7c97cdce86e);
$parcel$export(module.exports, "closestElement", () => $303e888fda8630d4$export$d508bcfb7f019487);
$parcel$export(module.exports, "parsePx", () => $303e888fda8630d4$export$b0eef8cd00b29d5c);
$parcel$export(module.exports, "maphElem", () => $303e888fda8630d4$export$5b6ab01a6efa50e2);
/**
 * Walks a DOM tree up to the provided `stopElement`, or if falsy before.
 * @param element
 * @param stopElement
 */ function $303e888fda8630d4$export$df14aaf7a527ab0c(element, shouldStop) {
    let rootElement = element;
    while(rootElement && rootElement.parentElement && !shouldStop(rootElement))rootElement = rootElement.parentElement;
    return rootElement;
}
function $303e888fda8630d4$export$debb760848ca95a(parent, wrapped) {
    const docsFragment = document.createDocumentFragment();
    Array.from(wrapped.children).forEach((child)=>{
        docsFragment.appendChild(child);
    });
    parent.replaceChild(docsFragment, wrapped);
}
function $303e888fda8630d4$export$5b66dc78851adb5e(el) {
    while(el.parentElement && el.childElementCount === 0 && el.textContent === ''){
        const parentEl = el.parentElement;
        parentEl.removeChild(el);
        el = parentEl;
    }
}
const $303e888fda8630d4$export$c8913a477cc44663 = (node, className)=>{
    if (!node) return false;
    if (node.classList && node.classList.contains) return node.classList.contains(className);
    if (!node.className) return false;
    const classNames = typeof node.className.baseVal === 'string' ? node.className.baseVal : node.className;
    return classNames.split(' ').indexOf(className) !== -1;
};
function $303e888fda8630d4$export$ff7f7c97cdce86e(node, s) {
    if (!node) return null;
    let el = node;
    if (!document.documentElement || !document.documentElement.contains(el)) return null;
    if (el.closest) return el.closest(s);
    do {
        const matchfn = el.matches ? el.matches : el.msMatchesSelector;
        if (matchfn && matchfn.call(el, s)) // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        return el;
        el = el.parentElement || el.parentNode;
    }while (el !== null && el.nodeType === 1);
    return null;
}
function $303e888fda8630d4$export$d508bcfb7f019487(node, s) {
    return $303e888fda8630d4$export$ff7f7c97cdce86e(node, s);
}
function $303e888fda8630d4$export$b0eef8cd00b29d5c(pxStr) {
    if (!pxStr.endsWith('px')) return undefined;
    const maybeNumber = parseInt(pxStr, 10);
    return !Number.isNaN(maybeNumber) ? maybeNumber : undefined;
}
function $303e888fda8630d4$export$b2d5d4f1aeebddf1(elem, callback) {
    const array = [];
    for(let i = 0; i < elem.childElementCount; i++)array.push(callback(elem.children[i], i, elem));
    return array;
}
function $303e888fda8630d4$export$5b6ab01a6efa50e2(elem, callback) {
    return $303e888fda8630d4$export$b2d5d4f1aeebddf1(elem, callback);
}

});


parcelRegister("iRC0e", function(module, exports) {

$parcel$export(module.exports, "RendererCssClassName", () => $8260bd4d0a5990ae$export$91f3bbbf974496e2);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
const $8260bd4d0a5990ae$var$clPrefix = 'ak-renderer-';
const $8260bd4d0a5990ae$export$91f3bbbf974496e2 = {
    DOCUMENT: `${$8260bd4d0a5990ae$var$clPrefix}document`,
    EXTENSION: `${$8260bd4d0a5990ae$var$clPrefix}extension`,
    EXTENSION_CENTER_ALIGN: `${$8260bd4d0a5990ae$var$clPrefix}extension-center-align`,
    EXTENSION_OVERFLOW_CONTAINER: `${$8260bd4d0a5990ae$var$clPrefix}extension-overflow-container`,
    NUMBER_COLUMN: `${$8260bd4d0a5990ae$var$clPrefix}table-number-column`,
    SORTABLE_COLUMN_WRAPPER: `${$8260bd4d0a5990ae$var$clPrefix}tableHeader-sortable-column__wrapper`,
    SORTABLE_COLUMN: `${$8260bd4d0a5990ae$var$clPrefix}tableHeader-sortable-column`,
    SORTABLE_COLUMN_ICON_WRAPPER: `${$8260bd4d0a5990ae$var$clPrefix}tableHeader-sorting-icon__wrapper`,
    SORTABLE_COLUMN_NO_ORDER: `${$8260bd4d0a5990ae$var$clPrefix}tableHeader-sorting-icon__no-order`
};

});


parcelRegister("7DXmb", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $857f9b714f712b51$export$e926676385687eaf);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $bMFKb = parcelRequire("bMFKb");

var $bgewf = parcelRequire("bgewf");

var $djRdf = parcelRequire("djRdf");

var $7ueoK = parcelRequire("7ueoK");

var $aXKmr = parcelRequire("aXKmr");
class $857f9b714f712b51$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    fireAnalyticsEvent(event) {
        const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
        if (createAnalyticsEvent) {
            const channel = (0, $bgewf.FabricChannel).editor;
            createAnalyticsEvent(event).fire(channel);
        }
    }
    hasFallback() {
        return typeof this.props.fallbackComponent !== 'undefined';
    }
    shouldRecover() {
        return this.hasFallback() && this.state.errorCaptured;
    }
    componentDidCatch(error, errorInfo) {
        const additionalInfo = this.props.additionalInfo ?? '';
        this.fireAnalyticsEvent({
            action: (0, $bMFKb.ACTION).CRASHED,
            actionSubject: this.props.component,
            actionSubjectId: this.props.componentId,
            eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL,
            attributes: {
                platform: (0, $7ueoK.PLATFORM).WEB,
                errorMessage: `${additionalInfo}${error?.message}`,
                componentStack: errorInfo?.componentStack || undefined,
                errorRethrown: Boolean(this.props.rethrowError)
            }
        });
        (0, $djRdf.logException)(error, {
            location: 'renderer'
        });
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        const pattern = /Failed to execute.*on 'Node'.*/;
        const matchesPattern = pattern.test(error.message);
        if (matchesPattern) {
            this.fireAnalyticsEvent({
                action: (0, $bMFKb.ACTION).CAUGHT_DOM_ERROR,
                actionSubject: this.props.component,
                actionSubjectId: this.props.componentId,
                eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    platform: (0, $7ueoK.PLATFORM).WEB,
                    errorMessage: `${additionalInfo}${error?.message}`
                }
            });
            this.setState(()=>({
                    domError: true
                }));
        }
        if (this.hasFallback()) this.setState({
            errorCaptured: true
        }, ()=>{
            if (this.props.rethrowError) throw error;
        });
    }
    render() {
        if (this.state.domError) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
            children: this.props.children
        }, (0, (/*@__PURE__*/$parcel$interopDefault($aXKmr)))());
        if (this.shouldRecover()) return this.props.fallbackComponent;
        return this.props.children;
    }
    constructor(...args){
        super(...args), this.state = {
            errorCaptured: false,
            domError: false
        };
    }
}

});
parcelRegister("djRdf", function(module, exports) {

$parcel$export(module.exports, "logException", () => $163b5c5391cb930a$export$f86b2a1a2ce291b3);

var $ggBOG = parcelRequire("ggBOG");
const $163b5c5391cb930a$var$SENTRY_DSN = 'https://0b10c8e02fb44d8796c047b102c9bee8@o55978.ingest.sentry.io/4505129224110080';
const $163b5c5391cb930a$var$packageName = 'editor-common'; // Sentry doesn't accept '/' in its releases https://docs.sentry.io/platforms/javascript/configuration/releases/
const $163b5c5391cb930a$var$packageVersion = "0.0.0-use.local";
const $163b5c5391cb930a$var$sanitiseSentryEvents = (data, _hint)=>{
    // Remove URL as it has UGC
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: Sanitise the URL instead of just removing it
    if (data.request) delete data.request.url;
    return data;
};


const $163b5c5391cb930a$export$f86b2a1a2ce291b3 = async (error, tags)=>{
    try {
        const { BrowserClient: BrowserClient, defaultIntegrations: defaultIntegrations, getCurrentHub: getCurrentHub } = await (parcelRequire("cRDYf"));
        const { ExtraErrorData: ExtraErrorData } = await (parcelRequire("ahkiE"));
        const sentryOptions = {
            dsn: (0, $ggBOG.isFedRamp)() ? undefined : $163b5c5391cb930a$var$SENTRY_DSN,
            release: `${$163b5c5391cb930a$var$packageName}@${$163b5c5391cb930a$var$packageVersion}`,
            environment: undefined ?? 'unknown',
            ignoreErrors: [
                // Network issues
                // Ignored via go/ees005
                // eslint-disable-next-line require-unicode-regexp
                /^network error/i,
                // Ignored via go/ees005
                // eslint-disable-next-line require-unicode-regexp
                /^network failure/i,
                'TypeError: Failed to fetch',
                // A benign error, see https://stackoverflow.com/a/50387233/2645305
                'ResizeObserver loop limit exceeded',
                // Ignored via go/ees005
                // eslint-disable-next-line require-unicode-regexp
                /ResizeObserver loop completed with undelivered notifications/
            ],
            autoSessionTracking: false,
            integrations: (_integrations)=>[
                    // Remove the Breadcrumbs integration from the default as it's too likely to log UGC/PII
                    // https://docs.sentry.io/platforms/javascript/configuration/integrations/default/
                    ...defaultIntegrations.filter(({ name: name })=>name !== 'Breadcrumbs'),
                    // Extracts all non-native attributes from the error object and attaches them to the event as the extra data
                    // https://docs.sentry.io/platforms/javascript/configuration/integrations/plugin/?original_referrer=https%3A%2F%2Fduckduckgo.com%2F#extraerrordata
                    new ExtraErrorData()
                ],
            beforeSend: $163b5c5391cb930a$var$sanitiseSentryEvents
        };
        // Use a client to avoid picking up the errors from parent applications
        const client = new BrowserClient(sentryOptions);
        const hub = getCurrentHub();
        hub.bindClient(client);
        hub.withScope((scope)=>{
            scope.setTags({
                // Jira environment variables
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                'jira-bundler': window.BUNDLER_VERSION,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                'jira-variant': window.BUILD_VARIANT,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                'jira-release': window.BUILD_KEY,
                // Confluence environment variables
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                'confluence-frontend-version': window.__buildInfo?.FRONTEND_VERSION,
                ...tags
            });
            // Explicitly remove the breadcrumbs as it's too likely to log UGC/PII to side-step the hub integrations not being respected
            scope.clearBreadcrumbs();
            hub.captureException(error);
        });
        return client.close();
    } catch (_error) {
    // Error reporting failed, we don't want this to generate more errors
    }
};

});
parcelRegister("ggBOG", function(module, exports) {

$parcel$export(module.exports, "isFedRamp", () => $a0cf5f3254b84053$export$64d6499adf9b2e51);
const $a0cf5f3254b84053$var$FEDRAMP_MODERATE = 'fedramp-moderate';
function $a0cf5f3254b84053$export$64d6499adf9b2e51() {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    const env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === $a0cf5f3254b84053$var$FEDRAMP_MODERATE;
    const matches = global.location?.hostname?.match(// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    /atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}

});

parcelRegister("cRDYf", function(module, exports) {

let $95d970a55f32ef8a$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $95d970a55f32ef8a$var$load("6dgQT").then(()=>parcelRequire('fVZ2Y'));

});

parcelRegister("ahkiE", function(module, exports) {

let $77bb3d058ff43e6f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $77bb3d058ff43e6f$var$load("f5ExK").then(()=>parcelRequire('lysGq'));

});


parcelRegister("7ueoK", function(module, exports) {

$parcel$export(module.exports, "PLATFORM", () => $0b4fec753ef144f9$export$88c4881e092abcaf);
$parcel$export(module.exports, "MODE", () => $0b4fec753ef144f9$export$e48589d9e4824227);
var $0b4fec753ef144f9$export$88c4881e092abcaf = /*#__PURE__*/ function(PLATFORM) {
    PLATFORM["NATIVE"] = "mobileNative";
    PLATFORM["HYBRID"] = "mobileHybrid";
    PLATFORM["WEB"] = "web";
    return PLATFORM;
}({});
var $0b4fec753ef144f9$export$e48589d9e4824227 = /*#__PURE__*/ function(MODE) {
    MODE["RENDERER"] = "renderer";
    MODE["EDITOR"] = "editor";
    return MODE;
}({});
var $0b4fec753ef144f9$var$RESOLVE_METHOD = /*#__PURE__*/ function(RESOLVE_METHOD) {
    RESOLVE_METHOD["COMPONENT"] = "component";
    RESOLVE_METHOD["CONSUMER"] = "consumer";
    RESOLVE_METHOD["ORPHANED"] = "orphaned";
    return RESOLVE_METHOD;
}($0b4fec753ef144f9$var$RESOLVE_METHOD || {});

});


parcelRegister("ex5uO", function(module, exports) {

$parcel$export(module.exports, "EVENT_TYPE", () => $d667e8c98ffb1fe9$export$76a2e4c433c23bb9);
$parcel$export(module.exports, "ACTION", () => $d667e8c98ffb1fe9$export$9523889e0a5da4ba);
$parcel$export(module.exports, "ACTION_SUBJECT", () => $d667e8c98ffb1fe9$export$7525482b5931e326);
$parcel$export(module.exports, "ACTION_SUBJECT_ID", () => $d667e8c98ffb1fe9$export$9957974f8b4d8f74);
var $d667e8c98ffb1fe9$export$76a2e4c433c23bb9 = /*#__PURE__*/ function(EVENT_TYPE) {
    EVENT_TYPE["OPERATIONAL"] = "operational";
    EVENT_TYPE["SCREEN"] = "screen";
    EVENT_TYPE["TRACK"] = "track";
    EVENT_TYPE["UI"] = "ui";
    return EVENT_TYPE;
}({});
var $d667e8c98ffb1fe9$export$9523889e0a5da4ba = /*#__PURE__*/ function(ACTION) {
    ACTION["STARTED"] = "started";
    ACTION["RENDERED"] = "rendered";
    ACTION["CRASHED"] = "unhandledErrorCaught";
    ACTION["INVALID_PROSEMIRROR_DOCUMENT"] = "invalidProsemirrorDocument";
    ACTION["SELECT_ALL_CAUGHT"] = "selectAllCaught";
    ACTION["SELECT_ALL_ESCAPED"] = "selectAllEscaped";
    ACTION["CLICKED"] = "clicked";
    ACTION["VIEWED"] = "viewed";
    ACTION["VISITED"] = "visited";
    ACTION["SORT_COLUMN"] = "sortedColumn";
    ACTION["SORT_COLUMN_NOT_ALLOWED"] = "sortColumnNotAllowed";
    ACTION["TOGGLE_EXPAND"] = "toggleExpand";
    ACTION["INSERTED"] = "inserted";
    ACTION["OPENED"] = "opened";
    ACTION["CLOSED"] = "closed";
    ACTION["DELETED"] = "deleted";
    ACTION["EDITED"] = "edited";
    ACTION["RESOLVED"] = "resolved";
    ACTION["CREATE_NOT_ALLOWED"] = "createNotAllowed";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_SUCCEEDED"] = "unsupportedContentLevelsTrackingSucceeded";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_ERRORED"] = "unsupportedContentLevelsTrackingErrored";
    ACTION["MEDIA_LINK_TRANSFORMED"] = "mediaLinkTransformed";
    return ACTION;
}({});
var $d667e8c98ffb1fe9$export$7525482b5931e326 = /*#__PURE__*/ function(ACTION_SUBJECT) {
    ACTION_SUBJECT["RENDERER"] = "renderer";
    ACTION_SUBJECT["BUTTON"] = "button";
    ACTION_SUBJECT["ANCHOR_LINK"] = "anchorLink";
    ACTION_SUBJECT["TABLE"] = "table";
    ACTION_SUBJECT["EXPAND"] = "expand";
    ACTION_SUBJECT["NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT["MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT["LINK"] = "link";
    ACTION_SUBJECT["ANNOTATION"] = "annotation";
    ACTION_SUBJECT["MEDIA"] = "media";
    return ACTION_SUBJECT;
}({});
var $d667e8c98ffb1fe9$export$9957974f8b4d8f74 = /*#__PURE__*/ function(ACTION_SUBJECT_ID) {
    ACTION_SUBJECT_ID["HEADING_ANCHOR_LINK"] = "headingAnchorLink";
    ACTION_SUBJECT_ID["LINK"] = "link";
    ACTION_SUBJECT_ID["INLINE_COMMENT"] = "inlineComment";
    ACTION_SUBJECT_ID["CODEBLOCK_COPY"] = "codeBlockCopy";
    ACTION_SUBJECT_ID["CODEBLOCK_WRAP"] = "codeBlockWrap";
    return ACTION_SUBJECT_ID;
}({});

});

parcelRegister("csUn2", function(module, exports) {

$parcel$export(module.exports, "AnnotationsPositionContext", () => $cb5aba900900238c$export$8c8c3e12db6c0591);
$parcel$export(module.exports, "AnnotationsWrapper", () => $cb5aba900900238c$export$cef0157dd42cbb3f);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $jxPcD = parcelRequire("jxPcD");

var $kfxeF = parcelRequire("kfxeF");

var $2MYsB = parcelRequire("2MYsB");

var $eFHDV = parcelRequire("eFHDV");

var $1YS5j = parcelRequire("1YS5j");

var $iNoZC = parcelRequire("iNoZC");

var $ftN6c = parcelRequire("ftN6c");

var $e2m7L = parcelRequire("e2m7L");

var $8dxEE = parcelRequire("8dxEE");

var $3OjM0 = parcelRequire("3OjM0");
const $cb5aba900900238c$var$LoadAnnotations = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo(({ adfDocument: adfDocument, isNestedRender: isNestedRender, onLoadComplete: onLoadComplete })=>{
    (0, $1YS5j.useLoadAnnotations)({
        adfDocument: adfDocument,
        isNestedRender: isNestedRender,
        onLoadComplete: onLoadComplete
    });
    return null;
});
const $cb5aba900900238c$export$8c8c3e12db6c0591 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext({
    startPos: 1
});
const $cb5aba900900238c$export$7121915072388536 = (props)=>{
    const { children: children, rendererRef: rendererRef, adfDocument: adfDocument, isNestedRender: isNestedRender, onLoadComplete: onLoadComplete } = props;
    const providers = (0, $eJOHy.useContext)((0, $eFHDV.ProvidersContext));
    const updateSubscriber = providers && providers.inlineComment && providers.inlineComment.updateSubscriber;
    const inlineCommentAnnotationsState = (0, $iNoZC.useAnnotationStateByTypeEvent)({
        type: (0, $jxPcD.AnnotationTypes).INLINE_COMMENT,
        updateSubscriber: updateSubscriber || null
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eFHDV.InlineCommentsStateContext).Provider, {
        value: inlineCommentAnnotationsState,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $e2m7L.AnnotationRangeProvider), {
            allowCommentsOnMedia: providers?.inlineComment?.allowCommentsOnMedia ?? false,
            isNestedRender: isNestedRender,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8dxEE.AnnotationHoverContext), {
                children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $2MYsB.AnnotationsContextWrapper), {
                    createAnalyticsEvent: createAnalyticsEvent,
                    rendererRef: rendererRef,
                    isNestedRender: isNestedRender,
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)($cb5aba900900238c$var$LoadAnnotations, {
                            adfDocument: adfDocument,
                            isNestedRender: isNestedRender,
                            onLoadComplete: onLoadComplete
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kfxeF.AnnotationView), {
                            isNestedRender: isNestedRender,
                            createAnalyticsEvent: createAnalyticsEvent
                        }),
                        children
                    ]
                })
            })
        })
    });
};
const $cb5aba900900238c$export$cef0157dd42cbb3f = (props)=>{
    const { children: children, annotationProvider: annotationProvider, rendererRef: rendererRef, adfDocument: adfDocument, isNestedRender: isNestedRender, onLoadComplete: onLoadComplete } = props;
    if (!isNestedRender && annotationProvider?.annotationManager) // We need to ensure there is a single instance of the annotation manager for the whole document
    // and that it is the same instance for all annotations.
    // This is because the annotation manager is responsible for managing the state of ALL annotations.
    // This includes annotations inside extensions.
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eFHDV.ProvidersContext).Provider, {
        value: annotationProvider,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3OjM0.AnnotationManagerProvider), {
            annotationManager: annotationProvider.annotationManager,
            updateSubscriber: annotationProvider?.inlineComment?.updateSubscriber ?? undefined,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)($cb5aba900900238c$export$7121915072388536, {
                rendererRef: rendererRef,
                adfDocument: adfDocument,
                isNestedRender: isNestedRender,
                onLoadComplete: onLoadComplete,
                children: children
            })
        })
    });
    else return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eFHDV.ProvidersContext).Provider, {
        value: annotationProvider,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($cb5aba900900238c$export$7121915072388536, {
            rendererRef: rendererRef,
            adfDocument: adfDocument,
            isNestedRender: isNestedRender,
            onLoadComplete: onLoadComplete,
            children: children
        })
    });
};

});
parcelRegister("kfxeF", function(module, exports) {

$parcel$export(module.exports, "AnnotationView", () => $f1a4c1b074cd6009$export$41cd4a02859c2806);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $eFHDV = parcelRequire("eFHDV");

var $iNoZC = parcelRequire("iNoZC");

var $4Z9bh = parcelRequire("4Z9bh");
const $f1a4c1b074cd6009$export$41cd4a02859c2806 = (props)=>{
    const providers = (0, $eJOHy.useContext)((0, $eFHDV.ProvidersContext));
    const actionContext = (0, $eJOHy.useContext)((0, $4Z9bh.RendererContext));
    const inlineCommentProvider = providers && providers.inlineComment;
    const updateSubscriber = inlineCommentProvider && inlineCommentProvider.updateSubscriber || null;
    const viewComponentProps = (0, $iNoZC.useAnnotationClickEvent)({
        updateSubscriber: updateSubscriber,
        createAnalyticsEvent: props.createAnalyticsEvent,
        isNestedRender: props.isNestedRender
    });
    const ViewComponent = inlineCommentProvider && inlineCommentProvider.viewComponent;
    const deleteAnnotation = (0, $eJOHy.useMemo)(()=>(annotationInfo)=>actionContext.deleteAnnotation(annotationInfo.id, annotationInfo.type), [
        actionContext
    ]);
    // For view mode, the finding of inline node types is a bit more complex,
    // that's why we will not provide it as a `inlineNodeTypes` props to the view component,
    // to speed up the rendering process.
    const getInlineNodeTypes = (0, $eJOHy.useCallback)((annotationId)=>actionContext.getInlineNodeTypes(annotationId), [
        actionContext
    ]);
    if (ViewComponent && viewComponentProps) {
        const { annotations: annotations, clickElementTarget: clickElementTarget } = viewComponentProps;
        return /*#__PURE__*/ (0, $gt9Am.jsx)(ViewComponent, {
            annotations: annotations,
            clickElementTarget: clickElementTarget,
            deleteAnnotation: deleteAnnotation,
            getInlineNodeTypes: getInlineNodeTypes
        });
    }
    return null;
};

});
parcelRegister("eFHDV", function(module, exports) {

$parcel$export(module.exports, "ProvidersContext", () => $1b6da805fd7eb803$export$6a26b015ac619737);
$parcel$export(module.exports, "InlineCommentsStateContext", () => $1b6da805fd7eb803$export$aafe46a36ef535ba);

var $eJOHy = parcelRequire("eJOHy");
const $1b6da805fd7eb803$export$6a26b015ac619737 = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $1b6da805fd7eb803$export$aafe46a36ef535ba = /*#__PURE__*/ (0, $eJOHy.createContext)({});

});

parcelRegister("iNoZC", function(module, exports) {

$parcel$export(module.exports, "useAnnotationStateByTypeEvent", () => $a748c376ed70405d$export$95f9f9045e92d283);
$parcel$export(module.exports, "useHasFocusEvent", () => $a748c376ed70405d$export$48f5d7f6702be07c);
$parcel$export(module.exports, "useAnnotationClickEvent", () => $a748c376ed70405d$export$26cf539704e444c1);

var $eJOHy = parcelRequire("eJOHy");

var $4Fc33 = parcelRequire("4Fc33");

var $jxPcD = parcelRequire("jxPcD");

var $bMFKb = parcelRequire("bMFKb");

var $bgewf = parcelRequire("bgewf");

var $eGOwo = parcelRequire("eGOwo");

var $3OjM0 = parcelRequire("3OjM0");
const $a748c376ed70405d$export$95f9f9045e92d283 = ({ type: type, updateSubscriber: updateSubscriber })=>{
    const [states, setStates] = (0, $eJOHy.useState)({});
    const { annotationManager: annotationManager, dispatch: dispatch } = (0, $3OjM0.useAnnotationManagerDispatch)();
    const { annotations: annotations } = (0, $3OjM0.useAnnotationManagerState)();
    const isAnnotationManagerEnabled = !!annotationManager;
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (!updateSubscriber) return;
        const cb = (payload)=>{
            if (!payload) return;
            const nextStates = Object.values(payload).reduce((acc, curr)=>{
                if (curr.id && curr.annotationType === type) {
                    // Check for empty state to prevent additional renders
                    const isEmpty = curr.state === null || curr.state === undefined;
                    return {
                        ...acc,
                        [curr.id]: !isEmpty ? curr.state : states[curr.id]
                    };
                }
                return acc;
            }, {});
            setStates({
                ...states,
                ...nextStates
            });
        };
        if (!isAnnotationManagerEnabled) {
            updateSubscriber.on((0, $4Fc33.AnnotationUpdateEvent).SET_ANNOTATION_STATE, cb);
            return ()=>{
                updateSubscriber.off((0, $4Fc33.AnnotationUpdateEvent).SET_ANNOTATION_STATE, cb);
            };
        }
    }, [
        states,
        type,
        updateSubscriber,
        dispatch,
        isAnnotationManagerEnabled
    ]);
    const annotationMarkStates = (0, $eJOHy.useMemo)(()=>{
        return Object.values(annotations).reduce((acc, curr)=>{
            return {
                ...acc,
                [curr.id]: curr.markState
            };
        }, {});
    }, [
        annotations
    ]);
    if (isAnnotationManagerEnabled) return annotationMarkStates;
    else return states;
};
const $a748c376ed70405d$export$48f5d7f6702be07c = ({ id: id, updateSubscriber: updateSubscriber })=>{
    const [hasFocus, setHasFocus] = (0, $eJOHy.useState)(false);
    const [isHovered, setIsHovered] = (0, $eJOHy.useState)(false);
    const { currentSelectedAnnotationId: currentSelectedAnnotationId, currentHoveredAnnotationId: currentHoveredAnnotationId } = (0, $3OjM0.useAnnotationManagerState)();
    const { annotationManager: annotationManager } = (0, $3OjM0.useAnnotationManagerDispatch)();
    const isAnnotationManagerEnabled = !!annotationManager;
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (!updateSubscriber) return;
        const cb = (payload)=>{
            setHasFocus(payload && payload.annotationId === id);
        };
        const callbackForHoveredAnnotation = (payload)=>{
            setIsHovered(payload && payload.annotationId === id);
        };
        const removeFocus = ()=>{
            setHasFocus(false);
            if (document.activeElement instanceof HTMLElement) document.activeElement.blur();
        };
        const removeHoverEffect = ()=>{
            setIsHovered(false);
            if (document.activeElement instanceof HTMLElement && !(0, $eGOwo.fg)('confluence_frontend_comments_panel_editor_focus')) document.activeElement.blur();
        };
        if (!isAnnotationManagerEnabled) {
            updateSubscriber.on((0, $4Fc33.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, cb);
            updateSubscriber.on((0, $4Fc33.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, callbackForHoveredAnnotation);
            updateSubscriber.on((0, $4Fc33.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, removeFocus);
            updateSubscriber.on((0, $4Fc33.AnnotationUpdateEvent).REMOVE_ANNOTATION_HOVERED, removeHoverEffect);
            return ()=>{
                updateSubscriber.off((0, $4Fc33.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, cb);
                updateSubscriber.off((0, $4Fc33.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, callbackForHoveredAnnotation);
                updateSubscriber.off((0, $4Fc33.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, removeFocus);
                updateSubscriber.off((0, $4Fc33.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, removeHoverEffect);
            };
        }
    }, [
        id,
        updateSubscriber,
        isAnnotationManagerEnabled
    ]);
    if (isAnnotationManagerEnabled) return {
        hasFocus: currentSelectedAnnotationId === id,
        isHovered: currentHoveredAnnotationId === id
    };
    else return {
        hasFocus: hasFocus,
        isHovered: isHovered
    };
};
const $a748c376ed70405d$var$NO_ANNOTATION_SELECTED = {
    annotations: [],
    clickElementTarget: undefined
};
const $a748c376ed70405d$export$26cf539704e444c1 = (props)=>{
    const [annotationClickEvent, setAnnotationClickEvent] = (0, $eJOHy.useState)(null);
    const { updateSubscriber: updateSubscriber, createAnalyticsEvent: createAnalyticsEvent, isNestedRender: isNestedRender } = props;
    const { annotationManager: annotationManager } = (0, $3OjM0.useAnnotationManagerDispatch)();
    const isAnnotationManagerEnabled = !!annotationManager;
    const { currentSelectedAnnotationId: currentSelectedAnnotationId, currentSelectedMarkRef: currentSelectedMarkRef } = (0, $3OjM0.useAnnotationManagerState)();
    const selectedAnnotation = (0, $eJOHy.useMemo)(()=>{
        return currentSelectedAnnotationId && currentSelectedMarkRef && currentSelectedMarkRef.id === currentSelectedAnnotationId ? {
            annotations: [
                {
                    id: currentSelectedAnnotationId,
                    type: (0, $jxPcD.AnnotationTypes).INLINE_COMMENT
                }
            ],
            clickElementTarget: currentSelectedMarkRef
        } : // When creating a new annotation, currentSelectedAnnotationId and currentSelectedMarkRef will be set one after another,
        // if this isn't a const, it will cause useMemo to return two different "empty" objects and causes infinite re-renders.
        $a748c376ed70405d$var$NO_ANNOTATION_SELECTED;
    }, [
        currentSelectedAnnotationId,
        currentSelectedMarkRef
    ]);
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (!updateSubscriber || isNestedRender) return;
        const clickCb = ({ annotationIds: annotationIds, eventTarget: eventTarget, eventTargetType: eventTargetType, viewMethod: viewMethod })=>{
            const annotationsByType = annotationIds.filter((id)=>!!id).map((id)=>({
                    id: id,
                    type: (0, $jxPcD.AnnotationTypes).INLINE_COMMENT
                }));
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $bMFKb.ACTION).VIEWED,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
                attributes: {
                    overlap: annotationsByType.length || 0,
                    targetNodeType: eventTargetType,
                    method: viewMethod
                }
            }).fire((0, $bgewf.FabricChannel).editor);
            setAnnotationClickEvent({
                annotations: annotationsByType,
                clickElementTarget: eventTarget
            });
        };
        const deselectCb = ()=>{
            setAnnotationClickEvent({
                annotations: [],
                clickElementTarget: undefined
            });
            if (document.activeElement instanceof HTMLElement) document.activeElement.blur();
        };
        if (!isAnnotationManagerEnabled) {
            updateSubscriber.on((0, $4Fc33.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, clickCb);
            updateSubscriber.on((0, $4Fc33.AnnotationUpdateEvent).DESELECT_ANNOTATIONS, deselectCb);
            return ()=>{
                updateSubscriber.off((0, $4Fc33.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, clickCb);
                updateSubscriber.off((0, $4Fc33.AnnotationUpdateEvent).DESELECT_ANNOTATIONS, deselectCb);
            };
        }
    }, [
        updateSubscriber,
        createAnalyticsEvent,
        isNestedRender,
        isAnnotationManagerEnabled
    ]);
    if (isAnnotationManagerEnabled) return isNestedRender ? null : selectedAnnotation;
    else return annotationClickEvent;
};

});
parcelRegister("4Fc33", function(module, exports) {

$parcel$export(module.exports, "AnnotationUpdateEvent", () => $d1a8723ca29ef28b$export$c1c4b33b4e7b1c70);

var $7OU8o = parcelRequire("7OU8o");
var $d1a8723ca29ef28b$export$c1c4b33b4e7b1c70 = /*#__PURE__*/ function(AnnotationUpdateEvent) {
    AnnotationUpdateEvent["SET_ANNOTATION_FOCUS"] = "SET_ANNOTATION_FOCUS";
    AnnotationUpdateEvent["SET_ANNOTATION_HOVERED"] = "SET_ANNOTATION_HOVERED";
    AnnotationUpdateEvent["SET_ANNOTATION_STATE"] = "SET_ANNOTATION_STATE";
    AnnotationUpdateEvent["REMOVE_ANNOTATION_FOCUS"] = "REMOVE_ANNOTATION_FOCUS";
    AnnotationUpdateEvent["REMOVE_ANNOTATION_HOVERED"] = "REMOVE_ANNOTATION_HOVERED";
    AnnotationUpdateEvent["ON_ANNOTATION_CLICK"] = "ON_ANNOTATION_CLICK";
    AnnotationUpdateEvent["DESELECT_ANNOTATIONS"] = "DESELECT_ANNOTATIONS";
    return AnnotationUpdateEvent;
}({});
class $d1a8723ca29ef28b$export$7cc60aa9ef845515 {
    emit(event, params) {
        if (typeof params === 'undefined') return this.emitter.emit(event);
        return this.emitter.emit(event, params);
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    on(event, listener) {
        return this.emitter.on(event, listener);
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    off(event, listener) {
        return this.emitter.removeListener(event, listener);
    }
    listeners(event) {
        return this.emitter.listeners(event);
    }
    constructor(){
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($7OU8o)))();
    }
}

});
parcelRegister("7OU8o", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $5b18bf0c82fb1188$var$R = typeof Reflect === 'object' ? Reflect : null;
var $5b18bf0c82fb1188$var$ReflectApply = $5b18bf0c82fb1188$var$R && typeof $5b18bf0c82fb1188$var$R.apply === 'function' ? $5b18bf0c82fb1188$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $5b18bf0c82fb1188$var$ReflectOwnKeys;
if ($5b18bf0c82fb1188$var$R && typeof $5b18bf0c82fb1188$var$R.ownKeys === 'function') $5b18bf0c82fb1188$var$ReflectOwnKeys = $5b18bf0c82fb1188$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $5b18bf0c82fb1188$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $5b18bf0c82fb1188$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $5b18bf0c82fb1188$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $5b18bf0c82fb1188$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $5b18bf0c82fb1188$var$EventEmitter() {
    $5b18bf0c82fb1188$var$EventEmitter.init.call(this);
}
module.exports = $5b18bf0c82fb1188$var$EventEmitter;
module.exports.once = $5b18bf0c82fb1188$var$once;
// Backwards-compat with node 0.10.x
$5b18bf0c82fb1188$var$EventEmitter.EventEmitter = $5b18bf0c82fb1188$var$EventEmitter;
$5b18bf0c82fb1188$var$EventEmitter.prototype._events = undefined;
$5b18bf0c82fb1188$var$EventEmitter.prototype._eventsCount = 0;
$5b18bf0c82fb1188$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $5b18bf0c82fb1188$var$defaultMaxListeners = 10;
function $5b18bf0c82fb1188$var$checkListener(listener) {
    if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($5b18bf0c82fb1188$var$EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function() {
        return $5b18bf0c82fb1188$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== 'number' || arg < 0 || $5b18bf0c82fb1188$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
        $5b18bf0c82fb1188$var$defaultMaxListeners = arg;
    }
});
$5b18bf0c82fb1188$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$5b18bf0c82fb1188$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || $5b18bf0c82fb1188$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
    this._maxListeners = n;
    return this;
};
function $5b18bf0c82fb1188$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $5b18bf0c82fb1188$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$5b18bf0c82fb1188$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $5b18bf0c82fb1188$var$_getMaxListeners(this);
};
$5b18bf0c82fb1188$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === 'error';
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === 'function') $5b18bf0c82fb1188$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $5b18bf0c82fb1188$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$5b18bf0c82fb1188$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $5b18bf0c82fb1188$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $5b18bf0c82fb1188$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit('newListener', type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === 'function') // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $5b18bf0c82fb1188$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
            w.name = 'MaxListenersExceededWarning';
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $5b18bf0c82fb1188$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$5b18bf0c82fb1188$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $5b18bf0c82fb1188$var$_addListener(this, type, listener, false);
};
$5b18bf0c82fb1188$var$EventEmitter.prototype.on = $5b18bf0c82fb1188$var$EventEmitter.prototype.addListener;
$5b18bf0c82fb1188$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $5b18bf0c82fb1188$var$_addListener(this, type, listener, true);
};
function $5b18bf0c82fb1188$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $5b18bf0c82fb1188$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $5b18bf0c82fb1188$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$5b18bf0c82fb1188$var$EventEmitter.prototype.once = function once(type, listener) {
    $5b18bf0c82fb1188$var$checkListener(listener);
    this.on(type, $5b18bf0c82fb1188$var$_onceWrap(this, type, listener));
    return this;
};
$5b18bf0c82fb1188$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $5b18bf0c82fb1188$var$checkListener(listener);
    this.prependListener(type, $5b18bf0c82fb1188$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$5b18bf0c82fb1188$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $5b18bf0c82fb1188$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
        }
    } else if (typeof list !== 'function') {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $5b18bf0c82fb1188$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
    }
    return this;
};
$5b18bf0c82fb1188$var$EventEmitter.prototype.off = $5b18bf0c82fb1188$var$EventEmitter.prototype.removeListener;
$5b18bf0c82fb1188$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === 'function') this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $5b18bf0c82fb1188$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === 'function') return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $5b18bf0c82fb1188$var$unwrapListeners(evlistener) : $5b18bf0c82fb1188$var$arrayClone(evlistener, evlistener.length);
}
$5b18bf0c82fb1188$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $5b18bf0c82fb1188$var$_listeners(this, type, true);
};
$5b18bf0c82fb1188$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $5b18bf0c82fb1188$var$_listeners(this, type, false);
};
$5b18bf0c82fb1188$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
    else return $5b18bf0c82fb1188$var$listenerCount.call(emitter, type);
};
$5b18bf0c82fb1188$var$EventEmitter.prototype.listenerCount = $5b18bf0c82fb1188$var$listenerCount;
function $5b18bf0c82fb1188$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === 'function') return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$5b18bf0c82fb1188$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $5b18bf0c82fb1188$var$ReflectOwnKeys(this._events) : [];
};
function $5b18bf0c82fb1188$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $5b18bf0c82fb1188$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $5b18bf0c82fb1188$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $5b18bf0c82fb1188$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
            resolve([].slice.call(arguments));
        }
        $5b18bf0c82fb1188$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== 'error') $5b18bf0c82fb1188$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $5b18bf0c82fb1188$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === 'function') $5b18bf0c82fb1188$var$eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
}
function $5b18bf0c82fb1188$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === 'function') {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === 'function') // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});


parcelRegister("3OjM0", function(module, exports) {

$parcel$export(module.exports, "AnnotationManagerProvider", () => $145edea21db52b9d$export$f21fb05766361bb3);
$parcel$export(module.exports, "useAnnotationManagerState", () => $145edea21db52b9d$export$654a1fb45487f838);
$parcel$export(module.exports, "useAnnotationManagerDispatch", () => $145edea21db52b9d$export$12cbbb89fb7702d0);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $jxPcD = parcelRequire("jxPcD");

var $4Fc33 = parcelRequire("4Fc33");

var $4Z9bh = parcelRequire("4Z9bh");
const $145edea21db52b9d$var$initState = {
    isDrafting: false,
    draftId: undefined,
    draftMarkRef: undefined,
    draftActionResult: undefined,
    annotations: {},
    currentSelectedAnnotationId: undefined,
    currentSelectedMarkRef: undefined,
    currentHoveredAnnotationId: undefined
};
const $145edea21db52b9d$var$AnnotationManagerStateContext = /*#__PURE__*/ (0, $eJOHy.createContext)($145edea21db52b9d$var$initState);
const $145edea21db52b9d$var$AnnotationManagerDispatchContext = /*#__PURE__*/ (0, $eJOHy.createContext)({
    annotationManager: undefined,
    dispatch: ()=>{}
});
function $145edea21db52b9d$var$reducer(state, action) {
    switch(action.type){
        case 'reset':
            return {
                ...state,
                ...$145edea21db52b9d$var$initState
            };
        case 'loadAnnotation':
            {
                const currentIds = Object.keys(state.annotations);
                const uids = Array.from(new Set(currentIds.concat(action.data.map((a)=>a.id))));
                const updates = [];
                for (const id of uids){
                    const loadedAnnotation = action.data.find((a)=>a.id === id);
                    if (!loadedAnnotation && state.annotations[id]?.markState === (0, $jxPcD.AnnotationMarkStates).ACTIVE) {
                        // If the annotation is not in the loaded data, we need to remove it from the state. However,
                        // rather then removing it, we will set the mark state to resolved. This is to align it better with
                        // how the editor works.
                        updates.push({
                            id: id,
                            markState: (0, $jxPcD.AnnotationMarkStates).RESOLVED
                        });
                        continue;
                    }
                    if (!!loadedAnnotation?.markState && state.annotations[id]?.markState !== loadedAnnotation.markState) {
                        updates.push({
                            id: id,
                            markState: loadedAnnotation.markState
                        });
                        continue;
                    }
                }
                if (updates.length > 0) return {
                    ...state,
                    annotations: updates.reduce((nextAnnotations, update)=>{
                        return {
                            ...nextAnnotations,
                            [update.id]: {
                                ...nextAnnotations[update.id],
                                ...update
                            }
                        };
                    }, state.annotations)
                };
                return state;
            }
        case 'updateAnnotation':
            {
                const current = state.annotations[action.data.id];
                const { id: id, selected: selected, hovered: hovered, markState: markState = current?.markState } = action.data;
                const updates = [];
                // If the annotation is not currently in the state, we need to add it to the state.
                if (!current) updates.push({
                    id: id,
                    markState: markState ?? (0, $jxPcD.AnnotationMarkStates).ACTIVE
                });
                // The goal of the following is to enforce a single selection and a single hover state across all annotations.
                let nextSelectedId = state.currentSelectedAnnotationId;
                if (selected && nextSelectedId !== id) nextSelectedId = id;
                // If the annotation is currently selected and it's being unselected, we need to remove it from the
                // current selected annotation id.
                if (selected === false && nextSelectedId === id) nextSelectedId = undefined;
                let nextHoveredId = state.currentHoveredAnnotationId;
                if (hovered && nextHoveredId !== id) nextHoveredId = id;
                // If the annotation is currently hovered and it's being unhovered, we need to remove it from the
                // current hovered annotation id.
                if (hovered === false && nextHoveredId === id) nextHoveredId = undefined;
                // If the annotations mark state is not the same as the current mark state, we need to update it.
                if (current?.markState !== markState) {
                    updates.push({
                        id: id,
                        markState: markState ?? (0, $jxPcD.AnnotationMarkStates).ACTIVE
                    });
                    // If the annotation is currently selected and it's being resolved, then we need to remove it from the
                    // current selected annotation id also.
                    if (markState === (0, $jxPcD.AnnotationMarkStates).RESOLVED && nextSelectedId === id) nextSelectedId = undefined;
                }
                if (updates.length > 0 || nextSelectedId !== state.currentSelectedAnnotationId || nextHoveredId !== state.currentHoveredAnnotationId) return {
                    ...state,
                    currentSelectedAnnotationId: nextSelectedId,
                    currentHoveredAnnotationId: nextHoveredId,
                    annotations: updates.reduce((nextAnnotations, update)=>{
                        return {
                            ...nextAnnotations,
                            [update.id]: {
                                ...nextAnnotations[update.id],
                                ...update
                            }
                        };
                    }, state.annotations)
                };
                return state;
            }
        case 'resetSelectedAnnotation':
            if (state.currentSelectedAnnotationId !== undefined) return {
                ...state,
                currentSelectedAnnotationId: undefined,
                currentSelectedMarkRef: undefined
            };
            return state;
        case 'resetHoveredAnnotation':
            if (state.currentHoveredAnnotationId !== undefined) return {
                ...state,
                currentHoveredAnnotationId: undefined
            };
            return state;
        case 'setDrafting':
            if (state.isDrafting !== action.data.isDrafting || state.draftId !== action.data.draftId || state.draftActionResult !== action.data.draftActionResult) // XXX: When a draft is open the current selected annotation should no longer be selected. We need
            // to decide what is better UX,
            // 1 - do we want to deselct the selected annotation on draft open, if so then when draft is closed the s
            // selected annotation will not come back
            // 2 - do we want to still allow the selected annotation to be selected when draft is open, however the underlying
            // mark style just shows the annotation as not selected when a draft is active. Then when a draft closes
            // we can reopen the previous selected annotation.
            return {
                ...state,
                isDrafting: action.data.isDrafting,
                draftId: action.data.draftId,
                draftActionResult: action.data.draftActionResult
            };
            return state;
        case 'setDraftMarkRef':
            if (state.draftMarkRef !== action.data.draftMarkRef) return {
                ...state,
                draftMarkRef: action.data.draftMarkRef
            };
            return state;
        case 'setSelectedMarkRef':
            if (state.currentSelectedMarkRef !== action.data.markRef) return {
                ...state,
                currentSelectedMarkRef: action.data.markRef
            };
            return state;
    }
}
const $145edea21db52b9d$export$f21fb05766361bb3 = ({ children: children, annotationManager: annotationManager, updateSubscriber: updateSubscriber })=>{
    const [state, dispatch] = (0, $eJOHy.useReducer)($145edea21db52b9d$var$reducer, $145edea21db52b9d$var$initState);
    const actionContext = (0, $eJOHy.useContext)((0, $4Z9bh.RendererContext));
    (0, $eJOHy.useEffect)(()=>{
        const getDraft = ()=>{
            if (!state.isDrafting || !state.draftActionResult || !state.draftMarkRef || !state.draftId) return {
                success: false,
                reason: 'draft-not-started'
            };
            return {
                success: true,
                inlineNodeTypes: state.draftActionResult.inlineNodeTypes ?? [],
                targetElement: state.draftMarkRef,
                actionResult: {
                    step: state.draftActionResult.step,
                    doc: state.draftActionResult.doc,
                    inlineNodeTypes: state.draftActionResult.inlineNodeTypes,
                    targetNodeType: state.draftActionResult.targetNodeType,
                    originalSelection: state.draftActionResult.originalSelection,
                    numMatches: state.draftActionResult.numMatches,
                    matchIndex: state.draftActionResult.matchIndex,
                    pos: state.draftActionResult.pos
                }
            };
        };
        annotationManager?.hook('getDraft', getDraft);
        return ()=>{
            annotationManager?.unhook('getDraft', getDraft);
        };
    }, [
        annotationManager,
        state.draftId,
        state.isDrafting,
        state.draftMarkRef,
        state.draftActionResult
    ]);
    // We need to watch for the draft mark element to exist, so we can inform any listeners that the draft has been started
    // and give them a reference to the element
    (0, $eJOHy.useEffect)(()=>{
        if (state.isDrafting && state.draftId && state.draftMarkRef && state.draftActionResult) annotationManager?.emit({
            name: 'draftAnnotationStarted',
            data: {
                inlineNodeTypes: state.draftActionResult.inlineNodeTypes ?? [],
                targetElement: state.draftMarkRef,
                actionResult: {
                    step: state.draftActionResult.step,
                    doc: state.draftActionResult.doc,
                    inlineNodeTypes: state.draftActionResult.inlineNodeTypes,
                    targetNodeType: state.draftActionResult.targetNodeType,
                    originalSelection: state.draftActionResult.originalSelection,
                    numMatches: state.draftActionResult.numMatches,
                    matchIndex: state.draftActionResult.matchIndex,
                    pos: state.draftActionResult.pos
                }
            }
        });
    }, [
        annotationManager,
        state.draftId,
        state.isDrafting,
        state.draftMarkRef,
        state.draftActionResult
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const setIsAnnotationSelected = (id, isSelected)=>{
            if (state.isDrafting) return {
                success: false,
                reason: 'draft-in-progress'
            };
            if (!state.annotations?.[id]) return {
                success: false,
                reason: 'id-not-valid'
            };
            // the annotation is currently not selected and is being selected
            if (id !== state.currentSelectedAnnotationId && isSelected) {
                dispatch({
                    type: 'updateAnnotation',
                    data: {
                        id: id,
                        selected: true
                    }
                });
                dispatch({
                    type: 'setSelectedMarkRef',
                    data: {
                        markRef: document.getElementById(id) || undefined
                    }
                });
            } else if (id === state.currentSelectedAnnotationId && !isSelected) dispatch({
                type: 'resetSelectedAnnotation'
            });
            return {
                success: true,
                isSelected: isSelected
            };
        };
        annotationManager?.hook('setIsAnnotationSelected', setIsAnnotationSelected);
        return ()=>{
            annotationManager?.unhook('setIsAnnotationSelected', setIsAnnotationSelected);
        };
    }, [
        annotationManager,
        state.isDrafting,
        state.annotations,
        state.currentSelectedAnnotationId,
        state.currentSelectedMarkRef
    ]);
    const prevSelectedAnnotationId = (0, $eJOHy.useRef)(undefined);
    (0, $eJOHy.useEffect)(()=>{
        if (prevSelectedAnnotationId.current) annotationManager?.emit({
            name: 'annotationSelectionChanged',
            data: {
                annotationId: prevSelectedAnnotationId.current,
                isSelected: false,
                inlineNodeTypes: []
            }
        });
        prevSelectedAnnotationId.current = state.currentSelectedAnnotationId;
    }, [
        state.currentSelectedAnnotationId,
        annotationManager
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (state.currentSelectedAnnotationId && state.currentSelectedMarkRef && state.currentSelectedMarkRef.id === state.currentSelectedAnnotationId) annotationManager?.emit({
            name: 'annotationSelectionChanged',
            data: {
                annotationId: state.currentSelectedAnnotationId,
                isSelected: true,
                inlineNodeTypes: []
            }
        });
    }, [
        annotationManager,
        state.currentSelectedAnnotationId,
        state.currentSelectedMarkRef
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const setIsAnnotationHovered = (id, isHovered)=>{
            if (!state.annotations?.[id]) return {
                success: false,
                reason: 'id-not-valid'
            };
            dispatch({
                type: 'updateAnnotation',
                data: {
                    id: id,
                    hovered: isHovered
                }
            });
            return {
                success: true,
                isHovered: isHovered
            };
        };
        annotationManager?.hook('setIsAnnotationHovered', setIsAnnotationHovered);
        return ()=>{
            annotationManager?.unhook('setIsAnnotationHovered', setIsAnnotationHovered);
        };
    }, [
        annotationManager,
        state.annotations
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const clearAnnotation = (id)=>{
            if (!state.annotations?.[id]) return {
                success: false,
                reason: 'id-not-valid'
            };
            const result = actionContext.deleteAnnotation(id, (0, $jxPcD.AnnotationTypes).INLINE_COMMENT);
            if (!result) return {
                success: false,
                reason: 'clear-failed'
            };
            const { step: step, doc: doc } = result;
            return {
                success: true,
                actionResult: {
                    step: step,
                    doc: doc
                }
            };
        };
        annotationManager?.hook('clearAnnotation', clearAnnotation);
        return ()=>{
            annotationManager?.unhook('clearAnnotation', clearAnnotation);
        };
    }, [
        annotationManager,
        state.annotations,
        actionContext
    ]);
    /**
	 * This is a temporary solution to ensure that the annotation manager state is in sync with the
	 * old updateSubscriber. The updateSubscriber will eventually be deprecated and the state will be managed
	 * by the annotation manager itself.
	 */ (0, $eJOHy.useEffect)(()=>{
        const onSetAnnotationState = (payload)=>{
            if (!payload) return;
            Object.values(payload).forEach((annotation)=>{
                if (annotation.id && annotation.annotationType === (0, $jxPcD.AnnotationTypes).INLINE_COMMENT) dispatch({
                    type: 'updateAnnotation',
                    data: {
                        id: annotation.id,
                        markState: annotation.state ?? undefined
                    }
                });
            });
        };
        const onAnnotationSelected = (payload)=>{
            dispatch({
                type: 'updateAnnotation',
                data: {
                    id: payload.annotationId,
                    selected: true
                }
            });
        };
        const onAnnotationHovered = (payload)=>{
            dispatch({
                type: 'updateAnnotation',
                data: {
                    id: payload.annotationId,
                    hovered: true
                }
            });
        };
        const onAnnotationSelectedRemoved = ()=>{
            dispatch({
                type: 'resetSelectedAnnotation'
            });
        };
        const onAnnotationHoveredRemoved = ()=>{
            dispatch({
                type: 'resetHoveredAnnotation'
            });
        };
        const onAnnotationClick = ({ annotationIds: annotationIds, eventTarget: eventTarget, eventTargetType: eventTargetType, viewMethod: viewMethod })=>{
            dispatch({
                type: 'updateAnnotation',
                data: {
                    id: annotationIds[0],
                    selected: true
                }
            });
            dispatch({
                type: 'setSelectedMarkRef',
                data: {
                    markRef: eventTarget
                }
            });
        };
        const onAnnotationDeselect = ()=>{
            dispatch({
                type: 'resetSelectedAnnotation'
            });
        };
        updateSubscriber?.on((0, $4Fc33.AnnotationUpdateEvent).SET_ANNOTATION_STATE, onSetAnnotationState);
        updateSubscriber?.on((0, $4Fc33.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, onAnnotationSelected);
        updateSubscriber?.on((0, $4Fc33.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, onAnnotationHovered);
        updateSubscriber?.on((0, $4Fc33.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, onAnnotationSelectedRemoved);
        updateSubscriber?.on((0, $4Fc33.AnnotationUpdateEvent).REMOVE_ANNOTATION_HOVERED, onAnnotationHoveredRemoved);
        updateSubscriber?.on((0, $4Fc33.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, onAnnotationClick);
        updateSubscriber?.on((0, $4Fc33.AnnotationUpdateEvent).DESELECT_ANNOTATIONS, onAnnotationDeselect);
        return ()=>{
            updateSubscriber?.off((0, $4Fc33.AnnotationUpdateEvent).SET_ANNOTATION_STATE, onSetAnnotationState);
            updateSubscriber?.off((0, $4Fc33.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, onAnnotationSelected);
            updateSubscriber?.off((0, $4Fc33.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, onAnnotationHovered);
            updateSubscriber?.off((0, $4Fc33.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, onAnnotationSelectedRemoved);
            updateSubscriber?.off((0, $4Fc33.AnnotationUpdateEvent).REMOVE_ANNOTATION_HOVERED, onAnnotationHoveredRemoved);
            updateSubscriber?.off((0, $4Fc33.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, onAnnotationClick);
            updateSubscriber?.off((0, $4Fc33.AnnotationUpdateEvent).DESELECT_ANNOTATIONS, onAnnotationDeselect);
        };
    }, [
        updateSubscriber
    ]);
    const dispatchData = (0, $eJOHy.useMemo)(()=>({
            annotationManager: annotationManager,
            dispatch: dispatch
        }), [
        annotationManager,
        dispatch
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($145edea21db52b9d$var$AnnotationManagerStateContext.Provider, {
        value: state,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($145edea21db52b9d$var$AnnotationManagerDispatchContext.Provider, {
            value: dispatchData,
            children: children
        })
    });
};
const $145edea21db52b9d$export$654a1fb45487f838 = ()=>{
    return (0, $eJOHy.useContext)($145edea21db52b9d$var$AnnotationManagerStateContext);
};
const $145edea21db52b9d$export$12cbbb89fb7702d0 = ()=>{
    return (0, $eJOHy.useContext)($145edea21db52b9d$var$AnnotationManagerDispatchContext);
};

});
parcelRegister("4Z9bh", function(module, exports) {

$parcel$export(module.exports, "RendererContext", () => $23eeb1bb2885a66b$export$1e9ea4edb6d1bfe6);
$parcel$export(module.exports, "RendererActionsContext", () => $23eeb1bb2885a66b$export$66feffbad722f9d4);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $ftN6c = parcelRequire("ftN6c");

var $3VCQy = parcelRequire("3VCQy");

var $bMFKb = parcelRequire("bMFKb");

var $e6uVp = parcelRequire("e6uVp");
const $23eeb1bb2885a66b$export$1e9ea4edb6d1bfe6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext(new (0, $e6uVp.default)());
function $23eeb1bb2885a66b$export$66feffbad722f9d4({ children: children, context: context }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const actions = (0, $eJOHy.useMemo)(()=>new (0, $e6uVp.default)(true), []);
    // Remove this eventually when root cause is assessed
    if ((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.count(children) > 1 && (0, $eGOwo.fg)('confluence_frontend_fix_view_page_slo')) // Send event when we get more than 1 child
    try {
        throw new Error('Too many children');
    } catch (e) {
        const { stack: stack } = e;
        createAnalyticsEvent({
            eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
            action: 'rendered',
            actionSubject: 'multipleChildren',
            actionSubjectId: 'rendererActionsContext',
            attributes: {
                numChildren: (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.count(children),
                stackTrace: stack
            }
        }).fire((0, $3VCQy.FabricChannel).editor);
    }
    return /*#__PURE__*/ (0, $gt9Am.jsx)($23eeb1bb2885a66b$export$1e9ea4edb6d1bfe6.Provider, {
        value: context || actions,
        children: (0, $eGOwo.fg)('confluence_frontend_fix_view_page_slo') ? (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.only(children) : children
    });
}
const $23eeb1bb2885a66b$export$d5fcf151601331bc = $23eeb1bb2885a66b$export$1e9ea4edb6d1bfe6.Consumer;

});
parcelRegister("e6uVp", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ae78d55dc28f79f$export$2e2bcd8739ae039);

var $jxPcD = parcelRequire("jxPcD");

var $7TRmB = parcelRequire("7TRmB");

var $lovmf = parcelRequire("lovmf");

var $3lIcL = parcelRequire("3lIcL");

var $bMFKb = parcelRequire("bMFKb");

var $lzEKq = parcelRequire("lzEKq");

var $eGOwo = parcelRequire("eGOwo");

var $2mfh2 = parcelRequire("2mfh2");

var $jidPs = parcelRequire("jidPs");

var $gKium = parcelRequire("gKium");
class $8ae78d55dc28f79f$export$2e2bcd8739ae039 {
    constructor(initFromContext = false){
        // This is our psuedo feature flag for now
        // This module can only be used when wrapped with
        // the <RendererContext> component for now.
        this.initFromContext = false;
        this.initFromContext = initFromContext;
        this.transformer = new (0, $lovmf.JSONTransformer)();
    }
    //#region private
    _privateRegisterRenderer(ref, doc, schema, onAnalyticsEvent) {
        if (!this.initFromContext) return;
        else if (!this.ref) this.ref = ref;
        else if (this.ref !== ref) throw new Error("Renderer has already been registered! It's not allowed to re-register with another new Renderer instance.");
        this.doc = doc;
        this.schema = schema;
        this.onAnalyticsEvent = onAnalyticsEvent;
    }
    _privateUnregisterRenderer() {
        this.doc = undefined;
        this.ref = undefined;
        this.schema = undefined;
    }
    /**
	 * Validate whether we can create an annotation between two positions
	 */ _privateValidatePositionsForAnnotation(from, to) {
        if (!this.doc || !this.schema) return false;
        const isEmptyTextSelectionCheck = (0, $eGOwo.fg)('cc_comments_more_complete_empty_text_check') ? (0, $7TRmB.isEmptyTextSelectionRenderer) : (0, $7TRmB.isEmptyTextSelection);
        const currentSelection = (0, $3lIcL.TextSelection).create(this.doc, from, to);
        if (isEmptyTextSelectionCheck(currentSelection, this.schema)) return false;
        const result = (0, $7TRmB.canApplyAnnotationOnRange)({
            from: from,
            to: to
        }, this.doc, this.schema);
        return result;
    }
    //#endregion
    deleteAnnotation(annotationId, annotationType) {
        if (!this.doc || !this.schema || !this.schema.marks.annotation) return false;
        const mark = this.schema.marks.annotation.create({
            id: annotationId,
            annotationType: annotationType
        });
        let from;
        let to;
        let nodePos;
        let step;
        this.doc.descendants((node, pos)=>{
            const found = mark.isInSet(node.marks);
            if (found && node.type.name === 'media') nodePos = pos;
            if (found && !from) {
                // Set both here incase it only spans one node.
                from = pos;
                to = pos + node.nodeSize;
            } else if (found && from) // If the mark spans multiple nodes,
            // we'll keep setting the end until no longer found.
            to = pos + node.nodeSize;
            return true;
        });
        if (nodePos !== undefined) step = new (0, $lzEKq.RemoveNodeMarkStep)(nodePos, mark);
        else {
            if (from === undefined || to === undefined) return false;
            step = new (0, $lzEKq.RemoveMarkStep)(from, to, mark);
        }
        const { doc: doc, failed: failed } = step.apply(this.doc);
        if (this.onAnalyticsEvent) {
            const payload = {
                action: (0, $bMFKb.ACTION).DELETED,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
                attributes: {
                    inlineNodeNames: step instanceof (0, $lzEKq.RemoveMarkStep) ? (0, $jidPs.getRendererRangeInlineNodeNames)({
                        // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        pos: {
                            from: from,
                            to: to
                        },
                        actions: this
                    }) : undefined
                }
            };
            this.onAnalyticsEvent(payload);
        }
        if (!failed && doc) return {
            step: step,
            doc: this.transformer.encode(doc)
        };
        return false;
    }
    annotate(range, annotationId, annotationType) {
        if (!this.doc || !this.schema || !this.schema.marks.annotation) return false;
        const pos = (0, $2mfh2.getPosFromRange)(range);
        if (!pos) return false;
        const { from: from, to: to } = pos;
        const validPositions = this._privateValidatePositionsForAnnotation(from, to);
        if (!validPositions) return false;
        return this.applyAnnotation(pos, {
            annotationId: annotationId,
            annotationType: (0, $jxPcD.AnnotationTypes).INLINE_COMMENT
        });
    }
    isValidAnnotationRange(range) {
        if (!range) return false;
        if ((0, $eGOwo.fg)('editor_inline_comments_on_inline_nodes')) {
            if (this.isRendererWithinRange(range)) return false;
        }
        const pos = (0, $2mfh2.getPosFromRange)(range);
        if (!pos || !this.doc) return false;
        return this._privateValidatePositionsForAnnotation(pos.from, pos.to);
    }
    isRangeAnnotatable(range) {
        try {
            if (!range) return false;
            const { startContainer: startContainer, endContainer: endContainer } = range;
            if (startContainer.parentElement?.closest('.ak-renderer-extension') || endContainer.parentElement?.closest('.ak-renderer-extension')) return false;
            return this.isValidAnnotationRange(range);
        } catch  {
            // isValidAnnotationRange can fail when called inside nested renderers.
            // while isRendererWithinRange guards against this to some degree -- the classnames
            // are controlled by product -- and we don't have platform guarantees on them.
            //
            // Currently there is a mix of logic across the platform and confluence on determining
            // positions that are annotatable. This is a defensive check to ensure we don't throw an error
            // in cases where the range is not valid.
            return false;
        }
    }
    // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
    /**
	 * This is replaced by `isRangeAnnotatable`.
	 *
	 * @deprecated
	 **/ isRendererWithinRange(range) {
        const { startContainer: startContainer, endContainer: endContainer } = range;
        if (startContainer.parentElement && startContainer.parentElement.closest('.ak-renderer-extension') || endContainer.parentElement && endContainer.parentElement.closest('.ak-renderer-extension')) return true;
        return false;
    }
    isValidAnnotationPosition(pos) {
        if (!pos || !this.doc) return false;
        return this._privateValidatePositionsForAnnotation(pos.from, pos.to);
    }
    /**
	 * Note: False indicates that the selection not able to be calculated.
	 */ getPositionFromRange(range) {
        if (!this.doc || !this.schema || !range) return false;
        return (0, $2mfh2.getPosFromRange)(range);
    }
    getAnnotationMarks() {
        const { schema: schema, doc: doc } = this;
        if (!schema || !doc) return [];
        const { marks: { annotation: annotationMarkType } } = schema;
        if (!annotationMarkType) return [];
        const marks = [];
        doc.descendants((node)=>{
            const annotationsMark = node.marks.filter((m)=>m.type === annotationMarkType);
            if (!annotationsMark || !annotationsMark.length) return true;
            marks.push(...annotationsMark);
            return false;
        });
        const uniqueMarks = new Map();
        marks.forEach((m)=>{
            uniqueMarks.set(m.attrs.id, m);
        });
        return Array.from(uniqueMarks.values());
    }
    getAnnotationsByPosition(range) {
        if (!this.doc || !this.schema) return [];
        const pos = (0, $2mfh2.getPosFromRange)(range);
        if (!pos || !this.doc) return [];
        return (0, $7TRmB.getAnnotationIdsFromRange)(pos, this.doc, this.schema);
    }
    applyAnnotation(pos, annotation) {
        if (!this.doc || !pos || !this.schema) return false;
        const { from: from, to: to } = pos;
        const { annotationId: annotationId, annotationType: annotationType } = annotation;
        let step;
        let targetNodeType;
        // As part of fix for RAP, `from` points to the position right before media node
        // hence, -1 is not needed
        const beforeNodePos = from;
        const possibleNode = this.doc.nodeAt(beforeNodePos);
        if (possibleNode?.type.name === 'media') {
            targetNodeType = 'media';
            step = new (0, $lzEKq.AddNodeMarkStep)(beforeNodePos, this.schema.marks.annotation.create({
                id: annotationId,
                type: annotationType
            }));
        } else {
            const resolvedNode = this.doc.resolve(from).node();
            // annotation is technically on text, but the context is caption
            targetNodeType = resolvedNode.type.name === 'caption' ? 'caption' : 'text';
            step = (0, $2mfh2.createAnnotationStep)(from, to, {
                annotationId: annotationId,
                annotationType: annotationType,
                schema: this.schema
            });
        }
        const { doc: doc, failed: failed } = step.apply(this.doc);
        if (failed || !doc) return false;
        const originalSelection = doc.textBetween(from, to);
        const { numMatches: numMatches, matchIndex: matchIndex, blockNodePos: blockNodePos } = (0, $gKium.getIndexMatch)(this.doc, this.schema, originalSelection, from);
        return {
            step: step,
            doc: this.transformer.encode(doc),
            inlineNodeTypes: (0, $jidPs.getRendererRangeInlineNodeNames)({
                actions: this,
                pos: {
                    from: from,
                    to: to
                }
            }),
            originalSelection: originalSelection,
            numMatches: numMatches,
            matchIndex: matchIndex,
            pos: blockNodePos,
            targetNodeType: targetNodeType
        };
    }
    generateAnnotationIndexMatch(pos) {
        if (!this.doc || !pos || !this.schema) return false;
        const { from: from, to: to } = pos;
        const originalSelection = this.doc.textBetween(from, to);
        const { numMatches: numMatches, matchIndex: matchIndex, blockNodePos: blockNodePos } = (0, $gKium.getIndexMatch)(this.doc, this.schema, originalSelection, from);
        return {
            originalSelection: originalSelection,
            numMatches: numMatches,
            matchIndex: matchIndex,
            pos: blockNodePos
        };
    }
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: Do not forget to remove `undefined` when the `editor_inline_comments_on_inline_nodes` is removed.
    getInlineNodeTypes(annotationId) {
        if (!this.doc || !this.schema) return [];
        return (0, $7TRmB.getAnnotationInlineNodeTypes)({
            doc: this.doc,
            schema: this.schema
        }, annotationId);
    }
}

});
parcelRegister("7TRmB", function(module, exports) {

$parcel$export(module.exports, "canApplyAnnotationOnRange", () => $1a8b7be3131e0019$export$77ddf8216f9eb904);
$parcel$export(module.exports, "getAnnotationIdsFromRange", () => $1a8b7be3131e0019$export$badbcc229c848aec);
$parcel$export(module.exports, "hasAnnotationMark", () => $1a8b7be3131e0019$export$5fe1412b20386053);
$parcel$export(module.exports, "containsAnyAnnotations", () => $1a8b7be3131e0019$export$1976770b876b2728);
$parcel$export(module.exports, "getRangeInlineNodeNames", () => $1a8b7be3131e0019$export$35054451202ed5d9);
$parcel$export(module.exports, "getAnnotationInlineNodeTypes", () => $1a8b7be3131e0019$export$8261bc1f662f3f6e);
$parcel$export(module.exports, "getAnnotationMarksForPos", () => $1a8b7be3131e0019$export$bb1945a828f2864b);
$parcel$export(module.exports, "isEmptyTextSelection", () => $1a8b7be3131e0019$export$2efbc6d84ea0fbec);
$parcel$export(module.exports, "isEmptyTextSelectionRenderer", () => $1a8b7be3131e0019$export$a35880e7ecdcf47b);

var $jxPcD = parcelRequire("jxPcD");

var $eGOwo = parcelRequire("eGOwo");
const $1a8b7be3131e0019$export$77ddf8216f9eb904 = (rangeSelection, doc, schema)=>{
    const { from: from, to: to } = rangeSelection;
    if (isNaN(from + to) || to - from <= 0 || to < 0 || from < 0) return false;
    let foundInvalid = false;
    doc.nodesBetween(rangeSelection.from, rangeSelection.to, (node, _pos, parent)=>{
        // Special exception for hardBreak nodes
        if (schema.nodes.hardBreak === node.type) return false;
        // For block elements or text nodes, we want to check
        // if annotations are allowed inside this tree
        // or if we're leaf and not text
        if ((0, $eGOwo.fg)('editor_inline_comments_on_inline_nodes')) {
            const isAllowedInlineNode = [
                'emoji',
                'status',
                'date',
                'mention',
                'inlineCard'
            ].includes(node.type.name);
            if (node.isInline && !node.isText && !isAllowedInlineNode || node.isLeaf && !node.isText && !isAllowedInlineNode || node.isText && !parent?.type.allowsMarkType(schema.marks.annotation)) {
                foundInvalid = true;
                return false;
            }
        } else if (node.isInline && !node.isText || node.isLeaf && !node.isText || node.isText && !parent?.type.allowsMarkType(schema.marks.annotation)) {
            foundInvalid = true;
            return false;
        }
        return true;
    });
    return !foundInvalid;
};
const $1a8b7be3131e0019$export$badbcc229c848aec = (rangeSelection, doc, schema)=>{
    const { from: from, to: to } = rangeSelection;
    const annotations = new Set();
    doc.nodesBetween(from, to, (node)=>{
        if (!node.marks) return true;
        node.marks.forEach((mark)=>{
            if (mark.type === schema.marks.annotation && mark.attrs) annotations.add(mark.attrs.id);
        });
        return true;
    });
    return Array.from(annotations);
};
function $1a8b7be3131e0019$export$5fe1412b20386053(node, state) {
    const { schema: { marks: { annotation: annotationMark } } } = state;
    return !!(annotationMark && node && node.marks.length && annotationMark.isInSet(node.marks));
}
function $1a8b7be3131e0019$export$1976770b876b2728(slice, state) {
    if (!slice.content.size) return false;
    let hasAnnotation = false;
    slice.content.forEach((node)=>{
        hasAnnotation = hasAnnotation || $1a8b7be3131e0019$export$5fe1412b20386053(node, state);
        // return early if annotation found already
        if (hasAnnotation) return true;
        // check annotations in descendants
        node.descendants((node)=>{
            if ($1a8b7be3131e0019$export$5fe1412b20386053(node, state)) {
                hasAnnotation = true;
                return false;
            }
            return true;
        });
    });
    return hasAnnotation;
}
function $1a8b7be3131e0019$export$35054451202ed5d9({ doc: doc, pos: pos }) {
    if (!(0, $eGOwo.fg)('editor_inline_comments_on_inline_nodes')) return undefined;
    const nodeNames = new Set();
    try {
        doc.nodesBetween(pos.from, pos.to, (node)=>{
            if (node.isInline) nodeNames.add(node.type.name);
        });
        // We sort the list alphabetically to make human consumption of the list easier (in tools like the analytics extension)
        const sortedNames = [
            ...nodeNames
        ].sort();
        return sortedNames;
    } catch  {
        // Some callers have existing gaps where the positions are not valid,
        // and so when called in the current document can throw an error if out of range.
        //
        // This is a defensive check to ensure we don't throw an error in those cases.
        return undefined;
    }
}
function $1a8b7be3131e0019$export$8261bc1f662f3f6e(state, annotationId) {
    if (!(0, $eGOwo.fg)('editor_inline_comments_on_inline_nodes')) return undefined;
    const mark = state.schema.marks.annotation.create({
        id: annotationId,
        annotationType: (0, $jxPcD.AnnotationTypes).INLINE_COMMENT
    });
    const inlineNodeNames = new Set();
    state.doc.descendants((node, pos)=>{
        if (mark.isInSet(node.marks)) inlineNodeNames.add(node.type.name);
        return true;
    });
    // This sorting is done to make human consumption easier (ie. in dev tools, test snapshots, analytics events, ...)
    return [
        ...inlineNodeNames
    ].sort();
}
function $1a8b7be3131e0019$export$bb1945a828f2864b(pos) {
    if (!(0, $eGOwo.fg)('editor_inline_comments_paste_insert_nodes')) return undefined;
    const annotationMarks = pos.marks().filter((mark)=>mark.type === pos.doc.type.schema.marks.annotation);
    return annotationMarks;
}
function $1a8b7be3131e0019$export$2efbc6d84ea0fbec(selection, schema) {
    const { text: text, paragraph: paragraph } = schema.nodes;
    let hasContent = false;
    selection.content().content.descendants((node)=>{
        // for empty paragraph - consider empty (nothing to comment on)
        if (node.type === paragraph && !node.content.size) return false;
        // for not a text or nonempty text - consider nonempty (can comment if the node is supported for annotations)
        if (node.type !== text || !node.textContent) hasContent = true;
        return !hasContent;
    });
    return !hasContent;
}
function $1a8b7be3131e0019$export$a35880e7ecdcf47b(selection, schema) {
    const { text: text, paragraph: paragraph } = schema.nodes;
    let hasContent = false;
    selection.content().content.descendants((node)=>{
        // for empty paragraph - consider empty (nothing to comment on)
        if (node.type === paragraph && !node.content.size) return false;
        // for inline elements - consider nonempty
        if (node.type !== text && node.type.isInline) hasContent = true;
        // for nonempty text - consider nonempty (can comment if the node is supported for annotations)
        if (node.type === text && !!node.textContent) hasContent = true;
        // for other non-text nodes - continue descending
        return !hasContent;
    });
    return !hasContent;
}

});

parcelRegister("2mfh2", function(module, exports) {

$parcel$export(module.exports, "isRoot", () => $03329e2d8fa98a74$export$e3140dc7d0c35e48);
$parcel$export(module.exports, "getPosFromRange", () => $03329e2d8fa98a74$export$243cdddc5b21d8c1);
$parcel$export(module.exports, "createAnnotationStep", () => $03329e2d8fa98a74$export$74899f7e5acb5cd3);

var $eGOwo = parcelRequire("eGOwo");

var $lzEKq = parcelRequire("lzEKq");
function $03329e2d8fa98a74$var$getStartPos(element) {
    return parseInt(element.dataset.rendererStartPos || '-1', 10);
}
const $03329e2d8fa98a74$var$getNodeType = (element)=>element.dataset.nodeType;
function $03329e2d8fa98a74$var$isPositionPointer(element) {
    return $03329e2d8fa98a74$var$getStartPos(element) > -1;
}
function $03329e2d8fa98a74$var$findParent(element) {
    const { parentElement: parentElement } = element;
    if (!parentElement || $03329e2d8fa98a74$export$e3140dc7d0c35e48(parentElement)) return null;
    if ($03329e2d8fa98a74$var$isPositionPointer(parentElement)) return parentElement;
    return $03329e2d8fa98a74$var$findParent(parentElement);
}
function $03329e2d8fa98a74$var$findMediaParent(element) {
    const { parentElement: parentElement } = element;
    if (!parentElement || $03329e2d8fa98a74$export$e3140dc7d0c35e48(parentElement)) return null;
    if (parentElement.dataset.nodeType === 'mediaSingle') return parentElement;
    return $03329e2d8fa98a74$var$findMediaParent(parentElement);
}
function $03329e2d8fa98a74$var$findParentBeforePointer(element) {
    const { parentElement: parentElement } = element;
    if ($03329e2d8fa98a74$export$e3140dc7d0c35e48(parentElement) || !parentElement) return null;
    if ($03329e2d8fa98a74$var$isPositionPointer(parentElement)) return element;
    return $03329e2d8fa98a74$var$findParentBeforePointer(parentElement);
}
function $03329e2d8fa98a74$var$isElementNode(node) {
    return node.nodeType === Node.ELEMENT_NODE;
}
function $03329e2d8fa98a74$var$isTextNode(node) {
    return node.nodeType === Node.TEXT_NODE;
}
function $03329e2d8fa98a74$var$isHighlightTextNode(node) {
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    return !!node?.dataset?.highlighted;
}
function $03329e2d8fa98a74$var$isNodeInlineMark(node) {
    return $03329e2d8fa98a74$var$isElementNode(node) && Boolean(node.dataset.rendererMark);
}
function $03329e2d8fa98a74$var$isElementInlineMark(element) {
    return !!element && Boolean(element.dataset.rendererMark);
}
function $03329e2d8fa98a74$var$isNodeInlineTextMark(node) {
    if (node === null) return false;
    const isInlineMark = $03329e2d8fa98a74$var$isElementNode(node) && Boolean(node.dataset.rendererMark);
    if (!isInlineMark) return false;
    /**
	 * This checks if the element has any descendents with the data-inline-card
	 * attribute set to 'true'. If it does, we should not consider it as an
	 * inline text mark.
	 **/ if ($03329e2d8fa98a74$var$hasInlineNodeDescendant(node)) return false;
    return true;
}
/**
 * This checks all the descendents of a node and returns true if it reaches
 * a descendant with the data-inline-card attribute set to 'true'.
 */ function $03329e2d8fa98a74$var$hasInlineNodeDescendant(node) {
    if ($03329e2d8fa98a74$var$isElementNode(node)) {
        if ((0, $eGOwo.fg)('editor_inline_comments_on_inline_nodes')) {
            if (node.dataset.annotationInlineNode === 'true') return true;
        } else {
            if (node.dataset.inlineCard === 'true') return true;
        }
        return Array.from(node.childNodes).some($03329e2d8fa98a74$var$hasInlineNodeDescendant);
    }
    return false;
}
function $03329e2d8fa98a74$var$resolveNodePos(node) {
    let resolvedPos = 0;
    let prev = node.previousSibling;
    while(prev){
        if ((0, $eGOwo.fg)('platform_editor_annotation_position_comment_nodes')) {
            if (prev.nodeType === Node.COMMENT_NODE) {
                // Comment nodes should not result in the position being
                // incremented, so we skip them.
                prev = prev.previousSibling;
                continue;
            }
        }
        if (prev && ($03329e2d8fa98a74$var$isTextNode(prev) || $03329e2d8fa98a74$var$isHighlightTextNode(prev))) resolvedPos += (prev.textContent || '').length;
        else if (prev) {
            if ((0, $eGOwo.fg)('editor_inline_comments_on_inline_nodes')) {
                if ($03329e2d8fa98a74$var$isNodeInlineTextMark(prev) && prev.textContent) resolvedPos += prev.textContent.length;
                else resolvedPos += 1;
            } else if ($03329e2d8fa98a74$var$isNodeInlineMark(prev) && prev.textContent) resolvedPos += prev.textContent.length;
            else resolvedPos += 1;
        }
        prev = prev.previousSibling;
    }
    return resolvedPos;
}
function $03329e2d8fa98a74$export$e3140dc7d0c35e48(element) {
    return !!element && element.classList.contains('ak-renderer-document');
}
function $03329e2d8fa98a74$export$5db587db55468da7(node, offset, findEnd = false) {
    // If the passed node doesn't exist, we should abort
    if (!node) return false;
    if ((0, $eGOwo.fg)('editor_inline_comments_on_inline_nodes')) {
        const startPosAncestor = node.parentElement?.closest('[data-renderer-start-pos');
        const potentialParent = (0, $eGOwo.fg)('editor_inline_comments_on_inline_nodes') ? 'data-annotation-mark' : 'data-inline-card';
        if (startPosAncestor?.hasAttribute(potentialParent)) {
            if (findEnd) return parseInt(startPosAncestor?.getAttribute('data-renderer-start-pos') || '-1', 10) + 1;
            else return parseInt(startPosAncestor?.getAttribute('data-renderer-start-pos') || '-1', 10);
        }
    }
    /**
	 * If anchor node is an element (e.g. after a triple click) the anchorOffset
	 * is the number of child nodes preceding the anchor.
	 * https://developer.mozilla.org/en-US/docs/Web/API/Selection/anchorOffset
	 *
	 * For end pos we calculate the number of characters by stepping through
	 * each of the node's children.
	 */ if (node instanceof HTMLElement && $03329e2d8fa98a74$var$isPositionPointer(node)) {
        if (findEnd) {
            let count = $03329e2d8fa98a74$var$getStartPos(node);
            const children = node.childNodes;
            for(let i = 0; i < offset; i++)count += children[i]?.textContent?.length || 1;
            return count;
        }
        return $03329e2d8fa98a74$var$getStartPos(node) + offset;
    }
    const parent = $03329e2d8fa98a74$var$findParent(node);
    // Similar to above, if we cant find a parent position pointer
    // we should not proceed.
    if (!parent) return false;
    let resolvedPos = $03329e2d8fa98a74$var$getStartPos(parent);
    let current = node;
    if (current.parentElement && current.parentElement !== parent) {
        // Find the parent element that is a direct child of the position pointer
        // the outer most element from our text position.
        const preParentPointer = $03329e2d8fa98a74$var$findParentBeforePointer(current.parentElement);
        // If our range is inside an inline node
        // We need to move our pointers to parent element
        // since we don't want to count text inside inline nodes at all
        if ((0, $eGOwo.fg)('editor_inline_comments_on_inline_nodes')) {
            if (!($03329e2d8fa98a74$var$isNodeInlineTextMark(preParentPointer) || $03329e2d8fa98a74$var$isHighlightTextNode(preParentPointer))) {
                current = current.parentElement;
                offset = 0;
            }
        } else if (!($03329e2d8fa98a74$var$isElementInlineMark(preParentPointer) || $03329e2d8fa98a74$var$isHighlightTextNode(preParentPointer))) {
            current = current.parentElement;
            offset = 0;
        }
        resolvedPos += $03329e2d8fa98a74$var$resolveNodePos(current);
        while(current && current.parentElement !== parent){
            current = current.parentNode;
            if (current) {
                const nodePos = $03329e2d8fa98a74$var$resolveNodePos(current);
                resolvedPos += nodePos;
            }
        }
    } else resolvedPos += $03329e2d8fa98a74$var$resolveNodePos(current);
    return resolvedPos + offset;
}
function $03329e2d8fa98a74$export$243cdddc5b21d8c1(range) {
    const { startContainer: startContainer, startOffset: startOffset, endContainer: endContainer, endOffset: endOffset } = range;
    const possibleMediaOrMediaSingleElement = $03329e2d8fa98a74$var$findParent(startContainer);
    // Video hover targets return media single, not media, thus, the extra check in condition.
    const isMediaOrMediaSingle = possibleMediaOrMediaSingleElement && // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    /media|mediaSingle/.test($03329e2d8fa98a74$var$getNodeType(possibleMediaOrMediaSingleElement) || '');
    if (isMediaOrMediaSingle) {
        let pos;
        const mediaSingleElement = $03329e2d8fa98a74$var$getNodeType(possibleMediaOrMediaSingleElement) === 'mediaSingle' ? possibleMediaOrMediaSingleElement : $03329e2d8fa98a74$var$findMediaParent(possibleMediaOrMediaSingleElement);
        if (mediaSingleElement) pos = $03329e2d8fa98a74$var$getStartPos(mediaSingleElement);
        if (pos !== undefined) return {
            from: pos,
            to: pos
        };
    }
    const from = $03329e2d8fa98a74$export$5db587db55468da7(startContainer, startOffset);
    const findEnd = true;
    const to = $03329e2d8fa98a74$export$5db587db55468da7(endContainer, endOffset, findEnd);
    if (from === false || to === false) return false;
    return {
        from: from,
        to: to
    };
}
function $03329e2d8fa98a74$export$74899f7e5acb5cd3(from, to, opts) {
    return new (0, $lzEKq.AddMarkStep)(Math.min(from, to), Math.max(from, to), opts.schema.marks.annotation.create({
        id: opts.annotationId,
        annotationType: opts.annotationType
    }));
}

});

parcelRegister("jidPs", function(module, exports) {

$parcel$export(module.exports, "getRendererRangeInlineNodeNames", () => $87925fa32df8c0bb$export$b0ea72d31617ccea);

var $7TRmB = parcelRequire("7TRmB");

var $eGOwo = parcelRequire("eGOwo");
function $87925fa32df8c0bb$export$b0ea72d31617ccea({ actions: actions, pos: pos }) {
    if (!(0, $eGOwo.fg)('editor_inline_comments_on_inline_nodes')) return undefined;
    const { doc: doc } = actions;
    if (!pos || !doc) return undefined;
    const inlineNodeNames = (0, $7TRmB.getRangeInlineNodeNames)({
        doc: doc,
        pos: pos
    });
    return inlineNodeNames;
}

});

parcelRegister("gKium", function(module, exports) {

$parcel$export(module.exports, "getIndexMatch", () => $55cdc9eaf22a5d55$export$fb7dab895a0d310e);
function $55cdc9eaf22a5d55$export$fb7dab895a0d310e(doc, schema, selectedText, startIndex) {
    let textContent = '';
    let matchIndex = 0;
    let numMatches = 0;
    let blockNodePos;
    doc.descendants((node, pos)=>{
        const nodeType = node.type;
        const { media: media } = schema.nodes;
        // Mirrors Confluence backend and doesn't construct textContent if it doesn't allow annotations
        // Don't skip media node so that block node can be defined its startIndex in within [nodeStart, nodeEnd]
        if ((node.isText || !nodeType.allowsMarkType(schema.marks.annotation)) && nodeType !== media) // Note: `return true` as a parent disallowing annotations does not mean a child disallows annotations.
        // Eg: panel (invalid) > p (valid)
        return true;
        const nodeStart = pos;
        const nodeEnd = nodeStart + node.nodeSize;
        if (startIndex >= nodeStart && startIndex <= nodeEnd) {
            // if it's a node block, set position to pos to indicate to the backend
            // that it's an annotation on a block node
            if (nodeType === media) blockNodePos = pos;
            // If the start of the annotation selection is within the current node, we scan the document for previous occurrences
            // Find the index by counting all previous instances of the selectedText in the partial textContent
            // Need to scan from start, up to `startIndex` (which includes partial of the current node)
            textContent += doc.textBetween(nodeStart, startIndex - 1);
            matchIndex = $55cdc9eaf22a5d55$export$3c2359e76fc742da(textContent, selectedText);
            // Complete appending of the node
            textContent += doc.textBetween(startIndex, nodeEnd);
        } else textContent += node.textContent;
        return true;
    });
    // Count total number of matches in final text
    numMatches = $55cdc9eaf22a5d55$export$3c2359e76fc742da(textContent, selectedText);
    return {
        numMatches: numMatches,
        matchIndex: matchIndex,
        textContent: textContent,
        blockNodePos: blockNodePos
    };
}
function $55cdc9eaf22a5d55$export$3c2359e76fc742da(searchString, query) {
    if (searchString === '' || query === '') return 0;
    // Escape characters that would trigger as syntax in a regex query before converting to the query
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const reg = new RegExp(query.replace(/(?=[.\\+*?[^\]$(){}\|])/g, '\\'), 'g');
    return (searchString.match(reg) || []).length;
}

});






parcelRegister("2MYsB", function(module, exports) {

$parcel$export(module.exports, "AnnotationsContextWrapper", () => $3225c5b8d7284970$export$787af8a111ff3c03);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $eFHDV = parcelRequire("eFHDV");

var $iYQKl = parcelRequire("iYQKl");

var $4jhSu = parcelRequire("4jhSu");
const $3225c5b8d7284970$export$787af8a111ff3c03 = (props)=>{
    const providers = (0, $eJOHy.useContext)((0, $eFHDV.ProvidersContext));
    const { rendererRef: rendererRef, createAnalyticsEvent: createAnalyticsEvent, children: children } = props;
    const inlineCommentProvider = providers && providers.inlineComment;
    const selectionComponent = inlineCommentProvider && inlineCommentProvider.selectionComponent;
    const hoverComponent = inlineCommentProvider && inlineCommentProvider.hoverComponent;
    if (!selectionComponent && !hoverComponent) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            children,
            !!hoverComponent && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iYQKl.RangeValidator), {
                createAnalyticsEvent: createAnalyticsEvent,
                rendererRef: rendererRef,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                component: hoverComponent
            }),
            !!selectionComponent && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4jhSu.SelectionRangeValidator), {
                createAnalyticsEvent: createAnalyticsEvent,
                rendererRef: rendererRef,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                selectionComponent: selectionComponent
            })
        ]
    });
};

});
parcelRegister("iYQKl", function(module, exports) {

$parcel$export(module.exports, "RangeValidator", () => $66f06c5e6ba01ad8$export$6d8376a902cb8aa7);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $eCe47 = parcelRequire("eCe47");

var $4Z9bh = parcelRequire("4Z9bh");

var $e2m7L = parcelRequire("e2m7L");

var $8dxEE = parcelRequire("8dxEE");
const $66f06c5e6ba01ad8$export$6d8376a902cb8aa7 = (props)=>{
    const { component: component, rendererRef: rendererRef, createAnalyticsEvent: createAnalyticsEvent } = props;
    const actions = (0, $eJOHy.useContext)((0, $4Z9bh.RendererContext));
    const { clearHoverRange: clearHoverRange } = (0, $e2m7L.useAnnotationRangeDispatch)();
    const { range: range, type: type } = (0, $e2m7L.useAnnotationRangeState)();
    const { isWithinRange: isWithinRange } = (0, $8dxEE.useAnnotationHoverContext)();
    if (!range || type !== 'hover') return null;
    const documentPosition = actions.getPositionFromRange(range);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eCe47.Mounter), {
        isWithinRange: isWithinRange,
        range: range,
        wrapperDOM: rendererRef,
        component: component,
        onClose: clearHoverRange,
        documentPosition: documentPosition,
        isAnnotationAllowed: true,
        applyAnnotation: actions.applyAnnotation.bind(actions),
        generateIndexMatch: actions.generateAnnotationIndexMatch.bind(actions),
        createAnalyticsEvent: createAnalyticsEvent
    });
};
$66f06c5e6ba01ad8$export$6d8376a902cb8aa7.displayName = 'HoverRangeValidator';

});
parcelRegister("eCe47", function(module, exports) {

$parcel$export(module.exports, "Mounter", () => $1f52d6c5534efa56$export$2109cd350bcf6eda);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $jxPcD = parcelRequire("jxPcD");

var $fH5Zn = parcelRequire("fH5Zn");

var $bgewf = parcelRequire("bgewf");

var $bMFKb = parcelRequire("bMFKb");

var $4Z9bh = parcelRequire("4Z9bh");

var $e2m7L = parcelRequire("e2m7L");

var $eGOwo = parcelRequire("eGOwo");
const $1f52d6c5534efa56$export$2109cd350bcf6eda = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo((props)=>{
    const { component: Component, range: range, isWithinRange: isWithinRange, isAnnotationAllowed: isAnnotationAllowed, wrapperDOM: wrapperDOM, onClose: onCloseProps, documentPosition: documentPosition, applyAnnotation: applyAnnotation, createAnalyticsEvent: createAnalyticsEvent, generateIndexMatch: generateIndexMatch } = props;
    const { promoteHoverToDraft: promoteHoverToDraft, clearHoverDraft: clearHoverDraft } = (0, $e2m7L.useAnnotationRangeDispatch)();
    const { hoverDraftDocumentPosition: hoverDraftDocumentPosition } = (0, $e2m7L.useAnnotationRangeState)();
    const actions = (0, $eJOHy.useContext)((0, $4Z9bh.RendererContext));
    const onCreateCallback = (0, $eJOHy.useCallback)((annotationId)=>{
        const positionToAnnotate = hoverDraftDocumentPosition || documentPosition;
        if (!isAnnotationAllowed || !positionToAnnotate || !applyAnnotation) return false;
        const annotation = {
            annotationId: annotationId,
            annotationType: (0, $jxPcD.AnnotationTypes).INLINE_COMMENT
        };
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $bMFKb.ACTION).INSERTED,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).INLINE_COMMENT,
            attributes: {},
            eventType: (0, $bMFKb.EVENT_TYPE).TRACK
        }).fire((0, $bgewf.FabricChannel).editor);
        return applyAnnotation(positionToAnnotate, annotation);
    }, [
        isAnnotationAllowed,
        documentPosition,
        applyAnnotation,
        createAnalyticsEvent,
        hoverDraftDocumentPosition
    ]);
    const createIndexCallback = (0, $eJOHy.useCallback)(()=>{
        if (!documentPosition || !generateIndexMatch) return false;
        const result = generateIndexMatch(documentPosition);
        if (!result) return false;
        return result;
    }, [
        documentPosition,
        generateIndexMatch
    ]);
    const applyDraftModeCallback = (0, $eJOHy.useCallback)((options)=>{
        if (!documentPosition || !isAnnotationAllowed) {
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $bMFKb.ACTION).CREATE_NOT_ALLOWED,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).INLINE_COMMENT,
                attributes: {
                    documentPosition: documentPosition,
                    isAnnotationAllowed: isAnnotationAllowed
                },
                eventType: (0, $bMFKb.EVENT_TYPE).TRACK
            }).fire((0, $bgewf.FabricChannel).editor);
            return false;
        }
        promoteHoverToDraft(documentPosition);
        if (createAnalyticsEvent) {
            const uniqueAnnotationsInRange = actions.getAnnotationsByPosition(range);
            createAnalyticsEvent({
                action: (0, $bMFKb.ACTION).OPENED,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
                attributes: {
                    overlap: uniqueAnnotationsInRange.length
                }
            }).fire((0, $bgewf.FabricChannel).editor);
        }
        window.requestAnimationFrame(()=>{
            if (options.keepNativeSelection) (0, $fH5Zn.updateWindowSelectionAroundDraft)(documentPosition);
            else {
                const sel = window.getSelection();
                if (sel) sel.removeAllRanges();
            }
        });
        const positionToAnnotate = hoverDraftDocumentPosition || documentPosition;
        if (!positionToAnnotate || !applyAnnotation || !options.annotationId) {
            if ((0, $eGOwo.fg)('cc_comments_improve_apply_draft_errors')) {
                if (createAnalyticsEvent) createAnalyticsEvent({
                    action: (0, $bMFKb.ACTION).CREATE_NOT_ALLOWED,
                    actionSubject: (0, $bMFKb.ACTION_SUBJECT).ANNOTATION,
                    actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).INLINE_COMMENT,
                    attributes: {
                        positionToAnnotate: positionToAnnotate,
                        applyAnnotationMissing: !applyAnnotation,
                        annotationId: options.annotationId
                    },
                    eventType: (0, $bMFKb.EVENT_TYPE).TRACK
                }).fire((0, $bgewf.FabricChannel).editor);
            }
            return false;
        }
        const annotation = {
            annotationId: options.annotationId,
            annotationType: (0, $jxPcD.AnnotationTypes).INLINE_COMMENT
        };
        return applyAnnotation(positionToAnnotate, annotation);
    }, [
        documentPosition,
        isAnnotationAllowed,
        createAnalyticsEvent,
        applyAnnotation,
        actions,
        range,
        promoteHoverToDraft,
        hoverDraftDocumentPosition
    ]);
    const removeDraftModeCallback = (0, $eJOHy.useCallback)(()=>{
        clearHoverDraft();
        const sel = window.getSelection();
        if (sel) sel.removeAllRanges();
    }, [
        clearHoverDraft
    ]);
    const onCloseCallback = (0, $eJOHy.useCallback)(()=>{
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $bMFKb.ACTION).CLOSED,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).INLINE_COMMENT,
            eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
            attributes: {}
        }).fire((0, $bgewf.FabricChannel).editor);
        removeDraftModeCallback();
        onCloseProps();
    }, [
        onCloseProps,
        removeDraftModeCallback,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
        range: range,
        isWithinRange: isWithinRange,
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        wrapperDOM: wrapperDOM.current,
        isAnnotationAllowed: isAnnotationAllowed,
        onClose: onCloseCallback,
        onCreate: onCreateCallback,
        getAnnotationIndexMatch: createIndexCallback,
        applyDraftMode: applyDraftModeCallback,
        removeDraftMode: removeDraftModeCallback
    });
});

});
parcelRegister("fH5Zn", function(module, exports) {

$parcel$export(module.exports, "dataAttributes", () => $2de571c1e1a9c251$export$15d6ddc168d35719);
$parcel$export(module.exports, "updateWindowSelectionAroundDraft", () => $2de571c1e1a9c251$export$e14699d956e87e73);
const $2de571c1e1a9c251$export$15d6ddc168d35719 = ({ from: from, to: to })=>{
    return {
        ['data-annotation-draft-mark']: true,
        ['data-draft-start-at']: from,
        ['data-draft-end-at']: to
    };
};
const $2de571c1e1a9c251$var$buildDataAttributesQuery = (pos)=>{
    const a = $2de571c1e1a9c251$export$15d6ddc168d35719(pos);
    return Object.entries(a).map(([k, v])=>`[${k}="${v}"]`).join('');
};
const $2de571c1e1a9c251$export$e14699d956e87e73 = (pos)=>{
    const sel = window.getSelection();
    if (!sel) return false;
    const draftNodes = document.querySelectorAll($2de571c1e1a9c251$var$buildDataAttributesQuery(pos));
    if (!draftNodes || draftNodes.length === 0) return false;
    sel.removeAllRanges();
    const range = document.createRange();
    range.setStart(draftNodes[0], 0);
    range.setEndAfter(draftNodes[draftNodes.length - 1]);
    sel.addRange(range);
    return true;
};

});

parcelRegister("e2m7L", function(module, exports) {

$parcel$export(module.exports, "AnnotationRangeProvider", () => $cf414537940f7a80$export$30384a6aedd19fee);
$parcel$export(module.exports, "useAnnotationRangeState", () => $cf414537940f7a80$export$e07ee6d6cc95d9a0);
$parcel$export(module.exports, "useAnnotationRangeDispatch", () => $cf414537940f7a80$export$708fc397e2b6f08d);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
const $cf414537940f7a80$var$initialState = {
    type: null,
    selectionRange: null,
    hoverRange: null,
    selectionDraftRange: null,
    hoverDraftRange: null,
    selectionDraftDocumentPosition: null,
    hoverDraftDocumentPosition: null
};
function $cf414537940f7a80$var$reducer(state, action) {
    switch(action.type){
        case 'clearSelection':
            if (state.selectionRange !== null) return {
                ...state,
                selectionRange: null,
                type: state.type === 'selection' ? null : state.type
            };
            return state;
        case 'clearHover':
            if (state.hoverRange !== null) return {
                ...state,
                hoverRange: null,
                type: state.type === 'hover' ? null : state.type
            };
            return state;
        case 'setSelection':
            if (state.selectionRange !== action.range) return {
                ...state,
                selectionRange: action.range,
                type: 'selection'
            };
            return state;
        case 'setHover':
            if (state.hoverRange !== action.range) return {
                ...state,
                hoverRange: action.range,
                type: 'hover'
            };
            return state;
        case 'promoteSelectionToDraft':
            // we should only promote the range to a draft if the current range type is a selection
            // we should also store the promotion type, so that a clear will not accidently clear the draft of a
            // different type
            if (state.selectionDraftRange !== state.selectionRange) return {
                ...state,
                selectionRange: null,
                type: state.type === 'selection' ? null : state.type,
                selectionDraftRange: state.selectionRange,
                selectionDraftDocumentPosition: action.position
            };
            return state;
        case 'promoteHoverToDraft':
            if (state.hoverDraftRange !== state.hoverRange) return {
                ...state,
                hoverRange: null,
                type: state.type === 'hover' ? null : state.type,
                hoverDraftRange: state.hoverRange,
                hoverDraftDocumentPosition: action.position
            };
            return state;
        case 'clearSelectionDraft':
            if (state.selectionDraftRange !== null) return {
                ...state,
                selectionDraftRange: null,
                selectionDraftDocumentPosition: null
            };
            return state;
        case 'clearHoverDraft':
            if (state.hoverDraftRange !== null) return {
                ...state,
                hoverDraftRange: null,
                hoverDraftDocumentPosition: null
            };
            return state;
    }
}
const $cf414537940f7a80$export$145b9bb655c3d220 = /*#__PURE__*/ (0, $eJOHy.createContext)({
    range: null,
    type: null,
    selectionDraftRange: null,
    hoverDraftRange: null,
    selectionDraftDocumentPosition: null,
    hoverDraftDocumentPosition: null
});
const $cf414537940f7a80$export$efb0d1c8cbaac647 = /*#__PURE__*/ (0, $eJOHy.createContext)({
    clearSelectionRange: ()=>{},
    clearHoverRange: ()=>{},
    setSelectionRange: ()=>{},
    promoteSelectionToDraft: ()=>{},
    promoteHoverToDraft: ()=>{},
    clearSelectionDraft: ()=>{},
    clearHoverDraft: ()=>{}
});
const $cf414537940f7a80$export$7cf774ce920e4bbd = ({ children: children, allowCommentsOnMedia: allowCommentsOnMedia })=>{
    const [{ selectionRange: selectionRange, hoverRange: hoverRange, type: type, selectionDraftRange: selectionDraftRange, selectionDraftDocumentPosition: selectionDraftDocumentPosition, hoverDraftRange: hoverDraftRange, hoverDraftDocumentPosition: hoverDraftDocumentPosition }, dispatch] = (0, $eJOHy.useReducer)($cf414537940f7a80$var$reducer, $cf414537940f7a80$var$initialState);
    const clearSelectionRange = (0, $eJOHy.useCallback)(()=>dispatch({
            type: 'clearSelection'
        }), []);
    const clearHoverRange = (0, $eJOHy.useCallback)(()=>dispatch({
            type: 'clearHover'
        }), []);
    const setSelectionRange = (0, $eJOHy.useCallback)((range)=>dispatch({
            type: 'setSelection',
            range: range
        }), []);
    const setHoverTarget = (0, $eJOHy.useCallback)((target)=>{
        // the HoverComponent expects an element deeply nested inside media, these classes work with the current implementation
        const mediaNode = target.querySelector('.media-card-inline-player, .media-file-card-view');
        if (!mediaNode) return;
        const range = document.createRange();
        range.setStartBefore(mediaNode);
        range.setEndAfter(mediaNode);
        dispatch({
            type: 'setHover',
            range: range
        });
    }, []);
    const promoteSelectionToDraft = (0, $eJOHy.useCallback)((position)=>{
        dispatch({
            type: 'promoteSelectionToDraft',
            position: position
        });
    }, []);
    const clearSelectionDraft = (0, $eJOHy.useCallback)(()=>{
        dispatch({
            type: 'clearSelectionDraft'
        });
    }, []);
    const promoteHoverToDraft = (0, $eJOHy.useCallback)((position)=>{
        dispatch({
            type: 'promoteHoverToDraft',
            position: position
        });
    }, []);
    const clearHoverDraft = (0, $eJOHy.useCallback)(()=>{
        dispatch({
            type: 'clearHoverDraft'
        });
    }, []);
    const stateData = (0, $eJOHy.useMemo)(()=>{
        return {
            // We techinically have two ranges, however we only want to expose one of them at a time, because only one draft
            // can be active at a time. The type of range is used to determine which range is active.
            range: type === 'selection' ? selectionRange : hoverRange,
            type: type,
            selectionDraftRange: selectionDraftRange,
            hoverDraftRange: hoverDraftRange,
            selectionDraftDocumentPosition: selectionDraftDocumentPosition,
            hoverDraftDocumentPosition: hoverDraftDocumentPosition
        };
    }, [
        selectionRange,
        hoverRange,
        type,
        selectionDraftRange,
        selectionDraftDocumentPosition,
        hoverDraftRange,
        hoverDraftDocumentPosition
    ]);
    const dispatchData = (0, $eJOHy.useMemo)(()=>({
            clearSelectionRange: clearSelectionRange,
            clearHoverRange: clearHoverRange,
            setSelectionRange: setSelectionRange,
            setHoverTarget: !!allowCommentsOnMedia ? setHoverTarget : undefined,
            promoteSelectionToDraft: promoteSelectionToDraft,
            promoteHoverToDraft: promoteHoverToDraft,
            clearSelectionDraft: clearSelectionDraft,
            clearHoverDraft: clearHoverDraft
        }), [
        allowCommentsOnMedia,
        clearSelectionRange,
        clearHoverRange,
        setSelectionRange,
        setHoverTarget,
        promoteSelectionToDraft,
        promoteHoverToDraft,
        clearSelectionDraft,
        clearHoverDraft
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($cf414537940f7a80$export$145b9bb655c3d220.Provider, {
        value: stateData,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($cf414537940f7a80$export$efb0d1c8cbaac647.Provider, {
            value: dispatchData,
            children: children
        })
    });
};
const $cf414537940f7a80$export$30384a6aedd19fee = ({ children: children, allowCommentsOnMedia: allowCommentsOnMedia, isNestedRender: isNestedRender })=>{
    /*
	 * If this is a nested render, we do not provide the context
	 * because it has already been provided higher up the component tree
	 * and we need the original context to create annotations on extensions.
	 */ return isNestedRender ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: children
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)($cf414537940f7a80$export$7cf774ce920e4bbd, {
        allowCommentsOnMedia: allowCommentsOnMedia,
        children: children
    });
};
const $cf414537940f7a80$export$e07ee6d6cc95d9a0 = ()=>{
    return (0, $eJOHy.useContext)($cf414537940f7a80$export$145b9bb655c3d220);
};
const $cf414537940f7a80$export$708fc397e2b6f08d = ()=>{
    return (0, $eJOHy.useContext)($cf414537940f7a80$export$efb0d1c8cbaac647);
};

});


parcelRegister("8dxEE", function(module, exports) {

$parcel$export(module.exports, "AnnotationHoverContext", () => $eff383fadc0ede10$export$b3db0feb20552fc3);
$parcel$export(module.exports, "useAnnotationHoverContext", () => $eff383fadc0ede10$export$a02bfcbbbf920306);
$parcel$export(module.exports, "useAnnotationHoverDispatch", () => $eff383fadc0ede10$export$c288883964405c82);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
const $eff383fadc0ede10$var$AnnotationHoverStateContext = /*#__PURE__*/ (0, $eJOHy.createContext)({
    isWithinRange: false
});
const $eff383fadc0ede10$var$AnnotationHoverDispatchContext = /*#__PURE__*/ (0, $eJOHy.createContext)({
    cancelTimeout: ()=>{},
    initiateTimeout: ()=>{},
    setIsWithinRange: ()=>{}
});
const $eff383fadc0ede10$export$b3db0feb20552fc3 = ({ children: children })=>{
    const [isWithinRange, setIsWithinRange] = (0, $eJOHy.useState)(false);
    const timeoutHandler = (0, $eJOHy.useRef)();
    const cancelTimeout = (0, $eJOHy.useCallback)(()=>{
        if (timeoutHandler) clearTimeout(timeoutHandler.current);
    }, [
        timeoutHandler
    ]);
    const initiateTimeout = (0, $eJOHy.useCallback)(()=>{
        if (isWithinRange) timeoutHandler.current = setTimeout(()=>{
            setIsWithinRange(false);
        }, 500);
    }, [
        isWithinRange
    ]);
    const stateData = (0, $eJOHy.useMemo)(()=>({
            isWithinRange: isWithinRange
        }), [
        isWithinRange
    ]);
    const dispatchData = (0, $eJOHy.useMemo)(()=>({
            cancelTimeout: cancelTimeout,
            initiateTimeout: initiateTimeout,
            setIsWithinRange: setIsWithinRange
        }), [
        cancelTimeout,
        initiateTimeout,
        setIsWithinRange
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($eff383fadc0ede10$var$AnnotationHoverStateContext.Provider, {
        value: stateData,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($eff383fadc0ede10$var$AnnotationHoverDispatchContext.Provider, {
            value: dispatchData,
            children: children
        })
    });
};
const $eff383fadc0ede10$export$a02bfcbbbf920306 = ()=>{
    return (0, $eJOHy.useContext)($eff383fadc0ede10$var$AnnotationHoverStateContext);
};
const $eff383fadc0ede10$export$c288883964405c82 = ()=>{
    return (0, $eJOHy.useContext)($eff383fadc0ede10$var$AnnotationHoverDispatchContext);
};

});


parcelRegister("4jhSu", function(module, exports) {

$parcel$export(module.exports, "SelectionRangeValidator", () => $d15d2217dff1b0e8$export$74435b85e23b84d9);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8Saoj = parcelRequire("8Saoj");

var $bggde = parcelRequire("bggde");

var $4Z9bh = parcelRequire("4Z9bh");
const $d15d2217dff1b0e8$export$74435b85e23b84d9 = (props)=>{
    const { selectionComponent: selectionComponent, rendererRef: rendererRef, createAnalyticsEvent: createAnalyticsEvent } = props;
    const actions = (0, $eJOHy.useContext)((0, $4Z9bh.RendererContext));
    const [type, range, draftRange, clearRange] = (0, $8Saoj.useUserSelectionRange)({
        rendererRef: rendererRef
    });
    const selectionRange = type === 'selection' ? range : null;
    // !!! the draft range will become invalid after the mark DOM is inserted
    if (!selectionRange && !draftRange) return null;
    const documentPosition = actions.getPositionFromRange(range);
    // This property is drilled down to consumers when a new range is selected to test it's validity
    let isAnnotationAllowedOnRange = false;
    try {
        isAnnotationAllowedOnRange = documentPosition && actions.isValidAnnotationPosition(documentPosition);
    } catch  {
        isAnnotationAllowedOnRange = false;
    }
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bggde.SelectionInlineCommentMounter), {
        range: selectionRange,
        draftRange: draftRange,
        wrapperDOM: rendererRef,
        component: selectionComponent,
        onClose: clearRange,
        documentPosition: documentPosition,
        isAnnotationAllowed: isAnnotationAllowedOnRange,
        applyAnnotation: actions.applyAnnotation.bind(actions),
        generateIndexMatch: actions.generateAnnotationIndexMatch.bind(actions),
        createAnalyticsEvent: createAnalyticsEvent
    });
};
$d15d2217dff1b0e8$export$74435b85e23b84d9.displayName = 'SelectionRangeValidator';

});
parcelRegister("8Saoj", function(module, exports) {

$parcel$export(module.exports, "useUserSelectionRange", () => $11095f38adeb145c$export$47201332e612f5a4);

var $eJOHy = parcelRequire("eJOHy");

var $e2m7L = parcelRequire("e2m7L");

var $hgjUT = parcelRequire("hgjUT");

var $2mfh2 = parcelRequire("2mfh2");

var $eGOwo = parcelRequire("eGOwo");

var $3OjM0 = parcelRequire("3OjM0");
const $11095f38adeb145c$export$47201332e612f5a4 = (props)=>{
    const { rendererRef: { current: rendererDOM } } = props;
    const selectionTimeoutRef = (0, $eJOHy.useRef)();
    const { clearSelectionRange: clearSelectionRange, setSelectionRange: setSelectionRange } = (0, $e2m7L.useAnnotationRangeDispatch)();
    const { range: range, type: type, selectionDraftRange: selectionDraftRange } = (0, $e2m7L.useAnnotationRangeState)();
    const { annotationManager: annotationManager } = (0, $3OjM0.useAnnotationManagerDispatch)();
    const lastRangeRef = (0, $eJOHy.useRef)(null);
    const isAnnotationManagerEnabled = !!annotationManager;
    const onSelectionChange = (0, $eJOHy.useCallback)((event)=>{
        if ((0, $eGOwo.fg)('platform_renderer_triple_click_selects_paragraph')) {
            if (selectionTimeoutRef.current) clearTimeout(selectionTimeoutRef.current);
            selectionTimeoutRef.current = setTimeout(()=>{
                const sel = document.getSelection();
                if (!sel || sel.type !== 'Range' || sel.rangeCount !== 1) {
                    lastRangeRef.current = null; // Clear last range if selection is invalid
                    if (isAnnotationManagerEnabled) clearSelectionRange();
                    return;
                }
                let _range = sel.getRangeAt(0);
                // Skip if the selection hasn’t changed
                if (lastRangeRef.current && _range.compareBoundaryPoints(Range.START_TO_START, lastRangeRef.current) === 0 && _range.compareBoundaryPoints(Range.END_TO_END, lastRangeRef.current) === 0) return;
                if (rendererDOM && (0, $hgjUT.isRangeInsideOfRendererContainer)(rendererDOM, _range)) {
                    const { startContainer: startContainer, endContainer: endContainer } = _range;
                    const isTripleClick = endContainer.nodeType !== Node.TEXT_NODE;
                    if (isTripleClick) {
                        let p = startContainer;
                        while(p && p.nodeName !== 'P' && p !== rendererDOM)p = p.parentNode;
                        if (p && p.nodeName === 'P' && p instanceof Element) {
                            const range = document.createRange();
                            range.selectNodeContents(p);
                            sel.removeAllRanges();
                            sel.addRange(range);
                            _range = sel.getRangeAt(0);
                        }
                    }
                    setSelectionRange(_range.cloneRange());
                    lastRangeRef.current = _range;
                }
            }, 100);
        } else {
            if (selectionTimeoutRef.current) clearTimeout(selectionTimeoutRef.current);
            selectionTimeoutRef.current = setTimeout(()=>{
                const sel = document.getSelection();
                if (!sel || sel.type !== 'Range' || sel.rangeCount !== 1) {
                    if (isAnnotationManagerEnabled) clearSelectionRange();
                    return;
                }
                const _range = sel.getRangeAt(0);
                if (rendererDOM && (0, $hgjUT.isRangeInsideOfRendererContainer)(rendererDOM, _range)) {
                    const { startContainer: startContainer, endContainer: endContainer, commonAncestorContainer: commonAncestorContainer } = _range;
                    const parentNode = startContainer.parentNode;
                    // ED-23493
                    // On triple-click in Chrome and Safari, the native Selection API's range has endContainer as a non-text node
                    // and commonAncestorContainer as root level div.ak-renderer-document when the node is followed by div or hr.
                    // Triple clicks are the only case that can cause the endContainer to be a non-text node
                    // Same check for highlight range logic in confluence/next/packages/comments-util/src/domUtils.ts Line 180
                    const isTripleClick = endContainer.nodeType !== Node.TEXT_NODE;
                    // isAnnotationAllowedOnRange range validation is checking if the parent container is root element and disable the comment if it is.
                    // platform/packages/editor/renderer/src/steps/index.ts Line 180
                    // This workaround ensures the endContainer is set to a text node when endContainer is non-text and the parent container is the root element
                    if (isTripleClick && commonAncestorContainer && commonAncestorContainer.nodeType === Node.ELEMENT_NODE && // Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    (0, $2mfh2.isRoot)(commonAncestorContainer) && parentNode?.nodeName === 'P' // ignore if the parent node is strong, em, etc.
                    ) {
                        const lastChild = parentNode?.lastChild && parentNode?.lastChild?.nodeType === Node.TEXT_NODE ? parentNode?.lastChild : parentNode?.lastChild?.childNodes[0];
                        _range.setEnd(lastChild, lastChild.length || 0);
                    }
                    setSelectionRange(_range.cloneRange());
                }
            }, 250);
        }
    }, [
        rendererDOM,
        setSelectionRange,
        clearSelectionRange,
        isAnnotationManagerEnabled
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!document || !rendererDOM) return;
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.addEventListener('selectionchange', onSelectionChange);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('selectionchange', onSelectionChange);
            clearSelectionRange();
        };
    }, [
        rendererDOM,
        onSelectionChange,
        clearSelectionRange
    ]);
    return [
        type,
        range,
        selectionDraftRange,
        clearSelectionRange
    ];
};

});
parcelRegister("hgjUT", function(module, exports) {

$parcel$export(module.exports, "isRangeInsideOfRendererContainer", () => $f03d2274a274d42b$export$90ee8f2d9317f430);
/** Exists in its own module to allow mocking in unit tests */ const $f03d2274a274d42b$export$90ee8f2d9317f430 = (rendererDOM, range)=>{
    const sourceRange = document.createRange();
    sourceRange.selectNode(rendererDOM);
    const isSelectionStartsAfterRenderer = range.compareBoundaryPoints(Range.START_TO_START, sourceRange) === 1;
    const isSelectionStartsBeforeRenderer = range.compareBoundaryPoints(Range.START_TO_END, sourceRange) === 1;
    const isSelectionEndsAfterRenderer = range.compareBoundaryPoints(Range.END_TO_END, sourceRange) === 1;
    return isSelectionStartsAfterRenderer && isSelectionStartsBeforeRenderer && !isSelectionEndsAfterRenderer;
};

});


parcelRegister("bggde", function(module, exports) {

$parcel$export(module.exports, "SelectionInlineCommentMounter", () => $b0e110fc86dabdf8$export$ca7741472ed8ba00);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8KLBw = parcelRequire("8KLBw");

var $jxPcD = parcelRequire("jxPcD");

var $eGOwo = parcelRequire("eGOwo");

var $fH5Zn = parcelRequire("fH5Zn");

var $bgewf = parcelRequire("bgewf");

var $bMFKb = parcelRequire("bMFKb");

var $jidPs = parcelRequire("jidPs");

var $4Z9bh = parcelRequire("4Z9bh");

var $3OjM0 = parcelRequire("3OjM0");

var $e2m7L = parcelRequire("e2m7L");
const $b0e110fc86dabdf8$export$ca7741472ed8ba00 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo((props)=>{
    const { component: Component, range: range, draftRange: draftRange, isAnnotationAllowed: isAnnotationAllowed, wrapperDOM: wrapperDOM, onClose: onCloseProps, documentPosition: documentPosition, applyAnnotation: applyAnnotation, createAnalyticsEvent: createAnalyticsEvent, generateIndexMatch: generateIndexMatch } = props;
    const { promoteSelectionToDraft: promoteSelectionToDraft, clearSelectionDraft: clearSelectionDraft } = (0, $e2m7L.useAnnotationRangeDispatch)();
    const { selectionDraftDocumentPosition: selectionDraftDocumentPosition } = (0, $e2m7L.useAnnotationRangeState)();
    const actions = (0, $eJOHy.useContext)((0, $4Z9bh.RendererContext));
    const { isDrafting: isDrafting, draftId: draftId } = (0, $3OjM0.useAnnotationManagerState)();
    const { annotationManager: annotationManager, dispatch: dispatch } = (0, $3OjM0.useAnnotationManagerDispatch)();
    const inlineNodeTypes = (0, $eJOHy.useMemo)(()=>{
        if ((0, $eGOwo.fg)('annotations_defensive_node_name_calculations')) {
            if (!actions.isRangeAnnotatable(range)) return undefined;
            return (0, $jidPs.getRendererRangeInlineNodeNames)({
                pos: documentPosition,
                actions: actions
            });
        } else {
            if (!(0, $eGOwo.fg)('editor_inline_comments_on_inline_nodes')) return undefined;
            if (actions.isValidAnnotationRange(range)) return (0, $jidPs.getRendererRangeInlineNodeNames)({
                pos: documentPosition,
                actions: actions
            });
            else return undefined;
        }
    }, [
        documentPosition,
        actions,
        range
    ]);
    const onCreateCallback = (0, $eJOHy.useCallback)((annotationId)=>{
        // We want to support creation on a documentPosition if the user is only using ranges
        // but we want to prioritize draft positions if they are being used by consumers
        // !!! at this point, the documentPosition can be the wrong position if the user select something else
        const positionToAnnotate = selectionDraftDocumentPosition || documentPosition;
        if (!positionToAnnotate || !applyAnnotation) return false;
        // Evaluate position validity when the user commits the position to be annotated
        const isCreateAllowedOnPosition = actions.isValidAnnotationPosition(positionToAnnotate);
        if (!isCreateAllowedOnPosition) return false;
        const annotation = {
            annotationId: annotationId,
            annotationType: (0, $jxPcD.AnnotationTypes).INLINE_COMMENT
        };
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $bMFKb.ACTION).INSERTED,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).INLINE_COMMENT,
            attributes: {
                inlineNodeNames: inlineNodeTypes
            },
            eventType: (0, $bMFKb.EVENT_TYPE).TRACK
        }).fire((0, $bgewf.FabricChannel).editor);
        return applyAnnotation(positionToAnnotate, annotation);
    }, [
        actions,
        documentPosition,
        applyAnnotation,
        createAnalyticsEvent,
        inlineNodeTypes,
        selectionDraftDocumentPosition
    ]);
    const createIndexCallback = (0, $eJOHy.useCallback)(()=>{
        if (!documentPosition || !generateIndexMatch) return false;
        const result = generateIndexMatch(documentPosition);
        if (!result) return false;
        return result;
    }, [
        documentPosition,
        generateIndexMatch
    ]);
    const applyDraftModeCallback = (0, $eJOHy.useCallback)((options)=>{
        if (!documentPosition || !isAnnotationAllowed) {
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $bMFKb.ACTION).CREATE_NOT_ALLOWED,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).INLINE_COMMENT,
                attributes: {
                    inlineNodeNames: inlineNodeTypes,
                    documentPosition: documentPosition,
                    isAnnotationAllowed: isAnnotationAllowed
                },
                eventType: (0, $bMFKb.EVENT_TYPE).TRACK
            }).fire((0, $bgewf.FabricChannel).editor);
            return false;
        }
        promoteSelectionToDraft(documentPosition);
        if (createAnalyticsEvent) {
            const uniqueAnnotationsInRange = range ? actions.getAnnotationsByPosition(range) : [];
            createAnalyticsEvent({
                action: (0, $bMFKb.ACTION).OPENED,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
                attributes: {
                    overlap: uniqueAnnotationsInRange.length,
                    inlineNodeNames: inlineNodeTypes
                }
            }).fire((0, $bgewf.FabricChannel).editor);
        }
        window.requestAnimationFrame(()=>{
            if (options.keepNativeSelection) (0, $fH5Zn.updateWindowSelectionAroundDraft)(documentPosition);
            else {
                const sel = window.getSelection();
                if (sel) sel.removeAllRanges();
            }
        });
        // at this point, the documentPosition is the position that the user has selected,
        // not the selectionDraftDocumentPosition
        // because the documentPosition is not promoted to selectionDraftDocumentPosition yet
        // use platform_editor_comments_api_manager here so we can clear the code path when the flag is removed
        const positionToAnnotate = (0, $eGOwo.fg)('platform_editor_comments_api_manager') ? documentPosition : selectionDraftDocumentPosition || documentPosition;
        if (!positionToAnnotate || !applyAnnotation || !options.annotationId) {
            if ((0, $eGOwo.fg)('cc_comments_improve_apply_draft_errors')) {
                if (createAnalyticsEvent) createAnalyticsEvent({
                    action: (0, $bMFKb.ACTION).CREATE_NOT_ALLOWED,
                    actionSubject: (0, $bMFKb.ACTION_SUBJECT).ANNOTATION,
                    actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).INLINE_COMMENT,
                    attributes: {
                        positionToAnnotate: positionToAnnotate,
                        applyAnnotationMissing: !applyAnnotation,
                        annotationId: options.annotationId
                    },
                    eventType: (0, $bMFKb.EVENT_TYPE).TRACK
                }).fire((0, $bgewf.FabricChannel).editor);
            }
            return false;
        }
        const annotation = {
            annotationId: options.annotationId,
            annotationType: (0, $jxPcD.AnnotationTypes).INLINE_COMMENT
        };
        return applyAnnotation(positionToAnnotate, annotation);
    }, [
        documentPosition,
        isAnnotationAllowed,
        createAnalyticsEvent,
        applyAnnotation,
        actions,
        range,
        inlineNodeTypes,
        promoteSelectionToDraft,
        selectionDraftDocumentPosition
    ]);
    const removeDraftModeCallback = (0, $eJOHy.useCallback)(()=>{
        clearSelectionDraft();
        const sel = window.getSelection();
        if (sel) sel.removeAllRanges();
    }, [
        clearSelectionDraft
    ]);
    const onCloseCallback = (0, $eJOHy.useCallback)(()=>{
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $bMFKb.ACTION).CLOSED,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).INLINE_COMMENT,
            eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
            attributes: {
                inlineNodeNames: inlineNodeTypes
            }
        }).fire((0, $bgewf.FabricChannel).editor);
        removeDraftModeCallback();
        onCloseProps();
    }, [
        onCloseProps,
        removeDraftModeCallback,
        createAnalyticsEvent,
        inlineNodeTypes
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (annotationManager) {
            const allowAnnotation = ()=>{
                if (isDrafting) return false;
                return isAnnotationAllowed;
            };
            annotationManager.hook('allowAnnotation', allowAnnotation);
            return ()=>{
                annotationManager.unhook('allowAnnotation', allowAnnotation);
            };
        }
    }, [
        annotationManager,
        isAnnotationAllowed,
        isDrafting
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (annotationManager) {
            const startDraft = ()=>{
                // if there is a draft in progress, we ignore it and start a new draft
                // this is because clearing the draft will remove the mark node from the DOM, which will cause the selection range to be invalid
                const id = (0, (/*@__PURE__*/$parcel$interopDefault($8KLBw)))();
                const result = applyDraftModeCallback({
                    annotationId: id,
                    keepNativeSelection: false
                });
                if (!result) return {
                    success: false,
                    reason: 'invalid-range'
                };
                dispatch({
                    type: 'setDrafting',
                    data: {
                        isDrafting: true,
                        draftId: id,
                        draftActionResult: result
                    }
                });
                dispatch({
                    type: 'resetSelectedAnnotation'
                });
                return {
                    success: true,
                    // We cannot get a ref to the target element here
                    // because the draft is not yet applied to the DOM
                    targetElement: undefined,
                    inlineNodeTypes: result.inlineNodeTypes ?? [],
                    actionResult: {
                        step: result.step,
                        doc: result.doc,
                        inlineNodeTypes: result.inlineNodeTypes,
                        targetNodeType: result.targetNodeType,
                        originalSelection: result.originalSelection,
                        numMatches: result.numMatches,
                        matchIndex: result.matchIndex,
                        pos: result.pos
                    }
                };
            };
            annotationManager.hook('startDraft', startDraft);
            return ()=>{
                annotationManager.unhook('startDraft', startDraft);
            };
        }
    }, [
        annotationManager,
        isDrafting,
        applyDraftModeCallback,
        actions,
        range,
        dispatch
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (annotationManager) {
            const clearDraft = ()=>{
                if (!isDrafting) return {
                    success: false,
                    reason: 'draft-not-started'
                };
                dispatch({
                    type: 'setDrafting',
                    data: {
                        isDrafting: false,
                        draftId: undefined,
                        draftActionResult: undefined
                    }
                });
                onCloseCallback();
                return {
                    success: true
                };
            };
            annotationManager.hook('clearDraft', clearDraft);
            return ()=>{
                annotationManager.unhook('clearDraft', clearDraft);
            };
        }
    }, [
        annotationManager,
        onCloseCallback,
        isDrafting,
        dispatch
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (annotationManager) {
            const applyDraft = (id)=>{
                if (!isDrafting || !draftId) return {
                    success: false,
                    reason: 'draft-not-started'
                };
                const result = onCreateCallback(id);
                if (!result) return {
                    success: false,
                    reason: 'range-no-longer-exists'
                };
                onCloseCallback();
                dispatch({
                    type: 'setDrafting',
                    data: {
                        isDrafting: false,
                        draftId: undefined,
                        draftActionResult: undefined
                    }
                });
                dispatch({
                    type: 'updateAnnotation',
                    data: {
                        id: id,
                        selected: true,
                        markState: (0, $jxPcD.AnnotationMarkStates).ACTIVE
                    }
                });
                return {
                    success: true,
                    targetElement: undefined,
                    actionResult: id !== draftId ? {
                        step: result.step,
                        doc: result.doc,
                        inlineNodeTypes: result.inlineNodeTypes,
                        targetNodeType: result.targetNodeType,
                        originalSelection: result.originalSelection,
                        numMatches: result.numMatches,
                        matchIndex: result.matchIndex,
                        pos: result.pos
                    } : undefined
                };
            };
            annotationManager.hook('applyDraft', applyDraft);
            return ()=>{
                annotationManager.unhook('applyDraft', applyDraft);
            };
        }
    }, [
        annotationManager,
        onCreateCallback,
        onCloseCallback,
        isDrafting,
        draftId,
        dispatch
    ]);
    // Please remove this NOP function when the flag platform_editor_comments_api_manager is removed.
    const nop = (0, $eJOHy.useMemo)(()=>()=>false, []);
    return /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
        range: range,
        draftRange: draftRange,
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        wrapperDOM: wrapperDOM.current,
        isAnnotationAllowed: isAnnotationAllowed,
        onClose: annotationManager ? nop : onCloseCallback,
        onCreate: annotationManager ? nop : onCreateCallback,
        getAnnotationIndexMatch: createIndexCallback,
        applyDraftMode: annotationManager ? nop : applyDraftModeCallback,
        removeDraftMode: annotationManager ? nop : removeDraftModeCallback,
        inlineNodeTypes: inlineNodeTypes
    });
});

});



parcelRegister("1YS5j", function(module, exports) {

$parcel$export(module.exports, "useLoadAnnotations", () => $34c81e7572b846dd$export$39f7c1a861a0d41c);

var $eJOHy = parcelRequire("eJOHy");

var $4Fc33 = parcelRequire("4Fc33");

var $eGOwo = parcelRequire("eGOwo");

var $eFHDV = parcelRequire("eFHDV");

var $4Z9bh = parcelRequire("4Z9bh");

var $3OjM0 = parcelRequire("3OjM0");
const $34c81e7572b846dd$export$39f7c1a861a0d41c = ({ adfDocument: adfDocument, isNestedRender: isNestedRender, onLoadComplete: onLoadComplete })=>{
    const actions = (0, $eJOHy.useContext)((0, $4Z9bh.RendererContext));
    const providers = (0, $eJOHy.useContext)((0, $eFHDV.ProvidersContext));
    const { annotationManager: annotationManager, dispatch: dispatch } = (0, $3OjM0.useAnnotationManagerDispatch)();
    const isAnnotationManagerEnabled = !!annotationManager;
    (0, $eJOHy.useEffect)(()=>{
        if (!providers) return;
        const { inlineComment: { getState: inlineCommentGetState, updateSubscriber: updateSubscriberInlineComment } } = providers;
        const annotations = actions.getAnnotationMarks();
        // we don't want to request integrators for state with an empty list of ids.
        if (!annotations.length) {
            if (!isNestedRender && (0, $eGOwo.fg)('use_comments_data_annotation_updater')) // inlineCommentGetState handles empty lists gracefully. It has a side-effect of clearing state, which is why this call is needed
            inlineCommentGetState([], isNestedRender);
            onLoadComplete && onLoadComplete({
                numberOfUnresolvedInlineComments: 0
            });
            return;
        }
        const ids = annotations.map((mark)=>mark.attrs.id);
        const cb = (data)=>{
            if (!updateSubscriberInlineComment) return;
            const payload = data.reduce((acc, value)=>({
                    ...acc,
                    [value.id]: value
                }), {});
            if (isAnnotationManagerEnabled) dispatch({
                type: 'loadAnnotation',
                data: Object.keys(payload).map((id)=>({
                        id: id,
                        markState: payload[id].state ?? undefined
                    }))
            });
            else updateSubscriberInlineComment.emit((0, $4Fc33.AnnotationUpdateEvent).SET_ANNOTATION_STATE, payload);
            onLoadComplete && onLoadComplete({
                numberOfUnresolvedInlineComments: data.filter((data)=>data.state === 'active').length
            });
        };
        inlineCommentGetState(ids, isNestedRender).then(cb);
    }, [
        actions,
        providers,
        adfDocument,
        isNestedRender,
        onLoadComplete,
        dispatch,
        isAnnotationManagerEnabled
    ]);
};

});


parcelRegister("2uPUs", function(module, exports) {

$parcel$export(module.exports, "ValidationContext", () => $637c2da842893e64$export$d452675449e81987);
$parcel$export(module.exports, "ValidationContextProvider", () => $637c2da842893e64$export$5b655fe45447a548);

var $eJOHy = parcelRequire("eJOHy");
const $637c2da842893e64$export$d452675449e81987 = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $637c2da842893e64$export$5b655fe45447a548 = $637c2da842893e64$export$d452675449e81987.Provider;

});


parcelRegister("bDynL", function(module, exports) {

$parcel$export(module.exports, "default", () => $9db481286d0d47db$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/prefer-primitives, @atlaskit/design-system/consistent-css-prop-usage */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");


var $eJOHy = parcelRequire("eJOHy");

var $fsEil = parcelRequire("fsEil");

var $cZRB0 = parcelRequire("cZRB0");

var $gpsHJ = parcelRequire("gpsHJ");
var $2bEPZ = parcelRequire("2bEPZ");

var $iRC0e = parcelRequire("iRC0e");

var $bnh3n = parcelRequire("bnh3n");
const $9db481286d0d47db$var$useMultiBodiedExtensionActions = ({ updateActiveChild: updateActiveChild, children: children })=>{
    const actions = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useMemo(()=>{
        return {
            changeActive (index) {
                return updateActiveChild(index);
            },
            addChild () {
                return false;
            },
            getChildrenCount () {
                return children ? children?.length : 0;
            },
            removeChild (index) {
                return false;
            },
            updateParameters (parameters) {
                return false;
            },
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            getChildren () {
                return [];
            },
            getChildrenContainer () {
                return null;
            }
        };
    }, [
        updateActiveChild,
        children
    ]);
    return actions;
};
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Ignored via go/DSP-18766
const $9db481286d0d47db$var$navigationCssExtended = /*#__PURE__*/ (0, $1NIU8.css)((0, $gpsHJ.sharedMultiBodiedExtensionStyles).mbeNavigation, ";margin-left:0!important;margin-right:0!important;.mbe-add-tab-button,.mbe-remove-tab{display:none;}");
const $9db481286d0d47db$var$MultiBodiedExtension = (props)=>{
    const { children: children, layout: layout = 'default', path: path = [] } = props;
    const [activeChildIndex, setActiveChildIndex] = (0, $eJOHy.useState)(0);
    const removeOverflow = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.toArray(children)// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .map((child)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(child) ? child.props.nodeType === 'table' : false).every(Boolean);
    const overflowContainerClass = !removeOverflow ? (0, $iRC0e.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER : '';
    const updateActiveChild = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((index)=>{
        if (typeof index !== 'number') {
            // Ignored via go/ees007
            // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
            // TODO: Make sure we log this somewhere if this happens
            setActiveChildIndex(0);
            return false;
        }
        setActiveChildIndex(index);
        return true;
    }, [
        setActiveChildIndex
    ]);
    const actions = $9db481286d0d47db$var$useMultiBodiedExtensionActions({
        updateActiveChild: updateActiveChild,
        children: children
    });
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    const containerCssExtended = /*#__PURE__*/ (0, $1NIU8.css)((0, $gpsHJ.sharedMultiBodiedExtensionStyles).mbeExtensionContainer, ";.ak-renderer-extension{margin-top:0!important;}[data-layout='full-width'],[data-layout='wide']{.multiBodiedExtension-navigation{border-right:3px solid ", `var(--ds-border, ${(0, $7bb4c1736002a04a$export$1ce2d1575d444ceb)})`, "!important;}}.multiBodiedExtension--frames>[data-extension-frame='true']:nth-of-type(", activeChildIndex + 1, "){", (0, $gpsHJ.sharedMultiBodiedExtensionStyles).extensionFrameContent, " margin-left:0;margin-right:0;}");
    const isTopLevel = path.length < 1;
    const centerAlignClass = isTopLevel && [
        'wide',
        'full-width'
    ].includes(layout) ? (0, $iRC0e.RendererCssClassName).EXTENSION_CENTER_ALIGN : '';
    function renderMbeContent(width) {
        return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `${(0, $iRC0e.RendererCssClassName).EXTENSION} ${centerAlignClass} ${overflowContainerClass}`,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                width: isTopLevel ? (0, $bnh3n.calcBreakoutWidth)(layout, width) : '100%'
            },
            "data-layout": layout
        }, /*#__PURE__*/ (0, $1NIU8.jsx)("nav", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "multiBodiedExtension-navigation",
            css: $9db481286d0d47db$var$navigationCssExtended,
            "data-testid": "multiBodiedExtension-navigation"
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $cZRB0.default), {
            ...props,
            actions: actions,
            type: "multiBodiedExtension"
        }, ({ result: result })=>{
            try {
                if (result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(result)) // Return the content directly if it's a valid JSX.Element
                return (0, $fsEil.renderExtension)(result, layout, {
                    isTopLevel: path.length < 1
                });
            } catch (e) {
            /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
            // Always return default content if anything goes wrong
            return (0, $fsEil.renderExtension)(children, layout, {
                isTopLevel: path.length < 1
            });
        })), /*#__PURE__*/ (0, $1NIU8.jsx)("article", {
            "data-testid": "multiBodiedExtension--frames",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `multiBodiedExtension--frames`
        }, children));
    }
    return /*#__PURE__*/ (0, $1NIU8.jsx)("section", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "multiBodiedExtension--container",
        css: containerCssExtended,
        "data-testid": "multiBodiedExtension--container",
        "data-active-child-index": activeChildIndex,
        "data-layout": layout
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $2bEPZ.WidthConsumer), null, ({ width: width })=>renderMbeContent(width)));
};
var $9db481286d0d47db$export$2e2bcd8739ae039 = $9db481286d0d47db$var$MultiBodiedExtension;

});
parcelRegister("gpsHJ", function(module, exports) {

$parcel$export(module.exports, "removeMarginsAndBorder", () => $4cef5c2bc10730e6$export$8df0393dc2d5d656);
$parcel$export(module.exports, "sharedMultiBodiedExtensionStyles", () => $4cef5c2bc10730e6$export$9c7196ca47f67390);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");
function $4cef5c2bc10730e6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Wraps the navigation bar and extensionFrames
const $4cef5c2bc10730e6$var$mbeExtensionContainer = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    background: 'transparent !important',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    'padding:': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        left: `${"var(--ds-space-100, 8px)"} !important`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        right: `${"var(--ds-space-100, 8px)"} !important`
    },
    paddingBottom: "var(--ds-space-100, 8px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.remove-padding': {
        paddingBottom: 0
    },
    position: 'relative',
    verticalAlign: 'middle',
    cursor: 'pointer',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.multiBodiedExtension-handler-result': {
        marginLeft: "var(--ds-space-100, 8px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    ".multiBodiedExtension-content-dom-wrapper > [data-extension-frame='true'], .multiBodiedExtension--frames > [data-extension-frame='true']": {
        display: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.multiBodiedExtension-content-dom-wrapper, .multiBodiedExtension--frames': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        "[data-extension-frame='true'] > :not(style):first-child, [data-extension-frame='true'] > style:first-child + *": {
            marginTop: 0
        }
    }
});
const $4cef5c2bc10730e6$var$mbeNavigation = {
    name: "2ubief",
    styles: "border-top-left-radius:var(--ds-border-radius, 3px);border-top-right-radius:var(--ds-border-radius, 3px);user-select:none;-webkit-user-modify:read-only;border-bottom:none !important;background:var(--ds-surface, white);margin-left:var(--ds-space-100, 8px);margin-right:var(--ds-space-100, 8px);&.remove-margins{margin:var(--ds-space-negative-100, -8px);}&.remove-border{border:none;}"
};
const $4cef5c2bc10730e6$var$extensionFrameContent = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    padding: `${"var(--ds-space-100, 8px)"} !important`,
    display: 'block',
    minHeight: '100px',
    background: 'transparent',
    borderBottomLeftRadius: "var(--ds-border-radius, 3px)",
    borderBottomRightRadius: "var(--ds-border-radius, 3px)",
    marginLeft: "var(--ds-space-100, 8px)",
    marginRight: "var(--ds-space-100, 8px)",
    cursor: 'initial',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.pm-table-with-controls': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginLeft: `${"var(--ds-space-150, 12px)"} !important`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        paddingRight: `${"var(--ds-space-150, 12px)"} !important`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.bodiedExtensionView-content-wrap': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginTop: `${"var(--ds-space-150, 12px)"} !important`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.extensionView-content-wrap': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginTop: `${"var(--ds-space-100, 8px)"} !important`
    }
});
const $4cef5c2bc10730e6$export$8df0393dc2d5d656 = {
    name: "c620zi",
    styles: "margin-left:0;margin-right:0;border:none"
};
const $4cef5c2bc10730e6$export$9c7196ca47f67390 = {
    mbeExtensionContainer: $4cef5c2bc10730e6$var$mbeExtensionContainer,
    mbeNavigation: $4cef5c2bc10730e6$var$mbeNavigation,
    extensionFrameContent: $4cef5c2bc10730e6$var$extensionFrameContent
};

});


parcelRegister("9DR0p", function(module, exports) {

$parcel$export(module.exports, "default", () => $19255d557a43e493$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/prefer-primitives, @atlaskit/design-system/consistent-css-prop-usage */ /**
                                                                                                                   * @jsxRuntime classic
                                                                                                                   * @jsx jsx
                                                                                                                   * @jsxFrag
                                                                                                                   */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $eJOHy = parcelRequire("eJOHy");

var $2bEPZ = parcelRequire("2bEPZ");

var $iRC0e = parcelRequire("iRC0e");

var $bnh3n = parcelRequire("bnh3n");

var $enT6M = parcelRequire("enT6M");

var $7Oflg = parcelRequire("7Oflg");
function $19255d557a43e493$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $19255d557a43e493$var$containerStyles = {
    name: "utcqjk",
    styles: "&:first-child > .ak-renderer-extension{margin-top:0;}"
};
const $19255d557a43e493$var$MultiBodiedExtensionChildrenContainer = ({ children: children })=>{
    return /*#__PURE__*/ (0, $1NIU8.jsx)("article", {
        "data-testid": "multiBodiedExtension--frames"
    }, children);
};
const $19255d557a43e493$var$MultiBodiedExtensionNavigation = ({ children: children })=>{
    return /*#__PURE__*/ (0, $1NIU8.jsx)("nav", {
        "data-testid": "multiBodiedExtension-navigation"
    }, children);
};
const $19255d557a43e493$var$MultiBodiedExtensionWrapper = ({ width: width, path: path, layout: layout, children: children })=>{
    const isTopLevel = path.length < 1;
    const centerAlignClass = isTopLevel && [
        'wide',
        'full-width'
    ].includes(layout) ? (0, $iRC0e.RendererCssClassName).EXTENSION_CENTER_ALIGN : '';
    // This hierarchy is copied from regular extension (see extension.tsx)
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${(0, $iRC0e.RendererCssClassName).EXTENSION} ${centerAlignClass}`,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            width: isTopLevel ? (0, $bnh3n.calcBreakoutWidth)(layout, width) : '100%'
        },
        "data-layout": layout,
        "data-testid": "multiBodiedExtension--wrapper"
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: `${(0, $iRC0e.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER}`
    }, children));
};
const $19255d557a43e493$var$MultiBodiedExtension = (props)=>{
    const { children: children, layout: layout = 'default', path: path = [], parameters: parameters, extensionType: extensionType, extensionKey: extensionKey, content: content, marks: marks, localId: localId } = props;
    const [activeChildIndex, setActiveChildIndex] = (0, $eJOHy.useState)(0);
    const { loading: loading, extensionContext: extensionContext } = (0, $7Oflg.useMultiBodiedExtensionContext)({
        extensionType: extensionType,
        extensionKey: extensionKey
    });
    const actions = (0, $enT6M.useMultiBodiedExtensionActions)({
        updateActiveChild: setActiveChildIndex,
        children: children,
        childrenContainer: /*#__PURE__*/ (0, $1NIU8.jsx)($19255d557a43e493$var$MultiBodiedExtensionChildrenContainer, null, children),
        allowBodiedOverride: extensionContext?.privateProps?.__allowBodiedOverride
    });
    const renderContent = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback(()=>{
        if (loading || !extensionContext) return null;
        const { NodeRenderer: NodeRenderer, privateProps: privateProps } = extensionContext;
        const fragmentLocalId = marks?.find((m)=>m.type.name === 'fragment')?.attrs?.localId;
        const node = {
            type: 'multiBodiedExtension',
            extensionKey: extensionKey,
            extensionType: extensionType,
            parameters: parameters,
            content: content,
            localId: localId,
            fragmentLocalId: fragmentLocalId
        };
        if (privateProps.__allowBodiedOverride) return /*#__PURE__*/ (0, $1NIU8.jsx)(NodeRenderer, {
            node: node,
            actions: actions
        });
        else return /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, $1NIU8.jsx)($19255d557a43e493$var$MultiBodiedExtensionNavigation, null, /*#__PURE__*/ (0, $1NIU8.jsx)(NodeRenderer, {
            node: node,
            actions: actions
        })), /*#__PURE__*/ (0, $1NIU8.jsx)($19255d557a43e493$var$MultiBodiedExtensionChildrenContainer, null, children));
    }, [
        loading,
        extensionContext,
        marks,
        extensionKey,
        extensionType,
        parameters,
        content,
        localId,
        actions,
        children
    ]);
    // make the frame visible
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    const containerActiveFrameStyles = /*#__PURE__*/ (0, $1NIU8.css)("& [data-extension-frame='true']:nth-of-type(", activeChildIndex + 1, "){display:block;}");
    return /*#__PURE__*/ (0, $1NIU8.jsx)("section", {
        css: [
            $19255d557a43e493$var$containerStyles,
            containerActiveFrameStyles
        ],
        "data-testid": "multiBodiedExtension--container",
        "data-multiBodiedExtension-container": true,
        "data-active-child-index": activeChildIndex,
        "data-layout": layout
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $2bEPZ.WidthConsumer), null, ({ width: width })=>/*#__PURE__*/ (0, $1NIU8.jsx)($19255d557a43e493$var$MultiBodiedExtensionWrapper, {
            layout: layout,
            width: width,
            path: path
        }, renderContent())));
};
var $19255d557a43e493$export$2e2bcd8739ae039 = $19255d557a43e493$var$MultiBodiedExtension;

});
parcelRegister("enT6M", function(module, exports) {

$parcel$export(module.exports, "useMultiBodiedExtensionActions", () => $c4dcfa71779e05f0$export$3c7139d93ecb4f1f);

var $eJOHy = parcelRequire("eJOHy");
const $c4dcfa71779e05f0$export$3c7139d93ecb4f1f = ({ updateActiveChild: updateActiveChild, children: children, allowBodiedOverride: allowBodiedOverride, childrenContainer: childrenContainer })=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useMemo(()=>{
        return {
            changeActive (index) {
                if (!Number.isInteger(index)) return false;
                updateActiveChild(index);
                return true;
            },
            addChild () {
                return false;
            },
            getChildrenCount () {
                return children && Array.isArray(children) ? children.length : 0;
            },
            removeChild (_index) {
                return false;
            },
            updateParameters (_parameters) {
                return false;
            },
            getChildren () {
                return [];
            },
            getChildrenContainer () {
                return allowBodiedOverride ? childrenContainer : null;
            }
        };
    }, [
        updateActiveChild,
        children,
        allowBodiedOverride,
        childrenContainer
    ]);
};

});

parcelRegister("7Oflg", function(module, exports) {

$parcel$export(module.exports, "useMultiBodiedExtensionContext", () => $f24dd63e8512ec71$export$e55394818db35473);

var $eJOHy = parcelRequire("eJOHy");

var $LFmXM = parcelRequire("LFmXM");

var $fvGDQ = parcelRequire("fvGDQ");

var $6Ramj = parcelRequire("6Ramj");
const $f24dd63e8512ec71$export$e55394818db35473 = ({ extensionType: extensionType, extensionKey: extensionKey })=>{
    const isMounted = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef(true);
    const localGetNodeRenderer = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useMemo(()=>(0, $LFmXM.default)((0, $fvGDQ.getNodeRenderer)), []);
    const [provider, setProvider] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const [privateProps, setPrivateProps] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState();
    const providerPromise = (0, $6Ramj.useProvider)('extensionProvider');
    (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useEffect(()=>{
        if (providerPromise) providerPromise.then((p)=>{
            if (isMounted.current) setProvider(p);
            return (0, $fvGDQ.getExtensionModuleNodePrivateProps)(p, extensionType, extensionKey);
        }).then((pr)=>{
            if (isMounted.current) setPrivateProps(pr);
        });
    }, [
        providerPromise,
        extensionType,
        extensionKey
    ]);
    const NodeRenderer = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useMemo(()=>{
        if (!provider) return null;
        return localGetNodeRenderer(provider, extensionType, extensionKey);
    }, [
        provider,
        extensionType,
        extensionKey,
        localGetNodeRenderer
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useEffect(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useMemo(()=>{
        if (!provider || !NodeRenderer || !privateProps) return {
            extensionContext: null,
            loading: true
        };
        return {
            extensionContext: {
                NodeRenderer: NodeRenderer,
                privateProps: privateProps
            },
            loading: false
        };
    }, [
        provider,
        NodeRenderer,
        privateProps
    ]);
};

});


parcelRegister("gzcAo", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ce4d6773e8cb55f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $eGOwo = parcelRequire("eGOwo");
function $8ce4d6773e8cb55f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8ce4d6773e8cb55f$var$containerCSSOld = {
    name: "1e1nv5z",
    styles: "min-height:100px;flex-basis:100%"
};
const $8ce4d6773e8cb55f$var$containerCSSNew = /*#__PURE__*/ (0, $1NIU8.css)({
    padding: `${"var(--ds-space-100, 8px)"}`,
    minHeight: '100px',
    // by default all frames are hidden, this style is overridden in multiBodiedExtensions for active frame
    display: 'none'
});
const $8ce4d6773e8cb55f$var$ExtensionFrame = (props)=>{
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: [
            (0, $eGOwo.fg)('platform_editor_multi_body_extension_extensibility') ? $8ce4d6773e8cb55f$var$containerCSSNew : $8ce4d6773e8cb55f$var$containerCSSOld
        ],
        "data-extension-frame": "true"
    }, props.children);
};
var $8ce4d6773e8cb55f$export$2e2bcd8739ae039 = $8ce4d6773e8cb55f$var$ExtensionFrame;

});

parcelRegister("53tmQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e35c62ab9ad9b570$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $7T1su = parcelRequire("7T1su");

var $iCTcU = parcelRequire("iCTcU");
function $e35c62ab9ad9b570$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)("ul", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $7T1su.bulletListSelector).substr(1),
        "data-indent-level": props.path ? (0, $iCTcU.getListIndentLevel)(props.path) : 1,
        children: props.children
    });
}

});
parcelRegister("iCTcU", function(module, exports) {

$parcel$export(module.exports, "getListIndentLevel", () => $a2d656820b3db7d4$export$75aa84e85754623e);
function $a2d656820b3db7d4$export$75aa84e85754623e(path) {
    let count = 1;
    path.forEach((node)=>{
        if (node.type.name === 'bulletList' || node.type.name === 'orderedList') count++;
    });
    return count;
}

});


parcelRegister("lbGwd", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4d94d1c513db838$export$2e2bcd8739ae039);
$parcel$export(module.exports, "DocWithSelectAllTrap", () => $b4d94d1c513db838$export$41121a410ca2f650);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $iRC0e = parcelRequire("iRC0e");

var $2v2KH = parcelRequire("2v2KH");
function $b4d94d1c513db838$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $iRC0e.RendererCssClassName).DOCUMENT,
        children: props.children
    });
}
function $b4d94d1c513db838$export$41121a410ca2f650(props) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ref: (0, $2v2KH.useSelectAllTrap)(),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $iRC0e.RendererCssClassName).DOCUMENT,
        children: props.children
    });
}

});
parcelRegister("2v2KH", function(module, exports) {

$parcel$export(module.exports, "useSelectAllTrap", () => $5478bcf2c5a2bb88$export$98871b245ee25215);

var $bMFKb = parcelRequire("bMFKb");

var $eJOHy = parcelRequire("eJOHy");

var $bdjbf = parcelRequire("bdjbf");

var $glugJ = parcelRequire("glugJ");
const $5478bcf2c5a2bb88$export$98871b245ee25215 = ()=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useContext((0, $bdjbf.default));
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef(null);
    const clicked = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef(false);
    const caught = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef();
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const mac = typeof navigator !== 'undefined' ? /Mac/.test(navigator.platform) : false;
    const onKeyDown = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((e)=>{
        const el = ref.current;
        if (!el) return;
        const modKey = mac ? e.metaKey : e.ctrlKey;
        if (!modKey || e.code !== 'KeyA' || e.shiftKey) return;
        const elementSelection = (0, $glugJ.ElementSelection).fromWindow();
        const isInput = e.target?.matches?.('input');
        if (elementSelection.eq(caught.current) || isInput) {
            fireAnalyticsEvent({
                eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
                action: (0, $bMFKb.ACTION).SELECT_ALL_ESCAPED,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).RENDERER
            });
            return;
        }
        if (elementSelection.inside(el) || elementSelection.type === 'None' && clicked.current) {
            fireAnalyticsEvent({
                eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
                action: (0, $bMFKb.ACTION).SELECT_ALL_CAUGHT,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).RENDERER
            });
            e.preventDefault();
            caught.current = elementSelection.select(el);
        }
    }, [
        mac,
        ref,
        fireAnalyticsEvent,
        clicked,
        caught
    ]);
    const onClick = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((e)=>{
        clicked.current = ref.current?.contains(e.target) ?? false;
    }, [
        ref,
        clicked
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useEffect(()=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.addEventListener('keydown', onKeyDown);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.addEventListener('click', onClick);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            window.removeEventListener('keydown', onKeyDown);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            window.removeEventListener('click', onClick);
        };
    }, [
        onKeyDown,
        onClick
    ]);
    return ref;
};

});
parcelRegister("bdjbf", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bb290c2d9dd1319$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
const $6bb290c2d9dd1319$var$AnalyticsContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext({
    fireAnalyticsEvent: (_event)=>null
});
var $6bb290c2d9dd1319$export$2e2bcd8739ae039 = $6bb290c2d9dd1319$var$AnalyticsContext;

});

parcelRegister("glugJ", function(module, exports) {

$parcel$export(module.exports, "ElementSelection", () => $7062a901fb1935c9$export$6e6724d89f27411);
class $7062a901fb1935c9$export$6e6724d89f27411 {
    constructor(selection){
        this.type = selection ? selection.type : 'None';
        if (selection && this.type !== 'None') this.range = selection.getRangeAt(0);
    }
    eq(selection) {
        if (!selection) return false;
        if (this.range && selection.range) {
            const startMatches = this.range?.compareBoundaryPoints(Range.START_TO_START, selection.range) === 0;
            const endMatches = this.range?.compareBoundaryPoints(Range.END_TO_END, selection.range) === 0;
            return startMatches && endMatches;
        }
        return this.type === 'None' && selection.type === 'None';
    }
    inside(el) {
        return el.contains(this.range?.commonAncestorContainer ?? null);
    }
    select(el) {
        const range = document.createRange();
        range.selectNodeContents(el);
        const selection = window.getSelection();
        if (selection) {
            selection.removeAllRanges();
            selection.addRange(range);
        }
        return $7062a901fb1935c9$export$6e6724d89f27411.fromWindow();
    }
    static fromWindow(win = window) {
        return new $7062a901fb1935c9$export$6e6724d89f27411(win.getSelection());
    }
}

});



parcelRegister("3OwO2", function(module, exports) {

$parcel$export(module.exports, "default", () => $79b328dc1583078f$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
const $79b328dc1583078f$var$HardBreak = ({ forceNewLine: forceNewLine = false })=>{
    // To display an empty line using Shift+Enter, ProseMirror inserts a
    // double <br>. The second <br> is not part of the document, it's just
    // there to make browsers behave properly. The forceNewLine prop in this
    // component replicates this behaviour. If the last child node is a
    // hardBreak, it will also insert a double <br>.
    if (forceNewLine) return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("br", {}),
            /*#__PURE__*/ (0, $gt9Am.jsx)("br", {})
        ]
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("br", {});
};
var $79b328dc1583078f$export$2e2bcd8739ae039 = $79b328dc1583078f$var$HardBreak;

});

parcelRegister("5v0qs", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e0bf67c244646d3$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $6fs4r = parcelRequire("6fs4r");

var $2QO3b = parcelRequire("2QO3b");

var $bMFKb = parcelRequire("bMFKb");

var $bdjbf = parcelRequire("bdjbf");

var $hhRpb = parcelRequire("hhRpb");

var $a6S67 = parcelRequire("a6S67");
const $9e0bf67c244646d3$var$getCurrentUrlWithHash = (hash = '')=>{
    const url = new URL(window.location.href);
    url.search = ''; // clear any query params so that the page will correctly scroll to the anchor
    url.hash = encodeURIComponent(hash);
    return url.href;
};
function $9e0bf67c244646d3$var$hasRightAlignmentMark(marks) {
    if (!marks || !marks.length) return false;
    return marks.some((mark)=>mark.type.name === 'alignment' && mark.attrs.align === 'end');
}
function $9e0bf67c244646d3$var$WrappedHeadingAnchor({ enableNestedHeaderLinks: enableNestedHeaderLinks, level: level, headingId: headingId, hideFromScreenReader: hideFromScreenReader }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bdjbf.default).Consumer, {
        children: ({ fireAnalyticsEvent: fireAnalyticsEvent })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $a6S67.default), {
                enableNestedHeaderLinks: enableNestedHeaderLinks,
                level: level,
                onCopyText: ()=>{
                    fireAnalyticsEvent({
                        action: (0, $bMFKb.ACTION).CLICKED,
                        actionSubject: (0, $bMFKb.ACTION_SUBJECT).BUTTON,
                        actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).HEADING_ANCHOR_LINK,
                        eventType: (0, $bMFKb.EVENT_TYPE).UI
                    });
                    return (0, $hhRpb.copyTextToClipboard)($9e0bf67c244646d3$var$getCurrentUrlWithHash(headingId));
                },
                hideFromScreenReader: hideFromScreenReader,
                headingId: headingId
            })
    });
}
function $9e0bf67c244646d3$var$Heading(props) {
    const { headingId: headingId, dataAttributes: dataAttributes, allowHeadingAnchorLinks: allowHeadingAnchorLinks, marks: marks, invisible: invisible } = props;
    const HX = `h${props.level}`;
    const mouseEntered = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef(false);
    const showAnchorLink = !!props.showAnchorLink;
    const isRightAligned = $9e0bf67c244646d3$var$hasRightAlignmentMark(marks);
    const enableNestedHeaderLinks = allowHeadingAnchorLinks && allowHeadingAnchorLinks.allowNestedHeaderLinks;
    const headingIdToUse = invisible ? undefined : headingId;
    const mouseEnterHandler = ()=>{
        if (showAnchorLink && !mouseEntered.current) {
            // Abort TTVC calculation when the mouse hovers over heading. Hovering over
            // heading render heading anchor and inline comment buttons. These user-induced
            // DOM changes are valid reasons to abort the TTVC calculation.
            (0, $2QO3b.abortAll)('new_interaction');
            mouseEntered.current = true;
        }
    };
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)(HX, {
                id: headingIdToUse,
                "data-renderer-start-pos": dataAttributes['data-renderer-start-pos'],
                onMouseEnter: mouseEnterHandler,
                children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
                    children: [
                        showAnchorLink && headingId && isRightAligned && /*#__PURE__*/ (0, $gt9Am.jsx)($9e0bf67c244646d3$var$WrappedHeadingAnchor, {
                            level: props.level,
                            enableNestedHeaderLinks: enableNestedHeaderLinks,
                            headingId: headingId,
                            hideFromScreenReader: true
                        }),
                        props.children,
                        showAnchorLink && headingId && !isRightAligned && /*#__PURE__*/ (0, $gt9Am.jsx)($9e0bf67c244646d3$var$WrappedHeadingAnchor, {
                            level: props.level,
                            enableNestedHeaderLinks: enableNestedHeaderLinks,
                            headingId: headingId,
                            hideFromScreenReader: true
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6fs4r.default), {
                testId: "visually-hidden-heading-anchor",
                children: showAnchorLink && headingId && /*#__PURE__*/ (0, $gt9Am.jsx)($9e0bf67c244646d3$var$WrappedHeadingAnchor, {
                    level: props.level,
                    enableNestedHeaderLinks: enableNestedHeaderLinks,
                    headingId: headingId
                })
            })
        ]
    });
}
var $9e0bf67c244646d3$export$2e2bcd8739ae039 = $9e0bf67c244646d3$var$Heading;

});
parcelRegister("hhRpb", function(module, exports) {

$parcel$export(module.exports, "copyTextToClipboard", () => $da1385cd7c8ce6e7$export$f980440e1ab4537d);
const $da1385cd7c8ce6e7$export$f980440e1ab4537d = (text)=>new Promise((resolve, reject)=>{
        const isApiSupported = !!navigator.clipboard && typeof navigator.clipboard.writeText === 'function';
        if (isApiSupported) navigator.clipboard.writeText(text).then(()=>resolve(), (e)=>reject(e));
        else reject('Clipboard API is not supported');
    });

});

parcelRegister("a6S67", function(module, exports) {

$parcel$export(module.exports, "HeadingAnchorWrapperClassName", () => $b1e1c8f0f51f3fcd$export$3c9cedc52604835d);
$parcel$export(module.exports, "default", () => $b1e1c8f0f51f3fcd$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $6YFG2 = parcelRequire("6YFG2");

var $av9Of = parcelRequire("av9Of");

var $k71qx = parcelRequire("k71qx");

var $4Iw1X = parcelRequire("4Iw1X");
function $b1e1c8f0f51f3fcd$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b1e1c8f0f51f3fcd$export$3c9cedc52604835d = 'heading-anchor-wrapper';
const $b1e1c8f0f51f3fcd$var$CopyAnchorWrapperWithRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef((props, ref)=>{
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        ...rest,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $b1e1c8f0f51f3fcd$export$3c9cedc52604835d,
        ref: ref
    }, children);
});
const $b1e1c8f0f51f3fcd$var$copyAnchorButtonStyles = {
    name: "vhh4ux",
    styles: "display:inline;outline:none;background-color:transparent;border:none;color:var(--ds-icon, #44546F);cursor:pointer;right:0"
};
// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
class $b1e1c8f0f51f3fcd$var$HeadingAnchor extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).PureComponent {
    componentDidMount() {
        this.resetMessage();
    }
    render() {
        const { tooltipMessage: tooltipMessage } = this.state;
        if (tooltipMessage) // We set the key to the message to ensure it remounts when the message
        // changes, so that it correctly repositions.
        // @see https://ecosystem.atlassian.net/projects/AK/queues/issue/AK-6548
        return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $k71qx.default), {
            // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
            tag: $b1e1c8f0f51f3fcd$var$CopyAnchorWrapperWithRef,
            content: tooltipMessage,
            position: "top",
            delay: 0,
            key: tooltipMessage
        }, this.renderAnchorButton());
        return this.renderAnchorButton();
    }
    constructor(...args){
        super(...args), this.state = {
            tooltipMessage: '',
            isClicked: false
        }, this.setTooltipState = (message, isClicked = false)=>{
            this.setState({
                // TODO: ED-14403 - investigate why this does not translate
                tooltipMessage: this.props.intl.formatMessage(message),
                isClicked: isClicked
            });
        }, this.getCopyAriaLabel = ()=>{
            const { copyAriaLabel: copyAriaLabel } = (0, $4Iw1X.headingAnchorLinkMessages);
            return this.props.intl.formatMessage(copyAriaLabel);
        }, this.copyToClipboard = async (event)=>{
            const { copiedHeadingLinkToClipboard: copiedHeadingLinkToClipboard, failedToCopyHeadingLink: failedToCopyHeadingLink } = (0, $4Iw1X.headingAnchorLinkMessages);
            event.stopPropagation();
            try {
                await this.props.onCopyText();
                this.setTooltipState(copiedHeadingLinkToClipboard, true);
            } catch (e) {
                this.setTooltipState(failedToCopyHeadingLink);
            }
        }, this.resetMessage = ()=>{
            this.setTooltipState((0, $4Iw1X.headingAnchorLinkMessages).copyHeadingLinkToClipboard);
        }, this.renderAnchorButton = ()=>{
            const { hideFromScreenReader: hideFromScreenReader = false, headingId: headingId } = this.props;
            return /*#__PURE__*/ (0, $1NIU8.jsx)("button", {
                "data-testid": "anchor-button",
                css: $b1e1c8f0f51f3fcd$var$copyAnchorButtonStyles,
                onMouseLeave: this.resetMessage,
                onClick: this.copyToClipboard,
                "aria-hidden": hideFromScreenReader,
                tabIndex: hideFromScreenReader ? undefined : -1,
                "aria-label": hideFromScreenReader ? undefined : this.state.tooltipMessage,
                "aria-labelledby": hideFromScreenReader ? undefined : headingId,
                type: "button"
            }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($av9Of))), {
                label: this.getCopyAriaLabel(),
                LEGACY_size: this.props.level > 3 ? 'small' : 'medium',
                color: this.state.isClicked ? "var(--ds-icon-selected, #0C66E4)" : "var(--ds-icon-subtle, #626F86)"
            }));
        };
    }
}
var $b1e1c8f0f51f3fcd$export$2e2bcd8739ae039 = (0, $6YFG2.default)($b1e1c8f0f51f3fcd$var$HeadingAnchor);

});
parcelRegister("av9Of", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0c2e6e563a714afa66b2c445d0695bd6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7a54689236011148$var$_react = $7a54689236011148$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $7a54689236011148$var$_link = $7a54689236011148$var$_interopRequireDefault((parcelRequire("cV8sz")));

var $7a54689236011148$var$_link2 = $7a54689236011148$var$_interopRequireDefault((parcelRequire("a2o1i")));
function $7a54689236011148$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LinkIcon.
 * This component is LinkIcon, with `UNSAFE_fallbackIcon` set to "LinkIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7a54689236011148$var$LinkIcon = (props)=>/*#__PURE__*/ $7a54689236011148$var$_react.default.createElement($7a54689236011148$var$_link.default, Object.assign({
        LEGACY_fallbackIcon: $7a54689236011148$var$_link2.default
    }, props));
$7a54689236011148$var$LinkIcon.Name = 'LinkIconMigration';
var $7a54689236011148$var$_default = module.exports.default = $7a54689236011148$var$LinkIcon;

});
parcelRegister("cV8sz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7acdc4638dae9667d9917d02594abf75>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $96815ed7645c21ae$var$_react = $96815ed7645c21ae$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $96815ed7645c21ae$var$_baseNew = $96815ed7645c21ae$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $96815ed7645c21ae$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Link".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $96815ed7645c21ae$var$LinkIcon = (props)=>/*#__PURE__*/ $96815ed7645c21ae$var$_react.default.createElement($96815ed7645c21ae$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.22 2.22a3.932 3.932 0 1 1 5.56 5.56l-2.25 2.25-1.06-1.06 2.25-2.25a2.432 2.432 0 0 0-3.44-3.44L7.03 5.53 5.97 4.47zm3.06 3.56-5.5 5.5-1.06-1.06 5.5-5.5zM2.22 8.22l2.25-2.25 1.06 1.06-2.25 2.25a2.432 2.432 0 0 0 3.44 3.44l2.25-2.25 1.06 1.06-2.25 2.25a3.932 3.932 0 1 1-5.56-5.56" clip-rule="evenodd"/>`
    }, props));
$96815ed7645c21ae$var$LinkIcon.displayName = 'LinkIcon';
var $96815ed7645c21ae$var$_default = module.exports.default = $96815ed7645c21ae$var$LinkIcon;

});

parcelRegister("a2o1i", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $74ecb925586ee899$var$_react = $74ecb925586ee899$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $74ecb925586ee899$var$_link = $74ecb925586ee899$var$_interopRequireDefault((parcelRequire("cV8sz")));
function $74ecb925586ee899$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $74ecb925586ee899$var$LinkIcon = (props)=>/*#__PURE__*/ $74ecb925586ee899$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="m12.856 5.457-.937.92a1 1 0 0 0 0 1.437 1.047 1.047 0 0 0 1.463 0l.984-.966c.967-.95 2.542-1.135 3.602-.288a2.54 2.54 0 0 1 .203 3.81l-2.903 2.852a2.646 2.646 0 0 1-3.696 0l-1.11-1.09L9 13.57l1.108 1.089c1.822 1.788 4.802 1.788 6.622 0l2.905-2.852a4.558 4.558 0 0 0-.357-6.82c-1.893-1.517-4.695-1.226-6.422.47"/><path d="m11.144 19.543.937-.92a1 1 0 0 0 0-1.437 1.047 1.047 0 0 0-1.462 0l-.985.966c-.967.95-2.542 1.135-3.602.288a2.54 2.54 0 0 1-.203-3.81l2.903-2.852a2.646 2.646 0 0 1 3.696 0l1.11 1.09L15 11.43l-1.108-1.089c-1.822-1.788-4.802-1.788-6.622 0l-2.905 2.852a4.558 4.558 0 0 0 .357 6.82c1.893 1.517 4.695 1.226 6.422-.47"/></g></svg>`
    }, props, {
        newIcon: $74ecb925586ee899$var$_link.default
    }));
$74ecb925586ee899$var$LinkIcon.displayName = 'LinkIcon';
var $74ecb925586ee899$var$_default = module.exports.default = $74ecb925586ee899$var$LinkIcon;

});


parcelRegister("4Iw1X", function(module, exports) {

$parcel$export(module.exports, "headingAnchorLinkMessages", () => $552b6cd9c26dd6f0$export$74bada844422036d);
$parcel$export(module.exports, "tableCellMessages", () => $552b6cd9c26dd6f0$export$c79ebc36348824d1);
$parcel$export(module.exports, "inlineCommentMessages", () => $552b6cd9c26dd6f0$export$9f52c375a6ef34fc);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $7qGN1 = parcelRequire("7qGN1");
const $552b6cd9c26dd6f0$export$74bada844422036d = (0, $7qGN1.defineMessages)({
    copyHeadingLinkToClipboard: {
        id: 'fabric.editor.headingLink.copyAnchorLink',
        defaultMessage: 'Copy link to heading',
        description: 'Copy heading link to clipboard'
    },
    copiedHeadingLinkToClipboard: {
        id: 'fabric.editor.headingLink.copied',
        defaultMessage: 'Copied!',
        description: 'Copied heading link to clipboard'
    },
    failedToCopyHeadingLink: {
        id: 'fabric.editor.headingLink.failedToCopy',
        defaultMessage: 'Copy failed',
        description: 'failed to copy heading link to clipboard'
    },
    copyAriaLabel: {
        id: 'fabric.editor.headingLink.copyAriaLabel',
        defaultMessage: 'Copy',
        description: 'copy aria label for link icon'
    }
});
const $552b6cd9c26dd6f0$export$c79ebc36348824d1 = (0, $7qGN1.defineMessages)({
    noneSortingLabel: {
        id: 'fabric.editor.headingLink.noneSortingLabel',
        defaultMessage: 'none',
        description: 'this table column is not sorted'
    },
    ascSortingLabel: {
        id: 'fabric.editor.headingLink.ascSortingLabel',
        defaultMessage: 'ascending',
        description: 'this table column is sorted in ascending order'
    },
    descSortingLabel: {
        id: 'fabric.editor.headingLink.descSortingLabel',
        defaultMessage: 'descending',
        description: 'this table column is sorted in descending order'
    }
});
const $552b6cd9c26dd6f0$export$9f52c375a6ef34fc = (0, $7qGN1.defineMessages)({
    contentRendererInlineCommentMarkerStart: {
        id: 'fabric.editor.inlineComment.marker.start',
        defaultMessage: 'inline comment start',
        description: 'Starting marker to indicate that text is highlighted with an inline comment by a screen reader.'
    },
    contentRendererInlineCommentMarkerEnd: {
        id: 'fabric.editor.inlineComment.marker.end',
        defaultMessage: 'inline comment end',
        description: 'Ending marker to indicate that text was highlighted with an inline comment by a screen reader.'
    }
});

});



parcelRegister("dnybp", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5d377e74d822dd2$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $cZRB0 = parcelRequire("cZRB0");
const $f5d377e74d822dd2$var$InlineExtension = (props)=>{
    const { text: text } = props;
    return(// Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cZRB0.default), {
        ...props,
        type: "inlineExtension",
        children: ({ result: result })=>{
            try {
                // Return the result directly if it's a valid JSX.Element
                if (result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(result)) return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                    children: result
                });
            } catch (e) {
            /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
            // Always return default content if anything goes wrong
            return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                children: text || 'inlineExtension'
            });
        }
    }));
};
var $f5d377e74d822dd2$export$2e2bcd8739ae039 = $f5d377e74d822dd2$var$InlineExtension;

});

parcelRegister("j3a3j", function(module, exports) {

$parcel$export(module.exports, "default", () => $667d38b36abe6e31$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $92xoS = parcelRequire("92xoS");
function $667d38b36abe6e31$export$2e2bcd8739ae039(props) {
    return (0, $92xoS.editorExperiment)('advanced_layouts', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: "layout-section-container",
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            "data-layout-section": true,
            "data-layout-columns": props?.content?.length,
            children: props.children
        })
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-layout-section": true,
        children: props.children
    });
}

});

parcelRegister("5YAb6", function(module, exports) {

$parcel$export(module.exports, "default", () => $1aad786176e81e67$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $2bEPZ = parcelRequire("2bEPZ");
function $1aad786176e81e67$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// localized styles, was from clearNextSiblingMarginTopStyle in @atlaskit/editor-common/ui
const $1aad786176e81e67$var$clearNextSiblingMarginTopStyle = {
    name: "1f3w791",
    styles: "& + *{margin-top:0 !important;}"
};
// localized styles, was from clearNextSiblingBlockMarkMarginTopStyle in @atlaskit/editor-common/ui
const $1aad786176e81e67$var$clearNextSiblingBlockMarkMarginTopStyle = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`+ .fabric-editor-block-mark > p,
	  + .fabric-editor-block-mark > h1,
	  + .fabric-editor-block-mark > h2,
	  + .fabric-editor-block-mark > h3,
	  + .fabric-editor-block-mark > h4,
	  + .fabric-editor-block-mark > h5,
	  + .fabric-editor-block-mark > h6
	`]: {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginTop: '0 !important'
    }
});
function $1aad786176e81e67$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        "data-layout-column": true,
        "data-column-width": props.width,
        style: {
            flexBasis: `${props.width}%`
        }
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $2bEPZ.WidthProvider), null, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: [
            $1aad786176e81e67$var$clearNextSiblingMarginTopStyle,
            $1aad786176e81e67$var$clearNextSiblingBlockMarkMarginTopStyle
        ]
    }), props.children));
}

});

parcelRegister("lLYaS", function(module, exports) {

$parcel$export(module.exports, "default", () => $681d17e16eed1ca4$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
function $681d17e16eed1ca4$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)("li", {
        children: props.children
    });
}

});

parcelRegister("9WY2n", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1daed5b0ad27c08$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $dKDe7 = parcelRequire("dKDe7");
const $e1daed5b0ad27c08$var$RenderCaption = ({ children: children, dataAttributes: dataAttributes })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dKDe7.default), {
        hasContent: true,
        dataAttributes: dataAttributes,
        children: children
    });
};
var $e1daed5b0ad27c08$export$2e2bcd8739ae039 = $e1daed5b0ad27c08$var$RenderCaption;

});
parcelRegister("dKDe7", function(module, exports) {

$parcel$export(module.exports, "default", () => $d97783cd2ad3e478$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $6YFG2 = parcelRequire("6YFG2");

var $8nu6j = parcelRequire("8nu6j");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $hr4HX = parcelRequire("hr4HX");
function $d97783cd2ad3e478$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d97783cd2ad3e478$var$captionWrapperStyle = {
    name: "1f0iwez",
    styles: "margin-top:var(--ds-space-100, 8px);text-align:center;position:relative;color:var(--ds-text-subtle, #44546F)"
};
const $d97783cd2ad3e478$var$placeholderStyle = (0, $1DXK0.xcss)({
    color: 'color.text.subtlest',
    position: 'absolute',
    top: 'space.0',
    width: '100%'
});
class $d97783cd2ad3e478$export$f7feb87190a94c76 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    render() {
        const { selected: selected, hasContent: hasContent, children: children, dataAttributes: dataAttributes, intl: { formatMessage: formatMessage } } = this.props;
        const showPlaceholder = !selected && !hasContent;
        return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            "data-media-caption": true,
            "data-testid": "media-caption",
            ...dataAttributes,
            css: $d97783cd2ad3e478$var$captionWrapperStyle
        }, showPlaceholder ? /*#__PURE__*/ (0, $1NIU8.jsx)((0, $8nu6j.default), {
            xcss: $d97783cd2ad3e478$var$placeholderStyle
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $5qJVF.default), null, formatMessage((0, $hr4HX.messages).placeholder))) : null, children);
    }
}
var $d97783cd2ad3e478$export$2e2bcd8739ae039 = (0, $6YFG2.default)($d97783cd2ad3e478$export$f7feb87190a94c76);

});
parcelRegister("hr4HX", function(module, exports) {

$parcel$export(module.exports, "messages", () => $9bc70266f7559b7d$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $9bc70266f7559b7d$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    placeholder: {
        id: 'fabric.editor.captionPlaceholder',
        defaultMessage: 'Add a caption',
        description: 'Placeholder description for an empty (new) caption in the editor'
    }
});

});



parcelRegister("fF9eS", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a507d0ec54be88c$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $a4ifE = parcelRequire("a4ifE");

var $kvnqO = parcelRequire("kvnqO");

var $fCXIH = parcelRequire("fCXIH");

var $iCTcU = parcelRequire("iCTcU");
function $2a507d0ec54be88c$export$2e2bcd8739ae039(props) {
    const extraProps = {};
    const itemCounterDigitsSize = (0, $fCXIH.getItemCounterDigitsSize)({
        order: props.order,
        itemsCount: props?.content?.length
    });
    if (itemCounterDigitsSize && itemCounterDigitsSize > 2) extraProps.style = (0, $kvnqO.getOrderedListInlineStyles)(itemCounterDigitsSize, 'object');
    if (props.order !== undefined) extraProps.start = (0, $fCXIH.resolveOrder)(props.order);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("ol", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $a4ifE.orderedListSelector).substr(1),
        "data-indent-level": props.path ? (0, $iCTcU.getListIndentLevel)(props.path) : 1,
        start: props.start,
        ...extraProps,
        children: props.children
    });
}

});
parcelRegister("kvnqO", function(module, exports) {

$parcel$export(module.exports, "listItemCounterPadding", () => $042d28d65fee5e06$export$bafd6beec0797f87);
$parcel$export(module.exports, "getOrderedListInlineStyles", () => $042d28d65fee5e06$export$6d31fdb1d74cee3e);
$parcel$export(module.exports, "listsSharedStyles", () => $042d28d65fee5e06$export$ea95db02cc29c78f);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $7T1su = parcelRequire("7T1su");
var $a4ifE = parcelRequire("a4ifE");

var $7EdFW = parcelRequire("7EdFW");
const $042d28d65fee5e06$export$bafd6beec0797f87 = 24;
var $042d28d65fee5e06$var$CSS_VAR_NAMES = /*#__PURE__*/ function(CSS_VAR_NAMES) {
    CSS_VAR_NAMES["ITEM_COUNTER_PADDING"] = "--ed--list--item-counter--padding";
    return CSS_VAR_NAMES;
}($042d28d65fee5e06$var$CSS_VAR_NAMES || {});
const $042d28d65fee5e06$var$getItemCounterLeftPadding = (itemCounterDigitsSize)=>{
    // Previous padding-left was approximately 24px. We approximate that
    // same value using "ch" units (which represent the width of a "0" digit
    // character). We use "ch" so that this computed padding can now grow if
    //  the font-size ever enlarges.
    let paddingLeft = `2.385ch`;
    if (itemCounterDigitsSize >= 3) {
        // When there are 3 or more digits, we use a combination of "ch" units and
        // pixel values so that while the computed padding grows if font-size ever
        // enlarges, it doesn't over-scale with each digit (because of the fixed pixel
        // portion of the computed value). This way, very large item counters will not
        // become overly left-padded.
        const fixedBasePx = 2;
        paddingLeft = `calc(${itemCounterDigitsSize + 1}ch - ${fixedBasePx}px)`;
    }
    return paddingLeft;
};
const $042d28d65fee5e06$var$stringifyStyle = (style)=>Object.entries(style).reduce((str, [key, value])=>`${str}${key}:${value};`, ``);
function $042d28d65fee5e06$export$6d31fdb1d74cee3e(itemCounterDigitsSize, styleFormat) {
    const style = {
        ["--ed--list--item-counter--padding"]: $042d28d65fee5e06$var$getItemCounterLeftPadding(itemCounterDigitsSize)
    };
    if (styleFormat === 'string') return $042d28d65fee5e06$var$stringifyStyle(style);
    return style;
}
const $042d28d65fee5e06$export$ea95db02cc29c78f = /*#__PURE__*/ (0, $1NIU8.css)("ul,ol{box-sizing:border-box;padding-left:var(", "--ed--list--item-counter--padding", ", ", $042d28d65fee5e06$export$bafd6beec0797f87, "px);li p:empty,li p>span:empty{", (0, $7EdFW.browser).gecko ? 'display: inline-block;' : '', ";}}", (0, $a4ifE.orderedListSelector), ",", (0, $7T1su.bulletListSelector), "{/*\n      Ensures list item content adheres to the list's margin instead\n      of filling the entire block row. This is important to allow\n      clicking interactive elements which are floated next to a list.\n\n      For some history and context on this block, see PRs related to tickets.:\n      @see ED-6551 - original issue.\n      @see ED-7015 - follow up issue.\n      @see ED-7447 - flow-root change.\n\n      We use 'display: table' (old clear fix / new block formatting context hack)\n      for older browsers and 'flow-root' for modern browsers.\n\n      @see https://css-tricks.com/display-flow-root/\n    */display:table;display:flow-root;}ul,ul ul ul ul{list-style-type:disc;}ul ul,ul ul ul ul ul{list-style-type:circle;}ul ul ul,ul ul ul ul ul ul{list-style-type:square;}ol,ol ol ol ol{list-style-type:decimal;}ol ol,ol ol ol ol ol{list-style-type:lower-alpha;}ol ol ol,ol ol ol ol ol ol{list-style-type:lower-roman;}ol[data-indent-level='1'],ol[data-indent-level='4']{list-style-type:decimal;}ol[data-indent-level='2'],ol[data-indent-level='5']{list-style-type:lower-alpha;}ol[data-indent-level='3'],ol[data-indent-level='6']{list-style-type:lower-roman;}ul[data-indent-level='1'],ul[data-indent-level='4']{list-style-type:disc;}ul[data-indent-level='2'],ul[data-indent-level='5']{list-style-type:circle;}ul[data-indent-level='3'],ul[data-indent-level='6']{list-style-type:square;}");

});

parcelRegister("fCXIH", function(module, exports) {

$parcel$export(module.exports, "resolveOrder", () => $8408b0ba796dc38c$export$d445360e2a3c026b);
$parcel$export(module.exports, "getOrderFromOrderedListNode", () => $8408b0ba796dc38c$export$cbefb5b89ef0719f);
$parcel$export(module.exports, "getItemCounterDigitsSize", () => $8408b0ba796dc38c$export$320582fc14ba1e0f);
$parcel$export(module.exports, "isListNode", () => $8408b0ba796dc38c$export$a7d7d2b9ba4d4dbb);
$parcel$export(module.exports, "isParagraphNode", () => $8408b0ba796dc38c$export$35f600abfe6f0127);
$parcel$export(module.exports, "isListItemNode", () => $8408b0ba796dc38c$export$2ddb0a75547407f6);
$parcel$export(module.exports, "isBulletList", () => $8408b0ba796dc38c$export$35b2f400604e700);
// File has been copied to packages/editor/editor-plugin-ai/src/provider/prosemirror-transformer/utils/list.ts
// If changes are made to this file, please make the same update in the linked file.
const $8408b0ba796dc38c$export$8ef94ae42a3729bd = 1;
const $8408b0ba796dc38c$export$d445360e2a3c026b = (order)=>{
    const num = Number(order);
    if (Number.isNaN(num)) return;
    if (num < 0) return;
    return Math.floor(Math.max(num, 0));
};
const $8408b0ba796dc38c$export$cbefb5b89ef0719f = (orderedListNode)=>{
    const order = orderedListNode?.attrs?.order;
    return $8408b0ba796dc38c$export$d445360e2a3c026b(order) ?? $8408b0ba796dc38c$export$8ef94ae42a3729bd;
};
const $8408b0ba796dc38c$export$320582fc14ba1e0f = (options)=>{
    const order = $8408b0ba796dc38c$export$d445360e2a3c026b(options.order) ?? $8408b0ba796dc38c$export$8ef94ae42a3729bd;
    const itemsCount = typeof options.itemsCount === 'number' ? options.itemsCount : 0;
    const largestCounter = order + (itemsCount - 1);
    return String(largestCounter)?.split('.')?.[0]?.length;
};
function $8408b0ba796dc38c$export$a7d7d2b9ba4d4dbb(node) {
    return Boolean(node && node.type && [
        'orderedList',
        'bulletList'
    ].includes(node.type.name));
}
function $8408b0ba796dc38c$export$35f600abfe6f0127(node) {
    return Boolean(node && node.type && 'paragraph' === node.type.name);
}
function $8408b0ba796dc38c$export$2ddb0a75547407f6(node) {
    return Boolean(node && node.type && 'listItem' === node.type.name);
}
function $8408b0ba796dc38c$export$35b2f400604e700(node) {
    return Boolean(node && node.type && 'bulletList' === node.type.name);
}

});


parcelRegister("lwXex", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8bd68a40fee5900$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $22Lfi = parcelRequire("22Lfi");
function $c8bd68a40fee5900$export$2e2bcd8739ae039({ children: children, dataAttributes: dataAttributes }) {
    return(// ignore the eslint warning Text primitive does not support dataAttributes
    // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading, @atlaskit/design-system/use-primitives-text
    /*#__PURE__*/ (0, $gt9Am.jsx)("p", {
        ...dataAttributes,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $22Lfi.default), {
            children: children
        })
    }));
}

});
parcelRegister("22Lfi", function(module, exports) {

$parcel$export(module.exports, "default", () => $412e5af08bbe0159$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
function $412e5af08bbe0159$export$2e2bcd8739ae039(props) {
    const { children: children } = props;
    const childCount = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.toArray(children).length;
    if (!childCount) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: "\xa0"
    });
    return children;
}

});


parcelRegister("gtUUa", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ab3bdba2518f19c$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
function $3ab3bdba2518f19c$export$2e2bcd8739ae039(props) {
    if (props.allowPlaceholderText) return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-placeholder": `${props.text}`,
        children: props.text
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {});
}

});

parcelRegister("aYUex", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ce23554b9f83dab$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
function $8ce23554b9f83dab$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $gt9Am.jsx)("hr", {
        role: "presentation"
    });
}

});

parcelRegister("idsFq", function(module, exports) {

$parcel$export(module.exports, "isTableResizingEnabled", () => $4ae183b0f220a464$export$eec82c0a93aa66d9);
$parcel$export(module.exports, "isStickyScrollbarEnabled", () => $4ae183b0f220a464$export$bdb2dadcb04aad50);
$parcel$export(module.exports, "default", () => $4ae183b0f220a464$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $cjLtO = parcelRequire("cjLtO");

var $k6yTf = parcelRequire("k6yTf");
var $2bEPZ = parcelRequire("2bEPZ");

var $eGOwo = parcelRequire("eGOwo");

var $d3BBj = parcelRequire("d3BBj");
var $bTpHi = parcelRequire("bTpHi");
var $gikGJ = parcelRequire("gikGJ");

var $hh2CV = parcelRequire("hh2CV");

var $7yBx7 = parcelRequire("7yBx7");

var $68RqK = parcelRequire("68RqK");

var $92xoS = parcelRequire("92xoS");


var $lzf9g = parcelRequire("lzf9g");

var $dZ1mQ = parcelRequire("dZ1mQ");

var $177xQ = parcelRequire("177xQ");

var $hpXI5 = parcelRequire("hpXI5");

var $3xZmi = parcelRequire("3xZmi");

var $hxOCd = parcelRequire("hxOCd");

var $eOVsb = parcelRequire("eOVsb");
const $4ae183b0f220a464$export$eec82c0a93aa66d9 = (appearance)=>(0, $3xZmi.isFullWidthOrFullPageAppearance)(appearance) || (0, $3xZmi.isCommentAppearance)(appearance) && (0, $92xoS.editorExperiment)('support_table_in_comment', true, {
        exposure: true
    });
const $4ae183b0f220a464$export$bdb2dadcb04aad50 = (appearance)=>(0, $3xZmi.isFullWidthOrFullPageAppearance)(appearance) && (0, $92xoS.editorExperiment)('platform_renderer_table_sticky_scrollbar', true, {
        exposure: true
    });
const $4ae183b0f220a464$export$334894231c46c1a5 = (children, tableNode, smartCardStorage, tableOrderStatus)=>{
    if (!tableOrderStatus || tableOrderStatus.order === (0, $hh2CV.SortOrder).NO_ORDER) return children;
    const { order: order, columnIndex: columnIndex } = tableOrderStatus;
    const compareNodesInOrder = (0, $gikGJ.createCompareNodes)({
        getInlineCardTextFromStore (attrs) {
            const { url: url } = attrs;
            if (!url) return null;
            return smartCardStorage.get(url) || null;
        }
    }, order);
    const tableArray = (0, $bTpHi.convertProsemirrorTableNodeToArrayOfRows)(tableNode);
    const tableArrayWithChildren = tableArray.map((rowNodes, index)=>({
            rowNodes: rowNodes,
            rowReact: children[index]
        }));
    const headerRow = tableArrayWithChildren.shift();
    const sortedTable = tableArrayWithChildren.sort((rowA, rowB)=>compareNodesInOrder(rowA.rowNodes[columnIndex], rowB.rowNodes[columnIndex]));
    if (headerRow) sortedTable.unshift(headerRow);
    return sortedTable.map((elem)=>elem.rowReact);
};
const $4ae183b0f220a464$export$42f5658c8e0092da = (row)=>{
    let hasRowspan = false;
    row.forEach((cell)=>hasRowspan = hasRowspan || cell.attrs.rowspan > 1);
    return hasRowspan;
};
const $4ae183b0f220a464$export$f422245984b0eda7 = (refElement)=>{
    return Math.round(refElement.getBoundingClientRect().top);
};
const $4ae183b0f220a464$export$7c141112f3c89f11 = (scrollTop, tableTop, tableBottom, rowHeight)=>tableTop <= scrollTop && !(tableBottom - rowHeight <= scrollTop);
const $4ae183b0f220a464$export$89f3188e1adc30d5 = (scrollTop, tableBottom, rowHeight)=>tableBottom - rowHeight <= scrollTop && !(tableBottom < scrollTop);
const $4ae183b0f220a464$export$100baa0f10804e6e = (rows, tableOrderStatus, onSorting)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(rows, (row, index)=>{
        if (index === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.only(row), {
            tableOrderStatus: tableOrderStatus,
            onSorting: onSorting
        });
        return row;
    });
};
const $4ae183b0f220a464$export$28daf78feed5098c = (rows)=>{
    if (!rows.length) return false;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const { children: children } = rows[0].props;
    if (!children.length) return false;
    if (children.length === 1) return children[0].type === (0, $lzf9g.TableHeader);
    return children.every((node)=>node.type === (0, $lzf9g.TableHeader));
};
const $4ae183b0f220a464$export$940095e914312886 = (node, children)=>{
    return $4ae183b0f220a464$export$28daf78feed5098c(children) && node && node.firstChild && !$4ae183b0f220a464$export$42f5658c8e0092da(node.firstChild);
};
class $4ae183b0f220a464$export$f2c3aea42b2a048f extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    /**
   *
   * @example
   */ componentDidMount() {
        this.resizeObserver = new ResizeObserver(this.applyResizerChange);
        if (this.wrapperRef.current) this.resizeObserver.observe(this.wrapperRef.current);
        if (this.stickyHeaderRef.current) this.resizeObserver.observe(this.stickyHeaderRef.current);
        if (this.props.stickyHeaders) {
            this.overflowParent = (0, $177xQ.OverflowParent).fromElement(this.tableRef.current, this.props.stickyHeaders?.defaultScrollRootId_DO_NOT_USE);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.addEventListener('scroll', this.onScroll);
        }
        if (this.wrapperRef.current && $4ae183b0f220a464$export$bdb2dadcb04aad50(this.props.rendererAppearance)) this.stickyScrollbar = new (0, $hxOCd.TableStickyScrollbar)(this.wrapperRef.current);
    }
    /**
   *
   * @param prevProps
   * @param prevState
   * @example
   */ componentDidUpdate(prevProps, prevState) {
        // toggling sticky headers visiblity
        if (this.props.stickyHeaders && !this.overflowParent) this.overflowParent = (0, $177xQ.OverflowParent).fromElement(this.tableRef.current, this.props.stickyHeaders?.defaultScrollRootId_DO_NOT_USE);
        else if (!this.props.stickyHeaders && this.overflowParent) {
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.removeEventListener('scroll', this.onScroll);
            this.overflowParent = null;
        }
        // offsetTop might have changed, re-position sticky header
        if (this.props.stickyHeaders !== prevProps.stickyHeaders) this.updateSticky();
        // sync horizontal scroll in floating div when toggling modes
        if (prevState.stickyMode !== this.state.stickyMode) this.onWrapperScrolled();
    }
    /**
   *
   */ get pinTop() {
        if (!this.tableRef.current || !this.stickyHeaderRef.current) return;
        return this.tableRef.current.offsetHeight - this.stickyHeaderRef.current.offsetHeight + (0, $cjLtO.tableMarginTop) - (0, $177xQ.tableStickyPadding);
    }
    /**
   *
   */ get shouldAddOverflowParentOffsetTop_DO_NOT_USE() {
        // IF the StickyHeaderConfig specifies that the default scroll root offsetTop should be added
        // AND the StickyHeaderConfig specifies a default scroll root id
        // AND the OverflowParent is the corresponding element
        // THEN we should add the OverflowParent offset top (RETURN TRUE)
        return this.props.stickyHeaders && !!this.props.stickyHeaders.shouldAddDefaultScrollRootOffsetTop_DO_NOT_USE && !!this.props.stickyHeaders.defaultScrollRootId_DO_NOT_USE && this.overflowParent && this.overflowParent.id === this.props.stickyHeaders.defaultScrollRootId_DO_NOT_USE;
    }
    /**
   *
   */ get stickyTop() {
        switch(this.state.stickyMode){
            case 'pin-bottom':
                return this.pinTop;
            case 'stick':
                const offsetTop = this.props.stickyHeaders && this.props.stickyHeaders.offsetTop;
                if (typeof offsetTop === 'number' && this.shouldAddOverflowParentOffsetTop_DO_NOT_USE) {
                    const overflowParentOffsetTop = this.overflowParent ? this.overflowParent.top : 0;
                    return offsetTop + overflowParentOffsetTop;
                } else return offsetTop;
            default:
                return undefined;
        }
    }
    /**
   *
   * @example
   */ render() {
        const { isNumberColumnEnabled: isNumberColumnEnabled, layout: layout, renderWidth: renderWidth, columnWidths: columnWidths, stickyHeaders: stickyHeaders, tableNode: tableNode, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, isInsideOfTable: isInsideOfTable, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension, allowTableAlignment: allowTableAlignment, allowTableResizing: allowTableResizing, isPresentational: isPresentational } = this.props;
        const { stickyMode: stickyMode } = this.state;
        const lineLengthFixedWidth = (0, $7yBx7.akEditorDefaultLayoutWidth);
        let left;
        let updatedLayout;
        // The tableWidth and left offset logic below must stay aligned with the `breakout-ssr.tsx` logic
        // Please consider changes below carefully to not negatively impact SSR
        // `renderWidth` cannot be depended on during SSR
        const isRenderWidthValid = !!renderWidth && renderWidth > 0;
        const renderWidthCSS = rendererAppearance === 'full-page' ? `100cqw - ${0, $9a762f515f769003$export$12fd658e5eef0d79}px * 2` : `100cqw`;
        const calcDefaultLayoutWidthByAppearance = (rendererAppearance, tableNode)=>{
            if (rendererAppearance === 'full-width' && !tableNode?.attrs.width) return [
                isRenderWidthValid ? Math.min((0, $7yBx7.akEditorFullWidthLayoutWidth), renderWidth) : (0, $7yBx7.akEditorFullWidthLayoutWidth),
                `min(${(0, $7yBx7.akEditorFullWidthLayoutWidth)}px, ${renderWidthCSS})`
            ];
            else if (rendererAppearance === 'comment' && allowTableResizing && !tableNode?.attrs.width) {
                const tableContainerWidth = (0, $68RqK.getTableContainerWidth)(tableNode);
                return [
                    isRenderWidthValid ? renderWidth : tableContainerWidth,
                    renderWidthCSS
                ];
            } else {
                // custom width, or width mapped to breakpoint
                const tableContainerWidth = (0, $68RqK.getTableContainerWidth)(tableNode);
                return [
                    isRenderWidthValid ? Math.min(tableContainerWidth, renderWidth) : tableContainerWidth,
                    `min(${tableContainerWidth}px, ${renderWidthCSS})`
                ];
            }
        };
        const [tableWidth, tableWidthCSS] = calcDefaultLayoutWidthByAppearance(rendererAppearance, tableNode);
        // Logic for table alignment in renderer
        const isTableAlignStart = tableNode && tableNode.attrs && tableNode.attrs.layout === 'align-start' && allowTableAlignment;
        const fullWidthLineLength = isRenderWidthValid ? Math.min((0, $7yBx7.akEditorFullWidthLayoutWidth), renderWidth) : (0, $7yBx7.akEditorFullWidthLayoutWidth);
        const fullWidthLineLengthCSS = `min(${(0, $7yBx7.akEditorFullWidthLayoutWidth)}px, ${renderWidthCSS})`;
        const commentLineLength = isRenderWidthValid ? renderWidth : lineLengthFixedWidth;
        const isCommentAppearanceAndTableAlignmentEnabled = (0, $3xZmi.isCommentAppearance)(rendererAppearance) && allowTableAlignment;
        const lineLength = (0, $3xZmi.isFullWidthAppearance)(rendererAppearance) ? fullWidthLineLength : isCommentAppearanceAndTableAlignmentEnabled ? commentLineLength : lineLengthFixedWidth;
        const lineLengthCSS = (0, $3xZmi.isFullWidthAppearance)(rendererAppearance) ? fullWidthLineLengthCSS : isCommentAppearanceAndTableAlignmentEnabled ? renderWidthCSS : `${lineLengthFixedWidth}px`;
        // Setting fixTableSSRResizing to false while FG logic is true in tableNew
        const fixTableSSRResizing = false;
        const tableWidthNew = fixTableSSRResizing ? (0, $68RqK.getTableContainerWidth)(tableNode) : tableWidth;
        const shouldCalculateLeftForAlignment = !isInsideOfBlockNode && !isInsideOfTable && isTableAlignStart && ((0, $3xZmi.isFullPageAppearance)(rendererAppearance) && tableWidthNew <= lineLengthFixedWidth || (0, $3xZmi.isFullWidthAppearance)(rendererAppearance) || isCommentAppearanceAndTableAlignmentEnabled);
        let leftCSS;
        if (shouldCalculateLeftForAlignment) {
            left = (tableWidth - lineLength) / 2;
            leftCSS = `(${tableWidthCSS} - ${lineLengthCSS}) / 2`;
        }
        if (fixTableSSRResizing) {
            if (!shouldCalculateLeftForAlignment && (0, $3xZmi.isFullPageAppearance)(rendererAppearance)) // Note tableWidthCSS here is the renderer width
            // When the screen is super wide we want table to break out.
            // However if screen is smaller than 760px. We want table align to left.
            leftCSS = `min(0px, ${lineLengthCSS} - ${tableWidthCSS}) / 2`;
        } else if (!shouldCalculateLeftForAlignment && (0, $3xZmi.isFullPageAppearance)(rendererAppearance) && tableWidthNew > lineLengthFixedWidth) left = lineLengthFixedWidth / 2 - tableWidth / 2;
        const children = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.toArray(this.props.children);
        // Historically, tables in the full-width renderer had their layout set to 'default' which is deceiving.
        // This check caters for those tables and helps with SSR logic
        const isFullWidth = !tableNode?.attrs.width && rendererAppearance === 'full-width' && layout !== 'full-width';
        if (isFullWidth) updatedLayout = 'full-width';
        else if (tableNode?.attrs.width) updatedLayout = 'custom';
        else updatedLayout = layout;
        let finalTableContainerWidth = allowTableResizing ? tableWidthNew : 'inherit';
        // We can only use CSS to determine the width when we have a known width in container.
        // When appearance is full-page, full-width or comment we use CSS based width calculation.
        // Otherwise it's fixed table width (customized width) or inherit.
        if ((rendererAppearance === 'full-page' || rendererAppearance === 'full-width') && fixTableSSRResizing) finalTableContainerWidth = allowTableResizing ? `calc(${tableWidthCSS})` : 'inherit';
        if (rendererAppearance === 'comment' && allowTableResizing && !allowTableAlignment) // If table alignment is disabled and table width is akEditorDefaultLayoutWidth = 760,
        // it is most likely a table created before "Support Table in Comments" FF was enabled
        // and we would see a bug ED-24795. A table created before "Support Table in Comments",
        // should inhirit the width of the renderer container.
        // !NOTE: it a table resized to 760 is copied from 'full-page' editor and pasted in comment editor
        // where (allowTableResizing && !allowTableAlignment), the table will loose 760px width.
        finalTableContainerWidth = tableNode?.attrs.width && tableNode?.attrs.width !== (0, $7yBx7.akEditorDefaultLayoutWidth) ? fixTableSSRResizing ? `calc(${tableWidthCSS})` : tableWidth : 'inherit';
        if (rendererAppearance === 'comment' && allowTableResizing && allowTableAlignment) // If table alignment is enabled and layout is not 'align-start' or 'center', we are loading a table that was
        // created before "Support Table in Comments" FF was enabled. So the table should have the same width as renderer container
        // instead of 760 that was set on tableNode when the table had been published.
        finalTableContainerWidth = (tableNode?.attrs.layout === 'align-start' || tableNode?.attrs.layout === 'center') && tableNode?.attrs.width ? fixTableSSRResizing ? `calc(${tableWidthCSS})` : tableWidth : 'inherit';
        let style;
        if (fixTableSSRResizing) style = {
            width: finalTableContainerWidth,
            left: leftCSS ? `calc(${leftCSS})` : undefined,
            marginLeft: shouldCalculateLeftForAlignment && leftCSS !== undefined ? `calc(-1 * (${leftCSS}))` : undefined
        };
        else style = {
            width: finalTableContainerWidth,
            left: left,
            marginLeft: shouldCalculateLeftForAlignment && left !== undefined ? -left : undefined
        };
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
            children: /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: `${(0, $cjLtO.TableSharedCssClassName).TABLE_CONTAINER} ${this.props.shadowClassNames || ''}`,
                "data-layout": updatedLayout,
                ref: this.props.handleRef,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: style,
                children: [
                    $4ae183b0f220a464$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $cjLtO.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP,
                        "data-testid": "sticky-scrollbar-sentinel-top"
                    }),
                    stickyHeaders && $4ae183b0f220a464$export$940095e914312886(tableNode, children) && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $177xQ.StickyTable), {
                        isNumberColumnEnabled: isNumberColumnEnabled,
                        tableWidth: tableWidth,
                        layout: layout,
                        renderWidth: renderWidth,
                        handleRef: this.props.handleRef,
                        shadowClassNames: this.props.shadowClassNames,
                        top: this.stickyTop,
                        mode: stickyMode,
                        innerRef: this.stickyWrapperRef,
                        wrapperWidth: this.state.wrapperWidth,
                        columnWidths: columnWidths,
                        rowHeight: this.state.headerRowHeight,
                        tableNode: tableNode,
                        rendererAppearance: rendererAppearance,
                        allowTableResizing: allowTableResizing,
                        children: [
                            children && children[0]
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $cjLtO.TableSharedCssClassName).TABLE_NODE_WRAPPER,
                        ref: this.wrapperRef,
                        onScroll: this.props.stickyHeaders && this.onWrapperScrolled,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hpXI5.Table), {
                            innerRef: this.tableRef,
                            columnWidths: columnWidths,
                            layout: layout,
                            isNumberColumnEnabled: isNumberColumnEnabled,
                            renderWidth: renderWidth,
                            tableNode: tableNode,
                            rendererAppearance: rendererAppearance,
                            isInsideOfBlockNode: isInsideOfBlockNode,
                            isInsideOfTable: isInsideOfTable,
                            isinsideMultiBodiedExtension: isinsideMultiBodiedExtension,
                            allowTableResizing: allowTableResizing,
                            isPresentational: isPresentational,
                            children: this.grabFirstRowRef(children)
                        })
                    }),
                    $4ae183b0f220a464$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $cjLtO.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER,
                        ref: this.stickyScrollbarRef,
                        style: {
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                            height: "var(--ds-space-250, 20px)",
                            // MAX_BROWSER_SCROLLBAR_HEIGHT
                            // Follow editor to hide by default so it does not show empty gap in SSR
                            // https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/browse/platform/packages/editor/editor-plugin-table/src/nodeviews/TableComponent.tsx#957
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                            display: fixTableSSRResizing ? 'none' : 'block',
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                            width: '100%'
                        },
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                            style: {
                                width: this.tableRef.current?.clientWidth,
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                height: '100%'
                            }
                        })
                    }),
                    $4ae183b0f220a464$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $cjLtO.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM,
                        "data-testid": "sticky-scrollbar-sentinel-bottom"
                    })
                ]
            })
        });
    }
    constructor(...args){
        super(...args), this.state = {
            stickyMode: 'none',
            wrapperWidth: 0,
            headerRowHeight: 0
        }, this.tableRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createRef(), this.stickyHeaderRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createRef(), this.stickyScrollbarRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createRef(), // used for sync scroll + copying wrapper width to sticky header
        this.stickyWrapperRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createRef(), this.wrapperRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createRef(), this.overflowParent = null, this.resizeObserver = null, this.applyResizerChange = (entries)=>{
            let wrapperWidth = this.state.wrapperWidth;
            let headerRowHeight = this.state.headerRowHeight;
            for (const entry of entries){
                if (entry.target === this.wrapperRef.current) wrapperWidth = entry.contentRect.width;
                else if (entry.target === this.stickyHeaderRef.current) headerRowHeight = Math.round(entry.contentRect.height);
            }
            if (headerRowHeight !== this.state.headerRowHeight || wrapperWidth !== this.state.wrapperWidth) this.setState({
                wrapperWidth: wrapperWidth,
                headerRowHeight: headerRowHeight
            });
        }, this.componentWillUnmount = ()=>{
            if (this.overflowParent) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.removeEventListener('scroll', this.onScroll);
            if (this.nextFrame) cancelAnimationFrame(this.nextFrame);
            if (this.resizeObserver) this.resizeObserver.disconnect();
            if (this.stickyScrollbar) this.stickyScrollbar.dispose();
        }, this.getScrollTop = ()=>{
            const { stickyHeaders: stickyHeaders } = this.props;
            const offsetTop = stickyHeaders && stickyHeaders.offsetTop || 0;
            return (this.overflowParent ? this.overflowParent.top : 0) + offsetTop;
        }, this.updateSticky = ()=>{
            const tableElem = this.tableRef.current;
            const refElem = this.stickyHeaderRef.current;
            if (!tableElem || !refElem) return;
            const scrollTop = this.getScrollTop() + (0, $177xQ.tableStickyPadding);
            const tableTop = $4ae183b0f220a464$export$f422245984b0eda7(tableElem);
            const tableBottom = tableTop + tableElem.clientHeight;
            const shouldSticky = $4ae183b0f220a464$export$7c141112f3c89f11(scrollTop, tableTop, tableBottom, refElem.clientHeight);
            const shouldPin = $4ae183b0f220a464$export$89f3188e1adc30d5(scrollTop, tableBottom, refElem.clientHeight);
            let stickyMode = 'none';
            if (shouldPin) stickyMode = 'pin-bottom';
            else if (shouldSticky) stickyMode = 'stick';
            if (this.state.stickyMode !== stickyMode) this.setState({
                stickyMode: stickyMode
            });
            this.nextFrame = undefined;
        }, this.onScroll = ()=>{
            if (!this.nextFrame) this.nextFrame = requestAnimationFrame(this.updateSticky);
        }, this.onWrapperScrolled = ()=>{
            if (!this.wrapperRef.current || !this.stickyWrapperRef.current) return;
            this.stickyWrapperRef.current.scrollLeft = this.wrapperRef.current.scrollLeft;
            if (this.stickyScrollbarRef.current) this.stickyScrollbarRef.current.scrollLeft = this.wrapperRef.current.scrollLeft;
        }, this.grabFirstRowRef = (children)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(children || false, (child, idx)=>{
                if (idx === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(child)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).cloneElement(child, {
                    innerRef: this.stickyHeaderRef
                });
                return child;
            });
        };
    }
}
class $4ae183b0f220a464$export$91e0997fd3f75d56 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    /**
   *
   * @example
   */ render() {
        const { children: children } = this.props;
        if (!children) return null;
        const childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.toArray(children);
        const orderedChildren = (0, $d3BBj.compose)(this.addNumberColumnIndexes, this.addSortableColumn)(childrenArray);
        // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, $gt9Am.jsx)($4ae183b0f220a464$export$f2c3aea42b2a048f, {
            ...this.props,
            children: orderedChildren
        });
    }
    constructor(...args){
        super(...args), this.state = {
            tableOrderStatus: undefined
        }, // adds sortable + re-orders children
        this.addSortableColumn = (childrenArray)=>{
            const { tableNode: tableNode, allowColumnSorting: allowColumnSorting, smartCardStorage: smartCardStorage } = this.props;
            const { tableOrderStatus: tableOrderStatus } = this.state;
            if (allowColumnSorting && $4ae183b0f220a464$export$28daf78feed5098c(childrenArray) && tableNode && !(0, $bTpHi.hasMergedCell)(tableNode)) return $4ae183b0f220a464$export$100baa0f10804e6e($4ae183b0f220a464$export$334894231c46c1a5(childrenArray, tableNode, smartCardStorage, tableOrderStatus), tableOrderStatus, this.changeSortOrder);
            return childrenArray;
        }, this.changeSortOrder = (columnIndex, sortOrder)=>{
            this.setState({
                tableOrderStatus: {
                    columnIndex: columnIndex,
                    order: sortOrder
                }
            });
        }, // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.addNumberColumnIndexes = (rows)=>{
            const { isNumberColumnEnabled: isNumberColumnEnabled } = this.props;
            const headerRowEnabled = $4ae183b0f220a464$export$28daf78feed5098c(rows);
            return (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(rows, (row, index)=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.only(row), {
                    isNumberColumnEnabled: isNumberColumnEnabled,
                    index: headerRowEnabled ? index === 0 ? '' : index : index + 1
                });
            });
        };
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $4ae183b0f220a464$var$TableWithShadowsAndContainerStyles = (0, $k6yTf.default)((0, $eOVsb.TableProcessorWithContainerStyles), {
    /**
   * The :scope is in reference to table container and we are selecting only
   * direct children that match the table node wrapper selector, not their
   * descendants.
   */ overflowSelector: `:scope > .${(0, $cjLtO.TableSharedCssClassName).TABLE_NODE_WRAPPER}`,
    useShadowObserver: true
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $4ae183b0f220a464$var$TableWithShadows = (0, $k6yTf.default)($4ae183b0f220a464$export$91e0997fd3f75d56, {
    /**
   * The :scope is in reference to table container and we are selecting only
   * direct children that match the table node wrapper selector, not their
   * descendants.
   */ overflowSelector: `:scope > .${(0, $cjLtO.TableSharedCssClassName).TABLE_NODE_WRAPPER}`,
    useShadowObserver: true
});
const $4ae183b0f220a464$var$TableWithWidth = (props)=>{
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if ((0, $eGOwo.fg)('platform-ssr-table-resize')) {
        const colWidthsSum = props.columnWidths?.reduce((total, val)=>total + val, 0) || 0;
        if (colWidthsSum || props.allowTableResizing) // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, $gt9Am.jsx)($4ae183b0f220a464$var$TableWithShadowsAndContainerStyles, {
            ...props
        });
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eOVsb.TableProcessorWithContainerStyles), {
            ...props
        });
    } else return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2bEPZ.WidthConsumer), {
        children: ({ width: width })=>{
            const renderWidth = props.rendererAppearance === 'full-page' ? width - (0, $9a762f515f769003$export$12fd658e5eef0d79) * 2 : width;
            const colWidthsSum = props.columnWidths?.reduce((total, val)=>total + val, 0) || 0;
            if (colWidthsSum || props.allowTableResizing) // Ignored via go/ees005
            // eslint-disable-next-line react/jsx-props-no-spreading
            return /*#__PURE__*/ (0, $gt9Am.jsx)($4ae183b0f220a464$var$TableWithShadows, {
                renderWidth: renderWidth,
                ...props
            });
            // there should not be a case when colWidthsSum is 0 and table is in overflow state - so no need to render shadows in this case
            return /*#__PURE__*/ (0, $gt9Am.jsx)($4ae183b0f220a464$export$91e0997fd3f75d56, {
                renderWidth: renderWidth,
                ...props
            });
        }
    });
};
var $4ae183b0f220a464$export$2e2bcd8739ae039 = (0, $dZ1mQ.withSmartCardStorage)($4ae183b0f220a464$var$TableWithWidth);

});
parcelRegister("cjLtO", function(module, exports) {

$parcel$export(module.exports, "tableMarginTop", () => $00ec34b4d6cfa8a7$export$808015ab1dd6897a);
$parcel$export(module.exports, "tableMarginTopWithControl", () => $00ec34b4d6cfa8a7$export$910bf0d22c3d10f2);
$parcel$export(module.exports, "tableMarginSides", () => $00ec34b4d6cfa8a7$export$a43e30915fab3ccf);
$parcel$export(module.exports, "tableCellMinWidth", () => $00ec34b4d6cfa8a7$export$531f77930bf508de);
$parcel$export(module.exports, "tableNewColumnMinWidth", () => $00ec34b4d6cfa8a7$export$c60fae4049791eae);
$parcel$export(module.exports, "tableCellBorderWidth", () => $00ec34b4d6cfa8a7$export$72aad729077aa0fb);
$parcel$export(module.exports, "tableCellPadding", () => $00ec34b4d6cfa8a7$export$e56b8ca552b280f6);
$parcel$export(module.exports, "TableSharedCssClassName", () => $00ec34b4d6cfa8a7$export$c096bca5477eb7ad);
$parcel$export(module.exports, "tableSharedStyle", () => $00ec34b4d6cfa8a7$export$c2bf8eea75aa9302);
$parcel$export(module.exports, "calcTableWidth", () => $00ec34b4d6cfa8a7$export$d7ece4d8beb06815);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $e6HpD = parcelRequire("e6HpD");

var $7yBx7 = parcelRequire("7yBx7");
var $1rXAK = parcelRequire("1rXAK");

var $eGOwo = parcelRequire("eGOwo");

var $7EdFW = parcelRequire("7EdFW");

var $gBkUB = parcelRequire("gBkUB");

var $63wVg = parcelRequire("63wVg");
function $00ec34b4d6cfa8a7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $00ec34b4d6cfa8a7$export$808015ab1dd6897a = 24;
const $00ec34b4d6cfa8a7$export$afe1899c3eea9823 = 16;
const $00ec34b4d6cfa8a7$export$910bf0d22c3d10f2 = 14;
const $00ec34b4d6cfa8a7$export$a43e30915fab3ccf = 8;
const $00ec34b4d6cfa8a7$export$531f77930bf508de = 48;
const $00ec34b4d6cfa8a7$export$c60fae4049791eae = 140;
const $00ec34b4d6cfa8a7$export$72aad729077aa0fb = 1;
const $00ec34b4d6cfa8a7$export$e56b8ca552b280f6 = 8;
const $00ec34b4d6cfa8a7$export$bba39e724bc39451 = 6;
const $00ec34b4d6cfa8a7$export$e5ff276883773ffd = 8;
const $00ec34b4d6cfa8a7$export$880976487022eb5 = $00ec34b4d6cfa8a7$export$808015ab1dd6897a + $00ec34b4d6cfa8a7$export$e5ff276883773ffd - $00ec34b4d6cfa8a7$export$72aad729077aa0fb;
const $00ec34b4d6cfa8a7$export$c096bca5477eb7ad = {
    TABLE_CONTAINER: `${(0, $e6HpD.tablePrefixSelector)}-container`,
    TABLE_NODE_WRAPPER: `${(0, $e6HpD.tablePrefixSelector)}-wrapper`,
    TABLE_LEFT_SHADOW: `${(0, $e6HpD.tablePrefixSelector)}-with-left-shadow`,
    TABLE_RIGHT_SHADOW: `${(0, $e6HpD.tablePrefixSelector)}-with-right-shadow`,
    TABLE_STICKY_SHADOW: `${(0, $e6HpD.tablePrefixSelector)}-sticky-shadow`,
    TABLE_STICKY_WRAPPER: `${(0, $e6HpD.tablePrefixSelector)}-sticky-wrapper`,
    TABLE_STICKY_SCROLLBAR_CONTAINER: `${(0, $e6HpD.tablePrefixSelector)}-sticky-scrollbar-container`,
    TABLE_STICKY_SENTINEL_TOP: `${(0, $e6HpD.tablePrefixSelector)}-sticky-sentinel-top`,
    TABLE_STICKY_SENTINEL_BOTTOM: `${(0, $e6HpD.tablePrefixSelector)}-sticky-sentinel-bottom`,
    TABLE_STICKY_SCROLLBAR_SENTINEL_TOP: `${(0, $e6HpD.tablePrefixSelector)}-sticky-scrollbar-sentinel-top`,
    TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM: `${(0, $e6HpD.tablePrefixSelector)}-sticky-scrollbar-sentinel-bottom`,
    TABLE_SHADOW_SENTINEL_LEFT: `${(0, $e6HpD.tablePrefixSelector)}-shadow-sentinel-left`,
    TABLE_SHADOW_SENTINEL_RIGHT: `${(0, $e6HpD.tablePrefixSelector)}-shadow-sentinel-right`,
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    TABLE_CELL_NODEVIEW_CONTENT_DOM: (0, $e6HpD.tableCellContentDomSelector),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    TABLE_CELL_WRAPPER: (0, $e6HpD.tableCellSelector),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    TABLE_HEADER_CELL_WRAPPER: (0, $e6HpD.tableHeaderSelector),
    TABLE_ROW_CONTROLS_WRAPPER: `${(0, $e6HpD.tablePrefixSelector)}-row-controls-wrapper`,
    TABLE_COLUMN_CONTROLS_DECORATIONS: `${(0, $e6HpD.tablePrefixSelector)}-column-controls-decoration`,
    TABLE_RESIZER_CONTAINER: `${(0, $e6HpD.tablePrefixSelector)}-resizer-container`
};
/* first block node has 0 top margin */ var $00ec34b4d6cfa8a7$var$_ref = {
    name: "qubt66",
    styles: ">:first-child:not(style),>style:first-child+*{margin-top:0;}>.ProseMirror-gapcursor:first-child+*,>style:first-child+.ProseMirror-gapcursor+*{margin-top:0;}>.ProseMirror-gapcursor:first-child+span+*,>style:first-child+.ProseMirror-gapcursor+span+*{margin-top:0;}"
};
var $00ec34b4d6cfa8a7$var$_ref2 = {
    name: "1fct7qz",
    styles: ">:nth-child(1 of :not(style, .ProseMirror-gapcursor, .ProseMirror-widget, span)){margin-top:0;}"
};
const $00ec34b4d6cfa8a7$var$firstNodeWithNotMarginTop = ()=>(0, $eGOwo.fg)('platform_editor_nested_dnd_styles_changes') ? $00ec34b4d6cfa8a7$var$_ref2 : $00ec34b4d6cfa8a7$var$_ref;
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Appears safe to auto-fix, but leaving it up to the team to remediate as the readability only gets worse with autofixing
const $00ec34b4d6cfa8a7$export$c2bf8eea75aa9302 = ()=>/*#__PURE__*/ (0, $1NIU8.css)((0, $63wVg.tableCellBackgroundStyleOverride)(), " .", $00ec34b4d6cfa8a7$export$c096bca5477eb7ad.TABLE_CONTAINER, "{position:relative;margin:0 auto var(--ds-space-200, 16px);box-sizing:border-box;.decisionItemView-content-wrap:first-of-type>div{margin-top:0;}}.", $00ec34b4d6cfa8a7$export$c096bca5477eb7ad.TABLE_CONTAINER, "[data-number-column='true']{padding-left:", (0, $7yBx7.akEditorTableNumberColumnWidth) - 1, "px;clear:both;}.", $00ec34b4d6cfa8a7$export$c096bca5477eb7ad.TABLE_RESIZER_CONTAINER, "{will-change:width,margin-left;}.", $00ec34b4d6cfa8a7$export$c096bca5477eb7ad.TABLE_RESIZER_CONTAINER, " table{will-change:width;}.", $00ec34b4d6cfa8a7$export$c096bca5477eb7ad.TABLE_NODE_WRAPPER, ">table{margin:var(--ds-space-300, 24px) 0 0 0;}.", $00ec34b4d6cfa8a7$export$c096bca5477eb7ad.TABLE_CONTAINER, ">table,.", $00ec34b4d6cfa8a7$export$c096bca5477eb7ad.TABLE_STICKY_WRAPPER, ">table{margin:var(--ds-space-300, 24px) var(--ds-space-100, 8px) 0 0;}", (0, $eGOwo.fg)('platform_editor_bordered_panel_nested_in_table') ? `.${$00ec34b4d6cfa8a7$export$c096bca5477eb7ad.TABLE_NODE_WRAPPER} .ak-editor-panel {
			border: ${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #d9dbea)"};
		}` : '', ".", $00ec34b4d6cfa8a7$export$c096bca5477eb7ad.TABLE_CONTAINER, ">table,.", $00ec34b4d6cfa8a7$export$c096bca5477eb7ad.TABLE_NODE_WRAPPER, ">table,.", $00ec34b4d6cfa8a7$export$c096bca5477eb7ad.TABLE_STICKY_WRAPPER, ">table{border-collapse:collapse;border:", $00ec34b4d6cfa8a7$export$72aad729077aa0fb, "px solid ", `var(--ds-background-accent-gray-subtler, ${(0, $7yBx7.akEditorTableBorder)})`, ";table-layout:fixed;font-size:1em;width:100%;&[data-autosize='true']{table-layout:auto;}&{*{box-sizing:border-box;}hr{box-sizing:content-box;}tbody{border-bottom:none;}th td{background-color:var(--ds-background-neutral-subtle, white);}", (0, $eGOwo.fg)('platform_editor_renderer_table_header_styles') ? `> tbody > tr > th, > tbody > tr > td` : 'th, td', "{min-width:", $00ec34b4d6cfa8a7$export$531f77930bf508de, "px;font-weight:var(--ds-font-weight-regular, 400);vertical-align:top;border:1px solid ", `var(--ds-background-accent-gray-subtler, ${(0, $7yBx7.akEditorTableBorder)})`, ";border-right-width:0;border-bottom-width:0;padding:var(--ds-space-100, 8px);", (0, $7EdFW.browser).gecko || (0, $7EdFW.browser).ie || (0, $7EdFW.browser).mac && (0, $7EdFW.browser).chrome ? 'background-clip: padding-box;' : '', " ", $00ec34b4d6cfa8a7$var$firstNodeWithNotMarginTop(), " th p:not(:first-of-type),td p:not(:first-of-type){margin-top:var(--ds-space-150, 12px);}}>tbody>tr>td{background-color:var(--ds-surface, #FFFFFF);}th{background-color:", `var(--ds-background-accent-gray-subtlest, ${(0, $7yBx7.akEditorTableToolbar)})`, ";text-align:left;&:not([style]):not(.danger){.", (0, $gBkUB.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER, ":not(.danger){background-color:var(--ds-surface-raised, rgb(235, 237, 240));:not(.", (0, $7yBx7.akEditorSelectedNodeClassName), "){box-shadow:0px 0px 0px 1px var(--ds-border, transparent);}.", (0, $gBkUB.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER, "{background-image:", (0, $1rXAK.overflowShadow)({
        leftCoverWidth: "var(--ds-space-300, 24px)"
    }), ";background-color:var(--ds-background-neutral, rgb(235, 237, 240));}.", (0, $gBkUB.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER, "{background-color:var(--ds-background-neutral, rgb(226, 229, 233));}>[data-ds--code--code-block]{background-image:", (0, $1rXAK.overflowShadow)({
        leftCoverWidth: "var(--ds-space-300, 24px)"
    }), "!important;background-color:var(--ds-background-neutral, rgb(235, 237, 240))!important;/* selector lives inside @atlaskit/code */--ds--code--line-number-bg-color:var(--ds-background-neutral, rgb(226, 229, 233));}}}}}}");
const $00ec34b4d6cfa8a7$export$d7ece4d8beb06815 = (layout, containerWidth, addControllerPadding = true)=>{
    switch(layout){
        case 'full-width':
            return containerWidth ? Math.min(containerWidth - (addControllerPadding ? (0, $7yBx7.akEditorBreakoutPadding) : 0), (0, $7yBx7.akEditorFullWidthLayoutWidth)) : (0, $7yBx7.akEditorFullWidthLayoutWidth);
        case 'wide':
            if (containerWidth) return Math.min(containerWidth - (addControllerPadding ? (0, $7yBx7.akEditorBreakoutPadding) : 0), (0, $7yBx7.akEditorWideLayoutWidth));
            return 0, $7yBx7.akEditorWideLayoutWidth;
        default:
            return 'inherit';
    }
};

});
parcelRegister("1rXAK", function(module, exports) {

$parcel$export(module.exports, "overflowShadow", () => $46a467cbc6a60acf$export$c5c1e4f4640336fb);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");
const $46a467cbc6a60acf$export$c5c1e4f4640336fb = ({ leftCoverWidth: leftCoverWidth, rightCoverWidth: rightCoverWidth })=>{
    const width = "var(--ds-space-100, 8px)";
    const leftCoverWidthResolved = leftCoverWidth || width;
    const rightCoverWidthResolved = rightCoverWidth || width;
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    return /*#__PURE__*/ (0, $1NIU8.css)();
};

});

parcelRegister("gBkUB", function(module, exports) {

$parcel$export(module.exports, "CodeBlockSharedCssClassName", () => $560191ff43d42495$export$42659c26f026f6ea);
$parcel$export(module.exports, "codeBlockSharedStyles", () => $560191ff43d42495$export$a4fbe21dc6fae881);
$parcel$export(module.exports, "codeBlockInListSafariFix", () => $560191ff43d42495$export$3aa5ee2f4c156533);
/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression -- Should be safe to autofix, but ignoring for now */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $7yBx7 = parcelRequire("7yBx7");
var $1rXAK = parcelRequire("1rXAK");
const $560191ff43d42495$export$42659c26f026f6ea = {
    CODEBLOCK_CONTAINER: 'code-block',
    CODEBLOCK_START: 'code-block--start',
    CODEBLOCK_END: 'code-block--end',
    CODEBLOCK_CONTENT_WRAPPER: 'code-block-content-wrapper',
    CODEBLOCK_LINE_NUMBER_GUTTER: 'line-number-gutter',
    CODEBLOCK_CONTENT: 'code-content',
    DS_CODEBLOCK: '[data-ds--code--code-block]',
    CODEBLOCK_CONTENT_WRAPPED: 'code-content--wrapped',
    CODEBLOCK_CONTAINER_LINE_NUMBER_WIDGET: 'code-content__line-number--wrapped'
};
const $560191ff43d42495$export$a4fbe21dc6fae881 = ()=>/*#__PURE__*/ (0, $1NIU8.css)(".", $560191ff43d42495$export$42659c26f026f6ea.CODEBLOCK_CONTENT_WRAPPED, ">.", $560191ff43d42495$export$42659c26f026f6ea.CODEBLOCK_CONTENT_WRAPPER, ">.", $560191ff43d42495$export$42659c26f026f6ea.CODEBLOCK_CONTENT, "{margin-right:var(--ds-space-100, 8px);code{display:block;word-break:break-word;white-space:pre-wrap;}}.", $560191ff43d42495$export$42659c26f026f6ea.CODEBLOCK_CONTENT_WRAPPER, ">.", $560191ff43d42495$export$42659c26f026f6ea.CODEBLOCK_CONTENT, "{display:flex;flex:1;code{flex-grow:1;white-space:pre;}}.", $560191ff43d42495$export$42659c26f026f6ea.CODEBLOCK_CONTAINER, "{position:relative;background-color:var(--ds-surface-raised, #FFFFFF);border-radius:var(--ds-border-radius, 3px);margin:", (0, $7yBx7.blockNodesVerticalMargin), " 0 0 0;font-family:", (0, $7yBx7.akEditorCodeFontFamily), ";min-width:", (0, $7yBx7.akEditorTableCellMinWidth), "px;cursor:pointer;clear:both;white-space:normal;.code-block-gutter-pseudo-element::before{content:attr(data-label);}.", $560191ff43d42495$export$42659c26f026f6ea.CODEBLOCK_START, "{position:absolute;visibility:hidden;height:1.5rem;top:0px;left:0px;}.", $560191ff43d42495$export$42659c26f026f6ea.CODEBLOCK_END, "{position:absolute;visibility:hidden;height:1.5rem;bottom:0px;right:0px;}.", $560191ff43d42495$export$42659c26f026f6ea.CODEBLOCK_CONTENT_WRAPPER, "{position:relative;background-color:var(--ds-background-neutral, #091E420F);display:flex;border-radius:var(--ds-border-radius, 3px);width:100%;counter-reset:line;overflow-x:auto;background-image:", (0, $1rXAK.overflowShadow)({
        leftCoverWidth: "var(--ds-space-300, 24px)"
    }), ";background-repeat:no-repeat;background-attachment:local,local,local,local,scroll,scroll,scroll,scroll;background-size:var(--ds-space-300, 24px) 100%,var(--ds-space-300, 24px) 100%,var(--ds-space-100, 8px) 100%,var(--ds-space-100, 8px) 100%,var(--ds-space-100, 8px) 100%,1px 100%,var(--ds-space-100, 8px) 100%,1px 100%;background-position:0 0,0 0,100% 0,100% 0,100% 0,100% 0,0 0,0 0;overflow-y:hidden;}.", $560191ff43d42495$export$42659c26f026f6ea.CODEBLOCK_LINE_NUMBER_GUTTER, "{background-color:var(--ds-background-neutral, #091E420F);position:relative;width:var(--lineNumberGutterWidth, 2rem);padding:var(--ds-space-100, 8px);flex-shrink:0;font-size:", (0, $7yBx7.relativeFontSizeToBase16)(14), ";box-sizing:content-box;}.", $560191ff43d42495$export$42659c26f026f6ea.CODEBLOCK_LINE_NUMBER_GUTTER, "::before{content:'1';visibility:hidden;font-size:", (0, $7yBx7.relativeFontSizeToBase16)(14), ";line-height:1.5rem;}.", $560191ff43d42495$export$42659c26f026f6ea.CODEBLOCK_CONTENT, "{code{tab-size:4;cursor:text;color:var(--ds-text, #172B4D);border-radius:var(--ds-border-radius, 3px);margin:var(--ds-space-100, 8px);font-size:", (0, $7yBx7.relativeFontSizeToBase16)(14), ";line-height:1.5rem;}}.", $560191ff43d42495$export$42659c26f026f6ea.CODEBLOCK_CONTAINER_LINE_NUMBER_WIDGET, "{pointer-events:none;user-select:none;width:var(--lineNumberGutterWidth, 2rem);left:0;position:absolute;font-size:", (0, $7yBx7.relativeFontSizeToBase16)(14), ";padding:0px var(--ds-space-100, 8px);line-height:1.5rem;text-align:right;color:var(--ds-text-subtlest, #505F79);box-sizing:content-box;}}");
const $560191ff43d42495$export$3aa5ee2f4c156533 = /*#__PURE__*/ (0, $1NIU8.css)("::before{content:' ';line-height:", (0, $7yBx7.akEditorLineHeight), ";}>p:first-child,>.code-block:first-child,>.ProseMirror-gapcursor:first-child+.code-block{margin-top:-", (0, $7yBx7.akEditorLineHeight), "em!important;}");

});

parcelRegister("63wVg", function(module, exports) {

$parcel$export(module.exports, "tableCellBackgroundStyleOverride", () => $79d10202613a72be$export$677e93f0f5f9623a);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $e6HpD = parcelRequire("e6HpD");

var $kZPQ0 = parcelRequire("kZPQ0");
// This is used in order to support usage of DS tokens. Table cell background-color
// is set inline in '@atlaskit/adf-schema' and the color value is stored in ADF so
// it is not possible to use tokens there without polluting ADF.
// As table cell backgrounds are set inline, this should not break mobile as
// hexToEditorBackgroundPaletteColor() outputs a css variable with fallback hex.
const $79d10202613a72be$var$mapBackgroundColors = ()=>{
    let cssString = '';
    (0, $e6HpD.tableBackgroundColorNames).forEach((value, key)=>{
        const paletteColorValue = (0, $kZPQ0.hexToEditorBackgroundPaletteColor)(value);
        if (paletteColorValue) cssString += `
        td[colorname='${key}' i],
        th[colorname='${key}' i] {
          background-color: ${paletteColorValue} !important;
        }
      `;
    });
    return cssString;
};
const $79d10202613a72be$export$677e93f0f5f9623a = ()=>/*#__PURE__*/ (0, $1NIU8.css)($79d10202613a72be$var$mapBackgroundColors());

});
parcelRegister("kZPQ0", function(module, exports) {

$parcel$export(module.exports, "hexToEditorBackgroundPaletteColor", () => $d7ddc44a74c35e5a$export$5f6a44a42a4b38c2);
$parcel$export(module.exports, "hexToEditorBackgroundPaletteRawValue", () => $d7ddc44a74c35e5a$export$a270511a0e7fd61a);
// This import will be stripped on build

var $2On2D = parcelRequire("2On2D");
function $d7ddc44a74c35e5a$export$5f6a44a42a4b38c2(hexColor) {
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    const tokenData = $d7ddc44a74c35e5a$export$2462741d70e6a62f[hexColor.toUpperCase()];
    return tokenData ? tokenData.token : undefined;
}
function $d7ddc44a74c35e5a$export$a270511a0e7fd61a(hexColor) {
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    const tokenData = $d7ddc44a74c35e5a$export$2462741d70e6a62f[hexColor.toUpperCase()];
    return tokenData ? tokenData.getValue(hexColor) : undefined;
}
const $d7ddc44a74c35e5a$export$2462741d70e6a62f = {
    // blue
    /** blue - light */ ['#DEEBFF']: {
        getValue: (fallback)=>(0, $2On2D.default)('color.background.accent.blue.subtlest', fallback),
        token: "var(--ds-background-accent-blue-subtlest, #DEEBFF)"
    },
    // source for hex code was legacy token B50
    /** blue - medium */ ['#B3D4FF']: {
        getValue: (fallback)=>(0, $2On2D.default)('color.background.accent.blue.subtler', fallback),
        token: "var(--ds-background-accent-blue-subtler, #B3D4FF)"
    },
    // source for hex code was legacy token B75
    /** blue - strong */ ['#4C9AFF']: {
        getValue: (fallback)=>(0, $2On2D.default)('color.background.accent.blue.subtle', fallback),
        token: "var(--ds-background-accent-blue-subtle, #4C9AFF)"
    },
    // source for hex code was legacy token B100
    // teal
    /** teal - light */ ['#E6FCFF']: {
        getValue: (fallback)=>(0, $2On2D.default)('color.background.accent.teal.subtlest', fallback),
        token: "var(--ds-background-accent-teal-subtlest, #E6FCFF)" // source for hex code was legacy token T50,
    },
    /** teal - medium */ ['#B3F5FF']: {
        getValue: (fallback)=>(0, $2On2D.default)('color.background.accent.teal.subtler', fallback),
        token: "var(--ds-background-accent-teal-subtler, #B3F5FF)" // source for hex code was legacy token T75,
    },
    /** teal - strong */ ['#79E2F2']: {
        getValue: (fallback)=>(0, $2On2D.default)('color.background.accent.teal.subtle', fallback),
        token: "var(--ds-background-accent-teal-subtle, #79E2F2)" // source for hex code was legacy token T100,
    },
    // green
    /** green - light */ ['#E3FCEF']: {
        getValue: (fallback)=>(0, $2On2D.default)('color.background.accent.green.subtlest', fallback),
        token: "var(--ds-background-accent-green-subtlest, #E3FCEF)" // source for hex code was legacy token G50,
    },
    /** green - medium */ ['#ABF5D1']: {
        getValue: (fallback)=>(0, $2On2D.default)('color.background.accent.green.subtler', fallback),
        token: "var(--ds-background-accent-green-subtler, #ABF5D1)" // source for hex code was legacy token G75,
    },
    /** green - strong */ ['#57D9A3']: {
        getValue: (fallback)=>(0, $2On2D.default)('color.background.accent.green.subtle', fallback),
        token: "var(--ds-background-accent-green-subtle, #57D9A3)" // source for hex code was legacy token G200,
    },
    // yellowOrange
    /** yellowOrange - light */ ['#FFFAE6']: {
        getValue: (fallback)=>(0, $2On2D.default)('color.background.accent.yellow.subtlest', fallback),
        token: "var(--ds-background-accent-yellow-subtlest, #FFFAE6)" // source for hex code was legacy token Y50,
    },
    /** yellowOrange - medium */ ['#FFF0B3']: {
        getValue: (fallback)=>(0, $2On2D.default)('color.background.accent.yellow.subtler', fallback),
        token: "var(--ds-background-accent-yellow-subtler, #FFF0B3)" // source for hex code was legacy token Y75,
    },
    /** yellowOrange - strong */ ['#FFC400']: {
        getValue: (fallback)=>(0, $2On2D.default)('color.background.accent.orange.subtle', fallback),
        token: "var(--ds-background-accent-orange-subtle, #FFC400)" // source for hex code was legacy token Y200,
    },
    // red
    /** red - light */ ['#FFEBE6']: {
        getValue: (fallback)=>(0, $2On2D.default)('color.background.accent.red.subtlest', fallback),
        token: "var(--ds-background-accent-red-subtlest, #FFEBE6)" // source for hex code was legacy token R50,
    },
    /** red - medium */ ['#FFBDAD']: {
        getValue: (fallback)=>(0, $2On2D.default)('color.background.accent.red.subtler', fallback),
        token: "var(--ds-background-accent-red-subtler, #FFBDAD)" // source for hex code was legacy token R75,
    },
    /** red - strong */ ['#FF8F73']: {
        getValue: (fallback)=>(0, $2On2D.default)('color.background.accent.red.subtle', fallback),
        token: "var(--ds-background-accent-red-subtle, #FF8F73)" // source for hex code was legacy token R100,
    },
    // purple
    /** purple - light */ ['#EAE6FF']: {
        getValue: (fallback)=>(0, $2On2D.default)('color.background.accent.purple.subtlest', fallback),
        token: "var(--ds-background-accent-purple-subtlest, #EAE6FF)" // source for hex code was legacy token P50,
    },
    /** purple - medium */ ['#C0B6F2']: {
        getValue: (fallback)=>(0, $2On2D.default)('color.background.accent.purple.subtler', fallback),
        token: "var(--ds-background-accent-purple-subtler, #C0B6F2)" // source for hex code was legacy token P75,
    },
    /** purple - strong */ ['#998DD9']: {
        getValue: (fallback)=>(0, $2On2D.default)('color.background.accent.purple.subtle', fallback),
        token: "var(--ds-background-accent-purple-subtle, #998DD9)" // source for hex code was legacy token P100,
    },
    // whiteGray
    /** whiteGray - light */ ['#FFFFFF']: {
        getValue: (fallback)=>(0, $2On2D.default)('elevation.surface', fallback),
        token: "var(--ds-surface, #FFFFFF)" // source for hex code was legacy token N0,
    },
    /** whiteGray - medium */ ['#F4F5F7']: {
        getValue: (fallback)=>(0, $2On2D.default)('color.background.accent.gray.subtlest', fallback),
        token: "var(--ds-background-accent-gray-subtlest, #F4F5F7)" // source for hex code was legacy token N20,
    },
    /** whiteGray - strong */ ['#B3BAC5']: {
        getValue: (fallback)=>(0, $2On2D.default)('color.background.accent.gray.subtle', fallback),
        token: "var(--ds-background-accent-gray-subtle, #B3BAC5)" // source for hex code was legacy token N60,
    }
};

});



parcelRegister("d3BBj", function(module, exports) {

$parcel$export(module.exports, "compose", () => $cebdc4ee82f37b00$export$f672e0b6f7222cd7);
/** Helper type for single arg function */ function $cebdc4ee82f37b00$export$f672e0b6f7222cd7(func, ...funcs) {
    const allFuncs = [
        func,
        ...funcs
    ];
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function composed(raw) {
        return allFuncs.reduceRight((memo, func)=>func(memo), raw);
    };
}

});

parcelRegister("bTpHi", function(module, exports) {

$parcel$export(module.exports, "getColumnWidths", () => $6086fc23ae8f0d14$export$e54c9225ca52acc);
$parcel$export(module.exports, "calcTableColumnWidths", () => $6086fc23ae8f0d14$export$98951d3cdcfd364b);
$parcel$export(module.exports, "hasMergedCell", () => $6086fc23ae8f0d14$export$f9d610bfbb78949b);
$parcel$export(module.exports, "convertProsemirrorTableNodeToArrayOfRows", () => $6086fc23ae8f0d14$export$69fbfaf01f2fd534);
$parcel$export(module.exports, "isPositionNearTableRow", () => $6086fc23ae8f0d14$export$889a8e446452be16);
function $6086fc23ae8f0d14$export$e54c9225ca52acc(node) {
    let tableColumnWidths = [];
    node.forEach((row)=>{
        const currentTableWidth = [];
        row.forEach((cell)=>{
            const { colspan: colspan, colwidth: colwidth } = cell.attrs;
            // column has been resized, colWidth will be an array, can safely take values even if cell is merged
            if (Array.isArray(colwidth)) currentTableWidth.push(...colwidth);
            else if (colspan !== undefined && colspan > 1) currentTableWidth.push(...Array(colspan).fill(0));
            else currentTableWidth.push(0);
        });
        if (currentTableWidth.length > tableColumnWidths.length) tableColumnWidths = currentTableWidth;
    });
    return tableColumnWidths;
}
function $6086fc23ae8f0d14$export$98951d3cdcfd364b(node) {
    const firstRow = node.firstChild;
    const tableColumnWidths = [];
    if (firstRow) firstRow.forEach((cell)=>{
        const { colspan: colspan, colwidth: colwidth } = cell.attrs;
        // column has been resized, colWidth will be an array, can safely take values even if cell is merged
        if (Array.isArray(colwidth)) tableColumnWidths.push(...colwidth);
        else if (colspan > 1) tableColumnWidths.push(...Array(colspan).fill(0));
        else tableColumnWidths.push(0);
    });
    return tableColumnWidths;
}
function $6086fc23ae8f0d14$export$f9d610bfbb78949b(tableNode) {
    let hasSpan = false;
    tableNode.descendants((node)=>{
        if (node.type.name === 'tableRow') return true;
        const { colspan: colspan, rowspan: rowspan } = node.attrs;
        if (colspan > 1 || rowspan > 1) hasSpan = true;
        return false;
    });
    return hasSpan;
}
function $6086fc23ae8f0d14$export$69fbfaf01f2fd534(tableNode) {
    const result = [];
    tableNode.forEach((rowNode)=>{
        if (rowNode.type.name === 'tableRow') {
            const row = [];
            rowNode.forEach((n)=>row.push(n));
            result.push(row);
        }
    });
    return result;
}
function $6086fc23ae8f0d14$export$889a8e446452be16(pos, schema, direction) {
    if (!schema.nodes.tableRow) return false;
    const doc = pos.doc;
    let resolved = pos;
    const sibling = direction === 'before' ? 'nodeBefore' : 'nodeAfter';
    while(resolved.depth > 0){
        const siblingType = resolved[sibling]?.type;
        if (siblingType === schema.nodes.tableRow) return true;
        resolved = doc.resolve(resolved[direction]());
    }
    return false;
}

});

parcelRegister("gikGJ", function(module, exports) {

$parcel$export(module.exports, "createCompareNodes", () => $2cd578ee4d14df78$export$49215374a8bec29c);

var $hh2CV = parcelRequire("hh2CV");
var $2cd578ee4d14df78$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType[ContentType["NUMBER"] = 0] = "NUMBER";
    ContentType[ContentType["TEXT"] = 5] = "TEXT";
    ContentType[ContentType["MENTION"] = 10] = "MENTION";
    ContentType[ContentType["DATE"] = 15] = "DATE";
    ContentType[ContentType["STATUS"] = 20] = "STATUS";
    ContentType[ContentType["LINK"] = 25] = "LINK";
    return ContentType;
}({});
function $2cd578ee4d14df78$var$getLinkMark(node) {
    const [linkMark] = node.marks.filter((mark)=>mark.type.name === 'link');
    return linkMark || null;
}
function $2cd578ee4d14df78$var$parseLocaleNumber(stringNumber, groupPattern, fractionPattern) {
    if (!stringNumber.trim().length) return null;
    const maybeANumber = Number.parseFloat(stringNumber.replace(groupPattern, '').replace(fractionPattern, '.'));
    if (Number.isNaN(maybeANumber)) return null;
    return maybeANumber;
}
function $2cd578ee4d14df78$export$8ebf986086b1866f() {
    // Source: https://stackoverflow.com/questions/12004808/does-javascript-take-local-decimal-separators-into-account
    const locale = window.navigator.language;
    const thousandSeparator = Intl.NumberFormat(locale).format(11111).replace(/\p{Number}/gu, '');
    const decimalSeparator = Intl.NumberFormat(locale).format(1.1).replace(/\p{Number}/gu, '');
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const numericPattern = new RegExp(`(\\d+(?:[${thousandSeparator}${decimalSeparator}]?\\d+)*)`, 'g');
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const thousandSeparatorPattern = new RegExp('\\' + thousandSeparator, 'g');
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const decimalSeparatorPattern = new RegExp('\\' + decimalSeparator);
    return (text)=>{
        if (!text.trim().length) return null;
        // This will break the text apart at the locations of the formatted numbers
        const result = text.split(numericPattern);
        // We then put the text back together but with all the formatted numbers converted back to plain numerals,
        // for example a sentence like "What is 1,000.01% of 10,000.01" would be normalized and sorted as
        // if it's saying "What is 1000.01% of 10000.01". This way the Intl.Collator can use the numeric setting to sort
        // numeral values within string correctly.
        const tokens = result.reduce((acc, stringNumber)=>{
            if (!stringNumber?.length) return acc;
            const maybeANumber = $2cd578ee4d14df78$var$parseLocaleNumber(stringNumber, thousandSeparatorPattern, decimalSeparatorPattern);
            // NOTE: We know there can only be a single decimal separator. So we can assume that if the first found separator
            // is not at the same position as the last found one, then we can assume the locale used to format the number
            // is different to our locale. This will result in the value being treated as a string.
            if (maybeANumber !== null && stringNumber.indexOf(decimalSeparator) === stringNumber.lastIndexOf(decimalSeparator)) acc.push(maybeANumber);
            else acc.push(stringNumber);
            return acc;
        }, []);
        if (tokens.length === 1) return tokens[0];
        return tokens.join('');
    };
}
function $2cd578ee4d14df78$export$7cc053f549ed70b8(textNode, normalizeTextParser) {
    // treat as a link if contain a link
    const linkMark = $2cd578ee4d14df78$var$getLinkMark(textNode);
    if (linkMark) {
        const value = textNode.text || '';
        return {
            type: 25,
            value: value
        };
    }
    const text = textNode.text || '';
    const normalizedText = normalizeTextParser(text);
    if (typeof normalizedText === 'number') return {
        type: 0,
        value: normalizedText
    };
    return {
        type: 5,
        value: normalizedText ?? text
    };
}
function $2cd578ee4d14df78$var$getMetaFromNode(node, options, normalizeTextParser) {
    if (!node) return null;
    const firstChild = node.firstChild;
    if (!firstChild) return null;
    switch(firstChild.type.name){
        // Text case
        /*
      Get Meta value from the first child if the cell is of type
        * Heading (Any cell where the text is set to a heading type)
        * Paragraph (Normal text)
     */ case 'heading':
        case 'paragraph':
            return $2cd578ee4d14df78$var$getMetaFromNode(firstChild, options, normalizeTextParser);
        case 'inlineCard':
            {
                const attrs = firstChild.attrs;
                const maybeTitle = options.getInlineCardTextFromStore(attrs);
                if (maybeTitle) return {
                    type: 25,
                    value: maybeTitle
                };
                const url = attrs.url;
                return {
                    type: 25,
                    value: url ? url : ''
                };
            }
        case 'text':
            return $2cd578ee4d14df78$export$7cc053f549ed70b8(firstChild, normalizeTextParser);
        case 'status':
            {
                const text = firstChild.attrs.text;
                return {
                    type: 20,
                    value: text
                };
            }
        case 'date':
            {
                const timestamp = Number.parseInt(firstChild.attrs.timestamp, 20);
                return {
                    type: 15,
                    value: timestamp
                };
            }
        case 'mention':
            {
                const text = firstChild.attrs.text || '';
                return {
                    type: 10,
                    value: text.toLowerCase()
                };
            }
        default:
            return null;
    }
}
function $2cd578ee4d14df78$var$compareValue(valueA, valueB) {
    if (valueA === valueB) return 0;
    if (typeof valueA === 'string' && typeof valueB === 'string') return valueA.localeCompare(valueB, window.navigator.language, {
        caseFirst: 'upper',
        numeric: true
    });
    return valueA > valueB ? 1 : -1;
}
const $2cd578ee4d14df78$export$49215374a8bec29c = (options, order = (0, $hh2CV.SortOrder).ASC)=>{
    const normalizeTextParser = $2cd578ee4d14df78$export$8ebf986086b1866f();
    return (nodeA, nodeB)=>{
        const metaNodeA = $2cd578ee4d14df78$var$getMetaFromNode(nodeA, options, normalizeTextParser);
        const metaNodeB = $2cd578ee4d14df78$var$getMetaFromNode(nodeB, options, normalizeTextParser);
        /*
      Donot switch the order (Asec or Desc) if either node is null.
      This will ensure that empty cells are always at the bottom during sorting.
    */ if (metaNodeA === null || metaNodeB === null) return $2cd578ee4d14df78$var$compareMetaFromNode(metaNodeA, metaNodeB);
        return (order === (0, $hh2CV.SortOrder).DESC ? -1 : 1) * $2cd578ee4d14df78$var$compareMetaFromNode(metaNodeA, metaNodeB);
    };
};
function $2cd578ee4d14df78$var$compareMetaFromNode(metaNodeA, metaNodeB) {
    if (metaNodeA === metaNodeB) return 0;
    if (metaNodeA === null || metaNodeB === null) return metaNodeB === null ? -1 : 1;
    if (metaNodeA.type !== metaNodeB.type) return metaNodeA.type > metaNodeB.type ? 1 : -1;
    return $2cd578ee4d14df78$var$compareValue(metaNodeA.value, metaNodeB.value);
}

});
parcelRegister("hh2CV", function(module, exports) {

$parcel$export(module.exports, "SortOrder", () => $026f7cd52e6b22e7$export$7ae723045d45777a);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $4Fc33 = parcelRequire("4Fc33");

var $aBsWC = parcelRequire("aBsWC");
var $026f7cd52e6b22e7$export$7ae723045d45777a = /*#__PURE__*/ function(SortOrder) {
    SortOrder["ASC"] = "asc";
    SortOrder["DESC"] = "desc";
    SortOrder["NO_ORDER"] = "no_order";
    return SortOrder;
}({});

});
parcelRegister("aBsWC", function(module, exports) {

$parcel$export(module.exports, "ToolbarSize", () => $639c7867308be22b$export$ed55211407a9423);
$parcel$export(module.exports, "ToolbarWidths", () => $639c7867308be22b$export$423b5e8c92d477b9);
$parcel$export(module.exports, "ToolbarWidthsNext", () => $639c7867308be22b$export$3f050002d3df641b);
$parcel$export(module.exports, "ToolbarWidthsFullPage", () => $639c7867308be22b$export$63ca43752be70b90);
$parcel$export(module.exports, "ToolbarWidthsFullPageNext", () => $639c7867308be22b$export$501a79d885598191);
var $639c7867308be22b$export$ed55211407a9423 = /*#__PURE__*/ function(ToolbarSize) {
    ToolbarSize[ToolbarSize["XXL"] = 6] = "XXL";
    ToolbarSize[ToolbarSize["XL"] = 5] = "XL";
    ToolbarSize[ToolbarSize["L"] = 4] = "L";
    ToolbarSize[ToolbarSize["M"] = 3] = "M";
    ToolbarSize[ToolbarSize["S"] = 2] = "S";
    ToolbarSize[ToolbarSize["XXXS"] = 1] = "XXXS";
    return ToolbarSize;
}({});
var $639c7867308be22b$export$423b5e8c92d477b9 = /*#__PURE__*/ function(ToolbarWidths) {
    ToolbarWidths[ToolbarWidths["XXL"] = 610] = "XXL";
    ToolbarWidths[ToolbarWidths["XL"] = 540] = "XL";
    ToolbarWidths[ToolbarWidths["L"] = 460] = "L";
    ToolbarWidths[ToolbarWidths["M"] = 450] = "M";
    ToolbarWidths[ToolbarWidths["S"] = 410] = "S";
    return ToolbarWidths;
}({});
var $639c7867308be22b$export$3f050002d3df641b = /*#__PURE__*/ function(ToolbarWidthsNext) {
    ToolbarWidthsNext[ToolbarWidthsNext["XXL"] = 768] = "XXL";
    ToolbarWidthsNext[ToolbarWidthsNext["XL"] = 576] = "XL";
    ToolbarWidthsNext[ToolbarWidthsNext["L"] = 460] = "L";
    ToolbarWidthsNext[ToolbarWidthsNext["M"] = 450] = "M";
    ToolbarWidthsNext[ToolbarWidthsNext["S"] = 410] = "S";
    return ToolbarWidthsNext;
}({});
var $639c7867308be22b$export$63ca43752be70b90 = /*#__PURE__*/ function(ToolbarWidthsFullPage) {
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["XXL"] = 650] = "XXL";
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["XL"] = 580] = "XL";
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["L"] = 540] = "L";
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["M"] = 490] = "M";
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["S"] = 410] = "S";
    return ToolbarWidthsFullPage;
}({});
var $639c7867308be22b$export$501a79d885598191 = /*#__PURE__*/ function(ToolbarWidthsFullPageNext) {
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["XXL"] = 1200] = "XXL";
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["XL"] = 992] = "XL";
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["L"] = 768] = "L";
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["M"] = 576] = "M";
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["S"] = 410] = "S";
    return ToolbarWidthsFullPageNext;
}({});

});



parcelRegister("68RqK", function(module, exports) {

$parcel$export(module.exports, "layoutToWidth", () => $0996654c31bce5a9$export$9b77d38feba5446);
$parcel$export(module.exports, "getParentNodeWidth", () => $0996654c31bce5a9$export$d76cc081ce1449a8);
$parcel$export(module.exports, "getTableContainerWidth", () => $0996654c31bce5a9$export$3930799be057b305);

var $BmspC = parcelRequire("BmspC");

var $7yBx7 = parcelRequire("7yBx7");

var $2smsR = parcelRequire("2smsR");

var $2onoM = parcelRequire("2onoM");

var $cjLtO = parcelRequire("cjLtO");

var $bnh3n = parcelRequire("bnh3n");
const $0996654c31bce5a9$var$GRID_SIZE = 8;
const $0996654c31bce5a9$export$9b77d38feba5446 = {
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    default: (0, $7yBx7.akEditorDefaultLayoutWidth),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    wide: (0, $7yBx7.akEditorWideLayoutWidth),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    'full-width': (0, $7yBx7.akEditorFullWidthLayoutWidth)
};
const $0996654c31bce5a9$export$d76cc081ce1449a8 = (pos, state, containerWidth, isFullWidthModeEnabled)=>{
    if (!pos) return;
    const node = $0996654c31bce5a9$var$getNestedParentNode(pos, state);
    if (!node) return;
    let layout = node.attrs.layout || 'default';
    const { schema: schema } = state;
    const breakoutMark = schema.marks.breakout && schema.marks.breakout.isInSet(node.marks);
    if (breakoutMark && breakoutMark.attrs.mode) layout = breakoutMark.attrs.mode;
    let parentWidth = $0996654c31bce5a9$var$calcBreakoutNodeWidth(layout, containerWidth, isFullWidthModeEnabled);
    // Please, do not copy or use this kind of code below
    // @ts-ignore
    const contextPanelPluginKey = {
        key: 'contextPanelPluginKey$',
        getState: (state)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return state['contextPanelPluginKey$'];
        }
    };
    switch(node.type){
        case schema.nodes.layoutSection:
            parentWidth += (0, $7yBx7.akLayoutGutterOffset) * 2; // extra width that gets added to layout
            // Calculate width of parent layout column when
            // Parallel layout with viewport greater than 1024px
            // OR side panel of an extension is open and change the node width to smaller than containerWidth
            if (containerWidth.width > (0, $7yBx7.gridMediumMaxWidth) || contextPanelPluginKey.getState(state)?.contents.length > 0 && contextPanelPluginKey.getState(state)?.contents[0] !== undefined) {
                parentWidth -= ((0, $2onoM.LAYOUT_SECTION_MARGIN) + 2) * (node.childCount - 1); // margin between sections
                const $pos = state.doc.resolve(pos);
                const column = (0, $BmspC.findParentNodeOfTypeClosestToPos)($pos, [
                    state.schema.nodes.layoutColumn
                ]);
                if (column && column.node && !isNaN(column.node.attrs.width)) // get exact width of parent layout column using node attrs
                parentWidth = Math.round(parentWidth * column.node.attrs.width * 0.01);
            }
            // account for the padding of the parent node
            parentWidth -= (0, $2onoM.LAYOUT_COLUMN_PADDING) * 2;
            break;
        case schema.nodes.bodiedExtension:
            parentWidth -= (0, $2smsR.BODIED_EXT_PADDING) * 2;
            break;
        case schema.nodes.extensionFrame:
            parentWidth -= (0, $2smsR.BODIED_EXT_PADDING) * 2;
            break;
        case schema.nodes.expand:
            // padding
            parentWidth -= $0996654c31bce5a9$var$GRID_SIZE * 2;
            // gutter offset
            parentWidth += $0996654c31bce5a9$var$GRID_SIZE * 3;
            // padding right
            parentWidth -= $0996654c31bce5a9$var$GRID_SIZE;
            // padding left
            parentWidth -= $0996654c31bce5a9$var$GRID_SIZE * 4 - $0996654c31bce5a9$var$GRID_SIZE / 2;
            break;
        case schema.nodes.tableCell:
        case schema.nodes.tableHeader:
            // Calculate the available column width
            if (Array.isArray(node.attrs.colwidth)) parentWidth = node.attrs.colwidth.slice(0, node.attrs.colspan).reduce((sum, width)=>sum + width, 0);
            // Compensate for padding
            parentWidth -= (0, $cjLtO.tableCellPadding) * 2;
            break;
    }
    parentWidth -= 2; // border
    return parentWidth;
};
const $0996654c31bce5a9$var$getNestedParentNode = (tablePos, state)=>{
    if (tablePos === undefined) return null;
    const $pos = state.doc.resolve(tablePos);
    const parent = (0, $BmspC.findParentNodeOfTypeClosestToPos)($pos, [
        state.schema.nodes.bodiedExtension,
        state.schema.nodes.extensionFrame,
        state.schema.nodes.layoutSection,
        state.schema.nodes.expand,
        state.schema.nodes.tableCell,
        state.schema.nodes.tableHeader
    ]);
    return parent ? parent.node : null;
};
const $0996654c31bce5a9$var$calcBreakoutNodeWidth = (layout, containerWidth, isFullWidthModeEnabled)=>{
    return isFullWidthModeEnabled ? Math.min(containerWidth.lineLength, (0, $7yBx7.akEditorFullWidthLayoutWidth)) : (0, $bnh3n.absoluteBreakoutWidth)(layout, containerWidth.width);
};
const $0996654c31bce5a9$export$3930799be057b305 = (node)=>{
    if (node?.attrs.width) return node.attrs.width;
    return $0996654c31bce5a9$export$9b77d38feba5446[node?.attrs.layout] || (0, $7yBx7.akEditorDefaultLayoutWidth);
};
const $0996654c31bce5a9$export$9724081a0d43786a = (node, offset)=>{
    const isNumberColumnEnabled = node.attrs.isNumberColumnEnabled;
    if (isNumberColumnEnabled && offset > 0) return $0996654c31bce5a9$export$3930799be057b305(node) - offset;
    return $0996654c31bce5a9$export$3930799be057b305(node);
};

});
parcelRegister("2smsR", function(module, exports) {

$parcel$export(module.exports, "BODIED_EXT_PADDING", () => $811b7408671269e7$export$5ac5087fe1217160);
$parcel$export(module.exports, "BODIED_EXT_MBE_MARGIN_TOP", () => $811b7408671269e7$export$91624ec52c59c24c);
const $811b7408671269e7$export$f5ecdce4c60ff98b = 8;
const $811b7408671269e7$export$5ac5087fe1217160 = $811b7408671269e7$export$f5ecdce4c60ff98b * 2;
const $811b7408671269e7$export$91624ec52c59c24c = 12;

});

parcelRegister("2onoM", function(module, exports) {

$parcel$export(module.exports, "LAYOUT_SECTION_MARGIN", () => $916997c92af17d95$export$cd04f19842abff0);
$parcel$export(module.exports, "LAYOUT_COLUMN_PADDING", () => $916997c92af17d95$export$a1bb91aa2d5fcce8);
const $916997c92af17d95$export$cd04f19842abff0 = 8;
const $916997c92af17d95$export$a1bb91aa2d5fcce8 = $916997c92af17d95$export$cd04f19842abff0 * 1.5;

});


const $9a762f515f769003$export$12fd658e5eef0d79 = 32;
const $9a762f515f769003$export$74b525449cc7cbd1 = 'ai-streaming-telepointer';

parcelRegister("lzf9g", function(module, exports) {

$parcel$export(module.exports, "TableHeader", () => $63cf8e5030b59364$export$f850895b287ef28e);
$parcel$export(module.exports, "TableCell", () => $63cf8e5030b59364$export$1e4baea7053fc0e3);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $4PpDP = parcelRequire("4PpDP");
var $e6HpD = parcelRequire("e6HpD");

var $58yRG = parcelRequire("58yRG");

var $hh2CV = parcelRequire("hh2CV");

var $kZPQ0 = parcelRequire("kZPQ0");

var $169DZ = parcelRequire("169DZ");

var $7ueoK = parcelRequire("7ueoK");

var $bMFKb = parcelRequire("bMFKb");

var $iRC0e = parcelRequire("iRC0e");

var $lRq8t = parcelRequire("lRq8t");

var $4Iw1X = parcelRequire("4Iw1X");
const $63cf8e5030b59364$var$IgnoreSorting = [
    'LABEL',
    'INPUT'
];
const $63cf8e5030b59364$var$nextStatusOrder = (currentSortOrder)=>{
    switch(currentSortOrder){
        case (0, $hh2CV.SortOrder).NO_ORDER:
            return (0, $hh2CV.SortOrder).ASC;
        case (0, $hh2CV.SortOrder).ASC:
            return (0, $hh2CV.SortOrder).DESC;
        case (0, $hh2CV.SortOrder).DESC:
            return (0, $hh2CV.SortOrder).NO_ORDER;
    }
    return (0, $hh2CV.SortOrder).NO_ORDER;
};
const $63cf8e5030b59364$var$getSortOrderLabel = (intl, currentSortOrder)=>{
    const { noneSortingLabel: noneSortingLabel, ascSortingLabel: ascSortingLabel, descSortingLabel: descSortingLabel } = (0, $4Iw1X.tableCellMessages);
    switch(currentSortOrder){
        case (0, $hh2CV.SortOrder).NO_ORDER:
            return intl.formatMessage(noneSortingLabel);
        case (0, $hh2CV.SortOrder).ASC:
            return intl.formatMessage(ascSortingLabel);
        case (0, $hh2CV.SortOrder).DESC:
            return intl.formatMessage(descSortingLabel);
        default:
            return intl.formatMessage(noneSortingLabel);
    }
};
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $63cf8e5030b59364$var$getDataAttributes = (colwidth, background)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const attrs = {};
    if (colwidth) attrs['data-colwidth'] = colwidth.join(',');
    /**
   * Storing hex code in data-cell-background because
   *  we want to have DST token (css variable) or
   *  DST token value (value (hex code) of css variable) in
   *  inline style to correct render table cell background
   *  based on selected theme.
   * Currently we rely on background color hex code stored in
   *  inline style.
   * Because of that when we copy and paste table, we end up
   *  having DST token or DST token value in ADF instead of
   *  original hex code which we map to DST token.
   * So, introducing data-cell-background.
   * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
   */ if (background) attrs['data-cell-background'] = background;
    return attrs;
};
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $63cf8e5030b59364$var$cssVariablePattern = /^var\(--.*\)$/;
const $63cf8e5030b59364$var$getStyle = ({ background: background, colGroupWidth: colGroupWidth, offsetTop: offsetTop, colorMode: colorMode })=>{
    const style = {};
    if (background && // ignore setting inline styles if ds neutral token is detected
    !background.includes('--ds-background-neutral')) {
        /**
     * The Editor supports users pasting content from external sources with custom table cell backgrounds and having those
     * backgrounds persisted.
     *
     * This feature predates the introduction of dark mode.
     *
     * Without the inversion logic below, tokenised content (ie. text), can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom background color when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect table cell background colors copied from external editor sources. Where we load the background color from a
     * seperate attribute (data-cell-background), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2892247168/Unsupported+custom+table+cell+background+colors+in+dark+theme+Editor+Job+Story
     */ const tokenColor = (0, $kZPQ0.hexToEditorBackgroundPaletteRawValue)(background);
        if (tokenColor) style.backgroundColor = tokenColor;
        else if (/**
     * There was previously a bug in dark mode where we would attempt to invert
     * a design token in `getDarkModeLCHColor` causing issues.
     * If it's a design token we should return it as is.
     */ $63cf8e5030b59364$var$cssVariablePattern.test(background)) style.backgroundColor = background;
        else // if we have a custom color, we need to check if we are in dark mode
        if (colorMode === 'dark') // if we are in dark mode, we need to invert the color
        style.backgroundColor = (0, $4PpDP.getDarkModeLCHColor)(background);
        else // if we are in light mode, we can just set the color
        style.backgroundColor = background;
    }
    if (colGroupWidth) {
        style.width = colGroupWidth;
        style.minWidth = colGroupWidth;
    }
    if (offsetTop !== undefined) style.top = offsetTop;
    return style;
};
const $63cf8e5030b59364$var$getWithCellProps = (WrapperComponent)=>{
    return function WithCellProps(props) {
        const { colorMode: colorMode } = (0, $58yRG.default)();
        const { children: children, className: className, onClick: onClick, colwidth: colwidth, colGroupWidth: colGroupWidth, rowspan: rowspan, colspan: colspan, background: background, offsetTop: offsetTop, ariaSort: ariaSort } = props;
        // This is used to set the background color of the cell
        // to a dark mode color in mobile dark mode
        const colorName = background ? (0, $e6HpD.tableBackgroundColorPalette).get(background) : '';
        return /*#__PURE__*/ (0, $gt9Am.jsx)(WrapperComponent, {
            rowSpan: rowspan,
            colSpan: colspan,
            // Note: When content from a renderer is pasted into an editor
            // the background color is not taken from the inline style.
            // Instead it is taken from the data-cell-background attribute
            // (added via getDataAttributes below).
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: $63cf8e5030b59364$var$getStyle({
                background: background,
                colGroupWidth: colGroupWidth,
                offsetTop: offsetTop,
                colorMode: colorMode
            }),
            colorname: colorName,
            onClick: onClick,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ...$63cf8e5030b59364$var$getDataAttributes(colwidth, background),
            "aria-sort": ariaSort,
            children: children
        });
    };
};
const $63cf8e5030b59364$var$TH = $63cf8e5030b59364$var$getWithCellProps('th');
const $63cf8e5030b59364$export$cfca40ca5c56a38e = (WrapperComponent)=>{
    return function THWithSortableColumn(props) {
        const intl = (0, $lRq8t.default)();
        const { allowColumnSorting: allowColumnSorting, onSorting: onSorting, children: children, sortOrdered: sortOrdered, isHeaderRow: isHeaderRow } = props;
        const sortOrderedClassName = sortOrdered === (0, $hh2CV.SortOrder).NO_ORDER ? (0, $iRC0e.RendererCssClassName).SORTABLE_COLUMN_NO_ORDER : '';
        if (!allowColumnSorting || !isHeaderRow) // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, $gt9Am.jsx)(WrapperComponent, {
            ...props
        });
        return /*#__PURE__*/ (0, $gt9Am.jsx)(WrapperComponent, {
            ...props,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $iRC0e.RendererCssClassName).SORTABLE_COLUMN_WRAPPER,
            ariaSort: $63cf8e5030b59364$var$getSortOrderLabel(intl, sortOrdered),
            children: /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
                className: (0, $iRC0e.RendererCssClassName).SORTABLE_COLUMN,
                children: [
                    children,
                    /*#__PURE__*/ (0, $gt9Am.jsx)("figure", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: `${(0, $iRC0e.RendererCssClassName).SORTABLE_COLUMN_ICON_WRAPPER} ${sortOrderedClassName}`,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $169DZ.default), {
                            isSortingAllowed: !!onSorting,
                            sortOrdered: sortOrdered,
                            onClick: sort,
                            onKeyDown: onKeyPress
                        })
                    })
                ]
            })
        });
        function onKeyPress(event) {
            const keys = [
                ' ',
                'Enter',
                'Spacebar'
            ];
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            const { tagName: tagName } = event.target;
            // trigger sorting if space or enter are clicked but not when in an input field (template variables)
            if (keys.includes(event.key) && !$63cf8e5030b59364$var$IgnoreSorting.includes(tagName)) {
                event.preventDefault();
                sort();
            }
        }
        function sort() {
            const { fireAnalyticsEvent: fireAnalyticsEvent, onSorting: onSorting, columnIndex: columnIndex, sortOrdered: sortOrdered } = props;
            if (onSorting && columnIndex != null) {
                const sortOrder = $63cf8e5030b59364$var$nextStatusOrder(sortOrdered);
                onSorting(columnIndex, sortOrder);
                fireAnalyticsEvent && fireAnalyticsEvent({
                    action: (0, $bMFKb.ACTION).SORT_COLUMN,
                    actionSubject: (0, $bMFKb.ACTION_SUBJECT).TABLE,
                    attributes: {
                        platform: (0, $7ueoK.PLATFORM).WEB,
                        mode: (0, $7ueoK.MODE).RENDERER,
                        columnIndex: columnIndex,
                        sortOrder: sortOrder
                    },
                    eventType: (0, $bMFKb.EVENT_TYPE).TRACK
                });
            } else fireAnalyticsEvent && fireAnalyticsEvent({
                action: (0, $bMFKb.ACTION).SORT_COLUMN_NOT_ALLOWED,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).TABLE,
                attributes: {
                    platform: (0, $7ueoK.PLATFORM).WEB,
                    mode: (0, $7ueoK.MODE).RENDERER
                },
                eventType: (0, $bMFKb.EVENT_TYPE).TRACK
            });
        }
    };
};
const $63cf8e5030b59364$export$f850895b287ef28e = $63cf8e5030b59364$export$cfca40ca5c56a38e($63cf8e5030b59364$var$TH);
const $63cf8e5030b59364$var$TD = $63cf8e5030b59364$var$getWithCellProps('td');
const $63cf8e5030b59364$export$1e4baea7053fc0e3 = $63cf8e5030b59364$var$TD;

});
parcelRegister("169DZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d4b1c665a79444b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $6YFG2 = parcelRequire("6YFG2");

var $k71qx = parcelRequire("k71qx");

var $hh2CV = parcelRequire("hh2CV");


var $lLPRx = parcelRequire("lLPRx");
function $7d4b1c665a79444b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $7d4b1c665a79444b$export$c3618f310f725028 = /*#__PURE__*/ function(StatusClassNames) {
    StatusClassNames["ASC"] = "sorting-icon-svg__asc";
    StatusClassNames["DESC"] = "sorting-icon-svg__desc";
    StatusClassNames["NO_ORDER"] = "sorting-icon-svg__no_order";
    StatusClassNames["SORTING_NOT_ALLOWED"] = "sorting-icon-svg__not-allowed";
    return StatusClassNames;
}({});
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $7d4b1c665a79444b$var$buttonStyles = /*#__PURE__*/ (0, $1NIU8.css)("position:absolute;display:flex;height:28px;width:28px;margin:var(--ds-space-075, 6px);right:0;top:0;border:2px solid var(--ds-border, #fff);border-radius:var(--ds-border-radius-100, 4px);background-color:var(--ds-surface-overlay, #FFFFFF);justify-content:center;align-items:center;cursor:pointer;&:hover{background-color:var(--ds-surface-overlay-hovered, #F1F2F4);}&:active{background-color:var(--ds-surface-overlay-pressed, rgba(179, 212, 255, 0.6));}&.", (0, $438179c68884651b$export$bd4f24d8b1e86b23), "__not-allowed{cursor:not-allowed;}");
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $7d4b1c665a79444b$var$iconWrapperStyles = /*#__PURE__*/ (0, $1NIU8.css)("width:8px;height:12px;transition:transform 0.3s cubic-bezier(0.15, 1, 0.3, 1);transform-origin:50% 50%;display:flex;justify-content:center;&.", "sorting-icon-svg__desc", "{transform:rotate(-180deg);}&.", (0, $438179c68884651b$export$bd4f24d8b1e86b23), "-inactive{opacity:0.7;}");
// The icon is created with CSS due to the following Firefox issue: https://product-fabric.atlassian.net/browse/ED-8001
// The TL;DR is that svg's in tables mess up how HTML is copied in Firefox. Using a styled div instead solves the problem.
// For this reason, svg's should be avoided in tables until this issue is fixed: https://bugzilla.mozilla.org/show_bug.cgi?id=1664350
const $7d4b1c665a79444b$var$iconStyles = {
    name: "14n17e4",
    styles: "height:100%;width:2px;border-radius:50px;background:var(--ds-icon, #42526E);user-select:none;&::before, &::after{background:var(--ds-icon, #42526E);content:'';height:2px;width:6px;position:absolute;border-radius:50px;}&::before{transform:rotate(45deg) translate(3.4px, 8.5px);}&::after{transform:rotate(-45deg) translate(-6.3px, 5.7px);}"
};
const $7d4b1c665a79444b$var$getIconClassName = (isSortingAllowed, sortOrdered)=>{
    const activated = sortOrdered !== (0, $hh2CV.SortOrder).NO_ORDER;
    const activeStatusClass = `${(0, $438179c68884651b$export$bd4f24d8b1e86b23)}-${activated ? 'active' : 'inactive'}`;
    if (!isSortingAllowed) return `${"sorting-icon-svg__not-allowed"} ${activeStatusClass}`;
    switch(sortOrdered){
        case (0, $hh2CV.SortOrder).ASC:
            return `${"sorting-icon-svg__asc"} ${activeStatusClass}`;
        case (0, $hh2CV.SortOrder).DESC:
            return `${"sorting-icon-svg__desc"} ${activeStatusClass}`;
        default:
            return `${"sorting-icon-svg__no_order"} ${activeStatusClass}`;
    }
};
const $7d4b1c665a79444b$var$getTooltipTitle = (intl, isSortingAllowed, sortOrdered)=>{
    const { noOrderLabel: noOrderLabel, ascOrderLabel: ascOrderLabel, descOrderLabel: descOrderLabel, invalidLabel: invalidLabel } = (0, $lLPRx.sortingIconMessages);
    if (!isSortingAllowed) return intl.formatMessage(invalidLabel);
    switch(sortOrdered){
        case (0, $hh2CV.SortOrder).NO_ORDER:
            return intl.formatMessage(noOrderLabel);
        case (0, $hh2CV.SortOrder).ASC:
            return intl.formatMessage(ascOrderLabel);
        case (0, $hh2CV.SortOrder).DESC:
            return intl.formatMessage(descOrderLabel);
    }
    return '';
};
const $7d4b1c665a79444b$var$getAriaLabel = (intl, isSortingAllowed, sortOrdered)=>{
    const { noOrderLabel: noOrderLabel, ascOrderLabel: ascOrderLabel, descOrderLabel: descOrderLabel, invalidLabel: invalidLabel, defaultLabel: defaultLabel } = (0, $lLPRx.sortingAriaLabelMessages);
    if (!isSortingAllowed) return intl.formatMessage(invalidLabel);
    switch(sortOrdered){
        case (0, $hh2CV.SortOrder).NO_ORDER:
            return intl.formatMessage(noOrderLabel);
        case (0, $hh2CV.SortOrder).ASC:
            return intl.formatMessage(ascOrderLabel);
        case (0, $hh2CV.SortOrder).DESC:
            return intl.formatMessage(descOrderLabel);
    }
    return intl.formatMessage(defaultLabel);
};
const $7d4b1c665a79444b$var$SortingIcon = ({ isSortingAllowed: isSortingAllowed, sortOrdered: sortOrdered, intl: intl, onClick: onClick, onKeyDown: onKeyDown })=>{
    const buttonClassName = `${(0, $438179c68884651b$export$bd4f24d8b1e86b23)} ${sortOrdered !== (0, $hh2CV.SortOrder).NO_ORDER ? 'is-active' : ''}${isSortingAllowed ? '' : ` ${0, $438179c68884651b$export$bd4f24d8b1e86b23}__not-allowed `}`;
    const content = $7d4b1c665a79444b$var$getTooltipTitle(intl, isSortingAllowed, sortOrdered);
    const ariaLabel = $7d4b1c665a79444b$var$getAriaLabel(intl, isSortingAllowed, sortOrdered);
    const handleClick = ()=>{
        if (isSortingAllowed) onClick();
    };
    const handleKeyDown = (event)=>{
        if (isSortingAllowed) onKeyDown(event);
    };
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $k71qx.default), {
        delay: 0,
        content: content,
        position: "top"
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $7d4b1c665a79444b$var$buttonStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: buttonClassName,
        role: "button",
        tabIndex: isSortingAllowed ? 0 : -1,
        "aria-label": ariaLabel,
        "aria-disabled": !isSortingAllowed,
        "aria-hidden": !isSortingAllowed,
        onClick: handleClick,
        onKeyDown: handleKeyDown
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $7d4b1c665a79444b$var$iconWrapperStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $7d4b1c665a79444b$var$getIconClassName(isSortingAllowed, sortOrdered)
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: [
            $7d4b1c665a79444b$var$iconStyles
        ]
    }))));
};
var $7d4b1c665a79444b$export$2e2bcd8739ae039 = (0, $6YFG2.default)($7d4b1c665a79444b$var$SortingIcon);

});
const $438179c68884651b$export$bd4f24d8b1e86b23 = `ak-renderer-tableHeader-sorting-icon`;

parcelRegister("lLPRx", function(module, exports) {

$parcel$export(module.exports, "sortingIconMessages", () => $f5c57691b59ca4ae$export$458c50917513cd1a);
$parcel$export(module.exports, "sortingAriaLabelMessages", () => $f5c57691b59ca4ae$export$f142573f51a67577);

var $7qGN1 = parcelRequire("7qGN1");
const $f5c57691b59ca4ae$export$458c50917513cd1a = (0, $7qGN1.defineMessages)({
    noOrderLabel: {
        id: 'fabric.editor.headingLink.noOrderLabel',
        defaultMessage: 'Sort column A to Z',
        description: 'Sort the column in ascending order'
    },
    ascOrderLabel: {
        id: 'fabric.editor.headingLink.ascOrderLabel',
        defaultMessage: 'Sort column Z to A',
        description: 'Sort the column in descending order'
    },
    descOrderLabel: {
        id: 'fabric.editor.headingLink.descOrderLabel',
        defaultMessage: 'Clear sorting',
        description: 'clear the sorting from this column'
    },
    invalidLabel: {
        id: 'fabric.editor.headingLink.invalidLabel',
        defaultMessage: `\u{26A0}\u{FE0F}  You can't sort a table with merged cells`,
        description: 'this sort is invalid for merged cells'
    }
});
const $f5c57691b59ca4ae$export$f142573f51a67577 = (0, $7qGN1.defineMessages)({
    noOrderLabel: {
        id: 'fabric.editor.tableHeader.sorting.no',
        defaultMessage: 'No sort applied to the column',
        description: 'Aria-label for Sort column button when sorting was not applied or the sorting has been cleared'
    },
    ascOrderLabel: {
        id: 'fabric.editor.tableHeader.sorting.asc',
        defaultMessage: 'Ascending sort applied',
        description: 'Aria-label for Sort column button when ascending sorting was applied'
    },
    descOrderLabel: {
        id: 'fabric.editor.tableHeader.sorting.desc',
        defaultMessage: 'Descending sort applied',
        description: 'Aria-label for Sort column button when descending sorting was applied'
    },
    invalidLabel: {
        id: 'fabric.editor.tableHeader.sorting.invalid',
        defaultMessage: `You can't sort a table with merged cells`,
        description: 'Aria-label for Sort column button when sorting is not possible'
    },
    defaultLabel: {
        id: 'fabric.editor.tableHeader.sorting.default',
        defaultMessage: 'Sort the column',
        description: 'Default aria-label for Sort column button'
    }
});

});



parcelRegister("dZ1mQ", function(module, exports) {

$parcel$export(module.exports, "Provider", () => $74c87a508e26c9e0$export$2881499e37b75b9a);
$parcel$export(module.exports, "withSmartCardStorage", () => $74c87a508e26c9e0$export$65e2d5a272a382b0);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
const $74c87a508e26c9e0$export$841858b892ce1f4c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext(new Map());
const $74c87a508e26c9e0$export$2881499e37b75b9a = function({ children: children }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)($74c87a508e26c9e0$export$841858b892ce1f4c.Provider, {
        value: new Map(),
        children: children
    });
};
const $74c87a508e26c9e0$export$65e2d5a272a382b0 = (WrappedComponent)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line react/prefer-stateless-function
    return class extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
        render() {
            return /*#__PURE__*/ (0, $gt9Am.jsx)($74c87a508e26c9e0$export$841858b892ce1f4c.Consumer, {
                children: (storage)=>/*#__PURE__*/ (0, $gt9Am.jsx)(WrappedComponent, {
                        ...this.props,
                        smartCardStorage: storage
                    })
            });
        }
    };
};

});

parcelRegister("177xQ", function(module, exports) {

$parcel$export(module.exports, "tableStickyPadding", () => $428fa281f6d943ea$export$3de6413b528017ca);
$parcel$export(module.exports, "StickyTable", () => $428fa281f6d943ea$export$fd9654fc359d55a3);
$parcel$export(module.exports, "OverflowParent", () => $428fa281f6d943ea$export$e97bc6692974bd0b);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $cjLtO = parcelRequire("cjLtO");

var $7yBx7 = parcelRequire("7yBx7");


var $eGOwo = parcelRequire("eGOwo");

var $hpXI5 = parcelRequire("hpXI5");

var $daWoF = parcelRequire("daWoF");
function $428fa281f6d943ea$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $428fa281f6d943ea$export$3de6413b528017ca = 8;
const $428fa281f6d943ea$var$modeSpecficStyles = {
    none: {
        name: "eivff4",
        styles: "display:none"
    },
    stick: {
        name: "duudsh",
        styles: "position:fixed"
    },
    'pin-bottom': {
        name: "a4hmbt",
        styles: "position:absolute"
    }
};
// refactored based on fixedTableDivStaticStyles
// TODO: DSP-4123 - Quality ticket
const $428fa281f6d943ea$var$fixedTableDivStaticStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    zIndex: 'var(--ak-renderer-sticky-header-zindex)',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $cjLtO.TableSharedCssClassName).TABLE_CONTAINER}, & .${(0, $cjLtO.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        marginTop: 0,
        marginBottom: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        tr: {
            background: "var(--ds-surface, white)"
        }
    },
    borderTop: `${$428fa281f6d943ea$export$3de6413b528017ca}px solid ${"var(--ds-surface, white)"}`,
    background: "var(--ds-surface-overlay, white)",
    boxShadow: `0 6px 4px -4px ${`var(--ds-shadow-overflow-perimeter, ${(0, $7bb4c1736002a04a$export$46987b49aab6d1a8)})`}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    "div[data-expanded='false'] &": {
        display: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $cjLtO.TableSharedCssClassName).TABLE_CONTAINER}.is-sticky.right-shadow::after, & .${(0, $cjLtO.TableSharedCssClassName).TABLE_CONTAINER}.is-sticky.left-shadow::before`]: {
        top: '0px',
        height: '100%'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "&.fixed-table-div-custom-table-resizing[mode='stick']": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: 'var(--ak-renderer-sticky-header-zindex)'
    }
});
const $428fa281f6d943ea$var$FixedTableDiv = (props)=>{
    const { top: top, wrapperWidth: wrapperWidth, mode: mode, allowTableResizing: allowTableResizing } = props;
    let stickyHeaderZIndex;
    if (allowTableResizing) stickyHeaderZIndex = 13;
    else stickyHeaderZIndex = (0, $7yBx7.akEditorStickyHeaderZIndex);
    const attrs = {
        mode: mode
    };
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        ...attrs,
        "data-testid": "sticky-table-fixed",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: allowTableResizing ? 'fixed-table-div-custom-table-resizing' : '',
        css: [
            $428fa281f6d943ea$var$fixedTableDivStaticStyles,
            $428fa281f6d943ea$var$modeSpecficStyles?.[mode]
        ],
        style: {
            '--ak-renderer-sticky-header-zindex': stickyHeaderZIndex,
            width: `${wrapperWidth}px`,
            top: (0, $eGOwo.fg)('sticky_header_in_embedded_confluence_fix') ? typeof top === 'number' ? `${top}px` : undefined : top ? `${top}px` : undefined
        }
    }, props.children);
};
const $428fa281f6d943ea$export$fd9654fc359d55a3 = ({ top: top, left: left, mode: mode, shadowClassNames: shadowClassNames, innerRef: innerRef, wrapperWidth: wrapperWidth, tableWidth: tableWidth, isNumberColumnEnabled: isNumberColumnEnabled, layout: layout, children: children, columnWidths: columnWidths, renderWidth: renderWidth, rowHeight: rowHeight, tableNode: tableNode, rendererAppearance: rendererAppearance, allowTableResizing: allowTableResizing, fixTableSSRResizing: fixTableSSRResizing = false })=>{
    let styles;
    /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ if (allowTableResizing) styles = /*#__PURE__*/ (0, $1NIU8.css)({
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        top: mode === 'pin-bottom' ? top : undefined,
        position: 'absolute'
    });
    else styles = /*#__PURE__*/ (0, $1NIU8.css)({
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        left: left && left < 0 ? left : undefined,
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        top: mode === 'pin-bottom' ? top : undefined,
        position: 'relative'
    });
    /* eslint-enable @atlaskit/design-system/ensure-design-token-usage */ return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: styles
    }, /*#__PURE__*/ (0, $1NIU8.jsx)($428fa281f6d943ea$var$FixedTableDiv, {
        top: mode === 'stick' ? top : undefined,
        mode: rowHeight > 300 ? 'none' : mode,
        wrapperWidth: wrapperWidth,
        allowTableResizing: allowTableResizing
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${(0, $cjLtO.TableSharedCssClassName).TABLE_CONTAINER} is-sticky ${shadowClassNames || ''}`,
        "data-layout": layout,
        style: {
            width: tableWidth,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            marginBottom: fixTableSSRResizing ? 0 : ''
        }
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        ref: innerRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${(0, $cjLtO.TableSharedCssClassName).TABLE_STICKY_WRAPPER}`,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $hpXI5.Table), {
        columnWidths: columnWidths,
        layout: layout,
        isNumberColumnEnabled: isNumberColumnEnabled,
        renderWidth: renderWidth,
        tableNode: tableNode,
        rendererAppearance: rendererAppearance,
        fixTableSSRResizing: fixTableSSRResizing
    }, /**
               * @see https://product-fabric.atlassian.net/browse/ED-10235
               * We pass prop 'invisible' to our table's children nodes meaning
               * they exist inside of the 'invisible' duplicated table component that
               * enables sticky headers.
               */ (0, $daWoF.recursivelyInjectProps)(children, {
        invisible: true
    })))))));
};
/**
 * Traverse DOM Tree upwards looking for table parents with "overflow: scroll".
 * @param table
 * @param defaultScrollRootId
 * @example
 */ function $428fa281f6d943ea$var$findHorizontalOverflowScrollParent(table, defaultScrollRootId) {
    let parent = table;
    if (!parent) return null;
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    while(parent = parent.parentElement){
        // IE11 on Window 8 doesn't show styles from CSS when accessing through element.style property.
        const style = window.getComputedStyle(parent);
        if (style.overflow === 'scroll' || style.overflowY === 'scroll') return parent;
        if (!!defaultScrollRootId && parent.id === defaultScrollRootId) // If a defaultScrollRootId was specified and we reached the element with this id without finding a closer
        // scroll parent, use this element as the scroll parent
        return parent;
    }
    return null;
}
class $428fa281f6d943ea$export$e97bc6692974bd0b {
    constructor(ref){
        this.ref = ref;
        this.ref = ref;
    }
    /**
   *
   * @param el
   * @param defaultScrollRootId
   * @example
   */ static fromElement(el, defaultScrollRootId) {
        return new $428fa281f6d943ea$export$e97bc6692974bd0b($428fa281f6d943ea$var$findHorizontalOverflowScrollParent(el, defaultScrollRootId) || window);
    }
    /**
   *
   */ get isElement() {
        return this.ref instanceof HTMLElement;
    }
    /**
   *
   */ get id() {
        if (this.ref instanceof HTMLElement) return this.ref.id;
        return '';
    }
    /**
   *
   */ get top() {
        if (this.ref instanceof HTMLElement) return this.ref.getBoundingClientRect().top;
        return 0;
    }
    /**
   *
   * @param type
   * @param cb
   * @param {...any} args
   * @example
   */ // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    addEventListener(type, cb, ...args) {
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.ref.addEventListener(type, cb, ...args);
    }
    /**
   *
   * @param type
   * @param cb
   * @param {...any} args
   * @example
   */ // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    removeEventListener(type, cb, ...args) {
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.ref.removeEventListener(type, cb, ...args);
    }
}

});
parcelRegister("hpXI5", function(module, exports) {

$parcel$export(module.exports, "Table", () => $73248f20006ee04a$export$54ec01a60f47d33d);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5X2BQ = parcelRequire("5X2BQ");

var $68RqK = parcelRequire("68RqK");

var $7yBx7 = parcelRequire("7yBx7");

var $eGOwo = parcelRequire("eGOwo");
const $73248f20006ee04a$export$54ec01a60f47d33d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo(({ innerRef: innerRef, isNumberColumnEnabled: isNumberColumnEnabled, columnWidths: columnWidths, layout: layout, renderWidth: renderWidth, children: children, tableNode: tableNode, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, isInsideOfTable: isInsideOfTable, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension, allowTableResizing: allowTableResizing, isPresentational: isPresentational, fixTableSSRResizing: fixTableSSRResizing = false })=>{
    let tableWidth = tableNode ? (0, $68RqK.getTableContainerWidth)(tableNode) : (0, $7yBx7.akEditorDefaultLayoutWidth);
    let tableColumnWidths = columnWidths;
    if (rendererAppearance === 'comment' && allowTableResizing && tableNode && !tableNode.attrs?.width) tableWidth = 'inherit';
    if (rendererAppearance === 'comment' && !allowTableResizing) // in the case we have css container stylings,
    // we don't need to calculate width here as this
    // is done via css
    {
        if (!(0, $eGOwo.fg)('platform-ssr-table-resize')) tableWidth = renderWidth;
    }
    // for columns that are evenly distributed, do not return `colgroup` since existing table containerQuery
    // scales up the columns width. This ensures columns always have 42px.
    if (rendererAppearance === 'comment') // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    {
        if ((0, $eGOwo.fg)('platform-ssr-table-resize') && (0, $eGOwo.fg)('platform_table_number_column')) tableColumnWidths = columnWidths && (0, $5X2BQ.colWidthSum)(columnWidths) ? columnWidths : undefined;
    }
    const tableLayout = tableNode?.attrs.layout;
    const tableDisplayMode = tableNode?.attrs.displayMode;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("table", {
        ...(0, $eGOwo.fg)('platform_renderer_isPresentational') && {
            role: isPresentational ? 'presentation' : undefined
        },
        "data-testid": "renderer-table",
        "data-number-column": isNumberColumnEnabled,
        "data-table-width": tableWidth,
        "data-layout": tableLayout,
        "data-table-display-mode": tableDisplayMode,
        ref: innerRef,
        style: {
            marginTop: fixTableSSRResizing ? '0px' : ''
        },
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5X2BQ.Colgroup), {
                columnWidths: tableColumnWidths,
                layout: layout,
                isNumberColumnEnabled: isNumberColumnEnabled,
                renderWidth: renderWidth,
                tableNode: tableNode,
                rendererAppearance: rendererAppearance,
                isInsideOfBlockNode: isInsideOfBlockNode,
                isInsideOfTable: isInsideOfTable,
                isinsideMultiBodiedExtension: isinsideMultiBodiedExtension,
                allowTableResizing: allowTableResizing
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("tbody", {
                children: children
            })
        ]
    });
});

});
parcelRegister("5X2BQ", function(module, exports) {

$parcel$export(module.exports, "colWidthSum", () => $f206524cd9dc600c$export$2d9bdaa5b8cd99f0);
$parcel$export(module.exports, "Colgroup", () => $f206524cd9dc600c$export$89efc2d0ceeaa030);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $cjLtO = parcelRequire("cjLtO");

var $7yBx7 = parcelRequire("7yBx7");

var $92xoS = parcelRequire("92xoS");

var $68RqK = parcelRequire("68RqK");

var $bMc4v = parcelRequire("bMc4v");

var $RTnFt = parcelRequire("RTnFt");

var $eGOwo = parcelRequire("eGOwo");
// we allow scaling down column widths by no more than 30%
// this intends to reduce unwanted scrolling in the Renderer in these scenarios:
// User A creates a table with column widths → User B views it on a smaller screen
// User A creates a table with column widths → User A views it with reduced viewport space (eg. Confluence sidebar is open)
const $f206524cd9dc600c$var$MAX_SCALING_PERCENT = 0.3;
const $f206524cd9dc600c$var$MAX_SCALING_PERCENT_TABLES_WITH_FIXED_COLUMN_WIDTHS_OPTION = 0.4;
const $f206524cd9dc600c$var$isTableColumnResized = (columnWidths)=>{
    const filteredWidths = columnWidths.filter((width)=>width !== 0);
    return !!filteredWidths.length;
};
const $f206524cd9dc600c$var$fixColumnWidth = (columnWidth, _tableWidth, _layoutWidth, zeroWidthColumnsCount, scaleDownPercent)=>{
    if (columnWidth === 0) return columnWidth;
    // If the tables total width (including no zero widths col or cols without width) is less than the current layout
    // We scale up the columns to meet the minimum of the table layout.
    if (zeroWidthColumnsCount === 0 && scaleDownPercent) return Math.max(Math.floor((1 - scaleDownPercent) * columnWidth), (0, $cjLtO.tableCellMinWidth));
    return Math.max(// We need to take tableCellBorderWidth, to avoid unnecessary overflow.
    columnWidth - (0, $cjLtO.tableCellBorderWidth), zeroWidthColumnsCount ? (0, $7yBx7.akEditorTableLegacyCellMinWidth) : (0, $cjLtO.tableCellMinWidth));
};
const $f206524cd9dc600c$var$calcScalePercent = ({ renderWidth: renderWidth, tableWidth: tableWidth, maxScale: maxScale, isNumberColumnEnabled: isNumberColumnEnabled })=>{
    const noNumColumnScalePercent = renderWidth / tableWidth;
    // when numbered column is enabled, we need to calculate the scale percent without the akEditorTableNumberColumnWidth
    // As numbered column width is not scaled down
    const numColumnScalePercent = (renderWidth - (0, $7yBx7.akEditorTableNumberColumnWidth)) / (tableWidth - (0, $7yBx7.akEditorTableNumberColumnWidth));
    const diffPercent = 1 - noNumColumnScalePercent;
    return diffPercent < maxScale ? isNumberColumnEnabled ? 1 - numColumnScalePercent : diffPercent : maxScale;
};
const $f206524cd9dc600c$export$2d9bdaa5b8cd99f0 = (columnWidths)=>columnWidths.reduce((prev, curr)=>curr + prev, 0);
const $f206524cd9dc600c$var$renderScaleDownColgroup = (props)=>{
    const { columnWidths: columnWidths, isNumberColumnEnabled: isNumberColumnEnabled, renderWidth: renderWidth, tableNode: tableNode, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, isInsideOfTable: isInsideOfTable, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension, isTableScalingEnabled: isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled: isTableFixedColumnWidthsOptionEnabled, allowTableResizing: allowTableResizing, isTopLevelRenderer: isTopLevelRenderer } = props;
    if (!columnWidths) return [];
    const tableColumnResized = $f206524cd9dc600c$var$isTableColumnResized(columnWidths);
    const noOfColumns = columnWidths.length;
    let targetWidths;
    // This is a fix for ED-23259
    // Some extensions (for ex: Page Properties or Excerpt) do not renderer tables directly inside themselves. They use ReactRenderer.
    // So if we add a check like isInsideExtension (similar to exising isInsideBlockNode), it will fail, and to the only way to learn
    // if the table is rendered inside another node, is to check if the Renderer itself is nested.
    const isRendererNested = isTopLevelRenderer === false;
    // appearance == comment && allowTableResizing && !tableNode?.attrs.width, means it is a comment
    // appearance == comment && !allowTableResizing && !tableNode?.attrs.width, means it is a inline comment
    // When comment and inline comment table width inherits from the parent container, we want tableContainerWidth === renderWidth
    // Tables with numbered columns inside of extensions cannot use the renderWidth when it is 0. In this case, it should
    // explicitly use the width coming from the table node as the final table container width.
    const tableContainerWidth = rendererAppearance === 'comment' && !tableNode?.attrs.width || isRendererNested && (!(0, $eGOwo.fg)('platform_fix_nested_num_column_scaling') || !isNumberColumnEnabled) ? renderWidth : (0, $68RqK.getTableContainerWidth)(tableNode);
    if (allowTableResizing && !isInsideOfBlockNode && !isInsideOfTable && !isinsideMultiBodiedExtension && !tableColumnResized) {
        // when no columns are resized, each column should have equal width, equals to tableWidth / noOfColumns
        const tableWidth = (isNumberColumnEnabled ? tableContainerWidth - (0, $7yBx7.akEditorTableNumberColumnWidth) : tableContainerWidth) - 1;
        const defaultColumnWidth = tableWidth / noOfColumns;
        targetWidths = new Array(noOfColumns).fill(defaultColumnWidth);
    } else if (!tableColumnResized) return null;
    const sumOfColumns = $f206524cd9dc600c$export$2d9bdaa5b8cd99f0(columnWidths);
    // tables in the wild may be smaller than table container width (col resizing bugs, created before custom widths etc.)
    // this causes issues with num column scaling as we add a new table column in renderer
    const isTableSmallerThanContainer = sumOfColumns < tableContainerWidth - 1;
    const forceScaleForNumColumn = isTableScalingEnabled && isNumberColumnEnabled && tableColumnResized;
    // when table resized and number column is enabled, we need to scale down the table in render
    if (forceScaleForNumColumn) {
        const calculatedTableContainerWidth = rendererAppearance === 'comment' && (0, $eGOwo.fg)('platform_custom_number_column') ? sumOfColumns : tableContainerWidth;
        const scalePercentage = +((calculatedTableContainerWidth - (0, $7yBx7.akEditorTableNumberColumnWidth)) / calculatedTableContainerWidth);
        const targetMaxWidth = calculatedTableContainerWidth - (0, $7yBx7.akEditorTableNumberColumnWidth);
        let totalWidthAfterScale = 0;
        const newScaledTargetWidths = columnWidths.map((width)=>{
            // we need to scale each column UP, to ensure total width of table matches table container
            const patchedWidth = isTableSmallerThanContainer ? width / sumOfColumns * (calculatedTableContainerWidth - 1) : width;
            const newWidth = Math.floor(patchedWidth * scalePercentage);
            totalWidthAfterScale += newWidth;
            return newWidth;
        });
        const diff = targetMaxWidth - totalWidthAfterScale;
        targetWidths = newScaledTargetWidths;
        if (diff > 0 || diff < 0 && Math.abs(diff) < (0, $cjLtO.tableCellMinWidth)) {
            let updated = false;
            targetWidths = targetWidths.map((width)=>{
                if (!updated && width + diff > (0, $cjLtO.tableCellMinWidth)) {
                    updated = true;
                    width += diff;
                }
                return width;
            });
        }
    }
    targetWidths = targetWidths || columnWidths;
    // @see ED-6056
    const maxTableWidth = renderWidth < tableContainerWidth ? renderWidth : tableContainerWidth;
    let tableWidth = isNumberColumnEnabled ? (0, $7yBx7.akEditorTableNumberColumnWidth) : 0;
    let minTableWidth = tableWidth;
    let zeroWidthColumnsCount = 0;
    targetWidths.forEach((width)=>{
        if (width) tableWidth += Math.ceil(width);
        else zeroWidthColumnsCount += 1;
        minTableWidth += Math.ceil(width) || (0, $7yBx7.akEditorTableLegacyCellMinWidth);
    });
    let cellMinWidth = 0;
    let scaleDownPercent = 0;
    const isTableScalingWithFixedColumnWidthsOptionEnabled = isTableScalingEnabled && isTableFixedColumnWidthsOptionEnabled;
    const isTableWidthFixed = isTableScalingWithFixedColumnWidthsOptionEnabled && props.tableNode?.attrs.displayMode === 'fixed';
    const maxScalingPercent = isTableScalingWithFixedColumnWidthsOptionEnabled || isTableScalingEnabled && rendererAppearance === 'comment' ? $f206524cd9dc600c$var$MAX_SCALING_PERCENT_TABLES_WITH_FIXED_COLUMN_WIDTHS_OPTION : $f206524cd9dc600c$var$MAX_SCALING_PERCENT;
    // fixes migration tables with zero-width columns
    if (zeroWidthColumnsCount > 0) {
        if (minTableWidth > maxTableWidth) {
            const minWidth = Math.ceil((maxTableWidth - tableWidth) / zeroWidthColumnsCount);
            cellMinWidth = minWidth < (0, $7yBx7.akEditorTableLegacyCellMinWidth) ? (0, $7yBx7.akEditorTableLegacyCellMinWidth) : minWidth;
        }
    } else if (renderWidth < tableWidth && !isTableWidthFixed) {
        const shouldTable100ScaleDown = rendererAppearance === 'comment' && allowTableResizing && !tableNode?.attrs.width;
        scaleDownPercent = $f206524cd9dc600c$var$calcScalePercent({
            renderWidth: renderWidth,
            tableWidth: tableWidth,
            maxScale: (0, $eGOwo.fg)('platform-ssr-table-resize') ? maxScalingPercent : shouldTable100ScaleDown ? 1 : maxScalingPercent,
            isNumberColumnEnabled: isNumberColumnEnabled
        });
    }
    return targetWidths.map((colWidth)=>{
        const width = $f206524cd9dc600c$var$fixColumnWidth(colWidth, minTableWidth, maxTableWidth, zeroWidthColumnsCount, scaleDownPercent) || cellMinWidth;
        const style = width ? {
            width: `${width}px`
        } : {};
        return style;
    });
};
const $f206524cd9dc600c$export$89efc2d0ceeaa030 = (props)=>{
    const { isTopLevelRenderer: isTopLevelRenderer } = (0, $RTnFt.useRendererContext)();
    const { columnWidths: columnWidths, isNumberColumnEnabled: isNumberColumnEnabled } = props;
    const flags = (0, $bMc4v.useFeatureFlags)();
    if (!columnWidths) return null;
    const colStyles = $f206524cd9dc600c$var$renderScaleDownColgroup({
        ...props,
        isTopLevelRenderer: isTopLevelRenderer,
        isTableScalingEnabled: props.rendererAppearance === 'full-page' || props.rendererAppearance === 'full-width' || props.rendererAppearance === 'comment' && (0, $92xoS.editorExperiment)('support_table_in_comment', true, {
            exposure: true
        }) || props.rendererAppearance === 'comment' && (0, $92xoS.editorExperiment)('support_table_in_comment_jira', true, {
            exposure: true
        }),
        isTableFixedColumnWidthsOptionEnabled: !!(flags && 'tableWithFixedColumnWidthsOption' in flags && flags.tableWithFixedColumnWidthsOption) && (props.rendererAppearance === 'full-page' || props.rendererAppearance === 'full-width')
    });
    if (!colStyles) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("colgroup", {
        children: [
            isNumberColumnEnabled && /*#__PURE__*/ (0, $gt9Am.jsx)("col", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                style: {
                    width: (0, $7yBx7.akEditorTableNumberColumnWidth)
                },
                "data-test-id": 'num'
            }),
            colStyles.map((style, idx)=>// Ignored via go/ees005
                // eslint-disable-next-line react/no-array-index-key, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, $gt9Am.jsx)("col", {
                    style: style
                }, idx))
        ]
    });
};

});
parcelRegister("bMc4v", function(module, exports) {

$parcel$export(module.exports, "useFeatureFlags", () => $cd26d1764c39db20$export$90335b3ff08f335);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $RTnFt = parcelRequire("RTnFt");
const $cd26d1764c39db20$export$90335b3ff08f335 = ()=>(0, $RTnFt.useRendererContext)()?.featureFlags;

});
parcelRegister("RTnFt", function(module, exports) {

$parcel$export(module.exports, "useRendererContext", () => $168a8c218e1e34ec$export$a906432540ed7ed8);
$parcel$export(module.exports, "RendererContextProvider", () => $168a8c218e1e34ec$export$ca5df47902194781);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $eJOHy = parcelRequire("eJOHy");
const $168a8c218e1e34ec$var$RendererContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext({});
const $168a8c218e1e34ec$export$a906432540ed7ed8 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useContext($168a8c218e1e34ec$var$RendererContext);
const $168a8c218e1e34ec$export$ca5df47902194781 = $168a8c218e1e34ec$var$RendererContext.Provider;

});




parcelRegister("daWoF", function(module, exports) {

$parcel$export(module.exports, "recursivelyInjectProps", () => $f4a7ec86790d5a0e$export$40e12ce8e0a76b0c);

var $eJOHy = parcelRequire("eJOHy");
function $f4a7ec86790d5a0e$export$40e12ce8e0a76b0c(children, propsToInject) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.toArray(children).map((child)=>{
        // Cannot add a prop to an invalid element, so just return the child
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(child)) return child;
        // Recursive call if child has nested children
        if (child.props.children) child = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).cloneElement(child, {
            children: $f4a7ec86790d5a0e$export$40e12ce8e0a76b0c(child.props.children, propsToInject)
        });
        // Add props to react child node
        return (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).cloneElement(child, propsToInject);
    });
}

});


parcelRegister("3xZmi", function(module, exports) {

$parcel$export(module.exports, "isFullWidthAppearance", () => $94795b49a3b496cd$export$c0112b8340d4924b);
$parcel$export(module.exports, "isFullPageAppearance", () => $94795b49a3b496cd$export$a64737a81cde10b4);
$parcel$export(module.exports, "isCommentAppearance", () => $94795b49a3b496cd$export$f77d2ff45b2c53ed);
$parcel$export(module.exports, "isFullWidthOrFullPageAppearance", () => $94795b49a3b496cd$export$33331a99fac775a1);
const $94795b49a3b496cd$export$c0112b8340d4924b = (appearance)=>appearance === 'full-width';
const $94795b49a3b496cd$export$a64737a81cde10b4 = (appearance)=>appearance === 'full-page';
const $94795b49a3b496cd$export$f77d2ff45b2c53ed = (appearance)=>appearance === 'comment';
const $94795b49a3b496cd$export$33331a99fac775a1 = (appearance)=>$94795b49a3b496cd$export$a64737a81cde10b4(appearance) || $94795b49a3b496cd$export$c0112b8340d4924b(appearance);

});

parcelRegister("hxOCd", function(module, exports) {

$parcel$export(module.exports, "TableStickyScrollbar", () => $aaed5ba788d3113a$export$8c072780619cfc83);

var $cjLtO = parcelRequire("cjLtO");

var $eGOwo = parcelRequire("eGOwo");
class $aaed5ba788d3113a$export$8c072780619cfc83 {
    constructor(wrapper){
        this.sentinels = {};
        this.handleScroll = (event)=>{
            if (!this.stickyScrollbarContainerElement || !this.wrapper || event.target !== this.stickyScrollbarContainerElement) return;
            this.wrapper.scrollLeft = this.stickyScrollbarContainerElement.scrollLeft;
        };
        this.wrapper = wrapper;
        this.init();
    }
    dispose() {
        if (this.stickyScrollbarContainerElement) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.stickyScrollbarContainerElement.removeEventListener('scroll', this.handleScroll);
        this.deleteIntersectionObserver();
    }
    scrollLeft(left) {
        if (this.stickyScrollbarContainerElement) this.stickyScrollbarContainerElement.scrollLeft = left;
    }
    init() {
        if (!this.wrapper) return;
        const scrollbarContainers = this.wrapper.parentElement?.querySelectorAll(`.${(0, $cjLtO.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER}`);
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.stickyScrollbarContainerElement = (0, $eGOwo.fg)('platform_editor_querySelector_fix_table_renderer') ? scrollbarContainers?.item(scrollbarContainers.length - 1) : this.wrapper.parentElement?.querySelector(`.${(0, $cjLtO.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER}`);
        if (this.stickyScrollbarContainerElement) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.stickyScrollbarContainerElement.addEventListener('scroll', this.handleScroll, {
            passive: true
        });
        this.createIntersectionObserver();
    }
    createIntersectionObserver() {
        this.rendererScrollableElement = window.document;
        if (!this.rendererScrollableElement || !this.wrapper) return;
        this.intersectionObserver = new IntersectionObserver((entries, _)=>{
            if (!this.stickyScrollbarContainerElement) return;
            entries.forEach((entry)=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const target = entry.target;
                if (target.classList.contains((0, $cjLtO.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM)) this.sentinelBottomCallback(entry);
                if (target.classList.contains((0, $cjLtO.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP)) this.sentinelTopCallback(entry);
            });
        }, {
            root: this.rendererScrollableElement
        });
        const bottomSentinels = this.wrapper?.parentElement?.getElementsByClassName((0, $cjLtO.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM);
        this.sentinels.bottom = (0, $eGOwo.fg)('platform_editor_querySelector_fix_table_renderer') ? bottomSentinels?.item(bottomSentinels.length - 1) : this.wrapper?.parentElement?.getElementsByClassName((0, $cjLtO.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM)?.item(0);
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.sentinels.top = this.wrapper?.parentElement?.getElementsByClassName((0, $cjLtO.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP)?.item(0);
        [
            this.sentinels.bottom,
            this.sentinels.top
        ].forEach((el)=>// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            this.intersectionObserver.observe(el));
    }
    deleteIntersectionObserver() {
        if (this.intersectionObserver) {
            if (this.sentinels.bottom) this.intersectionObserver.unobserve(this.sentinels.bottom);
            this.intersectionObserver.disconnect();
        }
    }
    sentinelBottomCallback(entry) {
        const sentinelIsAboveScrollArea = entry.boundingClientRect.top < (entry.rootBounds?.top || 0);
        this.bottomSentinelState = sentinelIsAboveScrollArea ? 'above' : entry.isIntersecting ? 'visible' : 'below';
        this.toggle();
    }
    sentinelTopCallback(entry) {
        const sentinelIsBelowScrollArea = (entry.rootBounds?.bottom || 0) < entry.boundingClientRect.top;
        this.topSentinelState = sentinelIsBelowScrollArea ? 'below' : entry.isIntersecting ? 'visible' : 'above';
        this.toggle();
    }
    toggle() {
        if ((this.topSentinelState === 'visible' || this.topSentinelState === 'above') && this.bottomSentinelState === 'below') this.show();
        else this.hide();
    }
    hide() {
        if (this.stickyScrollbarContainerElement && this.stickyScrollbarContainerElement.style.visibility !== 'hidden') this.stickyScrollbarContainerElement.style.visibility = 'hidden';
    }
    show() {
        if (this.stickyScrollbarContainerElement && this.stickyScrollbarContainerElement.style.visibility !== 'visible') this.stickyScrollbarContainerElement.style.visibility = 'visible';
    }
}

});

parcelRegister("eOVsb", function(module, exports) {

$parcel$export(module.exports, "TableProcessorWithContainerStyles", () => $4bc4db8903ecca42$export$827f89182557f335);
/* eslint-disable @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/enforce-style-prop, @repo/internal/react/no-class-components */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $cjLtO = parcelRequire("cjLtO");

var $68RqK = parcelRequire("68RqK");


var $eGOwo = parcelRequire("eGOwo");

var $d3BBj = parcelRequire("d3BBj");
var $bTpHi = parcelRequire("bTpHi");
var $gikGJ = parcelRequire("gikGJ");

var $hh2CV = parcelRequire("hh2CV");

var $7yBx7 = parcelRequire("7yBx7");

var $92xoS = parcelRequire("92xoS");

var $lzf9g = parcelRequire("lzf9g");

var $177xQ = parcelRequire("177xQ");

var $hpXI5 = parcelRequire("hpXI5");

var $3xZmi = parcelRequire("3xZmi");

var $hxOCd = parcelRequire("hxOCd");
const $4bc4db8903ecca42$var$stickyContainerBaseStyles = {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    height: "var(--ds-space-250, 20px)",
    // MAX_BROWSER_SCROLLBAR_HEIGHT
    // Follow editor to hide by default so it does not show empty gap in SSR
    // https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/browse/platform/packages/editor/editor-plugin-table/src/nodeviews/TableComponent.tsx#957
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    display: 'block',
    width: '100%'
};
const $4bc4db8903ecca42$var$stickyContainerAdditionalStyles = {
    visibility: 'hidden',
    overflowX: 'auto',
    position: 'sticky',
    bottom: "var(--ds-space-0, 0px)",
    zIndex: 1
};
const $4bc4db8903ecca42$export$eec82c0a93aa66d9 = (appearance)=>(0, $3xZmi.isFullWidthOrFullPageAppearance)(appearance) || (0, $3xZmi.isCommentAppearance)(appearance) && (0, $92xoS.editorExperiment)('support_table_in_comment', true, {
        exposure: true
    });
const $4bc4db8903ecca42$export$bdb2dadcb04aad50 = (appearance)=>(0, $3xZmi.isFullWidthOrFullPageAppearance)(appearance) && (0, $92xoS.editorExperiment)('platform_renderer_table_sticky_scrollbar', true, {
        exposure: true
    });
const $4bc4db8903ecca42$export$334894231c46c1a5 = (children, tableNode, smartCardStorage, tableOrderStatus)=>{
    if (!tableOrderStatus || tableOrderStatus.order === (0, $hh2CV.SortOrder).NO_ORDER) return children;
    const { order: order, columnIndex: columnIndex } = tableOrderStatus;
    const compareNodesInOrder = (0, $gikGJ.createCompareNodes)({
        getInlineCardTextFromStore (attrs) {
            const { url: url } = attrs;
            if (!url) return null;
            return smartCardStorage.get(url) || null;
        }
    }, order);
    const tableArray = (0, $bTpHi.convertProsemirrorTableNodeToArrayOfRows)(tableNode);
    const tableArrayWithChildren = tableArray.map((rowNodes, index)=>({
            rowNodes: rowNodes,
            rowReact: children[index]
        }));
    const headerRow = tableArrayWithChildren.shift();
    const sortedTable = tableArrayWithChildren.sort((rowA, rowB)=>compareNodesInOrder(rowA.rowNodes[columnIndex], rowB.rowNodes[columnIndex]));
    if (headerRow) sortedTable.unshift(headerRow);
    return sortedTable.map((elem)=>elem.rowReact);
};
const $4bc4db8903ecca42$export$42f5658c8e0092da = (row)=>{
    let hasRowspan = false;
    row.forEach((cell)=>hasRowspan = hasRowspan || cell.attrs.rowspan > 1);
    return hasRowspan;
};
const $4bc4db8903ecca42$export$f422245984b0eda7 = (refElement)=>{
    return Math.round(refElement.getBoundingClientRect().top);
};
const $4bc4db8903ecca42$export$7c141112f3c89f11 = (scrollTop, tableTop, tableBottom, rowHeight)=>tableTop <= scrollTop && !(tableBottom - rowHeight <= scrollTop);
const $4bc4db8903ecca42$export$89f3188e1adc30d5 = (scrollTop, tableBottom, rowHeight)=>tableBottom - rowHeight <= scrollTop && !(tableBottom < scrollTop);
const $4bc4db8903ecca42$export$100baa0f10804e6e = (rows, tableOrderStatus, onSorting)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(rows, (row, index)=>{
        if (index === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.only(row), {
            tableOrderStatus: tableOrderStatus,
            onSorting: onSorting
        });
        return row;
    });
};
const $4bc4db8903ecca42$export$28daf78feed5098c = (rows)=>{
    if (!rows.length) return false;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const { children: children } = rows[0].props;
    if (!children.length) return false;
    if (children.length === 1) return children[0].type === (0, $lzf9g.TableHeader);
    return children.every((node)=>node.type === (0, $lzf9g.TableHeader));
};
const $4bc4db8903ecca42$export$940095e914312886 = (node, children)=>{
    return $4bc4db8903ecca42$export$28daf78feed5098c(children) && node && node.firstChild && !$4bc4db8903ecca42$export$42f5658c8e0092da(node.firstChild);
};
class $4bc4db8903ecca42$export$f2c3aea42b2a048f extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    /**
   *
   * @example
   */ componentDidMount() {
        this.resizeObserver = new ResizeObserver(this.applyResizerChange);
        if (this.wrapperRef.current) this.resizeObserver.observe(this.wrapperRef.current);
        if (this.stickyHeaderRef.current) this.resizeObserver.observe(this.stickyHeaderRef.current);
        if (this.props.stickyHeaders) {
            this.overflowParent = (0, $177xQ.OverflowParent).fromElement(this.tableRef.current, this.props.stickyHeaders?.defaultScrollRootId_DO_NOT_USE);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.addEventListener('scroll', this.onScroll);
        }
        if (this.wrapperRef.current && $4bc4db8903ecca42$export$bdb2dadcb04aad50(this.props.rendererAppearance)) this.stickyScrollbar = new (0, $hxOCd.TableStickyScrollbar)(this.wrapperRef.current);
    }
    /**
   *
   * @param prevProps
   * @param prevState
   * @example
   */ componentDidUpdate(prevProps, prevState) {
        // toggling sticky headers visiblity
        if (this.props.stickyHeaders && !this.overflowParent) this.overflowParent = (0, $177xQ.OverflowParent).fromElement(this.tableRef.current, this.props.stickyHeaders?.defaultScrollRootId_DO_NOT_USE);
        else if (!this.props.stickyHeaders && this.overflowParent) {
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.removeEventListener('scroll', this.onScroll);
            this.overflowParent = null;
        }
        // offsetTop might have changed, re-position sticky header
        if (this.props.stickyHeaders !== prevProps.stickyHeaders) this.updateSticky();
        // sync horizontal scroll in floating div when toggling modes
        if (prevState.stickyMode !== this.state.stickyMode) this.onWrapperScrolled();
    }
    /**
   *
   */ get pinTop() {
        if (!this.tableRef.current || !this.stickyHeaderRef.current) return;
        return this.tableRef.current.offsetHeight - this.stickyHeaderRef.current.offsetHeight + (0, $cjLtO.tableMarginTop) - (0, $177xQ.tableStickyPadding);
    }
    /**
   *
   */ get shouldAddOverflowParentOffsetTop_DO_NOT_USE() {
        // IF the StickyHeaderConfig specifies that the default scroll root offsetTop should be added
        // AND the StickyHeaderConfig specifies a default scroll root id
        // AND the OverflowParent is the corresponding element
        // THEN we should add the OverflowParent offset top (RETURN TRUE)
        return this.props.stickyHeaders && !!this.props.stickyHeaders.shouldAddDefaultScrollRootOffsetTop_DO_NOT_USE && !!this.props.stickyHeaders.defaultScrollRootId_DO_NOT_USE && this.overflowParent && this.overflowParent.id === this.props.stickyHeaders.defaultScrollRootId_DO_NOT_USE;
    }
    /**
   *
   */ get stickyTop() {
        switch(this.state.stickyMode){
            case 'pin-bottom':
                return this.pinTop;
            case 'stick':
                const offsetTop = this.props.stickyHeaders && this.props.stickyHeaders.offsetTop;
                if (typeof offsetTop === 'number' && this.shouldAddOverflowParentOffsetTop_DO_NOT_USE) {
                    const overflowParentOffsetTop = this.overflowParent ? this.overflowParent.top : 0;
                    return offsetTop + overflowParentOffsetTop;
                } else return offsetTop;
            default:
                return undefined;
        }
    }
    /**
   *
   * @example
   */ render() {
        const { isNumberColumnEnabled: isNumberColumnEnabled, layout: layout, columnWidths: columnWidths, stickyHeaders: stickyHeaders, tableNode: tableNode, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, isInsideOfTable: isInsideOfTable, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension, allowTableAlignment: allowTableAlignment, allowTableResizing: allowTableResizing, isPresentational: isPresentational } = this.props;
        const { stickyMode: stickyMode } = this.state;
        const lineLengthFixedWidth = (0, $7yBx7.akEditorDefaultLayoutWidth);
        let updatedLayout;
        const renderWidthCSS = rendererAppearance === 'full-page' ? `100cqw - ${0, $9a762f515f769003$export$12fd658e5eef0d79}px * 2` : `100cqw`;
        const calcDefaultLayoutWidthByAppearance = (rendererAppearance, tableNode)=>{
            if (rendererAppearance === 'full-width' && !tableNode?.attrs.width) return `min(${0, $7yBx7.akEditorFullWidthLayoutWidth}px, ${renderWidthCSS})`;
            else if (rendererAppearance === 'comment' && allowTableResizing && !tableNode?.attrs.width) return renderWidthCSS;
            else {
                // custom width, or width mapped to breakpoint
                const tableContainerWidth = (0, $68RqK.getTableContainerWidth)(tableNode);
                return `min(${tableContainerWidth}px, ${renderWidthCSS})`;
            }
        };
        const tableWidthCSS = calcDefaultLayoutWidthByAppearance(rendererAppearance, tableNode);
        // Logic for table alignment in renderer
        const isTableAlignStart = tableNode && tableNode.attrs && tableNode.attrs.layout === 'align-start' && allowTableAlignment;
        const fullWidthLineLengthCSS = `min(${(0, $7yBx7.akEditorFullWidthLayoutWidth)}px, ${renderWidthCSS})`;
        const isCommentAppearanceAndTableAlignmentEnabled = (0, $3xZmi.isCommentAppearance)(rendererAppearance) && allowTableAlignment;
        const lineLengthCSS = (0, $3xZmi.isFullWidthAppearance)(rendererAppearance) ? fullWidthLineLengthCSS : isCommentAppearanceAndTableAlignmentEnabled ? renderWidthCSS : `${lineLengthFixedWidth}px`;
        const tableWidthNew = (0, $68RqK.getTableContainerWidth)(tableNode);
        const shouldCalculateLeftForAlignment = !isInsideOfBlockNode && !isInsideOfTable && isTableAlignStart && ((0, $3xZmi.isFullPageAppearance)(rendererAppearance) && tableWidthNew <= lineLengthFixedWidth || (0, $3xZmi.isFullWidthAppearance)(rendererAppearance) || isCommentAppearanceAndTableAlignmentEnabled);
        let leftCSS;
        if (shouldCalculateLeftForAlignment) leftCSS = `(${tableWidthCSS} - ${lineLengthCSS}) / 2`;
        if (!shouldCalculateLeftForAlignment && (0, $3xZmi.isFullPageAppearance)(rendererAppearance)) // Note tableWidthCSS here is the renderer width
        // When the screen is super wide we want table to break out.
        // However if screen is smaller than 760px. We want table align to left.
        leftCSS = `min(0px, ${lineLengthCSS} - ${tableWidthCSS}) / 2`;
        const children = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.toArray(this.props.children);
        // Historically, tables in the full-width renderer had their layout set to 'default' which is deceiving.
        // This check caters for those tables and helps with SSR logic
        const isFullWidth = !tableNode?.attrs.width && rendererAppearance === 'full-width' && layout !== 'full-width';
        if (isFullWidth) updatedLayout = 'full-width';
        else if (tableNode?.attrs.width) updatedLayout = 'custom';
        else updatedLayout = layout;
        let finalTableContainerWidth = allowTableResizing ? tableWidthNew : 'inherit';
        // We can only use CSS to determine the width when we have a known width in container.
        // When appearance is full-page, full-width or comment we use CSS based width calculation.
        // Otherwise it's fixed table width (customized width) or inherit.
        if (rendererAppearance === 'full-page' || rendererAppearance === 'full-width') finalTableContainerWidth = allowTableResizing ? `calc(${tableWidthCSS})` : 'inherit';
        if (rendererAppearance === 'comment' && allowTableResizing && !allowTableAlignment) // If table alignment is disabled and table width is akEditorDefaultLayoutWidth = 760,
        // it is most likely a table created before "Support Table in Comments" FF was enabled
        // and we would see a bug ED-24795. A table created before "Support Table in Comments",
        // should inhirit the width of the renderer container.
        // !NOTE: it a table resized to 760 is copied from 'full-page' editor and pasted in comment editor
        // where (allowTableResizing && !allowTableAlignment), the table will loose 760px width.
        finalTableContainerWidth = tableNode?.attrs.width && tableNode?.attrs.width !== (0, $7yBx7.akEditorDefaultLayoutWidth) ? `calc(${tableWidthCSS})` : 'inherit';
        if (rendererAppearance === 'comment' && allowTableResizing && allowTableAlignment) // If table alignment is enabled and layout is not 'align-start' or 'center', we are loading a table that was
        // created before "Support Table in Comments" FF was enabled. So the table should have the same width as renderer container
        // instead of 760 that was set on tableNode when the table had been published.
        finalTableContainerWidth = (tableNode?.attrs.layout === 'align-start' || tableNode?.attrs.layout === 'center') && tableNode?.attrs.width ? `calc(${tableWidthCSS})` : 'inherit';
        const style = {
            width: finalTableContainerWidth,
            left: leftCSS ? `calc(${leftCSS})` : undefined,
            marginLeft: shouldCalculateLeftForAlignment && leftCSS !== undefined ? `calc(-1 * (${leftCSS}))` : undefined
        };
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
            children: /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: `${(0, $cjLtO.TableSharedCssClassName).TABLE_CONTAINER} ${this.props.shadowClassNames || ''}`,
                "data-layout": updatedLayout,
                "data-testid": "table-container",
                ref: this.props.handleRef,
                style: style,
                children: [
                    $4bc4db8903ecca42$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $cjLtO.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP,
                        "data-testid": "sticky-scrollbar-sentinel-top"
                    }),
                    stickyHeaders && tableNode && $4bc4db8903ecca42$export$940095e914312886(tableNode, children) && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $177xQ.StickyTable), {
                        isNumberColumnEnabled: isNumberColumnEnabled,
                        tableWidth: "inherit",
                        renderWidth: 0,
                        layout: layout,
                        handleRef: this.props.handleRef,
                        shadowClassNames: this.props.shadowClassNames,
                        top: this.stickyTop,
                        mode: stickyMode,
                        innerRef: this.stickyWrapperRef,
                        wrapperWidth: this.state.wrapperWidth,
                        columnWidths: columnWidths,
                        rowHeight: this.state.headerRowHeight,
                        tableNode: tableNode,
                        rendererAppearance: rendererAppearance,
                        allowTableResizing: allowTableResizing,
                        fixTableSSRResizing: true,
                        children: [
                            children && children[0]
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $cjLtO.TableSharedCssClassName).TABLE_NODE_WRAPPER,
                        ref: this.wrapperRef,
                        "data-number-column": tableNode?.attrs.isNumberColumnEnabled,
                        "data-layout": tableNode?.attrs.layout,
                        "data-autosize": tableNode?.attrs.__autoSize,
                        "data-table-local-id": tableNode?.attrs.localId,
                        "data-table-width": tableNode?.attrs.width,
                        "data-vc": "table-node-wrapper",
                        onScroll: this.props.stickyHeaders && this.onWrapperScrolled,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hpXI5.Table), {
                            innerRef: this.tableRef,
                            columnWidths: columnWidths,
                            layout: layout,
                            renderWidth: 0,
                            isNumberColumnEnabled: isNumberColumnEnabled,
                            tableNode: tableNode,
                            rendererAppearance: rendererAppearance,
                            isInsideOfBlockNode: isInsideOfBlockNode,
                            isInsideOfTable: isInsideOfTable,
                            isinsideMultiBodiedExtension: isinsideMultiBodiedExtension,
                            allowTableResizing: allowTableResizing,
                            isPresentational: isPresentational,
                            children: this.grabFirstRowRef(children)
                        })
                    }),
                    $4bc4db8903ecca42$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: `${(0, $cjLtO.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER}${(0, $eGOwo.fg)('confluence_frontend_table_scrollbar_ttvc_fix') ? '-view-page' : ''}`,
                        ref: this.stickyScrollbarRef,
                        "data-vc": "table-sticky-scrollbar-container",
                        style: (0, $eGOwo.fg)('confluence_frontend_table_scrollbar_ttvc_fix') ? {
                            ...$4bc4db8903ecca42$var$stickyContainerBaseStyles,
                            ...$4bc4db8903ecca42$var$stickyContainerAdditionalStyles
                        } : $4bc4db8903ecca42$var$stickyContainerBaseStyles,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                            style: {
                                width: (0, $eGOwo.fg)('confluence_frontend_table_scrollbar_ttvc_fix') ? '100%' : this.tableRef.current?.clientWidth,
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                height: '100%'
                            }
                        })
                    }),
                    $4bc4db8903ecca42$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $cjLtO.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM,
                        "data-testid": "sticky-scrollbar-sentinel-bottom"
                    })
                ]
            })
        });
    }
    constructor(...args){
        super(...args), this.state = {
            stickyMode: 'none',
            wrapperWidth: 0,
            headerRowHeight: 0
        }, this.tableRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createRef(), this.stickyHeaderRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createRef(), this.stickyScrollbarRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createRef(), // used for sync scroll + copying wrapper width to sticky header
        this.stickyWrapperRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createRef(), this.wrapperRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createRef(), this.overflowParent = null, this.updatedLayout = 'custom', this.resizeObserver = null, this.applyResizerChange = (entries)=>{
            let wrapperWidth = this.state.wrapperWidth;
            let headerRowHeight = this.state.headerRowHeight;
            for (const entry of entries){
                if (entry.target === this.wrapperRef.current) wrapperWidth = entry.contentRect.width;
                else if (entry.target === this.stickyHeaderRef.current) headerRowHeight = Math.round(entry.contentRect.height);
            }
            if (headerRowHeight !== this.state.headerRowHeight || wrapperWidth !== this.state.wrapperWidth) this.setState({
                wrapperWidth: wrapperWidth,
                headerRowHeight: headerRowHeight
            });
        }, this.componentWillUnmount = ()=>{
            if (this.overflowParent) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.removeEventListener('scroll', this.onScroll);
            if (this.nextFrame) cancelAnimationFrame(this.nextFrame);
            if (this.resizeObserver) this.resizeObserver.disconnect();
            if (this.stickyScrollbar) this.stickyScrollbar.dispose();
        }, this.getScrollTop = ()=>{
            const { stickyHeaders: stickyHeaders } = this.props;
            const offsetTop = stickyHeaders && stickyHeaders.offsetTop || 0;
            return (this.overflowParent ? this.overflowParent.top : 0) + offsetTop;
        }, this.updateSticky = ()=>{
            const tableElem = this.tableRef.current;
            const refElem = this.stickyHeaderRef.current;
            if (!tableElem || !refElem) return;
            const scrollTop = this.getScrollTop() + (0, $177xQ.tableStickyPadding);
            const tableTop = $4bc4db8903ecca42$export$f422245984b0eda7(tableElem);
            const tableBottom = tableTop + tableElem.clientHeight;
            const shouldSticky = $4bc4db8903ecca42$export$7c141112f3c89f11(scrollTop, tableTop, tableBottom, refElem.clientHeight);
            const shouldPin = $4bc4db8903ecca42$export$89f3188e1adc30d5(scrollTop, tableBottom, refElem.clientHeight);
            let stickyMode = 'none';
            if (shouldPin) stickyMode = 'pin-bottom';
            else if (shouldSticky) stickyMode = 'stick';
            if (this.state.stickyMode !== stickyMode) this.setState({
                stickyMode: stickyMode
            });
            this.nextFrame = undefined;
        }, this.onScroll = ()=>{
            if (!this.nextFrame) this.nextFrame = requestAnimationFrame(this.updateSticky);
        }, this.onWrapperScrolled = ()=>{
            if (!this.wrapperRef.current || !this.stickyWrapperRef.current) return;
            this.stickyWrapperRef.current.scrollLeft = this.wrapperRef.current.scrollLeft;
            if (this.stickyScrollbarRef.current) this.stickyScrollbarRef.current.scrollLeft = this.wrapperRef.current.scrollLeft;
        }, this.grabFirstRowRef = (children)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(children || false, (child, idx)=>{
                if (idx === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(child)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).cloneElement(child, {
                    innerRef: this.stickyHeaderRef
                });
                return child;
            });
        };
    }
}
class $4bc4db8903ecca42$export$827f89182557f335 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    /**
   *
   * @example
   */ render() {
        const { children: children } = this.props;
        if (!children) return null;
        const childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.toArray(children);
        const orderedChildren = (0, $d3BBj.compose)(this.addNumberColumnIndexes, this.addSortableColumn)(childrenArray);
        // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, $gt9Am.jsx)($4bc4db8903ecca42$export$f2c3aea42b2a048f, {
            ...this.props,
            children: orderedChildren
        });
    }
    constructor(...args){
        super(...args), this.state = {
            tableOrderStatus: undefined
        }, // adds sortable + re-orders children
        this.addSortableColumn = (childrenArray)=>{
            const { tableNode: tableNode, allowColumnSorting: allowColumnSorting, smartCardStorage: smartCardStorage } = this.props;
            const { tableOrderStatus: tableOrderStatus } = this.state;
            if (allowColumnSorting && $4bc4db8903ecca42$export$28daf78feed5098c(childrenArray) && tableNode && !(0, $bTpHi.hasMergedCell)(tableNode)) return $4bc4db8903ecca42$export$100baa0f10804e6e($4bc4db8903ecca42$export$334894231c46c1a5(childrenArray, tableNode, smartCardStorage, tableOrderStatus), tableOrderStatus, this.changeSortOrder);
            return childrenArray;
        }, this.changeSortOrder = (columnIndex, sortOrder)=>{
            this.setState({
                tableOrderStatus: {
                    columnIndex: columnIndex,
                    order: sortOrder
                }
            });
        }, // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.addNumberColumnIndexes = (rows)=>{
            const { isNumberColumnEnabled: isNumberColumnEnabled } = this.props;
            const headerRowEnabled = $4bc4db8903ecca42$export$28daf78feed5098c(rows);
            return (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(rows, (row, index)=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.only(row), {
                    isNumberColumnEnabled: isNumberColumnEnabled,
                    index: headerRowEnabled ? index === 0 ? '' : index : index + 1
                });
            });
        };
    }
}

});


parcelRegister("eACId", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a8fa33519ffce33$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $d3BBj = parcelRequire("d3BBj");

var $hh2CV = parcelRequire("hh2CV");

var $iRC0e = parcelRequire("iRC0e");
class $0a8fa33519ffce33$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    render() {
        const { children: children, innerRef: innerRef } = this.props;
        const childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.toArray(children);
        return /*#__PURE__*/ (0, $gt9Am.jsxs)("tr", {
            ref: innerRef,
            children: [
                this.props.isNumberColumnEnabled && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, $gt9Am.jsx)("td", {
                    className: (0, $iRC0e.RendererCssClassName).NUMBER_COLUMN,
                    children: this.props.index
                }),
                (0, $d3BBj.compose)(this.addSortableColumn, this.addColGroupWidth)(childrenArray)
            ]
        });
    }
    constructor(...args){
        super(...args), this.state = {
            colGroupWidths: []
        }, this.addSortableColumn = (childrenArray)=>{
            const { allowColumnSorting: allowColumnSorting, index: rowIndex } = this.props;
            const isHeaderRow = !rowIndex;
            if (allowColumnSorting && isHeaderRow) childrenArray = childrenArray.map((child, index)=>{
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(child)) {
                    const { tableOrderStatus: tableOrderStatus } = this.props;
                    let sortOrdered = (0, $hh2CV.SortOrder).NO_ORDER;
                    if (tableOrderStatus) sortOrdered = index === tableOrderStatus.columnIndex ? tableOrderStatus.order : (0, $hh2CV.SortOrder).NO_ORDER;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).cloneElement(child, {
                        columnIndex: index,
                        onSorting: this.props.onSorting,
                        sortOrdered: sortOrdered,
                        isHeaderRow: isHeaderRow
                    });
                }
            });
            return childrenArray;
        }, this.addColGroupWidth = (childrenArray)=>{
            if (this.state.colGroupWidths?.length) childrenArray = childrenArray.map((child, index)=>{
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(child)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).cloneElement(child, {
                    colGroupWidth: this.state.colGroupWidths[index]
                });
            });
            return childrenArray;
        };
    }
}

});

parcelRegister("eoMJq", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5f6b4c882c0f359$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
function $b5f6b4c882c0f359$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: "UnknownBlock",
        children: props.children
    });
}

});

parcelRegister("dcc5P", function(module, exports) {

let $99b5c6c16e23a522$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $99b5c6c16e23a522$var$load("8736I").then(()=>parcelRequire('gp0ta'));

});

parcelRegister("5JvF6", function(module, exports) {

let $42c9b7241c7f8d92$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $42c9b7241c7f8d92$var$load("6aYtx").then(()=>parcelRequire('ioMWp'));

});

parcelRegister("e0VbS", function(module, exports) {

let $a33d6da741ec85ce$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $a33d6da741ec85ce$var$load("kyc3X").then(()=>parcelRequire('lu3aG'));

});

parcelRegister("2XR3X", function(module, exports) {

let $228a40a293e53962$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $228a40a293e53962$var$load("8A35j").then(()=>parcelRequire('MUFrj'));

});

parcelRegister("cRokE", function(module, exports) {

let $95cd4f1dde468b0f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $95cd4f1dde468b0f$var$load("9ClHX").then(()=>parcelRequire('8nyI6'));

});

parcelRegister("8uCPq", function(module, exports) {

let $62ef3e99965e8b36$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $62ef3e99965e8b36$var$load("i5I3w").then(()=>parcelRequire('2XJ8t'));

});

parcelRegister("bBs2k", function(module, exports) {

let $8728e5e8c743a940$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $8728e5e8c743a940$var$load("ipFBo").then(()=>parcelRequire('aEpcu'));

});

parcelRegister("5mDbU", function(module, exports) {

let $010205cffb59e798$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $010205cffb59e798$var$load("iFaWe").then(()=>parcelRequire('LiaMl'));

});

parcelRegister("lNpN3", function(module, exports) {

let $fde22dfa331bd047$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $fde22dfa331bd047$var$load("ffQaD"),
    $fde22dfa331bd047$var$load("kvRbA"),
    $fde22dfa331bd047$var$load("ldGmJ")
]).then(()=>parcelRequire('6L7mA'));

});

parcelRegister("gIrm0", function(module, exports) {

let $c2b5f94e1a75c695$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $c2b5f94e1a75c695$var$load("ffQaD"),
    $c2b5f94e1a75c695$var$load("kvRbA"),
    $c2b5f94e1a75c695$var$load("dMn8Q")
]).then(()=>parcelRequire('7naaD'));

});

parcelRegister("l4dZQ", function(module, exports) {

let $f564d419bdca679f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $f564d419bdca679f$var$load("fliVL"),
    $f564d419bdca679f$var$load("76n7a"),
    $f564d419bdca679f$var$load("l253H"),
    $f564d419bdca679f$var$load("ffQaD"),
    $f564d419bdca679f$var$load("kvRbA"),
    $f564d419bdca679f$var$load("kNFvF"),
    $f564d419bdca679f$var$load("2RTKs")
]).then(()=>parcelRequire('1C1WZ'));

});

parcelRegister("jtlbv", function(module, exports) {

let $e2d128931587ec72$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $e2d128931587ec72$var$load("fliVL"),
    $e2d128931587ec72$var$load("76n7a"),
    $e2d128931587ec72$var$load("l253H"),
    $e2d128931587ec72$var$load("ffQaD"),
    $e2d128931587ec72$var$load("kvRbA"),
    $e2d128931587ec72$var$load("kNFvF"),
    $e2d128931587ec72$var$load("7ePgM")
]).then(()=>parcelRequire('hGXwD'));

});

parcelRegister("lk57E", function(module, exports) {

let $f85f707301fee1fb$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $f85f707301fee1fb$var$load("fliVL"),
    $f85f707301fee1fb$var$load("76n7a"),
    $f85f707301fee1fb$var$load("l253H"),
    $f85f707301fee1fb$var$load("ffQaD"),
    $f85f707301fee1fb$var$load("kvRbA"),
    $f85f707301fee1fb$var$load("kNFvF"),
    $f85f707301fee1fb$var$load("3JEjo")
]).then(()=>parcelRequire('9ug1Y'));

});

parcelRegister("gFtpo", function(module, exports) {

let $c227499a18172965$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $c227499a18172965$var$load("7w8Lg").then(()=>parcelRequire('6Tw9l'));

});

parcelRegister("dd8Sn", function(module, exports) {

let $99e35fd8b927d51a$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $99e35fd8b927d51a$var$load("ffQaD"),
    $99e35fd8b927d51a$var$load("kvRbA"),
    $99e35fd8b927d51a$var$load("kDya6")
]).then(()=>parcelRequire('2FwjZ'));

});

parcelRegister("jeFNX", function(module, exports) {

let $e00fc0a9313b40c6$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $e00fc0a9313b40c6$var$load("76n7a"),
    $e00fc0a9313b40c6$var$load("l253H"),
    $e00fc0a9313b40c6$var$load("71t3O")
]).then(()=>parcelRequire('dHHKP'));

});

parcelRegister("3woGh", function(module, exports) {

let $2907815c61dad37c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $2907815c61dad37c$var$load("kCxTP").then(()=>parcelRequire('5KYHN'));

});

parcelRegister("jDPm9", function(module, exports) {

let $e4c97f1ee9129892$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $e4c97f1ee9129892$var$load("ffQaD"),
    $e4c97f1ee9129892$var$load("kvRbA"),
    $e4c97f1ee9129892$var$load("6tXwk")
]).then(()=>parcelRequire('glEdp'));

});

parcelRegister("cmA9s", function(module, exports) {

let $9003950fe244c1b1$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $9003950fe244c1b1$var$load("ffQaD"),
    $9003950fe244c1b1$var$load("kvRbA"),
    $9003950fe244c1b1$var$load("6F0xO")
]).then(()=>parcelRequire('dF4iL'));

});


parcelRegister("fB6mC", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3c66b95e4e31148$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5P88b = parcelRequire("5P88b");
const $f3c66b95e4e31148$var$TextWrapper = (props)=>{
    const { startPos: startPos, endPos: endPos } = props;
    const { children: children } = props;
    if (!children) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5P88b.TextWithAnnotationDraft), {
        startPos: startPos,
        endPos: endPos,
        textHighlighter: props.textHighlighter,
        marks: props.marks,
        children: children
    });
};
var $f3c66b95e4e31148$export$2e2bcd8739ae039 = $f3c66b95e4e31148$var$TextWrapper;

});
parcelRegister("5P88b", function(module, exports) {

$parcel$export(module.exports, "TextWithAnnotationDraft", () => $f285203f0973bda4$export$69a4e0ac39aaf9b7);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $dAxMl = parcelRequire("dAxMl");

var $9Go2F = parcelRequire("9Go2F");

var $lr7KE = parcelRequire("lr7KE");

var $fH5Zn = parcelRequire("fH5Zn");

var $bRAXN = parcelRequire("bRAXN");

var $7Uu7t = parcelRequire("7Uu7t");

var $3OjM0 = parcelRequire("3OjM0");

var $e2m7L = parcelRequire("e2m7L");
function $f285203f0973bda4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Localized AnnotationSharedCSSByState().common and AnnotationSharedCSSByState().focus
const $f285203f0973bda4$var$markStyles = {
    name: "ko40kj",
    styles: "color:inherit;background-color:unset;-webkit-tap-highlight-color:transparent;border-bottom:2px solid transparent;cursor:pointer;padding:1px 0 2px;&:has(.card), &:has([data-inline-card]){padding:5px 0 3px 0;}&:has(.date-lozenger-container){padding-top:var(--ds-space-025, 2px);}background:var(--ds-background-accent-yellow-subtlest-pressed, #F5CD47);border-bottom-color:var(--ds-border-accent-yellow, #B38600);box-shadow:var(--ds-shadow-overlay, 0px 8px 12px #091E4226, 0px 0px 1px #091E424f)"
};
const $f285203f0973bda4$export$8062d68eccdfa39c = ({ draftPosition: draftPosition, children: children })=>{
    const { dispatch: dispatch } = (0, $3OjM0.useAnnotationManagerDispatch)();
    const markRef = (0, $eJOHy.useCallback)((node)=>{
        dispatch({
            type: 'setDraftMarkRef',
            data: {
                draftMarkRef: node ?? undefined
            }
        });
    }, [
        dispatch
    ]);
    return /*#__PURE__*/ (0, $1NIU8.jsx)("mark", {
        "data-renderer-mark": true,
        ...(0, $fH5Zn.dataAttributes)(draftPosition),
        css: $f285203f0973bda4$var$markStyles,
        ref: markRef
    }, children);
};
const $f285203f0973bda4$export$846ef6158669db08 = (annotationPosition, fragmentCount)=>{
    if (annotationPosition === (0, $dAxMl.InsertDraftPosition).START) return 0;
    if (annotationPosition === (0, $dAxMl.InsertDraftPosition).END) return fragmentCount - 1;
    if (annotationPosition === (0, $dAxMl.InsertDraftPosition).INSIDE && fragmentCount === 3) return 1;
    return -1;
};
const $f285203f0973bda4$export$b756d37afc321d72 = ({ texts: texts, shouldApplyAnnotationAt: shouldApplyAnnotationAt, draftPosition: draftPosition, textHighlighter: textHighlighter, marks: marks })=>{
    const annotateIndex = $f285203f0973bda4$export$846ef6158669db08(shouldApplyAnnotationAt, texts.length);
    return texts.map((value, index)=>{
        const segments = (0, $bRAXN.segmentText)(value, textHighlighter);
        if (annotateIndex === index) return(// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        /*#__PURE__*/ (0, $1NIU8.jsx)($f285203f0973bda4$export$8062d68eccdfa39c, {
            key: index,
            draftPosition: draftPosition
        }, (0, $7Uu7t.renderTextSegments)(segments, textHighlighter, marks || [], draftPosition.from)));
        return(// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
            key: index
        }, (0, $7Uu7t.renderTextSegments)(segments, textHighlighter, marks || [], draftPosition.from)));
    });
};
const $f285203f0973bda4$export$69a4e0ac39aaf9b7 = ({ startPos: startPos, endPos: endPos, children: children, textHighlighter: textHighlighter, marks: marks })=>{
    const textPosition = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useMemo(()=>({
            start: startPos,
            end: endPos
        }), [
        endPos,
        startPos
    ]);
    const { selectionDraftDocumentPosition: nextDraftPosition } = (0, $e2m7L.useAnnotationRangeState)();
    const shouldApplyAnnotationAt = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useMemo(()=>{
        if (!nextDraftPosition) return false;
        return (0, $lr7KE.calcInsertDraftPositionOnText)(textPosition, nextDraftPosition);
    }, [
        nextDraftPosition,
        textPosition
    ]);
    const textString = (0, $9Go2F.findTextString)(children);
    if (!textString) return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Fragment), null, children);
    if (shouldApplyAnnotationAt === false || !nextDraftPosition) {
        const segments = (0, $bRAXN.segmentText)(textString, textHighlighter);
        return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Fragment), null, (0, $7Uu7t.renderTextSegments)(segments, textHighlighter, marks || [], startPos));
    }
    if (shouldApplyAnnotationAt === (0, $dAxMl.InsertDraftPosition).AROUND_TEXT) {
        const segments = (0, $bRAXN.segmentText)(textString, textHighlighter);
        return /*#__PURE__*/ (0, $1NIU8.jsx)($f285203f0973bda4$export$8062d68eccdfa39c, {
            key: 0,
            draftPosition: nextDraftPosition
        }, (0, $7Uu7t.renderTextSegments)(segments, textHighlighter, marks || [], startPos));
    }
    const offsets = (0, $9Go2F.calcTextSplitOffset)(nextDraftPosition, textPosition, textString);
    const texts = (0, $9Go2F.splitText)(textString, offsets);
    if (!texts) {
        const segments = (0, $bRAXN.segmentText)(textString, textHighlighter);
        return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Fragment), null, (0, $7Uu7t.renderTextSegments)(segments, textHighlighter, marks || [], startPos));
    }
    const components = $f285203f0973bda4$export$b756d37afc321d72({
        texts: texts,
        shouldApplyAnnotationAt: shouldApplyAnnotationAt,
        draftPosition: nextDraftPosition,
        textHighlighter: textHighlighter,
        marks: marks
    });
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Fragment), null, components);
};

});
parcelRegister("dAxMl", function(module, exports) {

$parcel$export(module.exports, "InsertDraftPosition", () => $75c06ae1a0de2c65$export$c1bd4813440b4505);
var $75c06ae1a0de2c65$export$c1bd4813440b4505 = /*#__PURE__*/ function(InsertDraftPosition) {
    InsertDraftPosition["AROUND_TEXT"] = "AROUND_TEXT";
    InsertDraftPosition["START"] = "START";
    InsertDraftPosition["END"] = "END";
    InsertDraftPosition["INSIDE"] = "INSIDE";
    return InsertDraftPosition;
}({});

});

parcelRegister("9Go2F", function(module, exports) {

$parcel$export(module.exports, "findTextString", () => $d3e611b0662150a6$export$a9795c84b22a1f06);
$parcel$export(module.exports, "splitText", () => $d3e611b0662150a6$export$2878cc467c8be8fe);
$parcel$export(module.exports, "calcTextSplitOffset", () => $d3e611b0662150a6$export$1059bfc467f4f55d);

var $eJOHy = parcelRequire("eJOHy");
const $d3e611b0662150a6$export$a9795c84b22a1f06 = (reactNode)=>{
    let result = null;
    const children = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.toArray(reactNode);
    for (const childNode of children){
        if (result) break;
        else if (typeof childNode === 'string') result = childNode;
        else if ($d3e611b0662150a6$var$isReactElement(childNode) && childNode.props.children) result = $d3e611b0662150a6$export$a9795c84b22a1f06(childNode.props.children);
    }
    return result;
};
function $d3e611b0662150a6$var$isReactElement(child) {
    return !!child.type;
}
const $d3e611b0662150a6$export$2878cc467c8be8fe = (text, { startOffset: startOffset, endOffset: endOffset })=>{
    if (endOffset > text.length || endOffset - startOffset <= 0) return null;
    return [
        text.slice(0, startOffset),
        text.slice(startOffset, endOffset),
        text.slice(endOffset)
    ].filter(Boolean);
};
const $d3e611b0662150a6$export$1059bfc467f4f55d = (position, textPosition, text)=>{
    const { start: start, end: end } = textPosition;
    const startOffset = Math.max(position.from - start, 0);
    const endOffset = Math.min(Math.abs(end - position.to - text.length), text.length);
    return {
        startOffset: startOffset,
        endOffset: endOffset
    };
};

});

parcelRegister("lr7KE", function(module, exports) {

$parcel$export(module.exports, "calcInsertDraftPositionOnText", () => $289f20261f120a5e$export$b1baddbd5f289877);

var $dAxMl = parcelRequire("dAxMl");
const $289f20261f120a5e$export$b1baddbd5f289877 = ({ start: startTextPosition, end: endTextPosition }, position)=>{
    const isRangePositionAroundText = position.from <= startTextPosition && position.to >= endTextPosition;
    if (isRangePositionAroundText) return (0, $dAxMl.InsertDraftPosition).AROUND_TEXT;
    const isRangePositionInsideText = position.from > startTextPosition && position.from < endTextPosition && position.to < endTextPosition && position.to > startTextPosition;
    if (isRangePositionInsideText) return (0, $dAxMl.InsertDraftPosition).INSIDE;
    const isRangePositionStartingAtText = position.from >= startTextPosition && position.from <= endTextPosition && position.to >= endTextPosition;
    if (isRangePositionStartingAtText) return (0, $dAxMl.InsertDraftPosition).END;
    const isRangePositionEndingAtText = position.from <= startTextPosition && position.to >= startTextPosition && position.to <= endTextPosition;
    if (isRangePositionEndingAtText) return (0, $dAxMl.InsertDraftPosition).START;
    return false;
};

});

parcelRegister("bRAXN", function(module, exports) {

$parcel$export(module.exports, "segmentText", () => $9bd02ef7824cc2a4$export$93301b6f1ff0b0c3);
function $9bd02ef7824cc2a4$export$93301b6f1ff0b0c3(text, highlighter) {
    if (!highlighter || !text) return [
        {
            type: 'plain',
            text: text ?? ''
        }
    ];
    const segments = [];
    let pos = 0;
    try {
        const markTextSegmentMatches = text.matchAll(highlighter.pattern);
        for (const markTextMatch of markTextSegmentMatches){
            if (markTextMatch.index !== 0) segments.push({
                type: 'plain',
                text: text.substring(pos, markTextMatch.index)
            });
            segments.push({
                type: 'match',
                text: markTextMatch[0],
                groups: markTextMatch.groups && // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                Object.keys(markTextMatch.groups).filter((key)=>markTextMatch.groups[key])
            });
            pos = markTextMatch.index + markTextMatch[0].length;
        }
        if (pos < text.length) segments.push({
            type: 'plain',
            text: text.substring(pos)
        });
        return segments;
    } catch (_e) {}
    return [
        {
            type: 'plain',
            text: text
        }
    ];
}

});

parcelRegister("7Uu7t", function(module, exports) {

$parcel$export(module.exports, "renderTextSegments", () => $ee7ad9044e65fe28$export$8a20fd0614851c5f);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
function $ee7ad9044e65fe28$export$8a20fd0614851c5f(segments, textHighlighter, marksList, startPos) {
    const Component = textHighlighter?.component;
    const marks = new Set(marksList.map((m)=>m.type.name));
    function renderSegment(segment, idx = 0) {
        if (segment.type === 'plain' || !Component) return segment.text;
        return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
            "data-highlighted": true,
            "data-vc": "highlighted-text",
            children: /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
                match: segment.text,
                groups: segment.groups,
                marks: marks,
                startPos: startPos + idx,
                children: segment.text
            }, `${segment.text}_${startPos}_${idx}`)
        });
    }
    if (segments.length === 1) return renderSegment(segments[0]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
        children: segments.map(renderSegment)
    }, `text-wrapper_${startPos}`);
}

});



parcelRegister("fpMtm", function(module, exports) {

$parcel$export(module.exports, "isAnnotationMark", () => $8e95121bd58c9778$export$855795c145f03402);
$parcel$export(module.exports, "default", () => $8e95121bd58c9778$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $jxPcD = parcelRequire("jxPcD");

var $jAnZ0 = parcelRequire("jAnZ0");
const $8e95121bd58c9778$export$855795c145f03402 = (mark)=>{
    return mark && mark.type && mark.type.name === 'annotation';
};
const $8e95121bd58c9778$var$AnnotationComponent = ({ id: id, annotationType: annotationType, children: children, dataAttributes: dataAttributes, annotationParentIds: annotationParentIds = [], allowAnnotations: allowAnnotations, useBlockLevel: useBlockLevel, isMediaInline: isMediaInline })=>{
    const data = {
        ...dataAttributes,
        ...(0, $jxPcD.buildDataAttributes)({
            id: id,
            annotationType: annotationType
        })
    };
    if (allowAnnotations) return isMediaInline ? // Inline comment on mediaInline is not supported as part of comments on media project,
    // hence skip any styling/event handling for annotations on mediaInline.
    // `id` is still needed so that comment view component can be correct positioned
    // when using comment navigation to access comments on mediaInline
    /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        id: id,
        children: children
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jAnZ0.MarkElement), {
        id: id,
        dataAttributes: data,
        annotationParentIds: annotationParentIds,
        annotationType: annotationType,
        useBlockLevel: useBlockLevel,
        children: children
    });
    return(// Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        id: id,
        ...data,
        children: children
    }));
};
var $8e95121bd58c9778$export$2e2bcd8739ae039 = $8e95121bd58c9778$var$AnnotationComponent;

});
parcelRegister("jAnZ0", function(module, exports) {

$parcel$export(module.exports, "MarkElement", () => $79e3bb2207ad1bdc$export$f3069f755c1eba0b);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $jxPcD = parcelRequire("jxPcD");

var $4Fc33 = parcelRequire("4Fc33");

var $kyRoR = parcelRequire("kyRoR");

var $8QIFO = parcelRequire("8QIFO");

var $eq5No = parcelRequire("eq5No");

var $iNoZC = parcelRequire("iNoZC");

var $eFHDV = parcelRequire("eFHDV");

var $3OjM0 = parcelRequire("3OjM0");
const $79e3bb2207ad1bdc$export$f3069f755c1eba0b = ({ annotationParentIds: annotationParentIds, children: children, dataAttributes: dataAttributes, id: id, useBlockLevel: useBlockLevel })=>{
    const updateSubscriber = (0, $eq5No.useInlineCommentSubscriberContext)();
    const states = (0, $eJOHy.useContext)((0, $eFHDV.InlineCommentsStateContext));
    const { hasFocus: hasFocus, isHovered: isHovered } = (0, $iNoZC.useHasFocusEvent)({
        id: id,
        updateSubscriber: updateSubscriber
    });
    const dataAttributesMemorized = (0, $eJOHy.useMemo)(()=>dataAttributes, [
        dataAttributes
    ]);
    const { dispatch: dispatch, annotationManager: annotationManager } = (0, $3OjM0.useAnnotationManagerDispatch)();
    const onClick = (0, $eJOHy.useCallback)((props)=>{
        if (!updateSubscriber) return;
        if (useBlockLevel) return;
        const { eventTarget: eventTarget, annotationIds: annotationIds } = props;
        if (annotationManager) {
            if (hasFocus) {
                dispatch({
                    type: 'resetSelectedAnnotation'
                });
                return;
            }
            annotationManager.checkPreemptiveGate().then((canSelect)=>{
                if (canSelect) {
                    // if there is a draft, clear it first
                    annotationManager?.clearDraft();
                    // use setIsAnnotationSelected won't work here if there is a draft in progress
                    // so we need to use dispatch to update the state directly
                    dispatch({
                        type: 'updateAnnotation',
                        data: {
                            id: annotationIds[0],
                            selected: true
                        }
                    });
                    dispatch({
                        type: 'setSelectedMarkRef',
                        data: {
                            markRef: eventTarget
                        }
                    });
                }
            }).catch((error)=>{
            // TODO: EDITOR-595 - An error occurred while checking the preemptive gate. We should report this error.
            });
        } else updateSubscriber.emit((0, $4Fc33.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
            annotationIds: annotationIds,
            eventTarget: eventTarget
        });
    }, [
        updateSubscriber,
        useBlockLevel,
        dispatch,
        annotationManager,
        hasFocus
    ]);
    const activeParentIds = (0, $8QIFO.useInlineCommentsFilter)({
        annotationIds: annotationParentIds,
        filter: {
            state: (0, $jxPcD.AnnotationMarkStates).ACTIVE
        }
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kyRoR.MarkComponent), {
        id: id,
        dataAttributes: dataAttributesMemorized,
        annotationParentIds: activeParentIds,
        onClick: onClick,
        hasFocus: hasFocus,
        isHovered: isHovered,
        state: states[id],
        useBlockLevel: useBlockLevel,
        children: children
    });
};

});
parcelRegister("kyRoR", function(module, exports) {

$parcel$export(module.exports, "MarkComponent", () => $77ee966c5ae21f53$export$4f5a51511304fdd0);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $jxPcD = parcelRequire("jxPcD");

var $eGOwo = parcelRequire("eGOwo");

var $lRq8t = parcelRequire("lRq8t");

var $4Iw1X = parcelRequire("4Iw1X");

var $3OjM0 = parcelRequire("3OjM0");
const $77ee966c5ae21f53$var$markStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    color: 'inherit',
    backgroundColor: 'unset',
    WebkitTapHighlightColor: 'transparent',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`&[data-mark-annotation-state='${(0, $jxPcD.AnnotationMarkStates).ACTIVE}']`]: {
        // was from blur in AnnotationSharedCSSByState().blur
        background: "var(--ds-background-accent-yellow-subtlest, #FFF7D6)",
        borderBottom: `2px solid ${"var(--ds-border-accent-yellow, #B38600)"}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&[data-has-focus="true"]': {
            background: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
            borderBottom: `2px solid ${"var(--ds-border-accent-yellow, #B38600)"}`,
            // TODO: DSP-4147 - Annotation shadow
            boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #091E4226, 0px 0px 1px #091E424f)",
            cursor: 'pointer'
        }
    }
});
const $77ee966c5ae21f53$var$markStylesLayeringFix = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`&[data-mark-annotation-state='${(0, $jxPcD.AnnotationMarkStates).ACTIVE}']`]: {
        // Only apply transparency to nested marks when parent is focused
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&[data-has-focus="true"] mark': {
            backgroundColor: 'transparent'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.fabric-background-color-mark &[data-has-focus="true"], &[data-has-focus="true"]': {
            background: "var(--ds-background-accent-yellow-subtlest-pressed, #F5CD47)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
            boxShadow: "var(--ds-shadow-raised, 0px 1px 1px #091E4240, 0px 0px 1px #091E424f)"
        }
    }
});
const $77ee966c5ae21f53$var$markStylesWithUpdatedShadow = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`&[data-mark-annotation-state='${(0, $jxPcD.AnnotationMarkStates).ACTIVE}']`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&[data-has-focus="true"]': {
            background: "var(--ds-background-accent-yellow-subtlest-pressed, #F5CD47)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
            boxShadow: "var(--ds-shadow-raised, 0px 1px 1px #091E4240, 0px 0px 1px #091E424f)"
        }
    }
});
const $77ee966c5ae21f53$var$markStylesWithInlineComments = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`&[data-mark-annotation-state='${(0, $jxPcD.AnnotationMarkStates).ACTIVE}']`]: {
        // was from common in AnnotationSharedCSSByState().common
        borderBottom: '2px solid transparent',
        cursor: 'pointer',
        padding: '1px 0 2px',
        // it was under fg(annotations_align_editor_and_renderer_styles) from AnnotationSharedCSSByState().common, assume it's on as already rolled out
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:has(.card), &:has([data-inline-card])': {
            padding: '5px 0 3px 0'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:has(.date-lozenger-container)': {
            paddingTop: "var(--ds-space-025, 2px)"
        },
        // was from blur in AnnotationSharedCSSByState().blur
        background: "var(--ds-background-accent-yellow-subtlest, #FFF7D6)",
        borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&[data-has-focus="true"]': {
            background: "var(--ds-background-accent-yellow-subtlest-pressed, #F5CD47)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
            boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #091E4226, 0px 0px 1px #091E424f)"
        }
    }
});
const $77ee966c5ae21f53$var$markStylesWithCommentsPanel = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`&[data-mark-annotation-state='${(0, $jxPcD.AnnotationMarkStates).ACTIVE}']`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&[data-is-hovered="true"]:not([data-has-focus="true"])': {
            background: "var(--ds-background-accent-yellow-subtlest-hovered, #F8E6A0)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
            boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #091E4226, 0px 0px 1px #091E424f)"
        }
    }
});
const $77ee966c5ae21f53$var$isMobile = ()=>{
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};
const $77ee966c5ae21f53$var$accessibilityStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    '&::before, &::after': {
        clipPath: 'inset(100%)',
        clip: 'rect(1px, 1px, 1px, 1px)',
        height: '1px',
        overflow: 'hidden',
        position: 'absolute',
        whiteSpace: 'nowrap',
        width: '1px'
    },
    '&::before': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        content: `' [var(--ak-renderer-annotation-startmarker)] '`
    },
    '&::after': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        content: `' [var(--ak-renderer-annotation-endmarker)] '`
    }
});
const $77ee966c5ae21f53$export$4f5a51511304fdd0 = ({ annotationParentIds: annotationParentIds, children: children, dataAttributes: dataAttributes, id: id, state: state, hasFocus: hasFocus, isHovered: isHovered, onClick: onClick, useBlockLevel: useBlockLevel })=>{
    const intl = (0, $lRq8t.default)();
    const annotationIds = (0, $eJOHy.useMemo)(()=>[
            ...new Set([
                ...annotationParentIds,
                id
            ])
        ], [
        id,
        annotationParentIds
    ]);
    const { annotationManager: annotationManager, dispatch: dispatch } = (0, $3OjM0.useAnnotationManagerDispatch)();
    const { currentSelectedAnnotationId: currentSelectedAnnotationId } = (0, $3OjM0.useAnnotationManagerState)();
    const isAnnotationManagerEnabled = !!annotationManager;
    // after creating a new annotation, we need to set the markRef to the new mark
    const markRef = (0, $eJOHy.useCallback)((node)=>{
        if (id === currentSelectedAnnotationId && node) dispatch({
            type: 'setSelectedMarkRef',
            data: {
                markRef: node
            }
        });
    }, [
        dispatch,
        id,
        currentSelectedAnnotationId
    ]);
    const onMarkClick = (0, $eJOHy.useCallback)((event)=>{
        // prevent inline mark logic for media block marks
        if (event.currentTarget instanceof HTMLElement && event.currentTarget.getAttribute('data-block-mark')) return;
        // prevents multiple callback on overlapping annotations
        if (event.defaultPrevented || state !== (0, $jxPcD.AnnotationMarkStates).ACTIVE) return;
        if ((0, $eGOwo.fg)('editor_inline_comments_on_inline_nodes')) // We only want to interfere with click events if the click is on some ui inside the renderer document
        // This is to prevent the click events from portaled content (such as link previews and mention profiles)
        {
            if (event.target instanceof HTMLElement && event.target.closest('.ak-renderer-document')) {
                if (event.target.closest('[data-mention-id]')) ;
                else {
                    // prevents from opening link URL inside webView in Safari
                    event.preventDefault();
                    event.stopPropagation();
                }
            }
        } else // prevents from opening link URL inside webView in Safari
        event.preventDefault();
        if (isAnnotationManagerEnabled) // currentTarget is the right element if there are multiple overlapping annotations
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        onClick({
            eventTarget: event.currentTarget,
            annotationIds: annotationIds
        });
        else // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        onClick({
            eventTarget: event.target,
            annotationIds: annotationIds
        });
    }, [
        annotationIds,
        onClick,
        state,
        isAnnotationManagerEnabled
    ]);
    const onMarkEnter = (evt)=>{
        const focusedElementTag = document.activeElement?.tagName;
        if (focusedElementTag === 'MARK' && evt.key === 'Enter') onMarkClick(evt);
    };
    const overriddenData = !state ? dataAttributes : {
        ...dataAttributes,
        'data-mark-annotation-state': state,
        'data-has-focus': hasFocus,
        'data-is-hovered': isHovered
    };
    const desktopAccessibilityAttributes = $77ee966c5ae21f53$var$isMobile() ? {} : {
        role: 'button',
        tabIndex: 0,
        onKeyDown: onMarkEnter,
        'aria-expanded': hasFocus
    };
    const accessibility = state !== (0, $jxPcD.AnnotationMarkStates).ACTIVE ? {
        'aria-disabled': true
    } : {
        'aria-details': annotationIds.join(', '),
        ...desktopAccessibilityAttributes
    };
    return (0, $1NIU8.jsx)(useBlockLevel ? 'div' : 'mark', {
        ref: id === currentSelectedAnnotationId ? markRef : undefined,
        id: id,
        [(0, $eGOwo.fg)('editor_inline_comments_on_inline_nodes') ? 'onClickCapture' : 'onClick']: onMarkClick,
        ...accessibility,
        ...overriddenData,
        ...!useBlockLevel && {
            css: [
                $77ee966c5ae21f53$var$markStyles,
                (0, $eGOwo.fg)('platform_renderer_nested_annotation_styling') && $77ee966c5ae21f53$var$markStylesLayeringFix,
                (0, $eGOwo.fg)('editor_inline_comments_on_inline_nodes') && $77ee966c5ae21f53$var$markStylesWithInlineComments,
                (0, $eGOwo.fg)('confluence-frontend-comments-panel') && $77ee966c5ae21f53$var$markStylesWithCommentsPanel,
                !$77ee966c5ae21f53$var$isMobile() && $77ee966c5ae21f53$var$accessibilityStyles,
                $77ee966c5ae21f53$var$markStylesWithUpdatedShadow
            ],
            style: {
                '--ak-renderer-annotation-startmarker': intl.formatMessage((0, $4Iw1X.inlineCommentMessages).contentRendererInlineCommentMarkerStart),
                '--ak-renderer-annotation-endmarker': intl.formatMessage((0, $4Iw1X.inlineCommentMessages).contentRendererInlineCommentMarkerEnd)
            }
        }
    }, children);
};

});

parcelRegister("8QIFO", function(module, exports) {

$parcel$export(module.exports, "useInlineCommentsFilter", () => $fc07fd7dc625d9d7$export$8e7d47f9e38ad4f1);

var $eJOHy = parcelRequire("eJOHy");

var $eFHDV = parcelRequire("eFHDV");
const $fc07fd7dc625d9d7$export$8e7d47f9e38ad4f1 = ({ annotationIds: annotationIds, filter: { state: stateFilter } })=>{
    const states = (0, $eJOHy.useContext)((0, $eFHDV.InlineCommentsStateContext));
    return (0, $eJOHy.useMemo)(()=>{
        return annotationIds.reduce((acc, id)=>{
            if (states && states[id] === stateFilter) return [
                ...acc,
                id
            ];
            return acc;
        }, []);
    }, [
        annotationIds,
        states,
        stateFilter
    ]);
};

});

parcelRegister("eq5No", function(module, exports) {

$parcel$export(module.exports, "useInlineCommentSubscriberContext", () => $5e4da24e72f18355$export$b46737175cffd396);

var $eJOHy = parcelRequire("eJOHy");

var $eFHDV = parcelRequire("eFHDV");
const $5e4da24e72f18355$export$b46737175cffd396 = ()=>{
    const providers = (0, $eJOHy.useContext)((0, $eFHDV.ProvidersContext));
    if (!providers) return null;
    const { inlineComment: { updateSubscriber: updateSubscriber } } = providers;
    return updateSubscriber || null;
};

});



parcelRegister("QAAiN", function(module, exports) {

$parcel$export(module.exports, "toReact", () => $e606d7f5429e1a94$export$d4334b129116aad7);
/* eslint-disable @atlaskit/editor/no-re-export */ // Mapping file

var $37UKp = parcelRequire("37UKp");

var $bIYcL = parcelRequire("bIYcL");

var $edt1J = parcelRequire("edt1J");

var $7B5Pg = parcelRequire("7B5Pg");

var $9PRAt = parcelRequire("9PRAt");

var $lFm6v = parcelRequire("lFm6v");

var $4U2Ut = parcelRequire("4U2Ut");

var $clQ8A = parcelRequire("clQ8A");

var $105lA = parcelRequire("105lA");

var $kh0nj = parcelRequire("kh0nj");

var $agnfA = parcelRequire("agnfA");

var $36uir = parcelRequire("36uir");

var $1JSxg = parcelRequire("1JSxg");

var $1lKH5 = parcelRequire("1lKH5");

var $jLqyg = parcelRequire("jLqyg");

var $5lVub = parcelRequire("5lVub");

var $fpMtm = parcelRequire("fpMtm");

var $79gvV = parcelRequire("79gvV");

var $6Iogh = parcelRequire("6Iogh");
const $e606d7f5429e1a94$export$c00d967a0f56fdb7 = {
    code: (0, $37UKp.default),
    em: (0, $bIYcL.default),
    link: (0, $edt1J.default),
    strike: (0, $7B5Pg.default),
    strong: (0, $9PRAt.default),
    subsup: (0, $lFm6v.default),
    textColor: (0, $4U2Ut.default),
    backgroundColor: (0, $clQ8A.default),
    underline: (0, $105lA.default),
    annotation: (0, $fpMtm.default),
    border: (0, $79gvV.default),
    // Stage0
    confluenceInlineComment: (0, $6Iogh.default),
    breakout: (0, $kh0nj.default),
    alignment: (0, $agnfA.default),
    indentation: (0, $36uir.default),
    unsupportedMark: (0, $1JSxg.default),
    unsupportedNodeAttribute: (0, $1lKH5.default),
    dataConsumer: (0, $jLqyg.default),
    fragment: (0, $5lVub.default)
};
const $e606d7f5429e1a94$export$d4334b129116aad7 = (mark)=>{
    return $e606d7f5429e1a94$export$c00d967a0f56fdb7[mark.type.name];
};

});
parcelRegister("37UKp", function(module, exports) {

$parcel$export(module.exports, "isCodeMark", () => $6bff173c6c794ed6$export$86390c02c110ec2f);
$parcel$export(module.exports, "default", () => $6bff173c6c794ed6$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6YFG2 = parcelRequire("6YFG2");

var $esi81 = parcelRequire("esi81");

var $brgNx = parcelRequire("brgNx");
const $6bff173c6c794ed6$export$86390c02c110ec2f = (mark)=>{
    return mark && mark.type && mark.type.name === 'code';
};
function $6bff173c6c794ed6$export$7cea6ffa7022e85f(props) {
    const codeBidiWarningLabel = props.intl.formatMessage((0, $brgNx.codeBidiWarningMessages).label);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $esi81.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "code",
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: props.codeBidiWarningTooltipEnabled,
        ...props.dataAttributes,
        children: props.children
    });
}
var $6bff173c6c794ed6$export$2e2bcd8739ae039 = (0, $6YFG2.default)($6bff173c6c794ed6$export$7cea6ffa7022e85f);

});
parcelRegister("esi81", function(module, exports) {

$parcel$export(module.exports, "default", () => $a412e6cbdd328664$export$2e2bcd8739ae039);
/* code.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $hDNIq = parcelRequire("hDNIq");

var $2E9Su = parcelRequire("2E9Su");
const $a412e6cbdd328664$var$styles = {
    base: "_ca0qyh40 _u5f3m5ip _n3tdyh40 _19bvm5ip _2rko1sit _11c81u0j _1reo1wug _18m91wug _1dqoglyw _1e0c1nu9 _bfhktkvp _16d9qvcn _syaz1fxt _vwz41kw7 _1i4q1hna _o5721jtm"
};
/**
 * __Code__
 *
 * Code highlights short strings of code snippets inline with body text.
 *
 * - [Examples](https://atlassian.design/components/code/examples)
 * - [Code](https://atlassian.design/components/code/code)
 * - [Usage](https://atlassian.design/components/code/usage)
 */ const $a412e6cbdd328664$var$Code = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)(function Code({ testId: testId, ...props }, ref) {
    const { children: children, codeBidiWarnings: codeBidiWarnings = true, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled = true, ...otherProps } = props;
    const decoratedChildren = codeBidiWarnings ? /*#__PURE__*/ (0, $gt9Am.jsx)($a412e6cbdd328664$var$RenderCodeChildrenWithBidiWarnings, {
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled,
        children: children
    }) : children;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("code", {
        ref: ref,
        "data-testid": testId,
        ...otherProps,
        className: (0, $hcewu.default)([
            $a412e6cbdd328664$var$styles.base
        ]),
        children: decoratedChildren
    });
}));
function $a412e6cbdd328664$var$RenderCodeChildrenWithBidiWarnings({ children: children, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled }) {
    const replacedChildren = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(children, (childNode)=>{
        if (typeof childNode === 'string') {
            const decorated = (0, $2E9Su.default)(childNode, ({ bidiCharacter: bidiCharacter, index: index })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $hDNIq.default), {
                    bidiCharacter: bidiCharacter,
                    label: codeBidiWarningLabel,
                    tooltipEnabled: codeBidiWarningTooltipEnabled
                }, index));
            return decorated;
        }
        if ($a412e6cbdd328664$var$isReactElement(childNode) && childNode.props.children) {
            // eslint-disable-next-line @repo/internal/react/no-clone-element
            const newChildNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).cloneElement(childNode, {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)($a412e6cbdd328664$var$RenderCodeChildrenWithBidiWarnings, {
                    codeBidiWarningLabel: codeBidiWarningLabel,
                    codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled,
                    children: childNode.props.children
                })
            });
            return newChildNode;
        }
        return childNode;
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
        children: replacedChildren
    });
}
function $a412e6cbdd328664$var$isReactElement(child) {
    return !!child.type;
}
$a412e6cbdd328664$var$Code.displayName = 'Code';
var $a412e6cbdd328664$export$2e2bcd8739ae039 = $a412e6cbdd328664$var$Code;

});
parcelRegister("hDNIq", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ef15aa1302d4294$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $k71qx = parcelRequire("k71qx");

var $6JdWh = parcelRequire("6JdWh");
function $9ef15aa1302d4294$export$2e2bcd8739ae039({ testId: testId, bidiCharacter: bidiCharacter, skipChildren: skipChildren, tooltipEnabled: tooltipEnabled, label: label = 'Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code.' }) {
    if (tooltipEnabled) return(// Following patches, this should be updated to use the render props signature which will provide aria attributes.
    // Note: this should be tested, as initial testing did not see attributes work with current tooltip implementation.
    // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
        content: label,
        tag: $9ef15aa1302d4294$var$CustomizedTagWithRef,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6JdWh.Decorator), {
            testId: testId,
            bidiCharacter: bidiCharacter,
            children: skipChildren ? null : bidiCharacter
        })
    }));
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6JdWh.Decorator), {
        testId: testId,
        bidiCharacter: bidiCharacter,
        children: skipChildren ? null : bidiCharacter
    });
}
const $9ef15aa1302d4294$var$CustomizedTagWithRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef((props, ref)=>{
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ...rest,
        ref: ref,
        children: children
    });
});

});
parcelRegister("6JdWh", function(module, exports) {

$parcel$export(module.exports, "Decorator", () => $773f36c924fc369d$export$a592b67c93d52467);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $6fs4r = parcelRequire("6fs4r");
const $773f36c924fc369d$var$decoration = {
    root: "_kqswh2mm _szpl2smr _dsq41wug _1xyt1b66 _123w1b66 _15nnze3t _rxygze3t _1a354jg8 _1j6r1odn _1uakf6fq _1kt9y7el _is06wx40 _1rus1tzq _1cfcvrvc _24gj1h6o _19o61h6o _cfu1116y _1rbawx40 _1xqc1rd4"
};
function $773f36c924fc369d$export$a592b67c93d52467({ bidiCharacter: bidiCharacter, children: children, testId: testId }) {
    const bidiCharacterCode = $773f36c924fc369d$var$getBidiCharacterCode(bidiCharacter);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $eJOHy.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                "data-testid": testId,
                "data-bidi-character-code": bidiCharacterCode,
                // This is set to true so that the content is not read out by
                // screen readers as the content includes angle brackets for
                // visual decoration purposes.
                // We use a visually hidden `mark` element below for screen readers
                "aria-hidden": "true",
                className: (0, $hcewu.default)([
                    $773f36c924fc369d$var$decoration.root
                ]),
                children: children
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6fs4r.default), {
                testId: testId && `${testId}--visually-hidden`,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)("mark", {
                    children: bidiCharacterCode
                })
            })
        ]
    });
}
function $773f36c924fc369d$var$getBidiCharacterCode(bidiCharacter) {
    const bidiCharacterCode = bidiCharacter.codePointAt(0)?.toString(16);
    return `U+${bidiCharacterCode}`;
}

});


parcelRegister("2E9Su", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb505789c157e144$export$2e2bcd8739ae039);
const $fb505789c157e144$export$ecb256e6a1f5ee7e = /[\u202A-\u202E\u2066-\u2069]/g;
function $fb505789c157e144$export$2e2bcd8739ae039(originalText, decorate) {
    const matches = [
        ...originalText.matchAll($fb505789c157e144$export$ecb256e6a1f5ee7e)
    ];
    if (matches.length === 0) // No matches encountered, so we return the originalText value
    return originalText;
    let children = [];
    let mappedTo = 0;
    for (const match of matches){
        if (mappedTo !== match.index) // There were unmatched characters prior to this match which haven't been
        // mapped to the children.
        // Add them as plain text.
        children.push(originalText.substring(mappedTo, match.index));
        children.push(decorate({
            bidiCharacter: match[0],
            index: match.index
        }));
        // While index is guaranteed to be present, it needs to be asserted due
        // to a limitation of typescripts regex handling
        //
        // https://github.com/microsoft/TypeScript/issues/36788
        // Decorate bidi character
        mappedTo = match.index + match[0].length;
    }
    if (mappedTo !== originalText.length) // There is text following the final match, which needs to be mapped
    // to the children.
    // Added as plain text.
    children.push(originalText.substring(mappedTo, originalText.length));
    // return the mapped children with decorated bidi characters
    return children;
}

});



parcelRegister("bIYcL", function(module, exports) {

$parcel$export(module.exports, "default", () => $8786347b58360674$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
function $8786347b58360674$export$2e2bcd8739ae039(props) {
    // ignore the eslint warning Text primitive does not support dataAttributes
    // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading, @atlaskit/design-system/use-primitives-text
    return /*#__PURE__*/ (0, $gt9Am.jsx)("em", {
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("edt1J", function(module, exports) {

$parcel$export(module.exports, "default", () => $6876389d600286d8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");


var $g9wjI = parcelRequire("g9wjI");

var $7ueoK = parcelRequire("7ueoK");

var $bMFKb = parcelRequire("bMFKb");

var $eGOwo = parcelRequire("eGOwo");

var $l5jZM = parcelRequire("l5jZM");

var $e2B2h = parcelRequire("e2B2h");
const $6876389d600286d8$var$anchorStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    color: `var(--ds-link, ${(0, $7bb4c1736002a04a$export$b3de0ae08da2ce64)})`,
    '&:hover': {
        color: `var(--ds-link, ${(0, $7bb4c1736002a04a$export$e62e8919cca44969)})`,
        textDecoration: 'underline'
    },
    '&:active': {
        color: `var(--ds-link-pressed, ${(0, $7bb4c1736002a04a$export$a6ee3d71bc067634)})`
    }
});
function $6876389d600286d8$export$2e2bcd8739ae039(props) {
    const { href: href, target: target, eventHandlers: eventHandlers, fireAnalyticsEvent: fireAnalyticsEvent, isMediaLink: isMediaLink, dataAttributes: dataAttributes } = props;
    const anchorProps = {
        href: href,
        target: target,
        title: href
    };
    if (target === '_blank') anchorProps.rel = 'noreferrer noopener';
    const handler = (0, $g9wjI.getEventHandler)(eventHandlers, 'link');
    if (isMediaLink) return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Fragment), null, props.children);
    const analyticsData = {
        attributes: {
            location: 'renderer'
        },
        // Below is added for the future implementation of Linking Platform namespaced analytic context
        location: 'renderer'
    };
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $e2B2h.default), {
        data: analyticsData
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $l5jZM.default), {
        css: $6876389d600286d8$var$anchorStyles,
        onClick: (e)=>{
            if (fireAnalyticsEvent) fireAnalyticsEvent({
                action: (0, $bMFKb.ACTION).VISITED,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).LINK,
                eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
                attributes: {
                    platform: (0, $7ueoK.PLATFORM).WEB,
                    mode: (0, $7ueoK.MODE).RENDERER
                }
            });
            if (handler) handler(e, href);
        },
        ...anchorProps,
        ...dataAttributes,
        ...(0, $eGOwo.fg)('platform_editor_hyperlink_underline') && {
            isLinkComponent: true
        }
    }, props.children));
}

});
parcelRegister("g9wjI", function(module, exports) {

$parcel$export(module.exports, "ADFEncoder", () => $cd37434dd3346d1d$export$bcf771b83128eae7);
$parcel$export(module.exports, "getText", () => $cd37434dd3346d1d$export$c72d34660a162238);
$parcel$export(module.exports, "getEventHandler", () => $cd37434dd3346d1d$export$eee20638634729b3);
$parcel$export(module.exports, "findInTree", () => $cd37434dd3346d1d$export$38b61ebf4950cd39);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $8DB98 = parcelRequire("8DB98");

var $lovmf = parcelRequire("lovmf");
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $cd37434dd3346d1d$var$createEncoder(parser, encoder) {
    return (value)=>encoder.encode(parser.parse(value));
}
class $cd37434dd3346d1d$export$bcf771b83128eae7 {
    constructor(createTransformerWithSchema){
        const transformer = createTransformerWithSchema((0, $8DB98.defaultSchema));
        this.encode = $cd37434dd3346d1d$var$createEncoder(transformer, new (0, $lovmf.JSONTransformer)());
    }
}
const $cd37434dd3346d1d$export$c72d34660a162238 = (node)=>{
    return node.text || node.attrs && (node.attrs.text || node.attrs.shortName) || `[${typeof node.type === 'string' ? node.type : node.type.name}]`;
};
const $cd37434dd3346d1d$export$eee20638634729b3 = (eventHandlers, type, eventName = 'onClick')=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return eventHandlers && type && eventHandlers[type] && eventHandlers[type][eventName];
};
function $cd37434dd3346d1d$export$38b61ebf4950cd39(element, topElement, evaluate) {
    if (element === topElement) return false;
    if (evaluate(element)) return true;
    if (!element.parentElement) return false;
    return $cd37434dd3346d1d$export$38b61ebf4950cd39(element.parentElement, topElement, evaluate);
}

});

parcelRegister("l5jZM", function(module, exports) {

$parcel$export(module.exports, "default", () => $1beed08016469a9f$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");

var $dUaMU = parcelRequire("dUaMU");

var $eJ9f5 = parcelRequire("eJ9f5");

var $eGOwo = parcelRequire("eGOwo");

var $liquj = parcelRequire("liquj");

var $1gQOQ = parcelRequire("1gQOQ");

var $zJfva = parcelRequire("zJfva");

var $jBltW = parcelRequire("jBltW");
const $1beed08016469a9f$var$PACKAGE_DATA = {
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local",
    componentName: 'linkUrl'
};
const $1beed08016469a9f$var$Anchor = (0, $liquj.withLinkClickedEvent)('a');
const $1beed08016469a9f$export$8c0773eab230d49e = (0, $liquj.withLinkClickedEvent)((0, $eJ9f5.default));
const $1beed08016469a9f$var$LinkUrl = ({ href: href, children: children, checkSafety: checkSafety = true, onClick: onClick, testId: testId = 'link-with-safety', isLinkComponent: isLinkComponent = false, ...props })=>{
    (0, $gRw8I.di)($1beed08016469a9f$export$8c0773eab230d49e, (0, $jBltW.useLinkWarningModal));
    const { isLinkSafe: isLinkSafe, showSafetyWarningModal: showSafetyWarningModal, ...linkWarningModalProps } = (0, $jBltW.useLinkWarningModal)();
    const Link = isLinkComponent && (0, $eGOwo.fg)('platform_editor_hyperlink_underline') ? $1beed08016469a9f$export$8c0773eab230d49e : $1beed08016469a9f$var$Anchor;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1gQOQ.LinkAnalyticsContext), {
                url: href,
                display: "url",
                children: /*#__PURE__*/ (0, $gt9Am.jsx)(Link, {
                    "data-testid": testId,
                    href: href || '',
                    onClick: (e)=>{
                        if (!checkSafety) {
                            onClick && onClick(e);
                            return;
                        }
                        // Only call the onClick if the link is safe
                        if (isLinkSafe(e, href)) onClick && onClick(e);
                        else showSafetyWarningModal(e, href);
                    },
                    ...props,
                    children: children
                })
            }),
            checkSafety && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $zJfva.default), {
                ...linkWarningModalProps
            })
        ]
    });
};
var $1beed08016469a9f$export$2e2bcd8739ae039 = (0, $dUaMU.default)($1beed08016469a9f$var$PACKAGE_DATA)($1beed08016469a9f$var$LinkUrl);

});
parcelRegister("liquj", function(module, exports) {

$parcel$export(module.exports, "fireLinkClickedEvent", () => $9bb097c912a9f010$export$7987de3055fbdcb0);
$parcel$export(module.exports, "withLinkClickedEvent", () => $9bb097c912a9f010$export$263352d59c0c5966);

var $eJOHy = parcelRequire("eJOHy");

var $8GnsF = parcelRequire("8GnsF");

var $e3qu2 = parcelRequire("e3qu2");

var $b43DQ = parcelRequire("b43DQ");
const $9bb097c912a9f010$export$cfb45d54e1604f6c = new Map([
    [
        undefined,
        'none'
    ],
    [
        0,
        'left'
    ],
    [
        1,
        'middle'
    ],
    [
        2,
        'right'
    ]
]);
const $9bb097c912a9f010$export$74743eda5dda3ccf = (e)=>{
    return [
        'alt',
        'ctrl',
        'meta',
        'shift'
    ].filter((key)=>e[`${key}Key`] === true);
};
const $9bb097c912a9f010$var$isContentEditable = (el)=>{
    return el instanceof HTMLElement && el.isContentEditable;
};
function $9bb097c912a9f010$export$d2a83e3b34be812b(e, clickType) {
    const { mac: mac, safari: safari } = (0, $8GnsF.browser)();
    /**
	 * If the link/parent is content editable then left click won't have typical effect
	 */ if ($9bb097c912a9f010$var$isContentEditable(e.currentTarget) && [
        'left',
        'middle'
    ].includes(clickType)) return 'contentEditable';
    switch(clickType){
        case 'left':
        case 'keyboard':
            {
                // Meta key = Cmd for macOS, Windows key sometimes for Windows (otherwise false)
                // https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/metaKey
                if (e.metaKey) return mac ? 'clickThroughNewTabOrWindow' : 'clickThrough';
                if (e.shiftKey) {
                    // Alt/option click in safari typically adds the link to bookmarks
                    if (safari) return 'alt';
                    return 'clickThroughNewTabOrWindow';
                }
                if (e.ctrlKey) {
                    // Ctrl+Left on macOS defaults to triggering a right click instead (so won't trigger onClick)
                    // but if this behaviour is disabled, likely outcome is clickThrough
                    if (mac) return 'clickThrough';
                    return 'clickThroughNewTabOrWindow';
                }
                if (e.altKey) return 'alt';
                const target = e.currentTarget.getAttribute('target');
                if (target === '_blank') return 'clickThroughNewTabOrWindow';
                return 'clickThrough';
            }
        case 'middle':
            return 'clickThroughNewTabOrWindow';
        case 'right':
            return 'contextMenu';
    }
    return 'unknown';
}
const $9bb097c912a9f010$var$linkClickedEvent = ({ clickType: clickType, clickOutcome: clickOutcome, keysHeld: keysHeld, defaultPrevented: defaultPrevented })=>({
        action: 'clicked',
        actionSubject: 'link',
        eventType: 'ui',
        attributes: {
            clickType: clickType,
            clickOutcome: clickOutcome,
            keysHeld: keysHeld,
            defaultPrevented: defaultPrevented
        }
    });
const $9bb097c912a9f010$export$7fedc699766c16de = (event)=>{
    // Through the `detail` property, we're able to determine if the event is (most likely) triggered via keyboard
    // https://developer.mozilla.org/en-US/docs/Web/API/UIEvent/detail
    const isKeyboard = event.nativeEvent.detail === 0;
    const clickType = isKeyboard ? 'keyboard' : $9bb097c912a9f010$export$cfb45d54e1604f6c.get(event.button);
    if (!clickType) return;
    const clickOutcome = $9bb097c912a9f010$export$d2a83e3b34be812b(event, clickType);
    const keysHeld = $9bb097c912a9f010$export$74743eda5dda3ccf(event);
    const defaultPrevented = event.defaultPrevented;
    const linkClickedEventResult = $9bb097c912a9f010$var$linkClickedEvent({
        clickType: clickType,
        clickOutcome: clickOutcome,
        keysHeld: keysHeld,
        defaultPrevented: defaultPrevented
    });
    // if the current target is an anchor tag, we can get the href from it and use that as the url being navigated too.
    if (event.currentTarget instanceof HTMLAnchorElement) {
        const url = event.currentTarget.href;
        return {
            ...linkClickedEventResult,
            nonPrivacySafeAttributes: {
                url: url
            }
        };
    } else // We can't get the href from the event target, so dont include the url or any non privacy safe attributes
    return linkClickedEventResult;
};
const $9bb097c912a9f010$export$7987de3055fbdcb0 = (createAnalyticsEvent)=>(event, overrides = {})=>{
        const payload = $9bb097c912a9f010$export$7fedc699766c16de(event);
        if (payload) createAnalyticsEvent({
            ...payload,
            ...overrides,
            attributes: {
                ...payload.attributes,
                ...overrides?.attributes
            },
            nonPrivacySafeAttributes: {
                ...payload.nonPrivacySafeAttributes,
                ...overrides?.nonPrivacySafeAttributes
            }
        }).fire((0, $b43DQ.ANALYTICS_CHANNEL));
    };
const $9bb097c912a9f010$var$getDisplayName = (WrappedComponent)=>{
    if (typeof WrappedComponent === 'string') return WrappedComponent;
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};
function $9bb097c912a9f010$export$263352d59c0c5966(WrappedComponent) {
    const Component = (props)=>{
        const onClick = (0, $e3qu2.useLinkClicked)(props.onClick);
        const onMouseDown = (0, $e3qu2.useMouseDownEvent)(props.onMouseDown);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(WrappedComponent, {
            ...props,
            onClick: onClick,
            onMouseDown: onMouseDown
        });
    };
    Component.displayName = `withLinkClickedEvent(${$9bb097c912a9f010$var$getDisplayName(WrappedComponent)})`;
    return Component;
}

});
parcelRegister("8GnsF", function(module, exports) {

$parcel$export(module.exports, "browser", () => $9001dc59012896ed$export$3f2684e5d7cb1006);
const $9001dc59012896ed$var$result = {
    mac: false,
    ie: false,
    ie_version: 0,
    gecko: false,
    chrome: false,
    chrome_version: 0,
    android: false,
    ios: false,
    webkit: false,
    safari: false,
    supportsIntersectionObserver: false,
    supportsResizeObserver: false
};
if (typeof navigator !== 'undefined') {
    const ieEdge = /Edge\/(\d+)/.exec(navigator.userAgent);
    const ieUpTo10 = /MSIE \d/.test(navigator.userAgent);
    const ie11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
    $9001dc59012896ed$var$result.mac = /Mac/.test(navigator.platform);
    let ie = $9001dc59012896ed$var$result.ie = !!(ieUpTo10 || ie11up || ieEdge);
    $9001dc59012896ed$var$result.ie_version = ieUpTo10 ? document.documentMode || 6 : ie11up ? +ie11up[1] : ieEdge ? +ieEdge[1] : null;
    $9001dc59012896ed$var$result.gecko = !ie && /gecko\/\d/i.test(navigator.userAgent);
    $9001dc59012896ed$var$result.chrome = !ie && /Chrome\//.test(navigator.userAgent);
    $9001dc59012896ed$var$result.chrome_version = parseInt((navigator.userAgent.match(/Chrome\/(\d+)/) || [])[1], 10);
    $9001dc59012896ed$var$result.android = /Android \d/.test(navigator.userAgent);
    $9001dc59012896ed$var$result.ios = !ie && /AppleWebKit/.test(navigator.userAgent) && /Mobile\/\w+/.test(navigator.userAgent);
    $9001dc59012896ed$var$result.webkit = !ie && !!document.documentElement && 'WebkitAppearance' in document.documentElement.style;
    $9001dc59012896ed$var$result.safari = Boolean(navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && navigator.userAgent.indexOf('CriOS') === -1 && navigator.userAgent.indexOf('FxiOS') === -1);
    $9001dc59012896ed$var$result.supportsIntersectionObserver = typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;
    $9001dc59012896ed$var$result.supportsResizeObserver = typeof window !== 'undefined' && 'ResizeObserver' in window && 'ResizeObserverEntry' in window;
}
function $9001dc59012896ed$export$3f2684e5d7cb1006() {
    return $9001dc59012896ed$var$result;
}

});

parcelRegister("e3qu2", function(module, exports) {

$parcel$export(module.exports, "useLinkClicked", () => $3d45ba8ff999246a$export$5993d3ca6c85f774);
$parcel$export(module.exports, "useMouseDownEvent", () => $3d45ba8ff999246a$export$df67f318ded0283c);

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $liquj = parcelRequire("liquj");
var $3d45ba8ff999246a$export$81a5b494baf0f17c = /*#__PURE__*/ function(ClickButton) {
    ClickButton[ClickButton["Left"] = 0] = "Left";
    ClickButton[ClickButton["Middle"] = 1] = "Middle";
    ClickButton[ClickButton["Right"] = 2] = "Right";
    return ClickButton;
}({});
const $3d45ba8ff999246a$export$5993d3ca6c85f774 = (/**
	 * Handler to
	 */ handler, /**
	 * Filter which mouse events should trigger the link clicked event
	 */ predicate)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    return (0, $eJOHy.useCallback)((...args)=>{
        const [event] = args;
        handler?.apply(null, args);
        if (!predicate || predicate?.(event)) (0, $liquj.fireLinkClickedEvent)(createAnalyticsEvent)(event);
    }, [
        handler,
        predicate,
        createAnalyticsEvent
    ]);
};
const $3d45ba8ff999246a$var$isNotLeftClick = (event)=>event.button !== 0;
const $3d45ba8ff999246a$export$df67f318ded0283c = (onMouseDown)=>{
    return $3d45ba8ff999246a$export$5993d3ca6c85f774(onMouseDown, $3d45ba8ff999246a$var$isNotLeftClick);
};

});

parcelRegister("b43DQ", function(module, exports) {

$parcel$export(module.exports, "ANALYTICS_CHANNEL", () => $3132e66a6b380708$export$85183a312807388d);
$parcel$export(module.exports, "context", () => $3132e66a6b380708$export$a078c61943f9dbbe);
$parcel$export(module.exports, "TrackQuickActionType", () => $3132e66a6b380708$export$72af824fa910c33e);
$parcel$export(module.exports, "TrackQuickActionFailureReason", () => $3132e66a6b380708$export$c89e475f7f7174c2);
$parcel$export(module.exports, "SmartLinkEvents", () => $3132e66a6b380708$export$b91e0203b928470c);
const $3132e66a6b380708$export$85183a312807388d = 'media';
const $3132e66a6b380708$export$a078c61943f9dbbe = {
    componentName: 'smart-cards',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
var $3132e66a6b380708$export$72af824fa910c33e = /*#__PURE__*/ function(TrackQuickActionType) {
    TrackQuickActionType["StatusUpdate"] = "StatusUpdate";
    return TrackQuickActionType;
}({});
var $3132e66a6b380708$export$c89e475f7f7174c2 = /*#__PURE__*/ function(TrackQuickActionFailureReason) {
    TrackQuickActionFailureReason["PermissionError"] = "PermissionError";
    TrackQuickActionFailureReason["ValidationError"] = "ValidationError";
    TrackQuickActionFailureReason["UnknownError"] = "UnknownError";
    return TrackQuickActionFailureReason;
}({});
class $3132e66a6b380708$export$b91e0203b928470c {
    insertSmartLink(url, type, createAnalyticsEvent) {
        $3132e66a6b380708$export$2a123f7ee48a122c({
            action: 'inserted',
            actionSubject: 'smartLink',
            eventType: 'track',
            attributes: {
                type: type
            },
            nonPrivacySafeAttributes: {
                domainName: url
            }
        }, createAnalyticsEvent);
    }
}
const $3132e66a6b380708$export$2a123f7ee48a122c = (payload, createAnalyticsEvent)=>{
    if (createAnalyticsEvent) createAnalyticsEvent(payload).fire($3132e66a6b380708$export$85183a312807388d);
};

});


parcelRegister("1gQOQ", function(module, exports) {

$parcel$export(module.exports, "LinkAnalyticsContext", () => $fe116df880bf8f77$export$9458cdec663b9ff1);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $e2B2h = parcelRequire("e2B2h");
const $fe116df880bf8f77$export$9458cdec663b9ff1 = ({ display: display, id: id, children: children, source: source })=>{
    const displayCategory = display === 'url' ? 'link' : undefined;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $e2B2h.default), {
        data: {
            source: source,
            attributes: {
                displayCategory: displayCategory,
                display: display,
                id: id
            }
        },
        children: children
    });
};

});

parcelRegister("zJfva", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b3c49071625adc0$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $kDaaB = parcelRequire("kDaaB");
var $6YFG2 = parcelRequire("6YFG2");
var $4nehu = parcelRequire("4nehu");

var $goZPP = parcelRequire("goZPP");

var $eJ9f5 = parcelRequire("eJ9f5");

var $fmSFT = parcelRequire("fmSFT");
var $ik0CA = parcelRequire("ik0CA");
var $kseeK = parcelRequire("kseeK");
var $2qG7I = parcelRequire("2qG7I");
var $5a9Ro = parcelRequire("5a9Ro");
var $956it = parcelRequire("956it");

var $19nmp = parcelRequire("19nmp");
const $7b3c49071625adc0$var$breakWordsCss = null;
const $7b3c49071625adc0$var$WarningModal = (props)=>{
    const { isOpen: isOpen, unsafeLinkText: unsafeLinkText, url: url, onClose: onClose, onContinue: onContinue, intl: intl } = props;
    const content = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $956it.default), {
        children: isOpen && /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $fmSFT.default), {
            onClose: onClose,
            testId: "link-with-safety-warning",
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2qG7I.default), {
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5a9Ro.default), {
                        appearance: "warning",
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                            ...(0, $19nmp.messages).check_this_link
                        })
                    })
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ik0CA.default), {
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                        className: (0, $hcewu.default)([
                            "_o5726vc6 _1nmz9jpi"
                        ]),
                        children: url && unsafeLinkText && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                            ...(0, $19nmp.messages).link_safety_warning_message,
                            values: {
                                unsafeLinkText: unsafeLinkText,
                                a: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJ9f5.default), {
                                        href: url,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        children: url
                                    })
                            }
                        })
                    })
                }),
                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $kseeK.default), {
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $goZPP.default), {
                            appearance: "subtle",
                            onClick: onClose,
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                                ...(0, $19nmp.messages).go_back
                            })
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $goZPP.default), {
                            appearance: "warning",
                            onClick: onContinue,
                            autoFocus: true,
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                                ...(0, $19nmp.messages).continue
                            })
                        })
                    ]
                })
            ]
        })
    });
    return intl ? content : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4nehu.default), {
        locale: "en",
        children: content
    });
};
var $7b3c49071625adc0$export$2e2bcd8739ae039 = (0, $6YFG2.default)($7b3c49071625adc0$var$WarningModal, {
    enforceContext: false
});

});
parcelRegister("19nmp", function(module, exports) {

$parcel$export(module.exports, "messages", () => $d6bf071ed8fc5324$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $d6bf071ed8fc5324$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    actions: {
        id: 'fabric.linking.actions',
        defaultMessage: 'Actions',
        description: ''
    },
    add_account: {
        id: 'fabric.linking.add_account',
        defaultMessage: 'Add account',
        description: 'Allows to add a new account'
    },
    ai_summarize: {
        id: 'fabric.linking.ai_summarize',
        defaultMessage: 'Summarize',
        description: 'Action to summarize link resource content with AI'
    },
    ai_summarized: {
        id: 'fabric.linking.ai_summarized',
        defaultMessage: 'Summarized by Atlassian Intelligence',
        description: 'Shown with the content summarised by AI.'
    },
    ai_summarized_abbreviation: {
        id: 'fabric.linking.ai_summarized_abbreviation',
        defaultMessage: 'Summarized by AI',
        description: 'Shown with the content summarised by AI. AI is in abbreviation form to reduce space.'
    },
    ai_summarized_info: {
        id: 'fabric.linking.ai_summarized_info',
        defaultMessage: 'Information quality may vary. <a>Learn more</a>',
        description: 'Additional info about the content summarised by AI.'
    },
    ai_summarized_info_short: {
        id: 'fabric.linking.ai_summarized_info_short',
        defaultMessage: 'Content quality may vary',
        description: 'Additional info about the content summarised by AI.'
    },
    ai_summarizing: {
        id: 'fabric.linking.ai_summarizing',
        defaultMessage: 'Atlassian Intelligence is working...',
        description: 'Shown when AI summary is summarising the link resource content.'
    },
    ai_summary_error_generic: {
        id: 'fabric.linking.ai_summary_error_generic',
        defaultMessage: "Atlassian Intelligence (AI) isn\u2019t responding. Try again later or <a>check the status of AI</a>.",
        description: 'Shown when AI Summary encountered an unexpected error while summarizing the linked resource content.'
    },
    ai_summary_error_acceptable_use_violation: {
        id: 'fabric.linking.ai_summary_error_acceptable_use_violation',
        defaultMessage: "We cannot show the results of this summary as it goes against <a>Atlassian's Acceptable Use Policy</a>.",
        description: 'Shown when AI summary is summarising the link resource content and the content violates atlassians acceptable use policy.'
    },
    ai_summary_error_hipaa_content_detected: {
        id: 'fabric.linking.ai_summary_error_hipaa_content_detected',
        defaultMessage: 'Atlassian Intelligence was unable to process your request as your content contains links to HIPAA restricted content.',
        description: 'Shown when the AI summary is summarising the link resource content and the content contains HIPAA restricted content.'
    },
    ai_summary_error_exceeding_context_length_error: {
        id: 'fabric.linking.ai_summary_error_exceeding_context_length_error',
        defaultMessage: "Atlassian Intelligence can't generate a summary for you right now as there is too much content to summarize.",
        description: 'Shown when the AI summary is summarising the link resource content and the content is too large to summarize.'
    },
    assigned_to: {
        id: 'fabric.linking.assigned_to',
        defaultMessage: 'Assigned to {context}',
        description: 'Indicates the person or entity that the resource is assigned to.'
    },
    automation_action_title: {
        id: 'fabric.linking.automation-action.title',
        defaultMessage: 'View automation rules',
        description: 'The title of the button in a hover card to open an automation menu for a given SmartLink.'
    },
    automation_action_icon_label: {
        id: 'fabric.linking.automation-action.icon.label',
        defaultMessage: 'Automation icon',
        description: 'The label for the automation icon inside of the button opening the automation menu.'
    },
    automation_action_tooltip: {
        id: 'fabric.linking.automation-action.tooltip',
        defaultMessage: 'Select an automation rule to run',
        description: 'The tooltip for the automation action indicating that a button will open an automation modal.'
    },
    automation_action_confluence_page_modal_title: {
        id: 'fabric.linking.automation-action.confluence.page.modal.title',
        defaultMessage: 'Page automations',
        description: 'The title of the automation modal when the SmartLink is a Confluence page'
    },
    automation_action_confluence_page_modal_description: {
        id: 'fabric.linking.automation-action.confluence.page.modal.description',
        defaultMessage: 'Apply an automation to <b>{name}</b>.{br}The available selections are controlled by Confluence and space administrators.',
        description: 'The description in the automation modal when the SmartLink is a Confluence page. Indicating which page the automation will apply to, and who controls the available automations.'
    },
    cancel: {
        id: 'fabric.linking.cancel',
        defaultMessage: 'Cancel',
        description: 'cancel'
    },
    beta: {
        id: 'fabric.linking.beta',
        defaultMessage: 'Beta',
        description: 'Indicates a beta phase of the feature.'
    },
    cannot_connect: {
        id: 'fabric.linking.cannot_connect',
        defaultMessage: "Can't connect, try again",
        description: 'Error for when a provided link is not found.'
    },
    cannot_find_link: {
        id: 'fabric.linking.cannot_find_link',
        defaultMessage: "Can't find link",
        description: 'Error for when a provided link is not found.'
    },
    click_to_join: {
        id: 'fabric.linking.click_to_join',
        defaultMessage: 'Join {context}',
        description: 'Allows the user join the product or service immediately'
    },
    click_to_join_description: {
        id: 'fabric.linking.click_to_join_description',
        defaultMessage: "You've been approved, so you can join {context} right away.",
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    close: {
        id: 'fabric.linking.close',
        defaultMessage: 'Close',
        description: ''
    },
    check_this_link: {
        id: 'fabric.linking.check_this_link',
        defaultMessage: 'Check this link',
        description: 'Link safety warning modal header'
    },
    compass_applied_components_count: {
        id: 'compass.applied_components_count.non-final',
        defaultMessage: 'Applied to {numberOfComponents, plural, one {{numberOfComponents, number} component}  other {{numberOfComponents, number} components}}'
    },
    connect_to: {
        id: 'fabric.linking.connect_to',
        defaultMessage: 'Connect to {name}',
        description: 'Allows the user to connect with different types of external services'
    },
    connect_account_description: {
        id: 'fabric.linking.connect_account_description',
        defaultMessage: "We'll open a new page to help you connect your {name} account",
        description: 'Explains what will happen when the users connects to a new account'
    },
    connect_link_account: {
        id: 'fabric.linking.connect_link_account',
        defaultMessage: 'Connect to preview',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link.'
    },
    connect_link_account_card: {
        id: 'fabric.linking.connect_link_account_card_view',
        defaultMessage: 'Connect',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
    },
    connect_link_account_card_name: {
        id: 'fabric.linking.connect_link_account_card_view_name',
        defaultMessage: 'Connect your {context} account',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in title.'
    },
    connect_link_account_card_description: {
        id: 'fabric.linking.connect_link_account_card_view_description',
        defaultMessage: 'To show a preview of this link, connect your {context} account.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in byline.'
    },
    connect_unauthorised_account_action: {
        id: 'fabric.linking.connect_unauthorised_account_action',
        defaultMessage: 'Connect to {context}',
        description: 'Shown on a button to connect user external account to their Atlassian account.'
    },
    connect_unauthorised_account_description: {
        id: 'fabric.linking.connect_unauthorised_account_description',
        defaultMessage: 'Connect your {context} account to collaborate on work across Atlassian products.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
    },
    connect_unauthorised_account_description_no_provider: {
        id: 'fabric.linking.connect_unauthorised_account_description_no_provider',
        defaultMessage: 'Connect your account to collaborate on work across Atlassian products.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view and we do not have the providers name.'
    },
    continue: {
        id: 'fabric.linking.continue',
        defaultMessage: 'Continue',
        description: 'continue'
    },
    copy_url_to_clipboard: {
        id: 'fabric.linking.copy_url_to_clipboard',
        defaultMessage: 'Copy link',
        description: ''
    },
    copied_url_to_clipboard: {
        id: 'fabric.linking.copied_url_to_clipboard',
        defaultMessage: 'Copied!',
        description: 'Url has been copied to the clipboard'
    },
    could_not_load_link: {
        id: 'fabric.linking.couldnt_load_link',
        defaultMessage: "We couldn't load this link for an unknown reason.",
        description: 'Error case for card view - link could not be loaded.'
    },
    created_by: {
        id: 'fabric.linking.created_by',
        defaultMessage: 'Created by {context}',
        description: 'Indicates the person or entity that created the resource.'
    },
    created_on_relative: {
        id: 'fabric.linking.create_on_relative',
        defaultMessage: 'Created {context}',
        description: 'Indicated when entity was created (relative form)'
    },
    created_on_absolute: {
        id: 'fabric.linking.create_on_absolute',
        defaultMessage: 'Created on {context}',
        description: 'Indicated when entity was created (absolute form)'
    },
    delete: {
        id: 'fabric.linking.delete',
        defaultMessage: 'Delete',
        description: 'Allow a user to delete a link'
    },
    download: {
        id: 'fabric.linking.download',
        defaultMessage: 'Download',
        description: ''
    },
    download_description: {
        id: 'fabric.linking.download_description',
        defaultMessage: 'Download this file into your local storage',
        description: 'Description on what Download does'
    },
    download_file: {
        id: 'fabric.linking.download_file',
        defaultMessage: 'Download file',
        description: 'Allow a user to download a file'
    },
    ai_summary_action: {
        id: 'fabric.linking.ai_summary_action',
        defaultMessage: 'Summarize with AI',
        description: 'Allow a user to summarize a link'
    },
    ai_summary_action_description: {
        id: 'fabric.linking.ai_summary_action_description',
        defaultMessage: 'Summarize the content of this link using Atlassian Intelligence.',
        description: 'Description of what the summarize link with AI action does'
    },
    copy_summary_action: {
        id: 'fabric.linking.copy_summary_action',
        defaultMessage: 'Copy summary',
        description: 'Allow a user to copy a generated summary'
    },
    copy_summary_action_description: {
        id: 'fabric.linking.copy_summary_action_description',
        defaultMessage: 'Copy summary',
        description: 'Description of what the copy summary AI action does'
    },
    copied_summary_action_description: {
        id: 'fabric.linking.copied_summary_action_description',
        defaultMessage: 'Copied summary to clipboard',
        description: 'Confirmation to the user that the summry has been copied'
    },
    edit: {
        id: 'fabric.linking.edit',
        defaultMessage: 'Edit',
        description: 'Allow a user to edit a link'
    },
    follow: {
        id: 'fabric.linking.follow',
        defaultMessage: 'Follow',
        description: 'Click to follow a project.'
    },
    follow_project_description: {
        id: 'fabric.linking.follow_project_description',
        defaultMessage: 'Follow to get notifications on this project',
        description: 'Description on what Follow does'
    },
    follow_project: {
        id: 'fabric.linking.follow_project',
        defaultMessage: 'Follow project',
        description: 'Click to follow a project.'
    },
    follow_project_error: {
        id: 'fabric.linking.follow_project_error',
        defaultMessage: 'We encountered an error while trying to follow the project. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when following an Atlas project'
    },
    follow_goal_description: {
        id: 'fabric.linking.follow_goal_description',
        defaultMessage: 'Follow this goal to get notifications on updates',
        description: 'Description on what Follow does'
    },
    follow_goal: {
        id: 'fabric.linking.follow_goal',
        defaultMessage: 'Follow goal',
        description: 'Click to follow a project.'
    },
    follow_goal_error: {
        id: 'fabric.linking.follow_goal_error',
        defaultMessage: 'We encountered an error while trying to follow the goal. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when following an Atlas goal'
    },
    go_back: {
        id: 'fabric.linking.go_back',
        defaultMessage: 'Go back',
        description: 'go back'
    },
    invalid_permissions: {
        id: 'fabric.linking.invalid_permissions',
        defaultMessage: 'Restricted content',
        description: 'Message shown when a user does not have permissions to view an item'
    },
    invalid_permissions_description: {
        id: 'fabric.linking.invalid_permissions_description',
        defaultMessage: "You'll need to request access or try a different account to view this preview.",
        description: 'Message shown when a user does not have permissions to view an item. Displayed as description.'
    },
    join_to_view: {
        id: 'fabric.linking.join_to_view',
        defaultMessage: 'Join {context} to view this issue',
        description: 'Allows the user join the product or service immediately'
    },
    learn_more_about_smart_links: {
        id: 'fabric.linking.learn_more_about_smart_links',
        defaultMessage: 'Learn more about Smart Links.',
        description: 'An anchor link to redirect user to a page about Smart Links.'
    },
    learn_more_about_connecting_account: {
        id: 'fabric.linking.learn_more_about_connecting_account',
        defaultMessage: 'Learn more about connecting your account to Atlassian products.',
        description: 'An anchor link to redirect user to a page about authorization with 3rd party accounts.'
    },
    loading: {
        id: 'fabric.linking.loading',
        defaultMessage: 'Loading...',
        description: 'Indicates an element on a page is loading.'
    },
    modified_by: {
        id: 'fabric.linking.updated_by',
        defaultMessage: 'Modified by {context}',
        description: 'Indicates the person or entity that modified the resource.'
    },
    modified_on_relative: {
        id: 'fabric.linking.modified_on_relative',
        defaultMessage: 'Updated {context}',
        description: 'Indicated when entity was modified (relative form)'
    },
    modified_on_absolute: {
        id: 'fabric.linking.modified_on_absolute',
        defaultMessage: 'Updated on {context}',
        description: 'Indicated when entity was modified (absolute form)'
    },
    more_actions: {
        id: 'fabric.linking.more_actions',
        defaultMessage: 'More actions',
        description: 'Allows the users to see more link actions'
    },
    open_issue_in_jira: {
        id: 'fabric.linking.open_issue_in_jira',
        defaultMessage: 'Open issue in Jira',
        description: 'Click to open link in Jira'
    },
    open_link_in_a_new_tab: {
        id: 'fabric.linking.open_link_in_a_new_tab',
        defaultMessage: 'Open link in a new tab',
        description: 'Click to open link in a new tab'
    },
    owned_by: {
        id: 'fabric.linking.owned_by',
        defaultMessage: 'Owned by {context}',
        description: 'Indicates the person or entity that owns or maintains the resource.'
    },
    owned_by_override: {
        id: 'fabric.linking.owned_by_override',
        defaultMessage: 'By {context}',
        description: 'Indicates the person or entity that owns or maintains the resource.'
    },
    preview_description: {
        id: 'fabric.linking.preview_description',
        defaultMessage: 'Open a full screen preview of this link',
        description: 'Description on what Preview does'
    },
    preview_improved: {
        id: 'fabric.linking.preview_improved',
        defaultMessage: 'Open preview',
        description: 'Click to view a richer view of your content, without needing to navigate to it.'
    },
    preview_close: {
        id: 'fabric.linking.preview_close',
        defaultMessage: 'Close preview',
        description: 'Click to close embed preview modal.'
    },
    preview_max_size: {
        id: 'fabric.linking.preview_max_size',
        defaultMessage: 'View full screen',
        description: 'Click to increase embed preview modal size to a maximum viewing size.'
    },
    preview_min_size: {
        id: 'fabric.linking.preview_min_size',
        defaultMessage: 'Close full screen',
        description: 'Click to decrease embed preview modal size to a minimum viewing size.'
    },
    priority_blocker: {
        id: 'fabric.linking.priority_blocker',
        defaultMessage: 'Blocker',
        description: 'Indicated priority as blocker'
    },
    priority_critical: {
        id: 'fabric.linking.priority_critical',
        defaultMessage: 'Critical',
        description: 'Indicated priority as critical'
    },
    priority_high: {
        id: 'fabric.linking.priority_high',
        defaultMessage: 'High',
        description: 'Indicated priority as high'
    },
    priority_highest: {
        id: 'fabric.linking.priority_highest',
        defaultMessage: 'Highest',
        description: 'Indicated priority as highest'
    },
    priority_low: {
        id: 'fabric.linking.priority_low',
        defaultMessage: 'Low',
        description: 'Indicated priority as low'
    },
    priority_lowest: {
        id: 'fabric.linking.priority_lowest',
        defaultMessage: 'Lowest',
        description: 'Indicated priority as lowest'
    },
    priority_major: {
        id: 'fabric.linking.priority_major',
        defaultMessage: 'Major',
        description: 'Indicated priority as major'
    },
    priority_medium: {
        id: 'fabric.linking.priority_medium',
        defaultMessage: 'Medium',
        description: 'Indicated priority as medium'
    },
    priority_minor: {
        id: 'fabric.linking.priority_minor',
        defaultMessage: 'Minor',
        description: 'Indicated priority as minor'
    },
    priority_trivial: {
        id: 'fabric.linking.priority_trivial',
        defaultMessage: 'Trivial',
        description: 'Indicated priority as trivial'
    },
    priority_undefined: {
        id: 'fabric.linking.priority_undefined',
        defaultMessage: 'Undefined',
        description: 'Indicated priority as unknown'
    },
    forbidden_access: {
        id: 'fabric.linking.forbidden_access',
        defaultMessage: 'Your access is forbidden',
        description: 'Shown when a user does not have access to a resource behind the link.'
    },
    pending_request: {
        id: 'fabric.linking.pending_request',
        defaultMessage: 'Your access request is pending',
        description: 'Shown when a user has requested an access but status is pending.'
    },
    read_time: {
        id: 'fabric.linking.read_time',
        defaultMessage: '{context} min read',
        description: 'Estimated time to read this resource'
    },
    restricted_link: {
        id: 'fabric.linking.restricted_link',
        defaultMessage: 'Restricted link, try another account',
        description: 'Message shown when a user does not have permissions to view an item'
    },
    request_access_to_view: {
        id: 'fabric.linking.request_access_to_view',
        defaultMessage: 'Request access to {context} to view this issue',
        description: 'Allows the user to request access to a product or service'
    },
    request_denied: {
        id: 'fabric.linking.request_denied',
        defaultMessage: 'Your access request was denied',
        description: 'The user had request access but the request was denied by a product or service'
    },
    retry: {
        id: 'fabric.linking.retry',
        defaultMessage: 'Retry',
        description: 'Allows user to perform an action again'
    },
    save: {
        id: 'fabric.linking.save',
        defaultMessage: 'Save',
        description: 'Just the "save" word'
    },
    sent_on_relative: {
        id: 'fabric.linking.sent_on_relative',
        defaultMessage: 'Sent {context}',
        description: 'Indicated when entity was sent (relative form)'
    },
    sent_on_absolute: {
        id: 'fabric.linking.sent_on_absolute',
        defaultMessage: 'Sent on {context}',
        description: 'Indicated when entity was sent (absolute form)'
    },
    status_change_load_error: {
        id: 'fabric.linking.status_change_load_error',
        defaultMessage: "We couldn\u2019t load the statuses and transitions",
        description: 'Informs the user that the loading of status transitions failed'
    },
    status_change_permission_error: {
        id: 'fabric.linking.status_change_permission_error',
        defaultMessage: "You don\u2019t have permission to transition this issue. ",
        description: 'Informs the user that they do not have enough permissions to update a status'
    },
    status_change_update_error: {
        id: 'fabric.linking.status_change_update_error',
        defaultMessage: "We couldn\u2019t update the status",
        description: "Occurs when a user tries to update an issue's status but fails to do so"
    },
    try_again: {
        id: 'fabric.linking.try_again',
        defaultMessage: 'Try again',
        description: 'Allow the user to try an action again'
    },
    try_another_account: {
        id: 'fabric.linking.try_another_account',
        defaultMessage: 'Try another account',
        description: 'Allows the user to try an action again with a different account'
    },
    link_safety_warning_message: {
        id: 'fabric.linking.link_safety_warning_message',
        defaultMessage: 'The link {unsafeLinkText} is taking you to a different site, <a>actual link here</a>',
        description: 'Link safety check warning message'
    },
    unauthorised_account_description: {
        id: 'fabric.linking.unauthorised_account_description',
        defaultMessage: "You're trying to preview a link to a private {context} page. We recommend you review the URL or contact the page owner.",
        description: 'Explains that user does not have access to a link.'
    },
    unauthorised_account_description_no_provider: {
        id: 'fabric.linking.unauthorised_account_description_no_provider',
        defaultMessage: "You're trying to preview a link to a private page. We recommend you review the URL or contact the page owner.",
        description: 'Explains that user does not have access to a link.'
    },
    unauthorised_account_name: {
        id: 'fabric.linking.unauthorised_account_name',
        defaultMessage: "We can't display private pages from {context}",
        description: 'Shown when a user does not have access to a link.'
    },
    unauthorised_account_name_no_provider: {
        id: 'fabric.linking.unauthorised_account_name_no_provider',
        defaultMessage: "We can't display private pages",
        description: 'Shown when a user does not have access to a link.'
    },
    unassigned: {
        id: 'fabric.linking.unassigned',
        defaultMessage: 'Unassigned',
        description: 'Shown as a tooltip text for a default unassigned fallback avatar'
    },
    unfollow: {
        id: 'fabric.linking.unfollow',
        defaultMessage: 'Unfollow',
        description: 'Click to unfollow a project.'
    },
    unfollow_project_description: {
        id: 'fabric.linking.unfollow_project_description',
        defaultMessage: 'Unfollow to stop receiving project notifications',
        description: 'Description on what Unfollow does'
    },
    unfollow_project: {
        id: 'fabric.linking.unfollow_project',
        defaultMessage: 'Unfollow project',
        description: 'Click to unfollow a project.'
    },
    unfollow_project_error: {
        id: 'fabric.linking.unfollow_project_error',
        defaultMessage: 'We encountered an error while trying to unfollow the project. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when unfollowing an Atlas project'
    },
    unfollow_goal_description: {
        id: 'fabric.linking.unfollow_goal_description',
        defaultMessage: 'Unfollow to stop receiving notifications for this goal',
        description: 'Description on what Unfollow does'
    },
    unfollow_goal: {
        id: 'fabric.linking.unfollow_goal',
        defaultMessage: 'Unfollow goal',
        description: 'Click to unfollow a project.'
    },
    unfollow_goal_error: {
        id: 'fabric.linking.unfollow_goal_error',
        defaultMessage: 'We encountered an error while trying to unfollow the goal. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when unfollowing an Atlas goal'
    },
    unlink_account: {
        id: 'fabric.linking.unlink_account',
        defaultMessage: 'Unlink Account',
        description: 'Allows to remove a connected account from the user'
    },
    view: {
        id: 'fabric.linking.view',
        defaultMessage: 'View',
        description: 'Go through to a piece of content to view it in its original context.'
    },
    viewIn: {
        id: 'fabric.linking.srclink',
        defaultMessage: 'View in',
        description: 'We have a link in our preview modals to the original document. This text goes before the provider name'
    },
    viewOriginal: {
        id: 'fabric.linking.srclinkunknown',
        defaultMessage: 'View Original',
        description: "We have a link in our preview modals to the original document. This is for when we don't know the provider name"
    },
    default_no_access_title: {
        id: 'fabric.linking.no_access_title',
        defaultMessage: 'Join {product} to view this content',
        description: 'Informs the user that they dont have access to certain content'
    },
    direct_access_title: {
        id: 'fabric.linking.direct_access_title',
        defaultMessage: 'Join {product} to view this content',
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    direct_access_description: {
        id: 'fabric.linking.direct_access_description',
        defaultMessage: 'Your team uses {product} to collaborate and you can start using it right away!',
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    direct_access: {
        id: 'fabric.linking.direct_access',
        defaultMessage: 'Join now',
        description: 'Allows the user join the product or service immediately'
    },
    request_access_description: {
        id: 'fabric.linking.request_access_description',
        defaultMessage: 'Your team uses {product} to collaborate. Send your admin a request for access.',
        description: 'Informs the user to request access to a product by talking to the website administrator'
    },
    request_access: {
        id: 'fabric.linking.request_access',
        defaultMessage: 'Request access',
        description: 'Allows the user to request access to a product or service'
    },
    request_access_pending_title: {
        id: 'fabric.linking.request_access_pending_title',
        defaultMessage: 'Access to {product} is pending',
        description: 'Informs the user that their request to view this content is pending'
    },
    request_access_pending_description: {
        id: 'fabric.linking.request_access_pending_description',
        defaultMessage: 'Your request to access {hostname} is awaiting admin approval.',
        description: 'Informs the user that their request to view this content is pending website administrator approval'
    },
    request_access_pending: {
        id: 'fabric.linking.request_access_pending',
        defaultMessage: 'Pending approval',
        description: 'Informs the user that their request to view this content is pending'
    },
    request_denied_description: {
        id: 'fabric.linking.request_denied_description',
        defaultMessage: "Your admin didn't approve your request to view {product} pages from {hostname}.",
        description: 'Informs the user that their request to view this content was denied'
    },
    access_exists_description: {
        id: 'fabric.linking.access_exists_description',
        defaultMessage: 'Request access to view this content from {hostname}.',
        description: 'Informs the user to contact the website administrator to request access to a product'
    },
    not_found_description: {
        id: 'fabric.linking.not_found_description',
        defaultMessage: "The page doesn't exist or it may have changed after this link was added.",
        description: 'Error case for when a provided item is not found within the list of items'
    },
    not_found_title: {
        id: 'fabric.linking.not_found_title',
        defaultMessage: "We can't show you this {product} page",
        description: 'Error case for when a provided link is not found'
    },
    forbidden_title: {
        id: 'fabric.linking.forbidden_title',
        defaultMessage: "You don't have access to this content",
        description: 'Informs the user that they do not have access to the linked content.'
    },
    forbidden_description: {
        id: 'fabric.linking.forbidden_description',
        defaultMessage: 'Contact your admin to request access to {hostname}.',
        description: 'Informs the user that they must contact the site administrator for access.'
    },
    related: {
        id: 'fabric.linking.related',
        defaultMessage: 'Related',
        description: 'Informs the user about related resources'
    },
    generic_error_message: {
        id: 'fabric.linking.generic_error_message',
        defaultMessage: 'An error occurred',
        description: 'A generic error message to the user'
    },
    related_links_modal_title: {
        id: 'fabric.linking.related_links_modal_title',
        defaultMessage: 'Recent links',
        description: 'Shown as the title for the related links modal'
    },
    related_links_modal_title_v2: {
        id: 'fabric.linking.related_links_modal_title_v2',
        defaultMessage: 'Related links',
        description: 'Shown as the title for the related links modal'
    },
    related_links_view_related_urls: {
        id: 'fabric.linking.related_links_view_related_urls',
        defaultMessage: 'View recent links',
        description: 'Action to view related links to the given resource'
    },
    related_links_view_related_links: {
        id: 'fabric.linking.related_links_view_related_links',
        defaultMessage: 'View related links',
        description: 'Action to view related links to the given resource'
    },
    related_links_found_in: {
        id: 'fabric.linking.related_links_found_in',
        defaultMessage: 'Found In',
        description: 'Informs the user of the resources are found in the given url'
    },
    related_links_found_in_v2: {
        id: 'fabric.linking.related_links_found_in_v2',
        defaultMessage: 'Found in',
        description: 'Informs the user of the resources are found in the given url'
    },
    related_links_not_found: {
        id: 'fabric.linking.related_links_not_found',
        defaultMessage: "We didn't find any links to show here.",
        description: 'Informs the user that there are no related resources for the given url'
    },
    related_links_includes_links_to: {
        id: 'fabric.linking.related_links_includes_links_to',
        defaultMessage: 'Includes Links To',
        description: 'Informs the user of the resources the url links to'
    },
    related_links_includes_links_to_v2: {
        id: 'fabric.linking.related_links_includes_links_to_v2',
        defaultMessage: 'Includes links to',
        description: 'Informs the user of the resources the url links to'
    },
    related_links_modal_error_header: {
        id: 'fabric.linking.related_links_modal_error_header',
        defaultMessage: 'Something went wrong',
        description: 'Title for related links error'
    },
    related_links_modal_error_title: {
        id: 'fabric.linking.related_links_modal_error_title',
        defaultMessage: `We're having trouble loading related links`,
        description: 'Title for related links error'
    },
    related_links_modal_unavailable_title: {
        id: 'fabric.linking.related_links_modal_unavailable_title',
        defaultMessage: `We couldn't find any related links`,
        description: 'Title for related links error'
    },
    related_links_modal_error_message: {
        id: 'fabric.linking.related_links_modal_error_message',
        defaultMessage: 'We ran into an issue trying to load recent links. Check your connection or refresh to try again.',
        description: 'Informs the user that there was a problem loading related links'
    },
    related_links_modal_error_description: {
        id: 'fabric.linking.related_links_modal_error_description',
        defaultMessage: 'Check your connection or refresh the page to try again',
        description: 'Informs the user that there was a problem loading related links'
    },
    related_links_modal_unavailable_description: {
        id: 'fabric.linking.related_links_modal_unavailable_description',
        defaultMessage: 'We continuously review and add related links for updated pages or other content types',
        description: 'Informs the user that there was a problem loading related links'
    },
    related_links_modal_unavailable_header: {
        id: 'fabric.linking.related_links_modal_unavailable_header',
        defaultMessage: 'No recent links',
        description: 'Title for related links being unavailable'
    },
    related_links_modal_unavailable_message: {
        id: 'fabric.linking.related_links_modal_unavailable_message',
        defaultMessage: "We didn't find any links to show here. We continuously review and add recent links for updated pages or other content types.",
        description: 'Informs the user that related links were not found but may be available in the future'
    },
    join_to_viewIssueTermRefresh: {
        id: 'fabric.linking.join_to_view-issue-term-refresh',
        defaultMessage: 'Join {context} to view this work item',
        description: 'Allows the user join the product or service immediately'
    },
    open_issue_in_jiraIssueTermRefresh: {
        id: 'fabric.linking.open_issue_in_jira-issue-term-refresh',
        defaultMessage: 'Open work item in Jira',
        description: 'Click to open link in Jira'
    },
    request_access_to_viewIssueTermRefresh: {
        id: 'fabric.linking.request_access_to_view-issue-term-refresh',
        defaultMessage: 'Request access to {context} to view this work item',
        description: 'Allows the user to request access to a product or service'
    },
    status_change_permission_errorIssueTermRefresh: {
        id: 'fabric.linking.status_change_permission_error-issue-term-refresh',
        defaultMessage: "You don\u2019t have permission to transition this work item. ",
        description: 'Informs the user that they do not have enough permissions to update a status'
    },
    team_members_count: {
        id: 'fabric.linking.team_members_count',
        defaultMessage: '{context} members',
        description: 'Indicates the count of team member'
    },
    user_attributes: {
        id: 'fabric.linking.user_attributes',
        defaultMessage: '{context}',
        description: 'Displays user attributes like role, department, location, and pronouns'
    }
});

});


parcelRegister("jBltW", function(module, exports) {

$parcel$export(module.exports, "useLinkWarningModal", () => $fb1c524ee3dbf684$export$32b76c003683c2ec);

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $lGxtk = parcelRequire("lGxtk");

var $eGOwo = parcelRequire("eGOwo");

var $b43DQ = parcelRequire("b43DQ");
const $fb1c524ee3dbf684$var$toUrl = (url, base)=>{
    try {
        return new URL(url, base);
    } catch  {
        return undefined;
    }
};
const $fb1c524ee3dbf684$export$32b76c003683c2ec = ()=>{
    const [unsafeLinkText, setUnsafeLinkText] = (0, $eJOHy.useState)(null);
    const [url, setUrl] = (0, $eJOHy.useState)(null);
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const sendWarningModalViewedEvent = ()=>{
        createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'linkSafetyWarningModal',
            eventType: 'screen',
            name: 'linkSafetyWarningModal'
        }).fire((0, $b43DQ.ANALYTICS_CHANNEL));
    };
    const sendContinueClickedEvent = ()=>{
        createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'linkSafetyWarningModalContinue',
            eventType: 'ui',
            screen: 'linkSafetyWarningModal'
        }).fire((0, $b43DQ.ANALYTICS_CHANNEL));
    };
    /**
	 * It checks and warns if a link text is a URL and different from an actual link destination
	 */ const isLinkSafe = (event, href)=>{
        if (!href) return true;
        const anchor = event.currentTarget;
        const linkText = anchor.innerText;
        const normalisedUrlFromLinkText = (0, $lGxtk.normalizeUrl)(linkText);
        if (!normalisedUrlFromLinkText) return true;
        const anchorLinkRegex = new RegExp(/^#/im);
        const isLinkTextAnchorLink = anchorLinkRegex.test(linkText);
        const isAnchorLink = anchorLinkRegex.test(href);
        if (isAnchorLink || isLinkTextAnchorLink) return true;
        const relativeLinkRegex = new RegExp(/^\//im);
        const isRelativeHrefLink = relativeLinkRegex.test(href);
        if (isRelativeHrefLink) return true;
        const hrefUrl = $fb1c524ee3dbf684$var$toUrl(href, window.location.origin);
        const linkTextUrl = $fb1c524ee3dbf684$var$toUrl(normalisedUrlFromLinkText, hrefUrl?.origin);
        if (!hrefUrl || !linkTextUrl) return true;
        if ((0, $eGOwo.fg)('do-not-show-link-mismatch-warning-for-same-origin')) {
            const currentAtlassianProductOrigin = window.location.origin;
            const isSafeToIgnoreNonOriginDifferences = hrefUrl?.origin === currentAtlassianProductOrigin && linkTextUrl?.origin === currentAtlassianProductOrigin;
            if (isSafeToIgnoreNonOriginDifferences) return true;
        }
        const httpProtocols = [
            'http:',
            'https:'
        ];
        let areProtocolsEquivalent;
        if (httpProtocols.includes(linkTextUrl.protocol) && httpProtocols.includes(hrefUrl.protocol)) {
            const noUserNameAndPassword = !linkTextUrl.username && !linkTextUrl.password && !hrefUrl.username && !hrefUrl.password;
            areProtocolsEquivalent = noUserNameAndPassword;
        } else areProtocolsEquivalent = linkTextUrl.protocol === hrefUrl.protocol;
        const areEquivalentLinks = linkTextUrl.hostname === hrefUrl.hostname && linkTextUrl.pathname === hrefUrl.pathname && linkTextUrl.search === hrefUrl.search && linkTextUrl.username === hrefUrl.username && linkTextUrl.password === hrefUrl.password && areProtocolsEquivalent;
        if (!areEquivalentLinks) return false;
        return true;
    };
    const showSafetyWarningModal = (event, href)=>{
        event.preventDefault();
        const anchor = event.currentTarget;
        const linkText = anchor.innerText;
        setUnsafeLinkText(linkText);
        href && setUrl(href);
        setIsOpen(true);
        sendWarningModalViewedEvent();
    };
    const onClose = ()=>{
        setIsOpen(false);
        setUnsafeLinkText(null);
        setUrl(null);
    };
    const onContinue = ()=>{
        onClose();
        sendContinueClickedEvent();
        url && window.open(url, '_blank', 'noopener noreferrer');
    };
    return {
        isLinkSafe: isLinkSafe,
        isOpen: isOpen,
        onClose: onClose,
        onContinue: onContinue,
        showSafetyWarningModal: showSafetyWarningModal,
        unsafeLinkText: unsafeLinkText,
        url: url
    };
};

});
parcelRegister("lGxtk", function(module, exports) {

$parcel$export(module.exports, "isSafeUrl", () => $e793a9958f7445ee$export$c9f92f5469372e0f);
$parcel$export(module.exports, "normalizeUrl", () => $e793a9958f7445ee$export$6535eb414fa2c8b6);
/**
 * This file has been partially duplicated in packages/editor/adf-schema/src/utils/url.ts
 * Any changes made here should be mirrored there until the duplicate behaviour is resolved
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $ap5nJ = parcelRequire("ap5nJ");
const $e793a9958f7445ee$var$linkify = (0, (/*@__PURE__*/$parcel$interopDefault($ap5nJ)))();
$e793a9958f7445ee$var$linkify.add('sourcetree:', 'http:');
$e793a9958f7445ee$var$linkify.add('jamfselfservice:', 'http:');
$e793a9958f7445ee$var$linkify.add('notes:', 'http:');
const $e793a9958f7445ee$var$tlds = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
const $e793a9958f7445ee$var$tlds2Char = 'a[cdefgilmnoqrtuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrtuvwxyz]|n[acefgilopruz]|om|p[aefghkmnrtw]|qa|r[eosuw]|s[abcdegijklmnrtuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
$e793a9958f7445ee$var$tlds.push($e793a9958f7445ee$var$tlds2Char);
$e793a9958f7445ee$var$linkify.tlds($e793a9958f7445ee$var$tlds, false);
const $e793a9958f7445ee$var$whitelistedURLPatterns = [
    /^https?:\/\/[^\s]*$/im,
    /^ftps?:\/\//im,
    /^gopher:\/\//im,
    /^integrity:\/\//im,
    /^file:\/\//im,
    /^smb:\/\//im,
    /^dynamicsnav:\/\//im,
    /^jamfselfservice:\/\/[^\s]*$/im,
    /^\//im,
    /^mailto:/im,
    /^skype:/im,
    /^callto:[^\s]*$/im,
    /^facetime:[^\s]*$/im,
    /^git:/im,
    /^irc6?:/im,
    /^news:/im,
    /^nntp:/im,
    /^feed:/im,
    /^cvs:/im,
    /^svn:/im,
    /^mvn:/im,
    /^ssh:/im,
    /^scp:\/\//im,
    /^sftp:\/\//im,
    /^itms:/im,
    // This is not a valid notes link, but we support this pattern for backwards compatibility
    /^notes:/im,
    /^notes:\/\//im,
    /^hipchat:\/\//im,
    /^sourcetree:/im,
    /^urn:/im,
    /^tel:/im,
    /^xmpp:/im,
    /^telnet:/im,
    /^vnc:/im,
    /^rdp:/im,
    /^whatsapp:/im,
    /^slack:/im,
    /^sips?:/im,
    /^magnet:/im,
    /^foo:/im,
    /^#/im
];
const $e793a9958f7445ee$var$normaliseLinkHref = (url)=>{
    const match = $e793a9958f7445ee$var$getLinkMatch(url);
    return match && match.url || null;
};
const $e793a9958f7445ee$var$getLinkMatch = (str)=>{
    if (!str) return null;
    let match = $e793a9958f7445ee$var$linkifyMatch(str);
    if (!match.length) match = $e793a9958f7445ee$var$linkify.match(str);
    return match && match.length > 0 && match[0].index === 0 && match[0].lastIndex === str.trim().length ? match[0] : null;
};
const $e793a9958f7445ee$var$LINK_REGEXP = /(https?|ftp|jamfselfservice|gopher|dynamicsnav|integrity|file|smb):\/\/[^\s]+/;
const $e793a9958f7445ee$var$linkifyMatch = (text)=>{
    const matches = [];
    if (!$e793a9958f7445ee$var$LINK_REGEXP.test(text)) return matches;
    let startpos = 0;
    let substr;
    while(substr = text.substr(startpos)){
        const link = (substr.match($e793a9958f7445ee$var$LINK_REGEXP) || [
            ''
        ])[0];
        if (link) {
            const index = substr.search($e793a9958f7445ee$var$LINK_REGEXP);
            const start = index >= 0 ? index + startpos : index;
            const end = start + link.length;
            matches.push({
                index: start,
                lastIndex: end,
                raw: link,
                url: link,
                text: link,
                schema: ''
            });
            startpos += end;
        } else break;
    }
    return matches;
};
const $e793a9958f7445ee$export$c9f92f5469372e0f = (url)=>{
    const urlTrimmed = url.trim();
    return $e793a9958f7445ee$var$whitelistedURLPatterns.some((p)=>p.test(urlTrimmed));
};
function $e793a9958f7445ee$export$6535eb414fa2c8b6(url) {
    if (!url) return '';
    const urlWithoutNewlines = url.replace(/[\r\n]+/g, '');
    if ($e793a9958f7445ee$export$c9f92f5469372e0f(urlWithoutNewlines)) return urlWithoutNewlines.trim();
    return $e793a9958f7445ee$var$normaliseLinkHref(urlWithoutNewlines);
}

});
parcelRegister("ap5nJ", function(module, exports) {
'use strict';
////////////////////////////////////////////////////////////////////////////////
// Helpers
// Merge objects
//
function $793069e9e15f92f4$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $793069e9e15f92f4$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $793069e9e15f92f4$var$isString(obj) {
    return $793069e9e15f92f4$var$_class(obj) === '[object String]';
}
function $793069e9e15f92f4$var$isObject(obj) {
    return $793069e9e15f92f4$var$_class(obj) === '[object Object]';
}
function $793069e9e15f92f4$var$isRegExp(obj) {
    return $793069e9e15f92f4$var$_class(obj) === '[object RegExp]';
}
function $793069e9e15f92f4$var$isFunction(obj) {
    return $793069e9e15f92f4$var$_class(obj) === '[object Function]';
}
function $793069e9e15f92f4$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
}
////////////////////////////////////////////////////////////////////////////////
var $793069e9e15f92f4$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $793069e9e15f92f4$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        return acc || $793069e9e15f92f4$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
var $793069e9e15f92f4$var$defaultSchemas = {
    'http:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp('^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i');
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    'https:': 'http:',
    'ftp:': 'http:',
    '//': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp('^' + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' + self.re.src_port + self.re.src_host_terminator + self.re.src_path, 'i');
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ':') return 0;
                if (pos >= 3 && text[pos - 3] === '/') return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    'mailto:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp('^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i');
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
/*eslint-disable max-len*/ // RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
var $793069e9e15f92f4$var$tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
var $793069e9e15f92f4$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
/*eslint-enable max-len*/ ////////////////////////////////////////////////////////////////////////////////
function $793069e9e15f92f4$var$resetScanCache(self) {
    self.__index__ = -1;
    self.__text_cache__ = '';
}
function $793069e9e15f92f4$var$createValidator(re) {
    return function(text, pos) {
        var tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $793069e9e15f92f4$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}

// Schemas compiler. Build regexps.
//
function $793069e9e15f92f4$var$compile(self) {
    // Load & clone RE patterns.
    var re = self.re = (parcelRequire("jgL8p"))(self.__opts__);
    // Define dynamic patterns
    var tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($793069e9e15f92f4$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join('|');
    function untpl(tpl) {
        return tpl.replace('%TLDS%', re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), 'i');
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), 'i');
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');
    //
    // Compile each schema
    //
    var aliases = [];
    self.__compiled__ = {}; // Reset compiled data
    function schemaError(name, val) {
        throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        var val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        var compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($793069e9e15f92f4$var$isObject(val)) {
            if ($793069e9e15f92f4$var$isRegExp(val.validate)) compiled.validate = $793069e9e15f92f4$var$createValidator(val.validate);
            else if ($793069e9e15f92f4$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($793069e9e15f92f4$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $793069e9e15f92f4$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($793069e9e15f92f4$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[''] = {
        validate: null,
        normalize: $793069e9e15f92f4$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    var slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($793069e9e15f92f4$var$escapeRE).join('|');
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
    self.re.schema_search = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');
    self.re.pretest = RegExp('(' + self.re.schema_test.source + ')|(' + self.re.host_fuzzy_test.source + ')|@', 'i');
    //
    // Cleanup
    //
    $793069e9e15f92f4$var$resetScanCache(self);
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $793069e9e15f92f4$var$Match(self, shift) {
    var start = self.__index__, end = self.__last_index__, text = self.__text_cache__.slice(start, end);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = self.__schema__.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = start + shift;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = end + shift;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = text;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = text;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = text;
}
function $793069e9e15f92f4$var$createMatch(self, shift) {
    var match = new $793069e9e15f92f4$var$Match(self, shift);
    self.__compiled__[match.schema].normalize(match, self);
    return match;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $793069e9e15f92f4$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $793069e9e15f92f4$var$LinkifyIt)) return new $793069e9e15f92f4$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($793069e9e15f92f4$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $793069e9e15f92f4$var$assign({}, $793069e9e15f92f4$var$defaultOptions, options);
    // Cache last tested result. Used to skip repeating steps on next `match` call.
    this.__index__ = -1;
    this.__last_index__ = -1; // Next scan position
    this.__schema__ = '';
    this.__text_cache__ = '';
    this.__schemas__ = $793069e9e15f92f4$var$assign({}, $793069e9e15f92f4$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $793069e9e15f92f4$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $793069e9e15f92f4$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $793069e9e15f92f4$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $793069e9e15f92f4$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $793069e9e15f92f4$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $793069e9e15f92f4$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $793069e9e15f92f4$var$LinkifyIt.prototype.test = function test(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return false;
    var m, ml, me, len, shift, next, re, tld_pos, at_pos;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) {
                this.__schema__ = m[2];
                this.__index__ = m.index + m[1].length;
                this.__last_index__ = m.index + m[0].length + len;
                break;
            }
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
        // guess schemaless links
        tld_pos = text.search(this.re.host_fuzzy_test);
        if (tld_pos >= 0) {
            // if tld is located after found link - no need to check fuzzy pattern
            if (this.__index__ < 0 || tld_pos < this.__index__) {
                if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                    shift = ml.index + ml[1].length;
                    if (this.__index__ < 0 || shift < this.__index__) {
                        this.__schema__ = '';
                        this.__index__ = shift;
                        this.__last_index__ = ml.index + ml[0].length;
                    }
                }
            }
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
        // guess schemaless emails
        at_pos = text.indexOf('@');
        if (at_pos >= 0) // We can't skip this check, because this cases are possible:
        // 192.168.1.1@gmail.com, my.in@example.com
        {
            if ((me = text.match(this.re.email_fuzzy)) !== null) {
                shift = me.index + me[1].length;
                next = me.index + me[0].length;
                if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                    this.__schema__ = 'mailto:';
                    this.__index__ = shift;
                    this.__last_index__ = next;
                }
            }
        }
    }
    return this.__index__ >= 0;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $793069e9e15f92f4$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $793069e9e15f92f4$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $793069e9e15f92f4$var$LinkifyIt.prototype.match = function match(text) {
    var shift = 0, result = [];
    // Try to take previous element from cache, if .test() called before
    if (this.__index__ >= 0 && this.__text_cache__ === text) {
        result.push($793069e9e15f92f4$var$createMatch(this, shift));
        shift = this.__last_index__;
    }
    // Cut head if cache was used
    var tail = shift ? text.slice(shift) : text;
    // Scan string until end reached
    while(this.test(tail)){
        result.push($793069e9e15f92f4$var$createMatch(this, shift));
        tail = tail.slice(this.__last_index__);
        shift += this.__last_index__;
    }
    if (result.length) return result;
    return null;
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $793069e9e15f92f4$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $793069e9e15f92f4$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $793069e9e15f92f4$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $793069e9e15f92f4$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = 'http://' + match.url;
    if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) match.url = 'mailto:' + match.url;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $793069e9e15f92f4$var$LinkifyIt.prototype.onCompile = function onCompile() {};
module.exports = $793069e9e15f92f4$var$LinkifyIt;

});
parcelRegister("jgL8p", function(module, exports) {
'use strict';




module.exports = function(opts) {
    var re = {};
    // Use direct extract instead of `regenerate` to reduse browserified size
    re.src_Any = (parcelRequire("hZcCd")).source;
    re.src_Cc = (parcelRequire("iNnZB")).source;
    re.src_Z = (parcelRequire("23KJ1")).source;
    re.src_P = (parcelRequire("dDBFM")).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join('|');
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join('|');
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    var text_separators = '[><\uff5c]';
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    ////////////////////////////////////////////////////////////////////////////////
    re.src_ip4 = '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    re.src_auth = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';
    re.src_port = '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
    re.src_host_terminator = '(?=$|' + text_separators + '|' + re.src_ZPCc + ')(?!-|_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';
    re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-;]).|' + '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' + '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' + '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + "\\'(?=" + re.src_pseudo_letter + '|[-]).|' + // allow `I'm_king` if no pair found
    '\\.{2,}[a-zA-Z0-9%/&]|' + // google has many dots in "google search" links (#66, #81).
    // github has ... in commit range links,
    // Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // - params separator
    // until more examples found.
    '\\.(?!' + re.src_ZCc + '|[.]).|' + (opts && opts['---'] ? '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
     : '\\-+|') + ',(?!' + re.src_ZCc + ').|' + // allow `,,,` in paths
    ';(?!' + re.src_ZCc + ').|' + // allow `;` if not followed by space-like char
    '\\!+(?!' + re.src_ZCc + '|[!]).|' + // allow `!!!` in paths, but not at the end
    '\\?(?!' + re.src_ZCc + '|[?]).' + ')+' + '|\\/' + ')?';
    // Allow anything in markdown spec, forbid quote (") at the first position
    // because emails enclosed in quotes are far more common
    re.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*';
    re.src_xn = 'xn--[a-z0-9\\-]{1,59}';
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    '(?:' + re.src_xn + '|' + re.src_pseudo_letter + '{1,63}' + ')';
    re.src_domain = '(?:' + re.src_xn + '|' + '(?:' + re.src_pseudo_letter + ')' + '|' + '(?:' + re.src_pseudo_letter + '(?:-|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' + ')';
    re.src_host = "(?:(?:(?:(?:" + re.src_domain + ')\\.)*' + re.src_domain /*_root*/  + ')' + ')';
    re.tpl_host_fuzzy = '(?:' + re.src_ip4 + '|' + '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' + ')';
    re.tpl_host_no_ip_fuzzy = '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    ////////////////////////////////////////////////////////////////////////////////
    // Main rules
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = 'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';
    re.tpl_email_fuzzy = '(^|' + text_separators + '|"|\\(|' + re.src_ZCc + ')' + '(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';
    return re;
};

});






parcelRegister("7B5Pg", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b3c96b2f2803b80$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
function $3b3c96b2f2803b80$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ...props.dataAttributes,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            textDecoration: 'line-through'
        },
        children: props.children
    });
}

});

parcelRegister("9PRAt", function(module, exports) {

$parcel$export(module.exports, "default", () => $bce450ecfa4821ab$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
function $bce450ecfa4821ab$export$2e2bcd8739ae039(props) {
    // ignore the eslint warning Text primitive does not support dataAttributes
    // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading, @atlaskit/design-system/use-primitives-text
    return /*#__PURE__*/ (0, $gt9Am.jsx)("strong", {
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("lFm6v", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d4e88ced3f0d8ea$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
const $4d4e88ced3f0d8ea$var$isSub = (type)=>{
    return type === 'sub';
};
function $4d4e88ced3f0d8ea$export$2e2bcd8739ae039(props) {
    if ($4d4e88ced3f0d8ea$var$isSub(props.type)) // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $gt9Am.jsx)("sub", {
        ...props.dataAttributes,
        children: props.children
    });
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $gt9Am.jsx)("sup", {
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("4U2Ut", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc4a5b898726e218$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $4PpDP = parcelRequire("4PpDP");

var $9NsIT = parcelRequire("9NsIT");

var $58yRG = parcelRequire("58yRG");
function $cc4a5b898726e218$export$2e2bcd8739ae039(props) {
    const { colorMode: colorMode } = (0, $58yRG.default)();
    // Note -- while there is no way to create custom colors using default tooling
    // the editor does supported ad hoc color values -- and there may be content
    // which has been migrated or created via apis which use such values.
    let paletteColorValue;
    /**
   * The Editor persists custom text colors when content has been migrated from the old editor, or created via
   * apis.
   *
   * This behaviour predates the introduction of dark mode.
   *
   * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
   *
   * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
   *
   * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
   * how we detect text colors copied from external editor sources. Where we load the background color from a
   * seperate attribute (data-text-custom-color), instead of the inline style.
   *
   * See the following document for more details on this behaviour
   * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
   */ const tokenColor = (0, $9NsIT.hexToEditorTextPaletteColor)(props.color);
    if (tokenColor) paletteColorValue = (0, $9NsIT.hexToEditorTextPaletteColor)(props.color) || props.color;
    else if (colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
    paletteColorValue = (0, $4PpDP.getDarkModeLCHColor)(props.color);
    else // if we are in light mode, we can just set the color
    paletteColorValue = props.color;
    const style = (0, $eJOHy.useMemo)(()=>({
            ['--custom-palette-color']: paletteColorValue
        }), [
        paletteColorValue
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ...props.dataAttributes,
        "data-text-custom-color": props.color,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-text-color-mark",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        children: props.children
    });
}

});
parcelRegister("9NsIT", function(module, exports) {

$parcel$export(module.exports, "hexToEditorTextPaletteColor", () => $cf1cfab83fe39928$export$9c2f408d391feb93);
// This import will be stripped on build
/**
 * This takes an adf hex color and returns a matching text palette color.
 *
 * By providing a design token, this enables ADF content to be rendered in new themes such as dark mode.
 *
 * Example usage
 * ```tsx
 * const cssValue = hexToTextPaletteColor('#0747A6');
 * //     ^? const cssValue: string
 * <span style={{textColor: cssValue}} />
 * ```
 * The names of tokens can change over time, and the values of tokens will differ between themes.
 * The exact output of this function is an implementation detail and should only be used when rendering
 * content to the user, on a client with a matching major version of `@atlaskit/tokens`.
 * - **DO NOT**: store the output of these functions in any user-generated content or back-end.
 * - **DO**: store the ADF hex color, and use these utilities at render time to display the themed version of the color
 */ function $cf1cfab83fe39928$export$9c2f408d391feb93(hexColor) {
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    return $cf1cfab83fe39928$export$57fa5089caad992[hexColor.toUpperCase()];
}
const $cf1cfab83fe39928$export$57fa5089caad992 = {
    // blue
    /** blue - light */ ['#B3D4FF']: "var(--ds-background-accent-blue-subtler, #B3D4FF)",
    // source for hex code was legacy token B75
    /** blue - medium */ ['#4C9AFF']: "var(--ds-icon-accent-blue, #4C9AFF)",
    // source for hex code was legacy token B100
    /** blue - strong */ ['#0747A6']: "var(--ds-text-accent-blue, #0747A6)",
    // source for hex code was legacy token B500
    // teal
    /** teal - light */ ['#B3F5FF']: "var(--ds-background-accent-teal-subtler, #B3F5FF)",
    // source for hex code was legacy token T75
    /** teal - medium */ ['#00B8D9']: "var(--ds-icon-accent-teal, #00B8D9)",
    // source for hex code was legacy token T300
    /** teal - strong */ ['#008DA6']: "var(--ds-text-accent-teal, #008DA6)",
    // source for hex code was legacy token T500
    // green
    /** green - light */ ['#ABF5D1']: "var(--ds-background-accent-green-subtler, #ABF5D1)",
    // source for hex code was legacy token G75
    /** green - medium */ ['#36B37E']: "var(--ds-icon-accent-green, #36B37E)",
    // source for hex code was legacy token G300
    /** green - strong */ ['#006644']: "var(--ds-text-accent-green, #006644)",
    // source for hex code was legacy token G500
    // yellowOrange
    /** yellowOrange - light */ ['#FFF0B3']: "var(--ds-background-accent-yellow-subtler, #FFF0B3)",
    // source for hex code was legacy token Y75
    /** yellowOrange - medium */ ['#FFC400']: "var(--ds-background-accent-orange-subtle, #FFC400)",
    // source for hex code was legacy token Y200
    /** yellowOrange - strong */ ['#FF991F']: "var(--ds-icon-accent-orange, #FF991F)",
    // source for hex code was legacy token Y400
    // red
    /** red - light */ ['#FFBDAD']: "var(--ds-background-accent-red-subtler, #FFBDAD)",
    // source for hex code was legacy token R75
    /** red - medium */ ['#FF5630']: "var(--ds-icon-accent-red, #FF5630)",
    // source for hex code was legacy token R300
    /** red - strong */ ['#BF2600']: "var(--ds-text-accent-red, #BF2600)",
    // source for hex code was legacy token R500
    // purple
    /** purple - light */ ['#EAE6FF']: "var(--ds-background-accent-purple-subtler, #EAE6FF)",
    // source for hex code was legacy token P50
    /** purple - medium */ ['#6554C0']: "var(--ds-icon-accent-purple, #6554C0)",
    // source for hex code was legacy token P300
    /** purple - strong */ ['#403294']: "var(--ds-text-accent-purple, #403294)",
    // source for hex code was legacy token P500
    // whiteGray
    /** whiteGray - light */ ['#FFFFFF']: "var(--ds-text-inverse, #FFFFFF)",
    // source for hex code was legacy token N0
    /** whiteGray - medium */ ['#97A0AF']: "var(--ds-icon-accent-gray, #97A0AF)",
    // source for hex code was legacy token N80
    /** whiteGray - strong */ ['#172B4D']: "var(--ds-text, #172B4D)" // source for hex code was legacy token N800
};

});


parcelRegister("clQ8A", function(module, exports) {

$parcel$export(module.exports, "default", () => $1546906879e66b96$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $4PpDP = parcelRequire("4PpDP");

var $drB0U = parcelRequire("drB0U");

var $58yRG = parcelRequire("58yRG");
function $1546906879e66b96$export$2e2bcd8739ae039(props) {
    const { colorMode: colorMode } = (0, $58yRG.default)();
    let paletteColorValue;
    /**
   * Documents can contain custom colors when content has been migrated from the old editor, or created via APIs.
   *
   * This behaviour predates the introduction of dark mode.
   *
   * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
   *
   * This introduces inversion of the presentation of the custom text background colors when the user is in dark mode.
   *
   * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
   * how we detect text background colors copied from external editor sources. Where we load the background color from a
   * separate attribute (data-background-custom-color), instead of the inline style.
   *
   * See the following document for more details on this behaviour
   * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
   */ const tokenColor = (0, $drB0U.hexToEditorTextBackgroundPaletteColor)(props.color);
    if (tokenColor) paletteColorValue = tokenColor;
    else if (colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
    paletteColorValue = (0, $4PpDP.getDarkModeLCHColor)(props.color);
    else // if we are in light mode, we can just set the color
    paletteColorValue = props.color;
    const style = (0, $eJOHy.useMemo)(()=>({
            ['--custom-palette-color']: paletteColorValue
        }), [
        paletteColorValue
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ...props.dataAttributes,
        "data-background-custom-color": props.color,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-background-color-mark",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        children: props.children
    });
}

});
parcelRegister("drB0U", function(module, exports) {

$parcel$export(module.exports, "hexToEditorTextBackgroundPaletteColor", () => $5768ec9dd457945c$export$8b58ff1b36bb75e0);

var $cbSL1 = parcelRequire("cbSL1");
const $5768ec9dd457945c$export$12a518ff137dd389 = {
    /** Gray - light */ ['#DCDFE4']: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
    /** Teal - light */ ['#C6EDFB']: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    /** Lime - light */ ['#D3F1A7']: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    /** Yellow - light */ ['#F8E6A0']: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
    /** Orange - light */ ['#FEDEC8']: "var(--ds-background-accent-orange-subtler, #FEDEC8)",
    /** Magenta - light */ ['#FDD0EC']: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    /** Purple - light */ ['#DFD8FD']: "var(--ds-background-accent-purple-subtler, #DFD8FD)"
};
function $5768ec9dd457945c$export$8b58ff1b36bb75e0(hexColor) {
    if (!(0, $cbSL1.expValEquals)('platform_editor_add_orange_highlight_color', 'cohort', 'test')) // @ts-expect-error Expect type error. Will modify production type
    // if experiment proceeds post-results.
    $5768ec9dd457945c$export$12a518ff137dd389['#FEDEC8'] = "var(--ds-background-accent-yellow-subtler, #F8E6A0)";
    // Ts ignore was used to allow use of conditional return type
    // (preferring better type on consumption over safety in implementation)
    // @ts-ignore
    return $5768ec9dd457945c$export$12a518ff137dd389[hexColor.toUpperCase()];
}

});
parcelRegister("cbSL1", function(module, exports) {

$parcel$export(module.exports, "expValEquals", () => $80111f8cfb287dae$export$45abdb3f977b5b14);

var $803eB = parcelRequire("803eB");
function $80111f8cfb287dae$export$45abdb3f977b5b14(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue = null) {
    return (0, $803eB.expValEqualsInternal)(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue, true);
}

});
parcelRegister("803eB", function(module, exports) {

$parcel$export(module.exports, "expValEqualsInternal", () => $1a1aa4dcd65a9a0e$export$58e581060588c6bb);

var $59rsN = parcelRequire("59rsN");

var $bfW07 = parcelRequire("bfW07");
function $1a1aa4dcd65a9a0e$export$58e581060588c6bb(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue, experimentExposure) {
    // @ts-ignore need to loosen the type here to allow for any experiment name
    if ((0, $bfW07._overrides)[experimentName] !== undefined) // This will be hit in the case of a test setting an override
    // @ts-ignore need to loosen the type here to allow for any experiment name
    return (0, $bfW07._overrides)[experimentName] === experimentExpectedValue;
    // If client is not initialized, we compare with the default value
    if (!(0, $59rsN.default).initializeCompleted()) return experimentDefaultValue === experimentExpectedValue;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $59rsN.default).getExperimentValue(experimentName, experimentParam, experimentDefaultValue, {
        fireExperimentExposure: experimentExposure
    });
    return experimentValue === experimentExpectedValue;
}

});




parcelRegister("105lA", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbcdb99a38cb4c35$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
function $fbcdb99a38cb4c35$export$2e2bcd8739ae039(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $gt9Am.jsx)("u", {
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("kh0nj", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd2a7aa9e7dc459d$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $2bEPZ = parcelRequire("2bEPZ");

var $bnh3n = parcelRequire("bnh3n");

var $7yBx7 = parcelRequire("7yBx7");

var $92xoS = parcelRequire("92xoS");

var $eGOwo = parcelRequire("eGOwo");
const $fd2a7aa9e7dc459d$var$wrapperStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `${(0, $7yBx7.blockNodesVerticalMargin)} 0`,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
    marginLeft: '50%',
    transform: 'translateX(-50%)'
});
const $fd2a7aa9e7dc459d$var$getWidth = (width, mode)=>{
    if ((0, $92xoS.editorExperiment)('advanced_layouts', true) && width) return `min(${width}px, var(--ak-editor--breakout-container-without-gutter-width))`;
    else {
        if (mode === 'full-width') return `max(${0, $7yBx7.akEditorDefaultLayoutWidth}px, min(${0, $7yBx7.akEditorFullWidthLayoutWidth}px, var(--ak-editor--breakout-container-without-gutter-width)))`;
        if (mode === 'wide') return `min(var(--ak-editor--breakout-wide-layout-width), var(--ak-editor--breakout-container-without-gutter-width))`;
    }
};
function $fd2a7aa9e7dc459d$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $2bEPZ.WidthConsumer), null, ({ width: width })=>/*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            css: $fd2a7aa9e7dc459d$var$wrapperStyles,
            "data-mode": props.mode,
            ...(0, $92xoS.editorExperiment)('advanced_layouts', true) && {
                'data-has-width': !!props.width,
                'data-width': props.width
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: (0, $eGOwo.fg)('platform_breakout_cls') ? {
                width: $fd2a7aa9e7dc459d$var$getWidth('width' in props ? props.width : null, props.mode)
            } : {
                width: (0, $92xoS.editorExperiment)('advanced_layouts', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                (0, $bnh3n.calcBreakoutWithCustomWidth)(props.mode, 'width' in props ? props.width : null, width) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                (0, $bnh3n.calcBreakoutWidth)(props.mode, width)
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "fabric-editor-breakout-mark fabric-editor-block-mark"
        }, props.children));
}

});

parcelRegister("agnfA", function(module, exports) {

$parcel$export(module.exports, "default", () => $776c00fdd448ca26$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $fRfD8 = parcelRequire("fRfD8");
const $776c00fdd448ca26$var$MarkWrapper = (props)=>{
    const dataAlign = props['data-align'] ? (0, $fRfD8.alignmentPositionMap)[props['data-align']] : undefined;
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        style: {
            textAlign: dataAlign
        },
        ...props
    }, props.children);
};
function $776c00fdd448ca26$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $1NIU8.jsx)($776c00fdd448ca26$var$MarkWrapper, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-editor-block-mark fabric-editor-alignment",
        "data-align": props.align
    }, props.children);
}

});

parcelRegister("36uir", function(module, exports) {

$parcel$export(module.exports, "default", () => $4adf8cdc302fb563$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
function $4adf8cdc302fb563$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-editor-block-mark fabric-editor-indentation-mark",
        "data-level": props.level,
        children: props.children
    });
}

});

parcelRegister("1JSxg", function(module, exports) {

$parcel$export(module.exports, "default", () => $56a2d33572f5581d$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
function $56a2d33572f5581d$export$2e2bcd8739ae039(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("1lKH5", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0ef138c69d3df93$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
function $b0ef138c69d3df93$export$2e2bcd8739ae039(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("jLqyg", function(module, exports) {

$parcel$export(module.exports, "default", () => $a728379652509c5a$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
function $a728379652509c5a$export$2e2bcd8739ae039(props) {
    const WrapperElement = props.isInline ? 'span' : 'div';
    return /*#__PURE__*/ (0, $gt9Am.jsx)(WrapperElement, {
        "data-source": props.sources ? JSON.stringify(props.sources) : undefined,
        "data-mark-type": "dataConsumer",
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("5lVub", function(module, exports) {

$parcel$export(module.exports, "default", () => $72bc8ea88846b0a8$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
function $72bc8ea88846b0a8$export$2e2bcd8739ae039(props) {
    const WrapperElement = props.isInline ? 'span' : 'div';
    return /*#__PURE__*/ (0, $gt9Am.jsx)(WrapperElement, {
        "data-localId": props.localId,
        "data-name": props.name,
        "data-mark-type": "fragment",
        ...props.dataAttributes,
        children: props.children
    });
}

});

parcelRegister("79gvV", function(module, exports) {

$parcel$export(module.exports, "default", () => $7877f25ac91f8c5c$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");
function $7877f25ac91f8c5c$export$2e2bcd8739ae039(props) {
    const borderColor = props.color ?? '';
    const borderSize = props.size ?? 0;
    return /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        "data-color": borderColor,
        "data-size": borderSize,
        "data-mark-type": "border"
    }, props.children);
}

});

parcelRegister("6Iogh", function(module, exports) {

$parcel$export(module.exports, "default", () => $990911999fff5606$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
class $990911999fff5606$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    render() {
        const { reference: reference, children: children } = this.props;
        return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
            "data-mark-type": "confluenceInlineComment",
            "data-reference": reference,
            children: children
        });
    }
}

});


parcelRegister("cRsRn", function(module, exports) {

$parcel$export(module.exports, "getMarksByOrder", () => $0190d1906f5ad323$export$99a33ed044c278ae);
$parcel$export(module.exports, "isSameMark", () => $0190d1906f5ad323$export$b1304404bdc42b7a);
$parcel$export(module.exports, "getValidDocument", () => $0190d1906f5ad323$export$fb80336a7e408cb3);
$parcel$export(module.exports, "getValidNode", () => $0190d1906f5ad323$export$81b20b6c83a56bd);

var $2OrIX = parcelRequire("2OrIX");
var $fAF2Y = parcelRequire("fAF2Y");
var $iKozC = parcelRequire("iKozC");
var $ePdnq = parcelRequire("ePdnq");

var $8DB98 = parcelRequire("8DB98");

var $eGOwo = parcelRequire("eGOwo");
const $0190d1906f5ad323$export$3b94ef2190b2d585 = {
    FINAL: 'final',
    STAGE_0: 'stage0'
};
const $0190d1906f5ad323$export$62d5811a2955c1d8 = [
    'fragment',
    'link',
    'em',
    'strong',
    'textColor',
    'backgroundColor',
    'strike',
    'subsup',
    'underline',
    'code',
    'confluenceInlineComment',
    'annotation',
    'dataConsumer'
];
const $0190d1906f5ad323$export$30f8aa4cc1f8c1cb = (type)=>{
    return type === 'sub' || type === 'sup';
};
const $0190d1906f5ad323$export$99a33ed044c278ae = (marks)=>{
    return [
        ...marks
    ].sort((a, b)=>$0190d1906f5ad323$export$62d5811a2955c1d8.indexOf(a.type.name) - $0190d1906f5ad323$export$62d5811a2955c1d8.indexOf(b.type.name));
};
const $0190d1906f5ad323$export$b1304404bdc42b7a = (mark, otherMark)=>{
    if (!mark || !otherMark) return false;
    return mark.eq(otherMark);
};
const $0190d1906f5ad323$export$fb80336a7e408cb3 = (doc, schema = (0, $8DB98.defaultSchema), adfStage = 'final')=>{
    const node = $0190d1906f5ad323$export$81b20b6c83a56bd(doc, schema, adfStage);
    if (node.type === 'doc') {
        node.content = $0190d1906f5ad323$var$wrapInlineNodes(node.content);
        return node;
    }
    return null;
};
const $0190d1906f5ad323$var$wrapInlineNodes = (nodes = [])=>{
    return nodes.map((node)=>(0, $fAF2Y.inlineNodes).has(node.type) ? {
            type: 'paragraph',
            content: [
                node
            ]
        } : node);
};
const $0190d1906f5ad323$export$fafd4f799ee68da0 = (content, schema = (0, $8DB98.defaultSchema), adfStage = 'final')=>{
    return content.map((node)=>$0190d1906f5ad323$export$81b20b6c83a56bd(node, schema, adfStage));
};
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $0190d1906f5ad323$var$TEXT_COLOR_PATTERN = /^#[0-9a-fA-F]{6}$/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $0190d1906f5ad323$var$RELATIVE_LINK = /^\//;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $0190d1906f5ad323$var$ANCHOR_LINK = /^#/;
const $0190d1906f5ad323$var$flattenUnknownBlockTree = (node, schema = (0, $8DB98.defaultSchema), adfStage = 'final')=>{
    const output = [];
    let isPrevLeafNode = false;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    for(let i = 0; i < node.content.length; i++){
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const childNode = node.content[i];
        const isLeafNode = !(childNode.content && childNode.content.length);
        if (i > 0) {
            if (isPrevLeafNode) output.push({
                type: 'text',
                text: ' '
            });
            else output.push({
                type: 'hardBreak'
            });
        }
        if (isLeafNode) output.push($0190d1906f5ad323$export$81b20b6c83a56bd(childNode, schema, adfStage));
        else output.push(...$0190d1906f5ad323$var$flattenUnknownBlockTree(childNode, schema, adfStage));
        isPrevLeafNode = isLeafNode;
    }
    return output;
};
const $0190d1906f5ad323$export$b9908ef75cad1e0e = (node)=>{
    const { attrs: attrs = {}, content: content, text: text, type: type } = node;
    if (!content || !content.length) {
        const unknownInlineNode = {
            type: 'text',
            text: text || attrs.text || `[${type}]`
        };
        const { textUrl: textUrl } = attrs;
        if (textUrl && (0, $iKozC.isSafeUrl)(textUrl)) unknownInlineNode.marks = [
            {
                type: 'link',
                attrs: {
                    href: textUrl
                }
            }
        ];
        return unknownInlineNode;
    }
    /*
	 * Find leaf nodes and join them. If leaf nodes' parent node is the same node
	 * join with a blank space, otherwise they are children of different branches, i.e.
	 * we need to join them with a hardBreak node
	 */ return {
        type: 'unknownBlock',
        content: $0190d1906f5ad323$var$flattenUnknownBlockTree(node)
    };
};
const $0190d1906f5ad323$var$getValidMarks = (marks, adfStage = 'final')=>{
    if (marks && marks.length > 0) return marks.reduce((acc, mark)=>{
        const validMark = $0190d1906f5ad323$export$87c6d4a6ebb7d9e9(mark, adfStage);
        if (validMark) acc.push(validMark);
        return acc;
    }, []);
    return marks;
};
const $0190d1906f5ad323$export$81b20b6c83a56bd = (originalNode, schema = (0, $8DB98.defaultSchema), adfStage = 'final')=>{
    const { attrs: attrs, marks: marks, text: text, type: type } = originalNode;
    let { content: content } = originalNode;
    const node = {
        attrs: attrs,
        marks: marks,
        text: text,
        type: type
    };
    if (content) node.content = content = $0190d1906f5ad323$export$fafd4f799ee68da0(content, schema, adfStage);
    // If node type doesn't exist in schema, make it an unknown node
    if (!schema.nodes[type]) return $0190d1906f5ad323$export$b9908ef75cad1e0e(node);
    if (type) switch(type){
        case 'doc':
            {
                const { version: version } = originalNode;
                if (version && content && content.length) return {
                    type: type,
                    content: content
                };
                break;
            }
        case 'codeBlock':
            if (content) content = content.reduce((acc, val)=>{
                if (val.type === 'text') acc.push({
                    type: val.type,
                    text: val.text
                });
                return acc;
            }, []);
            if (attrs && attrs.language) return {
                type: type,
                attrs: attrs,
                content: content,
                marks: marks
            };
            return {
                type: type,
                content: content,
                marks: marks
            };
        case 'date':
            if (attrs && attrs.timestamp) return {
                type: type,
                attrs: attrs,
                ...(0, $eGOwo.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'status':
            if (attrs && attrs.text && attrs.color) return {
                type: type,
                attrs: attrs,
                ...(0, $eGOwo.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'emoji':
            if (attrs && attrs.shortName) return {
                type: type,
                attrs: attrs,
                ...(0, $eGOwo.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'inlineExtension':
        case 'extension':
            if (attrs && attrs.extensionType && attrs.extensionKey) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'inlineCard':
            if (attrs && (attrs.datasource && !attrs.url || attrs.url && (0, $iKozC.isSafeUrl)(attrs.url) || attrs.data && attrs.data.url && (0, $iKozC.isSafeUrl)(attrs.data.url))) return {
                type: type,
                attrs: attrs,
                ...(0, $eGOwo.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'blockCard':
            if (attrs && (attrs.datasource && !attrs.url || attrs.url && (0, $iKozC.isSafeUrl)(attrs.url) || attrs.data && attrs.data.url && (0, $iKozC.isSafeUrl)(attrs.data.url))) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'embedCard':
            if (attrs && (attrs.url && (0, $iKozC.isSafeUrl)(attrs.url) || attrs.data && attrs.data.url && (0, $iKozC.isSafeUrl)(attrs.data.url)) && attrs.layout) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'bodiedExtension':
            if (attrs && attrs.extensionType && attrs.extensionKey && content) return {
                type: type,
                attrs: attrs,
                content: content
            };
            break;
        case 'multiBodiedExtension':
            if (attrs && attrs.extensionType && attrs.extensionKey && content) return {
                type: type,
                attrs: attrs,
                content: content
            };
            break;
        case 'extensionFrame':
            if (content) return {
                type: type,
                attrs: attrs,
                content: content
            };
            break;
        case 'hardBreak':
            return {
                type: type
            };
        case 'caption':
            if (content) return {
                type: type,
                content: content
            };
            break;
        case 'mediaInline':
            {
                let mediaId = '';
                let mediaCollection = [];
                if (attrs) {
                    const { id: id, collection: collection } = attrs;
                    mediaId = id;
                    mediaCollection = collection;
                }
                if (mediaId && mediaCollection) return {
                    type: type,
                    attrs: attrs,
                    marks: marks
                };
                break;
            }
        case 'media':
            {
                let mediaId = '';
                let mediaType = '';
                let mediaCollection = [];
                let mediaUrl = '';
                if (attrs) {
                    const { id: id, collection: collection, type: type, url: url } = attrs;
                    mediaId = id;
                    mediaType = type;
                    mediaCollection = collection;
                    mediaUrl = url;
                }
                if (mediaType === 'external' && !!mediaUrl) {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const mediaAttrs = {
                        type: mediaType,
                        url: mediaUrl,
                        width: attrs.width,
                        height: attrs.height
                    };
                    if (attrs.alt) mediaAttrs.alt = attrs.alt;
                    const getMarks = $0190d1906f5ad323$var$getValidMarks(marks, adfStage);
                    return getMarks ? {
                        type: type,
                        attrs: mediaAttrs,
                        marks: getMarks
                    } : {
                        type: type,
                        attrs: mediaAttrs
                    };
                } else if (mediaId && mediaType) {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const mediaAttrs = {
                        type: mediaType,
                        id: mediaId,
                        collection: mediaCollection
                    };
                    if (attrs.width) mediaAttrs.width = attrs.width;
                    if (attrs.height) mediaAttrs.height = attrs.height;
                    if (attrs.alt) mediaAttrs.alt = attrs.alt;
                    const getMarks = $0190d1906f5ad323$var$getValidMarks(marks, adfStage);
                    return getMarks ? {
                        type: type,
                        attrs: mediaAttrs,
                        marks: getMarks
                    } : {
                        type: type,
                        attrs: mediaAttrs
                    };
                }
                break;
            }
        case 'mediaGroup':
            if (Array.isArray(content) && !content.some((e)=>e.type !== 'media')) return {
                type: type,
                content: content
            };
            break;
        case 'mediaSingle':
            {
                const containsJustMedia = Array.isArray(content) && content.length === 1 && content[0].type === 'media';
                const containsMediaAndCaption = Array.isArray(content) && content.length === 2 && content[0].type === 'media' && content[1].type === 'caption';
                if (containsJustMedia || containsMediaAndCaption) return {
                    type: type,
                    attrs: attrs,
                    content: content,
                    marks: $0190d1906f5ad323$var$getValidMarks(marks, adfStage)
                };
                break;
            }
        case 'mention':
            {
                let mentionText = '';
                let mentionId;
                let mentionAccess;
                if (attrs) {
                    const { text: text, displayName: displayName, id: id, accessLevel: accessLevel } = attrs;
                    mentionText = text || displayName;
                    mentionId = id;
                    mentionAccess = accessLevel;
                }
                if (!mentionText) mentionText = text || '@unknown';
                if (mentionText && mentionId) {
                    const mentionNode = {
                        type: type,
                        attrs: {
                            id: mentionId,
                            text: mentionText,
                            accessLevel: ''
                        },
                        ...(0, $eGOwo.fg)('editor_inline_comments_on_inline_nodes') ? {
                            marks: marks
                        } : {}
                    };
                    if (mentionAccess) mentionNode.attrs.accessLevel = mentionAccess;
                    return mentionNode;
                }
                break;
            }
        case 'paragraph':
            if (adfStage === 'stage0') {
                const paragraphNode = {
                    type: type,
                    content: content || []
                };
                if (attrs && attrs.localId) paragraphNode.attrs = {
                    localId: attrs.localId
                };
                if (marks) paragraphNode.marks = [
                    ...marks
                ];
                return paragraphNode;
            }
            return marks ? {
                type: type,
                content: content || [],
                marks: marks
            } : {
                type: type,
                content: content || []
            };
        case 'rule':
            return {
                type: type
            };
        case 'text':
            {
                const { marks: marks } = node;
                if (text) return marks ? {
                    type: type,
                    text: text,
                    marks: $0190d1906f5ad323$var$getValidMarks(marks, adfStage)
                } : {
                    type: type,
                    text: text
                };
                break;
            }
        case 'heading':
            if (attrs) {
                const { level: level } = attrs;
                const between = (x, a, b)=>x >= a && x <= b;
                if (level && between(level, 1, 6)) {
                    if (adfStage === 'stage0') {
                        const headingNode = {
                            type: type,
                            content: content,
                            attrs: {
                                level: level
                            }
                        };
                        if (attrs.localId) headingNode.attrs.localId = attrs.localId;
                        if (marks) headingNode.marks = [
                            ...marks
                        ];
                        return headingNode;
                    }
                    return marks ? {
                        type: type,
                        content: content,
                        marks: marks,
                        attrs: {
                            level: level
                        }
                    } : {
                        type: type,
                        content: content,
                        attrs: {
                            level: level
                        }
                    };
                }
            }
            break;
        case 'bulletList':
            if (content) return {
                type: type,
                content: content
            };
            break;
        case 'orderedList':
            if (content) return {
                type: type,
                content: content,
                attrs: {
                    order: attrs && attrs.order
                }
            };
            break;
        case 'listItem':
            if (content) return {
                type: type,
                content: $0190d1906f5ad323$var$wrapInlineNodes(content)
            };
            break;
        case 'blockquote':
            if (content) return {
                type: type,
                content: content
            };
            break;
        case 'panel':
            if (attrs && content) {
                const { panelType: panelType } = attrs;
                if (Object.values((0, $ePdnq.PanelType)).includes(panelType)) return {
                    type: type,
                    attrs: attrs,
                    content: content
                };
            }
            break;
        case 'layoutSection':
            if (content) return {
                type: type,
                marks: marks,
                content: content
            };
            break;
        case 'layoutColumn':
            if (attrs && content) {
                if (attrs.width > 0 && attrs.width <= 100) return {
                    type: type,
                    content: content,
                    attrs: attrs
                };
            }
            break;
        case 'decisionList':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $2OrIX.generateUuid)()
                }
            };
        case 'decisionItem':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $2OrIX.generateUuid)(),
                    state: attrs && attrs.state || 'DECIDED'
                }
            };
        case 'taskList':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $2OrIX.generateUuid)()
                }
            };
        case 'taskItem':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $2OrIX.generateUuid)(),
                    state: attrs && attrs.state || 'TODO'
                }
            };
        case 'table':
            if (Array.isArray(content) && content.length > 0 && !content.some((e)=>e.type !== 'tableRow')) {
                if (adfStage === 'stage0') return {
                    type: type,
                    content: content,
                    attrs: {
                        ...attrs,
                        localId: attrs?.localId || (0, $2OrIX.generateUuid)(),
                        width: attrs?.width || null
                    }
                };
                return {
                    type: type,
                    content: content,
                    attrs: attrs
                };
            }
            break;
        case 'tableRow':
            if (Array.isArray(content) && content.length > 0 && !content.some((e)=>e.type !== 'tableCell' && e.type !== 'tableHeader')) return {
                type: type,
                content: content
            };
            break;
        case 'tableCell':
        case 'tableHeader':
            if (content) {
                const cellAttrs = {};
                if (attrs) {
                    if (attrs.colspan && attrs.colspan > 1) cellAttrs.colspan = attrs.colspan;
                    if (attrs.rowspan && attrs.rowspan > 1) cellAttrs.rowspan = attrs.rowspan;
                    if (attrs.background) cellAttrs.background = attrs.background;
                    if (attrs.colwidth && Array.isArray(attrs.colwidth)) cellAttrs.colwidth = attrs.colwidth;
                }
                return {
                    type: type,
                    content: $0190d1906f5ad323$var$wrapInlineNodes(content),
                    attrs: attrs ? cellAttrs : undefined
                };
            }
            break;
        case 'image':
            if (attrs && attrs.src) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'placeholder':
            if (attrs && typeof attrs.text !== 'undefined') return {
                type: type,
                attrs: attrs
            };
            break;
        case 'expand':
        case 'nestedExpand':
            return {
                type: type,
                attrs: attrs,
                content: content,
                marks: marks
            };
    }
    return $0190d1906f5ad323$export$b9908ef75cad1e0e(node);
};
const $0190d1906f5ad323$export$87c6d4a6ebb7d9e9 = (mark, adfStage = 'final')=>{
    const { attrs: attrs, type: type } = mark;
    if (type) switch(type){
        case 'code':
            return {
                type: type
            };
        case 'em':
            return {
                type: type
            };
        case 'link':
            if (attrs) {
                const { href: href, url: url, __confluenceMetadata: __confluenceMetadata } = attrs;
                let linkHref = href || url;
                if (linkHref && linkHref.indexOf(':') === -1 && !$0190d1906f5ad323$var$RELATIVE_LINK.test(linkHref) && !$0190d1906f5ad323$var$ANCHOR_LINK.test(linkHref)) linkHref = `http://${linkHref}`;
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const linkAttrs = {
                    href: linkHref
                };
                if (__confluenceMetadata) linkAttrs.__confluenceMetadata = __confluenceMetadata;
                if (linkHref && (0, $iKozC.isSafeUrl)(linkHref)) return {
                    type: type,
                    attrs: linkAttrs
                };
            }
            break;
        case 'strike':
            return {
                type: type
            };
        case 'strong':
            return {
                type: type
            };
        case 'subsup':
            if (attrs && attrs['type']) {
                const subSupType = attrs['type'];
                if ($0190d1906f5ad323$export$30f8aa4cc1f8c1cb(subSupType)) return {
                    type: type,
                    attrs: {
                        type: subSupType
                    }
                };
            }
            break;
        case 'textColor':
            if (attrs && $0190d1906f5ad323$var$TEXT_COLOR_PATTERN.test(attrs.color)) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'underline':
            return {
                type: type
            };
        case 'annotation':
            return {
                type: type,
                attrs: attrs
            };
        case 'border':
            return {
                type: type,
                attrs: attrs
            };
        case 'backgroundColor':
            if (attrs && $0190d1906f5ad323$var$TEXT_COLOR_PATTERN.test(attrs.color)) return {
                type: type,
                attrs: attrs
            };
            break;
    }
    if (adfStage === 'stage0') switch(type){
        case 'confluenceInlineComment':
            return {
                type: type,
                attrs: attrs
            };
        case 'dataConsumer':
            return {
                type: type,
                attrs: attrs
            };
        case 'fragment':
            return {
                type: type,
                attrs: attrs
            };
        case 'border':
            return {
                type: type,
                attrs: attrs
            };
    }
    return null;
};

});
parcelRegister("fAF2Y", function(module, exports) {

$parcel$export(module.exports, "inlineNodes", () => $b59a0ee18888e473$export$b1f729c6af6f2a6e);

var $jd35j = parcelRequire("jd35j");
const $b59a0ee18888e473$var$typedNodes = $jd35j;
const $b59a0ee18888e473$export$b1f729c6af6f2a6e = new Set(Object.keys($b59a0ee18888e473$var$typedNodes).filter((key)=>$b59a0ee18888e473$var$typedNodes[key] && $b59a0ee18888e473$var$typedNodes[key].group === 'inline'));

});
parcelRegister("jd35j", function(module, exports) {

$parcel$export(module.exports, "expandWithNestedExpand", () => (parcelRequire("eSKW9")).expandWithNestedExpand);
$parcel$export(module.exports, "expandToJSON", () => (parcelRequire("eSKW9")).toJSON);
$parcel$export(module.exports, "confluenceJiraIssue", () => (parcelRequire("itOTx")).confluenceJiraIssue);
$parcel$export(module.exports, "confluenceUnsupportedBlock", () => (parcelRequire("99RFR")).confluenceUnsupportedBlock);
$parcel$export(module.exports, "confluenceUnsupportedInline", () => (parcelRequire("4LGm1")).confluenceUnsupportedInline);
$parcel$export(module.exports, "doc", () => (parcelRequire("gjQyF")).doc);
$parcel$export(module.exports, "blockquote", () => (parcelRequire("iBSvH")).blockquote);
$parcel$export(module.exports, "extendedBlockquote", () => (parcelRequire("iBSvH")).extendedBlockquote);
$parcel$export(module.exports, "bulletList", () => (parcelRequire("7T1su")).bulletList);
$parcel$export(module.exports, "bulletListSelector", () => (parcelRequire("7T1su")).bulletListSelector);
$parcel$export(module.exports, "codeBlock", () => (parcelRequire("02BNy")).codeBlock);
$parcel$export(module.exports, "codeBlockToJSON", () => (parcelRequire("02BNy")).toJSON);
$parcel$export(module.exports, "hardBreak", () => (parcelRequire("ewUmv")).hardBreak);
$parcel$export(module.exports, "heading", () => (parcelRequire("8FGKL")).heading);
$parcel$export(module.exports, "rule", () => (parcelRequire("jC4KP")).rule);
$parcel$export(module.exports, "orderedList", () => (parcelRequire("a4ifE")).orderedList);
$parcel$export(module.exports, "orderedListSelector", () => (parcelRequire("a4ifE")).orderedListSelector);
$parcel$export(module.exports, "orderedListWithOrder", () => (parcelRequire("a4ifE")).orderedListWithOrder);
$parcel$export(module.exports, "paragraph", () => (parcelRequire("bK3tx")).paragraph);
$parcel$export(module.exports, "emoji", () => (parcelRequire("foHUC")).emoji);
$parcel$export(module.exports, "image", () => (parcelRequire("lM0g9")).image);
$parcel$export(module.exports, "mention", () => (parcelRequire("7axvl")).mention);
$parcel$export(module.exports, "mentionToJSON", () => (parcelRequire("7axvl")).toJSON);
$parcel$export(module.exports, "listItem", () => (parcelRequire("gkLMH")).listItem);
$parcel$export(module.exports, "listItemWithDecisionStage0", () => (parcelRequire("gkLMH")).listItemWithDecisionStage0);
$parcel$export(module.exports, "extendedPanel", () => (parcelRequire("ePdnq")).extendedPanel);
$parcel$export(module.exports, "PanelType", () => (parcelRequire("ePdnq")).PanelType);
$parcel$export(module.exports, "text", () => (parcelRequire("53i5t")).text);
$parcel$export(module.exports, "unknownBlock", () => (parcelRequire("bffKB")).default);
$parcel$export(module.exports, "caption", () => (parcelRequire("l2o3P")).caption);
$parcel$export(module.exports, "media", () => (parcelRequire("bTlUc")).media);
$parcel$export(module.exports, "copyPrivateMediaAttributes", () => (parcelRequire("bTlUc")).copyPrivateAttributes);
$parcel$export(module.exports, "mediaToJSON", () => (parcelRequire("bTlUc")).toJSON);
$parcel$export(module.exports, "mediaGroup", () => (parcelRequire("goVGV")).mediaGroup);
$parcel$export(module.exports, "mediaInline", () => (parcelRequire("5RVMs")).mediaInline);
$parcel$export(module.exports, "mediaSingle", () => (parcelRequire("8Mfla")).mediaSingle);
$parcel$export(module.exports, "mediaSingleSpec", () => (parcelRequire("8Mfla")).mediaSingleSpec);
$parcel$export(module.exports, "mediaSingleWithCaption", () => (parcelRequire("8Mfla")).mediaSingleWithCaption);
$parcel$export(module.exports, "mediaSingleWithWidthType", () => (parcelRequire("8Mfla")).mediaSingleWithWidthType);
$parcel$export(module.exports, "mediaSingleFull", () => (parcelRequire("8Mfla")).mediaSingleFull);
$parcel$export(module.exports, "mediaSingleToJSON", () => (parcelRequire("8Mfla")).toJSON);
$parcel$export(module.exports, "table", () => (parcelRequire("e6HpD")).table);
$parcel$export(module.exports, "tableWithNestedTable", () => (parcelRequire("e6HpD")).tableWithNestedTable);
$parcel$export(module.exports, "tableRowWithNestedTable", () => (parcelRequire("e6HpD")).tableRowWithNestedTable);
$parcel$export(module.exports, "tableCellWithNestedTable", () => (parcelRequire("e6HpD")).tableCellWithNestedTable);
$parcel$export(module.exports, "tableHeaderWithNestedTable", () => (parcelRequire("e6HpD")).tableHeaderWithNestedTable);
$parcel$export(module.exports, "tableStage0", () => (parcelRequire("e6HpD")).tableStage0);
$parcel$export(module.exports, "tableWithCustomWidth", () => (parcelRequire("e6HpD")).tableWithCustomWidth);
$parcel$export(module.exports, "tableToJSON", () => (parcelRequire("e6HpD")).tableToJSON);
$parcel$export(module.exports, "tableCell", () => (parcelRequire("e6HpD")).tableCell);
$parcel$export(module.exports, "toJSONTableCell", () => (parcelRequire("e6HpD")).toJSONTableCell);
$parcel$export(module.exports, "tableHeader", () => (parcelRequire("e6HpD")).tableHeader);
$parcel$export(module.exports, "toJSONTableHeader", () => (parcelRequire("e6HpD")).toJSONTableHeader);
$parcel$export(module.exports, "tableRow", () => (parcelRequire("e6HpD")).tableRow);
$parcel$export(module.exports, "tableBackgroundColorPalette", () => (parcelRequire("e6HpD")).tableBackgroundColorPalette);
$parcel$export(module.exports, "tableBackgroundBorderColor", () => (parcelRequire("e6HpD")).tableBackgroundBorderColor);
$parcel$export(module.exports, "tableBackgroundColorNames", () => (parcelRequire("e6HpD")).tableBackgroundColorNames);
$parcel$export(module.exports, "getCellAttrs", () => (parcelRequire("e6HpD")).getCellAttrs);
$parcel$export(module.exports, "getCellDomAttrs", () => (parcelRequire("e6HpD")).getCellDomAttrs);
$parcel$export(module.exports, "tablePrefixSelector", () => (parcelRequire("e6HpD")).tablePrefixSelector);
$parcel$export(module.exports, "tableCellSelector", () => (parcelRequire("e6HpD")).tableCellSelector);
$parcel$export(module.exports, "tableHeaderSelector", () => (parcelRequire("e6HpD")).tableHeaderSelector);
$parcel$export(module.exports, "tableCellContentWrapperSelector", () => (parcelRequire("e6HpD")).tableCellContentWrapperSelector);
$parcel$export(module.exports, "tableCellContentDomSelector", () => (parcelRequire("e6HpD")).tableCellContentDomSelector);
$parcel$export(module.exports, "decisionList", () => (parcelRequire("9FkNK")).decisionList);
$parcel$export(module.exports, "decisionListSelector", () => (parcelRequire("9FkNK")).decisionListSelector);
$parcel$export(module.exports, "decisionItem", () => (parcelRequire("eblOZ")).decisionItem);
$parcel$export(module.exports, "taskList", () => (parcelRequire("6Yq90")).taskList);
$parcel$export(module.exports, "taskListSelector", () => (parcelRequire("6Yq90")).taskListSelector);
$parcel$export(module.exports, "taskItem", () => (parcelRequire("5iuEY")).taskItem);
$parcel$export(module.exports, "date", () => (parcelRequire("s7CHM")).date);
$parcel$export(module.exports, "placeholder", () => (parcelRequire("hbObi")).placeholder);
$parcel$export(module.exports, "layoutSection", () => (parcelRequire("jSvxD")).layoutSection);
$parcel$export(module.exports, "layoutSectionWithSingleColumn", () => (parcelRequire("jSvxD")).layoutSectionWithSingleColumn);
$parcel$export(module.exports, "layoutColumn", () => (parcelRequire("gNk91")).layoutColumn);
$parcel$export(module.exports, "inlineCard", () => (parcelRequire("3MHOZ")).inlineCard);
$parcel$export(module.exports, "blockCard", () => (parcelRequire("5sqgz")).blockCard);
$parcel$export(module.exports, "unsupportedBlock", () => (parcelRequire("e1kFZ")).unsupportedBlock);
$parcel$export(module.exports, "unsupportedInline", () => (parcelRequire("5blh0")).unsupportedInline);
$parcel$export(module.exports, "status", () => (parcelRequire("c2Gqu")).status);
$parcel$export(module.exports, "nestedExpand", () => (parcelRequire("6UEeD")).nestedExpand);
$parcel$export(module.exports, "embedCard", () => (parcelRequire("YIci7")).embedCard);
$parcel$export(module.exports, "extension", () => (parcelRequire("6r1B4")).extension);
$parcel$export(module.exports, "inlineExtension", () => (parcelRequire("5Ufvu")).inlineExtension);
$parcel$export(module.exports, "bodiedExtension", () => (parcelRequire("kuVVV")).bodiedExtension);
$parcel$export(module.exports, "extensionFrame", () => (parcelRequire("6C9Qx")).extensionFrame);
$parcel$export(module.exports, "multiBodiedExtension", () => (parcelRequire("6C9Qx")).multiBodiedExtension);

var $eSKW9 = parcelRequire("eSKW9");

var $itOTx = parcelRequire("itOTx");

var $99RFR = parcelRequire("99RFR");

var $4LGm1 = parcelRequire("4LGm1");

var $gjQyF = parcelRequire("gjQyF");

var $iBSvH = parcelRequire("iBSvH");

var $7T1su = parcelRequire("7T1su");

var $02BNy = parcelRequire("02BNy");

var $ewUmv = parcelRequire("ewUmv");

var $8FGKL = parcelRequire("8FGKL");

var $jC4KP = parcelRequire("jC4KP");

var $a4ifE = parcelRequire("a4ifE");

var $bK3tx = parcelRequire("bK3tx");

var $foHUC = parcelRequire("foHUC");

var $lM0g9 = parcelRequire("lM0g9");

var $7axvl = parcelRequire("7axvl");

var $gkLMH = parcelRequire("gkLMH");

var $ePdnq = parcelRequire("ePdnq");

var $53i5t = parcelRequire("53i5t");

var $bffKB = parcelRequire("bffKB");

var $l2o3P = parcelRequire("l2o3P");

var $bTlUc = parcelRequire("bTlUc");

var $goVGV = parcelRequire("goVGV");

var $5RVMs = parcelRequire("5RVMs");

var $8Mfla = parcelRequire("8Mfla");

var $e6HpD = parcelRequire("e6HpD");

var $9FkNK = parcelRequire("9FkNK");

var $eblOZ = parcelRequire("eblOZ");

var $6Yq90 = parcelRequire("6Yq90");

var $5iuEY = parcelRequire("5iuEY");

var $s7CHM = parcelRequire("s7CHM");

var $hbObi = parcelRequire("hbObi");

var $jSvxD = parcelRequire("jSvxD");

var $gNk91 = parcelRequire("gNk91");

var $3MHOZ = parcelRequire("3MHOZ");

var $5sqgz = parcelRequire("5sqgz");

var $e1kFZ = parcelRequire("e1kFZ");

var $5blh0 = parcelRequire("5blh0");

var $c2Gqu = parcelRequire("c2Gqu");

var $6UEeD = parcelRequire("6UEeD");

var $YIci7 = parcelRequire("YIci7");

var $6r1B4 = parcelRequire("6r1B4");

var $5Ufvu = parcelRequire("5Ufvu");

var $kuVVV = parcelRequire("kuVVV");

var $6C9Qx = parcelRequire("6C9Qx");

});



parcelRegister("fftJQ", function(module, exports) {

$parcel$export(module.exports, "insideBreakoutLayout", () => $8a7b49658fbd7dfc$export$d7bc71cca336a3b);
$parcel$export(module.exports, "insideBlockNode", () => $8a7b49658fbd7dfc$export$42ddc573eb5a7b43);
$parcel$export(module.exports, "insideMultiBodiedExtension", () => $8a7b49658fbd7dfc$export$9f1e9347b0411934);
$parcel$export(module.exports, "insideTable", () => $8a7b49658fbd7dfc$export$244bf4b32387ef62);
const $8a7b49658fbd7dfc$var$isLayoutNode = (node)=>node.type.name === 'layoutSection';
const $8a7b49658fbd7dfc$var$hasBreakOutMark = (node)=>node.marks.some((m)=>m.type.name === 'breakout');
const $8a7b49658fbd7dfc$export$d7bc71cca336a3b = (path)=>path.some((item)=>$8a7b49658fbd7dfc$var$isLayoutNode(item) && $8a7b49658fbd7dfc$var$hasBreakOutMark(item));
const $8a7b49658fbd7dfc$export$42ddc573eb5a7b43 = (path, schema)=>{
    const { nodes: { expand: expand, nestedExpand: nestedExpand, layoutColumn: layoutColumn } } = schema;
    const blockNodeNames = [
        expand,
        nestedExpand,
        layoutColumn
    ].filter((node)=>Boolean(node)).map((node)=>node.name);
    return path && path.some((n)=>n.type && blockNodeNames.indexOf(n.type.name) > -1);
};
const $8a7b49658fbd7dfc$export$9f1e9347b0411934 = (path, schema)=>{
    const { nodes: { multiBodiedExtension: multiBodiedExtension } } = schema;
    return path.some((n)=>n.type === multiBodiedExtension);
};
const $8a7b49658fbd7dfc$export$244bf4b32387ef62 = (path, schema)=>{
    const { nodes: { table: table } } = schema;
    return path.some((n)=>n.type === table);
};

});


parcelRegister("fjfmN", function(module, exports) {

$parcel$export(module.exports, "renderDocument", () => $7a1052b2a1567e8a$export$59a54f98b9753d5c);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $8DB98 = parcelRequire("8DB98");

var $djAo6 = parcelRequire("djAo6");
var $jF4Mi = parcelRequire("jF4Mi");

var $bMFKb = parcelRequire("bMFKb");

var $3mTkR = parcelRequire("3mTkR");
var $3Ussg = parcelRequire("3Ussg");

var $cRsRn = parcelRequire("cRsRn");

var $eGOwo = parcelRequire("eGOwo");

var $LFmXM = parcelRequire("LFmXM");

var $7ueoK = parcelRequire("7ueoK");

var $lE3K0 = parcelRequire("lE3K0");

var $86V7W = parcelRequire("86V7W");
const $7a1052b2a1567e8a$var$SUPPORTS_HIRES_TIMER_API = !!(typeof window !== 'undefined' && window.performance && performance.now);
const $7a1052b2a1567e8a$var$withStopwatch = (cb)=>{
    const startTime = $7a1052b2a1567e8a$var$SUPPORTS_HIRES_TIMER_API ? performance.now() : Date.now();
    const output = cb();
    const endTime = $7a1052b2a1567e8a$var$SUPPORTS_HIRES_TIMER_API ? performance.now() : Date.now();
    const time = endTime - startTime;
    return {
        output: output,
        time: time
    };
};
const $7a1052b2a1567e8a$var$_validation = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
doc, schema, adfStage, useSpecBasedValidator, dispatchAnalyticsEvent, skipValidation, validationOverrides)=>{
    let result;
    if (useSpecBasedValidator) {
        // link mark on mediaSingle is deprecated, need to move link mark to child media node
        // https://product-fabric.atlassian.net/browse/ED-14043
        const { transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $djAo6.transformMediaLinkMarks)(doc);
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $bMFKb.ACTION).MEDIA_LINK_TRANSFORMED,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).RENDERER,
            eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL
        });
        result = skipValidation ? transformedAdf || doc : (0, $3Ussg.validateADFEntity)(schema, transformedAdf || doc, dispatchAnalyticsEvent, validationOverrides);
    } else result = (0, $cRsRn.getValidDocument)(doc, schema, adfStage);
    if (!result) return result;
    // ProseMirror always require a child under doc
    if (result.type === 'doc' && useSpecBasedValidator) {
        if (Array.isArray(result.content) && result.content.length === 0) result.content.push({
            type: 'paragraph',
            content: []
        });
        // Just making sure doc is always valid
        if (!result.version) result.version = 1;
    }
    // Convert nested-table extensions into nested tables
    try {
        const { transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $jF4Mi.transformNestedTablesIncomingDocument)(result, {
            environment: 'renderer',
            disableNestedRendererTreatment: (0, $eGOwo.fg)('platform_editor_nested_table_extension_comment_fix')
        });
        if (isTransformed) {
            dispatchAnalyticsEvent?.({
                action: (0, $bMFKb.ACTION).NESTED_TABLE_TRANSFORMED,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).RENDERER,
                eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL
            });
            result = transformedAdf;
        }
    } catch (e) {
        dispatchAnalyticsEvent?.({
            action: (0, $bMFKb.ACTION).INVALID_PROSEMIRROR_DOCUMENT,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).RENDERER,
            eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL,
            attributes: {
                platform: (0, $7ueoK.PLATFORM).WEB,
                errorStack: `${e instanceof Error && e.name === 'NodeNestingTransformError' ? 'NodeNestingTransformError - Failed to encode one or more nested tables' : undefined}`
            }
        });
    }
    return result;
};
const $7a1052b2a1567e8a$var$memoValidation = (0, $LFmXM.default)($7a1052b2a1567e8a$var$_validation, (newArgs, lastArgs)=>{
    let result = false;
    if ((0, $eGOwo.fg)('cc_complexit_fe_memovalidation_redundant_calls_2')) {
        const [newDoc, newSchema, newADFStage, newUseSpecValidator, , // ignoring dispatchAnalyticsEvent
        newSkipValidation, newValidationOverrides] = newArgs;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const [oldDoc, oldSchema, oldADFStage, oldUseSpecValidator, , // ignoring dispatchAnalyticsEvent
        oldSkipValidation, oldValidationOverrides] = lastArgs;
        result = $7a1052b2a1567e8a$var$areDocsEqual(newDoc, oldDoc) && newSchema === oldSchema && newADFStage === oldADFStage && newUseSpecValidator === oldUseSpecValidator && newSkipValidation === oldSkipValidation && newValidationOverrides === oldValidationOverrides;
    } else {
        // This path has a bug and it will wrongfully assign dispatchAnalyticsEvent to skipValidation/oldSkipValidation
        // instead of ignoring it as it does not skip it when unpacking the array.
        // This results the function returning false when it should return true
        // and causing extra re-renders. see https://hello.jira.atlassian.cloud/browse/COMPLEXIT-161.
        const [newDoc, newSchema, newADFStage, newUseSpecValidator, , skipValidation, newValidationOverrides] = newArgs;
        const [oldDoc, oldSchema, oldADFStage, oldUseSpecValidator, , oldSkipValidation, oldValidationOverrides] = lastArgs;
        result = $7a1052b2a1567e8a$var$areDocsEqual(newDoc, oldDoc) && newSchema === oldSchema && newADFStage === oldADFStage && newUseSpecValidator === oldUseSpecValidator && skipValidation === oldSkipValidation && newValidationOverrides === oldValidationOverrides;
    }
    return result;
});
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $7a1052b2a1567e8a$var$areDocsEqual = (docA, docB)=>{
    if (docA === docB) return true;
    if (typeof docA === 'string' && typeof docB === 'string') return docA === docB;
    // PMNode
    if (docA.type && docA.toJSON && docB.type && docB.toJSON) return JSON.stringify(docA.toJSON()) === JSON.stringify(docB.toJSON());
    // Object
    return JSON.stringify(docA) === JSON.stringify(docB);
};
const $7a1052b2a1567e8a$var$_serializeFragment = (serializer, doc)=>{
    return serializer.serializeFragment(doc.content);
};
const $7a1052b2a1567e8a$var$memoSerializeFragment = (0, $LFmXM.default)($7a1052b2a1567e8a$var$_serializeFragment, (newArgs, lastArgs)=>{
    const [newSerializer, newDoc] = newArgs;
    const [oldSerializer, oldDoc] = lastArgs;
    return newSerializer === oldSerializer && $7a1052b2a1567e8a$var$areDocsEqual(newDoc, oldDoc);
});
const $7a1052b2a1567e8a$var$_createNodeAndCheck = (schema, // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
doc, dispatchAnalyticsEvent)=>{
    const pmNode = schema.nodeFromJSON(doc);
    try {
        pmNode.check();
    } catch (err) {
        if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $bMFKb.ACTION).INVALID_PROSEMIRROR_DOCUMENT,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).RENDERER,
            attributes: {
                platform: (0, $7ueoK.PLATFORM).WEB,
                errorStack: err instanceof Error ? err.message : String(err)
            },
            eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL
        });
    }
    return pmNode;
};
const $7a1052b2a1567e8a$var$memoCreateNodeAndCheck = (0, $LFmXM.default)($7a1052b2a1567e8a$var$_createNodeAndCheck, (newArgs, lastArgs)=>{
    // ignore dispatchAnalyticsEvent
    const [newSchema, newDoc] = newArgs;
    const [oldSchema, oldDoc] = lastArgs;
    return newSchema === oldSchema && $7a1052b2a1567e8a$var$areDocsEqual(newDoc, oldDoc);
});
const $7a1052b2a1567e8a$export$59a54f98b9753d5c = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
doc, serializer, schema = (0, $8DB98.defaultSchema), adfStage = 'final', useSpecBasedValidator = false, rendererId = 'noid', dispatchAnalyticsEvent, unsupportedContentLevelsTracking, appearance, includeNodesCountInStats, skipValidation, validationOverrides)=>{
    const stat = {
        sanitizeTime: 0
    };
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if ((0, $eGOwo.fg)('platform_editor_renderer_rm_usespecbasedvalidator')) useSpecBasedValidator = true;
    const { output: validDoc, time: sanitizeTime } = $7a1052b2a1567e8a$var$withStopwatch(()=>{
        return $7a1052b2a1567e8a$var$memoValidation(doc, schema, adfStage, useSpecBasedValidator, dispatchAnalyticsEvent, skipValidation, validationOverrides);
    });
    // save sanitize time to stats
    stat.sanitizeTime = sanitizeTime;
    if (!validDoc) return {
        stat: stat,
        result: null
    };
    const { output: node, time: buildTreeTime } = $7a1052b2a1567e8a$var$withStopwatch(()=>{
        return $7a1052b2a1567e8a$var$memoCreateNodeAndCheck(schema, validDoc, dispatchAnalyticsEvent);
    });
    // save build tree time to stats
    stat.buildTreeTime = buildTreeTime;
    const { output: result, time: serializeTime } = $7a1052b2a1567e8a$var$withStopwatch(()=>{
        return $7a1052b2a1567e8a$var$memoSerializeFragment(serializer, node);
    });
    // save serialize tree time to stats
    stat.serializeTime = serializeTime;
    if (dispatchAnalyticsEvent && useSpecBasedValidator) {
        (0, $3mTkR.findAndTrackUnsupportedContentNodes)(node, schema, dispatchAnalyticsEvent);
        if (unsupportedContentLevelsTracking?.enabled) {
            const documentData = {
                doc: validDoc,
                appearance: appearance,
                rendererId: rendererId
            };
            (0, $lE3K0.trackUnsupportedContentLevels)(documentData, unsupportedContentLevelsTracking, dispatchAnalyticsEvent);
        }
    }
    if (includeNodesCountInStats) stat.nodesCount = (0, $86V7W.countNodes)(doc);
    return {
        result: result,
        stat: stat,
        pmDoc: node
    };
};

});
parcelRegister("djAo6", function(module, exports) {

$parcel$export(module.exports, "transformMediaLinkMarks", () => $b2a4642f722aa8d8$export$6528700f3fa2fe2a);

var $0mclG = parcelRequire("0mclG");
const $b2a4642f722aa8d8$export$6528700f3fa2fe2a = (adf)=>{
    let isTransformed = false;
    const transformedAdf = (0, $0mclG.traverse)(adf, {
        mediaSingle: (node)=>{
            if (!node.marks || !node.content || node.content[0]?.type !== 'media') return node;
            let linkMark = null;
            node.marks.forEach((mark, i)=>{
                if (mark.type === 'link') {
                    linkMark = mark;
                    node.marks?.splice(i, 1);
                    isTransformed = true;
                }
            });
            if (node.marks.length === 0) delete node.marks;
            if (linkMark) {
                const mediaNode = node.content[0];
                // only add link mark if media node doesnt already have one
                if (mediaNode.marks?.every((mark)=>mark.type !== 'link')) mediaNode.marks.push(linkMark);
                else if (!mediaNode.marks) mediaNode.marks = [
                    linkMark
                ];
            }
            return node;
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};

});

parcelRegister("3Ussg", function(module, exports) {

$parcel$export(module.exports, "validateADFEntity", () => $263400656bb608dd$export$884cfad20dece33e);

var $2MkAG = parcelRequire("2MkAG");

var $bMFKb = parcelRequire("bMFKb");

var $3mTkR = parcelRequire("3mTkR");
const $263400656bb608dd$export$8e7fd962b4d3895d = 'unsupportedNodeAttribute';
const $263400656bb608dd$var$errorCallbackFor = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
marks, validate, dispatchAnalyticsEvent, validationOverrides)=>{
    return (entity, error, options)=>{
        return $263400656bb608dd$export$468b008419c9a974(entity, error, {
            ...options,
            allowNestedTables: validationOverrides?.allowNestedTables
        }, marks, validate, dispatchAnalyticsEvent);
    };
};
const $263400656bb608dd$export$468b008419c9a974 = (entity, error, options, marks, validate, dispatchAnalyticsEvent)=>{
    if (entity && entity.type === $263400656bb608dd$export$8e7fd962b4d3895d) return entity;
    if (options.isMark) return $263400656bb608dd$export$87b732fa69cdf16e(error.meta, 'mark');
    if (options.isNodeAttribute) {
        const entityType = entity && entity.type ? entity.type : undefined;
        return {
            type: $263400656bb608dd$export$8e7fd962b4d3895d,
            attrs: {
                type: {
                    nodeType: entityType
                },
                unsupported: error.meta
            }
        };
    }
    if (entity && marks.indexOf(entity.type) > -1) return;
    /**
	 * There's a inconsistency between ProseMirror and ADF.
	 * `content` is actually optional in ProseMirror.
	 * And, also empty `text` node is not valid.
	 */ if (error.code === 'MISSING_PROPERTIES' && entity.type === 'paragraph') return {
        type: 'paragraph',
        content: []
    };
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: We can repair missing content like `panel` without a `paragraph`.
    if (error.code === 'INVALID_CONTENT_LENGTH') {
        if (error.meta && options.allowUnsupportedBlock && entity.content) return $263400656bb608dd$var$getEntityForInvalidContentLength(error, entity, validate, marks, dispatchAnalyticsEvent);
        else // Can't fix it by wrapping
        if (dispatchAnalyticsEvent) $263400656bb608dd$var$trackValidationError(dispatchAnalyticsEvent, error, entity);
    }
    // Nested tables don't actually exist in ADF. In ADF they are stored as an `extension` node with the nested table content serialized in a property of that extension.
    // Usually when we validate ADF we are validating this `extension` and then later transforming it into nested tables for usage by ProseMirror.
    // Under certain circumstances however, ADF validation is performed on this already transformed extension and since nested tables aren't allowed by ADF this
    // produces an error. For example, nested renderers in Confluence `bodiedExtension`'s. The nested renderer receives the already transformed nested tables that originated from the
    // `extension` node and validates it. This is invalid ADF so an error is thrown.
    // This override allows an exception to be made for nested tables in the validator in this circumstance.
    if (options.allowNestedTables) {
        const meta = error.meta;
        if (options.allowNestedTables && meta?.parentType && [
            'tableCell',
            'tableHeader'
        ].includes(meta?.parentType) && error.code === 'INVALID_CONTENT' && entity.type === 'table') return entity;
    }
    if (options.allowUnsupportedBlock) return $263400656bb608dd$export$87b732fa69cdf16e(entity);
    if (options.allowUnsupportedInline) return $263400656bb608dd$export$87b732fa69cdf16e(entity, 'inline');
    if (dispatchAnalyticsEvent) $263400656bb608dd$var$trackValidationError(dispatchAnalyticsEvent, error, entity);
    return entity;
};
function $263400656bb608dd$var$getEntityForInvalidContentLength(error, entity, validate, marks, dispatchAnalyticsEvent) {
    const meta = error.meta;
    if (meta.type === 'maximum') // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    entity.content = entity.content.filter((x)=>!!x).map((child, index)=>{
        return index >= meta.requiredLength && child.type !== 'unsupportedBlock' ? $263400656bb608dd$export$87b732fa69cdf16e(child) : validate(child, $263400656bb608dd$var$errorCallbackFor(marks, validate, dispatchAnalyticsEvent)).entity;
    });
    if (meta.type === 'minimum') {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if (entity.content.length === 0) return $263400656bb608dd$export$87b732fa69cdf16e(entity);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        entity.content = entity.content.filter((x)=>!!x).map((child)=>{
            return child.type !== 'unsupportedBlock' ? $263400656bb608dd$export$87b732fa69cdf16e(child) : child;
        });
    }
    return entity;
}
function $263400656bb608dd$var$trackValidationError(dispatchAnalyticsEvent, error, entity) {
    if (!dispatchAnalyticsEvent) return;
    (0, $3mTkR.fireUnsupportedEvent)(dispatchAnalyticsEvent, (0, $bMFKb.ACTION_SUBJECT_ID).UNSUPPORTED_ERROR, {
        type: entity.type || '',
        ancestry: entity.ancestorHierarchy || '',
        parentType: entity.parentType || '',
        marks: entity.marks || [],
        attrs: entity.attrs || {}
    }, error.code);
}
const $263400656bb608dd$export$884cfad20dece33e = (schema, node, dispatchAnalyticsEvent, validationOverrides)=>{
    const nodes = Object.keys(schema.nodes);
    const marks = Object.keys(schema.marks);
    const validate = (0, $2MkAG.validator)(nodes, marks, {
        allowPrivateAttributes: true
    });
    const emptyDoc = {
        type: 'doc',
        content: []
    };
    const { entity: entity = emptyDoc } = validate(node, $263400656bb608dd$var$errorCallbackFor(marks, validate, dispatchAnalyticsEvent, validationOverrides));
    return entity;
};
function $263400656bb608dd$export$87b732fa69cdf16e(originalValue, type = 'block') {
    let unsupportedNodeType;
    switch(type){
        case 'inline':
            unsupportedNodeType = 'unsupportedInline';
            break;
        case 'mark':
            unsupportedNodeType = 'unsupportedMark';
            break;
        default:
            unsupportedNodeType = 'unsupportedBlock';
    }
    return {
        type: unsupportedNodeType,
        attrs: {
            originalValue: originalValue
        }
    };
}

});
parcelRegister("2MkAG", function(module, exports) {

$parcel$export(module.exports, "validator", () => $96effbef339de82e$export$956325f45c5d174a);
// Ignored via go/ees005
// eslint-disable-next-line import/no-namespace

var $l7cdi = parcelRequire("l7cdi");

var $kfOTy = parcelRequire("kfOTy");

var $eZqxv = parcelRequire("eZqxv");
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $96effbef339de82e$var$mapMarksItems(spec, fn = (x)=>x) {
    if (spec.props && spec.props.marks) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const { items: items, ...rest } = spec.props.marks;
        return {
            ...spec,
            props: {
                ...spec.props,
                marks: {
                    ...rest,
                    /**
					 * `Text & MarksObject<Mark-1>` produces `items: ['mark-1']`
					 * `Text & MarksObject<Mark-1 | Mark-2>` produces `items: [['mark-1', 'mark-2']]`
					 */ items: items.length ? Array.isArray(items[0]) ? items.map(fn) : [
                        fn(items)
                    ] : [
                        []
                    ]
                }
            }
        };
    } else return spec;
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $96effbef339de82e$var$partitionObject = (obj, predicate)=>Object.keys(obj).reduce((acc, key)=>{
        const result = predicate(key, obj[key], obj);
        acc[result ? 0 : 1].push(key);
        return acc;
    }, [
        [],
        []
    ]);
/**
 * Normalizes the structure of files imported from './specs'.
 * We denormalised the spec to save bundle size.
 */ function $96effbef339de82e$var$createSpec(nodes, marks) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return Object.keys($l7cdi).reduce((newSpecs, k)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const spec = {
            ...$l7cdi[k]
        };
        if (spec.props) {
            spec.props = {
                ...spec.props
            };
            if (spec.props.content) {
                // 'tableCell_content' => { type: 'array', items: [ ... ] }
                if ((0, $kfOTy.isString)(spec.props.content)) // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                spec.props.content = $l7cdi[spec.props.content];
                // ['inline', 'emoji']
                if (Array.isArray(spec.props.content)) /**
					 * Flatten
					 *
					 * Input:
					 * [ { type: 'array', items: [ 'tableHeader' ] }, { type: 'array', items: [ 'tableCell' ] } ]
					 *
					 * Output:
					 * { type: 'array', items: [ [ 'tableHeader' ], [ 'tableCell' ] ] }
					 */ spec.props.content = {
                    type: 'array',
                    items: (spec.props.content || []).map((arr)=>arr.items)
                };
                else spec.props.content = {
                    ...spec.props.content
                };
                spec.props.content.items = spec.props.content.items// ['inline'] => [['emoji', 'hr', ...]]
                // ['media'] => [['media']]
                .map((item)=>(0, $kfOTy.isString)(item) ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    Array.isArray($l7cdi[item]) ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    $l7cdi[item] : [
                        item
                    ] : item)// [['emoji', 'hr', 'inline_code']] => [['emoji', 'hr', ['text', { marks: {} }]]]
                .map((item)=>item.map((subItem)=>// Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        Array.isArray($l7cdi[subItem]) ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        $l7cdi[subItem] : (0, $kfOTy.isString)(subItem) ? subItem : [
                            'text',
                            subItem
                        ])// Remove unsupported nodes & marks
                    // Filter nodes
                    .filter((subItem)=>{
                        if (nodes) {
                            // Node with overrides
                            // ['mediaSingle', { props: { content: { items: [ 'media', 'caption' ] } }}]
                            if (Array.isArray(subItem)) {
                                const isMainNodeSupported = nodes.indexOf(subItem[0]) > -1;
                                if (isMainNodeSupported && subItem[1]?.props?.content?.items) return subItem[1].props.content.items.every((item)=>nodes.indexOf(item) > -1);
                                return isMainNodeSupported;
                            }
                            return nodes.indexOf(subItem) > -1;
                        }
                        return true;
                    })// Filter marks
                    .map((subItem)=>Array.isArray(subItem) && marks ? /**
										 * TODO: Probably try something like immer, but it's 3.3kb gzipped.
										 * Not worth it just for this.
										 */ [
                            subItem[0],
                            $96effbef339de82e$var$mapMarksItems(subItem[1])
                        ] : subItem));
            }
        }
        newSpecs[k] = spec;
        return newSpecs;
    }, {});
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $96effbef339de82e$var$getOptionsForType(type, list) {
    if (!list) return {};
    for(let i = 0, len = list.length; i < len; i++){
        const spec = list[i];
        let name = spec;
        let options = {};
        if (Array.isArray(spec)) [name, options] = spec;
        if (name === type) return options;
    }
    return false;
}
const $96effbef339de82e$var$isValidatorSpecAttrs = (spec)=>{
    return !!spec.props;
};
function $96effbef339de82e$export$66c739158ef99a42(spec, value) {
    if (!(0, $kfOTy.isDefined)(value)) return !!spec.optional;
    if ($96effbef339de82e$var$isValidatorSpecAttrs(spec)) {
        // If spec has ".props" it is ValidatorSpecAttrs and need to pipe back in recursively
        const [_, invalidKeys] = $96effbef339de82e$var$partitionObject(spec.props, (key, subSpec)=>// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            $96effbef339de82e$export$66c739158ef99a42(subSpec, value[key]));
        return invalidKeys.length === 0;
    }
    // extension_node parameters has no type
    if (!(0, $kfOTy.isDefined)(spec.type)) return !!spec.optional;
    switch(spec.type){
        case 'boolean':
            return (0, $kfOTy.isBoolean)(value);
        case 'number':
            return (0, $kfOTy.isNumber)(value) && ((0, $kfOTy.isDefined)(spec.minimum) ? spec.minimum <= value : true) && ((0, $kfOTy.isDefined)(spec.maximum) ? spec.maximum >= value : true);
        case 'integer':
            return (0, $kfOTy.isInteger)(value) && ((0, $kfOTy.isDefined)(spec.minimum) ? spec.minimum <= value : true) && ((0, $kfOTy.isDefined)(spec.maximum) ? spec.maximum >= value : true);
        case 'string':
            const validatorFnPassed = (rule)=>typeof value === 'string' && (0, $kfOTy.isDefined)((0, $eZqxv.validatorFnMap)[rule]) && (0, $eZqxv.validatorFnMap)[rule](value);
            return (0, $kfOTy.isString)(value) && // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            ((0, $kfOTy.isDefined)(spec.minLength) ? spec.minLength <= value.length : true) && ((0, $kfOTy.isDefined)(spec.validatorFn) ? validatorFnPassed(spec.validatorFn) : true) && // Ignored via go/ees005
            // eslint-disable-next-line require-unicode-regexp
            (spec.pattern ? new RegExp(spec.pattern).test(value) : true);
        case 'object':
            return (0, $kfOTy.isPlainObject)(value);
        case 'array':
            if (Array.isArray(value)) {
                const isTuple = !!spec.isTupleLike;
                const { minItems: minItems, maxItems: maxItems } = spec;
                if (minItems !== undefined && value.length < minItems || maxItems !== undefined && value.length > maxItems) return false;
                if (isTuple) {
                    // If value has fewer items than tuple has specs - we are fine with that.
                    const numberOfItemsToCheck = Math.min(spec.items.length, value.length);
                    return Array(numberOfItemsToCheck).fill(null).every((_, i)=>$96effbef339de82e$export$66c739158ef99a42(spec.items[i], value[i]));
                } else return value.every((valueItem)=>// We check that at least one of the specs in the list (spec.items) matches each value from
                    spec.items.some((itemSpec)=>$96effbef339de82e$export$66c739158ef99a42(itemSpec, valueItem)));
            }
            return false;
        case 'enum':
            return (0, $kfOTy.isString)(value) && spec.values.indexOf(value) > -1;
    }
}
const $96effbef339de82e$var$errorMessageFor = (type, message)=>`${type}: ${message}.`;
const $96effbef339de82e$var$getUnsupportedOptions = (spec)=>{
    if (spec && spec.props && spec.props.content) {
        const { allowUnsupportedBlock: allowUnsupportedBlock, allowUnsupportedInline: allowUnsupportedInline } = spec.props.content;
        return {
            allowUnsupportedBlock: allowUnsupportedBlock,
            allowUnsupportedInline: allowUnsupportedInline
        };
    }
    return {};
};
const $96effbef339de82e$var$invalidChildContent = (child, errorCallback, parentSpec)=>{
    const message = $96effbef339de82e$var$errorMessageFor(child.type, 'invalid content');
    if (!errorCallback) throw new Error(message);
    else return errorCallback({
        ...child
    }, {
        code: 'INVALID_CONTENT',
        message: message,
        meta: {
            parentType: parentSpec?.props?.type?.values[0]
        }
    }, $96effbef339de82e$var$getUnsupportedOptions(parentSpec));
};
const $96effbef339de82e$var$unsupportedMarkContent = (errorCode, mark, errorCallback, errorMessage)=>{
    const message = errorMessage || $96effbef339de82e$var$errorMessageFor(mark.type, 'unsupported mark');
    if (!errorCallback) throw new Error(message);
    else return errorCallback({
        ...mark
    }, {
        code: errorCode,
        message: message,
        meta: mark
    }, {
        allowUnsupportedBlock: false,
        allowUnsupportedInline: false,
        isMark: true
    });
};
const $96effbef339de82e$var$unsupportedNodeAttributesContent = (entity, errorCode, invalidAttributes, message, errorCallback)=>{
    if (!errorCallback) throw new Error(message);
    else return errorCallback({
        type: entity.type
    }, {
        code: errorCode,
        message: message,
        meta: invalidAttributes
    }, {
        allowUnsupportedBlock: false,
        allowUnsupportedInline: false,
        isMark: false,
        isNodeAttribute: true
    });
};
function $96effbef339de82e$export$956325f45c5d174a(nodes, marks, options) {
    const validatorSpecs = $96effbef339de82e$var$createSpec(nodes, marks);
    const { mode: mode = 'strict', allowPrivateAttributes: allowPrivateAttributes = false } = options || {};
    const validate = (entity, errorCallback, allowed, parentSpec)=>{
        const validationResult = validateNode(entity, errorCallback, allowed, parentSpec);
        return {
            entity: validationResult.entity,
            valid: validationResult.valid
        };
    };
    const validateNode = (entity, errorCallback, allowed, parentSpec, isMark = false)=>{
        const { type: type } = entity;
        const newEntity = {
            ...entity
        };
        const err = (code, msg, meta)=>{
            const message = $96effbef339de82e$var$errorMessageFor(type, msg);
            if (errorCallback) return {
                valid: false,
                entity: errorCallback(newEntity, {
                    code: code,
                    message: message,
                    meta: meta
                }, $96effbef339de82e$var$getUnsupportedOptions(parentSpec))
            };
            else throw new Error(message);
        };
        if (type) {
            const typeOptions = $96effbef339de82e$var$getOptionsForType(type, allowed);
            if (typeOptions === false) return isMark ? {
                valid: false
            } : err('INVALID_TYPE', 'type not allowed here');
            const spec = validatorSpecs[type];
            if (!spec) return err('INVALID_TYPE', `${type}: No validation spec found for type!`);
            const specBasedValidationResult = specBasedValidationFor(spec, typeOptions, entity, err, newEntity, type, errorCallback, isMark);
            if (specBasedValidationResult.hasValidated && specBasedValidationResult.result) return specBasedValidationResult.result;
        } else return err('INVALID_TYPE', 'ProseMirror Node/Mark should contain a `type`');
        return {
            valid: true,
            entity: newEntity
        };
    };
    return validate;
    function marksValidationFor(validator, entity, errorCallback, newEntity, err) {
        let validationResult;
        if (validator.props && validator.props.marks) {
            const marksSet = allowedMarksFor(validator);
            const marksValidationResult = marksAfterValidation(entity, errorCallback, marksSet, validator);
            validationResult = {
                valid: true,
                entity: newEntity,
                marksValidationOutput: marksValidationResult
            };
        } else validationResult = marksForEntitySpecNotSupportingMarks(entity, newEntity, errorCallback, err);
        return validationResult;
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function validatorFor(spec, typeOptions) {
        return {
            ...spec,
            ...typeOptions,
            // options with props can override props of spec
            ...spec.props ? {
                props: {
                    ...spec.props,
                    ...typeOptions['props'] || {}
                }
            } : {}
        };
    }
    function marksAfterValidation(entity, errorCallback, marksSet, validator) {
        return entity.marks ? entity.marks.map((mark)=>{
            const isAKnownMark = marks ? marks.indexOf(mark.type) > -1 : true;
            if (mode === 'strict' && isAKnownMark) {
                const finalResult = validateNode(mark, errorCallback, marksSet, validator, true);
                const finalMark = finalResult.entity;
                if (finalMark) return {
                    valid: true,
                    originalMark: mark,
                    newMark: finalMark
                };
                else if (finalResult.marksValidationOutput && finalResult.marksValidationOutput.length) return {
                    valid: false,
                    originalMark: mark,
                    errorCode: finalResult.marksValidationOutput[0].errorCode,
                    message: finalResult.marksValidationOutput[0].message
                };
                else return {
                    valid: false,
                    originalMark: mark,
                    errorCode: 'INVALID_TYPE'
                };
            } else return {
                valid: false,
                originalMark: mark,
                errorCode: 'INVALID_CONTENT'
            };
        }) : [];
    }
    function allowedMarksFor(validator) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const { items: items } = validator.props.marks;
        const marksSet = items.length ? Array.isArray(items[0]) ? items[0] : items : [];
        return marksSet;
    }
    function marksForEntitySpecNotSupportingMarks(prevEntity, newEntity, errorCallback, err) {
        const errorCode = 'REDUNDANT_MARKS';
        const currentMarks = prevEntity.marks || [];
        const newMarks = currentMarks.map((mark)=>{
            const isUnsupportedNodeAttributeMark = mark.type === 'unsupportedNodeAttribute';
            if (isUnsupportedNodeAttributeMark) return mark;
            return $96effbef339de82e$var$unsupportedMarkContent(errorCode, mark, errorCallback);
        });
        if (newMarks.length) {
            newEntity.marks = newMarks;
            return {
                valid: true,
                entity: newEntity
            };
        } else return err('REDUNDANT_MARKS', 'redundant marks', {
            marks: Object.keys(currentMarks)
        });
    }
    function requiredPropertyValidationFor(validatorSpec, prevEntity, err) {
        let result = {
            valid: true,
            entity: prevEntity
        };
        if (validatorSpec.required) {
            if (!validatorSpec.required.every((prop)=>(0, $kfOTy.isDefined)(prevEntity[prop]))) result = err('MISSING_PROPERTIES', 'required prop missing');
        }
        return result;
    }
    function textPropertyValidationFor(validatorSpec, prevEntity, err) {
        let result = {
            valid: true,
            entity: prevEntity
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if (validatorSpec.props.text) {
            if ((0, $kfOTy.isDefined)(prevEntity.text) && // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            !$96effbef339de82e$export$66c739158ef99a42(validatorSpec.props.text, prevEntity.text)) result = err('INVALID_TEXT', `'text' validation failed`);
        }
        return result;
    }
    function contentLengthValidationFor(validatorSpec, prevEntity, err) {
        let result = {
            valid: true,
            entity: prevEntity
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if (validatorSpec.props.content && prevEntity.content) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const { minItems: minItems, maxItems: maxItems } = validatorSpec.props.content;
            const length = prevEntity.content.length;
            if ((0, $kfOTy.isDefined)(minItems) && minItems > length) result = err('INVALID_CONTENT_LENGTH', `'content' should have more than ${minItems} child`, {
                length: length,
                requiredLength: minItems,
                type: 'minimum'
            });
            else if ((0, $kfOTy.isDefined)(maxItems) && maxItems < length) result = err('INVALID_CONTENT_LENGTH', `'content' should have less than ${maxItems} child`, {
                length: length,
                requiredLength: maxItems,
                type: 'maximum'
            });
        }
        return result;
    }
    function invalidAttributesFor(validatorSpec, prevEntity) {
        let invalidAttrs = [];
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let validatorAttrs = {};
        if (validatorSpec.props && validatorSpec.props.attrs) {
            const attrOptions = (0, $kfOTy.makeArray)(validatorSpec.props.attrs);
            /**
			 * Attrs can be union type so try each path
			 * attrs: [{ props: { url: { type: 'string' } } }, { props: { data: {} } }],
			 * Gotcha: It will always report the last failure.
			 */ for(let i = 0, length = attrOptions.length; i < length; ++i){
                const attrOption = attrOptions[i];
                if (attrOption && attrOption.props) [, invalidAttrs] = $96effbef339de82e$var$partitionObject(attrOption.props, (key, spec)=>{
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const valueToValidate = prevEntity.attrs[key];
                    return $96effbef339de82e$export$66c739158ef99a42(spec, valueToValidate);
                });
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                validatorAttrs = attrOption;
                if (!invalidAttrs.length) break;
            }
        }
        return {
            invalidAttrs: invalidAttrs,
            validatorAttrs: validatorAttrs
        };
    }
    function attributesValidationFor(validatorSpec, prevEntity, newEntity, isMark, errorCallback) {
        const validatorSpecAllowsAttributes = validatorSpec.props && validatorSpec.props.attrs;
        if (prevEntity.attrs) {
            if (!validatorSpecAllowsAttributes) {
                if (isMark) return handleNoAttibutesAllowedInSpecForMark(prevEntity, prevEntity.attrs);
                const attrs = Object.keys(prevEntity.attrs);
                return handleUnsupportedNodeAttributes(prevEntity, newEntity, [], attrs, errorCallback);
            }
            const { hasUnsupportedAttrs: hasUnsupportedAttrs, redundantAttrs: redundantAttrs, invalidAttrs: invalidAttrs } = validateAttributes(validatorSpec, prevEntity, prevEntity.attrs);
            if (hasUnsupportedAttrs) {
                if (isMark) return handleUnsupportedMarkAttributes(prevEntity, invalidAttrs, redundantAttrs);
                return handleUnsupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, redundantAttrs, errorCallback);
            }
        }
        return {
            valid: true,
            entity: prevEntity
        };
    }
    function validateAttributes(validatorSpec, prevEntity, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    attributes) {
        const invalidAttributesResult = invalidAttributesFor(validatorSpec, prevEntity);
        const { invalidAttrs: invalidAttrs } = invalidAttributesResult;
        const validatorAttrs = invalidAttributesResult.validatorAttrs;
        const attrs = Object.keys(attributes).filter((k)=>!(allowPrivateAttributes && k.startsWith('__')));
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const redundantAttrs = attrs.filter((a)=>!validatorAttrs.props[a]);
        const hasRedundantAttrs = redundantAttrs.length > 0;
        const hasUnsupportedAttrs = invalidAttrs.length || hasRedundantAttrs;
        return {
            hasUnsupportedAttrs: hasUnsupportedAttrs,
            invalidAttrs: invalidAttrs,
            redundantAttrs: redundantAttrs
        };
    }
    function handleUnsupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, redundantAttrs, errorCallback) {
        const attr = invalidAttrs.concat(redundantAttrs);
        let result = {
            valid: true,
            entity: prevEntity
        };
        const message = $96effbef339de82e$var$errorMessageFor(prevEntity.type, `'attrs' validation failed`);
        const errorCode = 'UNSUPPORTED_ATTRIBUTES';
        newEntity.marks = wrapUnSupportedNodeAttributes(prevEntity, newEntity, attr, errorCode, message, errorCallback);
        result = {
            valid: true,
            entity: newEntity
        };
        return result;
    }
    function handleUnsupportedMarkAttributes(prevEntity, invalidAttrs, redundantAttrs) {
        let errorCode = 'INVALID_ATTRIBUTES';
        let message = $96effbef339de82e$var$errorMessageFor(prevEntity.type, `'attrs' validation failed`);
        const hasRedundantAttrs = redundantAttrs.length;
        const hasBothInvalidAndRedundantAttrs = hasRedundantAttrs && invalidAttrs.length;
        if (!hasBothInvalidAndRedundantAttrs && hasRedundantAttrs) {
            errorCode = 'REDUNDANT_ATTRIBUTES';
            message = $96effbef339de82e$var$errorMessageFor('redundant attributes found', redundantAttrs.join(', '));
        }
        const markValidationResult = {
            valid: true,
            originalMark: prevEntity,
            errorCode: errorCode,
            message: message
        };
        return {
            valid: false,
            marksValidationOutput: [
                markValidationResult
            ]
        };
    }
    function handleNoAttibutesAllowedInSpecForMark(prevEntity, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    attributes) {
        const message = $96effbef339de82e$var$errorMessageFor('redundant attributes found', Object.keys(attributes).join(', '));
        const errorCode = 'REDUNDANT_ATTRIBUTES';
        const markValidationResult = {
            valid: true,
            originalMark: prevEntity,
            errorCode: errorCode,
            message: message
        };
        return {
            valid: false,
            marksValidationOutput: [
                markValidationResult
            ]
        };
    }
    function wrapUnSupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, errorCode, message, errorCallback) {
        const invalidValues = {};
        // eslint-disable-next-line guard-for-in
        for(const invalidAttr in invalidAttrs){
            invalidValues[invalidAttrs[invalidAttr]] = prevEntity.attrs && prevEntity.attrs[invalidAttrs[invalidAttr]];
            if (newEntity.attrs) delete newEntity.attrs[invalidAttrs[invalidAttr]];
        }
        const unsupportedNodeAttributeValues = $96effbef339de82e$var$unsupportedNodeAttributesContent(prevEntity, errorCode, invalidValues, message, errorCallback);
        const finalEntity = {
            ...newEntity
        };
        if (finalEntity.marks) {
            if (!unsupportedNodeAttributeValues) return finalEntity.marks;
            // If there is an existing unsupported node attribute mark, overwrite it to avoid duplicate marks
            const existingMark = finalEntity.marks.find((mark)=>mark.type === unsupportedNodeAttributeValues.type);
            if (existingMark) existingMark.attrs = unsupportedNodeAttributeValues.attrs;
            else finalEntity.marks.push(unsupportedNodeAttributeValues);
            return finalEntity.marks;
        } else return [
            unsupportedNodeAttributeValues
        ];
    }
    function extraPropsValidationFor(validatorSpec, prevEntity, err, newEntity, type) {
        const result = {
            valid: true,
            entity: prevEntity
        };
        const [requiredProps, redundantProps] = $96effbef339de82e$var$partitionObject(prevEntity, (k)=>// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $kfOTy.isDefined)(validatorSpec.props[k]));
        if (redundantProps.length) {
            if (mode === 'loose') {
                newEntity = {
                    type: type
                };
                requiredProps.reduce((acc, p)=>(0, $kfOTy.copy)(prevEntity, acc, p), newEntity);
            } else {
                if (!((redundantProps.indexOf('marks') > -1 || redundantProps.indexOf('attrs') > -1) && redundantProps.length === 1)) return err('REDUNDANT_PROPERTIES', `redundant props found: ${redundantProps.join(', ')}`, {
                    props: redundantProps
                });
            }
        }
        return result;
    }
    function specBasedValidationFor(spec, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    typeOptions, prevEntity, err, newEntity, type, errorCallback, isMark) {
        const specBasedValidationResult = {
            hasValidated: false
        };
        const validatorSpec = validatorFor(spec, typeOptions);
        if (!validatorSpec) return specBasedValidationResult;
        // Required Props
        // For array format where `required` is an array
        const requiredPropertyValidatonResult = requiredPropertyValidationFor(validatorSpec, prevEntity, err);
        if (!requiredPropertyValidatonResult.valid) return {
            hasValidated: true,
            result: requiredPropertyValidatonResult
        };
        if (!validatorSpec.props) {
            const props = Object.keys(prevEntity);
            // If there's no validator.props then there shouldn't be any key except `type`
            if (props.length > 1) return {
                hasValidated: true,
                result: err('REDUNDANT_PROPERTIES', `redundant props found: ${Object.keys(prevEntity).join(', ')}`, {
                    props: props
                })
            };
            return specBasedValidationResult;
        }
        // Check text
        const textPropertyValidationResult = textPropertyValidationFor(validatorSpec, prevEntity, err);
        if (!textPropertyValidationResult.valid) return {
            hasValidated: true,
            result: textPropertyValidationResult
        };
        // Content Length
        const contentLengthValidationResult = contentLengthValidationFor(validatorSpec, prevEntity, err);
        if (!contentLengthValidationResult.valid) return {
            hasValidated: true,
            result: contentLengthValidationResult
        };
        // Required Props
        // For object format based on `optional` property
        const [, missingProps] = $96effbef339de82e$var$partitionObject(validatorSpec.props, (k, v)=>{
            // if the validator is an array, then check
            // if the `required` field contains the key.
            const isOptional = Array.isArray(v) ? !validatorSpec.required?.includes(k) : typeof v === 'object' && v !== null && 'optional' in v ? v.optional : false;
            return isOptional || (0, $kfOTy.isDefined)(prevEntity[k]);
        });
        if (missingProps.length) return {
            hasValidated: true,
            result: err('MISSING_PROPERTIES', 'required prop missing', {
                props: missingProps
            })
        };
        const attributesValidationResult = attributesValidationFor(validatorSpec, prevEntity, newEntity, isMark, errorCallback);
        if (!attributesValidationResult.valid) return {
            hasValidated: true,
            result: attributesValidationResult
        };
        if (isMark && attributesValidationResult.valid) return {
            hasValidated: true,
            result: attributesValidationResult
        };
        const extraPropsValidationResult = extraPropsValidationFor(validatorSpec, prevEntity, err, newEntity, type);
        if (!extraPropsValidationResult.valid) return {
            hasValidated: true,
            result: extraPropsValidationResult
        };
        // Children
        if (validatorSpec.props.content) {
            const contentValidatorSpec = validatorSpec.props.content;
            if (prevEntity.content) {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const validateChildNode = (child, index)=>{
                    if (child === undefined) return child;
                    const validateChildMarks = (childEntity, marksValidationOutput, errorCallback, isLastValidationSpec, isParentTupleLike = false)=>{
                        let marksAreValid = true;
                        if (childEntity && childEntity.marks && marksValidationOutput) {
                            const validMarks = marksValidationOutput.filter((mark)=>mark.valid);
                            // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            const finalMarks = marksValidationOutput.map((mr)=>{
                                if (mr.valid) return mr.newMark;
                                else {
                                    if (validMarks.length || isLastValidationSpec || isParentTupleLike || mr.errorCode === 'INVALID_TYPE' || mr.errorCode === 'INVALID_CONTENT' || mr.errorCode === 'REDUNDANT_ATTRIBUTES' || mr.errorCode === 'INVALID_ATTRIBUTES') return $96effbef339de82e$var$unsupportedMarkContent(// Ignored via go/ees005
                                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                                    mr.errorCode, mr.originalMark, errorCallback, mr.message);
                                    return;
                                }
                            }).filter(Boolean);
                            if (finalMarks.length) childEntity.marks = finalMarks;
                            else {
                                delete childEntity.marks;
                                marksAreValid = false;
                            }
                        }
                        return {
                            valid: marksAreValid,
                            entity: childEntity
                        };
                    };
                    const hasMultipleCombinationOfContentAllowed = !!contentValidatorSpec.isTupleLike;
                    if (hasMultipleCombinationOfContentAllowed) {
                        const { entity: newChildEntity, marksValidationOutput: marksValidationOutput } = validateNode(child, errorCallback, (0, $kfOTy.makeArray)(contentValidatorSpec.items[index] || contentValidatorSpec.items[contentValidatorSpec.items.length - 1]), validatorSpec);
                        const { entity: entity } = validateChildMarks(newChildEntity, marksValidationOutput, errorCallback, false, true);
                        return entity;
                    }
                    // Only go inside valid branch
                    const allowedSpecsForEntity = contentValidatorSpec.items.filter((item)=>Array.isArray(item) ? item.some(// [p, hr, ...] or [p, [text, {}], ...]
                        (spec)=>(Array.isArray(spec) ? spec[0] : spec) === child.type) : true);
                    if (allowedSpecsForEntity.length) {
                        if (allowedSpecsForEntity.length > 1) throw new Error('Consider using Tuple instead!');
                        const maybeArray = (0, $kfOTy.makeArray)(allowedSpecsForEntity[0]);
                        const allowedSpecsForChild = maybeArray.filter((item)=>(Array.isArray(item) ? item[0] : item) === child.type);
                        if (allowedSpecsForChild.length === 0) return $96effbef339de82e$var$invalidChildContent(child, errorCallback, validatorSpec);
                        /**
						 * When there's multiple possible branches try all of them.
						 * If all of them fails, throw the first one.
						 * e.g.- [['text', { marks: ['a'] }], ['text', { marks: ['b'] }]]
						 */ let firstError;
                        let firstChild;
                        for(let i = 0, len = allowedSpecsForChild.length; i < len; i++)try {
                            const allowedValueForCurrentSpec = [
                                allowedSpecsForChild[i]
                            ];
                            const { valid: valid, entity: newChildEntity, marksValidationOutput: marksValidationOutput } = validateNode(child, errorCallback, allowedValueForCurrentSpec, validatorSpec);
                            if (valid) {
                                const isLastValidationSpec = i === allowedSpecsForChild.length - 1;
                                const { valid: marksAreValid, entity: entity } = validateChildMarks(newChildEntity, marksValidationOutput, errorCallback, isLastValidationSpec);
                                const unsupportedMarks = entity && entity.marks && entity.marks.filter((mark)=>mark.type === 'unsupportedMark') || [];
                                if (marksAreValid && !unsupportedMarks.length) return entity;
                                else firstChild = firstChild || newChildEntity;
                            } else firstChild = firstChild || newChildEntity;
                        } catch (error) {
                            firstError = firstError || error;
                        }
                        if (!errorCallback) throw firstError;
                        else return firstChild;
                    } else return $96effbef339de82e$var$invalidChildContent(child, errorCallback, validatorSpec);
                };
                newEntity.content = prevEntity.content.map(validateChildNode).filter(Boolean);
            } else if (!contentValidatorSpec.optional) return {
                hasValidated: true,
                result: err('MISSING_PROPERTIES', 'missing `content` prop')
            };
        }
        // Marks
        if (prevEntity.marks) return {
            hasValidated: true,
            result: marksValidationFor(validatorSpec, prevEntity, errorCallback, newEntity, err)
        };
        return specBasedValidationResult;
    }
}

});
parcelRegister("l7cdi", function(module, exports) {

$parcel$export(module.exports, "alignment", () => (parcelRequire("aio1x")).alignment);
$parcel$export(module.exports, "annotation", () => (parcelRequire("aio1x")).annotation);
$parcel$export(module.exports, "backgroundColor", () => (parcelRequire("aio1x")).backgroundColor);
$parcel$export(module.exports, "blockCard", () => (parcelRequire("aio1x")).blockCard);
$parcel$export(module.exports, "block_content", () => (parcelRequire("aio1x")).block_content);
$parcel$export(module.exports, "blockRootOnly", () => (parcelRequire("aio1x")).blockRootOnly);
$parcel$export(module.exports, "blockquote", () => (parcelRequire("aio1x")).blockquote);
$parcel$export(module.exports, "bodiedExtension", () => (parcelRequire("aio1x")).bodiedExtension);
$parcel$export(module.exports, "bodiedExtension_with_marks", () => (parcelRequire("aio1x")).bodiedExtension_with_marks);
$parcel$export(module.exports, "border", () => (parcelRequire("aio1x")).border);
$parcel$export(module.exports, "breakout", () => (parcelRequire("aio1x")).breakout);
$parcel$export(module.exports, "bulletList", () => (parcelRequire("aio1x")).bulletList);
$parcel$export(module.exports, "caption", () => (parcelRequire("aio1x")).caption);
$parcel$export(module.exports, "code", () => (parcelRequire("aio1x")).code);
$parcel$export(module.exports, "codeBlock", () => (parcelRequire("aio1x")).codeBlock);
$parcel$export(module.exports, "codeBlock_root_only", () => (parcelRequire("aio1x")).codeBlock_root_only);
$parcel$export(module.exports, "text_with_no_marks", () => (parcelRequire("aio1x")).text_with_no_marks);
$parcel$export(module.exports, "confluenceInlineComment", () => (parcelRequire("aio1x")).confluenceInlineComment);
$parcel$export(module.exports, "dataConsumer", () => (parcelRequire("aio1x")).dataConsumer);
$parcel$export(module.exports, "date", () => (parcelRequire("aio1x")).date);
$parcel$export(module.exports, "decisionItem", () => (parcelRequire("aio1x")).decisionItem);
$parcel$export(module.exports, "decisionList", () => (parcelRequire("aio1x")).decisionList);
$parcel$export(module.exports, "doc", () => (parcelRequire("aio1x")).doc);
$parcel$export(module.exports, "em", () => (parcelRequire("aio1x")).em);
$parcel$export(module.exports, "embedCard", () => (parcelRequire("aio1x")).embedCard);
$parcel$export(module.exports, "emoji", () => (parcelRequire("aio1x")).emoji);
$parcel$export(module.exports, "expand", () => (parcelRequire("aio1x")).expand);
$parcel$export(module.exports, "expand_root_only", () => (parcelRequire("aio1x")).expand_root_only);
$parcel$export(module.exports, "extension", () => (parcelRequire("aio1x")).extension);
$parcel$export(module.exports, "extensionFrame", () => (parcelRequire("aio1x")).extensionFrame);
$parcel$export(module.exports, "extension_with_marks", () => (parcelRequire("aio1x")).extension_with_marks);
$parcel$export(module.exports, "fragment", () => (parcelRequire("aio1x")).fragment);
$parcel$export(module.exports, "hardBreak", () => (parcelRequire("aio1x")).hardBreak);
$parcel$export(module.exports, "heading", () => (parcelRequire("aio1x")).heading);
$parcel$export(module.exports, "heading_with_alignment", () => (parcelRequire("aio1x")).heading_with_alignment);
$parcel$export(module.exports, "heading_with_indentation", () => (parcelRequire("aio1x")).heading_with_indentation);
$parcel$export(module.exports, "heading_with_no_marks", () => (parcelRequire("aio1x")).heading_with_no_marks);
$parcel$export(module.exports, "indentation", () => (parcelRequire("aio1x")).indentation);
$parcel$export(module.exports, "inlineCard", () => (parcelRequire("aio1x")).inlineCard);
$parcel$export(module.exports, "inlineExtension", () => (parcelRequire("aio1x")).inlineExtension);
$parcel$export(module.exports, "inlineExtension_with_marks", () => (parcelRequire("aio1x")).inlineExtension_with_marks);
$parcel$export(module.exports, "inline_content", () => (parcelRequire("aio1x")).inline_content);
$parcel$export(module.exports, "layoutColumn", () => (parcelRequire("aio1x")).layoutColumn);
$parcel$export(module.exports, "layoutSection", () => (parcelRequire("aio1x")).layoutSection);
$parcel$export(module.exports, "layoutSection_full", () => (parcelRequire("aio1x")).layoutSection_full);
$parcel$export(module.exports, "layoutSection_with_single_column", () => (parcelRequire("aio1x")).layoutSection_with_single_column);
$parcel$export(module.exports, "link", () => (parcelRequire("aio1x")).link);
$parcel$export(module.exports, "listItem", () => (parcelRequire("aio1x")).listItem);
$parcel$export(module.exports, "media", () => (parcelRequire("aio1x")).media);
$parcel$export(module.exports, "mediaGroup", () => (parcelRequire("aio1x")).mediaGroup);
$parcel$export(module.exports, "mediaInline", () => (parcelRequire("aio1x")).mediaInline);
$parcel$export(module.exports, "mediaSingle", () => (parcelRequire("aio1x")).mediaSingle);
$parcel$export(module.exports, "mediaSingle_caption", () => (parcelRequire("aio1x")).mediaSingle_caption);
$parcel$export(module.exports, "mediaSingle_full", () => (parcelRequire("aio1x")).mediaSingle_full);
$parcel$export(module.exports, "mention", () => (parcelRequire("aio1x")).mention);
$parcel$export(module.exports, "multiBodiedExtension", () => (parcelRequire("aio1x")).multiBodiedExtension);
$parcel$export(module.exports, "nestedExpand", () => (parcelRequire("aio1x")).nestedExpand);
$parcel$export(module.exports, "nestedExpand_content", () => (parcelRequire("aio1x")).nestedExpand_content);
$parcel$export(module.exports, "nestedExpand_with_no_marks", () => (parcelRequire("aio1x")).nestedExpand_with_no_marks);
$parcel$export(module.exports, "non_nestable_block_content", () => (parcelRequire("aio1x")).non_nestable_block_content);
$parcel$export(module.exports, "orderedList", () => (parcelRequire("aio1x")).orderedList);
$parcel$export(module.exports, "panel", () => (parcelRequire("aio1x")).panel);
$parcel$export(module.exports, "paragraph", () => (parcelRequire("aio1x")).paragraph);
$parcel$export(module.exports, "paragraph_with_alignment", () => (parcelRequire("aio1x")).paragraph_with_alignment);
$parcel$export(module.exports, "paragraph_with_indentation", () => (parcelRequire("aio1x")).paragraph_with_indentation);
$parcel$export(module.exports, "paragraph_with_no_marks", () => (parcelRequire("aio1x")).paragraph_with_no_marks);
$parcel$export(module.exports, "placeholder", () => (parcelRequire("aio1x")).placeholder);
$parcel$export(module.exports, "rule", () => (parcelRequire("aio1x")).rule);
$parcel$export(module.exports, "status", () => (parcelRequire("aio1x")).status);
$parcel$export(module.exports, "strike", () => (parcelRequire("aio1x")).strike);
$parcel$export(module.exports, "strong", () => (parcelRequire("aio1x")).strong);
$parcel$export(module.exports, "subsup", () => (parcelRequire("aio1x")).subsup);
$parcel$export(module.exports, "table", () => (parcelRequire("aio1x")).table);
$parcel$export(module.exports, "tableCell", () => (parcelRequire("aio1x")).tableCell);
$parcel$export(module.exports, "tableHeader", () => (parcelRequire("aio1x")).tableHeader);
$parcel$export(module.exports, "tableRow", () => (parcelRequire("aio1x")).tableRow);
$parcel$export(module.exports, "taskItem", () => (parcelRequire("aio1x")).taskItem);
$parcel$export(module.exports, "taskList", () => (parcelRequire("aio1x")).taskList);
$parcel$export(module.exports, "text", () => (parcelRequire("aio1x")).text);
$parcel$export(module.exports, "textColor", () => (parcelRequire("aio1x")).textColor);
$parcel$export(module.exports, "text_code_inline", () => (parcelRequire("aio1x")).text_code_inline);
$parcel$export(module.exports, "text_formatted", () => (parcelRequire("aio1x")).text_formatted);
$parcel$export(module.exports, "text_link_inline", () => (parcelRequire("aio1x")).text_link_inline);
$parcel$export(module.exports, "underline", () => (parcelRequire("aio1x")).underline);
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $aio1x = parcelRequire("aio1x");

});
parcelRegister("aio1x", function(module, exports) {

$parcel$export(module.exports, "alignment", () => $77ee386e3e14f4e0$export$8e53000a4ec837);
$parcel$export(module.exports, "annotation", () => $77ee386e3e14f4e0$export$8512c9afa7b24c3b);
$parcel$export(module.exports, "backgroundColor", () => $77ee386e3e14f4e0$export$8c5a050822fd698c);
$parcel$export(module.exports, "block_content", () => $77ee386e3e14f4e0$export$a31afb40076fa18b);
$parcel$export(module.exports, "blockCard", () => $77ee386e3e14f4e0$export$c4c2f833baaebdb8);
$parcel$export(module.exports, "blockquote", () => $77ee386e3e14f4e0$export$67dc04e652a298ca);
$parcel$export(module.exports, "blockRootOnly", () => $77ee386e3e14f4e0$export$ebb5393736e9ba23);
$parcel$export(module.exports, "bodiedExtension", () => $77ee386e3e14f4e0$export$27903d543b563e39);
$parcel$export(module.exports, "bodiedExtension_with_marks", () => $77ee386e3e14f4e0$export$ee052cc5b2356e83);
$parcel$export(module.exports, "border", () => $77ee386e3e14f4e0$export$1edee58a52776cd9);
$parcel$export(module.exports, "breakout", () => $77ee386e3e14f4e0$export$89015c65f1c75e3f);
$parcel$export(module.exports, "bulletList", () => $77ee386e3e14f4e0$export$a140c94e5ea26bee);
$parcel$export(module.exports, "caption", () => $77ee386e3e14f4e0$export$8e3c2dfdc4f0453d);
$parcel$export(module.exports, "code", () => $77ee386e3e14f4e0$export$6565f9f03506010b);
$parcel$export(module.exports, "codeBlock", () => $77ee386e3e14f4e0$export$7bb0d5c671655cc4);
$parcel$export(module.exports, "codeBlock_root_only", () => $77ee386e3e14f4e0$export$38d90d1aac6883a3);
$parcel$export(module.exports, "confluenceInlineComment", () => $77ee386e3e14f4e0$export$f3b72f8fc4684ecd);
$parcel$export(module.exports, "dataConsumer", () => $77ee386e3e14f4e0$export$3024f02c495408d6);
$parcel$export(module.exports, "date", () => $77ee386e3e14f4e0$export$324d90190a8b822a);
$parcel$export(module.exports, "decisionItem", () => $77ee386e3e14f4e0$export$6959e16eeff859b4);
$parcel$export(module.exports, "decisionList", () => $77ee386e3e14f4e0$export$62d45a65fb43d95e);
$parcel$export(module.exports, "doc", () => $77ee386e3e14f4e0$export$2a111da947c407d2);
$parcel$export(module.exports, "em", () => $77ee386e3e14f4e0$export$c63c6f932822f543);
$parcel$export(module.exports, "embedCard", () => $77ee386e3e14f4e0$export$be4283d9a1cb1ff6);
$parcel$export(module.exports, "emoji", () => $77ee386e3e14f4e0$export$a19185d1233fc4b2);
$parcel$export(module.exports, "expand", () => $77ee386e3e14f4e0$export$9f77e0932fb78f72);
$parcel$export(module.exports, "expand_root_only", () => $77ee386e3e14f4e0$export$b2817c6954dd6d2c);
$parcel$export(module.exports, "extension", () => $77ee386e3e14f4e0$export$1b45514b112dd749);
$parcel$export(module.exports, "extension_with_marks", () => $77ee386e3e14f4e0$export$15be7c145cec614a);
$parcel$export(module.exports, "extensionFrame", () => $77ee386e3e14f4e0$export$4fdcae991fd743e7);
$parcel$export(module.exports, "fragment", () => $77ee386e3e14f4e0$export$f00aeb236b6f05af);
$parcel$export(module.exports, "hardBreak", () => $77ee386e3e14f4e0$export$371da9dd35aba193);
$parcel$export(module.exports, "heading", () => $77ee386e3e14f4e0$export$46e4a324ac90507f);
$parcel$export(module.exports, "heading_with_alignment", () => $77ee386e3e14f4e0$export$c17edf9af655deaf);
$parcel$export(module.exports, "heading_with_indentation", () => $77ee386e3e14f4e0$export$1902f9737466a0dc);
$parcel$export(module.exports, "heading_with_no_marks", () => $77ee386e3e14f4e0$export$7b491e75f1be9278);
$parcel$export(module.exports, "indentation", () => $77ee386e3e14f4e0$export$480c699bd4ec0d86);
$parcel$export(module.exports, "inline_content", () => $77ee386e3e14f4e0$export$e23e6162adaa368d);
$parcel$export(module.exports, "inlineCard", () => $77ee386e3e14f4e0$export$cbf8224b64e0d942);
$parcel$export(module.exports, "inlineExtension", () => $77ee386e3e14f4e0$export$16b353b2649bd8d9);
$parcel$export(module.exports, "inlineExtension_with_marks", () => $77ee386e3e14f4e0$export$e37f10815f36843d);
$parcel$export(module.exports, "layoutColumn", () => $77ee386e3e14f4e0$export$ab76e7c03cd6f650);
$parcel$export(module.exports, "layoutSection", () => $77ee386e3e14f4e0$export$b3b6a70a7fa4a5be);
$parcel$export(module.exports, "layoutSection_full", () => $77ee386e3e14f4e0$export$941b63fbd931e449);
$parcel$export(module.exports, "layoutSection_with_single_column", () => $77ee386e3e14f4e0$export$e0e9834198e8601d);
$parcel$export(module.exports, "link", () => $77ee386e3e14f4e0$export$9c30223ca0a664fb);
$parcel$export(module.exports, "listItem", () => $77ee386e3e14f4e0$export$76c7e83ecc9cdf05);
$parcel$export(module.exports, "media", () => $77ee386e3e14f4e0$export$987d49ffe1b0900f);
$parcel$export(module.exports, "mediaGroup", () => $77ee386e3e14f4e0$export$2855e964765eac9);
$parcel$export(module.exports, "mediaInline", () => $77ee386e3e14f4e0$export$38bab695e3f720f1);
$parcel$export(module.exports, "mediaSingle", () => $77ee386e3e14f4e0$export$969fe3781ca15058);
$parcel$export(module.exports, "mediaSingle_caption", () => $77ee386e3e14f4e0$export$68b0ead306f9670f);
$parcel$export(module.exports, "mediaSingle_full", () => $77ee386e3e14f4e0$export$f7fd577406abd5f8);
$parcel$export(module.exports, "mention", () => $77ee386e3e14f4e0$export$db83999c14438df4);
$parcel$export(module.exports, "multiBodiedExtension", () => $77ee386e3e14f4e0$export$c3c04d555a8b9013);
$parcel$export(module.exports, "nestedExpand", () => $77ee386e3e14f4e0$export$63cadbf5f4296627);
$parcel$export(module.exports, "nestedExpand_content", () => $77ee386e3e14f4e0$export$9584f52f3ebd5d7e);
$parcel$export(module.exports, "nestedExpand_with_no_marks", () => $77ee386e3e14f4e0$export$b756fc994eb0bc4f);
$parcel$export(module.exports, "non_nestable_block_content", () => $77ee386e3e14f4e0$export$ed866000601e7fa5);
$parcel$export(module.exports, "orderedList", () => $77ee386e3e14f4e0$export$a5dc81035676e7a);
$parcel$export(module.exports, "panel", () => $77ee386e3e14f4e0$export$21f42ab9b6679f44);
$parcel$export(module.exports, "paragraph", () => $77ee386e3e14f4e0$export$9c206ddddb32a9b);
$parcel$export(module.exports, "paragraph_with_alignment", () => $77ee386e3e14f4e0$export$9ca11c06877e5c64);
$parcel$export(module.exports, "paragraph_with_indentation", () => $77ee386e3e14f4e0$export$a3bd66932996fb7d);
$parcel$export(module.exports, "paragraph_with_no_marks", () => $77ee386e3e14f4e0$export$f06f75eb1e56b0c5);
$parcel$export(module.exports, "placeholder", () => $77ee386e3e14f4e0$export$c7187bbd1a7a9244);
$parcel$export(module.exports, "rule", () => $77ee386e3e14f4e0$export$fbeb3a3956e8a3c7);
$parcel$export(module.exports, "status", () => $77ee386e3e14f4e0$export$471f7ae5c4103ae1);
$parcel$export(module.exports, "strike", () => $77ee386e3e14f4e0$export$4899a95d70ec5056);
$parcel$export(module.exports, "strong", () => $77ee386e3e14f4e0$export$59ae2c325a998f89);
$parcel$export(module.exports, "subsup", () => $77ee386e3e14f4e0$export$b3401ee80eb31041);
$parcel$export(module.exports, "table", () => $77ee386e3e14f4e0$export$9852986a3ec5f6a0);
$parcel$export(module.exports, "tableCell", () => $77ee386e3e14f4e0$export$e1e720e5f4603e6a);
$parcel$export(module.exports, "tableHeader", () => $77ee386e3e14f4e0$export$48884d2a5190dc73);
$parcel$export(module.exports, "tableRow", () => $77ee386e3e14f4e0$export$ce666bf02318c957);
$parcel$export(module.exports, "taskItem", () => $77ee386e3e14f4e0$export$6d8b0ef52e2e6390);
$parcel$export(module.exports, "taskList", () => $77ee386e3e14f4e0$export$375b6afcc5f4d291);
$parcel$export(module.exports, "text", () => $77ee386e3e14f4e0$export$6f093cfa640b7166);
$parcel$export(module.exports, "text_code_inline", () => $77ee386e3e14f4e0$export$5008c13f04d544f6);
$parcel$export(module.exports, "text_formatted", () => $77ee386e3e14f4e0$export$d24a7becb4e0da7c);
$parcel$export(module.exports, "text_link_inline", () => $77ee386e3e14f4e0$export$2a9d18d5b3064e6c);
$parcel$export(module.exports, "text_with_no_marks", () => $77ee386e3e14f4e0$export$437a3d96346717e0);
$parcel$export(module.exports, "textColor", () => $77ee386e3e14f4e0$export$32f78bffcd82ff28);
$parcel$export(module.exports, "underline", () => $77ee386e3e14f4e0$export$425327af25286e5e);
const $77ee386e3e14f4e0$export$8e53000a4ec837 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'alignment'
            ]
        },
        attrs: {
            props: {
                align: {
                    type: 'enum',
                    values: [
                        'center',
                        'end'
                    ]
                }
            }
        }
    }
};
const $77ee386e3e14f4e0$export$8512c9afa7b24c3b = {
    props: {
        type: {
            type: 'enum',
            values: [
                'annotation'
            ]
        },
        attrs: {
            props: {
                id: {
                    type: 'string'
                },
                annotationType: {
                    type: 'enum',
                    values: [
                        'inlineComment'
                    ]
                }
            }
        }
    }
};
const $77ee386e3e14f4e0$export$8c5a050822fd698c = {
    props: {
        type: {
            type: 'enum',
            values: [
                'backgroundColor'
            ]
        },
        attrs: {
            props: {
                color: {
                    pattern: '^#[0-9a-fA-F]{6}$',
                    type: 'string'
                }
            }
        }
    }
};
const $77ee386e3e14f4e0$export$a31afb40076fa18b = [
    'blockCard',
    'paragraph_with_no_marks',
    'paragraph_with_alignment',
    'paragraph_with_indentation',
    'mediaSingle_caption',
    'mediaSingle_full',
    'codeBlock',
    'taskList',
    'bulletList',
    'orderedList',
    'heading_with_no_marks',
    'heading_with_alignment',
    'heading_with_indentation',
    'mediaGroup',
    'decisionList',
    'rule',
    'panel',
    'blockquote',
    'extension_with_marks',
    'embedCard',
    'table',
    'expand',
    'bodiedExtension_with_marks'
];
const $77ee386e3e14f4e0$export$c4c2f833baaebdb8 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'blockCard'
            ]
        },
        attrs: [
            {
                props: {
                    url: {
                        type: 'string',
                        optional: true,
                        validatorFn: 'safeUrl'
                    },
                    datasource: {
                        props: {
                            id: {
                                type: 'string'
                            },
                            parameters: {
                                type: 'object'
                            },
                            views: {
                                items: [
                                    {
                                        props: {
                                            properties: {
                                                optional: true,
                                                type: 'object'
                                            },
                                            type: {
                                                type: 'string'
                                            }
                                        }
                                    }
                                ],
                                minItems: 1,
                                type: 'array'
                            }
                        }
                    },
                    width: {
                        type: 'number',
                        optional: true
                    },
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'wrap-right',
                            'wrap-left',
                            'align-end',
                            'align-start'
                        ],
                        optional: true
                    }
                }
            },
            {
                props: {
                    url: {
                        type: 'string',
                        validatorFn: 'safeUrl'
                    }
                }
            },
            {
                props: {
                    data: {
                        type: 'object'
                    }
                }
            }
        ]
    },
    required: [
        'attrs'
    ]
};
const $77ee386e3e14f4e0$export$67dc04e652a298ca = {
    props: {
        type: {
            type: 'enum',
            values: [
                'blockquote'
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'orderedList',
                    'bulletList',
                    'codeBlock',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'mediaGroup',
                    'extension_with_marks'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $77ee386e3e14f4e0$export$ebb5393736e9ba23 = [
    'multiBodiedExtension'
];
const $77ee386e3e14f4e0$export$27903d543b563e39 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'bodiedExtension'
            ]
        },
        attrs: {
            props: {
                extensionKey: {
                    minLength: 1,
                    type: 'string'
                },
                extensionType: {
                    minLength: 1,
                    type: 'string'
                },
                parameters: {
                    type: 'object',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'default'
                    ],
                    optional: true
                },
                localId: {
                    minLength: 1,
                    type: 'string',
                    optional: true
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'non_nestable_block_content'
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $77ee386e3e14f4e0$export$ee052cc5b2356e83 = [
    'bodiedExtension',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'dataConsumer',
                        'fragment'
                    ]
                ]
            }
        }
    }
];
const $77ee386e3e14f4e0$export$1edee58a52776cd9 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'border'
            ]
        },
        attrs: {
            props: {
                size: {
                    type: 'number',
                    minimum: 1,
                    maximum: 3
                },
                color: {
                    pattern: '^#[0-9a-fA-F]{8}$|^#[0-9a-fA-F]{6}$',
                    type: 'string'
                }
            }
        }
    }
};
const $77ee386e3e14f4e0$export$89015c65f1c75e3f = {
    props: {
        type: {
            type: 'enum',
            values: [
                'breakout'
            ]
        },
        attrs: {
            props: {
                mode: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width'
                    ]
                },
                width: {
                    type: 'number',
                    optional: true
                }
            }
        }
    }
};
const $77ee386e3e14f4e0$export$a140c94e5ea26bee = {
    props: {
        type: {
            type: 'enum',
            values: [
                'bulletList'
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'listItem',
                    'listItem_with_nested_decision'
                ]
            ],
            minItems: 1
        }
    }
};
const $77ee386e3e14f4e0$export$8e3c2dfdc4f0453d = {
    props: {
        type: {
            type: 'enum',
            values: [
                'caption'
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'hardBreak',
                    'mention',
                    'emoji',
                    'date',
                    'placeholder',
                    'inlineCard',
                    'status',
                    'text_formatted',
                    'text_code_inline'
                ]
            ],
            optional: true,
            allowUnsupportedInline: true
        }
    }
};
const $77ee386e3e14f4e0$export$6565f9f03506010b = {
    props: {
        type: {
            type: 'enum',
            values: [
                'code'
            ]
        }
    }
};
const $77ee386e3e14f4e0$export$7bb0d5c671655cc4 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'codeBlock'
            ]
        },
        attrs: {
            props: {
                language: {
                    type: 'string',
                    optional: true
                },
                uniqueId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                'text_with_no_marks'
            ],
            optional: true,
            allowUnsupportedInline: true
        }
    }
};
const $77ee386e3e14f4e0$export$38d90d1aac6883a3 = [
    'codeBlock',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'breakout'
                ]
            }
        }
    }
];
const $77ee386e3e14f4e0$export$f3b72f8fc4684ecd = {
    props: {
        type: {
            type: 'enum',
            values: [
                'confluenceInlineComment'
            ]
        },
        attrs: {
            props: {
                reference: {
                    type: 'string'
                }
            }
        }
    }
};
const $77ee386e3e14f4e0$export$3024f02c495408d6 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'dataConsumer'
            ]
        },
        attrs: {
            props: {
                sources: {
                    type: 'array',
                    items: [
                        {
                            type: 'string'
                        }
                    ],
                    minItems: 1
                }
            }
        }
    }
};
const $77ee386e3e14f4e0$export$324d90190a8b822a = {
    props: {
        type: {
            type: 'enum',
            values: [
                'date'
            ]
        },
        attrs: {
            props: {
                timestamp: {
                    minLength: 1,
                    type: 'string'
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    }
};
const $77ee386e3e14f4e0$export$6959e16eeff859b4 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'decisionItem'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                },
                state: {
                    type: 'string'
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'inline_content'
            ],
            optional: true,
            allowUnsupportedInline: true
        }
    }
};
const $77ee386e3e14f4e0$export$62d45a65fb43d95e = {
    props: {
        type: {
            type: 'enum',
            values: [
                'decisionList'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'decisionItem'
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $77ee386e3e14f4e0$export$2a111da947c407d2 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'doc'
            ]
        },
        version: {
            type: 'enum',
            values: [
                1
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'blockCard',
                    'paragraph_with_no_marks',
                    'paragraph_with_alignment',
                    'paragraph_with_indentation',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock',
                    'taskList',
                    'bulletList',
                    'orderedList',
                    'heading_with_no_marks',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'mediaGroup',
                    'decisionList',
                    'rule',
                    'panel',
                    'blockquote',
                    'extension_with_marks',
                    'embedCard',
                    'table',
                    'expand',
                    'bodiedExtension_with_marks',
                    'codeBlock_root_only',
                    'layoutSection_with_single_column',
                    'layoutSection_full',
                    'multiBodiedExtension',
                    'expand_root_only'
                ]
            ],
            allowUnsupportedBlock: true
        }
    }
};
const $77ee386e3e14f4e0$export$c63c6f932822f543 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'em'
            ]
        }
    }
};
const $77ee386e3e14f4e0$export$be4283d9a1cb1ff6 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'embedCard'
            ]
        },
        attrs: {
            props: {
                url: {
                    type: 'string',
                    validatorFn: 'safeUrl'
                },
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'center',
                        'wrap-right',
                        'wrap-left',
                        'align-end',
                        'align-start'
                    ]
                },
                width: {
                    type: 'number',
                    maximum: 100,
                    minimum: 0,
                    optional: true
                },
                originalHeight: {
                    type: 'number',
                    optional: true
                },
                originalWidth: {
                    type: 'number',
                    optional: true
                }
            }
        }
    }
};
const $77ee386e3e14f4e0$export$a19185d1233fc4b2 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'emoji'
            ]
        },
        attrs: {
            props: {
                shortName: {
                    type: 'string'
                },
                id: {
                    type: 'string',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    }
};
const $77ee386e3e14f4e0$export$9f77e0932fb78f72 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'expand'
            ]
        },
        attrs: {
            props: {
                title: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'heading_with_no_marks',
                    'codeBlock',
                    'mediaGroup',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'decisionList',
                    'taskList',
                    'table',
                    'blockCard',
                    'embedCard',
                    'extension_with_marks',
                    'nestedExpand_with_no_marks'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $77ee386e3e14f4e0$export$b2817c6954dd6d2c = [
    'expand',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'breakout'
                ]
            }
        }
    }
];
const $77ee386e3e14f4e0$export$1b45514b112dd749 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'extension'
            ]
        },
        attrs: {
            props: {
                extensionKey: {
                    minLength: 1,
                    type: 'string'
                },
                extensionType: {
                    minLength: 1,
                    type: 'string'
                },
                parameters: {
                    type: 'object',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'default'
                    ],
                    optional: true
                },
                localId: {
                    minLength: 1,
                    type: 'string',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $77ee386e3e14f4e0$export$15be7c145cec614a = [
    'extension',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'dataConsumer',
                        'fragment'
                    ]
                ]
            }
        }
    }
];
const $77ee386e3e14f4e0$export$4fdcae991fd743e7 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'extensionFrame'
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'heading_with_no_marks',
                    'codeBlock',
                    'mediaGroup',
                    'mediaSingle_full',
                    'mediaSingle_caption',
                    'decisionList',
                    'taskList',
                    'table',
                    'extension_with_marks',
                    'bodiedExtension_with_marks',
                    'blockCard',
                    'embedCard'
                ]
            ],
            minItems: 1
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                [
                    'dataConsumer',
                    'fragment'
                ]
            ]
        }
    }
};
const $77ee386e3e14f4e0$export$f00aeb236b6f05af = {
    props: {
        type: {
            type: 'enum',
            values: [
                'fragment'
            ]
        },
        attrs: {
            props: {
                localId: {
                    minLength: 1,
                    type: 'string'
                },
                name: {
                    type: 'string',
                    optional: true
                }
            }
        }
    }
};
const $77ee386e3e14f4e0$export$371da9dd35aba193 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'hardBreak'
            ]
        },
        attrs: {
            props: {
                text: {
                    type: 'enum',
                    values: [
                        '\n'
                    ],
                    optional: true
                }
            },
            optional: true
        }
    }
};
const $77ee386e3e14f4e0$export$46e4a324ac90507f = {
    props: {
        type: {
            type: 'enum',
            values: [
                'heading'
            ]
        },
        attrs: {
            props: {
                level: {
                    type: 'number',
                    minimum: 1,
                    maximum: 6
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'inline_content'
            ],
            optional: true,
            allowUnsupportedInline: true
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $77ee386e3e14f4e0$export$c17edf9af655deaf = [
    'heading',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'alignment'
                ]
            }
        }
    }
];
const $77ee386e3e14f4e0$export$1902f9737466a0dc = [
    'heading',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'indentation'
                ]
            }
        }
    }
];
const $77ee386e3e14f4e0$export$7b491e75f1be9278 = [
    'heading',
    {
        props: {
            marks: {
                type: 'array',
                maxItems: 0,
                items: [],
                optional: true
            }
        }
    }
];
const $77ee386e3e14f4e0$export$480c699bd4ec0d86 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'indentation'
            ]
        },
        attrs: {
            props: {
                level: {
                    type: 'number',
                    minimum: 1,
                    maximum: 6
                }
            }
        }
    }
};
const $77ee386e3e14f4e0$export$e23e6162adaa368d = [
    'text_formatted',
    'text_code_inline',
    'date',
    'emoji',
    'hardBreak',
    'inlineCard',
    'mention',
    'placeholder',
    'status',
    'inlineExtension_with_marks',
    'mediaInline'
];
const $77ee386e3e14f4e0$export$cbf8224b64e0d942 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'inlineCard'
            ]
        },
        attrs: [
            {
                props: {
                    url: {
                        type: 'string',
                        validatorFn: 'safeUrl'
                    }
                }
            },
            {
                props: {
                    data: {
                        type: 'object'
                    }
                }
            }
        ],
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    },
    required: [
        'attrs'
    ]
};
const $77ee386e3e14f4e0$export$16b353b2649bd8d9 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'inlineExtension'
            ]
        },
        attrs: {
            props: {
                extensionKey: {
                    minLength: 1,
                    type: 'string'
                },
                extensionType: {
                    minLength: 1,
                    type: 'string'
                },
                parameters: {
                    type: 'object',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                localId: {
                    minLength: 1,
                    type: 'string',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $77ee386e3e14f4e0$export$e37f10815f36843d = [
    'inlineExtension',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'dataConsumer',
                        'fragment'
                    ]
                ]
            }
        }
    }
];
const $77ee386e3e14f4e0$export$ab76e7c03cd6f650 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'layoutColumn'
            ]
        },
        attrs: {
            props: {
                width: {
                    type: 'number',
                    minimum: 0,
                    maximum: 100
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'block_content'
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $77ee386e3e14f4e0$export$b3b6a70a7fa4a5be = {
    props: {
        type: {
            type: 'enum',
            values: [
                'layoutSection'
            ]
        },
        content: {
            type: 'array',
            items: [
                'layoutColumn'
            ],
            minItems: 1,
            maxItems: 3,
            allowUnsupportedBlock: true
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'breakout'
            ]
        }
    }
};
const $77ee386e3e14f4e0$export$941b63fbd931e449 = [
    'layoutSection',
    {
        props: {
            content: {
                type: 'array',
                items: [
                    'layoutColumn'
                ],
                minItems: 2,
                maxItems: 3,
                allowUnsupportedBlock: true
            },
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'breakout'
                ]
            }
        }
    }
];
const $77ee386e3e14f4e0$export$e0e9834198e8601d = [
    'layoutSection',
    {
        props: {
            attrs: {
                props: {
                    columnRuleStyle: {
                        type: 'enum',
                        values: [
                            'solid'
                        ],
                        optional: true
                    }
                },
                optional: true
            },
            content: {
                type: 'array',
                items: [
                    'layoutColumn'
                ],
                minItems: 1,
                maxItems: 5,
                allowUnsupportedBlock: true
            },
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'breakout'
                ]
            }
        }
    }
];
const $77ee386e3e14f4e0$export$9c30223ca0a664fb = {
    props: {
        type: {
            type: 'enum',
            values: [
                'link'
            ]
        },
        attrs: {
            props: {
                href: {
                    type: 'string',
                    validatorFn: 'safeUrl'
                },
                title: {
                    type: 'string',
                    optional: true
                },
                id: {
                    type: 'string',
                    optional: true
                },
                collection: {
                    type: 'string',
                    optional: true
                },
                occurrenceKey: {
                    type: 'string',
                    optional: true
                }
            }
        }
    }
};
const $77ee386e3e14f4e0$export$76c7e83ecc9cdf05 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'listItem'
            ]
        },
        content: {
            type: 'array',
            isTupleLike: true,
            items: [
                [
                    'paragraph_with_no_marks',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock',
                    'extension_with_marks'
                ],
                [
                    'paragraph_with_no_marks',
                    'bulletList',
                    'orderedList',
                    'taskList',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock',
                    'extension_with_marks'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $77ee386e3e14f4e0$export$2b82905b9aebbab0 = [
    'listItem',
    {
        props: {
            content: {
                type: 'array',
                isTupleLike: true,
                items: [
                    [
                        'paragraph_with_no_marks',
                        'mediaSingle_caption',
                        'mediaSingle_full',
                        'codeBlock',
                        'decisionList',
                        'extension_with_marks'
                    ],
                    [
                        'paragraph_with_no_marks',
                        'bulletList',
                        'orderedList',
                        'taskList',
                        'mediaSingle_caption',
                        'mediaSingle_full',
                        'codeBlock',
                        'decisionList',
                        'extension_with_marks'
                    ]
                ],
                minItems: 1,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $77ee386e3e14f4e0$export$987d49ffe1b0900f = {
    props: {
        type: {
            type: 'enum',
            values: [
                'media'
            ]
        },
        attrs: [
            {
                props: {
                    type: {
                        type: 'enum',
                        values: [
                            'link',
                            'file'
                        ]
                    },
                    id: {
                        minLength: 1,
                        type: 'string'
                    },
                    alt: {
                        type: 'string',
                        optional: true
                    },
                    collection: {
                        type: 'string'
                    },
                    height: {
                        type: 'number',
                        optional: true
                    },
                    occurrenceKey: {
                        minLength: 1,
                        type: 'string',
                        optional: true
                    },
                    width: {
                        type: 'number',
                        optional: true
                    }
                }
            },
            {
                props: {
                    type: {
                        type: 'enum',
                        values: [
                            'external'
                        ]
                    },
                    alt: {
                        type: 'string',
                        optional: true
                    },
                    height: {
                        type: 'number',
                        optional: true
                    },
                    width: {
                        type: 'number',
                        optional: true
                    },
                    url: {
                        type: 'string'
                    }
                }
            }
        ],
        marks: {
            type: 'array',
            optional: true,
            items: [
                [
                    'link',
                    'annotation',
                    'border'
                ]
            ]
        }
    },
    required: [
        'attrs'
    ]
};
const $77ee386e3e14f4e0$export$2855e964765eac9 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'mediaGroup'
            ]
        },
        content: {
            type: 'array',
            items: [
                'media'
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $77ee386e3e14f4e0$export$38bab695e3f720f1 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'mediaInline'
            ]
        },
        attrs: {
            props: {
                type: {
                    type: 'enum',
                    values: [
                        'link',
                        'file',
                        'image'
                    ],
                    optional: true
                },
                url: {
                    type: 'string',
                    optional: true
                },
                id: {
                    minLength: 1,
                    type: 'string'
                },
                alt: {
                    type: 'string',
                    optional: true
                },
                collection: {
                    type: 'string'
                },
                occurrenceKey: {
                    minLength: 1,
                    type: 'string',
                    optional: true
                },
                width: {
                    type: 'number',
                    optional: true
                },
                height: {
                    type: 'number',
                    optional: true
                },
                data: {
                    type: 'object',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                [
                    'link',
                    'annotation',
                    'border'
                ]
            ]
        }
    }
};
const $77ee386e3e14f4e0$export$969fe3781ca15058 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'mediaSingle'
            ]
        },
        attrs: [
            {
                props: {
                    width: {
                        type: 'number',
                        minimum: 0,
                        maximum: 100,
                        optional: true
                    },
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'wrap-right',
                            'wrap-left',
                            'align-end',
                            'align-start'
                        ]
                    },
                    widthType: {
                        type: 'enum',
                        values: [
                            'percentage'
                        ],
                        optional: true
                    }
                }
            },
            {
                props: {
                    width: {
                        type: 'number',
                        minimum: 0
                    },
                    widthType: {
                        type: 'enum',
                        values: [
                            'pixel'
                        ]
                    },
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'wrap-right',
                            'wrap-left',
                            'align-end',
                            'align-start'
                        ]
                    }
                }
            }
        ],
        marks: {
            type: 'array',
            optional: true,
            items: [
                'link'
            ]
        }
    }
};
const $77ee386e3e14f4e0$export$68b0ead306f9670f = [
    'mediaSingle',
    {
        props: {
            content: {
                type: 'array',
                isTupleLike: true,
                items: [
                    'media',
                    'caption'
                ],
                minItems: 1,
                maxItems: 2,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $77ee386e3e14f4e0$export$f7fd577406abd5f8 = [
    'mediaSingle',
    {
        props: {
            content: {
                type: 'array',
                items: [
                    'media'
                ],
                minItems: 1,
                maxItems: 1,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $77ee386e3e14f4e0$export$af10954ff7b86f88 = [
    'mediaSingle',
    {
        props: {
            content: {
                type: 'array',
                items: [
                    'media'
                ],
                minItems: 1,
                maxItems: 1,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $77ee386e3e14f4e0$export$db83999c14438df4 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'mention'
            ]
        },
        attrs: {
            props: {
                id: {
                    type: 'string'
                },
                localId: {
                    type: 'string',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                accessLevel: {
                    type: 'string',
                    optional: true
                },
                userType: {
                    type: 'enum',
                    values: [
                        'DEFAULT',
                        'SPECIAL',
                        'APP'
                    ],
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    }
};
const $77ee386e3e14f4e0$export$c3c04d555a8b9013 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'multiBodiedExtension'
            ]
        },
        attrs: {
            props: {
                extensionKey: {
                    type: 'string',
                    minLength: 1
                },
                extensionType: {
                    type: 'string',
                    minLength: 1
                },
                parameters: {
                    type: 'object',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                layout: {
                    type: 'enum',
                    values: [
                        'default',
                        'wide',
                        'full-width'
                    ],
                    optional: true
                },
                localId: {
                    type: 'string',
                    optional: true,
                    minLength: 1
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'extensionFrame'
            ]
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $77ee386e3e14f4e0$export$63cadbf5f4296627 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'nestedExpand'
            ]
        },
        attrs: {
            props: {
                title: {
                    type: 'string',
                    optional: true
                }
            }
        },
        content: 'nestedExpand_content'
    },
    required: [
        'content'
    ]
};
const $77ee386e3e14f4e0$export$9584f52f3ebd5d7e = {
    type: 'array',
    items: [
        [
            'paragraph_with_no_marks',
            'heading_with_no_marks',
            'mediaSingle_caption',
            'mediaSingle_full',
            'mediaGroup',
            'codeBlock',
            'bulletList',
            'orderedList',
            'taskList',
            'decisionList',
            'rule',
            'panel',
            'blockquote',
            'extension_with_marks'
        ]
    ],
    minItems: 1,
    allowUnsupportedBlock: true
};
const $77ee386e3e14f4e0$export$b756fc994eb0bc4f = [
    'nestedExpand',
    {
        props: {
            marks: {
                type: 'array',
                maxItems: 0,
                items: [],
                optional: true
            }
        }
    }
];
const $77ee386e3e14f4e0$export$ed866000601e7fa5 = [
    'paragraph_with_no_marks',
    'panel',
    'blockquote',
    'orderedList',
    'bulletList',
    'rule',
    'heading_with_no_marks',
    'codeBlock',
    'mediaGroup',
    'mediaSingle_caption',
    'mediaSingle_full',
    'decisionList',
    'taskList',
    'table',
    'blockCard',
    'embedCard',
    'extension_with_marks'
];
const $77ee386e3e14f4e0$export$a5dc81035676e7a = {
    props: {
        type: {
            type: 'enum',
            values: [
                'orderedList'
            ]
        },
        attrs: {
            props: {
                order: {
                    type: 'number',
                    minimum: 0,
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'listItem',
                    'listItem_with_nested_decision'
                ]
            ],
            minItems: 1
        }
    }
};
const $77ee386e3e14f4e0$export$21f42ab9b6679f44 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'panel'
            ]
        },
        attrs: {
            props: {
                panelType: {
                    type: 'enum',
                    values: [
                        'info',
                        'note',
                        'tip',
                        'warning',
                        'error',
                        'success',
                        'custom'
                    ]
                },
                panelIcon: {
                    type: 'string',
                    optional: true
                },
                panelIconId: {
                    type: 'string',
                    optional: true
                },
                panelIconText: {
                    type: 'string',
                    optional: true
                },
                panelColor: {
                    type: 'string',
                    optional: true
                }
            }
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'heading_with_no_marks',
                    'bulletList',
                    'orderedList',
                    'blockCard',
                    'mediaGroup',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock',
                    'taskList',
                    'rule',
                    'decisionList',
                    'extension_with_marks'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $77ee386e3e14f4e0$export$9c206ddddb32a9b = {
    props: {
        type: {
            type: 'enum',
            values: [
                'paragraph'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                'inline_content'
            ],
            optional: true,
            allowUnsupportedInline: true
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $77ee386e3e14f4e0$export$9ca11c06877e5c64 = [
    'paragraph',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'alignment'
                ]
            }
        }
    }
];
const $77ee386e3e14f4e0$export$a3bd66932996fb7d = [
    'paragraph',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'indentation'
                ]
            }
        }
    }
];
const $77ee386e3e14f4e0$export$f06f75eb1e56b0c5 = [
    'paragraph',
    {
        props: {
            marks: {
                type: 'array',
                maxItems: 0,
                items: [],
                optional: true
            }
        }
    }
];
const $77ee386e3e14f4e0$export$c7187bbd1a7a9244 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'placeholder'
            ]
        },
        attrs: {
            props: {
                text: {
                    type: 'string'
                }
            }
        }
    }
};
const $77ee386e3e14f4e0$export$fbeb3a3956e8a3c7 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'rule'
            ]
        }
    }
};
const $77ee386e3e14f4e0$export$471f7ae5c4103ae1 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'status'
            ]
        },
        attrs: {
            props: {
                text: {
                    minLength: 1,
                    type: 'string'
                },
                color: {
                    type: 'enum',
                    values: [
                        'neutral',
                        'purple',
                        'blue',
                        'red',
                        'yellow',
                        'green'
                    ]
                },
                localId: {
                    type: 'string',
                    optional: true
                },
                style: {
                    type: 'string',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    }
};
const $77ee386e3e14f4e0$export$4899a95d70ec5056 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'strike'
            ]
        }
    }
};
const $77ee386e3e14f4e0$export$59ae2c325a998f89 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'strong'
            ]
        }
    }
};
const $77ee386e3e14f4e0$export$b3401ee80eb31041 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'subsup'
            ]
        },
        attrs: {
            props: {
                type: {
                    type: 'enum',
                    values: [
                        'sub',
                        'sup'
                    ]
                }
            }
        }
    }
};
const $77ee386e3e14f4e0$export$9852986a3ec5f6a0 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'table'
            ]
        },
        attrs: {
            props: {
                displayMode: {
                    type: 'enum',
                    values: [
                        'default',
                        'fixed'
                    ],
                    optional: true
                },
                isNumberColumnEnabled: {
                    type: 'boolean',
                    optional: true
                },
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'center',
                        'align-end',
                        'align-start',
                        'default'
                    ],
                    optional: true
                },
                localId: {
                    type: 'string',
                    minLength: 1,
                    optional: true
                },
                width: {
                    type: 'number',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                'tableRow'
            ],
            minItems: 1
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'fragment'
            ]
        }
    }
};
const $77ee386e3e14f4e0$export$e1e720e5f4603e6a = {
    props: {
        type: {
            type: 'enum',
            values: [
                'tableCell'
            ]
        },
        attrs: {
            props: {
                colspan: {
                    type: 'number',
                    optional: true
                },
                rowspan: {
                    type: 'number',
                    optional: true
                },
                colwidth: {
                    type: 'array',
                    items: [
                        {
                            type: 'number'
                        }
                    ],
                    optional: true
                },
                background: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_alignment',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'heading_with_no_marks',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'codeBlock',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'mediaGroup',
                    'decisionList',
                    'taskList',
                    'blockCard',
                    'embedCard',
                    'extension_with_marks',
                    'nestedExpand_with_no_marks'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    },
    required: [
        'content'
    ]
};
const $77ee386e3e14f4e0$export$48884d2a5190dc73 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'tableHeader'
            ]
        },
        attrs: {
            props: {
                colspan: {
                    type: 'number',
                    optional: true
                },
                rowspan: {
                    type: 'number',
                    optional: true
                },
                colwidth: {
                    type: 'array',
                    items: [
                        {
                            type: 'number'
                        }
                    ],
                    optional: true
                },
                background: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_alignment',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'heading_with_no_marks',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'codeBlock',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'mediaGroup',
                    'decisionList',
                    'taskList',
                    'blockCard',
                    'embedCard',
                    'extension_with_marks',
                    'nestedExpand_with_no_marks',
                    'nestedExpand'
                ]
            ],
            minItems: 1
        }
    },
    required: [
        'content'
    ]
};
const $77ee386e3e14f4e0$export$ce666bf02318c957 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'tableRow'
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'tableCell',
                    'tableHeader'
                ]
            ]
        }
    }
};
const $77ee386e3e14f4e0$export$6d8b0ef52e2e6390 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'taskItem'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                },
                state: {
                    type: 'enum',
                    values: [
                        'TODO',
                        'DONE'
                    ]
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'inline_content'
            ],
            optional: true,
            allowUnsupportedInline: true
        }
    }
};
const $77ee386e3e14f4e0$export$375b6afcc5f4d291 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'taskList'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                }
            }
        },
        content: {
            type: 'array',
            isTupleLike: true,
            items: [
                'taskItem',
                [
                    'taskItem',
                    'taskList'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $77ee386e3e14f4e0$export$6f093cfa640b7166 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'text'
            ]
        },
        text: {
            type: 'string',
            minLength: 1
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $77ee386e3e14f4e0$export$5008c13f04d544f6 = [
    'text',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'code',
                        'link',
                        'annotation'
                    ]
                ]
            }
        }
    }
];
const $77ee386e3e14f4e0$export$d24a7becb4e0da7c = [
    'text',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'link',
                        'em',
                        'strong',
                        'strike',
                        'subsup',
                        'underline',
                        'textColor',
                        'annotation',
                        'backgroundColor',
                        null
                    ]
                ]
            }
        }
    }
];
const $77ee386e3e14f4e0$export$2a9d18d5b3064e6c = [
    'text',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'link'
                ]
            }
        }
    }
];
const $77ee386e3e14f4e0$export$437a3d96346717e0 = [
    'text',
    {
        props: {
            marks: {
                type: 'array',
                maxItems: 0,
                items: [],
                optional: true
            }
        }
    }
];
const $77ee386e3e14f4e0$export$32f78bffcd82ff28 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'textColor'
            ]
        },
        attrs: {
            props: {
                color: {
                    type: 'string',
                    pattern: '^#[0-9a-fA-F]{6}$'
                }
            }
        }
    }
};
const $77ee386e3e14f4e0$export$425327af25286e5e = {
    props: {
        type: {
            type: 'enum',
            values: [
                'underline'
            ]
        }
    }
};

});


parcelRegister("kfOTy", function(module, exports) {

$parcel$export(module.exports, "isDefined", () => $e5985938f1ee69ed$export$4e62c701997796c1);
$parcel$export(module.exports, "isNumber", () => $e5985938f1ee69ed$export$7e4aa119212bc614);
$parcel$export(module.exports, "isInteger", () => $e5985938f1ee69ed$export$a287f47fed4544b8);
$parcel$export(module.exports, "isBoolean", () => $e5985938f1ee69ed$export$f9ce7b637dfbe238);
$parcel$export(module.exports, "isString", () => $e5985938f1ee69ed$export$844ec244b1367d54);
$parcel$export(module.exports, "isPlainObject", () => $e5985938f1ee69ed$export$53b83ca8eaab0383);
$parcel$export(module.exports, "copy", () => $e5985938f1ee69ed$export$784d13d8ee351f07);
$parcel$export(module.exports, "makeArray", () => $e5985938f1ee69ed$export$7b85fd78dd236198);
const $e5985938f1ee69ed$export$4e62c701997796c1 = (x)=>x != null;
const $e5985938f1ee69ed$export$7e4aa119212bc614 = (x)=>typeof x === 'number' && !isNaN(x) && isFinite(x);
const $e5985938f1ee69ed$export$a287f47fed4544b8 = (x)=>typeof x === 'number' && isFinite(x) && Math.floor(x) === x;
const $e5985938f1ee69ed$export$f9ce7b637dfbe238 = (x)=>x === true || x === false || toString.call(x) === '[object Boolean]';
const $e5985938f1ee69ed$export$844ec244b1367d54 = (s)=>typeof s === 'string' || s instanceof String;
const $e5985938f1ee69ed$export$53b83ca8eaab0383 = (x)=>typeof x === 'object' && x !== null && !Array.isArray(x);
const $e5985938f1ee69ed$export$784d13d8ee351f07 = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
source, dest, key)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    dest[key] = source[key];
    return dest;
};
const $e5985938f1ee69ed$export$7b85fd78dd236198 = (maybeArray)=>Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];

});

parcelRegister("eZqxv", function(module, exports) {

$parcel$export(module.exports, "validatorFnMap", () => $804f031b1e946960$export$d1b377ca77ac267d);

var $iKozC = parcelRequire("iKozC");
const $804f031b1e946960$export$d1b377ca77ac267d = {
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    safeUrl: (0, $iKozC.isSafeUrl)
};

});



parcelRegister("lE3K0", function(module, exports) {

$parcel$export(module.exports, "trackUnsupportedContentLevels", () => $16664e34104af16b$export$a43de96edd8d0a0);

var $dyNYh = parcelRequire("dyNYh");
var $33XK0 = parcelRequire("33XK0");

var $bMFKb = parcelRequire("bMFKb");

var $7ueoK = parcelRequire("7ueoK");
const $16664e34104af16b$var$rendersMap = {};
const $16664e34104af16b$var$processLevelsAndTrack = (item, thresholds, dispatchAnalyticsEvent)=>{
    try {
        const { severity: severity, percentage: percentage, counts: { supportedNodes: supportedNodes, unsupportedNodes: unsupportedNodes, unsupportedNodeTypeCount: unsupportedNodeTypeCount } } = (0, $33XK0.getUnsupportedContentLevelData)(item.doc, thresholds);
        dispatchAnalyticsEvent({
            action: (0, $bMFKb.ACTION).UNSUPPORTED_CONTENT_LEVELS_TRACKING_SUCCEEDED,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).RENDERER,
            attributes: {
                appearance: (0, $dyNYh.getAnalyticsAppearance)(item.appearance),
                platform: (0, $7ueoK.PLATFORM).WEB,
                unsupportedContentLevelSeverity: severity,
                unsupportedContentLevelPercentage: percentage,
                unsupportedNodesCount: unsupportedNodes,
                supportedNodesCount: supportedNodes,
                unsupportedNodeTypeCount: unsupportedNodeTypeCount
            },
            eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL
        });
    } catch (err) {
        dispatchAnalyticsEvent({
            action: (0, $bMFKb.ACTION).UNSUPPORTED_CONTENT_LEVELS_TRACKING_ERRORED,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).RENDERER,
            attributes: {
                platform: (0, $7ueoK.PLATFORM).WEB,
                error: err instanceof Error ? err.message : String(err)
            },
            eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL
        });
    }
};
const $16664e34104af16b$var$schedule = (fn)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (typeof window.requestIdleCallback === 'function') // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.requestIdleCallback(fn);
    else setTimeout(fn, 0);
};
const $16664e34104af16b$var$DEFAULT_SAMPLING_RATE = 100;
const $16664e34104af16b$export$a43de96edd8d0a0 = (item, trackingOptions, dispatchAnalyticsEvent)=>{
    const { thresholds: thresholds, samplingRates: samplingRates } = trackingOptions;
    const appearance = item.appearance ?? 'unknown';
    if (!$16664e34104af16b$var$rendersMap[appearance]) $16664e34104af16b$var$rendersMap[appearance] = new Set();
    // bail out if already processed a render from a given renderer instance
    const didProcessRenderer = $16664e34104af16b$var$rendersMap[appearance].has(item.rendererId);
    if (didProcessRenderer) return;
    // otherwise track the render
    $16664e34104af16b$var$rendersMap[appearance].add(item.rendererId);
    const sampleRate = samplingRates && samplingRates[appearance] || $16664e34104af16b$var$DEFAULT_SAMPLING_RATE;
    // sample from the first available tracked render
    if ($16664e34104af16b$var$rendersMap[appearance].size === 1) $16664e34104af16b$var$schedule(()=>$16664e34104af16b$var$processLevelsAndTrack(item, thresholds, dispatchAnalyticsEvent));
    // cleanup/refresh tracked renders at the sampling rate
    if ($16664e34104af16b$var$rendersMap[appearance].size % sampleRate === 0) $16664e34104af16b$var$rendersMap[appearance] = new Set();
};

});
parcelRegister("33XK0", function(module, exports) {

$parcel$export(module.exports, "getUnsupportedContentLevelData", () => $5e806909aed268e6$export$484b83e0462998d);

var $0mclG = parcelRequire("0mclG");
var $5e806909aed268e6$export$6632e71a22d31bf1 = /*#__PURE__*/ function(UNSUPPORTED_CONTENT_LEVEL_SEVERITY) {
    UNSUPPORTED_CONTENT_LEVEL_SEVERITY["NORMAL"] = "normal";
    UNSUPPORTED_CONTENT_LEVEL_SEVERITY["DEGRADED"] = "degraded";
    UNSUPPORTED_CONTENT_LEVEL_SEVERITY["BLOCKING"] = "blocking";
    return UNSUPPORTED_CONTENT_LEVEL_SEVERITY;
}({});
const $5e806909aed268e6$export$f9f8a29778652c3e = {
    DEGRADED: 10,
    BLOCKING: 25
};
const $5e806909aed268e6$var$buildUnsupportedContentLevelThresholds = (customThresholds)=>{
    return {
        degraded: customThresholds?.degraded || $5e806909aed268e6$export$f9f8a29778652c3e.DEGRADED,
        blocking: customThresholds?.blocking || $5e806909aed268e6$export$f9f8a29778652c3e.BLOCKING
    };
};
const $5e806909aed268e6$var$countSupportedUnsupportedNodes = (validDocument)=>{
    let unsupportedNodes = 0;
    let supportedNodes = 0;
    const unsupportedNodeTypeCount = {};
    const unsupportedNodeTypes = [
        'unsupportedInline',
        'unsupportedBlock',
        'confluenceUnsupportedInline',
        'confluenceUnsupportedBlock'
    ];
    (0, $0mclG.traverse)(validDocument, {
        any: (node)=>{
            if (unsupportedNodeTypes.includes(node.type)) {
                const originalNode = node.attrs?.originalValue;
                if (originalNode) // start an independent traversal for the purpose of counting
                // unsupported content nodes (with nested children contributing towards
                // that count)
                (0, $0mclG.traverse)(originalNode, {
                    any: (unsupportedNode, parent)=>{
                        unsupportedNodes++;
                        // Count the types of unsupported nodes
                        const parentType = parent.parent?.node?.type ?? 'unknown';
                        const type = `${parentType}/${unsupportedNode?.type ?? 'unknown'}`;
                        unsupportedNodeTypeCount[type] = (unsupportedNodeTypeCount?.[type] ?? 0) + 1;
                    }
                });
                // force the parent traversal (which is counting supported content nodes)
                // to skip traversal/counting of nested children of the unsupported nodes
                return false;
            } else supportedNodes++;
        }
    });
    return {
        unsupportedNodes: unsupportedNodes,
        supportedNodes: supportedNodes,
        unsupportedNodeTypeCount: unsupportedNodeTypeCount
    };
};
const $5e806909aed268e6$var$mapUnsupportedContentLevelToSeverity = (unsupportedContentLevelPercent, thresholds)=>{
    if (thresholds.degraded <= unsupportedContentLevelPercent && unsupportedContentLevelPercent < thresholds.blocking) return "degraded";
    if (thresholds.blocking <= unsupportedContentLevelPercent) return "blocking";
    return "normal";
};
const $5e806909aed268e6$export$484b83e0462998d = (validDocument, customThresholds)=>{
    const { unsupportedNodes: unsupportedNodes, supportedNodes: supportedNodes, unsupportedNodeTypeCount: unsupportedNodeTypeCount } = $5e806909aed268e6$var$countSupportedUnsupportedNodes(validDocument);
    const thresholds = $5e806909aed268e6$var$buildUnsupportedContentLevelThresholds(customThresholds);
    const percentage = Math.round(unsupportedNodes / (unsupportedNodes + supportedNodes) * 100);
    const severity = $5e806909aed268e6$var$mapUnsupportedContentLevelToSeverity(percentage, thresholds);
    return {
        severity: severity,
        percentage: percentage,
        counts: {
            supportedNodes: supportedNodes,
            unsupportedNodes: unsupportedNodes,
            unsupportedNodeTypeCount: unsupportedNodeTypeCount
        }
    };
};

});


parcelRegister("86V7W", function(module, exports) {

$parcel$export(module.exports, "countNodes", () => $11211b02bfd44def$export$1daf15cbaf649dad);

var $7Tt7Y = parcelRequire("7Tt7Y");
function $11211b02bfd44def$export$1daf15cbaf649dad(adfDocument) {
    return (0, $7Tt7Y.reduce)(adfDocument, (acc, node)=>{
        acc[node.type] = (acc[node.type] || 0) + 1;
        return acc;
    }, {});
}

});
parcelRegister("7Tt7Y", function(module, exports) {

$parcel$export(module.exports, "reduce", () => $a7e2059b80756531$export$533b26079ad0b4b);

var $0mclG = parcelRequire("0mclG");
function $a7e2059b80756531$export$533b26079ad0b4b(adf, callback, initial) {
    let result = initial;
    (0, $0mclG.traverse)(adf, {
        any: (node)=>{
            result = callback(result, node);
        }
    });
    return result;
}

});



parcelRegister("4SRvD", function(module, exports) {

$parcel$export(module.exports, "EditorMediaClientProvider", () => $178829c31cb74d12$export$77218b6ff680865f);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $aRuva = parcelRequire("aRuva");
var $93R6D = parcelRequire("93R6D");

var $6Ramj = parcelRequire("6Ramj");
const $178829c31cb74d12$export$77218b6ff680865f = ({ children: children, ssr: ssr })=>{
    const [mediaClientConfig, setMediaClientConfig] = (0, $eJOHy.useState)();
    const mediaProvider = (0, $6Ramj.useProviderLayout)('mediaProvider');
    /**
	 * If a mediaClientConfig is provided then we will force
	 * skip the mediaClient from context
	 */ const shouldSkipContext = Boolean(ssr?.config || mediaProvider);
    const contextMediaClient = (0, $eJOHy.useContext)((0, $93R6D.MediaClientContext));
    // MediaClientProvider currently requires a mediaClientConfig
    // And inserting the MediaClientProvider will cause a re-render
    // We should use MediaClientProvider once it no longer requires a config
    const mediaClient = (0, $eJOHy.useMemo)(()=>mediaClientConfig ? (0, $aRuva.getMediaClient)(mediaClientConfig) : undefined, [
        mediaClientConfig
    ]);
    // Consumers can override the mediaClient for renderer,
    // by not providing both SSR config and mediaProvider,
    // and provide a top level mediaClient context
    // This is useful for testing and creating examples.
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (ssr?.config) setMediaClientConfig(ssr.config);
        else if (mediaProvider) mediaProvider.then((provider)=>{
            setMediaClientConfig(provider.viewMediaClientConfig);
        });
    }, [
        mediaProvider,
        ssr
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $93R6D.MediaClientContext).Provider, {
        value: shouldSkipContext ? mediaClient : contextMediaClient,
        children: children
    });
};

});
parcelRegister("aRuva", function(module, exports) {

$parcel$export(module.exports, "getMediaClient", () => $3430d7925e0b0890$export$c9ecbc1b719fd417);

var $e33YM = parcelRequire("e33YM");
const $3430d7925e0b0890$export$f92e83e86b03c398 = new Map();
const $3430d7925e0b0890$export$c9ecbc1b719fd417 = (mediaClientConfig)=>{
    // The Provider defines mediaClientConfig as required,
    // but integrators may skip it when using Media Card to display external images
    // i.e. a Media Client is not needed.
    // An empty mediaClientConfig object `{}` won't fall into this case,
    // but that case is handled internally by Media Client.
    if (!mediaClientConfig) return new (0, $e33YM.MediaClient)({
        authProvider: ()=>Promise.resolve({
                clientId: '',
                token: '',
                baseUrl: ''
            })
    });
    let mediaClient = $3430d7925e0b0890$export$f92e83e86b03c398.get(mediaClientConfig);
    if (!mediaClient) {
        mediaClient = new (0, $e33YM.MediaClient)(mediaClientConfig);
        $3430d7925e0b0890$export$f92e83e86b03c398.set(mediaClientConfig, mediaClient);
    }
    return mediaClient;
};

});
parcelRegister("e33YM", function(module, exports) {

$parcel$export(module.exports, "MediaClient", () => $4ee615cd17ba35c7$export$fba8b4ca6d386aec);

var $adK77 = parcelRequire("adK77");
parcelRequire("1jG9B");
var $9t1Mu = parcelRequire("9t1Mu");

var $jkwTu = parcelRequire("jkwTu");

var $iPHIU = parcelRequire("iPHIU");

var $gWavf = parcelRequire("gWavf");
parcelRequire("48hWz");
var $1ZNSP = parcelRequire("1ZNSP");

class $4ee615cd17ba35c7$export$fba8b4ca6d386aec {
    constructor(mediaClientConfig, store = (0, $1ZNSP.mediaStore), mediaApi){
        this.mediaClientConfig = mediaClientConfig;
        this.store = store;
        this.mediaStore = mediaApi ?? new (0, $jkwTu.MediaStore)({
            authProvider: mediaClientConfig.authProvider,
            initialAuth: mediaClientConfig.initialAuth,
            chunkHashAlgorithm: (0, $9t1Mu.ChunkHashAlgorithm).Sha256,
            authProviderTimeout: mediaClientConfig.authProviderTimeoutMs
        });
        this.config = mediaClientConfig;
        this.file = new (0, $iPHIU.FileFetcherImpl)(this.mediaStore, this.store);
        this.eventEmitter = new (0, $adK77.EventEmitter2)();
        this.stargate = new (0, $gWavf.StargateClient)(mediaClientConfig.stargateBaseUrl);
    }
    /**
	 * @internal
	 */ __DO_NOT_USE__getMediaStore() {
        return this.store;
    }
    getImage(id, params, controller, fetchMaxRes, traceContext) {
        return this.mediaStore.getImage(id, params, controller, fetchMaxRes, traceContext);
    }
    getImageUrl(id, params) {
        return this.mediaStore.getFileImageURL(id, params);
    }
    getImageUrlSync(id, params) {
        return this.mediaStore.getFileImageURLSync(id, params);
    }
    async getImageMetadata(id, params) {
        return (await this.mediaStore.getImageMetadata(id, params)).metadata;
    }
    async mobileUploadPromise() {
        if (this.mobileUpload) return this.mobileUpload;
        const module = await (parcelRequire("c4FM0"));
        this.mobileUpload = new module.MobileUploadImpl(this.mediaStore, this.store);
        return this.mobileUpload;
    }
    async removeFileFromCollection(id, collectionName, occurrenceKey, traceContext) {
        await this.mediaStore.removeCollectionFile(id, collectionName, occurrenceKey, traceContext);
    }
    on(event, listener) {
        this.eventEmitter.on(event, listener);
    }
    off(event, listener) {
        this.eventEmitter.off(event, listener);
    }
    emit(event, payload) {
        return this.eventEmitter.emit(event, payload);
    }
}

});
parcelRegister("adK77", function(module, exports) {

var $igDjg = parcelRequire("igDjg");
!function(undefined) {
    var isArray = Array.isArray ? Array.isArray : function _isArray(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    };
    var defaultMaxListeners = 10;
    function init() {
        this._events = {};
        if (this._conf) configure.call(this, this._conf);
    }
    function configure(conf) {
        if (conf) {
            this._conf = conf;
            conf.delimiter && (this.delimiter = conf.delimiter);
            this._maxListeners = conf.maxListeners !== undefined ? conf.maxListeners : defaultMaxListeners;
            conf.wildcard && (this.wildcard = conf.wildcard);
            conf.newListener && (this.newListener = conf.newListener);
            conf.verboseMemoryLeak && (this.verboseMemoryLeak = conf.verboseMemoryLeak);
            if (this.wildcard) this.listenerTree = {};
        } else this._maxListeners = defaultMaxListeners;
    }
    function logPossibleMemoryLeak(count, eventName) {
        var errorMsg = "(node) warning: possible EventEmitter memory leak detected. " + count + ' listeners added. ' + 'Use emitter.setMaxListeners() to increase limit.';
        if (this.verboseMemoryLeak) errorMsg += ' Event name: ' + eventName + '.';
        if (typeof $igDjg !== 'undefined' && $igDjg.emitWarning) {
            var e = new Error(errorMsg);
            e.name = 'MaxListenersExceededWarning';
            e.emitter = this;
            e.count = count;
            $igDjg.emitWarning(e);
        } else {
            console.error(errorMsg);
            if (console.trace) console.trace();
        }
    }
    function EventEmitter(conf) {
        this._events = {};
        this.newListener = false;
        this.verboseMemoryLeak = false;
        configure.call(this, conf);
    }
    EventEmitter.EventEmitter2 = EventEmitter; // backwards compatibility for exporting EventEmitter property
    //
    // Attention, function return type now is array, always !
    // It has zero elements if no any matches found and one or more
    // elements (leafs) if there are matches
    //
    function searchListenerTree(handlers, type, tree, i) {
        if (!tree) return [];
        var listeners = [], leaf, len, branch, xTree, xxTree, isolatedBranch, endReached, typeLength = type.length, currentType = type[i], nextType = type[i + 1];
        if (i === typeLength && tree._listeners) {
            //
            // If at the end of the event(s) list and the tree has listeners
            // invoke those listeners.
            //
            if (typeof tree._listeners === 'function') {
                handlers && handlers.push(tree._listeners);
                return [
                    tree
                ];
            } else {
                for(leaf = 0, len = tree._listeners.length; leaf < len; leaf++)handlers && handlers.push(tree._listeners[leaf]);
                return [
                    tree
                ];
            }
        }
        if (currentType === '*' || currentType === '**' || tree[currentType]) {
            //
            // If the event emitted is '*' at this part
            // or there is a concrete match at this patch
            //
            if (currentType === '*') {
                for(branch in tree)if (branch !== '_listeners' && tree.hasOwnProperty(branch)) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i + 1));
                return listeners;
            } else if (currentType === '**') {
                endReached = i + 1 === typeLength || i + 2 === typeLength && nextType === '*';
                if (endReached && tree._listeners) // The next element has a _listeners, add it to the handlers.
                listeners = listeners.concat(searchListenerTree(handlers, type, tree, typeLength));
                for(branch in tree)if (branch !== '_listeners' && tree.hasOwnProperty(branch)) {
                    if (branch === '*' || branch === '**') {
                        if (tree[branch]._listeners && !endReached) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], typeLength));
                        listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
                    } else if (branch === nextType) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i + 2));
                    else // No match on this one, shift into the tree but not in the type array.
                    listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
                }
                return listeners;
            }
            listeners = listeners.concat(searchListenerTree(handlers, type, tree[currentType], i + 1));
        }
        xTree = tree['*'];
        if (xTree) //
        // If the listener tree will allow any match for this part,
        // then recursively explore all branches of the tree
        //
        searchListenerTree(handlers, type, xTree, i + 1);
        xxTree = tree['**'];
        if (xxTree) {
            if (i < typeLength) {
                if (xxTree._listeners) // If we have a listener on a '**', it will catch all, so add its handler.
                searchListenerTree(handlers, type, xxTree, typeLength);
                // Build arrays of matching next branches and others.
                for(branch in xxTree)if (branch !== '_listeners' && xxTree.hasOwnProperty(branch)) {
                    if (branch === nextType) // We know the next element will match, so jump twice.
                    searchListenerTree(handlers, type, xxTree[branch], i + 2);
                    else if (branch === currentType) // Current node matches, move into the tree.
                    searchListenerTree(handlers, type, xxTree[branch], i + 1);
                    else {
                        isolatedBranch = {};
                        isolatedBranch[branch] = xxTree[branch];
                        searchListenerTree(handlers, type, {
                            '**': isolatedBranch
                        }, i + 1);
                    }
                }
            } else if (xxTree._listeners) // We have reached the end and still on a '**'
            searchListenerTree(handlers, type, xxTree, typeLength);
            else if (xxTree['*'] && xxTree['*']._listeners) searchListenerTree(handlers, type, xxTree['*'], typeLength);
        }
        return listeners;
    }
    function growListenerTree(type, listener) {
        type = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
        //
        // Looks for two consecutive '**', if so, don't add the event at all.
        //
        for(var i = 0, len = type.length; i + 1 < len; i++){
            if (type[i] === '**' && type[i + 1] === '**') return;
        }
        var tree = this.listenerTree;
        var name = type.shift();
        while(name !== undefined){
            if (!tree[name]) tree[name] = {};
            tree = tree[name];
            if (type.length === 0) {
                if (!tree._listeners) tree._listeners = listener;
                else {
                    if (typeof tree._listeners === 'function') tree._listeners = [
                        tree._listeners
                    ];
                    tree._listeners.push(listener);
                    if (!tree._listeners.warned && this._maxListeners > 0 && tree._listeners.length > this._maxListeners) {
                        tree._listeners.warned = true;
                        logPossibleMemoryLeak.call(this, tree._listeners.length, name);
                    }
                }
                return true;
            }
            name = type.shift();
        }
        return true;
    }
    // By default EventEmitters will print a warning if more than
    // 10 listeners are added to it. This is a useful default which
    // helps finding memory leaks.
    //
    // Obviously not all Emitters should be limited to 10. This function allows
    // that to be increased. Set to zero for unlimited.
    EventEmitter.prototype.delimiter = '.';
    EventEmitter.prototype.setMaxListeners = function(n) {
        if (n !== undefined) {
            this._maxListeners = n;
            if (!this._conf) this._conf = {};
            this._conf.maxListeners = n;
        }
    };
    EventEmitter.prototype.event = '';
    EventEmitter.prototype.once = function(event, fn) {
        return this._once(event, fn, false);
    };
    EventEmitter.prototype.prependOnceListener = function(event, fn) {
        return this._once(event, fn, true);
    };
    EventEmitter.prototype._once = function(event, fn, prepend) {
        this._many(event, 1, fn, prepend);
        return this;
    };
    EventEmitter.prototype.many = function(event, ttl, fn) {
        return this._many(event, ttl, fn, false);
    };
    EventEmitter.prototype.prependMany = function(event, ttl, fn) {
        return this._many(event, ttl, fn, true);
    };
    EventEmitter.prototype._many = function(event, ttl, fn, prepend) {
        var self = this;
        if (typeof fn !== 'function') throw new Error('many only accepts instances of Function');
        function listener() {
            if (--ttl === 0) self.off(event, listener);
            return fn.apply(this, arguments);
        }
        listener._origin = fn;
        this._on(event, listener, prepend);
        return self;
    };
    EventEmitter.prototype.emit = function() {
        this._events || init.call(this);
        var type = arguments[0];
        if (type === 'newListener' && !this.newListener) {
            if (!this._events.newListener) return false;
        }
        var al = arguments.length;
        var args, l, i, j;
        var handler;
        if (this._all && this._all.length) {
            handler = this._all.slice();
            if (al > 3) {
                args = new Array(al);
                for(j = 0; j < al; j++)args[j] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        handler[i].call(this, type);
                        break;
                    case 2:
                        handler[i].call(this, type, arguments[1]);
                        break;
                    case 3:
                        handler[i].call(this, type, arguments[1], arguments[2]);
                        break;
                    default:
                        handler[i].apply(this, args);
                }
            }
        }
        if (this.wildcard) {
            handler = [];
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
        } else {
            handler = this._events[type];
            if (typeof handler === 'function') {
                this.event = type;
                switch(al){
                    case 1:
                        handler.call(this);
                        break;
                    case 2:
                        handler.call(this, arguments[1]);
                        break;
                    case 3:
                        handler.call(this, arguments[1], arguments[2]);
                        break;
                    default:
                        args = new Array(al - 1);
                        for(j = 1; j < al; j++)args[j - 1] = arguments[j];
                        handler.apply(this, args);
                }
                return true;
            } else if (handler) // need to make copy of handlers because list can change in the middle
            // of emit call
            handler = handler.slice();
        }
        if (handler && handler.length) {
            if (al > 3) {
                args = new Array(al - 1);
                for(j = 1; j < al; j++)args[j - 1] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        handler[i].call(this);
                        break;
                    case 2:
                        handler[i].call(this, arguments[1]);
                        break;
                    case 3:
                        handler[i].call(this, arguments[1], arguments[2]);
                        break;
                    default:
                        handler[i].apply(this, args);
                }
            }
            return true;
        } else if (!this._all && type === 'error') {
            if (arguments[1] instanceof Error) throw arguments[1]; // Unhandled 'error' event
            else throw new Error("Uncaught, unspecified 'error' event.");
            return false;
        }
        return !!this._all;
    };
    EventEmitter.prototype.emitAsync = function() {
        this._events || init.call(this);
        var type = arguments[0];
        if (type === 'newListener' && !this.newListener) {
            if (!this._events.newListener) return Promise.resolve([
                false
            ]);
        }
        var promises = [];
        var al = arguments.length;
        var args, l, i, j;
        var handler;
        if (this._all) {
            if (al > 3) {
                args = new Array(al);
                for(j = 1; j < al; j++)args[j] = arguments[j];
            }
            for(i = 0, l = this._all.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        promises.push(this._all[i].call(this, type));
                        break;
                    case 2:
                        promises.push(this._all[i].call(this, type, arguments[1]));
                        break;
                    case 3:
                        promises.push(this._all[i].call(this, type, arguments[1], arguments[2]));
                        break;
                    default:
                        promises.push(this._all[i].apply(this, args));
                }
            }
        }
        if (this.wildcard) {
            handler = [];
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
        } else handler = this._events[type];
        if (typeof handler === 'function') {
            this.event = type;
            switch(al){
                case 1:
                    promises.push(handler.call(this));
                    break;
                case 2:
                    promises.push(handler.call(this, arguments[1]));
                    break;
                case 3:
                    promises.push(handler.call(this, arguments[1], arguments[2]));
                    break;
                default:
                    args = new Array(al - 1);
                    for(j = 1; j < al; j++)args[j - 1] = arguments[j];
                    promises.push(handler.apply(this, args));
            }
        } else if (handler && handler.length) {
            handler = handler.slice();
            if (al > 3) {
                args = new Array(al - 1);
                for(j = 1; j < al; j++)args[j - 1] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        promises.push(handler[i].call(this));
                        break;
                    case 2:
                        promises.push(handler[i].call(this, arguments[1]));
                        break;
                    case 3:
                        promises.push(handler[i].call(this, arguments[1], arguments[2]));
                        break;
                    default:
                        promises.push(handler[i].apply(this, args));
                }
            }
        } else if (!this._all && type === 'error') {
            if (arguments[1] instanceof Error) return Promise.reject(arguments[1]); // Unhandled 'error' event
            else return Promise.reject("Uncaught, unspecified 'error' event.");
        }
        return Promise.all(promises);
    };
    EventEmitter.prototype.on = function(type, listener) {
        return this._on(type, listener, false);
    };
    EventEmitter.prototype.prependListener = function(type, listener) {
        return this._on(type, listener, true);
    };
    EventEmitter.prototype.onAny = function(fn) {
        return this._onAny(fn, false);
    };
    EventEmitter.prototype.prependAny = function(fn) {
        return this._onAny(fn, true);
    };
    EventEmitter.prototype.addListener = EventEmitter.prototype.on;
    EventEmitter.prototype._onAny = function(fn, prepend) {
        if (typeof fn !== 'function') throw new Error('onAny only accepts instances of Function');
        if (!this._all) this._all = [];
        // Add the function to the event listener collection.
        if (prepend) this._all.unshift(fn);
        else this._all.push(fn);
        return this;
    };
    EventEmitter.prototype._on = function(type, listener, prepend) {
        if (typeof type === 'function') {
            this._onAny(type, listener);
            return this;
        }
        if (typeof listener !== 'function') throw new Error('on only accepts instances of Function');
        this._events || init.call(this);
        // To avoid recursion in the case that type == "newListeners"! Before
        // adding it to the listeners, first emit "newListeners".
        this.emit('newListener', type, listener);
        if (this.wildcard) {
            growListenerTree.call(this, type, listener);
            return this;
        }
        if (!this._events[type]) // Optimize the case of one listener. Don't need the extra array object.
        this._events[type] = listener;
        else {
            if (typeof this._events[type] === 'function') // Change to array.
            this._events[type] = [
                this._events[type]
            ];
            // If we've already got an array, just add
            if (prepend) this._events[type].unshift(listener);
            else this._events[type].push(listener);
            // Check for listener leak
            if (!this._events[type].warned && this._maxListeners > 0 && this._events[type].length > this._maxListeners) {
                this._events[type].warned = true;
                logPossibleMemoryLeak.call(this, this._events[type].length, type);
            }
        }
        return this;
    };
    EventEmitter.prototype.off = function(type, listener) {
        if (typeof listener !== 'function') throw new Error('removeListener only takes instances of Function');
        var handlers, leafs = [];
        if (this.wildcard) {
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
        } else {
            // does not use listeners(), so no side effect of creating _events[type]
            if (!this._events[type]) return this;
            handlers = this._events[type];
            leafs.push({
                _listeners: handlers
            });
        }
        for(var iLeaf = 0; iLeaf < leafs.length; iLeaf++){
            var leaf = leafs[iLeaf];
            handlers = leaf._listeners;
            if (isArray(handlers)) {
                var position = -1;
                for(var i = 0, length = handlers.length; i < length; i++)if (handlers[i] === listener || handlers[i].listener && handlers[i].listener === listener || handlers[i]._origin && handlers[i]._origin === listener) {
                    position = i;
                    break;
                }
                if (position < 0) continue;
                if (this.wildcard) leaf._listeners.splice(position, 1);
                else this._events[type].splice(position, 1);
                if (handlers.length === 0) {
                    if (this.wildcard) delete leaf._listeners;
                    else delete this._events[type];
                }
                this.emit("removeListener", type, listener);
                return this;
            } else if (handlers === listener || handlers.listener && handlers.listener === listener || handlers._origin && handlers._origin === listener) {
                if (this.wildcard) delete leaf._listeners;
                else delete this._events[type];
                this.emit("removeListener", type, listener);
            }
        }
        function recursivelyGarbageCollect(root) {
            if (root === undefined) return;
            var keys = Object.keys(root);
            for(var i in keys){
                var key = keys[i];
                var obj = root[key];
                if (obj instanceof Function || typeof obj !== "object" || obj === null) continue;
                if (Object.keys(obj).length > 0) recursivelyGarbageCollect(root[key]);
                if (Object.keys(obj).length === 0) delete root[key];
            }
        }
        recursivelyGarbageCollect(this.listenerTree);
        return this;
    };
    EventEmitter.prototype.offAny = function(fn) {
        var i = 0, l = 0, fns;
        if (fn && this._all && this._all.length > 0) {
            fns = this._all;
            for(i = 0, l = fns.length; i < l; i++)if (fn === fns[i]) {
                fns.splice(i, 1);
                this.emit("removeListenerAny", fn);
                return this;
            }
        } else {
            fns = this._all;
            for(i = 0, l = fns.length; i < l; i++)this.emit("removeListenerAny", fns[i]);
            this._all = [];
        }
        return this;
    };
    EventEmitter.prototype.removeListener = EventEmitter.prototype.off;
    EventEmitter.prototype.removeAllListeners = function(type) {
        if (arguments.length === 0) {
            !this._events || init.call(this);
            return this;
        }
        if (this.wildcard) {
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            var leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
            for(var iLeaf = 0; iLeaf < leafs.length; iLeaf++){
                var leaf = leafs[iLeaf];
                leaf._listeners = null;
            }
        } else if (this._events) this._events[type] = null;
        return this;
    };
    EventEmitter.prototype.listeners = function(type) {
        if (this.wildcard) {
            var handlers = [];
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handlers, ns, this.listenerTree, 0);
            return handlers;
        }
        this._events || init.call(this);
        if (!this._events[type]) this._events[type] = [];
        if (!isArray(this._events[type])) this._events[type] = [
            this._events[type]
        ];
        return this._events[type];
    };
    EventEmitter.prototype.eventNames = function() {
        return Object.keys(this._events);
    };
    EventEmitter.prototype.listenerCount = function(type) {
        return this.listeners(type).length;
    };
    EventEmitter.prototype.listenersAny = function() {
        if (this._all) return this._all;
        else return [];
    };
    if (typeof define === 'function' && define.amd) // AMD. Register as an anonymous module.
    define(function() {
        return EventEmitter;
    });
    else // CommonJS
    module.exports = EventEmitter;
}();

});

parcelRegister("1jG9B", function(module, exports) {

$parcel$export(module.exports, "mediaState", () => (parcelRequire("bLPxw")).mediaState);
$parcel$export(module.exports, "isClientBasedAuth", () => (parcelRequire("7mZlN")).isClientBasedAuth);
$parcel$export(module.exports, "authToOwner", () => (parcelRequire("7mZlN")).authToOwner);
$parcel$export(module.exports, "ChunkHashAlgorithm", () => (parcelRequire("9t1Mu")).ChunkHashAlgorithm);
// WARNING! DO NOTE MOVE THIS EXPORT!
// mediaState should be exported BEFORE StreamsCache import later because
// StreamsCache will try to import mediaState from here.

var $bLPxw = parcelRequire("bLPxw");

var $7mZlN = parcelRequire("7mZlN");

var $9t1Mu = parcelRequire("9t1Mu");

});
parcelRegister("bLPxw", function(module, exports) {

$parcel$export(module.exports, "mediaState", () => $b0497af2bbf706c4$export$8cef61637918b288);

var $adK77 = parcelRequire("adK77");

var $7xkt0 = parcelRequire("7xkt0");
const $b0497af2bbf706c4$export$8cef61637918b288 = {
    streams: new (0, $7xkt0.LRUMap)(1000),
    stateDeferreds: new Map(),
    eventEmitter: new (0, $adK77.EventEmitter2)()
};

});

parcelRegister("7mZlN", function(module, exports) {

$parcel$export(module.exports, "isClientBasedAuth", () => $8faf84af4f6865cd$export$6ba49fcac9c46e54);
$parcel$export(module.exports, "authToOwner", () => $8faf84af4f6865cd$export$17f6055767a8d96a);
function $8faf84af4f6865cd$export$6ba49fcac9c46e54(auth) {
    return !!auth.clientId;
}
function $8faf84af4f6865cd$export$af1ab14f2246ef72(auth) {
    return !!auth.asapIssuer;
}
const $8faf84af4f6865cd$export$17f6055767a8d96a = (auth)=>{
    if ($8faf84af4f6865cd$export$af1ab14f2246ef72(auth)) return auth;
    const clientAuth = {
        id: auth.clientId,
        baseUrl: auth.baseUrl,
        token: auth.token
    };
    return clientAuth;
};

});

parcelRegister("9t1Mu", function(module, exports) {

$parcel$export(module.exports, "ChunkHashAlgorithm", () => $7f634a1b182817d3$export$d3e73a50cc549c2e);
var $7f634a1b182817d3$export$d3e73a50cc549c2e = /*#__PURE__*/ function(ChunkHashAlgorithm) {
    ChunkHashAlgorithm["Sha256"] = "sha256";
    return ChunkHashAlgorithm;
}({});

});


parcelRegister("jkwTu", function(module, exports) {

$parcel$export(module.exports, "MediaStore", () => $6c83a790055aaff5$export$572b8a2a9fd7cbba);
$parcel$export(module.exports, "getMediaEnvironment", () => $6c83a790055aaff5$export$c8b741e18397852a);
$parcel$export(module.exports, "getMediaRegion", () => $6c83a790055aaff5$export$20f9315304dd6726);
parcelRequire("1jG9B");
var $9t1Mu = parcelRequire("9t1Mu");
var $7mZlN = parcelRequire("7mZlN");

var $6PCIn = parcelRequire("6PCIn");

var $1xw3A = parcelRequire("1xw3A");

var $h3W10 = parcelRequire("h3W10");
var $8RCh7 = parcelRequire("8RCh7");

var $2Cdf9 = parcelRequire("2Cdf9");

var $2dJnj = parcelRequire("2dJnj");

var $hsEvX = parcelRequire("hsEvX");

var $eGOwo = parcelRequire("eGOwo");

var $3NmFr = parcelRequire("3NmFr");
const $6c83a790055aaff5$var$MEDIA_API_REGION = 'media-api-region';
const $6c83a790055aaff5$var$MEDIA_API_ENVIRONMENT = 'media-api-environment';
const $6c83a790055aaff5$var$extendImageParams = (params, fetchMaxRes = false)=>{
    return {
        ...params,
        'max-age': params?.['max-age'] ?? (0, $6PCIn.FILE_CACHE_MAX_AGE),
        allowAnimated: params?.allowAnimated ?? true,
        mode: params?.mode ?? 'crop',
        ...fetchMaxRes ? {
            width: (0, $6PCIn.MAX_RESOLUTION),
            height: (0, $6PCIn.MAX_RESOLUTION)
        } : {}
    };
};
const $6c83a790055aaff5$var$jsonHeaders = {
    Accept: 'application/json',
    'Content-Type': 'application/json'
};
const $6c83a790055aaff5$var$cdnFeatureFlag = (endpoint)=>{
    let result = endpoint;
    if ((0, $3NmFr.isCommercial)() && (0, $eGOwo.fg)('platform_media_cdn_delivery')) result += '/cdn';
    return result;
};
class $6c83a790055aaff5$export$572b8a2a9fd7cbba {
    constructor(config){
        this.config = config;
        this.getArtifactBinary = async (artifacts, artifactName, { collectionName: collectionName, abortController: abortController, maxAge: maxAge = (0, $6PCIn.FILE_CACHE_MAX_AGE), traceContext: traceContext })=>{
            const metadata = {
                method: 'GET',
                endpoint: `artifact-cdn-url`
            };
            const extendedTraceContext = (0, $2Cdf9.extendTraceContext)(traceContext);
            const options = {
                ...metadata,
                traceContext: extendedTraceContext
            };
            const artifactUrl = await this.getArtifactURL(artifacts, artifactName, collectionName, maxAge);
            return (0, $8RCh7.request)(artifactUrl, options, abortController).then((0, $2Cdf9.createMapResponseToBlob)(metadata));
        };
        this.uploadArtifact = async (id, file, params, collectionName, traceContext)=>{
            const metadata = {
                method: 'POST',
                endpoint: '/file/{fileId}/artifact/binary'
            };
            const headers = {
                Accept: 'application/json',
                'Content-Type': file.type
            };
            const extendedParams = {
                ...params,
                name: file.name,
                collection: collectionName
            };
            const authContext = {
                collectionName: collectionName,
                access: [
                    {
                        type: 'file',
                        id: id,
                        actions: [
                            'update'
                        ]
                    }
                ]
            };
            const options = {
                ...metadata,
                authContext: authContext,
                headers: headers,
                params: extendedParams,
                body: file,
                traceContext: traceContext
            };
            return this.request(`/file/${id}/artifact/binary`, options).then((0, $2Cdf9.createMapResponseToJson)(metadata));
        };
        this.deleteArtifact = async (id, artifactName, collectionName, traceContext)=>{
            const metadata = {
                method: 'DELETE',
                endpoint: '/file/{fileId}/artifact/{artifactName}'
            };
            const authContext = {
                collectionName: collectionName,
                access: [
                    {
                        type: 'file',
                        id: id,
                        actions: [
                            'update'
                        ]
                    }
                ]
            };
            const options = {
                ...metadata,
                authContext: authContext,
                traceContext: traceContext,
                params: {
                    collection: collectionName
                }
            };
            await this.request(`/file/${id}/artifact/${artifactName}`, options);
        };
        this.resolveAuth = (authContext)=>(0, $hsEvX.resolveAuth)(this.config.authProvider, authContext, this.config.authProviderTimeout);
        this.resolveInitialAuth = ()=>(0, $hsEvX.resolveInitialAuth)(this.config.initialAuth);
        this._chunkHashAlgorithm = config.chunkHashAlgorithm || (0, $9t1Mu.ChunkHashAlgorithm).Sha256;
    }
    async removeCollectionFile(id, collectionName, occurrenceKey, traceContext) {
        const metadata = {
            method: 'PUT',
            endpoint: '/collection/{collectionName}'
        };
        const body = {
            actions: [
                {
                    action: 'remove',
                    item: {
                        type: 'file',
                        id: id,
                        occurrenceKey: occurrenceKey
                    }
                }
            ]
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        await this.request(`/collection/${collectionName}`, options);
    }
    createUpload(createUpTo = 1, collectionName, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/upload'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            params: {
                createUpTo: createUpTo,
                hashAlgorithm: this._chunkHashAlgorithm
            },
            headers: {
                Accept: 'application/json'
            },
            traceContext: traceContext
        };
        return this.request(`/upload`, options).then((0, $2Cdf9.createMapResponseToJson)(metadata));
    }
    async uploadChunk(etag, blob, uploadId, partNumber, collectionName, traceContext) {
        const metadata = {
            method: 'PUT',
            endpoint: '/chunk/{etag}'
        };
        const options = {
            ...metadata,
            params: {
                uploadId: uploadId,
                partNumber: partNumber
            },
            authContext: {
                collectionName: collectionName
            },
            body: blob,
            traceContext: traceContext
        };
        await this.request(`/chunk/${etag}`, options);
    }
    createFileFromUpload(body, params = {}, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/file/upload'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: params,
            headers: $6c83a790055aaff5$var$jsonHeaders,
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        return this.request('/file/upload', options).then((0, $2Cdf9.createMapResponseToJson)(metadata));
    }
    getRejectedResponseFromDescriptor(descriptor, limit) {
        return {
            fileId: descriptor.fileId,
            error: {
                code: 'ExceedMaxFileSizeLimit',
                title: 'The expected file size exceeded the maximum size limit.',
                href: 'https://dt-api-filestore--app.ap-southeast-2.dev.atl-paas.net/api.html#BadRequest',
                limit: limit,
                size: descriptor.size
            }
        };
    }
    async touchFiles(body, params = {}, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/upload/createWithFiles'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            headers: $6c83a790055aaff5$var$jsonHeaders,
            body: JSON.stringify(body),
            traceContext: traceContext,
            params: {
                hashAlgorithm: this._chunkHashAlgorithm
            }
        };
        return this.request('/upload/createWithFiles', options).then((0, $2Cdf9.createMapResponseToJson)(metadata));
    }
    getFile(fileId, params = {}, traceContext) {
        const metadata = {
            method: 'GET',
            endpoint: '/file/{fileId}'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: params,
            traceContext: traceContext
        };
        return this.request(`/file/${fileId}`, options).then((0, $2Cdf9.createMapResponseToJson)(metadata));
    }
    async getFileImageURL(id, params) {
        const { collection: collectionName } = params || {};
        const auth = await this.resolveAuth({
            collectionName: collectionName
        });
        return this.createFileImageURL(id, auth, params);
    }
    // TODO Create ticket in case Trace Id can be supported through query params
    getFileImageURLSync(id, params) {
        const auth = this.resolveInitialAuth();
        return this.createFileImageURL(id, auth, params);
    }
    createFileImageURL(id, auth, params) {
        const options = {
            params: $6c83a790055aaff5$var$extendImageParams(params),
            auth: auth
        };
        const imageEndpoint = $6c83a790055aaff5$var$cdnFeatureFlag('image');
        return (0, $2dJnj.mapToMediaCdnUrl)((0, $2Cdf9.createUrl)(`${auth.baseUrl}/file/${id}/${imageEndpoint}`, options), auth.token);
    }
    async getFileBinary(id, collectionName, abortController, maxAge = (0, $6PCIn.FILE_CACHE_MAX_AGE)) {
        const headers = {};
        const binaryEndpoint = $6c83a790055aaff5$var$cdnFeatureFlag('binary');
        const metadata = {
            method: 'GET',
            endpoint: `/file/{fileId}/${binaryEndpoint}`
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: headers,
            params: {
                collection: collectionName,
                'max-age': `${maxAge}`
            }
        };
        return this.request(`/file/${id}/${binaryEndpoint}`, options, abortController, true).then((0, $2Cdf9.createMapResponseToBlob)(metadata));
    }
    async getFileBinaryURL(id, collectionName, maxAge = (0, $6PCIn.FILE_CACHE_MAX_AGE)) {
        const auth = await this.resolveAuth({
            collectionName: collectionName
        });
        const options = {
            params: {
                dl: true,
                collection: collectionName,
                'max-age': maxAge
            },
            auth: auth
        };
        const binaryEndpoint = $6c83a790055aaff5$var$cdnFeatureFlag('binary');
        return (0, $2dJnj.mapToMediaCdnUrl)((0, $2Cdf9.createUrl)(`${auth.baseUrl}/file/${id}/${binaryEndpoint}`, options), auth.token);
    }
    async getArtifactURL(artifacts, artifactName, collectionName, maxAge = (0, $6PCIn.FILE_CACHE_MAX_AGE)) {
        // ----- WARNING ----------
        // DO NOT USE!!!!!
        // artifact.cdnUrl fails in Jira.
        // ----------------------------------
        // getArtifactURL returns a constructed url PATH, not the full Media/CDN Url.
        // We use the provided cdnUrl from metadata first.
        /* if (isCommercial() && fg('platform_media_cdn_delivery')) {
			const cdnUrl = artifacts[artifactName]?.cdnUrl;
			if (cdnUrl) {
				return cdnUrl;
			}
		} */ const artifactUrl = (0, $1xw3A.getArtifactUrl)(artifacts, artifactName);
        if (!artifactUrl) throw new Error(`artifact ${artifactName} not found`);
        const auth = await this.resolveAuth({
            collectionName: collectionName
        });
        const options = {
            params: {
                collection: collectionName,
                'max-age': maxAge
            },
            auth: auth
        };
        return (0, $2Cdf9.createUrl)((0, $2dJnj.mapToMediaCdnUrl)(artifactUrl, auth.token), options);
    }
    async getImage(id, params, controller, fetchMaxRes, traceContext) {
        // TODO add checkWebpSupport() back https://product-fabric.atlassian.net/browse/MPT-584
        const isWebpSupported = false;
        const headers = {};
        if (isWebpSupported) headers.accept = 'image/webp,image/*,*/*;q=0.8';
        const imageEndpoint = $6c83a790055aaff5$var$cdnFeatureFlag('image');
        const metadata = {
            method: 'GET',
            endpoint: `/file/{fileId}/${imageEndpoint}`
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params && params.collection
            },
            params: $6c83a790055aaff5$var$extendImageParams(params, fetchMaxRes),
            headers: headers,
            traceContext: traceContext,
            addMediaClientParam: true
        };
        return this.request(`/file/${id}/${imageEndpoint}`, options, controller, true).then((0, $2Cdf9.createMapResponseToBlob)(metadata));
    }
    async getItems(ids, collectionName, traceContext, includeHashForDuplicateFiles) {
        const descriptors = ids.map((id)=>({
                type: 'file',
                id: id,
                collection: collectionName
            }));
        const metadata = {
            method: 'POST',
            endpoint: '/items'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: $6c83a790055aaff5$var$jsonHeaders,
            body: JSON.stringify({
                descriptors: descriptors,
                includeHashForDuplicateFiles: includeHashForDuplicateFiles
            }),
            traceContext: traceContext
        };
        return this.request('/items', options).then((0, $2Cdf9.createMapResponseToJson)(metadata));
    }
    async getImageMetadata(id, params, traceContext) {
        const metadata = {
            method: 'GET',
            endpoint: '/file/{fileId}/image/metadata'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params && params.collection
            },
            params: params,
            traceContext: traceContext
        };
        return this.request(`/file/${id}/image/metadata`, options).then((0, $2Cdf9.createMapResponseToJson)(metadata));
    }
    async getDocumentContent(id, options, traceContext) {
        // when requesting for password protected document don't use CDN as it won't forward headers
        // this is deliberate to avoid caching Password protected files
        // Note: this should be removed once endpoint implements server side Cache-Control headers
        const shouldCache = !options.password;
        const endpoint = shouldCache ? $6c83a790055aaff5$var$cdnFeatureFlag('contents') : 'contents';
        const metadata = {
            method: 'GET',
            endpoint: `/file/{fileId}/document/${endpoint}`
        };
        const headers = options.password ? {
            'x-document-authorization': `Basic ${options.password}`
        } : {};
        const requestOptions = {
            ...metadata,
            authContext: {
                collectionName: options.collectionName
            },
            headers: headers,
            params: {
                collection: options.collectionName,
                pageStart: options.pageStart,
                pageEnd: options.pageEnd,
                'max-age': shouldCache ? (0, $6PCIn.FILE_CACHE_MAX_AGE) : 0
            },
            traceContext: traceContext
        };
        return this.request(`/file/${id}/document/${endpoint}`, requestOptions).then((0, $2Cdf9.createMapResponseToJson)(metadata));
    }
    async getDocumentPageImage(id, options, traceContext) {
        // when requesting for password protected document don't use CDN as it won't forward headers
        // this is deliberate to avoid caching Password protected files
        // Note: this should be removed once endpoint implements server side Cache-Control headers
        const shouldCache = !options.password;
        const endpoint = shouldCache ? $6c83a790055aaff5$var$cdnFeatureFlag('page') : 'page';
        const metadata = {
            method: 'GET',
            endpoint: `/file/{fileId}/document/${endpoint}`
        };
        const headers = options.password ? {
            'x-document-authorization': `Basic ${options.password}`
        } : {};
        const requestOptions = {
            ...metadata,
            authContext: {
                collectionName: options.collectionName
            },
            headers: headers,
            params: {
                collection: options.collectionName,
                page: options.page,
                zoom: options.zoom,
                'max-age': shouldCache ? (0, $6PCIn.FILE_CACHE_MAX_AGE) : 0
            },
            traceContext: traceContext
        };
        return this.request(`/file/${id}/document/${endpoint}`, requestOptions).then((0, $2Cdf9.createMapResponseToBlob)(metadata));
    }
    async appendChunksToUpload(uploadId, body, collectionName, traceContext) {
        const metadata = {
            method: 'PUT',
            endpoint: '/upload/{uploadId}/chunks'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: $6c83a790055aaff5$var$jsonHeaders,
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        await this.request(`/upload/${uploadId}/chunks`, options);
    }
    copyFileWithToken(body, params, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/file/copy/withToken'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: params,
            headers: $6c83a790055aaff5$var$jsonHeaders,
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        return this.request('/file/copy/withToken', options).then((0, $2Cdf9.createMapResponseToJson)(metadata));
    }
    copyFile(id, params, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/v2/file/copy'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: params,
            headers: $6c83a790055aaff5$var$jsonHeaders,
            body: JSON.stringify({
                id: id
            }),
            traceContext: traceContext,
            clientOptions: {
                retryOptions: {
                    shouldRetryError: (err)=>(0, $2Cdf9.defaultShouldRetryError)(err) || (0, $h3W10.isRequestError)(err) && err?.metadata?.statusCode === 401
                }
            }
        };
        return this.request('/v2/file/copy', options).then((0, $2Cdf9.createMapResponseToJson)(metadata));
    }
    async registerCopyIntents(files, traceContext, resolvedAuth) {
        const metadata = {
            method: 'POST',
            endpoint: '/file/copy/intents'
        };
        const options = {
            ...metadata,
            headers: $6c83a790055aaff5$var$jsonHeaders,
            body: JSON.stringify({
                files: files
            }),
            traceContext: traceContext,
            resolvedAuth: resolvedAuth
        };
        await this.request('/file/copy/intents', options);
    }
    async request(path, options = {
        method: 'GET',
        endpoint: undefined,
        authContext: {}
    }, controller, useMediaCdn) {
        const { method: method, endpoint: endpoint, authContext: authContext, params: params, headers: headers, body: body, clientOptions: clientOptions, traceContext: traceContext, addMediaClientParam: addMediaClientParam, resolvedAuth: resolvedAuth } = options;
        const auth = resolvedAuth ?? await this.resolveAuth(authContext);
        const clientId = (0, $7mZlN.isClientBasedAuth)(auth) ? auth.clientId : undefined;
        const extendedTraceContext = (0, $2Cdf9.extendTraceContext)(traceContext);
        const extendedParams = addMediaClientParam ? {
            ...params,
            clientId: clientId
        } : params;
        let url = `${auth.baseUrl}${path}`;
        if (useMediaCdn) url = (0, $2dJnj.mapToMediaCdnUrl)(url, auth.token);
        const response = await (0, $8RCh7.request)(url, {
            method: method,
            endpoint: endpoint,
            auth: auth,
            params: extendedParams,
            headers: headers,
            body: body,
            clientOptions: clientOptions,
            traceContext: extendedTraceContext
        }, controller);
        $6c83a790055aaff5$var$setKeyValueInSessionStorage($6c83a790055aaff5$var$MEDIA_API_REGION, response.headers.get('x-media-region'));
        $6c83a790055aaff5$var$setKeyValueInSessionStorage($6c83a790055aaff5$var$MEDIA_API_ENVIRONMENT, response.headers.get('x-media-env'));
        return response;
    }
    async testUrl(url, options = {}) {
        const { traceContext: traceContext } = options;
        await (0, $8RCh7.request)(url, {
            method: 'HEAD',
            traceContext: (0, $2Cdf9.extendTraceContext)(traceContext),
            clientOptions: {
                retryOptions: {
                    maxAttempts: 1
                }
            }
        });
    }
    get chunkHashAlgorithm() {
        return this._chunkHashAlgorithm;
    }
}
const $6c83a790055aaff5$var$getValueFromSessionStorage = (key)=>{
    return window && window.sessionStorage && window.sessionStorage.getItem(key) || undefined;
};
const $6c83a790055aaff5$var$setKeyValueInSessionStorage = (key, value)=>{
    if (!value || !(window && window.sessionStorage)) return;
    const currentValue = window.sessionStorage.getItem(key);
    if (currentValue !== value) window.sessionStorage.setItem(key, value);
};
const $6c83a790055aaff5$export$c8b741e18397852a = ()=>{
    return $6c83a790055aaff5$var$getValueFromSessionStorage($6c83a790055aaff5$var$MEDIA_API_ENVIRONMENT);
};
const $6c83a790055aaff5$export$20f9315304dd6726 = ()=>{
    return $6c83a790055aaff5$var$getValueFromSessionStorage($6c83a790055aaff5$var$MEDIA_API_REGION);
};

});
parcelRegister("6PCIn", function(module, exports) {

$parcel$export(module.exports, "RECENTS_COLLECTION", () => $b90d9cdebe03397b$export$860a16125e30000b);
$parcel$export(module.exports, "FILE_CACHE_MAX_AGE", () => $b90d9cdebe03397b$export$bd6e8fe09a90927b);
$parcel$export(module.exports, "MAX_RESOLUTION", () => $b90d9cdebe03397b$export$6e70f30e392bc53f);
$parcel$export(module.exports, "CHUNK_SIZE", () => $b90d9cdebe03397b$export$c1abb8bab1e615cd);
$parcel$export(module.exports, "PROCESSING_BATCH_SIZE", () => $b90d9cdebe03397b$export$3d5157f0def70e54);
$parcel$export(module.exports, "MAX_UPLOAD_FILE_SIZE", () => $b90d9cdebe03397b$export$f14f521f3d306044);

var $jmTJ7 = parcelRequire("jmTJ7");
const $b90d9cdebe03397b$export$860a16125e30000b = 'recents';
const $b90d9cdebe03397b$export$bd6e8fe09a90927b = 2592000; // Retain for 30 days
const $b90d9cdebe03397b$export$6e70f30e392bc53f = 4096;
const $b90d9cdebe03397b$export$c1abb8bab1e615cd = 5 * (0, $jmTJ7.DATA_UNIT).MB;
const $b90d9cdebe03397b$export$3d5157f0def70e54 = 1000;
const $b90d9cdebe03397b$export$f14f521f3d306044 = 2 * (0, $jmTJ7.DATA_UNIT).TB;

});
parcelRegister("jmTJ7", function(module, exports) {

$parcel$export(module.exports, "isNotFoundMediaItemDetails", () => $29f3d51eb645d15a$export$fd27d7abbc4a746d);
$parcel$export(module.exports, "DATA_UNIT", () => $29f3d51eb645d15a$export$76cfea4c354af843);
const $29f3d51eb645d15a$export$350ede7b7a6acf99 = (type)=>{
    const defaultPreviewableTypes = [
        'audio',
        'video',
        'image',
        'doc'
    ];
    return defaultPreviewableTypes.indexOf(type) > -1;
};
const $29f3d51eb645d15a$export$fd27d7abbc4a746d = (itemDetails)=>{
    return 'type' in itemDetails && itemDetails.type === 'not-found';
};
var $29f3d51eb645d15a$export$76cfea4c354af843 = /*#__PURE__*/ function(DATA_UNIT) {
    DATA_UNIT[DATA_UNIT["MB"] = 1048576] = "MB";
    DATA_UNIT[DATA_UNIT["GB"] = 1073741824] = "GB";
    DATA_UNIT[DATA_UNIT["TB"] = 1099511627776] = "TB";
    return DATA_UNIT;
}({});

});


parcelRegister("1xw3A", function(module, exports) {

$parcel$export(module.exports, "getArtifactUrl", () => $91442ef87cdc4338$export$1cc24defa44e7f84);

var $eGOwo = parcelRequire("eGOwo");

var $3NmFr = parcelRequire("3NmFr");
const $91442ef87cdc4338$export$1cc24defa44e7f84 = (artifacts, prop)=>{
    // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    if ((0, $3NmFr.isCommercial)() && (0, $eGOwo.fg)('platform_media_cdn_delivery') && artifacts[prop]?.url) return `${artifacts[prop]?.url}/cdn`;
    return artifacts[prop]?.url;
};

});
parcelRegister("3NmFr", function(module, exports) {

$parcel$export(module.exports, "isCommercial", () => $130542adabbe691e$export$df69ff6733e73e50);
function $130542adabbe691e$export$df69ff6733e73e50() {
    const global = globalThis;
    const perimeter = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (perimeter) // Note: reference to MICROS_PERIMETER can be found in: https://hello.atlassian.net/wiki/spaces/MICROS/pages/167212650/Runtime+configuration+environment+variables+and+adding+secrets#Micros-provided-variables
    return perimeter === 'commercial';
    // Return true if the current hostname does NOT match any of the forbidden patterns.
    return !global.location?.hostname?.match(/(atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net))/);
}

});


parcelRegister("h3W10", function(module, exports) {

$parcel$export(module.exports, "RequestError", () => $360d238df22c07b8$export$43ee7d0e4f429743);
$parcel$export(module.exports, "isRequestError", () => $360d238df22c07b8$export$3717b1ffef4428ea);

var $4rKJa = parcelRequire("4rKJa");
class $360d238df22c07b8$export$43ee7d0e4f429743 extends (0, $4rKJa.BaseMediaClientError) {
    constructor(reason, metadata, innerError){
        super(reason, metadata, innerError);
    }
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ get attributes() {
        const { reason: reason, metadata: { method: method, endpoint: endpoint, mediaRegion: mediaRegion, mediaEnv: mediaEnv, attempts: attempts, clientExhaustedRetries: clientExhaustedRetries, statusCode: statusCode, traceContext: traceContext } = {}, innerError: innerError } = this;
        return {
            reason: reason,
            method: method,
            endpoint: endpoint,
            mediaRegion: mediaRegion,
            mediaEnv: mediaEnv,
            attempts: attempts,
            clientExhaustedRetries: clientExhaustedRetries,
            statusCode: statusCode,
            metadata: {
                traceContext: traceContext
            },
            innerError: innerError
        };
    }
}
function $360d238df22c07b8$export$3717b1ffef4428ea(err) {
    return err instanceof $360d238df22c07b8$export$43ee7d0e4f429743;
}

});
parcelRegister("4rKJa", function(module, exports) {

$parcel$export(module.exports, "BaseMediaClientError", () => $e9c543355e5204ca$export$2b0aca14d61c3190);
$parcel$export(module.exports, "CommonMediaClientError", () => $e9c543355e5204ca$export$e574d1724215079f);
$parcel$export(module.exports, "isCommonMediaClientError", () => $e9c543355e5204ca$export$881f0f9bc813e1f3);
$parcel$export(module.exports, "toCommonMediaClientError", () => $e9c543355e5204ca$export$a5db89cfc88eff9);
$parcel$export(module.exports, "fromCommonMediaClientError", () => $e9c543355e5204ca$export$c2b89b9a32286816);

var $eBofv = parcelRequire("eBofv");
class $e9c543355e5204ca$export$2b0aca14d61c3190 extends Error {
    constructor(reason, metadata, innerError){
        super(reason), this.reason = reason, this.metadata = metadata, this.innerError = innerError;
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(this, new.target.prototype);
        // https://v8.dev/docs/stack-trace-api
        if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
    }
}
class $e9c543355e5204ca$export$e574d1724215079f extends $e9c543355e5204ca$export$2b0aca14d61c3190 {
    constructor(reason, metadata, innerError){
        super(reason, metadata, innerError);
    }
    get attributes() {
        return {
            reason: this.reason
        };
    }
}
function $e9c543355e5204ca$export$881f0f9bc813e1f3(error) {
    if (!error) return false;
    // Check if the error is an instance of Error
    if (error instanceof $e9c543355e5204ca$export$e574d1724215079f) return true;
    return typeof error.reason === 'string' && ('metadata' in error || error.metadata === undefined) && ('innerError' in error || error.innerError === undefined);
}
const $e9c543355e5204ca$export$a5db89cfc88eff9 = (errorFileState)=>{
    const error = errorFileState.details?.error;
    return new $e9c543355e5204ca$export$e574d1724215079f(error?.reason || 'unknown-reason', error.metadata, error.innerError);
};
const $e9c543355e5204ca$export$c2b89b9a32286816 = (id, occurrenceKey, error)=>{
    return {
        status: 'error',
        id: id,
        occurrenceKey: occurrenceKey,
        reason: error.reason,
        details: {
            /** Use this attr to translate back into CommonMediaClientError (toCommonMediaClientError) */ error: {
                reason: error?.reason,
                metadata: error?.metadata,
                innerError: error?.innerError
            },
            // Legacy details
            ...error?.attributes
        },
        message: error?.message
    };
};

});
parcelRegister("eBofv", function(module, exports) {

$parcel$export(module.exports, "getMediaClientErrorReason", () => $508e04f54b9269ab$export$c15d72765ee2baa4);
function $508e04f54b9269ab$export$2491e0bbdb59256e(error) {
    return error instanceof Object && 'attributes' in error && error.attributes instanceof Object && 'reason' in error.attributes && error instanceof Error;
}
function $508e04f54b9269ab$export$c15d72765ee2baa4(err) {
    return $508e04f54b9269ab$export$2491e0bbdb59256e(err) ? err.attributes.reason : 'unknown';
}

});



parcelRegister("8RCh7", function(module, exports) {

$parcel$export(module.exports, "request", () => $16d1dca60bf2e497$export$b5fe3f66a567bec0);

var $h3W10 = parcelRequire("h3W10");

var $2Cdf9 = parcelRequire("2Cdf9");
async function $16d1dca60bf2e497$export$b5fe3f66a567bec0(url, options = {}, controller) {
    const { method: method = 'GET', endpoint: endpoint, auth: auth, params: params, headers: headers, body: body, clientOptions: clientOptions = {}, traceContext: traceContext } = options;
    const { retryOptions: retryOptions } = clientOptions;
    const metadata = {
        method: method,
        endpoint: endpoint,
        traceContext: traceContext
    };
    // TODO BMPT-918: add client timeout feature behing a FF (using clientOptions.clientTimeout + Promise.race)
    const doFetch = ()=>fetch((0, $2Cdf9.createUrl)(url, {
            params: params
        }), {
            method: method,
            body: body,
            headers: (0, $2Cdf9.extendHeaders)(headers, auth, traceContext),
            signal: controller && controller.signal
        }).then((0, $2Cdf9.createProcessFetchResponse)(metadata));
    return (0, $2Cdf9.fetchRetry)(doFetch, metadata, retryOptions);
}

});
parcelRegister("2Cdf9", function(module, exports) {

$parcel$export(module.exports, "extendTraceContext", () => $8e2ee04a8e27c7ba$export$ee24a95986dfd173);
$parcel$export(module.exports, "createUrl", () => $8e2ee04a8e27c7ba$export$7138c24907de3954);
$parcel$export(module.exports, "extendHeaders", () => $8e2ee04a8e27c7ba$export$18cfbabc415d771c);
$parcel$export(module.exports, "createMapResponseToJson", () => $8e2ee04a8e27c7ba$export$e0519b126b73efa6);
$parcel$export(module.exports, "createMapResponseToBlob", () => $8e2ee04a8e27c7ba$export$5cc7b0795397da86);
$parcel$export(module.exports, "defaultShouldRetryError", () => $8e2ee04a8e27c7ba$export$fee2242cbb339663);
$parcel$export(module.exports, "fetchRetry", () => $8e2ee04a8e27c7ba$export$782df2acbe10b22c);
$parcel$export(module.exports, "createRequestErrorReason", () => $8e2ee04a8e27c7ba$export$6397609af718d008);
$parcel$export(module.exports, "createProcessFetchResponse", () => $8e2ee04a8e27c7ba$export$6e2e477edb7d6032);
parcelRequire("1jG9B");
var $7mZlN = parcelRequire("7mZlN");

var $3xaEP = parcelRequire("3xaEP");

var $9WNJB = parcelRequire("9WNJB");

var $h3W10 = parcelRequire("h3W10");
const $8e2ee04a8e27c7ba$var$getStatusCode = (error)=>(0, $h3W10.isRequestError)(error) && error.metadata?.statusCode && error.metadata.statusCode;
function $8e2ee04a8e27c7ba$export$80c51ea1e89203dd(timeout) {
    return new Promise((resolve)=>setTimeout(resolve, timeout));
}
function $8e2ee04a8e27c7ba$export$de0b576cf7ce4a53(err) {
    return err instanceof Error && err.message === 'request_cancelled' || !!err && err.name === 'AbortError';
}
function $8e2ee04a8e27c7ba$export$ad8c5cf7dd4c3caf(err) {
    return err instanceof TypeError;
}
function $8e2ee04a8e27c7ba$export$bc96a6a479480590(error) {
    const statusCode = error && $8e2ee04a8e27c7ba$var$getStatusCode(error);
    return statusCode === 429 || !!error && !!error.message && error.message.includes('429');
}
const $8e2ee04a8e27c7ba$export$ee24a95986dfd173 = (traceContext)=>traceContext ? {
        ...traceContext,
        spanId: traceContext?.spanId || (0, $3xaEP.getRandomTelemetryId)()
    } : undefined;
const $8e2ee04a8e27c7ba$export$922566b90d0535ce = {
    traceId: 'x-b3-traceid',
    spanId: 'x-b3-spanid',
    parentSpanId: 'x-b3-parentspanid',
    sampled: 'x-b3-sampled',
    flags: 'x-b3-flags'
};
const $8e2ee04a8e27c7ba$var$mapTraceIdToRequestHeaders = (traceContext)=>{
    return traceContext ? {
        [$8e2ee04a8e27c7ba$export$922566b90d0535ce.traceId]: traceContext.traceId,
        [$8e2ee04a8e27c7ba$export$922566b90d0535ce.spanId]: traceContext.spanId
    } : {};
};
function $8e2ee04a8e27c7ba$export$eaf4479116d2f925(auth) {
    if (!auth) return {};
    if ((0, $7mZlN.isClientBasedAuth)(auth)) return {
        'X-Client-Id': auth.clientId,
        Authorization: `Bearer ${auth.token}`
    };
    return {
        'X-Issuer': auth.asapIssuer,
        Authorization: `Bearer ${auth.token}`
    };
}
function $8e2ee04a8e27c7ba$export$7138c24907de3954(url, { params: params, auth: auth }) {
    const parsedUrl = new URL(url, auth?.baseUrl);
    const authParams = auth && (0, $9WNJB.mapAuthToQueryParameters)(auth) || {};
    const paramsToAppend = {
        ...params,
        ...authParams
    };
    Object.entries(paramsToAppend).filter(([_, value])=>value != null).forEach((pair)=>{
        parsedUrl.searchParams.set(...pair);
    });
    parsedUrl.searchParams.sort();
    return parsedUrl.toString();
}
function $8e2ee04a8e27c7ba$export$18cfbabc415d771c(headers, auth, traceContext) {
    if (!auth && !traceContext && !headers) return undefined;
    return {
        ...headers ?? {},
        ...$8e2ee04a8e27c7ba$export$eaf4479116d2f925(auth),
        ...$8e2ee04a8e27c7ba$var$mapTraceIdToRequestHeaders(traceContext)
    };
}
function $8e2ee04a8e27c7ba$export$e0519b126b73efa6(metadata) {
    return async (response)=>{
        try {
            return await response.json();
        } catch (err) {
            throw new (0, $h3W10.RequestError)('serverInvalidBody', {
                ...metadata,
                ...$8e2ee04a8e27c7ba$export$ea175c0c5497224(response),
                statusCode: response.status
            }, err instanceof Error ? err : undefined);
        }
    };
}
function $8e2ee04a8e27c7ba$export$5cc7b0795397da86(metadata) {
    return async (response)=>{
        try {
            return await response.blob();
        } catch (err) {
            throw new (0, $h3W10.RequestError)('serverInvalidBody', {
                ...metadata,
                ...$8e2ee04a8e27c7ba$export$ea175c0c5497224(response),
                statusCode: response.status
            }, err instanceof Error ? err : undefined);
        }
    };
}
const $8e2ee04a8e27c7ba$export$fee2242cbb339663 = (err)=>{
    const statusCode = $8e2ee04a8e27c7ba$var$getStatusCode(err);
    return $8e2ee04a8e27c7ba$export$ad8c5cf7dd4c3caf(err) || (statusCode ? statusCode >= 500 : false);
};
const $8e2ee04a8e27c7ba$export$c65cfa70960d8fe5 = {
    startTimeoutInMs: 1000,
    maxAttempts: 5,
    factor: 2
};
function $8e2ee04a8e27c7ba$export$359f19ca51f9eba1(error, extraMetadata) {
    const { reason: reason, metadata: metadata, innerError: innerError } = error;
    return new (0, $h3W10.RequestError)(reason, {
        ...metadata,
        ...extraMetadata
    }, innerError);
}
async function $8e2ee04a8e27c7ba$export$782df2acbe10b22c(functionToRetry, metadata, overwriteOptions = {}) {
    const options = {
        ...$8e2ee04a8e27c7ba$export$c65cfa70960d8fe5,
        ...overwriteOptions
    };
    const { startTimeoutInMs: startTimeoutInMs, maxAttempts: maxAttempts, factor: factor, shouldRetryError: shouldRetryError = $8e2ee04a8e27c7ba$export$fee2242cbb339663 } = options;
    let attempts = 0;
    let timeoutInMs = startTimeoutInMs;
    let lastError;
    const waitAndBumpTimeout = async ()=>{
        await $8e2ee04a8e27c7ba$export$80c51ea1e89203dd(timeoutInMs);
        timeoutInMs *= factor;
        attempts += 1;
    };
    while(attempts < maxAttempts)try {
        return await functionToRetry();
    } catch (err) {
        lastError = err;
        // don't retry if request was aborted by user
        if ($8e2ee04a8e27c7ba$export$de0b576cf7ce4a53(err)) throw new (0, $h3W10.RequestError)('clientAbortedRequest', metadata, err);
        if (!shouldRetryError(err)) throw err;
        await waitAndBumpTimeout();
    }
    if ((0, $h3W10.isRequestError)(lastError)) throw $8e2ee04a8e27c7ba$export$359f19ca51f9eba1(lastError, {
        attempts: attempts,
        clientExhaustedRetries: true
    });
    throw new (0, $h3W10.RequestError)('serverUnexpectedError', {
        ...metadata,
        attempts: attempts,
        clientExhaustedRetries: true
    }, lastError);
}
function $8e2ee04a8e27c7ba$export$6397609af718d008(statusCode) {
    switch(statusCode){
        case 400:
            return 'serverBadRequest';
        case 401:
            return 'serverUnauthorized';
        case 403:
            return 'serverForbidden';
        case 404:
            return 'serverNotFound';
        case 422:
            return 'serverUnprocessableEntity';
        case 423:
            return 'serverEntityLocked';
        case 429:
            return 'serverRateLimited';
        case 500:
            return 'serverInternalError';
        case 502:
            return 'serverBadGateway';
        default:
            return 'serverUnexpectedError';
    }
}
function $8e2ee04a8e27c7ba$export$d171f49f6b4ddc33(metadata, response) {
    const { status: statusCode } = response;
    const reason = $8e2ee04a8e27c7ba$export$6397609af718d008(statusCode);
    return new (0, $h3W10.RequestError)(reason, {
        ...metadata,
        ...$8e2ee04a8e27c7ba$export$ea175c0c5497224(response),
        statusCode: statusCode
    });
}
function $8e2ee04a8e27c7ba$export$6e2e477edb7d6032(metadata) {
    return (response)=>{
        if (response.ok || response.status < 400) return response;
        const requestError = $8e2ee04a8e27c7ba$export$d171f49f6b4ddc33(metadata, response);
        throw requestError;
    };
}
function $8e2ee04a8e27c7ba$export$ea175c0c5497224(response) {
    const { headers: headers } = response;
    const mediaRegion = headers.get('x-media-region') || 'unknown';
    const mediaEnv = headers.get('x-media-env') || 'unknown';
    return {
        mediaRegion: mediaRegion,
        mediaEnv: mediaEnv
    };
}

});
parcelRegister("3xaEP", function(module, exports) {

$parcel$export(module.exports, "isUndefined", () => $af4102ec3e3c11b2$export$fce6876652108ab);
$parcel$export(module.exports, "omitBy", () => $af4102ec3e3c11b2$export$d7a617dda645b4e3);
$parcel$export(module.exports, "getRandomHex", () => $af4102ec3e3c11b2$export$456b25e3a9b4a843);
$parcel$export(module.exports, "getRandomTelemetryId", () => $af4102ec3e3c11b2$export$2e36de8639bad0ad);
const $af4102ec3e3c11b2$export$fce6876652108ab = (value)=>value === undefined;
const $af4102ec3e3c11b2$export$357523c63a2253b9 = (obj, keys = [])=>{
    if (obj === undefined) return {};
    return Object.fromEntries(Object.entries(obj).filter(([k])=>keys.includes(k)));
};
const $af4102ec3e3c11b2$export$d7a617dda645b4e3 = (obj, predicate)=>Object.fromEntries(Object.entries(obj).filter(([, v])=>!predicate(v)));
const $af4102ec3e3c11b2$export$61fc7d43ac8f84b0 = (func, wait)=>{
    let timeout;
    return (...args)=>{
        clearTimeout(timeout);
        timeout = setTimeout(()=>func(...args), wait);
    };
};
const $af4102ec3e3c11b2$export$de994efd351b291c = (srcObj)=>{
    return (obj)=>{
        let key;
        for(key in srcObj){
            if (obj[key] === undefined || obj[key] !== srcObj[key]) return false;
        }
        return true;
    };
};
function $af4102ec3e3c11b2$var$getRandomHexValues(byte) {
    return [
        ...Array(byte * 2)
    ].map(()=>Math.floor(Math.random() * 16).toString(16)).join('');
}
function $af4102ec3e3c11b2$export$456b25e3a9b4a843(byte) {
    let randomHex;
    if (window?.crypto) try {
        randomHex = Array.from(window.crypto.getRandomValues(new Uint8Array(byte))).map((b)=>b.toString(16).padStart(2, '0')).join('');
    } catch (e) {
        randomHex = $af4102ec3e3c11b2$var$getRandomHexValues(byte);
    }
    else randomHex = $af4102ec3e3c11b2$var$getRandomHexValues(byte);
    return randomHex;
}
function $af4102ec3e3c11b2$export$2e36de8639bad0ad() {
    return $af4102ec3e3c11b2$export$456b25e3a9b4a843(8);
}

});

parcelRegister("9WNJB", function(module, exports) {

$parcel$export(module.exports, "mapAuthToQueryParameters", () => $47d6feb819b26718$export$6833b130611df767);
parcelRequire("1jG9B");
var $7mZlN = parcelRequire("7mZlN");
function $47d6feb819b26718$export$6833b130611df767(auth) {
    if ((0, $7mZlN.isClientBasedAuth)(auth)) return {
        client: auth.clientId,
        token: auth.token
    };
    else return {
        issuer: auth.asapIssuer,
        token: auth.token
    };
}

});



parcelRegister("2dJnj", function(module, exports) {

$parcel$export(module.exports, "mapToMediaCdnUrl", () => $bf5b522ee1224e39$export$fb88a576cf28364d);

var $eGOwo = parcelRequire("eGOwo");

var $3NmFr = parcelRequire("3NmFr");
const $bf5b522ee1224e39$export$8a9b6ab3569a543a = {
    'api.media.atlassian.com': 'media-cdn.atlassian.com',
    'media.staging.atl-paas.net': 'media-cdn.stg.atlassian.com'
};
// Cloudfront has a hard limit of 8,192 bytes
// https://docs.aws.amazon.com/AmazonCloudFront/latest/DeveloperGuide/cloudfront-limits.html
// Assuming other parts of the URL make up a max of ~1000 (in reality it's lower), the token can be ~7000
const $bf5b522ee1224e39$var$MEDIA_TOKEN_LENGTH_LIMIT = 7000;
function $bf5b522ee1224e39$export$fb88a576cf28364d(url, token) {
    const tokenLength = token?.length ?? 0;
    if (!(0, $3NmFr.isCommercial)() || tokenLength > $bf5b522ee1224e39$var$MEDIA_TOKEN_LENGTH_LIMIT) return url;
    // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    if ((0, $eGOwo.fg)('platform_media_cdn_delivery') && (0, $eGOwo.fg)('platform_media_cdn_single_host')) try {
        const parsedUrl = new URL(url);
        const cdnHost = $bf5b522ee1224e39$export$8a9b6ab3569a543a[parsedUrl.host];
        // If no mapping is found, return the original URL
        if (!cdnHost) return url;
        // Replace the host with the CDN host in the original URL
        parsedUrl.host = cdnHost;
        return parsedUrl.toString();
    } catch (error) {
        return url;
    }
    return url;
}

});

parcelRegister("hsEvX", function(module, exports) {

$parcel$export(module.exports, "resolveAuth", () => $6d143f49360dbe76$export$4b4cec3dcdfce972);
$parcel$export(module.exports, "resolveInitialAuth", () => $6d143f49360dbe76$export$5211e1371264aec3);

var $3Y4Hn = parcelRequire("3Y4Hn");

var $3nErQ = parcelRequire("3nErQ");
const $6d143f49360dbe76$export$560085fe411c0660 = 10000;
const $6d143f49360dbe76$export$4b4cec3dcdfce972 = async (authProvider, authContext, authProviderTimeout = $6d143f49360dbe76$export$560085fe411c0660)=>{
    let auth;
    try {
        auth = await Promise.race([
            authProvider(authContext),
            (0, $3nErQ.rejectTimeout)(authProviderTimeout, new (0, $3Y4Hn.MediaStoreError)('authProviderTimedOut'))
        ]);
    } catch (err) {
        if (err instanceof (0, $3Y4Hn.MediaStoreError)) throw err;
        throw new (0, $3Y4Hn.MediaStoreError)('failedAuthProvider', err instanceof Error ? err : undefined);
    }
    if (!auth) throw new (0, $3Y4Hn.MediaStoreError)('emptyAuth');
    /*
    We added a token expiration check here in the past, and then we had to revert due to edge cases in the client that we can't control.
    Token expiration check in the frontend is a bad idea. Don't do it!
    More info:
    https://bitbucket.org/atlassian/atlassian-frontend/pull-requests/13080
    https://gist.github.com/timvisee/fcda9bbdff88d45cc9061606b4b923ca
  */ return auth;
};
const $6d143f49360dbe76$export$5211e1371264aec3 = (auth)=>{
    if (!auth) throw new (0, $3Y4Hn.MediaStoreError)('missingInitialAuth');
    return auth;
};

});
parcelRegister("3Y4Hn", function(module, exports) {

$parcel$export(module.exports, "MediaStoreError", () => $d19f60583c5ce4e8$export$b78480bd311630bc);

var $4rKJa = parcelRequire("4rKJa");
class $d19f60583c5ce4e8$export$b78480bd311630bc extends (0, $4rKJa.BaseMediaClientError) {
    constructor(reason, innerError){
        super(reason, undefined, innerError);
    }
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ get attributes() {
        const { reason: reason, innerError: innerError } = this;
        return {
            reason: reason,
            innerError: innerError
        };
    }
}
function $d19f60583c5ce4e8$export$8d2a9b675b2ce37a(err) {
    return err instanceof $d19f60583c5ce4e8$export$b78480bd311630bc;
}

});

parcelRegister("3nErQ", function(module, exports) {

$parcel$export(module.exports, "rejectTimeout", () => $bdd7813d02cb717f$export$cf2d2a1124beacb2);
const $bdd7813d02cb717f$export$c30e7cea8bbec3c0 = (timeout, resolveWith)=>new Promise((resolve, _reject)=>{
        setTimeout(resolve, timeout, resolveWith);
    });
const $bdd7813d02cb717f$export$cf2d2a1124beacb2 = (timeout, rejectWith)=>new Promise((_resolve, reject)=>{
        setTimeout(reject, timeout, rejectWith);
    });

});



parcelRegister("iPHIU", function(module, exports) {

$parcel$export(module.exports, "FileFetcherImpl", () => $09c82e56436a3d4e$export$fe17eabf77aabacb);
$parcel$export(module.exports, "FileFetcherError", () => (parcelRequire("1GWfm")).FileFetcherError);

var $2PBDa = parcelRequire("2PBDa");

var $3PmNk = parcelRequire("3PmNk");

var $8KLBw = parcelRequire("8KLBw");
parcelRequire("1jG9B");
var $7mZlN = parcelRequire("7mZlN");

var $g1OQu = parcelRequire("g1OQu");

var $jkwTu = parcelRequire("jkwTu");

var $bbNl0 = parcelRequire("bbNl0");

var $jmTJ7 = parcelRequire("jmTJ7");

var $1GWfm = parcelRequire("1GWfm");

var $2mMyO = parcelRequire("2mMyO");

var $abkQS = parcelRequire("abkQS");

var $lRBVi = parcelRequire("lRBVi");

var $6PCIn = parcelRequire("6PCIn");

var $eaj78 = parcelRequire("eaj78");

var $hRxrn = parcelRequire("hRxrn");

var $atDjN = parcelRequire("atDjN");

var $053B3 = parcelRequire("053B3");

var $iDYg8 = parcelRequire("iDYg8");

var $jFXx8 = parcelRequire("jFXx8");
var $kFG4u = parcelRequire("kFG4u");

var $ea8A0 = parcelRequire("ea8A0");

var $jkEmk = parcelRequire("jkEmk");

var $5JVfG = parcelRequire("5JVfG");

var $8UZz3 = parcelRequire("8UZz3");

var $393Zn = parcelRequire("393Zn");

var $iX2Cl = parcelRequire("iX2Cl");
parcelRequire("48hWz");
var $1ZNSP = parcelRequire("1ZNSP");

var $bksvR = parcelRequire("bksvR");

var $2Cdf9 = parcelRequire("2Cdf9");

var $4rKJa = parcelRequire("4rKJa");
const $09c82e56436a3d4e$var$isCopySourceFileWithToken = (token)=>!!token.authProvider;
const $09c82e56436a3d4e$var$isCopyDestinationWithToken = (token)=>!!token.authProvider;
class $09c82e56436a3d4e$export$fe17eabf77aabacb {
    constructor(mediaApi, store = (0, $1ZNSP.mediaStore)){
        this.mediaApi = mediaApi;
        this.store = store;
        this.getErrorFileState = (error, id, occurrenceKey)=>{
            if ((0, $4rKJa.isCommonMediaClientError)(error)) return (0, $4rKJa.fromCommonMediaClientError)(id, occurrenceKey, error);
            // ________________________________________________
            // Legacy serializers
            // We need to revisit all the incoming error types and ensure all the "reason" values are known
            // We need to change the input error: any for a known type.
            if (typeof error === 'string') {
                const err = new (0, $4rKJa.CommonMediaClientError)(error);
                return (0, $4rKJa.fromCommonMediaClientError)(id, occurrenceKey, err);
            } else {
                const err = new (0, $4rKJa.CommonMediaClientError)(error?.reason || 'unknown', error?.metadata, error?.innerError);
                return (0, $4rKJa.fromCommonMediaClientError)(id, occurrenceKey, err);
            }
        };
        this.setFileState = (id, fileState)=>{
            this.store.setState((state)=>{
                state.files[id] = fileState;
            });
        };
        this.createDownloadFileStream = (id, collectionName, occurrenceKey, includeHashForDuplicateFiles, forceRefresh)=>{
            const subject = (0, $jkEmk.createMediaSubject)();
            const poll = new (0, $393Zn.PollingFunction)();
            // ensure subject errors if polling exceeds max iterations or uncaught exception in executor
            poll.onError = (error)=>subject.error(error);
            poll.execute(async ()=>{
                if (forceRefresh) this.dataloader.clear({
                    id: id,
                    collectionName: collectionName,
                    includeHashForDuplicateFiles: includeHashForDuplicateFiles
                });
                const response = await this.dataloader.load({
                    id: id,
                    collectionName: collectionName,
                    includeHashForDuplicateFiles: includeHashForDuplicateFiles
                });
                if ((0, $jmTJ7.isNotFoundMediaItemDetails)(response)) throw new (0, $1GWfm.FileFetcherError)('emptyItems', {
                    id: id,
                    collectionName: collectionName,
                    occurrenceKey: occurrenceKey,
                    traceContext: response.metadataTraceContext
                });
                if ((0, $iX2Cl.isEmptyFile)(response)) throw new (0, $1GWfm.FileFetcherError)('zeroVersionFile', {
                    id: id,
                    collectionName: collectionName,
                    occurrenceKey: occurrenceKey,
                    traceContext: response.metadataTraceContext
                });
                const fileState = (0, $bbNl0.mapMediaItemToFileState)(id, response);
                subject.next(fileState);
                switch(fileState.status){
                    case 'processing':
                        // the only case for continuing polling, otherwise this function is run once only
                        poll.next();
                        break;
                    case 'processed':
                        subject.complete();
                        break;
                }
            });
            return subject;
        };
        this.getUploadingFileStateBase = (file, upfrontId)=>{
            // TODO: DO not modify the input parameter 'content' attribute
            if (typeof file.content === 'string') file.content = (0, $iDYg8.convertBase64ToBlob)(file.content);
            const { content: content, name: name = '' } = file;
            const { id: id, occurrenceKey: occurrenceKey } = upfrontId;
            let preview;
            // TODO [MSW-796]: get file size for base64
            let size = 0;
            let mimeType = '';
            if (content instanceof Blob) {
                size = content.size;
                mimeType = content.type;
                preview = {
                    value: content,
                    origin: 'local'
                };
            }
            const mediaType = (0, $atDjN.getMediaTypeFromUploadableFile)(file);
            return {
                id: id,
                occurrenceKey: occurrenceKey,
                name: name,
                size: size,
                mediaType: mediaType,
                mimeType: mimeType,
                preview: preview
            };
        };
        this.uploadArtifact = async (id, file, params, collectionName, traceContext)=>{
            const { data: data } = await this.mediaApi.uploadArtifact(id, file, params, collectionName, traceContext);
            /* TEMPORARYLY PULLING NEW METADATA till the endpoint is fixed */ const { data: altData } = await this.mediaApi.getItems([
                id
            ], collectionName, traceContext);
            const itemDetails = altData.items[0].details;
            // ------------------------------------------------------------
            this.setFileState(id, (0, $bbNl0.mapMediaItemToFileState)(id, itemDetails));
            return data;
        };
        this.deleteArtifact = async (id, artifactName, collectionName, traceContext)=>{
            await this.mediaApi.deleteArtifact(id, artifactName, collectionName, traceContext);
            // Manually remove the artifact from file state instead of re-requesting the entire payload.
            const file = this.store.getState().files[id];
            if (file && file.status === 'processed' && file.artifacts) {
                const updatedArtifacts = {
                    ...file.artifacts
                };
                delete updatedArtifacts[artifactName];
                const updatedFileState = {
                    ...file,
                    artifacts: updatedArtifacts
                };
                this.setFileState(id, updatedFileState);
            }
        };
        this.getOrFetchFileState = async (id, collectionName)=>{
            let fileState = this.store.getState().files[id];
            return fileState ?? await this.getCurrentState(id, {
                collectionName: collectionName
            });
        };
        this.getDurationOfVideo = async (id, collectionName)=>{
            const fileState = await this.getOrFetchFileState(id, collectionName);
            if (fileState.status !== 'processed' || fileState.mediaType !== 'video' || !fileState.artifacts['video.mp4']) throw new Error('File is not a video');
            const artifactUrlString = await this.getArtifactURL(fileState.artifacts, 'video.mp4');
            const artifactUrl = new URL(artifactUrlString);
            const artifactPath = `${artifactUrl.pathname}${artifactUrl.search}`;
            const res = await this.mediaApi.request(artifactPath, {
                headers: {
                    Range: 'bytes=0-199'
                }
            });
            // Get the response as ArrayBuffer
            const arrayBuffer = await res.arrayBuffer();
            const uint8Array = new Uint8Array(arrayBuffer);
            const mvhdBytes = new Uint8Array([
                109,
                118,
                104,
                100
            ]); // "mvhd" in ASCII
            let mvhdIndex = -1;
            for(let i = 0; i <= uint8Array.length - mvhdBytes.length; i++){
                mvhdIndex = i;
                for(let j = 0; j < mvhdBytes.length; j++)if (uint8Array[i + j] !== mvhdBytes[j]) {
                    mvhdIndex = -1;
                    break;
                }
                if (mvhdIndex !== -1) break;
            }
            if (mvhdIndex === -1) throw new Error('Unable to find mvhd bytes');
            // Create DataView for reading big-endian integers
            const dataView = new DataView(arrayBuffer);
            const start = mvhdIndex + 16; // Skip atom header and version/flags
            // Check if we have enough bytes to read timescale and duration
            if (start + 8 > arrayBuffer.byteLength) return 0;
            // flase as second parameter indicates big-endian 32-bit integers
            const timeScale = dataView.getUint32(start, false);
            const duration = dataView.getUint32(start + 4, false);
            if (timeScale === 0) throw new Error('Timescale is invalid');
            // get the video length in seconds
            const videoLength = Math.floor(duration / timeScale);
            return videoLength;
        };
        this.getVideoDurations = async (files)=>{
            // get all the duration promises
            const promises = files.map(async ({ id: id, collectionName: collectionName })=>{
                try {
                    return await this.getDurationOfVideo(id, collectionName);
                } catch (_err) {
                    return -1;
                }
            });
            const durations = await Promise.all(promises);
            // only return the durations that are present;
            return durations.reduce((acc, curr, i)=>{
                if (curr !== -1) {
                    const id = files[i].id;
                    acc[id] = curr;
                }
                return acc;
            }, {});
        };
        this.dataloader = (0, $hRxrn.createFileDataloader)(mediaApi);
        this.copyIntentRegisterationBatcher = (0, $bksvR.createCopyIntentRegisterationBatcher)(mediaApi);
    }
    getFileState(id, options = {}) {
        const { collectionName: collectionName, occurrenceKey: occurrenceKey, includeHashForDuplicateFiles: includeHashForDuplicateFiles, forceRefresh: forceRefresh } = options;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($eaj78)))(id)) {
            const subject = (0, $jkEmk.createMediaSubject)();
            const err = new (0, $1GWfm.FileFetcherError)('invalidFileId', {
                id: id,
                collectionName: collectionName,
                occurrenceKey: occurrenceKey
            });
            const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
            subject.error(err);
            this.setFileState(id, errorFileState);
            return (0, $jFXx8.fromObservable)(subject);
        }
        if (forceRefresh) (0, $abkQS.getFileStreamsCache)().remove(id);
        return (0, $jFXx8.fromObservable)((0, $abkQS.getFileStreamsCache)().getOrInsert(id, ()=>{
            const subject = this.createDownloadFileStream(id, collectionName, undefined, includeHashForDuplicateFiles, forceRefresh);
            subject.subscribe({
                next: (fileState)=>{
                    this.setFileState(id, fileState);
                },
                error: (err)=>{
                    const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
                    this.setFileState(id, errorFileState);
                }
            });
            return subject;
        }));
    }
    getCurrentState(id, options) {
        return (0, $kFG4u.toPromise)(this.getFileState(id, options));
    }
    getArtifactURL(artifacts, artifactName, collectionName) {
        return this.mediaApi.getArtifactURL(artifacts, artifactName, collectionName);
    }
    getFileBinaryURL(id, collectionName, maxAge) {
        return this.mediaApi.getFileBinaryURL(id, collectionName, maxAge);
    }
    touchFiles(descriptors, collection, traceContext) {
        return this.mediaApi.touchFiles({
            descriptors: descriptors
        }, {
            collection: collection
        }, traceContext).then(({ data: data })=>data);
    }
    generateUploadableFileUpfrontIds(collection, traceContext) {
        const id = (0, (/*@__PURE__*/$parcel$interopDefault($8KLBw)))();
        const occurrenceKey = (0, (/*@__PURE__*/$parcel$interopDefault($8KLBw)))();
        const touchFileDescriptor = {
            fileId: id,
            occurrenceKey: occurrenceKey,
            collection: collection
        };
        const deferredUploadId = this.touchFiles([
            touchFileDescriptor
        ], collection, traceContext).then((touchedFiles)=>touchedFiles.created[0].uploadId);
        return {
            id: id,
            occurrenceKey: occurrenceKey,
            deferredUploadId: deferredUploadId
        };
    }
    async uploadExternal(url, collection, traceContext) {
        const uploadableFileUpfrontIds = this.generateUploadableFileUpfrontIds(collection, traceContext);
        const { id: id, occurrenceKey: occurrenceKey } = uploadableFileUpfrontIds;
        const subject = (0, $jkEmk.createMediaSubject)();
        const deferredBlob = fetch(url).then((response)=>response.blob()).catch(()=>undefined);
        const preview = new Promise(async (resolve, reject)=>{
            const blob = await deferredBlob;
            if (!blob) reject('Could not fetch the blob');
            resolve({
                value: blob,
                origin: 'remote'
            });
        });
        const name = url.split('/').pop() || '';
        // we create a initial fileState with the minimum info that we have at this point
        const fileState = {
            status: 'processing',
            name: name,
            size: 0,
            mediaType: 'unknown',
            mimeType: '',
            id: id,
            occurrenceKey: occurrenceKey,
            preview: preview
        };
        subject.next(fileState);
        // we save it into the cache as soon as possible, in case someone subscribes
        (0, $abkQS.getFileStreamsCache)().set(id, subject);
        this.setFileState(id, fileState);
        return new Promise(async (resolve, reject)=>{
            const blob = await deferredBlob;
            if (!blob) return reject('Could not download remote file');
            const { type: type, size: size } = blob;
            const file = {
                content: blob,
                mimeType: type,
                collection: collection,
                name: name,
                size: size
            };
            const mediaType = (0, $5JVfG.getMediaTypeFromMimeType)(type);
            // we emit a richer state after the blob is fetched
            subject.next({
                status: 'processing',
                name: name,
                size: size,
                mediaType: mediaType,
                mimeType: type,
                id: id,
                occurrenceKey: occurrenceKey,
                preview: preview
            });
            // we don't want to wait for the file to be upload
            this.upload(file, undefined, uploadableFileUpfrontIds, traceContext);
            let dimensions;
            try {
                dimensions = await (0, $ea8A0.getDimensionsFromBlob)(mediaType, blob);
            } catch (error) {
                reject(error);
                return;
            }
            resolve({
                dimensions: dimensions,
                mimeType: type,
                uploadableFileUpfrontIds: uploadableFileUpfrontIds
            });
        });
    }
    upload(file, controller, uploadableFileUpfrontIds, traceContext) {
        const { collection: collection } = file;
        const upfrontId = uploadableFileUpfrontIds || this.generateUploadableFileUpfrontIds(collection, traceContext);
        const { id: id, occurrenceKey: occurrenceKey } = upfrontId;
        const stateBase = this.getUploadingFileStateBase(file, upfrontId);
        const subject = (0, $jkEmk.createMediaSubject)();
        (0, $abkQS.getFileStreamsCache)().set(id, subject);
        const onProgress = (progress)=>{
            const fileState = {
                status: 'uploading',
                ...stateBase,
                progress: progress
            };
            subject.next(fileState);
            this.setFileState(id, fileState);
        };
        let processingSubscription = new (0, $2PBDa.Subscription)();
        const onUploadFinish = (error)=>{
            if (error) {
                const errorFileState = this.getErrorFileState(error, id, occurrenceKey);
                this.setFileState(id, errorFileState);
                return subject.error(error);
            }
            processingSubscription = this.createDownloadFileStream(id, collection, occurrenceKey).pipe((0, $3PmNk.map)((remoteFileState)=>({
                    // merges base state with remote state
                    ...stateBase,
                    ...remoteFileState,
                    ...(0, $053B3.overrideMediaTypeIfUnknown)(remoteFileState, stateBase.mediaType)
                }))).subscribe({
                next: (fileState)=>{
                    subject.next(fileState);
                    this.setFileState(id, fileState);
                },
                error: (err)=>{
                    const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
                    subject.error(err);
                    this.setFileState(id, errorFileState);
                },
                complete: subject.complete
            });
        };
        const { cancel: cancel } = (0, $2mMyO.uploadFile)(file, this.mediaApi, upfrontId, {
            onUploadFinish: onUploadFinish,
            onProgress: onProgress
        }, traceContext);
        controller?.setAbort(()=>{
            cancel();
            // TODO: filestate should turn to "Aborted" or something.
            // Consider canceling an upload that is already finished
            processingSubscription.unsubscribe();
        });
        // We should report progress asynchronously, since this is what consumer expects
        // (otherwise in newUploadService file-converting event will be emitted before files-added)
        setTimeout(onProgress, 0, 0);
        return (0, $jFXx8.fromObservable)(subject);
    }
    async downloadBinary(id, name = 'download', collectionName, traceContext) {
        const url = await this.mediaApi.getFileBinaryURL(id, collectionName);
        (0, $g1OQu.downloadUrl)(url, {
            name: name
        });
        (0, $lRBVi.globalMediaEventEmitter).emit('media-viewed', {
            fileId: id,
            isUserCollection: collectionName === (0, $6PCIn.RECENTS_COLLECTION),
            viewingLevel: 'download'
        });
        // Test the download after initiated the Browser process to catch any potential errors.
        await this.mediaApi.testUrl(url, {
            traceContext: traceContext
        });
    }
    async registerCopyIntent(id, collectionName) {
        // pre-resolving auth to add it to the key
        const auth = await this.mediaApi.resolveAuth({
            collectionName: collectionName
        });
        const key = {
            id: id,
            collectionName: collectionName,
            resolvedAuth: auth
        };
        const error = await this.copyIntentRegisterationBatcher.load(key);
        if (error) {
            // if the error is retryable then it should not be cached
            if ((0, $2Cdf9.defaultShouldRetryError)(error)) this.copyIntentRegisterationBatcher.clear(key);
            throw error;
        }
    }
    async copyFileWithToken(source, destination, traceContext) {
        const { authProvider: authProvider, collection: sourceCollection, id: id } = source;
        const { authProvider: destinationAuthProvider, collection: destinationCollectionName, replaceFileId: replaceFileId, occurrenceKey: occurrenceKey } = destination;
        const mediaStore = destination.mediaStore || new (0, $jkwTu.MediaStore)({
            authProvider: destinationAuthProvider
        });
        const owner = (0, $7mZlN.authToOwner)(await authProvider({
            collectionName: sourceCollection
        }));
        const body = {
            sourceFile: {
                id: id,
                collection: sourceCollection,
                owner: owner
            }
        };
        const params = {
            collection: destinationCollectionName,
            replaceFileId: replaceFileId,
            occurrenceKey: occurrenceKey
        };
        const { data: data } = await mediaStore.copyFileWithToken(body, params, traceContext);
        return data;
    }
    async copyFileWithIntent(source, destination, traceContext) {
        const res = await this.mediaApi.copyFile(source.id, {
            sourceCollection: source.collection,
            collection: destination.collection,
            replaceFileId: destination.replaceFileId
        }, traceContext);
        const { data: data } = res;
        return data;
    }
    async copyFile(source, destination, options = {}, traceContext) {
        const { id: id } = source;
        const { collection: destinationCollectionName, replaceFileId: replaceFileId, occurrenceKey: occurrenceKey } = destination;
        const { preview: preview, mimeType: mimeType } = options;
        const cache = (0, $abkQS.getFileStreamsCache)();
        let processingSubscription;
        try {
            let copiedFile;
            if ($09c82e56436a3d4e$var$isCopySourceFileWithToken(source) && $09c82e56436a3d4e$var$isCopyDestinationWithToken(destination)) copiedFile = await this.copyFileWithToken(source, destination, traceContext);
            else copiedFile = await this.copyFileWithIntent(source, destination, traceContext);
            // if we were passed a "mimeType", we propagate it into copiedFileWithMimeType
            const copiedFileWithMimeType = {
                ...copiedFile,
                ...mimeType ? {
                    mimeType: mimeType
                } : undefined
            };
            const { id: copiedId, mimeType: copiedMimeType } = copiedFileWithMimeType;
            // backend may return an "unknown" mediaType just after the copy
            // it's better to deduce it from "copiedMimeType" using getMediaTypeFromMimeType()
            const mediaType = copiedMimeType ? (0, $5JVfG.getMediaTypeFromMimeType)(copiedMimeType) : 'unknown';
            const copiedFileState = (0, $bbNl0.mapMediaFileToFileState)({
                data: copiedFileWithMimeType
            });
            const fileCache = cache.get(copiedId);
            const subject = fileCache || (0, $jkEmk.createMediaSubject)();
            // if we were passed a "preview", we propagate it into the copiedFileState
            const previewOverride = !(0, $bbNl0.isErrorFileState)(copiedFileState) && !!preview ? {
                preview: preview
            } : {};
            if (!(0, $bbNl0.isFinalFileState)(copiedFileState) && // mimeType should always be returned by "copyFileWithToken"
            // but in case it's not, we don't want to penalize "copyFile"
            copiedMimeType && await (0, $8UZz3.shouldFetchRemoteFileStates)(mediaType, copiedMimeType, preview)) {
                const fileState = {
                    ...copiedFileState,
                    ...(0, $053B3.overrideMediaTypeIfUnknown)(copiedFileState, mediaType),
                    ...previewOverride
                };
                subject.next(fileState);
                this.setFileState(copiedId, fileState);
                processingSubscription = this.createDownloadFileStream(copiedId, destinationCollectionName, occurrenceKey).subscribe({
                    next: (remoteFileState)=>{
                        const fileState = {
                            ...remoteFileState,
                            ...(0, $053B3.overrideMediaTypeIfUnknown)(remoteFileState, mediaType),
                            ...!(0, $bbNl0.isErrorFileState)(remoteFileState) && previewOverride
                        };
                        this.setFileState(copiedId, fileState);
                        return subject.next(fileState);
                    },
                    error: (err)=>{
                        const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
                        this.setFileState(copiedId, errorFileState);
                        return subject.error(err);
                    },
                    complete: ()=>subject.complete()
                });
            } else if (!(0, $bbNl0.isProcessingFileState)(copiedFileState)) {
                const fileState = {
                    ...copiedFileState,
                    ...!(0, $bbNl0.isErrorFileState)(copiedFileState) && previewOverride
                };
                subject.next(fileState);
                this.setFileState(copiedId, fileState);
            }
            if (!cache.has(copiedId)) (0, $abkQS.getFileStreamsCache)().set(copiedId, subject);
            return copiedFile;
        } catch (error) {
            if (processingSubscription) processingSubscription.unsubscribe();
            if (replaceFileId) {
                const fileCache = cache.get(replaceFileId);
                const replaceFileState = this.store.getState().files[replaceFileId];
                if (fileCache) fileCache.error(error);
                else // Create a new subject with the error state for new subscriptions
                cache.set(id, (0, $jkEmk.createMediaSubject)(error));
                const key = replaceFileState ? replaceFileId : id;
                const errorFileState = this.getErrorFileState(error, id, occurrenceKey);
                this.setFileState(key, errorFileState);
            }
            throw error;
        }
    }
}

});
parcelRegister("g1OQu", function(module, exports) {

$parcel$export(module.exports, "downloadUrl", () => $c1f893c1652c9963$export$8a96edb1c96563f4);
const $c1f893c1652c9963$export$8a96edb1c96563f4 = (url, options)=>{
    const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const iframeName = 'media-download-iframe';
    const link = document.createElement('a');
    let iframe = document.getElementById(iframeName);
    if (!iframe) {
        iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.id = iframeName;
        iframe.name = iframeName;
        document.body.appendChild(iframe);
    }
    link.href = url;
    if (options && options.name) link.download = options.name;
    link.target = isIE11 || isSafari ? '_blank' : iframeName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

});

parcelRegister("bbNl0", function(module, exports) {

$parcel$export(module.exports, "isUploadingFileState", () => $071e98cd60064284$export$70eb3481b487c668);
$parcel$export(module.exports, "isProcessingFileState", () => $071e98cd60064284$export$5c30e6dd75278e66);
$parcel$export(module.exports, "isProcessedFileState", () => $071e98cd60064284$export$1d17291aafa5f231);
$parcel$export(module.exports, "isErrorFileState", () => $071e98cd60064284$export$f863e1e09c8a926);
$parcel$export(module.exports, "isPreviewableFileState", () => $071e98cd60064284$export$92dd692b31e42e64);
$parcel$export(module.exports, "isFinalFileState", () => $071e98cd60064284$export$270b3fc27120edd0);
$parcel$export(module.exports, "isNonErrorFinalFileState", () => $071e98cd60064284$export$8f33148a37b0c72f);
$parcel$export(module.exports, "hasArtifacts", () => $071e98cd60064284$export$ecdf3dee1d148302);
$parcel$export(module.exports, "isImageRepresentationReady", () => $071e98cd60064284$export$4e33ccde53b4f0bf);
$parcel$export(module.exports, "mapMediaFileToFileState", () => $071e98cd60064284$export$ddfd67d20657322f);
$parcel$export(module.exports, "mapMediaItemToFileState", () => $071e98cd60064284$export$ea3730792e8bebfb);
const $071e98cd60064284$export$70eb3481b487c668 = (fileState)=>fileState.status === 'uploading';
const $071e98cd60064284$export$5c30e6dd75278e66 = (fileState)=>fileState.status === 'processing';
const $071e98cd60064284$export$1d17291aafa5f231 = (fileState)=>fileState.status === 'processed';
const $071e98cd60064284$export$f863e1e09c8a926 = (fileState)=>fileState.status === 'error';
const $071e98cd60064284$export$92dd692b31e42e64 = (fileState)=>!$071e98cd60064284$export$f863e1e09c8a926(fileState) && !!fileState.preview;
const $071e98cd60064284$export$270b3fc27120edd0 = (fileState)=>[
        'processed',
        'failed-processing',
        'error'
    ].includes(fileState.status);
const $071e98cd60064284$export$8f33148a37b0c72f = (fileState)=>[
        'processed',
        'failed-processing'
    ].includes(fileState.status);
const $071e98cd60064284$export$ecdf3dee1d148302 = (fileState)=>'artifacts' in fileState && fileState.artifacts !== undefined;
const $071e98cd60064284$export$4e33ccde53b4f0bf = (fileState)=>{
    switch(fileState.status){
        case 'processing':
        case 'processed':
        case 'failed-processing':
            return !!(fileState.representations && fileState.representations.image);
        default:
            return false;
    }
};
const $071e98cd60064284$export$ddfd67d20657322f = (mediaFile)=>{
    const { id: id, name: name, size: size, processingStatus: processingStatus, artifacts: artifacts, mediaType: mediaType, mimeType: mimeType, representations: representations, createdAt: createdAt, metadataTraceContext: metadataTraceContext, hash: hash, abuseClassification: abuseClassification, mediaMetadata: mediaMetadata } = mediaFile.data;
    const baseState = {
        id: id,
        name: name,
        size: size,
        mediaType: mediaType,
        mimeType: mimeType,
        artifacts: artifacts,
        representations: representations,
        createdAt: createdAt,
        hash: hash,
        metadataTraceContext: metadataTraceContext,
        abuseClassification: abuseClassification,
        mediaMetadata: mediaMetadata
    };
    switch(processingStatus){
        case 'pending':
        case undefined:
            return {
                ...baseState,
                status: 'processing'
            };
        case 'succeeded':
            return {
                ...baseState,
                status: 'processed'
            };
        case 'failed':
            return {
                ...baseState,
                status: 'failed-processing'
            };
    }
};
const $071e98cd60064284$export$ea3730792e8bebfb = (id, item)=>{
    return $071e98cd60064284$export$ddfd67d20657322f({
        data: {
            id: id,
            ...item
        }
    });
};

});

parcelRegister("1GWfm", function(module, exports) {

$parcel$export(module.exports, "FileFetcherError", () => $a248c46a7558c626$export$e3e60f0dab8641de);

var $4rKJa = parcelRequire("4rKJa");
class $a248c46a7558c626$export$e3e60f0dab8641de extends (0, $4rKJa.BaseMediaClientError) {
    constructor(reason, metadata){
        super(reason, metadata, undefined);
        this.id = metadata.id;
    }
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ get attributes() {
        const { reason: reason, metadata: { id: id, collectionName: collectionName, occurrenceKey: occurrenceKey, traceContext: traceContext } } = this;
        return {
            reason: reason,
            id: id,
            collectionName: collectionName,
            occurrenceKey: occurrenceKey,
            ...traceContext && {
                metadata: {
                    traceContext: traceContext
                }
            }
        };
    }
}
function $a248c46a7558c626$export$5c3435f75ce0ce70(err) {
    return err instanceof $a248c46a7558c626$export$e3e60f0dab8641de;
}

});

parcelRegister("2mMyO", function(module, exports) {

$parcel$export(module.exports, "uploadFile", () => $d0f3b9835713140d$export$a5575dbeeffdad98);

var $irjb3 = parcelRequire("irjb3");

var $2opa2 = parcelRequire("2opa2");

var $4pIMA = parcelRequire("4pIMA");

var $keN2a = parcelRequire("keN2a");

var $bpbRw = parcelRequire("bpbRw");

var $6PCIn = parcelRequire("6PCIn");

var $jZL78 = parcelRequire("jZL78");
const $d0f3b9835713140d$var$hashingFunction = async (blob, hashAlgorithm)=>{
    const hasher = await (0, $keN2a.createHasher)(hashAlgorithm);
    return hasher.hash(blob);
};
const $d0f3b9835713140d$var$createUploadingFunction = (store, deferredUploadId, collectionName, traceContext)=>async (chunk)=>{
        return await store.uploadChunk(chunk.hash, chunk.blob, await deferredUploadId, chunk.partNumber, collectionName, traceContext);
    };
const $d0f3b9835713140d$var$createProcessingFunction = (store, deferredUploadId, collection, traceContext)=>{
    let offset = 0;
    return async (chunks)=>{
        await store.appendChunksToUpload(await deferredUploadId, {
            chunks: $d0f3b9835713140d$var$hashedChunks(chunks),
            offset: offset
        }, collection, traceContext);
        offset += chunks.length;
    };
};
const $d0f3b9835713140d$var$createFileFromUpload = async (file, store, uploadableFileUpfrontIds, uploadId, traceContext)=>{
    const { collection: collection, name: name, mimeType: mimeType } = file;
    const { id: id, occurrenceKey: occurrenceKey } = uploadableFileUpfrontIds;
    const body = file.size ? {
        uploadId: uploadId,
        name: name,
        mimeType: mimeType,
        conditions: {
            size: file.size
        }
    } : {
        uploadId: uploadId,
        name: name,
        mimeType: mimeType
    };
    return store.createFileFromUpload(body, {
        occurrenceKey: occurrenceKey,
        collection: collection,
        replaceFileId: id
    }, traceContext);
};
const $d0f3b9835713140d$export$a5575dbeeffdad98 = (file, store, uploadableFileUpfrontIds, callbacks, traceContext)=>{
    const { content: content, collection: collection } = file;
    const { deferredUploadId: deferredUploadId, id: id, occurrenceKey: occurrenceKey } = uploadableFileUpfrontIds;
    let chunkSize = (0, $6PCIn.CHUNK_SIZE);
    try {
        if (content instanceof Blob) chunkSize = (0, $jZL78.calculateChunkSize)(content.size);
    } catch (err) {
        if (err instanceof Error && err.message === (0, $jZL78.fileSizeError)) callbacks?.onUploadFinish(new (0, $bpbRw.UploaderError)(err.message, {
            id: id,
            collectionName: collection,
            occurrenceKey: occurrenceKey
        }));
        return {
            cancel: ()=>{
                callbacks?.onUploadFinish('canceled');
            }
        };
    }
    const chunkinatorObservable = (0, $irjb3.chunkinator)(content, {
        hashingFunction: (blob)=>$d0f3b9835713140d$var$hashingFunction(blob, store.chunkHashAlgorithm),
        hashingConcurrency: 5,
        chunkSize: chunkSize,
        uploadingConcurrency: 3,
        uploadingFunction: $d0f3b9835713140d$var$createUploadingFunction(store, deferredUploadId, collection, traceContext),
        processingBatchSize: (0, $6PCIn.PROCESSING_BATCH_SIZE),
        processingFunction: $d0f3b9835713140d$var$createProcessingFunction(store, deferredUploadId, collection, traceContext)
    }, {
        onProgress (progress) {
            if (callbacks) callbacks.onProgress(progress);
        }
    });
    const onUploadFinish = callbacks && callbacks.onUploadFinish || (()=>{});
    const subscription = (0, $2opa2.from)(deferredUploadId).pipe((0, $4pIMA.concatMap)((uploadId)=>chunkinatorObservable.pipe((0, $4pIMA.concatMap)(()=>(0, $2opa2.from)($d0f3b9835713140d$var$createFileFromUpload(file, store, uploadableFileUpfrontIds, uploadId, traceContext)))))).subscribe({
        error: (err)=>onUploadFinish(err),
        complete: ()=>onUploadFinish()
    });
    return {
        cancel: ()=>{
            subscription.unsubscribe();
            onUploadFinish('canceled');
        }
    };
};
const $d0f3b9835713140d$var$hashedChunks = (chunks)=>chunks.map((chunk)=>chunk.hash);

});
parcelRegister("irjb3", function(module, exports) {

$parcel$export(module.exports, "chunkinator", () => $d61183fbf8357e07$export$9ab6bef3838698f8);

var $jgII5 = parcelRequire("jgII5");

var $4pIMA = parcelRequire("4pIMA");

var $aoje7 = parcelRequire("aoje7");

var $9cPse = parcelRequire("9cPse");

var $fjIB7 = parcelRequire("fjIB7");

var $iyZWI = parcelRequire("iyZWI");

var $htAnC = parcelRequire("htAnC");

var $h9RjH = parcelRequire("h9RjH");

var $aN4rI = parcelRequire("aN4rI");

var $2opa2 = parcelRequire("2opa2");
const $d61183fbf8357e07$export$88e80b3a0bb31f63 = (file, options, callbacks)=>(0, $9cPse.fromPromise)((0, $aN4rI.fetchBlob)(file)).pipe((0, $4pIMA.concatMap)((blob)=>{
        const { chunkSize: chunkSize } = options;
        const { onProgress: onProgress } = callbacks;
        const totalChunks = Math.ceil(blob.size / chunkSize);
        const slicenatedBlobs = (0, $fjIB7.slicenator)(blob, {
            size: chunkSize
        });
        const hashinatedBlobs = (0, $iyZWI.hashinator)(slicenatedBlobs, {
            concurrency: options.hashingConcurrency,
            hasher: options.hashingFunction
        });
        let uploadedChunks = 0;
        let uploadedBlobs = (0, $htAnC.uploadinator)(hashinatedBlobs, {
            concurrency: options.uploadingConcurrency,
            uploader: options.uploadingFunction
        });
        if (onProgress) uploadedBlobs = uploadedBlobs.pipe((0, $jgII5.tap)(()=>{
            uploadedChunks += 1;
            onProgress(uploadedChunks / totalChunks);
        }));
        return (0, $h9RjH.processinator)(uploadedBlobs, {
            batchSize: options.processingBatchSize,
            processor: options.processingFunction
        }).pipe((0, $4pIMA.concatMap)((batchedChunks)=>{
            return (0, $2opa2.from)(batchedChunks);
        }), (0, $aoje7.bufferCount)(totalChunks));
    }));
const $d61183fbf8357e07$export$9ab6bef3838698f8 = (file, options, callbacks)=>{
    return $d61183fbf8357e07$export$88e80b3a0bb31f63(file, options, callbacks);
};

});
parcelRegister("fjIB7", function(module, exports) {

$parcel$export(module.exports, "slicenator", () => $0dec34349839a009$export$5b92d769f2f57509);

var $4NFCE = parcelRequire("4NFCE");

var $3PmNk = parcelRequire("3PmNk");
const $0dec34349839a009$export$5b92d769f2f57509 = (blob, { size: chunkSize })=>{
    const totalChunks = Math.ceil(blob.size / chunkSize);
    return (0, $4NFCE.range)(0, totalChunks).pipe((0, $3PmNk.map)((index)=>{
        return {
            partNumber: index + 1,
            blob: blob.slice(index * chunkSize, (index + 1) * chunkSize)
        };
    }));
};

});

parcelRegister("iyZWI", function(module, exports) {

$parcel$export(module.exports, "hashinator", () => $946c6df5bbe7edda$export$d5f5a550a38ec367);

var $aN4rI = parcelRequire("aN4rI");
const $946c6df5bbe7edda$export$28a452a485721473 = (hasher)=>(slicedBlob)=>hasher(slicedBlob.blob).then((hash)=>({
                blob: slicedBlob.blob,
                hash: `${hash}-${slicedBlob.blob.size}`,
                partNumber: slicedBlob.partNumber
            }));
const $946c6df5bbe7edda$export$d5f5a550a38ec367 = (blobs$, { hasher: hasher, concurrency: concurrency })=>(0, $aN4rI.asyncMap)($946c6df5bbe7edda$export$28a452a485721473(hasher), concurrency)(blobs$);

});
parcelRegister("aN4rI", function(module, exports) {

$parcel$export(module.exports, "fetchBlob", () => $6bb2bbe9f31d7b02$export$14e9cfd4a872cc1e);
$parcel$export(module.exports, "asyncMap", () => $6bb2bbe9f31d7b02$export$707ee4c4c95d39e3);

var $7kixv = parcelRequire("7kixv");

var $eynBz = parcelRequire("eynBz");
async function $6bb2bbe9f31d7b02$export$14e9cfd4a872cc1e(file) {
    if (typeof file === 'string') return await fetch(file).then((response)=>response.blob());
    else return file;
}
const $6bb2bbe9f31d7b02$var$notify = (promise, observer, onReady)=>{
    const notifier = {
        notifyIfReady: ()=>false
    };
    promise.then((value)=>{
        notifier.notifyIfReady = ()=>{
            observer.next(value);
            observer.complete();
            return true;
        };
        onReady(notifier);
    }, (reason)=>{
        notifier.notifyIfReady = ()=>{
            observer.error(reason);
            return true;
        };
        onReady(notifier);
    });
    return notifier;
};
const $6bb2bbe9f31d7b02$var$mapper = (project)=>{
    const notifiers = new Array();
    const onReady = ()=>{
        // find the first non-ready notifier in the queue,
        // while invoking all ready notifiers that we encounter along the way
        const notReadyIdx = notifiers.findIndex((notifier)=>!notifier.notifyIfReady());
        if (notReadyIdx > 0) // remove all the notifiers we invoked
        notifiers.splice(0, notReadyIdx);
    };
    return (value)=>new (0, $7kixv.Observable)((sub)=>{
            notifiers.push($6bb2bbe9f31d7b02$var$notify(project(value), sub, onReady));
        });
};
const $6bb2bbe9f31d7b02$export$707ee4c4c95d39e3 = (project, concurrent)=>(0, $eynBz.mergeMap)($6bb2bbe9f31d7b02$var$mapper(project), concurrent);

});


parcelRegister("htAnC", function(module, exports) {

$parcel$export(module.exports, "uploadinator", () => $376f95738497d04c$export$94ce0f3fcf999415);

var $aN4rI = parcelRequire("aN4rI");
const $376f95738497d04c$export$94ce0f3fcf999415 = (blobs$, options)=>{
    const upload = (blob)=>{
        return options.uploader(blob).then(()=>blob);
    };
    return blobs$.pipe((0, $aN4rI.asyncMap)(upload, options.concurrency));
};

});

parcelRegister("h9RjH", function(module, exports) {

$parcel$export(module.exports, "processinator", () => $cfa6e3d7bb356500$export$2f21790600302ed);

var $aoje7 = parcelRequire("aoje7");

var $4pIMA = parcelRequire("4pIMA");
const $cfa6e3d7bb356500$export$2f21790600302ed = (blobs$, options)=>{
    const process = (blobs)=>{
        if (options.processor) return options.processor(blobs).then(()=>blobs);
        else return Promise.resolve(blobs);
    };
    return blobs$.pipe((0, $aoje7.bufferCount)(options.batchSize)).pipe((0, $4pIMA.concatMap)(process));
};

});


parcelRegister("keN2a", function(module, exports) {

$parcel$export(module.exports, "createHasher", () => $a41e44f7241fbce8$export$14b114effbc08b6b);
parcelRequire("1jG9B");
var $9t1Mu = parcelRequire("9t1Mu");
let $a41e44f7241fbce8$var$hasher = null;
let $a41e44f7241fbce8$var$sha256Hasher = null;
const $a41e44f7241fbce8$export$d9c9d11cd648a505 = ()=>{
    $a41e44f7241fbce8$var$hasher = null;
    $a41e44f7241fbce8$var$sha256Hasher = null;
};


const $a41e44f7241fbce8$export$14b114effbc08b6b = async (algorithm)=>{
    try {
        if (algorithm === (0, $9t1Mu.ChunkHashAlgorithm).Sha256) {
            if (!$a41e44f7241fbce8$var$sha256Hasher) {
                // TODO this needs to support worker sha256 hasher as well
                const { SimpleHasher: SimpleHasher } = await (parcelRequire("aOfga"));
                $a41e44f7241fbce8$var$sha256Hasher = new SimpleHasher();
            }
            return $a41e44f7241fbce8$var$sha256Hasher;
        }
    } catch (error) {}
    const { SimpleHasher: SimpleHasher } = await (parcelRequire("63Grn"));
    $a41e44f7241fbce8$var$hasher = new SimpleHasher();
    return $a41e44f7241fbce8$var$hasher;
};

});
parcelRegister("aOfga", function(module, exports) {

let $7dea6927bc881dd1$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $7dea6927bc881dd1$var$load("kxQbf").then(()=>parcelRequire('g8wZ9'));

});

parcelRegister("63Grn", function(module, exports) {

let $4693f1ae0207df80$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $4693f1ae0207df80$var$load("76n7a"),
    $4693f1ae0207df80$var$load("l253H"),
    $4693f1ae0207df80$var$load("6rET6")
]).then(()=>parcelRequire('cPCGi'));

});


parcelRegister("bpbRw", function(module, exports) {

$parcel$export(module.exports, "UploaderError", () => $85ab3781ae20a637$export$515240c3f059c807);

var $4rKJa = parcelRequire("4rKJa");
class $85ab3781ae20a637$export$515240c3f059c807 extends (0, $4rKJa.BaseMediaClientError) {
    constructor(reason, metadata){
        super(reason, metadata, undefined);
        this.id = metadata.id;
    }
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ get attributes() {
        const { reason: reason, metadata: { id: id, collectionName: collectionName, occurrenceKey: occurrenceKey } } = this;
        return {
            reason: reason,
            id: id,
            collectionName: collectionName,
            occurrenceKey: occurrenceKey
        };
    }
}
function $85ab3781ae20a637$export$80ee180172bc336(err) {
    return err instanceof $85ab3781ae20a637$export$515240c3f059c807;
}

});

parcelRegister("jZL78", function(module, exports) {

$parcel$export(module.exports, "fileSizeError", () => $b71a6cbe9ec1a24a$export$b36239e4c33c2902);
$parcel$export(module.exports, "calculateChunkSize", () => $b71a6cbe9ec1a24a$export$71f452e02035c1e2);

var $jmTJ7 = parcelRequire("jmTJ7");

var $6PCIn = parcelRequire("6PCIn");
const $b71a6cbe9ec1a24a$export$b36239e4c33c2902 = 'fileSizeExceedsLimit';
const $b71a6cbe9ec1a24a$export$71f452e02035c1e2 = (fileSize)=>{
    if (fileSize > (0, $6PCIn.MAX_UPLOAD_FILE_SIZE)) throw new Error($b71a6cbe9ec1a24a$export$b36239e4c33c2902);
    if (fileSize <= 5 * (0, $jmTJ7.DATA_UNIT).GB) return 5 * (0, $jmTJ7.DATA_UNIT).MB;
    if (fileSize > 5 * (0, $jmTJ7.DATA_UNIT).GB && fileSize <= 50 * (0, $jmTJ7.DATA_UNIT).GB) return 50 * (0, $jmTJ7.DATA_UNIT).MB;
    if (fileSize > 50 * (0, $jmTJ7.DATA_UNIT).GB && fileSize <= 0.95 * (0, $jmTJ7.DATA_UNIT).TB) return 100 * (0, $jmTJ7.DATA_UNIT).MB;
    return 210 * (0, $jmTJ7.DATA_UNIT).MB;
};

});


parcelRegister("abkQS", function(module, exports) {

$parcel$export(module.exports, "getFileStreamsCache", () => $20fb1b7a81082f5e$export$f2f061938c1e6810);
class $20fb1b7a81082f5e$export$4293896e79732236 {
    constructor(streams){
        this.streams = streams;
    }
    has(id) {
        return !!this.streams.find(id);
    }
    set(id, stream) {
        this.streams.set(id, stream);
    }
    get(id) {
        return this.streams.get(id);
    }
    getOrInsert(id, callback) {
        if (!this.has(id)) this.set(id, callback());
        return this.get(id);
    }
    removeAll() {
        this.streams.clear();
    }
    remove(id) {
        this.streams.delete(id);
    }
    get size() {
        return this.streams.size;
    }
}
let $20fb1b7a81082f5e$var$streamCache;

const $20fb1b7a81082f5e$export$f2f061938c1e6810 = ()=>{
    if (!$20fb1b7a81082f5e$var$streamCache) {
        // TODO: we can move this into a static import like
        // import {mediaState} from '@atlaskit/media-core'
        const mediaState = (parcelRequire("bLPxw")).mediaState;
        $20fb1b7a81082f5e$var$streamCache = new $20fb1b7a81082f5e$export$4293896e79732236(mediaState.streams);
    }
    return $20fb1b7a81082f5e$var$streamCache;
};

});

parcelRegister("lRBVi", function(module, exports) {

$parcel$export(module.exports, "globalMediaEventEmitter", () => $175af825576b091d$export$68d003d3105952ad);
parcelRequire("1jG9B");
var $bLPxw = parcelRequire("bLPxw");
const $175af825576b091d$export$68d003d3105952ad = {
    on (event, listener) {
        if ((0, $bLPxw.mediaState).eventEmitter) (0, $bLPxw.mediaState).eventEmitter.on(event, listener);
    },
    off (event, listener) {
        if ((0, $bLPxw.mediaState).eventEmitter) (0, $bLPxw.mediaState).eventEmitter.off(event, listener);
    },
    emit (event, payload) {
        if ((0, $bLPxw.mediaState).eventEmitter) return (0, $bLPxw.mediaState).eventEmitter.emit(event, payload);
        return undefined;
    }
};

});

parcelRegister("eaj78", function(module, exports) {
// Regular expression used for basic parsing of the uuid.

var $5Ovjr = parcelRequire("5Ovjr");
var $a500d3812b6eabd3$require$Buffer = $5Ovjr.Buffer;
var $a500d3812b6eabd3$var$pattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
/**
 * Unparses a UUID buffer to a string. From node-uuid:
 * https://github.com/defunctzombie/node-uuid/blob/master/uuid.js
 *
 * Copyright (c) 2010-2012 Robert Kieffer
 * MIT License - http://opensource.org/licenses/mit-license.php
 *
 * @param  {Buffer} buf
 * @param  {Number=0} offset
 * @return {String}
 */ var $a500d3812b6eabd3$var$_byteToHex = [];
for(var $a500d3812b6eabd3$var$i = 0; $a500d3812b6eabd3$var$i < 256; $a500d3812b6eabd3$var$i++)$a500d3812b6eabd3$var$_byteToHex[$a500d3812b6eabd3$var$i] = ($a500d3812b6eabd3$var$i + 0x100).toString(16).substr(1);
function $a500d3812b6eabd3$var$unparse(buf, offset) {
    var i = offset || 0, bth = $a500d3812b6eabd3$var$_byteToHex;
    return bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]];
}
/**
 * Determines whether the uuid is valid, converting
 * it from a buffer if necessary.
 *
 * @param  {String|Buffer}  uuid
 * @param  {Number=}  version
 * @return {Boolean}
 */ module.exports = function(uuid, version) {
    var parsedUuid;
    // If the uuid is a biffer, parse it...
    if ($a500d3812b6eabd3$require$Buffer.isBuffer(uuid)) parsedUuid = $a500d3812b6eabd3$var$unparse(uuid);
    else if (Object.prototype.toString.call(uuid) === '[object String]') parsedUuid = uuid;
    else return false;
    parsedUuid = parsedUuid.toLowerCase();
    // All UUIDs fit a basic schema. Match that.
    if (!$a500d3812b6eabd3$var$pattern.test(parsedUuid)) return false;
    // Now extract the version...
    if (version === undefined) version = $a500d3812b6eabd3$var$extractVersion(parsedUuid);
    else if ($a500d3812b6eabd3$var$extractVersion(parsedUuid) !== version) return false;
    switch(version){
        // For certain versions, the checks we did up to this point are fine.
        case 1:
        case 2:
            return true;
        // For versions 3 and 4, they must specify a variant.
        case 3:
        case 4:
        case 5:
            return [
                '8',
                '9',
                'a',
                'b'
            ].indexOf(parsedUuid.charAt(19)) !== -1;
        default:
            // We should only be able to reach this if the consumer explicitly
            // provided an invalid version. Prior to extractVersion we check
            // that it's 1-4 in the regex.
            throw new Error('Invalid version provided.');
    }
};
/**
 * Extracts the version from the UUID, which is (by definition) the M in
 * xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx
 *
 * @param  {String} uuid
 * @return {Number}
 */ var $a500d3812b6eabd3$var$extractVersion = module.exports.version = function(uuid) {
    return uuid.charAt(14) | 0;
};

});

parcelRegister("hRxrn", function(module, exports) {

$parcel$export(module.exports, "createFileDataloader", () => $611f84914cb6f1a5$export$ae188fee39529b82);

var $79KwK = parcelRequire("79KwK");

var $3xaEP = parcelRequire("3xaEP");
const $611f84914cb6f1a5$export$b79d95ee17a87a = 100;
const $611f84914cb6f1a5$var$isBatchLoadingErrorResult = (result)=>{
    return result.error instanceof Error;
};
const $611f84914cb6f1a5$var$isResponseFileItem = (fileItem)=>{
    return 'details' in fileItem;
};
const $611f84914cb6f1a5$var$makeCacheKey = (id, collection)=>collection ? `${id}-${collection}` : id;
const $611f84914cb6f1a5$export$71cd2e8f8162d47b = (dataloaderKeys, fileItems)=>{
    const itemsByKey = fileItems.reduce((prev, fileItem)=>{
        const { id: id, collection: collection } = fileItem;
        const key = $611f84914cb6f1a5$var$makeCacheKey(id, collection);
        if ($611f84914cb6f1a5$var$isBatchLoadingErrorResult(fileItem)) prev[key] = fileItem.error;
        else if ($611f84914cb6f1a5$var$isResponseFileItem(fileItem)) prev[key] = {
            ...fileItem.details,
            metadataTraceContext: fileItem.metadataTraceContext
        };
        else prev[key] = {
            id: id,
            collection: collection,
            type: 'not-found',
            metadataTraceContext: fileItem.metadataTraceContext
        };
        return prev;
    }, {});
    return dataloaderKeys.map((dataloaderKey)=>{
        const { id: id, collectionName: collectionName } = dataloaderKey;
        const key = $611f84914cb6f1a5$var$makeCacheKey(id, collectionName);
        return itemsByKey[key] || {
            id: id,
            type: 'not-found'
        };
    });
};
function $611f84914cb6f1a5$export$4a53beb129e8c49a(mediaStore) {
    return async (keys)=>{
        const nonCollectionName = '__media-single-file-collection__';
        const includeHashByCollection = keys.reduce((acc, key)=>{
            const collectionName = key.collectionName || nonCollectionName;
            if (key.includeHashForDuplicateFiles) acc[collectionName] = key.includeHashForDuplicateFiles;
            return acc;
        }, {});
        const fileIdsByCollection = keys.reduce((acc, key)=>{
            const collectionName = key.collectionName || nonCollectionName;
            const fileIds = acc[collectionName] || [];
            // de-duplicate ids in collection
            if (fileIds.indexOf(key.id) === -1) fileIds.push(key.id);
            acc[collectionName] = fileIds;
            return acc;
        }, {});
        const items = [];
        await Promise.all(Object.keys(fileIdsByCollection).map(async (collectionNameKey)=>{
            const metadataTraceContext = {
                traceId: (0, $3xaEP.getRandomTelemetryId)(),
                spanId: (0, $3xaEP.getRandomTelemetryId)()
            };
            const fileIds = fileIdsByCollection[collectionNameKey];
            const includeHashForDuplicateFiles = includeHashByCollection[collectionNameKey];
            const collectionName = collectionNameKey === nonCollectionName ? undefined : collectionNameKey;
            try {
                const response = await mediaStore.getItems(fileIds, collectionName, metadataTraceContext, includeHashForDuplicateFiles);
                const itemsWithMetadataTraceContext = response.data.items.map((item)=>({
                        ...item,
                        metadataTraceContext: metadataTraceContext
                    }));
                items.push(...itemsWithMetadataTraceContext);
                // add EmptyResponseFileItem for each file ID not included in /items response
                const itemsIds = itemsWithMetadataTraceContext.map((item)=>item.id);
                const fileIdsNotFound = fileIds.filter((id)=>!itemsIds.includes(id));
                fileIdsNotFound.forEach((fileId)=>{
                    items.push({
                        id: fileId,
                        collection: collectionName,
                        type: 'not-found',
                        metadataTraceContext: metadataTraceContext
                    });
                });
            } catch (error) {
                fileIds.forEach((fileId)=>{
                    items.push({
                        id: fileId,
                        collection: collectionName,
                        error: error
                    });
                });
            }
        }));
        return $611f84914cb6f1a5$export$71cd2e8f8162d47b(keys, items);
    };
}
function $611f84914cb6f1a5$export$ae188fee39529b82(mediaStore) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($79KwK)))($611f84914cb6f1a5$export$4a53beb129e8c49a(mediaStore), {
        maxBatchSize: $611f84914cb6f1a5$export$b79d95ee17a87a
    });
}

});

parcelRegister("atDjN", function(module, exports) {

$parcel$export(module.exports, "getMediaTypeFromUploadableFile", () => $4c3ee7170cb316c1$export$ac3214931ffd82af);

var $5JVfG = parcelRequire("5JVfG");
const $4c3ee7170cb316c1$export$ac3214931ffd82af = (file)=>{
    if (file.content instanceof Blob) {
        const type = file.content.type;
        return (0, $5JVfG.getMediaTypeFromMimeType)(type);
    } else return 'unknown';
};

});
parcelRegister("5JVfG", function(module, exports) {

$parcel$export(module.exports, "getMediaTypeFromMimeType", () => $2a0d3eeca821ff8d$export$79e1dc0d1801e8ef);
$parcel$export(module.exports, "isImageMimeTypeSupportedByBrowser", () => (parcelRequire("fK3MF")).isImageMimeTypeSupportedByBrowser);
$parcel$export(module.exports, "isVideoMimeTypeSupportedByBrowser", () => (parcelRequire("fK3MF")).isVideoMimeTypeSupportedByBrowser);

var $5hd6w = parcelRequire("5hd6w");

var $fK3MF = parcelRequire("fK3MF");

var $i9yw1 = parcelRequire("i9yw1");
const $2a0d3eeca821ff8d$export$79e1dc0d1801e8ef = (mimeType)=>{
    if ((0, $5hd6w.isArchive)(mimeType)) return 'archive';
    if ((0, $fK3MF.isImageMimeTypeSupportedByBrowser)(mimeType) || (0, $i9yw1.isImageMimeTypeSupportedByServer)(mimeType)) return 'image';
    if ((0, $fK3MF.isDocumentMimeTypeSupportedByBrowser)(mimeType) || (0, $i9yw1.isDocumentMimeTypeSupportedByServer)(mimeType)) return 'doc';
    if ((0, $fK3MF.isAudioMimeTypeSupportedByBrowser)(mimeType) || (0, $i9yw1.isAudioMimeTypeSupportedByServer)(mimeType)) return 'audio';
    if ((0, $fK3MF.isVideoMimeTypeSupportedByBrowser)(mimeType) || (0, $i9yw1.isVideoMimeTypeSupportedByServer)(mimeType)) return 'video';
    return 'unknown';
};

});
parcelRegister("5hd6w", function(module, exports) {

$parcel$export(module.exports, "isArchive", () => $d95d3f124d05d5e2$export$f47f3fe506e20fe6);
// Based on https://en.wikipedia.org/wiki/List_of_archive_formats
const $d95d3f124d05d5e2$export$f47f3fe506e20fe6 = (mimeType)=>[
        'application/x-archive',
        'application/x-cpio',
        'application/x-shar',
        'application/x-iso9660-image',
        'application/x-sbx',
        'application/x-tar',
        'application/x-bzip2',
        'application/gzip',
        'application/x-gzip',
        'application/x-lzip',
        'application/x-lzma',
        'application/x-lzop',
        'application/x-snappy-framed',
        'application/x-xz',
        'application/x-compress',
        'application/zstd',
        'application/x-7z-compressed',
        'application/x-ace-compressed',
        'application/x-astrotite-afa',
        'application/x-alz-compressed',
        'application/vnd.android.package-archive',
        'application/x-freearc',
        'application/x-arj',
        'application/x-b1',
        'application/vnd.ms-cab-compressed',
        'application/x-cfs-compressed',
        'application/x-dar',
        'application/x-dgc-compressed',
        'application/x-apple-diskimage',
        'application/x-gca-compressed',
        'application/java-archive',
        'application/x-lzh',
        'application/x-lzx',
        'application/x-rar-compressed',
        'application/x-stuffit',
        'application/x-stuffitx',
        'application/x-gtar',
        'application/x-ms-wim',
        'application/x-xar',
        'application/zip',
        'application/x-zoo',
        'application/x-par2'
    ].indexOf(mimeType.toLowerCase()) > -1;

});

parcelRegister("fK3MF", function(module, exports) {

$parcel$export(module.exports, "isImageMimeTypeSupportedByBrowser", () => $14d0a1fe72c887af$export$c021f2623a75015f);
$parcel$export(module.exports, "isDocumentMimeTypeSupportedByBrowser", () => $14d0a1fe72c887af$export$74325e3c843a9555);
$parcel$export(module.exports, "isAudioMimeTypeSupportedByBrowser", () => $14d0a1fe72c887af$export$ff36075ea755a717);
$parcel$export(module.exports, "isVideoMimeTypeSupportedByBrowser", () => $14d0a1fe72c887af$export$87bf945cf31ec2d9);
$parcel$export(module.exports, "isMimeTypeSupportedByBrowser", () => $14d0a1fe72c887af$export$55ca6cdaf6093034);
// Based on https://developer.mozilla.org/en-US/docs/Web/Media/Formats/Image_types
const $14d0a1fe72c887af$export$c021f2623a75015f = (mimeType)=>[
        'image/apng',
        'image/bmp',
        'image/gif',
        'image/x-icon',
        'image/jpeg',
        'image/png',
        'image/webp'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $14d0a1fe72c887af$export$74325e3c843a9555 = (mimeType)=>mimeType.toLowerCase() === 'application/pdf';
const $14d0a1fe72c887af$export$ff36075ea755a717 = (mimeType)=>[
        'audio/aac',
        'audio/flac',
        'audio/mp4',
        'audio/mpeg',
        'audio/ogg',
        'audio/x-ogg',
        'audio/wav',
        'audio/x-wav'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $14d0a1fe72c887af$export$87bf945cf31ec2d9 = (mimeType)=>[
        'video/mp4',
        'video/quicktime'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $14d0a1fe72c887af$export$55ca6cdaf6093034 = (mimeType)=>$14d0a1fe72c887af$export$74325e3c843a9555(mimeType) || $14d0a1fe72c887af$export$c021f2623a75015f(mimeType) || $14d0a1fe72c887af$export$ff36075ea755a717(mimeType) || $14d0a1fe72c887af$export$87bf945cf31ec2d9(mimeType);

});

parcelRegister("i9yw1", function(module, exports) {

$parcel$export(module.exports, "isImageMimeTypeSupportedByServer", () => $b92ae6a0fa1244e6$export$e9a065a80f76311e);
$parcel$export(module.exports, "isDocumentMimeTypeSupportedByServer", () => $b92ae6a0fa1244e6$export$86baad7a89d908e9);
$parcel$export(module.exports, "isAudioMimeTypeSupportedByServer", () => $b92ae6a0fa1244e6$export$8cba23825d020bbb);
$parcel$export(module.exports, "isVideoMimeTypeSupportedByServer", () => $b92ae6a0fa1244e6$export$9c2b4de5fdca2ce3);
$parcel$export(module.exports, "isMimeTypeSupportedByServer", () => $b92ae6a0fa1244e6$export$548d9148a80556a3);
// Based on https://developer.atlassian.com/platform/media/learning/file-previews/
const $b92ae6a0fa1244e6$export$e9a065a80f76311e = (mimeType)=>[
        'image/bmp',
        'image/x-windows-bmp',
        'application/dicom',
        'image/gif',
        'image/jpeg',
        'image/jpg',
        'image/jp_',
        'application/jpg',
        'application/x-jpg',
        'image/png',
        'application/png',
        'application/x-png',
        'application/vnd.adobe.photoshop',
        'image/vnd.adobe.photoshop',
        'image/photoshop',
        'image/x-photoshop',
        'image/psd',
        'application/photoshop',
        'application/psd',
        'zz-application/zz-winassoc-psd',
        'image/tiff',
        'image/x-tif',
        'image/x-tiff',
        'application/tif',
        'application/x-tif',
        'application/tiff',
        'application/x-tiff',
        'image/svg+xml',
        'image/heif',
        'image/heif-sequence',
        'image/heic',
        'image/heic-sequence'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $b92ae6a0fa1244e6$export$86baad7a89d908e9 = (mimeType)=>[
        // Adobe PDF
        'application/pdf',
        'application/x-pdf',
        'application/acrobat',
        'applications/vnd.pdf',
        'text/pdf',
        'text/x-pdf',
        // Adobe Illustrator
        'application/vnd.adobe.illustrator',
        // Microsoft Office
        'application/vnd.ms-office',
        // Microsoft Word
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
        'application/vnd.ms-word.document.macroenabled.12',
        'application/vnd.ms-word.template.macroenabled.12',
        // Microsoft Excel
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
        'application/vnd.ms-excel.sheet.macroenabled.12',
        'application/vnd.ms-excel.template.macroenabled.12',
        'application/vnd.ms-excel.addin.macroenabled.12',
        'application/vnd.ms-excel.sheet.macroenabled',
        'application/vnd.ms-excel.template.macroenabled',
        'application/vnd.ms-excel.addin.macroenabled',
        // Microsoft Powerpoint
        'application/vnd.ms-powerpoint',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        'application/vnd.openxmlformats-officedocument.presentationml.template',
        'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
        'application/vnd.ms-powerpoint.presentation.macroenabled.12',
        'application/vnd.ms-powerpoint.template.macroenabled.12',
        'application/vnd.ms-powerpoint.slideshow.macroenabled.12',
        // OpenOffice
        'application/vnd.sun.xml.writer',
        'application/vnd.sun.xml.writer.template',
        // OpenDocument
        'application/vnd.sun.xml.draw',
        'application/vnd.sun.xml.draw.template',
        'application/vnd.oasis.opendocument.graphics',
        'application/vnd.oasis.opendocument.presentation',
        'application/x-vnd.oasis.opendocument.presentation',
        'application/vnd.sun.xml.calc',
        'application/vnd.sun.xml.calc.template',
        'application/vnd.oasis.opendocument.spreadsheet',
        'application/x-vnd.oasis.opendocument.spreadsheet',
        'application/vnd.oasis.opendocument.spreadsheet-template',
        'application/vnd.oasis.opendocument.text',
        'application/vnd.oasis.opendocument.text-template',
        'application/vnd.oasis.opendocument.text-master',
        'application/x-vnd.oasis.opendocument.text',
        'application/x-vnd.oasis.opendocument.text-template',
        'application/x-vnd.oasis.opendocument.text-master',
        // WordPerfect
        'application/vnd.wordperfect',
        // Text files
        'text/csv',
        'text/x-diff',
        'text/x-perl',
        'text/x-python',
        'text/x-ruby',
        'text/rtf',
        'text/richtext',
        'text/plain',
        'application/txt',
        // Rich text
        'application/rtf',
        'application/x-rtf',
        // PostScript
        'application/postscript'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $b92ae6a0fa1244e6$export$8cba23825d020bbb = (mimeType)=>[
        'audio/aac',
        'audio/x-hx-aac-adts',
        'audio/vnd.dolby.dd-raw',
        'audio/aiff',
        'audio/x-aiff',
        'audio/x-monkeys-audio',
        'audio/x-ape',
        'audio/basic',
        'audio/flac',
        'audio/mp4',
        'audio/midi',
        'audio/x-matroska',
        'audio/x-mod',
        'audio/mpeg',
        'audio/ogg',
        'audio/x-ogg',
        'audio/x-pn-realaudio',
        'audio/wav',
        'audio/x-wav',
        'audio/x-ms-wma'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $b92ae6a0fa1244e6$export$9c2b4de5fdca2ce3 = (mimeType)=>[
        'video/3gpp',
        'video/3gpp2',
        'video/x-ms-asf',
        'video/avi',
        'video/msvideo',
        'video/x-msvideo',
        'video/x-dv',
        'video/x-flv',
        'video/m2ts',
        'video/x-m4v',
        'video/x-matroska',
        'video/quicktime',
        'video/mp4',
        'video/mpeg',
        'video/ogg',
        'video/x-ogg',
        'video/webm',
        'video/x-ms-wmv'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $b92ae6a0fa1244e6$export$94e1479e01d2af53 = (mimeType)=>[
        'binary/octet-stream'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $b92ae6a0fa1244e6$export$548d9148a80556a3 = (mimeType)=>$b92ae6a0fa1244e6$export$e9a065a80f76311e(mimeType) || $b92ae6a0fa1244e6$export$86baad7a89d908e9(mimeType) || $b92ae6a0fa1244e6$export$8cba23825d020bbb(mimeType) || $b92ae6a0fa1244e6$export$9c2b4de5fdca2ce3(mimeType) || $b92ae6a0fa1244e6$export$94e1479e01d2af53(mimeType);

});



parcelRegister("053B3", function(module, exports) {

$parcel$export(module.exports, "overrideMediaTypeIfUnknown", () => $492d4a64b2b2425c$export$89097c0ec1e0dee1);

var $bbNl0 = parcelRequire("bbNl0");
const $492d4a64b2b2425c$export$89097c0ec1e0dee1 = (fileState, mediaType)=>{
    if (!(0, $bbNl0.isErrorFileState)(fileState) && fileState.mediaType === 'unknown') return {
        mediaType: mediaType
    };
    return {};
};

});

parcelRegister("iDYg8", function(module, exports) {

$parcel$export(module.exports, "convertBase64ToBlob", () => $87b4c423efa40e5c$export$ed17558b11b88056);
const $87b4c423efa40e5c$export$ed17558b11b88056 = (base64)=>{
    const sliceSize = 512;
    const base64Data = base64.split(',')[1];
    const byteCharacters = atob(base64Data);
    const byteArrays = [];
    for(let offset = 0; offset < byteCharacters.length; offset += sliceSize){
        const slice = byteCharacters.slice(offset, offset + sliceSize);
        const byteNumbers = slice.split('').map((_, i)=>slice.charCodeAt(i));
        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }
    return new Blob(byteArrays, {
        type: 'image/jpeg'
    });
};

});

parcelRegister("jFXx8", function(module, exports) {

$parcel$export(module.exports, "fromObservable", () => $a6ac257ab8a71611$export$4b2432e2d8723823);

var $jkEmk = parcelRequire("jkEmk");
function $a6ac257ab8a71611$export$4b2432e2d8723823(observable) {
    return {
        subscribe: (observer)=>{
            const subscription = // This is needed to handle "subscribe" function overload.
            // It allows accepting a single "next" callback function as an argument.
            observer instanceof Function ? observable.subscribe(observer) : observable.subscribe(observer);
            return {
                unsubscribe: ()=>{
                    subscription.unsubscribe();
                }
            };
        }
    };
}
function $a6ac257ab8a71611$export$8659d1f07d151381(item) {
    return $a6ac257ab8a71611$export$4b2432e2d8723823((0, $jkEmk.createMediaSubject)(item));
}

});
parcelRegister("jkEmk", function(module, exports) {

$parcel$export(module.exports, "createMediaSubject", () => $5f3a872941d2eff3$export$bc76d51553fa5e35);

var $86Sof = parcelRequire("86Sof");
function $5f3a872941d2eff3$export$bc76d51553fa5e35(initialState) {
    const subject = new (0, $86Sof.ReplaySubject)(1);
    if (initialState instanceof Error) subject.error(initialState);
    else if (initialState) subject.next(initialState);
    return subject;
}

});


parcelRegister("kFG4u", function(module, exports) {

$parcel$export(module.exports, "toPromise", () => $74eb9133065f0126$export$4dbaaf6c79705e6c);

var $2PBDa = parcelRequire("2PBDa");
const $74eb9133065f0126$export$4dbaaf6c79705e6c = (mediaSubscribable, subscription = new (0, $2PBDa.Subscription)())=>new Promise((resolve, reject)=>subscription.add(mediaSubscribable.subscribe({
            next: (state)=>{
                resolve(state);
                subscription.unsubscribe();
            },
            error: (error)=>{
                reject(error);
                subscription.unsubscribe();
            }
        })));

});

parcelRegister("ea8A0", function(module, exports) {

$parcel$export(module.exports, "getDimensionsFromBlob", () => $2f9cb480159d13ae$export$71797c284d89a3e1);

var $hthqT = parcelRequire("hthqT");

var $gOskN = parcelRequire("gOskN");
const $2f9cb480159d13ae$export$71797c284d89a3e1 = async (mediaType, blob)=>{
    switch(mediaType){
        case 'image':
            {
                const url = URL.createObjectURL(blob);
                try {
                    return await (0, $hthqT.getImageDimensionsFromBlob)(url);
                } finally{
                    URL.revokeObjectURL(url);
                }
            }
        case 'video':
            return (0, $gOskN.getVideoDimensionsFromBlob)(blob);
        default:
            throw new Error(`Can't extract dimensions from ${mediaType}`);
    }
};

});
parcelRegister("hthqT", function(module, exports) {

$parcel$export(module.exports, "getImageDimensionsFromBlob", () => $d7d48590d371ba3a$export$a1c3205f28a20414);
const $d7d48590d371ba3a$export$a1c3205f28a20414 = (url)=>new Promise((resolve, reject)=>{
        const img = new Image();
        img.src = url;
        img.onload = ()=>resolve({
                width: img.width,
                height: img.height
            });
        img.onerror = reject;
    });

});

parcelRegister("gOskN", function(module, exports) {

$parcel$export(module.exports, "getVideoDimensionsFromBlob", () => $4a8128b4320ca47f$export$62aabd5ff85d0451);
const $4a8128b4320ca47f$export$62aabd5ff85d0451 = async (blob)=>{
    return new Promise((resolve, reject)=>{
        const url = URL.createObjectURL(blob);
        const video = document.createElement('video');
        video.preload = 'metadata';
        video.src = url;
        video.muted = true;
        // loadedmetadata, loadeddata, play, playing
        video.addEventListener('loadedmetadata', function timeupdateHandler() {
            video.removeEventListener('loadedmetadata', timeupdateHandler);
            resolve({
                width: video.videoWidth,
                height: video.videoHeight
            });
            URL.revokeObjectURL(url);
        });
        video.addEventListener('error', ()=>{
            reject(new Error('failed to load video'));
            URL.revokeObjectURL(url);
        });
    });
};

});


parcelRegister("8UZz3", function(module, exports) {

$parcel$export(module.exports, "shouldFetchRemoteFileStates", () => $d7014b773fe3cff6$export$2ccdd6f9a9eba6a);

var $fK3MF = parcelRequire("fK3MF");
var $i9yw1 = parcelRequire("i9yw1");

var $gOskN = parcelRequire("gOskN");
async function $d7014b773fe3cff6$export$2ccdd6f9a9eba6a(mediaType, mimeType, preview) {
    if ((mediaType === 'doc' || !(0, $fK3MF.isMimeTypeSupportedByBrowser)(mimeType) || !preview) && (0, $i9yw1.isMimeTypeSupportedByServer)(mimeType)) return true;
    if (mediaType === 'video' && !!preview) {
        const content = (await preview).value;
        if (!(content instanceof Blob)) return false;
        try {
            const { width: width, height: height } = await (0, $gOskN.getVideoDimensionsFromBlob)(content);
            return !width && !height;
        } catch (e) {
            // any exception from getVideoDimensionsFromBlob() may imply that local video isn't playable
            // hence we'll need remote fileStates to grab a "processed" video
            return true;
        }
    }
    return false;
}

});

parcelRegister("393Zn", function(module, exports) {

$parcel$export(module.exports, "PollingFunction", () => $10b695ec33f62c2d$export$4c54d536f8e37dc2);

var $8iexj = parcelRequire("8iexj");
const $10b695ec33f62c2d$export$9f15a162d6785fc9 = {
    poll_intervalMs: 3000,
    poll_maxAttempts: 30,
    poll_backoffFactor: 1.25,
    poll_maxIntervalMs: 200000
};
class $10b695ec33f62c2d$export$4c54d536f8e37dc2 {
    constructor(options){
        this.poll_intervalMs = 0;
        this.attempt = 1;
        this.shouldIterate = true;
        this.timeoutId = 0;
        this.options = {
            ...$10b695ec33f62c2d$export$9f15a162d6785fc9,
            ...options
        };
        this.poll_intervalMs = this.options.poll_intervalMs;
    }
    async execute(executor) {
        const { poll_maxAttempts: poll_maxAttempts } = this.options;
        if (poll_maxAttempts === 0) // hard kill, polling disabled
        return this.fail(new (0, $8iexj.PollingError)('pollingMaxAttemptsExceeded', {
            attempts: this.attempt
        }));
        try {
            // executor must explicitly call this.next() for triggering next iteration (pull)
            this.shouldIterate = false;
            await executor();
            if (!this.shouldIterate) return;
            if (this.attempt >= poll_maxAttempts) // max iterations exceeded, let the consumer know
            return this.fail(new (0, $8iexj.PollingError)('pollingMaxAttemptsExceeded', {
                attempts: this.attempt
            }));
            this.poll_intervalMs = this.getIntervalMsForIteration(this.attempt);
            this.attempt++;
            this.timeoutId = window.setTimeout(()=>this.execute(executor), this.poll_intervalMs);
        } catch (error) {
            this.fail(error);
        }
    }
    fail(error) {
        const { onError: onError } = this;
        this.cancel();
        onError && onError(error);
    }
    getIntervalMsForIteration(iteration) {
        let poll_intervalMs = this.options.poll_intervalMs;
        if (iteration === 1) return poll_intervalMs;
        for(let i = 2; i <= iteration; i++)poll_intervalMs = poll_intervalMs * this.options.poll_backoffFactor;
        return Math.min(Math.round(poll_intervalMs), this.options.poll_maxIntervalMs);
    }
    next() {
        this.shouldIterate = true;
    }
    cancel() {
        window.clearTimeout(this.timeoutId);
        this.timeoutId = 0;
    }
}

});
parcelRegister("8iexj", function(module, exports) {

$parcel$export(module.exports, "PollingError", () => $76319a6a54892893$export$c3748c310e92340a);

var $4rKJa = parcelRequire("4rKJa");
class $76319a6a54892893$export$c3748c310e92340a extends (0, $4rKJa.BaseMediaClientError) {
    constructor(reason, metadata){
        super(reason, metadata, undefined);
    }
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ get attributes() {
        const { reason: reason, metadata: { attempts: attempts } } = this;
        return {
            reason: reason,
            attempts: attempts
        };
    }
}
function $76319a6a54892893$export$541e3e52eea6fece(err) {
    return err instanceof $76319a6a54892893$export$c3748c310e92340a;
}

});


parcelRegister("iX2Cl", function(module, exports) {

$parcel$export(module.exports, "isEmptyFile", () => $0723e6aaf9777481$export$728192ce8dd94659);
const $0723e6aaf9777481$export$d32fc52697b2ec92 = 43200000; /* 12 hours */ 
function $0723e6aaf9777481$export$728192ce8dd94659(fileDetails, now = Date.now()) {
    const { artifacts: artifacts, mediaType: mediaType, mimeType: mimeType, name: name, processingStatus: processingStatus, representations: representations, size: size, createdAt: createdAt } = fileDetails;
    if (!artifacts && !mediaType && !mimeType && !name && !processingStatus && !representations && !size && typeof createdAt === 'number') {
        const msSinceFileCreation = now - createdAt;
        if (msSinceFileCreation > $0723e6aaf9777481$export$d32fc52697b2ec92) return true;
    }
    return false;
}

});

parcelRegister("48hWz", function(module, exports) {

$parcel$export(module.exports, "mediaStore", () => (parcelRequire("1ZNSP")).mediaStore);

var $1ZNSP = parcelRequire("1ZNSP");

});
parcelRegister("1ZNSP", function(module, exports) {

$parcel$export(module.exports, "mediaStore", () => $8cb4e2ad5e722a42$export$5785580dea19518d);

var $7LOiC = parcelRequire("7LOiC");

var $1pZVO = parcelRequire("1pZVO");

var $96y8R = parcelRequire("96y8R");
const $8cb4e2ad5e722a42$var$mediaStoreWithoutDevtools = (0, $96y8R.createStore)()((0, $7LOiC.subscribeWithSelector)((0, $1pZVO.immer)(()=>({
        files: {}
    }))));
const $8cb4e2ad5e722a42$var$mediaStoreWithDevtools = (0, $96y8R.createStore)()((0, $7LOiC.devtools)((0, $7LOiC.subscribeWithSelector)((0, $1pZVO.immer)(()=>({
        files: {}
    })))));
const $8cb4e2ad5e722a42$export$5785580dea19518d = $8cb4e2ad5e722a42$var$mediaStoreWithoutDevtools;
const $8cb4e2ad5e722a42$export$503459913a0dc356 = (initialStore)=>{
    return (0, $96y8R.createStore)()((0, $7LOiC.subscribeWithSelector)((0, $1pZVO.immer)(()=>({
            files: {},
            ...initialStore
        }))));
};

});
parcelRegister("7LOiC", function(module, exports) {

$parcel$export(module.exports, "devtools", () => $5a83f092dca5fc3e$export$6922d3b3a607469e);
$parcel$export(module.exports, "subscribeWithSelector", () => $5a83f092dca5fc3e$export$5c593627aef9f076);
var $5a83f092dca5fc3e$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/zustand/esm/middleware.mjs"
});
const $5a83f092dca5fc3e$var$reduxImpl = (reducer, initial)=>(set, _get, api)=>{
        api.dispatch = (action)=>{
            set((state)=>reducer(state, action), false, action);
            return action;
        };
        api.dispatchFromDevtools = true;
        return {
            dispatch: (...a)=>api.dispatch(...a),
            ...initial
        };
    };
const $5a83f092dca5fc3e$export$4feba8a1bc8e9afd = $5a83f092dca5fc3e$var$reduxImpl;
const $5a83f092dca5fc3e$var$trackedConnections = /* @__PURE__ */ new Map();
const $5a83f092dca5fc3e$var$getTrackedConnectionState = (name)=>{
    const api = $5a83f092dca5fc3e$var$trackedConnections.get(name);
    if (!api) return {};
    return Object.fromEntries(Object.entries(api.stores).map(([key, api2])=>[
            key,
            api2.getState()
        ]));
};
const $5a83f092dca5fc3e$var$extractConnectionInformation = (store, extensionConnector, options)=>{
    if (store === void 0) return {
        type: "untracked",
        connection: extensionConnector.connect(options)
    };
    const existingConnection = $5a83f092dca5fc3e$var$trackedConnections.get(options.name);
    if (existingConnection) return {
        type: "tracked",
        store: store,
        ...existingConnection
    };
    const newConnection = {
        connection: extensionConnector.connect(options),
        stores: {}
    };
    $5a83f092dca5fc3e$var$trackedConnections.set(options.name, newConnection);
    return {
        type: "tracked",
        store: store,
        ...newConnection
    };
};
const $5a83f092dca5fc3e$var$devtoolsImpl = (fn, devtoolsOptions = {})=>(set, get, api)=>{
        const { enabled: enabled, anonymousActionType: anonymousActionType, store: store, ...options } = devtoolsOptions;
        let extensionConnector;
        try {
            extensionConnector = (enabled != null ? enabled : ($5a83f092dca5fc3e$import_meta.env ? $5a83f092dca5fc3e$import_meta.env.MODE : void 0) !== "production") && window.__REDUX_DEVTOOLS_EXTENSION__;
        } catch (_e) {}
        if (!extensionConnector) {
            if (($5a83f092dca5fc3e$import_meta.env ? $5a83f092dca5fc3e$import_meta.env.MODE : void 0) !== "production" && enabled) console.warn("[zustand devtools middleware] Please install/enable Redux devtools extension");
            return fn(set, get, api);
        }
        const { connection: connection, ...connectionInformation } = $5a83f092dca5fc3e$var$extractConnectionInformation(store, extensionConnector, options);
        let isRecording = true;
        api.setState = (state, replace, nameOrAction)=>{
            const r = set(state, replace);
            if (!isRecording) return r;
            const action = nameOrAction === void 0 ? {
                type: anonymousActionType || "anonymous"
            } : typeof nameOrAction === "string" ? {
                type: nameOrAction
            } : nameOrAction;
            if (store === void 0) {
                connection == null || connection.send(action, get());
                return r;
            }
            connection == null || connection.send({
                ...action,
                type: `${store}/${action.type}`
            }, {
                ...$5a83f092dca5fc3e$var$getTrackedConnectionState(options.name),
                [store]: api.getState()
            });
            return r;
        };
        const setStateFromDevtools = (...a)=>{
            const originalIsRecording = isRecording;
            isRecording = false;
            set(...a);
            isRecording = originalIsRecording;
        };
        const initialState = fn(api.setState, get, api);
        if (connectionInformation.type === "untracked") connection == null || connection.init(initialState);
        else {
            connectionInformation.stores[connectionInformation.store] = api;
            connection == null || connection.init(Object.fromEntries(Object.entries(connectionInformation.stores).map(([key, store2])=>[
                    key,
                    key === connectionInformation.store ? initialState : store2.getState()
                ])));
        }
        if (api.dispatchFromDevtools && typeof api.dispatch === "function") {
            let didWarnAboutReservedActionType = false;
            const originalDispatch = api.dispatch;
            api.dispatch = (...a)=>{
                if (($5a83f092dca5fc3e$import_meta.env ? $5a83f092dca5fc3e$import_meta.env.MODE : void 0) !== "production" && a[0].type === "__setState" && !didWarnAboutReservedActionType) {
                    console.warn('[zustand devtools middleware] "__setState" action type is reserved to set state from the devtools. Avoid using it.');
                    didWarnAboutReservedActionType = true;
                }
                originalDispatch(...a);
            };
        }
        connection.subscribe((message)=>{
            var _a;
            switch(message.type){
                case "ACTION":
                    if (typeof message.payload !== "string") {
                        console.error("[zustand devtools middleware] Unsupported action format");
                        return;
                    }
                    return $5a83f092dca5fc3e$var$parseJsonThen(message.payload, (action)=>{
                        if (action.type === "__setState") {
                            if (store === void 0) {
                                setStateFromDevtools(action.state);
                                return;
                            }
                            if (Object.keys(action.state).length !== 1) console.error(`
                    [zustand devtools middleware] Unsupported __setState action format. 
                    When using 'store' option in devtools(), the 'state' should have only one key, which is a value of 'store' that was passed in devtools(),
                    and value of this only key should be a state object. Example: { "type": "__setState", "state": { "abc123Store": { "foo": "bar" } } }
                    `);
                            const stateFromDevtools = action.state[store];
                            if (stateFromDevtools === void 0 || stateFromDevtools === null) return;
                            if (JSON.stringify(api.getState()) !== JSON.stringify(stateFromDevtools)) setStateFromDevtools(stateFromDevtools);
                            return;
                        }
                        if (!api.dispatchFromDevtools) return;
                        if (typeof api.dispatch !== "function") return;
                        api.dispatch(action);
                    });
                case "DISPATCH":
                    switch(message.payload.type){
                        case "RESET":
                            setStateFromDevtools(initialState);
                            if (store === void 0) return connection == null ? void 0 : connection.init(api.getState());
                            return connection == null ? void 0 : connection.init($5a83f092dca5fc3e$var$getTrackedConnectionState(options.name));
                        case "COMMIT":
                            if (store === void 0) {
                                connection == null || connection.init(api.getState());
                                return;
                            }
                            return connection == null ? void 0 : connection.init($5a83f092dca5fc3e$var$getTrackedConnectionState(options.name));
                        case "ROLLBACK":
                            return $5a83f092dca5fc3e$var$parseJsonThen(message.state, (state)=>{
                                if (store === void 0) {
                                    setStateFromDevtools(state);
                                    connection == null || connection.init(api.getState());
                                    return;
                                }
                                setStateFromDevtools(state[store]);
                                connection == null || connection.init($5a83f092dca5fc3e$var$getTrackedConnectionState(options.name));
                            });
                        case "JUMP_TO_STATE":
                        case "JUMP_TO_ACTION":
                            return $5a83f092dca5fc3e$var$parseJsonThen(message.state, (state)=>{
                                if (store === void 0) {
                                    setStateFromDevtools(state);
                                    return;
                                }
                                if (JSON.stringify(api.getState()) !== JSON.stringify(state[store])) setStateFromDevtools(state[store]);
                            });
                        case "IMPORT_STATE":
                            {
                                const { nextLiftedState: nextLiftedState } = message.payload;
                                const lastComputedState = (_a = nextLiftedState.computedStates.slice(-1)[0]) == null ? void 0 : _a.state;
                                if (!lastComputedState) return;
                                if (store === void 0) setStateFromDevtools(lastComputedState);
                                else setStateFromDevtools(lastComputedState[store]);
                                connection == null || connection.send(null, // FIXME no-any
                                nextLiftedState);
                                return;
                            }
                        case "PAUSE_RECORDING":
                            return isRecording = !isRecording;
                    }
                    return;
            }
        });
        return initialState;
    };
const $5a83f092dca5fc3e$export$6922d3b3a607469e = $5a83f092dca5fc3e$var$devtoolsImpl;
const $5a83f092dca5fc3e$var$parseJsonThen = (stringified, f)=>{
    let parsed;
    try {
        parsed = JSON.parse(stringified);
    } catch (e) {
        console.error("[zustand devtools middleware] Could not parse the received json", e);
    }
    if (parsed !== void 0) f(parsed);
};
const $5a83f092dca5fc3e$var$subscribeWithSelectorImpl = (fn)=>(set, get, api)=>{
        const origSubscribe = api.subscribe;
        api.subscribe = (selector, optListener, options)=>{
            let listener = selector;
            if (optListener) {
                const equalityFn = (options == null ? void 0 : options.equalityFn) || Object.is;
                let currentSlice = selector(api.getState());
                listener = (state)=>{
                    const nextSlice = selector(state);
                    if (!equalityFn(currentSlice, nextSlice)) {
                        const previousSlice = currentSlice;
                        optListener(currentSlice = nextSlice, previousSlice);
                    }
                };
                if (options == null ? void 0 : options.fireImmediately) optListener(currentSlice, currentSlice);
            }
            return origSubscribe(listener);
        };
        const initialState = fn(set, get, api);
        return initialState;
    };
const $5a83f092dca5fc3e$export$5c593627aef9f076 = $5a83f092dca5fc3e$var$subscribeWithSelectorImpl;
const $5a83f092dca5fc3e$export$1be1fc439b849fdf = (initialState, create)=>(...a)=>Object.assign({}, initialState, create(...a));
function $5a83f092dca5fc3e$export$95a3b7b12ab518f9(getStorage, options) {
    let storage;
    try {
        storage = getStorage();
    } catch (_e) {
        return;
    }
    const persistStorage = {
        getItem: (name)=>{
            var _a;
            const parse = (str2)=>{
                if (str2 === null) return null;
                return JSON.parse(str2, options == null ? void 0 : options.reviver);
            };
            const str = (_a = storage.getItem(name)) != null ? _a : null;
            if (str instanceof Promise) return str.then(parse);
            return parse(str);
        },
        setItem: (name, newValue)=>storage.setItem(name, JSON.stringify(newValue, options == null ? void 0 : options.replacer)),
        removeItem: (name)=>storage.removeItem(name)
    };
    return persistStorage;
}
const $5a83f092dca5fc3e$var$toThenable = (fn)=>(input)=>{
        try {
            const result = fn(input);
            if (result instanceof Promise) return result;
            return {
                then (onFulfilled) {
                    return $5a83f092dca5fc3e$var$toThenable(onFulfilled)(result);
                },
                catch (_onRejected) {
                    return this;
                }
            };
        } catch (e) {
            return {
                then (_onFulfilled) {
                    return this;
                },
                catch (onRejected) {
                    return $5a83f092dca5fc3e$var$toThenable(onRejected)(e);
                }
            };
        }
    };
const $5a83f092dca5fc3e$var$oldImpl = (config, baseOptions)=>(set, get, api)=>{
        let options = {
            getStorage: ()=>localStorage,
            serialize: JSON.stringify,
            deserialize: JSON.parse,
            partialize: (state)=>state,
            version: 0,
            merge: (persistedState, currentState)=>({
                    ...currentState,
                    ...persistedState
                }),
            ...baseOptions
        };
        let hasHydrated = false;
        const hydrationListeners = /* @__PURE__ */ new Set();
        const finishHydrationListeners = /* @__PURE__ */ new Set();
        let storage;
        try {
            storage = options.getStorage();
        } catch (_e) {}
        if (!storage) return config((...args)=>{
            console.warn(`[zustand persist middleware] Unable to update item '${options.name}', the given storage is currently unavailable.`);
            set(...args);
        }, get, api);
        const thenableSerialize = $5a83f092dca5fc3e$var$toThenable(options.serialize);
        const setItem = ()=>{
            const state = options.partialize({
                ...get()
            });
            let errorInSync;
            const thenable = thenableSerialize({
                state: state,
                version: options.version
            }).then((serializedValue)=>storage.setItem(options.name, serializedValue)).catch((e)=>{
                errorInSync = e;
            });
            if (errorInSync) throw errorInSync;
            return thenable;
        };
        const savedSetState = api.setState;
        api.setState = (state, replace)=>{
            savedSetState(state, replace);
            setItem();
        };
        const configResult = config((...args)=>{
            set(...args);
            setItem();
        }, get, api);
        let stateFromStorage;
        const hydrate = ()=>{
            var _a;
            if (!storage) return;
            hasHydrated = false;
            hydrationListeners.forEach((cb)=>cb(get()));
            const postRehydrationCallback = ((_a = options.onRehydrateStorage) == null ? void 0 : _a.call(options, get())) || void 0;
            return $5a83f092dca5fc3e$var$toThenable(storage.getItem.bind(storage))(options.name).then((storageValue)=>{
                if (storageValue) return options.deserialize(storageValue);
            }).then((deserializedStorageValue)=>{
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) return options.migrate(deserializedStorageValue.state, deserializedStorageValue.version);
                        console.error(`State loaded from storage couldn't be migrated since no migrate function was provided`);
                    } else return deserializedStorageValue.state;
                }
            }).then((migratedState)=>{
                var _a2;
                stateFromStorage = options.merge(migratedState, (_a2 = get()) != null ? _a2 : configResult);
                set(stateFromStorage, true);
                return setItem();
            }).then(()=>{
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, void 0);
                hasHydrated = true;
                finishHydrationListeners.forEach((cb)=>cb(stateFromStorage));
            }).catch((e)=>{
                postRehydrationCallback == null || postRehydrationCallback(void 0, e);
            });
        };
        api.persist = {
            setOptions: (newOptions)=>{
                options = {
                    ...options,
                    ...newOptions
                };
                if (newOptions.getStorage) storage = newOptions.getStorage();
            },
            clearStorage: ()=>{
                storage == null || storage.removeItem(options.name);
            },
            getOptions: ()=>options,
            rehydrate: ()=>hydrate(),
            hasHydrated: ()=>hasHydrated,
            onHydrate: (cb)=>{
                hydrationListeners.add(cb);
                return ()=>{
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: (cb)=>{
                finishHydrationListeners.add(cb);
                return ()=>{
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        hydrate();
        return stateFromStorage || configResult;
    };
const $5a83f092dca5fc3e$var$newImpl = (config, baseOptions)=>(set, get, api)=>{
        let options = {
            storage: $5a83f092dca5fc3e$export$95a3b7b12ab518f9(()=>localStorage),
            partialize: (state)=>state,
            version: 0,
            merge: (persistedState, currentState)=>({
                    ...currentState,
                    ...persistedState
                }),
            ...baseOptions
        };
        let hasHydrated = false;
        const hydrationListeners = /* @__PURE__ */ new Set();
        const finishHydrationListeners = /* @__PURE__ */ new Set();
        let storage = options.storage;
        if (!storage) return config((...args)=>{
            console.warn(`[zustand persist middleware] Unable to update item '${options.name}', the given storage is currently unavailable.`);
            set(...args);
        }, get, api);
        const setItem = ()=>{
            const state = options.partialize({
                ...get()
            });
            return storage.setItem(options.name, {
                state: state,
                version: options.version
            });
        };
        const savedSetState = api.setState;
        api.setState = (state, replace)=>{
            savedSetState(state, replace);
            setItem();
        };
        const configResult = config((...args)=>{
            set(...args);
            setItem();
        }, get, api);
        api.getInitialState = ()=>configResult;
        let stateFromStorage;
        const hydrate = ()=>{
            var _a, _b;
            if (!storage) return;
            hasHydrated = false;
            hydrationListeners.forEach((cb)=>{
                var _a2;
                return cb((_a2 = get()) != null ? _a2 : configResult);
            });
            const postRehydrationCallback = ((_b = options.onRehydrateStorage) == null ? void 0 : _b.call(options, (_a = get()) != null ? _a : configResult)) || void 0;
            return $5a83f092dca5fc3e$var$toThenable(storage.getItem.bind(storage))(options.name).then((deserializedStorageValue)=>{
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) return [
                            true,
                            options.migrate(deserializedStorageValue.state, deserializedStorageValue.version)
                        ];
                        console.error(`State loaded from storage couldn't be migrated since no migrate function was provided`);
                    } else return [
                        false,
                        deserializedStorageValue.state
                    ];
                }
                return [
                    false,
                    void 0
                ];
            }).then((migrationResult)=>{
                var _a2;
                const [migrated, migratedState] = migrationResult;
                stateFromStorage = options.merge(migratedState, (_a2 = get()) != null ? _a2 : configResult);
                set(stateFromStorage, true);
                if (migrated) return setItem();
            }).then(()=>{
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, void 0);
                stateFromStorage = get();
                hasHydrated = true;
                finishHydrationListeners.forEach((cb)=>cb(stateFromStorage));
            }).catch((e)=>{
                postRehydrationCallback == null || postRehydrationCallback(void 0, e);
            });
        };
        api.persist = {
            setOptions: (newOptions)=>{
                options = {
                    ...options,
                    ...newOptions
                };
                if (newOptions.storage) storage = newOptions.storage;
            },
            clearStorage: ()=>{
                storage == null || storage.removeItem(options.name);
            },
            getOptions: ()=>options,
            rehydrate: ()=>hydrate(),
            hasHydrated: ()=>hasHydrated,
            onHydrate: (cb)=>{
                hydrationListeners.add(cb);
                return ()=>{
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: (cb)=>{
                finishHydrationListeners.add(cb);
                return ()=>{
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        if (!options.skipHydration) hydrate();
        return stateFromStorage || configResult;
    };
const $5a83f092dca5fc3e$var$persistImpl = (config, baseOptions)=>{
    if ("getStorage" in baseOptions || "serialize" in baseOptions || "deserialize" in baseOptions) {
        if (($5a83f092dca5fc3e$import_meta.env ? $5a83f092dca5fc3e$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] `getStorage`, `serialize` and `deserialize` options are deprecated. Use `storage` option instead.");
        return $5a83f092dca5fc3e$var$oldImpl(config, baseOptions);
    }
    return $5a83f092dca5fc3e$var$newImpl(config, baseOptions);
};
const $5a83f092dca5fc3e$export$9a6132153fba2e0 = $5a83f092dca5fc3e$var$persistImpl;

});

parcelRegister("1pZVO", function(module, exports) {

$parcel$export(module.exports, "immer", () => $10882a850d9663b5$export$428de7ec69ac95c);

var $K2rwM = parcelRequire("K2rwM");
const $10882a850d9663b5$var$immerImpl = (initializer)=>(set, get, store)=>{
        store.setState = (updater, replace, ...a)=>{
            const nextState = typeof updater === "function" ? (0, $K2rwM.produce)(updater) : updater;
            return set(nextState, replace, ...a);
        };
        return initializer(store.setState, get, store);
    };
const $10882a850d9663b5$export$428de7ec69ac95c = $10882a850d9663b5$var$immerImpl;

});
parcelRegister("K2rwM", function(module, exports) {

$parcel$export(module.exports, "isDraft", () => r);
$parcel$export(module.exports, "isDraftable", () => t);
$parcel$export(module.exports, "immerable", () => L);
$parcel$export(module.exports, "original", () => e);
$parcel$export(module.exports, "freeze", () => d);
$parcel$export(module.exports, "nothing", () => H);
$parcel$export(module.exports, "current", () => R);
$parcel$export(module.exports, "enableES5", () => F);
$parcel$export(module.exports, "enablePatches", () => T);
$parcel$export(module.exports, "enableMapSet", () => C);
$parcel$export(module.exports, "enableAllPlugins", () => J);
$parcel$export(module.exports, "castDraft", () => K);
$parcel$export(module.exports, "castImmutable", () => $);
$parcel$export(module.exports, "Immer", () => un);
$parcel$export(module.exports, "produce", () => fn);
$parcel$export(module.exports, "produceWithPatches", () => cn);
$parcel$export(module.exports, "setAutoFreeze", () => sn);
$parcel$export(module.exports, "setUseProxies", () => vn);
$parcel$export(module.exports, "applyPatches", () => pn);
$parcel$export(module.exports, "createDraft", () => ln);
$parcel$export(module.exports, "finishDraft", () => dn);
$parcel$export(module.exports, "default", () => $08a6311ec7f77a2c$export$2e2bcd8739ae039);
function n(n) {
    for(var r = arguments.length, t = Array(r > 1 ? r - 1 : 0), e = 1; e < r; e++)t[e - 1] = arguments[e];
    var i, o;
    throw Error("[Immer] minified error nr: " + n + (t.length ? " " + t.map(function(n) {
        return "'" + n + "'";
    }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function r(n) {
    return !!n && !!n[Q];
}
function t(n) {
    var r;
    return !!n && (function(n) {
        if (!n || "object" != typeof n) return !1;
        var r = Object.getPrototypeOf(n);
        if (null === r) return !0;
        var t = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
        return t === Object || "function" == typeof t && Function.toString.call(t) === Z;
    }(n) || Array.isArray(n) || !!n[L] || !!(null === (r = n.constructor) || void 0 === r ? void 0 : r[L]) || s(n) || v(n));
}
function e(t) {
    return r(t) || n(23, t), t[Q].t;
}
function i(n, r, t) {
    void 0 === t && (t = !1), 0 === o(n) ? (t ? Object.keys : nn)(n).forEach(function(e) {
        t && "symbol" == typeof e || r(e, n[e], n);
    }) : n.forEach(function(t, e) {
        return r(e, t, n);
    });
}
function o(n) {
    var r = n[Q];
    return r ? r.i > 3 ? r.i - 4 : r.i : Array.isArray(n) ? 1 : s(n) ? 2 : v(n) ? 3 : 0;
}
function u(n, r) {
    return 2 === o(n) ? n.has(r) : Object.prototype.hasOwnProperty.call(n, r);
}
function a(n, r) {
    return 2 === o(n) ? n.get(r) : n[r];
}
function f(n, r, t) {
    var e = o(n);
    2 === e ? n.set(r, t) : 3 === e ? n.add(t) : n[r] = t;
}
function c(n, r) {
    return n === r ? 0 !== n || 1 / n == 1 / r : n != n && r != r;
}
function s(n) {
    return X && n instanceof Map;
}
function v(n) {
    return q && n instanceof Set;
}
function p(n) {
    return n.o || n.t;
}
function l(n) {
    if (Array.isArray(n)) return Array.prototype.slice.call(n);
    var r = rn(n);
    delete r[Q];
    for(var t = nn(r), e = 0; e < t.length; e++){
        var i = t[e], o = r[i];
        !1 === o.writable && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (r[i] = {
            configurable: !0,
            writable: !0,
            enumerable: o.enumerable,
            value: n[i]
        });
    }
    return Object.create(Object.getPrototypeOf(n), r);
}
function d(n, e) {
    return void 0 === e && (e = !1), y(n) || r(n) || !t(n) || (o(n) > 1 && (n.set = n.add = n.clear = n.delete = h), Object.freeze(n), e && i(n, function(n, r) {
        return d(r, !0);
    }, !0)), n;
}
function h() {
    n(2);
}
function y(n) {
    return null == n || "object" != typeof n || Object.isFrozen(n);
}
function b(r) {
    var t = tn[r];
    return t || n(18, r), t;
}
function m(n, r) {
    tn[n] || (tn[n] = r);
}
function _() {
    return U;
}
function j(n, r) {
    r && (b("Patches"), n.u = [], n.s = [], n.v = r);
}
function g(n) {
    O(n), n.p.forEach(S), n.p = null;
}
function O(n) {
    n === U && (U = n.l);
}
function w(n) {
    return U = {
        p: [],
        l: U,
        h: n,
        m: !0,
        _: 0
    };
}
function S(n) {
    var r = n[Q];
    0 === r.i || 1 === r.i ? r.j() : r.g = !0;
}
function P(r, e) {
    e._ = e.p.length;
    var i = e.p[0], o = void 0 !== r && r !== i;
    return e.h.O || b("ES5").S(e, r, o), o ? (i[Q].P && (g(e), n(4)), t(r) && (r = M(e, r), e.l || x(e, r)), e.u && b("Patches").M(i[Q].t, r, e.u, e.s)) : r = M(e, i, []), g(e), e.u && e.v(e.u, e.s), r !== H ? r : void 0;
}
function M(n, r, t) {
    if (y(r)) return r;
    var e = r[Q];
    if (!e) return i(r, function(i, o) {
        return A(n, e, r, i, o, t);
    }, !0), r;
    if (e.A !== n) return r;
    if (!e.P) return x(n, e.t, !0), e.t;
    if (!e.I) {
        e.I = !0, e.A._--;
        var o = 4 === e.i || 5 === e.i ? e.o = l(e.k) : e.o, u = o, a = !1;
        3 === e.i && (u = new Set(o), o.clear(), a = !0), i(u, function(r, i) {
            return A(n, e, o, r, i, t, a);
        }), x(n, o, !1), t && n.u && b("Patches").N(e, t, n.u, n.s);
    }
    return e.o;
}
function A(e, i, o, a, c, s, v) {
    if (r(c)) {
        var p = M(e, c, s && i && 3 !== i.i && !u(i.R, a) ? s.concat(a) : void 0);
        if (f(o, a, p), !r(p)) return;
        e.m = !1;
    } else v && o.add(c);
    if (t(c) && !y(c)) {
        if (!e.h.D && e._ < 1) return;
        M(e, c), i && i.A.l || x(e, c);
    }
}
function x(n, r, t) {
    void 0 === t && (t = !1), !n.l && n.h.D && n.m && d(r, t);
}
function z(n, r) {
    var t = n[Q];
    return (t ? p(t) : n)[r];
}
function I(n, r) {
    if (r in n) for(var t = Object.getPrototypeOf(n); t;){
        var e = Object.getOwnPropertyDescriptor(t, r);
        if (e) return e;
        t = Object.getPrototypeOf(t);
    }
}
function k(n) {
    n.P || (n.P = !0, n.l && k(n.l));
}
function E(n) {
    n.o || (n.o = l(n.t));
}
function N(n, r, t) {
    var e = s(r) ? b("MapSet").F(r, t) : v(r) ? b("MapSet").T(r, t) : n.O ? function(n, r) {
        var t = Array.isArray(n), e = {
            i: t ? 1 : 0,
            A: r ? r.A : _(),
            P: !1,
            I: !1,
            R: {},
            l: r,
            t: n,
            k: null,
            o: null,
            j: null,
            C: !1
        }, i = e, o = en;
        t && (i = [
            e
        ], o = on);
        var u = Proxy.revocable(i, o), a = u.revoke, f = u.proxy;
        return e.k = f, e.j = a, f;
    }(r, t) : b("ES5").J(r, t);
    return (t ? t.A : _()).p.push(e), e;
}
function R(e) {
    return r(e) || n(22, e), function n(r) {
        if (!t(r)) return r;
        var e, u = r[Q], c = o(r);
        if (u) {
            if (!u.P && (u.i < 4 || !b("ES5").K(u))) return u.t;
            u.I = !0, e = D(r, c), u.I = !1;
        } else e = D(r, c);
        return i(e, function(r, t) {
            u && a(u.t, r) === t || f(e, r, n(t));
        }), 3 === c ? new Set(e) : e;
    }(e);
}
function D(n, r) {
    switch(r){
        case 2:
            return new Map(n);
        case 3:
            return Array.from(n);
    }
    return l(n);
}
function F() {
    function t(n, r) {
        var t = s[n];
        return t ? t.enumerable = r : s[n] = t = {
            configurable: !0,
            enumerable: r,
            get: function() {
                var r = this[Q];
                return en.get(r, n);
            },
            set: function(r) {
                var t = this[Q];
                en.set(t, n, r);
            }
        }, t;
    }
    function e(n) {
        for(var r = n.length - 1; r >= 0; r--){
            var t = n[r][Q];
            if (!t.P) switch(t.i){
                case 5:
                    a(t) && k(t);
                    break;
                case 4:
                    o(t) && k(t);
            }
        }
    }
    function o(n) {
        for(var r = n.t, t = n.k, e = nn(t), i = e.length - 1; i >= 0; i--){
            var o = e[i];
            if (o !== Q) {
                var a = r[o];
                if (void 0 === a && !u(r, o)) return !0;
                var f = t[o], s = f && f[Q];
                if (s ? s.t !== a : !c(f, a)) return !0;
            }
        }
        var v = !!r[Q];
        return e.length !== nn(r).length + (v ? 0 : 1);
    }
    function a(n) {
        var r = n.k;
        if (r.length !== n.t.length) return !0;
        var t = Object.getOwnPropertyDescriptor(r, r.length - 1);
        if (t && !t.get) return !0;
        for(var e = 0; e < r.length; e++)if (!r.hasOwnProperty(e)) return !0;
        return !1;
    }
    function f(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var s = {};
    m("ES5", {
        J: function(n, r) {
            var e = Array.isArray(n), i = function(n, r) {
                if (n) {
                    for(var e = Array(r.length), i = 0; i < r.length; i++)Object.defineProperty(e, "" + i, t(i, !0));
                    return e;
                }
                var o = rn(r);
                delete o[Q];
                for(var u = nn(o), a = 0; a < u.length; a++){
                    var f = u[a];
                    o[f] = t(f, n || !!o[f].enumerable);
                }
                return Object.create(Object.getPrototypeOf(r), o);
            }(e, n), o = {
                i: e ? 5 : 4,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                R: {},
                l: r,
                t: n,
                k: i,
                o: null,
                g: !1,
                C: !1
            };
            return Object.defineProperty(i, Q, {
                value: o,
                writable: !0
            }), i;
        },
        S: function(n, t, o) {
            o ? r(t) && t[Q].A === n && e(n.p) : (n.u && function n(r) {
                if (r && "object" == typeof r) {
                    var t = r[Q];
                    if (t) {
                        var e = t.t, o = t.k, f = t.R, c = t.i;
                        if (4 === c) i(o, function(r) {
                            r !== Q && (void 0 !== e[r] || u(e, r) ? f[r] || n(o[r]) : (f[r] = !0, k(t)));
                        }), i(e, function(n) {
                            void 0 !== o[n] || u(o, n) || (f[n] = !1, k(t));
                        });
                        else if (5 === c) {
                            if (a(t) && (k(t), f.length = !0), o.length < e.length) for(var s = o.length; s < e.length; s++)f[s] = !1;
                            else for(var v = e.length; v < o.length; v++)f[v] = !0;
                            for(var p = Math.min(o.length, e.length), l = 0; l < p; l++)o.hasOwnProperty(l) || (f[l] = !0), void 0 === f[l] && n(o[l]);
                        }
                    }
                }
            }(n.p[0]), e(n.p));
        },
        K: function(n) {
            return 4 === n.i ? o(n) : a(n);
        }
    });
}
function T() {
    function e(n) {
        if (!t(n)) return n;
        if (Array.isArray(n)) return n.map(e);
        if (s(n)) return new Map(Array.from(n.entries()).map(function(n) {
            return [
                n[0],
                e(n[1])
            ];
        }));
        if (v(n)) return new Set(Array.from(n).map(e));
        var r = Object.create(Object.getPrototypeOf(n));
        for(var i in n)r[i] = e(n[i]);
        return u(n, L) && (r[L] = n[L]), r;
    }
    function f(n) {
        return r(n) ? e(n) : n;
    }
    var c = "add";
    m("Patches", {
        $: function(r, t) {
            return t.forEach(function(t) {
                for(var i = t.path, u = t.op, f = r, s = 0; s < i.length - 1; s++){
                    var v = o(f), p = i[s];
                    "string" != typeof p && "number" != typeof p && (p = "" + p), 0 !== v && 1 !== v || "__proto__" !== p && "constructor" !== p || n(24), "function" == typeof f && "prototype" === p && n(24), "object" != typeof (f = a(f, p)) && n(15, i.join("/"));
                }
                var l = o(f), d = e(t.value), h = i[i.length - 1];
                switch(u){
                    case "replace":
                        switch(l){
                            case 2:
                                return f.set(h, d);
                            case 3:
                                n(16);
                            default:
                                return f[h] = d;
                        }
                    case c:
                        switch(l){
                            case 1:
                                return "-" === h ? f.push(d) : f.splice(h, 0, d);
                            case 2:
                                return f.set(h, d);
                            case 3:
                                return f.add(d);
                            default:
                                return f[h] = d;
                        }
                    case "remove":
                        switch(l){
                            case 1:
                                return f.splice(h, 1);
                            case 2:
                                return f.delete(h);
                            case 3:
                                return f.delete(t.value);
                            default:
                                return delete f[h];
                        }
                    default:
                        n(17, u);
                }
            }), r;
        },
        N: function(n, r, t, e) {
            switch(n.i){
                case 0:
                case 4:
                case 2:
                    return function(n, r, t, e) {
                        var o = n.t, s = n.o;
                        i(n.R, function(n, i) {
                            var v = a(o, n), p = a(s, n), l = i ? u(o, n) ? "replace" : c : "remove";
                            if (v !== p || "replace" !== l) {
                                var d = r.concat(n);
                                t.push("remove" === l ? {
                                    op: l,
                                    path: d
                                } : {
                                    op: l,
                                    path: d,
                                    value: p
                                }), e.push(l === c ? {
                                    op: "remove",
                                    path: d
                                } : "remove" === l ? {
                                    op: c,
                                    path: d,
                                    value: f(v)
                                } : {
                                    op: "replace",
                                    path: d,
                                    value: f(v)
                                });
                            }
                        });
                    }(n, r, t, e);
                case 5:
                case 1:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.R, u = n.o;
                        if (u.length < i.length) {
                            var a = [
                                u,
                                i
                            ];
                            i = a[0], u = a[1];
                            var s = [
                                e,
                                t
                            ];
                            t = s[0], e = s[1];
                        }
                        for(var v = 0; v < i.length; v++)if (o[v] && u[v] !== i[v]) {
                            var p = r.concat([
                                v
                            ]);
                            t.push({
                                op: "replace",
                                path: p,
                                value: f(u[v])
                            }), e.push({
                                op: "replace",
                                path: p,
                                value: f(i[v])
                            });
                        }
                        for(var l = i.length; l < u.length; l++){
                            var d = r.concat([
                                l
                            ]);
                            t.push({
                                op: c,
                                path: d,
                                value: f(u[l])
                            });
                        }
                        i.length < u.length && e.push({
                            op: "replace",
                            path: r.concat([
                                "length"
                            ]),
                            value: i.length
                        });
                    }(n, r, t, e);
                case 3:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.o, u = 0;
                        i.forEach(function(n) {
                            if (!o.has(n)) {
                                var i = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: "remove",
                                    path: i,
                                    value: n
                                }), e.unshift({
                                    op: c,
                                    path: i,
                                    value: n
                                });
                            }
                            u++;
                        }), u = 0, o.forEach(function(n) {
                            if (!i.has(n)) {
                                var o = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: c,
                                    path: o,
                                    value: n
                                }), e.unshift({
                                    op: "remove",
                                    path: o,
                                    value: n
                                });
                            }
                            u++;
                        });
                    }(n, r, t, e);
            }
        },
        M: function(n, r, t, e) {
            t.push({
                op: "replace",
                path: [],
                value: r === H ? void 0 : r
            }), e.push({
                op: "replace",
                path: [],
                value: n
            });
        }
    });
}
function C() {
    function r(n, r) {
        function t() {
            this.constructor = n;
        }
        a(n, r), n.prototype = (t.prototype = r.prototype, new t);
    }
    function e(n) {
        n.o || (n.R = new Map, n.o = new Map(n.t));
    }
    function o(n) {
        n.o || (n.o = new Set, n.t.forEach(function(r) {
            if (t(r)) {
                var e = N(n.A.h, r, n);
                n.p.set(r, e), n.o.add(e);
            } else n.o.add(r);
        }));
    }
    function u(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var a = function(n, r) {
        return (a = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(n, r) {
            n.__proto__ = r;
        } || function(n, r) {
            for(var t in r)r.hasOwnProperty(t) && (n[t] = r[t]);
        })(n, r);
    }, f = function() {
        function n(n, r) {
            return this[Q] = {
                i: 2,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                R: void 0,
                t: n,
                k: this,
                C: !1,
                g: !1
            }, this;
        }
        r(n, Map);
        var o = n.prototype;
        return Object.defineProperty(o, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), o.has = function(n) {
            return p(this[Q]).has(n);
        }, o.set = function(n, r) {
            var t = this[Q];
            return u(t), p(t).has(n) && p(t).get(n) === r || (e(t), k(t), t.R.set(n, !0), t.o.set(n, r), t.R.set(n, !0)), this;
        }, o.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), e(r), k(r), r.t.has(n) ? r.R.set(n, !1) : r.R.delete(n), r.o.delete(n), !0;
        }, o.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (e(n), k(n), n.R = new Map, i(n.t, function(r) {
                n.R.set(r, !1);
            }), n.o.clear());
        }, o.forEach = function(n, r) {
            var t = this;
            p(this[Q]).forEach(function(e, i) {
                n.call(r, t.get(i), i, t);
            });
        }, o.get = function(n) {
            var r = this[Q];
            u(r);
            var i = p(r).get(n);
            if (r.I || !t(i)) return i;
            if (i !== r.t.get(n)) return i;
            var o = N(r.A.h, i, r);
            return e(r), r.o.set(n, o), o;
        }, o.keys = function() {
            return p(this[Q]).keys();
        }, o.values = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.values();
            }, n.next = function() {
                var n = t.next();
                return n.done ? n : {
                    done: !1,
                    value: r.get(n.value)
                };
            }, n;
        }, o.entries = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.entries();
            }, n.next = function() {
                var n = t.next();
                if (n.done) return n;
                var e = r.get(n.value);
                return {
                    done: !1,
                    value: [
                        n.value,
                        e
                    ]
                };
            }, n;
        }, o[V] = function() {
            return this.entries();
        }, n;
    }(), c = function() {
        function n(n, r) {
            return this[Q] = {
                i: 3,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                t: n,
                k: this,
                p: new Map,
                g: !1,
                C: !1
            }, this;
        }
        r(n, Set);
        var t = n.prototype;
        return Object.defineProperty(t, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), t.has = function(n) {
            var r = this[Q];
            return u(r), r.o ? !!r.o.has(n) || !(!r.p.has(n) || !r.o.has(r.p.get(n))) : r.t.has(n);
        }, t.add = function(n) {
            var r = this[Q];
            return u(r), this.has(n) || (o(r), k(r), r.o.add(n)), this;
        }, t.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), o(r), k(r), r.o.delete(n) || !!r.p.has(n) && r.o.delete(r.p.get(n));
        }, t.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (o(n), k(n), n.o.clear());
        }, t.values = function() {
            var n = this[Q];
            return u(n), o(n), n.o.values();
        }, t.entries = function() {
            var n = this[Q];
            return u(n), o(n), n.o.entries();
        }, t.keys = function() {
            return this.values();
        }, t[V] = function() {
            return this.values();
        }, t.forEach = function(n, r) {
            for(var t = this.values(), e = t.next(); !e.done;)n.call(r, e.value, e.value, this), e = t.next();
        }, n;
    }();
    m("MapSet", {
        F: function(n, r) {
            return new f(n, r);
        },
        T: function(n, r) {
            return new c(n, r);
        }
    });
}
function J() {
    F(), C(), T();
}
function K(n) {
    return n;
}
function $(n) {
    return n;
}
var G, U, W = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"), X = "undefined" != typeof Map, q = "undefined" != typeof Set, B = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect, H = W ? Symbol.for("immer-nothing") : ((G = {})["immer-nothing"] = !0, G), L = W ? Symbol.for("immer-draftable") : "__$immer_draftable", Q = W ? Symbol.for("immer-state") : "__$immer_state", V = "undefined" != typeof Symbol && Symbol.iterator || "@@iterator", Y = {
    0: "Illegal state",
    1: "Immer drafts cannot have computed properties",
    2: "This object has been frozen and should not be mutated",
    3: function(n) {
        return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n;
    },
    4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
    5: "Immer forbids circular references",
    6: "The first or second argument to `produce` must be a function",
    7: "The third argument to `produce` must be a function or undefined",
    8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
    9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
    10: "The given draft is already finalized",
    11: "Object.defineProperty() cannot be used on an Immer draft",
    12: "Object.setPrototypeOf() cannot be used on an Immer draft",
    13: "Immer only supports deleting array indices",
    14: "Immer only supports setting array indices and the 'length' property",
    15: function(n) {
        return "Cannot apply patch, path doesn't resolve: " + n;
    },
    16: 'Sets cannot have "replace" patches.',
    17: function(n) {
        return "Unsupported patch operation: " + n;
    },
    18: function(n) {
        return "The plugin for '" + n + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n + "()` when initializing your application.";
    },
    20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",
    21: function(n) {
        return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n + "'";
    },
    22: function(n) {
        return "'current' expects a draft, got: " + n;
    },
    23: function(n) {
        return "'original' expects a draft, got: " + n;
    },
    24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
}, Z = "" + Object.prototype.constructor, nn = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function(n) {
    return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
} : Object.getOwnPropertyNames, rn = Object.getOwnPropertyDescriptors || function(n) {
    var r = {};
    return nn(n).forEach(function(t) {
        r[t] = Object.getOwnPropertyDescriptor(n, t);
    }), r;
}, tn = {}, en = {
    get: function(n, r) {
        if (r === Q) return n;
        var e = p(n);
        if (!u(e, r)) return function(n, r, t) {
            var e, i = I(r, t);
            return i ? "value" in i ? i.value : null === (e = i.get) || void 0 === e ? void 0 : e.call(n.k) : void 0;
        }(n, e, r);
        var i = e[r];
        return n.I || !t(i) ? i : i === z(n.t, r) ? (E(n), n.o[r] = N(n.A.h, i, n)) : i;
    },
    has: function(n, r) {
        return r in p(n);
    },
    ownKeys: function(n) {
        return Reflect.ownKeys(p(n));
    },
    set: function(n, r, t) {
        var e = I(p(n), r);
        if (null == e ? void 0 : e.set) return e.set.call(n.k, t), !0;
        if (!n.P) {
            var i = z(p(n), r), o = null == i ? void 0 : i[Q];
            if (o && o.t === t) return n.o[r] = t, n.R[r] = !1, !0;
            if (c(t, i) && (void 0 !== t || u(n.t, r))) return !0;
            E(n), k(n);
        }
        return n.o[r] === t && (void 0 !== t || r in n.o) || Number.isNaN(t) && Number.isNaN(n.o[r]) || (n.o[r] = t, n.R[r] = !0), !0;
    },
    deleteProperty: function(n, r) {
        return void 0 !== z(n.t, r) || r in n.t ? (n.R[r] = !1, E(n), k(n)) : delete n.R[r], n.o && delete n.o[r], !0;
    },
    getOwnPropertyDescriptor: function(n, r) {
        var t = p(n), e = Reflect.getOwnPropertyDescriptor(t, r);
        return e ? {
            writable: !0,
            configurable: 1 !== n.i || "length" !== r,
            enumerable: e.enumerable,
            value: t[r]
        } : e;
    },
    defineProperty: function() {
        n(11);
    },
    getPrototypeOf: function(n) {
        return Object.getPrototypeOf(n.t);
    },
    setPrototypeOf: function() {
        n(12);
    }
}, on = {};
i(en, function(n, r) {
    on[n] = function() {
        return arguments[0] = arguments[0][0], r.apply(this, arguments);
    };
}), on.deleteProperty = function(r, t) {
    return on.set.call(this, r, t, void 0);
}, on.set = function(r, t, e) {
    return en.set.call(this, r[0], t, e, r[0]);
};
var un = function() {
    function e(r) {
        var e = this;
        this.O = B, this.D = !0, this.produce = function(r, i, o) {
            if ("function" == typeof r && "function" != typeof i) {
                var u = i;
                i = r;
                var a = e;
                return function(n) {
                    var r = this;
                    void 0 === n && (n = u);
                    for(var t = arguments.length, e = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)e[o - 1] = arguments[o];
                    return a.produce(n, function(n) {
                        var t;
                        return (t = i).call.apply(t, [
                            r,
                            n
                        ].concat(e));
                    });
                };
            }
            var f;
            if ("function" != typeof i && n(6), void 0 !== o && "function" != typeof o && n(7), t(r)) {
                var c = w(e), s = N(e, r, void 0), v = !0;
                try {
                    f = i(s), v = !1;
                } finally{
                    v ? g(c) : O(c);
                }
                return "undefined" != typeof Promise && f instanceof Promise ? f.then(function(n) {
                    return j(c, o), P(n, c);
                }, function(n) {
                    throw g(c), n;
                }) : (j(c, o), P(f, c));
            }
            if (!r || "object" != typeof r) {
                if (void 0 === (f = i(r)) && (f = r), f === H && (f = void 0), e.D && d(f, !0), o) {
                    var p = [], l = [];
                    b("Patches").M(r, f, p, l), o(p, l);
                }
                return f;
            }
            n(21, r);
        }, this.produceWithPatches = function(n, r) {
            if ("function" == typeof n) return function(r) {
                for(var t = arguments.length, i = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)i[o - 1] = arguments[o];
                return e.produceWithPatches(r, function(r) {
                    return n.apply(void 0, [
                        r
                    ].concat(i));
                });
            };
            var t, i, o = e.produce(n, r, function(n, r) {
                t = n, i = r;
            });
            return "undefined" != typeof Promise && o instanceof Promise ? o.then(function(n) {
                return [
                    n,
                    t,
                    i
                ];
            }) : [
                o,
                t,
                i
            ];
        }, "boolean" == typeof (null == r ? void 0 : r.useProxies) && this.setUseProxies(r.useProxies), "boolean" == typeof (null == r ? void 0 : r.autoFreeze) && this.setAutoFreeze(r.autoFreeze);
    }
    var i = e.prototype;
    return i.createDraft = function(e) {
        t(e) || n(8), r(e) && (e = R(e));
        var i = w(this), o = N(this, e, void 0);
        return o[Q].C = !0, O(i), o;
    }, i.finishDraft = function(r, t) {
        var e = r && r[Q];
        var i = e.A;
        return j(i, t), P(void 0, i);
    }, i.setAutoFreeze = function(n) {
        this.D = n;
    }, i.setUseProxies = function(r) {
        r && !B && n(20), this.O = r;
    }, i.applyPatches = function(n, t) {
        var e;
        for(e = t.length - 1; e >= 0; e--){
            var i = t[e];
            if (0 === i.path.length && "replace" === i.op) {
                n = i.value;
                break;
            }
        }
        e > -1 && (t = t.slice(e + 1));
        var o = b("Patches").$;
        return r(n) ? o(n, t) : this.produce(n, function(n) {
            return o(n, t);
        });
    }, e;
}(), an = new un, fn = an.produce, cn = an.produceWithPatches.bind(an), sn = an.setAutoFreeze.bind(an), vn = an.setUseProxies.bind(an), pn = an.applyPatches.bind(an), ln = an.createDraft.bind(an), dn = an.finishDraft.bind(an);
var $08a6311ec7f77a2c$export$2e2bcd8739ae039 = fn;

});


parcelRegister("96y8R", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $6a0f287ca3f709ed$export$f51a9068ac82ea43);
var $6a0f287ca3f709ed$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/zustand/esm/vanilla.mjs"
});
const $6a0f287ca3f709ed$var$createStoreImpl = (createState)=>{
    let state;
    const listeners = /* @__PURE__ */ new Set();
    const setState = (partial, replace)=>{
        const nextState = typeof partial === "function" ? partial(state) : partial;
        if (!Object.is(nextState, state)) {
            const previousState = state;
            state = (replace != null ? replace : typeof nextState !== "object" || nextState === null) ? nextState : Object.assign({}, state, nextState);
            listeners.forEach((listener)=>listener(state, previousState));
        }
    };
    const getState = ()=>state;
    const getInitialState = ()=>initialState;
    const subscribe = (listener)=>{
        listeners.add(listener);
        return ()=>listeners.delete(listener);
    };
    const destroy = ()=>{
        if (($6a0f287ca3f709ed$import_meta.env ? $6a0f287ca3f709ed$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] The `destroy` method will be unsupported in a future version. Instead use unsubscribe function returned by subscribe. Everything will be garbage-collected if store is garbage-collected.");
        listeners.clear();
    };
    const api = {
        setState: setState,
        getState: getState,
        getInitialState: getInitialState,
        subscribe: subscribe,
        destroy: destroy
    };
    const initialState = state = createState(setState, getState, api);
    return api;
};
const $6a0f287ca3f709ed$export$f51a9068ac82ea43 = (createState)=>createState ? $6a0f287ca3f709ed$var$createStoreImpl(createState) : $6a0f287ca3f709ed$var$createStoreImpl;
var $6a0f287ca3f709ed$export$2e2bcd8739ae039 = (createState)=>{
    if (($6a0f287ca3f709ed$import_meta.env ? $6a0f287ca3f709ed$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use import { createStore } from 'zustand/vanilla'.");
    return $6a0f287ca3f709ed$export$f51a9068ac82ea43(createState);
};

});



parcelRegister("bksvR", function(module, exports) {

$parcel$export(module.exports, "createCopyIntentRegisterationBatcher", () => $6bed172d1e1e47c4$export$57945b6819e39246);

var $79KwK = parcelRequire("79KwK");

var $3xaEP = parcelRequire("3xaEP");
const $6bed172d1e1e47c4$export$b79d95ee17a87a = 100;
/**
 * Returns a function that, given Array<DataloaderKey>, resolves to an array of same length containing either DataloaderResult or Error.
 * Such contract is formalised by Dataloader 1.0, @see https://github.com/graphql/dataloader
 *
 * If an Error is resolved in the results, it must be at same position then their corresponding key:
 * - Dataloader will re-throw that Error when accessing/loading that particular key
 *
 * @param mediaStore instance of MediaStore
 */ function $6bed172d1e1e47c4$var$createBatchCopyIntentRegisterationFunc(mediaStore) {
    return async (keys)=>{
        const keysByToken = keys.reduce((acc, key)=>{
            const token = key.resolvedAuth.token;
            acc[token] = acc[token] || [];
            // de-duplicate ids in collection
            const hasDuplicates = acc[token].some(({ id: id, collectionName: collectionName })=>key.id === id && collectionName === key.collectionName);
            if (!hasDuplicates) acc[token].push(key);
            return acc;
        }, {});
        const items = [];
        await Promise.all(Object.keys(keysByToken).map(async (batchKey)=>{
            const metadataTraceContext = {
                traceId: (0, $3xaEP.getRandomTelemetryId)(),
                spanId: (0, $3xaEP.getRandomTelemetryId)()
            };
            const files = keysByToken[batchKey].map((key)=>({
                    id: key.id,
                    collection: key.collectionName
                }));
            // given these are batched by the token the assumption is that they have the same details.
            const resolvedAuth = keysByToken[batchKey][0].resolvedAuth;
            try {
                await mediaStore.registerCopyIntents(files, metadataTraceContext, resolvedAuth);
            } catch (error) {
                files.forEach(({ id: id, collection: collection })=>{
                    items.push({
                        id: id,
                        collection: collection,
                        error: error
                    });
                });
            }
        }));
        return keys.map(({ id: id, collectionName: collectionName })=>{
            return items.find((item)=>item.id === id && item.collection === collectionName)?.error;
        });
    };
}
function $6bed172d1e1e47c4$export$57945b6819e39246(mediaStore) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($79KwK)))($6bed172d1e1e47c4$var$createBatchCopyIntentRegisterationFunc(mediaStore), {
        maxBatchSize: $6bed172d1e1e47c4$export$b79d95ee17a87a,
        cacheKeyFn: ({ id: id, collectionName: collectionName = 'default', resolvedAuth: resolvedAuth })=>`${id}-${collectionName}-${resolvedAuth.token}`
    });
}

});


parcelRegister("gWavf", function(module, exports) {

$parcel$export(module.exports, "StargateClient", () => $60a1ef1a71feccaf$export$c66ca190f89caaac);
class $60a1ef1a71feccaf$export$c66ca190f89caaac {
    constructor(baseUrl){
        this.baseUrl = baseUrl || '/gateway/api';
    }
    async fetchToken(clientId) {
        return (await fetch(`${this.baseUrl}/media/auth/smartedge`, {
            credentials: 'include',
            headers: {
                'x-client-id': clientId
            }
        })).json();
    }
    isTokenExpired(token) {
        const currentTimeInSeconds = new Date().getTime() / 1000;
        return token.data.iat + token.data.expiresIn - currentTimeInSeconds < 0;
    }
}

});

parcelRegister("c4FM0", function(module, exports) {

let $8ca6431068cfdd61$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $8ca6431068cfdd61$var$load("lPk9Z").then(()=>parcelRequire('h77Xn'));

});



parcelRegister("93R6D", function(module, exports) {

$parcel$export(module.exports, "MediaClientContext", () => $c470ce77068e97aa$export$ba5d7212f2b4619f);
$parcel$export(module.exports, "MediaClientProvider", () => $c470ce77068e97aa$export$5bff351c86f56d97);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $aRuva = parcelRequire("aRuva");
const $c470ce77068e97aa$export$ba5d7212f2b4619f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext(undefined);
const $c470ce77068e97aa$export$5bff351c86f56d97 = ({ children: children, clientConfig: clientConfig })=>{
    const mediaClient = (0, $eJOHy.useMemo)(()=>(0, $aRuva.getMediaClient)(clientConfig), [
        clientConfig
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($c470ce77068e97aa$export$ba5d7212f2b4619f.Provider, {
        value: mediaClient,
        children: children
    });
};

});


parcelRegister("jzI2h", function(module, exports) {

$parcel$export(module.exports, "ActiveHeaderIdProvider", () => $49f30dc8867dd336$export$20439b49fdd0d26c);
$parcel$export(module.exports, "ActiveHeaderIdConsumer", () => $49f30dc8867dd336$export$cddc3c6ebe2d2cec);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
const { Provider: $49f30dc8867dd336$export$20439b49fdd0d26c, Consumer: $49f30dc8867dd336$var$Consumer } = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext(undefined);
/**
 * We need to expose this abstraction on top of the native Consumer in order to control when
 * The consumer will get notified when a match has happened. If we use the Consumer directly in
 * Expand components without this inner state, everytime a new prop comes in, and the `newActiveHeaderId`
 * is the same as before, we will set the expand to true forever, until the active header id changes.
 * Thus, the user won't be able to collapse the expand.
 *
 * By exposing `onNestedHeaderIdMatch` here we can control when will consumers be notified:
 * only when a `newActiveHeaderId` comes in from the Provider and the list of header ids includes it.
 */ const $49f30dc8867dd336$export$cddc3c6ebe2d2cec = ({ nestedHeaderIds: nestedHeaderIds, onNestedHeaderIdMatch: onNestedHeaderIdMatch })=>{
    const [activeHeaderId, setActiveHeaderId] = (0, $eJOHy.useState)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)($49f30dc8867dd336$var$Consumer, {
        children: (newActiveHeaderId)=>{
            if (!newActiveHeaderId || !nestedHeaderIds.includes(newActiveHeaderId)) setActiveHeaderId(undefined);
            else if (newActiveHeaderId !== activeHeaderId && nestedHeaderIds.includes(newActiveHeaderId)) {
                setActiveHeaderId(newActiveHeaderId);
                onNestedHeaderIdMatch();
            }
            return null;
        }
    });
};

});

parcelRegister("khi07", function(module, exports) {

$parcel$export(module.exports, "BreakoutSSRInlineScript", () => $28fde8499608f589$export$cfc1361be0de4203);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $bnh3n = parcelRequire("bnh3n");

var $eGOwo = parcelRequire("eGOwo");

function $28fde8499608f589$export$cfc1361be0de4203({ noOpSSRInlineScript: noOpSSRInlineScript }) {
    /**
	 * Should only inline this script while SSR,
	 * not needed on the client side.
	 */ // For hydrateRoot there is a mismatch on client for this script.
    // So we want to add the script on client side but guard it with check to
    // not execute logic
    if (typeof window !== 'undefined' && !window.navigator.userAgent.includes('jsdom')) {
        if (!noOpSSRInlineScript) return null;
        else window.__RENDERER_BYPASS_BREAKOUT_SSR__ = true;
    }
    const id = Math.floor(Math.random() * 9999990001) + 9999;
    const shouldSkipScript = {
        table: (0, $eGOwo.fg)('platform-ssr-table-resize'),
        breakout: (0, $eGOwo.fg)('platform_breakout_cls')
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)("script", {
        "data-breakout-script-id": id,
        // To investigate if we can replace this.
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: $28fde8499608f589$export$92859d13f30c883e(id, shouldSkipScript)
        },
        "data-testid": "breakout-ssr-inline-script"
    });
}
function $28fde8499608f589$export$92859d13f30c883e(id, shouldSkipScript) {
    return `
	 (function(window){
		if(typeof window !== 'undefined' && window.__RENDERER_BYPASS_BREAKOUT_SSR__) {
			return;
		}
    ${$28fde8499608f589$export$47813c4121c8b4b3};
    (${$28fde8499608f589$var$applyBreakoutAfterSSR.toString()})("${id}", breakoutConsts, ${JSON.stringify(shouldSkipScript)});
  })(window);
`;
}
const $28fde8499608f589$export$47813c4121c8b4b3 = `
  var breakoutConsts = ${JSON.stringify((0, $bnh3n.breakoutConsts))};
  breakoutConsts.mapBreakpointToLayoutMaxWidth = ${(0, $bnh3n.breakoutConsts).mapBreakpointToLayoutMaxWidth.toString()};
  breakoutConsts.getBreakpoint = ${(0, $bnh3n.breakoutConsts).getBreakpoint.toString()};
  breakoutConsts.calcBreakoutWidth = ${(0, $bnh3n.breakoutConsts).calcBreakoutWidth.toString()};
  breakoutConsts.calcBreakoutWithCustomWidth = ${(0, $bnh3n.breakoutConsts).calcBreakoutWithCustomWidth.toString()};
  breakoutConsts.calcLineLength = ${(0, $bnh3n.breakoutConsts).calcLineLength.toString()};
  breakoutConsts.calcWideWidth = ${(0, $bnh3n.breakoutConsts).calcWideWidth.toString()};
  breakoutConsts.FullPagePadding = ${(0, $9a762f515f769003$export$12fd658e5eef0d79).toString()};
`;
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $28fde8499608f589$var$applyBreakoutAfterSSR(id, breakoutConsts, shouldSkipBreakoutScript) {
    const MEDIA_NODE_TYPE = 'mediaSingle';
    const WIDE_LAYOUT_MODES = [
        'full-width',
        'wide',
        'custom'
    ];
    function findUp(element, condition) {
        if (!element) return;
        while(element.parentElement){
            if (condition(element)) return element.parentElement;
            element = element.parentElement;
        }
    }
    const renderer = findUp(document.querySelector(`[data-breakout-script-id="${id}"]`), (elem)=>!!elem.parentElement?.classList.contains('ak-renderer-wrapper'));
    if (!renderer) return;
    const observer = new MutationObserver((mutationsList)=>{
        mutationsList.forEach((item)=>{
            if (item.target.nodeType !== Node.ELEMENT_NODE) return;
            // Remove with feature gate 'platform-ssr-table-resize'
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            if (item.target.classList.contains('ak-renderer-document')) item.addedNodes.forEach((maybeNode)=>{
                // maybeNode may contain comments which doesn't have a dataset property
                if (maybeNode.nodeType !== Node.ELEMENT_NODE) return;
                let width;
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const node = maybeNode;
                const mode = node.dataset.mode || node.dataset.layout || '';
                const resizedBreakout = node.dataset.hasWidth === 'true';
                if (!mode || !WIDE_LAYOUT_MODES.includes(mode)) return;
                // When flag is on we are using CSS to calculate the table width thus don't need logic below to set the width and left.
                if (shouldSkipBreakoutScript.table && node.classList.contains('pm-table-container')) return;
                if (shouldSkipBreakoutScript.breakout && node.classList.contains('fabric-editor-breakout-mark')) return;
                // use breakout script for all other types of nodes
                if (node.classList.contains('pm-table-container') && mode === 'custom') {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    const rendererWidth = renderer.offsetWidth;
                    const effectiveWidth = rendererWidth - breakoutConsts.padding;
                    width = `${Math.min(parseInt(node.style.width), effectiveWidth)}px`;
                } else if (resizedBreakout) width = breakoutConsts.calcBreakoutWithCustomWidth(breakoutConsts)(mode, Number(node.dataset.width) || null, // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                renderer.offsetWidth);
                else // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                width = breakoutConsts.calcBreakoutWidth(breakoutConsts)(mode, renderer.offsetWidth);
                if (node.style.width === width) return;
                node.style.width = width;
                // Tables require some special logic, as they are not using common css transform approach,
                // because it breaks with sticky headers. This logic is copied from a table node:
                // https://bitbucket.org/atlassian/atlassian-frontend/src/77938aee0c140d02ff99b98a03849be1236865b4/packages/editor/renderer/src/react/nodes/table.tsx#table.tsx-235:245
                if (node.classList.contains('pm-table-container') && // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                !renderer.classList.contains('is-full-width')) {
                    const lineLength = breakoutConsts.calcLineLength(breakoutConsts)();
                    const left = lineLength / 2 - parseInt(width) / 2;
                    if (left < 0 && parseInt(width) > lineLength) node.style.left = left + 'px';
                    else node.style.left = '';
                }
            });
            else if (/**
				 * The mutation observer is only called once per added node.
				 * The above condition only deals with direct children of <div class="ak-renderer-document" />
				 * When it is initially called on the direct children, not all the sub children have loaded.
				 * So nested media elements which are not immediately loaded as sub children are not available in the above conditional.
				 * Thus adding this conditional to deal with all media elements directly.
				 */ // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            item.target.dataset.nodeType === MEDIA_NODE_TYPE) // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            applyMediaBreakout(item.target);
        });
    });
    const applyMediaBreakout = (card)=>{
        // width was already set by another breakout script
        if (card.style.width) return;
        const tableParent = findUp(card, (elem)=>elem instanceof HTMLTableCellElement);
        // only apply the breakout to media elements not nested inside table
        // table sizing is not based on percentage width
        if (tableParent) return;
        const mode = card.dataset.mode || card.dataset.layout || '';
        const width = card.dataset.width;
        const isPixelBasedResizing = card.dataset.widthType === 'pixel';
        if (WIDE_LAYOUT_MODES.includes(mode)) card.style.width = '100%';
        else if (width && !isPixelBasedResizing) // Pixel based resizing has width set in pixels based on its width attribute
        // Thus, no need to override for non-wide layouts
        card.style.width = `${width}%`;
    };
    observer.observe(renderer, {
        childList: true,
        subtree: true
    });
    /**
	 * Using window load event to unsubscribe from mutation observer, as at this stage document is fully rendered.
	 * Experiment with DOMContentLoaded showed that some of the blocks were not processed at all.
	 * That's why window load is necessary.
	 *
	 * More info:
	 * – https://html.spec.whatwg.org/multipage/parsing.html#the-end
	 * – https://developer.mozilla.org/en-US/docs/Web/API/Window/load_event
	 * – https://developer.mozilla.org/en-US/docs/Web/API/Document/DOMContentLoaded_event
	 */ const disconnect = ()=>{
        observer.disconnect();
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.removeEventListener('load', disconnect);
    };
    // Ignored via go/ees005
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    window.addEventListener('load', disconnect);
}
const $28fde8499608f589$export$2a0b3eeee3f2ea40 = (0, $bnh3n.breakoutConsts).calcLineLength((0, $bnh3n.breakoutConsts));

});

parcelRegister("hQy2y", function(module, exports) {

$parcel$export(module.exports, "isInteractiveElement", () => $829ac6fce69e52f7$export$3dee5e4542c672d9);


function $829ac6fce69e52f7$export$3dee5e4542c672d9(element) {
    if ('href' in element && element.href != null) return true;
    if (element.classList.contains((0, $2f9f53af5a1aaefa$export$42c8d07e41ed1e74))) return true;
    if (element.classList.contains((0, $87b212d64266f221$export$7a6526d4be3b7eb3))) return true;
    return false;
}

});
const $87b212d64266f221$export$7a6526d4be3b7eb3 = 'media-file-card-view';
const $87b212d64266f221$export$1b2a6cb6a124ba37 = 'media-file-card-view-selected';

/**
 * Classname for the media viewer popup that appears adjacent to the editor div. Use this to check
 * if the media viewer has appeared.
 */ const $2f9f53af5a1aaefa$export$42c8d07e41ed1e74 = 'media-viewer-popup';


parcelRegister("fC4S5", function(module, exports) {

$parcel$export(module.exports, "TruncatedWrapper", () => $95f9782da3cce186$export$79ad592494094f07);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $eJOHy = parcelRequire("eJOHy");
const $95f9782da3cce186$var$fadeOutStyles = (maxHeight, top, backgroundColor)=>/*#__PURE__*/ (0, $1NIU8.css)({
        position: 'relative',
        overflowY: 'hidden',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxHeight: `${maxHeight}px`,
        '&::after': {
            content: "''",
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            top: `${top}px`,
            bottom: 0,
            left: 0,
            right: 0,
            backgroundImage: `linear-gradient( ${"var(--ds-background-neutral-subtle, rgba(255, 255, 255, 0))"}, ${backgroundColor} )`
        }
    });
const $95f9782da3cce186$var$FadeOut = (props)=>{
    const { children: children, backgroundColor: backgroundColor, fadeHeight: fadeHeight, height: height } = props;
    const top = height - fadeHeight;
    const styles = $95f9782da3cce186$var$fadeOutStyles(height, top, backgroundColor);
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: styles
    }, children);
};
class $95f9782da3cce186$export$79ad592494094f07 extends (0, $eJOHy.Component) {
    constructor(props){
        super(props);
    }
    // TODO: DSP-4123 - Quality ticket as elevation.surface will be issue when sits top of modal.
    render() {
        const { height: height = 95, fadeHeight: fadeHeight = 24, backgroundColor: backgroundColor = "var(--ds-surface, white)", children: children } = this.props;
        return /*#__PURE__*/ (0, $1NIU8.jsx)($95f9782da3cce186$var$FadeOut, {
            height: height,
            fadeHeight: fadeHeight,
            backgroundColor: backgroundColor
        }, children);
    }
}

});

parcelRegister("bVKVd", function(module, exports) {

$parcel$export(module.exports, "RendererStyleContainer", () => $28bec4b928772749$export$8f0929e72efe521f);
/* eslint-disable @atlaskit/ui-styling-standard/no-important-styles */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values */ /**
                                                                                                                                                                                                                                                                           * @jsxRuntime classic
                                                                                                                                                                                                                                                                           * @jsx jsx
                                                                                                                                                                                                                                                                           */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $1NIU8 = parcelRequire("1NIU8");



var $eGOwo = parcelRequire("eGOwo");

var $iRC0e = parcelRequire("iRC0e");

var $7yBx7 = parcelRequire("7yBx7");

var $dA9km = parcelRequire("dA9km");

var $a6S67 = parcelRequire("a6S67");

var $gBkUB = parcelRequire("gBkUB");
var $fDsDd = parcelRequire("fDsDd");
var $kvnqO = parcelRequire("kvnqO");
var $laqWo = parcelRequire("laqWo");
var $e2Ny4 = parcelRequire("e2Ny4");
var $cjLtO = parcelRequire("cjLtO");
var $gZAVf = parcelRequire("gZAVf");

var $7T1su = parcelRequire("7T1su");
var $a4ifE = parcelRequire("a4ifE");

var $k6yTf = parcelRequire("k6yTf");
var $3gw29 = parcelRequire("3gw29");

var $7EdFW = parcelRequire("7EdFW");

var $92xoS = parcelRequire("92xoS");

var $idsFq = parcelRequire("idsFq");


var $ka8WB = parcelRequire("ka8WB");

var $Vv4zU = parcelRequire("Vv4zU");

var $c3ajv = parcelRequire("c3ajv");
function $28bec4b928772749$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $28bec4b928772749$var$wrappedMediaBreakoutPoint = 410;
const $28bec4b928772749$var$TELEPOINTER_ID = 'ai-streaming-telepointer';
const $28bec4b928772749$var$tableShadowWidth = 32;
const $28bec4b928772749$var$LAYOUT_BREAKPOINT_RENDERER = 629;
// originally defined from packages/editor/editor-plugin-table/src/ui/common-styles.ts
// Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
// eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
// TODO: tableRowHeight can be moved into `@atlaskit/editor-common/table`
const $28bec4b928772749$var$tableRowHeight = 44;
const $28bec4b928772749$var$isBackgroundClipBrowserFixNeeded = ()=>(0, $7EdFW.browser).isGecko || (0, $7EdFW.browser).isIE || (0, $7EdFW.browser).isMac && (0, $7EdFW.browser).isChrome;
// styles are copied from ./style.tsx
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage
const $28bec4b928772749$var$baseStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: 'var(--ak-renderer-base-font-size)',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '1.5rem',
    color: `var(--ds-text, ${(0, $7bb4c1736002a04a$export$7d61b15e0da132af)})`,
    [`.${(0, $iRC0e.RendererCssClassName).DOCUMENT}::after`]: {
        // we add a clearfix after ak-renderer-document in order to
        // contain internal floats (such as media images that are "wrap-left")
        // to just the renderer (and not spill outside of it)
        content: '""',
        visibility: 'hidden',
        display: 'block',
        height: 0,
        clear: 'both'
    },
    [`.${(0, $iRC0e.RendererCssClassName).DOCUMENT}`]: {
        // p, h3, and action items
        [`.${0, $dA9km.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
            height: '22px',
            transform: `translateY(-2px)`
        },
        h1: {
            [`> .mediaInlineView-content-wrap > .${0, $dA9km.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $dA9km.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $dA9km.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $dA9km.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '36px',
                transform: `translateY(-3px)`
            }
        },
        h2: {
            [`> .mediaInlineView-content-wrap > .${0, $dA9km.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $dA9km.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $dA9km.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $dA9km.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '31px',
                transform: `translateY(-3px)`
            }
        },
        h3: {
            [`> .mediaInlineView-content-wrap > .${0, $dA9km.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $dA9km.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $dA9km.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $dA9km.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '25px',
                transform: `translateY(-2px)`
            }
        },
        h4: {
            [`> .mediaInlineView-content-wrap > .${0, $dA9km.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $dA9km.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $dA9km.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $dA9km.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '23px',
                transform: `translateY(-2px)`
            }
        },
        h5: {
            [`> .mediaInlineView-content-wrap > .${0, $dA9km.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $dA9km.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $dA9km.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $dA9km.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '20px',
                transform: `translateY(-2px)`
            }
        },
        h6: {
            [`> .mediaInlineView-content-wrap > .${0, $dA9km.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $dA9km.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $dA9km.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $dA9km.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '18px',
                transform: `translateY(-2px)`
            }
        }
    },
    '& h1, & h2, & h3, & h4, & h5, & h6': {
        [`.${0, $a6S67.HeadingAnchorWrapperClassName}`]: {
            position: 'absolute',
            marginLeft: "var(--ds-space-075, 6px)",
            button: {
                paddingLeft: 0,
                paddingRight: 0
            },
            /**
       * Adds the visibility of the button when in focus through keyboard navigation.
       */ 'button:focus': {
                opacity: 1,
                transform: 'none !important'
            }
        },
        [`@media (hover: hover) and (pointer: fine)`]: {
            [`.${0, $a6S67.HeadingAnchorWrapperClassName}`]: {
                '> button': {
                    opacity: 0,
                    transform: `translate(-8px, 0px)`,
                    transition: `opacity 0.2s ease 0s, transform 0.2s ease 0s`
                }
            },
            '&:hover': {
                [`.${0, $a6S67.HeadingAnchorWrapperClassName} > button`]: {
                    opacity: 1,
                    transform: 'none !important'
                }
            }
        }
    },
    '& h1': {
        [`.${0, $a6S67.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${28 / 24}em`
        }
    },
    '& h2': {
        [`.${0, $a6S67.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${1.2}em`
        }
    },
    '& h3': {
        [`.${0, $a6S67.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${1.25}em`
        }
    },
    '& h4': {
        [`.${0, $a6S67.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${16 / 14}em`
        }
    },
    '& h5': {
        [`.${0, $a6S67.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${16 / 12}em`
        }
    },
    '& h6': {
        [`.${0, $a6S67.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${16 / 11}em`
        }
    },
    [`& span.akActionMark`]: {
        color: `var(--ds-link, ${(0, $7bb4c1736002a04a$export$b3de0ae08da2ce64)})`,
        textDecoration: 'none',
        cursor: 'pointer',
        '&:hover': {
            color: `var(--ds-link, ${(0, $7bb4c1736002a04a$export$e62e8919cca44969)})`,
            textDecoration: 'underline'
        },
        '&:active': {
            color: `var(--ds-link-pressed, ${(0, $7bb4c1736002a04a$export$a6ee3d71bc067634)})`
        }
    },
    '& span[data-placeholder]': {
        color: `var(--ds-text-subtlest, ${(0, $7bb4c1736002a04a$export$f563ee71e9ee74cd)})`
    }
});
const $28bec4b928772749$var$akEditorBreakpointForSmallDevice = '1266px';
const $28bec4b928772749$var$responsiveBreakoutWidth = /*#__PURE__*/ (0, $1NIU8.css)({
    '--ak-editor--breakout-container-without-gutter-width': `calc(100cqw - ${(0, $7yBx7.akEditorGutterPadding)}px * 2)`,
    // Corresponds to the legacyContentStyles from `@atlaskit/editor-core` meant to introduce responsive breakout width.
    '--ak-editor--breakout-wide-layout-width': `${(0, $7yBx7.akEditorCalculatedWideLayoutWidthSmallViewport)}px`,
    [`@media (min-width: ${$28bec4b928772749$var$akEditorBreakpointForSmallDevice})`]: {
        '--ak-editor--breakout-wide-layout-width': `${(0, $7yBx7.akEditorCalculatedWideLayoutWidth)}px`
    }
});
const $28bec4b928772749$var$responsiveBreakoutWidthFullWidth = /*#__PURE__*/ (0, $1NIU8.css)({
    '--ak-editor--breakout-container-without-gutter-width': '100cqw',
    // Corresponds to the legacyContentStyles from `@atlaskit/editor-core` meant to introduce responsive breakout width.
    '--ak-editor--breakout-wide-layout-width': `${(0, $7yBx7.akEditorCalculatedWideLayoutWidthSmallViewport)}px`,
    [`@media (min-width: ${$28bec4b928772749$var$akEditorBreakpointForSmallDevice})`]: {
        '--ak-editor--breakout-wide-layout-width': `${(0, $7yBx7.akEditorCalculatedWideLayoutWidth)}px`
    }
});
const $28bec4b928772749$var$hideHeadingCopyLinkWrapperStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    '& h1, & h2, & h3, & h4, & h5, & h6': {
        [`.${0, $a6S67.HeadingAnchorWrapperClassName}`]: {
            '&:focus-within': {
                opacity: 1
            }
        },
        [`@media (hover: hover) and (pointer: fine)`]: {
            [`.${0, $a6S67.HeadingAnchorWrapperClassName}`]: {
                opacity: 0,
                transition: `opacity 0.2s ease 0s`
            },
            '&:hover': {
                [`.${0, $a6S67.HeadingAnchorWrapperClassName}`]: {
                    opacity: 1
                }
            }
        }
    }
});
const $28bec4b928772749$var$rendererFullPageStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    maxWidth: `${(0, $7yBx7.akEditorDefaultLayoutWidth)}px`,
    margin: '0 auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    padding: `0 ${(0, $9a762f515f769003$export$12fd658e5eef0d79)}px`
});
const $28bec4b928772749$var$rendererFullWidthStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    maxWidth: `${(0, $7yBx7.akEditorFullWidthLayoutWidth)}px`,
    margin: `0 auto`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.fabric-editor-breakout-mark:not([data-has-width="true"]), .ak-renderer-extension': {
        width: '100% !important'
    }
});
const $28bec4b928772749$var$rendererFullWidthStylesForTableResizing = {
    name: "b6n1sl",
    styles: ".pm-table-container{width:100% !important;}"
};
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
const $28bec4b928772749$var$telepointerStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    [`#${$28bec4b928772749$var$TELEPOINTER_ID}`]: {
        display: 'inline-block',
        position: 'relative',
        width: '1.5px',
        height: '25px',
        backgroundColor: "var(--ds-background-brand-bold, #0C66E4)",
        marginLeft: "var(--ds-space-025, 2px)",
        '&::after': {
            content: '"AI"',
            position: 'absolute',
            display: 'block',
            top: 0,
            left: 0,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: '10px',
            fontWeight: "var(--ds-font-weight-bold, 700)",
            width: '12.5px',
            height: '13px',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            paddingTop: '1px',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            paddingLeft: '1.5px',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: 'initial',
            borderRadius: '0px 2px 2px 0px',
            color: "var(--ds-text-inverse, white)",
            backgroundColor: "var(--ds-background-brand-bold, #0C66E4)"
        }
    }
});
const $28bec4b928772749$var$whitespaceSharedStyles = {
    name: "1s8ykn2",
    styles: "word-wrap:break-word;white-space:pre-wrap"
};
const $28bec4b928772749$var$blockquoteSharedStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& blockquote': {
        boxSizing: 'border-box',
        color: 'inherit',
        width: '100%',
        display: 'inline-block',
        paddingLeft: "var(--ds-space-200, 16px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        borderLeft: `2px solid ${`var(--ds-border, ${(0, $7yBx7.akEditorBlockquoteBorderColor)})`}`,
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: `${(0, $7yBx7.blockNodesVerticalMargin)} 0 0 0`,
        marginRight: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        "[dir='rtl'] &": {
            paddingLeft: 0,
            paddingRight: "var(--ds-space-200, 16px)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:first-child': {
            marginTop: 0
        },
        '&::before': {
            content: "''"
        },
        '&::after': {
            content: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& p': {
            display: 'block'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '& table, & table:last-child': {
            display: 'inline-table'
        },
        // Workaround for overriding the inline-block display on last child of a blockquote set in CSS reset.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> .code-block:last-child, >.mediaSingleView-content-wrap:last-child, >.mediaGroupView-content-wrap:last-child': {
            display: 'block'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '> .extensionView-content-wrap:last-child': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            display: 'block'
        }
    }
});
const $28bec4b928772749$var$headingsSharedStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    '& h1': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: `${24 / 14}em`,
        fontStyle: 'inherit',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 28 / 24,
        color: "var(--ds-text, #172B4D)",
        fontWeight: "var(--ds-font-weight-medium, 500)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        letterSpacing: `-0.01em`,
        marginBottom: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.667em'
    },
    '& h2': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: `${20 / 14}em`,
        fontStyle: 'inherit',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 1.2,
        color: "var(--ds-text, #172B4D)",
        fontWeight: "var(--ds-font-weight-medium, 500)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        letterSpacing: `-0.008em`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.8em',
        marginBottom: 0
    },
    '& h3': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: `${16 / 14}em`,
        fontStyle: 'inherit',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 1.25,
        color: "var(--ds-text, #172B4D)",
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        letterSpacing: `-0.006em`,
        marginTop: "var(--ds-space-400, 2em)",
        marginBottom: 0
    },
    '& h4': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: `${1}em`,
        fontStyle: 'inherit',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 16 / 14,
        color: "var(--ds-text, #172B4D)",
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        letterSpacing: `-0.003em`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.357em'
    },
    '& h5': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: `${12 / 14}em`,
        fontStyle: 'inherit',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 16 / 12,
        color: "var(--ds-text, #172B4D)",
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.667em',
        textTransform: 'none'
    },
    '& h6': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: `${11 / 14}em`,
        fontStyle: 'inherit',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 16 / 11,
        color: "var(--ds-text-subtlest, #626F86)",
        fontWeight: "var(--ds-font-weight-bold, 700)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.455em',
        textTransform: 'none'
    }
});
const $28bec4b928772749$var$headingsSharedStylesWithEditorUGC = /*#__PURE__*/ (0, $1NIU8.css)({
    '& h1': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h1)`,
        marginBottom: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.45833em',
        '& strong': {
            // set all heading bold style to token font.weight.bold, as not matter what typography is used, the editorUGCToken will return the font weight 700
            fontWeight: "var(--ds-font-weight-bold, 700)"
        },
        '&::before': {}
    },
    '& h2': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h2)`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.4em',
        marginBottom: 0,
        '& strong': {
            // set all heading bold style to token font.weight.bold, as not matter what typography is used, the editorUGCToken will return the font weight 700
            fontWeight: "var(--ds-font-weight-bold, 700)"
        }
    },
    '& h3': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h3)`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.31249em',
        marginBottom: 0,
        '& strong': {
            // set all heading bold style to token font.weight.bold, as not matter what typography is used, the editorUGCToken will return the font weight 700
            fontWeight: "var(--ds-font-weight-bold, 700)"
        }
    },
    '& h4': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h4)`,
        marginTop: "var(--ds-space-250, 1.25em)",
        '& strong': {
            // set all heading bold style to token font.weight.bold, as not matter what typography is used, the editorUGCToken will return the font weight 700
            fontWeight: "var(--ds-font-weight-bold, 700)"
        }
    },
    '& h5': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h5)`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.45833em',
        textTransform: 'none',
        '& strong': {
            // set all heading bold style to token font.weight.bold, as not matter what typography is used, the editorUGCToken will return the font weight 700
            fontWeight: "var(--ds-font-weight-bold, 700)"
        }
    },
    '& h6': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h6)`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.59091em',
        textTransform: 'none',
        '& strong': {
            // set all heading bold style to token font.weight.bold, as not matter what typography is used, the editorUGCToken will return the font weight 700
            fontWeight: "var(--ds-font-weight-bold, 700)"
        }
    }
});
const $28bec4b928772749$var$headingWithAlignmentStyles = {
    name: "sd2n24",
    styles: ".fabric-editor-block-mark.fabric-editor-alignment:not(:first-child){> h1:first-child{margin-top:1.667em;} > h2:first-child{margin-top:1.8em;}> h3:first-child{margin-top:2em;}> h4:first-child{margin-top:1.357em;}> h5:first-child{margin-top:1.667em;}> h6:first-child{margin-top:1.455em;}}.ProseMirror-gapcursor:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .ProseMirror-widget:nth-child(2) + .fabric-editor-block-mark.fabric-editor-alignment{> :is(h1, h2, h3, h4, h5, h6):first-child{margin-top:0;}}"
};
const $28bec4b928772749$var$ruleSharedStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    '& hr': {
        border: 'none',
        backgroundColor: "var(--ds-border, #091E4224)",
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: `${(0, $7yBx7.akEditorLineHeight)}em 0`,
        height: '2px',
        borderRadius: '1px'
    }
});
const $28bec4b928772749$var$paragraphSharedStylesWithEditorUGC = /*#__PURE__*/ (0, $1NIU8.css)({
    '& p': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-normal-text)`,
        marginTop: (0, $7yBx7.blockNodesVerticalMargin),
        marginBottom: 0
    }
});
const $28bec4b928772749$var$paragraphSharedStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    '& p': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '1em',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: (0, $7yBx7.akEditorLineHeight),
        fontWeight: "var(--ds-font-weight-regular, 400)",
        marginTop: (0, $7yBx7.blockNodesVerticalMargin),
        marginBottom: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        letterSpacing: '-0.005em'
    }
});
const $28bec4b928772749$var$listsSharedStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    /* =============== INDENTATION SPACING ========= */ 'ul, ol': {
        boxSizing: 'border-box',
        paddingLeft: `var(--ed--list--item-counter--padding, ${(0, $kvnqO.listItemCounterPadding)}px)`
    },
    [`${0, $a4ifE.orderedListSelector}, ${0, $7T1su.bulletListSelector}`]: {
        /*
     Ensures list item content adheres to the list's margin instead
     of filling the entire block row. This is important to allow
     clicking interactive elements which are floated next to a list.
      For some history and context on this block, see PRs related to tickets.:
     @see ED-6551 - original issue.
     @see ED-7015 - follow up issue.
     @see ED-7447 - flow-root change.
      used to have display: 'table' in tag template style but not supported in object styles
     removed display: 'table' as 'flow-root' is supported in latest browsers
      @see https://css-tricks.com/display-flow-root/
    */ display: 'flow-root'
    },
    /* =============== INDENTATION AESTHETICS ========= */ /**
  	We support nested lists up to six levels deep.
  **/ /* LEGACY LISTS */ 'ul, ul ul ul ul': {
        listStyleType: 'disc'
    },
    'ul ul, ul ul ul ul ul': {
        listStyleType: 'circle'
    },
    'ul ul ul, ul ul ul ul ul ul': {
        listStyleType: 'square'
    },
    'ol, ol ol ol ol': {
        listStyleType: 'decimal'
    },
    'ol ol, ol ol ol ol ol': {
        listStyleType: 'lower-alpha'
    },
    'ol ol ol, ol ol ol ol ol ol': {
        listStyleType: 'lower-roman'
    },
    /* PREDICTABLE LISTS */ 'ol[data-indent-level="1"], ol[data-indent-level="4"]': {
        listStyleType: 'decimal'
    },
    'ol[data-indent-level="2"], ol[data-indent-level="5"]': {
        listStyleType: 'lower-alpha'
    },
    'ol[data-indent-level="3"], ol[data-indent-level="6"]': {
        listStyleType: 'lower-roman'
    },
    'ul[data-indent-level="1"], ul[data-indent-level="4"]': {
        listStyleType: 'disc'
    },
    'ul[data-indent-level="2"], ul[data-indent-level="5"]': {
        listStyleType: 'circle'
    },
    'ul[data-indent-level="3"], ul[data-indent-level="6"]': {
        listStyleType: 'square'
    }
});
/*
	Firefox does not handle empty block element inside li tag.
	If there is not block element inside li tag,
	then firefox sets inherited height to li
	However, if there is any block element and if it's empty
	(or has empty inline element) then
	firefox sets li tag height to zero.
	More details at
	https://product-fabric.atlassian.net/wiki/spaces/~455502413/pages/3149365890/ED-14110+Investigation
*/ const $28bec4b928772749$var$listsSharedStylesForGekko = {
    name: "jlg15n",
    styles: "ul, ol{li p:empty, li p > span:empty{display:inline-block;}}"
};
const $28bec4b928772749$var$indentationSharedStyles = {
    name: "1bgz9nd",
    styles: ".fabric-editor-indentation-mark{&[data-level='1']{margin-left:30px;}&[data-level='2']{margin-left:60px;}&[data-level='3']{margin-left:90px;}&[data-level='4']{margin-left:120px;}&[data-level='5']{margin-left:150px;}&[data-level='6']{margin-left:180px;}}"
};
const $28bec4b928772749$var$indentationSharedStylesWithMarginFix = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.fabric-editor-indentation-mark': {
        // Prevent marginTop of p:first-child overrode by batch.css
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        'p:first-child': {
            marginTop: (0, $7yBx7.blockNodesVerticalMargin)
        }
    }
});
const $28bec4b928772749$var$blockMarksSharedStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    /**
   * We need to remove margin-top from first item
   * inside doc, tableCell, tableHeader, blockquote, etc.
   */ [`*:not(.fabric-editor-block-mark) >,
  	*:not(.fabric-editor-block-mark) >
    div.fabric-editor-block-mark:first-of-type
	:not(.fabric-editor-indentation-mark)
	:not(.fabric-editor-alignment),
  	.fabric-editor-alignment:first-of-type:first-child,
  	.ProseMirror .fabric-editor-indentation-mark:first-of-type:first-child`]: {
        'p, h1, h2, h3, h4, h5, h6, .heading-wrapper': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            ':first-child:not(style), style:first-child + *': {
                marginTop: 0
            }
        }
    }
});
const $28bec4b928772749$var$codeMarkSharedStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.code': {
        '--ds--code--bg-color': "var(--ds-background-neutral, #091E420F)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '0.875em',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
        fontWeight: "var(--ds-font-weight-regular, 400)",
        backgroundColor: `var(--ds--code--bg-color,${`var(--ds-background-neutral, ${(0, $7bb4c1736002a04a$export$9fdfb749e33cdf97)})`})`,
        color: `var(--ds-text, ${(0, $7bb4c1736002a04a$export$7d61b15e0da132af)})`,
        borderStyle: 'none',
        borderRadius: "var(--ds-border-radius, 3px)",
        display: 'inline',
        padding: '2px 0.5ch',
        boxDecorationBreak: 'clone',
        overflow: 'auto',
        overflowWrap: 'break-word',
        whiteSpace: 'pre-wrap'
    }
});
const $28bec4b928772749$var$shadowSharedStyle = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $k6yTf.shadowClassNames).RIGHT_SHADOW}::before, .${(0, $k6yTf.shadowClassNames).RIGHT_SHADOW}::after, .${(0, $k6yTf.shadowClassNames).LEFT_SHADOW}::before, .${(0, $k6yTf.shadowClassNames).LEFT_SHADOW}::after`]: {
        display: 'none',
        position: 'absolute',
        pointerEvents: 'none',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: (0, $7yBx7.akEditorShadowZIndex),
        width: '8px',
        content: "''",
        height: 'calc(100%)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $k6yTf.shadowClassNames).RIGHT_SHADOW}, .${(0, $k6yTf.shadowClassNames).LEFT_SHADOW}`]: {
        position: 'relative'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $k6yTf.shadowClassNames).LEFT_SHADOW}::before`]: {
        background: `linear-gradient( to left, transparent 0, ${"var(--ds-shadow-overflow-spread, #091e4229)"} 140% ), linear-gradient( to right, ${"var(--ds-shadow-overflow-perimeter, transparent)"} 0px, transparent 1px )`,
        top: '0px',
        left: 0,
        display: 'block'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $k6yTf.shadowClassNames).RIGHT_SHADOW}::after`]: {
        background: `linear-gradient( to right, transparent 0, ${"var(--ds-shadow-overflow-spread, #091e4229)"} 140% ), linear-gradient( to left, ${"var(--ds-shadow-overflow-perimeter, transparent)"} 0px, transparent 1px )`,
        right: '0px',
        top: '0px',
        display: 'block'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $3gw29.shadowObserverClassNames).SENTINEL_LEFT}`]: {
        height: '100%',
        width: '0px',
        minWidth: '0px'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $3gw29.shadowObserverClassNames).SENTINEL_RIGHT}`]: {
        height: '100%',
        width: '0px',
        minWidth: '0px'
    }
});
const $28bec4b928772749$var$dateSharedStyle = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${(0, $fDsDd.DateSharedCssClassName).DATE_WRAPPER} span`]: {
        whiteSpace: 'unset'
    }
});
const $28bec4b928772749$var$textColorStyles = {
    name: "1nlqh0j",
    styles: ".fabric-text-color-mark{color:var(--custom-palette-color, inherit);}a .fabric-text-color-mark{color:unset;}"
};
const $28bec4b928772749$var$backgroundColorStyles = {
    name: "7ixjog",
    styles: ".fabric-background-color-mark{background-color:var(--custom-palette-color, inherit);border-radius:2px;padding-top:1px;padding-bottom:2px;box-decoration-break:clone;}a .fabric-background-color-mark{background-color:unset;}.fabric-background-color-mark .ak-editor-annotation{background-color:unset;}"
};
const $28bec4b928772749$var$tasksAndDecisionsStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    '.ProseMirror': {
        [`.taskItemView-content-wrap,
		.${(0, $gZAVf.TaskDecisionSharedCssClassName).DECISION_CONTAINER}`]: {
            position: 'relative',
            minWidth: `${(0, $7yBx7.akEditorTableCellMinWidth)}px`
        },
        [`.${(0, $gZAVf.TaskDecisionSharedCssClassName).DECISION_CONTAINER}`]: {
            marginTop: 0
        },
        [`.${(0, $gZAVf.TaskDecisionSharedCssClassName).TASK_CONTAINER}`]: {
            'span[contenteditable="false"]': {
                height: `${(0, $7yBx7.akEditorLineHeight)}em`
            }
        },
        [`.${(0, $gZAVf.TaskDecisionSharedCssClassName).TASK_ITEM}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: (0, $7yBx7.akEditorLineHeight)
        }
    },
    'div[data-task-local-id]': {
        'span[contenteditable="false"]': {
            height: `${(0, $7yBx7.akEditorLineHeight)}em`
        },
        'span[contenteditable="false"] + div': {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${(0, $7yBx7.akEditorLineHeight)}em`
        }
    },
    'div[data-task-list-local-id]': {
        margin: `${"var(--ds-space-150, 12px)"} 0 0 0`,
        // If task item is not first in the list then set margin top to 4px.
        'div + div': {
            marginTop: "var(--ds-space-050, 4px)"
        }
    },
    // If task list is not first in the document then set margin top to 4px.
    'div[data-task-list-local-id] div[data-task-list-local-id]': {
        marginTop: "var(--ds-space-050, 4px)",
        marginLeft: "var(--ds-space-300, 24px)"
    },
    /* When action list is inside panel */ '.ak-editor-panel__content': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> div[data-task-list-local-id]:first-child': {
            margin: '0 0 0 0 !important'
        }
    }
});
const $28bec4b928772749$var$smartCardStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    [`.${(0, $e2Ny4.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER}`]: {
        display: 'block',
        margin: `${(0, $7yBx7.blockNodesVerticalMargin)} 0 0`,
        maxWidth: `${760}px`
    }
});
const $28bec4b928772749$var$smartCardStylesAvatarFix = /*#__PURE__*/ (0, $1NIU8.css)({
    [`.${(0, $e2Ny4.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER}`]: {
        /* EDM-11991: Fix list plugin adding padding to ADS AvatarGroup start */ 'ul, ol': {
            paddingLeft: 'inherit'
        }
    }
});
const $28bec4b928772749$var$smartCardStylesAvatarMarginFix = /*#__PURE__*/ (0, $1NIU8.css)({
    [`.${(0, $e2Ny4.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER}`]: {
        'ul, ol': {
            marginRight: 'inherit'
        }
    }
});
const $28bec4b928772749$var$baseOtherStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    '& .UnknownBlock': {
        fontFamily: "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: `${0.875}rem`,
        fontWeight: "var(--ds-font-weight-regular, 400)",
        whiteSpace: 'pre-wrap',
        wordWrap: 'break-word'
    },
    '& span.date-node': {
        background: `var(--ds-background-neutral, ${(0, $7bb4c1736002a04a$export$920c0d5c49070351)})`,
        borderRadius: "var(--ds-border-radius-100, 3px)",
        color: `var(--ds-text, ${(0, $7bb4c1736002a04a$export$7d61b15e0da132af)})`,
        padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-050, 4px)"}`,
        margin: `0 1px`,
        transition: `background 0.3s`
    },
    '& span.date-node-highlighted': {
        background: `var(--ds-background-danger, ${(0, $7bb4c1736002a04a$export$4b84fd0e2c617bd)})`,
        color: `var(--ds-text-danger, ${(0, $7bb4c1736002a04a$export$2837b5a1a71d5c02)})`
    },
    '& .renderer-image': {
        maxWidth: '100%',
        display: 'block',
        margin: `${"var(--ds-space-300, 24px)"} 0`
    },
    [`.${0, $laqWo.richMediaClassName}.rich-media-wrapped + .${0, $laqWo.richMediaClassName}:not(.rich-media-wrapped)`]: {
        clear: 'both'
    },
    [`& .code-block,
	& blockquote,
	& hr,
	& > div > div:not(.rich-media-wrapped),
	.${0, $laqWo.richMediaClassName}.rich-media-wrapped + .rich-media-wrapped + *:not(.rich-media-wrapped),
	.${0, $laqWo.richMediaClassName}.rich-media-wrapped + div:not(.rich-media-wrapped),
	.${0, $laqWo.richMediaClassName}.image-align-start,
		.${0, $laqWo.richMediaClassName}.image-center,
		.${0, $laqWo.richMediaClassName}.image-align-end`]: {
        clear: 'both'
    },
    '& .rich-media-wrapped': {
        '& + h1, & + h2, & + h3, & + h4, & + h5, & + h6': {
            marginTop: "var(--ds-space-100, 8px)"
        }
    },
    // originally copied the block after mediaSharedStyle
    'div[class^="image-wrap-"] + div[class^="image-wrap-"]': {
        marginLeft: 0,
        marginRight: 0
    },
    /* Breakout for tables and extensions */ [`.${(0, $iRC0e.RendererCssClassName).DOCUMENT} >`]: {
        [`*:not([data-mark-type='fragment']) .${(0, $cjLtO.TableSharedCssClassName).TABLE_CONTAINER}`]: {
            // Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
            // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
            // TODO - improve inline style logic on table container so important styles aren't required here
            width: '100% !important',
            left: '0 !important'
        },
        [`[data-mark-type='fragment'] * .${(0, $cjLtO.TableSharedCssClassName).TABLE_CONTAINER}`]: {
            // Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
            // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
            // TODO - improve inline style logic on table container so important styles aren't required here
            width: '100% !important',
            left: '0 !important'
        },
        [`* .${(0, $iRC0e.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER}`]: {
            overflowX: 'auto'
        },
        [`& .${(0, $iRC0e.RendererCssClassName).EXTENSION}:first-child`]: {
            marginTop: 0
        }
    },
    [`.${(0, $iRC0e.RendererCssClassName).DOCUMENT}`]: {
        [`.${(0, $iRC0e.RendererCssClassName).EXTENSION}`]: {
            marginTop: `${(0, $7yBx7.blockNodesVerticalMargin)}`
        },
        [`.${(0, $iRC0e.RendererCssClassName).EXTENSION_CENTER_ALIGN}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginLeft: '50%',
            transform: 'translateX(-50%)'
        },
        [`.${(0, $cjLtO.TableSharedCssClassName).TABLE_NODE_WRAPPER}`]: {
            overflowX: 'auto'
        },
        [`.${(0, $3gw29.shadowObserverClassNames).SHADOW_CONTAINER} .${(0, $cjLtO.TableSharedCssClassName).TABLE_NODE_WRAPPER}`]: {
            display: 'flex'
        }
    }
});
const $28bec4b928772749$var$alignedHeadingAnchorStyle = /*#__PURE__*/ (0, $1NIU8.css)({
    // Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO Delete this comment after verifying space token -> previous value `margin: 6px`
    '.fabric-editor-block-mark[data-align] >': {
        'h1, h2, h3, h4, h5, h6': {
            position: 'relative'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.fabric-editor-block-mark:not([data-align="center"])[data-align]': {
        [`.${0, $a6S67.HeadingAnchorWrapperClassName}`]: {
            margin: `0 ${"var(--ds-space-075, 6px)"} 0 0`,
            // If the anchor is right aligned then the left side of the heading
            // is aligned with the left side of the anchor.
            // In order to align as expected we transform it the width of the element (plus our expected 6px)
            // to the left
            transform: `translateX(calc(-100% - ${"var(--ds-space-075, 6px)"}))`
        },
        '@media (hover: hover) and (pointer: fine)': {
            [`.${0, $a6S67.HeadingAnchorWrapperClassName} > button`]: {
                transform: `translate(8px, 0px)`
            }
        }
    }
});
// Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
// eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
// TODO: emotion refactor - there's a mediaSingleSharedNewStyle, but not originally used in the renderer.
const $28bec4b928772749$var$mediaSingleSharedStyle = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`li .${0, $laqWo.richMediaClassName}`]: {
        margin: 0
    },
    // Hack for chrome to fix media single position inside a list when media is the first child
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-chrome li > .mediaSingleView-content-wrap::before': {
        content: "''",
        display: 'block',
        height: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-firefox': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.mediaSingleView-content-wrap': {
            userSelect: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.captionView-content-wrap': {
            userSelect: 'text'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    ".mediaSingleView-content-wrap[layout='center']": {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`table .${0, $laqWo.richMediaClassName}`]: {
        marginTop: "var(--ds-space-150, 12px)",
        marginBottom: "var(--ds-space-150, 12px)",
        clear: 'both',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&.image-wrap-left[data-layout], &.image-wrap-right[data-layout]': {
            clear: 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '&:first-child': {
                marginTop: "var(--ds-space-150, 12px)"
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${0, $laqWo.richMediaClassName}.image-wrap-right + .${0, $laqWo.richMediaClassName}.image-wrap-left`]: {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${0, $laqWo.richMediaClassName}.image-wrap-left + .${0, $laqWo.richMediaClassName}.image-wrap-right, .${0, $laqWo.richMediaClassName}.image-wrap-right + .${0, $laqWo.richMediaClassName}.image-wrap-left, .${0, $laqWo.richMediaClassName}.image-wrap-left + .${0, $laqWo.richMediaClassName}.image-wrap-left, .${0, $laqWo.richMediaClassName}.image-wrap-right + .${0, $laqWo.richMediaClassName}.image-wrap-right`]: {
        marginRight: 0,
        marginLeft: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`@media all and (max-width: ${$28bec4b928772749$var$wrappedMediaBreakoutPoint}px)`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "div.mediaSingleView-content-wrap[layout='wrap-left'], div.mediaSingleView-content-wrap[data-layout='wrap-left'], div.mediaSingleView-content-wrap[layout='wrap-right'], div.mediaSingleView-content-wrap[data-layout='wrap-right']": {
            float: 'none',
            overflow: 'auto',
            margin: `${"var(--ds-space-150, 12px)"} 0`
        }
    }
});
// was shared between editor-core and renderer
const $28bec4b928772749$var$tableSharedStyle = /*#__PURE__*/ (0, $1NIU8.css)({
    // originally from packages/editor/editor-common/src/styles/shared/tableCell.ts
    // Hardcoding the background color for the table cells to avoid the use of inline styles
    'td[colorname="white" i], th[colorname="white" i]': {
        backgroundColor: `${"var(--ds-surface, #FFFFFF)"} !important`
    },
    'td[colorname="light blue" i], th[colorname="light blue" i]': {
        backgroundColor: `${"var(--ds-background-accent-blue-subtlest, #DEEBFF)"} !important`
    },
    'td[colorname="light teal" i], th[colorname="light teal" i]': {
        backgroundColor: `${"var(--ds-background-accent-teal-subtlest, #E6FCFF)"} !important`
    },
    'td[colorname="light green" i], th[colorname="light green" i]': {
        backgroundColor: `${"var(--ds-background-accent-green-subtlest, #E3FCEF)"} !important`
    },
    'td[colorname="light yellow" i], th[colorname="light yellow" i]': {
        backgroundColor: `${"var(--ds-background-accent-yellow-subtlest, #FFFAE6)"} !important`
    },
    'td[colorname="light red" i], th[colorname="light red" i]': {
        backgroundColor: `${"var(--ds-background-accent-red-subtlest, #FFEBE6)"} !important`
    },
    'td[colorname="light purple" i], th[colorname="light purple" i]': {
        backgroundColor: `${"var(--ds-background-accent-purple-subtlest, #EAE6FF)"} !important`
    },
    'td[colorname="light gray" i], th[colorname="light gray" i]': {
        backgroundColor: `${"var(--ds-background-accent-gray-subtlest, #F4F5F7)"} !important`
    },
    'td[colorname="blue" i], th[colorname="blue" i]': {
        backgroundColor: `${"var(--ds-background-accent-blue-subtler, #B3D4FF)"} !important`
    },
    'td[colorname="teal" i], th[colorname="teal" i]': {
        backgroundColor: `${"var(--ds-background-accent-teal-subtler, #B3F5FF)"} !important`
    },
    'td[colorname="green" i], th[colorname="green" i]': {
        backgroundColor: `${"var(--ds-background-accent-green-subtler, #ABF5D1)"} !important`
    },
    'td[colorname="yellow" i], th[colorname="yellow" i]': {
        backgroundColor: `${"var(--ds-background-accent-yellow-subtler, #FFF0B3)"} !important`
    },
    'td[colorname="red" i], th[colorname="red" i]': {
        backgroundColor: `${"var(--ds-background-accent-red-subtler, #FFBDAD)"} !important`
    },
    'td[colorname="purple" i], th[colorname="purple" i]': {
        backgroundColor: `${"var(--ds-background-accent-purple-subtler, #C0B6F2)"} !important`
    },
    'td[colorname="gray" i], th[colorname="gray" i]': {
        backgroundColor: `${"var(--ds-background-accent-gray-subtle, #B3BAC5)"} !important`
    },
    'td[colorname="dark blue" i], th[colorname="dark blue" i]': {
        backgroundColor: `${"var(--ds-background-accent-blue-subtle, #4C9AFF)"} !important`
    },
    'td[colorname="dark teal" i], th[colorname="dark teal" i]': {
        backgroundColor: `${"var(--ds-background-accent-teal-subtle, #79E2F2)"} !important`
    },
    'td[colorname="dark green" i], th[colorname="dark green" i]': {
        backgroundColor: `${"var(--ds-background-accent-green-subtle, #57D9A3)"} !important`
    },
    'td[colorname="dark yellow" i], th[colorname="dark yellow" i]': {
        backgroundColor: `${"var(--ds-background-accent-orange-subtle, #FFC400)"} !important`
    },
    'td[colorname="dark red" i], th[colorname="dark red" i]': {
        backgroundColor: `${"var(--ds-background-accent-red-subtle, #FF8F73)"} !important`
    },
    'td[colorname="dark purple" i], th[colorname="dark purple" i]': {
        backgroundColor: `${"var(--ds-background-accent-purple-subtle, #998DD9)"} !important`
    },
    [`.${(0, $cjLtO.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        position: 'relative',
        margin: `0 auto ${"var(--ds-space-200, 16px)"}`,
        boxSizing: 'border-box',
        /**
     * Fix block top alignment inside table cells.
     */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '.decisionItemView-content-wrap:first-of-type > div': {
            marginTop: 0
        }
    },
    [`.${(0, $cjLtO.TableSharedCssClassName).TABLE_CONTAINER}[data-number-column='true']`]: {
        paddingLeft: `${(0, $7yBx7.akEditorTableNumberColumnWidth) - 1}px`,
        clear: 'both'
    },
    [`.${(0, $cjLtO.TableSharedCssClassName).TABLE_RESIZER_CONTAINER}`]: {
        willChange: 'width, margin-left'
    },
    [`.${(0, $cjLtO.TableSharedCssClassName).TABLE_RESIZER_CONTAINER} table`]: {
        willChange: 'width'
    },
    [`.${(0, $cjLtO.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table`]: {
        margin: `${"var(--ds-space-300, 24px)"} 0 0 0`
    },
    [`.${(0, $cjLtO.TableSharedCssClassName).TABLE_CONTAINER} > table,
	.${(0, $cjLtO.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        margin: `${"var(--ds-space-300, 24px)"} ${"var(--ds-space-100, 8px)"} 0 0`
    },
    /* avoid applying styles to nested tables (possible via extensions) */ [`.${(0, $cjLtO.TableSharedCssClassName).TABLE_CONTAINER} > table,
	.${(0, $cjLtO.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
	.${(0, $cjLtO.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        borderCollapse: 'collapse',
        border: `${(0, $cjLtO.tableCellBorderWidth)}px solid ${`var(--ds-background-accent-gray-subtler, ${(0, $7yBx7.akEditorTableBorder)})`}`,
        tableLayout: 'fixed',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '1em',
        width: '100%',
        '&[data-autosize="true"]': {
            tableLayout: 'auto'
        },
        '*': {
            boxSizing: 'border-box'
        },
        hr: {
            boxSizing: 'content-box'
        },
        tbody: {
            borderBottom: 'none'
        },
        'th td': {
            backgroundColor: "var(--ds-background-neutral-subtle, white)"
        },
        '> tbody > tr > td': {
            backgroundColor: "var(--ds-surface, #FFFFFF)"
        },
        th: {
            backgroundColor: `var(--ds-background-accent-gray-subtlest, ${(0, $7yBx7.akEditorTableToolbar)})`,
            textAlign: 'left',
            /* only apply this styling to codeblocks in default background headercells */ /* TODO this needs to be overhauled as it relies on unsafe selectors */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not([style]):not(.danger)': {
                [`.${(0, $gBkUB.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER}:not(.danger)`]: {
                    backgroundColor: "var(--ds-surface-raised, rgb(235, 237, 240))",
                    [`&:not(.${0, $7yBx7.akEditorSelectedNodeClassName})`]: {
                        boxShadow: `0px 0px 0px 1px ${"var(--ds-border, transparent)"}`
                    },
                    [`.${(0, $gBkUB.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER}`]: {
                        // originally copied from packages/editor/editor-shared-styles/src/overflow-shadow/overflow-shadow.ts
                        backgroundImage: `linear-gradient(
							to right,
							${"var(--ds-background-neutral, #091E420F)"} ${"var(--ds-space-300, 24px)"},
							transparent ${"var(--ds-space-300, 24px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-300, 24px)"},
							transparent ${"var(--ds-space-300, 24px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-background-neutral, #091E420F)"} ${"var(--ds-space-100, 8px)"},
							transparent ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-100, 8px)"},
							transparent ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-shadow-overflow-spread, #091e4229)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-shadow-overflow-perimeter, #091e421f)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-shadow-overflow-spread, #091e4229)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-shadow-overflow-perimeter, #091e421f)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  )`,
                        backgroundColor: "var(--ds-background-neutral, rgb(235, 237, 240))"
                    },
                    [`.${(0, $gBkUB.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER}`]: {
                        backgroundColor: "var(--ds-background-neutral, rgb(226, 229, 233))"
                    },
                    /* this is only relevant to the element taken care of by renderer */ '> [data-ds--code--code-block]': {
                        // originally copied from packages/editor/editor-shared-styles/src/overflow-shadow/overflow-shadow.ts
                        backgroundImage: `linear-gradient(
							to right,
							${"var(--ds-background-neutral, #091E420F)"} ${"var(--ds-space-300, 24px)"},
							transparent ${"var(--ds-space-300, 24px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-300, 24px)"},
							transparent ${"var(--ds-space-300, 24px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-background-neutral, #091E420F)"} ${"var(--ds-space-100, 8px)"},
							transparent ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-100, 8px)"},
							transparent ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-shadow-overflow-spread, #091e4229)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-shadow-overflow-perimeter, #091e421f)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-shadow-overflow-spread, #091e4229)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-shadow-overflow-perimeter, #091e421f)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  )`,
                        backgroundColor: `${"var(--ds-background-neutral, rgb(235, 237, 240))"}!important`,
                        // selector lives inside @atlaskit/code
                        '--ds--code--line-number-bg-color': "var(--ds-background-neutral, rgb(226, 229, 233))"
                    }
                }
            }
        }
    }
});
const $28bec4b928772749$var$tableRendererHeaderStylesForTableCellOnly = /*#__PURE__*/ (0, $1NIU8.css)({
    [`.${(0, $cjLtO.TableSharedCssClassName).TABLE_CONTAINER} > table,
		.${(0, $cjLtO.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
		.${(0, $cjLtO.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        // platform_editor_renderer_table_header_styles has already been launched, so assume it's on
        '> tbody > tr > th, > tbody > tr > td': {
            minWidth: `${(0, $cjLtO.tableCellMinWidth)}px`,
            fontWeight: "var(--ds-font-weight-regular, 400)",
            verticalAlign: 'top',
            border: `1px solid ${`var(--ds-background-accent-gray-subtler, ${(0, $7yBx7.akEditorTableBorder)})`}`,
            borderRightWidth: 0,
            borderBottomWidth: 0,
            padding: "var(--ds-space-100, 8px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            'th p:not(:first-of-type), td p:not(:first-of-type)': {
                marginTop: "var(--ds-space-150, 12px)"
            }
        }
    }
});
const $28bec4b928772749$var$tableRendererNestedPanelStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    [`.${(0, $cjLtO.TableSharedCssClassName).TABLE_CONTAINER} .ak-editor-panel`]: {
        border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #d9dbea)"}`
    }
});
const $28bec4b928772749$var$tableStylesBackGroundClipForGeckoForTableCellOnly = /*#__PURE__*/ (0, $1NIU8.css)({
    [`.${(0, $cjLtO.TableSharedCssClassName).TABLE_CONTAINER} > table,
		.${(0, $cjLtO.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
		.${(0, $cjLtO.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> tbody > tr > th, > tbody > tr > td': {
            backgroundClip: 'padding-box'
        }
    }
});
const $28bec4b928772749$var$firstNodeWithNotMarginTopWithNestedDnD = /*#__PURE__*/ (0, $1NIU8.css)({
    [`.${(0, $cjLtO.TableSharedCssClassName).TABLE_CONTAINER} > table,
		.${(0, $cjLtO.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
		.${(0, $cjLtO.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        '> tbody > tr > th, > tbody > tr > td': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '> :nth-child(1 of :not(style, .ProseMirror-gapcursor, .ProseMirror-widget, span))': {
                marginTop: 0
            }
        }
    }
});
const $28bec4b928772749$var$firstNodeWithNotMarginTop = /*#__PURE__*/ (0, $1NIU8.css)({
    [`.${(0, $cjLtO.TableSharedCssClassName).TABLE_CONTAINER} > table,
		.${(0, $cjLtO.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
		.${(0, $cjLtO.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        '> tbody > tr > th, > tbody > tr > td': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '> :first-child:not(style), > style:first-child + *': {
                marginTop: 0
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '> .ProseMirror-gapcursor:first-child + *, > style:first-child + .ProseMirror-gapcursor + *': {
                marginTop: 0
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '> .ProseMirror-gapcursor:first-child + span + *, > style:first-child + .ProseMirror-gapcursor + span + *': {
                marginTop: 0
            }
        }
    }
});
const $28bec4b928772749$var$rendererTableStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    [`.${(0, $iRC0e.RendererCssClassName).DOCUMENT} .${(0, $cjLtO.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        zIndex: 0,
        transition: `all 0.1s linear`,
        display: 'flex' /* needed to avoid position: fixed jumpiness in Chrome */ ,
        /** Shadow overrides */ [`&.${(0, $k6yTf.shadowClassNames).RIGHT_SHADOW}::after, &.${(0, $k6yTf.shadowClassNames).LEFT_SHADOW}::before`]: {
            top: `${(0, $cjLtO.tableMarginTop) - 1}px`,
            height: `calc(100% - ${(0, $cjLtO.tableMarginTop)}px)`,
            zIndex: `${(0, $7yBx7.akEditorStickyHeaderZIndex)}`,
            width: `${$28bec4b928772749$var$tableShadowWidth}px`,
            background: `linear-gradient(
					to left,
					transparent 0,
					${`var(--ds-shadow-overflow-spread, ${(0, $7bb4c1736002a04a$export$46987b49aab6d1a8)})`} 140%
				),
				linear-gradient(
					to right,
					${"var(--ds-shadow-overflow-perimeter, transparent)"} 0px,
					transparent 1px
				)`
        },
        [`&.${(0, $k6yTf.shadowClassNames).RIGHT_SHADOW}::after`]: {
            background: `linear-gradient(
					to right,
					transparent 0,
					${`var(--ds-shadow-overflow-spread, ${(0, $7bb4c1736002a04a$export$46987b49aab6d1a8)})`} 140%
				),
				linear-gradient(
					to left,
					${"var(--ds-shadow-overflow-perimeter, transparent)"} 0px,
					transparent 1px
				)`,
            right: `0px`
        },
        [`&
          .${(0, $3gw29.shadowObserverClassNames).SENTINEL_LEFT},
          &
          .${(0, $3gw29.shadowObserverClassNames).SENTINEL_RIGHT}`]: {
            height: `calc(100% - ${(0, $cjLtO.tableMarginTop)}px)`
        }
    }
});
const $28bec4b928772749$var$stickyScrollbarStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    [`.${(0, $iRC0e.RendererCssClassName).DOCUMENT} .${(0, $cjLtO.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        position: 'relative',
        flexDirection: 'column',
        [`> .${(0, $cjLtO.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER}`]: {
            width: '100%',
            display: 'block',
            visibility: 'hidden',
            overflowX: 'auto',
            position: 'sticky',
            bottom: `${"var(--ds-space-0, 0px)"}`,
            zIndex: 1
        },
        [`> .${(0, $cjLtO.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM},
		> .${(0, $cjLtO.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP}`]: {
            position: 'absolute',
            width: '100%',
            height: '1px',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginTop: '-1px',
            // need this to avoid sentinel being focused via keyboard
            // this still allows it to be detected by intersection observer
            visibility: 'hidden'
        },
        [`> .${(0, $cjLtO.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP}`]: {
            top: `${$28bec4b928772749$var$tableRowHeight * 3}px`
        },
        [`> .${(0, $cjLtO.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM}`]: {
            bottom: `${"var(--ds-space-250, 20px)"}` // MAX_BROWSER_SCROLLBAR_HEIGHT = 20;
        }
    }
});
const $28bec4b928772749$var$rendererTableHeaderEqualHeightStylesForTableCellOnly = /*#__PURE__*/ (0, $1NIU8.css)({
    [`.${(0, $iRC0e.RendererCssClassName).DOCUMENT} .${(0, $cjLtO.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        [`.${(0, $cjLtO.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table, .${(0, $cjLtO.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
            height: '1px' /* will be ignored */ ,
            marginLeft: 0,
            marginRight: 0
        }
    },
    [`.${(0, $cjLtO.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table > tbody > tr:first-of-type, .${(0, $cjLtO.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table > tbody > tr:first-of-type`]: {
        height: '100%',
        'td, th': {
            position: 'relative'
        }
    }
});
const $28bec4b928772749$var$rendererTableSortableColumnStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    [`.${(0, $iRC0e.RendererCssClassName).DOCUMENT} .${(0, $cjLtO.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        [`.${(0, $cjLtO.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table, .${(0, $cjLtO.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
            // allow nested heading links
            [`.${(0, $iRC0e.RendererCssClassName).SORTABLE_COLUMN_WRAPPER}`]: {
                padding: 0,
                [`.${(0, $iRC0e.RendererCssClassName).SORTABLE_COLUMN}`]: {
                    width: '100%',
                    height: '100%',
                    padding: `${(0, $cjLtO.tableCellPadding)}px`,
                    borderWidth: '1.5px',
                    borderStyle: 'solid',
                    borderColor: `transparent`,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
                    '> *:first-child': {
                        marginTop: 0
                    },
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
                    '> .ProseMirror-gapcursor:first-child + *, > style:first-child + .ProseMirror-gapcursor + *': {
                        marginTop: 0
                    },
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
                    '> .ProseMirror-gapcursor:first-child + span + *, > style:first-child + .ProseMirror-gapcursor + span + *': {
                        marginTop: 0
                    },
                    '@supports selector(:focus-visible)': {
                        '&:focus': {
                            outline: 'unset'
                        },
                        '&:focus-visible': {
                            borderColor: `${`var(--ds-border-focused, ${(0, $7bb4c1736002a04a$export$e62e8919cca44969)})`}`
                        }
                    }
                },
                [`> .${(0, $iRC0e.RendererCssClassName).SORTABLE_COLUMN} > .${(0, $iRC0e.RendererCssClassName).SORTABLE_COLUMN_ICON_WRAPPER}`]: {
                    margin: 0,
                    [`.${0, $438179c68884651b$export$bd4f24d8b1e86b23}`]: {
                        opacity: 1,
                        transition: `opacity 0.2s ease-in-out`
                    }
                },
                [`> .${(0, $iRC0e.RendererCssClassName).SORTABLE_COLUMN}
						> .${(0, $iRC0e.RendererCssClassName).SORTABLE_COLUMN_NO_ORDER}`]: {
                    [`.${0, $438179c68884651b$export$bd4f24d8b1e86b23}`]: {
                        opacity: 0,
                        '&:focus': {
                            opacity: 1
                        }
                    }
                },
                [`&:hover:not(
							:has(
									.${(0, $iRC0e.RendererCssClassName).SORTABLE_COLUMN_WRAPPER}
										.${(0, $iRC0e.RendererCssClassName).SORTABLE_COLUMN}:hover
								)
						)
						> .${(0, $iRC0e.RendererCssClassName).SORTABLE_COLUMN}
						> .${(0, $iRC0e.RendererCssClassName).SORTABLE_COLUMN_NO_ORDER}`]: {
                    [`.${0, $438179c68884651b$export$bd4f24d8b1e86b23}`]: {
                        opacity: 1
                    }
                }
            }
        }
    }
});
// TODO: ED-27229 - Cleanup with `platform_editor_tables_numbered_column_correction`
const $28bec4b928772749$var$rendererTableColumnStylesOld = /*#__PURE__*/ (0, $1NIU8.css)({
    [`.${(0, $iRC0e.RendererCssClassName).DOCUMENT} .${(0, $cjLtO.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        'table[data-number-column="true"]': {
            [`.${(0, $iRC0e.RendererCssClassName).NUMBER_COLUMN}`]: {
                backgroundColor: `${`var(--ds-background-neutral, ${(0, $7yBx7.akEditorTableToolbar)})`}`,
                borderRight: `1px solid
								${`var(--ds-background-accent-gray-subtler, ${(0, $7yBx7.akEditorTableBorder)})`}`,
                width: `${(0, $7yBx7.akEditorTableNumberColumnWidth)}px`,
                textAlign: 'center',
                color: `${`var(--ds-text-subtlest, ${(0, $7bb4c1736002a04a$export$f563ee71e9ee74cd)})`}`,
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                fontSize: `${0.875} rem`
            },
            [`.fixed .${(0, $iRC0e.RendererCssClassName).NUMBER_COLUMN}`]: {
                borderRight: `0px none`
            }
        }
    }
});
const $28bec4b928772749$var$rendererTableColumnStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    [`.${(0, $iRC0e.RendererCssClassName).DOCUMENT} .${(0, $cjLtO.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        'table[data-number-column="true"]': {
            [`.${(0, $iRC0e.RendererCssClassName).NUMBER_COLUMN}`]: {
                backgroundColor: `${"var(--ds-background-accent-gray-subtlest, #F1F2F4)"}`,
                borderRight: `1px solid
								${`var(--ds-background-accent-gray-subtler, ${(0, $7yBx7.akEditorTableBorder)})`}`,
                width: `${(0, $7yBx7.akEditorTableNumberColumnWidth)}px`,
                textAlign: 'center',
                color: `${`var(--ds-text-subtlest, ${(0, $7bb4c1736002a04a$export$f563ee71e9ee74cd)})`}`,
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                fontSize: `${0.875} rem`
            },
            [`.fixed .${(0, $iRC0e.RendererCssClassName).NUMBER_COLUMN}`]: {
                borderRight: `0px none`
            }
        }
    }
});
const $28bec4b928772749$var$rendererTableHeaderEqualHeightStylesAllowNestedHeaderLinks = /*#__PURE__*/ (0, $1NIU8.css)({
    [`.${(0, $iRC0e.RendererCssClassName).DOCUMENT} .${(0, $cjLtO.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        [`.${(0, $cjLtO.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table, .${(0, $cjLtO.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
            [`.${(0, $iRC0e.RendererCssClassName).SORTABLE_COLUMN_WRAPPER}`]: {
                [`.${(0, $iRC0e.RendererCssClassName).SORTABLE_COLUMN}`]: {
                    [`.${0, $a6S67.HeadingAnchorWrapperClassName}`]: {
                        position: 'unset'
                    },
                    '>': {
                        'h1, h2, h3, h4, h5, h6': {
                            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
                            marginRight: '30px'
                        }
                    }
                }
            }
        }
    }
});
// @ts-expect-error - throw TS error when use !import in position.
const $28bec4b928772749$var$stickyHeaderStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    'tr[data-header-row].fixed': {
        position: 'fixed !important',
        display: 'flex',
        overflow: 'hidden',
        zIndex: `${(0, $7yBx7.akEditorStickyHeaderZIndex)}`,
        borderRight: `1px solid ${`var(--ds-background-accent-gray-subtler, ${(0, $7yBx7.akEditorTableBorder)})`}`,
        borderBottom: `1px solid ${`var(--ds-background-accent-gray-subtler, ${(0, $7yBx7.akEditorTableBorder)})`}`,
        /* this is to compensate for the table border */ transform: 'translateX(-1px)'
    },
    '.sticky > th': {
        zIndex: `${(0, $7yBx7.akEditorStickyHeaderZIndex)}`,
        position: 'fixed !important',
        top: 0
    },
    /* Make the number column header sticky */ '.sticky > td': {
        position: 'fixed !important',
        top: 0
    },
    /* add border for position: sticky
  and work around background-clip: padding-box
  bug for FF causing box-shadow bug in Chrome */ '.sticky th, .sticky td': {
        boxShadow: `0px 1px ${`var(--ds-background-accent-gray-subtler, ${(0, $7yBx7.akEditorTableBorder)})`},
			0px -0.5px ${`var(--ds-background-accent-gray-subtler, ${(0, $7yBx7.akEditorTableBorder)})`},
			inset -1px 0px ${`var(--ds-background-accent-gray-subtler, ${(0, $7yBx7.akEditorTableToolbar)})`},
			0px -1px ${`var(--ds-background-accent-gray-subtler, ${(0, $7yBx7.akEditorTableToolbar)})`}`
    },
    /* this will remove jumpiness caused in Chrome for sticky headers */ '.fixed + tr': {
        minHeight: '0px'
    }
});
const $28bec4b928772749$var$codeBlockAndLayoutStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    /*
   * We wrap CodeBlock in a grid to prevent it from overflowing the container of the renderer.
   * See ED-4159.
   */ '& .code-block': {
        maxWidth: '100%',
        display: 'block',
        position: 'relative',
        borderRadius: "var(--ds-border-radius-100, 3px)",
        /*
     * The overall renderer has word-wrap: break; which causes issues with
     * code block line numbers in Safari / iOS.
     */ wordWrap: 'normal'
    },
    '& .MediaGroup, & .code-block': {
        marginTop: `${(0, $7yBx7.blockNodesVerticalMargin)}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:first-child': {
            marginTop: 0
        }
    },
    // We overwrite the rule that clears margin-top for first nested codeblocks, as
    // our lightweight codeblock dom structure will always nest the codeblock inside
    // an extra container div which would constantly be targeted. Now, top-level
    // lightweight codeblock containers will not be targeted.
    // NOTE: This must be added after other .code-block styles in the root
    // Renderer stylesheet.
    [`.${(0, $iRC0e.RendererCssClassName).DOCUMENT}
		> .${(0, $ka8WB.LightWeightCodeBlockCssClassName).CONTAINER}
		.${(0, $gBkUB.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER}`]: {
        marginTop: (0, $7yBx7.blockNodesVerticalMargin)
    },
    '& [data-layout-section]': {
        marginTop: "var(--ds-space-250, 20px)",
        '& > div + div': {
            marginLeft: "var(--ds-space-400, 32px)"
        },
        [`@media screen and (max-width: ${0, $7yBx7.gridMediumMaxWidth}px)`]: {
            '& > div + div': {
                marginLeft: 0
            }
        },
        '& .MediaGroup, & .code-block': {
            marginTop: (0, $7yBx7.blockNodesVerticalMargin),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:first-child': {
                marginTop: 0
            }
        }
    },
    '& li': {
        '> .code-block': {
            margin: `${(0, $7yBx7.blockNodesVerticalMargin)} 0 0 0`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> .code-block:first-child': {
            marginTop: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> div:last-of-type.code-block': {
            marginBottom: (0, $7yBx7.blockNodesVerticalMargin)
        }
    }
});
const $28bec4b928772749$var$layoutSectionForAdvancedLayoutsStyles = {
    name: "4wptv0",
    styles: "& [data-layout-section]{& > div + div{margin-left:0;}}"
};
const $28bec4b928772749$var$gridRenderForCodeBlockStyles = {
    name: "18d2t58",
    styles: "& .code-block{display:grid;grid-template-columns:minmax(0, 1fr);& > span{grid-column:1;}}"
};
// This prevents https://product-fabric.atlassian.net/browse/ED-20924
const $28bec4b928772749$var$codeBlockInListSafariFixStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    [`&:not([data-node-type='decisionList']) > li,
		&:not(.${(0, $e2Ny4.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER}) > li`]: {
        '&::before': {
            content: '" "',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: (0, $7yBx7.akEditorLineHeight)
        },
        [`> p:first-child,
			> .code-block:first-child,
			> .ProseMirror-gapcursor:first-child + .code-block`]: {
            marginTop: `-${(0, $7yBx7.akEditorLineHeight)}em !important`
        }
    }
});
const $28bec4b928772749$var$columnLayoutSharedStyle = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '[data-layout-section]': {
        position: 'relative',
        display: 'flex',
        flexDirection: 'row',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > *': {
            flex: 1,
            minWidth: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > .unsupportedBlockView-content-wrap': {
            minWidth: 'initial'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`@media screen and (max-width: ${0, $7yBx7.gridMediumMaxWidth}px)`]: {
            flexDirection: 'column'
        }
    }
});
const $28bec4b928772749$var$columnLayoutResponsiveSharedStyle = {
    name: "ee7qh9",
    styles: "[data-layout-section]{display:flex;flex-direction:row;gap:var(--ds-space-100, 8px);& > *{flex:1;min-width:0;}& > .unsupportedBlockView-content-wrap{min-width:initial;}}.layout-section-container{container-type:inline-size;container-name:layout-area;}"
};
const $28bec4b928772749$var$columnLayoutResponsiveRendererStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.layout-section-container [data-layout-section]': {
        gap: "var(--ds-space-600, 48px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries
        [`@container layout-area (max-width: ${$28bec4b928772749$var$LAYOUT_BREAKPOINT_RENDERER}px)`]: {
            flexDirection: 'column',
            gap: "var(--ds-space-400, 32px)"
        }
    }
});
const $28bec4b928772749$var$rendererAnnotationStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    "& [data-mark-type='annotation'][data-mark-annotation-state='active'] [data-annotation-mark], & [data-annotation-draft-mark][data-annotation-inline-node]": {
        background: `var(--ds-background-accent-yellow-subtler, ${(0, $7bb4c1736002a04a$export$41060a744ab0b7ae)})`,
        borderBottom: `2px solid ${`var(--ds-border-accent-yellow, ${(0, $7bb4c1736002a04a$export$c6930421db9fa514)})`}`,
        boxShadow: `var(--ds-shadow-overlay, ${`1px 2px 3px ${(0, $7bb4c1736002a04a$export$d2d3bedfb276cac0)}, -1px 2px 3px ${(0, $7bb4c1736002a04a$export$d2d3bedfb276cac0)}`})`,
        cursor: 'pointer',
        padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-025, 2px)"}`
    }
});
const $28bec4b928772749$var$rendererAnnotationStylesCommentHeightFix = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '& [data-annotation-draft-mark][data-annotation-inline-node]': {
        borderBottom: '2px solid transparent',
        cursor: 'pointer',
        padding: '1px 0 2px',
        background: `var(--ds-background-accent-yellow-subtler, ${(0, $7bb4c1736002a04a$export$41060a744ab0b7ae)})`,
        borderBottomColor: `var(--ds-border-accent-yellow, ${(0, $7bb4c1736002a04a$export$c6930421db9fa514)})`,
        boxShadow: `var(--ds-shadow-overlay, ${`1px 2px 3px ${(0, $7bb4c1736002a04a$export$d2d3bedfb276cac0)}, -1px 2px 3px ${(0, $7bb4c1736002a04a$export$d2d3bedfb276cac0)}`})`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '& [data-annotation-draft-mark][data-annotation-inline-node][data-inline-card]': {
        padding: '5px 0 3px 0'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '& [data-annotation-draft-mark][data-annotation-inline-node].date-lozenger-container': {
        paddingTop: "var(--ds-space-025, 2px)"
    }
});
const $28bec4b928772749$export$8f0929e72efe521f = (props)=>{
    const { onClick: onClick, onMouseDown: onMouseDown, appearance: appearance, allowNestedHeaderLinks: allowNestedHeaderLinks, allowColumnSorting: allowColumnSorting, useBlockRenderForCodeBlock: useBlockRenderForCodeBlock, children: children, innerRef: innerRef, testId: testId } = props;
    const isAdvancedLayoutsOn = (0, $92xoS.editorExperiment)('advanced_layouts', true);
    return(// eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        ref: innerRef,
        onClick: onClick,
        onMouseDown: onMouseDown,
        style: {
            '--ak-renderer-base-font-size': `${(0, $c3ajv.getBaseFontSize)(appearance)}px`,
            '--ak-renderer-editor-font-heading-h1': `${(0, $Vv4zU.default)('editor.font.heading.h1')}`,
            '--ak-renderer-editor-font-heading-h2': `${(0, $Vv4zU.default)('editor.font.heading.h2')}`,
            '--ak-renderer-editor-font-heading-h3': `${(0, $Vv4zU.default)('editor.font.heading.h3')}`,
            '--ak-renderer-editor-font-heading-h4': `${(0, $Vv4zU.default)('editor.font.heading.h4')}`,
            '--ak-renderer-editor-font-heading-h5': `${(0, $Vv4zU.default)('editor.font.heading.h5')}`,
            '--ak-renderer-editor-font-heading-h6': `${(0, $Vv4zU.default)('editor.font.heading.h6')}`,
            '--ak-renderer-editor-font-normal-text': `${(0, $Vv4zU.default)('editor.font.body')}`
        },
        css: [
            $28bec4b928772749$var$baseStyles,
            $28bec4b928772749$var$hideHeadingCopyLinkWrapperStyles,
            appearance === 'full-page' && $28bec4b928772749$var$rendererFullPageStyles,
            appearance === 'full-width' && $28bec4b928772749$var$rendererFullWidthStyles,
            appearance === 'full-width' && !(0, $idsFq.isTableResizingEnabled)(appearance) && $28bec4b928772749$var$rendererFullWidthStylesForTableResizing,
            $28bec4b928772749$var$telepointerStyles,
            $28bec4b928772749$var$whitespaceSharedStyles,
            $28bec4b928772749$var$blockquoteSharedStyles,
            (0, $eGOwo.fg)('platform_editor_typography_ugc') ? $28bec4b928772749$var$headingsSharedStylesWithEditorUGC : $28bec4b928772749$var$headingsSharedStyles,
            $28bec4b928772749$var$headingWithAlignmentStyles,
            $28bec4b928772749$var$ruleSharedStyles,
            (0, $eGOwo.fg)('platform_editor_typography_ugc') ? $28bec4b928772749$var$paragraphSharedStylesWithEditorUGC : $28bec4b928772749$var$paragraphSharedStyles,
            $28bec4b928772749$var$listsSharedStyles,
            (0, $7EdFW.browser).gecko && $28bec4b928772749$var$listsSharedStylesForGekko,
            $28bec4b928772749$var$indentationSharedStyles,
            (0, $eGOwo.fg)('platform_editor__renderer_indentation_text_margin') && $28bec4b928772749$var$indentationSharedStylesWithMarginFix,
            $28bec4b928772749$var$blockMarksSharedStyles,
            $28bec4b928772749$var$codeMarkSharedStyles,
            $28bec4b928772749$var$shadowSharedStyle,
            $28bec4b928772749$var$dateSharedStyle,
            $28bec4b928772749$var$textColorStyles,
            $28bec4b928772749$var$backgroundColorStyles,
            $28bec4b928772749$var$tasksAndDecisionsStyles,
            $28bec4b928772749$var$smartCardStyles,
            $28bec4b928772749$var$smartCardStylesAvatarFix,
            (0, $eGOwo.fg)('smartcard_avatar_margin_fix') && $28bec4b928772749$var$smartCardStylesAvatarMarginFix,
            // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
            (0, $eGOwo.fg)('editor_inline_comments_on_inline_nodes') && $28bec4b928772749$var$rendererAnnotationStyles,
            // eslint-disable-next-line @atlaskit/platform/no-preconditioning, @atlaskit/platform/ensure-feature-flag-prefix
            (0, $eGOwo.fg)('editor_inline_comments_on_inline_nodes') && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
            (0, $eGOwo.fg)('annotations_align_editor_and_renderer_styles') && $28bec4b928772749$var$rendererAnnotationStylesCommentHeightFix,
            $28bec4b928772749$var$baseOtherStyles,
            allowNestedHeaderLinks && $28bec4b928772749$var$alignedHeadingAnchorStyle,
            $28bec4b928772749$var$mediaSingleSharedStyle,
            $28bec4b928772749$var$tableSharedStyle,
            $28bec4b928772749$var$tableRendererHeaderStylesForTableCellOnly,
            (0, $eGOwo.fg)('platform_editor_bordered_panel_nested_in_table') && $28bec4b928772749$var$tableRendererNestedPanelStyles,
            $28bec4b928772749$var$isBackgroundClipBrowserFixNeeded() && $28bec4b928772749$var$tableStylesBackGroundClipForGeckoForTableCellOnly,
            (0, $eGOwo.fg)('platform_editor_nested_dnd_styles_changes') ? $28bec4b928772749$var$firstNodeWithNotMarginTopWithNestedDnD : $28bec4b928772749$var$firstNodeWithNotMarginTop,
            $28bec4b928772749$var$rendererTableStyles,
            (0, $idsFq.isStickyScrollbarEnabled)(appearance) && $28bec4b928772749$var$stickyScrollbarStyles,
            $28bec4b928772749$var$rendererTableHeaderEqualHeightStylesForTableCellOnly,
            allowColumnSorting && $28bec4b928772749$var$rendererTableSortableColumnStyles,
            allowColumnSorting && allowNestedHeaderLinks && $28bec4b928772749$var$rendererTableHeaderEqualHeightStylesAllowNestedHeaderLinks,
            (0, $eGOwo.fg)('platform_editor_tables_numbered_column_correction') ? $28bec4b928772749$var$rendererTableColumnStyles : $28bec4b928772749$var$rendererTableColumnStylesOld,
            $28bec4b928772749$var$stickyHeaderStyles,
            $28bec4b928772749$var$codeBlockAndLayoutStyles,
            $28bec4b928772749$var$columnLayoutSharedStyle,
            isAdvancedLayoutsOn && $28bec4b928772749$var$columnLayoutResponsiveSharedStyle,
            isAdvancedLayoutsOn && $28bec4b928772749$var$columnLayoutResponsiveRendererStyles,
            isAdvancedLayoutsOn && $28bec4b928772749$var$layoutSectionForAdvancedLayoutsStyles,
            !useBlockRenderForCodeBlock && $28bec4b928772749$var$gridRenderForCodeBlockStyles,
            (0, $7EdFW.browser).safari && $28bec4b928772749$var$codeBlockInListSafariFixStyles,
            appearance === 'full-page' && (0, $eGOwo.fg)('platform_breakout_cls') ? $28bec4b928772749$var$responsiveBreakoutWidth : null,
            appearance === 'full-width' && (0, $eGOwo.fg)('platform_breakout_cls') ? $28bec4b928772749$var$responsiveBreakoutWidthFullWidth : null
        ],
        "data-testid": testId
    }, children));
};

});
parcelRegister("dA9km", function(module, exports) {

$parcel$export(module.exports, "INLINE_IMAGE_WRAPPER_CLASS_NAME", () => $a764f646abaeec54$export$dd2e16f83ae6aa78);
$parcel$export(module.exports, "INLINE_IMAGE_ASPECT_RATIO_CSS_VAR_KEY", () => $a764f646abaeec54$export$7ab34e219ce6eef);
$parcel$export(module.exports, "INLINE_IMAGE_BORDER_SIZE_CSS_VAR_KEY", () => $a764f646abaeec54$export$263a8a844c370a89);
$parcel$export(module.exports, "INLINE_IMAGE_BORDER_COLOR_CSS_VAR_KEY", () => $a764f646abaeec54$export$b0d1f1e1fb3c4b46);
$parcel$export(module.exports, "mediaInlineImageStyles", () => $a764f646abaeec54$export$dee15762144889b7);
$parcel$export(module.exports, "wrapperStyle", () => $a764f646abaeec54$export$c4d4f06a25de97f);
$parcel$export(module.exports, "selectedStyle", () => $a764f646abaeec54$export$a7abb1b3dc25813f);
$parcel$export(module.exports, "borderStyle", () => $a764f646abaeec54$export$4d0a7f76ad443516);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $hgI1e = parcelRequire("hgI1e");
const $a764f646abaeec54$export$dd2e16f83ae6aa78 = 'media-inline-image-wrapper';
const $a764f646abaeec54$export$7ab34e219ce6eef = '--editor-media-inline-image-aspect-ratio';
const $a764f646abaeec54$export$263a8a844c370a89 = '--editor-media-inline-image-border-size';
const $a764f646abaeec54$export$b0d1f1e1fb3c4b46 = '--editor-media-inline-image-border-color';
// We implemented such selectors to ensure specificity:
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Nested and dynamic css calls are violations, needs manual remediation
const $a764f646abaeec54$var$inlineImageHeight = (height, margin = 0)=>/*#__PURE__*/ (0, $1NIU8.css)(">.mediaInlineView-content-wrap>.", $a764f646abaeec54$export$dd2e16f83ae6aa78, ",>:is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap>.", $a764f646abaeec54$export$dd2e16f83ae6aa78, ",>.", $a764f646abaeec54$export$dd2e16f83ae6aa78, ",>:is(a, span[data-mark-type='border']) .", $a764f646abaeec54$export$dd2e16f83ae6aa78, "{height:", height, "px;transform:translateY(", margin, "px);}");
const $a764f646abaeec54$export$dee15762144889b7 = /*#__PURE__*/ (0, $1NIU8.css)(".", $a764f646abaeec54$export$dd2e16f83ae6aa78, "{height:", (0, $hgI1e.referenceHeights)['p'], "px;transform:translateY(-2px);}h1{", $a764f646abaeec54$var$inlineImageHeight((0, $hgI1e.referenceHeights)['h1'], -3), ";}h2{", $a764f646abaeec54$var$inlineImageHeight((0, $hgI1e.referenceHeights)['h2'], -3), ";}h3{", $a764f646abaeec54$var$inlineImageHeight((0, $hgI1e.referenceHeights)['h3'], -2), ";}h4{", $a764f646abaeec54$var$inlineImageHeight((0, $hgI1e.referenceHeights)['h4'], -2), ";}h5{", $a764f646abaeec54$var$inlineImageHeight((0, $hgI1e.referenceHeights)['h5'], -2), ";}h6{", $a764f646abaeec54$var$inlineImageHeight((0, $hgI1e.referenceHeights)['h6'], -2), ";}");
const $a764f646abaeec54$export$c4d4f06a25de97f = /*#__PURE__*/ (0, $1NIU8.css)({
    display: 'inline-flex',
    cursor: 'pointer',
    justifyContent: 'center',
    alignItems: 'center',
    verticalAlign: 'middle',
    overflow: 'hidden',
    borderRadius: `${"var(--ds-border-radius, 3px)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    aspectRatio: `var(${$a764f646abaeec54$export$7ab34e219ce6eef}, ${(0, $hgI1e.DEFAULT_INLINE_IMAGE_ASPECT_RATIO)})`,
    maxWidth: '100%'
});
const $a764f646abaeec54$export$a7abb1b3dc25813f = /*#__PURE__*/ (0, $1NIU8.css)({
    boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #0C66E4)"}`,
    outline: 'none'
});
const $a764f646abaeec54$export$4d0a7f76ad443516 = /*#__PURE__*/ (0, $1NIU8.css)({
    borderColor: `var(${$a764f646abaeec54$export$b0d1f1e1fb3c4b46})`,
    borderStyle: 'solid',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `calc(var(${$a764f646abaeec54$export$263a8a844c370a89}, ${(0, $hgI1e.DEFAULT_INLINE_IMAGE_BORDER_SIZE)}) * 2px)`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderWidth: `calc(var(${$a764f646abaeec54$export$263a8a844c370a89}, ${(0, $hgI1e.DEFAULT_INLINE_IMAGE_BORDER_SIZE)}) * 1px)`,
    boxSizing: `border-box`
});

});
parcelRegister("hgI1e", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_IMAGE_WIDTH", () => $e1b709a355af1a7b$export$d722b7527b1834a8);
$parcel$export(module.exports, "DEFAULT_IMAGE_HEIGHT", () => $e1b709a355af1a7b$export$da894f7669b4e67c);
$parcel$export(module.exports, "DEFAULT_INLINE_IMAGE_ASPECT_RATIO", () => $e1b709a355af1a7b$export$286cf28b87ad4b4f);
$parcel$export(module.exports, "DEFAULT_INLINE_IMAGE_BORDER_SIZE", () => $e1b709a355af1a7b$export$64fe09732fb8680);
$parcel$export(module.exports, "referenceHeights", () => $e1b709a355af1a7b$export$c1317a9224e4d798);
const $e1b709a355af1a7b$export$d722b7527b1834a8 = 250;
const $e1b709a355af1a7b$export$da894f7669b4e67c = 200;
const $e1b709a355af1a7b$export$286cf28b87ad4b4f = $e1b709a355af1a7b$export$d722b7527b1834a8 / $e1b709a355af1a7b$export$da894f7669b4e67c;
const $e1b709a355af1a7b$export$64fe09732fb8680 = 0;
const $e1b709a355af1a7b$export$c1317a9224e4d798 = {
    p: 22,
    h1: 36,
    h2: 31,
    h3: 25,
    h4: 23,
    h5: 20,
    h6: 18
};

});


parcelRegister("fDsDd", function(module, exports) {

$parcel$export(module.exports, "DateSharedCssClassName", () => $2b5fce49fa2ad059$export$99cdf122d0bb9f95);
$parcel$export(module.exports, "dateSharedStyle", () => $2b5fce49fa2ad059$export$86f86bd772084bf4);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");
const $2b5fce49fa2ad059$export$99cdf122d0bb9f95 = {
    DATE_WRAPPER: `date-lozenger-container`,
    DATE_CONTAINER: 'dateView-content-wrap'
};
const $2b5fce49fa2ad059$export$86f86bd772084bf4 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$2b5fce49fa2ad059$export$99cdf122d0bb9f95.DATE_WRAPPER} span`]: {
        whiteSpace: 'unset'
    }
});

});

parcelRegister("laqWo", function(module, exports) {

$parcel$export(module.exports, "richMediaClassName", () => $7b0053d081be8618$export$cfe6da7d522d87bb);
$parcel$export(module.exports, "mediaSingleSharedStyleNew", () => $7b0053d081be8618$export$b51dea84d928a378);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $7yBx7 = parcelRequire("7yBx7");
const $7b0053d081be8618$export$cfe6da7d522d87bb = 'rich-media-item';
const $7b0053d081be8618$var$wrappedMediaBreakoutPoint = 410;
const $7b0053d081be8618$export$d031611b96ba4cf0 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`li .${$7b0053d081be8618$export$cfe6da7d522d87bb}`]: {
        margin: 0
    },
    // Hack for chrome to fix media single position inside a list when media is the first child
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-chrome li > .mediaSingleView-content-wrap::before': {
        content: "''",
        display: 'block',
        height: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-firefox': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.mediaSingleView-content-wrap': {
            userSelect: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.captionView-content-wrap': {
            userSelect: 'text'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    ".mediaSingleView-content-wrap[layout='center']": {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`table .${$7b0053d081be8618$export$cfe6da7d522d87bb}`]: {
        marginTop: "var(--ds-space-150, 12px)",
        marginBottom: "var(--ds-space-150, 12px)",
        clear: 'both',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&.image-wrap-left[data-layout], &.image-wrap-right[data-layout]': {
            clear: 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '&:first-child': {
                marginTop: "var(--ds-space-150, 12px)"
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$7b0053d081be8618$export$cfe6da7d522d87bb}.image-wrap-right + .${$7b0053d081be8618$export$cfe6da7d522d87bb}.image-wrap-left`]: {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$7b0053d081be8618$export$cfe6da7d522d87bb}.image-wrap-left + .${$7b0053d081be8618$export$cfe6da7d522d87bb}.image-wrap-right, .${$7b0053d081be8618$export$cfe6da7d522d87bb}.image-wrap-right + .${$7b0053d081be8618$export$cfe6da7d522d87bb}.image-wrap-left, .${$7b0053d081be8618$export$cfe6da7d522d87bb}.image-wrap-left + .${$7b0053d081be8618$export$cfe6da7d522d87bb}.image-wrap-left, .${$7b0053d081be8618$export$cfe6da7d522d87bb}.image-wrap-right + .${$7b0053d081be8618$export$cfe6da7d522d87bb}.image-wrap-right`]: {
        marginRight: 0,
        marginLeft: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`@media all and (max-width: ${$7b0053d081be8618$var$wrappedMediaBreakoutPoint}px)`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "div.mediaSingleView-content-wrap[layout='wrap-left'], div.mediaSingleView-content-wrap[data-layout='wrap-left'], div.mediaSingleView-content-wrap[layout='wrap-right'], div.mediaSingleView-content-wrap[data-layout='wrap-right']": {
            float: 'none',
            overflow: 'auto',
            margin: `${"var(--ds-space-150, 12px)"} 0`
        }
    }
});
const $7b0053d081be8618$export$b51dea84d928a378 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`li .${$7b0053d081be8618$export$cfe6da7d522d87bb}`]: {
        margin: 0
    },
    // Hack for chrome to fix media single position inside a list when media is the first child
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-chrome li > .mediaSingleView-content-wrap::before': {
        content: "''",
        display: 'block',
        height: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-firefox': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.mediaSingleView-content-wrap': {
            userSelect: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.captionView-content-wrap': {
            userSelect: 'text'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ".mediaSingleView-content-wrap[layout^='wrap-']": {
        position: 'relative',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        zIndex: (0, $7yBx7.akEditorWrappedNodeZIndex)
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    ".mediaSingleView-content-wrap[layout='center']": {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`table .${$7b0053d081be8618$export$cfe6da7d522d87bb}`]: {
        marginTop: "var(--ds-space-150, 12px)",
        marginBottom: "var(--ds-space-150, 12px)",
        clear: 'both',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&.image-wrap-left[data-layout], &.image-wrap-right[data-layout]': {
            clear: 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '&:first-child': {
                marginTop: "var(--ds-space-150, 12px)"
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$7b0053d081be8618$export$cfe6da7d522d87bb}.image-wrap-right + .${$7b0053d081be8618$export$cfe6da7d522d87bb}.image-wrap-left`]: {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$7b0053d081be8618$export$cfe6da7d522d87bb}.image-wrap-left + .${$7b0053d081be8618$export$cfe6da7d522d87bb}.image-wrap-right, .${$7b0053d081be8618$export$cfe6da7d522d87bb}.image-wrap-right + .${$7b0053d081be8618$export$cfe6da7d522d87bb}.image-wrap-left, .${$7b0053d081be8618$export$cfe6da7d522d87bb}.image-wrap-left + .${$7b0053d081be8618$export$cfe6da7d522d87bb}.image-wrap-left, .${$7b0053d081be8618$export$cfe6da7d522d87bb}.image-wrap-right + .${$7b0053d081be8618$export$cfe6da7d522d87bb}.image-wrap-right`]: {
        marginRight: 0,
        marginLeft: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`@media all and (max-width: ${$7b0053d081be8618$var$wrappedMediaBreakoutPoint}px)`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "div.mediaSingleView-content-wrap[layout='wrap-left'], div.mediaSingleView-content-wrap[data-layout='wrap-left'], div.mediaSingleView-content-wrap[layout='wrap-right'], div.mediaSingleView-content-wrap[data-layout='wrap-right']": {
            float: 'none',
            overflow: 'auto',
            margin: `${"var(--ds-space-150, 12px)"} 0`
        }
    }
});

});

parcelRegister("e2Ny4", function(module, exports) {

$parcel$export(module.exports, "SmartCardSharedCssClassName", () => $dc5da4ab3a080f09$export$4ccd31bf665a88f6);
$parcel$export(module.exports, "getSmartCardSharedStyles", () => $dc5da4ab3a080f09$export$fbd9b588230965e4);

var $7yBx7 = parcelRequire("7yBx7");
const $dc5da4ab3a080f09$export$4ccd31bf665a88f6 = {
    INLINE_CARD_CONTAINER: 'inlineCardView-content-wrap',
    BLOCK_CARD_CONTAINER: 'blockCardView-content-wrap',
    EMBED_CARD_CONTAINER: 'embedCardView-content-wrap',
    DATASOURCE_CONTAINER: 'datasourceView-content-wrap',
    LOADER_WRAPPER: 'loader-wrapper'
};
const $dc5da4ab3a080f09$export$83e107f0a431e184 = `
  .${$dc5da4ab3a080f09$export$4ccd31bf665a88f6.BLOCK_CARD_CONTAINER} {
    display: block;
    margin: ${(0, $7yBx7.blockNodesVerticalMargin)} 0 0;
    max-width: ${760}px;
  }
`;
const $dc5da4ab3a080f09$export$fbd9b588230965e4 = ()=>`
  .${$dc5da4ab3a080f09$export$4ccd31bf665a88f6.BLOCK_CARD_CONTAINER} {
    display: block;
    margin: ${0, $7yBx7.blockNodesVerticalMargin} 0 0;
    max-width: ${760}px;
  }

  .${$dc5da4ab3a080f09$export$4ccd31bf665a88f6.BLOCK_CARD_CONTAINER} {
    /* EDM-11991: Fix list plugin adding padding to ADS AvatarGroup start */
    ul, ol {
      padding-left: inherit;
    }
    /* EDM-11991: Fix list plugin add padding to ADS AvatarGroup end */
  }
`;

});

parcelRegister("gZAVf", function(module, exports) {

$parcel$export(module.exports, "TaskDecisionSharedCssClassName", () => $c7201827a86a9c90$export$a7172b75d403a0e4);
$parcel$export(module.exports, "tasksAndDecisionsStyles", () => $c7201827a86a9c90$export$df437277fbc8b4f5);
/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $7yBx7 = parcelRequire("7yBx7");
const $c7201827a86a9c90$export$a7172b75d403a0e4 = {
    DECISION_CONTAINER: 'decisionItemView-content-wrap',
    TASK_CONTAINER: 'taskItemView-content-wrap',
    TASK_ITEM: 'task-item',
    TASK_CHECKBOX_CONTAINER: 'task-item-checkbox-wrap'
};
const $c7201827a86a9c90$export$df437277fbc8b4f5 = /*#__PURE__*/ (0, $1NIU8.css)(".ProseMirror{.taskItemView-content-wrap,.", $c7201827a86a9c90$export$a7172b75d403a0e4.DECISION_CONTAINER, "{position:relative;min-width:", (0, $7yBx7.akEditorTableCellMinWidth), "px;}.", $c7201827a86a9c90$export$a7172b75d403a0e4.DECISION_CONTAINER, "{margin-top:0;}.", $c7201827a86a9c90$export$a7172b75d403a0e4.TASK_CONTAINER, "{span[contenteditable='false']{height:", (0, $7yBx7.akEditorLineHeight), "em;}}.", $c7201827a86a9c90$export$a7172b75d403a0e4.TASK_ITEM, "{line-height:", (0, $7yBx7.akEditorLineHeight), ";}}div[data-task-local-id]{span[contenteditable='false']{height:", (0, $7yBx7.akEditorLineHeight), "em;}span[contenteditable='false']+div{line-height:", (0, $7yBx7.akEditorLineHeight), "em;}}div[data-task-list-local-id]{margin:var(--ds-space-150, 12px) 0 0 0;}div[data-task-list-local-id]{div+div{margin-top:var(--ds-space-050, 4px);}}div[data-task-list-local-id] div[data-task-list-local-id]{margin-top:var(--ds-space-050, 4px);margin-left:var(--ds-space-300, 24px);}.ak-editor-panel__content{>div[data-task-list-local-id]:first-child{margin:0 0 0 0!important;}}");

});

parcelRegister("ka8WB", function(module, exports) {

$parcel$export(module.exports, "LightWeightCodeBlockCssClassName", () => $bb090de99d5cd16d$export$afbde0e7339bed51);
$parcel$export(module.exports, "default", () => $bb090de99d5cd16d$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $7yBx7 = parcelRequire("7yBx7");
var $1rXAK = parcelRequire("1rXAK");

var $gBkUB = parcelRequire("gBkUB");

var $eM87S = parcelRequire("eM87S");

var $iRC0e = parcelRequire("iRC0e");
const $bb090de99d5cd16d$var$codeBlockSharedStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    [`.${(0, $gBkUB.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPED}
		> .${(0, $gBkUB.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER}
		> .${(0, $gBkUB.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT}`]: {
        marginRight: "var(--ds-space-100, 8px)",
        code: {
            display: 'block',
            wordBreak: 'break-word',
            whiteSpace: 'pre-wrap'
        }
    },
    [`.${(0, $gBkUB.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER}
		> .${(0, $gBkUB.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT}`]: {
        display: 'flex',
        flex: 1,
        code: {
            flexGrow: 1,
            whiteSpace: 'pre'
        }
    },
    [`.${(0, $gBkUB.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER}`]: {
        position: 'relative',
        backgroundColor: "var(--ds-surface-raised, #FFFFFF)",
        borderRadius: "var(--ds-border-radius, 3px)",
        margin: `${(0, $7yBx7.blockNodesVerticalMargin)} 0 0 0`,
        fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
        minWidth: `${(0, $7yBx7.akEditorTableCellMinWidth)}px`,
        cursor: 'pointer',
        clear: 'both',
        '--ds--code--bg-color': 'transparent',
        '.code-block-gutter-pseudo-element::before': {
            content: '"attr(data-label)"'
        },
        /* This is necessary to allow for arrow key navigation in/out of code blocks in Firefox. */ whiteSpace: 'normal',
        [`.${(0, $gBkUB.CodeBlockSharedCssClassName).CODEBLOCK_START}`]: {
            position: 'absolute',
            visibility: 'hidden',
            height: '1.5rem',
            top: '0px',
            left: '0px'
        },
        [`${(0, $gBkUB.CodeBlockSharedCssClassName).CODEBLOCK_END}`]: {
            position: 'absolute',
            visibility: 'hidden',
            height: '1.5rem',
            bottom: '0px',
            right: '0px'
        },
        [`.${(0, $gBkUB.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER}`]: {
            position: 'relative',
            backgroundColor: "var(--ds-background-neutral, #091E420F)",
            display: 'flex',
            borderRadius: "var(--ds-border-radius, 3px)",
            width: '100%',
            counterReset: 'line',
            overflowX: 'auto',
            backgroundImage: 'var(--ak-renderer-codeblock-content-wrapper-bg-img)',
            backgroundRepeat: 'no-repeat',
            backgroundAttachment: 'local, local, local, local, scroll, scroll, scroll, scroll',
            backgroundSize: `${"var(--ds-space-300, 24px)"} 100%,
				${"var(--ds-space-300, 24px)"} 100%,
				${"var(--ds-space-100, 8px)"} 100%,
				${"var(--ds-space-100, 8px)"} 100%,
				${"var(--ds-space-100, 8px)"} 100%,
				1px 100%,
				${"var(--ds-space-100, 8px)"} 100%,
				1px 100%`,
            backgroundPosition: `0 0,
				0 0,
				100% 0,
				100% 0,
				100% 0,
				100% 0,
				0 0,
				0 0`,
            /* Be careful if refactoring this; it is needed to keep arrow key navigation in Firefox consistent with other browsers. */ overflowY: 'hidden'
        },
        [`.${(0, $gBkUB.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER}`]: {
            backgroundColor: "var(--ds-background-neutral, #091E420F)",
            position: 'relative',
            width: 'var(--lineNumberGutterWidth, 2rem)',
            padding: "var(--ds-space-100, 8px)",
            flexShrink: 0,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: `${0.875}rem`,
            boxSizing: 'content-box'
        },
        // This is a fix of marker of list item with code block.
        // The list item marker in Chrome is aligned by the baseline of the text,
        // that's why we need to add a text (content: "1") to the line number gutter to align
        // the list item marker with the text.
        // Without it, the list item marker will be aligned by the bottom of the code block.
        [`.${(0, $gBkUB.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER}::before`]: {
            content: '"1"',
            visibility: 'hidden',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: `${0.875}rem`,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: '1.5rem'
        },
        [`.${(0, $gBkUB.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT}`]: {
            code: {
                tabSize: 4,
                cursor: 'text',
                color: "var(--ds-text, #172B4D)",
                borderRadius: "var(--ds-border-radius, 3px)",
                margin: "var(--ds-space-100, 8px)",
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                fontSize: `${0.875}rem`,
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                lineHeight: '1.5rem'
            }
        },
        [`.${(0, $gBkUB.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER_LINE_NUMBER_WIDGET}`]: {
            pointerEvents: 'none',
            userSelect: 'none',
            width: 'var(--lineNumberGutterWidth, 2rem)',
            left: 0,
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: `${0.875}rem`,
            padding: `0px ${"var(--ds-space-100, 8px)"}`,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: '1.5rem',
            textAlign: 'right',
            color: "var(--ds-text-subtlest, #505F79)",
            boxSizing: 'content-box'
        }
    }
});
const $bb090de99d5cd16d$var$lightWeightCodeBlockStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    [`.${(0, $gBkUB.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER}`]: {
        cursor: 'text'
    }
});
const $bb090de99d5cd16d$export$afbde0e7339bed51 = {
    CONTAINER: 'light-weight-code-block'
};
const $bb090de99d5cd16d$export$3f1ff491ca7c4c4a = ()=>{
    // We overwrite the rule that clears margin-top for first nested codeblocks, as
    // our lightweight codeblock dom structure will always nest the codeblock inside
    // an extra container div which would constantly be targeted. Now, top-level
    // lightweight codeblock containers will not be targeted.
    // NOTE: This must be added after other .code-block styles in the root
    // Renderer stylesheet.
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    return /*#__PURE__*/ (0, $1NIU8.css)(".", (0, $iRC0e.RendererCssClassName).DOCUMENT, ">.", $bb090de99d5cd16d$export$afbde0e7339bed51.CONTAINER, " .", (0, $gBkUB.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER, "{margin-top:", (0, $7yBx7.blockNodesVerticalMargin), ";}");
};
const $bb090de99d5cd16d$var$LightWeightCodeBlock = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ text: text, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled = true, className: className }, ref)=>{
    const textRows = (0, $eJOHy.useMemo)(()=>(text ?? '').split('\n'), [
        text
    ]);
    const { renderBidiWarnings: renderBidiWarnings } = (0, $eM87S.useBidiWarnings)({
        enableWarningTooltip: codeBidiWarningTooltipEnabled
    });
    const classNames = [
        $bb090de99d5cd16d$export$afbde0e7339bed51.CONTAINER,
        className
    ].join(' ');
    const codeBlockBackgroundImage = (0, $1rXAK.overflowShadow)({
        leftCoverWidth: "var(--ds-space-300, 24px)"
    });
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: classNames,
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $bb090de99d5cd16d$var$codeBlockSharedStyles,
            $bb090de99d5cd16d$var$lightWeightCodeBlockStyles
        ],
        style: {
            '--ak-renderer-codeblock-content-wrapper-bg-img': codeBlockBackgroundImage
        }
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        className: (0, $gBkUB.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $gBkUB.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $gBkUB.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER
    }, textRows.map((_, index)=>// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
            key: index
        }))), /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        className: (0, $gBkUB.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("code", null, renderBidiWarnings(text))))));
});
var $bb090de99d5cd16d$export$2e2bcd8739ae039 = $bb090de99d5cd16d$var$LightWeightCodeBlock;

});
parcelRegister("eM87S", function(module, exports) {

$parcel$export(module.exports, "useBidiWarnings", () => $594eb3f722888f10$export$9fb9fe546a188c7b);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $hDNIq = parcelRequire("hDNIq");

var $brgNx = parcelRequire("brgNx");

var $2E9Su = parcelRequire("2E9Su");
const $594eb3f722888f10$export$9fb9fe546a188c7b = ({ enableWarningTooltip: enableWarningTooltip = true })=>{
    const intl = (0, $lRq8t.default)();
    const warningLabel = intl.formatMessage((0, $brgNx.codeBidiWarningMessages).label);
    const renderBidiWarnings = (text)=>{
        return (0, $2E9Su.default)(text, ({ bidiCharacter: bidiCharacter, index: index })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $hDNIq.default), {
                bidiCharacter: bidiCharacter,
                label: warningLabel,
                tooltipEnabled: enableWarningTooltip
            }, index));
    };
    return {
        renderBidiWarnings: renderBidiWarnings,
        warningLabel: warningLabel
    };
};

});


parcelRegister("Vv4zU", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff494cb19d6b1863$export$2e2bcd8739ae039);

var $eGOwo = parcelRequire("eGOwo");

var $hszUU = parcelRequire("hszUU");
function $ff494cb19d6b1863$var$editorUGCToken(path) {
    let tokens;
    if ((0, $eGOwo.fg)('platform_editor_typography_ugc')) tokens = (0, $hszUU.editorUGCTokensRefreshed);
    else tokens = (0, $hszUU.editorUGCTokens);
    return tokens[path];
}
var $ff494cb19d6b1863$export$2e2bcd8739ae039 = $ff494cb19d6b1863$var$editorUGCToken;

});
parcelRegister("hszUU", function(module, exports) {

$parcel$export(module.exports, "editorUGCTokens", () => $587fd41298381b81$export$4a3637dc6e2ae29e);
$parcel$export(module.exports, "editorUGCTokensRefreshed", () => $587fd41298381b81$export$63adc0ebe3278d31);
const $587fd41298381b81$export$4a3637dc6e2ae29e = {
    'editor.font.heading.h1': 'normal 500 1.71429em/1.16667 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h2': 'normal 500 1.42857em/1.2 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h3': 'normal 600 1.14286em/1.25 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h4': 'normal 600 1em/1.14286 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h5': 'normal 600 0.857143em/1.33333 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h6': 'normal 700 0.785714em/1.45455 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.body': 'normal 400 1em/1.714 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.weight.heading.h1.bold': '700',
    'editor.font.weight.heading.h2.bold': '700',
    'editor.font.weight.heading.h3.bold': '700',
    'editor.font.weight.heading.h4.bold': '700',
    'editor.font.weight.heading.h5.bold': '700',
    'editor.font.weight.heading.h6.bold': '700'
};
const $587fd41298381b81$export$95588e746468319e = {
    'editor.font.heading.h1': 'normal 600 1.71429em/1.16667 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h2': 'normal 600 1.42857em/1.2 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h3': 'normal 600 1.14286em/1.25 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h4': 'normal 600  1em/1.14286 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h5': 'normal 600  0.857143em/1.33333 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h6': 'normal 600 0.785714em/1.45455 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.body': 'normal 400 1em/1.714 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.weight.heading.h1.bold': '700',
    'editor.font.weight.heading.h2.bold': '700',
    'editor.font.weight.heading.h3.bold': '700',
    'editor.font.weight.heading.h4.bold': '700',
    'editor.font.weight.heading.h5.bold': '700',
    'editor.font.weight.heading.h6.bold': '700'
};
const $587fd41298381b81$export$63adc0ebe3278d31 = {
    'editor.font.heading.h1': 'normal 600 1.71429em/1.16667 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h2': 'normal 600 1.42857em/1.2 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h3': 'normal 600 1.14286em/1.25 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h4': 'normal 600 1em/1.14286 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h5': 'normal 600 0.857143em/1.33333 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h6': 'normal 600 0.785714em/1.45455 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.body': 'normal 400 1em/1.714 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.weight.heading.h1.bold': '700',
    'editor.font.weight.heading.h2.bold': '700',
    'editor.font.weight.heading.h3.bold': '700',
    'editor.font.weight.heading.h4.bold': '700',
    'editor.font.weight.heading.h5.bold': '700',
    'editor.font.weight.heading.h6.bold': '700'
};

});


parcelRegister("c3ajv", function(module, exports) {

$parcel$export(module.exports, "getBaseFontSize", () => $99fc19356015857a$export$8e2864079bc476bd);

var $7yBx7 = parcelRequire("7yBx7");
const $99fc19356015857a$export$8e2864079bc476bd = (appearance)=>{
    return appearance && appearance !== 'comment' ? (0, $7yBx7.akEditorFullPageDefaultFontSize) : 14;
};

});


parcelRegister("goISJ", function(module, exports) {

$parcel$export(module.exports, "removeEmptySpaceAroundContent", () => $e351d9165cd2c4b0$export$c94cfc0c675062a1);
const $e351d9165cd2c4b0$export$c94cfc0c675062a1 = (document)=>{
    // Check if the document is valid
    if (!document || !document.content || !Array.isArray(document.content)) return document;
    // Check if the node is a meaningful content node meaning it is not an empty paragraph or a paragraph with only whitespace
    const isMeaningfulContentNode = (node)=>{
        // Check if the node is a non-empty paragraph or a non-paragraph node
        if (node.type !== 'paragraph') return true;
        // If the paragraph is empty, return false
        if (!node.content || node.content.length === 0) return false;
        // Check if paragraph has any content other than `hardBreak` or whitespace text nodes
        return node.content.some((child)=>{
            return !(child?.type === 'hardBreak' || child?.type === 'text' && typeof child.text === 'string' && child.text.trim() === '');
        });
    };
    const content = document.content;
    let firstContentIndex = -1;
    let lastContentIndex = -1;
    // Find the first and last paragraphs with content and check if they are meaningful
    for(let i = 0; i < content.length; i++)if (isMeaningfulContentNode(content[i])) {
        if (firstContentIndex === -1) firstContentIndex = i;
        lastContentIndex = i;
    }
    // If no content was found, return an empty document
    if (firstContentIndex === -1) return {
        ...document,
        content: []
    };
    // Slice the content array to include only paragraphs between the first and last content
    const trimmedContent = content.slice(firstContentIndex, lastContentIndex + 1);
    // Return a new document with the trimmed content
    return {
        ...document,
        content: trimmedContent
    };
};

});

parcelRegister("8AF0U", function(module, exports) {

$parcel$export(module.exports, "useMemoFromPropsDerivative", () => $da708a0839cc6084$export$80ffe7e3c6bf25c3);

var $eJOHy = parcelRequire("eJOHy");
function $da708a0839cc6084$export$80ffe7e3c6bf25c3(factory, propsDerivator, props) {
    // cache the last set of props
    const prev = (0, $eJOHy.useRef)(props);
    const prevFactory = (0, $eJOHy.useRef)(null);
    return (0, $eJOHy.useMemo)(()=>{
        // check if the serializer is already created
        let shouldCreate = !prevFactory.current;
        // check each prop to see if value has changed and also check if the number of props has changed
        if (prev.current !== props) {
            const propsEntries = Object.entries(props);
            shouldCreate = propsEntries.length !== Object.keys(prev.current).length || propsEntries.some(([key, prop])=>prev.current[key] !== prop);
        }
        prev.current = props;
        // If first time or any prop value has changed, create a new serializer
        if (shouldCreate) prevFactory.current = factory(propsDerivator(props));
        return prevFactory.current;
    }, // To keep deps consistent, here disable the exhaustive-deps rule to drop factory from the deps array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        propsDerivator,
        props
    ]);
}

});

parcelRegister("jWNZR", function(module, exports) {

$parcel$export(module.exports, "PortalContext", () => $8e263fa42711dda5$export$60d741e20e0aa309);
$parcel$export(module.exports, "usePortal", () => $8e263fa42711dda5$export$b1072f43c67b540c);

var $eJOHy = parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");
const $8e263fa42711dda5$export$60d741e20e0aa309 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext(undefined);
const $8e263fa42711dda5$export$b1072f43c67b540c = ({ portal: portalFromProps } = {})=>{
    const portalFromContext = (0, $eJOHy.useContext)($8e263fa42711dda5$export$60d741e20e0aa309);
    if (portalFromProps) return portalFromProps;
    if ((0, $eGOwo.fg)('cc_complexit_reduce_portal_rerenders')) return portalFromContext;
    return undefined;
};

});


parcelRegister("c9lZd", function(module, exports) {

$parcel$export(module.exports, "useEmojiProvider", () => $c9a19aae2574d758$export$d80cf6b7758b1c7e);

var $eJOHy = parcelRequire("eJOHy");

var $1RDZV = parcelRequire("1RDZV");

var $dV1IY = parcelRequire("dV1IY");

var $8q7lT = parcelRequire("8q7lT");

var $kEUB1 = parcelRequire("kEUB1");
const $c9a19aae2574d758$export$d80cf6b7758b1c7e = ()=>{
    const cloudId = (0, $kEUB1.useCloudId)();
    const atlassianAccountId = (0, $8q7lT.useAccountId)();
    const emojiProvider = (0, $eJOHy.useMemo)(()=>{
        const dataProviders = new (0, $1RDZV.default)();
        dataProviders.setProvider('emojiProvider', (0, $dV1IY.getEmojiProviderWithCustomEmoji)(cloudId, atlassianAccountId) || undefined);
        return dataProviders;
    }, [
        cloudId,
        atlassianAccountId
    ]);
    return emojiProvider;
};

});
parcelRegister("dV1IY", function(module, exports) {

$parcel$export(module.exports, "getEmojiProvider", () => $9a75dbe340213ba1$export$8210f5f78c0bcf27);
$parcel$export(module.exports, "getEmojiProviderWithCustomEmoji", () => $9a75dbe340213ba1$export$f9c5a1e85ff0cb72);
$parcel$export(module.exports, "getEmojiProviderWithCustomEmojiUploadDisabled", () => $9a75dbe340213ba1$export$7cda0fc535c2710f);
$parcel$export(module.exports, "fetchEmojiProvider", () => $9a75dbe340213ba1$export$12c2b0bd175ad5c1);

var $53MhD = parcelRequire("53MhD");

var $kFrAe = parcelRequire("kFrAe");
const $9a75dbe340213ba1$var$baseProviders = (serviceBaseUrl)=>[
        {
            url: `${serviceBaseUrl}/emoji/standard`
        },
        {
            url: `${serviceBaseUrl}/emoji/atlassian`
        }
    ];
const $9a75dbe340213ba1$export$8210f5f78c0bcf27 = ()=>(0, $kFrAe.getServiceProvider)((0, $kFrAe.EMOJI_SERVICEID), (serviceBaseUrl)=>{
        const emojiResource = new (0, $53MhD.default)({
            providers: $9a75dbe340213ba1$var$baseProviders(serviceBaseUrl)
        });
        return emojiResource.getEmojiProvider();
    });
const $9a75dbe340213ba1$export$f9c5a1e85ff0cb72 = (cloudId, accountId, // fetchAtStart allows you to delay emoji fetching
// however, if it is used in an editor, remember to call `fetchEmojiProvider` on mount
// because typing `:` does not trigger emoji fetching
fetchAtStart = true)=>(0, $kFrAe.getServiceProvider)((0, $kFrAe.EMOJI_WITH_CUSTOM_SERVICEID), (serviceBaseUrl)=>{
        const providers = cloudId ? [
            ...$9a75dbe340213ba1$var$baseProviders(serviceBaseUrl),
            {
                url: `${serviceBaseUrl}/emoji/${cloudId}/site`
            }
        ] : $9a75dbe340213ba1$var$baseProviders(serviceBaseUrl);
        const emojiResource = new (0, $53MhD.default)({
            providers: providers,
            allowUpload: true,
            // @ts-expect-error - TS2322 - Type 'string | null | undefined' is not assignable to type 'string'.
            currentUser: {
                id: accountId
            }
        });
        return emojiResource.getEmojiProvider({
            fetchAtStart: fetchAtStart
        });
    });
const $9a75dbe340213ba1$export$7cda0fc535c2710f = (cloudId, accountId, // fetchAtStart allows you to delay emoji fetching
// however, if it is used in an editor, remember to call `fetchEmojiProvider` on mount
// because typing `:` does not trigger emoji fetching
fetchAtStart = true)=>(0, $kFrAe.getServiceProvider)((0, $kFrAe.EMOJI_WITH_CUSTOM_UPLOAD_DISABLED_SERVICEID), (serviceBaseUrl)=>{
        const providers = cloudId ? [
            ...$9a75dbe340213ba1$var$baseProviders(serviceBaseUrl),
            {
                url: `${serviceBaseUrl}/emoji/${cloudId}/site`
            }
        ] : $9a75dbe340213ba1$var$baseProviders(serviceBaseUrl);
        const emojiResource = new (0, $53MhD.default)({
            providers: providers,
            allowUpload: false,
            // @ts-expect-error - TS2322 - Type 'string | null' is not assignable to type 'string'.
            currentUser: {
                id: accountId
            }
        });
        return emojiResource.getEmojiProvider({
            fetchAtStart: fetchAtStart
        });
    });
const $9a75dbe340213ba1$export$12c2b0bd175ad5c1 = async (emojiProviderPromise)=>{
    (await emojiProviderPromise)?.fetchEmojiProvider();
};

});
parcelRegister("53MhD", function(module, exports) {

$parcel$export(module.exports, "supportsUploadFeature", () => $a7fb98cbcf1e0eb5$export$7b697b720032fd6f);
$parcel$export(module.exports, "default", () => $a7fb98cbcf1e0eb5$export$2e2bcd8739ae039);
parcelRequire("kp3br");
var $7Eo2D = parcelRequire("7Eo2D");
var $kp3br = parcelRequire("kp3br");

var $8iUeU = parcelRequire("8iUeU");

var $32Nbx = parcelRequire("32Nbx");

var $fqzOa = parcelRequire("fqzOa");

var $G2hpM = parcelRequire("G2hpM");

var $adGgK = parcelRequire("adGgK");

var $kMGBZ = parcelRequire("kMGBZ");

var $5QefI = parcelRequire("5QefI");

var $g84Mp = parcelRequire("g84Mp");

var $8B8Wm = parcelRequire("8B8Wm");

var $1AKB0 = parcelRequire("1AKB0");
const $a7fb98cbcf1e0eb5$export$7b697b720032fd6f = (emojiProvider)=>{
    const emojiUploadProvider = emojiProvider;
    return !!emojiUploadProvider.isUploadSupported && !!emojiUploadProvider.uploadCustomEmoji && !!emojiUploadProvider.prepareForUpload;
};
class $a7fb98cbcf1e0eb5$export$b5efafc6dd611ec5 extends (0, $7Eo2D.AbstractResource) {
    constructor(config){
        super(), this.activeLoaders = 0, this.initialLoaders = 0, this.retries = new Map(), this.isInitialised = false, this.fetchOnDemand = false, this.getOptimisticImageURL = (emojiId)=>{
            if (this.emojiProviderConfig.optimisticImageApi) return this.emojiProviderConfig.optimisticImageApi.getUrl(emojiId);
            return;
        }, this.isRepositoryAvailable = (repository)=>{
            return !!repository;
        }, this.isLoaded = ()=>this.initialLoaders !== 0 && this.activeLoaders === 0;
        this.emojiProviderConfig = config;
        this.recordConfig = config.recordConfig;
        this.currentUser = config.currentUser;
        if ((0, $G2hpM.default)('localStorage')) this.selectedTone = this.loadStoredTone();
        if (config.providers.length === 0) throw new Error('No providers specified');
        this.fetchOnDemand = !!config.options && !!config.options.onlyFetchOnDemand;
        this.initialLoaders = this.emojiProviderConfig.providers.length;
        this.activeLoaders = this.emojiProviderConfig.providers.length;
        this.emojiResponses = [];
    }
    /**
	 * Get the emoji provider from Emoji Resource
	 * @returns Promise<EmojiProvider>
	 */ async getEmojiProvider(options = {
        fetchAtStart: !this.fetchOnDemand
    }) {
        if (options.fetchAtStart) try {
            await this.fetchEmojiProvider();
        } catch (error) {
            (0, $32Nbx.default)(error);
            return Promise.resolve(this);
        }
        return Promise.resolve(this);
    }
    async fetchIndividualProvider(provider, index) {
        const providerType = this.getProviderType(provider);
        try {
            (0, $8B8Wm.sampledUfoEmojiResourceFetched)(providerType).start({
                samplingRate: (0, $8iUeU.SAMPLING_RATE_EMOJI_RESOURCE_FETCHED_EXP)
            });
            (0, $8B8Wm.sampledUfoEmojiResourceFetched)(providerType).addMetadata({
                type: providerType
            });
            const loader = new (0, $kMGBZ.default)(provider);
            // fetch emoji from provider url and denormalise
            const emojiResponse = await loader.loadEmoji();
            (0, $8B8Wm.sampledUfoEmojiResourceFetched)(providerType).success();
            // setup emoji repository
            this.emojiResponses[index] = emojiResponse;
            this.initEmojiRepository(this.emojiResponses);
            await this.initSiteEmojiResource(emojiResponse, provider);
            this.activeLoaders--;
            this.performRetries();
            this.refreshLastFilter();
        } catch (error) {
            this.activeLoaders--;
            this.notifyError(error);
            (0, $8B8Wm.sampledUfoEmojiResourceFetched)(providerType).failure({
                metadata: {
                    reason: error,
                    source: 'EmojiProvider',
                    providerUrl: provider.url
                }
            });
            (0, $32Nbx.default)(`failed to fetch emoji provider for ${provider.url}`, error);
            throw new Error(`failed to fetch emoji from ${provider.url}`);
        }
    }
    async fetchEmojiProvider(force = false) {
        // unless (re-)fetch is being forced, fetching will only
        // happen if no emojiRepository exists
        // in case this method is called and emojiRepository has already been populated
        // the method will just return the existing emojiRepository
        if (force || !this.isRepositoryAvailable(this.emojiRepository) && !this.isInitialised) {
            this.isInitialised = true;
            this.emojiResponses = [];
            // fetch emoji providers
            await Promise.all(this.emojiProviderConfig.providers.map((provider, index)=>this.fetchIndividualProvider(provider, index)));
        }
        return Promise.resolve(this.emojiRepository);
    }
    onlyFetchOnDemand() {
        return this.fetchOnDemand;
    }
    async fetchByEmojiId(emojiId, optimistic) {
        // Check if repository exists and emoji is defined.
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) {
            const emoji = await this.findByEmojiId(emojiId);
            if (emoji) return await this.getMediaEmojiDescriptionURLWithInlineToken(emoji);
        }
        // If optimistic is fetched
        if (this.emojiProviderConfig.singleEmojiApi && optimistic) {
            // if config has singleEmojiApi then fetch single emoji
            const provider = {
                url: this.emojiProviderConfig.singleEmojiApi.getUrl(emojiId),
                securityProvider: this.emojiProviderConfig.singleEmojiApi.securityProvider
            };
            const loader = new (0, $kMGBZ.default)(provider);
            try {
                const loadEmoji = await loader.loadEmoji();
                if (!loadEmoji.emojis[0]) return;
                if (!this.isRepositoryAvailable(this.siteEmojiResource)) await this.initSiteEmojiResource(loadEmoji, provider);
                return this.getMediaEmojiDescriptionURLWithInlineToken(loadEmoji.emojis[0]);
            } catch  {
                const emoji = await this.findByEmojiId(emojiId);
                if (!emoji) return;
                return this.getMediaEmojiDescriptionURLWithInlineToken(emoji);
            }
        }
        const emoji = await this.findByEmojiId(emojiId);
        if (!emoji) return;
        return this.getMediaEmojiDescriptionURLWithInlineToken(emoji);
    }
    getProviderType(provider) {
        if (provider.url.includes('/site')) return (0, $adGgK.ProviderTypes).SITE;
        else if (provider.url.includes('/standard')) return (0, $adGgK.ProviderTypes).STANDARD;
        else if (provider.url.includes('/atlassian')) return (0, $adGgK.ProviderTypes).ATLASSIAN;
        return (0, $adGgK.ProviderTypes).UNKNOWN;
    }
    initEmojiRepository(emojiResponses) {
        let emojis = [];
        emojiResponses.forEach((emojiResponse)=>{
            emojis = emojis.concat(emojiResponse.emojis);
        });
        this.emojiRepository = new (0, $5QefI.default)(emojis);
    }
    initSiteEmojiResource(emojiResponse, provider) {
        if (!this.isRepositoryAvailable(this.siteEmojiResource) && emojiResponse.mediaApiToken) {
            this.siteEmojiResource = new (0, $g84Mp.default)(provider, emojiResponse.mediaApiToken);
            // Prime cache type + optimistic rendering by checking first Emoji.
            // If this is fails, it won't be primed until a good emoji is loaded later.
            const { emojis: emojis } = emojiResponse;
            if (emojis.length) {
                const done = this.siteEmojiResource.optimisticRendering(emojis[0]);
                if ((0, $fqzOa.isPromise)(done)) return done.then(()=>{
                    (0, $32Nbx.default)('Primed siteEmojiResource');
                }).catch(()=>{
                    (0, $32Nbx.default)('Failed to prime siteEmojiResource');
                });
                else (0, $32Nbx.default)('Already primed siteEmojiResource');
            } else (0, $32Nbx.default)('No emoji to prime siteEmojiResource with');
        }
        return Promise.resolve();
    }
    performRetries() {
        const currentRetries = this.retries;
        this.retries = new Map();
        currentRetries.forEach((resolveReject, retry)=>{
            const result = retry();
            if ((0, $fqzOa.isPromise)(result)) result.then((response)=>{
                resolveReject.resolve(response);
            }).catch((reason)=>{
                resolveReject.reject(reason);
            });
            else resolveReject.resolve(result);
        });
    }
    loadStoredTone() {
        if (typeof window === 'undefined') return undefined;
        const storedToneString = window.localStorage.getItem((0, $8iUeU.selectedToneStorageKey));
        if (storedToneString) {
            const storedTone = parseInt(storedToneString, 10);
            return !isNaN(storedTone) ? storedTone : undefined;
        }
        return undefined;
    }
    refreshLastFilter() {
        if (typeof this.lastQuery !== 'undefined') {
            const { query: query, options: options } = this.lastQuery;
            this.filter(query, options);
        }
    }
    retryIfLoading(retry, defaultResponse) {
        if (!this.isLoaded()) return new Promise((resolve, reject)=>{
            this.retries.set(retry, {
                resolve: resolve,
                reject: reject
            });
        });
        return Promise.resolve(defaultResponse);
    }
    notifyResult(result) {
        if (this.lastQuery && result.query === this.lastQuery.query) super.notifyResult(result);
    }
    /**
	 *  Returns the EmojiDescription with a valid media path that includes query token and client attributes to access the emoji media inline.
	 */ async getMediaEmojiDescriptionURLWithInlineToken(emoji) {
        if (this.isRepositoryAvailable(this.siteEmojiResource)) {
            const { representation: representation, altRepresentation: altRepresentation } = await this.siteEmojiResource.generateTokenisedMediaURLS(emoji.representation, emoji.altRepresentation);
            return {
                ...emoji,
                representation: representation,
                altRepresentation: altRepresentation
            };
        }
        return emoji;
    }
    loadMediaEmoji(emoji, useAlt) {
        if (!this.isRepositoryAvailable(this.siteEmojiResource) || !(0, $fqzOa.isMediaEmoji)(emoji)) return emoji;
        return this.siteEmojiResource.loadMediaEmoji(emoji, useAlt);
    }
    optimisticMediaRendering(emoji, useAlt) {
        if (!(0, $fqzOa.isMediaEmoji)(emoji)) return true;
        if (!this.isRepositoryAvailable(this.siteEmojiResource)) // Shouldn't have a media emoji without a siteEmojiResouce, but anyway ;)
        return false;
        const optimistic = this.siteEmojiResource.optimisticRendering(emoji, useAlt);
        if ((0, $fqzOa.isPromise)(optimistic)) // Not sure yet, so lets say no for now (this should normally be primed in most/all cases)
        return false;
        return optimistic;
    }
    filter(query, options) {
        (0, $8B8Wm.ufoExperiences)['emoji-searched'].start();
        (0, $8B8Wm.ufoExperiences)['emoji-searched'].addMetadata({
            queryLength: query?.length || 0
        });
        this.lastQuery = {
            query: query,
            options: options
        };
        if (this.isRepositoryAvailable(this.emojiRepository)) {
            const searchResults = this.emojiRepository.search(query, options);
            this.notifyResult(searchResults);
            (0, $8B8Wm.ufoExperiences)['emoji-searched'].success({
                metadata: {
                    emojisLength: searchResults.emojis.length,
                    source: options?.source || 'typeahead'
                }
            });
        } else // not ready
        this.notifyNotReady();
    }
    findByShortName(shortName) {
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) // Wait for all emoji to load before looking by shortName (to ensure correct priority)
        return this.emojiRepository.findByShortName(shortName);
        return this.retryIfLoading(()=>this.findByShortName(shortName), undefined);
    }
    findByEmojiId(emojiId) {
        const { id: id, shortName: shortName } = emojiId;
        if (this.isRepositoryAvailable(this.emojiRepository)) {
            if (id) {
                const emoji = this.emojiRepository.findById(id);
                if (emoji) return emoji;
                if (this.isLoaded()) {
                    // all loaded but not found by id, try server to see if
                    // this is a newly uploaded emoji
                    if (this.isRepositoryAvailable(this.siteEmojiResource)) return this.siteEmojiResource.findEmoji(emojiId).then((emoji)=>{
                        if (!emoji) // if not, fallback to searching by shortName to
                        // at least render an alternative
                        return this.findByShortName(shortName);
                        this.addUnknownEmoji(emoji);
                        return emoji;
                    });
                    // if not, fallback to searching by shortName to
                    // at least render an alternative
                    return this.findByShortName(shortName);
                }
            } else // no id fallback to shortName
            return this.findByShortName(shortName);
        }
        return this.retryIfLoading(()=>this.findByEmojiId(emojiId), undefined);
    }
    findById(id) {
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return this.emojiRepository.findById(id);
        return this.retryIfLoading(()=>this.findById(id), undefined);
    }
    findInCategory(categoryId) {
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return Promise.resolve(this.emojiRepository.findInCategory(categoryId));
        return this.retryIfLoading(()=>this.findInCategory(categoryId), []);
    }
    getAsciiMap() {
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return Promise.resolve(this.emojiRepository.getAsciiMap());
        return this.retryIfLoading(()=>this.getAsciiMap(), new Map());
    }
    getFrequentlyUsed(options) {
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return Promise.resolve(this.emojiRepository.getFrequentlyUsed(options));
        return this.retryIfLoading(()=>this.getFrequentlyUsed(options), []);
    }
    /**
	 * Record the selection of an emoji to a remote service if 'recordConfig' has been supplied.
	 * Regardless of the recordConfig, emoji selections will always be recorded on the EmojiRepository
	 * for the purposes of tracking the frequency of use.
	 *
	 * @param emoji The full description of the emoji to record usage for.
	 */ recordSelection(emoji) {
        const { recordConfig: recordConfig } = this;
        if (this.isRepositoryAvailable(this.emojiRepository)) this.emojiRepository.used(emoji);
        if (recordConfig) {
            const queryParams = {
                emojiId: (0, $fqzOa.toEmojiId)(emoji)
            };
            const requestInit = {
                method: 'POST'
            };
            return (0, $kp3br.utils).requestService(recordConfig, {
                queryParams: queryParams,
                requestInit: requestInit
            });
        }
        return Promise.resolve();
    }
    deleteSiteEmoji(emoji) {
        if (this.isRepositoryAvailable(this.siteEmojiResource) && emoji.id) return this.siteEmojiResource.deleteEmoji(emoji).then((success)=>{
            if (success && this.isRepositoryAvailable(this.emojiRepository)) {
                this.emojiRepository.delete(emoji);
                return true;
            }
            return false;
        }).catch((err)=>{
            // eslint-disable-next-line no-console
            console.error('failed to delete site emoji', err);
            return false;
        });
        return this.retryIfLoading(()=>this.deleteSiteEmoji(emoji), false);
    }
    getSelectedTone() {
        return this.selectedTone;
    }
    setSelectedTone(tone) {
        this.selectedTone = tone;
        if (typeof window === 'undefined') return;
        if ((0, $G2hpM.default)('localStorage')) try {
            window.localStorage.setItem((0, $8iUeU.selectedToneStorageKey), tone ? tone.toString() : '');
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error('failed to store selected emoji skin tone', e);
        }
    }
    calculateDynamicCategories() {
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return Promise.resolve(this.emojiRepository.getDynamicCategoryList());
        return this.retryIfLoading(()=>this.calculateDynamicCategories(), []);
    }
    getCurrentUser() {
        return this.currentUser;
    }
    addUnknownEmoji(emoji) {
        if (this.isRepositoryAvailable(this.emojiRepository)) this.emojiRepository.addUnknownEmoji(emoji);
    }
}
class $a7fb98cbcf1e0eb5$export$2e2bcd8739ae039 extends $a7fb98cbcf1e0eb5$export$b5efafc6dd611ec5 {
    constructor(config){
        super(config);
        this.allowUpload = !!config.allowUpload;
    }
    isUploadSupported() {
        if (!this.allowUpload) return Promise.resolve(false);
        if (this.isRepositoryAvailable(this.siteEmojiResource)) return this.siteEmojiResource.hasUploadToken();
        return this.retryIfLoading(()=>this.isUploadSupported(), false);
    }
    uploadCustomEmoji(upload, retry = false, timeout = 12000) {
        return this.isUploadSupported().then((supported)=>{
            if (!supported || !this.isRepositoryAvailable(this.siteEmojiResource)) return Promise.reject('No media api support is configured');
            const uploadPromise = this.siteEmojiResource.uploadEmoji(upload, retry).then((emoji)=>{
                // Use file preview blob URL to temporarily fix the graybox issue after uploading,
                // Because the media service takes time to process the image.
                // Ideally should improve CachingMediaImage by using mediaClient or mediaImage,
                // But that requires more efforts in FE & BE.
                // TODO: revist this when pick up COLLAB-2294
                emoji.representation.imagePath = upload.dataURL;
                this.addUnknownEmoji(emoji);
                this.refreshLastFilter();
                return emoji;
            });
            return (0, $1AKB0.promiseWithTimeout)(uploadPromise, timeout, 'uploadCustomEmoji timed out');
        });
    }
    prepareForUpload() {
        if (this.isRepositoryAvailable(this.siteEmojiResource)) this.siteEmojiResource.prepareForUpload();
        return this.retryIfLoading(()=>this.prepareForUpload(), undefined);
    }
}

});
parcelRegister("kp3br", function(module, exports) {
$parcel$export(module.exports, "AbstractResource", () => (parcelRequire("7Eo2D")).AbstractResource);

$parcel$export(module.exports, "utils", () => $6d8672354a8f8023$export$eab97d15b1788b8d);
parcelRequire("cVQsv");
parcelRequire("7Eo2D");

var $cT1cs = parcelRequire("cT1cs");

var $dyzJo = parcelRequire("dyzJo");
const $6d8672354a8f8023$export$eab97d15b1788b8d = $cT1cs;
const $6d8672354a8f8023$export$3b4c04cf7dad0e50 = $dyzJo;

});
parcelRegister("cVQsv", function(module, exports) {

$parcel$export(module.exports, "buildCredentials", () => $f9c5af0d8b1f4531$export$2ac26f1ab7eda637);
const $f9c5af0d8b1f4531$export$2ac26f1ab7eda637 = (secOptions)=>{
    return secOptions && secOptions.omitCredentials ? 'omit' : 'include';
};

});

parcelRegister("7Eo2D", function(module, exports) {

$parcel$export(module.exports, "AbstractResource", () => $33168f42924c071f$export$4529f10aed0950d4);
class $33168f42924c071f$export$4529f10aed0950d4 {
    subscribe(onChange) {
        this.listeners.add(onChange);
        if (this.lastResult) // Notify subscribe of last result (i.e. initial state)
        onChange.result(this.lastResult);
    }
    unsubscribe(onChange) {
        this.listeners.delete(onChange);
    }
    notifyResult(result) {
        this.listeners.forEach((onChange)=>{
            onChange.result(result);
        });
    }
    notifyError(error) {
        this.listeners.forEach((onChange)=>{
            if (onChange.error) onChange.error(error);
        });
    }
    notifyInfo(info) {
        this.listeners.forEach((onChange)=>{
            if (onChange.info) onChange.info(info);
        });
    }
    notifyNotReady() {
        this.listeners.forEach((onChange)=>{
            if (onChange.notReady) onChange.notReady();
        });
    }
    constructor(){
        this.listeners = new Set();
    }
}

});

parcelRegister("cT1cs", function(module, exports) {

$parcel$export(module.exports, "requestService", () => $8293192fd096fa7a$export$97bfde5a702aaeca);

var $fiPhB = parcelRequire("fiPhB");

var $eGOwo = parcelRequire("eGOwo");

var $4iJGP = parcelRequire("4iJGP");

var $cVQsv = parcelRequire("cVQsv");

var $2Ndb8 = parcelRequire("2Ndb8");
const $8293192fd096fa7a$export$97bfde5a702aaeca = (serviceConfig, options)=>{
    const { url: url, securityProvider: securityProvider, refreshedSecurityProvider: refreshedSecurityProvider } = serviceConfig;
    const { path: path, queryParams: queryParams, requestInit: requestInit } = options || (0, $2Ndb8.defaultRequestServiceOptions);
    const secOptions = securityProvider && securityProvider();
    const requestUrl = (0, $2Ndb8.buildUrl)(url, path, queryParams, secOptions);
    const headers = (0, $2Ndb8.buildHeaders)(secOptions, requestInit && requestInit.headers);
    const credentials = (0, $cVQsv.buildCredentials)(secOptions);
    const ignoreResponsePayload = options?.ignoreResponsePayload || false;
    // Get tracing headers from UFO
    const TRACING_HEADER_FOR_SERVICE_UTIL = 'platform_collab_provider_tracingheaders';
    const tracingHeaderEnabled = (0, $eGOwo.fg)('platform_collab_provider_tracingheaders');
    (0, $4iJGP.addFeatureFlagAccessed)(TRACING_HEADER_FOR_SERVICE_UTIL, tracingHeaderEnabled);
    let tracingHeaders = {};
    if (tracingHeaderEnabled) tracingHeaders = (0, $fiPhB.getActiveTraceHttpRequestHeaders)(url);
    const requestOptions = {
        ...requestInit,
        // populate headers mainly for the collab provider however
        // other components which uses this util can get the header as well.
        // Those tracing headers shall not incur any issues as long as backends handle them properly
        headers: {
            ...headers,
            ...tracingHeaders
        },
        credentials: credentials
    };
    return fetch(requestUrl, requestOptions).then((response)=>{
        if (response.status === 204) return Promise.resolve();
        else if (response.ok) return ignoreResponsePayload ? Promise.resolve() : response.json();
        else if (response.status === 401 && refreshedSecurityProvider) // auth issue - try once
        return refreshedSecurityProvider().then((newSecOptions)=>{
            const retryServiceConfig = {
                url: url,
                securityProvider: ()=>newSecOptions
            };
            return $8293192fd096fa7a$export$97bfde5a702aaeca(retryServiceConfig, options);
        });
        return Promise.reject({
            code: response.status,
            reason: response.statusText
        });
    });
};

});
parcelRegister("2Ndb8", function(module, exports) {

$parcel$export(module.exports, "defaultRequestServiceOptions", () => $fdc006ca8b04950a$export$160dbda113bfad3b);
$parcel$export(module.exports, "buildUrl", () => $fdc006ca8b04950a$export$b5cd97dee32de81d);
$parcel$export(module.exports, "buildHeaders", () => $fdc006ca8b04950a$export$7d6ed858a91629c3);
const $fdc006ca8b04950a$export$160dbda113bfad3b = {};
const $fdc006ca8b04950a$export$b5cd97dee32de81d = (baseUrl, path = '', queryParams, secOptions)=>{
    const searchParam = new URLSearchParams(// For relative urls, the URL class requires base to be set. It's ignored if a url is not relative.
    // Since we only care about search params it is fine to have any base url here.
    new URL(baseUrl, 'https://BASE_FALLBACK').search || undefined);
    baseUrl = baseUrl.split('?')[0];
    if (queryParams) {
        for(const key in queryParams)if (({}).hasOwnProperty.call(queryParams, key)) searchParam.append(key, queryParams[key]);
    }
    if (secOptions && secOptions.params) {
        for(const key in secOptions.params)if (({}).hasOwnProperty.call(secOptions.params, key)) {
            const values = secOptions.params[key];
            if (Array.isArray(values)) for(let i = 0; i < values.length; i++)searchParam.append(key, values[i]);
            else searchParam.append(key, values);
        }
    }
    let separator = '';
    if (path && baseUrl.substr(-1) !== '/' && !path.startsWith('/')) separator = '/';
    let params = searchParam.toString();
    if (params) params = '?' + params;
    return `${baseUrl}${separator}${path}${params}`;
};
const $fdc006ca8b04950a$var$addToHeaders = (headers, keyValues)=>{
    if (keyValues) {
        for(const key in keyValues)if (({}).hasOwnProperty.call(keyValues, key)) {
            const values = keyValues[key];
            if (Array.isArray(values)) for(let i = 0; i < values.length; i++)headers[key] = values[i];
            else headers[key] = values;
        }
    }
};
const $fdc006ca8b04950a$export$7d6ed858a91629c3 = (secOptions, extraHeaders)=>{
    const headers = {};
    $fdc006ca8b04950a$var$addToHeaders(headers, extraHeaders);
    if (secOptions) $fdc006ca8b04950a$var$addToHeaders(headers, secOptions.headers);
    return headers;
};

});


parcelRegister("dyzJo", function(module, exports) {

$parcel$export(module.exports, "requestServiceMultipart", () => $94befa78e14abede$export$8b13532c81e8ac89);

var $hCu6N = parcelRequire("hCu6N");

var $cVQsv = parcelRequire("cVQsv");

var $2Ndb8 = parcelRequire("2Ndb8");

var $eGOwo = parcelRequire("eGOwo");

var $4iJGP = parcelRequire("4iJGP");

var $fiPhB = parcelRequire("fiPhB");
const $94befa78e14abede$export$8b13532c81e8ac89 = async (serviceConfig, options = (0, $2Ndb8.defaultRequestServiceOptions))=>{
    const { url: url, securityProvider: securityProvider, refreshedSecurityProvider: refreshedSecurityProvider } = serviceConfig;
    const { path: path, queryParams: queryParams, requestInit: requestInit } = options;
    const secOptions = securityProvider && securityProvider();
    const requestUrl = (0, $2Ndb8.buildUrl)(url, path, queryParams, secOptions);
    const headers = (0, $2Ndb8.buildHeaders)(secOptions, requestInit && requestInit.headers);
    const credentials = (0, $cVQsv.buildCredentials)(secOptions);
    // Get tracing headers from UFO
    const TRACING_HEADER_FOR_SERVICE_UTIL = 'platform_collab_provider_tracingheaders';
    const tracingHeaderEnabled = (0, $eGOwo.fg)('platform_collab_provider_tracingheaders');
    (0, $4iJGP.addFeatureFlagAccessed)(TRACING_HEADER_FOR_SERVICE_UTIL, tracingHeaderEnabled);
    let tracingHeaders = {};
    if (tracingHeaderEnabled) tracingHeaders = (0, $fiPhB.getActiveTraceHttpRequestHeaders)(url);
    const requestOptions = {
        ...requestInit,
        // populate headers mainly for the collab provider however
        // other components which uses this util can get the header as well.
        // Those tracing headers shall not incur any issues as long as backends handle them properly
        headers: {
            ...headers,
            ...tracingHeaders
        },
        credentials: credentials
    };
    const fetchResponse = await fetch(requestUrl, requestOptions);
    const parts = await (0, $hCu6N.meros)(fetchResponse);
    if (fetchResponse.ok && fetchResponse.status !== 204) {
        if (parts[Symbol.asyncIterator] < 'u') // this lets us know that the response is multipart
        //
        // 	((parts as PartsGenerator)[Symbol.asyncIterator] as any) < 'u' came from the `meros` docs:
        //	https://github.com/maraisr/meros/blob/dec4feaa24090b94e8ac42fab1aff38a1e521680/readme.md
        // 	Look for expand section `If the content-type is NOT a multipart, then meros will resolve with the response argument.`
        return {
            isMultipart: true,
            parts: parts
        };
        return {
            isMultipart: false,
            body: await parts.json()
        };
    } else if (fetchResponse.status === 401 && refreshedSecurityProvider) // auth issue - try once
    return refreshedSecurityProvider().then((newSecOptions)=>{
        const retryServiceConfig = {
            url: url,
            securityProvider: ()=>newSecOptions
        };
        return $94befa78e14abede$export$8b13532c81e8ac89(retryServiceConfig, options);
    });
    return Promise.reject({
        code: fetchResponse.status,
        reason: fetchResponse.statusText
    });
};

});
parcelRegister("hCu6N", function(module, exports) {

$parcel$export(module.exports, "meros", () => $cd3d5734723579c0$export$74e0a034be2368c7);
var $cd3d5734723579c0$var$e = new TextDecoder;
async function $cd3d5734723579c0$export$74e0a034be2368c7(t, n) {
    if (!t.ok || !t.body || t.bodyUsed) return t;
    let i = t.headers.get("content-type");
    if (!i || !~i.indexOf("multipart/")) return t;
    let l = i.indexOf("boundary="), r = "-";
    if (~l) {
        let e = l + 9, t = i.indexOf(";", e);
        r = i.slice(e, t > -1 ? t : void 0).trim().replace(/"/g, "");
    }
    return async function*(t, n, i) {
        let l, r, d, o = t.getReader(), a = !i || !i.multiple, f = n.length, s = "", c = [];
        try {
            let t;
            e: for(; !(t = await o.read()).done;){
                let i = $cd3d5734723579c0$var$e.decode(t.value);
                l = s.length, s += i;
                let o = i.indexOf(n);
                for(~o ? l += o : l = s.indexOf(n), c = []; ~l;){
                    let e = s.slice(0, l), t = s.slice(l + f);
                    if (r) {
                        let n = e.indexOf("\r\n\r\n") + 4, i = e.lastIndexOf("\r\n", n), l = !1, r = e.slice(n, i > -1 ? void 0 : i), o = String(e.slice(0, n)).trim().split("\r\n"), f = {}, s = o.length;
                        for(; d = o[--s]; d = d.split(": "), f[d.shift().toLowerCase()] = d.join(": "));
                        if (d = f["content-type"], d && ~d.indexOf("application/json")) try {
                            r = JSON.parse(r), l = !0;
                        } catch (e) {}
                        if (d = {
                            headers: f,
                            body: r,
                            json: l
                        }, a ? yield d : c.push(d), "--" === t.slice(0, 2)) break e;
                    } else n = "\r\n" + n, r = f += 2;
                    s = t, l = s.indexOf(n);
                }
                c.length && (yield c);
            }
        } finally{
            c.length && (yield c), await o.cancel();
        }
    }(t.body, `--${r}`, n);
}

});



parcelRegister("8iUeU", function(module, exports) {

$parcel$export(module.exports, "customCategory", () => $2c4fbc100f789f14$export$5e4e3d1c3e43156a);
$parcel$export(module.exports, "frequentCategory", () => $2c4fbc100f789f14$export$78ccdc4be403c468);
$parcel$export(module.exports, "searchCategory", () => $2c4fbc100f789f14$export$1b0258512be88334);
$parcel$export(module.exports, "yourUploadsCategory", () => $2c4fbc100f789f14$export$42b510423367f354);
$parcel$export(module.exports, "customTitle", () => $2c4fbc100f789f14$export$5d0f2d8ee50f86f5);
$parcel$export(module.exports, "userCustomTitle", () => $2c4fbc100f789f14$export$1debc2f10cc69389);
$parcel$export(module.exports, "dataURLPrefix", () => $2c4fbc100f789f14$export$8ac325bfd32359b0);
$parcel$export(module.exports, "deleteEmojiLabel", () => $2c4fbc100f789f14$export$a330961542edfe6f);
$parcel$export(module.exports, "MAX_ORDINAL", () => $2c4fbc100f789f14$export$1a817f1886276c6d);
$parcel$export(module.exports, "defaultEmojiHeight", () => $2c4fbc100f789f14$export$3f99ac31dc0406db);
$parcel$export(module.exports, "emojiPickerWidth", () => $2c4fbc100f789f14$export$d171dc12fee2b1da);
$parcel$export(module.exports, "sizeGap", () => $2c4fbc100f789f14$export$c10ac8125a260041);
$parcel$export(module.exports, "defaultEmojiPickerSize", () => $2c4fbc100f789f14$export$5248fb9e0cccc41f);
$parcel$export(module.exports, "emojiPickerListHeight", () => $2c4fbc100f789f14$export$7722b8e9522021df);
$parcel$export(module.exports, "localStoragePrefix", () => $2c4fbc100f789f14$export$e394a0c530ae5631);
$parcel$export(module.exports, "selectedToneStorageKey", () => $2c4fbc100f789f14$export$79ee4ef84c545f8f);
$parcel$export(module.exports, "defaultCategories", () => $2c4fbc100f789f14$export$d7ab74456f1aa1ad);
$parcel$export(module.exports, "KeyboardKeys", () => $2c4fbc100f789f14$export$70f9e5bc10d7eac);
$parcel$export(module.exports, "KeyboardNavigationDirection", () => $2c4fbc100f789f14$export$1c4f2adc1f8e19d3);
$parcel$export(module.exports, "CATEGORYSELECTOR_KEYBOARD_KEYS_SUPPORTED", () => $2c4fbc100f789f14$export$99130b698ea188ae);
$parcel$export(module.exports, "EMOJI_KEYBOARD_KEYS_SUPPORTED", () => $2c4fbc100f789f14$export$84b035f8d01101cc);
$parcel$export(module.exports, "TONESELECTOR_KEYBOARD_KEYS_SUPPORTED", () => $2c4fbc100f789f14$export$e27d4e477c0cd4ec);
$parcel$export(module.exports, "EMOJIPICKERLIST_KEYBOARD_KEYS_SUPPORTED", () => $2c4fbc100f789f14$export$97027974dc06eeee);
$parcel$export(module.exports, "DEFAULT_TONE", () => $2c4fbc100f789f14$export$4f0ee90b28d6efc5);
$parcel$export(module.exports, "EMOJI_LIST_COLUMNS", () => $2c4fbc100f789f14$export$2829f3ec323f8ec0);
$parcel$export(module.exports, "EMOJI_LIST_PAGE_COUNT", () => $2c4fbc100f789f14$export$ce3a0e7d2d7d6ba2);
$parcel$export(module.exports, "EMOJI_SEARCH_DEBOUNCE", () => $2c4fbc100f789f14$export$858e8dc100a97278);
$parcel$export(module.exports, "SAMPLING_RATE_EMOJI_RENDERED_EXP", () => $2c4fbc100f789f14$export$83aab2ae64548423);
$parcel$export(module.exports, "SAMPLING_RATE_EMOJI_RESOURCE_FETCHED_EXP", () => $2c4fbc100f789f14$export$66cabad5e268b05e);
const $2c4fbc100f789f14$export$5e4e3d1c3e43156a = 'CUSTOM';
const $2c4fbc100f789f14$export$78ccdc4be403c468 = 'FREQUENT';
const $2c4fbc100f789f14$export$2c4b04c3aacdf1b3 = 'SITE';
const $2c4fbc100f789f14$export$1b0258512be88334 = 'SEARCH';
const $2c4fbc100f789f14$export$42b510423367f354 = 'USER_CUSTOM';
const $2c4fbc100f789f14$export$5d0f2d8ee50f86f5 = 'allUploadsCustomCategory';
const $2c4fbc100f789f14$export$1debc2f10cc69389 = 'userUploadsCustomCategory';
const $2c4fbc100f789f14$export$8ac325bfd32359b0 = 'data:';
const $2c4fbc100f789f14$export$a330961542edfe6f = 'delete-emoji';
const $2c4fbc100f789f14$export$1a817f1886276c6d = 100000;
const $2c4fbc100f789f14$export$3f99ac31dc0406db = 20;
const $2c4fbc100f789f14$export$d171dc12fee2b1da = 350;
const $2c4fbc100f789f14$export$c10ac8125a260041 = 80;
const $2c4fbc100f789f14$export$5248fb9e0cccc41f = 'medium';
const $2c4fbc100f789f14$export$94f75d625e7801d3 = 260;
const $2c4fbc100f789f14$export$7ed599d166d65aea = 295;
const $2c4fbc100f789f14$export$7722b8e9522021df = $2c4fbc100f789f14$export$7ed599d166d65aea - 58; // picker height - actions height
const $2c4fbc100f789f14$export$e218e5cb105a0e22 = 54;
const $2c4fbc100f789f14$export$e67f617938b111f1 = $2c4fbc100f789f14$export$7ed599d166d65aea + $2c4fbc100f789f14$export$e218e5cb105a0e22;
const $2c4fbc100f789f14$export$e394a0c530ae5631 = 'fabric.emoji';
const $2c4fbc100f789f14$export$79ee4ef84c545f8f = `${$2c4fbc100f789f14$export$e394a0c530ae5631}.selectedTone`;
const $2c4fbc100f789f14$export$d7ab74456f1aa1ad = [
    'PEOPLE',
    'NATURE',
    'FOODS',
    'ACTIVITY',
    'PLACES',
    'OBJECTS',
    'SYMBOLS',
    'FLAGS'
];
var $2c4fbc100f789f14$export$70f9e5bc10d7eac = /*#__PURE__*/ function(KeyboardKeys) {
    KeyboardKeys["ArrowLeft"] = "ArrowLeft";
    KeyboardKeys["ArrowRight"] = "ArrowRight";
    KeyboardKeys["ArrowUp"] = "ArrowUp";
    KeyboardKeys["ArrowDown"] = "ArrowDown";
    KeyboardKeys["PageUp"] = "PageUp";
    KeyboardKeys["PageDown"] = "PageDown";
    KeyboardKeys["Home"] = "Home";
    KeyboardKeys["End"] = "End";
    KeyboardKeys["Enter"] = "Enter";
    KeyboardKeys["Tab"] = "Tab";
    KeyboardKeys["Space"] = " ";
    KeyboardKeys["Backspace"] = "Backspace";
    return KeyboardKeys;
}({});
var $2c4fbc100f789f14$export$1c4f2adc1f8e19d3 = /*#__PURE__*/ function(KeyboardNavigationDirection) {
    KeyboardNavigationDirection["Down"] = "Down";
    KeyboardNavigationDirection["Up"] = "Up";
    KeyboardNavigationDirection["Left"] = "Left";
    KeyboardNavigationDirection["Right"] = "Right";
    return KeyboardNavigationDirection;
}({});
const $2c4fbc100f789f14$export$99130b698ea188ae = [
    "ArrowRight",
    "ArrowLeft",
    "Home",
    "End"
];
const $2c4fbc100f789f14$export$84b035f8d01101cc = [
    "Enter",
    "Backspace",
    " "
];
const $2c4fbc100f789f14$export$e27d4e477c0cd4ec = [
    "Enter",
    "Tab",
    " "
];
const $2c4fbc100f789f14$export$97027974dc06eeee = [
    "ArrowRight",
    "ArrowLeft",
    "Home",
    "End",
    "ArrowUp",
    "ArrowDown",
    "PageUp",
    "PageDown"
];
const $2c4fbc100f789f14$export$4f0ee90b28d6efc5 = 0;
const $2c4fbc100f789f14$export$9f7de4293d27f3aa = 50;
const $2c4fbc100f789f14$export$41388d9a435030e6 = 'hipchat_migration_emoticons';
const $2c4fbc100f789f14$export$273d18db3ba5f6b1 = 'atlassian.fabric.emoji.picker';
const $2c4fbc100f789f14$export$2829f3ec323f8ec0 = 8;
const $2c4fbc100f789f14$export$ce3a0e7d2d7d6ba2 = 5;
const $2c4fbc100f789f14$export$858e8dc100a97278 = 150;
const $2c4fbc100f789f14$export$83aab2ae64548423 = 20;
const $2c4fbc100f789f14$export$66cabad5e268b05e = 100;

});

parcelRegister("32Nbx", function(module, exports) {

$parcel$export(module.exports, "default", () => $9aab8f9e1de525a0$export$2e2bcd8739ae039);
let $9aab8f9e1de525a0$var$debugEnabled = false;
let $9aab8f9e1de525a0$var$stacktracesEnabled = false;
function $9aab8f9e1de525a0$export$748ada60eaf985cc(enable) {
    $9aab8f9e1de525a0$var$debugEnabled = enable;
}
function $9aab8f9e1de525a0$export$4f7017086af31c25(enable) {
    $9aab8f9e1de525a0$var$stacktracesEnabled = enable;
}
function $9aab8f9e1de525a0$export$2a858f450a2f66d() {
    if ($9aab8f9e1de525a0$var$stacktracesEnabled) // eslint-disable-next-line no-console
    console.log(new Error().stack);
}
function $9aab8f9e1de525a0$export$2e2bcd8739ae039(msg, ...args) {
    if ($9aab8f9e1de525a0$var$debugEnabled) // eslint-disable-next-line no-console
    console.log(msg, ...args);
}

});

parcelRegister("fqzOa", function(module, exports) {

$parcel$export(module.exports, "isSpriteServiceRepresentation", () => $23c7073f5fdbdf31$export$1c52f72b88b558e8);
$parcel$export(module.exports, "isSpriteRepresentation", () => $23c7073f5fdbdf31$export$a194199d673d75de);
$parcel$export(module.exports, "isImageRepresentation", () => $23c7073f5fdbdf31$export$90b099a26fbd8b41);
$parcel$export(module.exports, "isMediaRepresentation", () => $23c7073f5fdbdf31$export$979133dc1df141c6);
$parcel$export(module.exports, "isPromise", () => $23c7073f5fdbdf31$export$4369c812aac99591);
$parcel$export(module.exports, "isEmojiDescription", () => $23c7073f5fdbdf31$export$378ed2c87d03531c);
$parcel$export(module.exports, "isMediaEmoji", () => $23c7073f5fdbdf31$export$a7e82c67204c73a1);
$parcel$export(module.exports, "isLoadedMediaEmoji", () => $23c7073f5fdbdf31$export$d25a80b2c86d7fdf);
$parcel$export(module.exports, "isEmojiDescriptionWithVariations", () => $23c7073f5fdbdf31$export$b0ed6d8df471f3cc);
$parcel$export(module.exports, "isEmojiVariationDescription", () => $23c7073f5fdbdf31$export$82a0350e1f6b5c0a);
$parcel$export(module.exports, "isMessagesKey", () => $23c7073f5fdbdf31$export$dddfba07c16c94d2);
$parcel$export(module.exports, "toEmojiId", () => $23c7073f5fdbdf31$export$8d7d3de6b5b305d1);
$parcel$export(module.exports, "containsEmojiId", () => $23c7073f5fdbdf31$export$39ed0ad389e58ef7);
$parcel$export(module.exports, "convertImageToMediaRepresentation", () => $23c7073f5fdbdf31$export$20a1bd1d33069ce7);
$parcel$export(module.exports, "convertMediaToImageEmoji", () => $23c7073f5fdbdf31$export$f1a89a11f425faaa);
$parcel$export(module.exports, "buildEmojiDescriptionWithAltRepresentation", () => $23c7073f5fdbdf31$export$a48c58c688a3131);
$parcel$export(module.exports, "getCategoryId", () => $23c7073f5fdbdf31$export$4bcbf61cb6832a8e);

var $2lSsS = parcelRequire("2lSsS");

var $8iUeU = parcelRequire("8iUeU");
const $23c7073f5fdbdf31$export$1c52f72b88b558e8 = (rep)=>!!(rep && rep.spriteRef);
const $23c7073f5fdbdf31$export$a194199d673d75de = (rep)=>!!(rep && rep.sprite);
const $23c7073f5fdbdf31$export$90b099a26fbd8b41 = (rep)=>!!(rep && rep.imagePath);
const $23c7073f5fdbdf31$export$979133dc1df141c6 = (rep)=>!!(rep && rep.mediaPath);
const $23c7073f5fdbdf31$export$4369c812aac99591 = (p)=>!!(p && p.then);
const $23c7073f5fdbdf31$export$378ed2c87d03531c = (possibleEmojiDescription)=>possibleEmojiDescription && possibleEmojiDescription.shortName && possibleEmojiDescription.type;
const $23c7073f5fdbdf31$export$a7e82c67204c73a1 = (emoji)=>$23c7073f5fdbdf31$export$979133dc1df141c6(emoji.representation);
const $23c7073f5fdbdf31$export$7720a4954d6f75f8 = (rep)=>$23c7073f5fdbdf31$export$90b099a26fbd8b41(rep) && rep.imagePath.indexOf((0, $8iUeU.dataURLPrefix)) === 0;
const $23c7073f5fdbdf31$export$d25a80b2c86d7fdf = (emoji)=>emoji.category === (0, $8iUeU.customCategory) && $23c7073f5fdbdf31$export$7720a4954d6f75f8(emoji.representation);
const $23c7073f5fdbdf31$export$b0ed6d8df471f3cc = (emoji)=>!!(emoji && emoji.skinVariations);
const $23c7073f5fdbdf31$export$82a0350e1f6b5c0a = (object)=>{
    return 'baseId' in object;
};
const $23c7073f5fdbdf31$export$dddfba07c16c94d2 = (key)=>key in (0, $2lSsS.messages);
const $23c7073f5fdbdf31$export$8d7d3de6b5b305d1 = (emoji)=>({
        shortName: emoji.shortName,
        id: emoji.id,
        fallback: emoji.fallback
    });
const $23c7073f5fdbdf31$export$2dbfa5a5d35af350 = (emoji)=>{
    if (!emoji) return undefined;
    return $23c7073f5fdbdf31$export$8d7d3de6b5b305d1(emoji);
};
const $23c7073f5fdbdf31$export$92ad509d7c96b723 = (l, r)=>l === r || l && r && l.id === r.id && l.shortName === r.shortName;
const $23c7073f5fdbdf31$export$39ed0ad389e58ef7 = (emojis, emojiId)=>{
    if (!emojiId) return false;
    for(let i = 0; i < emojis.length; i++){
        if ($23c7073f5fdbdf31$export$92ad509d7c96b723(emojis[i], emojiId)) return true;
    }
    return false;
};
const $23c7073f5fdbdf31$export$20a1bd1d33069ce7 = (rep)=>({
        mediaPath: rep.imagePath,
        height: rep.height,
        width: rep.width
    });
const $23c7073f5fdbdf31$export$3197405d49d2e298 = (rep, newImagePath)=>({
        imagePath: newImagePath || rep.mediaPath,
        height: rep.height,
        width: rep.width
    });
const $23c7073f5fdbdf31$export$f1a89a11f425faaa = (emoji, newImagePath, useAlt)=>{
    const mediaRepresentation = emoji.representation;
    const mediaAltRepresentation = emoji.altRepresentation;
    const imgPath = !useAlt ? newImagePath : undefined;
    const altImgPath = useAlt ? newImagePath : undefined;
    if (!$23c7073f5fdbdf31$export$979133dc1df141c6(mediaRepresentation) && !$23c7073f5fdbdf31$export$979133dc1df141c6(mediaAltRepresentation)) return emoji;
    const representation = $23c7073f5fdbdf31$export$979133dc1df141c6(mediaRepresentation) ? $23c7073f5fdbdf31$export$3197405d49d2e298(mediaRepresentation, imgPath) : mediaRepresentation;
    const altRepresentation = $23c7073f5fdbdf31$export$979133dc1df141c6(mediaAltRepresentation) ? $23c7073f5fdbdf31$export$3197405d49d2e298(mediaAltRepresentation, altImgPath) : mediaAltRepresentation;
    const baseEmoji = {
        ...emoji,
        representation: representation
    };
    return $23c7073f5fdbdf31$export$a48c58c688a3131(baseEmoji, altRepresentation);
};
const $23c7073f5fdbdf31$export$a48c58c688a3131 = (emoji, altRepresentation)=>{
    if (!altRepresentation) return emoji;
    return {
        ...emoji,
        altRepresentation: altRepresentation
    };
};
const $23c7073f5fdbdf31$export$4bcbf61cb6832a8e = (emoji)=>emoji.category;

});
parcelRegister("2lSsS", function(module, exports) {

$parcel$export(module.exports, "messages", () => $8dae1054855c684a$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $8dae1054855c684a$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    deleteEmojiTooltip: {
        id: 'fabric.emoji.delete.tooltip',
        defaultMessage: 'Delete',
        description: 'Tooltip content for delete emoji when focus on deletable emoji'
    },
    deleteEmojiTooltipForScreenreader: {
        id: 'fabric.emoji.delete.screenreader.tooltip',
        defaultMessage: 'To delete {shortName} emoji, press Backspace',
        description: 'Tooltip content for delete emoji when focus on deletable emoji'
    },
    deleteEmojiTitle: {
        id: 'fabric.emoji.delete.title',
        defaultMessage: 'Remove emoji',
        description: 'Title for emoji removal dialog'
    },
    deleteEmojiDescription: {
        id: 'fabric.emoji.delete.description',
        defaultMessage: 'All existing instances of this emoji will be replaced with {emojiShortName}',
        description: 'Description for emoji removal dialog'
    },
    deleteEmojiLabel: {
        id: 'fabric.emoji.delete.label',
        defaultMessage: 'Remove',
        description: 'Button label to remove emoji'
    },
    addCustomEmojiLabel: {
        id: 'fabric.emoji.add.custom.emoji.label',
        defaultMessage: 'Add your own emoji',
        description: 'Button label to add custom emoji'
    },
    emojiPlaceholder: {
        id: 'fabric.emoji.placeholder',
        defaultMessage: 'e.g. hello',
        description: 'Placeholder for emoji that provides an example for emoji name'
    },
    emojiNameAriaLabel: {
        id: 'fabric.emoji.name.ariaLabel',
        defaultMessage: 'Enter a name for the new emoji',
        description: 'Explains to enter a name for a new emoji'
    },
    emojiChooseFileTitle: {
        id: 'fabric.emoji.choose.file.title',
        defaultMessage: 'Choose file',
        description: 'Choose custom emoji file'
    },
    emojiChooseFileScreenReaderDescription: {
        id: 'fabric.emoji.choose.file.screenReaderDescription',
        defaultMessage: 'Choose a file for the emoji. JPG, PNG or GIF. Max size 1 MB',
        description: 'Message indicating the purpose of choosing the file and requirements for the file'
    },
    emojiSelectSkinToneButtonAriaLabelText: {
        id: 'fabric.emoji.select.skin.tone.ariaLabel',
        defaultMessage: 'Choose your skin tone, {selectedTone} selected',
        description: 'Message indicating the purpose of the skin tone selection button and the selected tone'
    },
    emojiSelectSkinToneListAriaLabelText: {
        id: 'fabric.emoji.select.skin.list.ariaLabel',
        defaultMessage: 'Skin tone selector',
        description: 'Message indicating the purpose of the skin tone list and make user to choose one tone'
    },
    emojiImageRequirements: {
        id: 'fabric.emoji.image.requirements',
        defaultMessage: 'JPG, PNG or GIF. Max size 1 MB.',
        description: 'Message for emoji image requirements and maximum file size'
    },
    emojiPreviewTitle: {
        id: 'fabric.emoji.preview.title',
        defaultMessage: 'Preview',
        description: 'Emoji preview title'
    },
    emojiPreview: {
        id: 'fabric.emoji.preview',
        defaultMessage: 'Your new emoji {emoji} looks great',
        description: 'Emoji preview'
    },
    addEmojiLabel: {
        id: 'fabric.emoji.add.label',
        defaultMessage: 'Add emoji',
        description: 'verb - Button label to add emoji'
    },
    retryLabel: {
        id: 'fabric.emoji.retry.label',
        defaultMessage: 'Retry',
        description: 'verb - Button label to retry upload'
    },
    cancelLabel: {
        id: 'fabric.emoji.cancel.label',
        defaultMessage: 'Cancel',
        description: 'verb - button label to cancel operation'
    },
    searchPlaceholder: {
        id: 'fabric.emoji.search.placeholder',
        defaultMessage: 'Search',
        description: 'Placeholder for search emoji field'
    },
    searchLabel: {
        id: 'fabric.emoji.search.label',
        defaultMessage: 'Emoji name',
        description: 'verb - button label to search'
    },
    searchResultsStatus: {
        id: 'fabric.emoji.search.status.count',
        defaultMessage: 'Found {count} emojis',
        description: 'search results status for screenreader to read out'
    },
    searchResultsStatusSeeAll: {
        id: 'fabric.emoji.search.status',
        defaultMessage: 'Seeing all emojis',
        description: 'search results status when no search query for screenreader to read out'
    },
    categoriesSelectorLabel: {
        id: 'fabric.emoji.categories.label',
        defaultMessage: 'Choose an emoji category',
        description: 'Aria label for Emoji categories selector at the top of emoji picker'
    },
    categoriesSearchResults: {
        id: 'fabric.emoji.categories.search.results',
        defaultMessage: 'Search results',
        description: 'Emoji categories search results'
    },
    frequentCategory: {
        id: 'fabric.emoji.category.frequent',
        defaultMessage: 'Frequent',
        description: 'Emoji frequent category'
    },
    peopleCategory: {
        id: 'fabric.emoji.category.people',
        defaultMessage: 'People',
        description: 'Emoji frequent category'
    },
    natureCategory: {
        id: 'fabric.emoji.category.nature',
        defaultMessage: 'Nature',
        description: 'Emoji nature category'
    },
    foodsCategory: {
        id: 'fabric.emoji.category.foods',
        defaultMessage: 'Food & Drink',
        description: 'Emoji Foods category'
    },
    activityCategory: {
        id: 'fabric.emoji.category.activity',
        defaultMessage: 'Activity',
        description: 'Emoji activity category'
    },
    placesCategory: {
        id: 'fabric.emoji.category.places',
        defaultMessage: 'Travel & Places',
        description: 'Emoji Places category'
    },
    objectsCategory: {
        id: 'fabric.emoji.category.objects',
        defaultMessage: 'Objects',
        description: 'Emoji objects category'
    },
    symbolsCategory: {
        id: 'fabric.emoji.category.symbols',
        defaultMessage: 'Symbols',
        description: 'Emoji symbols category'
    },
    flagsCategory: {
        id: 'fabric.emoji.category.flags',
        defaultMessage: 'Flags',
        description: 'Emoji flags category'
    },
    productivityCategory: {
        id: 'fabric.emoji.category.productivity',
        defaultMessage: 'Atlassian & productivity',
        description: 'Emoji Atlassian & productivity category'
    },
    userUploadsCustomCategory: {
        id: 'fabric.emoji.category.user.uploads',
        defaultMessage: 'Your uploads',
        description: 'User uploads in the custom category'
    },
    allUploadsCustomCategory: {
        id: 'fabric.emoji.category.all.uploads',
        defaultMessage: 'All uploads',
        description: 'All uploads in the custom category'
    },
    deleteEmojiFailed: {
        id: 'fabric.emoji.error.delete.failed',
        defaultMessage: 'Remove failed',
        description: 'Error message when custom emoji failed to be removed'
    },
    emojiInvalidImage: {
        id: 'fabric.emoji.error.invalid.image',
        defaultMessage: 'Selected image is invalid',
        description: 'Error message for invalid selected image'
    },
    emojiUploadFailed: {
        id: 'fabric.emoji.error.upload.failed',
        defaultMessage: 'Upload failed',
        description: 'Failed to upload emoji image'
    },
    emojiUploadTimeout: {
        id: 'fabric.emoji.error.upload.timeout',
        defaultMessage: 'Upload timed out',
        description: 'Failed to upload emoji image'
    },
    emojiImageTooBig: {
        id: 'fabric.emoji.error.image.too.big',
        defaultMessage: 'Selected image is more than 1 MB',
        description: 'Error message for image too big, beyond the size limit'
    },
    emojiPickerTitle: {
        id: 'fabric.emoji.picker',
        defaultMessage: 'Emoji picker',
        description: 'Aria label for emoji picker'
    },
    emojiPickerListPanel: {
        id: 'fabric.emoji.pickerlist.tabpanel',
        defaultMessage: 'Emojis actions and list panel',
        description: 'Aria lable for tabpanel of emoji picker, which shows emojis actions and list'
    },
    emojiPickerGrid: {
        id: 'fabric.emoji.pickerlist.grid',
        defaultMessage: '{showSearchResults, select, true{Search results} other{Emojis}}',
        description: `Aria label for emoji picker grid, showSearchResults is a boolean variable, message will be "Entering Emojis table", or "Leaving Emojis"`
    },
    emojiButtonRoleDescription: {
        id: 'fabric.emoji.emojipicker.emoi.roledescription',
        defaultMessage: 'emoji button',
        description: `Aria roledescription for emoji button, used in emoji picker.`
    },
    error: {
        id: 'fabric.emoji.emojipicker.error',
        defaultMessage: 'Error!',
        description: `Aria label for error icon, apperaed in emoji uploader screens and delete emoji screens of emoji picker`
    }
});

});


parcelRegister("G2hpM", function(module, exports) {

$parcel$export(module.exports, "default", () => $94b47349612cc74c$export$2e2bcd8739ae039);
function $94b47349612cc74c$export$2e2bcd8739ae039(type) {
    if (typeof window === 'undefined') return false;
    var storage;
    try {
        storage = window[type];
        var x = '__storage_test__';
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    } catch (e) {
        return e instanceof DOMException && // everything except Firefox
        (e.code === 22 || // Firefox
        e.code === 1014 || // test name field too, because code might not be present
        // everything except Firefox
        e.name === 'QuotaExceededError' || // Firefox
        e.name === 'NS_ERROR_DOM_QUOTA_REACHED') && // acknowledge QuotaExceededError only if there's something already stored
        storage && storage.length !== 0;
    }
}

});

parcelRegister("adGgK", function(module, exports) {

$parcel$export(module.exports, "SearchSort", () => $a40ac3523e94d0b5$export$a15e9a4340d08b2e);
$parcel$export(module.exports, "SearchSourceTypes", () => $a40ac3523e94d0b5$export$db41220f541db607);
$parcel$export(module.exports, "ProviderTypes", () => $a40ac3523e94d0b5$export$bf337c9223e5c8b);
$parcel$export(module.exports, "UfoExperienceName", () => $a40ac3523e94d0b5$export$d0d1c9cd31a11a64);
$parcel$export(module.exports, "UfoComponentName", () => $a40ac3523e94d0b5$export$122ce5c8fda96269);
$parcel$export(module.exports, "UfoEmojiTimingsKeys", () => $a40ac3523e94d0b5$export$265ee18146a6885e);
$parcel$export(module.exports, "UfoEmojiTimings", () => $a40ac3523e94d0b5$export$482549d945a3723);
var $a40ac3523e94d0b5$export$a15e9a4340d08b2e = /*#__PURE__*/ function(SearchSort) {
    // no sort - just the default ordering of emoji
    SearchSort[SearchSort["None"] = 0] = "None";
    // a sort taking into account a number of factors including, usage, closeness of match to the query, etc
    SearchSort[SearchSort["Default"] = 1] = "Default";
    // sort such that the most frequently used emoji come first, and then standard, service defined ordering is preserved.
    SearchSort[SearchSort["UsageFrequency"] = 2] = "UsageFrequency";
    return SearchSort;
}({});
var $a40ac3523e94d0b5$export$db41220f541db607 = /*#__PURE__*/ function(SearchSourceTypes) {
    SearchSourceTypes["PICKER"] = "picker";
    SearchSourceTypes["TYPEAHEAD"] = "typeahead";
    return SearchSourceTypes;
}({});
var $a40ac3523e94d0b5$export$bf337c9223e5c8b = /*#__PURE__*/ function(ProviderTypes) {
    ProviderTypes["SITE"] = "SITE";
    ProviderTypes["STANDARD"] = "STANDARD";
    ProviderTypes["ATLASSIAN"] = "ATLASSIAN";
    ProviderTypes["UNKNOWN"] = "UNKNOWN";
    ProviderTypes["SINGLE"] = "SINGLE";
    return ProviderTypes;
}({});
var $a40ac3523e94d0b5$export$d0d1c9cd31a11a64 = /*#__PURE__*/ function(UfoExperienceName) {
    UfoExperienceName["EMOJI_RENDERED"] = "emoji-rendered";
    UfoExperienceName["EMOJI_RESOURCE_FETCHED"] = "emoji-resource-fetched";
    UfoExperienceName["EMOJI_PICKER_OPENED"] = "emoji-picker-opened";
    UfoExperienceName["EMOJI_SELECTION_RECORDED"] = "emoji-selection-recorded";
    UfoExperienceName["EMOJI_UPLOADED"] = "emoji-uploaded";
    UfoExperienceName["EMOJI_SEARCHED"] = "emoji-searched";
    return UfoExperienceName;
}({});
var $a40ac3523e94d0b5$export$122ce5c8fda96269 = /*#__PURE__*/ function(UfoComponentName) {
    UfoComponentName["EMOJI"] = "emoji";
    UfoComponentName["EMOJI_PICKER"] = "emoji-picker";
    UfoComponentName["EMOJI_PROVIDER"] = "emoji-provider";
    return UfoComponentName;
}({});
var $a40ac3523e94d0b5$export$265ee18146a6885e = /*#__PURE__*/ function(UfoEmojiTimingsKeys) {
    UfoEmojiTimingsKeys["FMP"] = "fmp";
    UfoEmojiTimingsKeys["MOUNTED"] = "emoji-mount";
    UfoEmojiTimingsKeys["METADATA"] = "emoji-metadata";
    UfoEmojiTimingsKeys["MEDIADATA"] = "emoji-media";
    UfoEmojiTimingsKeys["ONLOAD"] = "emoji-onload";
    return UfoEmojiTimingsKeys;
}({});
var $a40ac3523e94d0b5$export$482549d945a3723 = /*#__PURE__*/ function(UfoEmojiTimings) {
    UfoEmojiTimings["FMP_END"] = "fmp";
    UfoEmojiTimings["MOUNTED_END"] = "emoji-mount_end";
    UfoEmojiTimings["METADATA_START"] = "emoji-metadata_start";
    UfoEmojiTimings["METADATA_END"] = "emoji-metadata_end";
    UfoEmojiTimings["MEDIA_START"] = "emoji-media_start";
    UfoEmojiTimings["MEDIA_END"] = "emoji-media_end";
    UfoEmojiTimings["ONLOAD_START"] = "emoji-onload_start";
    UfoEmojiTimings["ONLOAD_END"] = "emoji-onload_end";
    return UfoEmojiTimings;
}({});

});

parcelRegister("kMGBZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $17c248999a68f2aa$export$2e2bcd8739ae039);

var $cBxa0 = parcelRequire("cBxa0");
class $17c248999a68f2aa$export$2e2bcd8739ae039 {
    constructor(config){
        this.config = config;
    }
    /**
	 * Returns a promise with an array of Emoji from all providers.
	 */ loadEmoji() {
        const emojisPromise = (0, $cBxa0.emojiRequest)(this.config);
        return emojisPromise.then((emojiServiceResponse)=>(0, $cBxa0.denormaliseEmojiServiceResponse)(emojiServiceResponse));
    }
}

});
parcelRegister("cBxa0", function(module, exports) {

$parcel$export(module.exports, "emojiRequest", () => $37cc264674c90168$export$ea1accde4cc117f4);
$parcel$export(module.exports, "getAltRepresentation", () => $37cc264674c90168$export$4a0301d636367e1d);
$parcel$export(module.exports, "denormaliseEmojiServiceResponse", () => $37cc264674c90168$export$afaea97e40b5ca70);
$parcel$export(module.exports, "shouldUseAltRepresentation", () => $37cc264674c90168$export$b7e9058f156d8d19);

var $kp3br = parcelRequire("kp3br");

var $fqzOa = parcelRequire("fqzOa");

var $32Nbx = parcelRequire("32Nbx");
const $37cc264674c90168$export$ea1accde4cc117f4 = (provider, options)=>{
    const { getRatio: getRatio = $37cc264674c90168$export$d39ce20a37bba061, ...serviceConfig } = provider;
    const scaleQueryParams = $37cc264674c90168$var$calculateScale(getRatio);
    const { queryParams: queryParams = {}, ...otherOptions } = options || {};
    const requestOptions = {
        ...otherOptions,
        queryParams: {
            ...scaleQueryParams,
            ...queryParams,
            preferredRepresentation: 'IMAGE'
        }
    };
    return (0, $kp3br.utils).requestService(serviceConfig, requestOptions);
};
const $37cc264674c90168$var$calculateScale = (getRatio)=>{
    // Retina display
    if (getRatio() > 1) return {
        scale: 'XHDPI',
        altScale: 'XXXHDPI'
    };
    // Default set used for desktop
    return {
        altScale: 'XHDPI'
    };
};
const $37cc264674c90168$export$d39ce20a37bba061 = ()=>{
    if (typeof window === 'undefined') return 0;
    return window.devicePixelRatio;
};
const $37cc264674c90168$export$4a0301d636367e1d = (reps)=>{
    // Invalid reps handled outside function - logic may change depending what the service returns
    return reps[$37cc264674c90168$var$calculateScale($37cc264674c90168$export$d39ce20a37bba061).altScale];
};
const $37cc264674c90168$export$db05e6ae1fd416af = (url, meta)=>!!(meta && meta.mediaApiToken && url.indexOf(meta.mediaApiToken.url) === 0);
const $37cc264674c90168$export$55077db3efc820aa = (representation, meta)=>{
    if ((0, $fqzOa.isSpriteServiceRepresentation)(representation) && meta && meta.spriteSheets) {
        const { height: height, width: width, x: x, y: y, xIndex: xIndex, yIndex: yIndex, spriteRef: spriteRef } = representation;
        const spriteSheet = meta.spriteSheets[spriteRef];
        if (spriteSheet) return {
            sprite: spriteSheet,
            height: height,
            width: width,
            x: x,
            y: y,
            xIndex: xIndex,
            yIndex: yIndex
        };
    } else if ((0, $fqzOa.isImageRepresentation)(representation)) {
        const { height: height, width: width, imagePath: imagePath } = representation;
        if ($37cc264674c90168$export$db05e6ae1fd416af(imagePath, meta)) return (0, $fqzOa.convertImageToMediaRepresentation)(representation);
        return {
            height: height,
            width: width,
            imagePath: imagePath
        };
    }
    (0, $32Nbx.default)('failed conversion for representation', representation, meta);
    return undefined;
};
const $37cc264674c90168$export$aa9faa01267cb2e7 = (altReps, meta)=>{
    return !altReps || Object.keys(altReps).length === 0 ? undefined : $37cc264674c90168$export$55077db3efc820aa($37cc264674c90168$export$4a0301d636367e1d(altReps), meta);
};
const $37cc264674c90168$export$e3da49c88c2e54d5 = (emoji, meta)=>{
    if (!emoji.skinVariations) return [];
    const skinEmoji = emoji.skinVariations;
    const baseId = emoji.id;
    return skinEmoji.map((skin)=>{
        const { representation: representation, altRepresentations: altRepresentations, ...other } = skin;
        return {
            baseId: baseId,
            representation: $37cc264674c90168$export$55077db3efc820aa(representation, meta),
            altRepresentation: $37cc264674c90168$export$aa9faa01267cb2e7(altRepresentations, meta),
            ...other
        };
    });
};
const $37cc264674c90168$export$afaea97e40b5ca70 = (emojiData)=>{
    const emojis = emojiData.emojis.map((emoji)=>{
        const newRepresentation = $37cc264674c90168$export$55077db3efc820aa(emoji.representation, emojiData.meta);
        const altRepresentation = $37cc264674c90168$export$aa9faa01267cb2e7(emoji.altRepresentations, emojiData.meta);
        const newSkinVariations = $37cc264674c90168$export$e3da49c88c2e54d5(emoji, emojiData.meta);
        // create trimmedServiceDesc which is emoji with no representations or skinVariations
        const { representation: representation, skinVariations: skinVariations, altRepresentations: altRepresentations, ...trimmedServiceDesc } = emoji;
        const response = {
            ...trimmedServiceDesc,
            representation: newRepresentation,
            skinVariations: newSkinVariations
        };
        return (0, $fqzOa.buildEmojiDescriptionWithAltRepresentation)(response, altRepresentation);
    });
    const mediaApiToken = emojiData.meta && emojiData.meta.mediaApiToken;
    return {
        emojis: emojis,
        mediaApiToken: mediaApiToken
    };
};
const $37cc264674c90168$var$getHeight = (fitToHeight)=>$37cc264674c90168$export$d39ce20a37bba061() > 1 ? fitToHeight * 2 : fitToHeight;
const $37cc264674c90168$export$b7e9058f156d8d19 = (emoji, fitToHeight)=>!!(fitToHeight && emoji.altRepresentation && $37cc264674c90168$var$getHeight(fitToHeight) > emoji.representation.height);

});


parcelRegister("5QefI", function(module, exports) {

$parcel$export(module.exports, "getEmojiVariation", () => $9b87de636599ba93$export$e55e46e1520c899d);
$parcel$export(module.exports, "default", () => $9b87de636599ba93$export$2e2bcd8739ae039);

var $1qij2 = parcelRequire("1qij2");

var $8iUeU = parcelRequire("8iUeU");

var $fqzOa = parcelRequire("fqzOa");

var $adGgK = parcelRequire("adGgK");

var $6xd1B = parcelRequire("6xd1B");

var $g6gOB = parcelRequire("g6gOB");

var $kLr62 = parcelRequire("kLr62");

var $eGOwo = parcelRequire("eGOwo");
// FS-1097 - duplicated in mentions - extract at some point into a shared library
class $9b87de636599ba93$var$Tokenizer {
    tokenize(text) {
        return this.tokenizeAsTokens(text).map((token)=>token.token);
    }
    tokenizeAsTokens(text) {
        let match;
        let tokens = [];
        (0, $6xd1B.tokenizerRegex).lastIndex = 0;
        while((match = (0, $6xd1B.tokenizerRegex).exec(text)) !== null)if (match[0]) tokens.push({
            token: match[0],
            start: match.index
        });
        return tokens;
    }
}
const $9b87de636599ba93$var$addAllVariants = (emoji, fnKey, map)=>{
    const key = fnKey(emoji);
    if (!map.has(key)) map.set(key, []);
    const emojisForKey = map.get(key);
    // Unnecessary, but typescript thinks it is. :/
    if (emojisForKey) emojisForKey.push(emoji);
    if ((0, $fqzOa.isEmojiDescriptionWithVariations)(emoji)) {
        // map variations too
        const variations = emoji.skinVariations;
        if (variations) variations.forEach((variation)=>$9b87de636599ba93$var$addAllVariants(variation, fnKey, map));
    }
};
const $9b87de636599ba93$var$findByKey = (map, key)=>{
    const emojis = map.get(key);
    if (emojis && emojis.length) // Priority is always to source from the last emoji set (last overrides first)
    return emojis[emojis.length - 1];
    return undefined;
};
const $9b87de636599ba93$var$splitQuery = (query = '')=>{
    const isColonQuery = query.indexOf(':') === 0;
    if (isColonQuery) return {
        nameQuery: query.slice(1),
        asciiQuery: query
    };
    return {
        nameQuery: query,
        asciiQuery: ''
    };
};
const $9b87de636599ba93$export$e55e46e1520c899d = (emoji, options)=>{
    if ((0, $fqzOa.isEmojiDescriptionWithVariations)(emoji) && options) {
        const skinTone = options.skinTone;
        if (skinTone && emoji.skinVariations && emoji.skinVariations.length) {
            const skinToneEmoji = emoji.skinVariations[skinTone - 1]; // skinTone start at 1
            if (skinToneEmoji) return skinToneEmoji;
        }
    }
    return emoji;
};
const $9b87de636599ba93$var$findEmojiIndex = (emojis, toFind)=>{
    const findId = toFind.id;
    let match = -1;
    emojis.forEach((emoji, index)=>{
        // Match if ID is defined and are equal
        // Or both have no id and shortnames match
        if (emoji.id && emoji.id === findId || !emoji.id && !findId && emoji.shortName === toFind.shortName) {
            match = index;
            return;
        }
    });
    return match;
};
class $9b87de636599ba93$export$2e2bcd8739ae039 {
    static{
        this.defaultEmojiWeight = 1000000;
    }
    constructor(emojis, usageTracker){
        this.fullSearchReady = false;
        this.emojis = emojis;
        this.initMembers(usageTracker);
    }
    /**
	 * Returns all available (and searchable) emoji in some default order.
	 */ all() {
        const options = {
            sort: (0, $adGgK.SearchSort).None
        };
        return this.search('', options);
    }
    /**
	 * Text search of emoji shortName and name field for suitable matches.
	 *
	 * Returns an array of all (searchable) emoji if query is empty or null, otherwise returns matching emoji.
	 *
	 * You can change how the results are sorted by specifying a custom EmojiComparator in the SearchOptions. If
	 * you don't want any sorting you can also disable via the SearchOptions (this might be a useful optimisation).
	 * If no sort is specified in SearchOptions then a default sorting it applied based on the query.
	 */ search(query, options) {
        let filteredEmoji = [];
        const { nameQuery: nameQuery, asciiQuery: asciiQuery } = $9b87de636599ba93$var$splitQuery(query);
        if (nameQuery) {
            filteredEmoji = this.getSearchIndex().search(nameQuery);
            if (asciiQuery) filteredEmoji = this.withAsciiMatch(asciiQuery, filteredEmoji);
        } else filteredEmoji = this.getAllSearchableEmojis();
        filteredEmoji = this.applySearchOptions(filteredEmoji, query, options);
        return {
            emojis: filteredEmoji,
            query: query
        };
    }
    /**
	 * Returns all emoji with matching shortName
	 */ findAllMatchingShortName(shortName) {
        return this.shortNameMap.get(shortName) || [];
    }
    /**
	 * Returns the first matching emoji matching the shortName, or null if none found.
	 */ findByShortName(shortName) {
        return $9b87de636599ba93$var$findByKey(this.shortNameMap, shortName);
    }
    /**
	 * Returns the first matching emoji matching the id, or null if none found.
	 */ findById(id) {
        return $9b87de636599ba93$var$findByKey(this.idMap, id);
    }
    findByAsciiRepresentation(asciiEmoji) {
        return this.asciiMap.get(asciiEmoji);
    }
    findInCategory(categoryId) {
        if (categoryId === (0, $8iUeU.frequentCategory)) return this.getFrequentlyUsed();
        else return this.all().emojis.filter((emoji)=>emoji.category === categoryId);
    }
    addUnknownEmoji(emoji) {
        this.emojis = [
            ...this.emojis,
            emoji
        ];
        this.getSearchIndex().addDocuments([
            emoji
        ]);
        this.addToMaps(emoji);
        this.addToDynamicCategories(emoji);
    }
    getAsciiMap() {
        return this.asciiMap;
    }
    /**
	 * Return the most frequently used emoji, ordered from most frequent to least frequent. Return an empty array if
	 * there are none.
	 *
	 * @param options optional settings to be applied to the set of frequently used emoji
	 */ getFrequentlyUsed(options) {
        const emojiIds = this.usageTracker.getOrder();
        let emojiResult = emojiIds.map((id)=>this.findById(id)).filter((e)=>e !== undefined);
        if (options) emojiResult = this.applySearchOptions(emojiResult, '', options);
        return emojiResult;
    }
    getDynamicCategoryList() {
        return this.dynamicCategoryList.slice();
    }
    /**
	 * Call this on emoji usage to allow the EmojiRepository to track the usage of emoji (which could be useful
	 * in sorting, etc).
	 *
	 * @param emoji the emoji that was just used
	 */ used(emoji) {
        this.usageTracker.recordUsage(emoji);
        // If this is the first usage ensure that we update the dynamic categories.
        // This is done in a 'timeout' since the usageTracker call previously also happens in a timeout. This ensures that
        // the frequent category will not appear until the usage has been tracked (avoiding the possibility of an empty
        // frequent category being shown in the picker).
        if (this.dynamicCategoryList.indexOf((0, $8iUeU.frequentCategory)) === -1) {
            if (typeof window === 'undefined') return;
            window.setTimeout(()=>{
                this.dynamicCategoryList.push((0, $8iUeU.frequentCategory));
            });
        }
    }
    delete(emoji) {
        const deletedIndex = $9b87de636599ba93$var$findEmojiIndex(this.emojis, emoji);
        if (deletedIndex !== -1) {
            // Remove the deleted emojis from the internal list
            this.emojis.splice(deletedIndex, 1);
            // Reconstruct repository member variables
            this.initMembers(this.usageTracker);
        }
    }
    withAsciiMatch(ascii, emojis) {
        let result = emojis;
        const asciiEmoji = this.findByAsciiRepresentation(ascii);
        if (asciiEmoji) {
            // Ensures that the same emoji isn't already in the list
            // If it is, we give precedence to the ascii match
            result = emojis.filter((e)=>e.id !== asciiEmoji.id);
            result = [
                asciiEmoji,
                ...result
            ];
        }
        return result;
    }
    applySearchOptions(emojis, query, options) {
        if (!options) options = {};
        if (options.sort === undefined) options.sort = (0, $adGgK.SearchSort).Default;
        let comparator;
        if (options.sort === (0, $adGgK.SearchSort).Default) comparator = (0, $g6gOB.createSearchEmojiComparator)(query, this.usageTracker.getOrder());
        else if (options.sort === (0, $adGgK.SearchSort).UsageFrequency) comparator = (0, $g6gOB.createUsageOnlyEmojiComparator)(this.usageTracker.getOrder());
        if (comparator) {
            comparator.compare = comparator.compare.bind(comparator); // TODO bind at a better place
            emojis = emojis.sort(comparator.compare);
        }
        if (options.limit && options.limit > 0) emojis = emojis.slice(0, options.limit);
        if (options.skinTone) return emojis.map((emoji)=>{
            return $9b87de636599ba93$export$e55e46e1520c899d(emoji, options);
        });
        return emojis;
    }
    initMembers(usageTracker) {
        this.usageTracker = usageTracker || new (0, $kLr62.UsageFrequencyTracker)();
        this.initRepositoryMetadata();
        if (!(0, $eGOwo.fg)('platform_index_emoji_just_in_time')) this.initSearchIndex();
    }
    /**
	 * Optimisation to initialise all map member variables in single loop over emojis
	 */ initRepositoryMetadata() {
        this.shortNameMap = new Map();
        this.idMap = new Map();
        this.asciiMap = new Map();
        const categorySet = new Set();
        this.emojis.forEach((emoji)=>{
            categorySet.add(emoji.category);
            this.addToMaps(emoji);
        });
        if (this.usageTracker.getOrder().length) categorySet.add((0, $8iUeU.frequentCategory));
        this.dynamicCategoryList = Array.from(categorySet).filter((category)=>(0, $8iUeU.defaultCategories).indexOf(category) === -1);
    }
    initSearchIndex() {
        this.fullSearch = new (0, $1qij2.Search)('id');
        this.fullSearch.tokenizer = new $9b87de636599ba93$var$Tokenizer();
        this.fullSearch.searchIndex = new (0, $1qij2.UnorderedSearchIndex)();
        this.fullSearch.addIndex('name');
        this.fullSearch.addIndex('shortName');
        this.fullSearch.addDocuments(this.getAllSearchableEmojis());
        this.fullSearchReady = true;
    }
    getSearchIndex() {
        if (!this.fullSearchReady) this.initSearchIndex();
        return this.fullSearch;
    }
    getAllSearchableEmojis() {
        return this.emojis.filter((emojiDescription)=>emojiDescription.searchable);
    }
    addToMaps(emoji) {
        // Give default value and assign higher weight to Atlassian emojis for logical order when sorting
        if (typeof emoji.order === 'undefined' || emoji.order === -1) emoji.order = $9b87de636599ba93$export$2e2bcd8739ae039.defaultEmojiWeight;
        if (typeof emoji.id === 'undefined') emoji.id = $9b87de636599ba93$export$2e2bcd8739ae039.defaultEmojiWeight.toString();
        $9b87de636599ba93$var$addAllVariants(emoji, (e)=>e.shortName, this.shortNameMap);
        $9b87de636599ba93$var$addAllVariants(emoji, (e)=>e.id, this.idMap);
        if (emoji.ascii) emoji.ascii.forEach((a)=>this.asciiMap.set(a, emoji));
    }
    addToDynamicCategories(emoji) {
        const category = (0, $fqzOa.getCategoryId)(emoji);
        if ((0, $8iUeU.defaultCategories).indexOf(category) === -1 && this.dynamicCategoryList.indexOf(category) === -1) this.dynamicCategoryList.push(category);
    }
}

});
parcelRegister("1qij2", function(module, exports) {

$parcel$export(module.exports, "UnorderedSearchIndex", () => $10966b55d7fb8e7d$export$5e70dbef3f0d47db);
$parcel$export(module.exports, "Search", () => $10966b55d7fb8e7d$export$4b85d3515bd863a5);
/**
 * Indexes for all substring searches (e.g. the term "cat" is indexed as "c", "ca", "cat", "a", "at", and "t").
 */ var $10966b55d7fb8e7d$export$58ac23006833dfe0 = /*#__PURE__*/ function() {
    function AllSubstringsIndexStrategy() {}
    var _proto = AllSubstringsIndexStrategy.prototype;
    /**
   * @inheritDocs
   */ _proto.expandToken = function expandToken(token) {
        var expandedTokens = [];
        var string;
        for(var i = 0, length = token.length; i < length; ++i){
            string = '';
            for(var j = i; j < length; ++j){
                string += token.charAt(j);
                expandedTokens.push(string);
            }
        }
        return expandedTokens;
    };
    return AllSubstringsIndexStrategy;
}();
/**
 * Indexes for exact word matches.
 */ var $10966b55d7fb8e7d$export$1dcc2d6a64836c8f = /*#__PURE__*/ function() {
    function ExactWordIndexStrategy() {}
    var _proto = ExactWordIndexStrategy.prototype;
    /**
   * @inheritDocs
   */ _proto.expandToken = function expandToken(token) {
        return token ? [
            token
        ] : [];
    };
    return ExactWordIndexStrategy;
}();
/**
 * Indexes for prefix searches (e.g. the term "cat" is indexed as "c", "ca", and "cat" allowing prefix search lookups).
 */ var $10966b55d7fb8e7d$export$eb7fc80cfe9abfe6 = /*#__PURE__*/ function() {
    function PrefixIndexStrategy() {}
    var _proto = PrefixIndexStrategy.prototype;
    /**
   * @inheritDocs
   */ _proto.expandToken = function expandToken(token) {
        var expandedTokens = [];
        var string = '';
        for(var i = 0, length = token.length; i < length; ++i){
            string += token.charAt(i);
            expandedTokens.push(string);
        }
        return expandedTokens;
    };
    return PrefixIndexStrategy;
}();
/**
 * Enforces case-sensitive text matches.
 */ var $10966b55d7fb8e7d$export$b88ffe9b5486f99a = /*#__PURE__*/ function() {
    function CaseSensitiveSanitizer() {}
    var _proto = CaseSensitiveSanitizer.prototype;
    /**
   * @inheritDocs
   */ _proto.sanitize = function sanitize(text) {
        return text ? text.trim() : '';
    };
    return CaseSensitiveSanitizer;
}();
/**
 * Sanitizes text by converting to a locale-friendly lower-case version and triming leading and trailing whitespace.
 */ var $10966b55d7fb8e7d$export$147e8ac43c84713a = /*#__PURE__*/ function() {
    function LowerCaseSanitizer() {}
    var _proto = LowerCaseSanitizer.prototype;
    /**
   * @inheritDocs
   */ _proto.sanitize = function sanitize(text) {
        return text ? text.toLocaleLowerCase().trim() : '';
    };
    return LowerCaseSanitizer;
}();
/**
 * Find and return a nested object value.
 *
 * @param object to crawl
 * @param path Property path
 * @returns {any}
 */ function $10966b55d7fb8e7d$var$getNestedFieldValue(object, path) {
    path = path || [];
    object = object || {};
    var value = object; // walk down the property path
    for(var i = 0; i < path.length; i++){
        value = value[path[i]];
        if (value == null) return null;
    }
    return value;
}
/**
 * Search index capable of returning results matching a set of tokens and ranked according to TF-IDF.
 */ var $10966b55d7fb8e7d$export$a1138c79781169cc = /*#__PURE__*/ function() {
    function TfIdfSearchIndex(uidFieldName) {
        this._uidFieldName = uidFieldName;
        this._tokenToIdfCache = {};
        this._tokenMap = {};
    }
    /**
   * @inheritDocs
   */ var _proto = TfIdfSearchIndex.prototype;
    _proto.indexDocument = function indexDocument(token, uid, doc) {
        this._tokenToIdfCache = {}; // New index invalidates previous IDF caches
        var tokenMap = this._tokenMap;
        var tokenDatum;
        if (typeof tokenMap[token] !== 'object') tokenMap[token] = tokenDatum = {
            $numDocumentOccurrences: 0,
            $totalNumOccurrences: 1,
            $uidMap: {}
        };
        else {
            tokenDatum = tokenMap[token];
            tokenDatum.$totalNumOccurrences++;
        }
        var uidMap = tokenDatum.$uidMap;
        if (typeof uidMap[uid] !== 'object') {
            tokenDatum.$numDocumentOccurrences++;
            uidMap[uid] = {
                $document: doc,
                $numTokenOccurrences: 1
            };
        } else uidMap[uid].$numTokenOccurrences++;
    } /**
   * @inheritDocs
   */ ;
    _proto.search = function search(tokens, corpus) {
        var uidToDocumentMap = {};
        for(var i = 0, numTokens = tokens.length; i < numTokens; i++){
            var token = tokens[i];
            var tokenMetadata = this._tokenMap[token]; // Short circuit if no matches were found for any given token.
            if (!tokenMetadata) return [];
            if (i === 0) {
                var keys = Object.keys(tokenMetadata.$uidMap);
                for(var j = 0, numKeys = keys.length; j < numKeys; j++){
                    var uid = keys[j];
                    uidToDocumentMap[uid] = tokenMetadata.$uidMap[uid].$document;
                }
            } else {
                var keys = Object.keys(uidToDocumentMap);
                for(var j = 0, numKeys = keys.length; j < numKeys; j++){
                    var uid = keys[j];
                    if (typeof tokenMetadata.$uidMap[uid] !== 'object') delete uidToDocumentMap[uid];
                }
            }
        }
        var documents = [];
        for(var uid in uidToDocumentMap)documents.push(uidToDocumentMap[uid]);
        var calculateTfIdf = this._createCalculateTfIdf(); // Return documents sorted by TF-IDF
        return documents.sort(function(documentA, documentB) {
            return calculateTfIdf(tokens, documentB, corpus) - calculateTfIdf(tokens, documentA, corpus);
        });
    };
    _proto._createCalculateIdf = function _createCalculateIdf() {
        var tokenMap = this._tokenMap;
        var tokenToIdfCache = this._tokenToIdfCache;
        return function calculateIdf(token, documents) {
            if (!tokenToIdfCache[token]) {
                var numDocumentsWithToken = typeof tokenMap[token] !== 'undefined' ? tokenMap[token].$numDocumentOccurrences : 0;
                tokenToIdfCache[token] = 1 + Math.log(documents.length / (1 + numDocumentsWithToken));
            }
            return tokenToIdfCache[token];
        };
    };
    _proto._createCalculateTfIdf = function _createCalculateTfIdf() {
        var tokenMap = this._tokenMap;
        var uidFieldName = this._uidFieldName;
        var calculateIdf = this._createCalculateIdf();
        return function calculateTfIdf(tokens, document, documents) {
            var score = 0;
            for(var i = 0, numTokens = tokens.length; i < numTokens; ++i){
                var token = tokens[i];
                var inverseDocumentFrequency = calculateIdf(token, documents);
                if (inverseDocumentFrequency === Infinity) inverseDocumentFrequency = 0;
                var uid;
                if (uidFieldName instanceof Array) uid = document && $10966b55d7fb8e7d$var$getNestedFieldValue(document, uidFieldName);
                else uid = document && document[uidFieldName];
                var termFrequency = typeof tokenMap[token] !== 'undefined' && typeof tokenMap[token].$uidMap[uid] !== 'undefined' ? tokenMap[token].$uidMap[uid].$numTokenOccurrences : 0;
                score += termFrequency * inverseDocumentFrequency;
            }
            return score;
        };
    };
    return TfIdfSearchIndex;
}();
/**
 * Search index capable of returning results matching a set of tokens but without any meaningful rank or order.
 */ var $10966b55d7fb8e7d$export$5e70dbef3f0d47db = /*#__PURE__*/ function() {
    function UnorderedSearchIndex() {
        this._tokenToUidToDocumentMap = {};
    }
    /**
   * @inheritDocs
   */ var _proto = UnorderedSearchIndex.prototype;
    _proto.indexDocument = function indexDocument(token, uid, doc) {
        if (typeof this._tokenToUidToDocumentMap[token] !== 'object') this._tokenToUidToDocumentMap[token] = {};
        this._tokenToUidToDocumentMap[token][uid] = doc;
    } /**
   * @inheritDocs
   */ ;
    _proto.search = function search(tokens, corpus) {
        var intersectingDocumentMap = {};
        var tokenToUidToDocumentMap = this._tokenToUidToDocumentMap;
        for(var i = 0, numTokens = tokens.length; i < numTokens; i++){
            var token = tokens[i];
            var documentMap = tokenToUidToDocumentMap[token]; // Short circuit if no matches were found for any given token.
            if (!documentMap) return [];
            if (i === 0) {
                var keys = Object.keys(documentMap);
                for(var j = 0, numKeys = keys.length; j < numKeys; j++){
                    var uid = keys[j];
                    intersectingDocumentMap[uid] = documentMap[uid];
                }
            } else {
                var keys = Object.keys(intersectingDocumentMap);
                for(var j = 0, numKeys = keys.length; j < numKeys; j++){
                    var uid = keys[j];
                    if (typeof documentMap[uid] !== 'object') delete intersectingDocumentMap[uid];
                }
            }
        }
        var keys = Object.keys(intersectingDocumentMap);
        var documents = [];
        for(var i = 0, numKeys = keys.length; i < numKeys; i++){
            var uid = keys[i];
            documents.push(intersectingDocumentMap[uid]);
        }
        return documents;
    };
    return UnorderedSearchIndex;
}();
var $10966b55d7fb8e7d$var$REGEX = /[^a-zа-яё0-9\-']+/i;
/**
 * Simple tokenizer that splits strings on whitespace characters and returns an array of all non-empty substrings.
 */ var $10966b55d7fb8e7d$export$f5ac5ec3cb556ad6 = /*#__PURE__*/ function() {
    function SimpleTokenizer() {}
    var _proto = SimpleTokenizer.prototype;
    /**
   * @inheritDocs
   */ _proto.tokenize = function tokenize(text) {
        return text.split($10966b55d7fb8e7d$var$REGEX).filter(function(text) {
            return text;
        } // Filter empty tokens
        );
    };
    return SimpleTokenizer;
}();
/**
 * Stemming is the process of reducing search tokens to their root (or stem) so that searches for different forms of a
 * word will match. For example "search", "searching" and "searched" are all reduced to the stem "search".
 *
 * <p>This stemming tokenizer converts tokens (words) to their stem forms before returning them. It requires an
 * external stemming function to be provided; for this purpose I recommend the NPM 'porter-stemmer' library.
 *
 * <p>For more information see http : //tartarus.org/~martin/PorterStemmer/
 */ var $10966b55d7fb8e7d$export$d2c689c98d4dcb27 = /*#__PURE__*/ function() {
    /**
   * Constructor.
   *
   * @param stemmingFunction Function capable of accepting a word and returning its stem.
   * @param decoratedIndexStrategy Index strategy to be run after all stop words have been removed.
   */ function StemmingTokenizer(stemmingFunction, decoratedTokenizer) {
        this._stemmingFunction = stemmingFunction;
        this._tokenizer = decoratedTokenizer;
    }
    /**
   * @inheritDocs
   */ var _proto = StemmingTokenizer.prototype;
    _proto.tokenize = function tokenize(text) {
        return this._tokenizer.tokenize(text).map(this._stemmingFunction);
    };
    return StemmingTokenizer;
}();
/**
 * Stop words list copied from Lunr JS.
 */ var $10966b55d7fb8e7d$export$eeaf491a400e882a = {
    a: true,
    able: true,
    about: true,
    across: true,
    after: true,
    all: true,
    almost: true,
    also: true,
    am: true,
    among: true,
    an: true,
    and: true,
    any: true,
    are: true,
    as: true,
    at: true,
    be: true,
    because: true,
    been: true,
    but: true,
    by: true,
    can: true,
    cannot: true,
    could: true,
    dear: true,
    did: true,
    'do': true,
    does: true,
    either: true,
    'else': true,
    ever: true,
    every: true,
    'for': true,
    from: true,
    'get': true,
    got: true,
    had: true,
    has: true,
    have: true,
    he: true,
    her: true,
    hers: true,
    him: true,
    his: true,
    how: true,
    however: true,
    i: true,
    'if': true,
    'in': true,
    into: true,
    is: true,
    it: true,
    its: true,
    just: true,
    least: true,
    "let": true,
    like: true,
    likely: true,
    may: true,
    me: true,
    might: true,
    most: true,
    must: true,
    my: true,
    neither: true,
    no: true,
    nor: true,
    not: true,
    of: true,
    off: true,
    often: true,
    on: true,
    only: true,
    or: true,
    other: true,
    our: true,
    own: true,
    rather: true,
    said: true,
    say: true,
    says: true,
    she: true,
    should: true,
    since: true,
    so: true,
    some: true,
    than: true,
    that: true,
    the: true,
    their: true,
    them: true,
    then: true,
    there: true,
    these: true,
    they: true,
    'this': true,
    tis: true,
    to: true,
    too: true,
    twas: true,
    us: true,
    wants: true,
    was: true,
    we: true,
    were: true,
    what: true,
    when: true,
    where: true,
    which: true,
    'while': true,
    who: true,
    whom: true,
    why: true,
    will: true,
    'with': true,
    would: true,
    yet: true,
    you: true,
    your: true
}; // Prevent false positives for inherited properties
$10966b55d7fb8e7d$export$eeaf491a400e882a.constructor = false;
$10966b55d7fb8e7d$export$eeaf491a400e882a.hasOwnProperty = false;
$10966b55d7fb8e7d$export$eeaf491a400e882a.isPrototypeOf = false;
$10966b55d7fb8e7d$export$eeaf491a400e882a.propertyIsEnumerable = false;
$10966b55d7fb8e7d$export$eeaf491a400e882a.toLocaleString = false;
$10966b55d7fb8e7d$export$eeaf491a400e882a.toString = false;
$10966b55d7fb8e7d$export$eeaf491a400e882a.valueOf = false;
/**
 * Stop words are very common (e.g. "a", "and", "the") and are often not semantically meaningful in the context of a
 * search. This tokenizer removes stop words from a set of tokens before passing the remaining tokens along for
 * indexing or searching purposes.
 */ var $10966b55d7fb8e7d$export$59d4dfff8ed0ca89 = /*#__PURE__*/ function() {
    /**
   * Constructor.
   *
   * @param decoratedIndexStrategy Index strategy to be run after all stop words have been removed.
   */ function StopWordsTokenizer(decoratedTokenizer) {
        this._tokenizer = decoratedTokenizer;
    }
    /**
   * @inheritDocs
   */ var _proto = StopWordsTokenizer.prototype;
    _proto.tokenize = function tokenize(text) {
        return this._tokenizer.tokenize(text).filter(function(token) {
            return !$10966b55d7fb8e7d$export$eeaf491a400e882a[token];
        });
    };
    return StopWordsTokenizer;
}();
function $10966b55d7fb8e7d$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $10966b55d7fb8e7d$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $10966b55d7fb8e7d$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $10966b55d7fb8e7d$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
/**
 * Simple client-side searching within a set of documents.
 *
 * <p>Documents can be searched by any number of fields. Indexing and search strategies are highly customizable.
 */ var $10966b55d7fb8e7d$export$4b85d3515bd863a5 = /*#__PURE__*/ function() {
    /**
   * Array containing either a property name or a path (list of property names) to a nested value
   */ /**
   * Constructor.
   * @param uidFieldName Field containing values that uniquely identify search documents; this field's values are used
   *                     to ensure that a search result set does not contain duplicate objects.
   */ function Search(uidFieldName) {
        if (!uidFieldName) throw Error('js-search requires a uid field name constructor parameter');
        this._uidFieldName = uidFieldName; // Set default/recommended strategies
        this._indexStrategy = new $10966b55d7fb8e7d$export$eb7fc80cfe9abfe6();
        this._searchIndex = new $10966b55d7fb8e7d$export$a1138c79781169cc(uidFieldName);
        this._sanitizer = new $10966b55d7fb8e7d$export$147e8ac43c84713a();
        this._tokenizer = new $10966b55d7fb8e7d$export$f5ac5ec3cb556ad6();
        this._documents = [];
        this._searchableFields = [];
    }
    /**
   * Override the default index strategy.
   * @param value Custom index strategy
   * @throws Error if documents have already been indexed by this search instance
   */ var _proto = Search.prototype;
    /**
   * Add a searchable document to the index. Document will automatically be indexed for search.
   * @param document
   */ _proto.addDocument = function addDocument(document) {
        this.addDocuments([
            document
        ]);
    } /**
   * Adds searchable documents to the index. Documents will automatically be indexed for search.
   * @param document
   */ ;
    _proto.addDocuments = function addDocuments(documents) {
        this._documents = this._documents.concat(documents);
        this.indexDocuments_(documents, this._searchableFields);
    } /**
   * Add a new searchable field to the index. Existing documents will automatically be indexed using this new field.
   *
   * @param field Searchable field or field path. Pass a string to index a top-level field and an array of strings for nested fields.
   */ ;
    _proto.addIndex = function addIndex(field) {
        this._searchableFields.push(field);
        this.indexDocuments_(this._documents, [
            field
        ]);
    } /**
   * Search all documents for ones matching the specified query text.
   * @param query
   * @returns {Array<Object>}
   */ ;
    _proto.search = function search(query) {
        var tokens = this._tokenizer.tokenize(this._sanitizer.sanitize(query));
        return this._searchIndex.search(tokens, this._documents);
    } /**
   * @param documents
   * @param _searchableFields Array containing property names and paths (lists of property names) to nested values
   * @private
   */ ;
    _proto.indexDocuments_ = function indexDocuments_(documents, _searchableFields) {
        this._initialized = true;
        var indexStrategy = this._indexStrategy;
        var sanitizer = this._sanitizer;
        var searchIndex = this._searchIndex;
        var tokenizer = this._tokenizer;
        var uidFieldName = this._uidFieldName;
        for(var di = 0, numDocuments = documents.length; di < numDocuments; di++){
            var doc = documents[di];
            var uid;
            if (uidFieldName instanceof Array) uid = $10966b55d7fb8e7d$var$getNestedFieldValue(doc, uidFieldName);
            else uid = doc[uidFieldName];
            for(var sfi = 0, numSearchableFields = _searchableFields.length; sfi < numSearchableFields; sfi++){
                var fieldValue;
                var searchableField = _searchableFields[sfi];
                if (searchableField instanceof Array) fieldValue = $10966b55d7fb8e7d$var$getNestedFieldValue(doc, searchableField);
                else fieldValue = doc[searchableField];
                if (fieldValue != null && typeof fieldValue !== 'string' && fieldValue.toString) fieldValue = fieldValue.toString();
                if (typeof fieldValue === 'string') {
                    var fieldTokens = tokenizer.tokenize(sanitizer.sanitize(fieldValue));
                    for(var fti = 0, numFieldValues = fieldTokens.length; fti < numFieldValues; fti++){
                        var fieldToken = fieldTokens[fti];
                        var expandedTokens = indexStrategy.expandToken(fieldToken);
                        for(var eti = 0, nummExpandedTokens = expandedTokens.length; eti < nummExpandedTokens; eti++){
                            var expandedToken = expandedTokens[eti];
                            searchIndex.indexDocument(expandedToken, uid, doc);
                        }
                    }
                }
            }
        }
    };
    $10966b55d7fb8e7d$var$_createClass(Search, [
        {
            key: "indexStrategy",
            set: function set(value) {
                if (this._initialized) throw Error('IIndexStrategy cannot be set after initialization');
                this._indexStrategy = value;
            },
            get: function get() {
                return this._indexStrategy;
            }
        },
        {
            key: "sanitizer",
            set: function set(value) {
                if (this._initialized) throw Error('ISanitizer cannot be set after initialization');
                this._sanitizer = value;
            },
            get: function get() {
                return this._sanitizer;
            }
        },
        {
            key: "searchIndex",
            set: function set(value) {
                if (this._initialized) throw Error('ISearchIndex cannot be set after initialization');
                this._searchIndex = value;
            },
            get: function get() {
                return this._searchIndex;
            }
        },
        {
            key: "tokenizer",
            set: function set(value) {
                if (this._initialized) throw Error('ITokenizer cannot be set after initialization');
                this._tokenizer = value;
            },
            get: function get() {
                return this._tokenizer;
            }
        }
    ]);
    return Search;
}();
/**
 * This utility highlights the occurrences of tokens within a string of text. It can be used to give visual indicators
 * of match criteria within searchable fields.
 *
 * <p>For performance purposes this highlighter only works with full-word or prefix token indexes.
 */ var $10966b55d7fb8e7d$export$11e693a7f8ce1bcc = /*#__PURE__*/ function() {
    /**
   * Constructor.
   *
   * @param opt_indexStrategy Index strategy used by Search
   * @param opt_sanitizer Sanitizer used by Search
   * @param opt_wrapperTagName Optional wrapper tag name; defaults to 'mark' (e.g. <mark>)
   */ function TokenHighlighter(opt_indexStrategy, opt_sanitizer, opt_wrapperTagName) {
        this._indexStrategy = opt_indexStrategy || new $10966b55d7fb8e7d$export$eb7fc80cfe9abfe6();
        this._sanitizer = opt_sanitizer || new $10966b55d7fb8e7d$export$147e8ac43c84713a();
        this._wrapperTagName = opt_wrapperTagName || 'mark';
    }
    /**
   * Highlights token occurrences within a string by wrapping them with a DOM element.
   *
   * @param text e.g. "john wayne"
   * @param tokens e.g. ["wa"]
   * @returns {string} e.g. "john <mark>wa</mark>yne"
   */ var _proto = TokenHighlighter.prototype;
    _proto.highlight = function highlight(text, tokens) {
        var tagsLength = this._wrapText('').length;
        var tokenDictionary = Object.create(null); // Create a token map for easier lookup below.
        for(var i = 0, numTokens = tokens.length; i < numTokens; i++){
            var token = this._sanitizer.sanitize(tokens[i]);
            var expandedTokens = this._indexStrategy.expandToken(token);
            for(var j = 0, numExpandedTokens = expandedTokens.length; j < numExpandedTokens; j++){
                var expandedToken = expandedTokens[j];
                if (!tokenDictionary[expandedToken]) tokenDictionary[expandedToken] = [
                    token
                ];
                else tokenDictionary[expandedToken].push(token);
            }
        } // Track actualCurrentWord and sanitizedCurrentWord separately in case we encounter nested tags.
        var actualCurrentWord = '';
        var sanitizedCurrentWord = '';
        var currentWordStartIndex = 0; // Note this assumes either prefix or full word matching.
        for(var i = 0, textLength = text.length; i < textLength; i++){
            var character = text.charAt(i);
            if (character === ' ') {
                actualCurrentWord = '';
                sanitizedCurrentWord = '';
                currentWordStartIndex = i + 1;
            } else {
                actualCurrentWord += character;
                sanitizedCurrentWord += this._sanitizer.sanitize(character);
            }
            if (tokenDictionary[sanitizedCurrentWord] && tokenDictionary[sanitizedCurrentWord].indexOf(sanitizedCurrentWord) >= 0) {
                actualCurrentWord = this._wrapText(actualCurrentWord);
                text = text.substring(0, currentWordStartIndex) + actualCurrentWord + text.substring(i + 1);
                i += tagsLength;
                textLength += tagsLength;
            }
        }
        return text;
    } /**
   * @param text to wrap
   * @returns Text wrapped by wrapper tag (e.g. "foo" becomes "<mark>foo</mark>")
   * @private
   */ ;
    _proto._wrapText = function _wrapText(text) {
        var tagName = this._wrapperTagName;
        return "<" + tagName + ">" + text + "</" + tagName + ">";
    };
    return TokenHighlighter;
}();

});

parcelRegister("6xd1B", function(module, exports) {

$parcel$export(module.exports, "tokenizerRegex", () => $f70cf16a202d1ef4$export$6558e5d0f0e834f8);
// \p{Han} => each chinese character is a separate token
// \p{L}+[\p{Mn}|']*\p{L} => consecutive letters, including non spacing mark and apostrophe are a single token
// const tokenizerRegex = new XRegExp("\\p{Han}|[\\p{L}|\\p{N}]+[\\p{Mn}|']*\\p{L}*", 'gi');
// Note: Regex compiled to unicode charsets using xregexp-transformer, refer to it if you need to compile it again.
//       @atlaskit/xregexp-transformer (https://bitbucket.org/atlassian/xregexp-transformer)
// eslint-disable-next-line no-misleading-character-class
const $f70cf16a202d1ef4$export$6558e5d0f0e834f8 = new RegExp("[\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u3005\u3007\u3021-\u3029\u3038-\u303B\u3400-\u4DB5\u4E00-\u9FEF\uF900-\uFA6D\uFA70-\uFAD9]|[A-Za-z\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEF\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7B9\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC|0-9\u00B2\u00B3\u00B9\u00BC-\u00BE\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u09F4-\u09F9\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0B72-\u0B77\u0BE6-\u0BF2\u0C66-\u0C6F\u0C78-\u0C7E\u0CE6-\u0CEF\u0D58-\u0D5E\u0D66-\u0D78\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F33\u1040-\u1049\u1090-\u1099\u1369-\u137C\u16EE-\u16F0\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1946-\u194F\u19D0-\u19DA\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\u2070\u2074-\u2079\u2080-\u2089\u2150-\u2182\u2185-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3007\u3021-\u3029\u3038-\u303A\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA620-\uA629\uA6E6-\uA6EF\uA830-\uA835\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19]+[\u0300-\u036F\u0483-\u0487\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D3-\u08E1\u08E3-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09C1-\u09C4\u09CD\u09E2\u09E3\u09FE\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01\u0B3C\u0B3F\u0B41-\u0B44\u0B4D\u0B56\u0B62\u0B63\u0B82\u0BC0\u0BCD\u0C00\u0C04\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81\u0CBC\u0CBF\u0CC6\u0CCC\u0CCD\u0CE2\u0CE3\u0D00\u0D01\u0D3B\u0D3C\u0D41-\u0D44\u0D4D\u0D62\u0D63\u0DCA\u0DD2-\u0DD4\u0DD6\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EB9\u0EBB\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u1885\u1886\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1ABD\u1B00-\u1B03\u1B34\u1B36-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DF9\u1DFB-\u1DFF\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302D\u3099\u309A\uA66F\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA8C4\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uA9E5\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F|']*[A-Za-z\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEF\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7B9\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]*", 'gi');

});

parcelRegister("g6gOB", function(module, exports) {

$parcel$export(module.exports, "createSearchEmojiComparator", () => $a54cd167449f5744$export$e6097b005751df7);
$parcel$export(module.exports, "createUsageOnlyEmojiComparator", () => $a54cd167449f5744$export$1bd055808eeccb4e);

var $8iUeU = parcelRequire("8iUeU");

var $fqzOa = parcelRequire("fqzOa");
function $a54cd167449f5744$export$e6097b005751df7(query, orderedIds) {
    const textQuery = query ? query.replace(/:/g, '').toLowerCase().trim() : undefined;
    const comparators = [];
    if (query) comparators.push(new $a54cd167449f5744$export$ff92575cd1bbad0e(query));
    // Add the comparators to the 'chain'. The order of adding each comparator is important to the sort that is applied by the
    // ChainedEmojiComparator. (Which is why you may see the same 'if' a few times.)
    if (textQuery) comparators.push(new $a54cd167449f5744$export$3026b08b79541139(textQuery));
    if (orderedIds && orderedIds.length) comparators.push(new $a54cd167449f5744$export$55e24837a4bf653(orderedIds));
    if (textQuery) comparators.push(new $a54cd167449f5744$export$587c775915dc4869(textQuery, 'shortName'), new $a54cd167449f5744$export$587c775915dc4869(textQuery, 'name'));
    comparators.push($a54cd167449f5744$export$165e96ceead77edd.Instance, $a54cd167449f5744$export$30ce221e1adf48c1.Instance);
    const comparator = new $a54cd167449f5744$export$a8052d0852821684(...comparators);
    comparator.compare = comparator.compare.bind(comparator);
    return comparator;
}
function $a54cd167449f5744$export$1bd055808eeccb4e(orderedIds) {
    const comparator = new $a54cd167449f5744$export$a8052d0852821684(new $a54cd167449f5744$export$55e24837a4bf653(orderedIds), new $a54cd167449f5744$export$a7f7a0b04013a8a8(), $a54cd167449f5744$export$165e96ceead77edd.Instance);
    comparator.compare = comparator.compare.bind(comparator);
    return comparator;
}
class $a54cd167449f5744$export$a8052d0852821684 {
    constructor(...comparators){
        this.chain = comparators;
    }
    compare(e1, e2) {
        for(let i = 0; i < this.chain.length; i++){
            const result = this.chain[i].compare(e1, e2);
            if (result !== 0) return result;
        }
        return 0;
    }
}
class $a54cd167449f5744$export$ff92575cd1bbad0e {
    constructor(query){
        this.query = query;
    }
    compare(e1, e2) {
        const e1HasAscii = e1.ascii && e1.ascii.indexOf(this.query) !== -1;
        const e2HasAscii = e2.ascii && e2.ascii.indexOf(this.query) !== -1;
        if (e1HasAscii && !e2HasAscii) return -1;
        else if (!e1HasAscii && e2HasAscii) return 1;
        return 0;
    }
}
class $a54cd167449f5744$export$3026b08b79541139 {
    constructor(query){
        this.colonQuery = `:${query}:`;
        this.typeComparator = new $a54cd167449f5744$export$a7f7a0b04013a8a8(true);
    }
    compare(e1, e2) {
        if (e1.shortName === this.colonQuery && e2.shortName === this.colonQuery) return this.typeComparator.compare(e1, e2);
        else if (e1.shortName === this.colonQuery) return -1;
        else if (e2.shortName === this.colonQuery) return 1;
        return 0;
    }
}
class $a54cd167449f5744$export$a7f7a0b04013a8a8 {
    constructor(reverse){
        if (reverse) this.typeToNumber = new Map([
            [
                'SITE',
                0
            ],
            [
                'ATLASSIAN',
                1
            ],
            [
                'STANDARD',
                2
            ]
        ]);
        else this.typeToNumber = new Map([
            [
                'STANDARD',
                0
            ],
            [
                'ATLASSIAN',
                1
            ],
            [
                'SITE',
                2
            ]
        ]);
    }
    compare(e1, e2) {
        return this.emojiTypeToOrdinal(e1) - this.emojiTypeToOrdinal(e2);
    }
    emojiTypeToOrdinal(emoji) {
        let ordinal = this.typeToNumber.get(emoji.type);
        if (ordinal === undefined) ordinal = 10;
        return ordinal;
    }
}
class $a54cd167449f5744$export$55e24837a4bf653 {
    constructor(orderedIds){
        this.positionLookup = new Map();
        // Make ordering start from 1 to avoid having zero in the map (which is falsey)
        orderedIds.map((id, index)=>this.positionLookup.set(id, index + 1));
    }
    compare(e1, e2) {
        if (!e1.id || !e2.id) return 0; // this shouldn't occur. Leave position unchanged if there is any missing id.
        let i1 = this.getPositionInOrder(e1);
        let i2 = this.getPositionInOrder(e2);
        return i1 - i2;
    }
    /**
	 * Get the ordinal representing the position of this emoji.
	 *
	 * @param id the id of the emoji
	 */ getPositionInOrder(emoji) {
        let id = emoji.id ? emoji.id : '0';
        if ((0, $fqzOa.isEmojiVariationDescription)(emoji)) id = emoji.baseId;
        const position = this.positionLookup.get(id);
        if (position) return position;
        else return 0, $8iUeU.MAX_ORDINAL;
    }
}
class $a54cd167449f5744$export$587c775915dc4869 {
    /**
	 * @param query the query to match
	 * @param propertyToCompare the property of EmojiDescription to check for query within
	 */ constructor(query, propertyToCompare){
        this.query = query;
        if (!propertyToCompare) throw new Error('propertyToCompare is required');
        this.propertyName = propertyToCompare;
    }
    getScore(emoji) {
        // It is fine to do override the null check here because we are checking
        // it on the constructor.
        const propertyValue = emoji[this.propertyName];
        const score = propertyValue ? propertyValue.indexOf(this.query) : (0, $8iUeU.MAX_ORDINAL);
        return score === -1 ? (0, $8iUeU.MAX_ORDINAL) : score;
    }
    compare(e1, e2) {
        return this.getScore(e1) - this.getScore(e2);
    }
}
class $a54cd167449f5744$export$165e96ceead77edd {
    constructor(){}
    static get Instance() {
        return this.INSTANCE || (this.INSTANCE = new this());
    }
    compare(e1, e2) {
        let o1 = e1.order ? e1.order : (0, $8iUeU.MAX_ORDINAL);
        let o2 = e2.order ? e2.order : (0, $8iUeU.MAX_ORDINAL);
        return o1 - o2;
    }
}
class $a54cd167449f5744$export$30ce221e1adf48c1 {
    constructor(){}
    static get Instance() {
        return this.INSTANCE || (this.INSTANCE = new this());
    }
    compare(e1, e2) {
        return e1.shortName.localeCompare(e2.shortName);
    }
}

});

parcelRegister("kLr62", function(module, exports) {

$parcel$export(module.exports, "UsageFrequencyTracker", () => $85a3435740842397$export$3f86810331c44209);

var $fqzOa = parcelRequire("fqzOa");

var $8iUeU = parcelRequire("8iUeU");

var $3tG1E = parcelRequire("3tG1E");

var $hHpDh = parcelRequire("hHpDh");

var $G2hpM = parcelRequire("G2hpM");
class $85a3435740842397$export$3f86810331c44209 {
    static{
        this.queueOptions = {
            storage: (0, $G2hpM.default)('localStorage') ? window.localStorage : undefined,
            storagePrefix: (0, $8iUeU.localStoragePrefix),
            maxDuplicates: 25,
            minUniqueItems: 5
        };
    }
    constructor(useStorageIfPossible = true){
        const options = $85a3435740842397$export$3f86810331c44209.queueOptions;
        if (useStorageIfPossible && options.storage) {
            const queueOptions = {
                ...options,
                storage: options.storage
            };
            this.queue = new (0, $hHpDh.default)(queueOptions);
        } else this.queue = new (0, $3tG1E.default)(options);
        this.gateway = new $85a3435740842397$export$a0e1fa6601cae894(10);
    }
    /**
	 * Record the fact that the supplied emoji was used. You should note that usage is updated asynchronously so you can not
	 * count on getOrder() reflecting this usage immediately.
	 *
	 * @param emoji the emoji who's usage is to be recorded. If the emoji has no id then no usage will be recorded
	 */ recordUsage(emoji) {
        let emojiId = emoji.id;
        if (emojiId) {
            if ((0, $fqzOa.isEmojiVariationDescription)(emoji)) emojiId = emoji.baseId;
            this.gateway.submit(()=>{
                if (emojiId) this.queue.enqueue(emojiId);
            });
        }
    }
    /**
	 * Returns an array of emoji id (without skin tone variations) sorted by most used to least used. If there
	 * are no usages then an empty array will be returned.
	 */ getOrder() {
        return this.queue.getItemsOrderedByDuplicateCount();
    }
    /**
	 * Exposed for testing only. Clear any recorded usage.
	 */ clear() {
        this.queue.clear();
    }
}
class $85a3435740842397$export$a0e1fa6601cae894 {
    constructor(maximumPermitted){
        if (maximumPermitted < 1) throw new RangeError('The maximumPermitted parameter must be 1 or more.');
        this.maximumPermitted = maximumPermitted;
        this.count = 0;
    }
    /**
	 * Run the supplied function if the count of already submitted work allows it. Drop the work
	 * if it's not allowed to run.
	 *
	 * Will return true if the function has been submitted or false if it was not submitted.
	 */ submit(f) {
        if (this.count >= this.maximumPermitted) return false;
        this.count++;
        const wrappedFunc = ()=>{
            try {
                f();
            } finally{
                this.completed();
            }
        };
        if (typeof window !== 'undefined') window.setTimeout(wrappedFunc);
        return true;
    }
    completed() {
        this.count--;
    }
}

});
parcelRegister("3tG1E", function(module, exports) {

$parcel$export(module.exports, "default", () => $41426f5ff409d188$export$2e2bcd8739ae039);
/**
 * The options used to configure a newly constructed queue.
 */ class $41426f5ff409d188$export$2e2bcd8739ae039 {
    /**
	 * Construct a new DuplicateLimitedQueue.
	 *
	 * @param options the options for this queue.
	 */ constructor(options){
        if (options.maxDuplicates < 1) throw new RangeError('The maxDuplicates option must be at least 1');
        if (options.minUniqueItems < 1) throw new RangeError('The minUniqueItems option must be at least 1');
        this.maximumSize = options.maxDuplicates * options.minUniqueItems;
        this.perItemSize = options.maxDuplicates;
        this.createEmptyState();
    }
    /**
	 * @param item the item to add to the queue.
	 */ enqueue(item) {
        this.enqueueWithoutOrdering(item);
        // enqueues are less time sensitive (and may happen less frequently) than queries against the queue
        // so do the ordering work on each enqueue.
        this.itemsOrderedByFrequency = this.orderItemsByFrequency();
    }
    /**
	 * Return the items in the queue, ordered by how often they are duplicated. The items with the
	 * most duplicates come first in the returned Array.
	 *
	 * If there are no items in the queue then an empty Array will be returned.
	 */ getItemsOrderedByDuplicateCount() {
        return this.itemsOrderedByFrequency;
    }
    /**
	 * Exposed for storybook/testing purposes only. Clear the contents of the queue.
	 */ clear() {
        this.createEmptyState();
    }
    /**
	 * A more efficient mechanism for adding multiple items. Ordering is only performed once all
	 * the items have been added.
	 *
	 * @param items the items to be enqueued, which happens in their presented order.
	 */ bulkEnqueue(items) {
        items.map((item)=>this.enqueueWithoutOrdering(item));
        this.itemsOrderedByFrequency = this.orderItemsByFrequency();
    }
    /**
	 * Return the items currently stored in the queue.
	 */ getItems() {
        return this.items;
    }
    createEmptyState() {
        this.items = new Array();
        this.itemCountMap = new Map();
        this.itemsOrderedByFrequency = new Array();
    }
    /**
	 * Enqueue the supplied item, keeping consistency with the limits configured. However no ordering is
	 * performed by this enqueuing. You must trigger that manually if required.
	 *
	 * @param item the item to be queued
	 */ enqueueWithoutOrdering(item) {
        const count = this.itemCountMap.get(item);
        if (count && count >= this.perItemSize) // find the first item with that key in the array and remove it
        this.removeFirstOccurrence(item);
        else if (this.items.length >= this.maximumSize) this.remove();
        this.add(item);
    }
    /**
	 * Get an array of items from the queue ordered by how often they are duplicated in the queue.
	 */ orderItemsByFrequency() {
        const orderedEntries = Array.from(this.itemCountMap.entries()).sort((a, b)=>{
            return b[1] - a[1];
        });
        return orderedEntries.map((value)=>value[0]);
    }
    decrementCount(item) {
        let count = this.itemCountMap.get(item);
        if (count) {
            count--;
            if (count > 0) this.itemCountMap.set(item, count);
            else this.itemCountMap.delete(item);
        }
    }
    /**
	 * Walk the list of items and remove the first occurrence of the matching item.
	 *
	 * @param item the item to be removed.
	 */ removeFirstOccurrence(item) {
        const index = this.items.indexOf(item);
        if (index !== -1) {
            this.items.splice(index, 1);
            this.decrementCount(item);
        }
    }
    /**
	 * Remove the first item from the queue and update the itemCountMap accordingly.
	 * @return the item add the front of the queue or undefined if the queue is empty
	 */ remove() {
        const removed = this.items.shift();
        if (removed !== undefined) this.decrementCount(removed);
        return removed;
    }
    /**
	 * Add the supplied item to the end of the queue and update the itemCountMap accordingly.
	 * @param item the item to be added to the queue
	 */ add(item) {
        this.items.push(item);
        const count = this.itemCountMap.get(item);
        if (count) this.itemCountMap.set(item, count + 1);
        else this.itemCountMap.set(item, 1);
    }
}

});

parcelRegister("hHpDh", function(module, exports) {

$parcel$export(module.exports, "default", () => $3aba84b62a5f15c2$export$2e2bcd8739ae039);

var $3tG1E = parcelRequire("3tG1E");

var $32Nbx = parcelRequire("32Nbx");
class $3aba84b62a5f15c2$export$2e2bcd8739ae039 extends (0, $3tG1E.default) {
    static{
        this.storageKey = 'lastUsed';
    }
    constructor(options){
        super(options);
        this.storage = options.storage;
        this.prefixedStorageKey = `${options.storagePrefix}.${$3aba84b62a5f15c2$export$2e2bcd8739ae039.storageKey}`;
        this.load();
    }
    /**
	 * Enqueue the supplied item and also persist the new contents of the queue to storage.
	 *
	 * @param item the item to be enqueued
	 */ enqueue(item) {
        super.enqueue(item);
        this.save();
    }
    /**
	 * Exposed for storybook/testing purposes only. Clear the contents of the queue, and localStorage.
	 */ clear() {
        super.clear();
        this.storage.removeItem(this.prefixedStorageKey);
    }
    /**
	 * Initialise the queue contents from the configured Storage. If there is no data found in
	 * storage then the queue will have no items added. Likewise, a failure to read or parse stored
	 * data will be swallowed and no items are added to the queue.
	 */ load() {
        const itemsJson = this.storage.getItem(this.prefixedStorageKey);
        if (itemsJson) try {
            const items = JSON.parse(itemsJson);
            this.bulkEnqueue(items);
        } catch (e) {
            (0, $32Nbx.default)(`Error parsing the queue stored as ${this.prefixedStorageKey} key from storage`, e);
        }
    }
    /**
	 * Save the current items in the queue, overwriting any previously stored queue.
	 * Any failure in saving will be silently ignored with the likely outcome that any previous
	 * saved items will remain unchanged in storage.
	 */ save() {
        const itemsJson = JSON.stringify(this.getItems());
        try {
            this.storage.setItem(this.prefixedStorageKey, itemsJson);
        } catch (e) {
            (0, $32Nbx.default)(`Error saving the queued items as ${this.prefixedStorageKey}`, e);
        }
    }
}

});



parcelRegister("g84Mp", function(module, exports) {

$parcel$export(module.exports, "default", () => $dcbb7b86e406216b$export$2e2bcd8739ae039);

var $kp3br = parcelRequire("kp3br");

var $aRuva = parcelRequire("aRuva");

var $fqzOa = parcelRequire("fqzOa");

var $bPZCQ = parcelRequire("bPZCQ");

var $cBxa0 = parcelRequire("cBxa0");

var $k1Z1t = parcelRequire("k1Z1t");

var $32Nbx = parcelRequire("32Nbx");
const $dcbb7b86e406216b$export$6f3a08dea02a7b2b = 0.95;
class $dcbb7b86e406216b$export$2e2bcd8739ae039 {
    constructor(siteServiceConfig, mediaApiToken){
        this.postToEmojiService = (upload, fileId)=>{
            const { shortName: shortName, name: name } = upload;
            const { width: width, height: height } = upload;
            const requestInit = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    shortName: shortName,
                    name: name,
                    width: width,
                    height: height,
                    fileId: fileId
                })
            };
            return (0, $kp3br.utils).requestService(this.siteServiceConfig, {
                requestInit: requestInit
            }).then((response)=>{
                const { emojis: emojis } = response;
                if (emojis.length) {
                    const { altRepresentations: altRepresentations, ...emoji } = emojis[0];
                    const response = {
                        ...emoji,
                        representation: (0, $fqzOa.convertImageToMediaRepresentation)(emoji.representation)
                    };
                    const altRepresentation = (0, $cBxa0.getAltRepresentation)(altRepresentations || {});
                    const imgAltRepresentation = altRepresentation ? (0, $fqzOa.convertImageToMediaRepresentation)(altRepresentation) : undefined;
                    return (0, $fqzOa.buildEmojiDescriptionWithAltRepresentation)(response, imgAltRepresentation);
                }
                throw new Error('No emoji returns from upload. Upload failed.');
            });
        };
        this.siteServiceConfig = siteServiceConfig;
        this.mediaApiToken = mediaApiToken;
        this.tokenManager = new (0, $k1Z1t.default)(siteServiceConfig);
        this.tokenManager.addToken('read', mediaApiToken);
        this.mediaEmojiCache = new (0, $bPZCQ.default)(this.tokenManager);
    }
    /**
	 * Will generate an emoji media path that is inclusive of client and token within the query parameter for media representation and altRepresentation
	 */ async generateTokenisedMediaURLS(representation, altRepresentation) {
        if (!(0, $fqzOa.isMediaRepresentation)(representation)) return {
            representation: representation,
            altRepresentation: altRepresentation
        };
        try {
            const readToken = await this.tokenManager.getToken('read');
            return Object.entries({
                representation: representation,
                altRepresentation: altRepresentation
            }).reduce((acc, [key, value])=>{
                if (value && (0, $fqzOa.isMediaRepresentation)(value)) {
                    const path = new URL(value.mediaPath);
                    const params = path.searchParams;
                    if (params.get('token') !== readToken.jwt) params.set('token', readToken.jwt);
                    if (params.get('client') !== readToken.clientId) params.set('client', readToken.clientId);
                    acc[key] = {
                        ...value,
                        mediaPath: path.toString()
                    };
                }
                return acc;
            }, {
                representation: representation,
                altRepresentation: altRepresentation
            });
        } catch (error) {
            return {
                representation: representation,
                altRepresentation: altRepresentation
            };
        }
    }
    /**
	 * Will load media emoji, returning a new EmojiDescription if, for example,
	 * the URL has changed.
	 */ loadMediaEmoji(emoji, useAlt) {
        if (!(0, $fqzOa.isMediaEmoji)(emoji)) throw new Error('Only supported for media emoji');
        return this.mediaEmojiCache.loadEmoji(emoji, useAlt);
    }
    optimisticRendering(emoji, useAlt) {
        const representation = useAlt ? emoji.altRepresentation : emoji.representation;
        if (!(0, $fqzOa.isMediaRepresentation)(representation)) throw new Error('Only supported for media emoji');
        const { mediaPath: mediaPath } = representation;
        return this.mediaEmojiCache.optimisticRendering(mediaPath);
    }
    uploadEmoji(upload, retry = false, progressCallback) {
        const startTime = Date.now();
        return this.tokenManager.getToken('upload', retry).then((uploadToken)=>{
            const tokenLoadTime = Date.now() - startTime;
            (0, $32Nbx.default)('upload token load time', tokenLoadTime);
            return new Promise((resolve, reject)=>{
                const { url: url, clientId: clientId, collectionName: collectionName } = uploadToken;
                const mediaClient = (0, $aRuva.getMediaClient)({
                    authProvider: ()=>Promise.resolve({
                            clientId: clientId,
                            token: uploadToken.jwt,
                            baseUrl: url
                        }),
                    useSha256ForUploads: true
                });
                const subscription = mediaClient.file.upload({
                    content: upload.dataURL,
                    name: upload.filename,
                    collection: collectionName
                }).subscribe({
                    next: (state)=>{
                        if (state.status === 'uploading' && progressCallback) progressCallback({
                            percent: state.progress * $dcbb7b86e406216b$export$6f3a08dea02a7b2b
                        });
                        else if (state.status === 'processing' || state.status === 'processed') {
                            subscription.unsubscribe();
                            const totalUploadTime = Date.now() - startTime;
                            const mediaUploadTime = totalUploadTime - tokenLoadTime;
                            (0, $32Nbx.default)('total upload / media upload times', totalUploadTime, mediaUploadTime);
                            this.postToEmojiService(upload, state.id).then((emoji)=>{
                                resolve(emoji);
                            }).catch((httpError)=>{
                                reject(httpError.reason || httpError);
                            });
                        }
                    },
                    error (error) {
                        reject(error);
                    }
                });
            });
        });
    }
    /**
	 * Check if the MediaEmojiResource has been able to initialise an uploadToken. Retrieving an upload token
	 * is asynchronous so the Promise will need to resolve before the state is known. If the token retrieval
	 * completes with failure then the Promise will resolve to false.
	 */ hasUploadToken() {
        const tokenPromise = this.tokenManager.getToken('upload');
        return tokenPromise.then((token)=>{
            return token !== undefined;
        }, ()=>{
            return false;
        });
    }
    prepareForUpload() {
        // make sure a token is loaded from the emoji service if we don't have one
        // as future request to uploadEmoji will use this, this to preload it, as it
        // usually takes 1-2 seconds to generate
        this.tokenManager.getToken('upload');
    }
    findEmoji(emojiId) {
        if (!emojiId.id) return Promise.reject(false);
        const path = `../${encodeURIComponent(emojiId.id)}`;
        return (0, $cBxa0.emojiRequest)(this.siteServiceConfig, {
            path: path
        }).then((serviceResponse)=>{
            const response = (0, $cBxa0.denormaliseEmojiServiceResponse)(serviceResponse);
            return response.emojis[0];
        }).catch((error)=>{
            (0, $32Nbx.default)('failed to load emoji', emojiId, error);
            return undefined;
        });
    }
    /**
	 * Calls to site-scoped EmojiResource to delete emoji
	 * @param emoji media emoji to delete
	 * @returns Promise.resolve() if success and Promise.reject() for failure
	 */ deleteEmoji(emoji) {
        if (!(0, $fqzOa.isMediaEmoji)(emoji) && !(0, $fqzOa.isLoadedMediaEmoji)(emoji)) return Promise.reject(false);
        if (!emoji.id) return Promise.reject(false);
        const path = `${encodeURIComponent(emoji.id)}`;
        const requestInit = {
            method: 'DELETE'
        };
        return (0, $kp3br.utils).requestService(this.siteServiceConfig, {
            path: path,
            requestInit: requestInit
        })// Successful delete on Promise.resolve
        .then(()=>true)// Unsuccessful delete on Promise.reject
        .catch(()=>false);
    }
}

});
parcelRegister("bPZCQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e4069442f1729a0$export$2e2bcd8739ae039);

var $fqzOa = parcelRequire("fqzOa");

var $9rgFW = parcelRequire("9rgFW");

var $32Nbx = parcelRequire("32Nbx");

var $7xkt0 = parcelRequire("7xkt0");
const $4e4069442f1729a0$var$getRequiredRepresentation = (emoji, useAlt)=>useAlt ? emoji.altRepresentation : emoji.representation;
const $4e4069442f1729a0$var$isUnsupportedBrowser = ()=>{
    const isIE = !!document.documentMode; // Internet Explorer 6-11
    const isEdge = !isIE && !!window.StyleMedia; // Edge 20+
    return isIE || isEdge;
};
class $4e4069442f1729a0$export$3850f566ce8d817a {
    constructor(mediaImageLoader){
        this.cachedImageUrls = new Set();
        (0, $32Nbx.default)('BrowserCacheStrategy');
        this.mediaImageLoader = mediaImageLoader;
    }
    loadEmoji(emoji, useAlt) {
        const representation = $4e4069442f1729a0$var$getRequiredRepresentation(emoji, useAlt);
        if (!(0, $fqzOa.isMediaRepresentation)(representation)) return emoji;
        const { mediaPath: mediaPath } = representation;
        if (this.cachedImageUrls.has(mediaPath)) // Already cached
        return emoji;
        return this.mediaImageLoader.loadMediaImage(mediaPath).then(()=>{
            // Media is loaded, can use original URL now, so just return original emoji
            this.cachedImageUrls.add(mediaPath);
            return emoji;
        }).catch(()=>{
            return undefined;
        });
    }
    optimisticRendering() {
        return true;
    }
    static supported(mediaPath, mediaImageLoader) {
        // IE/Edge uses memory cache strategy else images can fail to load
        // from a clean cache/if they are downloaded from the service
        // TODO: fix as a part of FS-1592
        if ($4e4069442f1729a0$var$isUnsupportedBrowser()) return Promise.resolve(false);
        return mediaImageLoader.loadMediaImage(mediaPath).then(()=>// Image should be cached in browser, if supported it should be accessible from the cache by an <img/>
            // Try to load without via image to confirm this support (this fails in Firefox)
            new Promise((resolve)=>{
                const img = new Image();
                img.addEventListener('load', ()=>{
                    resolve(true);
                });
                img.addEventListener('error', ()=>{
                    resolve(false);
                });
                img.src = mediaPath;
            })).catch(()=>false);
    }
}
const $4e4069442f1729a0$var$maxImageCached = 1000;
// Don't cache images large than this - dataUrl size in characters
const $4e4069442f1729a0$var$maxImageSize = 10000;
class $4e4069442f1729a0$export$b522858a3709f4c {
    constructor(mediaImageLoader){
        (0, $32Nbx.default)('MemoryCacheStrategy');
        this.mediaImageLoader = mediaImageLoader;
        this.dataURLCache = new (0, $7xkt0.LRUMap)($4e4069442f1729a0$var$maxImageCached);
    }
    loadEmoji(emoji, useAlt) {
        const representation = $4e4069442f1729a0$var$getRequiredRepresentation(emoji, useAlt);
        if (!(0, $fqzOa.isMediaRepresentation)(representation)) return emoji;
        const { mediaPath: mediaPath } = representation;
        const dataURL = this.dataURLCache.get(mediaPath);
        if (dataURL) // Already cached
        return (0, $fqzOa.convertMediaToImageEmoji)(emoji, dataURL, useAlt);
        // Not cached, load
        return this.mediaImageLoader.loadMediaImage(mediaPath).then((dataURL)=>{
            const loadedEmoji = (0, $fqzOa.convertMediaToImageEmoji)(emoji, dataURL, useAlt);
            if (dataURL.length <= $4e4069442f1729a0$var$maxImageSize) // Only cache if not large than max size
            this.dataURLCache.set(mediaPath, dataURL);
            else (0, $32Nbx.default)('No caching as image is too large', dataURL.length, dataURL.slice(0, 15), emoji.shortName);
            return loadedEmoji;
        }).catch(()=>{
            return undefined;
        });
    }
    optimisticRendering() {
        return false;
    }
}
class $4e4069442f1729a0$export$2e2bcd8739ae039 {
    constructor(tokenManager){
        this.waitingInitUrls = [];
        (0, $32Nbx.default)('MediaEmojiCache');
        this.mediaImageLoader = new (0, $9rgFW.default)(tokenManager);
    }
    loadEmoji(emoji, useAlt) {
        const representation = $4e4069442f1729a0$var$getRequiredRepresentation(emoji, useAlt);
        if (!(0, $fqzOa.isMediaRepresentation)(representation)) return emoji;
        const { mediaPath: mediaPath } = representation;
        const emojiCache = this.getCache(mediaPath);
        if ((0, $fqzOa.isPromise)(emojiCache)) // Promise based
        return emojiCache.then((cache)=>cache.loadEmoji(emoji, useAlt)).catch(()=>undefined);
        return emojiCache.loadEmoji(emoji, useAlt);
    }
    optimisticRendering(url) {
        const emojiCache = this.getCache(url);
        if ((0, $fqzOa.isPromise)(emojiCache)) // Promise based
        return emojiCache.then((cache)=>cache.optimisticRendering()).catch(()=>false);
        return emojiCache.optimisticRendering();
    }
    getCache(url) {
        if (this.cache) return this.cache;
        this.waitingInitUrls.push(url);
        if (!this.cacheLoading) this.cacheLoading = this.initCache().then((cache)=>{
            this.cache = cache;
            this.cacheLoading = undefined;
            return cache;
        }).catch((err)=>{
            this.cacheLoading = undefined;
            throw err;
        });
        return this.cacheLoading;
    }
    initCache() {
        const url = this.waitingInitUrls.pop();
        if (!url) return Promise.reject('Unable to initialise cache based on provided url(s)');
        return $4e4069442f1729a0$export$3850f566ce8d817a.supported(url, this.mediaImageLoader).then((supported)=>{
            this.waitingInitUrls = []; // clear
            this.cacheLoading = undefined;
            if (supported) return new $4e4069442f1729a0$export$3850f566ce8d817a(this.mediaImageLoader);
            return new $4e4069442f1729a0$export$b522858a3709f4c(this.mediaImageLoader);
        }).catch(()=>{
            return this.initCache();
        });
    }
}

});
parcelRegister("9rgFW", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d91f6546b6deb57$export$2e2bcd8739ae039);

var $4T9Po = parcelRequire("4T9Po");
const $8d91f6546b6deb57$var$defaultConcurrentDownloadLimit = 16;
const $8d91f6546b6deb57$var$backoffMaxDelayInMillis = 600;
const $8d91f6546b6deb57$var$defaultMaxRetriesOnNotFound = 2;
class $8d91f6546b6deb57$export$2e2bcd8739ae039 {
    constructor(tokenManager, options){
        this.mediaImageQueue = [];
        this.activeProcessing = 0;
        this.pendingRequests = new Map();
        this.concurrentDownloadLimit = options && options.concurrentDownloadLimit || $8d91f6546b6deb57$var$defaultConcurrentDownloadLimit;
        this.tokenManager = tokenManager;
    }
    loadMediaImage(url) {
        const maybePending = this.pendingRequests.get(url);
        if (maybePending !== undefined) return maybePending;
        const pending = new Promise((resolve, reject)=>{
            this.mediaImageQueue.push({
                url: url,
                resolve: resolve,
                reject: reject
            });
            this.processFromQueue();
        }).then((result)=>{
            this.pendingRequests.delete(url);
            return result;
        }).catch((error)=>{
            this.pendingRequests.delete(url);
            throw error;
        });
        this.pendingRequests.set(url, pending);
        return pending;
    }
    getQueueSize() {
        return this.mediaImageQueue.length;
    }
    getActiveDownloads() {
        return this.activeProcessing;
    }
    processFromQueue() {
        while(this.activeProcessing < this.concurrentDownloadLimit && this.mediaImageQueue.length > 0){
            this.activeProcessing++;
            const item = this.mediaImageQueue.shift();
            const { url: url, resolve: resolve, reject: reject } = item;
            this.tokenManager.getToken('read', false).then((token)=>{
                this.requestMediaEmoji(url, token, true).then((dataURL)=>{
                    resolve(dataURL);
                    this.completedItem();
                }).catch((error)=>{
                    reject(error);
                    this.completedItem();
                });
            }).catch((error)=>{
                // Failed to load, just resolve to original emoji
                reject(error);
                this.completedItem();
            });
        }
    }
    completedItem() {
        this.activeProcessing--;
        this.processFromQueue();
    }
    delay(durationInMillis) {
        return new Promise((resolve)=>setTimeout(resolve, durationInMillis));
    }
    requestMediaEmoji(url, token, retryOnAuthError, retriesOnNotFound = $8d91f6546b6deb57$var$defaultMaxRetriesOnNotFound) {
        return (0, $4T9Po.imageAcceptHeader)().then((acceptHeader)=>{
            // Media REST API: https://media-api-internal.atlassian.io/api.html#file__fileId__image_get
            const options = {
                headers: {
                    Authorization: `Bearer ${token.jwt}`,
                    'X-Client-Id': token.clientId,
                    Accept: acceptHeader
                }
            };
            return fetch(url, options).then((response)=>{
                // retry if 404
                if (response.status === 404 && retriesOnNotFound > 0) return this.delay($8d91f6546b6deb57$var$backoffMaxDelayInMillis / retriesOnNotFound) // backoff strategy
                .then(()=>this.requestMediaEmoji(url, token, false, retriesOnNotFound - 1));
                else if (response.status === 403 && retryOnAuthError) // retry once if 403
                return this.tokenManager.getToken('read', true).then((newToken)=>this.requestMediaEmoji(url, newToken, false));
                else if (response.ok) return response.blob().then((blob)=>this.readBlob(blob));
                throw new Error(`Unable to load media image. Status=${response.status} ${response.statusText}`);
            });
        });
    }
    readBlob(blob) {
        return new Promise((resolve, reject)=>{
            const reader = new FileReader();
            // TODO: [ts30] Add proper handling for null and ArrayBuffer
            reader.addEventListener('load', ()=>resolve(reader.result));
            reader.addEventListener('error', ()=>reject(reader.error));
            reader.readAsDataURL(blob);
        });
    }
}

});
parcelRegister("4T9Po", function(module, exports) {

$parcel$export(module.exports, "getNaturalImageSize", () => $1db1ed6195d2b828$export$90153ab95f408dfa);
$parcel$export(module.exports, "parseImage", () => $1db1ed6195d2b828$export$37bbb051492a18a7);
$parcel$export(module.exports, "hasFileExceededSize", () => $1db1ed6195d2b828$export$a115ddd5941792f1);
$parcel$export(module.exports, "imageAcceptHeader", () => $1db1ed6195d2b828$export$f8e7886bc155c2e6);
const $1db1ed6195d2b828$var$maxEmojiSizeInBytes = 1048576;
const $1db1ed6195d2b828$export$90153ab95f408dfa = (dataURL)=>{
    return new Promise((resolve, reject)=>{
        const img = new Image();
        img.addEventListener('load', ()=>{
            resolve({
                width: img.naturalWidth,
                height: img.naturalHeight
            });
        });
        img.addEventListener('error', reject);
        img.src = dataURL;
    });
};
const $1db1ed6195d2b828$export$37bbb051492a18a7 = (dataURL)=>{
    return new Promise((resolve, reject)=>{
        let img = new Image();
        img.onload = ()=>resolve({
                src: img.src
            });
        img.onerror = ()=>reject();
        img.src = dataURL;
    });
};
const $1db1ed6195d2b828$export$a115ddd5941792f1 = (file)=>{
    return file && file.size > $1db1ed6195d2b828$var$maxEmojiSizeInBytes;
};
// Duplicates https://bitbucket.org/atlassian/atlaskit/src/0e843df6df8bcd33fa7fc16cc63f11a0f6094957/packages/media-core/src/utils/checkWebpSupport.ts?at=master&fileviewer=file-view-default
// Didn't want to depend on the whole of media-core just for this util
/**
 * Checks if Webp support is enabled in the browser.
 * We know that creating a new image in memory and checking its height,
 * later on we cache this value forever.
 */ let $1db1ed6195d2b828$var$isWebpSupported;
const $1db1ed6195d2b828$export$c5a964eb84c7fca8 = ()=>{
    if ($1db1ed6195d2b828$var$isWebpSupported !== undefined) return Promise.resolve($1db1ed6195d2b828$var$isWebpSupported);
    return new Promise((resolve)=>{
        const img = new Image();
        const checkSupport = ()=>{
            $1db1ed6195d2b828$var$isWebpSupported = img.height === 2;
            resolve($1db1ed6195d2b828$var$isWebpSupported);
        };
        img.addEventListener('load', checkSupport);
        img.addEventListener('error', checkSupport);
        img.src = 'data:image/webp;base64,UklGRi4AAABXRUJQVlA4TCEAAAAvAUAAEB8wAiMwAgSSNtse/cXjxyCCmrYNWPwmHRH9jwMA';
    });
};
const $1db1ed6195d2b828$export$f8e7886bc155c2e6 = ()=>$1db1ed6195d2b828$export$c5a964eb84c7fca8().then((isWebpSupported)=>{
        // q=0.8 stands for 'quality factor' => http://stackoverflow.com/a/10496722
        const noWebpAcceptHeader = 'image/*,*/*;q=0.8';
        const webpAcceptHeader = 'image/webp,image/*,*/*;q=0.8';
        return isWebpSupported ? webpAcceptHeader : noWebpAcceptHeader;
    });

});



parcelRegister("k1Z1t", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c3d1420d2de3afa$export$2e2bcd8739ae039);

var $kp3br = parcelRequire("kp3br");
const $2c3d1420d2de3afa$export$866c20c059277b6 = 30;
class $2c3d1420d2de3afa$export$2e2bcd8739ae039 {
    constructor(siteServiceConfig){
        this.siteServiceConfig = siteServiceConfig;
        this.tokens = new Map();
    }
    isValidToken(mediaApiToken) {
        const nowInSeconds = Date.now() / 1000;
        const expiresAt = mediaApiToken.expiresAt - $2c3d1420d2de3afa$export$866c20c059277b6;
        if (nowInSeconds < expiresAt) return true;
        return false;
    }
    fetchNewToken(type) {
        return (0, $kp3br.utils).requestService(this.siteServiceConfig, {
            path: `token/${type}`
        });
    }
    addToken(type, mediaApiToken) {
        this.tokens.set(type, {
            mediaApiToken: mediaApiToken
        });
    }
    getToken(type, forceRefresh) {
        let tokenDetail = this.tokens.get(type);
        if (!tokenDetail) {
            tokenDetail = {};
            this.tokens.set(type, tokenDetail);
        }
        const { mediaApiToken: mediaApiToken, activeTokenRefresh: activeTokenRefresh } = tokenDetail;
        if (mediaApiToken) {
            if (this.isValidToken(mediaApiToken) && !forceRefresh) // still valid
            return Promise.resolve(mediaApiToken);
        }
        if (activeTokenRefresh) // refresh token promise already active, return that
        return activeTokenRefresh;
        // request a new token and track the promise for future requests until completed
        tokenDetail.activeTokenRefresh = this.fetchNewToken(type).then((token)=>{
            tokenDetail.mediaApiToken = token;
            tokenDetail.activeTokenRefresh = undefined;
            return token;
        });
        return tokenDetail.activeTokenRefresh;
    }
}

});


parcelRegister("8B8Wm", function(module, exports) {

$parcel$export(module.exports, "ufoExperiences", () => $883d6eb80cdaaaf8$export$615f888019c45765);
$parcel$export(module.exports, "sampledUfoRenderedEmoji", () => $883d6eb80cdaaaf8$export$71c8cba6f1251ea9);
$parcel$export(module.exports, "hasUfoMarked", () => $883d6eb80cdaaaf8$export$a9be054d2a5cedc0);
$parcel$export(module.exports, "sampledUfoEmojiResourceFetched", () => $883d6eb80cdaaaf8$export$1466212a1606133);

var $adGgK = parcelRequire("adGgK");

var $9iIu4 = parcelRequire("9iIu4");
var $aRnO1 = parcelRequire("aRnO1");
var $2pMzV = parcelRequire("2pMzV");

var $jZzVI = parcelRequire("jZzVI");
const $883d6eb80cdaaaf8$var$createRenderExperience = (componentName)=>{
    return {
        platform: {
            component: componentName
        },
        type: (0, $aRnO1.ExperienceTypes).Load,
        performanceType: (0, $aRnO1.ExperiencePerformanceTypes).PageSegmentLoad
    };
};
const $883d6eb80cdaaaf8$var$createInlineExperience = (componentName)=>{
    return {
        platform: {
            component: componentName
        },
        type: (0, $aRnO1.ExperienceTypes).Experience,
        performanceType: (0, $aRnO1.ExperiencePerformanceTypes).InlineResult
    };
};
const $883d6eb80cdaaaf8$var$customEmojiTimings = [
    {
        key: (0, $adGgK.UfoEmojiTimingsKeys).FMP,
        endMark: (0, $adGgK.UfoEmojiTimings).FMP_END
    },
    {
        key: (0, $adGgK.UfoEmojiTimingsKeys).METADATA,
        component: 'resourced-emoji',
        startMark: (0, $adGgK.UfoEmojiTimings).METADATA_START,
        endMark: (0, $adGgK.UfoEmojiTimings).METADATA_END
    },
    {
        key: (0, $adGgK.UfoEmojiTimingsKeys).MEDIADATA,
        component: 'caching-emoji',
        startMark: (0, $adGgK.UfoEmojiTimings).MEDIA_START,
        endMark: (0, $adGgK.UfoEmojiTimings).MEDIA_END
    },
    {
        key: (0, $adGgK.UfoEmojiTimingsKeys).MOUNTED,
        component: 'emoji',
        endMark: (0, $adGgK.UfoEmojiTimings).MOUNTED_END
    },
    {
        key: (0, $adGgK.UfoEmojiTimingsKeys).ONLOAD,
        startMark: (0, $adGgK.UfoEmojiTimings).ONLOAD_START,
        endMark: (0, $adGgK.UfoEmojiTimings).ONLOAD_END
    }
];
const $883d6eb80cdaaaf8$export$615f888019c45765 = {
    'emoji-rendered': new (0, $9iIu4.ConcurrentExperience)((0, $adGgK.UfoExperienceName).EMOJI_RENDERED, {
        platform: {
            component: (0, $adGgK.UfoComponentName).EMOJI
        },
        type: (0, $aRnO1.ExperienceTypes).Operation,
        performanceType: (0, $aRnO1.ExperiencePerformanceTypes).Custom,
        timings: $883d6eb80cdaaaf8$var$customEmojiTimings
    }),
    'emoji-resource-fetched': new (0, $9iIu4.ConcurrentExperience)((0, $adGgK.UfoExperienceName).EMOJI_RESOURCE_FETCHED, $883d6eb80cdaaaf8$var$createRenderExperience((0, $adGgK.UfoComponentName).EMOJI_PROVIDER)),
    'emoji-picker-opened': new (0, $2pMzV.UFOExperience)((0, $adGgK.UfoExperienceName).EMOJI_PICKER_OPENED, $883d6eb80cdaaaf8$var$createRenderExperience((0, $adGgK.UfoComponentName).EMOJI_PICKER)),
    'emoji-selection-recorded': new (0, $2pMzV.UFOExperience)((0, $adGgK.UfoExperienceName).EMOJI_SELECTION_RECORDED, $883d6eb80cdaaaf8$var$createInlineExperience((0, $adGgK.UfoComponentName).EMOJI_PROVIDER)),
    'emoji-uploaded': new (0, $2pMzV.UFOExperience)((0, $adGgK.UfoExperienceName).EMOJI_UPLOADED, $883d6eb80cdaaaf8$var$createInlineExperience((0, $adGgK.UfoComponentName).EMOJI_PICKER)),
    'emoji-searched': new (0, $2pMzV.UFOExperience)((0, $adGgK.UfoExperienceName).EMOJI_SEARCHED, $883d6eb80cdaaaf8$var$createInlineExperience((0, $adGgK.UfoComponentName).EMOJI_PICKER))
};
const $883d6eb80cdaaaf8$export$71c8cba6f1251ea9 = (emojiId)=>{
    return (0, $jZzVI.withSampling)($883d6eb80cdaaaf8$export$615f888019c45765['emoji-rendered'].getInstance(emojiId.id || emojiId.shortName));
};
const $883d6eb80cdaaaf8$export$a9be054d2a5cedc0 = (ufoExperience, name)=>{
    return ufoExperience.metrics.marks.some((mask)=>mask.name === name);
};
const $883d6eb80cdaaaf8$export$1466212a1606133 = (providerType)=>{
    return (0, $jZzVI.withSampling)($883d6eb80cdaaaf8$export$615f888019c45765['emoji-resource-fetched'].getInstance(providerType));
};

});
parcelRegister("jZzVI", function(module, exports) {

$parcel$export(module.exports, "withSampling", () => $79a9e98a54aa22fe$export$dc2f0946255b3f89);
const $79a9e98a54aa22fe$export$c7c4959fece2f3ec = {};
const $79a9e98a54aa22fe$export$cdff9a865136ae27 = ()=>{
    for (const prop of Object.getOwnPropertyNames($79a9e98a54aa22fe$export$c7c4959fece2f3ec))delete $79a9e98a54aa22fe$export$c7c4959fece2f3ec[prop];
};
const $79a9e98a54aa22fe$export$1c967630b3ea2d58 = (rate)=>{
    if (rate === 1) return true;
    if (rate === 0) return false;
    return Math.random() * rate <= 1;
};
const $79a9e98a54aa22fe$var$hasSampledFromStart = (experience)=>{
    if (!$79a9e98a54aa22fe$export$c7c4959fece2f3ec[experience.id]) return false;
    if (experience.instanceId) // if the instance of concurrent exp has been sampled from start, allow it.
    return $79a9e98a54aa22fe$export$c7c4959fece2f3ec[experience.id].sampledInstance[experience.instanceId];
    return $79a9e98a54aa22fe$export$c7c4959fece2f3ec[experience.id].sampled;
};
const $79a9e98a54aa22fe$export$dc2f0946255b3f89 = (ufoExperience)=>{
    const init = ()=>{
        if (!$79a9e98a54aa22fe$export$c7c4959fece2f3ec[ufoExperience.id]) $79a9e98a54aa22fe$export$c7c4959fece2f3ec[ufoExperience.id] = {
            sampled: false,
            sampledInstance: {}
        };
    };
    const start = async (options)=>{
        // check if the experience has already sampled before
        if ($79a9e98a54aa22fe$var$hasSampledFromStart(ufoExperience)) return;
        const isSampled = options.samplingFunc || $79a9e98a54aa22fe$export$1c967630b3ea2d58;
        if (!isSampled(options.samplingRate)) {
            if (ufoExperience.instanceId) $79a9e98a54aa22fe$export$c7c4959fece2f3ec[ufoExperience.id].sampledInstance[ufoExperience.instanceId] = false;
            $79a9e98a54aa22fe$export$c7c4959fece2f3ec[ufoExperience.id].sampled = false;
            return;
        }
        // update sampled records
        if (ufoExperience.instanceId) {
            $79a9e98a54aa22fe$export$c7c4959fece2f3ec[ufoExperience.id].sampledInstance[ufoExperience.instanceId] = true;
            $79a9e98a54aa22fe$export$c7c4959fece2f3ec[ufoExperience.id].sampled = true;
        }
        return ufoExperience.start(options.startTime);
    };
    const success = async (config)=>{
        if (!$79a9e98a54aa22fe$var$hasSampledFromStart(ufoExperience)) return null;
        return ufoExperience.success(config);
    };
    const failure = async (config)=>{
        if (!$79a9e98a54aa22fe$var$hasSampledFromStart(ufoExperience)) return null;
        return ufoExperience.failure(config);
    };
    const abort = async (config)=>{
        if (!$79a9e98a54aa22fe$var$hasSampledFromStart(ufoExperience)) return null;
        return ufoExperience.abort(config);
    };
    const addMetadata = (data)=>{
        if (!$79a9e98a54aa22fe$var$hasSampledFromStart(ufoExperience)) return;
        return ufoExperience.addMetadata(data);
    };
    const mark = (name, timestamp)=>{
        if (!$79a9e98a54aa22fe$var$hasSampledFromStart(ufoExperience)) return;
        return ufoExperience.mark(name, timestamp);
    };
    const markFMP = (timestamp)=>{
        if (!$79a9e98a54aa22fe$var$hasSampledFromStart(ufoExperience)) return;
        return ufoExperience.markFMP(timestamp);
    };
    const markInlineResponse = (timestamp)=>{
        if (!$79a9e98a54aa22fe$var$hasSampledFromStart(ufoExperience)) return;
        return ufoExperience.markInlineResponse(timestamp);
    };
    init();
    return {
        ...ufoExperience,
        start: start,
        addMetadata: addMetadata,
        success: success,
        failure: failure,
        abort: abort,
        mark: mark,
        markFMP: markFMP,
        markInlineResponse: markInlineResponse
    };
};

});


parcelRegister("1AKB0", function(module, exports) {

$parcel$export(module.exports, "promiseWithTimeout", () => $7d4e7f9f7c6d2510$export$a9cd205a244d9f54);
function $7d4e7f9f7c6d2510$export$a9cd205a244d9f54(promise, timeout, errorMessage = 'Timed out') {
    // Create a promise that rejects after the specified timeout
    const timeoutPromise = new Promise((_, reject)=>setTimeout(()=>reject(new Error(errorMessage)), timeout));
    // Use Promise.race to race the provided promise against the timeout promise
    return Promise.race([
        promise,
        timeoutPromise
    ]);
}

});


parcelRegister("kFrAe", function(module, exports) {

$parcel$export(module.exports, "EMOJI_SERVICEID", () => $041d4deb698c5fda$export$f3c4ed49c0fff3de);
$parcel$export(module.exports, "EMOJI_WITH_CUSTOM_SERVICEID", () => $041d4deb698c5fda$export$f8b39b441e3e8eb2);
$parcel$export(module.exports, "EMOJI_WITH_CUSTOM_UPLOAD_DISABLED_SERVICEID", () => $041d4deb698c5fda$export$2cdcb9248b6d4704);
$parcel$export(module.exports, "getServiceProvider", () => $041d4deb698c5fda$export$a4c27db78169052e);
$parcel$export(module.exports, "default", () => $041d4deb698c5fda$export$2e2bcd8739ae039);

var $hWeHP = parcelRequire("hWeHP");
const $041d4deb698c5fda$var$providersRepository = {};
const $041d4deb698c5fda$export$f3c4ed49c0fff3de = 'emoji';
const $041d4deb698c5fda$export$f8b39b441e3e8eb2 = 'emoji-with-custom';
const $041d4deb698c5fda$export$2cdcb9248b6d4704 = 'emoji-with-custom-upload-disabled';
const $041d4deb698c5fda$var$getServiceBaseUrl = (serviceId)=>{
    if (serviceId === $041d4deb698c5fda$export$f8b39b441e3e8eb2 || serviceId === $041d4deb698c5fda$export$2cdcb9248b6d4704) return (0, $hWeHP.default)('ajs-fabric-emoji-url');
    return (0, $hWeHP.default)(`ajs-fabric-${serviceId}-url`);
};
const $041d4deb698c5fda$export$a4c27db78169052e = (serviceId, serviceProviderGenerator)=>{
    try {
        let serviceProvider = $041d4deb698c5fda$var$providersRepository[serviceId];
        if (serviceProvider === undefined) {
            const serviceBaseUrl = $041d4deb698c5fda$var$getServiceBaseUrl(serviceId);
            if (serviceBaseUrl) {
                serviceProvider = Promise.resolve(serviceProviderGenerator(serviceBaseUrl));
                $041d4deb698c5fda$var$providersRepository[serviceId] = serviceProvider;
            }
        }
        return serviceProvider;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        return null;
    }
};
const $041d4deb698c5fda$export$59790759c19337ec = ()=>{
    Object.keys($041d4deb698c5fda$var$providersRepository).forEach((key)=>{
        delete $041d4deb698c5fda$var$providersRepository[key];
    });
};
var $041d4deb698c5fda$export$2e2bcd8739ae039 = $041d4deb698c5fda$var$getServiceBaseUrl;

});



parcelRegister("l7iSF", function(module, exports) {

$parcel$export(module.exports, "isExternalLink", () => $5dc3e88c92a2ca26$export$b98882f166bb7ce2);
$parcel$export(module.exports, "onLinkClick", () => $5dc3e88c92a2ca26$export$dccc97e4cadc9724);
$parcel$export(module.exports, "smartLinksDefault", () => $5dc3e88c92a2ca26$export$4f1b881d7a962ce6);
$parcel$export(module.exports, "useSmartCardProductType", () => $5dc3e88c92a2ca26$export$3f864e37674c79e7);

var $eJOHy = parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");

var $18DG7 = parcelRequire("18DG7");

var $ln6Iy = parcelRequire("ln6Iy");

var $bmoS1 = parcelRequire("bmoS1");

var $bNexr = parcelRequire("bNexr");
const $5dc3e88c92a2ca26$var$isLeftClick = (event)=>event.button === 0;
const $5dc3e88c92a2ca26$var$isMiddleClick = (event)=>event.button === 1;
const $5dc3e88c92a2ca26$var$isCmdOrCtrlClick = (event)=>$5dc3e88c92a2ca26$var$isLeftClick(event) && (event.metaKey || event.ctrlKey);
const $5dc3e88c92a2ca26$export$b98882f166bb7ce2 = (url)=>{
    (0, $gRw8I.di)(window);
    try {
        const { hostname: hostname, pathname: pathname } = new URL(url);
        return(// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        hostname !== window.location.hostname || ![
            '/jira',
            '/browse'
        ].some((includedPath)=>pathname.startsWith(includedPath)));
    } catch (err) {
        // Defaults to external link for invalid URLs to avoid further processing
        return true;
    }
};
const $5dc3e88c92a2ca26$export$dccc97e4cadc9724 = (event, url)=>{
    (0, $gRw8I.di)(window);
    if (!url) return;
    if ($5dc3e88c92a2ca26$export$b98882f166bb7ce2(url)) {
        event.preventDefault();
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.open(url, '_blank', 'noopener,noreferrer');
        return;
    }
    if (event.defaultPrevented) {
        // The default has already been prevented meaning that we need to open links in one
        // way or another to ensure we do eventually open the link
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        const mouseEvent = event;
        $5dc3e88c92a2ca26$var$isCmdOrCtrlClick(mouseEvent) || $5dc3e88c92a2ca26$var$isMiddleClick(mouseEvent) ? window.open(url, '_blank', 'noopener,noreferrer') : window.location.assign(url);
    }
};
const $5dc3e88c92a2ca26$export$4f1b881d7a962ce6 = {
    actionOptions: {
        hide: false,
        exclude: [
            (0, $18DG7.CardAction).ChangeStatusAction
        ]
    }
};
const $5dc3e88c92a2ca26$var$getProductForSmartLinksProvider = (projectType)=>{
    switch(projectType){
        case 0, $ln6Iy.CORE_PROJECT:
            return 'JWM';
        case 0, $ln6Iy.SOFTWARE_PROJECT:
            return 'JSW';
        case 0, $ln6Iy.SERVICE_DESK_PROJECT:
            return 'JSM';
        case 0, $ln6Iy.PRODUCT_DISCOVERY_PROJECT:
            return 'JPD';
        default:
            return undefined;
    }
};
const $5dc3e88c92a2ca26$export$3f864e37674c79e7 = ()=>{
    const issueKey = (0, $bmoS1.useIssueKey)();
    const projectKey = (0, $bNexr.useProjectKey)(issueKey);
    const projectType = (0, $bNexr.useProjectType)(projectKey);
    const product = (0, $eJOHy.useMemo)(()=>// Arbitrarily default to Jira Software if not specified
        $5dc3e88c92a2ca26$var$getProductForSmartLinksProvider(projectType) ?? 'JSW', [
        projectType
    ]);
    return product;
};

});
parcelRegister("18DG7", function(module, exports) {

$parcel$export(module.exports, "CardAction", () => $ff948bb743384c72$export$f40b7e0b762b928b);
var $ff948bb743384c72$export$f40b7e0b762b928b = /*#__PURE__*/ function(CardAction) {
    CardAction["DownloadAction"] = "DownloadAction";
    CardAction["PreviewAction"] = "PreviewAction";
    CardAction["ViewAction"] = "ViewAction";
    CardAction["ChangeStatusAction"] = "ChangeStatusAction";
    CardAction["FollowAction"] = "FollowAction";
    CardAction["CopyLinkAction"] = "CopyLinkAction";
    CardAction["AISummaryAction"] = "AISummaryAction";
    CardAction["AutomationAction"] = "AutomationAction";
    return CardAction;
}({});

});


parcelRegister("eF6kk", function(module, exports) {

$parcel$export(module.exports, "getLearnMoreMessage", () => $e0cc315fee364e23$export$2c1e5dc35269c547);
$parcel$export(module.exports, "adfDocument", () => $e0cc315fee364e23$export$754eb30ac7b536b8);
$parcel$export(module.exports, "getErrorMessage", () => $e0cc315fee364e23$export$82f46aa4e6535a45);

var $7jTnu = parcelRequire("7jTnu");


var $5Ldo0 = parcelRequire("5Ldo0");

var $fU05s = parcelRequire("fU05s");

var $k57C5 = parcelRequire("k57C5");
const $e0cc315fee364e23$export$2c1e5dc35269c547 = (fieldHelpTextUrl)=>{
    // fieldHelpTextUrl is used as a unique key. Extracting a suffix just for making the key shorter
    const urlSuffix = fieldHelpTextUrl.substring(fieldHelpTextUrl.lastIndexOf('#'));
    const LEARN_MORE = (0, $7jTnu.fg)('jira-issue-terminology-update-m4') ? (0, $fU05s.LEARN_MORE_MESSAGES) : (0, $fU05s.LEARN_MORE_MESSAGES_OLD);
    if (urlSuffix in LEARN_MORE) return LEARN_MORE[urlSuffix];
    return (0, $k57C5.default).fieldHelpTextLabel;
};
const $e0cc315fee364e23$export$188aeee1ab8948d8 = (fieldHelpTextUrl, formatMessage)=>{
    // fieldHelpTextUrl is used as a unique key. Extracting a suffix just for making the key shorter
    const helperMessage = $e0cc315fee364e23$export$2c1e5dc35269c547(fieldHelpTextUrl) || (0, $k57C5.default).fieldHelpTextLabel;
    return `[${formatMessage(helperMessage)}|${fieldHelpTextUrl}]`;
};
const $e0cc315fee364e23$export$754eb30ac7b536b8 = ({ description: description })=>(0, $5Ldo0.convertWikiToAdf)(description);
const $e0cc315fee364e23$export$82f46aa4e6535a45 = (validationError, fieldName, formatMessage, formatNumber)=>{
    switch(validationError){
        case 0, $c62d92ce2368c9f0$export$b1c05b34d317c074:
            return formatMessage((0, $k57C5.default).requiredErrorMessage, {
                fieldName: fieldName
            });
        case 0, $c62d92ce2368c9f0$export$618e922e89e8bcae:
            return formatMessage((0, $k57C5.default).stringInvalidErrorMessage, {
                fieldName: fieldName,
                MAX_STRING_SIZE: formatNumber((0, $c62d92ce2368c9f0$export$fe1a70381f6491b5))
            });
        case 0, $c62d92ce2368c9f0$export$d2d79153ead377fe:
            return formatMessage((0, $k57C5.default).urlInvalidErrorMessage, {
                fieldName: fieldName
            });
        default:
            return validationError;
    }
};

});
const $c62d92ce2368c9f0$export$b1c05b34d317c074 = 'REQUIRED';
const $c62d92ce2368c9f0$export$618e922e89e8bcae = 'STRING_INVALID';
const $c62d92ce2368c9f0$export$fe1a70381f6491b5 = 255;
const $c62d92ce2368c9f0$export$d2d79153ead377fe = 'URL_INVALID';

parcelRegister("5Ldo0", function(module, exports) {

$parcel$export(module.exports, "convertWikiToAdf", () => $8d1a0537a5b01a80$export$3dfdef94497f0395);

var $8DB98 = parcelRequire("8DB98");

var $lovmf = parcelRequire("lovmf");

var $dmYzn = parcelRequire("dmYzn");
const $8d1a0537a5b01a80$var$wikiTransformer = new (0, $dmYzn.WikiMarkupTransformer)((0, $8DB98.defaultSchema));
const $8d1a0537a5b01a80$var$adfTransformer = new (0, $lovmf.JSONTransformer)();
const $8d1a0537a5b01a80$export$3dfdef94497f0395 = (wiki)=>{
    if (wiki === null || wiki === undefined || wiki === '') return null;
    const pmNode = $8d1a0537a5b01a80$var$wikiTransformer.parse(wiki);
    return $8d1a0537a5b01a80$var$adfTransformer.encode(pmNode);
};

});

parcelRegister("fU05s", function(module, exports) {

$parcel$export(module.exports, "LEARN_MORE_MESSAGES_OLD", () => $bda8394b9e89569b$export$ed551050ae4441e4);
$parcel$export(module.exports, "LEARN_MORE_MESSAGES", () => $bda8394b9e89569b$export$eedb1bf75e1efb26);

var $k57C5 = parcelRequire("k57C5");
const $bda8394b9e89569b$var$LEARN_MORE_TYPES = {
    IssueTypes: '#IssueTypes',
    PriorityLevels: '#PriorityLevels',
    ResolutionTypes: '#ResolutionTypes',
    SecurityLevels: '#SecurityLevels',
    TimeTracking: '#TimeTracking',
    LogWork: '#LogWork'
};
const $bda8394b9e89569b$export$ed551050ae4441e4 = {
    [$bda8394b9e89569b$var$LEARN_MORE_TYPES.IssueTypes]: (0, $k57C5.default).fieldHelpIssueTypes,
    [$bda8394b9e89569b$var$LEARN_MORE_TYPES.PriorityLevels]: (0, $k57C5.default).fieldHelpPriorityLevels,
    [$bda8394b9e89569b$var$LEARN_MORE_TYPES.ResolutionTypes]: (0, $k57C5.default).fieldHelpResolutionDefinitions,
    [$bda8394b9e89569b$var$LEARN_MORE_TYPES.SecurityLevels]: (0, $k57C5.default).fieldHelpSecurityLevels,
    [$bda8394b9e89569b$var$LEARN_MORE_TYPES.TimeTracking]: (0, $k57C5.default).fieldHelpTimeTracking,
    [$bda8394b9e89569b$var$LEARN_MORE_TYPES.LogWork]: (0, $k57C5.default).fieldHelpLogWork
};
const $bda8394b9e89569b$export$eedb1bf75e1efb26 = {
    [$bda8394b9e89569b$var$LEARN_MORE_TYPES.IssueTypes]: (0, $k57C5.default).fieldHelpIssueTypesIssueTerminologyRefreshM4,
    [$bda8394b9e89569b$var$LEARN_MORE_TYPES.PriorityLevels]: (0, $k57C5.default).fieldHelpPriorityLevels,
    [$bda8394b9e89569b$var$LEARN_MORE_TYPES.ResolutionTypes]: (0, $k57C5.default).fieldHelpResolutionDefinitions,
    [$bda8394b9e89569b$var$LEARN_MORE_TYPES.SecurityLevels]: (0, $k57C5.default).fieldHelpSecurityLevels,
    [$bda8394b9e89569b$var$LEARN_MORE_TYPES.TimeTracking]: (0, $k57C5.default).fieldHelpTimeTracking,
    [$bda8394b9e89569b$var$LEARN_MORE_TYPES.LogWork]: (0, $k57C5.default).fieldHelpLogWork
};

});
parcelRegister("k57C5", function(module, exports) {

$parcel$export(module.exports, "default", () => $acae1d40cdcfec8f$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $acae1d40cdcfec8f$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    requiredErrorMessage: {
        "id": "issue-form-field-base.common.field-message.required-error-message",
        "defaultMessage": "{fieldName} is required"
    },
    stringInvalidErrorMessage: {
        "id": "issue-form-field-base.common.field-message.string-invalid-error-message",
        "defaultMessage": "{fieldName} can't exceed {MAX_STRING_SIZE, plural, one {# character} other {# characters}}."
    },
    urlInvalidErrorMessage: {
        "id": "issue-form-field-base.common.field-message.url-invalid-error-message",
        "defaultMessage": "{fieldName} is not a valid URL"
    },
    fieldHelpTextLabel: {
        "id": "issue-form-field-base.common.field-message.field-help-text-label",
        "defaultMessage": "Learn more"
    },
    fieldHelpIssueTypes: {
        "id": "issue-form-field-base.common.field-message.field-help-issue-types",
        "defaultMessage": "Learn about issue types"
    },
    fieldHelpPriorityLevels: {
        "id": "issue-form-field-base.common.field-message.field-help-priority-levels",
        "defaultMessage": "Learn about priority levels"
    },
    fieldHelpLogWork: {
        "id": "issue-form-field-base.common.field-message.field-help-log-work",
        "defaultMessage": "Learn about logging work"
    },
    fieldHelpTimeTracking: {
        "id": "issue-form-field-base.common.field-message.field-help-time-tracking",
        "defaultMessage": "Learn about time tracking"
    },
    fieldHelpResolutionDefinitions: {
        "id": "issue-form-field-base.common.field-message.field-help-resolution-definitions",
        "defaultMessage": "Resolutions definitions"
    },
    fieldHelpSecurityLevels: {
        "id": "issue-form-field-base.common.field-message.field-help-security-levels",
        "defaultMessage": "More on security levels"
    },
    fieldContentWithHelpText: {
        "id": "issue-form-field-base.common.field-message.field-content-with-help-text",
        "defaultMessage": "{fieldDescription} {fieldHelpText}"
    },
    fieldHelpIssueTypesIssueTerminologyRefreshM4: {
        "id": "issue-form-field-base.common.field-message.field-help-issue-types-issue-terminology-refresh-m4",
        "defaultMessage": "Learn about work types"
    }
});

});




parcelRegister("gPU3b", function(module, exports) {

$parcel$export(module.exports, "isForgeCustomField", () => $64536fb45863a750$export$78cf1b56a8dede1f);
$parcel$export(module.exports, "isForgeLegacyFieldType", () => $64536fb45863a750$export$3fb46a1fa454ffea);
$parcel$export(module.exports, "getExtensionIdFromLegacyFieldType", () => $64536fb45863a750$export$2b6a9cc67d548886);
$parcel$export(module.exports, "focusFormButton", () => $64536fb45863a750$export$f1a0ef98758e7a8a);
$parcel$export(module.exports, "isBuiltInJiraFieldRender", () => $64536fb45863a750$export$2909711775a2c267);

var $fohjD = parcelRequire("fohjD");

var $giy6r = parcelRequire("giy6r");
const $64536fb45863a750$export$78cf1b56a8dede1f = (fieldType)=>typeof fieldType === 'string' && (fieldType.startsWith((0, $fohjD.LEGACY_FORGE_FIELD_TYPE_PREFIX)) || fieldType.startsWith((0, $fohjD.FORGE_FIELD_TYPE_PREFIX)));
const $64536fb45863a750$export$3fb46a1fa454ffea = (fieldType)=>fieldType.startsWith((0, $fohjD.LEGACY_FORGE_FIELD_TYPE_PREFIX));
const $64536fb45863a750$export$2b6a9cc67d548886 = (fieldType)=>fieldType.split((0, $fohjD.PARTIAL_LEGACY_FORGE_FIELD_TYPE_PREFIX))[1] || null;
const $64536fb45863a750$export$319e805d3fc5ee35 = (fields)=>Object.values(fields).filter((field)=>$64536fb45863a750$export$78cf1b56a8dede1f(field.fieldType));
const $64536fb45863a750$export$f1a0ef98758e7a8a = (formSelector, target = document)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const button = target.querySelector(`button[form="${formSelector}"][type="submit"]`);
    if (button != null) button.focus();
};
function $64536fb45863a750$export$2909711775a2c267(extension, entryPoint, experience) {
    const edit = extension.properties?.edit;
    const view = 'view' in extension.properties ? extension.properties.view : undefined;
    const entry = entryPoint === 'edit' ? edit : view;
    let supportedExperience = false;
    if (entryPoint === 'edit') supportedExperience = edit && 'experience' in edit && edit.experience && (0, $giy6r.isCustomFieldEditRenderContext)(experience) ? edit.experience.includes(experience) : false;
    else supportedExperience = view && 'experience' in view && view.experience && (0, $giy6r.isCustomFieldViewRenderContext)(experience) ? view.experience.includes(experience) : false;
    const hasRenderFunction = entry && 'function' in entry;
    const hasSupportedResource = entry && 'resource' in entry && supportedExperience;
    const render = entry && 'render' in entry ? entry.render : null;
    return entryPoint === 'view' ? !hasRenderFunction && !(hasSupportedResource && render === 'native') : !hasRenderFunction && !hasSupportedResource;
}

});
parcelRegister("giy6r", function(module, exports) {

$parcel$export(module.exports, "isCustomFieldEditRenderContext", () => $3998c1bc4bf7dd49$export$b562ffa4bbc21d4f);
$parcel$export(module.exports, "isCustomFieldViewRenderContext", () => $3998c1bc4bf7dd49$export$36376c9ff94a7fbd);
function $3998c1bc4bf7dd49$export$b562ffa4bbc21d4f(context) {
    return context === 'issue-view' || context === 'issue-create' || context === 'issue-transition';
}
function $3998c1bc4bf7dd49$export$36376c9ff94a7fbd(context) {
    return context === 'issue-view';
}

});


parcelRegister("hdJ4q", function(module, exports) {

$parcel$export(module.exports, "EditMode", () => $97f247b193ab9540$export$5304145354a3bee9);

var $eJOHy = parcelRequire("eJOHy");

var $eSnSE = parcelRequire("eSnSE");

var $52lsd = parcelRequire("52lsd");

var $8mGAP = parcelRequire("8mGAP");

var $efBOp = parcelRequire("efBOp");

var $87XVk = parcelRequire("87XVk");

var $87MEE = parcelRequire("87MEE");

var $lRq8t = parcelRequire("lRq8t");

var $g2eay = parcelRequire("g2eay");

var $2GpiD = parcelRequire("2GpiD");
const $97f247b193ab9540$export$ba588b5cce278e96 = ({ extension: extension, extensionData: extensionData, extensionPayload: extensionPayload, analyticsAttributes: analyticsAttributes, onChange: onChange })=>{
    const [isModalMode, setIsModalMode] = (0, $eJOHy.useState)(false);
    const intl = (0, $lRq8t.default)();
    const onEditConfirm = (0, $eJOHy.useCallback)((newValue)=>{
        onChange((0, $g2eay.transformValue)(newValue, extension));
        (0, $8mGAP.fireTrackEditedEvent)(analyticsAttributes.renderContext, analyticsAttributes);
    }, [
        extension,
        analyticsAttributes,
        onChange
    ]);
    const onModalRender = (0, $eJOHy.useCallback)(()=>setIsModalMode(true), []);
    if (isModalMode) {
        // temporary for UI Kit 1 version of 1.2.0 when inline edit is not supported
        // should be removed with removal of UI Kit 1
        const translatedError = {
            message: intl.formatMessage((0, $2GpiD.default).modalModeErrorTitle),
            errorMessage: intl.formatMessage((0, $2GpiD.default).modalModeErrorDescription)
        };
        (0, $eSnSE.default).safeErrorWithoutCustomerData('jiraForgeUI.customFieldEdit', 'App tried to render modal expierience with non-supported UI Kit 1', {
            extennsionId: extension.id
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $87MEE.ErrorPanel), {
            error: translatedError
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $87XVk.AsyncCustomFieldInlineEdit), {
        extension: extension,
        extensionData: extensionData,
        analyticsAttributes: analyticsAttributes,
        extensionPayload: extensionPayload,
        onSubmit: onEditConfirm,
        onModalRender: onModalRender
    });
};
const $97f247b193ab9540$export$5304145354a3bee9 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $efBOp.EditAnalyticsWrapper), {
        attributes: (0, $52lsd.getAnalyticsAttributesFromExtension)(props.extension)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($97f247b193ab9540$export$ba588b5cce278e96, props));

});
parcelRegister("8mGAP", function(module, exports) {

$parcel$export(module.exports, "fireTrackEditedEvent", () => $e6ebb70c88157b2d$export$1798d320c6527c08);
$parcel$export(module.exports, "fireUiCanceledEvent", () => $e6ebb70c88157b2d$export$fc09afa3d0d5294c);
$parcel$export(module.exports, "fireOperationalEditFailedEvent", () => $e6ebb70c88157b2d$export$762dee9e981de3e1);
$parcel$export(module.exports, "fireUiTriggerClickEvent", () => $e6ebb70c88157b2d$export$cfefb608fbbf02c9);
$parcel$export(module.exports, "fireOperationalFailedEvent", () => $e6ebb70c88157b2d$export$add44f896fb31ba3);

var $fohjD = parcelRequire("fohjD");

var $7jTnu = parcelRequire("7jTnu");

var $1GZq2 = parcelRequire("1GZq2");

var $ibOCX = parcelRequire("ibOCX");

var $lHD3D = parcelRequire("lHD3D");

var $9gq2c = parcelRequire("9gq2c");
const $e6ebb70c88157b2d$var$moduleEventId = (0, $ibOCX.getEventIdOld)({
    module: (0, $fohjD.CUSTOM_FIELD_MODULE),
    moduleType: (0, $9gq2c.MODULE_TYPE_EXTENSION),
    entryPoint: (0, $fohjD.ENTRY_POINT_EDIT)
});
const $e6ebb70c88157b2d$var$triggerEventId = (0, $ibOCX.getEventIdOld)({
    module: (0, $fohjD.CUSTOM_FIELD_MODULE),
    moduleType: (0, $9gq2c.MODULE_TYPE_TRIGGER),
    entryPoint: (0, $fohjD.ENTRY_POINT_EDIT)
});
const $e6ebb70c88157b2d$export$1798d320c6527c08 = (source, attributes)=>(0, $1GZq2.fireTrackEvent)((0, $9gq2c.TRACK_ACTIONS).EDITED, {
        id: (0, $7jTnu.fg)('ditto-fcf-support-new-manifest-on-frontend') ? (0, $ibOCX.getEventId)({
            module: (0, $fohjD.CUSTOM_FIELD_MODULE),
            moduleType: (0, $9gq2c.MODULE_TYPE_EXTENSION),
            entryPoint: (0, $fohjD.ENTRY_POINT_EDIT)
        }) : $e6ebb70c88157b2d$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $e6ebb70c88157b2d$export$fc09afa3d0d5294c = (source, attributes)=>(0, $1GZq2.fireUiEvent)((0, $9gq2c.UI_ACTIONS).CANCELED, {
        id: (0, $7jTnu.fg)('ditto-fcf-support-new-manifest-on-frontend') ? (0, $ibOCX.getEventId)({
            module: (0, $fohjD.CUSTOM_FIELD_MODULE),
            moduleType: (0, $9gq2c.MODULE_TYPE_EXTENSION),
            entryPoint: (0, $fohjD.ENTRY_POINT_EDIT)
        }) : $e6ebb70c88157b2d$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $e6ebb70c88157b2d$export$762dee9e981de3e1 = (source, attributes)=>(0, $1GZq2.fireOperationalEvent)((0, $9gq2c.OPERATIONAL_ACTIONS).EDIT_FAILED, {
        id: (0, $7jTnu.fg)('ditto-fcf-support-new-manifest-on-frontend') ? (0, $ibOCX.getEventId)({
            module: (0, $fohjD.CUSTOM_FIELD_MODULE),
            moduleType: (0, $9gq2c.MODULE_TYPE_EXTENSION),
            entryPoint: (0, $fohjD.ENTRY_POINT_EDIT)
        }) : $e6ebb70c88157b2d$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $e6ebb70c88157b2d$export$cfefb608fbbf02c9 = (extensionId, source, attributes)=>{
    (0, $lHD3D.forgeModulesConcurrentLoadTime)(extensionId).start({
        startTime: performance.now()
    });
    return (0, $1GZq2.fireUiEvent)((0, $9gq2c.UI_ACTIONS).CLICKED, {
        id: (0, $7jTnu.fg)('ditto-fcf-support-new-manifest-on-frontend') ? (0, $ibOCX.getEventId)({
            module: (0, $fohjD.CUSTOM_FIELD_MODULE),
            moduleType: (0, $9gq2c.MODULE_TYPE_TRIGGER),
            entryPoint: (0, $fohjD.ENTRY_POINT_EDIT)
        }) : $e6ebb70c88157b2d$var$triggerEventId,
        source: source,
        attributes: attributes
    });
};
const $e6ebb70c88157b2d$export$add44f896fb31ba3 = (source, attributes)=>(0, $1GZq2.fireOperationalEvent)((0, $9gq2c.OPERATIONAL_ACTIONS).FAILED, {
        id: (0, $7jTnu.fg)('ditto-fcf-support-new-manifest-on-frontend') ? (0, $ibOCX.getEventId)({
            module: (0, $fohjD.CUSTOM_FIELD_MODULE),
            moduleType: (0, $9gq2c.MODULE_TYPE_EXTENSION),
            entryPoint: (0, $fohjD.ENTRY_POINT_EDIT)
        }) : $e6ebb70c88157b2d$var$moduleEventId,
        source: source,
        attributes: attributes
    });

});

parcelRegister("87XVk", function(module, exports) {

$parcel$export(module.exports, "AsyncCustomFieldInlineEdit", () => $70ff90b76565ef77$export$ca6c6772b322056d);

var $eJOHy = parcelRequire("eJOHy");

var $drCJm = parcelRequire("drCJm");

var $d4jEd = parcelRequire("d4jEd");
const $70ff90b76565ef77$var$isIssueViewProps = (props)=>props.extensionData.renderContext === 'issue-view';
const $70ff90b76565ef77$var$isIssueCreateOrTransitionProps = (props)=>props.extensionData.renderContext === 'issue-create' || props.extensionData.renderContext === 'issue-transition';
const $70ff90b76565ef77$export$980ea0297ad3a4c8 = (props)=>{
    if ($70ff90b76565ef77$var$isIssueViewProps(props)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d4jEd.LazyCustomFieldInlineEditIssueView), props);
    if ($70ff90b76565ef77$var$isIssueCreateOrTransitionProps(props)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $drCJm.LazyCustomFieldInlineEditForm), props);
    return null;
};
const $70ff90b76565ef77$export$ca6c6772b322056d = $70ff90b76565ef77$export$980ea0297ad3a4c8;

});
parcelRegister("drCJm", function(module, exports) {

$parcel$export(module.exports, "LazyCustomFieldInlineEditForm", () => $e8878a1856f37944$export$eb4eaeb8dcd7d4ca);

var $eJOHy = parcelRequire("eJOHy");


var $6hw9S = parcelRequire("6hw9S");

var $8mGAP = parcelRequire("8mGAP");

var $fohjD = parcelRequire("fohjD");

var $av1az = parcelRequire("av1az");

var $ch9En = parcelRequire("ch9En");

var $cZueg = parcelRequire("cZueg");

var $7jTnu = parcelRequire("7jTnu");

var $jhS2q = parcelRequire("jhS2q");

var $gRxHB = parcelRequire("gRxHB");

var $lTzC0 = parcelRequire("lTzC0");
const $e8878a1856f37944$var$skeletonConfig = [
    {
        width: 100
    }
];
const $e8878a1856f37944$export$eb4eaeb8dcd7d4ca = ({ onSubmit: onSubmit, onModalRender: onModalRender, ...restProps })=>{
    const requestsCount = (0, $eJOHy.useRef)(0);
    const [, { setFieldState: setFieldState }] = (0, $6hw9S.useInlineField)(restProps.extensionData.fieldId);
    const containerRef = (0, $eJOHy.useRef)(null);
    const { extension: extension, extensionData: extensionData, extensionPayload: extensionPayload, analyticsAttributes: analyticsAttributes } = restProps;
    const loadingComponent = (0, $eJOHy.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jhS2q.Skeleton), {
            skeletonConfig: $e8878a1856f37944$var$skeletonConfig
        }), []);
    const extensionDataValue = (0, $eJOHy.useMemo)(()=>{
        const preparedExtensionData = extensionData?.issue && extensionData?.project ? extensionData : {
            fieldId: extensionData.fieldId,
            fieldType: extensionData.fieldType,
            fieldName: extensionData.fieldName,
            renderContext: extensionData.renderContext,
            ...(0, $7jTnu.fg)('ditto-fcf-support-new-manifest-on-frontend') && {
                experience: extensionData.experience
            }
        };
        return {
            ...preparedExtensionData,
            type: extension.type,
            entryPoint: (0, $fohjD.ENTRY_POINT_EDIT),
            isInline: true
        };
    }, [
        extension,
        extensionData
    ]);
    const extraProps = (0, $eJOHy.useMemo)(()=>({
            loadingComponent: loadingComponent,
            module: (0, $fohjD.CUSTOM_FIELD_MODULE),
            entryPoint: (0, $fohjD.ENTRY_POINT_EDIT),
            extensionData: extensionDataValue,
            extensionPayload: extensionPayload,
            contextToken: (0, $fohjD.CONTEXT_TOKEN_TYPE_JIRA)
        }), [
        extensionDataValue,
        extensionPayload,
        loadingComponent
    ]);
    const createRetryFunction = (0, $7jTnu.fg)('forge_missing_analytics_attributes_for_fcf') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eJOHy.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (fieldValue)=>async ()=>{
            try {
                setFieldState({
                    fieldId: extensionData.fieldId,
                    status: (0, $dfc00c8d0d7fbcf9$export$f81c1d6b9217380c)
                });
                requestsCount.current += 1;
                const submitValue = await Promise.resolve(fieldValue);
                onSubmit(submitValue);
                requestsCount.current -= 1;
                if (requestsCount.current === 0) setFieldState({
                    fieldId: extensionData.fieldId,
                    status: (0, $dfc00c8d0d7fbcf9$export$9956c6a700e724c4)
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                setFieldState({
                    fieldId: extensionData.fieldId,
                    status: (0, $dfc00c8d0d7fbcf9$export$742c877aeb0f3dbd)
                });
                (0, $8mGAP.fireOperationalEditFailedEvent)(extensionData.renderContext, {
                    ...analyticsAttributes,
                    error: error,
                    isInline: true
                });
            }
            return undefined;
        }, [
        onSubmit,
        extensionData,
        setFieldState,
        analyticsAttributes
    ]) : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eJOHy.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (fieldValue)=>async ()=>{
            try {
                setFieldState({
                    fieldId: extensionData.fieldId,
                    status: (0, $dfc00c8d0d7fbcf9$export$f81c1d6b9217380c)
                });
                requestsCount.current += 1;
                const submitValue = await Promise.resolve(fieldValue);
                onSubmit(submitValue);
                requestsCount.current -= 1;
                if (requestsCount.current === 0) setFieldState({
                    fieldId: extensionData.fieldId,
                    status: (0, $dfc00c8d0d7fbcf9$export$9956c6a700e724c4)
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                setFieldState({
                    fieldId: extensionData.fieldId,
                    status: (0, $dfc00c8d0d7fbcf9$export$742c877aeb0f3dbd)
                });
                (0, $8mGAP.fireOperationalEditFailedEvent)(extensionData.renderContext, {
                    error: error,
                    isInline: true
                });
            }
            return undefined;
        }, [
        onSubmit,
        extensionData,
        setFieldState
    ]);
    let submit;
    if ((0, $7jTnu.fg)('fcf-new-submit-on-gic-and-tv')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    submit = (0, $cZueg.useForgeCustomFieldStateSync)({
        onSubmit: onSubmit,
        containerRef: containerRef,
        fieldId: restProps.extensionData.fieldId
    }).submit;
    else // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    submit = (0, $eJOHy.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    async ({ data: fieldValue })=>{
        const retryFunction = createRetryFunction(fieldValue);
        setFieldState({
            fieldId: extensionData.fieldId,
            retryFunction: retryFunction
        });
        await retryFunction();
        return undefined;
    }, [
        createRetryFunction,
        extensionData.fieldId,
        setFieldState
    ]);
    const bridge = (0, $eJOHy.useMemo)(()=>({
            submit: submit
        }), [
        submit
    ]);
    if ((0, $av1az.isNativeUiExtension)(extension, (0, $fohjD.ENTRY_POINT_EDIT)) || (0, $av1az.isCustomUIExtension)(extension, (0, $fohjD.ENTRY_POINT_EDIT))) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gRxHB.StopSubmitPropagation), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "custom-field-edit",
        fallback: null
    }, (0, $7jTnu.fg)('fcf-new-submit-on-gic-and-tv') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        ref: containerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lTzC0.LazyCustomFieldInlineEditExtension), {
        ...restProps,
        ...extraProps,
        onModalRender: onModalRender,
        onSubmit: onSubmit,
        bridge: bridge
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lTzC0.LazyCustomFieldInlineEditExtension), {
        ...restProps,
        ...extraProps,
        onModalRender: onModalRender,
        onSubmit: onSubmit,
        bridge: bridge
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gRxHB.StopSubmitPropagation), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "custom-field-inline-edit",
        fallback: loadingComponent
    }, (0, $7jTnu.fg)('fcf-new-submit-on-gic-and-tv') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        ref: containerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lTzC0.LazyCustomFieldInlineEditRenderer), {
        ...restProps,
        ...extraProps,
        onModalRender: onModalRender,
        onSubmit: onSubmit,
        bridge: bridge
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lTzC0.LazyCustomFieldInlineEditRenderer), {
        ...restProps,
        ...extraProps,
        onModalRender: onModalRender,
        onSubmit: onSubmit,
        bridge: bridge
    })));
};

});
const $dfc00c8d0d7fbcf9$export$32bbcfb76243a487 = 'FOCUSED';
const $dfc00c8d0d7fbcf9$export$f81c1d6b9217380c = 'PENDING';
const $dfc00c8d0d7fbcf9$export$2ace7d3737836262 = 'RESOLVED';
const $dfc00c8d0d7fbcf9$export$9956c6a700e724c4 = 'STORED';
const $dfc00c8d0d7fbcf9$export$742c877aeb0f3dbd = 'FAILED';
const $dfc00c8d0d7fbcf9$export$bbf78c43fa5268c8 = 'IDLE';
const $dfc00c8d0d7fbcf9$export$ae7c16bdba5e2e15 = 10000;
const $dfc00c8d0d7fbcf9$export$30daef8830f2505d = 'WAIT';
const $dfc00c8d0d7fbcf9$export$f86e250f1a7b07c8 = 'PROCEED';
const $dfc00c8d0d7fbcf9$export$e784a07a62e2e0e5 = 'TIMEOUT';

parcelRegister("cZueg", function(module, exports) {

$parcel$export(module.exports, "useForgeCustomFieldStateSync", () => $690434d5157b8145$export$874dabc3a2adff36);
/* eslint-disable no-void */ 
var $eJOHy = parcelRequire("eJOHy");

var $6hw9S = parcelRequire("6hw9S");

const $690434d5157b8145$export$874dabc3a2adff36 = ({ fieldId: fieldId, containerRef: containerRef, onSubmit: onSubmit })=>{
    const [fieldState, { setFieldState: setFieldState }] = (0, $6hw9S.useInlineField)(fieldId);
    const fieldStateRef = (0, $eJOHy.useRef)(fieldState);
    const recentSubmitIdRef = (0, $eJOHy.useRef)(Symbol('submit-id'));
    const isInFocus = (0, $eJOHy.useCallback)(()=>{
        return typeof globalThis !== 'undefined' && globalThis.document && (containerRef.current === globalThis.document.activeElement || containerRef.current?.contains(globalThis.document.activeElement));
    }, [
        containerRef
    ]);
    const syncFieldFocusState = (0, $eJOHy.useCallback)(()=>{
        if (isInFocus()) setFieldState({
            fieldId: fieldId,
            status: (0, $dfc00c8d0d7fbcf9$export$32bbcfb76243a487)
        });
        else if (fieldStateRef.current?.status === (0, $dfc00c8d0d7fbcf9$export$32bbcfb76243a487)) setFieldState({
            fieldId: fieldId,
            status: (0, $dfc00c8d0d7fbcf9$export$f81c1d6b9217380c)
        });
    }, [
        isInFocus,
        setFieldState,
        fieldId
    ]);
    /**
	 * This function is called when the form is submitted.
	 * It is used to sync the actual state of the field with our internal storage.
	 * This is necessary because the Forge fields defined using Custom UI are rendered in the iframe and not all their focus/blur events are propagated to the parent.
	 * We also want to manually trigger the blur event on the field so attached blur handlers kick in and the field's value gets submitted.
	 */ const onFormSubmit = (0, $eJOHy.useCallback)(()=>{
        syncFieldFocusState();
        if (isInFocus()) {
            const doc = typeof globalThis !== 'undefined' ? globalThis.document : undefined;
            const activeElement = doc?.activeElement;
            if (activeElement && 'blur' in activeElement && typeof activeElement.blur === 'function') activeElement.blur();
        }
    }, [
        syncFieldFocusState,
        isInFocus
    ]);
    (0, $eJOHy.useEffect)(()=>{
        setFieldState({
            onFormSubmit: onFormSubmit,
            fieldId: fieldId,
            status: (0, $dfc00c8d0d7fbcf9$export$bbf78c43fa5268c8)
        });
    }, // Keep these dependencies immutable, otherwise we are going to override the field's state.
    [
        fieldId,
        onFormSubmit,
        setFieldState
    ]);
    (0, $eJOHy.useEffect)(()=>{
        fieldStateRef.current = fieldState;
    }, [
        fieldState,
        setFieldState
    ]);
    (0, $eJOHy.useEffect)(()=>{
        syncFieldFocusState();
        // Wait for the focus to be moved to the element.
        // In case of iframes it is not immediate so we must use a slight delay.
        const delayedFieldFocusStateSync = ()=>setTimeout(syncFieldFocusState, 100);
        if (typeof globalThis !== 'undefined' && globalThis.document) globalThis.document.addEventListener('focusout', delayedFieldFocusStateSync);
        return ()=>{
            if (typeof globalThis !== 'undefined' && globalThis.document) globalThis.document.removeEventListener('focusout', delayedFieldFocusStateSync);
        };
    }, [
        syncFieldFocusState,
        fieldId
    ]);
    /**
	 * Submit bridge method implementation.
	 * It is possible for the app to programmatically submit the field multiple times.
	 * And it may be the case that they submit a promise that takes time to resolve.
	 * Because of that we need to update the state when the last pending submit is resolved.
	 */ const submit = (0, $eJOHy.useCallback)(async ({ data: data })=>{
        try {
            recentSubmitIdRef.current = Symbol('submit-id');
            const scopedSubmitId = recentSubmitIdRef.current;
            await setFieldState({
                fieldId: fieldId,
                status: (0, $dfc00c8d0d7fbcf9$export$f81c1d6b9217380c)
            });
            const resolvedValue = await Promise.resolve(data);
            if (scopedSubmitId === recentSubmitIdRef.current) {
                onSubmit(resolvedValue);
                await setFieldState({
                    fieldId: fieldId,
                    status: (0, $dfc00c8d0d7fbcf9$export$9956c6a700e724c4)
                });
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setFieldState({
                fieldId: fieldId,
                status: (0, $dfc00c8d0d7fbcf9$export$742c877aeb0f3dbd)
            });
        }
        return undefined;
    }, [
        fieldId,
        setFieldState,
        onSubmit
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            submit: submit
        }), [
        submit
    ]);
};

});

parcelRegister("jhS2q", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $18c216bd0fef0213$export$8f31e4c4a37b8e9c);
$parcel$export(module.exports, "SkeletonLayout", () => $18c216bd0fef0213$export$af3ba02ef74c9bdf);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");
const $18c216bd0fef0213$export$69f3c7f0b2b87aa2 = [];
const $18c216bd0fef0213$export$8f31e4c4a37b8e9c = ({ skeletonConfig: skeletonConfig = $18c216bd0fef0213$export$69f3c7f0b2b87aa2 })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, skeletonConfig.map(({ width: width }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($18c216bd0fef0213$var$ForgeSkeleton, {
            "data-testId": `forgeskeleton-${index}`,
            key: index,
            width: width
        })));
const $18c216bd0fef0213$export$af3ba02ef74c9bdf = ({ children: children, layout: layout })=>{
    if (!layout) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        testId: "forge-ui-async.common.ui.skeleton.box",
        xcss: $18c216bd0fef0213$var$layoutStyles
    }, children);
};
const $18c216bd0fef0213$var$shimmer = null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $18c216bd0fef0213$var$ForgeSkeleton = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1y04s53": (0, $awdRS.default)(`${__cmplp.width}%`)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsb1mcm _4t3ipxbi _19pkpxbi _5sag9cwz _1o51q7pw _tip812c5 _j7hq1nls _1pglp3kn _bfhkn82g _1itk1kpv _12vemgnk",
            __cmplp.className
        ])
    });
});
const $18c216bd0fef0213$var$layoutStyles = (0, $1DXK0.xcss)({
    paddingTop: 'space.200',
    paddingLeft: 'space.300',
    paddingRight: 'space.300'
});

});

parcelRegister("gRxHB", function(module, exports) {

$parcel$export(module.exports, "StopSubmitPropagation", () => $2550085adb77713c$export$238f56c0891e9254);

var $eJOHy = parcelRequire("eJOHy");
const $2550085adb77713c$export$e6dfd72ab29f8598 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testid": "forge-ui-async.common.ui.submit-stop-propogation-wrapper.forge-stop-propagation-wrapper",
        onSubmit: props.onSubmit
    }, props.children);
const $2550085adb77713c$export$238f56c0891e9254 = ({ children: children })=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleSubmit = (e)=>{
        e.stopPropagation();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2550085adb77713c$export$e6dfd72ab29f8598, {
        onSubmit: handleSubmit
    }, children);
};

});

parcelRegister("lTzC0", function(module, exports) {

$parcel$export(module.exports, "LazyCustomFieldInlineEditRenderer", () => $2b8d94ef93c49b7b$export$eef5130ba28e0f4e);
$parcel$export(module.exports, "LazyCustomFieldInlineEditExtension", () => $2b8d94ef93c49b7b$export$299b8ce8659dec8c);

var $aeOhE = parcelRequire("aeOhE");

var $lHD3D = parcelRequire("lHD3D");

var $9gq2c = parcelRequire("9gq2c");

var $bQWwW = parcelRequire("bQWwW");

const $2b8d94ef93c49b7b$var$getModule = ()=>(0, $lHD3D.measureInitialPageLoadAsyncResourcesTiming)((0, $9gq2c.PERFORMANCE_KEYS).MARKS.ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_START, (0, $9gq2c.PERFORMANCE_KEYS).MARKS.ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_END, ()=>(parcelRequire("7QzYl")));

const $2b8d94ef93c49b7b$var$getForgeExtensionModule = ()=>(0, $lHD3D.measureInitialPageLoadAsyncResourcesTiming)((0, $9gq2c.PERFORMANCE_KEYS).MARKS.ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_START, (0, $9gq2c.PERFORMANCE_KEYS).MARKS.ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_END, ()=>(parcelRequire("6g6vk")));
const $2b8d94ef93c49b7b$export$eef5130ba28e0f4e = (0, $aeOhE.withMetrics)(// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $bQWwW.lazyForPaint)(()=>$2b8d94ef93c49b7b$var$getModule().then((module)=>module.CustomFieldInlineEdit), {
    ssr: false
}));
const $2b8d94ef93c49b7b$export$299b8ce8659dec8c = (0, $aeOhE.withMetrics)(// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $bQWwW.lazyForPaint)(()=>$2b8d94ef93c49b7b$var$getForgeExtensionModule().then((module)=>module.CustomFieldInlineEdit), {
    ssr: false
}));

});
parcelRegister("7QzYl", function(module, exports) {

let $5b694b162e390c78$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $5b694b162e390c78$var$load("3yAl4"),
    $5b694b162e390c78$var$load("axvph")
]).then(()=>parcelRequire('kDfjQ'));

});

parcelRegister("6g6vk", function(module, exports) {

let $48e94853b8d04500$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $48e94853b8d04500$var$load("76n7a"),
    $48e94853b8d04500$var$load("l253H"),
    $48e94853b8d04500$var$load("ffQaD"),
    $48e94853b8d04500$var$load("kvRbA"),
    $48e94853b8d04500$var$load("kNFvF"),
    $48e94853b8d04500$var$load("3yAl4"),
    $48e94853b8d04500$var$load("5RoHW")
]).then(()=>parcelRequire('kKtg3'));

});



parcelRegister("d4jEd", function(module, exports) {

$parcel$export(module.exports, "LazyCustomFieldInlineEditIssueView", () => $24025f7a212600ba$export$9929b4973c13a82f);

var $eJOHy = parcelRequire("eJOHy");

var $bILK0 = parcelRequire("bILK0");

var $fohjD = parcelRequire("fohjD");

var $av1az = parcelRequire("av1az");

var $ch9En = parcelRequire("ch9En");

var $7jTnu = parcelRequire("7jTnu");

var $jhS2q = parcelRequire("jhS2q");

var $gRxHB = parcelRequire("gRxHB");

var $5shme = parcelRequire("5shme");

var $lTzC0 = parcelRequire("lTzC0");
const $24025f7a212600ba$var$skeletonConfig = [
    {
        width: 100
    }
];
const $24025f7a212600ba$export$9929b4973c13a82f = ({ onSave: onSave, onCancel: onCancel, onConfirm: onConfirm, onRender: onRender, ...restProps })=>{
    const { extension: extension, extensionData: extensionData, extensionPayload: extensionPayload } = restProps;
    const { showFlag: showFlag } = (0, $bILK0.useFlagsService)();
    const loadingComponent = (0, $eJOHy.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jhS2q.Skeleton), {
            skeletonConfig: $24025f7a212600ba$var$skeletonConfig
        }), []);
    const extensionDataValue = (0, $eJOHy.useMemo)(()=>{
        const preparedExtensionData = extensionData?.issue && extensionData?.project ? extensionData : {
            fieldType: extensionData.fieldType,
            fieldId: extensionData.fieldId,
            fieldName: extensionData.fieldName,
            renderContext: extensionData.renderContext,
            ...(0, $7jTnu.fg)('ditto-fcf-support-new-manifest-on-frontend') && {
                experience: extensionData.experience
            }
        };
        return {
            ...preparedExtensionData,
            type: extension.type,
            entryPoint: (0, $fohjD.ENTRY_POINT_EDIT),
            isInline: true
        };
    }, [
        extension.type,
        extensionData
    ]);
    const extraProps = (0, $eJOHy.useMemo)(()=>({
            loadingComponent: loadingComponent,
            module: (0, $fohjD.CUSTOM_FIELD_MODULE),
            entryPoint: (0, $fohjD.ENTRY_POINT_EDIT),
            extensionData: extensionDataValue,
            extensionPayload: extensionPayload,
            contextToken: (0, $fohjD.CONTEXT_TOKEN_TYPE_JIRA)
        }), [
        extensionDataValue,
        extensionPayload,
        loadingComponent
    ]);
    const submit = (0, $eJOHy.useCallback)(({ data: fieldValue })=>(0, $5shme.onCustomFieldSubmit)(fieldValue, onSave, onConfirm, showFlag), // todo SMT-491 onConfirm, onSave (fieldId) was changing every time component tree was changed by Bento issue view.
    // root cause - Bento's connect-field is creating onConfirm function and fieldId every time. More in mentioned ticket
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        showFlag
    ]);
    const close = onCancel;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const bridge = (0, $eJOHy.useMemo)(()=>({
            submit: submit,
            close: close
        }), [
        submit,
        close
    ]);
    if ((0, $av1az.isNativeUiExtension)(extension, (0, $fohjD.ENTRY_POINT_EDIT)) || (0, $av1az.isCustomUIExtension)(extension, (0, $fohjD.ENTRY_POINT_EDIT))) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gRxHB.StopSubmitPropagation), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "custom-field-edit",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lTzC0.LazyCustomFieldInlineEditExtension), {
        ...restProps,
        ...extraProps,
        onCancel: onCancel,
        onLoad: onRender,
        onRender: onRender,
        bridge: bridge
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gRxHB.StopSubmitPropagation), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "custom-field-edit",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lTzC0.LazyCustomFieldInlineEditRenderer), {
        ...restProps,
        ...extraProps,
        onRender: onRender,
        onCancel: onCancel,
        bridge: bridge
    })));
};

});
parcelRegister("5shme", function(module, exports) {

$parcel$export(module.exports, "onCustomFieldSubmit", () => $d9bfd8e0a6bde05c$export$fc8c2ed652969e74);

var $1uIew = parcelRequire("1uIew");

var $8J9xj = parcelRequire("8J9xj");
const $d9bfd8e0a6bde05c$export$fc8c2ed652969e74 = (fieldValue, onSave, onConfirm, showFlag)=>onSave(fieldValue).then((response)=>{
        if (response == null) return;
        // The error is handled in the catch block
        if ('error' in response) {
            if (response.error) throw response.error;
        } else onConfirm(response.data);
    }).catch((error)=>{
        showFlag((0, $8J9xj.default)(error));
        // Custom UI depends on this error to get know whether the form was successfully submitted or not
        if ((0, $1uIew.isValidationError)(error)) throw error;
        throw Error(`Unable to save custom field, error: ${error.message}`);
    });

});
parcelRegister("8J9xj", function(module, exports) {

$parcel$export(module.exports, "default", () => $c677eb749ad3bc35$export$2e2bcd8739ae039);

var $1uIew = parcelRequire("1uIew");

var $fcQZX = parcelRequire("fcQZX");

var $61CWe = parcelRequire("61CWe");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c677eb749ad3bc35$export$2e2bcd8739ae039 = (error)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $1uIew.isValidationError)(error) ? (0, $61CWe.default)(error.errors) : (0, $fcQZX.default)();

});
parcelRegister("fcQZX", function(module, exports) {

$parcel$export(module.exports, "default", () => $74ca76e904be5213$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $74ca76e904be5213$var$messages = (0, $7qGN1.defineMessages)({
    title: {
        "id": "forge-ui.common.flags.custom-field.edit-failed.generic-error.title",
        "defaultMessage": "We were unable to edit this custom field. Please try again."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$74ca76e904be5213$export$2e2bcd8739ae039 = ()=>({
        type: 'error',
        title: $74ca76e904be5213$var$messages.title,
        isAutoDismiss: false,
        messageId: 'forge-ui.common.ui.flags.custom-field.edit-failed.generic-error',
        messageType: 'transactional'
    });

});

parcelRegister("61CWe", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e4de95e24b200b1$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $4e4de95e24b200b1$var$messages = (0, $7qGN1.defineMessages)({
    title: {
        "id": "forge-ui.common.flags.custom-field.edit-failed.validation-error.title",
        "defaultMessage": "Validation error"
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4e4de95e24b200b1$export$2e2bcd8739ae039 = (errors)=>({
        type: 'error',
        title: $4e4de95e24b200b1$var$messages.title,
        description: errors.map(({ error: error })=>error).join(', '),
        isAutoDismiss: false,
        messageId: 'forge-ui.common.ui.flags.custom-field.edit-failed.validation-error',
        messageType: 'transactional'
    });

});





parcelRegister("87MEE", function(module, exports) {

$parcel$export(module.exports, "ErrorPanel", () => $ed9e0f7815c98c33$export$9f3dc18e1adf5d8f);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $iHPvF = parcelRequire("iHPvF");
var $akOEX = parcelRequire("akOEX");

var $7ep4S = parcelRequire("7ep4S");

var $lRq8t = parcelRequire("lRq8t");

var $2Ydb0 = parcelRequire("2Ydb0");
const $ed9e0f7815c98c33$var$Loader = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ed9e0f7815c98c33$var$LoaderWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
        testId: "forge-ui-renderers.common.ui.error-panel.forge-app-loading-spinner",
        size: "large"
    }));
const $ed9e0f7815c98c33$export$9f3dc18e1adf5d8f = ({ error: error, onRetry: onRetry })=>{
    const { message: message, errorMessage: errorMessage, errorDetails: errorDetails } = error;
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(false);
    const intl = (0, $lRq8t.default)();
    const onClickStopPropagation = (0, $eJOHy.useCallback)((e)=>e.stopPropagation(), []);
    const reinitializeApp = (0, $eJOHy.useCallback)(async (e)=>{
        setIsLoading(true);
        try {
            e.stopPropagation();
            if (onRetry) await onRetry();
        } catch  {} finally{
            setIsLoading(false);
        }
    }, [
        onRetry
    ]);
    if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ed9e0f7815c98c33$var$Loader, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ed9e0f7815c98c33$var$ContentWrapper, {
        onClick: onClickStopPropagation
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iHPvF.default), {
        appearance: "error",
        title: message,
        actions: onRetry ? [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $akOEX.default), {
                onClick: reinitializeApp,
                key: "refresh"
            }, intl.formatMessage((0, $2Ydb0.default).refreshApp))
        ] : []
    }, errorMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ed9e0f7815c98c33$var$ErrorMessageWrapper, null, errorMessage), errorDetails && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ed9e0f7815c98c33$var$ErrorDetailsWrapper, null, errorDetails)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ed9e0f7815c98c33$var$ContentWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsb1osq _k7zyidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ed9e0f7815c98c33$var$LoaderWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _y3gn1h6o _ca0qutpp _n3tdutpp _1bsb1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ed9e0f7815c98c33$var$ErrorMessageWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_o5721jtm",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ed9e0f7815c98c33$var$ErrorDetailsWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "pre", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_o5721jtm",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2Ydb0", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4d0241581dfac9b$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $a4d0241581dfac9b$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    refreshApp: {
        "id": "forge-ui-renderers.common.error-panel.refresh-app",
        "defaultMessage": "Refresh app"
    }
});

});


parcelRegister("g2eay", function(module, exports) {

$parcel$export(module.exports, "transformValue", () => $2f095fec1bed5469$export$98c150630afe5417);
$parcel$export(module.exports, "transformValueToExtensionData", () => $2f095fec1bed5469$export$b82f09291a00d8c1);

var $3JeUC = parcelRequire("3JeUC");

var $gPU3b = parcelRequire("gPU3b");

var $d9U9f = parcelRequire("d9U9f");
const $2f095fec1bed5469$export$98c150630afe5417 = (value, extension)=>{
    const { properties: { type: type, collection: collection } } = extension;
    switch(type){
        case 'string':
            if (collection === 'list' && Array.isArray(value)) // @ts-expect-error - TS2322 - Type 'Option[]' is not assignable to type 'ForgeCustomFieldValue'. | TS2345 - Argument of type 'string[] | User[] | Group[]' is not assignable to parameter of type 'LabelsValue'.
            return (0, $3JeUC.mapDataToLabelOptions)(value);
            return value;
        case 'object':
            return JSON.stringify(value);
        case 'user':
            if (value != null) // @ts-expect-error - TS2345 - Argument of type 'string | number | string[] | User | Group | { [key: string]: unknown; } | User[] | Group[]' is not assignable to parameter of type 'JiraUser | JiraUser[]'.
            return $2f095fec1bed5469$export$26760e7b66ccf1e1(value);
            return value;
        default:
            return value;
    }
};
const $2f095fec1bed5469$export$b82f09291a00d8c1 = (value, extension)=>{
    const type = extension?.properties?.type;
    const collection = extension?.properties?.collection;
    switch(type){
        case 'string':
            if (collection === 'list' && Array.isArray(value)) // @ts-expect-error - TS2345 - Argument of type 'ForgeCustomFieldValue' is not assignable to parameter of type 'Option[]'.
            return (0, $3JeUC.mapLabelOptionsToData)(value);
            return value;
        case 'object':
            return (0, $d9U9f.transformJSONStringToObject)(value);
        case 'user':
            if (value === null) return value;
            // @ts-expect-error - TS2345 - Argument of type 'ForgeCustomFieldValue' is not assignable to parameter of type 'UserOption | UserOption[]'.
            return $2f095fec1bed5469$export$e4490ea0dfe4173f(value);
        default:
            return value;
    }
};
const $2f095fec1bed5469$export$78d71f9ed5534abe = (fieldType, modules)=>modules.find((field)=>(0, $gPU3b.isForgeLegacyFieldType)(fieldType) ? field.id === (0, $gPU3b.getExtensionIdFromLegacyFieldType)(fieldType) : field.id === fieldType);
const $2f095fec1bed5469$export$e4490ea0dfe4173f = (userOption)=>{
    if (Array.isArray(userOption)) return userOption.map((option)=>({
            accountId: option.id
        }));
    return {
        accountId: userOption.id
    };
};
const $2f095fec1bed5469$export$3e406786572c35b0 = (userData)=>({
        id: userData.accountId || '',
        name: userData.name || '',
        avatarUrl: userData.picture || ''
    });
const $2f095fec1bed5469$export$26760e7b66ccf1e1 = (defaultValue)=>{
    if (Array.isArray(defaultValue)) return defaultValue.map($2f095fec1bed5469$export$3e406786572c35b0);
    return $2f095fec1bed5469$export$3e406786572c35b0(defaultValue);
};

});
parcelRegister("3JeUC", function(module, exports) {

$parcel$export(module.exports, "mapDataToLabelOptions", () => $67d8e6e44df4054f$export$cd8e373d5b1325b1);
$parcel$export(module.exports, "mapLabelOptionsToData", () => $67d8e6e44df4054f$export$1bf703d99c7bcef6);
$parcel$export(module.exports, "mapLabelOptionsToLabelPropertiesForJWMForm", () => $67d8e6e44df4054f$export$2671c63dacb16e09);
$parcel$export(module.exports, "mapLabelOptionsToLabelData", () => $67d8e6e44df4054f$export$58b6e7301c3c290b);
$parcel$export(module.exports, "mapLabelsResponseToLabelOptions", () => $67d8e6e44df4054f$export$37f55c1f665c1221);

var $cNNNb = parcelRequire("cNNNb");
const $67d8e6e44df4054f$export$cd8e373d5b1325b1 = (data)=>{
    if (!data) return [];
    return data.map((value)=>{
        if (typeof value !== 'string') return {
            value: value.name,
            label: value.name,
            ...value.color ? {
                color: value.color
            } : {}
        };
        return {
            value: value,
            label: value
        };
    });
};
const $67d8e6e44df4054f$export$1bf703d99c7bcef6 = (options)=>options.map(({ value: value })=>value);
const $67d8e6e44df4054f$export$2671c63dacb16e09 = (options)=>{
    const labels = [];
    const labelProperties = options?.map((option)=>{
        // @ts-expect-error - ts2322 - Type 'ReactNode' is not assignable to type 'string'.
        const optionLabel = option?.label;
        labels.push(optionLabel);
        if (option?.color) return {
            name: optionLabel,
            color: option?.color
        };
        return {
            name: optionLabel,
            ...option?.__isNew__ ? {
                color: (0, $cNNNb.GREY_META).name
            } : {}
        };
    });
    return {
        labels: labels,
        labelProperties: labelProperties
    };
};
const $67d8e6e44df4054f$export$58b6e7301c3c290b = (options)=>{
    return [
        {
            operation: 'edit',
            value: options?.map(({ label: label, color: color, __isNew__: __isNew__ })=>{
                if (color) return {
                    name: label,
                    color: color
                };
                return {
                    name: label,
                    ...__isNew__ ? {
                        color: (0, $cNNNb.GREY_META).name
                    } : {}
                };
            })
        },
        {
            operation: 'set',
            value: options?.map((option)=>option.label)
        }
    ];
};
const $67d8e6e44df4054f$export$37f55c1f665c1221 = (response)=>{
    const { suggestions: suggestions } = response;
    if (!suggestions) return [];
    return suggestions.map(({ label: label, color: color })=>({
            label: label,
            value: label,
            ...color ? {
                color: color
            } : {}
        }));
};

});
parcelRegister("cNNNb", function(module, exports) {

$parcel$export(module.exports, "GREY_META", () => $711a16afce0bfcb3$export$11b75436f568ab00);
$parcel$export(module.exports, "CHECK_MARK_COLOR_DARK", () => $711a16afce0bfcb3$export$270aee965367aeb3);
$parcel$export(module.exports, "CHECK_MARK_COLOR_LIGHT", () => $711a16afce0bfcb3$export$941ef40ef5fdd2b1);
$parcel$export(module.exports, "OPTION_COLOR_THEMES", () => $711a16afce0bfcb3$export$7f42563469df7e01);
$parcel$export(module.exports, "OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT", () => $711a16afce0bfcb3$export$2c649adf8351b065);
$parcel$export(module.exports, "OPTION_COLOR_THEMES_COLORFUL_DARKER_SINGLE_SELECT", () => $711a16afce0bfcb3$export$20b2b274810f728a);
$parcel$export(module.exports, "OPTION_COLOR_THEMES_MAP", () => $711a16afce0bfcb3$export$7c14120abebd4749);

var $isE62 = parcelRequire("isE62");
const $711a16afce0bfcb3$var$GREY_LIGHTEST_META = {
    name: 'GREY_LIGHTEST',
    backgroundColor: "var(--ds-background-neutral, #091E420F)",
    textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
    messageLabel: (0, $isE62.default).greyLightest
};
const $711a16afce0bfcb3$var$GREY_LIGHTER_META = {
    name: 'GREY_LIGHTER',
    backgroundColor: "var(--ds-background-neutral-hovered, #091E4224)",
    textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
    messageLabel: (0, $isE62.default).greyLighter
};
const $711a16afce0bfcb3$export$11b75436f568ab00 = {
    name: 'GREY',
    tagColor: 'grey',
    backgroundColor: "var(--ds-background-neutral-pressed, #091E424F)",
    textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
    messageLabel: (0, $isE62.default).grey
};
const $711a16afce0bfcb3$var$GREY_DARKER_META = {
    name: 'GREY_DARKER',
    tagColor: 'greyDarker',
    backgroundColor: "var(--ds-background-neutral-bold, #44546F)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).greyDarker
};
const $711a16afce0bfcb3$var$GREY_DARKEST_META = {
    name: 'GREY_DARKEST',
    backgroundColor: "var(--ds-background-neutral-bold-pressed, #172B4D)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).greyDarkest
};
const $711a16afce0bfcb3$var$PURPLE_LIGHTEST_META = {
    name: 'PURPLE_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-purple-subtlest, #F3F0FF)",
    textColor: "var(--ds-text-accent-purple-bolder, #352C63)",
    messageLabel: (0, $isE62.default).purpleLightest
};
const $711a16afce0bfcb3$var$PURPLE_LIGHTER_META = {
    name: 'PURPLE_LIGHTER',
    backgroundColor: "var(--ds-background-accent-purple-subtler, #DFD8FD)",
    textColor: "var(--ds-text-accent-purple-bolder, #352C63)",
    messageLabel: (0, $isE62.default).purpleLighter
};
const $711a16afce0bfcb3$var$PURPLE_META = {
    name: 'PURPLE',
    tagColor: 'purple',
    backgroundColor: "var(--ds-background-accent-purple-subtle, #9F8FEF)",
    textColor: "var(--ds-text-accent-purple-bolder, #352C63)",
    messageLabel: (0, $isE62.default).purple
};
const $711a16afce0bfcb3$export$7c314e2461a7241b = {
    name: 'PURPLE_DARKER',
    backgroundColor: "var(--ds-text-accent-purple, #5E4DB2)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).purpleDarker
};
const $711a16afce0bfcb3$var$PURPLE_DARKEST_META = {
    name: 'PURPLE_DARKEST',
    backgroundColor: "var(--ds-text-accent-purple-bolder, #352C63)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).purpleDarkest
};
const $711a16afce0bfcb3$var$BLUE_LIGHTEST_META = {
    name: 'BLUE_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-blue-subtlest, #E9F2FF)",
    textColor: "var(--ds-text-accent-blue-bolder, #09326C)",
    messageLabel: (0, $isE62.default).blueLightest
};
const $711a16afce0bfcb3$var$BLUE_LIGHTER_META = {
    name: 'BLUE_LIGHTER',
    backgroundColor: "var(--ds-background-accent-blue-subtler, #CCE0FF)",
    textColor: "var(--ds-text-accent-blue-bolder, #09326C)",
    messageLabel: (0, $isE62.default).blueLighter
};
const $711a16afce0bfcb3$var$BLUE_META = {
    name: 'BLUE',
    backgroundColor: "var(--ds-background-accent-blue-subtle, #579DFF)",
    textColor: "var(--ds-text-accent-blue-bolder, #09326C)",
    messageLabel: (0, $isE62.default).blue
};
const $711a16afce0bfcb3$var$BLUE_DARKER_META = {
    name: 'BLUE_DARKER',
    backgroundColor: "var(--ds-text-accent-blue, #0055CC)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).blueDarker
};
const $711a16afce0bfcb3$export$69c4eac71b813fba = {
    name: 'BLUE_DARKEST',
    backgroundColor: "var(--ds-text-accent-blue-bolder, #09326C)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).blueDarkest
};
const $711a16afce0bfcb3$var$TEAL_LIGHTEST_META = {
    name: 'TEAL_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
    textColor: "var(--ds-text-accent-teal-bolder, #164555)",
    messageLabel: (0, $isE62.default).tealLightest
};
const $711a16afce0bfcb3$var$TEAL_LIGHTER_META = {
    name: 'TEAL_LIGHTER',
    backgroundColor: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    textColor: "var(--ds-text-accent-teal-bolder, #164555)",
    messageLabel: (0, $isE62.default).tealLighter
};
const $711a16afce0bfcb3$var$TEAL_META = {
    name: 'TEAL',
    tagColor: 'teal',
    backgroundColor: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    textColor: "var(--ds-text-accent-teal-bolder, #164555)",
    messageLabel: (0, $isE62.default).teal
};
const $711a16afce0bfcb3$export$6daaa1cc3f46f41 = {
    name: 'TEAL_DARKER',
    backgroundColor: "var(--ds-text-accent-teal, #206A83)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).tealDarker
};
const $711a16afce0bfcb3$var$TEAL_DARKEST_META = {
    name: 'TEAL_DARKEST',
    backgroundColor: "var(--ds-text-accent-teal-bolder, #164555)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).tealDarkest
};
const $711a16afce0bfcb3$var$GREEN_LIGHTEST_META = {
    name: 'GREEN_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-green-subtlest, #DCFFF1)",
    textColor: "var(--ds-text-accent-green-bolder, #164B35)",
    messageLabel: (0, $isE62.default).greenLightest
};
const $711a16afce0bfcb3$var$GREEN_LIGHTER_META = {
    name: 'GREEN_LIGHTER',
    backgroundColor: "var(--ds-background-accent-green-subtler, #BAF3DB)",
    textColor: "var(--ds-text-accent-green-bolder, #164B35)",
    messageLabel: (0, $isE62.default).greenLighter
};
const $711a16afce0bfcb3$var$GREEN_META = {
    name: 'GREEN',
    tagColor: 'green',
    backgroundColor: "var(--ds-background-accent-green-subtle, #4BCE97)",
    textColor: "var(--ds-text-accent-green-bolder, #164B35)",
    messageLabel: (0, $isE62.default).green
};
const $711a16afce0bfcb3$var$GREEN_DARKER_META = {
    name: 'GREEN_DARKER',
    backgroundColor: "var(--ds-background-accent-green-bolder, #1F845A)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).greenDarker
};
const $711a16afce0bfcb3$var$GREEN_DARKEST_META = {
    name: 'GREEN_DARKEST',
    backgroundColor: "var(--ds-text-accent-green-bolder, #164B35)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).greenDarkest
};
const $711a16afce0bfcb3$var$LIME_LIGHTEST_META = {
    name: 'LIME_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-lime-subtlest, #EFFFD6)",
    textColor: "var(--ds-text-accent-lime-bolder, #37471F)",
    messageLabel: (0, $isE62.default).limeLightest
};
const $711a16afce0bfcb3$var$LIME_LIGHTER_META = {
    name: 'LIME_LIGHTER',
    backgroundColor: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    textColor: "var(--ds-text-accent-lime-bolder, #37471F)",
    messageLabel: (0, $isE62.default).limeLighter
};
const $711a16afce0bfcb3$var$LIME_META = {
    name: 'LIME',
    backgroundColor: "var(--ds-background-accent-lime-subtle, #94C748)",
    textColor: "var(--ds-text-accent-lime-bolder, #37471F)",
    messageLabel: (0, $isE62.default).lime
};
const $711a16afce0bfcb3$var$LIME_DARKER_META = {
    name: 'LIME_DARKER',
    backgroundColor: "var(--ds-text-accent-lime, #4C6B1F)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).limeDarker
};
const $711a16afce0bfcb3$var$LIME_DARKEST_META = {
    name: 'LIME_DARKEST',
    backgroundColor: "var(--ds-text-accent-lime-bolder, #37471F)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).limeDarkest
};
const $711a16afce0bfcb3$var$YELLOW_LIGHTEST_META = {
    name: 'YELLOW_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-yellow-subtlest, #FFF7D6)",
    textColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
    messageLabel: (0, $isE62.default).yellowLightest
};
const $711a16afce0bfcb3$var$YELLOW_LIGHTER_META = {
    name: 'YELLOW_LIGHTER',
    backgroundColor: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
    textColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
    messageLabel: (0, $isE62.default).yellowLighter
};
const $711a16afce0bfcb3$var$YELLOW_META = {
    name: 'YELLOW',
    tagColor: 'yellow',
    backgroundColor: "var(--ds-background-accent-yellow-subtle, #F5CD47)",
    textColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
    messageLabel: (0, $isE62.default).yellow
};
const $711a16afce0bfcb3$var$YELLOW_DARKER_META = {
    name: 'YELLOW_DARKER',
    backgroundColor: "var(--ds-text-accent-yellow, #7F5F01)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).yellowDarker
};
const $711a16afce0bfcb3$var$YELLOW_DARKEST_META = {
    name: 'YELLOW_DARKEST',
    backgroundColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).yellowDarkest
};
const $711a16afce0bfcb3$var$ORANGE_LIGHTEST_META = {
    name: 'ORANGE_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-orange-subtlest, #FFF3EB)",
    textColor: "var(--ds-text-accent-orange-bolder, #702E00)",
    messageLabel: (0, $isE62.default).orangeLightest
};
const $711a16afce0bfcb3$var$ORANGE_LIGHTER_META = {
    name: 'ORANGE_LIGHTER',
    backgroundColor: "var(--ds-background-accent-orange-subtler, #FEDEC8)",
    textColor: "var(--ds-text-accent-orange-bolder, #702E00)",
    messageLabel: (0, $isE62.default).orangeLighter
};
const $711a16afce0bfcb3$var$ORANGE_META = {
    name: 'ORANGE',
    tagColor: 'orange',
    backgroundColor: "var(--ds-background-accent-orange-subtle, #FEA362)",
    textColor: "var(--ds-text-accent-orange-bolder, #702E00)",
    messageLabel: (0, $isE62.default).orange
};
const $711a16afce0bfcb3$var$ORANGE_DARKER_META = {
    name: 'ORANGE_DARKER',
    backgroundColor: "var(--ds-background-accent-orange-bolder, #C25100)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).orangeDarker
};
const $711a16afce0bfcb3$var$ORANGE_DARKEST_META = {
    name: 'ORANGE_DARKEST',
    backgroundColor: "var(--ds-text-accent-orange-bolder, #702E00)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).orangeDarkest
};
const $711a16afce0bfcb3$var$RED_LIGHTEST_META = {
    name: 'RED_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-red-subtlest, #FFECEB)",
    textColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
    messageLabel: (0, $isE62.default).redLightest
};
const $711a16afce0bfcb3$var$RED_LIGHTER_META = {
    name: 'RED_LIGHTER',
    backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
    textColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
    messageLabel: (0, $isE62.default).redLighter
};
const $711a16afce0bfcb3$var$RED_META = {
    name: 'RED',
    tagColor: 'red',
    backgroundColor: "var(--ds-background-accent-red-subtle, #F87168)",
    textColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
    messageLabel: (0, $isE62.default).red
};
const $711a16afce0bfcb3$var$RED_DARKER_META = {
    name: 'RED_DARKER',
    backgroundColor: "var(--ds-background-accent-red-bolder, #C9372C)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).redDarker
};
const $711a16afce0bfcb3$var$RED_DARKEST_META = {
    name: 'RED_DARKEST',
    backgroundColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).redDarkest
};
const $711a16afce0bfcb3$var$MAGENTA_LIGHTEST_META = {
    name: 'MAGENTA_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    textColor: "var(--ds-text-accent-magenta-bolder, #50253F)",
    messageLabel: (0, $isE62.default).magentaLightest
};
const $711a16afce0bfcb3$var$MAGENTA_LIGHTER_META = {
    name: 'MAGENTA_LIGHTER',
    backgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    textColor: "var(--ds-text-accent-magenta-bolder, #50253F)",
    messageLabel: (0, $isE62.default).magentaLighter
};
const $711a16afce0bfcb3$var$MAGENTA_META = {
    name: 'MAGENTA',
    tagColor: 'magenta',
    backgroundColor: "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    textColor: "var(--ds-text-accent-magenta-bolder, #50253F)",
    messageLabel: (0, $isE62.default).magenta
};
const $711a16afce0bfcb3$var$MAGENTA_DARKER_META = {
    name: 'MAGENTA_DARKER',
    backgroundColor: "var(--ds-text-accent-magenta, #943D73)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).magentaDarker
};
const $711a16afce0bfcb3$var$MAGENTA_DARKEST_META = {
    name: 'MAGENTA_DARKEST',
    backgroundColor: "var(--ds-text-accent-magenta-bolder, #50253F)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $isE62.default).magentaDarkest
};
const $711a16afce0bfcb3$export$270aee965367aeb3 = "var(--ds-text-inverse, #FFFFFF)";
const $711a16afce0bfcb3$export$941ef40ef5fdd2b1 = "var(--ds-text, #172B4D)";
const $711a16afce0bfcb3$export$7f42563469df7e01 = [
    $711a16afce0bfcb3$var$GREY_LIGHTEST_META,
    $711a16afce0bfcb3$var$PURPLE_LIGHTEST_META,
    $711a16afce0bfcb3$var$BLUE_LIGHTEST_META,
    $711a16afce0bfcb3$var$TEAL_LIGHTEST_META,
    $711a16afce0bfcb3$var$GREEN_LIGHTEST_META,
    $711a16afce0bfcb3$var$LIME_LIGHTEST_META,
    $711a16afce0bfcb3$var$YELLOW_LIGHTEST_META,
    $711a16afce0bfcb3$var$ORANGE_LIGHTEST_META,
    $711a16afce0bfcb3$var$RED_LIGHTEST_META,
    $711a16afce0bfcb3$var$MAGENTA_LIGHTEST_META,
    $711a16afce0bfcb3$var$GREY_LIGHTER_META,
    $711a16afce0bfcb3$var$PURPLE_LIGHTER_META,
    $711a16afce0bfcb3$var$BLUE_LIGHTER_META,
    $711a16afce0bfcb3$var$TEAL_LIGHTER_META,
    $711a16afce0bfcb3$var$GREEN_LIGHTER_META,
    $711a16afce0bfcb3$var$LIME_LIGHTER_META,
    $711a16afce0bfcb3$var$YELLOW_LIGHTER_META,
    $711a16afce0bfcb3$var$ORANGE_LIGHTER_META,
    $711a16afce0bfcb3$var$RED_LIGHTER_META,
    $711a16afce0bfcb3$var$MAGENTA_LIGHTER_META,
    $711a16afce0bfcb3$export$11b75436f568ab00,
    $711a16afce0bfcb3$var$PURPLE_META,
    $711a16afce0bfcb3$var$BLUE_META,
    $711a16afce0bfcb3$var$TEAL_META,
    $711a16afce0bfcb3$var$GREEN_META,
    $711a16afce0bfcb3$var$LIME_META,
    $711a16afce0bfcb3$var$YELLOW_META,
    $711a16afce0bfcb3$var$ORANGE_META,
    $711a16afce0bfcb3$var$RED_META,
    $711a16afce0bfcb3$var$MAGENTA_META,
    $711a16afce0bfcb3$var$GREY_DARKER_META,
    $711a16afce0bfcb3$export$7c314e2461a7241b,
    $711a16afce0bfcb3$var$BLUE_DARKER_META,
    $711a16afce0bfcb3$export$6daaa1cc3f46f41,
    $711a16afce0bfcb3$var$GREEN_DARKER_META,
    $711a16afce0bfcb3$var$LIME_DARKER_META,
    $711a16afce0bfcb3$var$YELLOW_DARKER_META,
    $711a16afce0bfcb3$var$ORANGE_DARKER_META,
    $711a16afce0bfcb3$var$RED_DARKER_META,
    $711a16afce0bfcb3$var$MAGENTA_DARKER_META,
    $711a16afce0bfcb3$var$GREY_DARKEST_META,
    $711a16afce0bfcb3$var$PURPLE_DARKEST_META,
    $711a16afce0bfcb3$export$69c4eac71b813fba,
    $711a16afce0bfcb3$var$TEAL_DARKEST_META,
    $711a16afce0bfcb3$var$GREEN_DARKEST_META,
    $711a16afce0bfcb3$var$LIME_DARKEST_META,
    $711a16afce0bfcb3$var$YELLOW_DARKEST_META,
    $711a16afce0bfcb3$var$ORANGE_DARKEST_META,
    $711a16afce0bfcb3$var$RED_DARKEST_META,
    $711a16afce0bfcb3$var$MAGENTA_DARKEST_META
];
const $711a16afce0bfcb3$export$2c649adf8351b065 = [
    $711a16afce0bfcb3$var$PURPLE_META,
    $711a16afce0bfcb3$var$YELLOW_META,
    $711a16afce0bfcb3$var$GREEN_META,
    $711a16afce0bfcb3$var$TEAL_META,
    $711a16afce0bfcb3$var$RED_META,
    $711a16afce0bfcb3$var$ORANGE_META,
    $711a16afce0bfcb3$var$MAGENTA_META,
    $711a16afce0bfcb3$var$GREY_DARKER_META,
    $711a16afce0bfcb3$export$11b75436f568ab00
];
const $711a16afce0bfcb3$var$OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT_MAP = {};
$711a16afce0bfcb3$export$2c649adf8351b065.forEach((option)=>{
    $711a16afce0bfcb3$var$OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT_MAP[option.name] = option;
});
const $711a16afce0bfcb3$export$20b2b274810f728a = [
    $711a16afce0bfcb3$export$7c314e2461a7241b,
    $711a16afce0bfcb3$var$YELLOW_DARKER_META,
    $711a16afce0bfcb3$var$GREEN_DARKER_META,
    $711a16afce0bfcb3$export$6daaa1cc3f46f41,
    $711a16afce0bfcb3$var$RED_DARKER_META,
    $711a16afce0bfcb3$var$ORANGE_DARKER_META,
    $711a16afce0bfcb3$var$MAGENTA_DARKER_META,
    $711a16afce0bfcb3$var$GREY_DARKER_META,
    $711a16afce0bfcb3$var$GREY_DARKEST_META
];
const $711a16afce0bfcb3$export$7c14120abebd4749 = {};
$711a16afce0bfcb3$export$7f42563469df7e01.forEach((option)=>{
    $711a16afce0bfcb3$export$7c14120abebd4749[option.name] = option;
});

});
parcelRegister("isE62", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ddc0b3065e46f63$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $2ddc0b3065e46f63$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    greyLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.grey-lightest",
        "defaultMessage": "Grey lightest"
    },
    greyLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.grey-lighter",
        "defaultMessage": "Grey lighter"
    },
    grey: {
        "id": "@atlassian/jira-option-color-picker.color-picker.grey",
        "defaultMessage": "Grey"
    },
    greyDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.grey-darker",
        "defaultMessage": "Grey darker"
    },
    greyDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.grey-darkest",
        "defaultMessage": "Grey darkest"
    },
    purpleLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.purple-lightest",
        "defaultMessage": "Purple lightest"
    },
    purpleLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.purple-lighter",
        "defaultMessage": "Purple lighter"
    },
    purple: {
        "id": "@atlassian/jira-option-color-picker.color-picker.purple",
        "defaultMessage": "Purple"
    },
    purpleDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.purple-darker",
        "defaultMessage": "Purple darker"
    },
    purpleDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.purple-darkest",
        "defaultMessage": "Purple darkest"
    },
    blueLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.blue-lightest",
        "defaultMessage": "Blue lightest"
    },
    blueLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.blue-lighter",
        "defaultMessage": "Blue lighter"
    },
    blue: {
        "id": "@atlassian/jira-option-color-picker.color-picker.blue",
        "defaultMessage": "Blue"
    },
    blueDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.blue-darker",
        "defaultMessage": "Blue darker"
    },
    blueDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.blue-darkest",
        "defaultMessage": "Blue darkest"
    },
    tealLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.teal-lightest",
        "defaultMessage": "Teal lightest"
    },
    tealLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.teal-lighter",
        "defaultMessage": "Teal lighter"
    },
    teal: {
        "id": "@atlassian/jira-option-color-picker.color-picker.teal",
        "defaultMessage": "Teal"
    },
    tealDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.teal-darker",
        "defaultMessage": "Teal darker"
    },
    tealDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.teal-darkest",
        "defaultMessage": "Teal darkest"
    },
    greenLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.green-lightest",
        "defaultMessage": "Green lightest"
    },
    greenLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.green-lighter",
        "defaultMessage": "Green lighter"
    },
    green: {
        "id": "@atlassian/jira-option-color-picker.color-picker.green",
        "defaultMessage": "Green"
    },
    greenDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.green-darker",
        "defaultMessage": "Green darker"
    },
    greenDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.green-darkest",
        "defaultMessage": "Green darkest"
    },
    limeLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.lime-lightest",
        "defaultMessage": "Lime lightest"
    },
    limeLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.lime-lighter",
        "defaultMessage": "Lime lighter"
    },
    lime: {
        "id": "@atlassian/jira-option-color-picker.color-picker.lime",
        "defaultMessage": "Lime"
    },
    limeDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.lime-darker",
        "defaultMessage": "Lime darker"
    },
    limeDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.lime-darkest",
        "defaultMessage": "Lime darkest"
    },
    yellowLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.yellow-lightest",
        "defaultMessage": "Yellow lightest"
    },
    yellowLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.yellow-lighter",
        "defaultMessage": "Yellow lighter"
    },
    yellow: {
        "id": "@atlassian/jira-option-color-picker.color-picker.yellow",
        "defaultMessage": "Yellow"
    },
    yellowDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.yellow-darker",
        "defaultMessage": "Yellow darker"
    },
    yellowDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.yellow-darkest",
        "defaultMessage": "Yellow darkest"
    },
    orangeLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.orange-lightest",
        "defaultMessage": "Orange lightest"
    },
    orangeLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.orange-lighter",
        "defaultMessage": "Orange lighter"
    },
    orange: {
        "id": "@atlassian/jira-option-color-picker.color-picker.orange",
        "defaultMessage": "Orange"
    },
    orangeDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.orange-darker",
        "defaultMessage": "Orange darker"
    },
    orangeDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.orange-darkest",
        "defaultMessage": "Orange darkest"
    },
    redLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.red-lightest",
        "defaultMessage": "Red lightest"
    },
    redLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.red-lighter",
        "defaultMessage": "Red lighter"
    },
    red: {
        "id": "@atlassian/jira-option-color-picker.color-picker.red",
        "defaultMessage": "Red"
    },
    redDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.red-darker",
        "defaultMessage": "Red darker"
    },
    redDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.red-darkest",
        "defaultMessage": "Red darkest"
    },
    magentaLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.magenta-lightest",
        "defaultMessage": "Magenta lightest"
    },
    magentaLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.magenta-lighter",
        "defaultMessage": "Magenta lighter"
    },
    magenta: {
        "id": "@atlassian/jira-option-color-picker.color-picker.magenta",
        "defaultMessage": "Magenta"
    },
    magentaDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.magenta-darker",
        "defaultMessage": "Magenta darker"
    },
    magentaDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.magenta-darkest",
        "defaultMessage": "Magenta darkest"
    }
});

});



parcelRegister("d9U9f", function(module, exports) {

$parcel$export(module.exports, "transformJSONStringToObject", () => $e10661d44f6a4a54$export$2de59005e10fd82);

var $l5Z0K = parcelRequire("l5Z0K");
const $e10661d44f6a4a54$export$2de59005e10fd82 = (value)=>{
    try {
        return (0, (/*@__PURE__*/$parcel$interopDefault($l5Z0K)))(value) ? JSON.parse(value) : value;
    } catch  {
        return value;
    }
};

});


parcelRegister("2GpiD", function(module, exports) {

$parcel$export(module.exports, "default", () => $7899873009060702$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $7899873009060702$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    modalModeErrorTitle: {
        "id": "forge-field-base.form.edit.modal-mode-error-title",
        "defaultMessage": "We couldn't show this extension"
    },
    modalModeErrorDescription: {
        "id": "forge-field-base.form.edit.modal-mode-error-description",
        "defaultMessage": "Contact the app vendor to update the app."
    }
});

});


parcelRegister("aXssw", function(module, exports) {

$parcel$export(module.exports, "ForgeFieldMessage", () => $abc3a08e1fe6cf12$export$1df6b326181f4cdf);

var $eJOHy = parcelRequire("eJOHy");

var $fKXve = parcelRequire("fKXve");

var $8IeH1 = parcelRequire("8IeH1");

var $7ep4S = parcelRequire("7ep4S");


var $6hw9S = parcelRequire("6hw9S");

var $lRq8t = parcelRequire("lRq8t");

var $3kxux = parcelRequire("3kxux");

var $7fDLu = parcelRequire("7fDLu");
const $abc3a08e1fe6cf12$var$ErrorView = ({ fieldId: fieldId })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fKXve.ErrorMessage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        paddingInlineEnd: "space.050"
    }, formatMessage((0, $7fDLu.default).forgeFieldErrorTextLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3kxux.ForgeFieldDispatchButton), {
        fieldId: fieldId
    }));
};
const $abc3a08e1fe6cf12$var$HelperView = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fKXve.HelperMessage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        paddingInlineEnd: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
        size: "small"
    })), formatMessage((0, $7fDLu.default).forgeFieldPendingTextLabel));
};
const $abc3a08e1fe6cf12$var$SuccessView = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fKXve.ValidMessage), null, formatMessage((0, $7fDLu.default).forgeFieldSuccessTextLabel));
};
const $abc3a08e1fe6cf12$export$1df6b326181f4cdf = (props)=>{
    const failedErrorMessageAppeared = (0, $eJOHy.useRef)(false);
    const { fieldId: fieldId, renderFieldMessage: renderFieldMessage, error: error } = props;
    const [fieldState] = (0, $6hw9S.useInlineField)(fieldId);
    const renderDefaultErrorMessage = ()=>{
        if (renderFieldMessage !== null) return renderFieldMessage(error);
        return null;
    };
    if (error !== undefined) return renderDefaultErrorMessage();
    if (failedErrorMessageAppeared.current) {
        if (renderFieldMessage != null) switch(fieldState?.status){
            case 0, $dfc00c8d0d7fbcf9$export$742c877aeb0f3dbd:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($abc3a08e1fe6cf12$var$ErrorView, {
                    fieldId: fieldId
                });
            case 0, $dfc00c8d0d7fbcf9$export$9956c6a700e724c4:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($abc3a08e1fe6cf12$var$SuccessView, null);
            case 0, $dfc00c8d0d7fbcf9$export$f81c1d6b9217380c:
            case 0, $dfc00c8d0d7fbcf9$export$2ace7d3737836262:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($abc3a08e1fe6cf12$var$HelperView, null);
            default:
                return renderDefaultErrorMessage();
        }
        return null;
    }
    if (fieldState?.status === (0, $dfc00c8d0d7fbcf9$export$742c877aeb0f3dbd)) {
        failedErrorMessageAppeared.current = true;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($abc3a08e1fe6cf12$var$ErrorView, {
            fieldId: fieldId
        });
    }
    return renderDefaultErrorMessage();
};

});
parcelRegister("3kxux", function(module, exports) {

$parcel$export(module.exports, "ForgeFieldDispatchButton", () => $ea413c1684091612$export$59e3aafda495153);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");


var $6hw9S = parcelRequire("6hw9S");

var $lRq8t = parcelRequire("lRq8t");

var $iGSa4 = parcelRequire("iGSa4");
const $ea413c1684091612$export$59e3aafda495153 = (props)=>{
    const { fieldId: fieldId } = props;
    const [fieldState, { dispatchRetryFunction: dispatchRetryFunction }] = (0, $6hw9S.useInlineField)(fieldId);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const onClickHandler = async ()=>{
        if (fieldId !== undefined) await dispatchRetryFunction(fieldId);
    };
    const renderRetryButton = ()=>{
        if (fieldState !== undefined && fieldState?.status === (0, $dfc00c8d0d7fbcf9$export$742c877aeb0f3dbd)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            spacing: "none",
            appearance: "link",
            onClick: onClickHandler
        }, formatMessage((0, $iGSa4.default).forgeRetryButton));
        return null;
    };
    return renderRetryButton();
};

});
parcelRegister("iGSa4", function(module, exports) {

$parcel$export(module.exports, "default", () => $31b4ff9244244a61$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $31b4ff9244244a61$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    forgeRetryButton: {
        "id": "forge-field-base.form.field-message.field-dispatch-button.forge-retry-button",
        "defaultMessage": "Try again?"
    }
});

});


parcelRegister("7fDLu", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ba3262d0ae9aa4f$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $6ba3262d0ae9aa4f$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    forgeFieldErrorTextLabel: {
        "id": "forge-field-base.form.field-message.forge-field-error-text-label",
        "defaultMessage": "We couldn't save the value of this custom field."
    },
    forgeFieldSuccessTextLabel: {
        "id": "forge-field-base.form.field-message.forge-field-success-text-label",
        "defaultMessage": "Custom field value saved."
    },
    forgeFieldPendingTextLabel: {
        "id": "forge-field-base.form.field-message.forge-field-pending-text-label",
        "defaultMessage": "Saving custom field value."
    }
});

});



parcelRegister("fSIfd", function(module, exports) {

$parcel$export(module.exports, "ForgeField", () => $e702f65717048bec$export$34a15d6027142c62);

var $eJOHy = parcelRequire("eJOHy");

var $aeOhE = parcelRequire("aeOhE");

var $52lsd = parcelRequire("52lsd");

var $efBOp = parcelRequire("efBOp");

var $ljej9 = parcelRequire("ljej9");

var $7jTnu = parcelRequire("7jTnu");

var $gPU3b = parcelRequire("gPU3b");

var $gPU3b = parcelRequire("gPU3b");

var $112vq = parcelRequire("112vq");

var $krRBx = parcelRequire("krRBx");

var $5HtX6 = parcelRequire("5HtX6");


var $ldwED = parcelRequire("ldwED");
const $e702f65717048bec$export$4f0175d9150f8767 = ({ fieldType: fieldType, fieldName: fieldName, fieldId: fieldId, fieldProps: fieldProps, error: error, selectedProject: selectedProject, selectedIssueType: selectedIssueType, extension: extension, renderDefaultComponent: renderDefaultComponent })=>{
    const { onChange: onChange, value: value } = fieldProps;
    const extensionPayload = (0, $eJOHy.useMemo)(()=>{
        if (value === undefined) return {
            fieldValue: null
        };
        return {
            fieldValue: (0, $ldwED.transformValueToExtensionData)(value, extension)
        };
    }, [
        extension,
        value
    ]);
    const extensionData = (0, $eJOHy.useMemo)(()=>{
        const defaultExtensionData = {
            fieldId: fieldId,
            fieldType: (0, $gPU3b.isForgeLegacyFieldType)(fieldType) ? (0, $gPU3b.getExtensionIdFromLegacyFieldType)(fieldType) ?? fieldType : fieldType,
            fieldName: fieldName,
            renderContext: 'issue-create',
            ...(0, $7jTnu.fg)('ditto-fcf-support-new-manifest-on-frontend') && {
                experience: 'issue-create'
            }
        };
        if (!selectedProject || !selectedIssueType) return defaultExtensionData;
        const issueTypeId = (0, $ljej9.toIssueTypeId)(selectedIssueType.type === (0, $0c0dad85e5f0b556$export$92ab80c1dc9baf44) ? selectedIssueType.issueTypeId : selectedIssueType.value);
        return {
            ...defaultExtensionData,
            project: {
                id: (0, $ljej9.toProjectId)(selectedProject.value),
                key: (0, $ljej9.toProjectKey)(selectedProject.projectKey),
                type: selectedProject.projectType
            },
            issue: {
                type: selectedIssueType.type === (0, $0c0dad85e5f0b556$export$92ab80c1dc9baf44) && selectedIssueType.issueTypeName || selectedIssueType.label,
                typeId: issueTypeId
            }
        };
    }, [
        selectedProject,
        selectedIssueType,
        fieldId,
        fieldName,
        fieldType
    ]);
    const analyticsAttributes = (0, $eJOHy.useMemo)(()=>({
            renderContext: 'issue-create',
            fieldType: extension?.properties.type,
            module: extension?.type,
            ...extension ? (0, $52lsd.getAnalyticsAttributesFromExtension)(extension) : {}
        }), [
        extension
    ]);
    if (!extension) return null;
    const renderDefaultView = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, renderDefaultComponent(fieldProps, error), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aeOhE.ForgeScreenEvent), {
            attributes: {
                ...analyticsAttributes,
                renderMode: 'default'
            }
        }));
    if ((0, $7jTnu.fg)('ditto-fcf-support-new-manifest-on-frontend')) {
        if ((0, $gPU3b.isBuiltInJiraFieldRender)(extension, 'edit', 'issue-create')) return renderDefaultView();
    } else if (!extension.properties.edit) return renderDefaultView();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $112vq.EditMode), {
        extension: extension,
        extensionData: extensionData,
        extensionPayload: extensionPayload,
        analyticsAttributes: analyticsAttributes,
        onChange: onChange
    });
};
const $e702f65717048bec$export$34a15d6027142c62 = (props)=>{
    const { renderFieldMessage: renderFieldMessage, ...rest } = props;
    const { fieldId: fieldId, extension: extension, error: error } = rest;
    const analyticsAttributes = (0, $eJOHy.useMemo)(()=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        ({
            renderContext: 'issue-create',
            ...extension && (0, $52lsd.getAnalyticsAttributesFromExtension)(extension)
        }), [
        extension
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $efBOp.EditAnalyticsWrapper), {
        attributes: analyticsAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $krRBx.FieldContainer), {
        width: "100%"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e702f65717048bec$export$4f0175d9150f8767, rest), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5HtX6.ForgeFieldMessage), {
        error: error,
        fieldId: fieldId,
        renderFieldMessage: renderFieldMessage
    })));
};

});
parcelRegister("112vq", function(module, exports) {

$parcel$export(module.exports, "EditMode", () => $23cb62edf428b96d$export$5304145354a3bee9);

var $eJOHy = parcelRequire("eJOHy");

var $eSnSE = parcelRequire("eSnSE");

var $52lsd = parcelRequire("52lsd");

var $8mGAP = parcelRequire("8mGAP");

var $efBOp = parcelRequire("efBOp");

var $87XVk = parcelRequire("87XVk");

var $87MEE = parcelRequire("87MEE");

var $lRq8t = parcelRequire("lRq8t");

var $ldwED = parcelRequire("ldwED");

var $dsAn6 = parcelRequire("dsAn6");
const $23cb62edf428b96d$export$ba588b5cce278e96 = ({ extension: extension, extensionData: extensionData, extensionPayload: extensionPayload, analyticsAttributes: analyticsAttributes, onChange: onChange })=>{
    const [isModalMode, setIsModalMode] = (0, $eJOHy.useState)(false);
    const intl = (0, $lRq8t.default)();
    const onEditConfirm = (0, $eJOHy.useCallback)((newValue)=>{
        onChange((0, $ldwED.transformValue)(newValue, extension));
        (0, $8mGAP.fireTrackEditedEvent)('issue-create', analyticsAttributes);
    }, [
        extension,
        analyticsAttributes,
        onChange
    ]);
    const onModalRender = (0, $eJOHy.useCallback)(()=>setIsModalMode(true), []);
    if (isModalMode) {
        // temporary for UI Kit version of 1.2.0 when inline edit is not supported
        // will be fixed with https://ecosystem-platform.atlassian.net/browse/ARKEN-32
        const translatedError = {
            message: intl.formatMessage((0, $dsAn6.default).modalModeErrorTitle),
            errorMessage: intl.formatMessage((0, $dsAn6.default).modalModeErrorDescription)
        };
        (0, $eSnSE.default).safeErrorWithoutCustomerData('jiraForgeUI.customFieldEdit', 'App tried to render modal expierience on issue create', {
            ...analyticsAttributes,
            extension: JSON.stringify(extension)
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $87MEE.ErrorPanel), {
            error: translatedError
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $87XVk.AsyncCustomFieldInlineEdit), {
        extension: extension,
        extensionData: extensionData,
        analyticsAttributes: analyticsAttributes,
        extensionPayload: extensionPayload,
        onSubmit: onEditConfirm,
        onModalRender: onModalRender
    });
};
const $23cb62edf428b96d$export$5304145354a3bee9 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $efBOp.EditAnalyticsWrapper), {
        attributes: (0, $52lsd.getAnalyticsAttributesFromExtension)(props.extension)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($23cb62edf428b96d$export$ba588b5cce278e96, props));

});
parcelRegister("ldwED", function(module, exports) {

$parcel$export(module.exports, "transformValue", () => $4d9f51518be03e10$export$98c150630afe5417);
$parcel$export(module.exports, "transformValueToExtensionData", () => $4d9f51518be03e10$export$b82f09291a00d8c1);
$parcel$export(module.exports, "getExtension", () => $4d9f51518be03e10$export$78d71f9ed5534abe);

var $3JeUC = parcelRequire("3JeUC");

var $7jTnu = parcelRequire("7jTnu");

var $gPU3b = parcelRequire("gPU3b");

var $7gFRm = parcelRequire("7gFRm");
const $4d9f51518be03e10$export$98c150630afe5417 = (value, extension)=>{
    const { properties: { type: type, collection: collection } } = extension;
    switch(type){
        case 'string':
            if (collection === 'list' && Array.isArray(value)) // @ts-expect-error - TS2322 - Type 'Option[]' is not assignable to type 'ForgeCustomFieldValue'. | TS2345 - Argument of type 'string[] | User[] | Group[]' is not assignable to parameter of type 'LabelsValue'.
            return (0, $3JeUC.mapDataToLabelOptions)(value);
            return value;
        case 'number':
            if ((0, $7jTnu.fg)('fcf_required_number_fix_on_gic')) // The form coming from atlaskit expects number-type fields to
            // submit a string value, therefore we need to transform it.
            // The value is later sent in a payload as a number for issue create request
            return value != null ? String(value) : value;
            return value;
        case 'object':
            return value != null ? JSON.stringify(value) : value;
        case 'user':
            if (value != null) // @ts-expect-error - TS2345 - Argument of type 'string | number | string[] | User | Group | { [key: string]: unknown; } | User[] | Group[]' is not assignable to parameter of type 'JiraUser | JiraUser[]'.
            return $4d9f51518be03e10$export$26760e7b66ccf1e1(value);
            return value;
        default:
            return value;
    }
};
const $4d9f51518be03e10$export$b82f09291a00d8c1 = (value, extension)=>{
    const type = extension?.properties?.type;
    const collection = extension?.properties?.collection;
    switch(type){
        case 'string':
            if (collection === 'list' && Array.isArray(value)) // @ts-expect-error - TS2345 - Argument of type 'ForgeCustomFieldValue' is not assignable to parameter of type 'Option[]'.
            return (0, $3JeUC.mapLabelOptionsToData)(value);
            return value;
        case 'object':
            return (0, $7gFRm.transformJSONStringToObject)(value);
        case 'user':
            if (value === null) return value;
            // @ts-expect-error - TS2345 - Argument of type 'ForgeCustomFieldValue' is not assignable to parameter of type 'UserOption | UserOption[]'.
            return $4d9f51518be03e10$export$e4490ea0dfe4173f(value);
        default:
            return value;
    }
};
const $4d9f51518be03e10$export$78d71f9ed5534abe = (fieldType, modules)=>modules.find((field)=>(0, $gPU3b.isForgeLegacyFieldType)(fieldType) ? field.id === (0, $gPU3b.getExtensionIdFromLegacyFieldType)(fieldType) : field.id === fieldType);
const $4d9f51518be03e10$export$e4490ea0dfe4173f = (userOption)=>{
    if (Array.isArray(userOption)) return userOption.map((option)=>({
            accountId: option.id
        }));
    return {
        accountId: userOption.id
    };
};
const $4d9f51518be03e10$export$3e406786572c35b0 = (userData)=>({
        id: userData.accountId || '',
        name: userData.name || '',
        avatarUrl: userData.picture || ''
    });
const $4d9f51518be03e10$export$26760e7b66ccf1e1 = (defaultValue)=>{
    if (Array.isArray(defaultValue)) return defaultValue.map($4d9f51518be03e10$export$3e406786572c35b0);
    return $4d9f51518be03e10$export$3e406786572c35b0(defaultValue);
};

});
parcelRegister("7gFRm", function(module, exports) {

$parcel$export(module.exports, "transformJSONStringToObject", () => $aabd622256fd6033$export$2de59005e10fd82);

var $l5Z0K = parcelRequire("l5Z0K");
const $aabd622256fd6033$export$2de59005e10fd82 = (value)=>{
    try {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($l5Z0K)))(value) && JSON.parse(value)) return JSON.parse(value);
    } catch (e) {
        return value;
    }
    return value;
};

});


parcelRegister("dsAn6", function(module, exports) {

$parcel$export(module.exports, "default", () => $978492a3537dca48$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $978492a3537dca48$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    modalModeErrorTitle: {
        "id": "issue-create-commons.common.forge.edit.modal-mode-error-title",
        "defaultMessage": "We couldn't show this extension"
    },
    modalModeErrorDescription: {
        "id": "issue-create-commons.common.forge.edit.modal-mode-error-description",
        "defaultMessage": "Contact the app vendor to update the app."
    }
});

});


parcelRegister("krRBx", function(module, exports) {

$parcel$export(module.exports, "FieldContainer", () => $c1f4d37802f46fd0$export$b5c4b0e7cd7f148b);
/* FieldContainer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");
const $c1f4d37802f46fd0$export$b5c4b0e7cd7f148b = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { marginTop: marginTop, paddingBottom: paddingBottom, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1r250ak": (0, $awdRS.default)(typeof (__cmplp.width ?? 350) === 'number' ? `${__cmplp.width ?? 350}px` : __cmplp.width ?? 350),
            "--_1glwpqj": (0, $awdRS.default)(`${__cmplp.marginTop ?? 0}px`),
            "--_1i3s0vn": (0, $awdRS.default)(`${__cmplp.paddingBottom ?? 0}px`)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsbuo76 _19pknek2 _n3td11zn",
            __cmplp.className
        ])
    });
});

});

parcelRegister("5HtX6", function(module, exports) {

$parcel$export(module.exports, "ForgeFieldMessage", () => $419becf05f95e394$export$1df6b326181f4cdf);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $fKXve = parcelRequire("fKXve");

var $7ep4S = parcelRequire("7ep4S");


var $6hw9S = parcelRequire("6hw9S");

var $lRq8t = parcelRequire("lRq8t");

var $2I3Tf = parcelRequire("2I3Tf");

var $dOJuQ = parcelRequire("dOJuQ");
const $419becf05f95e394$export$1df6b326181f4cdf = (props)=>{
    const failedErrorMessageAppeared = (0, $eJOHy.useRef)(false);
    const { error: error, fieldId: fieldId, renderFieldMessage: renderFieldMessage } = props;
    const [fieldState] = (0, $6hw9S.useInlineField)(fieldId);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const renderErrorMessage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fKXve.ErrorMessage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($419becf05f95e394$var$MessagePartsSeparationWrapper, null, formatMessage((0, $dOJuQ.default).forgeFieldErrorTextLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2I3Tf.ForgeFieldDispatchButton), {
            fieldId: fieldId
        }));
    const renderSuccessMessage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fKXve.ValidMessage), null, formatMessage((0, $dOJuQ.default).forgeFieldSuccessTextLabel));
    const renderHelperMessage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fKXve.HelperMessage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($419becf05f95e394$var$MessagePartsSeparationWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
            size: "small"
        })), formatMessage((0, $dOJuQ.default).forgeFieldPendingTextLabel));
    const renderDefaultErrorMessage = ()=>{
        if (renderFieldMessage !== undefined && renderFieldMessage !== null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, renderFieldMessage(error));
        return null;
    };
    if (error !== undefined) return renderDefaultErrorMessage();
    if (failedErrorMessageAppeared.current) {
        if (renderFieldMessage !== undefined && renderFieldMessage !== null) switch(fieldState?.status){
            case 0, $dfc00c8d0d7fbcf9$export$742c877aeb0f3dbd:
                return renderErrorMessage();
            case 0, $dfc00c8d0d7fbcf9$export$9956c6a700e724c4:
                return renderSuccessMessage();
            case 0, $dfc00c8d0d7fbcf9$export$f81c1d6b9217380c:
            case 0, $dfc00c8d0d7fbcf9$export$2ace7d3737836262:
                return renderHelperMessage();
            default:
                return renderDefaultErrorMessage();
        }
        return null;
    }
    if (fieldState?.status === (0, $dfc00c8d0d7fbcf9$export$742c877aeb0f3dbd)) {
        failedErrorMessageAppeared.current = true;
        return renderErrorMessage();
    }
    return renderDefaultErrorMessage();
};
// For now, it only gives some space between the spinner and the message
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $419becf05f95e394$var$MessagePartsSeparationWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_u5f31b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2I3Tf", function(module, exports) {

$parcel$export(module.exports, "ForgeFieldDispatchButton", () => $3e290481ec973583$export$59e3aafda495153);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");


var $6hw9S = parcelRequire("6hw9S");
const $3e290481ec973583$export$59e3aafda495153 = (props)=>{
    const { fieldId: fieldId } = props;
    const [fieldState, { dispatchRetryFunction: dispatchRetryFunction }] = (0, $6hw9S.useInlineField)(fieldId);
    const onClickHandler = async ()=>{
        if (fieldId !== undefined) await dispatchRetryFunction(fieldId);
    };
    const renderRetryButton = ()=>{
        if (fieldState !== undefined && fieldState?.status === (0, $dfc00c8d0d7fbcf9$export$742c877aeb0f3dbd)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            spacing: "none",
            appearance: "link",
            onClick: onClickHandler
        }, "Try again?");
        return null;
    };
    return renderRetryButton();
};

});

parcelRegister("dOJuQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $de389f0169674bf0$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $de389f0169674bf0$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    forgeFieldErrorTextLabel: {
        "id": "issue-create-commons.common.forge.forge-field-message.forge-field-error-text-label",
        "defaultMessage": "We couldn't save the value of this custom field."
    },
    forgeFieldSuccessTextLabel: {
        "id": "issue-create-commons.common.forge.forge-field-message.forge-field-success-text-label",
        "defaultMessage": "Custom field value saved."
    },
    forgeFieldPendingTextLabel: {
        "id": "issue-create-commons.common.forge.forge-field-message.forge-field-pending-text-label",
        "defaultMessage": "Saving custom field value."
    }
});

});


// itsm practices - copied from src/packages/issue-create/issue-create-common-types/src/common/types/index.tsx
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $0c0dad85e5f0b556$var$SERVICE_REQUEST = 'SERVICE_REQUEST';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $0c0dad85e5f0b556$var$INCIDENT_MANAGEMENT = 'INCIDENT_MANAGEMENT';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $0c0dad85e5f0b556$var$PROBLEM_MANAGEMENT = 'PROBLEM_MANAGEMENT';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $0c0dad85e5f0b556$var$CHANGE_MANAGEMENT = 'CHANGE_MANAGEMENT';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $0c0dad85e5f0b556$var$POST_INCIDENT_REVIEW = 'POST_INCIDENT_REVIEW';
// cs practice
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $0c0dad85e5f0b556$var$DEVELOPER_ESCALATION = 'DEVELOPER_ESCALATION';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $0c0dad85e5f0b556$var$UNASSIGNED_REQUEST_TYPE = 'UNASSIGNED_REQUEST_TYPE';
const $0c0dad85e5f0b556$export$92ab80c1dc9baf44 = 'REQUEST_TYPE';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $0c0dad85e5f0b556$var$ISSUE_TYPE = 'ISSUE_TYPE';


parcelRegister("duCer", function(module, exports) {

$parcel$export(module.exports, "reportForgeFailure", () => $5b59ccd9ae719bd9$export$e95b9e5003024a9c);

var $8mGAP = parcelRequire("8mGAP");

var $gPU3b = parcelRequire("gPU3b");
const $5b59ccd9ae719bd9$export$e95b9e5003024a9c = (fieldType, modules, filteredOutModules)=>{
    const isExtensionFilteredOut = filteredOutModules.some((field)=>(0, $gPU3b.isForgeLegacyFieldType)(fieldType) ? field.id === (0, $gPU3b.getExtensionIdFromLegacyFieldType)(fieldType) : field.id === fieldType);
    const isEmptyForgeData = modules.length === 0 && filteredOutModules.length === 0;
    /*
        Not log error:
         * if the extensions is filtered out by display conditions or access narrowing
         * if the forge data is empty (when fetching error there is an excluded error, empty response is returned)
    */ if (isEmptyForgeData || isExtensionFilteredOut) return;
    (0, $8mGAP.fireOperationalFailedEvent)('issue-create', {
        error: Error('Forge extension passed to ForgeCustomField component is null or undefined'),
        renderContext: 'issue-create'
    });
};

});

parcelRegister("dxW4o", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundaryBypassProvider", () => $ddff54f0f13f9119$export$a5feb4d632b53009);
$parcel$export(module.exports, "ErrorBoundaryBypassInput", () => $ddff54f0f13f9119$export$36798a6d5688c318);
$parcel$export(module.exports, "ErrorBoundaryBypassOutput", () => $ddff54f0f13f9119$export$775be62266860b86);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
const $ddff54f0f13f9119$var$ErrorBoundaryBypassApiContext = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $ddff54f0f13f9119$var$ErrorBoundaryBypassErrorContext = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $ddff54f0f13f9119$export$a5feb4d632b53009 = ({ children: children })=>{
    const [bypassedError, setBypassedError] = (0, $eJOHy.useState)(null);
    const api = (0, $eJOHy.useMemo)(()=>({
            swallowError: (error)=>{
                setBypassedError(error);
            }
        }), []);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($ddff54f0f13f9119$var$ErrorBoundaryBypassErrorContext.Provider, {
        value: bypassedError,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($ddff54f0f13f9119$var$ErrorBoundaryBypassApiContext.Provider, {
            value: api,
            children: children
        })
    });
};
class $ddff54f0f13f9119$export$36798a6d5688c318 extends (0, $eJOHy.Component) {
    static getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true
        };
    }
    componentDidCatch(error) {
        if (this.context !== null) this.context.swallowError(error);
    }
    static{
        this.contextType = $ddff54f0f13f9119$var$ErrorBoundaryBypassApiContext;
    }
    render() {
        if (this.state.hasError) return null;
        return this.props.children;
    }
    constructor(...args){
        super(...args), this.state = {
            hasError: false
        };
    }
}
const $ddff54f0f13f9119$export$775be62266860b86 = ()=>{
    const bypassedError = (0, $eJOHy.useContext)($ddff54f0f13f9119$var$ErrorBoundaryBypassErrorContext);
    if (bypassedError !== null) throw bypassedError;
    return null;
};

});

parcelRegister("mWfDl", function(module, exports) {

$parcel$export(module.exports, "FieldBusyIndicator", () => $3a28af1700152607$export$cf3e115209fc94cb);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $lRq8t = parcelRequire("lRq8t");

var $jVMEg = parcelRequire("jVMEg");

var $7ep4S = parcelRequire("7ep4S");

var $k71qx = parcelRequire("k71qx");

var $83J8Z = parcelRequire("83J8Z");
const $3a28af1700152607$export$cf3e115209fc94cb = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldId: fieldId })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const loadingMessage = formatMessage((0, $83J8Z.default).fieldLevelIndicatorTooltipContent);
    const indicatorId = `issue-adjustments.ui.field-loading-indicator.${fieldId}`;
    const tooltipId = `issue-adjustments.ui.field-loading-indicator.tooltip.${fieldId}`;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
        tag: "span",
        content: loadingMessage,
        testId: tooltipId,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($3a28af1700152607$export$4e31364808fb7483, {
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jVMEg.default), {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {
                    testId: indicatorId,
                    size: "small"
                })
            })
        })
    });
});
$3a28af1700152607$export$cf3e115209fc94cb.displayName = 'FieldBusyIndicator';
const $3a28af1700152607$export$4e31364808fb7483 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_18u012x7",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jVMEg", function(module, exports) {

$parcel$export(module.exports, "default", () => $7198a9f02a598e87$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $huC5X = parcelRequire("huC5X");
function $7198a9f02a598e87$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $huC5X.default), {
        ...props
    });
}

});

parcelRegister("83J8Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $ffd3d52c3d59c768$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $ffd3d52c3d59c768$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    fieldLevelIndicatorTooltipContent: {
        id: 'issue-adjustments.field-busy-indicator.field-level-indicator-tooltip-content',
        defaultMessage: 'Loading UI modifications...',
        description: 'A tooltip message showed on UI modifications loading icon on each loading field'
    }
});

});


parcelRegister("enLyD", function(module, exports) {

$parcel$export(module.exports, "FieldValueDecoratorAsync", () => $33f1e16a439761dc$export$24545fc29fe55980);

var $eJOHy = parcelRequire("eJOHy");

var $82wKS = parcelRequire("82wKS");
var $i7n3g = parcelRequire("i7n3g");


var $8Ewlz = parcelRequire("8Ewlz");
const $33f1e16a439761dc$var$FieldValueDecoratorAsyncNoMemo = ({ children: children, fieldType: fieldType, fieldProps: fieldProps, fieldId: fieldId })=>{
    const adjustmentsAreEnabled = (0, $i7n3g.useAdjustmentsEnabled)();
    const undecoratedResult = children(fieldProps);
    if ((0, $82wKS.isFieldTypeSupported)((0, $6d500eb1fc6bc124$export$e615b7e9b8fb4715), fieldType) && adjustmentsAreEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Ewlz.EnabledFieldValueDecorator), {
        fieldProps: fieldProps,
        fieldId: fieldId,
        fieldType: fieldType
    }, children);
    return undecoratedResult;
};
const $33f1e16a439761dc$export$24545fc29fe55980 = /*#__PURE__*/ (0, $eJOHy.memo)($33f1e16a439761dc$var$FieldValueDecoratorAsyncNoMemo);

});
parcelRegister("8Ewlz", function(module, exports) {

$parcel$export(module.exports, "EnabledFieldValueDecorator", () => $bdb328c1f9d4def8$export$9d96bb1f53295b76);

var $ixrOr = parcelRequire("ixrOr");

var $BAHbx = parcelRequire("BAHbx");
const $bdb328c1f9d4def8$export$9d96bb1f53295b76 = ({ children: children, fieldId: fieldId, fieldProps: fieldProps })=>{
    const { onBlur: onBlur, onChange: onChange } = fieldProps;
    const { getFieldValue: getFieldValue } = (0, $BAHbx.useFormApi)();
    const { processChange: processChange } = (0, $ixrOr.useIssueAdjustmentsActions)();
    const processChangeByType = (eventType)=>{
        processChange({
            fieldId: fieldId,
            fieldValue: getFieldValue(fieldId),
            eventType: eventType
        });
    };
    const interceptedFieldProps = {
        ...fieldProps,
        onChange: (modifiedValue)=>{
            // Order is important to pass the current value to the UIM
            onChange(modifiedValue);
            processChangeByType('change');
        },
        onBlur: ()=>{
            // Order is important to pass the current value to the UIM
            onBlur();
            processChangeByType('blur');
        }
    };
    return children(interceptedFieldProps);
};

});
parcelRegister("BAHbx", function(module, exports) {

$parcel$export(module.exports, "FormApiProvider", () => $427250de28d30bc1$export$1e7be89a21d0c0ae);
$parcel$export(module.exports, "useFormApi", () => $427250de28d30bc1$export$4607062597b2b4df);

var $eJOHy = parcelRequire("eJOHy");
const $427250de28d30bc1$var$Context = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $427250de28d30bc1$export$1e7be89a21d0c0ae = ({ children: children, setFieldValue: setFieldValue, getFormState: getFormState })=>{
    const setFieldValueRef = (0, $eJOHy.useRef)(setFieldValue);
    setFieldValueRef.current = setFieldValue;
    const getFormStateRef = (0, $eJOHy.useRef)(getFormState);
    getFormStateRef.current = getFormState;
    const value = (0, $eJOHy.useMemo)(()=>({
            setFieldValue: (...args)=>setFieldValueRef.current(...args),
            getFieldValue: (fieldId)=>getFormStateRef.current().values[fieldId],
            getAllFieldValue: ()=>getFormStateRef.current().values
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($427250de28d30bc1$var$Context.Provider, {
        value: value
    }, children);
};
const $427250de28d30bc1$export$4607062597b2b4df = ()=>{
    const context = (0, $eJOHy.useContext)($427250de28d30bc1$var$Context);
    if (context === null) throw new Error('Missing FormApiProvider');
    return context;
};

});



parcelRegister("jHG59", function(module, exports) {

$parcel$export(module.exports, "getValueFromEventOrValue", () => $430fca88344529d5$export$a59801673b41acfd);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $430fca88344529d5$var$isEvent(event) {
    return Boolean(event && event.target);
}
function $430fca88344529d5$export$a59801673b41acfd(eventOrValue) {
    if ($430fca88344529d5$var$isEvent(eventOrValue)) {
        const { currentTarget: currentTarget } = eventOrValue;
        if (currentTarget.type === 'checkbox') {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            if (currentTarget.checked) return currentTarget.value || true;
            return currentTarget.value ? undefined : false;
        }
        if (currentTarget) return currentTarget.value;
    }
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return eventOrValue;
}

});

parcelRegister("coifs", function(module, exports) {

$parcel$export(module.exports, "FieldMessage", () => $f1b40a5373c85834$export$eb5013679a5d3f69);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $8DB98 = parcelRequire("8DB98");

var $fKXve = parcelRequire("fKXve");

var $eJ9f5 = parcelRequire("eJ9f5");

var $ix0Ab = parcelRequire("ix0Ab");

var $k71qx = parcelRequire("k71qx");

var $c9lZd = parcelRequire("c9lZd");

var $7jTnu = parcelRequire("7jTnu");

var $dTocu = parcelRequire("dTocu");

var $l7iSF = parcelRequire("l7iSF");

var $5Ldo0 = parcelRequire("5Ldo0");

var $afbvy = parcelRequire("afbvy");
const $f1b40a5373c85834$var$FieldHelpLink = /*#__PURE__*/ (0, $eJOHy.memo)(({ fieldHelpTextUrl: fieldHelpTextUrl })=>{
    const learnMoreMessage = (0, $afbvy.getLearnMoreMessage)(fieldHelpTextUrl ?? '');
    const { formatMessage: formatMessage } = (0, $dTocu.useIntlV2)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
        href: fieldHelpTextUrl,
        target: "_blank"
    }, formatMessage(learnMoreMessage));
});
const $f1b40a5373c85834$var$FieldMessageBehaviour = (props)=>{
    const { description: description = '', error: error, fieldName: fieldName, fieldHelpTextUrl: fieldHelpTextUrl = '', isMini: isMini, onLinkClickEvent: onLinkClickEvent, fieldId: fieldId } = props;
    const { formatMessage: formatMessage, formatNumber: formatNumber } = (0, $dTocu.useIntlV2)();
    const maxHeight = 22;
    const emojiProvider = (0, $c9lZd.useEmojiProvider)();
    const adfDocument = (0, $eJOHy.useMemo)(()=>{
        if (error) return null;
        return (0, $5Ldo0.convertWikiToAdf)(description);
    }, [
        description,
        error
    ]);
    if (error !== undefined && error !== false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fKXve.ErrorMessage), null, (0, $afbvy.getErrorMessage)(error, fieldName, formatMessage, formatNumber));
    if (!adfDocument && !fieldHelpTextUrl) return null;
    const getRenderer = (isTruncated = false)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ix0Ab.default // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        ), {
            document: adfDocument,
            schema: (0, $8DB98.defaultSchema),
            dataProviders: emojiProvider,
            disableHeadingIDs: true,
            featureFlags: {
                codeBidiWarnings: true,
                'code-bidi-warnings': true,
                // enables sending analytics event with renderer specific tti measurement
                // please do not clean up, this feature flag is meant to be rolled out permanently just for a fraction of users
                'renderer-tti-tracking': (0, $7jTnu.fg)('renderer_tti_tracking_jira'),
                'allow-windowed-code-block': true
            },
            maxHeight: isTruncated ? maxHeight : undefined,
            truncated: isTruncated,
            fadeOutHeight: isTruncated ? 0 : undefined,
            eventHandlers: {
                smartCard: {
                    onClick: (0, $l7iSF.onLinkClick)
                },
                link: {
                    onClick: onLinkClickEvent || (0, $l7iSF.onLinkClick)
                }
            },
            smartLinks: (0, $l7iSF.smartLinksDefault)
        });
    const getRenderedDescription = (truncatedRenderer = false)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fKXve.HelperMessage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f1b40a5373c85834$var$Description, {
            "data-testid": "issue-create-commons.common.ui.field-message.description",
            isMini: isMini,
            ...fieldId && {
                id: `${fieldId}-field-message`
            }
        }, adfDocument && getRenderer(truncatedRenderer), fieldHelpTextUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f1b40a5373c85834$var$FieldHelpLink, {
            fieldHelpTextUrl: fieldHelpTextUrl
        })));
    if (isMini) {
        if (adfDocument?.content[0]?.type === 'paragraph') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f1b40a5373c85834$var$TooltipContentContainer, null, getRenderer()),
            position: "bottom"
        }, getRenderedDescription(true));
        return null;
    }
    return getRenderedDescription();
};
const $f1b40a5373c85834$export$eb5013679a5d3f69 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f1b40a5373c85834$var$FieldMessageBehaviour, {
        key: `field-message-${props.fieldId}`,
        ...props
    });
const $f1b40a5373c85834$var$TooltipContentContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1f1h1vhk _woio15cr _13odidpf _9j7z1j89",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $f1b40a5373c85834$var$Description = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isMini: isMini, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_162p546": (0, $awdRS.default)(__cmplp.isMini && {
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
            })
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1f1hdcr7 _woio131l _13od1b66 _1pz31ynx",
            __cmplp.className
        ])
    });
});

});
parcelRegister("afbvy", function(module, exports) {

$parcel$export(module.exports, "getLearnMoreMessage", () => $c9705f33f8d0a1e2$export$2c1e5dc35269c547);
$parcel$export(module.exports, "getErrorMessage", () => $c9705f33f8d0a1e2$export$82f46aa4e6535a45);

var $epTsa = parcelRequire("epTsa");

var $3UrQk = parcelRequire("3UrQk");


var $f01rJ = parcelRequire("f01rJ");

var $5eW9r = parcelRequire("5eW9r");
const $c9705f33f8d0a1e2$export$2c1e5dc35269c547 = (fieldHelpTextUrl)=>{
    const urlSuffix = fieldHelpTextUrl.substring(fieldHelpTextUrl.lastIndexOf('#'));
    const learnMoreMessages = (0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $f01rJ.LEARN_MORE_MESSAGES_WITH_ISSUE_TERM) : (0, $f01rJ.LEARN_MORE_MESSAGES);
    if (urlSuffix in learnMoreMessages) return learnMoreMessages[urlSuffix];
    return (0, $5eW9r.default).fieldHelpTextLabel;
};
const $c9705f33f8d0a1e2$export$188aeee1ab8948d8 = (fieldHelpTextUrl, formatMessage)=>{
    const helperMessage = $c9705f33f8d0a1e2$export$2c1e5dc35269c547(fieldHelpTextUrl);
    return `[${formatMessage(helperMessage)}|${fieldHelpTextUrl}]`;
};
const $c9705f33f8d0a1e2$export$82f46aa4e6535a45 = (validationError, fieldName, formatMessage, formatNumber)=>{
    switch(validationError){
        case 0, $3UrQk.REQUIRED:
            return formatMessage((0, $5eW9r.default).requiredErrorMessage, {
                fieldName: fieldName
            });
        case 0, $84764505b39497ac$export$fd7dfa1695d325ca:
            return formatMessage((0, $5eW9r.default).labelsMaxErrorMessage, {
                MAX_ALLOWED_LABELS: formatNumber((0, $84764505b39497ac$export$1fdf850c93de8bae))
            });
        case 0, $84764505b39497ac$export$e77d629cc732976d:
            return formatMessage((0, $5eW9r.default).labelsInvalidErrorMessage, {
                MAX_LABEL_SIZE: formatNumber((0, $84764505b39497ac$export$9151073f92820ff8))
            });
        case 0, $84764505b39497ac$export$618e922e89e8bcae:
            return formatMessage((0, $5eW9r.default).stringInvalidErrorMessage, {
                fieldName: fieldName,
                MAX_STRING_SIZE: formatNumber((0, $84764505b39497ac$export$fe1a70381f6491b5))
            });
        case 0, $84764505b39497ac$export$8d30d41a8828e14f:
            return formatMessage((0, $5eW9r.default).forgeLabelsInvalidErrorMessage, {
                MAX_LABEL_SIZE: formatNumber((0, $84764505b39497ac$export$9151073f92820ff8))
            });
        default:
            return validationError;
    }
};

});
const $84764505b39497ac$export$9151073f92820ff8 = 255;
const $84764505b39497ac$export$fe1a70381f6491b5 = 255;
const $84764505b39497ac$export$1fdf850c93de8bae = 55;
const $84764505b39497ac$export$fd7dfa1695d325ca = 'MAX ALLOWED LABELS';
const $84764505b39497ac$export$e77d629cc732976d = 'LABELS INVALID';
const $84764505b39497ac$export$8d30d41a8828e14f = 'FORGE LABELS INVALID';
const $84764505b39497ac$export$618e922e89e8bcae = 'STRING_INVALID';

parcelRegister("f01rJ", function(module, exports) {

$parcel$export(module.exports, "LEARN_MORE_MESSAGES_WITH_ISSUE_TERM", () => $d64a785f6d3fe90b$export$1b2b0fc2cd5817de);
$parcel$export(module.exports, "LEARN_MORE_MESSAGES", () => $d64a785f6d3fe90b$export$eedb1bf75e1efb26);

var $5eW9r = parcelRequire("5eW9r");
const $d64a785f6d3fe90b$var$LEARN_MORE_TYPES = {
    IssueTypes: '#IssueTypes',
    PriorityLevels: '#PriorityLevels',
    ResolutionTypes: '#ResolutionTypes',
    SecurityLevels: '#SecurityLevels'
};
const $d64a785f6d3fe90b$export$1b2b0fc2cd5817de = {
    [$d64a785f6d3fe90b$var$LEARN_MORE_TYPES.IssueTypes]: (0, $5eW9r.default).fieldHelpIssueTypesIssueTermRefresh,
    [$d64a785f6d3fe90b$var$LEARN_MORE_TYPES.PriorityLevels]: (0, $5eW9r.default).fieldHelpPriorityLevels,
    [$d64a785f6d3fe90b$var$LEARN_MORE_TYPES.ResolutionTypes]: (0, $5eW9r.default).fieldHelpResolutionDefinitions,
    [$d64a785f6d3fe90b$var$LEARN_MORE_TYPES.SecurityLevels]: (0, $5eW9r.default).fieldHelpSecurityLevels
};
const $d64a785f6d3fe90b$export$eedb1bf75e1efb26 = {
    [$d64a785f6d3fe90b$var$LEARN_MORE_TYPES.IssueTypes]: (0, $5eW9r.default).fieldHelpIssueTypes,
    [$d64a785f6d3fe90b$var$LEARN_MORE_TYPES.PriorityLevels]: (0, $5eW9r.default).fieldHelpPriorityLevels,
    [$d64a785f6d3fe90b$var$LEARN_MORE_TYPES.ResolutionTypes]: (0, $5eW9r.default).fieldHelpResolutionDefinitions,
    [$d64a785f6d3fe90b$var$LEARN_MORE_TYPES.SecurityLevels]: (0, $5eW9r.default).fieldHelpSecurityLevels
};

});
parcelRegister("5eW9r", function(module, exports) {

$parcel$export(module.exports, "default", () => $0689bc60c608d140$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $0689bc60c608d140$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    requiredErrorMessage: {
        "id": "issue-create-commons.common.field-message.required-error-message",
        "defaultMessage": "{fieldName} is required"
    },
    labelsInvalidErrorMessage: {
        "id": "issue-create-commons.common.field-message.labels-invalid-error-message",
        "defaultMessage": "Labels can't have spaces or be more than {MAX_LABEL_SIZE, plural, one {# character} other {# characters}}."
    },
    stringInvalidErrorMessage: {
        "id": "issue-create-commons.common.field-message.string-invalid-error-message",
        "defaultMessage": "{fieldName} can't exceed {MAX_STRING_SIZE, plural, one {# character} other {# characters}}."
    },
    forgeLabelsInvalidErrorMessage: {
        "id": "issue-create-commons.common.field-message.forge-labels-invalid-error-message",
        "defaultMessage": "Labels can't have more than {MAX_LABEL_SIZE, plural, one {# character} other {# characters}}."
    },
    labelsMaxErrorMessage: {
        "id": "issue-create-commons.common.field-message.labels-max-error-message",
        "defaultMessage": "Can't have more than {MAX_ALLOWED_LABELS, plural, one {# label} other {# labels}}"
    },
    fieldHelpTextLabel: {
        "id": "issue-create-commons.common.field-message.field-help-text-label",
        "defaultMessage": "Learn more"
    },
    fieldHelpIssueTypes: {
        "id": "issue-create-commons.common.field-message.field-help-issue-types",
        "defaultMessage": "Learn about issue types"
    },
    fieldHelpPriorityLevels: {
        "id": "issue-create-commons.common.field-message.field-help-priority-levels",
        "defaultMessage": "Learn about priority levels"
    },
    fieldHelpResolutionDefinitions: {
        "id": "issue-create-commons.common.field-message.field-help-resolution-definitions",
        "defaultMessage": "Resolutions definitions"
    },
    fieldHelpSecurityLevels: {
        "id": "issue-create-commons.common.field-message.field-help-security-levels",
        "defaultMessage": "More on security levels"
    },
    fieldHelpIssueTypesIssueTermRefresh: {
        "id": "issue-create-commons.common.field-message.field-help-issue-types-issue-term-refresh",
        "defaultMessage": "Learn about work types"
    }
});

});




parcelRegister("4rsU2", function(module, exports) {

$parcel$export(module.exports, "FieldSkeleton", () => $720d0919b283b99b$export$f102dad4aafe4ad4);
$parcel$export(module.exports, "default", () => $720d0919b283b99b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $9A8Wt = parcelRequire("9A8Wt");

var $l9vfc = parcelRequire("l9vfc");
const $720d0919b283b99b$export$f102dad4aafe4ad4 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        // eslint-disable-next-line jira/integration/enforce-data-testid-usage
        "data-test-id": "issue-create-commons.common.ui.loader.skeleton",
        "data-testid": "issue-create-commons.common.ui.loader.skeleton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($720d0919b283b99b$var$Label, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $l9vfc.StyledFieldSkeleton), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($720d0919b283b99b$var$Description, null));
const $720d0919b283b99b$var$IssueCreateLoader = ({ skeletonCount: skeletonCount })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, Array.from({
        length: skeletonCount
    }, (_, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($720d0919b283b99b$export$f102dad4aafe4ad4, {
            key: `field-skeleton-${index}`
        })));
var $720d0919b283b99b$export$2e2bcd8739ae039 = $720d0919b283b99b$var$IssueCreateLoader;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $720d0919b283b99b$var$Label = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $9A8Wt.Skeleton), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4t3iv47k _1bsb68cl _19pkv47k _otyr12x7",
            __cmplp.className
        ])
    });
});
$720d0919b283b99b$var$Label.displayName = 'LabelSkeleton';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $720d0919b283b99b$var$Description = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $9A8Wt.Skeleton), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4t3ipxbi _1bsb1mjv",
            __cmplp.className
        ])
    });
});
$720d0919b283b99b$var$Description.displayName = 'DescriptionSkeleton';

});

parcelRegister("jq3eA", function(module, exports) {

$parcel$export(module.exports, "generateKeyForRequiredFromUIM", () => $762d1d54d833b12f$export$920d96e4692b3d51);
const $762d1d54d833b12f$export$920d96e4692b3d51 = (parameters)=>{
    const { fieldId: fieldId, isRequiredFromUIM: isRequiredFromUIM } = parameters;
    return `${fieldId}-field_${isRequiredFromUIM ? '' : 'non-'}required_from_uim`;
};

});


parcelRegister("ixdDB", function(module, exports) {

$parcel$export(module.exports, "ISSUE_CREATE_MODAL_BODY_SELECTOR", () => $c1ec507312d7c7c4$export$7c7171667037b275);
$parcel$export(module.exports, "closeMenuOnScroll", () => $c1ec507312d7c7c4$export$fe334d83c6aac80f);
// keeping it here instead of jira-issue-create to avoid cyclic dependencies.
const $c1ec507312d7c7c4$export$7c7171667037b275 = 'issue-create.ui.modal.modal-body';
const $c1ec507312d7c7c4$var$MENU_CLOSE_SELECTORS = [
    $c1ec507312d7c7c4$export$7c7171667037b275
];
const $c1ec507312d7c7c4$export$fe334d83c6aac80f = (e)=>{
    // @ts-expect-error - TS18047 -  'e.target' is possibly 'null'.
    if ($c1ec507312d7c7c4$var$MENU_CLOSE_SELECTORS.includes(e.target.id)) return true;
    return false;
};

});

parcelRegister("gfbId", function(module, exports) {

$parcel$export(module.exports, "mutateAffectedServicesField", () => $666ea9576832084f$export$c5ca3c9d905a51f0);
$parcel$export(module.exports, "transformDefaultAffectedServices", () => $666ea9576832084f$export$6f4e94c57a16128c);
$parcel$export(module.exports, "useFetchAffectedServicesName", () => $666ea9576832084f$export$9abe2f602f72a411);

var $eJOHy = parcelRequire("eJOHy");

var $eDBhy = parcelRequire("eDBhy");

var $1Ozm9 = parcelRequire("1Ozm9");

var $fGxxD = parcelRequire("fGxxD");
const $666ea9576832084f$export$c5ca3c9d905a51f0 = (selectedAffectedServices, fieldId)=>({
        affectedServicesField: {
            fieldId: fieldId,
            affectedServices: selectedAffectedServices.map(({ value: value })=>({
                    serviceId: value
                }))
        }
    });
const $666ea9576832084f$export$6f4e94c57a16128c = (defaultAffectedServices)=>defaultAffectedServices.map((service)=>({
            value: service.serviceId
        }));
const $666ea9576832084f$export$9abe2f602f72a411 = ()=>{
    const [isLoading, setLoading] = (0, $eJOHy.useState)(false);
    const handleFetch = (0, $eJOHy.useRef)((ids, setSelectedOptions)=>{
        setLoading(true);
        (0, $1Ozm9.default)('/rest/service-registry-api/service', {
            method: 'POST',
            body: JSON.stringify({
                ids: ids
            })
        }).then((response)=>{
            setLoading(false);
            setSelectedOptions((0, $fGxxD.mapServiceEntitiesToOptions)(response.services));
        }).catch((error)=>{
            setLoading(false);
            setSelectedOptions([]);
            (0, $eDBhy.fireIssueCreateErrorAnalytics)({
                meta: {
                    id: 'useFetchAffectedServicesName',
                    packageName: 'jiraIssueCreateCommons',
                    teamName: 'gryffindor'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        });
    });
    return [
        {
            isLoading: isLoading
        },
        handleFetch.current
    ];
};

});


parcelRegister("1pZVv", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6bb7b397651d319$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $k71qx = parcelRequire("k71qx");


var $5Acnt = parcelRequire("5Acnt");

var $fE4zR = parcelRequire("fE4zR");

var $l9vfc = parcelRequire("l9vfc");

var $2nXHu = parcelRequire("2nXHu");

var $ixdDB = parcelRequire("ixdDB");

var $9P44V = parcelRequire("9P44V");

const $b6bb7b397651d319$var$AssetsField = (props)=>{
    const { autoCompleteUrl: autoCompleteUrl, width: width, fieldProps: { value: value, onChange: onChange }, onCloseMenuOnScroll: // @ts-expect-error - TS2339 - Property 'onCloseMenuOnScroll' does not exist on type 'Props'.
    onCloseMenuOnScroll = (0, $ixdDB.closeMenuOnScroll), isDropdownMenuFixedAndLayered: // @ts-expect-error - TS2339 - Property 'isDropdownMenuFixedAndLayered' does not exist on type 'Props'.
    isDropdownMenuFixedAndLayered = false, error: error, fieldId: fieldId, defaultValue: defaultValue, isEditable: isEditable = true, nonEditableReason: nonEditableReason, selectedProject: selectedProject, selectedIssueType: selectedIssueType, ariaLabelledBy: ariaLabelledBy } = props;
    const [shouldFetchServiceName, setShouldFetchServiceName] = (0, $eJOHy.useState)(true);
    const [selectedOptions, setSelectedOptions] = (0, $eJOHy.useState)([]);
    const [{ isLoading: isLoading }, fetchAssetsName] = (0, $9P44V.useFetchAssetsWithId)();
    const projectId = selectedProject?.value || '';
    let issueTypeId;
    if (selectedIssueType) issueTypeId = selectedIssueType.type === (0, $4246188a36de9908$export$92ab80c1dc9baf44) ? selectedIssueType.issueTypeId : selectedIssueType.value;
    /*
	 * Fetch the asset names using the IDs from the default values that were saved
	 * */ (0, $eJOHy.useEffect)(()=>{
        if (shouldFetchServiceName && defaultValue && defaultValue.length > 0) {
            /*
			 * defaultValue will be of type AssetEntityForServer but flow gives error
			 * when trying to typecast it
			 * */ // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const ids = defaultValue.map(({ serializedOrigin: serializedOrigin })=>serializedOrigin);
            fetchAssetsName(ids, setSelectedOptions);
            setShouldFetchServiceName(false);
        } else setSelectedOptions(value);
    }, [
        defaultValue,
        fetchAssetsName,
        setSelectedOptions,
        shouldFetchServiceName,
        value
    ]);
    const getAssetsEdit = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5Acnt.default), {
            autoCompleteUrl: autoCompleteUrl,
            onChange: onChange,
            value: selectedOptions,
            fieldId: fieldId,
            isInvalid: Boolean(error),
            isDisabled: !isEditable,
            isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
            onCloseMenuOnScroll: onCloseMenuOnScroll,
            issueTypeId: issueTypeId,
            projectId: projectId,
            fetchSuggestionsOnFocus: true,
            ariaLabelledBy: ariaLabelledBy
        });
    if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $l9vfc.StyledFieldSkeleton), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fE4zR.FieldContainer), {
        width: width
    }, isEditable === false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: nonEditableReason?.message || ''
    }, getAssetsEdit()) : getAssetsEdit());
};
var $b6bb7b397651d319$export$2e2bcd8739ae039 = (0, $2nXHu.withFormField)({
    transformDefaultValue: (0, $9P44V.transformDefaultAssets)
})($b6bb7b397651d319$var$AssetsField);

});
parcelRegister("5Acnt", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec1c31560c1b022f$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $gWITR = parcelRequire("gWITR");

var $lRq8t = parcelRequire("lRq8t");

var $aUMMA = parcelRequire("aUMMA");

var $5fIxl = parcelRequire("5fIxl");

var $ftN6c = parcelRequire("ftN6c");

var $8q7lT = parcelRequire("8q7lT");

var $3soBO = parcelRequire("3soBO");

var $jnC6t = parcelRequire("jnC6t");
const $ec1c31560c1b022f$export$b7cbf126c81503e1 = 300;
// react-select with isMulti can return both null or an empty array for onChange depending on how
// it was cleared. Normalize this to an empty array https://github.com/JedWatson/react-select/issues/3632
const $ec1c31560c1b022f$var$normalizeOnChangeValues = (onChange)=>(updatedValues)=>onChange(updatedValues || []);
const $ec1c31560c1b022f$var$AssetsEdit = (props)=>{
    const { fieldId: fieldId, value: value, onChange: onChange, autoCompleteUrl: autoCompleteUrl, isInvalid: isInvalid, placeholder: placeholder = '', isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, onCloseMenuOnScroll: onCloseMenuOnScroll, isDisabled: isDisabled, issueTypeId: issueTypeId, projectId: projectId, fetchSuggestionsOnFocus: fetchSuggestionsOnFocus = false, classNamePrefix: classNamePrefix, ariaLabelledBy: ariaLabelledBy } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const accountId = (0, $8q7lT.useAccountId)();
    const [assetFilterName, setAssetFilterName] = (0, $eJOHy.useState)([]);
    const [, setAssetFilterConfigError] = (0, $eJOHy.useState)(false);
    const [lastFetchFailed, setLastFetchFailed] = (0, $eJOHy.useState)(false);
    const [defaultOptions, setDefaultOptions] = (0, $eJOHy.useState)([]);
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(false);
    const shouldFetchDefaultOptions = (0, $eJOHy.useRef)(true);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    /*
   * 1. Use customFieldId (eg. customfield_10085) to get asset filter contextId (eg. 10025)
   * 2. Use asset filter contextId to get asset filter name (eg. com.atlassian.servicedesk.connect.test-bed/mac.type.id)
   * 3. Use asset filter name for doing query in fetchAssets when user types in name of asset
   * */ (0, $eJOHy.useEffect)(()=>{
        (0, $jnC6t.fetchFieldFilterNames)(createAnalyticsEvent({}), fieldId, projectId, issueTypeId).then((result)=>{
            setAssetFilterName(result.map((res)=>`${res.appKey}/${res.originId}`));
        }).catch(()=>{
            setAssetFilterConfigError(true);
        });
    }, [
        fieldId,
        projectId,
        issueTypeId,
        createAnalyticsEvent
    ]);
    const searchAssets = (0, $eJOHy.useCallback)(async (query)=>{
        setLastFetchFailed(false);
        return (0, $jnC6t.fetchAssets)(query, autoCompleteUrl, accountId, assetFilterName, createAnalyticsEvent({})).catch(()=>{
            setLastFetchFailed(true);
            return [];
        });
    }, [
        autoCompleteUrl,
        accountId,
        assetFilterName,
        createAnalyticsEvent
    ]);
    const onFocus = async ()=>{
        if (shouldFetchDefaultOptions && defaultOptions && shouldFetchDefaultOptions.current && !defaultOptions.length) {
            shouldFetchDefaultOptions.current = false;
            setIsLoading && setIsLoading(true);
            const options = await searchAssets();
            setDefaultOptions && setDefaultOptions(options);
            setIsLoading && setIsLoading(false);
        }
    };
    const loadOptionsDebounced = (0, $5fIxl.default)(searchAssets, $ec1c31560c1b022f$export$b7cbf126c81503e1);
    const noOptionsMessage = (0, $eJOHy.useCallback)(()=>formatMessage(lastFetchFailed ? (0, $3soBO.default).failedFetch : (0, $3soBO.default).noMatches), [
        formatMessage,
        lastFetchFailed
    ]);
    const defaultOptionsProps = ()=>{
        if (fetchSuggestionsOnFocus) return {
            onFocus: onFocus,
            isLoading: isLoading,
            defaultOptions: defaultOptions
        };
        return {};
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gWITR.default), {
        fieldId: fieldId,
        loadOptions: loadOptionsDebounced,
        // @ts-expect-error - TS2322 - Type '(updatedValues: AssetOption[] | null) => void' is not assignable to type '(value: OptionsType<AssetOption>, action: ActionMeta<AssetOption>) => void'.
        onChange: $ec1c31560c1b022f$var$normalizeOnChangeValues(onChange),
        autoFocus: false,
        ...defaultOptionsProps(),
        isClearable: Boolean(value),
        isMulti: true,
        value: value,
        // @ts-expect-error - TS2322 - Type '"error" | null' is not assignable to type 'ValidationState | undefined'.
        validationState: isInvalid === true ? 'error' : null,
        noOptionsMessage: noOptionsMessage,
        placeholder: placeholder,
        // @ts-expect-error - TS2322 - Type '((e: ChangeEvent<HTMLElement>) => boolean) | undefined' is not assignable to type 'boolean | EventListener | undefined'.
        closeMenuOnScroll: onCloseMenuOnScroll,
        isDisabled: isDisabled,
        menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
        styles: (0, $aUMMA.defaultSelectStyles),
        classNamePrefix: classNamePrefix,
        "aria-labelledby": ariaLabelledBy
    });
};
var $ec1c31560c1b022f$export$2e2bcd8739ae039 = $ec1c31560c1b022f$var$AssetsEdit;

});
parcelRegister("3soBO", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b99f38f497727fd$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $9b99f38f497727fd$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    noMatches: {
        "id": "issue-field-assets.edit.no-matches",
        "defaultMessage": "No Matches"
    },
    failedFetch: {
        "id": "issue-field-assets.edit.failed-fetch",
        "defaultMessage": "Search failed. Please try again."
    }
});

});

parcelRegister("jnC6t", function(module, exports) {

$parcel$export(module.exports, "mapAssetEntityToAssetOptions", () => $25f24f7962525def$export$65ae210119db9fc5);
$parcel$export(module.exports, "fetchFieldFilterNames", () => $25f24f7962525def$export$668516cfbde240de);
$parcel$export(module.exports, "fetchAssets", () => $25f24f7962525def$export$6411291ff3741ab1);

var $b5RwB = parcelRequire("b5RwB");

var $gYnSx = parcelRequire("gYnSx");

var $1Ozm9 = parcelRequire("1Ozm9");

var $jGzN3 = parcelRequire("jGzN3");
const $25f24f7962525def$export$65ae210119db9fc5 = (data)=>data.map(({ label: label, origin: origin })=>({
            label: label.value,
            value: `${origin.appKey}/${origin.originId}`
        }));
const $25f24f7962525def$export$668516cfbde240de = async (analyticsEvent, customFieldId, projectId, issueTypeId)=>{
    const queryString = issueTypeId === null || issueTypeId === undefined ? (0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).stringify({
        projectId: projectId
    }) : (0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).stringify({
        projectId: projectId,
        issueTypeId: issueTypeId
    });
    return (0, $1Ozm9.default)(`/rest/assetinternalapi/latest/field/${customFieldId}/config?${queryString}`).then((response)=>response?.types || []).catch((error)=>{
        if (error.statusCode === 404) return Promise.resolve([]);
        (0, $gYnSx.default)({
            event: analyticsEvent,
            error: error,
            meta: {
                packageName: 'jiraIssueFieldAssets',
                id: 'fetchFieldFilterNames'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    });
};
const $25f24f7962525def$export$6411291ff3741ab1 = async (inputValue = '', autoCompleteUrl, accountId, assetTypesFilter, analyticsEvent)=>{
    const queryParams = {
        prioritizedAssignee: accountId,
        query: inputValue,
        type: assetTypesFilter
    };
    const queryString = (0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).stringify(queryParams);
    return (0, $jGzN3.performGetRequest)(`${autoCompleteUrl}?${queryString}`).then((response)=>$25f24f7962525def$export$65ae210119db9fc5(response.values)).catch((error)=>{
        (0, $gYnSx.default)({
            event: analyticsEvent,
            error: error,
            meta: {
                packageName: 'jiraIssueFieldAssets',
                id: 'fetchAssets'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    });
};

});


parcelRegister("9P44V", function(module, exports) {

$parcel$export(module.exports, "mapAssetOptionsToAssetEntity", () => $f739bc2ee2edf590$export$15c347a847be44f6);
$parcel$export(module.exports, "mutateAssetsFields", () => $f739bc2ee2edf590$export$9067b9149eea3adb);
$parcel$export(module.exports, "transformDefaultAssets", () => $f739bc2ee2edf590$export$42e188fe92589513);
$parcel$export(module.exports, "useFetchAssetsWithId", () => $f739bc2ee2edf590$export$aa4b3faecd2997ab);

var $eJOHy = parcelRequire("eJOHy");

var $eDBhy = parcelRequire("eDBhy");

var $1Ozm9 = parcelRequire("1Ozm9");

var $jnC6t = parcelRequire("jnC6t");
const $f739bc2ee2edf590$export$15c347a847be44f6 = (options)=>options.map(({ value: value })=>({
            appKey: value.split('/')[0],
            originId: value.split('/')[1],
            serializedOrigin: value,
            value: value
        }));
const $f739bc2ee2edf590$export$9067b9149eea3adb = (selectedAssets, fieldId)=>({
        assetsField: {
            fieldId: fieldId,
            assets: selectedAssets.map(({ value: value })=>({
                    appKey: value.split('/')[0],
                    originId: value.split('/')[1],
                    serializedOrigin: value,
                    value: value
                }))
        }
    });
const $f739bc2ee2edf590$export$42e188fe92589513 = (defaultAssets)=>defaultAssets.map(({ serializedOrigin: serializedOrigin })=>({
            value: serializedOrigin
        }));
const $f739bc2ee2edf590$export$aa4b3faecd2997ab = ()=>{
    const [isLoading, setLoading] = (0, $eJOHy.useState)(false);
    const handleFetch = (0, $eJOHy.useRef)((ids, setSelectedOptions)=>{
        setLoading(true);
        Promise.all(ids.map((id)=>(0, $1Ozm9.default)(`/rest/assetapi/asset/${id}`))).then((response)=>{
            setLoading(false);
            setSelectedOptions((0, $jnC6t.mapAssetEntityToAssetOptions)(response));
        }).catch((error)=>{
            setLoading(false);
            setSelectedOptions([]);
            (0, $eDBhy.fireIssueCreateErrorAnalytics)({
                meta: {
                    id: 'useFetchAssetsWithId',
                    packageName: 'jiraIssueCreateCommons',
                    teamName: 'gryffindor'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        });
    });
    return [
        {
            isLoading: isLoading
        },
        handleFetch.current
    ];
};

});


parcelRegister("5ub3a", function(module, exports) {

$parcel$export(module.exports, "default", () => $834717195ec6915d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $goZPP = parcelRequire("goZPP");

var $bQP4O = parcelRequire("bQP4O");
var $1DXK0 = parcelRequire("1DXK0");

var $f2JN3 = parcelRequire("f2JN3");

var $lRq8t = parcelRequire("lRq8t");

var $fkBVa = parcelRequire("fkBVa");

var $c9f6v = parcelRequire("c9f6v");

var $6XJko = parcelRequire("6XJko");

var $fE4zR = parcelRequire("fE4zR");

var $2nXHu = parcelRequire("2nXHu");

var $4yQUm = parcelRequire("4yQUm");

var $5HQhg = parcelRequire("5HQhg");

var $9qb2X = parcelRequire("9qb2X");
const $834717195ec6915d$export$7c52097ee36bd91 = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { autoCompleteUrl: autoCompleteUrl = '', width: width = (0, $6XJko.isVisualRefreshEnabled)() ? '100%' : props.width, fieldProps: { value: value, onChange: onChange, id: id, ...fieldProps }, autoFocus: autoFocus = false, isReadOnly: isReadOnly = false } = props;
    const [{ data: loggedInUser }] = (0, $c9f6v.useUserSubscriber)();
    const onAssignToMeClick = ()=>{
        onChange(loggedInUser);
    };
    const onAddAssigneeKeyDown = (0, $eJOHy.useCallback)((event)=>{
        if (id && (event.key === 'Enter' || event.key === ' ')) {
            onChange(loggedInUser);
            // this focus was implemented with getElementById as there is problem here using ref in UserPicker
            // doesn't pass ref to input inside the component
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            setTimeout(()=>document.getElementById(id)?.focus());
        }
    }, [
        id,
        loggedInUser,
        onChange
    ]);
    const showAssignToMe = loggedInUser && !isReadOnly;
    const assignToMeButton = (0, $6XJko.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bQP4O.default), {
        onClick: onAssignToMeClick,
        onKeyDown: onAddAssigneeKeyDown,
        testId: "issue-create-commons.ui.assignee-field.assing-to-me-button",
        xcss: $834717195ec6915d$var$assignToMeStyles
    }, formatMessage((0, $5HQhg.default).assignToMe)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "link",
        spacing: "none",
        onClick: onAssignToMeClick,
        onKeyDown: onAddAssigneeKeyDown,
        testId: "issue-create-commons.ui.assignee-field.assing-to-me-button"
    }, formatMessage((0, $5HQhg.default).assignToMe));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($834717195ec6915d$var$FieldContainer, {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fkBVa.default), {
        ...fieldProps,
        value: value,
        onChange: onChange,
        shouldPreloadAssignToMe: true,
        autoCompleteUrl: autoCompleteUrl,
        enableAutomaticOption: true,
        autoFocus: autoFocus,
        isDisabled: isReadOnly,
        width: width,
        inputId: id,
        openMenuOnClick: true
    }), showAssignToMe && assignToMeButton);
};
var $834717195ec6915d$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $2nXHu.withFormField)({
    validator: (0, $4yQUm.validateAssigneeField),
    transformDefaultValue: (0, $9qb2X.transformDefaultAssigneeValue // @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element' is not assignable to parameter of type 'AbstractComponent<ComponentProps<UserPickerFieldConfig, UserValue>, any>'.
    )
})($834717195ec6915d$export$7c52097ee36bd91);
const $834717195ec6915d$var$FieldContainerStylesWithVisualRefreshFFOff = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $fE4zR.FieldContainer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1v091b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $834717195ec6915d$var$FieldContainerStylesWithVisualRefreshFFOn = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $fE4zR.FieldContainer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1v091b66 _1wqpstnw _acx6idpf _1h0p1n1a",
            __cmplp.className
        ])
    });
});
const $834717195ec6915d$var$assignToMeStyles = (0, $1DXK0.xcss)({
    display: 'inline-block',
    color: 'color.link',
    cursor: 'pointer',
    marginTop: 'space.050',
    padding: 'space.0',
    backgroundColor: 'color.background.neutral.subtle',
    ':hover': {
        textDecoration: 'underline'
    },
    ':active': {
        color: 'color.link.pressed'
    }
});
const $834717195ec6915d$var$FieldContainer = (0, $f2JN3.componentWithCondition)(()=>(0, $6XJko.isVisualRefreshEnabled)(), $834717195ec6915d$var$FieldContainerStylesWithVisualRefreshFFOn, $834717195ec6915d$var$FieldContainerStylesWithVisualRefreshFFOff);

});
parcelRegister("fkBVa", function(module, exports) {

$parcel$export(module.exports, "default", () => $51af5a1b2006f27a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $3s8bj = parcelRequire("3s8bj");

var $ewHZ5 = parcelRequire("ewHZ5");

var $dTocu = parcelRequire("dTocu");

var $lMRlJ = parcelRequire("lMRlJ");

var $814y1 = parcelRequire("814y1");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $2lxLk = parcelRequire("2lxLk");
var $f39LL = parcelRequire("f39LL");

var $epTsa = parcelRequire("epTsa");

var $gZTP9 = parcelRequire("gZTP9");

var $kRvtD = parcelRequire("kRvtD");


var $30Vch = parcelRequire("30Vch");

var $75erM = parcelRequire("75erM");

var $434jX = parcelRequire("434jX");

var $7FxEb = parcelRequire("7FxEb");
const $51af5a1b2006f27a$var$DEFAULT_SEARCH_DEBOUCE_TIMEOUT = 300;
const $51af5a1b2006f27a$var$InlineAssigneeFieldOptionsLoadExperience = new (0, $f39LL.UFOExperience)('inline-assignee-picker.field-options-load', {
    type: (0, $2lxLk.ExperienceTypes).Operation,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).Custom,
    category: 'inline-assignee-picker.field-options-load'
});
const $51af5a1b2006f27a$var$isImproveInviteViaAssigneeEnabled = ()=>{
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [config] = (0, $epTsa.UNSAFE_noExposureExp)('jira_improve_invite_via_assignee');
    return config.get('isEnabled', false);
};
const $51af5a1b2006f27a$var$InlineAssigneePickerEdit = ({ shouldPreloadAssignToMe: shouldPreloadAssignToMe = false, autoCompleteUrl: autoCompleteUrl, value: value = null, width: width, isDisabled: isDisabled, onFocus: onFocus, onBlur: onBlur, onChange: onChange, searchDebounceTimeout: searchDebounceTimeout = $51af5a1b2006f27a$var$DEFAULT_SEARCH_DEBOUCE_TIMEOUT, enablePeopleInvite: enablePeopleInvite = true, enableAutomaticOption: enableAutomaticOption = false, isSubtle: isSubtle = false, appearance: appearance = 'normal', autoFocus: autoFocus = false, inputId: inputId, openMenuOnClick: openMenuOnClick = false, ariaLabel: ariaLabel, isRequired: isRequired, styles: styles, menuPortalTarget: menuPortalTarget, components: components, ...fieldProps })=>{
    const intl = (0, $dTocu.useIntlV2)();
    const self = (0, $eJOHy.useRef)({
        previousQuery: undefined
    }).current;
    const [{ data: users, loading: loading, error: error }, fetchUsers] = (0, $7FxEb.default)(autoCompleteUrl || '');
    const isEligibleForInviteOnOpen = (0, $kRvtD.useIsEligibleForInviteOnOpen)();
    const shouldShowInviteOnOpen = isEligibleForInviteOnOpen && enablePeopleInvite && $51af5a1b2006f27a$var$isImproveInviteViaAssigneeEnabled();
    const isAdmin = (0, $gZTP9.useIsAdmin)();
    const [assigneeValue, assigneeOptions, { userOptionsCount: userOptionsCount }] = (0, $434jX.useAssigneeOptions)({
        value: value,
        users: users,
        intl: intl,
        shouldPreloadAssignToMe: shouldPreloadAssignToMe,
        search: self.previousQuery,
        enablePeopleInvite: enablePeopleInvite,
        enableAutomaticOption: enableAutomaticOption,
        shouldHideUnassigned: isRequired,
        shouldShowInviteOnOpen: shouldShowInviteOnOpen
    });
    const [, { openModal: openModal }] = (0, $lMRlJ.useInvitePeopleModal)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        if (loading) {
            (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({
                actionSubject: 'inlineAssigneePicker',
                action: 'loading'
            }), 'inlineAssigneeOptions loading');
            $51af5a1b2006f27a$var$InlineAssigneeFieldOptionsLoadExperience.start();
        }
        if (error) {
            (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({
                actionSubject: 'inlineAssigneePicker',
                action: 'failed'
            }), 'inlineAssigneeOptions failed');
            $51af5a1b2006f27a$var$InlineAssigneeFieldOptionsLoadExperience.failure();
        }
        if (users.length) {
            (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({
                actionSubject: 'inlineAssigneePicker',
                action: 'loaded'
            }), 'inlineAssigneeOptions loaded');
            $51af5a1b2006f27a$var$InlineAssigneeFieldOptionsLoadExperience.success();
        }
    }, [
        loading,
        error,
        users,
        createAnalyticsEvent
    ]);
    const handleSearch = (0, $eJOHy.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))((query)=>{
            /*
     * Added extra condition to skip search. it's getting called during onBlur because previousQuery is undefined and query is empty string
     * then query !== self.previousQuery will be true and fetchUsers getting called unnecessarily
     */ if (query === '' && self.previousQuery === undefined) return;
            query !== self.previousQuery && fetchUsers(query);
            self.previousQuery = query;
        }, searchDebounceTimeout), // go/jfe-eslint
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        fetchUsers,
        searchDebounceTimeout,
        self.previousQuery
    ]);
    const handleOnFocus = (0, $eJOHy.useCallback)((sessionId)=>{
        onFocus?.(sessionId);
        // Exposure is fired here for jira_improve_invite_via_assignee because it is when the Assignee Field is opened
        if (isEligibleForInviteOnOpen && enablePeopleInvite) {
            if ((0, $epTsa.expVal)('jira_improve_invite_via_assignee', 'isEnabled', false)) (0, $434jX.fireInviteItemRendererEvent)({
                createAnalyticsEvent: createAnalyticsEvent,
                suggestionsCount: userOptionsCount,
                isAdmin: isAdmin
            });
        }
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'inlineAssigneePickerEdit opened', {
            isAdmin: isAdmin,
            enablePeopleInvite: enablePeopleInvite,
            shouldShowInviteOnOpen: shouldShowInviteOnOpen
        });
        if (!users || !users.length) fetchUsers();
    }, [
        onFocus,
        enablePeopleInvite,
        users,
        createAnalyticsEvent,
        isAdmin,
        isEligibleForInviteOnOpen,
        shouldShowInviteOnOpen,
        userOptionsCount,
        fetchUsers
    ]);
    const handleOnBlur = (0, $eJOHy.useCallback)((sessionId)=>{
        onBlur?.(sessionId);
        self.previousQuery = undefined;
    }, [
        onBlur,
        self
    ]);
    const handleOnChange = (0, $eJOHy.useCallback)((updatedValue, action)=>{
        if (!updatedValue || Array.isArray(updatedValue)) return;
        if (enablePeopleInvite && updatedValue.id === (0, $ee8519ef4d8fa2c0$export$d875316cb0cd94f7)) {
            openModal(createAnalyticsEvent ?? null, {
                inviteFlow: 'assignee'
            });
            onChange?.(value, action);
            return;
        }
        let newValue;
        if (updatedValue.id === (0, $ee8519ef4d8fa2c0$export$bdab9bfb39981463) || updatedValue.id === (0, $ee8519ef4d8fa2c0$export$d875316cb0cd94f7)) newValue = null;
        else newValue = (0, $30Vch.getUserFromUserOption)(updatedValue);
        onChange?.(newValue, action);
    }, [
        enablePeopleInvite,
        onChange,
        openModal,
        value,
        createAnalyticsEvent
    ]);
    /*
   * user picker default opens on focus, fetchUsers has to be called onFocus
   * when openMenuOnClick is enabled then fetchUsers should be called during onOpen rather than onFocus
   */ const controlProps = openMenuOnClick ? {
        openMenuOnClick: openMenuOnClick,
        onOpen: handleOnFocus
    } : {
        onFocus: handleOnFocus
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ewHZ5.UserPicker), {
        inputId: inputId,
        fieldId: (0, $814y1.ASSIGNEE_TYPE),
        autoFocus: autoFocus,
        placeholder: intl.formatMessage((0, $75erM.default).searchForAssignee),
        isLoading: loading,
        options: assigneeOptions,
        value: assigneeValue,
        isMulti: false,
        isClearable: false,
        onBlur: handleOnBlur,
        onChange: handleOnChange,
        onInputChange: handleSearch,
        subtle: isSubtle,
        appearance: appearance,
        width: width,
        isDisabled: isDisabled,
        ariaLabelledBy: fieldProps['aria-labelledby'],
        UNSAFE_hasDraggableParentComponent: true,
        ariaLabel: ariaLabel,
        menuPortalTarget: menuPortalTarget,
        styles: styles,
        components: components,
        ...controlProps
    });
};
var $51af5a1b2006f27a$export$2e2bcd8739ae039 = $51af5a1b2006f27a$var$InlineAssigneePickerEdit;

});
parcelRegister("kRvtD", function(module, exports) {

$parcel$export(module.exports, "useIsEligibleForInviteOnOpen", () => $a690cd6958a70a90$export$68fb0ef7a3be1bd);

var $gZTP9 = parcelRequire("gZTP9");

var $lUto7 = parcelRequire("lUto7");

var $96jid = parcelRequire("96jid");
const $a690cd6958a70a90$export$68fb0ef7a3be1bd = ()=>{
    const { isCurrentProjectJiraSoftware: isCurrentProjectJiraSoftware } = (0, $96jid.useIsCurrentProjectJiraSoftware)();
    const isAdmin = (0, $gZTP9.useIsAdmin)();
    const isSiteAdmin = (0, $lUto7.useIsSiteAdmin)();
    return isCurrentProjectJiraSoftware && (isAdmin || isSiteAdmin);
};

});
parcelRegister("96jid", function(module, exports) {

$parcel$export(module.exports, "useIsCurrentProjectJiraSoftware", () => $85dd7c95637ca89d$export$7c1f0cb7cb50b335);

var $2aY2d = parcelRequire("2aY2d");

var $ln6Iy = parcelRequire("ln6Iy");
const $85dd7c95637ca89d$export$7c1f0cb7cb50b335 = ()=>{
    const { data: projectContextData, loading: loading } = (0, $2aY2d.useProjectContext)();
    const isCurrentProjectJiraSoftware = projectContextData?.projectType === (0, $ln6Iy.SOFTWARE_PROJECT);
    return {
        loading: loading,
        isCurrentProjectJiraSoftware: isCurrentProjectJiraSoftware
    };
};

});


parcelRegister("434jX", function(module, exports) {

$parcel$export(module.exports, "fireInviteItemRendererEvent", () => $41c74d4e083b87a3$export$85383b532f48700a);
$parcel$export(module.exports, "useAssigneeOptions", () => $41c74d4e083b87a3$export$1eb7ccf9fc55d2e8);

var $a0po3 = parcelRequire("a0po3");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $gZTP9 = parcelRequire("gZTP9");

var $c9f6v = parcelRequire("c9f6v");


var $30Vch = parcelRequire("30Vch");

var $75erM = parcelRequire("75erM");
const $41c74d4e083b87a3$export$85383b532f48700a = ({ createAnalyticsEvent: createAnalyticsEvent, suggestionsCount: suggestionsCount, isAdmin: isAdmin, isInviteAndAssignFromBoard: isInviteAndAssignFromBoard = false })=>{
    if (createAnalyticsEvent === undefined || createAnalyticsEvent === null) return;
    const action = 'rendered';
    const actionSubject = 'inviteItem';
    const event = createAnalyticsEvent({
        action: action,
        actionSubject: actionSubject
    });
    const attrs = {
        fieldId: 'assignee',
        userRole: isAdmin ? 'admin' : 'basic',
        suggestionsCount: suggestionsCount,
        source: 'assigneeField',
        ...isInviteAndAssignFromBoard && {
            isInviteAndAssignFromBoard: true
        }
    };
    (0, $gCeeo.fireUIAnalytics)(event, `${actionSubject} ${action}`, attrs);
};
const $41c74d4e083b87a3$export$1eb7ccf9fc55d2e8 = ({ value: value, users: users, intl: intl, shouldPreloadAssignToMe: shouldPreloadAssignToMe, search: search, enablePeopleInvite: enablePeopleInvite, enableAutomaticOption: enableAutomaticOption, suggestedEmailDomain: suggestedEmailDomain, isEligibleForInviteAndAssign: isEligibleForInviteAndAssign, shouldHideUnassigned: shouldHideUnassigned, shouldShowInviteOnOpen: shouldShowInviteOnOpen })=>{
    const isAdmin = (0, $gZTP9.useIsAdmin)();
    const unassigned = (0, $30Vch.getUnassignedUser)(intl);
    const automaticOption = (0, $30Vch.getAutomaticUserOption)(intl);
    const valueOption = (0, $30Vch.getUserOptionFromUser)(value || unassigned);
    const [{ data: loggedInUser }] = (0, $c9f6v.useUserSubscriber)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const loggedInUserOption = loggedInUser ? {
        ...(0, $30Vch.getUserOptionFromUser)(loggedInUser),
        publicName: intl.formatMessage((0, $75erM.default).assignToMe)
    } : null;
    const isInvalidSearch = search === undefined || search === '';
    // show unassigned option if value is defined and no search or unassigned display name match the search
    const showUnassigned = !shouldHideUnassigned && (isInvalidSearch ? Boolean(value?.accountId) : unassigned.displayName.toLowerCase().startsWith((search || '').toLowerCase()));
    let showAutomaticOption = false;
    if (enableAutomaticOption === true) showAutomaticOption = isInvalidSearch ? Boolean(value?.accountId !== (0, $ee8519ef4d8fa2c0$export$f5d5f6bb902f1027)) : automaticOption.displayName.toLowerCase().startsWith((search || '').toLowerCase());
    const isLoggedInUserCurrentValue = loggedInUserOption !== null && valueOption.id === loggedInUserOption.id;
    const isLoggedInUserMatchSearch = users.some((user)=>loggedInUserOption !== null && user.accountId === loggedInUserOption.id);
    const showAssignToMeOnInit = !isLoggedInUserCurrentValue && (shouldPreloadAssignToMe || isLoggedInUserMatchSearch);
    const showAssignToMe = isInvalidSearch ? showAssignToMeOnInit : isLoggedInUserMatchSearch;
    const userOptions = users.filter((user)=>// remove selected user (value) from users list when search is not defined
        (!isInvalidSearch || user.accountId !== valueOption.id) && // remove logged in user (is already added in 2nd position above)
        !(loggedInUserOption !== null && user.accountId === loggedInUserOption.id)).map((0, $30Vch.getUserOptionFromUser));
    const invitePeopleOptions = [];
    if (enablePeopleInvite === true && shouldShowInviteOnOpen) {
        if (isEligibleForInviteAndAssign && search) invitePeopleOptions.push((0, $a0po3.getInviteAndAssignPeopleOption)(intl.formatMessage, search, suggestedEmailDomain));
        else invitePeopleOptions.push((0, $30Vch.getUserOptionFromUser)((0, $30Vch.getInvitePeopleOption)(intl, isAdmin)));
    } else if (enablePeopleInvite === true && !isInvalidSearch && userOptions.length < 3) {
        if (isEligibleForInviteAndAssign) {
            invitePeopleOptions.push((0, $a0po3.getInviteAndAssignPeopleOption)(intl.formatMessage, search, suggestedEmailDomain));
            $41c74d4e083b87a3$export$85383b532f48700a({
                createAnalyticsEvent: createAnalyticsEvent,
                suggestionsCount: userOptions.length,
                isAdmin: isAdmin,
                isInviteAndAssignFromBoard: true
            });
        } else {
            $41c74d4e083b87a3$export$85383b532f48700a({
                createAnalyticsEvent: createAnalyticsEvent,
                suggestionsCount: userOptions.length,
                isAdmin: isAdmin
            });
            invitePeopleOptions.push((0, $30Vch.getUserOptionFromUser)((0, $30Vch.getInvitePeopleOption)(intl, isAdmin)));
        }
    }
    const options = [
        ...showUnassigned ? [
            (0, $30Vch.getUserOptionFromUser)(unassigned)
        ] : [],
        ...showAutomaticOption ? [
            (0, $30Vch.getUserOptionFromUser)(automaticOption)
        ] : [],
        ...showAssignToMe && loggedInUserOption !== null ? [
            loggedInUserOption
        ] : [],
        ...userOptions,
        ...invitePeopleOptions
    ];
    return [
        valueOption,
        options,
        {
            userOptionsCount: userOptions.length
        }
    ];
};

});
parcelRegister("a0po3", function(module, exports) {

$parcel$export(module.exports, "isValidEmailAddress", () => $7a7f63b4eaa5e288$export$866f45a7554d0870);
$parcel$export(module.exports, "getInviteAndAssignPeopleOption", () => $7a7f63b4eaa5e288$export$34e0d98131b0b98a);

var $2lvD5 = parcelRequire("2lvD5");

var $gJ1Yn = parcelRequire("gJ1Yn");


var $8yJyf = parcelRequire("8yJyf");
const $7a7f63b4eaa5e288$var$getInviteAndAssignOption = (inputValue, suggestedEmailDomain)=>{
    const isEmail = inputValue && [
        (0, $f621eb647bcb9d4f$export$18d36911c7f94286),
        (0, $f621eb647bcb9d4f$export$da1c529049028734)
    ].includes((0, $2lvD5.isValidEmail)(inputValue));
    const value = isEmail || !suggestedEmailDomain ? inputValue : `${inputValue.replace(/\s+/g, '.').toLocaleLowerCase()}@${suggestedEmailDomain}`;
    return value;
};
const $7a7f63b4eaa5e288$export$866f45a7554d0870 = (inputValue)=>inputValue && (0, $2lvD5.isValidEmail)(inputValue) === (0, $f621eb647bcb9d4f$export$18d36911c7f94286);
const $7a7f63b4eaa5e288$export$34e0d98131b0b98a = (formatMessage, input, suggestedEmailDomain)=>{
    const possibleEmail = $7a7f63b4eaa5e288$var$getInviteAndAssignOption(input, suggestedEmailDomain);
    return {
        id: (0, $f621eb647bcb9d4f$export$898547b9297d1a3a),
        name: possibleEmail,
        avatarUrl: (0, (/*@__PURE__*/$parcel$interopDefault($gJ1Yn))),
        byline: formatMessage((0, $8yJyf.default).inviteAndAssign),
        isDisabled: (0, $2lvD5.isValidEmail)(possibleEmail) !== 'VALID'
    };
};

});
parcelRegister("gJ1Yn", function(module, exports) {
module.exports = new URL("email.very-specific-illu.3b6402e8.png", import.meta.url).toString();

});

const $f621eb647bcb9d4f$export$898547b9297d1a3a = '_INVITE_AND_ASSIGN_ID_';
const $f621eb647bcb9d4f$export$18d36911c7f94286 = 'VALID';
const $f621eb647bcb9d4f$export$da1c529049028734 = 'POTENTIAL';

parcelRegister("8yJyf", function(module, exports) {

$parcel$export(module.exports, "default", () => $b093af53a19b0514$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $b093af53a19b0514$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    inviteAndAssign: {
        "id": "invite-and-assign.common.invite-and-assign",
        "defaultMessage": "Invite and assign"
    }
});

});



parcelRegister("7FxEb", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5175d6d332d746f$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $eSnSE = parcelRequire("eSnSE");

var $1Ozm9 = parcelRequire("1Ozm9");
const $e5175d6d332d746f$var$useUsersQuery = (autoCompleteUrl, customFetchUsers)=>{
    const [users, setUsers] = (0, $eJOHy.useState)([]);
    const [error, setError] = (0, $eJOHy.useState)(undefined);
    const [loading, setLoading] = (0, $eJOHy.useState)(false);
    const currentQuery = (0, $eJOHy.useRef)('');
    const fetchUsers = (0, $eJOHy.useCallback)(// @ts-expect-error - TS2345 - Argument of type '(query?: string | undefined) => Promise<void> | Promise<never[]>' is not assignable to parameter of type 'FetchUsers'.
    (query = '')=>{
        if ([
            '',
            null,
            undefined
        ].includes(autoCompleteUrl)) return Promise.resolve([]);
        setLoading(true);
        currentQuery.current = query;
        if (error) setError(undefined);
        const usersFetchUrl = `${autoCompleteUrl || ''}${query}`;
        const fetchUsersMethod = customFetchUsers ? customFetchUsers(query) : (0, $1Ozm9.default)(usersFetchUrl);
        return fetchUsersMethod.then((response)=>{
            if (query === currentQuery.current) setUsers(response);
        }).catch((err)=>{
            if (query === currentQuery.current) setError(err);
            const errorMessage = customFetchUsers ? 'Failed to fetch using custom user fetcher' : 'Failed to fetch users';
            (0, $eSnSE.default).safeErrorWithoutCustomerData('issue.fields.assigne', errorMessage, err);
        }).finally(()=>setLoading(false));
    }, [
        autoCompleteUrl,
        error,
        customFetchUsers
    ]);
    return [
        {
            data: users,
            error: error,
            loading: loading
        },
        fetchUsers
    ];
};
var $e5175d6d332d746f$export$2e2bcd8739ae039 = $e5175d6d332d746f$var$useUsersQuery;

});


parcelRegister("4yQUm", function(module, exports) {

$parcel$export(module.exports, "validateString", () => $ea59272d283aab89$export$d7b0a588f685ba7e);
$parcel$export(module.exports, "validateSelectField", () => $ea59272d283aab89$export$53ded7ceec493f10);
$parcel$export(module.exports, "validateCascadingSelectField", () => $ea59272d283aab89$export$837294b8fc732f20);
$parcel$export(module.exports, "validateAssigneeField", () => $ea59272d283aab89$export$dd17aabe3f77b2ba);
$parcel$export(module.exports, "validateUserPickerField", () => $ea59272d283aab89$export$356346770aab95cb);
$parcel$export(module.exports, "validateCheckboxField", () => $ea59272d283aab89$export$7aa5e0976d0c384b);
$parcel$export(module.exports, "validateComponentField", () => $ea59272d283aab89$export$89943b0814df306d);
$parcel$export(module.exports, "validateCustomTeamsField", () => $ea59272d283aab89$export$364ea91bee38a994);
$parcel$export(module.exports, "validateGroupPickerField", () => $ea59272d283aab89$export$c6d4785f3f46f73a);
$parcel$export(module.exports, "validateMultiVersionsField", () => $ea59272d283aab89$export$727e23f536334715);
$parcel$export(module.exports, "validateOrganizationsField", () => $ea59272d283aab89$export$b97bb8e170430af8);
$parcel$export(module.exports, "validatePriorityField", () => $ea59272d283aab89$export$17fd881b060187f7);
$parcel$export(module.exports, "validateRadioSelectField", () => $ea59272d283aab89$export$f69029476f9179b);
$parcel$export(module.exports, "validateRadioGroupField", () => $ea59272d283aab89$export$d60dcaa093bca71d);
$parcel$export(module.exports, "validateResolutionField", () => $ea59272d283aab89$export$316feff8e636f81f);
$parcel$export(module.exports, "validateSingleVersionField", () => $ea59272d283aab89$export$45f7908dc93110fb);
$parcel$export(module.exports, "validateLabelField", () => $ea59272d283aab89$export$1a8caa895b9fda26);
$parcel$export(module.exports, "validateForgeLabelField", () => $ea59272d283aab89$export$bf4287ae453e2aab);
// @ts-expect-error - TS2614 - Module '"@atlaskit/user-picker"' has no exported member 'LegacyValue'. Did you mean to use 'import LegacyValue from "@atlaskit/user-picker"' instead?

var $3UrQk = parcelRequire("3UrQk");

// @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
const $ea59272d283aab89$export$d7b0a588f685ba7e = (value, isRequired, type)=>{
    if (isRequired && !value?.trim?.()) return 0, $3UrQk.REQUIRED;
    if (typeof value === 'string' && type === 'text' && value?.length > (0, $84764505b39497ac$export$fe1a70381f6491b5)) return 0, $84764505b39497ac$export$618e922e89e8bcae;
    return undefined;
};
const $ea59272d283aab89$export$53ded7ceec493f10 = (value, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
isRequired)=>{
    if (isRequired) {
        if (!value) return 0, $3UrQk.REQUIRED;
        if (Array.isArray(value) && !value.length) return 0, $3UrQk.REQUIRED;
    }
    return undefined;
};
const $ea59272d283aab89$export$837294b8fc732f20 = (value, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
isRequired)=>{
    if (isRequired) {
        if (!value) return 0, $3UrQk.REQUIRED;
    }
    return undefined;
};
const $ea59272d283aab89$export$dd17aabe3f77b2ba = (value, isRequired)=>{
    if (isRequired) {
        if (!value) return 0, $3UrQk.REQUIRED;
        if (Array.isArray(value) && !value.length) return 0, $3UrQk.REQUIRED;
    }
    return undefined;
};
const $ea59272d283aab89$export$356346770aab95cb = (value, isRequired)=>{
    if (isRequired) {
        if (!value) return 0, $3UrQk.REQUIRED;
        if (Array.isArray(value) && !value.length) return 0, $3UrQk.REQUIRED;
    }
    return undefined;
};
// @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
const $ea59272d283aab89$export$7aa5e0976d0c384b = (value, isRequired)=>{
    if (isRequired) {
        if (!value) return 0, $3UrQk.REQUIRED;
        if (Array.isArray(value) && !value.length) return 0, $3UrQk.REQUIRED;
    }
    return undefined;
};
// @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
const $ea59272d283aab89$export$89943b0814df306d = (value, isRequired)=>{
    if (isRequired) {
        if (!value) return 0, $3UrQk.REQUIRED;
        if (Array.isArray(value) && !value.length) return 0, $3UrQk.REQUIRED;
    }
    return undefined;
};
const $ea59272d283aab89$export$364ea91bee38a994 = (value, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
isRequired)=>{
    if (isRequired) {
        if (!value) return 0, $3UrQk.REQUIRED;
    }
    return undefined;
};
const $ea59272d283aab89$export$c6d4785f3f46f73a = (value, isRequired)=>{
    if (isRequired) {
        if (!value) return 0, $3UrQk.REQUIRED;
        if (Array.isArray(value) && !value.length) return 0, $3UrQk.REQUIRED;
    }
    return undefined;
};
const $ea59272d283aab89$export$727e23f536334715 = (value, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
isRequired)=>{
    if (isRequired) {
        if (!value) return 0, $3UrQk.REQUIRED;
        if (!value.length) return 0, $3UrQk.REQUIRED;
    }
    return undefined;
};
const $ea59272d283aab89$export$b97bb8e170430af8 = (data, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
isRequired)=>{
    if (isRequired) {
        if (!data) return 0, $3UrQk.REQUIRED;
        if (Array.isArray(data) && !data.length) return 0, $3UrQk.REQUIRED;
    }
    return undefined;
};
// @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
const $ea59272d283aab89$export$17fd881b060187f7 = (data, isRequired)=>{
    if (isRequired && !data) return 0, $3UrQk.REQUIRED;
    return undefined;
};
// @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
const $ea59272d283aab89$export$f69029476f9179b = (data, isRequired)=>{
    if (isRequired && !data) return 0, $3UrQk.REQUIRED;
    return undefined;
};
const $ea59272d283aab89$export$d60dcaa093bca71d = (data, isRequired)=>{
    if (isRequired && !data) return 0, $3UrQk.REQUIRED;
    return undefined;
};
const $ea59272d283aab89$export$316feff8e636f81f = (value, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
isRequired)=>{
    if (isRequired) {
        if (!value) return 0, $3UrQk.REQUIRED;
    }
    return undefined;
};
const $ea59272d283aab89$export$45f7908dc93110fb = (value, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
isRequired)=>{
    if (isRequired) {
        if (!value) return 0, $3UrQk.REQUIRED;
    }
    return undefined;
};
const $ea59272d283aab89$export$1a8caa895b9fda26 = (labels, isRequired)=>{
    if (isRequired) {
        if (!labels) return 0, $3UrQk.REQUIRED;
        if (Array.isArray(labels) && !labels.length) return 0, $3UrQk.REQUIRED;
    }
    if (labels && labels?.length > (0, $84764505b39497ac$export$1fdf850c93de8bae)) return 0, $84764505b39497ac$export$fd7dfa1695d325ca;
    if (labels && labels.map((label)=>label?.value?.trim?.()).some((value)=>value.includes(' ') || value.length > (0, $84764505b39497ac$export$9151073f92820ff8))) return 0, $84764505b39497ac$export$e77d629cc732976d;
    return undefined;
};
const $ea59272d283aab89$export$bf4287ae453e2aab = (labels, isRequired)=>{
    if (isRequired) {
        if (!labels) return 0, $3UrQk.REQUIRED;
        if (Array.isArray(labels) && !labels.length) return 0, $3UrQk.REQUIRED;
    }
    if (labels && labels?.length > (0, $84764505b39497ac$export$1fdf850c93de8bae)) return 0, $84764505b39497ac$export$fd7dfa1695d325ca;
    if (labels && labels.map((label)=>label?.value?.trim?.()).some((value)=>value.length > (0, $84764505b39497ac$export$9151073f92820ff8))) return 0, $84764505b39497ac$export$8d30d41a8828e14f;
    return undefined;
};

});

parcelRegister("5HQhg", function(module, exports) {

$parcel$export(module.exports, "default", () => $c344035f4483bca3$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $c344035f4483bca3$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    assignToMe: {
        "id": "issue-create-commons.assignee-field.assign-to-me",
        "defaultMessage": "Assign to me"
    }
});

});

parcelRegister("9qb2X", function(module, exports) {

$parcel$export(module.exports, "transformDefaultAssigneeValue", () => $386d80789565cdf2$export$f5415de9103f1c69);
$parcel$export(module.exports, "mapUserToAssigneeValue", () => $386d80789565cdf2$export$c4dfa893fba82437);
$parcel$export(module.exports, "mutateAssigneeUserPicker", () => $386d80789565cdf2$export$a6706b2f4762043b);


const $386d80789565cdf2$export$f5415de9103f1c69 = (value)=>({
        accountId: (value.accountId === '-1' ? (0, $ee8519ef4d8fa2c0$export$f5d5f6bb902f1027) : value.accountId) || '',
        displayName: value.name || '',
        avatarUrls: value.picture !== undefined ? {
            '16x16': value.picture,
            '24x24': value.picture,
            '32x32': value.picture,
            '48x48': value.picture
        } : {}
    });
const $386d80789565cdf2$export$c4dfa893fba82437 = (value)=>{
    if (value === null) return null;
    if (value.accountId === (0, $ee8519ef4d8fa2c0$export$f5d5f6bb902f1027)) return undefined;
    return {
        id: value.accountId
    };
};
const $386d80789565cdf2$export$a6706b2f4762043b = (selectedUser, fieldId)=>{
    if (selectedUser === null || selectedUser.accountId === null) return null;
    return {
        fieldId: fieldId,
        mutationGroup: (0, $1e24dbdd7b63ae9f$export$6684456d545bf498),
        user: {
            accountId: selectedUser.accountId
        }
    };
};

});


parcelRegister("035EY", function(module, exports) {

$parcel$export(module.exports, "AtlassianTeamsField", () => $af599eab19404762$export$96c8ee98de63ec5b);
$parcel$export(module.exports, "default", () => $af599eab19404762$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $k71qx = parcelRequire("k71qx");

var $h47gY = parcelRequire("h47gY");

var $2NDyQ = parcelRequire("2NDyQ");

var $bd2V9 = parcelRequire("bd2V9");

var $ch9En = parcelRequire("ch9En");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $lvKO5 = parcelRequire("lvKO5");

var $4NEt5 = parcelRequire("4NEt5");

var $7jTnu = parcelRequire("7jTnu");

var $lGaCn = parcelRequire("lGaCn");

var $fE4zR = parcelRequire("fE4zR");

var $2nXHu = parcelRequire("2nXHu");

var $24FkK = parcelRequire("24FkK");

const $af599eab19404762$var$overrideSelectStyles = {
    // @ts-expect-error - TS7006 - Parameter 'base' implicitly has an 'any' type.
    control: (base)=>({
            ...base,
            padding: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-075, 6px)"} ${"var(--ds-space-075, 6px)"} 0`
        })
};
const $af599eab19404762$var$stopFormPropagation = (e)=>{
    e.stopPropagation();
    e.preventDefault();
};
const $af599eab19404762$export$96c8ee98de63ec5b = (props)=>{
    const tenantContext = (0, $lvKO5.useTenantContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const siteId = tenantContext.cloudId;
    /**
   * The following is a hack to force the TeamPickerEdit to close after creating a team.
   * @atlaskit/smart-user-picker does not provide a way to close the dropdown menu, as it
   * doesn't expose the select Ref.
   *  */ const [hackIsEditable, setHackIsEditable] = (0, $eJOHy.useState)(true);
    const { width: width, fieldProps: { value: value, onChange: onChange, ...fieldProps }, isEditable: isEditable = true, nonEditableReason: nonEditableReason, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, autoFocus: autoFocus, description: description } = props;
    const onCreate = (0, $eJOHy.useCallback)((team)=>{
        if (team && team?.id !== value?.id) {
            (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'createTeamInline succeeded', 'issueCreate', {
                memberCount: team.memberCount
            });
            /**
       * The following is a hack to force the TeamPickerEdit to close after creating a team.
       * @atlaskit/smart-user-picker does not provide a way to close the dropdown menu, as it
       * doesn't expose the select Ref.
       *  */ setHackIsEditable(false);
            // required wait for new created team to be available
            setTimeout(()=>{
                onChange(team);
                setHackIsEditable(true);
            }, 1000);
        }
    }, [
        createAnalyticsEvent,
        onChange,
        value?.id
    ]);
    const [createTeamDialog, createTeamDialogTrigger] = (0, $2NDyQ.useCreateTeamDialog)({
        onCreate: onCreate
    });
    const getTeamEdit = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
            name: "team-picker-edit",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lGaCn.FieldLoader), null)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bd2V9.AsyncTeamPickerEdit), {
            ...fieldProps,
            width: width,
            siteId: siteId,
            autoFocus: autoFocus,
            defaultValue: value,
            // @ts-expect-error - TS2322 - Type '(value: TeamValue) => void' is not assignable to type 'OnChange'.
            onChange: onChange,
            isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
            isDisabled: isEditable === false || !hackIsEditable,
            styles: $af599eab19404762$var$overrideSelectStyles,
            createTeamDialogTrigger: createTeamDialogTrigger,
            ...(0, $7jTnu.fg)('jfp_a11y_issue_create_form_field_with_description') && {
                description: description
            }
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fE4zR.FieldContainer), {
        width: width
    }, isEditable === false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: nonEditableReason?.message || ''
    }, getTeamEdit()) : getTeamEdit(), (0, $7jTnu.fg)('error_boundaries_to_common_package') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4NEt5.JiraIssueCreateErrorBoundary), {
        id: "create-issue-field-team-create-dialog"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("form", {
        name: "gic-create-team-dialog-form",
        onSubmit: $af599eab19404762$var$stopFormPropagation
    }, createTeamDialog)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
        id: "create-issue-field-team-create-dialog"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("form", {
        name: "gic-create-team-dialog-form",
        onSubmit: $af599eab19404762$var$stopFormPropagation
    }, createTeamDialog)));
};
var $af599eab19404762$export$2e2bcd8739ae039 = (0, $2nXHu.withFormField)({
    validator: (0, $24FkK.validateAtlassianTeamsField),
    transformDefaultValue: (0, $24FkK.transformDefaultAtlassianTeam)
})($af599eab19404762$export$96c8ee98de63ec5b);

});
parcelRegister("bd2V9", function(module, exports) {

$parcel$export(module.exports, "AsyncTeamPickerEdit", () => $8c6e270275d8af34$export$7db2ade8dff2be91);

var $eJOHy = parcelRequire("eJOHy");

var $9A8Wt = parcelRequire("9A8Wt");

var $cBavF = parcelRequire("cBavF");

var $bbdV2 = parcelRequire("bbdV2");

var $bQWwW = parcelRequire("bQWwW");

var $9tR6g = parcelRequire("9tR6g");
const $8c6e270275d8af34$var$EMPTY_OBJECT = {};

const $8c6e270275d8af34$export$eaed616868423e8a = (0, $bQWwW.lazy)(()=>Promise.resolve((parcelRequire("7ws3M"))), {
    moduleId: "./src/packages/issue/fields/team/src/ui/edit-mode/index.tsx"
});
const $8c6e270275d8af34$export$7db2ade8dff2be91 = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $9tR6g.asyncTeamPickerEditEntryPoint), // use stable object reference to avoid re-renders
    $8c6e270275d8af34$var$EMPTY_OBJECT);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eJOHy.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        id: "async-jira-issue-atlassian-team-picker-edit",
        packageName: "jira-issue-field-team",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: props,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9A8Wt.SkeletonCompiled), {
            width: "350px",
            height: "40px"
        }),
        errorFallback: "unmount"
    });
};

});
parcelRegister("9tR6g", function(module, exports) {

$parcel$export(module.exports, "asyncTeamPickerEditEntryPoint", () => $4dc720b9d07cbe8b$export$80ec8c2b96e9988);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $4dc720b9d07cbe8b$export$80ec8c2b96e9988 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>Promise.resolve((parcelRequire("7ws3M"))).then((module)=>module.TeamPickerEditEntryPointContent), {
        moduleId: "ce0fa7b5",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});


parcelRegister("lGaCn", function(module, exports) {

$parcel$export(module.exports, "FieldLoader", () => $ab9906d62662e1af$export$dbd27b551621740c);

var $eJOHy = parcelRequire("eJOHy");

var $9A8Wt = parcelRequire("9A8Wt");
const $ab9906d62662e1af$export$dbd27b551621740c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9A8Wt.Skeleton), {
        width: "350px",
        height: "40px"
    });

});

parcelRegister("24FkK", function(module, exports) {

$parcel$export(module.exports, "mutateAtlassianTeamField", () => $872ff3ee16ae885e$export$c8b8a48d1ff67754);
$parcel$export(module.exports, "transformDefaultAtlassianTeam", () => $872ff3ee16ae885e$export$3fee94ad0b9e180c);
$parcel$export(module.exports, "transformAtlassianTeamFieldTypeString", () => $872ff3ee16ae885e$export$450002773f9da0a4);
$parcel$export(module.exports, "validateAtlassianTeamsField", () => $872ff3ee16ae885e$export$8222f94513c7d2e6);

var $3UrQk = parcelRequire("3UrQk");

const $872ff3ee16ae885e$export$c8b8a48d1ff67754 = (selectedTeam, fieldId)=>selectedTeam ? {
        fieldId: fieldId,
        mutationGroup: (0, $067872f9caf35ae1$export$31fd86f8f183952c),
        team: {
            teamId: selectedTeam.id
        }
    } : null;
const $872ff3ee16ae885e$export$3fee94ad0b9e180c = (team)=>({
        name: team.name,
        id: team.teamId,
        avatarUrl: team?.avatar?.small
    });
const $872ff3ee16ae885e$export$450002773f9da0a4 = (team)=>{
    if (team && team.id) return team.id;
    return null;
};
const $872ff3ee16ae885e$export$8222f94513c7d2e6 = (value, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
isRequired)=>{
    if (isRequired) {
        if (!value) return 0, $3UrQk.REQUIRED;
    }
    return undefined;
};

});
const $067872f9caf35ae1$export$31fd86f8f183952c = 'atlassianTeamFields';



parcelRegister("8D65g", function(module, exports) {

$parcel$export(module.exports, "getFileIdsFromFiles", () => $8fcbb67a45e75811$export$90bf402b5b4274c7);
$parcel$export(module.exports, "validateAttachment", () => $8fcbb67a45e75811$export$8af997fabc69757a);
$parcel$export(module.exports, "getFieldDropZoneContainerID", () => $8fcbb67a45e75811$export$2fab292eea84487a);

var $3UrQk = parcelRequire("3UrQk");
const $8fcbb67a45e75811$export$90bf402b5b4274c7 = (files)=>files.map((file)=>file.id.toString());
const $8fcbb67a45e75811$export$8af997fabc69757a = (value, isRequired)=>{
    if (isRequired) {
        if (!value || value.length === 0) return 0, $3UrQk.REQUIRED;
    }
    return undefined;
};
const $8fcbb67a45e75811$export$2fab292eea84487a = (fieldId)=>`${fieldId ? `${fieldId}-` : ''}dropzone-container`;

});

parcelRegister("7BqUP", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4bae31bf5a55e2f$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $AUSk2 = parcelRequire("AUSk2");

var $fE4zR = parcelRequire("fE4zR");

var $2nXHu = parcelRequire("2nXHu");

var $ixdDB = parcelRequire("ixdDB");

var $4yQUm = parcelRequire("4yQUm");

var $6FMuz = parcelRequire("6FMuz");

const $d4bae31bf5a55e2f$var$CascadingSelectField = (props)=>{
    const { fieldProps: { value: value, onChange: onChange, ...fieldProps }, allowedValues: cascadingSelectOptions, width: width, autoFocus: autoFocus = false, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, $ixdDB.closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, isReadOnly: isReadOnly = false, isEditable: isEditable = true } = props;
    const { allowedValues: allowedValues, allowedChildValues: allowedChildValues } = (0, $eJOHy.useMemo)(()=>(0, $6FMuz.transformToCascadingSelectOptions)(cascadingSelectOptions), [
        cascadingSelectOptions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fE4zR.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $AUSk2.AsyncCascadingSelectEdit), {
        ...fieldProps,
        value: value,
        allowedValues: allowedValues,
        allowedChildValues: allowedChildValues,
        // @ts-expect-error - TS2322 - Type '(e: ChangeEvent<HTMLElement>) => boolean' is not assignable to type '(e: SyntheticEvent<HTMLElement, Event>) => boolean'.
        onCloseMenuOnScroll: onCloseMenuOnScroll,
        isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
        // @ts-expect-error - TS2322 - Type '(value: SelectedOption) => void' is not assignable to type '(value: SelectedOption, meta: null, analyticsEvent: UIAnalyticsEventInterface) => Promise<void>'.
        onChange: onChange,
        isInvalid: false,
        autoFocus: autoFocus,
        areOptionsOnSameRow: false,
        isEditable: !isReadOnly && isEditable
    }));
};
var $d4bae31bf5a55e2f$export$2e2bcd8739ae039 = (0, $2nXHu.withFormField)({
    validator: (0, $4yQUm.validateCascadingSelectField),
    transformDefaultValue: $6FMuz.transformDefaultValue
})($d4bae31bf5a55e2f$var$CascadingSelectField);

});
parcelRegister("AUSk2", function(module, exports) {

$parcel$export(module.exports, "AsyncCascadingSelectEdit", () => $ff032f4c7a64f598$export$7db21897d0716698);

var $eJOHy = parcelRequire("eJOHy");

var $9A8Wt = parcelRequire("9A8Wt");

var $cBavF = parcelRequire("cBavF");

var $bbdV2 = parcelRequire("bbdV2");

var $fUsH1 = parcelRequire("fUsH1");
const $ff032f4c7a64f598$var$EMPTY_OBJECT = {};
const $ff032f4c7a64f598$export$7db21897d0716698 = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $fUsH1.asyncCascadingSelectEditEntryPoint), // use stable object reference to avoid re-renders
    $ff032f4c7a64f598$var$EMPTY_OBJECT);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eJOHy.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        id: "async-jira-issue-field-cascading-select-edit",
        packageName: "jira-issue-field-cascading-select",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: props,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9A8Wt.SkeletonCompiled), {
            width: "350px",
            height: "40px"
        }),
        errorFallback: "unmount"
    });
};

});
parcelRegister("fUsH1", function(module, exports) {

$parcel$export(module.exports, "asyncCascadingSelectEditEntryPoint", () => $22aecc76b9253f41$export$336a3a4bd9539e41);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $22aecc76b9253f41$export$336a3a4bd9539e41 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("0eqKs")).then((module)=>module.CascadingSelectViewEntryPointContent), {
        moduleId: "dba9fb26",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("0eqKs", function(module, exports) {

let $000b31c89838b934$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $000b31c89838b934$var$load("aBWzi").then(()=>parcelRequire('5tfmm'));

});



parcelRegister("6FMuz", function(module, exports) {

$parcel$export(module.exports, "transformToCascadingSelectOptions", () => $64c7ad4455ccf7e1$export$b06e6053830d7554);
$parcel$export(module.exports, "transformDefaultValue", () => $64c7ad4455ccf7e1$export$e2f4e5d31db527cc);
$parcel$export(module.exports, "mutateCascadingSelectField", () => $64c7ad4455ccf7e1$export$f402e35d933d11b5);

const $64c7ad4455ccf7e1$export$facac75482a8e0c5 = (option)=>{
    const { value: value, id: id } = option || {};
    if (value && id) return {
        label: value,
        value: id
    };
    return null;
};
const $64c7ad4455ccf7e1$export$b06e6053830d7554 = (cascadingSelectData)=>{
    const allowedValues = [];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const allowedChildValues = {};
    cascadingSelectData.forEach(({ parentOptionValue: parentOptionValue, childOptionValues: childOptionValues })=>{
        const transformedParentOption = $64c7ad4455ccf7e1$export$facac75482a8e0c5(parentOptionValue);
        if (parentOptionValue !== null && transformedParentOption !== null) {
            allowedValues.push(transformedParentOption);
            allowedChildValues[parentOptionValue.id] = childOptionValues.map($64c7ad4455ccf7e1$export$facac75482a8e0c5);
        }
    });
    return {
        allowedValues: allowedValues,
        allowedChildValues: allowedChildValues
    };
};
const $64c7ad4455ccf7e1$export$e2f4e5d31db527cc = (defaultValue)=>{
    const { parentOptionValue: parentOptionValue, childOptionValue: childOptionValue } = defaultValue;
    const transformedParentOption = $64c7ad4455ccf7e1$export$facac75482a8e0c5(parentOptionValue);
    let transformedDefaultValue = null;
    if (transformedParentOption !== null) transformedDefaultValue = {
        ...transformedParentOption,
        child: childOptionValue ? $64c7ad4455ccf7e1$export$facac75482a8e0c5(childOptionValue) : undefined
    };
    return transformedDefaultValue;
};
const $64c7ad4455ccf7e1$export$f402e35d933d11b5 = (selectedOption, fieldId)=>({
        fieldId: fieldId,
        parentOptionValue: {
            optionId: selectedOption.value
        },
        // @ts-expect-error - TS2339 - Property 'child' does not exist on type 'Option | ParentChildOption'.
        childOptionValue: selectedOption.child ? {
            // @ts-expect-error - TS2339 - Property 'child' does not exist on type 'Option | ParentChildOption'.
            optionId: selectedOption.child.value
        } : null,
        mutationGroup: (0, $781fa2d5aa9d7fb0$export$31fd86f8f183952c)
    });

});
const $781fa2d5aa9d7fb0$export$31fd86f8f183952c = 'cascadingSelectFields';



parcelRegister("eLd2G", function(module, exports) {

$parcel$export(module.exports, "default", () => $583c8aec394d2cc4$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $68TAs = parcelRequire("68TAs");

var $3DY4w = parcelRequire("3DY4w");

var $fE4zR = parcelRequire("fE4zR");

var $2nXHu = parcelRequire("2nXHu");

var $4yQUm = parcelRequire("4yQUm");

const $583c8aec394d2cc4$var$CheckboxField = (props)=>{
    const { width: width, fieldProps: { value: value, onChange: onChange }, error: error, allowedValues: allowedValues, fieldId: fieldId, isReadOnly: isReadOnly = false } = props;
    const options = (0, $3DY4w.mapDataToOptions)(allowedValues);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fE4zR.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $68TAs.default), {
        options: options,
        values: value,
        onChange: onChange,
        isInvalid: Boolean(error),
        isDisabled: isReadOnly,
        fieldId: fieldId
    }));
};
var $583c8aec394d2cc4$export$2e2bcd8739ae039 = (0, $2nXHu.withFormField)({
    validator: (0, $4yQUm.validateCheckboxField),
    transformDefaultValue: (0, $3DY4w.mapDataToOptions)
})($583c8aec394d2cc4$var$CheckboxField);

});
parcelRegister("68TAs", function(module, exports) {

$parcel$export(module.exports, "default", () => $f75dbbf6bbad4147$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $86tBw = parcelRequire("86tBw");

var $2yMqp = parcelRequire("2yMqp");

var $3DY4w = parcelRequire("3DY4w");
const $f75dbbf6bbad4147$var$CheckboxGroupEdit = (props)=>{
    const { values: values, options: options, isDisabled: isDisabled = false, onChange: onChange, isInvalid: isInvalid, fieldId: fieldId } = props;
    const onChangeCheckedItems = (event)=>{
        const itemValue = event.target.value;
        const retainValue = (0, $3DY4w.setRetainValue)({
            options: options,
            itemValue: itemValue,
            values: values
        });
        onChange(retainValue);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, options?.map((option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2yMqp.default), {
            name: fieldId,
            key: option.value
        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86tBw.default), {
                ...fieldProps,
                key: option.value,
                value: option.value,
                label: option.label,
                isChecked: values?.some((data)=>data.value === option.value),
                onChange: onChangeCheckedItems,
                isInvalid: isInvalid,
                isDisabled: isDisabled
            }))));
};
var $f75dbbf6bbad4147$export$2e2bcd8739ae039 = $f75dbbf6bbad4147$var$CheckboxGroupEdit;

});
parcelRegister("86tBw", function(module, exports) {

$parcel$export(module.exports, "default", () => $43629aa548cc82fb$export$2e2bcd8739ae039);
/* checkbox.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $jrFnt = parcelRequire("jrFnt");

var $gyJTO = parcelRequire("gyJTO");

var $cM2mi = parcelRequire("cM2mi");
var $jJLKy = parcelRequire("jJLKy");
var $9ywMw = parcelRequire("9ywMw");
var $lsp6q = parcelRequire("lsp6q");
const $43629aa548cc82fb$var$checkboxStyles = {
    root: "_19itglyw _nd5lfibj _12ji1r31 _1qu2glyw _12y31o36 _1bsb1osq _4t3i1osq _r06hglyw _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _tzy4idpf _r050fibj _9bg71mn3 _19op11so _a30fhteq _1610e4h9 _13wo93zu _q5a61gyf _8gq114p8 _wje2mov0 _1fo21cni _eyedglyw _1ef7js4s _1h6rjs4s _smzgj3jf _1dk7j3jf _l71j1i6y _t34a1i6y _y32gkivo _1ah9199y _1frj180l _h78e1g3k _dwvb1ps2 _1bok170n _1mhr17cl _fx2i3rva _10oaq2ws _w12s155b _15y61vek _e6ww155b _sg1j1vek _rphw18jz _y9y9mz2b _141bmz2b _255gmz2b _jj67mz2b _swhgmz2b _axq81diq _1jiz1diq _s9051diq _1efy1diq _1oav1diq _10y313gf _1wt913gf _qq8613gf _1adw13gf _12sr13gf _16jiglyw _693jglyw _1niqglyw _cl9tglyw _1jbnglyw _j1ta1hou _18qu1ps2 _1g52170n _1log17cl _32hzmz2b _1vv91diq _yjhd1hou _w1cowc43 _jdqn1onz _4y4t1onz _lvfrwc43 _g68dwc43 _13dk1onz _w1el1onz _a9yw1onz _1l3g1onz _dcdpgir2 _wobcgir2 _rp9wgir2 _9ebfwc43 _e43iwc43 _1tkuwc43 _1lehwc43 _b9q3wc43 _tu2918qt _1uxv18qt _1ufw18qt _opo918qt _1e8318qt _1k3d18qt _25yv18qt _1igz18qt _c7cc18qt _1swg18qt"
}; /**
    * __Checkbox__
    *
    * A checkbox an input control that allows a user to select one or more options from a number of choices.
    *
    * - [Examples](https://atlassian.design/components/checkbox/examples)
    * - [Code](https://atlassian.design/components/checkbox/code)
    * - [Usage](https://atlassian.design/components/checkbox/usage)
    */ 
const $43629aa548cc82fb$var$Checkbox = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)(function Checkbox({ isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, className: className, ...rest }, ref) {
    const [isCheckedState, setIsCheckedState] = (0, $eJOHy.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $eJOHy.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const internalRef = (0, $eJOHy.useRef)(null);
    const mergedRefs = (0, $gyJTO.default)([
        internalRef,
        ref
    ]); // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $eJOHy.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $jJLKy.default), {
        isDisabled: isDisabled,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // When there is more usage of this pattern we'll update the lint rule.
        xcss: xcss,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("input" // It is necessary only for Safari. It allows to render focus styles.
            , {
                tabIndex: 0,
                ...rest,
                type: "checkbox",
                ref: mergedRefs,
                disabled: isDisabled,
                checked: isChecked,
                value: value,
                name: name,
                required: isRequired,
                className: (0, $hcewu.default)([
                    $43629aa548cc82fb$var$checkboxStyles.root,
                    className
                ]),
                onChange: onChangeAnalytics,
                "aria-invalid": isInvalid ? 'true' : undefined,
                "data-testid": testId && `${testId}--hidden-checkbox`,
                "data-invalid": isInvalid ? 'true' : undefined
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cM2mi.default), {
                isIndeterminate: isIndeterminate,
                isChecked: isChecked
            }),
            label && /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $9ywMw.default), {
                children: [
                    label,
                    isRequired && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lsp6q.default), {})
                ]
            })
        ]
    });
}));
$43629aa548cc82fb$var$Checkbox.displayName = 'Checkbox';
var $43629aa548cc82fb$export$2e2bcd8739ae039 = $43629aa548cc82fb$var$Checkbox;

});
parcelRegister("cM2mi", function(module, exports) {

$parcel$export(module.exports, "default", () => $b89a586a6c2ef726$export$2e2bcd8739ae039);
/* checkbox-icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $2Swhg = parcelRequire("2Swhg");

var $eGOwo = parcelRequire("eGOwo");
function $b89a586a6c2ef726$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) {
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $eGOwo.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
            fill: "inherit",
            x: "8",
            y: "11",
            width: "8",
            height: "2",
            rx: "1"
        });
    }
    if (isChecked) {
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $eGOwo.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
            d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
            fill: "inherit"
        });
    }
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ const $b89a586a6c2ef726$var$CheckboxIcon = /*#__PURE__*/ (0, $eJOHy.memo)(({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $eJOHy.useMemo)(()=>$b89a586a6c2ef726$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2Swhg.default), {
        label: "",
        primaryColor: "var(--checkbox-background-color)",
        secondaryColor: "var(--checkbox-tick-color)",
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
                (0, $eGOwo.fg)('platform-visual-refresh-icons') ? /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                    fill: "currentColor",
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5"
                }) : /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                    fill: "currentColor",
                    x: "6",
                    y: "6",
                    width: "12",
                    height: "12",
                    rx: "2"
                }),
                icon
            ]
        })
    });
});
var $b89a586a6c2ef726$export$2e2bcd8739ae039 = $b89a586a6c2ef726$var$CheckboxIcon;

});

parcelRegister("jJLKy", function(module, exports) {

$parcel$export(module.exports, "default", () => $4573aabb850f2ff0$export$2e2bcd8739ae039);
/* label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $4573aabb850f2ff0$var$baseStyles = null;
const $4573aabb850f2ff0$var$textLabelLayoutStyles = null;
const $4573aabb850f2ff0$var$disabledStyles = null;
const $4573aabb850f2ff0$var$labelStyles = null;
function $4573aabb850f2ff0$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)("label", {
        className: (0, $hcewu.default)([
            "_11c82smr _1e0c11p5 _1ejihkll _umai184x _syazj3m3 _80om73ad",
            label && "_zulp1nu5 _yv0ey09t",
            isDisabled && "_syaz1tvo _80om13gf",
            "_h5e3mag2 _1nzs11d3 _1eszzyvw _yp0jhh5a _ay2w1y1w _d51u10ko _phft1fmg _1g1funzk _l6wkzyvw _1dikhh5a _1sfg1q3k _fpdj1y1w _1yjc194a _oaj11fmg _1j3h1q3k _eawb1dzn _1rda1qbb _18q015t7 _13hr3acm",
            xcss
        ]),
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id,
        children: children
    });
}

});

parcelRegister("9ywMw", function(module, exports) {

$parcel$export(module.exports, "default", () => $94306373cce3a9fe$export$2e2bcd8739ae039);
/* label-text.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $94306373cce3a9fe$var$labelTextStyles = null;
function $94306373cce3a9fe$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        className: (0, $hcewu.default)([
            "_nd5l11ig _1wpz1h6o"
        ]),
        children: children
    });
}

});

parcelRegister("lsp6q", function(module, exports) {

$parcel$export(module.exports, "default", () => $bafcc116ddbb4544$export$2e2bcd8739ae039);
/* required-indicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $bafcc116ddbb4544$var$requiredIndicatorStyles = null;
function $bafcc116ddbb4544$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "aria-hidden": true,
        className: (0, $hcewu.default)([
            "_syaz1gtz _bozgv77o"
        ]),
        children: "*"
    });
}

});


parcelRegister("2yMqp", function(module, exports) {

$parcel$export(module.exports, "default", () => $636b62edc5d062fa$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $6svxr = parcelRequire("6svxr");
/**
 * __Checkbox field__
 *
 * A checkbox field is a form field that lets users select an item. Users can check or uncheck the checkbox.
 *
 * - [Examples] https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#checkboxfield-reference
 * - [Code] https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#checkboxfield-reference
 * - [Usage] https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#checkboxfield-reference
 */ const $636b62edc5d062fa$var$CheckboxField = ({ children: children, defaultIsChecked: defaultIsChecked = false, isDisabled: isDisabled, isRequired: isRequired, label: label, name: name, value: value, ...rest })=>{
    // Maintains a memoised list of the default values
    const defaultValue = (0, $eJOHy.useCallback)((currentValue = [])=>defaultIsChecked && value !== undefined ? [
            ...currentValue,
            value
        ] : currentValue, [
        value,
        defaultIsChecked
    ]);
    return value !== undefined ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6svxr.default), {
        ...rest,
        defaultValue: defaultValue,
        isDisabled: isDisabled,
        isRequired: isRequired,
        label: label,
        name: name,
        transform: (event, currentValue)=>event.currentTarget.checked && currentValue ? [
                ...currentValue,
                value
            ] : currentValue.filter((v)=>v !== value),
        children: ({ fieldProps: { value: fieldValue, ...otherFieldProps }, ...others })=>children({
                fieldProps: {
                    ...otherFieldProps,
                    isChecked: !!fieldValue.find((v)=>v === value),
                    value: value
                },
                ...others
            })
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6svxr.default), {
        ...rest,
        defaultValue: defaultIsChecked,
        isDisabled: isDisabled,
        isRequired: isRequired,
        label: label,
        name: name,
        transform: (event)=>event.currentTarget.checked,
        children: ({ fieldProps: { value: fieldValue, ...otherFieldProps }, ...others })=>children({
                fieldProps: {
                    ...otherFieldProps,
                    isChecked: fieldValue,
                    value: value
                },
                ...others
            })
    });
};
var $636b62edc5d062fa$export$2e2bcd8739ae039 = $636b62edc5d062fa$var$CheckboxField;

});

parcelRegister("3DY4w", function(module, exports) {

$parcel$export(module.exports, "mapDataToOptions", () => $73f10657646472ec$export$99a866ffa3af7d8b);
$parcel$export(module.exports, "mapOptionsToData", () => $73f10657646472ec$export$ffef3a401aef987b);
$parcel$export(module.exports, "setRetainValue", () => $73f10657646472ec$export$7f2b89a121299348);
const $73f10657646472ec$export$99a866ffa3af7d8b = (data)=>data.map(({ id: id, value: value })=>({
            label: value,
            value: id
        }));
const $73f10657646472ec$export$ffef3a401aef987b = (options)=>options.map(({ label: label, value: value })=>({
            id: value,
            value: label
        }));
const $73f10657646472ec$export$7f2b89a121299348 = ({ options: options, itemValue: itemValue, values: values })=>{
    const selectedOption = options?.find((option)=>option.value === itemValue);
    let retainValue = [
        ...values || []
    ];
    let isElementAlreadyChecked = false;
    const newCheckedItems = values?.filter((item)=>{
        if (item.value === itemValue) isElementAlreadyChecked = true;
        return item.value !== itemValue;
    });
    if (isElementAlreadyChecked && newCheckedItems !== undefined) retainValue = newCheckedItems;
    else if (selectedOption) retainValue.push(selectedOption);
    return retainValue;
};

});



parcelRegister("jjsF0", function(module, exports) {

$parcel$export(module.exports, "mutateCheckboxField", () => $cf0ab67d761c6672$export$23a688ac1e0973b5);

const $cf0ab67d761c6672$export$23a688ac1e0973b5 = (values, fieldId)=>{
    const transformedValues = values.map(({ value: value })=>({
            optionId: value
        }));
    return {
        fieldId: fieldId,
        mutationGroup: (0, $667f0aae7c6bbbd6$export$31fd86f8f183952c),
        options: transformedValues
    };
};

});
const $667f0aae7c6bbbd6$export$31fd86f8f183952c = 'multipleSelectFields';


parcelRegister("37Tnh", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecd6ac72c575c128$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $6OjRx = parcelRequire("6OjRx");

var $9D41I = parcelRequire("9D41I");

var $fE4zR = parcelRequire("fE4zR");

var $2nXHu = parcelRequire("2nXHu");

var $ixdDB = parcelRequire("ixdDB");
const $ecd6ac72c575c128$var$CmdbField = (props)=>{
    const { autoCompleteUrl: autoCompleteUrl, additionalData: { isMulti: isMulti = false, attributesIncludedInAutoCompleteSearch: attributesIncludedInAutoCompleteSearch }, fieldProps: { value: value, onChange: onChange }, contextAndValuesOfIssueBeingCreated: contextAndValuesOfIssueBeingCreated, selectedProject: selectedProject, autoFocus: autoFocus = false, width: width, fieldId: fieldId, ariaLabelledBy: ariaLabelledBy } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fE4zR.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9D41I.LimitData), {
        limitProperty: (0, $9D41I.MAX_CMDB_OBJECTS_PER_FIELD)
    }, (limit)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6OjRx.CmdbFieldObjectPicker), {
            autoCompleteUrl: `${autoCompleteUrl}?`,
            displayedValues: value,
            selectedValues: value,
            attributesToDisplayInSearch: attributesIncludedInAutoCompleteSearch,
            multiple: isMulti,
            onChange: onChange,
            autoFocus: autoFocus,
            limit: limit,
            menuPosition: "fixed",
            onCloseMenuOnScroll: (0, $ixdDB.closeMenuOnScroll),
            contextAndValuesOfIssueBeingCreated: {
                ...contextAndValuesOfIssueBeingCreated,
                fieldId: fieldId,
                selectedProject: selectedProject
            },
            ariaLabelledBy: ariaLabelledBy
        })));
};
var // @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element' is not assignable to parameter of type 'AbstractComponent<ComponentProps<CmdbFieldConfig, FieldValue>, any>'.
$ecd6ac72c575c128$export$2e2bcd8739ae039 = (0, $2nXHu.withFormField)({})($ecd6ac72c575c128$var$CmdbField);

});
parcelRegister("6OjRx", function(module, exports) {

$parcel$export(module.exports, "CmdbFieldObjectPicker", () => $16682953c20dc930$export$2c337ae5a2979962);

var $eJOHy = parcelRequire("eJOHy");

var $6XEne = parcelRequire("6XEne");
var $c4OV1 = parcelRequire("c4OV1");

var $bILK0 = parcelRequire("bILK0");

var $lRq8t = parcelRequire("lRq8t");

var $6U3FB = parcelRequire("6U3FB");

var $hOPXt = parcelRequire("hOPXt");

var $43nEs = parcelRequire("43nEs");

var $hdcNT = parcelRequire("hdcNT");

var $5pGc2 = parcelRequire("5pGc2");

var $4hTST = parcelRequire("4hTST");

var $aZKFb = parcelRequire("aZKFb");

var $kF5Rw = parcelRequire("kF5Rw");

var $7zUow = parcelRequire("7zUow");
const $16682953c20dc930$export$f3d4a8207a9d907f = (attributesToDisplayInSearch)=>(cmdbObject)=>{
        const getDisplayValuesFromAttribute = (attribute)=>attribute.objectAttributeValues.map((val)=>val.displayValue).join(' ');
        // This label is the string value that @atlaskit/select uses under the hood
        // to determine a 'match' when typing in the select field. Therefore, we need to
        // build a string that includes values for all the attributes marked as
        // 'searchable' within the Insight field configuration.
        const searchableLabel = cmdbObject.attributes.map((attribute)=>{
            if (// @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
            attributesToDisplayInSearch.includes(attribute.objectTypeAttribute.name) || attributesToDisplayInSearch.includes('Label') && attribute.objectTypeAttribute.label === true) return getDisplayValuesFromAttribute(attribute);
            return undefined;
        }).filter(Boolean).join(' ');
        // Label should fall back to the label attribute of the object if it doesn't contain any of the search attributes
        return {
            value: cmdbObject.id,
            label: searchableLabel || cmdbObject.label,
            rawData: cmdbObject
        };
    };
const $16682953c20dc930$export$cc2466dccf2cb27d = (values)=>{
    if (!values) return values;
    return values.map((x)=>({
            label: x.label,
            value: x.objectId,
            rawData: x
        }));
};
const $16682953c20dc930$export$2c337ae5a2979962 = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const hasConfigError = !props.attributesToDisplayInSearch?.length; // null, undefined or empty is a config error
    const { autoCompleteUrl: autoCompleteUrl, attributesToDisplayInSearch: attributesToDisplayInSearch = [], multiple: multiple = false, displayedValues: displayedValues, selectedValues: selectedValues = [], onChange: propsOnChange, issueId: issueId, limit: limit, autoFocus: autoFocus, menuPosition: menuPosition = 'absolute', onCloseMenuOnScroll: onCloseMenuOnScroll, contextAndValuesOfIssueBeingCreated: contextAndValuesOfIssueBeingCreated, testId: testId, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy } = props;
    const fetchCmdbObjects = (searchValue)=>{
        if (typeof autoCompleteUrl === 'string' && autoCompleteUrl) return (0, $hdcNT.searchCmdbObjects)(autoCompleteUrl, searchValue, issueId, (0, $6U3FB.extractFieldValueMap)(contextAndValuesOfIssueBeingCreated));
        throw new Error('Invalid URL');
    };
    const transformObjectToSelectOption = (0, $eJOHy.useMemo)(()=>$16682953c20dc930$export$f3d4a8207a9d907f(attributesToDisplayInSearch), [
        attributesToDisplayInSearch
    ]);
    const { selectProps: selectProps, error: error, totalNumberOfResults: totalNumberOfResults } = (0, $hOPXt.usePaginatedAutocomplete)(selectedValues, fetchCmdbObjects, transformObjectToSelectOption, contextAndValuesOfIssueBeingCreated);
    const numberOfSearchResults = (totalNumberOfResults ?? 0) >= (0, $43nEs.MAX_OBJECT_COUNT_CUTOFF) ? `${0, $43nEs.MAX_OBJECT_COUNT_CUTOFF}+` : totalNumberOfResults;
    const selectPropsWithLabel = selectProps && Object.keys(selectProps).length && {
        ...selectProps,
        options: [
            {
                label: formatMessage((0, $kF5Rw.default).dropdownNumberOfSearchResultsLabel, {
                    numberOfSearchResults: numberOfSearchResults,
                    isLoading: selectProps.isLoading
                }),
                options: selectProps.options
            }
        ]
    };
    const { showFlag: showFlag } = (0, $bILK0.useFlagsService)();
    const onChange = (0, $eJOHy.useCallback)((selectedOption)=>{
        if (!selectedOption) {
            propsOnChange([]);
            return;
        }
        if (Array.isArray(selectedOption)) propsOnChange(selectedOption.map((x)=>x.rawData));
        if (!Array.isArray(selectedOption)) propsOnChange([
            selectedOption.rawData
        ]);
    }, [
        propsOnChange
    ]);
    const showGenericErrorFlag = (0, $eJOHy.useCallback)(()=>{
        showFlag({
            type: 'error',
            title: formatMessage((0, $kF5Rw.default).errorTitleCmdbAssets),
            description: formatMessage((0, $kF5Rw.default).errorMessage),
            isAutoDismiss: true,
            messageId: 'servicedesk-cmdb-field-object-picker.ui.show-flag.error.error-title-cmdb-assets',
            messageType: 'transactional'
        });
    }, [
        formatMessage,
        showFlag
    ]);
    const responseErrorHandler = (0, $eJOHy.useMemo)(()=>({
            404: ()=>showGenericErrorFlag(),
            400: ()=>showFlag({
                    type: 'error',
                    title: formatMessage((0, $kF5Rw.default).errorTitleCmdbFieldSearch),
                    description: formatMessage((0, $kF5Rw.default).errorMessageCmdbFieldSearch),
                    isAutoDismiss: true,
                    messageId: 'servicedesk-cmdb-field-object-picker.ui.show-flag.error.error-title-cmdb-field-search',
                    messageType: 'transactional'
                })
        }), [
        formatMessage,
        showFlag,
        showGenericErrorFlag
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (error) responseErrorHandler[error.statusCode] ? responseErrorHandler[error.statusCode]() : showGenericErrorFlag();
    }, [
        error,
        responseErrorHandler,
        showGenericErrorFlag
    ]);
    const { Option: Option } = (0, $6XEne.components);
    const customComponents = (0, $eJOHy.useMemo)(()=>({
            // @ts-expect-error - TS7006 - Parameter 'optionProps' implicitly has an 'any' type.
            Option: (optionProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Option, optionProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4hTST.CmdbSelectOption), {
                    label: optionProps.label,
                    data: optionProps.data,
                    selectProps: optionProps.selectProps,
                    attributesToDisplayInSearch: attributesToDisplayInSearch
                }))
        }), // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        attributesToDisplayInSearch
    ]);
    const singleObjectReached = !multiple && selectedValues.length === 1;
    const singleObjectExceeded = !multiple && selectedValues.length > 1;
    const objectLimitReached = selectedValues.length === limit;
    const objectLimitExceeded = selectedValues.length > limit;
    const shouldShowSelect = (multiple || selectedValues.length === 0) && selectedValues.length < limit;
    const getMessages = (objectLimit)=>{
        const validationMessages = [];
        singleObjectExceeded && validationMessages.push({
            label: 'warning',
            messageContent: formatMessage((0, $kF5Rw.default).warningMultipleObjectsMessage)
        });
        objectLimitExceeded && validationMessages.push({
            label: 'warning',
            messageContent: formatMessage((0, $kF5Rw.default).warningObjectLimitExceeded, {
                objectLimit: objectLimit
            })
        });
        singleObjectReached && validationMessages.push({
            label: 'info',
            messageContent: formatMessage((0, $kF5Rw.default).infoSingleObjectMessage)
        });
        objectLimitReached && validationMessages.push({
            label: 'info',
            messageContent: formatMessage((0, $kF5Rw.default).infoObjectLimitReached, {
                objectLimit: objectLimit
            })
        });
        return validationMessages.length > 0 ? [
            validationMessages[0]
        ] : [];
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testid": testId
    }, hasConfigError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5pGc2.CmdbFieldError), {
        fieldId: contextAndValuesOfIssueBeingCreated?.fieldId
    }), !hasConfigError && (displayedValues || shouldShowSelect) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c4OV1.default), {
        // Setting a value of null causes the field to go back to being empty after a selection is made
        value: $16682953c20dc930$export$cc2466dccf2cb27d(displayedValues),
        isMulti: multiple,
        autoFocus: autoFocus,
        // @ts-expect-error - TS2322 - Type '(selectedOption: OptionsType<CmdbObject> | OptionsType<CmdbObject>[]) => void' is not assignable to type '(value: OptionsType<CmdbObject> | OptionsType<...> | null, action: ActionMeta<...>) => void'.
        onChange: onChange,
        placeholder: formatMessage((0, $kF5Rw.default).searchPlaceholder),
        components: customComponents,
        isClearable: true,
        menuPlacement: "auto",
        // @ts-expect-error - TS2322 - Type 'string | null' is not assignable to type 'MenuPosition | undefined'.
        menuPosition: menuPosition,
        styles: (0, $7zUow.customStyles),
        closeMenuOnScroll: onCloseMenuOnScroll,
        ...selectPropsWithLabel,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aZKFb.EditMessage), {
        messages: getMessages(limit)
    }));
};

});
parcelRegister("6U3FB", function(module, exports) {

$parcel$export(module.exports, "extractFieldValueMap", () => $0d045ce63aeea11e$export$fb98c8002c9a4960);

var $814y1 = parcelRequire("814y1");
const $0d045ce63aeea11e$var$getStringValue = (fieldValues)=>fieldValues;
const $0d045ce63aeea11e$var$getJoinedArray = (fieldValues)=>fieldValues.map(({ value: value })=>value).join(',');
const $0d045ce63aeea11e$var$extractFieldValueMethods = {
    [(0, $814y1.SUMMARY_TYPE)]: $0d045ce63aeea11e$var$getStringValue,
    [(0, $814y1.DUE_DATE_TYPE)]: $0d045ce63aeea11e$var$getStringValue,
    [(0, $814y1.AFFECTS_VERSIONS_TYPE)]: $0d045ce63aeea11e$var$getJoinedArray,
    [(0, $814y1.FIX_VERSIONS_TYPE)]: $0d045ce63aeea11e$var$getJoinedArray,
    [(0, $814y1.COMPONENTS_TYPE)]: $0d045ce63aeea11e$var$getJoinedArray,
    [(0, $814y1.ASSIGNEE_TYPE)]: ({ accountId: accountId })=>accountId,
    [(0, $814y1.REPORTER_TYPE)]: ({ id: id })=>id,
    [(0, $814y1.PRIORITY_TYPE)]: ({ value: value })=>value,
    [(0, $814y1.RESOLUTION_TYPE)]: ({ value: value })=>value,
    [(0, $814y1.CMDB_OBJECT_CF_TYPE)]: (fieldValues)=>fieldValues.map(({ workspaceId: workspaceId, objectId: objectId })=>`${workspaceId}:${objectId}`).join(',')
};
const $0d045ce63aeea11e$var$extractIssueTypeValue = (selectedIssueType)=>selectedIssueType.type === 'REQUEST_TYPE' ? selectedIssueType.issueTypeId : selectedIssueType.value;
const $0d045ce63aeea11e$export$fb98c8002c9a4960 = (contextAndValues)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result = {};
    if (contextAndValues) {
        const { getFormState: getFormState, fieldConfig: fieldConfig, selectedProject: selectedProject, selectedIssueType: selectedIssueType } = contextAndValues;
        const formData = getFormState().values;
        Object.keys(formData).forEach((fieldId)=>{
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly summary: (fieldValues: string) => string; readonly duedate: (fieldValues: string) => string; readonly versions: (fieldValues: Options | VersionOption[]) => string; ... 6 more ...; readonly "com.atlassian.jira.plugins.cmdb:cmdb-object-cftype": (fieldValues: CmdbObject[]) => string; }'.
            const extractFieldValue = $0d045ce63aeea11e$var$extractFieldValueMethods[fieldConfig[fieldId]?.fieldType];
            const fieldValues = formData[fieldId];
            if (extractFieldValue && fieldValues) result[fieldId] = extractFieldValue(fieldValues);
        });
        if (selectedProject) result.pid = selectedProject.value;
        if (selectedIssueType) result.issuetype = $0d045ce63aeea11e$var$extractIssueTypeValue(selectedIssueType);
    }
    return result;
};

});

parcelRegister("hOPXt", function(module, exports) {

$parcel$export(module.exports, "usePaginatedAutocomplete", () => $a20a18a2ac8b2128$export$6e13ec0c80bdfaa8);

var $eJOHy = parcelRequire("eJOHy");

var $3s8bj = parcelRequire("3s8bj");

var $8E59C = parcelRequire("8E59C");

var $6U3FB = parcelRequire("6U3FB");

var $2aDN1 = parcelRequire("2aDN1");
const $a20a18a2ac8b2128$var$filterOutAlreadySelectedOptionFromAvailableOptions = (availableOptions, optionsToRemove)=>availableOptions.filter((optionFromRequest)=>!optionsToRemove.find((selectedOption)=>selectedOption.id === optionFromRequest.id));
const $a20a18a2ac8b2128$var$addOrReplaceNewResults = (action, optionsToSave)=>(oldOptions)=>{
        switch(action){
            case (0, $2aDN1.Actions).APPEND:
                return [
                    ...oldOptions,
                    ...optionsToSave
                ];
            case (0, $2aDN1.Actions).REPLACE:
            default:
                return optionsToSave;
        }
    };
const $a20a18a2ac8b2128$var$calculateNumberOfResults = (totalNumberOfResults, savedResultFromTheSearch, displayedOptions)=>{
    if (totalNumberOfResults) return totalNumberOfResults - (savedResultFromTheSearch.length - displayedOptions.length);
    return totalNumberOfResults;
};
const $a20a18a2ac8b2128$export$6e13ec0c80bdfaa8 = (selectedResults, doFetch, transform, contextAndValuesOfIssueBeingCreated)=>{
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(false);
    const [savedResultFromTheSearch, setSavedResultFromTheSearch] = (0, $eJOHy.useState)([]);
    const [hasUserEnteredTextForLastSearch, setHasUserEnteredTextForLastSearch] = (0, $eJOHy.useState)(undefined);
    const [totalNumberOfResults, setTotalNumberOfResults] = (0, $eJOHy.useState)();
    const [error, setError] = (0, $eJOHy.useState)();
    const fetchNextPageRef = (0, $eJOHy.useRef)();
    const isMenuOpen = (0, $eJOHy.useRef)(false);
    const oldContextRef = (0, $eJOHy.useRef)();
    const fetchSearchResults = async (fetchFunction, action)=>{
        setIsLoading(true);
        try {
            const { results: results, fetchNextPage: nextPageFunction, total: total } = await fetchFunction();
            setTotalNumberOfResults(total);
            const newOptions = $a20a18a2ac8b2128$var$filterOutAlreadySelectedOptionFromAvailableOptions(results, selectedResults);
            if (newOptions.length === 0 && nextPageFunction) await fetchSearchResults(nextPageFunction, (0, $2aDN1.Actions).APPEND);
            else fetchNextPageRef.current = nextPageFunction;
            setSavedResultFromTheSearch($a20a18a2ac8b2128$var$addOrReplaceNewResults(action, results));
            (0, $8E59C.autocompleteInsightFieldExperience).success();
            setIsLoading(false);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            fetchNextPageRef.current = undefined;
            (0, $8E59C.autocompleteInsightFieldExperience).failure();
            if (err && err.name === 'AbortError') return;
            setError(err);
            setIsLoading(false);
        }
    };
    const onInputChange = (searchValue, type)=>{
        // Fetch search results not triggered on selection of object
        if (type.action === 'input-change') {
            (0, $8E59C.autocompleteInsightFieldExperience).start();
            setHasUserEnteredTextForLastSearch(searchValue !== '');
            fetchSearchResults(()=>doFetch(searchValue), (0, $2aDN1.Actions).REPLACE);
        }
    };
    const debouncedOnInputChange = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(onInputChange, 400);
    const onMenuScrollToBottom = async ()=>{
        if (fetchNextPageRef.current) {
            (0, $8E59C.autocompleteInsightFieldExperience).start();
            await fetchSearchResults(fetchNextPageRef.current, (0, $2aDN1.Actions).APPEND);
        }
    };
    const hasContextChanged = (currentContext)=>{
        const fieldId = contextAndValuesOfIssueBeingCreated?.fieldId;
        const oldContext = oldContextRef.current;
        if (!oldContext || !currentContext) return false;
        const currentContextKeys = Object.keys(currentContext);
        const oldContextKeys = Object.keys(oldContext);
        if (currentContextKeys.length !== oldContextKeys.length) return true;
        for(let i = 0; i < currentContextKeys.length; i += 1){
            const key = currentContextKeys[i];
            const value1 = currentContext[key];
            const value2 = oldContext[key];
            const isCheckingValueOfCurrentField = fieldId === key;
            if (!isCheckingValueOfCurrentField && value1 !== value2) return true;
        }
        return false;
    };
    const onMenuOpen = async ()=>{
        if (!isMenuOpen.current) {
            isMenuOpen.current = true;
            (0, $8E59C.autocompleteInsightFieldExperience).start();
            const currentContext = (0, $6U3FB.extractFieldValueMap)(contextAndValuesOfIssueBeingCreated);
            if (hasUserEnteredTextForLastSearch !== false || hasContextChanged(currentContext)) {
                await fetchSearchResults(()=>doFetch(''), (0, $2aDN1.Actions).REPLACE);
                setHasUserEnteredTextForLastSearch(false);
                oldContextRef.current = currentContext;
            } else (0, $8E59C.autocompleteInsightFieldExperience).success();
        }
    };
    const onMenuClose = ()=>{
        isMenuOpen.current = false;
    };
    const displayedOptions = (0, $eJOHy.useMemo)(()=>$a20a18a2ac8b2128$var$filterOutAlreadySelectedOptionFromAvailableOptions(savedResultFromTheSearch, selectedResults).map(transform), [
        savedResultFromTheSearch,
        selectedResults,
        transform
    ]);
    return {
        error: error,
        selectProps: {
            isLoading: isLoading,
            options: displayedOptions,
            onInputChange: debouncedOnInputChange,
            onMenuScrollToBottom: onMenuScrollToBottom,
            onMenuOpen: onMenuOpen,
            onMenuClose: onMenuClose
        },
        totalNumberOfResults: $a20a18a2ac8b2128$var$calculateNumberOfResults(totalNumberOfResults, savedResultFromTheSearch, displayedOptions)
    };
};

});
parcelRegister("2aDN1", function(module, exports) {

$parcel$export(module.exports, "Actions", () => $0484d22250c82429$export$b52183d5cfb26dc9);
const $0484d22250c82429$export$b52183d5cfb26dc9 = Object.freeze({
    APPEND: 'APPEND',
    REPLACE: 'REPLACE'
});

});


parcelRegister("43nEs", function(module, exports) {

$parcel$export(module.exports, "ALLOWED_TEXT_AREA_ATTRIBUTE_HTML_TAGS", () => $d6cd90b8647ac288$export$3d2246e48d9cfed3);
$parcel$export(module.exports, "DATE_VALUE_FORMAT", () => $d6cd90b8647ac288$export$d1fb6689cfa66d9b);
$parcel$export(module.exports, "TIME_VALUE_FORMAT", () => $d6cd90b8647ac288$export$5f2ab89513b5926a);
$parcel$export(module.exports, "ZONE_VALUE_FORMAT", () => $d6cd90b8647ac288$export$5c2d6de3ca9adcbe);
$parcel$export(module.exports, "GENERAL_DATE_TIME_FORMAT", () => $d6cd90b8647ac288$export$defafc11b2455f78);
$parcel$export(module.exports, "SCREEN_READER_DATE_TIME_FORMAT", () => $d6cd90b8647ac288$export$f61f3fa9ed38719a);
$parcel$export(module.exports, "globalErrorContexts", () => $d6cd90b8647ac288$export$b896d7bac8b72b0);
$parcel$export(module.exports, "MAX_OBJECT_COUNT_CUTOFF", () => $d6cd90b8647ac288$export$89b103afe26b1ad0);
/**
 * When there is a `textarea` type attribute on an object, the user can enter rich text that
 * is saved and transferred as raw HTML. Because of this, we need to sanitize the input
 * before rendering it to prevent XSS. The below is the allowlist of HTML tags we're expecting
 * to receieve from the editor. All other tags will be stripped out before rendering.
 */ const $d6cd90b8647ac288$export$3d2246e48d9cfed3 = [
    'p',
    'u',
    'a',
    'em',
    'strong',
    'span',
    'ol',
    'ul',
    'li',
    'pre',
    'code',
    'h2',
    'h3',
    'h4',
    'hr',
    'table',
    'thead',
    'tbody',
    'tr',
    'th',
    'td'
];
const $d6cd90b8647ac288$export$d1fb6689cfa66d9b = 'yyyy-MM-dd';
const $d6cd90b8647ac288$export$5f2ab89513b5926a = 'HH:mm';
const $d6cd90b8647ac288$export$5c2d6de3ca9adcbe = 'XXX';
const $d6cd90b8647ac288$export$defafc11b2455f78 = 'dd/MMM/yy h:mm a';
const $d6cd90b8647ac288$export$f61f3fa9ed38719a = 'do MMMM Y h:mm a';
const $d6cd90b8647ac288$export$b896d7bac8b72b0 = [
    'objectsLimit',
    'objectTypeAttributesLimit',
    'objectSchemaLimit'
];
const $d6cd90b8647ac288$export$89b103afe26b1ad0 = 1000;

});

parcelRegister("hdcNT", function(module, exports) {

$parcel$export(module.exports, "searchCmdbObjects", () => $dd56c734439b6066$export$24be3d709330b09);

var $1Ozm9 = parcelRequire("1Ozm9");
const $dd56c734439b6066$var$RESULTS_PER_PAGE = 50;
// @ts-expect-error - TS7031 - Binding element 'size' implicitly has an 'any' type. | TS7031 - Binding element 'hasNextPage' implicitly has an 'any' type. | TS7031 - Binding element 'results' implicitly has an 'any' type. | TS7031 - Binding element 'total' implicitly has an 'any' type.
const $dd56c734439b6066$var$transform = ({ size: size, hasNextPage: hasNextPage, results: results, total: total })=>({
        size: size,
        hasNextPage: hasNextPage,
        // @ts-expect-error - TS7006 - Parameter 'entry' implicitly has an 'any' type.
        results: results.map((entry)=>({
                ...entry,
                // @ts-expect-error - TS7006 - Parameter 'att' implicitly has an 'any' type.
                attributes: entry.attributes.map((att)=>({
                        ...att,
                        type: att.objectTypeAttribute.type
                    }))
            })),
        total: total
    });
let $dd56c734439b6066$var$abortController = null;
const $dd56c734439b6066$export$24be3d709330b09 = async (autoCompleteUrl, query, issueId, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
fieldValueMap, page = 0)=>{
    if ($dd56c734439b6066$var$abortController && $dd56c734439b6066$var$abortController.abort) $dd56c734439b6066$var$abortController.abort();
    $dd56c734439b6066$var$abortController = new AbortController();
    const result = await (0, $1Ozm9.default)(`${autoCompleteUrl}start=${$dd56c734439b6066$var$RESULTS_PER_PAGE * page}&limit=${$dd56c734439b6066$var$RESULTS_PER_PAGE}`, {
        method: 'POST',
        body: JSON.stringify({
            query: query,
            issueId: issueId,
            fieldValueMap: fieldValueMap
        }),
        signal: $dd56c734439b6066$var$abortController.signal
    }).then($dd56c734439b6066$var$transform);
    return {
        results: result.results,
        fetchNextPage: result.hasNextPage ? ()=>$dd56c734439b6066$export$24be3d709330b09(autoCompleteUrl, query, issueId, fieldValueMap, page + 1) : undefined,
        total: result.total
    };
};

});

parcelRegister("5pGc2", function(module, exports) {

$parcel$export(module.exports, "CmdbFieldError", () => $194ae67f1e4db5f8$export$bd2288ff08a8a1d9);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $lrDpY = parcelRequire("lrDpY");

var $eJ9f5 = parcelRequire("eJ9f5");

var $goZPP = parcelRequire("goZPP");

var $806LH = parcelRequire("806LH");

var $d3cA1 = parcelRequire("d3cA1");

var $7jTnu = parcelRequire("7jTnu");

var $lRq8t = parcelRequire("lRq8t");

var $7cSYk = parcelRequire("7cSYk");

var $gSuah = parcelRequire("gSuah");

var $jopyG = parcelRequire("jopyG");

var $lvKO5 = parcelRequire("lvKO5");

var $lpkCu = parcelRequire("lpkCu");
const $194ae67f1e4db5f8$var$UpgradeToPremiumLink = (chunks)=>(0, $7jTnu.fg)('replace-anchor-with-link__falcons') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
        href: (0, $gSuah.getJsmChangeEditionUrl)(),
        target: "_blank"
    }, chunks) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("a", {
        href: (0, $gSuah.getJsmChangeEditionUrl)(),
        target: "_blank"
    }, chunks);
const $194ae67f1e4db5f8$export$cf18a118761851fd = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($194ae67f1e4db5f8$var$InlineMessageContentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($194ae67f1e4db5f8$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d3cA1))), {
        spacing: "spacious",
        label: "error",
        color: "var(--ds-icon-danger, #C9372C)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", null, children));
const $194ae67f1e4db5f8$export$eb21c278059498f8 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)(); // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("p", null, formatMessage((0, $lpkCu.default).errorInvalidFieldConfig));
};
const $194ae67f1e4db5f8$export$22a4392f7c676bd6 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)(); // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("p", null, formatMessage((0, $lpkCu.default).errorInvalidFieldConfigDisabledCmdbAssets));
};
const $194ae67f1e4db5f8$export$14493edb463e15ea = ({ fieldId: fieldId })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("p", null, formatMessage((0, $lpkCu.default).errorInvalidFieldConfigAdmin)), fieldId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        testId: "servicedesk-cmdb-field-object-picker.ui.cmdb-field-error.button",
        appearance: "link",
        href: (0, $lrDpY.getConfigureCustomFieldUrl)(fieldId),
        target: "_blank"
    }, formatMessage((0, $lpkCu.default).errorInvalidFieldConfigAdminLink)));
};
const $194ae67f1e4db5f8$export$3d5c9691c28d309d = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const notPremiumErrorAdmin = formatMessage((0, $lpkCu.default).errorInvalidFieldConfigDowngradedAdminCmdbAssets, {
        a: $194ae67f1e4db5f8$var$UpgradeToPremiumLink
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "xsmall",
        as: "span"
    }, notPremiumErrorAdmin);
};
const $194ae67f1e4db5f8$export$192152d4765eff13 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)(); // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("p", null, formatMessage((0, $lpkCu.default).errorUnknown));
};
const $194ae67f1e4db5f8$export$bd2288ff08a8a1d9 = (props)=>{
    const tenantContext = (0, $lvKO5.useTenantContext)();
    const hasPremium = (0, $jopyG.isPremiumInstance)(tenantContext);
    const isCmdbEnabled = (0, $7cSYk.isCMDBEnabledInEnvironment)(tenantContext.cmdbDisabledInFedRAMP);
    const { isAdmin: isAdmin } = tenantContext;
    const errorBody = (0, $eJOHy.useMemo)(()=>{
        if (!isCmdbEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($194ae67f1e4db5f8$export$22a4392f7c676bd6, null);
        if (hasPremium && !isAdmin) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($194ae67f1e4db5f8$export$eb21c278059498f8, null);
        if (hasPremium && isAdmin) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($194ae67f1e4db5f8$export$14493edb463e15ea, {
            fieldId: props.fieldId
        });
        if (!hasPremium && isAdmin) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($194ae67f1e4db5f8$export$3d5c9691c28d309d, null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($194ae67f1e4db5f8$export$192152d4765eff13, null);
    }, [
        hasPremium,
        isAdmin,
        isCmdbEnabled,
        props.fieldId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($194ae67f1e4db5f8$export$cf18a118761851fd, null, errorBody);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $194ae67f1e4db5f8$var$IconWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2hwxu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $194ae67f1e4db5f8$var$InlineMessageContentWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _ep9tidpf _1oh2idpf _9r1zidpf _99ztidpf _f5gaidpf _1m2uidpf _hstcidpf _9n9oidpf _1vkjeo28",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lrDpY", function(module, exports) {

$parcel$export(module.exports, "getAssociateFieldToScreensUrl", () => $f0ccae485bdf514e$export$23b03b7fae19e4d9);
$parcel$export(module.exports, "getScreenUrl", () => $f0ccae485bdf514e$export$f7bdae1f819aa43b);
$parcel$export(module.exports, "getTranslateCustomFieldUrl", () => $f0ccae485bdf514e$export$d190ce44f97f903);
$parcel$export(module.exports, "getConfigureCustomFieldUrl", () => $f0ccae485bdf514e$export$6e2455bbc376835a);
$parcel$export(module.exports, "getEditCustomFieldUrl", () => $f0ccae485bdf514e$export$16e5d0ee7be5b38f);
$parcel$export(module.exports, "getDeleteCustomFieldUrl", () => $f0ccae485bdf514e$export$45ccfea6f6fbf3cc);
$parcel$export(module.exports, "defaultQuery", () => $f0ccae485bdf514e$export$c08de3b5cc335eeb);
$parcel$export(module.exports, "ITEMS_PER_PAGE", () => $f0ccae485bdf514e$export$ec93a669a20aa982);
$parcel$export(module.exports, "CUSTOM_FIELDS_TYPE", () => $f0ccae485bdf514e$export$49b8e5da9a1d0738);
$parcel$export(module.exports, "ATLASSIAN_TEAM_CF_TYPE", () => $f0ccae485bdf514e$export$d5f572ebd2c1f0d1);

var $lP55g = parcelRequire("lP55g");

const $f0ccae485bdf514e$export$23b03b7fae19e4d9 = (id)=>`/secure/admin/AssociateFieldToScreens!default.jspa?fieldId=${id}`;
const $f0ccae485bdf514e$export$f7bdae1f819aa43b = (screenId)=>`/secure/admin/ConfigureFieldScreen.jspa?id=${screenId}`;
const $f0ccae485bdf514e$export$d190ce44f97f903 = (id)=>`/secure/admin/TranslateCustomField!default.jspa?id=${(0, $lP55g.getTrimId)(id)}`;
const $f0ccae485bdf514e$export$6e2455bbc376835a = (id)=>`/secure/admin/ConfigureCustomField!default.jspa?customFieldId=${(0, $lP55g.getTrimId)(id)}`;
const $f0ccae485bdf514e$export$16e5d0ee7be5b38f = (id)=>`/secure/admin/EditCustomField!default.jspa?id=${(0, $lP55g.getTrimId)(id)}`;
const $f0ccae485bdf514e$export$45ccfea6f6fbf3cc = (id)=>`/secure/admin/DeleteCustomField!default.jspa?id=${(0, $lP55g.getTrimId)(id)}`;
const $f0ccae485bdf514e$export$c08de3b5cc335eeb = {
    searchFilter: undefined,
    customFieldStatus: (0, $c9dc380c2a537db0$export$2b35adb71b3f6143)
};
const $f0ccae485bdf514e$export$ec93a669a20aa982 = 15;
const $f0ccae485bdf514e$export$49b8e5da9a1d0738 = 'custom';
const $f0ccae485bdf514e$export$d5f572ebd2c1f0d1 = 'com.atlassian.jira.plugin.system.customfieldtypes:atlassian-team';

});
parcelRegister("lP55g", function(module, exports) {

$parcel$export(module.exports, "getTrimId", () => $50ae51571fa327e5$export$4817065c39922b39);
const $50ae51571fa327e5$export$4817065c39922b39 = (id)=>id.split('_').reverse()[0];

});

const $c9dc380c2a537db0$export$3c5e605ca7ade9f2 = 'NAME';
const $c9dc380c2a537db0$export$965630dc71fb3a05 = 'LAST_USED';
const $c9dc380c2a537db0$export$d5a7f00a6a604217 = 'SCREENS_AND_CONTEXTS';
const $c9dc380c2a537db0$export$44d67b522cbcce6d = 'PROJECTS';
const $c9dc380c2a537db0$export$421090ea46f71c9c = 'DELETED_ON';
const $c9dc380c2a537db0$export$a7cd2db90465ec68 = 'PERMANENTLY_DELETING';
const $c9dc380c2a537db0$export$2b35adb71b3f6143 = 'Active';
const $c9dc380c2a537db0$export$f1ded5eab7e819b3 = 'Trashed';


parcelRegister("gSuah", function(module, exports) {

$parcel$export(module.exports, "getProjectUrl", () => $617ab16f323338b8$export$951b86b8e730b952);
$parcel$export(module.exports, "getRequestTypesUrl", () => $617ab16f323338b8$export$9d7c743b509e267);
$parcel$export(module.exports, "getChangeRequestTypesUrl", () => $617ab16f323338b8$export$6096ac65eb900914);
$parcel$export(module.exports, "getProjectSettingsPageUrl", () => $617ab16f323338b8$export$75ee62cffcd82d96);
$parcel$export(module.exports, "getProjectSettingsUrl", () => $617ab16f323338b8$export$a497c8f8c3782075);
$parcel$export(module.exports, "getWorkflowSettingsUrl", () => $617ab16f323338b8$export$c2a8139910ee6c);
$parcel$export(module.exports, "getJsmChangeEditionUrl", () => $617ab16f323338b8$export$b87292f363462760);
$parcel$export(module.exports, "getUserManagementUrl", () => $617ab16f323338b8$export$13f39b40814e5f3e);

var $ln6Iy = parcelRequire("ln6Iy");

var $47Jx0 = parcelRequire("47Jx0");

var $dFfRj = parcelRequire("dFfRj");

var $jmJlK = parcelRequire("jmJlK");

var $gwhEz = parcelRequire("gwhEz");

var $02kpm = parcelRequire("02kpm");
const $617ab16f323338b8$export$951b86b8e730b952 = (projectKey)=>(0, $02kpm.generatePath)((0, $gwhEz.projectsRedirectRoute).path, {
        projectKey: projectKey
    });
const $617ab16f323338b8$var$getNextgenIssueTypesUrl = (projectKey, issueTypeId)=>(0, $47Jx0.getNextgenSettingsIssueTypesUrl)((0, $ln6Iy.SERVICE_DESK_PROJECT), projectKey, issueTypeId);
const $617ab16f323338b8$export$9d7c743b509e267 = (projectKey, isSimplified = false)=>isSimplified ? $617ab16f323338b8$var$getNextgenIssueTypesUrl(projectKey) : (0, $02kpm.generatePath)((0, $jmJlK.projectSettingsServicedeskTicketTypesConfigRoute).path, {
        projectKey: projectKey
    });
const $617ab16f323338b8$export$6096ac65eb900914 = (projectKey, isSimplified = false)=>isSimplified ? $617ab16f323338b8$var$getNextgenIssueTypesUrl(projectKey) : `${$617ab16f323338b8$export$9d7c743b509e267(projectKey, isSimplified)}/category/changes`;
const $617ab16f323338b8$export$75ee62cffcd82d96 = (projectKey, relativeUrl)=>`/jira/servicedesk/projects/${projectKey}/settings/${relativeUrl}`;
const $617ab16f323338b8$export$a497c8f8c3782075 = (projectKey, isSimplified = false)=>{
    const classicSettingsUrl = `/plugins/servlet/project-config/${projectKey}`;
    return isSimplified ? $617ab16f323338b8$var$getNextgenIssueTypesUrl(projectKey) : classicSettingsUrl;
};
const $617ab16f323338b8$export$c2a8139910ee6c = (projectKey, issueTypeId, isSimplified = false)=>{
    if (!issueTypeId) return isSimplified ? $617ab16f323338b8$var$getNextgenIssueTypesUrl(projectKey) : (0, $02kpm.generatePath)((0, $dFfRj.legacyProjectSettingsWorkflowsRoute).path, {
        projectKey: projectKey
    });
    return isSimplified ? $617ab16f323338b8$var$getNextgenIssueTypesUrl(projectKey, issueTypeId) : `/plugins/servlet/project-config/${projectKey}/issuetypes/${issueTypeId}/workflow`;
};
const $617ab16f323338b8$export$b87292f363462760 = ()=>'/admin/billing/applications/change-edition/jira-servicedesk.ondemand';
const $617ab16f323338b8$export$13f39b40814e5f3e = ()=>'/admin/users?referrerName=JIRA';

});
parcelRegister("dFfRj", function(module, exports) {

$parcel$export(module.exports, "legacyProjectSettingsWorkflowsRoute", () => $d6f76bba36af0fd3$export$b03606cedffdadf6);
const $d6f76bba36af0fd3$export$b03606cedffdadf6 = {
    name: 'legacy-project-settings-workflows',
    path: '/plugins/servlet/project-config/:projectKey/workflows'
};

});

parcelRegister("gwhEz", function(module, exports) {

$parcel$export(module.exports, "projectsRedirectRoute", () => $210d4f34607aed1b$export$e6bc3ea427ddafb8);
const $210d4f34607aed1b$export$e6bc3ea427ddafb8 = {
    name: 'projects-redirect',
    path: '/projects/:projectKey',
    query: [
        'selectedItem!=(.+)'
    ],
    exact: true
};

});


parcelRegister("lpkCu", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f4043b8ddb6101b$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $1f4043b8ddb6101b$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    errorInvalidFieldConfig: {
        "id": "servicedesk-cmdb-field-object-picker.cmdb-field-error.error-invalid-field-config",
        "defaultMessage": "This field needs to be configured with an object schema. Please contact your admin to configure this field."
    },
    errorInvalidFieldConfigAdmin: {
        "id": "servicedesk-cmdb-field-object-picker.cmdb-field-error.error-invalid-field-config-admin",
        "defaultMessage": "This field needs to be configured with an object schema."
    },
    errorInvalidFieldConfigAdminLink: {
        "id": "servicedesk-cmdb-field-object-picker.cmdb-field-error.error-invalid-field-config-admin-link",
        "defaultMessage": "Configure this custom field"
    },
    errorInvalidFieldConfigDowngradedAdminCmdbAssets: {
        "id": "servicedesk-cmdb-field-object-picker.cmdb-field-error.error-invalid-field-config-downgraded-admin-cmdb-assets",
        "defaultMessage": "Assets is not available in this Jira instance. <a>Upgrade to Premium</a> to re-enable Assets and see this data."
    },
    errorInvalidFieldConfigDisabledCmdbAssets: {
        "id": "servicedesk-cmdb-field-object-picker.cmdb-field-error.error-invalid-field-config-disabled-cmdb-assets",
        "defaultMessage": "Assets is not available in this Jira instance."
    },
    errorUnknown: {
        "id": "servicedesk-cmdb-field-object-picker.cmdb-field-error.error-unknown",
        "defaultMessage": "Something went wrong. Please refresh the page or contact your admin if the problem persists."
    }
});

});


parcelRegister("4hTST", function(module, exports) {

$parcel$export(module.exports, "CmdbSelectOption", () => $77cb5e301b0d1a4d$export$a7be07965a3ed09b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $8nu6j = parcelRequire("8nu6j");
var $dW738 = parcelRequire("dW738");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $rJILZ = parcelRequire("rJILZ");

var $7jTnu = parcelRequire("7jTnu");
const $77cb5e301b0d1a4d$export$fee117cd50d6234b = ({ match: match, children: children })=>{
    if (match === '') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
    // we need to escape special characters to avoid getting them interpreted in the RegExp group
    const escapedSpecialCharsInMatchQuery = match.replace(/[\\.,*+?^${}()|[\]]/g, '\\$&');
    const parts = children.split(new RegExp(`(${escapedSpecialCharsInMatchQuery})`, 'gi'));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, parts.map((part, i)=>{
        if (part.toLowerCase() === match.toLowerCase()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
            as: "strong",
            key: i
        }, part);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
            key: i
        }, part);
    }));
};
const $77cb5e301b0d1a4d$export$cd0f2f750043f4bc = (attributes)=>attributes.map(({ objectAttributeValues: objectAttributeValues })=>objectAttributeValues.map(({ displayValue: displayValue })=>displayValue).join(', ')).join(' | ');
const $77cb5e301b0d1a4d$export$a7be07965a3ed09b = ({ attributesToDisplayInSearch: attributesToDisplayInSearch, data: data, selectProps: selectProps, label: label })=>{
    // Casting to CmdbObject as typing gets lost when passed through AK Select
    const object = data.rawData;
    const { inputValue: inputValue } = selectProps;
    const displayedAttributes = (0, $eJOHy.useMemo)(()=>attributesToDisplayInSearch.map((attrName)=>attrName === 'Label' ? object.attributes.find((attr)=>attr.objectTypeAttribute.label) : object.attributes.find((attr)=>attr.objectTypeAttribute.name === attrName)).filter(Boolean), [
        object,
        attributesToDisplayInSearch
    ]);
    const primaryAttributeString = displayedAttributes?.[0]?.objectAttributeValues // @ts-expect-error - TS2349 - This expression is not callable.
    ?.filter((v)=>v.displayValue) // eslint-disable-line @typescript-eslint/no-explicit-any
    .map((v)=>v.displayValue) // eslint-disable-line @typescript-eslint/no-explicit-any
    .join(', ') || label;
    const attributesString = $77cb5e301b0d1a4d$export$cd0f2f750043f4bc(displayedAttributes.slice(1));
    return (0, $7jTnu.fg)('modern_issue_transition_field_support_cmdb') ? // Fix double hover issue and transformed to Box and Stack to avoid using styled-components
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $77cb5e301b0d1a4d$var$outerBoxStyles,
        testId: "servicedesk-cmdb-field-object-picker.ui.cmdb-select-option"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $77cb5e301b0d1a4d$var$iconWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $rJILZ.MemoizedInsightIcon), {
        mediaClientConfig: object.avatar.mediaClientConfig,
        iconUrl: object.avatar.url48,
        label: object.label,
        size: "small"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $77cb5e301b0d1a4d$var$objectNameStyles,
        testId: "servicedesk-cmdb-field-object-picker.ui.cmdb-select-option.object-name"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($77cb5e301b0d1a4d$export$fee117cd50d6234b, {
        match: inputValue ?? ''
    }, primaryAttributeString)), attributesString && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $77cb5e301b0d1a4d$var$attributesStyles,
        testId: "servicedesk-cmdb-field-object-picker.ui.cmdb-select-option.attributes"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($77cb5e301b0d1a4d$export$fee117cd50d6234b, {
        match: inputValue ?? ''
    }, attributesString)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($77cb5e301b0d1a4d$var$Outer, {
        "data-testid": "servicedesk-cmdb-field-object-picker.ui.cmdb-select-option"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($77cb5e301b0d1a4d$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $rJILZ.MemoizedInsightIcon), {
        mediaClientConfig: object.avatar.mediaClientConfig,
        iconUrl: object.avatar.url48,
        label: object.label,
        size: "small"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($77cb5e301b0d1a4d$var$ObjectName, {
        "data-testid": "servicedesk-cmdb-field-object-picker.ui.cmdb-select-option.object-name"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($77cb5e301b0d1a4d$export$fee117cd50d6234b, {
        match: inputValue ?? ''
    }, primaryAttributeString)), attributesString && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($77cb5e301b0d1a4d$var$Attributes, {
        "data-testid": "servicedesk-cmdb-field-object-picker.ui.cmdb-select-option.attributes"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($77cb5e301b0d1a4d$export$fee117cd50d6234b, {
        match: inputValue ?? ''
    }, attributesString))));
};
const $77cb5e301b0d1a4d$var$outerBoxStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    alignItems: 'center',
    paddingTop: 'space.100',
    paddingRight: 'space.200',
    paddingBottom: 'space.100',
    paddingLeft: 'space.200'
});
const $77cb5e301b0d1a4d$var$iconWrapperStyles = (0, $1DXK0.xcss)({
    marginRight: 'space.150',
    flexShrink: 0
});
const $77cb5e301b0d1a4d$var$objectNameStyles = (0, $1DXK0.xcss)({
    font: 'font.body'
});
const $77cb5e301b0d1a4d$var$attributesStyles = (0, $1DXK0.xcss)({
    font: 'font.body.UNSAFE_small'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $77cb5e301b0d1a4d$var$Outer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _ca0qu2gc _u5f3pxbi _n3tdu2gc _19bvpxbi _irr3166n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $77cb5e301b0d1a4d$var$IconWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2hwxutpp _1o9zidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $77cb5e301b0d1a4d$var$ObjectName = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c82smr _vwz41tcg",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $77cb5e301b0d1a4d$var$Attributes = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c8dcr7",
            __cmplp.className
        ])
    });
});

});
parcelRegister("rJILZ", function(module, exports) {

$parcel$export(module.exports, "InsightIcon", () => $b4089468fa56dc7f$export$4f72cced31fa9b94);
$parcel$export(module.exports, "MemoizedInsightIcon", () => $b4089468fa56dc7f$export$55641517b59933d7);
$parcel$export(module.exports, "UnstyledInsightIcon", () => $b4089468fa56dc7f$export$30c7947f25987be2);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $2TCFC = parcelRequire("2TCFC");
var $5DgXR = parcelRequire("5DgXR");
var $lC3pF = parcelRequire("lC3pF");

var $cgxPA = parcelRequire("cgxPA");

var $51aj0 = parcelRequire("51aj0");
const $b4089468fa56dc7f$export$d80733771196ad02 = (mediaClientConfig)=>Boolean(mediaClientConfig.mediaBaseUrl) && Boolean(mediaClientConfig.mediaJwtToken) && Boolean(mediaClientConfig.clientId) && Boolean(mediaClientConfig.fileId);
const $b4089468fa56dc7f$var$DefaultIcon = ({ size: size, label: label })=>/*#__PURE__*/ $eJOHy.createElement((0, $5DgXR.default), {
        appearance: "square",
        size: size,
        name: label
    });
const $b4089468fa56dc7f$export$a39db5532f57c7c2 = (clientAuth)=>Promise.resolve({
        clientId: clientAuth.clientId,
        token: clientAuth.mediaJwtToken,
        // eslint-disable-next-line jira/deprecations/no-base-url
        baseUrl: clientAuth.mediaBaseUrl
    });
const $b4089468fa56dc7f$export$4f72cced31fa9b94 = (props)=>{
    const { iconUrl: iconUrl, size: size, label: label, mediaClientConfig: mediaClientConfig } = props;
    const sizeInPx = (0, $2TCFC.AVATAR_SIZES)[size];
    const renderAvatar = (src)=>/*#__PURE__*/ $eJOHy.createElement("img", {
            loading: "lazy",
            src: src,
            width: sizeInPx,
            height: sizeInPx,
            alt: ""
        });
    if (!mediaClientConfig || $b4089468fa56dc7f$export$d80733771196ad02(mediaClientConfig) === false) {
        if (iconUrl) return renderAvatar(iconUrl);
        return /*#__PURE__*/ $eJOHy.createElement($b4089468fa56dc7f$var$DefaultIcon, {
            size: size,
            label: label
        });
    }
    const fileIdentifier = {
        id: mediaClientConfig.fileId,
        mediaItemType: 'file'
    };
    const imageSize = {
        width: (0, $2TCFC.AVATAR_SIZES)[size],
        height: (0, $2TCFC.AVATAR_SIZES)[size]
    };
    return /*#__PURE__*/ $eJOHy.createElement((0, $cgxPA.MediaImageWithErrorBoundary), {
        identifier: fileIdentifier,
        mediaClientConfig: {
            authProvider: ()=>$b4089468fa56dc7f$export$a39db5532f57c7c2(mediaClientConfig)
        },
        apiConfig: imageSize
    }, ({ loading: loading, error: error, data: data })=>{
        if (loading) return /*#__PURE__*/ $eJOHy.createElement((0, $lC3pF.default), {
            appearance: "square",
            size: size
        });
        if (error) {
            (0, $51aj0.fireCmdbErrorAnalytics)({
                error: // @ts-expect-error - TS2322 - Type 'true' is not assignable to type 'Error | undefined'.
                error,
                meta: {
                    id: 'insightIcon',
                    packageName: 'jiraServicedeskInsightIcon',
                    teamName: 'aurum'
                }
            });
            return /*#__PURE__*/ $eJOHy.createElement($b4089468fa56dc7f$var$DefaultIcon, {
                size: size,
                label: label
            });
        }
        if (!data) return /*#__PURE__*/ $eJOHy.createElement($b4089468fa56dc7f$var$DefaultIcon, {
            size: size,
            label: label
        });
        return renderAvatar(data.src);
    });
};
const $b4089468fa56dc7f$export$55641517b59933d7 = /*#__PURE__*/ (0, $eJOHy.memo)($b4089468fa56dc7f$export$4f72cced31fa9b94);
const $b4089468fa56dc7f$export$30c7947f25987be2 = (props)=>/*#__PURE__*/ $eJOHy.createElement($b4089468fa56dc7f$var$UnstyledInsightIconWrapper, null, /*#__PURE__*/ $eJOHy.createElement($b4089468fa56dc7f$export$55641517b59933d7, props));
/**
 * The reason for calling !important on display block is to ovveride the inherited
 * CSS from Avatar atlaskit component in order to centre the icon within the reference
 * object container.
 */ // Double check the shadow !
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b4089468fa56dc7f$var$UnstyledInsightIconWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pk1i6y _2hwx1i6y _otyr1i6y _18u01i6y _1e0c1txw _p7r1tcjq _1ugpglyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lC3pF", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd8f08acdf78d9e1$export$2e2bcd8739ae039);
/* skeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $fd8f08acdf78d9e1$var$bgColorCssVar = '--avatar-skeleton-background-color';
const $fd8f08acdf78d9e1$var$styles = {
    root: "_2rko1q5u _189e1bk5 _1dqonqa1 _1h6d3acm _1e0c1o8l _bfhk1r8p _tzy4nh7s",
    strongOpacity: "_tzy4clii"
};
const $fd8f08acdf78d9e1$var$sizeStyles = {
    xsmall: "_1bsb7vkz _4t3i7vkz",
    small: "_1bsb1tcg _4t3i1tcg",
    medium: "_1bsbzwfg _4t3izwfg",
    large: "_1bsb1ylp _4t3i1ylp",
    xlarge: "_1bsb16xz _4t3i16xz",
    xxlarge: "_1bsb1qr7 _4t3i1qr7"
};
const $fd8f08acdf78d9e1$var$borderRadiusMap = {
    xsmall: "_2rkogqwt",
    small: "_2rkogqwt",
    medium: "_2rko1l7b",
    large: "_2rko1l7b",
    xlarge: "_2rkoi2wt",
    xxlarge: "_2rkob7nn"
};
/**
 * __Skeleton__
 *
 * A skeleton is the loading state for the avatar component.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-skeleton/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-skeleton/code)
 */ const $fd8f08acdf78d9e1$var$Skeleton = ({ size: size, appearance: appearance, color: color, weight: weight })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        style: {
            [$fd8f08acdf78d9e1$var$bgColorCssVar]: color ?? 'currentColor'
        },
        className: (0, $hcewu.default)([
            $fd8f08acdf78d9e1$var$styles.root,
            $fd8f08acdf78d9e1$var$sizeStyles[size ?? 'medium'],
            appearance === 'square' && $fd8f08acdf78d9e1$var$borderRadiusMap[size ?? 'medium'],
            weight === 'strong' && $fd8f08acdf78d9e1$var$styles.strongOpacity
        ])
    });
var $fd8f08acdf78d9e1$export$2e2bcd8739ae039 = $fd8f08acdf78d9e1$var$Skeleton;

});

parcelRegister("cgxPA", function(module, exports) {

$parcel$export(module.exports, "MediaImageWithErrorBoundary", () => $4d10e61645f59e88$export$758a2fef95a29ad0);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $axOsj = parcelRequire("axOsj");

var $iDkaD = parcelRequire("iDkaD");
const $4d10e61645f59e88$export$758a2fef95a29ad0 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $axOsj.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
            children: props.children({
                loading: false,
                error: true
            })
        }),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iDkaD.MediaImageWithMediaClient), {
            ...props
        })
    });

});
parcelRegister("iDkaD", function(module, exports) {

$parcel$export(module.exports, "MediaImageWithMediaClient", () => $124670e45144e8f4$export$8acd7eecc88dfeb5);
/* mediaImage.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $cu5Ae = parcelRequire("cu5Ae");

var $iN7PZ = parcelRequire("iN7PZ");

var $eGOwo = parcelRequire("eGOwo");
const $124670e45144e8f4$var$copyDivStyles = null;
const $124670e45144e8f4$var$MediaImageBase = ({ identifier: identifier, apiConfig: apiConfig = {}, children: children, ssr: ssr })=>{
    const { width: width, height: height, mode: mode, allowAnimated: allowAnimated, upscale: upscale, 'max-age': maxAge } = apiConfig;
    const dimensions = {
        width: width,
        height: height
    };
    const { preview: preview, error: error, copyNodeRef: copyNodeRef, getSsrScriptProps: getSsrScriptProps } = (0, $iN7PZ.useFilePreview)({
        identifier: identifier,
        dimensions: dimensions,
        ssr: ssr,
        resizeMode: mode,
        allowAnimated: allowAnimated,
        upscale: upscale,
        maxAge: maxAge
    });
    //----------------------------------------------------------------
    // RENDER
    //----------------------------------------------------------------
    let status = 'loading';
    if (preview?.dataURI) status = 'succeeded';
    else if (error) status = 'error';
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            children({
                loading: status === 'loading',
                error: status === 'error',
                data: status === 'succeeded' ? {
                    status: status,
                    src: preview?.dataURI
                } : undefined
            }),
            (0, $eGOwo.fg)('platform_media_cross_client_copy') && /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                ref: copyNodeRef,
                className: (0, $hcewu.default)([
                    "_1e0cglyw"
                ])
            }),
            getSsrScriptProps && /*#__PURE__*/ (0, $gt9Am.jsx)("script", {
                ...getSsrScriptProps()
            })
        ]
    });
};
const $124670e45144e8f4$export$8acd7eecc88dfeb5 = (props)=>{
    const MediaImageComponent = (0, $eJOHy.useMemo)(()=>(0, $cu5Ae.withMediaClient)($124670e45144e8f4$var$MediaImageBase), []);
    return /*#__PURE__*/ (0, $gt9Am.jsx)(MediaImageComponent, {
        ...props
    });
};

});
parcelRegister("cu5Ae", function(module, exports) {

$parcel$export(module.exports, "withMediaClient", () => $5bfc4058bddc627f$export$9f7977d4a2561bee);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $93R6D = parcelRequire("93R6D");
const $5bfc4058bddc627f$export$9f7977d4a2561bee = (Component)=>({ mediaClientConfig: mediaClientConfig, ...otherProps })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $93R6D.MediaClientContext).Consumer, {
            children: (value)=>value ? /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
                    ...otherProps,
                    mediaClient: value
                }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $93R6D.MediaClientProvider), {
                    clientConfig: mediaClientConfig,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $93R6D.MediaClientContext).Consumer, {
                        children: (client)=>/*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
                                ...otherProps,
                                mediaClient: client
                            })
                    })
                })
        });

});

parcelRegister("iN7PZ", function(module, exports) {

$parcel$export(module.exports, "useFilePreview", () => $e54d3f9e11f733f6$export$4eaebdef02112fe4);

var $eJOHy = parcelRequire("eJOHy");

var $bbNl0 = parcelRequire("bbNl0");
var $4rKJa = parcelRequire("4rKJa");

var $kCvcX = parcelRequire("kCvcX");
var $djK7X = parcelRequire("djK7X");
var $3cc2J = parcelRequire("3cc2J");

var $fK3MF = parcelRequire("fK3MF");

var $e2t9t = parcelRequire("e2t9t");

var $33YQ1 = parcelRequire("33YQ1");

var $k9eRE = parcelRequire("k9eRE");
var $hNvWT = parcelRequire("hNvWT");
var $9Mg12 = parcelRequire("9Mg12");

var $i0gVY = parcelRequire("i0gVY");
var $8Dv9L = parcelRequire("8Dv9L");

var $3c1p9 = parcelRequire("3c1p9");
const $e54d3f9e11f733f6$export$4eaebdef02112fe4 = ({ resizeMode: resizeMode = 'crop', identifier: identifier, ssr: ssr, dimensions: dimensions, traceContext: traceContext, skipRemote: skipRemote, mediaBlobUrlAttrs: mediaBlobUrlAttrs, allowAnimated: allowAnimated = true, upscale: upscale, maxAge: maxAge, source: source })=>{
    const mediaClient = (0, $3cc2J.useMediaClient)();
    const [status, setStatus] = (0, $eJOHy.useState)('loading');
    const [error, setError] = (0, $eJOHy.useState)();
    const [nonCriticalError, setNonCriticalError] = (0, $eJOHy.useState)();
    const [isBannedLocalPreview, setIsBannedLocalPreview] = (0, $eJOHy.useState)(false);
    const [upfrontPreviewStatus, setUpfrontPreviewStatus] = (0, $eJOHy.useState)('not-resolved');
    const ssrReliabilityRef = (0, $eJOHy.useRef)({
        server: {
            status: 'unknown'
        },
        client: {
            status: 'unknown'
        }
    });
    const requestDimensions = (0, $eJOHy.useMemo)(()=>dimensions ? (0, $3c1p9.createRequestDimensions)(dimensions) : undefined, [
        dimensions
    ]);
    const requestDimensionsRef = (0, $3c1p9.useCurrentValueRef)(requestDimensions);
    let imageURLParams = {
        collection: identifier.collectionName,
        mode: resizeMode,
        ...requestDimensions,
        allowAnimated: allowAnimated,
        upscale: upscale,
        'max-age': maxAge
    };
    imageURLParams = {
        ...imageURLParams,
        source: source
    };
    const previewInitializer = ()=>{
        const preview = (0, $9Mg12.mediaFilePreviewCache).get(identifier.id, resizeMode);
        if (preview) return preview;
        if (ssr) {
            const ssrData = (0, $8Dv9L.getSSRData)(identifier);
            if (ssrData?.error) ssrReliabilityRef.current.server = {
                status: 'fail',
                ...ssrData.error
            };
            if (!ssrData?.dataURI) try {
                return (0, $k9eRE.getSSRPreview)(ssr, mediaClient, identifier.id, imageURLParams, mediaBlobUrlAttrs);
            } catch (e) {
                ssrReliabilityRef.current[ssr] = {
                    status: 'fail',
                    ...(0, $e2t9t.extractErrorInfo)(e, traceContext)
                };
            }
            else {
                const { dimensions: dimensions, dataURI: dataURI } = ssrData;
                return {
                    dataURI: dataURI,
                    dimensions: dimensions,
                    source: 'ssr-data'
                };
            }
        }
    };
    const [preview, setPreview] = (0, $eJOHy.useState)(previewInitializer);
    //----------------------------------------------------------------
    // FILE STATE
    //----------------------------------------------------------------
    const { fileState: fileState } = (0, $djK7X.useFileState)(identifier.id, {
        skipRemote: skipRemote,
        collectionName: identifier.collectionName,
        occurrenceKey: identifier.occurrenceKey
    });
    // Derived from File State
    const isBackendPreviewReady = !!fileState && (0, $bbNl0.isImageRepresentationReady)(fileState);
    const fileStateErrorMessage = fileState?.status === 'error' ? fileState.message : undefined;
    const { preview: localBinary, mediaType: mediaType, mimeType: mimeType } = fileState && fileState?.status !== 'error' ? fileState : {};
    //----------------------------------------------------------------
    // Update status
    //----------------------------------------------------------------
    // TOOD: make a full hook reset (remount) on New identifier or client
    (0, $eJOHy.useEffect)(()=>{
        setStatus('loading');
    }, [
        identifier
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (status !== 'error') {
            if (preview || fileState?.status === 'processed' && !isBackendPreviewReady) setStatus('complete');
            else if (!preview && fileState?.status === 'failed-processing' && !isBackendPreviewReady) {
                setStatus('error');
                setError(new (0, $33YQ1.MediaFilePreviewError)('failed-processing'));
            } else if (!preview && fileState?.status === 'error' && upfrontPreviewStatus === 'resolved') {
                setStatus('error');
                setError(new (0, $33YQ1.MediaFilePreviewError)('metadata-fetch', (0, $4rKJa.toCommonMediaClientError)(fileState)));
            } else setStatus('loading');
        }
    }, [
        preview,
        status,
        fileState,
        isBackendPreviewReady,
        fileStateErrorMessage,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // Preview Fetch Helper
    //----------------------------------------------------------------
    const getAndCacheRemotePreviewRef = (0, $3c1p9.useCurrentValueRef)(()=>{
        return (0, $k9eRE.getAndCacheRemotePreview)(mediaClient, identifier.id, requestDimensions || {}, imageURLParams, mediaBlobUrlAttrs, traceContext);
    });
    //----------------------------------------------------------------
    // Upfront Preview
    //----------------------------------------------------------------
    (0, $eJOHy.useEffect)(()=>{
        // Only fetch upfront (no file state) if there is no preview in the state already
        if (preview) setUpfrontPreviewStatus('resolved');
        else if (!preview && upfrontPreviewStatus === 'not-resolved' && !skipRemote) {
            // We block any possible future call to this method regardless of the outcome (success or fail)
            // If it fails, the normal preview fetch should occur after the file state is fetched anyways
            setUpfrontPreviewStatus('resolving');
            const fetchedDimensions = {
                ...requestDimensions
            };
            getAndCacheRemotePreviewRef.current().then((newPreview)=>{
                // If there are new and bigger dimensions in the props, and the upfront preview is still resolving,
                // the fetched preview is no longer valid, and thus, we dismiss it
                if (!(0, $3c1p9.isBigger)(fetchedDimensions, requestDimensionsRef.current)) setPreview(newPreview);
            }).catch(()=>{
            // NO need to log error. If this call fails, a refetch will happen after
            }).finally(()=>{
                setUpfrontPreviewStatus('resolved');
            });
        }
    }, [
        getAndCacheRemotePreviewRef,
        preview,
        requestDimensions,
        requestDimensionsRef,
        skipRemote,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // Cache, Local & Remote Preview
    //----------------------------------------------------------------
    const mediaBlobUrlAttrsRef = (0, $3c1p9.useCurrentValueRef)(mediaBlobUrlAttrs);
    (0, $eJOHy.useEffect)(()=>{
        const cachedPreview = (0, $9Mg12.mediaFilePreviewCache).get(identifier.id, resizeMode);
        // Cached Preview ----------------------------------------------------------------
        if (!preview && cachedPreview && !(0, $3c1p9.isBigger)(cachedPreview?.dimensions, requestDimensions)) setPreview(cachedPreview);
        else if (!preview && !isBannedLocalPreview && localBinary && (0, $hNvWT.isSupportedLocalPreview)(mediaType) && (0, $fK3MF.isMimeTypeSupportedByBrowser)(mimeType || '')) // Local preview is available only if it's supported by browser and supported by Media Card (isSupportedLocalPreview)
        // For example, SVGs are mime type NOT supported by browser but media type supported by Media Card (image)
        // Then, local Preview NOT available
        (0, $k9eRE.getAndCacheLocalPreview)(identifier.id, localBinary, requestDimensions || {}, resizeMode, mediaBlobUrlAttrsRef.current).then(setPreview).catch((e)=>{
            setIsBannedLocalPreview(true);
            // CXP-2723 TODO: We might have to wrap this error in MediaCardError
            setNonCriticalError(e);
        });
        else if (!error && !nonCriticalError && (!preview || (0, $3c1p9.isBigger)(preview.dimensions, requestDimensions) || // We always refetch SSR preview to be able to browser-cache a version without the token in the query parameters
        (0, $k9eRE.isSSRPreview)(preview)) && !skipRemote && upfrontPreviewStatus === 'resolved' && isBackendPreviewReady) getAndCacheRemotePreviewRef.current().then(setPreview).catch((e)=>{
            const wrappedError = (0, $33YQ1.ensureMediaFilePreviewError)('preview-fetch', e);
            if (!preview) {
                setStatus('error');
                setError(wrappedError);
            } else // If there is already a preview, we consider it a non-critical error
            setNonCriticalError(wrappedError);
        });
    }, [
        error,
        nonCriticalError,
        getAndCacheRemotePreviewRef,
        identifier.id,
        resizeMode,
        isBannedLocalPreview,
        mediaBlobUrlAttrsRef,
        preview,
        requestDimensions,
        skipRemote,
        isBackendPreviewReady,
        localBinary,
        mediaType,
        mimeType,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // RETURN
    //----------------------------------------------------------------
    const onImageError = (0, $eJOHy.useCallback)((failedPreview)=>{
        if (!failedPreview) return;
        if ((0, $k9eRE.isSSRClientPreview)(failedPreview)) ssrReliabilityRef.current.client = (0, $e2t9t.createFailedSSRObject)(failedPreview, traceContext);
        // If the preview failed and it comes from server (global scope / ssrData), it means that we have reused it in client and the error counts for both: server & client.
        if ((0, $k9eRE.isSSRDataPreview)(failedPreview)) {
            ssrReliabilityRef.current.server = (0, $e2t9t.createFailedSSRObject)(failedPreview, traceContext);
            ssrReliabilityRef.current.client = (0, $e2t9t.createFailedSSRObject)(failedPreview, traceContext);
        }
        // If the dataURI has been replaced, we can dismiss this error
        if (failedPreview.dataURI !== preview?.dataURI) return;
        const isLocal = (0, $k9eRE.isLocalPreview)(failedPreview);
        const isRemote = (0, $k9eRE.isRemotePreview)(failedPreview);
        if (isLocal || isRemote) {
            const error = new (0, $33YQ1.ImageLoadError)(failedPreview?.source);
            (0, $9Mg12.mediaFilePreviewCache).remove(identifier.id, resizeMode);
            if (isLocal) setIsBannedLocalPreview(true);
            if (isRemote) {
                setStatus('error');
                setError(error);
            }
            setPreview(undefined);
        }
    }, [
        identifier.id,
        preview?.dataURI,
        resizeMode,
        traceContext
    ]);
    const onImageLoad = (0, $eJOHy.useCallback)((newPreview)=>{
        if (newPreview) {
            if ((0, $k9eRE.isSSRClientPreview)(newPreview) && ssrReliabilityRef.current.client.status === 'unknown') ssrReliabilityRef.current.client = {
                status: 'success'
            };
            /*
        If the image loads successfully and it comes from server (global scope / ssrData), it means that we have reused it in client and the success counts for both: server & client.
      */ if ((0, $k9eRE.isSSRDataPreview)(newPreview) && ssrReliabilityRef.current.server.status === 'unknown') {
                ssrReliabilityRef.current.server = {
                    status: 'success'
                };
                ssrReliabilityRef.current.client = {
                    status: 'success'
                };
            }
        }
        // If the dataURI has been replaced, we can dismiss this callback
        if (newPreview?.dataURI !== preview?.dataURI) return;
    }, [
        preview?.dataURI
    ]);
    // FOR SSR
    const getSsrScriptProps = ssr === 'server' ? ()=>(0, $i0gVY.generateScriptProps)(identifier, preview?.dataURI, requestDimensions, ssrReliabilityRef.current.server?.status === 'fail' ? ssrReliabilityRef.current.server : undefined) : undefined;
    const { copyNodeRef: copyNodeRef } = (0, $kCvcX.useCopyIntent)(identifier.id, {
        collectionName: identifier.collectionName
    });
    // CXP-2723 TODO: should consider simplifying our analytics, and how
    // we might get rid of ssrReliabiltyRef from our hook
    return {
        preview: preview,
        status: status,
        error: error,
        nonCriticalError: nonCriticalError,
        ssrReliability: ssrReliabilityRef.current,
        onImageError: onImageError,
        onImageLoad: onImageLoad,
        getSsrScriptProps: getSsrScriptProps,
        copyNodeRef: copyNodeRef
    };
};

});
parcelRegister("kCvcX", function(module, exports) {

$parcel$export(module.exports, "useCopyIntent", () => $556b9eb703c9e12d$export$46fd859414de9d62);

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $eGOwo = parcelRequire("eGOwo");

var $3cc2J = parcelRequire("3cc2J");

var $bMoFA = parcelRequire("bMoFA");

var $b7hyt = parcelRequire("b7hyt");
function $556b9eb703c9e12d$var$useCurrentValueRef(value) {
    const ref = (0, $eJOHy.useRef)(value);
    ref.current = value;
    return ref;
}
const $556b9eb703c9e12d$export$46fd859414de9d62 = (id, options = {})=>{
    const mediaClient = (0, $3cc2J.useMediaClient)();
    const innerRef = (0, $eJOHy.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const registerCopyIntentRef = $556b9eb703c9e12d$var$useCurrentValueRef(async ()=>{
        try {
            await mediaClient.file.registerCopyIntent(id, options.collectionName);
            createAnalyticsEvent((0, $bMoFA.getCopyIntentSuccessPayload)(id));
        } catch (err) {
            createAnalyticsEvent((0, $bMoFA.getCopyIntentErrorPayload)(err, id));
        }
    });
    const copyNodeRef = (0, $eJOHy.useCallback)((elem)=>{
        innerRef.current = elem;
        if ((0, $eGOwo.fg)('platform_media_cross_client_copy')) elem?.addEventListener('contextmenu', ()=>{
            registerCopyIntentRef.current();
        });
    }, [
        registerCopyIntentRef
    ]);
    const onGlobalCopy = (0, $eJOHy.useCallback)(async ()=>{
        const currentCopyTarget = innerRef.current;
        const currentSelectionContainsNode = currentCopyTarget && getSelection()?.containsNode(currentCopyTarget, true);
        if (currentSelectionContainsNode) registerCopyIntentRef.current();
    }, [
        registerCopyIntentRef
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if ((0, $eGOwo.fg)('platform_media_cross_client_copy')) (0, $b7hyt.getDocument)()?.addEventListener('copy', onGlobalCopy);
        return ()=>(0, $b7hyt.getDocument)()?.removeEventListener('copy', onGlobalCopy);
    }, [
        onGlobalCopy
    ]);
    return {
        copyNodeRef: copyNodeRef
    };
};

});
parcelRegister("3cc2J", function(module, exports) {

$parcel$export(module.exports, "useMediaClient", () => $d8e7b96ea4671e74$export$8b3e87ea56c3a345);

var $eJOHy = parcelRequire("eJOHy");

var $93R6D = parcelRequire("93R6D");

var $f7iZ0 = parcelRequire("f7iZ0");
const $d8e7b96ea4671e74$export$8b3e87ea56c3a345 = ()=>{
    const mediaClient = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useContext((0, $93R6D.MediaClientContext));
    const { mediaClient: altMediaClient } = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useContext((0, $f7iZ0.MediaContext)) || {};
    if (!mediaClient && !altMediaClient) throw new Error('No MediaClient set, use MediaClientProvider or MediaProvider to set one');
    // WARNING: typescript can't infer that at least one mediaClient is defined here. Adding the `!` is a hack to make typescript happy.
    return mediaClient || altMediaClient;
};

});
parcelRegister("f7iZ0", function(module, exports) {

$parcel$export(module.exports, "MediaContext", () => $b977b15c2bc7301b$export$c94ff18a59d4c4d);
$parcel$export(module.exports, "MediaProvider", () => $b977b15c2bc7301b$export$57164260bc1f1218);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $aRuva = parcelRequire("aRuva");

var $lMkQs = parcelRequire("lMkQs");
const $b977b15c2bc7301b$export$c94ff18a59d4c4d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext(undefined);
const $b977b15c2bc7301b$export$57164260bc1f1218 = ({ children: children, mediaClientConfig: mediaClientConfig, mediaSettings: mediaSettings })=>{
    const mediaClient = (0, $eJOHy.useMemo)(()=>(0, $aRuva.getMediaClient)(mediaClientConfig), [
        mediaClientConfig
    ]);
    const settings = (0, $lMkQs.useMediaParsedSettings)(mediaSettings);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($b977b15c2bc7301b$export$c94ff18a59d4c4d.Provider, {
        value: {
            mediaClient: mediaClient,
            settings: settings
        },
        children: children
    });
};

});
parcelRegister("lMkQs", function(module, exports) {

$parcel$export(module.exports, "useMediaParsedSettings", () => $e0ef7db6f81da61d$export$d54af28440a5efc0);

var $eJOHy = parcelRequire("eJOHy");

var $4iDQM = parcelRequire("4iDQM");
const $e0ef7db6f81da61d$export$d54af28440a5efc0 = (mediaSettings = {})=>{
    const settings = (0, $eJOHy.useMemo)(()=>{
        const newSettings = {
            ...mediaSettings
        };
        newSettings.mediaUserPreferences = (0, $4iDQM.defaultMediaUserPreferences);
        return newSettings;
    }, [
        mediaSettings
    ]);
    return settings;
};

});
parcelRegister("4iDQM", function(module, exports) {

$parcel$export(module.exports, "defaultMediaUserPreferences", () => $fd3af50559080092$export$2d23ed2854ac1650);
// Currently only supports boolean, string. Uncomment below to support number
const $fd3af50559080092$var$MediaUserPreferencesTypes = {
    videoCaptionsEnabled: 'boolean',
    videoCaptionsPreferredLocale: 'string'
};
const $fd3af50559080092$export$7e209e67b965bc63 = (userPreferences)=>({
        set: (key, value)=>{
            userPreferences.set(key, value.toString());
        },
        get: (key)=>{
            const value = userPreferences.get(key);
            if (value === null || value === undefined) return undefined;
            if ($fd3af50559080092$var$MediaUserPreferencesTypes[key] === 'boolean') return value === 'true';
            // Uncomment to support number
            // if (MediaUserSettingsTypes[key] === 'number') {
            // 	return Number(value) as MediaSettingsTypeMap[K];
            // }
            return value;
        }
    });
const $fd3af50559080092$var$defaultUserPreferences = {
    set: (key, value)=>{
        const MEDIA_KEY = 'media';
        localStorage.setItem(`${MEDIA_KEY}-${key}`, value);
    },
    get: (key)=>{
        const MEDIA_KEY = 'media';
        return localStorage.getItem(`${MEDIA_KEY}-${key}`);
    }
};
const $fd3af50559080092$export$2d23ed2854ac1650 = $fd3af50559080092$export$7e209e67b965bc63($fd3af50559080092$var$defaultUserPreferences);

});




parcelRegister("bMoFA", function(module, exports) {

$parcel$export(module.exports, "getCopyIntentErrorPayload", () => $93f079c5c30deecd$export$3ab52330b662b987);
$parcel$export(module.exports, "getCopyIntentSuccessPayload", () => $93f079c5c30deecd$export$aacb463551da2e8f);

var $h3W10 = parcelRequire("h3W10");
const $93f079c5c30deecd$var$getRequestErrorDetails = (err)=>{
    if ((0, $h3W10.isRequestError)(err)) return {
        request: {
            statusCode: err.metadata?.statusCode,
            traceContext: err.metadata?.traceContext,
            mediaEnv: err.metadata?.mediaEnv,
            mediaRegion: err.metadata?.mediaRegion
        }
    };
};
const $93f079c5c30deecd$export$3ab52330b662b987 = (error, fileId = '')=>{
    return {
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaCopyIntent',
        failReason: (0, $h3W10.isRequestError)(error) ? error.reason : 'nativeError',
        attributes: {
            status: 'fail',
            fileAttributes: {
                fileId: fileId
            },
            ...$93f079c5c30deecd$var$getRequestErrorDetails(error)
        }
    };
};
const $93f079c5c30deecd$export$aacb463551da2e8f = (fileId = '')=>{
    return {
        eventType: 'operational',
        action: 'succeeded',
        actionSubject: 'mediaCopyIntent',
        attributes: {
            fileAttributes: {
                fileId: fileId
            }
        }
    };
};

});

parcelRegister("b7hyt", function(module, exports) {

$parcel$export(module.exports, "getDocument", () => $b67882b47b14e094$export$f65ca476c09acec0);
const $b67882b47b14e094$export$f65ca476c09acec0 = ()=>{
    if (typeof window === 'undefined') return;
    if (typeof window.document === 'undefined') return;
    return window.document;
};

});


parcelRegister("djK7X", function(module, exports) {

$parcel$export(module.exports, "useFileState", () => $5a07b53d359ee7c3$export$90ff537b0999afb);

var $eJOHy = parcelRequire("eJOHy");

var $3cc2J = parcelRequire("3cc2J");

var $kNd6B = parcelRequire("kNd6B");
function $5a07b53d359ee7c3$export$90ff537b0999afb(id, options = {}) {
    const { collectionName: collectionName, occurrenceKey: occurrenceKey, skipRemote: skipRemote = false, includeHashForDuplicateFiles: includeHashForDuplicateFiles } = options;
    const mediaClient = (0, $3cc2J.useMediaClient)();
    const fileState = (0, $kNd6B.useMediaStore)((state)=>state.files[id]);
    (0, $eJOHy.useEffect)(()=>{
        // No need to resubscribe if there is a fileState already
        if (!fileState && !skipRemote) mediaClient.file.getFileState(id, {
            collectionName: collectionName,
            occurrenceKey: occurrenceKey,
            includeHashForDuplicateFiles: includeHashForDuplicateFiles
        });
    }, [
        id,
        mediaClient,
        collectionName,
        occurrenceKey,
        skipRemote,
        fileState,
        includeHashForDuplicateFiles
    ]);
    return {
        fileState: fileState
    };
}

});
parcelRegister("kNd6B", function(module, exports) {

$parcel$export(module.exports, "useMediaStore", () => $d5b1e147a2796345$export$8a9cc8c330400af8);

var $eOVQp = parcelRequire("eOVQp");

var $3cc2J = parcelRequire("3cc2J");
const $d5b1e147a2796345$var$createBoundedUseStore = (store)=>(selector, equals)=>(0, $eOVQp.useStore)(store, selector, equals);
function $d5b1e147a2796345$export$8a9cc8c330400af8(selector, equals) {
    const mediaClient = (0, $3cc2J.useMediaClient)();
    const store = mediaClient.__DO_NOT_USE__getMediaStore();
    const useBoundStore = $d5b1e147a2796345$var$createBoundedUseStore(store);
    return useBoundStore(selector, equals);
}

});
parcelRegister("eOVQp", function(module, exports) {

$parcel$export(module.exports, "useStore", () => $aca29ade4cd157ce$export$6ccbb43953eebf8);

var $96y8R = parcelRequire("96y8R");

var $eJOHy = parcelRequire("eJOHy");

var $iHcr1 = parcelRequire("iHcr1");
var $aca29ade4cd157ce$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/zustand/esm/index.mjs"
});
const { useDebugValue: $aca29ade4cd157ce$var$useDebugValue } = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy)));
const { useSyncExternalStoreWithSelector: $aca29ade4cd157ce$var$useSyncExternalStoreWithSelector } = (0, (/*@__PURE__*/$parcel$interopDefault($iHcr1)));
let $aca29ade4cd157ce$var$didWarnAboutEqualityFn = false;
const $aca29ade4cd157ce$var$identity = (arg)=>arg;
function $aca29ade4cd157ce$export$6ccbb43953eebf8(api, selector = $aca29ade4cd157ce$var$identity, equalityFn) {
    if (($aca29ade4cd157ce$import_meta.env ? $aca29ade4cd157ce$import_meta.env.MODE : void 0) !== "production" && equalityFn && !$aca29ade4cd157ce$var$didWarnAboutEqualityFn) {
        console.warn("[DEPRECATED] Use `createWithEqualityFn` instead of `create` or use `useStoreWithEqualityFn` instead of `useStore`. They can be imported from 'zustand/traditional'. https://github.com/pmndrs/zustand/discussions/1937");
        $aca29ade4cd157ce$var$didWarnAboutEqualityFn = true;
    }
    const slice = $aca29ade4cd157ce$var$useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getInitialState, selector, equalityFn);
    $aca29ade4cd157ce$var$useDebugValue(slice);
    return slice;
}
const $aca29ade4cd157ce$var$createImpl = (createState)=>{
    if (($aca29ade4cd157ce$import_meta.env ? $aca29ade4cd157ce$import_meta.env.MODE : void 0) !== "production" && typeof createState !== "function") console.warn("[DEPRECATED] Passing a vanilla store will be unsupported in a future version. Instead use `import { useStore } from 'zustand'`.");
    const api = typeof createState === "function" ? (0, $96y8R.createStore)(createState) : createState;
    const useBoundStore = (selector, equalityFn)=>$aca29ade4cd157ce$export$6ccbb43953eebf8(api, selector, equalityFn);
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
const $aca29ade4cd157ce$export$185802fd694ee1f5 = (createState)=>createState ? $aca29ade4cd157ce$var$createImpl(createState) : $aca29ade4cd157ce$var$createImpl;
var $aca29ade4cd157ce$export$2e2bcd8739ae039 = (createState)=>{
    if (($aca29ade4cd157ce$import_meta.env ? $aca29ade4cd157ce$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use `import { create } from 'zustand'`.");
    return $aca29ade4cd157ce$export$185802fd694ee1f5(createState);
};

});



parcelRegister("e2t9t", function(module, exports) {

$parcel$export(module.exports, "extractErrorInfo", () => $3f058c26ca766723$export$74aaf4784c2edb2c);
$parcel$export(module.exports, "createFailedSSRObject", () => $3f058c26ca766723$export$768c370ed0dbaeb3);

var $4rKJa = parcelRequire("4rKJa");

var $33YQ1 = parcelRequire("33YQ1");
const $3f058c26ca766723$export$29aa614726672b2e = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $4rKJa.isCommonMediaClientError)(secondaryError)) return secondaryError.metadata?.traceContext;
};
const $3f058c26ca766723$export$4af9d71992e89714 = (error)=>{
    return error.primaryReason || 'nativeError';
};
const $3f058c26ca766723$export$88c61dcad53762da = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $4rKJa.isCommonMediaClientError)(secondaryError)) return secondaryError.reason;
    return 'nativeError';
};
const $3f058c26ca766723$export$9ccc5365d056da4b = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $4rKJa.isCommonMediaClientError)(secondaryError)) return secondaryError.message;
    return error.message;
};
const $3f058c26ca766723$export$74aaf4784c2edb2c = (error, metadataTraceContext)=>{
    return {
        failReason: $3f058c26ca766723$export$4af9d71992e89714(error),
        error: $3f058c26ca766723$export$88c61dcad53762da(error),
        errorDetail: $3f058c26ca766723$export$9ccc5365d056da4b(error),
        metadataTraceContext: metadataTraceContext ?? $3f058c26ca766723$export$29aa614726672b2e(error)
    };
};
const $3f058c26ca766723$export$768c370ed0dbaeb3 = (preview, metadataTraceContext)=>({
        status: 'fail',
        ...$3f058c26ca766723$export$74aaf4784c2edb2c(new (0, $33YQ1.ImageLoadError)(preview.source), metadataTraceContext)
    });

});
parcelRegister("33YQ1", function(module, exports) {

$parcel$export(module.exports, "MediaFilePreviewError", () => $ba556c1ff2a47bc7$export$96e559194c287cf4);
$parcel$export(module.exports, "LocalPreviewError", () => $ba556c1ff2a47bc7$export$2c035820a31723e);
$parcel$export(module.exports, "RemotePreviewError", () => $ba556c1ff2a47bc7$export$10ab445310d30114);
$parcel$export(module.exports, "SsrPreviewError", () => $ba556c1ff2a47bc7$export$18e89b7e50818288);
$parcel$export(module.exports, "ImageLoadError", () => $ba556c1ff2a47bc7$export$d0a45ab59b4606b);
$parcel$export(module.exports, "ensureMediaFilePreviewError", () => $ba556c1ff2a47bc7$export$7156ce7b78b49bd7);
class $ba556c1ff2a47bc7$export$96e559194c287cf4 extends Error {
    constructor(primaryReason, secondaryError){
        super(primaryReason), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(this, new.target.prototype);
        // https://v8.dev/docs/stack-trace-api
        if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
    }
}
class $ba556c1ff2a47bc7$export$2c035820a31723e extends $ba556c1ff2a47bc7$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
class $ba556c1ff2a47bc7$export$10ab445310d30114 extends $ba556c1ff2a47bc7$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
class $ba556c1ff2a47bc7$export$18e89b7e50818288 extends $ba556c1ff2a47bc7$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
const $ba556c1ff2a47bc7$var$getImageLoadPrimaryReason = (source)=>{
    switch(source){
        case 'cache-remote':
            return 'cache-remote-uri';
        case 'cache-local':
            return 'cache-local-uri';
        case 'external':
            return 'external-uri';
        case 'local':
            return 'local-uri';
        case 'remote':
            return 'remote-uri';
        case 'ssr-client':
            return 'ssr-client-uri';
        case 'ssr-server':
        case 'ssr-data':
            return 'ssr-server-uri';
        // This fail reason will come from a bug, most likely.
        default:
            return `unknown-uri`;
    }
};
class $ba556c1ff2a47bc7$export$d0a45ab59b4606b extends $ba556c1ff2a47bc7$export$96e559194c287cf4 {
    constructor(source){
        super($ba556c1ff2a47bc7$var$getImageLoadPrimaryReason(source));
    }
}
function $ba556c1ff2a47bc7$export$553696a6e769784c(err) {
    return err instanceof $ba556c1ff2a47bc7$export$96e559194c287cf4;
}
const $ba556c1ff2a47bc7$export$b380593ba3516c6f = (err)=>err instanceof $ba556c1ff2a47bc7$export$2c035820a31723e;
const $ba556c1ff2a47bc7$export$e1d87830b3784f94 = (err)=>err instanceof $ba556c1ff2a47bc7$export$10ab445310d30114;
const $ba556c1ff2a47bc7$export$443aeb298d35d79d = (err)=>$ba556c1ff2a47bc7$export$553696a6e769784c(err) && err.primaryReason === 'local-preview-unsupported';
const $ba556c1ff2a47bc7$export$7156ce7b78b49bd7 = (primaryReason, error, updatePrimaryReason)=>{
    if ($ba556c1ff2a47bc7$export$553696a6e769784c(error)) {
        if (updatePrimaryReason && error.primaryReason !== primaryReason) return new $ba556c1ff2a47bc7$export$96e559194c287cf4(primaryReason, error.secondaryError);
        return error;
    }
    return new $ba556c1ff2a47bc7$export$96e559194c287cf4(primaryReason, error);
};

});


parcelRegister("k9eRE", function(module, exports) {

$parcel$export(module.exports, "getSSRPreview", () => $acdcd6198e7dee1d$export$faf1c301c59a1bdc);
$parcel$export(module.exports, "isLocalPreview", () => $acdcd6198e7dee1d$export$78ad02c5efc361c9);
$parcel$export(module.exports, "isRemotePreview", () => $acdcd6198e7dee1d$export$87442a14a8a19e0);
$parcel$export(module.exports, "isSSRClientPreview", () => $acdcd6198e7dee1d$export$36aae1afbc0a9661);
$parcel$export(module.exports, "isSSRDataPreview", () => $acdcd6198e7dee1d$export$f366c2c8a792cce6);
$parcel$export(module.exports, "isSSRPreview", () => $acdcd6198e7dee1d$export$dea79d05143ccf4);
$parcel$export(module.exports, "getAndCacheRemotePreview", () => $acdcd6198e7dee1d$export$49721bcc26fb9388);
$parcel$export(module.exports, "getAndCacheLocalPreview", () => $acdcd6198e7dee1d$export$98e935d981c884d);

var $bajro = parcelRequire("bajro");

var $33YQ1 = parcelRequire("33YQ1");

var $9Mg12 = parcelRequire("9Mg12");

var $hNvWT = parcelRequire("hNvWT");
const $acdcd6198e7dee1d$var$extendAndCachePreview = (id, mode, preview, mediaBlobUrlAttrs)=>{
    let source;
    switch(preview.source){
        case 'local':
            source = 'cache-local';
            break;
        case 'remote':
            source = 'cache-remote';
            break;
        default:
            source = preview.source;
    }
    // We want to embed some meta context into dataURI for Copy/Paste to work.
    const dataURI = mediaBlobUrlAttrs ? (0, $bajro.addFileAttrsToUrl)(preview.dataURI, mediaBlobUrlAttrs) : preview.dataURI;
    // We store new cardPreview into cache
    (0, $9Mg12.mediaFilePreviewCache).set(id, mode, {
        ...preview,
        source: source,
        dataURI: dataURI
    });
    return {
        ...preview,
        dataURI: dataURI
    };
};
const $acdcd6198e7dee1d$export$faf1c301c59a1bdc = (ssr, mediaClient, id, params, mediaBlobUrlAttrs)=>{
    let dataURI;
    try {
        const rawDataURI = mediaClient.getImageUrlSync(id, params);
        // We want to embed some meta context into dataURI for Copy/Paste to work.
        dataURI = mediaBlobUrlAttrs ? (0, $bajro.addFileAttrsToUrl)(rawDataURI, mediaBlobUrlAttrs) : rawDataURI;
        const source = ssr === 'client' ? 'ssr-client' : 'ssr-server';
        return {
            dataURI: dataURI,
            source: source,
            orientation: 1
        };
    } catch (e) {
        const reason = ssr === 'server' ? 'ssr-server-uri' : 'ssr-client-uri';
        throw new (0, $33YQ1.SsrPreviewError)(reason, e instanceof Error ? e : undefined);
    }
};
const $acdcd6198e7dee1d$export$78ad02c5efc361c9 = (preview)=>{
    const localSources = [
        'local',
        'cache-local'
    ];
    return localSources.includes(preview.source);
};
const $acdcd6198e7dee1d$export$87442a14a8a19e0 = (preview)=>{
    const remoteSources = [
        'remote',
        'cache-remote'
    ];
    return remoteSources.includes(preview.source);
};
const $acdcd6198e7dee1d$export$36aae1afbc0a9661 = (preview)=>preview.source === 'ssr-client';
const $acdcd6198e7dee1d$export$f366c2c8a792cce6 = (preview)=>preview.source === 'ssr-data';
const $acdcd6198e7dee1d$export$dea79d05143ccf4 = (preview)=>{
    const ssrClientSources = [
        'ssr-client',
        'ssr-server',
        'ssr-data'
    ];
    return ssrClientSources.includes(preview.source);
};
const $acdcd6198e7dee1d$export$49721bcc26fb9388 = async (mediaClient, id, dimensions, params, mediaBlobUrlAttrs, traceContext)=>{
    const remotePreview = await (0, $hNvWT.getRemotePreview)(mediaClient, id, params, traceContext);
    return $acdcd6198e7dee1d$var$extendAndCachePreview(id, params.mode, {
        ...remotePreview,
        dimensions: dimensions
    }, mediaBlobUrlAttrs);
};
const $acdcd6198e7dee1d$export$98e935d981c884d = async (id, filePreview, dimensions, mode, mediaBlobUrlAttrs)=>{
    const localPreview = await (0, $hNvWT.getLocalPreview)(filePreview);
    return $acdcd6198e7dee1d$var$extendAndCachePreview(id, mode, {
        ...localPreview,
        dimensions: dimensions
    }, mediaBlobUrlAttrs);
};

});
parcelRegister("bajro", function(module, exports) {

$parcel$export(module.exports, "isMediaBlobUrl", () => $dd0a5c69b434a5a7$export$e1e8ad57ada2d90);
$parcel$export(module.exports, "getAttrsFromUrl", () => $dd0a5c69b434a5a7$export$b91a9e94ff0cbb29);
$parcel$export(module.exports, "addFileAttrsToUrl", () => $dd0a5c69b434a5a7$export$e51a8146182600b8);
const $dd0a5c69b434a5a7$var$mediaBlobUrlIdentifier = 'media-blob-url';
const $dd0a5c69b434a5a7$export$e1e8ad57ada2d90 = (url)=>{
    return url.indexOf(`${$dd0a5c69b434a5a7$var$mediaBlobUrlIdentifier}=true`) > -1;
};
const $dd0a5c69b434a5a7$var$getNumberFromParams = (params, name)=>{
    const value = params.get(name);
    return typeof value === 'string' && !isNaN(parseInt(value)) ? parseInt(value) : undefined;
};
const $dd0a5c69b434a5a7$var$getStringFromParams = (params, name)=>{
    const value = params.get(name);
    if (!value) return;
    return decodeURIComponent(value);
};
const $dd0a5c69b434a5a7$export$b91a9e94ff0cbb29 = (blobUrl)=>{
    const url = new URL(blobUrl);
    const hash = url.hash.replace('#', '');
    const params = new URLSearchParams(hash);
    const id = params.get('id');
    const contextId = params.get('contextId');
    // check if we have the required params
    if (!id || !contextId) return;
    return {
        id: id,
        contextId: contextId,
        collection: $dd0a5c69b434a5a7$var$getStringFromParams(params, 'collection'),
        alt: $dd0a5c69b434a5a7$var$getStringFromParams(params, 'alt'),
        height: $dd0a5c69b434a5a7$var$getNumberFromParams(params, 'height'),
        width: $dd0a5c69b434a5a7$var$getNumberFromParams(params, 'width'),
        size: $dd0a5c69b434a5a7$var$getNumberFromParams(params, 'size'),
        name: $dd0a5c69b434a5a7$var$getStringFromParams(params, 'name'),
        mimeType: $dd0a5c69b434a5a7$var$getStringFromParams(params, 'mimeType')
    };
};
const $dd0a5c69b434a5a7$export$89a7e74069fbb7af = (json)=>{
    return Object.keys(json).filter((attrName)=>typeof json[attrName] !== 'undefined' && json[attrName] !== null).map((key)=>{
        const value = json[key];
        if (typeof value === 'undefined' || value === null) return;
        return `${encodeURIComponent(key)}=${encodeURIComponent(value.toString())}`;
    }).join('&');
};
const $dd0a5c69b434a5a7$export$e51a8146182600b8 = (url, fileAttrs)=>{
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (isSafari) return url;
    const mediaIdentifierAttr = {
        [$dd0a5c69b434a5a7$var$mediaBlobUrlIdentifier]: 'true'
    };
    const mergedAttrs = {
        ...mediaIdentifierAttr,
        ...fileAttrs
    };
    const queryAttrs = $dd0a5c69b434a5a7$export$89a7e74069fbb7af(mergedAttrs);
    // we can't use '?' separator for blob url params
    return `${url}#${queryAttrs}`;
};

});

parcelRegister("9Mg12", function(module, exports) {

$parcel$export(module.exports, "mediaFilePreviewCache", () => $d9909271b08294f2$export$b7e8ee3f7a41459);

var $4ZQua = parcelRequire("4ZQua");
const $d9909271b08294f2$export$611736262b635f8d = (id, mode)=>{
    const resizeMode = mode || 'crop';
    return [
        id,
        resizeMode
    ].join('-');
};
class $d9909271b08294f2$export$7b50526c091bb915 {
    constructor(previewCache){
        this.previewCache = previewCache;
        this.get = (id, mode)=>{
            const cacheKey = $d9909271b08294f2$export$611736262b635f8d(id, mode);
            return this.previewCache.get(cacheKey);
        };
        this.set = (id, mode, cardPreview)=>{
            const cacheKey = $d9909271b08294f2$export$611736262b635f8d(id, mode);
            this.previewCache.set(cacheKey, cardPreview);
        };
        this.remove = (id, mode)=>{
            const cacheKey = $d9909271b08294f2$export$611736262b635f8d(id, mode);
            this.previewCache.remove(cacheKey);
        };
        this.clear = ()=>{
            this.previewCache.clear();
        };
    }
}
const $d9909271b08294f2$export$b7e8ee3f7a41459 = new $d9909271b08294f2$export$7b50526c091bb915((0, $4ZQua.createObjectURLCache)());

});
parcelRegister("4ZQua", function(module, exports) {

$parcel$export(module.exports, "createObjectURLCache", () => $7640c7504dcb2ad6$export$ba71be67d5c32535);

var $adK77 = parcelRequire("adK77");

var $7xkt0 = parcelRequire("7xkt0");
const $7640c7504dcb2ad6$export$36d0f9859761643d = 50;
class $7640c7504dcb2ad6$var$ExtendedLRUCache extends (0, $7xkt0.LRUMap) {
    constructor(limit){
        super(limit);
        this.eventEmitter = new (0, $adK77.EventEmitter2)();
    }
    shift() {
        const entry = super.shift();
        this.eventEmitter.emit('shift', entry);
        return entry;
    }
    on(event, callback) {
        this.eventEmitter.on(event, callback);
    }
}
class $7640c7504dcb2ad6$export$75d1c8c9ba1d0773 {
    constructor(size){
        this.cache = new $7640c7504dcb2ad6$var$ExtendedLRUCache(size);
        this.cache.on('shift', (entry)=>{
            if (entry && entry[1].dataURI) URL.revokeObjectURL(entry[1].dataURI);
        });
    }
    has(key) {
        return !!this.cache.find(key);
    }
    get(key) {
        return this.cache.get(key);
    }
    set(key, value) {
        this.cache.set(key, value);
    }
    remove(key) {
        const removed = this.cache.delete(key);
        removed && URL.revokeObjectURL(removed.dataURI);
    }
    clear() {
        this.cache.clear();
    }
}
const $7640c7504dcb2ad6$export$ba71be67d5c32535 = ()=>new $7640c7504dcb2ad6$export$75d1c8c9ba1d0773($7640c7504dcb2ad6$export$36d0f9859761643d);

});


parcelRegister("hNvWT", function(module, exports) {

$parcel$export(module.exports, "isSupportedLocalPreview", () => $3247cef0fce3851d$export$1fa85b75e8662d54);
$parcel$export(module.exports, "getLocalPreview", () => $3247cef0fce3851d$export$3d6ed68e437b8c99);
$parcel$export(module.exports, "getRemotePreview", () => $3247cef0fce3851d$export$bfe20bd01db02b3);

var $5JVfG = parcelRequire("5JVfG");

var $cK5G4 = parcelRequire("cK5G4");

var $33YQ1 = parcelRequire("33YQ1");

var $heXDA = parcelRequire("heXDA");
const $3247cef0fce3851d$export$1fa85b75e8662d54 = (mediaType)=>mediaType === 'image' || mediaType === 'video';
const $3247cef0fce3851d$var$getImageLocalPreview = async (value)=>{
    try {
        const orientation = await (0, $cK5G4.getOrientation)(value);
        const dataURI = URL.createObjectURL(value);
        return {
            dataURI: dataURI,
            orientation: orientation,
            source: 'local'
        };
    } catch (e) {
        throw new (0, $33YQ1.LocalPreviewError)('local-preview-image', e instanceof Error ? e : undefined);
    }
};
const $3247cef0fce3851d$var$getVideoLocalPreview = async (value)=>{
    try {
        const dataURI = await (0, $heXDA.takeSnapshot)(value);
        return {
            dataURI: dataURI,
            orientation: 1,
            source: 'local'
        };
    } catch (e) {
        throw new (0, $33YQ1.LocalPreviewError)('local-preview-video', e instanceof Error ? e : undefined);
    }
};
const $3247cef0fce3851d$export$3d6ed68e437b8c99 = async (filePreview)=>{
    let value;
    try {
        const resolvedFilePreview = await filePreview;
        value = resolvedFilePreview.value;
    } catch (e) {
        throw new (0, $33YQ1.LocalPreviewError)('local-preview-rejected', e instanceof Error ? e : undefined);
    }
    if (typeof value === 'string') return {
        dataURI: value,
        orientation: 1,
        source: 'local'
    };
    else if (value instanceof Blob) {
        const { type: type } = value;
        const mediaType = (0, $5JVfG.getMediaTypeFromMimeType)(type);
        switch(mediaType){
            case 'image':
                return $3247cef0fce3851d$var$getImageLocalPreview(value);
            case 'video':
                return $3247cef0fce3851d$var$getVideoLocalPreview(value);
            default:
                throw new (0, $33YQ1.LocalPreviewError)('local-preview-unsupported');
        }
    }
    throw new (0, $33YQ1.LocalPreviewError)('local-preview-unsupported');
};
const $3247cef0fce3851d$export$bfe20bd01db02b3 = async (mediaClient, id, params, traceContext)=>{
    try {
        const blob = await mediaClient.getImage(id, params, undefined, undefined, traceContext);
        return {
            dataURI: URL.createObjectURL(blob),
            orientation: 1,
            source: 'remote'
        };
    } catch (e) {
        throw new (0, $33YQ1.RemotePreviewError)('remote-preview-fetch', e instanceof Error ? e : undefined);
    }
};

});
parcelRegister("cK5G4", function(module, exports) {

$parcel$export(module.exports, "getImageInfo", () => $4622caaad73ce041$export$2176b0e68c10508f);
$parcel$export(module.exports, "getOrientation", () => $4622caaad73ce041$export$67689507e8404821);

var $9PgO0 = parcelRequire("9PgO0");

var $f8uqC = parcelRequire("f8uqC");

var $fOXQV = parcelRequire("fOXQV");

var $kHzU5 = parcelRequire("kHzU5");
const { Orientation: $4622caaad73ce041$var$Orientation, XResolution: $4622caaad73ce041$var$XResolution } = (0, $9PgO0.SupportedImageMetaTag);
// http://bonfx.com/why-is-the-web-72-dpi-and-print-300-dpi/
const $4622caaad73ce041$var$DPI_WEB_BASELINE = 72;
async function $4622caaad73ce041$export$2176b0e68c10508f(fileInfo) {
    const metadata = await $4622caaad73ce041$export$c142eb1c8c5c79c(fileInfo);
    if (!metadata) return null;
    const { width: width, height: height, tags: tags } = metadata;
    const scaleFactor = $4622caaad73ce041$export$dd08dbbf61041ccd(fileInfo.file, tags);
    return {
        scaleFactor: scaleFactor,
        width: width,
        height: height
    };
}
function $4622caaad73ce041$export$dd08dbbf61041ccd(file, tags) {
    const scaleFactorFromFilename = $4622caaad73ce041$export$11cb6a214555dd36(file);
    if (scaleFactorFromFilename !== null) return scaleFactorFromFilename;
    else if (tags) {
        /**
		 * Scale Factor is actually a 2D thing, but in practice X & Y are same in 99% cases.
		 * So we are only relying on X axis.
		 */ if (typeof tags['PixelPerUnitX'] === 'number') // 1 inch = 0.0254 meters
        return Math.round(tags['PixelPerUnitX'] * 0.0254) / $4622caaad73ce041$var$DPI_WEB_BASELINE;
        else return $4622caaad73ce041$export$268f92356524130b(tags, $4622caaad73ce041$var$XResolution, $4622caaad73ce041$var$DPI_WEB_BASELINE) / $4622caaad73ce041$var$DPI_WEB_BASELINE;
    } else return 1;
}
const $4622caaad73ce041$var$getOrientationFromTags = (tags)=>{
    if (tags && tags[$4622caaad73ce041$var$Orientation]) {
        const tagValue = tags[$4622caaad73ce041$var$Orientation];
        if (tagValue) {
            const numericValue = parseInt(tagValue, 10);
            if (isNaN(numericValue)) return (0, $9PgO0.ExifOrientation)[tagValue];
            return numericValue;
        }
    }
    return 1;
};
async function $4622caaad73ce041$export$67689507e8404821(file) {
    const tags = await (0, $f8uqC.readImageMetaTags)(file);
    return $4622caaad73ce041$var$getOrientationFromTags(tags);
}
function $4622caaad73ce041$export$268f92356524130b(tags, key, defaultValue) {
    try {
        const num = parseFloat(`${tags[key]}`);
        if (!isNaN(num)) return num;
    } catch (e) {
    //
    }
    return defaultValue;
}
function $4622caaad73ce041$export$11cb6a214555dd36(file) {
    try {
        // filenames with scale ratio in name take precedence - eg. filename@2x.png
        const match = file.name.trim().match(/@([0-9\.]+)x\.[a-z]{3}$/);
        if (match) return parseFloat(match[1]);
    } catch (e) {
    // parse problem, return null
    }
    return null;
}
async function $4622caaad73ce041$export$c142eb1c8c5c79c(fileInfo) {
    const { file: file, src: src } = fileInfo;
    const type = file.type;
    let width = 0;
    let height = 0;
    const tags = await (0, $f8uqC.readImageMetaTags)(file);
    // since we're reading metadata anyway, try to get dimensions from there...
    if (tags && tags.PixelXDimension) width = $4622caaad73ce041$export$268f92356524130b(tags, 'PixelXDimension', 0);
    if (tags && tags.PixelXDimension) height = $4622caaad73ce041$export$268f92356524130b(tags, 'PixelYDimension', 0);
    const data = {
        type: type,
        width: width,
        height: height,
        naturalWidth: width,
        naturalHeight: height,
        tags: tags
    };
    /*
	 * The PixelXDimension and PixelYDimension of image tags can mean something different than just width and height, especially when images are compressed or for other reasons.
	 * https://imagemagick.org/discourse-server/viewtopic.php?t=27037
	 * We've also received JAC tickets reporting incorrect dimensions because of this
	 * https://jira.atlassian.com/browse/CONFCLOUD-78275
	 * The best way to get accurate dimensions is by loading images into the HTML, which reflects the actual dimensions the browser will render
	 */ try {
        const img = await (0, $fOXQV.loadImage)(src);
        const { width: width, height: height } = (0, $fOXQV.readImageNaturalOrientationFromDOM)(img);
        data.width = width;
        data.height = height;
        data.naturalWidth = img.naturalWidth;
        data.naturalHeight = img.naturalHeight;
    } catch (e) {
        return null;
    }
    return data;
}

});
parcelRegister("9PgO0", function(module, exports) {

$parcel$export(module.exports, "ImageType", () => $c8d64cb551bef33f$export$48c85e6e32ef0825);
$parcel$export(module.exports, "SupportedImageMetaTag", () => $c8d64cb551bef33f$export$e369bb48cf33e564);
$parcel$export(module.exports, "ExifOrientation", () => $c8d64cb551bef33f$export$f6ea0c89fd7d156);
var $c8d64cb551bef33f$export$48c85e6e32ef0825 = /*#__PURE__*/ function(ImageType) {
    ImageType["JPEG"] = "image/jpeg";
    ImageType["PNG"] = "image/png";
    return ImageType;
}({});
var $c8d64cb551bef33f$export$e369bb48cf33e564 = /*#__PURE__*/ function(SupportedImageMetaTag) {
    SupportedImageMetaTag["XResolution"] = "XResolution";
    SupportedImageMetaTag["YResolution"] = "YResolution";
    SupportedImageMetaTag["Orientation"] = "Orientation";
    return SupportedImageMetaTag;
}({});
const $c8d64cb551bef33f$export$f6ea0c89fd7d156 = {
    'top-left': 1,
    'top-right': 2,
    'bottom-right': 3,
    'bottom-left': 4,
    'left-top': 5,
    'right-top': 6,
    'right-bottom': 7,
    'left-bottom': 8
};

});

parcelRegister("f8uqC", function(module, exports) {

$parcel$export(module.exports, "readImageMetaTags", () => $80e2aeeb99751964$export$41982b5c7acb23c4);

var $9PgO0 = parcelRequire("9PgO0");

var $dCEVY = parcelRequire("dCEVY");

var $7BlyC = parcelRequire("7BlyC");

var $3yAnp = parcelRequire("3yAnp");
async function $80e2aeeb99751964$export$41982b5c7acb23c4(file) {
    const type = file.type;
    try {
        if (type === (0, $9PgO0.ImageType).PNG) {
            // http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Summary-of-standard-chunks
            // iTXt = XML text with metadata
            // pHYs = Physical pixel dimensions
            const { iTXt: iTXt, pHYs: pHYs } = await (0, $7BlyC.readPNGXMPMetaData)(file);
            const xmpMetaData = {
                ...(0, $3yAnp.parseXMPMetaData)(iTXt),
                ...pHYs
            };
            return xmpMetaData;
        } else if (file.type === (0, $9PgO0.ImageType).JPEG) return await (0, $dCEVY.readJPEGExifMetaData)(file);
    } catch (e) {
    // problem parsing metadata
    }
    return null;
}

});
parcelRegister("dCEVY", function(module, exports) {

$parcel$export(module.exports, "readJPEGExifMetaData", () => $ff103de7f6ab6f18$export$556b2ccec62d7f2a);

var $9PgO0 = parcelRequire("9PgO0");
const { XResolution: $ff103de7f6ab6f18$var$XResolution, YResolution: $ff103de7f6ab6f18$var$YResolution } = (0, $9PgO0.SupportedImageMetaTag);
let $ff103de7f6ab6f18$var$loadImage;

function $ff103de7f6ab6f18$export$556b2ccec62d7f2a(file) {
    return new Promise(async (resolve, reject)=>{
        if (!$ff103de7f6ab6f18$var$loadImage) {
            const module = await (parcelRequire("9JMwr"));
            $ff103de7f6ab6f18$var$loadImage = module.default || module;
        }
        $ff103de7f6ab6f18$var$loadImage.parseMetaData(file, (data)=>{
            try {
                const tags = data && data.exif ? data.exif.getAll() : {};
                Object.keys(tags).forEach((key)=>{
                    const value = tags[key];
                    if (typeof value === 'object' && (key === $ff103de7f6ab6f18$var$XResolution || key === $ff103de7f6ab6f18$var$YResolution) && 'numerator' in value) // some test images had this structure, so just take the numerator value to simplify returned value
                    tags[key] = value.numerator;
                    if (typeof tags[key] === 'number') // in case numbers types were auto-converted, keep everything the same between jpeg & png we keep as strings
                    tags[key] = `${tags[key]}`;
                });
                resolve(tags);
            } catch (e) {
                reject(e);
            }
        });
    });
}

});
parcelRegister("9JMwr", function(module, exports) {

let $716df486413b4273$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $716df486413b4273$var$load("2HU4O").then(()=>parcelRequire('4Mu1O'));

});


parcelRegister("7BlyC", function(module, exports) {

$parcel$export(module.exports, "readPNGXMPMetaData", () => $e9cd4ca7c89b16ee$export$5fb37736440fca6f);

var $fOXQV = parcelRequire("fOXQV");
let $e9cd4ca7c89b16ee$var$pngChunksExtract;

async function $e9cd4ca7c89b16ee$export$5fb37736440fca6f(file) {
    if (!$e9cd4ca7c89b16ee$var$pngChunksExtract) {
        const module = await (parcelRequire("dopkG"));
        $e9cd4ca7c89b16ee$var$pngChunksExtract = module.default || module;
    }
    const buffer = await (0, $fOXQV.fileToArrayBuffer)(file);
    const chunks = $e9cd4ca7c89b16ee$var$pngChunksExtract(buffer);
    return await $e9cd4ca7c89b16ee$export$9185743fdd58ce45(chunks);
}
async function $e9cd4ca7c89b16ee$export$9185743fdd58ce45(chunks) {
    let iTXt = '';
    let pHYs = {};
    /**
	 * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Summary-of-standard-chunks
	 * Order of every chunk is not guaranteed.
	 * And both iTXt and pHYs are Ancillary chunks.
	 */ for(let i = 0; i < chunks.length; ++i){
        const chunk = chunks[i];
        // Must be last
        if (chunk.name === 'IEND') break;
        /**
		 * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Anc-text
		 * iTXt contains the useful XMP/XML string data of meta tags
		 */ if (chunk.name === 'iTXt') iTXt = String.fromCharCode.apply(null, Array.from(chunk.data));
        /**
		 * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.pHYs
		 * Pixels per unit, X axis: 4 bytes (unsigned integer)
		 * Pixels per unit, Y axis: 4 bytes (unsigned integer)
		 * Unit specifier:          1 byte  (0: unit is unknown 1: unit is the meter)
		 */ if (chunk.name === 'pHYs') {
            const dv = new DataView(chunk.data.buffer);
            const unitSpecifier = dv.getUint8(8);
            // meter
            if (unitSpecifier === 1) {
                const PixelPerUnitX = dv.getUint32(0);
                const PixelPerUnitY = dv.getUint32(4);
                pHYs = {
                    PixelPerUnitX: PixelPerUnitX,
                    PixelPerUnitY: PixelPerUnitY
                };
            }
        }
    }
    return {
        iTXt: iTXt,
        pHYs: pHYs
    };
}

});
parcelRegister("fOXQV", function(module, exports) {

$parcel$export(module.exports, "dataURItoFile", () => $cb7adf01e70d1e12$export$80d19edb7b1ae293);
$parcel$export(module.exports, "fileToDataURI", () => $cb7adf01e70d1e12$export$849633012686f7ee);
$parcel$export(module.exports, "getFileInfo", () => $cb7adf01e70d1e12$export$ca39f27fe4f7d9b4);
$parcel$export(module.exports, "fileToArrayBuffer", () => $cb7adf01e70d1e12$export$956310555b96755a);
$parcel$export(module.exports, "loadImage", () => $cb7adf01e70d1e12$export$fe58198efe02b173);
$parcel$export(module.exports, "readImageNaturalOrientationFromDOM", () => $cb7adf01e70d1e12$export$325d46491952db2d);
$parcel$export(module.exports, "findParentByClassname", () => $cb7adf01e70d1e12$export$89ff65f1d45dfb03);
$parcel$export(module.exports, "getMimeIcon", () => $cb7adf01e70d1e12$export$61a1de0822e2820);

var $6OBnQ = parcelRequire("6OBnQ");

var $2Pj0H = parcelRequire("2Pj0H");

var $jb8ZN = parcelRequire("jb8ZN");

var $4w1Xx = parcelRequire("4w1Xx");

var $heBKY = parcelRequire("heBKY");

var $jP9Cl = parcelRequire("jP9Cl");

var $gAsmN = parcelRequire("gAsmN");

var $iqmbF = parcelRequire("iqmbF");

var $hLw8T = parcelRequire("hLw8T");

var $jpYYq = parcelRequire("jpYYq");

var $4SXVP = parcelRequire("4SXVP");

var $91IX3 = parcelRequire("91IX3");

var $i9oSq = parcelRequire("i9oSq");

var $1TONM = parcelRequire("1TONM");

var $3LgN4 = parcelRequire("3LgN4");

var $jmdLl = parcelRequire("jmdLl");
function $cb7adf01e70d1e12$export$80d19edb7b1ae293(dataURI, filename = 'untitled') {
    if (dataURI.length === 0) throw new Error('dataURI not found');
    // convert base64/URLEncoded data component to raw binary data held in a string
    const dataURIParts = dataURI.split(',');
    const byteString = dataURIParts[0].indexOf('base64') >= 0 ? atob(dataURIParts[1]) : decodeURIComponent(dataURIParts[1]);
    // separate out the mime component
    let mimeString;
    try {
        mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    } catch (e) {
        // https://stackoverflow.com/questions/1176022/unknown-file-type-mime
        mimeString = 'application/octet-stream';
    }
    // write the bytes of the string to a typed array
    const intArray = new Uint8Array(byteString.length);
    for(let i = 0; i < byteString.length; i++)intArray[i] = byteString.charCodeAt(i);
    const blob = new Blob([
        intArray
    ], {
        type: mimeString
    });
    try {
        return new File([
            blob
        ], filename, {
            type: mimeString
        });
    } catch (e) {
        // IE11 does not allow the File constructor (yay!)
        // we get around this by decorating the blob instance with File properties
        // effectively casting up from Blob to File.
        const ie11File = blob;
        const date = new Date();
        ie11File.lastModified = date.getTime();
        ie11File.lastModifiedDate = date;
        ie11File.name = filename;
        ie11File.webkitRelativePath = '';
        return ie11File;
    }
}
function $cb7adf01e70d1e12$export$849633012686f7ee(blob) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.addEventListener('load', ()=>{
            const result = reader.result;
            if (typeof result === 'string') resolve(result);
            else if (result === null) reject();
        });
        reader.addEventListener('error', reject);
        reader.readAsDataURL(blob);
    });
}
async function $cb7adf01e70d1e12$export$ca39f27fe4f7d9b4(file, src) {
    return {
        file: file,
        src: src || await $cb7adf01e70d1e12$export$849633012686f7ee(file)
    };
}
async function $cb7adf01e70d1e12$export$d727e14d7168c14(src, file) {
    return {
        file: file || await $cb7adf01e70d1e12$export$80d19edb7b1ae293(src),
        src: src
    };
}
function $cb7adf01e70d1e12$export$956310555b96755a(file) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.addEventListener('load', ()=>{
            const array = new Uint8Array(reader.result);
            resolve(array);
        });
        reader.addEventListener('error', reject);
        reader.readAsArrayBuffer(file);
    });
}
function $cb7adf01e70d1e12$export$fe58198efe02b173(src) {
    return new Promise((resolve, reject)=>{
        const img = new Image();
        img.src = src;
        img.onload = ()=>{
            resolve(img);
        };
        img.onerror = reject;
    });
}
function $cb7adf01e70d1e12$export$325d46491952db2d(img) {
    img.style.position = 'absolute';
    img.style.visibility = 'hidden';
    document.body.appendChild(img);
    const { width: width, height: height } = img.getBoundingClientRect();
    document.body.removeChild(img);
    return {
        width: width,
        height: height
    };
}
const $cb7adf01e70d1e12$export$89ff65f1d45dfb03 = (element, className, maxParentElement = document.body)=>{
    if (element.classList.contains(className)) return element;
    let currentElement = element;
    while(currentElement.parentElement !== maxParentElement){
        if (currentElement.parentElement) {
            currentElement = currentElement.parentElement;
            if (currentElement.classList.contains(className)) return currentElement;
        } else return undefined;
    }
    return undefined;
};
const $cb7adf01e70d1e12$var$mimeTypes = [
    {
        label: 'pdf',
        mimeTypes: [
            'application/pdf'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6OBnQ)))
    },
    {
        label: 'google-form',
        mimeTypes: [
            'application/vnd.google-apps.form'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hLw8T)))
    },
    {
        label: 'google-slides',
        mimeTypes: [
            'application/vnd.google-apps.presentation'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4SXVP)))
    },
    {
        label: 'google-form',
        mimeTypes: [
            'application/vnd.google-apps.form'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hLw8T)))
    },
    {
        label: 'google-sheets',
        mimeTypes: [
            'application/vnd.google-apps.spreadsheet'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jpYYq)))
    },
    {
        label: 'google-docs',
        mimeTypes: [
            'application/vnd.google-apps.document',
            'application/vnd.google-apps.kix'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iqmbF)))
    },
    {
        label: 'microsoft-word',
        mimeTypes: [
            'application/msword',
            'application/vnd.openxmlformats-officedocument.word'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4w1Xx)))
    },
    {
        label: 'presentation',
        mimeTypes: [
            'application/x-iwork-keynote-sffkey',
            'application/vnd.oasis.opendocument.presentation'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($1TONM)))
    },
    {
        label: 'powerpoint-presentation',
        mimeTypes: [
            'application/vnd.openxmlformats-officedocument.presentationml.presentation',
            'application/vnd.ms-powerpoint'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jb8ZN)))
    },
    {
        label: 'giphy',
        mimeTypes: [
            'image/gif'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2Pj0H)))
    },
    {
        label: 'spreadsheet',
        mimeTypes: [
            'text/csv'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($i9oSq)))
    },
    {
        label: 'excel-spreadsheet',
        mimeTypes: [
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/vnd.ms-excel',
            'application/x-iwork-keynote-sffnumbers'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($91IX3)))
    }
];
function $cb7adf01e70d1e12$export$61a1de0822e2820(mimeType, fileName) {
    // based on the mimeType, determine the corresponding icon and label
    const iconInfo = $cb7adf01e70d1e12$var$mimeTypes.find((file)=>file.mimeTypes.indexOf(mimeType) > -1);
    //return the appropriate icon and its label if we have it
    if (iconInfo) return iconInfo;
    if ((0, $jmdLl.isCodeViewerItem)(fileName, mimeType)) return {
        label: 'source-code',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3LgN4)))
    };
    // we are not able to determine what icon to render based on the mimeType
    // hence we render the icon based on the filename
    if (fileName.match(/.*\.sketch$/)) return {
        label: 'sketch',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($heBKY)))
    };
    if (fileName.match(/.*\.fig$/)) return {
        label: 'figma',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jP9Cl)))
    };
    if (fileName.match(/.*\.exe$/) || fileName.match(/.*\.dmg$/)) return {
        label: 'executable',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gAsmN)))
    };
    // cannot find a corresponding mimeType icon.
    return undefined;
}

});
parcelRegister("6OBnQ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $4f6469314c3d6ff1$var$_react = $4f6469314c3d6ff1$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $4f6469314c3d6ff1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4f6469314c3d6ff1$var$PdfDocument24Icon = (props)=>/*#__PURE__*/ $4f6469314c3d6ff1$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.846 12.17h.483c1.116 0 1.203-.322 1.203-.776 0-.518-.268-.771-.817-.771h-.869zm6.29 2.183h.664c.742 0 1.501-.22 1.501-1.855 0-1.65-.802-1.86-1.501-1.86h-.665zM4.462 15.99h-1.08A.384.384 0 0 1 3 15.606V9.383c0-.21.171-.383.383-.383h2.494c1.483 0 2.52.984 2.52 2.394 0 1.43-1.015 2.39-2.525 2.39H4.846v1.822a.384.384 0 0 1-.383.384m7.45 0h-2.24a.384.384 0 0 1-.384-.384V9.383c0-.21.172-.383.383-.383h2.242c2.107 0 3.268 1.237 3.268 3.484 0 2.26-1.16 3.506-3.268 3.506m5.776 0h-1.08a.384.384 0 0 1-.384-.384V9.383c0-.21.172-.383.383-.383h4.009c.21 0 .383.172.383.383v.88a.383.383 0 0 1-.383.383h-2.545v1.14h2.292c.212 0 .383.172.383.383v.867c0 .21-.171.383-.383.383h-2.292v2.187a.384.384 0 0 1-.383.384"/></svg>`
    }, props, {
        size: 'medium'
    }));
$4f6469314c3d6ff1$var$PdfDocument24Icon.displayName = 'PdfDocument24Icon';
var $4f6469314c3d6ff1$var$_default = module.exports.default = $4f6469314c3d6ff1$var$PdfDocument24Icon;

});

parcelRegister("2Pj0H", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $20ef173efcc507e4$var$_react = $20ef173efcc507e4$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $20ef173efcc507e4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $20ef173efcc507e4$var$Gif24Icon = (props)=>/*#__PURE__*/ $20ef173efcc507e4$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m10.564 16.636h-1.93a.243.243 0 0 1-.244-.243V8.384c0-.135.108-.243.243-.243h1.93c.135 0 .244.108.244.243v8.009a.243.243 0 0 1-.243.243m3.79 0h-1.931a.243.243 0 0 1-.243-.243V8.384c0-.135.109-.243.243-.243h5.334c.133 0 .243.108.243.243v1.573c0 .134-.11.243-.243.243h-3.16v1.42h2.848c.135 0 .244.11.244.244v1.518a.243.243 0 0 1-.244.244h-2.847v2.767c0 .134-.11.243-.244.243m-10.567.146C4.416 16.782 3 15.31 3 12.843v-.962C3 9.487 4.453 8 6.793 8c2.314 0 3.436 1.467 3.522 2.922a.24.24 0 0 1-.242.258H8.195a.24.24 0 0 1-.24-.2c-.1-.55-.552-.892-1.18-.892-1.108 0-1.34.985-1.34 1.81v.94c0 1.231.467 1.856 1.393 1.856.885 0 1.2-.538 1.2-1v-.092H6.874a.243.243 0 0 1-.243-.243v-1.373c0-.134.11-.243.243-.243h3.216c.134 0 .243.109.243.243v1.555c0 1.496-.929 3.241-3.546 3.241"/></svg>`
    }, props, {
        size: 'medium'
    }));
$20ef173efcc507e4$var$Gif24Icon.displayName = 'Gif24Icon';
var $20ef173efcc507e4$var$_default = module.exports.default = $20ef173efcc507e4$var$Gif24Icon;

});

parcelRegister("jb8ZN", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $df6605c69004c362$var$_react = $df6605c69004c362$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $df6605c69004c362$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $df6605c69004c362$var$PowerpointPresentation24Icon = (props)=>/*#__PURE__*/ $df6605c69004c362$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ca5010" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5zM7.854 8.454h2.94c1.45 0 2.441.972 2.441 2.437 0 1.45-1.03 2.422-2.514 2.422H9.329V15.5H7.854zM9.33 9.665v2.451h1.07c.844 0 1.337-.43 1.337-1.22 0-.801-.483-1.231-1.333-1.231z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$df6605c69004c362$var$PowerpointPresentation24Icon.displayName = 'PowerpointPresentation24Icon';
var $df6605c69004c362$var$_default = module.exports.default = $df6605c69004c362$var$PowerpointPresentation24Icon;

});

parcelRegister("4w1Xx", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $349babaa4a8a09e8$var$_react = $349babaa4a8a09e8$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $349babaa4a8a09e8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $349babaa4a8a09e8$var$WordDocument24Icon = (props)=>/*#__PURE__*/ $349babaa4a8a09e8$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#1d7afc" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zm5.629 5.324L8.687 16H7.295L5.43 8.954h1.533l1.099 4.966h.078l1.284-4.966h1.245l1.309 4.966h.078l1.089-4.966h1.523L12.798 16h-1.382l-1.333-4.663zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$349babaa4a8a09e8$var$WordDocument24Icon.displayName = 'WordDocument24Icon';
var $349babaa4a8a09e8$var$_default = module.exports.default = $349babaa4a8a09e8$var$WordDocument24Icon;

});

parcelRegister("heBKY", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $c8c1082e5cae77c8$var$_react = $c8c1082e5cae77c8$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $c8c1082e5cae77c8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c8c1082e5cae77c8$var$Sketch24Icon = (props)=>/*#__PURE__*/ $c8c1082e5cae77c8$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff8b00" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m9.03 20c.29-.001.562-.126.752-.343l6.971-8a1 1 0 0 0 .095-1.185l-2.485-4a1 1 0 0 0-.85-.472h-8.84c-.334 0-.646.167-.832.444l-2.674 4a1 1 0 0 0 .081 1.216l7.03 8c.188.216.462.34.75.34"/></svg>`
    }, props, {
        size: 'medium'
    }));
$c8c1082e5cae77c8$var$Sketch24Icon.displayName = 'Sketch24Icon';
var $c8c1082e5cae77c8$var$_default = module.exports.default = $c8c1082e5cae77c8$var$Sketch24Icon;

});

parcelRegister("jP9Cl", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $e6ea3d8b8f4b0c1d$var$_react = $e6ea3d8b8f4b0c1d$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $e6ea3d8b8f4b0c1d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e6ea3d8b8f4b0c1d$var$Figma24Icon = (props)=>/*#__PURE__*/ $e6ea3d8b8f4b0c1d$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3.248 0A3.25 3.25 0 0 0 0 3.248v17.504A3.25 3.25 0 0 0 3.248 24h17.504A3.25 3.25 0 0 0 24 20.752V3.248A3.25 3.25 0 0 0 20.752 0zm8.755 17.013a2.506 2.506 0 0 1-2.505 2.506 2.506 2.506 0 0 1 0-5.013 2.506 2.506 0 0 1 0-5.012 2.506 2.506 0 0 1 0-5.013h5.009a2.506 2.506 0 0 1 0 5.013h-2.504v2.5a2.506 2.506 0 0 1 2.504-2.5 2.506 2.506 0 0 1 0 5.012 2.506 2.506 0 0 1-2.504-2.5z" clip-rule="evenodd"/></svg>`
    }, props, {
        size: 'medium'
    }));
$e6ea3d8b8f4b0c1d$var$Figma24Icon.displayName = 'Figma24Icon';
var $e6ea3d8b8f4b0c1d$var$_default = module.exports.default = $e6ea3d8b8f4b0c1d$var$Figma24Icon;

});

parcelRegister("gAsmN", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $c1360329a45292df$var$_react = $c1360329a45292df$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $c1360329a45292df$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c1360329a45292df$var$Executable24Icon = (props)=>/*#__PURE__*/ $c1360329a45292df$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m2 13v5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-5zm1.883-8a1 1 0 0 0-.992.876L5 13h14l-.89-7.124A1 1 0 0 0 17.116 5zM8 15h8a1 1 0 0 1 0 2H8a1 1 0 0 1 0-2"/></svg>`
    }, props, {
        size: 'medium'
    }));
$c1360329a45292df$var$Executable24Icon.displayName = 'Executable24Icon';
var $c1360329a45292df$var$_default = module.exports.default = $c1360329a45292df$var$Executable24Icon;

});

parcelRegister("iqmbF", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $d69bdda0af90a430$var$_react = $d69bdda0af90a430$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $d69bdda0af90a430$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d69bdda0af90a430$var$GoogleDoc24Icon = (props)=>/*#__PURE__*/ $d69bdda0af90a430$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2196f3" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$d69bdda0af90a430$var$GoogleDoc24Icon.displayName = 'GoogleDoc24Icon';
var $d69bdda0af90a430$var$_default = module.exports.default = $d69bdda0af90a430$var$GoogleDoc24Icon;

});

parcelRegister("hLw8T", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $ceefc245c72865b3$var$_react = $ceefc245c72865b3$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $ceefc245c72865b3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ceefc245c72865b3$var$GoogleForm24Icon = (props)=>/*#__PURE__*/ $ceefc245c72865b3$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$ceefc245c72865b3$var$GoogleForm24Icon.displayName = 'GoogleForm24Icon';
var $ceefc245c72865b3$var$_default = module.exports.default = $ceefc245c72865b3$var$GoogleForm24Icon;

});

parcelRegister("jpYYq", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $e22fa632d0a47674$var$_react = $e22fa632d0a47674$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $e22fa632d0a47674$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e22fa632d0a47674$var$GoogleSheet24Icon = (props)=>/*#__PURE__*/ $e22fa632d0a47674$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#0a9d58" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$e22fa632d0a47674$var$GoogleSheet24Icon.displayName = 'GoogleSheet24Icon';
var $e22fa632d0a47674$var$_default = module.exports.default = $e22fa632d0a47674$var$GoogleSheet24Icon;

});

parcelRegister("4SXVP", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $38eab1c43401fe51$var$_react = $38eab1c43401fe51$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $38eab1c43401fe51$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $38eab1c43401fe51$var$GoogleSlide24Icon = (props)=>/*#__PURE__*/ $38eab1c43401fe51$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ffc107" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$38eab1c43401fe51$var$GoogleSlide24Icon.displayName = 'GoogleSlide24Icon';
var $38eab1c43401fe51$var$_default = module.exports.default = $38eab1c43401fe51$var$GoogleSlide24Icon;

});

parcelRegister("91IX3", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $69271380a604c514$var$_react = $69271380a604c514$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $69271380a604c514$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $69271380a604c514$var$ExcelSpreadsheet24Icon = (props)=>/*#__PURE__*/ $69271380a604c514$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#22a06b" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5zM6.93 15.5l2.25-3.55-2.236-3.496h1.734l1.47 2.466h.087l1.485-2.466h1.65l-2.32 3.52 2.286 3.526h-1.68l-1.513-2.388h-.088L8.52 15.5z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$69271380a604c514$var$ExcelSpreadsheet24Icon.displayName = 'ExcelSpreadsheet24Icon';
var $69271380a604c514$var$_default = module.exports.default = $69271380a604c514$var$ExcelSpreadsheet24Icon;

});

parcelRegister("i9oSq", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $d36c5d4aab250180$var$_react = $d36c5d4aab250180$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $d36c5d4aab250180$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d36c5d4aab250180$var$Spreadsheet24Icon = (props)=>/*#__PURE__*/ $d36c5d4aab250180$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#36b37e" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m2 5a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2zm0 4a1 1 0 1 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zm7-12a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$d36c5d4aab250180$var$Spreadsheet24Icon.displayName = 'Spreadsheet24Icon';
var $d36c5d4aab250180$var$_default = module.exports.default = $d36c5d4aab250180$var$Spreadsheet24Icon;

});

parcelRegister("1TONM", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $162255ae7d5921b9$var$_react = $162255ae7d5921b9$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $162255ae7d5921b9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $162255ae7d5921b9$var$Presentation24Icon = (props)=>/*#__PURE__*/ $162255ae7d5921b9$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m3 14a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0v-3a1 1 0 0 0-1-1m8-6a1 1 0 0 0-1 1v9a1 1 0 0 0 2 0V9a1 1 0 0 0-1-1m-4 4a1 1 0 0 0-1 1v5a1 1 0 0 0 2 0v-5a1 1 0 0 0-1-1m8-7a1 1 0 0 0-1 1v12a1 1 0 0 0 2 0V6a1 1 0 0 0-1-1"/></svg>`
    }, props, {
        size: 'medium'
    }));
$162255ae7d5921b9$var$Presentation24Icon.displayName = 'Presentation24Icon';
var $162255ae7d5921b9$var$_default = module.exports.default = $162255ae7d5921b9$var$Presentation24Icon;

});

parcelRegister("3LgN4", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $2bd2c91c79a3039e$var$_react = $2bd2c91c79a3039e$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $2bd2c91c79a3039e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2bd2c91c79a3039e$var$SourceCode24Icon = (props)=>/*#__PURE__*/ $2bd2c91c79a3039e$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#00b8d9" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m5.017 12.265-2.58-2.501L8.236 7.05a.999.999 0 1 0-1.392-1.436l-3.54 3.432a1 1 0 0 0 0 1.436l3.32 3.219a1 1 0 1 0 1.393-1.436m6.638-8.21a1 1 0 0 0-1.271.62l-4.83 14.046a1 1 0 0 0 1.892.65l4.829-14.045a1 1 0 0 0-.62-1.271m6.081 9.776-3.32-3.219a.999.999 0 1 0-1.393 1.436l2.58 2.501-2.799 2.714a.999.999 0 1 0 1.392 1.436l3.54-3.432a1 1 0 0 0 0-1.436"/></svg>`
    }, props, {
        size: 'medium'
    }));
$2bd2c91c79a3039e$var$SourceCode24Icon.displayName = 'SourceCode24Icon';
var $2bd2c91c79a3039e$var$_default = module.exports.default = $2bd2c91c79a3039e$var$SourceCode24Icon;

});

parcelRegister("jmdLl", function(module, exports) {

$parcel$export(module.exports, "getExtension", () => $d6ba8b104df87d35$export$78d71f9ed5534abe);
$parcel$export(module.exports, "isCodeViewerItem", () => $d6ba8b104df87d35$export$bb139b46f345ca28);
$parcel$export(module.exports, "getLanguageType", () => $d6ba8b104df87d35$export$ba4368c844580f9e);
function $d6ba8b104df87d35$export$78d71f9ed5534abe(filename) {
    if (filename.indexOf('.') > -1) return filename.split('.').pop();
    return '';
}
const $d6ba8b104df87d35$var$codeViewerMimeTypes = [
    {
        mimetype: 'application/json',
        language: 'json'
    },
    {
        mimetype: 'text/html',
        language: 'html'
    }
];
function $d6ba8b104df87d35$export$bb139b46f345ca28(name, mimetype = 'unknown') {
    return $d6ba8b104df87d35$export$ba4368c844580f9e(name, mimetype) !== null;
}
function $d6ba8b104df87d35$export$ba4368c844580f9e(name, mimetype) {
    if (mimetype) {
        const languageForMimeType = $d6ba8b104df87d35$var$codeViewerMimeTypes.find((x)=>x.mimetype === mimetype);
        if (languageForMimeType) return languageForMimeType.language;
    }
    const ext = $d6ba8b104df87d35$export$78d71f9ed5534abe(name);
    switch(ext){
        case 'abap':
        case 'ada':
        case 'c':
        case 'css':
        case 'd':
        case 'dart':
        case 'go':
        case 'graphql':
        case 'groovy':
        case 'html':
        case 'java':
        case 'json':
        case 'matlab':
        case 'xml':
        case 'lua':
        case 'puppet':
        case 'qml':
        case 'sass':
        case 'sql':
        case 'php':
        case 'r':
        case 'swift':
        case 'tcl':
        case 'vala':
        case 'vhdl':
        case 'xquery':
            return ext;
        case 'as':
        case 'asc':
            return 'actionscript';
        case 'ino':
            return 'arduino';
        case 'au3':
            return 'autoit';
        case 'cpp':
        case 'h':
        case 'c++':
            return 'c++';
        case 'coffee':
            return 'coffeescript';
        case 'cs':
            return 'csharp';
        case 'cu':
            return 'cuda';
        case 'pas':
        case 'dpr':
        case 'dproj':
        case 'dpk':
            return 'delphi';
        case 'ex':
        case 'exs':
            return 'elixir';
        case 'erl':
        case 'hrl':
            return 'erlang';
        case 'f90':
        case 'for':
        case 'f':
        case 'fpp':
        case 'i':
        case 'i90':
        case 'ftn':
            return 'fortran';
        case 'dbc':
            return 'foxpro';
        case 'hs':
        case 'has':
            return 'haskell';
        case 'hx':
            return 'haxe';
        case 'js':
        case 'jsx':
            return 'javascript';
        case 'jl':
            return 'julia';
        case 'kt':
            return 'kotlin';
        case 'm':
        case 'mm':
            return 'objective-c';
        case 'j':
            return 'objective-j';
        case 'tex':
            return 'latex';
        case 'nb':
        case 'cdf':
            return 'mathematica';
        case 'cma':
            return 'ocaml';
        case 'pl':
            return 'perl';
        case 'py':
            return 'python';
        case 'ps1':
        case 'psd1':
        case 'psm1':
            return 'powershell';
        case 'rb':
            return 'ruby';
        case 'rst':
            return 'restructuredtext';
        case 'rs':
            return 'rust';
        case 'rkt':
            return 'racket';
        case 'sh':
            return 'shell';
        case 'sc':
        case 'sch':
            return 'scheme';
        case 'txt':
        case 'msg':
        case 'log':
        case 'csv':
        case 'md':
            return 'text';
        case 'ts':
        case 'tsx':
            return 'typescript';
        case 'v':
            return 'verilog';
        case 'xq':
        case 'xql':
        case 'xqm':
        case 'xqy':
            return 'xquery';
        case 'lock':
        case 'yaml':
        case 'yml':
            return 'yaml';
        default:
            return null;
    }
}

});


parcelRegister("dopkG", function(module, exports) {

let $9c012ac78e0c2259$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $9c012ac78e0c2259$var$load("fWdHm").then(()=>parcelRequire('6TwJU'));

});


parcelRegister("3yAnp", function(module, exports) {

$parcel$export(module.exports, "parseXMPMetaData", () => $a54c683875c3acaa$export$55c3bc9841b19de2);
function $a54c683875c3acaa$export$55c3bc9841b19de2(xmpMetaData) {
    const metadata = {};
    const tags = xmpMetaData.match(/<(tiff|exif):.+>/gi);
    if (tags) tags.forEach((tag)=>{
        const match = tag.match(/<(tiff|exif):([^>]+)>([^<]+)/i);
        if (match) {
            const name = match[2];
            metadata[name] = match[3];
        }
    });
    return metadata;
}

});


parcelRegister("kHzU5", function(module, exports) {

$parcel$export(module.exports, "isRotated", () => $d080920ecf648ea4$export$8af433705f41088f);
$parcel$export(module.exports, "getCssFromImageOrientation", () => $d080920ecf648ea4$export$43142f95b8de7a91);
const $d080920ecf648ea4$var$ORIENT_TRANSFORMS = {
    1: 'none',
    2: 'rotateY(180deg)',
    3: 'rotate(180deg)',
    4: 'rotate(180deg) rotateY(180deg)',
    5: 'rotate(270deg) rotateY(180deg)',
    6: 'rotate(90deg)',
    7: 'rotate(90deg) rotateY(180deg)',
    8: 'rotate(270deg)'
};
const $d080920ecf648ea4$export$8af433705f41088f = (orientation)=>orientation >= 5;
const $d080920ecf648ea4$export$43142f95b8de7a91 = (orientation)=>{
    return $d080920ecf648ea4$var$ORIENT_TRANSFORMS[orientation];
};

});


parcelRegister("heXDA", function(module, exports) {

$parcel$export(module.exports, "takeSnapshot", () => $e7f813388d1815ac$export$4269d30173168e5c);
const $e7f813388d1815ac$export$4269d30173168e5c = async (blob)=>{
    return new Promise((resolve, reject)=>{
        const url = URL.createObjectURL(blob);
        const video = document.createElement('video');
        video.preload = 'metadata';
        video.src = url;
        video.muted = true;
        video.play().catch(()=>{
            return reject(new Error('failed to play video'));
        });
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        video.addEventListener('timeupdate', function timeUpdateHandler() {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            video.removeEventListener('timeupdate', timeUpdateHandler);
            video.pause();
            URL.revokeObjectURL(url);
            //create canvas to draw our first frame on.
            if (!video.videoWidth && !video.videoHeight) return reject(new Error('error retrieving video dimensions'));
            const canvas = document.createElement('canvas');
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            const context = canvas.getContext('2d');
            if (!context) return reject(new Error('error creating canvas context'));
            context.drawImage(video, 0, 0, canvas.width, canvas.height);
            const dataURL = canvas.toDataURL('image/jpeg', 0.85);
            resolve(dataURL);
        });
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        video.addEventListener('error', ()=>{
            reject(new Error('failed to load video'));
            URL.revokeObjectURL(url);
        });
    });
};

});



parcelRegister("i0gVY", function(module, exports) {

$parcel$export(module.exports, "getMediaCardSSR", () => $c6ffe105f3de4b84$export$ede93d4564eaa8da);
$parcel$export(module.exports, "getKey", () => $c6ffe105f3de4b84$export$a47fb462a08de82f);
$parcel$export(module.exports, "generateScriptProps", () => $c6ffe105f3de4b84$export$de7c49925e44d75d);

var $itX9h = parcelRequire("itX9h");
const $c6ffe105f3de4b84$export$21c2ece80f3e3137 = 'mediaCardSsr';
const $c6ffe105f3de4b84$export$5b1a163e413609f8 = '__MEDIA_INTERNAL';
function $c6ffe105f3de4b84$export$96a3cfb3a41e9bb2(globalScope = window) {
    // Must match GLOBAL_MEDIA_NAMESPACE. Can't reference the constant from here.
    const namespace = '__MEDIA_INTERNAL';
    if (!globalScope[namespace]) globalScope[namespace] = {};
    return globalScope[namespace];
}
function $c6ffe105f3de4b84$export$ede93d4564eaa8da(globalScope = window) {
    const globalMedia = $c6ffe105f3de4b84$export$96a3cfb3a41e9bb2(globalScope);
    // Must match GLOBAL_MEDIA_CARD_SSR. Can't reference the constant from here.
    const key = 'mediaCardSsr';
    if (!globalMedia[key]) globalMedia[key] = {};
    return globalMedia[key];
}
const $c6ffe105f3de4b84$var$dashed = (param)=>param ? `-${param}` : '';
const $c6ffe105f3de4b84$export$a47fb462a08de82f = ({ id: id, collectionName: collectionName, occurrenceKey: occurrenceKey })=>`${id}${$c6ffe105f3de4b84$var$dashed(collectionName)}${$c6ffe105f3de4b84$var$dashed(occurrenceKey)}`;
const $c6ffe105f3de4b84$export$4310981e0aa4ce67 = (key, dataURI, dimensions, error, globalScope = window)=>{
    const mediaCardSsr = $c6ffe105f3de4b84$export$ede93d4564eaa8da(globalScope);
    mediaCardSsr[key] = {
        dataURI: dataURI,
        dimensions: dimensions,
        error: error
    };
};
const $c6ffe105f3de4b84$var$generateScript = (identifier, dataURI, dimensions, error)=>{
    const functionCall = (0, $itX9h.printFunctionCall)($c6ffe105f3de4b84$export$4310981e0aa4ce67, $c6ffe105f3de4b84$export$a47fb462a08de82f(identifier), dataURI, dimensions, error);
    return (0, $itX9h.printScript)([
        $c6ffe105f3de4b84$export$ede93d4564eaa8da.toString(),
        $c6ffe105f3de4b84$export$96a3cfb3a41e9bb2.toString(),
        functionCall
    ]);
};
const $c6ffe105f3de4b84$export$de7c49925e44d75d = (identifier, dataURI, dimensions, error)=>({
        dangerouslySetInnerHTML: {
            __html: $c6ffe105f3de4b84$var$generateScript(identifier, dataURI, dimensions, error)
        }
    });

});
parcelRegister("itX9h", function(module, exports) {

$parcel$export(module.exports, "printFunctionCall", () => $58d2f85efd2afaca$export$3742967cc82ac85a);
$parcel$export(module.exports, "printScript", () => $58d2f85efd2afaca$export$8b902fb69a2f17c1);

var $eGOwo = parcelRequire("eGOwo");
const $58d2f85efd2afaca$var$printParam = (param)=>{
    if (typeof param === 'string') return `'${param}'`;
    else if (typeof param === 'object') return JSON.stringify(param);
    else if (param === undefined) return 'undefined';
    return param;
};
const $58d2f85efd2afaca$var$printParams = (args)=>args.map((arg)=>$58d2f85efd2afaca$var$printParam(arg)).join(',');
const $58d2f85efd2afaca$export$3742967cc82ac85a = (fn, ...args)=>`(${fn.toString()})(${$58d2f85efd2afaca$var$printParams(args)});`;
const $58d2f85efd2afaca$export$8b902fb69a2f17c1 = (statements)=>(0, $eGOwo.fg)('platform_remove_media_script_after_execution') ? `(function(){
 			 ${statements.join(';')}
  			document.currentScript.remove();
		})();
		` : `(function(){
   			${statements.join(';')}
 		})();`;

});


parcelRegister("8Dv9L", function(module, exports) {

$parcel$export(module.exports, "getSSRData", () => $2f30a37781c6f0c3$export$d3a890b0f7844b6f);

var $i0gVY = parcelRequire("i0gVY");
const $2f30a37781c6f0c3$export$d3a890b0f7844b6f = (identifier)=>{
    const mediaCardSsr = (0, $i0gVY.getMediaCardSSR)();
    if (!mediaCardSsr) return;
    return mediaCardSsr[(0, $i0gVY.getKey)(identifier)];
};

});

parcelRegister("3c1p9", function(module, exports) {

$parcel$export(module.exports, "isBigger", () => $f93a7743871712e9$export$912a00e9a5470d9a);
$parcel$export(module.exports, "createRequestDimensions", () => $f93a7743871712e9$export$3063221e86a58f9);
$parcel$export(module.exports, "useCurrentValueRef", () => $f93a7743871712e9$export$b3e10e1f0fbb71db);

var $eJOHy = parcelRequire("eJOHy");
const $f93a7743871712e9$export$912a00e9a5470d9a = (current, next)=>{
    const { width: currentWidth, height: currentHeight } = current || {};
    const { width: nextWidth, height: nextHeight } = next || {};
    if (!!currentWidth && !!currentHeight && !!nextWidth && !!nextHeight) {
        const nextIsWider = currentWidth < nextWidth;
        const nextIsHigher = currentHeight < nextHeight;
        return nextIsHigher || nextIsWider;
    } else return false;
};
/** Verifies if the current screen is retina display */ function $f93a7743871712e9$var$isRetina() {
    const mediaQuery = '(-webkit-min-device-pixel-ratio: 1.5), (min--moz-device-pixel-ratio: 1.5), (-o-min-device-pixel-ratio: 3/2), (min-resolution: 1.5dppx)';
    return window.devicePixelRatio > 1 || window.matchMedia && window.matchMedia(mediaQuery).matches;
}
const $f93a7743871712e9$export$3063221e86a58f9 = (dimensions)=>{
    if (!dimensions) return;
    const retinaFactor = $f93a7743871712e9$var$isRetina() ? 2 : 1;
    const { width: width, height: height } = dimensions;
    const result = {};
    if (width) result.width = width * retinaFactor;
    if (height) result.height = height * retinaFactor;
    return result;
};
function $f93a7743871712e9$export$b3e10e1f0fbb71db(value) {
    const ref = (0, $eJOHy.useRef)(value);
    ref.current = value;
    return ref;
}

});






parcelRegister("aZKFb", function(module, exports) {

$parcel$export(module.exports, "EditMessage", () => $efc036cca9dd305b$export$1951eb47789629cd);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $7MiYh = parcelRequire("7MiYh");

var $jNOdV = parcelRequire("jNOdV");
const $efc036cca9dd305b$export$1951eb47789629cd = (props)=>{
    const renderMessage = (message, index)=>{
        switch(message.label){
            case 'warning':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($efc036cca9dd305b$var$MessageContainer, {
                    key: index
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jNOdV))), {
                    spacing: "spacious",
                    label: "warning",
                    color: "var(--ds-icon-warning, #E56910)"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($efc036cca9dd305b$var$Message, null, message.messageContent));
            case 'info':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($efc036cca9dd305b$var$MessageContainer, {
                    key: index
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7MiYh))), {
                    spacing: "spacious",
                    label: "info"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($efc036cca9dd305b$var$Message, null, message.messageContent));
            default:
                return undefined;
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, props.messages.map(renderMessage));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $efc036cca9dd305b$var$MessageContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c81o8v _syaz1gjq _1e0c1txw _4cvr1h6o _vwz41cnx",
            __cmplp.className
        ])
    });
});
const $efc036cca9dd305b$var$Message = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_18u01b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jNOdV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d0bf07842bc2fe365de9b1d85cb30465>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e6a98d42b8b0ed3d$var$_react = $e6a98d42b8b0ed3d$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $e6a98d42b8b0ed3d$var$_warning = $e6a98d42b8b0ed3d$var$_interopRequireDefault((parcelRequire("dUhgd")));

var $e6a98d42b8b0ed3d$var$_warning2 = $e6a98d42b8b0ed3d$var$_interopRequireDefault((parcelRequire("78Hx3")));
function $e6a98d42b8b0ed3d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for WarningIcon.
 * This component is WarningIcon, with `UNSAFE_fallbackIcon` set to "EditorWarningIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for warning statuses.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e6a98d42b8b0ed3d$var$WarningIcon = (props)=>/*#__PURE__*/ $e6a98d42b8b0ed3d$var$_react.default.createElement($e6a98d42b8b0ed3d$var$_warning.default, Object.assign({
        LEGACY_fallbackIcon: $e6a98d42b8b0ed3d$var$_warning2.default
    }, props));
$e6a98d42b8b0ed3d$var$WarningIcon.Name = 'WarningIconMigration';
var $e6a98d42b8b0ed3d$var$_default = module.exports.default = $e6a98d42b8b0ed3d$var$WarningIcon;

});
parcelRegister("78Hx3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $532b0c56cbaaba87$var$_react = $532b0c56cbaaba87$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $532b0c56cbaaba87$var$_warning = $532b0c56cbaaba87$var$_interopRequireDefault((parcelRequire("dUhgd")));
function $532b0c56cbaaba87$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $532b0c56cbaaba87$var$EditorWarningIcon = (props)=>/*#__PURE__*/ $532b0c56cbaaba87$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m13.31 5.343 7.359 13.17A1 1 0 0 1 19.796 20H4.204a1 1 0 0 1-.873-1.488l7.36-13.169a1.5 1.5 0 0 1 2.618 0M12 8.5a1.09 1.09 0 0 0-1.081 1.239l.513 3.766a.573.573 0 0 0 1.136 0l.513-3.766A1.09 1.09 0 0 0 12 8.5m0 8.63a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25"/></svg>`
    }, props, {
        newIcon: $532b0c56cbaaba87$var$_warning.default
    }));
$532b0c56cbaaba87$var$EditorWarningIcon.displayName = 'EditorWarningIcon';
var $532b0c56cbaaba87$var$_default = module.exports.default = $532b0c56cbaaba87$var$EditorWarningIcon;

});



parcelRegister("kF5Rw", function(module, exports) {

$parcel$export(module.exports, "default", () => $3104bff6cd87c05c$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $3104bff6cd87c05c$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    searchPlaceholder: {
        "id": "servicedesk-cmdb-field-object-picker.search-placeholder",
        "defaultMessage": "Select or search for objects"
    },
    errorTitleCmdbAssets: {
        "id": "servicedesk-cmdb-field-object-picker.error-title-cmdb-assets",
        "defaultMessage": "Could not fetch Assets objects"
    },
    errorMessage: {
        "id": "servicedesk-cmdb-field-object-picker.error-message",
        "defaultMessage": "Please refresh the page and try again"
    },
    errorTitleCmdbFieldSearch: {
        "id": "servicedesk-cmdb-field-object-picker.error-title-cmdb-field-search",
        "defaultMessage": "We couldn't fetch any objects for this field"
    },
    errorMessageCmdbFieldSearch: {
        "id": "servicedesk-cmdb-field-object-picker.error-message-cmdb-field-search",
        "defaultMessage": "Remove attributes that no longer exist in the Assets Custom field configuration filter, and ensure the AQL query is valid."
    },
    infoSingleObjectMessage: {
        "id": "servicedesk-cmdb-field-object-picker.info-single-object-message",
        "defaultMessage": "This field can only store a single object"
    },
    warningMultipleObjectsMessage: {
        "id": "servicedesk-cmdb-field-object-picker.warning-multiple-objects-message",
        "defaultMessage": "This field is configured to store a single object. Remove some objects to save changes."
    },
    infoObjectLimitReached: {
        "id": "servicedesk-cmdb-field-object-picker.info-object-limit-reached",
        "defaultMessage": "This field can only store {objectLimit, plural, one {# object} other {# objects}}."
    },
    warningObjectLimitExceeded: {
        "id": "servicedesk-cmdb-field-object-picker.warning-object-limit-exceeded",
        "defaultMessage": "This field is configured to store {objectLimit, plural, one {# object} other {# objects}}. Remove some objects to save changes."
    },
    dropdownNumberOfSearchResultsLabel: {
        "id": "servicedesk-cmdb-field-object-picker.dropdown-number-of-search-results-label",
        "defaultMessage": "{numberOfSearchResults} search {numberOfSearchResults, plural, one {result} other {results}} {isLoading, select, true {(refreshing)} other {}}"
    }
});

});

parcelRegister("7zUow", function(module, exports) {

$parcel$export(module.exports, "customStyles", () => $03138c192386def7$export$edf5b2501a573922);

var $dPMMf = parcelRequire("dPMMf");
const $03138c192386def7$export$edf5b2501a573922 = {
    menu: (base)=>({
            ...base,
            zIndex: (0, $dPMMf.layers).modal
        }),
    menuPortal: (base)=>({
            ...base,
            zIndex: (0, $dPMMf.layers).modal
        })
};

});


parcelRegister("9D41I", function(module, exports) {

$parcel$export(module.exports, "MAX_AUTOMATION_RULES_PER_SD", () => $6ba7c7d2f96c3944$export$dca2c2105b681490);
$parcel$export(module.exports, "MAX_AUTOMATION_BRANCHES_PER_RULE", () => $6ba7c7d2f96c3944$export$a48ac34d39e0fc22);
$parcel$export(module.exports, "MAX_QUEUES_PER_SD", () => $6ba7c7d2f96c3944$export$2e0ba662d5bb7742);
$parcel$export(module.exports, "MAX_SLA_GOALS_PER_SD", () => $6ba7c7d2f96c3944$export$eb69982aa3a172b4);
$parcel$export(module.exports, "MAX_CMDB_OBJECTS_PER_FIELD", () => $6ba7c7d2f96c3944$export$cb3888a8c43147d2);
$parcel$export(module.exports, "LIMIT_DEFAULTS", () => $6ba7c7d2f96c3944$export$5ed1d2ac050e39d);
$parcel$export(module.exports, "getLimit", () => $6ba7c7d2f96c3944$export$fb8ce379717a383d);
$parcel$export(module.exports, "LimitData", () => $6ba7c7d2f96c3944$export$9989835030ecd317);
$parcel$export(module.exports, "withLimitData", () => $6ba7c7d2f96c3944$export$c5d8aa8a650e690f);

var $eJOHy = parcelRequire("eJOHy");

var $eSnSE = parcelRequire("eSnSE");

var $1Ozm9 = parcelRequire("1Ozm9");
const $6ba7c7d2f96c3944$export$dca2c2105b681490 = 'max_automation_rules_per_sd';
const $6ba7c7d2f96c3944$export$a48ac34d39e0fc22 = 'max_automation_branches_per_rule';
const $6ba7c7d2f96c3944$export$2e0ba662d5bb7742 = 'max_queues_per_sd';
const $6ba7c7d2f96c3944$export$eb69982aa3a172b4 = 'max_sla_goals_per_sd';
const $6ba7c7d2f96c3944$export$cb3888a8c43147d2 = 'max_cmdb_objects_per_field';
const $6ba7c7d2f96c3944$export$801a603585fb94d8 = 'max_num_team_priority_queues_per_sd';
const $6ba7c7d2f96c3944$export$5ed1d2ac050e39d = {
    [$6ba7c7d2f96c3944$export$dca2c2105b681490]: 30,
    [$6ba7c7d2f96c3944$export$a48ac34d39e0fc22]: 30,
    [$6ba7c7d2f96c3944$export$2e0ba662d5bb7742]: 300,
    [$6ba7c7d2f96c3944$export$eb69982aa3a172b4]: 30,
    [$6ba7c7d2f96c3944$export$cb3888a8c43147d2]: 20,
    [$6ba7c7d2f96c3944$export$801a603585fb94d8]: 50
};
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $6ba7c7d2f96c3944$var$limitCache = {};
const $6ba7c7d2f96c3944$export$c419786abd6faaad = (limitProperty)=>{
    delete $6ba7c7d2f96c3944$var$limitCache[limitProperty];
};
const $6ba7c7d2f96c3944$export$fb8ce379717a383d = (limitProperty)=>{
    if (!$6ba7c7d2f96c3944$var$limitCache[limitProperty]) $6ba7c7d2f96c3944$var$limitCache[limitProperty] = (0, $1Ozm9.default)(`/rest/servicedesk/latest/limit/${limitProperty}?_=${Date.now()}`).then(({ limit: limit })=>limit, (error)=>{
        // Will allow us to try again to fetch limit
        $6ba7c7d2f96c3944$export$c419786abd6faaad(limitProperty);
        (0, $eSnSE.default).safeWarnWithoutCustomerData('servicedesk.common.view.components.limit-data', `Failed to fetch limit for ${limitProperty}`);
        throw error;
    });
    return $6ba7c7d2f96c3944$var$limitCache[limitProperty];
};
class $6ba7c7d2f96c3944$export$9989835030ecd317 extends (0, $eJOHy.Component) {
    componentDidMount() {
        const { limitProperty: limitProperty } = this.props;
        const defaultLimit = $6ba7c7d2f96c3944$export$5ed1d2ac050e39d[limitProperty];
        $6ba7c7d2f96c3944$export$fb8ce379717a383d(limitProperty).then((limit)=>{
            this.updateLimit(limit || defaultLimit);
        }).catch(()=>{
            this.updateLimit(defaultLimit);
        });
    }
    updateLimit(newLimit) {
        this.setState(({ limit: oldLimit })=>oldLimit !== newLimit ? {
                limit: newLimit
            } : undefined);
    }
    render() {
        return this.props.children(this.state.limit);
    }
    constructor(...args){
        super(...args), this.state = {
            // Current consumers of LimitData expect typeof number so this cannot be an empty value.
            // This also voids limit messages showing until we have a reliable limit,
            // instead of showing then changing the value
            limit: Infinity
        };
    }
}
const $6ba7c7d2f96c3944$export$c5d8aa8a650e690f = (limitProperty, WrappedComponent)=>(props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6ba7c7d2f96c3944$export$9989835030ecd317, {
            limitProperty: limitProperty
        }, (limit)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(WrappedComponent, {
                limit: limit,
                ...props
            }));

});


parcelRegister("bVuLX", function(module, exports) {

$parcel$export(module.exports, "transformCmdbField", () => $8bfbbdef1c577a54$export$3c3af8d272413d1c);
const $8bfbbdef1c577a54$export$3c3af8d272413d1c = (options)=>options.map((option)=>({
            id: option.id,
            objectId: option.objectId,
            workspaceId: option.workspaceId
        }));

});

parcelRegister("egbID", function(module, exports) {

$parcel$export(module.exports, "default", () => $a476db7537880866$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $9Tyd1 = parcelRequire("9Tyd1");

var $1wTTU = parcelRequire("1wTTU");

var $2nXHu = parcelRequire("2nXHu");

const $a476db7537880866$var$ColorPickerField = (props)=>{
    const { fieldProps: { value: value, onChange: onChange } } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9Tyd1.ColorPicker), {
        value: value,
        onChange: onChange,
        showColorName: true
    });
};
var $a476db7537880866$export$2e2bcd8739ae039 = (0, $2nXHu.withFormField)({
    transformDefaultValue: (0, $1wTTU.asColor)
})($a476db7537880866$var$ColorPickerField);

});
parcelRegister("9Tyd1", function(module, exports) {

$parcel$export(module.exports, "ColorPicker", () => $5205bd86abd16779$export$9feb1bc2e5f1ccb3);
$parcel$export(module.exports, "ColorPickerWrapper", () => $5205bd86abd16779$export$3144fa159460e52e);
$parcel$export(module.exports, "ColorName", () => $5205bd86abd16779$export$93f3fcc778132720);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $7hYf3 = parcelRequire("7hYf3");

var $dTocu = parcelRequire("dTocu");

var $8URAw = parcelRequire("8URAw");

var $kNB2R = parcelRequire("kNB2R");

var $1Qtfz = parcelRequire("1Qtfz");
const $5205bd86abd16779$var$popperProps = {
    strategy: 'fixed',
    modifiers: [
        {
            name: 'offset',
            options: {
                offset: [
                    -10,
                    5
                ]
            }
        }
    ]
};
const $5205bd86abd16779$export$9feb1bc2e5f1ccb3 = ({ value: color, showColorName: showColorName, onChange: onChange })=>{
    const intl = (0, $dTocu.useIntlV2)();
    const colorPalette = (0, $kNB2R.getI18nColorPalette)(intl);
    const colorString = (0, $8URAw.MAP_COLORS_TO_VALUE)[color];
    const maybeColorLabel = colorPalette.filter((pcol)=>pcol.value === colorString)[0];
    const colorLabel = maybeColorLabel && maybeColorLabel.label || ''; // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onChangeHandler = (changedTo)=>{
        // changedTo is a CSS value string like '#FF7452', so we have to map it back to Color
        onChange((0, $8URAw.MAP_VALUE_TO_COLOR)[changedTo]);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5205bd86abd16779$export$3144fa159460e52e, {
        "data-testid": (0, $kNB2R.colorFieldDataTestId)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7hYf3.default), {
        label: intl.formatMessage((0, $1Qtfz.default).label),
        palette: colorPalette,
        selectedColor: colorString,
        cols: colorPalette.length / 2,
        onChange: onChangeHandler,
        popperProps: $5205bd86abd16779$var$popperProps
    }), showColorName && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5205bd86abd16779$export$93f3fcc778132720, null, colorLabel));
};
var $5205bd86abd16779$export$2e2bcd8739ae039 // Move 2px to the left to align with other components
 = $5205bd86abd16779$export$9feb1bc2e5f1ccb3;
const $5205bd86abd16779$export$3144fa159460e52e = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _2lx2vrvc _4cvr1h6o _18u01i6y _ca0qu2gc _u5f3u2gc _4t3izwfg _z29hglyw",
            __cmplp.className
        ])
    });
});
$5205bd86abd16779$export$3144fa159460e52e.displayName = 'ColorPickerWrapper'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $5205bd86abd16779$export$93f3fcc778132720 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u01b66",
            __cmplp.className
        ])
    });
});
$5205bd86abd16779$export$93f3fcc778132720.displayName = 'ColorName';

});
parcelRegister("7hYf3", function(module, exports) {

$parcel$export(module.exports, "Compact", () => $0ec27a535bf140b4$export$6479582a9c9e50ce);
$parcel$export(module.exports, "default", () => $0ec27a535bf140b4$export$2e2bcd8739ae039);

var $gcTu7 = parcelRequire("gcTu7");

var $j2tr1 = parcelRequire("j2tr1");

var $7PKEg = parcelRequire("7PKEg");
const { Compact: $0ec27a535bf140b4$export$6479582a9c9e50ce, Standard: $0ec27a535bf140b4$export$d5a1f56087d42b19 } = (0, $j2tr1.Mode);
var $0ec27a535bf140b4$export$2e2bcd8739ae039 = (0, $gcTu7.default);

});
parcelRegister("gcTu7", function(module, exports) {

$parcel$export(module.exports, "default", () => $701fb0a81d662465$export$2e2bcd8739ae039);
/* ColorPicker.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $sl8jM = parcelRequire("sl8jM");

var $2yxf3 = parcelRequire("2yxf3");

var $3DofW = parcelRequire("3DofW");


var $5fWw9 = parcelRequire("5fWw9");
var $dUaMU = parcelRequire("dUaMU");
var $4J0ad = parcelRequire("4J0ad");

var $dmrRn = parcelRequire("dmrRn");

var $6YFG2 = parcelRequire("6YFG2");

var $20iFi = parcelRequire("20iFi");
const $701fb0a81d662465$var$defaultPopperProps = {
    strategy: 'fixed',
    modifiers: [
        {
            name: 'offset',
            options: {
                offset: [
                    0,
                    8
                ]
            }
        }
    ],
    placement: 'bottom-start'
};
const $701fb0a81d662465$var$packageName = "platform-pkg";
const $701fb0a81d662465$var$packageVersion = "0.0.0-use.local";
class $701fb0a81d662465$var$ColorPickerWithoutAnalyticsBase extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    render() {
        const { palette: palette, selectedColor: selectedColor, checkMarkColor: checkMarkColor, cols: cols, popperProps: popperProps = $701fb0a81d662465$var$defaultPopperProps, label: label = 'Color picker', triggerId: triggerId, selectedColourSwatchSize: selectedColourSwatchSize, showDefaultSwatchColor: showDefaultSwatchColor = true, isDisabledSelectedSwatch: isDisabledSelectedSwatch, intl: intl, variant: variant = 'fill', testId: testId } = this.props;
        const { options: options, value: value } = (0, $dmrRn.getOptions)(palette, selectedColor, showDefaultSwatchColor);
        const fullLabel = this.getFullLabel(intl, value, label);
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $sl8jM.default), {
            target: ({ ref: ref, isOpen: isOpen })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    ref: ref,
                    className: (0, $hcewu.default)([
                        "_1e0c1o8l"
                    ]),
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2yxf3.default), {
                        ...value,
                        label: fullLabel,
                        expanded: isOpen,
                        swatchSize: selectedColourSwatchSize,
                        isDisabled: isDisabledSelectedSwatch,
                        id: triggerId,
                        variant: variant
                    })
                }),
            popperProps: popperProps,
            maxMenuWidth: "auto",
            minMenuWidth: "auto",
            options: options,
            label: fullLabel,
            value: value,
            components: $3DofW,
            onChange: this.onChangeSelect,
            searchThreshold: Number.MAX_VALUE,
            //@ts-ignore react-select unsupported props
            cols: cols,
            checkMarkColor: checkMarkColor,
            variant: variant,
            onKeyDown: this.onKeyDown,
            isTabbing: this.state.isTabbing,
            onOptionKeyDown: this.onOptionKeyDown,
            testId: testId,
            onMenuOpen: this.props.onMenuOpen
        });
    }
    constructor(...args){
        super(...args), this.createAndFireEventOnAtlaskit = (0, $5fWw9.default)('atlaskit'), this.state = {
            isTabbing: false
        }, this.changeAnalyticsCaller = ()=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            if (createAnalyticsEvent) return this.createAndFireEventOnAtlaskit({
                action: 'clicked',
                actionSubject: 'color-picker',
                attributes: {
                    componentName: 'color-picker',
                    packageName: $701fb0a81d662465$var$packageName,
                    packageVersion: $701fb0a81d662465$var$packageVersion
                }
            })(createAnalyticsEvent);
            return undefined;
        }, this.onChangeSelect = (option)=>{
            this.props.onChange(option.value, this.changeAnalyticsCaller());
        }, this.onOptionKeyDown = (value)=>{
            this.props.onChange(value, this.changeAnalyticsCaller());
        }, this.onKeyDown = (e)=>{
            const key = e.key;
            if (key === (0, $7bfa827b2284d06c$export$10f6869ed0a7d75b)) this.setState({
                isTabbing: true
            });
            else if (key === (0, $7bfa827b2284d06c$export$b34c7ae3fd8138d2) || key === (0, $7bfa827b2284d06c$export$1734a06b2397c2a8)) this.setState({
                isTabbing: false
            });
            else if (key === (0, $7bfa827b2284d06c$export$929c2026f4dd54a2)) e.stopPropagation();
        }, this.getFullLabel = (intl, value, label)=>{
            if (value && value.label) return intl.formatMessage((0, $20iFi.default).colorPickerAriaLabel, {
                color: value.label,
                message: label
            });
            else return label;
        };
    }
}
const $701fb0a81d662465$export$2fcf66ed38ff3cf5 = (0, $6YFG2.default)($701fb0a81d662465$var$ColorPickerWithoutAnalyticsBase);
var $701fb0a81d662465$export$2e2bcd8739ae039 = (0, $dUaMU.default)({
    componentName: 'color-picker',
    packageName: $701fb0a81d662465$var$packageName,
    packageVersion: $701fb0a81d662465$var$packageVersion
})((0, $4J0ad.default)()($701fb0a81d662465$export$2fcf66ed38ff3cf5));
const $701fb0a81d662465$var$colorCardWrapperStyles = null;

});
parcelRegister("2yxf3", function(module, exports) {

$parcel$export(module.exports, "default", () => $e52eb0d445f2cec1$export$2e2bcd8739ae039);
/* Trigger.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $k71qx = parcelRequire("k71qx");

var $eGOwo = parcelRequire("eGOwo");
const $e52eb0d445f2cec1$var$ColorCard = ({ value: value, label: label, expanded: expanded, onClick: onClick, swatchSize: swatchSize = 'default', isDisabled: isDisabled, id: id, variant: variant = 'fill' })=>{
    const handleMouseDown = (0, $eJOHy.useCallback)((event)=>{
        event.preventDefault();
    }, []);
    const handleClick = (0, $eJOHy.useCallback)((event)=>{
        if (onClick) {
            event.preventDefault();
            onClick();
        }
    }, [
        onClick
    ]);
    const isOutlineVariant = variant === 'outline';
    const colorCardStyles = isOutlineVariant ? {
        borderColor: value || 'grey'
    } : {
        backgroundColor: value || 'transparent'
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
        content: label,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("button", {
            disabled: isDisabled,
            onClick: handleClick,
            onMouseDown: handleMouseDown,
            "aria-label": label,
            "aria-expanded": expanded,
            "aria-haspopup": true,
            type: "button",
            id: id,
            className: (0, $hcewu.default)([
                "_19it4jjs _2rko130s _v564ervx _12ji1r31 _1qu2glyw _12y31o36 _1e0c1o8l _kqswh2mm _vchhusvi _bfhktxrc _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _80omtlke",
                swatchSize === 'small' ? "_1bsb1tcg _4t3i1tcg _154i1i6y" : "_1bsbzwfg _4t3izwfg",
                "_nt751r31 _gk8x1r31 _49pcglyw _24ueglyw _1hvw1o36 _b4yv1o36 _858u1l4g _rslm1l4g _4cvxtxrc",
                expanded && !(0, $eGOwo.fg)('platform-design-system-dsp-20821-color-pickr-focus') && "_12ji1r31 _1qu2glyw _12y31o36 _1h6d1l4g"
            ]),
            children: /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                className: (0, $hcewu.default)([
                    "_1bsb1osq _4t3i1osq _1e0c1txw _4cvr1h6o _1bah1h6o"
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    style: colorCardStyles,
                    className: (0, $hcewu.default)([
                        isOutlineVariant ? "_2rkosqtm _189e1bk5 _1dqonqa1" : "_2rkosqtm _16qs16qq",
                        swatchSize === 'small' ? "_1bsb7vkz _4t3i7vkz" : "_1bsb1tcg _4t3i1tcg"
                    ])
                })
            })
        })
    });
};
var $e52eb0d445f2cec1$export$2e2bcd8739ae039 = $e52eb0d445f2cec1$var$ColorCard;
const $e52eb0d445f2cec1$var$sharedColorContainerStyles = null;
const $e52eb0d445f2cec1$var$smallColorContainerSize = null;
const $e52eb0d445f2cec1$var$defaultColorContainerSize = null;
const $e52eb0d445f2cec1$var$colorCardButtonStyles = null;
const $e52eb0d445f2cec1$var$colorCardButtonFocusedStyles = null;
const $e52eb0d445f2cec1$var$colorCardWrapperStyles = null;
const $e52eb0d445f2cec1$var$colorCardContentStyles = null;
const $e52eb0d445f2cec1$var$colorCardContentStylesOutline = null;
const $e52eb0d445f2cec1$var$smallColorCardContentSize = null;
const $e52eb0d445f2cec1$var$defaultColorCardContentSize = null;

});

parcelRegister("3DofW", function(module, exports) {

$parcel$export(module.exports, "MenuList", () => $675befeb14ad5b1d$export$d4c4e98c5044dc8);
$parcel$export(module.exports, "Option", () => $675befeb14ad5b1d$export$36d18380658d5d20);
$parcel$export(module.exports, "DropdownIndicator", () => $675befeb14ad5b1d$export$ec98719d3db7f2e4);
$parcel$export(module.exports, "Placeholder", () => $675befeb14ad5b1d$export$84712d0562a614b8);
/* components.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $8SHCI = parcelRequire("8SHCI");

var $dmrRn = parcelRequire("dmrRn");


var $lRq8t = parcelRequire("lRq8t");

var $20iFi = parcelRequire("20iFi");
const $675befeb14ad5b1d$export$d4c4e98c5044dc8 = (props)=>{
    const { //@ts-ignore react-select unsupported props
    selectProps: { cols: cols }, innerRef: innerRef, children: children } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        role: "group",
        "aria-label": formatMessage((0, $20iFi.default).menuListAriaLabel),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            maxWidth: cols ? (0, $dmrRn.getWidth)(cols) : undefined
        },
        //@ts-ignore react-select unsupported props
        ref: innerRef,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1n261g80 _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66"
        ]),
        children: children
    });
};
const $675befeb14ad5b1d$export$36d18380658d5d20 = (props)=>{
    const { data: { value: value, label: label }, //@ts-ignore react-select unsupported props
    selectProps: { checkMarkColor: checkMarkColor, onOptionKeyDown: onOptionKeyDown, isTabbing: isTabbing, variant: variant }, isFocused: isFocused, isSelected: isSelected, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ...innerProps,
        role: "radio",
        "aria-checked": isSelected,
        "aria-selected": undefined,
        "aria-label": label,
        className: (0, $hcewu.default)([
            "_1e0c1txw _19pkv77o _2hwxv77o _otyrv77o _18u0v77o _4t3izwfg"
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8SHCI.default), {
            type: (0, $7bfa827b2284d06c$export$9fea11a016bc5bcf),
            label: label,
            value: value,
            checkMarkColor: checkMarkColor,
            isOption: true,
            focused: isFocused,
            selected: isSelected,
            onKeyDown: (value)=>onOptionKeyDown(value),
            isTabbing: isTabbing,
            variant: variant
        })
    });
};
const $675befeb14ad5b1d$export$ec98719d3db7f2e4 = ()=>null;
const $675befeb14ad5b1d$export$84712d0562a614b8 = ()=>null;
const $675befeb14ad5b1d$var$colorCardWrapperStyles = null;
const $675befeb14ad5b1d$var$colorPaletteContainerStyles = null;

});
parcelRegister("8SHCI", function(module, exports) {

$parcel$export(module.exports, "default", () => $376483d419901d67$export$2e2bcd8739ae039);
/* ColorCard.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $6XkOW = parcelRequire("6XkOW");

var $k71qx = parcelRequire("k71qx");



var $kmlzw = parcelRequire("kmlzw");
const $376483d419901d67$var$ColorCard = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, componentRef)=>{
    const { type: type, autoFocus: autoFocus = true, initialFocusRef: initialFocusRef, isInsideMenu: isInsideMenu = true, value: value, label: label, selected: selected, focused: focused, checkMarkColor: checkMarkColor = (0, $7bb4c1736002a04a$export$29a4f05edc054374), isTabbing: isTabbing, onClick: onClick, onKeyDown: onKeyDown, variant: variant = 'fill' } = props;
    const ref = (0, $eJOHy.useRef)(null);
    const isInitialFocus = (0, $eJOHy.useRef)(true);
    const isColorPaletteMenu = type === (0, $7bfa827b2284d06c$export$2643a2cdce1d3963);
    const handleMouseDown = (0, $eJOHy.useCallback)((event)=>{
        event.preventDefault();
    }, []);
    const handleClick = (0, $eJOHy.useCallback)((event)=>{
        if (onClick) {
            event.preventDefault();
            onClick(event, value);
        }
    }, [
        onClick,
        value
    ]);
    const handleKeyDown = (0, $eJOHy.useCallback)((event)=>{
        if ((isColorPaletteMenu || isTabbing === undefined || isTabbing) && onClick && (event.key === (0, $7bfa827b2284d06c$export$8152f929a25a0ff4) || event.key === (0, $7bfa827b2284d06c$export$e51a3576c045c8d5))) {
            event.preventDefault();
            if (isTabbing) event.stopPropagation();
            onClick(event, value);
        }
        if (isColorPaletteMenu) onKeyDown?.(event);
        else if (event.key === (0, $7bfa827b2284d06c$export$10f6869ed0a7d75b)) {
            event.preventDefault();
            event.stopPropagation();
        }
    }, [
        isColorPaletteMenu,
        isTabbing,
        value,
        onClick,
        onKeyDown
    ]);
    (0, $eJOHy.useImperativeHandle)(componentRef, ()=>({
            focus: ()=>{
                if (isColorPaletteMenu) {
                    if (isInitialFocus.current) {
                        autoFocus && !initialFocusRef && ref.current?.focus();
                        isInitialFocus.current = false;
                    } else ref.current?.focus();
                }
            }
        }), [
        autoFocus,
        isColorPaletteMenu,
        initialFocusRef
    ]);
    const isInsideMenuRole = isInsideMenu ? 'menuitemradio' : 'radio';
    const role = isColorPaletteMenu ? isInsideMenuRole : 'presentation';
    const ariaChecked = isColorPaletteMenu ? selected : undefined;
    const ariaLabel = isColorPaletteMenu ? label : undefined;
    const isOutlineVariant = variant === 'outline';
    const newCheckmarkColor = isOutlineVariant ? "var(--ds-icon, #44546F)" : checkMarkColor;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
        content: label,
        children: (tooltipProps)=>{
            delete tooltipProps['aria-describedby'];
            return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                ...tooltipProps,
                ref: initialFocusRef ? (0, $kmlzw.mergeRefs)([
                    ref,
                    tooltipProps.ref,
                    initialFocusRef
                ]) : (0, $kmlzw.mergeRefs)([
                    ref,
                    tooltipProps.ref
                ]),
                role: role,
                tabIndex: selected ? 0 : -1,
                "aria-checked": ariaChecked,
                "aria-label": ariaLabel,
                onClick: handleClick,
                onMouseDown: handleMouseDown,
                onKeyDown: handleKeyDown,
                className: (0, $hcewu.default)([
                    "_19it4jjs _2rko130s _v564ervx _12ji1r31 _1qu2glyw _12y31o36 _1e0c1o8l _kqswh2mm _1bsbzwfg _4t3izwfg _vchhusvi _bfhktxrc _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _80omtlke",
                    (isColorPaletteMenu || isTabbing === undefined || isTabbing) && "_858uvmul _4cvxvmul",
                    focused && (isColorPaletteMenu || !isTabbing) && "_1h6dvmul"
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    className: (0, $hcewu.default)([
                        "_1bsb1osq _4t3i1osq _1e0c1txw _4cvr1h6o _1bah1h6o"
                    ]),
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    , {
                        style: isOutlineVariant ? {
                            borderColor: value || 'grey'
                        } : {
                            backgroundColor: value || 'transparent'
                        },
                        className: (0, $hcewu.default)([
                            "_2rkosqtm _1bsb1tcg _4t3i1tcg _16qs16qq",
                            isOutlineVariant && "_189e1bk5 _1dqonqa1 _16qsglyw"
                        ]),
                        children: selected && /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6XkOW))), {
                            color: newCheckmarkColor,
                            label: "",
                            spacing: "spacious",
                            LEGACY_margin: "1px"
                        })
                    })
                })
            });
        }
    });
});
var $376483d419901d67$export$2e2bcd8739ae039 = $376483d419901d67$var$ColorCard;
const $376483d419901d67$var$colorCardOptionTabbingStyles = null;
const $376483d419901d67$var$colorCardOptionFocusedStyles = null;
const $376483d419901d67$var$sharedColorContainerStyles = null;
const $376483d419901d67$var$colorCardWrapperStyles = null;
const $376483d419901d67$var$colorCardContentStyles = null;
const $376483d419901d67$var$colorCardContentStylesOutline = null;

});
parcelRegister("6XkOW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::666ec8073f4584891951ab85e48975eb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5108674e45de2f8c$var$_react = $5108674e45de2f8c$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $5108674e45de2f8c$var$_checkMark = $5108674e45de2f8c$var$_interopRequireDefault((parcelRequire("lwpci")));

var $5108674e45de2f8c$var$_done = $5108674e45de2f8c$var$_interopRequireDefault((parcelRequire("37Ug4")));
function $5108674e45de2f8c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CheckMarkIcon.
 * This component is CheckMarkIcon, with `UNSAFE_fallbackIcon` set to "EditorDoneIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5108674e45de2f8c$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $5108674e45de2f8c$var$_react.default.createElement($5108674e45de2f8c$var$_checkMark.default, Object.assign({
        LEGACY_fallbackIcon: $5108674e45de2f8c$var$_done.default
    }, props));
$5108674e45de2f8c$var$CheckMarkIcon.Name = 'CheckMarkIconMigration';
var $5108674e45de2f8c$var$_default = module.exports.default = $5108674e45de2f8c$var$CheckMarkIcon;

});
parcelRegister("lwpci", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a3e71f4112aeb66b16fbd284cc49bbc6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fab021c59a8f6419$var$_react = $fab021c59a8f6419$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fab021c59a8f6419$var$_baseNew = $fab021c59a8f6419$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $fab021c59a8f6419$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fab021c59a8f6419$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $fab021c59a8f6419$var$_react.default.createElement($fab021c59a8f6419$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m15.076 3.23-8.75 10.5a.75.75 0 0 1-1.159-.008l-4.25-5.25 1.166-.944 3.675 4.54 8.166-9.798z" clip-rule="evenodd"/>`
    }, props));
$fab021c59a8f6419$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $fab021c59a8f6419$var$_default = module.exports.default = $fab021c59a8f6419$var$CheckMarkIcon;

});

parcelRegister("37Ug4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $246daa468c067835$var$_react = $246daa468c067835$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $246daa468c067835$var$_checkMark = $246daa468c067835$var$_interopRequireDefault((parcelRequire("lwpci")));
function $246daa468c067835$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $246daa468c067835$var$EditorDoneIcon = (props)=>/*#__PURE__*/ $246daa468c067835$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M7.356 10.942a.497.497 0 0 0-.713 0l-.7.701a.5.5 0 0 0-.003.71l3.706 3.707a.5.5 0 0 0 .705.003l7.712-7.712a.493.493 0 0 0-.006-.708l-.7-.7a.504.504 0 0 0-.714 0l-6.286 6.286a.506.506 0 0 1-.713 0z"/></svg>`
    }, props, {
        newIcon: $246daa468c067835$var$_checkMark.default
    }));
$246daa468c067835$var$EditorDoneIcon.displayName = 'EditorDoneIcon';
var $246daa468c067835$var$_default = module.exports.default = $246daa468c067835$var$EditorDoneIcon;

});


const $7bfa827b2284d06c$export$9fea11a016bc5bcf = 'COLOR_PICKER';
const $7bfa827b2284d06c$export$2643a2cdce1d3963 = 'COLOR_PALETTE_MENU';
const $7bfa827b2284d06c$export$64c9b8c6e6a2c6ac = 32;
const $7bfa827b2284d06c$export$e51a3576c045c8d5 = ' ';
const $7bfa827b2284d06c$export$8152f929a25a0ff4 = 'Enter';
const $7bfa827b2284d06c$export$b34c7ae3fd8138d2 = 'ArrowUp';
const $7bfa827b2284d06c$export$1734a06b2397c2a8 = 'ArrowDown';
const $7bfa827b2284d06c$export$842fd6cf65a6b80c = 'ArrowLeft';
const $7bfa827b2284d06c$export$695331c89a36efd6 = 'ArrowRight';
const $7bfa827b2284d06c$export$10f6869ed0a7d75b = 'Tab';
const $7bfa827b2284d06c$export$929c2026f4dd54a2 = 'Escape';


parcelRegister("dmrRn", function(module, exports) {

$parcel$export(module.exports, "getWidth", () => $3d4e270ca6cd0f6d$export$3c49c185de0c2bfc);
$parcel$export(module.exports, "getOptions", () => $3d4e270ca6cd0f6d$export$d2312e68e1f5ad00);
// AFP-2532 TODO: Fix automatic suppressions below
// eslint-disable-next-line @atlassian/tangerine/import/entry-points

var $IW7jS = parcelRequire("IW7jS");


var $LFmXM = parcelRequire("LFmXM");

var $j2tr1 = parcelRequire("j2tr1");
const $3d4e270ca6cd0f6d$export$3c49c185de0c2bfc = (cols, mode)=>{
    const width = cols * ((0, $7bfa827b2284d06c$export$64c9b8c6e6a2c6ac) + (0, $IW7jS.gridSize)() / 2);
    return mode === (0, $j2tr1.Mode).Standard ? width + (0, $IW7jS.gridSize)() : width;
};
const $3d4e270ca6cd0f6d$export$d2312e68e1f5ad00 = (0, $LFmXM.default)((palette, selectedColor, showDefaultSwatchColor)=>{
    let focusedItemIndex = 0;
    let defaultSelectedColor = palette[0];
    if (!showDefaultSwatchColor) defaultSelectedColor = {
        label: '',
        value: ''
    };
    const value = palette.find((color, index)=>{
        if (color.value === selectedColor) {
            focusedItemIndex = index;
            return true;
        }
        return false;
    }) || defaultSelectedColor;
    return {
        options: palette,
        value: value,
        focusedItemIndex: focusedItemIndex
    };
});

});
parcelRegister("j2tr1", function(module, exports) {

$parcel$export(module.exports, "Mode", () => $f3c5976a1b5e3dac$export$9484bbecc3c49a2e);
var $f3c5976a1b5e3dac$export$9484bbecc3c49a2e = /*#__PURE__*/ function(Mode) {
    Mode[Mode["Compact"] = 0] = "Compact";
    Mode[Mode["Standard"] = 1] = "Standard";
    return Mode;
}({});

});


parcelRegister("20iFi", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e6d54e8a9a1463d$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $5e6d54e8a9a1463d$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    colorPickerAriaLabel: {
        id: 'jira.color-picker.src.color-picker-aria-label',
        defaultMessage: '{color} selected, {message}',
        description: 'This text is used as aria-label text in color picker component'
    },
    menuListAriaLabel: {
        id: 'jira.color-picker.src.menu-list-aria-label',
        defaultMessage: 'Color picker list',
        description: 'This text is used as aria-label text for the listbox element in color picker component'
    }
});

});



parcelRegister("7PKEg", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d309be0be175b64$export$2e2bcd8739ae039);
/* ColorPaletteMenu.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j2tr1 = parcelRequire("j2tr1");

var $5fWw9 = parcelRequire("5fWw9");
var $dUaMU = parcelRequire("dUaMU");
var $4J0ad = parcelRequire("4J0ad");

var $8SHCI = parcelRequire("8SHCI");

var $dmrRn = parcelRequire("dmrRn");

const $1d309be0be175b64$export$4bbfe93c6a14e8e6 = ({ autoFocus: autoFocus = true, isFocusLockEnabled: isFocusLockEnabled = true, isInsideMenu: isInsideMenu = true, createAnalyticsEvent: createAnalyticsEvent, onChange: onChange, palette: palette, selectedColor: selectedColor, checkMarkColor: checkMarkColor, label: label = 'Color picker', cols: cols = 6, mode: mode = (0, $j2tr1.Mode).Standard, initialFocusRef: initialFocusRef, variant: variant = 'fill' })=>{
    const { options: options, value: selectedValue } = (0, $dmrRn.getOptions)(palette, selectedColor);
    const fullLabel = `${label}, ${selectedValue.label} selected`;
    const selectedColorIndex = selectedValue.value ? options.findIndex(({ value: value })=>value === selectedValue.value) : 0;
    const [focusedIndex, setFocusedIndex] = (0, $eJOHy.useState)(selectedColorIndex);
    const createAndFireEventOnAtlaskit = (0, $5fWw9.default)('atlaskit');
    const changeAnalyticsCaller = ()=>{
        if (createAnalyticsEvent) return createAndFireEventOnAtlaskit({
            action: 'clicked',
            actionSubject: 'color-palette-menu',
            attributes: {
                componentName: 'color-picker',
                packageName: "platform-pkg",
                packageVersion: "0.0.0-use.local"
            }
        })(createAnalyticsEvent);
        return undefined;
    };
    const colorCardRefs = (0, $eJOHy.useMemo)(()=>[], []);
    const handleChange = (event, value)=>{
        onChange(event, value, changeAnalyticsCaller());
    };
    (0, $eJOHy.useEffect)(()=>{
        colorCardRefs[focusedIndex]?.focus();
    }, [
        focusedIndex,
        colorCardRefs
    ]);
    const handleKeyDown = (0, $eJOHy.useCallback)((event)=>{
        const numItems = options.length;
        switch(event.key){
            case 0, $7bfa827b2284d06c$export$1734a06b2397c2a8:
            case 0, $7bfa827b2284d06c$export$695331c89a36efd6:
                setFocusedIndex((prevIndex)=>(prevIndex + 1) % numItems);
                break;
            case 0, $7bfa827b2284d06c$export$b34c7ae3fd8138d2:
            case 0, $7bfa827b2284d06c$export$842fd6cf65a6b80c:
                setFocusedIndex((prevIndex)=>(prevIndex - 1 + numItems) % numItems);
                break;
            case 0, $7bfa827b2284d06c$export$10f6869ed0a7d75b:
                if (isFocusLockEnabled) {
                    event.preventDefault();
                    event.stopPropagation();
                    setFocusedIndex(selectedColorIndex);
                }
                break;
            default:
                break;
        }
    }, [
        isFocusLockEnabled,
        selectedColorIndex,
        setFocusedIndex,
        options
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "aria-label": fullLabel,
        role: isInsideMenu ? 'menu' : 'radiogroup',
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            width: `${(0, $dmrRn.getWidth)(cols, mode)}px`
        },
        className: (0, $hcewu.default)([
            "_1e0c1txw _kqswh2mm _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t _bfhk1bhr",
            mode === (0, $j2tr1.Mode).Standard && "_2rkosqtm _16qs1akw"
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            className: (0, $hcewu.default)([
                "_1e0c1txw _1n261g80 _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
                mode === (0, $j2tr1.Mode).Compact && "_ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t"
            ]),
            children: options.map(({ label: label, value: value }, index)=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    className: (0, $hcewu.default)([
                        "_1e0c1txw _19pkv77o _2hwxv77o _otyrv77o _18u0v77o _4t3izwfg"
                    ]),
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8SHCI.default), {
                        type: (0, $7bfa827b2284d06c$export$2643a2cdce1d3963),
                        label: label,
                        value: value,
                        checkMarkColor: checkMarkColor,
                        isOption: true,
                        selected: value === selectedValue.value,
                        onClick: handleChange,
                        ref: (ref)=>{
                            colorCardRefs[index] = ref;
                        },
                        autoFocus: autoFocus,
                        initialFocusRef: value === selectedValue.value ? initialFocusRef : undefined,
                        isInsideMenu: isInsideMenu,
                        onKeyDown: handleKeyDown,
                        variant: variant
                    })
                }, value))
        })
    });
};
var $1d309be0be175b64$export$2e2bcd8739ae039 = (0, $dUaMU.default)({
    componentName: 'color-picker',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
})((0, $4J0ad.default)()($1d309be0be175b64$export$4bbfe93c6a14e8e6));
const $1d309be0be175b64$var$colorCardWrapperStyles = null;
const $1d309be0be175b64$var$colorPaletteContainerStyles = null;
const $1d309be0be175b64$var$colorPaletteContainerCompactStyles = null;
const $1d309be0be175b64$var$colorPaletteMenuStyles = null;
const $1d309be0be175b64$var$colorPaletteMenuStandardStyles = null;

});


parcelRegister("kNB2R", function(module, exports) {

$parcel$export(module.exports, "colorFieldDataTestId", () => $d701a8649f5ce105$export$d5ae1babf783fed9);
$parcel$export(module.exports, "getI18nColorPalette", () => $d701a8649f5ce105$export$9ceccb3244ae7dac);

var $LFmXM = parcelRequire("LFmXM");

var $1wTTU = parcelRequire("1wTTU");
const $d701a8649f5ce105$export$d5ae1babf783fed9 = 'issue.views.issue-base.foundation.color.color-picker-wrapper';
const $d701a8649f5ce105$export$9ceccb3244ae7dac = (0, $LFmXM.default)(({ formatMessage: formatMessage })=>(0, $1wTTU.getDefaultColorPalette)(formatMessage));

});

parcelRegister("1Qtfz", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa638d7428b263be$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $fa638d7428b263be$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    label: {
        "id": "color-picker.edit.label",
        "defaultMessage": "Change color"
    }
});

});



parcelRegister("dUh12", function(module, exports) {

$parcel$export(module.exports, "mutateEpicColorField", () => $90f0dc76a1d62d33$export$80288f09329d6da0);
$parcel$export(module.exports, "mutateIssueColorField", () => $90f0dc76a1d62d33$export$9e0b17281ec856bc);

var $1wTTU = parcelRequire("1wTTU");

const $90f0dc76a1d62d33$export$80288f09329d6da0 = (selectedColor, fieldId)=>({
        fieldId: fieldId,
        mutationGroup: (0, $292db06eaf05de2a$export$31fd86f8f183952c),
        color: {
            name: (0, $1wTTU.asClassicEpicColor)(selectedColor)
        }
    });
const $90f0dc76a1d62d33$export$9e0b17281ec856bc = (selectedColor, fieldId)=>({
        fieldId: fieldId,
        mutationGroup: (0, $292db06eaf05de2a$export$31fd86f8f183952c),
        color: {
            name: (0, $1wTTU.asServerColor)(selectedColor)
        }
    });

});
const $292db06eaf05de2a$export$31fd86f8f183952c = 'colorFields';


parcelRegister("ktkwO", function(module, exports) {

$parcel$export(module.exports, "default", () => $bad20b5e9d5cbbe6$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $k71qx = parcelRequire("k71qx");

var $3vXi5 = parcelRequire("3vXi5");

var $lRq8t = parcelRequire("lRq8t");

var $f5ikm = parcelRequire("f5ikm");

var $ecSnb = parcelRequire("ecSnb");

var $coifs = parcelRequire("coifs");

var $fE4zR = parcelRequire("fE4zR");

var $l9vfc = parcelRequire("l9vfc");

var $2nXHu = parcelRequire("2nXHu");

var $ixdDB = parcelRequire("ixdDB");

var $4yQUm = parcelRequire("4yQUm");

var $2eRZu = parcelRequire("2eRZu");

const $bad20b5e9d5cbbe6$var$ComponentsField = (props)=>{
    const { autoFocus: autoFocus, width: width, fieldProps: { value: value, onChange: onChange, id: id, isRequired: isRequired, ...fieldProps }, error: error, allowedValues: allowedValues, selectedProject: selectedProject, description: description, fieldName: fieldName, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, $ixdDB.closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, isReadOnly: isReadOnly = false, isMini: isMini } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const isDisabled = allowedValues.length === 0;
    const options = (0, $ecSnb.mapDataToOptions)(allowedValues);
    const { projectKey: projectKey } = selectedProject || {};
    const projectKeyStr = projectKey || '';
    const { enabled: areGlobalComponentsEnabled, loading: loading } = (0, $3vXi5.useGlobalComponentsProperty)(projectKeyStr);
    const getComponentSelectEdit = ()=>{
        if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $l9vfc.StyledFieldSkeleton), null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f5ikm.default), {
            ...fieldProps,
            options: options,
            isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
            value: value,
            onChange: onChange,
            autoFocus: autoFocus,
            isInvalid: Boolean(error),
            showFooter: false,
            projectKey: projectKeyStr,
            placeholder: isDisabled ? formatMessage((0, $2eRZu.default).none) : '',
            isDisabled: isDisabled || isReadOnly,
            onCloseMenuOnScroll: onCloseMenuOnScroll,
            canCreateNewItem: !areGlobalComponentsEnabled,
            inputId: id,
            isRequired: isRequired
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fE4zR.FieldContainer), {
        width: width
    }, isDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: formatMessage((0, $2eRZu.default).tooltipWhenDisabled)
    }, getComponentSelectEdit()) : getComponentSelectEdit(), !isDisabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $coifs.FieldMessage), {
        description: description,
        error: error,
        fieldName: fieldName,
        isMini: isMini
    }));
};
var $bad20b5e9d5cbbe6$export$2e2bcd8739ae039 = (0, $2nXHu.withFormField)({
    transformDefaultValue: (0, $ecSnb.mapDataToOptions),
    validator: (0, $4yQUm.validateComponentField),
    shouldRenderFieldMessage: false
})($bad20b5e9d5cbbe6$var$ComponentsField);

});
parcelRegister("3vXi5", function(module, exports) {

$parcel$export(module.exports, "useGlobalComponentsProperty", () => $508bf55092e05713$export$a070f388fcd93df0);

var $eJOHy = parcelRequire("eJOHy");

var $aBthQ = parcelRequire("aBthQ");

var $hbF3h = parcelRequire("hbF3h");

var $7jTnu = parcelRequire("7jTnu");

var $eJrcF = parcelRequire("eJrcF");

var $6zEUu = parcelRequire("6zEUu");

var $2aQVf = parcelRequire("2aQVf");
function $508bf55092e05713$var$useGlobalComponentsPropertyOld(projectKey) {
    const [loading, setLoading] = (0, $eJOHy.useState)(true);
    const [enabled, setEnabled] = (0, $eJOHy.useState)(undefined);
    const [error, setError] = (0, $eJOHy.useState)(undefined);
    const loadGlobalComponentsProperty = (0, $eJOHy.useCallback)(()=>{
        setEnabled(undefined);
        setError(undefined);
        setLoading(true);
    }, [
        setEnabled,
        setError,
        setLoading
    ]);
    const resolveGlobalComponentsProperty = (0, $eJOHy.useCallback)((value)=>{
        if (value instanceof Error) {
            setEnabled(undefined);
            setError(value);
        } else {
            setEnabled(value);
            setError(undefined);
        }
        setLoading(false);
    }, [
        setEnabled,
        setError,
        setLoading
    ]);
    (0, $eJOHy.useEffect)(()=>{
        loadGlobalComponentsProperty();
        (0, $2aQVf.getGlobalComponentsProperty)(projectKey).then((r)=>resolveGlobalComponentsProperty(r.value)).catch((e)=>resolveGlobalComponentsProperty(e));
    }, [
        loadGlobalComponentsProperty,
        resolveGlobalComponentsProperty,
        projectKey
    ]);
    const setProperty = (0, $eJOHy.useCallback)((newValue)=>{
        loadGlobalComponentsProperty();
        return (0, $2aQVf.setGlobalComponentsProperty)(projectKey, newValue)// We are clearing the Jira components cache here which is the
        // data source for "Recent components" in the components field
        // for Jira issues. This should be cleared when toggling between
        // global components enabled or disabled to avoid stales
        // suggestions from either.
        .then(()=>(0, $aBthQ.default).clearAll()).then(()=>resolveGlobalComponentsProperty(newValue)).catch((e)=>{
            resolveGlobalComponentsProperty(e);
            throw e;
        });
    }, [
        loadGlobalComponentsProperty,
        resolveGlobalComponentsProperty,
        projectKey
    ]);
    return {
        enabled: enabled,
        loading: loading,
        error: error,
        setProperty: setProperty
    };
}
function $508bf55092e05713$var$useGlobalComponentsPropertyNew(projectKey) {
    const { data: resourceData, loading: resourceLoading, error: resourceError, promise: resourcePromise } = (0, $eJrcF.useResource)((0, $6zEUu.projectGlobalComponentsResource));
    const [resourceAvailable] = (0, $eJOHy.useState)(Boolean(resourceData) || Boolean(resourcePromise) || Boolean(resourceError) || Boolean(resourceLoading));
    // If the resource is not available, fallback loading to true as per the old implementation
    const [loading, setLoading] = (0, $eJOHy.useState)(resourceAvailable ? resourceLoading : true);
    const [enabled, setEnabled] = (0, $eJOHy.useState)(resourceLoading === false ? resourceData?.value : undefined);
    const [error, setError] = (0, $eJOHy.useState)(resourceError instanceof Error ? resourceError : undefined);
    const loadGlobalComponentsProperty = (0, $eJOHy.useCallback)(()=>{
        setEnabled(undefined);
        setError(undefined);
        setLoading(true);
    }, [
        setEnabled,
        setError,
        setLoading
    ]);
    const resolveGlobalComponentsProperty = (0, $eJOHy.useCallback)((value)=>{
        if (value instanceof Error) {
            setEnabled(undefined);
            setError(value);
        } else {
            setEnabled(value);
            setError(undefined);
        }
        setLoading(false);
    }, [
        setEnabled,
        setError,
        setLoading
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (resourceLoading) resourcePromise?.then((d)=>resolveGlobalComponentsProperty(d?.value)).catch((e)=>resolveGlobalComponentsProperty(e));
        else if (!resourceAvailable) {
            // If resource does not exist, we need to load the property manually
            loadGlobalComponentsProperty();
            (0, $2aQVf.getGlobalComponentsProperty)(projectKey).then((r)=>resolveGlobalComponentsProperty(r.value)).catch((e)=>resolveGlobalComponentsProperty(e));
        }
    }, [
        resourceLoading,
        resourcePromise,
        resolveGlobalComponentsProperty,
        loadGlobalComponentsProperty,
        projectKey,
        resourceAvailable
    ]);
    const setProperty = (0, $eJOHy.useCallback)((newValue)=>{
        loadGlobalComponentsProperty();
        return (0, $2aQVf.setGlobalComponentsProperty)(projectKey, newValue)// We are clearing the Jira components cache here which is the
        // data source for "Recent components" in the components field
        // for Jira issues. This should be cleared when toggling between
        // global components enabled or disabled to avoid stales
        // suggestions from either.
        .then(()=>(0, $aBthQ.default).clearAll()).then(()=>resolveGlobalComponentsProperty(newValue)).catch((e)=>{
            resolveGlobalComponentsProperty(e);
            throw e;
        });
    }, [
        loadGlobalComponentsProperty,
        resolveGlobalComponentsProperty,
        projectKey
    ]);
    return {
        enabled: enabled,
        loading: loading,
        error: error,
        setProperty: setProperty
    };
}
const $508bf55092e05713$export$a070f388fcd93df0 = (0, $hbF3h.functionWithCondition)(()=>(0, $7jTnu.fg)('jira-project-isglobalcomponent-route-resource'), $508bf55092e05713$var$useGlobalComponentsPropertyNew, $508bf55092e05713$var$useGlobalComponentsPropertyOld);

});
parcelRegister("aBthQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b78104e48e12705$export$2e2bcd8739ae039);

var $2ZrIe = parcelRequire("2ZrIe");

var $iwh6p = parcelRequire("iwh6p");
var $6b78104e48e12705$export$2e2bcd8739ae039 = (0, $2ZrIe.default)((0, $iwh6p.props));

});
parcelRegister("2ZrIe", function(module, exports) {

$parcel$export(module.exports, "default", () => $68c90beac6bbcd15$export$2e2bcd8739ae039);

var $dQ3qN = parcelRequire("dQ3qN");
const $68c90beac6bbcd15$var$pNothing = ()=>Promise.resolve();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$68c90beac6bbcd15$export$2e2bcd8739ae039 = (config)=>{
    if (!false) {
        const Cache = (0, $dQ3qN.default)(config);
        const getAll = ()=>Cache.then((cache)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
                cache.getEntries().then((entries)=>entries.map(([, value])=>value)));
        const get = (key)=>Cache.then((cache)=>cache.get(key));
        const set = (key, value)=>Cache.then((cache)=>cache.set(key, value));
        const remove = (key)=>Cache.then((cache)=>cache.delete(key));
        const update = (key, value)=>Cache.then((cache)=>cache.update(key, value));
        const refresh = ()=>Cache.then((cache)=>cache.refresh()).then(()=>getAll());
        const clearAll = ()=>Cache.then((cache)=>cache.getEntries().then((entries)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
                    Promise.all(entries.map(([key])=>cache.delete(key)))) // Replace with lodash/noop
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                .then(()=>{}));
        return {
            get: get,
            getAll: getAll,
            set: set,
            remove: remove,
            update: update,
            refresh: refresh,
            clearAll: clearAll
        };
    }
    return {
        // @ts-expect-error - TS2322 - Type '() => Promise<void>' is not assignable to type '(key: string) => Promise<C | undefined>'.
        get: $68c90beac6bbcd15$var$pNothing,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        getAll: ()=>Promise.resolve([]),
        set: ()=>Promise.resolve(),
        remove: $68c90beac6bbcd15$var$pNothing,
        update: $68c90beac6bbcd15$var$pNothing,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        refresh: ()=>Promise.resolve([]),
        clearAll: $68c90beac6bbcd15$var$pNothing
    };
};

});
parcelRegister("dQ3qN", function(module, exports) {

$parcel$export(module.exports, "Cache", () => $dad4e0b94ce9085b$export$94affb487e701bf2);
$parcel$export(module.exports, "default", () => $dad4e0b94ce9085b$export$2e2bcd8739ae039);

var $dnU6V = parcelRequire("dnU6V");

var $4elgJ = parcelRequire("4elgJ");

var $eSnSE = parcelRequire("eSnSE");


var $6O0zm = parcelRequire("6O0zm");
const $dad4e0b94ce9085b$var$calculateEntryAge = (timestamp)=>Date.now() - timestamp;
function $dad4e0b94ce9085b$export$94affb487e701bf2(props) {
    const cache = new Map();
    const { size: size } = props;
    let storage;
    let hasSyncedFromStorage = false;
    const devTools = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__.connect({
        name: `Cache ${props.cacheKey}`,
        serialize: true
    }) : null;
    const syncWithDevTools = (type, payload)=>{
        if ((0, $6O0zm.default).devTools) devTools && devTools.send({
            type: type,
            payload: payload
        }, cache, {}, props.cacheKey);
    };
    const removeExpiredKeysFromStorage = async (store)=>{
        const updatedStore = {
            ...store
        };
        if (props.storageType === (0, $8da4e41a25982619$export$bf340b99118a1511)) return {};
        const { cacheKey: cacheKey, maxAge: maxAge } = props;
        if (maxAge !== undefined) {
            Object.keys(store).forEach((key)=>{
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                const keyAge = $dad4e0b94ce9085b$var$calculateEntryAge(store[key].timestamp);
                if (keyAge > maxAge) {
                    // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: any; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                    syncWithDevTools((0, $8da4e41a25982619$export$26d12233004a7a60), {
                        [String(key)]: updatedStore[key]
                    });
                    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                    delete updatedStore[key];
                    // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'K'.
                    cache.delete(key);
                }
            });
            storage.set(cacheKey, updatedStore);
        }
        return updatedStore;
    };
    const removeExpiredEntry = (key, val)=>{
        if (props.storageType !== (0, $8da4e41a25982619$export$bf340b99118a1511)) {
            const { maxAge: maxAge } = props;
            if (maxAge !== undefined && $dad4e0b94ce9085b$var$calculateEntryAge(val.timestamp) > maxAge) {
                // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V>; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
                syncWithDevTools((0, $8da4e41a25982619$export$26d12233004a7a60), {
                    [String(key)]: val
                });
                cache.delete(key);
                return true;
            }
        }
        return false;
    };
    const createStore = ()=>{
        if (props.storageType === (0, $8da4e41a25982619$export$2670cb7d5d4f7184)) storage = (0, $dnU6V.createLocalStorageProvider)((0, $6O0zm.CACHE_PREFIX));
        else storage = (0, $4elgJ.createSessionStorageProvider)((0, $6O0zm.CACHE_PREFIX));
        return storage;
    };
    const set = async (key, value)=>{
        await load();
        // @ts-expect-error - TS2345 - Argument of type 'string | K' is not assignable to parameter of type 'K'.
        cache.delete(key);
        const entry = {
            value: value,
            timestamp: Date.now()
        };
        let storedContent = {};
        if (props.storageType !== (0, $8da4e41a25982619$export$bf340b99118a1511)) {
            storedContent = storage.get(props.cacheKey) || {};
            // @ts-expect-error - TS2536 - Type 'string | K' cannot be used to index type 'Partial<Record<K, Entry<V>>>'.
            storedContent[key] = entry;
        }
        // @ts-expect-error - TS2345 - Argument of type 'string | K' is not assignable to parameter of type 'K'.
        cache.set(key, entry);
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V>; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $8da4e41a25982619$export$5e8f180ef0142226), {
            [String(key)]: entry
        });
        if (cache.size > size) {
            const keys = cache.keys();
            const firstEntry = keys.next().value;
            if (firstEntry !== undefined) {
                cache.delete(firstEntry);
                syncWithDevTools((0, $8da4e41a25982619$export$a61768fefd33fcb1), firstEntry);
                if (props.storageType !== (0, $8da4e41a25982619$export$bf340b99118a1511)) // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                delete storedContent[firstEntry];
            }
        }
        props.storageType !== (0, $8da4e41a25982619$export$bf340b99118a1511) && storage.set(props.cacheKey, storedContent);
    };
    const load = async ()=>{
        if (false || hasSyncedFromStorage) return;
        hasSyncedFromStorage = true;
        if (props.storageType === (0, $8da4e41a25982619$export$bf340b99118a1511)) return;
        const { cacheKey: cacheKey } = props;
        storage = createStore();
        try {
            let data = storage.get(cacheKey) || {};
            data = await removeExpiredKeysFromStorage(data);
            syncWithDevTools((0, $8da4e41a25982619$export$61f74127e2b53cbe), data);
            const orderedKeys = Object.keys(data).sort(// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
            (key1, key2)=>data[key1].timestamp - data[key2].timestamp);
            await Promise.all(orderedKeys.map(async (key)=>{
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                await set(key, data[key].value);
            }));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $eSnSE.default).safeWarnWithoutCustomerData((0, $8da4e41a25982619$export$7271276960377470), `There was an error syncing with storage - ${cacheKey}`, err);
            throw err;
        }
    };
    const clear = async ()=>{
        await load();
        cache.clear();
        if (props.storageType !== (0, $8da4e41a25982619$export$bf340b99118a1511)) {
            const { cacheKey: cacheKey } = props;
            storage.remove(cacheKey);
        }
        syncWithDevTools((0, $8da4e41a25982619$export$6c4d37c7f376a1de), {});
    };
    const get = async (key)=>{
        await load();
        let val = cache.get(key);
        if (val) {
            if (removeExpiredEntry(key, val)) val = undefined;
        }
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V> | undefined; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $8da4e41a25982619$export$1bb358554aac31c1), {
            [String(key)]: val
        });
        return val && val.value;
    };
    const update = async (key, value)=>{
        await load();
        const previousValue = cache.get(key);
        if (!previousValue) return;
        const entry = {
            value: value,
            timestamp: previousValue.timestamp
        };
        let storedContent = {};
        if (props.storageType !== (0, $8da4e41a25982619$export$bf340b99118a1511)) {
            storedContent = storage.get(props.cacheKey) || {};
            storedContent[key] = entry;
        }
        cache.set(key, entry);
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V>; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $8da4e41a25982619$export$e271b26eefe41db8), {
            [String(key)]: entry
        });
        props.storageType !== (0, $8da4e41a25982619$export$bf340b99118a1511) && storage.set(props.cacheKey, storedContent);
    };
    const getEntries = async ()=>{
        await load();
        const entries = Array.from(cache.entries()).filter(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        ([key, value])=>!removeExpiredEntry(key, value));
        syncWithDevTools((0, $8da4e41a25982619$export$9eb68924983e00fb), entries);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return entries.map(([key, { value: value }])=>[
                key,
                value
            ]);
    };
    const deleteEntry = async (key)=>{
        await load();
        if (props.storageType !== (0, $8da4e41a25982619$export$bf340b99118a1511)) {
            const storedContent = storage.get(props.cacheKey) || {};
            delete storedContent[key];
            storage.set(props.cacheKey, storedContent);
        }
        cache.delete(key);
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V> | undefined; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $8da4e41a25982619$export$4bd2facc4a3e6aa1), {
            [String(key)]: cache.get(key)
        });
    };
    const refresh = async ()=>{
        if (props.storageType === (0, $8da4e41a25982619$export$bf340b99118a1511)) return;
        cache.clear();
        hasSyncedFromStorage = false;
        await load();
    };
    if ((0, $6O0zm.default).scopes.current !== (0, $6O0zm.default).scopes.prev) clear();
    return {
        cache: cache,
        get: get,
        set: set,
        delete: deleteEntry,
        clear: clear,
        load: load,
        update: update,
        getEntries: // @ts-expect-error - TS2322 - Type '() => Promise<any[][]>' is not assignable to type '() => Promise<[K, V][]>'.
        getEntries,
        refresh: refresh
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $dad4e0b94ce9085b$var$cacheMap = {};
const $dad4e0b94ce9085b$var$getCache = async (props)=>{
    await (0, $6O0zm.scopeGuard)().catch((error)=>{
        (0, $eSnSE.default).safeErrorWithoutCustomerData('common.cache.scope', 'There was a failure within cache scopeGuard', error);
    });
    const { cacheKey: cacheKey } = props;
    // @ts-expect-error - TS7009 - 'new' expression, whose target lacks a construct signature, implicitly has an 'any' type.
    $dad4e0b94ce9085b$var$cacheMap[cacheKey] = $dad4e0b94ce9085b$var$cacheMap[cacheKey] || new $dad4e0b94ce9085b$export$94affb487e701bf2(props);
    return $dad4e0b94ce9085b$var$cacheMap[cacheKey];
};
const $dad4e0b94ce9085b$export$710d301bf26d9700 = ()=>{
    Object.values($dad4e0b94ce9085b$var$cacheMap).forEach((cache)=>cache.clear());
};
var $dad4e0b94ce9085b$export$2e2bcd8739ae039 = $dad4e0b94ce9085b$var$getCache;

});
const $8da4e41a25982619$export$7271276960377470 = 'common-cache';
const $8da4e41a25982619$export$a61768fefd33fcb1 = 'capacity exceeded';
const $8da4e41a25982619$export$6c4d37c7f376a1de = 'clear';
const $8da4e41a25982619$export$e271b26eefe41db8 = 'update';
const $8da4e41a25982619$export$4bd2facc4a3e6aa1 = 'delete';
const $8da4e41a25982619$export$26d12233004a7a60 = 'delete stale entry';
const $8da4e41a25982619$export$1bb358554aac31c1 = 'get';
const $8da4e41a25982619$export$61f74127e2b53cbe = 'hydrate';
const $8da4e41a25982619$export$5e8f180ef0142226 = 'set';
const $8da4e41a25982619$export$9eb68924983e00fb = 'get entries';
const $8da4e41a25982619$export$bf340b99118a1511 = 'memory';
const $8da4e41a25982619$export$2670cb7d5d4f7184 = 'local';
const $8da4e41a25982619$export$b796061ff0c82e1a = 'session';



parcelRegister("iwh6p", function(module, exports) {

$parcel$export(module.exports, "props", () => $4231e629c0fae11c$export$8128bb6492cf3de7);

const $4231e629c0fae11c$var$MAX_RESULTS = 10;
const $4231e629c0fae11c$var$CACHE_SIZE = $4231e629c0fae11c$var$MAX_RESULTS * 2;
const $4231e629c0fae11c$var$COMPONENTS_CACHE_KEY = 'components';
const $4231e629c0fae11c$export$8128bb6492cf3de7 = {
    size: $4231e629c0fae11c$var$CACHE_SIZE,
    cacheKey: $4231e629c0fae11c$var$COMPONENTS_CACHE_KEY,
    maxAge: 604800000,
    storageType: (0, $8da4e41a25982619$export$2670cb7d5d4f7184)
};

});


parcelRegister("6zEUu", function(module, exports) {

$parcel$export(module.exports, "projectGlobalComponentsResource", () => $dea084457308c93c$export$d2cb7067a31cf873);

var $l1VxS = parcelRequire("l1VxS");

var $bBtQo = parcelRequire("bBtQo");

var $3Is9n = parcelRequire("3Is9n");
const $dea084457308c93c$export$be79e0677801e96e = 'PROJECT_GLOBAL_COMPONENTS';
const $dea084457308c93c$export$d2cb7067a31cf873 = (0, $l1VxS.createResource)({
    type: $dea084457308c93c$export$be79e0677801e96e,
    getKey: (matchedRoute)=>(0, $bBtQo.getProjectIdOrKey)(matchedRoute.match, matchedRoute.query),
    getData: (...args)=>(0, $3Is9n.getData)(...args)
});

});
parcelRegister("3Is9n", function(module, exports) {

$parcel$export(module.exports, "getData", () => $c5448ba1b9fac404$export$7a171f172be0782e);

var $bBtQo = parcelRequire("bBtQo");

var $gYnSx = parcelRequire("gYnSx");

var $jGzN3 = parcelRequire("jGzN3");
const $c5448ba1b9fac404$export$7a171f172be0782e = async (matchedRoute, _)=>{
    const projectIdOrKey = (0, $bBtQo.getProjectIdOrKey)(matchedRoute.match, matchedRoute.query);
    if (projectIdOrKey == null || projectIdOrKey === '') return null;
    return $c5448ba1b9fac404$export$1db3503600a1638e(projectIdOrKey);
};
const $c5448ba1b9fac404$var$GLOBAL_COMPONENTS_PROPERTY_KEY = 'jira.global.components';
// Default projectKey regex, source: https://stash.atlassian.com/projects/JIRACLOUD/repos/jira/browse/jira-components/jira-api/src/main/java/com/atlassian/jira/util/JiraKeyUtils.java#421
const $c5448ba1b9fac404$var$PROJECT_KEY_REGEX = /^[A-Z][A-Z]+$/;
const $c5448ba1b9fac404$var$url = (projectIdOrKey, entityKey)=>`/rest/api/3/project/${projectIdOrKey}/properties/${entityKey}`;
const $c5448ba1b9fac404$var$getProjectId = async (projectKey)=>{
    const project = await (0, $jGzN3.performGetRequest)(`/rest/api/3/project/${projectKey}`);
    return project?.id;
};
const $c5448ba1b9fac404$export$1db3503600a1638e = async (projectKey)=>{
    try {
        let endpoint;
        if (!$c5448ba1b9fac404$var$PROJECT_KEY_REGEX.test(projectKey)) {
            // We need to fetch the project id here because some users have malformed project keys that are not compatible with the project properties endpoint
            const projectId = await $c5448ba1b9fac404$var$getProjectId(projectKey);
            if (!projectId) return {
                key: $c5448ba1b9fac404$var$GLOBAL_COMPONENTS_PROPERTY_KEY,
                value: null
            };
            endpoint = $c5448ba1b9fac404$var$url(projectId, $c5448ba1b9fac404$var$GLOBAL_COMPONENTS_PROPERTY_KEY);
        } else endpoint = $c5448ba1b9fac404$var$url(projectKey, $c5448ba1b9fac404$var$GLOBAL_COMPONENTS_PROPERTY_KEY);
        return await (0, $jGzN3.performGetRequest)(endpoint);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // The endpoint returns 404 if the project property is not set, but we don't treat it as an
        // actual error
        if (error.statusCode === 404) return {
            key: $c5448ba1b9fac404$var$GLOBAL_COMPONENTS_PROPERTY_KEY,
            value: null
        };
        (0, $gYnSx.default)({
            meta: {
                id: 'getGlobalComponentsProperty',
                packageName: 'jiraCompassCommon',
                teamName: 'compass-lodestone'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true,
            attributes: {
                projectKey: projectKey
            }
        });
        throw error;
    }
};

});


parcelRegister("2aQVf", function(module, exports) {

$parcel$export(module.exports, "getGlobalComponentsProperty", () => $36db035861e09445$export$1db3503600a1638e);
$parcel$export(module.exports, "setGlobalComponentsProperty", () => $36db035861e09445$export$71702a5b14caff65);

var $gYnSx = parcelRequire("gYnSx");

var $jGzN3 = parcelRequire("jGzN3");
const $36db035861e09445$var$GLOBAL_COMPONENTS_PROPERTY_KEY = 'jira.global.components';
// Default projectKey regex, source: https://stash.atlassian.com/projects/JIRACLOUD/repos/jira/browse/jira-components/jira-api/src/main/java/com/atlassian/jira/util/JiraKeyUtils.java#421
const $36db035861e09445$var$PROJECT_KEY_REGEX = /^[A-Z][A-Z]+$/;
const $36db035861e09445$var$url = (projectIdOrKey, entityKey)=>`/rest/api/3/project/${projectIdOrKey}/properties/${entityKey}`;
const $36db035861e09445$var$getProjectId = async (projectKey)=>{
    const project = await (0, $jGzN3.performGetRequest)(`/rest/api/3/project/${projectKey}`);
    return project?.id;
};
const $36db035861e09445$export$1db3503600a1638e = async (projectKey)=>{
    try {
        let endpoint;
        if (!$36db035861e09445$var$PROJECT_KEY_REGEX.test(projectKey)) {
            // We need to fetch the project id here because some users have malformed project keys that are not compatible with the project properties endpoint
            const projectId = await $36db035861e09445$var$getProjectId(projectKey);
            if (!projectId) return {
                key: $36db035861e09445$var$GLOBAL_COMPONENTS_PROPERTY_KEY,
                value: null
            };
            endpoint = $36db035861e09445$var$url(projectId, $36db035861e09445$var$GLOBAL_COMPONENTS_PROPERTY_KEY);
        } else endpoint = $36db035861e09445$var$url(projectKey, $36db035861e09445$var$GLOBAL_COMPONENTS_PROPERTY_KEY);
        return await (0, $jGzN3.performGetRequest)(endpoint);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // The endpoint returns 404 if the project property is not set, but we don't treat it as an
        // actual error
        if (error.statusCode === 404) return {
            key: $36db035861e09445$var$GLOBAL_COMPONENTS_PROPERTY_KEY,
            value: null
        };
        (0, $gYnSx.default)({
            meta: {
                id: 'getGlobalComponentsProperty',
                packageName: 'jiraCompassCommon',
                teamName: 'compass-lodestone'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true,
            attributes: {
                projectKey: projectKey
            }
        });
        throw error;
    }
};
async function $36db035861e09445$export$71702a5b14caff65(projectKey, value) {
    try {
        let endpoint;
        if (!$36db035861e09445$var$PROJECT_KEY_REGEX.test(projectKey)) {
            // We need to fetch the project id here because some users have malformed project keys that are not compatible with the project properties endpoint
            const projectId = await $36db035861e09445$var$getProjectId(projectKey);
            if (!projectId) return;
            endpoint = $36db035861e09445$var$url(projectId, $36db035861e09445$var$GLOBAL_COMPONENTS_PROPERTY_KEY);
        } else endpoint = $36db035861e09445$var$url(projectKey, $36db035861e09445$var$GLOBAL_COMPONENTS_PROPERTY_KEY);
        await (0, $jGzN3.performPutRequest)(endpoint, {
            body: JSON.stringify(value)
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gYnSx.default)({
            meta: {
                id: 'setGlobalComponentsProperty',
                packageName: 'jiraCompassCommon',
                teamName: 'compass-lodestone'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true,
            attributes: {
                projectKey: projectKey
            }
        });
        throw error;
    }
}

});


parcelRegister("f5ikm", function(module, exports) {

$parcel$export(module.exports, "default", () => $c298c31a74e3865a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $kVcjU = parcelRequire("kVcjU");

var $lRq8t = parcelRequire("lRq8t");

var $aUMMA = parcelRequire("aUMMA");

var $avlIo = parcelRequire("avlIo");

var $3H12S = parcelRequire("3H12S");
const $c298c31a74e3865a$var$ComponentsSelectEdit = (props)=>{
    const { value: value, options: options, onChange: onChange, onFocus: onFocus, onBlur: onBlur, placeholder: placeholder = '', autoFocus: autoFocus = false, isInvalid: isInvalid = false, isDisabled: isDisabled = false, showFooter: showFooter = false, onCloseMenuOnScroll: onCloseMenuOnScroll, projectKey: projectKey, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, canCreateNewItem: canCreateNewItem = false, formatNewInlineComponentCreateLabel: formatNewInlineComponentCreateLabel, inputId: inputId, isRequired: isRequired, ...fieldProps } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const getNewInlineComponentCreateLabel = (0, $eJOHy.useCallback)((inputValue)=>`${inputValue} (${formatNewInlineComponentCreateLabel !== undefined ? formatNewInlineComponentCreateLabel : formatMessage((0, $3H12S.default).createNewItem)})`, [
        formatNewInlineComponentCreateLabel,
        formatMessage
    ]);
    const isValidNewOption = (0, $eJOHy.useCallback)((query)=>{
        const fieldInputLabels = options.map((option)=>option.label.toLowerCase());
        return canCreateNewItem && query.trim() !== '' && !fieldInputLabels.includes(query.trim().toLowerCase());
    }, [
        canCreateNewItem,
        options
    ]);
    const handleInlineComponentCreate = (inputValue)=>{
        onChange([
            ...value || [],
            {
                label: inputValue,
                value: null
            }
        ]);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kVcjU.default), {
        inputId: inputId,
        required: isRequired,
        ...fieldProps,
        value: value,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore - TS2322 - Type 'Options' is not assignable to type 'readonly (Options | GroupBase<Options>)[]
        options: options,
        placeholder: placeholder || formatMessage((0, $3H12S.default).placeholder),
        // @ts-expect-error - TS2322 - Type '(arg1: Options) => void' is not assignable to type '(value: OptionsType<{ label: string; value: string; }>, action: ActionMeta<{ label: string; value: string; }>) => void'.
        onChange: onChange,
        onFocus: onFocus,
        onBlur: onBlur,
        autoFocus: autoFocus,
        closeMenuOnScroll: onCloseMenuOnScroll,
        menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
        styles: (0, $aUMMA.defaultSelectStyles),
        // @ts-expect-error - TS2322 - Type '"error" | null' is not assignable to type 'ValidationState | undefined'.
        validationState: isInvalid === true ? 'error' : null,
        components: {
            MenuList: (menuListProps)=>// @ts-expect-error - Type '{ showFooter: boolean; projectKey: string; children: ReactNode; }' is missing the following properties from type 'MenuListProps<unknown, boolean, GroupBase<unknown>>': maxHeight, innerRef, focusedOption, innerProps, and 12 more.
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $avlIo.default), {
                    ...menuListProps,
                    showFooter: showFooter,
                    projectKey: projectKey
                })
        },
        isMulti: true,
        isDisabled: isDisabled,
        isValidNewOption: isValidNewOption,
        formatCreateLabel: getNewInlineComponentCreateLabel,
        onCreateOption: handleInlineComponentCreate,
        testId: "issue-field-components-field.ui.edit.components-field-select" // added this for testing purpose, it doesn't apply any style
        ,
        classNamePrefix: "components-field-select"
    });
};
var $c298c31a74e3865a$export$2e2bcd8739ae039 = $c298c31a74e3865a$var$ComponentsSelectEdit;

});
parcelRegister("avlIo", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ca1bf4a5ac987e7$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $jQjGM = parcelRequire("jQjGM");

var $6XEne = parcelRequire("6XEne");

var $lRq8t = parcelRequire("lRq8t");

var $ahGV0 = parcelRequire("ahGV0");
const $2ca1bf4a5ac987e7$var$menuListStyles = {
    root: "_1q51ze3t _85i5ze3t"
};
const $2ca1bf4a5ac987e7$var$MenuWithFooter = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { children: children, showFooter: showFooter, projectKey: projectKey, footerLabel: footerLabel, ...restProps } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6XEne.components).MenuList, {
        ...restProps,
        xcss: $2ca1bf4a5ac987e7$var$menuListStyles.root
    }, children), showFooter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2ca1bf4a5ac987e7$export$fd9000017733fabf, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2ca1bf4a5ac987e7$export$500fb058ad7aeb1, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2ca1bf4a5ac987e7$export$e0513c91be1318ca, {
        href: `/plugins/servlet/project-config/${projectKey}/administer-components`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jQjGM))), {
        label: "componentFooterAddIcon",
        LEGACY_size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2ca1bf4a5ac987e7$var$LinkText, null, footerLabel ?? formatMessage((0, $ahGV0.default).componentLabel))))));
};
var $2ca1bf4a5ac987e7$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $2ca1bf4a5ac987e7$var$MenuWithFooter;
const $2ca1bf4a5ac987e7$var$LinkText = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_18u0u2gc",
            __cmplp.className
        ])
    });
});
const $2ca1bf4a5ac987e7$export$fd9000017733fabf = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_x3doudwz _1e0c1txw _2lx2vrvc _ca0qu2gc _u5f3idpf _n3tdu2gc _19bvidpf",
            __cmplp.className
        ])
    });
});
const $2ca1bf4a5ac987e7$export$500fb058ad7aeb1 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0q1b66 _u5f3utpp _n3td1b66 _19bvutpp _1bsb1osq _irr3166n",
            __cmplp.className
        ])
    });
});
const $2ca1bf4a5ac987e7$export$e0513c91be1318ca = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _9oik18uv _1bnxglyw _jf4cnqa1",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jQjGM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::739edc58ca910533dbcf168239dfad1b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e7222574ac205219$var$_react = $e7222574ac205219$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $e7222574ac205219$var$_add = $e7222574ac205219$var$_interopRequireDefault((parcelRequire("dcLzM")));

var $e7222574ac205219$var$_add2 = $e7222574ac205219$var$_interopRequireDefault((parcelRequire("lnnie")));
function $e7222574ac205219$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for AddIcon.
 * This component is AddIcon, with `UNSAFE_fallbackIcon` set to "AddIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for creating and adding an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e7222574ac205219$var$AddIcon = (props)=>/*#__PURE__*/ $e7222574ac205219$var$_react.default.createElement($e7222574ac205219$var$_add.default, Object.assign({
        LEGACY_fallbackIcon: $e7222574ac205219$var$_add2.default
    }, props));
$e7222574ac205219$var$AddIcon.Name = 'AddIconMigration';
var $e7222574ac205219$var$_default = module.exports.default = $e7222574ac205219$var$AddIcon;

});
parcelRegister("lnnie", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f8fdd0750f7e22cb$var$_react = $f8fdd0750f7e22cb$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $f8fdd0750f7e22cb$var$_add = $f8fdd0750f7e22cb$var$_interopRequireDefault((parcelRequire("dcLzM")));
function $f8fdd0750f7e22cb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f8fdd0750f7e22cb$var$AddIcon = (props)=>/*#__PURE__*/ $f8fdd0750f7e22cb$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M13 11V3.993A.997.997 0 0 0 12 3c-.556 0-1 .445-1 .993V11H3.993A.997.997 0 0 0 3 12c0 .557.445 1 .993 1H11v7.007c0 .548.448.993 1 .993.556 0 1-.445 1-.993V13h7.007A.997.997 0 0 0 21 12c0-.556-.445-1-.993-1z"/></svg>`
    }, props, {
        newIcon: $f8fdd0750f7e22cb$var$_add.default
    }));
$f8fdd0750f7e22cb$var$AddIcon.displayName = 'AddIcon';
var $f8fdd0750f7e22cb$var$_default = module.exports.default = $f8fdd0750f7e22cb$var$AddIcon;

});


parcelRegister("ahGV0", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ca0c0cd39b263da$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $5ca0c0cd39b263da$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    componentLabel: {
        "id": "issue-field-components-field.edit.menu.component-label",
        "defaultMessage": "Create new component"
    }
});

});


parcelRegister("3H12S", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d6adda6c1a52337$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $8d6adda6c1a52337$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    placeholder: {
        "id": "issue-field-components-field.edit.placeholder",
        "defaultMessage": "Select Component"
    },
    createNewItem: {
        "id": "issue-field-components-field.edit.create-new-item",
        "defaultMessage": "New Component"
    }
});

});


parcelRegister("ecSnb", function(module, exports) {

$parcel$export(module.exports, "mapDataToOptions", () => $dc849dff172ae963$export$99a866ffa3af7d8b);
$parcel$export(module.exports, "mapOptionsToData", () => $dc849dff172ae963$export$ffef3a401aef987b);
const $dc849dff172ae963$export$99a866ffa3af7d8b = (data)=>data.map(({ id: id, name: name })=>({
            label: name,
            value: id
        }));
const $dc849dff172ae963$export$ffef3a401aef987b = (data)=>data.map(({ label: label, value: value })=>({
            id: value,
            name: label
        }));

});

parcelRegister("2eRZu", function(module, exports) {

$parcel$export(module.exports, "default", () => $cfd8b558d2950b0d$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $cfd8b558d2950b0d$var$messages = (0, $7qGN1.defineMessages)({
    none: {
        "id": "issue-create-commons.components-field.none",
        "defaultMessage": "None"
    },
    tooltipWhenDisabled: {
        "id": "issue-create-commons.components-field.tooltip-when-disabled",
        "defaultMessage": "We couldn't find any components for this project"
    }
});
var $cfd8b558d2950b0d$export$2e2bcd8739ae039 = $cfd8b558d2950b0d$var$messages;

});


parcelRegister("4fwkr", function(module, exports) {

$parcel$export(module.exports, "mutateComponentsField", () => $b06a04af9965fe97$export$499415d02c5db090);
const $b06a04af9965fe97$export$499415d02c5db090 = (selectedComponents)=>({
        components: selectedComponents.reduce((acc, { value: value })=>{
            if (value !== null) acc.push({
                componentId: value
            });
            return acc;
        }, [])
    });

});

parcelRegister("c0mzI", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef2a0ac36f46132d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $k71qx = parcelRequire("k71qx");

var $2bMPg = parcelRequire("2bMPg");

var $fE4zR = parcelRequire("fE4zR");

var $2nXHu = parcelRequire("2nXHu");

var $ixdDB = parcelRequire("ixdDB");

var $4yQUm = parcelRequire("4yQUm");

var $kljID = parcelRequire("kljID");

const $ef2a0ac36f46132d$export$c3b8fa1b9560fb7e = (props)=>{
    const { width: width, fieldProps: { value: value, onChange: onChange }, fieldId: fieldId, error: error, autoCompleteUrl: autoCompleteUrl = '/rest/teams/1.0/teams/find', isEditable: isEditable = true, nonEditableReason: nonEditableReason, onCloseMenuOnScroll: // @ts-expect-error - TS2339 - Property 'onCloseMenuOnScroll' does not exist on type 'Props'.
    onCloseMenuOnScroll = (0, $ixdDB.closeMenuOnScroll), isDropdownMenuFixedAndLayered: // @ts-expect-error - TS2339 - Property 'isDropdownMenuFixedAndLayered' does not exist on type 'Props'.
    isDropdownMenuFixedAndLayered = false, ariaLabelledBy: ariaLabelledBy } = props;
    const getTeamEdit = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2bMPg.default), {
            autoCompleteUrl: autoCompleteUrl,
            onChange: onChange,
            value: value,
            fieldId: fieldId,
            isInvalid: Boolean(error),
            isDisabled: !isEditable,
            isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
            onCloseMenuOnScroll: onCloseMenuOnScroll,
            fetchSuggestionsOnFocus: true,
            ariaLabelledBy: ariaLabelledBy
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fE4zR.FieldContainer), {
        width: width
    }, isEditable === false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: nonEditableReason?.message || ''
    }, getTeamEdit()) : getTeamEdit());
};
var $ef2a0ac36f46132d$export$2e2bcd8739ae039 = (0, $2nXHu.withFormField)({
    validator: (0, $4yQUm.validateCustomTeamsField),
    transformDefaultValue: (0, $kljID.transformDefaultTeam)
})($ef2a0ac36f46132d$export$c3b8fa1b9560fb7e);

});
parcelRegister("2bMPg", function(module, exports) {

$parcel$export(module.exports, "default", () => $8052b27405bab3d5$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $gWITR = parcelRequire("gWITR");

var $lRq8t = parcelRequire("lRq8t");

var $aUMMA = parcelRequire("aUMMA");

var $5fIxl = parcelRequire("5fIxl");

var $6BlKA = parcelRequire("6BlKA");

var $5Qe2D = parcelRequire("5Qe2D");

var $lLO2U = parcelRequire("lLO2U");

var $cictW = parcelRequire("cictW");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8052b27405bab3d5$var$MenuList = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5Qe2D.default), props);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8052b27405bab3d5$var$Option = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lLO2U.default), props);
const $8052b27405bab3d5$var$CustomTeamPickerEdit = (props)=>{
    const { fieldId: fieldId, value: value, onChange: onChange, autoCompleteUrl: autoCompleteUrl, isInvalid: isInvalid, autoFocus: autoFocus = false, isDisabled: isDisabled, placeholder: placeholder = '', isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, onCloseMenuOnScroll: onCloseMenuOnScroll, fetchSuggestionsOnFocus: fetchSuggestionsOnFocus = false, classNamePrefix: classNamePrefix, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [defaultOptions, setDefaultOptions] = (0, $eJOHy.useState)([]);
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(false);
    const shouldFetchDefaultOptions = (0, $eJOHy.useRef)(true);
    const handleSearch = (0, $5fIxl.default)(async (query)=>(0, $cictW.fetchTeams)(query || '', autoCompleteUrl), 300);
    const onFocus = async ()=>{
        if (shouldFetchDefaultOptions && defaultOptions && shouldFetchDefaultOptions.current && !defaultOptions.length) {
            shouldFetchDefaultOptions.current = false;
            setIsLoading && setIsLoading(true);
            const options = await handleSearch();
            setDefaultOptions && setDefaultOptions(options);
            setIsLoading && setIsLoading(false);
        }
    };
    const defaultOptionsProps = ()=>{
        if (fetchSuggestionsOnFocus) return {
            onFocus: onFocus,
            isLoading: isLoading,
            defaultOptions: defaultOptions
        };
        return {};
    };
    const noOptionsMessage = (0, $eJOHy.useCallback)(()=>formatMessage((0, $6BlKA.default).noMatches), [
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gWITR.default), {
        fieldId: fieldId,
        ...defaultOptionsProps(),
        loadOptions: handleSearch,
        onChange: onChange,
        autoFocus: autoFocus,
        isClearable: Boolean(value),
        isMulti: false,
        value: value,
        // @ts-expect-error - TS2322 - Type '"error" | null' is not assignable to type 'ValidationState | undefined'.
        validationState: isInvalid === true ? 'error' : null,
        components: {
            MenuList: $8052b27405bab3d5$var$MenuList,
            Option: $8052b27405bab3d5$var$Option
        },
        noOptionsMessage: noOptionsMessage,
        placeholder: placeholder,
        isDisabled: isDisabled,
        // @ts-expect-error - TS2322 - Type '((e: ChangeEvent<HTMLElement>) => boolean) | undefined' is not assignable to type 'boolean | EventListener | undefined'.
        closeMenuOnScroll: onCloseMenuOnScroll,
        menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
        styles: (0, $aUMMA.defaultSelectStyles),
        classNamePrefix: classNamePrefix,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy
    });
};
var $8052b27405bab3d5$export$2e2bcd8739ae039 = $8052b27405bab3d5$var$CustomTeamPickerEdit;

});
parcelRegister("6BlKA", function(module, exports) {

$parcel$export(module.exports, "default", () => $d639af3f1701fb8b$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $d639af3f1701fb8b$var$messages = (0, $7qGN1.defineMessages)({
    menuHeader: {
        "id": "issue-field-custom-team.menu-header",
        "defaultMessage": "Pick a shared team that you\u2019ve created through a Portfolio plan"
    },
    noMatches: {
        "id": "issue-field-custom-team.no-matches",
        "defaultMessage": "No Matches"
    },
    menuFooter: {
        "id": "issue-field-custom-team.menu-footer",
        "defaultMessage": "Showing 100 results. To display more results, please refine your search."
    }
});
var $d639af3f1701fb8b$export$2e2bcd8739ae039 = $d639af3f1701fb8b$var$messages;

});

parcelRegister("5Qe2D", function(module, exports) {

$parcel$export(module.exports, "default", () => $7475d5ac02383889$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $6XEne = parcelRequire("6XEne");

var $lRq8t = parcelRequire("lRq8t");

var $6BlKA = parcelRequire("6BlKA");
const $7475d5ac02383889$var$menuListStyles = {
    root: "_1q51ze3t _85i5ze3t"
};
const $7475d5ac02383889$var$MenuListComponent = (props)=>{
    const { options: options } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const footer = options.length > 0 && options[0].moreResultsAvailable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7475d5ac02383889$var$MenuFooterText, null, formatMessage((0, $6BlKA.default).menuFooter)) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6XEne.components).MenuList, {
        ...props,
        xcss: $7475d5ac02383889$var$menuListStyles.root
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7475d5ac02383889$var$Container, null, formatMessage((0, $6BlKA.default).menuHeader)), props.children, footer);
};
var $7475d5ac02383889$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $7475d5ac02383889$var$MenuListComponent;
const $7475d5ac02383889$var$MenuFooterText = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c82smr _syaz131l _ca0qu2gc _u5f3pxbi _n3tdu2gc _19bvpxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7475d5ac02383889$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0qu2gc _u5f3pxbi _n3tdu2gc _19bvpxbi",
            __cmplp.className
        ])
    });
});

});

parcelRegister("lLO2U", function(module, exports) {

$parcel$export(module.exports, "default", () => $88d011d32c9d4e83$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $6XEne = parcelRequire("6XEne");

var $ik5jk = parcelRequire("ik5jk");
const $88d011d32c9d4e83$var$optionStyles = {
    root: "_1q51ze3t _85i5ze3t _bozgze3t _y4tize3t"
};
const $88d011d32c9d4e83$var$OptionComponent = (props)=>{
    const value = props.data;
    if (value) {
        const { avatarUrl: avatarUrl, label: label } = value;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6XEne.components).Option, {
            ...props,
            xcss: $88d011d32c9d4e83$var$optionStyles.root
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($88d011d32c9d4e83$var$OptionWrapper, null, avatarUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($88d011d32c9d4e83$var$Icon, {
            src: avatarUrl,
            alt: label
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $88d011d32c9d4e83$var$boxStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ik5jk.default), {
            alt: ""
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($88d011d32c9d4e83$var$OptionText, null, props.children)));
    }
    return null;
};
var $88d011d32c9d4e83$export$2e2bcd8739ae039 = $88d011d32c9d4e83$var$OptionComponent;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $88d011d32c9d4e83$var$Icon = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsb7vkz _4t3i7vkz _2hwxu2gc",
            __cmplp.className
        ])
    });
});
const $88d011d32c9d4e83$var$OptionWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _1e0c1txw _2lx2vrvc _4cvr1h6o _1bahv2br _1q51ze3t _y4ti1b66 _85i5ze3t _bozg1b66",
            __cmplp.className
        ])
    });
});
const $88d011d32c9d4e83$var$OptionText = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _1bto1l2s _o5721q9c",
            __cmplp.className
        ])
    });
});
const $88d011d32c9d4e83$var$boxStyle = (0, $1DXK0.xcss)({
    height: '16px',
    width: '16px',
    marginRight: 'space.100'
});

});
parcelRegister("ik5jk", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd1e7fc0967f16d1$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See closest README.md

var $c4huj = parcelRequire("c4huj");

var $13GmR = parcelRequire("13GmR");
const $cd1e7fc0967f16d1$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($13GmR)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($13GmR))
});
var $cd1e7fc0967f16d1$export$2e2bcd8739ae039 = $cd1e7fc0967f16d1$var$Illustration;
// for advanced use only
const $cd1e7fc0967f16d1$export$a179c88182cb9d56 = [
    0,
    0,
    596,
    596
];

});
parcelRegister("13GmR", function(module, exports) {
module.exports = new URL("team.aa9af04e.svg", import.meta.url).toString();

});



parcelRegister("cictW", function(module, exports) {

$parcel$export(module.exports, "transformTeamFieldTypeString", () => $b74f1f0d6400b1c7$export$f7d628c77d5447d0);
$parcel$export(module.exports, "fetchTeams", () => $b74f1f0d6400b1c7$export$a789e725ac68b08d);

var $jGzN3 = parcelRequire("jGzN3");
const $b74f1f0d6400b1c7$export$4accbe1c2fbc55dd = (team)=>({
        label: team.title,
        value: team.id.toString(),
        isShared: team.shareable,
        avatarUrl: team.avatarUrl
    });
const $b74f1f0d6400b1c7$export$f7d628c77d5447d0 = (team)=>{
    if (team) return team.value.toString();
    return null;
};
const $b74f1f0d6400b1c7$export$a789e725ac68b08d = async (query, autoCompleteUrl)=>{
    const response = await (0, $jGzN3.performPostRequest)(autoCompleteUrl, {
        body: JSON.stringify({
            excludedIds: [],
            maxResults: 100,
            query: query
        })
    });
    if (response) {
        const teams = response.teams.map($b74f1f0d6400b1c7$export$4accbe1c2fbc55dd);
        return [
            {
                moreResultsAvailable: response.moreResultsAvailable,
                options: teams
            }
        ];
    }
    return [];
};

});


parcelRegister("kljID", function(module, exports) {

$parcel$export(module.exports, "mutateTeamField", () => $21fff542c4884db2$export$8db32a33b76e5823);
$parcel$export(module.exports, "transformDefaultTeam", () => $21fff542c4884db2$export$d2d64eb763c850a1);

const $21fff542c4884db2$export$8db32a33b76e5823 = (selectedTeam, fieldId)=>selectedTeam ? {
        fieldId: fieldId,
        mutationGroup: (0, $73721c6e6be19494$export$31fd86f8f183952c),
        team: {
            teamId: selectedTeam.value
        }
    } : null;
const $21fff542c4884db2$export$d2d64eb763c850a1 = (team)=>({
        label: team.name,
        value: team.teamId,
        isShared: true
    });

});
const $73721c6e6be19494$export$31fd86f8f183952c = 'teamFields';



parcelRegister("5vmYB", function(module, exports) {

$parcel$export(module.exports, "default", () => $2aea7603e4b2754e$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $cDJ0f = parcelRequire("cDJ0f");

var $2sLVw = parcelRequire("2sLVw");

var $dL9bk = parcelRequire("dL9bk");

var $dPMMf = parcelRequire("dPMMf");

var $4NEt5 = parcelRequire("4NEt5");

var $lRq8t = parcelRequire("lRq8t");

var $7jTnu = parcelRequire("7jTnu");

var $fE4zR = parcelRequire("fE4zR");

var $4frAn = parcelRequire("4frAn");
const $2aea7603e4b2754e$var$DataClassificationField = (props)=>{
    const { width: width, value: value, onChange: onChange, allowedValues: allowedValues, errorMessage: errorMessage, isDisabled: isDisabled, nonEditableReason: nonEditableReason } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const attributes = (0, $eJOHy.useMemo)(()=>({
            isDisabled: isDisabled
        }), [
        isDisabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4NEt5.JiraIssueCreateErrorBoundary), {
        id: "dataClassificationField",
        packageName: "jiraIssueCreateCommons",
        fallback: "unmount",
        sendToPrivacyUnsafeSplunk: true,
        ...(0, $7jTnu.fg)('jira-issue-create-error-boundary-enabled') ? {
            attributes: attributes
        } : {}
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fE4zR.FieldContainer), {
        width: width,
        marginTop: (0, $dPMMf.gridSize) * 2.25,
        paddingBottom: (0, $dPMMf.gridSize) * 2.25
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cDJ0f.Label), {
        htmlFor: "data-classification-dropdown-input",
        id: "data-classification-select"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sLVw.default), {
        justifyContent: "start"
    }, formatMessage((0, $4frAn.default).classificationFieldLabel))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dL9bk.DataClassificationDropdown), {
        options: allowedValues,
        value: value,
        onChange: onChange,
        isDisabled: isDisabled,
        disabledTooltipMessage: nonEditableReason?.message,
        errorMessage: errorMessage
    })));
};
var $2aea7603e4b2754e$export$2e2bcd8739ae039 = $2aea7603e4b2754e$var$DataClassificationField;

});

parcelRegister("fSik2", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b2ef35cf7d87377$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $9Dhvc = parcelRequire("9Dhvc");

var $iUa8i = parcelRequire("iUa8i");

var $lRq8t = parcelRequire("lRq8t");

var $dO9h7 = parcelRequire("dO9h7");

var $2cfd4 = parcelRequire("2cfd4");

var $iw2hI = parcelRequire("iw2hI");

var $fE4zR = parcelRequire("fE4zR");

var $2nXHu = parcelRequire("2nXHu");

var $ibskQ = parcelRequire("ibskQ");

var $4yQUm = parcelRequire("4yQUm");

var $55167 = parcelRequire("55167");

const $1b2ef35cf7d87377$export$845e1054649a85c2 = 0;
const $1b2ef35cf7d87377$var$DateField = (props)=>{
    const { autoFocus: autoFocus = false, width: width, fieldProps: { value: value = '', onChange: onChange, id: id }, error: error, isReadOnly: isReadOnly = false } = props;
    const locale = (0, $2cfd4.useLocale)();
    const standardisedLocale = (0, $iw2hI.standardizeLocale)(locale);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const weekStartDay = (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))((0, $dO9h7.getLocale)(locale), 'options.weekStartsOn', $1b2ef35cf7d87377$export$845e1054649a85c2);
    const safeValue = value === null ? undefined : value;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fE4zR.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iUa8i.default), {
        value: safeValue,
        isDisabled: isReadOnly,
        onChange: onChange,
        autoFocus: autoFocus,
        locale: standardisedLocale,
        isInvalid: Boolean(error),
        selectProps: {
            /**
      	Temporary fix to prevent form submit on enter press on an open calendar.
      	Ideally this should either be handled by atlaskit or keypress enter event should only be supressed when calendar is open.
      	There is no way to know if the calendar is open in the current implementation
      		Side Effect: Form will not submit on enter keyPress even when calendar is not open.
      */ onKeyDown: (0, $ibskQ.preventFormSubmitOnEnterKeyPress)
        },
        weekStartDay: weekStartDay,
        label: formatMessage((0, $55167.default).ariaLabel),
        "aria-describedby": `${id}-helper`,
        id: id,
        placeholder: formatMessage((0, $55167.default).placeholder),
        shouldShowCalendarButton: true,
        inputLabel: formatMessage((0, $55167.default).ariaLabel)
    }));
};
var // @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element' is not assignable to parameter of type 'AbstractComponent<ComponentProps<DateFieldConfig, FieldValue>, any>'.
$1b2ef35cf7d87377$export$2e2bcd8739ae039 = (0, $2nXHu.withFormField)({
    validator: (0, $4yQUm.validateString)
})($1b2ef35cf7d87377$var$DateField);

});
parcelRegister("iUa8i", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8d7b5e7995f81e7$export$2e2bcd8739ae039);

var $eGOwo = parcelRequire("eGOwo");

var $1BRZx = parcelRequire("1BRZx");

var $lLHJE = parcelRequire("lLHJE");

var $k2Uo2 = parcelRequire("k2Uo2");
const $b8d7b5e7995f81e7$var$DatePicker = (0, $1BRZx.componentWithCondition)(()=>(0, $eGOwo.fg)('dst-date-picker-use-functional-component'), (0, $k2Uo2.default), (0, $lLHJE.default));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b8d7b5e7995f81e7$export$2e2bcd8739ae039 = $b8d7b5e7995f81e7$var$DatePicker;

});
parcelRegister("1BRZx", function(module, exports) {

$parcel$export(module.exports, "componentWithCondition", () => $48de19f2c65a8561$export$6e8ea24b15199873);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
function $48de19f2c65a8561$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>condition() ? /*#__PURE__*/ (0, $gt9Am.jsx)(ComponentTrue, {
            ...props,
            ref: ref
        }) : /*#__PURE__*/ (0, $gt9Am.jsx)(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    return ComponentWithCondition;
}

});

parcelRegister("lLHJE", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fe32780a1f5c05c$export$2e2bcd8739ae039);
/* date-picker-class.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $dBLX0 = parcelRequire("dBLX0");
var $kQ82p = parcelRequire("kQ82p");

var $5fWw9 = parcelRequire("5fWw9");
var $dUaMU = parcelRequire("dUaMU");
var $4J0ad = parcelRequire("4J0ad");

var $Ay1uj = parcelRequire("Ay1uj");

var $6qaBj = parcelRequire("6qaBj");

var $gl2vi = parcelRequire("gl2vi");

var $3GKOL = parcelRequire("3GKOL");

var $cK9J2 = parcelRequire("cK9J2");

var $eGOwo = parcelRequire("eGOwo");

var $8IeH1 = parcelRequire("8IeH1");

var $c4OV1 = parcelRequire("c4OV1");
var $e9zKl = parcelRequire("e9zKl");

var $RoXqn = parcelRequire("RoXqn");

var $47or1 = parcelRequire("47or1");

var $hmV0i = parcelRequire("hmV0i");

var $gNwsY = parcelRequire("gNwsY");

var $1u9xN = parcelRequire("1u9xN");

var $7OE9J = parcelRequire("7OE9J");
const $2fe32780a1f5c05c$var$packageName = "platform-pkg";
const $2fe32780a1f5c05c$var$packageVersion = "0.0.0-use.local";
const $2fe32780a1f5c05c$var$datePickerDefaultProps = {
    defaultIsOpen: false,
    defaultValue: '',
    disabled: [],
    disabledDateFilter: (_)=>false,
    locale: 'en-US',
    // These disables are here for proper typing when used as defaults. They
    // should *not* use the `noop` function.
    /* eslint-disable @repo/internal/react/use-noop */ onBlur: (_event)=>{},
    onChange: (_value)=>{},
    onFocus: (_event)=>{} /* eslint-enable @repo/internal/react/use-noop */ 
};
const $2fe32780a1f5c05c$var$styles = {
    pickerContainerStyles: "_kqswh2mm",
    iconContainerStyles: "_v564vrg3 _1e0c1txw _4t3i1osq _kqswstnw _4cvr1h6o _i0dl1kw7 _syaz131l _152tze3t _rjxpze3t _30l31gjq",
    iconSpacingWithClearButtonStyles: "_12l2xy5q",
    iconSpacingWithoutClearButtonStyles: "_12l21b66",
    dropdownIndicatorStyles: "_1ul91k8s _1tke1k8s _1e0c1txw _4cvr1h6o _1bah1h6o"
}; // eslint-disable-next-line @repo/internal/react/no-class-components
class $2fe32780a1f5c05c$export$df43d21f5faca9f7 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = $2fe32780a1f5c05c$var$datePickerDefaultProps;
    }
    constructor(props){
        super(props), this.containerRef = null, this.calendarRef = /*#__PURE__*/ (0, $eJOHy.createRef)(), this.calendarButtonRef = /*#__PURE__*/ (0, $eJOHy.createRef)(), // correctly to allow controlled/uncontrolled usage.
        this.getValue = ()=>this.props.value ?? this.state.value, this.getIsOpen = ()=>this.props.isOpen ?? this.state.isOpen, this.onCalendarChange = ({ iso: iso })=>{
            this.setState({
                calendarValue: (0, $47or1.getParsedISO)({
                    iso: iso
                })
            });
        }, this.onCalendarSelect = ({ iso: iso })=>{
            this.setState({
                selectInputValue: '',
                isOpen: false,
                calendarValue: iso,
                value: iso,
                wasOpenedFromCalendarButton: false
            });
            this.props.onChange(iso); // Yes, this is not ideal. The alternative is to be able to place a ref
            // on the inner input of Select itself, which would require a lot of
            // extra stuff in the Select component for only this one thing. While
            // this would be more "React-y", it doesn't seem to pose any other
            // benefits. Performance-wise, we are only searching within the
            // container, so it's quick.
            if (this.state.wasOpenedFromCalendarButton) this.calendarButtonRef.current?.focus();
            else {
                const innerCombobox = this.containerRef?.querySelector('[role="combobox"]');
                innerCombobox?.focus();
            }
            this.setState({
                isOpen: false
            });
        }, this.onInputClick = ()=>{
            if (!this.props.isDisabled && !this.getIsOpen()) this.setState({
                isOpen: true,
                wasOpenedFromCalendarButton: false
            });
        }, this.onContainerBlur = (event)=>{
            const newlyFocusedElement = event.relatedTarget;
            if (!this.containerRef?.contains(newlyFocusedElement)) {
                this.setState({
                    isOpen: false,
                    shouldSetFocusOnCurrentDay: false,
                    wasOpenedFromCalendarButton: false
                });
                this.props.onBlur(event);
            }
        }, this.onContainerFocus = ()=>{
            this.setState({
                shouldSetFocusOnCurrentDay: false
            });
        }, this.onSelectBlur = (event)=>{
            const newlyFocusedElement = event.relatedTarget;
            if (this.state.clearingFromIcon) // Don't close menu if blurring after the user has clicked clear
            this.setState({
                clearingFromIcon: false
            });
            else if (!this.containerRef?.contains(newlyFocusedElement)) // Don't close menu if focus is staying within the date picker's
            // container. Makes keyboard accessibility of calendar possible
            this.setState({
                isOpen: false,
                isFocused: false,
                wasOpenedFromCalendarButton: false
            });
        }, this.onSelectFocus = (event)=>{
            const { clearingFromIcon: clearingFromIcon } = this.state;
            const value = this.getValue();
            if (clearingFromIcon) // Don't open menu if focussing after the user has clicked clear
            this.setState({
                clearingFromIcon: false
            });
            else this.setState({
                // Don't open when focused into via keyboard if the calendar button is present
                isOpen: !this.props.shouldShowCalendarButton,
                calendarValue: value,
                isFocused: true,
                wasOpenedFromCalendarButton: false
            });
            this.props.onFocus(event);
        }, this.onTextInput = (event)=>{
            const inputValue = event.target.value;
            if (inputValue) {
                const parsed = (0, $47or1.parseDate)(inputValue, {
                    parseInputValue: this.props.parseInputValue,
                    dateFormat: this.props.dateFormat,
                    l10n: this.state.l10n
                }); // Only try to set the date if we have month & day
                if (parsed && (0, $dBLX0.default)(parsed)) // We format the parsed date to YYYY-MM-DD here because
                // this is the format expected by the @atlaskit/calendar component
                this.setState({
                    calendarValue: (0, $1u9xN.getShortISOString)(parsed)
                });
            }
            this.setState({
                isOpen: true,
                wasOpenedFromCalendarButton: false
            });
        }, this.onInputKeyDown = (event)=>{
            const { calendarValue: calendarValue } = this.state;
            const value = this.getValue();
            const keyPressed = event.key.toLowerCase(); // If the input is focused and the calendar is not visible, handle space and enter clicks
            if (!this.state.isOpen && (keyPressed === 'enter' || keyPressed === ' ')) this.setState({
                isOpen: true,
                wasOpenedFromCalendarButton: false
            });
            switch(keyPressed){
                case 'escape':
                    // Yes, this is not ideal. The alternative is to be able to place a ref
                    // on the inner input of Select itself, which would require a lot of
                    // extra stuff in the Select component for only this one thing. While
                    // this would be more "React-y", it doesn't seem to pose any other
                    // benefits. Performance-wise, we are only searching within the
                    // container, so it's quick.
                    if (this.state.wasOpenedFromCalendarButton) this.calendarButtonRef.current?.focus();
                    else {
                        const innerCombobox = this.containerRef?.querySelector('[role="combobox"]');
                        innerCombobox?.focus();
                    }
                    this.setState({
                        isOpen: false,
                        shouldSetFocusOnCurrentDay: false,
                        wasOpenedFromCalendarButton: false
                    });
                    break;
                case 'backspace':
                case 'delete':
                    {
                        const inputCount = 0;
                        if (value && event.target instanceof HTMLInputElement && event.target.value.length <= inputCount) // If being cleared from keyboard, don't change behaviour
                        this.setState({
                            clearingFromIcon: false,
                            value: ''
                        });
                        break;
                    }
                case 'enter':
                    if (!this.state.isOpen) return;
                     // Prevent form submission when a date is selected
                    // using enter. See https://product-fabric.atlassian.net/browse/DSP-2501
                    // for more details.
                    event.preventDefault();
                    if (!(0, $47or1.isDateDisabled)(calendarValue, {
                        disabled: this.props.disabled
                    })) {
                        // Get a safe `calendarValue` in case the value exceeds the maximum
                        // allowed by ISO 8601
                        const safeCalendarValue = (0, $1u9xN.getSafeCalendarValue)(calendarValue);
                        const valueChanged = safeCalendarValue !== value;
                        this.setState({
                            selectInputValue: '',
                            isOpen: false,
                            value: safeCalendarValue,
                            calendarValue: safeCalendarValue,
                            wasOpenedFromCalendarButton: false
                        });
                        if (valueChanged) this.props.onChange(safeCalendarValue);
                    }
                    break;
                case 'arrowdown':
                case 'arrowup':
                    if (!this.state.shouldSetFocusOnCurrentDay) this.setState({
                        isOpen: true,
                        shouldSetFocusOnCurrentDay: true
                    });
                    break;
                default:
                    break;
            }
        }, this.onCalendarButtonKeyDown = (e)=>{
            // Don't allow an arrow up or down to open the menu, since the input key
            // down handler is actually on the parent.
            if (e.type === 'keydown' && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) e.stopPropagation();
             // We want to stop this from triggering other keydown events, particularly
            // for space and enter presses. Otherwise, it opens and then closes
            // immediately.
            if (e.type === 'keydown' && (e.key === ' ' || e.key === 'Enter')) {
                e.stopPropagation();
                this.setState({
                    isKeyDown: true,
                    wasOpenedFromCalendarButton: true
                });
            }
        } // This event handler is triggered from both keydown and click. It's weird.
        , this.onCalendarButtonClick = (e)=>{
            this.setState({
                isOpen: !this.state.isOpen,
                wasOpenedFromCalendarButton: true
            }, ()=>{
                // We don't want the focus to move if this is a click event
                if (!this.state.isKeyDown) return;
                this.setState({
                    isKeyDown: false
                }); // Focus on the first button within the calendar
                this.calendarRef?.current?.querySelector('button')?.focus();
            });
            e.stopPropagation();
        }, this.onClear = ()=>{
            let changedState = {
                value: '',
                calendarValue: this.props.defaultValue || (0, $1u9xN.getShortISOString)(new Date())
            };
            if (!this.props.hideIcon) changedState = {
                ...changedState,
                clearingFromIcon: true
            };
            this.setState(changedState);
            this.props.onChange('');
        } // `unknown` is used because `value` is unused so it does not matter.
        , this.onSelectChange = (_value, action)=>{
            // Used for native clear event in React Select
            // Triggered when clicking ClearIndicator or backspace with no value
            if (action.action === 'clear') this.onClear();
        }, this.handleSelectInputChange = (selectInputValue, actionMeta)=>{
            const onInputChange = this.props.selectProps?.onInputChange;
            if (onInputChange) onInputChange(selectInputValue, actionMeta);
            this.setState({
                selectInputValue: selectInputValue
            });
        }, this.getContainerRef = (ref)=>{
            const oldRef = this.containerRef;
            this.containerRef = ref; // Cause a re-render if we're getting the container ref for the first time
            // as the layered menu requires it for dimension calculation
            if (oldRef == null && ref != null) this.forceUpdate();
        };
        this.state = {
            isKeyDown: false,
            isOpen: this.props.defaultIsOpen,
            isFocused: false,
            clearingFromIcon: false,
            selectInputValue: this.props.selectProps?.inputValue || '',
            value: this.props.value || this.props.defaultValue,
            calendarValue: this.props.value || this.props.defaultValue || (0, $1u9xN.getShortISOString)(new Date()),
            l10n: (0, $cK9J2.createLocalizationProvider)(this.props.locale),
            locale: this.props.locale,
            shouldSetFocusOnCurrentDay: false,
            wasOpenedFromCalendarButton: false
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.locale !== prevState.locale) return {
            l10n: (0, $cK9J2.createLocalizationProvider)(nextProps.locale),
            locale: nextProps.locale
        };
        else return null;
    }
    render() {
        const { appearance: appearance = 'default', 'aria-describedby': ariaDescribedBy, autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'Clear', hideIcon: hideIcon = false, openCalendarLabel: openCalendarLabel = 'Open calendar', disabled: disabled, disabledDateFilter: disabledDateFilter, icon: Icon = (0, (/*@__PURE__*/$parcel$interopDefault($3GKOL))), id: id = '', innerProps: innerProps = {}, inputLabel: inputLabel = 'Date picker', inputLabelId: inputLabelId, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, label: label = '', locale: locale, maxDate: maxDate, minDate: minDate, name: name = '', nextMonthLabel: nextMonthLabel, previousMonthLabel: previousMonthLabel, selectProps: selectProps = {}, shouldShowCalendarButton: shouldShowCalendarButton, spacing: spacing = 'default', testId: testId, weekStartDay: weekStartDay } = this.props;
        const { calendarValue: calendarValue, selectInputValue: selectInputValue } = this.state;
        const value = this.getValue();
        let actualSelectInputValue;
        actualSelectInputValue = selectInputValue;
        const menuIsOpen = this.getIsOpen() && !isDisabled;
        const showClearIndicator = Boolean((value || selectInputValue) && !hideIcon);
        let clearIndicator = Icon; // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $eGOwo.fg)('platform-visual-refresh-icons')) clearIndicator = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                xcss: $2fe32780a1f5c05c$var$styles.dropdownIndicatorStyles,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)(Icon, {
                    ...props
                })
            });
        const dropDownIcon = appearance === 'subtle' || hideIcon || showClearIndicator ? null : clearIndicator;
        const SingleValue = (0, $7OE9J.makeSingleValue)({
            lang: this.props.locale
        });
        const selectComponents = {
            DropdownIndicator: shouldShowCalendarButton ? (0, $RoXqn.EmptyComponent) : dropDownIcon,
            // Only use this new container component if the calendar button is shown.
            // Otherwise, it throws errors downstream for some reason
            ...shouldShowCalendarButton ? {
                IndicatorsContainer: (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $hmV0i.IndicatorsContainer), {
                        ...props,
                        showClearIndicator: showClearIndicator
                    })
            } : {},
            Menu: $gNwsY.Menu,
            SingleValue: SingleValue,
            ...!showClearIndicator && {
                ClearIndicator: (0, $RoXqn.EmptyComponent)
            },
            ...selectProps.components
        };
        const { styles: selectStyles = {} } = selectProps;
        const disabledStyle = isDisabled ? {
            pointerEvents: 'none',
            color: "var(--ds-icon-disabled, inherit)"
        } : {};
        const calendarProps = {
            calendarContainerRef: this.containerRef,
            calendarDisabled: disabled,
            calendarDisabledDateFilter: disabledDateFilter,
            calendarMaxDate: maxDate,
            calendarMinDate: minDate,
            calendarRef: this.calendarRef,
            calendarValue: value && (0, $1u9xN.getShortISOString)((0, $kQ82p.default)(value)),
            calendarView: calendarValue,
            onCalendarChange: this.onCalendarChange,
            onCalendarSelect: this.onCalendarSelect,
            calendarLocale: locale,
            calendarWeekStartDay: weekStartDay,
            shouldSetFocusOnCurrentDay: this.state.shouldSetFocusOnCurrentDay,
            menuInnerWrapper: this.props.menuInnerWrapper
        }; // @ts-ignore -- Argument of type 'StylesConfig<OptionType, false, GroupBase<OptionType>>' is not assignable to parameter of type 'StylesConfig<OptionType, boolean, GroupBase<OptionType>>'.
        const mergedStyles = (0, $e9zKl.mergeStyles)(selectStyles, {
            control: (base)=>({
                    ...base,
                    ...disabledStyle
                }),
            indicatorsContainer: (base)=>({
                    ...base,
                    paddingLeft: "var(--ds-space-025, 2px)",
                    // ICON_PADDING = 2
                    paddingRight: "var(--ds-space-075, 6px)" // 8 - ICON_PADDING = 6
                })
        });
        const initialValue = value ? {
            label: (0, $47or1.formatDate)(value, {
                formatDisplayLabel: this.props.formatDisplayLabel,
                dateFormat: this.props.dateFormat,
                l10n: this.state.l10n
            }),
            value: value
        } : null; // `label` takes precedence of the `inputLabel`
        const fullopenCalendarLabel = label || inputLabel ? `${label || inputLabel}, ${openCalendarLabel}` : openCalendarLabel;
        return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
            ...innerProps,
            role: "presentation",
            onBlur: this.onContainerBlur,
            onFocus: this.onContainerFocus,
            onClick: this.onInputClick,
            onInput: this.onTextInput,
            onKeyDown: this.onInputKeyDown,
            ref: this.getContainerRef,
            "data-testid": testId && `${testId}--container`,
            className: (0, $hcewu.default)([
                $2fe32780a1f5c05c$var$styles.pickerContainerStyles
            ]),
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)("input", {
                    name: name,
                    type: "hidden",
                    value: value,
                    "data-testid": testId && `${testId}--input`
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $c4OV1.default), {
                    appearance: this.props.appearance,
                    "aria-describedby": ariaDescribedBy,
                    label: label || undefined,
                    autoFocus: autoFocus,
                    clearControlLabel: clearControlLabel,
                    closeMenuOnSelect: true,
                    enableAnimation: false,
                    inputId: id,
                    inputValue: actualSelectInputValue,
                    isDisabled: isDisabled,
                    isRequired: isRequired,
                    menuIsOpen: menuIsOpen,
                    onBlur: this.onSelectBlur,
                    onChange: this.onSelectChange,
                    onFocus: this.onSelectFocus,
                    onInputChange: this.handleSelectInputChange,
                    placeholder: (0, $47or1.getPlaceholder)({
                        placeholder: this.props.placeholder,
                        l10n: this.state.l10n
                    }),
                    styles: mergedStyles,
                    value: initialValue,
                    ...selectProps,
                    // up when you alter some of the properties in the `selectComponents`
                    // object. These errors are still present, and I suspect have always
                    // been present, without changing the unrelated code. Ignoring as the
                    // component still works as expected despite this error. And also
                    // because the select refresh team may solve it later.
                    components: selectComponents,
                    // selectProps or not and what wil be overwritten
                    isClearable: true,
                    isInvalid: isInvalid,
                    spacing: spacing,
                    testId: testId,
                    // @ts-ignore --  Property 'calendarContainerRef' does not exist on type 'IntrinsicAttributes & LibraryManagedAttributes<(<Option extends unknown = OptionType, IsMulti extends boolean = false>(props: AtlaskitSelectProps<Option, IsMulti> & { ...; }) => Element), AtlaskitSelectProps<...> & { ...; }>'.
                    calendarContainerRef: calendarProps.calendarContainerRef,
                    calendarDisabled: calendarProps.calendarDisabled,
                    calendarDisabledDateFilter: calendarProps.calendarDisabledDateFilter,
                    calendarLocale: calendarProps.calendarLocale,
                    calendarMaxDate: calendarProps.calendarMaxDate,
                    calendarMinDate: calendarProps.calendarMinDate,
                    calendarRef: calendarProps.calendarRef,
                    calendarValue: calendarProps.calendarValue,
                    calendarView: calendarProps.calendarView,
                    calendarWeekStartDay: calendarProps.calendarWeekStartDay,
                    nextMonthLabel: nextMonthLabel,
                    onCalendarChange: calendarProps.onCalendarChange,
                    onCalendarSelect: calendarProps.onCalendarSelect,
                    previousMonthLabel: previousMonthLabel,
                    shouldSetFocusOnCurrentDay: calendarProps.shouldSetFocusOnCurrentDay,
                    menuInnerWrapper: calendarProps.menuInnerWrapper
                }),
                shouldShowCalendarButton && !isDisabled ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gl2vi.IdProvider), {
                    prefix: "open-calendar-label--",
                    children: ({ id: openCalendarLabelId })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                            xcss: (0, $6qaBj.cx)($2fe32780a1f5c05c$var$styles.iconContainerStyles, value && !hideIcon ? $2fe32780a1f5c05c$var$styles.iconSpacingWithClearButtonStyles : $2fe32780a1f5c05c$var$styles.iconSpacingWithoutClearButtonStyles),
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                                appearance: "subtle",
                                label: !inputLabelId ? fullopenCalendarLabel : openCalendarLabel,
                                "aria-labelledby": inputLabelId ? `${inputLabelId} ${openCalendarLabelId}` : undefined,
                                id: openCalendarLabelId,
                                icon: (iconProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3GKOL))), {
                                        ...iconProps,
                                        color: "var(--ds-icon, #44546F)"
                                    }),
                                onClick: this.onCalendarButtonClick,
                                onKeyDown: this.onCalendarButtonKeyDown,
                                ref: this.calendarButtonRef,
                                testId: testId && `${testId}--open-calendar-button`
                            })
                        })
                }) : null
            ]
        });
    }
}
const $2fe32780a1f5c05c$var$DatePicker = (0, $dUaMU.default)({
    componentName: 'datePicker',
    packageName: $2fe32780a1f5c05c$var$packageName,
    packageVersion: $2fe32780a1f5c05c$var$packageVersion
})((0, $4J0ad.default)({
    onChange: (0, $5fWw9.default)('atlaskit')({
        action: 'selectedDate',
        actionSubject: 'datePicker',
        attributes: {
            componentName: 'datePicker',
            packageName: $2fe32780a1f5c05c$var$packageName,
            packageVersion: $2fe32780a1f5c05c$var$packageVersion
        }
    })
})($2fe32780a1f5c05c$export$df43d21f5faca9f7));
var $2fe32780a1f5c05c$export$2e2bcd8739ae039 = $2fe32780a1f5c05c$var$DatePicker;

});
parcelRegister("3GKOL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9571ec76557171a7f54748c218c48225>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2af99c62070f9b2c$var$_react = $2af99c62070f9b2c$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $2af99c62070f9b2c$var$_calendar = $2af99c62070f9b2c$var$_interopRequireDefault((parcelRequire("btkTq")));

var $2af99c62070f9b2c$var$_calendar2 = $2af99c62070f9b2c$var$_interopRequireDefault((parcelRequire("76JV8")));
function $2af99c62070f9b2c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CalendarIcon.
 * This component is CalendarIcon, with `UNSAFE_fallbackIcon` set to "CalendarIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2af99c62070f9b2c$var$CalendarIcon = (props)=>/*#__PURE__*/ $2af99c62070f9b2c$var$_react.default.createElement($2af99c62070f9b2c$var$_calendar.default, Object.assign({
        LEGACY_fallbackIcon: $2af99c62070f9b2c$var$_calendar2.default
    }, props));
$2af99c62070f9b2c$var$CalendarIcon.Name = 'CalendarIconMigration';
var $2af99c62070f9b2c$var$_default = module.exports.default = $2af99c62070f9b2c$var$CalendarIcon;

});
parcelRegister("btkTq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::43a4f9fcd22489798c1322bda48936cf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $85a29c08b1b7d658$var$_react = $85a29c08b1b7d658$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $85a29c08b1b7d658$var$_baseNew = $85a29c08b1b7d658$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $85a29c08b1b7d658$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Calendar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $85a29c08b1b7d658$var$CalendarIcon = (props)=>/*#__PURE__*/ $85a29c08b1b7d658$var$_react.default.createElement($85a29c08b1b7d658$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.5 2.5v2H6v-2h4v2h1.5v-2H13a.5.5 0 0 1 .5.5v3h-11V3a.5.5 0 0 1 .5-.5zm-2 5V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V7.5zm9-6.5H13a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1.5V0H6v1h4V0h1.5z" clip-rule="evenodd"/>`
    }, props));
$85a29c08b1b7d658$var$CalendarIcon.displayName = 'CalendarIcon';
var $85a29c08b1b7d658$var$_default = module.exports.default = $85a29c08b1b7d658$var$CalendarIcon;

});

parcelRegister("76JV8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $52ccb6d3a2735d8d$var$_react = $52ccb6d3a2735d8d$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $52ccb6d3a2735d8d$var$_calendar = $52ccb6d3a2735d8d$var$_interopRequireDefault((parcelRequire("btkTq")));
function $52ccb6d3a2735d8d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $52ccb6d3a2735d8d$var$CalendarIcon = (props)=>/*#__PURE__*/ $52ccb6d3a2735d8d$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.995 5h14.01C20.107 5 21 5.895 21 6.994v12.012A1.994 1.994 0 0 1 19.005 21H4.995A1.995 1.995 0 0 1 3 19.006V6.994C3 5.893 3.892 5 4.995 5M5 9v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9zm1-5a1 1 0 0 1 2 0v1H6zm10 0a1 1 0 0 1 2 0v1h-2zm-9 9v-2.001h2V13zm8 0v-2.001h2V13zm-4 0v-2.001h2.001V13zm-4 4v-2h2v2zm4 0v-2h2.001v2zm4 0v-2h2v2z"/></svg>`
    }, props, {
        newIcon: $52ccb6d3a2735d8d$var$_calendar.default
    }));
$52ccb6d3a2735d8d$var$CalendarIcon.displayName = 'CalendarIcon';
var $52ccb6d3a2735d8d$var$_default = module.exports.default = $52ccb6d3a2735d8d$var$CalendarIcon;

});


parcelRegister("cK9J2", function(module, exports) {

$parcel$export(module.exports, "createLocalizationProvider", () => $2150f4a906bcb332$export$ea56ca58f08ffa52);

var $4ZGCx = parcelRequire("4ZGCx");

var $ktSIT = parcelRequire("ktSIT");

var $92aEh = parcelRequire("92aEh");
const $2150f4a906bcb332$export$ea56ca58f08ffa52 = (locale, formatterOptions)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $4ZGCx.normalizeLocale)(locale);
    const formatDate = (date)=>Intl.DateTimeFormat(normalizedLocale).format(date);
    const formatTime = (date)=>Intl.DateTimeFormat(normalizedLocale, {
            hour: 'numeric',
            minute: 'numeric'
        }).format(date);
    const getDays = (weekStartDay = 0, length)=>{
        const dayFormatter = Intl.DateTimeFormat(normalizedLocale, {
            weekday: length
        });
        // Right now there is no way to find out first day of the week based on Intl (locale)
        // api. Check issue here: https://github.com/tc39/ecma402/issues/6
        // So we rotate the weekdays based on #weekStartDay parameter.
        const weekdays = [
            0,
            1,
            2,
            3,
            4,
            5,
            6
        ];
        const rotatedWeekdays = weekStartDay > 0 ? [
            ...weekdays.slice(weekStartDay),
            ...weekdays.slice(0, weekStartDay)
        ] : weekdays;
        return rotatedWeekdays.map((day)=>{
            // Some short days are longer than 3 characters but are unique if the first
            // three non-white characters are used.
            const result = dayFormatter// Date range chosen which has a Sun-Sat range so we can extract the names
            .format(new Date(2000, 9, day + 1, 12))// \u200E matches on the Left-to-Right Mark character in IE/Edge
            .replace(/[\s\u200E]/g, '');
            // If short days, only return first three characters. Else return whole thing
            if (length === 'short') return result.substring(0, 3);
            else return result;
        });
    };
    const getDaysShort = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'short');
    };
    const getDaysLong = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'long');
    };
    const getMonthsLong = ()=>{
        const monthFormatter = Intl.DateTimeFormat(normalizedLocale, {
            month: 'long'
        });
        return [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ].map((month)=>// Date chosen for no real reason, the only important part is the month
            // Using 2020 'cos Safari has a faulty implementation when we use the year 2000
            // Intl.DateTimeFormat("en-US", { month: 'long'}).format(new Date(2000, 3, 1))
            // should give "April" but gives "March" in Safari
            monthFormatter.format(new Date(2020, month, 1)));
    };
    const parseDate = (date, options = {})=>(0, $ktSIT.createDateParser)(normalizedLocale)(date, options);
    const formatToParts = (date = new Date())=>{
        const formatter = new Intl.DateTimeFormat(normalizedLocale, formatterOptions);
        /**
		 * Safari has a bug that returns the wrong month for years 2005 and before.
		 * The error occurs when the passed date has been created with numbers, like new Date(2000, 3, 1)
		 * Not all the months fail in each year. To ensure the correct output,
		 * we select 2020 as the base year for the whole date,
		 * then we replace in the result the original input year
		 */ const fixedDate = new Date(date);
        fixedDate.setFullYear(2020);
        const fixedParts = (0, $92aEh.toFormattedParts)(formatter.formatToParts(fixedDate));
        const originalParts = (0, $92aEh.toFormattedParts)(formatter.formatToParts(date));
        if (fixedParts.year) fixedParts.year = originalParts.year;
        /**
		 * Chrome has a bug that returns hour="00" when it's 12:00pm in certain languages
		 * We fix it by detecting the real time with getHours method
		 */ if (fixedParts.hour === '00' && fixedDate.getHours() === 12) fixedParts.hour = '12';
        return fixedParts;
    };
    return {
        getDaysShort: getDaysShort,
        getDaysLong: getDaysLong,
        getMonthsLong: getMonthsLong,
        formatDate: formatDate,
        formatTime: formatTime,
        parseDate: parseDate,
        formatToParts: formatToParts
    };
};

});
parcelRegister("4ZGCx", function(module, exports) {

$parcel$export(module.exports, "normalizeLocale", () => $caa7b379de4e9e4d$export$dca0327c9b9c6498);
const $caa7b379de4e9e4d$export$dca0327c9b9c6498 = (locale)=>locale.replace(/_/g, '-');

});

parcelRegister("ktSIT", function(module, exports) {

$parcel$export(module.exports, "createDateParser", () => $f0407708fddca50b$export$cfa2ef2687faeda2);

var $4ZGCx = parcelRequire("4ZGCx");

var $61I7t = parcelRequire("61I7t");
const $f0407708fddca50b$var$INVALID_DATE = new Date(NaN);
const $f0407708fddca50b$var$INVARIANT = {
    year: 1993,
    month: 2,
    day: 18
};
const $f0407708fddca50b$var$INVARIANT_DATE = (0, $61I7t.toDate)($f0407708fddca50b$var$INVARIANT);
const $f0407708fddca50b$var$FORMAT_EXTRACTOR_REGEX = /(\d+)[^\d]+(\d+)[^\d]+(\d+)\.?/;
const $f0407708fddca50b$var$DATE_PARSER_REGEX = /(\d+)[^\d]*(\d+)?[^\d]*(\d+)?\.?/;
// Internet Explorer returns non-printing characters when formatting a date
const $f0407708fddca50b$var$stripExtras = (str)=>str.replace(/\u200E/g, '');
const $f0407708fddca50b$var$extractDateParts = (matchResult)=>{
    return matchResult// Get the 3 capture groups
    .splice(1, 4)// Convert them to numbers
    .map((datePart)=>parseInt(datePart, 10));
};
const $f0407708fddca50b$export$cfa2ef2687faeda2 = (locale)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $4ZGCx.normalizeLocale)(locale);
    const dateFormatter = Intl.DateTimeFormat(normalizedLocale);
    // Generate a date string from a hard coded date, this allows us to determine
    // the year/month/day position for the provided locale.
    const rawDateString = dateFormatter.format($f0407708fddca50b$var$INVARIANT_DATE);
    const shortDate = $f0407708fddca50b$var$stripExtras(rawDateString);
    // Extract the date pieces from the locale formatted date string
    const formatMatch = shortDate.match($f0407708fddca50b$var$FORMAT_EXTRACTOR_REGEX);
    if (!formatMatch) throw new Error('Unable to create DateParser');
    const formatParts = $f0407708fddca50b$var$extractDateParts(formatMatch);
    // Find the year/month/day positions of the locale formatted invariant date
    const yearPosition = formatParts.indexOf($f0407708fddca50b$var$INVARIANT.year);
    const monthPosition = formatParts.indexOf($f0407708fddca50b$var$INVARIANT.month);
    const dayPosition = formatParts.indexOf($f0407708fddca50b$var$INVARIANT.day);
    return (date, options = {})=>{
        const dateMatch = $f0407708fddca50b$var$stripExtras(date).match($f0407708fddca50b$var$DATE_PARSER_REGEX);
        if (!dateMatch) return $f0407708fddca50b$var$INVALID_DATE;
        const dateParts = $f0407708fddca50b$var$extractDateParts(dateMatch);
        // Use the previously extracted year/month/day positions to extract each
        // date piece.
        const extractedDate = {
            year: dateParts[yearPosition],
            month: dateParts[monthPosition],
            day: dateParts[dayPosition]
        };
        const normalizedDate = (0, $61I7t.normalizeDate)(extractedDate, options?.defaultFirstDay);
        if (!(0, $61I7t.isValid)(normalizedDate)) return $f0407708fddca50b$var$INVALID_DATE;
        return (0, $61I7t.toDate)(normalizedDate);
    };
};

});
parcelRegister("61I7t", function(module, exports) {

$parcel$export(module.exports, "toDate", () => $862914b96a01ecbb$export$e67a095c620b86fe);
$parcel$export(module.exports, "isValid", () => $862914b96a01ecbb$export$1ea939691cdc45b8);
$parcel$export(module.exports, "normalizeDate", () => $862914b96a01ecbb$export$fcc71269590ba0a8);
/**
 * A numerical representation of a date:
 *  - year: any positive integer
 *  - month: 1 - 12 (Jan - Dec)
 *  - day: 1 - [28, 29, 30, 31] (depending on month)
 */ const $862914b96a01ecbb$export$abe96da78d4f59dd = (date)=>({
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
    });
const $862914b96a01ecbb$export$e67a095c620b86fe = (date)=>// The 'proper' month is stored in a DateObj but Date expects month index
    new Date(date.year, date.month - 1, date.day);
const $862914b96a01ecbb$export$553d7fa8e3805fc0 = (year)=>{
    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
};
const $862914b96a01ecbb$export$f645ddd439eb259d = (year, month)=>{
    // February depends on leap year
    if (month === 2 && $862914b96a01ecbb$export$553d7fa8e3805fc0(year)) return 29;
    return [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][month - 1];
};
const $862914b96a01ecbb$export$1ea939691cdc45b8 = (date)=>{
    const { year: year, month: month, day: day } = date;
    const daysInMonth = $862914b96a01ecbb$export$f645ddd439eb259d(year, month);
    return 1 <= month && month <= 12 && 1 <= day && day <= daysInMonth;
};
const $862914b96a01ecbb$export$fcc71269590ba0a8 = (date, defaultFirstDay = false)=>{
    const now = $862914b96a01ecbb$export$abe96da78d4f59dd(new Date());
    const { year: year, month: month, day: day } = date;
    // 19 should evaluate to 2019
    const fullYear = year < 100 ? 2000 + year : year;
    // Missing date pieces are filled in with their current date values
    const normalizedYear = !isNaN(fullYear) ? fullYear : now.year;
    const normalizedMonth = !isNaN(month) && month !== 0 ? month : now.month;
    const normalizedDay = !isNaN(day) && day !== 0 ? day : month !== 0 && defaultFirstDay ? 1 : now.day;
    return {
        year: normalizedYear,
        month: normalizedMonth,
        day: normalizedDay
    };
};

});


parcelRegister("92aEh", function(module, exports) {

$parcel$export(module.exports, "toFormattedParts", () => $0bfc942d7a009811$export$9b7ca29af37c192);
const $0bfc942d7a009811$export$9b7ca29af37c192 = (rawParts)=>rawParts.reduce((result, datePart)=>({
            ...result,
            [datePart.type]: datePart.value
        }), {});

});


parcelRegister("RoXqn", function(module, exports) {

$parcel$export(module.exports, "EmptyComponent", () => $f314d4d8e1112a31$export$5e30e9a24d6c1203);
$parcel$export(module.exports, "placeholderDatetime", () => $f314d4d8e1112a31$export$fff8babee5abe3e2);
$parcel$export(module.exports, "defaultTimes", () => $f314d4d8e1112a31$export$b42ffb9f09b1861b);
$parcel$export(module.exports, "defaultTimeFormat", () => $f314d4d8e1112a31$export$9e6d8fcf62256b85);
$parcel$export(module.exports, "defaultDateFormat", () => $f314d4d8e1112a31$export$75032c84f56650eb);
$parcel$export(module.exports, "padToTwo", () => $f314d4d8e1112a31$export$a7de57e5b672ccdb);
$parcel$export(module.exports, "formatDateTimeZoneIntoIso", () => $f314d4d8e1112a31$export$2eeb05a2ecc2ce0a);
/**
 * This component is used to hide portions of Select component.
 */ const $f314d4d8e1112a31$export$5e30e9a24d6c1203 = ()=>null;
const $f314d4d8e1112a31$export$fff8babee5abe3e2 = new Date(1993, 1, 18, 13);
const $f314d4d8e1112a31$export$b42ffb9f09b1861b = [
    '09:00',
    '09:30',
    '10:00',
    '10:30',
    '11:00',
    '11:30',
    '12:00',
    '12:30',
    '13:00',
    '13:30',
    '14:00',
    '14:30',
    '15:00',
    '15:30',
    '16:00',
    '16:30',
    '17:00',
    '17:30',
    '18:00'
];
const $f314d4d8e1112a31$export$9e6d8fcf62256b85 = 'h:mma';
const $f314d4d8e1112a31$export$75032c84f56650eb = 'YYYY/MM/DD';
function $f314d4d8e1112a31$export$a7de57e5b672ccdb(number) {
    return number <= 99 ? `0${number}`.slice(-2) : `${number}`;
}
function $f314d4d8e1112a31$export$2eeb05a2ecc2ce0a(date, time, zone) {
    // 12:00 => 12:00, 1:00 => 01:00
    const needsLeadingZero = /^\d:/;
    const sanitizedTime = needsLeadingZero.test(time) ? `0${time}` : time;
    return `${date}T${sanitizedTime}${zone}`;
}

});

parcelRegister("47or1", function(module, exports) {

$parcel$export(module.exports, "isDateDisabled", () => $0a9aca5af48d76f0$export$d38e7e283938128c);
$parcel$export(module.exports, "getParsedISO", () => $0a9aca5af48d76f0$export$38db26406d1a1ee2);
$parcel$export(module.exports, "parseDate", () => $0a9aca5af48d76f0$export$6b862160d295c8e);
$parcel$export(module.exports, "formatDate", () => $0a9aca5af48d76f0$export$3ae94a2503e890a1);
$parcel$export(module.exports, "getPlaceholder", () => $0a9aca5af48d76f0$export$d3f5c5e0a5023fa0);
/**
 * Everything in this file is to smooth out the migration of the new date picker
 * (https://product-fabric.atlassian.net/browse/DSP-20682). When that ticket is
 * complete, all of these functions will ilkely be merged back into the date
 * picker. Please do not pre-optimize and put these back into the date picker
 * unless you are working on the DTP Refresh and you have a good reason to do
 * so, thank you!
 *
 * All variables within the `di` objects are dependency injections. They should
 * be read from within the component at the end of the day. But because we are
 * extracting them, we have to inject them in every place manually. When we
 * re-introduce them to the components, we can likely remove the `di` variables
 * and instead use internal variables.
 *
 * If component _only_ has injected variables, it is fully internal and was
 * broken out to be it's own function.
 */ 
var $57raR = parcelRequire("57raR");
var $cBFyu = parcelRequire("cBFyu");
var $kQ82p = parcelRequire("kQ82p");

var $5PwWU = parcelRequire("5PwWU");

var $RoXqn = parcelRequire("RoXqn");
const $0a9aca5af48d76f0$export$d38e7e283938128c = (date, di)=>{
    const { disabled: disabled } = di;
    return disabled.indexOf(date) > -1;
};
const $0a9aca5af48d76f0$export$38db26406d1a1ee2 = (di)=>{
    const { iso: iso } = di;
    const [year, month, date] = iso.split('-');
    let newIso = iso;
    const parsedDate = parseInt(date, 10);
    const parsedMonth = parseInt(month, 10);
    const parsedYear = parseInt(year, 10);
    const lastDayInMonth = (0, $cBFyu.default)(new Date(parsedYear, parsedMonth - 1)).getDate();
    if (lastDayInMonth < parsedDate) newIso = `${parsedYear}-${(0, $RoXqn.padToTwo)(parsedMonth)}-${(0, $RoXqn.padToTwo)(lastDayInMonth)}`;
    else newIso = `${parsedYear}-${(0, $RoXqn.padToTwo)(parsedMonth)}-${(0, $RoXqn.padToTwo)(parsedDate)}`;
    return newIso;
};
const $0a9aca5af48d76f0$export$6b862160d295c8e = (date, di)=>{
    const { parseInputValue: parseInputValue, dateFormat: dateFormat, l10n: l10n } = di;
    if (parseInputValue) return parseInputValue(date, dateFormat || (0, $RoXqn.defaultDateFormat));
    return l10n.parseDate(date);
};
const $0a9aca5af48d76f0$export$3ae94a2503e890a1 = (value, di)=>{
    const { formatDisplayLabel: formatDisplayLabel, dateFormat: dateFormat, l10n: l10n } = di;
    if (formatDisplayLabel) return formatDisplayLabel(value, dateFormat || (0, $RoXqn.defaultDateFormat));
    const date = (0, $kQ82p.default)(value);
    return dateFormat ? (0, $57raR.default)(date, (0, $5PwWU.convertTokens)(dateFormat)) : l10n.formatDate(date);
};
const $0a9aca5af48d76f0$export$d3f5c5e0a5023fa0 = (di)=>{
    const { placeholder: placeholder, l10n: l10n } = di;
    return placeholder || l10n.formatDate((0, $RoXqn.placeholderDatetime));
};

});
parcelRegister("5PwWU", function(module, exports) {

$parcel$export(module.exports, "convertTokens", () => $0e0ecc26a93a278c$export$4d5430175be73d45);
// https://github.com/date-fns/date-fns-upgrade/blob/master/src/v2/convertTokens/index.ts
const $0e0ecc26a93a278c$var$tokensMap = {
    // 'D MMMM': '',
    // 'Do MMMM': '',
    // 'DD MMMM': '',
    M: 'L',
    Mo: 'Mo',
    MM: 'LL',
    MMM: 'LLL',
    MMMM: 'LLLL',
    Q: 'q',
    Qo: 'qo',
    D: 'd',
    Do: 'do',
    DD: 'dd',
    DDD: 'D',
    DDDo: 'Do',
    DDDD: 'DDD',
    d: 'i',
    do: 'io',
    dd: 'iiiiii',
    ddd: 'iii',
    dddd: 'iiii',
    A: 'a',
    a: 'a',
    aa: 'aaaa',
    E: 'i',
    W: 'I',
    Wo: 'Io',
    WW: 'II',
    YY: 'yy',
    YYYY: 'yyyy',
    GG: 'RR',
    GGGG: 'RRRR',
    H: 'H',
    HH: 'HH',
    h: 'h',
    hh: 'hh',
    m: 'm',
    mm: 'mm',
    s: 's',
    ss: 'ss',
    S: 'S',
    SS: 'SS',
    SSS: 'SSS',
    Z: 'xxx',
    ZZ: 'xx',
    X: 't',
    x: 'T'
};
const $0e0ecc26a93a278c$var$v1tokens = Object.keys($0e0ecc26a93a278c$var$tokensMap).sort().reverse();
const $0e0ecc26a93a278c$var$tokensRegExp = new RegExp(// v1 escape string (unsure the purpose of post-pipe capture group)
"(\\[[^\\[]*\\])|(\\\\)?('.+'|" + // All v1 tokens
$0e0ecc26a93a278c$var$v1tokens.join('|') + '|.)', 'g');
function $0e0ecc26a93a278c$export$4d5430175be73d45(format) {
    const tokensCaptures = format.match($0e0ecc26a93a278c$var$tokensRegExp);
    if (!tokensCaptures) return format;
    return tokensCaptures.reduce((parsed, tokenString, index)=>{
        const v2token = $0e0ecc26a93a278c$var$tokensMap[tokenString];
        if (!v2token) {
            const escapedCaptures = tokenString.match(/^\[(.+)\]$/);
            if (escapedCaptures) parsed.escapedTextBuffer.push(escapedCaptures[1]);
            else parsed.escapedTextBuffer.push(tokenString);
        }
        const endOfString = index === tokensCaptures.length - 1;
        if (parsed.escapedTextBuffer.length && (v2token || endOfString)) {
            // This allows double parentheses to be rendered correctly
            // according to date-fns's spec.
            // https://date-fns.org/v2.29.3/docs/format
            //
            // We have to keep the single quote and then remove it because
            // browser support for lookahead/behind is low and causes breaking
            // errors (HOT-104152)
            const filteredEscapedTextBuffer = parsed.escapedTextBuffer.map((token)=>token[0] === "'" && token.slice(-1) === "'" ? token.slice(1, -1) : token).filter((token)=>token !== "'").join('');
            parsed.formatBuffer.push(`'${filteredEscapedTextBuffer}'`);
            parsed.escapedTextBuffer = [];
        }
        if (v2token) parsed.formatBuffer.push(v2token);
        return parsed;
    }, {
        formatBuffer: [],
        escapedTextBuffer: []
    }).formatBuffer.join('');
}

});


parcelRegister("hmV0i", function(module, exports) {

$parcel$export(module.exports, "IndicatorsContainer", () => $85a1248019ae74fb$export$d0ffd7e649cab6f);
/* indicators-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $6XEne = parcelRequire("6XEne");
const $85a1248019ae74fb$var$styles = {
    calendarButtonInclusionStyles: "_ahbqxy5q",
    calendarButtonOnlyInclusionStyles: "_ahbq1ejb"
};
const $85a1248019ae74fb$export$d0ffd7e649cab6f = ({ showClearIndicator: showClearIndicator, ...rest })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            showClearIndicator ? $85a1248019ae74fb$var$styles.calendarButtonInclusionStyles : $85a1248019ae74fb$var$styles.calendarButtonOnlyInclusionStyles
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6XEne.components).IndicatorsContainer, {
            ...rest
        })
    });

});

parcelRegister("gNwsY", function(module, exports) {

$parcel$export(module.exports, "Menu", () => $41b3b0700e22b1c1$export$d9b273488cd8ce6f);
/* menu.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $dBLX0 = parcelRequire("dBLX0");
var $kQ82p = parcelRequire("kQ82p");

var $cSUzd = parcelRequire("cSUzd");

var $3rigy = parcelRequire("3rigy");

var $7G7nX = parcelRequire("7G7nX");
/**
 * @param isos A series of ISO dates.
 * @returns The last valid date within the array of ISO strings.
 */ function $41b3b0700e22b1c1$var$getValidDate(isos) {
    return isos.reduce((acc, iso)=>{
        const date = (0, $kQ82p.default)(iso);
        return (0, $dBLX0.default)(date) ? {
            day: date.getDate(),
            month: date.getMonth() + 1,
            year: date.getFullYear()
        } : acc;
    }, {});
}
const $41b3b0700e22b1c1$var$menuStyles = null;
const $41b3b0700e22b1c1$export$d9b273488cd8ce6f = ({ selectProps: selectProps, innerProps: innerProps })=>{
    const { calendarValue: calendarValue, calendarView: calendarView, menuInnerWrapper: MenuInnerWrapper } = selectProps;
    const { day: day, month: month, year: year } = $41b3b0700e22b1c1$var$getValidDate([
        calendarValue,
        calendarView
    ]);
    const onMenuMouseDown = (event)=>{
        if (event.button !== 0) return;
        event.stopPropagation();
        event.preventDefault();
    };
    const Wrapper = typeof MenuInnerWrapper === 'function' ? MenuInnerWrapper : (0, $eJOHy.Fragment);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3rigy.Layering), {
        isDisabled: false,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7G7nX.default), {
            inputValue: selectProps.inputValue,
            containerRef: selectProps.calendarContainerRef,
            content: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                ...innerProps,
                onMouseDown: onMenuMouseDown,
                className: (0, $hcewu.default)([
                    "_2rkoglpi _1reo15vq _18m915vq _1pbyowjs _bfhk1bhr _16qs1cd0"
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)(Wrapper, {
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cSUzd.default), {
                        day: day,
                        month: month,
                        year: year,
                        disabled: selectProps.calendarDisabled,
                        disabledDateFilter: selectProps.calendarDisabledDateFilter,
                        minDate: selectProps.calendarMinDate,
                        maxDate: selectProps.calendarMaxDate,
                        nextMonthLabel: selectProps.nextMonthLabel,
                        onChange: selectProps.onCalendarChange,
                        onSelect: selectProps.onCalendarSelect,
                        previousMonthLabel: selectProps.previousMonthLabel,
                        ref: selectProps.calendarRef,
                        selected: [
                            selectProps.calendarValue
                        ],
                        shouldSetFocusOnCurrentDay: selectProps.shouldSetFocusOnCurrentDay,
                        locale: selectProps.calendarLocale,
                        testId: selectProps.testId && `${selectProps.testId}--calendar`,
                        weekStartDay: selectProps.calendarWeekStartDay
                    })
                })
            }),
            testId: selectProps.testId
        })
    });
};

});
parcelRegister("cSUzd", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1db3bdfc4d701b2$export$2e2bcd8739ae039);
/* calendar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $jrFnt = parcelRequire("jrFnt");

var $3Vuhz = parcelRequire("3Vuhz");

var $gl2vi = parcelRequire("gl2vi");

var $8IeH1 = parcelRequire("8IeH1");
var $78OnL = parcelRequire("78OnL");

var $hWhuM = parcelRequire("hWhuM");

var $jOHXZ = parcelRequire("jOHXZ");

var $1p4Fz = parcelRequire("1p4Fz");

var $h2Y6s = parcelRequire("h2Y6s");

var $7pqrO = parcelRequire("7pqrO");

var $8m7JM = parcelRequire("8m7JM");

var $5Pa93 = parcelRequire("5Pa93");

var $cM3gB = parcelRequire("cM3gB");

var $lPLOh = parcelRequire("lPLOh");

var $jtNxE = parcelRequire("jtNxE");
const $d1db3bdfc4d701b2$var$styles = {
    box: "_1e0c1o8l _uiztglyw"
};
const $d1db3bdfc4d701b2$var$analyticsAttributes = {
    componentName: 'calendar',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $d1db3bdfc4d701b2$var$InnerCalendar = /*#__PURE__*/ (0, $eJOHy.forwardRef)(function Calendar({ day: day, defaultDay: defaultDay = 0, defaultMonth: defaultMonth = 0, defaultPreviouslySelected: defaultPreviouslySelected = (0, $h2Y6s.blankStringArray), defaultSelected: defaultSelected = (0, $h2Y6s.blankStringArray), defaultYear: defaultYear = 0, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDate, maxDate: maxDate, month: month, nextMonthLabel: nextMonthLabel, onBlur: onBlur = (0, $3Vuhz.default), onChange: onChange = (0, $3Vuhz.default), onFocus: onFocus = (0, $3Vuhz.default), onSelect: onSelect = (0, $3Vuhz.default), previouslySelected: previouslySelected, previousMonthLabel: previousMonthLabel, selected: selected, shouldSetFocusOnCurrentDay: shouldSetFocusOnCurrentDay = false, today: today, locale: locale = 'en-US', year: year, analyticsContext: analyticsContext, weekStartDay: weekStartDay = 0, testId: testId, className: className, style: style, tabIndex: tabIndex = 0 }, ref) {
    const { day: [dayValue, setDayValue], month: [monthValue, setMonthValue], year: [yearValue, setYearValue], today: [todayValue], selected: [selectedValue, setSelectedValue], previous: [previouslySelectedValue, setPreviouslySelectedValue] } = (0, $7pqrO.default)({
        day: day,
        defaultDay: defaultDay,
        month: month,
        defaultMonth: defaultMonth,
        year: year,
        defaultYear: defaultYear,
        today: today,
        selected: selected,
        defaultSelected: defaultSelected,
        previouslySelected: previouslySelected,
        defaultPreviouslySelected: defaultPreviouslySelected
    });
    const [shouldSetFocus, setShouldSetFocus] = (0, $eJOHy.useState)(false);
    const onChangeWithAnalytics = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        ...$d1db3bdfc4d701b2$var$analyticsAttributes
    });
    const { navigate: navigate, handleClickNextMonth: handleClickNextMonth, handleClickNextYear: handleClickNextYear, handleClickPrevMonth: handleClickPrevMonth, handleClickPrevYear: handleClickPrevYear } = (0, $cM3gB.default)({
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        shouldSetFocus: [
            shouldSetFocus,
            setShouldSetFocus
        ],
        onChange: onChangeWithAnalytics
    });
    const onSelectWithAnalytics = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: onSelect,
        action: 'selected',
        analyticsData: analyticsContext,
        ...$d1db3bdfc4d701b2$var$analyticsAttributes
    });
    const { handleClickDay: handleClickDay, handleContainerKeyDown: handleContainerKeyDown } = (0, $lPLOh.default)({
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        selected: [
            selectedValue,
            setSelectedValue
        ],
        previous: [
            ,
            setPreviouslySelectedValue
        ],
        onSelect: onSelectWithAnalytics,
        navigate: navigate
    });
    const { handleContainerBlur: handleContainerBlur, handleContainerFocus: handleContainerFocus } = (0, $8m7JM.default)({
        onFocus: onFocus,
        onBlur: onBlur
    });
    const { monthsLong: monthsLong, daysShort: daysShort, daysLong: daysLong } = (0, $jtNxE.default)({
        locale: locale,
        weekStartDay: weekStartDay
    });
    const weeks = (0, $5Pa93.default)({
        day: dayValue,
        month: monthValue,
        year: yearValue,
        today: todayValue,
        selected: selectedValue,
        previouslySelected: previouslySelectedValue,
        disabled: disabled,
        disabledDateFilter: disabledDateFilter,
        minDate: minDate,
        maxDate: maxDate,
        daysLong: daysLong,
        weekStartDay: weekStartDay
    });
    const getNextMonthHeading = ()=>{
        // Next month is (currentMonth - 1) + 1, or just currentMonth in this
        // instance.
        const nextMonth = monthValue % 12;
        const showNextYear = monthValue === 12;
        return `${monthsLong[nextMonth]} ${showNextYear ? yearValue + 1 : yearValue}`;
    };
    const getNextYearHeading = ()=>{
        // Months are held in Date object as zero-indexed
        const thisMonth = (monthValue - 1) % 12;
        const nextYear = yearValue + 1;
        return `${monthsLong[thisMonth]} ${nextYear}`;
    };
    const getPreviousMonthHeading = ()=>{
        // Previous month is (monthValue - 1) - 1. Need to add 12 so the modulo
        // works as expected and stays positive.
        const previousMonth = (monthValue + 12 - 2) % 12;
        const showPreviousYear = monthValue === 1;
        return `${monthsLong[previousMonth]} ${showPreviousYear ? yearValue - 1 : yearValue}`;
    };
    const getPreviousYearHeading = ()=>{
        // Months are held in Date object as zero-indexed
        const thisMonth = (monthValue - 1) % 12;
        const previousYear = yearValue - 1;
        return `${monthsLong[thisMonth]} ${previousYear}`;
    };
    const headerId = (0, $gl2vi.useId)();
    return(// eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $gt9Am.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: className,
        style: style,
        onBlur: handleContainerBlur,
        onFocus: handleContainerFocus,
        "data-testid": testId && `${testId}--container`,
        ref: ref,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
            xcss: $d1db3bdfc4d701b2$var$styles.box,
            padding: "space.200",
            "aria-label": "calendar",
            testId: testId && `${testId}--calendar`,
            children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $78OnL.default), {
                space: "space.150",
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hWhuM.default // The month number needs to be translated to index in the month
                    ), {
                        // name array e.g. 1 (January) -> 0
                        monthLongTitle: monthsLong[monthValue - 1],
                        year: yearValue,
                        nextMonthLabel: nextMonthLabel,
                        previousMonthLabel: previousMonthLabel,
                        nextMonthHeading: getNextMonthHeading(),
                        nextYearHeading: getNextYearHeading(),
                        previousMonthHeading: getPreviousMonthHeading(),
                        previousYearHeading: getPreviousYearHeading(),
                        handleClickNextMonth: handleClickNextMonth,
                        handleClickNextYear: handleClickNextYear,
                        handleClickPrevMonth: handleClickPrevMonth,
                        handleClickPrevYear: handleClickPrevYear,
                        headerId: headerId,
                        tabIndex: tabIndex,
                        testId: testId
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $8IeH1.default), {
                        role: "grid",
                        onKeyDown: handleContainerKeyDown,
                        "aria-labelledby": headerId,
                        testId: testId && `${testId}--calendar-dates`,
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1p4Fz.default), {
                                daysShort: daysShort,
                                testId: testId
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jOHXZ.default), {
                                weeks: weeks,
                                handleClickDay: handleClickDay,
                                monthsLong: monthsLong,
                                shouldSetFocus: shouldSetFocus || shouldSetFocusOnCurrentDay,
                                tabIndex: tabIndex,
                                testId: testId
                            })
                        ]
                    })
                ]
            })
        })
    }));
});
/**
 * __Calendar__
 *
 * A calendar is used for date selection.
 *
 * - [Examples](https://atlassian.design/components/calendar/examples)
 * - [Code](https://atlassian.design/components/calendar/code)
 * - [Usage](https://atlassian.design/components/calendar/usage)
 */ const $d1db3bdfc4d701b2$var$Calendar = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)(function Calendar(props, ref) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)($d1db3bdfc4d701b2$var$InnerCalendar, {
        ...props,
        ref: ref
    });
}));
$d1db3bdfc4d701b2$var$Calendar.displayName = 'Calendar';
var $d1db3bdfc4d701b2$export$2e2bcd8739ae039 = $d1db3bdfc4d701b2$var$Calendar;

});
parcelRegister("hWhuM", function(module, exports) {

$parcel$export(module.exports, "default", () => $8fe58087a91a587c$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $Ay1uj = parcelRequire("Ay1uj");

var $gl2vi = parcelRequire("gl2vi");

var $806LH = parcelRequire("806LH");

var $ld0cd = parcelRequire("ld0cd");

var $cqfIR = parcelRequire("cqfIR");

var $8PCRQ = parcelRequire("8PCRQ");

var $cQxBL = parcelRequire("cQxBL");

var $8IeH1 = parcelRequire("8IeH1");
var $6djmC = parcelRequire("6djmC");
const $8fe58087a91a587c$var$Header = /*#__PURE__*/ (0, $eJOHy.memo)(function Header({ monthLongTitle: monthLongTitle, year: year, previousMonthLabel: previousMonthLabel = 'Previous month', previousYearLabel: previousYearLabel = 'Previous year', previousMonthHeading: previousMonthHeading, previousYearHeading: previousYearHeading, nextMonthLabel: nextMonthLabel = 'Next month', nextYearLabel: nextYearLabel = 'Next year', nextMonthHeading: nextMonthHeading, nextYearHeading: nextYearHeading, handleClickPrevMonth: handleClickPrevMonth, handleClickPrevYear: handleClickPrevYear, handleClickNextMonth: handleClickNextMonth, handleClickNextYear: handleClickNextYear, headerId: headerId, tabIndex: tabIndex, testId: testId }) {
    const announceId = (0, $gl2vi.useId)();
    // All of this is because `aria-atomic` is not fully supported for different
    // assistive technologies. We want the value of the current month and year to
    // be announced, but *only* if that value has been interacted with since
    // being mounted. This allows us to conditionally apply the `aria-live`
    // attribute.  Without this, the `aria-live` property is set on mount and
    // overrides the default input's readout in downstream consumers (e.g.
    // datetime picker).
    const [hasInteractedWithMonthOrYear, setHasInteractedWithMonthOrYear] = (0, $eJOHy.useState)(false);
    const handlePrevMonthInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickPrevMonth(e);
    };
    const handlePrevYearInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickPrevYear(e);
    };
    const handleNextMonthInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickNextMonth(e);
    };
    const handleNextYearInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickNextYear(e);
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        paddingInline: "space.100",
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
            space: "space.0",
            alignBlock: "center",
            spread: "space-between",
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
                    space: "space.100",
                    alignBlock: "start",
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                            appearance: "subtle",
                            spacing: "compact",
                            tabIndex: tabIndex,
                            onClick: handlePrevYearInteraction,
                            testId: testId && `${testId}--previous-year`,
                            icon: (iconProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ld0cd))), {
                                    ...iconProps,
                                    size: "small"
                                }),
                            label: `${previousYearLabel}, ${previousYearHeading}`
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                            appearance: "subtle",
                            spacing: "compact",
                            tabIndex: tabIndex,
                            onClick: handlePrevMonthInteraction,
                            testId: testId && `${testId}--previous-month`,
                            icon: (iconProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8PCRQ))), {
                                    ...iconProps,
                                    size: "small"
                                }),
                            label: `${previousMonthLabel}, ${previousMonthHeading}`
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                    "aria-live": hasInteractedWithMonthOrYear ? 'polite' : undefined,
                    id: announceId,
                    testId: testId && `${testId}--current-month-year--container`,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $806LH.default), {
                        size: "xsmall",
                        as: "h2",
                        id: headerId,
                        testId: testId && `${testId}--current-month-year`,
                        children: `${monthLongTitle} ${year}`
                    })
                }),
                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
                    space: "space.100",
                    alignBlock: "end",
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                            appearance: "subtle",
                            spacing: "compact",
                            tabIndex: tabIndex,
                            onClick: handleNextMonthInteraction,
                            testId: testId && `${testId}--next-month`,
                            icon: (iconProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cQxBL))), {
                                    ...iconProps,
                                    size: "small"
                                }),
                            label: `${nextMonthLabel}, ${nextMonthHeading}`
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                            appearance: "subtle",
                            spacing: "compact",
                            tabIndex: tabIndex,
                            onClick: handleNextYearInteraction,
                            testId: testId && `${testId}--next-year`,
                            icon: (iconProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cqfIR))), {
                                    ...iconProps,
                                    size: "small"
                                }),
                            label: `${nextYearLabel}, ${nextYearHeading}`
                        })
                    ]
                })
            ]
        })
    });
});
$8fe58087a91a587c$var$Header.displayName = 'Header';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$8fe58087a91a587c$export$2e2bcd8739ae039 = $8fe58087a91a587c$var$Header;

});
parcelRegister("ld0cd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::89a5ee1ee34f6c51127fc5be19fb8c41>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f70af6cd1d0cef8e$var$_react = $f70af6cd1d0cef8e$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $f70af6cd1d0cef8e$var$_baseNew = $f70af6cd1d0cef8e$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $f70af6cd1d0cef8e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDoubleLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Navigate to previous year in calendar/date picker
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f70af6cd1d0cef8e$var$ChevronDoubleLeftIcon = (props)=>/*#__PURE__*/ $f70af6cd1d0cef8e$var$_react.default.createElement($f70af6cd1d0cef8e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m7.72 1.47-6 6a.75.75 0 0 0-.052 1.004l.052.056 6 6 1.06-1.06L3.31 8l5.47-5.47z"/><path fill="currentcolor" d="m12.47 1.47-6 6a.75.75 0 0 0-.052 1.004l.052.056 6 6 1.06-1.06L8.06 8l5.47-5.47z"/>`
    }, props));
$f70af6cd1d0cef8e$var$ChevronDoubleLeftIcon.displayName = 'ChevronDoubleLeftIcon';
var $f70af6cd1d0cef8e$var$_default = module.exports.default = $f70af6cd1d0cef8e$var$ChevronDoubleLeftIcon;

});

parcelRegister("cqfIR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a70faad39a1700c3cb50a44f6bcc1a4e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $90b41be71667434a$var$_react = $90b41be71667434a$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $90b41be71667434a$var$_baseNew = $90b41be71667434a$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $90b41be71667434a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDoubleRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Navigate to next year in calendar/date picker
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $90b41be71667434a$var$ChevronDoubleRightIcon = (props)=>/*#__PURE__*/ $90b41be71667434a$var$_react.default.createElement($90b41be71667434a$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m8.28 1.47 6 6a.75.75 0 0 1 .052 1.004l-.052.056-6 6-1.06-1.06L12.69 8 7.22 2.53z"/><path fill="currentcolor" d="m3.53 1.47 6 6a.75.75 0 0 1 .052 1.004l-.052.056-6 6-1.06-1.06L7.94 8 2.47 2.53z"/>`
    }, props));
$90b41be71667434a$var$ChevronDoubleRightIcon.displayName = 'ChevronDoubleRightIcon';
var $90b41be71667434a$var$_default = module.exports.default = $90b41be71667434a$var$ChevronDoubleRightIcon;

});

parcelRegister("8PCRQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4b851fec559156e1edca3c5f214f4a7f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $66e13c6de5d90262$var$_react = $66e13c6de5d90262$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $66e13c6de5d90262$var$_baseNew = $66e13c6de5d90262$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $66e13c6de5d90262$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Navigate back, show previous page of pagination results
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $66e13c6de5d90262$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $66e13c6de5d90262$var$_react.default.createElement($66e13c6de5d90262$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m9.97 1.47-6 6a.75.75 0 0 0-.052 1.004l.052.056 6 6 1.06-1.06L5.56 8l5.47-5.47z"/>`
    }, props));
$66e13c6de5d90262$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $66e13c6de5d90262$var$_default = module.exports.default = $66e13c6de5d90262$var$ChevronLeftIcon;

});


parcelRegister("jOHXZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $7776188040914bac$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");

var $17gD3 = parcelRequire("17gD3");

var $48tPc = parcelRequire("48tPc");
const $7776188040914bac$var$WeekDays = /*#__PURE__*/ (0, $eJOHy.memo)(function WeekDays({ weeks: weeks, handleClickDay: handleClickDay, monthsLong: monthsLong, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
        role: "rowgroup",
        testId: testId && `${testId}--month`,
        children: weeks.map((week, i)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $48tPc.default), {
                testId: testId && `${testId}--week`,
                children: week.values.map((weekDay)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $17gD3.default), {
                        isDisabled: weekDay.isDisabled,
                        isFocused: weekDay.isFocused,
                        isToday: weekDay.isToday,
                        dayLong: weekDay.weekDayName,
                        month: weekDay.month,
                        monthLong: monthsLong[weekDay.month - 1],
                        onClick: handleClickDay,
                        isPreviouslySelected: weekDay.isPreviouslySelected,
                        isSelected: weekDay.isSelected,
                        isSibling: weekDay.isSiblingMonth,
                        year: weekDay.year,
                        shouldSetFocus: shouldSetFocus,
                        tabIndex: tabIndex,
                        testId: testId,
                        children: weekDay.day
                    }, `${week.id}-${weekDay.id}`))
            }, i))
    });
});
$7776188040914bac$var$WeekDays.displayName = 'WeekDays';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7776188040914bac$export$2e2bcd8739ae039 = $7776188040914bac$var$WeekDays;

});
parcelRegister("17gD3", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f55ebb7772d4c5d$export$2e2bcd8739ae039);
/* date.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $3Vuhz = parcelRequire("3Vuhz");

var $hYvlq = parcelRequire("hYvlq");
const $7f55ebb7772d4c5d$var$dateCellSiblingStyle = null;
const $7f55ebb7772d4c5d$var$dateCellTodayStyle = null;
const $7f55ebb7772d4c5d$var$dateCellPrevSelectedStyle = null;
const $7f55ebb7772d4c5d$var$dateCellSelectedStyle = null;
const $7f55ebb7772d4c5d$var$dateCellDisabledStyle = null;
const $7f55ebb7772d4c5d$var$dateCellStyles = null;
const $7f55ebb7772d4c5d$var$Date = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)(function Date({ children: day, isDisabled: isDisabled = false, isFocused: isFocused = false, isToday: isToday = false, dayLong: dayLong, month: month, monthLong: monthLong, onClick: onClick = (0, $3Vuhz.default), isPreviouslySelected: isPreviouslySelected = false, isSelected: isSelected = false, isSibling: isSibling = false, year: year, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId }, _ref) {
    const dateRef = (0, $eJOHy.useRef)({
        day: day,
        month: month,
        year: year,
        isDisabled: isDisabled
    });
    (0, $eJOHy.useEffect)(()=>{
        dateRef.current = {
            day: day,
            month: month,
            year: year,
            isDisabled: isDisabled
        };
    }, [
        day,
        month,
        year,
        isDisabled
    ]);
    const focusRef = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useEffect)(()=>{
        if (isFocused && shouldSetFocus && focusRef.current) focusRef.current.focus();
    }, [
        isFocused,
        shouldSetFocus
    ]);
    const handleClick = (0, $eJOHy.useCallback)(()=>{
        const { day: dayValue, month: monthValue, year: yearValue, isDisabled: isDisabledValue } = dateRef.current;
        if (!isDisabledValue) onClick({
            day: dayValue,
            month: monthValue,
            year: yearValue
        });
    }, [
        onClick
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hYvlq.default), {
        role: "gridcell",
        alignItems: "center",
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("button", {
            "aria-current": isToday ? 'date' : undefined,
            "aria-disabled": isDisabled || undefined,
            "aria-label": `${day}, ${dayLong} ${monthLong} ${year}`,
            "aria-pressed": isSelected ? 'true' : 'false',
            tabIndex: isFocused ? tabIndex : -1,
            type: "button",
            onClick: handleClick,
            ref: focusRef,
            "data-disabled": isDisabled || undefined,
            "data-focused": isFocused || undefined,
            "data-prev-selected": isPreviouslySelected || undefined,
            "data-selected": isSelected || undefined,
            "data-sibling": isSibling || undefined,
            "data-today": isToday || undefined,
            "data-testid": testId && (isSelected ? `${testId}--selected-day` : `${testId}--day`),
            className: (0, $hcewu.default)([
                "_kkk2n7od _2rko1l7b _11c82smr _1h6d3acm _1dqonqa1 _189eyh40 _1e0c1ule _kqswh2mm _16jlkb7n _bfhk18uv _syazj3m3 _80omtlke _85i51b66 _1q511b66 _y4tirdoj _bozgrdoj _y3gn1h6o _pojj194a _10knnqa1 _1wysyh40 _irr314ae _30l3j3m3 _1di61l7b _9h8hj3m3",
                isSibling && "_syaz1wmz _30l31wmz",
                isToday && "_syaz1ldt _k48p1igg _1ywu1ule _1qdgyh40 _18postnw _1hfk1r31 _aetrb3bt _1gufv77o _1czdv77o _g0nfv77o",
                isPreviouslySelected && "_bfhk29zg _syazc8hx _30l3c8hx",
                isSelected && "_bfhk1p4p _syazqueg _irr3quvt _30l31uqy",
                isDisabled && "_syaz7dlb _80om13gf _irr318uv _30l37dlb"
            ]),
            children: day
        })
    });
}));
$7f55ebb7772d4c5d$var$Date.displayName = 'Date';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7f55ebb7772d4c5d$export$2e2bcd8739ae039 = $7f55ebb7772d4c5d$var$Date;

});
parcelRegister("hYvlq", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e062987a137d87a$export$2e2bcd8739ae039);
/* grid.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $3e062987a137d87a$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
const $3e062987a137d87a$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
const $3e062987a137d87a$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
const $3e062987a137d87a$var$alignContentMap = {
    start: "_ae4vv2br",
    center: "_ae4v1h6o",
    end: "_ae4vh9n0",
    'space-between': "_ae4v1yb4",
    'space-around': "_ae4v1b1v",
    'space-evenly': "_ae4vitcz",
    stretch: "_ae4v1fhb"
};
const $3e062987a137d87a$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
const $3e062987a137d87a$var$baseStyles = {
    root: "_1e0c11p5 _vchhusvi"
};
const $3e062987a137d87a$var$gridAutoFlowMap = {
    row: "_wij2vrvc",
    column: "_wij21bp4",
    dense: "_wij218l3",
    'row dense': "_wij2j5tq",
    'column dense': "_wij2adhi"
};
/**
 * __Grid__
 *
 * `Grid` is a primitive component that implements the CSS Grid API.
 *
 * - [Examples](https://atlassian.design/components/primitives/grid/examples)
 * - [Code](https://atlassian.design/components/primitives/grid/code)
 *
 * @example
 * ```tsx
 * import { Grid, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Grid gap="space.100" gridColumns="1fr 1fr">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Grid>
 * )
 * ```
 */ const $3e062987a137d87a$var$Grid = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: as, alignItems: alignItems, alignContent: alignContent, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, id: id, role: role, testId: testId, autoFlow: autoFlow, xcss: xcss }, ref)=>{
    const Component = as || 'div';
    return /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
        id: id,
        role: role,
        className: (0, $hcewu.default)([
            $3e062987a137d87a$var$baseStyles.root,
            gap && $3e062987a137d87a$var$columnGapMap[gap],
            columnGap && $3e062987a137d87a$var$columnGapMap[columnGap],
            gap && $3e062987a137d87a$var$rowGapMap[gap],
            rowGap && $3e062987a137d87a$var$rowGapMap[rowGap],
            alignItems && $3e062987a137d87a$var$alignItemsMap[alignItems],
            alignContent && $3e062987a137d87a$var$alignContentMap[alignContent],
            justifyContent && $3e062987a137d87a$var$justifyContentMap[justifyContent],
            autoFlow && $3e062987a137d87a$var$gridAutoFlowMap[autoFlow],
            xcss
        ]),
        "data-testid": testId,
        ref: ref,
        children: children
    });
}));
$3e062987a137d87a$var$Grid.displayName = 'Grid';
var $3e062987a137d87a$export$2e2bcd8739ae039 = $3e062987a137d87a$var$Grid;

});


parcelRegister("48tPc", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f5de1de4465d4ec$export$2e2bcd8739ae039);
/* week-day-grid.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hYvlq = parcelRequire("hYvlq");
const $4f5de1de4465d4ec$var$styles = {
    templateColumns: "_yv0eloeq"
};
/**
 * __Week day grid__
 *
 * A week day grid aligns elements in a 7 wide grid layout.
 *
 */ const $4f5de1de4465d4ec$var$WeekDayGrid = ({ testId: testId, children: children, isHidden: isHidden })=>{
    const row = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hYvlq.default), {
        testId: testId,
        xcss: $4f5de1de4465d4ec$var$styles.templateColumns,
        role: "row",
        children: children
    });
    return isHidden ? /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "aria-hidden": "true",
        children: row
    }) : row;
};
var $4f5de1de4465d4ec$export$2e2bcd8739ae039 = $4f5de1de4465d4ec$var$WeekDayGrid;

});


parcelRegister("1p4Fz", function(module, exports) {

$parcel$export(module.exports, "default", () => $be65a37818b8364c$export$2e2bcd8739ae039);
/* week-header.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");
var $3cMgR = parcelRequire("3cMgR");

var $48tPc = parcelRequire("48tPc");
const $be65a37818b8364c$var$styles = {
    columnHeader: "_1ul98pqr _o5721q9c _1e0c1txw _1bah1h6o"
};
const $be65a37818b8364c$var$WeekHeader = /*#__PURE__*/ (0, $eJOHy.memo)(function WeekHeader({ daysShort: daysShort, testId: testId }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $48tPc.default), {
        isHidden: true,
        testId: testId && `${testId}--column-headers`,
        children: daysShort.map((shortDay)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                padding: "space.100",
                xcss: $be65a37818b8364c$var$styles.columnHeader,
                role: "columnheader",
                testId: testId && `${testId}--column-header`,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                    weight: "bold",
                    size: "UNSAFE_small",
                    align: "center",
                    color: "color.text.subtle",
                    children: shortDay
                })
            }, shortDay))
    });
});
$be65a37818b8364c$var$WeekHeader.displayName = 'WeekHeader';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$be65a37818b8364c$export$2e2bcd8739ae039 = $be65a37818b8364c$var$WeekHeader;

});

parcelRegister("h2Y6s", function(module, exports) {

$parcel$export(module.exports, "arrowKeys", () => $be18158d85881f31$export$8b15eca9c6d5c48a);
$parcel$export(module.exports, "daysPerWeek", () => $be18158d85881f31$export$3ae905d9742bef55);
$parcel$export(module.exports, "monthsPerYear", () => $be18158d85881f31$export$c9b7c010035d60c6);
$parcel$export(module.exports, "blankStringArray", () => $be18158d85881f31$export$8fa20d70624f8b9d);
const $be18158d85881f31$export$8b15eca9c6d5c48a = {
    ArrowDown: 'down',
    ArrowLeft: 'left',
    ArrowRight: 'right',
    ArrowUp: 'up'
};
const $be18158d85881f31$export$3ae905d9742bef55 = 7;
const $be18158d85881f31$export$c9b7c010035d60c6 = 12;
const $be18158d85881f31$export$8fa20d70624f8b9d = [];

});

parcelRegister("7pqrO", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd0ab84481a095dc$export$2e2bcd8739ae039);

var $7O2l7 = parcelRequire("7O2l7");

var $3c3v8 = parcelRequire("3c3v8");

var $ediHA = parcelRequire("ediHA");
function $dd0ab84481a095dc$export$2e2bcd8739ae039({ day: day, defaultDay: defaultDay, month: month, defaultMonth: defaultMonth, year: year, defaultYear: defaultYear, today: today, selected: selected, defaultSelected: defaultSelected, previouslySelected: previouslySelected, defaultPreviouslySelected: defaultPreviouslySelected }) {
    const { current: { thisDay: thisDay, thisMonth: thisMonth, thisYear: thisYear } } = (0, $3c3v8.default)(()=>{
        const now = new Date();
        const thisDay = now.getDate();
        const thisMonth = now.getMonth() + 1;
        const thisYear = now.getFullYear();
        return {
            thisDay: thisDay,
            thisMonth: thisMonth,
            thisYear: thisYear
        };
    });
    const [dayValue, setDayValue] = (0, $7O2l7.default)(day, ()=>defaultDay || thisDay);
    const [monthValue, setMonthValue] = (0, $7O2l7.default)(month, ()=>defaultMonth || thisMonth);
    const [yearValue, setYearValue] = (0, $7O2l7.default)(year, ()=>defaultYear || thisYear);
    const [todayValue] = (0, $7O2l7.default)(today, ()=>today || `${thisYear}-${(0, $ediHA.default)(thisMonth)}-${(0, $ediHA.default)(thisDay)}`);
    const [selectedValue, setSelectedValue] = (0, $7O2l7.default)(selected, ()=>defaultSelected);
    const [previouslySelectedValue, setPreviouslySelectedValue] = (0, $7O2l7.default)(previouslySelected, ()=>defaultPreviouslySelected);
    return {
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        today: [
            todayValue
        ],
        selected: [
            selectedValue,
            setSelectedValue
        ],
        previous: [
            previouslySelectedValue,
            setPreviouslySelectedValue
        ]
    };
}

});
parcelRegister("ediHA", function(module, exports) {

$parcel$export(module.exports, "default", () => $50fecd0d0148fc4a$export$2e2bcd8739ae039);
function $50fecd0d0148fc4a$export$2e2bcd8739ae039(num) {
    return num < 10 ? `0${num}` : `${num}`;
}

});


parcelRegister("8m7JM", function(module, exports) {

$parcel$export(module.exports, "default", () => $c971afa7669251e8$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
function $c971afa7669251e8$export$2e2bcd8739ae039({ onBlur: onBlur, onFocus: onFocus }) {
    const handleContainerBlur = (0, $eJOHy.useCallback)((event)=>{
        onBlur(event);
    }, [
        onBlur
    ]);
    const handleContainerFocus = (0, $eJOHy.useCallback)((event)=>{
        onFocus(event);
    }, [
        onFocus
    ]);
    return {
        handleContainerBlur: handleContainerBlur,
        handleContainerFocus: handleContainerFocus
    };
}

});

parcelRegister("5Pa93", function(module, exports) {

$parcel$export(module.exports, "default", () => $6571678cf382b203$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $kQ82p = parcelRequire("kQ82p");

var $h2Y6s = parcelRequire("h2Y6s");

var $fdbAT = parcelRequire("fdbAT");

var $cFI4x = parcelRequire("cFI4x");
function $6571678cf382b203$var$useGetCalendarWithSixthWeek(calendar, { month: month, year: year, weekStartDay: weekStartDay }) {
    const shouldDisplaySixthWeek = calendar.length % 6;
    const calendarLastValue = calendar[calendar.length - 1];
    return (0, $eJOHy.useMemo)(()=>{
        // Some months jump between 5 and 6 weeks to display. In some cases 4 (Feb
        // with the 1st on a Monday etc). This ensures the UI doesn't jump around by
        // catering to always showing 6 weeks.
        if (shouldDisplaySixthWeek) {
            const lastDayIsSibling = calendarLastValue.siblingMonth;
            const sliceStart = lastDayIsSibling ? (0, $h2Y6s.daysPerWeek) : 0;
            return (0, $cFI4x.default)(year, month, {
                weekStartDay: weekStartDay
            }).slice(sliceStart, sliceStart + (0, $h2Y6s.daysPerWeek)).map((date)=>({
                    ...date,
                    siblingMonth: true
                }));
        }
    }, [
        calendarLastValue,
        month,
        shouldDisplaySixthWeek,
        weekStartDay,
        year
    ]);
}
function $6571678cf382b203$export$2e2bcd8739ae039({ day: day, daysLong: daysLong, month: month, year: year, today: today, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDateString, maxDate: maxDateString, selected: selected, previouslySelected: previouslySelected, weekStartDay: weekStartDay }) {
    const calendar = (0, $eJOHy.useMemo)(()=>(0, $cFI4x.default)(year, month - 1, {
            weekStartDay: weekStartDay
        }), [
        month,
        weekStartDay,
        year
    ]);
    const calendarWithSixthWeek = $6571678cf382b203$var$useGetCalendarWithSixthWeek(calendar, {
        month: month,
        year: year,
        weekStartDay: weekStartDay
    });
    if (calendarWithSixthWeek) calendar.push(...calendarWithSixthWeek);
    const minDate = minDateString ? (0, $kQ82p.default)(minDateString) : undefined;
    const maxDate = maxDateString ? (0, $kQ82p.default)(maxDateString) : undefined;
    const needJsDate = minDateString || maxDateString;
    return (0, $eJOHy.useMemo)(()=>{
        const weeks = [];
        calendar.forEach((date)=>{
            const dateAsString = (0, $fdbAT.default)(date, {
                fixMonth: true
            });
            const JSDate = needJsDate ? (0, $kQ82p.default)(dateAsString) : undefined;
            let week;
            if (date.weekDay === weekStartDay) {
                week = {
                    id: dateAsString,
                    values: []
                };
                weeks.push(week);
            } else week = weeks[weeks.length - 1];
            const weekDayOffset = (date.weekDay - weekStartDay) % 7;
            // Define a bunch of `const`s
            const weekDayName = daysLong[weekDayOffset];
            const isDisabledByArray = disabled ? disabled.indexOf(dateAsString) > -1 : false;
            const isDisabledByFilter = disabledDateFilter ? disabledDateFilter(dateAsString) : false;
            const isDisabledByMin = minDate && JSDate ? JSDate < minDate : false;
            const isDisabledByMax = maxDate && JSDate ? JSDate > maxDate : false;
            const isDisabled = isDisabledByArray || isDisabledByFilter || isDisabledByMin || isDisabledByMax;
            const isFocused = day === date.day && !date.siblingMonth;
            const isPreviouslySelected = !isDisabled && previouslySelected.indexOf(dateAsString) > -1;
            const isSelected = !isDisabled && selected.indexOf(dateAsString) > -1;
            const isSiblingMonth = !!date.siblingMonth;
            const isToday = today === dateAsString;
            week.values.push({
                id: dateAsString,
                isDisabled: isDisabled,
                isFocused: isFocused,
                isToday: isToday,
                month: date.month + 1,
                isPreviouslySelected: isPreviouslySelected,
                isSelected: isSelected,
                isSiblingMonth: isSiblingMonth,
                year: date.year,
                day: date.day,
                weekDayName: weekDayName
            });
        });
        return weeks;
    }, [
        calendar,
        day,
        disabled,
        disabledDateFilter,
        minDate,
        maxDate,
        needJsDate,
        previouslySelected,
        selected,
        today,
        weekStartDay,
        daysLong
    ]);
}

});
parcelRegister("fdbAT", function(module, exports) {

$parcel$export(module.exports, "default", () => $33e505eaecca4d6d$export$2e2bcd8739ae039);

var $ediHA = parcelRequire("ediHA");
function $33e505eaecca4d6d$export$2e2bcd8739ae039(date, options) {
    return `${date.year}-${(0, $ediHA.default)(date.month + (options && options.fixMonth ? 1 : 0))}-${(0, $ediHA.default)(date.day)}`;
}

});

parcelRegister("cFI4x", function(module, exports) {

$parcel$export(module.exports, "default", () => $5fc98c4c7dc36d65$export$2e2bcd8739ae039);
/**
 * Logic taken from https://github.com/WesSouza/calendar-base which is not maintained for quite sometime.
 * This will help us fixing any issue we might get or any new functionality we might want to support.
 * Not changing much code below. Just removed those parts which we don't need.
 */ 
var $h2Y6s = parcelRequire("h2Y6s");

var $d9oTA = parcelRequire("d9oTA");
function $5fc98c4c7dc36d65$export$2e2bcd8739ae039(year, month, { weekStartDay: weekStartDay = 0 } = {
    weekStartDay: 0
}) {
    const date = new Date(Date.UTC(year, month, 1, 0, 0, 0, 0));
    const utcYear = date.getUTCFullYear();
    const utcMonth = date.getUTCMonth();
    const calendar = [];
    const firstDay = date.getUTCDay();
    const firstDate = -(((0, $h2Y6s.daysPerWeek) - weekStartDay + firstDay) % (0, $h2Y6s.daysPerWeek));
    const lastDate = (0, $d9oTA.default)(utcYear, utcMonth);
    const lastDay = (lastDate - firstDate) % (0, $h2Y6s.daysPerWeek);
    const lastDateOfPreviousMonth = (0, $d9oTA.default)(utcYear, utcMonth - 1);
    let dateCounter = firstDate;
    let currentDay;
    let currentDate;
    let currentDateObject = null;
    let calculatedMonth;
    let calculatedYear;
    const maxDateCount = lastDate - dateCounter + (lastDay !== 0 ? (0, $h2Y6s.daysPerWeek) - lastDay : 0) + firstDate;
    while(dateCounter < maxDateCount){
        currentDate = dateCounter + 1;
        currentDay = ((dateCounter < 1 ? (0, $h2Y6s.daysPerWeek) + dateCounter : dateCounter) + firstDay) % (0, $h2Y6s.daysPerWeek);
        if (currentDate < 1 || currentDate > lastDate) {
            if (currentDate < 1) {
                calculatedMonth = utcMonth - 1;
                calculatedYear = utcYear;
                if (calculatedMonth < 0) {
                    calculatedMonth = (0, $h2Y6s.monthsPerYear) - 1;
                    calculatedYear--;
                }
                currentDate = lastDateOfPreviousMonth + currentDate;
            } else if (currentDate > lastDate) {
                calculatedMonth = utcMonth + 1;
                calculatedYear = utcYear;
                if (calculatedMonth > (0, $h2Y6s.monthsPerYear) - 1) {
                    calculatedMonth = 0;
                    calculatedYear++;
                }
                currentDate = dateCounter - lastDate + 1;
            }
            if (calculatedMonth !== undefined && calculatedYear !== undefined) currentDateObject = {
                day: currentDate,
                weekDay: currentDay,
                month: calculatedMonth,
                year: calculatedYear,
                siblingMonth: true
            };
        } else currentDateObject = {
            day: currentDate,
            weekDay: currentDay,
            month: utcMonth,
            year: utcYear
        };
        calendar.push(currentDateObject);
        dateCounter++;
    }
    return calendar;
}

});
parcelRegister("d9oTA", function(module, exports) {

$parcel$export(module.exports, "default", () => $bdb6610bba124d19$export$2e2bcd8739ae039);
function $bdb6610bba124d19$export$2e2bcd8739ae039(year, month) {
    return new Date(year, month + 1, 0).getDate();
}

});



parcelRegister("cM3gB", function(module, exports) {

$parcel$export(module.exports, "default", () => $e11abbd67514b7e7$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $h2Y6s = parcelRequire("h2Y6s");

var $fdbAT = parcelRequire("fdbAT");

var $d9oTA = parcelRequire("d9oTA");
const $e11abbd67514b7e7$var$getNextMonth = (monthValue, yearValue)=>{
    let month = monthValue;
    let year = yearValue;
    if (month === (0, $h2Y6s.monthsPerYear)) {
        month = 1;
        year += 1;
    } else month += 1;
    return {
        month: month,
        year: year
    };
};
const $e11abbd67514b7e7$var$getPrevMonth = (monthValue, yearValue)=>{
    let month = monthValue;
    let year = yearValue;
    if (month === 1) {
        month = (0, $h2Y6s.monthsPerYear);
        year -= 1;
    } else month -= 1;
    return {
        month: month,
        year: year
    };
};
function $e11abbd67514b7e7$export$2e2bcd8739ae039({ day: [dayValue, setDayValue], month: [monthValue, setMonthValue], year: [yearValue, setYearValue], shouldSetFocus: [_shouldSetFocus, setShouldSetFocus], onChange: onChange }) {
    const dateRef = (0, $eJOHy.useRef)({
        day: dayValue,
        month: monthValue,
        year: yearValue
    });
    (0, $eJOHy.useEffect)(()=>{
        dateRef.current = {
            day: dayValue,
            month: monthValue,
            year: yearValue
        };
    }, [
        dayValue,
        monthValue,
        yearValue
    ]);
    const triggerOnChange = (0, $eJOHy.useCallback)(({ year: year, month: month, day: day, type: type })=>{
        const iso = (0, $fdbAT.default)({
            year: year,
            month: month,
            day: day
        });
        const isFocusableType = [
            'up',
            'down',
            'left',
            'right'
        ].includes(type);
        onChange({
            day: day,
            month: month,
            year: year,
            iso: iso,
            type: type
        });
        setDayValue(day);
        setMonthValue(month);
        setYearValue(year);
        setShouldSetFocus(isFocusableType);
    }, [
        onChange,
        setDayValue,
        setMonthValue,
        setYearValue,
        setShouldSetFocus
    ]);
    const navigate = (0, $eJOHy.useCallback)((type)=>{
        const { day: day, month: month, year: year } = dateRef.current;
        if (type === 'down') {
            const next = day + (0, $h2Y6s.daysPerWeek);
            const daysInMonth = (0, $d9oTA.default)(year, month - 1);
            if (next > daysInMonth) {
                const { month: nextMonth, year: nextYear } = $e11abbd67514b7e7$var$getNextMonth(month, year);
                triggerOnChange({
                    year: nextYear,
                    month: nextMonth,
                    day: next - daysInMonth,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: next,
                type: type
            });
        } else if (type === 'left') {
            const prev = day - 1;
            if (prev < 1) {
                const { month: prevMonth, year: prevYear } = $e11abbd67514b7e7$var$getPrevMonth(month, year);
                const prevDay = (0, $d9oTA.default)(prevYear, prevMonth - 1);
                triggerOnChange({
                    year: prevYear,
                    month: prevMonth,
                    day: prevDay,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: prev,
                type: type
            });
        } else if (type === 'right') {
            const next = day + 1;
            const daysInMonth = (0, $d9oTA.default)(year, month - 1);
            if (next > daysInMonth) {
                const { month: nextMonth, year: nextYear } = $e11abbd67514b7e7$var$getNextMonth(month, year);
                triggerOnChange({
                    year: nextYear,
                    month: nextMonth,
                    day: 1,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: next,
                type: type
            });
        } else if (type === 'up') {
            const prev = day - (0, $h2Y6s.daysPerWeek);
            if (prev < 1) {
                const { month: prevMonth, year: prevYear } = $e11abbd67514b7e7$var$getPrevMonth(month, year);
                const prevDay = (0, $d9oTA.default)(prevYear, prevMonth - 1) + prev;
                triggerOnChange({
                    year: prevYear,
                    month: prevMonth,
                    day: prevDay,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: prev,
                type: type
            });
        }
    }, [
        triggerOnChange
    ]);
    const handleClickNextMonth = (0, $eJOHy.useCallback)(()=>{
        const { day: day, month: month, year: year } = {
            ...dateRef.current,
            ...$e11abbd67514b7e7$var$getNextMonth(dateRef.current.month, dateRef.current.year)
        };
        triggerOnChange({
            day: day,
            month: month,
            year: year,
            type: 'nextMonth'
        });
    }, [
        triggerOnChange
    ]);
    const handleClickNextYear = (0, $eJOHy.useCallback)(()=>{
        const { day: day, month: month, year: year } = dateRef.current;
        triggerOnChange({
            day: day,
            month: month,
            year: year + 1,
            type: 'nextYear'
        });
    }, [
        triggerOnChange
    ]);
    const handleClickPrevMonth = (0, $eJOHy.useCallback)(()=>{
        const { day: day, month: month, year: year } = {
            ...dateRef.current,
            ...$e11abbd67514b7e7$var$getPrevMonth(dateRef.current.month, dateRef.current.year)
        };
        triggerOnChange({
            day: day,
            month: month,
            year: year,
            type: 'prevMonth'
        });
    }, [
        triggerOnChange
    ]);
    const handleClickPrevYear = (0, $eJOHy.useCallback)(()=>{
        const { day: day, month: month, year: year } = dateRef.current;
        triggerOnChange({
            day: day,
            month: month,
            year: year - 1,
            type: 'prevYear'
        });
    }, [
        triggerOnChange
    ]);
    return {
        navigate: navigate,
        handleClickNextMonth: handleClickNextMonth,
        handleClickNextYear: handleClickNextYear,
        handleClickPrevMonth: handleClickPrevMonth,
        handleClickPrevYear: handleClickPrevYear
    };
}

});

parcelRegister("lPLOh", function(module, exports) {

$parcel$export(module.exports, "default", () => $395ce53b4353da25$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $h2Y6s = parcelRequire("h2Y6s");

var $fdbAT = parcelRequire("fdbAT");
function $395ce53b4353da25$export$2e2bcd8739ae039({ day: [dayValue], month: [monthValue], year: [yearValue], selected: [selectedValue, setSelectedValue], previous: [, setPreviouslySelectedValue], onSelect: onSelect, navigate: navigate }) {
    const dateRef = (0, $eJOHy.useRef)({
        day: dayValue,
        month: monthValue,
        year: yearValue
    });
    (0, $eJOHy.useEffect)(()=>{
        dateRef.current = {
            day: dayValue,
            month: monthValue,
            year: yearValue
        };
    }, [
        dayValue,
        monthValue,
        yearValue
    ]);
    const triggerOnSelect = (0, $eJOHy.useCallback)(({ year: year, month: month, day: day })=>{
        const iso = (0, $fdbAT.default)({
            year: year,
            month: month,
            day: day
        });
        onSelect({
            day: day,
            month: month,
            year: year,
            iso: iso
        });
        setPreviouslySelectedValue(selectedValue);
        setSelectedValue([
            iso
        ]);
    }, [
        onSelect,
        selectedValue,
        setPreviouslySelectedValue,
        setSelectedValue
    ]);
    const handleClickDay = (0, $eJOHy.useCallback)(({ year: year, month: month, day: day })=>{
        triggerOnSelect({
            year: year,
            month: month,
            day: day
        });
    }, [
        triggerOnSelect
    ]);
    const handleContainerKeyDown = (0, $eJOHy.useCallback)((e)=>{
        const { key: key } = e;
        const arrowKey = (0, $h2Y6s.arrowKeys)[key];
        if (key === 'Enter' || key === ' ') {
            e.preventDefault();
            triggerOnSelect(dateRef.current);
        } else if (arrowKey) {
            e.preventDefault();
            navigate(arrowKey);
        }
    }, [
        triggerOnSelect,
        navigate
    ]);
    return {
        handleClickDay: handleClickDay,
        handleContainerKeyDown: handleContainerKeyDown
    };
}

});

parcelRegister("jtNxE", function(module, exports) {

$parcel$export(module.exports, "default", () => $01a6b7d4c4da291b$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $cK9J2 = parcelRequire("cK9J2");
function $01a6b7d4c4da291b$export$2e2bcd8739ae039({ locale: locale, weekStartDay: weekStartDay }) {
    const l10n = (0, $eJOHy.useMemo)(()=>(0, $cK9J2.createLocalizationProvider)(locale), [
        locale
    ]);
    const monthsLong = (0, $eJOHy.useMemo)(()=>l10n.getMonthsLong(), [
        l10n
    ]);
    const daysShort = (0, $eJOHy.useMemo)(()=>l10n.getDaysShort(weekStartDay), [
        l10n,
        weekStartDay
    ]);
    const daysLong = (0, $eJOHy.useMemo)(()=>l10n.getDaysLong(weekStartDay), [
        l10n,
        weekStartDay
    ]);
    return {
        monthsLong: monthsLong,
        daysShort: daysShort,
        daysLong: daysLong
    };
}

});


parcelRegister("7G7nX", function(module, exports) {

$parcel$export(module.exports, "default", () => $68ce7a484b05c143$export$2e2bcd8739ae039);
/* fixed-layer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $3Vuhz = parcelRequire("3Vuhz");

var $anoAR = parcelRequire("anoAR");

var $6G5P1 = parcelRequire("6G5P1");
var $8qmYl = parcelRequire("8qmYl");
var $azjc1 = parcelRequire("azjc1");
const $68ce7a484b05c143$var$styles = {
    root: "_bfhk18uv _kqswstnw _154ize3t",
    popperStyles: "_1pbyowjs"
};
class $68ce7a484b05c143$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    componentDidUpdate(prevProps) {
        if (prevProps.inputValue !== this.props.inputValue) this.update();
    }
    render() {
        const { containerRef: containerRef, content: content, testId: testId } = this.props;
        // Wait for containerRef callback to cause a re-render
        if (!containerRef) return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {});
        const divStyles = {
            height: containerRef.getBoundingClientRect().height,
            // Don't block the clear button
            width: containerRef.getBoundingClientRect().width - parseInt((0, $anoAR.sizes).small.slice(0, -2)) - 8
        };
        return(/* Need to wrap layer in a fixed position div so that it will render its content as fixed
       * We need to set the intial top value to where the container is and zIndex so that it still
       * applies since we're creating a new stacking context. */ /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6G5P1.Manager), {
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $azjc1.Reference), {
                    children: ({ ref: ref })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                            ref: ref,
                            "data-layer-child": true,
                            style: divStyles,
                            className: (0, $hcewu.default)([
                                $68ce7a484b05c143$var$styles.root
                            ])
                        })
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8qmYl.Popper), {
                    children: ({ ref: ref, style: style, update: update })=>{
                        this.update = update;
                        return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                            ref: ref,
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                            style: style,
                            "data-testid": testId && `${testId}--popper--container`,
                            className: (0, $hcewu.default)([
                                $68ce7a484b05c143$var$styles.popperStyles
                            ]),
                            children: content
                        });
                    }
                })
            ]
        }));
    }
    constructor(...args){
        super(...args), this.update = (0, $3Vuhz.default);
    }
}

});
parcelRegister("anoAR", function(module, exports) {

$parcel$export(module.exports, "sizes", () => $19bef17192bf3a9c$export$c647cb0ee6e282fe);
const $19bef17192bf3a9c$export$c647cb0ee6e282fe = {
    small: '16px',
    medium: '24px',
    large: '32px',
    xlarge: '48px'
};
const $19bef17192bf3a9c$export$7bd66fc94c81bf84 = {
    small: 'small',
    medium: 'medium',
    large: 'large',
    xlarge: 'xlarge'
};
const $19bef17192bf3a9c$export$62ad7b0c781000e9 = {
    small: {
        width: $19bef17192bf3a9c$export$c647cb0ee6e282fe.small,
        height: $19bef17192bf3a9c$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $19bef17192bf3a9c$export$c647cb0ee6e282fe.medium,
        height: $19bef17192bf3a9c$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $19bef17192bf3a9c$export$c647cb0ee6e282fe.large,
        height: $19bef17192bf3a9c$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $19bef17192bf3a9c$export$c647cb0ee6e282fe.xlarge,
        height: $19bef17192bf3a9c$export$c647cb0ee6e282fe.xlarge
    }
};

});



parcelRegister("1u9xN", function(module, exports) {

$parcel$export(module.exports, "getShortISOString", () => $a3c204a1b42604a4$export$77d5bc49fed7ef14);
$parcel$export(module.exports, "getSafeCalendarValue", () => $a3c204a1b42604a4$export$ff525416014fb67d);

var $57raR = parcelRequire("57raR");

var $5PwWU = parcelRequire("5PwWU");
function $a3c204a1b42604a4$export$77d5bc49fed7ef14(date) {
    return (0, $57raR.default)(date, (0, $5PwWU.convertTokens)('YYYY-MM-DD'));
}
function $a3c204a1b42604a4$export$ff525416014fb67d(calendarValue) {
    // If `calendarValue` has a year that is greater than 9999, default to
    // today's date
    const yearIsOverLimit = calendarValue.match(/^\d{5,}/);
    if (yearIsOverLimit) return $a3c204a1b42604a4$export$77d5bc49fed7ef14(new Date());
    return calendarValue;
}

});

parcelRegister("7OE9J", function(module, exports) {

$parcel$export(module.exports, "makeSingleValue", () => $8e54d9aa121b2675$export$6e30bf8cb1347b56);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6XEne = parcelRequire("6XEne");
const $8e54d9aa121b2675$export$6e30bf8cb1347b56 = ({ lang: lang })=>({ children: children, className: className, clearValue: clearValue, cx: cx, data: data, getStyles: getStyles, getValue: getValue, hasValue: hasValue, isDisabled: isDisabled, isMulti: isMulti, isRtl: isRtl, options: options, selectOption: selectOption, selectProps: selectProps, setValue: setValue, ...rest })=>{
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6XEne.components).SingleValue, {
            ...rest,
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            clearValue: clearValue,
            cx: cx,
            data: data,
            getStyles: getStyles,
            getValue: getValue,
            hasValue: hasValue,
            innerProps: {
                lang: lang
            },
            isDisabled: isDisabled,
            isMulti: isMulti,
            isRtl: isRtl,
            options: options,
            selectOption: selectOption,
            selectProps: selectProps,
            setValue: setValue,
            children: children
        });
    };

});


parcelRegister("k2Uo2", function(module, exports) {

$parcel$export(module.exports, "default", () => $00683ba6c52d5435$export$2e2bcd8739ae039);
/* date-picker-fc.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $dBLX0 = parcelRequire("dBLX0");
var $kQ82p = parcelRequire("kQ82p");

var $jrFnt = parcelRequire("jrFnt");

var $Ay1uj = parcelRequire("Ay1uj");

var $6qaBj = parcelRequire("6qaBj");

var $gl2vi = parcelRequire("gl2vi");

var $3GKOL = parcelRequire("3GKOL");

var $cK9J2 = parcelRequire("cK9J2");

var $eGOwo = parcelRequire("eGOwo");

var $8IeH1 = parcelRequire("8IeH1");

var $c4OV1 = parcelRequire("c4OV1");
var $e9zKl = parcelRequire("e9zKl");

var $RoXqn = parcelRequire("RoXqn");

var $47or1 = parcelRequire("47or1");

var $hmV0i = parcelRequire("hmV0i");

var $gNwsY = parcelRequire("gNwsY");

var $1u9xN = parcelRequire("1u9xN");

var $7OE9J = parcelRequire("7OE9J");
const $00683ba6c52d5435$var$packageName = "platform-pkg";
const $00683ba6c52d5435$var$packageVersion = "0.0.0-use.local";
const $00683ba6c52d5435$var$styles = {
    pickerContainerStyle: "_kqswh2mm",
    dropdownIndicatorStyles: "_1ul91k8s _1tke1k8s _1e0c1txw _4cvr1h6o _1bah1h6o",
    iconContainerStyles: "_v564vrg3 _1e0c1txw _4t3i1osq _kqswstnw _4cvr1h6o _i0dl1kw7 _syaz131l _152tze3t _rjxpze3t _30l31gjq",
    iconSpacingWithClearButtonStyles: "_12l2xy5q",
    iconSpacingWithoutClearButtonStyles: "_12l21b66"
};
const $00683ba6c52d5435$var$analyticsAttributes = {
    componentName: 'datePicker',
    packageName: $00683ba6c52d5435$var$packageName,
    packageVersion: $00683ba6c52d5435$var$packageVersion
}; /**
    * __Date picker__
    *
    * A date picker allows the user to select a particular date.
    *
    * - [Examples](https://atlassian.design/components/datetime-picker/date-picker/examples)
    * - [Code](https://atlassian.design/components/datetime-picker/date-picker/code)
    * - [Usage](https://atlassian.design/components/datetime-picker/date-picker/usage)
    */ 
const $00683ba6c52d5435$var$DatePicker = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, forwardedRef)=>{
    const containerRef = (0, $eJOHy.useRef)(null);
    const calendarRef = (0, $eJOHy.useRef)(null);
    const calendarButtonRef = (0, $eJOHy.useRef)(null);
    const { appearance: appearance = 'default', autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'Clear', hideIcon: hideIcon = false, openCalendarLabel: openCalendarLabel = 'Open calendar', defaultIsOpen: defaultIsOpen = false, defaultValue: defaultValue = '', disabled: disabled = [], disabledDateFilter: disabledDateFilter = (_)=>false, icon: Icon = (0, (/*@__PURE__*/$parcel$interopDefault($3GKOL))), id: id = '', innerProps: innerProps = {}, inputLabel: inputLabel = 'Date picker', inputLabelId: inputLabelId, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, label: label = '', name: name = '', onBlur: // eslint-disable-next-line @repo/internal/react/use-noop
    onBlur = (_event)=>{}, // eslint-disable-next-line @repo/internal/react/use-noop
    onChange: onChangeProp = (_value)=>{}, onFocus: // eslint-disable-next-line @repo/internal/react/use-noop
    onFocus = (_event)=>{}, selectProps: selectProps = {}, shouldShowCalendarButton: shouldShowCalendarButton, spacing: spacing = 'default', locale: propLocale = 'en-US', value: propValue, isOpen: isOpenProp, maxDate: maxDate, minDate: minDate, weekStartDay: weekStartDay, formatDisplayLabel: formatDisplayLabel, testId: testId, 'aria-describedby': ariaDescribedBy, placeholder: placeholder, nextMonthLabel: nextMonthLabel, previousMonthLabel: previousMonthLabel, ...rest } = props;
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(defaultIsOpen);
    const [_, setIsFocused] = (0, $eJOHy.useState)(false);
    const [clearingFromIcon, setClearingFromIcon] = (0, $eJOHy.useState)(false);
    const [selectInputValue, setSelectInputValue] = (0, $eJOHy.useState)(selectProps.inputValue);
    const [value, setValue] = (0, $eJOHy.useState)(propValue || defaultValue);
    const [calendarValue, setCalendarValue] = (0, $eJOHy.useState)(propValue || defaultValue || (0, $1u9xN.getShortISOString)(new Date()));
    const [l10n, setL10n] = (0, $eJOHy.useState)((0, $cK9J2.createLocalizationProvider)(propLocale));
    const [locale, setLocale] = (0, $eJOHy.useState)(propLocale);
    const [shouldSetFocusOnCurrentDay, setShouldSetFocusOnCurrentDay] = (0, $eJOHy.useState)(false);
    const [isKeyDown, setIsKeyDown] = (0, $eJOHy.useState)(false);
    const [wasOpenedFromCalendarButton, setWasOpenedFromCalendarButton] = (0, $eJOHy.useState)(false); // Hack to force update: https://legacy.reactjs.org/docs/hooks-faq.html#is-there-something-like-forceupdate
    const [, forceUpdate] = (0, $eJOHy.useReducer)((x)=>!x, true);
    const onChangePropWithAnalytics = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: onChangeProp,
        action: 'selectedDate',
        actionSubject: 'datePicker',
        ...$00683ba6c52d5435$var$analyticsAttributes
    });
    if (propLocale !== locale) {
        setL10n((0, $cK9J2.createLocalizationProvider)(propLocale));
        setLocale(propLocale);
    }
    (0, $eJOHy.useEffect)(()=>{
        // We don't want the focus to move if this is a click event
        if (!isKeyDown) return;
        if (isOpen && wasOpenedFromCalendarButton) {
            setIsKeyDown(false); // Focus on the first button within the calendar
            calendarRef?.current?.querySelector('button')?.focus();
        }
    }, [
        isKeyDown,
        calendarRef,
        isOpen,
        wasOpenedFromCalendarButton
    ]);
    const getValue = ()=>propValue ?? value;
    const getIsOpen = ()=>isOpenProp ?? isOpen;
    const onCalendarChange = ({ iso: iso })=>{
        setCalendarValue((0, $47or1.getParsedISO)({
            iso: iso
        }));
    };
    const onCalendarSelect = ({ iso: iso })=>{
        setSelectInputValue('');
        setIsOpen(false);
        setCalendarValue(iso);
        setValue(iso);
        setWasOpenedFromCalendarButton(false);
        onChangePropWithAnalytics(iso); // Yes, this is not ideal. The alternative is to be able to place a ref
        // on the inner input of Select itself, which would require a lot of
        // extra stuff in the Select component for only this one thing. While
        // this would be more "React-y", it doesn't seem to pose any other
        // benefits. Performance-wise, we are only searching within the
        // container, so it's quick.
        if (wasOpenedFromCalendarButton) calendarButtonRef.current?.focus();
        else {
            const innerCombobox = containerRef?.current?.querySelector('[role="combobox"]');
            innerCombobox?.focus();
        }
        setIsOpen(false);
    };
    const onInputClick = ()=>{
        if (!isDisabled && !getIsOpen()) {
            setIsOpen(true);
            setWasOpenedFromCalendarButton(false);
        }
    };
    const onContainerBlur = (event)=>{
        const newlyFocusedElement = event.relatedTarget;
        if (!containerRef?.current?.contains(newlyFocusedElement)) {
            setIsOpen(false);
            setShouldSetFocusOnCurrentDay(false);
            setWasOpenedFromCalendarButton(false);
            onBlur(event);
        }
    };
    const onContainerFocus = ()=>{
        setShouldSetFocusOnCurrentDay(false);
    };
    const onSelectBlur = (event)=>{
        const newlyFocusedElement = event.relatedTarget;
        if (clearingFromIcon) // Don't close menu if blurring after the user has clicked clear
        setClearingFromIcon(false);
        else if (!containerRef?.current?.contains(newlyFocusedElement)) {
            // Don't close menu if focus is staying within the date picker's
            // container. Makes keyboard accessibility of calendar possible
            setIsOpen(false);
            setIsFocused(false);
            setWasOpenedFromCalendarButton(false);
        }
    };
    const onSelectFocus = (event)=>{
        const value = getValue();
        if (clearingFromIcon) // Don't open menu if focussing after the user has clicked clear
        setClearingFromIcon(false);
        else {
            // Don't open when focused into via keyboard if the calendar button is present
            setIsOpen(!shouldShowCalendarButton);
            setCalendarValue(value);
            setIsFocused(true);
            setWasOpenedFromCalendarButton(false);
        }
        onFocus(event);
    };
    const onTextInput = (event)=>{
        const inputValue = event.target.value;
        if (inputValue) {
            const parsed = (0, $47or1.parseDate)(inputValue, {
                parseInputValue: rest?.parseInputValue,
                dateFormat: rest?.dateFormat,
                l10n: l10n
            }); // Only try to set the date if we have month & day
            if (parsed && (0, $dBLX0.default)(parsed)) // We format the parsed date to YYYY-MM-DD here because
            // this is the format expected by the @atlaskit/calendar component
            setCalendarValue((0, $1u9xN.getShortISOString)(parsed));
        }
        setIsOpen(true);
        setWasOpenedFromCalendarButton(false);
    };
    const onInputKeyDown = (event)=>{
        const value = getValue();
        const keyPressed = event.key.toLowerCase(); // If the input is focused and the calendar is not visible, handle space and enter clicks
        if (!isOpen && (keyPressed === 'enter' || keyPressed === ' ')) {
            setIsOpen(true);
            setWasOpenedFromCalendarButton(false);
        }
        switch(keyPressed){
            case 'escape':
                // Yes, this is not ideal. The alternative is to be able to place a ref
                // on the inner input of Select itself, which would require a lot of
                // extra stuff in the Select component for only this one thing. While
                // this would be more "React-y", it doesn't seem to pose any other
                // benefits. Performance-wise, we are only searching within the
                // container, so it's quick.
                if (wasOpenedFromCalendarButton) calendarButtonRef.current?.focus();
                else {
                    const innerCombobox = containerRef?.current?.querySelector('[role="combobox"]');
                    innerCombobox?.focus();
                }
                setIsOpen(false);
                setShouldSetFocusOnCurrentDay(false);
                setWasOpenedFromCalendarButton(false);
                break;
            case 'backspace':
            case 'delete':
                {
                    const inputCount = 0;
                    if (value && event.target instanceof HTMLInputElement && event.target.value.length <= inputCount) {
                        // If being cleared from keyboard, don't change behaviour
                        setClearingFromIcon(false);
                        setValue('');
                    }
                    break;
                }
            case 'enter':
                if (!isOpen) return;
                 // Prevent form submission when a date is selected
                // using enter. See https://product-fabric.atlassian.net/browse/DSP-2501
                // for more details.
                event.preventDefault();
                if (!(0, $47or1.isDateDisabled)(calendarValue, {
                    disabled: disabled
                })) {
                    // Get a safe `calendarValue` in case the value exceeds the maximum
                    // allowed by ISO 8601
                    const safeCalendarValue = (0, $1u9xN.getSafeCalendarValue)(calendarValue);
                    const valueChanged = safeCalendarValue !== value;
                    setSelectInputValue('');
                    setIsOpen(false);
                    setValue(safeCalendarValue);
                    setCalendarValue(safeCalendarValue);
                    setWasOpenedFromCalendarButton(wasOpenedFromCalendarButton);
                    if (valueChanged) onChangePropWithAnalytics(safeCalendarValue);
                }
                break;
            case 'arrowdown':
            case 'arrowup':
                if (!shouldSetFocusOnCurrentDay) {
                    setIsOpen(true);
                    setShouldSetFocusOnCurrentDay(true);
                }
                break;
            default:
                break;
        }
    };
    const onCalendarButtonKeyDown = (e)=>{
        // Don't allow an arrow up or down to open the menu, since the input key
        // down handler is actually on the parent.
        if (e.type === 'keydown' && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) e.stopPropagation();
         // We want to stop this from triggering other keydown events, particularly
        // for space and enter presses. Otherwise, it opens and then closes
        // immediately.
        if (e.type === 'keydown' && (e.key === ' ' || e.key === 'Enter')) {
            e.stopPropagation();
            setIsKeyDown(true);
            setWasOpenedFromCalendarButton(true);
        }
    }; // This event handler is triggered from both keydown and click. It's weird.
    const onCalendarButtonClick = (e)=>{
        setIsOpen((isOpen)=>{
            if (isOpen) {
                (0, $eGOwo.fg)('platform_dst_menuonclose_fix') && props.selectProps?.onMenuClose?.();
                return false;
            } else {
                (0, $eGOwo.fg)('platform_dst_menuonclose_fix') && props.selectProps?.onMenuOpen?.();
                return true;
            }
        });
        setWasOpenedFromCalendarButton(true);
        e.stopPropagation();
    };
    const onClear = ()=>{
        setValue('');
        setCalendarValue(defaultValue || (0, $1u9xN.getShortISOString)(new Date()));
        if (!hideIcon) setClearingFromIcon(true);
        onChangePropWithAnalytics('');
    }; // `unknown` is used because `value` is unused so it does not matter.
    const onSelectChange = (_value, action)=>{
        // Used for native clear event in React Select
        // Triggered when clicking ClearIndicator or backspace with no value
        if (action.action === 'clear') onClear();
    };
    const handleSelectInputChange = (selectInputValue, actionMeta)=>{
        if (selectProps.onInputChange) selectProps.onInputChange(selectInputValue, actionMeta);
        setSelectInputValue(selectInputValue);
    };
    const getContainerRef = (0, $eJOHy.useCallback)((ref)=>{
        const oldRef = containerRef.current;
        containerRef.current = ref; // Cause a re-render if we're getting the container ref for the first time
        // as the layered menu requires it for dimension calculation
        if (oldRef == null && ref != null) forceUpdate();
    }, [
        containerRef
    ]);
    const getterValue = getValue();
    let actualSelectInputValue;
    actualSelectInputValue = selectInputValue;
    const menuIsOpen = getIsOpen() && !isDisabled;
    const showClearIndicator = Boolean((getterValue || selectInputValue) && !hideIcon);
    let clearIndicator = Icon; // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if ((0, $eGOwo.fg)('platform-visual-refresh-icons')) clearIndicator = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
            xcss: $00683ba6c52d5435$var$styles.dropdownIndicatorStyles,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)(Icon, {
                ...props
            })
        });
    const dropDownIcon = appearance === 'subtle' || hideIcon || showClearIndicator ? null : clearIndicator;
    const SingleValue = (0, $7OE9J.makeSingleValue)({
        lang: propLocale
    });
    const selectComponents = {
        ...selectProps.components,
        DropdownIndicator: shouldShowCalendarButton ? (0, $RoXqn.EmptyComponent) : dropDownIcon,
        // Only use this new container component if the calendar button is shown.
        // Otherwise, it throws errors downstream for some reason
        ...shouldShowCalendarButton ? {
            IndicatorsContainer: (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $hmV0i.IndicatorsContainer), {
                    ...props,
                    showClearIndicator: showClearIndicator
                })
        } : {},
        Menu: $gNwsY.Menu,
        SingleValue: SingleValue,
        ...!showClearIndicator && {
            ClearIndicator: (0, $RoXqn.EmptyComponent)
        }
    };
    const { styles: selectStyles = {} } = selectProps;
    const disabledStyle = isDisabled ? {
        pointerEvents: 'none',
        color: "var(--ds-icon-disabled, inherit)"
    } : {};
    const calendarProps = {
        calendarContainerRef: containerRef.current,
        calendarDisabled: disabled,
        calendarDisabledDateFilter: disabledDateFilter,
        calendarMaxDate: maxDate,
        calendarMinDate: minDate,
        calendarRef: calendarRef,
        calendarValue: getterValue && (0, $1u9xN.getShortISOString)((0, $kQ82p.default)(getterValue)),
        calendarView: calendarValue,
        onCalendarChange: onCalendarChange,
        onCalendarSelect: onCalendarSelect,
        calendarLocale: locale,
        calendarWeekStartDay: weekStartDay,
        shouldSetFocusOnCurrentDay: shouldSetFocusOnCurrentDay,
        /**
     * This overrides the inner wrapper the Calendar.
     * @private Please use this with extreme caution, this API may be changed in the future.
     */ menuInnerWrapper: props?.menuInnerWrapper
    }; // @ts-ignore -- Argument of type 'StylesConfig<OptionType, false, GroupBase<OptionType>>' is not assignable to parameter of type 'StylesConfig<OptionType, boolean, GroupBase<OptionType>>'.
    const mergedStyles = (0, $e9zKl.mergeStyles)(selectStyles, {
        control: (base)=>({
                ...base,
                ...disabledStyle
            }),
        indicatorsContainer: (base)=>({
                ...base,
                paddingLeft: "var(--ds-space-025, 2px)",
                // ICON_PADDING = 2
                paddingRight: "var(--ds-space-075, 6px)" // 8 - ICON_PADDING = 6
            })
    });
    const initialValue = getterValue ? {
        label: (0, $47or1.formatDate)(getterValue, {
            formatDisplayLabel: formatDisplayLabel,
            dateFormat: rest?.dateFormat,
            l10n: l10n
        }),
        value: getterValue
    } : null; // `label` takes precedence of the `inputLabel`
    const fullopenCalendarLabel = label || inputLabel ? `${label || inputLabel}, ${openCalendarLabel}` : openCalendarLabel;
    const openCalendarLabelId = `open-calendar-label--${(0, $gl2vi.useId)()}`;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        ...innerProps,
        "data-testid": testId && `${testId}--container`,
        onBlur: onContainerBlur,
        onFocus: onContainerFocus,
        onClick: onInputClick,
        onInput: onTextInput,
        onKeyDown: onInputKeyDown,
        ref: getContainerRef,
        role: "presentation",
        className: (0, $hcewu.default)([
            $00683ba6c52d5435$var$styles.pickerContainerStyle
        ]),
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("input", {
                name: name,
                type: "hidden",
                value: getterValue,
                "data-testid": testId && `${testId}--input`
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $c4OV1.default), {
                appearance: appearance,
                "aria-describedby": ariaDescribedBy,
                label: label || undefined,
                autoFocus: autoFocus,
                clearControlLabel: clearControlLabel,
                closeMenuOnSelect: true,
                enableAnimation: false,
                inputId: id,
                inputValue: actualSelectInputValue,
                isDisabled: isDisabled,
                isRequired: isRequired,
                menuIsOpen: menuIsOpen,
                onBlur: onSelectBlur,
                onChange: onSelectChange,
                onFocus: onSelectFocus,
                onInputChange: handleSelectInputChange,
                placeholder: (0, $47or1.getPlaceholder)({
                    placeholder: placeholder,
                    l10n: l10n
                }),
                // @ts-ignore -- Type 'OptionType' is not assignable to type '{ label: string; value: string; }'
                styles: mergedStyles,
                value: initialValue,
                ...selectProps,
                // up when you alter some of the properties in the `selectComponents`
                // object. These errors are still present, and I suspect have always
                // been present, without changing the unrelated code. Ignoring as the
                // component still works as expected despite this error. And also
                // because the select refresh team may solve it later.
                components: selectComponents,
                // selectProps or not and what wil be overwritten
                isClearable: true,
                isInvalid: isInvalid,
                spacing: spacing,
                testId: testId,
                // @ts-ignore --  Property 'calendarContainerRef' does not exist on type 'IntrinsicAttributes & LibraryManagedAttributes<(<Option extends unknown = OptionType, IsMulti extends boolean = false>(props: AtlaskitSelectProps<Option, IsMulti> & { ...; }) => Element), AtlaskitSelectProps<...> & { ...; }>'.
                calendarContainerRef: calendarProps.calendarContainerRef,
                calendarDisabled: calendarProps.calendarDisabled,
                calendarDisabledDateFilter: calendarProps.calendarDisabledDateFilter,
                calendarLocale: calendarProps.calendarLocale,
                calendarMaxDate: calendarProps.calendarMaxDate,
                calendarMinDate: calendarProps.calendarMinDate,
                calendarRef: calendarProps.calendarRef,
                calendarValue: calendarProps.calendarValue,
                calendarView: calendarProps.calendarView,
                calendarWeekStartDay: calendarProps.calendarWeekStartDay,
                nextMonthLabel: nextMonthLabel,
                onCalendarChange: calendarProps.onCalendarChange,
                onCalendarSelect: calendarProps.onCalendarSelect,
                previousMonthLabel: previousMonthLabel,
                shouldSetFocusOnCurrentDay: calendarProps.shouldSetFocusOnCurrentDay,
                menuInnerWrapper: calendarProps.menuInnerWrapper
            }),
            shouldShowCalendarButton && !isDisabled ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                xcss: (0, $6qaBj.cx)($00683ba6c52d5435$var$styles.iconContainerStyles, value && !hideIcon ? $00683ba6c52d5435$var$styles.iconSpacingWithClearButtonStyles : $00683ba6c52d5435$var$styles.iconSpacingWithoutClearButtonStyles),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                    appearance: "subtle",
                    label: !inputLabelId ? fullopenCalendarLabel : openCalendarLabel,
                    "aria-labelledby": inputLabelId ? `${inputLabelId} ${openCalendarLabelId}` : undefined,
                    id: openCalendarLabelId,
                    icon: (iconProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3GKOL))), {
                            ...iconProps,
                            color: "var(--ds-icon, #44546F)"
                        }),
                    onClick: onCalendarButtonClick,
                    onKeyDown: onCalendarButtonKeyDown,
                    ref: calendarButtonRef,
                    testId: testId && `${testId}--open-calendar-button`
                })
            }) : null
        ]
    });
});
var $00683ba6c52d5435$export$2e2bcd8739ae039 = $00683ba6c52d5435$var$DatePicker;

});


parcelRegister("iw2hI", function(module, exports) {

$parcel$export(module.exports, "standardizeLocale", () => $07e147bc3d7cc59d$export$ca06804549ae25fb);
$parcel$export(module.exports, "verifyTimeZone", () => $07e147bc3d7cc59d$export$93ff13646da25bd);

var $4qiFT = parcelRequire("4qiFT");

var $eSnSE = parcelRequire("eSnSE");
const $07e147bc3d7cc59d$export$95b7602913551865 = 'en-US';
const $07e147bc3d7cc59d$export$ca06804549ae25fb = (jiraLocale)=>{
    if (typeof jiraLocale !== 'string') {
        (0, $eSnSE.default).safeErrorWithoutCustomerData('jira-issue-format-date.standardize-locale', `Invalid input type for locale was passed in: ${jiraLocale}. Falling back to ${$07e147bc3d7cc59d$export$95b7602913551865}.`);
        return $07e147bc3d7cc59d$export$95b7602913551865;
    }
    const standardizedLocale = jiraLocale.replace('_', '-');
    switch(standardizedLocale){
        case 'en':
            return 'en-US';
        case 'en-UK':
            return 'en-GB';
        default:
            if (!(0, $4qiFT.default).includes(jiraLocale)) (0, $eSnSE.default).safeWarnWithoutCustomerData('jira-issue-format-date.standardize-locale', `Discovered unsupported locale: ${jiraLocale}. This value was not modified, but its use may lead to unpredictable behaviour for formatting.`);
            return standardizedLocale;
    }
};
const $07e147bc3d7cc59d$export$93ff13646da25bd = (timeZone)=>{
    try {
        Intl.DateTimeFormat($07e147bc3d7cc59d$export$95b7602913551865, {
            timeZone: timeZone
        });
        return timeZone;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $eSnSE.default).safeErrorWithoutCustomerData('jira-issue-format-date.verify-time-zone', `Invalid timeZone: ${String(timeZone)}. Date time formatting cannot be performed with this value. Falling back to undefined`, error);
        return undefined;
    }
};

});

parcelRegister("ibskQ", function(module, exports) {

$parcel$export(module.exports, "preventFormSubmitOnEnterKeyPress", () => $a8d6448c7922d4c1$export$9d2267fe165de4b6);
const $a8d6448c7922d4c1$export$9d2267fe165de4b6 = (event)=>{
    event.key === 'Enter' && event.preventDefault();
};

});

parcelRegister("55167", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b31dccaf31190aa$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $1b31dccaf31190aa$var$messages = (0, $7qGN1.defineMessages)({
    placeholder: {
        "id": "issue-create-commons.date-field.placeholder",
        "defaultMessage": "Select date"
    },
    ariaLabel: {
        "id": "issue-create-commons.date-field.aria-label",
        "defaultMessage": "Enter a Date"
    }
});
var $1b31dccaf31190aa$export$2e2bcd8739ae039 = $1b31dccaf31190aa$var$messages;

});


parcelRegister("cD5DT", function(module, exports) {

$parcel$export(module.exports, "mutateDateField", () => $a98c193430921541$export$cc256064cc35499f);
$parcel$export(module.exports, "transformDate", () => $a98c193430921541$export$57e73ea84b51baf0);

var $57raR = parcelRequire("57raR");

var $kQ82p = parcelRequire("kQ82p");

const $a98c193430921541$export$cc256064cc35499f = (date, fieldId)=>{
    const dateInputFormat = 'yyyy-MM-dd';
    return {
        fieldId: fieldId,
        date: {
            formattedDate: (0, $57raR.default)((0, $kQ82p.default)(date), dateInputFormat)
        },
        mutationGroup: (0, $219bc535a3c5fb65$export$31fd86f8f183952c)
    };
};
const $a98c193430921541$export$57e73ea84b51baf0 = (date)=>date || null;

});
const $219bc535a3c5fb65$export$31fd86f8f183952c = 'datePickerFields';


parcelRegister("8eZP2", function(module, exports) {

$parcel$export(module.exports, "default", () => $36f150938baef381$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $aFlwJ = parcelRequire("aFlwJ");

var $ch9En = parcelRequire("ch9En");

var $lGaCn = parcelRequire("lGaCn");

var $fE4zR = parcelRequire("fE4zR");

var $2nXHu = parcelRequire("2nXHu");

var $ibskQ = parcelRequire("ibskQ");

var $4yQUm = parcelRequire("4yQUm");

var $ikdY7 = parcelRequire("ikdY7");

const $36f150938baef381$export$ae1ced156568f0b0 = (props)=>{
    const { autoFocus: autoFocus = false, width: width, fieldProps: { value: value, onChange: onChange, isDisabled: isDisabled, ...fieldProps }, error: error, isReadOnly: isReadOnly = false, fieldName: fieldName } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const handleChange = (dateTimeValue)=>{
        onChange(dateTimeValue || '');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fE4zR.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "date-time-field-edit-view",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lGaCn.FieldLoader), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aFlwJ.AsyncDateTimeFieldEditView), {
        label: fieldName,
        ...fieldProps,
        isDisabled: isDisabled || isReadOnly,
        autoFocus: autoFocus,
        value: value,
        onChange: handleChange,
        isInvalid: Boolean(error),
        datePickerProps: {
            selectProps: {
                onKeyDown: (0, $ibskQ.preventFormSubmitOnEnterKeyPress)
            },
            placeholder: formatMessage((0, $ikdY7.default).datePickerPlaceholder)
        },
        timePickerProps: {
            placeholder: formatMessage((0, $ikdY7.default).timePickerPlaceholder)
        }
    })));
};
var $36f150938baef381$export$2e2bcd8739ae039 = (0, $2nXHu.withFormField)({
    validator: (0, $4yQUm.validateString)
})(// @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element' is not assignable to parameter of type 'AbstractComponent<ComponentProps<DateTimeFieldConfig, FieldValue>, any>'.
$36f150938baef381$export$ae1ced156568f0b0);

});
parcelRegister("aFlwJ", function(module, exports) {

$parcel$export(module.exports, "AsyncDateTimeFieldEditView", () => $107a7005222b1ece$export$657a1b8545a979b8);

var $eJOHy = parcelRequire("eJOHy");

var $9A8Wt = parcelRequire("9A8Wt");

var $cBavF = parcelRequire("cBavF");

var $bbdV2 = parcelRequire("bbdV2");

var $hFOCU = parcelRequire("hFOCU");
const $107a7005222b1ece$var$EMPTY_OBJECT = {};
const $107a7005222b1ece$export$657a1b8545a979b8 = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $hFOCU.asyncDateTimeFieldEditViewEntrypoint), // use stable reference to avoid re-renders
    $107a7005222b1ece$var$EMPTY_OBJECT);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eJOHy.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        id: "async-jira-issue-field-date-time-edit-view",
        packageName: "jira-issue-field-date-time",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: props,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9A8Wt.SkeletonCompiled), {
            width: "350px",
            height: "40px"
        }),
        errorFallback: "unmount"
    });
};

});
parcelRegister("hFOCU", function(module, exports) {

$parcel$export(module.exports, "asyncDateTimeFieldEditViewEntrypoint", () => $ff0fc100cb3637bf$export$971e82244ad6d423);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $ff0fc100cb3637bf$export$971e82244ad6d423 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("heQ6y")).then((module)=>module.DateTimeFieldEditViewEntryPointContent), {
        moduleId: "267b9282",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("heQ6y", function(module, exports) {

let $c8cc295c3b17cf3d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $c8cc295c3b17cf3d$var$load("IQIOD").then(()=>parcelRequire('hKLwM'));

});



parcelRegister("ikdY7", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f104d896e282b28$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $1f104d896e282b28$var$messages = (0, $7qGN1.defineMessages)({
    datePickerPlaceholder: {
        "id": "issue-create-commons.date-time-field.date-picker-placeholder",
        "defaultMessage": "Select date"
    },
    timePickerPlaceholder: {
        "id": "issue-create-commons.date-time-field.time-picker-placeholder",
        "defaultMessage": "Select time"
    }
});
var $1f104d896e282b28$export$2e2bcd8739ae039 = $1f104d896e282b28$var$messages;

});


parcelRegister("lumDD", function(module, exports) {

$parcel$export(module.exports, "mutateDateTimeField", () => $c8a1168450718b24$export$c17fd814c724a443);

var $57raR = parcelRequire("57raR");

var $kQ82p = parcelRequire("kQ82p");

const $c8a1168450718b24$export$c17fd814c724a443 = (date, fieldId)=>{
    const dateTimeInputFormat = "yyyy-MM-dd'T'HH:mm:ssXXX";
    return {
        fieldId: fieldId,
        dateTime: {
            formattedDateTime: (0, $57raR.default)((0, $kQ82p.default)(date), dateTimeInputFormat)
        },
        mutationGroup: (0, $95af0b48d97e4a92$export$31fd86f8f183952c)
    };
};

});
const $95af0b48d97e4a92$export$31fd86f8f183952c = 'dateTimePickerFields';


parcelRegister("cDYPA", function(module, exports) {

$parcel$export(module.exports, "transformDefaultEpicValue", () => $e86338946501b1d0$export$d1fe9e25b0dbb9af);
$parcel$export(module.exports, "mutateEpicLinkField", () => $e86338946501b1d0$export$5e81faed0a30e719);
const $e86338946501b1d0$export$d1fe9e25b0dbb9af = ({ key: key, summary: summary })=>({
        label: summary,
        value: key
    });
const $e86338946501b1d0$export$5e81faed0a30e719 = ({ value: value }, fieldId)=>({
        epicLinkField: {
            fieldId: fieldId,
            epicLink: {
                issueKey: value
            }
        }
    });

});

parcelRegister("93gMe", function(module, exports) {

$parcel$export(module.exports, "default", () => $020b63b9ddc98882$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $86tBw = parcelRequire("86tBw");

var $7jTnu = parcelRequire("7jTnu");

var $dTocu = parcelRequire("dTocu");

var $6TzwE = parcelRequire("6TzwE");

var $dXi8G = parcelRequire("dXi8G");

var $fE4zR = parcelRequire("fE4zR");

var $2nXHu = parcelRequire("2nXHu");

var $ixdDB = parcelRequire("ixdDB");

var $8eQep = parcelRequire("8eQep");

var $5fZlk = parcelRequire("5fZlk");
const $020b63b9ddc98882$export$5939eb0b0c440cdc = (props)=>{
    const { autoCompleteUrl: autoCompleteUrl, width: width, fieldId: fieldId, allowedValues: allowedValues, autoFocus: autoFocus = false, fieldProps: { value: value, onChange: onChange, id: id, isRequired: isRequired }, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, $ixdDB.closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, isCreateLinkedIssue: isCreateLinkedIssue = false, additionalData: additionalData, ariaLabelledBy: ariaLabelledBy } = props;
    const { formatMessage: formatMessage } = (0, $dTocu.useIntlV2)();
    const options = (0, $dXi8G.mapDataToOptions)(allowedValues);
    // According to the new implemented logic, the initial values of the checkboxes will be determined by the BE payload.
    // If the response from the BE is null, we wont display the checkbox
    // if it's false, we'll display it and mark it unchecked
    // it it's true, we'll display it and mark it checked
    const { copyLinks: copyLinks, copyAttachments: copyAttachments } = additionalData?.copyLinksAndAttachments || {};
    const hasUpdatedInitialLinks = (0, $eJOHy.useRef)(false);
    (0, $eJOHy.useEffect)(()=>{
        /**
     * With concurrent, onChange is changing every render and value is not updated,
     * so we get an infinite loop in this useEffect.
     *
     * This ref is used to avoid this infinite loop.
     */ if (hasUpdatedInitialLinks.current) return;
        if (isCreateLinkedIssue && (0, $7jTnu.fg)('create_linked_issues_trigger_point_issue_view')) {
            if (value?.includeAttachments === undefined && value?.includeLinks === undefined) {
                onChange({
                    ...value || {},
                    includeLinks: copyLinks || false,
                    includeAttachments: copyAttachments || false
                });
                hasUpdatedInitialLinks.current = true;
            }
        }
    }, [
        copyAttachments,
        copyLinks,
        isCreateLinkedIssue,
        onChange,
        value
    ]);
    const onIssueLinksEditChange = (newValue)=>{
        value && onChange({
            ...value || {},
            ...newValue
        });
    };
    const onIncludeAttachmentsChange = (e)=>{
        value && onChange({
            ...value,
            includeAttachments: e.currentTarget.checked
        });
    };
    const onIncludeLinksChange = (e)=>{
        value && onChange({
            ...value,
            includeLinks: e.currentTarget.checked
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fE4zR.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6TzwE.IssueLinksEdit), {
        linkTypeOptions: options,
        autoFocus: autoFocus,
        autoCompleteUrl: autoCompleteUrl,
        onChange: isCreateLinkedIssue && (0, $7jTnu.fg)('create_linked_issues_trigger_point_issue_view') ? onIssueLinksEditChange : onChange,
        fetchSuggestionsOnMount: false,
        value: value,
        fieldId: fieldId,
        onCloseMenuOnScroll: onCloseMenuOnScroll,
        isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
        inputId: id,
        isRequired: isRequired,
        ariaLabelledBy: ariaLabelledBy,
        ariaLabel: formatMessage((0, $8eQep.default).ariaLabel)
    }), isCreateLinkedIssue && (0, $7jTnu.fg)('create_linked_issues_trigger_point_issue_view') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($020b63b9ddc98882$var$CheckboxWrapper, null, additionalData?.copyLinksAndAttachments !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86tBw.default), {
        onChange: onIncludeLinksChange,
        label: formatMessage((0, $8eQep.default).includeLinks),
        isChecked: value?.includeLinks || false
    }), additionalData?.copyLinksAndAttachments !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86tBw.default), {
        onChange: onIncludeAttachmentsChange,
        label: formatMessage((0, $8eQep.default).includeAttachments),
        isChecked: value?.includeAttachments || false
    })));
};
var $020b63b9ddc98882$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $2nXHu.withFormField)({
    transformDefaultValue: (0, $5fZlk.transformDefaultIssueLinksValue),
    validator: (0, $5fZlk.validateIssueLinksField // @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element' is not assignable to parameter of type 'AbstractComponent<ComponentProps<IssueLinksFieldConfig, IssueLink>, any>'.
    )
})($020b63b9ddc98882$export$5939eb0b0c440cdc);
const $020b63b9ddc98882$var$CheckboxWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_zulp1b66 _1e0c1txw _2lx21bp4 _ca0q1b66 _19bv1b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6TzwE", function(module, exports) {

$parcel$export(module.exports, "IssueLinksEdit", () => $bd78280c477bbc4d$export$4db6edf6dd313d5a);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $l821w = parcelRequire("l821w");

var $8oaSP = parcelRequire("8oaSP");
const $bd78280c477bbc4d$export$4db6edf6dd313d5a = (props)=>{
    const { fieldId: fieldId, autoCompleteUrl: autoCompleteUrl, onChange: onChange, linkTypeOptions: linkTypeOptions, autoFocus: autoFocus = false, value: value, fetchSuggestionsOnMount: fetchSuggestionsOnMount, onCloseMenuOnScroll: onCloseMenuOnScroll, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, isDisabled: isDisabled, isRequired: isRequired, inputId: inputId, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy } = props;
    const onLinkTypeChange = (val)=>{
        onChange({
            linkType: val,
            issues: value ? value.issues : []
        });
    };
    const onLinkSearchChange = (val)=>{
        if (value) onChange({
            linkType: value.linkType,
            issues: val
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bd78280c477bbc4d$var$FlexColumn, {
        "data-testid": "issue-field-issue-links.ui.edit.issue-links"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $l821w.default), {
        options: linkTypeOptions,
        autoFocus: autoFocus,
        value: value ? value.linkType : undefined,
        onChange: onLinkTypeChange,
        onCloseMenuOnScroll: onCloseMenuOnScroll,
        isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
        isDisabled: isDisabled,
        inputId: inputId,
        isRequired: isRequired,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8oaSP.default), {
        fieldId: fieldId,
        value: value ? value.issues : undefined,
        fetchSuggestionsOnMount: fetchSuggestionsOnMount,
        autoCompleteUrl: autoCompleteUrl,
        onChange: onLinkSearchChange,
        onCloseMenuOnScroll: onCloseMenuOnScroll,
        isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
        isDisabled: isDisabled
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bd78280c477bbc4d$var$FlexColumn = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});

});
parcelRegister("l821w", function(module, exports) {

$parcel$export(module.exports, "default", () => $634a4d7f2e2e8d3b$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $c4OV1 = parcelRequire("c4OV1");

var $aUMMA = parcelRequire("aUMMA");

var $7jTnu = parcelRequire("7jTnu");
const $634a4d7f2e2e8d3b$var$IssueLinksTypeControl = (props)=>{
    const { options: options, value: value, onChange: onChange, autoFocus: autoFocus = false, onCloseMenuOnScroll: onCloseMenuOnScroll, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, isDisabled: isDisabled, inputId: inputId, isRequired: isRequired, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy } = props;
    (0, $eJOHy.useEffect)(()=>{
        if (value === undefined) onChange(options[0]);
    }, [
        value,
        onChange,
        options
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $634a4d7f2e2e8d3b$var$linkTypeWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c4OV1.default), {
        inputId: inputId,
        required: isRequired,
        options: options,
        value: value,
        // @ts-expect-error - TS2322 - Type '(arg1: IssueLinkType) => void' is not assignable to type '(value: IssueLinkType | null, action: ActionMeta<IssueLinkType>) => void'.
        onChange: onChange,
        isMulti: false,
        autoFocus: autoFocus,
        defaultValue: options[0],
        closeMenuOnScroll: onCloseMenuOnScroll,
        styles: (0, $aUMMA.defaultSelectStyles),
        menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
        isDisabled: isDisabled,
        classNamePrefix: "issue-link-type",
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy
    }));
};
const $634a4d7f2e2e8d3b$var$IssueLinksTypeExperiment = (props)=>{
    const { options: options, value: value, onChange: onChange, autoFocus: autoFocus = false, onCloseMenuOnScroll: onCloseMenuOnScroll, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, isDisabled: isDisabled, inputId: inputId, isRequired: isRequired, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy } = props;
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (value === undefined) onChange(options[0]);
    }, [
        value,
        onChange,
        options
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $634a4d7f2e2e8d3b$var$linkTypeWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c4OV1.default), {
        inputId: inputId,
        required: isRequired,
        options: options,
        value: value,
        // @ts-expect-error - TS2322 - Type '(arg1: IssueLinkType) => void' is not assignable to type '(value: IssueLinkType | null, action: ActionMeta<IssueLinkType>) => void'.
        onChange: onChange,
        isMulti: false,
        autoFocus: autoFocus,
        defaultValue: options[0],
        closeMenuOnScroll: onCloseMenuOnScroll,
        styles: (0, $aUMMA.defaultSelectStyles),
        menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
        isDisabled: isDisabled,
        classNamePrefix: "issue-link-type",
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy
    }));
};
const $634a4d7f2e2e8d3b$var$IssueLinksType = (props)=>{
    if ((0, $7jTnu.fg)('create_another_issue_react_18_fix')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($634a4d7f2e2e8d3b$var$IssueLinksTypeExperiment, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($634a4d7f2e2e8d3b$var$IssueLinksTypeControl, props);
};
var $634a4d7f2e2e8d3b$export$2e2bcd8739ae039 = $634a4d7f2e2e8d3b$var$IssueLinksType;
const $634a4d7f2e2e8d3b$var$linkTypeWrapperStyles = (0, $1DXK0.xcss)({
    width: '100%',
    marginBottom: 'space.100'
});

});

parcelRegister("8oaSP", function(module, exports) {

$parcel$export(module.exports, "default", () => $5191b3581619bfc2$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $7jTnu = parcelRequire("7jTnu");

var $jGzN3 = parcelRequire("jGzN3");

var $lRq8t = parcelRequire("lRq8t");

var $jZPPe = parcelRequire("jZPPe");

var $epTsa = parcelRequire("epTsa");

var $bNexr = parcelRequire("bNexr");

var $ln6Iy = parcelRequire("ln6Iy");

var $bmoS1 = parcelRequire("bmoS1");

var $e9fnY = parcelRequire("e9fnY");

var $ifdhL = parcelRequire("ifdhL");
const $5191b3581619bfc2$var$getAriaLabelAndPlaceholder = ({ isJSMProject: isJSMProject, formatMessage: formatMessage })=>{
    if (!isJSMProject && (0, $epTsa.expVal)('enhanced_multiselect_linking_experiment', 'isEnhanceMultiSelectLinkedIssueEnable', false)) {
        const msg = (0, $e9fnY.default).enhanceMultiSelectLinkedIssueEnableText;
        const searchMessage = (0, $e9fnY.default).searchMessage;
        return {
            placeholder: formatMessage(searchMessage),
            ariaLabel: formatMessage(msg)
        };
    }
    if ((0, $7jTnu.fg)('jira-issue-terminology-refresh-m3')) return {
        ariaLabel: formatMessage((0, $e9fnY.default).placeholderIssueTermRefresh),
        placeholder: formatMessage((0, $e9fnY.default).placeholderIssueTermRefresh)
    };
    return {
        ariaLabel: formatMessage((0, $e9fnY.default).placeholder),
        placeholder: formatMessage((0, $e9fnY.default).placeholder)
    };
};
const $5191b3581619bfc2$var$IssueLinksSearchEdit = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [invalidSelections, setInValidSelections] = (0, $eJOHy.useState)([]);
    const [isInvalidState, setIsInvalidState] = (0, $eJOHy.useState)(false);
    const { fieldId: fieldId, onFocus: onFocus, onBlur: onBlur, value: value, options: options, onChange: onChange, autoCompleteUrl: autoCompleteUrl, loadingMessage: loadingMessage, getSuggestions: getSuggestions, useTransformSuggestions: useTransformSuggestions, noOptionsMessage: noOptionsMessage, fetchSuggestionsOnMount: fetchSuggestionsOnMount, isInvalid: isInvalid, onCloseMenuOnScroll: onCloseMenuOnScroll, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, isDisabled: isDisabled } = props;
    const issueKey = (0, $bmoS1.useIssueKey)();
    const projectKey = (0, $bNexr.useProjectKey)(issueKey);
    const projectType = (0, $bNexr.useProjectType)(projectKey);
    const isJSMProject = projectType === (0, $ln6Iy.SERVICE_DESK_PROJECT);
    const { ariaLabel: ariaLabel, placeholder: placeholder } = $5191b3581619bfc2$var$getAriaLabelAndPlaceholder({
        isJSMProject: isJSMProject,
        formatMessage: formatMessage
    });
    const fetchSuggestions = (0, $eJOHy.useCallback)(async (query)=>{
        const response = await (0, $jGzN3.performGetRequest)(`${autoCompleteUrl}${query}`);
        return response;
    }, [
        autoCompleteUrl
    ]); /** returns the update invalid selection list that only contains values still present in the user selections */ 
    const updateInvalidSelections = (0, $eJOHy.useCallback)((selectionValues)=>{
        const issueKeyValues = selectionValues ? selectionValues.map((v)=>v.value) : []; // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        const updateSelections = invalidSelections.length ? // @ts-expect-error - TS2571 - Object is of type 'unknown'. | TS7006 - Parameter 'i' implicitly has an 'any' type.
        invalidSelections.filter((i)=>issueKeyValues.includes(i)) : [];
        if (updateSelections.length) setIsInvalidState(true);
        else setIsInvalidState(false);
        setInValidSelections(updateSelections);
    }, [
        invalidSelections
    ]);
    const onChangeSelectedValues = (0, $eJOHy.useCallback)((values, suggestions)=>{
        const currentHost = (0, $ifdhL.getCurrentHostPattern)();
        updateInvalidSelections(values);
        const newIssueLinks = values !== null && values !== undefined ? values.map((issueLink)=>{
            const strippedIssueKey = (0, $ifdhL.stripUrlToIssueKey)(currentHost, issueLink.value.toString());
            return {
                ...issueLink,
                iconUrl: issueLink.__isNew__ === true && suggestions && suggestions[0].options ? suggestions[0].options.find((option)=>option.value === issueLink.value)?.iconUrl : issueLink.iconUrl,
                label: strippedIssueKey,
                value: strippedIssueKey
            };
        }) : values;
        onChange(newIssueLinks);
    }, [
        onChange,
        updateInvalidSelections
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5191b3581619bfc2$var$FlexRow, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $5191b3581619bfc2$var$searchWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jZPPe.SearchableSelect), {
        fieldId: fieldId,
        getSuggestions: getSuggestions !== undefined ? getSuggestions : fetchSuggestions,
        onChange: onChangeSelectedValues,
        isMulti: true,
        value: value,
        options: options,
        onBlur: onBlur,
        onFocus: onFocus,
        onCloseMenuOnScroll: onCloseMenuOnScroll,
        isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
        isDisabled: isDisabled,
        placeholder: placeholder,
        getTransformedSuggestions: useTransformSuggestions !== undefined ? useTransformSuggestions : (0, $ifdhL.transformIssueSuggestionItems),
        canCreateNewItem: true,
        loadingMessage: loadingMessage,
        noOptionsMessage: noOptionsMessage,
        onChangeQueryValue: (0, $ifdhL.stripQueryValueToIssueKey),
        isInvalid: isInvalid === true || isInvalidState,
        fetchSuggestionsOnMount: fetchSuggestionsOnMount,
        formatCreateLabel: formatMessage((0, $e9fnY.default).createNewIssueLink),
        ariaLabel: ariaLabel
    })));
};
var $5191b3581619bfc2$export$2e2bcd8739ae039 = $5191b3581619bfc2$var$IssueLinksSearchEdit;
const $5191b3581619bfc2$var$searchWrapperStyles = (0, $1DXK0.xcss)({
    width: '100%'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5191b3581619bfc2$var$FlexRow = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jZPPe", function(module, exports) {

$parcel$export(module.exports, "SearchableSelect", () => $d1edc7640de56c24$export$6037a18d4e29dfa9);

var $eJOHy = parcelRequire("eJOHy");

var $3s8bj = parcelRequire("3s8bj");

var $fKXve = parcelRequire("fKXve");

var $kVcjU = parcelRequire("kVcjU");

var $dPMMf = parcelRequire("dPMMf");

var $lRq8t = parcelRequire("lRq8t");

var $1VLiF = parcelRequire("1VLiF");

var $f1FvV = parcelRequire("f1FvV");

var $aUMMA = parcelRequire("aUMMA");

var $epTsa = parcelRequire("epTsa");

var $36oqb = parcelRequire("36oqb");
const $d1edc7640de56c24$export$251bdbdbce9550ea = 300;
const $d1edc7640de56c24$export$6037a18d4e29dfa9 = (props)=>{
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(false);
    const [menuIsOpen, setMenuIsOpen] = (0, $eJOHy.useState)(false);
    const [suggestions, setSuggestions] = (0, $eJOHy.useState)();
    const [defaultSuggestions, setDefaultSuggestions] = (0, $eJOHy.useState)();
    const [hasLastFetchFailed, setHasLastFetchFailed] = (0, $eJOHy.useState)(false);
    const lastQuery = (0, $eJOHy.useRef)('');
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { fieldId: fieldId, isMulti: isMulti, isInvalid: isInvalid, placeholder: placeholder, value: value, options: options, components: components, canCreateNewItem: canCreateNewItem, classNamePrefix: classNamePrefix, onChangeQueryValue: onChangeQueryValue, onChange: onChange, onFocus: onFocus, onBlur: onBlur, fetchSuggestionsOnMount: fetchSuggestionsOnMount, getSuggestions: getSuggestions, formatOptionLabel: formatOptionLabel, noOptionsMessage: noOptionsMessage, loadingMessage: loadingMessage, componentsProps: componentsProps, getTransformedSuggestions: getTransformedSuggestions, errorMessagePosition: errorMessagePosition, invalidMessage: invalidMessage, onPostTransformSuggestions: onPostTransformSuggestions, formatCreateLabel: formatCreateLabel, autoFocus: autoFocus = false, onCloseMenuOnScroll: onCloseMenuOnScroll, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, isDisabled: isDisabled, ariaLabel: ariaLabel } = props;
    /** Fetching and transforming results logic below * */ const handleSuggestions = (0, $eJOHy.useCallback)(// @ts-expect-error - TS7006 - Parameter 'query' implicitly has an 'any' type.
    (results, query)=>{
        if (lastQuery.current === query) {
            const response = getTransformedSuggestions(results, formatMessage, query);
            if (onPostTransformSuggestions) onPostTransformSuggestions(response, query);
            setSuggestions(response);
            if (query === '') setDefaultSuggestions(response);
        }
    }, [
        formatMessage,
        getTransformedSuggestions,
        onPostTransformSuggestions
    ]);
    const getFailedFetchMessage = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1VLiF.FailedFetchOptionWrapper), null, formatMessage((0, $36oqb.default).failedFetch)), [
        formatMessage
    ]);
    const requestSuggestions = (0, $eJOHy.useCallback)(async (query = '')=>{
        try {
            const response = await getSuggestions(query, componentsProps);
            setIsLoading(false);
            handleSuggestions(response, query);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setIsLoading(false);
            setHasLastFetchFailed(true);
            const failedOption = [
                {
                    label: getFailedFetchMessage(),
                    value: '',
                    isDisabled: true
                }
            ];
            setSuggestions(failedOption);
        }
    }, [
        componentsProps,
        getFailedFetchMessage,
        getSuggestions,
        handleSuggestions
    ]);
    (0, $eJOHy.useMemo)(()=>{
        if (fetchSuggestionsOnMount) {
            if (!options && !defaultSuggestions) {
                setIsLoading(true);
                requestSuggestions();
            } else if (options) {
                setDefaultSuggestions(options);
                setSuggestions(options);
            } else {
                lastQuery.current = '';
                setIsLoading(true);
                requestSuggestions();
            }
        }
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        componentsProps
    ]);
    // go/jfe-eslint
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const debouncedRequestSuggestions = (0, $eJOHy.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(requestSuggestions, $d1edc7640de56c24$export$251bdbdbce9550ea), []);
    /** Action handlers below * */ const onQueryChange = (0, $eJOHy.useCallback)((query)=>{
        debouncedRequestSuggestions.cancel();
        setHasLastFetchFailed(false);
        if (query) {
            const transformedQuery = onChangeQueryValue ? onChangeQueryValue(query) : query;
            lastQuery.current = transformedQuery;
            setIsLoading(true);
            debouncedRequestSuggestions(transformedQuery);
        } else {
            lastQuery.current = '';
            setIsLoading(false);
            setSuggestions(defaultSuggestions);
        }
    }, [
        debouncedRequestSuggestions,
        defaultSuggestions,
        onChangeQueryValue
    ]);
    const onSelectFocus = (0, $eJOHy.useCallback)((e)=>{
        setMenuIsOpen(true);
        if (lastQuery.current === '' && !defaultSuggestions) {
            setIsLoading(true);
            requestSuggestions();
        }
        onFocus && onFocus(e);
    }, [
        defaultSuggestions,
        onFocus,
        requestSuggestions
    ]);
    const onSelectBlur = (0, $eJOHy.useCallback)((e)=>{
        setMenuIsOpen(false);
        onBlur && onBlur(e);
    }, [
        onBlur
    ]);
    const onChangeSelected = (0, $eJOHy.useCallback)(// @ts-expect-error - TS7006 - Parameter 'values' implicitly has an 'any' type.
    (values)=>{
        onChange(values, suggestions);
    }, [
        onChange,
        suggestions
    ]);
    /** Custom rendering through functions below * */ const getFormatOptionLabel = (0, $eJOHy.useCallback)((option, meta)=>{
        if (formatOptionLabel !== undefined) return formatOptionLabel(option, meta);
        if (option.iconUrl === undefined) return option.label;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1VLiF.OptionWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1VLiF.ImgSpan), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("img", {
            src: option.iconUrl,
            alt: "",
            width: 2 * (0, $dPMMf.gridSize),
            height: 2 * (0, $dPMMf.gridSize),
            role: "none"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1VLiF.FlexSpan), null, option.label));
    }, [
        formatOptionLabel
    ]);
    const renderErrorMessage = (0, $eJOHy.useCallback)(()=>invalidMessage !== undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1VLiF.ErrorMessageWrapper), {
            key: `${fieldId}-error-message`,
            errorMessagePosition: errorMessagePosition
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fKXve.ErrorMessage), null, invalidMessage)) : null, [
        errorMessagePosition,
        fieldId,
        invalidMessage
    ]);
    const getCreateLabel = (0, $eJOHy.useCallback)((inputValue)=>`${inputValue} (${formatCreateLabel !== undefined ? formatCreateLabel : formatMessage((0, $36oqb.default).createNewItem)})`, [
        formatCreateLabel,
        formatMessage
    ]);
    const getNoOptionsMessage = (0, $eJOHy.useCallback)(()=>noOptionsMessage !== undefined ? noOptionsMessage : formatMessage((0, $36oqb.default).empty), [
        formatMessage,
        noOptionsMessage
    ]);
    const getLoadingMessage = (0, $eJOHy.useCallback)(()=>loadingMessage !== undefined ? loadingMessage : formatMessage((0, $36oqb.default).loading), [
        formatMessage,
        loadingMessage
    ]);
    const filterOption = (0, $eJOHy.useCallback)((option)=>{
        if (hasLastFetchFailed) // If the fetch has failed, we will show a disabled option to indicate the error to users
        return true;
        return (0, $f1FvV.filterOptionByLabelAndFilterValues)(option, lastQuery.current || '');
    }, [
        hasLastFetchFailed
    ]);
    const isValidNewOption = (0, $eJOHy.useCallback)((query)=>{
        if (canCreateNewItem && query !== '') return true;
        return false;
    }, [
        canCreateNewItem
    ]);
    /**  Rendering logic below * */ const renderSelectField = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kVcjU.default), {
            classNamePrefix: classNamePrefix,
            key: fieldId,
            options: suggestions,
            autoFocus: autoFocus,
            // @ts-expect-error TS2345: Argument of type '{ new <Option = OptionType, IsMulti extends boolean = false>(props: SelectProps<Option, IsMulti>): { components: Partial<SelectComponents<Option, IsMulti, GroupBase<Option>>>; ... 23 more ...; UNSAFE_componentWillUpdate?(nextProps: Readonly<...>, nextState: Readonly<...>, nextContext: any): void; }; defaultProps: { ...' is not assignable to parameter of type 'ComponentType<SelectProps<unknown, boolean> | AsyncSelectProps<unknown, boolean> | CreatableSelectProps<unknown, boolean>>'.
            value: value,
            onBlur: onSelectBlur,
            onFocus: onSelectFocus,
            noOptionsMessage: getNoOptionsMessage,
            loadingMessage: getLoadingMessage,
            menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
            styles: (0, $aUMMA.defaultSelectStyles),
            placeholder: placeholder !== undefined ? placeholder : formatMessage((0, $36oqb.default).placeholder),
            onInputChange: onQueryChange,
            onChange: onChangeSelected,
            isLoading: menuIsOpen && isLoading,
            filterOption: filterOption,
            isClearable: true,
            formatOptionLabel: getFormatOptionLabel,
            // @ts-expect-error - Type '{ Menu: ComponentType<MenuProps>; } | undefined' is not assignable to type 'Partial<SelectComponents<Option, boolean, GroupBase<Option>>> | undefined'
            components: components,
            componentsProps: componentsProps,
            isMulti: isMulti,
            isValidNewOption: isValidNewOption,
            // @ts-expect-error - null has to be changed to undefined
            validationState: isInvalid === true ? 'error' : null,
            formatCreateLabel: getCreateLabel,
            closeMenuOnScroll: onCloseMenuOnScroll,
            isDisabled: isDisabled,
            "aria-label": ariaLabel,
            ...(0, $epTsa.expVal)('enhanced_multiselect_linking_experiment', 'isEnhanceMultiSelectLinkedIssueEnable', false) ? {
                closeMenuOnSelect: false
            } : {}
        });
    const componentList = [
        renderSelectField()
    ];
    errorMessagePosition === 'top' ? componentList.unshift(renderErrorMessage()) : componentList.push(renderErrorMessage());
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, componentList);
};
$d1edc7640de56c24$export$6037a18d4e29dfa9.defaultProps = {
    isMulti: false,
    canCreateNewItem: false,
    fetchSuggestionsOnMount: true
};
var $d1edc7640de56c24$export$2e2bcd8739ae039 = $d1edc7640de56c24$export$6037a18d4e29dfa9;

});
parcelRegister("1VLiF", function(module, exports) {

$parcel$export(module.exports, "getFailedFetchSelectOptions", () => $54b1fdf551d137ca$export$6ed0d629c0656ce1);
$parcel$export(module.exports, "FailedFetchOptionWrapper", () => $54b1fdf551d137ca$export$38a1a0a811e06255);
$parcel$export(module.exports, "getFailedFetchSelectOptionsWithDefaultLabel", () => $54b1fdf551d137ca$export$aa3357fb0ebcdb2b);
$parcel$export(module.exports, "OptionWrapper", () => $54b1fdf551d137ca$export$d6f6a072cce04542);
$parcel$export(module.exports, "ImgSpan", () => $54b1fdf551d137ca$export$df67068a00dece12);
$parcel$export(module.exports, "FlexSpan", () => $54b1fdf551d137ca$export$d90eccb59fb62cab);
$parcel$export(module.exports, "ErrorMessageWrapper", () => $54b1fdf551d137ca$export$9e874bb1adc98a55);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $epTsa = parcelRequire("epTsa");

var $lRq8t = parcelRequire("lRq8t");

var $4Hcat = parcelRequire("4Hcat");
const $54b1fdf551d137ca$export$6ed0d629c0656ce1 = (query, label)=>[
        {
            options: [
                {
                    label: // @ts-expect-error ReactNode is not assignable to string (which is the only type in docs: https://atlassian.design/components/select/code). But it works
                    label,
                    value: '',
                    isDisabled: true,
                    filterValues: [
                        query
                    ] // filterOptionByLabelAndFilterValues will check `filterValues` and since it contains the user's query, this option will always show
                }
            ]
        }
    ];
const $54b1fdf551d137ca$var$DefaultFailedFetchMessage = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const failedFetchMessage = (0, $4Hcat.default).failedFetch;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($54b1fdf551d137ca$export$38a1a0a811e06255, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", null, formatMessage(failedFetchMessage), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("a", {
        role: "button",
        href: window.location.href,
        onClick: ()=>window.location.reload()
    }, formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $4Hcat.default).reloadIssueIssueTermRefresh : (0, $4Hcat.default).reloadIssue))));
};
const $54b1fdf551d137ca$export$aa3357fb0ebcdb2b = (query)=>$54b1fdf551d137ca$export$6ed0d629c0656ce1(query, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($54b1fdf551d137ca$var$DefaultFailedFetchMessage, null)); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $54b1fdf551d137ca$export$d6f6a072cce04542 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $54b1fdf551d137ca$export$38a1a0a811e06255 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $54b1fdf551d137ca$export$d6f6a072cce04542, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bah1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $54b1fdf551d137ca$export$df67068a00dece12 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _u5f3u2gc",
            __cmplp.className
        ])
    });
});
const $54b1fdf551d137ca$export$d90eccb59fb62cab = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});
const $54b1fdf551d137ca$export$9e874bb1adc98a55 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { errorMessagePopsition: errorMessagePopsition, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "",
            __cmplp.errorMessagePopsition === 'top' && "_otyri2wt",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4Hcat", function(module, exports) {

$parcel$export(module.exports, "default", () => $00759e784ef4d011$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $00759e784ef4d011$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    failedFetch: {
        "id": "issue-field-select-base.failed-fetch-options.failed-fetch",
        "defaultMessage": "Search failed."
    },
    reloadIssue: {
        "id": "issue-field-select-base.failed-fetch-options.reload-issue",
        "defaultMessage": "Try reloading the issue."
    },
    reloadIssueIssueTermRefresh: {
        "id": "issue-field-select-base.failed-fetch-options.reload-issue-issue-term-refresh",
        "defaultMessage": "Try reloading"
    }
});

});


parcelRegister("f1FvV", function(module, exports) {

$parcel$export(module.exports, "filterOptionByLabelAndFilterValues", () => $0b19d4706e6a94cf$export$58bb91b619b113f6);

var $LFmXM = parcelRequire("LFmXM");

var $1beam = parcelRequire("1beam");
const $0b19d4706e6a94cf$export$d3e698d53f63efcd = (val, inputValueIgnoredCase)=>// label can be Object for new option in CreatableSelect
    typeof val === 'string' && val// no need to .trim() since input is already trimmed and we search for .includes() so it does not matter if field has leading or trailing spaces
    .toLowerCase().includes(inputValueIgnoredCase);
const $0b19d4706e6a94cf$var$stringifyLabelAndDataFilterValues = (option)=>{
    const { label: label, data: data } = option || {};
    const { filterValues: filterValues } = data || {};
    const labelString = typeof label === 'string' ? label : '';
    const filterValuesString = (filterValues || []).join(' ');
    return `${labelString} ${filterValuesString}`;
};
/**
 * By default react-select matches by both option.label and option.value: https://github.com/JedWatson/react-select/blob/b7868d23ccd0b9e623b277f971e89020d426fbdb/packages/react-select/src/filters.js#L14.
 * This leads to undesired UX, when filter result includes options without displayed text matching the query (which is very confusing for the user): BENTO-5735, BENTO-5655.
 * That's why we need this function.
 */ const $0b19d4706e6a94cf$var$filterOptionByLabelAndFilterValuesInternal = (0, $LFmXM.default)(()=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $1beam.createFilter)({
        // Take an option object and convert it to a string that needs to partially match the user's query
        stringify: $0b19d4706e6a94cf$var$stringifyLabelAndDataFilterValues
    }));
const $0b19d4706e6a94cf$export$58bb91b619b113f6 = (option, inputValue)=>$0b19d4706e6a94cf$var$filterOptionByLabelAndFilterValuesInternal()(option, inputValue);

});

parcelRegister("36oqb", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd93d0822249a52b$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $bd93d0822249a52b$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    empty: {
        "id": "searchable-select.empty",
        "defaultMessage": "No matches found"
    },
    failedFetch: {
        "id": "searchable-select.failed-fetch",
        "defaultMessage": "Search failed. Please try again."
    },
    placeholder: {
        "id": "searchable-select.placeholder",
        "defaultMessage": "Select an option"
    },
    loading: {
        "id": "searchable-select.loading",
        "defaultMessage": "Searching..."
    },
    createNewItem: {
        "id": "searchable-select.create-new-item",
        "defaultMessage": "Create"
    }
});

});


parcelRegister("e9fnY", function(module, exports) {

$parcel$export(module.exports, "default", () => $e798ab3ee9fd32a1$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $e798ab3ee9fd32a1$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    placeholder: {
        "id": "issue-field-issue-links.edit.search.placeholder",
        "defaultMessage": "Select Issue"
    },
    openIssues: {
        "id": "issue-field-issue-links.edit.search.open-issues",
        "defaultMessage": "Open Issues"
    },
    noHistoryResults: {
        "id": "issue-field-issue-links.edit.search.no-history-results",
        "defaultMessage": "Type to search for an issue summary or key"
    },
    singleInvalidIssue: {
        "id": "issue-field-issue-links.edit.search.single-invalid-issue",
        "defaultMessage": "We can't find an issue with the key"
    },
    multipleInvalidIssues: {
        "id": "issue-field-issue-links.edit.search.multiple-invalid-issues",
        "defaultMessage": "We can't find issues with the keys"
    },
    createNewIssueLink: {
        "id": "issue-field-issue-links.edit.search.create-new-issue-link",
        "defaultMessage": "Exact key"
    },
    placeholderIssueTermRefresh: {
        "id": "issue-field-issue-links.edit.search.placeholder-issue-term-refresh",
        "defaultMessage": "Select work item"
    },
    openIssuesIssueTermRefresh: {
        "id": "issue-field-issue-links.edit.search.open-issues-issue-term-refresh",
        "defaultMessage": "Open work items"
    },
    noHistoryResultsIssueTermRefresh: {
        "id": "issue-field-issue-links.edit.search.no-history-results-issue-term-refresh",
        "defaultMessage": "Type to search for a work item or key"
    },
    singleInvalidIssueIssueTermRefresh: {
        "id": "issue-field-issue-links.edit.search.single-invalid-issue-issue-term-refresh",
        "defaultMessage": "We can't find a work item with the key"
    },
    multipleInvalidIssuesIssueTermRefresh: {
        "id": "issue-field-issue-links.edit.search.multiple-invalid-issues-issue-term-refresh",
        "defaultMessage": "We can't find work items with the keys"
    },
    enhanceMultiSelectLinkedIssueEnableText: {
        "id": "issue-field-issue-links.edit.search.enhance-multi-select-linked-issue-enable-text",
        "defaultMessage": "Type, search or paste URL to link work items"
    },
    searchMessage: {
        "id": "issue-field-issue-links.edit.search.search-message",
        "defaultMessage": "Type, search or paste URL"
    }
});

});

parcelRegister("ifdhL", function(module, exports) {

$parcel$export(module.exports, "getCurrentHostPattern", () => $fa16eb1445106f92$export$47e10df7c3c19b6b);
$parcel$export(module.exports, "stripUrlToIssueKey", () => $fa16eb1445106f92$export$1f3c6284caef177b);
$parcel$export(module.exports, "stripQueryValueToIssueKey", () => $fa16eb1445106f92$export$a1fbc8ef5ec2d6e3);
$parcel$export(module.exports, "transformIssueSuggestionItems", () => $fa16eb1445106f92$export$41cc13f7ec7b4b3d);

var $7jTnu = parcelRequire("7jTnu");

var $e9fnY = parcelRequire("e9fnY");
// If the full URL supplied matches the Jira view issue pattern for the specified site then strip the URL
// to just the issue key. If the URL does not match the pattern then return it unchanged.
const $fa16eb1445106f92$var$ISSUE_BROWSE_PATH = 'browse/';
const $fa16eb1445106f92$var$ISSUE_KEY_REGEXP = /^(([A-Z][A-Z0-9]+)-([0-9]+))($|\?.*)/;
const $fa16eb1445106f92$export$47e10df7c3c19b6b = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.location.port !== '') // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return `${window.location.protocol}//${window.location.hostname}:${window.location.port}`;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return `${window.location.protocol}//${window.location.hostname}`;
};
const $fa16eb1445106f92$export$1f3c6284caef177b = (tenantUrl, candidateUrl)=>{
    let tenantUrlPath = tenantUrl;
    if (tenantUrlPath === undefined || candidateUrl === undefined) return candidateUrl || '';
    if (!tenantUrlPath.endsWith('/')) tenantUrlPath += '/';
    tenantUrlPath += $fa16eb1445106f92$var$ISSUE_BROWSE_PATH;
    if (candidateUrl.indexOf(tenantUrlPath) !== 0) return candidateUrl;
    const candidatePath = candidateUrl.slice(tenantUrlPath.length);
    const match = candidatePath.match($fa16eb1445106f92$var$ISSUE_KEY_REGEXP);
    if (match === null) return candidateUrl;
    return match[1] || ''; // issue key is at index 1 (first capture group)
};
const $fa16eb1445106f92$export$a1fbc8ef5ec2d6e3 = (queryValue)=>{
    const currentHost = $fa16eb1445106f92$export$47e10df7c3c19b6b();
    return $fa16eb1445106f92$export$1f3c6284caef177b(currentHost, queryValue);
};
const $fa16eb1445106f92$export$41cc13f7ec7b4b3d = (results, formatMessage, query = '')=>{
    const { sections: sections } = results;
    const heading = formatMessage((0, $7jTnu.fg)('jira-issue-terminology-refresh-m3') ? (0, $e9fnY.default).openIssuesIssueTermRefresh : (0, $e9fnY.default).openIssues);
    const noSuggestionsMessage = formatMessage((0, $7jTnu.fg)('jira-issue-terminology-refresh-m3') ? (0, $e9fnY.default).noHistoryResultsIssueTermRefresh : (0, $e9fnY.default).noHistoryResults);
    const suggestions = sections.map((section)=>section.issues).filter((issues)=>!!issues) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce((flatten, current)=>flatten.concat(current.map((issue)=>({
                label: `${issue.key} ${issue.summaryText}`,
                value: issue.key,
                id: issue.id ? issue.id.toString() : '',
                iconUrl: issue.img,
                // Allows us to force all items returned by the endpoint to be displayed.
                filterValues: [
                    query
                ]
            }))), []) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce((uniq, current)=>uniq.findIndex((item)=>item.value === current.value) < 0 ? [
            ...uniq,
            current
        ] : uniq, []);
    if (suggestions.length) {
        const selectSuggestions = [
            {
                label: heading,
                options: suggestions
            }
        ];
        return selectSuggestions;
    }
    const noSuggestion = [
        {
            label: noSuggestionsMessage,
            isDisabled: true,
            value: ''
        }
    ];
    return noSuggestion;
};
const $fa16eb1445106f92$export$fb7a6b38a05bd2b7 = ({ value: value })=>Number(value);

});



parcelRegister("dXi8G", function(module, exports) {

$parcel$export(module.exports, "mapDataToOption", () => $352985d2842cf2d9$export$5c1e24ea9ccb80aa);
$parcel$export(module.exports, "mapDataToOptions", () => $352985d2842cf2d9$export$99a866ffa3af7d8b);
$parcel$export(module.exports, "mapOptionsToData", () => $352985d2842cf2d9$export$ffef3a401aef987b);
const $352985d2842cf2d9$export$5c1e24ea9ccb80aa = (linkType)=>({
        id: linkType.linkTypeId,
        label: linkType.relationName,
        value: linkType.relationName,
        name: linkType.linkTypeName,
        direction: linkType.direction
    });
const $352985d2842cf2d9$export$99a866ffa3af7d8b = (linkTypes)=>linkTypes.map($352985d2842cf2d9$export$5c1e24ea9ccb80aa);
const $352985d2842cf2d9$export$ffef3a401aef987b = (option)=>{
    // handling the case where default value may get set in the process of setting the default value of link type dropdown but the user never selects any issues
    if (option.issues.length === 0) return undefined;
    const direction = option.linkType.direction === 'INWARD' ? 'inwardIssues' : 'outwardIssues';
    return [
        {
            add: {
                values: [
                    {
                        type: {
                            id: option.linkType.id
                        },
                        [direction]: option.issues.map((issue)=>({
                                key: issue.value
                            }))
                    }
                ]
            }
        }
    ];
};

});

parcelRegister("8eQep", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a305bab2781db4e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $9a305bab2781db4e$var$messages = (0, $7qGN1.defineMessages)({
    includeLinks: {
        "id": "issue-create-commons.issue-links-field.include-links",
        "defaultMessage": "Include links"
    },
    includeAttachments: {
        "id": "issue-create-commons.issue-links-field.include-attachments",
        "defaultMessage": "Include attachments"
    },
    ariaLabel: {
        "id": "issue-create-commons.issue-links-field.aria-label",
        "defaultMessage": "Select an action for linked work item"
    }
});
var $9a305bab2781db4e$export$2e2bcd8739ae039 = $9a305bab2781db4e$var$messages;

});

parcelRegister("5fZlk", function(module, exports) {

$parcel$export(module.exports, "transformDefaultIssueLinksValue", () => $1f73887245358a8d$export$acce6bb888b6838c);
$parcel$export(module.exports, "validateIssueLinksField", () => $1f73887245358a8d$export$542fc2dd23d5dbdc);
$parcel$export(module.exports, "mutateIssueLinksField", () => $1f73887245358a8d$export$c498672524a9f24d);

var $7jTnu = parcelRequire("7jTnu");

var $3UrQk = parcelRequire("3UrQk");

var $dXi8G = parcelRequire("dXi8G");
const $1f73887245358a8d$export$acce6bb888b6838c = (value)=>{
    if (value && value.length > 0) {
        const issues = [];
        value.forEach((issueLink)=>{
            if (issueLink.issue) issues.push({
                iconUrl: issueLink.issue.avatar?.small,
                id: issueLink.issue.issueId.toString(),
                label: issueLink.issue.key,
                value: issueLink.issue.key
            });
        });
        return (0, $7jTnu.fg)('create_linked_issues_trigger_point_issue_view') ? {
            linkType: (0, $dXi8G.mapDataToOption)(value?.[0]?.relatedBy),
            issues: issues,
            includeAttachments: undefined,
            includeLinks: undefined
        } : {
            linkType: (0, $dXi8G.mapDataToOption)(value?.[0]?.relatedBy),
            issues: issues
        };
    }
    return undefined;
};
const $1f73887245358a8d$export$542fc2dd23d5dbdc = (value, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
isRequired)=>{
    if (isRequired) {
        // value can be null/undefined/{} or issues can be [] when default value is set for the link type select, check the default transformer for this field
        if (!value?.issues?.length) return 0, $3UrQk.REQUIRED;
    }
    return undefined;
};
const $1f73887245358a8d$export$c498672524a9f24d = (value)=>({
        issueLinks: {
            linkTypeName: value.linkType.value,
            linkedIssueKeys: value?.issues?.map((issue)=>issue.value.toString()) || []
        }
    });

});


parcelRegister("jANxQ", function(module, exports) {

$parcel$export(module.exports, "ForgeLabelsField", () => $0f15cac5896fd802$export$f77bab10d748bb71);
$parcel$export(module.exports, "default", () => $0f15cac5896fd802$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $aFa5H = parcelRequire("aFa5H");

var $epTsa = parcelRequire("epTsa");

var $fE4zR = parcelRequire("fE4zR");

var $2nXHu = parcelRequire("2nXHu");

var $ixdDB = parcelRequire("ixdDB");

var $4yQUm = parcelRequire("4yQUm");

var $2me76 = parcelRequire("2me76");

const $0f15cac5896fd802$var$LabelsField = (props)=>{
    const { fieldId: fieldId, autoCompleteUrl: autoCompleteUrl, error: error, width: width, autoFocus: autoFocus = false, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, $ixdDB.closeMenuOnScroll), fieldProps: { value: value, onChange: onChange, id: id, isRequired: isRequired }, isReadOnly: isReadOnly = false } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fE4zR.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aFa5H.LabelsEdit), {
        isInvalid: Boolean(error),
        fetchSuggestionsOnMount: false,
        isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
        autoCompleteUrl: autoCompleteUrl,
        onChange: onChange,
        value: value,
        autoFocus: autoFocus,
        onCloseMenuOnScroll: onCloseMenuOnScroll,
        isDisabled: isReadOnly,
        inputId: id,
        isRequired: isRequired,
        ...(0, $epTsa.expVal)('adding-color-to-labels-field-experiment-milestone2', 'isColorfulNewLabelsEnabled', false) ? {
            fieldId: fieldId
        } : {}
    }));
};
const $0f15cac5896fd802$export$f77bab10d748bb71 = (0, $2nXHu.withFormField)({
    validator: (0, $4yQUm.validateForgeLabelField),
    transformDefaultValue: (0, $2me76.mapDataToLabelOptions)
})($0f15cac5896fd802$var$LabelsField);
var $0f15cac5896fd802$export$2e2bcd8739ae039 = (0, $2nXHu.withFormField)({
    validator: (0, $4yQUm.validateLabelField),
    transformDefaultValue: (0, $2me76.mapDataToLabelOptions)
})($0f15cac5896fd802$var$LabelsField);

});
parcelRegister("aFa5H", function(module, exports) {

$parcel$export(module.exports, "LabelsEdit", () => $0278e93500fcb1f8$export$23584166c0ffb901);

var $b4alz = parcelRequire("b4alz");

var $eJOHy = parcelRequire("eJOHy");

var $k0ahr = parcelRequire("k0ahr");

var $3s8bj = parcelRequire("3s8bj");

var $aXKmr = parcelRequire("aXKmr");

var $j4oe4 = parcelRequire("j4oe4");

var $6XEne = parcelRequire("6XEne");

var $Ay1uj = parcelRequire("Ay1uj");

var $gTr6H = parcelRequire("gTr6H");

var $8nu6j = parcelRequire("8nu6j");
var $bQP4O = parcelRequire("bQP4O");
var $1DXK0 = parcelRequire("1DXK0");

var $IW7jS = parcelRequire("IW7jS");

var $7jTnu = parcelRequire("7jTnu");

var $lRq8t = parcelRequire("lRq8t");

var $1VLiF = parcelRequire("1VLiF");

var $f1FvV = parcelRequire("f1FvV");

var $aUMMA = parcelRequire("aUMMA");

var $814y1 = parcelRequire("814y1");

var $39uVc = parcelRequire("39uVc");

var $aCFLd = parcelRequire("aCFLd");

var $kp5kj = parcelRequire("kp5kj");

var $051tO = parcelRequire("051tO");

var $cNe2t = parcelRequire("cNe2t");

var $epTsa = parcelRequire("epTsa");

var $6XJko = parcelRequire("6XJko");

var $gZTP9 = parcelRequire("gZTP9");

var $3osLr = parcelRequire("3osLr");

var $kEUB1 = parcelRequire("kEUB1");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $eDBhy = parcelRequire("eDBhy");

var $cNNNb = parcelRequire("cNNNb");

var $2aY2d = parcelRequire("2aY2d");

var $3JeUC = parcelRequire("3JeUC");

var $k4FEf = parcelRequire("k4FEf");

var $cd713 = parcelRequire("cd713");

var $edfym = parcelRequire("edfym");
const $0278e93500fcb1f8$export$251bdbdbce9550ea = 300;
const $0278e93500fcb1f8$var$multiValueStyles = {
    root: "_hn7lze3t _ujoyze3t",
    isVisualRefreshDisabled: "_2rkoiti9 _bfhk18uv _1vxp1b66 _1onpze3t _3lltze3t _k4bfze3t"
};
const $0278e93500fcb1f8$var$multiValueLabelStyles = {
    root: "_1oqf3acm"
};
const $0278e93500fcb1f8$var$multiValueRemoveStyles = {
    root: "_1tga113p _11lgglyw _1e22lcct _wb7e1iit _gy631fxt _13dibs82"
};
const $0278e93500fcb1f8$var$labelsValueStyles = {
    multiValue: (base, { data: data })=>{
        // @ts-expect-error - ts2322 - Type 'ReactNode' is not assignable to type 'string'.
        const dataLabel = data.label;
        const { backgroundColor: backgroundColorMilestone1 } = (0, $051tO.getColorMetadata)((0, $aCFLd.memoizeGetAutoGeneratedColorForLabels)(dataLabel));
        const isNewLabel = data.__isNew__;
        const newLabelColor = data.color ?? (0, $cNNNb.GREY_META).name;
        const oldLabelColor = data.color ?? (0, $aCFLd.memoizeGetAutoGeneratedColorForLabels)(dataLabel);
        const { backgroundColor: backgroundColorMilestone2 } = (0, $051tO.getColorMetadata)(isNewLabel ? newLabelColor : oldLabelColor);
        const backgroundColor = (0, $epTsa.expVal)('adding-color-to-labels-field-experiment-milestone2', 'isColorfulNewLabelsEnabled', false) ? backgroundColorMilestone2 : backgroundColorMilestone1;
        return {
            ...base,
            border: `1px solid ${backgroundColor}`,
            '& > div > div > div': {
                paddingLeft: 0,
                paddingRight: 0
            },
            ...!(0, $6XJko.isVisualRefreshEnabled)() ? {
                borderRadius: "var(--ds-border-radius-100, 4px)",
                backgroundColor: 'transparent',
                '& > div': {
                    paddingLeft: "var(--ds-space-050, 4px)",
                    paddingRight: 0,
                    paddingTop: 0,
                    paddingBottom: 0
                }
            } : {}
        };
    },
    multiValueLabel: (base)=>({
            ...base,
            '& > div > div': {
                borderColor: 'transparent'
            }
        })
};
const $0278e93500fcb1f8$var$labelsRemoveIconStyles = {
    multiValueRemove: (base)=>({
            ...base,
            '& > div > span > svg': {
                transform: 'scale(1.5)',
                fill: 'none'
            },
            '& > div > span > svg > g > path': {
                d: 'path("m 2 10 l 4 -4 m 4 -4 L 6 6 m 0 0 L 2 2 m 4 4 l 4 4")',
                transform: 'translate(5px, 6px)',
                stroke: "var(--ds-text, #172B4D)",
                strokeWidth: '1.5'
            }
        })
};
const $0278e93500fcb1f8$export$23584166c0ffb901 = (props)=>{
    const { autoCompleteUrl: autoCompleteUrl, autoFocus: autoFocus, onChange: onChange, onFocus: onFocus, onBlur: onBlur, spacing: spacing, value: value, options: options, cachedOptions: cachedOptions = [], formatCreateLabel: formatCreateLabel, noOptionsMessage: noOptionsMessage, loadingMessage: loadingMessage, onCloseMenuOnScroll: onCloseMenuOnScroll, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, getSuggestions: getSuggestions, fetchSuggestionsOnMount: fetchSuggestionsOnMount = true, fieldId: fieldId = (0, $814y1.LABELS_TYPE), isInvalid: isInvalid = false, isDisabled: isDisabled = false, ariaLabel: ariaLabel = '', inputId: inputId, isRequired: isRequired, openMenuOnFocus: openMenuOnFocus } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [suggestions, setSuggestions] = (0, $eJOHy.useState)();
    const [defaultSuggestions, setDefaultSuggestions] = (0, $eJOHy.useState)();
    const [hasLastFetchFailed, setHasLastFetchFailed] = (0, $eJOHy.useState)(false);
    const [menuIsOpen, setMenuIsOpen] = (0, $eJOHy.useState)(false);
    const lastQuery = (0, $eJOHy.useRef)('');
    const sessionId = (0, $eJOHy.useRef)((0, $aXKmr.v4)());
    const { data: project } = (0, $2aY2d.useProjectContext)();
    const cloudId = (0, $kEUB1.useCloudId)();
    const [commit] = (0, $j4oe4.useMutation)((0, $b4alz.default));
    const isProjectAdmin = project?.isProjectAdmin || false;
    const isGlobalAdmin = (0, $gZTP9.useIsAdmin)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [{ isLoadingSuggestions: isLoadingSuggestions }, { getLabelsSuggestions: getLabelsSuggestions, setIsLoadingSuggestions: setIsLoadingSuggestions }] = (0, $k4FEf.useLabelsSuggestions)({
        fieldId: fieldId,
        getSuggestions: getSuggestions
    });
    const getFailedFetchMessage = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1VLiF.FailedFetchOptionWrapper), null, formatMessage((0, $edfym.default).failedFetch)), [
        formatMessage
    ]);
    const fetchSuggestions = (0, $eJOHy.useCallback)(async (query = '')=>{
        try {
            const response = await getLabelsSuggestions(autoCompleteUrl, query, sessionId.current);
            setIsLoadingSuggestions(false);
            if (lastQuery.current === query) {
                const results = (0, $3JeUC.mapLabelsResponseToLabelOptions)(response);
                setSuggestions(results);
                if (query === '') setDefaultSuggestions(results);
            } // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setIsLoadingSuggestions(false);
            setHasLastFetchFailed(true);
            setSuggestions([
                {
                    label: getFailedFetchMessage(),
                    value: '',
                    isDisabled: true
                }
            ]);
        }
    }, [
        autoCompleteUrl,
        getFailedFetchMessage,
        getLabelsSuggestions,
        lastQuery,
        sessionId,
        setHasLastFetchFailed,
        setIsLoadingSuggestions
    ]);
    if ((0, $7jTnu.fg)('_jira-concurrent-state-update-hasnt-mounted-yet')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eJOHy.useEffect)(()=>{
        if (fetchSuggestionsOnMount) {
            if (!options && !defaultSuggestions) {
                setIsLoadingSuggestions(true);
                fetchSuggestions();
            } else if (options && !defaultSuggestions) {
                setDefaultSuggestions(options);
                setSuggestions(options);
            } else {
                lastQuery.current = '';
                setIsLoadingSuggestions(true);
                fetchSuggestions();
            }
        } // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    else // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eJOHy.useMemo)(()=>{
        if (fetchSuggestionsOnMount) {
            if (!options && !defaultSuggestions) {
                setIsLoadingSuggestions(true);
                fetchSuggestions();
            } else if (options && !defaultSuggestions) {
                setDefaultSuggestions(options);
                setSuggestions(options);
            } else {
                lastQuery.current = '';
                setIsLoadingSuggestions(true);
                fetchSuggestions();
            }
        } // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const groupedSuggestions = (0, $eJOHy.useMemo)(()=>[
            {
                label: formatMessage((0, $edfym.default).recent),
                options: cachedOptions
            },
            {
                label: formatMessage((0, $edfym.default).all),
                options: suggestions || []
            }
        ], [
        cachedOptions,
        formatMessage,
        suggestions
    ]); // go/jfe-eslint
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const debouncedFetchSuggestions = (0, $eJOHy.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(fetchSuggestions, $0278e93500fcb1f8$export$251bdbdbce9550ea), []);
    const allLabels = (0, $eJOHy.useCallback)(()=>[
            ...cachedOptions ?? [],
            ...suggestions ?? []
        ], [
        cachedOptions,
        suggestions
    ]);
    const isNewLabelText = (0, $eJOHy.useCallback)((inputValue)=>{
        const isNewLabel = !allLabels().some((option)=>{
            // @ts-expect-error - ts2322 - Type 'ReactNode' is not assignable to type 'string'.
            const optionLabel = option.label;
            return optionLabel === inputValue;
        });
        return isNewLabel;
    }, [
        allLabels
    ]);
    const getCreateLabel = (0, $eJOHy.useCallback)((inputValue)=>{
        return `${inputValue} (${formatCreateLabel !== undefined ? formatCreateLabel : formatMessage((0, $edfym.default).createNewItem)})`;
    }, [
        formatCreateLabel,
        formatMessage
    ]);
    const getNoOptionsMessage = (0, $eJOHy.useCallback)(()=>noOptionsMessage !== undefined ? noOptionsMessage : formatMessage((0, $edfym.default).empty), [
        formatMessage,
        noOptionsMessage
    ]);
    const getLoadingMessage = (0, $eJOHy.useCallback)(()=>loadingMessage !== undefined ? loadingMessage : formatMessage((0, $edfym.default).loading), [
        formatMessage,
        loadingMessage
    ]);
    const filterOption = (0, $eJOHy.useCallback)((option, query)=>{
        if (hasLastFetchFailed) // If the fetch has failed, we will show a disabled option to indicate the error to users
        return true;
        return (0, $f1FvV.filterOptionByLabelAndFilterValues)(option, query || '');
    }, [
        hasLastFetchFailed
    ]);
    const isFocusingRef = (0, $eJOHy.useRef)(false);
    const onQueryChange = (0, $eJOHy.useCallback)((query)=>{
        debouncedFetchSuggestions.cancel();
        setHasLastFetchFailed(false);
        if ((0, $epTsa.expVal)('adding-color-to-labels-field-experiment-milestone2', 'isColorfulNewLabelsEnabled', false)) {
            setMenuIsOpen(true);
            requestAnimationFrame(()=>{
                if (isFocusingRef.current === false) {
                    if (query) {
                        lastQuery.current = query;
                        setIsLoadingSuggestions(true);
                        debouncedFetchSuggestions(query);
                    } else {
                        lastQuery.current = '';
                        setIsLoadingSuggestions(false);
                        setSuggestions(defaultSuggestions);
                    }
                }
            });
        } else if (query) {
            lastQuery.current = query;
            setIsLoadingSuggestions(true);
            debouncedFetchSuggestions(query);
        } else {
            lastQuery.current = '';
            setIsLoadingSuggestions(false);
            setSuggestions(defaultSuggestions);
        }
    }, [
        debouncedFetchSuggestions,
        defaultSuggestions,
        setIsLoadingSuggestions,
        setSuggestions
    ]);
    const [selectedLabelForEdit, setSelectedLabelForEdit] = (0, $eJOHy.useState)();
    const [showColorPickerPopup, setShowColorPickerPopup] = (0, $eJOHy.useState)(false);
    const [showColorPickerPopupWhenCreated, setShowColorPickerPopupWhenCreated] = (0, $eJOHy.useState)(false);
    const [isManuallyFocusing, setIsManuallyFocusing] = (0, $eJOHy.useState)(false);
    const lastFocusedKey = (0, $eJOHy.useRef)(null);
    const onSelectFocus = (0, $eJOHy.useCallback)((e)=>{
        if (!suggestions) {
            setIsLoadingSuggestions(true);
            fetchSuggestions('');
        }
        if ((0, $epTsa.expVal)('adding-color-to-labels-field-experiment-milestone2', 'isColorfulNewLabelsEnabled', false)) {
            setMenuIsOpen(!menuIsOpen);
            isFocusingRef.current = false;
            lastFocusedKey.current = {
                key: 'input',
                index: 0,
                type: 'input'
            };
        }
        onFocus && onFocus(e);
    }, [
        suggestions,
        menuIsOpen,
        onFocus,
        setIsLoadingSuggestions,
        fetchSuggestions
    ]);
    const onSelectBlur = (0, $eJOHy.useCallback)((e)=>{
        if ((0, $epTsa.expVal)('adding-color-to-labels-field-experiment-milestone2', 'isColorfulNewLabelsEnabled', false)) requestAnimationFrame(()=>{
            const button = globalThis.document.querySelector('div[role="group"] > button[type="button"] [data-testid="option-color-picker.option-tag.field-tag-wrapper"]')?.closest('button');
            if (globalThis.document.activeElement === button) setIsManuallyFocusing(true);
            else {
                setIsManuallyFocusing(false);
                setMenuIsOpen(false);
            }
        });
        else {
            setMenuIsOpen(false);
            onBlur && onBlur(e);
        }
    }, [
        onBlur
    ]);
    const handleCreateOption = (0, $eJOHy.useCallback)((label)=>{
        const newLabel = {
            label: label,
            value: label,
            color: (0, $cNNNb.GREY_META).name,
            __isNew__: true
        };
        setSelectedLabelForEdit(newLabel);
        setShowColorPickerPopupWhenCreated(true);
        (0, $gCeeo.fireTrackAnalyticsDeferred)(createAnalyticsEvent({}), 'newLabel created', {
            label: label,
            fieldId: fieldId
        });
        const newLabels = [
            ...value || [],
            newLabel
        ];
        onChange?.(newLabels);
    }, [
        createAnalyticsEvent,
        fieldId,
        onChange,
        value
    ]);
    const menuPosition = isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined;
    const isLoading = isLoadingSuggestions;
    const onEditOption = (option)=>{
        setSelectedLabelForEdit(option);
        setShowColorPickerPopup(true);
    };
    const resetLabelsColorPickerState = ()=>{
        setSelectedLabelForEdit(undefined);
        setShowColorPickerPopup(false);
        setShowColorPickerPopupWhenCreated(false);
    };
    const submitLabelsUpdatedColor = (param)=>{
        if (!selectedLabelForEdit) return;
        setMenuIsOpen(false);
        if (selectedLabelForEdit.__isNew__ && value) {
            const updatedColoredValue = value && value.map((val)=>{
                const isSelected = val.label === param.name;
                return {
                    ...val,
                    ...isSelected ? {
                        color: param?.color
                    } : {}
                };
            });
            onChange?.(updatedColoredValue);
        }
        const projectId = project?.projectId;
        let jiraProjectAri = null;
        try {
            jiraProjectAri = projectId && cloudId && (0, $epTsa.expVal)('adding-color-to-labels-field-experiment-milestone2', 'isColorfulNewLabelsEnabled', false) && (0, $3osLr.JiraProjectAri).create({
                siteId: cloudId,
                projectId: projectId.toString()
            }).toString();
        } catch (error) {
            (0, $eDBhy.fireIssueCreateErrorAnalytics)({
                meta: {
                    id: 'getProjectAriId',
                    packageName: 'jiraIssueFieldLabels',
                    teamName: 'gryffindor'
                },
                attributes: {
                    projectId: projectId,
                    cloudId: cloudId
                },
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
        const analyticsEvent = createAnalyticsEvent({});
        if (jiraProjectAri) commit({
            variables: {
                input: {
                    projectId: jiraProjectAri,
                    labelColorUpdate: [
                        {
                            fieldId: fieldId,
                            label: param.name,
                            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            color: param.color
                        }
                    ]
                }
            },
            optimisticResponse: {
                jira: {
                    bulkUpdateLabelColor: {
                        success: true,
                        errors: null
                    }
                }
            },
            onCompleted (mutationData) {
                if (mutationData?.jira?.bulkUpdateLabelColor?.success) {
                    fetchSuggestions();
                    const updatedSuggestions = suggestions && suggestions.map((label)=>{
                        const isSelected = label.label === param.name;
                        return {
                            ...label,
                            ...isSelected ? {
                                color: param.color
                            } : {}
                        };
                    });
                    setSuggestions(updatedSuggestions);
                    (0, $gCeeo.fireTrackAnalyticsDeferred)(analyticsEvent, 'labelColor updated', {
                        label: param,
                        isNewLabel: selectedLabelForEdit.__isNew__ || false
                    });
                } else {
                    const errorMessage = mutationData?.jira?.bulkUpdateLabelColor?.errors?.[0]?.message ?? undefined;
                    (0, $eDBhy.fireIssueCreateErrorAnalytics)({
                        meta: {
                            id: 'labelColorUpdate',
                            packageName: 'jiraIssueFieldLabels',
                            teamName: 'gryffindor'
                        },
                        attributes: {
                            label: param,
                            errorMessage: errorMessage,
                            isNewLabel: selectedLabelForEdit.__isNew__ || false
                        },
                        sendToPrivacyUnsafeSplunk: true
                    });
                }
            },
            onError (error) {
                (0, $eDBhy.fireIssueCreateErrorAnalytics)({
                    meta: {
                        id: 'labelColorUpdate',
                        packageName: 'jiraIssueFieldLabels',
                        teamName: 'gryffindor'
                    },
                    attributes: {
                        label: param
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        });
    };
    const popupContent = ()=>{
        const isNewLabel = selectedLabelForEdit?.__isNew__;
        const newLabelColor = selectedLabelForEdit?.color ?? '';
        const oldLabelColor = selectedLabelForEdit?.color ?? (0, $aCFLd.memoizeGetAutoGeneratedColorForLabels)(selectedLabelForEdit?.label?.toString());
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $39uVc.LabelsColorPickerForm), {
            onCancel: ()=>{
                resetLabelsColorPickerState();
            },
            onSubmit: (param)=>{
                resetLabelsColorPickerState();
                submitLabelsUpdatedColor(param);
            },
            initialData: {
                name: selectedLabelForEdit?.label?.toString() ?? '',
                color: isNewLabel ? newLabelColor : oldLabelColor
            },
            isNewLabel: isNewLabel || false
        });
    };
    const styles = (0, $eJOHy.useMemo)(()=>{
        if ((0, $epTsa.expVal)('adding-color-to-labels-field-in-jira-experiment', 'isColoredLabelsEnabled', false) || (0, $epTsa.expVal)('adding-color-to-labels-field-experiment-milestone2', 'isColorfulNewLabelsEnabled', false)) {
            if (!(0, $6XJko.isVisualRefreshEnabled)()) return {
                ...(0, $aUMMA.defaultSelectStyles),
                ...$0278e93500fcb1f8$var$labelsValueStyles,
                ...$0278e93500fcb1f8$var$labelsRemoveIconStyles
            };
            return {
                ...(0, $aUMMA.defaultSelectStyles),
                ...$0278e93500fcb1f8$var$labelsValueStyles
            };
        }
        return 0, $aUMMA.defaultSelectStyles;
    }, []);
    const styleComponents = (0, $eJOHy.useMemo)(()=>{
        if ((0, $epTsa.expVal)('adding-color-to-labels-field-experiment-milestone2', 'isColorfulNewLabelsEnabled', false) || (0, $epTsa.expVal)('adding-color-to-labels-field-in-jira-experiment', 'isColoredLabelsEnabled', false)) return {
            MultiValueContainer: (multiValueProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6XEne.components).MultiValueContainer, {
                    ...multiValueProps,
                    xcss: (0, $k0ahr.cx)($0278e93500fcb1f8$var$multiValueStyles.root, !(0, $6XJko.isVisualRefreshEnabled)() && $0278e93500fcb1f8$var$multiValueStyles.isVisualRefreshDisabled)
                }),
            MultiValueLabel: (multiValueLabelProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6XEne.components).MultiValueLabel, {
                    ...multiValueLabelProps,
                    xcss: $0278e93500fcb1f8$var$multiValueLabelStyles.root
                }),
            MultiValueRemove: (multiValueRemoveProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6XEne.components).MultiValueRemove, {
                    ...multiValueRemoveProps,
                    xcss: !(0, $6XJko.isVisualRefreshEnabled)() && $0278e93500fcb1f8$var$multiValueRemoveStyles.root
                })
        };
    }, []);
    const handleKeyDown = (e)=>{
        if (menuIsOpen === false && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) {
            setMenuIsOpen(true);
            isFocusingRef.current = false;
        }
        if (e.key === 'Enter') e.preventDefault();
        if (e.key === 'Escape') e.stopPropagation();
        const menu = e.currentTarget.querySelector('[role="dialog"]');
        if (!menu || ![
            'Tab',
            'ArrowDown',
            'ArrowUp'
        ].includes(e.key)) return;
        const buttons = Array.from(menu.querySelectorAll('button:not([disabled]), [role="group"] button:not([disabled])'));
        if (!buttons.length) return;
        e.preventDefault();
        const input = e.currentTarget.querySelector('input');
        const focusableElements = [
            input,
            ...buttons
        ].filter((el)=>el instanceof HTMLElement);
        const currentFocusIndex = focusableElements.findIndex((el)=>el === globalThis.document?.activeElement);
        let direction = 1;
        if (e.key === 'ArrowUp' || e.key === 'Tab' && e.shiftKey) direction = -1;
        const nextIndex = (currentFocusIndex + direction + focusableElements.length) % focusableElements.length;
        focusableElements[nextIndex]?.focus();
        if (nextIndex === 0) {
            isFocusingRef.current = false;
            onQueryChange('');
        } else isFocusingRef.current = true;
    };
    const labelsField = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cd713.default), {
        isMulti: true,
        autoFocus: autoFocus,
        fieldId: fieldId,
        options: groupedSuggestions,
        value: value,
        isDisabled: (0, $epTsa.expVal)('adding-color-to-labels-field-experiment-milestone2', 'isColorfulNewLabelsEnabled', false) ? isDisabled || (showColorPickerPopup || showColorPickerPopupWhenCreated) && !isInvalid : isDisabled,
        onBlur: onSelectBlur,
        menuPosition: menuPosition,
        styles: styles,
        onFocus: onSelectFocus,
        noOptionsMessage: getNoOptionsMessage,
        closeMenuOnScroll: onCloseMenuOnScroll,
        loadingMessage: getLoadingMessage,
        placeholder: formatMessage((0, $edfym.default).placeholder),
        onInputChange: onQueryChange,
        onChange: onChange,
        spacing: spacing,
        isLoading: (0, $epTsa.expVal)('adding-color-to-labels-field-experiment-milestone2', 'isColorfulNewLabelsEnabled', false) ? menuIsOpen && isLoading : isLoading,
        filterOption: filterOption,
        ...(0, $epTsa.expVal)('adding-color-to-labels-field-experiment-milestone2', 'isColorfulNewLabelsEnabled', false) ? {
            isValidNewOption: (inputValue)=>inputValue !== '' && isNewLabelText(inputValue),
            onCreateOption: handleCreateOption,
            menuIsOpen: menuIsOpen && !showColorPickerPopupWhenCreated && !showColorPickerPopup
        } : {},
        formatCreateLabel: getCreateLabel,
        ...!(0, $epTsa.expVal)('adding-color-to-labels-field-experiment-milestone2', 'isColorfulNewLabelsEnabled', false) && (0, $epTsa.expVal)('adding-color-to-labels-field-in-jira-experiment', 'isColoredLabelsEnabled', false) ? {
            formatOptionLabel: (option)=>$0278e93500fcb1f8$var$RenderLabel(option, `(${formatMessage((0, $edfym.default).createNewItem)})`)
        } : {},
        components: (0, $epTsa.expVal)('adding-color-to-labels-field-experiment-milestone2', 'isColorfulNewLabelsEnabled', false) ? {
            ...styleComponents,
            Option: (optionProps)=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0278e93500fcb1f8$var$LabelFocusableOption, {
                    optionProps: optionProps,
                    createNewLabelString: formatCreateLabel !== undefined ? `(${formatCreateLabel})` : `(${formatMessage((0, $edfym.default).createNewItem)})`,
                    onEditOption: onEditOption,
                    lastFocusedKey: lastFocusedKey,
                    isManuallyFocusing: isManuallyFocusing,
                    isProjectAdmin: isProjectAdmin || false,
                    isGlobalAdmin: isGlobalAdmin || false
                });
            }
        } : styleComponents,
        validationState: isInvalid === true ? 'error' : null,
        sessionId: sessionId.current,
        "aria-label": ariaLabel,
        inputId: inputId,
        isRequired: isRequired,
        openMenuOnFocus: openMenuOnFocus,
        ...(0, $epTsa.expVal)('adding-color-to-labels-field-experiment-milestone2', 'isColorfulNewLabelsEnabled', false) ? {
            UNSAFE_is_experimental_generic: true,
            onKeyDown: handleKeyDown
        } : {}
    });
    return !isInvalid && (showColorPickerPopup || showColorPickerPopupWhenCreated) && (0, $epTsa.expVal)('adding-color-to-labels-field-experiment-milestone2', 'isColorfulNewLabelsEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cNe2t.JiraPopup), {
        zIndex: (0, $IW7jS.layers).modal(),
        isOpen: showColorPickerPopup || showColorPickerPopupWhenCreated,
        autoFocus: false,
        placement: "bottom-start",
        fallbackPlacements: [
            'bottom-end'
        ],
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
                ...triggerProps,
                role: "menu"
            }, labelsField),
        popupComponent: $0278e93500fcb1f8$var$PopupContainer,
        onClose: resetLabelsColorPickerState,
        content: popupContent,
        messageId: "issue-field-labels.ui.edit.popup.labels.popup",
        messageType: "transactional"
    }) : labelsField;
};
const $0278e93500fcb1f8$var$LabelFocusableOption = ({ optionProps: optionProps, createNewLabelString: createNewLabelString, onEditOption: onEditOption, lastFocusedKey: lastFocusedKey, isManuallyFocusing: isManuallyFocusing, isProjectAdmin: isProjectAdmin, isGlobalAdmin: isGlobalAdmin })=>{
    const [isOptionFocused, setIsOptionFocused] = (0, $eJOHy.useState)(false);
    const [isOptionHovered, setIsOptionHovered] = (0, $eJOHy.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6XEne.components).Option, {
        ...optionProps,
        isFocused: isOptionFocused || isOptionHovered
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0278e93500fcb1f8$export$b1ba072352f6f9fd, {
        option: optionProps.data,
        createNewLabelString: createNewLabelString,
        onEditOption: onEditOption,
        lastFocusedKey: lastFocusedKey,
        isManuallyFocusing: isManuallyFocusing,
        isProjectAdmin: isProjectAdmin,
        isGlobalAdmin: isGlobalAdmin,
        isOptionFocused: isOptionFocused,
        isOptionHovered: isOptionHovered,
        setIsOptionFocused: setIsOptionFocused,
        setIsOptionHovered: setIsOptionHovered
    }));
};
const $0278e93500fcb1f8$var$RenderLabel = (option, createNewLabelString)=>{
    // @ts-expect-error - ts2322 - Type 'ReactNode' is not assignable to type 'string'.
    const optionLabel = option.label;
    if (typeof optionLabel === 'string' && optionLabel.endsWith(createNewLabelString)) {
        const optionLabelWithoutNewLabel = optionLabel.slice(0, -createNewLabelString.length).trim();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kp5kj.OptionTag), {
            name: optionLabel,
            color: (0, $aCFLd.memoizeGetAutoGeneratedColorForLabels)(optionLabelWithoutNewLabel)
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kp5kj.OptionTag), {
        name: optionLabel,
        color: (0, $aCFLd.memoizeGetAutoGeneratedColorForLabels)(optionLabel)
    });
};
const $0278e93500fcb1f8$export$b1ba072352f6f9fd = ({ option: option, createNewLabelString: createNewLabelString, onEditOption: onEditOption, lastFocusedKey: lastFocusedKey, isManuallyFocusing: isManuallyFocusing, isProjectAdmin: isProjectAdmin, isGlobalAdmin: isGlobalAdmin, isOptionFocused: isOptionFocused, isOptionHovered: isOptionHovered, setIsOptionFocused: setIsOptionFocused, setIsOptionHovered: setIsOptionHovered })=>{
    // @ts-expect-error - ts2322 - Type 'ReactNode' is not assignable to type 'string'.
    const optionLabel = option.label;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const pressableRefsNew = (0, $eJOHy.useRef)({});
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (!lastFocusedKey.current) return;
        const { key: key, index: index, type: type } = lastFocusedKey.current;
        if (isManuallyFocusing && pressableRefsNew?.current[key]?.[index] && type === 'button') requestAnimationFrame(()=>{
            pressableRefsNew?.current[key]?.[index]?.focus();
        });
    }, [
        isManuallyFocusing,
        lastFocusedKey
    ]);
    if (typeof optionLabel === 'string' && optionLabel.endsWith(createNewLabelString)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $0278e93500fcb1f8$var$optionContentStyles,
        role: "group",
        tabIndex: -1,
        onMouseOver: ()=>{
            setIsOptionFocused?.(false);
            setIsOptionHovered?.(true);
        },
        onMouseOut: ()=>setIsOptionHovered?.(false),
        onFocus: ()=>{
            setIsOptionHovered?.(false);
            setIsOptionFocused?.(true);
        },
        onBlur: (e)=>{
            const relatedTarget = e.relatedTarget;
            if (!e.currentTarget.contains(relatedTarget)) setIsOptionFocused?.(false);
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bQP4O.default), {
        xcss: $0278e93500fcb1f8$var$pressableStyles,
        backgroundColor: "color.background.neutral.subtle",
        onKeyDown: (e)=>{
            if (e.key === 'Enter' || e.key === ' ') {
                e.stopPropagation(); // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const input = globalThis.document.querySelector('input#labels-field');
                requestAnimationFrame(()=>{
                    input?.focus();
                });
            }
        },
        onFocus: ()=>{
            const focusedKey = lastFocusedKey; // eslint-disable-next-line react-hooks/react-compiler
            focusedKey.current = {
                key: optionLabel,
                index: 0,
                type: 'button'
            };
        },
        ref: (el)=>{
            if (!el) return;
            if (!pressableRefsNew?.current[optionLabel]) pressableRefsNew.current[optionLabel] = [];
            if (!pressableRefsNew.current[optionLabel].includes(el)) pressableRefsNew.current[optionLabel].push(el);
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kp5kj.OptionTag), {
        name: optionLabel,
        color: (0, $cNNNb.GREY_META).name
    })));
    const iconButtonLabel = formatMessage((0, $edfym.default).editOption, {
        optionName: optionLabel
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $0278e93500fcb1f8$var$optionContentStyles,
        role: "group",
        tabIndex: -1,
        onMouseOver: ()=>{
            setIsOptionFocused?.(false);
            setIsOptionHovered?.(true);
        },
        onMouseOut: ()=>setIsOptionHovered?.(false),
        onFocus: ()=>{
            setIsOptionHovered?.(false);
            setIsOptionFocused?.(true);
        },
        onBlur: (e)=>{
            const relatedTarget = e.relatedTarget;
            if (!e.currentTarget.contains(relatedTarget)) setIsOptionFocused?.(false);
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bQP4O.default), {
        xcss: $0278e93500fcb1f8$var$pressableStyles,
        backgroundColor: "color.background.neutral.subtle",
        onKeyDown: (e)=>{
            if (e.key === 'Enter' || e.key === ' ') {
                e.stopPropagation(); // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const input = globalThis.document.querySelector('input#labels-field');
                requestAnimationFrame(()=>{
                    input?.focus();
                });
            }
        },
        onFocus: ()=>{
            const focusedKeyRef = lastFocusedKey;
            focusedKeyRef.current = {
                key: optionLabel,
                index: 0,
                type: 'button'
            };
        },
        ref: (el)=>{
            if (!el) return; // Initialize array if not already present
            if (!pressableRefsNew?.current[optionLabel]) pressableRefsNew.current[optionLabel] = [];
             // Avoid duplicate refs
            if (!pressableRefsNew.current[optionLabel].includes(el)) pressableRefsNew.current[optionLabel].push(el);
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kp5kj.OptionTag), {
        name: optionLabel,
        color: option.color ?? (0, $aCFLd.memoizeGetAutoGeneratedColorForLabels)(optionLabel),
        isColoredLabel: true
    })), $0278e93500fcb1f8$var$RenderInlineEditButton(option, lastFocusedKey, onEditOption, pressableRefsNew, isProjectAdmin, isGlobalAdmin, isOptionFocused || isOptionHovered, iconButtonLabel));
};
const $0278e93500fcb1f8$var$RenderInlineEditButton = (option, lastFocusedKey, onEditOption, pressableRefsNew, isProjectAdmin, isGlobalAdmin, isFocused, iconButtonLabel)=>{
    // @ts-expect-error - ts2322 - Type 'ReactNode' is not assignable to type 'string'.
    const optionLabel = option.label;
    if ((isProjectAdmin || isGlobalAdmin) && option.label && isFocused) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
        ref: (el)=>{
            if (!el) return;
            if (!pressableRefsNew?.current[optionLabel].includes(el)) pressableRefsNew?.current[optionLabel].push(el);
        },
        onKeyDown: (e)=>{
            if (e.key === 'Enter' || e.key === ' ') e.stopPropagation();
        },
        onFocus: ()=>{
            const focusedKeyRef = lastFocusedKey;
            focusedKeyRef.current = {
                key: optionLabel,
                index: 1,
                type: 'button'
            };
        },
        testId: `labels-field-edit.inline-edit-button-${option.label}`,
        isDisabled: option.isDisabled,
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gTr6H))),
        spacing: "compact",
        tabIndex: 0,
        onClick: (event)=>{
            event.stopPropagation();
            onEditOption?.(option);
        },
        label: iconButtonLabel
    });
};
const $0278e93500fcb1f8$var$PopupContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        ...props,
        ref: ref
    }));
var $0278e93500fcb1f8$export$2e2bcd8739ae039 = $0278e93500fcb1f8$export$23584166c0ffb901;
const $0278e93500fcb1f8$var$optionContentStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    justifyContent: 'space-between'
});
const $0278e93500fcb1f8$var$pressableStyles = (0, $1DXK0.xcss)({
    height: '24px'
});

});
parcelRegister("b4alz", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6d5ae8ce6437642$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c8bbe7fd276f3e0e312fc041dd95ffeb>>
 * @relayHash 60dd021592867dbbf77e4481d94ec0dc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID bd9e30f5fd96ad77f2c8b9fc668ac31b357e455dc0253b311708cf72a84e9250
const $b6d5ae8ce6437642$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "input",
                            "variableName": "input"
                        }
                    ],
                    "concreteType": "JiraBulkLabelColorUpdatePayload",
                    "kind": "LinkedField",
                    "name": "bulkUpdateLabelColor",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "success"
                        },
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "message"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "edit_labelsUpdateColorMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "edit_labelsUpdateColorMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "bd9e30f5fd96ad77f2c8b9fc668ac31b357e455dc0253b311708cf72a84e9250",
            "metadata": {},
            "name": "edit_labelsUpdateColorMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$b6d5ae8ce6437642$var$node.hash = "45b4d9e9cdae63b87911a8d2424bce9d";
var $b6d5ae8ce6437642$export$2e2bcd8739ae039 = $b6d5ae8ce6437642$var$node;

});

parcelRegister("gTr6H", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ce3559d453dff44735097f553c900f9f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c4c6cf489c8bf4fc$var$_react = $c4c6cf489c8bf4fc$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $c4c6cf489c8bf4fc$var$_baseNew = $c4c6cf489c8bf4fc$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $c4c6cf489c8bf4fc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Edit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c4c6cf489c8bf4fc$var$EditIcon = (props)=>/*#__PURE__*/ $c4c6cf489c8bf4fc$var$_react.default.createElement($c4c6cf489c8bf4fc$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11.586.854a2 2 0 0 1 2.828 0l.732.732a2 2 0 0 1 0 2.828L10.01 9.551a2 2 0 0 1-.864.51l-3.189.91a.75.75 0 0 1-.927-.927l.91-3.189a2 2 0 0 1 .51-.864zm1.768 1.06a.5.5 0 0 0-.708 0l-.585.586L13.5 3.94l.586-.586a.5.5 0 0 0 0-.707zM12.439 5 11 3.56 7.51 7.052a.5.5 0 0 0-.128.217l-.54 1.89 1.89-.54a.5.5 0 0 0 .217-.127zM3 2.501a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5v-3H15v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-10a2 2 0 0 1 2-2h3v1.5z" clip-rule="evenodd"/>`
    }, props));
$c4c6cf489c8bf4fc$var$EditIcon.displayName = 'EditIcon';
var $c4c6cf489c8bf4fc$var$_default = module.exports.default = $c4c6cf489c8bf4fc$var$EditIcon;

});

parcelRegister("39uVc", function(module, exports) {

$parcel$export(module.exports, "LabelsColorPickerForm", () => $53122d96f4e70f8e$export$db58e0ba069ba689);

var $eJOHy = parcelRequire("eJOHy");

var $5CSKW = parcelRequire("5CSKW");

var $8nu6j = parcelRequire("8nu6j");
var $lmgo6 = parcelRequire("lmgo6");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $kT4JG = parcelRequire("kT4JG");

var $kp5kj = parcelRequire("kp5kj");

var $cNNNb = parcelRequire("cNNNb");

var $gnomV = parcelRequire("gnomV");
const $53122d96f4e70f8e$export$db58e0ba069ba689 = /*#__PURE__*/ (0, $eJOHy.memo)(({ onCancel: onCancel, onSubmit: onSubmit, initialData: initialData, isNewLabel: isNewLabel = false })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { color: color, name: name } = initialData;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [currentColor, setCurrentColor] = (0, $eJOHy.useState)(!color ? (0, $cNNNb.GREY_META).name : color);
    (0, $eJOHy.useEffect)(()=>{
        (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'LabelsColorPickerForm viewed', {
            isNewLabel: isNewLabel
        });
    }, [
        createAnalyticsEvent,
        isNewLabel
    ]);
    const handleSubmit = (0, $eJOHy.useCallback)(()=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'LabelsColorPickerFormSave', {
            isNewLabel: isNewLabel
        });
        onSubmit && onSubmit({
            name: name,
            color: currentColor
        });
    }, [
        createAnalyticsEvent,
        isNewLabel,
        onSubmit,
        name,
        currentColor
    ]);
    const handleCancel = (0, $eJOHy.useCallback)(()=>{
        onCancel();
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'LabelsColorPickerFormCancel', {
            isNewLabel: isNewLabel
        });
    }, [
        onCancel,
        createAnalyticsEvent,
        isNewLabel
    ]);
    const handleKeyDownEvent = (0, $eJOHy.useCallback)((event)=>{
        if (event.key === 'Escape' || event.key === 'Esc' || event.keyCode === 27) handleCancel();
        if (event.key === 'Enter' || event.keyCode === 13) {
            handleSubmit();
            event.preventDefault();
        }
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') event.stopPropagation();
    }, [
        handleCancel,
        handleSubmit
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (typeof window !== 'undefined') {
            window.addEventListener('keydown', handleKeyDownEvent, true);
            return ()=>{
                window.removeEventListener('keydown', handleKeyDownEvent, true);
            };
        }
    }, [
        handleKeyDownEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $53122d96f4e70f8e$var$formStyles,
            $53122d96f4e70f8e$var$maxWidthStyles
        ],
        backgroundColor: "elevation.surface.overlay"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $53122d96f4e70f8e$var$formContentStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $53122d96f4e70f8e$var$colorPickerWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kT4JG.ColorPickerMenu), {
        onChangeColor: (newColor)=>{
            setCurrentColor(newColor);
            (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'color clicked', 'LabelsFormColorPicker', {
                color: newColor,
                isNewLabel: isNewLabel
            });
        },
        color: currentColor,
        colorPaletteVariant: "new",
        colorCardVariant: "outline"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        justifyContent: "space-between",
        xcss: $53122d96f4e70f8e$var$buttonContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $53122d96f4e70f8e$var$previewStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kp5kj.OptionTag), {
        name: name,
        color: currentColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
        onBlur: (e)=>{
            if (!e.relatedTarget) e.stopPropagation();
        },
        appearance: "primary",
        spacing: "compact",
        testId: "option-color-picker.labels-color-picker.submit-button",
        onClick: handleSubmit
    }, formatMessage((0, $gnomV.default).saveButton)))));
});
const $53122d96f4e70f8e$var$formStyles = (0, $1DXK0.xcss)({
    borderRadius: 'border.radius',
    boxShadow: 'elevation.shadow.overlay',
    display: 'block',
    padding: 'space.200',
    width: 'fit-content'
});
const $53122d96f4e70f8e$var$maxWidthStyles = (0, $1DXK0.xcss)({
    maxWidth: '356px'
});
const $53122d96f4e70f8e$var$colorPickerWrapperStyles = (0, $1DXK0.xcss)({
    marginBottom: 'space.150'
});
const $53122d96f4e70f8e$var$formContentStyles = (0, $1DXK0.xcss)({
    marginTop: 'space.100'
});
const $53122d96f4e70f8e$var$previewStyles = (0, $1DXK0.xcss)({
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    maxWidth: '180px'
});
const $53122d96f4e70f8e$var$buttonContainerStyles = (0, $1DXK0.xcss)({
    marginLeft: 'space.050',
    marginRight: 'space.050'
});

});
parcelRegister("kT4JG", function(module, exports) {

$parcel$export(module.exports, "ColorPickerMenu", () => $7f9e35b8f6eaec4c$export$4f039f014adbb6f0);

var $eJOHy = parcelRequire("eJOHy");

var $7PKEg = parcelRequire("7PKEg");
var $7hYf3 = parcelRequire("7hYf3");

var $lRq8t = parcelRequire("lRq8t");

var $cNNNb = parcelRequire("cNNNb");

var $051tO = parcelRequire("051tO");
const $7f9e35b8f6eaec4c$export$4f039f014adbb6f0 = ({ color: color, onChangeColor: onChangeColor, colorPaletteVariant: colorPaletteVariant = 'old', colorCardVariant: colorCardVariant = 'fill' })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const getColorPalette = ()=>{
        switch(colorPaletteVariant){
            case 'new':
                return 0, $cNNNb.OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT;
            case 'newDarker':
                return 0, $cNNNb.OPTION_COLOR_THEMES_COLORFUL_DARKER_SINGLE_SELECT;
            case 'old':
            default:
                return 0, $cNNNb.OPTION_COLOR_THEMES;
        }
    };
    const colorPalette = getColorPalette().map(({ backgroundColor: backgroundColor, messageLabel: messageLabel })=>({
            label: formatMessage(messageLabel),
            value: backgroundColor
        }));
    const handleChangeColor = (0, $eJOHy.useCallback)((e, newColor)=>{
        onChangeColor((0, $051tO.getColorNameFromValue)(newColor));
        e.stopPropagation();
    }, [
        onChangeColor
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7PKEg.default), {
        cols: colorPaletteVariant === 'old' ? colorPalette.length / 5 : colorPalette.length,
        palette: colorPalette,
        selectedColor: (0, $051tO.getValueFromColorName)(color),
        onChange: handleChangeColor,
        mode: (0, $7hYf3.Compact),
        checkMarkColor: color.includes('LIGHT') ? (0, $cNNNb.CHECK_MARK_COLOR_LIGHT) : (0, $cNNNb.CHECK_MARK_COLOR_DARK),
        autoFocus: false,
        isFocusLockEnabled: false,
        isInsideMenu: false,
        variant: colorCardVariant
    });
};

});
parcelRegister("051tO", function(module, exports) {

$parcel$export(module.exports, "getRandomColor", () => $3b3f14c0d0659bfe$export$e4369cabd7e84cd9);
$parcel$export(module.exports, "getColorNameFromValue", () => $3b3f14c0d0659bfe$export$b5ccbadd112d8ce9);
$parcel$export(module.exports, "getValueFromColorName", () => $3b3f14c0d0659bfe$export$9eff62e8ee2aaa2c);
$parcel$export(module.exports, "getColorMetadata", () => $3b3f14c0d0659bfe$export$49fce7fdcf55f26d);

var $cNNNb = parcelRequire("cNNNb");
const $3b3f14c0d0659bfe$export$e4369cabd7e84cd9 = ({ colorPaletteVariant: colorPaletteVariant = '' } = {})=>{
    // usign colorPaletteVariant to determine which color palette to use for random color selection
    const palette = colorPaletteVariant === 'newDarker' ? (0, $cNNNb.OPTION_COLOR_THEMES_COLORFUL_DARKER_SINGLE_SELECT) : (0, $cNNNb.OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT);
    const randomIndex = Math.floor(Math.random() * palette.length);
    return palette[randomIndex].name;
};
const $3b3f14c0d0659bfe$export$b5ccbadd112d8ce9 = (colorValue)=>(0, $cNNNb.OPTION_COLOR_THEMES).find((item)=>item.backgroundColor === colorValue)?.name ?? '';
const $3b3f14c0d0659bfe$export$9eff62e8ee2aaa2c = (colorName)=>(0, $cNNNb.OPTION_COLOR_THEMES_MAP)[colorName]?.backgroundColor ?? '';
const $3b3f14c0d0659bfe$export$49fce7fdcf55f26d = (colorName)=>{
    if (!colorName) return 0, $cNNNb.GREY_META;
    return (0, $cNNNb.OPTION_COLOR_THEMES_MAP)[colorName] ?? (0, $cNNNb.GREY_META);
};
const $3b3f14c0d0659bfe$export$4ef6b7574883e63d = ()=>(0, $cNNNb.OPTION_COLOR_THEMES).map((item)=>item.name);

});


parcelRegister("kp5kj", function(module, exports) {

$parcel$export(module.exports, "OptionTag", () => $3f06606f2017e535$export$5991b62d89f5cc);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $k71qx = parcelRequire("k71qx");

var $epTsa = parcelRequire("epTsa");

var $051tO = parcelRequire("051tO");
const $3f06606f2017e535$export$5991b62d89f5cc = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)(({ name: name, color: color, isInteractive: isInteractive = true, showTooltip: showTooltip = false, isColoredLabel: isColoredLabel }, ref)=>{
    const { backgroundColor: tagColor } = (0, $051tO.getColorMetadata)(color);
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $3f06606f2017e535$var$tagWrapperStyles,
            isInteractive && $3f06606f2017e535$var$interactiveStyles
        ],
        "aria-label": name,
        testId: "option-color-picker.option-tag.field-tag-wrapper",
        ref: ref
    }, isColoredLabel && (0, $epTsa.expVal)('adding-color-to-labels-field-experiment-milestone2', 'isColorfulNewLabelsEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        testId: `option-color-picker.option-tag.${color || 'default'}`,
        xcss: $3f06606f2017e535$var$styledTagsStyles,
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            borderColor: tagColor
        }
    }, name) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3f06606f2017e535$var$StyledTag, {
        "data-testid": `option-color-picker.option-tag.${color || 'default'}`,
        color: tagColor
    }, name));
    return showTooltip ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $3f06606f2017e535$var$tooltipStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: name
    }, content)) : content;
}));
const $3f06606f2017e535$var$tooltipStyles = (0, $1DXK0.xcss)({
    overflow: 'hidden'
});
const $3f06606f2017e535$var$tagWrapperStyles = (0, $1DXK0.xcss)({
    display: 'inline-flex',
    justifyContent: 'left',
    alignItems: 'center',
    transition: '0.3s',
    maxWidth: '100%',
    minWidth: '0',
    minHeight: '0',
    color: 'color.text'
});
const $3f06606f2017e535$var$interactiveStyles = (0, $1DXK0.xcss)({
    ':hover': {
        cursor: 'pointer'
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3f06606f2017e535$var$StyledTagBase = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c82smr _1reo15vq _18m915vq _vwz4f6fq _1bto1l2s _o5721q9c _p12f1osq",
            __cmplp.className
        ])
    });
});
const $3f06606f2017e535$var$StyledTag = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $3f06606f2017e535$var$StyledTagBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_14v0t1n": (0, $awdRS.default)(`1px solid ${__cmplp.color}`)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko5n0m _19it11we _bfhk18uv _u5f31b66 _19bv1b66",
            __cmplp.className
        ])
    });
});
const $3f06606f2017e535$var$styledTagsStyles = (0, $1DXK0.xcss)({
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    borderRadius: "var(--ds-border-radius-100, 4px)",
    backgroundColor: 'color.background.neutral.subtle',
    borderStyle: 'solid',
    borderWidth: '1px',
    paddingRight: 'space.050',
    paddingLeft: 'space.050',
    maxWidth: '180px'
});

});

parcelRegister("gnomV", function(module, exports) {

$parcel$export(module.exports, "default", () => $64b82de36165740a$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $64b82de36165740a$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    saveButton: {
        "id": "jira-option-color-picker.labels-color-picker.save-button",
        "defaultMessage": "Save \u23CE"
    }
});

});


parcelRegister("aCFLd", function(module, exports) {

$parcel$export(module.exports, "memoizeGetAutoGeneratedColorForLabels", () => $3bdc301abc6592d1$export$8100203285e9ab92);
$parcel$export(module.exports, "memoizeGetAutoGeneratedColorForLabelsTag", () => $3bdc301abc6592d1$export$a80529ae8ec44f02);

var $5PQOA = parcelRequire("5PQOA");

var $cNNNb = parcelRequire("cNNNb");

var $1mQND = parcelRequire("1mQND");

var $eFge8 = parcelRequire("eFge8");
const $3bdc301abc6592d1$export$97056d4b28203ee9 = (option)=>{
    if (option) {
        const hashValue = (0, $1mQND.getHashValueForText)(option);
        const randomIndex = (0, $eFge8.getRandomIndex)(hashValue);
        return (0, $cNNNb.OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT)[randomIndex].name;
    }
    return (0, $cNNNb.GREY_META).name;
};
const $3bdc301abc6592d1$export$a3f5334e7a13e57a = (option)=>{
    if (option) {
        const hashValue = (0, $1mQND.getHashValueForText)(option);
        const randomIndex = (0, $eFge8.getRandomIndex)(hashValue);
        return (0, $cNNNb.OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT)[randomIndex].tagColor;
    }
    return (0, $cNNNb.GREY_META).tagColor;
};
const $3bdc301abc6592d1$export$8100203285e9ab92 = (0, (/*@__PURE__*/$parcel$interopDefault($5PQOA)))($3bdc301abc6592d1$export$97056d4b28203ee9);
const $3bdc301abc6592d1$export$a80529ae8ec44f02 = (0, (/*@__PURE__*/$parcel$interopDefault($5PQOA)))($3bdc301abc6592d1$export$a3f5334e7a13e57a);

});
parcelRegister("1mQND", function(module, exports) {

$parcel$export(module.exports, "getHashValueForText", () => $682ff2f1c6e48764$export$e352defce701b36e);

const $682ff2f1c6e48764$export$e352defce701b36e = (text)=>{
    let hashValue = 0;
    for(let i = 0; i < text.length; i++)hashValue = (hashValue * (0, $12800e69511f991d$export$d15e38bcd75fda7c) + text.charCodeAt(i)) % (0, $12800e69511f991d$export$e143f4b09221a374);
    return hashValue;
};

});
/*
 * This is used to calculate the hash value of the provided text,
 * allowing us to generate random hash values for the options in the Labels field.
 * As a result, we enhance the randomization of color assignments to Labels.
 */ const $12800e69511f991d$export$d15e38bcd75fda7c = 256;
const $12800e69511f991d$export$e143f4b09221a374 = 1000000007;


parcelRegister("eFge8", function(module, exports) {

$parcel$export(module.exports, "getRandomIndex", () => $e4e4b7d26b0de284$export$cb0dffe2d2ae675a);

var $cNNNb = parcelRequire("cNNNb");
const $e4e4b7d26b0de284$export$cb0dffe2d2ae675a = (hashValue)=>{
    const colorThemesLength = (0, $cNNNb.OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT).length;
    const randomIndex = hashValue % colorThemesLength;
    return randomIndex;
};

});


parcelRegister("k4FEf", function(module, exports) {

$parcel$export(module.exports, "useLabelsSuggestions", () => $d749ce6c38626946$export$c5b80cd78ff71c5f);

var $eJOHy = parcelRequire("eJOHy");

var $gPCSe = parcelRequire("gPCSe");

var $jGzN3 = parcelRequire("jGzN3");

var $2AxRD = parcelRequire("2AxRD");

var $814y1 = parcelRequire("814y1");

var $ftN6c = parcelRequire("ftN6c");
const $d749ce6c38626946$export$343652b9755c68e7 = async (autoCompleteUrl, query, sessionId)=>{
    let url = `${autoCompleteUrl}${encodeURIComponent(query)}`;
    if (sessionId !== undefined && sessionId !== null) url = `${url}&sessionId=${sessionId}`;
    return (0, $jGzN3.performGetRequest)(url);
};
const $d749ce6c38626946$export$c5b80cd78ff71c5f = (props)=>{
    const { fieldId: fieldId, getSuggestions: getSuggestions = $d749ce6c38626946$export$343652b9755c68e7 } = props;
    const [isLoadingSuggestions, setIsLoadingSuggestions] = (0, $eJOHy.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const getLabelsSuggestions = (0, $eJOHy.useCallback)(async (autoCompleteUrl, query, sessionId)=>{
        const startTime = (0, $gPCSe.default).now();
        const queryLength = query.length;
        try {
            const response = await getSuggestions(autoCompleteUrl, query, sessionId);
            if (fieldId === (0, $814y1.LABELS_TYPE)) (0, $2AxRD.fireSuggestionsRequestSuccessEvent)((0, $814y1.LABELS_TYPE), startTime, createAnalyticsEvent, {
                sessionId: sessionId,
                queryLength: queryLength
            });
            setIsLoadingSuggestions(false);
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (fieldId === (0, $814y1.LABELS_TYPE)) (0, $2AxRD.fireSuggestionsRequestFailedEvent)((0, $814y1.LABELS_TYPE), startTime, createAnalyticsEvent, {
                sessionId: sessionId
            });
            setIsLoadingSuggestions(false);
            throw error;
        }
    }, [
        createAnalyticsEvent,
        fieldId,
        getSuggestions,
        setIsLoadingSuggestions
    ]);
    const actions = (0, $eJOHy.useMemo)(()=>({
            getLabelsSuggestions: getLabelsSuggestions,
            setIsLoadingSuggestions: setIsLoadingSuggestions
        }), [
        getLabelsSuggestions,
        setIsLoadingSuggestions
    ]);
    return [
        {
            isLoadingSuggestions: isLoadingSuggestions
        },
        actions
    ];
};

});
parcelRegister("2AxRD", function(module, exports) {

$parcel$export(module.exports, "fireSuggestionsRequestSuccessEvent", () => $0416cb67b864def2$export$7eeca21c46efa338);
$parcel$export(module.exports, "fireSuggestionsRequestFailedEvent", () => $0416cb67b864def2$export$a31ac580130dee62);

var $gPCSe = parcelRequire("gPCSe");

var $gCeeo = parcelRequire("gCeeo");
const $0416cb67b864def2$var$fireRequestEvent = (action, actionSubject, startTime, createAnalyticsEvent, additionalAttributes)=>{
    const attributes = {
        ...additionalAttributes,
        elapsedTimeMs: (0, $gPCSe.default).now() - startTime
    };
    createAnalyticsEvent && (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({
        action: action,
        actionSubject: actionSubject
    }), `${actionSubject} ${action}`, attributes);
};
const $0416cb67b864def2$export$7eeca21c46efa338 = (fieldId, startTime, createAnalyticsEvent, additionalAttributes)=>{
    $0416cb67b864def2$var$fireRequestEvent('succeeded', `${fieldId}Suggestions`, startTime, createAnalyticsEvent, additionalAttributes);
};
const $0416cb67b864def2$export$a31ac580130dee62 = (fieldId, startTime, createAnalyticsEvent, additionalAttributes)=>{
    $0416cb67b864def2$var$fireRequestEvent('failed', `${fieldId}Suggestions`, startTime, createAnalyticsEvent, additionalAttributes);
};

});


parcelRegister("cd713", function(module, exports) {

$parcel$export(module.exports, "default", () => $8bd5b276bfccea4d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");

var $jPROM = parcelRequire("jPROM");

var $aXKmr = parcelRequire("aXKmr");

var $kVcjU = parcelRequire("kVcjU");

var $fTI0O = parcelRequire("fTI0O");

var $gPCSe = parcelRequire("gPCSe");

var $bGaT8 = parcelRequire("bGaT8");

var $hjf2q = parcelRequire("hjf2q");
var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $7y1rb = parcelRequire("7y1rb");
const $8bd5b276bfccea4d$var$ANALYTICS_PAYLOAD_TRUNCATION_SIZE = 20;
const $8bd5b276bfccea4d$var$analyticsProps = {
    onChange: 'valueChanged',
    onInputChange: 'inputChanged',
    onMenuOpen: 'menuOpened',
    onMenuClose: 'menuClosed'
};
const $8bd5b276bfccea4d$export$53574ab050410077 = (0, $hjf2q.AnalyticsEventToProps)('select', $8bd5b276bfccea4d$var$analyticsProps)((0, $kVcjU.default));
const $8bd5b276bfccea4d$var$CreatableSelectWithAnalyticsView = (props)=>{
    const { fieldId: fieldId, isLoading: isLoading, onChange: onChange, onInputChange: onInputChange, options: options, value: value, isDisabled: isDisabled, sessionId: customSessionId, isMulti: isMulti, inputId: inputId, isRequired: isRequired, aiSuggestedLabelsError: aiSuggestedLabelsError, shouldFireAiLabelsInitiatedEvent: shouldFireAiLabelsInitiatedEvent = false, aiSuggestedLabelsInstrumentationId: aiSuggestedLabelsInstrumentationId = '' } = props;
    const sessionId = (0, $eJOHy.useRef)(customSessionId);
    const sessionStartedAt = (0, $eJOHy.useRef)(0);
    const [flatOptions, setFlatOptions] = (0, $eJOHy.useState)((0, $7y1rb.flattenOptions)(options));
    const [queryAtSetValue, setQueryAtSetValue] = (0, $eJOHy.useState)('');
    const [savedQuery, setSavedQuery] = (0, $eJOHy.useState)('');
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const getAnalyticsAttributes = (0, $eJOHy.useCallback)((query)=>{
        const selectedOptions = !(0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(value) ? value : [];
        let filteredOptions = (0, $7y1rb.filterOptions)(flatOptions, query);
        const optionsLength = filteredOptions.length;
        // truncate to reduce payload size
        filteredOptions = filteredOptions.slice(0, $8bd5b276bfccea4d$var$ANALYTICS_PAYLOAD_TRUNCATION_SIZE);
        const safeFilteredOptions = (0, $7y1rb.getSafeOptionsForAnalytics)(filteredOptions);
        return {
            inputId: inputId,
            required: isRequired,
            fieldId: fieldId,
            isLoading: isLoading,
            isDisabled: isDisabled,
            optionsLength: optionsLength,
            componentName: 'select',
            packageName: '@atlaskit/select',
            optionValuesSafeForAnalytics: false,
            options: safeFilteredOptions,
            optionsLengths: (0, $7y1rb.getOptionValuesLengths)(filteredOptions),
            queryLength: query.length,
            queryHash: query === '' ? query : (0, $bGaT8.memoizedHashString)(query),
            selectedOptions: (0, $7y1rb.getSafeOptionsForAnalytics)(selectedOptions),
            selectedOptionsLengths: (0, $7y1rb.getOptionValuesLengths)(selectedOptions),
            sessionId: sessionId.current,
            truncationSize: $8bd5b276bfccea4d$var$ANALYTICS_PAYLOAD_TRUNCATION_SIZE
        };
    }, [
        value,
        flatOptions,
        inputId,
        isRequired,
        fieldId,
        isLoading,
        isDisabled
    ]);
    const getItemOrder = (0, $eJOHy.useCallback)((selectedItem)=>{
        const matchedIndexes = [];
        flatOptions.forEach((option, index)=>{
            if (option.value === selectedItem.value) matchedIndexes.push(index);
        });
        return matchedIndexes.length > 0 ? matchedIndexes[0] : -1;
    }, [
        flatOptions
    ]);
    const fireUIAnalyticsEvent = (0, $eJOHy.useCallback)((analyticsEvent, query, extraAttributes)=>{
        const attributes = {
            ...getAnalyticsAttributes(query),
            ...extraAttributes
        };
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, attributes);
    }, [
        getAnalyticsAttributes
    ]);
    const fireTrackAnalyticsEvent = (0, $eJOHy.useCallback)((analyticsEvent, action, actionSubject, extraAttributes)=>{
        const attributes = {
            ...getAnalyticsAttributes(savedQuery),
            ...extraAttributes
        };
        (0, $gCeeo.fireTrackAnalytics)(analyticsEvent, `${actionSubject} ${action}`, attributes);
    }, [
        getAnalyticsAttributes,
        savedQuery
    ]);
    const startSession = (0, $eJOHy.useCallback)(()=>{
        if (sessionId.current === undefined) sessionId.current = (0, $aXKmr.v4)();
        sessionStartedAt.current = (0, $gPCSe.default).now();
        fireTrackAnalyticsEvent(createAnalyticsEvent({
            action: 'started'
        }), 'started', 'optionSelectionSession');
    }, [
        createAnalyticsEvent,
        fireTrackAnalyticsEvent,
        sessionId,
        sessionStartedAt
    ]);
    const endSession = (0, $eJOHy.useCallback)((interactionType)=>{
        if (sessionId.current !== undefined) {
            const currentStartedAt = sessionStartedAt.current;
            const elapsedTime = currentStartedAt !== 0 ? (0, $gPCSe.default).now() - currentStartedAt : 0;
            fireTrackAnalyticsEvent(createAnalyticsEvent({
                action: 'ended'
            }), 'ended', 'optionSelectionSession', {
                elapsedTime: elapsedTime,
                interactionType: interactionType
            });
        }
        sessionId.current = undefined;
        sessionStartedAt.current = 0;
    }, [
        createAnalyticsEvent,
        fireTrackAnalyticsEvent,
        sessionId,
        sessionStartedAt
    ]);
    const restartSession = (0, $eJOHy.useCallback)((interactionType)=>{
        endSession(interactionType);
        startSession();
    }, [
        endSession,
        startSession
    ]);
    const fireInputChangedEvent = (0, $eJOHy.useCallback)((query, actionMeta, analyticsEvent)=>{
        if (actionMeta.action === 'set-value') // Save query for option changed analytic
        setQueryAtSetValue(savedQuery);
        setSavedQuery(query);
        analyticsEvent.update({
            action: 'changed',
            actionSubject: 'filter'
        });
        fireUIAnalyticsEvent(analyticsEvent, query);
    }, [
        fireUIAnalyticsEvent,
        savedQuery,
        setSavedQuery,
        setQueryAtSetValue
    ]);
    const fireOptionCreatedEvent = (0, $eJOHy.useCallback)((option, analyticsEvent)=>{
        analyticsEvent.update({
            action: 'created',
            actionSubject: 'option'
        });
        const oldSessionId = sessionId.current;
        restartSession('option created');
        fireUIAnalyticsEvent(analyticsEvent, queryAtSetValue, {
            selectedOption: (0, $7y1rb.getSafeValue)(option.value),
            sessionId: oldSessionId
        });
    }, [
        fireUIAnalyticsEvent,
        queryAtSetValue,
        restartSession,
        sessionId
    ]);
    const fireOptionRemovedEvent = (0, $eJOHy.useCallback)((option, analyticsEvent)=>{
        analyticsEvent.update({
            action: 'removed',
            actionSubject: 'option'
        });
        fireUIAnalyticsEvent(analyticsEvent, savedQuery, {
            removedItem: option ? (0, $7y1rb.getSafeValue)(option.value) : undefined
        });
    }, [
        savedQuery,
        fireUIAnalyticsEvent
    ]);
    const fireOptionSelectedEvent = (0, $eJOHy.useCallback)((option, analyticsEvent)=>{
        analyticsEvent.update({
            action: 'changed',
            actionSubject: 'option'
        });
        const oldSessionId = sessionId.current;
        restartSession('option selected');
        fireUIAnalyticsEvent(analyticsEvent, queryAtSetValue, {
            selectedOption: (0, $7y1rb.getSafeValue)(option.value),
            selectedOptionLength: option.value !== null ? `${option.value}`.length : 0,
            selectedOrder: getItemOrder(option),
            sessionId: oldSessionId
        });
        if (option.isAiSuggested) {
            (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'aiResult actioned', (0, $fTI0O.getFieldSuggestionAiAttributes)(aiSuggestedLabelsInstrumentationId));
            (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'aiResult viewed', {
                ...(0, $fTI0O.getFieldSuggestionAiAttributes)(aiSuggestedLabelsInstrumentationId),
                doesNotMeetMAUCriteria: false
            });
        }
    }, [
        getItemOrder,
        queryAtSetValue,
        restartSession,
        sessionId,
        createAnalyticsEvent,
        fireUIAnalyticsEvent,
        aiSuggestedLabelsInstrumentationId
    ]);
    const onChangeWithAnalytics = (0, $eJOHy.useCallback)((selectedOptionOrOptions, actionMeta, analyticsEvent)=>{
        const selectedOption = Array.isArray(selectedOptionOrOptions) ? selectedOptionOrOptions[selectedOptionOrOptions.length - 1] : selectedOptionOrOptions;
        switch(actionMeta.action){
            case 'create-option':
                if (selectedOption !== null) fireOptionCreatedEvent(selectedOption, analyticsEvent);
                break;
            case 'remove-value':
            case 'pop-value':
            case 'deselect-option':
                fireOptionRemovedEvent(actionMeta.removedValue || actionMeta.option, analyticsEvent);
                break;
            case 'select-option':
                if (selectedOption !== null) fireOptionSelectedEvent(selectedOption, analyticsEvent);
                break;
            default:
                break;
        }
        const selectedValue = isMulti ? selectedOptionOrOptions || [] : selectedOptionOrOptions;
        if (onChange) onChange(selectedValue, actionMeta);
    }, [
        fireOptionCreatedEvent,
        fireOptionRemovedEvent,
        fireOptionSelectedEvent,
        onChange,
        isMulti
    ]);
    const onInputChangeWithAnalytics = (0, $eJOHy.useCallback)((query, actionMeta, analyticsEvent)=>{
        if (actionMeta.action === 'input-change' || actionMeta.action === 'set-value') fireInputChangedEvent(query, actionMeta, analyticsEvent);
        onInputChange(query, sessionId.current);
    }, [
        fireInputChangedEvent,
        onInputChange,
        sessionId
    ]);
    (0, $eJOHy.useEffect)(()=>{
        startSession();
        fireInputChangedEvent('', {
            action: 'fake-action'
        }, createAnalyticsEvent({}));
        return ()=>{
            endSession();
        };
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $eJOHy.useEffect)(()=>{
        if (shouldFireAiLabelsInitiatedEvent) {
            (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'aiInteraction initiated', {
                ...(0, $fTI0O.getFieldSuggestionAiAttributes)(aiSuggestedLabelsInstrumentationId),
                doesNotMeetMAUCriteria: true
            });
            if (aiSuggestedLabelsError !== undefined) (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'aiResult error', {
                ...(0, $fTI0O.getFieldSuggestionAiAttributes)(aiSuggestedLabelsInstrumentationId),
                error: aiSuggestedLabelsError,
                errorMessage: aiSuggestedLabelsError?.message
            });
            else (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'aiResult viewed', {
                ...(0, $fTI0O.getFieldSuggestionAiAttributes)(aiSuggestedLabelsInstrumentationId),
                doesNotMeetMAUCriteria: true
            });
        }
    /**
		 * shouldFireAiLabelsInitiatedEvent is initially false, and is only changed to true when the AI suggestions API call is completed, the `Suggested labels` category is visible,
		 * and there are 1 or more AI suggested labels.
		 * We only want this to ever run once after the AI suggestions are loaded, and hence only shouldFireAiLabelsInitiatedEvent is included in the dependency array.
		 */ // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        shouldFireAiLabelsInitiatedEvent
    ]);
    (0, $eJOHy.useEffect)(()=>{
        // since due to multiple setState calls component is rerendered
        // added this change to reduce the number of setState call will be fixed,
        // wasn't able to replicate this issue in local so adding this change in feature flag.
        // sentry link: https://sentry.prod.atl-paas.net/atlassian/jira-frontend/issues/4943577/?query=is%3Aunresolved%20logger%3AjiraIssueCreateModal.withFormField
        const flattenedOption = (0, $7y1rb.flattenOptions)(options);
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(flatOptions, flattenedOption)) setFlatOptions(flattenedOption);
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        options
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($8bd5b276bfccea4d$export$53574ab050410077, {
        ...props,
        onChange: onChangeWithAnalytics,
        onInputChange: onInputChangeWithAnalytics
    });
};
var $8bd5b276bfccea4d$export$2e2bcd8739ae039 = $8bd5b276bfccea4d$var$CreatableSelectWithAnalyticsView;

});
parcelRegister("fTI0O", function(module, exports) {

$parcel$export(module.exports, "FIELD_SUGGESTIONS_SOURCE", () => $545aa0424d19c311$export$15e0a433f81fa929);
$parcel$export(module.exports, "getFieldSuggestionAiAttributes", () => $545aa0424d19c311$export$c79d78ffaf8190cf);
const $545aa0424d19c311$export$15e0a433f81fa929 = {
    LABELS_DROPDOWN: 'field_suggestions_labels_dropdown',
    API_CALL: 'field_suggestions_api_call'
};
const $545aa0424d19c311$export$c79d78ffaf8190cf = (singleInstrumentationID, // TODO: When we extend field suggestions to other fields, we should update the default value/make it a required variable
invokedFrom = $545aa0424d19c311$export$15e0a433f81fa929.LABELS_DROPDOWN)=>{
    return {
        aiFeatureName: 'jiraFieldSuggestions',
        userGeneratedAI: 0,
        proactiveAIGenerated: 1,
        isAIFeature: 1,
        singleInstrumentationID: singleInstrumentationID,
        // TODO: Make this more modular when we suggest more field types
        fieldSuggestionType: 'labels',
        invokedFrom: invokedFrom
    };
};

});

parcelRegister("bGaT8", function(module, exports) {

$parcel$export(module.exports, "memoizedHashString", () => $f7f07ef49ed59bd7$export$c9e165da390f6283);

var $b2noC = parcelRequire("b2noC");

var $LFmXM = parcelRequire("LFmXM");

var $aYncF = parcelRequire("aYncF");
const $f7f07ef49ed59bd7$export$fdd2c0ba94025c3c = (0, $LFmXM.default)(()=>{
    const { cloudId: cloudId } = (0, $aYncF.getTenantContext_DEPRECATED_DO_NOT_USE)();
    return cloudId;
});
const $f7f07ef49ed59bd7$export$c9e165da390f6283 = (attribute)=>{
    const cloudId = $f7f07ef49ed59bd7$export$fdd2c0ba94025c3c();
    const hash = (0, $b2noC.sha256)(`${cloudId}_${attribute.trim()}`);
    return hash;
};

});
parcelRegister("b2noC", function(module, exports) {

var $igDjg = parcelRequire("igDjg");


/**
 * [js-sha256]{@link https://github.com/emn178/js-sha256}
 *
 * @version 0.11.0
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2014-2024
 * @license MIT
 */ /*jslint bitwise: true */ (function() {
    'use strict';
    var ERROR = 'input is invalid type';
    var WINDOW = typeof window === 'object';
    var root = WINDOW ? window : {};
    if (root.JS_SHA256_NO_WINDOW) WINDOW = false;
    var WEB_WORKER = !WINDOW && typeof self === 'object';
    var NODE_JS = !root.JS_SHA256_NO_NODE_JS && typeof $igDjg === 'object' && $igDjg.versions && $igDjg.versions.node;
    if (NODE_JS) root = $parcel$global;
    else if (WEB_WORKER) root = self;
    var COMMON_JS = !root.JS_SHA256_NO_COMMON_JS && true && module.exports;
    var AMD = typeof define === 'function' && define.amd;
    var ARRAY_BUFFER = !root.JS_SHA256_NO_ARRAY_BUFFER && typeof ArrayBuffer !== 'undefined';
    var HEX_CHARS = '0123456789abcdef'.split('');
    var EXTRA = [
        -2147483648,
        8388608,
        32768,
        128
    ];
    var SHIFT = [
        24,
        16,
        8,
        0
    ];
    var K = [
        0x428a2f98,
        0x71374491,
        0xb5c0fbcf,
        0xe9b5dba5,
        0x3956c25b,
        0x59f111f1,
        0x923f82a4,
        0xab1c5ed5,
        0xd807aa98,
        0x12835b01,
        0x243185be,
        0x550c7dc3,
        0x72be5d74,
        0x80deb1fe,
        0x9bdc06a7,
        0xc19bf174,
        0xe49b69c1,
        0xefbe4786,
        0x0fc19dc6,
        0x240ca1cc,
        0x2de92c6f,
        0x4a7484aa,
        0x5cb0a9dc,
        0x76f988da,
        0x983e5152,
        0xa831c66d,
        0xb00327c8,
        0xbf597fc7,
        0xc6e00bf3,
        0xd5a79147,
        0x06ca6351,
        0x14292967,
        0x27b70a85,
        0x2e1b2138,
        0x4d2c6dfc,
        0x53380d13,
        0x650a7354,
        0x766a0abb,
        0x81c2c92e,
        0x92722c85,
        0xa2bfe8a1,
        0xa81a664b,
        0xc24b8b70,
        0xc76c51a3,
        0xd192e819,
        0xd6990624,
        0xf40e3585,
        0x106aa070,
        0x19a4c116,
        0x1e376c08,
        0x2748774c,
        0x34b0bcb5,
        0x391c0cb3,
        0x4ed8aa4a,
        0x5b9cca4f,
        0x682e6ff3,
        0x748f82ee,
        0x78a5636f,
        0x84c87814,
        0x8cc70208,
        0x90befffa,
        0xa4506ceb,
        0xbef9a3f7,
        0xc67178f2
    ];
    var OUTPUT_TYPES = [
        'hex',
        'array',
        'digest',
        'arrayBuffer'
    ];
    var blocks = [];
    if (root.JS_SHA256_NO_NODE_JS || !Array.isArray) Array.isArray = function(obj) {
        return Object.prototype.toString.call(obj) === '[object Array]';
    };
    if (ARRAY_BUFFER && (root.JS_SHA256_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView)) ArrayBuffer.isView = function(obj) {
        return typeof obj === 'object' && obj.buffer && obj.buffer.constructor === ArrayBuffer;
    };
    var createOutputMethod = function(outputType, is224) {
        return function(message) {
            return new Sha256(is224, true).update(message)[outputType]();
        };
    };
    var createMethod = function(is224) {
        var method = createOutputMethod('hex', is224);
        if (NODE_JS) method = nodeWrap(method, is224);
        method.create = function() {
            return new Sha256(is224);
        };
        method.update = function(message) {
            return method.create().update(message);
        };
        for(var i = 0; i < OUTPUT_TYPES.length; ++i){
            var type = OUTPUT_TYPES[i];
            method[type] = createOutputMethod(type, is224);
        }
        return method;
    };
    var nodeWrap = function(method, is224) {
        var crypto = (parcelRequire("lOA8N"));
        var Buffer = (parcelRequire("lOA8N")).Buffer;
        var algorithm = is224 ? 'sha224' : 'sha256';
        var bufferFrom;
        if (Buffer.from && !root.JS_SHA256_NO_BUFFER_FROM) bufferFrom = Buffer.from;
        else bufferFrom = function(message) {
            return new Buffer(message);
        };
        var nodeMethod = function(message) {
            if (typeof message === 'string') return crypto.createHash(algorithm).update(message, 'utf8').digest('hex');
            else {
                if (message === null || message === undefined) throw new Error(ERROR);
                else if (message.constructor === ArrayBuffer) message = new Uint8Array(message);
            }
            if (Array.isArray(message) || ArrayBuffer.isView(message) || message.constructor === Buffer) return crypto.createHash(algorithm).update(bufferFrom(message)).digest('hex');
            else return method(message);
        };
        return nodeMethod;
    };
    var createHmacOutputMethod = function(outputType, is224) {
        return function(key, message) {
            return new HmacSha256(key, is224, true).update(message)[outputType]();
        };
    };
    var createHmacMethod = function(is224) {
        var method = createHmacOutputMethod('hex', is224);
        method.create = function(key) {
            return new HmacSha256(key, is224);
        };
        method.update = function(key, message) {
            return method.create(key).update(message);
        };
        for(var i = 0; i < OUTPUT_TYPES.length; ++i){
            var type = OUTPUT_TYPES[i];
            method[type] = createHmacOutputMethod(type, is224);
        }
        return method;
    };
    function Sha256(is224, sharedMemory) {
        if (sharedMemory) {
            blocks[0] = blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
            this.blocks = blocks;
        } else this.blocks = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        if (is224) {
            this.h0 = 0xc1059ed8;
            this.h1 = 0x367cd507;
            this.h2 = 0x3070dd17;
            this.h3 = 0xf70e5939;
            this.h4 = 0xffc00b31;
            this.h5 = 0x68581511;
            this.h6 = 0x64f98fa7;
            this.h7 = 0xbefa4fa4;
        } else {
            this.h0 = 0x6a09e667;
            this.h1 = 0xbb67ae85;
            this.h2 = 0x3c6ef372;
            this.h3 = 0xa54ff53a;
            this.h4 = 0x510e527f;
            this.h5 = 0x9b05688c;
            this.h6 = 0x1f83d9ab;
            this.h7 = 0x5be0cd19;
        }
        this.block = this.start = this.bytes = this.hBytes = 0;
        this.finalized = this.hashed = false;
        this.first = true;
        this.is224 = is224;
    }
    Sha256.prototype.update = function(message) {
        if (this.finalized) return;
        var notString, type = typeof message;
        if (type !== 'string') {
            if (type === 'object') {
                if (message === null) throw new Error(ERROR);
                else if (ARRAY_BUFFER && message.constructor === ArrayBuffer) message = new Uint8Array(message);
                else if (!Array.isArray(message)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(message)) throw new Error(ERROR);
                }
            } else throw new Error(ERROR);
            notString = true;
        }
        var code, index = 0, i, length = message.length, blocks = this.blocks;
        while(index < length){
            if (this.hashed) {
                this.hashed = false;
                blocks[0] = this.block;
                this.block = blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
            }
            if (notString) for(i = this.start; index < length && i < 64; ++index)blocks[i >>> 2] |= message[index] << SHIFT[i++ & 3];
            else for(i = this.start; index < length && i < 64; ++index){
                code = message.charCodeAt(index);
                if (code < 0x80) blocks[i >>> 2] |= code << SHIFT[i++ & 3];
                else if (code < 0x800) {
                    blocks[i >>> 2] |= (0xc0 | code >>> 6) << SHIFT[i++ & 3];
                    blocks[i >>> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else if (code < 0xd800 || code >= 0xe000) {
                    blocks[i >>> 2] |= (0xe0 | code >>> 12) << SHIFT[i++ & 3];
                    blocks[i >>> 2] |= (0x80 | code >>> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >>> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else {
                    code = 0x10000 + ((code & 0x3ff) << 10 | message.charCodeAt(++index) & 0x3ff);
                    blocks[i >>> 2] |= (0xf0 | code >>> 18) << SHIFT[i++ & 3];
                    blocks[i >>> 2] |= (0x80 | code >>> 12 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >>> 2] |= (0x80 | code >>> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >>> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                }
            }
            this.lastByteIndex = i;
            this.bytes += i - this.start;
            if (i >= 64) {
                this.block = blocks[16];
                this.start = i - 64;
                this.hash();
                this.hashed = true;
            } else this.start = i;
        }
        if (this.bytes > 4294967295) {
            this.hBytes += this.bytes / 4294967296 << 0;
            this.bytes = this.bytes % 4294967296;
        }
        return this;
    };
    Sha256.prototype.finalize = function() {
        if (this.finalized) return;
        this.finalized = true;
        var blocks = this.blocks, i = this.lastByteIndex;
        blocks[16] = this.block;
        blocks[i >>> 2] |= EXTRA[i & 3];
        this.block = blocks[16];
        if (i >= 56) {
            if (!this.hashed) this.hash();
            blocks[0] = this.block;
            blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
        }
        blocks[14] = this.hBytes << 3 | this.bytes >>> 29;
        blocks[15] = this.bytes << 3;
        this.hash();
    };
    Sha256.prototype.hash = function() {
        var a = this.h0, b = this.h1, c = this.h2, d = this.h3, e = this.h4, f = this.h5, g = this.h6, h = this.h7, blocks = this.blocks, j, s0, s1, maj, t1, t2, ch, ab, da, cd, bc;
        for(j = 16; j < 64; ++j){
            // rightrotate
            t1 = blocks[j - 15];
            s0 = (t1 >>> 7 | t1 << 25) ^ (t1 >>> 18 | t1 << 14) ^ t1 >>> 3;
            t1 = blocks[j - 2];
            s1 = (t1 >>> 17 | t1 << 15) ^ (t1 >>> 19 | t1 << 13) ^ t1 >>> 10;
            blocks[j] = blocks[j - 16] + s0 + blocks[j - 7] + s1 << 0;
        }
        bc = b & c;
        for(j = 0; j < 64; j += 4){
            if (this.first) {
                if (this.is224) {
                    ab = 300032;
                    t1 = blocks[0] - 1413257819;
                    h = t1 - 150054599 << 0;
                    d = t1 + 24177077 << 0;
                } else {
                    ab = 704751109;
                    t1 = blocks[0] - 210244248;
                    h = t1 - 1521486534 << 0;
                    d = t1 + 143694565 << 0;
                }
                this.first = false;
            } else {
                s0 = (a >>> 2 | a << 30) ^ (a >>> 13 | a << 19) ^ (a >>> 22 | a << 10);
                s1 = (e >>> 6 | e << 26) ^ (e >>> 11 | e << 21) ^ (e >>> 25 | e << 7);
                ab = a & b;
                maj = ab ^ a & c ^ bc;
                ch = e & f ^ ~e & g;
                t1 = h + s1 + ch + K[j] + blocks[j];
                t2 = s0 + maj;
                h = d + t1 << 0;
                d = t1 + t2 << 0;
            }
            s0 = (d >>> 2 | d << 30) ^ (d >>> 13 | d << 19) ^ (d >>> 22 | d << 10);
            s1 = (h >>> 6 | h << 26) ^ (h >>> 11 | h << 21) ^ (h >>> 25 | h << 7);
            da = d & a;
            maj = da ^ d & b ^ ab;
            ch = h & e ^ ~h & f;
            t1 = g + s1 + ch + K[j + 1] + blocks[j + 1];
            t2 = s0 + maj;
            g = c + t1 << 0;
            c = t1 + t2 << 0;
            s0 = (c >>> 2 | c << 30) ^ (c >>> 13 | c << 19) ^ (c >>> 22 | c << 10);
            s1 = (g >>> 6 | g << 26) ^ (g >>> 11 | g << 21) ^ (g >>> 25 | g << 7);
            cd = c & d;
            maj = cd ^ c & a ^ da;
            ch = g & h ^ ~g & e;
            t1 = f + s1 + ch + K[j + 2] + blocks[j + 2];
            t2 = s0 + maj;
            f = b + t1 << 0;
            b = t1 + t2 << 0;
            s0 = (b >>> 2 | b << 30) ^ (b >>> 13 | b << 19) ^ (b >>> 22 | b << 10);
            s1 = (f >>> 6 | f << 26) ^ (f >>> 11 | f << 21) ^ (f >>> 25 | f << 7);
            bc = b & c;
            maj = bc ^ b & d ^ cd;
            ch = f & g ^ ~f & h;
            t1 = e + s1 + ch + K[j + 3] + blocks[j + 3];
            t2 = s0 + maj;
            e = a + t1 << 0;
            a = t1 + t2 << 0;
            this.chromeBugWorkAround = true;
        }
        this.h0 = this.h0 + a << 0;
        this.h1 = this.h1 + b << 0;
        this.h2 = this.h2 + c << 0;
        this.h3 = this.h3 + d << 0;
        this.h4 = this.h4 + e << 0;
        this.h5 = this.h5 + f << 0;
        this.h6 = this.h6 + g << 0;
        this.h7 = this.h7 + h << 0;
    };
    Sha256.prototype.hex = function() {
        this.finalize();
        var h0 = this.h0, h1 = this.h1, h2 = this.h2, h3 = this.h3, h4 = this.h4, h5 = this.h5, h6 = this.h6, h7 = this.h7;
        var hex = HEX_CHARS[h0 >>> 28 & 0x0F] + HEX_CHARS[h0 >>> 24 & 0x0F] + HEX_CHARS[h0 >>> 20 & 0x0F] + HEX_CHARS[h0 >>> 16 & 0x0F] + HEX_CHARS[h0 >>> 12 & 0x0F] + HEX_CHARS[h0 >>> 8 & 0x0F] + HEX_CHARS[h0 >>> 4 & 0x0F] + HEX_CHARS[h0 & 0x0F] + HEX_CHARS[h1 >>> 28 & 0x0F] + HEX_CHARS[h1 >>> 24 & 0x0F] + HEX_CHARS[h1 >>> 20 & 0x0F] + HEX_CHARS[h1 >>> 16 & 0x0F] + HEX_CHARS[h1 >>> 12 & 0x0F] + HEX_CHARS[h1 >>> 8 & 0x0F] + HEX_CHARS[h1 >>> 4 & 0x0F] + HEX_CHARS[h1 & 0x0F] + HEX_CHARS[h2 >>> 28 & 0x0F] + HEX_CHARS[h2 >>> 24 & 0x0F] + HEX_CHARS[h2 >>> 20 & 0x0F] + HEX_CHARS[h2 >>> 16 & 0x0F] + HEX_CHARS[h2 >>> 12 & 0x0F] + HEX_CHARS[h2 >>> 8 & 0x0F] + HEX_CHARS[h2 >>> 4 & 0x0F] + HEX_CHARS[h2 & 0x0F] + HEX_CHARS[h3 >>> 28 & 0x0F] + HEX_CHARS[h3 >>> 24 & 0x0F] + HEX_CHARS[h3 >>> 20 & 0x0F] + HEX_CHARS[h3 >>> 16 & 0x0F] + HEX_CHARS[h3 >>> 12 & 0x0F] + HEX_CHARS[h3 >>> 8 & 0x0F] + HEX_CHARS[h3 >>> 4 & 0x0F] + HEX_CHARS[h3 & 0x0F] + HEX_CHARS[h4 >>> 28 & 0x0F] + HEX_CHARS[h4 >>> 24 & 0x0F] + HEX_CHARS[h4 >>> 20 & 0x0F] + HEX_CHARS[h4 >>> 16 & 0x0F] + HEX_CHARS[h4 >>> 12 & 0x0F] + HEX_CHARS[h4 >>> 8 & 0x0F] + HEX_CHARS[h4 >>> 4 & 0x0F] + HEX_CHARS[h4 & 0x0F] + HEX_CHARS[h5 >>> 28 & 0x0F] + HEX_CHARS[h5 >>> 24 & 0x0F] + HEX_CHARS[h5 >>> 20 & 0x0F] + HEX_CHARS[h5 >>> 16 & 0x0F] + HEX_CHARS[h5 >>> 12 & 0x0F] + HEX_CHARS[h5 >>> 8 & 0x0F] + HEX_CHARS[h5 >>> 4 & 0x0F] + HEX_CHARS[h5 & 0x0F] + HEX_CHARS[h6 >>> 28 & 0x0F] + HEX_CHARS[h6 >>> 24 & 0x0F] + HEX_CHARS[h6 >>> 20 & 0x0F] + HEX_CHARS[h6 >>> 16 & 0x0F] + HEX_CHARS[h6 >>> 12 & 0x0F] + HEX_CHARS[h6 >>> 8 & 0x0F] + HEX_CHARS[h6 >>> 4 & 0x0F] + HEX_CHARS[h6 & 0x0F];
        if (!this.is224) hex += HEX_CHARS[h7 >>> 28 & 0x0F] + HEX_CHARS[h7 >>> 24 & 0x0F] + HEX_CHARS[h7 >>> 20 & 0x0F] + HEX_CHARS[h7 >>> 16 & 0x0F] + HEX_CHARS[h7 >>> 12 & 0x0F] + HEX_CHARS[h7 >>> 8 & 0x0F] + HEX_CHARS[h7 >>> 4 & 0x0F] + HEX_CHARS[h7 & 0x0F];
        return hex;
    };
    Sha256.prototype.toString = Sha256.prototype.hex;
    Sha256.prototype.digest = function() {
        this.finalize();
        var h0 = this.h0, h1 = this.h1, h2 = this.h2, h3 = this.h3, h4 = this.h4, h5 = this.h5, h6 = this.h6, h7 = this.h7;
        var arr = [
            h0 >>> 24 & 0xFF,
            h0 >>> 16 & 0xFF,
            h0 >>> 8 & 0xFF,
            h0 & 0xFF,
            h1 >>> 24 & 0xFF,
            h1 >>> 16 & 0xFF,
            h1 >>> 8 & 0xFF,
            h1 & 0xFF,
            h2 >>> 24 & 0xFF,
            h2 >>> 16 & 0xFF,
            h2 >>> 8 & 0xFF,
            h2 & 0xFF,
            h3 >>> 24 & 0xFF,
            h3 >>> 16 & 0xFF,
            h3 >>> 8 & 0xFF,
            h3 & 0xFF,
            h4 >>> 24 & 0xFF,
            h4 >>> 16 & 0xFF,
            h4 >>> 8 & 0xFF,
            h4 & 0xFF,
            h5 >>> 24 & 0xFF,
            h5 >>> 16 & 0xFF,
            h5 >>> 8 & 0xFF,
            h5 & 0xFF,
            h6 >>> 24 & 0xFF,
            h6 >>> 16 & 0xFF,
            h6 >>> 8 & 0xFF,
            h6 & 0xFF
        ];
        if (!this.is224) arr.push(h7 >>> 24 & 0xFF, h7 >>> 16 & 0xFF, h7 >>> 8 & 0xFF, h7 & 0xFF);
        return arr;
    };
    Sha256.prototype.array = Sha256.prototype.digest;
    Sha256.prototype.arrayBuffer = function() {
        this.finalize();
        var buffer = new ArrayBuffer(this.is224 ? 28 : 32);
        var dataView = new DataView(buffer);
        dataView.setUint32(0, this.h0);
        dataView.setUint32(4, this.h1);
        dataView.setUint32(8, this.h2);
        dataView.setUint32(12, this.h3);
        dataView.setUint32(16, this.h4);
        dataView.setUint32(20, this.h5);
        dataView.setUint32(24, this.h6);
        if (!this.is224) dataView.setUint32(28, this.h7);
        return buffer;
    };
    function HmacSha256(key, is224, sharedMemory) {
        var i, type = typeof key;
        if (type === 'string') {
            var bytes = [], length = key.length, index = 0, code;
            for(i = 0; i < length; ++i){
                code = key.charCodeAt(i);
                if (code < 0x80) bytes[index++] = code;
                else if (code < 0x800) {
                    bytes[index++] = 0xc0 | code >>> 6;
                    bytes[index++] = 0x80 | code & 0x3f;
                } else if (code < 0xd800 || code >= 0xe000) {
                    bytes[index++] = 0xe0 | code >>> 12;
                    bytes[index++] = 0x80 | code >>> 6 & 0x3f;
                    bytes[index++] = 0x80 | code & 0x3f;
                } else {
                    code = 0x10000 + ((code & 0x3ff) << 10 | key.charCodeAt(++i) & 0x3ff);
                    bytes[index++] = 0xf0 | code >>> 18;
                    bytes[index++] = 0x80 | code >>> 12 & 0x3f;
                    bytes[index++] = 0x80 | code >>> 6 & 0x3f;
                    bytes[index++] = 0x80 | code & 0x3f;
                }
            }
            key = bytes;
        } else {
            if (type === 'object') {
                if (key === null) throw new Error(ERROR);
                else if (ARRAY_BUFFER && key.constructor === ArrayBuffer) key = new Uint8Array(key);
                else if (!Array.isArray(key)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(key)) throw new Error(ERROR);
                }
            } else throw new Error(ERROR);
        }
        if (key.length > 64) key = new Sha256(is224, true).update(key).array();
        var oKeyPad = [], iKeyPad = [];
        for(i = 0; i < 64; ++i){
            var b = key[i] || 0;
            oKeyPad[i] = 0x5c ^ b;
            iKeyPad[i] = 0x36 ^ b;
        }
        Sha256.call(this, is224, sharedMemory);
        this.update(iKeyPad);
        this.oKeyPad = oKeyPad;
        this.inner = true;
        this.sharedMemory = sharedMemory;
    }
    HmacSha256.prototype = new Sha256();
    HmacSha256.prototype.finalize = function() {
        Sha256.prototype.finalize.call(this);
        if (this.inner) {
            this.inner = false;
            var innerHash = this.array();
            Sha256.call(this, this.is224, this.sharedMemory);
            this.update(this.oKeyPad);
            this.update(innerHash);
            Sha256.prototype.finalize.call(this);
        }
    };
    var exports = createMethod();
    exports.sha256 = exports;
    exports.sha224 = createMethod(true);
    exports.sha256.hmac = createHmacMethod();
    exports.sha224.hmac = createHmacMethod(true);
    if (COMMON_JS) module.exports = exports;
    else {
        root.sha256 = exports.sha256;
        root.sha224 = exports.sha224;
        if (AMD) define(function() {
            return exports;
        });
    }
})();

});


parcelRegister("7y1rb", function(module, exports) {

$parcel$export(module.exports, "getSafeValue", () => $414d1831d901a140$export$d05672fd1312a6d);
$parcel$export(module.exports, "getSafeOptionsForAnalytics", () => $414d1831d901a140$export$fde3d804891b8254);
$parcel$export(module.exports, "flattenOptions", () => $414d1831d901a140$export$7baa7c13b358b002);
$parcel$export(module.exports, "getOptionValuesLengths", () => $414d1831d901a140$export$e2e167245697ed4e);
$parcel$export(module.exports, "filterOptions", () => $414d1831d901a140$export$60d56ed3961c839c);

var $5FdZg = parcelRequire("5FdZg");

var $bGaT8 = parcelRequire("bGaT8");
const $414d1831d901a140$export$d05672fd1312a6d = (val)=>(0, $bGaT8.memoizedHashString)(val.toString()).toString();
const $414d1831d901a140$export$fde3d804891b8254 = (items)=>items.filter((item)=>item.value).map(({ value: value })=>$414d1831d901a140$export$d05672fd1312a6d(value));
const $414d1831d901a140$export$7baa7c13b358b002 = (optionGroups)=>(0, (/*@__PURE__*/$parcel$interopDefault($5FdZg)))(optionGroups.map((group)=>group.options));
const $414d1831d901a140$export$e2e167245697ed4e = (items)=>items.filter((item)=>item.value).map(({ value: value })=>value != null ? `${value}`.length : 0);
const $414d1831d901a140$export$60d56ed3961c839c = (options, query)=>options.filter((option)=>typeof option.value === 'string' && option.value.toLowerCase().includes((query || '').toLowerCase()) || typeof option.label === 'string' && option.label.toLowerCase().includes((query || '').toLowerCase()));

});
parcelRegister("5FdZg", function(module, exports) {

var $72Qfa = parcelRequire("72Qfa");

var $79hL0 = parcelRequire("79hL0");
/**
 * Creates a flattened array of values by running each element in `collection`
 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
 * with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [n, n];
 * }
 *
 * _.flatMap([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */ function $41fba19db79c4e52$var$flatMap(collection, iteratee) {
    return $72Qfa($79hL0(collection, iteratee), 1);
}
module.exports = $41fba19db79c4e52$var$flatMap;

});
parcelRegister("79hL0", function(module, exports) {

var $lylkU = parcelRequire("lylkU");

var $1lM9j = parcelRequire("1lM9j");

var $k0Eii = parcelRequire("k0Eii");

var $4sprp = parcelRequire("4sprp");
/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function $534725d937053460$var$map(collection, iteratee) {
    var func = $4sprp(collection) ? $lylkU : $k0Eii;
    return func(collection, $1lM9j(iteratee, 3));
}
module.exports = $534725d937053460$var$map;

});
parcelRegister("k0Eii", function(module, exports) {

var $c3u3c = parcelRequire("c3u3c");

var $7H30b = parcelRequire("7H30b");
/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $e9131047aaeaff47$var$baseMap(collection, iteratee) {
    var index = -1, result = $7H30b(collection) ? Array(collection.length) : [];
    $c3u3c(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
module.exports = $e9131047aaeaff47$var$baseMap;

});





parcelRegister("edfym", function(module, exports) {

$parcel$export(module.exports, "default", () => $403b755ba4c02a55$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $403b755ba4c02a55$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    empty: {
        "id": "issue-field-labels.edit.empty",
        "defaultMessage": "No matches found"
    },
    failedFetch: {
        "id": "issue-field-labels.edit.failed-fetch",
        "defaultMessage": "Search failed. Please try again."
    },
    placeholder: {
        "id": "issue-field-labels.edit.placeholder",
        "defaultMessage": "Select label"
    },
    createNewItem: {
        "id": "issue-field-labels.edit.create-new-item",
        "defaultMessage": "New label"
    },
    loading: {
        "id": "issue-field-labels.edit.loading",
        "defaultMessage": "Searching..."
    },
    recent: {
        "id": "issue-field-labels.edit.recent",
        "defaultMessage": "Recent labels"
    },
    all: {
        "id": "issue-field-labels.edit.all",
        "defaultMessage": "All labels"
    },
    editOption: {
        "id": "issue-field-single-select-editview-full.single-select.edit-option",
        "defaultMessage": "Edit option {optionName}"
    }
});

});


parcelRegister("2me76", function(module, exports) {

$parcel$export(module.exports, "mapDataToLabelOptions", () => $2af562eb0a3d24f6$export$cd8e373d5b1325b1);
$parcel$export(module.exports, "mutateLabelsFields", () => $2af562eb0a3d24f6$export$f691a7c5b86be653);

const $2af562eb0a3d24f6$export$cd8e373d5b1325b1 = (data)=>data.map(({ name: name, color: color })=>({
            value: name,
            label: name,
            ...color ? {
                color: color.colorKey
            } : {}
        }));
const $2af562eb0a3d24f6$export$f691a7c5b86be653 = (selectedLabels, fieldId)=>({
        fieldId: fieldId,
        labels: selectedLabels.map(({ value: value })=>({
                name: value
            })),
        mutationGroup: (0, $cf0a64b66bad6072$export$31fd86f8f183952c)
    });

});
const $cf0a64b66bad6072$export$31fd86f8f183952c = 'labelsFields';



parcelRegister("4zIi4", function(module, exports) {

$parcel$export(module.exports, "getIsTimeEstimateExceeded", () => $5eb281e28706a2a9$export$20e7052b315e94b);
$parcel$export(module.exports, "getCalculatedTimeRemainingIfAny", () => $5eb281e28706a2a9$export$51a45955a3207e1b);
$parcel$export(module.exports, "getLogWorkSubmitValue", () => $5eb281e28706a2a9$export$7d47ca3907f5addd);

var $57raR = parcelRequire("57raR");

var $169bb = parcelRequire("169bb");

var $eebhl = parcelRequire("eebhl");

var $j7N7F = parcelRequire("j7N7F");
const $5eb281e28706a2a9$export$20e7052b315e94b = (args)=>{
    const { config: config, timeTrackingValue: timeTrackingValue, timeSpent: timeSpent, timeRemaining: timeRemaining } = args;
    const isTimeRemainingValid = (0, $169bb.isValidTimeString)(config)(timeRemaining);
    const isTimeSpentValid = (0, $169bb.isValidTimeString)(config)(timeSpent);
    const isTimeTrackingValid = (0, $169bb.isValidTimeString)(config)(timeTrackingValue);
    if (isTimeTrackingValid && (isTimeRemainingValid || isTimeSpentValid)) {
        let timeSpentInSeconds = 0;
        let timeRemainingInSeconds = 0;
        const timeTrackingValueInSeconds = (0, $j7N7F.default)(config.daysPerWeek, config.hoursPerDay)(timeTrackingValue);
        if (isTimeSpentValid) // @ts-expect-error - TS2322 - Type 'number | null' is not assignable to type 'number'.
        timeSpentInSeconds = (0, $j7N7F.default)(config.daysPerWeek, config.hoursPerDay)(timeSpent);
        if (isTimeRemainingValid) // @ts-expect-error - TS2322 - Type 'number | null' is not assignable to type 'number'.
        timeRemainingInSeconds = (0, $j7N7F.default)(config.daysPerWeek, config.hoursPerDay)(timeRemaining);
        timeRemainingInSeconds = typeof timeRemainingInSeconds !== 'number' ? 0 : timeRemainingInSeconds;
        timeSpentInSeconds = typeof timeSpentInSeconds !== 'number' ? 0 : timeSpentInSeconds;
        if (typeof timeTrackingValueInSeconds === 'number') {
            if (timeSpentInSeconds + timeRemainingInSeconds > timeTrackingValueInSeconds) return true;
        }
    }
    return false;
};
const $5eb281e28706a2a9$export$51a45955a3207e1b = (args)=>{
    let calculatedTimeRemaining = null;
    const { timeSpent: timeSpent, timeTrackingValue: timeTrackingValue, config: config } = args;
    const isValidTimeTrackingValue = (0, $169bb.isValidTimeString)(config)(timeTrackingValue);
    if (!timeSpent && isValidTimeTrackingValue) return timeTrackingValue;
    const isValidTimeSpent = (0, $169bb.isValidTimeString)(config)(timeSpent);
    if (isValidTimeTrackingValue && isValidTimeSpent) {
        const timeSpentInSeconds = (0, $j7N7F.default)(config.daysPerWeek, config.hoursPerDay)(timeSpent) || 0;
        const timeTrackingInSeconds = (0, $j7N7F.default)(config.daysPerWeek, config.hoursPerDay)(timeTrackingValue) || 0;
        if (timeTrackingInSeconds >= timeSpentInSeconds) calculatedTimeRemaining = (0, $eebhl.default)(config.daysPerWeek, config.hoursPerDay)(timeTrackingInSeconds - timeSpentInSeconds);
    }
    return calculatedTimeRemaining;
};
const $5eb281e28706a2a9$export$7d47ca3907f5addd = (value)=>{
    const { dateValue: dateValue, timeSpent: timeSpent, timeRemaining: timeRemaining, description: description } = value;
    const adjustEstimate = timeRemaining ? 'new' : 'leave';
    return [
        {
            add: {
                started: dateValue ? (0, $57raR.default)(new Date(dateValue), "yyyy-MM-dd'T'HH:mm:ss.SSSxxxx") : undefined,
                timeSpent: timeSpent,
                adjustEstimate: adjustEstimate,
                newEstimate: timeRemaining,
                comment: description && JSON.stringify(description)
            }
        }
    ];
};

});
parcelRegister("169bb", function(module, exports) {

$parcel$export(module.exports, "formatTimeString", () => $711aadf76714c8f0$export$2de90790c3ad23b1);
$parcel$export(module.exports, "isValidTimeString", () => $711aadf76714c8f0$export$669626963db3b187);
$parcel$export(module.exports, "parseTimeString", () => $711aadf76714c8f0$export$53148bfa4e677363);

var $9J40B = parcelRequire("9J40B");

var $eebhl = parcelRequire("eebhl");

var $j7N7F = parcelRequire("j7N7F");

var $3YPJ0 = parcelRequire("3YPJ0");

var $5iJeL = parcelRequire("5iJeL");

const $711aadf76714c8f0$export$2de90790c3ad23b1 = (config)=>(timeValue)=>(0, $eebhl.default)(config.daysPerWeek, config.hoursPerDay)(timeValue || 0);
const $711aadf76714c8f0$export$5eb9d332712102eb = (config)=>(value)=>{
        let trimmedValue = value.trim();
        // If user doesn't type the valid format (m, h, d, or w), use default unit format set in the configuration.
        const isValidNumber = (0, $3YPJ0.isNumeric)(trimmedValue.replaceAll(',', '.'));
        if (isValidNumber) {
            const { defaultUnit: defaultUnit } = config;
            trimmedValue = `${trimmedValue}${(0, $5iJeL.getDefaultTimeTrackingUnit)(defaultUnit)}`;
        }
        return trimmedValue;
    };
const $711aadf76714c8f0$export$669626963db3b187 = (config)=>(value)=>{
        const timeString = $711aadf76714c8f0$export$5eb9d332712102eb(config)(value);
        return timeString === '' || (0, $9J40B.default)(timeString);
    };
const $711aadf76714c8f0$export$53148bfa4e677363 = (config)=>(value)=>{
        const timeString = $711aadf76714c8f0$export$5eb9d332712102eb(config)(value);
        if (!$711aadf76714c8f0$export$669626963db3b187(config)(timeString)) return 0;
        return (0, $j7N7F.default)(config.daysPerWeek, config.hoursPerDay)(timeString);
    };

});
parcelRegister("9J40B", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1e063e4d6ff7ef7$export$2e2bcd8739ae039);

var $eRPqr = parcelRequire("eRPqr");

var $j7N7F = parcelRequire("j7N7F");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e1e063e4d6ff7ef7$export$2e2bcd8739ae039 = (timeString)=>{
    // We don't care about daysPerWeek or hoursPerDay - we only need to test that the value can be parsed.
    const result = (0, $j7N7F.default)(1, 1)(timeString);
    return result !== null && (0, (/*@__PURE__*/$parcel$interopDefault($eRPqr)))(result);
};

});
parcelRegister("eRPqr", function(module, exports) {

var $NROo8 = parcelRequire("NROo8");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $ad2de7eeaba7a4ae$var$nativeIsFinite = $NROo8.isFinite;
/**
 * Checks if `value` is a finite primitive number.
 *
 * **Note:** This method is based on
 * [`Number.isFinite`](https://mdn.io/Number/isFinite).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
 * @example
 *
 * _.isFinite(3);
 * // => true
 *
 * _.isFinite(Number.MIN_VALUE);
 * // => true
 *
 * _.isFinite(Infinity);
 * // => false
 *
 * _.isFinite('3');
 * // => false
 */ function $ad2de7eeaba7a4ae$var$isFinite(value) {
    return typeof value == 'number' && $ad2de7eeaba7a4ae$var$nativeIsFinite(value);
}
module.exports = $ad2de7eeaba7a4ae$var$isFinite;

});

parcelRegister("j7N7F", function(module, exports) {

$parcel$export(module.exports, "default", () => $90469f1cb6ff73a8$export$2e2bcd8739ae039);
const $90469f1cb6ff73a8$var$MINUTES_PER_HOUR = 60;
const $90469f1cb6ff73a8$var$SECONDS_PER_MINUTE = 60;
// Supports both '.' and ',' as decimal separators
const $90469f1cb6ff73a8$var$UNIT_STRING_PATTERN = /^(\d+(?:[.,]\d+)?)([wdhm])$/;
const $90469f1cb6ff73a8$var$convertToUnitQuantity = (rawString)=>{
    const matches = $90469f1cb6ff73a8$var$UNIT_STRING_PATTERN.exec(rawString);
    if (!matches) return null;
    // Replace comma with a period for evaluating arithmetic decimal
    const normalizedQuantity = matches[1].replaceAll(',', '.');
    return {
        quantity: parseFloat(normalizedQuantity),
        unit: matches[2]
    };
};
const $90469f1cb6ff73a8$var$timeStringToSeconds = (daysPerWeek, hoursPerDay)=>{
    const unitDefinitions = [
        {
            unit: 'w',
            seconds: daysPerWeek * hoursPerDay * $90469f1cb6ff73a8$var$MINUTES_PER_HOUR * $90469f1cb6ff73a8$var$SECONDS_PER_MINUTE
        },
        {
            unit: 'd',
            seconds: hoursPerDay * $90469f1cb6ff73a8$var$MINUTES_PER_HOUR * $90469f1cb6ff73a8$var$SECONDS_PER_MINUTE
        },
        {
            unit: 'h',
            seconds: $90469f1cb6ff73a8$var$MINUTES_PER_HOUR * $90469f1cb6ff73a8$var$SECONDS_PER_MINUTE
        },
        {
            unit: 'm',
            seconds: $90469f1cb6ff73a8$var$SECONDS_PER_MINUTE
        }
    ];
    return (timeString)=>{
        // Split up the time string, and parse it into an array of UnitQuantities.
        const unitQuantities = timeString.split(' ').map($90469f1cb6ff73a8$var$convertToUnitQuantity);
        let quantitiesConsumed = 0;
        let seconds = 0;
        for(let i = 0; i < unitDefinitions.length; i += 1){
            // If we have consumed all the quantity-unit pairs in the string
            // we are done.
            if (quantitiesConsumed === unitQuantities.length) break;
            const unitDefinition = unitDefinitions[i];
            const unitQuantity = unitQuantities[quantitiesConsumed];
            if (!unitQuantity) return null;
            // If the quantity-unit pair matches the unit definition we are up to, consume it.
            if (unitQuantity.unit === unitDefinition.unit) {
                seconds += unitQuantity.quantity * unitDefinition.seconds;
                quantitiesConsumed += 1;
            }
        }
        // We have made it through all the unit definitions, but there is still some left-over input
        if (quantitiesConsumed < unitQuantities.length) return null;
        return Math.floor(seconds);
    };
};
var $90469f1cb6ff73a8$export$2e2bcd8739ae039 = $90469f1cb6ff73a8$var$timeStringToSeconds;

});


parcelRegister("eebhl", function(module, exports) {

$parcel$export(module.exports, "default", () => $853dcd26ce405ee8$export$2e2bcd8739ae039);
const $853dcd26ce405ee8$var$MINUTES_PER_HOUR = 60;
const $853dcd26ce405ee8$var$SECONDS_PER_MINUTE = 60;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$853dcd26ce405ee8$export$2e2bcd8739ae039 = (daysPerWeek, hoursPerDay)=>{
    const units = [
        {
            suffix: 'w',
            seconds: daysPerWeek * hoursPerDay * $853dcd26ce405ee8$var$MINUTES_PER_HOUR * $853dcd26ce405ee8$var$SECONDS_PER_MINUTE
        },
        {
            suffix: 'd',
            seconds: hoursPerDay * $853dcd26ce405ee8$var$MINUTES_PER_HOUR * $853dcd26ce405ee8$var$SECONDS_PER_MINUTE
        },
        {
            suffix: 'h',
            seconds: $853dcd26ce405ee8$var$MINUTES_PER_HOUR * $853dcd26ce405ee8$var$SECONDS_PER_MINUTE
        },
        {
            suffix: 'm',
            seconds: $853dcd26ce405ee8$var$SECONDS_PER_MINUTE
        }
    ];
    return (seconds)=>{
        const initial = {
            secondsRemaining: seconds,
            timeString: ''
        };
        const result = units.reduce((acc, unit)=>{
            // Skip this unit if it doesn't have a valid number of seconds
            if (unit.seconds <= 0) return acc;
            const numUnits = Math.floor(acc.secondsRemaining / unit.seconds);
            const updatedSecondsRemaining = numUnits >= 1 ? acc.secondsRemaining % unit.seconds : acc.secondsRemaining;
            const updatedTimeString = numUnits >= 1 ? `${acc.timeString} ${numUnits}${unit.suffix}` : acc.timeString;
            return {
                secondsRemaining: updatedSecondsRemaining,
                timeString: updatedTimeString
            };
        }, initial);
        return result.timeString.trim() || '0m';
    };
};

});

parcelRegister("3YPJ0", function(module, exports) {

$parcel$export(module.exports, "isNumeric", () => $ef06441bdd270ccf$export$e90fb89750dba83f);
const $ef06441bdd270ccf$export$e90fb89750dba83f = (num)=>num.length > 0 && !Number.isNaN(Number(num));

});

parcelRegister("5iJeL", function(module, exports) {

$parcel$export(module.exports, "getDefaultTimeTrackingUnit", () => $4a595c55416867fe$export$2b38dfc7401492ba);
// This is required to map the default time-tracking unit coming from the server (gira endpoint BENTO: 3334) to client
const $4a595c55416867fe$var$DEFAULT_TIME_TRACKING_UNIT_CLIENT = {
    minute: 'm',
    hour: 'h',
    day: 'd',
    week: 'w'
};
const $4a595c55416867fe$export$2b38dfc7401492ba = (serverDefaultUnit)=>$4a595c55416867fe$var$DEFAULT_TIME_TRACKING_UNIT_CLIENT[serverDefaultUnit] || $4a595c55416867fe$var$DEFAULT_TIME_TRACKING_UNIT_CLIENT.minute;

});



parcelRegister("jFPx3", function(module, exports) {

$parcel$export(module.exports, "default", () => $f383882f67e43f0e$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8DB98 = parcelRequire("8DB98");

var $ix0Ab = parcelRequire("ix0Ab");

var $7jTnu = parcelRequire("7jTnu");

var $l7iSF = parcelRequire("l7iSF");
const $f383882f67e43f0e$var$MessageCFBehaviour = (props)=>{
    const { defaultValue: defaultValue } = props;
    if (defaultValue === undefined) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ix0Ab.default), {
        document: defaultValue,
        schema: (0, $8DB98.defaultSchema),
        disableHeadingIDs: true,
        eventHandlers: {
            smartCard: {
                onClick: (0, $l7iSF.onLinkClick)
            },
            link: {
                onClick: (0, $l7iSF.onLinkClick)
            }
        },
        featureFlags: {
            codeBidiWarnings: true,
            'code-bidi-warnings': true,
            // enables sending analytics event with renderer specific tti measurement
            // please do not clean up, this feature flag is meant to be rolled out permanently just for a fraction of users
            'renderer-tti-tracking': (0, $7jTnu.fg)('renderer_tti_tracking_jira')
        },
        smartLinks: (0, $l7iSF.smartLinksDefault)
    });
};
const $f383882f67e43f0e$var$MessageCF = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f383882f67e43f0e$var$MessageCFBehaviour, {
        key: "message-custom-field",
        ...props
    });
var $f383882f67e43f0e$export$2e2bcd8739ae039 = $f383882f67e43f0e$var$MessageCF;

});

parcelRegister("eskjo", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b670206055ca3c0$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $ezTte = parcelRequire("ezTte");

var $1CAom = parcelRequire("1CAom");

var $fE4zR = parcelRequire("fE4zR");

var $2nXHu = parcelRequire("2nXHu");

var $ixdDB = parcelRequire("ixdDB");

var $4yQUm = parcelRequire("4yQUm");

var $26AI2 = parcelRequire("26AI2");

const $0b670206055ca3c0$var$MultiGroupPickerField = (props)=>{
    const { width: width, fieldProps: { value: value, onChange: onChange, ...fieldProps }, fieldId: fieldId, error: error, autoCompleteUrl: autoCompleteUrl, autoFocus: autoFocus = false, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, ariaLabelledBy: ariaLabelledBy } = props;
    const getExtraProps = ()=>{
        if (isDropdownMenuFixedAndLayered) return {
            menuPosition: 'fixed',
            groupPickerStyles: (0, $ezTte.defaultUserPickerStyles),
            onCloseMenuOnScroll: (0, $ixdDB.closeMenuOnScroll)
        };
        return {
            onCloseMenuOnScroll: (0, $ixdDB.closeMenuOnScroll)
        };
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fE4zR.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1CAom.default), {
        ...fieldProps,
        autoCompleteUrl: autoCompleteUrl,
        onChange: onChange,
        value: value,
        fieldId: fieldId,
        isInvalid: Boolean(error),
        autoFocus: autoFocus,
        isMulti: true,
        placeholder: " ",
        "aria-labelledby": ariaLabelledBy,
        ...getExtraProps()
    }));
};
var $0b670206055ca3c0$export$2e2bcd8739ae039 = (0, $2nXHu.withFormField)({
    validator: (0, $4yQUm.validateGroupPickerField),
    transformDefaultValue: (0, $26AI2.transformGroupDefaultValueToUserOption)
})($0b670206055ca3c0$var$MultiGroupPickerField);

});
parcelRegister("ezTte", function(module, exports) {

$parcel$export(module.exports, "defaultUserPickerStyles", () => $6ab4d811886a046f$export$ddd4b90ea2d7a329);

var $dPMMf = parcelRequire("dPMMf");
const $6ab4d811886a046f$export$ddd4b90ea2d7a329 = {
    menuPortal: (base)=>({
            ...base,
            zIndex: String((0, $dPMMf.layers).modal)
        })
};

});

parcelRegister("1CAom", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e40a3a9670dc9f0$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $3s8bj = parcelRequire("3s8bj");

var $ewHZ5 = parcelRequire("ewHZ5");

var $lRq8t = parcelRequire("lRq8t");

var $cCjAH = parcelRequire("cCjAH");

var $3QAfv = parcelRequire("3QAfv");

var $1Sqdg = parcelRequire("1Sqdg");

var $bBX9F = parcelRequire("bBX9F");
const $0e40a3a9670dc9f0$var$DEFAULT_SEARCH_DEBOUCE_TIMEOUT = 300;
const $0e40a3a9670dc9f0$var$GroupPicker = ({ autoCompleteUrl: autoCompleteUrl, value: value, onFocus: onFocus, onBlur: onBlur, onChange: onChange, isMulti: isMulti, isDisabled: isDisabled, fieldId: fieldId, width: width, searchDebounceTimeout: // @ts-expect-error - TS2339 - Property 'searchDebounceTimeout' does not exist on type 'Props'.
searchDebounceTimeout = $0e40a3a9670dc9f0$var$DEFAULT_SEARCH_DEBOUCE_TIMEOUT, isInvalid: isInvalid, autoFocus: autoFocus = false, placeholder: placeholder, onCloseMenuOnScroll: onCloseMenuOnScroll, menuPosition: menuPosition, groupPickerStyles: groupPickerStyles = {}, isClearable: isClearable = true, ...fieldProps })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const previousQuery = (0, $eJOHy.useRef)('');
    const { groups: groups, loading: loading, fetchGroups: fetchGroups } = (0, $3QAfv.default)(autoCompleteUrl || '');
    const [isDropdownVisible, setIsDropdownVisible] = (0, $eJOHy.useState)(false);
    const getUserPickerControlStyle = (0, $eJOHy.useCallback)((styles)=>{
        if (isInvalid === true) return {
            ...styles,
            ...(0, $bBX9F.invalidStateStyle)
        };
        return styles;
    }, [
        isInvalid
    ]);
    const handleSearch = (0, $eJOHy.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))((query)=>{
            setIsDropdownVisible(!!query);
            // if query has changed, get groups
            if (query !== previousQuery.current && query !== undefined) fetchGroups(query);
            previousQuery.current = query || '';
        }, searchDebounceTimeout), [
        fetchGroups,
        previousQuery,
        searchDebounceTimeout
    ]);
    const handleOnFocus = (0, $eJOHy.useCallback)((sessionId)=>{
        setIsDropdownVisible(true);
        onFocus?.(sessionId);
        if (!groups || !groups.length) fetchGroups();
    }, [
        fetchGroups,
        groups,
        onFocus
    ]);
    const handleOnBlur = (0, $eJOHy.useCallback)((sessionId)=>{
        setIsDropdownVisible(false);
        onBlur?.(sessionId);
        previousQuery.current = '';
    }, [
        onBlur,
        previousQuery
    ]);
    const handleOnChange = (updatedValue)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        onChange(updatedValue);
    };
    const getOptions = ()=>groups.filter((group)=>group.name.includes(previousQuery.current)).map((group)=>(0, $cCjAH.transformGroupToUserOption)(group));
    const onClear = ()=>{
        onChange(null);
    };
    const closeMenuOnScroll = (e)=>{
        if (isDropdownVisible && onCloseMenuOnScroll && onCloseMenuOnScroll(e)) setIsDropdownVisible(false);
    };
    const getIsClearable = ()=>isClearable ? Boolean(value) : false;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ewHZ5.UserPicker), {
        ariaLabelledBy: fieldProps['aria-labelledby'],
        fieldId: fieldId,
        width: width,
        autoFocus: autoFocus,
        isLoading: loading,
        options: getOptions(),
        value: value,
        onFocus: handleOnFocus,
        onClear: onClear,
        isMulti: isMulti,
        isDisabled: isDisabled,
        isClearable: getIsClearable(),
        onBlur: handleOnBlur,
        onInputChange: handleSearch,
        onChange: handleOnChange,
        placeholder: placeholder,
        addMoreMessage: formatMessage((0, $1Sqdg.default).addMoreGroupsPrompt),
        UNSAFE_hasDraggableParentComponent: true,
        closeMenuOnScroll: closeMenuOnScroll,
        open: isDropdownVisible,
        menuPosition: menuPosition,
        styles: {
            control: getUserPickerControlStyle,
            ...groupPickerStyles
        }
    });
};
var $0e40a3a9670dc9f0$export$2e2bcd8739ae039 = $0e40a3a9670dc9f0$var$GroupPicker;

});
parcelRegister("cCjAH", function(module, exports) {

$parcel$export(module.exports, "transformGroupToUserOption", () => $364a74b65e1c8c1f$export$f9f97cb0418e400f);
$parcel$export(module.exports, "transformUserPickerOptionToGroup", () => $364a74b65e1c8c1f$export$7727449e04185a4c);
$parcel$export(module.exports, "transformGroupToName", () => $364a74b65e1c8c1f$export$c76efe48b8ca8203);
$parcel$export(module.exports, "transformGroupsToNames", () => $364a74b65e1c8c1f$export$285022bf9288513e);
$parcel$export(module.exports, "appendTypePropertyToGroupOptions", () => $364a74b65e1c8c1f$export$705009f1a414da46);
const $364a74b65e1c8c1f$export$f9f97cb0418e400f = (group)=>({
        id: group.name,
        name: group.name,
        type: 'group'
    });
const $364a74b65e1c8c1f$export$7727449e04185a4c = (userOption)=>({
        groupId: userOption.id,
        name: userOption.name,
        type: 'group'
    });
const $364a74b65e1c8c1f$export$c76efe48b8ca8203 = (group)=>({
        name: group.name
    });
const $364a74b65e1c8c1f$export$285022bf9288513e = (groups)=>groups.map((group)=>$364a74b65e1c8c1f$export$c76efe48b8ca8203(group));
const $364a74b65e1c8c1f$export$705009f1a414da46 = (groups)=>groups.map((group)=>({
            ...group,
            type: 'group'
        }));

});

parcelRegister("3QAfv", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae4e9f1b234ec064$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $eSnSE = parcelRequire("eSnSE");

var $jGzN3 = parcelRequire("jGzN3");

var $cCjAH = parcelRequire("cCjAH");
const $ae4e9f1b234ec064$var$useGroupsQuery = (autoCompleteUrl)=>{
    const [groups, setGroups] = (0, $eJOHy.useState)([]);
    const [error, setError] = (0, $eJOHy.useState)(undefined);
    const [loading, setLoading] = (0, $eJOHy.useState)(false);
    const currentQuery = (0, $eJOHy.useRef)('');
    const fetchGroups = (0, $eJOHy.useCallback)(async (query = '')=>{
        if ([
            '',
            null,
            undefined
        ].includes(autoCompleteUrl)) return Promise.resolve([]);
        const groupsFetchUrl = `${autoCompleteUrl || ''}${query}`;
        setLoading(true);
        currentQuery.current = query;
        if (error) setError(undefined);
        try {
            const response = await (0, $jGzN3.performGetRequest)(groupsFetchUrl);
            let groupsWithType = [];
            if (query === currentQuery.current) {
                if (response && response.groups) {
                    groupsWithType = (0, $cCjAH.appendTypePropertyToGroupOptions)(response.groups);
                    setGroups(groupsWithType);
                } else setGroups([]);
            }
            return groupsWithType;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            if (query === currentQuery.current) setError(err);
            (0, $eSnSE.default).safeErrorWithoutCustomerData('issue.fields.grouppicker', 'Failed to fetch groups', err);
            return err;
        } finally{
            setLoading(false);
        }
    }, [
        autoCompleteUrl,
        error
    ]);
    return {
        groups: groups,
        error: error,
        loading: loading,
        fetchGroups: fetchGroups
    };
};
var $ae4e9f1b234ec064$export$2e2bcd8739ae039 = $ae4e9f1b234ec064$var$useGroupsQuery;

});

parcelRegister("1Sqdg", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ba2f9698998c578$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $2ba2f9698998c578$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    addMoreGroupsPrompt: {
        "id": "issue-field-group-picker.edit.add-more-groups-prompt",
        "defaultMessage": "add more groups..."
    }
});

});

parcelRegister("bBX9F", function(module, exports) {

$parcel$export(module.exports, "invalidStateStyle", () => $a587f3c9620f71a7$export$f204658c943efb85);
const $a587f3c9620f71a7$export$f204658c943efb85 = {
    borderColor: "var(--ds-border-danger, #E2483D)"
};

});


parcelRegister("26AI2", function(module, exports) {

$parcel$export(module.exports, "transformGroupDefaultValueToUserOption", () => $be8b40a81ee23965$export$d9591be6713fcfc8);
$parcel$export(module.exports, "mutateMultipleGroupPickerField", () => $be8b40a81ee23965$export$8cb86783be488510);
// @ts-expect-error - TS2614 - Module '"@atlaskit/user-picker"' has no exported member 'LegacyValue'. Did you mean to use 'import LegacyValue from "@atlaskit/user-picker"' instead?

var $cCjAH = parcelRequire("cCjAH");

const $be8b40a81ee23965$export$d9591be6713fcfc8 = (group)=>{
    if (!group) return null;
    if (Array.isArray(group)) return group.map((groupItem)=>(0, $cCjAH.transformGroupToUserOption)(groupItem));
    return (0, $cCjAH.transformGroupToUserOption)(group);
};
const $be8b40a81ee23965$export$8cb86783be488510 = (selectedGroups, fieldId)=>({
        fieldId: fieldId,
        groups: selectedGroups.map(({ name: name })=>({
                groupName: name
            })),
        mutationGroup: (0, $eeb6fb2f1e6228a1$export$31fd86f8f183952c)
    });

});
const $eeb6fb2f1e6228a1$export$31fd86f8f183952c = 'multipleGroupPickerFields';



parcelRegister("jKaE2", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7c1b04164930074$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $hllPB = parcelRequire("hllPB");

const $c7c1b04164930074$var$MultiSelectField = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hllPB.default), {
        ...props,
        isMulti: true
    });
var $c7c1b04164930074$export$2e2bcd8739ae039 = $c7c1b04164930074$var$MultiSelectField;

});
parcelRegister("hllPB", function(module, exports) {

$parcel$export(module.exports, "default", () => $93a73d1f2e1ea599$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $7pY2Y = parcelRequire("7pY2Y");

var $6KapF = parcelRequire("6KapF");

var $ixdDB = parcelRequire("ixdDB");

var $4yQUm = parcelRequire("4yQUm");

var $2nXHu = parcelRequire("2nXHu");

var $fE4zR = parcelRequire("fE4zR");

var $7kxDn = parcelRequire("7kxDn");
const $93a73d1f2e1ea599$var$SelectField = (props)=>{
    const { fieldId: fieldId, autoFocus: autoFocus = false, allowedValues: allowedValues, width: width, error: error, fieldProps: { value: value, onChange: onChange, id: id, isRequired: isRequired }, isMulti: isMulti = false, isReadOnly: isReadOnly = false, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, $ixdDB.closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, closeMenuOnSelect: closeMenuOnSelect = false } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fE4zR.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7pY2Y.default), {
        onChange: onChange,
        isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
        options: (0, $6KapF.mapDataToSelectOptions)(allowedValues),
        value: value,
        autoFocus: autoFocus,
        isInvalid: Boolean(error),
        classNamePrefix: `select-${fieldId}`,
        isMulti: isMulti,
        hideSelectedOptions: true,
        onCloseMenuOnScroll: onCloseMenuOnScroll,
        isClearable: true,
        onFilterOption: (0, $7kxDn.onFilterOption),
        isDisabled: isReadOnly,
        isRequired: isRequired,
        inputId: id,
        closeMenuOnSelect: closeMenuOnSelect
    }));
};
var $93a73d1f2e1ea599$export$2e2bcd8739ae039 = (0, $2nXHu.withFormField)({
    transformDefaultValue: (0, $7kxDn.transformDefaultSelectValues),
    validator: (0, $4yQUm.validateSelectField)
})($93a73d1f2e1ea599$var$SelectField);

});
parcelRegister("7pY2Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $3586527006aa6f34$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $c4OV1 = parcelRequire("c4OV1");

var $aUMMA = parcelRequire("aUMMA");

var $7jTnu = parcelRequire("7jTnu");
const $3586527006aa6f34$var$SelectEdit = (props)=>{
    const { classNamePrefix: classNamePrefix, closeMenuOnSelect: closeMenuOnSelect = false, placeholder: placeholder = '', options: options, onChange: onChange, onBlur: onBlur, onFocus: onFocus, autoFocus: autoFocus = false, isInvalid: isInvalid, isMulti: isMulti = false, isDisabled: isDisabled = false, value: value, isClearable: isClearable, onCloseMenuOnScroll: onCloseMenuOnScroll, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, onFilterOption: onFilterOption, inputId: inputId, isRequired: isRequired, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, defaultMenuIsOpen: defaultMenuIsOpen } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c4OV1.default), {
        placeholder: placeholder,
        options: options,
        value: value,
        classNamePrefix: classNamePrefix,
        // @ts-expect-error - TS2322 - Type '(option: SelectOption) => void' is not assignable to type '(value: SelectOption | OptionsType<SelectOption> | null, action: ActionMeta<SelectOption>) => void'.
        onChange: onChange,
        onBlur: onBlur,
        isMulti: isMulti,
        onFocus: onFocus,
        autoFocus: autoFocus,
        menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
        styles: (0, $aUMMA.defaultSelectStyles),
        // @ts-expect-error - TS2322 - Type '"error" | null' is not assignable to type 'ValidationState | undefined'.
        validationState: isInvalid === true ? 'error' : null,
        isClearable: isClearable,
        isDisabled: isDisabled,
        closeMenuOnScroll: onCloseMenuOnScroll,
        filterOption: onFilterOption,
        inputId: inputId,
        required: isRequired,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        closeMenuOnSelect: closeMenuOnSelect,
        ...(0, $7jTnu.fg)('bulk_ops_ktlo_fixes') && {
            defaultMenuIsOpen: defaultMenuIsOpen
        }
    });
};
var $3586527006aa6f34$export$2e2bcd8739ae039 = $3586527006aa6f34$var$SelectEdit;

});

parcelRegister("6KapF", function(module, exports) {

$parcel$export(module.exports, "mapSelectOptionsToData", () => $422cb851184a80c2$export$7cdfccbc726f6f22);
$parcel$export(module.exports, "mapMultiSelectOptionsToData", () => $422cb851184a80c2$export$b91253d30be01e62);
$parcel$export(module.exports, "mapDataToSelectOption", () => $422cb851184a80c2$export$8f475f1fdc96a964);
$parcel$export(module.exports, "mapDataToSelectOptions", () => $422cb851184a80c2$export$dc22cde66e28d4af);
const $422cb851184a80c2$export$7cdfccbc726f6f22 = (option)=>({
        id: option.value,
        value: option.label
    });
const $422cb851184a80c2$export$b91253d30be01e62 = (options)=>options.map((option)=>({
            id: option.value,
            value: option.label
        }));
const $422cb851184a80c2$export$8f475f1fdc96a964 = (optionExternal)=>({
        label: optionExternal.value,
        value: optionExternal.id
    });
const $422cb851184a80c2$export$dc22cde66e28d4af = (data)=>data.map((optionExternal)=>$422cb851184a80c2$export$8f475f1fdc96a964(optionExternal));

});

parcelRegister("7kxDn", function(module, exports) {

$parcel$export(module.exports, "transformDefaultSelectValues", () => $476888ac37975b01$export$cfb7677fb5241257);
$parcel$export(module.exports, "onFilterOption", () => $476888ac37975b01$export$5fde4483c43b93b);

var $6KapF = parcelRequire("6KapF");
const $476888ac37975b01$export$cfb7677fb5241257 = (defaultValue)=>{
    if (Array.isArray(defaultValue)) return (0, $6KapF.mapDataToSelectOptions)(defaultValue);
    return (0, $6KapF.mapDataToSelectOption)(defaultValue);
};
const $476888ac37975b01$export$5fde4483c43b93b = (option, inputValue)=>option.label.toLowerCase().includes(inputValue.toLowerCase());

});



parcelRegister("fS2Sv", function(module, exports) {

$parcel$export(module.exports, "mutateMultiSelectField", () => $ba1e0c9286a3b192$export$3313ce8403b211b4);
$parcel$export(module.exports, "mapMultiSelectOptionsToConnectData", () => $ba1e0c9286a3b192$export$a7431ac3899bcd4d);

const $ba1e0c9286a3b192$export$3313ce8403b211b4 = (selectedValues, fieldId)=>({
        fieldId: fieldId,
        mutationGroup: (0, $2349c05b391c493a$export$31fd86f8f183952c),
        options: selectedValues.map(({ value: value })=>({
                optionId: value
            }))
    });
const $ba1e0c9286a3b192$export$a7431ac3899bcd4d = (options)=>options.map((option)=>option.value);

});
const $2349c05b391c493a$export$31fd86f8f183952c = 'multipleSelectFields';


parcelRegister("6nvAz", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f714ccc50a1db67$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $6VWiM = parcelRequire("6VWiM");
const $6f714ccc50a1db67$var$MultiUserPickerField = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6VWiM.default), {
        ...props,
        isMulti: true,
        context: "CustomMultiUserField"
    });
var $6f714ccc50a1db67$export$2e2bcd8739ae039 = $6f714ccc50a1db67$var$MultiUserPickerField;

});
parcelRegister("6VWiM", function(module, exports) {

$parcel$export(module.exports, "default", () => $529b01b4fedffa26$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $7jTnu = parcelRequire("7jTnu");

var $4yBOW = parcelRequire("4yBOW");

var $ixdDB = parcelRequire("ixdDB");

var $4yQUm = parcelRequire("4yQUm");

var $2nXHu = parcelRequire("2nXHu");

var $fE4zR = parcelRequire("fE4zR");

var $d706p = parcelRequire("d706p");

const $529b01b4fedffa26$var$getAutoCompleteUrl = (context, fieldId, projectKey)=>`/rest/api/3/user/recommend?${new URLSearchParams({
        context: context,
        ...projectKey && {
            project: projectKey
        },
        ...fieldId && {
            fieldId: fieldId
        },
        query: ''
    })}`;
const $529b01b4fedffa26$var$UserPickerField = (props)=>{
    const { width: width, fieldProps: { value: value, onChange: onChange, id: id }, isMulti: isMulti, autoFocus: autoFocus = false, fieldId: fieldId, placeholder: placeholder = ' ', isDisabled: isDisabled = false, isReadOnly: isReadOnly = false, onFetchSuggestions: onFetchSuggestions, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, context: context, selectedProject: selectedProject, projectKey: projectKey } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fE4zR.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4yBOW.default), {
        autoCompleteUrl: $529b01b4fedffa26$var$getAutoCompleteUrl(context, fieldId, // this is for fixing an issue that the custom user picker doesn't show the right user group in form when the project key is missing
        (0, $7jTnu.fg)('jira_forms_fix_user_picker_missing_project_key') ? projectKey || selectedProject?.projectKey : selectedProject?.projectKey),
        placeholder: placeholder,
        isDisabled: isReadOnly || isDisabled,
        onChange: onChange,
        value: value,
        appearance: "normal",
        isMulti: isMulti,
        autoFocus: autoFocus,
        fieldId: fieldId,
        fetchSuggestions: onFetchSuggestions,
        isClearable: true,
        width: width,
        inputId: id,
        onCloseMenuOnScroll: (0, $ixdDB.closeMenuOnScroll),
        isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered
    }));
};
var $529b01b4fedffa26$export$2e2bcd8739ae039 = (0, $2nXHu.withFormField)({
    validator: (0, $4yQUm.validateUserPickerField),
    transformDefaultValue: (0, $d706p.transformDefaultUserValues)
})($529b01b4fedffa26$var$UserPickerField);

});
parcelRegister("4yBOW", function(module, exports) {

$parcel$export(module.exports, "default", () => $937c75afb5fdcba3$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $hKwJp = parcelRequire("hKwJp");

var $ezTte = parcelRequire("ezTte");
const $937c75afb5fdcba3$var$UserPickerEdit = (props)=>{
    const { fieldId: fieldId, appearance: appearance, width: width, onChange: onChange, onSelection: onSelection, value: value, autoFocus: autoFocus = false, placeholder: placeholder = '', isDisabled: isDisabled = false, autoCompleteUrl: autoCompleteUrl, isMulti: isMulti, fetchSuggestions: fetchSuggestions, emptyOption: emptyOption, onDataLoaded: onDataLoaded, onDataRequest: onDataRequest, onCancel: onCancel, isDropdownVisibleByDefault: isDropdownVisibleByDefault, isClearable: isClearable, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, onCloseMenuOnScroll: onCloseMenuOnScroll, inputId: inputId, isBulkEdit: isBulkEdit = false, ...fieldProps } = props;
    const extraProps = ()=>{
        if (isDropdownMenuFixedAndLayered) return {
            menuPosition: 'fixed',
            styles: (0, $ezTte.defaultUserPickerStyles),
            onCloseMenuOnScroll: onCloseMenuOnScroll
        };
        return {
            onCloseMenuOnScroll: onCloseMenuOnScroll
        };
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hKwJp.default), {
        ...fieldProps,
        fieldId: fieldId,
        inputId: inputId,
        appearance: appearance,
        width: width,
        onChange: onChange,
        value: value,
        autoFocus: autoFocus,
        placeholder: placeholder,
        isDisabled: isDisabled,
        isMulti: isMulti,
        autoCompleteUrl: autoCompleteUrl,
        fetchSuggestions: fetchSuggestions,
        emptyOption: emptyOption,
        onSelection: onSelection,
        onDataLoaded: onDataLoaded,
        onDataRequest: onDataRequest,
        onCancel: onCancel,
        isDropdownVisibleByDefault: isDropdownVisibleByDefault,
        isClearable: isClearable,
        isBulkEdit: isBulkEdit,
        ...extraProps()
    });
};
var $937c75afb5fdcba3$export$2e2bcd8739ae039 = $937c75afb5fdcba3$var$UserPickerEdit;

});
parcelRegister("hKwJp", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff917e2f502b288a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $3s8bj = parcelRequire("3s8bj");

var $12DRg = parcelRequire("12DRg");

var $ewHZ5 = parcelRequire("ewHZ5");

var $jGzN3 = parcelRequire("jGzN3");

var $lRq8t = parcelRequire("lRq8t");


var $7xkiz = parcelRequire("7xkiz");

var $iOe3s = parcelRequire("iOe3s");
const $ff917e2f502b288a$var$stringContains = (str, substr)=>{
    if (str == null) return false;
    if (substr == null || substr === '') return true;
    return str.toLowerCase().includes(substr.toLowerCase());
};
const $ff917e2f502b288a$export$251bdbdbce9550ea = 400;
const $ff917e2f502b288a$var$UserPickerWrapper = (props)=>{
    const { allowEmail: allowEmail = false, isDisabled: isDisabled, isMulti: isMulti = false, value: value = null, emptyOption: emptyOption = null, appearance: appearance = 'compact', onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), onCancel: onCancel = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), onSelection: onSelection = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), onDataRequest: onDataRequest = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), onDataLoaded: onDataLoaded = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), isClearable: isClearable = false, portalElement: portalElement, isDropdownVisibleByDefault: isDropdownVisibleByDefault, menuPosition: menuPosition, onCloseMenuOnScroll: onCloseMenuOnScroll, autoFocus: autoFocus, fieldId: fieldId, placeholder: placeholder, width: width, autoCompleteUrl: autoCompleteUrl, noBorder: noBorder, styles: styles, shouldShowEmailInOptions: shouldShowEmailInOptions = false, withoutDebounce: withoutDebounce = false, inputId: inputId, isBulkEdit: isBulkEdit = false, openMenuOnClick: openMenuOnClick = false, isRequired: isRequired = false, menuMinWidth: menuMinWidth, fetchSuggestions: fetchSuggestionsProps, ...fieldProps } = props;
    const [isDropdownVisible, setIsDropdownVisible] = (0, $eJOHy.useState)(Boolean(isDropdownVisibleByDefault));
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    // null instead of '' because:
    // 1. fetchSuggestions is called as part of useEffect with query as one of the dependencies
    // 2. we dont want to call fetchSuggestions on mount, so added a check query !== null
    // 3. we want to call fetchSuggestions when query is '' and when picker gets focused (we set query as '') when it gets focused
    const [query, setQueryString] = (0, $eJOHy.useState)(null);
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(false);
    const [wasFocused, setWasFocused] = (0, $eJOHy.useState)(false);
    const [wasCleared, setWasCleared] = (0, $eJOHy.useState)(false);
    const [suggestions, setSuggestions] = (0, $eJOHy.useState)([]);
    const [sessionId, setSessionId] = (0, $eJOHy.useState)('');
    const getEmptyValue = ()=>emptyOption ? {
            ...emptyOption,
            id: (0, $c056b3ad6a2eccc2$export$61a0b64dfe00294c)
        } : null;
    const debounceTime = withoutDebounce ? 0 : $ff917e2f502b288a$export$251bdbdbce9550ea;
    const requestSuggestionsDebounced = (0, $eJOHy.useMemo)(()=>{
        const isCurrentValue = (userOptionValue)=>{
            if (!userOptionValue) return value === null;
            if (Array.isArray(value)) return value.length > 0 ? !!value.find((suggestion)=>suggestion.id === userOptionValue.id) : userOptionValue.id === (0, $c056b3ad6a2eccc2$export$61a0b64dfe00294c);
            return value ? userOptionValue.id === value.id : userOptionValue.id === (0, $c056b3ad6a2eccc2$export$61a0b64dfe00294c);
        };
        const fetchSuggestions = async ()=>{
            let users = [];
            if (autoCompleteUrl !== undefined) {
                const autoCompleteResponse = await (0, $jGzN3.performGetRequest)(`${autoCompleteUrl}${query || ''}`);
                users = (0, $iOe3s.mapAutoCompleteResponseToUsers)(autoCompleteResponse, isBulkEdit);
            }
            return users.map((userData)=>(0, $iOe3s.mapUserObjectToUserOption)(userData, shouldShowEmailInOptions));
        };
        const handleSuggestions = (newSuggestions)=>{
            if (!isDropdownVisible || !newSuggestions) return;
            // Prevent the selected value from appearing in the list of suggestions at initial load.
            const filteredSuggestions = wasFocused ? newSuggestions.filter((suggestion)=>!isCurrentValue(suggestion)) : newSuggestions;
            setIsLoading(false);
            setSuggestions(filteredSuggestions);
            onDataLoaded(!query, filteredSuggestions.length);
        };
        const handleError = ()=>{
            setIsLoading(false);
            setSuggestions([]);
        };
        // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
        const requestSuggestions = ()=>{
            onDataRequest(!query);
            if (fetchSuggestionsProps) return fetchSuggestionsProps(query, sessionId).then((results)=>{
                handleSuggestions(results);
            }).catch(handleError);
            return fetchSuggestions().then((results)=>handleSuggestions(results)).catch(handleError);
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(()=>{
            requestSuggestions();
        }, debounceTime);
    }, [
        debounceTime,
        value,
        autoCompleteUrl,
        query,
        isBulkEdit,
        shouldShowEmailInOptions,
        isDropdownVisible,
        wasFocused,
        onDataLoaded,
        onDataRequest,
        fetchSuggestionsProps,
        sessionId
    ]);
    (0, $eJOHy.useEffect)(()=>{
        // Added extra !isDropdownVisible condition - avoid query when dropdown is closed
        if (query === null || !isDropdownVisible) return;
        requestSuggestionsDebounced();
        return ()=>{
            requestSuggestionsDebounced.cancel();
        };
    }, [
        requestSuggestionsDebounced,
        query,
        isDropdownVisible
    ]);
    const onSelectedValueChangeMulti = (userOptionValue)=>{
        if (userOptionValue && userOptionValue.length === 0) onChange(null);
        else onChange(userOptionValue);
    };
    const onSelectedValueChangeSingle = (userOptionValue)=>{
        const valueId = userOptionValue && !Array.isArray(userOptionValue) && userOptionValue.id;
        if (valueId === (0, $c056b3ad6a2eccc2$export$61a0b64dfe00294c)) onChange(null);
        else onChange(userOptionValue);
    };
    const onSuggestionSelect = (userOptionValue, sId)=>{
        setSessionId(sId || '');
        setWasFocused(false);
        setWasCleared(false);
        setIsLoading(false);
        setSuggestions([]);
        onSelection(sessionId);
        if (Array.isArray(userOptionValue)) onSelectedValueChangeMulti(userOptionValue);
        else // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        onSelectedValueChangeSingle(userOptionValue);
    };
    const onBlur = ()=>{
        setIsDropdownVisible(false);
        setIsLoading(false);
        setWasFocused(false);
        setSuggestions([]);
        if (wasCleared) {
            onSuggestionSelect(getEmptyValue());
            return;
        }
        onCancel();
    };
    const onDropdownOpen = (sId)=>{
        setSessionId(sId || '');
        setQueryString('');
        setIsDropdownVisible(true);
        setIsLoading(true);
        setWasFocused(true);
        setWasCleared(false);
    };
    const onQueryChange = (queryStr, sId)=>{
        setSessionId(sId || '');
        setQueryString(queryStr || '');
        setIsLoading(!!queryStr);
        setWasFocused(false);
        setIsDropdownVisible(!!queryStr);
    };
    const onClear = ()=>{
        setWasCleared(true);
        onSuggestionSelect(null);
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const closeMenuOnScroll = (e)=>{
        if (onCloseMenuOnScroll && onCloseMenuOnScroll(e)) setIsDropdownVisible(false);
    };
    const isMatchingQuery = (suggestion)=>{
        // when feature flag is false the predict should allow all
        const { displayName: displayName, name: name } = suggestion;
        return !isLoading || $ff917e2f502b288a$var$stringContains(displayName, query) || $ff917e2f502b288a$var$stringContains(name, query);
    };
    const getSuggestions = ()=>suggestions.filter((suggestion)=>isMatchingQuery(suggestion));
    const filteredSuggestions = getSuggestions();
    const pickerValue = value || getEmptyValue();
    const getNoOptionsMessage = ()=>query === null || query === '' ? formatMessage((0, $7xkiz.default).emptyQueryMessage) : undefined;
    /*
   * user picker default opens on focus, so most of the operations like loading, querying, dropdown open/close are modified during onFocus
   * when openMenuOnClick is true then dropdown state managed internally as like select then have to use onOpen to modify any state like loading, querying
   */ const controlProps = openMenuOnClick ? {
        openMenuOnClick: openMenuOnClick,
        onOpen: onDropdownOpen
    } : {
        open: isDropdownVisible,
        onFocus: onDropdownOpen
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ewHZ5.UserPicker), {
        value: pickerValue,
        options: filteredSuggestions,
        isMulti: isMulti,
        fieldId: fieldId,
        menuMinWidth: menuMinWidth,
        menuPortalTarget: portalElement,
        width: width,
        appearance: appearance,
        isClearable: isClearable,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        placeholder: placeholder,
        onBlur: onBlur,
        isLoading: isLoading && isDropdownVisible,
        onClear: onClear,
        onInputChange: onQueryChange,
        onChange: onSuggestionSelect,
        noBorder: noBorder,
        styles: styles,
        noOptionsMessage: getNoOptionsMessage,
        allowEmail: allowEmail,
        inputId: inputId,
        required: isRequired,
        ariaLabel: fieldProps['aria-label'],
        ariaLabelledBy: fieldProps['aria-labelledby'],
        closeMenuOnScroll: closeMenuOnScroll,
        menuPosition: menuPosition,
        ...controlProps
    });
};
var $ff917e2f502b288a$export$2e2bcd8739ae039 = $ff917e2f502b288a$var$UserPickerWrapper;

});
const $c056b3ad6a2eccc2$export$61a0b64dfe00294c = 'USER_PICKER_EMPTY';

parcelRegister("7xkiz", function(module, exports) {

$parcel$export(module.exports, "default", () => $55f21552ba60edb8$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $55f21552ba60edb8$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    emptyQueryMessage: {
        "id": "base-user-picker.empty-query-message",
        "defaultMessage": "Start typing to get a list of possible matches."
    }
});

});

parcelRegister("iOe3s", function(module, exports) {

$parcel$export(module.exports, "mapUserObjectToUserOption", () => $bab0d9f772604af7$export$e11fc32dba4fe919);
$parcel$export(module.exports, "mapAutoCompleteResponseToUsers", () => $bab0d9f772604af7$export$ec325826d2bf6655);

var $gYnSx = parcelRequire("gYnSx");
const $bab0d9f772604af7$export$e11fc32dba4fe919 = (userData, shouldShowEmailInOptions = false)=>{
    let userOption = {
        id: userData.accountId || '',
        name: userData.displayName || '',
        avatarUrl: userData?.avatarUrl || userData.avatarUrls?.['32x32'] || ''
    };
    if (shouldShowEmailInOptions === true && userData.emailAddress !== null && userData.emailAddress !== undefined) // @ts-expect-error - TS2322 - Type '{ byline: string; id: string; name: string; avatarUrl: string; }' is not assignable to type '{ id: string; name: string; avatarUrl: string; }'.
    userOption = {
        ...userOption,
        byline: userData.emailAddress
    };
    return userOption;
};
const $bab0d9f772604af7$export$ec325826d2bf6655 = (autoCompleteResponse, isBulkEdit)=>{
    try {
        if (isBulkEdit) {
            if (autoCompleteResponse && typeof autoCompleteResponse === 'object' && 'users' in autoCompleteResponse && autoCompleteResponse.users) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return autoCompleteResponse.users;
        } else if (Array.isArray(autoCompleteResponse)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return autoCompleteResponse;
        throw Error('autoCompleteResponse is either null or not expected value');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gYnSx.default)({
            meta: {
                id: 'mapAutoCompleteResponse',
                packageName: 'jiraBaseUserPicker',
                teamName: 'gryffindor'
            },
            error: error,
            skipSentry: true,
            attributes: {
                autoCompleteResponseIsNull: autoCompleteResponse === null
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return [];
};

});





parcelRegister("dOwo2", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e034ce54f66c952$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $k71qx = parcelRequire("k71qx");

var $lRq8t = parcelRequire("lRq8t");

var $lA1W4 = parcelRequire("lA1W4");

var $coifs = parcelRequire("coifs");

var $fE4zR = parcelRequire("fE4zR");

var $2nXHu = parcelRequire("2nXHu");

var $ixdDB = parcelRequire("ixdDB");

var $4yQUm = parcelRequire("4yQUm");

var $ddaK6 = parcelRequire("ddaK6");

var $fAftm = parcelRequire("fAftm");

const $7e034ce54f66c952$var$MultiVersionsField = (props)=>{
    const { width: width, fieldProps: { value: value, onChange: onChange, id: id, isRequired: isRequired }, fieldId: fieldId, fieldName: fieldName, description: description, isReadOnly: isReadOnly = false, allowedValues: allowedValues, error: error, autoFocus: autoFocus = false, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, $ixdDB.closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, isMini: isMini } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const options = (0, $fAftm.transformVersionExternalOptionstoVersionOptions)(allowedValues);
    const isDisabled = allowedValues.length === 0;
    const onChangeVersionsEdit = (versionEditValue)=>{
        if (Array.isArray(versionEditValue) || versionEditValue === null) onChange(versionEditValue);
    };
    const getVersionsEdit = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lA1W4.default), {
            options: options,
            value: value,
            isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
            isMulti: true,
            onChange: onChangeVersionsEdit,
            isInvalid: Boolean(error),
            fieldId: fieldId,
            onCloseMenuOnScroll: onCloseMenuOnScroll,
            isDisabled: isReadOnly || isDisabled,
            autoFocus: autoFocus,
            placeholder: isDisabled ? formatMessage((0, $ddaK6.default).none) : '',
            inputId: id,
            isRequired: isRequired
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fE4zR.FieldContainer), {
        width: width
    }, isDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: formatMessage((0, $ddaK6.default).tooltip)
    }, getVersionsEdit()) : getVersionsEdit(), !isDisabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $coifs.FieldMessage), {
        description: description,
        error: error,
        fieldName: fieldName,
        isMini: isMini
    }));
};
var $7e034ce54f66c952$export$2e2bcd8739ae039 = (0, $2nXHu.withFormField)({
    validator: (0, $4yQUm.validateMultiVersionsField),
    transformDefaultValue: (0, $fAftm.transformVersionExternalOptionstoVersionOptions),
    shouldRenderFieldMessage: false
})($7e034ce54f66c952$var$MultiVersionsField);

});
parcelRegister("lA1W4", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e7f05cbead138be$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $c4OV1 = parcelRequire("c4OV1");

var $lRq8t = parcelRequire("lRq8t");

var $aUMMA = parcelRequire("aUMMA");

var $dOI9z = parcelRequire("dOI9z");
const $0e7f05cbead138be$var$Versions = (props)=>{
    const { value: value, options: options, onChange: onChange, placeholder: placeholder = '', isInvalid: isInvalid, fieldId: fieldId, isMulti: isMulti, autoFocus: autoFocus = false, isDisabled: isDisabled, onCloseMenuOnScroll: onCloseMenuOnScroll, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, inputId: inputId, isRequired: isRequired, classNamePrefix: classNamePrefix, isClearable: isClearable = true, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, openMenuOnFocus: openMenuOnFocus = false } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const getIsClearable = ()=>{
        if (!isClearable) return false;
        return Array.isArray(value) ? value.length > 0 : Boolean(value);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c4OV1.default), {
        placeholder: placeholder,
        options: (0, $dOI9z.getGroupedOptions)((0, $dOI9z.removeArchivedOptions)(options), formatMessage),
        // @ts-expect-error - TS2322 - Type '"error" | null' is not assignable to type 'ValidationState | undefined'.
        validationState: isInvalid === true ? 'error' : null,
        value: value,
        fieldId: fieldId,
        isMulti: isMulti,
        menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides -- Ignored via go/DSP-18766
        styles: (0, $aUMMA.defaultSelectStyles),
        // @ts-expect-error - TS2322 - Type '(option: VersionOption | VersionOption[] | null) => void' is not assignable to type '(value: VersionOption | OptionsType<VersionOption> | null, action: ActionMeta<VersionOption>) => void'.
        onChange: onChange,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        closeMenuOnScroll: onCloseMenuOnScroll,
        isClearable: getIsClearable(),
        inputId: inputId,
        required: isRequired,
        classNamePrefix: classNamePrefix,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        openMenuOnFocus: openMenuOnFocus
    });
};
var $0e7f05cbead138be$export$2e2bcd8739ae039 = $0e7f05cbead138be$var$Versions;

});
parcelRegister("dOI9z", function(module, exports) {

$parcel$export(module.exports, "transformVersionExternalToVersion", () => $776f46bd68c49ea6$export$c1c38f7974aa8bed);
$parcel$export(module.exports, "removeArchivedOptions", () => $776f46bd68c49ea6$export$6f0b68b6e372a0e6);
$parcel$export(module.exports, "getGroupedOptions", () => $776f46bd68c49ea6$export$721c3d9226425f9c);
$parcel$export(module.exports, "getVersionsIds", () => $776f46bd68c49ea6$export$c96a1607e976ccc6);
$parcel$export(module.exports, "getVersionId", () => $776f46bd68c49ea6$export$d0a84488c5034e2b);

var $l2GhR = parcelRequire("l2GhR");
const $776f46bd68c49ea6$var$getStatusFromRestOption = (option)=>{
    if (option.released) return 'RELEASED';
    if (option.archived) return 'ARCHIVED';
    return 'UNRELEASED';
};
const $776f46bd68c49ea6$export$eb178ff2323a1ab3 = (option)=>({
        label: option.name,
        value: option.id,
        status: $776f46bd68c49ea6$var$getStatusFromRestOption(option)
    });
const $776f46bd68c49ea6$export$c1c38f7974aa8bed = (option)=>({
        label: option.name,
        value: option.id,
        status: option.status
    });
const $776f46bd68c49ea6$export$6f0b68b6e372a0e6 = (options)=>options.filter((option)=>option.status !== 'ARCHIVED');
const $776f46bd68c49ea6$export$721c3d9226425f9c = (options, formatMessage)=>{
    const groupedOptions = [];
    // archived options are assumed to be filtered out already since we don't want to display them. Here, we are grouping according to 'status' being RELEASED or UNRELEASED
    if (options.length) {
        // the order of versions is decided from the first option since the API response follows the order
        const versionOrder = options.length && options[0].status === 'RELEASED' ? [
            'RELEASED',
            'UNRELEASED'
        ] : [
            'UNRELEASED',
            'RELEASED'
        ];
        // @ts-expect-error - TS2345 - Argument of type '(status: Status) => void' is not assignable to parameter of type '(value: string, index: number, array: string[]) => void'.
        versionOrder.forEach((status)=>{
            const statusOptions = options.filter((option)=>option.status === status);
            if (statusOptions.length) groupedOptions.push({
                options: statusOptions,
                label: status === 'RELEASED' ? formatMessage((0, $l2GhR.default).released) : formatMessage((0, $l2GhR.default).unreleased)
            });
        });
    }
    return groupedOptions;
};
const $776f46bd68c49ea6$export$c96a1607e976ccc6 = (selectedVersions)=>selectedVersions.map((v)=>({
            id: v.value
        }));
const $776f46bd68c49ea6$export$d0a84488c5034e2b = (selectedVersion)=>({
        id: selectedVersion.value
    });

});
parcelRegister("l2GhR", function(module, exports) {

$parcel$export(module.exports, "default", () => $03a802f08f52b713$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $03a802f08f52b713$var$messages = (0, $7qGN1.defineMessages)({
    released: {
        "id": "issue-field-versions.released",
        "defaultMessage": "Released"
    },
    unreleased: {
        "id": "issue-field-versions.unreleased",
        "defaultMessage": "Unreleased"
    }
});
var $03a802f08f52b713$export$2e2bcd8739ae039 = $03a802f08f52b713$var$messages;

});



parcelRegister("ddaK6", function(module, exports) {

$parcel$export(module.exports, "default", () => $16015d0f3d7a2b41$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $16015d0f3d7a2b41$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    none: {
        "id": "issue-create-commons.multi-versions-field.none",
        "defaultMessage": "None"
    },
    tooltip: {
        "id": "issue-create-commons.multi-versions-field.tooltip",
        "defaultMessage": "We couldn't find any versions for this project"
    }
});

});

parcelRegister("fAftm", function(module, exports) {

$parcel$export(module.exports, "transformVersionExternalOptionstoVersionOptions", () => $9c38922f7fd62a42$export$11cad9e2f2e9ae55);
$parcel$export(module.exports, "mutateMultiVersionsField", () => $9c38922f7fd62a42$export$6999207a9642bd09);

var $dOI9z = parcelRequire("dOI9z");

const $9c38922f7fd62a42$export$11cad9e2f2e9ae55 = (options)=>options.map((option)=>(0, $dOI9z.transformVersionExternalToVersion)(option));
const $9c38922f7fd62a42$export$6999207a9642bd09 = (selectedVersions, fieldId)=>({
        fieldId: fieldId,
        mutationGroup: (0, $7cd8019c50d8ddd9$export$31fd86f8f183952c),
        versions: selectedVersions.map(({ value: value })=>({
                versionId: value
            }))
    });

});
const $7cd8019c50d8ddd9$export$31fd86f8f183952c = 'multipleVersionPickerFields';



parcelRegister("1VP2V", function(module, exports) {

$parcel$export(module.exports, "default", () => $03fc09207ab3b42f$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $lm0ZR = parcelRequire("lm0ZR");

var $2nXHu = parcelRequire("2nXHu");

var $4yQUm = parcelRequire("4yQUm");

var $ko1zK = parcelRequire("ko1zK");

const $03fc09207ab3b42f$export$63c5fa0b2fdccd2e = (props)=>{
    const { width: width = 350, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lm0ZR.InputField), {
        type: "number",
        width: width,
        ...rest
    });
};
var $03fc09207ab3b42f$export$2e2bcd8739ae039 = (0, $2nXHu.withFormField)({
    validator: (0, $4yQUm.validateString),
    transformDefaultValue: (0, $ko1zK.transformAsString)
})(// @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element' is not assignable to parameter of type 'AbstractComponent<ComponentProps<InputFieldConfig, string>, any>'.
$03fc09207ab3b42f$export$63c5fa0b2fdccd2e);

});
parcelRegister("lm0ZR", function(module, exports) {

$parcel$export(module.exports, "InputField", () => $586658d32f103532$export$dd2171e2b7d3bc5b);
$parcel$export(module.exports, "default", () => $586658d32f103532$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $sY9BV = parcelRequire("sY9BV");

var $4yQUm = parcelRequire("4yQUm");

var $2nXHu = parcelRequire("2nXHu");

var $2raVK = parcelRequire("2raVK");
const $586658d32f103532$export$dd2171e2b7d3bc5b = (props)=>{
    const { type: type = 'text', width: width = 'auto', error: error, fieldProps: { value: value = '', onChange: onChange, ...rest }, autoFocus: autoFocus, isReadOnly: isReadOnly = false } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $sY9BV.default), {
        ...rest,
        // @ts-expect-error - TS2322 - Type '(value: string) => void' is not assignable to type 'FormEventHandler<HTMLInputElement>'.
        onChange: onChange,
        value: value,
        type: type,
        width: width,
        step: "any",
        testId: "issue-create-commons.common.ui.fields.base-fields.input-field.textfield",
        isInvalid: Boolean(error),
        autoFocus: autoFocus,
        onWheel: (0, $2raVK.preventMouseScrollForNumericFieldHandler),
        isDisabled: isReadOnly || rest.isDisabled
    });
};
var $586658d32f103532$export$2e2bcd8739ae039 = (0, $2nXHu.withFormField)({
    validator: (0, $4yQUm.validateString)
})(// @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element' is not assignable to parameter of type 'AbstractComponent<ComponentProps<InputFieldConfig, string>, any>'.
$586658d32f103532$export$dd2171e2b7d3bc5b);

});
parcelRegister("2raVK", function(module, exports) {

$parcel$export(module.exports, "preventMouseScrollForNumericFieldHandler", () => $00dc944cc6be550a$export$3fedcbfe1c53d8f);
const $00dc944cc6be550a$export$3fedcbfe1c53d8f = (event)=>{
    if (event?.currentTarget?.type === 'number') event.currentTarget.blur?.();
};

});


parcelRegister("ko1zK", function(module, exports) {

$parcel$export(module.exports, "transformAsNumber", () => $2bb04542b92080fd$export$52c4e7404b9db862);
$parcel$export(module.exports, "mutateNumberField", () => $2bb04542b92080fd$export$6701d4d68ea6db95);
$parcel$export(module.exports, "transformAsString", () => $2bb04542b92080fd$export$afe59f8094df7220);

const $2bb04542b92080fd$export$52c4e7404b9db862 = (value)=>{
    if (value) return Number(value);
    return undefined;
};
const $2bb04542b92080fd$export$6701d4d68ea6db95 = (value, fieldId)=>({
        fieldId: fieldId,
        value: Number(value),
        mutationGroup: (0, $6a0fe377abda155e$export$31fd86f8f183952c)
    });
const $2bb04542b92080fd$export$afe59f8094df7220 = (value)=>{
    if (value !== undefined) return String(value);
    return undefined;
};

});
const $6a0fe377abda155e$export$31fd86f8f183952c = 'numberFields';



parcelRegister("p3R5y", function(module, exports) {

$parcel$export(module.exports, "default", () => $a663ad0d4efb2f8c$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8JCmF = parcelRequire("8JCmF");

var $ch9En = parcelRequire("ch9En");

var $lGaCn = parcelRequire("lGaCn");

var $fE4zR = parcelRequire("fE4zR");

var $2nXHu = parcelRequire("2nXHu");

var $ixdDB = parcelRequire("ixdDB");

var $4yQUm = parcelRequire("4yQUm");

var $OOOvs = parcelRequire("OOOvs");

const $a663ad0d4efb2f8c$var$OrganizationsField = (props)=>{
    const { autoCompleteUrl: autoCompleteUrl, width: width, autoFocus: autoFocus = false, fieldProps: { value: value, onChange: onChange, ...fieldProps }, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, $ixdDB.closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, error: error } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fE4zR.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "organizations-edit",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lGaCn.FieldLoader), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8JCmF.LazyOrganizationsEdit), {
        ...fieldProps,
        isInvalid: Boolean(error),
        isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
        autoCompleteUrl: autoCompleteUrl,
        onChange: onChange,
        value: value,
        autoFocus: autoFocus,
        onCloseMenuOnScroll: onCloseMenuOnScroll,
        fetchSuggestionsOnFocus: true
    })));
};
var $a663ad0d4efb2f8c$export$2e2bcd8739ae039 = (0, $2nXHu.withFormField)({
    validator: (0, $4yQUm.validateOrganizationsField),
    transformDefaultValue: (0, $OOOvs.mapDataToOrganizationOptions)
})($a663ad0d4efb2f8c$var$OrganizationsField);

});
parcelRegister("8JCmF", function(module, exports) {

$parcel$export(module.exports, "LazyOrganizationsEdit", () => $22f243e18c078416$export$f11d485f96c53cba);

var $bQWwW = parcelRequire("bQWwW");

const $22f243e18c078416$export$f11d485f96c53cba = (0, $bQWwW.lazy)(()=>(parcelRequire("fkW8z")).then((module)=>module.OrganizationsEdit), {
    moduleId: "./src/packages/issue/fields/organizations/src/index.tsx"
});

});
parcelRegister("fkW8z", function(module, exports) {

let $b2a5d22104b7b8f0$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $b2a5d22104b7b8f0$var$load("8dhqQ").then(()=>parcelRequire('5i4s6'));

});


parcelRegister("OOOvs", function(module, exports) {

$parcel$export(module.exports, "mapDataToOrganizationOptions", () => $9a428802164947bf$export$bb720a783a78b0f4);
$parcel$export(module.exports, "mutateOrganizationsField", () => $9a428802164947bf$export$51fa85dc3b5fc461);
const $9a428802164947bf$export$bb720a783a78b0f4 = (data)=>data.map(({ organizationName: organizationName, organizationId: organizationId })=>({
            value: organizationId,
            label: organizationName
        }));
const $9a428802164947bf$export$51fa85dc3b5fc461 = (selectedOrganizations, fieldId)=>({
        organizationField: {
            fieldId: fieldId,
            organizations: selectedOrganizations.map(({ value: value })=>({
                    organizationId: value
                }))
        }
    });

});


parcelRegister("kmGOd", function(module, exports) {

$parcel$export(module.exports, "default", () => $034c9b22394cd968$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $fKXve = parcelRequire("fKXve");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $lopBx = parcelRequire("lopBx");

var $epTsa = parcelRequire("epTsa");

var $7jTnu = parcelRequire("7jTnu");

var $lRq8t = parcelRequire("lRq8t");


var $6LckD = parcelRequire("6LckD");

var $fE4zR = parcelRequire("fE4zR");

var $2nXHu = parcelRequire("2nXHu");

var $ixdDB = parcelRequire("ixdDB");

var $5jAKT = parcelRequire("5jAKT");

var $8cifA = parcelRequire("8cifA");

const $034c9b22394cd968$export$96c87c0afbe06b37 = (props)=>{
    const { fieldId: fieldId, fieldProps: { value: value, onChange: onChange }, width: width, autoFocus: autoFocus = false, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, $ixdDB.closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, isExistingIssue: isExistingIssue, selectedProject: selectedProject, selectedIssueType: selectedIssueType, issueKey: issueKey, isReadOnly: isReadOnly = false } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    let issueTypeId;
    if (selectedIssueType) issueTypeId = selectedIssueType.type === (0, $4246188a36de9908$export$92ab80c1dc9baf44) ? selectedIssueType.issueTypeId : selectedIssueType.value;
    /**
   * When creating a sub-task from the GIC modal, we:
   * - pre-populate the parent field in "src/packages/issue-navigator/issue-operations/meatball-menu/src/ui/dropdown-menu-group/button-item/index"
   * - disable the parent field to prevent the user to change it
   *
   * This prevents the user to make a mistake or bump into potential edge cases.
   */ const isDisabled = props.isSubTaskCreationOpen || isReadOnly;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fE4zR.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6LckD.ParentFieldEdit), {
        fieldId: fieldId,
        value: value,
        onChange: onChange,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isExistingIssue: isExistingIssue,
        onCloseMenuOnScroll: onCloseMenuOnScroll,
        isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
        selectedProjectId: selectedProject ? selectedProject.value : undefined,
        selectedIssueTypeId: issueTypeId,
        fetchSuggestionsOnFocus: true,
        passedInIssueKey: (0, $7jTnu.fg)('render-modern-issue-transition') || (0, $lopBx.isFedRamp)() ? issueKey : undefined,
        spacing: "default",
        showDoneIssuesCheckboxVisible: true,
        ...fieldId && (0, $7jTnu.fg)('jfp_a11y_issue_create_form_field_with_description') && {
            descriptionId: `${fieldId}-field-helper`
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $034c9b22394cd968$var$fieldDescriptionStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fKXve.HelperMessage), null, formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5jAKT.default).descriptionIssueTermRefresh : (0, $5jAKT.default).description))));
};
const $034c9b22394cd968$var$fieldDescriptionStyles = (0, $1DXK0.xcss)({
    marginTop: 'space.100'
});
var $034c9b22394cd968$export$2e2bcd8739ae039 = (0, $2nXHu.withFormField)({
    transformDefaultValue: (0, $8cifA.transformDefaultParentValue),
    validator: (0, $8cifA.validateParentField)
})(// @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element' is not assignable to parameter of type 'AbstractComponent<ComponentProps<ParentFieldConfig, LegacyValue<Option>>, any>'.
$034c9b22394cd968$export$96c87c0afbe06b37);

});
parcelRegister("6LckD", function(module, exports) {

$parcel$export(module.exports, "ParentFieldEdit", () => $e64160e0ae88f069$export$55c2cccecfd24751);
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck react-select unsupported props

var $eJOHy = parcelRequire("eJOHy");

var $3s8bj = parcelRequire("3s8bj");

var $c4OV1 = parcelRequire("c4OV1");

var $k71qx = parcelRequire("k71qx");

var $7jTnu = parcelRequire("7jTnu");

var $lRq8t = parcelRequire("lRq8t");

var $bmoS1 = parcelRequire("bmoS1");

var $aUMMA = parcelRequire("aUMMA");

var $kEUB1 = parcelRequire("kEUB1");

var $2F5Ok = parcelRequire("2F5Ok");

var $eNxi7 = parcelRequire("eNxi7");

var $cM93q = parcelRequire("cM93q");

var $jvNQh = parcelRequire("jvNQh");

var $fbh6R = parcelRequire("fbh6R");
const $e64160e0ae88f069$var$LOAD_OPTIONS_DEBOUNCE_TIMER = 300;
const $e64160e0ae88f069$export$55c2cccecfd24751 = (props)=>{
    const { onFocus: onFocus, onBlur: onBlur, value: value = null, onChange: onChange, selectedProjectId: selectedProjectId, selectedIssueTypeId: selectedIssueTypeId, isInvalid: isInvalid = false, autoFocus: autoFocus = false, onCloseMenuOnScroll: onCloseMenuOnScroll, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, isDisabled: isDisabled = false, isExistingIssue: isExistingIssue = false, defaultMenuIsOpen: defaultMenuIsOpen = false, isEditing: isEditing, classNamePrefix: classNamePrefix, isClearable: isClearable = true, passedInIssueKey: passedInIssueKey, fieldId: // used for experiences that don't have issueKey in context, eg. bulk edit
    fieldId, spacing: spacingProps = 'compact', 'aria-labelledby': ariaLabelledBy, onSearchParents: onSearchParents, showDoneIssuesCheckboxVisible: showDoneIssuesCheckboxVisible, descriptionId: descriptionId } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(false);
    const [suggestions, setSuggestions] = (0, $eJOHy.useState)();
    const [defaultSuggestions, setDefaultSuggestions] = (0, $eJOHy.useState)();
    const [noOptionsMessage, setNoOptionsMessage] = (0, $eJOHy.useState)('');
    const [hasLastFetchFailed, setHasLastFetchFailed] = (0, $eJOHy.useState)(false);
    const [excludeDone, setExcludeDone] = (0, $eJOHy.useState)(true);
    const isInitialMount = (0, $eJOHy.useRef)(true);
    const lastQuery = (0, $eJOHy.useRef)('');
    const cloudId = (0, $kEUB1.useCloudId)();
    const issueKey = (0, $bmoS1.useIssueKey)();
    const componentProps = (0, $eJOHy.useMemo)(()=>({
            onChange: (event)=>{
                setExcludeDone(!event.target.checked);
            },
            showDoneIssuesCheckboxVisible: showDoneIssuesCheckboxVisible
        }), [
        showDoneIssuesCheckboxVisible
    ]);
    const formatOptionLabel = (0, $eJOHy.useCallback)((option, { context: context })=>{
        if (context === 'menu') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
            content: option.label
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jvNQh.default), {
            option: option
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, option.label || `${option.key} ${option.fields.summary}`);
    }, []);
    const searchParents = (0, $eJOHy.useCallback)(async (query = '')=>{
        setHasLastFetchFailed(false);
        try {
            lastQuery.current = query;
            if (isExistingIssue) {
                const fetchedOptions = await (0, $fbh6R.fetchParentsForExisting)({
                    searchTerm: query,
                    issueKey: passedInIssueKey || issueKey,
                    cloudId: cloudId,
                    excludeDone: excludeDone
                });
                return fetchedOptions;
            }
            if (selectedProjectId && selectedIssueTypeId) {
                const fetchedOptions = await (0, $fbh6R.fetchParentsForNew)({
                    searchTerm: query,
                    selectedProjectId: selectedProjectId,
                    selectedIssueTypeId: selectedIssueTypeId,
                    cloudId: cloudId,
                    excludeDone: excludeDone
                });
                return fetchedOptions;
            }
            setHasLastFetchFailed(true);
            return {
                options: []
            };
        } catch  {
            setHasLastFetchFailed(true);
            return {
                options: []
            };
        }
    }, [
        isExistingIssue,
        issueKey,
        cloudId,
        excludeDone,
        selectedProjectId,
        selectedIssueTypeId,
        passedInIssueKey
    ]);
    const requestSuggestions = (0, $eJOHy.useCallback)(async (query = '')=>{
        let response;
        if (onSearchParents) response = await onSearchParents(query);
        else response = await searchParents(query);
        if (lastQuery.current === query) {
            if (response.options !== undefined) {
                setSuggestions(response.options);
                if (response.options.length === 0 && response.message) setNoOptionsMessage(response.message);
                if (query === '') setDefaultSuggestions(response.options);
            } else {
                setSuggestions([]);
                if (query === '') setDefaultSuggestions([]);
            }
            setIsLoading(false);
        }
    }, [
        searchParents,
        onSearchParents
    ]);
    // go/jfe-eslint
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const debouncedRequestSuggestions = (0, $eJOHy.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(requestSuggestions, $e64160e0ae88f069$var$LOAD_OPTIONS_DEBOUNCE_TIMER), [
        excludeDone
    ]);
    const onQueryChange = (0, $eJOHy.useCallback)((query)=>{
        debouncedRequestSuggestions.cancel();
        setHasLastFetchFailed(false);
        if (query) {
            lastQuery.current = query;
            setIsLoading(true);
            debouncedRequestSuggestions(query);
        } else {
            lastQuery.current = '';
            setIsLoading(false);
            setSuggestions(defaultSuggestions);
        }
    }, [
        debouncedRequestSuggestions,
        defaultSuggestions
    ]);
    const handleFocus = (0, $eJOHy.useCallback)((e)=>{
        if (lastQuery.current === '' && !defaultSuggestions) {
            setIsLoading(true);
            requestSuggestions();
        }
        onFocus && onFocus(e);
    }, [
        defaultSuggestions,
        onFocus,
        requestSuggestions
    ]);
    const getNoOptionsMessage = (0, $eJOHy.useCallback)(()=>{
        const noOptions = noOptionsMessage !== '' ? noOptionsMessage : formatMessage((0, $cM93q.default).noMatches);
        // we now get the translated message from the backend, but will fall back to the old message if it's not there
        return hasLastFetchFailed ? formatMessage((0, $cM93q.default).failedFetch) : noOptions;
    }, [
        formatMessage,
        hasLastFetchFailed,
        noOptionsMessage
    ]);
    const getLoadingMessage = (0, $eJOHy.useCallback)(()=>formatMessage((0, $cM93q.default).loading), [
        formatMessage
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!isInitialMount.current) {
            setIsLoading(true);
            requestSuggestions(lastQuery.current);
        }
        isInitialMount.current = false;
    }, [
        excludeDone,
        requestSuggestions
    ]);
    const spacing = (0, $eJOHy.useMemo)(()=>spacingProps, [
        spacingProps
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c4OV1.default), {
        // need to stop esc keydown propagation to avoid modal close if select is open
        onKeyDown: (0, $2F5Ok.preventEscKeyPropagationKeyPressHandler),
        inputId: `${fieldId}-field`,
        options: suggestions,
        value: value,
        formatOptionLabel: formatOptionLabel,
        onBlur: onBlur,
        onFocus: handleFocus,
        onChange: onChange,
        menuPosition: isDropdownMenuFixedAndLayered ? 'fixed' : undefined,
        styles: (0, $aUMMA.defaultSelectStyles),
        closeMenuOnScroll: onCloseMenuOnScroll,
        isMulti: false,
        isLoading: isLoading,
        onInputChange: onQueryChange,
        loadingMessage: getLoadingMessage,
        noOptionsMessage: getNoOptionsMessage,
        placeholder: formatMessage((0, $cM93q.default).placeholder),
        components: {
            Menu: $eNxi7.default
        },
        componentsProps: componentProps,
        autoFocus: autoFocus,
        validationState: isInvalid === true ? 'error' : undefined,
        hideSelectedOptions: true,
        isClearable: isClearable,
        ...isEditing !== undefined && {
            menuIsOpen: isEditing
        },
        isDisabled: isDisabled,
        defaultMenuIsOpen: defaultMenuIsOpen,
        classNamePrefix: classNamePrefix,
        spacing: spacing,
        "aria-label": formatMessage((0, $cM93q.default).placeholder),
        "aria-labelledby": ariaLabelledBy,
        menuPlacement: "auto",
        ...(0, $7jTnu.fg)('jfp_a11y_issue_create_form_field_with_description') && {
            descriptionId: descriptionId
        }
    });
};

});
parcelRegister("2F5Ok", function(module, exports) {

$parcel$export(module.exports, "getOptionColorElem", () => $7eccea2aa441862f$export$b00899e73680c477);
$parcel$export(module.exports, "mapDataToOptions", () => $7eccea2aa441862f$export$99a866ffa3af7d8b);
$parcel$export(module.exports, "mapOptionToData", () => $7eccea2aa441862f$export$fc800909123977f3);
$parcel$export(module.exports, "preventEscKeyPropagationKeyPressHandler", () => $7eccea2aa441862f$export$feb08457bf70a411);
$parcel$export(module.exports, "getLozengeThemeByColor", () => $7eccea2aa441862f$export$949dc67535a8ff2);
/* utils.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $8URAw = parcelRequire("8URAw");

var $1wTTU = parcelRequire("1wTTU");
const $7eccea2aa441862f$export$bc913b9c9057634d = (color)=>color === undefined || color === '' ? 'transparent' : (0, $8URAw.MAP_COLORS_TO_VALUE)[color];
const $7eccea2aa441862f$export$b00899e73680c477 = (color)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7eccea2aa441862f$var$ColorPatch, {
        color: color,
        "data-testid": `issue-field-parent.common.color-patch-${color}`
    });
const $7eccea2aa441862f$export$99a866ffa3af7d8b = (issueParents)=>{
    return issueParents.map(({ id: id, issueType: issueType, key: key, summary: summary, color: color, isDone: isDone })=>({
            id: id,
            key: key,
            fields: {
                issuetype: issueType,
                summary: summary
            },
            color: color,
            value: id,
            label: `${key} ${summary}`,
            isDone: isDone
        }));
};
const $7eccea2aa441862f$export$fc800909123977f3 = (option)=>({
        id: option.value
    });
const $7eccea2aa441862f$export$9b822862d986dfdf = (0, $1wTTU.transformColorToTheme)((colorSchema)=>({
        color: colorSchema.text,
        backgroundColor: colorSchema.textBackground
    }));
const $7eccea2aa441862f$export$feb08457bf70a411 = (event)=>{
    if (event?.key === 'Escape') event?.nativeEvent?.stopImmediatePropagation();
};
const $7eccea2aa441862f$export$949dc67535a8ff2 = (color)=>$7eccea2aa441862f$export$9b822862d986dfdf[color];
// We adjust the size of the color patch away from normal grid sizes because
// the issue type icon actually has a 1px border on each side, which is 2x1px on width/height
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7eccea2aa441862f$var$ColorPatch = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1nzbko4": (0, $awdRS.default)($7eccea2aa441862f$export$bc913b9c9057634d(__cmplp.color))
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko1y44 _1bsbdlk8 _1ul9dlk8 _4t3idlk8 _bfhk1vzt",
            __cmplp.className
        ])
    });
});

});

parcelRegister("eNxi7", function(module, exports) {

$parcel$export(module.exports, "default", () => $d85c1c7620c6b0b3$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $86tBw = parcelRequire("86tBw");

var $6XEne = parcelRequire("6XEne");

var $7jTnu = parcelRequire("7jTnu");

var $lRq8t = parcelRequire("lRq8t");

var $8oYXQ = parcelRequire("8oYXQ");
const $d85c1c7620c6b0b3$var$Menu = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { children: children, ...restProps } = props;
    // note: "isDefaultChecked" is used for VR tests only, therefore it is defaulted to false in production
    const isDefaultChecked = props.selectProps?.componentsProps?.isDefaultChecked || false;
    // default to true if showDoneIssuesCheckboxVisible is undefined
    const showDoneIssuesCheckboxVisible = props.selectProps?.componentsProps?.showDoneIssuesCheckboxVisible !== undefined && props.selectProps.componentsProps.showDoneIssuesCheckboxVisible;
    const label = formatMessage((0, $7jTnu.fg)('jira-issue-terminology-refresh-m3') ? (0, $8oYXQ.default).checkboxLabelIssueTermRefresh : (0, $8oYXQ.default).checkboxLabel);
    const onKeyDown = (0, $eJOHy.useCallback)((event)=>{
        // stopping propagation when focus moves to checkbox because select already binded with space and enter for selection
        if (event.key === ' ') event.stopPropagation();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6XEne.components).Menu, restProps, showDoneIssuesCheckboxVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d85c1c7620c6b0b3$var$CheckboxWrapper, {
        onClick: props.selectProps?.componentsProps?.onChange
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86tBw.default), {
        defaultChecked: isDefaultChecked,
        onKeyDown: onKeyDown,
        label: label
    })), children);
};
var $d85c1c7620c6b0b3$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $d85c1c7620c6b0b3$var$Menu;
const $d85c1c7620c6b0b3$var$CheckboxWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_zulp1b66 _n7zludwz _1e0c1txw _2lx2vrvc _1bah1y6m _ca0qu2gc _u5f3utpp _n3tdu2gc _19bvutpp _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8oYXQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $33c4809b50f2c613$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $33c4809b50f2c613$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    checkboxLabel: {
        "id": "issue-field-parent.edit.menu.checkbox-label",
        "defaultMessage": "Show done issues"
    },
    checkboxLabelIssueTermRefresh: {
        "id": "issue-field-parent.edit.menu.checkbox-label-issue-term-refresh",
        "defaultMessage": "Show everything marked as done"
    }
});

});


parcelRegister("cM93q", function(module, exports) {

$parcel$export(module.exports, "default", () => $76c77af67aa85c2f$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $76c77af67aa85c2f$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    noMatches: {
        "id": "issue-field-parent.edit.no-matches",
        "defaultMessage": "No matches"
    },
    failedFetch: {
        "id": "issue-field-parent.edit.failed-fetch",
        "defaultMessage": "Search failed. Please try again."
    },
    placeholder: {
        "id": "issue-field-parent.edit.placeholder",
        "defaultMessage": "Select parent"
    },
    loading: {
        "id": "issue-field-parent.edit.loading",
        "defaultMessage": "Searching..."
    }
});

});

parcelRegister("jvNQh", function(module, exports) {

$parcel$export(module.exports, "default", () => $37b12bd3e29bbb28$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $6XkOW = parcelRequire("6XkOW");

var $lRq8t = parcelRequire("lRq8t");

var $2F5Ok = parcelRequire("2F5Ok");

var $cb2WC = parcelRequire("cb2WC");
const $37b12bd3e29bbb28$var$renderOptionDescription = (option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($37b12bd3e29bbb28$var$OptionDescriptionWrapper, null, option.description != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($37b12bd3e29bbb28$var$Description, null, option.description) : null);
const $37b12bd3e29bbb28$var$renderIconsKeyAndDoneLabel = (option, doneParentLabel, iconAltMessage)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($37b12bd3e29bbb28$var$OptionColorTypeKeyWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($37b12bd3e29bbb28$var$IconColorKeyWrapper, null, option?.color ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, (0, $2F5Ok.getOptionColorElem)(option?.color), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($37b12bd3e29bbb28$var$IconWithColor, {
        src: option.fields?.issuetype.iconUrl,
        alt: iconAltMessage
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($37b12bd3e29bbb28$var$Icon, {
        src: option.fields?.issuetype.iconUrl,
        alt: iconAltMessage
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($37b12bd3e29bbb28$var$IssueKey, null, option.key)), option.isDone ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($37b12bd3e29bbb28$var$DoneWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6XkOW))), {
        spacing: "spacious",
        color: "var(--ds-text-success, #216E4E)",
        label: "done-parent-issue"
    }), doneParentLabel) : null);
const $37b12bd3e29bbb28$var$CustomOption = ({ option: option })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)(); // narrowing type to ParentFieldOption
    if ('fields' in option) {
        const fields = option?.fields;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($37b12bd3e29bbb28$var$OptionWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($37b12bd3e29bbb28$var$OptionTextContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($37b12bd3e29bbb28$var$OptionLabel, null, $37b12bd3e29bbb28$var$renderIconsKeyAndDoneLabel(option, formatMessage((0, $cb2WC.default).doneParentLabel), formatMessage((0, $cb2WC.default).icon, {
            issueType: fields?.issuetype.name || ''
        })), option.fields.summary)));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($37b12bd3e29bbb28$var$OptionWrapper, null, option.elemBefore != null ? option.elemBefore : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($37b12bd3e29bbb28$var$OptionTextContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($37b12bd3e29bbb28$var$OptionLabel, null, option.label), $37b12bd3e29bbb28$var$renderOptionDescription(option)));
};
var $37b12bd3e29bbb28$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $37b12bd3e29bbb28$var$CustomOption;
const $37b12bd3e29bbb28$var$IconWithColor = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_18u0u2gc _p12f7vkz",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $37b12bd3e29bbb28$var$Icon = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_p12f7vkz",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $37b12bd3e29bbb28$var$IconColorKeyWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _syaz1gjq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $37b12bd3e29bbb28$var$DoneWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _syaz131l",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $37b12bd3e29bbb28$var$IssueKey = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _1bto1l2s _p12f1osq _18u0u2gc",
            __cmplp.className
        ])
    });
});
const $37b12bd3e29bbb28$var$OptionColorTypeKeyWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c8dcr7 _1e0c1txw _1bah1yb4 _2lx2vrvc _4cvr1h6o _syaz131l _otyr1b66",
            __cmplp.className
        ])
    });
});
const $37b12bd3e29bbb28$var$OptionDescriptionWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c8dcr7 _1e0c1txw _2lx2vrvc _4cvr1h6o _19pk1b66",
            __cmplp.className
        ])
    });
});
const $37b12bd3e29bbb28$var$Description = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _1bto1l2s _p12f1osq",
            __cmplp.className
        ])
    });
});
const $37b12bd3e29bbb28$var$OptionLabel = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _16jlkb7n",
            __cmplp.className
        ])
    });
});
const $37b12bd3e29bbb28$var$OptionTextContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _1e0c1txw _2lx21bp4 _19pkidpf _2hwxu2gc _otyridpf _18u0u2gc _ca0qv77o _u5f3idpf _n3tdv77o _19bvidpf _16jlkb7n",
            __cmplp.className
        ])
    });
});
const $37b12bd3e29bbb28$var$OptionWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cb2WC", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7e625a301fc8a96$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $f7e625a301fc8a96$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    icon: {
        "id": "issue-field-parent.edit.option.icon",
        "defaultMessage": "{issueType} icon"
    },
    doneParentLabel: {
        "id": "issue-field-parent.edit.option.done-parent-label",
        "defaultMessage": "Done"
    }
});

});


parcelRegister("fbh6R", function(module, exports) {

$parcel$export(module.exports, "fetchParentsForNew", () => $e5cc009eaad08672$export$73bed6a0175e413);
$parcel$export(module.exports, "fetchParentsForExisting", () => $e5cc009eaad08672$export$f995718992ca6c2f);

var $gYnSx = parcelRequire("gYnSx");

var $S4iTK = parcelRequire("S4iTK");

var $6ADjF = parcelRequire("6ADjF");

var $2F5Ok = parcelRequire("2F5Ok");
const $e5cc009eaad08672$export$cfeee2ee86ead336 = 'bento';
const $e5cc009eaad08672$export$73bed6a0175e413 = async (props)=>{
    const { searchTerm: searchTerm, selectedProjectId: selectedProjectId, selectedIssueTypeId: selectedIssueTypeId, cloudId: cloudId, excludeDone: excludeDone } = props;
    // This is a gira request
    try {
        const response = await (0, $6ADjF.fetchParentCandidatesForNewIssue)(cloudId, selectedProjectId, selectedIssueTypeId, searchTerm, excludeDone);
        return {
            options: (0, $2F5Ok.mapDataToOptions)(response.candidates),
            message: response.message
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gYnSx.default)({
            meta: {
                id: 'fetchParentsForNew',
                packageName: 'jiraIssueFieldParent',
                teamName: $e5cc009eaad08672$export$cfeee2ee86ead336
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw new Error(error);
    }
};
const $e5cc009eaad08672$export$f995718992ca6c2f = async (props)=>{
    const { searchTerm: searchTerm, issueKey: issueKey, cloudId: cloudId, excludeDone: excludeDone } = props;
    // This is a gira request
    try {
        const response = await (0, $S4iTK.fetchParentCandidatesForExistingIssue)(cloudId, issueKey, searchTerm, excludeDone);
        return {
            options: (0, $2F5Ok.mapDataToOptions)(response.candidates),
            message: response.message
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gYnSx.default)({
            meta: {
                id: 'fetchParentsForExisting',
                packageName: 'jiraIssueFieldParent',
                teamName: $e5cc009eaad08672$export$cfeee2ee86ead336
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};

});
parcelRegister("S4iTK", function(module, exports) {

$parcel$export(module.exports, "fetchParentCandidatesForExistingIssue", () => $0b58621ddcc1857f$export$59a0f41a1d5dcee0);


var $1uIew = parcelRequire("1uIew");

var $6p6D9 = parcelRequire("6p6D9");

var $4yH8v = parcelRequire("4yH8v");

var $b53tw = parcelRequire("b53tw");

var $3btMe = parcelRequire("3btMe");
const $0b58621ddcc1857f$export$59a0f41a1d5dcee0 = async (cloudId, issueKey, searchTerm, excludeDone)=>{
    const response = (0, $4yH8v.default)(cloudId, issueKey, searchTerm, excludeDone);
    const { data: data, errors: errors } = await response;
    if (!data || errors) {
        const message = errors ? JSON.stringify(errors) : 'No data returned from graphql call';
        throw new (0, $b53tw.default)(new Error(message), (0, $6p6D9.PARENT_CANDIDATES_FOR_EXISTING_ISSUES_QUERY_WITH_INFO));
    }
    if (data.jira.parentCandidatesWithInfoForExistingIssue !== undefined && !data.jira?.parentCandidatesWithInfoForExistingIssue) {
        // @ts-expect-error - TS2339 - Property 'length' does not exist on type 'never'.
        if (Array.isArray(errors) && errors.length > 0) {
            const errorMessage = JSON.stringify(errors);
            // if `parentCandidatesForExistingIssue` is missing and any errors were in the response
            // assume that an error caused the data to be missing.
            throw new (0, $b53tw.default)(new (0, $1uIew.default)((0, $44ccf6b895337c89$export$e813cd7045fcc98d), `Call to gira for parent candidates returned with errors: ${errorMessage}`), (0, $6p6D9.PARENT_CANDIDATES_FOR_EXISTING_ISSUES_QUERY_WITH_INFO));
        } else // GraphQL doesn't rely on HTTP status codes to classify errors.
        // But we do have code that knows how to handle 404s (display "Issue not found"
        // screen, etc.), so that's why we're forcing a 404 here.
        throw new (0, $b53tw.default)(new (0, $1uIew.default)((0, $44ccf6b895337c89$export$8bca792d963eb0ef), 'Call to gira for parent candidates returned empty response'), (0, $6p6D9.PARENT_CANDIDATES_FOR_EXISTING_ISSUES_QUERY_WITH_INFO));
    }
    const candidates = data.jira.parentCandidatesWithInfoForExistingIssue !== undefined ? (0, $3btMe.transformData)(data.jira.parentCandidatesWithInfoForExistingIssue.parentCandidates.edges) : [];
    return {
        candidates: candidates,
        message: data.jira.parentCandidatesWithInfoForExistingIssue !== undefined ? data.jira.parentCandidatesWithInfoForExistingIssue.message : undefined
    };
};

});
parcelRegister("6p6D9", function(module, exports) {

$parcel$export(module.exports, "PARENT_CANDIDATES_FOR_EXISTING_ISSUES_QUERY_WITH_INFO", () => $e2827bdf25e435a5$export$c7c7f21787854c5b);
$parcel$export(module.exports, "buildParentCandidatesForExistingIssueQuery", () => $e2827bdf25e435a5$export$b64c34b6ba3d6bf5);

var $5s8Kz = parcelRequire("5s8Kz");
const $e2827bdf25e435a5$export$c7c7f21787854c5b = 'issueParentCandidatesForExistingIssuesQueryWithInfo';
const $e2827bdf25e435a5$export$b64c34b6ba3d6bf5 = ()=>`
    query jira_parenting_${$e2827bdf25e435a5$export$c7c7f21787854c5b}($issueKey: String!, $cloudId: ID!, $searchTerm: String, $excludeDone: Boolean, $first: Int)  {
        ${(0, $5s8Kz.parentCandidatesForExistingIssueQuery)()}
    }
`;

});
parcelRegister("5s8Kz", function(module, exports) {

$parcel$export(module.exports, "parentCandidatesForExistingIssueQuery", () => $c03849bbd2a3356c$export$f63a6e3151b9dd82);
const $c03849bbd2a3356c$var$issueType = ()=>`
    ... on JiraIssueTypeField {
        fieldId
        issueType {
            issueTypeId
            name
            avatar {
                xsmall
            }
        }
    }
`;
const $c03849bbd2a3356c$var$summary = ()=>`
    ... on JiraSingleLineTextField {
        fieldId
        text
    }
`;
const $c03849bbd2a3356c$var$color = ()=>`
    issueColorField {
      color {
        colorKey
      }
    }
`;
const $c03849bbd2a3356c$var$status = ()=>`
    ... on JiraStatusField {
      fieldId
      status {
        statusCategory{
          statusCategoryId
        }
      }
    }
`;
const $c03849bbd2a3356c$var$fieldsById = ()=>`fieldsById(ids:["summary", "issuetype", "status"]){
  edges{
    node{
      ${$c03849bbd2a3356c$var$issueType()}
      ${$c03849bbd2a3356c$var$summary()}
      ${$c03849bbd2a3356c$var$status()}
    }
  }
}`;
const $c03849bbd2a3356c$export$f63a6e3151b9dd82 = ()=>`
    jira {
      parentCandidatesWithInfoForExistingIssue(key: $issueKey, cloudId: $cloudId, searchTerm: $searchTerm, excludeDone: $excludeDone, first: $first) {
        parentCandidates {
          edges {
            node {
              issueId
              key
              ${$c03849bbd2a3356c$var$color()}
              ${$c03849bbd2a3356c$var$fieldsById()}
            }
          }
        }
        message
      }
    }
`;

});


parcelRegister("4yH8v", function(module, exports) {

$parcel$export(module.exports, "default", () => $258eeced7126eafa$export$2e2bcd8739ae039);

var $6p6D9 = parcelRequire("6p6D9");

var $fVpjy = parcelRequire("fVpjy");
const $258eeced7126eafa$export$83bff8b82e36a9e9 = 20;
var /**
 * Returns parent candidates for an existing issue
 *
 * @param cloudId - The cloud ID of the instance
 * @param issueKey - The key of the issue to find parents for e.g SCRUM-1000
 * @param searchTerm - A search string for the parent, on either full key match or partial summary match
 * @param excludeDone - Whether to exclude done issues from the list of parent candidate results
 * @returns A list of possible parent issues for the specified issue
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$258eeced7126eafa$export$2e2bcd8739ae039 = async (cloudId, issueKey, searchTerm, excludeDone)=>{
    const variables = {
        cloudId: cloudId,
        issueKey: issueKey,
        searchTerm: searchTerm,
        excludeDone: excludeDone,
        first: $258eeced7126eafa$export$83bff8b82e36a9e9
    };
    const response = await (0, $fVpjy.getClient)().query({
        query: (0, $6p6D9.buildParentCandidatesForExistingIssueQuery)(),
        variables: variables
    });
    return response;
};

});

parcelRegister("b53tw", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b5a28c22f84e602$export$2e2bcd8739ae039);

var $1uIew = parcelRequire("1uIew");
class $4b5a28c22f84e602$export$2e2bcd8739ae039 extends Error {
    constructor(error, endpoint){
        if (error instanceof $4b5a28c22f84e602$export$2e2bcd8739ae039) return error;
        super(error.message);
        this.error = error;
        this.message = error.message;
        if (error instanceof (0, $1uIew.default)) {
            if (error.traceId != null) this.traceId = error.traceId;
            this.statusCode = error.statusCode;
        }
        this.endpoint = endpoint;
    }
}

});

parcelRegister("3btMe", function(module, exports) {

$parcel$export(module.exports, "transformData", () => $1ec8221944535bc4$export$3ceb62baab058c6b);


var $7keuM = parcelRequire("7keuM");

var $1uIew = parcelRequire("1uIew");

var $8URAw = parcelRequire("8URAw");
const $1ec8221944535bc4$export$3ceb62baab058c6b = (edges)=>edges.map((edge)=>{
        const edgeNode = edge.node;
        const fieldsEdges = edgeNode.fieldsById.edges;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const summaryField = fieldsEdges.find((field)=>field.node.fieldId === 'summary');
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const issueTypeField = fieldsEdges.find((field)=>field.node.fieldId === 'issuetype');
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const statusField = fieldsEdges.find((field)=>field.node.fieldId === 'status');
        const colorField = edgeNode.issueColorField;
        if (summaryField === undefined) throw new (0, $1uIew.ValidationError)('Validation Error', [
            {
                field: 'summary',
                error: 'Call to gira for parent candidates returned without summary data'
            }
        ], (0, $44ccf6b895337c89$export$8bca792d963eb0ef));
        if (issueTypeField === undefined) throw new (0, $1uIew.ValidationError)('Validation Error', [
            {
                field: 'issueType',
                error: 'Call to gira for parent candidates returned without issue type data'
            }
        ], (0, $44ccf6b895337c89$export$8bca792d963eb0ef));
        if (statusField === undefined) throw new (0, $1uIew.ValidationError)('Validation Error', [
            {
                field: 'status',
                error: 'Call to gira for parent candidates returned without status data'
            }
        ], (0, $44ccf6b895337c89$export$8bca792d963eb0ef));
        if (// only issues at level 1 are expected to have a hierarchy level (i.e Epics)
        issueTypeField.node.issueType?.hierarchy?.level === 1 && colorField === undefined) throw new (0, $1uIew.ValidationError)('Validation Error', [
            {
                field: 'Issue Color',
                error: 'Call to gira for parent candidates returned without color data'
            }
        ], (0, $44ccf6b895337c89$export$8bca792d963eb0ef));
        const summaryFieldNode = summaryField.node;
        const issueTypeFieldNode = issueTypeField.node;
        const checkParentIssueIsDone = (statusCategoryId)=>{
            const doneStatusCategoryId = (0, $7keuM).StatusCategoryIds[(0, $7keuM).StatusCategoryTypes.DONE];
            return doneStatusCategoryId && String(doneStatusCategoryId) === statusCategoryId;
        };
        const isDone = checkParentIssueIsDone(statusField.node.status.statusCategory.statusCategoryId);
        const statusCategoryId = statusField?.node.status.statusCategory.statusCategoryId;
        const parent = {
            id: edgeNode.issueId,
            key: edgeNode.key,
            summary: summaryFieldNode.text,
            issueType: {
                id: String(issueTypeFieldNode.issueType.issueTypeId),
                name: issueTypeFieldNode.issueType.name,
                iconUrl: issueTypeFieldNode.issueType.avatar.xsmall
            },
            isDone: isDone,
            statusCategoryId: statusCategoryId
        };
        // todo: write a test for issueColor undefined
        return {
            ...parent,
            color: colorField?.color?.colorKey ? (0, $8URAw.MAP_FROM_SERVER_COLOR)[colorField.color.colorKey] : undefined
        };
    });

});


parcelRegister("6ADjF", function(module, exports) {

$parcel$export(module.exports, "fetchParentCandidatesForNewIssue", () => $0ab99168864bc222$export$48a29a1313179c04);


var $1uIew = parcelRequire("1uIew");

var $dkfBl = parcelRequire("dkfBl");

var $77f6w = parcelRequire("77f6w");

var $b53tw = parcelRequire("b53tw");

var $3btMe = parcelRequire("3btMe");
const $0ab99168864bc222$export$48a29a1313179c04 = async (cloudId, projectId, issueTypeId, searchTerm, excludeDone)=>{
    const response = (0, $77f6w.default)(cloudId, projectId, issueTypeId, searchTerm, excludeDone);
    const { data: data, errors: errors } = await response;
    if (!data || errors) {
        const message = errors ? JSON.stringify(errors) : 'No data returned from graphql call';
        throw new (0, $b53tw.default)(new Error(message), (0, $dkfBl.PARENT_CANDIDATES_FOR_NEW_ISSUES_QUERY_WITH_INFO));
    }
    if (!data.jira?.parentCandidatesWithInfoForNewIssue) {
        // @ts-expect-error - TS2339 - Property 'length' does not exist on type 'never'.
        if (Array.isArray(errors) && errors.length > 0) {
            const errorMessage = JSON.stringify(errors);
            // if `parentCandidatesForExistingIssue` is missing and any errors were in the response
            // assume that an error caused the data to be missing.
            throw new (0, $b53tw.default)(new (0, $1uIew.default)((0, $44ccf6b895337c89$export$e813cd7045fcc98d), `Call to gira for parent candidates returned with errors: ${errorMessage}`), (0, $dkfBl.PARENT_CANDIDATES_FOR_NEW_ISSUES_QUERY_WITH_INFO));
        } else // GraphQL doesn't rely on HTTP status codes to classify errors.
        // But we do have code that knows how to handle 404s (display "Issue not found"
        // screen, etc.), so that's why we're forcing a 404 here.
        throw new (0, $b53tw.default)(new (0, $1uIew.default)((0, $44ccf6b895337c89$export$8bca792d963eb0ef), 'Call to gira for parent candidates returned empty response'), (0, $dkfBl.PARENT_CANDIDATES_FOR_NEW_ISSUES_QUERY_WITH_INFO));
    }
    const candidates = data.jira.parentCandidatesWithInfoForNewIssue !== undefined ? (0, $3btMe.transformData)(data.jira.parentCandidatesWithInfoForNewIssue.parentCandidates.edges) : [];
    return {
        candidates: candidates,
        message: data.jira.parentCandidatesWithInfoForNewIssue !== undefined ? data.jira.parentCandidatesWithInfoForNewIssue.message : undefined
    };
};

});
parcelRegister("dkfBl", function(module, exports) {

$parcel$export(module.exports, "PARENT_CANDIDATES_FOR_NEW_ISSUES_QUERY_WITH_INFO", () => $761cc61094045423$export$26f006aaa0389bc0);
$parcel$export(module.exports, "buildParentCandidatesForNewIssueQuery", () => $761cc61094045423$export$453f3d2e0fac3592);

var $eqH4K = parcelRequire("eqH4K");
const $761cc61094045423$export$26f006aaa0389bc0 = 'issueParentCandidatesForNewIssuesQueryWithInfo';
const $761cc61094045423$export$453f3d2e0fac3592 = ()=>`
    query jira_parenting_${$761cc61094045423$export$26f006aaa0389bc0}($projectId: ID!, $issueTypeId: ID!, $cloudId: ID!, $searchTerm: String, $excludeDone: Boolean, $first: Int)  {
        ${(0, $eqH4K.parentCandidatesForNewIssueQuery)()}
    }
`;

});
parcelRegister("eqH4K", function(module, exports) {

$parcel$export(module.exports, "parentCandidatesForNewIssueQuery", () => $c78f3377a0889ed6$export$1dfd5c8a625d5960);
const $c78f3377a0889ed6$var$issueType = ()=>`
    ... on JiraIssueTypeField {
        fieldId
        issueType {
            issueTypeId
            name
            avatar {
                xsmall
            }
        }
    }
`;
const $c78f3377a0889ed6$var$summary = ()=>`
    ... on JiraSingleLineTextField {
        fieldId
        text
    }
`;
const $c78f3377a0889ed6$var$color = ()=>`
    issueColorField {
      color {
        colorKey
      }
    }
`;
const $c78f3377a0889ed6$var$status = ()=>`
    ... on JiraStatusField {
      fieldId
      status {
        statusCategory{
          statusCategoryId
        }
      }
    }
`;
const $c78f3377a0889ed6$var$fieldsById = ()=>`fieldsById(ids:["summary", "issuetype", "status"]){
  edges{
    node{
      ${$c78f3377a0889ed6$var$issueType()}
      ${$c78f3377a0889ed6$var$summary()}
      ${$c78f3377a0889ed6$var$status()}
    }
  }
}`;
const $c78f3377a0889ed6$export$1dfd5c8a625d5960 = ()=>`
    jira {
        parentCandidatesWithInfoForNewIssue(projectId: $projectId, issueTypeId: $issueTypeId, cloudId: $cloudId, searchTerm: $searchTerm, excludeDone: $excludeDone, first: $first) {
          parentCandidates {
            edges {
              node {
                issueId
                key
                ${$c78f3377a0889ed6$var$color()}
                ${$c78f3377a0889ed6$var$fieldsById()}
              }
            }
          }
          message
        }
      }
`;

});


parcelRegister("77f6w", function(module, exports) {

$parcel$export(module.exports, "default", () => $872fe6b4b6bce661$export$2e2bcd8739ae039);

var $dkfBl = parcelRequire("dkfBl");

var $fVpjy = parcelRequire("fVpjy");
const $872fe6b4b6bce661$export$1fd3b40492f4ef9f = 20;
var /**
 * Returns parent candidates for a new issue (e.g one that is about to be created)
 *
 * @param cloudId - The cloud ID of the instance
 * @param projectId - The ID of the project in which the issue will be created
 * @param issueTypeId - The issue type of the project to be created
 * @param searchTerm - A search string for the parent, on either full key match or partial summary match
 * @param excludeDone - Whether to exclude done issues from the list of parent candidate results
 * @returns A list of possible parent issues for the specified project and issue type
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$872fe6b4b6bce661$export$2e2bcd8739ae039 = async (cloudId, projectId, issueTypeId, searchTerm, excludeDone)=>{
    const variables = {
        cloudId: cloudId,
        projectId: projectId,
        issueTypeId: issueTypeId,
        searchTerm: searchTerm,
        excludeDone: excludeDone,
        first: $872fe6b4b6bce661$export$1fd3b40492f4ef9f
    };
    const response = await (0, $fVpjy.getClient)().query({
        query: (0, $dkfBl.buildParentCandidatesForNewIssueQuery)(),
        variables: variables,
        operationName: `jira_parenting_${(0, $dkfBl.PARENT_CANDIDATES_FOR_NEW_ISSUES_QUERY_WITH_INFO)}`
    });
    return response;
};

});




parcelRegister("5jAKT", function(module, exports) {

$parcel$export(module.exports, "default", () => $d770211456669eae$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $d770211456669eae$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    description: {
        "id": "issue-create-commons.parent-field.description",
        "defaultMessage": "Your issue type hierarchy determines the issues you can select here."
    },
    descriptionIssueTermRefresh: {
        "id": "issue-create-commons.parent-field.description-issue-term-refresh",
        "defaultMessage": "Your work type hierarchy determines the work items you can select here."
    }
});

});

parcelRegister("8cifA", function(module, exports) {

$parcel$export(module.exports, "transformDefaultParentValue", () => $eaee6885fc2d19b3$export$f38bec4d01c88544);
$parcel$export(module.exports, "validateParentField", () => $eaee6885fc2d19b3$export$656803053e0b9113);
$parcel$export(module.exports, "mutateParentField", () => $eaee6885fc2d19b3$export$15ec054c85ac7db1);

var $3UrQk = parcelRequire("3UrQk");

var $8URAw = parcelRequire("8URAw");
const $eaee6885fc2d19b3$export$f38bec4d01c88544 = (defaultValue)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const summaryField = defaultValue.fieldsById.edges.find((field)=>field.node.__typename === 'JiraSingleLineTextField');
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const issueTypeField = defaultValue.fieldsById.edges.find((field)=>field.node.__typename === 'JiraIssueType');
    const { key: key, issueId: issueId, issueColorField: issueColorField } = defaultValue;
    const summary = summaryField?.node.text;
    const label = `${key} ${summary}`;
    return {
        label: label,
        value: issueId,
        key: key,
        color: issueColorField && issueColorField.color !== null ? (0, $8URAw.MAP_FROM_SERVER_COLOR)[issueColorField.color] : undefined,
        fields: {
            summary: summary,
            issuetype: {
                name: issueTypeField?.node.issueType.name,
                iconUrl: issueTypeField?.node.issueType.avatar.xsmall
            }
        }
    };
};
const $eaee6885fc2d19b3$export$656803053e0b9113 = (data, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
isRequired)=>{
    if (isRequired) {
        if (!data) return 0, $3UrQk.REQUIRED;
    }
    return undefined;
};
const $eaee6885fc2d19b3$export$15ec054c85ac7db1 = ({ value: value })=>({
        parentField: {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            issueId: value
        }
    });

});


parcelRegister("1m1S4", function(module, exports) {

$parcel$export(module.exports, "default", () => $033f0058add69412$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $jGzN3 = parcelRequire("jGzN3");

var $6VWiM = parcelRequire("6VWiM");

var $bVgiW = parcelRequire("bVgiW");

const $033f0058add69412$var$PeopleField = (props)=>{
    const { additionalData: { isMulti: isMulti }, autoCompleteUrl: autoCompleteUrl, selectedProject: selectedProject, ...rest } = props;
    const projectKey = selectedProject?.projectKey;
    const fetchSuggestions = (0, $eJOHy.useCallback)(async (query)=>{
        const autoCompleteResponse = await (0, $jGzN3.performGetRequest)(`/rest/api/3/user/recommend?${new URLSearchParams({
            context: 'People',
            ...projectKey && {
                project: projectKey
            },
            query: query ?? ''
        })}`);
        return (autoCompleteResponse ?? []).map((0, $bVgiW.transformToUserOption));
    }, [
        projectKey
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6VWiM.default), {
        ...rest,
        isMulti: isMulti,
        autoCompleteUrl: autoCompleteUrl,
        onFetchSuggestions: fetchSuggestions
    });
};
var $033f0058add69412$export$2e2bcd8739ae039 = $033f0058add69412$var$PeopleField;

});
parcelRegister("bVgiW", function(module, exports) {

$parcel$export(module.exports, "mutatePeopleField", () => $7acbce39aa9076b3$export$62bbb242ba3788ab);
$parcel$export(module.exports, "mapUserOptionOrOptionsToIds", () => $7acbce39aa9076b3$export$2ebc7514b112dd56);
$parcel$export(module.exports, "transformToUserOption", () => $7acbce39aa9076b3$export$5924759166d7a225);

const $7acbce39aa9076b3$export$62bbb242ba3788ab = (selectedValue, fieldId)=>({
        fieldId: fieldId,
        mutationGroup: (0, $5a1791357597fcb3$export$34a73409a6330355),
        users: Array.isArray(selectedValue) ? selectedValue.map((user)=>({
                accountId: user.id
            })) : [
            {
                accountId: selectedValue.id
            }
        ]
    });
const $7acbce39aa9076b3$export$2ebc7514b112dd56 = (userOption)=>{
    if (Array.isArray(userOption)) return userOption.map((option)=>({
            id: option.id
        }));
    return [
        {
            id: userOption.id
        }
    ];
};
const $7acbce39aa9076b3$export$5924759166d7a225 = (userData)=>({
        id: userData.accountId,
        name: userData.displayName || '',
        avatarUrl: userData.avatarUrl || userData.avatarUrls?.['32x32'] || ''
    });

});
const $5a1791357597fcb3$export$34a73409a6330355 = 'peopleFields';



parcelRegister("gkRdD", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4e27e3519e547ac$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $lWVHw = parcelRequire("lWVHw");

var $lxTUS = parcelRequire("lxTUS");

var $fE4zR = parcelRequire("fE4zR");

var $2nXHu = parcelRequire("2nXHu");

var $ixdDB = parcelRequire("ixdDB");

var $4yQUm = parcelRequire("4yQUm");

var $hf2Er = parcelRequire("hf2Er");
const $e4e27e3519e547ac$var$PriorityField = (props)=>{
    const { autoFocus: autoFocus, width: width, fieldProps: { value: value, onChange: onChange, id: id, isRequired: isRequired }, error: error, allowedValues: allowedValues, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, $ixdDB.closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, isReadOnly: isReadOnly = false, ariaLabelledBy: ariaLabelledBy } = props;
    const options = (0, $lxTUS.mapDataToOptions)(allowedValues);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fE4zR.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lWVHw.default), {
        options: options,
        value: value,
        onChange: onChange,
        autoFocus: autoFocus,
        isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
        isInvalid: Boolean(error),
        onCloseMenuOnScroll: onCloseMenuOnScroll,
        isDisabled: isReadOnly,
        inputId: id,
        isRequired: isRequired,
        ariaLabelledBy: ariaLabelledBy
    }));
};
var $e4e27e3519e547ac$export$2e2bcd8739ae039 = (0, $2nXHu.withFormField)({
    validator: (0, $4yQUm.validatePriorityField),
    transformDefaultValue: $hf2Er.transformDefaultValue
})($e4e27e3519e547ac$var$PriorityField);

});
parcelRegister("lWVHw", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e68b03376c1b323$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $c4OV1 = parcelRequire("c4OV1");

var $9QSSI = parcelRequire("9QSSI");

var $aUMMA = parcelRequire("aUMMA");
const $2e68b03376c1b323$var$PriorityEdit = (props)=>{
    const { value: value, options: options, onChange: onChange, onFocus: onFocus, onBlur: onBlur, placeholder: placeholder = '', autoFocus: autoFocus, inputId: inputId, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, isClearable: isClearable = false, isDisabled: isDisabled, isInvalid: isInvalid, isRequired: isRequired, isSearchable: isSearchable, classNamePrefix: classNamePrefix, openMenuOnFocus: openMenuOnFocus, menuIsOpen: menuIsOpen, menuPortalTarget: menuPortalTarget, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, styles: styles, formatOptionLabel: formatOptionLabel = (0, $9QSSI.formatOptionLabel), onCloseMenuOnScroll: onCloseMenuOnScroll } = props;
    const stylesMemoized = (0, $eJOHy.useMemo)(()=>{
        return {
            ...(0, $aUMMA.defaultSelectStyles),
            ...styles
        };
    }, [
        styles
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c4OV1.default), {
        inputId: inputId,
        value: value,
        options: options,
        placeholder: placeholder,
        // @ts-expect-error - TS2322 - Type '(arg1: Option) => void' is not assignable to type '(value: Option | null, action: ActionMeta<Option>) => void'.
        onChange: onChange,
        onFocus: onFocus,
        onBlur: onBlur,
        autoFocus: autoFocus,
        menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
        styles: stylesMemoized,
        // @ts-expect-error - TS2322 - Type '"error" | null' is not assignable to type 'ValidationState | undefined'.
        validationState: isInvalid === true ? 'error' : null,
        formatOptionLabel: formatOptionLabel,
        menuIsOpen: menuIsOpen,
        menuPortalTarget: menuPortalTarget,
        hideSelectedOptions: true,
        closeMenuOnScroll: onCloseMenuOnScroll,
        required: isRequired,
        isClearable: isClearable,
        isDisabled: isDisabled,
        isSearchable: isSearchable,
        classNamePrefix: classNamePrefix,
        openMenuOnFocus: openMenuOnFocus,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy
    });
};
var $2e68b03376c1b323$export$2e2bcd8739ae039 = $2e68b03376c1b323$var$PriorityEdit;

});
parcelRegister("9QSSI", function(module, exports) {

$parcel$export(module.exports, "formatOptionLabel", () => $4f87cabf8ac28d1c$export$322216d90ffb8d0e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $5DgXR = parcelRequire("5DgXR");
const $4f87cabf8ac28d1c$export$b4053b30a2d3983b = (props)=>{
    const { option: { label: label, iconUrl: iconUrl, description: description }, optionContext: optionContext } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4f87cabf8ac28d1c$var$FlexRow, null, Boolean(iconUrl) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4f87cabf8ac28d1c$var$AvatarWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5DgXR.default), {
        appearance: "square",
        size: "xsmall",
        src: iconUrl,
        borderColor: "transparent"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4f87cabf8ac28d1c$var$FlexColumn, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testid": "issue-field-select-base.ui.format-option-label.c-label"
    }, label), optionContext === 'menu' && Boolean(description) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4f87cabf8ac28d1c$var$Description, null, description)));
};
const $4f87cabf8ac28d1c$export$322216d90ffb8d0e = (option, { context: context })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4f87cabf8ac28d1c$export$b4053b30a2d3983b, {
        option: option,
        optionContext: context
    });
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4f87cabf8ac28d1c$var$FlexRow = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $4f87cabf8ac28d1c$var$FlexColumn = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2lx21bp4 _1e0c1txw _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $4f87cabf8ac28d1c$var$AvatarWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2hwxu2gc _1e0c1txw",
            __cmplp.className
        ])
    });
});
const $4f87cabf8ac28d1c$var$Description = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c81o8v _syaz131l",
            __cmplp.className
        ])
    });
});

});


parcelRegister("lxTUS", function(module, exports) {

$parcel$export(module.exports, "mapDataToOptions", () => $ef092d2a7c4a4615$export$99a866ffa3af7d8b);
$parcel$export(module.exports, "mapOptionToData", () => $ef092d2a7c4a4615$export$fc800909123977f3);
const $ef092d2a7c4a4615$export$99a866ffa3af7d8b = (data)=>data.map(({ id: id, name: name, iconUrl: iconUrl })=>({
            label: name,
            value: id,
            iconUrl: iconUrl
        }));
const $ef092d2a7c4a4615$export$fc800909123977f3 = ({ label: label, value: value, iconUrl: iconUrl })=>({
        id: value,
        name: label,
        iconUrl: iconUrl
    });

});

parcelRegister("hf2Er", function(module, exports) {

$parcel$export(module.exports, "transformDefaultValue", () => $772edc0fdbe46b89$export$e2f4e5d31db527cc);
$parcel$export(module.exports, "mutatePriorityField", () => $772edc0fdbe46b89$export$2c46dd13be598543);
const $772edc0fdbe46b89$export$e2f4e5d31db527cc = ({ id: id, name: name, iconUrl: iconUrl })=>({
        label: name,
        value: id,
        iconUrl: iconUrl
    });
const $772edc0fdbe46b89$export$2c46dd13be598543 = ({ value: value })=>({
        priority: {
            priorityId: value
        }
    });

});


parcelRegister("9bfcI", function(module, exports) {

$parcel$export(module.exports, "default", () => $fdba81020c49f87d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $lbouf = parcelRequire("lbouf");

var $fE4zR = parcelRequire("fE4zR");

var $2nXHu = parcelRequire("2nXHu");

var $ixdDB = parcelRequire("ixdDB");

var $iYBjh = parcelRequire("iYBjh");

const $fdba81020c49f87d$var$ProjectCF = (props)=>{
    const { fieldId: fieldId, autoCompleteUrl: autoCompleteUrl = '', fieldProps: { value: value = null, onChange: onChange, id: id }, width: width, autoFocus: autoFocus = false, onCloseMenuOnScroll: // @ts-expect-error - TS2339 - Property 'onCloseMenuOnScroll' does not exist on type 'Props'.
    onCloseMenuOnScroll = (0, $ixdDB.closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, ariaLabelledBy: ariaLabelledBy } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fE4zR.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lbouf.ProjectCustomFieldEdit), {
        value: value,
        onChange: onChange,
        autoFocus: autoFocus,
        autoCompleteUrl: autoCompleteUrl,
        onCloseMenuOnScroll: onCloseMenuOnScroll,
        isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
        fetchSuggestionsOnFocus: true,
        "aria-labelledby": ariaLabelledBy,
        fieldId: id || fieldId
    }));
};
var $fdba81020c49f87d$export$2e2bcd8739ae039 = (0, $2nXHu.withFormField)({
    validator: (0, $iYBjh.validateProjectField),
    transformDefaultValue: (0, $iYBjh.transformDefaultProjectValue)
})($fdba81020c49f87d$var$ProjectCF);

});
parcelRegister("lbouf", function(module, exports) {

$parcel$export(module.exports, "ProjectCustomFieldEdit", () => $89e3e92ba8473ef5$export$8d413eb197febcb2);

var $eJOHy = parcelRequire("eJOHy");

var $gWITR = parcelRequire("gWITR");

var $hqYEY = parcelRequire("hqYEY");

var $lRq8t = parcelRequire("lRq8t");

var $9QSSI = parcelRequire("9QSSI");

var $aUMMA = parcelRequire("aUMMA");

var $jxCGn = parcelRequire("jxCGn");

var $5fIxl = parcelRequire("5fIxl");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $5Z148 = parcelRequire("5Z148");

var $dTtz9 = parcelRequire("dTtz9");
const $89e3e92ba8473ef5$var$LOAD_OPTIONS_DEBOUNCE_TIMER = 300;
const $89e3e92ba8473ef5$var$PROJECT_OPTIONS_LOADED = 'issue-field-project-options-loaded';
const $89e3e92ba8473ef5$var$projectOptionsLoadedMetric = (0, $hqYEY.metrics).custom({
    key: $89e3e92ba8473ef5$var$PROJECT_OPTIONS_LOADED
});
const $89e3e92ba8473ef5$export$8d413eb197febcb2 = (props)=>{
    const { fieldId: fieldId, autoCompleteUrl: autoCompleteUrl, autoFocus: autoFocus, blurInputOnSelect: blurInputOnSelect, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, hideSelectedOptions: hideSelectedOptions, onChange: onChange, onCloseMenuOnScroll: onCloseMenuOnScroll, openMenuOnFocus: openMenuOnFocus, spacing: spacing, fetchSuggestionsOnFocus: fetchSuggestionsOnFocus = false, isInvalid: isInvalid = false, value: value = null, onBlur: onBlur, label: label, 'aria-labelledby': ariaLabelledBy } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [lastFetchFailed, setLastFetchFailed] = (0, $eJOHy.useState)(false);
    const [defaultOptions, setDefaultOptions] = (0, $eJOHy.useState)([]);
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(false);
    const shouldFetchDefaultOptions = (0, $eJOHy.useRef)(true);
    const isInSampleAnalytics = (0, $eJOHy.useRef)((0, $jxCGn.isInSample)());
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const fireOptionsLoadedAnalyticsEvent = (duration)=>{
        const action = 'loaded';
        const actionSubject = 'projectFieldOptions';
        const event = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject
        });
        const attrs = {
            duration: duration
        };
        (0, $gCeeo.fireOperationalAnalytics)(event, `${actionSubject} ${action}`, attrs);
    };
    const searchProjects = async (query = '')=>{
        setLastFetchFailed(false);
        isInSampleAnalytics.current && $89e3e92ba8473ef5$var$projectOptionsLoadedMetric.start();
        return (0, $dTtz9.fetchProjects)(query, autoCompleteUrl).then((projectsData)=>{
            if (isInSampleAnalytics.current) {
                $89e3e92ba8473ef5$var$projectOptionsLoadedMetric.stop();
                const { start: start, stop: stop } = $89e3e92ba8473ef5$var$projectOptionsLoadedMetric.getData();
                const duration = stop && start ? stop - start : null;
                fireOptionsLoadedAnalyticsEvent(duration);
            }
            return projectsData;
        }).catch(()=>{
            isInSampleAnalytics.current && $89e3e92ba8473ef5$var$projectOptionsLoadedMetric.cancel();
            setLastFetchFailed(true);
            return [];
        });
    };
    const onFocus = async ()=>{
        if (shouldFetchDefaultOptions && defaultOptions && shouldFetchDefaultOptions.current && !defaultOptions.length) {
            shouldFetchDefaultOptions.current = false;
            setIsLoading && setIsLoading(true);
            const options = await searchProjects();
            setDefaultOptions && setDefaultOptions(options);
            setIsLoading && setIsLoading(false);
        }
    };
    // go/jfe-eslint
    const loadOptionsDebounced = (0, $5fIxl.default)(searchProjects, $89e3e92ba8473ef5$var$LOAD_OPTIONS_DEBOUNCE_TIMER);
    const getNoOptionsMessage = (0, $eJOHy.useCallback)(()=>formatMessage(lastFetchFailed ? (0, $5Z148.default).failedFetch : (0, $5Z148.default).noMatches), [
        formatMessage,
        lastFetchFailed
    ]);
    const defaultOptionsProps = ()=>{
        if (fetchSuggestionsOnFocus) return {
            onFocus: onFocus,
            isLoading: isLoading,
            defaultOptions: defaultOptions
        };
        return {};
    };
    // NOTE: Only used for drilling down `react-select` props!
    // See: https://react-select.com/props
    const additionalSelectProps = {
        blurInputOnSelect: blurInputOnSelect,
        hideSelectedOptions: hideSelectedOptions,
        openMenuOnFocus: openMenuOnFocus,
        spacing: spacing
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gWITR.default), {
        fieldId: fieldId,
        autoFocus: autoFocus,
        ...defaultOptionsProps(),
        ...additionalSelectProps,
        isClearable: true,
        // @ts-expect-error - TS2322 - Type '((e: ChangeEvent<HTMLElement>) => boolean) | undefined' is not assignable to type 'boolean | EventListener | undefined'.
        closeMenuOnScroll: onCloseMenuOnScroll,
        formatOptionLabel: (0, $9QSSI.formatOptionLabel),
        loadOptions: loadOptionsDebounced,
        menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
        noOptionsMessage: getNoOptionsMessage,
        placeholder: formatMessage((0, $5Z148.default).placeholder),
        styles: (0, $aUMMA.defaultSelectStyles),
        // @ts-expect-error - TS2322 - Type '"error" | null' is not assignable to type 'ValidationState | undefined'.
        validationState: isInvalid === true ? 'error' : null,
        value: value,
        // @ts-expect-error - TS2322 - Type '(value: Option) => void' is not assignable to type '(value: Option | null, action: ActionMeta<Option>) => void'.
        onChange: onChange,
        onBlur: onBlur,
        label: label,
        "aria-labelledby": ariaLabelledBy,
        inputId: fieldId
    });
};

});
parcelRegister("jxCGn", function(module, exports) {

$parcel$export(module.exports, "isInSample", () => $5c228c8a5723854f$export$a994c91d08ead5ff);

const $5c228c8a5723854f$export$a994c91d08ead5ff = (sampleRate = (0, $9ffe3c13ac3aa7ad$export$9fc1f2d681a9e609))=>Math.random() <= 1 / sampleRate;

});
/**
 * Sample rates are defined as the inverse.
 * e.g. a sample rate of 100 = 1 in 100 events are sent.
 */ const $9ffe3c13ac3aa7ad$export$9fc1f2d681a9e609 = 100; // 1%


parcelRegister("5Z148", function(module, exports) {

$parcel$export(module.exports, "default", () => $78959c0324f2919f$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $78959c0324f2919f$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    noMatches: {
        "id": "issue-field-project.edit.async-project-cf.no-matches",
        "defaultMessage": "No matches"
    },
    failedFetch: {
        "id": "issue-field-project.edit.async-project-cf.failed-fetch",
        "defaultMessage": "Search failed. Please try again."
    },
    placeholder: {
        "id": "issue-field-project.edit.async-project-cf.placeholder",
        "defaultMessage": "Select project"
    },
    loading: {
        "id": "issue-field-project.edit.async-project-cf.loading",
        "defaultMessage": "Searching..."
    }
});

});

parcelRegister("dTtz9", function(module, exports) {

$parcel$export(module.exports, "fetchProjects", () => $c6400ddcf2f171cf$export$f0d2ca471cdb99b0);

var $gYnSx = parcelRequire("gYnSx");

var $1uIew = parcelRequire("1uIew");

var $jGzN3 = parcelRequire("jGzN3");

var $jpZmU = parcelRequire("jpZmU");
const $c6400ddcf2f171cf$export$f0d2ca471cdb99b0 = async (inputValue, autoCompleteUrl)=>(0, $jGzN3.performGetRequest)(`${autoCompleteUrl}${inputValue}`).then((response)=>(0, $jpZmU.mapDataToOptions)(response.values)).catch((error)=>{
        (0, $gYnSx.trackFetchErrors)({
            error: error,
            id: 'fetchProjects',
            packageName: 'jiraIssueFieldProject',
            logToSentry: !(0, $1uIew.isValidationError)(error),
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    });

});
parcelRegister("jpZmU", function(module, exports) {

$parcel$export(module.exports, "mapDataToOption", () => $6400e893558a660a$export$5c1e24ea9ccb80aa);
$parcel$export(module.exports, "mapDataToOptions", () => $6400e893558a660a$export$99a866ffa3af7d8b);
$parcel$export(module.exports, "mapOptionToData", () => $6400e893558a660a$export$fc800909123977f3);
const $6400e893558a660a$export$5c1e24ea9ccb80aa = (data)=>({
        label: data.name,
        value: data.key,
        iconUrl: data.avatarUrls['48x48'],
        projectId: data.id
    });
const $6400e893558a660a$export$99a866ffa3af7d8b = (data)=>data.map($6400e893558a660a$export$5c1e24ea9ccb80aa);
const $6400e893558a660a$export$fc800909123977f3 = ({ label: label, value: value, iconUrl: iconUrl })=>({
        key: value,
        name: label,
        avatarUrls: {
            '48x48': iconUrl
        }
    });

});



parcelRegister("iYBjh", function(module, exports) {

$parcel$export(module.exports, "mutateProjectField", () => $448e3f9e774a4109$export$fb6480503bf79949);
$parcel$export(module.exports, "validateProjectField", () => $448e3f9e774a4109$export$5c1e30a9f731caaf);
$parcel$export(module.exports, "transformDefaultProjectValue", () => $448e3f9e774a4109$export$c77f86922e480ac0);

var $3UrQk = parcelRequire("3UrQk");
const $448e3f9e774a4109$export$fb6480503bf79949 = (selectedProject, fieldId)=>({
        projectFields: [
            {
                fieldId: fieldId,
                project: {
                    projectId: selectedProject.projectId || ''
                }
            }
        ]
    });
const $448e3f9e774a4109$export$5c1e30a9f731caaf = (data, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
isRequired)=>{
    if (isRequired) {
        if (!data) return 0, $3UrQk.REQUIRED;
    }
    return undefined;
};
const $448e3f9e774a4109$export$c77f86922e480ac0 = (data)=>({
        label: data.name,
        value: data.key,
        iconUrl: data.avatar.large,
        projectId: data.id
    });

});


parcelRegister("lpUJE", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c7a4b95b47ce83c$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $akW84 = parcelRequire("akW84");

var $kYBcr = parcelRequire("kYBcr");

var $fE4zR = parcelRequire("fE4zR");

var $2nXHu = parcelRequire("2nXHu");

var $4yQUm = parcelRequire("4yQUm");

var $ie17Q = parcelRequire("ie17Q");
const $5c7a4b95b47ce83c$export$a314277471067e8a = (props)=>{
    const { width: width, fieldProps: { value: value, onChange: onChange, isDisabled: isDisabled = false, ...fieldProps }, error: error, allowedValues: allowedValues, isReadOnly: isReadOnly = false } = props;
    const options = (0, $kYBcr.mapDataToOptions)(allowedValues);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fE4zR.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $akW84.default), {
        ...fieldProps,
        options: options,
        isDisabled: isReadOnly || isDisabled,
        value: value,
        onChange: onChange,
        isInvalid: Boolean(error)
    }));
};
var $5c7a4b95b47ce83c$export$2e2bcd8739ae039 = (0, $2nXHu.withFormField)({
    validator: (0, $4yQUm.validateRadioGroupField),
    transformDefaultValue: $ie17Q.transformDefaultValue
})($5c7a4b95b47ce83c$export$a314277471067e8a);

});
parcelRegister("akW84", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe661bbde48c5ebe$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $a6tuu = parcelRequire("a6tuu");
const $fe661bbde48c5ebe$var$RadioGroupEdit = (props)=>{
    const { value: value, options: options, onChange: onChange, isInvalid: isInvalid, isDisabled: isDisabled = false, ...fieldProps } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $a6tuu.default), {
        ...fieldProps,
        // radio group component handles undefined and null differently, pay attention when change value property
        value: value === null ? value : value?.value,
        options: options,
        isDisabled: isDisabled,
        onChange: (e)=>onChange(options.find((option)=>option.value === e?.target?.value) || null),
        isInvalid: isInvalid
    });
};
var $fe661bbde48c5ebe$export$2e2bcd8739ae039 = $fe661bbde48c5ebe$var$RadioGroupEdit;

});
parcelRegister("a6tuu", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $de7bef9bf1f92e14$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $3Vuhz = parcelRequire("3Vuhz");

var $gl2vi = parcelRequire("gl2vi");

var $gPG64 = parcelRequire("gPG64");
const $de7bef9bf1f92e14$var$noOptions = [];
function $de7bef9bf1f92e14$export$2e2bcd8739ae039(props) {
    const { onChange: onChange, options: options = $de7bef9bf1f92e14$var$noOptions, value: propValue, defaultValue: defaultValue, id: id, isDisabled: isDisabled, isRequired: isRequired, isInvalid: isInvalid, onInvalid: onInvalid = (0, $3Vuhz.default), name: name, analyticsContext: analyticsContext, ['aria-labelledby']: ariaLabelledBy, testId: testId } = props;
    const uid = (0, $gl2vi.useId)();
    const [selectedValue, setSelectedValue] = (0, $eJOHy.useState)(propValue !== undefined ? propValue : defaultValue);
    const onRadioChange = (0, $eJOHy.useCallback)((e, analyticsEvent)=>{
        setSelectedValue(e.currentTarget.value);
        if (onChange) onChange(e, analyticsEvent);
    }, [
        onChange
    ]);
    // If propValue is provided than act as a controlled component
    // If not then act as an uncontrolled component using the value from state
    const value = typeof propValue !== 'undefined' ? propValue : selectedValue;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        role: "radiogroup",
        "aria-labelledby": ariaLabelledBy,
        "data-testid": testId,
        "aria-describedby": isInvalid ? `${id || uid}-error` : undefined,
        id: id || uid,
        children: options.map(({ ...optionProps }, index)=>{
            if (typeof isDisabled !== 'undefined') optionProps.isDisabled = isDisabled;
            const isChecked = value !== null && optionProps.value === value;
            return /*#__PURE__*/ (0, $eJOHy.createElement)((0, $gPG64.default), {
                ...optionProps,
                name: name || optionProps.name,
                key: index,
                onChange: onRadioChange,
                onInvalid: onInvalid,
                isInvalid: isChecked && isInvalid,
                isChecked: isChecked,
                testId: optionProps.testId || testId,
                isRequired: isRequired,
                analyticsContext: analyticsContext
            });
        })
    });
}

});
parcelRegister("gPG64", function(module, exports) {

$parcel$export(module.exports, "default", () => $e69f9767f170f926$export$2e2bcd8739ae039);
/* radio.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $jrFnt = parcelRequire("jrFnt");

var $3Vuhz = parcelRequire("3Vuhz");

var $eGOwo = parcelRequire("eGOwo");
const $e69f9767f170f926$var$packageName = "platform-pkg";
const $e69f9767f170f926$var$packageVersion = "0.0.0-use.local";
const $e69f9767f170f926$var$noop = (0, $3Vuhz.default);
const $e69f9767f170f926$var$labelPaddingStyles = null;
const $e69f9767f170f926$var$labelStyles = null;
const $e69f9767f170f926$var$radioStyles = null;
const $e69f9767f170f926$var$newRadioStyles = null;
const $e69f9767f170f926$var$InnerRadio = /*#__PURE__*/ (0, $eJOHy.forwardRef)(function Radio(props, ref) {
    const { ariaLabel: ariaLabel, isDisabled: isDisabled = false, isRequired: isRequired, isInvalid: isInvalid = false, isChecked: isChecked = false, label: label, name: name, onChange: onChange = $e69f9767f170f926$var$noop, value: value, testId: testId, analyticsContext: analyticsContext, // events and all other input props
    ...rest } = props;
    const onChangeAnalytics = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'radio',
        packageName: $e69f9767f170f926$var$packageName,
        packageVersion: $e69f9767f170f926$var$packageVersion
    });
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("label", {
        "data-testid": testId && `${testId}--radio-label`,
        "data-disabled": isDisabled ? 'true' : undefined,
        className: (0, $hcewu.default)([
            "_11c82smr _1e0c1txw _vchhusvi _kqswh2mm _4cvr1y6m _syazj3m3 _mqf81tvo _g7st13gf"
        ]),
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("input", {
                ...rest,
                tabIndex: 0,
                "aria-label": ariaLabel,
                checked: isChecked,
                disabled: isDisabled,
                name: name,
                onChange: onChangeAnalytics,
                required: isRequired,
                type: "radio",
                value: value,
                "data-testid": testId && `${testId}--radio-input`,
                // use :invalid selector
                "data-invalid": isInvalid ? 'true' : undefined,
                ref: ref,
                className: (0, $hcewu.default)([
                    "_18s8ze3t _19it3vzd _2rko1q5u _12ji1r31 _1qu2glyw _12y31o36 _v56415j1 _1e0c1txw _1bsb1tcg _4t3i1tcg _kqswh2mm _4cvr1h6o _1bah1h6o _1o9zidpf _bfhk4t47 _13diglyw _1q6qmag2 _11511fmg _1s6w1qbb _tqbwidpf _t9ec1s1q _s7n4jp4b _wstuglyw _16r2ucr4 _14mj1q5u _qc5orqeg _z0ai1cbz _1qdg1cbz _18postnw _aetrb3bt _1peq1xmd _iosizyvw _11jyzyvw _f3ett94y _19ybk8x7 _1d7pk8x7 _j5dh13gf _scgf13gf _1gcs13gf _1x1a13gf _6hp813gf _4rya1y1w _o1bd1y1w _nxi61y1w _neoe1y1w _1el21y1w _lekrzcs9 _11v7zcs9 _1f8czcs9 _s2ftzcs9 _17a1zcs9 _x48a15t7 _1ib215t7 _1yk915t7 _gdmb15t7 _pmm415t7 _y2mvehbj _1bg4jfq9 _6tjkehbj _awqnjfq9 _1rvq10ko _1p9j1fmg _x2tzhh5a _1iwzhh5a _sj8y1wq0 _jckox2ru _1dvd1fmg _60ak1dzn",
                    (0, $eGOwo.fg)('platform-visual-refresh-icons') && "_t9ec1soj _z0ai120g _1qdg120g"
                ])
            }),
            label ? /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                className: (0, $hcewu.default)([
                    "_85i5v77o _1q51v77o _y4ti1b66 _bozg1b66"
                ]),
                children: label
            }) : null
        ]
    });
}); /**
     * __Radio__
     *
     * A radio input allows users to select only one option from a number of choices. Radio is generally displayed in a radio group.
     *
     * - [Examples](https://atlassian.design/components/radio/examples)
     * - [Code](https://atlassian.design/components/radio/code)
     * - [Usage](https://atlassian.design/components/radio/usage)
     */ 
const $e69f9767f170f926$var$Radio = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)(function Radio(props, ref) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)($e69f9767f170f926$var$InnerRadio, {
        ...props,
        ref: ref
    });
}));
var $e69f9767f170f926$export$2e2bcd8739ae039 = $e69f9767f170f926$var$Radio;

});



parcelRegister("kYBcr", function(module, exports) {

$parcel$export(module.exports, "mapDataToOptions", () => $a87001acf34008b0$export$99a866ffa3af7d8b);
$parcel$export(module.exports, "mapOptionToData", () => $a87001acf34008b0$export$fc800909123977f3);
const $a87001acf34008b0$export$99a866ffa3af7d8b = (data)=>data?.map(({ id: id, value: value })=>({
            label: value,
            value: id,
            testId: id
        }));
const $a87001acf34008b0$export$fc800909123977f3 = (option)=>({
        id: option?.value,
        value: option?.label
    });

});

parcelRegister("ie17Q", function(module, exports) {

$parcel$export(module.exports, "transformDefaultValue", () => $9ceec5c2d2569a17$export$e2f4e5d31db527cc);
const $9ceec5c2d2569a17$export$e2f4e5d31db527cc = ({ id: id, value: value })=>({
        label: value,
        value: id,
        testId: id
    });

});


parcelRegister("4CDpZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $39690fa34421b2e7$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $ln6Iy = parcelRequire("ln6Iy");

var $8ugqW = parcelRequire("8ugqW");

var $d706p = parcelRequire("d706p");

var $fE4zR = parcelRequire("fE4zR");

var $2nXHu = parcelRequire("2nXHu");

var $4yQUm = parcelRequire("4yQUm");
const $39690fa34421b2e7$var$ReporterField = (props)=>{
    const { width: width, fieldProps: { value: value, onChange: onChange, ...fieldProps }, autoFocus: autoFocus = false, isRequired: isRequired, isReadOnly: isReadOnly = false, selectedProject: selectedProject } = props;
    const { projectType: projectType, projectKey: projectKey } = selectedProject || {};
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fE4zR.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8ugqW.default), {
        ...fieldProps,
        value: value,
        onChange: onChange,
        appearance: "normal",
        isDisabled: isReadOnly,
        autoCompleteUrl: `/rest/api/3/user/recommend?${new URLSearchParams({
            context: 'Reporter',
            ...projectKey && {
                project: projectKey
            },
            query: ''
        })}`,
        isMulti: false,
        autoFocus: autoFocus,
        isClearable: !isRequired,
        allowEmail: projectType === (0, $ln6Iy.SERVICE_DESK_PROJECT),
        width: width,
        inputId: fieldProps.id,
        openMenuOnClick: true
    }));
};
var $39690fa34421b2e7$export$2e2bcd8739ae039 = (0, $2nXHu.withFormField)({
    validator: (0, $4yQUm.validateUserPickerField),
    transformDefaultValue: (0, $d706p.transformJiraUserToUserOption)
})($39690fa34421b2e7$var$ReporterField);

});
parcelRegister("8ugqW", function(module, exports) {

$parcel$export(module.exports, "default", () => $7715a58d5f6a39e7$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $hKwJp = parcelRequire("hKwJp");

var $iOe3s = parcelRequire("iOe3s");

var $814y1 = parcelRequire("814y1");

var $3MbOI = parcelRequire("3MbOI");

var $7IpfL = parcelRequire("7IpfL");
const $7715a58d5f6a39e7$var$ReporterEdit = (props)=>{
    const { allowEmail: allowEmail = false, appearance: appearance, width: width, onChange: onChange, onSelection: onSelection, value: value = null, autoFocus: autoFocus = false, placeholder: placeholder = '', isDisabled: isDisabled = false, autoCompleteUrl: autoCompleteUrl, onCancel: onCancel, isClearable: isClearable = true, fetchSuggestions: fetchSuggestionsProps, shouldSetDefaultValue: shouldSetDefaultValueProp = true, openMenuOnClick: openMenuOnClick = false, ...fieldProps } = props;
    const { data: { user: user } } = (0, $3MbOI.useCurrentUser)();
    const shouldSetDefaultValue = (0, $eJOHy.useRef)(!value && shouldSetDefaultValueProp);
    // to store default value in form field wrapper if value is not set
    (0, $eJOHy.useEffect)(()=>{
        if (shouldSetDefaultValue.current && user && !value) {
            shouldSetDefaultValue.current = false;
            onChange((0, $iOe3s.mapUserObjectToUserOption)(user, true));
        }
    }, [
        onChange,
        user,
        value
    ]);
    const fetchSuggestionsCallback = (0, $eJOHy.useCallback)(async (query)=>(0, $7IpfL.fetchSuggestions)(autoCompleteUrl, query), [
        autoCompleteUrl
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hKwJp.default), {
        ...fieldProps,
        appearance: appearance,
        width: width,
        fieldId: (0, $814y1.REPORTER_TYPE),
        autoCompleteUrl: autoCompleteUrl,
        // @ts-expect-error TS2322: Type (arg1: UserOption) => void is not assignable to type (arg1: UserOption | UserOption[]) => void
        onChange: onChange,
        value: value,
        autoFocus: autoFocus,
        placeholder: placeholder,
        isDisabled: isDisabled,
        fetchSuggestions: fetchSuggestionsProps || fetchSuggestionsCallback,
        onSelection: onSelection,
        onCancel: onCancel,
        isClearable: isClearable,
        allowEmail: allowEmail,
        shouldShowEmailInOptions: true,
        openMenuOnClick: openMenuOnClick,
        "aria-labelledby": fieldProps['aria-labelledby']
    });
};
var $7715a58d5f6a39e7$export$2e2bcd8739ae039 = $7715a58d5f6a39e7$var$ReporterEdit;

});
parcelRegister("7IpfL", function(module, exports) {

$parcel$export(module.exports, "fetchSuggestions", () => $ad3d967b4c731b7a$export$ebf2f44fe450da2b);

var $iOe3s = parcelRequire("iOe3s");

var $jGzN3 = parcelRequire("jGzN3");
const $ad3d967b4c731b7a$export$ebf2f44fe450da2b = async (autoCompleteUrl, query)=>{
    let users = [];
    const url = `${autoCompleteUrl}${query || ''}`;
    const suggestionsResponse = await (0, $jGzN3.performGetRequest)(url) || [];
    if (Array.isArray(suggestionsResponse)) // user/search returns array
    users = suggestionsResponse.map((userFromApi)=>(0, $iOe3s.mapUserObjectToUserOption)(userFromApi, true));
    else if (suggestionsResponse.users) // user/picker returns object
    // @ts-expect-error - TS7006 - Parameter 'userFromApi' implicitly has an 'any' type.
    users = suggestionsResponse.users.map((userFromApi)=>(0, $iOe3s.mapUserObjectToUserOption)(userFromApi, true));
    return users;
};

});



parcelRegister("jM4kG", function(module, exports) {

$parcel$export(module.exports, "default", () => $3cb71f6df01b2190$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $kx7kM = parcelRequire("kx7kM");

var $ch9En = parcelRequire("ch9En");

var $lGaCn = parcelRequire("lGaCn");

var $fE4zR = parcelRequire("fE4zR");

var $2nXHu = parcelRequire("2nXHu");

var $ixdDB = parcelRequire("ixdDB");

var $4yQUm = parcelRequire("4yQUm");

var $7aP7Z = parcelRequire("7aP7Z");

const $3cb71f6df01b2190$var$ResolutionField = (props)=>{
    const { allowedValues: allowedValues, fieldId: fieldId, width: width, error: error, fieldProps: { value: value, onChange: onChange, ...fieldProps }, autoFocus: autoFocus = false, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, $ixdDB.closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fE4zR.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "inline-resolution-edit",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lGaCn.FieldLoader), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kx7kM.AsyncInlineResolutionEdit), {
        ...fieldProps,
        options: (0, $7aP7Z.mapAllowedValuesToSelectOptions)(allowedValues),
        value: value,
        // @ts-expect-error - TS2322 - Type '(value: ResolutionOption) => void' is not assignable to type '(option: ResolutionOption) => Promise<undefined> | undefined'.
        onChange: onChange,
        isInvalid: Boolean(error),
        autoFocus: autoFocus,
        classNamePrefix: `resolution-field-${fieldId}`,
        onCloseMenuOnScroll: onCloseMenuOnScroll,
        isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered
    })));
};
var $3cb71f6df01b2190$export$2e2bcd8739ae039 = (0, $2nXHu.withFormField)({
    transformDefaultValue: (0, $7aP7Z.transformDefaultResolutionValue),
    validator: (0, $4yQUm.validateResolutionField)
})($3cb71f6df01b2190$var$ResolutionField);

});
parcelRegister("kx7kM", function(module, exports) {

$parcel$export(module.exports, "AsyncInlineResolutionEdit", () => $2959a8b81e823278$export$af39bdbe1dcb0a1e);

var $bQWwW = parcelRequire("bQWwW");

const $2959a8b81e823278$export$af39bdbe1dcb0a1e = (0, $bQWwW.lazy)(()=>(parcelRequire("2EpYZ")).then((module)=>module.InlineResolutionEdit), {
    moduleId: "./src/packages/issue/fields/resolution/src/index.tsx"
});

});
parcelRegister("2EpYZ", function(module, exports) {

let $1ee378ccd84e41c1$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $1ee378ccd84e41c1$var$load("4l4CX").then(()=>parcelRequire('5WBO8'));

});


parcelRegister("7aP7Z", function(module, exports) {

$parcel$export(module.exports, "mapAllowedValuesToSelectOptions", () => $14cd1e6e631e4f0b$export$103f56c5c26f12e5);
$parcel$export(module.exports, "transformDefaultResolutionValue", () => $14cd1e6e631e4f0b$export$dbeca145fe19aaf1);
$parcel$export(module.exports, "mutateResolutionField", () => $14cd1e6e631e4f0b$export$a08b1e842f0a7a26);
const $14cd1e6e631e4f0b$export$103f56c5c26f12e5 = (allowedValues)=>allowedValues.map((value)=>({
            value: value.id,
            label: value.name
        }));
const $14cd1e6e631e4f0b$export$dbeca145fe19aaf1 = (value)=>({
        value: value.id,
        label: value.name
    });
const $14cd1e6e631e4f0b$export$a08b1e842f0a7a26 = (selectedResolution)=>({
        resolution: {
            resolutionId: selectedResolution.value
        }
    });

});


parcelRegister("a2hP6", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8fef42f2618164c$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $jGzN3 = parcelRequire("jGzN3");

var $4yBOW = parcelRequire("4yBOW");

var $fE4zR = parcelRequire("fE4zR");

var $2nXHu = parcelRequire("2nXHu");

var $4yQUm = parcelRequire("4yQUm");

var $6aO03 = parcelRequire("6aO03");
const $a8fef42f2618164c$var$RespondersField = (props)=>{
    const { width: width, fieldProps: { value: value, onChange: onChange, ...fieldProps }, autoFocus: autoFocus = false, fieldId: fieldId, autoCompleteUrl: autoCompleteUrl = '', placeholder: placeholder = '', isDisabled: isDisabled = false } = props;
    const onFetchSuggestions = async (query)=>{
        let responders = [];
        if (autoCompleteUrl !== undefined) {
            let autoCompleteResponse;
            try {
                autoCompleteResponse = await (0, $jGzN3.performGetRequest)(`${autoCompleteUrl}/?query=${query || ''}`);
            } catch (err) {
                return [];
            }
            if (autoCompleteResponse.responders) responders = autoCompleteResponse.responders;
        }
        return (0, $6aO03.transformDefaultUserValues)(responders);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fE4zR.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4yBOW.default), {
        ...fieldProps,
        autoCompleteUrl: autoCompleteUrl,
        placeholder: placeholder,
        isDisabled: isDisabled,
        onChange: onChange,
        value: value,
        appearance: "normal",
        isMulti: true,
        autoFocus: autoFocus,
        fieldId: fieldId,
        fetchSuggestions: onFetchSuggestions,
        isClearable: true
    }));
};
var $a8fef42f2618164c$export$2e2bcd8739ae039 = (0, $2nXHu.withFormField)({
    validator: (0, $4yQUm.validateUserPickerField),
    transformDefaultValue: (0, $6aO03.transformDefaultUserValues)
})($a8fef42f2618164c$var$RespondersField);

});
parcelRegister("6aO03", function(module, exports) {

$parcel$export(module.exports, "transformDefaultUserValues", () => $7265a2100d9e9a02$export$26760e7b66ccf1e1);
$parcel$export(module.exports, "mapUserOptionsToAris", () => $7265a2100d9e9a02$export$80dc4fd89a4c227d);
const $7265a2100d9e9a02$var$transformResponderTypeToUserOption = (userData)=>({
        id: userData?.ari || '',
        name: userData?.name || '',
        avatarUrl: userData?.avatarUrl || ''
    });
const $7265a2100d9e9a02$var$validateDefaultValue = (responder)=>{
    if (responder === null || responder === undefined) return false;
    if (!responder.ari || !responder.name) return false;
    return true;
};
const $7265a2100d9e9a02$export$26760e7b66ccf1e1 = (defaultValue)=>{
    if (defaultValue === null || defaultValue === undefined) return [];
    return defaultValue.filter($7265a2100d9e9a02$var$validateDefaultValue).map($7265a2100d9e9a02$var$transformResponderTypeToUserOption);
};
const $7265a2100d9e9a02$var$mapUserOptionToAri = (userData)=>({
        ari: userData.id
    });
const $7265a2100d9e9a02$export$80dc4fd89a4c227d = (userData)=>userData.map($7265a2100d9e9a02$var$mapUserOptionToAri);

});


parcelRegister("7zPNF", function(module, exports) {

$parcel$export(module.exports, "default", () => $389afdba0664fdb2$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $ezTte = parcelRequire("ezTte");

var $1CAom = parcelRequire("1CAom");

var $2nXHu = parcelRequire("2nXHu");

var $ixdDB = parcelRequire("ixdDB");

var $4yQUm = parcelRequire("4yQUm");

var $aDcwy = parcelRequire("aDcwy");

const $389afdba0664fdb2$var$SingleGroupPickerField = (props)=>{
    const { width: width, fieldProps: { value: value, onChange: onChange }, fieldId: fieldId, error: error, autoCompleteUrl: autoCompleteUrl, autoFocus: autoFocus = false, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, ariaLabelledBy: ariaLabelledBy } = props;
    const getExtraProps = ()=>{
        if (isDropdownMenuFixedAndLayered) return {
            menuPosition: 'fixed',
            groupPickerStyles: (0, $ezTte.defaultUserPickerStyles),
            onCloseMenuOnScroll: (0, $ixdDB.closeMenuOnScroll)
        };
        return {
            onCloseMenuOnScroll: (0, $ixdDB.closeMenuOnScroll)
        };
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1CAom.default), {
        autoCompleteUrl: autoCompleteUrl,
        onChange: onChange,
        value: value,
        fieldId: fieldId,
        autoFocus: autoFocus,
        isMulti: false,
        "aria-labelledby": ariaLabelledBy,
        width: width,
        isInvalid: Boolean(error),
        placeholder: " ",
        ...getExtraProps()
    });
};
var $389afdba0664fdb2$export$2e2bcd8739ae039 = (0, $2nXHu.withFormField)({
    validator: (0, $4yQUm.validateGroupPickerField),
    transformDefaultValue: (0, $aDcwy.transformGroupDefaultValueToUserOption)
})($389afdba0664fdb2$var$SingleGroupPickerField);

});
parcelRegister("aDcwy", function(module, exports) {

$parcel$export(module.exports, "transformGroupDefaultValueToUserOption", () => $7e47f165c8318de2$export$d9591be6713fcfc8);
$parcel$export(module.exports, "mutateSingleGroupPickerField", () => $7e47f165c8318de2$export$daeca2ffaa5d8b62);

var $cCjAH = parcelRequire("cCjAH");

const $7e47f165c8318de2$export$d9591be6713fcfc8 = (group)=>{
    if (!group) return null;
    return (0, $cCjAH.transformGroupToUserOption)(group);
};
const $7e47f165c8318de2$export$daeca2ffaa5d8b62 = (selectedGroup, fieldId)=>({
        fieldId: fieldId,
        group: {
            groupName: selectedGroup.name
        },
        mutationGroup: (0, $1f119677dfdc552d$export$31fd86f8f183952c)
    });

});
const $1f119677dfdc552d$export$31fd86f8f183952c = 'singleGroupPickerFields';



parcelRegister("etqwZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d65f7660e5790c73$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $hllPB = parcelRequire("hllPB");

const $d65f7660e5790c73$var$SingleSelectField = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hllPB.default), {
        ...props,
        isMulti: false,
        closeMenuOnSelect: true
    });
var $d65f7660e5790c73$export$2e2bcd8739ae039 = $d65f7660e5790c73$var$SingleSelectField;

});

parcelRegister("86yhe", function(module, exports) {

$parcel$export(module.exports, "mutateSingleSelectField", () => $ea40223873ddaffd$export$35684f6945108587);
$parcel$export(module.exports, "mapSelectOptionsToConnectData", () => $ea40223873ddaffd$export$ed4050ca50f08036);

const $ea40223873ddaffd$export$35684f6945108587 = ({ value: value }, fieldId)=>({
        fieldId: fieldId,
        mutationGroup: (0, $2ee1663fe448319e$export$31fd86f8f183952c),
        option: {
            optionId: value
        }
    });
const $ea40223873ddaffd$export$ed4050ca50f08036 = (option)=>option.value;

});
const $2ee1663fe448319e$export$31fd86f8f183952c = 'singleSelectFields';


parcelRegister("8Cejx", function(module, exports) {

$parcel$export(module.exports, "default", () => $207e498519ac51e2$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $6VWiM = parcelRequire("6VWiM");
const $207e498519ac51e2$var$SingleUserPickerField = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6VWiM.default), {
        ...props,
        isMulti: false,
        context: "CustomUserField"
    });
var $207e498519ac51e2$export$2e2bcd8739ae039 = $207e498519ac51e2$var$SingleUserPickerField;

});

parcelRegister("7I9yO", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e67c0b15256b294$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $k71qx = parcelRequire("k71qx");

var $lRq8t = parcelRequire("lRq8t");

var $lA1W4 = parcelRequire("lA1W4");

var $dOI9z = parcelRequire("dOI9z");

var $coifs = parcelRequire("coifs");

var $fE4zR = parcelRequire("fE4zR");

var $2nXHu = parcelRequire("2nXHu");

var $ixdDB = parcelRequire("ixdDB");

var $4yQUm = parcelRequire("4yQUm");

var $01zai = parcelRequire("01zai");

var $5ujfv = parcelRequire("5ujfv");

const $0e67c0b15256b294$var$SingleVersionField = (props)=>{
    const { width: width, fieldProps: { value: value, onChange: onChange }, fieldId: fieldId, fieldName: fieldName, description: description, allowedValues: allowedValues, error: error, autoFocus: autoFocus = false, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, $ixdDB.closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, isMini: isMini, ariaLabelledBy: ariaLabelledBy } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const onChangeVersionsEdit = (versionEditValue)=>{
        if (!Array.isArray(versionEditValue)) onChange(versionEditValue);
    };
    const options = (0, $5ujfv.transformVersionExternalOptionstoVersionOptions)(allowedValues);
    const isDisabled = allowedValues.length === 0;
    const getVersionsEdit = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lA1W4.default), {
            options: options,
            value: value,
            onChange: onChangeVersionsEdit,
            isInvalid: Boolean(error),
            fieldId: fieldId,
            isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
            isMulti: false,
            isDisabled: isDisabled,
            placeholder: isDisabled ? formatMessage((0, $01zai.default).none) : '',
            autoFocus: autoFocus,
            onCloseMenuOnScroll: onCloseMenuOnScroll,
            ariaLabelledBy: ariaLabelledBy
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fE4zR.FieldContainer), {
        width: width
    }, isDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: formatMessage((0, $01zai.default).tooltip)
    }, getVersionsEdit()) : getVersionsEdit(), !isDisabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $coifs.FieldMessage), {
        description: description,
        error: error,
        fieldName: fieldName,
        isMini: isMini
    }));
};
var $0e67c0b15256b294$export$2e2bcd8739ae039 = (0, $2nXHu.withFormField)({
    validator: (0, $4yQUm.validateSingleVersionField),
    transformDefaultValue: (0, $dOI9z.transformVersionExternalToVersion),
    shouldRenderFieldMessage: false
})($0e67c0b15256b294$var$SingleVersionField);

});
parcelRegister("01zai", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8848bba66e67b1b$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $c8848bba66e67b1b$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    none: {
        "id": "issue-create-commons.single-version-field.none",
        "defaultMessage": "None"
    },
    tooltip: {
        "id": "issue-create-commons.single-version-field.tooltip",
        "defaultMessage": "We couldn't find any versions for this project"
    }
});

});

parcelRegister("5ujfv", function(module, exports) {

$parcel$export(module.exports, "transformVersionExternalOptionstoVersionOptions", () => $485c02722b4c8535$export$11cad9e2f2e9ae55);
$parcel$export(module.exports, "mutateSingleVersionField", () => $485c02722b4c8535$export$57ed62196c76c8b6);

var $dOI9z = parcelRequire("dOI9z");

const $485c02722b4c8535$export$11cad9e2f2e9ae55 = (options)=>options.map((option)=>(0, $dOI9z.transformVersionExternalToVersion)(option));
const $485c02722b4c8535$export$57ed62196c76c8b6 = ({ value: value }, fieldId)=>({
        fieldId: fieldId,
        mutationGroup: (0, $98873fbaf146204f$export$31fd86f8f183952c),
        version: {
            versionId: value
        }
    });

});
const $98873fbaf146204f$export$31fd86f8f183952c = 'singleVersionPickerFields';



parcelRegister("kTnLR", function(module, exports) {

$parcel$export(module.exports, "SprintField", () => $61b80baad052c8f2$export$617303ef516d5a01);
$parcel$export(module.exports, "default", () => $61b80baad052c8f2$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $iHPvF = parcelRequire("iHPvF");

var $k71qx = parcelRequire("k71qx");

var $epTsa = parcelRequire("epTsa");

var $lRq8t = parcelRequire("lRq8t");

var $2wDen = parcelRequire("2wDen");

var $3V5Jq = parcelRequire("3V5Jq");

var $7jTnu = parcelRequire("7jTnu");

var $coifs = parcelRequire("coifs");

var $fE4zR = parcelRequire("fE4zR");

var $2nXHu = parcelRequire("2nXHu");

var $ixdDB = parcelRequire("ixdDB");

var $9zSH1 = parcelRequire("9zSH1");

var $aixH0 = parcelRequire("aixH0");

const $61b80baad052c8f2$export$617303ef516d5a01 = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { width: width, autoCompleteUrl: autoCompleteUrl = '/rest/greenhopper/1.0/sprint/picker?query=', fieldProps: { value: value, onChange: onChange, id: id, isRequired: isRequired }, selectedProject: selectedProject, error: error, fieldId: fieldId, autoFocus: autoFocus = false, description: description, fieldName: fieldName, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, $ixdDB.closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, isEditable: isEditable = true, nonEditableReason: nonEditableReason, isMini: isMini } = props;
    const renderSprintEdit = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2wDen.default), {
            fieldId: fieldId,
            autoCompleteUrl: autoCompleteUrl,
            onChange: onChange,
            value: value,
            isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
            fetchSuggestionsOnMount: false,
            autoFocus: autoFocus,
            isInvalid: Boolean(error),
            onCloseMenuOnScroll: onCloseMenuOnScroll,
            isDisabled: isEditable === false,
            getSuggestions: (0, $aixH0.getSprintSuggestions),
            ...(0, $7jTnu.fg)('jfp_a11y_fix_issue_create_sprint_label') && {
                noLabel: true
            },
            ...selectedProject?.projectKey ? {
                projectKey: selectedProject?.projectKey
            } : {},
            inputId: id,
            isRequired: isRequired,
            ...fieldId && (0, $7jTnu.fg)('jfp_a11y_issue_create_form_field_with_description') && {
                descriptionId: `${fieldId}-field-helper`
            }
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fE4zR.FieldContainer), {
        width: width
    }, isEditable === false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: nonEditableReason?.message || ''
    }, renderSprintEdit()) : renderSprintEdit(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $coifs.FieldMessage), {
        description: description,
        error: error,
        fieldName: fieldName,
        isMini: isMini
    }), value && value.state === (0, $3V5Jq.ACTIVE_SPRINT_STATE) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $61b80baad052c8f2$var$messageContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iHPvF.default), {
        appearance: "warning",
        testId: "issue-create-commons.ui.sprint-field.required-fields-message"
    }, formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $9zSH1.default).activeSprintSelectionWarningMessageIssueTermRefresh : (0, $9zSH1.default).activeSprintSelectionWarningMessage))) : null);
};
var $61b80baad052c8f2$export$2e2bcd8739ae039 = (0, $2nXHu.withFormField)({
    transformDefaultValue: (0, $aixH0.transformDefaultSprintValue),
    shouldRenderFieldMessage: false
})($61b80baad052c8f2$export$617303ef516d5a01);
const $61b80baad052c8f2$var$messageContainerStyles = (0, $1DXK0.xcss)({
    marginTop: 'space.050'
});

});
parcelRegister("2wDen", function(module, exports) {

$parcel$export(module.exports, "default", () => $f63aa82f7eee1080$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $3s8bj = parcelRequire("3s8bj");

var $7jTnu = parcelRequire("7jTnu");

var $lRq8t = parcelRequire("lRq8t");

var $1VLiF = parcelRequire("1VLiF");

var $f1FvV = parcelRequire("f1FvV");

var $9QSSI = parcelRequire("9QSSI");

var $aUMMA = parcelRequire("aUMMA");

var $5HAIV = parcelRequire("5HAIV");

var $814y1 = parcelRequire("814y1");

var $15azN = parcelRequire("15azN");

var $kZuUp = parcelRequire("kZuUp");

var $3dENi = parcelRequire("3dENi");

var $gxTNf = parcelRequire("gxTNf");

var $hfXBy = parcelRequire("hfXBy");
const $f63aa82f7eee1080$export$251bdbdbce9550ea = 300;
const $f63aa82f7eee1080$var$SprintEdit = (props)=>{
    const { autoCompleteUrl: autoCompleteUrl, projectKey: projectKey, autoFocus: autoFocus, onChange: onChange, onFocus: onFocus, onBlur: onBlur, spacing: spacing, value: value, options: options, noOptionsMessage: noOptionsMessage, loadingMessage: loadingMessage, onCloseMenuOnScroll: onCloseMenuOnScroll, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, useTransformSuggestions: useTransformSuggestions, onPostTransformSuggestions: onPostTransformSuggestions, getSuggestions: getSuggestions, fetchSuggestionsOnMount: fetchSuggestionsOnMount = true, fieldId: fieldId = (0, $814y1.SPRINT_TYPE), isInvalid: isInvalid = false, isDisabled: isDisabled = false, inputId: inputId, isRequired: isRequired, openMenuOnFocus: openMenuOnFocus, 'aria-labelledby': ariaLabelledBy, descriptionId: descriptionId, noLabel: noLabel = false } = props;
    const [suggestions, setSuggestions] = (0, $eJOHy.useState)();
    const [defaultSuggestions, setDefaultSuggestions] = (0, $eJOHy.useState)();
    const [hasLastFetchFailed, setHasLastFetchFailed] = (0, $eJOHy.useState)(false);
    const lastQuery = (0, $eJOHy.useRef)('');
    const [restrictSprints, setRestrictSprint] = (0, $eJOHy.useState)((0, $3dENi.getCheckboxValueFromLocalStorage)((0, $3dENi.EDIT_SPRINT_CHECKBOX_CACHE_KEY)));
    const isInitialMount = (0, $eJOHy.useRef)(true);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [{ isLoadingSuggestions: isLoadingSuggestions }, { getSprintSuggestions: getSprintSuggestions, setIsLoadingSuggestions: setIsLoadingSuggestions }] = (0, $kZuUp.useSprintSuggestions)({
        getSuggestions: getSuggestions
    });
    const onCheckboxClick = (0, $eJOHy.useCallback)(()=>{
        setRestrictSprint(!restrictSprints);
        (0, $3dENi.setCheckBoxValueInLocalStorage)((0, $3dENi.EDIT_SPRINT_CHECKBOX_CACHE_KEY), !restrictSprints);
    }, [
        restrictSprints
    ]);
    const componentProps = (0, $eJOHy.useMemo)(()=>({
            isChecked: restrictSprints,
            onChange: onCheckboxClick,
            projectKey: projectKey
        }), [
        restrictSprints,
        projectKey,
        onCheckboxClick
    ]);
    const handleSuggestions = (0, $eJOHy.useCallback)((results, query)=>{
        if (lastQuery.current === query) {
            const transformSuggestions = useTransformSuggestions || (0, $15azN.transformSuggestions);
            const response = transformSuggestions(results, formatMessage);
            if (onPostTransformSuggestions) onPostTransformSuggestions(response, query);
            setSuggestions(response);
            if (query === '') setDefaultSuggestions(response);
        }
    }, [
        formatMessage,
        useTransformSuggestions,
        onPostTransformSuggestions
    ]);
    const getFailedFetchMessage = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1VLiF.FailedFetchOptionWrapper), null, formatMessage((0, $hfXBy.default).failedFetch)), [
        formatMessage
    ]);
    const fetchSuggestions = (0, $eJOHy.useCallback)(async (query = '')=>{
        try {
            let response;
            if (restrictSprints && projectKey) response = await getSprintSuggestions(autoCompleteUrl, query, projectKey);
            else response = await getSprintSuggestions(autoCompleteUrl, query);
            handleSuggestions(response, query);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setHasLastFetchFailed(true);
            const failedOption = [
                {
                    label: getFailedFetchMessage(),
                    value: '',
                    isDisabled: true
                }
            ];
            setSuggestions(failedOption);
        }
    }, [
        autoCompleteUrl,
        restrictSprints,
        projectKey,
        getFailedFetchMessage,
        getSprintSuggestions,
        handleSuggestions
    ]);
    if ((0, $7jTnu.fg)('_jira-concurrent-state-update-hasnt-mounted-yet')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eJOHy.useEffect)(()=>{
        if (fetchSuggestionsOnMount) {
            if (!options && !defaultSuggestions) {
                setIsLoadingSuggestions(true);
                fetchSuggestions();
            } else if (options && !defaultSuggestions) {
                setDefaultSuggestions(options);
                setSuggestions(options);
            } else {
                lastQuery.current = '';
                setIsLoadingSuggestions(true);
                fetchSuggestions();
            }
        }
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    else // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eJOHy.useMemo)(()=>{
        if (fetchSuggestionsOnMount) {
            if (!options && !defaultSuggestions) {
                setIsLoadingSuggestions(true);
                fetchSuggestions();
            } else if (options && !defaultSuggestions) {
                setDefaultSuggestions(options);
                setSuggestions(options);
            } else {
                lastQuery.current = '';
                setIsLoadingSuggestions(true);
                fetchSuggestions();
            }
        }
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // go/jfe-eslint
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const debouncedFetchSuggestions = (0, $eJOHy.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(fetchSuggestions, $f63aa82f7eee1080$export$251bdbdbce9550ea), [
        restrictSprints
    ]);
    const getNoOptionsMessage = (0, $eJOHy.useCallback)(()=>noOptionsMessage !== undefined ? noOptionsMessage : formatMessage((0, $hfXBy.default).empty), [
        formatMessage,
        noOptionsMessage
    ]);
    const getLoadingMessage = (0, $eJOHy.useCallback)(()=>loadingMessage !== undefined ? loadingMessage : formatMessage((0, $hfXBy.default).loading), [
        formatMessage,
        loadingMessage
    ]);
    const filterOption = (0, $eJOHy.useCallback)((option, query)=>{
        if (hasLastFetchFailed) // If the fetch has failed, we will show a disabled option to indicate the error to users
        return true;
        return (0, $f1FvV.filterOptionByLabelAndFilterValues)(option, query || '');
    }, [
        hasLastFetchFailed
    ]);
    const onQueryChange = (0, $eJOHy.useCallback)((query)=>{
        debouncedFetchSuggestions.cancel();
        setHasLastFetchFailed(false);
        if (query) {
            lastQuery.current = query;
            setIsLoadingSuggestions(true);
            debouncedFetchSuggestions(query);
        } else {
            lastQuery.current = '';
            setIsLoadingSuggestions(false);
            setSuggestions(defaultSuggestions);
        }
    }, [
        debouncedFetchSuggestions,
        defaultSuggestions,
        setIsLoadingSuggestions,
        setSuggestions
    ]);
    const onSelectFocus = (0, $eJOHy.useCallback)((e)=>{
        if (!suggestions) {
            setIsLoadingSuggestions(true);
            fetchSuggestions('');
        }
        onFocus && onFocus(e);
    }, [
        fetchSuggestions,
        onFocus,
        setIsLoadingSuggestions,
        suggestions
    ]);
    const onSelectBlur = (0, $eJOHy.useCallback)((e)=>{
        onBlur && onBlur(e);
    }, [
        onBlur
    ]);
    const onValueChange = (0, $eJOHy.useCallback)((newValues)=>{
        // We're passing in suggestions for validation
        // e.g., if selected sprint is active and will affect the issue
        onChange && onChange(newValues, suggestions);
    }, [
        onChange,
        suggestions
    ]);
    const menuPosition = isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined;
    // Fetch the suggestions again if user toggles the checkbox
    (0, $eJOHy.useEffect)(()=>{
        if (!isInitialMount.current) {
            setIsLoadingSuggestions(true);
            debouncedFetchSuggestions(lastQuery.current);
        }
        isInitialMount.current = false;
    }, [
        restrictSprints,
        debouncedFetchSuggestions,
        setIsLoadingSuggestions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5HAIV.default), {
        inputId: inputId,
        isRequired: isRequired,
        isClearable: true,
        hideSelectedOptions: true,
        autoFocus: autoFocus,
        fieldId: fieldId,
        options: suggestions,
        value: value,
        onBlur: onSelectBlur,
        menuPosition: menuPosition,
        componentsProps: projectKey ? componentProps : undefined,
        components: projectKey ? {
            Menu: $gxTNf.default
        } : undefined,
        styles: (0, $aUMMA.defaultSelectStyles),
        onFocus: onSelectFocus,
        noOptionsMessage: getNoOptionsMessage,
        closeMenuOnScroll: onCloseMenuOnScroll,
        loadingMessage: getLoadingMessage,
        placeholder: formatMessage((0, $hfXBy.default).placeholder),
        onInputChange: onQueryChange,
        onChange: onValueChange,
        spacing: spacing,
        isLoading: isLoadingSuggestions,
        filterOption: filterOption,
        formatOptionLabel: (0, $9QSSI.formatOptionLabel),
        validationState: isInvalid === true ? 'error' : null,
        isDisabled: isDisabled,
        openMenuOnFocus: openMenuOnFocus,
        "aria-labelledby": ariaLabelledBy,
        noLabel: noLabel,
        ...(0, $7jTnu.fg)('jfp_a11y_issue_create_form_field_with_description') && {
            descriptionId: descriptionId
        }
    });
};
var $f63aa82f7eee1080$export$2e2bcd8739ae039 = $f63aa82f7eee1080$var$SprintEdit;

});
parcelRegister("5HAIV", function(module, exports) {

$parcel$export(module.exports, "default", () => $24ea98274f792336$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $jPROM = parcelRequire("jPROM");

var $aXKmr = parcelRequire("aXKmr");

var $kVcjU = parcelRequire("kVcjU");

var $gPCSe = parcelRequire("gPCSe");

var $lRq8t = parcelRequire("lRq8t");

var $bGaT8 = parcelRequire("bGaT8");

var $hjf2q = parcelRequire("hjf2q");
var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $5fw7F = parcelRequire("5fw7F");

var $6GTI5 = parcelRequire("6GTI5");
const $24ea98274f792336$var$ANALYTICS_PAYLOAD_TRUNCATION_SIZE = 20;
const $24ea98274f792336$var$analyticsProps = {
    onChange: 'valueChanged',
    onInputChange: 'inputChanged',
    onMenuOpen: 'menuOpened',
    onMenuClose: 'menuClosed'
};
const $24ea98274f792336$export$53574ab050410077 = (0, $hjf2q.AnalyticsEventToProps)('select', $24ea98274f792336$var$analyticsProps)((0, $kVcjU.default));
const $24ea98274f792336$var$CreatableSelectWithAnalyticsView = (props)=>{
    const { fieldId: fieldId, isLoading: isLoading, onChange: onChange, onInputChange: onInputChange, options: options = [], value: value, sessionId: customSessionId, canCreateNewItem: canCreateNewItem = false, inputId: inputId, isRequired: isRequired, ariaLabel: ariaLabel = '', noLabel: noLabel = false } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const hasSessionStarted = (0, $eJOHy.useRef)(false);
    const sessionId = (0, $eJOHy.useRef)(customSessionId);
    const sessionStartedAt = (0, $eJOHy.useRef)(0);
    const endSessionRef = (0, $eJOHy.useRef)(undefined);
    const [queryAtSetValue, setQueryAtSetValue] = (0, $eJOHy.useState)('');
    const [savedQuery, setSavedQuery] = (0, $eJOHy.useState)('');
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const flatOptions = (0, $eJOHy.useMemo)(()=>(0, $6GTI5.flattenOptions)(options), [
        options
    ]);
    const getAnalyticsAttributes = (0, $eJOHy.useCallback)((query)=>{
        const selectedOptions = !(0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(value) ? value : [];
        let filteredOptions = (0, $6GTI5.filterOptions)(flatOptions, query);
        const optionsLength = filteredOptions.length;
        // truncate to reduce payload size
        filteredOptions = filteredOptions.slice(0, $24ea98274f792336$var$ANALYTICS_PAYLOAD_TRUNCATION_SIZE);
        const safeFilteredOptions = (0, $6GTI5.getSafeOptionsForAnalytics)(filteredOptions);
        return {
            inputId: inputId,
            required: isRequired,
            fieldId: fieldId,
            isLoading: isLoading,
            optionsLength: optionsLength,
            componentName: 'select',
            // TODO: update the lib's version after the bump
            packageName: '@atlaskit/select',
            optionValuesSafeForAnalytics: false,
            options: safeFilteredOptions,
            optionsLengths: (0, $6GTI5.getOptionValuesLengths)(filteredOptions),
            queryLength: query.length,
            queryHash: query === '' ? query : (0, $bGaT8.memoizedHashString)(query),
            selectedOptions: (0, $6GTI5.getSafeOptionsForAnalytics)(selectedOptions),
            selectedOptionsLengths: (0, $6GTI5.getOptionValuesLengths)(selectedOptions),
            sessionId: sessionId.current,
            truncationSize: $24ea98274f792336$var$ANALYTICS_PAYLOAD_TRUNCATION_SIZE
        };
    }, [
        value,
        flatOptions,
        inputId,
        isRequired,
        fieldId,
        isLoading
    ]);
    const getItemOrder = (0, $eJOHy.useCallback)((selectedItem)=>{
        const matchedIndexes = [];
        flatOptions.forEach((option, index)=>{
            if (option.value === selectedItem.value) matchedIndexes.push(index);
        });
        return matchedIndexes.length > 0 ? matchedIndexes[0] : -1;
    }, [
        flatOptions
    ]);
    const fireUIAnalyticsEvent = (0, $eJOHy.useCallback)((analyticsEvent, query, extraAttributes)=>{
        const attributes = {
            ...getAnalyticsAttributes(query),
            ...extraAttributes
        };
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, attributes);
    }, [
        getAnalyticsAttributes
    ]);
    const fireTrackAnalyticsEvent = (0, $eJOHy.useCallback)((analyticsEvent, action, actionSubject, extraAttributes)=>{
        const attributes = {
            ...getAnalyticsAttributes(savedQuery),
            ...extraAttributes
        };
        (0, $gCeeo.fireTrackAnalytics)(analyticsEvent, `${actionSubject} ${action}`, attributes);
    }, [
        getAnalyticsAttributes,
        savedQuery
    ]);
    const startSession = (0, $eJOHy.useCallback)(()=>{
        if (sessionId.current === undefined) sessionId.current = (0, $aXKmr.v4)();
        sessionStartedAt.current = (0, $gPCSe.default).now();
        fireTrackAnalyticsEvent(createAnalyticsEvent({
            action: 'started'
        }), 'started', 'optionSelectionSession');
    }, [
        createAnalyticsEvent,
        fireTrackAnalyticsEvent,
        sessionId,
        sessionStartedAt
    ]);
    const endSession = (0, $eJOHy.useCallback)(()=>{
        if (sessionId.current !== undefined) {
            const currentStartedAt = sessionStartedAt.current;
            const elapsedTime = currentStartedAt === 0 ? (0, $gPCSe.default).now() - currentStartedAt : 0;
            fireTrackAnalyticsEvent(createAnalyticsEvent({
                action: 'ended'
            }), 'ended', 'optionSelectionSession', {
                elapsedTime: elapsedTime
            });
        }
        sessionId.current = undefined;
        sessionStartedAt.current = 0;
    }, [
        createAnalyticsEvent,
        fireTrackAnalyticsEvent,
        sessionId,
        sessionStartedAt
    ]);
    const restartSession = (0, $eJOHy.useCallback)(()=>{
        endSession();
        startSession();
    }, [
        endSession,
        startSession
    ]);
    const fireInputChangedEvent = (0, $eJOHy.useCallback)((query, actionMeta, analyticsEvent)=>{
        if (actionMeta.action === 'set-value') // Save query for option changed analytic
        setQueryAtSetValue(savedQuery);
        setSavedQuery(query);
        analyticsEvent.update({
            action: 'changed',
            actionSubject: 'filter'
        });
        fireUIAnalyticsEvent(analyticsEvent, query);
    }, [
        fireUIAnalyticsEvent,
        savedQuery,
        setSavedQuery,
        setQueryAtSetValue
    ]);
    const fireOptionCreatedEvent = (0, $eJOHy.useCallback)((option, analyticsEvent)=>{
        analyticsEvent.update({
            action: 'created',
            actionSubject: 'option'
        });
        const oldSessionId = sessionId.current;
        restartSession();
        fireUIAnalyticsEvent(analyticsEvent, queryAtSetValue, {
            selectedOption: (0, $6GTI5.getSafeValue)(option.value),
            sessionId: oldSessionId
        });
    }, [
        fireUIAnalyticsEvent,
        queryAtSetValue,
        restartSession,
        sessionId
    ]);
    const fireOptionRemovedEvent = (0, $eJOHy.useCallback)((option, analyticsEvent)=>{
        analyticsEvent.update({
            action: 'removed',
            actionSubject: 'option'
        });
        fireUIAnalyticsEvent(analyticsEvent, savedQuery, {
            removedItem: option ? (0, $6GTI5.getSafeValue)(option.value) : undefined
        });
    }, [
        fireUIAnalyticsEvent,
        savedQuery
    ]);
    const fireOptionSelectedEvent = (0, $eJOHy.useCallback)((option, analyticsEvent)=>{
        analyticsEvent.update({
            action: 'changed',
            actionSubject: 'option'
        });
        const oldSessionId = sessionId.current;
        restartSession();
        fireUIAnalyticsEvent(analyticsEvent, queryAtSetValue, {
            selectedOption: (0, $6GTI5.getSafeValue)(option.value),
            selectedOptionLength: option.value !== null ? `${option.value}`.length : 0,
            selectedOrder: getItemOrder(option),
            sessionId: oldSessionId
        });
    }, [
        fireUIAnalyticsEvent,
        getItemOrder,
        queryAtSetValue,
        restartSession,
        sessionId
    ]);
    const onChangeWithAnalytics = (0, $eJOHy.useCallback)((selectedOptionOrOptions, actionMeta, analyticsEvent)=>{
        const selectedOption = Array.isArray(selectedOptionOrOptions) ? selectedOptionOrOptions[selectedOptionOrOptions.length - 1] : selectedOptionOrOptions;
        switch(actionMeta.action){
            case 'create-option':
                if (selectedOption !== null) fireOptionCreatedEvent(selectedOption, analyticsEvent);
                break;
            case 'remove-value':
            case 'pop-value':
            case 'deselect-option':
                fireOptionRemovedEvent(actionMeta.removedValue || actionMeta.option, analyticsEvent);
                break;
            case 'select-option':
                if (selectedOption !== null) fireOptionSelectedEvent(selectedOption, analyticsEvent);
                break;
            default:
                break;
        }
        onChange && onChange(selectedOptionOrOptions, actionMeta);
    }, [
        fireOptionCreatedEvent,
        fireOptionRemovedEvent,
        fireOptionSelectedEvent,
        onChange
    ]);
    const onInputChangeWithAnalytics = (0, $eJOHy.useCallback)((query, actionMeta, analyticsEvent)=>{
        if (actionMeta.action === 'input-change' || actionMeta.action === 'set-value') fireInputChangedEvent(query, actionMeta, analyticsEvent);
        onInputChange && onInputChange(query, sessionId.current);
    }, [
        fireInputChangedEvent,
        onInputChange,
        sessionId
    ]);
    const isValidNewOption = (0, $eJOHy.useCallback)(()=>!!canCreateNewItem, [
        canCreateNewItem
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!hasSessionStarted.current) {
            startSession();
            fireInputChangedEvent('', {
                action: 'fake-action'
            }, createAnalyticsEvent({}));
            hasSessionStarted.current = true;
        }
    }, [
        createAnalyticsEvent,
        fireInputChangedEvent,
        startSession
    ]);
    (0, $eJOHy.useEffect)(()=>{
        endSessionRef.current = endSession;
    }, [
        endSession
    ]);
    (0, $eJOHy.useEffect)(()=>()=>{
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            endSessionRef.current && endSessionRef.current();
        }, // In order to avoid triggering this cleanup when the endSession callback is updated by adding a dependency to endSession here,
    // we call it via a ref instead
    []);
    const { isRequired: required, ...propsWithoutRequired } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($24ea98274f792336$export$53574ab050410077, {
        ...propsWithoutRequired,
        required: isRequired,
        onChange: onChangeWithAnalytics,
        onInputChange: onInputChangeWithAnalytics,
        isValidNewOption: isValidNewOption,
        ...!noLabel && {
            label: ariaLabel || formatMessage((0, $5fw7F.default).ariaLabelForSelect)
        }
    });
};
var $24ea98274f792336$export$2e2bcd8739ae039 = $24ea98274f792336$var$CreatableSelectWithAnalyticsView;

});
parcelRegister("5fw7F", function(module, exports) {

$parcel$export(module.exports, "default", () => $041f7aa16734b8b5$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $041f7aa16734b8b5$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    ariaLabelForSelect: {
        "id": "issue-field-select-with-analytics.ariaLabel",
        "defaultMessage": "Select Field"
    }
});

});

parcelRegister("6GTI5", function(module, exports) {

$parcel$export(module.exports, "getSafeValue", () => $fe87a86e20a4dd3d$export$d05672fd1312a6d);
$parcel$export(module.exports, "getSafeOptionsForAnalytics", () => $fe87a86e20a4dd3d$export$fde3d804891b8254);
$parcel$export(module.exports, "flattenOptions", () => $fe87a86e20a4dd3d$export$7baa7c13b358b002);
$parcel$export(module.exports, "getOptionValuesLengths", () => $fe87a86e20a4dd3d$export$e2e167245697ed4e);
$parcel$export(module.exports, "filterOptions", () => $fe87a86e20a4dd3d$export$60d56ed3961c839c);

var $5FdZg = parcelRequire("5FdZg");

var $bGaT8 = parcelRequire("bGaT8");
const $fe87a86e20a4dd3d$export$d05672fd1312a6d = (val)=>(0, $bGaT8.memoizedHashString)(val.toString()).toString();
const $fe87a86e20a4dd3d$export$fde3d804891b8254 = (items)=>{
    const itemsToFilter = Array.isArray(items) ? items : [
        items
    ];
    return itemsToFilter.filter((item)=>item.value).map(({ value: value })=>$fe87a86e20a4dd3d$export$d05672fd1312a6d(value));
};
const $fe87a86e20a4dd3d$export$7baa7c13b358b002 = (optionGroups)=>(0, (/*@__PURE__*/$parcel$interopDefault($5FdZg)))(optionGroups.map((optionOrGroup)=>optionOrGroup.options ? optionOrGroup.options : [
            optionOrGroup
        ]));
const $fe87a86e20a4dd3d$export$e2e167245697ed4e = (items)=>{
    const itemsToFilter = Array.isArray(items) ? items : [
        items
    ];
    return itemsToFilter.filter((item)=>item.value).map(({ value: value })=>value != null ? `${value}`.length : 0);
};
const $fe87a86e20a4dd3d$export$60d56ed3961c839c = (options, query)=>options.filter((option)=>typeof option.value === 'string' && option.value.toLowerCase().includes((query || '').toLowerCase()) || typeof option.label === 'string' && option.label.toLowerCase().includes((query || '').toLowerCase()));

});


parcelRegister("15azN", function(module, exports) {

$parcel$export(module.exports, "hasState", () => $ae2998df30d35f51$export$d2fec4e2fc5f065a);
$parcel$export(module.exports, "findSprintWithState", () => $ae2998df30d35f51$export$fb6b70a9c996212b);
$parcel$export(module.exports, "mapSprintOptionToData", () => $ae2998df30d35f51$export$fb7a6b38a05bd2b7);
$parcel$export(module.exports, "transformSuggestions", () => $ae2998df30d35f51$export$1d0ee4320c26fb60);

var $3V5Jq = parcelRequire("3V5Jq");

var $7ZBX0 = parcelRequire("7ZBX0");
const $ae2998df30d35f51$export$e6c9132cef5ee76f = (sprintId)=>`/secure/GHGoToBoard.jspa?sprintId=${sprintId}`;
const $ae2998df30d35f51$export$d2fec4e2fc5f065a = (state)=>(sprint)=>sprint.state !== undefined && sprint.state.toLowerCase() === state.toLowerCase();
const $ae2998df30d35f51$export$fb6b70a9c996212b = (sprints, state)=>{
    if (!sprints) return undefined;
    return sprints.find($ae2998df30d35f51$export$d2fec4e2fc5f065a(state));
};
const $ae2998df30d35f51$export$d63c3784bf3852ca = (state)=>{
    if (state !== undefined) {
        const stateKey = state.toUpperCase();
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly ACTIVE: "ACTIVE"; readonly CLOSED: "CLOSED"; readonly FUTURE: "FUTURE"; }'.
        return (0, $3V5Jq.SPRINT_STATES)[stateKey];
    }
    return undefined;
};
const $ae2998df30d35f51$export$fb7a6b38a05bd2b7 = ({ value: value })=>Number(value);
const $ae2998df30d35f51$export$fbb2e1641ffac377 = (option)=>({
        id: Number(option.value),
        name: String(option.label),
        state: option.state,
        // mapSprintValueToOption ensures there will always be a boardId
        boardId: Number(option.data?.boardId) || 0
    });
const $ae2998df30d35f51$export$b9928e57702db7d9 = (items)=>items.map($ae2998df30d35f51$export$fbb2e1641ffac377);
const $ae2998df30d35f51$export$cbdf60de7f2200e7 = (option)=>({
        id: Number(option.value),
        boardName: option.description,
        name: String(option.label),
        // mapSprintSuggestionToOption ensures there will always be a state
        // @ts-expect-error - TS2322 - Type 'SprintState | undefined' is not assignable to type 'SprintState'.
        stateKey: $ae2998df30d35f51$export$d63c3784bf3852ca(option.state),
        // mapSprintSuggestionToOption ensures there will always be a date
        date: String(option.data?.date)
    });
const $ae2998df30d35f51$export$db10bf437c75c497 = (items)=>items.map($ae2998df30d35f51$export$cbdf60de7f2200e7);
const $ae2998df30d35f51$export$15c97379ebef6b30 = (sprint)=>({
        id: sprint.id,
        description: sprint.boardName,
        label: sprint.name,
        state: sprint.stateKey,
        value: sprint.id,
        data: {
            date: sprint.date,
            fromCache: sprint.fromCache
        }
    });
const $ae2998df30d35f51$export$c1cb9e6f1beaee0d = (items)=>items.map($ae2998df30d35f51$export$15c97379ebef6b30);
const $ae2998df30d35f51$export$ce3013ece3dbf252 = (sprint)=>({
        id: sprint.id,
        name: sprint.name,
        href: $ae2998df30d35f51$export$e6c9132cef5ee76f(sprint.id),
        endDate: sprint.endDate || ''
    });
const $ae2998df30d35f51$export$755a6a3c6172f7e = (sprint)=>({
        label: sprint.name,
        value: sprint.id,
        href: $ae2998df30d35f51$export$e6c9132cef5ee76f(sprint.id),
        state: $ae2998df30d35f51$export$d63c3784bf3852ca(sprint.state),
        data: {
            boardId: sprint.boardId,
            date: sprint.startDate
        }
    });
const $ae2998df30d35f51$export$cbcaba92baa2e404 = (items)=>items.map($ae2998df30d35f51$export$755a6a3c6172f7e);
const $ae2998df30d35f51$export$1d0ee4320c26fb60 = (suggestionsFromServer, formatMessage)=>{
    const serverSuggestions = suggestionsFromServer.suggestions || [];
    const allMatches = suggestionsFromServer.allMatches || [];
    const allItems = serverSuggestions.concat(allMatches);
    const activeItems = allItems.filter((sprint)=>sprint.stateKey === (0, $3V5Jq.ACTIVE_SPRINT_STATE)).map($ae2998df30d35f51$export$15c97379ebef6b30);
    const futureItems = allItems.filter((sprint)=>sprint.stateKey === (0, $3V5Jq.FUTURE_SPRINT_STATE)).map($ae2998df30d35f51$export$15c97379ebef6b30);
    const sprints = [
        {
            label: formatMessage((0, $7ZBX0.default).activeSprints),
            options: activeItems
        },
        {
            label: formatMessage((0, $7ZBX0.default).futureSprints),
            options: futureItems
        }
    ];
    return sprints;
};

});
parcelRegister("3V5Jq", function(module, exports) {

$parcel$export(module.exports, "ACTIVE_SPRINT_STATE", () => $7e490155e8b1a9ed$export$3ebc9911a79d714f);
$parcel$export(module.exports, "FUTURE_SPRINT_STATE", () => $7e490155e8b1a9ed$export$863e42082c6bde5);
$parcel$export(module.exports, "CLOSED_SPRINT_STATE", () => $7e490155e8b1a9ed$export$86cdef09a89e8c4b);
$parcel$export(module.exports, "SPRINT_STATES", () => $7e490155e8b1a9ed$export$73a0206a4dc59760);
const $7e490155e8b1a9ed$export$3ebc9911a79d714f = 'ACTIVE';
const $7e490155e8b1a9ed$export$863e42082c6bde5 = 'FUTURE';
const $7e490155e8b1a9ed$export$86cdef09a89e8c4b = 'CLOSED';
const $7e490155e8b1a9ed$export$73a0206a4dc59760 = {
    ACTIVE: $7e490155e8b1a9ed$export$3ebc9911a79d714f,
    CLOSED: $7e490155e8b1a9ed$export$86cdef09a89e8c4b,
    FUTURE: $7e490155e8b1a9ed$export$863e42082c6bde5
};

});

parcelRegister("7ZBX0", function(module, exports) {

$parcel$export(module.exports, "default", () => $b03a6b433db0a2b0$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $b03a6b433db0a2b0$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    activeSprints: {
        "id": "issue-field-sprint.common.active-sprints",
        "defaultMessage": "Active"
    },
    futureSprints: {
        "id": "issue-field-sprint.common.future-sprints",
        "defaultMessage": "Future"
    },
    recentSprints: {
        "id": "issue-field-sprint.common.recent-sprints",
        "defaultMessage": "Recent sprints"
    }
});

});


parcelRegister("kZuUp", function(module, exports) {

$parcel$export(module.exports, "useSprintSuggestions", () => $ff95b0be9a41a150$export$16d0ab78a0b529dc);

var $eJOHy = parcelRequire("eJOHy");

var $b5RwB = parcelRequire("b5RwB");

var $jGzN3 = parcelRequire("jGzN3");

const $ff95b0be9a41a150$var$defaultParams = (0, $b5RwB.stringify)({
    maxActiveSprints: (0, $d3c0eabe62e9aa5e$export$7112c73100e3ee45),
    maxResults: (0, $d3c0eabe62e9aa5e$export$f6b2881bc1090cea)
});
const $ff95b0be9a41a150$export$6945d45e210d19eb = async (autoCompleteUrl, query, projectKey)=>{
    let queryString;
    if (projectKey !== null && projectKey !== undefined) queryString = `${autoCompleteUrl}${encodeURIComponent(query)}&projectKey=${encodeURIComponent(projectKey)}&${$ff95b0be9a41a150$var$defaultParams}`;
    else queryString = `${autoCompleteUrl}${encodeURIComponent(query)}&${$ff95b0be9a41a150$var$defaultParams}`;
    return (0, $jGzN3.performGetRequest)(queryString);
};
const $ff95b0be9a41a150$export$16d0ab78a0b529dc = (props)=>{
    const { getSuggestions: getSuggestions = $ff95b0be9a41a150$export$6945d45e210d19eb } = props || {};
    const [isLoadingSuggestions, setIsLoadingSuggestions] = (0, $eJOHy.useState)(false);
    const getSprintSuggestions = (0, $eJOHy.useCallback)(async (autoCompleteUrl, query, projectKey)=>{
        try {
            const response = await getSuggestions(autoCompleteUrl, query, projectKey);
            setIsLoadingSuggestions(false);
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setIsLoadingSuggestions(false);
            throw error;
        }
    }, [
        getSuggestions,
        setIsLoadingSuggestions
    ]);
    const actions = (0, $eJOHy.useMemo)(()=>({
            getSprintSuggestions: getSprintSuggestions,
            setIsLoadingSuggestions: setIsLoadingSuggestions
        }), [
        getSprintSuggestions,
        setIsLoadingSuggestions
    ]);
    return [
        {
            isLoadingSuggestions: isLoadingSuggestions
        },
        actions
    ];
};

});
const $d3c0eabe62e9aa5e$export$f27038d72181627e = '/rest/greenhopper/1.0/sprint/picker?query=';
const $d3c0eabe62e9aa5e$export$7112c73100e3ee45 = 5;
const $d3c0eabe62e9aa5e$export$f6b2881bc1090cea = 10;


parcelRegister("3dENi", function(module, exports) {

$parcel$export(module.exports, "EDIT_SPRINT_CHECKBOX_CACHE_KEY", () => $46a6a269833bc1ba$export$90fd8fcc9388370d);
$parcel$export(module.exports, "getCheckboxValueFromLocalStorage", () => $46a6a269833bc1ba$export$b6ec857d138d143b);
$parcel$export(module.exports, "setCheckBoxValueInLocalStorage", () => $46a6a269833bc1ba$export$1750bf12ee05e0ac);

var $b5RwB = parcelRequire("b5RwB");

var $dnU6V = parcelRequire("dnU6V");

var $7jTnu = parcelRequire("7jTnu");
const $46a6a269833bc1ba$var$localStorageProvider = (0, $dnU6V.createLocalStorageProvider)('', false);
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $46a6a269833bc1ba$var$getViewMode = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).parse(window.location.search).view || '';
const $46a6a269833bc1ba$export$d5e150c1e3186bd1 = ()=>$46a6a269833bc1ba$var$getViewMode().includes('planning');
const $46a6a269833bc1ba$export$90fd8fcc9388370d = 'edit_sprint_cache_value';
const $46a6a269833bc1ba$export$b6ec857d138d143b = (key)=>{
    let value;
    if ((0, $7jTnu.fg)('jfp-vulcan-browser-storage-migration')) value = $46a6a269833bc1ba$var$localStorageProvider.get(key);
    else if (typeof window !== 'undefined') value = window.localStorage?.getItem(key);
    return value ? JSON.parse(value) : true;
};
const $46a6a269833bc1ba$export$1750bf12ee05e0ac = (key, value)=>{
    try {
        if ((0, $7jTnu.fg)('jfp-vulcan-browser-storage-migration')) $46a6a269833bc1ba$var$localStorageProvider.set(key, value);
        else if (typeof window !== 'undefined') // @ts-expect-error - TS2345 - Argument of type 'boolean' is not assignable to parameter of type 'string'.
        window.localStorage.setItem(key, value);
    } catch  {
    // do nothing
    }
};

});

parcelRegister("gxTNf", function(module, exports) {

$parcel$export(module.exports, "default", () => $124ee1513b50ceb2$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $86tBw = parcelRequire("86tBw");

var $6XEne = parcelRequire("6XEne");

var $lRq8t = parcelRequire("lRq8t");

var $jD2iR = parcelRequire("jD2iR");

var $coPEL = parcelRequire("coPEL");
const $124ee1513b50ceb2$var$Menu = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { children: children, ...restProps } = props;
    const isChecked = props.selectProps?.componentsProps?.isChecked || false;
    const projectKey = props.selectProps?.componentsProps?.projectKey || null;
    const label = formatMessage((0, $jD2iR.default).checkboxLabel, {
        projectKey: projectKey
    });
    const onKeyDown = (0, $eJOHy.useCallback)((event)=>{
        // stopping propagation when focus moves to checkbox because select already binded with space and enter for selection
        if (event.key === ' ') event.stopPropagation();
    }, []);
    return(// @ts-expect-error - TS2746 - This JSX tag's 'children' prop expects a single child of type 'ReactElement<any, string | JSXElementConstructor<any>>', but multiple children were provided.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6XEne.components).Menu, restProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $coPEL.CheckboxWrapper), {
        onClick: props.selectProps?.componentsProps?.onChange
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86tBw.default), {
        onKeyDown: onKeyDown,
        isChecked: isChecked,
        label: label,
        testId: "issue-field-sprint.ui.edit.menu.checkbox"
    })), children)));
};
var // @ts-expect-error - TS2352 - Conversion of type '(props: Props) => JSX.Element' to type 'ReactNode' may be a mistake because neither type sufficiently overlaps with the other. If this was intentional, convert the expression to 'unknown' first.
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$124ee1513b50ceb2$export$2e2bcd8739ae039 = $124ee1513b50ceb2$var$Menu;

});
parcelRegister("jD2iR", function(module, exports) {

$parcel$export(module.exports, "default", () => $90606542a0d1618c$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $90606542a0d1618c$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    checkboxLabel: {
        "id": "issue-field-sprint.edit.menu.checkbox-label",
        "defaultMessage": "Only show sprints in this project ({projectKey})"
    }
});

});

parcelRegister("coPEL", function(module, exports) {

$parcel$export(module.exports, "CheckboxWrapper", () => $3aef7d0d2189325d$export$eef12940a6696c78);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- To migrate as part of go/ui-styling-standard

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $3aef7d0d2189325d$export$eef12940a6696c78 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_n7zludwz _1e0c1txw _2lx2vrvc _1bah1y6m _ca0qu2gc _u5f3utpp _n3tdu2gc _19bvutpp _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});


parcelRegister("hfXBy", function(module, exports) {

$parcel$export(module.exports, "default", () => $33964953555072c4$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $33964953555072c4$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    placeholder: {
        "id": "issue-field-sprint.edit.placeholder",
        "defaultMessage": "Select sprint"
    },
    empty: {
        "id": "issue-field-sprint.edit.empty",
        "defaultMessage": "No matches found"
    },
    failedFetch: {
        "id": "issue-field-sprint.edit.failed-fetch",
        "defaultMessage": "Search failed. Please try again."
    },
    loading: {
        "id": "issue-field-sprint.edit.loading",
        "defaultMessage": "Searching..."
    }
});

});


parcelRegister("9zSH1", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce0f131b266884fc$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $ce0f131b266884fc$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    activeSprintSelectionWarningMessage: {
        "id": "issue-create-commons.sprint-field.active-sprint-selection-warning-message",
        "defaultMessage": "Creating this issue will affect the active sprint's scope"
    },
    activeSprintSelectionWarningMessageIssueTermRefresh: {
        "id": "issue-create-commons.sprint-field.active-sprint-selection-warning-message-issue-term-refresh",
        "defaultMessage": "Creating this work item will affect the active sprint's scope"
    }
});

});

parcelRegister("aixH0", function(module, exports) {

$parcel$export(module.exports, "transformDefaultSprintValue", () => $77358ff226030af3$export$94efa001ab93bfd1);
$parcel$export(module.exports, "mutateJiraSprintField", () => $77358ff226030af3$export$38f8d6ec9f8dd490);
$parcel$export(module.exports, "getSprintSuggestions", () => $77358ff226030af3$export$a5ccca5b51d5d670);

var $jGzN3 = parcelRequire("jGzN3");
const $77358ff226030af3$export$94efa001ab93bfd1 = (selectedSprints)=>{
    const sprint = selectedSprints[0];
    return sprint && {
        label: sprint.name,
        value: sprint.sprintId,
        state: sprint.state
    };
};
const $77358ff226030af3$export$38f8d6ec9f8dd490 = ({ value: value }, fieldId)=>({
        sprintsField: {
            fieldId: fieldId,
            sprints: [
                {
                    sprintId: value.toString()
                }
            ]
        }
    });
const $77358ff226030af3$export$c1102c96d31ebe29 = (autoCompleteUrl, query, projectKey)=>{
    const queryString = `${autoCompleteUrl}${encodeURIComponent(query)}`;
    if (projectKey !== null && projectKey !== undefined) return `${queryString}&projectKey=${encodeURIComponent(projectKey)}`;
    return queryString;
};
const $77358ff226030af3$export$a5ccca5b51d5d670 = async (autoCompleteUrl, query, projectKey)=>(0, $jGzN3.performGetRequest)($77358ff226030af3$export$c1102c96d31ebe29(autoCompleteUrl, query, projectKey));

});


parcelRegister("imx16", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2b80e2718089cbd$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $lm0ZR = parcelRequire("lm0ZR");

const $f2b80e2718089cbd$var$TextField = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lm0ZR.default), {
        type: "text",
        ...props
    });
var $f2b80e2718089cbd$export$2e2bcd8739ae039 = $f2b80e2718089cbd$var$TextField;

});

parcelRegister("f9vi5", function(module, exports) {

$parcel$export(module.exports, "mutateTextField", () => $44b54f4cf46a44ab$export$5dd442db0007fb2d);

const $44b54f4cf46a44ab$export$5dd442db0007fb2d = (value, fieldId)=>({
        fieldId: fieldId,
        text: value,
        mutationGroup: (0, $7a4d1e9b291a644a$export$31fd86f8f183952c)
    });

});
const $7a4d1e9b291a644a$export$31fd86f8f183952c = 'singleLineTextFields';


parcelRegister("cO7jo", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5dc6b89350379fb$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8aDuw = parcelRequire("8aDuw");

var $fE4zR = parcelRequire("fE4zR");

var $2nXHu = parcelRequire("2nXHu");

var $4yQUm = parcelRequire("4yQUm");

const $a5dc6b89350379fb$var$TextAreaField = (props)=>{
    const { width: width = '100%', fieldProps: { value: value = '', onChange: onChange, onBlur: onBlur, ...fieldProps }, error: error, autoFocus: autoFocus = false, isReadOnly: isReadOnly = false } = props;
    const onTextAreaChange = (e)=>{
        onChange(e.target.value);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fE4zR.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8aDuw.default), {
        ...fieldProps,
        value: value,
        onChange: onTextAreaChange,
        onBlur: onBlur,
        isInvalid: Boolean(error),
        autoFocus: autoFocus,
        isDisabled: isReadOnly
    }));
};
var $a5dc6b89350379fb$export$2e2bcd8739ae039 = (0, $2nXHu.withFormField)({
    validator: (0, $4yQUm.validateString)
})(// @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element' is not assignable to parameter of type 'AbstractComponent<ComponentProps<TextAreaFieldConfig, string>, any>'.
$a5dc6b89350379fb$var$TextAreaField);

});
parcelRegister("8aDuw", function(module, exports) {

$parcel$export(module.exports, "default", () => $d506e134b0995cba$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $dQmi3 = parcelRequire("dQmi3");
const $d506e134b0995cba$var$TextAreaEdit = (props)=>{
    const { isRequired: isRequired = false, isInvalid: isInvalid, value: value, placeholder: placeholder = '', onBlur: onBlur, onFocus: onFocus, onChange: onChange, minimumRows: minimumRows = 3, autoFocus: autoFocus = false, isDisabled: isDisabled = false, ...fieldProps } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dQmi3.default), {
        ...fieldProps,
        isRequired: isRequired,
        placeholder: placeholder,
        value: value,
        autoFocus: autoFocus,
        onBlur: onBlur,
        onFocus: onFocus,
        onChange: onChange,
        isInvalid: isInvalid,
        minimumRows: minimumRows,
        isDisabled: isDisabled
    });
};
var $d506e134b0995cba$export$2e2bcd8739ae039 = $d506e134b0995cba$var$TextAreaEdit;

});
parcelRegister("dQmi3", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef995104f62942f4$export$2e2bcd8739ae039);
/* text-area.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $eJOHy = parcelRequire("eJOHy");

var $jrFnt = parcelRequire("jrFnt");

var $eGOwo = parcelRequire("eGOwo");
const $ef995104f62942f4$var$packageName = "platform-pkg";
const $ef995104f62942f4$var$packageVersion = "0.0.0-use.local";
const $ef995104f62942f4$var$analyticsParams = {
    componentName: 'textArea',
    packageName: $ef995104f62942f4$var$packageName,
    packageVersion: $ef995104f62942f4$var$packageVersion
};
const $ef995104f62942f4$var$lineHeightBase = 20;
const $ef995104f62942f4$var$lineHeightCompact = 16;
const $ef995104f62942f4$var$compactVerticalPadding = 2;
const $ef995104f62942f4$var$verticalPadding = 6;
const $ef995104f62942f4$var$transitionDuration = '0.2s';
const $ef995104f62942f4$var$borderWidth = 2;
const $ef995104f62942f4$var$baseStyles = null;
const $ef995104f62942f4$var$appearanceStyles = {
    standard: "_1dqonqa1 _kp821elr _1ltx1j9a _1bqs13gt _z1pvsyzs _19wt1elr _12ym1d5g _19qkv77o _1dbiv77o _1etu1v6z _zedr1v6z _1itd12x7 _1a4912x7 _17km1v6z _wg601v6z _858u1p6i _jomrr01l _7ehiq049 _186j1p6i _qu18syzs",
    subtle: "_1dqonqa1 _kp823acm _1ltx18uv _19wt1elr _12ym1d5g _19qkv77o _1dbiv77o _1etu1v6z _zedr1v6z _1itd12x7 _1a4912x7 _wg601v6z _17km1v6z _858u1p6i _jomrr01l _7ehiq049",
    none: "_1dqoglyw _kp823acm _1ltx18uv _19wt3acm _12ym18uv _19qkv77o _zedr12x7 _1dbiv77o _1etu12x7 _1itd12x7 _wg6012x7 _1a4912x7 _17km12x7 _858u3acm _jomr18uv _7ehinruj"
};
const $ef995104f62942f4$var$fontStyles = {
    default: "_ect41gqc",
    monospace: "_ect41odn _1tn22smr _14mdudxr",
    large: "_11c81ixg _1tn22smr"
};
const $ef995104f62942f4$var$resizeStyles = {
    horizontal: "_14zg1e08",
    vertical: "_14zg1e54",
    auto: "_14zg1hrf",
    smart: "_14zgglyw",
    none: "_14zgglyw"
};
const $ef995104f62942f4$var$setSmartHeight = (el)=>{
    // Always reset height to auto before calculating new height
    el.style.height = 'auto';
    const borderHeight = $ef995104f62942f4$var$borderWidth;
    const paddingBoxHeight = el.scrollHeight;
    const borderBoxHeight = paddingBoxHeight + borderHeight * 2;
    el.style.height = `${borderBoxHeight}px`;
};
const $ef995104f62942f4$var$InnerTextArea = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const ourRef = (0, $eJOHy.useRef)(null);
    const { resize: resize = 'smart', appearance: appearance = 'standard', isCompact: isCompact = false, isRequired: isRequired = false, isReadOnly: isReadOnly = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, minimumRows: minimumRows = 2, testId: testId, maxHeight: maxHeight = '50vh', onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, style: style, ...rest } = props;
    const borderHeight = (0, $eJOHy.useMemo)(()=>appearance === 'none' ? 2 : 1, [
        appearance
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $ef995104f62942f4$var$setSmartHeight(el);
    }, [
        resize,
        value
    ]);
    const onBlurWithAnalytics = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$ef995104f62942f4$var$analyticsParams
    });
    const onFocusWithAnalytics = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$ef995104f62942f4$var$analyticsParams
    });
    const getTextAreaRef = (elementRef)=>{
        ourRef.current = elementRef;
        if (ref && typeof ref === 'object') // @ts-ignore
        ref.current = elementRef;
        if (ref && typeof ref === 'function') ref(elementRef);
    };
    const handleOnChange = (0, $eJOHy.useCallback)((e)=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $ef995104f62942f4$var$setSmartHeight(el);
        onChange && onChange(e);
    }, [
        onChange,
        resize
    ]);
    const controlProps = {
        'data-invalid': isInvalid ? isInvalid : undefined,
        'data-compact': isCompact ? isCompact : undefined,
        'data-testid': testId ? testId : undefined
    };
    const compactMinHeightStyles = null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("textarea", {
        ...controlProps,
        value: value,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        ref: getTextAreaRef,
        onChange: handleOnChange,
        onBlur: onBlurWithAnalytics,
        onFocus: onFocusWithAnalytics,
        rows: minimumRows,
        ...rest,
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _16jlkb7n _1o9zkb7n _i0dl1osq _2rko1sit _11c82smr _12ji1r31 _1qu2glyw _12y31o36 _1reo1wug _18m91wug _v564r5cv _189ee4h9 _1e0c1ule _vchhusvi _1bsb1osq _1ul9idpf _p12f1osq _kqswh2mm _syazj3m3 _slp31hna _153g78r2 _usy4mag2 _1a2sr6rt _vbqb9jg2 _j5dh13gf _cfjqkb7n _k3o7n7od _1goxglyw _13xeglyw _1fra78r2 _ibjd10ko _6zpvr6rt _19k01y1w _1idr1wmz _1lep9jg2 _nmhq1fiz _1n388sxn _1luh194a _ndzbr01l _1vj01cu8",
            $ef995104f62942f4$var$appearanceStyles[appearance],
            (0, $eGOwo.fg)('platform_design_system_team_safari_input_fix') && $ef995104f62942f4$var$fontStyles['large'],
            $ef995104f62942f4$var$fontStyles[isMonospaced ? 'monospace' : 'default'],
            $ef995104f62942f4$var$resizeStyles[resize],
            "_uzq71i7i _16lwuel1"
        ]),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            maxHeight: maxHeight,
            "--_6ny3x7": (0, $awdRS.default)($ef995104f62942f4$var$lineHeightCompact * minimumRows + $ef995104f62942f4$var$compactVerticalPadding * 2 + borderHeight * 2, "px"),
            "--_eorxnz": (0, $awdRS.default)($ef995104f62942f4$var$lineHeightBase * minimumRows + $ef995104f62942f4$var$verticalPadding * 2 + borderHeight * 2, "px")
        }
    });
}); /**
     * __Text area__
     *
     * A text area lets users enter long form text which spans over multiple lines.
     *
     * - [Examples](https://atlassian.design/components/textarea/examples)
     * - [Code](https://atlassian.design/components/textarea/code)
     * - [Usage](https://atlassian.design/components/textarea/usage)
     */ 
const $ef995104f62942f4$var$TextArea = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)(function TextArea(props, ref) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)($ef995104f62942f4$var$InnerTextArea, {
        ref: ref,
        ...props
    });
}));
$ef995104f62942f4$var$TextArea.displayName = 'TextArea';
var $ef995104f62942f4$export$2e2bcd8739ae039 = $ef995104f62942f4$var$TextArea;

});



parcelRegister("7sscC", function(module, exports) {

$parcel$export(module.exports, "mutateTextAreaField", () => $a6dd7ead5ae2422a$export$26988cd8ac7fed9b);

const $a6dd7ead5ae2422a$export$26988cd8ac7fed9b = (value, fieldId)=>({
        fieldId: fieldId,
        mutationGroup: (0, $21da9aeb784145ac$export$31fd86f8f183952c),
        richText: {
            wikiText: value
        }
    });

});
const $21da9aeb784145ac$export$31fd86f8f183952c = 'richTextFields';


parcelRegister("aCPP2", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a582bc6e3e713ae$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $lm0ZR = parcelRequire("lm0ZR");

const $4a582bc6e3e713ae$var$UrlField = (props)=>{
    const { width: width = 350, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lm0ZR.default), {
        type: "url",
        width: width,
        ...rest
    });
};
var $4a582bc6e3e713ae$export$2e2bcd8739ae039 = $4a582bc6e3e713ae$var$UrlField;

});

parcelRegister("5R3KZ", function(module, exports) {

$parcel$export(module.exports, "mutateUrlField", () => $1234564b9a8faedb$export$68f54af506df5feb);

const $1234564b9a8faedb$export$68f54af506df5feb = (url, fieldId)=>{
    const mutatedValue = {
        fieldId: fieldId,
        mutationGroup: (0, $0016daa1697c8cf5$export$31fd86f8f183952c)
    };
    mutatedValue.url = url;
    return mutatedValue;
};

});
const $0016daa1697c8cf5$export$31fd86f8f183952c = 'urlFields';


parcelRegister("9cLf3", function(module, exports) {

$parcel$export(module.exports, "transformToServerValue", () => $661fa188d5b9cb90$export$6f0c6eec5b71d787);

var $5PQOA = parcelRequire("5PQOA");
const $661fa188d5b9cb90$export$d1480328df7a42bf = (serverValue)=>{
    if (!serverValue) return null;
    const { id: id, value: value, child: child } = serverValue;
    return {
        value: id,
        label: value,
        child: child && {
            value: child.id,
            label: child.value
        }
    };
};
const $661fa188d5b9cb90$export$899758961952c638 = (0, (/*@__PURE__*/$parcel$interopDefault($5PQOA)))((values)=>values.map(({ id: id, value: value })=>({
            value: id,
            label: value
        })));
const $661fa188d5b9cb90$export$575da772c90849b8 = (0, (/*@__PURE__*/$parcel$interopDefault($5PQOA)))((values)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    values.reduce((acc, { id: id, children: children })=>{
        acc[id] = children ? $661fa188d5b9cb90$export$899758961952c638(children) : [];
        return acc;
    }, {}));
const $661fa188d5b9cb90$export$6f0c6eec5b71d787 = (option)=>{
    if (!option) return null;
    const { label: label, value: value } = option;
    // @ts-expect-error - TS2339 - Property 'child' does not exist on type 'Option | ParentChildOption'.
    const child = option.child || undefined;
    return {
        id: value,
        value: label,
        child: child && {
            id: child.value,
            value: child.label
        }
    };
};

});

parcelRegister("30SZQ", function(module, exports) {

$parcel$export(module.exports, "transformSuggestions", () => $0a14b1f2cebfc820$export$1d0ee4320c26fb60);
$parcel$export(module.exports, "mapEpicLinkOptionToData", () => $0a14b1f2cebfc820$export$2d8fd73a87ecc4de);
// eslint-disable-next-line jira/restricted/react-component-props

var $eJOHy = parcelRequire("eJOHy");

var $8URAw = parcelRequire("8URAw");

var $4IyQU = parcelRequire("4IyQU");

var $kSo08 = parcelRequire("kSo08");
const $0a14b1f2cebfc820$export$b00899e73680c477 = (color)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kSo08.ColorPatch), {
        color: color
    });
const $0a14b1f2cebfc820$export$9227063fc962e54 = (epic)=>{
    const color = (0, $8URAw.MAP_FROM_SERVER_COLOR)[epic.issueColor.key];
    return {
        color: color,
        label: epic.summary,
        value: epic.key,
        id: epic.id.toString(),
        description: epic.key,
        elemBefore: $0a14b1f2cebfc820$export$b00899e73680c477(color),
        filterValues: [
            epic.summary,
            epic.key
        ],
        isDone: epic.done
    };
};
const $0a14b1f2cebfc820$export$1d0ee4320c26fb60 = (response, formatMessage)=>{
    const epicLists = response.values || [];
    const epicLink = [
        {
            label: formatMessage((0, $4IyQU.default).allEpics),
            options: epicLists.map($0a14b1f2cebfc820$export$9227063fc962e54)
        }
    ];
    return epicLink;
};
const $0a14b1f2cebfc820$export$2d8fd73a87ecc4de = ({ value: value })=>value;

});
parcelRegister("4IyQU", function(module, exports) {

$parcel$export(module.exports, "default", () => $50221dbd730922d2$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $50221dbd730922d2$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    placeholder: {
        "id": "issue-field-epic-link.edit.placeholder",
        "defaultMessage": "Select Epic"
    },
    noOptionsMessage: {
        "id": "issue-field-epic-link.edit.no-options-message",
        "defaultMessage": "No matches found"
    },
    failedFetch: {
        "id": "issue-field-epic-link.edit.failed-fetch",
        "defaultMessage": "Search failed. Please try again."
    },
    loadingMessage: {
        "id": "issue-field-epic-link.edit.loading-message",
        "defaultMessage": "Searching..."
    },
    allEpics: {
        "id": "issue-field-epic-link.edit.all-epics",
        "defaultMessage": "All epics"
    }
});

});

parcelRegister("kSo08", function(module, exports) {

$parcel$export(module.exports, "ColorPatch", () => $4d0e4c8b32c7f1cc$export$a3f78762e82c8733);
// eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $cdbP5 = parcelRequire("cdbP5");

var $dPMMf = parcelRequire("dPMMf");

var $8URAw = parcelRequire("8URAw");
const $4d0e4c8b32c7f1cc$export$a3f78762e82c8733 = /*#__PURE__*/ (0, $cdbP5.default).div.withConfig({
    componentId: "p05qyv-0"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `${(0, $dPMMf.gridSize) * 2.5}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `${(0, $dPMMf.gridSize) * 2.5}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        borderRadius: `${(0, $dPMMf.gridSize) / 2}px`,
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: (0, $8URAw.MAP_COLORS_TO_VALUE)[props.color]
    }));

});


parcelRegister("i4diV", function(module, exports) {

$parcel$export(module.exports, "mapOrganizationOptionsToData", () => $9bfc57c3a3523312$export$aa1a3b6fac8d058a);
$parcel$export(module.exports, "mapDataToOrganizationOptions", () => $9bfc57c3a3523312$export$bb720a783a78b0f4);
const $9bfc57c3a3523312$export$aa1a3b6fac8d058a = (options)=>options.map(({ value: value })=>Number.parseInt(value, 10));
const $9bfc57c3a3523312$export$bb720a783a78b0f4 = (data)=>data.map(({ id: id, name: name })=>({
            label: name,
            value: `${id}`
        }));

});

parcelRegister("Gh5XP", function(module, exports) {

$parcel$export(module.exports, "mapDataToOptions", () => $698f226249a4ffbd$export$99a866ffa3af7d8b);
$parcel$export(module.exports, "mapOptionToData", () => $698f226249a4ffbd$export$fc800909123977f3);
const $698f226249a4ffbd$export$4c05e2584b34e4d8 = (issueTypes)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const transformedIssueTypes = {};
    issueTypes.forEach((issueType)=>{
        const { id: id, iconUrl: iconUrl } = issueType;
        transformedIssueTypes[id] = iconUrl;
    });
    return transformedIssueTypes;
};
const $698f226249a4ffbd$export$227473965d2e27db = (projects)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const transformedProjects = {};
    projects.forEach((project)=>{
        const { id: id, key: key } = project;
        transformedProjects[id] = key;
    });
    return transformedProjects;
};
const $698f226249a4ffbd$export$99a866ffa3af7d8b = (response)=>{
    const transformedIssueTypes = $698f226249a4ffbd$export$4c05e2584b34e4d8(response.issueTypes);
    const transformedProjects = $698f226249a4ffbd$export$227473965d2e27db(response.projects);
    const transformedResponse = response.issues.map((issue)=>{
        const { issueKey: issueKey, issueSummary: issueSummary, issueTypeId: issueTypeId, projectId: projectId } = issue;
        const projectKey = transformedProjects[projectId];
        return {
            label: `${projectKey}-${issueKey} ${issueSummary}`,
            value: `${projectKey}-${issueKey}`,
            iconUrl: transformedIssueTypes[String(issueTypeId)]
        };
    });
    return transformedResponse;
};
const $698f226249a4ffbd$export$fc800909123977f3 = (option)=>option.value;

});

parcelRegister("JKlhd", function(module, exports) {

$parcel$export(module.exports, "mapOptionToResolutionOption", () => $e6170a82899964d7$export$f915ce0689a595ca);
$parcel$export(module.exports, "mapResolutionOptionToOption", () => $e6170a82899964d7$export$203456290cf27045);
$parcel$export(module.exports, "mapAndFilterResolutionOptions", () => $e6170a82899964d7$export$38929c8b23814052);
const $e6170a82899964d7$export$f915ce0689a595ca = (option)=>({
        id: option.value,
        name: option.label
    });
const $e6170a82899964d7$export$203456290cf27045 = (option)=>({
        value: option.id,
        label: option.name
    });
const $e6170a82899964d7$export$2ad0f62ebcc9982d = (options)=>options.map((option)=>$e6170a82899964d7$export$203456290cf27045(option));
const $e6170a82899964d7$export$38929c8b23814052 = (currentOption, options)=>{
    if (!currentOption) return $e6170a82899964d7$export$2ad0f62ebcc9982d(options);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return options.reduce((resolutionOptions, option)=>{
        if (option.id !== currentOption.id) resolutionOptions.push($e6170a82899964d7$export$203456290cf27045(option));
        return resolutionOptions;
    }, []);
};

});

parcelRegister("clLhb", function(module, exports) {

$parcel$export(module.exports, "getOptionLabel", () => $8d8467e7dabac151$export$dac6ace3020563ca);
$parcel$export(module.exports, "getOptionValue", () => $8d8467e7dabac151$export$40be908210c5a79c);
$parcel$export(module.exports, "convertRolesToCurrentRole", () => $8d8467e7dabac151$export$dede06c97eeff392);
$parcel$export(module.exports, "transformRolesToArrayIfNull", () => $8d8467e7dabac151$export$394ee8daa9411a86);
$parcel$export(module.exports, "mapRoleToRestrictionValue", () => $8d8467e7dabac151$export$3bb7b17fecda53ae);
$parcel$export(module.exports, "isUserRoleIncludedInRestrictedRoles", () => $8d8467e7dabac151$export$e3d70e1822e7e331);

var $4q8Hz = parcelRequire("4q8Hz");
const $8d8467e7dabac151$export$dac6ace3020563ca = (role)=>role.name;
const $8d8467e7dabac151$export$40be908210c5a79c = (role)=>role.roleId;
const $8d8467e7dabac151$export$dede06c97eeff392 = (selectedRoles, allRoles)=>{
    const transformedCurrentRoles = [];
    selectedRoles.forEach((restriction)=>{
        const matchedRestriction = allRoles.find((role)=>role.roleId === restriction.roleId);
        matchedRestriction && transformedCurrentRoles.push(matchedRestriction);
    });
    return transformedCurrentRoles;
};
const $8d8467e7dabac151$export$394ee8daa9411a86 = (roles, onChange)=>onChange(roles || []);
const $8d8467e7dabac151$export$3bb7b17fecda53ae = (roles)=>({
        projectrole: roles.map(({ roleId: roleId })=>({
                restrictionValue: roleId
            }))
    });
const $8d8467e7dabac151$export$e3d70e1822e7e331 = (selectedRoles, rolesWithCurrentUserRole)=>{
    // no restrictions applied
    if (selectedRoles.length === 0) return true;
    const selectedRoleWithCurrentUserRoles = (0, (/*@__PURE__*/$parcel$interopDefault($4q8Hz)))(selectedRoles, rolesWithCurrentUserRole, 'roleId');
    return Boolean(selectedRoleWithCurrentUserRoles.length);
};

});

parcelRegister("caiim", function(module, exports) {

$parcel$export(module.exports, "IssueCreateOrganizationField", () => $a6b8d30e42f4542c$export$589d64992e8dd3db);

var $eJOHy = parcelRequire("eJOHy");

var $jaNQz = parcelRequire("jaNQz");

var $1KdDN = parcelRequire("1KdDN");

var $lGaCn = parcelRequire("lGaCn");

var $fE4zR = parcelRequire("fE4zR");

var $2nXHu = parcelRequire("2nXHu");

var $ixdDB = parcelRequire("ixdDB");

var $4xbv3 = parcelRequire("4xbv3");
var $iqtgH = parcelRequire("iqtgH");

var $bNexr = parcelRequire("bNexr");

var $bmoS1 = parcelRequire("bmoS1");

var $8wYnX = parcelRequire("8wYnX");

var $cHJmY = parcelRequire("cHJmY");

var $86m8P = parcelRequire("86m8P");
const $a6b8d30e42f4542c$export$8ad431dc6194deae = (props)=>{
    const { width: width, autoFocus: autoFocus = false, fieldProps: { value: value, onChange: onChange, ...fieldProps }, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, $ixdDB.closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, error: error, searchUrl: searchUrl } = props;
    const issueKey = (0, $bmoS1.useIssueKey)();
    const projectKey = (0, $bNexr.useProjectKey)(issueKey);
    const projectId = (0, $bNexr.useProjectId)(projectKey);
    const { projectId: projectIdNoIssueKey } = (0, $8wYnX.useCommonPageContext)();
    const finalProjectId = issueKey ? projectId : projectIdNoIssueKey;
    const autoCompleteUrl = searchUrl || `/rest/servicedesk/1/project/${finalProjectId}/organisations/all/search`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fE4zR.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jaNQz.default), {
        name: "organization-edit",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lGaCn.FieldLoader), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        sourceName: "organizationFieldGIC",
        sourceType: (0, $466f60259c330878$export$1171103ea9083ffa)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqtgH.FireScreenAnalytics), {
        attributes: {
            organizationFieldViewed: 'GIC'
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cHJmY.EditView), {
        ...fieldProps,
        isInvalid: Boolean(error),
        isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
        onChange: onChange,
        value: value,
        autoFocus: autoFocus,
        onCloseMenuOnScroll: onCloseMenuOnScroll,
        spacing: "default",
        searchUrl: autoCompleteUrl
    })));
};
const $a6b8d30e42f4542c$export$c44556a89b9dcda3 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "organizationField",
        packageName: "jiraServicedeskCustomerServiceOrganizationField",
        teamName: "boysenberry",
        sendToPrivacyUnsafeSplunk: true,
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a6b8d30e42f4542c$export$8ad431dc6194deae, props));
};
const $a6b8d30e42f4542c$export$589d64992e8dd3db = (0, $2nXHu.withFormField)({
    validator: (0, $86m8P.validateOrganizationField)
})($a6b8d30e42f4542c$export$c44556a89b9dcda3);

});
parcelRegister("8wYnX", function(module, exports) {

$parcel$export(module.exports, "useCommonPageContext", () => $50e80cea8a3c06da$export$682ebac4d54e1a69);

var $9OCJd = parcelRequire("9OCJd");

var $ljej9 = parcelRequire("ljej9");

var $7jTnu = parcelRequire("7jTnu");
const $50e80cea8a3c06da$export$682ebac4d54e1a69 = (// eslint-disable-next-line react-hooks/react-compiler
usePageContext = (0, $9OCJd.usePageContext))=>{
    // eslint-disable-next-line react-hooks/react-compiler
    const [{ data: pageContextData, error: error }] = usePageContext();
    const { tenantContext: tenantContext, projectContext: projectContext } = pageContextData || {};
    const { projectKey: projectKey, projectName: projectName, projectId: projectId, projectType: projectType, isProjectSimplified: isProjectSimplified } = projectContext || {};
    const { locale: locale } = tenantContext || {};
    return {
        // @deprecated baseUrl is always '', remove it from your packages: go/baseurl-cleanup-jfe
        baseUrl: '',
        error: error,
        locale: locale,
        projectKey: projectKey !== undefined ? (0, $ljej9.toProjectKey)(projectKey) : projectKey,
        projectName: projectName,
        projectId: projectId != null ? (0, $ljej9.toProjectId)(projectId.toString()) : projectId,
        projectType: (0, $7jTnu.fg)('jcs_project_type_m3') ? projectType : undefined,
        isProjectSimplified: isProjectSimplified
    };
};

});
parcelRegister("9OCJd", function(module, exports) {

$parcel$export(module.exports, "usePageContext", () => $0f1ed288f228d066$export$9c25024bdfe755f7);

var $eJOHy = parcelRequire("eJOHy");

var $bo7Z6 = parcelRequire("bo7Z6");

var $dZRaT = parcelRequire("dZRaT");

var $lvKO5 = parcelRequire("lvKO5");

var $5tgJD = parcelRequire("5tgJD");
const $0f1ed288f228d066$var$getProjectContextResource = ()=>(0, $dZRaT.projectContextResourceWithCache);
const $0f1ed288f228d066$export$9c25024bdfe755f7 = (customContext)=>{
    const tenantContext = (0, $lvKO5.useTenantContext)();
    const { data: projectContext, loading: projectContextLoading, error: projectContextError } = (0, $bo7Z6.useResourceWithCustomRouterContext)($0f1ed288f228d066$var$getProjectContextResource(), customContext);
    const [{ data: serviceDeskContext, loading: serviceDeskLoading, error: serviceDeskError }] = (0, $5tgJD.useServiceDeskContext)(projectContext?.projectKey || undefined, customContext);
    const pageContextData = (0, $eJOHy.useMemo)(()=>({
            data: projectContext && serviceDeskContext ? {
                serviceDeskContext: {
                    portalId: serviceDeskContext.portalId,
                    portalUrl: serviceDeskContext.portalUrl,
                    canSeeNewIssueView: serviceDeskContext.canSeeNewIssueView,
                    userRole: serviceDeskContext.userRole,
                    serviceDeskId: serviceDeskContext.serviceDeskId
                },
                projectContext: {
                    projectId: projectContext.projectId,
                    projectKey: projectContext.projectKey,
                    projectName: projectContext.projectName,
                    projectType: projectContext.projectType,
                    // Refactor this in https://jdog.jira-dev.com/browse/JSK-443 this is a temporary fix to
                    // resolve a regression https://jira.atlassian.com/browse/JSDCLOUD-8751
                    isAdmin: projectContext.isProjectAdmin || tenantContext.isAdmin,
                    isProjectSimplified: projectContext.simplified
                },
                tenantContext: {
                    locale: tenantContext.locale,
                    userFullname: tenantContext.userFullname,
                    cloudId: tenantContext.cloudId,
                    fabricPfDirUrl: tenantContext.fabricPfDirUrl,
                    atlassianAccountId: tenantContext.atlassianAccountId,
                    isJiraAdmin: tenantContext.isAdmin,
                    isSiteAdmin: tenantContext.isSiteAdmin,
                    activationId: tenantContext.activationId
                }
            } : null,
            loading: projectContextLoading || serviceDeskLoading,
            error: serviceDeskError || projectContextError || null
        }), [
        tenantContext,
        projectContext,
        serviceDeskContext,
        projectContextLoading,
        serviceDeskLoading,
        serviceDeskError,
        projectContextError
    ]);
    return [
        pageContextData
    ];
};

});
parcelRegister("5tgJD", function(module, exports) {

$parcel$export(module.exports, "useServiceDeskContext", () => $c0c57c7bdd281961$export$712ead87353ac687);

var $eJOHy = parcelRequire("eJOHy");

var $bo7Z6 = parcelRequire("bo7Z6");

var $kgDPH = parcelRequire("kgDPH");
const $c0c57c7bdd281961$var$getServiceDeskContextResource = ()=>(0, $kgDPH.serviceDeskContextResource);
const $c0c57c7bdd281961$export$712ead87353ac687 = (projectKey, customContext)=>{
    const { data: data, loading: loading, error: error, refresh: refreshCache } = (0, $bo7Z6.useResourceWithCustomRouterContext)($c0c57c7bdd281961$var$getServiceDeskContextResource(), customContext);
    (0, $eJOHy.useEffect)(()=>{
        if (!false) refreshCache();
    }, [
        projectKey,
        refreshCache
    ]);
    return [
        {
            data: data,
            loading: loading,
            error: error
        }
    ];
};

});
parcelRegister("kgDPH", function(module, exports) {

$parcel$export(module.exports, "serviceDeskContextResource", () => $5ade9d115ab90445$export$5eaaf465969a9171);

var $fcQiO = parcelRequire("fcQiO");

var $l1VxS = parcelRequire("l1VxS");


const $5ade9d115ab90445$var$getDataLoader = ()=>(parcelRequire("6GXhG"));
const $5ade9d115ab90445$export$5eaaf465969a9171 = (0, $l1VxS.createResource)({
    type: (0, $ae1f145ea4ba545a$export$ac01662d5287bc5c),
    getKey: ({ match: match, query: query })=>(0, $fcQiO.getProjectKeyOrIdFromMatchAndQuery)({
            match: match,
            query: query
        }),
    getDataLoader: $5ade9d115ab90445$var$getDataLoader,
    maxAge: Infinity
});

});
const $ae1f145ea4ba545a$export$ac01662d5287bc5c = 'SERVICEDESK_CONTEXT';

parcelRegister("6GXhG", function(module, exports) {

let $4df4a6f153c11136$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $4df4a6f153c11136$var$load("9VGhB").then(()=>parcelRequire('c0Tkr'));

});





parcelRegister("cHJmY", function(module, exports) {

$parcel$export(module.exports, "EditView", () => $8c4e0637a7a33566$export$280eb2fbab4e5389);

var $eJOHy = parcelRequire("eJOHy");

var $3s8bj = parcelRequire("3s8bj");

var $3Wh6p = parcelRequire("3Wh6p");
var $1DXK0 = parcelRequire("1DXK0");

var $6XEne = parcelRequire("6XEne");
var $c4OV1 = parcelRequire("c4OV1");

var $7ep4S = parcelRequire("7ep4S");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $jGzN3 = parcelRequire("jGzN3");

var $gYnSx = parcelRequire("gYnSx");

var $dPMMf = parcelRequire("dPMMf");

var $lRq8t = parcelRequire("lRq8t");

var $c2Sgp = parcelRequire("c2Sgp");

var $7jTnu = parcelRequire("7jTnu");

var $eVCyZ = parcelRequire("eVCyZ");

var $iMtIc = parcelRequire("iMtIc");

var $cbRUq = parcelRequire("cbRUq");
const $8c4e0637a7a33566$export$8966118654f4b5f3 = 300;
const $8c4e0637a7a33566$export$8aef825906bb8745 = 2000;
const $8c4e0637a7a33566$var$getNoOptionsMessage = (error, inputValue)=>{
    if (error) return (0, $iMtIc.default).organizationFieldErrorState;
    return inputValue ? (0, $iMtIc.default).organizationFieldNoResults : (0, $iMtIc.default).organizationFieldNoOptions;
};
const $8c4e0637a7a33566$var$LoadingIndicator = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
        ...props,
        size: "small"
    });
const $8c4e0637a7a33566$var$ValueContainerOld = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6XEne.components).ValueContainer, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        xcss: $8c4e0637a7a33566$var$iconStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c2Sgp.LabelIcon), {
        size: "xsmall",
        type: "ORGANIZATION"
    }), children));
const $8c4e0637a7a33566$var$ValueContainer = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6XEne.components).ValueContainer, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        space: "space.100",
        alignBlock: "center",
        xcss: $8c4e0637a7a33566$var$styles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c2Sgp.LabelIcon), {
        size: "xsmall",
        type: "ORGANIZATION"
    }), children));
const $8c4e0637a7a33566$var$Option = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6XEne.components).Option, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c2Sgp.LabelIcon), {
        size: "xsmall",
        type: "ORGANIZATION"
    }), children));
const $8c4e0637a7a33566$export$280eb2fbab4e5389 = ({ onChange: onChange, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, isInvalid: isInvalid, autoFocus: autoFocus, openMenuOnFocus: openMenuOnFocus, value: value, classNamePrefix: classNamePrefix, onCloseMenuOnScroll: onCloseMenuOnScroll, spacing: spacing = 'compact', searchUrl: searchUrl, ...fieldProps })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [hasError, setHasError] = (0, $eJOHy.useState)(false);
    const debouncedFireSearchSuccessEvent = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(()=>(0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'jcsOrganizationFieldSearch succeeded'), $8c4e0637a7a33566$export$8aef825906bb8745, {
        leading: true,
        trailing: false
    } // fire event on the leading edge of the debounce
    );
    const searchOrganizations = (0, $eJOHy.useCallback)((query = '', callback)=>{
        setHasError(false);
        (0, $jGzN3.performGetRequest)(`${searchUrl}?query=${encodeURIComponent(query)}`).then((response)=>{
            debouncedFireSearchSuccessEvent();
            callback((0, $cbRUq.mapDataToOrganizationOptions)(response));
        }).catch((error)=>{
            (0, $gYnSx.default)({
                meta: {
                    id: 'searchOrganizations',
                    packageName: 'servicedeskCustomerServiceCustomFields',
                    teamName: 'boysenberry'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            setHasError(true);
            callback([]);
        });
    }, [
        debouncedFireSearchSuccessEvent,
        searchUrl
    ]);
    const loadOptionsDebounced = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(searchOrganizations, $8c4e0637a7a33566$export$8966118654f4b5f3);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c4OV1.default), {
        ...fieldProps,
        inputId: "organization",
        loadOptions: loadOptionsDebounced,
        value: value,
        cacheOptions: true,
        placeholder: formatMessage((0, $iMtIc.default).organizationFieldPlaceholder),
        autoFocus: autoFocus,
        openMenuOnFocus: openMenuOnFocus,
        spacing: spacing,
        styles: {
            valueContainer: (base)=>({
                    ...base,
                    display: 'flex',
                    alignItems: 'center',
                    backgroundColor: "var(--ds-background-input, #FFFFFF)"
                }),
            // Makes sure the cursor is directly to the right of the selected text
            singleValue: (base)=>({
                    ...base,
                    marginRight: 0,
                    marginLeft: 0
                }),
            input: (base)=>({
                    ...base,
                    marginLeft: 0
                }),
            container: (base)=>({
                    ...base,
                    minWidth: '200px'
                }),
            menu: (base)=>({
                    ...base,
                    zIndex: (0, $dPMMf.layers).modal
                })
        },
        components: {
            ValueContainer: (0, $7jTnu.fg)('jcs-issue-view-truncate-reporter') ? $8c4e0637a7a33566$var$ValueContainer : $8c4e0637a7a33566$var$ValueContainerOld,
            Option: $8c4e0637a7a33566$var$Option,
            LoadingIndicator: $8c4e0637a7a33566$var$LoadingIndicator
        },
        noOptionsMessage: ({ inputValue: inputValue })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, formatMessage($8c4e0637a7a33566$var$getNoOptionsMessage(hasError, inputValue))),
        onChange: (newValue)=>{
            (0, $eVCyZ.editOrganizationFieldIssueViewExperience).start();
            onChange(newValue);
            if (value?.value !== newValue?.value) (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
                action: 'changed',
                actionSubject: 'organizationField'
            }), {
                hasValue: !!newValue
            });
        },
        classNamePrefix: classNamePrefix,
        closeMenuOnScroll: onCloseMenuOnScroll,
        menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
        isInvalid: isInvalid,
        isClearable: true
    });
};
const $8c4e0637a7a33566$var$iconStyles = (0, $1DXK0.xcss)({
    marginRight: 'space.100',
    marginLeft: 'space.050'
});
const $8c4e0637a7a33566$var$styles = (0, $1DXK0.xcss)({
    width: '100%',
    minWidth: '0px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    paddingInline: 'space.050'
});

});
parcelRegister("c2Sgp", function(module, exports) {

$parcel$export(module.exports, "LabelIcon", () => $8e0a4930fab8c8ac$export$6722f2abd5aa752a);

var $eJOHy = parcelRequire("eJOHy");

var $1WryD = parcelRequire("1WryD");

var $9hb7e = parcelRequire("9hb7e");

var $fYw7A = parcelRequire("fYw7A");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $6XJko = parcelRequire("6XJko");
const $8e0a4930fab8c8ac$export$6722f2abd5aa752a = ({ size: size, type: type, label: label = '', testId: testId, ...etc })=>{
    const Icon = type === 'ORGANIZATION' ? (0, (/*@__PURE__*/$parcel$interopDefault($9hb7e))) : (0, (/*@__PURE__*/$parcel$interopDefault($fYw7A)));
    const iconSize = size === 'large' ? 'large' : 'small';
    const isLarge = size === 'large';
    if ((0, $6XJko.isVisualRefreshEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $8e0a4930fab8c8ac$var$containerStyles,
            size === 'small' && $8e0a4930fab8c8ac$var$smallStyles,
            size === 'xsmall' && $8e0a4930fab8c8ac$var$xsmallStyles
        ],
        testId: testId
    }, isLarge ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1WryD.default), {
        icon: Icon,
        appearance: "gray",
        shape: "square",
        size: "40",
        label: label
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Icon, {
        color: "var(--ds-icon, #44546F)",
        label: label,
        ...etc
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $8e0a4930fab8c8ac$var$containerStyles,
            size === 'large' && $8e0a4930fab8c8ac$var$largeStyles,
            size === 'small' && $8e0a4930fab8c8ac$var$smallStyles,
            size === 'xsmall' && $8e0a4930fab8c8ac$var$xsmallStyles
        ],
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Icon, {
        LEGACY_primaryColor: "var(--ds-icon, #44546F)",
        LEGACY_size: iconSize,
        label: label,
        ...etc
    }));
};
const $8e0a4930fab8c8ac$var$containerStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    backgroundColor: 'color.background.neutral'
});
const $8e0a4930fab8c8ac$var$largeStyles = (0, $1DXK0.xcss)({
    borderRadius: 'border.radius.200',
    padding: 'space.050'
});
const $8e0a4930fab8c8ac$var$smallStyles = (0, $1DXK0.xcss)({
    borderRadius: 'border.radius.050',
    padding: 'space.050'
});
const $8e0a4930fab8c8ac$var$xsmallStyles = (0, $1DXK0.xcss)({
    borderRadius: 'border.radius.050',
    padding: 'space.025'
});

});
parcelRegister("1WryD", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d5a874af77e003e$export$2e2bcd8739ae039);
/* icon-tile.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eGOwo = parcelRequire("eGOwo");
const $6d5a874af77e003e$var$sizeMap = {
    '16': "_1bsb7vkz _4t3i7vkz",
    '24': "_1bsb1tcg _4t3i1tcg",
    '32': "_1bsbzwfg _4t3izwfg",
    '40': "_1bsb1ylp _4t3i1ylp",
    '48': "_1bsbckbl _4t3ickbl"
};
const $6d5a874af77e003e$var$appearanceMap = {
    grayBold: "_bfhk1t1b _syaz5w2r",
    limeBold: "_bfhktde4 _syaz5w2r",
    greenBold: "_bfhk1e5c _syaz5w2r",
    blueBold: "_bfhkc8cv _syaz5w2r",
    redBold: "_bfhkuibq _syaz5w2r",
    purpleBold: "_bfhkygwo _syaz5w2r",
    magentaBold: "_bfhkc3uk _syaz5w2r",
    tealBold: "_bfhk2c8p _syaz5w2r",
    orangeBold: "_bfhkjgng _syaz5w2r",
    yellowBold: "_bfhk1vop _syaz5w2r",
    gray: "_bfhk1v33 _syaz16ni",
    lime: "_bfhkz2ec _syaz8645",
    orange: "_bfhkf2vu _syaz7r97",
    magenta: "_bfhkv9ra _syazv8hk",
    green: "_bfhk1wnw _syaz17hp",
    blue: "_bfhk4v9p _syaz1ov1",
    red: "_bfhk1rtt _syaznbxb",
    purple: "_bfhk1jkz _syaz5yjc",
    teal: "_bfhk1a17 _syaz8uof",
    yellow: "_bfhk3fv2 _syaz1oqg"
};
const $6d5a874af77e003e$var$shapeMap = {
    square: "_2rkoiti9",
    circle: "_2rko14q2"
};
const $6d5a874af77e003e$var$iconTileStyles = null;
function $6d5a874af77e003e$export$2e2bcd8739ae039(props) {
    const { icon: Icon, label: label, appearance: appearance, size: size = '24', shape: shape = 'square', LEGACY_fallbackComponent: LEGACY_fallbackComponent, testId: testId } = props;
    const ExpandedIcon = Icon;
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if (LEGACY_fallbackComponent && !(0, $eGOwo.fg)('platform-visual-refresh-icons')) return LEGACY_fallbackComponent;
    else return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-testid": testId,
        className: (0, $hcewu.default)([
            "_1e0c116y _vchhusvi _4cvr1h6o _1bah1h6o _1wybidpf",
            $6d5a874af77e003e$var$appearanceMap[appearance],
            $6d5a874af77e003e$var$sizeMap[size],
            $6d5a874af77e003e$var$shapeMap[shape]
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)(ExpandedIcon, {
            color: "currentColor",
            label: label,
            spacing: "spacious",
            shouldScale: true
        })
    });
}

});

parcelRegister("9hb7e", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8c9411407c1f042ec99fb06f89567549>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6c0e52f169dc52c1$var$_react = $6c0e52f169dc52c1$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $6c0e52f169dc52c1$var$_officeBuilding = $6c0e52f169dc52c1$var$_interopRequireDefault((parcelRequire("jPgjO")));

var $6c0e52f169dc52c1$var$_officeBuildingFilled = $6c0e52f169dc52c1$var$_interopRequireDefault((parcelRequire("bjFeZ")));
function $6c0e52f169dc52c1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for OfficeBuildingIcon.
 * This component is OfficeBuildingIcon, with `UNSAFE_fallbackIcon` set to "OfficeBuildingFilledIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: office in Atlas, company.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6c0e52f169dc52c1$var$OfficeBuildingIcon = (props)=>/*#__PURE__*/ $6c0e52f169dc52c1$var$_react.default.createElement($6c0e52f169dc52c1$var$_officeBuilding.default, Object.assign({
        LEGACY_fallbackIcon: $6c0e52f169dc52c1$var$_officeBuildingFilled.default
    }, props));
$6c0e52f169dc52c1$var$OfficeBuildingIcon.Name = 'OfficeBuildingIconMigration';
var $6c0e52f169dc52c1$var$_default = module.exports.default = $6c0e52f169dc52c1$var$OfficeBuildingIcon;

});
parcelRegister("jPgjO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dfe75e26330f86b48e811f0d520fc5e3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e6ef7042ada3add3$var$_react = $e6ef7042ada3add3$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $e6ef7042ada3add3$var$_baseNew = $e6ef7042ada3add3$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $e6ef7042ada3add3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "OfficeBuilding".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: office in Atlas, company.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e6ef7042ada3add3$var$OfficeBuildingIcon = (props)=>/*#__PURE__*/ $e6ef7042ada3add3$var$_react.default.createElement($e6ef7042ada3add3$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12.5h1V16H1v-1.5h1zm1.5 12.5h2v-3.75a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 .75.75v3.75h2V2a.5.5 0 0 0-.5-.5H4a.5.5 0 0 0-.5.5zm5.5 0v-3H7v3zm-2-10H5V3h2zm4 0H9V3h2zM5 6h2v1.5H5zm4 0h2v1.5H9z" clip-rule="evenodd"/>`
    }, props));
$e6ef7042ada3add3$var$OfficeBuildingIcon.displayName = 'OfficeBuildingIcon';
var $e6ef7042ada3add3$var$_default = module.exports.default = $e6ef7042ada3add3$var$OfficeBuildingIcon;

});

parcelRegister("bjFeZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $83d1759e81e2efbc$var$_react = $83d1759e81e2efbc$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $83d1759e81e2efbc$var$_officeBuilding = $83d1759e81e2efbc$var$_interopRequireDefault((parcelRequire("jPgjO")));
function $83d1759e81e2efbc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $83d1759e81e2efbc$var$OfficeBuildingFilledIcon = (props)=>/*#__PURE__*/ $83d1759e81e2efbc$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" fill-rule="nonzero" d="M8 6H5.009C3.902 6 3 6.962 3 8.15v10.7C3 20.04 3.9 21 5.009 21h5.487H8z"/><path fill="inherit" d="M6 10h2v2H6zm0 3h2v2H6z"/><path fill="currentcolor" d="M9 4.995C9 3.893 9.902 3 11.009 3h7.982C20.101 3 21 3.893 21 4.995v14.01A2.004 2.004 0 0 1 18.991 21H9z"/><path fill="inherit" d="M12 7h2v2h-2zm0 3h2v2h-2zm0 3h2v2h-2zm2 3h2v3h-2zm2-9h2v2h-2zm0 3h2v2h-2zm0 3h2v2h-2z"/></g></svg>`
    }, props, {
        newIcon: $83d1759e81e2efbc$var$_officeBuilding.default
    }));
$83d1759e81e2efbc$var$OfficeBuildingFilledIcon.displayName = 'OfficeBuildingFilledIcon';
var $83d1759e81e2efbc$var$_default = module.exports.default = $83d1759e81e2efbc$var$OfficeBuildingFilledIcon;

});



parcelRegister("eVCyZ", function(module, exports) {

$parcel$export(module.exports, "editOrganizationFieldIssueViewExperience", () => $b47e82c619ab9f96$export$8da05580d9bb4547);

var $2lxLk = parcelRequire("2lxLk");
var $f39LL = parcelRequire("f39LL");
const $b47e82c619ab9f96$export$8da05580d9bb4547 = new (0, $f39LL.UFOExperience)('jsm-cs-organization-custom-field-issue-view-edit', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
});

});

parcelRegister("iMtIc", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d98daa9fb63da06$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $8d98daa9fb63da06$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    organizationFieldPlaceholder: {
        "id": "servicedesk-customer-service-organization-field.common.organization-edit-view-placeholder-non-final",
        "defaultMessage": "Select option"
    },
    organizationFieldNoOptions: {
        "id": "servicedesk-customer-service-organization-field.common.organization-edit-view-no-options-non-final",
        "defaultMessage": "No options"
    },
    organizationFieldNoResults: {
        "id": "servicedesk-customer-service-organization-field.common.organization-edit-view-no-results-non-final",
        "defaultMessage": "No matches"
    },
    organizationFieldErrorState: {
        "id": "servicedesk-customer-service-organization-field.common.organization-edit-view-error-state-non-final",
        "defaultMessage": "Failed to fetch options"
    }
});

});

parcelRegister("cbRUq", function(module, exports) {

$parcel$export(module.exports, "mapDataToOrganizationOptions", () => $4904eb72fe50eea8$export$bb720a783a78b0f4);
const $4904eb72fe50eea8$export$bb720a783a78b0f4 = (data)=>data?.results?.results?.map(({ id: id, name: name })=>({
            label: name,
            value: `${id}`
        })) || [];

});


parcelRegister("86m8P", function(module, exports) {

$parcel$export(module.exports, "mapOrganizationOptionToData", () => $da6363276279414d$export$156d062414dbdd98);
$parcel$export(module.exports, "validateOrganizationField", () => $da6363276279414d$export$90b32914fc328a85);

var $3UrQk = parcelRequire("3UrQk");
const $da6363276279414d$export$156d062414dbdd98 = (option)=>Number.parseInt(option.value, 10);
const $da6363276279414d$export$608983f592de28e3 = (selectedOrganization, fieldId)=>({
        organizationField: {
            fieldId: fieldId,
            organization: {
                organizationId: selectedOrganization.value
            }
        }
    });
const $da6363276279414d$export$90b32914fc328a85 = (value, isRequired)=>{
    if (isRequired) {
        if (!value) return 0, $3UrQk.REQUIRED;
    }
    return undefined;
};

});


parcelRegister("kXkAy", function(module, exports) {

$parcel$export(module.exports, "IssueCreateEntitlementField", () => $49ddef4221e4f80b$export$99314741193b044b);

var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");

var $lGaCn = parcelRequire("lGaCn");

var $fE4zR = parcelRequire("fE4zR");

var $2nXHu = parcelRequire("2nXHu");

var $ixdDB = parcelRequire("ixdDB");

var $ch9En = parcelRequire("ch9En");

var $4xbv3 = parcelRequire("4xbv3");
var $iqtgH = parcelRequire("iqtgH");

var $2DFdx = parcelRequire("2DFdx");
var $8gBzI = parcelRequire("8gBzI");

var $aI0Nj = parcelRequire("aI0Nj");

var $rZu9E = parcelRequire("rZu9E");

var $i2Yqr = parcelRequire("i2Yqr");
const $49ddef4221e4f80b$export$48549219ad5358dc = (props)=>{
    const { width: width, autoFocus: autoFocus = false, fieldProps: { value: value, onChange: onChange, ...fieldProps }, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, $ixdDB.closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, error: error, contextAndValuesOfIssueBeingCreated: contextAndValuesOfIssueBeingCreated } = props;
    const { getFormState: getFormState } = contextAndValuesOfIssueBeingCreated;
    const formState = getFormState();
    const reporter = formState?.values?.reporter;
    const [currentReporter, setCurrentReporter] = (0, $eJOHy.useState)(reporter);
    (0, $eJOHy.useEffect)(()=>{
        if (reporter?.id !== currentReporter?.id) {
            onChange(null);
            setCurrentReporter(reporter);
        }
    }, [
        reporter,
        currentReporter,
        onChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fE4zR.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "entitlement-edit",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lGaCn.FieldLoader), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        sourceName: "entitlementsFieldGIC",
        sourceType: (0, $466f60259c330878$export$1171103ea9083ffa)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqtgH.FireScreenAnalytics), {
        attributes: {
            entitlementsFieldViewed: 'GIC'
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aI0Nj.LazyEditView), {
        ...fieldProps,
        isInvalid: Boolean(error),
        isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
        onChange: onChange,
        value: value,
        autoFocus: autoFocus,
        onCloseMenuOnScroll: onCloseMenuOnScroll,
        reporterId: reporter?.id,
        spacing: "default"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2DFdx.ExperienceSuccess), {
        experience: (0, $rZu9E.entitlementFieldGicMountExperience)
    })));
};
const $49ddef4221e4f80b$export$f13f32889402194 = (props)=>{
    (0, $8gBzI.useUFOComponentExperience)((0, $rZu9E.entitlementFieldGicMountExperience));
    const onError = (_, error)=>{
        (0, $rZu9E.entitlementFieldGicMountExperience).failure();
        throw error; // rethrow error to be caught by WithFormField erorr boundary so that the field label doesn't show
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "entitlementField",
        packageName: "jiraServicedeskCustomerServiceEntitlementsField",
        onError: onError,
        teamName: "boysenberry",
        sendToPrivacyUnsafeSplunk: true,
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($49ddef4221e4f80b$export$48549219ad5358dc, props));
};
const $49ddef4221e4f80b$export$99314741193b044b = (0, $2nXHu.withFormField)({
    validator: (0, $i2Yqr.validateEntitlementField)
})($49ddef4221e4f80b$export$f13f32889402194);

});
parcelRegister("8gBzI", function(module, exports) {

$parcel$export(module.exports, "useUFOComponentExperience", () => $f45c0feaf94c0f80$export$30ab340faaed55d4);

var $eJOHy = parcelRequire("eJOHy");
const $f45c0feaf94c0f80$var$useConstructor = (callback)=>{
    const hasBeenFired = (0, $eJOHy.useRef)(false);
    if (!hasBeenFired.current) {
        callback();
        hasBeenFired.current = true;
    }
    return null;
};
const $f45c0feaf94c0f80$export$30ab340faaed55d4 = (experience)=>{
    (0, $eJOHy.useEffect)(()=>{
        return ()=>{
            experience.abort();
        };
    // we want this cleanup to only happen on unmount so this is a legit use of empty array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $f45c0feaf94c0f80$var$useConstructor(()=>experience.start());
    return null;
};

});

parcelRegister("aI0Nj", function(module, exports) {

$parcel$export(module.exports, "LazyEditView", () => $273e7e993dc0b8ce$export$a17259a78f401488);

var $bQWwW = parcelRequire("bQWwW");

const $273e7e993dc0b8ce$export$a17259a78f401488 = (0, $bQWwW.lazy)(()=>(parcelRequire("2KvzV")).then((module)=>module.EditView), {
    moduleId: "./src/packages/servicedesk/customer-service/entitlements-field/src/common/ui/edit-view/index.tsx"
});

});
parcelRegister("2KvzV", function(module, exports) {

let $20085f7cfe6ec683$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $20085f7cfe6ec683$var$load("gfrSS").then(()=>parcelRequire('lKcma'));

});


parcelRegister("rZu9E", function(module, exports) {

$parcel$export(module.exports, "entitlementFieldGicMountExperience", () => $bb5c25ff7cebe3a1$export$588fc8ac7a187272);
$parcel$export(module.exports, "entitlementFieldDataFetchExperience", () => $bb5c25ff7cebe3a1$export$7f9aebf7c6d536d6);
$parcel$export(module.exports, "entitlementFieldIssueViewMountExperience", () => $bb5c25ff7cebe3a1$export$66e03de8aa0e97b8);
$parcel$export(module.exports, "editEntitlementFieldIssueViewExperience", () => $bb5c25ff7cebe3a1$export$6889e91b24599276);

var $2lxLk = parcelRequire("2lxLk");
var $f39LL = parcelRequire("f39LL");
const $bb5c25ff7cebe3a1$export$588fc8ac7a187272 = new (0, $f39LL.UFOExperience)('jsm-cs-entitlement-custom-field-gic-mount', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
});
const $bb5c25ff7cebe3a1$export$7f9aebf7c6d536d6 = new (0, $f39LL.UFOExperience)('jsm-cs-entitlement-custom-field-data-fetch', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
});
const $bb5c25ff7cebe3a1$export$66e03de8aa0e97b8 = new (0, $f39LL.UFOExperience)('jsm-cs-entitlement-custom-field-issue-view-mount', {
    type: (0, $2lxLk.ExperienceTypes).Load,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).PageSegmentLoad
});
const $bb5c25ff7cebe3a1$export$6889e91b24599276 = new (0, $f39LL.UFOExperience)('jsm-cs-entitlement-custom-field-issue-view-edit', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
});

});

parcelRegister("i2Yqr", function(module, exports) {

$parcel$export(module.exports, "mapEntitlementOptionToData", () => $e11284090cbcb0ce$export$1c1e5611b1980840);
$parcel$export(module.exports, "validateEntitlementField", () => $e11284090cbcb0ce$export$3f9370506eb4fa6c);

var $3UrQk = parcelRequire("3UrQk");
const $e11284090cbcb0ce$export$1c1e5611b1980840 = (option)=>option.value;
const $e11284090cbcb0ce$export$3b43598c7abb6d70 = (selectedEntitlement, fieldId)=>({
        entitlementField: {
            fieldId: fieldId,
            entitlement: {
                entitlementId: `${selectedEntitlement.value}`
            }
        }
    });
const $e11284090cbcb0ce$export$3f9370506eb4fa6c = (value, isRequired)=>{
    if (isRequired) {
        if (!value) return 0, $3UrQk.REQUIRED;
    }
    return undefined;
};

});


parcelRegister("38tHc", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d7b85efb45308cd$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2hoAW = parcelRequire("2hoAW");

var $fKXve = parcelRequire("fKXve");

var $lRq8t = parcelRequire("lRq8t");

var $3UrQk = parcelRequire("3UrQk");

var $41EpJ = parcelRequire("41EpJ");

var $fIw44 = parcelRequire("fIw44");

var $6Wki2 = parcelRequire("6Wki2");

var $7jTnu = parcelRequire("7jTnu");

var $7xKYD = parcelRequire("7xKYD");

var $f5Bz9 = parcelRequire("f5Bz9");
const $3d7b85efb45308cd$export$f10e1476c0ddb959 = ()=>(0, $eJOHy.useState)(false);
const $3d7b85efb45308cd$var$AttachmentsField = (props)=>{
    const { view: view } = (0, $fIw44.useMinimizableModal)();
    const { fieldId: fieldId, fieldName: fieldName, description: description, isRequired: isRequired, additionalData: additionalData, selectedProject: selectedProject, onInProgressChange: onInProgressChange, additionalData: { maxAllowedTotalAttachmentsSize: maxAllowedTotalAttachmentsSize }, defaultValue: defaultValue, isCollapsed: isCollapsed } = props;
    const { mediaContext: mediaContext } = additionalData;
    const uploadToken = mediaContext?.uploadToken;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [attachmentSizeValidation, onAttachmentSizeValidation] = $3d7b85efb45308cd$export$f10e1476c0ddb959();
    const [isRefetching, setIsRefetching] = (0, $eJOHy.useState)(false);
    // Use the upload permissions service to refetch tokens (only when feature gate is enabled)
    const [isUploadPermissionFetching, uploadPermissions, fetchUploadPermissions] = (0, $7xKYD.useUploadPermissions)();
    let attachmentUploadContext;
    // Use refetched permissions if available and feature gate is enabled, otherwise fall back to original token
    // eslint-disable-next-line jira/ff/no-preconditioning
    if ((0, $7jTnu.fg)('gic-attachment-media-token-refresh') && uploadPermissions) attachmentUploadContext = {
        clientId: uploadPermissions.clientId,
        serviceHost: uploadPermissions.serviceHost,
        collection: uploadPermissions.collection,
        token: uploadPermissions.token
    };
    else if (uploadToken) attachmentUploadContext = {
        clientId: uploadToken.clientId,
        serviceHost: uploadToken.endpointUrl,
        collection: uploadToken.targetCollection,
        token: uploadToken.token
    };
    // Refetch function that uses the upload permissions service (only when feature gate is enabled)
    const refetchToken = (0, $eJOHy.useCallback)(async ()=>{
        if (!selectedProject?.value || isRefetching) return;
        setIsRefetching(true);
        try {
            // Use project-collection type for attachments field
            await fetchUploadPermissions(selectedProject.value, 'project-collection');
        } finally{
            setIsRefetching(false);
        }
    }, [
        selectedProject?.value,
        fetchUploadPermissions,
        isRefetching
    ]);
    // Use the existing media token refetch hook to automatically refetch when token expires
    if ((0, $7jTnu.fg)('gic-attachment-media-token-refresh')) {
        // Use the current token (either from uploadPermissions or uploadToken)
        const currentToken = uploadPermissions?.token ?? uploadToken?.token ?? null;
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $6Wki2.useRefetchMediaTokenOnExpired)({
            mediaToken: currentToken,
            refetch: refetchToken,
            shouldWaitUntilBrowserActive: true
        });
    }
    const dropzoneContainerId = view === 'modal' ? (0, $3UrQk.FORM_DROPZONE_CONTAINER_ID) : (0, $3UrQk.MINIMISED_DROPZONE_CONTAINER_ID);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $41EpJ.default), {
        fieldId: fieldId,
        fieldName: fieldName,
        description: description,
        isRequired: isRequired,
        mediaUploadContext: attachmentUploadContext,
        projectId: selectedProject?.value || null,
        onInProgressChange: onInProgressChange,
        maxAllowedTotalAttachmentsSize: maxAllowedTotalAttachmentsSize,
        onAttachmentSizeValidation: onAttachmentSizeValidation,
        dropzoneContainerId: dropzoneContainerId,
        shouldScrollIntoViewOnUploadStart: true,
        defaultValue: defaultValue,
        isCollapsed: isCollapsed
    }), !attachmentUploadContext && !isUploadPermissionFetching && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fKXve.ErrorMessage), null, formatMessage((0, $f5Bz9.default).missingToken)), attachmentSizeValidation && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fKXve.ErrorMessage), null, formatMessage((0, $f5Bz9.default).attachmentSizeLimitCheck), " (", (0, (/*@__PURE__*/$parcel$interopDefault($2hoAW)))(maxAllowedTotalAttachmentsSize, {
        unitSeparator: ' '
    }), ")."));
};
var $3d7b85efb45308cd$export$2e2bcd8739ae039 = $3d7b85efb45308cd$var$AttachmentsField;

});
parcelRegister("2hoAW", function(module, exports) {
/*!
 * bytes
 * Copyright(c) 2012-2014 TJ Holowaychuk
 * Copyright(c) 2015 Jed Watson
 * MIT Licensed
 */ 'use strict';
/**
 * Module exports.
 * @public
 */ module.exports = $1a903f4c87d81bb7$var$bytes;
module.exports.format = $1a903f4c87d81bb7$var$format;
module.exports.parse = $1a903f4c87d81bb7$var$parse;
/**
 * Module variables.
 * @private
 */ var $1a903f4c87d81bb7$var$formatThousandsRegExp = /\B(?=(\d{3})+(?!\d))/g;
var $1a903f4c87d81bb7$var$formatDecimalsRegExp = /(?:\.0*|(\.[^0]+)0+)$/;
var $1a903f4c87d81bb7$var$map = {
    b: 1,
    kb: 1024,
    mb: 1048576,
    gb: 1073741824,
    tb: Math.pow(1024, 4),
    pb: Math.pow(1024, 5)
};
var $1a903f4c87d81bb7$var$parseRegExp = /^((-|\+)?(\d+(?:\.\d+)?)) *(kb|mb|gb|tb|pb)$/i;
/**
 * Convert the given value in bytes into a string or parse to string to an integer in bytes.
 *
 * @param {string|number} value
 * @param {{
 *  case: [string],
 *  decimalPlaces: [number]
 *  fixedDecimals: [boolean]
 *  thousandsSeparator: [string]
 *  unitSeparator: [string]
 *  }} [options] bytes options.
 *
 * @returns {string|number|null}
 */ function $1a903f4c87d81bb7$var$bytes(value, options) {
    if (typeof value === 'string') return $1a903f4c87d81bb7$var$parse(value);
    if (typeof value === 'number') return $1a903f4c87d81bb7$var$format(value, options);
    return null;
}
/**
 * Format the given value in bytes into a string.
 *
 * If the value is negative, it is kept as such. If it is a float,
 * it is rounded.
 *
 * @param {number} value
 * @param {object} [options]
 * @param {number} [options.decimalPlaces=2]
 * @param {number} [options.fixedDecimals=false]
 * @param {string} [options.thousandsSeparator=]
 * @param {string} [options.unit=]
 * @param {string} [options.unitSeparator=]
 *
 * @returns {string|null}
 * @public
 */ function $1a903f4c87d81bb7$var$format(value, options) {
    if (!Number.isFinite(value)) return null;
    var mag = Math.abs(value);
    var thousandsSeparator = options && options.thousandsSeparator || '';
    var unitSeparator = options && options.unitSeparator || '';
    var decimalPlaces = options && options.decimalPlaces !== undefined ? options.decimalPlaces : 2;
    var fixedDecimals = Boolean(options && options.fixedDecimals);
    var unit = options && options.unit || '';
    if (!unit || !$1a903f4c87d81bb7$var$map[unit.toLowerCase()]) {
        if (mag >= $1a903f4c87d81bb7$var$map.pb) unit = 'PB';
        else if (mag >= $1a903f4c87d81bb7$var$map.tb) unit = 'TB';
        else if (mag >= $1a903f4c87d81bb7$var$map.gb) unit = 'GB';
        else if (mag >= $1a903f4c87d81bb7$var$map.mb) unit = 'MB';
        else if (mag >= $1a903f4c87d81bb7$var$map.kb) unit = 'KB';
        else unit = 'B';
    }
    var val = value / $1a903f4c87d81bb7$var$map[unit.toLowerCase()];
    var str = val.toFixed(decimalPlaces);
    if (!fixedDecimals) str = str.replace($1a903f4c87d81bb7$var$formatDecimalsRegExp, '$1');
    if (thousandsSeparator) str = str.split('.').map(function(s, i) {
        return i === 0 ? s.replace($1a903f4c87d81bb7$var$formatThousandsRegExp, thousandsSeparator) : s;
    }).join('.');
    return str + unitSeparator + unit;
}
/**
 * Parse the string value into an integer in bytes.
 *
 * If no unit is given, it is assumed the value is in bytes.
 *
 * @param {number|string} val
 *
 * @returns {number|null}
 * @public
 */ function $1a903f4c87d81bb7$var$parse(val) {
    if (typeof val === 'number' && !isNaN(val)) return val;
    if (typeof val !== 'string') return null;
    // Test if the string passed is valid
    var results = $1a903f4c87d81bb7$var$parseRegExp.exec(val);
    var floatValue;
    var unit = 'b';
    if (!results) {
        // Nothing could be extracted from the given string
        floatValue = parseInt(val, 10);
        unit = 'b';
    } else {
        // Retrieve the value and the unit
        floatValue = parseFloat(results[1]);
        unit = results[4].toLowerCase();
    }
    if (isNaN(floatValue)) return null;
    return Math.floor($1a903f4c87d81bb7$var$map[unit] * floatValue);
}

});

parcelRegister("41EpJ", function(module, exports) {

$parcel$export(module.exports, "AttachmentsField", () => $a93ac2e91f508810$export$f7c49e57ef98664f);
$parcel$export(module.exports, "default", () => $a93ac2e91f508810$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $a7rgl = parcelRequire("a7rgl");

var $5CSKW = parcelRequire("5CSKW");

var $2PadD = parcelRequire("2PadD");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $3UrQk = parcelRequire("3UrQk");

var $esbfK = parcelRequire("esbfK");

var $72wok = parcelRequire("72wok");

var $9gUgJ = parcelRequire("9gUgJ");

var $ch9En = parcelRequire("ch9En");

var $7jTnu = parcelRequire("7jTnu");

var $2nXHu = parcelRequire("2nXHu");

var $l6KZT = parcelRequire("l6KZT");

var $8D65g = parcelRequire("8D65g");
const $a93ac2e91f508810$export$f7c49e57ef98664f = (props)=>{
    const { mediaUploadContext: mediaUploadContext, onInProgressChange: onInProgressChange, projectId: projectId, fieldId: fieldId = '', fieldProps: { onChange: onChange, value: value, ...fieldProps }, maxAllowedTotalAttachmentsSize: maxAllowedTotalAttachmentsSize, onAttachmentSizeValidation: onAttachmentSizeValidation, dropzoneContainerId: dropzoneContainerId = '', shouldScrollIntoViewOnUploadStart: shouldScrollIntoViewOnUploadStart = false, defaultValue: defaultValue = [], attachmentCustomUploadURL: attachmentCustomUploadURL } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { files: files, onUploadStart: onUploadStart, onUploadError: onUploadError, mediaClientConfig: mediaClientConfig, uploadConfig: uploadConfig, onRemoveFile: onRemoveFile, onUploadEnd: onUploadEnd, isUploading: isUploading, setAttachments: setAttachments, ...resUseAttachments } = (0, $72wok.default)({
        mediaUploadContext: mediaUploadContext,
        projectId: projectId,
        maxAllowedTotalAttachmentsSize: maxAllowedTotalAttachmentsSize,
        onAttachmentSizeValidation: onAttachmentSizeValidation,
        attachmentCustomUploadURL: attachmentCustomUploadURL
    });
    const { isDefaultValueInitialized: isDefaultValueInitialized, setDefaultValueInitialized: setDefaultValueInitialized } = resUseAttachments;
    (0, $eJOHy.useEffect)(()=>{
        // setting DefaultValueInitialized only when receiving default Value to guarantee we will set DefaultValue even if it's loaded with some delay.
        if (defaultValue && Array.isArray(defaultValue) && isDefaultValueInitialized === false) {
            const currentAttachments = [];
            setAttachments(currentAttachments.concat(defaultValue.map((mediaFile)=>({
                    mediaFile: mediaFile,
                    isUploading: false
                }))));
            setDefaultValueInitialized(true);
        }
    }, [
        setAttachments,
        defaultValue,
        isDefaultValueInitialized,
        setDefaultValueInitialized
    ]);
    if ((0, $7jTnu.fg)('gic-attachment-field-with-react18-concurrent-mode')) // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eJOHy.useLayoutEffect)(()=>{
        let shouldCallOnChange = false;
        const isValueAnArray = Array.isArray(value);
        if (isValueAnArray && value.length !== files.length) shouldCallOnChange = true;
        if (!isValueAnArray && files.length) shouldCallOnChange = true;
        if (shouldCallOnChange) onChange(files);
    }, [
        files,
        onChange,
        value
    ]);
    else // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eJOHy.useEffect)(()=>{
        let shouldCallOnChange = false;
        const isValueAnArray = Array.isArray(value);
        if (isValueAnArray && value.length !== files.length) shouldCallOnChange = true;
        if (!isValueAnArray && files.length) shouldCallOnChange = true;
        if (shouldCallOnChange) onChange(files);
    }, [
        files,
        onChange,
        value
    ]);
    // TBD: create a controlled reusable attachment component
    (0, $eJOHy.useEffect)(()=>{
        // @ts-expect-error - TS2339 - Property 'shouldClear' does not exist on type 'FieldValue'.
        if (value && value.shouldClear === true) setAttachments([]);
    }, [
        setAttachments,
        value
    ]);
    (0, $eJOHy.useEffect)(()=>{
        onInProgressChange && onInProgressChange(isUploading);
    }, [
        isUploading,
        onInProgressChange
    ]);
    if (!mediaUploadContext) return null;
    const onAttachmentUploadStart = (uploadStartPayload)=>{
        onUploadStart(uploadStartPayload);
        if (shouldScrollIntoViewOnUploadStart) {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            const fieldElement = document.getElementById((0, $8D65g.getFieldDropZoneContainerID)(fieldId));
            if (fieldElement) (0, $a7rgl.default)(fieldElement, (0, $3UrQk.DEFAULT_SCROLL_OPTIONS));
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a93ac2e91f508810$var$FieldDropzoneContainer, {
        id: (0, $8D65g.getFieldDropZoneContainerID)(fieldId)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a93ac2e91f508810$var$BrowseDropzoneArea, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2PadD))), {
        spacing: "spacious",
        label: "",
        color: "var(--ds-icon, #44546F)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a93ac2e91f508810$var$BrowseDropzoneAreaText, null, `${formatMessage((0, $l6KZT.default).dropzone)}`, "\xa0"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9gUgJ.default), {
        ...fieldProps,
        mediaClientConfig: mediaClientConfig,
        uploadConfig: uploadConfig,
        onUploadError: onUploadError,
        onUploadStart: onAttachmentUploadStart,
        onUploadEnd: onUploadEnd,
        dropzoneContainer: document.getElementById(dropzoneContainerId || (0, $8D65g.getFieldDropZoneContainerID)(fieldId))
    }, ({ setIsBrowserOpen: setIsBrowserOpen })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $a93ac2e91f508810$var$browseButtonStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
            onClick: ()=>setIsBrowserOpen(true),
            "aria-label": formatMessage((0, $l6KZT.default).browseAriaLabel)
        }, formatMessage((0, $l6KZT.default).browse)))))), files.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $a93ac2e91f508810$var$mediaContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "attachments-filmstrip-view",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $esbfK.AsyncAttachmentsFilmstripView), {
        mediaClientConfig: mediaClientConfig,
        files: files,
        onRemoveFile: onRemoveFile,
        collectionName: mediaUploadContext.collection
    }))));
};
var $a93ac2e91f508810$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $2nXHu.withFormField)({
    validator: (0, $8D65g.validateAttachment // @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element | null' is not assignable to parameter of type 'AbstractComponent<ComponentProps<AttachmentFieldConfig, FieldValue>, any>'.
    )
})($a93ac2e91f508810$export$f7c49e57ef98664f);
const $a93ac2e91f508810$var$FieldDropzoneContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_189et94y _1dqogq9o _1h6dmuej _1e0c1txw _1bah1h6o _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp _syaz131l",
            __cmplp.className
        ])
    });
});
const $a93ac2e91f508810$var$mediaContainerStyles = (0, $1DXK0.xcss)({
    marginTop: 'space.050'
});
const $a93ac2e91f508810$var$browseButtonStyles = (0, $1DXK0.xcss)({
    marginLeft: 'space.075'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a93ac2e91f508810$var$BrowseDropzoneArea = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a93ac2e91f508810$var$BrowseDropzoneAreaText = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_18u01b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2PadD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::da6815f1e303f26a4e473874c26eef5d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $20e8457987a4b96b$var$_react = $20e8457987a4b96b$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $20e8457987a4b96b$var$_cloudArrowUp = $20e8457987a4b96b$var$_interopRequireDefault((parcelRequire("bzGVj")));

var $20e8457987a4b96b$var$_upload = $20e8457987a4b96b$var$_interopRequireDefault((parcelRequire("lmcPJ")));
function $20e8457987a4b96b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CloudArrowUpIcon.
 * This component is CloudArrowUpIcon, with `UNSAFE_fallbackIcon` set to "UploadIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: deployments in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $20e8457987a4b96b$var$CloudArrowUpIcon = (props)=>/*#__PURE__*/ $20e8457987a4b96b$var$_react.default.createElement($20e8457987a4b96b$var$_cloudArrowUp.default, Object.assign({
        LEGACY_fallbackIcon: $20e8457987a4b96b$var$_upload.default
    }, props));
$20e8457987a4b96b$var$CloudArrowUpIcon.Name = 'CloudArrowUpIconMigration';
var $20e8457987a4b96b$var$_default = module.exports.default = $20e8457987a4b96b$var$CloudArrowUpIcon;

});
parcelRegister("bzGVj", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7e83f76db2e7ada7e0358014b5e026a9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $86d44242ca1c7b8f$var$_react = $86d44242ca1c7b8f$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $86d44242ca1c7b8f$var$_baseNew = $86d44242ca1c7b8f$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $86d44242ca1c7b8f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CloudArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: deployments in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $86d44242ca1c7b8f$var$CloudArrowUpIcon = (props)=>/*#__PURE__*/ $86d44242ca1c7b8f$var$_react.default.createElement($86d44242ca1c7b8f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 3a4.25 4.25 0 0 0-4.236 3.9.75.75 0 0 1-.565.668A2.251 2.251 0 0 0 3.75 12v1.5a3.75 3.75 0 0 1-1.418-7.222 5.751 5.751 0 0 1 11.239-.458A4 4 0 0 1 12 13.5V12a2.5 2.5 0 0 0 .712-4.897.75.75 0 0 1-.526-.59A4.25 4.25 0 0 0 8 3m0 4a.75.75 0 0 1 .53.22l3 3-1.06 1.06-1.72-1.72V16h-1.5V9.56l-1.72 1.72-1.06-1.06 3-3A.75.75 0 0 1 8 7" clip-rule="evenodd"/>`
    }, props));
$86d44242ca1c7b8f$var$CloudArrowUpIcon.displayName = 'CloudArrowUpIcon';
var $86d44242ca1c7b8f$var$_default = module.exports.default = $86d44242ca1c7b8f$var$CloudArrowUpIcon;

});

parcelRegister("lmcPJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f8c59b79ccf43c2a$var$_react = $f8c59b79ccf43c2a$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $f8c59b79ccf43c2a$var$_cloudArrowUp = $f8c59b79ccf43c2a$var$_interopRequireDefault((parcelRequire("bzGVj")));
function $f8c59b79ccf43c2a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f8c59b79ccf43c2a$var$UploadIcon = (props)=>/*#__PURE__*/ $f8c59b79ccf43c2a$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M11.208 9.32 9.29 11.253a1 1 0 0 0 0 1.409.98.98 0 0 0 1.397 0l1.29-1.301 1.336 1.347a.98.98 0 0 0 1.397.001 1 1 0 0 0 .001-1.408l-1.965-1.98a1.08 1.08 0 0 0-1.538-.001"/><path d="m11 10.007.001 9.986c0 .557.448 1.008 1 1.007.553 0 1-.45 1-1.007L13 10.006C13 9.451 12.552 9 12 9s-1.001.451-1 1.007"/><path d="M7.938 5.481a5 5 0 0 0-.777-.063C4.356 5.419 2 7.62 2 10.499 2 13.408 4.385 16 7.1 16h2.881v-1.993H7.1c-1.657 0-3.115-1.663-3.115-3.508 0-1.778 1.469-3.087 3.104-3.087h.012c.389 0 .686.051.97.15l.17.063c.605.248.875-.246.875-.246l.15-.267c.73-1.347 2.201-2.096 3.716-2.119a4.14 4.14 0 0 1 4.069 3.644l.046.34s.071.525.665.525c.013 0 .012.005.023.005h.254c1.136 0 1.976.959 1.976 2.158 0 1.207-.987 2.342-2.07 2.342h-3.964V16h3.964C20.105 16 22 13.955 22 11.665c0-1.999-1.312-3.663-3.138-4.074-.707-2.707-3.053-4.552-5.886-4.591-1.975.021-3.901.901-5.038 2.481"/></g></svg>`
    }, props, {
        newIcon: $f8c59b79ccf43c2a$var$_cloudArrowUp.default
    }));
$f8c59b79ccf43c2a$var$UploadIcon.displayName = 'UploadIcon';
var $f8c59b79ccf43c2a$var$_default = module.exports.default = $f8c59b79ccf43c2a$var$UploadIcon;

});


parcelRegister("esbfK", function(module, exports) {

$parcel$export(module.exports, "AsyncAttachmentsFilmstripView", () => $467d90b6a25db05a$export$85605b8f3b532b83);

var $bQWwW = parcelRequire("bQWwW");

const $467d90b6a25db05a$export$85605b8f3b532b83 = (0, $bQWwW.lazy)(()=>(parcelRequire("jEsQS")).then((module)=>module.AttachmentsFilmstripView), {
    moduleId: "./src/packages/issue/fields/attachments/src/index.tsx"
});

});
parcelRegister("jEsQS", function(module, exports) {

let $e4e82224acb5a1ea$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $e4e82224acb5a1ea$var$load("1L6rf").then(()=>parcelRequire('3FwQL'));

});


parcelRegister("72wok", function(module, exports) {

$parcel$export(module.exports, "default", () => $cfb72513afaefe49$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $jPROM = parcelRequire("jPROM");

var $dC6sn = parcelRequire("dC6sn");
const $cfb72513afaefe49$var$useAttachments = (attachmentArgs)=>{
    const { mediaUploadContext: mediaUploadContext, projectId: projectId, issueId: issueId, maxAllowedTotalAttachmentsSize: maxAllowedTotalAttachmentsSize, onAttachmentSizeValidation: onAttachmentSizeValidation, attachmentCustomUploadURL: attachmentCustomUploadURL } = attachmentArgs;
    if (!mediaUploadContext) throw new Error('mediaUploadContext is null!');
    const [attachments, setAttachments] = (0, $eJOHy.useState)([]);
    const [files, setFiles] = (0, $eJOHy.useState)([]);
    const [isUploading, setUploading] = (0, $eJOHy.useState)(false);
    const [isDefaultValueInitialized, setDefaultValueInitialized] = (0, $eJOHy.useState)(false);
    const stateRef = (0, $eJOHy.useRef)();
    stateRef.current = files;
    (0, $eJOHy.useEffect)(()=>{
        setFiles(attachments.map((attachment)=>attachment.mediaFile));
        setUploading(attachments.some((attachment)=>attachment.isUploading));
    }, [
        attachments
    ]);
    const mediaClientConfig = (0, $eJOHy.useMemo)(()=>({
            authProvider: ()=>Promise.resolve({
                    baseUrl: mediaUploadContext.serviceHost,
                    clientId: mediaUploadContext.clientId,
                    token: mediaUploadContext.token
                }),
            useSha256ForUploads: true
        }), [
        mediaUploadContext.serviceHost,
        mediaUploadContext.clientId,
        mediaUploadContext.token
    ]);
    const uploadConfig = (0, $eJOHy.useMemo)(()=>({
            uploadParams: {
                collection: mediaUploadContext.collection
            }
        }), [
        mediaUploadContext.collection
    ]);
    const onUploadStart = (0, $eJOHy.useCallback)((uploadStartPayload)=>{
        const currentFiles = stateRef.current ? stateRef.current : [];
        const totalAttachments = [
            ...uploadStartPayload.files,
            ...currentFiles
        ];
        if (maxAllowedTotalAttachmentsSize === undefined || (0, $dC6sn.getAttachmentsSize)(totalAttachments) <= maxAllowedTotalAttachmentsSize) {
            if (onAttachmentSizeValidation) onAttachmentSizeValidation(false);
            setAttachments((currentAttachments)=>currentAttachments.concat(uploadStartPayload.files.map((mediaFile)=>({
                        mediaFile: mediaFile,
                        isUploading: true
                    }))));
        } else if (onAttachmentSizeValidation) onAttachmentSizeValidation(true);
    }, [
        onAttachmentSizeValidation,
        maxAllowedTotalAttachmentsSize
    ]);
    const onUploadError = (0, $eJOHy.useCallback)((uploadError)=>{
        setAttachments((currentAttachments)=>currentAttachments.filter((attachment)=>attachment.mediaFile.id !== uploadError.fileId));
    }, []);
    const onUploadEnd = (0, $eJOHy.useCallback)((uploadEndPayload)=>{
        (async ()=>{
            const mediaFile = uploadEndPayload.file;
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(projectId)) await (0, $dC6sn.copyToAttachment)({
                id: projectId,
                isProjectId: true,
                mediaFile: mediaFile,
                attachmentCustomUploadURL: attachmentCustomUploadURL
            });
            else if (!(0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(issueId)) await (0, $dC6sn.copyToAttachment)({
                id: issueId,
                isProjectId: false,
                mediaFile: mediaFile,
                attachmentCustomUploadURL: attachmentCustomUploadURL
            });
            setAttachments((currentAttachments)=>{
                const isAttachmentPresentInCurrentAttachments = currentAttachments.find((attachment)=>attachment.mediaFile.id === mediaFile.id);
                if (isAttachmentPresentInCurrentAttachments) return currentAttachments.filter((attachment)=>attachment.mediaFile.id !== mediaFile.id).concat([
                    {
                        mediaFile: mediaFile,
                        isUploading: false
                    }
                ]);
                return currentAttachments;
            });
        })();
    }, [
        issueId,
        projectId,
        attachmentCustomUploadURL
    ]);
    const onRemoveFile = (fileToBeRemoved)=>{
        setAttachments((currentAttachments)=>currentAttachments.filter((attachment)=>attachment.mediaFile.id !== fileToBeRemoved.details.id));
        if (onAttachmentSizeValidation) onAttachmentSizeValidation(false);
    };
    return {
        files: files,
        setAttachments: setAttachments,
        onUploadStart: onUploadStart,
        onUploadError: onUploadError,
        mediaClientConfig: mediaClientConfig,
        uploadConfig: uploadConfig,
        onRemoveFile: onRemoveFile,
        onUploadEnd: onUploadEnd,
        isUploading: isUploading,
        isDefaultValueInitialized: isDefaultValueInitialized,
        setDefaultValueInitialized: setDefaultValueInitialized
    };
};
var $cfb72513afaefe49$export$2e2bcd8739ae039 = $cfb72513afaefe49$var$useAttachments;

});
parcelRegister("dC6sn", function(module, exports) {

$parcel$export(module.exports, "copyToAttachment", () => $4bdbd44daf725251$export$b9a44fdbc3de4b85);
$parcel$export(module.exports, "getAttachmentsSize", () => $4bdbd44daf725251$export$ed1597b81cfdb5f6);

var $jGzN3 = parcelRequire("jGzN3");
const $4bdbd44daf725251$export$a7455b0d8bb5c44e = (projectId)=>`/rest/api/2/attachment/upload/project/${projectId}`;
const $4bdbd44daf725251$export$cf1f2654bf86294f = (issueId)=>`/rest/api/2/attachment/upload/issue/${issueId}`;
const $4bdbd44daf725251$export$b9a44fdbc3de4b85 = async (props)=>{
    const { id: id, mediaFile: mediaFile, isProjectId: isProjectId, attachmentCustomUploadURL: attachmentCustomUploadURL } = props;
    const { attachmentId: attachmentId } = await (0, $jGzN3.performPostRequest)(attachmentCustomUploadURL || (isProjectId ? $4bdbd44daf725251$export$a7455b0d8bb5c44e(id) : $4bdbd44daf725251$export$cf1f2654bf86294f(id)), {
        body: JSON.stringify({
            fileId: mediaFile.id
        })
    });
    return attachmentId;
};
const $4bdbd44daf725251$export$ed1597b81cfdb5f6 = (files)=>files.reduce((attachmentsSize, attachment)=>attachmentsSize + attachment.size, 0);

});


parcelRegister("9gUgJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d37df20b61d2b599$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $g5q5z = parcelRequire("g5q5z");
var $2aSHS = parcelRequire("2aSHS");

var $aw7mB = parcelRequire("aw7mB");

var $7jTnu = parcelRequire("7jTnu");
const $d37df20b61d2b599$var$AttachmentsUpload = (props)=>{
    const [isBrowserOpen, setIsBrowserOpen] = (0, $eJOHy.useState)(false);
    const { dropzoneContainer: dropzoneContainer, onUploadStart: onUploadStart, onUploadError: onUploadError, mediaClientConfig: mediaClientConfig, uploadConfig: uploadConfig, onUploadEnd: onUploadEnd, children: renderPropFn } = props;
    // Force remount of media picker components when mediaClientConfig changes
    // This is needed because Browser/Dropzone/Clipboard components don't update their mediaClient on re-render
    // Only enable this behavior when token refresh feature gate is enabled
    const [mediaConfigRefreshCount, setMediaConfigRefreshCount] = (0, $eJOHy.useState)(0);
    (0, $eJOHy.useEffect)(()=>{
        if ((0, $7jTnu.fg)('gic-attachment-media-token-refresh')) setMediaConfigRefreshCount((prev)=>prev + 1);
    }, [
        mediaClientConfig
    ]);
    const dropzoneConfig = {
        ...uploadConfig
    };
    const browserConfig = {
        ...uploadConfig,
        multiple: true
    };
    const clipboardConfig = {
        ...uploadConfig
    };
    if (dropzoneContainer) dropzoneConfig.container = dropzoneContainer;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $g5q5z.BrowserLoader), {
        isOpen: isBrowserOpen,
        config: browserConfig,
        mediaClientConfig: mediaClientConfig,
        onUploadsStart: onUploadStart,
        onError: onUploadError,
        onEnd: onUploadEnd,
        onClose: ()=>setIsBrowserOpen(false),
        key: (0, $7jTnu.fg)('gic-attachment-media-token-refresh') ? `browser-${mediaConfigRefreshCount}` : 'browser'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2aSHS.DropzoneLoader), {
        mediaClientConfig: mediaClientConfig,
        config: dropzoneConfig,
        onUploadsStart: onUploadStart,
        onEnd: onUploadEnd,
        key: (0, $7jTnu.fg)('gic-attachment-media-token-refresh') ? `dropzone-${mediaConfigRefreshCount}` : 'dropzone'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aw7mB.Clipboard), {
        mediaClientConfig: mediaClientConfig,
        config: clipboardConfig,
        onUploadsStart: onUploadStart,
        onEnd: onUploadEnd,
        isolated: false,
        key: (0, $7jTnu.fg)('gic-attachment-media-token-refresh') ? `clipboard-${mediaConfigRefreshCount}` : 'clipboard'
    }), renderPropFn({
        setIsBrowserOpen: setIsBrowserOpen
    }));
};
var $d37df20b61d2b599$export$2e2bcd8739ae039 = $d37df20b61d2b599$var$AttachmentsUpload;

});
parcelRegister("g5q5z", function(module, exports) {

$parcel$export(module.exports, "BrowserLoader", () => $d7a553d925749fa5$export$3ce634ac4a869e2c);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");


class $d7a553d925749fa5$export$3ce634ac4a869e2c extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).PureComponent {
    static{
        this.displayName = 'AsyncBrowser';
    }
    componentDidMount() {
        this.mounted = true;
    }
    componentWillUnmount() {
        this.mounted = false;
    }
    async UNSAFE_componentWillMount() {
        if (!this.state.Browser) {
            const [mediaClient, browserModule] = await Promise.all([
                (parcelRequire("9aJ0Y")),
                (parcelRequire("8ki2g"))
            ]);
            // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
            $d7a553d925749fa5$export$3ce634ac4a869e2c.Browser = mediaClient.withMediaClient(browserModule.Browser);
            if (this.mounted) this.setState({
                Browser: $d7a553d925749fa5$export$3ce634ac4a869e2c.Browser
            });
        }
    }
    render() {
        if (!this.state.Browser) return null;
        return /*#__PURE__*/ (0, $gt9Am.jsx)(this.state.Browser, {
            ...this.props
        });
    }
    constructor(...args){
        super(...args), this.mounted = false, this.state = {
            Browser: $d7a553d925749fa5$export$3ce634ac4a869e2c.Browser
        };
    }
}

});
parcelRegister("9aJ0Y", function(module, exports) {

let $6ad7f73c1d418af0$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $6ad7f73c1d418af0$var$load("lrf77").then(()=>parcelRequire('bJDDe'));

});

parcelRegister("8ki2g", function(module, exports) {

let $60fe2e7718be8fd1$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $60fe2e7718be8fd1$var$load("ffQaD"),
    $60fe2e7718be8fd1$var$load("kvRbA"),
    $60fe2e7718be8fd1$var$load("fkMdp")
]).then(()=>parcelRequire('1q8gp'));

});


parcelRegister("2aSHS", function(module, exports) {

$parcel$export(module.exports, "DropzoneLoader", () => $6161634676269dd9$export$66201d263cd6342);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");



class $6161634676269dd9$export$66201d263cd6342 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).PureComponent {
    static{
        this.displayName = 'AsyncDropzone';
    }
    async UNSAFE_componentWillMount() {
        if (!this.state.Dropzone || !this.state.MediaPickerErrorBoundary) try {
            const [mediaClient, dropzoneModule, mediaPickerErrorBoundaryModule] = await Promise.all([
                (parcelRequire("9aJ0Y")),
                (parcelRequire("iMltD")),
                (parcelRequire("fU3A0"))
            ]);
            // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
            $6161634676269dd9$export$66201d263cd6342.Dropzone = mediaClient.withMediaClient(dropzoneModule.Dropzone);
            $6161634676269dd9$export$66201d263cd6342.MediaPickerErrorBoundary = mediaPickerErrorBoundaryModule.default;
            this.setState({
                Dropzone: $6161634676269dd9$export$66201d263cd6342.Dropzone,
                MediaPickerErrorBoundary: $6161634676269dd9$export$66201d263cd6342.MediaPickerErrorBoundary
            });
        } catch (error) {
        // TODO [MS-2272]: Add operational error to catch async import error
        }
    }
    render() {
        const { Dropzone: Dropzone, MediaPickerErrorBoundary: MediaPickerErrorBoundary } = this.state;
        if (!Dropzone || !MediaPickerErrorBoundary) return null;
        return /*#__PURE__*/ (0, $gt9Am.jsx)(MediaPickerErrorBoundary, {
            children: /*#__PURE__*/ (0, $gt9Am.jsx)(Dropzone, {
                ...this.props
            })
        });
    }
    constructor(...args){
        super(...args), this.state = {
            Dropzone: $6161634676269dd9$export$66201d263cd6342.Dropzone,
            MediaPickerErrorBoundary: $6161634676269dd9$export$66201d263cd6342.MediaPickerErrorBoundary
        };
    }
}

});
parcelRegister("iMltD", function(module, exports) {

let $dabd5e986856287c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $dabd5e986856287c$var$load("ffQaD"),
    $dabd5e986856287c$var$load("kvRbA"),
    $dabd5e986856287c$var$load("890pK")
]).then(()=>parcelRequire('a2EQ7'));

});

parcelRegister("fU3A0", function(module, exports) {

let $b93edcdd6355c4eb$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $b93edcdd6355c4eb$var$load("kNFvF"),
    $b93edcdd6355c4eb$var$load("6Rih1")
]).then(()=>parcelRequire('aCUUP'));

});


parcelRegister("aw7mB", function(module, exports) {

$parcel$export(module.exports, "Clipboard", () => $4ea0e77ad8d5829d$export$8b44c43c7d8f0830);

var $eJOHy = parcelRequire("eJOHy");

var $1tMM9 = parcelRequire("1tMM9");

var $k4xkV = parcelRequire("k4xkV");
const $4ea0e77ad8d5829d$export$7b1ba4955557a858 = ()=>null;
const $4ea0e77ad8d5829d$export$8b44c43c7d8f0830 = ({ config: config, isolated: isolated, ...props })=>{
    const container = (0, $k4xkV.useClipboardContextBoundary)();
    const onPaste = (0, $eJOHy.useCallback)((event)=>{
        // do not propagate event above container boundary
        event.stopPropagation();
        // preventing default will disable any copy-paste
        // event.preventDefault();
        // false means "allow"
        return false;
    }, []);
    const derivedConfig = (0, $eJOHy.useMemo)(()=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        container ? {
            ...config,
            container: container,
            onPaste: onPaste
        } : config, [
        config,
        container,
        onPaste
    ]);
    if (!container && isolated !== false) // hard block clipboard if boundary is not set
    // render "marker" to ease testing
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4ea0e77ad8d5829d$export$7b1ba4955557a858, null);
    // Here there is a good opportunity to report own existence to the boundary to prevent two Clipboards from being active at the same node
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1tMM9.ClipboardLoader), {
        ...props,
        config: derivedConfig
    });
};

});
parcelRegister("1tMM9", function(module, exports) {

$parcel$export(module.exports, "ClipboardLoader", () => $9028b917b600d17c$export$d7936799bf32b554);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");


class $9028b917b600d17c$export$d7936799bf32b554 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).PureComponent {
    static{
        this.displayName = 'AsyncClipboard';
    }
    async UNSAFE_componentWillMount() {
        if (!this.state.Clipboard) {
            const [mediaClient, clipboardModule] = await Promise.all([
                (parcelRequire("9aJ0Y")),
                (parcelRequire("9Keg7"))
            ]);
            // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
            $9028b917b600d17c$export$d7936799bf32b554.Clipboard = mediaClient.withMediaClient(clipboardModule.Clipboard);
            this.setState({
                Clipboard: $9028b917b600d17c$export$d7936799bf32b554.Clipboard
            });
        }
    }
    render() {
        if (!this.state.Clipboard) return null;
        return /*#__PURE__*/ (0, $gt9Am.jsx)(this.state.Clipboard, {
            ...this.props
        });
    }
    constructor(...args){
        super(...args), this.state = {
            Clipboard: $9028b917b600d17c$export$d7936799bf32b554.Clipboard
        };
    }
}

});
parcelRegister("9Keg7", function(module, exports) {

let $71837879db29194c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $71837879db29194c$var$load("gwqaI").then(()=>parcelRequire('gx7xU'));

});


parcelRegister("k4xkV", function(module, exports) {

$parcel$export(module.exports, "ClipboardStoreContainer", () => $a2a16f508c7a10ff$export$c4bc9440a978eec1);
$parcel$export(module.exports, "useClipboardContextActions", () => $a2a16f508c7a10ff$export$a3e41c5b3d4c30b7);
$parcel$export(module.exports, "useClipboardContextBoundary", () => $a2a16f508c7a10ff$export$37046969a30ae0a0);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");
const $a2a16f508c7a10ff$var$ClipboardStore = (0, $GtRbT.createStore)({
    name: 'clipboard-store',
    // using containedBy will break all "unscoped" locations. We dont want it for now
    // containedBy: ClipboardStoreContainer,
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    initialState: {
        boundary: null
    },
    actions: {
        setClipBoardContext: (boundary)=>({ setState: setState })=>{
                setState({
                    boundary: boundary
                });
            }
    }
});
const $a2a16f508c7a10ff$export$c4bc9440a978eec1 = (0, $6E16M.createContainer)($a2a16f508c7a10ff$var$ClipboardStore);
const $a2a16f508c7a10ff$export$a3e41c5b3d4c30b7 = (0, $iJq0l.createActionsHook)($a2a16f508c7a10ff$var$ClipboardStore);
const $a2a16f508c7a10ff$var$useClipboardContextBoundarySelector = (0, $iJq0l.createHook)($a2a16f508c7a10ff$var$ClipboardStore, {
    selector: (state)=>state.boundary
});
const $a2a16f508c7a10ff$export$37046969a30ae0a0 = ()=>$a2a16f508c7a10ff$var$useClipboardContextBoundarySelector()[0];

});



parcelRegister("l6KZT", function(module, exports) {

$parcel$export(module.exports, "default", () => $a55aba019e9c9c8e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $a55aba019e9c9c8e$var$messages = (0, $7qGN1.defineMessages)({
    dropzone: {
        "id": "issue-create-commons.attachments-field.dropzone",
        "defaultMessage": "Drop files to attach or"
    },
    browse: {
        "id": "issue-create-commons.attachments-field.browse",
        "defaultMessage": "Browse"
    },
    browseAriaLabel: {
        "id": "issue-create-commons.attachments-field.browse-aria-label",
        "defaultMessage": "Browse attachment"
    },
    missingToken: {
        "id": "issue-create-commons.attachments-field.missing-token",
        "defaultMessage": "Something went wrong"
    }
});
var $a55aba019e9c9c8e$export$2e2bcd8739ae039 = $a55aba019e9c9c8e$var$messages;

});


parcelRegister("fIw44", function(module, exports) {

$parcel$export(module.exports, "MinimizableModalProvider", () => $2d1c378317c790b5$export$582a26efcd805dfd);
$parcel$export(module.exports, "useMinimizableModal", () => $2d1c378317c790b5$export$40bb90ec193b1c2f);

var $eJOHy = parcelRequire("eJOHy");

var $kk5YU = parcelRequire("kk5YU");

var $dIu0P = parcelRequire("dIu0P");

var $4l3UO = parcelRequire("4l3UO");
const $2d1c378317c790b5$export$a9554de703151814 = /*#__PURE__*/ (0, $eJOHy.createContext)({
    shouldFocusChanger: false,
    view: 'modal',
    previousView: 'modal',
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setView: ()=>{},
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    unminimizeModal: ()=>{},
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onClose: ()=>{},
    transitionByKeyboardFrom: null,
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setTransitionByKeyboardFrom: ()=>{},
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setShouldFocusChanger: ()=>{},
    isTransitionInState: ()=>false,
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setTransitionState: ()=>{},
    shouldDisableViewChangerButtons: false,
    customDisabledViewChangerButtonsMessage: '',
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setShouldDisableViewChangerButtons: ()=>{},
    isNestedModal: false,
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setIsNestedModal: ()=>{},
    displayMinimizableButtons: true
});
const $2d1c378317c790b5$export$582a26efcd805dfd = ({ initialView: initialView = 'modal', view: view, onViewChange: onViewChange, onClose: onClose, children: children, displayMinimizableButtons: displayMinimizableButtons = true })=>{
    /**
	 * When view is passed in as a prop, this modal is controlled
	 * When it is not passed in, _view is used to handle the view changes when the modal is uncontrolled
	 * actualView is the view that we are displaying
	 * previousView is the previously displayed view (so that minimized knows what view to expand to)
	 */ const [_view, _setView] = (0, $eJOHy.useState)(view || initialView);
    const actualView = (0, $eJOHy.useMemo)(()=>view || _view, [
        view,
        _view
    ]);
    const previousView = (0, $4l3UO.usePrevious)(actualView, [
        'minimized'
    ]);
    const [modalState, setModalState] = (0, $eJOHy.useState)((0, $dIu0P.TransitionState).EXITED);
    const [miniState, setMiniState] = (0, $eJOHy.useState)((0, $dIu0P.TransitionState).EXITED);
    const [minimizedState, setMinimizedState] = (0, $eJOHy.useState)((0, $dIu0P.TransitionState).EXITED);
    const [fullscreenState, setFullscreenState] = (0, $eJOHy.useState)((0, $dIu0P.TransitionState).EXITED);
    const [_shouldDisableViewChangerButtons, _setShouldDisableViewChangerButtons] = (0, $eJOHy.useState)(false);
    const [_customDisabledViewChangerButtonsMessage, _setCustomDisabledViewChangerButtonsMessage] = (0, $eJOHy.useState)('');
    const [isNestedModal, setIsNestedModal] = (0, $eJOHy.useState)(false);
    const transitionByKeyboardFrom = (0, $eJOHy.useRef)(null);
    const shouldFocusChanger = (0, $eJOHy.useRef)(false);
    const currentTransitionState = (0, $eJOHy.useMemo)(()=>({
            modal: modalState,
            mini: miniState,
            minimized: minimizedState,
            fullscreen: fullscreenState
        }), [
        modalState,
        miniState,
        minimizedState,
        fullscreenState
    ]);
    /**
	 * Will always return true if OS reduced motion is turned on since all usages of isTransitionInState
	 * are checking for a transition to be done before doing something
	 * With reduced motion its easiest to assume that the transition is always done since there are no transitions
	 */ const isTransitionInState = (0, $eJOHy.useCallback)((viewsTransitioning, state, fallbackForReducedMotion = true)=>{
        if ((0, $kk5YU.isReducedMotion)()) return fallbackForReducedMotion;
        return viewsTransitioning.every((viewTransitioning)=>currentTransitionState[viewTransitioning] === state);
    }, [
        currentTransitionState
    ]);
    const setTransitionState = (0, $eJOHy.useCallback)((viewTransitioning, state)=>{
        if (viewTransitioning === 'modal') setModalState(state);
        if (viewTransitioning === 'mini') setMiniState(state);
        if (viewTransitioning === 'minimized') setMinimizedState(state);
        if (viewTransitioning === 'fullscreen') setFullscreenState(state);
    }, []);
    const setShouldFocusChanger = (hasTransitioned)=>{
        shouldFocusChanger.current = hasTransitioned;
    };
    const setView = (0, $eJOHy.useCallback)((newView, force = false)=>{
        if (_shouldDisableViewChangerButtons && !force) return;
        if (view) {
            if (onViewChange) onViewChange(newView);
            return;
        }
        _setView(newView);
    }, [
        _shouldDisableViewChangerButtons,
        onViewChange,
        view
    ]);
    const unminimizeModal = (0, $eJOHy.useCallback)((fallbackView)=>{
        // For the case where the user controls the view of the minimizable modal, and starts it as 'minimized'
        if (previousView === 'minimized') {
            setView(fallbackView);
            return;
        }
        setView(previousView);
    }, [
        setView,
        previousView
    ]);
    const setTransitionByKeyboardFrom = (0, $eJOHy.useCallback)((keyPressedFrom)=>{
        transitionByKeyboardFrom.current = keyPressedFrom;
    }, []);
    const setShouldDisableViewChangerButtons = (0, $eJOHy.useCallback)((shouldDisableViewChangerButtons, customDisabledViewChangerButtonsMessage = '')=>{
        _setShouldDisableViewChangerButtons(shouldDisableViewChangerButtons);
        _setCustomDisabledViewChangerButtonsMessage(customDisabledViewChangerButtonsMessage);
    }, []);
    const context = (0, $eJOHy.useMemo)(()=>({
            shouldFocusChanger: shouldFocusChanger.current,
            view: actualView,
            setView: setView,
            previousView: previousView,
            onClose: onClose,
            unminimizeModal: unminimizeModal,
            transitionByKeyboardFrom: transitionByKeyboardFrom.current,
            setTransitionByKeyboardFrom: setTransitionByKeyboardFrom,
            setShouldFocusChanger: setShouldFocusChanger,
            isTransitionInState: isTransitionInState,
            setTransitionState: setTransitionState,
            shouldDisableViewChangerButtons: _shouldDisableViewChangerButtons,
            customDisabledViewChangerButtonsMessage: _customDisabledViewChangerButtonsMessage,
            setShouldDisableViewChangerButtons: setShouldDisableViewChangerButtons,
            isNestedModal: isNestedModal,
            setIsNestedModal: setIsNestedModal,
            displayMinimizableButtons: displayMinimizableButtons
        }), [
        _customDisabledViewChangerButtonsMessage,
        _shouldDisableViewChangerButtons,
        actualView,
        isNestedModal,
        isTransitionInState,
        onClose,
        previousView,
        setShouldDisableViewChangerButtons,
        setTransitionByKeyboardFrom,
        setTransitionState,
        setView,
        unminimizeModal,
        displayMinimizableButtons
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2d1c378317c790b5$export$a9554de703151814.Provider, {
        value: context
    }, children);
};
const $2d1c378317c790b5$export$40bb90ec193b1c2f = ()=>{
    const context = (0, $eJOHy.useContext)($2d1c378317c790b5$export$a9554de703151814);
    if (context === undefined) throw new Error('useMinimizableModal must be used within a MinimizableModalProvider');
    return context;
};

});
parcelRegister("dIu0P", function(module, exports) {

$parcel$export(module.exports, "TransitionState", () => $d17ec6492462dcd3$export$145c1ed87b1a2216);
const $d17ec6492462dcd3$export$145c1ed87b1a2216 = {
    EXITED: 1,
    ENTERED: 2,
    TRANSITIONING: 3
};

});

parcelRegister("4l3UO", function(module, exports) {

$parcel$export(module.exports, "usePrevious", () => $15996c6850f8dfb5$export$5cae361ad82dce8b);

var $eJOHy = parcelRequire("eJOHy");
function $15996c6850f8dfb5$export$5cae361ad82dce8b(value, ignoreValues) {
    const ref = (0, $eJOHy.useRef)(value);
    (0, $eJOHy.useEffect)(()=>{
        if (ref.current !== value && !ignoreValues.includes(value)) ref.current = value;
    }, [
        value,
        ignoreValues
    ]);
    return ref.current;
}

});


parcelRegister("6Wki2", function(module, exports) {

$parcel$export(module.exports, "useRefetchMediaTokenOnExpired", () => $1daf95ddc9229eeb$export$3bb150837881f171);

var $eJOHy = parcelRequire("eJOHy");
const $1daf95ddc9229eeb$export$3bb150837881f171 = ({ mediaToken: mediaToken, refetch: refetch, shouldWaitUntilBrowserActive: shouldWaitUntilBrowserActive })=>{
    const timerRef = (0, $eJOHy.useRef)(null);
    const expiration = (0, $eJOHy.useMemo)(()=>{
        try {
            if (!mediaToken) return null;
            return JSON.parse(atob(mediaToken.split('.')[1])).exp;
        } catch (err) {
            // noop
            return null;
        }
    }, [
        mediaToken
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!expiration) {
            if (timerRef.current) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.clearTimeout(timerRef.current);
            return;
        }
        const expirationDate = new Date(expiration * 1000);
        // extra 2 seconds to account for network latency
        const expirationTimeout = expirationDate.getTime() - Date.now() - 2000;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        timerRef.current = window.setTimeout(()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            if (shouldWaitUntilBrowserActive && document.visibilityState !== 'visible') {
                const handleVisibilityChange = ()=>{
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    if (document.visibilityState === 'visible') {
                        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                        document.removeEventListener('visibilitychange', handleVisibilityChange);
                        refetch();
                    }
                };
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                document.addEventListener('visibilitychange', handleVisibilityChange);
                return;
            }
            refetch();
        }, expirationTimeout);
        return ()=>{
            if (timerRef.current) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.clearTimeout(timerRef.current);
        };
    }, [
        expiration,
        refetch,
        shouldWaitUntilBrowserActive
    ]);
};

});

parcelRegister("7xKYD", function(module, exports) {

$parcel$export(module.exports, "useUploadPermissions", () => $64ff0c4ed65edfed$export$9fc4bf889c7dbfba);

var $eJOHy = parcelRequire("eJOHy");

var $jGzN3 = parcelRequire("jGzN3");

var $iadOE = parcelRequire("iadOE");
const $64ff0c4ed65edfed$export$9fc4bf889c7dbfba = ()=>{
    const [isUploadPermissionFetching, setIsUploadPermissionFetching] = (0, $eJOHy.useState)(false);
    const [uploadPermissions, setUploadPermissions] = (0, $eJOHy.useState)(null);
    const fetchUploadPermissions = (0, $eJOHy.useCallback)(async (projectId, uploadCollectionType)=>{
        setIsUploadPermissionFetching(true);
        const permissionUrl = uploadCollectionType === 'project-collection' ? (0, $iadOE.getAttachmentsFieldCollectionUrl)(projectId) : (0, $iadOE.getMediaUploadPermissionUrl)(projectId);
        try {
            const uploadResponse = await (0, $jGzN3.performGetRequest)(permissionUrl);
            setUploadPermissions({
                clientId: uploadResponse.clientId,
                serviceHost: uploadResponse.endpointUrl,
                token: uploadResponse.token,
                tokenLifespanInMs: uploadResponse.tokenDurationInMins * 60000,
                collection: uploadResponse.targetCollection,
                tokenIssueTimestamp: Date.now() - 10000
            });
            setIsUploadPermissionFetching(false);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setIsUploadPermissionFetching(false);
            throw new Error(err);
        }
    }, []);
    return [
        isUploadPermissionFetching,
        uploadPermissions,
        fetchUploadPermissions
    ];
};

});
parcelRegister("iadOE", function(module, exports) {

$parcel$export(module.exports, "getMediaUploadPermissionUrl", () => $6181f0774c211b79$export$9f4e6a02a32c7984);
$parcel$export(module.exports, "getAttachmentsFieldCollectionUrl", () => $6181f0774c211b79$export$36853b1bae07716a);
const $6181f0774c211b79$export$9f4e6a02a32c7984 = (projectId)=>`/rest/api/3/attachment/upload/issue/credentials/adf?projectIdOrKey=${projectId}`;
const $6181f0774c211b79$export$36853b1bae07716a = (projectId)=>`/rest/api/latest/attachment/upload/project/${projectId}/credentials`;

});


parcelRegister("f5Bz9", function(module, exports) {

$parcel$export(module.exports, "default", () => $5552c9cd8b83888a$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $5552c9cd8b83888a$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    missingToken: {
        "id": "issue-create.common.fields.attachments-field.missing-token",
        "defaultMessage": "Something went wrong"
    },
    attachmentSizeLimitCheck: {
        "id": "issue-create.common.fields.attachments-field.attachment-size-limit-check",
        "defaultMessage": "We couldn\u2019t upload the attachment as you\u2019ve exceeded the limit"
    }
});

});


parcelRegister("lUlE5", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a48f28c301224c7$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $jFHCE = parcelRequire("jFHCE");

var $gRw8I = parcelRequire("gRw8I");

var $foxSH = parcelRequire("foxSH");

var $9A8Wt = parcelRequire("9A8Wt");

var $dPMMf = parcelRequire("dPMMf");

var $fE4zR = parcelRequire("fE4zR");

var $2nXHu = parcelRequire("2nXHu");

var $bzMDD = parcelRequire("bzMDD");

var $c0I4e = parcelRequire("c0I4e");

var $ch9En = parcelRequire("ch9En");

var $gsFUG = parcelRequire("gsFUG");

var $g9Vr6 = parcelRequire("g9Vr6");

var $ljej9 = parcelRequire("ljej9");

var $8q7lT = parcelRequire("8q7lT");

var $kEUB1 = parcelRequire("kEUB1");

var $egdl2 = parcelRequire("egdl2");

var $5D4DO = parcelRequire("5D4DO");

var $7jTnu = parcelRequire("7jTnu");

var $epTsa = parcelRequire("epTsa");

var $dNlYM = parcelRequire("dNlYM");

var $lRq8t = parcelRequire("lRq8t");

var $6u3jg = parcelRequire("6u3jg");

var $7OfzM = parcelRequire("7OfzM");

var $hZyII = parcelRequire("hZyII");

const $2a48f28c301224c7$var$skeletonHeight = `${(0, $dPMMf.gridSize) * 18.75}px`;
const $2a48f28c301224c7$var$PRINCIPAL_ID = 'context'; /**
                                 * We use the same DescriptionField component for all fields of "paragraph" type, including custom fields
                                 * This constant is for the default issue description field name
                                 */ 
const $2a48f28c301224c7$var$DESCRIPTION_FIELD_DEFAULT_FIELD_NAME = 'Description';
const $2a48f28c301224c7$var$DESCRIPTION_FIELD_EXPERIENCE = 'GIC';
const $2a48f28c301224c7$export$336230c809f2ec53 = (props)=>{
    (0, $gRw8I.di)(window);
    const { width: width = '100%', fieldProps: { value: value, onChange: onChange, onBlur: onBlur }, selectedProject: selectedProject, defaultValue: defaultValue, additionalData: additionalData, fieldName: fieldName, autoFocus: autoFocus = false, isReadOnly: isReadOnly = false, selectedIssueType: selectedIssueType, getFormState: getFormState } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { data: orgId } = (0, $g9Vr6.useOrgId)();
    const cloudId = (0, $kEUB1.useCloudId)();
    const loggedInUserAccountId = (0, $8q7lT.useAccountId)();
    const isGICPositioningEnabled = (0, $6u3jg.useIsGICPositioningEnabled)();
    // TODO Add this field with the fields on previous line when cleaning FF
    // @ts-expect-error - TS2525 - Initializer provides no value for this binding element and the binding element has no default value. | TS2525 - Initializer provides no value for this binding element and the binding element has no default value.
    const { onFocus: onFocusField, onBlur: onBlurField } = isGICPositioningEnabled() ? props : {};
    const { mediaContext: mediaContext, adminRichTextConfig: adminRichTextConfig } = additionalData;
    let mediaUploadContext;
    const uploadToken = mediaContext?.uploadToken;
    if (uploadToken) mediaUploadContext = {
        clientId: uploadToken.clientId,
        serviceHost: uploadToken.endpointUrl,
        collection: uploadToken.targetCollection,
        token: uploadToken.token
    };
    const [editorApi, setEditorApi] = (0, $eJOHy.useState)();
    const product = (0, $gsFUG.getProductForEditorAIPlugin)(selectedProject?.projectType);
    const issueTypeLabel = selectedIssueType?.label?.toLowerCase();
    const allowIssueReformatter = (0, $eJOHy.useMemo)(()=>fieldName === $2a48f28c301224c7$var$DESCRIPTION_FIELD_DEFAULT_FIELD_NAME, [
        fieldName
    ]);
    const productConfig = (0, $eJOHy.useMemo)(()=>({
            product: 'jira',
            cloudId: cloudId
        }), [
        cloudId
    ]);
    const linkPicker = (0, $egdl2.useLinkPickerEditorProps)(undefined, productConfig);
    const descriptionValue = value && typeof value === 'object' && 'type' in value ? value : undefined;
    const extractedLinksRef = (0, $7jTnu.fg)('gravityai-2132-extract-links-issue-reformatter') ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5D4DO.useExtractedLinksRef)(descriptionValue) : undefined;
    const editorPluginAIConfig = (0, $eJOHy.useMemo)(()=>({
            editorPluginAIConfig: {
                product: product,
                isAiOptInEnabled: !!adminRichTextConfig?.aiEnabledByProject,
                allowIssueReformatter: // For more context about allowIssueReformatter option, please refer to this PR: https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/91592/overview
                allowIssueReformatter,
                getAdditionalProps: ()=>{
                    const linkedUrls = extractedLinksRef?.current?.(); // Replace if condition with the FF cleanup of gravityai-2132-extract-links-issue-reformatter
                    if (linkedUrls) return {
                        issue_type_label: issueTypeLabel,
                        issue_summary: getFormState?.()?.values.summary || '',
                        linked_urls: linkedUrls
                    };
                    return {
                        issue_type_label: issueTypeLabel,
                        issue_summary: getFormState?.()?.values.summary || ''
                    };
                },
                aiLifeCycleDynamicAttributesGetter: ()=>({
                        issueTypeLabel: issueTypeLabel || ''
                    }),
                linking: linkPicker ? {
                    linkPicker: linkPicker,
                    smartLinks: {
                        provider: Promise.resolve(new (0, $foxSH.EditorCardProvider)())
                    }
                } : undefined,
                getChannelVariables: (purpose)=>{
                    if (purpose === 'rovo-agent') {
                        if (typeof cloudId === 'string' && typeof loggedInUserAccountId === 'string') return {
                            cloudId: cloudId,
                            userId: loggedInUserAccountId,
                            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                            contentURL: window.location.origin + window.location.pathname
                        };
                    }
                    return null;
                },
                actionSideEffects: {
                    continueInChat: ()=>{
                        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                        const dockButton = document.getElementById('minimizable-modal.ui.modal-container.modal-header.mini-button');
                        dockButton?.click?.();
                    }
                }
            }
        }), [
        product,
        adminRichTextConfig?.aiEnabledByProject,
        allowIssueReformatter,
        linkPicker,
        issueTypeLabel,
        getFormState,
        cloudId,
        loggedInUserAccountId,
        extractedLinksRef
    ]);
    const editorConfig = (0, $gsFUG.useEditorConfig)(editorPluginAIConfig);
    const mentionProvider = (0, $eJOHy.useRef)(new (0, $c0I4e.UserTeamProjectMentionProviderWithResolverMentionName)({
        projectKey: (0, $ljej9.toProjectKey)(`${selectedProject?.projectKey || ''}`),
        projectType: selectedProject?.projectType
    }, {
        userId: $2a48f28c301224c7$var$PRINCIPAL_ID,
        cloudId: cloudId,
        orgId: orgId
    }));
    const editorKey = (0, $eJOHy.useRef)(Date.now());
    const mediaProvider = {
        viewContext: mediaUploadContext,
        uploadContext: mediaUploadContext
    };
    let actualValue = defaultValue; // We are force resetting the editor using key as we could not achieve using EditorActions.replaceDocument or clear
    // We tried to pass down ref to the DescriptionEdit component and call the replaceDocument from here. Which did not work.
    // If we find a better way to achieve this, this code inside should be replaced.
    (0, $7jTnu.fg)('fix-gic-concurrent-rendering') ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eJOHy.useLayoutEffect)(()=>{
        // @ts-expect-error - TS2339 - Property 'resetRequired' does not exist on type 'DocNode | ResetDescriptionValue | OverrideDescriptionValue'.
        if (value?.resetRequired === true) {
            editorKey.current = Date.now(); // @ts-expect-error - TS2322 - Type 'Pick<DocNode | ResetDescriptionValue | OverrideDescriptionValue, never> | undefined' is not assignable to type 'FieldValue'.
            onChange((0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(value, 'resetRequired'));
        }
    }, [
        defaultValue,
        onChange,
        value
    ]) : // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eJOHy.useEffect)(()=>{
        // @ts-expect-error - TS2339 - Property 'resetRequired' does not exist on type 'DocNode | ResetDescriptionValue | OverrideDescriptionValue'.
        if (value?.resetRequired === true) {
            editorKey.current = Date.now(); // @ts-expect-error - TS2322 - Type 'Pick<DocNode | ResetDescriptionValue | OverrideDescriptionValue, never> | undefined' is not assignable to type 'FieldValue'.
            onChange((0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(value, 'resetRequired'));
        }
    }, [
        defaultValue,
        onChange,
        value
    ]); // This is a similar hack to the one you see above for the case when we don't want to reset the editor to the
    // initial value but instead override the existing one with new one. It's needed for UI modifications setValue to work.
    // As above: once a better way is found, this code should be replaced.
    // UNBOX-505
    // @ts-expect-error - TS2339 - Property 'overrideRequired' does not exist on type 'DocNode | ResetDescriptionValue | OverrideDescriptionValue'.
    const overrideRequired = value?.overrideRequired || false; // @ts-expect-error - TS2322 - Type 'Pick<DocNode | ResetDescriptionValue | OverrideDescriptionValue, never> | undefined' is not assignable to type 'FieldValue'.
    actualValue = overrideRequired ? (0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(value, 'overrideRequired') : value ?? defaultValue; // Since this useEffect call is in the feature-flag condition we can ignore eslint complaints
    (0, $7jTnu.fg)('fix-gic-concurrent-rendering') ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (overrideRequired === true) {
            editorKey.current = Date.now();
            onChange(actualValue);
        }
    }, [
        overrideRequired,
        onChange,
        actualValue
    ]) : // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eJOHy.useEffect)(()=>{
        if (overrideRequired === true) {
            editorKey.current = Date.now();
            onChange(actualValue);
        }
    }, [
        overrideRequired,
        onChange,
        actualValue
    ]);
    const issueSummary = getFormState?.()?.values.summary || '';
    const issueDescription = value && typeof value === 'object' && 'type' in value ? value : undefined;
    const isDescriptionCompleterEnabled = adminRichTextConfig?.aiEnabledByProject && (0, $epTsa.expVal)('experiment_proactive_desc_completer_issueview', 'isEnabled', false);
    const contentComponents = (0, $eJOHy.useMemo)(()=>isDescriptionCompleterEnabled ? {
            before: [],
            after: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dNlYM.AsyncAiProactiveDescriptionCompleter), {
                editorApi: editorApi,
                editorExperience: $2a48f28c301224c7$var$DESCRIPTION_FIELD_EXPERIENCE,
                issueType: issueTypeLabel,
                issueSummary: issueSummary,
                issueDescription: issueDescription
            })
        } : undefined, [
        editorApi,
        isDescriptionCompleterEnabled,
        issueDescription,
        issueSummary,
        issueTypeLabel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fE4zR.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "description-field",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9A8Wt.Skeleton), {
            height: $2a48f28c301224c7$var$skeletonHeight
        })
    }, isGICPositioningEnabled() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2a48f28c301224c7$var$WrapperDiv, {
        tabIndex: -1,
        onFocus: ()=>{
            if (isGICPositioningEnabled() && onFocusField) onFocusField();
        },
        onBlur: isGICPositioningEnabled() ? onBlurField : undefined,
        "data-testid": isGICPositioningEnabled() ? 'issue-create.common.ui.fields.description-field.wrapper' : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bzMDD.AsyncRichTextEditView), {
        key: editorKey.current,
        onChange: onChange,
        onBlur: onBlur,
        defaultValue: actualValue,
        mentionProvider: mentionProvider.current,
        mediaContext: mediaProvider,
        shouldFocus: autoFocus,
        isDisabled: isReadOnly,
        assistiveLabel: fieldName,
        sharedEditorConfig: editorConfig,
        ...isDescriptionCompleterEnabled ? {
            setEditorApi: setEditorApi,
            contentComponents: contentComponents,
            placeholder: formatMessage((0, $hZyII.messages).placeholder)
        } : {}
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bzMDD.AsyncRichTextEditView), {
        key: editorKey.current,
        onChange: onChange,
        onBlur: onBlur,
        defaultValue: actualValue,
        mentionProvider: mentionProvider.current,
        mediaContext: mediaProvider,
        shouldFocus: autoFocus,
        isDisabled: isReadOnly,
        assistiveLabel: fieldName,
        sharedEditorConfig: editorConfig,
        ...isDescriptionCompleterEnabled ? {
            setEditorApi: setEditorApi,
            contentComponents: contentComponents,
            placeholder: formatMessage((0, $hZyII.messages).placeholder)
        } : {}
    })));
};
var $2a48f28c301224c7$export$2e2bcd8739ae039 // eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
 = (0, $2nXHu.withFormField)({
    validator: (0, $7OfzM.validateDescriptionField // @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element' is not assignable to parameter of type 'AbstractComponent<ComponentProps<DescriptionFieldConfig, FieldValue>, any>'.
    )
})($2a48f28c301224c7$export$336230c809f2ec53);
const $2a48f28c301224c7$var$WrapperDiv = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_12ji1r31 _1qu2glyw _12y31o36",
            __cmplp.className
        ])
    });
});
$2a48f28c301224c7$var$WrapperDiv.displayName = 'WrapperDiv';

});
parcelRegister("foxSH", function(module, exports) {

$parcel$export(module.exports, "EditorCardProvider", () => $a07a3b4c27f68ec7$export$e4635c0135e1a519);
// WARNING!!!
// Editor Card Provider has been moved to the @atlaskit/editor-card-provider package.
// If you are going to make changes here, be aware that this folder and instance
// of Editor Card Provider will be removed.
// For more information see:
// https://hello.atlassian.net/browse/ENGHEALTH-661
// and
// https://product-fabric.atlassian.net/browse/EDM-5755

var $79KwK = parcelRequire("79KwK");

var $a5MXk = parcelRequire("a5MXk");
var $4g7cp = parcelRequire("4g7cp");
var $hhFie = parcelRequire("hhFie");

var $hy9OT = parcelRequire("hy9OT");

var $dlQ9v = parcelRequire("dlQ9v");

var $3KDr5 = parcelRequire("3KDr5");
const $a07a3b4c27f68ec7$var$BATCH_WAIT_TIME = 50;
// Check if it is matching a Jira Roadmaps or Jira Timeline url
// NOT to be confused with JSM timeline
const $a07a3b4c27f68ec7$var$isJiraRoadmapOrTimeline = (url)=>url.match(/^https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/boards\/.*?\/(timeline|roadmap)\/?/);
const $a07a3b4c27f68ec7$var$isPolarisView = (url)=>url.match(/^https:\/\/.*?\/jira\/polaris\/projects\/[^\/]+?\/ideas\/view\/\d+$|^https:\/\/.*?\/secure\/JiraProductDiscoveryAnonymous\.jspa\?hash=\w+|^https:\/\/.*?\/jira\/polaris\/share\/\w+|^https:\/\/.*?\/jira\/discovery\/share\/views\/[\w-]+(\?selectedIssue=[\w-]+&issueViewLayout=sidebar&issueViewSection=[\w-]+)?$/);
const $a07a3b4c27f68ec7$var$isJwmView = (url)=>url.match(/^https:\/\/.*?\/jira\/core\/projects\/[^\/]+?\/(timeline|calendar|list|board|summary|(form\/[^\/]+?))\/?/);
const $a07a3b4c27f68ec7$var$isGiphyMedia = (url)=>url.match(/^https:\/\/(.*?\.)?giphy\.com\/(gifs|media|clips)\//);
const $a07a3b4c27f68ec7$var$isProformaView = (url)=>url.match(/^https:\/\/[^/]+\/jira\/(core|software(\/c)?|servicedesk)\/projects\/\w+\/forms\/form\/direct\/\d+\/\d+.*$/);
class $a07a3b4c27f68ec7$export$e4635c0135e1a519 {
    constructor(envKey, baseUrlOverride){
        this.baseUrl = baseUrlOverride || (0, $a5MXk.getBaseUrl)(envKey);
        this.resolverUrl = (0, $a5MXk.getResolverUrl)(envKey, baseUrlOverride);
        this.transformer = new (0, $dlQ9v.Transformer)();
        this.requestHeaders = {
            Origin: this.baseUrl
        };
        this.providersLoader = new (0, (/*@__PURE__*/$parcel$interopDefault($79KwK)))((keys)=>this.batchProviders(keys), {
            batchScheduleFn: (callback)=>setTimeout(callback, $a07a3b4c27f68ec7$var$BATCH_WAIT_TIME)
        });
        this.cardClient = new (0, $3KDr5.default)(envKey, baseUrlOverride);
    }
    async batchProviders(keys) {
        // EDM-2205: Batch requests in the case that user paste multiple links at
        // once. This is so that only one /providersData is being called.
        const providersData = await this.fetchProvidersData();
        return keys.map(()=>providersData);
    }
    async check(resourceUrl) {
        try {
            const response = await this.cardClient.fetchData(resourceUrl);
            if ((0, $4g7cp.getStatus)(response) !== 'not_found') return true;
        } catch (e) {
            return false;
        }
    }
    async fetchProvidersData() {
        const endpoint = `${this.resolverUrl}/providers`;
        const response = await (0, $hhFie.request)('post', endpoint, undefined, this.requestHeaders);
        return {
            patterns: response.providers.reduce((allSources, provider)=>{
                return allSources.concat(provider.patterns);
            }, []),
            userPreferences: response.userPreferences
        };
    }
    async loadProviderData() {
        try {
            this.providersData = await this.providersLoader.load('providersData');
        } catch (err) {
            // eslint-disable-next-line
            console.error('failed to fetch /providers', err);
            this.providersLoader.clear('providerData');
            return undefined;
        }
    }
    async findPattern(url) {
        return !!await this.findPatternData(url) || !!await this.check(url);
    }
    doesUrlMatchPath(path, url) {
        // Using [a-zA-Z0-9] here instead of \w since that includes underscores
        const startingRegex = new RegExp(/^[a-zA-Z0-9]/).test(path) ? '(^|[^a-zA-Z0-9])' : '';
        const endingRegex = new RegExp(/[a-zA-Z0-9]$/).test(path) ? '($|[^a-zA-Z0-9])' : '';
        const escapedPath = path.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
        const regexPattern = new RegExp(`${startingRegex}${escapedPath}${endingRegex}`);
        return regexPattern.test(url);
    }
    async findUserPreference(url) {
        if (!this.providersData) await this.loadProviderData();
        const userPreferences = this.providersData?.userPreferences;
        if (userPreferences) {
            const { defaultAppearance: defaultAppearance, appearances: appearances } = userPreferences;
            const allMatchedLabeledAppearances = appearances.filter(({ urlSegment: urlSegment })=>this.doesUrlMatchPath(urlSegment, url));
            if (allMatchedLabeledAppearances.length > 0) {
                const longestMatchedLabeledAppearance = allMatchedLabeledAppearances.reduce((previousLabeledAppearance, currentLabeledAppearance)=>previousLabeledAppearance.urlSegment.length > currentLabeledAppearance.urlSegment.length ? previousLabeledAppearance : currentLabeledAppearance);
                return longestMatchedLabeledAppearance.appearance;
            }
            if (defaultAppearance !== 'inline') return defaultAppearance;
        }
    }
    async findPatternData(url) {
        if (!this.providersData) await this.loadProviderData();
        return this.providersData?.patterns.find((pattern)=>url.match(pattern.source));
    }
    getHardCodedAppearance(url) {
        if ($a07a3b4c27f68ec7$var$isJiraRoadmapOrTimeline(url) || $a07a3b4c27f68ec7$var$isPolarisView(url) || $a07a3b4c27f68ec7$var$isJwmView(url) || $a07a3b4c27f68ec7$var$isGiphyMedia(url) || $a07a3b4c27f68ec7$var$isProformaView(url)) return 'embed';
    }
    /**
	 * Make a /resolve call and find out if result has embed capability
	 * @param url
	 * @private
	 */ async canBeResolvedAsEmbed(url) {
        try {
            const details = await this.cardClient.fetchData(url);
            if (!details) return false;
            // Imagine response is "unauthorized". We won't be able to tell if even after auth
            // page going to have preview. Yes, we can show auth view for embed. But what if even after
            // success auth flow there won't be preview? We will already have ugly embed ADF.
            // Being on a safe side - if we get anything but resolved - we decide it can't be an embed.
            if ((0, $4g7cp.getStatus)(details) !== 'resolved') return false;
            const embed = (0, $hy9OT.extractSmartLinkEmbed)(details);
            return !!embed;
        } catch (e) {
            return false;
        }
    }
    async resolve(url, appearance, shouldForceAppearance) {
        try {
            if (shouldForceAppearance === true) // At this point we don't need to check pattern nor call `check` because manual change means
            // this url is already supported and can be resolved. We want to ignore all other options and
            // respect user's choice.
            return this.transformer.toAdf(url, appearance);
            const hardCodedAppearance = this.getHardCodedAppearance(url);
            const [matchedProviderPattern, userPreference] = await Promise.all([
                this.findPatternData(url),
                this.findUserPreference(url)
            ]);
            if (shouldForceAppearance === false && userPreference === 'url') return Promise.reject(undefined);
            let isSupported = !!matchedProviderPattern || await this.check(url);
            if (isSupported) {
                const providerDefaultAppearance = matchedProviderPattern?.defaultView;
                let preferredAppearance = shouldForceAppearance === undefined ? hardCodedAppearance || appearance : // if user's default choice is NOT "inline" (so, block or embed at this point, url was dealt with above)
                userPreference || // If user's default choice is "inline" or user hasn't specified preferences at all,
                // we check whatever one of the hardcoded providers match url (jira roadmap/timeline, polaris, etc)
                hardCodedAppearance || // If non match, we see if this provider has default appearance for this particular regexp
                providerDefaultAppearance || // If not, we pick what editor (or any other client) requested
                appearance;
                if (preferredAppearance === userPreference && userPreference === 'embed') {
                    const canItBeEmbed = await this.canBeResolvedAsEmbed(url);
                    if (!canItBeEmbed) preferredAppearance = 'inline';
                }
                return this.transformer.toAdf(url, preferredAppearance);
            }
        } catch (e) {
            // eslint-disable-next-line
            console.warn(`Error when trying to check Smart Card url "${url}"${e instanceof Error ? ` - ${e.name} ${e.message}` : ''}`, e);
        }
        return Promise.reject(undefined);
    }
}
const $a07a3b4c27f68ec7$export$b7c3c9a99f7959f5 = new $a07a3b4c27f68ec7$export$e4635c0135e1a519();

});
parcelRegister("dlQ9v", function(module, exports) {

$parcel$export(module.exports, "Transformer", () => $a1e2fba301cb8de2$export$f993aef960936087);
class $a1e2fba301cb8de2$export$f993aef960936087 {
    buildInlineAdf(url) {
        return {
            type: 'inlineCard',
            attrs: {
                url: url
            }
        };
    }
    buildBlockAdf(url) {
        return {
            type: 'blockCard',
            attrs: {
                url: url
            }
        };
    }
    buildEmbedAdf(url) {
        return {
            type: 'embedCard',
            attrs: {
                url: url,
                layout: 'wide'
            }
        };
    }
    toAdf(url, appearance) {
        switch(appearance){
            case 'inline':
                return this.buildInlineAdf(url);
            case 'block':
                return this.buildBlockAdf(url);
            case 'embed':
                return this.buildEmbedAdf(url);
        }
    }
}

});


parcelRegister("bzMDD", function(module, exports) {

$parcel$export(module.exports, "AsyncRichTextEditView", () => $76e7e9ed757bb085$export$ba962c8a1ae57ac);

var $eJOHy = parcelRequire("eJOHy");

var $9A8Wt = parcelRequire("9A8Wt");

var $cBavF = parcelRequire("cBavF");

var $bbdV2 = parcelRequire("bbdV2");

var $7jTnu = parcelRequire("7jTnu");

var $jpnAp = parcelRequire("jpnAp");
const $76e7e9ed757bb085$var$EMPTY_OBJECT = {};
const $76e7e9ed757bb085$export$ba962c8a1ae57ac = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $jpnAp.asyncRichTextEditEntryPoint), // use stable object reference to avoid re-renders
    $76e7e9ed757bb085$var$EMPTY_OBJECT);
    if ((0, $7jTnu.fg)('fix-create-another-bug-in-react18-concurrent-mode')) // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks, react-hooks/rules-of-hooks, react-hooks/react-compiler
    (0, $eJOHy.useLayoutEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    else // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks, react-hooks/rules-of-hooks, react-hooks/react-compiler
    (0, $eJOHy.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        id: "jira-issue-field-rich-text-edit-async",
        packageName: "jira-issue-field-rich-text",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: props,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9A8Wt.SkeletonCompiled), {
            height: "150px"
        }),
        errorFallback: "unmount"
    });
};

});
parcelRegister("jpnAp", function(module, exports) {

$parcel$export(module.exports, "asyncRichTextEditEntryPoint", () => $108ab5a24e61984d$export$153c0381975152a7);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $108ab5a24e61984d$export$153c0381975152a7 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("4kkZ0")).then((module)=>module.EntryPointContent), {
        moduleId: "7ade4e9b",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("4kkZ0", function(module, exports) {

let $32694e7335fa4b90$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $32694e7335fa4b90$var$load("ffQaD"),
    $32694e7335fa4b90$var$load("kvRbA"),
    $32694e7335fa4b90$var$load("fliVL"),
    $32694e7335fa4b90$var$load("76n7a"),
    $32694e7335fa4b90$var$load("l253H"),
    $32694e7335fa4b90$var$load("cjfgm")
]).then(()=>parcelRequire('7lHRe'));

});



parcelRegister("c0I4e", function(module, exports) {

$parcel$export(module.exports, "UserTeamProjectMentionProviderWithResolverMentionName", () => $cdb259a5589c189b$export$9bc9aba7518c0a7);

var $a50DX = parcelRequire("a50DX");
var $49R7i = parcelRequire("49R7i");

var $9zNJZ = parcelRequire("9zNJZ");

var $5r4f6 = parcelRequire("5r4f6");
class $cdb259a5589c189b$export$9bc9aba7518c0a7 extends (0, $5r4f6.UserTeamProjectMentionProvider) {
    constructor(projectOptions, teamOptions){
        super(projectOptions, teamOptions);
        this.config = {
            mentionNameResolver: new (0, $a50DX.DefaultMentionNameResolver)(new (0, $9zNJZ.default)())
        };
    }
    resolveMentionName(id) {
        if (!this.config.mentionNameResolver) return {
            id: id,
            name: '',
            status: (0, $49R7i.MentionNameStatus).UNKNOWN
        };
        return this.config.mentionNameResolver.lookupName(id);
    }
    supportsMentionNameResolving() {
        return !!this.config.mentionNameResolver;
    }
    cacheMentionName(id, mentionName) {
        if (!this.config.mentionNameResolver) return;
        this.config.mentionNameResolver.cacheName(id, mentionName);
    }
}

});
parcelRegister("a50DX", function(module, exports) {

$parcel$export(module.exports, "DefaultMentionNameResolver", () => $f69f8df3d531f626$export$2ae0434dccdcb77e);

var $49R7i = parcelRequire("49R7i");

var $bPSqT = parcelRequire("bPSqT");
class $f69f8df3d531f626$export$2ae0434dccdcb77e {
    static{
        this.waitForBatch = 100 // ms
        ;
    }
    static{
        this.waitForResolveAll = 800 // ms
        ;
    }
    constructor(client, analyticsProps = {}, onResolvedAll = ()=>{}){
        this.nameCache = new Map();
        this.nameQueue = new Map();
        this.nameStartTime = new Map();
        this.processingQueue = new Map();
        this.debounce = 0;
        this.debounceOnResolve = null;
        this.isOnResolvedAllCalled = false;
        this.processQueue = ()=>{
            clearTimeout(this.debounce);
            this.debounce = 0;
            const { queue: queue, extraQueue: extraQueue } = this.splitQueueAtLimit();
            this.nameQueue = extraQueue;
            this.processingQueue = $f69f8df3d531f626$export$71ea0798a8cad7d8(this.processingQueue, queue);
            this.client.lookupMentionNames(Array.from(queue.keys())).then((response)=>{
                response.forEach((mentionDetail)=>{
                    const { id: id } = mentionDetail;
                    queue.delete(id);
                    this.resolveQueueItem(mentionDetail);
                });
                queue.forEach((_callback, id)=>{
                    // No response from client for these ids treat as unknown
                    this.resolveQueueItem({
                        id: id,
                        status: (0, $49R7i.MentionNameStatus).UNKNOWN
                    });
                });
            }).catch(()=>{
                // Service completely failed, reject all items in the queue
                queue.forEach((_callback, id)=>{
                    this.resolveQueueItem({
                        id: id,
                        status: (0, $49R7i.MentionNameStatus).SERVICE_ERROR
                    });
                });
            });
            // Make sure anything left in the queue gets processed.
            if (this.nameQueue.size > 0) this.scheduleProcessQueue();
            else this.scheduleOnAllResolved();
        };
        this.client = client;
        this.fireHydrationEvent = (0, $bPSqT.fireAnalyticsMentionHydrationEvent)(analyticsProps);
        // If provided, this will be called once all pending mentions in the queue are resolved.
        // A sample usage is scrolling to a mention on page load, after the mentions have loadad.
        this.onResolvedAll = onResolvedAll;
    }
    lookupName(id) {
        const name = this.nameCache.get(id);
        if (name) {
            this.fireAnalytics(true, name);
            if (this.nameQueue.size === 0) this.scheduleOnAllResolved();
            return name;
        }
        return new Promise((resolve)=>{
            const processingItems = this.processingQueue.get(id);
            if (processingItems) this.processingQueue.set(id, [
                ...processingItems,
                resolve
            ]);
            const queuedItems = this.nameQueue.get(id) || [];
            this.nameQueue.set(id, [
                ...queuedItems,
                resolve
            ]);
            if (queuedItems.length === 0 && !processingItems) this.nameStartTime.set(id, Date.now());
            this.scheduleProcessQueue();
            if (this.isQueueAtLimit()) this.processQueue();
        });
    }
    cacheName(id, name) {
        this.nameCache.set(id, {
            id: id,
            name: name,
            status: (0, $49R7i.MentionNameStatus).OK
        });
    }
    scheduleProcessQueue() {
        if (!this.debounce) this.debounce = window.setTimeout(this.processQueue, $f69f8df3d531f626$export$2ae0434dccdcb77e.waitForBatch);
    }
    scheduleOnAllResolved() {
        if (this.debounceOnResolve) clearTimeout(this.debounceOnResolve);
        this.debounceOnResolve = window.setTimeout(()=>{
            if (this.isOnResolvedAllCalled) return;
            this.onResolvedAll();
            this.isOnResolvedAllCalled = true;
        }, $f69f8df3d531f626$export$2ae0434dccdcb77e.waitForResolveAll);
    }
    isQueueAtLimit() {
        return this.nameQueue.size >= this.client.getLookupLimit();
    }
    splitQueueAtLimit() {
        const values = Array.from(this.nameQueue.entries());
        const splitPoint = this.client.getLookupLimit();
        return {
            queue: new Map(values.slice(0, splitPoint)),
            extraQueue: new Map(values.slice(splitPoint))
        };
    }
    resolveQueueItem(mentionDetail) {
        const { id: id } = mentionDetail;
        const resolvers = this.processingQueue.get(id);
        if (resolvers) {
            this.processingQueue.delete(id);
            this.nameCache.set(id, mentionDetail);
            resolvers.forEach((resolve)=>{
                try {
                    resolve(mentionDetail);
                } catch  {
                // ignore - exception in consumer
                }
            });
            this.fireAnalytics(false, mentionDetail);
        }
    }
    fireAnalytics(fromCache, mentionDetail) {
        const { id: id } = mentionDetail;
        const action = mentionDetail.status === (0, $49R7i.MentionNameStatus).OK ? 'completed' : 'failed';
        const start = this.nameStartTime.get(id);
        const duration = start ? Date.now() - start : 0;
        this.nameStartTime.delete(id);
        this.fireHydrationEvent(action, id, fromCache, duration);
    }
}
function $f69f8df3d531f626$export$71ea0798a8cad7d8(queueA, queueB) {
    const queueBeingMerged = new Map([
        ...queueA
    ]);
    // now add the items from the second queue that are not already in the
    //  merged queue being built
    [
        ...queueB
    ].forEach((item)=>{
        const [key, queueBCallbacks] = item;
        const itemAlreadyInMergedQueue = queueBeingMerged.has(key);
        if (!itemAlreadyInMergedQueue) queueBeingMerged.set(key, queueBCallbacks);
        else {
            // item already in merged queue, merge the callback arrays
            const queueACallbacks = queueBeingMerged.get(key) ?? [];
            const mergedCallbacks = new Set([
                ...queueBCallbacks,
                ...queueACallbacks
            ]);
            const deduplicatedCallbacks = Array.from(mergedCallbacks.values()); // prevents calling them twice
            queueBeingMerged.set(key, deduplicatedCallbacks);
        }
    });
    return queueBeingMerged;
}

});
parcelRegister("49R7i", function(module, exports) {

$parcel$export(module.exports, "MentionType", () => $35dcc6829e4a1d1d$export$2102863a3c660c6b);
$parcel$export(module.exports, "UserAccessLevel", () => $35dcc6829e4a1d1d$export$81124e6148ca5db0);
$parcel$export(module.exports, "UserType", () => $35dcc6829e4a1d1d$export$8436e53e45ffe15b);
$parcel$export(module.exports, "SliNames", () => $35dcc6829e4a1d1d$export$7afb0727c7d7e8af);
$parcel$export(module.exports, "ComponentNames", () => $35dcc6829e4a1d1d$export$5c42d9dea6d035c1);
$parcel$export(module.exports, "Actions", () => $35dcc6829e4a1d1d$export$b52183d5cfb26dc9);
$parcel$export(module.exports, "MentionNameStatus", () => $35dcc6829e4a1d1d$export$b8fa67dc54502853);
$parcel$export(module.exports, "isRestricted", () => $35dcc6829e4a1d1d$export$dbaa15dc1820b89a);
$parcel$export(module.exports, "isSpecialMention", () => $35dcc6829e4a1d1d$export$37b8dcac6198c514);
$parcel$export(module.exports, "isAppMention", () => $35dcc6829e4a1d1d$export$eb590c844d13454c);
$parcel$export(module.exports, "isTeamMention", () => $35dcc6829e4a1d1d$export$803b1379348dbfd5);
$parcel$export(module.exports, "isSpecialMentionText", () => $35dcc6829e4a1d1d$export$d13d4f976b36a397);
$parcel$export(module.exports, "isPromise", () => $35dcc6829e4a1d1d$export$4369c812aac99591);
var $35dcc6829e4a1d1d$export$2102863a3c660c6b = /*#__PURE__*/ function(MentionType) {
    MentionType[MentionType["SELF"] = 0] = "SELF";
    MentionType[MentionType["RESTRICTED"] = 1] = "RESTRICTED";
    MentionType[MentionType["DEFAULT"] = 2] = "DEFAULT";
    return MentionType;
}({});
var $35dcc6829e4a1d1d$export$81124e6148ca5db0 = /*#__PURE__*/ function(UserAccessLevel) {
    UserAccessLevel[UserAccessLevel["NONE"] = 0] = "NONE";
    UserAccessLevel[UserAccessLevel["SITE"] = 1] = "SITE";
    UserAccessLevel[UserAccessLevel["APPLICATION"] = 2] = "APPLICATION";
    UserAccessLevel[UserAccessLevel["CONTAINER"] = 3] = "CONTAINER";
    return UserAccessLevel;
}({});
var $35dcc6829e4a1d1d$export$8436e53e45ffe15b = /*#__PURE__*/ function(UserType) {
    UserType[UserType["DEFAULT"] = 0] = "DEFAULT";
    UserType[UserType["SPECIAL"] = 1] = "SPECIAL";
    UserType[UserType["APP"] = 2] = "APP";
    UserType[UserType["TEAM"] = 3] = "TEAM";
    UserType[UserType["SYSTEM"] = 4] = "SYSTEM";
    return UserType;
}({});
var $35dcc6829e4a1d1d$export$7afb0727c7d7e8af = /*#__PURE__*/ function(SliNames) {
    SliNames["SEARCH"] = "searchUser";
    SliNames["SEARCH_TEAM"] = "searchTeam";
    SliNames["INITIAL_STATE"] = "initialState";
    SliNames["SELECT"] = "select";
    SliNames["SELECT_TEAM"] = "selectTeam";
    return SliNames;
}({});
var $35dcc6829e4a1d1d$export$5c42d9dea6d035c1 = /*#__PURE__*/ function(ComponentNames) {
    ComponentNames["TYPEAHEAD"] = "mentionTypeahead";
    ComponentNames["MENTION"] = "mention";
    return ComponentNames;
}({});
var $35dcc6829e4a1d1d$export$b52183d5cfb26dc9 = /*#__PURE__*/ function(Actions) {
    Actions["VIEWED"] = "viewed";
    Actions["CLICKED"] = "clicked";
    Actions["CLOSED"] = "closed";
    Actions["SUCCEEDED"] = "succeeded";
    Actions["FAILED"] = "failed";
    return Actions;
}({});
var $35dcc6829e4a1d1d$export$b8fa67dc54502853 = /*#__PURE__*/ function(MentionNameStatus) {
    MentionNameStatus[MentionNameStatus["UNKNOWN"] = 0] = "UNKNOWN";
    MentionNameStatus[MentionNameStatus["SERVICE_ERROR"] = 1] = "SERVICE_ERROR";
    MentionNameStatus[MentionNameStatus["OK"] = 2] = "OK";
    return MentionNameStatus;
}({});
function $35dcc6829e4a1d1d$export$dbaa15dc1820b89a(accessLevel) {
    return !!accessLevel && accessLevel === $35dcc6829e4a1d1d$export$81124e6148ca5db0[0];
}
function $35dcc6829e4a1d1d$export$37b8dcac6198c514(mention) {
    return !!mention.userType && mention.userType === $35dcc6829e4a1d1d$export$8436e53e45ffe15b[1];
}
function $35dcc6829e4a1d1d$export$eb590c844d13454c(mention) {
    return mention.userType && mention.userType === $35dcc6829e4a1d1d$export$8436e53e45ffe15b[2];
}
function $35dcc6829e4a1d1d$export$803b1379348dbfd5(mention) {
    return mention.userType && mention.userType === $35dcc6829e4a1d1d$export$8436e53e45ffe15b[3];
}
function $35dcc6829e4a1d1d$export$d13d4f976b36a397(mentionText) {
    return mentionText && (mentionText === '@all' || mentionText === '@here');
}
const $35dcc6829e4a1d1d$export$4369c812aac99591 = (p)=>!!(p && p.then);

});

parcelRegister("bPSqT", function(module, exports) {

$parcel$export(module.exports, "SLI_EVENT_TYPE", () => $504a08bf167f720e$export$245097525aef1262);
$parcel$export(module.exports, "SMART_EVENT_TYPE", () => $504a08bf167f720e$export$c724588856bbfbcf);
$parcel$export(module.exports, "fireAnalyticsMentionEvent", () => $504a08bf167f720e$export$44902bc7b3f0b09f);
$parcel$export(module.exports, "fireAnalyticsMentionHydrationEvent", () => $504a08bf167f720e$export$91b2fa6a0fe06408);



var $49R7i = parcelRequire("49R7i");
const $504a08bf167f720e$var$packageName = "platform-pkg";
const $504a08bf167f720e$var$packageVersion = "0.0.0-use.local";
const $504a08bf167f720e$export$245097525aef1262 = 'sli';
const $504a08bf167f720e$export$c724588856bbfbcf = 'smart';
const $504a08bf167f720e$export$a823474ae5cb9e9c = (props)=>(action, duration, userIds = [], query)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = {
                action: action,
                actionSubject: (0, $49R7i.ComponentNames).TYPEAHEAD,
                attributes: {
                    packageName: $504a08bf167f720e$var$packageName,
                    packageVersion: $504a08bf167f720e$var$packageVersion,
                    componentName: (0, $49R7i.ComponentNames).MENTION,
                    duration: Math.round(duration),
                    userIds: userIds,
                    queryLength: query ? query.length : 0
                },
                eventType: (0, $d6f34b7bd34f6138$export$12346a674644c156)
            };
            const analyticsEvent = props.createAnalyticsEvent(eventPayload);
            analyticsEvent.fire((0, $ab7a4be2f9c8c36f$export$d821aa4c8afb384e));
        }
    };
const $504a08bf167f720e$export$44902bc7b3f0b09f = (createEvent)=>(actionSubject, action, text, id, accessLevel)=>{
        const payload = {
            action: action,
            actionSubject: actionSubject,
            eventType: (0, $d6f34b7bd34f6138$export$a1562d08625f5d7e),
            attributes: {
                packageName: $504a08bf167f720e$var$packageName,
                packageVersion: $504a08bf167f720e$var$packageVersion,
                componentName: (0, $49R7i.ComponentNames).MENTION,
                accessLevel: accessLevel,
                isSpecial: (0, $49R7i.isSpecialMentionText)(text),
                userId: id
            }
        };
        const event = createEvent(payload);
        event.fire((0, $ab7a4be2f9c8c36f$export$d821aa4c8afb384e));
        return event;
    };
const $504a08bf167f720e$export$c8b245b690e10169 = (props)=>(actionSubject, action)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = $504a08bf167f720e$export$c357a2872628de7c(actionSubject, action);
            props.createAnalyticsEvent(eventPayload).fire((0, $ab7a4be2f9c8c36f$export$d821aa4c8afb384e));
        }
    };
const $504a08bf167f720e$export$c357a2872628de7c = (actionSubject, action, attributes)=>{
    const eventPayload = {
        action: action,
        actionSubject: actionSubject,
        eventType: (0, $d6f34b7bd34f6138$export$12346a674644c156),
        attributes: {
            packageName: $504a08bf167f720e$var$packageName,
            packageVersion: $504a08bf167f720e$var$packageVersion,
            componentName: (0, $49R7i.ComponentNames).MENTION,
            ...attributes
        }
    };
    return eventPayload;
};
const $504a08bf167f720e$export$91b2fa6a0fe06408 = (props)=>(action, userId, fromCache, duration)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = {
                action: action,
                actionSubject: (0, $49R7i.ComponentNames).MENTION,
                actionSubjectId: 'hydration',
                attributes: {
                    packageName: $504a08bf167f720e$var$packageName,
                    packageVersion: $504a08bf167f720e$var$packageVersion,
                    componentName: (0, $49R7i.ComponentNames).MENTION,
                    userId: userId,
                    fromCache: fromCache,
                    duration: Math.round(duration)
                },
                eventType: (0, $d6f34b7bd34f6138$export$12346a674644c156)
            };
            const analyticsEvent = props.createAnalyticsEvent(eventPayload);
            analyticsEvent.fire((0, $ab7a4be2f9c8c36f$export$d821aa4c8afb384e));
        }
    };
// OLD Analytics
const $504a08bf167f720e$var$MENTION_ANALYTICS_PREFIX = 'atlassian.fabric.mention';
const $504a08bf167f720e$export$34ac71ce24cddec2 = (firePrivateAnalyticsEvent)=>(eventName, text, accessLevel)=>{
        if (firePrivateAnalyticsEvent) firePrivateAnalyticsEvent(`${$504a08bf167f720e$var$MENTION_ANALYTICS_PREFIX}.${eventName}`, {
            accessLevel: accessLevel,
            isSpecial: (0, $49R7i.isSpecialMentionText)(text)
        });
    };

});
// same types defined in analytics-web-client but avoid creating dependency with that
const $d6f34b7bd34f6138$export$a1562d08625f5d7e = 'ui';
const $d6f34b7bd34f6138$export$947dac6c72b26f81 = 'track';
const $d6f34b7bd34f6138$export$f1d537d508d2945a = 'screen';
const $d6f34b7bd34f6138$export$12346a674644c156 = 'operational';
const $d6f34b7bd34f6138$export$b055de0e665cb20c = 'unknown';

const $ab7a4be2f9c8c36f$export$d821aa4c8afb384e = 'fabric-elements';



parcelRegister("9zNJZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3e411f0a8235c3e$export$2e2bcd8739ae039);

var $49R7i = parcelRequire("49R7i");
const $a3e411f0a8235c3e$var$bulkUserPath = '/rest/api/3/user/bulk';
const $a3e411f0a8235c3e$var$MAX_MENTIONS = 50;
class $a3e411f0a8235c3e$export$2e2bcd8739ae039 {
    getLookupLimit() {
        // HOT-108964 - sending too many mentions in the request header at once returns a 400
        // The API itself apparently has a hard limit of 90 (HOT-95106), but if we're not careful we can send too many
        // mentions and make the request header too large and the endpoint falls over
        return $a3e411f0a8235c3e$var$MAX_MENTIONS;
    }
    async lookupMentionNames(ids) {
        const params = ids.reduce((idParams, id, index)=>`${idParams}${index > 0 ? '&' : ''}accountId=${encodeURIComponent(id)}`, '');
        return fetch(`${$a3e411f0a8235c3e$var$bulkUserPath}?${params}&maxResults=${$a3e411f0a8235c3e$var$MAX_MENTIONS}`, {
            credentials: 'same-origin'
        }).then((response)=>response.json()).then((data)=>{
            if (!data || !data.values || !data.values.length) return [];
            return data.values.filter(Boolean).map((user)=>({
                    id: user.accountId,
                    name: user.displayName,
                    status: (0, $49R7i.MentionNameStatus).OK
                }));
        });
    }
}

});

parcelRegister("5r4f6", function(module, exports) {

$parcel$export(module.exports, "UserTeamProjectMentionProvider", () => $5dc4265fb67ff268$export$68d633262339b833);

var $3s8bj = parcelRequire("3s8bj");

var $jPROM = parcelRequire("jPROM");

var $7jTnu = parcelRequire("7jTnu");

var $fLz6r = parcelRequire("fLz6r");

var $gP31H = parcelRequire("gP31H");
const $5dc4265fb67ff268$var$MENTION_DEBOUNCE_MS = 150;
class $5dc4265fb67ff268$export$68d633262339b833 extends (0, $fLz6r.ProjectMentionProvider) {
    constructor(projectOptions, teamOptions){
        super(projectOptions.projectKey, projectOptions.projectType), this.debouncedSearch = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(async (query, contextIdentifier)=>{
            const currentSearchTime = Date.now();
            try {
                const teamResults = this.teamMentionProvider.getRecommendedMentions(// @ts-expect-error - TS2345 - Argument of type 'string | null | undefined' is not assignable to parameter of type 'string'.
                query, contextIdentifier);
                // @ts-expect-error - TS2345 - Argument of type 'string | null | undefined' is not assignable to parameter of type 'string'.
                const userResults = this.search(query, contextIdentifier);
                const mentionsQuery = (0, $7jTnu.fg)('gryf-5309-issue-create-mention-order') ? [
                    userResults,
                    teamResults
                ] : [
                    teamResults,
                    userResults
                ];
                const mentionResults = await Promise.all(mentionsQuery);
                // @ts-expect-error - TS2345 - Argument of type 'string | null | undefined' is not assignable to parameter of type 'string'.
                this.activeSearches.delete(query);
                // discard the response from previous requests
                if (currentSearchTime > this.lastSearchTime) this.lastSearchTime = currentSearchTime;
                return mentionResults.reduce((acc, mentionResult)=>{
                    if (mentionResult) acc.mentions = [
                        ...acc.mentions,
                        ...mentionResult.mentions
                    ];
                    return acc;
                }, {
                    mentions: [],
                    query: query ?? ''
                });
            } catch (e) {
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(query) && query.length > 0) this.activeSearches.delete(query);
                throw e;
            }
        }, $5dc4265fb67ff268$var$MENTION_DEBOUNCE_MS);
        this.teamMentionProvider = new (0, $gP31H.TeamMentionProvider)({
            cloudId: teamOptions.cloudId,
            userId: teamOptions.userId,
            orgId: teamOptions.orgId
        });
    }
    /**
	 * We override the filter function to search and interpolate the results from both the project and team mention providers.
	 * This is so that we can only show users that have project access.
	 */ async filter(query, contextIdentifier) {
        try {
            const currentSearchTime = Date.now();
            const mentionResults = await this.debouncedSearch(query, contextIdentifier);
            const results = mentionResults ?? {
                mentions: [],
                query: query ?? ''
            };
            this._notifyListeners(results, {
                duration: Date.now() - currentSearchTime
            });
            this._notifyAllResultsListeners(results);
        } catch (e) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            this._notifyErrorListeners(e);
        }
    }
}

});
parcelRegister("fLz6r", function(module, exports) {

$parcel$export(module.exports, "ProjectMentionProvider", () => $1cd5be83fafe29b2$export$40976f7091c70c78);

var $b5RwB = parcelRequire("b5RwB");

var $bQFKU = parcelRequire("bQFKU");
class $1cd5be83fafe29b2$export$40976f7091c70c78 extends (0, $bQFKU.AbstractMentionProvider) {
    constructor(projectKey, projectType){
        super(projectType), this.getQueryString = (query)=>(0, $b5RwB.stringify)({
                query: query,
                projectKey: this.projectKey,
                maxResults: 10
            }), this.getUrl = (queryString)=>`/rest/api/2/user/viewissue/search?${queryString}`, this.shouldHighlightMention = (mention)=>mention.id === this.projectKey;
        this.projectKey = projectKey;
    }
}

});
parcelRegister("bQFKU", function(module, exports) {

$parcel$export(module.exports, "AbstractMentionProvider", () => $9c67832c1020a971$export$1503942bd70a06a4);

var $3s8bj = parcelRequire("3s8bj");

var $jPROM = parcelRequire("jPROM");

var $231b4 = parcelRequire("231b4");

var $aYncF = parcelRequire("aYncF");

var $1Ozm9 = parcelRequire("1Ozm9");

var $lMRlJ = parcelRequire("lMRlJ");

var $8w0eW = parcelRequire("8w0eW");
const $9c67832c1020a971$var$MENTION_DEBOUNCE_MS = 150;
class $9c67832c1020a971$export$1503942bd70a06a4 extends (0, $231b4.AbstractMentionResource) {
    constructor(projectType, createAnalyticsEvent){
        super(), this.debouncedFilter = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))((query, contextIdentifier)=>{
            const currentSearchTime = Date.now();
            // @ts-expect-error - TS2345 - Argument of type 'string | null | undefined' is not assignable to parameter of type 'string'.
            return this.search(query, contextIdentifier).then((mentionResult)=>{
                // @ts-expect-error - TS2345 - Argument of type 'string | null | undefined' is not assignable to parameter of type 'string'.
                this.activeSearches.delete(query);
                // discard the response from previous requests
                if (currentSearchTime > this.lastSearchTime) {
                    this.lastSearchTime = currentSearchTime;
                    this._notifyListeners(mentionResult, {
                        duration: Date.now() - currentSearchTime
                    });
                }
                this._notifyAllResultsListeners(mentionResult);
            }).catch((e)=>{
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(query) && query.length > 0) this.activeSearches.delete(query);
                this._notifyErrorListeners(e);
            });
        }, $9c67832c1020a971$var$MENTION_DEBOUNCE_MS);
        this.baseUrl = '';
        this.lastSearchTime = 0;
        this.activeSearches = new Set();
        this.productName = (0, $8w0eW.subProductFromProjectType)(projectType);
        this.userRole = (0, $aYncF.getTenantContext_DEPRECATED_DO_NOT_USE)().isAdmin ? 'admin' : 'basic';
        this.onInviteItemClick = ()=>{
            (0, $lMRlJ.triggerOpenModal)(createAnalyticsEvent ?? null, {
                inviteFlow: 'mention'
            });
        };
        this.shouldEnableInvite = true;
        this.isEligibleXProductUserInvite = false;
        this.inviteXProductUser = ()=>Promise.resolve();
    }
    isFiltering(query) {
        return this.activeSearches.has(query);
    }
    filter(query, contextIdentifier) {
        return this.debouncedFilter(query, contextIdentifier);
    }
    search(query, context) {
        const queryString = this.getQueryString(query, context);
        const url = this.getUrl(queryString);
        this.activeSearches.add(query);
        return this.fetchMentions(url).then((users)=>users.map((user)=>({
                    name: user.displayName,
                    mentionName: user.displayName,
                    nickname: user.displayName,
                    id: user.accountId,
                    avatarUrl: user.avatarUrls['48x48']
                }))).then((mentions)=>({
                query: query,
                mentions: mentions
            }));
    }
    // Allow concrete subclasses to override this method so fetch calls can be instrumented
    fetchMentions(url) {
        return (0, $1Ozm9.default)(url);
    }
}

});
parcelRegister("231b4", function(module, exports) {

$parcel$export(module.exports, "AbstractMentionResource", () => $ccd5ccb172c3212e$export$8576ba1ed2760927);
$parcel$export(module.exports, "isResolvingMentionProvider", () => $ccd5ccb172c3212e$export$ae1fce5f69858ef3);

var $kp3br = parcelRequire("kp3br");

var $49R7i = parcelRequire("49R7i");

var $lAjeM = parcelRequire("lAjeM");

var $bPSqT = parcelRequire("bPSqT");

var $3s8bj = parcelRequire("3s8bj");
const $ccd5ccb172c3212e$var$MAX_QUERY_ITEMS = 100;
const $ccd5ccb172c3212e$var$MAX_NOTIFIED_ITEMS = 20;
const $ccd5ccb172c3212e$var$emptySecurityProvider = ()=>{
    return {
        params: {},
        headers: {}
    };
};
class $ccd5ccb172c3212e$export$4529f10aed0950d4 {
    constructor(){
        this.changeListeners = new Map();
        this.allResultsListeners = new Map();
        this.errListeners = new Map();
        this.infoListeners = new Map();
        this.analyticsListeners = new Map();
    }
    subscribe(key, callback, errCallback, infoCallback, allResultsCallback, analyticsListeners) {
        if (callback) this.changeListeners.set(key, callback);
        if (errCallback) this.errListeners.set(key, errCallback);
        if (infoCallback) this.infoListeners.set(key, infoCallback);
        if (allResultsCallback) this.allResultsListeners.set(key, allResultsCallback);
        if (analyticsListeners) this.analyticsListeners.set(key, analyticsListeners);
    }
    unsubscribe(key) {
        this.changeListeners.delete(key);
        this.errListeners.delete(key);
        this.infoListeners.delete(key);
        this.allResultsListeners.delete(key);
        this.analyticsListeners.delete(key);
    }
}
class $ccd5ccb172c3212e$export$8576ba1ed2760927 extends $ccd5ccb172c3212e$export$4529f10aed0950d4 {
    shouldHighlightMention(_mention) {
        return false;
    }
    // eslint-disable-next-line class-methods-use-this
    filter(query) {
        throw new Error(`not yet implemented.\nParams: query=${query}`);
    }
    // eslint-disable-next-line class-methods-use-this, no-unused-vars
    recordMentionSelection(_mention) {
    // Do nothing
    }
    isFiltering(_query) {
        return false;
    }
    _notifyListeners(mentionsResult, stats) {
        (0, $lAjeM.default)('ak-mention-resource._notifyListeners', mentionsResult && mentionsResult.mentions && mentionsResult.mentions.length, this.changeListeners);
        this.changeListeners.forEach((listener, key)=>{
            try {
                listener(mentionsResult.mentions.slice(0, $ccd5ccb172c3212e$var$MAX_NOTIFIED_ITEMS), mentionsResult.query, stats);
            } catch (e) {
                // ignore error from listener
                (0, $lAjeM.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyAllResultsListeners(mentionsResult) {
        (0, $lAjeM.default)('ak-mention-resource._notifyAllResultsListeners', mentionsResult && mentionsResult.mentions && mentionsResult.mentions.length, this.changeListeners);
        this.allResultsListeners.forEach((listener, key)=>{
            try {
                listener(mentionsResult.mentions.slice(0, $ccd5ccb172c3212e$var$MAX_NOTIFIED_ITEMS), mentionsResult.query);
            } catch (e) {
                // ignore error from listener
                (0, $lAjeM.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyErrorListeners(error, query) {
        this.errListeners.forEach((listener, key)=>{
            try {
                listener(error, query);
            } catch (e) {
                // ignore error from listener
                (0, $lAjeM.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyInfoListeners(info) {
        this.infoListeners.forEach((listener, key)=>{
            try {
                listener(info);
            } catch (e) {
                // ignore error fromr listener
                (0, $lAjeM.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyAnalyticsListeners(event, actionSubject, action, attributes) {
        this.analyticsListeners.forEach((listener, key)=>{
            try {
                listener(event, actionSubject, action, attributes);
            } catch (e) {
                // ignore error from listener
                (0, $lAjeM.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
}
class $ccd5ccb172c3212e$export$5a4331e3e1c43553 extends $ccd5ccb172c3212e$export$8576ba1ed2760927 {
    constructor(config){
        super();
        this.verifyMentionConfig(config);
        this.config = config;
        this.lastReturnedSearch = 0;
        this.activeSearches = new Set();
        this.productName = config.productName;
        this.shouldEnableInvite = !!config.shouldEnableInvite;
        this.onInviteItemClick = config.onInviteItemClick;
        this.inviteXProductUser = config.inviteXProductUser;
        this.userRole = config.userRole || 'basic';
        if (this.config.debounceTime) this.filter = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(this.filter, this.config.debounceTime);
    }
    shouldHighlightMention(mention) {
        if (this.config.shouldHighlightMention) return this.config.shouldHighlightMention(mention);
        return false;
    }
    notify(searchTime, mentionResult, query) {
        if (searchTime > this.lastReturnedSearch) {
            this.lastReturnedSearch = searchTime;
            this._notifyListeners(mentionResult, {
                duration: Date.now() - searchTime
            });
        } else {
            const date = new Date(searchTime).toISOString().substr(17, 6);
            (0, $lAjeM.default)('Stale search result, skipping', date, query); // eslint-disable-line no-console, max-len
        }
        this._notifyAllResultsListeners(mentionResult);
    }
    notifyError(error, query) {
        this._notifyErrorListeners(error, query);
        if (query) this.activeSearches.delete(query);
    }
    async filter(query, contextIdentifier) {
        try {
            const searchTime = Date.now();
            let results;
            if (!query) results = await this.initialState(contextIdentifier);
            else {
                this.activeSearches.add(query);
                const searchResponse = this.search(query, contextIdentifier);
                results = await searchResponse.mentions;
            }
            this.notify(searchTime, results, query);
        } catch (error) {
            this.notifyError(error, query);
        }
    }
    isFiltering(query) {
        return this.activeSearches.has(query);
    }
    resolveMentionName(id) {
        if (!this.config.mentionNameResolver) return {
            id: id,
            name: '',
            status: (0, $49R7i.MentionNameStatus).UNKNOWN
        };
        return this.config.mentionNameResolver.lookupName(id);
    }
    cacheMentionName(id, mentionName) {
        if (!this.config.mentionNameResolver) return;
        this.config.mentionNameResolver.cacheName(id, mentionName);
    }
    supportsMentionNameResolving() {
        return !!this.config.mentionNameResolver;
    }
    updateActiveSearches(query) {
        this.activeSearches.add(query);
    }
    verifyMentionConfig(config) {
        if (!config.url) throw new Error('config.url is a required parameter');
        if (!config.securityProvider) config.securityProvider = $ccd5ccb172c3212e$var$emptySecurityProvider;
    }
    initialState(contextIdentifier) {
        return this.remoteInitialState(contextIdentifier);
    }
    /**
	 * Clear a context object to generate query params by removing empty
	 * strings, `undefined` and empty values.
	 *
	 * @param contextIdentifier the current context identifier
	 * @returns a safe context for query encoding
	 */ clearContext(contextIdentifier = {}) {
        return Object.keys(contextIdentifier).filter((key)=>contextIdentifier[key]).reduce((context, key)=>({
                [key]: contextIdentifier[key],
                ...context
            }), {});
    }
    getQueryParams(contextIdentifier) {
        const configParams = {};
        if (this.config.containerId) configParams['containerId'] = this.config.containerId;
        if (this.config.productId) configParams['productIdentifier'] = this.config.productId;
        // if contextParams exist then it will override configParams for containerId
        return {
            ...configParams,
            ...this.clearContext(contextIdentifier)
        };
    }
    /**
	 * Returns the initial mention display list before a search is performed for the specified
	 * container.
	 *
	 * @param contextIdentifier
	 * @returns Promise
	 */ async remoteInitialState(contextIdentifier) {
        const queryParams = this.getQueryParams(contextIdentifier);
        const options = {
            path: 'bootstrap',
            queryParams: queryParams
        };
        try {
            const result = await (0, $kp3br.utils).requestService(this.config, options);
            this._notifyAnalyticsListeners((0, $bPSqT.SLI_EVENT_TYPE), (0, $49R7i.SliNames).INITIAL_STATE, (0, $49R7i.Actions).SUCCEEDED);
            return this.transformServiceResponse(result, '');
        } catch (error) {
            this._notifyAnalyticsListeners((0, $bPSqT.SLI_EVENT_TYPE), (0, $49R7i.SliNames).INITIAL_STATE, (0, $49R7i.Actions).FAILED);
            throw error;
        }
    }
    search(query, contextIdentifier) {
        return {
            mentions: this.remoteSearch(query, contextIdentifier)
        };
    }
    async remoteSearch(query, contextIdentifier) {
        const options = {
            path: 'search',
            queryParams: {
                query: query,
                limit: $ccd5ccb172c3212e$var$MAX_QUERY_ITEMS,
                ...this.getQueryParams(contextIdentifier)
            }
        };
        try {
            const result = await (0, $kp3br.utils).requestService(this.config, options);
            this._notifyAnalyticsListeners((0, $bPSqT.SLI_EVENT_TYPE), (0, $49R7i.SliNames).SEARCH, (0, $49R7i.Actions).SUCCEEDED);
            return this.transformServiceResponse(result, query);
        } catch (error) {
            this._notifyAnalyticsListeners((0, $bPSqT.SLI_EVENT_TYPE), (0, $49R7i.SliNames).SEARCH, (0, $49R7i.Actions).FAILED);
            throw error;
        }
    }
    transformServiceResponse(result, query) {
        const mentions = result.mentions.map((mention)=>{
            let lozenge;
            if ((0, $49R7i.isAppMention)(mention)) lozenge = mention.userType;
            else if ((0, $49R7i.isTeamMention)(mention)) lozenge = mention.userType;
            return {
                ...mention,
                lozenge: lozenge,
                query: query
            };
        });
        return {
            ...result,
            mentions: mentions,
            query: result.query || query
        };
    }
}
class $ccd5ccb172c3212e$export$65bd6083489bd8bb {
    constructor(statusCode, statusMessage){
        this.statusCode = statusCode;
        this.message = statusMessage;
        this.name = 'HttpError';
        this.stack = new Error().stack;
    }
}
const $ccd5ccb172c3212e$export$ae1fce5f69858ef3 = (p)=>!!(p && p.supportsMentionNameResolving && p.supportsMentionNameResolving());
var $ccd5ccb172c3212e$export$2e2bcd8739ae039 = $ccd5ccb172c3212e$export$5a4331e3e1c43553;

});
parcelRegister("lAjeM", function(module, exports) {

$parcel$export(module.exports, "default", () => $11dfa2f74f082c3a$export$2e2bcd8739ae039);
let $11dfa2f74f082c3a$var$debugEnabled = false;
let $11dfa2f74f082c3a$var$stacktracesEnabled = false;
function $11dfa2f74f082c3a$export$748ada60eaf985cc(enable) {
    $11dfa2f74f082c3a$var$debugEnabled = enable;
}
function $11dfa2f74f082c3a$export$4f7017086af31c25(enable) {
    $11dfa2f74f082c3a$var$stacktracesEnabled = enable;
}
function $11dfa2f74f082c3a$export$2a858f450a2f66d() {
    if ($11dfa2f74f082c3a$var$stacktracesEnabled) // eslint-disable-next-line no-console
    console.log(new Error().stack);
}
function $11dfa2f74f082c3a$export$2e2bcd8739ae039(msg, ...args) {
    if ($11dfa2f74f082c3a$var$debugEnabled) // eslint-disable-next-line no-console
    console.log(msg, ...args);
}

});


parcelRegister("8w0eW", function(module, exports) {

$parcel$export(module.exports, "subProductFromProjectType", () => $1cc9a356cc2374f5$export$246e1e2a5c86a633);

var $ln6Iy = parcelRequire("ln6Iy");
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $1cc9a356cc2374f5$var$SERVICEDESK_APPLICATION_ROLE = 'jira-servicedesk';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $1cc9a356cc2374f5$var$SOFTWARE_APPLICATION_ROLE = 'jira-software';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $1cc9a356cc2374f5$var$CORE_APPLICATION_ROLE = 'jira-core';
const $1cc9a356cc2374f5$export$246e1e2a5c86a633 = (projectType)=>{
    switch(projectType){
        case 0, $ln6Iy.SERVICE_DESK_PROJECT:
            return 'Jira Service Management';
        default:
            return 'Jira';
    }
};

});



parcelRegister("gP31H", function(module, exports) {

$parcel$export(module.exports, "TeamMentionProvider", () => $d35414e980cfb13b$export$d113415d07aa661c);

var $ksMiI = parcelRequire("ksMiI");
const $d35414e980cfb13b$var$BaseSmartMentionConfigOptions = {
    env: 'prod',
    productKey: 'jira',
    includeTeams: true,
    includeUsers: false
};
class $d35414e980cfb13b$export$d113415d07aa661c extends (0, $ksMiI.default) {
    constructor({ cloudId: cloudId, orgId: orgId, userId: userId }){
        super({
            ...$d35414e980cfb13b$var$BaseSmartMentionConfigOptions,
            siteId: cloudId,
            orgId: orgId,
            principalId: userId ?? undefined
        });
    }
}

});
parcelRegister("ksMiI", function(module, exports) {

$parcel$export(module.exports, "default", () => $91150ae795394624$export$2e2bcd8739ae039);

var $231b4 = parcelRequire("231b4");
var $49R7i = parcelRequire("49R7i");

var $CODcb = parcelRequire("CODcb");

var $k7V0u = parcelRequire("k7V0u");

var $2ZMN2 = parcelRequire("2ZMN2");

var $hO9Fs = parcelRequire("hO9Fs");
const $91150ae795394624$var$CONTEXT_TYPE = 'Mentions';
const $91150ae795394624$var$isSmartMentionConfigWithMentionNameResolver = (smartMentionConfig)=>!!smartMentionConfig.mentionNameResolver;
/*
 * This is a provider implementation which calls URS to provide a list of recommended users/teams to mention.
 * The entryPoint hierarchy is : Editor -> editor-core -> plugins -> mentions -> typeAhead -> getItems -> pluginState.pluginProvider.filter
 * The results are then mapped to mentionItems which have a render prop mentionToTypeaheadItem -> MentionItem
 * https://bitbucket.org/atlassian/atlassian-frontend/src/0884032d85f11f43c13532cd21f13f696b0d28a7/packages/editor/editor-core/src/plugins/mentions/index.tsx#lines-219
 *
 */ class $91150ae795394624$var$SmartMentionResource extends (0, $231b4.AbstractMentionResource) {
    constructor(smartMentionConfig){
        super();
        // If the product doesn't provide a mention name resolve, use the default resolver so that
        // mention names can be looked up from PRS without configuration.
        this.smartMentionConfig = $91150ae795394624$var$isSmartMentionConfigWithMentionNameResolver(smartMentionConfig) ? smartMentionConfig : {
            ...smartMentionConfig,
            mentionNameResolver: new (0, $2ZMN2.DefaultMentionNameResolver)(smartMentionConfig.baseUrl)
        };
        this.lastReturnedSearch = 0;
    }
    shouldHighlightMention(mention) {
        if (this.smartMentionConfig.shouldHighlightMention) return this.smartMentionConfig.shouldHighlightMention(mention);
        return false;
    }
    notify(searchTime, mentionResult, query) {
        if (searchTime > this.lastReturnedSearch) {
            this.lastReturnedSearch = searchTime;
            this._notifyListeners(mentionResult, {
                duration: Date.now() - searchTime
            });
        }
        this._notifyAllResultsListeners(mentionResult);
    }
    notifyError(error, query) {
        this._notifyErrorListeners(error, query);
    }
    async filter(query, contextIdentifier) {
        this.contextIdentifier = contextIdentifier;
        const searchTime = Date.now();
        try {
            let results = await this.getRecommendedMentions(query ? query : '', contextIdentifier);
            this.notify(searchTime, results, query);
        } catch (error) {
            this.notifyError(error, query);
        }
    }
    async getRecommendedMentions(query, contextIdentifier) {
        const startTime = window.performance.now();
        const conf = this.smartMentionConfig;
        const maxNumberOfResults = conf.maxNumberOfResults || 100;
        const request = {
            baseUrl: conf.baseUrl,
            context: {
                productKey: conf.productKey,
                contextType: $91150ae795394624$var$CONTEXT_TYPE,
                principalId: conf.principalId || 'context',
                containerId: contextIdentifier && contextIdentifier.containerId,
                siteId: conf.siteId,
                organizationId: conf.orgId,
                objectId: contextIdentifier && contextIdentifier.objectId || 'undefined',
                childObjectId: contextIdentifier && contextIdentifier.childObjectId || 'undefined',
                mentionsSessionId: contextIdentifier && contextIdentifier.sessionId || 'undefined',
                sessionId: contextIdentifier && contextIdentifier.sessionId || 'undefined'
            },
            includeGroups: conf.includeGroups,
            includeTeams: conf.includeTeams,
            includeUsers: typeof conf.includeUsers === 'undefined' ? true : conf.includeUsers,
            maxNumberOfResults: maxNumberOfResults,
            searchQueryFilter: conf.searchQueryFilter,
            query: query
        };
        try {
            this._notifyAnalyticsListeners((0, $k7V0u.SMART_EVENT_TYPE), 'users', (0, $k7V0u.Actions).REQUESTED, (0, $k7V0u.defaultAttributes)(contextIdentifier));
            const users = await (0, $hO9Fs.default)(request);
            const elapsedTimeMilli = window.performance.now() - startTime;
            const usersForAnalytics = (0, $k7V0u.getUsersForAnalytics)(users);
            this._notifyAnalyticsListeners((0, $k7V0u.SMART_EVENT_TYPE), 'usersRequest', (0, $k7V0u.Actions).SUCCESSFUL, {
                elapsedTimeMilli: elapsedTimeMilli,
                users: usersForAnalytics,
                displayedUsers: usersForAnalytics,
                ...(0, $k7V0u.defaultAttributes)(contextIdentifier)
            });
            const mentions = this.transformUsersToMentions(users);
            return {
                mentions: mentions,
                query: query
            };
        } catch (e) {
            const elapsedTimeMilli = window.performance.now() - startTime;
            this._notifyAnalyticsListeners((0, $k7V0u.SMART_EVENT_TYPE), 'usersRequest', (0, $k7V0u.Actions).FAILED, {
                elapsedTimeMilli: elapsedTimeMilli,
                ...(0, $k7V0u.defaultAttributes)(contextIdentifier)
            });
            throw e instanceof Error ? e : new Error(String(e));
        }
    }
    transformTeamMember(member) {
        return {
            id: member.id,
            name: member.name
        };
    }
    transformUserToMention(item) {
        const type = item.entityType;
        let defaultVals = {
            source: 'smarts'
        };
        if (type === (0, $CODcb.EntityType).USER) {
            const user = item;
            return {
                ...defaultVals,
                id: user.id,
                accessLevel: user.accessLevel,
                avatarUrl: user.avatarUrl,
                mentionName: user.nickname || '',
                name: user.name,
                userType: user.userType
            };
        }
        if (type === (0, $CODcb.EntityType).TEAM) {
            const team = item;
            let teamLink = '';
            const defaultTeamLink = `${window.location.origin}/people/team/${team.id}`;
            if (typeof this.smartMentionConfig.teamLinkResolver === 'function') teamLink = this.smartMentionConfig.teamLinkResolver(item.id);
            return {
                ...defaultVals,
                id: team.id,
                name: team.displayName || '',
                mentionName: team.displayName,
                avatarUrl: team.smallAvatarImageUrl,
                accessLevel: (0, $49R7i.UserAccessLevel)[(0, $49R7i.UserAccessLevel).CONTAINER],
                userType: (0, $49R7i.UserType)[(0, $49R7i.UserType).TEAM],
                lozenge: (0, $49R7i.UserType)[(0, $49R7i.UserType).TEAM],
                context: {
                    members: team.members ? team.members.map(this.transformTeamMember) : [],
                    includesYou: team.includesYou || false,
                    memberCount: team.memberCount || 0,
                    teamLink: teamLink || defaultTeamLink
                },
                source: 'smarts'
            };
        }
        if (type === (0, $CODcb.EntityType).GROUP) {
            const group = item;
            return {
                ...defaultVals,
                id: group.id,
                userType: type.toLowerCase(),
                name: group.name || '',
                lozenge: type.toLowerCase()
            };
        }
        return {
            id: item.id,
            userType: (0, $CODcb.EntityType).USER.toLowerCase(),
            avatarUrl: item.avatarUrl,
            name: item.name,
            lozenge: (0, $CODcb.EntityType).USER.toLowerCase()
        };
    }
    transformUsersToMentions(recommendationItems) {
        return (recommendationItems || []).map(this.transformUserToMention, this).filter((user)=>!!user).map((user)=>user);
    }
    cacheMentionName(id, mentionName) {
        this.smartMentionConfig.mentionNameResolver.cacheName(id, mentionName);
    }
    resolveMentionName(id) {
        return this.smartMentionConfig.mentionNameResolver.lookupName(id);
    }
    supportsMentionNameResolving() {
        return true;
    }
    recordMentionSelection(_mention) {
        this._notifyAnalyticsListeners((0, $k7V0u.SMART_EVENT_TYPE), 'usersRequest', (0, $k7V0u.Actions).SELECTED, {
            selectedOption: _mention.id,
            ...(0, $k7V0u.defaultAttributes)(this.contextIdentifier)
        });
    }
}
var $91150ae795394624$export$2e2bcd8739ae039 = $91150ae795394624$var$SmartMentionResource;

});
parcelRegister("CODcb", function(module, exports) {

$parcel$export(module.exports, "EntityType", () => $0b1e2bf74ade2c72$export$8eda7e02f8f033b2);
var $0b1e2bf74ade2c72$export$8eda7e02f8f033b2 = /*#__PURE__*/ function(EntityType) {
    EntityType["USER"] = "USER";
    EntityType["TEAM"] = "TEAM";
    EntityType["GROUP"] = "GROUP";
    return EntityType;
}({});

});

parcelRegister("k7V0u", function(module, exports) {

$parcel$export(module.exports, "SMART_EVENT_TYPE", () => $5ac43c7a05b9ad74$export$c724588856bbfbcf);
$parcel$export(module.exports, "Actions", () => $5ac43c7a05b9ad74$export$b52183d5cfb26dc9);
$parcel$export(module.exports, "defaultAttributes", () => $5ac43c7a05b9ad74$export$38cd8db2db178f58);
$parcel$export(module.exports, "getUsersForAnalytics", () => $5ac43c7a05b9ad74$export$e8be30a842a4b49d);
const $5ac43c7a05b9ad74$export$c724588856bbfbcf = 'smart';
var $5ac43c7a05b9ad74$export$b52183d5cfb26dc9 = /*#__PURE__*/ function(Actions) {
    Actions["REQUESTED"] = "requested";
    Actions["SUCCESSFUL"] = "successful";
    Actions["SEARCHED"] = "searched";
    Actions["FAILED"] = "failed";
    Actions["SELECTED"] = "selected";
    return Actions;
}({});
const $5ac43c7a05b9ad74$export$38cd8db2db178f58 = (context)=>{
    return {
        context: context?.objectId || '',
        sessionId: context?.sessionId || '',
        pickerType: 'mentions',
        source: 'smarts'
    };
};
const $5ac43c7a05b9ad74$export$e8be30a842a4b49d = (users)=>{
    return users ? users.map(({ id: id, entityType: entityType })=>({
            id: id,
            type: entityType.toLowerCase()
        })) : [];
};

});

parcelRegister("2ZMN2", function(module, exports) {

$parcel$export(module.exports, "DefaultMentionNameResolver", () => $54120c1d82f7f6ec$export$2ae0434dccdcb77e);

var $49R7i = parcelRequire("49R7i");

var $5EIFk = parcelRequire("5EIFk");

var $b8DUT = parcelRequire("b8DUT");
const $54120c1d82f7f6ec$var$buildUsersQuery = (accountIds)=>({
        query: `query usersQuery($accountIds: [ID!]!) {
    users(accountIds: $accountIds) {
      name
      accountId
    }
  }`,
        variables: {
            accountIds: accountIds
        }
    });
const $54120c1d82f7f6ec$var$makeRequest = async (url, accountIds)=>{
    const query = $54120c1d82f7f6ec$var$buildUsersQuery(accountIds);
    return (0, $b8DUT.graphqlQuery)(url, query);
};
class $54120c1d82f7f6ec$export$2ae0434dccdcb77e {
    constructor(baseUrl){
        this.baseUrl = baseUrl;
        this.cache = new Map();
    }
    async lookupName(id) {
        try {
            if (this.cache.has(id)) return {
                id: id,
                name: this.cache.get(id),
                status: (0, $49R7i.MentionNameStatus).OK
            };
            const url = (0, $5EIFk.PRD_CONFIG).getGraphQLUrl(this.baseUrl);
            const data = await $54120c1d82f7f6ec$var$makeRequest(url, [
                id
            ]);
            const userInfo = data.users?.find((user)=>user.accountId === id);
            return userInfo ? {
                id: id,
                name: userInfo.name,
                status: (0, $49R7i.MentionNameStatus).OK
            } : {
                id: id,
                status: (0, $49R7i.MentionNameStatus).UNKNOWN
            };
        } catch (error) {
            // on network error, return original list with label 'Unknown'
            return {
                id: id,
                status: (0, $49R7i.MentionNameStatus).UNKNOWN
            };
        }
    }
    cacheName(id, name) {
        this.cache.set(id, name);
    }
}

});
parcelRegister("5EIFk", function(module, exports) {

$parcel$export(module.exports, "PRD_CONFIG", () => $7221eea12d648a04$export$d4fff2dfff3e2bc1);
const $7221eea12d648a04$export$d4fff2dfff3e2bc1 = {
    getRecommendationServiceUrl (baseUrl) {
        return baseUrl ? `${baseUrl}/gateway/api/v1/recommendations` : '/gateway/api/v1/recommendations';
    },
    getUsersServiceUrl (productKey) {
        return productKey === 'jira' ? `/rest/api/3/user/bulk` : `/wiki/rest/api/user/bulk`;
    },
    getGraphQLUrl (baseUrl) {
        return baseUrl ? `${baseUrl}/gateway/api/graphql` : `/gateway/api/graphql`;
    },
    getTeamsUrl (baseUrl) {
        return baseUrl ? `/${baseUrl}/gateway/api/v3/teams` : `/gateway/api/v3/teams`;
    }
};

});

parcelRegister("b8DUT", function(module, exports) {

$parcel$export(module.exports, "graphqlQuery", () => $a6434f4d740402c2$export$74eb8d79ae3e02b5);
const $a6434f4d740402c2$var$buildHeaders = ()=>{
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    return headers;
};
function $a6434f4d740402c2$export$74eb8d79ae3e02b5(serviceUrl, query) {
    const headers = $a6434f4d740402c2$var$buildHeaders();
    return fetch(new Request(`${serviceUrl}`, {
        method: 'POST',
        credentials: 'include',
        mode: 'cors',
        headers: headers,
        body: JSON.stringify(query)
    })).then((response)=>{
        if (!response.ok) return Promise.reject({
            code: response.status,
            reason: response.statusText
        });
        return response;
    }).then((response)=>response.json()).then((json)=>{
        if (json.errors) return Promise.reject({
            reason: json.errors[0]?.category || 'default'
        });
        return json.data;
    });
}

});


parcelRegister("hO9Fs", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9a5e5183bec5db2$export$2e2bcd8739ae039);

var $5EIFk = parcelRequire("5EIFk");
const $a9a5e5183bec5db2$var$getUserRecommendations = (request)=>{
    const url = (0, $5EIFk.PRD_CONFIG).getRecommendationServiceUrl(request.baseUrl);
    return fetch(url, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'content-type': 'application/json'
        },
        body: JSON.stringify({
            context: request.context,
            includeUsers: request.includeUsers,
            includeGroups: request.includeGroups,
            includeTeams: request.includeTeams,
            maxNumberOfResults: request.maxNumberOfResults,
            performSearchQueryOnly: false,
            searchQuery: {
                cpusQueryHighlights: {
                    query: '',
                    field: ''
                },
                customQuery: '',
                customerDirectoryId: '',
                filter: request.searchQueryFilter || '',
                minimumAccessLevel: 'APPLICATION',
                queryString: request.query,
                restrictTo: {
                    userIds: [],
                    groupIds: []
                },
                searchUserbase: false
            }
        })
    }).then((response)=>{
        if (response.status === 200) return response.json();
        return Promise.reject({
            message: `error calling smart service, statusCode=${response.status}, statusText=${response.statusText}`
        });
    }).then((response)=>response.recommendedUsers);
};
var $a9a5e5183bec5db2$export$2e2bcd8739ae039 = $a9a5e5183bec5db2$var$getUserRecommendations;

});





parcelRegister("gsFUG", function(module, exports) {

$parcel$export(module.exports, "getProductForEditorAIPlugin", () => $5cb79a409cf83047$export$ae2611ff27e7ff5);
$parcel$export(module.exports, "useEditorConfig", () => $5cb79a409cf83047$export$68f5e61568cc49bc);

var $eJOHy = parcelRequire("eJOHy");

var $eJ9f5 = parcelRequire("eJ9f5");

var $86tBw = parcelRequire("86tBw");

var $7zSEj = parcelRequire("7zSEj");

var $aJ1QD = parcelRequire("aJ1QD");

var $ln6Iy = parcelRequire("ln6Iy");

var $eSnSE = parcelRequire("eSnSE");

var $7jTnu = parcelRequire("7jTnu");

var $5dqlp = parcelRequire("5dqlp");

var $igGHJ = parcelRequire("igGHJ");

var $kDaaB = parcelRequire("kDaaB");
var $lRq8t = parcelRequire("lRq8t");

var $ivqdF = parcelRequire("ivqdF");

var $3ASEn = parcelRequire("3ASEn");

var $jrvsa = parcelRequire("jrvsa");

var $LUGny = parcelRequire("LUGny");
const $5cb79a409cf83047$var$FEEDBACK_COLLECTOR_ID = 'fb2a9bff-f1e7-4deb-b396-7bfaae5af671';
const $5cb79a409cf83047$var$FEEDBACK_CONTEXT_ID = 'customfield_10047';
const $5cb79a409cf83047$var$LINK_TO_PRIVACY_POLICY = 'https://www.atlassian.com/legal/privacy-policy';
const $5cb79a409cf83047$var$LINK_TO_RESEARCH_GROUP = 'https://www.atlassian.com/research-group';
const $5cb79a409cf83047$var$buildAdditionalFields = (props, hasUserConsent)=>{
    if (!props || !props.getAIExperience) return undefined;
    const { getAIExperience: getAIExperience, sentiment: sentiment, editorAttributes: editorAttributes } = props;
    const aiExperience = getAIExperience?.(hasUserConsent) || {};
    let feedbackMetadataStringified = `sentiment: ${sentiment}\n`;
    Object.entries({
        ...aiExperience,
        ...editorAttributes
    }).forEach((item)=>{
        feedbackMetadataStringified += `${item[0]}: ${item[1]}\n`;
    });
    return [
        {
            id: $5cb79a409cf83047$var$FEEDBACK_CONTEXT_ID,
            value: feedbackMetadataStringified
        }
    ];
};
const $5cb79a409cf83047$var$CanContactLabel = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), {
        ...(0, $jrvsa.default).canContactText,
        values: {
            // this is done exactly as documented here: https://developer.atlassian.com/platform/localization/i18n-formatting/avoiding-concatenation/#links
            // @ts-expect-error - https://github.com/formatjs/formatjs/issues/3550 need to updated to v6 intl
            a: (...chunks)=>(0, $7jTnu.fg)('replace-anchor-with-link__issue-view---kenji') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
                    target: "_blank",
                    href: $5cb79a409cf83047$var$LINK_TO_PRIVACY_POLICY
                }, chunks) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("a", {
                    target: "_blank",
                    href: $5cb79a409cf83047$var$LINK_TO_PRIVACY_POLICY
                }, chunks)
        }
    });
const $5cb79a409cf83047$var$EnrolLabel = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), {
        ...(0, $jrvsa.default).improveAtlassianText,
        values: {
            // this is done exactly as documented here: https://developer.atlassian.com/platform/localization/i18n-formatting/avoiding-concatenation/#links
            // @ts-expect-error - https://github.com/formatjs/formatjs/issues/3550 need to updated to v6 intl
            a: (...chunks)=>(0, $7jTnu.fg)('replace-anchor-with-link__issue-view---kenji') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
                    target: "_blank",
                    href: $5cb79a409cf83047$var$LINK_TO_RESEARCH_GROUP
                }, chunks) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("a", {
                    target: "_blank",
                    href: $5cb79a409cf83047$var$LINK_TO_RESEARCH_GROUP
                }, chunks)
        }
    });
const $5cb79a409cf83047$export$ae2611ff27e7ff5 = (projectType)=>{
    switch(projectType){
        case 0, $ln6Iy.CORE_PROJECT:
            return (0, $LUGny.Product).JWM;
        case 0, $ln6Iy.SOFTWARE_PROJECT:
            return (0, $LUGny.Product).JSW;
        case 0, $ln6Iy.SERVICE_DESK_PROJECT:
            return (0, $LUGny.Product).JSM;
        case 0, $ln6Iy.PRODUCT_DISCOVERY_PROJECT:
            return (0, $LUGny.Product).JPD;
        default:
            return null;
    }
};
const $5cb79a409cf83047$export$7543cd52952bad27 = (editorPluginAIConfig)=>{
    const isAIOptedIn = editorPluginAIConfig.isAiOptInEnabled;
    return isAIOptedIn ? 'enabled' : 'disabled';
};
const $5cb79a409cf83047$export$ff2962de2b2c930f = (product)=>{
    switch(product){
        case (0, $LUGny.Product).JSW:
            return 'jira-software';
        case (0, $LUGny.Product).JPD:
            return 'jpd';
        case (0, $LUGny.Product).JSM:
            return 'jsm';
        default:
            return 'jira';
    }
};
// Extracting this function as it caused instability between renders, as picked up by Cypress
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $5cb79a409cf83047$var$fireEmptyExperimentExposure = ()=>{};
const $5cb79a409cf83047$export$68f5e61568cc49bc = ({ editorPluginAIConfig: editorPluginAIConfig })=>{
    const { openFeedbackCollector: openFeedbackCollector, updateCustomRenderComponent: updateCustomRenderComponent, updateAdditionalFields: updateAdditionalFields } = (0, $igGHJ.useFeedbackCollectorActions)();
    const { optInStatus: optInStatus, triggerOptInFlow: triggerOptInFlow, AIOptInModal: AIOptInModal } = (0, $ivqdF.useAIOptIn)({
        editorPluginAIConfig: editorPluginAIConfig
    });
    // AI Upsell In Editor Experiment
    const { isEnrolledInExperiment: isAIUpsellInEditorFreeEnrolled, isExperimentEnabled: isAIUpsellInEditorFreeEnabled, fireExperimentExposure: fireAIUpsellInEditorFreeExposure } = (0, $7jTnu.fg)('jira_free_ai_in_editor_v2_gate') ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $3ASEn.useAIUpsellInEditorFree)(optInStatus, editorPluginAIConfig?.product) : {
        isEnrolledInExperiment: false,
        isExperimentEnabled: false,
        fireExperimentExposure: $5cb79a409cf83047$var$fireEmptyExperimentExposure
    };
    (0, $eJOHy.useEffect)(()=>{
        if (isAIUpsellInEditorFreeEnrolled) fireAIUpsellInEditorFreeExposure();
    }, [
        isAIUpsellInEditorFreeEnrolled,
        fireAIUpsellInEditorFreeExposure
    ]);
    const [hasUserConsent, setHasUserConsent] = (0, $eJOHy.useState)(false);
    const [additionalFieldsData, setAdditionalFieldsData] = (0, $eJOHy.useState)(null);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const handleHasUserConsent = (0, $eJOHy.useCallback)(()=>{
        setHasUserConsent(!hasUserConsent);
        updateAdditionalFields($5cb79a409cf83047$var$buildAdditionalFields(additionalFieldsData, !hasUserConsent));
    }, [
        hasUserConsent,
        additionalFieldsData,
        updateAdditionalFields
    ]);
    const renderCustomFeedbackContent = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86tBw.default), {
            label: formatMessage((0, $jrvsa.default).userConsentCheckboxLabel),
            onChange: handleHasUserConsent,
            isChecked: hasUserConsent
        }), [
        hasUserConsent,
        formatMessage,
        handleHasUserConsent
    ]);
    const PromptEditor = (0, $eJOHy.useMemo)(()=>(0, $7zSEj.createPromptEditor)({
            linking: editorPluginAIConfig?.linking,
            featureFlags: {},
            enableLinks: !!editorPluginAIConfig?.linking
        }), [
        editorPluginAIConfig?.linking
    ]);
    (0, $eJOHy.useEffect)(()=>{
        updateCustomRenderComponent(renderCustomFeedbackContent);
    }, [
        renderCustomFeedbackContent,
        updateCustomRenderComponent
    ]);
    const AIConfiguration = (0, $eJOHy.useMemo)(()=>{
        if (!editorPluginAIConfig?.product) return undefined;
        return (0, $aJ1QD.createJiraEditorPluginAIOptions)({
            aiGlobalOptIn: {
                status: optInStatus,
                triggerOptInFlow: triggerOptInFlow
            },
            aiLifeCycleDynamicAttributesGetter: editorPluginAIConfig.aiLifeCycleDynamicAttributesGetter,
            generativeAIApiUrl: '/gateway/api/editor-ai/v1/generative/ai',
            issueId: editorPluginAIConfig?.issueId,
            // issueId will be required only in JSM product
            product: editorPluginAIConfig.product,
            allowIssueReformatter: editorPluginAIConfig?.allowIssueReformatter,
            allowSuggestResponse: editorPluginAIConfig.allowSuggestResponse,
            getAdditionalProps: editorPluginAIConfig?.getAdditionalProps,
            handleFeedbackSubmission: async ({ sentiment: sentiment, editorAttributes: editorAttributes, getAIExperience: getAIExperience })=>{
                // @ts-expect-error plugin issue
                const feedbackContextData = {
                    getAIExperience: getAIExperience,
                    sentiment: sentiment,
                    editorAttributes: editorAttributes
                };
                const feedbackCollectorProps = {
                    entrypointId: (0, $5dqlp.ENTRY_POINT_ID_GENERATIVE_AI),
                    feedbackTitle: formatMessage((0, $jrvsa.default).feedBackTitle),
                    feedbackCollectorId: $5cb79a409cf83047$var$FEEDBACK_COLLECTOR_ID,
                    renderCustomContent: renderCustomFeedbackContent,
                    showTypeField: false,
                    summaryPlaceholder: formatMessage((0, $jrvsa.default).summaryPlaceholder),
                    additionalFields: $5cb79a409cf83047$var$buildAdditionalFields(feedbackContextData, hasUserConsent),
                    canBeContactedLabel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5cb79a409cf83047$var$CanContactLabel, null),
                    enrolInResearchLabel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5cb79a409cf83047$var$EnrolLabel, null)
                };
                setAdditionalFieldsData(feedbackContextData);
                try {
                    openFeedbackCollector(feedbackCollectorProps);
                    return {
                        status: 'submitted'
                    };
                } catch (error) {
                    (0, $eSnSE.default).safeErrorWithoutCustomerData('platforms.utils.shared-editor-config.entry', 'Error sending feedback submission', error instanceof Error ? error : undefined);
                    return {
                        status: 'failed'
                    };
                }
            },
            PromptEditor: PromptEditor,
            AIButtonWrapper: isAIUpsellInEditorFreeEnabled ? (0, $3ASEn.AIUpsellButtonWrapper) : undefined,
            getChannelVariables: editorPluginAIConfig?.getChannelVariables,
            actionSideEffects: editorPluginAIConfig?.actionSideEffects,
            actionOverrides: editorPluginAIConfig?.actionOverrides,
            auditLogSettings: editorPluginAIConfig.auditLogEventData ? {
                enabled: true,
                eventData: editorPluginAIConfig.auditLogEventData
            } : {
                enabled: false
            }
        });
    }, [
        hasUserConsent,
        optInStatus,
        triggerOptInFlow,
        editorPluginAIConfig,
        openFeedbackCollector,
        formatMessage,
        renderCustomFeedbackContent,
        PromptEditor,
        isAIUpsellInEditorFreeEnabled
    ]);
    return {
        props: {
            isAIUpsellInEditorFreeEnabled: isAIUpsellInEditorFreeEnabled
        },
        AIConfiguration: AIConfiguration,
        components: {
            AIOptInModal: AIOptInModal
        }
    };
};

});
parcelRegister("7zSEj", function(module, exports) {

$parcel$export(module.exports, "createPromptEditor", () => $1d34fb7ba3f90e48$export$df4eed2eacb29ddb);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $d7OCi = parcelRequire("d7OCi");

var $9Ssie = parcelRequire("9Ssie");

var $eJ0dy = parcelRequire("eJ0dy");

var $kCWwL = parcelRequire("kCWwL");

var $hzPqg = parcelRequire("hzPqg");

var $3lIcL = parcelRequire("3lIcL");

var $eGOwo = parcelRequire("eGOwo");

var $2sLVw = parcelRequire("2sLVw");

var $1LVxc = parcelRequire("1LVxc");

var $20HYH = parcelRequire("20HYH");

var $i3bYv = parcelRequire("i3bYv");

var $cHPqZ = parcelRequire("cHPqZ");

var $ghcZR = parcelRequire("ghcZR");
const $1d34fb7ba3f90e48$var$EditorWrapper = (props)=>{
    const appearance = 'chromeless';
    const { editorProps: editorProps, options: options } = props;
    const { type: type = 'user-input', onChange: onChange, onInputChange: onInputChange, onADFChange: onADFChange, defaultValue: defaultValue, enableLinks: enableLinks, setFocusHandlers: setFocusHandlers, setClearHandler: setClearHandler, ariaLabel: ariaLabel } = editorProps;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const handleChange = (0, $eJOHy.useCallback)((editorView)=>{
        const textSerializer = (0, $1LVxc.default).fromSchema(editorView.state.schema);
        const text = textSerializer.serializeFragment(editorView.state.doc.content);
        const adf = (0, $9Ssie.toJSON)(editorView.state.doc);
        onChange?.({
            text: text,
            adf: adf
        });
        onADFChange?.(adf);
        onInputChange?.(text);
    }, [
        onChange,
        onADFChange,
        onInputChange
    ]);
    const onSave = (0, $eJOHy.useCallback)((editorView)=>{
        handleChange(editorView);
    }, [
        handleChange
    ]);
    // We could have created preset outside PromptEditor component,
    //  but currently placeholder prop ComposableEditor is not working.
    // We have to pass placeholder to placeholder plugin.
    // That's why using usePreset, who memoize preset.
    const { preset: preset, editorApi: editorApi } = (0, $hzPqg.usePreset)(()=>(0, $ghcZR.createAIPromptPreset)({
            ...options,
            placeholder: {
                placeholder: editorProps.placeholder
            },
            onSave: onSave,
            enableLinks: enableLinks
        }), [
        options,
        editorProps.placeholder
    ]);
    const editorViewRef = (0, $eJOHy.useRef)(null);
    const onEditorReady = (0, $eJOHy.useCallback)((editorActions)=>{
        if (setClearHandler) setClearHandler(()=>editorActions.clear());
        const editorView = editorActions._privateGetEditorView();
        if (editorView) {
            editorViewRef.current = editorView;
            if (!editorActions.isDocumentEmpty()) editorView.dispatch(editorView.state.tr.setSelection(new (0, $3lIcL.AllSelection)(editorView.state.doc)));
        }
    }, [
        setClearHandler
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (setFocusHandlers) /**
			 * We need to expose clear function through ref because
			 *  changing defaultValue does not clear editor.
			 */ setFocusHandlers(editorApi?.core?.actions.blur, editorApi?.core?.actions.focus);
    }, [
        editorApi,
        setFocusHandlers
    ]);
    // Skip any toolbars that displays in the editor, like Link Picker toolbar
    // Yes, it's ugly, but it's easier way, because we can't have access to the PromptEditor
    // floating toolbar.
    const stopPropagationForFloatingToolbar = (0, $eJOHy.useCallback)((event)=>{
        const eventFloatingToolbar = event.target instanceof HTMLElement ? event.target.closest('[data-testid="editor-floating-toolbar"]') : null;
        // Check that floating toolbar is a child of the current target,
        // i.e. it's a child of current the editor.
        if (eventFloatingToolbar && event.currentTarget.contains(eventFloatingToolbar)) event.stopPropagation();
    }, []);
    const addItemButton = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $20HYH.AddItemButton), {});
    return(// eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        onKeyDown: stopPropagationForFloatingToolbar,
        onKeyUp: stopPropagationForFloatingToolbar,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $2sLVw.default), {
            gap: "space.050",
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJ0dy.ComposableEditor), {
                    mentionProvider: options.mentionProvider,
                    appearance: appearance,
                    minHeight: 20,
                    maxHeight: 200,
                    preset: preset,
                    assistiveLabel: ariaLabel ?? formatMessage((0, $d7OCi.aiMessages).promptbuilderAriaLabel),
                    shouldFocus: editorProps.autoFocus ?? true,
                    defaultValue: defaultValue,
                    onChange: handleChange,
                    // We will remove use of onEditorReady when editorApi provides a matching "clear()" action.
                    onEditorReady: onEditorReady
                }),
                (0, $eGOwo.fg)('platform_editor_ai_in_document_streaming') ? type === 'interrogate' ? addItemButton : null : (type === 'user-input' || type === 'interrogate') && /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
                    children: [
                        options.enableLinks && options.linkPicker && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $i3bYv.LinkPickerButton), {
                            editorApi: editorApi,
                            promptType: type
                        }),
                        options.mentionProvider && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cHPqZ.MentionButton), {
                            editorApi: editorApi,
                            promptType: type
                        })
                    ]
                })
            ]
        })
    }));
};
function $1d34fb7ba3f90e48$export$df4eed2eacb29ddb(options) {
    return (props)=>{
        const editorProps = {
            editorProps: props,
            options: options
        };
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kCWwL.default), {
            children: /*#__PURE__*/ (0, $gt9Am.jsx)($1d34fb7ba3f90e48$var$EditorWrapper, {
                ...editorProps
            })
        });
    };
}

});
parcelRegister("d7OCi", function(module, exports) {

$parcel$export(module.exports, "aiMessages", () => $3f8ff26c7f1ec876$export$480e55f805d7990f);

var $7qGN1 = parcelRequire("7qGN1");
const $3f8ff26c7f1ec876$export$480e55f805d7990f = (0, $7qGN1.defineMessages)({
    // Event hub messages
    eventHubfallbackSuggestedTitle: {
        id: 'fabric.editor.ai.eventHub.fallbackSuggestedTitle',
        defaultMessage: 'Page title',
        description: 'A fallback suggested title for the suggest title prompt'
    },
    eventHubfallbackSuggestedTitlePrefix: {
        id: 'fabric.editor.ai.eventHub.fallbackSuggestedTitlePrefix',
        defaultMessage: 'Page',
        description: 'A fallback suggested title prefix for the suggest title prompt'
    },
    // Toolbar messages
    aiToolbarTitle: {
        id: 'fabric.editor.ai.toolbar.titleText',
        defaultMessage: 'Atlassian Intelligence',
        description: 'Title for Atlassian Intelligence button in editor selection floating toolbar'
    },
    improveWritingToolbarIconTitle: {
        id: 'fabric.editor.ai.toolbar.improveWriting.title',
        defaultMessage: 'Improve writing',
        description: 'Title for an option to use Atlassian Intellgience to improve the writing of content currently selected by the user'
    },
    improveWritingToolbarIconTooltip: {
        id: 'fabric.editor.ai.toolbar.improveWriting.tooltip',
        defaultMessage: 'Tell Atlassian Intelligence to improve the writing of your selection',
        description: 'Tooltip text for an option to use Atlassian Intellgience to improve the writing of content currently selected by the user'
    },
    askAIToolbarIconTitle: {
        id: 'fabric.editor.ai.toolbar.askAI.title',
        defaultMessage: 'Ask AI',
        description: 'Title for an option to use Atlassian Intellgience'
    },
    askRovoInputButtonLabel: {
        id: 'fabric.editor.ai.toolbar.askRovoInputButton.label',
        defaultMessage: 'Ask Rovo...',
        description: 'Label for the input button prompting user to type a query to Rovo.'
    },
    askAIToolbarIconTooltip: {
        id: 'fabric.editor.ai.toolbar.tryAI.tooltip',
        defaultMessage: 'Open Atlassian Intelligence',
        description: 'Tooltip text for an option to use Atlassian Intellgience'
    },
    askAIToolbarIconTooltipQuickCommand: {
        id: 'fabric.editor.ai.toolbar.tryAI.tooltip.quickCommand',
        defaultMessage: "Ask AI {key}+'",
        description: 'Tooltip text for an option to use Atlassian Intellgience with quick command'
    },
    tryAIToolbarIconTitle: {
        id: 'fabric.editor.ai.toolbar.tryAI.title',
        defaultMessage: 'Try AI',
        description: 'Title for an option to use Atlassian Intellgience'
    },
    tryAIToolbarIconTooltip: {
        id: 'fabric.editor.ai.toolbar.tryAI.tooltip',
        defaultMessage: 'Open Atlassian Intelligence',
        description: 'Tooltip text for an option to use Atlassian Intellgience'
    },
    simplifiedAIToolbarIconTitle: {
        id: 'fabric.editor.ai.toolbar.simplifiedAI.title',
        defaultMessage: 'AI',
        description: 'Title for Atlassian Intelligence button in editor selection floating toolbar'
    },
    // Prebuilt messages
    atlasGenerateContentConfigItemDescription: {
        id: 'fabric.editor.ai.atlas-prebuilt.atlasGenerateContentConfigItemDescription',
        defaultMessage: `Generates content to be inserted into the update`,
        description: 'Description for AI Generate content prompt'
    },
    atlasSummarizePageConfigItemDescription: {
        id: 'fabric.editor.ai.atlas-prebuilt.atlasSummarizePageConfigItemDescription',
        defaultMessage: `Summarizes the content of the update`,
        description: 'Description for AI Summarise content prompt'
    },
    confluenceChangeToneSelectionToolbarDropdownMenuTitle: {
        id: 'fabric.editor.ai.confluence-prebuilt.confluenceChangeToneSelectionToolbarDropdownMenuTitle',
        defaultMessage: 'Change tone',
        description: 'Title for Atlassian Intelligence "Change Tone" dropdown in editor selection floating toolbar'
    },
    confluenceRewriteSelectionToolbarDropdownMenuTitle: {
        id: 'fabric.editor.ai.confluence-prebuilt.confluenceRewriteSelectionToolbarDropdownMenuTitle',
        defaultMessage: 'Rewrite',
        description: 'Title for Atlassian Intelligence "Rewrite" dropdown in editor selection floating toolbar'
    },
    confluenceTranslateSelectionToolbarDropdownMenuTitle: {
        id: 'fabric.editor.ai.confluence-prebuilt.confluenceTranslateSelectionToolbarDropdownMenuTitle',
        defaultMessage: 'Translate',
        description: 'Title for Atlassian Intelligence "Translate" dropdown in editor selection floating toolbar'
    },
    // AI Panel Action items messages
    actionItemsPageTitle: {
        id: 'fabric.editor.ai.ai-panels.actionItemsPageTitle',
        defaultMessage: `Action items panel (Beta)`,
        description: 'Title for AI action items panel'
    },
    actionItemsPageDescription: {
        id: 'fabric.editor.ai.ai-panels.actionItemsPageDescription',
        defaultMessage: `Use Atlassian Intelligence to find action items and display in a panel`,
        description: 'Description for AI action items panel'
    },
    // AI Panel Summarise page messages
    summarizePageTitle: {
        id: 'fabric.editor.ai.ai-panels.summarizePageTitle',
        defaultMessage: `Page summary panel (Beta)`,
        description: 'Title for AI summary panel'
    },
    summarisePageDescription: {
        id: 'fabric.editor.ai.ai-panels.summarizePageDescription',
        defaultMessage: `Use Atlassian Intelligence to summarize this page and display in a panel`,
        description: 'Description for AI summary panel'
    },
    // Agent messages
    agentsDropdownTitle: {
        id: 'rovo.agents.dropdown.title',
        defaultMessage: 'Agents',
        description: 'Title for the agents dropdown in the editor toolbar'
    },
    agentsViewAgentsLabel: {
        id: 'rovo.agents.dropdown.viewAgents.label',
        defaultMessage: 'View all agents',
        description: 'Label for the dropdown option that allows a user to View all available Agents'
    },
    // Error messages
    unhandledErrorMessage: {
        id: 'fabric.editor.ai.experience-application.unhandledErrorMessage',
        defaultMessage: "We're having trouble. Close the dialog and try again.",
        description: 'Message to users that displays when an unexpected error happens'
    },
    markdownErrorMessage: {
        id: 'fabric.editor.ai.experience-application.error-boundary.markdownErrorMessage',
        defaultMessage: "We're having trouble generating the preview. Close the dialog and try again.",
        description: 'Message to users that displays when an error occurs while generating a preview.'
    },
    // Prompt Builder messages
    promptbuilderAriaLabel: {
        id: 'fabric.editor.ai.commandPalette.promptBuilderForm.generateContent.ariaLabel',
        defaultMessage: 'Ask Atlassian Intelligence',
        description: 'Aria label for prompt builder form'
    },
    promptBuilderFromButton: {
        id: 'fabric.editor.ai.commandPalette.promptBuilderForm.buttons.submit',
        defaultMessage: 'Generate',
        description: 'Label for the Submit button in the command palette'
    },
    // AI Smart button messages
    aiSmartButtonDynamicSurfaceSelectedContent: {
        id: 'fabric.editor.ai.ai-smart-button.context.reference',
        defaultMessage: 'Selected content',
        description: 'When there is selection, show the selected content in the AI dynamic surface panel'
    }
});

});

parcelRegister("9Ssie", function(module, exports) {

$parcel$export(module.exports, "isParagraph", () => $842b6525224fe87c$export$d7ae8c533ae18832);
$parcel$export(module.exports, "isText", () => $842b6525224fe87c$export$1879817ac5c922b7);
$parcel$export(module.exports, "isLinkMark", () => $842b6525224fe87c$export$5dfeda3a9e6fe056);
$parcel$export(module.exports, "SelectedState", () => $842b6525224fe87c$export$a6212ae0c82963af);
$parcel$export(module.exports, "isNodeSelectedOrInRange", () => $842b6525224fe87c$export$5125f50e751e84db);
$parcel$export(module.exports, "isSupportedInParent", () => $842b6525224fe87c$export$b6e38334b1fb4d1b);
$parcel$export(module.exports, "isMediaNode", () => $842b6525224fe87c$export$d6ca4605aefeca32);
$parcel$export(module.exports, "isNodeBeforeMediaNode", () => $842b6525224fe87c$export$cfaa7840b0c93780);
$parcel$export(module.exports, "toJSON", () => $842b6525224fe87c$export$54fd2c36b5cc6731);
$parcel$export(module.exports, "nodeToJSON", () => $842b6525224fe87c$export$3a858d3babd60825);

var $lovmf = parcelRequire("lovmf");

var $BmspC = parcelRequire("BmspC");
const $842b6525224fe87c$export$cdc577fd3f583194 = (tr)=>{
    const nodes = [];
    const steps = tr.steps || [];
    steps.forEach((step)=>{
        step.getMap().forEach((oldStart, oldEnd, newStart, newEnd)=>{
            tr.doc.nodesBetween(newStart, Math.min(newEnd, tr.doc.content.size), (node)=>{
                if (!nodes.find((n)=>n === node)) nodes.push(node);
                return false;
            });
        });
    });
    return nodes;
};
const $842b6525224fe87c$export$4c39e41e39b3c449 = (node)=>{
    try {
        node.check(); // this will throw an error if the node is invalid
    } catch (error) {
        return false;
    }
    return true;
};
const $842b6525224fe87c$export$996213f7c272fc6f = (nodes)=>nodes.every($842b6525224fe87c$export$4c39e41e39b3c449);
const $842b6525224fe87c$export$26b9f946b448f23e = (node, type)=>type && node && node.type === type;
const $842b6525224fe87c$export$d7ae8c533ae18832 = (node, schema)=>$842b6525224fe87c$export$26b9f946b448f23e(node, schema.nodes.paragraph);
const $842b6525224fe87c$export$1879817ac5c922b7 = (node, schema)=>$842b6525224fe87c$export$26b9f946b448f23e(node, schema.nodes.text);
const $842b6525224fe87c$export$5dfeda3a9e6fe056 = (node, schema)=>$842b6525224fe87c$export$26b9f946b448f23e(node, schema.marks.link);
var $842b6525224fe87c$export$a6212ae0c82963af = /*#__PURE__*/ function(SelectedState) {
    SelectedState[SelectedState["selectedInRange"] = 0] = "selectedInRange";
    SelectedState[SelectedState["selectedInside"] = 1] = "selectedInside";
    return SelectedState;
}({});
const $842b6525224fe87c$export$5125f50e751e84db = (anchorPosition, headPosition, nodePosition, nodeSize)=>{
    if (typeof nodePosition !== 'number') return null;
    const rangeStart = Math.min(anchorPosition, headPosition);
    const rangeEnd = Math.max(anchorPosition, headPosition);
    const nodeStart = nodePosition;
    const nodeEnd = nodePosition + nodeSize;
    if (anchorPosition === headPosition) return null;
    if (rangeStart <= nodeStart && nodeEnd < rangeEnd || rangeStart < nodeStart && nodeEnd <= rangeEnd) return 0;
    if (nodeStart <= anchorPosition && headPosition <= nodeEnd) return 1;
    return null;
};
const $842b6525224fe87c$export$b6e38334b1fb4d1b = (state, fragment, currentAppearance)=>{
    const depth = currentAppearance === 'embed' || currentAppearance === 'block' ? undefined : -1;
    const parent = state.selection.$from.node(depth);
    return parent && parent.type.validContent(fragment);
};
const $842b6525224fe87c$export$d6ca4605aefeca32 = (node)=>{
    return [
        'media',
        'mediaInline',
        'mediaGroup',
        'mediaSingle'
    ].includes(node.type.name);
};
const $842b6525224fe87c$export$cfaa7840b0c93780 = ($pos, state)=>{
    let nodeBefore = $pos.nodeBefore;
    if (!nodeBefore) {
        const depthOfParent = $pos.depth - 1 || 1;
        const parentNode = (0, $BmspC.findParentNodeOfType)([
            state.schema.nodes[`${$pos.node(depthOfParent).type.name}`]
        ])(state.selection);
        const resolvedPosOfParentNode = parentNode ? state.tr.doc.resolve(parentNode.pos) : undefined;
        const nodeBeforeParent = resolvedPosOfParentNode && resolvedPosOfParentNode.pos < state.doc.nodeSize ? resolvedPosOfParentNode.nodeBefore : undefined;
        if (nodeBeforeParent) nodeBefore = nodeBeforeParent;
    }
    if (nodeBefore) return [
        'media',
        'mediaInline',
        'mediaGroup',
        'mediaSingle'
    ].includes(nodeBefore.type.name);
    return false;
};
const $842b6525224fe87c$var$transformer = new (0, $lovmf.JSONTransformer)();
function $842b6525224fe87c$export$54fd2c36b5cc6731(node) {
    return $842b6525224fe87c$var$transformer.encode(node);
}
function $842b6525224fe87c$export$3a858d3babd60825(node) {
    return $842b6525224fe87c$var$transformer.encodeNode(node);
}

});

parcelRegister("eJ0dy", function(module, exports) {

$parcel$export(module.exports, "ComposableEditor", () => $b35cecd1d6e05771$export$36a7c46ebbddbc5d);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $4623N = parcelRequire("4623N");

var $lGWJD = parcelRequire("lGWJD");
function $b35cecd1d6e05771$export$36a7c46ebbddbc5d(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const AppearanceComponent = (0, $eJOHy.useMemo)(()=>(0, $4623N.default)(props.appearance), [
        props.appearance
    ]);
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lGWJD.CoreEditor), {
        ...props,
        AppearanceComponent: AppearanceComponent
    });
}

});
parcelRegister("4623N", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1d58f65253e0159$export$2e2bcd8739ae039);

var $5bg1T = parcelRequire("5bg1T");

var $oN7a7 = parcelRequire("oN7a7");

var $hjMp1 = parcelRequire("hjMp1");
function $e1d58f65253e0159$export$2e2bcd8739ae039(appearance) {
    appearance = appearance || 'comment';
    switch(appearance){
        case 'full-page':
        case 'full-width':
            return 0, $hjMp1.FullPageEditor;
        case 'chromeless':
            return 0, $5bg1T.default;
        case 'comment':
            return 0, $oN7a7.CommentEditorWithIntl;
        default:
            throw new Error(`Appearance '${appearance}' is not supported by the editor.`);
    }
}

});
parcelRegister("5bg1T", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef3f63f387936899$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $kLQ9a = parcelRequire("kLQ9a");
var $bSToC = parcelRequire("bSToC");

var $frlUM = parcelRequire("frlUM");


var $eGOwo = parcelRequire("eGOwo");

var $AIyOt = parcelRequire("AIyOt");

var $cbSL1 = parcelRequire("cbSL1");

var $92xoS = parcelRequire("92xoS");

var $jyiGU = parcelRequire("jyiGU");

var $7XjxI = parcelRequire("7XjxI");

var $gyhYD = parcelRequire("gyhYD");

var $52GJU = parcelRequire("52GJU");
function $ef3f63f387936899$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ef3f63f387936899$var$scrollbarStylesNew = {
    name: "1tu1yi6",
    styles: "-ms-overflow-style:-ms-autohiding-scrollbar;&::-webkit-scrollbar-corner{display:none;}&::-webkit-scrollbar-thumb{background-color:var(--ds-background-neutral-subtle, #00000000);}&:hover::-webkit-scrollbar-thumb{background-color:var(--ds-background-neutral-bold, #44546F);border-radius:8px;}&::-webkit-scrollbar-thumb:hover{background-color:var(--ds-background-neutral-bold-hovered, #2C3E5D);}"
};
const $ef3f63f387936899$var$chromelessEditorStyles = /*#__PURE__*/ (0, $1NIU8.css)("line-height:20px;height:auto;overflow-x:hidden;overflow-y:auto;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
(0, $e23eba3bf6a7aed3$export$b2380b18b089518f), "max-width:inherit;box-sizing:border-box;word-wrap:break-word;div > .ProseMirror{outline:none;white-space:pre-wrap;padding:0;margin:0;& > :last-child{padding-bottom:var(--ds-space-100, 0.5em);}}");
const $ef3f63f387936899$var$chromelessEditorStylesNew = {
    name: "1236vqr",
    styles: "line-height:20px;height:auto;overflow-x:hidden;overflow-y:auto;max-width:inherit;box-sizing:border-box;word-wrap:break-word;div > .ProseMirror{outline:none;white-space:pre-wrap;padding:0;margin:0;& > :last-child{padding-bottom:var(--ds-space-100, 0.5em);}}"
};
const $ef3f63f387936899$var$extraSpaceLastLineFix = {
    name: "1cghcav",
    styles: ".ProseMirror{& > p:last-of-type{margin-bottom:var(--ds-space-0, 0px);}}"
};
const $ef3f63f387936899$export$fceb9665be86d56e = (0, $jyiGU.createEditorContentStyle)();
$ef3f63f387936899$export$fceb9665be86d56e.displayName = 'ContentArea';
const $ef3f63f387936899$var$EditorContainer = (0, $AIyOt.componentWithCondition)(()=>(0, $92xoS.editorExperiment)('platform_editor_core_static_emotion', true, {
        exposure: true
    }), (0, $7XjxI.default), $ef3f63f387936899$export$fceb9665be86d56e);
const $ef3f63f387936899$var$useEditorViewModePluginState = (0, $kLQ9a.sharedPluginStateHookMigratorFactory)((pluginInjectionApi)=>{
    const { editorViewModeState: editorViewModeState } = (0, $bSToC.useSharedPluginState)(pluginInjectionApi, [
        'editorViewMode'
    ]);
    return editorViewModeState?.mode;
}, (pluginInjectionApi)=>{
    return (0, $frlUM.useSharedPluginStateSelector)(pluginInjectionApi, 'editorViewMode.mode');
});
class $ef3f63f387936899$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    static{
        this.displayName = 'ChromelessEditorAppearance';
    }
    render() {
        return /*#__PURE__*/ (0, $1NIU8.jsx)($ef3f63f387936899$var$RenderWithPluginState, {
            editorAPI: this.props.editorAPI,
            renderChrome: this.renderChrome
        });
    }
    constructor(...args){
        super(...args), this.appearance = 'chromeless', this.containerElement = null, this.renderChrome = ({ maxContentSize: maxContentSize })=>{
            const { editorDOMElement: editorDOMElement, editorView: editorView, editorActions: editorActions, eventDispatcher: eventDispatcher, providerFactory: providerFactory, contentComponents: contentComponents, customContentComponents: customContentComponents, maxHeight: maxHeight, minHeight: minHeight = 30, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, disabled: disabled, dispatchAnalyticsEvent: dispatchAnalyticsEvent, pluginHooks: pluginHooks, featureFlags: featureFlags } = this.props;
            const maxContentSizeReached = Boolean(maxContentSize?.maxContentSizeReached);
            const editorViewMode = $ef3f63f387936899$var$useEditorViewModePluginState(this.props.editorAPI);
            return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $52GJU.default), {
                animate: maxContentSizeReached
            }, /*#__PURE__*/ (0, $1NIU8.jsx)($ef3f63f387936899$export$5ffd32ebea3773c5, {
                maxHeight: maxHeight,
                minHeight: minHeight,
                containerRef: (ref)=>this.containerElement = ref
            }, /*#__PURE__*/ (0, $1NIU8.jsx)($ef3f63f387936899$var$EditorContainer, {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                className: "ak-editor-content-area",
                featureFlags: featureFlags,
                viewMode: editorViewMode,
                appearance: this.appearance
            }, customContentComponents && 'before' in customContentComponents ? customContentComponents.before : customContentComponents, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $gyhYD.default), {
                editorView: editorView,
                editorActions: editorActions,
                eventDispatcher: eventDispatcher,
                providerFactory: providerFactory,
                appearance: this.appearance,
                items: contentComponents,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement,
                containerElement: this.containerElement,
                disabled: !!disabled,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                wrapperElement: this.containerElement,
                pluginHooks: pluginHooks
            }), editorDOMElement, customContentComponents && 'after' in customContentComponents ? customContentComponents.after : null)));
        };
    }
}
const $ef3f63f387936899$var$useMaxContentSizePluginState = (0, $kLQ9a.sharedPluginStateHookMigratorFactory)((pluginInjectionApi)=>{
    const { maxContentSizeState: maxContentSizeState } = (0, $bSToC.useSharedPluginState)(pluginInjectionApi, [
        'maxContentSize'
    ]);
    return {
        maxContentSizeState: maxContentSizeState
    };
}, (pluginInjectionApi)=>{
    const maxContentSizeReached = (0, $frlUM.useSharedPluginStateSelector)(pluginInjectionApi, 'maxContentSize.maxContentSizeReached');
    return {
        maxContentSizeState: maxContentSizeReached === undefined ? undefined : {
            maxContentSizeReached: maxContentSizeReached
        }
    };
});
function $ef3f63f387936899$var$RenderWithPluginState({ renderChrome: renderChrome, editorAPI: editorAPI }) {
    const { maxContentSizeState: maxContentSizeState } = $ef3f63f387936899$var$useMaxContentSizePluginState(editorAPI);
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Fragment), null, renderChrome({
        maxContentSize: maxContentSizeState
    }));
}
function $ef3f63f387936899$var$ChromelessEditorContainerNext({ maxHeight: maxHeight, minHeight: minHeight, children: children, containerRef: containerRef }) {
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: [
            $ef3f63f387936899$var$chromelessEditorStylesNew,
            $ef3f63f387936899$var$scrollbarStylesNew,
            (0, $eGOwo.fg)('platform_fix_extra_space_last_line_comment_editor') && $ef3f63f387936899$var$extraSpaceLastLineFix
        ],
        style: {
            maxHeight: maxHeight ? `${maxHeight}px` : undefined,
            minHeight: `${minHeight}px`
        },
        "data-testid": "chromeless-editor",
        id: "chromeless-editor",
        ref: containerRef
    }, children);
}
function $ef3f63f387936899$var$ChromelessEditorContainerOld({ maxHeight: maxHeight, minHeight: minHeight, children: children, containerRef: containerRef }) {
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: [
            $ef3f63f387936899$var$chromelessEditorStyles,
            maxHeight && /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $1NIU8.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                maxHeight: `${maxHeight}px`
            }),
            /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $1NIU8.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                minHeight: `${minHeight}px`
            }),
            (0, $eGOwo.fg)('platform_fix_extra_space_last_line_comment_editor') && $ef3f63f387936899$var$extraSpaceLastLineFix
        ],
        "data-testid": "chromeless-editor",
        id: "chromeless-editor",
        ref: containerRef
    }, children);
}
const $ef3f63f387936899$export$5ffd32ebea3773c5 = (0, $AIyOt.componentWithCondition)(()=>(0, $cbSL1.expValEquals)('platform_editor_core_static_emotion', 'isEnabled', true), $ef3f63f387936899$var$ChromelessEditorContainerNext, $ef3f63f387936899$var$ChromelessEditorContainerOld);

});
parcelRegister("kLQ9a", function(module, exports) {

$parcel$export(module.exports, "sharedPluginStateHookMigratorFactory", () => $61a0780a1d45508b$export$5fd276487301609);

var $1DmqU = parcelRequire("1DmqU");

var $cbSL1 = parcelRequire("cbSL1");
function $61a0780a1d45508b$export$5fd276487301609(newHook, oldHook) {
    return (0, $1DmqU.conditionalHooksFactory)(()=>(0, $cbSL1.expValEquals)('platform_editor_usesharedpluginstateselector', 'isEnabled', true), newHook, oldHook);
}

});
parcelRegister("1DmqU", function(module, exports) {

$parcel$export(module.exports, "conditionalHooksFactory", () => $c7ee05ec9845cd50$export$691e93bad45e6f07);
/**
 * A factory function to create a conditional hook. The condition must return a boolean value
 * that does not change after initialisation. This function will cache the result of the condition
 * and use it to determine which hook to call. If the condition changes between renders,
 * unexpected behaviour may occur.
 *
 * **This hook should only be used for Feature Gates & Experiments where the value doesn't change.**
 * ```ts
 * // Acceptable use
 * const useMyHook = conditionalHooksFactory(
 *   () => isFeatureEnabled('my-feature'),
 *   useMyNewHook,
 *   useMyOldHook,
 * );
 *
 * // Not acceptable use
 * const useMyHook = conditionalHooksFactory(
 *    () => someVarThatCouldChange === 'my-value',
 *    useMyNewHook,
 *    useMyOldHook,
 * );
 * ```
 *
 * @param condition The condition function that will be used to determine which hook to call.
 * @param newHook The new hook to call if the condition is true.
 * @param oldHook The old hook to call if the condition is false.
 * @returns A migrator hook that will call either the new hook or the old hook based on the condition.
 */ function $c7ee05ec9845cd50$export$691e93bad45e6f07(condition, newHook, oldHook) {
    // Since we are conditionally rendering hooks, we need to ensure the condition result won't change
    // between renders. We can do this by caching the result of the condition.
    let conditionCache = null;
    return (...args)=>{
        const conditionResult = condition(); // call each time so we can track exposures
        if (conditionCache === null) conditionCache = conditionResult;
        if (conditionCache) return newHook(...args);
        else return oldHook(...args);
    };
}

});


parcelRegister("bSToC", function(module, exports) {

$parcel$export(module.exports, "useSharedPluginState", () => $b02d4f6815d6953c$export$a4c4fd90e2b72baa);

var $eJOHy = parcelRequire("eJOHy");

var $3s8bj = parcelRequire("3s8bj");
/**
 *
 * Directly map object values
 *
 * @param object The object to transform
 * @param mapFunction The function to map an old value to new one
 * @returns Object with the same key but transformed values
 *
 */ function $b02d4f6815d6953c$var$mapValues(object, mapFunction) {
    return Object.entries(object).reduce((acc, [key, value])=>({
            ...acc,
            [key]: mapFunction(value)
        }), {});
}
// When we use the `useSharedPluginState` example: `useSharedPluginState(api, ['width'])`
// it will re-render every time the component re-renders as the array "['width']" is seen as an update.
// This hook is used to prevent re-renders due to this.
function $b02d4f6815d6953c$var$useStaticPlugins(plugins) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $eJOHy.useMemo)(()=>plugins, []);
}
function $b02d4f6815d6953c$export$a4c4fd90e2b72baa(injectionApi, plugins, options) {
    const pluginNames = $b02d4f6815d6953c$var$useStaticPlugins(plugins);
    // Create a memoized object containing the named plugins
    const namedExternalPlugins = (0, $eJOHy.useMemo)(()=>pluginNames.reduce((acc, pluginName)=>({
                ...acc,
                [`${String(pluginName)}State`]: injectionApi?.[pluginName]
            }), {}), [
        injectionApi,
        pluginNames
    ]);
    return $b02d4f6815d6953c$var$useSharedPluginStateInternal(namedExternalPlugins, options);
}
function $b02d4f6815d6953c$var$useSharedPluginStateInternal(externalPlugins, options = {}) {
    const [pluginStates, setPluginState] = (0, $eJOHy.useState)($b02d4f6815d6953c$var$mapValues(externalPlugins, (value)=>options.disabled ? undefined : value?.sharedState.currentState()));
    const refStates = (0, $eJOHy.useRef)({});
    const mounted = (0, $eJOHy.useRef)(false);
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (options.disabled) return;
        const debouncedPluginStateUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(()=>{
            setPluginState((currentPluginStates)=>({
                    ...currentPluginStates,
                    ...refStates.current
                }));
        });
        // If we re-render this hook due to a change in the external
        // plugins we need to push a state update to ensure we have
        // the most current state.
        if (mounted.current) {
            refStates.current = $b02d4f6815d6953c$var$mapValues(externalPlugins, (value)=>value?.sharedState.currentState());
            debouncedPluginStateUpdate();
        }
        const unsubs = Object.entries(externalPlugins).map(([pluginKey, externalPlugin])=>{
            return externalPlugin?.sharedState.onChange(({ nextSharedState: nextSharedState, prevSharedState: prevSharedState })=>{
                if (prevSharedState === nextSharedState) return;
                refStates.current[pluginKey] = nextSharedState;
                debouncedPluginStateUpdate();
            });
        });
        mounted.current = true;
        return ()=>{
            refStates.current = {};
            unsubs.forEach((cb)=>cb?.());
        };
    // Do not re-render due to state changes, we only need to check this when
    // setting up the initial subscription.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        externalPlugins,
        options.disabled
    ]);
    return pluginStates;
}

});

parcelRegister("frlUM", function(module, exports) {

$parcel$export(module.exports, "useSharedPluginStateSelector", () => $d936bc043638308c$export$feb16861fe41d066);

var $eJOHy = parcelRequire("eJOHy");

var $9Dhvc = parcelRequire("9Dhvc");

var $cSmYj = parcelRequire("cSmYj");

var $eJQEz = parcelRequire("eJQEz");
function $d936bc043638308c$export$feb16861fe41d066(api, plugin, options = {}) {
    const transformer = (0, $eJOHy.useCallback)((pluginState)=>{
        const [pluginName, ...properties] = plugin.split('.');
        if (!pluginState || properties?.length === 0) return undefined;
        return (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(pluginState?.[`${pluginName}State`], properties);
    }, [
        plugin
    ]);
    const pluginNameArray = (0, $eJOHy.useMemo)(()=>{
        const [pluginName] = plugin.split('.');
        return [
            pluginName
        ];
    }, [
        plugin
    ]);
    const initialState = (0, $eJOHy.useMemo)(()=>{
        if (options.disabled) return;
        const [pluginName] = plugin.split('.');
        return transformer({
            [`${pluginName}State`]: api?.[pluginName]?.sharedState.currentState()
        });
    }, [
        plugin,
        api,
        options.disabled,
        transformer
    ]);
    return $d936bc043638308c$var$useSharedPluginStateSelectorInternal(api, pluginNameArray, transformer, initialState, options);
}
function $d936bc043638308c$var$useSharedPluginStateSelectorInternal(api, plugins, transformer, initialState, options = {}) {
    const [selectedPluginState, setSelectedPluginState] = (0, $eJOHy.useState)(()=>initialState);
    (0, $eJQEz.usePluginStateEffect)(api, plugins, (pluginStates)=>{
        // `pluginStates`: This is the same type through inference - but typescript doesn't recognise them as they are computed slightly differently
        const transformedValue = transformer(pluginStates);
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(transformedValue, selectedPluginState)) setSelectedPluginState(()=>transformedValue);
    }, options);
    return selectedPluginState;
}

});
parcelRegister("eJQEz", function(module, exports) {

$parcel$export(module.exports, "usePluginStateEffect", () => $f7a31f1b90f34787$export$85f3fdc261c569b3);

var $eJOHy = parcelRequire("eJOHy");

var $3s8bj = parcelRequire("3s8bj");

var $cbSL1 = parcelRequire("cbSL1");
/**
 *
 * Directly map object values
 *
 * @param object The object to transform
 * @param mapFunction The function to map an old value to new one
 * @returns Object with the same key but transformed values
 *
 */ function $f7a31f1b90f34787$var$mapValues(object, mapFunction) {
    return Object.entries(object).reduce((acc, [key, value])=>({
            ...acc,
            [key]: mapFunction(value)
        }), {});
}
// When we use the `useSharedPluginState` example: `useSharedPluginState(api, ['width'])`
// it will re-render every time the component re-renders as the array "['width']" is seen as an update.
// This hook is used to prevent re-renders due to this.
function $f7a31f1b90f34787$var$useStaticPlugins(plugins) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $eJOHy.useMemo)(()=>plugins, []);
}
function $f7a31f1b90f34787$export$85f3fdc261c569b3(injectionApi, plugins, effect, options = {}) {
    const pluginNames = $f7a31f1b90f34787$var$useStaticPlugins(plugins);
    // Create a memoized object containing the named plugins
    const namedExternalPlugins = (0, $eJOHy.useMemo)(()=>pluginNames.reduce((acc, pluginName)=>({
                ...acc,
                [`${String(pluginName)}State`]: injectionApi?.[pluginName]
            }), {}), [
        injectionApi,
        pluginNames
    ]);
    $f7a31f1b90f34787$var$usePluginStateEffectInternal(namedExternalPlugins, effect, options);
}
function $f7a31f1b90f34787$var$usePluginStateEffectInternal(externalPlugins, effect, options = {}) {
    const refStates = (0, $eJOHy.useRef)();
    const cleanup = (0, $eJOHy.useRef)();
    const latestEffect = (0, $eJOHy.useRef)(effect);
    // We should store the latest effect in a reference so it is more intuitive to the user
    // and we are not causing a memory leak by having references to old state.
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (options.disabled || !(0, $cbSL1.expValEquals)('platform_editor_usesharedpluginstateselector', 'isEnabled', true)) return;
        latestEffect.current = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(effect);
        return ()=>{
            latestEffect.current = undefined;
        };
    }, [
        effect,
        options.disabled
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (options.disabled || (0, $cbSL1.expValEquals)('platform_editor_usesharedpluginstateselector', 'isEnabled', true)) return;
        latestEffect.current = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(effect);
        return ()=>{
            latestEffect.current = undefined;
        };
    }, [
        effect,
        options.disabled
    ]);
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (options.disabled) return;
        // Update the reference for this plugin and activate the effect
        refStates.current = $f7a31f1b90f34787$var$mapValues(externalPlugins, (value)=>value?.sharedState.currentState());
        cleanup.current = latestEffect.current?.(refStates.current);
        const unsubs = Object.entries(externalPlugins).map(([pluginKey, externalPlugin])=>externalPlugin?.sharedState.onChange(({ nextSharedState: nextSharedState, prevSharedState: prevSharedState })=>{
                if (prevSharedState !== nextSharedState && refStates.current) {
                    // Update the reference for this plugin and activate the effect
                    refStates.current[pluginKey] = nextSharedState;
                    cleanup.current = latestEffect.current?.(refStates.current);
                }
            }));
        return ()=>{
            refStates.current = undefined;
            unsubs.forEach((cb)=>cb?.());
            cleanup.current?.();
        };
    // Do not re-run if the `effect` changes - this is not expected with `useEffect` or similar hooks
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        externalPlugins,
        options.disabled
    ]);
}

});


/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
const $e23eba3bf6a7aed3$export$b2380b18b089518f = `
  -ms-overflow-style: -ms-autohiding-scrollbar;

  &::-webkit-scrollbar {
    overflow: hidden,
  }

  &::-webkit-scrollbar-corner {
    display: none;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${"var(--ds-background-neutral-subtle, #00000000)"};
  }

  &:hover::-webkit-scrollbar-thumb {
    background-color: ${"var(--ds-background-neutral-bold, #44546F)"};
    border-radius: 8px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: ${"var(--ds-background-neutral-bold-hovered, #2C3E5D)"};
  }
`;

parcelRegister("jyiGU", function(module, exports) {

$parcel$export(module.exports, "createEditorContentStyle", () => $9f876c050f409026$export$91e7c20fa6d6a4b5);
/* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ /* eslint-disable react-hooks/rules-of-hooks */ /* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression -- Requires manual remediation over time due to use of unsafe nested mixins */ /**
                                                                                                                                                                                                                                                                                   * @jsxRuntime classic
                                                                                                                                                                                                                                                                                   * @jsx jsx
                                                                                                                                                                                                                                                                                   */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");
var $loabE = parcelRequire("loabE");

var $7EdFW = parcelRequire("7EdFW");

var $eh3wX = parcelRequire("eh3wX");

var $8iUeU = parcelRequire("8iUeU");
var $dXRfX = parcelRequire("dXRfX");

var $av5GH = parcelRequire("av5GH");

var $7kf0Z = parcelRequire("7kf0Z");

var $3N6pN = parcelRequire("3N6pN");

var $l8DE0 = parcelRequire("l8DE0");
var $eDJ4M = parcelRequire("eDJ4M");
var $jp9xB = parcelRequire("jp9xB");
var $gBkUB = parcelRequire("gBkUB");
var $j7par = parcelRequire("j7par");
var $fDsDd = parcelRequire("fDsDd");
var $kd9l4 = parcelRequire("kd9l4");
var $is7NW = parcelRequire("is7NW");
var $e2Ny4 = parcelRequire("e2Ny4");
var $cidLz = parcelRequire("cidLz");
var $d1Z2v = parcelRequire("d1Z2v");
var $vDp4P = parcelRequire("vDp4P");
var $kvnqO = parcelRequire("kvnqO");
var $cYzoj = parcelRequire("cYzoj");
var $fH5IE = parcelRequire("fH5IE");
var $1cdIU = parcelRequire("1cdIU");
var $lI1SP = parcelRequire("lI1SP");
var $aaqba = parcelRequire("aaqba");
var $hkyHj = parcelRequire("hkyHj");
var $gZAVf = parcelRequire("gZAVf");
var $bhdjn = parcelRequire("bhdjn");
var $iCwuj = parcelRequire("iCwuj");
var $6up3L = parcelRequire("6up3L");
parcelRequire("fOha9");
var $cC0Do = parcelRequire("cC0Do");
parcelRequire("fTxct");
var $b1G5H = parcelRequire("b1G5H");
parcelRequire("kebxX");
var $6HZZD = parcelRequire("6HZZD");
parcelRequire("hFwc2");
var $7D0Jo = parcelRequire("7D0Jo");

var $7yBx7 = parcelRequire("7yBx7");
var $2N2k8 = parcelRequire("2N2k8");
var $egs2l = parcelRequire("egs2l");

var $eGOwo = parcelRequire("eGOwo");

var $9Letn = parcelRequire("9Letn");

var $92xoS = parcelRequire("92xoS");

var $58yRG = parcelRequire("58yRG");

var $fDrn5 = parcelRequire("fDrn5");

var $e8cBm = parcelRequire("e8cBm");

var $4e15Z = parcelRequire("4e15Z");

var $320JB = parcelRequire("320JB");

var $afDZa = parcelRequire("afDZa");

var $aQRv5 = parcelRequire("aQRv5");

var $kVRJd = parcelRequire("kVRJd");

var $h6DrW = parcelRequire("h6DrW");

var $3RA4L = parcelRequire("3RA4L");

var $g3llj = parcelRequire("g3llj");

var $llrTf = parcelRequire("llrTf");

var $1UKpI = parcelRequire("1UKpI");
function $9f876c050f409026$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $9f876c050f409026$export$4ea5976125a01ffa = /*#__PURE__*/ (0, $1NIU8.css)(".ProseMirror{", (0, $vDp4P.linkSharedStyle)(), ";}");
const $9f876c050f409026$var$ruleStyles = ()=>/*#__PURE__*/ (0, $1NIU8.css)(".ProseMirror{", (0, $lI1SP.ruleSharedStyles)(), ";hr{cursor:pointer;padding:var(--ds-space-050, 4px) 0;margin:var(--ds-space-300, 24px) 0;background-clip:content-box;&.", (0, $7yBx7.akEditorSelectedNodeClassName), "{outline:none;background-color:", `var(--ds-border-selected, ${(0, $7yBx7.akEditorSelectedBorderColor)})`, ";}}}");
const $9f876c050f409026$var$mentionNodeStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.editor-mention-primitive': {
        display: 'inline',
        borderRadius: '20px',
        cursor: 'pointer',
        padding: '0 0.3em 2px 0.23em',
        // To match `packages/elements/mention/src/components/Mention/PrimitiveMention.tsx` implementation
        // we match the line height exactly
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: '1.714',
        fontWeight: "var(--ds-font-weight-regular, 400)",
        wordBreak: 'break-word',
        background: "var(--ds-background-neutral, #091E420F)",
        border: '1px solid transparent',
        color: "var(--ds-text-subtle, #44546F)",
        '&:hover': {
            background: "var(--ds-background-neutral-hovered, #091E4224)"
        },
        '&:active': {
            background: "var(--ds-background-neutral-pressed, #091E424F)"
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.editor-mention-primitive.mention-restricted': {
        background: 'transparent',
        border: `1px solid ${"var(--ds-border-bold, #758195)"}`,
        color: "var(--ds-text, #172B4D)",
        '&:hover': {
            background: 'transparent'
        },
        '&:active': {
            background: 'transparent'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.editor-mention-primitive.mention-self': {
        background: "var(--ds-background-brand-bold, #0C66E4)",
        border: '1px solid transparent',
        color: "var(--ds-text-inverse, #FFFFFF)",
        '&:hover': {
            background: "var(--ds-background-brand-bold-hovered, #0055CC)"
        },
        '&:active': {
            background: "var(--ds-background-brand-bold-pressed, #09326C)"
        }
    }
});
// The feature-gate for this is dependent on the use of refreshed typography - bear this in mind when cleaning up
// This is currently enforced through statsig prerequisite gates, as per #help-afm recommendation.
// So it will need to be considered if the typography gates are still in use when this is cleaned up.
const $9f876c050f409026$var$mentionNodeStylesMixin_fg_platform_editor_centre_mention_padding = {
    name: "1n5x4b4",
    styles: ".editor-mention-primitive{padding:1px 0.3em 1px 0.23em;}"
};
const $9f876c050f409026$var$mentionSelectionStyles = /*#__PURE__*/ (0, $1NIU8.css)(".danger{.editor-mention-primitive{box-shadow:0 0 0 ", (0, $7yBx7.akEditorSelectedBorderSize), "px ", (0, $7yBx7.akEditorDeleteBorder), ";background-color:", `var(--ds-background-danger, ${(0, $7yBx7.akEditorDeleteBackgroundWithOpacity)})`, ";}}.", (0, $7yBx7.akEditorSelectedNodeClassName), ">.editor-mention-primitive,.", (0, $7yBx7.akEditorSelectedNodeClassName), ">.editor-mention-primitive.mention-self,.", (0, $7yBx7.akEditorSelectedNodeClassName), ">.editor-mention-primitive.mention-restricted{", (0, $2N2k8.getSelectionStyles)([
    (0, $egs2l.SelectionStyle).BoxShadow,
    (0, $egs2l.SelectionStyle).Background
]), "color:var(--ds-text-subtle, #44546F);}");
const $9f876c050f409026$var$mentionsSelectionStylesWithSearchMatch = /*#__PURE__*/ (0, $1NIU8.css)(".danger{.editor-mention-primitive{box-shadow:0 0 0 ", (0, $7yBx7.akEditorSelectedBorderSize), "px ", (0, $7yBx7.akEditorDeleteBorder), ";background-color:", `var(--ds-background-danger, ${(0, $7yBx7.akEditorDeleteBackgroundWithOpacity)})`, ";}}.", (0, $7yBx7.akEditorSelectedNodeClassName), ":not(.search-match-block)>.editor-mention-primitive,.", (0, $7yBx7.akEditorSelectedNodeClassName), ":not(.search-match-block)>.editor-mention-primitive.mention-self,.", (0, $7yBx7.akEditorSelectedNodeClassName), ":not(.search-match-block)>.editor-mention-primitive.mention-restricted{", (0, $2N2k8.getSelectionStyles)([
    (0, $egs2l.SelectionStyle).BoxShadow,
    (0, $egs2l.SelectionStyle).Background
]), "color:var(--ds-text-subtle, #44546F);}.", (0, $7yBx7.akEditorSelectedNodeClassName), ".search-match-block>.editor-mention-primitive,.", (0, $7yBx7.akEditorSelectedNodeClassName), ".search-match-block>.editor-mention-primitive.mention-self,.", (0, $7yBx7.akEditorSelectedNodeClassName), ".search-match-block>.editor-mention-primitive.mention-restricted{", (0, $2N2k8.getSelectionStyles)([
    (0, $egs2l.SelectionStyle).Background
]), "color:var(--ds-text-subtle, #44546F);}");
const $9f876c050f409026$var$mentionsStyles = /*#__PURE__*/ (0, $1NIU8.css)(".", (0, $av5GH.MentionSharedCssClassName).MENTION_CONTAINER, "{&.", (0, $7yBx7.akEditorSelectedNodeClassName), " [data-mention-id]>span{", (0, $2N2k8.getSelectionStyles)([
    (0, $egs2l.SelectionStyle).BoxShadow,
    (0, $egs2l.SelectionStyle).Background
]), "color:var(--ds-text-subtle, #44546F);}}.danger{.", (0, $av5GH.MentionSharedCssClassName).MENTION_CONTAINER, ".", (0, $7yBx7.akEditorSelectedNodeClassName), ">span>span>span{box-shadow:0 0 0 ", (0, $7yBx7.akEditorSelectedBorderSize), "px ", (0, $7yBx7.akEditorDeleteBorder), ";background-color:", `var(--ds-background-danger, ${(0, $7yBx7.akEditorDeleteBackgroundWithOpacity)})`, ";}.", (0, $av5GH.MentionSharedCssClassName).MENTION_CONTAINER, ">span>span>span{background-color:var(--ds-background-neutral, #091E420F);color:var(--ds-text-subtle, #44546F);}}");
const $9f876c050f409026$var$listsStyles = /*#__PURE__*/ (0, $1NIU8.css)(".ProseMirror{li{position:relative;>p:not(:first-child){margin:var(--ds-space-050, 4px) 0 0 0;}>style:first-child+p{margin-top:", (0, $7yBx7.blockNodesVerticalMargin), ";}}&:not([data-node-type='decisionList'])>li,&:not(.", (0, $e2Ny4.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER, ")>li{", (0, $7EdFW.browser).safari ? (0, $gBkUB.codeBlockInListSafariFix) : '', ";}}");
const $9f876c050f409026$var$emojiStyles = /*#__PURE__*/ (0, $1NIU8.css)(".", (0, $dXRfX.EmojiSharedCssClassName).EMOJI_CONTAINER, "{display:inline-block;}.", (0, $dXRfX.EmojiSharedCssClassName).EMOJI_SPRITE, ",.", (0, $dXRfX.EmojiSharedCssClassName).EMOJI_IMAGE, "{background:no-repeat transparent;display:inline-block;height:", (0, $8iUeU.defaultEmojiHeight), "px;max-height:", (0, $8iUeU.defaultEmojiHeight), "px;cursor:pointer;vertical-align:middle;user-select:all;}.", (0, $7yBx7.akEditorSelectedNodeClassName), "{.", (0, $dXRfX.EmojiSharedCssClassName).EMOJI_SPRITE, ",.", (0, $dXRfX.EmojiSharedCssClassName).EMOJI_IMAGE, "{border-radius:2px;", (0, $2N2k8.getSelectionStyles)([
    (0, $egs2l.SelectionStyle).Blanket,
    (0, $egs2l.SelectionStyle).BoxShadow
]), ";}}");
const $9f876c050f409026$export$d3bdc0d52bb6c2c8 = {
    name: "12q9gkf",
    styles: ".ProseMirror .placeholder-decoration{color:var(--ds-text-subtlest, #626F86);width:100%;pointer-events:none;user-select:none;.placeholder-android{pointer-events:none;outline:none;user-select:none;position:absolute;}}"
};
const $9f876c050f409026$var$placeholderOverflowStyles = {
    name: "9a360",
    styles: ".ProseMirror p:has(.placeholder-decoration-hide-overflow){overflow:hidden;white-space:nowrap;text-overflow:ellipsis;}"
};
const $9f876c050f409026$var$placeholderWrapStyles = {
    name: "25qy8u",
    styles: ".ProseMirror mark[data-type-ahead-query=\"true\"]:has(.placeholder-decoration-wrap){white-space:nowrap;}"
};
const $9f876c050f409026$var$firstBlockNodeStylesNew = /*#__PURE__*/ (0, $1NIU8.css)(".ProseMirror{>.", (0, $7kf0Z.PanelSharedCssClassName).prefix, ",>.", (0, $gBkUB.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER, ",>.", (0, $e2Ny4.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER, ",>div[data-task-list-local-id],>div[data-layout-section],>.", (0, $is7NW.expandClassNames).prefix, "{&:first-child{margin-top:0;}}>hr:first-child,>.ProseMirror-widget:first-child+hr{margin-top:0;}}");
// Make sure the first floating toolbar button has focus ring when focused via .focus()
const $9f876c050f409026$var$firstFloatingToolbarButtonStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    'button.first-floating-toolbar-button:focus': {
        outline: `2px solid ${"var(--ds-border-focused, #2684FF)"}`
    }
});
// The breakpoint for small devices is 1266px, copied from getBreakpoint in platform/packages/editor/editor-common/src/ui/WidthProvider/index.tsx
const $9f876c050f409026$var$akEditorBreakpointForSmallDevice = `1266px`;
// We are going to deprecate this in near future
// Currently, we are migrating content styles in packages/editor/editor-core/src/ui/EditorContentContainer.tsx
// Under editor experiment platform_editor_core_static_emotion
// If you are making changes to this file, please make sure to update in EditorContentContainer.tsx as well
var $9f876c050f409026$var$_ref = {
    name: "1li8ktf",
    styles: ".hyperlink-open-link{min-width:24px;svg{max-width:18px;}}"
};
var $9f876c050f409026$var$_ref2 = {
    name: "p4ha7",
    styles: ".ProseMirror-hideselection{caret-color:transparent;}"
};
var $9f876c050f409026$var$_ref3 = {
    name: "p4ha7",
    styles: ".ProseMirror-hideselection{caret-color:transparent;}"
};
const $9f876c050f409026$var$legacyContentStyles = (props)=>/*#__PURE__*/ (0, $1NIU8.css)("--ak-editor--default-gutter-padding:", (0, $7yBx7.akEditorGutterPadding), "px;--ak-editor--large-gutter-padding:", (0, $7yBx7.akEditorGutterPaddingDynamic)(), "px;--ak-editor--default-layout-width:", (0, $7yBx7.akEditorDefaultLayoutWidth), "px;--ak-editor--full-width-layout-width:", (0, $7yBx7.akEditorFullWidthLayoutWidth), "px;--ak-editor--line-length:min(\n\t\tcalc(100cqw - var(--ak-editor--large-gutter-padding) * 2),\n\t\tvar(--ak-editor--default-layout-width)\n\t);--ak-editor--breakout-wide-layout-width:", (0, $7yBx7.akEditorCalculatedWideLayoutWidthSmallViewport), "px;--ak-editor--breakout-full-page-guttering-padding:calc(\n\t\tvar(--ak-editor--large-gutter-padding) * 2 + var(--ak-editor--default-gutter-padding)\n\t);--ak-editor--breakout-fallback-width:calc(\n\t\t100cqw - var(--ak-editor--breakout-full-page-guttering-padding)\n\t);.fabric-editor--full-width-mode{--ak-editor--line-length:min(\n\t\t\tcalc(100cqw - var(--ak-editor--large-gutter-padding) * 2),\n\t\t\tvar(--ak-editor--full-width-layout-width)\n\t\t);--ak-editor--breakout-fallback-width:100%;}.ProseMirror{--ak-editor-max-container-width:calc(100cqw - var(--ak-editor--large-gutter-padding));}.ProseMirror>div[data-prosemirror-node-block] [data-prosemirror-node-block]{--ak-editor-max-container-width:100%;}@container editor-area (width >= ", $9f876c050f409026$var$akEditorBreakpointForSmallDevice, "){.ProseMirror{--ak-editor--breakout-wide-layout-width:", (0, $7yBx7.akEditorCalculatedWideLayoutWidth), "px;}}.ProseMirror{outline:none;font-size:", (0, $7yBx7.editorFontSize)({
        theme: props.theme
    }), "px;", (0, $6up3L.whitespaceSharedStyles), ";", (0, $fH5IE.paragraphSharedStyles)(props.typographyTheme), ";", (0, $kvnqO.listsSharedStyles), ";", (0, $d1Z2v.indentationSharedStyles), ";", (0, $aaqba.shadowSharedStyle), ";", (0, $fDrn5.InlineNodeViewSharedStyles), ";}.ProseMirror-hideselection *::selection{background:transparent;}.ProseMirror-hideselection *::-moz-selection{background:transparent;}", (0, $eGOwo.fg)('platform_editor_hide_cursor_when_pm_hideselection') ? $9f876c050f409026$var$_ref3 : null, (0, $92xoS.editorExperiment)('platform_editor_advanced_code_blocks', true) ? $9f876c050f409026$var$_ref2 : null, " .ProseMirror-selectednode{outline:none;}.ProseMirror-selectednode:empty{outline:2px solid var(--ds-border-focused, #8cf);}.ProseMirror.ProseMirror-focused:has(.ProseMirror-mark-boundary-cursor){caret-color:transparent;}.ProseMirror:not(.ProseMirror-focused) .ProseMirror-mark-boundary-cursor{display:none;}", $9f876c050f409026$var$firstFloatingToolbarButtonStyles, " ", (0, $7D0Jo.placeholderTextStyles), " ", (0, $eGOwo.fg)('platform_editor_system_fake_text_highlight_colour') && (0, $7D0Jo.placeholderTextStyles_fg_platform_editor_system_fake_text_highlight_colour), " ", $9f876c050f409026$export$d3bdc0d52bb6c2c8, " ", (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1') ? $9f876c050f409026$var$placeholderOverflowStyles : null, " ", (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1') && (0, $eGOwo.fg)('platform_editor_quick_insert_placeholder') ? $9f876c050f409026$var$placeholderWrapStyles : null, " ", (0, $320JB.codeBlockStyles)(), " ", (0, $cC0Do.blocktypeStyles)(props.typographyTheme), " ", (0, $j7par.codeMarkSharedStyles)(), " ", (0, $bhdjn.textColorStyles), " ", (0, $eDJ4M.backgroundColorStyles)(), " ", $9f876c050f409026$var$listsStyles, " ", $9f876c050f409026$var$ruleStyles(), " ", (0, $3RA4L.mediaStyles)(), " ", (0, $h6DrW.layoutStyles)(props.viewMode), " ", (0, $eGOwo.fg)('confluence_team_presence_scroll_to_pointer') ? (0, $eh3wX.telepointerStyle) : (0, $eh3wX.telepointerStyleWithInitialOnly), " ", (0, $3N6pN.gapCursorStyles), ";", (0, $g3llj.panelStyles)(), " ", $9f876c050f409026$var$mentionsStyles, " ", $9f876c050f409026$var$mentionNodeStyles, " ", (0, $eGOwo.fg)('platform_editor_centre_mention_padding') && $9f876c050f409026$var$mentionNodeStylesMixin_fg_platform_editor_centre_mention_padding, " ", (0, $9Letn.expValEqualsNoExposure)('platform_editor_find_and_replace_improvements', 'isEnabled', true) && (0, $eGOwo.fg)('platform_editor_find_and_replace_improvements_1') ? $9f876c050f409026$var$mentionsSelectionStylesWithSearchMatch : $9f876c050f409026$var$mentionSelectionStyles, " ", $9f876c050f409026$var$emojiStyles, " ", (0, $gZAVf.tasksAndDecisionsStyles), " ", (0, $cidLz.gridStyles), " ", $9f876c050f409026$export$4ea5976125a01ffa, " ", (0, $jp9xB.blockMarksSharedStyles), " ", (0, $fDsDd.dateSharedStyle), " ", (0, $kVRJd.extensionStyles), " ", (0, $aQRv5.expandStyles)(), " ", (0, $9Letn.expValEqualsNoExposure)('platform_editor_find_and_replace_improvements', 'isEnabled', true) ? (0, $eGOwo.fg)('platform_editor_find_and_replace_improvements_1') ? (0, $b1G5H.findReplaceStylesNewNoImportant) : (0, $b1G5H.findReplaceStylesNew) : (0, $b1G5H.findReplaceStyles), " ", (0, $6HZZD.textHighlightStyle), " ", (0, $1UKpI.taskDecisionStyles), " ", (0, $1UKpI.taskItemStyles), (0, $eGOwo.fg)('platform-visual-refresh-icons') && (0, $1UKpI.taskDecisionIconWithVisualRefresh), " ", !(0, $eGOwo.fg)('platform-visual-refresh-icons') && (0, $1UKpI.taskDecisionIconWithoutVisualRefresh), " ", (0, $llrTf.statusStyles)(), " ", (0, $llrTf.statusNodeStyles)(), " ", (0, $l8DE0.annotationSharedStyles)(), " ", (0, $hkyHj.smartCardStyles)(), " ", (0, $e2Ny4.getSmartCardSharedStyles)(), " ", (0, $afDZa.dateStyles), " ", (0, $afDZa.dateNodeStyles), " ", (0, $kd9l4.embedCardStyles)(), " ", (0, $iCwuj.unsupportedStyles), " ", (0, $1cdIU.resizerStyles), " ", (0, $1cdIU.pragmaticResizerStyles)(), " ", (0, $1cdIU.pragmaticStylesLayoutFirstNodeResizeHandleFix)(), " ", (0, $1cdIU.pragmaticResizerStylesForTooltip)(), " ", (0, $e8cBm.aiPanelStyles)(props.colorMode), " ", $9f876c050f409026$var$firstBlockNodeStylesNew, " ", (0, $eGOwo.fg)('platform_editor_vanilla_codebidi_warning') && (0, $4e15Z.codeBidiWarningStyles), " .panelView-content-wrap{box-sizing:border-box;}.mediaGroupView-content-wrap ul{padding:0;}div.fabric-editor-block-mark[class^='fabric-editor-align']{clear:none!important;}.fabric-editor-align-end{text-align:right;}.fabric-editor-align-start{text-align:left;}.fabric-editor-align-center{text-align:center;}.fabric-editor--full-width-mode{.pm-table-container{.code-block,.extension-container,.multiBodiedExtension--container{max-width:100%;}}}.pm-table-header-content-wrap :not(.fabric-editor-alignment),.pm-table-header-content-wrap :not(p, .fabric-editor-block-mark)+div.fabric-editor-block-mark,.pm-table-cell-content-wrap :not(p, .fabric-editor-block-mark)+div.fabric-editor-block-mark{p:first-of-type{margin-top:0;}}.pm-table-cell-content-wrap .mediaGroupView-content-wrap{clear:both;}.hyperlink-floating-toolbar,.", (0, $cYzoj.ClassNames).FLOATING_TOOLBAR_COMPONENT, "{padding:0;}", !(0, $eGOwo.fg)('platform-visual-refresh-icons') ? $9f876c050f409026$var$_ref : null, ";");
const $9f876c050f409026$export$91e7c20fa6d6a4b5 = (styles)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef((props, ref)=>{
        const { className: className, children: children, featureFlags: featureFlags } = props;
        const theme = (0, $loabE.u)();
        const { colorMode: colorMode, typography: typography } = (0, $58yRG.default)();
        const memoizedStyle = (0, $eJOHy.useMemo)(()=>$9f876c050f409026$var$legacyContentStyles({
                theme: theme,
                colorMode: colorMode,
                featureFlags: featureFlags,
                viewMode: props.viewMode,
                typographyTheme: typography
            }), [
            theme,
            colorMode,
            featureFlags,
            props.viewMode,
            typography
        ]);
        if (props.isScrollable) return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ref: ref,
            css: [
                memoizedStyle,
                styles
            ],
            "data-editor-scroll-container": "true",
            "data-testid": "editor-content-container"
        }, children);
        return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ref: ref,
            css: [
                memoizedStyle,
                styles
            ],
            "data-testid": "editor-content-container"
        }, children);
    });
};
var $9f876c050f409026$export$2e2bcd8739ae039 = $9f876c050f409026$export$91e7c20fa6d6a4b5();

});
parcelRegister("eh3wX", function(module, exports) {

$parcel$export(module.exports, "PROVIDER_ERROR_CODE", () => $baa7c1787ff83074$export$54cb529986e2487b);
$parcel$export(module.exports, "DisconnectReason", () => $baa7c1787ff83074$export$258d16488300d83f);
$parcel$export(module.exports, "TELEPOINTER_DIM_CLASS", () => $baa7c1787ff83074$export$75f1e2b0ae2c8197);
$parcel$export(module.exports, "TELEPOINTER_PULSE_CLASS", () => $baa7c1787ff83074$export$44ee82a2b1106d13);
$parcel$export(module.exports, "TELEPOINTER_PULSE_DURING_TR_CLASS", () => $baa7c1787ff83074$export$15875d5e8ce4fd42);
$parcel$export(module.exports, "TELEPOINTER_PULSE_DURING_TR_DURATION_MS", () => $baa7c1787ff83074$export$cea3f62f94f5fdf0);
$parcel$export(module.exports, "TELEPOINTER_DATA_SESSION_ID_ATTR", () => $baa7c1787ff83074$export$74788e2dc4d9be50);
$parcel$export(module.exports, "telepointerStyleWithInitialOnly", () => $baa7c1787ff83074$export$42e13fa9d2b0c35d);
$parcel$export(module.exports, "telepointerStyle", () => $baa7c1787ff83074$export$c94087d6ea5127ad);
$parcel$export(module.exports, "isDirtyTransaction", () => $baa7c1787ff83074$export$c500b1bc696a0abc);
$parcel$export(module.exports, "tintDirtyTransaction", () => $baa7c1787ff83074$export$f25182515d14d793);

var $1NIU8 = parcelRequire("1NIU8");

var $7yBx7 = parcelRequire("7yBx7");

var $01wZP = parcelRequire("01wZP");
var $baa7c1787ff83074$export$54cb529986e2487b = /*#__PURE__*/ function(PROVIDER_ERROR_CODE) {
    PROVIDER_ERROR_CODE["NO_PERMISSION_ERROR"] = "NO_PERMISSION_ERROR";
    PROVIDER_ERROR_CODE["INVALID_USER_TOKEN"] = "INVALID_USER_TOKEN";
    PROVIDER_ERROR_CODE["DOCUMENT_NOT_FOUND"] = "DOCUMENT_NOT_FOUND";
    PROVIDER_ERROR_CODE["LOCKED"] = "LOCKED";
    PROVIDER_ERROR_CODE["FAIL_TO_SAVE"] = "FAIL_TO_SAVE";
    PROVIDER_ERROR_CODE["DOCUMENT_RESTORE_ERROR"] = "DOCUMENT_RESTORE_ERROR";
    PROVIDER_ERROR_CODE["INITIALISATION_ERROR"] = "INITIALISATION_ERROR";
    PROVIDER_ERROR_CODE["NETWORK_ISSUE"] = "NETWORK_ISSUE";
    PROVIDER_ERROR_CODE["INVALID_PROVIDER_CONFIGURATION"] = "INVALID_PROVIDER_CONFIGURATION";
    PROVIDER_ERROR_CODE["INTERNAL_SERVICE_ERROR"] = "INTERNAL_SERVICE_ERROR";
    PROVIDER_ERROR_CODE["DOCUMENT_UPDATE_ERROR"] = "DOCUMENT_UPDATE_ERROR";
    return PROVIDER_ERROR_CODE;
}({});
var $baa7c1787ff83074$export$258d16488300d83f = /*#__PURE__*/ function(DisconnectReason) {
    DisconnectReason["CLIENT_DISCONNECT"] = "CLIENT_DISCONNECT";
    DisconnectReason["SERVER_DISCONNECT"] = "SERVER_DISCONNECT";
    DisconnectReason["SOCKET_CLOSED"] = "SOCKET_CLOSED";
    DisconnectReason["SOCKET_ERROR"] = "SOCKET_ERROR";
    DisconnectReason["SOCKET_TIMEOUT"] = "SOCKET_TIMEOUT";
    DisconnectReason["UNKNOWN_DISCONNECT"] = "UNKNOWN_DISCONNECT";
    return DisconnectReason;
}({});
const $baa7c1787ff83074$var$telepointerColorStyle = (backgroundColor, textColor, index)=>{
    const { colorMode: colorMode } = (0, $01wZP.default)();
    const backgroundStyle = colorMode === 'dark' ? `linear-gradient(to bottom, ${backgroundColor} -800000%, transparent 200000%)` : `linear-gradient(to bottom, ${backgroundColor} -850000%, transparent 150000%)`;
    return `
    &.color-${index} {
      background: ${backgroundStyle};
      &::after {
        background-color: ${backgroundColor};
        color: ${textColor};
        border-color: ${backgroundColor};
      }
    }
  `;
};
const $baa7c1787ff83074$export$75f1e2b0ae2c8197 = 'telepointer-dim';
const $baa7c1787ff83074$export$44ee82a2b1106d13 = 'telepointer-pulse-animate';
const $baa7c1787ff83074$export$15875d5e8ce4fd42 = 'telepointer-pulse-during-tr';
const $baa7c1787ff83074$export$cea3f62f94f5fdf0 = 7500; // Keeping it longer so it'll be easier to spot during transactions
const $baa7c1787ff83074$export$74788e2dc4d9be50 = 'data-telepointer-sessionid';
const $baa7c1787ff83074$export$42e13fa9d2b0c35d = /*#__PURE__*/ (0, $1NIU8.css)(".ProseMirror .telepointer{position:relative;transition:opacity 200ms;", (0, $7yBx7.participantColors).map((participantColor, index)=>$baa7c1787ff83074$var$telepointerColorStyle(participantColor.backgroundColor, participantColor.textColor, index)), ";&.telepointer-selection:not(.inlineNodeView){line-height:1.2;pointer-events:none;user-select:none;}&.telepointer-selection-badge::after{content:attr(data-initial);position:absolute;display:block;top:-14px;font-size:", (0, $7yBx7.relativeFontSizeToBase16)(9), ";padding:var(--ds-space-025, 2px);color:var(--ds-text-inverse, #FFFFFF);left:0px;border-radius:2px 2px 2px 0;line-height:initial;}&.", $baa7c1787ff83074$export$75f1e2b0ae2c8197, "{opacity:0.2;}}");
const $baa7c1787ff83074$export$c94087d6ea5127ad = /*#__PURE__*/ (0, $1NIU8.css)("@keyframes pulseIn{0%,100%{transform:scaleX(0);opacity:0;}10%{transform:scaleX(1.4);opacity:1;}15%,85%{transform:scaleX(1);opacity:1;}}@keyframes pulseOut{0%,90%,100%{transform:scaleX(1);opacity:1;}10%,80%{transform:scaleX(0);opacity:0;}}@keyframes pulseInDuringTr{0%,95%{transform:scaleX(1);opacity:1;}100%{transform:scaleX(0);opacity:0;}}@keyframes pulseOutDuringTr{100%{transform:scaleX(1);opacity:1;}0%,90%{transform:scaleX(0);opacity:0;}}.ProseMirror .telepointer{position:relative;transition:opacity 200ms;", (0, $7yBx7.participantColors).map((participantColor, index)=>$baa7c1787ff83074$var$telepointerColorStyle(participantColor.backgroundColor, participantColor.textColor, index)), ";&.telepointer-selection:not(.inlineNodeView){line-height:1.2;pointer-events:none;user-select:none;}&.telepointer-selection-badge{.telepointer-initial,.telepointer-fullname{position:absolute;display:block;user-select:none;white-space:pre;top:-14px;left:0px;font:var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);padding-left:var(--ds-space-050, 4px);padding-right:var(--ds-space-050, 4px);color:var(--ds-text-inverse, #FFFFFF);border-radius:0 2px 2px 0;}.telepointer-initial{opacity:1;transition:opacity 0.15s ease-out;}.telepointer-fullname{opacity:0;transform:scaleX(0);transform-origin:top left;transition:transform 0.15s ease-out,opacity 0.15s ease-out;}}&.", $baa7c1787ff83074$export$44ee82a2b1106d13, "{.telepointer-initial{animation:pulseOut 2.5s ease-in-out;}.telepointer-fullname{animation:pulseIn 2.5s ease-in-out;}}&.", $baa7c1787ff83074$export$15875d5e8ce4fd42, "{.telepointer-initial{animation:pulseOutDuringTr ", $baa7c1787ff83074$export$cea3f62f94f5fdf0, "ms ease-in-out;}.telepointer-fullname{animation:pulseInDuringTr ", $baa7c1787ff83074$export$cea3f62f94f5fdf0, "ms ease-in-out;}}&:hover{.telepointer-initial{opacity:0;transition-delay:150ms;}.telepointer-fullname{transform:scaleX(1);opacity:1;z-index:1;}}&.", $baa7c1787ff83074$export$75f1e2b0ae2c8197, "{opacity:0.2;}}");
const $baa7c1787ff83074$var$tintKey = 'collab:isDirtyTransaction';
const $baa7c1787ff83074$export$c500b1bc696a0abc = (tr)=>{
    return Boolean(tr.getMeta($baa7c1787ff83074$var$tintKey));
};
const $baa7c1787ff83074$export$f25182515d14d793 = (tr)=>{
    tr.setMeta($baa7c1787ff83074$var$tintKey, true);
};

});

parcelRegister("dXRfX", function(module, exports) {

$parcel$export(module.exports, "EmojiSharedCssClassName", () => $ba76b0d4382ed38f$export$ee47248f9a998789);

const $ba76b0d4382ed38f$export$ee47248f9a998789 = {
    EMOJI_CONTAINER: 'emojiView-content-wrap',
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    EMOJI_NODE: (0, $eb4c5e773f9bbee2$export$b06c4aab1d012063),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    EMOJI_SPRITE: (0, $eb4c5e773f9bbee2$export$1c10634420a08d8a),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    EMOJI_IMAGE: (0, $eb4c5e773f9bbee2$export$da61cef1c8919f7c),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    EMOJI_PLACEHOLDER: (0, $eb4c5e773f9bbee2$export$c7187bbd1a7a9244)
};

});
const $eb4c5e773f9bbee2$export$8633a0edef8e95dd = 'emoji-common-selected';
const $eb4c5e773f9bbee2$export$860109dfd198259b = 'emoji-common-select-on-hover';
const $eb4c5e773f9bbee2$export$1c10634420a08d8a = 'emoji-common-emoji-sprite';
const $eb4c5e773f9bbee2$export$b06c4aab1d012063 = 'emoji-common-node';
const $eb4c5e773f9bbee2$export$da61cef1c8919f7c = 'emoji-common-emoji-image';
const $eb4c5e773f9bbee2$export$b11fa39b56a371f6 = 'emoji-common-deleteButton';
const $eb4c5e773f9bbee2$export$11462c0756c24ab6 = 'emoji-common-main-styles';
const $eb4c5e773f9bbee2$export$22b19c311e9caa4 = 'emoji-common-deletable';
const $eb4c5e773f9bbee2$export$c7187bbd1a7a9244 = 'emoji-common-placeholder';
const $eb4c5e773f9bbee2$export$b0fe756d87022806 = 'emoji-picker-add-emoji';


parcelRegister("av5GH", function(module, exports) {

$parcel$export(module.exports, "MentionSharedCssClassName", () => $f50611b263831150$export$e5f60e08987c4e73);
const $f50611b263831150$export$e5f60e08987c4e73 = {
    MENTION_CONTAINER: 'mentionView-content-wrap'
};

});

parcelRegister("7kf0Z", function(module, exports) {

$parcel$export(module.exports, "darkPanelColors", () => $8f40ff547e3f0696$export$804476272fbaff5e);
$parcel$export(module.exports, "PanelSharedCssClassName", () => $8f40ff547e3f0696$export$6dd740b6c888e050);
$parcel$export(module.exports, "getPanelTypeBackgroundNoTokens", () => $8f40ff547e3f0696$export$8099afddf1b1be78);
$parcel$export(module.exports, "panelSharedStyles", () => $8f40ff547e3f0696$export$fc98407afe711ba8);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $ePdnq = parcelRequire("ePdnq");

var $kZPQ0 = parcelRequire("kZPQ0");

var $7yBx7 = parcelRequire("7yBx7");

var $7yBx7 = parcelRequire("7yBx7");


var $eGOwo = parcelRequire("eGOwo");
const $8f40ff547e3f0696$var$lightPanelColors = {
    info: '#DEEBFF',
    note: '#EAE6FF',
    tip: '#E3FCEF',
    success: '#E3FCEF',
    warning: '#FFFAE6',
    error: '#FFEBE6'
};
const $8f40ff547e3f0696$export$804476272fbaff5e = {
    // standard panels
    info: `#0C294F`,
    error: `#441C13`,
    warning: `#413001`,
    tip: `#052E21`,
    success: `#052E21`,
    note: `#282249`,
    // Reds
    R900: '#601D16',
    // Red Saturated
    R100S: `#FFEFEB`,
    R300S: `#FFB5A3`,
    R500S: `#FF6B47`,
    R800S: `#C4320E`,
    R1200S: `#441C13`,
    // Yellows
    Y900: '#533F04',
    // Yellow Saturated
    Y100S: `#FFF3D1`,
    Y300S: `#FFDC7A`,
    Y500S: `#FFC933`,
    Y800S: `#D8A003`,
    Y1200S: `#413001`,
    // Greens
    G900: '#164B35',
    // Green Saturated
    G100S: `#E3FCF0`,
    G300S: `#95EEC5`,
    G400S: `#60DCA8`,
    G900S: `#086848`,
    G1200S: `#052E21`,
    // Blues
    B900: '#09326C',
    // Saturated Blues
    B100S: '#E5F0FF',
    B300S: '#A3C9FF',
    B500S: '#4794FF',
    B800S: '#0055CC',
    B1200S: '#0C294F',
    // Purples
    P900: `#352C63`,
    // Purple Saturated
    P100S: `#EEEBFF`,
    P300S: `#CCC3FE`,
    P500S: `#A292F7`,
    P800S: `#5E49CA`,
    P1200S: `#282249`,
    // Teals
    T900: '#1D474C',
    // Teal Saturated
    T100S: `#DBFAFF`,
    T300S: `#78EBFC`,
    T400S: `#3AD6EE`,
    T900S: `#056270`,
    T1200S: `#0B3037`,
    // Dark Mode Alpha
    DarkGray: '#161A1D',
    Gray: '#2C333A',
    LightGray: '#5A6977',
    TextColor: '#D9DDE3'
};
const $8f40ff547e3f0696$var$lightIconColor = {
    info: "var(--ds-icon-information, #1D7AFC)",
    note: "var(--ds-icon-discovery, #8270DB)",
    tip: "var(--ds-icon-success, #22A06B)",
    success: "var(--ds-icon-success, #22A06B)",
    warning: "var(--ds-icon-warning, #E56910)",
    error: "var(--ds-icon-danger, #C9372C)"
};
// New custom icons are a little smaller than predefined icons.
// To fix alignment issues with custom icons, vertical alignment is updated.
const $8f40ff547e3f0696$var$panelEmojiSpriteVerticalAlignment = -(24 - (0, $7yBx7.akEditorCustomIconSize)) / 2;
const $8f40ff547e3f0696$var$panelEmojiImageVerticalAlignment = $8f40ff547e3f0696$var$panelEmojiSpriteVerticalAlignment - 1;
function $8f40ff547e3f0696$export$9490e629452e7f9e(colorName, colorValue) {
    return `
  &[data-panel-color="${colorName}"] {
    background-color: ${colorValue} !important; // !important to override default style color
    color: ${$8f40ff547e3f0696$export$804476272fbaff5e.TextColor};
  }
  `;
}
const $8f40ff547e3f0696$var$prefix = 'ak-editor-panel';
const $8f40ff547e3f0696$export$6dd740b6c888e050 = {
    prefix: $8f40ff547e3f0696$var$prefix,
    content: `${$8f40ff547e3f0696$var$prefix}__content`,
    icon: `${$8f40ff547e3f0696$var$prefix}__icon`,
    noIcon: `${$8f40ff547e3f0696$var$prefix}__no-icon`
};
const $8f40ff547e3f0696$export$b0ee08fae091706a = {
    infoPanel: `.${$8f40ff547e3f0696$var$prefix}[data-panel-type=${(0, $ePdnq.PanelType).INFO}]`,
    notePanel: `.${$8f40ff547e3f0696$var$prefix}[data-panel-type=${(0, $ePdnq.PanelType).NOTE}]`,
    warningPanel: `.${$8f40ff547e3f0696$var$prefix}[data-panel-type=${(0, $ePdnq.PanelType).WARNING}]`,
    errorPanel: `.${$8f40ff547e3f0696$var$prefix}[data-panel-type=${(0, $ePdnq.PanelType).ERROR}]`,
    successPanel: `.${$8f40ff547e3f0696$var$prefix}[data-panel-type=${(0, $ePdnq.PanelType).SUCCESS}]`,
    noteButton: `button[aria-label="Note"]`,
    warningButton: `button[aria-label="Warning"]`,
    removeButton: `button[aria-label="Remove"]`,
    colorPalette: `[aria-label="Background color"]`,
    selectedColor: `[aria-label="Light green"]`,
    removeEmojiIcon: `[aria-label="Remove emoji"]`,
    emojiIcon: `[aria-label="editor-add-emoji"]`,
    selectedEmoji: `[aria-label=":grinning:"]`,
    addYourOwnEmoji: `#add-custom-emoji`,
    emojiNameInCustomEmoji: `[aria-label="Enter a name for the new emoji"]`,
    title: `#editor-title`,
    emojiPopup: `[aria-label="Popup"]`,
    searchEmoji: `[aria-label="Emoji name"]`,
    orangeWarningIcon: `[aria-label=":warning:"]`,
    yellowWarningIcon: `[aria-label=":warning:"]  span:nth-child(1)`,
    copyButton: `button[aria-label="Copy"]`
};
const $8f40ff547e3f0696$var$getIconStyles = (panelType)=>{
    return `
		.${$8f40ff547e3f0696$export$6dd740b6c888e050.icon}[data-panel-type='${panelType}'] {
			color: ${$8f40ff547e3f0696$var$lightIconColor[panelType]};
		}
	`;
};
const $8f40ff547e3f0696$export$8099afddf1b1be78 = (panelType)=>$8f40ff547e3f0696$var$lightPanelColors[panelType] || 'none';
const $8f40ff547e3f0696$export$dd3f0fd482ae7ccc = (panelType)=>(0, $kZPQ0.hexToEditorBackgroundPaletteColor)($8f40ff547e3f0696$var$lightPanelColors[panelType]) || 'none';
const $8f40ff547e3f0696$var$mainDynamicStyles = (panelType)=>{
    return `
    background-color: ${$8f40ff547e3f0696$export$dd3f0fd482ae7ccc(panelType)};
    color: inherit;
  `;
};
const $8f40ff547e3f0696$export$d707b378cb63679a = ()=>/*#__PURE__*/ (0, $1NIU8.css)("border-radius:var(--ds-border-radius, 3px);margin:", (0, $7yBx7.blockNodesVerticalMargin), " 0 0;padding-top:var(--ds-space-100, 8px);padding-right:var(--ds-space-200, 16px);padding-bottom:var(--ds-space-100, 8px);padding-left:var(--ds-space-100, 8px);min-width:", (0, $7yBx7.akEditorTableCellMinWidth), "px;display:flex;position:relative;align-items:normal;word-break:break-word;", $8f40ff547e3f0696$var$mainDynamicStyles((0, $ePdnq.PanelType).INFO), " .", $8f40ff547e3f0696$export$6dd740b6c888e050.icon, "{flex-shrink:0;height:var(--ds-space-300, 24px);width:var(--ds-space-300, 24px);box-sizing:content-box;padding-right:var(--ds-space-100, 8px);text-align:center;user-select:none;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;margin-top:0.1em;>span{vertical-align:middle;display:inline-flex;}.", (0, $eb4c5e773f9bbee2$export$1c10634420a08d8a), "{vertical-align:", $8f40ff547e3f0696$var$panelEmojiSpriteVerticalAlignment, "px;}.", (0, $eb4c5e773f9bbee2$export$da61cef1c8919f7c), "{vertical-align:", $8f40ff547e3f0696$var$panelEmojiImageVerticalAlignment, "px;@-moz-document url-prefix(){img{display:inline-block;}}}}.ak-editor-panel__content{margin:var(--ds-space-025, 2px) 0 var(--ds-space-025, 2px);flex:1 0 0;min-width:0;}", (0, $eGOwo.fg)('platform_editor_add_border_for_nested_panel') ? `.${$8f40ff547e3f0696$export$6dd740b6c888e050.content} .${$8f40ff547e3f0696$var$prefix} {
			border: 1px solid ${"var(--ds-border, #091E42)"};
		}` : '', " &[data-panel-type='", (0, $ePdnq.PanelType).INFO, "']{", $8f40ff547e3f0696$var$getIconStyles((0, $ePdnq.PanelType).INFO), ";}&[data-panel-type='", (0, $ePdnq.PanelType).NOTE, "']{", $8f40ff547e3f0696$var$mainDynamicStyles((0, $ePdnq.PanelType).NOTE), " ", $8f40ff547e3f0696$var$getIconStyles((0, $ePdnq.PanelType).NOTE), ";}&[data-panel-type='", (0, $ePdnq.PanelType).TIP, "']{", $8f40ff547e3f0696$var$mainDynamicStyles((0, $ePdnq.PanelType).TIP), " ", $8f40ff547e3f0696$var$getIconStyles((0, $ePdnq.PanelType).TIP), ";}&[data-panel-type='", (0, $ePdnq.PanelType).WARNING, "']{", $8f40ff547e3f0696$var$mainDynamicStyles((0, $ePdnq.PanelType).WARNING), " ", $8f40ff547e3f0696$var$getIconStyles((0, $ePdnq.PanelType).WARNING), ";}&[data-panel-type='", (0, $ePdnq.PanelType).ERROR, "']{", $8f40ff547e3f0696$var$mainDynamicStyles((0, $ePdnq.PanelType).ERROR), " ", $8f40ff547e3f0696$var$getIconStyles((0, $ePdnq.PanelType).ERROR), ";}&[data-panel-type='", (0, $ePdnq.PanelType).SUCCESS, "']{", $8f40ff547e3f0696$var$mainDynamicStyles((0, $ePdnq.PanelType).SUCCESS), " ", $8f40ff547e3f0696$var$getIconStyles((0, $ePdnq.PanelType).SUCCESS), ";}", (0, $eGOwo.fg)('platform_editor_nested_dnd_styles_changes') ? `&.${$8f40ff547e3f0696$export$6dd740b6c888e050.noIcon} {
			padding-right: ${"var(--ds-space-150, 12px)"};
			padding-left: ${"var(--ds-space-150, 12px)"};
		}` : '', ";");
const $8f40ff547e3f0696$export$fc98407afe711ba8 = ()=>/*#__PURE__*/ (0, $1NIU8.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        [`.${$8f40ff547e3f0696$export$6dd740b6c888e050.prefix}`]: $8f40ff547e3f0696$export$d707b378cb63679a()
    });

});

parcelRegister("3N6pN", function(module, exports) {

$parcel$export(module.exports, "hideCaretModifier", () => $c949221da68db29f$export$8adc5edbc4a22166);
$parcel$export(module.exports, "gapCursorStyles", () => $c949221da68db29f$export$f6b9d90c2745834e);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");
const $c949221da68db29f$var$gapCursorBlink = (0, $1NIU8.keyframes)({
    'from, to': {
        opacity: 0
    },
    '50%': {
        opacity: 1
    }
});
const $c949221da68db29f$export$8adc5edbc4a22166 = 'ProseMirror-hide-gapcursor';
const $c949221da68db29f$var$gapCursor = '.ProseMirror-gapcursor';
const $c949221da68db29f$var$prosemirrorwidgetNotBlock = '.ProseMirror-widget:not([data-blocks-decoration-container="true"]):not([data-blocks-drag-handle-container="true"]):not([data-blocks-quick-insert-container="true"])';
const $c949221da68db29f$var$wrapLeft = '[layout="wrap-left"]';
const $c949221da68db29f$var$wrapRight = '[layout="wrap-right"]';
const $c949221da68db29f$export$f6b9d90c2745834e = /*#__PURE__*/ (0, $1NIU8.css)(".ProseMirror{&.", $c949221da68db29f$export$8adc5edbc4a22166, "{caret-color:transparent;}", $c949221da68db29f$var$gapCursor, "{display:none;pointer-events:none;position:relative;& span{caret-color:transparent;position:absolute;height:100%;width:100%;display:block;}& span::after{animation:1s ", $c949221da68db29f$var$gapCursorBlink, " step-start infinite;border-left:1px solid;content:'';display:block;position:absolute;top:0;height:100%;}&.-left span::after{left:var(--ds-space-negative-050, -4px);}&.-right span::after{right:var(--ds-space-negative-050, -4px);}& span[layout='full-width'],& span[layout='wide'],& span[layout='fixed-width']{margin-left:50%;transform:translateX(-50%);}&", $c949221da68db29f$var$wrapRight, "{float:right;}&:first-of-type+ul,&:first-of-type+span+ul,&:first-of-type+ol,&:first-of-type+span+ol,&:first-of-type+pre,&:first-of-type+span+pre,&:first-of-type+blockquote,&:first-of-type+span+blockquote{margin-top:0;}}&.ProseMirror-focused ", $c949221da68db29f$var$gapCursor, "{display:block;border-color:transparent;}}", $c949221da68db29f$var$gapCursor, $c949221da68db29f$var$wrapLeft, "+span+", $c949221da68db29f$var$wrapLeft, ",", $c949221da68db29f$var$gapCursor, $c949221da68db29f$var$wrapRight, "+span+", $c949221da68db29f$var$wrapRight, ",", $c949221da68db29f$var$gapCursor, "+", $c949221da68db29f$var$wrapLeft, "+", $c949221da68db29f$var$wrapRight, ",", $c949221da68db29f$var$gapCursor, "+", $c949221da68db29f$var$wrapLeft, "+span+", $c949221da68db29f$var$wrapRight, ",", $c949221da68db29f$var$gapCursor, "+", $c949221da68db29f$var$wrapRight, "+", $c949221da68db29f$var$wrapLeft, ",", $c949221da68db29f$var$gapCursor, "+", $c949221da68db29f$var$wrapRight, "+span+", $c949221da68db29f$var$wrapLeft, ",", $c949221da68db29f$var$wrapLeft, "+", $c949221da68db29f$var$gapCursor, "+", $c949221da68db29f$var$wrapRight, ",", $c949221da68db29f$var$wrapLeft, "+", $c949221da68db29f$var$gapCursor, "+span ", $c949221da68db29f$var$wrapRight, ",", $c949221da68db29f$var$wrapRight, "+", $c949221da68db29f$var$gapCursor, "+", $c949221da68db29f$var$wrapLeft, ",", $c949221da68db29f$var$wrapRight, "+", $c949221da68db29f$var$gapCursor, "+span+", $c949221da68db29f$var$wrapLeft, ",", $c949221da68db29f$var$wrapLeft, "+", $c949221da68db29f$var$gapCursor, "{clear:none;}", $c949221da68db29f$var$wrapLeft, "+", $c949221da68db29f$var$gapCursor, "+", $c949221da68db29f$var$wrapRight, ">div,", $c949221da68db29f$var$wrapLeft, "+", $c949221da68db29f$var$gapCursor, "+span+", $c949221da68db29f$var$wrapRight, ">div,", $c949221da68db29f$var$wrapRight, "+", $c949221da68db29f$var$gapCursor, "+", $c949221da68db29f$var$wrapLeft, ">div,", $c949221da68db29f$var$wrapRight, "+", $c949221da68db29f$var$gapCursor, "+span+", $c949221da68db29f$var$wrapLeft, ">div,", $c949221da68db29f$var$gapCursor, "+", $c949221da68db29f$var$wrapRight, "+", $c949221da68db29f$var$wrapLeft, ">div,", $c949221da68db29f$var$gapCursor, "+", $c949221da68db29f$var$wrapRight, "+span+", $c949221da68db29f$var$wrapLeft, ">div,", $c949221da68db29f$var$gapCursor, "+", $c949221da68db29f$var$wrapLeft, "+", $c949221da68db29f$var$wrapRight, ">div,", $c949221da68db29f$var$gapCursor, "+", $c949221da68db29f$var$wrapLeft, "+span+", $c949221da68db29f$var$wrapRight, ">div{margin-right:0;margin-left:0;margin-bottom:0;}", $c949221da68db29f$var$wrapLeft, "+", $c949221da68db29f$var$gapCursor, ",", $c949221da68db29f$var$wrapRight, "+", $c949221da68db29f$var$gapCursor, "{float:left;}", $c949221da68db29f$var$gapCursor, "+", $c949221da68db29f$var$wrapLeft, "+span+", $c949221da68db29f$var$wrapRight, "::after,", $c949221da68db29f$var$gapCursor, "+", $c949221da68db29f$var$wrapRight, "+span+", $c949221da68db29f$var$wrapLeft, "::after,", $c949221da68db29f$var$wrapLeft, "+", $c949221da68db29f$var$gapCursor, "+", $c949221da68db29f$var$wrapRight, "::after,", $c949221da68db29f$var$wrapLeft, "+", $c949221da68db29f$var$gapCursor, "+span+", $c949221da68db29f$var$wrapRight, "::after,", $c949221da68db29f$var$wrapRight, "+", $c949221da68db29f$var$gapCursor, "+", $c949221da68db29f$var$wrapLeft, "::after,", $c949221da68db29f$var$wrapRight, "+", $c949221da68db29f$var$gapCursor, "+span+", $c949221da68db29f$var$wrapLeft, "::after{visibility:hidden;display:block;font-size:0;content:' ';clear:both;height:0;}", $c949221da68db29f$var$wrapLeft, "+", $c949221da68db29f$var$gapCursor, "+", $c949221da68db29f$var$wrapRight, "+*,", $c949221da68db29f$var$wrapLeft, "+", $c949221da68db29f$var$gapCursor, "+", $c949221da68db29f$var$wrapRight, "+span+*,", $c949221da68db29f$var$wrapRight, "+", $c949221da68db29f$var$gapCursor, "+", $c949221da68db29f$var$wrapLeft, "+*,", $c949221da68db29f$var$wrapRight, "+", $c949221da68db29f$var$gapCursor, "+", $c949221da68db29f$var$wrapLeft, "+span+*,", $c949221da68db29f$var$wrapLeft, "+", $c949221da68db29f$var$gapCursor, "+span+", $c949221da68db29f$var$wrapRight, "+*,", $c949221da68db29f$var$wrapRight, "+", $c949221da68db29f$var$gapCursor, "+span+", $c949221da68db29f$var$wrapLeft, "+*,", $c949221da68db29f$var$gapCursor, "+", $c949221da68db29f$var$wrapLeft, "+span+", $c949221da68db29f$var$wrapRight, "+*,", $c949221da68db29f$var$gapCursor, "+", $c949221da68db29f$var$wrapRight, "+span+", $c949221da68db29f$var$wrapLeft, "+*,", $c949221da68db29f$var$wrapLeft, "+", $c949221da68db29f$var$gapCursor, "+", $c949221da68db29f$var$wrapRight, "+*>*,", $c949221da68db29f$var$wrapLeft, "+", $c949221da68db29f$var$gapCursor, "+", $c949221da68db29f$var$wrapRight, "+span+*>*,", $c949221da68db29f$var$wrapRight, "+", $c949221da68db29f$var$gapCursor, "+", $c949221da68db29f$var$wrapLeft, "+*>*,", $c949221da68db29f$var$wrapRight, "+", $c949221da68db29f$var$gapCursor, "+", $c949221da68db29f$var$wrapLeft, "+span+*>*,", $c949221da68db29f$var$wrapLeft, "+", $c949221da68db29f$var$gapCursor, "+span+", $c949221da68db29f$var$wrapRight, "+*>*,", $c949221da68db29f$var$wrapRight, "+", $c949221da68db29f$var$gapCursor, "+span+", $c949221da68db29f$var$wrapLeft, "+*>*,", $c949221da68db29f$var$gapCursor, "+", $c949221da68db29f$var$wrapLeft, "+span+", $c949221da68db29f$var$wrapRight, "+*>*,", $c949221da68db29f$var$gapCursor, "+", $c949221da68db29f$var$wrapRight, "+span+", $c949221da68db29f$var$wrapLeft, "+*>*,", $c949221da68db29f$var$prosemirrorwidgetNotBlock, "+", $c949221da68db29f$var$gapCursor, "+*,", $c949221da68db29f$var$prosemirrorwidgetNotBlock, "+", $c949221da68db29f$var$gapCursor, "+span+*{margin-top:0;}");

});

parcelRegister("l8DE0", function(module, exports) {

$parcel$export(module.exports, "AnnotationSharedClassNames", () => $699ed6094ac331bd$export$b0aeb22a160e5b4c);
$parcel$export(module.exports, "BlockAnnotationSharedClassNames", () => $699ed6094ac331bd$export$ac15f3ad21fefeac);
$parcel$export(module.exports, "annotationSharedStyles", () => $699ed6094ac331bd$export$5f72fe1d39f8129b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $eGOwo = parcelRequire("eGOwo");
function $699ed6094ac331bd$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $699ed6094ac331bd$export$6d0ce11e3a04da25 = 'ak-editor-annotation';
const $699ed6094ac331bd$export$b0aeb22a160e5b4c = {
    focus: `${$699ed6094ac331bd$export$6d0ce11e3a04da25}-focus`,
    blur: `${$699ed6094ac331bd$export$6d0ce11e3a04da25}-blur`,
    draft: `${$699ed6094ac331bd$export$6d0ce11e3a04da25}-draft`,
    hover: `${$699ed6094ac331bd$export$6d0ce11e3a04da25}-hover`
};
const $699ed6094ac331bd$export$3600479d19dfa7a9 = 'ak-editor-block-annotation';
const $699ed6094ac331bd$export$ac15f3ad21fefeac = {
    focus: `${$699ed6094ac331bd$export$3600479d19dfa7a9}-focus`,
    blur: `${$699ed6094ac331bd$export$3600479d19dfa7a9}-blur`,
    draft: `${$699ed6094ac331bd$export$3600479d19dfa7a9}-draft`
};
var $699ed6094ac331bd$var$_ref = {
    name: "1afe5d9",
    styles: "background:var(--ds-background-accent-yellow-subtlest-hovered, #F8E6A0);border-bottom-color:var(--ds-border-accent-yellow, #B38600);box-shadow:var(--ds-shadow-raised, 0px 1px 1px #091E4240, 0px 0px 1px #091E424f)"
};
var $699ed6094ac331bd$var$_ref2 = {
    name: "kh65d",
    styles: "background:var(--ds-background-accent-yellow-subtlest, #FFF7D6);border-bottom-color:var(--ds-border-accent-yellow, #B38600)"
};
var $699ed6094ac331bd$var$_ref3 = {
    name: "1m36z9o",
    styles: "background:var(--ds-background-accent-yellow-subtlest-pressed, #F5CD47);border-bottom-color:var(--ds-border-accent-yellow, #B38600);box-shadow:var(--ds-shadow-raised, 0px 1px 1px #091E4240, 0px 0px 1px #091E424f)"
};
const $699ed6094ac331bd$export$261ebe180da42726 = ()=>{
    if ((0, $eGOwo.fg)('editor_inline_comments_on_inline_nodes')) // NOTE: These styles are shared between renderer and editor. Sometimes they
    // need different selectors and other times they apply the same attributes
    // in a different way. For example in renderer the focus styles are an
    // override, not a separate class. Be sure to check both usages of this
    // before modifying.
    return {
        common: {
            borderBottom: '2px solid transparent',
            cursor: 'pointer',
            padding: '1px 0 2px',
            '&:has(.card), &:has([data-inline-card])': (0, $eGOwo.fg)('annotations_align_editor_and_renderer_styles') ? {
                padding: '5px 0 3px 0'
            } : {
                paddingTop: '4px',
                border: 'none',
                boxShadow: `0 2px 0 0 ${"var(--ds-border-accent-yellow, #B38600)"}`
            },
            '&:has(.date-lozenger-container)': {
                paddingTop: '2px'
            }
        },
        focus: $699ed6094ac331bd$var$_ref3,
        blur: $699ed6094ac331bd$var$_ref2,
        hover: $699ed6094ac331bd$var$_ref
    };
    else return {
        focus: /*#__PURE__*/ (0, $1NIU8.css)({
            // Background is not coming through in confluence, suspecting to be caused by some specific combination of
            // emotion and token look up
            background: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
            borderBottom: `2px solid ${"var(--ds-border-accent-yellow, #B38600)"}`,
            // TODO: DSP-4147 - Annotation shadow
            boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #091E4226, 0px 0px 1px #091E424f)",
            cursor: 'pointer'
        }),
        blur: /*#__PURE__*/ (0, $1NIU8.css)({
            background: "var(--ds-background-accent-yellow-subtlest, #FFF7D6)",
            borderBottom: `2px solid ${"var(--ds-border-accent-yellow, #B38600)"}`,
            cursor: 'pointer'
        })
    };
};
const $699ed6094ac331bd$export$5f72fe1d39f8129b = ()=>(0, $eGOwo.fg)('editor_inline_comments_on_inline_nodes') ? /*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- `AnnotationSharedCSSByState()` is not safe in object syntax
    (0, $1NIU8.css)(".ProseMirror{.", $699ed6094ac331bd$export$b0aeb22a160e5b4c.blur, ",.", $699ed6094ac331bd$export$b0aeb22a160e5b4c.focus, ",.", $699ed6094ac331bd$export$b0aeb22a160e5b4c.draft, "{", $699ed6094ac331bd$export$261ebe180da42726().common, ";}.", $699ed6094ac331bd$export$b0aeb22a160e5b4c.focus, "{", $699ed6094ac331bd$export$261ebe180da42726().focus, ";}.", $699ed6094ac331bd$export$b0aeb22a160e5b4c.draft, "{", $699ed6094ac331bd$export$261ebe180da42726().focus, ";cursor:initial;}.", $699ed6094ac331bd$export$b0aeb22a160e5b4c.blur, "{", $699ed6094ac331bd$export$261ebe180da42726().blur, ";}.", $699ed6094ac331bd$export$b0aeb22a160e5b4c.hover, "{", $699ed6094ac331bd$export$261ebe180da42726().common, ";", $699ed6094ac331bd$export$261ebe180da42726().hover, ";}}") : /*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- `AnnotationSharedCSSByState()` is not safe in object syntax
    (0, $1NIU8.css)(".ProseMirror{.", $699ed6094ac331bd$export$b0aeb22a160e5b4c.focus, "{", $699ed6094ac331bd$export$261ebe180da42726().focus, ";}.", $699ed6094ac331bd$export$b0aeb22a160e5b4c.draft, "{", $699ed6094ac331bd$export$261ebe180da42726().focus, ";cursor:initial;}.", $699ed6094ac331bd$export$b0aeb22a160e5b4c.blur, "{", $699ed6094ac331bd$export$261ebe180da42726().blur, ";}}");

});

parcelRegister("eDJ4M", function(module, exports) {

$parcel$export(module.exports, "backgroundColorStyles", () => $df9b6370e0ba8f8e$export$e4cca17cf56e99d);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $df9b6370e0ba8f8e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
var $df9b6370e0ba8f8e$var$_ref = {
    name: "7ixjog",
    styles: ".fabric-background-color-mark{background-color:var(--custom-palette-color, inherit);border-radius:2px;padding-top:1px;padding-bottom:2px;box-decoration-break:clone;}a .fabric-background-color-mark{background-color:unset;}.fabric-background-color-mark .ak-editor-annotation{background-color:unset;}"
};
const $df9b6370e0ba8f8e$export$e4cca17cf56e99d = ()=>{
    return $df9b6370e0ba8f8e$var$_ref;
};

});

parcelRegister("jp9xB", function(module, exports) {

$parcel$export(module.exports, "blockMarksSharedStyles", () => $1b27139298d2e5c9$export$33edc553df878c50);
/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression -- Perfectly safe to auto-fix, but leaving it up to the team to remediate as the readability only gets worse with autofixing */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $1b27139298d2e5c9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1b27139298d2e5c9$export$33edc553df878c50 = {
    name: "1p01ut3",
    styles: "*:not(.fabric-editor-block-mark)>,*:not(.fabric-editor-block-mark)>div.fabric-editor-block-mark:first-of-type:not(.fabric-editor-indentation-mark):not(.fabric-editor-alignment),.fabric-editor-alignment:first-of-type:first-child,.ProseMirror .fabric-editor-indentation-mark:first-of-type:first-child{p,h1,h2,h3,h4,h5,h6,.heading-wrapper{:first-child:not(style),style:first-child+*{margin-top:0;}}}"
};

});

parcelRegister("j7par", function(module, exports) {

$parcel$export(module.exports, "codeMarkSharedStyles", () => $3b9a59a675b257e4$export$ea799c18f699972b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");
const $3b9a59a675b257e4$export$ea799c18f699972b = ()=>{
    return /*#__PURE__*/ (0, $1NIU8.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.code': {
            '--ds--code--bg-color': "var(--ds-background-neutral, #091E420F)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            display: 'inline',
            padding: '2px 0.5ch',
            backgroundColor: `var(--ds--code--bg-color,${"var(--ds-background-neutral, #091E420F)"})`,
            borderRadius: "var(--ds-border-radius, 3px)",
            borderStyle: 'none',
            boxDecorationBreak: 'clone',
            color: "var(--ds-text, #172B4D)",
            fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: '0.875em',
            fontWeight: "var(--ds-font-weight-regular, 400)",
            overflow: 'auto',
            overflowWrap: 'break-word',
            whiteSpace: 'pre-wrap'
        }
    });
};

});

parcelRegister("kd9l4", function(module, exports) {

$parcel$export(module.exports, "embedCardStyles", () => $4a251fb9b4caee0a$export$5a1f57c6600b90f1);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $7yBx7 = parcelRequire("7yBx7");
const $4a251fb9b4caee0a$export$5a1f57c6600b90f1 = ()=>/*#__PURE__*/ (0, $1NIU8.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.ProseMirror': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            ".embedCardView-content-wrap[layout^='wrap-']": {
                maxWidth: '100%',
                position: 'relative',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
                zIndex: (0, $7yBx7.akEditorWrappedNodeZIndex)
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            ".embedCardView-content-wrap[layout='wrap-left']": {
                float: 'left'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            ".embedCardView-content-wrap[layout='wrap-right']": {
                float: 'right'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            ".embedCardView-content-wrap[layout='wrap-right'] + .embedCardView-content-wrap[layout='wrap-left']": {
                clear: 'both'
            }
        }
    });
const $4a251fb9b4caee0a$export$9a900b6b0c1fa45 = /*#__PURE__*/ (0, $1NIU8.css)({
    margin: `0 ${"var(--ds-space-150, 12px)"}`
});

});

parcelRegister("is7NW", function(module, exports) {

$parcel$export(module.exports, "expandIconContainerStyle", () => $4022cd3059a6bfcb$export$2e9dabdcf16aeb54);
$parcel$export(module.exports, "expandClassNames", () => $4022cd3059a6bfcb$export$6ba39aa0ead007b7);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $4022cd3059a6bfcb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $4022cd3059a6bfcb$export$e1f541b6d8e35681 = {
    name: "1igsh0u",
    styles: "margin-left:var(--ds-space-negative-100, -8px)"
};
const $4022cd3059a6bfcb$export$2e9dabdcf16aeb54 = {
    name: "s5xdrg",
    styles: "display:flex;align-items:center"
};
const $4022cd3059a6bfcb$var$prefix = 'ak-editor-expand';
const $4022cd3059a6bfcb$export$6ba39aa0ead007b7 = {
    prefix: $4022cd3059a6bfcb$var$prefix,
    expanded: `${$4022cd3059a6bfcb$var$prefix}__expanded`,
    titleContainer: `${$4022cd3059a6bfcb$var$prefix}__title-container`,
    inputContainer: `${$4022cd3059a6bfcb$var$prefix}__input-container`,
    iconContainer: `${$4022cd3059a6bfcb$var$prefix}__icon-container`,
    icon: `${$4022cd3059a6bfcb$var$prefix}__icon`,
    titleInput: `${$4022cd3059a6bfcb$var$prefix}__title-input`,
    content: `${$4022cd3059a6bfcb$var$prefix}__content`,
    type: (type)=>`${$4022cd3059a6bfcb$var$prefix}__type-${type}`
};

});

parcelRegister("cidLz", function(module, exports) {

$parcel$export(module.exports, "GRID_GUTTER", () => $fd8f62b16f17b119$export$108900bf32350a8b);
$parcel$export(module.exports, "gridStyles", () => $fd8f62b16f17b119$export$61d0da483c72dda3);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $7yBx7 = parcelRequire("7yBx7");
const $fd8f62b16f17b119$export$108900bf32350a8b = 12;
const $fd8f62b16f17b119$export$61d0da483c72dda3 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.gridParent': {
        width: `calc(100% + ${$fd8f62b16f17b119$export$108900bf32350a8b * 2}px)`,
        marginLeft: "var(--ds-space-negative-150, -12px)",
        marginRight: "var(--ds-space-negative-150, -12px)",
        transform: 'scale(1)',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: (0, $7yBx7.akEditorGridLineZIndex)
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.gridContainer': {
        position: 'fixed',
        height: '100vh',
        width: '100%',
        pointerEvents: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.gridLine': {
        borderLeft: `1px solid ${"var(--ds-border, #091E4224)"}`,
        display: 'inline-block',
        boxSizing: 'border-box',
        height: '100%',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginLeft: '-1px',
        transition: 'border-color 0.15s linear',
        zIndex: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.highlight': {
        borderLeft: `1px solid ${"var(--ds-border-focused, #388BFF)"}`
    }
});

});

parcelRegister("d1Z2v", function(module, exports) {

$parcel$export(module.exports, "indentationSharedStyles", () => $1b10cdb3dfa22b64$export$6856b92f564d3de8);
/* eslint-disable @atlaskit/design-system/use-tokens-space */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $1b10cdb3dfa22b64$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1b10cdb3dfa22b64$export$6856b92f564d3de8 = {
    name: "1bgz9nd",
    styles: ".fabric-editor-indentation-mark{&[data-level='1']{margin-left:30px;}&[data-level='2']{margin-left:60px;}&[data-level='3']{margin-left:90px;}&[data-level='4']{margin-left:120px;}&[data-level='5']{margin-left:150px;}&[data-level='6']{margin-left:180px;}}"
};

});

parcelRegister("vDp4P", function(module, exports) {

$parcel$export(module.exports, "linkSharedStyle", () => $58fe69e96a4176ce$export$d835732bf782c240);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $eGOwo = parcelRequire("eGOwo");
function $58fe69e96a4176ce$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
var $58fe69e96a4176ce$var$_ref = {
    name: "bp6sai",
    styles: "a.blockLink{display:block;}"
};
var $58fe69e96a4176ce$var$_ref2 = {
    name: "13hvbxv",
    styles: "a.blockLink{display:block;}a[data-prosemirror-mark-name=\"link\"]{text-decoration:underline;}a[data-prosemirror-mark-name=\"link\"]:hover{text-decoration:none;}"
};
const $58fe69e96a4176ce$export$d835732bf782c240 = ()=>{
    return (0, $eGOwo.fg)('platform_editor_hyperlink_underline') ? $58fe69e96a4176ce$var$_ref2 : $58fe69e96a4176ce$var$_ref;
};

});

parcelRegister("cYzoj", function(module, exports) {

$parcel$export(module.exports, "ClassNames", () => $ba39bea6c852bb89$export$9b9c0f9d9f3552b8);
const $ba39bea6c852bb89$var$prefix = 'pm-alt-text';
const $ba39bea6c852bb89$export$9b9c0f9d9f3552b8 = {
    FLOATING_TOOLBAR_COMPONENT: `${$ba39bea6c852bb89$var$prefix}-alt-text-floating-toolbar`,
    MEDIA_CONTAINER: 'mediaView-content-wrap'
};

});

parcelRegister("fH5IE", function(module, exports) {

$parcel$export(module.exports, "paragraphSharedStyles", () => $a82fce8c60ef5d3b$export$2f49074d75b0e29f);
/* eslint-disable @atlaskit/ui-styling-standard/no-exported-styles */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $7yBx7 = parcelRequire("7yBx7");

var $eGOwo = parcelRequire("eGOwo");

var $Vv4zU = parcelRequire("Vv4zU");
const $a82fce8c60ef5d3b$export$2f49074d75b0e29f = (typographyTheme)=>{
    return (0, $eGOwo.fg)('platform_editor_typography_ugc') ? /*#__PURE__*/ (0, $1NIU8.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& p': {
            font: (0, $Vv4zU.default)('editor.font.body'),
            marginTop: (0, $7yBx7.blockNodesVerticalMargin),
            marginBottom: 0
        }
    }) : /*#__PURE__*/ (0, $1NIU8.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& p': {
            fontSize: '1em',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            lineHeight: (0, $7yBx7.akEditorLineHeight),
            fontWeight: "var(--ds-font-weight-regular, 400)",
            marginTop: (0, $7yBx7.blockNodesVerticalMargin),
            marginBottom: 0,
            letterSpacing: '-0.005em'
        }
    });
};

});

parcelRegister("1cdIU", function(module, exports) {

$parcel$export(module.exports, "resizerItemClassName", () => $664b56465943704f$export$a06160db3520e5a2);
$parcel$export(module.exports, "resizerHoverZoneClassName", () => $664b56465943704f$export$c42cdcfd48254bda);
$parcel$export(module.exports, "resizerExtendedZone", () => $664b56465943704f$export$10b67c6ff1748bd);
$parcel$export(module.exports, "resizerHandleClassName", () => $664b56465943704f$export$6afc20f0ff6d041);
$parcel$export(module.exports, "resizerHandleTrackClassName", () => $664b56465943704f$export$a5792d7e2a486d41);
$parcel$export(module.exports, "resizerHandleThumbClassName", () => $664b56465943704f$export$2201bc1aaee73f36);
$parcel$export(module.exports, "resizerDangerClassName", () => $664b56465943704f$export$97a99610b6f0a178);
$parcel$export(module.exports, "handleWrapperClass", () => $664b56465943704f$export$b123b2c8a2536d05);
$parcel$export(module.exports, "resizerHandleThumbWidth", () => $664b56465943704f$export$b5fa87f62ced4967);
$parcel$export(module.exports, "resizerHandleZIndex", () => $664b56465943704f$export$3d867927ebf9bc1f);
$parcel$export(module.exports, "resizerStyles", () => $664b56465943704f$export$ce55ec61aa49b942);
$parcel$export(module.exports, "pragmaticResizerStylesForTooltip", () => $664b56465943704f$export$21b363e15a3a4b0b);
$parcel$export(module.exports, "pragmaticStylesLayoutFirstNodeResizeHandleFix", () => $664b56465943704f$export$241444dc11ae22d6);
$parcel$export(module.exports, "pragmaticResizerStyles", () => $664b56465943704f$export$62cd5dfd9881f590);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $7yBx7 = parcelRequire("7yBx7");

var $eGOwo = parcelRequire("eGOwo");

var $9Letn = parcelRequire("9Letn");

var $92xoS = parcelRequire("92xoS");
function $664b56465943704f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $664b56465943704f$export$a06160db3520e5a2 = 'resizer-item';
const $664b56465943704f$export$c42cdcfd48254bda = 'resizer-hover-zone';
const $664b56465943704f$export$10b67c6ff1748bd = 'resizer-is-extended';
const $664b56465943704f$export$6afc20f0ff6d041 = 'resizer-handle';
const $664b56465943704f$export$a5792d7e2a486d41 = `${$664b56465943704f$export$6afc20f0ff6d041}-track`;
const $664b56465943704f$export$2201bc1aaee73f36 = `${$664b56465943704f$export$6afc20f0ff6d041}-thumb`;
const $664b56465943704f$export$97a99610b6f0a178 = `${$664b56465943704f$export$6afc20f0ff6d041}-danger`;
// akEditorSelectedNodeClassName from '@atlaskit/editor-shared-styles';
const $664b56465943704f$var$akEditorSelectedNodeClassName = 'ak-editor-selected-node';
const $664b56465943704f$export$b123b2c8a2536d05 = 'resizer-handle-wrapper';
const $664b56465943704f$export$b5fa87f62ced4967 = 3;
const $664b56465943704f$export$3d867927ebf9bc1f = 1;
const $664b56465943704f$export$ce55ec61aa49b942 = /*#__PURE__*/ (0, $1NIU8.css)(".", $664b56465943704f$export$a06160db3520e5a2, "{will-change:width;&:hover,&.display-handle{&>.", $664b56465943704f$export$b123b2c8a2536d05, ">.", $664b56465943704f$export$6afc20f0ff6d041, "{visibility:visible;opacity:1;}}&.is-resizing{& .", $664b56465943704f$export$2201bc1aaee73f36, "{background:var(--ds-border-focused, #388BFF);}}&.", $664b56465943704f$export$97a99610b6f0a178, "{& .", $664b56465943704f$export$2201bc1aaee73f36, "{transition:none;background:", `var(--ds-icon-danger, ${(0, $7yBx7.akEditorDeleteIconColor)})`, ";}}}.", $664b56465943704f$export$6afc20f0ff6d041, "{display:flex;visibility:hidden;opacity:0;flex-direction:column;justify-content:center;align-items:center;width:7px;transition:visibility 0.2s,opacity 0.2s;& div[role='presentation']{width:100%;height:100%;display:flex;flex-direction:column;justify-content:center;align-items:center;margin-top:var(--ds-space-negative-200, -16px);white-space:normal;}&.left{align-items:flex-start;}&.right{align-items:flex-end;}&.small{& .", $664b56465943704f$export$2201bc1aaee73f36, "{height:43px;}}&.medium{& .", $664b56465943704f$export$2201bc1aaee73f36, "{height:64px;}}&.large{& .", $664b56465943704f$export$2201bc1aaee73f36, "{height:96px;}}&.clamped{& .", $664b56465943704f$export$2201bc1aaee73f36, "{height:clamp(43px, calc(100% - 32px), 96px);}}&.sticky{& .", $664b56465943704f$export$2201bc1aaee73f36, "{position:sticky;top:var(--ds-space-150, 12px);bottom:var(--ds-space-150, 12px);}}&:hover{& .", $664b56465943704f$export$2201bc1aaee73f36, "{background:var(--ds-border-focused, #388BFF);}& .", $664b56465943704f$export$a5792d7e2a486d41, "{visibility:visible;opacity:0.5;}}}.", $664b56465943704f$export$2201bc1aaee73f36, "{content:' ';display:flex;width:3px;margin:0 var(--ds-space-025, 2px);height:64px;transition:background-color 0.2s;border-radius:6px;border:0;padding:0;z-index:2;outline:none;min-height:24px;background:var(--ds-border, #091E4224);&:hover{cursor:col-resize;}&:focus{background:var(--ds-border-selected, #0C66E4);&::after{content:'';position:absolute;top:var(--ds-space-negative-050, -4px);right:var(--ds-space-negative-050, -4px);bottom:var(--ds-space-negative-050, -4px);left:var(--ds-space-negative-050, -4px);border:2px solid var(--ds-border-focused, #388BFF);border-radius:inherit;z-index:-1;}}}.", $664b56465943704f$export$a5792d7e2a486d41, "{visibility:hidden;position:absolute;width:7px;height:calc(100% - 40px);border-radius:4px;opacity:0;transition:background-color 0.2s,visibility 0.2s,opacity 0.2s;&.none{background:none;}&.shadow{background:var(--ds-background-selected, #E9F2FF);}&.full-height{background:var(--ds-background-selected, #E9F2FF);height:100%;min-height:36px;}}.", $664b56465943704f$var$akEditorSelectedNodeClassName, "{& .", $664b56465943704f$export$2201bc1aaee73f36, "{background:var(--ds-border-focused, #388BFF);}}.", $664b56465943704f$export$c42cdcfd48254bda, "{position:relative;display:inline-block;width:100%;&.", $664b56465943704f$export$10b67c6ff1748bd, "{padding:0 var(--ds-space-150, 12px);left:var(--ds-space-negative-150, -12px);}}table .", $664b56465943704f$export$c42cdcfd48254bda, ",table .", $664b56465943704f$export$c42cdcfd48254bda, ".", $664b56465943704f$export$10b67c6ff1748bd, "{padding:unset;left:unset;}");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles
var $664b56465943704f$var$_ref2 = {
    name: "am2lta",
    styles: ".pm-breakout-resize-handle-rail-wrapper{display:flex;align-items:center;justify-content:center;height:100%;cursor:col-resize;border-radius:4px;z-index:2;[role=\"presentation\"]{height:100%;width:100%;}.pm-breakout-resize-handle-rail-inside-tooltip{height:100%;}}"
};
const $664b56465943704f$export$21b363e15a3a4b0b = ()=>{
    if ((0, $9Letn.expValEqualsNoExposure)('platform_editor_breakout_resizing', 'isEnabled', true) && (0, $eGOwo.fg)('platform_editor_breakout_resizing_hello_release')) return $664b56465943704f$var$_ref2;
};
var $664b56465943704f$var$_ref = {
    name: "zqeg2w",
    styles: ".fabric-editor-breakout-mark{&:has([data-prosemirror-node-name=\"layoutSection\"].first-node-in-document){> .pm-breakout-resize-handle-container{height:calc(100% - 8px);}}}"
};
const $664b56465943704f$export$241444dc11ae22d6 = ()=>{
    if ((0, $92xoS.editorExperiment)('advanced_layouts', true) && (0, $9Letn.expValEqualsNoExposure)('platform_editor_breakout_resizing', 'isEnabled', true) && (0, $eGOwo.fg)('platform_editor_breakout_resizing_hello_release')) return $664b56465943704f$var$_ref;
};
const $664b56465943704f$export$62cd5dfd9881f590 = ()=>{
    if (!(0, $9Letn.expValEqualsNoExposure)('platform_editor_breakout_resizing', 'isEnabled', true)) return;
    // styles needed to be duplicated
    if ((0, $eGOwo.fg)('platform_editor_breakout_resizing_hello_release')) return /*#__PURE__*/ (0, $1NIU8.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.fabric-editor-breakout-mark': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:has([data-prosemirror-node-name="codeBlock"])': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '> .pm-breakout-resize-handle-container--left': {
                    left: '-5px'
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '> .pm-breakout-resize-handle-container--right': {
                    right: '-5px'
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '> .pm-breakout-resize-handle-container': {
                    height: 'calc(100% - 12px)'
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:has([data-prosemirror-node-name="expand"]), &:has([data-prosemirror-node-name="layoutSection"])': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '> .pm-breakout-resize-handle-container--left': {
                    left: '-25px'
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '> .pm-breakout-resize-handle-container--right': {
                    right: '-25px'
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:has([data-prosemirror-node-name="expand"])': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '> .pm-breakout-resize-handle-container': {
                    height: 'calc(100% - 4px)'
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:has([data-prosemirror-node-name="layoutSection"])': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '> .pm-breakout-resize-handle-container': {
                    height: 'calc(100% - 8px)'
                }
            },
            // the first node in the document always has margin-top = 0
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:has(.first-node-in-document)': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '> .pm-breakout-resize-handle-container': {
                    height: '100%'
                }
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.pm-breakout-resize-handle-container': {
            position: 'relative',
            alignSelf: 'end',
            gridRow: 1,
            gridColumn: 1,
            height: '100%',
            width: 7
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.pm-breakout-resize-handle-container--left': {
            justifySelf: 'start'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.pm-breakout-resize-handle-container--right': {
            justifySelf: 'end'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.pm-breakout-resize-handle-rail': {
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            cursor: 'col-resize',
            borderRadius: 4,
            transition: 'background-color 0.2s, visibility 0.2s, opacity 0.2s',
            zIndex: 2,
            opacity: 0,
            '&:hover': {
                background: "var(--ds-background-selected, #E9F2FF)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '.pm-breakout-resize-handle-thumb': {
                    background: "var(--ds-border-focused, #388BFF)"
                }
            }
        },
        // same as 'hover' styles above
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.pm-breakout-resize-handle-container--active': {
            background: "var(--ds-background-selected, #E9F2FF)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.pm-breakout-resize-handle-thumb': {
                background: "var(--ds-border-focused, #388BFF)"
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.pm-breakout-resize-handle-hit-box': {
            position: 'absolute',
            top: 0,
            bottom: 0,
            left: -20,
            right: -20,
            zIndex: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.pm-breakout-resize-handle-thumb': {
            minWidth: $664b56465943704f$export$b5fa87f62ced4967,
            // copied from resizeStyles.clamped
            height: 'clamp(27px, calc(100% - 32px), 96px)',
            background: "var(--ds-border, #091E4224)",
            borderRadius: 6,
            // sticky styles
            position: 'sticky',
            top: "var(--ds-space-150, 12px)",
            bottom: "var(--ds-space-150, 12px)"
        }
    });
    return /*#__PURE__*/ (0, $1NIU8.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.fabric-editor-breakout-mark': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:has([data-prosemirror-node-name="codeBlock"])': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '> .pm-breakout-resize-handle-container--left': {
                    left: '-12px'
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '> .pm-breakout-resize-handle-container--right': {
                    right: '-12px'
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '> .pm-breakout-resize-handle-container': {
                    height: 'calc(100% - 12px)'
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:has([data-prosemirror-node-name="expand"]), &:has([data-prosemirror-node-name="layoutSection"])': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '> .pm-breakout-resize-handle-container--left': {
                    left: '-32px'
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '> .pm-breakout-resize-handle-container--right': {
                    right: '-32px'
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:has([data-prosemirror-node-name="expand"])': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '> .pm-breakout-resize-handle-container': {
                    height: 'calc(100% - 4px)'
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:has([data-prosemirror-node-name="layoutSection"])': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '> .pm-breakout-resize-handle-container': {
                    height: 'calc(100% - 8px)'
                }
            },
            // the first node in the document always has margin-top = 0
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:has(.first-node-in-document)': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '> .pm-breakout-resize-handle-container': {
                    height: '100%'
                }
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.pm-breakout-resize-handle-container': {
            position: 'relative',
            alignSelf: 'end',
            gridRow: 1,
            gridColumn: 1,
            height: '100%',
            width: 7
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.pm-breakout-resize-handle-container--left': {
            justifySelf: 'start'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.pm-breakout-resize-handle-container--right': {
            justifySelf: 'end'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.pm-breakout-resize-handle-rail': {
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            cursor: 'col-resize',
            borderRadius: 4,
            transition: 'background-color 0.2s, visibility 0.2s, opacity 0.2s',
            zIndex: 2,
            opacity: 0,
            '&:hover': {
                background: "var(--ds-background-selected, #E9F2FF)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '.pm-breakout-resize-handle-thumb': {
                    background: "var(--ds-border-focused, #388BFF)"
                }
            }
        },
        // same as 'hover' styles above
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.pm-breakout-resize-handle-container--active': {
            background: "var(--ds-background-selected, #E9F2FF)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.pm-breakout-resize-handle-thumb': {
                background: "var(--ds-border-focused, #388BFF)"
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.pm-breakout-resize-handle-hit-box': {
            position: 'absolute',
            top: 0,
            bottom: 0,
            left: -20,
            right: -20,
            zIndex: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.pm-breakout-resize-handle-thumb': {
            minWidth: $664b56465943704f$export$b5fa87f62ced4967,
            // copied from resizeStyles.clamped
            height: 'clamp(27px, calc(100% - 32px), 96px)',
            background: "var(--ds-border, #091E4224)",
            borderRadius: 6,
            // sticky styles
            position: 'sticky',
            top: "var(--ds-space-150, 12px)",
            bottom: "var(--ds-space-150, 12px)"
        }
    });
};

});
parcelRegister("9Letn", function(module, exports) {

$parcel$export(module.exports, "expValEqualsNoExposure", () => $83516221b3225979$export$63eebf86443a0a61);

var $803eB = parcelRequire("803eB");
function $83516221b3225979$export$63eebf86443a0a61(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue = null) {
    return (0, $803eB.expValEqualsInternal)(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue, false);
}

});


parcelRegister("lI1SP", function(module, exports) {

$parcel$export(module.exports, "ruleSharedStyles", () => $49a08d08535c0e06$export$329434b3a2da905e);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $7yBx7 = parcelRequire("7yBx7");
const $49a08d08535c0e06$export$329434b3a2da905e = ()=>/*#__PURE__*/ (0, $1NIU8.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& hr': {
            border: 'none',
            backgroundColor: "var(--ds-border, #091E4224)",
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            margin: `${(0, $7yBx7.akEditorLineHeight)}em 0`,
            height: '2px',
            borderRadius: '1px'
        }
    });

});

parcelRegister("aaqba", function(module, exports) {

$parcel$export(module.exports, "shadowSharedStyle", () => $5fcdd12c7005a7ac$export$985ce3da3286f9ed);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $7yBx7 = parcelRequire("7yBx7");

var $k6yTf = parcelRequire("k6yTf");

var $3gw29 = parcelRequire("3gw29");
const $5fcdd12c7005a7ac$var$shadowWidth = 8;
/**
 * TODO: This is close to working and removes a tone of JS from OverflowShadow component
 *
 *  background: linear-gradient(to right, white 30%, rgba(255, 255, 255, 0)),
 *         linear-gradient(to right, rgba(255, 255, 255, 0), white 70%) 100% 0,
 *        linear-gradient(to right, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0)),
 *         linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.2)) 100% 0;
 *       background-repeat: no-repeat;
 *       background-color: white;
 *       background-size: 40px 100%, 40px 100%, 14px 100%, 14px 100%;
 *
 *      background-attachment: local, local, scroll, scroll;
 */ const $5fcdd12c7005a7ac$export$985ce3da3286f9ed = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $k6yTf.shadowClassNames).RIGHT_SHADOW}::before, .${(0, $k6yTf.shadowClassNames).RIGHT_SHADOW}::after, .${(0, $k6yTf.shadowClassNames).LEFT_SHADOW}::before, .${(0, $k6yTf.shadowClassNames).LEFT_SHADOW}::after`]: {
        display: 'none',
        position: 'absolute',
        pointerEvents: 'none',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: (0, $7yBx7.akEditorShadowZIndex),
        width: `${$5fcdd12c7005a7ac$var$shadowWidth}px`,
        content: "''",
        height: 'calc(100%)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $k6yTf.shadowClassNames).RIGHT_SHADOW}, .${(0, $k6yTf.shadowClassNames).LEFT_SHADOW}`]: {
        position: 'relative'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $k6yTf.shadowClassNames).LEFT_SHADOW}::before`]: {
        background: `linear-gradient( to left, transparent 0, ${"var(--ds-shadow-overflow-spread, #091e4229)"} 140% ), linear-gradient( to right, ${"var(--ds-shadow-overflow-perimeter, transparent)"} 0px, transparent 1px )`,
        top: '0px',
        left: 0,
        display: 'block'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $k6yTf.shadowClassNames).RIGHT_SHADOW}::after`]: {
        background: `linear-gradient( to right, transparent 0, ${"var(--ds-shadow-overflow-spread, #091e4229)"} 140% ), linear-gradient( to left, ${"var(--ds-shadow-overflow-perimeter, transparent)"} 0px, transparent 1px )`,
        right: '0px',
        top: '0px',
        display: 'block'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $3gw29.shadowObserverClassNames).SENTINEL_LEFT}`]: {
        height: '100%',
        width: '0px',
        minWidth: '0px'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $3gw29.shadowObserverClassNames).SENTINEL_RIGHT}`]: {
        height: '100%',
        width: '0px',
        minWidth: '0px'
    }
});

});

parcelRegister("hkyHj", function(module, exports) {

$parcel$export(module.exports, "DATASOURCE_INNER_CONTAINER_CLASSNAME", () => $c59ef2f2bf46923b$export$32f80df830e375f6);
$parcel$export(module.exports, "FLOATING_TOOLBAR_LINKPICKER_CLASSNAME", () => $c59ef2f2bf46923b$export$863ae87a9d233606);
$parcel$export(module.exports, "smartCardStyles", () => $c59ef2f2bf46923b$export$b346a5d6d598424c);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $7yBx7 = parcelRequire("7yBx7");
var $2N2k8 = parcelRequire("2N2k8");
var $egs2l = parcelRequire("egs2l");

var $eGOwo = parcelRequire("eGOwo");

var $9Letn = parcelRequire("9Letn");

var $92xoS = parcelRequire("92xoS");

var $e2Ny4 = parcelRequire("e2Ny4");
const $c59ef2f2bf46923b$export$32f80df830e375f6 = 'datasourceView-content-inner-wrap';
const $c59ef2f2bf46923b$export$863ae87a9d233606 = 'card-floating-toolbar--link-picker';
const $c59ef2f2bf46923b$export$b346a5d6d598424c = ()=>/*#__PURE__*/ (0, $1NIU8.css)(".", (0, $e2Ny4.SmartCardSharedCssClassName).INLINE_CARD_CONTAINER, "{max-width:calc(100% - 20px);vertical-align:top;word-break:break-all;", (0, $eGOwo.fg)('editor_inline_comments_on_inline_nodes') ? `.card-with-comment {
          background: ${"var(--ds-background-accent-yellow-subtler, #F8E6A0)"};
          border-bottom: 2px solid ${"var(--ds-border-accent-yellow, #B38600)"};
          box-shadow: ${"var(--ds-shadow-overlay, 0px 8px 12px #091E4226, 0px 0px 1px #091E424f)"};
        }` : '', " .card{padding-left:var(--ds-space-025, 2px);padding-right:var(--ds-space-025, 2px);padding-top:0.5em;padding-bottom:0.5em;margin-bottom:-0.5em;.", (0, $e2Ny4.SmartCardSharedCssClassName).LOADER_WRAPPER, ">a:focus{", (0, $2N2k8.getSelectionStyles)([
        (0, $egs2l.SelectionStyle).BoxShadow
    ]), ";}}", (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1') ? `[data-inlinecard-button-overlay='icon-wrapper-line-height'] span {
				line-height: 0;
			}` : '', " ", (0, $9Letn.expValEqualsNoExposure)('platform_editor_find_and_replace_improvements', 'isEnabled', true) && (0, $eGOwo.fg)('platform_editor_find_and_replace_improvements_1') ? `
				&.${0, $7yBx7.akEditorSelectedNodeClassName}:not(.search-match-block) .${(0, $e2Ny4.SmartCardSharedCssClassName).LOADER_WRAPPER} > a {
				${(0, $2N2k8.getSelectionStyles)([
        (0, $egs2l.SelectionStyle).BoxShadow
    ])}
			}` : `
				&.${0, $7yBx7.akEditorSelectedNodeClassName} .${(0, $e2Ny4.SmartCardSharedCssClassName).LOADER_WRAPPER} > a {
				${(0, $2N2k8.getSelectionStyles)([
        (0, $egs2l.SelectionStyle).BoxShadow
    ])}
			}`, " .", (0, $e2Ny4.SmartCardSharedCssClassName).LOADER_WRAPPER, ">a{z-index:1;position:relative;}&.danger{.", (0, $e2Ny4.SmartCardSharedCssClassName).LOADER_WRAPPER, ">a{box-shadow:0 0 0 1px ", `var(--ds-border-danger, ${(0, $7yBx7.akEditorDeleteBorder)})`, ";z-index:2;}}}.", (0, $e2Ny4.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER, "{.", (0, $e2Ny4.SmartCardSharedCssClassName).LOADER_WRAPPER, ">div{cursor:", // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-registration
    (0, $eGOwo.fg)('linking_platform_smart_links_in_live_pages') ? 'text' : 'pointer', ";a{cursor:", // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-registration
    (0, $eGOwo.fg)('linking_platform_smart_links_in_live_pages') ? 'pointer' : 'auto', ";}}&.", (0, $7yBx7.akEditorSelectedNodeClassName), " .", (0, $e2Ny4.SmartCardSharedCssClassName).LOADER_WRAPPER, ">div{", (0, $2N2k8.getSelectionStyles)([
        (0, $egs2l.SelectionStyle).BoxShadow
    ]), " border-radius:var(--ds-border-radius-200, 8px);}&.danger{.", (0, $e2Ny4.SmartCardSharedCssClassName).LOADER_WRAPPER, ">div{box-shadow:0 0 0 1px ", `var(--ds-border-danger, ${(0, $7yBx7.akEditorDeleteBorder)})`, "!important;}}}.", (0, $e2Ny4.SmartCardSharedCssClassName).DATASOURCE_CONTAINER, ".", (0, $e2Ny4.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER, "{max-width:100%;display:flex;justify-content:center;.", $c59ef2f2bf46923b$export$32f80df830e375f6, "{cursor:pointer;background-color:var(--ds-background-neutral-subtle, #00000000);border-radius:var(--ds-border-radius-200, 8px);border:1px solid var(--ds-border, #091E4224);overflow:hidden;}&.", (0, $7yBx7.akEditorSelectedNodeClassName), "{.", $c59ef2f2bf46923b$export$32f80df830e375f6, "{", (0, $2N2k8.getSelectionStyles)([
        (0, $egs2l.SelectionStyle).BoxShadow
    ]), " input::selection{background-color:var(--ds-background-selected-hovered, #CCE0FF);}input::-moz-selection{background-color:var(--ds-background-selected-hovered, #CCE0FF);}}}&.danger{.", $c59ef2f2bf46923b$export$32f80df830e375f6, "{box-shadow:0 0 0 1px ", `var(--ds-border-danger, ${(0, $7yBx7.akEditorDeleteBorder)})`, ";}}}.", (0, $e2Ny4.SmartCardSharedCssClassName).EMBED_CARD_CONTAINER, "{.", (0, $e2Ny4.SmartCardSharedCssClassName).LOADER_WRAPPER, ">div{cursor:pointer;a{cursor:", // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-registration
    (0, $eGOwo.fg)('linking_platform_smart_links_in_live_pages') ? 'pointer' : 'auto', ";}&::after{transition:box-shadow 0s;}}", (0, $9Letn.expValEqualsNoExposure)('platform_editor_find_and_replace_improvements', 'isEnabled', true) && (0, $eGOwo.fg)('platform_editor_find_and_replace_improvements_1') ? `
				&.${0, $7yBx7.akEditorSelectedNodeClassName}:not(.search-match-block) .${(0, $e2Ny4.SmartCardSharedCssClassName).LOADER_WRAPPER} > div::after {
					${(0, $2N2k8.getSelectionStyles)([
        (0, $egs2l.SelectionStyle).BoxShadow
    ])}
				}
			` : `
				&.${0, $7yBx7.akEditorSelectedNodeClassName} .${(0, $e2Ny4.SmartCardSharedCssClassName).LOADER_WRAPPER} > div::after {
					${(0, $2N2k8.getSelectionStyles)([
        (0, $egs2l.SelectionStyle).BoxShadow
    ])}
				}
			`, " &.danger{.media-card-frame::after{box-shadow:0 0 0 1px ", `var(--ds-border-danger, ${(0, $7yBx7.akEditorDeleteBorder)})`, "!important;background:", `var(--ds-background-danger, ${(0, $7yBx7.akEditorDeleteBackground)})`, "!important;}.richMedia-resize-handle-right::after,.richMedia-resize-handle-left::after{background:", `var(--ds-border-danger, ${(0, $7yBx7.akEditorDeleteBorder)})`, ";}}}.", $c59ef2f2bf46923b$export$863ae87a9d233606, "{padding:0;}");

});
parcelRegister("2N2k8", function(module, exports) {

$parcel$export(module.exports, "getSelectionStyles", () => $6b23a7199e707c88$export$fb186b651805ffe4);
$parcel$export(module.exports, "hideNativeBrowserTextSelectionStyles", () => $6b23a7199e707c88$export$a716852a0c5e54d5);

var $7yBx7 = parcelRequire("7yBx7");

var $egs2l = parcelRequire("egs2l");
const $6b23a7199e707c88$export$fb186b651805ffe4 = (selectionStyles)=>selectionStyles.map((selectionStyle)=>$6b23a7199e707c88$var$getSelectionStyle(selectionStyle)).concat($6b23a7199e707c88$export$a716852a0c5e54d5).join('\n');
const $6b23a7199e707c88$export$a716852a0c5e54d5 = `
  ::selection,*::selection {
    background-color: transparent;
  }
  ::-moz-selection,*::-moz-selection {
    background-color: transparent;
  }
`;
const $6b23a7199e707c88$var$getSelectionStyle = (style)=>{
    switch(style){
        case (0, $egs2l.SelectionStyle).Border:
            return `
        border: ${0, $7yBx7.akEditorSelectedBorder};

        // Fixes ED-15246: Trello card is visible through a border of a table border
        &::after {
          height: 100%;
          content: '\\00a0';
          background: ${0, $7yBx7.akEditorSelectedBorderColor};
          position: absolute;
          right: -1px;
          top: 0;
          bottom: 0;
          width: 1px;
          border: none;
          display: inline-block;
        }
      `;
        case (0, $egs2l.SelectionStyle).BoxShadow:
            return `
        box-shadow: ${0, $7yBx7.akEditorSelectedBoxShadow};
        border-color: transparent;
        `;
        case (0, $egs2l.SelectionStyle).Background:
            return `background-color: ${"var(--ds-background-selected, #E9F2FF)"};`;
        case (0, $egs2l.SelectionStyle).Blanket:
            return `
        position: relative;

        // Fixes ED-9263, where emoji or inline card in panel makes selection go outside the panel
        // in Safari. Looks like it's caused by user-select: all in the emoji element
        -webkit-user-select: text;

        ::before {
          position: absolute;
          content: '';
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          width: 100%;
          pointer-events: none;
          z-index: ${0, $7yBx7.akEditorSmallZIndex};
          background-color: ${"var(--ds-blanket-selected, #388BFF14)"}
        }`;
        default:
            return '';
    }
};

});
parcelRegister("egs2l", function(module, exports) {

$parcel$export(module.exports, "SelectionStyle", () => $947335242c3fddd4$export$80010201b36a8290);
/**
 * These are generic selection styles for all nodes
 * If you have custom behaviour needed for a node, add that in the plugin's styles
 * file in editor-core
 */ var $947335242c3fddd4$export$80010201b36a8290 = /*#__PURE__*/ function(SelectionStyle) {
    SelectionStyle[SelectionStyle["Border"] = 0] = "Border";
    SelectionStyle[SelectionStyle["BoxShadow"] = 1] = "BoxShadow";
    SelectionStyle[SelectionStyle["Background"] = 2] = "Background";
    SelectionStyle[SelectionStyle["Blanket"] = 3] = "Blanket";
    return SelectionStyle;
}({});

});



parcelRegister("bhdjn", function(module, exports) {

$parcel$export(module.exports, "textColorStyles", () => $12f4786441ff2012$export$a518ea5d00002b38);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $12f4786441ff2012$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $12f4786441ff2012$export$a518ea5d00002b38 = {
    name: "1nlqh0j",
    styles: ".fabric-text-color-mark{color:var(--custom-palette-color, inherit);}a .fabric-text-color-mark{color:unset;}"
};

});

parcelRegister("iCwuj", function(module, exports) {

$parcel$export(module.exports, "UnsupportedSharedCssClassName", () => $45e608889ed741c9$export$629043421dcc56e5);
$parcel$export(module.exports, "unsupportedStyles", () => $45e608889ed741c9$export$637bcb89343f7ef4);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $7yBx7 = parcelRequire("7yBx7");
var $2N2k8 = parcelRequire("2N2k8");
var $egs2l = parcelRequire("egs2l");
const $45e608889ed741c9$export$629043421dcc56e5 = {
    BLOCK_CONTAINER: 'unsupportedBlockView-content-wrap',
    INLINE_CONTAINER: 'unsupportedInlineView-content-wrap'
};
const $45e608889ed741c9$var$inlineUnsupportedSelector = `.${$45e608889ed741c9$export$629043421dcc56e5.INLINE_CONTAINER} > span:nth-of-type(2)`;
const $45e608889ed741c9$var$blockUnsupportedSelector = `.${$45e608889ed741c9$export$629043421dcc56e5.BLOCK_CONTAINER} > div`;
const $45e608889ed741c9$export$637bcb89343f7ef4 = /*#__PURE__*/ (0, $1NIU8.css)($45e608889ed741c9$var$blockUnsupportedSelector, ",", $45e608889ed741c9$var$inlineUnsupportedSelector, "{cursor:pointer;}.", (0, $7yBx7.akEditorSelectedNodeClassName), $45e608889ed741c9$var$blockUnsupportedSelector, ",.", (0, $7yBx7.akEditorSelectedNodeClassName), $45e608889ed741c9$var$inlineUnsupportedSelector, "{", (0, $2N2k8.getSelectionStyles)([
    (0, $egs2l.SelectionStyle).Background,
    (0, $egs2l.SelectionStyle).Border
]), ";}.danger{.", (0, $7yBx7.akEditorSelectedNodeClassName), $45e608889ed741c9$var$blockUnsupportedSelector, ",.", (0, $7yBx7.akEditorSelectedNodeClassName), $45e608889ed741c9$var$inlineUnsupportedSelector, "{border:", (0, $7yBx7.akEditorSelectedBorderSize), "px solid ", `var(--ds-border-danger, ${(0, $7yBx7.akEditorDeleteBorder)})`, ";background-color:", `var(--ds-blanket-danger, ${(0, $7yBx7.akEditorDeleteBackgroundWithOpacity)})`, ";}}");

});

parcelRegister("6up3L", function(module, exports) {

$parcel$export(module.exports, "whitespaceSharedStyles", () => $8b32076d952ebf30$export$c9ce3bfa46d7acba);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $8b32076d952ebf30$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8b32076d952ebf30$export$c9ce3bfa46d7acba = {
    name: "1s8ykn2",
    styles: "word-wrap:break-word;white-space:pre-wrap"
};

});

parcelRegister("fOha9", function(module, exports) {

$parcel$export(module.exports, "blocktypeStyles", () => (parcelRequire("cC0Do")).blocktypeStyles);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $cC0Do = parcelRequire("cC0Do");

});
parcelRegister("cC0Do", function(module, exports) {

$parcel$export(module.exports, "blocktypeStyles", () => $059db71ad6c547b2$export$610a2509037eaf6);
/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $lu6Kl = parcelRequire("lu6Kl");
var $ifrjt = parcelRequire("ifrjt");

var $eGOwo = parcelRequire("eGOwo");
const $059db71ad6c547b2$export$610a2509037eaf6 = (typographyTheme)=>/*#__PURE__*/ (0, $1NIU8.css)(".ProseMirror{", (0, $lu6Kl.blockquoteSharedStyles), ";", (0, $ifrjt.headingsSharedStyles)(typographyTheme), ";}", (0, $eGOwo.fg)('platform_editor_nested_dnd_styles_changes') && `.ak-editor-content-area.appearance-full-page .ProseMirror blockquote {
		padding-left: ${"var(--ds-space-250, 20px)"};
	}

	/* Don't want extra padding for inline editor (nested) */
	.ak-editor-content-area .ak-editor-content-area .ProseMirror blockquote {
		padding-left: ${"var(--ds-space-200, 16px)"};
	}`, ";");

});
parcelRegister("lu6Kl", function(module, exports) {

$parcel$export(module.exports, "blockquoteSharedStyles", () => $f7ed224e95af54b3$export$1b5f3b43e6c4a8ee);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $7yBx7 = parcelRequire("7yBx7");
const $f7ed224e95af54b3$export$1b5f3b43e6c4a8ee = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& blockquote': {
        boxSizing: 'border-box',
        color: 'inherit',
        width: '100%',
        display: 'inline-block',
        paddingLeft: "var(--ds-space-200, 16px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        borderLeft: `2px solid ${`var(--ds-border, ${(0, $7yBx7.akEditorBlockquoteBorderColor)})`}`,
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: `${(0, $7yBx7.blockNodesVerticalMargin)} 0 0 0`,
        marginRight: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        "[dir='rtl'] &": {
            paddingLeft: 0,
            paddingRight: "var(--ds-space-200, 16px)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:first-child': {
            marginTop: 0
        },
        '&::before': {
            content: "''"
        },
        '&::after': {
            content: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& p': {
            display: 'block'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '& table, & table:last-child': {
            display: 'inline-table'
        },
        // Workaround for overriding the inline-block display on last child of a blockquote set in CSS reset.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> .code-block:last-child, >.mediaSingleView-content-wrap:last-child, >.mediaGroupView-content-wrap:last-child': {
            display: 'block'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '> .extensionView-content-wrap:last-child': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            display: 'block'
        }
    }
});

});

parcelRegister("ifrjt", function(module, exports) {

$parcel$export(module.exports, "headingsSharedStyles", () => $072b136e11b961b1$export$9272613b68afed4b);
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ /* eslint-disable @atlaskit/design-system/use-tokens-space */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $eGOwo = parcelRequire("eGOwo");

var $Vv4zU = parcelRequire("Vv4zU");
const $072b136e11b961b1$var$headingWithAlignmentStyles = ()=>// Override marginTop: 0 with default margin found in headingsSharedStyles for first heading in alignment block that is not the first child
    ({
        '.fabric-editor-block-mark.fabric-editor-alignment:not(:first-child)': {
            '> h1:first-child': {
                marginTop: '1.667em'
            },
            ' > h2:first-child': {
                marginTop: '1.8em'
            },
            '> h3:first-child': {
                marginTop: '2em'
            },
            '> h4:first-child': {
                marginTop: '1.357em'
            },
            '> h5:first-child': {
                marginTop: '1.667em'
            },
            '> h6:first-child': {
                marginTop: '1.455em'
            }
        },
        // Set marginTop: 0 if alignment block is next to a gap cursor or widget that is first child
        '.ProseMirror-gapcursor:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .ProseMirror-widget:nth-child(2) + .fabric-editor-block-mark.fabric-editor-alignment': {
            '> :is(h1, h2, h3, h4, h5, h6):first-child': {
                marginTop: '0'
            }
        }
    });
const $072b136e11b961b1$export$9272613b68afed4b = (typographyTheme)=>{
    if ((0, $eGOwo.fg)('platform_editor_typography_ugc')) return /*#__PURE__*/ (0, $1NIU8.css)({
        '& h1': {
            font: (0, $Vv4zU.default)('editor.font.heading.h1'),
            marginBottom: 0,
            marginTop: '1.45833em',
            '& strong': {
                fontWeight: (0, $Vv4zU.default)('editor.font.weight.heading.h1.bold')
            },
            '&::before': {}
        },
        '& h2': {
            font: (0, $Vv4zU.default)('editor.font.heading.h2'),
            marginTop: '1.4em',
            marginBottom: 0,
            '& strong': {
                fontWeight: (0, $Vv4zU.default)('editor.font.weight.heading.h1.bold')
            }
        },
        '& h3': {
            font: (0, $Vv4zU.default)('editor.font.heading.h3'),
            marginTop: '1.31249em',
            marginBottom: 0,
            '& strong': {
                fontWeight: (0, $Vv4zU.default)('editor.font.weight.heading.h1.bold')
            }
        },
        '& h4': {
            font: (0, $Vv4zU.default)('editor.font.heading.h4'),
            marginTop: '1.25em',
            '& strong': {
                fontWeight: (0, $Vv4zU.default)('editor.font.weight.heading.h1.bold')
            }
        },
        '& h5': {
            font: (0, $Vv4zU.default)('editor.font.heading.h5'),
            marginTop: '1.45833em',
            textTransform: 'none',
            '& strong': {
                fontWeight: (0, $Vv4zU.default)('editor.font.weight.heading.h1.bold')
            }
        },
        '& h6': {
            font: (0, $Vv4zU.default)('editor.font.heading.h6'),
            marginTop: '1.59091em',
            textTransform: 'none',
            '& strong': {
                fontWeight: (0, $Vv4zU.default)('editor.font.weight.heading.h1.bold')
            }
        },
        ...$072b136e11b961b1$var$headingWithAlignmentStyles()
    });
    else return /*#__PURE__*/ (0, $1NIU8.css)({
        '& h1': {
            fontSize: `${24 / 14}em`,
            fontStyle: 'inherit',
            lineHeight: 28 / 24,
            color: "var(--ds-text, #172B4D)",
            fontWeight: "var(--ds-font-weight-medium, 500)",
            letterSpacing: `-0.01em`,
            marginBottom: 0,
            marginTop: '1.667em'
        },
        '& h2': {
            fontSize: `${20 / 14}em`,
            fontStyle: 'inherit',
            lineHeight: 1.2,
            color: "var(--ds-text, #172B4D)",
            fontWeight: "var(--ds-font-weight-medium, 500)",
            letterSpacing: `-0.008em`,
            marginTop: '1.8em',
            marginBottom: 0
        },
        '& h3': {
            fontSize: `${16 / 14}em`,
            fontStyle: 'inherit',
            lineHeight: 1.25,
            color: "var(--ds-text, #172B4D)",
            fontWeight: "var(--ds-font-weight-semibold, 600)",
            letterSpacing: `-0.006em`,
            marginTop: '2em',
            marginBottom: 0
        },
        '& h4': {
            fontSize: `${1}em`,
            fontStyle: 'inherit',
            lineHeight: 16 / 14,
            color: "var(--ds-text, #172B4D)",
            fontWeight: "var(--ds-font-weight-semibold, 600)",
            letterSpacing: `-0.003em`,
            marginTop: '1.357em'
        },
        '& h5': {
            fontSize: `${12 / 14}em`,
            fontStyle: 'inherit',
            lineHeight: 16 / 12,
            color: "var(--ds-text, #172B4D)",
            fontWeight: "var(--ds-font-weight-semibold, 600)",
            marginTop: '1.667em',
            textTransform: 'none'
        },
        '& h6': {
            fontSize: `${11 / 14}em`,
            fontStyle: 'inherit',
            lineHeight: 16 / 11,
            color: "var(--ds-text-subtlest, #626F86)",
            fontWeight: "var(--ds-font-weight-bold, 700)",
            marginTop: '1.455em',
            textTransform: 'none'
        },
        ...$072b136e11b961b1$var$headingWithAlignmentStyles()
    });
};

});



parcelRegister("fTxct", function(module, exports) {

$parcel$export(module.exports, "findReplaceStyles", () => (parcelRequire("b1G5H")).findReplaceStyles);
$parcel$export(module.exports, "findReplaceStylesNew", () => (parcelRequire("b1G5H")).findReplaceStylesNew);
$parcel$export(module.exports, "findReplaceStylesNewNoImportant", () => (parcelRequire("b1G5H")).findReplaceStylesNewNoImportant);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $b1G5H = parcelRequire("b1G5H");

});
parcelRegister("b1G5H", function(module, exports) {

$parcel$export(module.exports, "searchMatchClass", () => $f1d038f000d0a156$export$cec6db4af40340f0);
$parcel$export(module.exports, "searchMatchTextClass", () => $f1d038f000d0a156$export$a19ecadc9ecc39b1);
$parcel$export(module.exports, "selectedSearchMatchClass", () => $f1d038f000d0a156$export$bf208a338b2a2f1f);
$parcel$export(module.exports, "blockSearchMatchClass", () => $f1d038f000d0a156$export$bb09fa712812841f);
$parcel$export(module.exports, "selectedBlockSearchMatchClass", () => $f1d038f000d0a156$export$99146b4c1ad5837a);
$parcel$export(module.exports, "darkModeSearchMatchClass", () => $f1d038f000d0a156$export$6cc90c491f952538);
$parcel$export(module.exports, "searchMatchExpandTitleClass", () => $f1d038f000d0a156$export$2414358ab66f419a);
$parcel$export(module.exports, "findReplaceStyles", () => $f1d038f000d0a156$export$c5ceb9c726010930);
$parcel$export(module.exports, "findReplaceStylesNew", () => $f1d038f000d0a156$export$f6e8277f5198ab7b);
$parcel$export(module.exports, "findReplaceStylesNewNoImportant", () => $f1d038f000d0a156$export$4b5dc75d9d87c842);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ /* eslint-disable */ 
var $1NIU8 = parcelRequire("1NIU8");


var $is7NW = parcelRequire("is7NW");
const $f1d038f000d0a156$export$cec6db4af40340f0 = 'search-match';
const $f1d038f000d0a156$export$a19ecadc9ecc39b1 = 'search-match-text';
const $f1d038f000d0a156$export$bf208a338b2a2f1f = 'selected-search-match';
const $f1d038f000d0a156$export$bb09fa712812841f = 'search-match-block';
const $f1d038f000d0a156$export$99146b4c1ad5837a = 'search-match-block-selected';
const $f1d038f000d0a156$export$6cc90c491f952538 = 'search-match-dark';
const $f1d038f000d0a156$export$2414358ab66f419a = 'search-match-expand-title';
const $f1d038f000d0a156$var$inlineCardSelector = '.loader-wrapper>a';
const $f1d038f000d0a156$var$statusSelector = '.lozenge-wrapper';
const $f1d038f000d0a156$var$mentionSelector = '.editor-mention-primitive';
const $f1d038f000d0a156$var$dateSelector = '.date-lozenger-container>span';
const $f1d038f000d0a156$export$c5ceb9c726010930 = /*#__PURE__*/ (0, $1NIU8.css)({
    [`.${$f1d038f000d0a156$export$cec6db4af40340f0}`]: {
        borderRadius: '3px',
        backgroundColor: "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
        boxShadow: `var(--ds-shadow-raised, ${`0 1px 1px 0 ${(0, $7bb4c1736002a04a$export$7d3359664e8bb0e5)}, 0 0 1px 0 ${(0, $7bb4c1736002a04a$export$d2d3bedfb276cac0)}`})` + ', inset 0 0 0 1px ' + `var(--ds-border-input, ${`${0, $7bb4c1736002a04a$export$46987b49aab6d1a8}`})`
    },
    [`.${$f1d038f000d0a156$export$bf208a338b2a2f1f}`]: {
        backgroundColor: "var(--ds-background-accent-teal-subtle, #6CC3E0)"
    }
});
const $f1d038f000d0a156$export$f6e8277f5198ab7b = /*#__PURE__*/ (0, $1NIU8.css)({
    /** Text match styles */ /** Light mode */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    [`.${$f1d038f000d0a156$export$a19ecadc9ecc39b1}`]: {
        borderRadius: "var(--ds-space-050, 4px)",
        boxShadow: `
		inset 0 0 0 1px ${"var(--ds-background-accent-magenta-subtler-pressed, #E774BB)"},
		inset 0 0 0 5px ${"var(--ds-background-accent-magenta-subtler, #FDD0EC)"}
		`,
        // TODO: ED-28376 - clean up !important later
        backgroundColor: `${"var(--ds-background-accent-magenta-subtler, #FDD0EC)"} !important`,
        color: "var(--ds-text, #172B4D)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    [`.${$f1d038f000d0a156$export$a19ecadc9ecc39b1}.${$f1d038f000d0a156$export$bf208a338b2a2f1f}`]: {
        boxShadow: `
		inset 0 0 0 1px ${"var(--ds-background-accent-magenta-subtler-pressed, #E774BB)"},
		inset 0 0 0 5px ${"var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)"}
		`,
        // TODO: ED-28376 - clean up !important later
        backgroundColor: `${"var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)"} !important`
    },
    /** Dark mode */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    [`.${$f1d038f000d0a156$export$a19ecadc9ecc39b1}.${$f1d038f000d0a156$export$6cc90c491f952538}`]: {
        boxShadow: `
		inset 0 0 0 1px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"},
		inset 0 0 0 5px ${"var(--ds-background-accent-magenta-bolder-pressed, #50253F)"}
		`,
        // TODO: ED-28376 - clean up !important later
        backgroundColor: `${"var(--ds-background-accent-magenta-bolder-pressed, #50253F)"} !important`,
        color: "var(--ds-text-inverse, #FFFFFF)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    [`.${$f1d038f000d0a156$export$a19ecadc9ecc39b1}.${$f1d038f000d0a156$export$bf208a338b2a2f1f}.${$f1d038f000d0a156$export$6cc90c491f952538}`]: {
        boxShadow: `
		inset 0 0 0 1px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"},
		inset 0 0 0 5px ${"var(--ds-background-accent-magenta-bolder-hovered, #943D73)"}
		`,
        // TODO: ED-28376 - clean up !important later
        backgroundColor: `${"var(--ds-background-accent-magenta-bolder-hovered, #943D73)"} !important`
    },
    /** Block match styles */ /** Light mode */ /** Without node selection */ [`.${$f1d038f000d0a156$export$bb09fa712812841f}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-smart-link-container="true"], .loader-wrapper>div::after': {
            boxShadow: `
			inset 0 0 0 1px ${"var(--ds-background-accent-magenta-subtler-pressed, #E774BB)"},
			inset 0 0 0 5px ${"var(--ds-background-accent-magenta-subtler, #FDD0EC)"}
			`
        },
        [`${$f1d038f000d0a156$var$inlineCardSelector}, ${$f1d038f000d0a156$var$statusSelector}, ${$f1d038f000d0a156$var$mentionSelector}, ${$f1d038f000d0a156$var$dateSelector}`]: {
            boxShadow: `0px 0px 0px 4px ${"var(--ds-background-accent-magenta-subtler, #FDD0EC)"}, 0px 0px 0px 5px ${"var(--ds-background-accent-magenta-subtler-pressed, #E774BB)"}`
        }
    },
    [`.${$f1d038f000d0a156$export$bb09fa712812841f}.${$f1d038f000d0a156$export$99146b4c1ad5837a}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-smart-link-container="true"], .loader-wrapper>div::after': {
            boxShadow: `
			inset 0 0 0 1px ${"var(--ds-background-accent-magenta-subtler-pressed, #E774BB)"},
			inset 0 0 0 4px ${"var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)"}
			`
        },
        [`${$f1d038f000d0a156$var$inlineCardSelector}, ${$f1d038f000d0a156$var$statusSelector}, ${$f1d038f000d0a156$var$mentionSelector}, ${$f1d038f000d0a156$var$dateSelector}`]: {
            boxShadow: `0px 0px 0px 4px ${"var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)"}, 0px 0px 0px 5px ${"var(--ds-background-accent-magenta-subtler-pressed, #E774BB)"}`
        }
    },
    /** With node selection */ [`.${$f1d038f000d0a156$export$bb09fa712812841f}.ak-editor-selected-node`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.loader-wrapper>div::after': {
            boxShadow: `
			inset 0 0 0 1px ${"var(--ds-background-accent-magenta-subtler-pressed, #E774BB)"},
			inset 0 0 0 5px ${"var(--ds-background-accent-magenta-subtler, #FDD0EC)"},
			0 0 0 1px ${"var(--ds-border-selected, #0C66E4)"}
			`
        },
        [`${$f1d038f000d0a156$var$inlineCardSelector}, ${$f1d038f000d0a156$var$statusSelector}, ${$f1d038f000d0a156$var$mentionSelector}, ${$f1d038f000d0a156$var$dateSelector}`]: {
            // TODO: ED-28376 - will clean up !important later
            boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #0C66E4)"}, 0px 0px 0px 4px ${"var(--ds-background-accent-magenta-subtler, #FDD0EC)"}, 0px 0px 0px 5px ${"var(--ds-background-accent-magenta-subtler-pressed, #E774BB)"} !important`
        }
    },
    [`.${$f1d038f000d0a156$export$bb09fa712812841f}.${$f1d038f000d0a156$export$99146b4c1ad5837a}.ak-editor-selected-node`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-smart-link-container="true"], .loader-wrapper>div::after': {
            boxShadow: `
			inset 0 0 0 1px ${"var(--ds-background-accent-magenta-subtler-pressed, #E774BB)"},
			inset 0 0 0 4px ${"var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)"},
			0 0 0 1px ${"var(--ds-border-selected, #0C66E4)"}
			`
        },
        [`${$f1d038f000d0a156$var$inlineCardSelector}, ${$f1d038f000d0a156$var$statusSelector}, ${$f1d038f000d0a156$var$mentionSelector}, ${$f1d038f000d0a156$var$dateSelector}`]: {
            // TODO: ED-28376 - will clean up !important later
            boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #0C66E4)"}, 0px 0px 0px 4px ${"var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)"}, 0px 0px 0px 5px ${"var(--ds-background-accent-magenta-subtler-pressed, #E774BB)"} !important`
        }
    },
    /** Dark mode */ /** Without node selection */ [`.${$f1d038f000d0a156$export$bb09fa712812841f}.${$f1d038f000d0a156$export$6cc90c491f952538}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-smart-link-container="true"], .loader-wrapper>div::after': {
            boxShadow: `
			inset 0 0 0 1px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"},
			inset 0 0 0 5px ${"var(--ds-background-accent-magenta-bolder-pressed, #50253F)"}
			`
        },
        [`${$f1d038f000d0a156$var$inlineCardSelector}, ${$f1d038f000d0a156$var$statusSelector}, ${$f1d038f000d0a156$var$mentionSelector}, ${$f1d038f000d0a156$var$dateSelector}`]: {
            boxShadow: `0px 0px 0px 4px ${"var(--ds-background-accent-magenta-bolder-pressed, #50253F)"}, 0px 0px 0px 5px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"}`
        }
    },
    [`.${$f1d038f000d0a156$export$bb09fa712812841f}.${$f1d038f000d0a156$export$99146b4c1ad5837a}.${$f1d038f000d0a156$export$6cc90c491f952538}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-smart-link-container="true"], .loader-wrapper>div::after': {
            boxShadow: `
			inset 0 0 0 1px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"},
			inset 0 0 0 4px ${"var(--ds-background-accent-magenta-bolder-hovered, #943D73)"}
			`
        },
        [`${$f1d038f000d0a156$var$inlineCardSelector}, ${$f1d038f000d0a156$var$statusSelector}, ${$f1d038f000d0a156$var$mentionSelector}, ${$f1d038f000d0a156$var$dateSelector}`]: {
            boxShadow: `0px 0px 0px 4px ${"var(--ds-background-accent-magenta-bolder-hovered, #943D73)"}, 0px 0px 0px 5px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"}`
        }
    },
    /** With node selection */ [`.${$f1d038f000d0a156$export$bb09fa712812841f}.${$f1d038f000d0a156$export$6cc90c491f952538}.ak-editor-selected-node`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.loader-wrapper>div::after': {
            boxShadow: `
			inset 0 0 0 1px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"},
			inset 0 0 0 5px ${"var(--ds-background-accent-magenta-bolder-pressed, #50253F)"},
			0 0 0 1px ${"var(--ds-border-selected, #0C66E4)"}
			`
        },
        [`${$f1d038f000d0a156$var$inlineCardSelector}, ${$f1d038f000d0a156$var$statusSelector}, ${$f1d038f000d0a156$var$mentionSelector}, ${$f1d038f000d0a156$var$dateSelector}`]: {
            boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #0C66E4)"}, 0px 0px 0px 4px ${"var(--ds-background-accent-magenta-bolder-pressed, #50253F)"}, 0px 0px 0px 5px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"} !important`
        }
    },
    [`.${$f1d038f000d0a156$export$bb09fa712812841f}.${$f1d038f000d0a156$export$99146b4c1ad5837a}.${$f1d038f000d0a156$export$6cc90c491f952538}.ak-editor-selected-node`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-smart-link-container="true"], .loader-wrapper>div::after': {
            boxShadow: `
			inset 0 0 0 1px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"},
			inset 0 0 0 4px ${"var(--ds-background-accent-magenta-bolder-hovered, #943D73)"},
			0 0 0 1px ${"var(--ds-border-selected, #0C66E4)"}
			`
        },
        [`${$f1d038f000d0a156$var$inlineCardSelector}, ${$f1d038f000d0a156$var$statusSelector}, ${$f1d038f000d0a156$var$mentionSelector}, ${$f1d038f000d0a156$var$dateSelector}`]: {
            boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #0C66E4)"}, 0px 0px 0px 4px ${"var(--ds-background-accent-magenta-bolder-hovered, #943D73)"}, 0px 0px 0px 5px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"} !important`
        }
    },
    /** Expand title match styles */ /** Light mode */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    [`.${$f1d038f000d0a156$export$2414358ab66f419a} > .${(0, $is7NW.expandClassNames).titleContainer} > .${(0, $is7NW.expandClassNames).inputContainer}`]: {
        borderRadius: "var(--ds-space-050, 4px)",
        boxShadow: `
		inset 0 0 0 1px ${"var(--ds-background-accent-magenta-subtler-pressed, #E774BB)"},
		inset 0 0 0 5px ${"var(--ds-background-accent-magenta-subtler, #FDD0EC)"}
		`,
        backgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        [`.${(0, $is7NW.expandClassNames).titleInput}`]: {
            color: "var(--ds-text, #172B4D)"
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    [`.${$f1d038f000d0a156$export$2414358ab66f419a}.${$f1d038f000d0a156$export$bf208a338b2a2f1f} > .${(0, $is7NW.expandClassNames).titleContainer} > .${(0, $is7NW.expandClassNames).inputContainer}`]: {
        boxShadow: `
		inset 0 0 0 1px ${"var(--ds-background-accent-magenta-subtler-pressed, #E774BB)"},
		inset 0 0 0 5px ${"var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)"}
		`,
        backgroundColor: "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)"
    },
    /** Dark mode */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    [`.${$f1d038f000d0a156$export$2414358ab66f419a}.${$f1d038f000d0a156$export$6cc90c491f952538} > .${(0, $is7NW.expandClassNames).titleContainer} > .${(0, $is7NW.expandClassNames).inputContainer}`]: {
        boxShadow: `
		inset 0 0 0 1px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"},
		inset 0 0 0 5px ${"var(--ds-background-accent-magenta-bolder-pressed, #50253F)"}
		`,
        backgroundColor: "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        [`.${(0, $is7NW.expandClassNames).titleInput}`]: {
            color: "var(--ds-text-inverse, #FFFFFF)"
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    [`.${$f1d038f000d0a156$export$2414358ab66f419a}.${$f1d038f000d0a156$export$bf208a338b2a2f1f}.${$f1d038f000d0a156$export$6cc90c491f952538} > .${(0, $is7NW.expandClassNames).titleContainer} > .${(0, $is7NW.expandClassNames).inputContainer}`]: {
        boxShadow: `
		inset 0 0 0 1px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"},
		inset 0 0 0 5px ${"var(--ds-background-accent-magenta-bolder-hovered, #943D73)"}
		`,
        backgroundColor: "var(--ds-background-accent-magenta-bolder-hovered, #943D73)"
    }
});
const $f1d038f000d0a156$export$4b5dc75d9d87c842 = /*#__PURE__*/ (0, $1NIU8.css)({
    /** Text match styles */ /** Light mode */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    [`.${$f1d038f000d0a156$export$a19ecadc9ecc39b1}`]: {
        borderRadius: "var(--ds-space-050, 4px)",
        boxShadow: `
		inset 0 0 0 1px ${"var(--ds-background-accent-magenta-subtler-pressed, #E774BB)"},
		inset 0 0 0 5px ${"var(--ds-background-accent-magenta-subtler, #FDD0EC)"}
		`,
        // we need to use !important here as we need to override inline selection styles
        backgroundColor: `${"var(--ds-background-accent-magenta-subtler, #FDD0EC)"} !important`,
        color: "var(--ds-text, #172B4D)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    [`.${$f1d038f000d0a156$export$a19ecadc9ecc39b1}.${$f1d038f000d0a156$export$bf208a338b2a2f1f}`]: {
        boxShadow: `
		inset 0 0 0 1px ${"var(--ds-background-accent-magenta-subtler-pressed, #E774BB)"},
		inset 0 0 0 5px ${"var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)"}
		`,
        // we need to use !important here as we need to override inline selection styles
        backgroundColor: `${"var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)"} !important`
    },
    /** Dark mode */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    [`.${$f1d038f000d0a156$export$a19ecadc9ecc39b1}.${$f1d038f000d0a156$export$6cc90c491f952538}`]: {
        boxShadow: `
		inset 0 0 0 1px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"},
		inset 0 0 0 5px ${"var(--ds-background-accent-magenta-bolder-pressed, #50253F)"}
		`,
        backgroundColor: `${"var(--ds-background-accent-magenta-bolder-pressed, #50253F)"}`,
        color: "var(--ds-text-inverse, #FFFFFF)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    [`.${$f1d038f000d0a156$export$a19ecadc9ecc39b1}.${$f1d038f000d0a156$export$bf208a338b2a2f1f}.${$f1d038f000d0a156$export$6cc90c491f952538}`]: {
        boxShadow: `
		inset 0 0 0 1px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"},
		inset 0 0 0 5px ${"var(--ds-background-accent-magenta-bolder-hovered, #943D73)"}
		`,
        backgroundColor: `${"var(--ds-background-accent-magenta-bolder-hovered, #943D73)"}`
    },
    /** Block match styles */ /** Light mode */ /** Without node selection */ [`.${$f1d038f000d0a156$export$bb09fa712812841f}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-smart-link-container="true"], .loader-wrapper>div::after': {
            boxShadow: `
			inset 0 0 0 1px ${"var(--ds-background-accent-magenta-subtler-pressed, #E774BB)"},
			inset 0 0 0 5px ${"var(--ds-background-accent-magenta-subtler, #FDD0EC)"}
			`
        },
        [`${$f1d038f000d0a156$var$inlineCardSelector}, ${$f1d038f000d0a156$var$statusSelector}, ${$f1d038f000d0a156$var$mentionSelector}, ${$f1d038f000d0a156$var$dateSelector}`]: {
            boxShadow: `0px 0px 0px 4px ${"var(--ds-background-accent-magenta-subtler, #FDD0EC)"}, 0px 0px 0px 5px ${"var(--ds-background-accent-magenta-subtler-pressed, #E774BB)"}`
        }
    },
    [`.${$f1d038f000d0a156$export$bb09fa712812841f}.${$f1d038f000d0a156$export$99146b4c1ad5837a}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-smart-link-container="true"], .loader-wrapper>div::after': {
            boxShadow: `
			inset 0 0 0 1px ${"var(--ds-background-accent-magenta-subtler-pressed, #E774BB)"},
			inset 0 0 0 4px ${"var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)"}
			`
        },
        [`${$f1d038f000d0a156$var$inlineCardSelector}, ${$f1d038f000d0a156$var$statusSelector}, ${$f1d038f000d0a156$var$mentionSelector}, ${$f1d038f000d0a156$var$dateSelector}`]: {
            boxShadow: `0px 0px 0px 4px ${"var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)"}, 0px 0px 0px 5px ${"var(--ds-background-accent-magenta-subtler-pressed, #E774BB)"}`
        }
    },
    /** With node selection */ // We need to include the embedCardView and statusView classes to have higher specificity than the default selected state styles
    [`.${$f1d038f000d0a156$export$bb09fa712812841f}.embedCardView-content-wrap.ak-editor-selected-node,
	  .${$f1d038f000d0a156$export$bb09fa712812841f}.statusView-content-wrap.ak-editor-selected-node,
	  .${$f1d038f000d0a156$export$bb09fa712812841f}.mentionView-content-wrap.ak-editor-selected-node,
	  .${$f1d038f000d0a156$export$bb09fa712812841f}.inlineCardView-content-wrap.ak-editor-selected-node,
	  .${$f1d038f000d0a156$export$bb09fa712812841f}.ak-editor-selected-node`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.loader-wrapper>div::after': {
            boxShadow: `
			inset 0 0 0 1px ${"var(--ds-background-accent-magenta-subtler-pressed, #E774BB)"},
			inset 0 0 0 5px ${"var(--ds-background-accent-magenta-subtler, #FDD0EC)"},
			0 0 0 1px ${"var(--ds-border-selected, #0C66E4)"}
			`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        [`${$f1d038f000d0a156$var$inlineCardSelector}, ${$f1d038f000d0a156$var$statusSelector}, ${$f1d038f000d0a156$var$mentionSelector}, ${$f1d038f000d0a156$var$dateSelector}`]: {
            boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #0C66E4)"}, 0px 0px 0px 4px ${"var(--ds-background-accent-magenta-subtler, #FDD0EC)"}, 0px 0px 0px 5px ${"var(--ds-background-accent-magenta-subtler-pressed, #E774BB)"}`
        }
    },
    [`.${$f1d038f000d0a156$export$bb09fa712812841f}.${$f1d038f000d0a156$export$99146b4c1ad5837a}.ak-editor-selected-node`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-smart-link-container="true"], .loader-wrapper>div::after': {
            boxShadow: `
			inset 0 0 0 1px ${"var(--ds-background-accent-magenta-subtler-pressed, #E774BB)"},
			inset 0 0 0 4px ${"var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)"},
			0 0 0 1px ${"var(--ds-border-selected, #0C66E4)"}
			`
        },
        [`${$f1d038f000d0a156$var$inlineCardSelector}, ${$f1d038f000d0a156$var$statusSelector}, ${$f1d038f000d0a156$var$mentionSelector}, ${$f1d038f000d0a156$var$dateSelector}`]: {
            boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #0C66E4)"}, 0px 0px 0px 4px ${"var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)"}, 0px 0px 0px 5px ${"var(--ds-background-accent-magenta-subtler-pressed, #E774BB)"}`
        }
    },
    /** Dark mode */ /** Without node selection */ [`.${$f1d038f000d0a156$export$bb09fa712812841f}.${$f1d038f000d0a156$export$6cc90c491f952538}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-smart-link-container="true"], .loader-wrapper>div::after': {
            boxShadow: `
			inset 0 0 0 1px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"},
			inset 0 0 0 5px ${"var(--ds-background-accent-magenta-bolder-pressed, #50253F)"}
			`
        },
        [`${$f1d038f000d0a156$var$inlineCardSelector}, ${$f1d038f000d0a156$var$statusSelector}, ${$f1d038f000d0a156$var$mentionSelector}, ${$f1d038f000d0a156$var$dateSelector}`]: {
            boxShadow: `0px 0px 0px 4px ${"var(--ds-background-accent-magenta-bolder-pressed, #50253F)"}, 0px 0px 0px 5px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"}`
        }
    },
    [`.${$f1d038f000d0a156$export$bb09fa712812841f}.${$f1d038f000d0a156$export$99146b4c1ad5837a}.${$f1d038f000d0a156$export$6cc90c491f952538}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-smart-link-container="true"], .loader-wrapper>div::after': {
            boxShadow: `
			inset 0 0 0 1px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"},
			inset 0 0 0 4px ${"var(--ds-background-accent-magenta-bolder-hovered, #943D73)"}
			`
        },
        [`${$f1d038f000d0a156$var$inlineCardSelector}, ${$f1d038f000d0a156$var$statusSelector}, ${$f1d038f000d0a156$var$mentionSelector}, ${$f1d038f000d0a156$var$dateSelector}`]: {
            boxShadow: `0px 0px 0px 4px ${"var(--ds-background-accent-magenta-bolder-hovered, #943D73)"}, 0px 0px 0px 5px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"}`
        }
    },
    /** With node selection */ [`.${$f1d038f000d0a156$export$bb09fa712812841f}.${$f1d038f000d0a156$export$6cc90c491f952538}.ak-editor-selected-node, .${$f1d038f000d0a156$export$bb09fa712812841f}.${$f1d038f000d0a156$export$6cc90c491f952538}.mentionView-content-wrap.ak-editor-selected-node`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.loader-wrapper>div::after': {
            boxShadow: `
			inset 0 0 0 1px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"},
			inset 0 0 0 5px ${"var(--ds-background-accent-magenta-bolder-pressed, #50253F)"},
			0 0 0 1px ${"var(--ds-border-selected, #0C66E4)"}
			`
        },
        [`${$f1d038f000d0a156$var$inlineCardSelector}, ${$f1d038f000d0a156$var$statusSelector}, ${$f1d038f000d0a156$var$mentionSelector}, ${$f1d038f000d0a156$var$dateSelector}`]: {
            boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #0C66E4)"}, 0px 0px 0px 4px ${"var(--ds-background-accent-magenta-bolder-pressed, #50253F)"}, 0px 0px 0px 5px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"}`
        }
    },
    [`.${$f1d038f000d0a156$export$bb09fa712812841f}.${$f1d038f000d0a156$export$99146b4c1ad5837a}.${$f1d038f000d0a156$export$6cc90c491f952538}.ak-editor-selected-node`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-smart-link-container="true"], .loader-wrapper>div::after': {
            boxShadow: `
			inset 0 0 0 1px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"},
			inset 0 0 0 4px ${"var(--ds-background-accent-magenta-bolder-hovered, #943D73)"},
			0 0 0 1px ${"var(--ds-border-selected, #0C66E4)"}
			`
        },
        [`${$f1d038f000d0a156$var$inlineCardSelector}, ${$f1d038f000d0a156$var$statusSelector}, ${$f1d038f000d0a156$var$mentionSelector}, ${$f1d038f000d0a156$var$dateSelector}`]: {
            boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #0C66E4)"}, 0px 0px 0px 4px ${"var(--ds-background-accent-magenta-bolder-hovered, #943D73)"}, 0px 0px 0px 5px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"}`
        }
    },
    /** Expand title match styles */ /** Light mode */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    [`.${$f1d038f000d0a156$export$2414358ab66f419a} > .${(0, $is7NW.expandClassNames).titleContainer} > .${(0, $is7NW.expandClassNames).inputContainer}`]: {
        borderRadius: "var(--ds-space-050, 4px)",
        boxShadow: `
		inset 0 0 0 1px ${"var(--ds-background-accent-magenta-subtler-pressed, #E774BB)"},
		inset 0 0 0 5px ${"var(--ds-background-accent-magenta-subtler, #FDD0EC)"}
		`,
        backgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        [`.${(0, $is7NW.expandClassNames).titleInput}`]: {
            color: "var(--ds-text, #172B4D)"
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    [`.${$f1d038f000d0a156$export$2414358ab66f419a}.${$f1d038f000d0a156$export$bf208a338b2a2f1f} > .${(0, $is7NW.expandClassNames).titleContainer} > .${(0, $is7NW.expandClassNames).inputContainer}`]: {
        boxShadow: `
		inset 0 0 0 1px ${"var(--ds-background-accent-magenta-subtler-pressed, #E774BB)"},
		inset 0 0 0 5px ${"var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)"}
		`,
        backgroundColor: "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)"
    },
    /** Dark mode */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    [`.${$f1d038f000d0a156$export$2414358ab66f419a}.${$f1d038f000d0a156$export$6cc90c491f952538} > .${(0, $is7NW.expandClassNames).titleContainer} > .${(0, $is7NW.expandClassNames).inputContainer}`]: {
        boxShadow: `
		inset 0 0 0 1px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"},
		inset 0 0 0 5px ${"var(--ds-background-accent-magenta-bolder-pressed, #50253F)"}
		`,
        backgroundColor: "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        [`.${(0, $is7NW.expandClassNames).titleInput}`]: {
            color: "var(--ds-text-inverse, #FFFFFF)"
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    [`.${$f1d038f000d0a156$export$2414358ab66f419a}.${$f1d038f000d0a156$export$bf208a338b2a2f1f}.${$f1d038f000d0a156$export$6cc90c491f952538} > .${(0, $is7NW.expandClassNames).titleContainer} > .${(0, $is7NW.expandClassNames).inputContainer}`]: {
        boxShadow: `
		inset 0 0 0 1px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"},
		inset 0 0 0 5px ${"var(--ds-background-accent-magenta-bolder-hovered, #943D73)"}
		`,
        backgroundColor: "var(--ds-background-accent-magenta-bolder-hovered, #943D73)"
    }
});

});


parcelRegister("kebxX", function(module, exports) {

$parcel$export(module.exports, "textHighlightStyle", () => (parcelRequire("6HZZD")).textHighlightStyle);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $6HZZD = parcelRequire("6HZZD");

});
parcelRegister("6HZZD", function(module, exports) {

$parcel$export(module.exports, "textHighlightStyle", () => $25fee6b3ed7737d2$export$b286500adc7d91cd);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

const $25fee6b3ed7737d2$export$b286500adc7d91cd = /*#__PURE__*/ (0, $1NIU8.css)(".", (0, $9ab11d64da7be9b0$export$78dda1ebb9a1ea84), "{background-color:var(--ds-background-accent-blue-subtlest, #E9F2FF);border-bottom:2px solid var(--ds-background-accent-blue-subtler, #cce0ff);}");

});
const $9ab11d64da7be9b0$export$164821e1c3d789fd = 'ak-editor-paste-toolbar';
const $9ab11d64da7be9b0$export$81e541fc7755f475 = 'ak-editor-paste-toolbar-item-dropdownList';
const $9ab11d64da7be9b0$export$78dda1ebb9a1ea84 = 'text-highlight';
const $9ab11d64da7be9b0$export$d829547aa567b0f1 = 'paste-highlight-decoration-key';
const $9ab11d64da7be9b0$export$af443436fa5992cb = 'ak-editor-paste-toolbar-item';
const $9ab11d64da7be9b0$export$220f0307408bc0c = 'akEditor';
const $9ab11d64da7be9b0$export$299d35c5583816ad = 'paste-options-testid';
const $9ab11d64da7be9b0$export$d1234a98f427930 = 'paste-options$';



parcelRegister("hFwc2", function(module, exports) {

$parcel$export(module.exports, "placeholderTextStyles", () => (parcelRequire("7D0Jo")).placeholderTextStyles);
$parcel$export(module.exports, "placeholderTextStyles_fg_platform_editor_system_fake_text_highlight_colour", () => (parcelRequire("7D0Jo")).placeholderTextStyles_fg_platform_editor_system_fake_text_highlight_colour);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $7D0Jo = parcelRequire("7D0Jo");

});
parcelRegister("7D0Jo", function(module, exports) {

$parcel$export(module.exports, "placeholderTextStyles", () => $bb58a400d555b8ce$export$56bce713f2cb8aa7);
$parcel$export(module.exports, "placeholderTextStyles_fg_platform_editor_system_fake_text_highlight_colour", () => $bb58a400d555b8ce$export$60c8e6f773c06037);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $7yBx7 = parcelRequire("7yBx7");
var $2N2k8 = parcelRequire("2N2k8");
var $egs2l = parcelRequire("egs2l");

function $bb58a400d555b8ce$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $bb58a400d555b8ce$export$56bce713f2cb8aa7 = /*#__PURE__*/ (0, $1NIU8.css)(".ProseMirror span[data-placeholder]{color:", `var(--ds-text-subtlest, ${(0, $7bb4c1736002a04a$export$f563ee71e9ee74cd)})`, ";display:inline;}.ProseMirror span.pm-placeholder{display:inline;color:", `var(--ds-text-subtlest, ${(0, $7bb4c1736002a04a$export$f563ee71e9ee74cd)})`, ";}.ProseMirror span.pm-placeholder__text{display:inline;color:", `var(--ds-text-subtlest, ${(0, $7bb4c1736002a04a$export$f563ee71e9ee74cd)})`, ";}.ProseMirror span.pm-placeholder.", (0, $7yBx7.akEditorSelectedNodeClassName), "{", (0, $2N2k8.getSelectionStyles)([
    (0, $egs2l.SelectionStyle).Background
]), ";}.ProseMirror span.pm-placeholder__text[data-placeholder]::after{color:", `var(--ds-text-subtlest, ${(0, $7bb4c1736002a04a$export$f563ee71e9ee74cd)})`, ";cursor:text;content:attr(data-placeholder);display:inline;}.ProseMirror{.ProseMirror-fake-text-cursor{display:inline;pointer-events:none;position:relative;}.ProseMirror-fake-text-cursor::after{content:'';display:inline;top:0;position:absolute;border-right:1px solid var(--ds-border, rgba(0, 0, 0, 0.4));}.ProseMirror-fake-text-selection{display:inline;pointer-events:none;position:relative;background-color:", `var(--ds-background-selected, ${(0, $7bb4c1736002a04a$export$8c13c2ee36917869)})`, ";}}");
const $bb58a400d555b8ce$export$60c8e6f773c06037 = {
    name: "1tuyvfm",
    styles: ".ProseMirror{.ProseMirror-fake-text-selection{background-color:Highlight;color:HighlightText;}}"
};

});


parcelRegister("fDrn5", function(module, exports) {

$parcel$export(module.exports, "InlineNodeViewSharedStyles", () => $4af37d67fe332a6f$export$3fc32cdc53f6edeb);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $T8owb = parcelRequire("T8owb");

const $4af37d67fe332a6f$export$3fc32cdc53f6edeb = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`.${0, $T8owb.inlineNodeViewClassname}`]: {
        display: 'inline',
        userSelect: 'all',
        whiteSpace: 'nowrap',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '& > *:not(.zeroWidthSpaceContainer)': {
            whiteSpace: 'pre-wrap'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > .assistive': {
            userSelect: 'none'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-safari': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`.${0, $T8owb.inlineNodeViewClassname}`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '::selection, *::selection': {
                background: 'transparent'
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`&.ua-chrome .${0, $T8owb.inlineNodeViewClassname} > span`]: {
        userSelect: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`.${0, $T8owb.inlineNodeViewClassname}AddZeroWidthSpace`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '::after': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            content: `'${(0, $f9e41f230eb38f84$export$15a09f5ef055bcfa)}'`
        }
    }
});

});
parcelRegister("T8owb", function(module, exports) {

$parcel$export(module.exports, "inlineNodeViewClassname", () => $b84df48f6f66821f$export$dfb58b577a6f1cd9);
$parcel$export(module.exports, "getInlineNodeViewProducer", () => $b84df48f6f66821f$export$17a8c3162956317d);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $3xw6l = parcelRequire("3xw6l");

var $eGOwo = parcelRequire("eGOwo");

var $bMFKb = parcelRequire("bMFKb");

var $28ffc = parcelRequire("28ffc");

var $dyNYh = parcelRequire("dyNYh");
var $7EdFW = parcelRequire("7EdFW");
var $lT8fo = parcelRequire("lT8fo");


var $6dBwJ = parcelRequire("6dBwJ");

var $29oOz = parcelRequire("29oOz");
const $b84df48f6f66821f$var$isSSR = Boolean(undefined);
const $b84df48f6f66821f$export$dfb58b577a6f1cd9 = 'inlineNodeView';
const $b84df48f6f66821f$var$canRenderFallback = (node)=>{
    return node.type.isInline && node.type.isAtom && node.type.isLeaf;
};
// list of inline nodes with toDOM fallback implementations that can be virtualized. As
// additional nodes are converted they should be added here
const $b84df48f6f66821f$var$virtualizedNodeAllowlist = [
    'inlineCard'
];
function $b84df48f6f66821f$var$createNodeView({ nodeViewParams: nodeViewParams, pmPluginFactoryParams: pmPluginFactoryParams, Component: Component, extraComponentProps: extraComponentProps, extraNodeViewProps: extraNodeViewProps }) {
    // We set a variable for the current node which is
    // used for comparisions when doing updates, before being
    // overwritten to the updated node.
    let currentNode = nodeViewParams.node;
    const key = (0, $6dBwJ.generateUniqueNodeKey)();
    // First we setup the dom element which will be rendered and "tracked" by prosemirror
    // and also used as a "editor portal" (not react portal) target by the editor
    // portal provider api, for rendering the Component passed.
    let domRef = document.createElement('span');
    domRef.contentEditable = 'false';
    $b84df48f6f66821f$var$setDomAttrs(nodeViewParams.node, domRef);
    const fallbackRef = {
        current: null
    };
    // @see ED-3790
    // something gets messed up during mutation processing inside of a
    // nodeView if DOM structure has nested plain "div"s, it doesn't see the
    // difference between them and it kills the nodeView
    domRef.classList.add(`${nodeViewParams.node.type.name}View-content-wrap`, `${$b84df48f6f66821f$export$dfb58b577a6f1cd9}`);
    // This util is shared for tracking rendering, and the ErrorBoundary that
    // is setup to wrap the Component when rendering
    // NOTE: This is not a prosemirror dispatch
    function dispatchAnalyticsEvent(payload) {
        pmPluginFactoryParams.eventDispatcher.emit((0, $dyNYh.analyticsEventKey), {
            payload: payload
        });
    }
    // This is called to render the Component into domRef which is inside the
    // prosemirror View.
    // Internally it uses the unstable_renderSubtreeIntoContainer api to render,
    // to the passed dom element (domRef) which means it is automatically
    // "cleaned up" when you do a "re render".
    function renderComponent() {
        pmPluginFactoryParams.portalProviderAPI.render($b84df48f6f66821f$var$getPortalChildren({
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            currentNode: currentNode,
            nodeViewParams: nodeViewParams,
            Component: Component,
            extraComponentProps: extraComponentProps
        }), domRef, key);
    }
    const { samplingRate: samplingRate, slowThreshold: slowThreshold, trackingEnabled: trackingEnabled } = (0, $lT8fo.getPerformanceOptions)(nodeViewParams.view);
    trackingEnabled && (0, $lT8fo.startMeasureReactNodeViewRendered)({
        nodeTypeName: currentNode.type.name
    });
    // We render the component while creating the node view
    renderComponent();
    trackingEnabled && (0, $lT8fo.stopMeasureReactNodeViewRendered)({
        nodeTypeName: currentNode.type.name,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        samplingRate: samplingRate,
        slowThreshold: slowThreshold
    });
    const extraNodeViewPropsWithStopEvent = {
        ...extraNodeViewProps
    };
    // https://prosemirror.net/docs/ref/#view.NodeView
    const nodeView = {
        get dom () {
            return domRef;
        },
        update (nextNode, _decorations) {
            // Let ProseMirror handle the update if node types are different.
            // This prevents an issue where it was not possible to select the
            // inline node view then replace it by entering text - the node
            // view contents would be deleted but the node view itself would
            // stay in the view and become uneditable.
            if (currentNode.type !== nextNode.type) return false;
            // On updates, we only set the new attributes if the type, attributes, and marks
            // have changed on the node.
            // NOTE: this could mean attrs changes aren't reflected in the dom,
            // when an attribute key which was previously present is no longer
            // present.
            // ie.
            // -> Original attributes { text: "hello world", color: "red" }
            // -> Updated attributes { color: "blue" }
            // in this case, the dom text attribute will not be cleared.
            //
            // This may not be an issue with any of our current node schemas.
            if (!currentNode.sameMarkup(nextNode)) $b84df48f6f66821f$var$setDomAttrs(nextNode, domRef);
            currentNode = nextNode;
            renderComponent();
            return true;
        },
        destroy () {
            // When prosemirror destroys the node view, we need to clean up
            // what we have previously rendered using the editor portal
            // provider api.
            pmPluginFactoryParams.portalProviderAPI.remove(key);
            // @ts-expect-error Expect an error as domRef is expected to be
            // of HTMLSpanElement type however once the node view has
            // been destroyed no other consumers should still be using it.
            domRef = undefined;
            fallbackRef.current = null;
        },
        ...extraNodeViewPropsWithStopEvent
    };
    return nodeView;
}
function $b84df48f6f66821f$var$createNodeViewVirtualized({ nodeViewParams: nodeViewParams, pmPluginFactoryParams: pmPluginFactoryParams, Component: Component, extraComponentProps: extraComponentProps, extraNodeViewProps: extraNodeViewProps }) {
    // We set a variable for the current node which is
    // used for comparisions when doing updates, before being
    // overwritten to the updated node.
    let currentNode = nodeViewParams.node;
    const key = (0, $6dBwJ.generateUniqueNodeKey)();
    // First we setup the dom element which will be rendered and "tracked" by prosemirror
    // and also used as a "editor portal" (not react portal) target by the editor
    // portal provider api, for rendering the Component passed.
    let domRef = document.createElement('span');
    domRef.contentEditable = 'false';
    $b84df48f6f66821f$var$setDomAttrs(nodeViewParams.node, domRef);
    const fallbackRef = {
        current: null
    };
    // @see ED-3790
    // something gets messed up during mutation processing inside of a
    // nodeView if DOM structure has nested plain "div"s, it doesn't see the
    // difference between them and it kills the nodeView
    domRef.classList.add(`${nodeViewParams.node.type.name}View-content-wrap`, `${$b84df48f6f66821f$export$dfb58b577a6f1cd9}`);
    function onBeforeReactDomRender() {
        if (!fallbackRef.current) return;
        domRef.removeChild(fallbackRef.current);
        fallbackRef.current = null;
    }
    // This util is shared for tracking rendering, and the ErrorBoundary that
    // is setup to wrap the Component when rendering
    // NOTE: This is not a prosemirror dispatch
    function dispatchAnalyticsEvent(payload) {
        pmPluginFactoryParams.eventDispatcher.emit((0, $dyNYh.analyticsEventKey), {
            payload: payload
        });
    }
    // This is called to render the Component into domRef which is inside the
    // prosemirror View.
    // Internally it uses the unstable_renderSubtreeIntoContainer api to render,
    // to the passed dom element (domRef) which means it is automatically
    // "cleaned up" when you do a "re render".
    function renderComponent() {
        pmPluginFactoryParams.portalProviderAPI.render($b84df48f6f66821f$var$getPortalChildren({
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            currentNode: currentNode,
            nodeViewParams: nodeViewParams,
            Component: Component,
            extraComponentProps: extraComponentProps
        }), domRef, key, onBeforeReactDomRender);
    }
    let didRenderComponentWithIntersectionObserver = false;
    let destroyed = false;
    let removeIntersectionObserver = ()=>{};
    function renderFallback() {
        if (!$b84df48f6f66821f$var$canRenderFallback(currentNode) || typeof currentNode.type?.spec?.toDOM !== 'function') return;
        const fallback = (0, $3xw6l.DOMSerializer).renderSpec(document, currentNode.type.spec.toDOM(currentNode));
        const dom = fallback.dom;
        fallbackRef.current = dom;
        domRef.replaceChildren(dom);
    }
    function attachNodeViewObserver() {
        const observer = (0, $29oOz.getOrCreateOnVisibleObserver)(nodeViewParams.view);
        if (domRef) removeIntersectionObserver = observer.observe(domRef, ()=>{
            if (!didRenderComponentWithIntersectionObserver && !destroyed) {
                renderComponent();
                didRenderComponentWithIntersectionObserver = true;
            }
        });
    }
    renderFallback();
    // allow the fallback to render first before attaching the observer.
    // Will tweak this in a follow up PR to optimise rendering of visible
    // nodes without fallback rendering.
    setTimeout(()=>{
        attachNodeViewObserver();
    }, 0);
    const extraNodeViewPropsWithStopEvent = {
        ...extraNodeViewProps,
        stopEvent: (event)=>{
            const maybeStopEvent = extraNodeViewProps?.stopEvent;
            if (typeof maybeStopEvent === 'function') return maybeStopEvent(event);
            return false;
        }
    };
    // https://prosemirror.net/docs/ref/#view.NodeView
    const nodeView = {
        get dom () {
            return domRef;
        },
        update (nextNode, _decorations) {
            // Let ProseMirror handle the update if node types are different.
            // This prevents an issue where it was not possible to select the
            // inline node view then replace it by entering text - the node
            // view contents would be deleted but the node view itself would
            // stay in the view and become uneditable.
            if (currentNode.type !== nextNode.type) return false;
            // On updates, we only set the new attributes if the type, attributes, and marks
            // have changed on the node.
            // NOTE: this could mean attrs changes aren't reflected in the dom,
            // when an attribute key which was previously present is no longer
            // present.
            // ie.
            // -> Original attributes { text: "hello world", color: "red" }
            // -> Updated attributes { color: "blue" }
            // in this case, the dom text attribute will not be cleared.
            //
            // This may not be an issue with any of our current node schemas.
            if (!currentNode.sameMarkup(nextNode)) $b84df48f6f66821f$var$setDomAttrs(nextNode, domRef);
            currentNode = nextNode;
            if (didRenderComponentWithIntersectionObserver) renderComponent();
            return true;
        },
        destroy () {
            removeIntersectionObserver();
            destroyed = true;
            // When prosemirror destroys the node view, we need to clean up
            // what we have previously rendered using the editor portal
            // provider api.
            pmPluginFactoryParams.portalProviderAPI.remove(key);
            // @ts-expect-error Expect an error as domRef is expected to be
            // of HTMLSpanElement type however once the node view has
            // been destroyed no other consumers should still be using it.
            domRef = undefined;
            fallbackRef.current = null;
        },
        ...extraNodeViewPropsWithStopEvent
    };
    return nodeView;
}
/**
 * Copies the attributes from a ProseMirror Node to a DOM node.
 * @param node The Prosemirror Node from which to source the attributes
 */ function $b84df48f6f66821f$var$setDomAttrs(node, element) {
    Object.keys(node.attrs || {}).forEach((attr)=>{
        element.setAttribute(attr, node.attrs[attr]);
    });
}
function $b84df48f6f66821f$var$getPortalChildren({ dispatchAnalyticsEvent: dispatchAnalyticsEvent, currentNode: currentNode, nodeViewParams: nodeViewParams, Component: Component, extraComponentProps: extraComponentProps }) {
    return function portalChildren() {
        //  All inline nodes use `display: inline` to allow for multi-line
        //  wrapping. This does produce an issue in Chrome where it is not
        //  possible to click select the position after the node,
        //  see: https://product-fabric.atlassian.net/browse/ED-12003
        //  however this is only a problem for node views that use
        //  `display: inline-block` somewhere within the Component.
        //  Looking at the below structure, spans with className
        //  `inlineNodeViewAddZeroWidthSpace` have pseudo elements that
        //  add a zero width space which fixes the problem.
        //  Without the additional zero width space before the Component,
        //  it is not possible to use the keyboard to range select in Safari.
        //
        //  Zero width spaces on either side of the Component also prevent
        //  the cursor from appearing inside the node view on all browsers.
        //
        //  Note:
        //  In future it is worth considering prohibiting the use of `display: inline-block`
        //  within inline node view Components however would require a sizable
        //  refactor. A test suite to catch any instances of this is ideal however
        //  the refactor required is currently out of scope for https://product-fabric.atlassian.net/browse/ED-14176
        return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $28ffc.ErrorBoundary), {
            component: (0, $bMFKb.ACTION_SUBJECT).REACT_NODE_VIEW,
            componentId: currentNode?.type?.name ?? (0, $bMFKb.ACTION_SUBJECT_ID).UNKNOWN_NODE,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent
        }, /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
            className: `zeroWidthSpaceContainer`
        }, /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
            className: `${$b84df48f6f66821f$export$dfb58b577a6f1cd9}AddZeroWidthSpace`
        }), (0, $f9e41f230eb38f84$export$15a09f5ef055bcfa)), /*#__PURE__*/ (0, $1NIU8.jsx)(Component, {
            view: nodeViewParams.view,
            // TODO: ED-13910 - Remove the boolean to fix the prosemirror view type
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            getPos: nodeViewParams.getPos,
            node: currentNode,
            ...extraComponentProps
        }), (0, $7EdFW.browser).android ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
            className: `zeroWidthSpaceContainer`,
            contentEditable: "false"
        }, /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
            className: `${$b84df48f6f66821f$export$dfb58b577a6f1cd9}AddZeroWidthSpace`
        }), (0, $f9e41f230eb38f84$export$15a09f5ef055bcfa)) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
            className: `${$b84df48f6f66821f$export$dfb58b577a6f1cd9}AddZeroWidthSpace`
        }));
    };
}
const $b84df48f6f66821f$var$counterPerEditorViewMap = new WeakMap();
function $b84df48f6f66821f$export$17a8c3162956317d({ pmPluginFactoryParams: pmPluginFactoryParams, Component: Component, extraComponentProps: extraComponentProps, extraNodeViewProps: extraNodeViewProps }) {
    function nodeViewProducer(...nodeViewProducerParameters) {
        const view = nodeViewProducerParameters[1];
        const node = nodeViewProducerParameters[0];
        const parameters = {
            nodeViewParams: {
                node: node,
                view: view,
                getPos: nodeViewProducerParameters[2],
                decorations: nodeViewProducerParameters[3]
            },
            pmPluginFactoryParams: pmPluginFactoryParams,
            Component: Component,
            extraComponentProps: extraComponentProps,
            extraNodeViewProps: extraNodeViewProps
        };
        const isNodeTypeAllowedToBeVirtualized = $b84df48f6f66821f$var$virtualizedNodeAllowlist.includes(node?.type?.name || '');
        if (!isNodeTypeAllowedToBeVirtualized || $b84df48f6f66821f$var$isSSR) return $b84df48f6f66821f$var$createNodeView(parameters);
        if ((0, $eGOwo.fg)('platform_editor_inline_node_virt_threshold_override')) return $b84df48f6f66821f$var$createNodeViewVirtualized(parameters);
        let inlineNodeViewsVirtualizationCounter = $b84df48f6f66821f$var$counterPerEditorViewMap.get(view) || 0;
        inlineNodeViewsVirtualizationCounter += 1;
        $b84df48f6f66821f$var$counterPerEditorViewMap.set(view, inlineNodeViewsVirtualizationCounter);
        // We never virtualize the 100th first elements
        if (inlineNodeViewsVirtualizationCounter <= 100) return $b84df48f6f66821f$var$createNodeView(parameters);
        return $b84df48f6f66821f$var$createNodeViewVirtualized(parameters);
    }
    return nodeViewProducer;
}

});
parcelRegister("28ffc", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $5cc3db7d4b1c17d6$export$e926676385687eaf);

var $eJOHy = parcelRequire("eJOHy");

var $bMFKb = parcelRequire("bMFKb");

var $djRdf = parcelRequire("djRdf");
class $5cc3db7d4b1c17d6$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    hasFallback() {
        return typeof this.props.fallbackComponent !== 'undefined';
    }
    shouldRecover() {
        return this.hasFallback() && this.state.errorCaptured;
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.dispatchAnalyticsEvent) this.props.dispatchAnalyticsEvent({
            action: (0, $bMFKb.ACTION).EDITOR_CRASHED,
            actionSubject: this.props.component,
            actionSubjectId: this.props.componentId,
            eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL,
            attributes: {
                error: error,
                errorInfo: errorInfo,
                errorRethrown: !this.hasFallback()
            }
        });
        (0, $djRdf.logException)(error, {
            location: 'editor-common'
        });
        if (this.hasFallback()) this.setState({
            errorCaptured: true
        });
    }
    render() {
        if (this.shouldRecover()) return this.props.fallbackComponent;
        return this.props.children;
    }
    constructor(...args){
        super(...args), this.state = {
            errorCaptured: false
        };
    }
}

});

parcelRegister("lT8fo", function(module, exports) {

$parcel$export(module.exports, "getPerformanceOptions", () => $4a9fd58283843c2b$export$9838b97af1c61be);
$parcel$export(module.exports, "startMeasureReactNodeViewRendered", () => $4a9fd58283843c2b$export$2630f5971dfad231);
$parcel$export(module.exports, "stopMeasureReactNodeViewRendered", () => $4a9fd58283843c2b$export$dc5a82f0bfc526c3);

var $bMFKb = parcelRequire("bMFKb");

var $hvjqZ = parcelRequire("hvjqZ");
// This was existing logic when converting from ReactNodeView
// our current sampling for this event is not bound by node.type
let $4a9fd58283843c2b$var$nodeViewRenderedEventsCounter = 0;
const $4a9fd58283843c2b$var$DEFAULT_SAMPLING_RATE = 100;
const $4a9fd58283843c2b$var$DEFAULT_SLOW_THRESHOLD = 7;
function $4a9fd58283843c2b$export$9838b97af1c61be(view) {
    // Please, do not copy or use this kind of code below
    // @ts-ignore
    const fakePluginKey = {
        key: 'analyticsPlugin$',
        getState: (state)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return state['analyticsPlugin$'];
        }
    };
    const pluginState = fakePluginKey.getState(view.state);
    const nodeViewTracking = pluginState && pluginState.performanceTracking ? pluginState.performanceTracking.nodeViewTracking || {} : {};
    const samplingRate = nodeViewTracking.samplingRate ?? $4a9fd58283843c2b$var$DEFAULT_SAMPLING_RATE;
    const slowThreshold = nodeViewTracking.slowThreshold ?? $4a9fd58283843c2b$var$DEFAULT_SLOW_THRESHOLD;
    return {
        trackingEnabled: !!nodeViewTracking.enabled,
        samplingRate: samplingRate,
        slowThreshold: slowThreshold
    };
}
function $4a9fd58283843c2b$export$2630f5971dfad231({ nodeTypeName: nodeTypeName }) {
    (0, $hvjqZ.startMeasure)(`\u{1F989}${nodeTypeName}::ReactNodeView`);
}
function $4a9fd58283843c2b$export$dc5a82f0bfc526c3({ nodeTypeName: nodeTypeName, dispatchAnalyticsEvent: dispatchAnalyticsEvent, samplingRate: samplingRate, slowThreshold: slowThreshold }) {
    (0, $hvjqZ.stopMeasure)(`\u{1F989}${nodeTypeName}::ReactNodeView`, (duration)=>{
        if (++$4a9fd58283843c2b$var$nodeViewRenderedEventsCounter % samplingRate === 0 && duration > slowThreshold) dispatchAnalyticsEvent({
            action: (0, $bMFKb.ACTION).REACT_NODEVIEW_RENDERED,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).EDITOR,
            eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL,
            attributes: {
                node: nodeTypeName,
                duration: duration
            }
        });
    });
}

});

const $f9e41f230eb38f84$export$15a09f5ef055bcfa = '\u200b';
const $f9e41f230eb38f84$export$2b4d00c13dcd3c1f = '\u200d';

parcelRegister("6dBwJ", function(module, exports) {

$parcel$export(module.exports, "generateUniqueNodeKey", () => $ad0e44a9b4fdbc6f$export$4a323a0542a1e4d1);

var $8KLBw = parcelRequire("8KLBw");
const $ad0e44a9b4fdbc6f$export$4a323a0542a1e4d1 = ()=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($8KLBw)))();
};

});

parcelRegister("29oOz", function(module, exports) {

$parcel$export(module.exports, "getOrCreateOnVisibleObserver", () => $87abe9f23f9d7afe$export$d73c873f0a6a03c3);

var $5PQOA = parcelRequire("5PQOA");
// Use this selector to set the intersection observer boundary for editor's inline node views
// If this does not exist, it will use the IntersectionObserver's default root
const $87abe9f23f9d7afe$var$INTERSECTION_OBSERVER_ROOT_SELECTOR = '[data-editor-scroll-container="true"]';
const $87abe9f23f9d7afe$var$INTERSECTION_OBSERVER_OPTIONS = {
    rootMargin: '0px 0px 100px 0px',
    threshold: 0
};
const $87abe9f23f9d7afe$export$d73c873f0a6a03c3 = (0, (/*@__PURE__*/$parcel$interopDefault($5PQOA)))((view)=>{
    const intersectionObserverOptions = {
        root: view.dom.closest($87abe9f23f9d7afe$var$INTERSECTION_OBSERVER_ROOT_SELECTOR),
        ...$87abe9f23f9d7afe$var$INTERSECTION_OBSERVER_OPTIONS
    };
    const callbackMap = new WeakMap();
    const observer = new IntersectionObserver((entries)=>{
        entries.filter((entry)=>entry.isIntersecting) // Only process visible entries
        .map((entry)=>callbackMap.get(entry.target))// Invoke callbacks together to group browser rendering
        // Avoiding requestAnimationFrame to reduce visual flickering
        .forEach((cb)=>cb?.());
    }, intersectionObserverOptions);
    return {
        observe: (el, callback)=>{
            callbackMap.set(el, callback);
            observer.observe(el);
            return ()=>observer.unobserve(el);
        }
    };
});

});



parcelRegister("e8cBm", function(module, exports) {

$parcel$export(module.exports, "aiPanelStyles", () => $bcd81d9dc12675ef$export$cdf1b75966a7ba92);
/**
 * TODO ED-26957 - remove legacy styles when static emotion refactor is complete
 * We are moving this to new location under FF: platform_editor_core_static_emotion
 * New location: packages/editor/editor-core/src/ui/EditorContentContainer.tsx
 * If you are making updates to this file, please updates in new location as well.
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");
const $bcd81d9dc12675ef$var$isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
const $bcd81d9dc12675ef$var$rotationAnimation = (0, $1NIU8.keyframes)({
    '0%': {
        '--panel-gradient-angle': '0deg',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...$bcd81d9dc12675ef$var$isFirefox ? {
            backgroundPosition: '100%'
        } : {}
    },
    '100%': {
        '--panel-gradient-angle': '360deg',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...$bcd81d9dc12675ef$var$isFirefox ? {
            backgroundPosition: '-100%'
        } : {}
    }
});
const $bcd81d9dc12675ef$var$aiPrismColor = {
    ['prism.border.step.1']: {
        light: '#0065FF',
        dark: '#0065FF80'
    },
    ['prism.border.step.2']: {
        light: '#0469FF',
        dark: '#0469FF80'
    },
    ['prism.border.step.3']: {
        light: '#BF63F3',
        dark: '#BF63F380'
    },
    ['prism.border.step.4']: {
        light: '#FFA900',
        dark: '#FFA90080'
    }
};
const $bcd81d9dc12675ef$var$prismBorderAnimationStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    '&::before, &::after': {
        animationName: $bcd81d9dc12675ef$var$rotationAnimation,
        animationDuration: '2s',
        animationTimingFunction: 'linear',
        animationIterationCount: 'infinite',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...$bcd81d9dc12675ef$var$isFirefox ? {
            animationDirection: 'normal',
            animationDuration: '1s'
        } : {},
        '@media (prefers-reduced-motion)': {
            animation: 'none'
        }
    }
});
const $bcd81d9dc12675ef$var$prismBorderStyles = (colorMode, hover)=>/*#__PURE__*/ (0, $1NIU8.css)({
        content: "''",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        position: 'absolute',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: -1,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `calc(100% + 2px)`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `calc(100% + 2px)`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        top: `-1px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        left: `-1px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        borderRadius: `calc(${"var(--ds-border-radius-100, 3px)"} + 1px)`,
        transform: 'translate3d(0, 0, 0)',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...hover ? {
            background: "var(--ds-border-input, #8590A2)"
        } : $bcd81d9dc12675ef$var$isFirefox ? {
            background: `linear-gradient(90deg,
								${$bcd81d9dc12675ef$var$aiPrismColor['prism.border.step.1'][colorMode ?? 'light']} 0%,
								${$bcd81d9dc12675ef$var$aiPrismColor['prism.border.step.2'][colorMode ?? 'light']} 12%,
								${$bcd81d9dc12675ef$var$aiPrismColor['prism.border.step.3'][colorMode ?? 'light']} 24%,
								${$bcd81d9dc12675ef$var$aiPrismColor['prism.border.step.4'][colorMode ?? 'light']} 48%,
								${$bcd81d9dc12675ef$var$aiPrismColor['prism.border.step.3'][colorMode ?? 'light']} 64%,
								${$bcd81d9dc12675ef$var$aiPrismColor['prism.border.step.2'][colorMode ?? 'light']} 80%,
								${$bcd81d9dc12675ef$var$aiPrismColor['prism.border.step.1'][colorMode ?? 'light']} 100%
							)`,
            backgroundSize: '200%'
        } : {
            background: `conic-gradient(
								from var(--panel-gradient-angle, 270deg),
								${$bcd81d9dc12675ef$var$aiPrismColor['prism.border.step.1'][colorMode ?? 'light']} 0%,
								${$bcd81d9dc12675ef$var$aiPrismColor['prism.border.step.2'][colorMode ?? 'light']} 20%,
								${$bcd81d9dc12675ef$var$aiPrismColor['prism.border.step.3'][colorMode ?? 'light']} 50%,
								${$bcd81d9dc12675ef$var$aiPrismColor['prism.border.step.4'][colorMode ?? 'light']} 56%,
								${$bcd81d9dc12675ef$var$aiPrismColor['prism.border.step.1'][colorMode ?? 'light']} 100%
							)`
        }
    });
const $bcd81d9dc12675ef$export$cdf1b75966a7ba92 = (colorMode)=>/*#__PURE__*/ (0, $1NIU8.css)("@property --panel-gradient-angle{syntax:'<angle>';initial-value:270deg;inherits:false;}div[extensionType='com.atlassian.ai-blocks']{.extension-label{display:none;}.extension-container{position:relative;box-shadow:none;overflow:unset;background-color:var(--ds-surface, #FFFFFF)!important;&::before,&::after{", $bcd81d9dc12675ef$var$prismBorderStyles(colorMode), ";}&.with-hover-border{&::before,&::after{", $bcd81d9dc12675ef$var$prismBorderStyles(colorMode, true), ";}}& .with-margin-styles{background-color:var(--ds-surface, #FFFFFF)!important;border-radius:var(--ds-border-radius-100, 3px);}}}div[extensionType='com.atlassian.ai-blocks']:has(.streaming){.extension-container{box-shadow:none;overflow:unset;", $bcd81d9dc12675ef$var$prismBorderAnimationStyles, " &::before,&::after{", $bcd81d9dc12675ef$var$prismBorderStyles(colorMode), ";}}}div[extensionType='com.atlassian.ai-blocks'].danger{.extension-container{box-shadow:0 0 0 1px var(--ds-border-danger, #E2483D);}}div[extensiontype='com.atlassian.ai-blocks'][extensionkey='ai-action-items-block:aiActionItemsBodiedExtension']{div[data-node-type='actionList']{margin:0!important;}}");

});

parcelRegister("4e15Z", function(module, exports) {

$parcel$export(module.exports, "codeBidiWarningStyles", () => $5769bf22e571ef11$export$98853831203df33a);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $1NIU8 = parcelRequire("1NIU8");
const $5769bf22e571ef11$export$98853831203df33a = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="code-bidi-warning"]': {
        display: 'inline-block'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="code-bidi-warning"] [data-bidi-component="code-bidi-warning-decorator"]': {
        paddingInlineStart: "var(--ds-space-050, 4px)",
        paddingInlineEnd: "var(--ds-space-050, 4px)",
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        fontStyle: 'normal',
        fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        paddingTop: '0.05rem',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        paddingBottom: '0.05rem',
        color: "var(--ds-text-warning, #A54800)",
        backgroundColor: "var(--ds-background-warning, #FFF7D6)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="code-bidi-warning"] [data-bidi-component="code-bidi-warning-decorator"]:hover': {
        color: "var(--ds-text-warning, #A54800)",
        backgroundColor: "var(--ds-background-warning-hovered, #F8E6A0)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="code-bidi-warning"] [data-bidi-component="code-bidi-warning-tooltip"]': {
        visibility: 'hidden',
        boxSizing: 'border-box',
        width: '15pc',
        backgroundColor: "var(--ds-background-neutral-bold, #44546F)",
        color: "var(--ds-text-inverse, #FFFFFF)",
        overflowWrap: 'break-word',
        cursor: 'default',
        borderRadius: "var(--ds-border-radius, 4px)",
        margin: "var(--ds-space-0, 0px)",
        padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-075, 6px)"}`,
        position: 'fixed',
        // The character label will be ~80px and this is positioned from the end of that label
        // We also use this instead of top: 24px to make sure the tooltip maintains its initial position
        // instead of being positioned relative to the viewport.
        // We need to use position: fixed so that the tooltip bypasses the overflow settings of the code block
        // and is always visible.
        // We also offset a little extra here to account for the transition behavior (to replicate ADS fade-in-from-top)
        transform: 'translate(calc(-50% - 40px), calc(24px - 4px))',
        opacity: 0,
        whiteSpace: 'normal',
        font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        zIndex: 9999,
        // Exit animation timings
        // - Mark invisible after 0.475s
        // - After 0.3s, fade out and move up over 0.175s
        transition: 'visibility 0s linear 0.475s, opacity 0.175s cubic-bezier(0.15,1,0.3,1) 0.3s, transform 0.175s cubic-bezier(0.15,1,0.3,1) 0.3s'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="code-bidi-warning"]:hover [data-bidi-component="code-bidi-warning-tooltip"]': {
        visibility: 'visible',
        transform: 'translate(calc(-50% - 40px), calc(24px))',
        opacity: 1,
        // Enter animation timings
        // - Mark visible after 0.3s of hovering
        // - After 0.3s, fade in over 0.175s
        // - After 0.3s, move down over 0.35s
        transition: 'visibility 0s linear 0.3s, opacity 0.175s cubic-bezier(0.15,1,0.3,1) 0.3s, transform 0.35s cubic-bezier(0.15,1,0.3,1) 0.3s'
    }
});

});

parcelRegister("320JB", function(module, exports) {

$parcel$export(module.exports, "codeBlockStyles", () => $cdf9e2f03c2870af$export$4baaed2b257b830);
/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $gBkUB = parcelRequire("gBkUB");

var $7yBx7 = parcelRequire("7yBx7");
var $2N2k8 = parcelRequire("2N2k8");
var $egs2l = parcelRequire("egs2l");

var $beiHJ = parcelRequire("beiHJ");
function $cdf9e2f03c2870af$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $cdf9e2f03c2870af$var$_ref3 = {
    name: "1dgciks",
    styles: "&::after{height:100%;content:'';position:absolute;left:0;top:0;width:24px;background-color:var(--ds-blanket-danger, none);}"
};
const $cdf9e2f03c2870af$var$GutterDangerOverlay = ()=>$cdf9e2f03c2870af$var$_ref3;
/* When code-block is inside the panel  */ var $cdf9e2f03c2870af$var$_ref = {
    name: "czrl7q",
    styles: ".ak-editor-panel__content{>.code-block:first-child{margin:0 0 0 0!important;}}"
};
var $cdf9e2f03c2870af$var$_ref2 = {
    name: "142jt9z",
    styles: ".ak-editor-panel__content{>.code-block:first-child,>.ProseMirror-widget:first-child+.code-block,>.ProseMirror-widget:first-child+.ProseMirror-widget+.code-block{margin:0 0 0 0!important;}}"
};
const $cdf9e2f03c2870af$var$firstCodeBlockWithNoMargin = (0, $beiHJ.functionWithFG)('platform_editor_nested_dnd_styles_changes', ()=>$cdf9e2f03c2870af$var$_ref2, ()=>$cdf9e2f03c2870af$var$_ref);
const $cdf9e2f03c2870af$export$4baaed2b257b830 = ()=>/*#__PURE__*/ (0, $1NIU8.css)(".ProseMirror{", (0, $gBkUB.codeBlockSharedStyles)(), ";}.ProseMirror li{>.code-block{margin:", (0, $7yBx7.blockNodesVerticalMargin), " 0 0 0;}>.code-block:first-child,>.ProseMirror-gapcursor:first-child+.code-block{margin-top:0;}>div:last-of-type.code-block,>pre:last-of-type.code-block{margin-bottom:", (0, $7yBx7.blockNodesVerticalMargin), ";}}.ProseMirror .code-block.", (0, $7yBx7.akEditorSelectedNodeClassName), ":not(.danger){", (0, $2N2k8.getSelectionStyles)([
        (0, $egs2l.SelectionStyle).BoxShadow,
        (0, $egs2l.SelectionStyle).Blanket
    ]), ";}.ProseMirror .danger.code-block{box-shadow:0 0 0 ", (0, $7yBx7.akEditorSelectedBorderSize), "px ", `var(--ds-border-danger, ${(0, $7yBx7.akEditorDeleteBorder)})`, ";.", (0, $gBkUB.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER, "{background-color:var(--ds-background-danger, #FFECEB);color:", `var(--ds-text-danger, ${(0, $7yBx7.akEditorDeleteIconColor)})`, ";", $cdf9e2f03c2870af$var$GutterDangerOverlay(), ";}.", (0, $gBkUB.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT, "{background-color:", `var(--ds-blanket-danger, ${(0, $7yBx7.akEditorDeleteBackground)})`, ";}}.ProseMirror .danger .code-block{.", (0, $gBkUB.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER, "{background-color:var(--ds-background-danger, rgba(255, 143, 115, 0.5));color:", `var(--ds-text-danger, ${(0, $7yBx7.akEditorDeleteIconColor)})`, ";", $cdf9e2f03c2870af$var$GutterDangerOverlay(), ";}.", (0, $gBkUB.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT, "{background-color:var(--ds-blanket-danger, rgba(255, 189, 173, 0.5));}}", $cdf9e2f03c2870af$var$firstCodeBlockWithNoMargin(), ";");

});
parcelRegister("beiHJ", function(module, exports) {

$parcel$export(module.exports, "functionWithFG", () => $7d429f092fdee0b6$export$53903226fff06fbb);

var $eGOwo = parcelRequire("eGOwo");

var $ca7s3 = parcelRequire("ca7s3");
const $7d429f092fdee0b6$export$53903226fff06fbb = (featureFlagName, functionTrue, functionFalse)=>(0, $ca7s3.functionWithCondition)(()=>(0, $eGOwo.fg)(featureFlagName), functionTrue, functionFalse);

});
parcelRegister("ca7s3", function(module, exports) {

$parcel$export(module.exports, "functionWithCondition", () => $2c308d3097081b64$export$af3c0e82a18fc057);
/**
 * Returns one of functions depending on a boolean condition.
 * Both functions should have the same signature.
 * @see {@link functionUnionWithCondition} for functions with different return types
 */ function $2c308d3097081b64$export$af3c0e82a18fc057(condition, functionTrue, functionFalse) {
    const fnWithCondition = (...args)=>condition() ? functionTrue(...args) : functionFalse(...args);
    // Improvement: set name on a function. Requires external helper, not required for production
    return fnWithCondition;
}
function $2c308d3097081b64$export$c41c28c1d883fcd5(condition, functionTrue, functionFalse) {
    // @ts-expect-error TS2345: Argument of type '(...args: C) => R2' is not assignable to parameter of type '(...args: C) => R1'.
    return $2c308d3097081b64$export$af3c0e82a18fc057(condition, functionTrue, functionFalse);
}

});



parcelRegister("afDZa", function(module, exports) {

$parcel$export(module.exports, "dateNodeStyles", () => $63b8db90bb3c45de$export$208c1691908c039b);
$parcel$export(module.exports, "dateStyles", () => $63b8db90bb3c45de$export$37579fbc35dcc1a9);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $fDsDd = parcelRequire("fDsDd");

var $7yBx7 = parcelRequire("7yBx7");
var $2N2k8 = parcelRequire("2N2k8");
var $egs2l = parcelRequire("egs2l");
const $63b8db90bb3c45de$export$208c1691908c039b = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "[data-prosemirror-node-name='date'] .date-lozenger-container span": {
        backgroundColor: "var(--ds-background-neutral, #091E420F)",
        color: "var(--ds-text, #172B4D)",
        borderRadius: "var(--ds-border-radius-100, 4px)",
        padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-050, 4px)"}`,
        margin: '0 1px',
        position: 'relative',
        transition: 'background 0.3s',
        whiteSpace: 'nowrap',
        cursor: 'unset'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "[data-prosemirror-node-name='date'] .date-lozenger-container span:hover": {
        backgroundColor: "var(--ds-background-neutral-hovered, #091E4224)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "[data-prosemirror-node-name='date'] .date-lozenger-container span.date-node-color-red": {
        backgroundColor: "var(--ds-background-accent-red-subtlest, #FFECEB)",
        color: "var(--ds-text-accent-red, #AE2E24)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "[data-prosemirror-node-name='date'] .date-lozenger-container span.date-node-color-red:hover": {
        backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)"
    }
});
const $63b8db90bb3c45de$export$37579fbc35dcc1a9 = /*#__PURE__*/ (0, $1NIU8.css)(".", (0, $fDsDd.DateSharedCssClassName).DATE_CONTAINER, "{.", (0, $fDsDd.DateSharedCssClassName).DATE_WRAPPER, "{line-height:initial;cursor:pointer;}&.", (0, $7yBx7.akEditorSelectedNodeClassName), "{.", (0, $fDsDd.DateSharedCssClassName).DATE_WRAPPER, ">span{", (0, $2N2k8.getSelectionStyles)([
    (0, $egs2l.SelectionStyle).BoxShadow
]), ";}}}.danger{.", (0, $fDsDd.DateSharedCssClassName).DATE_CONTAINER, ".", (0, $7yBx7.akEditorSelectedNodeClassName), " .", (0, $fDsDd.DateSharedCssClassName).DATE_WRAPPER, ">span{box-shadow:0 0 0 ", (0, $7yBx7.akEditorSelectedBorderSize), "px ", `var(--ds-border-danger, ${(0, $7yBx7.akEditorDeleteBorder)})`, ";}}");

});

parcelRegister("aQRv5", function(module, exports) {

$parcel$export(module.exports, "expandStyles", () => $30f069b5ebc11238$export$4bb28258452e3b9a);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $2lnbZ = parcelRequire("2lnbZ");
var $is7NW = parcelRequire("is7NW");
var $fpql2 = parcelRequire("fpql2");

var $7yBx7 = parcelRequire("7yBx7");
var $2N2k8 = parcelRequire("2N2k8");
var $egs2l = parcelRequire("egs2l");

var $eGOwo = parcelRequire("eGOwo");
function $30f069b5ebc11238$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $30f069b5ebc11238$var$EXPAND_SELECTED_BACKGROUND = "var(--ds-background-neutral-subtle, rgba(255, 255, 255, 0.6))";
var $30f069b5ebc11238$var$_ref2 = {
    name: "1t3zvjb",
    styles: "color:var(--ds-icon-subtle, #626F86)"
};
const $30f069b5ebc11238$var$EXPAND_ICON_COLOR = ()=>$30f069b5ebc11238$var$_ref2;
const $30f069b5ebc11238$var$DANGER_STATE_BACKGROUND_COLOR = "var(--ds-background-danger, #FFECEB)";
const $30f069b5ebc11238$var$DANGER_STATE_BORDER_COLOR = "var(--ds-border-danger, #E2483D)";
var $30f069b5ebc11238$var$_ref = {
    name: "1oz7tqa",
    styles: ">:nth-child(1 of :not(style, .ProseMirror-gapcursor, .ProseMirror-widget, span)){margin-top:0;}>div.ak-editor-expand[data-node-type='nestedExpand']{margin-top:var(--ds-space-050, 0.25rem);}"
};
const $30f069b5ebc11238$var$firstNodeWithNotMarginTop = ()=>(0, $eGOwo.fg)('platform_editor_nested_dnd_styles_changes') ? $30f069b5ebc11238$var$_ref : '';
const $30f069b5ebc11238$export$4bb28258452e3b9a = ()=>/*#__PURE__*/ (0, $1NIU8.css)(".", (0, $is7NW.expandClassNames).icon, ">div{display:flex;}.", (0, $is7NW.expandClassNames).prefix, "{", (0, $fpql2.sharedExpandStyles).containerStyles({
        expanded: false,
        focused: false
    })(), " cursor:pointer;box-sizing:border-box;td>&{margin-top:0;}.", (0, $is7NW.expandClassNames).iconContainer, " svg{", $30f069b5ebc11238$var$EXPAND_ICON_COLOR(), ";transform:rotate(90deg);}&.", (0, $7yBx7.akEditorSelectedNodeClassName), ":not(.danger){", (0, $eGOwo.fg)('platform_editor_nested_dnd_styles_changes') ? (0, $2N2k8.getSelectionStyles)([
        (0, $egs2l.SelectionStyle).Blanket
    ]) + `border: ${0, $7yBx7.akEditorSelectedBorder};` : (0, $2N2k8.getSelectionStyles)([
        (0, $egs2l.SelectionStyle).Blanket,
        (0, $egs2l.SelectionStyle).Border
    ]), ";}&.danger{background:", $30f069b5ebc11238$var$DANGER_STATE_BACKGROUND_COLOR, ";border-color:", $30f069b5ebc11238$var$DANGER_STATE_BORDER_COLOR, ";}}.ProseMirror>.", (0, $is7NW.expandClassNames).type('expand'), ",.", (0, $2lnbZ.BreakoutCssClassName).BREAKOUT_MARK_DOM, ">.", (0, $is7NW.expandClassNames).type('expand'), "{margin-left:-", (0, $7yBx7.akLayoutGutterOffset), "px;margin-right:-", (0, $7yBx7.akLayoutGutterOffset), "px;}", (0, $eGOwo.fg)('platform_editor_nested_dnd_styles_changes') && `.ak-editor-content-area.appearance-full-page .ProseMirror
		> .${(0, $is7NW.expandClassNames).type('expand')},
		.${(0, $2lnbZ.BreakoutCssClassName).BREAKOUT_MARK_DOM}
		> .${(0, $is7NW.expandClassNames).type('expand')} {
		margin-left: -${(0, $7yBx7.akLayoutGutterOffset) + 8}px;
		margin-right: -${(0, $7yBx7.akLayoutGutterOffset) + 8}px;
	}`, " .", (0, $is7NW.expandClassNames).content, "{", (0, $fpql2.sharedExpandStyles).contentStyles({
        expanded: false,
        focused: false
    })(), " cursor:text;padding-top:0px;}.", (0, $is7NW.expandClassNames).titleInput, "{", (0, $fpql2.sharedExpandStyles).titleInputStyles(), ";}.", (0, $is7NW.expandClassNames).titleContainer, "{", (0, $fpql2.sharedExpandStyles).titleContainerStyles(), ";align-items:center;overflow:visible;}.", (0, $is7NW.expandClassNames).expanded, "{background:", $30f069b5ebc11238$var$EXPAND_SELECTED_BACKGROUND, ";border-color:var(--ds-border, #091E4224);.", (0, $is7NW.expandClassNames).content, "{padding-top:var(--ds-space-100, 8px);", $30f069b5ebc11238$var$firstNodeWithNotMarginTop(), ";}}.", (0, $is7NW.expandClassNames).inputContainer, "{width:100%;}.", (0, $is7NW.expandClassNames).prefix, ":(.", (0, $is7NW.expandClassNames).expanded, "){.expand-content-wrapper{height:auto;}}.", (0, $is7NW.expandClassNames).prefix, ":not(.", (0, $is7NW.expandClassNames).expanded, "){.ak-editor-expand__content{position:absolute;height:1px;width:1px;overflow:hidden;clip:rect(1px, 1px, 1px, 1px);white-space:nowrap;}.", (0, $is7NW.expandClassNames).iconContainer, " svg{", $30f069b5ebc11238$var$EXPAND_ICON_COLOR(), ";transform:rotate(0deg);}&:not(.", (0, $7yBx7.akEditorSelectedNodeClassName), "):not(.danger){background:transparent;border-color:transparent;&:hover{border-color:var(--ds-border, #091E4224);background:", $30f069b5ebc11238$var$EXPAND_SELECTED_BACKGROUND, ";}}}");

});
parcelRegister("2lnbZ", function(module, exports) {

$parcel$export(module.exports, "BreakoutCssClassName", () => $aa9f014a89ad802c$export$c21a3b023fccd534);
const $aa9f014a89ad802c$export$c21a3b023fccd534 = {
    BREAKOUT_MARK: 'fabric-editor-breakout-mark',
    BREAKOUT_MARK_DOM: 'fabric-editor-breakout-mark-dom'
};

});

parcelRegister("fpql2", function(module, exports) {

$parcel$export(module.exports, "EXPAND_CONTAINER_PADDING", () => $2aa0ff4706771bfd$export$6065600df915db53);
$parcel$export(module.exports, "sharedExpandStyles", () => $2aa0ff4706771bfd$export$8c0b53d8e8508fed);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $7yBx7 = parcelRequire("7yBx7");

var $eGOwo = parcelRequire("eGOwo");
const $2aa0ff4706771bfd$var$BORDER_RADIUS = "var(--ds-border-radius-100, 4px)";
const $2aa0ff4706771bfd$var$EXPAND_COLLAPSED_BACKGROUND = "var(--ds-background-neutral-subtle, transparent)";
const $2aa0ff4706771bfd$var$EXPAND_SELECTED_BACKGROUND = "var(--ds-surface, rgba(255, 255, 255, 0.6))";
const $2aa0ff4706771bfd$var$EXPAND_FOCUSED_BORDER_COLOR = "var(--ds-border-focused, #388BFF)";
const $2aa0ff4706771bfd$var$EXPAND_COLLAPSED_BORDER_COLOR = 'transparent';
const $2aa0ff4706771bfd$var$EXPAND_EXPANDED_BORDER_COLOR = "var(--ds-border, #091E4224)";
const $2aa0ff4706771bfd$export$6065600df915db53 = 8;
const $2aa0ff4706771bfd$var$containerStyles = (styleProps)=>{
    const { expanded: expanded, focused: focused } = styleProps;
    const marginTop = "var(--ds-space-050, 0.25rem)";
    const marginBottom = 0;
    // Only only these margins if the expand isn't editable
    // and is the root level expand.
    const marginHorizontal = styleProps['data-node-type'] === 'expand' ? `-${0, $7yBx7.akLayoutGutterOffset}px` : 0;
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const margin = `${marginTop} ${marginHorizontal} ${marginBottom}`;
    return ()=>/*#__PURE__*/ (0, $1NIU8.css)({
            borderWidth: '1px',
            borderStyle: 'solid',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: focused ? $2aa0ff4706771bfd$var$EXPAND_FOCUSED_BORDER_COLOR : expanded ? $2aa0ff4706771bfd$var$EXPAND_EXPANDED_BORDER_COLOR : $2aa0ff4706771bfd$var$EXPAND_COLLAPSED_BORDER_COLOR,
            borderRadius: $2aa0ff4706771bfd$var$BORDER_RADIUS,
            minHeight: '25px',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            background: !expanded ? $2aa0ff4706771bfd$var$EXPAND_COLLAPSED_BACKGROUND : $2aa0ff4706771bfd$var$EXPAND_SELECTED_BACKGROUND,
            margin: margin,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            transition: `background 0.3s ${(0, $7yBx7.akEditorSwoopCubicBezier)}, border-color 0.3s ${(0, $7yBx7.akEditorSwoopCubicBezier)}`,
            padding: `var(--ds-space-100, ${`${$2aa0ff4706771bfd$export$6065600df915db53}px`})`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            'td > :not(style):first-child, td > style:first-child + *': {
                marginTop: 0
            }
        });
};
const $2aa0ff4706771bfd$var$contentStyles = (styleProps)=>()=>/*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
        (0, $1NIU8.css)("padding-top:", styleProps.expanded ? "var(--ds-space-100, 8px)" : "var(--ds-space-0, 0px)", ";padding-right:var(--ds-space-100, 8px);padding-left:var(--ds-space-300, 24px);margin-left:var(--ds-space-050, 4px);display:flow-root;/* The follow rules inside @supports block are added as a part of ED-8893\n\t\tThe fix is targeting mobile bridge on iOS 12 or below,\n\t\tWe should consider remove this fix when we no longer support iOS 12 */@supports not (display: flow-root){width:100%;box-sizing:border-box;}", !styleProps.expanded ? `
        .expand-content-wrapper, .nestedExpand-content-wrapper {
          /* We visually hide the content here to preserve the content during copy+paste */
          /* Do not add text nowrap here because inline comment navigation depends on the location of the text */
          width: 100%;
          display: block;
          height: 0;
          overflow: hidden;
          clip: rect(1px, 1px, 1px, 1px);
          user-select: none;
        }
      ` : '', ";");
const $2aa0ff4706771bfd$var$titleInputStyles = ()=>/*#__PURE__*/ (0, $1NIU8.css)({
        outline: 'none',
        border: 'none',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        fontSize: (0, $7yBx7.relativeFontSizeToBase16)(14),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
        lineHeight: (0, $eGOwo.fg)('platform-visual-refresh-icons') ? 1 : (0, $7yBx7.akEditorLineHeight),
        fontWeight: "var(--ds-font-weight-regular, 400)",
        color: "var(--ds-text-subtlest, #626F86)",
        background: 'transparent',
        display: 'flex',
        flex: 1,
        padding: `0 0 0 ${"var(--ds-space-050, 4px)"}`,
        width: '100%',
        '&::placeholder': {
            opacity: 1,
            color: "var(--ds-text-subtlest, #626F86)"
        }
    });
const $2aa0ff4706771bfd$var$titleContainerStyles = ()=>/*#__PURE__*/ (0, $1NIU8.css)({
        padding: 0,
        display: 'flex',
        alignItems: 'flex-start',
        background: 'none',
        border: 'none',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        fontSize: (0, $7yBx7.relativeFontSizeToBase16)(14),
        width: '100%',
        color: "var(--ds-text-subtle, #44546F)",
        overflow: 'hidden',
        cursor: 'pointer',
        '&:focus': {
            outline: 0
        }
    });
const $2aa0ff4706771bfd$export$8c0b53d8e8508fed = {
    titleInputStyles: $2aa0ff4706771bfd$var$titleInputStyles,
    titleContainerStyles: $2aa0ff4706771bfd$var$titleContainerStyles,
    containerStyles: $2aa0ff4706771bfd$var$containerStyles,
    contentStyles: $2aa0ff4706771bfd$var$contentStyles
};

});


parcelRegister("kVRJd", function(module, exports) {

$parcel$export(module.exports, "extensionStyles", () => $e4eac2281f466866$export$c0c648396dbd86d3);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $7yBx7 = parcelRequire("7yBx7");
var $2N2k8 = parcelRequire("2N2k8");
var $egs2l = parcelRequire("egs2l");
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Needs manual remediation
const $e4eac2281f466866$var$extensionLabelStyles = /*#__PURE__*/ (0, $1NIU8.css)("&.danger>span>div>.extension-label{background-color:var(--ds-background-accent-red-subtler, #FFD5D2);color:var(--ds-text-danger, #AE2E24);opacity:1;box-shadow:none;}&:not(.danger).", (0, $7yBx7.akEditorSelectedNodeClassName), ">span>div>.extension-label{background-color:var(--ds-background-selected, #E9F2FF);color:var(--ds-text-selected, #0C66E4);opacity:1;box-shadow:none;}&.danger>span>div>.extension-label>span{display:inline;}&:not(.danger).", (0, $7yBx7.akEditorSelectedNodeClassName), ">span>div .extension-label>span{display:inline;}&.danger.", (0, $7yBx7.akEditorSelectedNodeClassName), ">span>.extension-edit-toggle-container{opacity:1;}&:not(.danger).", (0, $7yBx7.akEditorSelectedNodeClassName), ">span>.extension-edit-toggle-container{opacity:1;}&.danger.", (0, $7yBx7.akEditorSelectedNodeClassName), ">span>div>.extension-label.always-hide-label{opacity:0;}&:not(.danger).", (0, $7yBx7.akEditorSelectedNodeClassName), ">span>div>.extension-label.always-hide-label{opacity:0;}&:not(.danger).", (0, $7yBx7.akEditorSelectedNodeClassName), ">span>div>.extension-label.with-bodied-macro-live-page-styles{box-shadow:0 0 0 ", (0, $7yBx7.akEditorSelectedBorderSize), "px var(--ds-border-selected, #0C66E4);}&.danger.", (0, $7yBx7.akEditorSelectedNodeClassName), ">span>div>.extension-label.with-bodied-macro-live-page-styles{box-shadow:0 0 0 ", (0, $7yBx7.akEditorSelectedBorderSize), "px var(--ds-border-danger, #E2483D);}&.danger.", (0, $7yBx7.akEditorSelectedNodeClassName), ">span>.extension-edit-toggle-container>.extension-edit-toggle{background-color:var(--ds-background-accent-red-subtler, #FFD5D2);color:var(--ds-text-danger, #AE2E24);box-shadow:none;}");
const $e4eac2281f466866$var$dangerOverlayStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    opacity: 0.3,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    backgroundColor: `var(--ds-background-danger-hovered, ${(0, $7yBx7.akEditorDeleteBackground)})`
});
const $e4eac2281f466866$export$c0c648396dbd86d3 = /*#__PURE__*/ (0, $1NIU8.css)(".multiBodiedExtensionView-content-wrap{&.danger>span>.multiBodiedExtension--container{box-shadow:0 0 0 ", (0, $7yBx7.akEditorSelectedBorderSize), "px ", `var(--ds-border-danger, ${(0, $7yBx7.akEditorDeleteBorder)})`, ";background-color:", `var(--ds-background-danger, ${(0, $7yBx7.akEditorDeleteBackground)})`, ";}", $e4eac2281f466866$var$extensionLabelStyles, " &.danger>span>.with-danger-overlay{background-color:transparent;.multiBodiedExtension--overlay{", $e4eac2281f466866$var$dangerOverlayStyles, ";}}&:not(.danger).", (0, $7yBx7.akEditorSelectedNodeClassName), "{&>span>.multiBodiedExtension--container{", (0, $2N2k8.getSelectionStyles)([
    (0, $egs2l.SelectionStyle).BoxShadow,
    (0, $egs2l.SelectionStyle).Blanket
]), ";}}.multiBodiedExtension--container{width:100%;max-width:100%;}}.inlineExtensionView-content-wrap{", $e4eac2281f466866$var$extensionLabelStyles, ";&.danger>span>.extension-container{box-shadow:0 0 0 ", (0, $7yBx7.akEditorSelectedBorderSize), "px ", `var(--ds-border-danger, ${(0, $7yBx7.akEditorDeleteBorder)})`, ";background-color:", `var(--ds-background-danger, ${(0, $7yBx7.akEditorDeleteBackground)})`, ";}&.danger>span>.with-danger-overlay{background-color:transparent;.extension-overlay{", $e4eac2281f466866$var$dangerOverlayStyles, ";}}&:not(.danger).", (0, $7yBx7.akEditorSelectedNodeClassName), "{&>span>.extension-container{", (0, $2N2k8.getSelectionStyles)([
    (0, $egs2l.SelectionStyle).BoxShadow
]), ";}}}.bodied-extension-to-dom-label::after{content:attr(data-bodied-extension-label);}.extensionView-content-wrap,.multiBodiedExtensionView-content-wrap,.bodiedExtensionView-content-wrap{margin:", (0, $7yBx7.blockNodesVerticalMargin), " 0;&:first-of-type{margin-top:0;}&:last-of-type{margin-bottom:0;}&:not(.danger).", (0, $7yBx7.akEditorSelectedNodeClassName), "{&>span>.extension-container{", (0, $2N2k8.getSelectionStyles)([
    (0, $egs2l.SelectionStyle).BoxShadow
]), ";}}&.danger>span>.extension-container{box-shadow:0 0 0 ", (0, $7yBx7.akEditorSelectedBorderSize), "px ", `var(--ds-border-danger, ${(0, $7yBx7.akEditorDeleteBorder)})`, ";background-color:", `var(--ds-background-danger, ${(0, $7yBx7.akEditorDeleteBackground)})`, ";}", $e4eac2281f466866$var$extensionLabelStyles, " &.danger>span>.with-danger-overlay{background-color:transparent;.extension-overlay{", $e4eac2281f466866$var$dangerOverlayStyles, ";}}&.inline{word-wrap:break-all;}}.extensionView-content-wrap .extension-container{overflow:hidden;&:has(.extension-editable-area){overflow:visible;}}.bodiedExtensionView-content-wrap .extensionView-content-wrap .extension-container{width:100%;max-width:100%;}[data-mark-type='fragment']{&>.extensionView-content-wrap,&>.bodiedExtensionView-content-wrap{margin:", (0, $7yBx7.blockNodesVerticalMargin), " 0;}&>[data-mark-type='dataConsumer']{&>.extensionView-content-wrap,&>.bodiedExtensionView-content-wrap{margin:", (0, $7yBx7.blockNodesVerticalMargin), " 0;}}&:first-child{&>.extensionView-content-wrap,&>.bodiedExtensionView-content-wrap{margin-top:0;}&>[data-mark-type='dataConsumer']{&>.extensionView-content-wrap,&>.bodiedExtensionView-content-wrap{margin-top:0;}}}&:nth-last-of-type(-n + 2):not(:first-of-type){&>.extensionView-content-wrap,&>.bodiedExtensionView-content-wrap{margin-bottom:0;}&>[data-mark-type='dataConsumer']{&>.extensionView-content-wrap,&>.bodiedExtensionView-content-wrap{margin-bottom:0;}}}}");

});

parcelRegister("h6DrW", function(module, exports) {

$parcel$export(module.exports, "layoutStyles", () => $f43bf528f4407914$export$ac8f5049e4e10701);
/**
 * TODO ED-26957 - remove legacy styles when static emotion refactor is complete
 * We are moving this to new location under FF: platform_editor_core_static_emotion
 * New location: packages/editor/editor-core/src/ui/EditorContentContainer.tsx
 * If you are making updates to this file, please updates in new location as well.
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $jmB4Z = parcelRequire("jmB4Z");
var $2onoM = parcelRequire("2onoM");
parcelRequire("5hj2U");
var $dzEzE = parcelRequire("dzEzE");
parcelRequire("bZI5M");
var $fsO0s = parcelRequire("fsO0s");

var $7yBx7 = parcelRequire("7yBx7");
var $2N2k8 = parcelRequire("2N2k8");
var $egs2l = parcelRequire("egs2l");

var $eGOwo = parcelRequire("eGOwo");

var $92xoS = parcelRequire("92xoS");
function $f43bf528f4407914$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f43bf528f4407914$var$AK_NESTED_DND_GUTTER_OFFSET = 8;
var $f43bf528f4407914$var$_ref = {
    name: "kzeyqg",
    styles: ">:not(style):first-child,>style:first-child+*{margin-top:0;}>.ProseMirror-gapcursor:first-child+*,>style:first-child+.ProseMirror-gapcursor+*{margin-top:0;}>.ProseMirror-gapcursor:first-child+span+*{margin-top:0;}"
};
var $f43bf528f4407914$var$_ref2 = {
    name: "1fct7qz",
    styles: ">:nth-child(1 of :not(style, .ProseMirror-gapcursor, .ProseMirror-widget, span)){margin-top:0;}"
};
const $f43bf528f4407914$var$firstNodeWithNotMarginTop = ()=>(0, $eGOwo.fg)('platform_editor_nested_dnd_styles_changes') ? $f43bf528f4407914$var$_ref2 : $f43bf528f4407914$var$_ref;
// Ignored via go/ees007
// eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
// TODO handle responsive
const $f43bf528f4407914$var$layoutColumnStyles = ()=>(0, $92xoS.editorExperiment)('advanced_layouts', true) ? /*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    (0, $1NIU8.css)(">[data-layout-column]{margin:0 ", (0, $2onoM.LAYOUT_SECTION_MARGIN) / 2, "px;}>[data-layout-column]:first-of-type{margin-left:0;}>[data-layout-column]:last-of-type{margin-right:0;}@media screen and (max-width: ", (0, $7yBx7.gridMediumMaxWidth), "px){[data-layout-column]+[data-layout-column]{margin:0;}}>[data-layout-column].", (0, $7yBx7.akEditorSelectedNodeClassName), ":not(.danger){", (0, $2N2k8.getSelectionStyles)([
        (0, $egs2l.SelectionStyle).Blanket
    ]), ";::before{width:calc(100% - 8px);left:4px;border-radius:var(--ds-border-radius, 3px);}}") : /*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    (0, $1NIU8.css)("[data-layout-column]+[data-layout-column]{margin-left:", (0, $2onoM.LAYOUT_SECTION_MARGIN), "px;}@media screen and (max-width: ", (0, $7yBx7.gridMediumMaxWidth), "px){[data-layout-column]+[data-layout-column]{margin-left:0;}}");
const $f43bf528f4407914$var$layoutSectionStyles = ()=>(0, $92xoS.editorExperiment)('advanced_layouts', true) ? /*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    (0, $1NIU8.css)((0, $jmB4Z.columnLayoutResponsiveSharedStyle), ";.layout-section-container [data-layout-section]{>.ProseMirror-widget{flex:none;display:contents!important;&[data-blocks-drag-handle-container] div{display:contents!important;}&[data-blocks-drop-target-container]{display:block!important;margin:var(--ds-space-negative-050, -4px);[data-drop-target-for-element]{position:absolute;}}&+[data-layout-column]{margin:0;}}>[data-layout-column]{margin:0;}}") : /*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    (0, $1NIU8.css)((0, $jmB4Z.columnLayoutSharedStyle), ";");
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
const $f43bf528f4407914$var$layoutBorderStyles = (viewMode)=>/*#__PURE__*/ (0, $1NIU8.css)("&.selected [data-layout-column],&:hover [data-layout-column]{border:", viewMode === 'view' ? 0 : (0, $7yBx7.akEditorSelectedBorderSize), "px solid var(--ds-border, #091E4224);}&.selected.danger [data-layout-column]{background-color:", `var(--ds-background-danger, ${(0, $7yBx7.akEditorDeleteBackground)})`, ";border-color:", `var(--ds-border-danger, ${(0, $7yBx7.akEditorDeleteBorder)})`, ";}&.", (0, $7yBx7.akEditorSelectedNodeClassName), ":not(.danger){[data-layout-column]{", (0, $2N2k8.getSelectionStyles)([
        (0, $egs2l.SelectionStyle).Border,
        (0, $egs2l.SelectionStyle).Blanket
    ]), " ::after{background-color:transparent;}}}");
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
const $f43bf528f4407914$var$columnSeparatorStyles = (viewMode)=>/*#__PURE__*/ (0, $1NIU8.css)("[data-layout-content]::before{content:'';border-left:", viewMode === 'view' ? 0 : (0, $7yBx7.akEditorSelectedBorderSize), "px solid var(--ds-border, #091E4224);position:absolute;height:calc(100% - 24px);margin-left:-25px;}");
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
const $f43bf528f4407914$var$rowSeparatorStyles = (viewMode)=>/*#__PURE__*/ (0, $1NIU8.css)("[data-layout-content]::before{content:'';border-top:", viewMode === 'view' ? 0 : (0, $7yBx7.akEditorSelectedBorderSize), "px solid var(--ds-border, #091E4224);position:absolute;width:calc(100% - 32px);margin-top:-13px;border-left:unset;margin-left:unset;height:unset;}");
// jest warning: JSDOM version (22) doesn't support the new @container CSS rule
const $f43bf528f4407914$var$layoutWithSeparatorBorderResponsiveStyles = (breakpoint, viewMode)=>/*#__PURE__*/ (0, $1NIU8.css)("&.selected,&:hover,&.selected.danger,&.", (0, $7yBx7.akEditorSelectedNodeClassName), ":not(.danger){[data-layout-column]:not(:first-of-type){@container editor-area (max-width:", breakpoint, "px){", $f43bf528f4407914$var$rowSeparatorStyles(viewMode), ";}}}");
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
const $f43bf528f4407914$var$layoutWithSeparatorBorderStyles = (viewMode)=>{
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    return /*#__PURE__*/ (0, $1NIU8.css)("&.selected [data-layout-column]:not(:first-of-type),[data-empty-layout='true'] [data-layout-column]:not(:first-of-type),&:hover [data-layout-column]:not(:first-of-type){", $f43bf528f4407914$var$columnSeparatorStyles(viewMode), ";}&.selected.danger [data-layout-section]{background-color:", `var(--ds-background-danger, ${(0, $7yBx7.akEditorDeleteBackground)})`, ";box-shadow:0 0 0 ", viewMode === 'view' ? 0 : (0, $7yBx7.akEditorSelectedBorderSize), "px ", (0, $7yBx7.akEditorDeleteBorder), ";border-radius:4px;[data-layout-column]:not(:first-of-type){", $f43bf528f4407914$var$columnSeparatorStyles(viewMode), ";}}&.", (0, $7yBx7.akEditorSelectedNodeClassName), ":not(.danger) [data-layout-section]{box-shadow:0 0 0 ", viewMode === 'view' ? 0 : (0, $7yBx7.akEditorSelectedBorderSize), "px var(--ds-border-selected, #0C66E4);border-radius:4px;background-color:var(--ds-background-selected, #E9F2FF);[data-layout-column]{", (0, $2N2k8.getSelectionStyles)([
        (0, $egs2l.SelectionStyle).Blanket
    ]), " border:0px;::before{background-color:transparent;}}[data-layout-column]:not(:first-of-type){", $f43bf528f4407914$var$columnSeparatorStyles(viewMode), ";}}");
};
// jest warning: JSDOM version (22) doesn't support the new @container CSS rule
const $f43bf528f4407914$var$layoutResponsiveStyles = (viewMode)=>/*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    (0, $1NIU8.css)(".fabric-editor--full-width-mode .ProseMirror{>.layoutSectionView-content-wrap{", $f43bf528f4407914$var$layoutWithSeparatorBorderResponsiveStyles(724, viewMode), ";[data-layout-section]{@container editor-area (max-width:724px){flex-direction:column;}}}}.ak-editor-content-area:not(.fabric-editor--full-width-mode) .ProseMirror{>.layoutSectionView-content-wrap{", $f43bf528f4407914$var$layoutWithSeparatorBorderResponsiveStyles(788, viewMode), ";[data-layout-section]{@container editor-area (max-width:788px){flex-direction:column;}}}}.ProseMirror .fabric-editor-breakout-mark{.layoutSectionView-content-wrap{", $f43bf528f4407914$var$layoutWithSeparatorBorderResponsiveStyles(820, viewMode), ";[data-layout-section]{@container editor-area (max-width:820px){flex-direction:column;}}}}");
const $f43bf528f4407914$export$ac8f5049e4e10701 = (viewMode)=>/*#__PURE__*/ (0, $1NIU8.css)(".ProseMirror{", $f43bf528f4407914$var$layoutSectionStyles(), " [data-layout-section]{margin:var(--ds-space-100, 8px) -", (0, $7yBx7.akLayoutGutterOffset) + ((0, $eGOwo.fg)('platform_editor_nested_dnd_styles_changes') ? $f43bf528f4407914$var$AK_NESTED_DND_GUTTER_OFFSET : 0), "px 0;transition:border-color 0.3s ", (0, $7yBx7.akEditorSwoopCubicBezier), ";cursor:", viewMode === 'view' ? 'default' : 'pointer', ";", $f43bf528f4407914$var$layoutColumnStyles(), ";[data-layout-column]{flex:1;position:relative;min-width:0;border:", viewMode === 'view' || (0, $92xoS.editorExperiment)('advanced_layouts', true) ? 0 : (0, $7yBx7.akEditorSelectedBorderSize), "px solid var(--ds-border, #091E4224);border-radius:4px;padding:", (0, $2onoM.LAYOUT_COLUMN_PADDING), "px ", (0, $2onoM.LAYOUT_COLUMN_PADDING) + ((0, $eGOwo.fg)('platform_editor_nested_dnd_styles_changes') ? 8 : 0), "px;box-sizing:border-box;>div{", $f43bf528f4407914$var$firstNodeWithNotMarginTop(), ">.embedCardView-content-wrap:first-of-type .rich-media-item{margin-top:0;}>.mediaSingleView-content-wrap:first-of-type .rich-media-item{margin-top:0;}>.ProseMirror-gapcursor.-right:first-child+.mediaSingleView-content-wrap .rich-media-item,>style:first-child+.ProseMirror-gapcursor.-right+.mediaSingleView-content-wrap .rich-media-item,>.ProseMirror-gapcursor.-right:first-of-type+.embedCardView-content-wrap .rich-media-item{margin-top:0;}>.ProseMirror-gapcursor:first-child+span+.mediaSingleView-content-wrap .rich-media-item,>style:first-child+.ProseMirror-gapcursor+span+.mediaSingleView-content-wrap .rich-media-item{margin-top:0;}>[data-node-type='decisionList']{li:first-of-type [data-decision-wrapper]{margin-top:0;}}}[data-layout-content]{height:100%;cursor:text;.mediaGroupView-content-wrap{clear:both;}}}}[data-layout-section],.layoutSectionView-content-wrap{", (0, $92xoS.editorExperiment)('advanced_layouts', true) ? $f43bf528f4407914$var$layoutWithSeparatorBorderStyles(viewMode) : $f43bf528f4407914$var$layoutBorderStyles(viewMode), ";}}", (0, $92xoS.editorExperiment)('advanced_layouts', true) && $f43bf528f4407914$var$layoutResponsiveStyles(viewMode), "[data-blocks-drop-target-container]~[data-layout-column]>[data-layout-content]::before{display:none;}.fabric-editor--full-width-mode .ProseMirror{[data-layout-section]{.", (0, $dzEzE.TableCssClassName).TABLE_CONTAINER, "{margin:0 ", (0, $fsO0s.tableMarginFullWidthMode), "px;}}}", (0, $92xoS.editorExperiment)('advanced_layouts', false) && (0, $eGOwo.fg)('platform_editor_nested_dnd_styles_changes') && `.ak-editor-content-area.appearance-full-page .ProseMirror [data-layout-section] {
				margin: ${"var(--ds-space-100, 8px)"} -${(0, $7yBx7.akLayoutGutterOffset) + 8}px 0;
				}`, ";");

});
parcelRegister("jmB4Z", function(module, exports) {

$parcel$export(module.exports, "columnLayoutSharedStyle", () => $1dfa5ce5d9841969$export$6891a39948814a80);
$parcel$export(module.exports, "columnLayoutResponsiveSharedStyle", () => $1dfa5ce5d9841969$export$3afcac98e7ca927d);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $7yBx7 = parcelRequire("7yBx7");
function $1dfa5ce5d9841969$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1dfa5ce5d9841969$export$6891a39948814a80 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '[data-layout-section]': {
        position: 'relative',
        display: 'flex',
        flexDirection: 'row',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > *': {
            flex: 1,
            minWidth: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > .unsupportedBlockView-content-wrap': {
            minWidth: 'initial'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`@media screen and (max-width: ${0, $7yBx7.gridMediumMaxWidth}px)`]: {
            flexDirection: 'column'
        }
    }
});
const $1dfa5ce5d9841969$export$3afcac98e7ca927d = {
    name: "ee7qh9",
    styles: "[data-layout-section]{display:flex;flex-direction:row;gap:var(--ds-space-100, 8px);& > *{flex:1;min-width:0;}& > .unsupportedBlockView-content-wrap{min-width:initial;}}.layout-section-container{container-type:inline-size;container-name:layout-area;}"
};
const $1dfa5ce5d9841969$var$LAYOUT_BREAKPOINT_RENDERER = 629;
/* jest warning: JSDOM version (22) doesn't support the new @container CSS rule */ const $1dfa5ce5d9841969$export$f2451ec7aca7656c = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.layout-section-container': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-layout-section]': {
            gap: "var(--ds-space-600, 48px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            [`@container layout-area (max-width:${$1dfa5ce5d9841969$var$LAYOUT_BREAKPOINT_RENDERER}px)`]: {
                flexDirection: 'column',
                gap: "var(--ds-space-400, 32px)"
            }
        }
    }
});

});

parcelRegister("5hj2U", function(module, exports) {

$parcel$export(module.exports, "TableCssClassName", () => (parcelRequire("dzEzE")).TableCssClassName);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $dzEzE = parcelRequire("dzEzE");

});
parcelRegister("dzEzE", function(module, exports) {

$parcel$export(module.exports, "RESIZE_HANDLE_AREA_DECORATION_GAP", () => $fdf40ec48390ab73$export$1a38c7157d718094);
$parcel$export(module.exports, "TableDecorations", () => $fdf40ec48390ab73$export$fe8f2ca19399400e);
$parcel$export(module.exports, "TableCssClassName", () => $fdf40ec48390ab73$export$19a8a7a6488b1b9f);
$parcel$export(module.exports, "ShadowEvent", () => $fdf40ec48390ab73$export$ce63d9b315ac58c9);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $e6HpD = parcelRequire("e6HpD");

var $cjLtO = parcelRequire("cjLtO");
const $fdf40ec48390ab73$export$1a38c7157d718094 = 30;
var $fdf40ec48390ab73$export$fe8f2ca19399400e = /*#__PURE__*/ function(TableDecorations) {
    /** Classic controls */ TableDecorations["ALL_CONTROLS_HOVER"] = "CONTROLS_HOVER";
    TableDecorations["ROW_CONTROLS_HOVER"] = "ROW_CONTROLS_HOVER";
    TableDecorations["COLUMN_CONTROLS_HOVER"] = "COLUMN_CONTROLS_HOVER";
    TableDecorations["TABLE_CONTROLS_HOVER"] = "TABLE_CONTROLS_HOVER";
    TableDecorations["CELL_CONTROLS_HOVER"] = "CELL_CONTROLS_HOVER";
    TableDecorations["COLUMN_CONTROLS_DECORATIONS"] = "COLUMN_CONTROLS_DECORATIONS";
    TableDecorations["COLUMN_DROP_TARGET_DECORATIONS"] = "COLUMN_DROP_TARGET_DECORATIONS";
    TableDecorations["COLUMN_SELECTED"] = "COLUMN_SELECTED";
    TableDecorations["COLUMN_RESIZING_HANDLE"] = "COLUMN_RESIZING_HANDLE";
    TableDecorations["COLUMN_RESIZING_HANDLE_WIDGET"] = "COLUMN_RESIZING_HANDLE_WIDGET";
    TableDecorations["COLUMN_RESIZING_HANDLE_LINE"] = "COLUMN_RESIZING_HANDLE_LINE";
    TableDecorations["COLUMN_INSERT_LINE"] = "COLUMN_INSERT_LINE";
    TableDecorations["ROW_INSERT_LINE"] = "ROW_INSERT_LINE";
    TableDecorations["LAST_CELL_ELEMENT"] = "LAST_CELL_ELEMENT";
    return TableDecorations;
}({});
const $fdf40ec48390ab73$export$19a8a7a6488b1b9f = {
    ...(0, $cjLtO.TableSharedCssClassName),
    /** Classic controls */ COLUMN_CONTROLS: `${(0, $e6HpD.tablePrefixSelector)}-column-controls`,
    COLUMN_CONTROLS_DECORATIONS: `${(0, $e6HpD.tablePrefixSelector)}-column-controls-decoration`,
    COLUMN_SELECTED: `${(0, $e6HpD.tablePrefixSelector)}-column__selected`,
    ROW_CONTROLS_WRAPPER: `${(0, $e6HpD.tablePrefixSelector)}-row-controls-wrapper`,
    ROW_CONTROLS: `${(0, $e6HpD.tablePrefixSelector)}-row-controls`,
    ROW_CONTROLS_INNER: `${(0, $e6HpD.tablePrefixSelector)}-row-controls__inner`,
    ROW_CONTROLS_BUTTON_WRAP: `${(0, $e6HpD.tablePrefixSelector)}-row-controls__button-wrap`,
    ROW_CONTROLS_BUTTON: `${(0, $e6HpD.tablePrefixSelector)}-row-controls__button`,
    CONTROLS_BUTTON: `${(0, $e6HpD.tablePrefixSelector)}-controls__button`,
    CONTROLS_BUTTON_ICON: `${(0, $e6HpD.tablePrefixSelector)}-controls__button-icon`,
    CONTROLS_INSERT_BUTTON: `${(0, $e6HpD.tablePrefixSelector)}-controls__insert-button`,
    CONTROLS_INSERT_BUTTON_INNER: `${(0, $e6HpD.tablePrefixSelector)}-controls__insert-button-inner`,
    CONTROLS_INSERT_BUTTON_WRAP: `${(0, $e6HpD.tablePrefixSelector)}-controls__insert-button-wrap`,
    CONTROLS_INSERT_LINE: `${(0, $e6HpD.tablePrefixSelector)}-controls__insert-line`,
    CONTROLS_BUTTON_OVERLAY: `${(0, $e6HpD.tablePrefixSelector)}-controls__button-overlay`,
    DRAG_CONTROLS_INSERT_BUTTON: `${(0, $e6HpD.tablePrefixSelector)}-controls__drag-insert-button`,
    DRAG_CONTROLS_INSERT_BUTTON_INNER: `${(0, $e6HpD.tablePrefixSelector)}-controls__drag-insert-button-inner`,
    DRAG_CONTROLS_INSERT_BUTTON_INNER_COLUMN: `${(0, $e6HpD.tablePrefixSelector)}-controls__drag-insert-button-inner-column`,
    DRAG_CONTROLS_INSERT_BUTTON_INNER_ROW: `${(0, $e6HpD.tablePrefixSelector)}-controls__drag-insert-button-inner-row`,
    DRAG_CONTROLS_INSERT_BUTTON_INNER_ROW_CHROMELESS: `${(0, $e6HpD.tablePrefixSelector)}-controls__drag-insert-button-inner-row-chromeless`,
    DRAG_CONTROLS_INSERT_BUTTON_WRAP: `${(0, $e6HpD.tablePrefixSelector)}-controls__drag-insert-button-wrap`,
    CONTROLS_INSERT_MARKER: `${(0, $e6HpD.tablePrefixSelector)}-controls__insert-marker`,
    CONTROLS_INSERT_COLUMN: `${(0, $e6HpD.tablePrefixSelector)}-controls__insert-column`,
    CONTROLS_INSERT_ROW: `${(0, $e6HpD.tablePrefixSelector)}-controls__insert-row`,
    CONTROLS_DELETE_BUTTON_WRAP: `${(0, $e6HpD.tablePrefixSelector)}-controls__delete-button-wrap`,
    CONTROLS_DELETE_BUTTON: `${(0, $e6HpD.tablePrefixSelector)}-controls__delete-button`,
    CONTROLS_FLOATING_BUTTON_COLUMN: `${(0, $e6HpD.tablePrefixSelector)}-controls-floating__button-column`,
    CONTROLS_FLOATING_BUTTON_ROW: `${(0, $e6HpD.tablePrefixSelector)}-controls-floating__button-row`,
    CORNER_CONTROLS: `${(0, $e6HpD.tablePrefixSelector)}-corner-controls`,
    CORNER_CONTROLS_INSERT_ROW_MARKER: `${(0, $e6HpD.tablePrefixSelector)}-corner-controls__insert-row-marker`,
    CORNER_CONTROLS_INSERT_COLUMN_MARKER: `${(0, $e6HpD.tablePrefixSelector)}-corner-controls__insert-column-marker`,
    CONTROLS_CORNER_BUTTON: `${(0, $e6HpD.tablePrefixSelector)}-corner-button`,
    /** drag and drop controls */ DRAG_ROW_CONTROLS_WRAPPER: `${(0, $e6HpD.tablePrefixSelector)}-drag-row-controls-wrapper`,
    DRAG_ROW_CONTROLS: `${(0, $e6HpD.tablePrefixSelector)}-drag-row-controls`,
    DRAG_ROW_FLOATING_INSERT_DOT_WRAPPER: `${(0, $e6HpD.tablePrefixSelector)}-drag-row-floating-insert-dot-wrapper`,
    DRAG_ROW_FLOATING_INSERT_DOT: `${(0, $e6HpD.tablePrefixSelector)}-drag-row-floating-insert-dot`,
    DRAG_COLUMN_CONTROLS: `${(0, $e6HpD.tablePrefixSelector)}-drag-column-controls`,
    DRAG_COLUMN_FLOATING_INSERT_DOT_WRAPPER: `${(0, $e6HpD.tablePrefixSelector)}-drag-columns-floating-insert-dot-wrapper`,
    DRAG_COLUMN_FLOATING_INSERT_DOT: `${(0, $e6HpD.tablePrefixSelector)}-drag-columns-floating-insert-dot`,
    DRAG_COLUMN_CONTROLS_WRAPPER: `${(0, $e6HpD.tablePrefixSelector)}-col-controls-wrapper`,
    DRAG_COLUMN_DROP_TARGET_CONTROLS: `${(0, $e6HpD.tablePrefixSelector)}-col-drop-target-controls`,
    DRAG_COLUMN_CONTROLS_INNER: `${(0, $e6HpD.tablePrefixSelector)}-col-controls__inner`,
    DRAG_HANDLE_BUTTON_CONTAINER: `${(0, $e6HpD.tablePrefixSelector)}-drag-handle-button-container`,
    DRAG_HANDLE_BUTTON_CLICKABLE_ZONE: `${(0, $e6HpD.tablePrefixSelector)}-drag-handle-button-clickable-zone`,
    DRAG_CORNER_BUTTON: `${(0, $e6HpD.tablePrefixSelector)}-drag-corner-button`,
    DRAG_CORNER_BUTTON_INNER: `${(0, $e6HpD.tablePrefixSelector)}-drag-corner-button-inner`,
    /** nested tables classes */ NESTED_TABLE_WITH_CONTROLS: `${(0, $e6HpD.tablePrefixSelector)}-nested-table-with-controls`,
    /** disabled classes */ DRAG_HANDLE_DISABLED: `${(0, $e6HpD.tablePrefixSelector)}-drag-handle-disabled`,
    /** minimised handle class */ DRAG_HANDLE_MINIMISED: `${(0, $e6HpD.tablePrefixSelector)}-drag-handle-minimised`,
    DRAG_SUBMENU: `${(0, $e6HpD.tablePrefixSelector)}-drag-submenu`,
    DRAG_SUBMENU_ICON: `${(0, $e6HpD.tablePrefixSelector)}-drag-submenu-icon`,
    /** Other classes */ NUMBERED_COLUMN: `${(0, $e6HpD.tablePrefixSelector)}-numbered-column`,
    NUMBERED_COLUMN_BUTTON: `${(0, $e6HpD.tablePrefixSelector)}-numbered-column__button`,
    NUMBERED_COLUMN_BUTTON_DISABLED: `${(0, $e6HpD.tablePrefixSelector)}-numbered-column__button-disabled`,
    HOVERED_COLUMN: `${(0, $e6HpD.tablePrefixSelector)}-hovered-column`,
    HOVERED_ROW: `${(0, $e6HpD.tablePrefixSelector)}-hovered-row`,
    HOVERED_TABLE: `${(0, $e6HpD.tablePrefixSelector)}-hovered-table`,
    HOVERED_NO_HIGHLIGHT: `${(0, $e6HpD.tablePrefixSelector)}-hovered-no-highlight`,
    HOVERED_CELL: `${(0, $e6HpD.tablePrefixSelector)}-hovered-cell`,
    HOVERED_CELL_IN_DANGER: 'danger',
    HOVERED_CELL_ACTIVE: 'active',
    HOVERED_CELL_WARNING: `${(0, $e6HpD.tablePrefixSelector)}-hovered-cell__warning`,
    HOVERED_DELETE_BUTTON: `${(0, $e6HpD.tablePrefixSelector)}-hovered-delete-button`,
    WITH_CONTROLS: `${(0, $e6HpD.tablePrefixSelector)}-with-controls`,
    RESIZING_PLUGIN: `${(0, $e6HpD.tablePrefixSelector)}-resizing-plugin`,
    RESIZE_CURSOR: `${(0, $e6HpD.tablePrefixSelector)}-resize-cursor`,
    IS_RESIZING: `${(0, $e6HpD.tablePrefixSelector)}-is-resizing`,
    RESIZE_HANDLE_DECORATION: `${(0, $e6HpD.tablePrefixSelector)}-resize-decoration`,
    CONTEXTUAL_SUBMENU: `${(0, $e6HpD.tablePrefixSelector)}-contextual-submenu`,
    CONTEXTUAL_MENU_BUTTON_WRAP: `${(0, $e6HpD.tablePrefixSelector)}-contextual-menu-button-wrap`,
    CONTEXTUAL_MENU_BUTTON: `${(0, $e6HpD.tablePrefixSelector)}-contextual-menu-button`,
    CONTEXTUAL_MENU_BUTTON_FIXED: `${(0, $e6HpD.tablePrefixSelector)}-contextual-menu-button-fixed`,
    CONTEXTUAL_MENU_ICON: `${(0, $e6HpD.tablePrefixSelector)}-contextual-submenu-icon`,
    CONTEXTUAL_MENU_ICON_SMALL: `${(0, $e6HpD.tablePrefixSelector)}-contextual-submenu-icon-small`,
    // come from prosemirror-table
    SELECTED_CELL: 'selectedCell',
    // defined in ReactNodeView based on PM node name
    NODEVIEW_WRAPPER: 'tableView-content-wrap',
    TABLE_SELECTED: `${(0, $e6HpD.tablePrefixSelector)}-table__selected`,
    TABLE_CELL: (0, $e6HpD.tableCellSelector),
    TABLE_HEADER_CELL: (0, $e6HpD.tableHeaderSelector),
    TABLE_STICKY: `${(0, $e6HpD.tablePrefixSelector)}-sticky`,
    TABLE_CHROMELESS: `${(0, $e6HpD.tablePrefixSelector)}-chromeless`,
    TOP_LEFT_CELL: 'table > tbody > tr:nth-child(2) > td:nth-child(1)',
    LAST_ITEM_IN_CELL: `${(0, $e6HpD.tablePrefixSelector)}-last-item-in-cell`,
    WITH_COLUMN_INSERT_LINE: `${(0, $e6HpD.tablePrefixSelector)}-column-insert-line`,
    WITH_COLUMN_INSERT_LINE_INACTIVE: `${(0, $e6HpD.tablePrefixSelector)}-column-insert-line__inactive`,
    WITH_FIRST_COLUMN_INSERT_LINE: `${(0, $e6HpD.tablePrefixSelector)}-first-column-insert-line`,
    WITH_FIRST_COLUMN_INSERT_LINE_INACTIVE: `${(0, $e6HpD.tablePrefixSelector)}-first-column-insert-line__inactive`,
    WITH_LAST_COLUMN_INSERT_LINE: `${(0, $e6HpD.tablePrefixSelector)}-last-column-insert-line`,
    WITH_LAST_COLUMN_INSERT_LINE_INACTIVE: `${(0, $e6HpD.tablePrefixSelector)}-last-column-insert-line__inactive`,
    WITH_RESIZE_LINE: `${(0, $e6HpD.tablePrefixSelector)}-column-resize-line`,
    WITH_RESIZE_LINE_LAST_COLUMN: `${(0, $e6HpD.tablePrefixSelector)}-column-resize-line-last-column`,
    WITH_DRAG_RESIZE_LINE: `${(0, $e6HpD.tablePrefixSelector)}-drag-column-resize-line`,
    WITH_DRAG_RESIZE_LINE_LAST_COLUMN: `${(0, $e6HpD.tablePrefixSelector)}-drag-column-resize-line-last-column`,
    WITH_ROW_INSERT_LINE: `${(0, $e6HpD.tablePrefixSelector)}-row-insert-line`,
    WITH_ROW_INSERT_LINE_INACTIVE: `${(0, $e6HpD.tablePrefixSelector)}-row-insert-line__inactive`,
    WITH_LAST_ROW_INSERT_LINE: `${(0, $e6HpD.tablePrefixSelector)}-last-row-insert-line`,
    WITH_LAST_ROW_INSERT_LINE_INACTIVE: `${(0, $e6HpD.tablePrefixSelector)}-last-row-insert-line__inactive`
};
var $fdf40ec48390ab73$export$ce63d9b315ac58c9 = /*#__PURE__*/ function(ShadowEvent) {
    ShadowEvent["SHOW_BEFORE_SHADOW"] = "showBeforeShadow";
    ShadowEvent["SHOW_AFTER_SHADOW"] = "showAfterShadow";
    return ShadowEvent;
}({});

});


parcelRegister("bZI5M", function(module, exports) {

$parcel$export(module.exports, "tableMarginFullWidthMode", () => (parcelRequire("fsO0s")).tableMarginFullWidthMode);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $fsO0s = parcelRequire("fsO0s");

});
parcelRegister("fsO0s", function(module, exports) {

$parcel$export(module.exports, "tableCellBackgroundColor", () => $487027b5f980591c$export$3efa753685336605);
$parcel$export(module.exports, "tableHeaderCellBackgroundColor", () => $487027b5f980591c$export$95883e661e73a1d1);
$parcel$export(module.exports, "tableTextColor", () => $487027b5f980591c$export$14da8da34a807702);
$parcel$export(module.exports, "tableBorderColor", () => $487027b5f980591c$export$60473ec4f7c2b794);
$parcel$export(module.exports, "tableCellSelectedColor", () => $487027b5f980591c$export$f26d047169b4195d);
$parcel$export(module.exports, "tableToolbarSelectedColor", () => $487027b5f980591c$export$8c5dd0fc35774ae1);
$parcel$export(module.exports, "tableBorderSelectedColor", () => $487027b5f980591c$export$9bf0891aaaf2fecb);
$parcel$export(module.exports, "tableCellSelectedDeleteIconColor", () => $487027b5f980591c$export$a699493d7d7580c3);
$parcel$export(module.exports, "tableCellSelectedDeleteIconBackground", () => $487027b5f980591c$export$cd5e5900c9fa42dc);
$parcel$export(module.exports, "tableCellDeleteColor", () => $487027b5f980591c$export$3c2a828febe9d506);
$parcel$export(module.exports, "tableBorderDeleteColor", () => $487027b5f980591c$export$870d72a5700e711d);
$parcel$export(module.exports, "tableToolbarDeleteColor", () => $487027b5f980591c$export$e7bba7ffd7bf3c50);
$parcel$export(module.exports, "tableCellHoverDeleteIconColor", () => $487027b5f980591c$export$6cc2aa96833a5989);
$parcel$export(module.exports, "tableCellHoverDeleteIconBackground", () => $487027b5f980591c$export$9907ca2ad437ddcc);
$parcel$export(module.exports, "tableBorderRadiusSize", () => $487027b5f980591c$export$371da7842ff35a5b);
$parcel$export(module.exports, "tablePadding", () => $487027b5f980591c$export$e5ff276883773ffd);
$parcel$export(module.exports, "tableScrollbarOffset", () => $487027b5f980591c$export$92421f8864c287b1);
$parcel$export(module.exports, "tableMarginFullWidthMode", () => $487027b5f980591c$export$cbcfa4314b903419);
$parcel$export(module.exports, "tableInsertColumnButtonSize", () => $487027b5f980591c$export$6d23b13c5fcb846c);
$parcel$export(module.exports, "tableDeleteButtonSize", () => $487027b5f980591c$export$cb376ed67c7ae37e);
$parcel$export(module.exports, "tableDeleteButtonOffset", () => $487027b5f980591c$export$52b432855099b8bd);
$parcel$export(module.exports, "tableToolbarSize", () => $487027b5f980591c$export$a4d60e31f4f6188b);
$parcel$export(module.exports, "tableControlsSpacing", () => $487027b5f980591c$export$880976487022eb5);
$parcel$export(module.exports, "tableInsertColumnButtonOffset", () => $487027b5f980591c$export$73b1242ebdcc73be);
$parcel$export(module.exports, "lineMarkerSize", () => $487027b5f980591c$export$a3e71c692f2c2213);
$parcel$export(module.exports, "columnControlsDecorationHeight", () => $487027b5f980591c$export$62374dd2f63076b0);
$parcel$export(module.exports, "columnControlsZIndex", () => $487027b5f980591c$export$da0ccd381b1a80f);
$parcel$export(module.exports, "columnControlsSelectedZIndex", () => $487027b5f980591c$export$83da30a15600a83e);
$parcel$export(module.exports, "rowControlsZIndex", () => $487027b5f980591c$export$45aeeddcedd441ab);
$parcel$export(module.exports, "insertLineWidth", () => $487027b5f980591c$export$cc7ed656b7dcf729);
$parcel$export(module.exports, "resizeHandlerAreaWidth", () => $487027b5f980591c$export$72409f838e9c33c7);
$parcel$export(module.exports, "resizeLineWidth", () => $487027b5f980591c$export$45d9825f76985b4e);
$parcel$export(module.exports, "resizeHandlerZIndex", () => $487027b5f980591c$export$887c1388be90c08e);
$parcel$export(module.exports, "contextualMenuTriggerSize", () => $487027b5f980591c$export$3969371f057ce1e5);
$parcel$export(module.exports, "contextualMenuDropdownWidth", () => $487027b5f980591c$export$a6ed027d1a83416d);
$parcel$export(module.exports, "contextualMenuDropdownWidthDnD", () => $487027b5f980591c$export$42d9040c5091b076);
$parcel$export(module.exports, "stickyRowZIndex", () => $487027b5f980591c$export$1279af870a198fea);
$parcel$export(module.exports, "stickyRowOffsetTop", () => $487027b5f980591c$export$83c60dd0aac17107);
$parcel$export(module.exports, "stickyHeaderBorderBottomWidth", () => $487027b5f980591c$export$13b0e72269a9a3aa);
$parcel$export(module.exports, "tableOverflowShadowWidth", () => $487027b5f980591c$export$40311377f05dbfc4);
$parcel$export(module.exports, "tableOverflowShadowWidthWide", () => $487027b5f980591c$export$1680d391e1ce7b96);
$parcel$export(module.exports, "tablePopupMenuFitHeight", () => $487027b5f980591c$export$3cdde837cf189e96);
$parcel$export(module.exports, "dropTargetsZIndex", () => $487027b5f980591c$export$b2015400488f9243);
$parcel$export(module.exports, "TABLE_SNAP_GAP", () => $487027b5f980591c$export$8f6133b6e2b4291);
$parcel$export(module.exports, "TABLE_HIGHLIGHT_GAP", () => $487027b5f980591c$export$edb1b9caf8ff5b32);
$parcel$export(module.exports, "TABLE_HIGHLIGHT_TOLERANCE", () => $487027b5f980591c$export$7af5c65e392a647);
$parcel$export(module.exports, "TABLE_GUIDELINE_VISIBLE_ADJUSTMENT", () => $487027b5f980591c$export$858d012f03ae70a5);
$parcel$export(module.exports, "TABLE_DRAG_MENU_SORT_GROUP_HEIGHT", () => $487027b5f980591c$export$a13bd817a2eda041);
$parcel$export(module.exports, "TABLE_DRAG_MENU_PADDING_TOP", () => $487027b5f980591c$export$e0140c2b978caac5);
$parcel$export(module.exports, "TABLE_DRAG_MENU_MENU_GROUP_BEFORE_HEIGHT", () => $487027b5f980591c$export$c6a9e7014cf7aedc);
$parcel$export(module.exports, "dragMenuDropdownWidth", () => $487027b5f980591c$export$963fb187132ee7cf);
$parcel$export(module.exports, "dragTableInsertColumnButtonSize", () => $487027b5f980591c$export$d18320cc8ee69115);
$parcel$export(module.exports, "dropTargetExtendedWidth", () => $487027b5f980591c$export$6bec1f8a2aa82be8);
$parcel$export(module.exports, "colorPalletteColumns", () => $487027b5f980591c$export$2c18704a8d793cdb);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $cjLtO = parcelRequire("cjLtO");

var $7yBx7 = parcelRequire("7yBx7");


var $dzEzE = parcelRequire("dzEzE");
const $487027b5f980591c$export$3efa753685336605 = `var(--ds-surface, ${(0, $7bb4c1736002a04a$export$29a4f05edc054374)})`;
const $487027b5f980591c$export$95883e661e73a1d1 = `var(--ds-background-accent-gray-subtlest, ${(0, $7yBx7.akEditorTableHeaderCellBackground)})`;
const $487027b5f980591c$export$1b578d7ab4fc0385 = `var(--ds-background-neutral-subtle, ${(0, $7yBx7.akEditorTableToolbar)})`;
const $487027b5f980591c$export$14da8da34a807702 = `var(--ds-text-subtlest, ${(0, $7bb4c1736002a04a$export$f563ee71e9ee74cd)})`;
const $487027b5f980591c$export$60473ec4f7c2b794 = `var(--ds-background-accent-gray-subtler, ${(0, $7yBx7.akEditorTableBorder)})`;
const $487027b5f980591c$export$5aac4cb73ae3f2da = `var(--ds-background-neutral, ${(0, $7bb4c1736002a04a$export$9fdfb749e33cdf97)})`;
const $487027b5f980591c$export$f26d047169b4195d = `var(--ds-blanket-selected, ${(0, $7yBx7.akEditorTableCellBlanketSelected)})`;
const $487027b5f980591c$export$8c5dd0fc35774ae1 = `var(--ds-background-selected-pressed, ${(0, $7bb4c1736002a04a$export$215b7063051591f1)})`;
const $487027b5f980591c$export$9bf0891aaaf2fecb = `var(--ds-border-focused, ${(0, $7yBx7.akEditorTableBorderSelected)})`;
const $487027b5f980591c$export$a699493d7d7580c3 = `var(--ds-icon-subtle, ${(0, $7bb4c1736002a04a$export$e2ef2124cf4024b1)})`;
const $487027b5f980591c$export$cd5e5900c9fa42dc = `var(--ds-background-accent-gray-subtlest, ${(0, $7bb4c1736002a04a$export$8d43898f60b96a82)})`;
const $487027b5f980591c$export$3c2a828febe9d506 = `var(--ds-blanket-danger, ${(0, $7yBx7.akEditorTableCellBlanketDeleted)})`;
const $487027b5f980591c$export$870d72a5700e711d = `var(--ds-border-danger, ${(0, $7bb4c1736002a04a$export$2010d0fb4295b346)})`;
const $487027b5f980591c$export$e7bba7ffd7bf3c50 = `var(--ds-background-danger-pressed, ${(0, $7bb4c1736002a04a$export$b34b069eff244586)})`;
const $487027b5f980591c$export$6cc2aa96833a5989 = "var(--ds-icon-inverse, white)";
const $487027b5f980591c$export$9907ca2ad437ddcc = `var(--ds-background-danger-bold, ${(0, $7bb4c1736002a04a$export$4a7404f376229999)})`;
const $487027b5f980591c$export$371da7842ff35a5b = 3;
const $487027b5f980591c$export$e5ff276883773ffd = 8;
const $487027b5f980591c$export$92421f8864c287b1 = 15;
const $487027b5f980591c$export$cbcfa4314b903419 = 2;
const $487027b5f980591c$export$6d23b13c5fcb846c = 20;
const $487027b5f980591c$export$cb376ed67c7ae37e = 16;
const $487027b5f980591c$export$52b432855099b8bd = 6;
const $487027b5f980591c$export$a4d60e31f4f6188b = (0, $7yBx7.akEditorTableToolbarSize);
const $487027b5f980591c$export$880976487022eb5 = (0, $cjLtO.tableMarginTop) + $487027b5f980591c$export$e5ff276883773ffd - (0, $cjLtO.tableCellBorderWidth);
const $487027b5f980591c$export$73b1242ebdcc73be = 3;
const $487027b5f980591c$export$86dfc955b6099b88 = 32;
const $487027b5f980591c$export$893fc0cfd2a0c40e = 13;
const $487027b5f980591c$export$a3e71c692f2c2213 = 4;
const $487027b5f980591c$export$62374dd2f63076b0 = 25;
const $487027b5f980591c$export$da0ccd381b1a80f = (0, $7yBx7.akEditorUnitZIndex) * 10;
const $487027b5f980591c$export$83da30a15600a83e = $487027b5f980591c$export$da0ccd381b1a80f + 1;
const $487027b5f980591c$export$45aeeddcedd441ab = (0, $7yBx7.akEditorUnitZIndex) * 10;
const $487027b5f980591c$export$5b53cc051bf05434 = $487027b5f980591c$export$83da30a15600a83e + 1;
const $487027b5f980591c$export$cc7ed656b7dcf729 = 3;
const $487027b5f980591c$export$72409f838e9c33c7 = (0, $dzEzE.RESIZE_HANDLE_AREA_DECORATION_GAP) / 3;
const $487027b5f980591c$export$45d9825f76985b4e = 2;
const $487027b5f980591c$export$887c1388be90c08e = $487027b5f980591c$export$da0ccd381b1a80f + (0, $7yBx7.akRichMediaResizeZIndex);
const $487027b5f980591c$export$3969371f057ce1e5 = 16;
const $487027b5f980591c$export$a6ed027d1a83416d = 180;
const $487027b5f980591c$export$42d9040c5091b076 = 250;
const $487027b5f980591c$export$1279af870a198fea = $487027b5f980591c$export$887c1388be90c08e + 2;
const $487027b5f980591c$export$83c60dd0aac17107 = 8;
const $487027b5f980591c$export$13b0e72269a9a3aa = 1;
const $487027b5f980591c$export$40311377f05dbfc4 = 8;
const $487027b5f980591c$export$1680d391e1ce7b96 = 32;
const $487027b5f980591c$export$3cdde837cf189e96 = 188;
const $487027b5f980591c$export$b2015400488f9243 = 14;
const $487027b5f980591c$export$8f6133b6e2b4291 = 9;
const $487027b5f980591c$export$edb1b9caf8ff5b32 = 10;
const $487027b5f980591c$export$7af5c65e392a647 = 2;
const $487027b5f980591c$export$11cf30061861ec4a = 5;
const $487027b5f980591c$export$858d012f03ae70a5 = -68;
const $487027b5f980591c$export$a13bd817a2eda041 = 92;
const $487027b5f980591c$export$e0140c2b978caac5 = 4;
const $487027b5f980591c$export$c6a9e7014cf7aedc = 6;
const $487027b5f980591c$export$963fb187132ee7cf = 250;
const $487027b5f980591c$export$d18320cc8ee69115 = 16;
const $487027b5f980591c$export$6bec1f8a2aa82be8 = 150;
const $487027b5f980591c$export$2c18704a8d793cdb = 7;
const $487027b5f980591c$export$150cd2564fec30b7 = 8;

});



parcelRegister("3RA4L", function(module, exports) {

$parcel$export(module.exports, "mediaStyles", () => $6573923f8c94101a$export$abd2efc27ac7e809);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $dA9km = parcelRequire("dA9km");

var $laqWo = parcelRequire("laqWo");

var $7yBx7 = parcelRequire("7yBx7");

var $jbnQ0 = parcelRequire("jbnQ0");
const $6573923f8c94101a$export$abd2efc27ac7e809 = ()=>/*#__PURE__*/ (0, $1NIU8.css)(".ProseMirror{", (0, $laqWo.mediaSingleSharedStyleNew), " & [layout='full-width'] .", (0, $laqWo.richMediaClassName), ",& [layout='wide'] .", (0, $laqWo.richMediaClassName), "{margin-left:50%;transform:translateX(-50%);}.media-extended-resize-experience[layout^='wrap-']{overflow:visible!important;}& [layout^='wrap-']+[layout^='wrap-']{clear:none;&+p,&+div[class^='fabric-editor-align'],&+ul,&+ol,&+h1,&+h2,&+h3,&+h4,&+h5,&+h6{clear:both!important;}& .", (0, $laqWo.richMediaClassName), "{margin-left:0;margin-right:0;}}", (0, $dA9km.mediaInlineImageStyles), " .mediaSingleView-content-wrap[layout^='wrap-']{max-width:100%;clear:inherit;}.mediaSingleView-content-wrap[layout='wrap-left']{float:left;}.mediaSingleView-content-wrap[layout='wrap-right']{float:right;}.mediaSingleView-content-wrap[layout='wrap-right']+.mediaSingleView-content-wrap[layout='wrap-left']{clear:both;}&>.mediaSingleView-content-wrap{.richMedia-resize-handle-right{margin-right:-", (0, $7yBx7.akEditorMediaResizeHandlerPaddingWide), "px;}.richMedia-resize-handle-left{margin-left:-", (0, $7yBx7.akEditorMediaResizeHandlerPaddingWide), "px;}}}.richMedia-resize-handle-right,.richMedia-resize-handle-left{display:flex;flex-direction:column;justify-content:center;}.richMedia-resize-handle-right{align-items:flex-end;padding-right:var(--ds-space-150, 12px);margin-right:-", (0, $7yBx7.akEditorMediaResizeHandlerPadding), "px;}.richMedia-resize-handle-left{align-items:flex-start;padding-left:var(--ds-space-150, 12px);margin-left:-", (0, $7yBx7.akEditorMediaResizeHandlerPadding), "px;}.richMedia-resize-handle-right::after,.richMedia-resize-handle-left::after{content:' ';display:flex;width:3px;height:64px;border-radius:6px;}.", (0, $laqWo.richMediaClassName), ":hover .richMedia-resize-handle-left::after,.", (0, $laqWo.richMediaClassName), ":hover .richMedia-resize-handle-right::after{background:var(--ds-border, #091E4224);}.", (0, $7yBx7.akEditorSelectedNodeClassName), " .richMedia-resize-handle-right::after,.", (0, $7yBx7.akEditorSelectedNodeClassName), " .richMedia-resize-handle-left::after,.", (0, $laqWo.richMediaClassName), " .richMedia-resize-handle-right:hover::after,.", (0, $laqWo.richMediaClassName), " .richMedia-resize-handle-left:hover::after,.", (0, $laqWo.richMediaClassName), ".is-resizing .richMedia-resize-handle-right::after,.", (0, $laqWo.richMediaClassName), ".is-resizing .richMedia-resize-handle-left::after{background:var(--ds-border-focused, #388BFF);}.__resizable_base__{left:unset!important;width:auto!important;height:auto!important;}.danger>div>div>.media-card-frame,.danger>span>a{background-color:", `var(--ds-background-danger, ${(0, $7yBx7.akEditorDeleteBackground)})`, ";box-shadow:0px 0px 0px ", (0, $7yBx7.akEditorSelectedBorderBoldSize), "px ", `var(--ds-border-danger, ${(0, $7yBx7.akEditorDeleteBorder)})`, ";transition:background-color 0s,box-shadow 0s;}.danger{.", (0, $laqWo.richMediaClassName), " .", (0, $87b212d64266f221$export$7a6526d4be3b7eb3), "::after{border:1px solid ", `var(--ds-border-danger, ${(0, $7yBx7.akEditorDeleteIconColor)})`, ";}.", (0, $laqWo.richMediaClassName), " .", (0, $jbnQ0.inlinePlayerClassName), "::after{border:1px solid ", `var(--ds-border-danger, ${(0, $7yBx7.akEditorDeleteIconColor)})`, ";}.", (0, $laqWo.richMediaClassName), " .", (0, $c214caf0b65ba182$export$c5ba918dbb0b00f3), "{box-shadow:0 0 0 1px ", `var(--ds-border-danger, ${(0, $7yBx7.akEditorDeleteIconColor)})`, "!important;}.richMedia-resize-handle-right::after,.richMedia-resize-handle-left::after{background:", `var(--ds-icon-danger, ${(0, $7yBx7.akEditorDeleteIconColor)})`, "!important;}.resizer-handle-thumb{background:", `var(--ds-icon-danger, ${(0, $7yBx7.akEditorDeleteIconColor)})`, "!important;}div div .media-card-frame,.inlineCardView-content-wrap>span>a{background-color:var(--ds-blanket-danger, rgb(255, 189, 173, 0.5));transition:background-color 0s;}div div .media-card-frame::after{box-shadow:none;}}.warning{.", (0, $laqWo.richMediaClassName), " .", (0, $87b212d64266f221$export$7a6526d4be3b7eb3), "::after{border:1px solid var(--ds-border-warning, #E56910);}.", (0, $laqWo.richMediaClassName), " .", (0, $jbnQ0.inlinePlayerClassName), "::after{border:1px solid var(--ds-border-warning, #E56910);}.", (0, $laqWo.richMediaClassName), " .", (0, $c214caf0b65ba182$export$c5ba918dbb0b00f3), "{box-shadow:0 0 0 1px var(--ds-border-warning, #E56910)!important;}.resizer-handle-thumb{background:var(--ds-icon-warning, #E56910)!important;}}.media-filmstrip-list-item{cursor:pointer;}.mediaGroupView-content-wrap.", (0, $7yBx7.akEditorSelectedNodeClassName), " #newFileExperienceWrapper{box-shadow:", (0, $7yBx7.akEditorSelectedBoxShadow), ";}"); /* `left: unset` above is to work around Chrome bug where rendering a div with
 * that style applied inside a container that has a scroll, causes any svgs on
 * the page, without a border, that are inside a flexbox, to no longer align to
 * the center of their viewbox.
 *
 * for us, this means that all the toolbar icons start jumping around if
 * you make the viewport small
 */ 

});
parcelRegister("jbnQ0", function(module, exports) {

$parcel$export(module.exports, "inlinePlayerClassName", () => $3a69e8a96f043606$export$70bc5d30fe886af);
$parcel$export(module.exports, "inlinePlayerWrapperStyles", () => $3a69e8a96f043606$export$bffd1a8ecf8d5d06);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $IW7jS = parcelRequire("IW7jS");

var $28sr0 = parcelRequire("28sr0");

var $2N2k8 = parcelRequire("2N2k8");
var $egs2l = parcelRequire("egs2l");
/*
 * Used to display the blue border around a selected card without
 * shrinking the image OR growing the card size
 */ const $3a69e8a96f043606$var$getSelectedBorderStyle = ({ selected: selected })=>`
    ${selected ? (0, $2N2k8.hideNativeBrowserTextSelectionStyles) : ''}

    &::after {
      content: '';
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      box-sizing: border-box;
      pointer-events: none;
      ${0, $IW7jS.borderRadius}
      ${selected ? (0, $2N2k8.getSelectionStyles)([
        (0, $egs2l.SelectionStyle).Border
    ]) : ''}
    }
  `;
const $3a69e8a96f043606$export$70bc5d30fe886af = 'media-card-inline-player';
const $3a69e8a96f043606$export$bffd1a8ecf8d5d06 = ({ dimensions: dimensions, selected: selected })=>/*#__PURE__*/ (0, $1NIU8.css)("width:", (0, $28sr0.getDimensionsWithDefault)(dimensions).width || '100%', ";height:", (0, $28sr0.getDimensionsWithDefault)(dimensions).height || 'auto', ";overflow:hidden;border-radius:", (0, $IW7jS.borderRadius)(), "px;position:relative;max-width:100%;max-height:100%;", $3a69e8a96f043606$var$getSelectedBorderStyle(selected), " video{width:100%;height:100%;}");
$3a69e8a96f043606$export$bffd1a8ecf8d5d06.displayName = 'InlinePlayerWrapper';

});
parcelRegister("28sr0", function(module, exports) {

$parcel$export(module.exports, "getDimensionsWithDefault", () => $61071ab5121234d6$export$36acad525b1fb57b);
const $61071ab5121234d6$export$36acad525b1fb57b = (dimensions = {
    width: '100%',
    height: '100%'
})=>{
    return {
        height: typeof dimensions.height === 'number' ? `${dimensions.height}px` : dimensions.height,
        width: typeof dimensions.width === 'number' ? `${dimensions.width}px` : dimensions.width
    };
};

});


const $c214caf0b65ba182$export$c5ba918dbb0b00f3 = 'new-file-experience-wrapper';


parcelRegister("g3llj", function(module, exports) {

$parcel$export(module.exports, "panelStyles", () => $b01128650c56e11b$export$8290cf129669d0cb);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $7kf0Z = parcelRequire("7kf0Z");

var $7yBx7 = parcelRequire("7yBx7");
var $2N2k8 = parcelRequire("2N2k8");
var $egs2l = parcelRequire("egs2l");

var $eGOwo = parcelRequire("eGOwo");
const $b01128650c56e11b$export$8290cf129669d0cb = ()=>/*#__PURE__*/ (0, $1NIU8.css)(".ProseMirror{", (0, $7kf0Z.panelSharedStyles)(), ";.", (0, $7kf0Z.PanelSharedCssClassName).prefix, "{cursor:pointer;&.danger{box-shadow:0 0 0 ", (0, $7yBx7.akEditorSelectedBorderSize), "px ", (0, $7yBx7.akEditorDeleteBorder), ";background-color:", `var(--ds-background-danger, ${(0, $7yBx7.akEditorDeleteBackground)})`, "!important;.", (0, $7kf0Z.PanelSharedCssClassName).icon, "{color:", `var(--ds-icon-danger, ${(0, $7yBx7.akEditorDeleteIconColor)})`, "!important;}}}.", (0, $7kf0Z.PanelSharedCssClassName).content, "{cursor:text;}.danger .", (0, $7kf0Z.PanelSharedCssClassName).prefix, "{&[data-panel-type]{background-color:", `var(--ds-blanket-danger, ${(0, $7yBx7.akEditorDeleteBackgroundWithOpacity)})`, ";.", (0, $7kf0Z.PanelSharedCssClassName).icon, "{color:", `var(--ds-icon-danger, ${(0, $7yBx7.akEditorDeleteIconColor)})`, ";}}}}.", (0, $7kf0Z.PanelSharedCssClassName).prefix, ".", (0, $7yBx7.akEditorSelectedNodeClassName), ":not(.danger){", (0, $2N2k8.getSelectionStyles)([
        (0, $egs2l.SelectionStyle).BoxShadow,
        (0, $egs2l.SelectionStyle).Blanket
    ]), ";}", (0, $eGOwo.fg)('platform_editor_nested_dnd_styles_changes') && `.ak-editor-content-area.appearance-full-page .ProseMirror {
		.ak-editor-panel .${(0, $7kf0Z.PanelSharedCssClassName).icon} {
			padding-right: ${"var(--ds-space-150, 12px)"};
		}

		.ak-editor-panel.${(0, $7kf0Z.PanelSharedCssClassName).noIcon} {
			padding-left: ${"var(--ds-space-250, 20px)"};
			padding-right: ${"var(--ds-space-250, 20px)"};
		}
	}`, ";", (0, $eGOwo.fg)('platform_editor_nested_dnd_styles_changes') && `.ak-editor-content-area .ak-editor-content-area .ProseMirror {
		.ak-editor-panel .${(0, $7kf0Z.PanelSharedCssClassName).icon} {
			padding-right: ${"var(--ds-space-100, 8px)"};
		}
		.ak-editor-panel.${(0, $7kf0Z.PanelSharedCssClassName).noIcon} {
			padding-right: ${"var(--ds-space-150, 12px)"};
			padding-left: ${"var(--ds-space-150, 12px)"};
		}
	}`, ";");

});

parcelRegister("llrTf", function(module, exports) {

$parcel$export(module.exports, "statusNodeStyles", () => $4933f768cc6d0e01$export$7133824bb2b7920a);
$parcel$export(module.exports, "statusStyles", () => $4933f768cc6d0e01$export$79c8c9ad308bbe07);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $goGls = parcelRequire("goGls");
var $cjLtO = parcelRequire("cjLtO");

var $7yBx7 = parcelRequire("7yBx7");
var $2N2k8 = parcelRequire("2N2k8");
var $egs2l = parcelRequire("egs2l");

var $eGOwo = parcelRequire("eGOwo");

var $9Letn = parcelRequire("9Letn");
function $4933f768cc6d0e01$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $4933f768cc6d0e01$var$getVisualRefreshStatusStyles = ()=>// eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    (0, $eGOwo.fg)('platform-component-visual-refresh') ? (0, $9Letn.expValEqualsNoExposure)('platform_editor_find_and_replace_improvements', 'isEnabled', true) && (0, $eGOwo.fg)('platform_editor_find_and_replace_improvements_1') ? /*#__PURE__*/ (0, $1NIU8.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values,  @atlaskit/ui-styling-standard/no-imported-style-values
        [`&.${0, $7yBx7.akEditorSelectedNodeClassName}:not('.search-match-block') .${(0, $goGls.StatusSharedCssClassName).STATUS_LOZENGE} > span`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            boxShadow: (0, $7yBx7.akEditorSelectedBoldBoxShadow)
        }
    }) : /*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    (0, $1NIU8.css)("&.", (0, $7yBx7.akEditorSelectedNodeClassName), " .", (0, $goGls.StatusSharedCssClassName).STATUS_LOZENGE, ">span{box-shadow:", (0, $7yBx7.akEditorSelectedBoldBoxShadow), ";}") : (0, $9Letn.expValEqualsNoExposure)('platform_editor_find_and_replace_improvements', 'isEnabled', true) && (0, $eGOwo.fg)('platform_editor_find_and_replace_improvements_1') ? /*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    (0, $1NIU8.css)("&.", (0, $7yBx7.akEditorSelectedNodeClassName), ":not('.search-match-block') .", (0, $goGls.StatusSharedCssClassName).STATUS_LOZENGE, ">span{", (0, $2N2k8.getSelectionStyles)([
        (0, $egs2l.SelectionStyle).BoxShadow
    ]), ";}") : /*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    (0, $1NIU8.css)("&.", (0, $7yBx7.akEditorSelectedNodeClassName), " .", (0, $goGls.StatusSharedCssClassName).STATUS_LOZENGE, ">span{", (0, $2N2k8.getSelectionStyles)([
        (0, $egs2l.SelectionStyle).BoxShadow
    ]), ";}");
var $4933f768cc6d0e01$var$_ref = {
    name: "1lp1zoq",
    styles: "[data-prosemirror-node-name=\"status\"] > [data-color=neutral] .lozenge-wrapper{background-color:var(--ds-background-neutral, #091E420F);}[data-prosemirror-node-name=\"status\"] > [data-color=neutral] .lozenge-text{color:var(--ds-text-subtle, #44546F);}[data-prosemirror-node-name=\"status\"] > [data-color=purple] .lozenge-wrapper{background-color:var(--ds-background-discovery, #F3F0FF);}[data-prosemirror-node-name=\"status\"] > [data-color=purple] .lozenge-text{color:var(--ds-text-discovery, #5E4DB2);}[data-prosemirror-node-name=\"status\"] > [data-color=blue] .lozenge-wrapper{background-color:var(--ds-background-information, #E9F2FF);}[data-prosemirror-node-name=\"status\"] > [data-color=blue] .lozenge-text{color:var(--ds-text-information, #0055CC);}[data-prosemirror-node-name=\"status\"] > [data-color=yellow] .lozenge-wrapper{background-color:var(--ds-background-warning, #FFF7D6);}[data-prosemirror-node-name=\"status\"] > [data-color=yellow] .lozenge-text{color:var(--ds-text-warning, #A54800);}[data-prosemirror-node-name=\"status\"] > [data-color=red] .lozenge-wrapper{background-color:var(--ds-background-danger, #FFECEB);}[data-prosemirror-node-name=\"status\"] > [data-color=red] .lozenge-text{color:var(--ds-text-danger, #AE2E24);}[data-prosemirror-node-name=\"status\"] > [data-color=green] .lozenge-wrapper{background-color:var(--ds-background-success, #DCFFF1);}[data-prosemirror-node-name=\"status\"] > [data-color=green] .lozenge-text{color:var(--ds-text-success, #216E4E);}"
};
var $4933f768cc6d0e01$var$_ref2 = {
    name: "1ty5u6z",
    styles: "[data-prosemirror-node-name=\"status\"] .lozenge-text{color:#292A2E;}[data-prosemirror-node-name=\"status\"] > [data-color=neutral] > .lozenge-wrapper{background-color:#DDDEE1;}[data-prosemirror-node-name=\"status\"] > [data-color=purple] > .lozenge-wrapper{background-color:#D8A0F7;}[data-prosemirror-node-name=\"status\"] > [data-color=blue] > .lozenge-wrapper{background-color:#8FB8F6;}[data-prosemirror-node-name=\"status\"] > [data-color=yellow] > .lozenge-wrapper{background-color:#F9C84E;}[data-prosemirror-node-name=\"status\"] > [data-color=red] > .lozenge-wrapper{background-color:#FD9891;}[data-prosemirror-node-name=\"status\"] > [data-color=green] > .lozenge-wrapper{background-color:#B3DF72;}"
};
const $4933f768cc6d0e01$var$getStatusColors = ()=>(0, $eGOwo.fg)('platform-component-visual-refresh') ? $4933f768cc6d0e01$var$_ref2 : $4933f768cc6d0e01$var$_ref;
const $4933f768cc6d0e01$var$baseStatusStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-neutral, #091E420F)",
        maxWidth: '100%',
        paddingInline: "var(--ds-space-050, 4px)",
        display: 'inline-flex',
        borderRadius: '3px',
        blockSize: 'min-content',
        position: 'static',
        overflow: 'hidden',
        boxSizing: 'border-box',
        appearance: 'none',
        border: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] .lozenge-text': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '11px',
        fontStyle: 'normal',
        fontFamily: "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        fontWeight: "var(--ds-font-weight-bold, 700)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: '16px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        textTransform: 'uppercase',
        whiteSpace: 'nowrap',
        maxWidth: `calc(200px - ${"var(--ds-space-100, 8px)"})`
    }
});
const $4933f768cc6d0e01$export$7133824bb2b7920a = ()=>/*#__PURE__*/ (0, $1NIU8.css)($4933f768cc6d0e01$var$baseStatusStyles, " ", $4933f768cc6d0e01$var$getStatusColors(), ";");
const $4933f768cc6d0e01$export$79c8c9ad308bbe07 = ()=>/*#__PURE__*/ (0, $1NIU8.css)(".", (0, $cjLtO.TableSharedCssClassName).TABLE_CELL_WRAPPER, ",.", (0, $cjLtO.TableSharedCssClassName).TABLE_HEADER_CELL_WRAPPER, ",[data-layout-section]{.", (0, $goGls.StatusSharedCssClassName).STATUS_CONTAINER, "{max-width:100%;line-height:0;>span{width:100%;}}}.", (0, $goGls.StatusSharedCssClassName).STATUS_CONTAINER, "{", $4933f768cc6d0e01$var$getVisualRefreshStatusStyles(), ";>span{cursor:pointer;line-height:0;}}.danger{.", (0, $goGls.StatusSharedCssClassName).STATUS_LOZENGE, ">span{background-color:", (0, $7yBx7.akEditorDeleteBackgroundWithOpacity), ";}.", (0, $goGls.StatusSharedCssClassName).STATUS_CONTAINER, ".", (0, $7yBx7.akEditorSelectedNodeClassName), " .", (0, $goGls.StatusSharedCssClassName).STATUS_LOZENGE, ">span{box-shadow:0 0 0 ", (0, $7yBx7.akEditorSelectedBorderSize), "px ", (0, $7yBx7.akEditorDeleteBorder), ";}}");

});
parcelRegister("goGls", function(module, exports) {

$parcel$export(module.exports, "StatusSharedCssClassName", () => $1ed853d931a9d2a3$export$b18e58a1c082b710);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
const $1ed853d931a9d2a3$export$b18e58a1c082b710 = {
    STATUS_CONTAINER: 'statusView-content-wrap',
    STATUS_LOZENGE: 'status-lozenge-span'
};

});


parcelRegister("1UKpI", function(module, exports) {

$parcel$export(module.exports, "taskDecisionStyles", () => $c6e0bc2fbd9dd415$export$6083a263609cde43);
$parcel$export(module.exports, "taskDecisionIconWithVisualRefresh", () => $c6e0bc2fbd9dd415$export$f8ccb407a8d1c4f);
$parcel$export(module.exports, "taskDecisionIconWithoutVisualRefresh", () => $c6e0bc2fbd9dd415$export$733e7b81df8e7f2e);
$parcel$export(module.exports, "taskItemStyles", () => $c6e0bc2fbd9dd415$export$2a9fa9bb25fe40d2);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $gZAVf = parcelRequire("gZAVf");

var $2N2k8 = parcelRequire("2N2k8");
var $egs2l = parcelRequire("egs2l");
function $c6e0bc2fbd9dd415$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $c6e0bc2fbd9dd415$export$6083a263609cde43 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ak-editor-selected-node > [data-decision-wrapper], ol[data-node-type="decisionList"].ak-editor-selected-node': // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    [
        {
            borderRadius: '4px'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
        (0, $2N2k8.getSelectionStyles)([
            (0, $egs2l.SelectionStyle).BoxShadow,
            (0, $egs2l.SelectionStyle).Blanket
        ])
    ],
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.danger decisionItemView-content-wrap.ak-editor-selected-node > div': {
        boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`,
        backgroundColor: "var(--ds-blanket-danger, #EF5C4814)",
        '&::after': {
            content: 'none' // reset the Blanket selection style
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="decisionItem"]': {
        listStyleType: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper]': {
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'row',
        margin: `${"var(--ds-space-100, 8px)"} 0 0 0`,
        padding: "var(--ds-space-100, 8px)",
        paddingLeft: "var(--ds-space-150, 12px)",
        borderRadius: "var(--ds-border-radius-100, 4px)",
        backgroundColor: "var(--ds-background-neutral, #091E420F)",
        position: 'relative'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper] > [data-component="icon"]': {
        flex: '0 0 16px',
        height: '16px',
        width: '16px',
        margin: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-150, 12px)"} 0 0`,
        color: "var(--ds-icon-subtle, #626F86)",
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="decisionItem"]:not(:has([data-empty]):not(:has([data-type-ahead]))) > [data-decision-wrapper] > [data-component="icon"]': {
        color: "var(--ds-icon-success, #22A06B)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper] > [data-component="icon"] > span': {
        display: 'inline-block',
        flexShrink: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography -- Mirroring icon styles
        lineHeight: 1
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper] > [data-component="icon"] > span > svg': {
        overflow: 'hidden',
        pointerEvents: 'none',
        color: 'currentColor',
        verticalAlign: 'bottom'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper] > [data-component="placeholder"]': {
        margin: `0 0 0 calc(${"var(--ds-space-100, 8px)"} * 3.5)`,
        position: 'absolute',
        color: "var(--ds-text-subtlest, #626F86)",
        pointerEvents: 'none',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        maxWidth: 'calc(100% - 50px)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="decisionItem"]:not(:has([data-empty]):not(:has([data-type-ahead]))) > [data-decision-wrapper] > [data-component="placeholder"]': {
        display: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper] > [data-component="content"]': {
        margin: 0,
        wordWrap: 'break-word',
        minWidth: 0,
        flex: '1 1 auto'
    }
});
const $c6e0bc2fbd9dd415$export$f8ccb407a8d1c4f = {
    name: "b3ew8y",
    styles: "[data-prosemirror-node-name=\"decisionItem\"] > [data-decision-wrapper] > [data-component=\"icon\"] > span >  svg[data-icon-source=\"legacy\"]{display:none;}[data-prosemirror-node-name=\"decisionItem\"] > [data-decision-wrapper] > [data-component=\"icon\"] > span{box-sizing:border-box;padding-inline-end:var(--ds--button--new-icon-padding-end, 0);padding-inline-start:var(--ds--button--new-icon-padding-start, 0);@media screen and (forced-colors: active){color:canvastext;filter:grayscale(1);}}[data-prosemirror-node-name=\"decisionItem\"] > [data-decision-wrapper] > [data-component=\"icon\"] > span > svg{width:var(--ds-space-300, 24px);height:var(--ds-space-300, 24px);}"
};
const $c6e0bc2fbd9dd415$export$733e7b81df8e7f2e = {
    name: "s6v8rd",
    styles: "[data-prosemirror-node-name=\"decisionItem\"] > [data-decision-wrapper] > [data-component=\"icon\"] > span >  svg[data-icon-source=\"refreshed\"]{display:none;}[data-prosemirror-node-name=\"decisionItem\"] > [data-decision-wrapper] > [data-component=\"icon\"] > span{width:32px;height:32px;@media screen and (forced-colors: active){filter:grayscale(1);color:canvastext;fill:canvas;}}[data-prosemirror-node-name=\"decisionItem\"] > [data-decision-wrapper] > [data-component=\"icon\"] > span > svg{max-width:100%;max-height:100%;fill:var(--ds-surface, #FFFFFF);width:32px;height:32px;}"
};
const $c6e0bc2fbd9dd415$export$2a9fa9bb25fe40d2 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="taskItem"]': {
        listStyle: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="taskItem"] [data-component="task-item-main"]': {
        display: 'flex',
        flexDirection: 'row',
        position: 'relative'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="taskItem"] [data-component="placeholder"]': {
        position: 'absolute',
        color: "var(--ds-text-subtlest, #626F86)",
        margin: `0 0 0 calc(${"var(--ds-space-100, 8px)"} * 3)`,
        pointerEvents: 'none',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        maxWidth: 'calc(100% - 50px)',
        display: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    "[data-prosemirror-node-name='taskItem']:has([data-empty]):not(:has([data-type-ahead])) [data-component='placeholder']": {
        display: 'block'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="taskItem"] [data-component="content"]': {
        margin: 0,
        wordWrap: 'break-word',
        minWidth: 0,
        flex: '1 1 auto'
    },
    // copied styles from packages/design-system/icon/src/components/icon-new.tsx
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="taskItem"] [data-component="checkbox-icon-wrap"]': {
        display: 'inline-block',
        boxSizing: 'border-box',
        flexShrink: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 1,
        paddingInlineEnd: 'var(--ds--button--new-icon-padding-end, 0)',
        paddingInlineStart: 'var(--ds--button--new-icon-padding-start, 0)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="taskItem"] [data-component="checkbox-icon-wrap"] svg': {
        overflow: 'hidden',
        pointerEvents: 'none',
        color: 'currentColor',
        verticalAlign: 'bottom',
        width: "var(--ds-space-200, 16px)",
        height: "var(--ds-space-200, 16px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-node-name="taskItem"] input[type=checkbox]:not(:checked) + span [data-component=checkbox-checked-icon]': {
        display: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-node-name="taskItem"] input[type=checkbox]:not(:checked) + span [data-component=checkbox-unchecked-icon]': {
        display: 'inline'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="taskItem"] input[type=checkbox]:checked + span [data-component=checkbox-checked-icon]': {
        display: 'inline'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="taskItem"] input[type=checkbox]:checked + span [data-component=checkbox-unchecked-icon]': {
        display: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`[data-prosemirror-node-name="taskItem"] .${(0, $gZAVf.TaskDecisionSharedCssClassName).TASK_CHECKBOX_CONTAINER}`]: {
        flex: '0 0 24px',
        width: '24px',
        height: '24px',
        position: 'relative',
        alignSelf: 'start',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "& > input[type='checkbox']": {
            width: '16px',
            height: '16px',
            zIndex: 1,
            cursor: 'pointer',
            outline: 'none',
            margin: 0,
            opacity: 0,
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '&[disabled]': {
                cursor: 'default'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '+ span': {
                width: '24px',
                height: '24px',
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '+ span > svg': {
                boxSizing: 'border-box',
                display: 'inline',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                maxWidth: 'unset',
                maxHeight: 'unset',
                position: 'absolute',
                overflow: 'hidden',
                color: "var(--ds-background-input, #FFFFFF)",
                transition: 'color 0.2s ease-in-out, fill 0.2s ease-in-out',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                'path:first-of-type': {
                    visibility: 'hidden'
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                'rect:first-of-type': {
                    stroke: "var(--ds-border-input, #8590A2)",
                    strokeWidth: 1,
                    transition: 'stroke 0.2s ease-in-out'
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&:hover + span > svg': {
                color: "var(--ds-background-input-hovered, #F7F8F9)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                'rect:first-of-type': {
                    stroke: "var(--ds-border-input, #8590A2)"
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&:checked:hover + span > svg': {
                color: "var(--ds-background-selected-bold-hovered, #0055CC)",
                fill: "var(--ds-icon-inverse, #FFFFFF)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                'rect:first-of-type': {
                    stroke: "var(--ds-background-selected-bold-hovered, #0055CC)"
                }
            },
            '&:checked': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
                '+ span > svg': {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                    'path:first-of-type': {
                        visibility: 'visible'
                    },
                    color: "var(--ds-background-selected-bold, #0C66E4)",
                    fill: "var(--ds-icon-inverse, #FFFFFF)",
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                    'rect:first-of-type': {
                        stroke: "var(--ds-background-selected-bold, #0C66E4)"
                    }
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '&:active + span > svg': {
                color: "var(--ds-background-input-pressed, #FFFFFF)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                'rect:first-of-type': {
                    stroke: "var(--ds-border, #091E4224)"
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '&:checked:active + span > svg': {
                color: "var(--ds-background-input-pressed, #FFFFFF)",
                fill: "var(--ds-icon-inverse, #FFFFFF)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                'rect:first-of-type': {
                    stroke: "var(--ds-border, #091E4224)"
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '&:disabled + span > svg, &:disabled:hover + span > svg, &:disabled:focus + span > svg, &:disabled:active + span > svg': {
                color: "var(--ds-background-disabled, #091E4208)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                'rect:first-of-type': {
                    stroke: "var(--ds-background-disabled, #091E4208)"
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '&:disabled:checked + span > svg': {
                fill: "var(--ds-icon-disabled, #091E424F)"
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '&:focus + span::after': {
                position: 'absolute',
                width: "var(--ds-space-200, 16px)",
                height: "var(--ds-space-200, 16px)",
                border: `2px solid ${"var(--ds-border-focused, #388BFF)"}`,
                borderRadius: "var(--ds-space-050, 4px)",
                content: "''",
                display: 'block',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)'
            }
        }
    }
});

});


parcelRegister("7XjxI", function(module, exports) {

$parcel$export(module.exports, "default", () => $42977f0494318a12$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/platform/ensure-feature-flag-prefix */ /* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");
var $loabE = parcelRequire("loabE");

var $7EdFW = parcelRequire("7EdFW");

var $7yBx7 = parcelRequire("7yBx7");

var $eGOwo = parcelRequire("eGOwo");

var $cbSL1 = parcelRequire("cbSL1");

var $9Letn = parcelRequire("9Letn");

var $92xoS = parcelRequire("92xoS");

var $58yRG = parcelRequire("58yRG");

var $g3IWD = parcelRequire("g3IWD");

var $jEh2r = parcelRequire("jEh2r");

var $dUP13 = parcelRequire("dUP13");

var $9C47H = parcelRequire("9C47H");

var $ifZIx = parcelRequire("ifZIx");

var $cnIgR = parcelRequire("cnIgR");

var $iOgo7 = parcelRequire("iOgo7");

var $kdwal = parcelRequire("kdwal");

var $9A6ET = parcelRequire("9A6ET");

var $bOenW = parcelRequire("bOenW");

var $hbiJU = parcelRequire("hbiJU");

var $ipdG9 = parcelRequire("ipdG9");

var $fGeMV = parcelRequire("fGeMV");

var $l61tR = parcelRequire("l61tR");

var $aZU0R = parcelRequire("aZU0R");

var $l1WmN = parcelRequire("l1WmN");

var $ftlkF = parcelRequire("ftlkF");

var $hgRND = parcelRequire("hgRND");

var $eXk0C = parcelRequire("eXk0C");

var $cni8p = parcelRequire("cni8p");

var $bVQOn = parcelRequire("bVQOn");

var $ivuYE = parcelRequire("ivuYE");

var $8lEWs = parcelRequire("8lEWs");

var $6tApo = parcelRequire("6tApo");

var $iFTJL = parcelRequire("iFTJL");

var $a9Tj3 = parcelRequire("a9Tj3");

var $9dvIW = parcelRequire("9dvIW");

var $d2E5F = parcelRequire("d2E5F");

var $jw6co = parcelRequire("jw6co");

var $51Rgo = parcelRequire("51Rgo");

var $bRDpM = parcelRequire("bRDpM");

var $02AzZ = parcelRequire("02AzZ");

var $g7Nsb = parcelRequire("g7Nsb");

var $5mW2j = parcelRequire("5mW2j");

var $ftB1y = parcelRequire("ftB1y");

var $khwCN = parcelRequire("khwCN");

var $famkW = parcelRequire("famkW");

var $krgOs = parcelRequire("krgOs");

var $bEDkR = parcelRequire("bEDkR");

var $6uQ8z = parcelRequire("6uQ8z");

var $cZpyt = parcelRequire("cZpyt");

var $2287P = parcelRequire("2287P");

var $8A2V5 = parcelRequire("8A2V5");

var $bHGrA = parcelRequire("bHGrA");

var $lOMXK = parcelRequire("lOMXK");

var $fdSLH = parcelRequire("fdSLH");

var $iBvA9 = parcelRequire("iBvA9");

var $l0XHK = parcelRequire("l0XHK");
const $42977f0494318a12$var$isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
/**
 * EditorContentStyles is a wrapper component that applies styles to its children
 * based on the provided feature flags, view mode, and other props.
 * It uses Emotion for styling and supports scrollable content.
 *
 * This will be used in near future to replace the current editor content styles from index.tsx
 */ const $42977f0494318a12$var$EditorContentContainer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef((props, ref)=>{
    const { className: className, children: children, viewMode: viewMode, isScrollable: isScrollable, appearance: appearance } = props;
    const theme = (0, $loabE.u)();
    const { colorMode: colorMode } = (0, $58yRG.default)();
    const isFullPage = appearance === 'full-page' || appearance === 'full-width';
    const isComment = appearance === 'comment';
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        ref: ref,
        css: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $9C47H.baseStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $l0XHK.whitespaceStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $6tApo.indentationStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $bEDkR.shadowStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $iFTJL.InlineNodeViewSharedStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $famkW.hideSelectionStyles),
            ((0, $eGOwo.fg)('platform_editor_hide_cursor_when_pm_hideselection') || (0, $92xoS.editorExperiment)('platform_editor_advanced_code_blocks', true)) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $famkW.hideCursorWhenHideSelectionStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $famkW.selectedNodeStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $hbiJU.cursorStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $cni8p.firstFloatingToolbarButtonStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $g7Nsb.placeholderTextStyles),
            (0, $eGOwo.fg)('platform_editor_system_fake_text_highlight_colour') && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $g7Nsb.placeholderTextStylesMixin_fg_platform_editor_system_fake_text_highlight_colour),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $g7Nsb.placeholderStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1') && (0, $g7Nsb.placeholderOverflowStyles),
            (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1') && (0, $eGOwo.fg)('platform_editor_quick_insert_placeholder') && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $g7Nsb.placeholderWrapStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $kdwal.codeBlockStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            !(0, $eGOwo.fg)('platform_editor_fix_code_block_bg_color_in_macro_2') && (0, $kdwal.codeBgColorStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            !(0, $eGOwo.fg)('platform_editor_typography_ugc') && (0, $fGeMV.editorUGCTokensDefault),
            (0, $eGOwo.fg)('platform_editor_typography_ugc') && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $fGeMV.editorUGCTokensRefreshed),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $cnIgR.blocktypeStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $eGOwo.fg)('platform_editor_typography_ugc') ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $cnIgR.blocktypeStyles_fg_platform_editor_typography_ugc) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $cnIgR.blocktypeStyles_without_fg_platform_editor_typography_ugc),
            (0, $eGOwo.fg)('platform_editor_nested_dnd_styles_changes') && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $cnIgR.blocktypeStyles_fg_platform_editor_nested_dnd_styles_changes),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $9A6ET.codeMarkStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $lOMXK.textColorStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $dUP13.backgroundColorStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $d2E5F.listsStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $ftB1y.ruleStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $jw6co.mediaStyles),
            (0, $eGOwo.fg)('confluence_team_presence_scroll_to_pointer') ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $bHGrA.telepointerStyle) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $bHGrA.telepointerStyleWithInitialOnly),
            /* This needs to be after telepointer styles as some overlapping rules have equal specificity, and so the order is significant */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $bHGrA.telepointerColorAndCommonStyle),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $ivuYE.gapCursorStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $bRDpM.panelStyles),
            (0, $eGOwo.fg)('platform_editor_add_border_for_nested_panel') && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $bRDpM.panelStylesMixin_fg_platform_editor_add_border_for_nested_panel),
            (0, $eGOwo.fg)('platform_editor_nested_dnd_styles_changes') && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $bRDpM.panelStylesMixin_fg_platform_editor_nested_dnd_styles_changes),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $bRDpM.panelStylesMixin),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $51Rgo.mentionsStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $8A2V5.tasksAndDecisionsStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $8lEWs.gridStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $ifZIx.blockMarksStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $ipdG9.dateStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $ftlkF.extensionStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $l1WmN.expandStyles),
            (0, $eGOwo.fg)('platform_editor_nested_dnd_styles_changes') ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $l1WmN.expandStylesMixin_fg_platform_editor_nested_dnd_styles_changes) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $l1WmN.expandStylesMixin_without_fg_platform_editor_nested_dnd_styles_changes),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $eGOwo.fg)('platform-visual-refresh-icons') && (0, $l1WmN.expandStylesMixin_fg_platform_visual_refresh_icons),
            (0, $cbSL1.expValEquals)('platform_editor_find_and_replace_improvements', 'isEnabled', true) ? (0, $eGOwo.fg)('platform_editor_find_and_replace_improvements_1') ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $hgRND.findReplaceStylesNewNoImportant) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $hgRND.findReplaceStylesNew) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $hgRND.findReplaceStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $fdSLH.textHighlightStyle),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $8A2V5.decisionStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $8A2V5.taskItemStyles),
            (0, $eGOwo.fg)('platform-visual-refresh-icons') && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $8A2V5.decisionIconWithVisualRefresh),
            !(0, $eGOwo.fg)('platform-visual-refresh-icons') && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $8A2V5.decisionIconWithoutVisualRefresh),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $cZpyt.statusStyles),
            (0, $eGOwo.fg)('platform-component-visual-refresh') ? (0, $9Letn.expValEqualsNoExposure)('platform_editor_find_and_replace_improvements', 'isEnabled', true) && (0, $eGOwo.fg)('platform_editor_find_and_replace_improvements_1') ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $cZpyt.statusStylesMixin_fg_platform_component_visual_refresh_with_search_match) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $cZpyt.statusStylesMixin_fg_platform_component_visual_refresh) : (0, $9Letn.expValEqualsNoExposure)('platform_editor_find_and_replace_improvements', 'isEnabled', true) && (0, $eGOwo.fg)('platform_editor_find_and_replace_improvements_1') ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $cZpyt.statusStylesMixin_without_fg_platform_component_visual_refresh_with_search_match) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $cZpyt.statusStylesMixin_without_fg_platform_component_visual_refresh),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $jEh2r.annotationStyles),
            (0, $9Letn.expValEqualsNoExposure)('platform_editor_find_and_replace_improvements', 'isEnabled', true) && (0, $eGOwo.fg)('platform_editor_find_and_replace_improvements_1') ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $6uQ8z.smartCardStylesWithSearchMatch) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $6uQ8z.smartCardStyles),
            (0, $9Letn.expValEqualsNoExposure)('platform_editor_controls', 'cohort', 'variant1') && (0, $eGOwo.fg)('platform_editor_controls_patch_15') && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $6uQ8z.editorControlsSmartCardStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $l61tR.embedCardStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $iBvA9.unsupportedStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $5mW2j.resizerStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $a9Tj3.layoutBaseStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $92xoS.editorExperiment)('advanced_layouts', true) && (0, $a9Tj3.layoutBaseStylesAdvanced),
            (0, $92xoS.editorExperiment)('advanced_layouts', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $a9Tj3.layoutSectionStylesAdvanced) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $a9Tj3.layoutSectionStylesNotAdvanced),
            (0, $92xoS.editorExperiment)('advanced_layouts', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $a9Tj3.layoutColumnStylesAdvanced) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $a9Tj3.layoutColumnStylesNotAdvanced),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $92xoS.editorExperiment)('advanced_layouts', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $a9Tj3.layoutSelectedStylesAdvanced) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $a9Tj3.layoutSelectedStylesNotAdvanced),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $92xoS.editorExperiment)('advanced_layouts', true) && (0, $a9Tj3.layoutColumnResponsiveStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $92xoS.editorExperiment)('advanced_layouts', true) && (0, $a9Tj3.layoutResponsiveBaseStyles),
            (0, $eGOwo.fg)('platform_editor_nested_dnd_styles_changes') && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $a9Tj3.layoutBaseStylesFixesUnderNestedDnDFG),
            (0, $eGOwo.fg)('platform_editor_nested_dnd_styles_changes') ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $a9Tj3.layoutColumnMartinTopFixesNew) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $a9Tj3.layoutColumnMartinTopFixesOld),
            (0, $eGOwo.fg)('linking_platform_smart_links_in_live_pages') ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $6uQ8z.smartLinksInLivePagesStyles) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $6uQ8z.smartLinksInLivePagesStylesOld),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $6uQ8z.linkingVisualRefreshV1Styles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $ipdG9.dateVanillaStyles),
            (0, $eGOwo.fg)('platform_editor_typography_ugc') ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $02AzZ.paragraphStylesUGCRefreshed) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $02AzZ.paragraphStylesOld),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $eGOwo.fg)('platform_editor_hyperlink_underline') ? (0, $9dvIW.linkStyles) : (0, $9dvIW.linkStylesOld),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $7EdFW.browser).safari && (0, $d2E5F.listsStylesSafariFix),
            (0, $9Letn.expValEqualsNoExposure)('platform_editor_breakout_resizing', 'isEnabled', true) ? (0, $eGOwo.fg)('platform_editor_breakout_resizing_width_changes') ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $5mW2j.pragmaticResizerStylesNew) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $5mW2j.pragmaticResizerStyles) : undefined,
            (0, $92xoS.editorExperiment)('advanced_layouts', true) && (0, $9Letn.expValEqualsNoExposure)('platform_editor_breakout_resizing', 'isEnabled', true) && (0, $eGOwo.fg)('platform_editor_breakout_resizing_hello_release') && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $5mW2j.pragmaticStylesLayoutFirstNodeResizeHandleFix),
            (0, $9Letn.expValEqualsNoExposure)('platform_editor_breakout_resizing', 'isEnabled', true) && (0, $eGOwo.fg)('platform_editor_breakout_resizing_hello_release') && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $5mW2j.pragmaticResizerStylesForTooltip),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $g3IWD.aiPanelBaseStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            $42977f0494318a12$var$isFirefox && (0, $g3IWD.aiPanelBaseFirefoxStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            colorMode === 'dark' && (0, $g3IWD.aiPanelDarkStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            colorMode === 'dark' && $42977f0494318a12$var$isFirefox && (0, $g3IWD.aiPanelDarkFirefoxStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            viewMode === 'view' && (0, $a9Tj3.layoutStylesForView),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            viewMode === 'view' && (0, $92xoS.editorExperiment)('advanced_layouts', true) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $a9Tj3.layoutSelectedStylesForViewAdvanced),
            viewMode === 'view' && (0, $92xoS.editorExperiment)('advanced_layouts', false) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $a9Tj3.layoutSelectedStylesForViewNotAdvanced),
            viewMode === 'view' && (0, $92xoS.editorExperiment)('advanced_layouts', true) && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $a9Tj3.layoutResponsiveStylesForView),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            isComment && (0, $bOenW.commentEditorStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            isComment && (0, $2287P.tableCommentEditorStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            isFullPage && (0, $bVQOn.fullPageEditorStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            isFullPage && (0, $khwCN.scrollbarStyles),
            (0, $eGOwo.fg)('platform_editor_nested_dnd_styles_changes') ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $kdwal.firstCodeBlockWithNoMargin) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $kdwal.firstCodeBlockWithNoMarginOld),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $eXk0C.firstBlockNodeStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $51Rgo.mentionNodeStyles),
            (0, $9Letn.expValEqualsNoExposure)('platform_editor_find_and_replace_improvements', 'isEnabled', true) && (0, $eGOwo.fg)('platform_editor_find_and_replace_improvements_1') ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $51Rgo.mentionsSelectionStylesWithSearchMatch) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $51Rgo.mentionsSelectionStyles),
            (0, $eGOwo.fg)('platform_editor_centre_mention_padding') && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $51Rgo.mentionsStylesMixin_platform_editor_centre_mention_padding),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $aZU0R.emojiStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $bRDpM.panelViewStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $jw6co.mediaGroupStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $jw6co.mediaAlignmentStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $2287P.tableLayoutFixes),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $9dvIW.hyperLinkFloatingToolbarStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            !(0, $eGOwo.fg)('platform-visual-refresh-icons') && (0, $9dvIW.linkLegacyIconStylesFix),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $eGOwo.fg)('confluence_floating_toolbar_animation') && (0, $krgOs.selectionToolbarAnimationStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $eGOwo.fg)('platform_editor_vanilla_codebidi_warning') && (0, $iOgo7.codeBidiWarningStyles)
        ],
        "data-editor-scroll-container": isScrollable ? 'true' : undefined,
        "data-testid": "editor-content-container",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--ak-editor-base-font-size': `${(0, $7yBx7.editorFontSize)({
                theme: theme
            })}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--ak-editor--large-gutter-padding': `${(0, $7yBx7.akEditorGutterPaddingDynamic)()}px`
        }
    }, children);
});
var $42977f0494318a12$export$2e2bcd8739ae039 = $42977f0494318a12$var$EditorContentContainer;

});
parcelRegister("g3IWD", function(module, exports) {

$parcel$export(module.exports, "aiPanelBaseStyles", () => $699539a74131df67$export$7d2a5652980d3808);
$parcel$export(module.exports, "aiPanelBaseFirefoxStyles", () => $699539a74131df67$export$541b06daf7fd8fce);
$parcel$export(module.exports, "aiPanelDarkStyles", () => $699539a74131df67$export$9a2d17c0df63f635);
$parcel$export(module.exports, "aiPanelDarkFirefoxStyles", () => $699539a74131df67$export$18b242302a502e32);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $1NIU8 = parcelRequire("1NIU8");
/**
 * aiPanelStyles
 * was imported from packages/editor/editor-core/src/ui/ContentStyles/ai-panels.ts
 */ const $699539a74131df67$var$rotationAnimation = (0, $1NIU8.keyframes)({
    '0%': {
        '--panel-gradient-angle': '0deg'
    },
    '100%': {
        '--panel-gradient-angle': '360deg'
    }
});
const $699539a74131df67$var$rotationAnimationFirefox = (0, $1NIU8.keyframes)({
    '0%': {
        '--panel-gradient-angle': '0deg',
        backgroundPosition: '100%'
    },
    '100%': {
        '--panel-gradient-angle': '360deg',
        backgroundPosition: '-100%'
    }
});
const $699539a74131df67$var$aiPrismColor = {
    ['prism.border.step.1']: {
        light: '#0065FF',
        dark: '#0065FF80'
    },
    ['prism.border.step.2']: {
        light: '#0469FF',
        dark: '#0469FF80'
    },
    ['prism.border.step.3']: {
        light: '#BF63F3',
        dark: '#BF63F380'
    },
    ['prism.border.step.4']: {
        light: '#FFA900',
        dark: '#FFA90080'
    }
};
const $699539a74131df67$var$aiPrismColorStep1Light = $699539a74131df67$var$aiPrismColor['prism.border.step.1']['light'];
const $699539a74131df67$var$aiPrismColorStep2Light = $699539a74131df67$var$aiPrismColor['prism.border.step.2']['light'];
const $699539a74131df67$var$aiPrismColorStep3Light = $699539a74131df67$var$aiPrismColor['prism.border.step.3']['light'];
const $699539a74131df67$var$aiPrismColorStep4Light = $699539a74131df67$var$aiPrismColor['prism.border.step.4']['light'];
const $699539a74131df67$var$aiPrismColorStep1Dark = $699539a74131df67$var$aiPrismColor['prism.border.step.1']['dark'];
const $699539a74131df67$var$aiPrismColorStep2Dark = $699539a74131df67$var$aiPrismColor['prism.border.step.2']['dark'];
const $699539a74131df67$var$aiPrismColorStep3Dark = $699539a74131df67$var$aiPrismColor['prism.border.step.3']['dark'];
const $699539a74131df67$var$aiPrismColorStep4Dark = $699539a74131df67$var$aiPrismColor['prism.border.step.4']['dark'];
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
const $699539a74131df67$var$prismBorderBaseBackgroundFirefox = `linear-gradient(90deg, ${$699539a74131df67$var$aiPrismColorStep1Light} 0%, ${$699539a74131df67$var$aiPrismColorStep2Light} 12%, ${$699539a74131df67$var$aiPrismColorStep3Light} 24%, ${$699539a74131df67$var$aiPrismColorStep4Light} 48%, ${$699539a74131df67$var$aiPrismColorStep3Light} 64%, ${$699539a74131df67$var$aiPrismColorStep2Light} 80%, ${$699539a74131df67$var$aiPrismColorStep1Light} 100%)`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
const $699539a74131df67$var$prismBorderBaseBackground = `conic-gradient(from var(--panel-gradient-angle, 270deg), ${$699539a74131df67$var$aiPrismColorStep1Light} 0%, ${$699539a74131df67$var$aiPrismColorStep2Light} 20%, ${$699539a74131df67$var$aiPrismColorStep3Light} 50%, ${$699539a74131df67$var$aiPrismColorStep4Light} 56%, ${$699539a74131df67$var$aiPrismColorStep1Light} 100%)`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
const $699539a74131df67$var$prismBorderDarkBackgroundFirefox = `linear-gradient(90deg, ${$699539a74131df67$var$aiPrismColorStep1Dark} 0%, ${$699539a74131df67$var$aiPrismColorStep2Dark} 12%, ${$699539a74131df67$var$aiPrismColorStep3Dark} 24%, ${$699539a74131df67$var$aiPrismColorStep4Dark} 48%, ${$699539a74131df67$var$aiPrismColorStep3Dark} 64%, ${$699539a74131df67$var$aiPrismColorStep2Dark} 80%, ${$699539a74131df67$var$aiPrismColorStep1Dark} 100%)`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
const $699539a74131df67$var$prismBorderDarkBackground = `conic-gradient(from var(--panel-gradient-angle, 270deg), ${$699539a74131df67$var$aiPrismColorStep1Dark} 0%, ${$699539a74131df67$var$aiPrismColorStep2Dark} 20%, ${$699539a74131df67$var$aiPrismColorStep3Dark} 50%, ${$699539a74131df67$var$aiPrismColorStep4Dark} 56%, ${$699539a74131df67$var$aiPrismColorStep1Dark} 100%)`;
const $699539a74131df67$export$7d2a5652980d3808 = /*#__PURE__*/ (0, $1NIU8.css)({
    '@property --panel-gradient-angle': {
        syntax: '<angle>',
        initialValue: '270deg',
        inherits: false
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    'div[extensionType="com.atlassian.ai-blocks"]': {
        /* This hides the label for the extension */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.extension-label': {
            display: 'none'
        },
        /* This styles the ai panel correctly when its just sitting on the page and there
    is no user interaction */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.extension-container': {
            position: 'relative',
            boxShadow: 'none',
            overflow: 'unset',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            backgroundColor: `${"var(--ds-surface, #FFFFFF)"} !important`,
            // prismBorderBaseStyles
            '&::before, &::after': {
                content: "''",
                position: 'absolute',
                zIndex: -1,
                width: `calc(100% + 2px)`,
                height: `calc(100% + 2px)`,
                top: `-1px`,
                left: `-1px`,
                borderRadius: `calc(${"var(--ds-border-radius-100, 3px)"} + 1px)`,
                transform: 'translate3d(0, 0, 0)',
                background: $699539a74131df67$var$prismBorderBaseBackground
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.with-hover-border': {
                '&::before, &::after': {
                    //prismBorderHoverStyles
                    background: "var(--ds-border-input, #8590A2)"
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '& .with-margin-styles': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                backgroundColor: `${"var(--ds-surface, #FFFFFF)"} !important`,
                borderRadius: "var(--ds-border-radius-100, 3px)"
            }
        }
    },
    /* This styles the ai panel correctly when its streaming */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    'div[extensionType="com.atlassian.ai-blocks"]:has(.streaming)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.extension-container': {
            '&::before, &::after': {
                // prismBorderAnimationStyles
                animationName: $699539a74131df67$var$rotationAnimation,
                animationDuration: '2s',
                animationTimingFunction: 'linear',
                animationIterationCount: 'infinite',
                '@media (prefers-reduced-motion)': {
                    animation: 'none'
                }
            }
        }
    },
    /* This styles the ai panel correctly when a user is hovering over the delete button in the floating panel */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    'div[extensionType="com.atlassian.ai-blocks"].danger': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.extension-container': {
            boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`
        }
    },
    /* This removes the margin from the action list when inside an ai panel */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    'div[extensiontype="com.atlassian.ai-blocks"][extensionkey="ai-action-items-block:aiActionItemsBodiedExtension"]': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'div[data-node-type="actionList"]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            margin: '0 !important'
        }
    }
});
const $699539a74131df67$export$541b06daf7fd8fce = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    'div[extensionType="com.atlassian.ai-blocks"]': {
        '&::before, &::after': {
            background: $699539a74131df67$var$prismBorderBaseBackgroundFirefox,
            backgroundSize: '200%'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    'div[extensionType="com.atlassian.ai-blocks"]:has(.streaming)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.extension-container': {
            '&::before, &::after': {
                animationName: $699539a74131df67$var$rotationAnimationFirefox,
                animationDirection: 'normal',
                animationDuration: '1s'
            }
        }
    }
});
const $699539a74131df67$export$9a2d17c0df63f635 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    'div[extensionType="com.atlassian.ai-blocks"]': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.extension-container': {
            '&::before, &::after': {
                background: $699539a74131df67$var$prismBorderDarkBackground
            }
        }
    }
});
const $699539a74131df67$export$18b242302a502e32 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    'div[extensionType="com.atlassian.ai-blocks"]': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.extension-container': {
            '&::before, &::after': {
                background: $699539a74131df67$var$prismBorderDarkBackgroundFirefox,
                backgroundSize: '200%'
            }
        }
    }
});

});

parcelRegister("jEh2r", function(module, exports) {

$parcel$export(module.exports, "annotationStyles", () => $249babfc18f57823$export$65cde0a0b7e7c1c1);

var $1NIU8 = parcelRequire("1NIU8");

var $l8DE0 = parcelRequire("l8DE0");
const $249babfc18f57823$export$65cde0a0b7e7c1c1 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${(0, $l8DE0.AnnotationSharedClassNames).blur}, .${(0, $l8DE0.AnnotationSharedClassNames).focus}, .${(0, $l8DE0.AnnotationSharedClassNames).draft}, .${(0, $l8DE0.AnnotationSharedClassNames).hover}`]: {
            borderBottom: '2px solid transparent',
            cursor: 'pointer',
            padding: '1px 0 2px',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:has(.card), &:has([data-inline-card])': {
                padding: '5px 0 3px 0'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:has(.date-lozenger-container)': {
                paddingTop: "var(--ds-space-025, 2px)"
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${(0, $l8DE0.AnnotationSharedClassNames).focus}`]: {
            background: "var(--ds-background-accent-yellow-subtlest-pressed, #F5CD47)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
            boxShadow: "var(--ds-shadow-raised, 0px 1px 1px #091E4240, 0px 0px 1px #091E424f)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${(0, $l8DE0.AnnotationSharedClassNames).draft}`]: {
            background: "var(--ds-background-accent-yellow-subtlest-pressed, #F5CD47)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
            boxShadow: "var(--ds-shadow-raised, 0px 1px 1px #091E4240, 0px 0px 1px #091E424f)",
            cursor: 'initial'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${(0, $l8DE0.AnnotationSharedClassNames).blur}`]: {
            background: "var(--ds-background-accent-yellow-subtlest, #FFF7D6)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${(0, $l8DE0.AnnotationSharedClassNames).hover}`]: {
            background: "var(--ds-background-accent-yellow-subtlest-hovered, #F8E6A0)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
            boxShadow: "var(--ds-shadow-raised, 0px 1px 1px #091E4240, 0px 0px 1px #091E424f)"
        }
    }
});

});

parcelRegister("dUP13", function(module, exports) {

$parcel$export(module.exports, "backgroundColorStyles", () => $024bfa874c46c3b7$export$e4cca17cf56e99d);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $024bfa874c46c3b7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $024bfa874c46c3b7$export$e4cca17cf56e99d = {
    name: "7ixjog",
    styles: ".fabric-background-color-mark{background-color:var(--custom-palette-color, inherit);border-radius:2px;padding-top:1px;padding-bottom:2px;box-decoration-break:clone;}a .fabric-background-color-mark{background-color:unset;}.fabric-background-color-mark .ak-editor-annotation{background-color:unset;}"
};

});

parcelRegister("9C47H", function(module, exports) {

$parcel$export(module.exports, "baseStyles", () => $4385740eaa5c2877$export$6a08aa478781aaec);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $1NIU8 = parcelRequire("1NIU8");
// = akEditorDefaultLayoutWidth * breakoutWideScaleRatio = 1010.8 ~ 1011 This is a resulting width value that is applied to nodes that currently use breakouts (except table) and are set to `wide` when the viewport's width is > 1329px.
const $4385740eaa5c2877$var$akEditorCalculatedWideLayoutWidth = 1011;
// from breakoutConsts.calcWideWidth, layoutMaxWidth * breakoutConsts.wideScaleRatio = 904.8 ~ 905 This is a resulting width value that is applied to nodes that currently use breakouts (except table) and are set to `wide` when the viewport's width is <= 1266px.
const $4385740eaa5c2877$var$akEditorCalculatedWideLayoutWidthSmallViewport = 905;
const $4385740eaa5c2877$var$akEditorGutterPadding = 32;
const $4385740eaa5c2877$var$akEditorDefaultLayoutWidth = 760;
const $4385740eaa5c2877$var$akEditorFullWidthLayoutWidth = 1800;
// The breakpoint for small devices is 1266px, copied from getBreakpoint in platform/packages/editor/editor-common/src/ui/WidthProvider/index.tsx
const $4385740eaa5c2877$var$akEditorBreakpointForSmallDevice = `1266px`;
const $4385740eaa5c2877$export$6a08aa478781aaec = /*#__PURE__*/ (0, $1NIU8.css)({
    '--ak-editor--default-gutter-padding': `${$4385740eaa5c2877$var$akEditorGutterPadding}px`,
    '--ak-editor--default-layout-width': `${$4385740eaa5c2877$var$akEditorDefaultLayoutWidth}px`,
    '--ak-editor--full-width-layout-width': `${$4385740eaa5c2877$var$akEditorFullWidthLayoutWidth}px`,
    /* calculate editor line length, 100cqw is the editor container width */ '--ak-editor--line-length': 'min(calc(100cqw - var(--ak-editor--large-gutter-padding) * 2), var(--ak-editor--default-layout-width))',
    '--ak-editor--breakout-wide-layout-width': `${$4385740eaa5c2877$var$akEditorCalculatedWideLayoutWidthSmallViewport}px`,
    '--ak-editor--breakout-full-page-guttering-padding': 'calc(var(--ak-editor--large-gutter-padding) * 2 + var(--ak-editor--default-gutter-padding))',
    '--ak-editor--breakout-fallback-width': 'calc(100cqw - var(--ak-editor--breakout-full-page-guttering-padding))',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.fabric-editor--full-width-mode': {
        '--ak-editor--line-length': 'min(calc(100cqw - var(--ak-editor--large-gutter-padding) * 2), var(--ak-editor--full-width-layout-width))',
        /* in full width appearances it's not possible to rely on cqw because it doesn't account for the page scrollbar, which depends on users system settings */ '--ak-editor--breakout-fallback-width': '100%'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        '--ak-editor-max-container-width': 'calc(100cqw - var(--ak-editor--large-gutter-padding))',
        outline: 'none',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 'var(--ak-editor-base-font-size)'
    },
    /* We can't allow nodes that are inside other nodes to bleed from the parent container */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror > div[data-prosemirror-node-block] [data-prosemirror-node-block]': {
        '--ak-editor-max-container-width': '100%'
    },
    /* container editor-area is defined in platform/packages/editor/editor-core/src/ui/Appearance/FullPage/StyledComponents.ts */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries, @atlaskit/ui-styling-standard/no-unsafe-values
    [`@container editor-area (width >= ${$4385740eaa5c2877$var$akEditorBreakpointForSmallDevice})`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ProseMirror': {
            '--ak-editor--breakout-wide-layout-width': `${$4385740eaa5c2877$var$akEditorCalculatedWideLayoutWidth}px`
        }
    }
});

});

parcelRegister("ifZIx", function(module, exports) {

$parcel$export(module.exports, "blockMarksStyles", () => $5934f9ed13f35a2d$export$e561f1e4e17b129d);
function $5934f9ed13f35a2d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $5934f9ed13f35a2d$export$e561f1e4e17b129d = {
    name: "13r502m",
    styles: "*:not(.fabric-editor-block-mark) >, *:not(.fabric-editor-block-mark) > div.fabric-editor-block-mark:first-of-type:not(.fabric-editor-indentation-mark):not(.fabric-editor-alignment), .fabric-editor-alignment:first-of-type:first-child, .ProseMirror .fabric-editor-indentation-mark:first-of-type:first-child{p, h1, h2, h3, h4, h5, h6, .heading-wrapper{&:first-child:not(style), style:first-child + *{margin-top:0;}}}"
};

});

parcelRegister("cnIgR", function(module, exports) {

$parcel$export(module.exports, "blocktypeStyles", () => $2c13caad1b2bf46d$export$610a2509037eaf6);
$parcel$export(module.exports, "blocktypeStyles_fg_platform_editor_typography_ugc", () => $2c13caad1b2bf46d$export$36460e974c9904b9);
$parcel$export(module.exports, "blocktypeStyles_without_fg_platform_editor_typography_ugc", () => $2c13caad1b2bf46d$export$4a8301858e3f950);
$parcel$export(module.exports, "blocktypeStyles_fg_platform_editor_nested_dnd_styles_changes", () => $2c13caad1b2bf46d$export$13d8dd04b9497c9a);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $1NIU8 = parcelRequire("1NIU8");
function $2c13caad1b2bf46d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2c13caad1b2bf46d$export$610a2509037eaf6 = {
    name: "emi9uv",
    styles: ".ProseMirror{& blockquote{box-sizing:border-box;color:inherit;width:100%;display:inline-block;padding-left:var(--ds-space-200, 16px);border-left-width:2px;border-left-style:solid;border-left-color:var(--ds-border, #091E4224);margin:0.75rem 0 0 0;margin-right:0;[dir=\"rtl\"] &{padding-left:0;padding-right:var(--ds-space-200, 16px);}&:first-child{margin-top:0;}&::before{content:'';}&::after{content:none;}& p{display:block;}& table, & table:last-child{display:inline-table;}> .code-block:last-child, >.mediaSingleView-content-wrap:last-child, >.mediaGroupView-content-wrap:last-child{display:block;}> .extensionView-content-wrap:last-child{display:block;}}.fabric-editor-block-mark.fabric-editor-alignment:not(:first-child){> h1:first-child{margin-top:1.667em;}> h2:first-child{margin-top:1.8em;}> h3:first-child{margin-top:2em;}> h4:first-child{margin-top:1.357em;}> h5:first-child{margin-top:1.667em;}> h6:first-child{margin-top:1.455em;}}.ProseMirror-gapcursor:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .ProseMirror-widget:nth-child(2) + .fabric-editor-block-mark.fabric-editor-alignment{> :is(h1, h2, h3, h4, h5, h6):first-child{margin-top:0;}}}"
};
const $2c13caad1b2bf46d$export$36460e974c9904b9 = {
    name: "jrdqfj",
    styles: ".ProseMirror{& h1{font:var(--editor-font-ugc-token-heading-h1);margin-bottom:0;margin-top:1.45833em;& strong{font-weight:var(--editor-font-ugc-token-weight-heading-bold);}}& h2{font:var(--editor-font-ugc-token-heading-h2);margin-bottom:0;margin-top:1.4em;& strong{font-weight:var(--editor-font-ugc-token-weight-heading-bold);}}& h3{font:var(--editor-font-ugc-token-heading-h3);margin-bottom:0;margin-top:1.31249em;& strong{font-weight:var(--editor-font-ugc-token-weight-heading-bold);}}& h4{font:var(--editor-font-ugc-token-heading-h4);margin-top:1.25em;& strong{font-weight:var(--editor-font-ugc-token-weight-heading-bold);}}& h5{font:var(--editor-font-ugc-token-heading-h5);margin-top:1.45833em;text-transform:none;& strong{font-weight:var(--editor-font-ugc-token-weight-heading-bold);}}& h6{font:var(--editor-font-ugc-token-heading-h6);margin-top:1.59091em;text-transform:none;& strong{font-weight:var(--editor-font-ugc-token-weight-heading-bold);}}}"
};
const $2c13caad1b2bf46d$export$4a8301858e3f950 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& h1': {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: 'calc(24em / 14)',
            fontStyle: 'inherit',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: 'calc(28 / 24)',
            color: "var(--ds-text, #172B4D)",
            fontWeight: "var(--ds-font-weight-medium, 500)",
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            letterSpacing: `-0.01em`,
            marginBottom: 0,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginTop: '1.667em'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& h2': {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: 'calc(20em / 14)',
            fontStyle: 'inherit',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: 'calc(24 / 20)',
            color: "var(--ds-text, #172B4D)",
            fontWeight: "var(--ds-font-weight-medium, 500)",
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            letterSpacing: `-0.008em`,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginTop: '1.8em',
            marginBottom: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& h3': {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: 'calc(16em / 14)',
            fontStyle: 'inherit',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: 'calc(20 / 16)',
            color: "var(--ds-text, #172B4D)",
            fontWeight: "var(--ds-font-weight-semibold, 600)",
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            letterSpacing: `-0.006em`,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginTop: '2em',
            marginBottom: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& h4': {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: 'calc(14em / 14)',
            fontStyle: 'inherit',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: 'calc(16 / 14)',
            color: "var(--ds-text, #172B4D)",
            fontWeight: "var(--ds-font-weight-semibold, 600)",
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            letterSpacing: `-0.003em`,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginTop: '1.357em'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& h5': {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: 'calc(12em / 14)',
            fontStyle: 'inherit',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: 'calc(16 / 12)',
            color: "var(--ds-text, #172B4D)",
            fontWeight: "var(--ds-font-weight-semibold, 600)",
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginTop: '1.667em',
            textTransform: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& h6': {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: 'calc(11em / 14)',
            fontStyle: 'inherit',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: 'calc(16 / 11)',
            color: "var(--ds-text-subtlest, #626F86)",
            fontWeight: "var(--ds-font-weight-bold, 700)",
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginTop: '1.455em',
            textTransform: 'none'
        }
    }
});
const $2c13caad1b2bf46d$export$13d8dd04b9497c9a = {
    name: "18w6jtp",
    styles: ".ak-editor-content-area.appearance-full-page .ProseMirror blockquote{padding-left:var(--ds-space-250, 20px);}.ak-editor-content-area .ak-editor-content-area .ProseMirror blockquote{padding-left:var(--ds-space-200, 16px);}"
};

});

parcelRegister("iOgo7", function(module, exports) {

$parcel$export(module.exports, "codeBidiWarningStyles", () => $f4f2062210aa6838$export$98853831203df33a);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $1NIU8 = parcelRequire("1NIU8");
const $f4f2062210aa6838$export$98853831203df33a = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="code-bidi-warning"]': {
        display: 'inline-block'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="code-bidi-warning"] [data-bidi-component="code-bidi-warning-decorator"]': {
        paddingInlineStart: "var(--ds-space-050, 4px)",
        paddingInlineEnd: "var(--ds-space-050, 4px)",
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        fontStyle: 'normal',
        fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        paddingTop: '0.05rem',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        paddingBottom: '0.05rem',
        color: "var(--ds-text-warning, #A54800)",
        backgroundColor: "var(--ds-background-warning, #FFF7D6)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="code-bidi-warning"] [data-bidi-component="code-bidi-warning-decorator"]:hover': {
        color: "var(--ds-text-warning, #A54800)",
        backgroundColor: "var(--ds-background-warning-hovered, #F8E6A0)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="code-bidi-warning"] [data-bidi-component="code-bidi-warning-tooltip"]': {
        visibility: 'hidden',
        boxSizing: 'border-box',
        width: '15pc',
        backgroundColor: "var(--ds-background-neutral-bold, #44546F)",
        color: "var(--ds-text-inverse, #FFFFFF)",
        overflowWrap: 'break-word',
        cursor: 'default',
        borderRadius: "var(--ds-border-radius, 4px)",
        margin: "var(--ds-space-0, 0px)",
        padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-075, 6px)"}`,
        position: 'fixed',
        // The character label will be ~80px and this is positioned from the end of that label
        // We also use this instead of top: 24px to make sure the tooltip maintains its initial position
        // instead of being positioned relative to the viewport.
        // We need to use position: fixed so that the tooltip bypasses the overflow settings of the code block
        // and is always visible.
        // We also offset a little extra here to account for the transition behavior (to replicate ADS fade-in-from-top)
        transform: 'translate(calc(-50% - 40px), calc(24px - 4px))',
        opacity: 0,
        whiteSpace: 'normal',
        font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        zIndex: 9999,
        // Exit animation timings
        // - Mark invisible after 0.475s
        // - After 0.3s, fade out and move up over 0.175s
        transition: 'visibility 0s linear 0.475s, opacity 0.175s cubic-bezier(0.15,1,0.3,1) 0.3s, transform 0.175s cubic-bezier(0.15,1,0.3,1) 0.3s'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="code-bidi-warning"]:hover [data-bidi-component="code-bidi-warning-tooltip"]': {
        visibility: 'visible',
        transform: 'translate(calc(-50% - 40px), calc(24px))',
        opacity: 1,
        // Enter animation timings
        // - Mark visible after 0.3s of hovering
        // - After 0.3s, fade in over 0.175s
        // - After 0.3s, move down over 0.35s
        transition: 'visibility 0s linear 0.3s, opacity 0.175s cubic-bezier(0.15,1,0.3,1) 0.3s, transform 0.35s cubic-bezier(0.15,1,0.3,1) 0.3s'
    }
});

});

parcelRegister("kdwal", function(module, exports) {

$parcel$export(module.exports, "CodeBlockSharedCssClassName", () => $d6a88bda7f42404d$export$42659c26f026f6ea);
$parcel$export(module.exports, "codeBlockStyles", () => $d6a88bda7f42404d$export$4baaed2b257b830);
$parcel$export(module.exports, "codeBgColorStyles", () => $d6a88bda7f42404d$export$107831225ad52bb4);
$parcel$export(module.exports, "firstCodeBlockWithNoMargin", () => $d6a88bda7f42404d$export$ddc3dd3ba723d1af);
$parcel$export(module.exports, "firstCodeBlockWithNoMarginOld", () => $d6a88bda7f42404d$export$50458a606d5c37d0);

var $1NIU8 = parcelRequire("1NIU8");

var $jhoGk = parcelRequire("jhoGk");

var $famkW = parcelRequire("famkW");
function $d6a88bda7f42404d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d6a88bda7f42404d$export$42659c26f026f6ea = {
    CODEBLOCK_CONTAINER: 'code-block',
    CODEBLOCK_START: 'code-block--start',
    CODEBLOCK_END: 'code-block--end',
    CODEBLOCK_CONTENT_WRAPPER: 'code-block-content-wrapper',
    CODEBLOCK_LINE_NUMBER_GUTTER: 'line-number-gutter',
    CODEBLOCK_CONTENT: 'code-content',
    DS_CODEBLOCK: '[data-ds--code--code-block]',
    CODEBLOCK_CONTENT_WRAPPED: 'code-content--wrapped',
    CODEBLOCK_CONTAINER_LINE_NUMBER_WIDGET: 'code-content__line-number--wrapped'
};
const $d6a88bda7f42404d$var$fontSize14px = `${0.875}rem`;
const $d6a88bda7f42404d$var$blockNodesVerticalMargin = '0.75rem';
const $d6a88bda7f42404d$var$gutterDangerOverlay = {
    name: "110x2n0",
    styles: "&::after{height:100%;content:'';position:absolute;left:0;top:0;width:24px;background-color:var(--ds-blanket-danger, #EF5C4814);}"
};
const $d6a88bda7f42404d$export$4baaed2b257b830 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$d6a88bda7f42404d$export$42659c26f026f6ea.CODEBLOCK_CONTENT_WRAPPED} > .${$d6a88bda7f42404d$export$42659c26f026f6ea.CODEBLOCK_CONTENT_WRAPPER} > .${$d6a88bda7f42404d$export$42659c26f026f6ea.CODEBLOCK_CONTENT}`]: {
            marginRight: "var(--ds-space-100, 8px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            code: {
                display: 'block',
                wordBreak: 'break-word',
                whiteSpace: 'pre-wrap'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$d6a88bda7f42404d$export$42659c26f026f6ea.CODEBLOCK_CONTENT_WRAPPER} > .${$d6a88bda7f42404d$export$42659c26f026f6ea.CODEBLOCK_CONTENT}`]: {
            display: 'flex',
            flex: 1,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            code: {
                flexGrow: 1,
                whiteSpace: 'pre'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$d6a88bda7f42404d$export$42659c26f026f6ea.CODEBLOCK_CONTAINER}`]: {
            position: 'relative',
            backgroundColor: "var(--ds-surface-raised, #FFFFFF)",
            borderRadius: "var(--ds-border-radius, 3px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
            margin: `${$d6a88bda7f42404d$var$blockNodesVerticalMargin} 0 0 0`,
            fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
            minWidth: 48,
            cursor: 'pointer',
            clear: 'both',
            // This is necessary to allow for arrow key navigation in/out of code blocks in Firefox.
            whiteSpace: 'normal',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.code-block-gutter-pseudo-element::before': {
                content: 'attr(data-label)'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$d6a88bda7f42404d$export$42659c26f026f6ea.CODEBLOCK_START}`]: {
                position: 'absolute',
                visibility: 'hidden',
                height: '1.5rem',
                top: 0,
                left: 0
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$d6a88bda7f42404d$export$42659c26f026f6ea.CODEBLOCK_END}`]: {
                position: 'absolute',
                visibility: 'hidden',
                height: '1.5rem',
                bottom: 0,
                right: 0
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$d6a88bda7f42404d$export$42659c26f026f6ea.CODEBLOCK_CONTENT_WRAPPER}`]: [
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $jhoGk.overflowShadowStyles),
                {
                    position: 'relative',
                    backgroundColor: "var(--ds-background-neutral, #091E420F)",
                    display: 'flex',
                    borderRadius: "var(--ds-border-radius, 3px)",
                    width: '100%',
                    counterReset: 'line',
                    overflowX: 'auto',
                    backgroundRepeat: 'no-repeat',
                    backgroundAttachment: 'local, local, local, local, scroll, scroll, scroll, scroll',
                    backgroundSize: `${"var(--ds-space-300, 24px)"} 100%,
	                         ${"var(--ds-space-300, 24px)"} 100%,
	                         ${"var(--ds-space-100, 8px)"} 100%,
	                         ${"var(--ds-space-100, 8px)"} 100%,
	                         ${"var(--ds-space-100, 8px)"} 100%,
	                         1px 100%,
	                         ${"var(--ds-space-100, 8px)"} 100%,
	                         1px 100%`,
                    backgroundPosition: `0 0,
	                             0 0,
                               100% 0,
                               100% 0,
                               100% 0,
                               100% 0,
	                             0 0,
	                             0 0`,
                    // Be careful if refactoring this; it is needed to keep arrow key navigation in Firefox consistent with other browsers.
                    overflowY: 'hidden'
                }
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$d6a88bda7f42404d$export$42659c26f026f6ea.CODEBLOCK_LINE_NUMBER_GUTTER}`]: {
                backgroundColor: "var(--ds-background-neutral, #091E420F)",
                position: 'relative',
                width: 'var(--lineNumberGutterWidth, 2rem)',
                padding: "var(--ds-space-100, 8px)",
                flexShrink: 0,
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                fontSize: $d6a88bda7f42404d$var$fontSize14px,
                boxSizing: 'content-box'
            },
            // This is a fix of marker of list item with code block.
            // The list item marker in Chrome is aligned by the baseline of the text,
            // that's why we need to add a text (content: "1") to the line number gutter to align
            // the list item marker with the text.
            // Without it, the list item marker will be aligned by the bottom of the code block. */
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$d6a88bda7f42404d$export$42659c26f026f6ea.CODEBLOCK_LINE_NUMBER_GUTTER}::before`]: {
                content: "'1'",
                visibility: 'hidden',
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                fontSize: $d6a88bda7f42404d$var$fontSize14px,
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                lineHeight: '1.5rem'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$d6a88bda7f42404d$export$42659c26f026f6ea.CODEBLOCK_CONTENT}`]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                code: {
                    tabSize: 4,
                    cursor: 'text',
                    color: "var(--ds-text, #172B4D)",
                    borderRadius: "var(--ds-border-radius, 3px)",
                    margin: "var(--ds-space-100, 8px)",
                    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                    fontSize: $d6a88bda7f42404d$var$fontSize14px,
                    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                    lineHeight: '1.5rem'
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$d6a88bda7f42404d$export$42659c26f026f6ea.CODEBLOCK_CONTAINER_LINE_NUMBER_WIDGET}`]: {
                pointerEvents: 'none',
                userSelect: 'none',
                width: 'var(--lineNumberGutterWidth, 2rem)',
                left: 0,
                position: 'absolute',
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                fontSize: $d6a88bda7f42404d$var$fontSize14px,
                padding: `0px ${"var(--ds-space-100, 8px)"}`,
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                lineHeight: '1.5rem',
                textAlign: 'right',
                color: "var(--ds-text-subtlest, #505F79)",
                boxSizing: 'content-box'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        li: {
            // if same list item has multiple code blocks we need top margin for all but first
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '> .code-block': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
                margin: `${$d6a88bda7f42404d$var$blockNodesVerticalMargin} 0 0 0`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors
            '> .code-block:first-child, > .ProseMirror-gapcursor:first-child + .code-block': {
                marginTop: 0
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors
            '> div:last-of-type.code-block, > pre:last-of-type.code-block': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
                marginBottom: $d6a88bda7f42404d$var$blockNodesVerticalMargin
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-imported-style-values
        [`.code-block.ak-editor-selected-node:not(.danger)`]: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $famkW.boxShadowSelectionStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $famkW.blanketSelectionStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $famkW.hideNativeBrowserTextSelectionStyles)
        ],
        // Danger when top level node
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.danger.code-block': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
            boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$d6a88bda7f42404d$export$42659c26f026f6ea.CODEBLOCK_LINE_NUMBER_GUTTER}`]: [
                {
                    backgroundColor: "var(--ds-background-danger, #FFECEB)",
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                    color: "var(--ds-text-danger, #AE2E24)"
                },
                $d6a88bda7f42404d$var$gutterDangerOverlay
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$d6a88bda7f42404d$export$42659c26f026f6ea.CODEBLOCK_CONTENT}`]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                backgroundColor: "var(--ds-blanket-danger, #EF5C4814)"
            }
        },
        // Danger when nested node
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.danger .code-block': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$d6a88bda7f42404d$export$42659c26f026f6ea.CODEBLOCK_LINE_NUMBER_GUTTER}`]: [
                {
                    backgroundColor: "var(--ds-background-danger, #FFECEB)",
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                    color: "var(--ds-text-danger, #AE2E24)"
                },
                $d6a88bda7f42404d$var$gutterDangerOverlay
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$d6a88bda7f42404d$export$42659c26f026f6ea.CODEBLOCK_CONTENT}`]: {
                backgroundColor: "var(--ds-blanket-danger, #EF5C4814)"
            }
        }
    }
});
const $d6a88bda7f42404d$export$107831225ad52bb4 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$d6a88bda7f42404d$export$42659c26f026f6ea.CODEBLOCK_CONTAINER}`]: {
        '--ds--code--bg-color': 'transparent'
    }
});
const $d6a88bda7f42404d$export$ddc3dd3ba723d1af = {
    name: "1pwqusk",
    styles: ".ProseMirror{.ak-editor-panel__content{> .code-block:first-child, > .ProseMirror-widget:first-child + .code-block, > .ProseMirror-widget:first-child + .ProseMirror-widget + .code-block{margin:0!important;}}}"
};
const $d6a88bda7f42404d$export$50458a606d5c37d0 = {
    name: "1jcwwg4",
    styles: ".ProseMirror{.ak-editor-panel__content{> .code-block:first-child{margin:0!important;}}}"
};

});
parcelRegister("jhoGk", function(module, exports) {

$parcel$export(module.exports, "overflowShadowStyles", () => $bd6de6a2b5bbbfc1$export$cd7bee32f3fef345);

var $1NIU8 = parcelRequire("1NIU8");
const $bd6de6a2b5bbbfc1$export$cd7bee32f3fef345 = /*#__PURE__*/ (0, $1NIU8.css)({
    backgroundImage: `
		linear-gradient(
			to right,
			${"var(--ds-background-neutral, #091E420F)"} ${"var(--ds-space-300, 24px)"},
			transparent ${"var(--ds-space-300, 24px)"}
		),
		linear-gradient(
			to right,
			${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-300, 24px)"},
			transparent ${"var(--ds-space-300, 24px)"}
		),
		linear-gradient(
			to left,
			${"var(--ds-background-neutral, #091E420F)"} ${"var(--ds-space-100, 8px)"},
			transparent ${"var(--ds-space-100, 8px)"}
		),
		linear-gradient(
			to left,
			${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-100, 8px)"},
			transparent ${"var(--ds-space-100, 8px)"}
		),
		linear-gradient(
			to left,
			${"var(--ds-shadow-overflow-spread, #091e4229)"} 0,
			${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
		),
		linear-gradient(
			to left,
			${"var(--ds-shadow-overflow-perimeter, #091e421f)"} 0,
			${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
		),
		linear-gradient(
			to right,
			${"var(--ds-shadow-overflow-spread, #091e4229)"} 0,
			${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
		),
		linear-gradient(
			to right,
			${"var(--ds-shadow-overflow-perimeter, #091e421f)"} 0,
			${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
		)
	`
});

});

parcelRegister("famkW", function(module, exports) {

$parcel$export(module.exports, "hideNativeBrowserTextSelectionStyles", () => $9065106edc6fff3a$export$a716852a0c5e54d5);
$parcel$export(module.exports, "borderSelectionStyles", () => $9065106edc6fff3a$export$48dd9ca0c16e4625);
$parcel$export(module.exports, "boxShadowSelectionStyles", () => $9065106edc6fff3a$export$a8e8bf15b18b52a0);
$parcel$export(module.exports, "backgroundSelectionStyles", () => $9065106edc6fff3a$export$b2937e5c446645ec);
$parcel$export(module.exports, "blanketSelectionStyles", () => $9065106edc6fff3a$export$e7c1f2908e268236);
$parcel$export(module.exports, "hideSelectionStyles", () => $9065106edc6fff3a$export$b8cc3f8fc9e3d56a);
$parcel$export(module.exports, "hideCursorWhenHideSelectionStyles", () => $9065106edc6fff3a$export$cc1dcabcf4a29354);
$parcel$export(module.exports, "selectedNodeStyles", () => $9065106edc6fff3a$export$a3d8f4cb8a14da43);

var $1NIU8 = parcelRequire("1NIU8");
function $9065106edc6fff3a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $9065106edc6fff3a$export$a716852a0c5e54d5 = {
    name: "1fqpa4w",
    styles: "&::selection,*::selection{background-color:transparent;}&::-moz-selection,*::-moz-selection{background-color:transparent;}"
};
const $9065106edc6fff3a$export$48dd9ca0c16e4625 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
    border: `1px solid ${"var(--ds-border-selected, #0C66E4)"}`,
    // Fixes ED-15246: Trello card is visible through a border of a table border
    '&::after': {
        height: '100%',
        content: "'\\00a0'",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
        background: "var(--ds-border-selected, #0C66E4)",
        position: 'absolute',
        right: -1,
        top: 0,
        bottom: 0,
        width: 1,
        border: 'none',
        display: 'inline-block'
    }
});
const $9065106edc6fff3a$export$a8e8bf15b18b52a0 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
    boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #0C66E4)"}`,
    borderColor: 'transparent'
});
const $9065106edc6fff3a$export$b2937e5c446645ec = {
    name: "1l5b1jb",
    styles: "background-color:var(--ds-background-selected, #E9F2FF)"
};
const $9065106edc6fff3a$export$e7c1f2908e268236 = {
    name: "na0ofp",
    styles: "position:relative;-webkit-user-select:text;&::before{position:absolute;content:'';left:0;right:0;top:0;bottom:0;width:100%;pointer-events:none;z-index:12;background-color:var(--ds-blanket-selected, #388BFF14);}"
};
const $9065106edc6fff3a$export$b8cc3f8fc9e3d56a = {
    name: "105gl83",
    styles: ".ProseMirror-hideselection{*::selection{background:transparent;}*::-moz-selection{background:transparent;}}"
};
const $9065106edc6fff3a$export$cc1dcabcf4a29354 = {
    name: "p4ha7",
    styles: ".ProseMirror-hideselection{caret-color:transparent;}"
};
const $9065106edc6fff3a$export$a3d8f4cb8a14da43 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror-selectednode': {
        outline: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror-selectednode:empty': {
        outline: `2px solid ${"var(--ds-border-focused, #388BFF)"}`
    }
});

});


parcelRegister("9A6ET", function(module, exports) {

$parcel$export(module.exports, "codeMarkStyles", () => $d41324697c305c78$export$2029176b06e1b241);

var $1NIU8 = parcelRequire("1NIU8");
const $d41324697c305c78$export$2029176b06e1b241 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.code': {
        '--ds--code--bg-color': "var(--ds-background-neutral, #091E420F)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        display: 'inline',
        padding: '2px 0.5ch',
        backgroundColor: `var(--ds--code--bg-color,${"var(--ds-background-neutral, #091E420F)"})`,
        borderRadius: "var(--ds-border-radius, 3px)",
        borderStyle: 'none',
        boxDecorationBreak: 'clone',
        color: "var(--ds-text, #172B4D)",
        fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '0.875em',
        fontWeight: "var(--ds-font-weight-regular, 400)",
        overflow: 'auto',
        overflowWrap: 'break-word',
        whiteSpace: 'pre-wrap'
    }
});

});

parcelRegister("bOenW", function(module, exports) {

$parcel$export(module.exports, "commentEditorStyles", () => $40cb95d2de1819a2$export$d6e7bceefcc20e27);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $1NIU8 = parcelRequire("1NIU8");
const $40cb95d2de1819a2$var$CommentEditorMargin = 14;
const $40cb95d2de1819a2$var$GRID_GUTTER = 12;
const $40cb95d2de1819a2$export$d6e7bceefcc20e27 = /*#__PURE__*/ (0, $1NIU8.css)({
    flexGrow: 1,
    overflowX: 'clip',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '24px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.ProseMirror': {
        margin: "var(--ds-space-150, 12px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.gridParent': {
        marginLeft: "var(--ds-space-025, 2px)",
        marginRight: "var(--ds-space-025, 2px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `calc(100% + ${$40cb95d2de1819a2$var$CommentEditorMargin - $40cb95d2de1819a2$var$GRID_GUTTER}px)`
    },
    padding: "var(--ds-space-250, 20px)"
});

});

parcelRegister("hbiJU", function(module, exports) {

$parcel$export(module.exports, "cursorStyles", () => $bbc9dc9b7e34646f$export$f21d9f928c6ae322);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled
function $bbc9dc9b7e34646f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $bbc9dc9b7e34646f$export$f21d9f928c6ae322 = {
    name: "1w3oq8q",
    styles: ".ProseMirror.ProseMirror-focused:has(.ProseMirror-mark-boundary-cursor){caret-color:transparent;}.ProseMirror:not(.ProseMirror-focused) .ProseMirror-mark-boundary-cursor{display:none;}"
};

});

parcelRegister("ipdG9", function(module, exports) {

$parcel$export(module.exports, "dateVanillaStyles", () => $9d04087153a93635$export$b89fadc5134d50fa);
$parcel$export(module.exports, "dateStyles", () => $9d04087153a93635$export$37579fbc35dcc1a9);

var $1NIU8 = parcelRequire("1NIU8");

var $famkW = parcelRequire("famkW");
const $9d04087153a93635$export$99cdf122d0bb9f95 = {
    DATE_WRAPPER: `date-lozenger-container`,
    DATE_CONTAINER: 'dateView-content-wrap'
};
const $9d04087153a93635$export$b89fadc5134d50fa = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`[data-prosemirror-node-name='date'] .${$9d04087153a93635$export$99cdf122d0bb9f95.DATE_WRAPPER} span`]: {
        backgroundColor: "var(--ds-background-neutral, #091E420F)",
        color: "var(--ds-text, #172B4D)",
        borderRadius: "var(--ds-border-radius-100, 4px)",
        padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-050, 4px)"}`,
        margin: '0 1px',
        position: 'relative',
        transition: 'background 0.3s',
        whiteSpace: 'nowrap',
        cursor: 'unset'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`[data-prosemirror-node-name='date'] .${$9d04087153a93635$export$99cdf122d0bb9f95.DATE_WRAPPER} span:hover`]: {
        backgroundColor: "var(--ds-background-neutral-hovered, #091E4224)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`[data-prosemirror-node-name='date'] .${$9d04087153a93635$export$99cdf122d0bb9f95.DATE_WRAPPER} span.date-node-color-red`]: {
        backgroundColor: "var(--ds-background-accent-red-subtlest, #FFECEB)",
        color: "var(--ds-text-accent-red, #AE2E24)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`[data-prosemirror-node-name='date'] .${$9d04087153a93635$export$99cdf122d0bb9f95.DATE_WRAPPER} span.date-node-color-red:hover`]: {
        backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)"
    }
});
const $9d04087153a93635$export$37579fbc35dcc1a9 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$9d04087153a93635$export$99cdf122d0bb9f95.DATE_WRAPPER} span`]: {
        whiteSpace: 'unset'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$9d04087153a93635$export$99cdf122d0bb9f95.DATE_CONTAINER}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$9d04087153a93635$export$99cdf122d0bb9f95.DATE_WRAPPER}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: 'initial',
            cursor: 'pointer'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.ak-editor-selected-node': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$9d04087153a93635$export$99cdf122d0bb9f95.DATE_WRAPPER} > span`]: [
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $famkW.boxShadowSelectionStyles),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $famkW.hideNativeBrowserTextSelectionStyles)
            ]
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.danger': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$9d04087153a93635$export$99cdf122d0bb9f95.DATE_CONTAINER}.ak-editor-selected-node .${$9d04087153a93635$export$99cdf122d0bb9f95.DATE_WRAPPER} > span`]: {
            boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`
        }
    }
});

});

parcelRegister("fGeMV", function(module, exports) {

$parcel$export(module.exports, "editorUGCTokensDefault", () => $c6f5988542c59082$export$87e0522332cd3719);
$parcel$export(module.exports, "editorUGCTokensRefreshed", () => $c6f5988542c59082$export$63adc0ebe3278d31);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled
function $c6f5988542c59082$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $c6f5988542c59082$export$87e0522332cd3719 = {
    name: "u5gvmr",
    styles: "--editor-font-ugc-token-heading-h1:normal 500 1.71429em/1.16667 ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-heading-h2:normal 500 1.42857em/1.2 ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-heading-h3:normal 600 1.14286em/1.25 ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-heading-h4:normal 600 1em/1.14286 ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-heading-h5:normal 600 0.857143em/1.33333 ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-heading-h6:normal 700 0.785714em/1.45455 ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-body:normal 400 1em/1.714 ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-weight-heading-bold:700"
};
const $c6f5988542c59082$export$95588e746468319e = {
    name: "14r7dlz",
    styles: "--editor-font-ugc-token-heading-h1:normal 600 1.71429em/1.16667 ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-heading-h2:normal 600 1.42857em/1.2 ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-heading-h3:normal 600 1.14286em/1.25 ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-heading-h4:normal 600  1em/1.14286 ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-heading-h5:normal 600  0.857143em/1.33333 ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-heading-h6:normal 600 0.785714em/1.45455 ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-body:normal 400 1em/1.714 ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-weight-heading-bold:700"
};
const $c6f5988542c59082$export$63adc0ebe3278d31 = {
    name: "1maftdw",
    styles: "--editor-font-ugc-token-heading-h1:normal 600 1.71429em/1.16667 \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-heading-h2:normal 600 1.42857em/1.2 \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-heading-h3:normal 600 1.14286em/1.25 \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-heading-h4:normal 600 1em/1.14286 \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-heading-h5:normal 600 0.857143em/1.33333 \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-heading-h6:normal 600 0.785714em/1.45455 \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-body:normal 400 1em/1.714 \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif;--editor-font-ugc-token-weight-heading-bold:700"
};

});

parcelRegister("l61tR", function(module, exports) {

$parcel$export(module.exports, "embedCardStyles", () => $356bedc457c60c0b$export$5a1f57c6600b90f1);
function $356bedc457c60c0b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $356bedc457c60c0b$export$5a1f57c6600b90f1 = {
    name: "1tw1dm8",
    styles: ".ProseMirror{.embedCardView-content-wrap[layout^='wrap-']{max-width:100%;position:relative;z-index:2;}.embedCardView-content-wrap[layout='wrap-left']{float:left;}.embedCardView-content-wrap[layout='wrap-right']{float:right;}.embedCardView-content-wrap[layout='wrap-right'] + .embedCardView-content-wrap[layout='wrap-left']{clear:both;}}"
};

});

parcelRegister("aZU0R", function(module, exports) {

$parcel$export(module.exports, "emojiStyles", () => $40f24ef1e1f02788$export$d73b97ac20f33f4);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $1NIU8 = parcelRequire("1NIU8");

var $8iUeU = parcelRequire("8iUeU");
var $dXRfX = parcelRequire("dXRfX");

var $7yBx7 = parcelRequire("7yBx7");

var $famkW = parcelRequire("famkW");
function $40f24ef1e1f02788$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $40f24ef1e1f02788$var$emojiSelectionStyles = {
    name: "tg3mx0",
    styles: "border-radius:2px"
};
const $40f24ef1e1f02788$export$d73b97ac20f33f4 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.${(0, $dXRfX.EmojiSharedCssClassName).EMOJI_CONTAINER}`]: {
        display: 'inline-block'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.${(0, $dXRfX.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $dXRfX.EmojiSharedCssClassName).EMOJI_IMAGE}`]: {
        background: 'no-repeat transparent',
        display: 'inline-block',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        height: `${(0, $8iUeU.defaultEmojiHeight)}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        maxHeight: `${(0, $8iUeU.defaultEmojiHeight)}px`,
        cursor: 'pointer',
        verticalAlign: 'middle',
        userSelect: 'all'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.${0, $7yBx7.akEditorSelectedNodeClassName}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`.${(0, $dXRfX.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $dXRfX.EmojiSharedCssClassName).EMOJI_IMAGE}`]: [
            $40f24ef1e1f02788$var$emojiSelectionStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $famkW.blanketSelectionStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $famkW.boxShadowSelectionStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $famkW.hideNativeBrowserTextSelectionStyles)
        ]
    }
});

});

parcelRegister("l1WmN", function(module, exports) {

$parcel$export(module.exports, "expandStyles", () => $04d1b98fb107f419$export$4bb28258452e3b9a);
$parcel$export(module.exports, "expandStylesMixin_fg_platform_visual_refresh_icons", () => $04d1b98fb107f419$export$20843fd014d7530c);
$parcel$export(module.exports, "expandStylesMixin_fg_platform_editor_nested_dnd_styles_changes", () => $04d1b98fb107f419$export$26d7f96b2bb98b5b);
$parcel$export(module.exports, "expandStylesMixin_without_fg_platform_editor_nested_dnd_styles_changes", () => $04d1b98fb107f419$export$4dd1b2c2505a38a);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $1NIU8 = parcelRequire("1NIU8");
function $04d1b98fb107f419$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $04d1b98fb107f419$export$4bb28258452e3b9a = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ak-editor-expand__icon > div': {
        display: 'flex'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ak-editor-expand': {
        // sharedExpandStyles.containerStyles({ expanded: false, focused: false })(),
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: 'transparent',
        borderRadius: "var(--ds-border-radius-100, 4px)",
        minHeight: '25px',
        background: "var(--ds-background-neutral-subtle, transparent)",
        margin: `${"var(--ds-space-050, 0.25rem)"} 0 0`,
        transition: 'background 0.3s cubic-bezier(0.15, 1, 0.3, 1), border-color 0.3s cubic-bezier(0.15, 1, 0.3, 1)',
        padding: "var(--ds-space-100, 8px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        'td > :not(style):first-child, td > style:first-child + *': {
            marginTop: 0
        },
        cursor: 'pointer',
        boxSizing: 'border-box',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        'td > &': {
            marginTop: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-editor-expand__icon-container svg': {
            color: "var(--ds-icon-subtle, #626F86)",
            transform: 'rotate(90deg)'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&.ak-editor-selected-node:not(.danger)': {
            // SelectionStyle.Blanket
            position: 'relative',
            // Fixes ED-9263, where emoji or inline card in panel makes selection go outside the panel
            // in Safari. Looks like it's caused by user-select: all in the emoji element
            '-webkit-user-select': 'text',
            '&::before': {
                position: 'absolute',
                content: "''",
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                width: '100%',
                pointerEvents: 'none',
                zIndex: 12,
                // akEditorStickyheaderZIndex (11) + 1
                backgroundColor: "var(--ds-blanket-selected, #388BFF14)"
            },
            // SelectionStyle.Border (common case)
            border: `1px solid ${"var(--ds-border-selected, #0C66E4)"}`,
            // If fg('platform_editor_nested_dnd_styles_changes') is true,
            // then we'll also need the rest of the selection styles for blanket
            // hideNativeBrowserTextSelectionStyles
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&::selection, *::selection': {
                backgroundColor: 'transparent'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&::-moz-selection, *::-moz-selection': {
                backgroundColor: 'transparent'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger': {
            background: "var(--ds-background-danger, #FFECEB)",
            borderColor: "var(--ds-border-danger, #E2483D)"
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror > .ak-editor-expand__type-expand, .fabric-editor-breakout-mark-dom > .ak-editor-expand__type-expand': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginLeft: '-12px',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginRight: '-12px'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ak-editor-expand__content': {
        // sharedExpandStyles.contentStyles({ expanded: false, focused: false })(),
        paddingTop: "var(--ds-space-0, 0px)",
        paddingRight: "var(--ds-space-100, 8px)",
        paddingLeft: "var(--ds-space-300, 24px)",
        marginLeft: "var(--ds-space-050, 4px)",
        display: 'flow-root',
        /* The follow rules inside @supports block are added as a part of ED-8893
    	The fix is targeting mobile bridge on iOS 12 or below,
    	We should consider remove this fix when we no longer support iOS 12 */ '@supports not (display: flow-root)': {
            width: '100%',
            boxSizing: 'border-box'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.expand-content-wrapper, .nestedExpand-content-wrapper': {
            /* We visually hide the content here to preserve the content during copy+paste */ /* Do not add text nowrap here because inline comment navigation depends on the location of the text */ width: '100%',
            display: 'block',
            height: 0,
            overflow: 'hidden',
            clip: 'rect(1px, 1px, 1px, 1px)',
            userSelect: 'none'
        },
        cursor: 'text'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ak-editor-expand__title-input': {
        // sharedExpandStyles.titleInputStyles(),
        outline: 'none',
        border: 'none',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 'calc(14rem / 16)',
        // relativeFontSizeToBase16(14),
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 1.714,
        // If fg('platform-visual-refresh-icons') then this needs to be overridden
        fontWeight: "var(--ds-font-weight-regular, 400)",
        color: "var(--ds-text-subtlest, #626F86)",
        background: 'transparent',
        display: 'flex',
        flex: 1,
        padding: `0 0 0 ${"var(--ds-space-050, 4px)"}`,
        width: '100%',
        '&::placeholder': {
            opacity: 1,
            color: "var(--ds-text-subtlest, #626F86)"
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ak-editor-expand__title-container': {
        // sharedExpandStyles.titleContainerStyles(),
        padding: 0,
        display: 'flex',
        // Omitting alignItems: 'flex-start' as it would be overridden
        background: 'none',
        border: 'none',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 'calc(14rem / 16)',
        // relativeFontSizeToBase16(14),
        width: '100%',
        color: "var(--ds-text-subtle, #44546F)",
        // Omitting overflow: 'hidden' as it would be overridden
        cursor: 'pointer',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&:focus': {
            outline: 0
        },
        alignItems: 'center',
        overflow: 'visible'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ak-editor-expand__expanded': {
        background: "var(--ds-background-neutral-subtle, #00000000)",
        borderColor: "var(--ds-border, #091E4224)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-editor-expand__content': {
            paddingTop: "var(--ds-space-100, 8px)"
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ak-editor-expand__input-container': {
        width: '100%'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.ak-editor-expand:not(.ak-editor-expand__expanded)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-editor-expand__content': {
            position: 'absolute',
            height: '1px',
            width: '1px',
            overflow: 'hidden',
            clip: 'rect(1px, 1px, 1px, 1px)',
            whiteSpace: 'nowrap'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-editor-expand__icon-container svg': {
            color: "var(--ds-icon-subtle, #626F86)",
            transform: 'rotate(0deg)'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:not(.ak-editor-selected-node):not(.danger)': {
            background: 'transparent',
            borderColor: 'transparent',
            '&:hover': {
                borderColor: "var(--ds-border, #091E4224)",
                background: "var(--ds-background-neutral-subtle, #00000000)"
            }
        }
    }
});
const $04d1b98fb107f419$export$20843fd014d7530c = {
    name: "1izbe44",
    styles: ".ak-editor-expand__title-input{line-height:1;}"
};
const $04d1b98fb107f419$export$26d7f96b2bb98b5b = {
    name: "b2r3jw",
    styles: ".ak-editor-content-area.appearance-full-page .ProseMirror > .ak-editor-expand__type-expand, .fabric-editor-breakout-mark-dom > .ak-editor-expand__type-expand{margin-left:-20px;margin-right:-20px;}.ak-editor-expand__expanded{.ak-editor-expand__content{> :nth-child(1 of :not(style, .ProseMirror-gapcursor, .ProseMirror-widget, span)){margin-top:0;}> div.ak-editor-expand[data-node-type=\"nestedExpand\"]{margin-top:var(--ds-space-050, 0.25rem);}}}"
};
const $04d1b98fb107f419$export$4dd1b2c2505a38a = {
    name: "1oa7j7",
    styles: ".ak-editor-expand{&.ak-editor-selected-node:not(.danger){&::after{height:100%;content:'\\00a0';background:var(--ds-border-selected, #0C66E4);position:absolute;right:-1px;top:0;bottom:0;width:1px;border:none;display:inline-block;}}}"
};

});

parcelRegister("ftlkF", function(module, exports) {

$parcel$export(module.exports, "extensionStyles", () => $94d47c11854fef9e$export$c0c648396dbd86d3);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $1NIU8 = parcelRequire("1NIU8");

var $famkW = parcelRequire("famkW");
const $94d47c11854fef9e$export$c0c648396dbd86d3 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.multiBodiedExtensionView-content-wrap': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger > span > .multiBodiedExtension--container': {
            boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`,
            backgroundColor: "var(--ds-background-danger, #FFECEB)"
        },
        // ...extensionLabelStyles
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger > span > div > .extension-label': {
            backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
            color: "var(--ds-text-danger, #AE2E24)",
            opacity: 1,
            boxShadow: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:not(.danger).ak-editor-selected-node > span > div > .extension-label': {
            backgroundColor: "var(--ds-background-selected, #E9F2FF)",
            color: "var(--ds-text-selected, #0C66E4)",
            opacity: 1,
            boxShadow: 'none'
        },
        /* Targets the icon for bodied macro styling in button label */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger > span > div > .extension-label > span': {
            display: 'inline'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:not(.danger).ak-editor-selected-node > span > div .extension-label > span': {
            display: 'inline'
        },
        /* Start of bodied extension edit toggle styles */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger.ak-editor-selected-node > span > .extension-edit-toggle-container': {
            opacity: 1
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:not(.danger).ak-editor-selected-node > span > .extension-edit-toggle-container': {
            opacity: 1
        },
        /* In view mode of the bodied macro, we never want to show the extension label */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger.ak-editor-selected-node > span > div > .extension-label.always-hide-label': {
            opacity: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:not(.danger).ak-editor-selected-node > span > div > .extension-label.always-hide-label': {
            opacity: 0
        },
        /* .with-bodied-macro-live-page-styles class will only be added to bodied macros with the renderer mode gate enabled */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:not(.danger).ak-editor-selected-node > span > div > .extension-label.with-bodied-macro-live-page-styles': {
            boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #0C66E4)"}`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger.ak-editor-selected-node > span > div > .extension-label.with-bodied-macro-live-page-styles': {
            boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger.ak-editor-selected-node > span > .extension-edit-toggle-container > .extension-edit-toggle': {
            backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
            color: "var(--ds-text-danger, #AE2E24)",
            boxShadow: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&.danger > span > .with-danger-overlay': {
            backgroundColor: 'transparent',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.multiBodiedExtension--overlay': {
                // ...dangerOverlayStyles
                opacity: 0.3,
                backgroundColor: "var(--ds-background-danger-hovered, #FFD5D2)"
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:not(.danger).ak-editor-selected-node': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            '& > span > .multiBodiedExtension--container': [
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $famkW.boxShadowSelectionStyles),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $famkW.blanketSelectionStyles),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $famkW.hideNativeBrowserTextSelectionStyles)
            ]
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.multiBodiedExtension--container': {
            width: '100%',
            maxWidth: '100%' // ensure width can't go over 100%
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.inlineExtensionView-content-wrap': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger > span > .extension-container': {
            boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`,
            backgroundColor: "var(--ds-background-danger, #FFECEB)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger > span > .with-danger-overlay': {
            /* If the macro turned used to red before, not setting the background to be transparent will cause the
      danger state to have two layers of red which we don't want. */ backgroundColor: 'transparent',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.extension-overlay': {
                // ...dangerOverlayStyles
                opacity: 0.3,
                backgroundColor: "var(--ds-background-danger-hovered, #FFD5D2)"
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:not(.danger).ak-editor-selected-node': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            '& > span > .extension-container': [
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $famkW.boxShadowSelectionStyles),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $famkW.hideNativeBrowserTextSelectionStyles)
            ]
        },
        // ...extensionLabelStyles
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger > span > div > .extension-label': {
            backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
            color: "var(--ds-text-danger, #AE2E24)",
            opacity: 1,
            boxShadow: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:not(.danger).ak-editor-selected-node > span > div > .extension-label': {
            backgroundColor: "var(--ds-background-selected, #E9F2FF)",
            color: "var(--ds-text-selected, #0C66E4)",
            opacity: 1,
            boxShadow: 'none'
        },
        /* Targets the icon for bodied macro styling in button label */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger > span > div > .extension-label > span': {
            display: 'inline'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:not(.danger).ak-editor-selected-node > span > div .extension-label > span': {
            display: 'inline'
        },
        /* Start of bodied extension edit toggle styles */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger.ak-editor-selected-node > span > .extension-edit-toggle-container': {
            opacity: 1
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:not(.danger).ak-editor-selected-node > span > .extension-edit-toggle-container': {
            opacity: 1
        },
        /* In view mode of the bodied macro, we never want to show the extension label */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger.ak-editor-selected-node > span > div > .extension-label.always-hide-label': {
            opacity: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:not(.danger).ak-editor-selected-node > span > div > .extension-label.always-hide-label': {
            opacity: 0
        },
        /* .with-bodied-macro-live-page-styles class will only be added to bodied macros with the renderer mode gate enabled */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:not(.danger).ak-editor-selected-node > span > div > .extension-label.with-bodied-macro-live-page-styles': {
            boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #0C66E4)"}`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger.ak-editor-selected-node > span > div > .extension-label.with-bodied-macro-live-page-styles': {
            boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger.ak-editor-selected-node > span > .extension-edit-toggle-container > .extension-edit-toggle': {
            backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
            color: "var(--ds-text-danger, #AE2E24)",
            boxShadow: 'none'
        }
    },
    /* This is referenced in the toDOM of a bodied extension and is used to put
  label content into the bodied extension.
  We do this so that we don't serialise the label (which causes the label to be
  copied to the clipboard causing copy-paste issues). */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.bodied-extension-to-dom-label::after': {
        content: 'attr(data-bodied-extension-label)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.extensionView-content-wrap, .multiBodiedExtensionView-content-wrap, .bodiedExtensionView-content-wrap': {
        margin: `0.75rem 0`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:first-of-type': {
            marginTop: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:last-of-type': {
            marginBottom: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:not(.danger).ak-editor-selected-node': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            '& > span > .extension-container': [
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $famkW.boxShadowSelectionStyles),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $famkW.hideNativeBrowserTextSelectionStyles)
            ]
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger > span > .extension-container': {
            boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`,
            backgroundColor: "var(--ds-background-danger, #FFECEB)"
        },
        // ...extensionLabelStyles
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger > span > div > .extension-label': {
            backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
            color: "var(--ds-text-danger, #AE2E24)",
            opacity: 1,
            boxShadow: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:not(.danger).ak-editor-selected-node > span > div > .extension-label': {
            backgroundColor: "var(--ds-background-selected, #E9F2FF)",
            color: "var(--ds-text-selected, #0C66E4)",
            opacity: 1,
            boxShadow: 'none'
        },
        /* Targets the icon for bodied macro styling in button label */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger > span > div > .extension-label > span': {
            display: 'inline'
        },
        /** Targets legacy content header in LCM extension */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger > span > .legacy-content-header': {
            boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`,
            backgroundColor: `${"var(--ds-background-danger, #FFECEB)"}`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '& .status-lozenge-span > span': {
                backgroundColor: `${"var(--ds-background-accent-red-subtle-hovered, #FD9891)"}`
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:not(.danger).ak-editor-selected-node > span > div .extension-label > span': {
            display: 'inline'
        },
        /* Start of bodied extension edit toggle styles */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger.ak-editor-selected-node > span > .extension-edit-toggle-container': {
            opacity: 1
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:not(.danger).ak-editor-selected-node > span > .extension-edit-toggle-container': {
            opacity: 1
        },
        /* In view mode of the bodied macro, we never want to show the extension label */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger.ak-editor-selected-node > span > div > .extension-label.always-hide-label': {
            opacity: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:not(.danger).ak-editor-selected-node > span > div > .extension-label.always-hide-label': {
            opacity: 0
        },
        /* .with-bodied-macro-live-page-styles class will only be added to bodied macros with the renderer mode gate enabled */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:not(.danger).ak-editor-selected-node > span > div > .extension-label.with-bodied-macro-live-page-styles': {
            boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #0C66E4)"}`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger.ak-editor-selected-node > span > div > .extension-label.with-bodied-macro-live-page-styles': {
            boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger.ak-editor-selected-node > span > .extension-edit-toggle-container > .extension-edit-toggle': {
            backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
            color: "var(--ds-text-danger, #AE2E24)",
            boxShadow: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&.danger > span > .with-danger-overlay': {
            backgroundColor: 'transparent',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.extension-overlay': {
                // ...dangerOverlayStyles
                opacity: 0.3,
                backgroundColor: "var(--ds-background-danger-hovered, #FFD5D2)"
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.inline': {
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.extensionView-content-wrap .extension-container': {
        overflow: 'hidden',
        /* Don't hide overflow for editors inside extensions. */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:has(.extension-editable-area)': {
            overflow: 'visible'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.bodiedExtensionView-content-wrap .extensionView-content-wrap .extension-container': {
        width: '100%',
        maxWidth: '100%' // ensure width can't go over 100%
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "[data-mark-type='fragment']": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& > .extensionView-content-wrap, & > .bodiedExtensionView-content-wrap': {
            margin: '0.75rem 0'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "& > [data-mark-type='dataConsumer']": {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '& > .extensionView-content-wrap, & > .bodiedExtensionView-content-wrap': {
                margin: '0.75rem 0'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:first-child': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '& > .extensionView-content-wrap, & > .bodiedExtensionView-content-wrap': {
                marginTop: 0
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            "& > [data-mark-type='dataConsumer']": {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '& > .extensionView-content-wrap, & > .bodiedExtensionView-content-wrap': {
                    marginTop: 0
                }
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:nth-last-of-type(-n + 2):not(:first-of-type)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '& > .extensionView-content-wrap, & > .bodiedExtensionView-content-wrap': {
                marginBottom: 0
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            "& > [data-mark-type='dataConsumer']": {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '& > .extensionView-content-wrap, & > .bodiedExtensionView-content-wrap': {
                    marginBottom: 0
                }
            }
        }
    }
});

});

parcelRegister("hgRND", function(module, exports) {

$parcel$export(module.exports, "findReplaceStyles", () => $27c55fcc747b2da2$export$c5ceb9c726010930);
$parcel$export(module.exports, "findReplaceStylesNew", () => $27c55fcc747b2da2$export$f6e8277f5198ab7b);
$parcel$export(module.exports, "findReplaceStylesNewNoImportant", () => $27c55fcc747b2da2$export$4b5dc75d9d87c842);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $1NIU8 = parcelRequire("1NIU8");
const $27c55fcc747b2da2$export$c5ceb9c726010930 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match': {
        borderRadius: '3px',
        backgroundColor: "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
        boxShadow: `${"var(--ds-shadow-raised, 0 1px 1px 0 rgba(9, 30, 66, 0.25), 0 0 1px 0 rgba(9, 30, 66, 0.31))"}, inset 0 0 0 1px ${"var(--ds-border-input, #8590A2)"}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.selected-search-match': {
        backgroundColor: "var(--ds-background-accent-teal-subtle, #6CC3E0)"
    }
});
const $27c55fcc747b2da2$export$f6e8277f5198ab7b = /*#__PURE__*/ (0, $1NIU8.css)({
    /** Text match styles */ /** Light mode */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-text': {
        borderRadius: "var(--ds-space-050, 4px)",
        boxShadow: `
		inset 0 0 0 1px ${"var(--ds-background-accent-magenta-subtler-pressed, #E774BB)"},
		inset 0 0 0 5px ${"var(--ds-background-accent-magenta-subtler, #FDD0EC)"}
		`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        backgroundColor: `${"var(--ds-background-accent-magenta-subtler, #FDD0EC)"} !important`,
        color: "var(--ds-text, #172B4D)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-text.selected-search-match': {
        boxShadow: `
		inset 0 0 0 1px ${"var(--ds-background-accent-magenta-subtler-pressed, #E774BB)"},
		inset 0 0 0 5px ${"var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)"}
		`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        backgroundColor: `${"var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)"} !important`
    },
    /** Dark mode */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-text.search-match-dark': {
        boxShadow: `
		inset 0 0 0 1px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"},
		inset 0 0 0 5px ${"var(--ds-background-accent-magenta-bolder-pressed, #50253F)"}
		`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        backgroundColor: `${"var(--ds-background-accent-magenta-bolder-pressed, #50253F)"} !important`,
        color: "var(--ds-text-inverse, #FFFFFF)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-text.selected-search-match.search-match-dark': {
        boxShadow: `
		inset 0 0 0 1px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"},
		inset 0 0 0 5px ${"var(--ds-background-accent-magenta-bolder-hovered, #943D73)"}
		`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        backgroundColor: `${"var(--ds-background-accent-magenta-bolder-hovered, #943D73)"} !important`
    },
    /** Block match styles */ /** Light mode */ /** Without node selection */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-block': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-smart-link-container="true"], .loader-wrapper>div::after': {
            boxShadow: `
			inset 0 0 0 1px ${"var(--ds-background-accent-magenta-subtler-pressed, #E774BB)"},
			inset 0 0 0 5px ${"var(--ds-background-accent-magenta-subtler, #FDD0EC)"}
			`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.loader-wrapper>a, .lozenge-wrapper, .editor-mention-primitive, .date-lozenger-container>span': {
            boxShadow: `0px 0px 0px 4px ${"var(--ds-background-accent-magenta-subtler, #FDD0EC)"}, 0px 0px 0px 5px ${"var(--ds-background-accent-magenta-subtler-pressed, #E774BB)"}`
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-block.search-match-block-selected': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-smart-link-container="true"], .loader-wrapper>div::after': {
            boxShadow: `
			inset 0 0 0 1px ${"var(--ds-background-accent-magenta-subtler-pressed, #E774BB)"},
			inset 0 0 0 4px ${"var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)"}
			`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.loader-wrapper>a, .lozenge-wrapper, .editor-mention-primitive, .date-lozenger-container>span': {
            boxShadow: `0px 0px 0px 4px ${"var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)"}, 0px 0px 0px 5px ${"var(--ds-background-accent-magenta-subtler-pressed, #E774BB)"}`
        }
    },
    /** With node selection */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-block.ak-editor-selected-node': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.loader-wrapper>div::after': {
            boxShadow: `
			inset 0 0 0 1px ${"var(--ds-background-accent-magenta-subtler-pressed, #E774BB)"},
			inset 0 0 0 5px ${"var(--ds-background-accent-magenta-subtler, #FDD0EC)"},
			0 0 0 1px ${"var(--ds-border-selected, #0C66E4)"}
			`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.loader-wrapper>a, .lozenge-wrapper, .editor-mention-primitive, .date-lozenger-container>span': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #0C66E4)"}, 0px 0px 0px 4px ${"var(--ds-background-accent-magenta-subtler, #FDD0EC)"}, 0px 0px 0px 5px ${"var(--ds-background-accent-magenta-subtler-pressed, #E774BB)"} !important`
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-block.search-match-block-selected.ak-editor-selected-node': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-smart-link-container="true"], .loader-wrapper>div::after': {
            boxShadow: `
			inset 0 0 0 1px ${"var(--ds-background-accent-magenta-subtler-pressed, #E774BB)"},
			inset 0 0 0 4px ${"var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)"},
			0 0 0 1px ${"var(--ds-border-selected, #0C66E4)"}
			`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.loader-wrapper>a, .lozenge-wrapper, .editor-mention-primitive, .date-lozenger-container>span': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #0C66E4)"}, 0px 0px 0px 4px ${"var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)"}, 0px 0px 0px 5px ${"var(--ds-background-accent-magenta-subtler-pressed, #E774BB)"} !important`
        }
    },
    /** Dark mode */ /** Without node selection */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-block.search-match-dark': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-smart-link-container="true"], .loader-wrapper>div::after': {
            boxShadow: `
			inset 0 0 0 1px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"},
			inset 0 0 0 5px ${"var(--ds-background-accent-magenta-bolder-pressed, #50253F)"}
			`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.loader-wrapper>a, .lozenge-wrapper, .editor-mention-primitive, .date-lozenger-container>span': {
            boxShadow: `0px 0px 0px 4px ${"var(--ds-background-accent-magenta-bolder-pressed, #50253F)"}, 0px 0px 0px 5px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"}`
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-block.search-match-block-selected.search-match-dark': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-smart-link-container="true"], .loader-wrapper>div::after': {
            boxShadow: `
			inset 0 0 0 1px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"},
			inset 0 0 0 4px ${"var(--ds-background-accent-magenta-bolder-hovered, #943D73)"}
			`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.loader-wrapper>a, .lozenge-wrapper, .editor-mention-primitive, .date-lozenger-container>span': {
            boxShadow: `0px 0px 0px 4px ${"var(--ds-background-accent-magenta-bolder-hovered, #943D73)"}, 0px 0px 0px 5px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"}`
        }
    },
    /** With node selection */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-block.search-match-dark.ak-editor-selected-node': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.loader-wrapper>div::after': {
            boxShadow: `
			inset 0 0 0 1px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"},
			inset 0 0 0 5px ${"var(--ds-background-accent-magenta-bolder-pressed, #50253F)"},
			0 0 0 1px ${"var(--ds-border-selected, #0C66E4)"}
			`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.loader-wrapper>a, .lozenge-wrapper, .editor-mention-primitive, .date-lozenger-container>span': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #0C66E4)"}, 0px 0px 0px 4px ${"var(--ds-background-accent-magenta-bolder-pressed, #50253F)"}, 0px 0px 0px 5px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"} !important`
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-block.search-match-block-selected.search-match-dark.ak-editor-selected-node': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-smart-link-container="true"], .loader-wrapper>div::after': {
            boxShadow: `
			inset 0 0 0 1px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"},
			inset 0 0 0 4px ${"var(--ds-background-accent-magenta-bolder-hovered, #943D73)"},
			0 0 0 1px ${"var(--ds-border-selected, #0C66E4)"}
			`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.loader-wrapper>a, .lozenge-wrapper, .editor-mention-primitive, .date-lozenger-container>span': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #0C66E4)"}, 0px 0px 0px 4px ${"var(--ds-background-accent-magenta-bolder-hovered, #943D73)"}, 0px 0px 0px 5px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"} !important`
        }
    },
    /** Expand title match styles */ /** Light mode */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-expand-title > .ak-editor-expand__title-container > .ak-editor-expand__input-container': {
        borderRadius: "var(--ds-space-050, 4px)",
        boxShadow: `
		inset 0 0 0 1px ${"var(--ds-background-accent-magenta-subtler-pressed, #E774BB)"},
		inset 0 0 0 5px ${"var(--ds-background-accent-magenta-subtler, #FDD0EC)"}
		`,
        backgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-editor-expand__title-input': {
            color: "var(--ds-text, #172B4D)"
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-expand-title.selected-search-match > .ak-editor-expand__title-container > .ak-editor-expand__input-container': {
        boxShadow: `
		inset 0 0 0 1px ${"var(--ds-background-accent-magenta-subtler-pressed, #E774BB)"},
		inset 0 0 0 5px ${"var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)"}
		`,
        backgroundColor: "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)"
    },
    /** Dark mode */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-expand-title.search-match-dark > .ak-editor-expand__title-container > .ak-editor-expand__input-container': {
        boxShadow: `
		inset 0 0 0 1px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"},
		inset 0 0 0 5px ${"var(--ds-background-accent-magenta-bolder-pressed, #50253F)"}
		`,
        backgroundColor: "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-editor-expand__title-input': {
            color: "var(--ds-text-inverse, #FFFFFF)"
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-expand-title.selected-search-match.search-match-dark > .ak-editor-expand__title-container > .ak-editor-expand__input-container': {
        boxShadow: `
		inset 0 0 0 1px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"},
		inset 0 0 0 5px ${"var(--ds-background-accent-magenta-bolder-hovered, #943D73)"}
		`,
        backgroundColor: "var(--ds-background-accent-magenta-bolder-hovered, #943D73)"
    }
});
const $27c55fcc747b2da2$export$4b5dc75d9d87c842 = /*#__PURE__*/ (0, $1NIU8.css)({
    /** Text match styles */ /** Light mode */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-text': {
        borderRadius: "var(--ds-space-050, 4px)",
        boxShadow: `
		inset 0 0 0 1px ${"var(--ds-background-accent-magenta-subtler-pressed, #E774BB)"},
		inset 0 0 0 5px ${"var(--ds-background-accent-magenta-subtler, #FDD0EC)"}
		`,
        // we need to use !important here as we need to override inline selection styles
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        backgroundColor: `${"var(--ds-background-accent-magenta-subtler, #FDD0EC)"} !important`,
        color: "var(--ds-text, #172B4D)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-text.selected-search-match': {
        boxShadow: `
		inset 0 0 0 1px ${"var(--ds-background-accent-magenta-subtler-pressed, #E774BB)"},
		inset 0 0 0 5px ${"var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)"}
		`,
        // we need to use !important here as we need to override inline selection styles
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        backgroundColor: `${"var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)"} !important`
    },
    /** Dark mode */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-text.search-match-dark': {
        boxShadow: `
		inset 0 0 0 1px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"},
		inset 0 0 0 5px ${"var(--ds-background-accent-magenta-bolder-pressed, #50253F)"}
		`,
        // we need to use !important here as we need to override inline selection styles
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        backgroundColor: `${"var(--ds-background-accent-magenta-bolder-pressed, #50253F)"} !important`,
        color: "var(--ds-text-inverse, #FFFFFF)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-text.selected-search-match.search-match-dark': {
        boxShadow: `
		inset 0 0 0 1px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"},
		inset 0 0 0 5px ${"var(--ds-background-accent-magenta-bolder-hovered, #943D73)"}
		`,
        // we need to use !important here as we need to override inline selection styles
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        backgroundColor: `${"var(--ds-background-accent-magenta-bolder-hovered, #943D73)"} !important`
    },
    /** Block match styles */ /** Light mode */ /** Without node selection */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-block': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-smart-link-container="true"], .loader-wrapper>div::after': {
            boxShadow: `
			inset 0 0 0 1px ${"var(--ds-background-accent-magenta-subtler-pressed, #E774BB)"},
			inset 0 0 0 5px ${"var(--ds-background-accent-magenta-subtler, #FDD0EC)"}
			`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.loader-wrapper>a, .lozenge-wrapper, .editor-mention-primitive, .date-lozenger-container>span': {
            boxShadow: `0px 0px 0px 4px ${"var(--ds-background-accent-magenta-subtler, #FDD0EC)"}, 0px 0px 0px 5px ${"var(--ds-background-accent-magenta-subtler-pressed, #E774BB)"}`
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-block.search-match-block-selected': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-smart-link-container="true"], .loader-wrapper>div::after': {
            boxShadow: `
			inset 0 0 0 1px ${"var(--ds-background-accent-magenta-subtler-pressed, #E774BB)"},
			inset 0 0 0 4px ${"var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)"}
			`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.loader-wrapper>a, .lozenge-wrapper, .editor-mention-primitive, .date-lozenger-container>span': {
            boxShadow: `0px 0px 0px 4px ${"var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)"}, 0px 0px 0px 5px ${"var(--ds-background-accent-magenta-subtler-pressed, #E774BB)"}`
        }
    },
    /** With node selection */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-block.ak-editor-selected-node': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.loader-wrapper>div::after': {
            boxShadow: `
			inset 0 0 0 1px ${"var(--ds-background-accent-magenta-subtler-pressed, #E774BB)"},
			inset 0 0 0 5px ${"var(--ds-background-accent-magenta-subtler, #FDD0EC)"},
			0 0 0 1px ${"var(--ds-border-selected, #0C66E4)"}
			`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.loader-wrapper>a, .lozenge-wrapper, .editor-mention-primitive, .date-lozenger-container>span': {
            boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #0C66E4)"}, 0px 0px 0px 4px ${"var(--ds-background-accent-magenta-subtler, #FDD0EC)"}, 0px 0px 0px 5px ${"var(--ds-background-accent-magenta-subtler-pressed, #E774BB)"}`
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-block.search-match-block-selected.ak-editor-selected-node': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-smart-link-container="true"], .loader-wrapper>div::after': {
            boxShadow: `
			inset 0 0 0 1px ${"var(--ds-background-accent-magenta-subtler-pressed, #E774BB)"},
			inset 0 0 0 4px ${"var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)"},
			0 0 0 1px ${"var(--ds-border-selected, #0C66E4)"}
			`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.loader-wrapper>a, .lozenge-wrapper, .editor-mention-primitive, .date-lozenger-container>span': {
            boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #0C66E4)"}, 0px 0px 0px 4px ${"var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)"}, 0px 0px 0px 5px ${"var(--ds-background-accent-magenta-subtler-pressed, #E774BB)"}`
        }
    },
    /** Dark mode */ /** Without node selection */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-block.search-match-dark': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-smart-link-container="true"], .loader-wrapper>div::after': {
            boxShadow: `
			inset 0 0 0 1px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"},
			inset 0 0 0 5px ${"var(--ds-background-accent-magenta-bolder-pressed, #50253F)"}
			`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.loader-wrapper>a, .lozenge-wrapper, .editor-mention-primitive, .date-lozenger-container>span': {
            boxShadow: `0px 0px 0px 4px ${"var(--ds-background-accent-magenta-bolder-pressed, #50253F)"}, 0px 0px 0px 5px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"}`
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-block.search-match-block-selected.search-match-dark': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-smart-link-container="true"], .loader-wrapper>div::after': {
            boxShadow: `
			inset 0 0 0 1px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"},
			inset 0 0 0 4px ${"var(--ds-background-accent-magenta-bolder-hovered, #943D73)"}
			`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.loader-wrapper>a, .lozenge-wrapper, .editor-mention-primitive, .date-lozenger-container>span': {
            boxShadow: `0px 0px 0px 4px ${"var(--ds-background-accent-magenta-bolder-hovered, #943D73)"}, 0px 0px 0px 5px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"}`
        }
    },
    /** With node selection */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-block.search-match-dark.ak-editor-selected-node': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.loader-wrapper>div::after': {
            boxShadow: `
			inset 0 0 0 1px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"},
			inset 0 0 0 5px ${"var(--ds-background-accent-magenta-bolder-pressed, #50253F)"},
			0 0 0 1px ${"var(--ds-border-selected, #0C66E4)"}
			`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.loader-wrapper>a, .lozenge-wrapper, .editor-mention-primitive, .date-lozenger-container>span': {
            boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #0C66E4)"}, 0px 0px 0px 4px ${"var(--ds-background-accent-magenta-bolder-pressed, #50253F)"}, 0px 0px 0px 5px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"}`
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-block.search-match-block-selected.search-match-dark.ak-editor-selected-node': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-smart-link-container="true"], .loader-wrapper>div::after': {
            boxShadow: `
			inset 0 0 0 1px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"},
			inset 0 0 0 4px ${"var(--ds-background-accent-magenta-bolder-hovered, #943D73)"},
			0 0 0 1px ${"var(--ds-border-selected, #0C66E4)"}
			`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.loader-wrapper>a, .lozenge-wrapper, .editor-mention-primitive, .date-lozenger-container>span': {
            boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #0C66E4)"}, 0px 0px 0px 4px ${"var(--ds-background-accent-magenta-bolder-hovered, #943D73)"}, 0px 0px 0px 5px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"}`
        }
    },
    /** Expand title match styles */ /** Light mode */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-expand-title > .ak-editor-expand__title-container > .ak-editor-expand__input-container': {
        borderRadius: "var(--ds-space-050, 4px)",
        boxShadow: `
		inset 0 0 0 1px ${"var(--ds-background-accent-magenta-subtler-pressed, #E774BB)"},
		inset 0 0 0 5px ${"var(--ds-background-accent-magenta-subtler, #FDD0EC)"}
		`,
        backgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-editor-expand__title-input': {
            color: "var(--ds-text, #172B4D)"
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-expand-title.selected-search-match > .ak-editor-expand__title-container > .ak-editor-expand__input-container': {
        boxShadow: `
		inset 0 0 0 1px ${"var(--ds-background-accent-magenta-subtler-pressed, #E774BB)"},
		inset 0 0 0 5px ${"var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)"}
		`,
        backgroundColor: "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)"
    },
    /** Dark mode */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-expand-title.search-match-dark > .ak-editor-expand__title-container > .ak-editor-expand__input-container': {
        boxShadow: `
		inset 0 0 0 1px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"},
		inset 0 0 0 5px ${"var(--ds-background-accent-magenta-bolder-pressed, #50253F)"}
		`,
        backgroundColor: "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-editor-expand__title-input': {
            color: "var(--ds-text-inverse, #FFFFFF)"
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.search-match-expand-title.selected-search-match.search-match-dark > .ak-editor-expand__title-container > .ak-editor-expand__input-container': {
        boxShadow: `
		inset 0 0 0 1px ${"var(--ds-background-accent-magenta-bolder, #AE4787)"},
		inset 0 0 0 5px ${"var(--ds-background-accent-magenta-bolder-hovered, #943D73)"}
		`,
        backgroundColor: "var(--ds-background-accent-magenta-bolder-hovered, #943D73)"
    }
});

});

parcelRegister("eXk0C", function(module, exports) {

$parcel$export(module.exports, "firstBlockNodeStyles", () => $247d7e71c20f1de6$export$2d6e8a1d666d4a60);

var $1NIU8 = parcelRequire("1NIU8");

var $7kf0Z = parcelRequire("7kf0Z");

var $is7NW = parcelRequire("is7NW");
var $e2Ny4 = parcelRequire("e2Ny4");

var $kdwal = parcelRequire("kdwal");
const $247d7e71c20f1de6$export$2d6e8a1d666d4a60 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`> .${(0, $7kf0Z.PanelSharedCssClassName).prefix}, > .${(0, $kdwal.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER}, > .${(0, $e2Ny4.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER}, > div[data-task-list-local-id], > div[data-layout-section], > .${(0, $is7NW.expandClassNames).prefix}`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:first-child': {
                marginTop: 0
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors
        '> hr:first-child, > .ProseMirror-widget:first-child + hr': {
            marginTop: 0
        }
    }
});

});

parcelRegister("cni8p", function(module, exports) {

$parcel$export(module.exports, "firstFloatingToolbarButtonStyles", () => $6ad95db767abb176$export$f06cff4aa315bcf9);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $1NIU8 = parcelRequire("1NIU8");
const $6ad95db767abb176$export$f06cff4aa315bcf9 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    'button.first-floating-toolbar-button:focus': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        outline: `2px solid ${"var(--ds-border-focused, #388BFF)"}`
    }
});

});

parcelRegister("bVQOn", function(module, exports) {

$parcel$export(module.exports, "fullPageEditorStyles", () => $f8db2b9032b8f267$export$eb88bb4706d67f65);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled
function $f8db2b9032b8f267$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f8db2b9032b8f267$export$eb88bb4706d67f65 = {
    name: "1ro9jdo",
    styles: "flex-grow:1;height:100%;overflow-y:scroll;position:relative;display:flex;flex-direction:column;scroll-behavior:smooth"
};

});

parcelRegister("ivuYE", function(module, exports) {

$parcel$export(module.exports, "gapCursorStyles", () => $6aba582e724017a6$export$f6b9d90c2745834e);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $1NIU8 = parcelRequire("1NIU8");
const $6aba582e724017a6$var$gapCursorBlink = (0, $1NIU8.keyframes)({
    'from, to': {
        opacity: 0
    },
    '50%': {
        opacity: 1
    }
});
const $6aba582e724017a6$export$8adc5edbc4a22166 = 'ProseMirror-hide-gapcursor';
const $6aba582e724017a6$var$gapCursorSelector = '.ProseMirror-gapcursor';
const $6aba582e724017a6$var$prosemirrorwidgetNotBlock = '.ProseMirror-widget:not([data-blocks-decoration-container="true"]):not([data-blocks-drag-handle-container="true"]):not([data-blocks-quick-insert-container="true"])';
const $6aba582e724017a6$var$wrapLeft = '[layout="wrap-left"]';
const $6aba582e724017a6$var$wrapRight = '[layout="wrap-right"]';
const $6aba582e724017a6$var$fixVerticalAlignmentSelector = `
	&:first-of-type + ul,
	&:first-of-type + span + ul,
	&:first-of-type + ol,
	&:first-of-type + span + ol,
	&:first-of-type + pre,
	&:first-of-type + span + pre,
	&:first-of-type + blockquote,
	&:first-of-type + span + blockquote
`;
const $6aba582e724017a6$var$twoImagesSideBySideFixSelector = `
  ${$6aba582e724017a6$var$gapCursorSelector}${$6aba582e724017a6$var$wrapLeft} + span + ${$6aba582e724017a6$var$wrapLeft},
  ${$6aba582e724017a6$var$gapCursorSelector}${$6aba582e724017a6$var$wrapRight} + span + ${$6aba582e724017a6$var$wrapRight},
  ${$6aba582e724017a6$var$gapCursorSelector} + ${$6aba582e724017a6$var$wrapLeft} + ${$6aba582e724017a6$var$wrapRight},
  ${$6aba582e724017a6$var$gapCursorSelector} + ${$6aba582e724017a6$var$wrapLeft} + span + ${$6aba582e724017a6$var$wrapRight},
  ${$6aba582e724017a6$var$gapCursorSelector} + ${$6aba582e724017a6$var$wrapRight} + ${$6aba582e724017a6$var$wrapLeft},
  ${$6aba582e724017a6$var$gapCursorSelector} + ${$6aba582e724017a6$var$wrapRight} + span + ${$6aba582e724017a6$var$wrapLeft},
  ${$6aba582e724017a6$var$wrapLeft} + ${$6aba582e724017a6$var$gapCursorSelector} + ${$6aba582e724017a6$var$wrapRight},
  ${$6aba582e724017a6$var$wrapLeft} + ${$6aba582e724017a6$var$gapCursorSelector} + span ${$6aba582e724017a6$var$wrapRight},
  ${$6aba582e724017a6$var$wrapRight} + ${$6aba582e724017a6$var$gapCursorSelector} + ${$6aba582e724017a6$var$wrapLeft},
  ${$6aba582e724017a6$var$wrapRight} + ${$6aba582e724017a6$var$gapCursorSelector} + span + ${$6aba582e724017a6$var$wrapLeft},
  ${$6aba582e724017a6$var$wrapLeft} + ${$6aba582e724017a6$var$gapCursorSelector}`;
const $6aba582e724017a6$var$marginFixSelector = `
  ${$6aba582e724017a6$var$wrapLeft} + ${$6aba582e724017a6$var$gapCursorSelector} + ${$6aba582e724017a6$var$wrapRight} > div,
  ${$6aba582e724017a6$var$wrapLeft} + ${$6aba582e724017a6$var$gapCursorSelector} + span + ${$6aba582e724017a6$var$wrapRight} > div,
  ${$6aba582e724017a6$var$wrapRight} + ${$6aba582e724017a6$var$gapCursorSelector} + ${$6aba582e724017a6$var$wrapLeft} > div,
  ${$6aba582e724017a6$var$wrapRight} + ${$6aba582e724017a6$var$gapCursorSelector} + span + ${$6aba582e724017a6$var$wrapLeft} > div,
  ${$6aba582e724017a6$var$gapCursorSelector} + ${$6aba582e724017a6$var$wrapRight} + ${$6aba582e724017a6$var$wrapLeft} > div,
  ${$6aba582e724017a6$var$gapCursorSelector} + ${$6aba582e724017a6$var$wrapRight} + span + ${$6aba582e724017a6$var$wrapLeft} > div,
  ${$6aba582e724017a6$var$gapCursorSelector} + ${$6aba582e724017a6$var$wrapLeft} + ${$6aba582e724017a6$var$wrapRight} > div,
  ${$6aba582e724017a6$var$gapCursorSelector} + ${$6aba582e724017a6$var$wrapLeft} + span + ${$6aba582e724017a6$var$wrapRight} > div`;
const $6aba582e724017a6$var$floatLeftFixSelector = `
  ${$6aba582e724017a6$var$wrapLeft} + ${$6aba582e724017a6$var$gapCursorSelector},
  ${$6aba582e724017a6$var$wrapRight} + ${$6aba582e724017a6$var$gapCursorSelector}`;
const $6aba582e724017a6$var$afterPresudoSelector = `
  ${$6aba582e724017a6$var$gapCursorSelector} + ${$6aba582e724017a6$var$wrapLeft} + span + ${$6aba582e724017a6$var$wrapRight}::after,
  ${$6aba582e724017a6$var$gapCursorSelector} + ${$6aba582e724017a6$var$wrapRight} + span + ${$6aba582e724017a6$var$wrapLeft}::after,
  ${$6aba582e724017a6$var$wrapLeft} + ${$6aba582e724017a6$var$gapCursorSelector} + ${$6aba582e724017a6$var$wrapRight}::after,
  ${$6aba582e724017a6$var$wrapLeft} + ${$6aba582e724017a6$var$gapCursorSelector} + span + ${$6aba582e724017a6$var$wrapRight}::after,
  ${$6aba582e724017a6$var$wrapRight} + ${$6aba582e724017a6$var$gapCursorSelector} + ${$6aba582e724017a6$var$wrapLeft}::after,
  ${$6aba582e724017a6$var$wrapRight} + ${$6aba582e724017a6$var$gapCursorSelector} + span + ${$6aba582e724017a6$var$wrapLeft}::after`;
const $6aba582e724017a6$var$marginDeepChildrenFixSelector = `
${$6aba582e724017a6$var$wrapLeft} + ${$6aba582e724017a6$var$gapCursorSelector} + ${$6aba582e724017a6$var$wrapRight} + *,
  ${$6aba582e724017a6$var$wrapLeft} + ${$6aba582e724017a6$var$gapCursorSelector} + ${$6aba582e724017a6$var$wrapRight} + span + *,
  ${$6aba582e724017a6$var$wrapRight} + ${$6aba582e724017a6$var$gapCursorSelector} + ${$6aba582e724017a6$var$wrapLeft} + *,
  ${$6aba582e724017a6$var$wrapRight} + ${$6aba582e724017a6$var$gapCursorSelector} + ${$6aba582e724017a6$var$wrapLeft} + span + *,
  ${$6aba582e724017a6$var$wrapLeft} + ${$6aba582e724017a6$var$gapCursorSelector} + span + ${$6aba582e724017a6$var$wrapRight} + *,
  ${$6aba582e724017a6$var$wrapRight} + ${$6aba582e724017a6$var$gapCursorSelector} + span + ${$6aba582e724017a6$var$wrapLeft} + *,
  ${$6aba582e724017a6$var$gapCursorSelector} + ${$6aba582e724017a6$var$wrapLeft} + span + ${$6aba582e724017a6$var$wrapRight} + *,
  ${$6aba582e724017a6$var$gapCursorSelector} + ${$6aba582e724017a6$var$wrapRight} + span + ${$6aba582e724017a6$var$wrapLeft} + *,
  ${$6aba582e724017a6$var$wrapLeft} + ${$6aba582e724017a6$var$gapCursorSelector} + ${$6aba582e724017a6$var$wrapRight} + * > *,
  ${$6aba582e724017a6$var$wrapLeft} + ${$6aba582e724017a6$var$gapCursorSelector} + ${$6aba582e724017a6$var$wrapRight} + span + * > *,
  ${$6aba582e724017a6$var$wrapRight} + ${$6aba582e724017a6$var$gapCursorSelector} + ${$6aba582e724017a6$var$wrapLeft} + * > *,
  ${$6aba582e724017a6$var$wrapRight} + ${$6aba582e724017a6$var$gapCursorSelector} + ${$6aba582e724017a6$var$wrapLeft} + span + * > *,
  ${$6aba582e724017a6$var$wrapLeft} + ${$6aba582e724017a6$var$gapCursorSelector} + span + ${$6aba582e724017a6$var$wrapRight} + * > *,
  ${$6aba582e724017a6$var$wrapRight} + ${$6aba582e724017a6$var$gapCursorSelector} + span + ${$6aba582e724017a6$var$wrapLeft} + * > *,
  ${$6aba582e724017a6$var$gapCursorSelector} + ${$6aba582e724017a6$var$wrapLeft} + span + ${$6aba582e724017a6$var$wrapRight} + * > *,
  ${$6aba582e724017a6$var$gapCursorSelector} + ${$6aba582e724017a6$var$wrapRight} + span + ${$6aba582e724017a6$var$wrapLeft} + * > *,
  ${$6aba582e724017a6$var$prosemirrorwidgetNotBlock} + ${$6aba582e724017a6$var$gapCursorSelector} + *,
  ${$6aba582e724017a6$var$prosemirrorwidgetNotBlock} + ${$6aba582e724017a6$var$gapCursorSelector} + span + *`;
const $6aba582e724017a6$export$f6b9d90c2745834e = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [`&.${$6aba582e724017a6$export$8adc5edbc4a22166}`]: {
            caretColor: 'transparent'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [$6aba582e724017a6$var$gapCursorSelector]: {
            display: 'none',
            pointerEvents: 'none',
            position: 'relative',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '& span': {
                caretColor: 'transparent',
                position: 'absolute',
                height: '100%',
                width: '100%',
                display: 'block'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '& span::after': {
                animation: `1s ${$6aba582e724017a6$var$gapCursorBlink} step-start infinite`,
                borderLeft: '1px solid',
                content: "''",
                display: 'block',
                position: 'absolute',
                top: 0,
                height: '100%'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.-left span::after': {
                left: "var(--ds-space-negative-050, -4px)"
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.-right span::after': {
                right: "var(--ds-space-negative-050, -4px)"
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '& span[layout="full-width"], & span[layout="wide"], & span[layout="fixed-width"]': {
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
                marginLeft: '50%',
                transform: 'translateX(-50%)'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            [`&${$6aba582e724017a6$var$wrapRight}`]: {
                float: 'right'
            },
            /* fix vertical alignment of gap cursor */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
            [$6aba582e724017a6$var$fixVerticalAlignmentSelector]: {
                marginTop: 0
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [`&.ProseMirror-focused ${$6aba582e724017a6$var$gapCursorSelector}`]: {
            display: 'block',
            borderColor: 'transparent'
        }
    },
    /* This hack below is for two images aligned side by side */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [$6aba582e724017a6$var$twoImagesSideBySideFixSelector]: {
        clear: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [$6aba582e724017a6$var$marginFixSelector]: {
        marginRight: 0,
        marginLeft: 0,
        marginBottom: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [$6aba582e724017a6$var$floatLeftFixSelector]: {
        float: 'left'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [$6aba582e724017a6$var$afterPresudoSelector]: {
        visibility: 'hidden',
        display: 'block',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 0,
        content: "' '",
        clear: 'both',
        height: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [$6aba582e724017a6$var$marginDeepChildrenFixSelector]: {
        marginTop: 0
    }
});

});

parcelRegister("8lEWs", function(module, exports) {

$parcel$export(module.exports, "gridStyles", () => $c3078574795805c7$export$61d0da483c72dda3);

var $1NIU8 = parcelRequire("1NIU8");
const $c3078574795805c7$export$61d0da483c72dda3 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.gridParent': {
        width: `calc(100% + 24px)`,
        marginLeft: "var(--ds-space-negative-150, -12px)",
        marginRight: "var(--ds-space-negative-150, -12px)",
        transform: 'scale(1)',
        zIndex: 2
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.gridContainer': {
        position: 'fixed',
        height: '100vh',
        width: '100%',
        pointerEvents: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.gridLine': {
        borderLeft: `1px solid ${"var(--ds-border, #091E4224)"}`,
        display: 'inline-block',
        boxSizing: 'border-box',
        height: '100%',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginLeft: '-1px',
        transition: 'border-color 0.15s linear',
        zIndex: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.highlight': {
        borderLeft: `1px solid ${"var(--ds-border-focused, #388BFF)"}`
    }
});

});

parcelRegister("6tApo", function(module, exports) {

$parcel$export(module.exports, "indentationStyles", () => $6915d298031facd2$export$fc74cf03693076b4);
function $6915d298031facd2$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $6915d298031facd2$export$fc74cf03693076b4 = {
    name: "86ymtv",
    styles: ".ProseMirror{.fabric-editor-indentation-mark{&[data-level='1']{margin-left:30px;}&[data-level='2']{margin-left:60px;}&[data-level='3']{margin-left:90px;}&[data-level='4']{margin-left:120px;}&[data-level='5']{margin-left:150px;}&[data-level='6']{margin-left:180px;}}}"
};

});

parcelRegister("iFTJL", function(module, exports) {

$parcel$export(module.exports, "InlineNodeViewSharedStyles", () => $748764bed64b9090$export$3fc32cdc53f6edeb);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled
function $748764bed64b9090$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $748764bed64b9090$export$3fc32cdc53f6edeb = {
    name: "n6ftfq",
    styles: ".ProseMirror{.inlineNodeView{display:inline;user-select:all;white-space:nowrap;& > *:not(.zeroWidthSpaceContainer){white-space:pre-wrap;}& > .assistive{user-select:none;}}&.ua-safari{.inlineNodeView{&::selection, *::selection{background:transparent;}}}&.ua-chrome .inlineNodeView > span{user-select:none;}.inlineNodeViewAddZeroWidthSpace{&::after{content:'\u200B';}}}"
};

});

parcelRegister("a9Tj3", function(module, exports) {

$parcel$export(module.exports, "layoutColumnStylesAdvanced", () => $2612b88834a2d8d3$export$8dd21c7c24132a82);
$parcel$export(module.exports, "layoutColumnStylesNotAdvanced", () => $2612b88834a2d8d3$export$fe39d5414c0135d3);
$parcel$export(module.exports, "layoutColumnResponsiveStyles", () => $2612b88834a2d8d3$export$55890fd3e3be7f1b);
$parcel$export(module.exports, "layoutSectionStylesAdvanced", () => $2612b88834a2d8d3$export$d9912ef7f698aab8);
$parcel$export(module.exports, "layoutSectionStylesNotAdvanced", () => $2612b88834a2d8d3$export$17d7fe9c8be65e97);
$parcel$export(module.exports, "layoutSelectedStylesNotAdvanced", () => $2612b88834a2d8d3$export$cdcbf2d4bffabda6);
$parcel$export(module.exports, "layoutSelectedStylesAdvanced", () => $2612b88834a2d8d3$export$fe59793079ccb11a);
$parcel$export(module.exports, "layoutResponsiveBaseStyles", () => $2612b88834a2d8d3$export$c1454bb6dd8837f5);
$parcel$export(module.exports, "layoutResponsiveStylesForView", () => $2612b88834a2d8d3$export$203a03d09c37c555);
$parcel$export(module.exports, "layoutBaseStyles", () => $2612b88834a2d8d3$export$ce383b8d82e44bf5);
$parcel$export(module.exports, "layoutBaseStylesAdvanced", () => $2612b88834a2d8d3$export$74ce03ae8f7cbe1a);
$parcel$export(module.exports, "layoutBaseStylesFixesUnderNestedDnDFG", () => $2612b88834a2d8d3$export$4d009f8d3cbd5535);
$parcel$export(module.exports, "layoutSelectedStylesForViewAdvanced", () => $2612b88834a2d8d3$export$20e6a345585c5c3c);
$parcel$export(module.exports, "layoutSelectedStylesForViewNotAdvanced", () => $2612b88834a2d8d3$export$70038a77af1ac7b5);
$parcel$export(module.exports, "layoutStylesForView", () => $2612b88834a2d8d3$export$ec8bdd18ecbadae7);
$parcel$export(module.exports, "layoutColumnMartinTopFixesNew", () => $2612b88834a2d8d3$export$c60086c81c0ffabf);
$parcel$export(module.exports, "layoutColumnMartinTopFixesOld", () => $2612b88834a2d8d3$export$598dd68f26eb7eff);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $1NIU8 = parcelRequire("1NIU8");

var $famkW = parcelRequire("famkW");
function $2612b88834a2d8d3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2612b88834a2d8d3$var$gridMediumMaxWidth = 1024;
const $2612b88834a2d8d3$var$akEditorSelectedNodeClassName = 'ak-editor-selected-node';
const $2612b88834a2d8d3$var$selectorForNotResizedLayoutInFulllWidthEditor = '.fabric-editor--full-width-mode .ProseMirror > .layoutSectionView-content-wrap';
const $2612b88834a2d8d3$var$selectorForNotResizedLayoutInFixedWidthEditor = '.ak-editor-content-area:not(.fabric-editor--full-width-mode) .ProseMirror > .layoutSectionView-content-wrap';
const $2612b88834a2d8d3$var$selectorForResizedLayoutInFullOrFixedWidthEditor = '.ProseMirror .fabric-editor-breakout-mark .layoutSectionView-content-wrap';
const $2612b88834a2d8d3$var$layoutResponsiveSelectedSelector = `&.selected, &:hover, &.selected.danger, &.${$2612b88834a2d8d3$var$akEditorSelectedNodeClassName}:not(.danger)`;
const $2612b88834a2d8d3$var$layoutSelectedSelector = `&.selected, [data-empty-layout='true'], &:hover, &.selected.danger [data-layout-section], &.${$2612b88834a2d8d3$var$akEditorSelectedNodeClassName}:not(.danger) [data-layout-section]`;
const $2612b88834a2d8d3$export$8dd21c7c24132a82 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror [data-layout-section]': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '> [data-layout-column]': {
            margin: '0 4px'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors
        '> [data-layout-column]:first-of-type': {
            marginLeft: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors
        '> [data-layout-column]:last-of-type': {
            marginRight: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`@media screen and (max-width: ${$2612b88834a2d8d3$var$gridMediumMaxWidth}px)`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '[data-layout-column] + [data-layout-column]': {
                margin: 0
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`> [data-layout-column].${$2612b88834a2d8d3$var$akEditorSelectedNodeClassName}:not(.danger)`]: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $famkW.blanketSelectionStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $famkW.hideNativeBrowserTextSelectionStyles),
            {
                // layout column selection shorter after layout border has been removed
                '::before': {
                    width: 'calc(100% - 8px)',
                    left: 4,
                    borderRadius: "var(--ds-border-radius, 3px)"
                }
            }
        ]
    }
});
const $2612b88834a2d8d3$export$fe39d5414c0135d3 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror [data-layout-section]': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-layout-column] + [data-layout-column]': {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginLeft: 8
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`@media screen and (max-width: ${$2612b88834a2d8d3$var$gridMediumMaxWidth}px)`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '[data-layout-column] + [data-layout-column]': {
                marginLeft: 0
            }
        }
    }
});
const $2612b88834a2d8d3$export$55890fd3e3be7f1b = {
    name: "4jflbi",
    styles: ".ProseMirror [data-layout-section]{display:flex;flex-direction:row;gap:var(--ds-space-100, 8px);& > *{flex:1;min-width:0;}& > .unsupportedBlockView-content-wrap{min-width:initial;}}.layout-section-container{container-type:inline-size;container-name:layout-area;}"
};
const $2612b88834a2d8d3$export$d9912ef7f698aab8 = {
    name: "xjr39a",
    styles: ".ProseMirror .layout-section-container [data-layout-section]{> .ProseMirror-widget{flex:none;display:contents !important;&[data-blocks-drag-handle-container] div{display:contents !important;}&[data-blocks-drop-target-container]{display:block !important;margin:var(--ds-space-negative-050, -4px);[data-drop-target-for-element]{position:absolute;}}& + [data-layout-column]{margin:0;}}> [data-layout-column]{margin:0;}}"
};
const $2612b88834a2d8d3$export$17d7fe9c8be65e97 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.ProseMirror [data-layout-section]': {
        position: 'relative',
        display: 'flex',
        flexDirection: 'row',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > *': {
            flex: 1,
            minWidth: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > .unsupportedBlockView-content-wrap': {
            minWidth: 'initial'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`@media screen and (max-width: ${$2612b88834a2d8d3$var$gridMediumMaxWidth}px)`]: {
            flexDirection: 'column'
        }
    }
});
const $2612b88834a2d8d3$export$cdcbf2d4bffabda6 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-layout-section], .layoutSectionView-content-wrap': {
            // Shows the border when cursor is inside a layout
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.selected [data-layout-column], &:hover [data-layout-column]': {
                border: `1px solid ${"var(--ds-border, #091E4224)"}`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.selected.danger [data-layout-column]': {
                backgroundColor: "var(--ds-background-danger, #FFECEB)",
                borderColor: "var(--ds-border-danger, #E2483D)"
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`&.${$2612b88834a2d8d3$var$akEditorSelectedNodeClassName}:not(.danger)`]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                '[data-layout-column]': [
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                    (0, $famkW.borderSelectionStyles),
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                    (0, $famkW.blanketSelectionStyles),
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                    (0, $famkW.hideNativeBrowserTextSelectionStyles),
                    {
                        '::after': {
                            backgroundColor: 'transparent'
                        }
                    }
                ]
            }
        }
    }
});
// TODO: ED-28075 - inline rowSeparatorBaseStyles to unblock Compiled CSS migration
const $2612b88834a2d8d3$var$rowSeparatorBaseStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-layout-content]::before': {
        content: "''",
        borderTop: `1px solid ${"var(--ds-border, #091E4224)"}`,
        position: 'absolute',
        width: 'calc(100% - 32px)',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: -13,
        // clear styles for column separator
        borderLeft: 'unset',
        marginLeft: 'unset',
        height: 'unset'
    }
});
const $2612b88834a2d8d3$export$fe59793079ccb11a = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-layout-section], .layoutSectionView-content-wrap': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
            [$2612b88834a2d8d3$var$layoutSelectedSelector]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
                '[data-layout-column]:not(:first-of-type) [data-layout-content]::before': {
                    content: "''",
                    borderLeft: `1px solid ${"var(--ds-border, #091E4224)"}`,
                    position: 'absolute',
                    height: 'calc(100% - 24px)',
                    // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
                    marginLeft: -25
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.selected.danger [data-layout-section]': {
                backgroundColor: "var(--ds-background-danger, #FFECEB)",
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`,
                borderRadius: 4
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`&.${$2612b88834a2d8d3$var$akEditorSelectedNodeClassName}:not(.danger) [data-layout-section]`]: {
                boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #0C66E4)"}`,
                borderRadius: 4,
                backgroundColor: "var(--ds-background-selected, #E9F2FF)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                '[data-layout-column]': [
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                    (0, $famkW.blanketSelectionStyles),
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                    (0, $famkW.hideNativeBrowserTextSelectionStyles),
                    {
                        border: 0,
                        '::before': {
                            backgroundColor: 'transparent'
                        }
                    }
                ]
            }
        }
    }
});
const $2612b88834a2d8d3$export$c1454bb6dd8837f5 = /*#__PURE__*/ (0, $1NIU8.css)({
    // chosen breakpoints in container queries are to make sure layout responsiveness in editor aligns with renderer
    // not resized layout in full-width editor
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [$2612b88834a2d8d3$var$selectorForNotResizedLayoutInFulllWidthEditor]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-layout-section]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries
            '@container editor-area (max-width:724px)': {
                flexDirection: 'column'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [$2612b88834a2d8d3$var$layoutResponsiveSelectedSelector]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors
            '[data-layout-column]:not(:first-of-type)': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries,@atlaskit/ui-styling-standard/no-unsafe-values
                [`@container editor-area (max-width:724px)`]: $2612b88834a2d8d3$var$rowSeparatorBaseStyles
            }
        }
    },
    // not resized layout in fixed-width editor
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [$2612b88834a2d8d3$var$selectorForNotResizedLayoutInFixedWidthEditor]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-layout-section]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries
            '@container editor-area (max-width:788px)': {
                flexDirection: 'column'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [$2612b88834a2d8d3$var$layoutResponsiveSelectedSelector]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors
            '[data-layout-column]:not(:first-of-type)': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries,@atlaskit/ui-styling-standard/no-unsafe-values
                [`@container editor-area (max-width:788px)`]: $2612b88834a2d8d3$var$rowSeparatorBaseStyles
            }
        }
    },
    // resized layout in full/fixed-width editor
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [$2612b88834a2d8d3$var$selectorForResizedLayoutInFullOrFixedWidthEditor]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-layout-section]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries
            '@container editor-area (max-width:820px)': {
                flexDirection: 'column'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [$2612b88834a2d8d3$var$layoutResponsiveSelectedSelector]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors
            '[data-layout-column]:not(:first-of-type)': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries,@atlaskit/ui-styling-standard/no-unsafe-values
                [`@container editor-area (max-width:820px)`]: $2612b88834a2d8d3$var$rowSeparatorBaseStyles
            }
        }
    }
});
const $2612b88834a2d8d3$export$203a03d09c37c555 = /*#__PURE__*/ (0, $1NIU8.css)({
    // chosen breakpoints in container queries are to make sure layout responsiveness in editor aligns with renderer
    // not resized layout in full-width editor
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [$2612b88834a2d8d3$var$selectorForNotResizedLayoutInFulllWidthEditor]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [$2612b88834a2d8d3$var$layoutResponsiveSelectedSelector]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors
            '[data-layout-column]:not(:first-of-type)': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries,@atlaskit/ui-styling-standard/no-unsafe-values
                [`@container editor-area (max-width:724px)`]: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                    '[data-layout-content]::before': {
                        borderTop: 0
                    }
                }
            }
        }
    },
    // not resized layout in fixed-width editor
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [$2612b88834a2d8d3$var$selectorForNotResizedLayoutInFixedWidthEditor]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [$2612b88834a2d8d3$var$layoutResponsiveSelectedSelector]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors
            '[data-layout-column]:not(:first-of-type)': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries,@atlaskit/ui-styling-standard/no-unsafe-values
                [`@container editor-area (max-width:788px)`]: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                    '[data-layout-content]::before': {
                        borderTop: 0
                    }
                }
            }
        }
    },
    // resized layout in full/fixed-width editor
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [$2612b88834a2d8d3$var$selectorForResizedLayoutInFullOrFixedWidthEditor]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [$2612b88834a2d8d3$var$layoutResponsiveSelectedSelector]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors
            '[data-layout-column]:not(:first-of-type)': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries,@atlaskit/ui-styling-standard/no-unsafe-values
                [`@container editor-area (max-width:820px)`]: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                    '[data-layout-content]::before': {
                        borderTop: 0
                    }
                }
            }
        }
    }
});
const $2612b88834a2d8d3$export$ce383b8d82e44bf5 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-layout-section]': {
            margin: `${"var(--ds-space-100, 8px)"} -12px 0`,
            transition: 'border-color 0.3s cubic-bezier(0.15, 1, 0.3, 1)',
            cursor: 'pointer',
            // Inner cursor located 26px from left
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '[data-layout-column]': {
                flex: 1,
                position: 'relative',
                minWidth: 0,
                /* disable 4 borders when in view mode and advanced layouts is on */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                border: `1px solid ${"var(--ds-border, #091E4224)"}`,
                borderRadius: 4,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                padding: "var(--ds-space-150, 12px)",
                boxSizing: 'border-box',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '> div': {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
                    '> .embedCardView-content-wrap:first-of-type .rich-media-item': {
                        marginTop: 0
                    },
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
                    '> .mediaSingleView-content-wrap:first-of-type .rich-media-item': {
                        marginTop: 0
                    },
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
                    '> .ProseMirror-gapcursor.-right:first-child + .mediaSingleView-content-wrap .rich-media-item, > style:first-child + .ProseMirror-gapcursor.-right + .mediaSingleView-content-wrap .rich-media-item, > .ProseMirror-gapcursor.-right:first-of-type + .embedCardView-content-wrap .rich-media-item': {
                        marginTop: 0
                    },
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
                    '> .ProseMirror-gapcursor:first-child + span + .mediaSingleView-content-wrap .rich-media-item, > style:first-child + .ProseMirror-gapcursor + span + .mediaSingleView-content-wrap .rich-media-item': {
                        marginTop: 0
                    },
                    // Prevent first DecisionWrapper's margin-top: 8px from shifting decisions down and shrinking layout's node selectable area (leniency margin)
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                    "> [data-node-type='decisionList']": {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
                        'li:first-of-type [data-decision-wrapper]': {
                            marginTop: 0
                        }
                    }
                },
                // Make the 'content' fill the entire height of the layout column to allow click handler of layout section nodeview to target only data-layout-column
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '[data-layout-content]': {
                    height: '100%',
                    cursor: 'text',
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                    '.mediaGroupView-content-wrap': {
                        clear: 'both'
                    }
                }
            }
        }
    },
    // hide separator when element is dragging on top of a layout column
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-blocks-drop-target-container] ~ [data-layout-column] > [data-layout-content]::before': {
        display: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.fabric-editor--full-width-mode .ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-layout-section]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.pm-table-container': {
                margin: '0 2px'
            }
        }
    }
});
const $2612b88834a2d8d3$export$74ce03ae8f7cbe1a = {
    name: "14on7sz",
    styles: ".ProseMirror [data-layout-section] [data-layout-column]{border:0;}"
};
const $2612b88834a2d8d3$export$4d009f8d3cbd5535 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror [data-layout-section]': {
        margin: `${"var(--ds-space-100, 8px)"} -20px 0`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror [data-layout-section] [data-layout-column]': {
        padding: '12px 20px'
    }
});
const $2612b88834a2d8d3$export$20e6a345585c5c3c = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-layout-section], .layoutSectionView-content-wrap': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-nested-selectors
            [$2612b88834a2d8d3$var$layoutSelectedSelector]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
                '[data-layout-column]:not(:first-of-type) [data-layout-content]::before': {
                    borderLeft: 0
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.selected.danger [data-layout-section]': {
                boxShadow: `0 0 0 0 ${"var(--ds-border-danger, #E2483D)"}`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-nested-selectors
            [`&.${$2612b88834a2d8d3$var$akEditorSelectedNodeClassName}:not(.danger) [data-layout-section]`]: {
                boxShadow: `0 0 0 0 ${"var(--ds-border-selected, #0C66E4)"}`
            }
        }
    }
});
const $2612b88834a2d8d3$export$70038a77af1ac7b5 = {
    name: "1nqe1o0",
    styles: ".ProseMirror{[data-layout-section], .layoutSectionView-content-wrap{&.selected [data-layout-column], &:hover [data-layout-column]{border:0;}}}"
};
const $2612b88834a2d8d3$export$ec8bdd18ecbadae7 = {
    name: "1xloaqb",
    styles: ".ProseMirror{[data-layout-section]{cursor:default;[data-layout-column]{border:0;}}}"
};
const $2612b88834a2d8d3$export$c60086c81c0ffabf = {
    name: "1gk7267",
    styles: ".ProseMirror [data-layout-section] [data-layout-column] > div{> :nth-child(1 of :not(style, .ProseMirror-gapcursor, .ProseMirror-widget, span)){margin-top:0;}}"
};
const $2612b88834a2d8d3$export$598dd68f26eb7eff = {
    name: "uvfuhz",
    styles: ".ProseMirror [data-layout-section] [data-layout-column] > div{> :not(style):first-child, > style:first-child + *{margin-top:0;}> .ProseMirror-gapcursor:first-child + *, > style:first-child + .ProseMirror-gapcursor + *{margin-top:0;}> .ProseMirror-gapcursor:first-child + span + *{margin-top:0;}}"
};

});

parcelRegister("9dvIW", function(module, exports) {

$parcel$export(module.exports, "linkStyles", () => $e216d8155bc86c53$export$4ea5976125a01ffa);
$parcel$export(module.exports, "linkStylesOld", () => $e216d8155bc86c53$export$d9d1ccc645b021);
$parcel$export(module.exports, "hyperLinkFloatingToolbarStyles", () => $e216d8155bc86c53$export$889b949305b162f9);
$parcel$export(module.exports, "linkLegacyIconStylesFix", () => $e216d8155bc86c53$export$e696625219a66da6);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled
function $e216d8155bc86c53$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e216d8155bc86c53$export$4ea5976125a01ffa = {
    name: "aj1leh",
    styles: ".ProseMirror a.blockLink{display:block;}.ProseMirror a[data-prosemirror-mark-name=\"link\"]{text-decoration:underline;}.ProseMirror a[data-prosemirror-mark-name=\"link\"]:hover{text-decoration:none;}"
};
const $e216d8155bc86c53$export$d9d1ccc645b021 = {
    name: "qnti7x",
    styles: ".ProseMirror a.blockLink{display:block;}"
};
const $e216d8155bc86c53$export$889b949305b162f9 = {
    name: "1cwtun1",
    styles: ".hyperlink-floating-toolbar{padding:0;}"
};
const $e216d8155bc86c53$export$e696625219a66da6 = {
    name: "1li8ktf",
    styles: ".hyperlink-open-link{min-width:24px;svg{max-width:18px;}}"
};

});

parcelRegister("d2E5F", function(module, exports) {

$parcel$export(module.exports, "listsStyles", () => $2ab7e6e52b65acbd$export$5f95d55c83a3b7bc);
$parcel$export(module.exports, "listsStylesSafariFix", () => $2ab7e6e52b65acbd$export$dba87c9b43c1033d);

var $1NIU8 = parcelRequire("1NIU8");
// copied from packages/editor/editor-shared-styles/src/consts/consts.ts
const $2ab7e6e52b65acbd$var$akEditorLineHeight = 1.714;
// copied from packages/editor/editor-common/src/styles/shared/smart-card.ts
const $2ab7e6e52b65acbd$var$BLOCK_CARD_CONTAINER = 'blockCardView-content-wrap';
// copied from packages/editor/editor-shared-styles/src/consts/consts.ts
const $2ab7e6e52b65acbd$var$blockNodesVerticalMargin = '0.75rem';
const $2ab7e6e52b65acbd$export$5f95d55c83a3b7bc = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        /* =============== INDENTATION SPACING ========= */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'ul, ol': {
            boxSizing: 'border-box',
            paddingLeft: `var(--ed--list--item-counter--padding, 24px)`
        },
        // Firefox does not handle empty block element inside li tag.
        // If there is not block element inside li tag,	then firefox sets inherited height to li
        // However, if there is any block element and if it's empty	(or has empty inline element) then
        // firefox sets li tag height to zero.
        //
        // More details at
        // https://product-fabric.atlassian.net/wiki/spaces/~455502413/pages/3149365890/ED-14110+Investigation
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.ua-firefox': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            'ul, ol': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                'li p:empty, li p > span:empty': {
                    display: 'inline-block'
                }
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-ol, .ak-ul': {
            // Ensures list item content adheres to the list's margin instead
            // of filling the entire block row. This is important to allow
            // clicking interactive elements which are floated next to a list.
            //
            // For some history and context on this block, see PRs related to tickets.:
            // @see ED-6551 - original issue.
            // @see ED-7015 - follow up issue.
            // @see ED-7447 - flow-root change.
            //
            // @see https://css-tricks.com/display-flow-root/
            //
            // For older browsers the do not support flow-root. */
            // stylelint-disable declaration-block-no-duplicate-properties */
            display: 'flow-root'
        },
        /* =============== INDENTATION AESTHETICS ========= */ // We support nested lists up to six levels deep.
        /*  ======== LEGACY LISTS ======== */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'ul, ul ul ul ul': {
            listStyleType: 'disc'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'ul ul, ul ul ul ul ul': {
            listStyleType: 'circle'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'ul ul ul, ul ul ul ul ul ul': {
            listStyleType: 'square'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'ol, ol ol ol ol': {
            listStyleType: 'decimal'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'ol ol, ol ol ol ol ol': {
            listStyleType: 'lower-alpha'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'ol ol ol, ol ol ol ol ol ol': {
            listStyleType: 'lower-roman'
        },
        /* ======== PREDICTABLE LISTS ======== */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "ol[data-indent-level='1'], ol[data-indent-level='4']": {
            listStyleType: 'decimal'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "ol[data-indent-level='2'], ol[data-indent-level='5']": {
            listStyleType: 'lower-alpha'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "ol[data-indent-level='3'], ol[data-indent-level='6']": {
            listStyleType: 'lower-roman'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "ul[data-indent-level='1'], ul[data-indent-level='4']": {
            listStyleType: 'disc'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "ul[data-indent-level='2'], ul[data-indent-level='5']": {
            listStyleType: 'circle'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "ul[data-indent-level='3'], ul[data-indent-level='6']": {
            listStyleType: 'square'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        li: {
            position: 'relative',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '& > p:not(:first-child)': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                margin: `${"var(--ds-space-050, 4px)"} 0 0 0`
            },
            /* In SSR the above rule will apply to all p tags because first-child would be a style tag.
      	The following rule resets the first p tag back to its original margin
      	defined in packages/editor/editor-common/src/styles/shared/paragraph.ts */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '& > style:first-child + p': {
                marginTop: $2ab7e6e52b65acbd$var$blockNodesVerticalMargin
            }
        }
    }
});
const $2ab7e6e52b65acbd$export$dba87c9b43c1033d = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.ProseMirror:not(.${$2ab7e6e52b65acbd$var$BLOCK_CARD_CONTAINER}) > li::before`]: {
        content: '" "',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        lineHeight: $2ab7e6e52b65acbd$var$akEditorLineHeight
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.ProseMirror:not(.${$2ab7e6e52b65acbd$var$BLOCK_CARD_CONTAINER}) > li > p:first-child, .ProseMirror:not(.${$2ab7e6e52b65acbd$var$BLOCK_CARD_CONTAINER}) > li > .code-block:first-child, .ProseMirror:not(.${$2ab7e6e52b65acbd$var$BLOCK_CARD_CONTAINER}) > li > .ProseMirror-gapcursor:first-child + .code-block`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        marginTop: `-${$2ab7e6e52b65acbd$var$akEditorLineHeight}em !important`
    }
});

});

parcelRegister("jw6co", function(module, exports) {

$parcel$export(module.exports, "mediaStyles", () => $2ceb85f8698e9c0d$export$abd2efc27ac7e809);
$parcel$export(module.exports, "mediaGroupStyles", () => $2ceb85f8698e9c0d$export$cbc2f5b7ba4a5b45);
$parcel$export(module.exports, "mediaAlignmentStyles", () => $2ceb85f8698e9c0d$export$228abfa0106fa708);

var $1NIU8 = parcelRequire("1NIU8");

var $dA9km = parcelRequire("dA9km");

var $cYzoj = parcelRequire("cYzoj");
var $laqWo = parcelRequire("laqWo");

var $7yBx7 = parcelRequire("7yBx7");

var $jbnQ0 = parcelRequire("jbnQ0");
function $2ceb85f8698e9c0d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2ceb85f8698e9c0d$var$wrappedMediaBreakoutPoint = 410;
/**
 * Reference Heights
 *
 * These heights enforce consistent sizes with media inline nodes due to
 * inconsistencies with center aligned inline nodes and text.
 *
 * There is conversation about refactoring media inline nodes to conform to
 * aligning correctly with the surrounding text.
 *
 * These constants originally came from `headingSizes` from the `theme` package
 * and have been copied here to remove this package.
 */ const $2ceb85f8698e9c0d$var$referenceHeights = {
    p: 22,
    h1: 36,
    h2: 31,
    h3: 25,
    h4: 23,
    h5: 20,
    h6: 18
};
const $2ceb85f8698e9c0d$var$inlineImageSelector = `> .mediaInlineView-content-wrap > .${(0, $dA9km.INLINE_IMAGE_WRAPPER_CLASS_NAME)}, > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${(0, $dA9km.INLINE_IMAGE_WRAPPER_CLASS_NAME)}, > .${(0, $dA9km.INLINE_IMAGE_WRAPPER_CLASS_NAME)}, > :is(a, span[data-mark-type='border']) .${(0, $dA9km.INLINE_IMAGE_WRAPPER_CLASS_NAME)}`;
const $2ceb85f8698e9c0d$export$abd2efc27ac7e809 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-imported-style-values
        [`li .${0, $laqWo.richMediaClassName}`]: {
            margin: 0
        },
        // Hack for chrome to fix media single position inside a list when media is the first child
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.ua-chrome li > .mediaSingleView-content-wrap::before': {
            content: "''",
            display: 'block',
            height: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.ua-firefox': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.mediaSingleView-content-wrap': {
                userSelect: 'none'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.captionView-content-wrap': {
                userSelect: 'text'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        ".mediaSingleView-content-wrap[layout^='wrap-']": {
            position: 'relative',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-imported-style-values
            zIndex: (0, $7yBx7.akEditorWrappedNodeZIndex),
            maxWidth: '100%',
            /* overwrite default Prosemirror setting making it clear: both */ clear: 'inherit'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        ".mediaSingleView-content-wrap[layout='center']": {
            clear: 'both'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-imported-style-values
        [`table .${0, $laqWo.richMediaClassName}`]: {
            marginTop: "var(--ds-space-150, 12px)",
            marginBottom: "var(--ds-space-150, 12px)",
            clear: 'both',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.image-wrap-left[data-layout], &.image-wrap-right[data-layout]': {
                clear: 'none',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
                '&:first-child': {
                    marginTop: "var(--ds-space-150, 12px)"
                }
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-imported-style-values
        [`.${0, $laqWo.richMediaClassName}.image-wrap-right + .${0, $laqWo.richMediaClassName}.image-wrap-left`]: {
            clear: 'both'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-imported-style-values
        [`.${0, $laqWo.richMediaClassName}.image-wrap-left + .${0, $laqWo.richMediaClassName}.image-wrap-right, .${0, $laqWo.richMediaClassName}.image-wrap-right + .${0, $laqWo.richMediaClassName}.image-wrap-left, .${0, $laqWo.richMediaClassName}.image-wrap-left + .${0, $laqWo.richMediaClassName}.image-wrap-left, .${0, $laqWo.richMediaClassName}.image-wrap-right + .${0, $laqWo.richMediaClassName}.image-wrap-right`]: {
            marginRight: 0,
            marginLeft: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`@media all and (max-width: ${$2ceb85f8698e9c0d$var$wrappedMediaBreakoutPoint}px)`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            "div.mediaSingleView-content-wrap[layout='wrap-left'], div.mediaSingleView-content-wrap[data-layout='wrap-left'], div.mediaSingleView-content-wrap[layout='wrap-right'], div.mediaSingleView-content-wrap[data-layout='wrap-right']": {
                float: 'none',
                overflow: 'auto',
                margin: `${"var(--ds-space-150, 12px)"} 0`
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`& [layout='full-width'] .${0, $laqWo.richMediaClassName}, & [layout='wide'] .${0, $laqWo.richMediaClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginLeft: '50%',
            transform: 'translateX(-50%)'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        ".media-extended-resize-experience[layout^='wrap-']": {
            // override 'overflow: auto' when viewport <= 410 set by mediaSingleSharedStyle
            // to prevent scroll bar
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            overflow: 'visible !important'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "& [layout^='wrap-'] + [layout^='wrap-']": {
            clear: 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            "& + p, & + div[class^='fabric-editor-align'], & + ul, & + ol, & + h1, & + h2, & + h3, & + h4, & + h5, & + h6": {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles,@atlaskit/ui-styling-standard/no-unsafe-values
                clear: 'both !important'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`& .${0, $laqWo.richMediaClassName}`]: {
                marginLeft: 0,
                marginRight: 0
            }
        },
        // Shifting the mediaInline image component (renders image) to align nicely with
        // mediaInline (renders text) is a bit of a testing ground. This numbers represent
        // shift in top and bottom and size adjustments to make up for lack of 1to1 size
        //  mapping
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${0, $dA9km.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            height: $2ceb85f8698e9c0d$var$referenceHeights['p'],
            transform: 'translateY(-2px)'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        h1: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [$2ceb85f8698e9c0d$var$inlineImageSelector]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                height: $2ceb85f8698e9c0d$var$referenceHeights.h1,
                transform: `translateY(-3px)`
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        h2: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [$2ceb85f8698e9c0d$var$inlineImageSelector]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                height: $2ceb85f8698e9c0d$var$referenceHeights.h2,
                transform: `translateY(-3px)`
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        h3: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [$2ceb85f8698e9c0d$var$inlineImageSelector]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                height: $2ceb85f8698e9c0d$var$referenceHeights.h3,
                transform: `translateY(-2px)`
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        h4: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [$2ceb85f8698e9c0d$var$inlineImageSelector]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                height: $2ceb85f8698e9c0d$var$referenceHeights.h4,
                transform: `translateY(-2px)`
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        h5: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [$2ceb85f8698e9c0d$var$inlineImageSelector]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                height: $2ceb85f8698e9c0d$var$referenceHeights.h5,
                transform: `translateY(-2px)`
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        h6: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [$2ceb85f8698e9c0d$var$inlineImageSelector]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                height: $2ceb85f8698e9c0d$var$referenceHeights.h6,
                transform: `translateY(-2px)`
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        ".mediaSingleView-content-wrap[layout='wrap-left']": {
            float: 'left'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        ".mediaSingleView-content-wrap[layout='wrap-right']": {
            float: 'right'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        ".mediaSingleView-content-wrap[layout='wrap-right'] + .mediaSingleView-content-wrap[layout='wrap-left']": {
            clear: 'both'
        },
        // Larger margins for resize handlers when at depth 0 of the document
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& > .mediaSingleView-content-wrap': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.richMedia-resize-handle-right': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
                marginRight: `-${(0, $7yBx7.akEditorMediaResizeHandlerPaddingWide)}px`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.richMedia-resize-handle-left': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
                marginLeft: `-${(0, $7yBx7.akEditorMediaResizeHandlerPaddingWide)}px`
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values,@atlaskit/ui-styling-standard/no-imported-style-values
    [`.${(0, $cYzoj.ClassNames).FLOATING_TOOLBAR_COMPONENT}`]: {
        padding: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.richMedia-resize-handle-right, .richMedia-resize-handle-left': {
        display: 'flex',
        flexDirection: 'column',
        /* vertical align */ justifyContent: 'center'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.richMedia-resize-handle-right': {
        alignItems: 'flex-end',
        paddingRight: "var(--ds-space-150, 12px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
        marginRight: `-${(0, $7yBx7.akEditorMediaResizeHandlerPadding)}px`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.richMedia-resize-handle-left': {
        alignItems: 'flex-start',
        paddingLeft: "var(--ds-space-150, 12px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
        marginLeft: `-${(0, $7yBx7.akEditorMediaResizeHandlerPadding)}px`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.richMedia-resize-handle-right::after, .richMedia-resize-handle-left::after': {
        content: "' '",
        display: 'flex',
        width: 3,
        height: 64,
        borderRadius: 6
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${0, $laqWo.richMediaClassName}:hover .richMedia-resize-handle-left::after, .${0, $laqWo.richMediaClassName}:hover .richMedia-resize-handle-right::after`]: {
        background: "var(--ds-border, #091E4224)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${0, $7yBx7.akEditorSelectedNodeClassName} .richMedia-resize-handle-right::after, .${0, $7yBx7.akEditorSelectedNodeClassName} .richMedia-resize-handle-left::after, .${0, $laqWo.richMediaClassName} .richMedia-resize-handle-right:hover::after, .${0, $laqWo.richMediaClassName} .richMedia-resize-handle-left:hover::after, .${0, $laqWo.richMediaClassName}.is-resizing .richMedia-resize-handle-right::after, .${0, $laqWo.richMediaClassName}.is-resizing .richMedia-resize-handle-left::after`]: {
        background: "var(--ds-border-focused, #388BFF)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.__resizable_base__': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        left: 'unset !important',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        width: 'auto !important',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        height: 'auto !important'
    },
    // Danger when top level node for smart cards / inline links
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.danger > div > div > .media-card-frame, .danger > span > a': {
        backgroundColor: "var(--ds-background-danger, #FFECEB)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
        boxShadow: `0px 0px 0px ${(0, $7yBx7.akEditorSelectedBorderBoldSize)}px, ${"var(--ds-border-danger, #E2483D)"}`,
        transition: 'background-color 0s, box-shadow 0s'
    },
    // Danger when nested node or common
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.danger': {
        // Media single
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${0, $laqWo.richMediaClassName} .${0, $87b212d64266f221$export$7a6526d4be3b7eb3}::after`]: {
            border: `1px solid ${"var(--ds-border-danger, #E2483D)"}`
        },
        // Media single video player
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${0, $laqWo.richMediaClassName} .${0, $jbnQ0.inlinePlayerClassName}::after`]: {
            border: `1px solid ${"var(--ds-border-danger, #E2483D)"}`
        },
        // New file experience
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${0, $laqWo.richMediaClassName} .${0, $c214caf0b65ba182$export$c5ba918dbb0b00f3}`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"} !important`
        },
        // Media resize legacy handlers
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.richMedia-resize-handle-right::after, .richMedia-resize-handle-left::after': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            background: `${"var(--ds-icon-danger, #C9372C)"} !important`
        },
        // Media resize new handlers
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.resizer-handle-thumb': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            background: `${"var(--ds-icon-danger, #C9372C)"} !important`
        },
        // Smart cards
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'div div .media-card-frame, .inlineCardView-content-wrap > span > a': {
            backgroundColor: `${"var(--ds-blanket-danger, #EF5C4814)"}`,
            transition: `background-color 0s`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'div div .media-card-frame::after': {
            boxShadow: 'none'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.warning': {
        // Media single
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${0, $laqWo.richMediaClassName} .${0, $87b212d64266f221$export$7a6526d4be3b7eb3}::after`]: {
            border: `1px solid ${"var(--ds-border-warning, #E56910)"}`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${0, $laqWo.richMediaClassName} .${0, $jbnQ0.inlinePlayerClassName}::after`]: {
            border: `1px solid ${"var(--ds-border-warning, #E56910)"}`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${0, $laqWo.richMediaClassName} .${0, $c214caf0b65ba182$export$c5ba918dbb0b00f3}`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            boxShadow: `0 0 0 1px ${"var(--ds-border-warning, #E56910)"} !important`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.resizer-handle-thumb': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            background: `${"var(--ds-icon-warning, #E56910)"} !important`
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.media-filmstrip-list-item': {
        cursor: 'pointer'
    },
    // When clicking drag handle, mediaGroup node will be selected. Hence we need to apply selected style to each media node
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.mediaGroupView-content-wrap.${0, $7yBx7.akEditorSelectedNodeClassName} #newFileExperienceWrapper`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/ui-styling-standard/no-unsafe-values
        boxShadow: (0, $7yBx7.akEditorSelectedBoxShadow)
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ak-editor-no-interaction #newFileExperienceWrapper': {
        boxShadow: 'none'
    }
});
const $2ceb85f8698e9c0d$export$cbc2f5b7ba4a5b45 = {
    name: "efqvbk",
    styles: ".mediaGroupView-content-wrap ul{padding:0;}"
};
const $2ceb85f8698e9c0d$export$228abfa0106fa708 = {
    name: "1u86ffv",
    styles: ".fabric-editor-block-mark[class^=\"fabric-editor-align\"]{clear:none;}.fabric-editor-align-end{text-align:right;}.fabric-editor-align-start{text-align:left;}.fabric-editor-align-center{text-align:center;}.fabric-editor--full-width-mode{.pm-table-container{.code-block, .extension-container, .multiBodiedExtension--container{max-width:100%;}}}"
};

});

parcelRegister("51Rgo", function(module, exports) {

$parcel$export(module.exports, "mentionsStyles", () => $b4303f6126700a98$export$1445f2e2b3a1d9c8);
$parcel$export(module.exports, "mentionNodeStyles", () => $b4303f6126700a98$export$5fb9b21e3678e9ac);
$parcel$export(module.exports, "mentionsStylesMixin_platform_editor_centre_mention_padding", () => $b4303f6126700a98$export$2ebd33ccf1b7a9f0);
$parcel$export(module.exports, "mentionsSelectionStyles", () => $b4303f6126700a98$export$8697a9554aac2a5a);
$parcel$export(module.exports, "mentionsSelectionStylesWithSearchMatch", () => $b4303f6126700a98$export$13ab2f17ccaf48f6);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $1NIU8 = parcelRequire("1NIU8");

var $av5GH = parcelRequire("av5GH");

var $7yBx7 = parcelRequire("7yBx7");

var $famkW = parcelRequire("famkW");
function $b4303f6126700a98$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/* need to specify dark text colour because personal mentions
(in dark blue) have white text by default */ const $b4303f6126700a98$var$mentionsSelectedColor = {
    name: "4hmdsz",
    styles: "color:var(--ds-text-subtle, #44546F)"
};
const $b4303f6126700a98$export$1445f2e2b3a1d9c8 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.${(0, $av5GH.MentionSharedCssClassName).MENTION_CONTAINER}`]: {
        // TODO: ED-28075 - refactor selection styles to unblock Compiled CSS migration
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`&.${0, $7yBx7.akEditorSelectedNodeClassName} [data-mention-id] > span`]: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $famkW.boxShadowSelectionStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $famkW.backgroundSelectionStyles),
            $b4303f6126700a98$var$mentionsSelectedColor
        ]
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.danger': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`.${(0, $av5GH.MentionSharedCssClassName).MENTION_CONTAINER}.${0, $7yBx7.akEditorSelectedNodeClassName}`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '> span > span > span': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
                boxShadow: `0 0 0 ${(0, $7yBx7.akEditorSelectedBorderSize)}px ${(0, $7yBx7.akEditorDeleteBorder)}`,
                backgroundColor: "var(--ds-background-danger, #FFECEB)"
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`.${(0, $av5GH.MentionSharedCssClassName).MENTION_CONTAINER} > span > span > span`]: {
            backgroundColor: "var(--ds-background-neutral, #091E420F)",
            color: "var(--ds-text-subtle, #44546F)"
        }
    }
});
const $b4303f6126700a98$export$5fb9b21e3678e9ac = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.editor-mention-primitive': {
        display: 'inline',
        borderRadius: '20px',
        cursor: 'pointer',
        padding: '0 0.3em 2px 0.23em',
        // To match `packages/elements/mention/src/components/Mention/PrimitiveMention.tsx` implementation
        // we match the line height exactly
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: '1.714',
        fontWeight: "var(--ds-font-weight-regular, 400)",
        wordBreak: 'break-word',
        background: "var(--ds-background-neutral, #091E420F)",
        border: '1px solid transparent',
        color: "var(--ds-text-subtle, #44546F)",
        '&:hover': {
            background: "var(--ds-background-neutral-hovered, #091E4224)"
        },
        '&:active': {
            background: "var(--ds-background-neutral-pressed, #091E424F)"
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.editor-mention-primitive.mention-restricted': {
        background: 'transparent',
        border: `1px solid ${"var(--ds-border-bold, #758195)"}`,
        color: "var(--ds-text, #172B4D)",
        '&:hover': {
            background: 'transparent'
        },
        '&:active': {
            background: 'transparent'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.editor-mention-primitive.mention-self': {
        background: "var(--ds-background-brand-bold, #0C66E4)",
        border: '1px solid transparent',
        color: "var(--ds-text-inverse, #FFFFFF)",
        '&:hover': {
            background: "var(--ds-background-brand-bold-hovered, #0055CC)"
        },
        '&:active': {
            background: "var(--ds-background-brand-bold-pressed, #09326C)"
        }
    }
});
const $b4303f6126700a98$export$2ebd33ccf1b7a9f0 = {
    name: "1n5x4b4",
    styles: ".editor-mention-primitive{padding:1px 0.3em 1px 0.23em;}"
};
const $b4303f6126700a98$export$8697a9554aac2a5a = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.danger': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.editor-mention-primitive': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            boxShadow: `0 0 0 ${(0, $7yBx7.akEditorSelectedBorderSize)}px ${(0, $7yBx7.akEditorDeleteBorder)}`,
            backgroundColor: "var(--ds-background-danger, #FFECEB)"
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.${0, $7yBx7.akEditorSelectedNodeClassName}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '> .editor-mention-primitive, > .editor-mention-primitive.mention-self, > .editor-mention-primitive.mention-restricted': // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values,
        [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $famkW.boxShadowSelectionStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $famkW.backgroundSelectionStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $famkW.hideNativeBrowserTextSelectionStyles),
            $b4303f6126700a98$var$mentionsSelectedColor
        ]
    }
});
const $b4303f6126700a98$export$13ab2f17ccaf48f6 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.danger': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.editor-mention-primitive': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            boxShadow: `0 0 0 ${(0, $7yBx7.akEditorSelectedBorderSize)}px ${(0, $7yBx7.akEditorDeleteBorder)}`,
            backgroundColor: "var(--ds-background-danger, #FFECEB)"
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.${0, $7yBx7.akEditorSelectedNodeClassName}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '> .editor-mention-primitive, > .editor-mention-primitive.mention-self, > .editor-mention-primitive.mention-restricted': // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values,
        [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $famkW.backgroundSelectionStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $famkW.hideNativeBrowserTextSelectionStyles),
            $b4303f6126700a98$var$mentionsSelectedColor
        ]
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.${0, $7yBx7.akEditorSelectedNodeClassName}:not('.search-match-block')`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '> .editor-mention-primitive, > .editor-mention-primitive.mention-self, > .editor-mention-primitive.mention-restricted': // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values,
        [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $famkW.boxShadowSelectionStyles)
        ]
    }
});

});

parcelRegister("bRDpM", function(module, exports) {

$parcel$export(module.exports, "panelStyles", () => $811bc2ff7ba56aae$export$8290cf129669d0cb);
$parcel$export(module.exports, "panelStylesMixin_fg_platform_editor_add_border_for_nested_panel", () => $811bc2ff7ba56aae$export$5d6cd01bc333145b);
$parcel$export(module.exports, "panelStylesMixin_fg_platform_editor_nested_dnd_styles_changes", () => $811bc2ff7ba56aae$export$1bea98aa89006044);
$parcel$export(module.exports, "panelStylesMixin", () => $811bc2ff7ba56aae$export$59d3d90d4141195);
$parcel$export(module.exports, "panelViewStyles", () => $811bc2ff7ba56aae$export$21dc022a1db4e807);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $1NIU8 = parcelRequire("1NIU8");
function $811bc2ff7ba56aae$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $811bc2ff7ba56aae$export$8290cf129669d0cb = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-editor-panel': {
            cursor: 'pointer',
            /* Danger when top level node */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.danger': {
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                backgroundColor: `${"var(--ds-background-danger, #FFECEB)"} !important`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '.ak-editor-panel__icon': {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                    color: `${"var(--ds-icon-danger, #C9372C)"} !important`
                }
            },
            // panelSharedStyles()
            // panelSharedStylesWithoutPrefix()
            borderRadius: "var(--ds-border-radius, 3px)",
            margin: `0.75rem 0 0`,
            paddingTop: "var(--ds-space-100, 8px)",
            paddingRight: "var(--ds-space-200, 16px)",
            paddingBottom: "var(--ds-space-100, 8px)",
            paddingLeft: "var(--ds-space-100, 8px)",
            minWidth: '48px',
            display: 'flex',
            position: 'relative',
            alignItems: 'normal',
            wordBreak: 'break-word',
            // mainDynamicStyles(PanelType.INFO)
            // > getPanelTypeBackground(PanelType.INFO)
            backgroundColor: "var(--ds-background-accent-blue-subtlest, #E9F2FF)",
            color: 'inherit',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.ak-editor-panel__icon': {
                flexShrink: 0,
                height: "var(--ds-space-300, 24px)",
                width: "var(--ds-space-300, 24px)",
                boxSizing: 'content-box',
                paddingRight: "var(--ds-space-100, 8px)",
                textAlign: 'center',
                userSelect: 'none',
                '-moz-user-select': 'none',
                '-webkit-user-select': 'none',
                '-ms-user-select': 'none',
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
                marginTop: '0.1em',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '> span': {
                    verticalAlign: 'middle',
                    display: 'inline-flex'
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '.emoji-common-emoji-sprite': {
                    verticalAlign: '-2px' // -(8*3-20)/2 [px]
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '.emoji-common-emoji-image': {
                    verticalAlign: '-3px',
                    // panelEmojiSpriteVerticalAlignment - 1 [px]
                    /* Vertical align only works for inline-block elements in Firefox */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
                    '@-moz-document url-prefix()': {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                        img: {
                            display: 'inline-block'
                        }
                    }
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.ak-editor-panel__content': {
                margin: `${"var(--ds-space-025, 2px)"} 0 ${"var(--ds-space-025, 2px)"}`,
                flex: '1 0 0',
                /*
        	https://ishadeed.com/article/min-max-css/#setting-min-width-to-zero-with-flexbox
        	The default value for min-width is auto, which is computed to zero.
        	When an element is a flex item, the value of min-width doesn’t compute to zero.
        	The minimum size of a flex item is equal to the size of its contents.
        */ minWidth: 0
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&[data-panel-type="note"]': {
                // mainDynamicStyles(PanelType.NOTE)
                backgroundColor: "var(--ds-background-accent-purple-subtlest, #F3F0FF)",
                color: 'inherit'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&[data-panel-type="tip"]': {
                // mainDynamicStyles(PanelType.TIP)
                backgroundColor: "var(--ds-background-accent-green-subtlest, #DCFFF1)",
                color: 'inherit'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&[data-panel-type="warning"]': {
                // mainDynamicStyles(PanelType.WARNING)
                backgroundColor: "var(--ds-background-accent-yellow-subtlest, #FFF7D6)",
                color: 'inherit'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&[data-panel-type="error"]': {
                // mainDynamicStyles(PanelType.ERROR)
                backgroundColor: "var(--ds-background-accent-red-subtlest, #FFECEB)",
                color: 'inherit'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&[data-panel-type="success"]': {
                // mainDynamicStyles(PanelType.SUCCESS)
                backgroundColor: "var(--ds-background-accent-green-subtlest, #DCFFF1)",
                color: 'inherit'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-editor-panel__content': {
            cursor: 'text'
        },
        /* Danger when nested node */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.danger .ak-editor-panel': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&[data-panel-type]': {
                backgroundColor: "var(--ds-blanket-danger, #EF5C4814)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
                '.ak-editor-panel__icon': {
                    color: "var(--ds-icon-danger, #C9372C)"
                }
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.ak-editor-panel.ak-editor-selected-node:not(.danger)': {
        // getSelectionStyles([SelectionStyle.BoxShadow, SelectionStyle.Blanket]),
        // SelectionStyle.BoxShadow
        boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #0C66E4)"}`,
        borderColor: 'transparent',
        // SelectionStyle.Blanket
        position: 'relative',
        // Fixes ED-9263, where emoji or inline card in panel makes selection go outside the panel
        // in Safari. Looks like it's caused by user-select: all in the emoji element
        '-webkit-user-select': 'text',
        '&::before': {
            position: 'absolute',
            content: '""',
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
            width: '100%',
            pointerEvents: 'none',
            zIndex: 12,
            // akEditorSmallZIndex
            backgroundColor: "var(--ds-blanket-selected, #388BFF14)"
        },
        // hideNativeSelectionStyles
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&::selection, *::selection': {
            backgroundColor: 'transparent'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&::-moz-selection, *::-moz-selection': {
            backgroundColor: 'transparent'
        }
    }
});
const $811bc2ff7ba56aae$export$5d6cd01bc333145b = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-editor-panel': {
            // Support nested panel
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.ak-editor-panel__content .ak-editor-panel': {
                border: `1px solid ${"var(--ds-border, #091E4224)"}`
            }
        }
    }
});
const $811bc2ff7ba56aae$export$1bea98aa89006044 = {
    name: "icrrk4",
    styles: ".ProseMirror{.ak-editor-panel{&.ak-editor-panel__no-icon{padding-right:var(--ds-space-150, 12px);padding-left:var(--ds-space-150, 12px);}}}.ak-editor-content-area.appearance-full-page .ProseMirror{.ak-editor-panel .ak-editor-panel__icon{padding-right:var(--ds-space-150, 12px);}.ak-editor-panel.ak-editor-panel__no-icon{padding-left:var(--ds-space-250, 20px);padding-right:var(--ds-space-250, 20px);}}.ak-editor-content-area .ak-editor-content-area .ProseMirror{.ak-editor-panel .ak-editor-panel__icon{padding-right:var(--ds-space-100, 8px);}.ak-editor-panel.ak-editor-panel__no-icon{padding-right:var(--ds-space-150, 12px);padding-left:var(--ds-space-150, 12px);}}"
};
const $811bc2ff7ba56aae$export$59d3d90d4141195 = {
    name: "qz3hzr",
    styles: ".ProseMirror{.ak-editor-panel{&[data-panel-type=\"info\"]{.ak-editor-panel__icon[data-panel-type=\"info\"]{color:var(--ds-icon-information, #1D7AFC);}}&[data-panel-type=\"note\"]{.ak-editor-panel__icon[data-panel-type=\"note\"]{color:var(--ds-icon-discovery, #8270DB);}}&[data-panel-type=\"tip\"]{.ak-editor-panel__icon[data-panel-type=\"tip\"]{color:var(--ds-icon-success, #22A06B);}}&[data-panel-type=\"warning\"]{.ak-editor-panel__icon[data-panel-type=\"warning\"]{color:var(--ds-icon-warning, #E56910);}}&[data-panel-type=\"error\"]{.ak-editor-panel__icon[data-panel-type=\"error\"]{color:var(--ds-icon-danger, #C9372C);}}&[data-panel-type=\"success\"]{.ak-editor-panel__icon[data-panel-type=\"success\"]{color:var(--ds-icon-success, #22A06B);}}}}"
};
const $811bc2ff7ba56aae$export$21dc022a1db4e807 = {
    name: "5hfp5c",
    styles: ".panelView-content-wrap{box-sizing:border-box;}"
};

});

parcelRegister("02AzZ", function(module, exports) {

$parcel$export(module.exports, "paragraphStylesUGCRefreshed", () => $6c1f15f81e4dd34f$export$29f6e72d2a83d55a);
$parcel$export(module.exports, "paragraphStylesOld", () => $6c1f15f81e4dd34f$export$855ac5a16d662324);

var $1NIU8 = parcelRequire("1NIU8");
const $6c1f15f81e4dd34f$var$blockNodesVerticalMargin = '0.75rem';
const $6c1f15f81e4dd34f$export$29f6e72d2a83d55a = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.ProseMirror p': {
        // The `editor.font.body` token is used for the UGC typography theme.
        // We don't use `editorUGCToken('editor.font.body')` here because we want to build this styles statically.
        // See platform/packages/editor/editor-common/src/ugc-tokens/get-editor-ugc-token.tsx
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: 'normal 400 1em/1.714 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
        marginTop: $6c1f15f81e4dd34f$var$blockNodesVerticalMargin,
        marginBottom: 0
    }
});
const $6c1f15f81e4dd34f$export$a251c8dae8d8433a = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.ProseMirror p': {
        // The `editor.font.body` token is used for the UGC typography theme.
        // We don't use `editorUGCToken('editor.font.body')` here because we want to build this styles statically.
        // See platform/packages/editor/editor-common/src/ugc-tokens/get-editor-ugc-token.tsx
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: 'normal 400 1em/1.714 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
        marginTop: $6c1f15f81e4dd34f$var$blockNodesVerticalMargin,
        marginBottom: 0
    }
});
const $6c1f15f81e4dd34f$export$855ac5a16d662324 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.ProseMirror p': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '1em',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 1.714,
        fontWeight: "var(--ds-font-weight-regular, 400)",
        marginTop: $6c1f15f81e4dd34f$var$blockNodesVerticalMargin,
        marginBottom: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        letterSpacing: '-0.005em'
    }
});

});

parcelRegister("g7Nsb", function(module, exports) {

$parcel$export(module.exports, "placeholderTextStyles", () => $d1b33a989f10eb2f$export$56bce713f2cb8aa7);
$parcel$export(module.exports, "placeholderTextStylesMixin_fg_platform_editor_system_fake_text_highlight_colour", () => $d1b33a989f10eb2f$export$2fcfba7d5a578c86);
$parcel$export(module.exports, "placeholderStyles", () => $d1b33a989f10eb2f$export$d3bdc0d52bb6c2c8);
$parcel$export(module.exports, "placeholderOverflowStyles", () => $d1b33a989f10eb2f$export$ec7b3b2c50356d2e);
$parcel$export(module.exports, "placeholderWrapStyles", () => $d1b33a989f10eb2f$export$959bd343ec1d44de);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $1NIU8 = parcelRequire("1NIU8");
function $d1b33a989f10eb2f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d1b33a989f10eb2f$export$56bce713f2cb8aa7 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror span[data-placeholder]': {
        color: "var(--ds-text-subtlest, #626F86)",
        display: 'inline'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror span.pm-placeholder': {
        display: 'inline',
        color: "var(--ds-text-subtlest, #626F86)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror span.pm-placeholder__text': {
        display: 'inline',
        color: "var(--ds-text-subtlest, #626F86)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror span.pm-placeholder.ak-editor-selected-node': {
        // ...backgroundSelectionStyles
        backgroundColor: "var(--ds-background-selected, #E9F2FF)",
        // ...backgroundSelectionStyles -> hideNativeBrowserTextSelectionStyles
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&::selection,*::selection': {
            backgroundColor: 'transparent'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-nested-selectors
        '&::-moz-selection,*::-moz-selection': {
            backgroundColor: 'transparent'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror span.pm-placeholder__text[data-placeholder]::after': {
        color: "var(--ds-text-subtlest, #626F86)",
        cursor: 'text',
        content: 'attr(data-placeholder)',
        display: 'inline'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ProseMirror-fake-text-cursor': {
            display: 'inline',
            pointerEvents: 'none',
            position: 'relative'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ProseMirror-fake-text-cursor::after': {
            content: '""',
            display: 'inline',
            top: 0,
            position: 'absolute',
            borderRight: `1px solid ${"var(--ds-border, #091E4224)"}`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ProseMirror-fake-text-selection': {
            display: 'inline',
            pointerEvents: 'none',
            position: 'relative',
            backgroundColor: "var(--ds-background-selected, #B3D4FF)"
        }
    }
});
const $d1b33a989f10eb2f$export$2fcfba7d5a578c86 = {
    name: "1tuyvfm",
    styles: ".ProseMirror{.ProseMirror-fake-text-selection{background-color:Highlight;color:HighlightText;}}"
};
const $d1b33a989f10eb2f$export$d3bdc0d52bb6c2c8 = {
    name: "12q9gkf",
    styles: ".ProseMirror .placeholder-decoration{color:var(--ds-text-subtlest, #626F86);width:100%;pointer-events:none;user-select:none;.placeholder-android{pointer-events:none;outline:none;user-select:none;position:absolute;}}"
};
const $d1b33a989f10eb2f$export$ec7b3b2c50356d2e = {
    name: "9a360",
    styles: ".ProseMirror p:has(.placeholder-decoration-hide-overflow){overflow:hidden;white-space:nowrap;text-overflow:ellipsis;}"
};
const $d1b33a989f10eb2f$export$959bd343ec1d44de = {
    name: "25qy8u",
    styles: ".ProseMirror mark[data-type-ahead-query=\"true\"]:has(.placeholder-decoration-wrap){white-space:nowrap;}"
};

});

parcelRegister("5mW2j", function(module, exports) {

$parcel$export(module.exports, "resizerStyles", () => $4f9aebd5f6249d37$export$ce55ec61aa49b942);
$parcel$export(module.exports, "pragmaticResizerStylesForTooltip", () => $4f9aebd5f6249d37$export$21b363e15a3a4b0b);
$parcel$export(module.exports, "pragmaticStylesLayoutFirstNodeResizeHandleFix", () => $4f9aebd5f6249d37$export$241444dc11ae22d6);
$parcel$export(module.exports, "pragmaticResizerStyles", () => $4f9aebd5f6249d37$export$62cd5dfd9881f590);
$parcel$export(module.exports, "pragmaticResizerStylesNew", () => $4f9aebd5f6249d37$export$4f3e1cb10ec03a18);

var $1NIU8 = parcelRequire("1NIU8");
function $4f9aebd5f6249d37$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $4f9aebd5f6249d37$export$a06160db3520e5a2 = 'resizer-item';
const $4f9aebd5f6249d37$export$c42cdcfd48254bda = 'resizer-hover-zone';
const $4f9aebd5f6249d37$export$10b67c6ff1748bd = 'resizer-is-extended';
const $4f9aebd5f6249d37$export$6afc20f0ff6d041 = 'resizer-handle';
const $4f9aebd5f6249d37$export$a5792d7e2a486d41 = `${$4f9aebd5f6249d37$export$6afc20f0ff6d041}-track`;
const $4f9aebd5f6249d37$export$2201bc1aaee73f36 = `${$4f9aebd5f6249d37$export$6afc20f0ff6d041}-thumb`;
const $4f9aebd5f6249d37$export$97a99610b6f0a178 = `${$4f9aebd5f6249d37$export$6afc20f0ff6d041}-danger`;
const $4f9aebd5f6249d37$export$b5fa87f62ced4967 = 3;
const $4f9aebd5f6249d37$export$b123b2c8a2536d05 = 'resizer-handle-wrapper';
const $4f9aebd5f6249d37$export$ce55ec61aa49b942 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$4f9aebd5f6249d37$export$a06160db3520e5a2}`]: {
        willChange: 'width',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&:hover, &.display-handle': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`& > .${$4f9aebd5f6249d37$export$b123b2c8a2536d05} > .${$4f9aebd5f6249d37$export$6afc20f0ff6d041}`]: {
                visibility: 'visible',
                opacity: 1
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.is-resizing': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`& .${$4f9aebd5f6249d37$export$2201bc1aaee73f36}`]: {
                background: "var(--ds-border-focused, #388BFF)"
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`&.${$4f9aebd5f6249d37$export$97a99610b6f0a178}`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`& .${$4f9aebd5f6249d37$export$2201bc1aaee73f36}`]: {
                transition: 'none',
                background: "var(--ds-icon-danger, #C9372C)"
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$4f9aebd5f6249d37$export$6afc20f0ff6d041}`]: {
        display: 'flex',
        visibility: 'hidden',
        opacity: 0,
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: 7,
        transition: 'visibility 0.2s, opacity 0.2s',
        // NOTE: The below style is targeted at the div element added by the tooltip. We don't have any means of injecting styles
        // into the tooltip
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "& div[role='presentation']": {
            width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: "var(--ds-space-negative-200, -16px)",
            whiteSpace: 'normal'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.left': {
            alignItems: 'flex-start'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.right': {
            alignItems: 'flex-end'
        },
        // Handle Sizing
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.small': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`& .${$4f9aebd5f6249d37$export$2201bc1aaee73f36}`]: {
                height: 43
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.medium': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`& .${$4f9aebd5f6249d37$export$2201bc1aaee73f36}`]: {
                height: 64
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.large': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`& .${$4f9aebd5f6249d37$export$2201bc1aaee73f36}`]: {
                height: 96
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.clamped': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`& .${$4f9aebd5f6249d37$export$2201bc1aaee73f36}`]: {
                height: 'clamp(43px, calc(100% - 32px), 96px)'
            }
        },
        // Handle Alignment
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.sticky': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`& .${$4f9aebd5f6249d37$export$2201bc1aaee73f36}`]: {
                position: 'sticky',
                top: "var(--ds-space-150, 12px)",
                bottom: "var(--ds-space-150, 12px)"
            }
        },
        '&:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`& .${$4f9aebd5f6249d37$export$2201bc1aaee73f36}`]: {
                background: "var(--ds-border-focused, #388BFF)"
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`& .${$4f9aebd5f6249d37$export$a5792d7e2a486d41}`]: {
                visibility: 'visible',
                opacity: 0.5
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$4f9aebd5f6249d37$export$2201bc1aaee73f36}`]: {
        content: "' '",
        display: 'flex',
        width: 3,
        margin: `0 ${"var(--ds-space-025, 2px)"}`,
        height: 64,
        transition: 'background-color 0.2s',
        borderRadius: 6,
        border: 0,
        padding: 0,
        zIndex: 2,
        outline: 'none',
        minHeight: 24,
        background: "var(--ds-border, #091E4224)",
        '&:hover': {
            cursor: 'col-resize'
        },
        '&:focus': {
            background: "var(--ds-border-selected, #0C66E4)",
            '&::after': {
                content: "''",
                position: 'absolute',
                top: "var(--ds-space-negative-050, -4px)",
                right: "var(--ds-space-negative-050, -4px)",
                bottom: "var(--ds-space-negative-050, -4px)",
                left: "var(--ds-space-negative-050, -4px)",
                border: `2px solid ${"var(--ds-border-focused, #388BFF)"}`,
                borderRadius: 'inherit',
                zIndex: -1
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$4f9aebd5f6249d37$export$a5792d7e2a486d41}`]: {
        visibility: 'hidden',
        position: 'absolute',
        width: 7,
        height: 'calc(100% - 40px)',
        borderRadius: 4,
        opacity: 0,
        transition: 'background-color 0.2s, visibility 0.2s, opacity 0.2s',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.none': {
            background: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.shadow': {
            background: "var(--ds-background-selected, #E9F2FF)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.full-height': {
            background: "var(--ds-background-selected, #E9F2FF)",
            height: '100%',
            minHeight: 36
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    '.ak-editor-selected-node': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`& .${$4f9aebd5f6249d37$export$2201bc1aaee73f36}`]: {
            background: "var(--ds-border-focused, #388BFF)"
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.ak-editor-no-interaction .ak-editor-selected-node .${$4f9aebd5f6249d37$export$6afc20f0ff6d041}:not(:hover) .${$4f9aebd5f6249d37$export$2201bc1aaee73f36}`]: {
        background: "var(--ds-border, #091E4224)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$4f9aebd5f6249d37$export$c42cdcfd48254bda}`]: {
        position: 'relative',
        display: 'inline-block',
        width: '100%',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`&.${$4f9aebd5f6249d37$export$10b67c6ff1748bd}`]: {
            padding: `0 ${"var(--ds-space-150, 12px)"}`,
            left: "var(--ds-space-negative-150, -12px)"
        }
    },
    // This below style is here to make sure the image width is correct when nested in a table
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`table .${$4f9aebd5f6249d37$export$c42cdcfd48254bda}, table .${$4f9aebd5f6249d37$export$c42cdcfd48254bda}.${$4f9aebd5f6249d37$export$10b67c6ff1748bd}`]: {
        padding: 'unset',
        left: 'unset'
    }
});
const $4f9aebd5f6249d37$export$21b363e15a3a4b0b = {
    name: "am2lta",
    styles: ".pm-breakout-resize-handle-rail-wrapper{display:flex;align-items:center;justify-content:center;height:100%;cursor:col-resize;border-radius:4px;z-index:2;[role=\"presentation\"]{height:100%;width:100%;}.pm-breakout-resize-handle-rail-inside-tooltip{height:100%;}}"
};
const $4f9aebd5f6249d37$export$241444dc11ae22d6 = {
    name: "zqeg2w",
    styles: ".fabric-editor-breakout-mark{&:has([data-prosemirror-node-name=\"layoutSection\"].first-node-in-document){> .pm-breakout-resize-handle-container{height:calc(100% - 8px);}}}"
};
const $4f9aebd5f6249d37$export$62cd5dfd9881f590 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.fabric-editor-breakout-mark': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:has([data-prosemirror-node-name="codeBlock"])': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '> .pm-breakout-resize-handle-container--left': {
                left: '-12px'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '> .pm-breakout-resize-handle-container--right': {
                right: '-12px'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '> .pm-breakout-resize-handle-container': {
                height: 'calc(100% - 12px)'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:has([data-prosemirror-node-name="expand"]), &:has([data-prosemirror-node-name="layoutSection"])': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '> .pm-breakout-resize-handle-container--left': {
                left: '-32px'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '> .pm-breakout-resize-handle-container--right': {
                right: '-32px'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:has([data-prosemirror-node-name="expand"])': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '> .pm-breakout-resize-handle-container': {
                height: 'calc(100% - 4px)'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:has([data-prosemirror-node-name="layoutSection"])': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '> .pm-breakout-resize-handle-container': {
                height: 'calc(100% - 8px)'
            }
        },
        // the first node in the document always has margin-top = 0
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:has(.first-node-in-document)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '> .pm-breakout-resize-handle-container': {
                height: '100%'
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.pm-breakout-resize-handle-container': {
        position: 'relative',
        alignSelf: 'end',
        gridRow: 1,
        gridColumn: 1,
        height: '100%',
        width: 7
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.pm-breakout-resize-handle-container--left': {
        justifySelf: 'start'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.pm-breakout-resize-handle-container--right': {
        justifySelf: 'end'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.pm-breakout-resize-handle-rail': {
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        cursor: 'col-resize',
        borderRadius: 4,
        transition: 'background-color 0.2s, visibility 0.2s, opacity 0.2s',
        zIndex: 2,
        opacity: 0,
        '&:hover': {
            background: "var(--ds-background-selected, #E9F2FF)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.pm-breakout-resize-handle-thumb': {
                background: "var(--ds-border-focused, #388BFF)"
            }
        }
    },
    // same as 'hover' styles above
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.pm-breakout-resize-handle-container--active': {
        background: "var(--ds-background-selected, #E9F2FF)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.pm-breakout-resize-handle-thumb': {
            background: "var(--ds-border-focused, #388BFF)"
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.pm-breakout-resize-handle-hit-box': {
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: -20,
        right: -20,
        zIndex: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.pm-breakout-resize-handle-thumb': {
        minWidth: $4f9aebd5f6249d37$export$b5fa87f62ced4967,
        // copied from resizeStyles.clamped
        height: 'clamp(27px, calc(100% - 32px), 96px)',
        background: "var(--ds-border, #091E4224)",
        borderRadius: 6,
        // sticky styles
        position: 'sticky',
        top: "var(--ds-space-150, 12px)",
        bottom: "var(--ds-space-150, 12px)"
    }
});
const $4f9aebd5f6249d37$export$4f3e1cb10ec03a18 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.fabric-editor-breakout-mark': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:has([data-prosemirror-node-name="codeBlock"])': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '> .pm-breakout-resize-handle-container--left': {
                left: '-5px'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '> .pm-breakout-resize-handle-container--right': {
                right: '-5px'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '> .pm-breakout-resize-handle-container': {
                height: 'calc(100% - 12px)'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:has([data-prosemirror-node-name="expand"]), &:has([data-prosemirror-node-name="layoutSection"])': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '> .pm-breakout-resize-handle-container--left': {
                left: '-25px'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '> .pm-breakout-resize-handle-container--right': {
                right: '-25px'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:has([data-prosemirror-node-name="expand"])': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '> .pm-breakout-resize-handle-container': {
                height: 'calc(100% - 4px)'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:has([data-prosemirror-node-name="layoutSection"])': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '> .pm-breakout-resize-handle-container': {
                height: 'calc(100% - 8px)'
            }
        },
        // the first node in the document always has margin-top = 0
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:has(.first-node-in-document)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '> .pm-breakout-resize-handle-container': {
                height: '100%'
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.pm-breakout-resize-handle-container': {
        position: 'relative',
        alignSelf: 'end',
        gridRow: 1,
        gridColumn: 1,
        height: '100%',
        width: 7
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.pm-breakout-resize-handle-container--left': {
        justifySelf: 'start'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.pm-breakout-resize-handle-container--right': {
        justifySelf: 'end'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.pm-breakout-resize-handle-rail': {
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        cursor: 'col-resize',
        borderRadius: 4,
        transition: 'background-color 0.2s, visibility 0.2s, opacity 0.2s',
        zIndex: 2,
        opacity: 0,
        '&:hover': {
            background: "var(--ds-background-selected, #E9F2FF)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.pm-breakout-resize-handle-thumb': {
                background: "var(--ds-border-focused, #388BFF)"
            }
        }
    },
    // same as 'hover' styles above
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.pm-breakout-resize-handle-container--active': {
        background: "var(--ds-background-selected, #E9F2FF)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.pm-breakout-resize-handle-thumb': {
            background: "var(--ds-border-focused, #388BFF)"
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.pm-breakout-resize-handle-hit-box': {
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: -20,
        right: -20,
        zIndex: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.pm-breakout-resize-handle-thumb': {
        minWidth: $4f9aebd5f6249d37$export$b5fa87f62ced4967,
        // copied from resizeStyles.clamped
        height: 'clamp(27px, calc(100% - 32px), 96px)',
        background: "var(--ds-border, #091E4224)",
        borderRadius: 6,
        // sticky styles
        position: 'sticky',
        top: "var(--ds-space-150, 12px)",
        bottom: "var(--ds-space-150, 12px)"
    }
});

});

parcelRegister("ftB1y", function(module, exports) {

$parcel$export(module.exports, "ruleStyles", () => $5795383c614a8c7e$export$2413e968422424ec);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $1NIU8 = parcelRequire("1NIU8");

var $7yBx7 = parcelRequire("7yBx7");
const $5795383c614a8c7e$export$2413e968422424ec = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror hr': {
        border: 'none',
        backgroundColor: "var(--ds-border, #091E4224)",
        height: '2px',
        borderRadius: '1px',
        cursor: 'pointer',
        padding: `${"var(--ds-space-050, 4px)"} 0`,
        margin: `${"var(--ds-space-300, 24px)"} 0`,
        backgroundClip: 'content-box'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.ProseMirror hr.${0, $7yBx7.akEditorSelectedNodeClassName}`]: {
        outline: 'none',
        backgroundColor: "var(--ds-border-selected, #0C66E4)"
    }
});

});

parcelRegister("khwCN", function(module, exports) {

$parcel$export(module.exports, "scrollbarStyles", () => $ce5959d77d71240d$export$b2380b18b089518f);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled
function $ce5959d77d71240d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ce5959d77d71240d$export$b2380b18b089518f = {
    name: "1tu1yi6",
    styles: "-ms-overflow-style:-ms-autohiding-scrollbar;&::-webkit-scrollbar-corner{display:none;}&::-webkit-scrollbar-thumb{background-color:var(--ds-background-neutral-subtle, #00000000);}&:hover::-webkit-scrollbar-thumb{background-color:var(--ds-background-neutral-bold, #44546F);border-radius:8px;}&::-webkit-scrollbar-thumb:hover{background-color:var(--ds-background-neutral-bold-hovered, #2C3E5D);}"
};

});

parcelRegister("krgOs", function(module, exports) {

$parcel$export(module.exports, "selectionToolbarAnimationStyles", () => $9d1f359457013a31$export$1629cb32bbba3a7e);

var $1NIU8 = parcelRequire("1NIU8");
const $9d1f359457013a31$var$fadeIn = (0, $1NIU8.keyframes)({
    from: {
        opacity: 0,
        transform: 'translateY(-16px)'
    },
    to: {
        opacity: 1,
        transform: 'translateY(0)'
    }
});
const $9d1f359457013a31$export$1629cb32bbba3a7e = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "[aria-label='Selection toolbar']": {
        animationName: $9d1f359457013a31$var$fadeIn,
        animationDuration: `0.2s`,
        animationTimingFunction: `cubic-bezier(0.6, 0, 0, 1)`
    }
});

});

parcelRegister("bEDkR", function(module, exports) {

$parcel$export(module.exports, "shadowStyles", () => $0c992df02a25760d$export$9750a92ac0203c10);

var $1NIU8 = parcelRequire("1NIU8");
const $0c992df02a25760d$export$4735dd2b0fa88aa5 = {
    RIGHT_SHADOW: 'right-shadow',
    LEFT_SHADOW: 'left-shadow'
};
const $0c992df02a25760d$export$1cbe0bb16052178d = {
    SENTINEL_LEFT: 'sentinel-left',
    SENTINEL_RIGHT: 'sentinel-right',
    SHADOW_CONTAINER: 'with-shadow-observer'
};
const $0c992df02a25760d$export$9750a92ac0203c10 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`& .${$0c992df02a25760d$export$4735dd2b0fa88aa5.RIGHT_SHADOW}::before, .${$0c992df02a25760d$export$4735dd2b0fa88aa5.RIGHT_SHADOW}::after, .${$0c992df02a25760d$export$4735dd2b0fa88aa5.LEFT_SHADOW}::before, .${$0c992df02a25760d$export$4735dd2b0fa88aa5.LEFT_SHADOW}::after`]: {
            display: 'none',
            position: 'absolute',
            pointerEvents: 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            zIndex: 2,
            width: 8,
            content: "''",
            height: 'calc(100%)'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`& .${$0c992df02a25760d$export$4735dd2b0fa88aa5.RIGHT_SHADOW}, .${$0c992df02a25760d$export$4735dd2b0fa88aa5.LEFT_SHADOW}`]: {
            position: 'relative'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`& .${$0c992df02a25760d$export$4735dd2b0fa88aa5.LEFT_SHADOW}::before`]: {
            background: `linear-gradient(to left, transparent 0, ${"var(--ds-shadow-overflow-spread, #091e4229)"} 140% ), linear-gradient( to right, ${"var(--ds-shadow-overflow-perimeter, transparent)"} 0px, transparent 1px)`,
            top: 0,
            left: 0,
            display: 'block'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`& .${$0c992df02a25760d$export$4735dd2b0fa88aa5.RIGHT_SHADOW}::after`]: {
            background: `linear-gradient(to right, transparent 0, ${"var(--ds-shadow-overflow-spread, #091e4229)"} 140% ), linear-gradient( to left, ${"var(--ds-shadow-overflow-perimeter, transparent)"} 0px, transparent 1px)`,
            right: 0,
            top: 0,
            display: 'block'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`& .${$0c992df02a25760d$export$1cbe0bb16052178d.SENTINEL_LEFT}`]: {
            height: '100%',
            width: 0,
            minWidth: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`& .${$0c992df02a25760d$export$1cbe0bb16052178d.SENTINEL_RIGHT}`]: {
            height: '100%',
            width: 0,
            minWidth: 0
        }
    }
});

});

parcelRegister("6uQ8z", function(module, exports) {

$parcel$export(module.exports, "editorControlsSmartCardStyles", () => $cb72127d5cad6aec$export$f64b12e3fb171ebc);
$parcel$export(module.exports, "smartCardStyles", () => $cb72127d5cad6aec$export$b346a5d6d598424c);
$parcel$export(module.exports, "smartCardStylesWithSearchMatch", () => $cb72127d5cad6aec$export$56d86af0724ad29e);
$parcel$export(module.exports, "smartLinksInLivePagesStyles", () => $cb72127d5cad6aec$export$cb0683bb9c4e1322);
$parcel$export(module.exports, "smartLinksInLivePagesStylesOld", () => $cb72127d5cad6aec$export$d0907e21de0d46fc);
$parcel$export(module.exports, "linkingVisualRefreshV1Styles", () => $cb72127d5cad6aec$export$1a87a16059da4299);

var $1NIU8 = parcelRequire("1NIU8");

var $famkW = parcelRequire("famkW");
const $cb72127d5cad6aec$export$32f80df830e375f6 = 'datasourceView-content-inner-wrap';
const $cb72127d5cad6aec$export$863ae87a9d233606 = 'card-floating-toolbar--link-picker';
const $cb72127d5cad6aec$export$4ccd31bf665a88f6 = {
    INLINE_CARD_CONTAINER: 'inlineCardView-content-wrap',
    BLOCK_CARD_CONTAINER: 'blockCardView-content-wrap',
    EMBED_CARD_CONTAINER: 'embedCardView-content-wrap',
    DATASOURCE_CONTAINER: 'datasourceView-content-wrap',
    LOADER_WRAPPER: 'loader-wrapper'
};
const $cb72127d5cad6aec$export$f64b12e3fb171ebc = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$cb72127d5cad6aec$export$4ccd31bf665a88f6.INLINE_CARD_CONTAINER}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-inlinecard-button-overlay="icon-wrapper-line-height"] span': {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: 0
        }
    }
});
const $cb72127d5cad6aec$export$b346a5d6d598424c = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$cb72127d5cad6aec$export$4ccd31bf665a88f6.INLINE_CARD_CONTAINER}`]: {
        maxWidth: 'calc(100% - 20px)',
        verticalAlign: 'top',
        wordBreak: 'break-all',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.card-with-comment': {
            background: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
            borderBottom: `2px solid ${"var(--ds-border-accent-yellow, #B38600)"}`,
            boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #091E4226, 0px 0px 1px #091E424f)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.card': {
            paddingLeft: "var(--ds-space-025, 2px)",
            paddingRight: "var(--ds-space-025, 2px)",
            paddingTop: "var(--ds-space-100, 0.5em)",
            paddingBottom: "var(--ds-space-100, 0.5em)",
            marginBottom: "var(--ds-space-negative-100, -0.5em)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$cb72127d5cad6aec$export$4ccd31bf665a88f6.LOADER_WRAPPER} > a:focus`]: [
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $famkW.boxShadowSelectionStyles),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $famkW.hideNativeBrowserTextSelectionStyles)
            ]
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`&.ak-editor-selected-node .${$cb72127d5cad6aec$export$4ccd31bf665a88f6.LOADER_WRAPPER} > a`]: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $famkW.boxShadowSelectionStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $famkW.hideNativeBrowserTextSelectionStyles)
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$cb72127d5cad6aec$export$4ccd31bf665a88f6.LOADER_WRAPPER} > a`]: {
            // EDM-1717: box-shadow Safari fix start
            zIndex: 1,
            position: 'relative'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$cb72127d5cad6aec$export$4ccd31bf665a88f6.LOADER_WRAPPER} > a`]: {
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`,
                // EDM-1717: box-shadow Safari fix start
                zIndex: 2
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$cb72127d5cad6aec$export$4ccd31bf665a88f6.BLOCK_CARD_CONTAINER}`]: {
        display: 'block',
        margin: '0.75rem 0 0',
        maxWidth: `${760}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`&.ak-editor-selected-node .${$cb72127d5cad6aec$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div`]: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $famkW.boxShadowSelectionStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $famkW.hideNativeBrowserTextSelectionStyles),
            {
                borderRadius: "var(--ds-border-radius-200, 8px)"
            }
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$cb72127d5cad6aec$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div`]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"} !important`
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$cb72127d5cad6aec$export$4ccd31bf665a88f6.DATASOURCE_CONTAINER}.${$cb72127d5cad6aec$export$4ccd31bf665a88f6.BLOCK_CARD_CONTAINER}`]: {
        maxWidth: '100%',
        display: 'flex',
        justifyContent: 'center',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$cb72127d5cad6aec$export$32f80df830e375f6}`]: {
            cursor: 'pointer',
            backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
            borderRadius: "var(--ds-border-radius-200, 8px)",
            border: `1px solid ${"var(--ds-border, #091E4224)"}`,
            overflow: 'hidden'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.ak-editor-selected-node': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$cb72127d5cad6aec$export$32f80df830e375f6}`]: [
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $famkW.boxShadowSelectionStyles),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $famkW.hideNativeBrowserTextSelectionStyles),
                {
                    'input::selection': {
                        backgroundColor: "var(--ds-background-selected-hovered, #CCE0FF)"
                    },
                    'input::-moz-selection': {
                        backgroundColor: "var(--ds-background-selected-hovered, #CCE0FF)"
                    }
                }
            ]
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$cb72127d5cad6aec$export$32f80df830e375f6}`]: {
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$cb72127d5cad6aec$export$4ccd31bf665a88f6.EMBED_CARD_CONTAINER}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$cb72127d5cad6aec$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div`]: {
            cursor: 'pointer',
            '&::after': {
                transition: 'box-shadow 0s'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`&.ak-editor-selected-node .${$cb72127d5cad6aec$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div::after`]: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $famkW.boxShadowSelectionStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $famkW.hideNativeBrowserTextSelectionStyles)
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.media-card-frame::after': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"} !important`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                background: `${"var(--ds-background-danger, #FFECEB)"} !important`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.richMedia-resize-handle-right::after, .richMedia-resize-handle-left::after': {
                background: "var(--ds-border-danger, #E2483D)"
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$cb72127d5cad6aec$export$863ae87a9d233606}`]: {
        padding: 0
    }
});
const $cb72127d5cad6aec$export$56d86af0724ad29e = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$cb72127d5cad6aec$export$4ccd31bf665a88f6.INLINE_CARD_CONTAINER}`]: {
        maxWidth: 'calc(100% - 20px)',
        verticalAlign: 'top',
        wordBreak: 'break-all',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.card-with-comment': {
            background: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
            borderBottom: `2px solid ${"var(--ds-border-accent-yellow, #B38600)"}`,
            boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #091E4226, 0px 0px 1px #091E424f)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.card': {
            paddingLeft: "var(--ds-space-025, 2px)",
            paddingRight: "var(--ds-space-025, 2px)",
            paddingTop: "var(--ds-space-100, 0.5em)",
            paddingBottom: "var(--ds-space-100, 0.5em)",
            marginBottom: "var(--ds-space-negative-100, -0.5em)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$cb72127d5cad6aec$export$4ccd31bf665a88f6.LOADER_WRAPPER} > a:focus`]: [
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $famkW.boxShadowSelectionStyles),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $famkW.hideNativeBrowserTextSelectionStyles)
            ]
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`&.ak-editor-selected-node .${$cb72127d5cad6aec$export$4ccd31bf665a88f6.LOADER_WRAPPER} > a`]: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $famkW.hideNativeBrowserTextSelectionStyles)
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`&.ak-editor-selected-node:not(.search-match-block) .${$cb72127d5cad6aec$export$4ccd31bf665a88f6.LOADER_WRAPPER} > a`]: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $famkW.boxShadowSelectionStyles)
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$cb72127d5cad6aec$export$4ccd31bf665a88f6.LOADER_WRAPPER} > a`]: {
            // EDM-1717: box-shadow Safari fix start
            zIndex: 1,
            position: 'relative'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$cb72127d5cad6aec$export$4ccd31bf665a88f6.LOADER_WRAPPER} > a`]: {
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`,
                // EDM-1717: box-shadow Safari fix start
                zIndex: 2
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$cb72127d5cad6aec$export$4ccd31bf665a88f6.BLOCK_CARD_CONTAINER}`]: {
        display: 'block',
        margin: '0.75rem 0 0',
        maxWidth: `${760}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`&.ak-editor-selected-node .${$cb72127d5cad6aec$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div`]: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $famkW.boxShadowSelectionStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $famkW.hideNativeBrowserTextSelectionStyles),
            {
                borderRadius: "var(--ds-border-radius-200, 8px)"
            }
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$cb72127d5cad6aec$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div`]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"} !important`
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$cb72127d5cad6aec$export$4ccd31bf665a88f6.DATASOURCE_CONTAINER}.${$cb72127d5cad6aec$export$4ccd31bf665a88f6.BLOCK_CARD_CONTAINER}`]: {
        maxWidth: '100%',
        display: 'flex',
        justifyContent: 'center',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$cb72127d5cad6aec$export$32f80df830e375f6}`]: {
            cursor: 'pointer',
            backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
            borderRadius: "var(--ds-border-radius-200, 8px)",
            border: `1px solid ${"var(--ds-border, #091E4224)"}`,
            overflow: 'hidden'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.ak-editor-selected-node': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$cb72127d5cad6aec$export$32f80df830e375f6}`]: [
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $famkW.boxShadowSelectionStyles),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $famkW.hideNativeBrowserTextSelectionStyles),
                {
                    'input::selection': {
                        backgroundColor: "var(--ds-background-selected-hovered, #CCE0FF)"
                    },
                    'input::-moz-selection': {
                        backgroundColor: "var(--ds-background-selected-hovered, #CCE0FF)"
                    }
                }
            ]
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`.${$cb72127d5cad6aec$export$32f80df830e375f6}`]: {
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$cb72127d5cad6aec$export$4ccd31bf665a88f6.EMBED_CARD_CONTAINER}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$cb72127d5cad6aec$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div`]: {
            cursor: 'pointer',
            '&::after': {
                transition: 'box-shadow 0s'
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`&.ak-editor-selected-node .${$cb72127d5cad6aec$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div::after`]: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $famkW.hideNativeBrowserTextSelectionStyles)
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`&.ak-editor-selected-node:not(.search-match-block) .${$cb72127d5cad6aec$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div::after`]: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $famkW.boxShadowSelectionStyles)
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.danger': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.media-card-frame::after': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"} !important`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
                background: `${"var(--ds-background-danger, #FFECEB)"} !important`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.richMedia-resize-handle-right::after, .richMedia-resize-handle-left::after': {
                background: "var(--ds-border-danger, #E2483D)"
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$cb72127d5cad6aec$export$863ae87a9d233606}`]: {
        padding: 0
    }
});
const $cb72127d5cad6aec$export$cb0683bb9c4e1322 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$cb72127d5cad6aec$export$4ccd31bf665a88f6.BLOCK_CARD_CONTAINER}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$cb72127d5cad6aec$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div`]: {
            cursor: 'text',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            a: {
                cursor: 'pointer'
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$cb72127d5cad6aec$export$4ccd31bf665a88f6.EMBED_CARD_CONTAINER}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$cb72127d5cad6aec$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            a: {
                cursor: 'pointer'
            }
        }
    }
});
const $cb72127d5cad6aec$export$d0907e21de0d46fc = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$cb72127d5cad6aec$export$4ccd31bf665a88f6.BLOCK_CARD_CONTAINER}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$cb72127d5cad6aec$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div`]: {
            cursor: 'pointer',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            a: {
                cursor: 'auto'
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$cb72127d5cad6aec$export$4ccd31bf665a88f6.EMBED_CARD_CONTAINER}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$cb72127d5cad6aec$export$4ccd31bf665a88f6.LOADER_WRAPPER} > div`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            a: {
                cursor: 'auto'
            }
        }
    }
});
const $cb72127d5cad6aec$export$1a87a16059da4299 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$cb72127d5cad6aec$export$4ccd31bf665a88f6.BLOCK_CARD_CONTAINER}`]: {
        // EDM-11991: Fix list plugin adding padding to ADS AvatarGroup
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'ul, ol': {
            paddingLeft: 'inherit'
        }
    }
});

});

parcelRegister("cZpyt", function(module, exports) {

$parcel$export(module.exports, "statusStyles", () => $f5157a89598b2125$export$79c8c9ad308bbe07);
$parcel$export(module.exports, "statusStylesMixin_fg_platform_component_visual_refresh", () => $f5157a89598b2125$export$7c209f30e9068068);
$parcel$export(module.exports, "statusStylesMixin_fg_platform_component_visual_refresh_with_search_match", () => $f5157a89598b2125$export$8b4cca12f7a094c7);
$parcel$export(module.exports, "statusStylesMixin_without_fg_platform_component_visual_refresh", () => $f5157a89598b2125$export$dc185896d75d4b4);
$parcel$export(module.exports, "statusStylesMixin_without_fg_platform_component_visual_refresh_with_search_match", () => $f5157a89598b2125$export$60b421c3da7a2a99);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $1NIU8 = parcelRequire("1NIU8");
const $f5157a89598b2125$export$79c8c9ad308bbe07 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.pm-table-cell-content-wrap, .pm-table-header-content-wrap, [data-layout-section]': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.statusView-content-wrap': {
            maxWidth: '100%',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '& > span': {
                width: '100%'
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.statusView-content-wrap': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& > span': {
            cursor: 'pointer',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: 0 // Prevent responsive layouts increasing height of container.
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.danger': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.status-lozenge-span > span': {
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
            backgroundColor: 'rgba(255, 189, 173, 0.5)' // akEditorDeleteBackgroundWithOpacity
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.statusView-content-wrap.ak-editor-selected-node': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.status-lozenge-span > span': {
                boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-neutral, #091E420F)",
        maxWidth: '100%',
        paddingInline: "var(--ds-space-050, 4px)",
        display: 'inline-flex',
        borderRadius: '3px',
        blockSize: 'min-content',
        position: 'static',
        overflow: 'hidden',
        boxSizing: 'border-box',
        appearance: 'none',
        border: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] .lozenge-text': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '11px',
        fontStyle: 'normal',
        fontFamily: "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        fontWeight: "var(--ds-font-weight-bold, 700)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: '16px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        textTransform: 'uppercase',
        whiteSpace: 'nowrap',
        maxWidth: `calc(200px - ${"var(--ds-space-100, 8px)"})`
    }
});
const $f5157a89598b2125$export$7c209f30e9068068 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.statusView-content-wrap': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.ak-editor-selected-node .status-lozenge-span > span': {
            boxShadow: `0 0 0 2px ${"var(--ds-border-selected, #0C66E4)"}`
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] .lozenge-text': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        color: '#292A2E'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=neutral] > .lozenge-wrapper': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        backgroundColor: '#DDDEE1'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=purple] > .lozenge-wrapper': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        backgroundColor: '#D8A0F7'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=blue] > .lozenge-wrapper': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        backgroundColor: '#8FB8F6'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=yellow] > .lozenge-wrapper': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        backgroundColor: '#F9C84E'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=red] > .lozenge-wrapper': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        backgroundColor: '#FD9891'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=green] > .lozenge-wrapper': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        backgroundColor: '#B3DF72'
    }
});
const $f5157a89598b2125$export$8b4cca12f7a094c7 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.statusView-content-wrap:not(.search-match-block)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.ak-editor-selected-node .status-lozenge-span > span': {
            boxShadow: `0 0 0 2px ${"var(--ds-border-selected, #0C66E4)"}`
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] .lozenge-text': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        color: '#292A2E'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=neutral] > .lozenge-wrapper': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        backgroundColor: '#DDDEE1'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=purple] > .lozenge-wrapper': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        backgroundColor: '#D8A0F7'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=blue] > .lozenge-wrapper': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        backgroundColor: '#8FB8F6'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=yellow] > .lozenge-wrapper': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        backgroundColor: '#F9C84E'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=red] > .lozenge-wrapper': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        backgroundColor: '#FD9891'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=green] > .lozenge-wrapper': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        backgroundColor: '#B3DF72'
    }
});
const $f5157a89598b2125$export$dc185896d75d4b4 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.statusView-content-wrap': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.ak-editor-selected-node .status-lozenge-span > span': {
            // getSelectionStyles([SelectionStyle.BoxShadow]);
            boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #0C66E4)"}`,
            borderColor: 'transparent',
            // hideNativeBrowserTextSelectionStyles
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&::selection, & *::selection': {
                backgroundColor: 'transparent'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&::-moz-selection, & *::-moz-selection': {
                backgroundColor: 'transparent'
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=neutral] .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-neutral, #091E420F)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=neutral] .lozenge-text': {
        color: "var(--ds-text-subtle, #44546F)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=purple] .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-discovery, #F3F0FF)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=purple] .lozenge-text': {
        color: "var(--ds-text-discovery, #5E4DB2)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=blue] .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-information, #E9F2FF)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=blue] .lozenge-text': {
        color: "var(--ds-text-information, #0055CC)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=yellow] .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-warning, #FFF7D6)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=yellow] .lozenge-text': {
        color: "var(--ds-text-warning, #A54800)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=red] .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-danger, #FFECEB)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=red] .lozenge-text': {
        color: "var(--ds-text-danger, #AE2E24)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=green] .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-success, #DCFFF1)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=green] .lozenge-text': {
        color: "var(--ds-text-success, #216E4E)"
    }
});
const $f5157a89598b2125$export$60b421c3da7a2a99 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.statusView-content-wrap:not(.search-match-block)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.ak-editor-selected-node .status-lozenge-span > span': {
            // getSelectionStyles([SelectionStyle.BoxShadow]);
            boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #0C66E4)"}`,
            borderColor: 'transparent',
            // hideNativeBrowserTextSelectionStyles
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&::selection, & *::selection': {
                backgroundColor: 'transparent'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&::-moz-selection, & *::-moz-selection': {
                backgroundColor: 'transparent'
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=neutral] .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-neutral, #091E420F)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=neutral] .lozenge-text': {
        color: "var(--ds-text-subtle, #44546F)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=purple] .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-discovery, #F3F0FF)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=purple] .lozenge-text': {
        color: "var(--ds-text-discovery, #5E4DB2)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=blue] .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-information, #E9F2FF)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=blue] .lozenge-text': {
        color: "var(--ds-text-information, #0055CC)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=yellow] .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-warning, #FFF7D6)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=yellow] .lozenge-text': {
        color: "var(--ds-text-warning, #A54800)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=red] .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-danger, #FFECEB)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=red] .lozenge-text': {
        color: "var(--ds-text-danger, #AE2E24)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=green] .lozenge-wrapper': {
        backgroundColor: "var(--ds-background-success, #DCFFF1)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="status"] > [data-color=green] .lozenge-text': {
        color: "var(--ds-text-success, #216E4E)"
    }
});

});

parcelRegister("2287P", function(module, exports) {

$parcel$export(module.exports, "tableLayoutFixes", () => $742a6fc2ff79e14c$export$696afa9d8a2fe544);
$parcel$export(module.exports, "tableCommentEditorStyles", () => $742a6fc2ff79e14c$export$61a2da566f69d1df);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $1NIU8 = parcelRequire("1NIU8");

var $khwCN = parcelRequire("khwCN");
function $742a6fc2ff79e14c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $742a6fc2ff79e14c$export$696afa9d8a2fe544 = {
    name: "p382o5",
    styles: ".pm-table-header-content-wrap :not(.fabric-editor-alignment), .pm-table-header-content-wrap :not(p, .fabric-editor-block-mark) + div.fabric-editor-block-mark, .pm-table-cell-content-wrap :not(p, .fabric-editor-block-mark) + div.fabric-editor-block-mark{p:first-of-type{margin-top:0;}}.pm-table-cell-content-wrap .mediaGroupView-content-wrap{clear:both;}"
};
const $742a6fc2ff79e14c$export$5dc8ab529dc33316 = {
    name: "mlsake",
    styles: "margin-left:0;margin-right:0"
};
const $742a6fc2ff79e14c$export$61a2da566f69d1df = /*#__PURE__*/ (0, $1NIU8.css)({
    // TODO: ED-28075 - refactor array include to unblock Compiled CSS migration
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`.ProseMirror .pm-table-wrapper > table`]: [
        $742a6fc2ff79e14c$export$5dc8ab529dc33316,
        (0, $khwCN.scrollbarStyles)
    ]
});

});

parcelRegister("8A2V5", function(module, exports) {

$parcel$export(module.exports, "tasksAndDecisionsStyles", () => $dab29d26076633be$export$df437277fbc8b4f5);
$parcel$export(module.exports, "decisionStyles", () => $dab29d26076633be$export$c2f467e1dc47f4f1);
$parcel$export(module.exports, "decisionIconWithVisualRefresh", () => $dab29d26076633be$export$e237513ae3de60b5);
$parcel$export(module.exports, "decisionIconWithoutVisualRefresh", () => $dab29d26076633be$export$921eec0bd8c26b90);
$parcel$export(module.exports, "taskItemStyles", () => $dab29d26076633be$export$2a9fa9bb25fe40d2);

var $1NIU8 = parcelRequire("1NIU8");

var $famkW = parcelRequire("famkW");
function $dab29d26076633be$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $dab29d26076633be$var$akEditorLineHeight = 1.714;
const $dab29d26076633be$var$akEditorSelectedNodeClassName = 'ak-editor-selected-node';
const $dab29d26076633be$export$a7172b75d403a0e4 = {
    DECISION_CONTAINER: 'decisionItemView-content-wrap',
    TASK_CONTAINER: 'taskItemView-content-wrap',
    TASK_ITEM: 'task-item',
    TASK_CHECKBOX_CONTAINER: 'task-item-checkbox-wrap'
};
const $dab29d26076633be$export$df437277fbc8b4f5 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.taskItemView-content-wrap, .${$dab29d26076633be$export$a7172b75d403a0e4.DECISION_CONTAINER}`]: {
            position: 'relative',
            minWidth: 48
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$dab29d26076633be$export$a7172b75d403a0e4.DECISION_CONTAINER}`]: {
            marginTop: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$dab29d26076633be$export$a7172b75d403a0e4.TASK_CONTAINER}`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            "span[contenteditable='false']": {
                height: `${$dab29d26076633be$var$akEditorLineHeight}em`
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$dab29d26076633be$export$a7172b75d403a0e4.TASK_ITEM}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: $dab29d26076633be$var$akEditorLineHeight
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    'div[data-task-local-id]': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "span[contenteditable='false']": {
            height: `${$dab29d26076633be$var$akEditorLineHeight}em`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "span[contenteditable='false'] + div": {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${$dab29d26076633be$var$akEditorLineHeight}em`
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    'div[data-task-list-local-id]': {
        margin: `${"var(--ds-space-150, 12px)"} 0 0 0`,
        // If task item is not first in the list then set margin top to 4px.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'div + div': {
            marginTop: "var(--ds-space-050, 4px)"
        }
    },
    // If task list is not first in the document then set margin top to 4px.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    'div[data-task-list-local-id] div[data-task-list-local-id]': {
        marginTop: "var(--ds-space-050, 4px)",
        marginLeft: "var(--ds-space-300, 24px)"
    },
    // When action list is inside panel
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ak-editor-panel__content': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-selectors
        '> div[data-task-list-local-id]:first-child': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            margin: '0 !important'
        }
    }
});
const $dab29d26076633be$export$c2f467e1dc47f4f1 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$dab29d26076633be$var$akEditorSelectedNodeClassName} > [data-decision-wrapper], ol[data-node-type='decisionList'].${$dab29d26076633be$var$akEditorSelectedNodeClassName}`]: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    [
        {
            borderRadius: '4px'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
        (0, $famkW.boxShadowSelectionStyles),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
        (0, $famkW.blanketSelectionStyles),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
        (0, $famkW.hideNativeBrowserTextSelectionStyles)
    ],
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.danger': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [`.${$dab29d26076633be$export$a7172b75d403a0e4.DECISION_CONTAINER}.${$dab29d26076633be$var$akEditorSelectedNodeClassName} > div`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            boxShadow: `0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`,
            backgroundColor: "var(--ds-blanket-danger, #EF5C4814)",
            '&::after': {
                content: 'none' // reset the Blanket selection style
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="decisionItem"]': {
        listStyleType: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper]': {
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'row',
        margin: `${"var(--ds-space-100, 8px)"} 0 0 0`,
        padding: "var(--ds-space-100, 8px)",
        paddingLeft: "var(--ds-space-150, 12px)",
        borderRadius: "var(--ds-border-radius-100, 4px)",
        backgroundColor: "var(--ds-background-neutral, #091E420F)",
        position: 'relative'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper] > [data-component="icon"]': {
        flex: '0 0 16px',
        height: '16px',
        width: '16px',
        margin: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-150, 12px)"} 0 0`,
        color: "var(--ds-icon-subtle, #626F86)",
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="decisionItem"]:not(:has([data-empty]):not(:has([data-type-ahead]))) > [data-decision-wrapper] > [data-component="icon"]': {
        color: "var(--ds-icon-success, #22A06B)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper] > [data-component="icon"] > span': {
        display: 'inline-block',
        flexShrink: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography -- Mirroring icon styles
        lineHeight: 1
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper] > [data-component="icon"] > span > svg': {
        overflow: 'hidden',
        pointerEvents: 'none',
        color: 'currentColor',
        verticalAlign: 'bottom'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper] > [data-component="placeholder"]': {
        margin: `0 0 0 calc(${"var(--ds-space-100, 8px)"} * 3.5)`,
        position: 'absolute',
        color: "var(--ds-text-subtlest, #626F86)",
        pointerEvents: 'none',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        maxWidth: 'calc(100% - 50px)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="decisionItem"]:not(:has([data-empty]):not(:has([data-type-ahead]))) > [data-decision-wrapper] > [data-component="placeholder"]': {
        display: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="decisionItem"] > [data-decision-wrapper] > [data-component="content"]': {
        margin: 0,
        wordWrap: 'break-word',
        minWidth: 0,
        flex: '1 1 auto'
    }
});
const $dab29d26076633be$export$e237513ae3de60b5 = {
    name: "b3ew8y",
    styles: "[data-prosemirror-node-name=\"decisionItem\"] > [data-decision-wrapper] > [data-component=\"icon\"] > span >  svg[data-icon-source=\"legacy\"]{display:none;}[data-prosemirror-node-name=\"decisionItem\"] > [data-decision-wrapper] > [data-component=\"icon\"] > span{box-sizing:border-box;padding-inline-end:var(--ds--button--new-icon-padding-end, 0);padding-inline-start:var(--ds--button--new-icon-padding-start, 0);@media screen and (forced-colors: active){color:canvastext;filter:grayscale(1);}}[data-prosemirror-node-name=\"decisionItem\"] > [data-decision-wrapper] > [data-component=\"icon\"] > span > svg{width:var(--ds-space-300, 24px);height:var(--ds-space-300, 24px);}"
};
const $dab29d26076633be$export$921eec0bd8c26b90 = {
    name: "s6v8rd",
    styles: "[data-prosemirror-node-name=\"decisionItem\"] > [data-decision-wrapper] > [data-component=\"icon\"] > span >  svg[data-icon-source=\"refreshed\"]{display:none;}[data-prosemirror-node-name=\"decisionItem\"] > [data-decision-wrapper] > [data-component=\"icon\"] > span{width:32px;height:32px;@media screen and (forced-colors: active){filter:grayscale(1);color:canvastext;fill:canvas;}}[data-prosemirror-node-name=\"decisionItem\"] > [data-decision-wrapper] > [data-component=\"icon\"] > span > svg{max-width:100%;max-height:100%;fill:var(--ds-surface, #FFFFFF);width:32px;height:32px;}"
};
const $dab29d26076633be$export$2a9fa9bb25fe40d2 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="taskItem"]': {
        listStyle: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="taskItem"] [data-component="task-item-main"]': {
        display: 'flex',
        flexDirection: 'row',
        position: 'relative'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="taskItem"] [data-component="placeholder"]': {
        position: 'absolute',
        color: "var(--ds-text-subtlest, #626F86)",
        margin: `0 0 0 calc(${"var(--ds-space-100, 8px)"} * 3)`,
        pointerEvents: 'none',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        maxWidth: 'calc(100% - 50px)',
        display: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    "[data-prosemirror-node-name='taskItem']:has([data-empty]):not(:has([data-type-ahead])) [data-component='placeholder']": {
        display: 'block'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="taskItem"] [data-component="content"]': {
        margin: 0,
        wordWrap: 'break-word',
        minWidth: 0,
        flex: '1 1 auto'
    },
    // copied styles from packages/design-system/icon/src/components/icon-new.tsx
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="taskItem"] [data-component="checkbox-icon-wrap"]': {
        display: 'inline-block',
        boxSizing: 'border-box',
        flexShrink: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 1,
        paddingInlineEnd: 'var(--ds--button--new-icon-padding-end, 0)',
        paddingInlineStart: 'var(--ds--button--new-icon-padding-start, 0)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="taskItem"] [data-component="checkbox-icon-wrap"] svg': {
        overflow: 'hidden',
        pointerEvents: 'none',
        color: 'currentColor',
        verticalAlign: 'bottom',
        width: "var(--ds-space-200, 16px)",
        height: "var(--ds-space-200, 16px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-node-name="taskItem"] input[type=checkbox]:not(:checked) + span [data-component=checkbox-checked-icon]': {
        display: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-node-name="taskItem"] input[type=checkbox]:not(:checked) + span [data-component=checkbox-unchecked-icon]': {
        display: 'inline'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="taskItem"] input[type=checkbox]:checked + span [data-component=checkbox-checked-icon]': {
        display: 'inline'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[data-prosemirror-node-name="taskItem"] input[type=checkbox]:checked + span [data-component=checkbox-unchecked-icon]': {
        display: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`[data-prosemirror-node-name="taskItem"] .${$dab29d26076633be$export$a7172b75d403a0e4.TASK_CHECKBOX_CONTAINER}`]: {
        flex: '0 0 24px',
        width: '24px',
        height: '24px',
        position: 'relative',
        alignSelf: 'start',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "& > input[type='checkbox']": {
            width: '16px',
            height: '16px',
            zIndex: 1,
            cursor: 'pointer',
            outline: 'none',
            margin: 0,
            opacity: 0,
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '&[disabled]': {
                cursor: 'default'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '+ span': {
                width: '24px',
                height: '24px',
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '+ span > svg': {
                boxSizing: 'border-box',
                display: 'inline',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                maxWidth: 'unset',
                maxHeight: 'unset',
                position: 'absolute',
                overflow: 'hidden',
                color: "var(--ds-background-input, #FFFFFF)",
                transition: 'color 0.2s ease-in-out, fill 0.2s ease-in-out',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                'path:first-of-type': {
                    visibility: 'hidden'
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                'rect:first-of-type': {
                    stroke: "var(--ds-border-input, #8590A2)",
                    strokeWidth: 1,
                    transition: 'stroke 0.2s ease-in-out'
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&:hover + span > svg': {
                color: "var(--ds-background-input-hovered, #F7F8F9)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                'rect:first-of-type': {
                    stroke: "var(--ds-border-input, #8590A2)"
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&:checked:hover + span > svg': {
                color: "var(--ds-background-selected-bold-hovered, #0055CC)",
                fill: "var(--ds-icon-inverse, #FFFFFF)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                'rect:first-of-type': {
                    stroke: "var(--ds-background-selected-bold-hovered, #0055CC)"
                }
            },
            '&:checked': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
                '+ span > svg': {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                    'path:first-of-type': {
                        visibility: 'visible'
                    },
                    color: "var(--ds-background-selected-bold, #0C66E4)",
                    fill: "var(--ds-icon-inverse, #FFFFFF)",
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                    'rect:first-of-type': {
                        stroke: "var(--ds-background-selected-bold, #0C66E4)"
                    }
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '&:active + span > svg': {
                color: "var(--ds-background-input-pressed, #FFFFFF)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                'rect:first-of-type': {
                    stroke: "var(--ds-border, #091E4224)"
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '&:checked:active + span > svg': {
                color: "var(--ds-background-input-pressed, #FFFFFF)",
                fill: "var(--ds-icon-inverse, #FFFFFF)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                'rect:first-of-type': {
                    stroke: "var(--ds-border, #091E4224)"
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '&:disabled + span > svg, &:disabled:hover + span > svg, &:disabled:focus + span > svg, &:disabled:active + span > svg': {
                color: "var(--ds-background-disabled, #091E4208)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                'rect:first-of-type': {
                    stroke: "var(--ds-background-disabled, #091E4208)"
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '&:disabled:checked + span > svg': {
                fill: "var(--ds-icon-disabled, #091E424F)"
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '&:focus + span::after': {
                position: 'absolute',
                width: "var(--ds-space-200, 16px)",
                height: "var(--ds-space-200, 16px)",
                border: `2px solid ${"var(--ds-border-focused, #388BFF)"}`,
                borderRadius: "var(--ds-space-050, 4px)",
                content: "''",
                display: 'block',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)'
            }
        }
    }
});

});

parcelRegister("bHGrA", function(module, exports) {

$parcel$export(module.exports, "telepointerColorAndCommonStyle", () => $181b659280034467$export$3f28e75e37279280);
$parcel$export(module.exports, "telepointerStyle", () => $181b659280034467$export$c94087d6ea5127ad);
$parcel$export(module.exports, "telepointerStyleWithInitialOnly", () => $181b659280034467$export$42e13fa9d2b0c35d);
/* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ /* eslint-disable @atlaskit/ui-styling-standard/no-exported-styles */ /* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ 
var $1NIU8 = parcelRequire("1NIU8");
function $181b659280034467$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $181b659280034467$var$pulseIn = (0, $1NIU8.keyframes)({
    '0%, 100%': {
        transform: 'scaleX(0)',
        opacity: 0
    },
    '10%': {
        transform: 'scaleX(1.4)',
        opacity: 1
    },
    '15%, 85%': {
        transform: 'scaleX(1)',
        opacity: 1
    }
});
const $181b659280034467$var$pulseOut = (0, $1NIU8.keyframes)({
    '0%, 90%, 100%': {
        transform: 'scaleX(1)',
        opacity: 1
    },
    '10%, 80%': {
        transform: 'scaleX(0)',
        opacity: 0
    }
});
const $181b659280034467$var$pulseInDuringTr = (0, $1NIU8.keyframes)({
    '0%, 95%': {
        transform: 'scaleX(1)',
        opacity: 1
    },
    '100%': {
        transform: 'scaleX(0)',
        opacity: 0
    }
});
const $181b659280034467$var$pulseOutDuringTr = (0, $1NIU8.keyframes)({
    '100%': {
        transform: 'scaleX(1)',
        opacity: 1
    },
    '0%, 90%': {
        transform: 'scaleX(0)',
        opacity: 0
    }
});
const $181b659280034467$export$3f28e75e37279280 = {
    name: "13y51hg",
    styles: ".ProseMirror .telepointer{position:relative;transition:opacity 200ms;&.telepointer-selection:not(.inlineNodeView){line-height:1.2;pointer-events:none;user-select:none;}&.telepointer-dim{opacity:0.2;}&.color-0{--telepointer-participant-text-color:var(--ds-text-inverse, #FFFFFF);--telepointer-participant-bg-color:var(--ds-background-accent-red-bolder, #C9372C);}&.color-1{--telepointer-participant-text-color:var(--ds-text-inverse, #FFFFFF);--telepointer-participant-bg-color:var(--ds-background-accent-blue-bolder, #0C66E4);}&.color-2{--telepointer-participant-text-color:var(--ds-text-inverse, #FFFFFF);--telepointer-participant-bg-color:var(--ds-background-accent-green-bolder, #1F845A);}&.color-3{--telepointer-participant-text-color:var(--ds-text-inverse, #FFFFFF);--telepointer-participant-bg-color:var(--ds-background-accent-yellow-bolder, #946F00);}&.color-4{--telepointer-participant-text-color:var(--ds-text-inverse, #FFFFFF);--telepointer-participant-bg-color:var(--ds-background-accent-purple-bolder, #6E5DC6);}&.color-5{--telepointer-participant-text-color:var(--ds-text-inverse, #FFFFFF);--telepointer-participant-bg-color:var(--ds-background-accent-magenta-bolder, #AE4787);}&.color-6{--telepointer-participant-text-color:var(--ds-text-inverse, #FFFFFF);--telepointer-participant-bg-color:var(--ds-background-accent-teal-bolder, #227D9B);}&.color-7{--telepointer-participant-text-color:var(--ds-text-inverse, #FFFFFF);--telepointer-participant-bg-color:var(--ds-background-accent-orange-bolder, #C25100);}&.color-8{--telepointer-participant-text-color:var(--ds-text-inverse, #FFFFFF);--telepointer-participant-bg-color:var(--ds-background-accent-lime-bolder, #5B7F24);}&.color-9{--telepointer-participant-text-color:var(--ds-text-inverse, #FFFFFF);--telepointer-participant-bg-color:var(--ds-background-accent-gray-bolder, #626F86);}&.color-10{--telepointer-participant-text-color:var(--ds-text-accent-gray-bolder, #091E42);--telepointer-participant-bg-color:var(--ds-background-accent-blue-subtle, #579DFF);}&.color-11{--telepointer-participant-text-color:var(--ds-text-accent-gray-bolder, #091E42);--telepointer-participant-bg-color:var(--ds-background-accent-red-subtle, #F87168);}&.color-12{--telepointer-participant-text-color:var(--ds-text-accent-gray-bolder, #091E42);--telepointer-participant-bg-color:var(--ds-background-accent-orange-subtle, #FEA362);}&.color-13{--telepointer-participant-text-color:var(--ds-text-accent-gray-bolder, #091E42);--telepointer-participant-bg-color:var(--ds-background-accent-yellow-subtle, #F5CD47);}&.color-14{--telepointer-participant-text-color:var(--ds-text-accent-gray-bolder, #091E42);--telepointer-participant-bg-color:var(--ds-background-accent-green-subtle, #4BCE97);}&.color-15{--telepointer-participant-text-color:var(--ds-text-accent-gray-bolder, #091E42);--telepointer-participant-bg-color:var(--ds-background-accent-teal-subtle, #6CC3E0);}&.color-16{--telepointer-participant-text-color:var(--ds-text-accent-gray-bolder, #091E42);--telepointer-participant-bg-color:var(--ds-background-accent-purple-subtle, #9F8FEF);}&.color-17{--telepointer-participant-text-color:var(--ds-text-accent-gray-bolder, #091E42);--telepointer-participant-bg-color:var(--ds-background-accent-magenta-subtle, #E774BB);}html:not([data-color-mode=dark]) &{--telepointer-participant-background-first-stop:-850000%;--telepointer-participant-background-second-stop:150000%;}html[data-color-mode=dark] &{--telepointer-participant-background-first-stop:-800000%;--telepointer-participant-background-second-stop:200000%;}&[class*=\"color-\"]{background:linear-gradient(to bottom, var(--telepointer-participant-bg-color) var(--telepointer-participant-background-first-stop), transparent var(--telepointer-participant-background-second-stop));&::after{background-color:var(--telepointer-participant-bg-color);color:var(--telepointer-participant-text-color);border-color:var(--telepointer-participant-bg-color);}}}"
};
const $181b659280034467$export$c94087d6ea5127ad = /*#__PURE__*/ (0, $1NIU8.css)({
    '.ProseMirror .telepointer': {
        '&.telepointer-selection-badge': {
            '.telepointer-initial, .telepointer-fullname': {
                position: 'absolute',
                display: 'block',
                userSelect: 'none',
                whiteSpace: 'pre',
                top: -14,
                left: 0,
                font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
                paddingLeft: "var(--ds-space-050, 4px)",
                paddingRight: "var(--ds-space-050, 4px)",
                color: "var(--ds-text-inverse, #FFFFFF)",
                borderRadius: '0 2px 2px 0'
            },
            '.telepointer-initial': {
                opacity: 1,
                transition: 'opacity 0.15s ease-out'
            },
            '.telepointer-fullname': {
                opacity: 0,
                transform: 'scaleX(0)',
                transformOrigin: 'top left',
                transition: 'transform 0.15s ease-out, opacity 0.15s ease-out'
            }
        },
        '&.telepointer-pulse-animate': {
            '.telepointer-initial': {
                animation: `${$181b659280034467$var$pulseOut} 2.5s ease-in-out`
            },
            '.telepointer-fullname': {
                animation: `${$181b659280034467$var$pulseIn} 2.5s ease-in-out`
            }
        },
        '&.telepointer-pulse-during-tr': {
            '.telepointer-initial': {
                animation: `${$181b659280034467$var$pulseOutDuringTr} 7500ms ease-in-out`
            },
            '.telepointer-fullname': {
                animation: `${$181b659280034467$var$pulseInDuringTr} 7500ms ease-in-out`
            }
        },
        '&:hover': {
            '.telepointer-initial': {
                opacity: 0,
                transitionDelay: '150ms'
            },
            '.telepointer-fullname': {
                transform: 'scaleX(1)',
                opacity: 1,
                zIndex: 1
            }
        }
    }
});
const $181b659280034467$export$42e13fa9d2b0c35d = /*#__PURE__*/ (0, $1NIU8.css)({
    '.ProseMirror .telepointer': {
        '&.telepointer-selection-badge::after': {
            content: 'attr(data-initial)',
            position: 'absolute',
            display: 'block',
            top: -14,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: '0.5625rem',
            padding: "var(--ds-space-025, 2px)",
            color: "var(--ds-text-inverse, #FFFFFF)",
            left: 0,
            borderRadius: '2px 2px 2px 0',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: 'initial'
        }
    }
});

});

parcelRegister("lOMXK", function(module, exports) {

$parcel$export(module.exports, "textColorStyles", () => $126b9fc34664e060$export$a518ea5d00002b38);
function $126b9fc34664e060$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $126b9fc34664e060$export$a518ea5d00002b38 = {
    name: "1nlqh0j",
    styles: ".fabric-text-color-mark{color:var(--custom-palette-color, inherit);}a .fabric-text-color-mark{color:unset;}"
};

});

parcelRegister("fdSLH", function(module, exports) {

$parcel$export(module.exports, "textHighlightStyle", () => $dfd7ca8f25ce57ed$export$b286500adc7d91cd);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $1NIU8 = parcelRequire("1NIU8");
const $dfd7ca8f25ce57ed$export$b286500adc7d91cd = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.text-highlight': {
        backgroundColor: "var(--ds-background-accent-blue-subtlest, #E9F2FF)",
        borderBottom: `2px solid ${"var(--ds-background-accent-blue-subtler, #CCE0FF)"}`
    }
});

});

parcelRegister("iBvA9", function(module, exports) {

$parcel$export(module.exports, "unsupportedStyles", () => $8785b25087c6a3b1$export$637bcb89343f7ef4);

var $1NIU8 = parcelRequire("1NIU8");

var $famkW = parcelRequire("famkW");
const $8785b25087c6a3b1$export$629043421dcc56e5 = {
    BLOCK_CONTAINER: 'unsupportedBlockView-content-wrap',
    INLINE_CONTAINER: 'unsupportedInlineView-content-wrap'
};
const $8785b25087c6a3b1$export$637bcb89343f7ef4 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
    [`.${$8785b25087c6a3b1$export$629043421dcc56e5.BLOCK_CONTAINER} > div, .${$8785b25087c6a3b1$export$629043421dcc56e5.INLINE_CONTAINER} > span:nth-of-type(2)`]: {
        cursor: 'pointer'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ak-editor-selected-node': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`&.${$8785b25087c6a3b1$export$629043421dcc56e5.BLOCK_CONTAINER} > div, &.${$8785b25087c6a3b1$export$629043421dcc56e5.INLINE_CONTAINER} > span:nth-of-type(2)`]: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $famkW.backgroundSelectionStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $famkW.borderSelectionStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $famkW.hideNativeBrowserTextSelectionStyles)
        ]
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.danger': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-editor-selected-node': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors,@atlaskit/ui-styling-standard/no-unsafe-values
            [`&.${$8785b25087c6a3b1$export$629043421dcc56e5.BLOCK_CONTAINER} > div, &.${$8785b25087c6a3b1$export$629043421dcc56e5.INLINE_CONTAINER} > span:nth-of-type(2)`]: {
                border: `1px solid ${"var(--ds-border-danger, #E2483D)"}`,
                backgroundColor: "var(--ds-blanket-danger, #EF5C4814)"
            }
        }
    }
});

});

parcelRegister("l0XHK", function(module, exports) {

$parcel$export(module.exports, "whitespaceStyles", () => $b673b6aaba39e431$export$2ee83b65ab9fac74);
function $b673b6aaba39e431$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b673b6aaba39e431$export$2ee83b65ab9fac74 = {
    name: "1e3eb5t",
    styles: ".ProseMirror{word-wrap:break-word;white-space:pre-wrap;}"
};

});


parcelRegister("gyhYD", function(module, exports) {

$parcel$export(module.exports, "default", () => $be2098ae651ac5e5$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $cSmYj = parcelRequire("cSmYj");

var $bMFKb = parcelRequire("bMFKb");

var $lTt3Y = parcelRequire("lTt3Y");

var $a8knB = parcelRequire("a8knB");
function $be2098ae651ac5e5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $be2098ae651ac5e5$var$pluginsComponentsWrapper = {
    name: "zjik7",
    styles: "display:flex"
};
const $be2098ae651ac5e5$var$PluginSlot = ({ items: items, editorView: editorView, editorActions: editorActions, eventDispatcher: eventDispatcher, providerFactory: providerFactory, appearance: appearance, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, containerElement: containerElement, disabled: disabled, dispatchAnalyticsEvent: dispatchAnalyticsEvent, wrapperElement: wrapperElement, pluginHooks: pluginHooks })=>{
    if (!items && !pluginHooks || !editorView) return null;
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $lTt3Y.ErrorBoundary), {
        component: (0, $bMFKb.ACTION_SUBJECT).PLUGIN_SLOT,
        fallbackComponent: null
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $a8knB.MountPluginHooks), {
        editorView: editorView,
        pluginHooks: pluginHooks,
        containerElement: containerElement
    }), /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $be2098ae651ac5e5$var$pluginsComponentsWrapper
    }, items?.map((component, key)=>{
        const props = {
            key: key
        };
        const element = component({
            editorView: editorView,
            editorActions: editorActions,
            eventDispatcher: eventDispatcher,
            providerFactory: providerFactory,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            appearance: appearance,
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: popupsBoundariesElement,
            popupsScrollableElement: popupsScrollableElement,
            containerElement: containerElement,
            disabled: disabled,
            wrapperElement: wrapperElement
        });
        return element && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).cloneElement(element, props);
    })));
};
const $be2098ae651ac5e5$var$PluginSlotComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo($be2098ae651ac5e5$var$PluginSlot, (0, (/*@__PURE__*/$parcel$interopDefault($cSmYj))));
$be2098ae651ac5e5$var$PluginSlotComponent.displayName = 'PluginSlot';
var $be2098ae651ac5e5$export$2e2bcd8739ae039 = $be2098ae651ac5e5$var$PluginSlotComponent;

});
parcelRegister("lTt3Y", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $207e38d0440b647d$export$e926676385687eaf);

var $eJOHy = parcelRequire("eJOHy");

var $bMFKb = parcelRequire("bMFKb");

var $djRdf = parcelRequire("djRdf");
class $207e38d0440b647d$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    hasFallback() {
        return typeof this.props.fallbackComponent !== 'undefined';
    }
    shouldRecover() {
        return this.hasFallback() && this.state.errorCaptured;
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.dispatchAnalyticsEvent) this.props.dispatchAnalyticsEvent({
            action: (0, $bMFKb.ACTION).EDITOR_CRASHED,
            actionSubject: this.props.component,
            actionSubjectId: this.props.componentId,
            eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL,
            attributes: {
                error: error,
                errorInfo: errorInfo,
                errorRethrown: !this.hasFallback()
            }
        });
        (0, $djRdf.logException)(error, {
            location: 'editor-core/ui'
        });
        if (this.hasFallback()) this.setState({
            errorCaptured: true
        });
    }
    render() {
        if (this.shouldRecover()) return this.props.fallbackComponent;
        return this.props.children;
    }
    constructor(...args){
        super(...args), this.state = {
            errorCaptured: false
        };
    }
}

});

parcelRegister("a8knB", function(module, exports) {

$parcel$export(module.exports, "MountPluginHooks", () => $6043c76403f3f940$export$a9224552b63e3fe8);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
function $6043c76403f3f940$var$MountPluginHook({ usePluginHook: usePluginHook, editorView: editorView, containerElement: containerElement }) {
    usePluginHook({
        editorView: editorView,
        containerElement: containerElement
    });
    return null;
}
function $6043c76403f3f940$export$a9224552b63e3fe8({ pluginHooks: pluginHooks, editorView: editorView, containerElement: containerElement }) {
    if (!editorView) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: pluginHooks?.map((usePluginHook, key)=>/*#__PURE__*/ (0, $gt9Am.jsx)($6043c76403f3f940$var$MountPluginHook, {
                usePluginHook: usePluginHook,
                editorView: editorView,
                containerElement: containerElement
            }, key))
    });
}

});


parcelRegister("52GJU", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd92e6ea4def32e6$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");
const $bd92e6ea4def32e6$var$pulseBackground = (0, $1NIU8.keyframes)({
    '50%': {
        backgroundColor: "var(--ds-blanket-danger, #EF5C4814)"
    }
});
const $bd92e6ea4def32e6$var$pulseBackgroundReverse = (0, $1NIU8.keyframes)({
    '0%': {
        backgroundColor: "var(--ds-blanket-danger, #EF5C4814)"
    },
    '50%': {
        backgroundColor: 'auto'
    },
    '100%': {
        backgroundColor: "var(--ds-blanket-danger, #EF5C4814)"
    }
});
const $bd92e6ea4def32e6$var$flashWrapper = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.-flash > div': {
        animationName: $bd92e6ea4def32e6$var$pulseBackgroundReverse,
        animationDuration: '0.25s',
        animationTimingFunction: 'ease-in-out'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > div': {
        animation: "'none'"
    }
});
const $bd92e6ea4def32e6$var$flashWrapperAnimated = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`${$bd92e6ea4def32e6$var$flashWrapper} & > div`]: {
        animationName: $bd92e6ea4def32e6$var$pulseBackground,
        animationDuration: '0.25s',
        animationTimingFunction: 'ease-in-out'
    }
});
class $bd92e6ea4def32e6$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    render() {
        const { animate: animate, children: children } = this.props;
        this.toggle = animate && !this.toggle;
        return(// eslint-disable-next-line @atlaskit/design-system/prefer-primitives
        /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            css: animate ? $bd92e6ea4def32e6$var$flashWrapperAnimated : $bd92e6ea4def32e6$var$flashWrapper,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: this.toggle ? '-flash' : ''
        }, children));
    }
    constructor(...args){
        super(...args), this.toggle = false;
    }
}

});


parcelRegister("oN7a7", function(module, exports) {

$parcel$export(module.exports, "CommentEditorWithIntl", () => $60fe10be5cfe3118$export$7b9f3a51cd0c1967);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $k9JrM = parcelRequire("k9JrM");

var $lRq8t = parcelRequire("lRq8t");

var $48q59 = parcelRequire("48q59");

var $5CSKW = parcelRequire("5CSKW");

var $kLQ9a = parcelRequire("kLQ9a");
var $bSToC = parcelRequire("bSToC");

var $h2yqz = parcelRequire("h2yqz");

var $cidLz = parcelRequire("cidLz");

var $2bEPZ = parcelRequire("2bEPZ");

var $baHgw = parcelRequire("baHgw");

var $frlUM = parcelRequire("frlUM");
parcelRequire("62CL0");
var $2G9Kp = parcelRequire("2G9Kp");

var $7yBx7 = parcelRequire("7yBx7");

var $AIyOt = parcelRequire("AIyOt");

var $cbSL1 = parcelRequire("cbSL1");

var $92xoS = parcelRequire("92xoS");

var $g5n6x = parcelRequire("g5n6x");

var $g0hAu = parcelRequire("g0hAu");

var $jyiGU = parcelRequire("jyiGU");

var $7XjxI = parcelRequire("7XjxI");

var $gyhYD = parcelRequire("gyhYD");

var $8NyYn = parcelRequire("8NyYn");

var $83GXu = parcelRequire("83GXu");

var $52GJU = parcelRequire("52GJU");

var $xxDMM = parcelRequire("xxDMM");
function $60fe10be5cfe3118$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $60fe10be5cfe3118$var$CommentEditorMargin = 14;
const $60fe10be5cfe3118$var$MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT = 490;
const $60fe10be5cfe3118$var$commentEditorStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    display: 'flex',
    flexDirection: 'column',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.less-margin .ProseMirror': {
        margin: `${"var(--ds-space-150, 12px)"} ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"}`
    },
    minWidth: '272px',
    height: 'auto',
    backgroundColor: "var(--ds-background-input, white)",
    border: `1px solid ${"var(--ds-border-input, #8590A2)"}`,
    boxSizing: 'border-box',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: "var(--ds-border-radius, 3px)",
    maxWidth: 'inherit',
    wordWrap: 'break-word'
});
const $60fe10be5cfe3118$var$ContentArea = (0, $jyiGU.createEditorContentStyle)(/*#__PURE__*/ (0, $1NIU8.css)({
    flexGrow: 1,
    overflowX: 'clip',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '24px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.ProseMirror': {
        margin: "var(--ds-space-150, 12px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.gridParent': {
        marginLeft: "var(--ds-space-025, 2px)",
        marginRight: "var(--ds-space-025, 2px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `calc(100% + ${$60fe10be5cfe3118$var$CommentEditorMargin - (0, $cidLz.GRID_GUTTER)}px)`
    },
    padding: "var(--ds-space-250, 20px)"
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
(0, $2G9Kp.tableCommentEditorStyles)));
$60fe10be5cfe3118$var$ContentArea.displayName = 'ContentArea';
const $60fe10be5cfe3118$var$secondaryToolbarStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    boxSizing: 'border-box',
    justifyContent: 'flex-end',
    alignItems: 'center',
    display: 'flex',
    padding: `${"var(--ds-space-150, 12px)"} ${"var(--ds-space-025, 2px)"}`
});
const $60fe10be5cfe3118$var$mainToolbarCustomComponentsSlotStyle = (isTwoLineEditorToolbar = false)=>/*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Needs manual remediation
    (0, $1NIU8.css)("display:flex;justify-content:flex-end;align-items:center;flex-grow:1;padding-right:var(--ds-space-250, 20px);>div{display:flex;flex-shrink:0;}", isTwoLineEditorToolbar && `
    @media (max-width: ${$60fe10be5cfe3118$var$MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT}px) {
      {
        padding-right: 0;
      }
    }
  `, ";");
const $60fe10be5cfe3118$var$mainToolbarCustomComponentsSlotStyleNew = {
    name: "4cnzc6",
    styles: "display:flex;justify-content:flex-end;align-items:center;flex-grow:1;padding-right:var(--ds-space-250, 20px);> div{display:flex;flex-shrink:0;}"
};
const $60fe10be5cfe3118$var$mainToolbarCustomComponentsSlotStyleTwoLineToolbarNew = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    [`@media (max-width: ${$60fe10be5cfe3118$var$MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT}px)`]: {
        paddingRight: 0
    }
});
const $60fe10be5cfe3118$var$appearance = 'comment';
const $60fe10be5cfe3118$var$EditorContainer = (0, $AIyOt.componentWithCondition)(()=>(0, $92xoS.editorExperiment)('platform_editor_core_static_emotion', true, {
        exposure: true
    }), (0, $7XjxI.default), $60fe10be5cfe3118$var$ContentArea);
const $60fe10be5cfe3118$var$useCommentEditorPluginsStates = (0, $kLQ9a.sharedPluginStateHookMigratorFactory)((pluginInjectionApi)=>{
    return (0, $bSToC.useSharedPluginState)(pluginInjectionApi, [
        'maxContentSize',
        'primaryToolbar',
        'editorViewMode'
    ]);
}, (pluginInjectionApi)=>{
    const maxContentSizeReached = (0, $frlUM.useSharedPluginStateSelector)(pluginInjectionApi, 'maxContentSize.maxContentSizeReached');
    const primaryToolbarComponents = (0, $frlUM.useSharedPluginStateSelector)(pluginInjectionApi, 'primaryToolbar.components');
    const editorViewMode = (0, $frlUM.useSharedPluginStateSelector)(pluginInjectionApi, 'editorViewMode.mode');
    return {
        maxContentSizeState: maxContentSizeReached === undefined ? undefined : {
            maxContentSizeReached: maxContentSizeReached
        },
        primaryToolbarState: !primaryToolbarComponents ? undefined : {
            components: primaryToolbarComponents
        },
        editorViewModeState: !editorViewMode ? undefined : {
            mode: editorViewMode
        }
    };
});
const $60fe10be5cfe3118$export$7b9f3a51cd0c1967 = (props)=>{
    const { editorAPI: editorAPI } = props;
    const { maxContentSizeState: maxContentSizeState, primaryToolbarState: primaryToolbarHookState, editorViewModeState: editorViewModeState } = $60fe10be5cfe3118$var$useCommentEditorPluginsStates(editorAPI);
    const primaryToolbarState = (0, $8NyYn.getPrimaryToolbarComponents)(editorAPI, primaryToolbarHookState?.components);
    const { mediaState: mediaState } = (0, $bSToC.useSharedPluginState)(editorAPI, [
        'media'
    ]);
    const intl = (0, $lRq8t.default)();
    const { editorDOMElement: editorDOMElement, editorView: editorView, editorActions: editorActions, eventDispatcher: eventDispatcher, providerFactory: providerFactory, contentComponents: contentComponents, customContentComponents: customContentComponents, customPrimaryToolbarComponents: customPrimaryToolbarComponents, primaryToolbarComponents: primaryToolbarComponentsProp, customSecondaryToolbarComponents: customSecondaryToolbarComponents, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, maxHeight: maxHeight, minHeight: minHeight = 150, onSave: onSave, onCancel: onCancel, disabled: disabled, dispatchAnalyticsEvent: dispatchAnalyticsEvent, useStickyToolbar: useStickyToolbar, pluginHooks: pluginHooks, featureFlags: featureFlags, innerRef: innerRef } = props;
    const maxContentSizeReached = Boolean(maxContentSizeState?.maxContentSizeReached);
    const showSecondaryToolbar = !!onSave || !!onCancel || !!customSecondaryToolbarComponents;
    const containerElement = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef(null);
    // Wrapper container for toolbar and content area
    const wrapperElementRef = (0, $eJOHy.useMemo)(()=>innerRef || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createRef(), [
        innerRef
    ]);
    const [saveButtonDisabled, setSaveButtonDisabled] = (0, $eJOHy.useState)(false);
    (0, $eJOHy.useEffect)(()=>{
        if (mediaState) mediaState.subscribeToUploadInProgressState(setSaveButtonDisabled);
        return ()=>mediaState?.unsubscribeFromUploadInProgressState(setSaveButtonDisabled);
    }, [
        mediaState
    ]);
    const handleSave = (0, $eJOHy.useCallback)(()=>{
        if (editorView && onSave) onSave(editorView);
    }, [
        editorView,
        onSave
    ]);
    const handleCancel = (0, $eJOHy.useCallback)(()=>{
        if (editorView && onCancel) onCancel(editorView);
    }, [
        editorView,
        onCancel
    ]);
    const isShortcutToFocusToolbar = (0, $eJOHy.useCallback)((event)=>{
        //Alt + F9 to reach first element in this main toolbar
        return event.altKey && (event.key === 'F9' || event.keyCode === 120);
    }, []);
    // When primary toolbar components is undefined, do not show two line editor toolbar
    const isTwoLineToolbarEnabled = !!customPrimaryToolbarComponents;
    const handleEscape = (0, $eJOHy.useCallback)((event)=>{
        if (!editorView?.hasFocus()) editorView?.focus();
        event.preventDefault();
        event.stopPropagation();
    }, [
        editorView
    ]);
    let primaryToolbarComponents = primaryToolbarComponentsProp;
    if (Array.isArray(primaryToolbarState?.components) && Array.isArray(primaryToolbarComponents)) primaryToolbarComponents = primaryToolbarState.components.concat(primaryToolbarComponents);
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $52GJU.default), {
        animate: maxContentSizeReached
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $2bEPZ.WidthProvider), null, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: [
            $60fe10be5cfe3118$var$commentEditorStyles,
            /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $1NIU8.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                minHeight: `${minHeight}px`
            })
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "akEditor",
        ref: wrapperElementRef
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $xxDMM.MainToolbar), {
        useStickyToolbar: useStickyToolbar,
        twoLineEditorToolbar: isTwoLineToolbarEnabled
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $baHgw.ToolbarArrowKeyNavigationProvider), {
        editorView: editorView,
        childComponentSelector: "[data-testid='ak-editor-main-toolbar']",
        isShortcutToFocusToolbar: isShortcutToFocusToolbar,
        handleEscape: handleEscape,
        editorAppearance: $60fe10be5cfe3118$var$appearance,
        useStickyToolbar: useStickyToolbar,
        intl: intl
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $83GXu.ToolbarWithSizeDetector), {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        editorView: editorView,
        editorActions: editorActions,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        eventDispatcher: eventDispatcher,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        providerFactory: providerFactory,
        appearance: $60fe10be5cfe3118$var$appearance,
        items: primaryToolbarComponents,
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        disabled: !!disabled,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        containerElement: containerElement.current,
        twoLineEditorToolbar: isTwoLineToolbarEnabled
    }), /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: (0, $cbSL1.expValEquals)('platform_editor_core_static_emotion_non_central', 'isEnabled', true) ? [
            $60fe10be5cfe3118$var$mainToolbarCustomComponentsSlotStyleNew,
            isTwoLineToolbarEnabled && $60fe10be5cfe3118$var$mainToolbarCustomComponentsSlotStyleTwoLineToolbarNew
        ] : /* eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766 */ $60fe10be5cfe3118$var$mainToolbarCustomComponentsSlotStyle(isTwoLineToolbarEnabled)
    }, customPrimaryToolbarComponents))), /*#__PURE__*/ (0, $1NIU8.jsx)((0, $g5n6x.default), {
        editorView: editorView,
        editorDisabled: disabled
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $2bEPZ.WidthConsumer), null, ({ width: width })=>{
        return /*#__PURE__*/ (0, $1NIU8.jsx)($60fe10be5cfe3118$var$EditorContainer, {
            ref: containerElement,
            css: maxHeight ? /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $1NIU8.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                maxHeight: `${maxHeight}px`,
                // When maxHeight is set, content area should have overflow-y explicitly set as auto
                // As we have overflow-x: clip for the content area, and when maxHeight prop is set, overflow-y will be computed as visible by default.
                // This will cause the content area to have content overflowing the container
                // so need to set overflow-y as auto to make sure the content area is scrollable
                overflowY: 'auto'
            }) : null,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, (/*@__PURE__*/$parcel$interopDefault($k9JrM)))('ak-editor-content-area', {
                'less-margin': width < (0, $7yBx7.akEditorMobileBreakoutPoint)
            }),
            featureFlags: featureFlags,
            viewMode: editorViewModeState?.mode,
            appearance: $60fe10be5cfe3118$var$appearance
        }, customContentComponents && 'before' in customContentComponents ? (0, $g0hAu.contentComponentClickWrapper)(customContentComponents.before) : (0, $g0hAu.contentComponentClickWrapper)(customContentComponents), /*#__PURE__*/ (0, $1NIU8.jsx)((0, $gyhYD.default), {
            editorView: editorView,
            editorActions: editorActions,
            eventDispatcher: eventDispatcher,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            providerFactory: providerFactory,
            appearance: $60fe10be5cfe3118$var$appearance,
            items: contentComponents,
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: popupsBoundariesElement,
            popupsScrollableElement: popupsScrollableElement,
            containerElement: containerElement.current,
            disabled: !!disabled,
            wrapperElement: wrapperElementRef.current,
            pluginHooks: pluginHooks
        }), editorDOMElement, customContentComponents && 'after' in customContentComponents ? (0, $g0hAu.contentComponentClickWrapper)(customContentComponents.after) : null);
    }))), showSecondaryToolbar && /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $60fe10be5cfe3118$var$secondaryToolbarStyles,
        "data-testid": "ak-editor-secondary-toolbar"
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $48q59.default), null, !!onSave && /*#__PURE__*/ (0, $1NIU8.jsx)((0, $5CSKW.default), {
        appearance: "primary",
        onClick: handleSave,
        testId: "comment-save-button",
        isDisabled: disabled || saveButtonDisabled,
        interactionName: "editor-comment-save-button"
    }, intl.formatMessage((0, $h2yqz.default).saveButton)), !!onCancel && /*#__PURE__*/ (0, $1NIU8.jsx)((0, $5CSKW.default), {
        appearance: "subtle",
        onClick: handleCancel,
        isDisabled: disabled,
        interactionName: "editor-comment-cancel-button"
    }, intl.formatMessage((0, $h2yqz.default).cancelButton))), /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        style: {
            flexGrow: 1
        }
    }), customSecondaryToolbarComponents)));
};
$60fe10be5cfe3118$export$7b9f3a51cd0c1967.displayName = 'CommentEditorAppearance';

});
parcelRegister("k9JrM", function(module, exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if (0, module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRegister("baHgw", function(module, exports) {

$parcel$export(module.exports, "KeyDownHandlerContext", () => $3af9f0f89cac008b$export$5455406531e3792c);
$parcel$export(module.exports, "ToolbarArrowKeyNavigationProvider", () => $3af9f0f89cac008b$export$9837e395eba6f527);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $92xoS = parcelRequire("92xoS");

var $jiQ0H = parcelRequire("jiQ0H");

var $1LIK6 = parcelRequire("1LIK6");

var $jlbSP = parcelRequire("jlbSP");

function $3af9f0f89cac008b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $3af9f0f89cac008b$export$5455406531e3792c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext({
    handleArrowLeft: ()=>{},
    handleArrowRight: ()=>{},
    handleTab: ()=>{}
});
const $3af9f0f89cac008b$var$centeredToolbarContainer = {
    name: "1iikq5b",
    styles: "display:flex;width:100%;align-items:center"
};
const $3af9f0f89cac008b$export$9837e395eba6f527 = ({ children: children, editorView: editorView, childComponentSelector: childComponentSelector, handleEscape: handleEscape, disableArrowKeyNavigation: disableArrowKeyNavigation, isShortcutToFocusToolbar: isShortcutToFocusToolbar, editorAppearance: editorAppearance, useStickyToolbar: useStickyToolbar, intl: intl })=>{
    const wrapperRef = (0, $eJOHy.useRef)(null);
    const selectedItemIndex = (0, $eJOHy.useRef)(0);
    const incrementIndex = (0, $eJOHy.useCallback)((list)=>{
        let index = 0;
        if (document.activeElement) {
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            index = list.indexOf(document.activeElement);
            index = (index + 1) % list.length;
        }
        selectedItemIndex.current = index;
    }, []);
    const decrementIndex = (0, $eJOHy.useCallback)((list)=>{
        let index = 0;
        if (document.activeElement) {
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            index = list.indexOf(document.activeElement);
            index = (list.length + index - 1) % list.length;
        }
        selectedItemIndex.current = index;
    }, []);
    const handleArrowRight = ()=>{
        const filteredFocusableElements = $3af9f0f89cac008b$var$getFilteredFocusableElements(wrapperRef?.current);
        incrementIndex(filteredFocusableElements);
        filteredFocusableElements[selectedItemIndex.current]?.focus();
    };
    const handleArrowLeft = ()=>{
        const filteredFocusableElements = $3af9f0f89cac008b$var$getFilteredFocusableElements(wrapperRef?.current);
        decrementIndex(filteredFocusableElements);
        filteredFocusableElements[selectedItemIndex.current]?.focus();
    };
    const handleTab = ()=>{
        const filteredFocusableElements = $3af9f0f89cac008b$var$getFilteredFocusableElements(wrapperRef?.current);
        filteredFocusableElements[selectedItemIndex.current]?.focus();
    };
    const handleArrowRightMemoized = (0, $eJOHy.useCallback)(()=>{
        const filteredFocusableElements = $3af9f0f89cac008b$var$getFilteredFocusableElements(wrapperRef?.current);
        incrementIndex(filteredFocusableElements);
        filteredFocusableElements[selectedItemIndex.current]?.focus();
    }, [
        incrementIndex
    ]);
    const handleArrowLeftMemoized = (0, $eJOHy.useCallback)(()=>{
        const filteredFocusableElements = $3af9f0f89cac008b$var$getFilteredFocusableElements(wrapperRef?.current);
        decrementIndex(filteredFocusableElements);
        filteredFocusableElements[selectedItemIndex.current]?.focus();
    }, [
        decrementIndex
    ]);
    const handleTabMemoized = (0, $eJOHy.useCallback)(()=>{
        const filteredFocusableElements = $3af9f0f89cac008b$var$getFilteredFocusableElements(wrapperRef?.current);
        filteredFocusableElements[selectedItemIndex.current]?.focus();
    }, []);
    const handleTabLocal = ()=>{
        const filteredFocusableElements = $3af9f0f89cac008b$var$getFilteredFocusableElements(wrapperRef?.current);
        filteredFocusableElements.forEach((element)=>{
            element.setAttribute('tabindex', '-1');
        });
        filteredFocusableElements[selectedItemIndex.current].setAttribute('tabindex', '0');
    };
    const focusAndScrollToElement = (element, scrollToElement = true)=>{
        if (scrollToElement) element?.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'nearest'
        });
        element.focus();
    };
    const submenuKeydownHandleContextRaw = {
        handleArrowLeft: handleArrowLeft,
        handleArrowRight: handleArrowRight,
        handleTab: handleTab
    };
    const submenuKeydownHandleContextMemoized = (0, $eJOHy.useMemo)(()=>({
            handleArrowLeft: handleArrowLeftMemoized,
            handleArrowRight: handleArrowRightMemoized,
            handleTab: handleTabMemoized
        }), [
        handleArrowLeftMemoized,
        handleArrowRightMemoized,
        handleTabMemoized
    ]);
    const submenuKeydownHandleContext = (0, $92xoS.editorExperiment)('platform_editor_toolbar_rerender_optimization_exp', true) ? submenuKeydownHandleContextMemoized : submenuKeydownHandleContextRaw;
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (!wrapperRef.current || disableArrowKeyNavigation) return;
        const { current: element } = wrapperRef;
        /**
     * To handle the key events on the list
     * @param event
     */ const handleKeyDown = (event)=>{
            // To trap the focus inside the horizontal toolbar for left and right arrow keys
            const targetElement = event.target;
            if (targetElement instanceof HTMLElement && !targetElement.closest(`${childComponentSelector}`)) return;
            if (targetElement instanceof HTMLElement && document.querySelector('[data-role="droplistContent"], [data-test-id="color-picker-menu"], [data-emoji-picker-container="true"]')?.contains(targetElement) || targetElement instanceof HTMLElement && document.querySelector('[data-test-id="color-picker-menu"]')?.contains(targetElement) || event.key === 'ArrowUp' || event.key === 'ArrowDown' || disableArrowKeyNavigation) return;
            const menuWrapper = document.querySelector('.menu-key-handler-wrapper');
            if (menuWrapper) // if menu wrapper exists, then a menu is open and arrow keys will be handled by MenuArrowKeyNavigationProvider
            return;
            const elementBrowser = wrapperRef?.current?.querySelector(`#${(0, $jiQ0H.ELEMENT_BROWSER_ID)}`);
            if (elementBrowser) // if element browser is open, then arrow keys will be handled by MenuArrowKeyNavigationProvider
            return;
            const filteredFocusableElements = $3af9f0f89cac008b$var$getFilteredFocusableElements(wrapperRef?.current);
            if (!filteredFocusableElements || filteredFocusableElements?.length === 0) return;
            // If the target element is the media picker then navigation is handled by the media picker
            if (targetElement instanceof HTMLElement && targetElement.closest(`[aria-label="${intl.formatMessage((0, $jlbSP.mediaInsertMessages).mediaPickerPopupAriaLabel)}"]`)) return;
            if (targetElement instanceof HTMLElement && !wrapperRef.current?.contains(targetElement)) selectedItemIndex.current = -1;
            else selectedItemIndex.current = targetElement instanceof HTMLElement && filteredFocusableElements.indexOf(targetElement) > -1 ? filteredFocusableElements.indexOf(targetElement) : selectedItemIndex.current;
            // do not scroll to focused element for sticky toolbar when navigating with arrows to avoid unnesessary scroll jump
            const allowScrollToElement = !(editorAppearance === 'comment' && !!useStickyToolbar);
            switch(event.key){
                case 'ArrowRight':
                    incrementIndex(filteredFocusableElements);
                    focusAndScrollToElement(filteredFocusableElements[selectedItemIndex.current], allowScrollToElement);
                    event.preventDefault();
                    break;
                case 'ArrowLeft':
                    decrementIndex(filteredFocusableElements);
                    focusAndScrollToElement(filteredFocusableElements[selectedItemIndex.current], allowScrollToElement);
                    event.preventDefault();
                    break;
                case 'Tab':
                    handleTabLocal();
                    break;
                case 'Escape':
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    handleEscape(event);
                    break;
                default:
            }
        };
        const globalKeyDownHandler = (event)=>{
            // To focus the first element in the toolbar
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            if (isShortcutToFocusToolbar(event)) {
                const filteredFocusableElements = $3af9f0f89cac008b$var$getFilteredFocusableElements(wrapperRef?.current);
                filteredFocusableElements[0]?.focus();
                // Button component from DS removes focus ring when :focus:not(:focus-visible) is true
                // Since here we programmatically focus the first button in the toolbar (as suppose to keyboard navigation), browser does not always force focus-visible to true
                // which is why the first button in the toolbar is not shown with focus ring
                // The workaround is add a new classname so we add back focus ring when the button is focused
                if (filteredFocusableElements[0]?.tagName === 'BUTTON') filteredFocusableElements[0].classList.add('first-floating-toolbar-button');
                filteredFocusableElements[0]?.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                    inline: 'nearest'
                });
            }
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element?.addEventListener('keydown', handleKeyDown);
        const editorViewDom = editorView?.dom;
        if (isShortcutToFocusToolbar) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        editorViewDom?.addEventListener('keydown', globalKeyDownHandler);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element?.removeEventListener('keydown', handleKeyDown);
            if (isShortcutToFocusToolbar) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            editorViewDom?.removeEventListener('keydown', globalKeyDownHandler);
        };
    }, [
        selectedItemIndex,
        wrapperRef,
        editorView,
        disableArrowKeyNavigation,
        handleEscape,
        childComponentSelector,
        incrementIndex,
        decrementIndex,
        isShortcutToFocusToolbar,
        editorAppearance,
        useStickyToolbar,
        intl
    ]);
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: editorAppearance === 'comment' && $3af9f0f89cac008b$var$centeredToolbarContainer,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "custom-key-handler-wrapper",
        ref: wrapperRef,
        role: "toolbar",
        "aria-label": intl.formatMessage((0, $1LIK6.messages).toolbarLabel),
        "aria-controls": (0, $0f281244a829b337$export$b16ce0826b76e795)
    }, /*#__PURE__*/ (0, $1NIU8.jsx)($3af9f0f89cac008b$export$5455406531e3792c.Provider, {
        value: submenuKeydownHandleContext
    }, children));
};
function $3af9f0f89cac008b$var$getFocusableElements(rootNode) {
    if (!rootNode) return [];
    const focusableModalElements = rootNode.querySelectorAll('a[href], button:not([disabled]), textarea, input, select, div[tabindex="-1"], div[tabindex="0"]') || [];
    return Array.from(focusableModalElements);
}
function $3af9f0f89cac008b$var$getFilteredFocusableElements(rootNode) {
    // The focusable elements from child components such as dropdown menus / popups are ignored
    return $3af9f0f89cac008b$var$getFocusableElements(rootNode).filter((elm)=>{
        const style = window.getComputedStyle(elm);
        // ignore invisible element to avoid losing focus
        const isVisible = style.visibility !== 'hidden' && style.display !== 'none';
        return !elm.closest('[data-role="droplistContent"]') && !elm.closest('[data-emoji-picker-container="true"]') && !elm.closest('[data-test-id="color-picker-menu"]') && !elm.closest('.scroll-buttons') && isVisible;
    });
}

});
parcelRegister("jiQ0H", function(module, exports) {

$parcel$export(module.exports, "GRID_SIZE", () => $238f781d7af120a7$export$bc90872e265d166e);
$parcel$export(module.exports, "DEVICE_BREAKPOINT_NUMBERS", () => $238f781d7af120a7$export$1f1798e92fa75806);
$parcel$export(module.exports, "FLEX_ITEMS_CONTAINER_BREAKPOINT_NUMBERS", () => $238f781d7af120a7$export$69bde1b03e8b5224);
$parcel$export(module.exports, "SIDEBAR_WIDTH", () => $238f781d7af120a7$export$780035d9fe48eb32);
$parcel$export(module.exports, "SIDEBAR_HEADING_WRAPPER_HEIGHT", () => $238f781d7af120a7$export$95b62a1773aa5ebe);
$parcel$export(module.exports, "INLINE_SIDEBAR_HEIGHT", () => $238f781d7af120a7$export$51a2d6b2c009fbfd);
$parcel$export(module.exports, "SEARCH_ITEM_HEIGHT_WIDTH", () => $238f781d7af120a7$export$df8bcac60101d466);
$parcel$export(module.exports, "SCROLLBAR_WIDTH", () => $238f781d7af120a7$export$9a6bb2acef5e644a);
$parcel$export(module.exports, "ELEMENT_LIST_PADDING", () => $238f781d7af120a7$export$3b8e93b2c0f295b0);
$parcel$export(module.exports, "ELEMENT_ITEM_HEIGHT", () => $238f781d7af120a7$export$6d221f35db1b75aa);
$parcel$export(module.exports, "ELEMENT_ITEM_PADDING", () => $238f781d7af120a7$export$ab53450bc5fd5b7d);
$parcel$export(module.exports, "ELEMENT_BROWSER_ID", () => $238f781d7af120a7$export$6ee360fa4b93ee8e);
const $238f781d7af120a7$export$bc90872e265d166e = 8;
const $238f781d7af120a7$export$1f1798e92fa75806 = {
    small: $238f781d7af120a7$export$bc90872e265d166e * 40,
    medium: $238f781d7af120a7$export$bc90872e265d166e * 75,
    large: $238f781d7af120a7$export$bc90872e265d166e * 128
};
const $238f781d7af120a7$export$69bde1b03e8b5224 = {
    small: $238f781d7af120a7$export$bc90872e265d166e * 50,
    medium: $238f781d7af120a7$export$1f1798e92fa75806.medium,
    large: $238f781d7af120a7$export$1f1798e92fa75806.large
};
const $238f781d7af120a7$export$780035d9fe48eb32 = `${$238f781d7af120a7$export$bc90872e265d166e * 25}px`;
const $238f781d7af120a7$export$95b62a1773aa5ebe = `${$238f781d7af120a7$export$bc90872e265d166e * 6}px`;
const $238f781d7af120a7$export$387950d54d372827 = '12px';
const $238f781d7af120a7$export$51a2d6b2c009fbfd = '54px';
const $238f781d7af120a7$export$df8bcac60101d466 = '20px';
const $238f781d7af120a7$export$9a6bb2acef5e644a = 15;
const $238f781d7af120a7$export$3b8e93b2c0f295b0 = 2;
const $238f781d7af120a7$export$6d221f35db1b75aa = 60;
const $238f781d7af120a7$export$ab53450bc5fd5b7d = 10;
const $238f781d7af120a7$export$6ee360fa4b93ee8e = 'editor-element-browser';

});

const $0f281244a829b337$export$b16ce0826b76e795 = 'ak-editor-textarea';


parcelRegister("62CL0", function(module, exports) {

$parcel$export(module.exports, "tableFullPageEditorStyles", () => (parcelRequire("2G9Kp")).tableFullPageEditorStyles);
$parcel$export(module.exports, "tableCommentEditorStyles", () => (parcelRequire("2G9Kp")).tableCommentEditorStyles);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $2G9Kp = parcelRequire("2G9Kp");

});
parcelRegister("2G9Kp", function(module, exports) {

$parcel$export(module.exports, "insertColumnButtonOffset", () => $20b4f0d27cf50488$export$af45328890cf2a82);
$parcel$export(module.exports, "tableStyles", () => $20b4f0d27cf50488$export$e938d6f191645a3e);
$parcel$export(module.exports, "tableFullPageEditorStyles", () => $20b4f0d27cf50488$export$b0d19c9126eaec7a);
$parcel$export(module.exports, "tableCommentEditorStyles", () => $20b4f0d27cf50488$export$61a2da566f69d1df);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $7EdFW = parcelRequire("7EdFW");

var $cjLtO = parcelRequire("cjLtO");


var $7yBx7 = parcelRequire("7yBx7");
var $2N2k8 = parcelRequire("2N2k8");
var $egs2l = parcelRequire("egs2l");


var $eGOwo = parcelRequire("eGOwo");


var $92xoS = parcelRequire("92xoS");


var $dzEzE = parcelRequire("dzEzE");

var $fsO0s = parcelRequire("fsO0s");

var $hrsCv = parcelRequire("hrsCv");
const $20b4f0d27cf50488$var$cornerControlHeight = (0, $fsO0s.tableToolbarSize) + 1;
const $20b4f0d27cf50488$export$af45328890cf2a82 = (0, $fsO0s.tableInsertColumnButtonSize) / 2;
const $20b4f0d27cf50488$export$cc4d06b9af7cea87 = 44;
const $20b4f0d27cf50488$var$rangeSelectionStyles = `
.${(0, $dzEzE.TableCssClassName).NODEVIEW_WRAPPER}.${(0, $7yBx7.akEditorSelectedNodeClassName)} table tbody tr {
  th,td {
    ${(0, $2N2k8.getSelectionStyles)([
    (0, $egs2l.SelectionStyle).Blanket,
    (0, $egs2l.SelectionStyle).Border
])}

    // The non-break space /00a0 in :after selector caused a table scroll issue when pressing Cmd+A to select table
    // This line is to override the content of :after selector from the shared getSelectionStyles
    &::after {
      content: '';
    }
  }
}
`;
const $20b4f0d27cf50488$var$sentinelStyles = `.${(0, $dzEzE.TableCssClassName).TABLE_CONTAINER} {
  > .${(0, $dzEzE.TableCssClassName).TABLE_STICKY_SENTINEL_TOP}, > .${(0, $dzEzE.TableCssClassName).TABLE_STICKY_SENTINEL_BOTTOM} {
    position: absolute;
    width: 100%;
    height: 1px;
    margin-top: -1px;
    // need this to avoid sentinel being focused via keyboard
    // this still allows it to be detected by intersection observer
    visibility: hidden;
  }
  > .${(0, $dzEzE.TableCssClassName).TABLE_STICKY_SENTINEL_TOP} {
    top: ${(0, $fsO0s.columnControlsDecorationHeight)}px;
  }
  > .${(0, $dzEzE.TableCssClassName).TABLE_STICKY_SENTINEL_BOTTOM} {
      bottom: ${(0, $fsO0s.tableScrollbarOffset) + (0, $fsO0s.stickyRowOffsetTop) + (0, $fsO0s.tablePadding) * 2 + 23}px;
  }
  &.${(0, $dzEzE.TableCssClassName).WITH_CONTROLS} {
    > .${(0, $dzEzE.TableCssClassName).TABLE_STICKY_SENTINEL_TOP} {
      top: 0px;
    }
    > .${(0, $dzEzE.TableCssClassName).TABLE_STICKY_SENTINEL_BOTTOM} {
      margin-bottom: ${(0, $fsO0s.columnControlsDecorationHeight)}px;
    }
  }
}`;
const $20b4f0d27cf50488$var$stickyScrollbarSentinelStyles = `.${(0, $dzEzE.TableCssClassName).TABLE_CONTAINER} {
 > .${(0, $dzEzE.TableCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM},
 > .${(0, $dzEzE.TableCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP} {
    position: absolute;
    width: 100%;
    height: 1px;
    margin-top: -1px;
    // need this to avoid sentinel being focused via keyboard
    // this still allows it to be detected by intersection observer
    visibility: hidden;
  }
  > .${(0, $dzEzE.TableCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP} {
    top: ${(0, $fsO0s.columnControlsDecorationHeight) + $20b4f0d27cf50488$export$cc4d06b9af7cea87 * 3}px;
  }
  > .${(0, $dzEzE.TableCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM} {
    bottom: ${(0, $7yBx7.MAX_BROWSER_SCROLLBAR_HEIGHT)}px;
  }
}`;
const $20b4f0d27cf50488$var$stickyScrollbarContainerStyles = `.${(0, $dzEzE.TableCssClassName).TABLE_CONTAINER} {
  > .${(0, $dzEzE.TableCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER} {
    width: 100%;
    display: none;
    overflow-x: auto;
    position: sticky;
    bottom: 0;
    z-index: 1;
  }
}`;
const $20b4f0d27cf50488$var$stickyScrollbarStyles = `${$20b4f0d27cf50488$var$stickyScrollbarContainerStyles} ${$20b4f0d27cf50488$var$stickyScrollbarSentinelStyles}`;
const $20b4f0d27cf50488$var$shadowSentinelStyles = `
  .${(0, $dzEzE.TableCssClassName).TABLE_SHADOW_SENTINEL_LEFT},
  .${(0, $dzEzE.TableCssClassName).TABLE_SHADOW_SENTINEL_RIGHT} {
    position: absolute;
    top: 0;
    height: 100%;
    width: 1px;
    visibility: hidden;
  }
  .${(0, $dzEzE.TableCssClassName).TABLE_SHADOW_SENTINEL_LEFT} {
    left: 0;
  }
  .${(0, $dzEzE.TableCssClassName).TABLE_SHADOW_SENTINEL_RIGHT} {
    right: 0;
  }
`;
const $20b4f0d27cf50488$var$breakoutWidthStyling = ()=>{
    return /*#__PURE__*/ (0, $1NIU8.css)(">*:not([data-mark-type='fragment']) .", (0, $dzEzE.TableCssClassName).NODEVIEW_WRAPPER, " .", (0, $dzEzE.TableCssClassName).TABLE_CONTAINER, "{margin-left:unset!important;width:100%!important;}>[data-mark-type='fragment'] * .", (0, $dzEzE.TableCssClassName).NODEVIEW_WRAPPER, " .", (0, $dzEzE.TableCssClassName).TABLE_CONTAINER, "{margin-left:unset!important;width:100%!important;}");
};
const $20b4f0d27cf50488$var$viewModeSortStyles = ()=>{
    return /*#__PURE__*/ (0, $1NIU8.css)("th{.", (0, $70b9d0f0eac405d8$export$b61cb5d3425147f), "{+p{margin-top:0!important;}}>.", (0, $70b9d0f0eac405d8$export$b61cb5d3425147f), "{&:has(.is-active){.", (0, $438179c68884651b$export$bd4f24d8b1e86b23), "{opacity:1;}}}>.", (0, $70b9d0f0eac405d8$export$b61cb5d3425147f), "{.", (0, $438179c68884651b$export$bd4f24d8b1e86b23), "{opacity:0;&:focus{opacity:1;}}}&:hover:not(:has(.", (0, $dzEzE.TableCssClassName).TABLE_CONTAINER, ":hover)){>.", (0, $70b9d0f0eac405d8$export$b61cb5d3425147f), "{.", (0, $438179c68884651b$export$bd4f24d8b1e86b23), "{opacity:1;}}}}");
};
const $20b4f0d27cf50488$var$tableBorderStyles = ()=>{
    return `border-color: ${0, $fsO0s.tableBorderDeleteColor}`;
};
// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
const $20b4f0d27cf50488$var$tableStickyHeaderColumnControlsDecorationsStyle = ()=>{
    return /*#__PURE__*/ (0, $1NIU8.css)(".", (0, $dzEzE.TableCssClassName).TABLE_STICKY, " .", (0, $dzEzE.TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "{z-index:0;left:-1px;}.", (0, $dzEzE.TableCssClassName).TABLE_STICKY, " .", (0, $dzEzE.TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "::after{border-left:1px solid ", (0, $fsO0s.tableBorderColor), ";}.", (0, $dzEzE.TableCssClassName).TABLE_STICKY, " tr:first-of-type th.", (0, $dzEzE.TableCssClassName).TABLE_HEADER_CELL, "{&.", (0, $dzEzE.TableCssClassName).COLUMN_SELECTED, ",&.", (0, $dzEzE.TableCssClassName).HOVERED_COLUMN, "{.", (0, $dzEzE.TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "::after{left:0;}}}");
};
const $20b4f0d27cf50488$var$tableStickyHeaderFirefoxFixStyle = ()=>{
    /*
     This is MAGIC!
     This fixes a bug which occurs in firefox when the first row becomes sticky.
     see https://product-fabric.atlassian.net/browse/ED-19177
   */ if ((0, $7EdFW.browser).gecko) return /*#__PURE__*/ (0, $1NIU8.css)(".", (0, $dzEzE.TableCssClassName).TABLE_STICKY, ">tbody::before{content:'';}");
};
const $20b4f0d27cf50488$export$9989b31b7900261c = (props)=>/*#__PURE__*/ (0, $1NIU8.css)((0, $cjLtO.tableSharedStyle)(), ";", (0, $hrsCv.columnControlsLineMarker)(), ";", (0, $hrsCv.hoveredDeleteButton)(), ";", (0, $hrsCv.hoveredCell)(), ";", (0, $hrsCv.hoveredWarningCell), ";", (0, $hrsCv.insertLine)(), ";", (0, $hrsCv.resizeHandle)(), ";", $20b4f0d27cf50488$var$rangeSelectionStyles, ";", $20b4f0d27cf50488$var$viewModeSortStyles(), ";.", (0, $dzEzE.TableCssClassName).LAST_ITEM_IN_CELL, "{margin-bottom:0;}.", (0, $dzEzE.TableCssClassName).TABLE_NODE_WRAPPER, "{td.", (0, $dzEzE.TableCssClassName).TABLE_CELL, ",th.", (0, $dzEzE.TableCssClassName).TABLE_HEADER_CELL, "{position:relative;overflow:visible;}td.", (0, $dzEzE.TableCssClassName).TABLE_CELL, "{background-color:", (0, $fsO0s.tableCellBackgroundColor), ";&::after{height:100%;content:'';border-left:1px solid ", (0, $fsO0s.tableBorderColor), ";border-bottom:1px solid ", (0, $fsO0s.tableBorderColor), ";position:absolute;right:0px;top:0px;bottom:0;width:100%;display:inline-block;pointer-events:none;}}}.", (0, $dzEzE.TableCssClassName).CONTROLS_FLOATING_BUTTON_COLUMN, "{", (0, $hrsCv.insertColumnButtonWrapper)(), ";}.", (0, $dzEzE.TableCssClassName).CONTROLS_FLOATING_BUTTON_ROW, "{", (0, $hrsCv.insertRowButtonWrapper)(), ";}", (0, $hrsCv.dragInsertButtonWrapper)(), " ", (0, $hrsCv.dragCornerControlButton)(), (0, $hrsCv.DeleteButton)(), (0, $eGOwo.fg)('platform_editor_nested_tables_sticky_header_bug') ? `
		${(0, $eGOwo.fg)('platform_editor_number_column_sticky_header_broken') ? `.${(0, $dzEzE.TableCssClassName).TABLE_STICKY} > .${props.isDragAndDropEnabled ? (0, $dzEzE.TableCssClassName).DRAG_ROW_CONTROLS_WRAPPER : (0, $dzEzE.TableCssClassName).ROW_CONTROLS_WRAPPER} .${(0, $dzEzE.TableCssClassName).NUMBERED_COLUMN} .${(0, $dzEzE.TableCssClassName).NUMBERED_COLUMN_BUTTON}:first-of-type {` : `.${(0, $dzEzE.TableCssClassName).TABLE_STICKY} > .${(0, $dzEzE.TableCssClassName).DRAG_ROW_CONTROLS_WRAPPER} .${(0, $dzEzE.TableCssClassName).NUMBERED_COLUMN} .${(0, $dzEzE.TableCssClassName).NUMBERED_COLUMN_BUTTON}:first-of-type {`}
			margin-top: ${(0, $eGOwo.fg)('platform_editor_number_column_sticky_header_bug') ? (0, $fsO0s.stickyRowOffsetTop) : (0, $fsO0s.stickyRowOffsetTop) + 2}px;
			width: ${0, $7yBx7.akEditorTableNumberColumnWidth}px;

			position: fixed !important;
			z-index: ${0, $7yBx7.akEditorStickyHeaderZIndex} !important;
			box-shadow: 0px -${0, $fsO0s.stickyRowOffsetTop}px ${"var(--ds-surface, white)"};
			border-right: 0 none;
			/* top set by NumberColumn component */
		}
		` : `
    	.${(0, $dzEzE.TableCssClassName).TABLE_STICKY} .${(0, $dzEzE.TableCssClassName).NUMBERED_COLUMN} .${(0, $dzEzE.TableCssClassName).NUMBERED_COLUMN_BUTTON}:first-of-type {
			margin-top: ${(0, $eGOwo.fg)('platform_editor_number_column_sticky_header_bug') ? (0, $fsO0s.stickyRowOffsetTop) : (0, $fsO0s.stickyRowOffsetTop) + 2}px;
			width: ${0, $7yBx7.akEditorTableNumberColumnWidth}px;

			position: fixed !important;
			z-index: ${0, $7yBx7.akEditorStickyHeaderZIndex} !important;
			box-shadow: 0px -${0, $fsO0s.stickyRowOffsetTop}px ${"var(--ds-surface, white)"};
			border-right: 0 none;
			/* top set by NumberColumn component */
		}
		`, " .", (0, $dzEzE.TableCssClassName).TABLE_STICKY, " .", (0, $dzEzE.TableCssClassName).CORNER_CONTROLS, ".sticky{position:fixed!important;z-index:", (0, $7yBx7.akEditorSmallZIndex), "!important;background:var(--ds-surface, white);width:", (0, $fsO0s.tableToolbarSize), "px;height:", (0, $fsO0s.tableToolbarSize), "px;}.", (0, $dzEzE.TableCssClassName).CORNER_CONTROLS, ".sticky .", (0, $dzEzE.TableCssClassName).CONTROLS_CORNER_BUTTON, "{border-bottom:0px none;border-right:0px none;height:", (0, $fsO0s.tableToolbarSize), "px;width:", (0, $fsO0s.tableToolbarSize), "px;}", $20b4f0d27cf50488$var$tableStickyHeaderColumnControlsDecorationsStyle(), " ", $20b4f0d27cf50488$var$tableStickyHeaderFirefoxFixStyle(), " .", (0, $dzEzE.TableCssClassName).TABLE_STICKY, " .", (0, $dzEzE.TableCssClassName).ROW_CONTROLS, " .", (0, $dzEzE.TableCssClassName).ROW_CONTROLS_BUTTON_WRAP, ".sticky{position:fixed!important;z-index:", (0, $7yBx7.akEditorStickyHeaderZIndex), "!important;display:flex;border-left:", (0, $fsO0s.tableToolbarSize), "px solid var(--ds-surface, white);margin-left:-", (0, $fsO0s.tableToolbarSize), "px;}.", (0, $dzEzE.TableCssClassName).TABLE_STICKY, " col:first-of-type{border-right:1px solid var(--ds-surface, green);}tr.sticky{padding-top:", (0, $fsO0s.stickyRowOffsetTop), "px;position:fixed;display:grid;z-index:", (0, $7yBx7.akEditorTableCellOnStickyHeaderZIndex) - 5, ";overflow-y:visible;overflow-x:hidden;grid-auto-flow:column;background:var(--ds-surface, white);box-sizing:content-box;box-shadow:0 6px 4px -4px ", `var(--ds-shadow-overflow-perimeter, ${(0, $7bb4c1736002a04a$export$46987b49aab6d1a8)})`, ";margin-left:-1px;&.no-pointer-events{pointer-events:none;}}.", (0, $dzEzE.TableCssClassName).TABLE_STICKY, " .", (0, $dzEzE.TableCssClassName).TABLE_STICKY_SHADOW, "{left:unset;position:fixed;z-index:", (0, $7yBx7.akEditorTableCellOnStickyHeaderZIndex), ";}.", (0, $dzEzE.TableCssClassName).WITH_CONTROLS, ".", (0, $dzEzE.TableCssClassName).TABLE_STICKY, " .", (0, $dzEzE.TableCssClassName).TABLE_STICKY_SHADOW, "{padding-bottom:", (0, $fsO0s.tableToolbarSize), "px;}.tableView-content-wrap:has(.tableView-content-wrap):has(\n\t\t\t.", (0, $dzEzE.TableCssClassName).NESTED_TABLE_WITH_CONTROLS, "\n\t\t){padding-left:unset;}.tableView-content-wrap:has(.", (0, $dzEzE.TableCssClassName).NESTED_TABLE_WITH_CONTROLS, "){padding-left:15px;}tr.sticky th{border-bottom:", (0, $fsO0s.stickyHeaderBorderBottomWidth), "px solid ", (0, $fsO0s.tableBorderColor), ";margin-right:-1px;}.", (0, $dzEzE.TableCssClassName).TABLE_STICKY, " tr.sticky>th:last-child{border-right-width:1px;}.", (0, $dzEzE.TableCssClassName).TABLE_STICKY, " tr.sticky>th:first-of-type{margin-left:0px;}.", (0, $dzEzE.TableCssClassName).TABLE_STICKY, " tr.sticky::after{content:' ';width:", $20b4f0d27cf50488$export$af45328890cf2a82 + 1, "px;}.", (0, $dzEzE.TableCssClassName).TABLE_STICKY, " .sticky+tr{min-height:0px;}.", (0, $dzEzE.TableCssClassName).TABLE_CONTAINER, ".", (0, $dzEzE.TableCssClassName).TABLE_STICKY, "{tr.sticky td.", (0, $dzEzE.TableCssClassName).WITH_RESIZE_LINE, ",tr.sticky th.", (0, $dzEzE.TableCssClassName).WITH_RESIZE_LINE, "{.", (0, $dzEzE.TableCssClassName).RESIZE_HANDLE_DECORATION, "::after{right:", ((0, $fsO0s.resizeHandlerAreaWidth) - (0, $fsO0s.resizeLineWidth)) / 2 + 1, "px;}}tr.sticky td.", (0, $dzEzE.TableCssClassName).WITH_RESIZE_LINE, ".", (0, $dzEzE.TableCssClassName).SELECTED_CELL, ",tr.sticky th.", (0, $dzEzE.TableCssClassName).WITH_RESIZE_LINE, ".", (0, $dzEzE.TableCssClassName).SELECTED_CELL, "{.", (0, $dzEzE.TableCssClassName).RESIZE_HANDLE_DECORATION, "::after{right:", ((0, $fsO0s.resizeHandlerAreaWidth) - (0, $fsO0s.resizeLineWidth)) / 2, "px;}}}tr.sticky .", (0, $dzEzE.TableCssClassName).HOVERED_CELL, ",tr.sticky .", (0, $dzEzE.TableCssClassName).SELECTED_CELL, "{z-index:1;}.", (0, $dzEzE.TableCssClassName).WITH_CONTROLS, " tr.sticky{padding-top:", (0, $fsO0s.tableControlsSpacing), "px;}", (0, $eGOwo.fg)('platform_editor_nested_tables_sticky_header_bug') ? `
		.${(0, $dzEzE.TableCssClassName).WITH_CONTROLS}.${(0, $dzEzE.TableCssClassName).TABLE_STICKY} > .${(0, $dzEzE.TableCssClassName).DRAG_ROW_CONTROLS_WRAPPER}
			.${(0, $dzEzE.TableCssClassName).NUMBERED_COLUMN}
			.${(0, $dzEzE.TableCssClassName).NUMBERED_COLUMN_BUTTON}:first-of-type {
			margin-top: ${(0, $eGOwo.fg)('platform_editor_number_column_sticky_header_bug') ? (0, $fsO0s.tableControlsSpacing) : (0, $fsO0s.tableControlsSpacing) + 2}px;
		}
		` : `
		.${(0, $dzEzE.TableCssClassName).WITH_CONTROLS}.${(0, $dzEzE.TableCssClassName).TABLE_STICKY}
			.${(0, $dzEzE.TableCssClassName).NUMBERED_COLUMN}
			.${(0, $dzEzE.TableCssClassName).NUMBERED_COLUMN_BUTTON}:first-of-type {
			margin-top: ${(0, $eGOwo.fg)('platform_editor_number_column_sticky_header_bug') ? (0, $fsO0s.tableControlsSpacing) : (0, $fsO0s.tableControlsSpacing) + 2}px;
		}
		`, " .", (0, $dzEzE.TableCssClassName).CORNER_CONTROLS, ".sticky{border-top:", (0, $eGOwo.fg)('platform_editor_number_column_sticky_header_bug') ? (0, $fsO0s.tableControlsSpacing) - (0, $fsO0s.tableToolbarSize) : (0, $fsO0s.tableControlsSpacing) - (0, $fsO0s.tableToolbarSize) + 2, "px solid var(--ds-surface, white);}", $20b4f0d27cf50488$var$sentinelStyles, " ", (0, $hrsCv.OverflowShadow)(props.featureFlags?.tableDragAndDrop), " ", $20b4f0d27cf50488$var$stickyScrollbarStyles, " .", (0, $dzEzE.TableCssClassName).TABLE_STICKY, " .", (0, $dzEzE.TableCssClassName).TABLE_STICKY_SHADOW, "{height:0;}.less-padding{padding:0 ", (0, $fsO0s.tablePadding), "px;.", (0, $dzEzE.TableCssClassName).DRAG_ROW_CONTROLS_WRAPPER, ",.", (0, $dzEzE.TableCssClassName).ROW_CONTROLS_WRAPPER, "{padding:0 ", (0, $fsO0s.tablePadding), "px;&::after{right:6px!important;}}.", (0, $dzEzE.TableCssClassName).DRAG_ROW_CONTROLS_WRAPPER, ".", (0, $dzEzE.TableCssClassName).TABLE_CHROMELESS, "{left:-4px;}.", (0, $dzEzE.TableCssClassName).DRAG_COLUMN_CONTROLS_WRAPPER, "{padding:0 ", (0, $fsO0s.tablePadding), "px;}.", (0, $dzEzE.TableCssClassName).DRAG_COLUMN_CONTROLS_WRAPPER, ".", (0, $dzEzE.TableCssClassName).TABLE_CHROMELESS, "{left:-8px;}&.", (0, $dzEzE.TableCssClassName).TABLE_CONTAINER, "[data-number-column='true']{padding-left:", (0, $7yBx7.akEditorTableNumberColumnWidth) + (0, $fsO0s.tablePadding) - 1, "px;}.", (0, $dzEzE.TableCssClassName).TABLE_LEFT_SHADOW, ",.", (0, $dzEzE.TableCssClassName).TABLE_RIGHT_SHADOW, "{width:", (0, $fsO0s.tableOverflowShadowWidth), "px;}.", (0, $dzEzE.TableCssClassName).TABLE_LEFT_SHADOW, "{left:6px;}.", (0, $dzEzE.TableCssClassName).TABLE_LEFT_SHADOW, ".", (0, $dzEzE.TableCssClassName).TABLE_CHROMELESS, "{left:8px;}.", (0, $dzEzE.TableCssClassName).TABLE_RIGHT_SHADOW, "{left:calc(100% - 6px);}.", (0, $dzEzE.TableCssClassName).TABLE_RIGHT_SHADOW, ".", (0, $dzEzE.TableCssClassName).TABLE_CHROMELESS, "{left:calc(100% - 16px);}}>.", (0, $dzEzE.TableCssClassName).NODEVIEW_WRAPPER, "{/**\n       * Prevent margins collapsing, aids with placing the gap-cursor correctly\n       * @see https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Box_Model/Mastering_margin_collapsing\n       *\n       * TODO: Enable this, many tests will fail!\n       * border-top: 1px solid transparent;\n       */}", $20b4f0d27cf50488$var$breakoutWidthStyling(), " ", (0, $hrsCv.columnControlsDecoration)(), ";", (0, $hrsCv.rowControlsWrapperDotStyle)(), ";.", (0, $dzEzE.TableCssClassName).CORNER_CONTROLS, "{width:", (0, $fsO0s.tableToolbarSize) + 1, "px;height:", $20b4f0d27cf50488$var$cornerControlHeight, "px;display:none;.", (0, $dzEzE.TableCssClassName).CORNER_CONTROLS_INSERT_ROW_MARKER, "{position:relative;", (0, $hrsCv.InsertMarker)(`
          left: -11px;
          top: 9px;
        `), ";}}.", (0, $dzEzE.TableCssClassName).CORNER_CONTROLS, ".sticky{.", (0, $dzEzE.TableCssClassName).CORNER_CONTROLS_INSERT_ROW_MARKER, "{display:none!important;}}.", (0, $dzEzE.TableCssClassName).CONTROLS_CORNER_BUTTON, "{position:absolute;top:0;width:", (0, $fsO0s.tableToolbarSize) + 1, "px;height:", (0, $fsO0s.tableToolbarSize) + 1, "px;border:1px solid ", (0, $fsO0s.tableBorderColor), ";border-radius:0;border-top-left-radius:", (0, $fsO0s.tableBorderRadiusSize), "px;background:", (0, $fsO0s.tableHeaderCellBackgroundColor), ";box-sizing:border-box;padding:0;:focus{outline:none;}}.active .", (0, $dzEzE.TableCssClassName).CONTROLS_CORNER_BUTTON, "{border-color:", (0, $fsO0s.tableBorderSelectedColor), ";background:", (0, $fsO0s.tableToolbarSelectedColor), ";}.", (0, $dzEzE.TableCssClassName).TABLE_CONTAINER, "[data-number-column='true']{.", (0, $dzEzE.TableCssClassName).CORNER_CONTROLS, ",.", (0, $dzEzE.TableCssClassName).CONTROLS_CORNER_BUTTON, "{width:", (0, $7yBx7.akEditorTableToolbarSize) + (0, $7yBx7.akEditorTableNumberColumnWidth) + 1, "px;}.", (0, $dzEzE.TableCssClassName).ROW_CONTROLS, " .", (0, $dzEzE.TableCssClassName).CONTROLS_BUTTON, "{border-right-width:0;}}:not(.", (0, $dzEzE.TableCssClassName).IS_RESIZING, ") .", (0, $dzEzE.TableCssClassName).CONTROLS_CORNER_BUTTON, ":hover{border-color:", (0, $fsO0s.tableBorderSelectedColor), ";background:", (0, $fsO0s.tableToolbarSelectedColor), ";cursor:pointer;}:not(.", (0, $dzEzE.TableCssClassName).IS_RESIZING, ") .", (0, $dzEzE.TableCssClassName).CONTROLS_CORNER_BUTTON, ".", (0, $dzEzE.TableCssClassName).HOVERED_CELL_IN_DANGER, "{border-color:", (0, $fsO0s.tableBorderDeleteColor), ";background:", (0, $fsO0s.tableToolbarDeleteColor), ";}.", (0, $dzEzE.TableCssClassName).ROW_CONTROLS, "{width:", (0, $fsO0s.tableToolbarSize), "px;box-sizing:border-box;display:none;position:relative;", (0, $hrsCv.InsertMarker)(`
        bottom: -1px;
        left: -11px;
      `), ";", (0, $hrsCv.HeaderButton)(`
        border-bottom: 1px solid ${(0, $fsO0s.tableBorderColor)};
        border-right: 0px;
        border-radius: 0;
        height: 100%;
        width: ${(0, $fsO0s.tableToolbarSize)}px;

        .${(0, $dzEzE.TableCssClassName).CONTROLS_BUTTON_OVERLAY} {
          position: absolute;
          width: 30px;
          height: 50%;
          right: 0;
          bottom: 0;
        }
        .${(0, $dzEzE.TableCssClassName).CONTROLS_BUTTON_OVERLAY}:first-of-type {
          top: 0;
        }
      `), ";.", (0, $dzEzE.TableCssClassName).ROW_CONTROLS_INNER, "{display:flex;flex-direction:column;}.", (0, $dzEzE.TableCssClassName).ROW_CONTROLS_BUTTON_WRAP, ":last-child>button{border-bottom-left-radius:", (0, $fsO0s.tableBorderRadiusSize), "px;}.", (0, $dzEzE.TableCssClassName).ROW_CONTROLS_BUTTON_WRAP, "{position:relative;margin-top:-1px;}.", (0, $dzEzE.TableCssClassName).ROW_CONTROLS_BUTTON_WRAP, ":hover,.", (0, $dzEzE.TableCssClassName).ROW_CONTROLS_BUTTON_WRAP, ".active,.", (0, $dzEzE.TableCssClassName).CONTROLS_BUTTON, ":hover{z-index:", (0, $7yBx7.akEditorUnitZIndex), ";}}.", (0, $dzEzE.TableCssClassName).DRAG_ROW_CONTROLS, "{display:grid;align-items:center;position:absolute;z-index:", (0, $eGOwo.fg)('platform_editor_table_column_selected_state_fix') ? (0, $fsO0s.rowControlsZIndex) + 4 : (0, $7yBx7.akEditorUnitZIndex), ";.", (0, $dzEzE.TableCssClassName).DRAG_ROW_FLOATING_INSERT_DOT_WRAPPER, "{position:absolute;align-self:end;height:100%;width:18px;}.", (0, $dzEzE.TableCssClassName).DRAG_ROW_FLOATING_INSERT_DOT, "{position:absolute;bottom:-3px;left:2px;background-color:var(--ds-background-accent-gray-subtler, #C1C7D0);height:4px;width:4px;border-radius:50%;pointer-events:none;}}.", (0, $dzEzE.TableCssClassName).DRAG_COLUMN_CONTROLS, "{.", (0, $dzEzE.TableCssClassName).DRAG_COLUMN_CONTROLS_INNER, "{height:24px;position:absolute;top:var(--ds-space-negative-150, -12px);z-index:", (0, $fsO0s.resizeHandlerZIndex), ";}.", (0, $dzEzE.TableCssClassName).DRAG_COLUMN_FLOATING_INSERT_DOT_WRAPPER, "{position:absolute;height:24px;width:100%;}.", (0, $dzEzE.TableCssClassName).DRAG_COLUMN_FLOATING_INSERT_DOT, "{background-color:var(--ds-background-accent-gray-subtler, #C1C7D0);height:4px;width:4px;border-radius:50%;position:absolute;right:-2px;}}.", (0, $dzEzE.TableCssClassName).DRAG_HANDLE_BUTTON_CLICKABLE_ZONE, "{background:none;border:none;outline:none;position:absolute;margin:0;padding:0;display:flex;align-items:center;cursor:pointer;:focus{outline:none;}}.", (0, $dzEzE.TableCssClassName).DRAG_HANDLE_BUTTON_CONTAINER, "{cursor:grab;pointer-events:auto;line-height:0;padding:0;border-radius:6px;width:max-content;border:2px solid ", `var(--ds-surface, ${(0, $7bb4c1736002a04a$export$29a4f05edc054374)})`, ";display:flex;justify-content:center;align-items:center;background:transparent;outline:none;&.placeholder{background-color:transparent;border:2px solid transparent;}&.", (0, $dzEzE.TableCssClassName).DRAG_HANDLE_DISABLED, "{cursor:pointer;& svg{&>rect.", (0, $dzEzE.TableCssClassName).DRAG_HANDLE_MINIMISED, "{fill:var(--ds-background-accent-gray-subtler, #DCDFE4);}&>rect{fill:var(--ds-background-accent-gray-subtlest, #F4F5F7);}&>g>rect{fill:var(--ds-icon-disabled, #BFDBF847);}}}&:not(.", (0, $dzEzE.TableCssClassName).DRAG_HANDLE_DISABLED, "){& svg{rect{fill:var(--ds-background-accent-gray-subtler, #DCDFE4);}g{fill:var(--ds-icon-subtle, #626f86);}}&:hover{svg{rect{fill:var(--ds-background-accent-blue-subtle, #579DFF);}g{fill:var(--ds-icon-inverse, #FFF);}}}&:active{cursor:grabbing;}&.selected{:focus{outline:2px solid var(--ds-border-focused, #2684FF);outline-offset:1px;}&:active{outline:none;}svg{rect{fill:var(--ds-background-accent-blue-subtle, #579dff);}g{fill:var(--ds-icon-inverse, #fff);}}}&.danger{svg{rect{fill:var(--ds-background-accent-red-subtler-pressed, #F87462);}g{fill:var(--ds-border-inverse, #FFF);}}}}}", (0, $hrsCv.floatingColumnControls)(), " :not(.", (0, $dzEzE.TableCssClassName).IS_RESIZING, ") .", (0, $dzEzE.TableCssClassName).ROW_CONTROLS, "{", (0, $hrsCv.HeaderButtonHover)(), " ", (0, $hrsCv.HeaderButtonDanger)(), ";}.", (0, $dzEzE.TableCssClassName).NUMBERED_COLUMN, "{position:relative;float:right;margin-left:", (0, $7yBx7.akEditorTableToolbarSize), "px;top:", ((0, $eGOwo.fg)('platform_editor_number_column_sticky_header_broken') ? props.isDragAndDropEnabled : props.featureFlags?.tableDragAndDrop) || (0, $92xoS.editorExperiment)('support_table_in_comment_jira', true) ? 0 : (0, $7yBx7.akEditorTableToolbarSize), "px;width:", (0, $7yBx7.akEditorTableNumberColumnWidth) + 1, "px;box-sizing:border-box;}.", (0, $dzEzE.TableCssClassName).NUMBERED_COLUMN_BUTTON, "{border:1px solid ", (0, $fsO0s.tableBorderColor), ";box-sizing:border-box;margin-top:-1px;padding-bottom:2px;padding:10px 2px;text-align:center;font-size:", (0, $7yBx7.relativeFontSizeToBase16)(14), ";background-color:", (0, $fsO0s.tableHeaderCellBackgroundColor), ";color:", (0, $fsO0s.tableTextColor), ";border-color:", (0, $fsO0s.tableBorderColor), ";:first-child:not(style),style:first-child+*{margin-top:0;}:last-child{border-bottom:1px solid ", (0, $fsO0s.tableBorderColor), ";}}", (0, $eGOwo.fg)('platform_editor_nested_tables_sticky_header_bug') ? `
		${(0, $eGOwo.fg)('platform_editor_number_column_sticky_header_broken') ? `.${(0, $dzEzE.TableCssClassName).TABLE_STICKY} > .${props.isDragAndDropEnabled ? (0, $dzEzE.TableCssClassName).DRAG_ROW_CONTROLS_WRAPPER : (0, $dzEzE.TableCssClassName).ROW_CONTROLS_WRAPPER} {
				.${(0, $dzEzE.TableCssClassName).NUMBERED_COLUMN_BUTTON_DISABLED}:first-of-type::after {` : `.${(0, $dzEzE.TableCssClassName).TABLE_STICKY} > .${(0, $dzEzE.TableCssClassName).DRAG_ROW_CONTROLS_WRAPPER} {
				.${(0, $dzEzE.TableCssClassName).NUMBERED_COLUMN_BUTTON_DISABLED}:first-of-type::after {`}
				content: '';
				display: block;
				height: 33px;
				width: 100%;
				background-color: ${"var(--ds-surface, white)"};
				position: absolute;

				/* the extra pixel is accounting for borders */
				top: -34px;
				left: -1px;
			}
		}
		` : `
		.${(0, $dzEzE.TableCssClassName).TABLE_STICKY} {
			.${(0, $dzEzE.TableCssClassName).NUMBERED_COLUMN_BUTTON_DISABLED}:first-of-type::after {
				content: '';
				display: block;
				height: 33px;
				width: 100%;
				background-color: ${"var(--ds-surface, white)"};
				position: absolute;

				/* the extra pixel is accounting for borders */
				top: -34px;
				left: -1px;
			}
		}
		`, " .", (0, $dzEzE.TableCssClassName).WITH_CONTROLS, "{.", (0, $dzEzE.TableCssClassName).CORNER_CONTROLS, ",.", (0, $dzEzE.TableCssClassName).ROW_CONTROLS, "{display:block;}.", (0, $dzEzE.TableCssClassName).NUMBERED_COLUMN, "{padding-left:0px;.", (0, $dzEzE.TableCssClassName).NUMBERED_COLUMN_BUTTON, "{border-left:0 none;}.", (0, $dzEzE.TableCssClassName).NUMBERED_COLUMN_BUTTON, ".active{border-bottom:1px solid ", (0, $fsO0s.tableBorderSelectedColor), ";border-color:", (0, $fsO0s.tableBorderSelectedColor), ";background-color:", (0, $fsO0s.tableToolbarSelectedColor), ";position:relative;z-index:", (0, $7yBx7.akEditorUnitZIndex), ";color:", `var(--ds-text-selected, ${(0, $7bb4c1736002a04a$export$29a4f05edc054374)})`, ";}}.", (0, $dzEzE.TableCssClassName).TABLE_CONTAINER, "{.", (0, $dzEzE.TableCssClassName).NUMBERED_COLUMN_BUTTON, "{border-left:1px solid ", (0, $fsO0s.tableBorderColor), ";}}}:not(.", (0, $dzEzE.TableCssClassName).IS_RESIZING, ") .", (0, $dzEzE.TableCssClassName).WITH_CONTROLS, "{.", (0, $dzEzE.TableCssClassName).NUMBERED_COLUMN_BUTTON, ":not(.", (0, $dzEzE.TableCssClassName).NUMBERED_COLUMN_BUTTON_DISABLED, "){cursor:pointer;}.", (0, $dzEzE.TableCssClassName).NUMBERED_COLUMN_BUTTON, ":not(.", (0, $dzEzE.TableCssClassName).NUMBERED_COLUMN_BUTTON_DISABLED, "):hover{border-bottom:1px solid ", (0, $fsO0s.tableBorderSelectedColor), ";border-color:", (0, $fsO0s.tableBorderSelectedColor), ";background-color:", (0, $fsO0s.tableToolbarSelectedColor), ";position:relative;z-index:", (0, $7yBx7.akEditorUnitZIndex), ";color:", `var(--ds-text-selected, ${(0, $7bb4c1736002a04a$export$29a4f05edc054374)})`, ";}.", (0, $dzEzE.TableCssClassName).NUMBERED_COLUMN_BUTTON, ".", (0, $dzEzE.TableCssClassName).HOVERED_CELL_IN_DANGER, "{background-color:", (0, $fsO0s.tableToolbarDeleteColor), ";border:1px solid ", (0, $fsO0s.tableBorderDeleteColor), ";border-left:0;color:", `var(--ds-text-danger, ${(0, $7bb4c1736002a04a$export$2837b5a1a71d5c02)})`, ";position:relative;z-index:", (0, $7yBx7.akEditorUnitZIndex), ";}}.", (0, $dzEzE.TableCssClassName).TABLE_NODE_WRAPPER, ">table{table-layout:fixed;white-space:normal;border-top:none;margin-right:-1px;position:relative;>tbody>tr{white-space:pre-wrap;}.", (0, $dzEzE.TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "+*{margin-top:0;}th.", (0, $dzEzE.TableCssClassName).TABLE_HEADER_CELL, ">.fabric-editor-block-mark{>h1:first-of-type,>h2:first-of-type,>h3:first-of-type,>h4:first-of-type,>h5:first-of-type,>h6:first-of-type{margin-top:0;}}.", (0, $dzEzE.TableCssClassName).SELECTED_CELL, ",.", (0, $dzEzE.TableCssClassName).HOVERED_CELL_IN_DANGER, "{position:relative;}.", (0, $dzEzE.TableCssClassName).SELECTED_CELL, "::after,.", (0, $dzEzE.TableCssClassName).HOVERED_CELL_IN_DANGER, "::after{z-index:", (0, $7yBx7.akEditorSmallZIndex), ";position:absolute;content:'';left:0;right:0;top:0;bottom:0;width:100%;pointer-events:none;}.", (0, $dzEzE.TableCssClassName).SELECTED_CELL, "{border:1px solid ", (0, $fsO0s.tableBorderSelectedColor), ";}.", (0, $dzEzE.TableCssClassName).SELECTED_CELL, "::after{background:", (0, $fsO0s.tableCellSelectedColor), ";z-index:", (0, $7yBx7.akEditorSmallZIndex), ";}th.", (0, $dzEzE.TableCssClassName).HOVERED_CELL_IN_DANGER, "::after,td.", (0, $dzEzE.TableCssClassName).HOVERED_CELL_IN_DANGER, "::after{background:", (0, $fsO0s.tableCellDeleteColor), ";z-index:", (0, $7yBx7.akEditorUnitZIndex) * 100, ";}td.", (0, $dzEzE.TableCssClassName).HOVERED_CELL, ",td.", (0, $dzEzE.TableCssClassName).SELECTED_CELL, ",th.", (0, $dzEzE.TableCssClassName).TABLE_HEADER_CELL, ".", (0, $dzEzE.TableCssClassName).SELECTED_CELL, ",th.", (0, $dzEzE.TableCssClassName).TABLE_HEADER_CELL, ".", (0, $dzEzE.TableCssClassName).HOVERED_CELL, "{&::after{height:100%;width:100%;border:1px solid ", (0, $fsO0s.tableBorderSelectedColor), ";content:'';position:absolute;left:-1px;top:-1px;bottom:0;z-index:", (0, $7yBx7.akEditorSmallZIndex), ";display:inline-block;pointer-events:none;}&.", (0, $dzEzE.TableCssClassName).HOVERED_CELL_IN_DANGER, "::after{", $20b4f0d27cf50488$var$tableBorderStyles(), ";z-index:", (0, $7yBx7.akEditorUnitZIndex) * 100, ";}&.", (0, $dzEzE.TableCssClassName).HOVERED_NO_HIGHLIGHT, ".", (0, $dzEzE.TableCssClassName).HOVERED_CELL_IN_DANGER, "::after{", $20b4f0d27cf50488$var$tableBorderStyles(), ";z-index:", (0, $7yBx7.akEditorUnitZIndex) * 100, ";}}}.", (0, $dzEzE.TableCssClassName).DRAG_ROW_CONTROLS_WRAPPER, "{position:absolute;margin-top:", (0, $cjLtO.tableMarginTop), "px;left:-", (0, $fsO0s.tableToolbarSize) + 1, "px;", (0, $eGOwo.fg)('platform_editor_table_column_selected_state_fix') ? '' : `z-index: ${(0, $fsO0s.rowControlsZIndex) + 4}`, ";}.", (0, $dzEzE.TableCssClassName).ROW_CONTROLS_WRAPPER, "{position:absolute;", props.isDragAndDropEnabled && (0, $eGOwo.fg)('platform_editor_numbered_column_misalignment') ? `
			margin-top: ${0, $cjLtO.tableMarginTop}px;
			top: 0;
			left: -${(0, $fsO0s.tableToolbarSize) + 1}px;
		` : `
			/* top of corner control is table margin top - corner control height + 1 pixel of table border. */
			top: ${(0, $cjLtO.tableMarginTop) - $20b4f0d27cf50488$var$cornerControlHeight + 1}px;
			margin-top: 0;
			left: -${0, $fsO0s.tableToolbarSize}px;
		`, ";}.", (0, $dzEzE.TableCssClassName).DRAG_ROW_CONTROLS_WRAPPER, ".", (0, $dzEzE.TableCssClassName).TABLE_LEFT_SHADOW, ",.", (0, $dzEzE.TableCssClassName).ROW_CONTROLS_WRAPPER, ".", (0, $dzEzE.TableCssClassName).TABLE_LEFT_SHADOW, "{z-index:", (0, $7yBx7.akEditorUnitZIndex), ";}.", (0, $dzEzE.TableCssClassName).DRAG_COLUMN_CONTROLS_WRAPPER, "{position:absolute;top:", (0, $cjLtO.tableMarginTop), "px;}.", (0, $dzEzE.TableCssClassName).TABLE_STICKY, " .", (0, $dzEzE.TableCssClassName).DRAG_COLUMN_CONTROLS_WRAPPER, "{position:fixed;z-index:", (0, $7yBx7.akEditorTableCellOnStickyHeaderZIndex) - 4, ";}", (0, $eGOwo.fg)('platform_editor_nested_table_drag_controls') ? `
		.${(0, $dzEzE.TableCssClassName).TABLE_CONTAINER} {
			.${(0, $dzEzE.TableCssClassName).TABLE_STICKY} .${(0, $dzEzE.TableCssClassName).DRAG_COLUMN_CONTROLS_WRAPPER} {
				position: absolute;
				z-index: ${0, $7yBx7.akEditorUnitZIndex};
			}
		}
		` : '', " .", (0, $dzEzE.TableCssClassName).TABLE_NODE_WRAPPER, "{padding-bottom:0px;overflow:auto;overflow-y:hidden;position:relative;}");
const $20b4f0d27cf50488$export$e938d6f191645a3e = (props)=>/*#__PURE__*/ (0, $1NIU8.css)(".ProseMirror{", $20b4f0d27cf50488$export$9989b31b7900261c(props), ";}.ProseMirror.", (0, $dzEzE.TableCssClassName).IS_RESIZING, "{.", (0, $dzEzE.TableCssClassName).TABLE_NODE_WRAPPER, "{overflow-x:auto;", (0, $e23eba3bf6a7aed3$export$b2380b18b089518f), ";}}.ProseMirror.", (0, $dzEzE.TableCssClassName).RESIZE_CURSOR, "{cursor:col-resize;}", $20b4f0d27cf50488$var$shadowSentinelStyles, ";");
const $20b4f0d27cf50488$export$b0d19c9126eaec7a = /*#__PURE__*/ (0, $1NIU8.css)(".ProseMirror .", (0, $dzEzE.TableCssClassName).TABLE_NODE_WRAPPER, ">table{margin-left:0;margin-right:-1px;width:100%;}");
const $20b4f0d27cf50488$export$61a2da566f69d1df = /*#__PURE__*/ (0, $1NIU8.css)(".ProseMirror .", (0, $dzEzE.TableCssClassName).TABLE_NODE_WRAPPER, ">table{margin-left:0;margin-right:0;", (0, $e23eba3bf6a7aed3$export$b2380b18b089518f), ";}");

});
const $70b9d0f0eac405d8$export$b61cb5d3425147f = 'view-mode-sorting-icon';
const $70b9d0f0eac405d8$export$fb5c0ba8f0806db1 = 'is-disabled';
const $70b9d0f0eac405d8$export$665a01df2c44393a = 'data-sort-index';

parcelRegister("hrsCv", function(module, exports) {

$parcel$export(module.exports, "InsertMarker", () => $378af66192388ab5$export$22ce45ffbca2b768);
$parcel$export(module.exports, "HeaderButton", () => $378af66192388ab5$export$c7c73467b57835d);
$parcel$export(module.exports, "HeaderButtonHover", () => $378af66192388ab5$export$eb5435fbd56e8d4);
$parcel$export(module.exports, "HeaderButtonDanger", () => $378af66192388ab5$export$7f243984d41e6570);
$parcel$export(module.exports, "dragInsertButtonWrapper", () => $378af66192388ab5$export$cfa9a9cdd25b9d6e);
$parcel$export(module.exports, "dragCornerControlButton", () => $378af66192388ab5$export$6134f9ac8c9f161f);
$parcel$export(module.exports, "insertColumnButtonWrapper", () => $378af66192388ab5$export$d9daf73b486785b9);
$parcel$export(module.exports, "insertRowButtonWrapper", () => $378af66192388ab5$export$595c9c01d7c39885);
$parcel$export(module.exports, "columnControlsLineMarker", () => $378af66192388ab5$export$6114ba9f95ca48dc);
$parcel$export(module.exports, "DeleteButton", () => $378af66192388ab5$export$d6f68d0fe29f8050);
$parcel$export(module.exports, "OverflowShadow", () => $378af66192388ab5$export$f802e22253ad2b2c);
$parcel$export(module.exports, "floatingColumnControls", () => $378af66192388ab5$export$125caa90718a4ea9);
$parcel$export(module.exports, "rowControlsWrapperDotStyle", () => $378af66192388ab5$export$a2258906ae78ec82);
$parcel$export(module.exports, "columnControlsDecoration", () => $378af66192388ab5$export$8c8180e74f25db6a);
$parcel$export(module.exports, "hoveredDeleteButton", () => $378af66192388ab5$export$4d63bf225990ad34);
$parcel$export(module.exports, "hoveredCell", () => $378af66192388ab5$export$1c46f5412a5a3ae0);
$parcel$export(module.exports, "hoveredWarningCell", () => $378af66192388ab5$export$40edb32b62e4fb85);
$parcel$export(module.exports, "resizeHandle", () => $378af66192388ab5$export$8e36b812ea421d73);
$parcel$export(module.exports, "insertLine", () => $378af66192388ab5$export$b9932a52fb1c7aad);
/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression -- needs mahual remediation */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $cjLtO = parcelRequire("cjLtO");

var $7yBx7 = parcelRequire("7yBx7");


var $dzEzE = parcelRequire("dzEzE");

var $fsO0s = parcelRequire("fsO0s");
const $378af66192388ab5$var$InsertLine = (cssString)=>/*#__PURE__*/ (0, $1NIU8.css)(".", (0, $dzEzE.TableCssClassName).CONTROLS_INSERT_LINE, "{background:", (0, $fsO0s.tableBorderSelectedColor), ";display:none;position:absolute;z-index:", (0, $7yBx7.akEditorUnitZIndex), ";", cssString, ";}");
const $378af66192388ab5$var$Marker = ()=>/*#__PURE__*/ (0, $1NIU8.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: (0, $fsO0s.tableBorderColor),
        position: 'absolute',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `${(0, $fsO0s.lineMarkerSize)}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `${(0, $fsO0s.lineMarkerSize)}px`,
        borderRadius: '50%',
        pointerEvents: 'none'
    });
const $378af66192388ab5$export$22ce45ffbca2b768 = (cssString)=>/*#__PURE__*/ (0, $1NIU8.css)(".", (0, $dzEzE.TableCssClassName).CONTROLS_INSERT_MARKER, "{", $378af66192388ab5$var$Marker(), ";", cssString, ";}");
const $378af66192388ab5$var$Button = (cssString)=>/*#__PURE__*/ (0, $1NIU8.css)("border-radius:var(--ds-border-radius, 3px);border-width:0px;display:inline-flex;max-width:100%;text-align:center;margin:0px;padding:0px;text-decoration:none;transition:background 0.1s ease-out 0s,box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38) 0s;outline:none!important;cursor:none;>.", (0, $dzEzE.TableCssClassName).CONTROLS_BUTTON_ICON, "{display:inline-flex;max-height:100%;max-width:100%;}", cssString, ";");
const $378af66192388ab5$export$c7c73467b57835d = (cssString)=>/*#__PURE__*/ (0, $1NIU8.css)(".", (0, $dzEzE.TableCssClassName).CONTROLS_BUTTON, "{background:", (0, $fsO0s.tableHeaderCellBackgroundColor), ";border:1px solid ", (0, $fsO0s.tableBorderColor), ";display:block;box-sizing:border-box;padding:0;", cssString, ";:focus{outline:none;}}.", (0, $dzEzE.TableCssClassName).ROW_CONTROLS_BUTTON, "::after{content:' ';background-color:transparent;left:-15px;top:0;position:absolute;width:15px;height:100%;z-index:1;}.active .", (0, $dzEzE.TableCssClassName).CONTROLS_BUTTON, "{color:", `var(--ds-icon-inverse, ${(0, $7bb4c1736002a04a$export$29a4f05edc054374)})`, ";background-color:", (0, $fsO0s.tableToolbarSelectedColor), ";border-color:", (0, $fsO0s.tableBorderSelectedColor), ";}");
const $378af66192388ab5$export$eb5435fbd56e8d4 = ()=>/*#__PURE__*/ (0, $1NIU8.css)(".", (0, $dzEzE.TableCssClassName).CONTROLS_BUTTON, ":hover{color:", `var(--ds-icon-inverse, ${(0, $7bb4c1736002a04a$export$29a4f05edc054374)})`, ";background-color:", (0, $fsO0s.tableToolbarSelectedColor), ";border-color:", (0, $fsO0s.tableBorderSelectedColor), ";cursor:pointer;}");
const $378af66192388ab5$export$7f243984d41e6570 = ()=>/*#__PURE__*/ (0, $1NIU8.css)(".", (0, $dzEzE.TableCssClassName).HOVERED_CELL_IN_DANGER, " .", (0, $dzEzE.TableCssClassName).CONTROLS_BUTTON, "{background-color:", (0, $fsO0s.tableToolbarDeleteColor), ";border-color:", (0, $fsO0s.tableBorderDeleteColor), ";position:relative;z-index:", (0, $7yBx7.akEditorUnitZIndex), ";}");
const $378af66192388ab5$var$InsertButton = ()=>/*#__PURE__*/ (0, $1NIU8.css)(".", (0, $dzEzE.TableCssClassName).CONTROLS_INSERT_BUTTON_INNER, "{position:absolute;z-index:", (0, $7yBx7.akEditorUnitZIndex) + 10, ";bottom:0;}.", (0, $dzEzE.TableCssClassName).CONTROLS_INSERT_BUTTON_INNER, ",.", (0, $dzEzE.TableCssClassName).CONTROLS_INSERT_BUTTON, "{height:", (0, $fsO0s.tableInsertColumnButtonSize), "px;width:", (0, $fsO0s.tableInsertColumnButtonSize), "px;}.", (0, $dzEzE.TableCssClassName).CONTROLS_INSERT_BUTTON, "{", $378af66192388ab5$var$Button(`
      background: ${"var(--ds-surface-overlay, white)"};
      box-shadow: ${`var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $7bb4c1736002a04a$export$d2d3bedfb276cac0)}, 0 0 1px ${(0, $7bb4c1736002a04a$export$d2d3bedfb276cac0)}`})`};
      color: ${`var(--ds-icon, ${(0, $7bb4c1736002a04a$export$e2ef2124cf4024b1)})`};
    `), ";}.", (0, $dzEzE.TableCssClassName).CONTROLS_INSERT_LINE, "{display:none;}&:hover .", (0, $dzEzE.TableCssClassName).CONTROLS_INSERT_LINE, "{display:flex;}");
const $378af66192388ab5$var$InsertButtonHover = ()=>/*#__PURE__*/ (0, $1NIU8.css)(".", (0, $dzEzE.TableCssClassName).CONTROLS_INSERT_BUTTON, ":hover{background:", `var(--ds-background-brand-bold, ${(0, $7bb4c1736002a04a$export$e62e8919cca44969)})`, ";color:var(--ds-icon-inverse, white);cursor:pointer;}");
const $378af66192388ab5$export$cfa9a9cdd25b9d6e = ()=>/*#__PURE__*/ (0, $1NIU8.css)(".", (0, $dzEzE.TableCssClassName).DRAG_CONTROLS_INSERT_BUTTON_INNER, "{position:absolute;z-index:", (0, $7yBx7.akEditorUnitZIndex) + 10, ";}.", (0, $dzEzE.TableCssClassName).DRAG_CONTROLS_INSERT_BUTTON_INNER_COLUMN, "{bottom:-3px;left:2px;}.", (0, $dzEzE.TableCssClassName).DRAG_CONTROLS_INSERT_BUTTON_INNER_ROW, "{left:-3px;bottom:-2px;}.", (0, $dzEzE.TableCssClassName).DRAG_CONTROLS_INSERT_BUTTON_INNER_ROW_CHROMELESS, "{left:6px;bottom:-2px;}.", (0, $dzEzE.TableCssClassName).DRAG_CONTROLS_INSERT_BUTTON, "{", $378af66192388ab5$var$Button(`
    background: ${"var(--ds-surface-overlay, white)"};
    color: ${`var(--ds-icon, ${(0, $7bb4c1736002a04a$export$e2ef2124cf4024b1)})`};
    border: 1px solid ${"var(--ds-background-accent-gray-subtler, #C1C7D0)"};
    border-radius: 50%;
    height: ${(0, $fsO0s.dragTableInsertColumnButtonSize)}px;
    width: ${(0, $fsO0s.dragTableInsertColumnButtonSize)}px;
  `), ";}.", (0, $dzEzE.TableCssClassName).DRAG_CONTROLS_INSERT_BUTTON, ":hover{background:", `var(--ds-background-brand-bold, ${(0, $7bb4c1736002a04a$export$e62e8919cca44969)})`, ";border:1px solid ", `var(--ds-background-brand-bold, ${(0, $7bb4c1736002a04a$export$e62e8919cca44969)})`, ";color:var(--ds-icon-inverse, white);cursor:pointer;}");
const $378af66192388ab5$export$6134f9ac8c9f161f = ()=>/*#__PURE__*/ (0, $1NIU8.css)(".", (0, $dzEzE.TableCssClassName).DRAG_CORNER_BUTTON, "{width:15px;height:15px;display:flex;justify-content:center;align-items:center;position:absolute;top:-17px;left:-5px;background-color:transparent;border:none;padding:0;outline:none;z-index:", (0, $7yBx7.akEditorUnitZIndex) * 99, ";&.active .", (0, $dzEzE.TableCssClassName).DRAG_CORNER_BUTTON_INNER, "{background-color:var(--ds-border-selected, #0C66E4);width:10px;height:10px;border-width:2px;border-radius:4px;top:3px;left:2px;}&:hover{cursor:pointer;.", (0, $dzEzE.TableCssClassName).DRAG_CORNER_BUTTON_INNER, "{width:10px;height:10px;border-radius:4px;top:3px;left:2px;}}}.", (0, $dzEzE.TableCssClassName).DRAG_CORNER_BUTTON_INNER, "{border:1px solid var(--ds-border-inverse, #FFF);background-color:var(--ds-background-accent-gray-subtler, #DCDFE4);border-radius:2px;width:5px;height:5px;position:relative;}");
const $378af66192388ab5$export$d9daf73b486785b9 = ()=>/*#__PURE__*/ (0, $1NIU8.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $378af66192388ab5$var$InsertButton(), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $378af66192388ab5$var$InsertButtonHover(), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $378af66192388ab5$var$InsertLine(`
    width: 2px;
    left: 9px;
  `));
const $378af66192388ab5$export$595c9c01d7c39885 = ()=>/*#__PURE__*/ (0, $1NIU8.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $378af66192388ab5$var$InsertButton(), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $378af66192388ab5$var$InsertButtonHover(), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $378af66192388ab5$var$InsertLine(`
    height: 2px;
    top: -11px;
	${''}
    left: ${(0, $fsO0s.tableInsertColumnButtonSize) - 1}px;
  `));
const $378af66192388ab5$export$6114ba9f95ca48dc = ()=>/*#__PURE__*/ (0, $1NIU8.css)(".", (0, $dzEzE.TableCssClassName).TABLE_CONTAINER, ".", (0, $dzEzE.TableCssClassName).WITH_CONTROLS, " table tr:first-of-type td,.", (0, $dzEzE.TableCssClassName).TABLE_CONTAINER, ".", (0, $dzEzE.TableCssClassName).WITH_CONTROLS, " table tr:first-of-type th{position:relative;}");
const $378af66192388ab5$export$d6f68d0fe29f8050 = ()=>/*#__PURE__*/ (0, $1NIU8.css)(".", (0, $dzEzE.TableCssClassName).CONTROLS_DELETE_BUTTON_WRAP, ",.", (0, $dzEzE.TableCssClassName).CONTROLS_DELETE_BUTTON, "{height:", (0, $fsO0s.tableDeleteButtonSize), "px;width:", (0, $fsO0s.tableDeleteButtonSize), "px;}.", (0, $dzEzE.TableCssClassName).CONTROLS_DELETE_BUTTON_WRAP, "{.", (0, $dzEzE.TableCssClassName).CONTROLS_DELETE_BUTTON, "{", $378af66192388ab5$var$Button(`
        background: ${(0, $fsO0s.tableCellSelectedDeleteIconBackground)};
        color: ${(0, $fsO0s.tableCellSelectedDeleteIconColor)};
      `), ";}}.", (0, $dzEzE.TableCssClassName).CONTROLS_DELETE_BUTTON, ":hover{background:", (0, $fsO0s.tableCellHoverDeleteIconBackground), ";color:", (0, $fsO0s.tableCellHoverDeleteIconColor), ";cursor:pointer;}");
const $378af66192388ab5$export$f802e22253ad2b2c = (isDragAndDropEnabled)=>/*#__PURE__*/ (0, $1NIU8.css)(".", (0, $dzEzE.TableCssClassName).TABLE_RIGHT_SHADOW, ",.", (0, $dzEzE.TableCssClassName).TABLE_LEFT_SHADOW, "{display:block;height:calc(100% - ", (0, $cjLtO.tableMarginTop), "px);position:absolute;pointer-events:none;top:", (0, $cjLtO.tableMarginTop), "px;z-index:", (0, $7yBx7.akEditorShadowZIndex), ";width:", (0, $fsO0s.tableOverflowShadowWidthWide), "px;}.", (0, $dzEzE.TableCssClassName).TABLE_LEFT_SHADOW, "{background:linear-gradient(\n\t\t\t\tto left,\n\t\t\t\ttransparent 0,\n\t\t\t\t", `var(--ds-shadow-overflow-spread, ${(0, $7bb4c1736002a04a$export$46987b49aab6d1a8)})`, " 140%\n\t\t\t),linear-gradient(\n\t\t\t\tto right,\n\t\t\t\tvar(--ds-shadow-overflow-perimeter, transparent) 0px,\n\t\t\t\ttransparent 1px\n\t\t\t);left:0px;}.", (0, $dzEzE.TableCssClassName).TABLE_CONTAINER, "[data-number-column='true']>:not(.", (0, $dzEzE.TableCssClassName).TABLE_STICKY_SHADOW, ").", (0, $dzEzE.TableCssClassName).TABLE_LEFT_SHADOW, "{left:", (0, $7yBx7.akEditorTableNumberColumnWidth) - 1, "px;}.", (0, $dzEzE.TableCssClassName).TABLE_RIGHT_SHADOW, "{background:linear-gradient(\n\t\t\t\tto right,\n\t\t\t\ttransparent 0,\n\t\t\t\t", `var(--ds-shadow-overflow-spread, ${(0, $7bb4c1736002a04a$export$46987b49aab6d1a8)})`, " 140%\n\t\t\t),linear-gradient(\n\t\t\t\tto left,\n\t\t\t\tvar(--ds-shadow-overflow-perimeter, transparent) 0px,\n\t\t\t\ttransparent 1px\n\t\t\t);left:calc(100% - ", (0, $fsO0s.tableOverflowShadowWidthWide), "px);}.", (0, $dzEzE.TableCssClassName).WITH_CONTROLS, "{", $378af66192388ab5$var$overflowShadowWidhoutDnD(isDragAndDropEnabled), " .", (0, $dzEzE.TableCssClassName).TABLE_LEFT_SHADOW, "{border-left:1px solid ", (0, $fsO0s.tableBorderColor), ";}}");
const $378af66192388ab5$var$overflowShadowWidhoutDnD = (isDragAndDropEnabled)=>{
    if (!isDragAndDropEnabled) return /*#__PURE__*/ (0, $1NIU8.css)(".", (0, $dzEzE.TableCssClassName).TABLE_RIGHT_SHADOW, ",.", (0, $dzEzE.TableCssClassName).TABLE_LEFT_SHADOW, "{height:calc(100% - ", (0, $cjLtO.tableMarginTopWithControl), "px);top:", (0, $cjLtO.tableMarginTopWithControl), "px;}");
};
const $378af66192388ab5$var$columnHeaderButton = (cssString)=>{
    return /*#__PURE__*/ (0, $1NIU8.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        background: (0, $fsO0s.tableHeaderCellBackgroundColor),
        display: 'block',
        boxSizing: 'border-box',
        padding: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        ':focus': {
            outline: 'none'
        }
    }, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    cssString);
};
const $378af66192388ab5$var$columnHeaderButtonSelected = ()=>/*#__PURE__*/ (0, $1NIU8.css)({
        color: `var(--ds-text-inverse, ${(0, $7bb4c1736002a04a$export$29a4f05edc054374)})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: (0, $fsO0s.tableToolbarSelectedColor),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        borderColor: (0, $fsO0s.tableBorderSelectedColor),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: (0, $fsO0s.columnControlsSelectedZIndex)
    });
const $378af66192388ab5$var$getFloatingDotOverrides = ()=>{
    return /*#__PURE__*/ (0, $1NIU8.css)("tr th:last-child .", (0, $dzEzE.TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "::before,tr td:last-child .", (0, $dzEzE.TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "::before{content:'';background-color:", (0, $fsO0s.tableBorderColor), ";position:absolute;height:", (0, $fsO0s.lineMarkerSize), "px;width:", (0, $fsO0s.lineMarkerSize), "px;border-radius:50%;pointer-events:none;top:var(--ds-space-025, 2px);right:0px;}");
};
const $378af66192388ab5$export$125caa90718a4ea9 = ()=>{
    return /*#__PURE__*/ (0, $1NIU8.css)(".", (0, $dzEzE.TableCssClassName).DRAG_COLUMN_DROP_TARGET_CONTROLS, "{box-sizing:border-box;position:absolute;top:0;.", (0, $dzEzE.TableCssClassName).DRAG_COLUMN_CONTROLS_INNER, "{display:flex;flex-direction:row;}}.", (0, $dzEzE.TableCssClassName).DRAG_COLUMN_CONTROLS, "{box-sizing:border-box;.", (0, $dzEzE.TableCssClassName).DRAG_COLUMN_CONTROLS_INNER, "{display:grid;justify-items:center;}}");
};
const $378af66192388ab5$export$a2258906ae78ec82 = ()=>{
    return /*#__PURE__*/ (0, $1NIU8.css)("div.", (0, $dzEzE.TableCssClassName).WITH_CONTROLS, ">.", (0, $dzEzE.TableCssClassName).DRAG_ROW_CONTROLS_WRAPPER, "::after{display:none;}div.", (0, $dzEzE.TableCssClassName).WITH_CONTROLS, ">.", (0, $dzEzE.TableCssClassName).ROW_CONTROLS_WRAPPER, "::after{content:' ';background-color:", (0, $fsO0s.tableBorderColor), ";position:absolute;height:", (0, $fsO0s.lineMarkerSize), "px;width:", (0, $fsO0s.lineMarkerSize), "px;border-radius:50%;pointer-events:none;top:-", (0, $fsO0s.tableToolbarSize) + (0, $cjLtO.tableCellBorderWidth), "px;right:-1px;}");
};
const $378af66192388ab5$export$8c8180e74f25db6a = ()=>{
    return /*#__PURE__*/ (0, $1NIU8.css)(".", (0, $dzEzE.TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "{display:none;cursor:pointer;position:absolute;width:100%;left:0;top:-", (0, $fsO0s.columnControlsDecorationHeight) + (0, $cjLtO.tableCellBorderWidth), "px;height:", (0, $fsO0s.columnControlsDecorationHeight), "px;&::before{content:' ';background-color:", (0, $fsO0s.tableBorderColor), ";position:absolute;height:", (0, $fsO0s.lineMarkerSize), "px;width:", (0, $fsO0s.lineMarkerSize), "px;border-radius:50%;pointer-events:none;top:2px;right:var(--ds-space-negative-025, -2px);}&::after{content:' ';", $378af66192388ab5$var$columnHeaderButton(`
        border-right: ${(0, $cjLtO.tableCellBorderWidth)}px solid ${(0, $fsO0s.tableBorderColor)};
        border-top: ${(0, $cjLtO.tableCellBorderWidth)}px solid ${(0, $fsO0s.tableBorderColor)};
        border-bottom: ${(0, $cjLtO.tableCellBorderWidth)}px solid ${(0, $fsO0s.tableBorderColor)};
        box-sizing: content-box;
        height: ${(0, $fsO0s.tableToolbarSize) - 1}px;
        width: 100%;
        position: absolute;
        top: ${(0, $fsO0s.columnControlsDecorationHeight) - (0, $fsO0s.tableToolbarSize)}px;
        left: 0px;
        z-index: ${(0, $fsO0s.columnControlsZIndex)};
      `), ";}}", $378af66192388ab5$var$getFloatingDotOverrides(), " .", (0, $dzEzE.TableCssClassName).WITH_CONTROLS, " .", (0, $dzEzE.TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "{display:block;}table tr:first-of-type td.", (0, $dzEzE.TableCssClassName).TABLE_CELL, ",table tr:first-of-type th.", (0, $dzEzE.TableCssClassName).TABLE_HEADER_CELL, "{&.", (0, $dzEzE.TableCssClassName).COLUMN_SELECTED, ",&.", (0, $dzEzE.TableCssClassName).HOVERED_TABLE, "{.", (0, $dzEzE.TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "::after{", $378af66192388ab5$var$columnHeaderButtonSelected(), ";}&.", (0, $dzEzE.TableCssClassName).HOVERED_CELL_IN_DANGER, " .", (0, $dzEzE.TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "::after{background-color:", (0, $fsO0s.tableToolbarDeleteColor), ";border-color:", (0, $fsO0s.tableBorderDeleteColor), ";z-index:", (0, $7yBx7.akEditorUnitZIndex) * 100, ";}}}table tr:first-of-type td.", (0, $dzEzE.TableCssClassName).TABLE_CELL, ",table tr:first-of-type th.", (0, $dzEzE.TableCssClassName).TABLE_HEADER_CELL, "{&.", (0, $dzEzE.TableCssClassName).COLUMN_SELECTED, ",&.", (0, $dzEzE.TableCssClassName).HOVERED_COLUMN, "{.", (0, $dzEzE.TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "::after{", $378af66192388ab5$var$columnHeaderButtonSelected(), ";border-left:", (0, $cjLtO.tableCellBorderWidth), "px solid ", (0, $fsO0s.tableBorderSelectedColor), ";left:-", (0, $cjLtO.tableCellBorderWidth), "px;}}}table tr:first-of-type td.", (0, $dzEzE.TableCssClassName).TABLE_CELL, ",table tr:first-of-type th.", (0, $dzEzE.TableCssClassName).TABLE_HEADER_CELL, "{&.", (0, $dzEzE.TableCssClassName).HOVERED_COLUMN, "{.", (0, $dzEzE.TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "::after{", $378af66192388ab5$var$columnHeaderButtonSelected(), ";}&.", (0, $dzEzE.TableCssClassName).HOVERED_CELL_IN_DANGER, " .", (0, $dzEzE.TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "::after{background-color:", (0, $fsO0s.tableToolbarDeleteColor), ";border-color:", (0, $fsO0s.tableBorderDeleteColor), ";border-left:", (0, $cjLtO.tableCellBorderWidth), "px solid ", (0, $fsO0s.tableBorderDeleteColor), ";left:-", (0, $cjLtO.tableCellBorderWidth), "px;z-index:", (0, $7yBx7.akEditorUnitZIndex) * 100, ";}}}.", (0, $dzEzE.TableCssClassName).TABLE_SELECTED, " table tr:first-of-type td.", (0, $dzEzE.TableCssClassName).TABLE_CELL, ",.", (0, $dzEzE.TableCssClassName).TABLE_SELECTED, " table tr:first-of-type th.", (0, $dzEzE.TableCssClassName).TABLE_HEADER_CELL, "{.", (0, $dzEzE.TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "::after{", $378af66192388ab5$var$columnHeaderButtonSelected(), ";}}");
};
const $378af66192388ab5$export$4d63bf225990ad34 = ()=>/*#__PURE__*/ (0, $1NIU8.css)(".", (0, $dzEzE.TableCssClassName).TABLE_CONTAINER, ".", (0, $dzEzE.TableCssClassName).HOVERED_DELETE_BUTTON, "{.", (0, $dzEzE.TableCssClassName).SELECTED_CELL, ",.", (0, $dzEzE.TableCssClassName).COLUMN_SELECTED, ",.", (0, $dzEzE.TableCssClassName).HOVERED_CELL, "{border:1px solid ", (0, $fsO0s.tableBorderDeleteColor), ";}.", (0, $dzEzE.TableCssClassName).SELECTED_CELL, "::after{background:", (0, $fsO0s.tableCellDeleteColor), ";}.", (0, $dzEzE.TableCssClassName).TABLE_NODE_WRAPPER, ">table{td.", (0, $dzEzE.TableCssClassName).HOVERED_NO_HIGHLIGHT, "::after{background:", (0, $fsO0s.tableCellDeleteColor), ";border:1px solid ", (0, $fsO0s.tableBorderDeleteColor), ";}th.", (0, $dzEzE.TableCssClassName).HOVERED_NO_HIGHLIGHT, "{background-color:unset;}th.", (0, $dzEzE.TableCssClassName).HOVERED_NO_HIGHLIGHT, "::after{background:", (0, $fsO0s.tableCellDeleteColor), ";border:1px solid ", (0, $fsO0s.tableBorderDeleteColor), ";}}}");
const $378af66192388ab5$export$1c46f5412a5a3ae0 = ()=>/*#__PURE__*/ (0, $1NIU8.css)(":not(.", (0, $dzEzE.TableCssClassName).IS_RESIZING, ") .", (0, $dzEzE.TableCssClassName).TABLE_CONTAINER, ":not(.", (0, $dzEzE.TableCssClassName).HOVERED_DELETE_BUTTON, "){.", (0, $dzEzE.TableCssClassName).HOVERED_CELL, "{position:relative;border:1px solid ", (0, $fsO0s.tableBorderSelectedColor), ";}.", (0, $dzEzE.TableCssClassName).HOVERED_CELL, ".", (0, $dzEzE.TableCssClassName).HOVERED_NO_HIGHLIGHT, "{position:relative;border:1px solid ", (0, $fsO0s.tableBorderColor), ";}}");
const $378af66192388ab5$export$40edb32b62e4fb85 = /*#__PURE__*/ (0, $1NIU8.css)(":not(.", (0, $dzEzE.TableCssClassName).IS_RESIZING, ") .", (0, $dzEzE.TableCssClassName).TABLE_CONTAINER, ":not(.", (0, $dzEzE.TableCssClassName).HOVERED_DELETE_BUTTON, "){td.", (0, $dzEzE.TableCssClassName).HOVERED_CELL_WARNING, "{background-color:", `var(--ds-background-warning, ${(0, $7bb4c1736002a04a$export$8d9596b529bbb9cf)})`, "!important;border:1px solid ", `var(--ds-border-warning, ${(0, $7bb4c1736002a04a$export$5aae31392d72caaa)})`, ";}}");
// Explicit pixel values required here to ensure correct positioning and sizes of column resize handle
// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
const $378af66192388ab5$var$resizeLineStyles = ()=>{
    return /*#__PURE__*/ (0, $1NIU8.css)("th.", (0, $dzEzE.TableCssClassName).WITH_DRAG_RESIZE_LINE, "::before,td.", (0, $dzEzE.TableCssClassName).WITH_DRAG_RESIZE_LINE, "::before{content:' ';position:absolute;left:var(--ds-space-negative-025, -2px);top:-1px;width:", (0, $fsO0s.resizeLineWidth), "px;height:calc(100% + 2px);background-color:", (0, $fsO0s.tableBorderSelectedColor), ";z-index:", (0, $fsO0s.columnControlsZIndex) * 2, ";}th.", (0, $dzEzE.TableCssClassName).WITH_DRAG_RESIZE_LINE_LAST_COLUMN, "::before,td.", (0, $dzEzE.TableCssClassName).WITH_DRAG_RESIZE_LINE_LAST_COLUMN, "::before{content:' ';position:absolute;right:-1px;top:-1px;width:", (0, $fsO0s.resizeLineWidth), "px;height:calc(100% + 2px);background-color:", (0, $fsO0s.tableBorderSelectedColor), ";z-index:", (0, $fsO0s.columnControlsZIndex) * 2, ";}td.", (0, $dzEzE.TableCssClassName).WITH_RESIZE_LINE, "::before{content:' ';position:absolute;left:var(--ds-space-negative-025, -2px);top:-1px;width:", (0, $fsO0s.resizeLineWidth), "px;height:calc(100% + 2px);background-color:", (0, $fsO0s.tableBorderSelectedColor), ";z-index:", (0, $fsO0s.columnControlsZIndex) * 2, ";}th.", (0, $dzEzE.TableCssClassName).WITH_RESIZE_LINE, "::before{content:' ';left:var(--ds-space-negative-025, -2px);position:absolute;width:", (0, $fsO0s.resizeLineWidth), "px;height:calc(100% + ", (0, $fsO0s.tableToolbarSize) + (0, $cjLtO.tableCellBorderWidth), "px);background-color:", (0, $fsO0s.tableBorderSelectedColor), ";z-index:", (0, $fsO0s.columnControlsZIndex) * 2, ";top:-", (0, $fsO0s.tableToolbarSize) + (0, $cjLtO.tableCellBorderWidth), "px;}td.", (0, $dzEzE.TableCssClassName).WITH_RESIZE_LINE_LAST_COLUMN, "::before{content:' ';position:absolute;right:-1px;top:-1px;width:", (0, $fsO0s.resizeLineWidth), "px;height:calc(100% + 2px);background-color:", (0, $fsO0s.tableBorderSelectedColor), ";z-index:", (0, $fsO0s.columnControlsZIndex) * 2, ";}th.", (0, $dzEzE.TableCssClassName).WITH_RESIZE_LINE_LAST_COLUMN, "::before{content:' ';right:-1px;position:absolute;width:", (0, $fsO0s.resizeLineWidth), "px;height:calc(100% + ", (0, $fsO0s.tableToolbarSize) + (0, $cjLtO.tableCellBorderWidth), "px);background-color:", (0, $fsO0s.tableBorderSelectedColor), ";z-index:", (0, $fsO0s.columnControlsZIndex) * 2, ";top:-", (0, $fsO0s.tableToolbarSize) + (0, $cjLtO.tableCellBorderWidth), "px;}");
};
const $378af66192388ab5$export$8e36b812ea421d73 = ()=>/*#__PURE__*/ (0, $1NIU8.css)(".", (0, $dzEzE.TableCssClassName).TABLE_CONTAINER, "{.", (0, $dzEzE.TableCssClassName).RESIZE_HANDLE_DECORATION, "{background-color:transparent;position:absolute;width:", (0, $fsO0s.resizeHandlerAreaWidth), "px;height:100%;top:0;right:-", (0, $fsO0s.resizeHandlerAreaWidth) / 2, "px;cursor:col-resize;z-index:", (0, $fsO0s.resizeHandlerZIndex), ";}tr th:last-child .", (0, $dzEzE.TableCssClassName).RESIZE_HANDLE_DECORATION, ",tr td:last-child .", (0, $dzEzE.TableCssClassName).RESIZE_HANDLE_DECORATION, "{background-color:transparent;position:absolute;width:", (0, $fsO0s.resizeHandlerAreaWidth) / 2, "px;height:100%;top:0;right:0;cursor:col-resize;z-index:", (0, $fsO0s.resizeHandlerZIndex), ";}", $378af66192388ab5$var$resizeLineStyles(), " table tr:first-of-type th.", (0, $dzEzE.TableCssClassName).WITH_DRAG_RESIZE_LINE, " .", (0, $dzEzE.TableCssClassName).RESIZE_HANDLE_DECORATION, "::after,table tr:first-of-type td.", (0, $dzEzE.TableCssClassName).WITH_DRAG_RESIZE_LINE, " .", (0, $dzEzE.TableCssClassName).RESIZE_HANDLE_DECORATION, "::after,table tr:first-of-type th.", (0, $dzEzE.TableCssClassName).WITH_RESIZE_LINE, " .", (0, $dzEzE.TableCssClassName).RESIZE_HANDLE_DECORATION, "::after,table tr:first-of-type td.", (0, $dzEzE.TableCssClassName).WITH_RESIZE_LINE, " .", (0, $dzEzE.TableCssClassName).RESIZE_HANDLE_DECORATION, "::after{top:-", (0, $fsO0s.tableToolbarSize) + (0, $cjLtO.tableCellBorderWidth), "px;height:calc(100% + ", (0, $fsO0s.tableToolbarSize) + (0, $cjLtO.tableCellBorderWidth), "px);}}");
// Drag and Drop: drop target insert line
const $378af66192388ab5$var$tableCellColumnInsertLineStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    content: "' '",
    position: 'absolute',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: `calc(100% + ${(0, $cjLtO.tableCellBorderWidth) * 2}px)`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $fsO0s.insertLineWidth)}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    zIndex: (0, $fsO0s.columnControlsZIndex) * 2
});
const $378af66192388ab5$var$tableCellRowInsertLineStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    content: "' '",
    position: 'absolute',
    left: "var(--ds-space-negative-025, -2px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: `${(0, $fsO0s.insertLineWidth)}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `calc(100% + ${(0, $cjLtO.tableCellBorderWidth) * 2}px)`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    zIndex: (0, $fsO0s.columnControlsZIndex) * 2
});
const $378af66192388ab5$var$insertLineActiveColor = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    backgroundColor: (0, $fsO0s.tableBorderSelectedColor)
});
const $378af66192388ab5$var$insertLineInactiveColor = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    backgroundColor: `var(--ds-background-accent-gray-subtler, ${(0, $7yBx7.akEditorTableBorder)})`
});
const $378af66192388ab5$export$b9932a52fb1c7aad = ()=>/*#__PURE__*/ (0, $1NIU8.css)(".", (0, $dzEzE.TableCssClassName).TABLE_CONTAINER, "{td.", (0, $dzEzE.TableCssClassName).WITH_FIRST_COLUMN_INSERT_LINE, "::before{", $378af66192388ab5$var$tableCellColumnInsertLineStyles, " left:-1px;top:-1px;", $378af66192388ab5$var$insertLineActiveColor, ";}td.", (0, $dzEzE.TableCssClassName).WITH_FIRST_COLUMN_INSERT_LINE_INACTIVE, "::before{", $378af66192388ab5$var$tableCellColumnInsertLineStyles, " left:-1px;top:-1px;", $378af66192388ab5$var$insertLineInactiveColor, ";}th.", (0, $dzEzE.TableCssClassName).WITH_FIRST_COLUMN_INSERT_LINE, "::before{", $378af66192388ab5$var$tableCellColumnInsertLineStyles, " left:-1px;top:-", (0, $cjLtO.tableCellBorderWidth), "px;", $378af66192388ab5$var$insertLineActiveColor, ";}th.", (0, $dzEzE.TableCssClassName).WITH_FIRST_COLUMN_INSERT_LINE_INACTIVE, "::before{", $378af66192388ab5$var$tableCellColumnInsertLineStyles, " left:-1px;top:-", (0, $cjLtO.tableCellBorderWidth), "px;", $378af66192388ab5$var$insertLineInactiveColor, ";}td.", (0, $dzEzE.TableCssClassName).WITH_COLUMN_INSERT_LINE, "::before{", $378af66192388ab5$var$tableCellColumnInsertLineStyles, " left:var(--ds-space-negative-025, -2px);top:-1px;", $378af66192388ab5$var$insertLineActiveColor, ";}td.", (0, $dzEzE.TableCssClassName).WITH_COLUMN_INSERT_LINE_INACTIVE, "::before{", $378af66192388ab5$var$tableCellColumnInsertLineStyles, " left:var(--ds-space-negative-025, -2px);top:-1px;", $378af66192388ab5$var$insertLineInactiveColor, ";}th.", (0, $dzEzE.TableCssClassName).WITH_COLUMN_INSERT_LINE, "::before{", $378af66192388ab5$var$tableCellColumnInsertLineStyles, " left:var(--ds-space-negative-025, -2px);top:-", (0, $cjLtO.tableCellBorderWidth), "px;", $378af66192388ab5$var$insertLineActiveColor, ";}th.", (0, $dzEzE.TableCssClassName).WITH_COLUMN_INSERT_LINE_INACTIVE, "::before{", $378af66192388ab5$var$tableCellColumnInsertLineStyles, " left:var(--ds-space-negative-025, -2px);top:-", (0, $cjLtO.tableCellBorderWidth), "px;", $378af66192388ab5$var$insertLineInactiveColor, ";}td.", (0, $dzEzE.TableCssClassName).WITH_LAST_COLUMN_INSERT_LINE, "::before{", $378af66192388ab5$var$tableCellColumnInsertLineStyles, " right:-1px;top:-1px;", $378af66192388ab5$var$insertLineActiveColor, ";}td.", (0, $dzEzE.TableCssClassName).WITH_LAST_COLUMN_INSERT_LINE_INACTIVE, "::before{", $378af66192388ab5$var$tableCellColumnInsertLineStyles, " right:-1px;top:-1px;", $378af66192388ab5$var$insertLineInactiveColor, ";}th.", (0, $dzEzE.TableCssClassName).WITH_LAST_COLUMN_INSERT_LINE, "::before{", $378af66192388ab5$var$tableCellColumnInsertLineStyles, " right:-1px;top:-", (0, $cjLtO.tableCellBorderWidth), "px;", $378af66192388ab5$var$insertLineActiveColor, ";}th.", (0, $dzEzE.TableCssClassName).WITH_LAST_COLUMN_INSERT_LINE_INACTIVE, "::before{", $378af66192388ab5$var$tableCellColumnInsertLineStyles, " right:-1px;top:-", (0, $cjLtO.tableCellBorderWidth), "px;", $378af66192388ab5$var$insertLineInactiveColor, ";}td.", (0, $dzEzE.TableCssClassName).WITH_ROW_INSERT_LINE, "::before{", $378af66192388ab5$var$tableCellRowInsertLineStyles, " top:-1px;", $378af66192388ab5$var$insertLineActiveColor, ";}td.", (0, $dzEzE.TableCssClassName).WITH_ROW_INSERT_LINE_INACTIVE, "::before{", $378af66192388ab5$var$tableCellRowInsertLineStyles, " top:-1px;", $378af66192388ab5$var$insertLineInactiveColor, ";}th.", (0, $dzEzE.TableCssClassName).WITH_ROW_INSERT_LINE, "::before{", $378af66192388ab5$var$tableCellRowInsertLineStyles, " top:-1px;", $378af66192388ab5$var$insertLineActiveColor, ";}th.", (0, $dzEzE.TableCssClassName).WITH_ROW_INSERT_LINE_INACTIVE, "::before{", $378af66192388ab5$var$tableCellRowInsertLineStyles, " top:-1px;", $378af66192388ab5$var$insertLineInactiveColor, ";}td.", (0, $dzEzE.TableCssClassName).WITH_LAST_ROW_INSERT_LINE, "::before{", $378af66192388ab5$var$tableCellRowInsertLineStyles, " bottom:0;", $378af66192388ab5$var$insertLineActiveColor, ";}td.", (0, $dzEzE.TableCssClassName).WITH_LAST_ROW_INSERT_LINE_INACTIVE, "::before{", $378af66192388ab5$var$tableCellRowInsertLineStyles, " bottom:0;", $378af66192388ab5$var$insertLineInactiveColor, ";}th.", (0, $dzEzE.TableCssClassName).WITH_LAST_ROW_INSERT_LINE, "::before{", $378af66192388ab5$var$tableCellRowInsertLineStyles, " bottom:0;", $378af66192388ab5$var$insertLineActiveColor, ";}th.", (0, $dzEzE.TableCssClassName).WITH_LAST_ROW_INSERT_LINE_INACTIVE, "::before{", $378af66192388ab5$var$tableCellRowInsertLineStyles, " bottom:0;", $378af66192388ab5$var$insertLineInactiveColor, ";}}");

});



parcelRegister("g5n6x", function(module, exports) {

$parcel$export(module.exports, "default", () => $371e4919406a4a18$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $jqh4E = parcelRequire("jqh4E");
function $371e4919406a4a18$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $371e4919406a4a18$var$clickWrapper = {
    name: "sox1a6",
    styles: "flex-grow:1;height:100%"
};
const $371e4919406a4a18$export$68468c5dbde37b99 = ({ editorView: editorView, editorDisabled: editorDisabled, children: children })=>{
    const handleMouseDown = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((event)=>{
        if (!editorView) return;
        if (!editorDisabled) (0, $jqh4E.clickAreaClickHandler)(editorView, event);
    }, [
        editorView,
        editorDisabled
    ]);
    return(// eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        "data-editor-click-wrapper": true,
        "data-testid": "click-wrapper",
        css: $371e4919406a4a18$var$clickWrapper,
        onMouseDown: handleMouseDown
    }, children));
};
var $371e4919406a4a18$export$2e2bcd8739ae039 = $371e4919406a4a18$export$68468c5dbde37b99;

});
parcelRegister("jqh4E", function(module, exports) {

$parcel$export(module.exports, "clickAreaClickHandler", () => $ac7a694f83c2c94e$export$28b64e3e5a38e8a2);

var $eh3wX = parcelRequire("eh3wX");

var $2Ttys = parcelRequire("2Ttys");

var $gEqKI = parcelRequire("gEqKI");

var $7SIsS = parcelRequire("7SIsS");

var $eGOwo = parcelRequire("eGOwo");

var $g0hAu = parcelRequire("g0hAu");
// we ignore all of the clicks made inside <div class="ak-editor-content-area" /> (but not clicks on the node itself)
const $ac7a694f83c2c94e$var$insideContentArea = (ref)=>{
    while(ref){
        if (ref.classList && ref.classList.contains('ak-editor-content-area')) return true;
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        ref = ref.parentNode;
    }
    return false;
};
const $ac7a694f83c2c94e$var$insideProseMirrorEditableArea = (ref)=>{
    return Boolean(ref?.closest('.ProseMirror'));
};
const $ac7a694f83c2c94e$export$79ba7abfc5f47a65 = (target)=>{
    const modalDialog = target?.closest('[role=dialog]');
    if (modalDialog) // return false if not an editor inside modal, otherwise return true
    return !!modalDialog?.querySelector('.akEditor');
    // no modal present so we can return true
    return true;
};
const $ac7a694f83c2c94e$export$28b64e3e5a38e8a2 = (view, event)=>{
    const isEditorFocused = !!view?.hasFocus?.();
    if (!(event.target instanceof HTMLElement)) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const target = event.target;
    const isTargetContentArea = target?.classList.contains('ak-editor-content-area');
    const isTargetChildOfContentArea = $ac7a694f83c2c94e$var$insideContentArea(target?.parentNode instanceof HTMLElement ? target?.parentNode : null);
    const isTargetInsideEditableArea = $ac7a694f83c2c94e$var$insideProseMirrorEditableArea(target);
    // Any click inside ProseMirror should be managed by ProseMirror
    if (isTargetInsideEditableArea) return false;
    const isEventComingFromContentArea = Boolean(event.currentTarget.querySelector('.ak-editor-content-area'));
    // @see https://product-fabric.atlassian.net/browse/ED-4287
    // click event gets triggered twice on a checkbox (on <label> first and then on <input>)
    // by the time it gets triggered on input, PM already re-renders nodeView and detaches it from DOM
    // which doesn't pass the check !contentArea.contains(event.target)
    const isInputClicked = target?.nodeName === 'INPUT';
    // @see ED-5126
    const isPopupClicked = !!(0, $7SIsS.closestElement)(target, '[data-editor-popup]');
    // Fixes issue when using a textarea for editor title in full page editor doesn't let user focus it.
    const isTextAreaClicked = target?.nodeName === 'TEXTAREA';
    const isBreadcrumbClicked = !!(0, $7SIsS.closestElement)(target, 'nav[aria-label="Breadcrumbs"]');
    const selection = window.getSelection();
    const isEditorPopupTextSelected = selection?.type === 'Range' && // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    (0, $7SIsS.closestElement)(selection?.anchorNode, '[data-editor-popup]');
    // For clicks directly on the content component -- they should not be ignored
    const isContentComponent = (0, $eGOwo.fg)('platform_editor_keep_focus_on_content_comp_clicks') ? target?.parentElement?.closest(`[${(0, $g0hAu.ignoreAttribute)}]`) : !!(0, $7SIsS.closestElement)(target, `[${(0, $g0hAu.ignoreAttribute)}]`) || target?.getAttribute((0, $g0hAu.ignoreAttribute)) === 'true';
    // This is a super workaround to find when events are coming from Confluence InlineComment modal
    // We don't own those components, so we can't change them
    const isEventComingFromInlineCommentPopup = Boolean((0, $7SIsS.closestElement)(event.currentTarget, 'div[offset]')) || Boolean((0, $7SIsS.closestElement)(target, 'div[offset]'));
    const isButtonClicked = Boolean((0, $7SIsS.closestElement)(event.currentTarget, 'button')) || Boolean((0, $7SIsS.closestElement)(target, 'button')) || event.currentTarget?.nodeName === 'BUTTON' || target?.nodeName === 'BUTTON';
    const isTargetInsideContentArea = Boolean(isTargetChildOfContentArea);
    const isBetweenContentAreaAndEditableContent = isTargetInsideContentArea && !isTargetInsideEditableArea;
    // Column Picker dropdown in Datasources table
    const isDatasourcePopupClicked = !!target?.closest('#column-picker-popup');
    const edgeCaseScenario1 = (isBetweenContentAreaAndEditableContent || !isEventComingFromContentArea) && !isEditorFocused;
    const edgeCaseScenario2 = !isTargetInsideContentArea && isEditorFocused;
    const edgeCaseScenario3 = isTargetContentArea && !isTargetInsideContentArea && !isEditorFocused;
    const edgeCaseScenario4 = isEventComingFromContentArea && !isTargetContentArea && !isTargetInsideContentArea && !isEditorFocused;
    const edgeCases = edgeCaseScenario1 || edgeCaseScenario2 || edgeCaseScenario3 || edgeCaseScenario4;
    const isClickOutsideEditor = edgeCases && !isDatasourcePopupClicked && !isEventComingFromInlineCommentPopup && !isButtonClicked && !isInputClicked && !isTextAreaClicked && !isPopupClicked && !isBreadcrumbClicked && !isEditorPopupTextSelected && !isContentComponent && $ac7a694f83c2c94e$export$79ba7abfc5f47a65(target);
    // click was within editor container and focus should be brought to input
    if (isClickOutsideEditor && view) $ac7a694f83c2c94e$export$c5a7a653c4681bfd(view, event);
};
const $ac7a694f83c2c94e$export$c5a7a653c4681bfd = (view, event)=>{
    const { dispatch: dispatch, dom: dom, state: state } = view;
    const { tr: tr } = state;
    const isEditorFocused = !!view?.hasFocus?.();
    const isBottomAreaClicked = event.clientY > dom.getBoundingClientRect().bottom;
    if (isBottomAreaClicked) {
        tr.setMeta('outsideProsemirrorEditorClicked', true);
        (0, $2Ttys.addParagraphAtEnd)(tr);
    }
    (0, $gEqKI.setSelectionTopLevelBlocks)(tr, event, // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    dom, view.posAtCoords.bind(view), isEditorFocused);
    (0, $eh3wX.tintDirtyTransaction)(tr);
    if (!tr.docChanged && !tr.selectionSet) return;
    if (dispatch) dispatch(tr);
    view.focus();
    event.preventDefault();
};

});
parcelRegister("2Ttys", function(module, exports) {

$parcel$export(module.exports, "addParagraphAtEnd", () => $401855f8a07ae14f$export$fc18809329b5ff08);
$parcel$export(module.exports, "changeImageAlignment", () => $401855f8a07ae14f$export$774cc08dd90b6a6a);
$parcel$export(module.exports, "createToggleBlockMarkOnRange", () => $401855f8a07ae14f$export$1115c4cf51ae1924);
$parcel$export(module.exports, "createToggleInlineMarkOnRange", () => $401855f8a07ae14f$export$a10bb5a1a10022f6);
$parcel$export(module.exports, "toggleBlockMark", () => $401855f8a07ae14f$export$72d6145976985e8c);
$parcel$export(module.exports, "findCutBefore", () => $401855f8a07ae14f$export$ad1078cb3917e860);

var $3lIcL = parcelRequire("3lIcL");

var $cwzAY = parcelRequire("cwzAY");

var $piMVJ = parcelRequire("piMVJ");
function $401855f8a07ae14f$export$fc18809329b5ff08(tr) {
    const { doc: { type: { schema: { nodes: { paragraph: paragraph } } } }, doc: doc } = tr;
    if (doc.lastChild && !(doc.lastChild.type === paragraph && doc.lastChild.content.size === 0)) {
        if (paragraph) tr.insert(doc.content.size, paragraph.createAndFill());
    }
    tr.setSelection((0, $3lIcL.TextSelection).create(tr.doc, tr.doc.content.size - 1));
    tr.scrollIntoView();
}
function $401855f8a07ae14f$export$2864da03fd603a92() {
    return function(state, dispatch) {
        const { tr: tr } = state;
        $401855f8a07ae14f$export$fc18809329b5ff08(tr);
        if (dispatch) dispatch(tr);
        return true;
    };
}
const $401855f8a07ae14f$export$774cc08dd90b6a6a = (align)=>(state, dispatch)=>{
        const { from: from, to: to } = state.selection;
        const tr = state.tr;
        state.doc.nodesBetween(from, to, (node, pos)=>{
            if (node.type === state.schema.nodes.mediaSingle) tr.setNodeMarkup(pos, undefined, {
                ...node.attrs,
                layout: align === 'center' ? 'center' : `align-${align}`
            });
        });
        if (tr.docChanged && dispatch) {
            dispatch(tr.scrollIntoView());
            return true;
        }
        return false;
    };
const $401855f8a07ae14f$export$1115c4cf51ae1924 = (markType, getAttrs, allowedBlocks)=>(from, to, tr, state)=>{
        let markApplied = false;
        state.doc.nodesBetween(from, to, (node, pos, parent)=>{
            if (!node.type.isBlock) return false;
            if ((!allowedBlocks || (Array.isArray(allowedBlocks) ? allowedBlocks.indexOf(node.type) > -1 : allowedBlocks(state.schema, node, parent))) && parent?.type.allowsMarkType(markType)) {
                const oldMarks = node.marks.filter((mark)=>mark.type === markType);
                const prevAttrs = oldMarks.length ? oldMarks[0].attrs : undefined;
                const newAttrs = getAttrs(prevAttrs, node);
                if (newAttrs !== undefined) {
                    tr.setNodeMarkup(pos, node.type, node.attrs, node.marks.filter((mark)=>!markType.excludes(mark.type)).concat(newAttrs === false ? [] : markType.create(newAttrs)));
                    markApplied = true;
                }
            }
            return;
        });
        return markApplied;
    };
const $401855f8a07ae14f$export$a10bb5a1a10022f6 = (markType, getAttrs)=>(from, to, tr, state)=>{
        let markApplied = false;
        state.doc.nodesBetween(from, to, (node, pos, parent)=>{
            if (parent?.type.allowsMarkType(markType)) {
                const oldMarks = node.marks.filter((mark)=>mark.type === markType);
                const prevAttrs = oldMarks.length ? oldMarks[0].attrs : undefined;
                const newAttrs = getAttrs(prevAttrs, node);
                if (newAttrs !== undefined) {
                    tr.setNodeMarkup(pos, node.type, node.attrs, node.marks.filter((mark)=>!markType.excludes(mark.type)).concat(newAttrs === false ? [] : markType.create(newAttrs)));
                    tr.setSelection((0, $3lIcL.NodeSelection).create(tr.doc, state.selection.from));
                    markApplied = true;
                }
            }
            return;
        });
        return markApplied;
    };
const $401855f8a07ae14f$export$72d6145976985e8c = (markType, getAttrs, allowedBlocks)=>(state, dispatch)=>{
        let markApplied = false;
        const tr = state.tr;
        const toggleBlockMarkOnRange = $401855f8a07ae14f$export$1115c4cf51ae1924(markType, getAttrs, allowedBlocks);
        if (state.selection instanceof (0, $cwzAY.CellSelection)) state.selection.forEachCell((cell, pos)=>{
            markApplied = toggleBlockMarkOnRange(pos, pos + cell.nodeSize, tr, state);
        });
        else {
            const { from: from, to: to } = state.selection;
            markApplied = toggleBlockMarkOnRange(from, to, tr, state);
        }
        if (markApplied && tr.docChanged) {
            if (dispatch) dispatch(tr.scrollIntoView());
            return true;
        }
        return false;
    };
const $401855f8a07ae14f$export$59c0bf8874edecc7 = (state, dispatch)=>{
    const tr = state.tr;
    tr.replace(0, state.doc.nodeSize - 2);
    tr.setSelection((0, $3lIcL.Selection).atStart(tr.doc));
    if (dispatch) {
        dispatch(tr);
        return true;
    }
    return false;
};
function $401855f8a07ae14f$export$ad1078cb3917e860($pos) {
    // parent is non-isolating, so we can look across this boundary
    if (!$pos.parent.type.spec.isolating) // search up the tree from the pos's *parent*
    for(let i = $pos.depth - 1; i >= 0; i--){
        // starting from the inner most node's parent, find out
        // if we're not its first child
        if ($pos.index(i) > 0) return $pos.doc.resolve($pos.before(i + 1));
        if ($pos.node(i).type.spec.isolating) break;
    }
    return null;
}
function $401855f8a07ae14f$export$c6a04dca1ed03a3c(level) {
    return function(state, dispatch) {
        const { selection: selection, schema: schema, tr: tr } = state;
        const ranges = selection instanceof (0, $cwzAY.CellSelection) ? selection.ranges : [
            selection
        ];
        ranges.forEach(({ $from: $from, $to: $to })=>{
            tr.setBlockType($from.pos, $to.pos, schema.nodes.heading, {
                level: level
            });
        });
        if (dispatch) dispatch(tr);
        return true;
    };
}

});
parcelRegister("piMVJ", function(module, exports) {

$parcel$export(module.exports, "insertBlock", () => $30b8ddabf0c2d0be$export$f51280337625031);

var $3lIcL = parcelRequire("3lIcL");

var $BmspC = parcelRequire("BmspC");
const $30b8ddabf0c2d0be$export$f51280337625031 = (state, nodeType, start, end, // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
attrs)=>{
    // To ensure that match is done after HardBreak.
    const { hardBreak: hardBreak, codeBlock: codeBlock, listItem: listItem } = state.schema.nodes;
    const $pos = state.doc.resolve(start);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    if ($pos.nodeAfter.type !== hardBreak) return null;
    // To ensure no nesting is done. (unless we're inserting a codeBlock inside lists)
    if ($pos.depth > 1 && !(nodeType === codeBlock && (0, $BmspC.hasParentNodeOfType)(listItem)(state.selection))) return null;
    // Split at the start of autoformatting and delete formatting characters.
    let tr = state.tr.delete(start, end).split(start);
    let currentNode = tr.doc.nodeAt(start + 1);
    // If node has more content split at the end of autoformatting.
    let nodeHasMoreContent = false;
    tr.doc.nodesBetween(start, start + currentNode.nodeSize, (node, pos)=>{
        if (!nodeHasMoreContent && node.type === hardBreak) {
            nodeHasMoreContent = true;
            tr = tr.split(pos + 1).delete(pos, pos + 1);
        }
    });
    if (nodeHasMoreContent) currentNode = tr.doc.nodeAt(start + 1);
    // Create new node and fill with content of current node.
    const { blockquote: blockquote, paragraph: paragraph } = state.schema.nodes;
    let content;
    let depth;
    if (nodeType === blockquote) {
        depth = 3;
        content = [
            paragraph.create({}, currentNode.content)
        ];
    } else {
        depth = 2;
        content = currentNode.content;
    }
    const newNode = nodeType.create(attrs, content);
    // Add new node.
    tr = tr.setSelection(new (0, $3lIcL.NodeSelection)(tr.doc.resolve(start + 1)))// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    .replaceSelectionWith(newNode).setSelection(new (0, $3lIcL.TextSelection)(tr.doc.resolve(start + depth)));
    return tr;
};

});


parcelRegister("gEqKI", function(module, exports) {

$parcel$export(module.exports, "setSelectionTopLevelBlocks", () => $a7c226ba21b437a8$export$1b305efb24649ca5);
$parcel$export(module.exports, "setGapCursorAtPos", () => $a7c226ba21b437a8$export$44fdd7840a0a11f2);

var $3lIcL = parcelRequire("3lIcL");

var $6BNUN = parcelRequire("6BNUN");

var $8TSsQ = parcelRequire("8TSsQ");
// This function captures clicks outside of the ProseMirror contentEditable area
// see also description of "handleClick" in gap-cursor pm-plugin
const $a7c226ba21b437a8$var$captureCursorCoords = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
event, editorRef, posAtCoords, tr)=>{
    const rect = editorRef.getBoundingClientRect();
    // capture clicks before the first block element
    if (event.clientY < rect.top) return {
        position: 0,
        side: (0, $6BNUN.Side).LEFT
    };
    if (rect.left > 0) {
        // calculate start position of a node that is vertically at the same level
        const coords = posAtCoords({
            left: rect.left,
            top: event.clientY
        });
        if (coords && coords.inside > -1) {
            const $from = tr.doc.resolve(coords.inside);
            const start = $from.before(1);
            const side = event.clientX < rect.left ? (0, $6BNUN.Side).LEFT : (0, $6BNUN.Side).RIGHT;
            let position;
            if (side === (0, $6BNUN.Side).LEFT) position = start;
            else {
                const node = tr.doc.nodeAt(start);
                if (node) position = start + node.nodeSize;
            }
            return {
                position: position,
                side: side
            };
        }
    }
    return null;
};
const $a7c226ba21b437a8$export$1b305efb24649ca5 = (tr, // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
event, editorRef, posAtCoords, editorFocused)=>{
    const cursorCoords = $a7c226ba21b437a8$var$captureCursorCoords(event, editorRef, posAtCoords, tr);
    if (!cursorCoords) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const $pos = cursorCoords.position !== undefined ? tr.doc.resolve(cursorCoords.position) : null;
    if ($pos === null) return;
    const isGapCursorAllowed = cursorCoords.side === (0, $6BNUN.Side).LEFT ? (0, $8TSsQ.isValidTargetNode)($pos.nodeAfter) : (0, $8TSsQ.isValidTargetNode)($pos.nodeBefore);
    if (isGapCursorAllowed && (0, $6BNUN.GapCursorSelection).valid($pos)) {
        // this forces PM to re-render the decoration node if we change the side of the gap cursor, it doesn't do it by default
        if (tr.selection instanceof (0, $6BNUN.GapCursorSelection)) tr.setSelection((0, $3lIcL.Selection).near($pos));
        else tr.setSelection(new (0, $6BNUN.GapCursorSelection)($pos, cursorCoords.side));
    } else if (editorFocused === false) {
        const selectionTemp = (0, $3lIcL.Selection).findFrom($pos, cursorCoords.side === (0, $6BNUN.Side).LEFT ? 1 : -1, true);
        if (selectionTemp) tr.setSelection(selectionTemp);
    }
};
const $a7c226ba21b437a8$export$44fdd7840a0a11f2 = (position, side = (0, $6BNUN.Side).LEFT)=>(state, dispatch)=>{
        // @see ED-6231
        if (position > state.doc.content.size) return false;
        const $pos = state.doc.resolve(position);
        if ((0, $6BNUN.GapCursorSelection).valid($pos)) {
            if (dispatch) dispatch(state.tr.setSelection(new (0, $6BNUN.GapCursorSelection)($pos, side)));
            return true;
        }
        return false;
    };

});
parcelRegister("6BNUN", function(module, exports) {

$parcel$export(module.exports, "Side", () => $99eae554af83c227$export$80a00690bda7f17e);
$parcel$export(module.exports, "JSON_ID", () => $99eae554af83c227$export$d9f9f34e18094ffd);
$parcel$export(module.exports, "GapCursorSelection", () => $99eae554af83c227$export$7d98c58ca1423246);

var $3xw6l = parcelRequire("3xw6l");

var $3lIcL = parcelRequire("3lIcL");

var $8TSsQ = parcelRequire("8TSsQ");
var $99eae554af83c227$export$80a00690bda7f17e = /*#__PURE__*/ function(Side) {
    Side["LEFT"] = "left";
    Side["RIGHT"] = "right";
    return Side;
}({});
const $99eae554af83c227$export$d9f9f34e18094ffd = 'gapcursor';
class $99eae554af83c227$export$7d98c58ca1423246 extends (0, $3lIcL.Selection) {
    /**
	 * Construct a GapCursorSelection
	 * @param {ResolvedPos} $pos resolved position
	 * @param {Side} side side where the gap cursor is drawn
	 */ constructor($pos, side = "left"){
        super($pos, $pos), this.side = side, this.visible = false;
    }
    static valid($pos) {
        const { parent: parent, nodeBefore: nodeBefore, nodeAfter: nodeAfter } = $pos;
        const targetNode = (0, $8TSsQ.isValidTargetNode)(nodeBefore) ? nodeBefore : (0, $8TSsQ.isValidTargetNode)(nodeAfter) ? nodeAfter : null;
        if (!targetNode || parent.isTextblock) return false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const deflt = parent.contentMatchAt($pos.index()).defaultType;
        return deflt && deflt.isTextblock;
    }
    static findFrom($pos, dir, mustMove = false) {
        const side = dir === 1 ? "right" : "left";
        if (!mustMove && $99eae554af83c227$export$7d98c58ca1423246.valid($pos)) return new $99eae554af83c227$export$7d98c58ca1423246($pos, side);
        let pos = $pos.pos;
        // TODO: ED-5048 - Fix any, potential issue.
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let next = null;
        // Scan up from this position
        for(let d = $pos.depth;; d--){
            const parent = $pos.node(d);
            if (side === "right" ? $pos.indexAfter(d) < parent.childCount : $pos.index(d) > 0) {
                next = parent.maybeChild(side === "right" ? $pos.indexAfter(d) : $pos.index(d) - 1);
                break;
            } else if (d === 0) return null;
            pos += dir;
            const $cur = $pos.doc.resolve(pos);
            if ($99eae554af83c227$export$7d98c58ca1423246.valid($cur)) return new $99eae554af83c227$export$7d98c58ca1423246($cur, side);
        }
        // And then down into the next node
        for(;;){
            next = side === "right" ? next.firstChild : next.lastChild;
            if (next === null) break;
            pos += dir;
            const $cur = $pos.doc.resolve(pos);
            if ($99eae554af83c227$export$7d98c58ca1423246.valid($cur)) return new $99eae554af83c227$export$7d98c58ca1423246($cur, side);
        }
        return null;
    }
    static fromJSON(doc, json) {
        return new $99eae554af83c227$export$7d98c58ca1423246(doc.resolve(json.pos), json.side);
    }
    map(doc, mapping) {
        const $pos = doc.resolve(mapping.map(this.head));
        return $99eae554af83c227$export$7d98c58ca1423246.valid($pos) ? new $99eae554af83c227$export$7d98c58ca1423246($pos, this.side) : (0, $3lIcL.Selection).near($pos);
    }
    eq(other) {
        return other instanceof $99eae554af83c227$export$7d98c58ca1423246 && other.head === this.head;
    }
    content() {
        return (0, $3xw6l.Slice).empty;
    }
    getBookmark() {
        return new $99eae554af83c227$export$afd2c0d75bc9ce6c(this.anchor);
    }
    toJSON() {
        return {
            pos: this.head,
            type: $99eae554af83c227$export$d9f9f34e18094ffd,
            side: this.side
        };
    }
}
(0, $3lIcL.Selection).jsonID($99eae554af83c227$export$d9f9f34e18094ffd, $99eae554af83c227$export$7d98c58ca1423246);
class $99eae554af83c227$export$afd2c0d75bc9ce6c {
    constructor(pos){
        this.pos = pos;
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    map(mapping) {
        return new $99eae554af83c227$export$afd2c0d75bc9ce6c(mapping.map(this.pos));
    }
    resolve(doc) {
        const $pos = doc.resolve(this.pos);
        return $99eae554af83c227$export$7d98c58ca1423246.valid($pos) ? new $99eae554af83c227$export$7d98c58ca1423246($pos) : (0, $3lIcL.Selection).near($pos);
    }
}

});
parcelRegister("8TSsQ", function(module, exports) {

$parcel$export(module.exports, "isValidTargetNode", () => $54676098617ff86f$export$b485b49b5e1715ef);

var $cm19r = parcelRequire("cm19r");
const $54676098617ff86f$export$b485b49b5e1715ef = (node)=>{
    return !!node && !(0, $cm19r.isIgnored)(node);
};

});
parcelRegister("cm19r", function(module, exports) {

$parcel$export(module.exports, "isIgnored", () => $d6040c4eb752c505$export$ac3f691269cd6d9b);
// we don't show gap cursor for those nodes
const $d6040c4eb752c505$var$IGNORED_NODES = [
    'paragraph',
    'bulletList',
    'orderedList',
    'listItem',
    'taskItem',
    'decisionItem',
    'heading',
    'blockquote',
    'layoutColumn',
    'caption',
    'media',
    'extensionFrame'
];
const $d6040c4eb752c505$export$ac3f691269cd6d9b = (node)=>{
    return !!node && $d6040c4eb752c505$var$IGNORED_NODES.indexOf(node.type.name) !== -1;
};

});




parcelRegister("g0hAu", function(module, exports) {

$parcel$export(module.exports, "ignoreAttribute", () => $12f311670fb11a3b$export$72d101e93c081651);
$parcel$export(module.exports, "contentComponentClickWrapper", () => $12f311670fb11a3b$export$57a965c23051130d);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");
const $12f311670fb11a3b$export$72d101e93c081651 = 'data-editor-content-component';
const $12f311670fb11a3b$export$57a965c23051130d = (reactComponents)=>{
    if (!(0, $eGOwo.fg)('platform_editor_content_component_ignore_click')) return reactComponents;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-editor-content-component": 'true',
        children: reactComponents
    });
};

});



parcelRegister("8NyYn", function(module, exports) {

$parcel$export(module.exports, "getPrimaryToolbarComponents", () => $8b360cf558a33077$export$f454e86f6cef71f4);

var $eGOwo = parcelRequire("eGOwo");
const $8b360cf558a33077$export$f454e86f6cef71f4 = (editorAPI, components)=>{
    if ((0, $eGOwo.fg)('platform_editor_setup_editorapi_sync')) return {
        components: components ?? editorAPI?.primaryToolbar?.sharedState.currentState()?.components
    };
    return {
        components: components
    };
};

});

parcelRegister("83GXu", function(module, exports) {

$parcel$export(module.exports, "ToolbarWithSizeDetector", () => $2f7ab9153867bb66$export$6bb21858343ac39d);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $fNh22 = parcelRequire("fNh22");

var $aBsWC = parcelRequire("aBsWC");

var $7yBx7 = parcelRequire("7yBx7");

var $AIyOt = parcelRequire("AIyOt");

var $cbSL1 = parcelRequire("cbSL1");

var $gMRLG = parcelRequire("gMRLG");

var $7uu4v = parcelRequire("7uu4v");

var $6caZI = parcelRequire("6caZI");

var $5DVwo = parcelRequire("5DVwo");

var $lUsTM = parcelRequire("lUsTM");
function $2f7ab9153867bb66$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Remove when platform_editor_core_static_emotion is cleaned up
const $2f7ab9153867bb66$var$toolbar = /*#__PURE__*/ (0, $1NIU8.css)({
    width: '100%',
    position: 'relative',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${0, $7yBx7.akEditorMobileMaxWidth}px)`]: {
        gridColumn: '1 / 2',
        gridRow: 2,
        width: 'calc(100% - 30px)',
        margin: `0 ${"var(--ds-space-200, 16px)"}`
    }
});
// Rename to toolbar when platform_editor_core_static_emotion is cleaned up
const $2f7ab9153867bb66$var$staticToolbar = {
    name: "n48rgu",
    styles: "width:100%;position:relative"
};
const $2f7ab9153867bb66$var$DynamicStyleToolbarWithSizeDetector = (props)=>{
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef(null);
    const [width, setWidth] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState(undefined);
    const elementWidth = (0, $6caZI.useElementWidth)(ref, {
        skip: typeof width !== 'undefined'
    });
    const defaultToolbarSize = (0, $fNh22.isSSR)() && (0, $7uu4v.isFullPage)(props.appearance) ? (0, $aBsWC.ToolbarSize).XXL : undefined;
    const toolbarSize = typeof width === 'undefined' && typeof elementWidth === 'undefined' ? defaultToolbarSize : // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $lUsTM.widthToToolbarSize)(width || elementWidth, props.appearance);
    const toolbarStyle = (0, $eJOHy.useMemo)(()=>{
        const toolbarWidth = (0, $7uu4v.isFullPage)(props.appearance) && props.twoLineEditorToolbar ? (0, $aBsWC.ToolbarSize).S : (0, $aBsWC.ToolbarSize).M;
        const toolbarMinWidth = (0, $lUsTM.toolbarSizeToWidth)(toolbarWidth, props.appearance);
        const minWidth = `min-width: ${props.hasMinWidth ? toolbarMinWidth : '254'}px`;
        return [
            $2f7ab9153867bb66$var$toolbar,
            minWidth
        ];
    }, [
        props.appearance,
        props.hasMinWidth,
        props.twoLineEditorToolbar
    ]);
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: toolbarStyle
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $gMRLG.WidthObserver), {
        setWidth: setWidth
    }), props.editorView && toolbarSize ? // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $1NIU8.jsx)((0, $5DVwo.Toolbar), {
        ...props,
        toolbarSize: toolbarSize
    }) : /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        ref: ref
    })));
};
const $2f7ab9153867bb66$var$StaticStyleToolbarWithSizeDetector = (props)=>{
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef(null);
    const [width, setWidth] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState(undefined);
    const elementWidth = (0, $6caZI.useElementWidth)(ref, {
        skip: typeof width !== 'undefined'
    });
    const defaultToolbarSize = (0, $fNh22.isSSR)() && (0, $7uu4v.isFullPage)(props.appearance) ? (0, $aBsWC.ToolbarSize).XXL : undefined;
    const toolbarSize = typeof width === 'undefined' && typeof elementWidth === 'undefined' ? defaultToolbarSize : // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $lUsTM.widthToToolbarSize)(width || elementWidth, props.appearance);
    const minWidthValue = (0, $eJOHy.useMemo)(()=>{
        if (props.hasMinWidth) {
            const toolbarWidth = (0, $7uu4v.isFullPage)(props.appearance) && props.twoLineEditorToolbar ? (0, $aBsWC.ToolbarSize).S : (0, $aBsWC.ToolbarSize).M;
            return (0, $lUsTM.toolbarSizeToWidth)(toolbarWidth, props.appearance);
        } else return 254;
    }, [
        props.appearance,
        props.hasMinWidth,
        props.twoLineEditorToolbar
    ]);
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $2f7ab9153867bb66$var$staticToolbar,
        style: {
            minWidth: `${minWidthValue}px`
        }
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $gMRLG.WidthObserver), {
        setWidth: setWidth
    }), props.editorView && toolbarSize ? /*#__PURE__*/ (0, $1NIU8.jsx)((0, $5DVwo.Toolbar), {
        toolbarSize: toolbarSize,
        items: props.items,
        editorView: props.editorView,
        editorActions: props.editorActions,
        eventDispatcher: props.eventDispatcher,
        providerFactory: props.providerFactory,
        appearance: props.appearance,
        popupsMountPoint: props.popupsMountPoint,
        popupsBoundariesElement: props.popupsBoundariesElement,
        popupsScrollableElement: props.popupsScrollableElement,
        disabled: props.disabled,
        dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
        containerElement: props.containerElement,
        hasMinWidth: props.hasMinWidth,
        twoLineEditorToolbar: props.twoLineEditorToolbar
    }) : /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        ref: ref
    }));
};
const $2f7ab9153867bb66$export$6bb21858343ac39d = (0, $AIyOt.componentWithCondition)(()=>(0, $cbSL1.expValEquals)('platform_editor_core_static_emotion_non_central', 'isEnabled', true), $2f7ab9153867bb66$var$StaticStyleToolbarWithSizeDetector, $2f7ab9153867bb66$var$DynamicStyleToolbarWithSizeDetector);

});
parcelRegister("7uu4v", function(module, exports) {

$parcel$export(module.exports, "isFullPage", () => $95a6cae108f6bd6d$export$2800a15841f40ad7);
function $95a6cae108f6bd6d$export$2800a15841f40ad7(appearance) {
    return appearance === 'full-page' || appearance === 'full-width';
}

});

parcelRegister("6caZI", function(module, exports) {

$parcel$export(module.exports, "useElementWidth", () => $c781e6aa3a282142$export$1217913212f99c7);

var $eJOHy = parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");
const $c781e6aa3a282142$export$1217913212f99c7 = (ref, { skip: skip })=>{
    const [elementWidth, setWidth] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState(undefined);
    (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useEffect(()=>{
        if (!skip && ref.current && !(0, $eGOwo.fg)('platform_editor_prevent_toolbar_width_reflow')) setWidth(Math.round(ref.current.getBoundingClientRect().width));
    }, [
        skip,
        setWidth,
        ref
    ]);
    return elementWidth;
};

});

parcelRegister("5DVwo", function(module, exports) {

$parcel$export(module.exports, "Toolbar", () => $1cf27d3b03d64cbb$export$4c260019440d418f);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $aBsWC = parcelRequire("aBsWC");

var $c7es2 = parcelRequire("c7es2");
const $1cf27d3b03d64cbb$export$4c260019440d418f = (props)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $c7es2.ToolbarInner), {
        items: props.items,
        editorView: props.editorView,
        editorActions: props.editorActions,
        eventDispatcher: props.eventDispatcher,
        providerFactory: props.providerFactory,
        appearance: props.appearance,
        popupsMountPoint: props.popupsMountPoint,
        popupsBoundariesElement: props.popupsBoundariesElement,
        popupsScrollableElement: props.popupsScrollableElement,
        disabled: props.disabled,
        dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
        toolbarSize: props.toolbarSize,
        isToolbarReducedSpacing: props.toolbarSize < (0, $aBsWC.ToolbarSize).XXL,
        containerElement: props.containerElement
    });
};

});
parcelRegister("c7es2", function(module, exports) {

$parcel$export(module.exports, "ToolbarInner", () => $2736648cc3a08310$export$7c77e89663c6a665);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $cSmYj = parcelRequire("cSmYj");

var $fNh22 = parcelRequire("fNh22");

var $7yBx7 = parcelRequire("7yBx7");
const $2736648cc3a08310$var$toolbarComponentsWrapper = /*#__PURE__*/ (0, $1NIU8.css)({
    display: 'flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${0, $7yBx7.akEditorMobileMaxWidth}px)`]: {
        justifyContent: 'space-between'
    }
});
class $2736648cc3a08310$export$7c77e89663c6a665 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    shouldComponentUpdate(nextProps) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(nextProps, this.props);
    }
    render() {
        const { appearance: appearance, editorView: editorView, editorActions: editorActions, eventDispatcher: eventDispatcher, providerFactory: providerFactory, items: items, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, toolbarSize: toolbarSize, disabled: disabled, isToolbarReducedSpacing: isToolbarReducedSpacing, dispatchAnalyticsEvent: dispatchAnalyticsEvent, containerElement: containerElement } = this.props;
        if (!items || !items.length) return null;
        if ((0, $fNh22.isSSR)()) // Toolbar in SSR environment is showing collapsed state, which caused layout shift after hydrating to SPA.
        // Hiding toolbar in SSR until the dependency of screen width is resolved in SSR environment.
        return null;
        return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            css: $2736648cc3a08310$var$toolbarComponentsWrapper,
            "data-vc": "toolbar-inner"
        }, items.map((component, key)=>{
            const element = component({
                editorView: editorView,
                editorActions: editorActions,
                eventDispatcher: eventDispatcher,
                providerFactory: providerFactory,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                appearance: appearance,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement,
                disabled: disabled,
                toolbarSize: toolbarSize,
                isToolbarReducedSpacing: isToolbarReducedSpacing,
                containerElement: containerElement,
                isLastItem: key === items.length - 1,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                wrapperElement: null
            });
            return element && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).cloneElement(element, {
                key: key
            });
        }));
    }
}

});


parcelRegister("lUsTM", function(module, exports) {

$parcel$export(module.exports, "toolbarSizeToWidth", () => $9fb6e1b7a31d0594$export$df8e48f984163082);
$parcel$export(module.exports, "widthToToolbarSize", () => $9fb6e1b7a31d0594$export$886398ab6922a80f);

var $aBsWC = parcelRequire("aBsWC");

var $eGOwo = parcelRequire("eGOwo");

var $7uu4v = parcelRequire("7uu4v");
// Toolbar sizes for full page editor a little bit different, because it has more buttons e.g. actions button...
const $9fb6e1b7a31d0594$var$toolbarSizesFullPageNext = [
    {
        width: (0, $aBsWC.ToolbarWidthsFullPageNext).XXL,
        size: (0, $aBsWC.ToolbarSize).XXL
    },
    {
        width: (0, $aBsWC.ToolbarWidthsFullPageNext).XL,
        size: (0, $aBsWC.ToolbarSize).XL
    },
    {
        width: (0, $aBsWC.ToolbarWidthsFullPageNext).L,
        size: (0, $aBsWC.ToolbarSize).L
    },
    {
        width: (0, $aBsWC.ToolbarWidthsFullPageNext).M,
        size: (0, $aBsWC.ToolbarSize).M
    },
    {
        width: (0, $aBsWC.ToolbarWidthsFullPageNext).S,
        size: (0, $aBsWC.ToolbarSize).S
    }
];
// eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
/** @deprecated
 * To be removed as part of ED-25129 in favour of toolbarSizesFullPageNext along with references
 * to platform_editor_toolbar_responsive_fixes feature gate
 */ const $9fb6e1b7a31d0594$var$toolbarSizesFullPage = [
    {
        width: (0, $aBsWC.ToolbarWidthsFullPage).XXL,
        size: (0, $aBsWC.ToolbarSize).XXL
    },
    {
        width: (0, $aBsWC.ToolbarWidthsFullPage).XL,
        size: (0, $aBsWC.ToolbarSize).XL
    },
    {
        width: (0, $aBsWC.ToolbarWidthsFullPage).L,
        size: (0, $aBsWC.ToolbarSize).L
    },
    {
        width: (0, $aBsWC.ToolbarWidthsFullPage).M,
        size: (0, $aBsWC.ToolbarSize).M
    },
    {
        width: (0, $aBsWC.ToolbarWidthsFullPage).S,
        size: (0, $aBsWC.ToolbarSize).S
    }
];
const $9fb6e1b7a31d0594$var$toolbarSizesNext = [
    {
        width: (0, $aBsWC.ToolbarWidthsNext).XXL,
        size: (0, $aBsWC.ToolbarSize).XXL
    },
    {
        width: (0, $aBsWC.ToolbarWidthsNext).XL,
        size: (0, $aBsWC.ToolbarSize).XL
    },
    {
        width: (0, $aBsWC.ToolbarWidthsNext).L,
        size: (0, $aBsWC.ToolbarSize).L
    },
    {
        width: (0, $aBsWC.ToolbarWidthsNext).M,
        size: (0, $aBsWC.ToolbarSize).M
    },
    {
        width: (0, $aBsWC.ToolbarWidthsNext).S,
        size: (0, $aBsWC.ToolbarSize).S
    }
];
// eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
/** @deprecated
 * To be removed as part of ED-25129 in favour of toolbarSizesNext along with references
 * to platform_editor_toolbar_responsive_fixes feature gate
 */ const $9fb6e1b7a31d0594$var$toolbarSizes = [
    {
        width: (0, $aBsWC.ToolbarWidths).XXL,
        size: (0, $aBsWC.ToolbarSize).XXL
    },
    {
        width: (0, $aBsWC.ToolbarWidths).XL,
        size: (0, $aBsWC.ToolbarSize).XL
    },
    {
        width: (0, $aBsWC.ToolbarWidths).L,
        size: (0, $aBsWC.ToolbarSize).L
    },
    {
        width: (0, $aBsWC.ToolbarWidths).M,
        size: (0, $aBsWC.ToolbarSize).M
    },
    {
        width: (0, $aBsWC.ToolbarWidths).S,
        size: (0, $aBsWC.ToolbarSize).S
    }
];
const $9fb6e1b7a31d0594$var$toolbarSizesForAppearance = (appearance)=>(0, $7uu4v.isFullPage)(appearance) ? (0, $eGOwo.fg)('platform_editor_toolbar_responsive_fixes') ? $9fb6e1b7a31d0594$var$toolbarSizesFullPageNext : $9fb6e1b7a31d0594$var$toolbarSizesFullPage : (0, $eGOwo.fg)('platform_editor_toolbar_responsive_fixes') ? $9fb6e1b7a31d0594$var$toolbarSizesNext : $9fb6e1b7a31d0594$var$toolbarSizes;
const $9fb6e1b7a31d0594$export$df8e48f984163082 = (toolbarSize, appearance)=>{
    return ($9fb6e1b7a31d0594$var$toolbarSizesForAppearance(appearance).find(({ size: size })=>toolbarSize === size) || {
        width: (0, $aBsWC.ToolbarWidths).S
    }).width;
};
const $9fb6e1b7a31d0594$export$886398ab6922a80f = (toolbarWidth, appearance)=>{
    return ($9fb6e1b7a31d0594$var$toolbarSizesForAppearance(appearance).find(({ width: width })=>toolbarWidth > width) || {
        size: (0, $aBsWC.ToolbarSize).XXXS
    }).size;
};

});


parcelRegister("xxDMM", function(module, exports) {

$parcel$export(module.exports, "MainToolbar", () => $cdffe18353f994db$export$f7e5e5a2fbd99270);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $eGOwo = parcelRequire("eGOwo");

var $cbSL1 = parcelRequire("cbSL1");
function $cdffe18353f994db$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $cdffe18353f994db$var$MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT = 490;
const $cdffe18353f994db$var$akEditorMenuZIndex = 500;
const $cdffe18353f994db$var$akEditorToolbarKeylineHeight = 2;
/* eslint-disable @atlaskit/platform/ensure-feature-flag-registration */ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Needs manual remediation
const $cdffe18353f994db$var$mainToolbarWrapperStyle = (isTwoLineEditorToolbar = false)=>/*#__PURE__*/ (0, $1NIU8.css)("position:relative;align-items:center;padding:var(--ds-space-100, 8px) var(--ds-space-100, 8px) 0;display:flex;height:auto;background-color:var(--ds-surface, white);box-shadow:none;padding-left:var(--ds-space-250, 20px);&>div{", isTwoLineEditorToolbar && `
        @media (max-width: ${$cdffe18353f994db$var$MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT}px) {
          flex-direction: column-reverse;
          align-items: end;
          display: flex;
          justify-content: flex-end;
        }

        /* make this more explicit for a toolbar */
        > *:nth-child(1) {
          @media (max-width: ${$cdffe18353f994db$var$MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT}px) {
            > div:nth-child(2) {
              justify-content: flex-end;
              display: flex;
            }
          }
        }
    `, ";>:first-child:not(style),>style:first-child+*{margin-left:0;}}.block-type-btn{padding-left:0;}", (0, $eGOwo.fg)('platform-visual-refresh-icons') && 'span svg { max-width: 100%; }', ";");
const $cdffe18353f994db$var$mainToolbarWrapperStyleNew = /*#__PURE__*/ (0, $1NIU8.css)({
    position: 'relative',
    alignItems: 'center',
    padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"} 0`,
    display: 'flex',
    height: 'auto',
    backgroundColor: "var(--ds-surface, white)",
    boxShadow: 'none',
    paddingLeft: "var(--ds-space-250, 20px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '> div': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> div:first-of-type:not(style), > style:first-of-type + *': {
            marginLeft: 0
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.block-type-btn': {
        paddingLeft: 0
    }
});
const $cdffe18353f994db$var$mainToolbarTwoLineStylesNew = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '& > div': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        [`@media (max-width: ${$cdffe18353f994db$var$MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT}px)`]: {
            flexDirection: 'column-reverse',
            alignItems: 'end',
            display: 'flex',
            justifyContent: 'flex-end'
        },
        /* make this more explicit for a toolbar */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> div:first-of-type': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            [`@media (max-width: ${$cdffe18353f994db$var$MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT}px)`]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
                '> div:nth-of-type(2)': {
                    justifyContent: 'flex-end',
                    display: 'flex'
                }
            }
        }
    }
});
const $cdffe18353f994db$var$mainToolbarWrapperStylesVisualRefresh = {
    name: "y5dbpb",
    styles: "span svg{max-width:100%;}"
};
/* eslint-enable @atlaskit/platform/ensure-feature-flag-registration */ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $cdffe18353f994db$var$stickyToolbarWrapperStyle = /*#__PURE__*/ (0, $1NIU8.css)("position:relative;position:sticky;padding-bottom:var(--ds-space-100, 8px);z-index:", $cdffe18353f994db$var$akEditorMenuZIndex, ";transition:box-shadow ease-in-out 0.2s;&.show-keyline{box-shadow:0 ", $cdffe18353f994db$var$akEditorToolbarKeylineHeight, "px 0 0 var(--ds-background-accent-gray-subtlest, #F1F2F4);}");
const $cdffe18353f994db$var$stickyToolbarWrapperStyleNew = /*#__PURE__*/ (0, $1NIU8.css)({
    position: 'sticky',
    paddingBottom: "var(--ds-space-100, 8px)",
    zIndex: $cdffe18353f994db$var$akEditorMenuZIndex,
    transition: 'box-shadow ease-in-out 0.2s',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '&.show-keyline': {
        boxShadow: `0 ${$cdffe18353f994db$var$akEditorToolbarKeylineHeight}px 0 0 ${"var(--ds-background-accent-gray-subtlest, #F1F2F4)"}`
    }
});
const $cdffe18353f994db$var$StickyToolbar = (props)=>{
    const [top, setTop] = (0, $eJOHy.useState)(0);
    // ED-15802: if externalToolbarRef is passed in, set top to externalToolbarRef?.current?.clientHeight
    // else if offsetTop is a number set top to offsetTop
    // otherwise top is 0 as initial state
    (0, $eJOHy.useEffect)(()=>{
        if (props.externalToolbarRef?.current?.clientHeight) setTop(props.externalToolbarRef.current.clientHeight);
        else setTop(props.offsetTop || 0);
    }, [
        props.externalToolbarRef,
        props.offsetTop
    ]);
    return(// eslint-disable-next-line @atlaskit/design-system/prefer-primitives
    /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: (0, $cbSL1.expValEquals)('platform_editor_core_static_emotion_non_central', 'isEnabled', true) ? [
            $cdffe18353f994db$var$mainToolbarWrapperStyleNew,
            props.twoLineEditorToolbar && $cdffe18353f994db$var$mainToolbarTwoLineStylesNew,
            (0, $eGOwo.fg)('platform-visual-refresh-icons') && $cdffe18353f994db$var$mainToolbarWrapperStylesVisualRefresh,
            $cdffe18353f994db$var$stickyToolbarWrapperStyleNew
        ] : // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        [
            $cdffe18353f994db$var$mainToolbarWrapperStyle(props.twoLineEditorToolbar),
            $cdffe18353f994db$var$stickyToolbarWrapperStyle
        ],
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
        style: {
            top: `${top}px`
        },
        "data-testid": "ak-editor-main-toolbar",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: 'show-keyline'
    }, props.children));
};
const $cdffe18353f994db$var$FixedToolbar = (props)=>// eslint-disable-next-line @atlaskit/design-system/prefer-primitives
    /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: (0, $cbSL1.expValEquals)('platform_editor_core_static_emotion_non_central', 'isEnabled', true) ? [
            $cdffe18353f994db$var$mainToolbarWrapperStyleNew,
            props.twoLineEditorToolbar && $cdffe18353f994db$var$mainToolbarTwoLineStylesNew,
            (0, $eGOwo.fg)('platform-visual-refresh-icons') && $cdffe18353f994db$var$mainToolbarWrapperStylesVisualRefresh
        ] : // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        $cdffe18353f994db$var$mainToolbarWrapperStyle(props.twoLineEditorToolbar),
        "data-testid": "ak-editor-main-toolbar"
    }, props.children);
/**
 * ED-15802: Scenarios when a sticky bar is used:
 * 1. useStickyToolbar is true
 * 2. useStickyToolbar is a DOM element
 * 3. useStickyToolbar is an object and has offsetTop key;
 */ const $cdffe18353f994db$var$getStickyParameters = (configuration)=>{
    // const isUsingStickyOffset, isHTMLElement is used so TS can properly infer types.
    const isHTMLElement = typeof configuration === 'object' && !('offsetTop' in configuration);
    const isUsingStickyOffset = typeof configuration === 'object' && 'offsetTop' in configuration;
    if (typeof configuration !== 'object') return {
        externalToolbarRef: undefined,
        offsetTop: undefined
    };
    if (isUsingStickyOffset) return {
        offsetTop: configuration.offsetTop
    };
    if (isHTMLElement) return {
        externalToolbarRef: configuration
    };
};
const $cdffe18353f994db$export$f7e5e5a2fbd99270 = ({ useStickyToolbar: useStickyToolbar, twoLineEditorToolbar: twoLineEditorToolbar, children: children })=>{
    if (useStickyToolbar) return /*#__PURE__*/ (0, $1NIU8.jsx)($cdffe18353f994db$var$StickyToolbar, {
        ...$cdffe18353f994db$var$getStickyParameters(useStickyToolbar),
        twoLineEditorToolbar: twoLineEditorToolbar
    }, children);
    return /*#__PURE__*/ (0, $1NIU8.jsx)($cdffe18353f994db$var$FixedToolbar, {
        twoLineEditorToolbar: twoLineEditorToolbar
    }, children);
};

});


parcelRegister("hjMp1", function(module, exports) {

$parcel$export(module.exports, "FullPageEditor", () => $f671905adb7a028b$export$a15423dd96de66f2);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $7EdFW = parcelRequire("7EdFW");

var $kLQ9a = parcelRequire("kLQ9a");
var $bSToC = parcelRequire("bSToC");

var $jZyjN = parcelRequire("jZyjN");

var $frlUM = parcelRequire("frlUM");

var $7yBx7 = parcelRequire("7yBx7");

var $eGOwo = parcelRequire("eGOwo");

var $92xoS = parcelRequire("92xoS");

var $8NyYn = parcelRequire("8NyYn");

var $33SIh = parcelRequire("33SIh");

var $eNwcO = parcelRequire("eNwcO");

var $jUtLl = parcelRequire("jUtLl");

var $dm5Ee = parcelRequire("dm5Ee");
const $f671905adb7a028b$var$useShowKeyline = (contentAreaRef)=>{
    const [showKeyline, setShowKeyline] = (0, $eJOHy.useState)(false);
    (0, $eJOHy.useEffect)(()=>{
        if (!contentAreaRef.current?.contentArea) return;
        const intersection = new IntersectionObserver(([entry])=>{
            setShowKeyline(!entry.isIntersecting && entry.boundingClientRect.top < entry.intersectionRect.top);
        }, {
            root: undefined,
            // Safari seems to miss events (on fast scroll) sometimes due
            // to differences in IntersectionObserver behaviour between browsers.
            // By lowering the threshold a little it gives Safari more
            // time to catch these events.
            threshold: (0, $7EdFW.browser).safari ? 0.98 : 1
        });
        intersection.observe(contentAreaRef.current.contentArea);
        return ()=>{
            intersection.disconnect();
        };
    }, [
        contentAreaRef
    ]);
    return showKeyline;
};
const $f671905adb7a028b$var$hasCustomComponents = (components)=>{
    if (!components) return false;
    if ('before' in components) return Array.isArray(components.before) && components.before.length > 0 || !!components.before || Array.isArray(components.after) && components.after.length > 0 || !!components.after;
    return true;
};
const $f671905adb7a028b$var$useFullPageEditorPluginsStates = (0, $kLQ9a.sharedPluginStateHookMigratorFactory)((pluginInjectionApi)=>{
    const sharedState = (0, $bSToC.useSharedPluginState)(pluginInjectionApi, [
        'editorViewMode',
        'primaryToolbar',
        'interaction'
    ]);
    return {
        primaryToolbarState: sharedState?.primaryToolbarState,
        editorViewModeState: sharedState?.editorViewModeState,
        interactionState: sharedState?.interactionState?.interactionState
    };
}, (pluginInjectionApi)=>{
    const primaryToolbarComponents = (0, $frlUM.useSharedPluginStateSelector)(pluginInjectionApi, 'primaryToolbar.components');
    const editorViewMode = (0, $frlUM.useSharedPluginStateSelector)(pluginInjectionApi, 'editorViewMode.mode');
    const interactionState = (0, $frlUM.useSharedPluginStateSelector)(pluginInjectionApi, 'interaction.interactionState');
    return {
        primaryToolbarState: !primaryToolbarComponents ? undefined : {
            components: primaryToolbarComponents
        },
        editorViewModeState: !editorViewMode ? undefined : {
            mode: editorViewMode
        },
        interactionState: interactionState
    };
});
const $f671905adb7a028b$export$a15423dd96de66f2 = (props)=>{
    const wrapperElementRef = (0, $eJOHy.useMemo)(()=>props.innerRef, [
        props.innerRef
    ]);
    const scrollContentContainerRef = (0, $eJOHy.useRef)(null);
    const showKeyline = $f671905adb7a028b$var$useShowKeyline(scrollContentContainerRef);
    const editorAPI = props.editorAPI;
    const { editorViewModeState: editorViewModeState, primaryToolbarState: primaryToolbarHookState, interactionState: interactionState } = $f671905adb7a028b$var$useFullPageEditorPluginsStates(editorAPI);
    const primaryToolbarState = (0, $8NyYn.getPrimaryToolbarComponents)(editorAPI, primaryToolbarHookState?.components);
    const viewMode = (0, $jUtLl.getEditorViewMode)(editorViewModeState, props.preset);
    const hasHadInteraction = interactionState !== 'hasNotHadInteraction';
    let toolbarDocking = (0, $frlUM.useSharedPluginStateSelector)(editorAPI, 'selectionToolbar.toolbarDocking', {
        disabled: (0, $eGOwo.fg)('platform_editor_use_preferences_plugin')
    });
    const { toolbarDockingPosition: toolbarDockingPosition } = (0, $frlUM.useSharedPluginStateSelector)(editorAPI, 'userPreferences.preferences', {
        disabled: !(0, $eGOwo.fg)('platform_editor_use_preferences_plugin')
    }) || {};
    if (!(0, $eGOwo.fg)('platform_editor_use_preferences_plugin')) {
        if (!toolbarDocking && (0, $eGOwo.fg)('platform_editor_controls_toolbar_ssr_fix')) {
            // This is a workaround for the rendering issue with the selection toolbar
            // where using useSharedPluginStateSelector or useSharedPluginState the state are not
            // available when the editor is first loaded. and cause the toolbar to blink.
            const defaultDocking = props.__livePage ? 'none' : 'top';
            toolbarDocking = editorAPI?.selectionToolbar?.sharedState.currentState()?.toolbarDocking ?? defaultDocking;
        }
    }
    let primaryToolbarComponents = props.primaryToolbarComponents;
    if (Array.isArray(primaryToolbarState?.components) && Array.isArray(primaryToolbarComponents)) primaryToolbarComponents = primaryToolbarState.components.concat(primaryToolbarComponents);
    let isEditorToolbarHidden = (0, $eGOwo.fg)('platform_editor_sync_editor_view_mode_state') ? viewMode === 'view' : editorViewModeState?.mode === 'view';
    const { customPrimaryToolbarComponents: customPrimaryToolbarComponents } = props;
    if ((0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1', {
        exposure: true
    })) {
        if ((0, $eGOwo.fg)('platform_editor_use_preferences_plugin')) // need to check if the toolbarDockingPosition is set to 'none' or 'top'
        {
            if (toolbarDockingPosition === 'none') {
                primaryToolbarComponents = [];
                if (!$f671905adb7a028b$var$hasCustomComponents(customPrimaryToolbarComponents)) isEditorToolbarHidden = true;
            }
        } else if ((0, $eGOwo.fg)('platform_editor_controls_toolbar_ssr_fix')) {
            if (toolbarDocking === 'none') {
                primaryToolbarComponents = [];
                if (!$f671905adb7a028b$var$hasCustomComponents(customPrimaryToolbarComponents)) isEditorToolbarHidden = true;
            }
        } else {
            if (toolbarDocking !== 'top') primaryToolbarComponents = [];
            if (!primaryToolbarComponents?.length && !$f671905adb7a028b$var$hasCustomComponents(customPrimaryToolbarComponents)) isEditorToolbarHidden = true;
        }
    }
    const popupsBoundariesElement = props.popupsBoundariesElement || scrollContentContainerRef?.current?.containerArea || undefined;
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $jZyjN.ContextPanelWidthProvider), null, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: (0, $dm5Ee.fullPageEditorWrapper),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "akEditor",
        ref: wrapperElementRef,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--ak-editor-fullpage-toolbar-height': (0, $7yBx7.FULL_PAGE_EDITOR_TOOLBAR_HEIGHT)()
        }
    }, !isEditorToolbarHidden && /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eNwcO.FullPageToolbar), {
        appearance: props.appearance,
        editorAPI: editorAPI,
        beforeIcon: props.primaryToolbarIconBefore,
        collabEdit: props.collabEdit,
        containerElement: scrollContentContainerRef.current?.scrollContainer ?? null,
        customPrimaryToolbarComponents: props.customPrimaryToolbarComponents,
        disabled: !!props.disabled,
        dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
        editorActions: props.editorActions,
        editorDOMElement: props.editorDOMElement,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        editorView: props.editorView,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        eventDispatcher: props.eventDispatcher,
        hasMinWidth: props.enableToolbarMinWidth,
        popupsBoundariesElement: props.popupsBoundariesElement,
        popupsMountPoint: props.popupsMountPoint,
        popupsScrollableElement: props.popupsScrollableElement,
        primaryToolbarComponents: primaryToolbarComponents,
        providerFactory: props.providerFactory,
        showKeyline: showKeyline,
        featureFlags: props.featureFlags
    }), /*#__PURE__*/ (0, $1NIU8.jsx)((0, $33SIh.FullPageContentArea), {
        editorAPI: editorAPI,
        ref: scrollContentContainerRef,
        appearance: props.appearance,
        contentComponents: props.contentComponents,
        contextPanel: props.contextPanel,
        customContentComponents: props.customContentComponents,
        disabled: props.disabled,
        dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
        editorActions: props.editorActions,
        editorDOMElement: props.editorDOMElement,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        editorView: props.editorView,
        eventDispatcher: props.eventDispatcher,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsMountPoint: props.popupsMountPoint,
        popupsScrollableElement: props.popupsScrollableElement,
        providerFactory: props.providerFactory,
        wrapperElement: wrapperElementRef?.current ?? null,
        pluginHooks: props.pluginHooks,
        featureFlags: props.featureFlags,
        isEditorToolbarHidden: isEditorToolbarHidden,
        viewMode: editorViewModeState?.mode,
        hasHadInteraction: hasHadInteraction
    })));
};

});
parcelRegister("jZyjN", function(module, exports) {

$parcel$export(module.exports, "ContextPanelWidthProvider", () => $24b1a0c50dab7ab4$export$ba19517e2c08f4aa);
$parcel$export(module.exports, "ContextPanelConsumer", () => $24b1a0c50dab7ab4$export$24734d8d7782a3fc);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
const $24b1a0c50dab7ab4$export$c174a7dc96b2afb8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext({
    width: 0,
    positionedOverEditor: false,
    broadcastWidth: ()=>{},
    broadcastPosition: ()=>{}
});
class $24b1a0c50dab7ab4$export$ba19517e2c08f4aa extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(props){
        super(props), this.state = {
            width: 0,
            positionedOverEditor: false
        }, this.broadcastSidebarWidth = (width)=>{
            if (width !== this.state.width) this.setState({
                width: width
            });
        }, this.broadcastPosition = (positionedOverEditor)=>{
            if (positionedOverEditor !== this.state.positionedOverEditor) this.setState({
                positionedOverEditor: positionedOverEditor
            });
        };
    }
    render() {
        const { width: width, positionedOverEditor: positionedOverEditor } = this.state;
        return /*#__PURE__*/ (0, $gt9Am.jsx)($24b1a0c50dab7ab4$export$e38af27e662e9783, {
            value: {
                width: width,
                positionedOverEditor: positionedOverEditor,
                broadcastWidth: this.broadcastSidebarWidth,
                broadcastPosition: this.broadcastPosition
            },
            children: this.props.children
        });
    }
}
const { Provider: $24b1a0c50dab7ab4$export$e38af27e662e9783, Consumer: $24b1a0c50dab7ab4$export$24734d8d7782a3fc } = $24b1a0c50dab7ab4$export$c174a7dc96b2afb8;

});

parcelRegister("33SIh", function(module, exports) {

$parcel$export(module.exports, "FullPageContentArea", () => $413fb8c44ae5e4e1$export$7db1e8e055ebd208);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");
var $loabE = parcelRequire("loabE");

var $k9JrM = parcelRequire("k9JrM");

var $6YFG2 = parcelRequire("6YFG2");

var $9FkNK = parcelRequire("9FkNK");
var $6Yq90 = parcelRequire("6Yq90");

var $1LIK6 = parcelRequire("1LIK6");
parcelRequire("62CL0");
var $2G9Kp = parcelRequire("2G9Kp");

var $7yBx7 = parcelRequire("7yBx7");


var $eGOwo = parcelRequire("eGOwo");

var $AIyOt = parcelRequire("AIyOt");

var $cbSL1 = parcelRequire("cbSL1");

var $9Letn = parcelRequire("9Letn");

var $92xoS = parcelRequire("92xoS");

var $g5n6x = parcelRequire("g5n6x");

var $g0hAu = parcelRequire("g0hAu");

var $jyiGU = parcelRequire("jyiGU");

var $lMLcG = parcelRequire("lMLcG");

var $7XjxI = parcelRequire("7XjxI");

var $gyhYD = parcelRequire("gyhYD");

var $dm5Ee = parcelRequire("dm5Ee");
function $413fb8c44ae5e4e1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $413fb8c44ae5e4e1$var$akEditorFullWidthLayoutWidth = 1800;
const $413fb8c44ae5e4e1$var$akEditorSwoopCubicBezier = `cubic-bezier(0.15, 1, 0.3, 1)`;
const $413fb8c44ae5e4e1$var$tableMarginFullWidthMode = 2;
const $413fb8c44ae5e4e1$var$akLayoutGutterOffset = 12;
const $413fb8c44ae5e4e1$var$SWOOP_ANIMATION = `0.5s ${$413fb8c44ae5e4e1$var$akEditorSwoopCubicBezier}`;
const $413fb8c44ae5e4e1$var$AK_NESTED_DND_GUTTER_OFFSET = 8;
const $413fb8c44ae5e4e1$var$getTotalPadding = ()=>(0, $7yBx7.akEditorGutterPaddingDynamic)() * 2;
// old styles - to be deleted when cleaning up experiment `platform_editor_core_static_emotion_non_central`
const $413fb8c44ae5e4e1$var$editorContentAreaStyle = ({ layoutMaxWidth: layoutMaxWidth, fullWidthMode: fullWidthMode, isEditorToolbarHidden: isEditorToolbarHidden })=>[
        $413fb8c44ae5e4e1$var$editorContentArea,
        $413fb8c44ae5e4e1$var$editorContentAreaProsemirrorStyle,
        $413fb8c44ae5e4e1$var$fullWidthNonChromelessBreakoutBlockTableStyle,
        !fullWidthMode && $413fb8c44ae5e4e1$var$editorContentAreaWithLayoutWith(layoutMaxWidth),
        // for breakout resizing, there's no need to restrict the width of codeblocks as they're always wrapped in a breakout mark
        (0, $9Letn.expValEqualsNoExposure)('platform_editor_breakout_resizing', 'isEnabled', true) && (0, $eGOwo.fg)('platform_editor_breakout_resizing_width_changes') ? $413fb8c44ae5e4e1$var$editorContentAreaContainerStyleExcludeCodeBlock() : $413fb8c44ae5e4e1$var$editorContentAreaContainerStyle(),
        ...(0, $eGOwo.fg)('platform_editor_controls_no_toolbar_space') ? [] : [
            (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1') && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
            $413fb8c44ae5e4e1$var$contentAreaReducedHeaderSpace,
            isEditorToolbarHidden && (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1') && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
            $413fb8c44ae5e4e1$var$contentAreaReservedPrimaryToolbarSpace
        ]
    ];
const $413fb8c44ae5e4e1$var$editorContentAreaWithLayoutWith = (layoutMaxWidth)=>/*#__PURE__*/ (0, $1NIU8.css)({
        // this restricts max width
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `${layoutMaxWidth + $413fb8c44ae5e4e1$var$getTotalPadding()}px`
    });
/* Prevent horizontal scroll on page in full width mode */ const $413fb8c44ae5e4e1$var$editorContentAreaContainerStyleExcludeCodeBlock = ()=>/*#__PURE__*/ (0, $1NIU8.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.fabric-editor--full-width-mode': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '.extension-container, .multiBodiedExtension--container': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                maxWidth: `calc(100% - ${$413fb8c44ae5e4e1$var$tableMarginFullWidthMode * 2}px)`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '.extension-container.inline': {
                maxWidth: '100%'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            'td .extension-container.inline': {
                maxWidth: 'inherit'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '[data-layout-section]': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                maxWidth: `calc(100% + ${($413fb8c44ae5e4e1$var$akLayoutGutterOffset + ((0, $eGOwo.fg)('platform_editor_nested_dnd_styles_changes') ? $413fb8c44ae5e4e1$var$AK_NESTED_DND_GUTTER_OFFSET : 0)) * 2}px)`
            }
        }
    });
/* Prevent horizontal scroll on page in full width mode */ const $413fb8c44ae5e4e1$var$editorContentAreaContainerStyle = ()=>/*#__PURE__*/ (0, $1NIU8.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.fabric-editor--full-width-mode': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '.code-block, .extension-container, .multiBodiedExtension--container': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                maxWidth: `calc(100% - ${$413fb8c44ae5e4e1$var$tableMarginFullWidthMode * 2}px)`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '.extension-container.inline': {
                maxWidth: '100%'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            'td .extension-container.inline': {
                maxWidth: 'inherit'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '[data-layout-section]': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                maxWidth: `calc(100% + ${($413fb8c44ae5e4e1$var$akLayoutGutterOffset + ((0, $eGOwo.fg)('platform_editor_nested_dnd_styles_changes') ? $413fb8c44ae5e4e1$var$AK_NESTED_DND_GUTTER_OFFSET : 0)) * 2}px)`
            }
        }
    });
const $413fb8c44ae5e4e1$var$editorContentArea = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '24px',
    paddingTop: "var(--ds-space-600, 48px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.ak-editor-content-area-no-toolbar &': {
        // When the toolbar is hidden, we don't want content to jump up
        // the extra 1px is to account for the border on the toolbar
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values,  @atlaskit/ui-styling-standard/no-unsafe-values
        paddingTop: `calc(${"var(--ds-space-600, 48px)"} + ${(0, $7yBx7.FULL_PAGE_EDITOR_TOOLBAR_HEIGHT)()} + 1px)`
    },
    paddingBottom: "var(--ds-space-600, 48px)",
    height: 'calc( 100% - 105px )',
    width: '100%',
    margin: 'auto',
    flexDirection: 'column',
    flexGrow: 1,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: `${$413fb8c44ae5e4e1$var$akEditorFullWidthLayoutWidth + $413fb8c44ae5e4e1$var$getTotalPadding()}px`,
    transition: `max-width ${$413fb8c44ae5e4e1$var$SWOOP_ANIMATION}`
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
(0, $2G9Kp.tableFullPageEditorStyles));
const $413fb8c44ae5e4e1$var$editorContentAreaProsemirrorStyle = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& .ProseMirror': {
        flexGrow: 1,
        boxSizing: 'border-box',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > *': {
            clear: 'both'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`> p, > ul, > ol:not(${0, $6Yq90.taskListSelector}):not(${0, $9FkNK.decisionListSelector}), > h1, > h2, > h3, > h4, > h5, > h6`]: {
            clear: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '> p:last-child': {
            marginBottom: "var(--ds-space-300, 24px)"
        }
    }
});
const $413fb8c44ae5e4e1$var$fullWidthNonChromelessBreakoutBlockTableStyle = {
    name: "bywn89",
    styles: ".fabric-editor--full-width-mode:not(:has(#chromeless-editor)){.fabric-editor-breakout-mark, .extension-container.block, .pm-table-container{width:100% !important;}.fabric-editor-breakout-mark{margin-left:unset !important;transform:none !important;}}"
};
// An additional spacing applied at the top of the content area reserving space when the primary toolbar
// is hidden – this avoids layout shift when the toolbar is toggled under the editor controls feature
const $413fb8c44ae5e4e1$var$contentAreaReservedPrimaryToolbarSpace = /*#__PURE__*/ (0, $1NIU8.css)({
    // extra 1px to account for the bottom border on the toolbar
    marginTop: `calc(${"var(--ds-space-500, 40px)"} + 1px)`
});
// A reduced top spacing applied to the content area to compensate for the reserved space at the top
// of the page when the primary toolbar is hidden under the editor controls feature
const $413fb8c44ae5e4e1$var$contentAreaReducedHeaderSpace = {
    name: "1y04g5d",
    styles: "padding-top:var(--ds-space-400, 32px)"
};
const $413fb8c44ae5e4e1$var$editorContentGutterStyle = ()=>{
    return /*#__PURE__*/ (0, $1NIU8.css)({
        boxSizing: 'border-box',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        padding: `0 ${(0, $7yBx7.akEditorGutterPaddingDynamic)()}px`
    });
};
// new styles
const $413fb8c44ae5e4e1$var$editorContentAreaNew = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '24px',
    paddingTop: "var(--ds-space-600, 48px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.ak-editor-content-area-no-toolbar &': {
        // When the toolbar is hidden, we don't want content to jump up
        // the extra 1px is to account for the border on the toolbar
        paddingTop: `calc(${"var(--ds-space-600, 48px)"} + var(--ak-editor-fullpage-toolbar-height) + 1px)`
    },
    paddingBottom: "var(--ds-space-600, 48px)",
    height: 'calc( 100% - 105px )',
    width: '100%',
    margin: 'auto',
    flexDirection: 'column',
    flexGrow: 1,
    maxWidth: 'var(--ak-editor-content-area-max-width)',
    transition: `max-width ${$413fb8c44ae5e4e1$var$SWOOP_ANIMATION}`
});
const $413fb8c44ae5e4e1$var$tableFullPageEditorStylesNew = {
    name: "1h9cr7f",
    styles: ".ProseMirror .pm-table-wrapper > table{margin-left:0;margin-right:-1px;width:100%;}"
};
const $413fb8c44ae5e4e1$var$editorContentAreaContainerNestedDndStyle = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.fabric-editor--full-width-mode': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-layout-section]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            maxWidth: `calc(100% + ${($413fb8c44ae5e4e1$var$akLayoutGutterOffset + $413fb8c44ae5e4e1$var$AK_NESTED_DND_GUTTER_OFFSET) * 2}px)`
        }
    }
});
/* Prevent horizontal scroll on page in full width mode */ const $413fb8c44ae5e4e1$var$editorContentAreaContainerStyleExcludeCodeBlockNew = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.fabric-editor--full-width-mode': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.extension-container, .multiBodiedExtension--container': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            maxWidth: `calc(100% - ${$413fb8c44ae5e4e1$var$tableMarginFullWidthMode * 2}px)`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.extension-container.inline': {
            maxWidth: '100%'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        'td .extension-container.inline': {
            maxWidth: 'inherit'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '[data-layout-section]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            maxWidth: `calc(100% + ${$413fb8c44ae5e4e1$var$akLayoutGutterOffset * 2}px)`
        }
    }
});
/* Prevent horizontal scroll on page in full width mode */ const $413fb8c44ae5e4e1$var$editorContentAreaContainerStyleNew = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.fabric-editor--full-width-mode': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.code-block, .extension-container, .multiBodiedExtension--container': {
            maxWidth: `calc(100% - ${$413fb8c44ae5e4e1$var$tableMarginFullWidthMode * 2}px)`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.extension-container.inline': {
            maxWidth: '100%'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        'td .extension-container.inline': {
            maxWidth: 'inherit'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '[data-layout-section]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            maxWidth: `calc(100% + ${$413fb8c44ae5e4e1$var$akLayoutGutterOffset * 2}px)`
        }
    }
});
const $413fb8c44ae5e4e1$var$editorContentGutterStyleFG = {
    name: "56lgh2",
    styles: "padding:0 72px"
};
const $413fb8c44ae5e4e1$var$editorContentGutterStyles = {
    name: "1h0el6e",
    styles: "box-sizing:border-box;padding:0 52px"
};
const $413fb8c44ae5e4e1$var$contentAreaNew = /*#__PURE__*/ (0, $1NIU8.css)({
    display: 'flex',
    flexDirection: 'row',
    height: `calc(100% - var(--ak-editor-fullpage-toolbar-height))`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    '&.ak-editor-content-area-no-toolbar': {
        // The editor toolbar height is 1px off (from the border) -- so we need to add 1px to the height
        // to match the toolbar height
        height: `calc(100% + 1px)`
    },
    boxSizing: 'border-box',
    margin: 0,
    padding: 0,
    transition: `padding 0ms ${$413fb8c44ae5e4e1$var$akEditorSwoopCubicBezier}`
});
const $413fb8c44ae5e4e1$var$contentAreaHeightNoToolbar = {
    name: "13udsys",
    styles: "height:100%"
};
const $413fb8c44ae5e4e1$export$81adcdb8b9fca1f7 = 'ak-editor-fp-content-area';
const $413fb8c44ae5e4e1$export$5c151fe82051a1a7 = 'ak-editor-container';
const $413fb8c44ae5e4e1$var$scrollStyles = /*#__PURE__*/ (0, $1NIU8.css)("flex-grow:1;height:100%;overflow-y:scroll;position:relative;display:flex;flex-direction:column;scroll-behavior:smooth;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
(0, $e23eba3bf6a7aed3$export$b2380b18b089518f));
const $413fb8c44ae5e4e1$export$2631a3ab3cdd158d = (0, $jyiGU.createEditorContentStyle)($413fb8c44ae5e4e1$var$scrollStyles);
$413fb8c44ae5e4e1$export$2631a3ab3cdd158d.displayName = 'ScrollContainer';
const $413fb8c44ae5e4e1$var$EditorContainer = (0, $AIyOt.componentWithCondition)(()=>(0, $92xoS.editorExperiment)('platform_editor_core_static_emotion', true, {
        exposure: true
    }), (0, $7XjxI.default), $413fb8c44ae5e4e1$export$2631a3ab3cdd158d);
const $413fb8c44ae5e4e1$var$Content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef((props, ref)=>{
    const theme = (0, $loabE.u)();
    const fullWidthMode = props.appearance === 'full-width';
    const scrollContainerRef = (0, $eJOHy.useRef)(null);
    const contentAreaRef = (0, $eJOHy.useRef)(null);
    const containerRef = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useImperativeHandle)(ref, ()=>({
            get scrollContainer () {
                return scrollContainerRef.current;
            },
            get contentArea () {
                return contentAreaRef.current;
            },
            get containerArea () {
                return containerRef.current;
            }
        }), []);
    const shouldSetHiddenDataAttribute = ()=>{
        // When platform_editor_controls_performance_fixes is enabled we use a different method to
        // determine if the toolbar is hidden from outside of the editor, which doesn't require setting
        // data-editor-primary-toolbar-hidden on the content area
        // NOTE: When tidying, this function and the data attribute can be removed
        if (!props.isEditorToolbarHidden || (0, $92xoS.editorExperiment)('platform_editor_controls_performance_fixes', true)) return false;
        return (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1');
    };
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: (0, $cbSL1.expValEquals)('platform_editor_core_static_emotion_non_central', 'isEnabled', true) ? [
            $413fb8c44ae5e4e1$var$contentAreaNew,
            props.isEditorToolbarHidden && $413fb8c44ae5e4e1$var$contentAreaHeightNoToolbar
        ] : [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $dm5Ee.contentArea),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            props.isEditorToolbarHidden && $413fb8c44ae5e4e1$var$contentAreaHeightNoToolbar
        ],
        "data-testid": $413fb8c44ae5e4e1$export$81adcdb8b9fca1f7,
        ref: containerRef
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
        (0, $dm5Ee.contentAreaWrapper),
        "data-testid": $413fb8c44ae5e4e1$export$5c151fe82051a1a7,
        "data-editor-container": 'true'
    }, /*#__PURE__*/ (0, $1NIU8.jsx)($413fb8c44ae5e4e1$var$EditorContainer, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-editor-popup-scroll-parent",
        featureFlags: props.featureFlags,
        ref: scrollContainerRef,
        viewMode: props?.viewMode,
        isScrollable: true,
        appearance: props.appearance
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $g5n6x.default), {
        editorView: props.editorView,
        editorDisabled: props.disabled
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: (0, $cbSL1.expValEquals)('platform_editor_core_static_emotion_non_central', 'isEnabled', true) ? [
            $413fb8c44ae5e4e1$var$editorContentAreaNew,
            $413fb8c44ae5e4e1$var$editorContentAreaProsemirrorStyle,
            $413fb8c44ae5e4e1$var$tableFullPageEditorStylesNew,
            $413fb8c44ae5e4e1$var$fullWidthNonChromelessBreakoutBlockTableStyle,
            // for breakout resizing, there's no need to restrict the width of codeblocks as they're always wrapped in a breakout mark
            (0, $9Letn.expValEqualsNoExposure)('platform_editor_breakout_resizing', 'isEnabled', true) && (0, $eGOwo.fg)('platform_editor_breakout_resizing_width_changes') ? $413fb8c44ae5e4e1$var$editorContentAreaContainerStyleExcludeCodeBlockNew : $413fb8c44ae5e4e1$var$editorContentAreaContainerStyleNew,
            (0, $eGOwo.fg)('platform_editor_nested_dnd_styles_changes') && $413fb8c44ae5e4e1$var$editorContentAreaContainerNestedDndStyle,
            !(0, $eGOwo.fg)('platform_editor_controls_no_toolbar_space') && (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1') && $413fb8c44ae5e4e1$var$contentAreaReducedHeaderSpace,
            !(0, $eGOwo.fg)('platform_editor_controls_no_toolbar_space') && props.isEditorToolbarHidden && (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1') && $413fb8c44ae5e4e1$var$contentAreaReservedPrimaryToolbarSpace
        ] : [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            ...$413fb8c44ae5e4e1$var$editorContentAreaStyle({
                fullWidthMode: fullWidthMode,
                layoutMaxWidth: theme.layoutMaxWidth,
                isEditorToolbarHidden: props.isEditorToolbarHidden
            })
        ],
        style: {
            '--ak-editor-content-area-max-width': !fullWidthMode ? `${theme.layoutMaxWidth + $413fb8c44ae5e4e1$var$getTotalPadding()}px` : `${$413fb8c44ae5e4e1$var$akEditorFullWidthLayoutWidth + $413fb8c44ae5e4e1$var$getTotalPadding()}px`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: "ak-editor-content-area-region",
        "data-editor-editable-content": true,
        "data-editor-primary-toolbar-hidden": shouldSetHiddenDataAttribute() ? 'true' : undefined,
        role: "region",
        "aria-label": props.intl.formatMessage((0, $1LIK6.messages).editableContentLabel),
        ref: contentAreaRef
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: (0, $cbSL1.expValEquals)('platform_editor_core_static_emotion_non_central', 'isEnabled', true) ? [
            $413fb8c44ae5e4e1$var$editorContentGutterStyles,
            // eslint-disable-next-line @atlaskit/platform/no-preconditioning
            (0, $eGOwo.fg)('platform_editor_controls_increase_full_page_gutter') && (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1') && $413fb8c44ae5e4e1$var$editorContentGutterStyleFG
        ] : [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            $413fb8c44ae5e4e1$var$editorContentGutterStyle()
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, (/*@__PURE__*/$parcel$interopDefault($k9JrM)))('ak-editor-content-area', 'appearance-full-page', {
            'fabric-editor--full-width-mode': fullWidthMode
        }),
        ref: contentAreaRef
    }, !!props.customContentComponents && 'before' in props.customContentComponents ? (0, $g0hAu.contentComponentClickWrapper)(props.customContentComponents.before) : (0, $g0hAu.contentComponentClickWrapper)(props.customContentComponents), /*#__PURE__*/ (0, $1NIU8.jsx)((0, $gyhYD.default), {
        editorView: props.editorView,
        editorActions: props.editorActions,
        eventDispatcher: props.eventDispatcher,
        providerFactory: props.providerFactory,
        appearance: props.appearance,
        items: props.contentComponents,
        pluginHooks: props.pluginHooks,
        contentArea: contentAreaRef.current ?? undefined,
        popupsMountPoint: props.popupsMountPoint,
        popupsBoundariesElement: props.popupsBoundariesElement,
        popupsScrollableElement: props.popupsScrollableElement,
        disabled: !!props.disabled,
        containerElement: scrollContainerRef.current,
        dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
        wrapperElement: props.wrapperElement
    }), props.editorDOMElement, !!props.customContentComponents && 'after' in props.customContentComponents ? (0, $g0hAu.contentComponentClickWrapper)(props.customContentComponents.after) : null))))), /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: (0, $dm5Ee.sidebarArea)
    }, props.contextPanel || /*#__PURE__*/ (0, $1NIU8.jsx)((0, $lMLcG.ContextPanel), {
        editorAPI: props.editorAPI,
        visible: false
    })));
});
const $413fb8c44ae5e4e1$export$7db1e8e055ebd208 = (0, $6YFG2.default)($413fb8c44ae5e4e1$var$Content, {
    forwardRef: true
});

});
parcelRegister("lMLcG", function(module, exports) {

$parcel$export(module.exports, "ContextPanel", () => $768cf551d01d648a$export$c174a7dc96b2afb8);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $6YFG2 = parcelRequire("6YFG2");

var $1aLTh = parcelRequire("1aLTh");

var $kLQ9a = parcelRequire("kLQ9a");
var $bSToC = parcelRequire("bSToC");

var $dTBhg = parcelRequire("dTBhg");

var $jZyjN = parcelRequire("jZyjN");

var $frlUM = parcelRequire("frlUM");

var $7yBx7 = parcelRequire("7yBx7");

var $eGOwo = parcelRequire("eGOwo");
function $768cf551d01d648a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $768cf551d01d648a$var$ANIM_SPEED_MS = 500;
const $768cf551d01d648a$var$panelHidden = {
    name: "k2uqvh",
    styles: "width:0"
};
const $768cf551d01d648a$export$21f42ab9b6679f44 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $7yBx7.akEditorContextPanelWidth)}px`,
    height: '100%',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `width ${$768cf551d01d648a$var$ANIM_SPEED_MS}ms ${(0, $7yBx7.akEditorSwoopCubicBezier)}`,
    overflow: 'hidden',
    boxShadow: `inset 2px 0 0 0 ${"var(--ds-border, #091E4224)"}`
});
const $768cf551d01d648a$var$disablePanelAnimation = {
    name: "1wx2bp",
    styles: "transition:none"
};
const $768cf551d01d648a$export$a7db06668cad9adb = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `width 600ms ${(0, $7yBx7.akEditorSwoopCubicBezier)}`,
    boxSizing: 'border-box',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $7yBx7.akEditorContextPanelWidth)}px`,
    height: '100%',
    overflowY: 'auto'
});
const $768cf551d01d648a$var$paddingStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    padding: `${"var(--ds-space-200, 16px)"} ${"var(--ds-space-200, 16px)"} 0px`
});
// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
class $768cf551d01d648a$var$SwappableContentAreaInner extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).PureComponent {
    static getDerivedStateFromProps(props, state) {
        if (props.pluginContent !== state.currentPluginContent) return {
            ...state,
            currentPluginContent: props.pluginContent
        };
        return null;
    }
    unsetPluginContent() {
        this.setState({
            currentPluginContent: undefined
        });
    }
    componentDidMount() {
        // use this to trigger an animation
        this.setState({
            mounted: true
        });
    }
    render() {
        const width = this.props.customWidth ?? (0, $7yBx7.akEditorContextPanelWidth);
        const userVisible = !!this.props.visible;
        const visible = userVisible || !!this.state.currentPluginContent;
        const hasPadding = this.props.hasPadding === undefined ? true : this.props.hasPadding;
        const customPanelWidthStyles = /*#__PURE__*/ (0, $1NIU8.css)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @repo/internal/react/no-class-components
            width: `${this.props.customWidth}px`,
            overflowX: 'hidden'
        });
        return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $jZyjN.ContextPanelConsumer), null, ({ broadcastWidth: broadcastWidth })=>{
            const contextPanelWidth = visible ? width : 0;
            broadcastWidth(contextPanelWidth);
            return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
                css: [
                    $768cf551d01d648a$export$21f42ab9b6679f44,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/consistent-css-prop-usage
                    this.props.customWidth && customPanelWidthStyles,
                    !visible && $768cf551d01d648a$var$panelHidden,
                    (0, $eGOwo.fg)('platform_editor_disable_context_panel_animation') && $768cf551d01d648a$var$disablePanelAnimation
                ],
                "data-testid": "context-panel-panel",
                "aria-labelledby": "context-panel-title",
                "aria-label": this.props.intl?.formatMessage((0, $dTBhg.contextPanelMessages).panelLabel) || '',
                role: "dialog"
            }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
                "data-testid": "context-panel-content",
                css: [
                    $768cf551d01d648a$export$a7db06668cad9adb,
                    hasPadding && $768cf551d01d648a$var$paddingStyles,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/consistent-css-prop-usage
                    this.props.customWidth && customPanelWidthStyles,
                    !visible && $768cf551d01d648a$var$panelHidden,
                    (0, $eGOwo.fg)('platform_editor_disable_context_panel_animation') && $768cf551d01d648a$var$disablePanelAnimation
                ]
            }, this.showPluginContent() || this.showProvidedContent(userVisible)));
        });
    }
    constructor(...args){
        super(...args), this.state = {
            mounted: false,
            currentPluginContent: undefined
        }, this.focusEditor = ()=>{
            const { editorAPI: editorAPI } = this.props;
            editorAPI?.core?.actions.focus({
                scrollIntoView: false
            });
        }, this.showPluginContent = ()=>{
            const { pluginContent: pluginContent } = this.props;
            const { currentPluginContent: currentPluginContent } = this.state;
            if (!currentPluginContent) return;
            const animSpeedMs = (0, $eGOwo.fg)('platform_editor_disable_context_panel_animation') ? 0 : $768cf551d01d648a$var$ANIM_SPEED_MS;
            return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $1aLTh.default), {
                timeout: this.state.mounted ? animSpeedMs : 0,
                in: !!pluginContent,
                mountOnEnter: true,
                unmountOnExit: true,
                onExited: ()=>this.unsetPluginContent()
            }, currentPluginContent);
        }, this.showProvidedContent = (isVisible)=>{
            const { children: children } = this.props;
            if (!children) return;
            const animSpeedMs = (0, $eGOwo.fg)('platform_editor_disable_context_panel_animation') ? 0 : $768cf551d01d648a$var$ANIM_SPEED_MS;
            return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $1aLTh.default), {
                timeout: this.state.mounted ? animSpeedMs : 0,
                in: isVisible,
                mountOnEnter: true,
                unmountOnExit: true,
                onExiting: this.focusEditor
            }, children);
        };
    }
}
const $768cf551d01d648a$var$useContextPanelSharedState = (0, $kLQ9a.sharedPluginStateHookMigratorFactory)((pluginInjectionApi)=>{
    const { contextPanelState: contextPanelState } = (0, $bSToC.useSharedPluginState)(pluginInjectionApi, [
        'contextPanel'
    ]);
    return contextPanelState?.contents;
}, (pluginInjectionApi)=>{
    return (0, $frlUM.useSharedPluginStateSelector)(pluginInjectionApi, 'contextPanel.contents');
});
const $768cf551d01d648a$export$2aac880ec6fe2608 = (0, $6YFG2.default)($768cf551d01d648a$var$SwappableContentAreaInner);
function $768cf551d01d648a$export$c174a7dc96b2afb8(props) {
    const contextPanelContents = $768cf551d01d648a$var$useContextPanelSharedState(props.editorAPI);
    const firstContent = contextPanelContents && contextPanelContents.find(Boolean);
    return /*#__PURE__*/ (0, $1NIU8.jsx)($768cf551d01d648a$export$2aac880ec6fe2608, {
        ...props,
        editorAPI: props.editorAPI,
        pluginContent: firstContent
    });
}

});

parcelRegister("dm5Ee", function(module, exports) {

$parcel$export(module.exports, "fullPageEditorWrapper", () => $1952200599e6675c$export$ffbc962f588258d5);
$parcel$export(module.exports, "contentArea", () => $1952200599e6675c$export$26bdc8f90c1f72f6);
$parcel$export(module.exports, "contentAreaWrapper", () => $1952200599e6675c$export$484266f72d7ebbab);
$parcel$export(module.exports, "sidebarArea", () => $1952200599e6675c$export$a838a71bfc839c1d);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $7yBx7 = parcelRequire("7yBx7");
function $1952200599e6675c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1952200599e6675c$export$ffbc962f588258d5 = {
    name: "cui2x",
    styles: "min-width:340px;height:100%;display:flex;flex-direction:column;box-sizing:border-box"
};
const $1952200599e6675c$export$26bdc8f90c1f72f6 = ()=>{
    const editorToolbarHeight = (0, $7yBx7.FULL_PAGE_EDITOR_TOOLBAR_HEIGHT)();
    return /*#__PURE__*/ (0, $1NIU8.css)({
        display: 'flex',
        flexDirection: 'row',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `calc(100% - ${editorToolbarHeight})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        '&.ak-editor-content-area-no-toolbar': {
            // The editor toolbar height is 1px off (from the border) -- so we need to add 1px to the height
            // to match the toolbar height
            height: `calc(100% + 1px)`
        },
        boxSizing: 'border-box',
        margin: 0,
        padding: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transition: `padding 0ms ${(0, $7yBx7.akEditorSwoopCubicBezier)}`
    });
};
const $1952200599e6675c$export$484266f72d7ebbab = {
    name: "znpqtq",
    styles: "width:100%;container-type:inline-size;container-name:editor-area;contain:layout style inline-size"
};
const $1952200599e6675c$export$a838a71bfc839c1d = {
    name: "18di8tn",
    styles: "height:100%;box-sizing:border-box;align-self:flex-end;.extension-editable-area &{height:auto;position:sticky;top:0;align-self:flex-start;}"
};
const $1952200599e6675c$export$14d7990cf2a76cb6 = {
    name: "1ffp76g",
    styles: ".fabric-editor--full-width-mode{.pm-table-container, .code-block, .extension-container{display:none;}.multiBodiedExtension--container{display:none;}}"
};

});


parcelRegister("eNwcO", function(module, exports) {

$parcel$export(module.exports, "FullPageToolbar", () => $85bb1bcc4dc82f1f$export$26f3f0e30f9545b4);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $6YFG2 = parcelRequire("6YFG2");

var $1LIK6 = parcelRequire("1LIK6");

var $jZyjN = parcelRequire("jZyjN");

var $baHgw = parcelRequire("baHgw");

var $92xoS = parcelRequire("92xoS");

var $fZpc5 = parcelRequire("fZpc5");

var $83GXu = parcelRequire("83GXu");

var $1fxYk = parcelRequire("1fxYk");

var $3SxeZ = parcelRequire("3SxeZ");

var $eDOZJ = parcelRequire("eDOZJ");

var $6XFMd = parcelRequire("6XFMd");
const $85bb1bcc4dc82f1f$export$477aaffea178bc4e = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo((props)=>{
    const [shouldSplitToolbar, setShouldSplitToolbar] = (0, $eJOHy.useState)(false);
    const { editorAPI: editorAPI } = props;
    // When primary toolbar components is undefined, do not show two line editor toolbar
    const twoLineEditorToolbar = (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1') ? !!props.customPrimaryToolbarComponents && props.primaryToolbarComponents?.length !== 0 : !!props.customPrimaryToolbarComponents;
    // When a toolbar portal context is provided, render the  toolbar inside a portal.
    // Otherwise fall back to a fragment just to avoid forking rendering logic.
    const { Portal: ToolbarPortal } = (0, $fZpc5.useToolbarPortal)() ?? {
        Portal: (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment
    };
    const hasToolbarPortal = ToolbarPortal !== (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment;
    const popupsMountPoint = hasToolbarPortal ? undefined : props.popupsMountPoint;
    const nonCustomToolbar = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: (0, $eDOZJ.nonCustomToolbarWrapperStyle)
    }, props.beforeIcon && /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: (0, $eDOZJ.mainToolbarIconBeforeStyle)
    }, props.beforeIcon), /*#__PURE__*/ (0, $1NIU8.jsx)((0, $83GXu.ToolbarWithSizeDetector), {
        editorView: props.editorView,
        editorActions: props.editorActions,
        eventDispatcher: props.eventDispatcher,
        providerFactory: props.providerFactory,
        appearance: props.appearance,
        items: props.primaryToolbarComponents,
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: props.popupsBoundariesElement,
        popupsScrollableElement: props.popupsScrollableElement,
        disabled: props.disabled,
        dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
        containerElement: props.containerElement,
        hasMinWidth: props.hasMinWidth,
        twoLineEditorToolbar: twoLineEditorToolbar
    }));
    const customToolbar = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: (0, $eDOZJ.customToolbarWrapperStyle)
    }, !!props.customPrimaryToolbarComponents && 'before' in props.customPrimaryToolbarComponents ? /*#__PURE__*/ (0, $1NIU8.jsx)((0, $1fxYk.BeforePrimaryToolbarWrapper), {
        beforePrimaryToolbarComponents: props.customPrimaryToolbarComponents?.before
    }) : null, !(0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1') && editorAPI?.findReplace && twoLineEditorToolbar ? editorAPI?.findReplace.actions.registerToolbarButton({
        popupsBoundariesElement: props.popupsBoundariesElement,
        popupsMountPoint: popupsMountPoint,
        popupsScrollableElement: props.popupsScrollableElement,
        editorView: props.editorView,
        containerElement: props.containerElement,
        dispatchAnalyticsEvent: props.dispatchAnalyticsEvent
    }) : null, !!props.customPrimaryToolbarComponents && 'after' in props.customPrimaryToolbarComponents ? props.customPrimaryToolbarComponents.after : props.customPrimaryToolbarComponents);
    (0, $eJOHy.useEffect)(()=>{
        if (twoLineEditorToolbar) {
            const updateOnResize = ()=>{
                setShouldSplitToolbar(window.innerWidth <= (0, $eDOZJ.MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT));
            };
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            window.addEventListener('resize', updateOnResize);
            updateOnResize();
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            return ()=>window.removeEventListener('resize', updateOnResize);
        }
    });
    const isShortcutToFocusToolbarRaw = (event)=>{
        //Alt + F9 to reach first element in this main toolbar
        return event.altKey && (event.key === 'F9' || event.keyCode === 120);
    };
    const isShortcutToFocusToolbarMemoized = (0, $eJOHy.useCallback)(isShortcutToFocusToolbarRaw, []);
    const isShortcutToFocusToolbar = (0, $92xoS.editorExperiment)('platform_editor_toolbar_rerender_optimization_exp', true) ? isShortcutToFocusToolbarMemoized : isShortcutToFocusToolbarRaw;
    const handleEscapeRaw = (event)=>{
        if (!props.editorView?.hasFocus()) props.editorView?.focus();
        event.preventDefault();
        event.stopPropagation();
    };
    const handleEscapeMemoized = (0, $eJOHy.useCallback)((event)=>{
        if (!props.editorView?.hasFocus()) props.editorView?.focus();
        event.preventDefault();
        event.stopPropagation();
    }, [
        props.editorView
    ]);
    const handleEscape = (0, $92xoS.editorExperiment)('platform_editor_toolbar_rerender_optimization_exp', true) ? handleEscapeMemoized : handleEscapeRaw;
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $jZyjN.ContextPanelConsumer), null, ({ width: contextPanelWidth })=>/*#__PURE__*/ (0, $1NIU8.jsx)((0, $baHgw.ToolbarArrowKeyNavigationProvider), {
            editorView: props.editorView,
            childComponentSelector: "[data-testid='ak-editor-main-toolbar']",
            isShortcutToFocusToolbar: isShortcutToFocusToolbar,
            handleEscape: handleEscape,
            intl: props.intl
        }, /*#__PURE__*/ (0, $1NIU8.jsx)(ToolbarPortal, null, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $6XFMd.MainToolbarWrapper), {
            showKeyline: props.showKeyline || contextPanelWidth > 0,
            twoLineEditorToolbar: twoLineEditorToolbar,
            "data-testid": "ak-editor-main-toolbar"
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $3SxeZ.MainToolbarForFirstChildWrapper), {
            twoLineEditorToolbar: twoLineEditorToolbar,
            role: "toolbar",
            "aria-label": props.intl.formatMessage((0, $1LIK6.messages).toolbarLabel)
        }, shouldSplitToolbar ? customToolbar : nonCustomToolbar), /*#__PURE__*/ (0, $1NIU8.jsx)((0, $3SxeZ.MainToolbarForSecondChildWrapper), {
            twoLineEditorToolbar: twoLineEditorToolbar,
            "data-testid": "avatar-group-outside-plugin",
            role: "region",
            "aria-label": props.intl.formatMessage((0, $1LIK6.messages).pageActionsLabel)
        }, shouldSplitToolbar ? nonCustomToolbar : customToolbar), /*#__PURE__*/ (0, $1NIU8.jsx)((0, $fZpc5.ToolbarPortalMountPoint), null)))));
});
const $85bb1bcc4dc82f1f$export$26f3f0e30f9545b4 = (0, $6YFG2.default)($85bb1bcc4dc82f1f$export$477aaffea178bc4e);

});
parcelRegister("fZpc5", function(module, exports) {

$parcel$export(module.exports, "ToolbarPortalContextProvider", () => $407a72f432efd5e4$export$89a0c16b81a39772);
$parcel$export(module.exports, "useToolbarPortal", () => $407a72f432efd5e4$export$9fa9b541c351558);
$parcel$export(module.exports, "ToolbarPortalMountPoint", () => $407a72f432efd5e4$export$ed65ed0e830b18c8);
/* ToolbarPortal.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");
const $407a72f432efd5e4$var$ToolbarPortalContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext(undefined);
const $407a72f432efd5e4$export$89a0c16b81a39772 = ({ children: children, portal: portal, isActive: isActive })=>{
    const value = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useMemo(()=>({
            Portal: portal,
            isActive: isActive
        }), [
        portal,
        isActive
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($407a72f432efd5e4$var$ToolbarPortalContext.Provider, {
        value: value,
        children: children
    });
};
const $407a72f432efd5e4$export$9fa9b541c351558 = ()=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useContext($407a72f432efd5e4$var$ToolbarPortalContext);
};
const $407a72f432efd5e4$var$toolbarPortalStyles = {
    portal: "_1r04ze3t _kqswstnw _fiawglyw"
};
const $407a72f432efd5e4$export$ed65ed0e830b18c8 = ()=>{
    const portal = $407a72f432efd5e4$export$9fa9b541c351558();
    // Don't render a mountpoint when we're already inside a portal
    if (portal) return null;
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            $407a72f432efd5e4$var$toolbarPortalStyles.portal,
            "ak-editor-toolbar-portal"
        ])
    });
};

});

parcelRegister("1fxYk", function(module, exports) {

$parcel$export(module.exports, "BeforePrimaryToolbarWrapper", () => $0d381531e34c3bbb$export$b41281e8d2acb8ab);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $1NIU8 = parcelRequire("1NIU8");
function $0d381531e34c3bbb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0d381531e34c3bbb$var$beforePrimaryToolbarPluginWrapperStyles = {
    name: "ep0vx",
    styles: "display:flex;flex-grow:1;justify-content:flex-end;align-items:center"
};
const $0d381531e34c3bbb$export$b41281e8d2acb8ab = (props)=>/*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $0d381531e34c3bbb$var$beforePrimaryToolbarPluginWrapperStyles,
        "data-testid": 'before-primary-toolbar-components-plugin'
    }, props.beforePrimaryToolbarComponents);

});

parcelRegister("3SxeZ", function(module, exports) {

$parcel$export(module.exports, "MainToolbarForFirstChildWrapper", () => $819d158688912a49$export$e9a48721664257fd);
$parcel$export(module.exports, "MainToolbarForSecondChildWrapper", () => $819d158688912a49$export$c8150e2de9fece09);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $AIyOt = parcelRequire("AIyOt");

var $cbSL1 = parcelRequire("cbSL1");

var $eDOZJ = parcelRequire("eDOZJ");
function $819d158688912a49$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Pre-computed static styles for first- and second-child wrappers.
// These contain no runtime logic and are safe for static-emotion mode.
const $819d158688912a49$var$firstChildStaticBase = {
    name: "5thnkd",
    styles: "display:flex;flex-grow:1"
};
// we can't avoid some kind of function call here, so we need to disable the rule
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $819d158688912a49$var$firstChildStaticTwoLine = {
    name: "125cgyn",
    styles: "@media (max-width: 868px){flex:1 1 100%;height:var(--ak-editor-fullpage-toolbar-height);justify-content:flex-end;min-width:fit-content;}"
};
const $819d158688912a49$var$secondChildStaticBase = {
    name: "g8017n",
    styles: "min-width:fit-content"
};
// we can't avoid some kind of function call here, so we need to disable the rule
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $819d158688912a49$var$secondChildStaticTwoLine = {
    name: "3psy",
    styles: "@media (max-width: 868px){display:flex;flex-grow:1;flex:1 1 100%;margin:auto;height:var(--ak-editor-fullpage-toolbar-height);min-width:0;}"
};
// ---------------- First child wrapper ----------------
const $819d158688912a49$var$FirstChildWrapperStatic = ({ twoLineEditorToolbar: twoLineEditorToolbar, children: children, role: role, 'aria-label': ariaLabel, 'data-testid': testId })=>/*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: [
            $819d158688912a49$var$firstChildStaticBase,
            twoLineEditorToolbar && $819d158688912a49$var$firstChildStaticTwoLine
        ],
        role: role,
        "aria-label": ariaLabel,
        "data-testid": testId
    }, children);
const $819d158688912a49$var$FirstChildWrapperDynamic = ({ twoLineEditorToolbar: twoLineEditorToolbar, children: children, role: role, 'aria-label': ariaLabel, 'data-testid': testId })=>/*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/consistent-css-prop-usage
        css: (0, $eDOZJ.mainToolbarFirstChildStyle)(twoLineEditorToolbar),
        role: role,
        "aria-label": ariaLabel,
        "data-testid": testId
    }, children);
const $819d158688912a49$export$e9a48721664257fd = (0, $AIyOt.componentWithCondition)(()=>(0, $cbSL1.expValEquals)('platform_editor_core_static_emotion_non_central', 'isEnabled', true), $819d158688912a49$var$FirstChildWrapperStatic, $819d158688912a49$var$FirstChildWrapperDynamic);
// ---------------- Second child wrapper ----------------
const $819d158688912a49$var$SecondChildWrapperStatic = ({ twoLineEditorToolbar: twoLineEditorToolbar, children: children, role: role, 'aria-label': ariaLabel, 'data-testid': testId })=>/*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: [
            $819d158688912a49$var$secondChildStaticBase,
            twoLineEditorToolbar && $819d158688912a49$var$secondChildStaticTwoLine
        ],
        role: role,
        "aria-label": ariaLabel,
        "data-testid": testId
    }, children);
const $819d158688912a49$var$SecondChildWrapperDynamic = ({ twoLineEditorToolbar: twoLineEditorToolbar, children: children, role: role, 'aria-label': ariaLabel, 'data-testid': testId })=>/*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/consistent-css-prop-usage
        css: (0, $eDOZJ.mainToolbarSecondChildStyle)(twoLineEditorToolbar),
        role: role,
        "aria-label": ariaLabel,
        "data-testid": testId
    }, children);
const $819d158688912a49$export$c8150e2de9fece09 = (0, $AIyOt.componentWithCondition)(()=>(0, $cbSL1.expValEquals)('platform_editor_core_static_emotion_non_central', 'isEnabled', true), $819d158688912a49$var$SecondChildWrapperStatic, $819d158688912a49$var$SecondChildWrapperDynamic);

});
parcelRegister("eDOZJ", function(module, exports) {

$parcel$export(module.exports, "MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT", () => $01fda2251b8a1f0c$export$f71dca5c73c8a7);
$parcel$export(module.exports, "mainToolbarStyle", () => $01fda2251b8a1f0c$export$149462a46fbcc8c8);
$parcel$export(module.exports, "mainToolbarIconBeforeStyle", () => $01fda2251b8a1f0c$export$8ae7cf5e67319342);
$parcel$export(module.exports, "mainToolbarFirstChildStyle", () => $01fda2251b8a1f0c$export$53973a689c603614);
$parcel$export(module.exports, "mainToolbarSecondChildStyle", () => $01fda2251b8a1f0c$export$b0242e3e235d994c);
$parcel$export(module.exports, "nonCustomToolbarWrapperStyle", () => $01fda2251b8a1f0c$export$a41238ec40a49ad0);
$parcel$export(module.exports, "customToolbarWrapperStyle", () => $01fda2251b8a1f0c$export$9c5878561f814452);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $7yBx7 = parcelRequire("7yBx7");

var $eGOwo = parcelRequire("eGOwo");
function $01fda2251b8a1f0c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $01fda2251b8a1f0c$export$f71dca5c73c8a7 = 868;
// box-shadow is overriden by the mainToolbar
const $01fda2251b8a1f0c$var$mainToolbarWithKeyline = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    boxShadow: `${"var(--ds-shadow-overflow, 0px 0px 8px #091E4228, 0px 0px 1px #091E421e)"}`
});
const $01fda2251b8a1f0c$var$mainToolbarTwoLineStyle = ()=>{
    const editorToolbarHeight = (0, $7yBx7.FULL_PAGE_EDITOR_TOOLBAR_HEIGHT)();
    return /*#__PURE__*/ (0, $1NIU8.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        [`@media (max-width: ${$01fda2251b8a1f0c$export$f71dca5c73c8a7}px)`]: {
            flexWrap: 'wrap',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: `calc(${editorToolbarHeight} * 2)`
        }
    });
};
const $01fda2251b8a1f0c$var$flexibleIconSize = {
    name: "1ymvw5b",
    styles: "& span svg{max-width:100%;}"
};
const $01fda2251b8a1f0c$var$mainToolbar = ()=>{
    const editorToolbarHeight = (0, $7yBx7.FULL_PAGE_EDITOR_TOOLBAR_HEIGHT)();
    return /*#__PURE__*/ (0, $1NIU8.css)({
        position: 'relative',
        alignItems: 'center',
        boxShadow: 'none',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        borderBottom: `1px solid ${"var(--ds-border, #091E4224)"}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transition: `box-shadow 200ms ${(0, $7yBx7.akEditorSwoopCubicBezier)}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: (0, $7yBx7.akEditorFloatingDialogZIndex),
        display: 'flex',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: editorToolbarHeight,
        flexShrink: 0,
        backgroundColor: "var(--ds-surface, white)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& object': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
            height: '0 !important'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`@media (max-width: ${0, $7yBx7.akEditorMobileMaxWidth}px)`]: {
            display: 'grid',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: `calc(${editorToolbarHeight} * 2)`
        }
    }, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/platform/ensure-feature-flag-registration, @atlaskit/ui-styling-standard/no-unsafe-values
    (0, $eGOwo.fg)('platform-visual-refresh-icons') && $01fda2251b8a1f0c$var$flexibleIconSize);
};
const $01fda2251b8a1f0c$export$149462a46fbcc8c8 = (showKeyline, twoLineEditorToolbar)=>[
        $01fda2251b8a1f0c$var$mainToolbar,
        showKeyline && $01fda2251b8a1f0c$var$mainToolbarWithKeyline,
        twoLineEditorToolbar && $01fda2251b8a1f0c$var$mainToolbarTwoLineStyle
    ];
const $01fda2251b8a1f0c$export$8ae7cf5e67319342 = /*#__PURE__*/ (0, $1NIU8.css)({
    margin: "var(--ds-space-200, 16px)",
    height: "var(--ds-space-400, 32px)",
    width: "var(--ds-space-400, 32px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${0, $7yBx7.akEditorMobileMaxWidth}px)`]: {
        gridColumn: 1,
        gridRow: 1
    }
});
const $01fda2251b8a1f0c$var$mainToolbarFirstChild = /*#__PURE__*/ (0, $1NIU8.css)({
    display: 'flex',
    flexGrow: 1,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${0, $7yBx7.akEditorMobileMaxWidth}px)`]: {
        gridColumn: 1,
        gridRow: 1
    }
});
const $01fda2251b8a1f0c$var$mainToolbarFirstChildTowLine = ()=>{
    const editorToolbarHeight = (0, $7yBx7.FULL_PAGE_EDITOR_TOOLBAR_HEIGHT)();
    return /*#__PURE__*/ (0, $1NIU8.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        [`@media (max-width: ${$01fda2251b8a1f0c$export$f71dca5c73c8a7}px)`]: {
            flex: '1 1 100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: editorToolbarHeight,
            justifyContent: 'flex-end',
            minWidth: 'fit-content'
        }
    });
};
const $01fda2251b8a1f0c$export$53973a689c603614 = (twoLineEditorToolbar)=>[
        $01fda2251b8a1f0c$var$mainToolbarFirstChild,
        twoLineEditorToolbar && $01fda2251b8a1f0c$var$mainToolbarFirstChildTowLine
    ];
const $01fda2251b8a1f0c$var$mainToolbarSecondChild = {
    name: "g8017n",
    styles: "min-width:fit-content"
};
const $01fda2251b8a1f0c$var$mainToolbarSecondChildTwoLine = ()=>{
    const editorToolbarHeight = (0, $7yBx7.FULL_PAGE_EDITOR_TOOLBAR_HEIGHT)();
    return /*#__PURE__*/ (0, $1NIU8.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        [`@media (max-width: ${$01fda2251b8a1f0c$export$f71dca5c73c8a7}px)`]: {
            display: 'flex',
            flexGrow: 1,
            flex: '1 1 100%',
            margin: 'auto',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: editorToolbarHeight,
            minWidth: 0
        }
    });
};
const $01fda2251b8a1f0c$export$b0242e3e235d994c = (twoLineEditorToolbar)=>[
        $01fda2251b8a1f0c$var$mainToolbarSecondChild,
        twoLineEditorToolbar && $01fda2251b8a1f0c$var$mainToolbarSecondChildTwoLine
    ];
const $01fda2251b8a1f0c$export$a41238ec40a49ad0 = {
    name: "t6ix9q",
    styles: "align-items:center;display:flex;flex-grow:1"
};
const $01fda2251b8a1f0c$export$9c5878561f814452 = {
    name: "1vr7vmn",
    styles: "align-items:center;display:flex"
};

});


parcelRegister("6XFMd", function(module, exports) {

$parcel$export(module.exports, "MainToolbarWrapper", () => $4e4b9c4a74e9fa83$export$9e3c8dcb351b94fd);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $7yBx7 = parcelRequire("7yBx7");

var $eGOwo = parcelRequire("eGOwo");

var $AIyOt = parcelRequire("AIyOt");

var $cbSL1 = parcelRequire("cbSL1");

var $eDOZJ = parcelRequire("eDOZJ");
function $4e4b9c4a74e9fa83$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Base styles that don't depend on feature flags
const $4e4b9c4a74e9fa83$var$baseToolbarStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    position: 'relative',
    alignItems: 'center',
    boxShadow: 'none',
    borderBottom: `1px solid ${"var(--ds-border, #091E4224)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    transition: `box-shadow 200ms ${(0, $7yBx7.akEditorSwoopCubicBezier)}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    zIndex: (0, $7yBx7.akEditorFloatingDialogZIndex),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    display: 'flex',
    height: 'var(--ak-editor-fullpage-toolbar-height)',
    flexShrink: 0,
    backgroundColor: "var(--ds-surface, #FFFFFF)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '& object': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        height: '0 !important'
    }
});
const $4e4b9c4a74e9fa83$var$flexibleIconSize = {
    name: "1ymvw5b",
    styles: "& span svg{max-width:100%;}"
};
// box-shadow is overriden by the mainToolbar
const $4e4b9c4a74e9fa83$var$mainToolbarWithKeyline = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    boxShadow: `${"var(--ds-shadow-overflow, 0px 0px 8px #091E4228, 0px 0px 1px #091E421e)"}`
});
const $4e4b9c4a74e9fa83$var$mainToolbarTwoLineStyle = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${0, $eDOZJ.MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT}px)`]: {
        flexWrap: 'wrap',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `calc(var(--ak-editor-fullpage-toolbar-height) * 2)`
    }
});
const $4e4b9c4a74e9fa83$var$MainToolbarWrapperNext = ({ showKeyline: showKeyline, twoLineEditorToolbar: twoLineEditorToolbar, children: children, 'data-testid': testId })=>{
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: [
            $4e4b9c4a74e9fa83$var$baseToolbarStyles,
            (0, $eGOwo.fg)('platform-visual-refresh-icons') && $4e4b9c4a74e9fa83$var$flexibleIconSize,
            showKeyline && $4e4b9c4a74e9fa83$var$mainToolbarWithKeyline,
            twoLineEditorToolbar && $4e4b9c4a74e9fa83$var$mainToolbarTwoLineStyle
        ],
        "data-testid": testId
    }, children);
};
/**
 * Original version of the toolbar wrapper using dynamic styles
 */ const $4e4b9c4a74e9fa83$var$MainToolbarWrapperOld = ({ showKeyline: showKeyline, twoLineEditorToolbar: twoLineEditorToolbar, children: children, 'data-testid': testId })=>{
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
        (0, $eDOZJ.mainToolbarStyle)(showKeyline, twoLineEditorToolbar),
        "data-testid": testId
    }, children);
};
const $4e4b9c4a74e9fa83$export$9e3c8dcb351b94fd = (0, $AIyOt.componentWithCondition)(()=>(0, $cbSL1.expValEquals)('platform_editor_core_static_emotion_non_central', 'isEnabled', true), $4e4b9c4a74e9fa83$var$MainToolbarWrapperNext, $4e4b9c4a74e9fa83$var$MainToolbarWrapperOld);

});


parcelRegister("jUtLl", function(module, exports) {

$parcel$export(module.exports, "getEditorViewMode", () => $cfcd309e63ade6af$export$419814ca23c581e8);

var $eGOwo = parcelRequire("eGOwo");
// Retrieve the initial config value from the editor view plugin preset
const $cfcd309e63ade6af$var$getViewModeSync = (preset)=>{
    if (!(0, $eGOwo.fg)('platform_editor_sync_editor_view_mode_state')) return undefined;
    // @ts-expect-error - data is a private property
    const editorViewModePlugin = preset.data.find((p)=>{
        if (Array.isArray(p)) {
            const [plugin, config] = p;
            return plugin({
                config: config
            }).name === 'editorViewMode';
        } else return p?.({
            config: undefined
        })?.name === 'editorViewMode';
    });
    // If we have set a default value on the view mode (index 1) then we can return the mode, otherwise we haven't set by default
    return Array.isArray(editorViewModePlugin) ? editorViewModePlugin[1]?.mode : undefined;
};
const $cfcd309e63ade6af$export$419814ca23c581e8 = (editorViewModeState, preset)=>{
    if (!editorViewModeState?.mode) return $cfcd309e63ade6af$var$getViewModeSync(preset);
    return editorViewModeState?.mode;
};

});



parcelRegister("lGWJD", function(module, exports) {

$parcel$export(module.exports, "CoreEditor", () => $d93d62d948ab1b4f$export$be7eaacc86ce4514);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $cSmYj = parcelRequire("cSmYj");

var $8KLBw = parcelRequire("8KLBw");

var $eUaD0 = parcelRequire("eUaD0");

var $ftN6c = parcelRequire("ftN6c");

var $bMFKb = parcelRequire("bMFKb");
var $cd124 = parcelRequire("cd124");

var $hvjqZ = parcelRequire("hvjqZ");

var $dyNYh = parcelRequire("dyNYh");

var $2pwTW = parcelRequire("2pwTW");

var $kCWwL = parcelRequire("kCWwL");

var $hUQD4 = parcelRequire("hUQD4");

var $1ZFgR = parcelRequire("1ZFgR");

var $k9jP1 = parcelRequire("k9jP1");

var $7rP03 = parcelRequire("7rP03");

var $hk8Wh = parcelRequire("hk8Wh");

var $1PCVi = parcelRequire("1PCVi");

var $1NJcR = parcelRequire("1NJcR");

var $fy7ur = parcelRequire("fy7ur");

var $fwDw9 = parcelRequire("fwDw9");
/**
 * Editor wrapper that deals with the lifecycle logic of the editor
 * @param passedProps
 * @example
 */ function $d93d62d948ab1b4f$var$Editor(passedProps) {
    const propsRef = (0, $eJOHy.useRef)(passedProps);
    const props = (0, $1NJcR.default)(passedProps);
    (0, $eJOHy.useMemo)(()=>{
        propsRef.current = props;
    }, [
        props
    ]);
    const editorContext = (0, $kCWwL.useEditorContext)();
    const editorActionsPlaceholderInstance = (0, $eJOHy.useMemo)(()=>new (0, $2pwTW.default)(), []);
    const editorActions = editorContext.editorActions || editorActionsPlaceholderInstance;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const handleAnalyticsEvent = (0, $eJOHy.useCallback)((data)=>{
        (0, $cd124.fireAnalyticsEvent)(createAnalyticsEvent)(data);
    }, [
        createAnalyticsEvent
    ]);
    const getFeatureFlagsFromRef = (0, $eJOHy.useCallback)(()=>{
        return {
            ...(0, $hUQD4.createFeatureFlagsFromProps)(propsRef.current.featureFlags),
            useNativeCollabPlugin: Boolean(typeof propsRef.current.collabEdit?.useNativePlugin === 'boolean' ? !!propsRef.current.collabEdit?.useNativePlugin : false)
        };
    }, []);
    const onEditorCreated = (0, $eJOHy.useCallback)((instance)=>{
        const { contextIdentifierProvider: contextIdentifierProvider, onEditorReady: onEditorReady, featureFlags: featureFlags } = propsRef.current;
        editorActions._privateRegisterEditor(instance.view, instance.eventDispatcher, instance.transformer, getFeatureFlagsFromRef);
        if (onEditorReady) {
            (0, $hvjqZ.startMeasure)((0, $1ZFgR.default).ON_EDITOR_READY_CALLBACK);
            onEditorReady(editorActions);
            (0, $hvjqZ.stopMeasure)((0, $1ZFgR.default).ON_EDITOR_READY_CALLBACK, (0, $fwDw9.default)((0, $bMFKb.ACTION).ON_EDITOR_READY_CALLBACK, {
                contextIdentifierProvider: contextIdentifierProvider,
                featureFlags: featureFlags
            }, createAnalyticsEvent));
        }
    }, [
        editorActions,
        createAnalyticsEvent,
        getFeatureFlagsFromRef,
        propsRef
    ]);
    const onEditorDestroyed = (0, $eJOHy.useCallback)((_instance)=>{
        const { onDestroy: onDestroy } = propsRef.current;
        editorActions._privateUnregisterEditor();
        if (onDestroy) onDestroy();
    }, [
        editorActions,
        propsRef
    ]);
    (0, $1PCVi.default)(props, createAnalyticsEvent);
    const providerFactory = (0, $fy7ur.default)(props, editorActions, createAnalyticsEvent);
    const { onSave: onSaveFromProps } = props;
    const handleSave = (0, $eJOHy.useCallback)((view)=>{
        if (onSaveFromProps) onSaveFromProps(view);
    }, [
        onSaveFromProps
    ]);
    const isFullPageApperance = Boolean(props.appearance && [
        'full-page',
        'full-width'
    ].includes(props.appearance));
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Fragment), null, isFullPageApperance ? /*#__PURE__*/ (0, $1NIU8.jsx)((0, $7rP03.EditorINPMetrics), null) : null, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $hk8Wh.EditorInternal), {
        props: props,
        handleAnalyticsEvent: handleAnalyticsEvent,
        createAnalyticsEvent: createAnalyticsEvent,
        preset: props.preset,
        handleSave: handleSave,
        editorActions: editorActions,
        onEditorCreated: onEditorCreated,
        onEditorDestroyed: onEditorDestroyed,
        providerFactory: providerFactory,
        AppearanceComponent: props.AppearanceComponent
    }));
}
const $d93d62d948ab1b4f$var$useMemoEditorFeatureFlags = (featureFlags)=>{
    const ffRef = (0, $eJOHy.useRef)(featureFlags);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(ffRef.current, featureFlags)) ffRef.current = featureFlags;
    return ffRef.current;
};
function $d93d62d948ab1b4f$export$be7eaacc86ce4514(props) {
    const editorSessionId = (0, $eJOHy.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($8KLBw)))());
    const data = (0, $eJOHy.useMemo)(()=>{
        return {
            packageName: (0, $k9jP1.name),
            packageVersion: (0, $k9jP1.version),
            componentName: 'editorCore',
            appearance: (0, $dyNYh.getAnalyticsAppearance)(props.appearance),
            editorSessionId: editorSessionId.current
        };
    }, [
        props.appearance
    ]);
    const memodEditorFeatureFlags = $d93d62d948ab1b4f$var$useMemoEditorFeatureFlags(props.featureFlags);
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eUaD0.FabricEditorAnalyticsContext), {
        // @ts-expect-error Type 'string' is not assignable to type '"editorCore" | "renderer"'.
        data: data
    }, /*#__PURE__*/ (0, $1NIU8.jsx)($d93d62d948ab1b4f$var$Editor, {
        ...props,
        featureFlags: memodEditorFeatureFlags
    }));
}
$d93d62d948ab1b4f$export$be7eaacc86ce4514.propTypes = {
    minHeight: ({ appearance: appearance, minHeight: minHeight })=>{
        if (minHeight && appearance && ![
            'comment',
            'chromeless'
        ].includes(appearance)) return new Error('minHeight only supports editor appearance chromeless and comment for Editor');
        return null;
    }
};
var $d93d62d948ab1b4f$export$2e2bcd8739ae039 = $d93d62d948ab1b4f$export$be7eaacc86ce4514;

});
parcelRegister("cd124", function(module, exports) {

$parcel$export(module.exports, "editorAnalyticsChannel", () => $00836d68af125af6$export$1467dbbb3bb418c6);
$parcel$export(module.exports, "fireAnalyticsEvent", () => $00836d68af125af6$export$c7d191551feb734);

var $bgewf = parcelRequire("bgewf");

var $b1YJC = parcelRequire("b1YJC");
const $00836d68af125af6$export$1467dbbb3bb418c6 = (0, $bgewf.FabricChannel).editor;
const $00836d68af125af6$export$c7d191551feb734 = (createAnalyticsEvent, options)=>({ payload: payload, channel: channel = $00836d68af125af6$export$1467dbbb3bb418c6 })=>{
        if (!createAnalyticsEvent) return;
        if (options?.immediate) {
            createAnalyticsEvent(payload)?.fire(channel);
            return;
        }
        const queue = (0, $b1YJC.AnalyticsQueue).get();
        queue.schedule(()=>createAnalyticsEvent(payload)?.fire(channel));
    };

});
parcelRegister("b1YJC", function(module, exports) {

$parcel$export(module.exports, "AnalyticsQueue", () => $d318da68cac51402$export$b44c4ba8fe19bbc7);

var $LFmXM = parcelRequire("LFmXM");
class $d318da68cac51402$export$b44c4ba8fe19bbc7 {
    static{
        this.get = (0, $LFmXM.default)(()=>new $d318da68cac51402$export$b44c4ba8fe19bbc7());
    }
    constructor(){
        this.tasks = [];
        this.running = false;
    }
    request(fn) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (window.requestIdleCallback) // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        window.requestIdleCallback(fn);
        else {
            const start = performance.now();
            setTimeout(()=>{
                fn({
                    didTimeout: false,
                    timeRemaining: ()=>Math.max(0, 50 - (performance.now() - start))
                });
            }, 0);
        }
    }
    pending() {
        // Defensive coding as navigator.scheduling.isInputPending is an experimental API
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (typeof window.navigator?.scheduling?.isInputPending === 'function') // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return window.navigator?.scheduling?.isInputPending() === true;
        return false;
    }
    process() {
        if (this.running) return;
        this.running = true;
        this.request((deadline)=>{
            while(deadline.timeRemaining() > 0 && this.tasks.length > 0 && !this.pending()){
                const task = this.tasks.shift();
                if (task) task();
            }
            this.running = false;
            if (this.tasks.length > 0) this.process();
        });
    }
    schedule(task) {
        this.tasks.push(task);
        this.process();
    }
}

});


parcelRegister("2pwTW", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0c717bcbbc27c7c$export$2e2bcd8739ae039);

var $bMFKb = parcelRequire("bMFKb");

var $aoyv9 = parcelRequire("aoyv9");

var $51k6y = parcelRequire("51k6y");

var $dyNYh = parcelRequire("dyNYh");

var $3xw6l = parcelRequire("3xw6l");

var $3lIcL = parcelRequire("3lIcL");

var $BmspC = parcelRequire("BmspC");

var $eGOwo = parcelRequire("eGOwo");

var $1zRDH = parcelRequire("1zRDH");

var $dLCMh = parcelRequire("dLCMh");

var $98LxN = parcelRequire("98LxN");

var $lgr6j = parcelRequire("lgr6j");

var $kWYFo = parcelRequire("kWYFo");

var $dtmLc = parcelRequire("dtmLc");
// Please, do not copy or use this kind of code below
// @ts-ignore
const $d0c717bcbbc27c7c$var$fakePluginKey = {
    key: 'nativeCollabProviderPlugin$',
    getState: (state)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return state['nativeCollabProviderPlugin$'];
    }
};
class $d0c717bcbbc27c7c$export$2e2bcd8739ae039 {
    static from(view, eventDispatcher, transformer) {
        const editorActions = new $d0c717bcbbc27c7c$export$2e2bcd8739ae039();
        editorActions._privateRegisterEditor(view, eventDispatcher, transformer);
        return editorActions;
    }
    //#region private
    // This method needs to be public for context based helper components.
    _privateGetEditorView() {
        return this.editorView;
    }
    _privateGetEventDispatcher() {
        return this.eventDispatcher;
    }
    getFeatureFlags() {
        return {};
    }
    // This method needs to be public for EditorContext component.
    _privateRegisterEditor(editorView, eventDispatcher, contentTransformer, getFeatureFlags = ()=>({})) {
        this.contentTransformer = contentTransformer;
        this.eventDispatcher = eventDispatcher;
        this.getFeatureFlags = getFeatureFlags;
        if (!this.editorView && editorView) {
            this.editorView = editorView;
            this.listeners.forEach((cb)=>cb(editorView, eventDispatcher));
        } else if (this.editorView !== editorView) throw new Error("Editor has already been registered! It's not allowed to re-register editor with the new Editor instance.");
        if (this.contentTransformer) this.contentEncode = this.contentTransformer.encode.bind(this.contentTransformer);
    }
    // This method needs to be public for EditorContext component.
    _privateUnregisterEditor() {
        this.editorView = undefined;
        this.contentTransformer = undefined;
        this.contentEncode = undefined;
        this.eventDispatcher = undefined;
        this.getFeatureFlags = ()=>({});
    }
    _privateSubscribe(cb) {
        // If editor is registered and somebody is trying to add a listener,
        // just call it first.
        if (this.editorView && this.eventDispatcher) cb(this.editorView, this.eventDispatcher);
        this.listeners.push(cb);
    }
    _privateUnsubscribe(cb) {
        this.listeners = this.listeners.filter((c)=>c !== cb);
    }
    //#endregion
    focus({ scrollIntoView: scrollIntoView } = {
        scrollIntoView: true
    }) {
        if (!this.editorView || this.editorView.hasFocus()) return false;
        this.editorView.focus();
        if ((0, $eGOwo.fg)('platform_editor_reduce_scroll_jump_on_editor_start')) {
            if (scrollIntoView ?? true) this.editorView.dispatch(this.editorView.state.tr.scrollIntoView());
        } else this.editorView.dispatch(this.editorView.state.tr.scrollIntoView());
        return true;
    }
    blur() {
        if (!this.editorView || !this.editorView.hasFocus()) return false;
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.editorView.dom.blur();
        return true;
    }
    clear() {
        if (!this.editorView) return false;
        const editorView = this.editorView;
        const { state: state } = editorView;
        const tr = editorView.state.tr.setSelection((0, $3lIcL.TextSelection).create(state.doc, 0, state.doc.nodeSize - 2)).deleteSelection();
        editorView.dispatch(tr);
        return true;
    }
    // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
    /**
	 * @deprecated This is deprecated and is no longer maintained.
	 *
	 * Use the `requestDocument` API from `editorAPI` (ie. `editorApi?.core?.actions.requestDocument( ... ))
	 * it has inbuilt throttling and is designed for use with `ComposableEditor`.
	 *
	 * Docs on its usage are available from: https://atlaskit.atlassian.com/packages/editor/editor-core
	 *
	 * WARNING: this may be called repeatedly, async with care
	 */ async getValue() {
        const { editorView: editorView } = this;
        if (!editorView) return;
        const doc = await (0, $1zRDH.getEditorValueWithMedia)(editorView);
        const json = (0, $dtmLc.toJSON)(doc);
        if (!this.contentEncode) return json;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const nodeSanitized = (0, $3xw6l.Node).fromJSON(this.editorView.state.schema, json);
        try {
            return this.contentEncode(nodeSanitized);
        } catch (e) {
            this.dispatchAnalyticsEvent({
                action: (0, $bMFKb.ACTION).DOCUMENT_PROCESSING_ERROR,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).EDITOR,
                eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    errorMessage: `${e instanceof Error && e.name === 'NodeNestingTransformError' ? 'NodeNestingTransformError - Failed to encode one or more nested tables' : undefined}`
                }
            });
            throw e;
        }
    }
    // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
    /**
	 * @deprecated - please use `getNodeWithPosByLocalId` found in the core plugin actions instead
	 * @example 
	  	const { editorApi, preset } = usePreset(...);
		const extensionAPI = editorAPI?.extension?.actions?.api();
		// Use nodeWithPos as desired
		const nodeWithPos = extensionAPI.getNodeWithPosByLocalId(localId);
		const node = nodeWithPos.node;
		const nodePos = nodeWithPos.pos;
	 */ getNodeByLocalId(id) {
        if (this.editorView?.state) {
            const nodes = (0, $kWYFo.findNodePosByLocalIds)(this.editorView?.state, [
                id
            ]);
            const node = nodes.length >= 1 ? nodes[0] : undefined;
            return node?.node;
        }
    }
    getNodeByFragmentLocalId(id) {
        if (this.editorView?.state) {
            const nodes = (0, $98LxN.findNodePosByFragmentLocalIds)(this.editorView?.state, [
                id
            ]);
            return nodes.length > 0 ? nodes[0].node : undefined;
        }
    }
    /**
	 * This method will return the currently selected `Node` if the selection is a `Node`.
	 * Otherwise, if the selection is textual or a non-selectable `Node` within another selectable `Node`, the closest selectable parent `Node` will be returned.
	 */ getSelectedNode() {
        if (this.editorView?.state?.selection) {
            const { selection: selection } = this.editorView.state;
            if (selection instanceof (0, $3lIcL.NodeSelection)) return selection.node;
            return (0, $BmspC.findParentNode)((node)=>Boolean(node.type.spec.selectable))(selection)?.node;
        }
    }
    isDocumentEmpty() {
        // Unlikely case when editorView has been destroyed before calling isDocumentEmpty,
        // we treat this case as if document was empty.
        if (!this.editorView) return true;
        return (0, $lgr6j.isEmptyDocument)(this.editorView.state.doc);
    }
    // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
    /**
	 * @deprecated - please use `replaceDocument` found in the core plugin actions instead
	 * using this will reset your Editor State which could cause some things to break (like emojis)
	 * @example - use the `replaceDocument` from the core plugin actions instead
	 * ```ts
	 * const { editorApi, preset } = usePreset(...);
		// where you need it
		editorApi?.core.actions.replaceDocument(value);
		return <ComposableEditor preset={preset} ... />
	 */ replaceDocument(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    rawValue, shouldScrollToBottom = true, // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
    /** @deprecated [ED-14158] shouldAddToHistory is not being used in this function */ shouldAddToHistory = true) {
        (0, $dLCMh.default)('EditorActions.replaceDocument', {
            shouldAddToHistory: shouldAddToHistory
        }, [
            {
                property: 'shouldAddToHistory',
                description: '[ED-14158] EditorActions.replaceDocument does not use the shouldAddToHistory arg',
                type: 'removed'
            }
        ]);
        if (!this.editorView || rawValue === undefined || rawValue === null) return false;
        if (this.eventDispatcher) this.eventDispatcher.emit('resetEditorState', {
            doc: rawValue,
            shouldScrollToBottom: shouldScrollToBottom
        });
        return true;
    }
    replaceSelection(rawValue, tryToReplace, position) {
        if (!this.editorView) return false;
        const { state: state } = this.editorView;
        if (!rawValue) {
            const tr = state.tr.deleteSelection().scrollIntoView();
            this.editorView.dispatch(tr);
            return true;
        }
        const { schema: schema } = state;
        const content = Array.isArray(rawValue) ? (0, $51k6y.processRawFragmentValue)(schema, rawValue, undefined, undefined, undefined, this.dispatchAnalyticsEvent) : (0, $51k6y.processRawValue)(schema, rawValue, undefined, undefined, undefined, this.dispatchAnalyticsEvent);
        if (!content) return false;
        // try to find a place in the document where to insert a node if its not allowed at the cursor position by schema
        this.editorView.dispatch((0, $BmspC.safeInsert)(content, position, tryToReplace)(state.tr).scrollIntoView());
        return true;
    }
    appendText(text) {
        if (!this.editorView || !text) return false;
        const { state: state } = this.editorView;
        const lastChild = state.doc.lastChild;
        if (lastChild && lastChild.type !== state.schema.nodes.paragraph) return false;
        const tr = state.tr.insertText(text).scrollIntoView();
        this.editorView.dispatch(tr);
        return true;
    }
    constructor(){
        this.listeners = [];
        this.dispatchAnalyticsEvent = (payload)=>{
            if (this.eventDispatcher) {
                const dispatch = (0, $aoyv9.createDispatch)(this.eventDispatcher);
                dispatch((0, $dyNYh.analyticsEventKey), {
                    payload: payload
                });
            }
        };
        /**
	 * If editor is using new collab service,
	 * we want editor to call the collab provider to
	 * retrieve the final acknowledged state of the
	 * editor. The final acknowledged editor state
	 * refers to the latest state of editor with confirmed
	 * steps.
	 */ this.getResolvedEditorState = async (reason)=>{
            const { useNativeCollabPlugin: useNativeCollabPlugin } = this.getFeatureFlags();
            if (!this.editorView) throw new Error('Called getResolvedEditorState before editorView is ready');
            if (!useNativeCollabPlugin) {
                const editorValue = await this.getValue();
                if (!editorValue) throw new Error('editorValue is undefined');
                return {
                    content: editorValue,
                    title: null,
                    stepVersion: -1
                };
            }
            const editorView = this.editorView;
            await (0, $1zRDH.getEditorValueWithMedia)(editorView);
            const collabEditState = $d0c717bcbbc27c7c$var$fakePluginKey.getState(editorView.state);
            return collabEditState?.getFinalAcknowledgedState(reason);
        };
    }
}

});
parcelRegister("aoyv9", function(module, exports) {

$parcel$export(module.exports, "EventDispatcher", () => $b11d9cb9e7b224cf$export$ec8b666c5fe2c75a);
$parcel$export(module.exports, "createDispatch", () => $b11d9cb9e7b224cf$export$f57f9cc7ce57b7d0);
class $b11d9cb9e7b224cf$export$ec8b666c5fe2c75a {
    on(event, cb) {
        if (!this.listeners[event]) this.listeners[event] = new Set();
        this.listeners[event].add(cb);
    }
    has(event, cb) {
        if (!this.listeners[event]) return false;
        return this.listeners[event].has(cb);
    }
    off(event, cb) {
        if (!this.listeners[event]) return;
        if (this.listeners[event].has(cb)) this.listeners[event].delete(cb);
    }
    emit(event, data) {
        if (!this.listeners[event]) return;
        this.listeners[event].forEach((cb)=>cb(data));
    }
    destroy() {
        this.listeners = {};
    }
    constructor(){
        this.listeners = {};
    }
}
function $b11d9cb9e7b224cf$var$getEventFromEventName(eventName) {
    return typeof eventName === 'string' ? eventName : eventName.key;
}
function $b11d9cb9e7b224cf$export$f57f9cc7ce57b7d0(eventDispatcher) {
    return (eventName, data)=>{
        if (!eventName) throw new Error('event name is required!');
        eventDispatcher.emit($b11d9cb9e7b224cf$var$getEventFromEventName(eventName), data);
    };
}

});

parcelRegister("51k6y", function(module, exports) {

$parcel$export(module.exports, "processRawValueWithoutValidation", () => $a4056244480d3585$export$cafe23194e65f591);
$parcel$export(module.exports, "processRawValue", () => $a4056244480d3585$export$f1a0a61081c3ed62);
$parcel$export(module.exports, "processRawFragmentValue", () => $a4056244480d3585$export$89b7989c347e6a7b);

var $krqJC = parcelRequire("krqJC");
var $5krZp = parcelRequire("5krZp");
var $igmrQ = parcelRequire("igmrQ");
var $djAo6 = parcelRequire("djAo6");
var $jF4Mi = parcelRequire("jF4Mi");
var $iKCq6 = parcelRequire("iKCq6");
var $cdRsw = parcelRequire("cdRsw");

var $3xw6l = parcelRequire("3xw6l");

var $bMFKb = parcelRequire("bMFKb");

var $fIcYL = parcelRequire("fIcYL");

var $3mTkR = parcelRequire("3mTkR");

var $3Ussg = parcelRequire("3Ussg");
const $a4056244480d3585$var$transformNestedTablesWithAnalytics = (node, dispatchAnalyticsEvent)=>{
    try {
        const { transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $jF4Mi.transformNestedTablesIncomingDocument)(node);
        if (isTransformed && dispatchAnalyticsEvent) {
            dispatchAnalyticsEvent({
                action: (0, $bMFKb.ACTION).NESTED_TABLE_TRANSFORMED,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).EDITOR,
                eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL
            });
            return {
                transformedAdf: transformedAdf,
                isTransformed: isTransformed
            };
        }
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error('Failed to transform one or more nested tables in the document');
        if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $bMFKb.ACTION).DOCUMENT_PROCESSING_ERROR,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).EDITOR,
            eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL,
            attributes: {
                errorMessage: `${e instanceof Error && e.name === 'NodeNestingTransformError' ? 'NodeNestingTransformError - Failed to transform one or more nested tables' : undefined}`
            }
        });
    }
    return {
        transformedAdf: node,
        isTransformed: false
    };
};
function $a4056244480d3585$export$cafe23194e65f591(schema, value, dispatchAnalyticsEvent) {
    if (!value) return;
    let node;
    if (typeof value === 'string') try {
        node = JSON.parse(value);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(`Error processing value: ${value} isn't a valid JSON`);
        return;
    }
    else node = value;
    // Convert nested-table extensions into nested tables
    const { transformedAdf: transformedAdf } = $a4056244480d3585$var$transformNestedTablesWithAnalytics(node, dispatchAnalyticsEvent);
    return (0, $3xw6l.Node).fromJSON(schema, transformedAdf);
}
function $a4056244480d3585$export$f1a0a61081c3ed62(schema, value, providerFactory, sanitizePrivateContent, contentTransformer, dispatchAnalyticsEvent) {
    if (!value) return;
    let node;
    if (typeof value === 'string') try {
        if (contentTransformer) {
            const doc = contentTransformer.parse(value);
            node = doc.toJSON();
        } else node = JSON.parse(value);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(`Error processing value: ${value} isn't a valid JSON`);
        return;
    }
    else node = value;
    if (Array.isArray(node)) {
        // eslint-disable-next-line no-console
        console.error(`Error processing value: ${node} is an array, but it must be an object.`);
        return;
    }
    try {
        // ProseMirror always require a child under doc
        if (node.type === 'doc') {
            if (Array.isArray(node.content) && node.content.length === 0) node.content.push({
                type: 'paragraph',
                content: []
            });
            // Just making sure doc is always valid
            if (!node.version) node.version = 1;
        }
        if (contentTransformer) return (0, $3xw6l.Node).fromJSON(schema, node);
        // link mark on mediaSingle is deprecated, need to move link mark to child media node
        // https://product-fabric.atlassian.net/browse/ED-14043
        let { transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $djAo6.transformMediaLinkMarks)(node);
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $bMFKb.ACTION).MEDIA_LINK_TRANSFORMED,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).EDITOR,
            eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL
        });
        // See: HOT-97965 https://product-fabric.atlassian.net/browse/ED-14400
        // We declared in code mark spec that links and marks should not co-exist on
        // text nodes. This util strips code marks from bad text nodes and preserves links.
        // Otherwise, prosemirror will try to repair the invalid document by stripping links
        // and preserving code marks during content changes.
        ({ transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $cdRsw.transformTextLinkCodeMarks)(transformedAdf));
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $bMFKb.ACTION).TEXT_LINK_MARK_TRANSFORMED,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).EDITOR,
            eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL
        });
        let discardedMarks = [];
        ({ transformedAdf: transformedAdf, isTransformed: isTransformed, discardedMarks: discardedMarks } = (0, $krqJC.transformDedupeMarks)(transformedAdf));
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $bMFKb.ACTION).DEDUPE_MARKS_TRANSFORMED_V2,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).EDITOR,
            eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL,
            attributes: {
                /** UGC WARNING
					 *
					 * DO NOT include the `mark` attributes inside, we map here to only
					 * extract the mark type as that is the only non-UGC safe information
					 * that we can add to event-attributes
					 *
					 */ discardedMarkTypes: discardedMarks.map((mark)=>mark.type)
            }
        });
        ({ transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $iKCq6.transformNodesMissingContent)(transformedAdf));
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $bMFKb.ACTION).NODES_MISSING_CONTENT_TRANSFORMED,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).EDITOR,
            eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL
        });
        ({ transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $5krZp.transformIndentationMarks)(transformedAdf));
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $bMFKb.ACTION).INDENTATION_MARKS_TRANSFORMED,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).EDITOR,
            eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL
        });
        ({ transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $igmrQ.transformInvalidMediaContent)(transformedAdf));
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $bMFKb.ACTION).INVALID_MEDIA_CONTENT_TRANSFORMED,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).EDITOR,
            eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL
        });
        // Convert nested-table extensions into nested tables
        ({ transformedAdf: transformedAdf } = $a4056244480d3585$var$transformNestedTablesWithAnalytics(transformedAdf, dispatchAnalyticsEvent));
        if (dispatchAnalyticsEvent) {
            const hasSingleColumnLayout = transformedAdf.content?.some((node)=>node && node.type === 'layoutSection' && node.content?.length === 1);
            if (hasSingleColumnLayout) dispatchAnalyticsEvent({
                action: (0, $bMFKb.ACTION).SINGLE_COL_LAYOUT_DETECTED,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).EDITOR,
                eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL
            });
        }
        const entity = (0, $3Ussg.validateADFEntity)(schema, transformedAdf || node, dispatchAnalyticsEvent);
        const newEntity = $a4056244480d3585$var$maySanitizePrivateContent(entity, providerFactory, sanitizePrivateContent);
        const parsedDoc = (0, $3xw6l.Node).fromJSON(schema, newEntity);
        // throws an error if the document is invalid
        try {
            parsedDoc.check();
        } catch (err) {
            if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
                action: (0, $bMFKb.ACTION).INVALID_PROSEMIRROR_DOCUMENT,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).EDITOR,
                eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL
            });
            throw err;
        }
        if (dispatchAnalyticsEvent) (0, $3mTkR.findAndTrackUnsupportedContentNodes)(parsedDoc, schema, dispatchAnalyticsEvent);
        return parsedDoc;
    } catch (e) {
        if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $bMFKb.ACTION).DOCUMENT_PROCESSING_ERROR,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).EDITOR,
            eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL
        });
        // eslint-disable-next-line no-console
        console.error(`Error processing document:\n${e instanceof Error ? e.message : String(e)}\n\n`, JSON.stringify(node));
        if ($a4056244480d3585$var$isProseMirrorSchemaCheckError(e)) throw e;
        return;
    }
}
function $a4056244480d3585$export$89b7989c347e6a7b(schema, value, providerFactory, sanitizePrivateContent, contentTransformer, dispatchAnalyticsEvent) {
    if (!value) return;
    const adfEntities = value.map((item)=>$a4056244480d3585$export$f1a0a61081c3ed62(schema, item, providerFactory, sanitizePrivateContent, contentTransformer, dispatchAnalyticsEvent)).filter((item)=>Boolean(item));
    if (adfEntities.length === 0) return;
    return (0, $3xw6l.Fragment).from(adfEntities);
}
function $a4056244480d3585$var$isProseMirrorSchemaCheckError(error) {
    return error instanceof RangeError && // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    (!!error.message.match(/^Invalid collection of marks for node/) || // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    !!error.message.match(/^Invalid content for node/));
}
const $a4056244480d3585$var$maySanitizePrivateContent = (entity, providerFactory, sanitizePrivateContent)=>{
    if (sanitizePrivateContent && providerFactory) return (0, $fIcYL.sanitizeNodeForPrivacy)(entity, providerFactory);
    return entity;
};

});
parcelRegister("krqJC", function(module, exports) {

$parcel$export(module.exports, "transformDedupeMarks", () => $e6b88b763f6730b1$export$af4e387303482581);

var $0mclG = parcelRequire("0mclG");
// This is the set of marks that we wont allow in duplicate to
// exist on a given node, regardless of their attributes. We do
// not include annotations here, because we do allow duplicate
// annotations as long as they have unique id attributes (valid scenario)
const $e6b88b763f6730b1$var$markDuplicatesDisallowed = new Set([
    'strong',
    'underline',
    'textColor',
    'link',
    'em',
    'subsup',
    'strike',
    'backgroundColor'
]);
const $e6b88b763f6730b1$var$maybeHasDisallowedDuplicateMarks = (node)=>{
    const markTypes = node.marks?.map((mark)=>mark.type)?.filter((markType)=>// For annotations, we are performing the same cheap check
        // for duplicates by type, without considering IDs, to quickly determine
        // whether there may be potential deduping targets.
        // In the actual deduping logic in maybeRemoveDisallowedDuplicateMarks,
        // we correctly/safely dedupe annotations by their unique IDs.
        $e6b88b763f6730b1$var$markDuplicatesDisallowed.has(markType) || markType === 'annotation');
    if (!markTypes?.length) return false;
    return new Set(markTypes).size !== markTypes.length;
};
const $e6b88b763f6730b1$var$maybeRemoveDisallowedDuplicateMarks = (node)=>{
    const quota = new Map();
    const annotationsQuota = new Map();
    const discardedMarks = [];
    $e6b88b763f6730b1$var$markDuplicatesDisallowed.forEach((mark)=>{
        quota.set(mark, false);
    });
    if (!node.marks) return {
        discardedMarks: discardedMarks
    };
    const dedupedMarks = node.marks.filter((mark)=>{
        const markType = mark.type;
        if (markType === 'annotation') {
            const id = mark.attrs?.id;
            if (annotationsQuota.has(id)) {
                discardedMarks.push(mark);
                return false;
            } else {
                annotationsQuota.set(id, true);
                return true;
            }
        }
        if (quota.has(markType)) {
            if (!quota.get(markType)) {
                quota.set(markType, true);
                return true;
            } else {
                discardedMarks.push(mark);
                return false;
            }
        }
        return true;
    });
    return {
        node: {
            ...node,
            marks: dedupedMarks
        },
        discardedMarks: discardedMarks
    };
};
const $e6b88b763f6730b1$export$af4e387303482581 = (adf)=>{
    let isTransformed = false;
    const discardedMarks = [];
    const transformedAdf = (0, $0mclG.traverse)(adf, {
        text: (node)=>{
            if ($e6b88b763f6730b1$var$maybeHasDisallowedDuplicateMarks(node)) {
                const result = $e6b88b763f6730b1$var$maybeRemoveDisallowedDuplicateMarks(node);
                const resultDiscardedMarks = result.discardedMarks;
                if (resultDiscardedMarks.length) {
                    discardedMarks.push(...resultDiscardedMarks);
                    isTransformed = true;
                    return result.node;
                }
            }
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed,
        discardedMarks: discardedMarks
    };
};

});

parcelRegister("5krZp", function(module, exports) {

$parcel$export(module.exports, "transformIndentationMarks", () => $816655705743962e$export$c06e4b521519af22);

var $0mclG = parcelRequire("0mclG");
const $816655705743962e$var$hasChildHeadingWithIndentation = (node)=>node.content?.some((childNode)=>childNode?.type === 'heading' && childNode?.marks?.some((mark)=>mark.type === 'indentation')) ?? false;
const $816655705743962e$var$removeIndentationFromHeadings = (node)=>{
    return {
        ...node,
        content: node.content?.map((childNode)=>{
            if (childNode?.type === 'heading') return {
                ...childNode,
                marks: childNode.marks?.filter((mark)=>mark.type !== 'indentation')
            };
            return childNode;
        })
    };
};
const $816655705743962e$export$c06e4b521519af22 = (adf)=>{
    let isTransformed = false;
    const transformedAdf = (0, $0mclG.traverse)(adf, {
        tableCell: (node)=>{
            if ($816655705743962e$var$hasChildHeadingWithIndentation(node)) {
                isTransformed = true;
                return $816655705743962e$var$removeIndentationFromHeadings(node);
            }
        },
        tableHeader: (node)=>{
            if ($816655705743962e$var$hasChildHeadingWithIndentation(node)) {
                isTransformed = true;
                return $816655705743962e$var$removeIndentationFromHeadings(node);
            }
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};

});

parcelRegister("igmrQ", function(module, exports) {

$parcel$export(module.exports, "transformInvalidMediaContent", () => $70a64ef7adeadfa6$export$1c8c16d74c7a63bf);

var $0mclG = parcelRequire("0mclG");

var $i429R = parcelRequire("i429R");
const $70a64ef7adeadfa6$var$getChildrenTypeCounts = (nodeContent, allowedTypes)=>{
    const childrenTypes = {};
    nodeContent.forEach((childNode, index)=>{
        if (!childNode?.type || !allowedTypes.includes(childNode.type)) return;
        if (!childrenTypes[childNode.type]) {
            childrenTypes[childNode.type] = 1;
            return;
        }
        childrenTypes[childNode.type]++;
    });
    return childrenTypes;
};
const $70a64ef7adeadfa6$var$removeDuplicatedNodes = (type, content, predicate)=>{
    let maxIterations = 10;
    let childrenTypeCounts = $70a64ef7adeadfa6$var$getChildrenTypeCounts(content, [
        type
    ])[type];
    let firstPredicateNodeIndex = content.findIndex(predicate);
    while(childrenTypeCounts > 1 && firstPredicateNodeIndex > -1 && maxIterations-- > 0){
        content.splice(firstPredicateNodeIndex, 1);
        firstPredicateNodeIndex = content.findIndex(predicate);
        childrenTypeCounts = $70a64ef7adeadfa6$var$getChildrenTypeCounts(content, [
            type
        ])[type];
    }
};
/**
 * @param  {{[type:string]:number}} allowedTypes - array types allowed to deduplicate
 */ const $70a64ef7adeadfa6$var$deduplicateMediaSingleChildren = (node, allowedTypes)=>{
    if (!node.content) return;
    const content = [
        ...node.content
    ];
    Object.keys(allowedTypes).forEach((type)=>{
        //prioritise removing empty nodes first
        $70a64ef7adeadfa6$var$removeDuplicatedNodes(type, content, (node)=>node?.type === type && (0, $i429R.isEmpty)(node));
        //remove other remaining dupicates
        $70a64ef7adeadfa6$var$removeDuplicatedNodes(type, content, (node)=>node?.type === type);
    });
    return {
        ...node,
        content: content
    };
};
const $70a64ef7adeadfa6$export$1c8c16d74c7a63bf = (adf)=>{
    let isTransformed = false;
    const transformedAdf = (0, $0mclG.traverse)(adf, {
        mediaSingle: (node)=>{
            if (!node?.content?.length) return;
            const disallowedDuplicateTypes = [
                'media',
                'caption'
            ];
            const childrenTypes = $70a64ef7adeadfa6$var$getChildrenTypeCounts(node.content, disallowedDuplicateTypes);
            if (Object.values(childrenTypes).some((occurences)=>occurences > 1)) {
                isTransformed = true;
                return $70a64ef7adeadfa6$var$deduplicateMediaSingleChildren(node, childrenTypes);
            }
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};

});

parcelRegister("iKCq6", function(module, exports) {

$parcel$export(module.exports, "transformNodesMissingContent", () => $98796c1208bbd0b8$export$652814b83c30d251);

var $0mclG = parcelRequire("0mclG");

var $lfq9L = parcelRequire("lfq9L");
var $h9WvI = parcelRequire("h9WvI");
var $fe5Ef = parcelRequire("fe5Ef");
var $dr60v = parcelRequire("dr60v");

var $i429R = parcelRequire("i429R");
const $98796c1208bbd0b8$var$getMaxColumnsCountForTable = (tableNode)=>{
    let colsInRow = 1;
    tableNode.content?.forEach((childNode)=>{
        if (childNode?.type === 'tableRow' && typeof childNode.content?.length === 'number' && childNode.content.length > colsInRow) colsInRow = childNode.content.length;
    });
    return colsInRow;
};
const $98796c1208bbd0b8$var$createValidEmptyContent = (node)=>{
    switch(node.type){
        case 'tableCell':
            return [
                (0, $h9WvI.paragraph)()
            ];
        default:
            return [];
    }
};
const $98796c1208bbd0b8$var$fixIfTableCellInvalidEmpty = (reportTransform)=>(node)=>{
        if ((0, $i429R.isEmpty)(node)) {
            reportTransform();
            return {
                ...node,
                content: $98796c1208bbd0b8$var$createValidEmptyContent(node)
            };
        }
    };
const $98796c1208bbd0b8$var$hasNonListItemChildren = (node)=>node.content?.some((node)=>node?.type !== 'listItem');
const $98796c1208bbd0b8$var$hasEmptyListItemChildren = (node)=>node.content?.some((childNode)=>childNode?.type === 'listItem' && !childNode.content?.length);
const $98796c1208bbd0b8$var$tryCreateValidListItemWrappedChildren = (parentListNode)=>{
    return parentListNode.content?.map((childNode)=>{
        if (childNode) switch(childNode.type){
            case 'listItem':
                if ((0, $i429R.isEmpty)(childNode)) {
                    const result = (0, $lfq9L.listItem)([
                        (0, $h9WvI.paragraph)()
                    ]);
                    return result;
                }
                return childNode;
            case 'text':
                return (0, $lfq9L.listItem)([
                    (0, $h9WvI.paragraph)(childNode)
                ]);
            default:
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                return (0, $lfq9L.listItem)([
                    childNode
                ]);
        }
        return childNode;
    });
};
const $98796c1208bbd0b8$var$fixIfListParentWithInvalidListItemChildren = (reportTransform)=>(node)=>{
        if ($98796c1208bbd0b8$var$hasNonListItemChildren(node) || $98796c1208bbd0b8$var$hasEmptyListItemChildren(node)) {
            reportTransform();
            return {
                ...node,
                content: $98796c1208bbd0b8$var$tryCreateValidListItemWrappedChildren(node)
            };
        }
    };
const $98796c1208bbd0b8$var$hasNonTableRowChildren = (node)=>node.content?.some((node)=>node?.type !== 'tableRow');
const $98796c1208bbd0b8$var$tryCreateValidTableRowWrappedChildren = (parentTableNode)=>{
    const maxColsCount = $98796c1208bbd0b8$var$getMaxColumnsCountForTable(parentTableNode);
    return parentTableNode.content?.map((childNode)=>{
        if (childNode) switch(childNode.type){
            case 'text':
                return (0, $dr60v.tableRow)([
                    (0, $fe5Ef.tableCell)({})((0, $h9WvI.paragraph)(childNode)),
                    ...new Array(maxColsCount - 1).fill((0, $fe5Ef.tableCell)({})((0, $h9WvI.paragraph)()))
                ]);
            case 'tableCell':
                return (0, $dr60v.tableRow)([
                    childNode
                ]);
            case 'tableRow':
                if ((0, $i429R.isEmpty)(childNode)) return (0, $dr60v.tableRow)([
                    ...new Array(maxColsCount).fill((0, $fe5Ef.tableCell)({})((0, $h9WvI.paragraph)()))
                ]);
                return childNode;
            default:
                return childNode;
        }
        return childNode;
    });
};
const $98796c1208bbd0b8$var$hasEmptyTableRowChildren = (node)=>node?.content?.some((node)=>node?.type === 'tableRow' && node?.content?.length === 0);
const $98796c1208bbd0b8$var$fixIfTableParentWithInvalidTableRowChildren = (reportTransform)=>(node)=>{
        if ($98796c1208bbd0b8$var$hasEmptyTableRowChildren(node) || $98796c1208bbd0b8$var$hasNonTableRowChildren(node)) {
            reportTransform();
            return {
                ...node,
                content: $98796c1208bbd0b8$var$tryCreateValidTableRowWrappedChildren(node)
            };
        }
    };
const $98796c1208bbd0b8$var$removeMediaSingleWithNoContent = (reportTransform)=>(node)=>{
        if ((0, $i429R.isEmpty)(node)) {
            reportTransform();
            return false;
        }
    };
const $98796c1208bbd0b8$export$652814b83c30d251 = (adf)=>{
    let isTransformed = false;
    const reportTransform = ()=>{
        isTransformed = true;
    };
    let transformedAdf = (0, $0mclG.traverse)(adf, {
        tableCell: $98796c1208bbd0b8$var$fixIfTableCellInvalidEmpty(reportTransform)
    });
    // Empty mediaSingle nodes get stripped from the document and so this transform
    // will create an empty listItem if the media node is in a list. Empty listItems
    // are invalid adf, so we need to transform the mediaSingle nodes first.
    transformedAdf = (0, $0mclG.traverse)(transformedAdf || adf, {
        mediaSingle: $98796c1208bbd0b8$var$removeMediaSingleWithNoContent(reportTransform)
    });
    transformedAdf = (0, $0mclG.traverse)(transformedAdf || adf, {
        bulletList: $98796c1208bbd0b8$var$fixIfListParentWithInvalidListItemChildren(reportTransform),
        orderedList: $98796c1208bbd0b8$var$fixIfListParentWithInvalidListItemChildren(reportTransform),
        table: $98796c1208bbd0b8$var$fixIfTableParentWithInvalidTableRowChildren(reportTransform)
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};

});
parcelRegister("lfq9L", function(module, exports) {

$parcel$export(module.exports, "listItem", () => $61dc1d317d068dab$export$76c7e83ecc9cdf05);
const $61dc1d317d068dab$export$76c7e83ecc9cdf05 = (content)=>({
        type: 'listItem',
        content: content
    });

});

parcelRegister("fe5Ef", function(module, exports) {

$parcel$export(module.exports, "tableCell", () => $506ded3492622aa6$export$e1e720e5f4603e6a);
const $506ded3492622aa6$export$e1e720e5f4603e6a = (attrs)=>(...content)=>({
            type: 'tableCell',
            attrs: attrs,
            content: content
        });

});

parcelRegister("dr60v", function(module, exports) {

$parcel$export(module.exports, "tableRow", () => $4e0b8a40e6638685$export$ce666bf02318c957);
const $4e0b8a40e6638685$export$ce666bf02318c957 = (content)=>({
        type: 'tableRow',
        content: content
    });

});


parcelRegister("cdRsw", function(module, exports) {

$parcel$export(module.exports, "transformTextLinkCodeMarks", () => $a8aa57247cebadf0$export$3d531d2daf0e8a14);

var $0mclG = parcelRequire("0mclG");
const $a8aa57247cebadf0$var$hasLinkAndCodeMarks = (node)=>{
    const marks = node.marks?.map((mark)=>mark.type);
    return marks?.includes('link') && marks?.includes('code');
};
const $a8aa57247cebadf0$var$removeCodeMarks = (node)=>{
    if (node.marks) return {
        ...node,
        marks: node.marks.filter((mark)=>mark.type !== 'code')
    };
    return node;
};
const $a8aa57247cebadf0$export$3d531d2daf0e8a14 = (adf)=>{
    let isTransformed = false;
    const transformedAdf = (0, $0mclG.traverse)(adf, {
        text: (node)=>{
            if ($a8aa57247cebadf0$var$hasLinkAndCodeMarks(node)) {
                isTransformed = true;
                return $a8aa57247cebadf0$var$removeCodeMarks(node);
            }
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};

});

parcelRegister("fIcYL", function(module, exports) {

$parcel$export(module.exports, "sanitizeNodeForPrivacy", () => $172bab980f7d6e6f$export$8a32f625580e0a06);

var $0mclG = parcelRequire("0mclG");

var $231b4 = parcelRequire("231b4");
function $172bab980f7d6e6f$export$8a32f625580e0a06(json, providerFactory) {
    const mentionNames = new Map();
    let hasCacheableMentions = false;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const sanitizedJSON = (0, $0mclG.traverse)(json, {
        mention: (node)=>{
            if (node.attrs && node.attrs.text) {
                hasCacheableMentions = true;
                // Remove @ prefix
                const text = node.attrs.text;
                const name = text.startsWith('@') ? text.slice(1) : text;
                mentionNames.set(node.attrs.id, name);
            }
            return {
                ...node,
                attrs: {
                    ...node.attrs,
                    text: ''
                }
            };
        }
    });
    if (hasCacheableMentions && providerFactory) {
        const handler = (_name, providerPromise)=>{
            if (providerPromise) providerPromise.then((provider)=>{
                if ((0, $231b4.isResolvingMentionProvider)(provider)) {
                    mentionNames.forEach((name, id)=>{
                        provider.cacheMentionName(id, name);
                    });
                    mentionNames.clear();
                    providerFactory.unsubscribe('mentionProvider', handler);
                }
            });
        };
        providerFactory.subscribe('mentionProvider', handler);
    }
    return sanitizedJSON;
}

});


parcelRegister("1zRDH", function(module, exports) {

$parcel$export(module.exports, "getEditorValueWithMedia", () => $1072be5483a485cf$export$99c45752ffdaa598);
// Please, do not copy or use this kind of code below
// @ts-ignore
const $1072be5483a485cf$var$mediaPluginKey = {
    key: 'mediaPlugin$',
    getState: (state)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return state['mediaPlugin$'];
    }
};
async function $1072be5483a485cf$export$99c45752ffdaa598(editorView) {
    const mediaPluginState = editorView.state && $1072be5483a485cf$var$mediaPluginKey.getState(editorView.state);
    if (mediaPluginState && mediaPluginState.waitForMediaUpload) await mediaPluginState.waitForPendingTasks();
    return editorView.state.doc;
}

});

parcelRegister("dLCMh", function(module, exports) {

$parcel$export(module.exports, "default", () => $64b694e1960e5cc1$export$2e2bcd8739ae039);
function $64b694e1960e5cc1$var$deprecationWarnings(className, props, deprecations) {
    return;
}
var $64b694e1960e5cc1$export$2e2bcd8739ae039 = $64b694e1960e5cc1$var$deprecationWarnings;

});

parcelRegister("98LxN", function(module, exports) {

$parcel$export(module.exports, "findNodePosByFragmentLocalIds", () => $c3ac6deb3e3077bc$export$1dc8bea8646ac811);
const $c3ac6deb3e3077bc$export$1dc8bea8646ac811 = (state, ids)=>{
    if (ids.length === 0) return [];
    const nodes = [];
    const localIdSet = new Set(ids);
    state.doc.descendants((node, pos)=>{
        const fragmentLocalIdList = node.marks?.filter((m)=>m.type.name === 'fragment').map((m)=>m.attrs?.localId).filter((id)=>id && localIdSet.has(id));
        if (fragmentLocalIdList.length > 0) nodes.push({
            node: node,
            pos: pos
        });
        // stop traversing once we found all the nodes
        return localIdSet.size !== nodes.length;
    });
    return nodes;
};

});

parcelRegister("lgr6j", function(module, exports) {

$parcel$export(module.exports, "isEmptyDocument", () => $28d5451797013a88$export$2da47a16c0b6bcb);
/**
 * Temporary file which extracts function from `editor-common`.
 *
 * Eventually we will deprecate and delete EditorActions. This is here to
 * help decouple it from editor-common
 */ function $28d5451797013a88$export$b648602b09795358(node) {
    return !!node && node.type.name === 'paragraph' && !node.childCount;
}
function $28d5451797013a88$export$2da47a16c0b6bcb(node) {
    const nodeChild = node.content.firstChild;
    if (node.childCount !== 1 || !nodeChild) return false;
    return $28d5451797013a88$export$b648602b09795358(nodeChild);
}

});

parcelRegister("kWYFo", function(module, exports) {

$parcel$export(module.exports, "findNodePosByLocalIds", () => $8a10f65a200ea998$export$947fc26275418e36);
/**
 * Temporary file which extracts function from `editor-common`.
 *
 * Eventually we will deprecate and delete EditorActions. This is here to
 * help decouple it from editor-common
 */ const $8a10f65a200ea998$export$947fc26275418e36 = (state, ids, option = {})=>{
    if (ids.length === 0) return [];
    const nodes = [];
    const localIdSet = new Set(ids);
    if (option.includeDocNode && localIdSet.has(state.doc.attrs?.localId)) nodes.push({
        node: state.doc,
        pos: 0
    });
    state.doc.descendants((node, pos)=>{
        if (localIdSet.has(node.attrs?.localId)) nodes.push({
            node: node,
            pos: pos
        });
        // stop traversing once we found all the nodes
        return localIdSet.size !== nodes.length;
    });
    return nodes;
};

});

parcelRegister("dtmLc", function(module, exports) {

$parcel$export(module.exports, "toJSON", () => $50c5f8cc57b19c60$export$54fd2c36b5cc6731);
/**
 * Temporary file which extracts function from `editor-common`.
 *
 * Eventually we will deprecate and delete EditorActions. This is here to
 * help decouple it from editor-common
 */ 
var $lovmf = parcelRequire("lovmf");
const $50c5f8cc57b19c60$var$transformer = new (0, $lovmf.JSONTransformer)();
function $50c5f8cc57b19c60$export$54fd2c36b5cc6731(node) {
    return $50c5f8cc57b19c60$var$transformer.encode(node);
}

});


parcelRegister("kCWwL", function(module, exports) {

$parcel$export(module.exports, "useEditorContext", () => $61d12d29fead659b$export$b119c82498f162a5);
$parcel$export(module.exports, "default", () => $61d12d29fead659b$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $cT3Ey = parcelRequire("cT3Ey");

var $dWjPG = parcelRequire("dWjPG");

var $2pwTW = parcelRequire("2pwTW");
const $61d12d29fead659b$export$b119c82498f162a5 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useContext((0, $dWjPG.EditorContext));
class $61d12d29fead659b$export$797df872f5526664 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    constructor(props){
        super(props);
    }
    render() {
        // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, $gt9Am.jsx)($61d12d29fead659b$var$LegacyEditorContextNew, {
            ...this.props,
            children: this.props.children
        });
    }
}
function $61d12d29fead659b$var$LegacyEditorContextNew({ children: children, editorActions: editorActions }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dWjPG.EditorContext).Provider, {
        value: {
            editorActions: editorActions ?? new (0, $2pwTW.default)()
        },
        children: children
    });
}
class $61d12d29fead659b$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    static{
        this.childContextTypes = {
            editorActions: (0, (/*@__PURE__*/$parcel$interopDefault($cT3Ey))).object
        };
    }
    constructor(props){
        super(props);
        this.editorActions = props.editorActions || new (0, $2pwTW.default)();
    }
    getChildContext() {
        return {
            editorActions: this.editorActions
        };
    }
    render() {
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dWjPG.EditorContext).Provider, {
            value: this.getChildContext(),
            children: this.props.children
        });
    }
}

});
parcelRegister("dWjPG", function(module, exports) {

$parcel$export(module.exports, "EditorContext", () => $cbb76531ff6b3d2e$export$27b8dd149e32f6c7);

var $eJOHy = parcelRequire("eJOHy");
const $cbb76531ff6b3d2e$export$27b8dd149e32f6c7 = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext({});

});


parcelRegister("hUQD4", function(module, exports) {

$parcel$export(module.exports, "createFeatureFlagsFromProps", () => $89800ae9585acbb0$export$63102b0cbe181144);

var $jgFE8 = parcelRequire("jgFE8");
function $89800ae9585acbb0$var$verifyJSON(json) {
    try {
        return JSON.parse(json);
    } catch (e) {
        return undefined;
    }
}
function $89800ae9585acbb0$var$getSpellCheck(featureFlags) {
    if (!!featureFlags?.['disableSpellcheckByBrowser']) return typeof featureFlags?.['disableSpellcheckByBrowser'] === 'object' ? featureFlags?.['disableSpellcheckByBrowser'] : typeof featureFlags?.['disableSpellcheckByBrowser'] === 'string' ? $89800ae9585acbb0$var$verifyJSON(featureFlags?.['disableSpellcheckByBrowser']) : undefined;
    if (!!featureFlags?.['disable-spellcheck-by-browser']) return typeof featureFlags?.['disable-spellcheck-by-browser'] === 'object' ? featureFlags?.['disable-spellcheck-by-browser'] : typeof featureFlags?.['disable-spellcheck-by-browser'] === 'string' ? $89800ae9585acbb0$var$verifyJSON(featureFlags?.['disable-spellcheck-by-browser']) : undefined;
    return undefined;
}
function $89800ae9585acbb0$export$63102b0cbe181144(featureFlags) {
    const normalizedFeatureFlags = (0, $jgFE8.normalizeFeatureFlags)(featureFlags);
    return {
        ...normalizedFeatureFlags,
        catchAllTracking: false,
        showAvatarGroupAsPlugin: Boolean(typeof featureFlags?.showAvatarGroupAsPlugin === 'boolean' ? !!featureFlags?.showAvatarGroupAsPlugin : false),
        errorBoundaryDocStructure: Boolean(typeof featureFlags?.useErrorBoundaryDocStructure === 'boolean' ? !!featureFlags?.useErrorBoundaryDocStructure : false),
        synchronyErrorDocStructure: Boolean(typeof featureFlags?.synchronyErrorDocStructure === 'boolean' ? !!featureFlags?.synchronyErrorDocStructure : false),
        enableViewUpdateSubscription: Boolean(typeof featureFlags?.enableViewUpdateSubscription === 'boolean' ? !!featureFlags?.enableViewUpdateSubscription : false),
        collabAvatarScroll: Boolean(typeof featureFlags?.collabAvatarScroll === 'boolean' ? !!featureFlags?.collabAvatarScroll : false),
        twoLineEditorToolbar: Boolean(typeof featureFlags?.twoLineEditorToolbar === 'boolean' ? !!featureFlags?.twoLineEditorToolbar : false),
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        disableSpellcheckByBrowser: $89800ae9585acbb0$var$getSpellCheck(featureFlags)
    };
}

});

parcelRegister("1ZFgR", function(module, exports) {

$parcel$export(module.exports, "default", () => $a50c41b70f4c9cc8$export$2e2bcd8739ae039);
var $a50c41b70f4c9cc8$export$2e2bcd8739ae039 = {
    EDITOR_MOUNTED: 'Editor Component Mount Time',
    PROSEMIRROR_RENDERED: 'ProseMirror Render Time',
    PROSEMIRROR_CONTENT_RENDERED: 'ProseMirror Content Render Time',
    ON_EDITOR_READY_CALLBACK: 'onEditorReady Callback Duration'
};

});

parcelRegister("k9jP1", function(module, exports) {

$parcel$export(module.exports, "name", () => $6f0d45a1741f1dcc$export$a8ff84c12d48cfa6);
$parcel$export(module.exports, "version", () => $6f0d45a1741f1dcc$export$83d89fbfd8236492);
const $6f0d45a1741f1dcc$export$a8ff84c12d48cfa6 = "platform-pkg";
const $6f0d45a1741f1dcc$export$83d89fbfd8236492 = "0.0.0-use.local";

});

parcelRegister("7rP03", function(module, exports) {

$parcel$export(module.exports, "EditorINPMetrics", () => $2873978d0730d0bc$export$5942461441325be9);

var $eJOHy = parcelRequire("eJOHy");

var $3s8bj = parcelRequire("3s8bj");

var $ftN6c = parcelRequire("ftN6c");

var $bMFKb = parcelRequire("bMFKb");
var $cd124 = parcelRequire("cd124");

var $59Ldo = parcelRequire("59Ldo");

var $2QO3b = parcelRequire("2QO3b");
const $2873978d0730d0bc$export$5942461441325be9 = ()=>{
    const analyticsEvents = (0, $ftN6c.useAnalyticsEvents)();
    // onMount lifecycle hook
    (0, $eJOHy.useEffect)(()=>{
        let cleanupFn;
        const cleanupIdleCallback = $2873978d0730d0bc$var$createIdleCallback(()=>{
            cleanupFn = (0, $59Ldo.setupINPTracking)(({ value: value })=>{
                const interaction = (0, $2QO3b.getActiveInteraction)();
                const ufoName = interaction?.ufoName;
                $2873978d0730d0bc$var$sendAnalytics(analyticsEvents.createAnalyticsEvent, value, ufoName);
            });
        });
        // Cleanup function that will be called when the component unmounts
        return ()=>{
            cleanupIdleCallback();
            cleanupFn?.();
        };
    // Using hook as mount lifecycle hook.
    // We do not need to set dependency on analyticsEvents since we are using the analyticsEvents object reference
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // This component doesn't render anything
    return null;
};
const $2873978d0730d0bc$var$sendAnalytics = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))((createAnalyticsEvent, value, ufoName)=>{
    (0, $cd124.fireAnalyticsEvent)(createAnalyticsEvent)({
        payload: {
            // @ts-expect-error Temporary data
            action: 'inp',
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).EDITOR,
            eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
            attributes: {
                inp: value,
                ufoName: ufoName
            }
        }
    });
}, 1000, {
    trailing: true
});
const $2873978d0730d0bc$var$createIdleCallback = (callback)=>{
    if (typeof window.requestIdleCallback === 'function') {
        const id = window.requestIdleCallback(callback);
        return ()=>window.cancelIdleCallback(id);
    }
    // Fallback to setTimeout with 0 delay if requestIdleCallback is not available
    const id = window.setTimeout(callback, 0);
    return ()=>window.clearTimeout(id);
};

});
parcelRegister("59Ldo", function(module, exports) {

$parcel$export(module.exports, "setupINPTracking", () => $cb7c07d5eaf82a22$export$56930d9a67e0aae6);

var $74C10 = parcelRequire("74C10");

var $igDjg = parcelRequire("igDjg");
const $cb7c07d5eaf82a22$export$56930d9a67e0aae6 = (callback)=>{
    if (!$cb7c07d5eaf82a22$var$isINPSupported()) return;
    return (0, $74C10.onINP)((metric)=>{
        callback({
            value: metric.value
        });
    });
};
const $cb7c07d5eaf82a22$var$isINPSupported = ()=>{
    const isSSR = !window || typeof $igDjg !== 'undefined' && Boolean($igDjg?.env?.REACT_SSR || false);
    if (isSSR) return false;
    // Return if the browser doesn't support all APIs needed to measure INP.
    if (!('PerformanceEventTiming' in window && 'interactionId' in PerformanceEventTiming.prototype)) return false;
    if (!PerformanceObserver.supportedEntryTypes.includes('event') && !PerformanceObserver.supportedEntryTypes.includes('first-input')) return false;
    return true;
};

});
parcelRegister("74C10", function(module, exports) {

$parcel$export(module.exports, "onINP", () => $ff320fc665a8f45c$export$7df4b36ecaed99e1);
// Adapted from https://github.com/GoogleChrome/web-vitals/blob/main/src/lib/onINP.ts

var $9rvy8 = parcelRequire("9rvy8");

var $f5yKN = parcelRequire("f5yKN");

var $aiUnN = parcelRequire("aiUnN");

var $69eZD = parcelRequire("69eZD");
const $ff320fc665a8f45c$export$7df4b36ecaed99e1 = (callback)=>{
    const metric = {
        value: 0,
        delta: 0,
        entries: []
    };
    const reporter = (0, $9rvy8.bindReporter)(callback);
    const interactionManager = new (0, $f5yKN.InteractionManager)();
    const handleEntries = (entries)=>{
        (0, $69eZD.whenIdle)(()=>{
            entries.forEach((entry)=>interactionManager.processInteractionEntry(entry));
            const inp = interactionManager.estimateP98LongestInteraction();
            if (inp && inp.latency !== metric.value) {
                metric.value = inp.latency;
                metric.entries = entries;
                reporter(metric);
            }
        });
    };
    const po = $ff320fc665a8f45c$var$observeInteractionEvent(handleEntries);
    const onHiddenCleanup = (0, $aiUnN.onHidden)(()=>{
        handleEntries(po.takeRecords());
        reporter(metric);
    });
    return ()=>{
        po.disconnect();
        interactionManager.cleanup();
        onHiddenCleanup();
    };
};
const $ff320fc665a8f45c$var$observeInteractionEvent = (callback)=>{
    const po = new PerformanceObserver((list)=>{
        // Delay by a microtask to workaround a bug in Safari where the
        // callback is invoked immediately, rather than in a separate task.
        // See: https://github.com/GoogleChrome/web-vitals/issues/277
        Promise.resolve().then(()=>{
            callback(list.getEntries());
        });
    });
    // Event Timing entries have their durations rounded to the nearest 8ms,
    // so a duration of 40ms would be any event that spans 2.5 or more frames
    // at 60Hz. This threshold is chosen to strike a balance between usefulness
    // and performance. Running this callback for any interaction that spans
    // just one or two frames is likely not worth the insight that could be
    // gained.
    if (PerformanceObserver.supportedEntryTypes.includes('event')) po.observe({
        type: 'event',
        buffered: true,
        durationThreshold: 40
    });
    if (PerformanceObserver.supportedEntryTypes.includes('first-input')) po.observe({
        type: 'first-input',
        buffered: true
    });
    return po;
};

});
parcelRegister("9rvy8", function(module, exports) {

$parcel$export(module.exports, "bindReporter", () => $fdd0dd6328969e43$export$17679dccdd551979);
// Adapted from https://github.com/GoogleChrome/web-vitals/blob/main/src/lib/bindReporter.ts
const $fdd0dd6328969e43$export$17679dccdd551979 = (callback)=>{
    let prevValue;
    let delta;
    return (metric)=>{
        if (metric.value >= 0) {
            delta = metric.value - (prevValue || 0);
            // Report the metric if there's a non-zero delta or if no previous
            // value exists (which can happen in the case of the document becoming
            // hidden when the metric value is 0).
            // See: https://github.com/GoogleChrome/web-vitals/issues/14
            if (delta || prevValue === undefined) {
                prevValue = metric.value;
                metric.delta = delta;
                callback(metric);
            }
        }
    };
};

});

parcelRegister("f5yKN", function(module, exports) {

$parcel$export(module.exports, "InteractionManager", () => $07782c762f135a93$export$aaa80641d584351c);
// Adapted from https://github.com/GoogleChrome/web-vitals/blob/main/src/lib/interactions.ts

var $lI9Ca = parcelRequire("lI9Ca");
class $07782c762f135a93$export$aaa80641d584351c {
    static{
        this.MAX_INTERACTIONS_TO_CONSIDER = 10;
    }
    constructor(){
        this.longestInteractionList = [];
        this.longestInteractionMap = new Map();
        this.interactionCountPolyfill = new (0, $lI9Ca.InteractionCountPolyfill)();
    }
    cleanup() {
        this.interactionCountPolyfill.cleanup();
    }
    /**
	 * Returns the estimated p98 longest interaction based on the stored
	 * interaction candidates and the interaction count for the current page.
	 */ estimateP98LongestInteraction() {
        const candidateInteractionIndex = Math.min(this.longestInteractionList.length - 1, Math.floor(this.interactionCountPolyfill.getInteractionCount() / 50));
        return this.longestInteractionList[candidateInteractionIndex];
    }
    /**
	 * Takes a performance entry and adds it to the list of worst interactions
	 * if its duration is long enough to make it among the worst. If the
	 * entry is part of an existing interaction, it is merged and the latency
	 * and entries list is updated as needed.
	 */ processInteractionEntry(entry) {
        // Skip further processing for entries that cannot be INP candidates.
        if (!(entry.interactionId || entry.entryType === 'first-input')) return;
        // The least-long of the 10 longest interactions.
        const minLongestInteraction = this.longestInteractionList[this.longestInteractionList.length - 1];
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const existingInteraction = this.longestInteractionMap.get(entry.interactionId);
        // Only process the entry if it's possibly one of the ten longest,
        // or if it's part of an existing interaction.
        if (existingInteraction || this.longestInteractionList.length < $07782c762f135a93$export$aaa80641d584351c.MAX_INTERACTIONS_TO_CONSIDER || entry.duration > minLongestInteraction.latency) {
            // If the interaction already exists, update it. Otherwise create one.
            if (existingInteraction) {
                // If the new entry has a longer duration, replace the old entries,
                // otherwise add to the array.
                if (entry.duration > existingInteraction.latency) {
                    existingInteraction.entries = [
                        entry
                    ];
                    existingInteraction.latency = entry.duration;
                } else if (entry.duration === existingInteraction.latency && entry.startTime === existingInteraction.entries[0].startTime) existingInteraction.entries.push(entry);
            } else {
                const interaction = {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    id: entry.interactionId,
                    latency: entry.duration,
                    entries: [
                        entry
                    ]
                };
                this.longestInteractionMap.set(interaction.id, interaction);
                this.longestInteractionList.push(interaction);
            }
            // Sort the entries by latency (descending) and keep only the top ten.
            this.longestInteractionList.sort((a, b)=>b.latency - a.latency);
            if (this.longestInteractionList.length > $07782c762f135a93$export$aaa80641d584351c.MAX_INTERACTIONS_TO_CONSIDER) this.longestInteractionList.splice($07782c762f135a93$export$aaa80641d584351c.MAX_INTERACTIONS_TO_CONSIDER).forEach((i)=>this.longestInteractionMap.delete(i.id));
        }
    }
}

});
parcelRegister("lI9Ca", function(module, exports) {

$parcel$export(module.exports, "InteractionCountPolyfill", () => $d7103430ac5809b3$export$51e52147760fc784);
// Adapted from https://github.com/GoogleChrome/web-vitals/blob/main/src/lib/polyfills/interactionCountPolyfill.ts
class $d7103430ac5809b3$export$51e52147760fc784 {
    constructor(){
        this.interactionCountEstimate = 0;
        this.minKnownInteractionId = Infinity;
        this.maxKnownInteractionId = 0;
        if ('interactionCount' in performance || this.po) return;
        if (!PerformanceObserver.supportedEntryTypes.includes('event')) return;
        this.po = new PerformanceObserver((list)=>{
            // Delay by a microtask to workaround a bug in Safari where the
            // callback is invoked immediately, rather than in a separate task.
            // See: https://github.com/GoogleChrome/web-vitals/issues/277
            Promise.resolve().then(()=>{
                this.updateEstimate(list.getEntries());
            });
        });
        this.po.observe({
            type: 'event',
            buffered: true,
            durationThreshold: 0
        });
    }
    cleanup() {
        this.po?.disconnect();
    }
    updateEstimate(entries) {
        entries.forEach((e)=>{
            if (e.interactionId) {
                this.minKnownInteractionId = Math.min(this.minKnownInteractionId, e.interactionId);
                this.maxKnownInteractionId = Math.max(this.maxKnownInteractionId, e.interactionId);
                this.interactionCountEstimate = this.maxKnownInteractionId ? (this.maxKnownInteractionId - this.minKnownInteractionId) / 7 + 1 : 0;
            }
        });
    }
    /**
	 * Returns the `interactionCount` value using the native API (if available)
	 * or the polyfill estimate in this module.
	 */ getInteractionCount() {
        return this.po ? this.interactionCountEstimate : performance.interactionCount || 0;
    }
}

});


parcelRegister("aiUnN", function(module, exports) {

$parcel$export(module.exports, "onHidden", () => $123034d5ec99c082$export$91ec2be6fdd8f1b4);
// Adapted from https://github.com/GoogleChrome/web-vitals/blob/main/src/lib/onHidden.ts
const $123034d5ec99c082$export$91ec2be6fdd8f1b4 = (cb)=>{
    const handleVisibilityChange = ()=>{
        if (document.visibilityState === 'hidden') cb();
    };
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return ()=>{
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
};

});

parcelRegister("69eZD", function(module, exports) {

$parcel$export(module.exports, "whenIdle", () => $845c084e2c0211be$export$4d9952dcbf5b2792);
// Adapted from https://github.com/GoogleChrome/web-vitals/blob/main/src/lib/whenIdle.ts

var $aiUnN = parcelRequire("aiUnN");
const $845c084e2c0211be$export$4d9952dcbf5b2792 = (cb)=>{
    const rIC = window.requestIdleCallback || window.setTimeout;
    let handle = -1;
    cb = $845c084e2c0211be$var$runOnce(cb);
    // If the document is hidden, run the callback immediately, otherwise
    // race an idle callback with the next `visibilitychange` event.
    if (document.visibilityState === 'hidden') cb();
    else {
        const cleanup = (0, $aiUnN.onHidden)(()=>{
            cb();
            cleanup();
        });
        handle = rIC(()=>{
            cb();
            cleanup();
        });
    }
    return handle;
};
// Adapted from https://github.com/GoogleChrome/web-vitals/blob/main/src/lib/runOnce.ts
const $845c084e2c0211be$var$runOnce = (cb)=>{
    let called = false;
    return ()=>{
        if (!called) {
            cb();
            called = true;
        }
    };
};

});




parcelRegister("hk8Wh", function(module, exports) {

$parcel$export(module.exports, "EditorInternal", () => $817212d4106d8dfd$export$2617c0dabe49c335);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $bMFKb = parcelRequire("bMFKb");

var $i2Pif = parcelRequire("i2Pif");

var $eGOwo = parcelRequire("eGOwo");

var $8kDPZ = parcelRequire("8kDPZ");

var $jLBRN = parcelRequire("jLBRN");

var $kCWwL = parcelRequire("kCWwL");

var $6HxkX = parcelRequire("6HxkX");

var $hUQD4 = parcelRequire("hUQD4");

var $i5btK = parcelRequire("i5btK");

var $gk7i7 = parcelRequire("gk7i7");

var $dLePd = parcelRequire("dLePd");
function $817212d4106d8dfd$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $817212d4106d8dfd$var$editorContainerStyles = {
    name: "zxsb69",
    styles: "position:relative;width:100%;height:100%"
};
const $817212d4106d8dfd$export$2617c0dabe49c335 = /*#__PURE__*/ (0, $eJOHy.memo)(({ props: props, handleAnalyticsEvent: handleAnalyticsEvent, createAnalyticsEvent: createAnalyticsEvent, handleSave: handleSave, editorActions: editorActions, providerFactory: providerFactory, onEditorCreated: onEditorCreated, onEditorDestroyed: onEditorDestroyed, preset: preset, AppearanceComponent: AppearanceComponent })=>{
    const overriddenEditorProps = {
        ...props,
        onSave: props.onSave ? handleSave : undefined,
        // noop all analytic events, even if a handler is still passed.
        analyticsHandler: undefined
    };
    const featureFlags = (0, $hUQD4.createFeatureFlagsFromProps)(props.featureFlags);
    // Render tracking is firing too many events in Jira so we are disabling them for now. See - https://product-fabric.atlassian.net/browse/ED-25616
    // Also firing too many events for the legacy content macro, so disabling for now. See - https://product-fabric.atlassian.net/browse/ED-26650
    const renderTrackingEnabled = !(0, $eGOwo.fg)('platform_editor_disable_rerender_tracking_jira') && !featureFlags.lcmPreventRenderTracking;
    const useShallow = false;
    const [portalProviderAPI, PortalRenderer] = (0, $i2Pif.usePortalProvider)();
    const [nodeViewPortalProviderAPI, NodeViewPortalRenderer] = (0, $i2Pif.usePortalProvider)();
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Fragment), null, renderTrackingEnabled && /*#__PURE__*/ (0, $1NIU8.jsx)((0, $i5btK.RenderTracking), {
        componentProps: props,
        action: (0, $bMFKb.ACTION).RE_RENDERED,
        actionSubject: (0, $bMFKb.ACTION_SUBJECT).EDITOR,
        handleAnalyticsEvent: handleAnalyticsEvent,
        propsToIgnore: [
            'defaultValue'
        ],
        useShallow: useShallow
    }), /*#__PURE__*/ (0, $1NIU8.jsx)((0, $8kDPZ.default), {
        errorTracking: true,
        createAnalyticsEvent: createAnalyticsEvent,
        contextIdentifierProvider: props.contextIdentifierProvider,
        featureFlags: featureFlags
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $817212d4106d8dfd$var$editorContainerStyles
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $kCWwL.default), {
        editorActions: editorActions
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $6HxkX.IntlProviderIfMissingWrapper), null, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Fragment), null, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $jLBRN.default), {
        editorProps: overriddenEditorProps,
        createAnalyticsEvent: createAnalyticsEvent,
        portalProviderAPI: portalProviderAPI,
        nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
        providerFactory: providerFactory,
        onEditorCreated: onEditorCreated,
        onEditorDestroyed: onEditorDestroyed,
        disabled: props.disabled,
        preset: preset,
        render: ({ editor: editor, view: view, eventDispatcher: eventDispatcher, config: config, dispatchAnalyticsEvent: dispatchAnalyticsEvent, editorRef: editorRef, editorAPI: editorAPI })=>/*#__PURE__*/ (0, $1NIU8.jsx)((0, $gk7i7.BaseThemeWrapper), {
                baseFontSize: (0, $dLePd.getBaseFontSize)(props.appearance)
            }, /*#__PURE__*/ (0, $1NIU8.jsx)(AppearanceComponent, {
                innerRef: editorRef,
                editorAPI: editorAPI,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                appearance: props.appearance,
                disabled: props.disabled,
                editorActions: editorActions,
                editorDOMElement: editor,
                editorView: view,
                providerFactory: providerFactory,
                eventDispatcher: eventDispatcher,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                maxHeight: props.maxHeight,
                minHeight: props.minHeight,
                onSave: props.onSave ? handleSave : undefined,
                onCancel: props.onCancel,
                popupsMountPoint: props.popupsMountPoint,
                popupsBoundariesElement: props.popupsBoundariesElement,
                popupsScrollableElement: props.popupsScrollableElement,
                contentComponents: config.contentComponents,
                primaryToolbarComponents: config.primaryToolbarComponents,
                primaryToolbarIconBefore: props.primaryToolbarIconBefore,
                secondaryToolbarComponents: config.secondaryToolbarComponents,
                customContentComponents: props.contentComponents,
                customPrimaryToolbarComponents: props.primaryToolbarComponents,
                customSecondaryToolbarComponents: props.secondaryToolbarComponents,
                contextPanel: props.contextPanel,
                collabEdit: props.collabEdit,
                persistScrollGutter: props.persistScrollGutter,
                enableToolbarMinWidth: props.featureFlags?.toolbarMinWidthOverflow != null ? !!props.featureFlags?.toolbarMinWidthOverflow : props.allowUndoRedoButtons,
                useStickyToolbar: props.useStickyToolbar,
                featureFlags: featureFlags,
                pluginHooks: config.pluginHooks,
                __livePage: props.__livePage,
                preset: preset
            }))
    }), /*#__PURE__*/ (0, $1NIU8.jsx)(PortalRenderer, null), /*#__PURE__*/ (0, $1NIU8.jsx)(NodeViewPortalRenderer, null)))))));
});

});
parcelRegister("i2Pif", function(module, exports) {

$parcel$export(module.exports, "usePortalProvider", () => $4646bebc3aa0f491$export$9b00782c24eb3d6b);

var $eJOHy = parcelRequire("eJOHy");

var $1qnsL = parcelRequire("1qnsL");

var $fn460 = parcelRequire("fn460");
function $4646bebc3aa0f491$export$9b00782c24eb3d6b() {
    const portalManager = (0, $eJOHy.useMemo)(()=>new (0, $fn460.PortalManager)(), []);
    const PortalRenderer = (0, $eJOHy.useMemo)(()=>(0, $1qnsL.createPortalRendererComponent)(portalManager), [
        portalManager
    ]);
    const portalProviderAPI = (0, $eJOHy.useMemo)(()=>(0, $1qnsL.getPortalProviderAPI)(portalManager), [
        portalManager
    ]);
    // Cleanup on unmount
    (0, $eJOHy.useEffect)(()=>{
        return ()=>{
            portalProviderAPI.destroy();
        };
    }, [
        portalManager,
        portalProviderAPI
    ]);
    return [
        portalProviderAPI,
        PortalRenderer
    ];
}

});
parcelRegister("1qnsL", function(module, exports) {

$parcel$export(module.exports, "createPortalRendererComponent", () => $6429de9c70dbffb7$export$adfaaa25a1ea6e69);
$parcel$export(module.exports, "getPortalProviderAPI", () => $6429de9c70dbffb7$export$3a6b5f5c5bba4bde);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $aQK2r = parcelRequire("aQK2r");

var $hUHRU = parcelRequire("hUHRU");
function $6429de9c70dbffb7$export$adfaaa25a1ea6e69(portalManager) {
    return function PortalRenderer() {
        const [buckets, setBuckets] = (0, $eJOHy.useState)(portalManager.getBuckets());
        (0, $eJOHy.useLayoutEffect)(()=>{
            portalManager.registerPortalRenderer(setBuckets);
            return ()=>{
                portalManager.unregisterPortalRenderer();
            };
        }, []);
        const portalsElements = (0, $eJOHy.useMemo)(// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        ()=>buckets.map((_, i)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $hUHRU.PortalBucket), {
                    id: i,
                    portalManager: portalManager
                }, i)), [
            buckets
        ]);
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
            children: portalsElements
        });
    };
}
const $6429de9c70dbffb7$export$eab0ea19ad3bed77 = ({ getChildren: getChildren, onBeforeRender: onBeforeRender })=>{
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (onBeforeRender) onBeforeRender();
    }, [
        onBeforeRender
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: getChildren()
    });
};
const $6429de9c70dbffb7$var$PortalRenderWrapper = /*#__PURE__*/ (0, $eJOHy.memo)($6429de9c70dbffb7$export$eab0ea19ad3bed77);
$6429de9c70dbffb7$var$PortalRenderWrapper.displayName = 'PortalRenderWrapper';
const $6429de9c70dbffb7$export$3a6b5f5c5bba4bde = (portalManager)=>{
    const portalsMap = new Map();
    return {
        render: (children, container, key, onBeforeReactDomRender)=>{
            if (typeof onBeforeReactDomRender === 'function') {
                const portal = /*#__PURE__*/ (0, $aQK2r.createPortal)(/*#__PURE__*/ (0, $gt9Am.jsx)($6429de9c70dbffb7$var$PortalRenderWrapper, {
                    getChildren: children,
                    onBeforeRender: onBeforeReactDomRender
                }), container, key);
                portalsMap.set(key, portalManager.registerPortal(key, portal));
            } else {
                const portal = /*#__PURE__*/ (0, $aQK2r.createPortal)(children(), container, key);
                portalsMap.set(key, portalManager.registerPortal(key, portal));
            }
        },
        remove: (key)=>{
            portalsMap.get(key)?.();
            portalsMap.delete(key);
        },
        destroy: ()=>{
            portalsMap.clear();
            portalManager.destroy();
        }
    };
};

});
parcelRegister("hUHRU", function(module, exports) {

$parcel$export(module.exports, "PortalBucket", () => $564ebff32eef59b5$export$828f0f29e8293a07);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
function $564ebff32eef59b5$export$828f0f29e8293a07({ id: id, portalManager: portalManager }) {
    // State to hold the current portals for this bucket
    const [portals, setPortals] = (0, $eJOHy.useState)({});
    // Effect to register/unregister this bucket with the portal manager on mount/unmount
    (0, $eJOHy.useLayoutEffect)(()=>{
        portalManager.registerBucket(id, setPortals);
        return ()=>{
            portalManager.unregisterBucket(id);
        };
    }, [
        id,
        portalManager
    ]);
    // Memoize the portal elements to avoid unnecessary re-renders
    const portalElements = (0, $eJOHy.useMemo)(()=>Object.values(portals), [
        portals
    ]);
    // Render the current portal elements
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: portalElements
    });
}

});


parcelRegister("fn460", function(module, exports) {

$parcel$export(module.exports, "PortalManager", () => $20f010b4fef23297$export$52c7ef79917c2f38);
const $20f010b4fef23297$var$DEFAULT_INITIAL_BUCKETS = 50;
const $20f010b4fef23297$var$DEFAULT_MAX_BUCKET_CAPACITY = 50;
const $20f010b4fef23297$var$DEFAULT_SCALE_RATIO = 0.5;
/**
 * Creates an empty bucket object with a specified capacity. Each bucket is designed
 * to hold a certain number of React portals and has an associated updater function
 * which can be null initially.
 *
 * @function createEmptyBucket
 * @param {number} capacity - The maximum capacity of the bucket.
 * @returns {PortalBucketType} An object representing an empty bucket with the specified capacity.
 */ function $20f010b4fef23297$var$createEmptyBucket(capacity) {
    return {
        portals: {},
        capacity: capacity,
        updater: null
    };
}
class $20f010b4fef23297$export$52c7ef79917c2f38 {
    constructor(initialBuckets = $20f010b4fef23297$var$DEFAULT_INITIAL_BUCKETS, maxBucketCapacity = $20f010b4fef23297$var$DEFAULT_MAX_BUCKET_CAPACITY, scaleRatio = $20f010b4fef23297$var$DEFAULT_SCALE_RATIO){
        this.maxBucketCapacity = maxBucketCapacity;
        this.scaleRatio = scaleRatio;
        // Initialise buckets array by creating an array of length `initialBuckets` containing empty buckets
        this.buckets = Array.from({
            length: initialBuckets
        }, ()=>$20f010b4fef23297$var$createEmptyBucket(maxBucketCapacity));
        this.portalToBucketMap = new Map();
        this.availableBuckets = new Set(Array.from({
            length: initialBuckets
        }, (_, i)=>i));
        this.portalRendererUpdater = null;
        this.scaleCapacityThreshold = maxBucketCapacity / 2;
    }
    getCurrentBucket() {
        return this.availableBuckets.values().next().value;
    }
    createBucket() {
        const currentBucket = this.getCurrentBucket();
        //If the current bucket has capacity, skip this logic
        if (this.buckets[currentBucket].capacity > 0) return;
        else // The current bucket is full, delete the bucket from the list of available buckets
        this.availableBuckets.delete(currentBucket);
        // Skip creating new bucket if there are buckets still available
        if (this.availableBuckets.size > 0) return;
        // Scale the buckets up only if there are no available buckets left
        // Calculate how many new buckets need to be added
        const numBucketsToAdd = Math.floor(this.buckets.length * this.scaleRatio);
        this.buckets = [
            ...this.buckets
        ];
        for(let i = 0; i < numBucketsToAdd; i++){
            this.buckets.push($20f010b4fef23297$var$createEmptyBucket(this.maxBucketCapacity));
            this.availableBuckets.add(this.buckets.length - 1);
        }
        this.portalRendererUpdater?.(this.buckets);
    }
    getBuckets() {
        return this.buckets;
    }
    registerBucket(id, updater) {
        this.buckets[id].updater = updater;
        this.buckets[id].updater?.(()=>({
                ...this.buckets[id].portals
            }));
    }
    unregisterBucket(id) {
        this.buckets[id].updater = null;
    }
    updateBuckets(id) {
        this.buckets[id].updater?.(()=>{
            // new object is required to trigger react updates
            return {
                ...this.buckets[id].portals
            };
        });
    }
    registerPortal(key, portal) {
        this.createBucket();
        this.buckets[this.getCurrentBucket()].capacity -= 1;
        const id = this.portalToBucketMap.get(key) ?? this.getCurrentBucket();
        this.portalToBucketMap.set(key, id);
        if (this.buckets[id].portals[key] !== portal) {
            this.buckets[id].portals[key] = portal;
            this.updateBuckets(id);
        }
        //returns a function to unregister the portal
        return ()=>{
            delete this.buckets[id].portals[key];
            this.portalToBucketMap.delete(key);
            this.buckets[id].capacity += 1;
            if (this.buckets[id].capacity > this.scaleCapacityThreshold) this.availableBuckets.add(id);
            this.updateBuckets(id);
        };
    }
    registerPortalRenderer(updater) {
        if (!this.portalRendererUpdater) updater(()=>this.buckets);
        this.portalRendererUpdater = updater;
    }
    unregisterPortalRenderer() {
        this.portalRendererUpdater = null;
    }
    /**
	 * Cleans up resources used by the PortalManager. This includes clearing all portals,
	 * unregistering all buckets, and resetting internal state.
	 */ destroy() {
        // Iterate through each bucket and clear its portals and unset the updater function
        this.buckets.forEach((bucket, id)=>{
            bucket.portals = {}; // Clearing all portals from the bucket
            bucket.updater = null; // Unsetting the bucket's updater function
            this.availableBuckets.add(id); // Mark all buckets as available
        });
        this.portalToBucketMap.clear();
        this.portalRendererUpdater = null;
        this.availableBuckets = new Set(this.buckets.map((_, index)=>index));
    }
}

});


parcelRegister("8kDPZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b525350fd30c7c95$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $aXKmr = parcelRequire("aXKmr");

var $bMFKb = parcelRequire("bMFKb");
var $cd124 = parcelRequire("cd124");

var $eemFN = parcelRequire("eemFN");

var $jjlK8 = parcelRequire("jjlK8");

var $djRdf = parcelRequire("djRdf");

var $6L9Sq = parcelRequire("6L9Sq");

var $52SlE = parcelRequire("52SlE");
class $b525350fd30c7c95$export$d6d3bedcc5fc09c8 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    static{
        this.defaultProps = {
            rethrow: true,
            errorTracking: true
        };
    }
    constructor(props){
        super(props), this.browserExtensions = undefined, this.state = {
            error: undefined
        }, this.sendErrorData = async (analyticsErrorPayload)=>{
            const product = await this.getProductName();
            const { error: error, errorInfo: errorInfo } = analyticsErrorPayload;
            const sharedId = (0, (/*@__PURE__*/$parcel$interopDefault($aXKmr)))();
            const browserInfo = window?.navigator?.userAgent || 'unknown';
            const attributes = {
                product: product,
                browserInfo: browserInfo,
                error: error.toString(),
                errorInfo: errorInfo,
                errorId: sharedId,
                browserExtensions: this.browserExtensions,
                docStructure: this.featureFlags.errorBoundaryDocStructure && this.props.editorView ? (0, $eemFN.getDocStructure)(this.props.editorView.state.doc, {
                    compact: true
                }) : undefined,
                outdatedBrowser: (0, $6L9Sq.isOutdatedBrowser)(browserInfo)
            };
            this.fireAnalyticsEvent({
                action: (0, $bMFKb.ACTION).EDITOR_CRASHED,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).EDITOR,
                eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL,
                attributes: attributes
            });
            this.fireAnalyticsEvent({
                action: (0, $bMFKb.ACTION).EDITOR_CRASHED_ADDITIONAL_INFORMATION,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).EDITOR,
                eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    errorId: sharedId
                }
            });
            (0, $djRdf.logException)(error, {
                location: 'editor-core/create-editor',
                product: product
            });
        }, this.getProductName = async ()=>{
            const { contextIdentifierProvider: contextIdentifierProvider } = this.props;
            if (contextIdentifierProvider) {
                const context = await contextIdentifierProvider;
                if (context.product) return context.product;
            }
            return 'atlaskit';
        }, this.fireAnalyticsEvent = (event)=>{
            this.props.createAnalyticsEvent?.(event).fire((0, $cd124.editorAnalyticsChannel));
        };
        this.featureFlags = props.featureFlags;
    }
    componentDidCatch(error, errorInfo) {
        // Only report and re-render once, to avoid over-reporting errors and infinite rerendering
        if (this.state.error) return;
        if (this.props.errorTracking) this.sendErrorData({
            error: error,
            errorInfo: errorInfo,
            errorStack: error.stack
        });
        // Update state to allow a re-render to attempt graceful recovery (in the event that
        // the error was caused by a race condition or is intermittent)
        this.setState({
            error: error
        }, ()=>{
            if (this.props.rethrow) // Now that a re-render has occurred, we re-throw to allow product error boundaries
            // to catch and handle the error too.
            //
            // Note that when rethrowing inside a error boundary, the stack trace
            // from a higher error boundary's componentDidCatch.info param will reset
            // to this component, instead of the original component which threw it.
            throw error;
        });
    }
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // FIXME: This is causing more problems then it's solving. The async check to sniff the browser extensions is block some
    // react unit tests. Essentially jest never completes and just hangs. This was code was added 3yrs ago so that errors
    // would detail if the browser had grammarly extension installed or not. I'm not sure if anyone has every inspecting this
    // as it doesn't look like any dashboards exist for it.
    // You can see the open handles that are block tests if you run unit tests with --detectOpenHandles
    // async componentDidMount() {
    // 	this.browserExtensions = await sniffUserBrowserExtensions({
    // 		extensions: ['grammarly'],
    // 		async: true,
    // 		asyncTimeoutMs: 20000,
    // 	});
    // }
    render() {
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jjlK8.IntlErrorBoundary), {
            children: this.props.children
        });
    }
}
var $b525350fd30c7c95$export$2e2bcd8739ae039 = (0, $52SlE.WithEditorView)($b525350fd30c7c95$export$d6d3bedcc5fc09c8);

});
parcelRegister("eemFN", function(module, exports) {

$parcel$export(module.exports, "getDocStructure", () => $d9ff8bf4a728f56a$export$6451b72139862cbd);
const $d9ff8bf4a728f56a$var$hash = {
    nodes: {
        doc: 'doc',
        paragraph: 'p',
        text: 't',
        bulletList: 'ul',
        orderedList: 'ol',
        listItem: 'li',
        heading: 'h',
        blockquote: 'blockq',
        codeBlock: 'codebl',
        panel: 'pnl',
        rule: 'rl',
        hardBreak: 'br',
        mention: 'ment',
        emoji: 'emj',
        image: 'img',
        caption: 'cap',
        media: 'media',
        mediaGroup: 'mediag',
        mediaSingle: 'medias',
        plain: 'pln',
        table: 'table',
        tableCell: 'td',
        tableHeader: 'th',
        tableRow: 'tr',
        decisionList: 'dl',
        decisionItem: 'di',
        taskList: 'tl',
        taskItem: 'ti',
        extension: 'ext',
        inlineExtension: 'exti',
        bodiedExtension: 'extb',
        multiBodiedExtension: 'extmbe',
        extensionFrame: 'extfrm',
        status: 'sts',
        placeholder: 'plh',
        inlineCard: 'cardi',
        blockCard: 'cardb',
        embedCard: 'carde',
        expand: 'exp',
        nestedExpand: 'expn',
        unsupportedBlock: 'unsupb',
        unsupportedInline: 'unsupi',
        unknownBlock: 'unkb',
        date: 'date'
    },
    marks: {
        em: 'em',
        strong: 'strong',
        code: 'code',
        strike: 'strike',
        underline: 'undline',
        link: 'lnk',
        subsup: 'subsup',
        textColor: 'txtclr',
        unsupportedMark: 'unsupmrk',
        unsupportedNodeAttribute: 'unsupnattr',
        annotation: 'anno'
    }
};
function $d9ff8bf4a728f56a$var$shortHash(type, isMark) {
    const code = $d9ff8bf4a728f56a$var$hash[isMark ? 'marks' : 'nodes'][type];
    return code ? code : type;
}
function $d9ff8bf4a728f56a$var$compactStringifier(node) {
    const isContentEmpty = !node.content;
    const isTextNode = node?.type === 'text';
    const hasMarks = node.marks?.length;
    const isContentArray = Array.isArray(node.content);
    const marks = (child)=>{
        if (hasMarks) // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return node.marks.reduce((str, mark)=>`${$d9ff8bf4a728f56a$var$shortHash(mark, true)}(${str})`, child);
        return child;
    };
    let content;
    if (isTextNode) content = String(node.nodeSize);
    else if (isContentEmpty) content = '';
    else if (isContentArray) // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    content = node.content.map((node)=>$d9ff8bf4a728f56a$var$compactStringifier(node)).join(',');
    return marks(`${$d9ff8bf4a728f56a$var$shortHash(node.type, false)}(${content})`);
}
const $d9ff8bf4a728f56a$export$6451b72139862cbd = (doc, options)=>{
    try {
        const result = $d9ff8bf4a728f56a$var$getBlockNode(doc, 0);
        if (options?.compact) return $d9ff8bf4a728f56a$var$compactStringifier(result);
        return result;
    } catch (error) {
        return `Error logging document structure: ${error}`;
    }
};
const $d9ff8bf4a728f56a$var$getBlockNode = (node, pos)=>{
    const blockNode = {
        type: node.type.name,
        pos: pos,
        nodeSize: node.nodeSize
    };
    const content = $d9ff8bf4a728f56a$var$getBlockNodeContent(node.content, pos);
    if (content.length > 0) blockNode.content = content;
    const marks = $d9ff8bf4a728f56a$var$getMarks(node);
    if (marks.length > 0) blockNode.marks = marks;
    return blockNode;
};
const $d9ff8bf4a728f56a$var$getBlockNodeContent = (node, pos)=>{
    if (!node || !node.content || !node.content.length) return [];
    let blockNodeContent = [];
    const { content: content } = node;
    if (content[0].isBlock) {
        // children are block nodes
        let prevNode;
        blockNodeContent = content.map((node)=>{
            pos += prevNode ? prevNode.nodeSize : 1;
            prevNode = node;
            return $d9ff8bf4a728f56a$var$getBlockNode(node, pos);
        });
    } else {
        // children are inline nodes .
        const result = $d9ff8bf4a728f56a$var$getInlineNodes(content, pos);
        blockNodeContent = result.inlineNodes;
        pos = result.pos;
    }
    return blockNodeContent;
};
const $d9ff8bf4a728f56a$var$getInlineNodes = (nodes, pos)=>{
    const inlineNodes = nodes.map((node)=>{
        const { nodeSize: nodeSize } = node;
        const inlineNode = {
            type: node.type.name,
            pos: pos,
            nodeSize: nodeSize
        };
        const marks = $d9ff8bf4a728f56a$var$getMarks(node);
        if (marks.length > 0) inlineNode.marks = marks;
        pos += nodeSize;
        return inlineNode;
    });
    return {
        inlineNodes: inlineNodes,
        pos: pos
    };
};
const $d9ff8bf4a728f56a$var$getMarks = (node)=>node.marks.map((mark)=>mark.type.name);

});

parcelRegister("6L9Sq", function(module, exports) {

$parcel$export(module.exports, "isOutdatedBrowser", () => $93aebe4619b5fb8c$export$12d09524e028927);
const $93aebe4619b5fb8c$export$12d09524e028927 = (userAgent)=>{
    // Take browsers in both Desktop and Mobile (includes Chrome, Firefox, Edge and Safari) within last 2 years
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const chrome = /Chrome\//.test(userAgent) && !/OPR\//.test(userAgent);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const chromeVersion = chrome ? parseInt((userAgent.match(/Chrome\/(\d+)/) || [])[1], 10) : 0;
    if (chromeVersion >= 84) return false;
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const gecko = /gecko\/\d/i.test(userAgent);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const geckoVersion = gecko ? parseInt((userAgent.match(/Firefox\/(\d+)/) || [])[1], 10) : 0;
    if (geckoVersion >= 84) return false;
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const edge = /Edge\/(\d+)/.exec(userAgent);
    const edgeVersion = edge ? +edge[1] : 0;
    if (edgeVersion >= 84) return false;
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const safari = !chrome && !gecko && /Version\/([0-9\._]+).*Safari/.test(userAgent);
    const safariVersion = safari ? // eslint-disable-next-line require-unicode-regexp
    parseInt((userAgent.match(/Version\/([0-9\._]+).*Safari/) || [])[1], 10) : 0;
    if (safariVersion >= 12) return false;
    return true;
};

});

parcelRegister("52SlE", function(module, exports) {

$parcel$export(module.exports, "WithEditorView", () => $e8537f9f2fd3cf1d$export$cf381084b490bd31);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kCWwL = parcelRequire("kCWwL");
const $e8537f9f2fd3cf1d$export$cf381084b490bd31 = (WrappedComponent)=>{
    const _WithFeatureFlags = (props)=>{
        const { editorActions: editorActions } = (0, $kCWwL.useEditorContext)();
        return(// Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        /*#__PURE__*/ (0, $gt9Am.jsx)(WrappedComponent, {
            ...props,
            editorView: editorActions?._privateGetEditorView()
        }));
    };
    return _WithFeatureFlags;
};

});


parcelRegister("jLBRN", function(module, exports) {

$parcel$export(module.exports, "default", () => $97220bff0cbd31bb$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $6YFG2 = parcelRequire("6YFG2");

var $8KLBw = parcelRequire("8KLBw");

var $bMFKb = parcelRequire("bMFKb");
var $cd124 = parcelRequire("cd124");
var $8MfCL = parcelRequire("8MfCL");

var $aoyv9 = parcelRequire("aoyv9");

var $2Kn3g = parcelRequire("2Kn3g");
var $5ZVTg = parcelRequire("5ZVTg");

var $elRHR = parcelRequire("elRHR");

var $jgFE8 = parcelRequire("jgFE8");

var $65rqJ = parcelRequire("65rqJ");

var $Sk9g1 = parcelRequire("Sk9g1");

var $dTLXq = parcelRequire("dTLXq");

var $51k6y = parcelRequire("51k6y");

var $g9imq = parcelRequire("g9imq");

var $dyNYh = parcelRequire("dyNYh");

var $bnAxN = parcelRequire("bnAxN");

var $3lIcL = parcelRequire("3lIcL");

var $b7EWj = parcelRequire("b7EWj");

var $eGOwo = parcelRequire("eGOwo");

var $2QO3b = parcelRequire("2QO3b");

var $cbSL1 = parcelRequire("cbSL1");

var $jy3uD = parcelRequire("jy3uD");

var $hUQD4 = parcelRequire("hUQD4");

var $4wM3w = parcelRequire("4wM3w");

var $7uu4v = parcelRequire("7uu4v");

var $i5btK = parcelRequire("i5btK");

var $1ZFgR = parcelRequire("1ZFgR");


var $20Ctl = parcelRequire("20Ctl");

var $lAhIB = parcelRequire("lAhIB");

var $3bqXX = parcelRequire("3bqXX");

var $erdK2 = parcelRequire("erdK2");

var $jGMZf = parcelRequire("jGMZf");

var $aHrTy = parcelRequire("aHrTy");

var $YsDKQ = parcelRequire("YsDKQ");

var $l9xeW = parcelRequire("l9xeW");

var $2afhI = parcelRequire("2afhI");
const $97220bff0cbd31bb$var$EDIT_AREA_ID = 'ak-editor-textarea';
function $97220bff0cbd31bb$export$e7d1b1cbca007e16(props) {
    const { preset: preset, editorProps: { appearance: nextAppearance, disabled: disabled, featureFlags: editorPropFeatureFlags, errorReporterHandler: errorReporterHandler, defaultValue: defaultValue, shouldFocus: shouldFocus, __livePage: __livePage }, onEditorCreated: onEditorCreated, onEditorDestroyed: onEditorDestroyed } = props;
    const [editorAPI, setEditorAPI] = (0, $eJOHy.useState)(undefined);
    const editorRef = (0, $eJOHy.useRef)(null);
    const viewRef = (0, $eJOHy.useRef)();
    const focusTimeoutId = (0, $eJOHy.useRef)();
    // ProseMirror is instantiated prior to the initial React render cycle,
    // so we allow transactions by default, to avoid discarding the initial one.
    const canDispatchTransactions = (0, $eJOHy.useRef)(true);
    const editorId = (0, $eJOHy.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($8KLBw)))());
    const eventDispatcher = (0, $eJOHy.useMemo)(()=>new (0, $aoyv9.EventDispatcher)(), []);
    const config = (0, $eJOHy.useRef)({
        nodes: [],
        marks: [],
        pmPlugins: [],
        contentComponents: [],
        pluginHooks: [],
        primaryToolbarComponents: [],
        secondaryToolbarComponents: [],
        onEditorViewStateUpdatedCallbacks: []
    });
    const contentTransformer = (0, $eJOHy.useRef)(undefined);
    const featureFlags = (0, $eJOHy.useMemo)(()=>(0, $hUQD4.createFeatureFlagsFromProps)(editorPropFeatureFlags), [
        editorPropFeatureFlags
    ]);
    const getEditorState = (0, $eJOHy.useCallback)(()=>viewRef.current?.state, []);
    const getEditorView = (0, $eJOHy.useCallback)(()=>viewRef.current, []);
    const dispatch = (0, $eJOHy.useMemo)(()=>(0, $aoyv9.createDispatch)(eventDispatcher), [
        eventDispatcher
    ]);
    const errorReporter = (0, $eJOHy.useMemo)(()=>(0, $20Ctl.createErrorReporter)(errorReporterHandler), [
        errorReporterHandler
    ]);
    const handleAnalyticsEvent = (0, $eJOHy.useCallback)((payload)=>{
        (0, $cd124.fireAnalyticsEvent)(props.createAnalyticsEvent)(payload);
    }, [
        props.createAnalyticsEvent
    ]);
    const dispatchAnalyticsEvent = (0, $eJOHy.useCallback)((payload)=>{
        const dispatch = (0, $aoyv9.createDispatch)(eventDispatcher);
        dispatch((0, $dyNYh.analyticsEventKey), {
            payload: payload
        });
    }, [
        eventDispatcher
    ]);
    const pluginInjectionAPI = (0, $eJOHy.useRef)(new (0, $dTLXq.EditorPluginInjectionAPI)({
        getEditorState: getEditorState,
        getEditorView: getEditorView,
        fireAnalyticsEvent: handleAnalyticsEvent
    }));
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (!(0, $eGOwo.fg)('platform_editor_setup_editorapi_sync')) setEditorAPI(pluginInjectionAPI.current.api());
    }, []);
    const createEditorState = (0, $eJOHy.useCallback)((options)=>{
        let schema;
        if (viewRef.current) {
            if (options.resetting) /**
					 * ReactEditorView currently does NOT handle dynamic schema,
					 * We are reusing the existing schema, and rely on #reconfigureState
					 * to update `this.config`
					 */ schema = viewRef.current.state.schema;
            else {
                /**
					 * There's presently a number of issues with changing the schema of a
					 * editor inflight. A significant issue is that we lose the ability
					 * to keep track of a user's history as the internal plugin state
					 * keeps a list of Steps to undo/redo (which are tied to the schema).
					 * Without a good way to do work around this, we prevent this for now.
					 */ // eslint-disable-next-line no-console
                console.warn('The editor does not support changing the schema dynamically.');
                return viewRef.current.state;
            }
        } else {
            config.current = (0, $20Ctl.processPluginsList)((0, $lAhIB.default)(options.props.preset, props.editorProps, pluginInjectionAPI.current));
            schema = (0, $3bqXX.createSchema)(config.current);
            if ((0, $eGOwo.fg)('platform_editor_setup_editorapi_sync')) setEditorAPI(pluginInjectionAPI.current.api());
        }
        const { contentTransformerProvider: contentTransformerProvider } = options.props.editorProps;
        const plugins = (0, $20Ctl.createPMPlugins)({
            schema: schema,
            dispatch: dispatch,
            errorReporter: errorReporter,
            editorConfig: config.current,
            eventDispatcher: eventDispatcher,
            providerFactory: options.props.providerFactory,
            portalProviderAPI: props.portalProviderAPI,
            nodeViewPortalProviderAPI: props.nodeViewPortalProviderAPI,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            featureFlags: featureFlags,
            getIntl: ()=>props.intl,
            onEditorStateUpdated: (0, $eGOwo.fg)('platform_editor_catch_missing_injection_states') ? pluginInjectionAPI.current.onEditorViewUpdated : undefined
        });
        contentTransformer.current = contentTransformerProvider ? contentTransformerProvider(schema) : undefined;
        const api = pluginInjectionAPI.current.api();
        // If we have a doc prop, we need to process it into a PMNode
        let doc;
        if (options.doc) {
            // if the collabEdit API is set, skip this validation due to potential pm validation errors
            // from docs that end up with invalid marks after processing (See #hot-111702 for more details)
            if (api?.collabEdit !== undefined && (0, $eGOwo.fg)('editor_load_conf_collab_docs_without_checks') || options.props.editorProps.skipValidation) doc = (0, $51k6y.processRawValueWithoutValidation)(schema, options.doc, dispatchAnalyticsEvent);
            else doc = (0, $51k6y.processRawValue)(schema, options.doc, options.props.providerFactory, options.props.editorProps.sanitizePrivateContent, contentTransformer.current, dispatchAnalyticsEvent);
        }
        const isViewMode = api?.editorViewMode?.sharedState.currentState().mode === 'view';
        let selection;
        if (doc) {
            if (isViewMode) {
                const emptySelection = new (0, $3lIcL.TextSelection)(doc.resolve(0));
                return (0, $3lIcL.EditorState).create({
                    schema: schema,
                    plugins: plugins,
                    doc: doc,
                    selection: emptySelection
                });
            } else selection = options.selectionAtStart ? (0, $3lIcL.Selection).atStart(doc) : (0, $3lIcL.Selection).atEnd(doc);
        }
        // Workaround for ED-3507: When media node is the last element, scrollIntoView throws an error
        const patchedSelection = selection ? (0, $3lIcL.Selection).findFrom(selection.$head, -1, true) || undefined : undefined;
        return (0, $3lIcL.EditorState).create({
            schema: schema,
            plugins: plugins,
            doc: doc,
            selection: patchedSelection
        });
    }, [
        errorReporter,
        featureFlags,
        props.intl,
        props.portalProviderAPI,
        props.nodeViewPortalProviderAPI,
        props.editorProps,
        dispatchAnalyticsEvent,
        eventDispatcher,
        dispatch
    ]);
    const initialEditorState = (0, $eJOHy.useMemo)(()=>createEditorState({
            props: props,
            doc: defaultValue,
            // ED-4759: Don't set selection at end for full-page editor - should be at start.
            selectionAtStart: (0, $7uu4v.isFullPage)(nextAppearance)
        }), // This is only used for the initial state - afterwards we will have `viewRef` available for use
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    const getCurrentEditorState = (0, $eJOHy.useCallback)(()=>{
        return viewRef.current?.state ?? initialEditorState;
    }, [
        initialEditorState
    ]);
    const blur = (0, $eJOHy.useCallback)(()=>{
        if (!viewRef.current) return;
        if (viewRef.current.dom instanceof HTMLElement && viewRef.current.hasFocus()) viewRef.current.dom.blur();
        // The selectionToDOM method uses the document selection to determine currently selected node
        // We need to mimic blurring this as it seems doing the above is not enough.
        // @ts-expect-error
        const sel = viewRef.current.root.getSelection();
        if (sel) sel.removeAllRanges();
    }, []);
    const resetEditorState = (0, $eJOHy.useCallback)(({ doc: doc, shouldScrollToBottom: shouldScrollToBottom })=>{
        if (!viewRef.current) return;
        // We cannot currently guarantee when all the portals will have re-rendered during a reconfigure
        // so we blur here to stop ProseMirror from trying to apply selection to detached nodes or
        // nodes that haven't been re-rendered to the document yet.
        blur();
        const newEditorState = createEditorState({
            props: props,
            doc: doc,
            resetting: true,
            selectionAtStart: !shouldScrollToBottom
        });
        viewRef.current.updateState(newEditorState);
        props.editorProps.onChange?.(viewRef.current, {
            source: 'local',
            isDirtyChange: false
        });
    }, [
        blur,
        createEditorState,
        props
    ]);
    // Initialise phase
    // Using constructor hook so we setup and dispatch analytics before anything else
    (0, $2Kn3g.default)(()=>{
        // This needs to be before initialising editorState because
        // we dispatch analytics events in plugin initialisation
        eventDispatcher.on((0, $dyNYh.analyticsEventKey), handleAnalyticsEvent);
        eventDispatcher.on('resetEditorState', resetEditorState);
        dispatchAnalyticsEvent({
            action: (0, $bMFKb.ACTION).STARTED,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).EDITOR,
            attributes: {
                platform: (0, $8MfCL.PLATFORMS).WEB,
                featureFlags: featureFlags ? (0, $jgFE8.getEnabledFeatureFlagKeys)(featureFlags) : [],
                accountLocale: props.intl?.locale,
                browserLocale: window.navigator.language
            },
            eventType: (0, $bMFKb.EVENT_TYPE).UI
        });
    });
    (0, $eJOHy.useLayoutEffect)(()=>{
        // Transaction dispatching is already enabled by default prior to
        // mounting, but we reset it here, just in case the editor view
        // instance is ever recycled (mounted again after unmounting) with
        // the same key.
        // AND since React 18 effects may run multiple times so we need to ensure
        // this is reset so that transactions are still allowed.
        // Although storing mounted state is an anti-pattern in React,
        // we do so here so that we can intercept and abort asynchronous
        // ProseMirror transactions when a dismount is imminent.
        canDispatchTransactions.current = true;
        return ()=>{
            // We can ignore any transactions from this point onwards.
            // This serves to avoid potential runtime exceptions which could arise
            // from an async dispatched transaction after it's unmounted.
            canDispatchTransactions.current = false;
        };
    }, []);
    // Cleanup
    (0, $eJOHy.useLayoutEffect)(()=>{
        return ()=>{
            const focusTimeoutIdCurrent = focusTimeoutId.current;
            if (focusTimeoutIdCurrent) clearTimeout(focusTimeoutIdCurrent);
            if (viewRef.current) {
                // Destroy the state if the Editor is being unmounted
                const editorState = viewRef.current.state;
                editorState.plugins.forEach((plugin)=>{
                    const state = plugin.getState(editorState);
                    if (state && state.destroy) state.destroy();
                });
            }
            eventDispatcher.destroy();
        // this.view will be destroyed when React unmounts in handleEditorViewRef
        };
    }, [
        eventDispatcher
    ]);
    const reconfigureState = (0, $eJOHy.useCallback)((props)=>{
        if (!viewRef.current) return;
        // We cannot currently guarantee when all the portals will have re-rendered during a reconfigure
        // so we blur here to stop ProseMirror from trying to apply selection to detached nodes or
        // nodes that haven't been re-rendered to the document yet.
        blur();
        const editorPlugins = (0, $lAhIB.default)(props.preset, props.editorProps, pluginInjectionAPI.current);
        config.current = (0, $20Ctl.processPluginsList)(editorPlugins);
        const state = viewRef.current.state;
        const plugins = (0, $20Ctl.createPMPlugins)({
            schema: state.schema,
            dispatch: dispatch,
            errorReporter: errorReporter,
            editorConfig: config.current,
            eventDispatcher: eventDispatcher,
            providerFactory: props.providerFactory,
            portalProviderAPI: props.portalProviderAPI,
            nodeViewPortalProviderAPI: props.nodeViewPortalProviderAPI,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            featureFlags: featureFlags,
            getIntl: ()=>props.intl,
            onEditorStateUpdated: (0, $eGOwo.fg)('platform_editor_catch_missing_injection_states') ? pluginInjectionAPI.current.onEditorViewUpdated : undefined
        });
        const newState = state.reconfigure({
            plugins: plugins
        });
        // need to update the state first so when the view builds the nodeviews it is
        // using the latest plugins
        viewRef.current.updateState(newState);
        return viewRef.current.update({
            ...viewRef.current.props,
            state: newState
        });
    }, [
        blur,
        dispatchAnalyticsEvent,
        eventDispatcher,
        dispatch,
        errorReporter,
        featureFlags
    ]);
    const onEditorViewUpdated = (0, $eJOHy.useCallback)(({ originalTransaction: originalTransaction, transactions: transactions, oldEditorState: oldEditorState, newEditorState: newEditorState })=>{
        if (!(0, $eGOwo.fg)('platform_editor_catch_missing_injection_states')) pluginInjectionAPI.current.onEditorViewUpdated({
            newEditorState: newEditorState,
            oldEditorState: oldEditorState
        });
        if (!(0, $eGOwo.fg)('platform_editor_migrate_state_updates')) config.current?.onEditorViewStateUpdatedCallbacks.forEach((entry)=>{
            entry.callback({
                originalTransaction: originalTransaction,
                transactions: transactions,
                oldEditorState: oldEditorState,
                newEditorState: newEditorState
            });
        });
    }, []);
    const dispatchTransaction = (0, $l9xeW.useDispatchTransaction)({
        onChange: props.editorProps.onChange,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        onEditorViewUpdated: onEditorViewUpdated,
        isRemoteReplaceDocumentTransaction: pluginInjectionAPI.current.api()?.collabEdit?.actions?.isRemoteReplaceDocumentTransaction
    });
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: Remove these when we deprecate these props from editor-props - smartLinks is unfortunately still used in some places, we can sidestep this problem if we move everyone across to ComposableEditor and deprecate Editor
    const UNSAFE_cards = props.editorProps.UNSAFE_cards;
    const smartLinks = props.editorProps.smartLinks;
    // Temporary to replace provider factory while migration to `ComposableEditor` occurs
    (0, $jy3uD.useProviders)({
        editorApi: editorAPI,
        contextIdentifierProvider: props.editorProps.contextIdentifierProvider,
        mediaProvider: props.editorProps.media?.provider,
        mentionProvider: props.editorProps.mentionProvider,
        cardProvider: props.editorProps.linking?.smartLinks?.provider || smartLinks && smartLinks.provider || UNSAFE_cards && UNSAFE_cards.provider,
        emojiProvider: props.editorProps.emojiProvider,
        autoformattingProvider: props.editorProps.autoformattingProvider,
        taskDecisionProvider: props.editorProps.taskDecisionProvider
    });
    const getDirectEditorProps = (0, $eJOHy.useCallback)((state)=>{
        return {
            state: state ?? getCurrentEditorState(),
            dispatchTransaction: (tr)=>{
                // Block stale transactions:
                // Prevent runtime exceptions from async transactions that would attempt to
                // update the DOM after React has unmounted the Editor.
                if (canDispatchTransactions.current) dispatchTransaction(viewRef.current, tr);
            },
            // Disables the contentEditable attribute of the editor if the editor is disabled
            editable: (_state)=>!disabled,
            attributes: {
                'data-gramm': 'false'
            }
        };
    }, [
        dispatchTransaction,
        disabled,
        getCurrentEditorState
    ]);
    const createEditorView = (0, $eJOHy.useCallback)((node)=>{
        (0, $65rqJ.measureRender)((0, $1ZFgR.default).PROSEMIRROR_RENDERED, ({ duration: duration, startTime: startTime, distortedDuration: distortedDuration })=>{
            const proseMirrorRenderedSeverity = (0, $dyNYh.getAnalyticsEventSeverity)(duration, (0, $96851126f0c152a2$export$646a6982857f2cd5), (0, $96851126f0c152a2$export$79d7eac6cbb6352d));
            if (viewRef.current) {
                const nodes = (0, $4wM3w.getNodesCount)(viewRef.current.state.doc);
                const ttfb = (0, $Sk9g1.getResponseEndTime)();
                const contextIdentifier = pluginInjectionAPI.current.api().base?.sharedState.currentState();
                dispatchAnalyticsEvent({
                    action: (0, $bMFKb.ACTION).PROSEMIRROR_RENDERED,
                    actionSubject: (0, $bMFKb.ACTION_SUBJECT).EDITOR,
                    attributes: {
                        duration: duration,
                        startTime: startTime,
                        nodes: nodes,
                        ttfb: ttfb,
                        severity: proseMirrorRenderedSeverity,
                        objectId: contextIdentifier?.objectId,
                        distortedDuration: distortedDuration
                    },
                    eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL
                });
            }
        });
        // Creates the editor-view from this.editorState. If an editor has been mounted
        // previously, this will contain the previous state of the editor.
        const view = new (0, $b7EWj.EditorView)({
            mount: node
        }, getDirectEditorProps());
        viewRef.current = view;
        pluginInjectionAPI.current.onEditorViewUpdated({
            newEditorState: viewRef.current.state,
            oldEditorState: undefined
        });
        return view;
    }, [
        getDirectEditorProps,
        dispatchAnalyticsEvent
    ]);
    const [editorView, setEditorView] = (0, $eJOHy.useState)(undefined);
    // Detects if the editor is nested inside an extension - ie. it is a Legacy Content Extension (LCE)
    const isNestedEditor = (0, $eJOHy.useRef)(null);
    const isNestedEditorCalculated = (0, $eJOHy.useRef)(false);
    if ((0, $eGOwo.fg)('platform_editor_lce_scrolltop_mitigation')) {
        if (editorRef.current !== null && !isNestedEditorCalculated.current) {
            isNestedEditor.current = !!editorRef.current?.closest('.extension-editable-area');
            isNestedEditorCalculated.current = true;
        }
    }
    const originalScrollToRestore = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef(!isNestedEditor.current && (0, $7uu4v.isFullPage)(props.editorProps.appearance) && (0, $eGOwo.fg)('platform_editor_reduce_scroll_jump_on_editor_start') ? document.querySelector('[data-editor-scroll-container]')?.scrollTop : undefined);
    const mitigateScrollJump = // The feature gate here is being used to avoid potential bugs with the scroll restoration code
    // moving it to the end of the expression negates the point of the feature gate
    // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    (0, $7uu4v.isFullPage)(props.editorProps.appearance) && (0, $eGOwo.fg)('platform_editor_reduce_scroll_jump_on_editor_start') && originalScrollToRestore.current && originalScrollToRestore.current !== 0;
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (shouldFocus && editorView?.props.editable?.(editorView.state) && (0, $eGOwo.fg)('platform_editor_react_18_autofocus_fix')) {
            if ((0, $eGOwo.fg)('platform_editor_reduce_scroll_jump_on_editor_start')) {
                if (!mitigateScrollJump) {
                    const liveDocWithContent = (__livePage || (0, $cbSL1.expValEquals)('platform_editor_no_cursor_on_edit_page_init', 'isEnabled', true)) && !(0, $bnAxN.isEmptyDocument)(editorView.state.doc);
                    if (!liveDocWithContent) focusTimeoutId.current = (0, $YsDKQ.handleEditorFocus)(editorView);
                    if ((0, $cbSL1.expValEquals)('platform_editor_no_cursor_on_edit_page_init', 'isEnabled', true) && (0, $eGOwo.fg)('cc_editor_focus_before_editor_on_load')) {
                        if (!disabled && shouldFocus && !(0, $bnAxN.isEmptyDocument)(editorView.state.doc)) (0, $jGMZf.focusEditorElement)(editorId.current);
                    }
                }
            } else {
                const liveDocWithContent = (__livePage || (0, $cbSL1.expValEquals)('platform_editor_no_cursor_on_edit_page_init', 'isEnabled', true)) && !(0, $bnAxN.isEmptyDocument)(editorView.state.doc);
                if (!liveDocWithContent) focusTimeoutId.current = (0, $YsDKQ.handleEditorFocus)(editorView);
            }
        }
    }, [
        editorView,
        shouldFocus,
        __livePage,
        mitigateScrollJump,
        disabled
    ]);
    const scrollElement = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef();
    const possibleListeners = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef([]);
    (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useEffect(()=>{
        return ()=>{
            if ((0, $eGOwo.fg)('cc_editor_abort_ufo_load_on_editor_scroll')) {
                if (scrollElement.current) // eslint-disable-next-line react-hooks/exhaustive-deps
                for (const possibleListener of possibleListeners.current)// eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                scrollElement.current?.removeEventListener(...possibleListener);
                scrollElement.current = null;
            }
        };
    }, []);
    const handleEditorViewRef = (0, $eJOHy.useCallback)((node)=>{
        if ((0, $eGOwo.fg)('cc_editor_abort_ufo_load_on_editor_scroll')) {
            if (node) {
                scrollElement.current = document.querySelector('[data-editor-scroll-container]');
                const cleanupListeners = ()=>{
                    // eslint-disable-next-line react-hooks/exhaustive-deps
                    for (const possibleListener of possibleListeners.current)// eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    scrollElement.current?.removeEventListener(...possibleListener);
                };
                if (scrollElement.current) {
                    const wheelAbortHandler = ()=>{
                        const activeInteraction = (0, $2QO3b.getActiveInteraction)();
                        if (activeInteraction && [
                            'edit-page',
                            'live-edit'
                        ].includes(activeInteraction.ufoName)) (0, $2QO3b.abortAll)('new_interaction', `wheel-on-editor-element`);
                        cleanupListeners();
                    };
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    scrollElement.current.addEventListener('wheel', wheelAbortHandler);
                    possibleListeners.current.push([
                        'wheel',
                        wheelAbortHandler
                    ]);
                    const scrollAbortHandler = ()=>{
                        const activeInteraction = (0, $2QO3b.getActiveInteraction)();
                        if (activeInteraction && [
                            'edit-page',
                            'live-edit'
                        ].includes(activeInteraction.ufoName)) (0, $2QO3b.abortAll)('new_interaction', `scroll-on-editor-element`);
                        cleanupListeners();
                    };
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    scrollElement.current.addEventListener('scroll', scrollAbortHandler);
                    possibleListeners.current.push([
                        'scroll',
                        scrollAbortHandler
                    ]);
                }
            }
        }
        if (!viewRef.current && node) {
            (0, $elRHR.nodeVisibilityManager)(node).initialiseNodeObserver();
            const view = createEditorView(node);
            if ((0, $eGOwo.fg)('platform_editor_reduce_scroll_jump_on_editor_start')) {
                if (mitigateScrollJump) {
                    const scrollElement = document.querySelector('[data-editor-scroll-container]');
                    scrollElement?.scrollTo({
                        top: originalScrollToRestore.current,
                        behavior: 'instant'
                    });
                }
            }
            onEditorCreated({
                view: view,
                config: config.current,
                eventDispatcher: eventDispatcher,
                transformer: contentTransformer.current
            });
            if ((0, $eGOwo.fg)('platform_editor_react_18_autofocus_fix')) {
                /**
					 * Defer using startTransition when it is available (in React 18) to fix
					 * autofocus bug where React 18's concurrent rendering mode interferes with
					 * setTimeout used in handleEditorFocus, causing autofocus to break.
					 */ const react18OnlyStartTransition = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy)))?.startTransition ?? ((fn)=>fn());
                react18OnlyStartTransition(()=>{
                    // Force React to re-render so consumers get a reference to the editor view
                    setEditorView(view);
                });
            } else {
                if (shouldFocus && view.props.editable && view.props.editable(view.state)) {
                    if ((0, $eGOwo.fg)('platform_editor_reduce_scroll_jump_on_editor_start')) {
                        if (!mitigateScrollJump) {
                            const isLivePageWithContent = (__livePage || (0, $cbSL1.expValEquals)('platform_editor_no_cursor_on_edit_page_init', 'isEnabled', true)) && !(0, $bnAxN.isEmptyDocument)(view.state.doc);
                            if (!isLivePageWithContent && shouldFocus && view.props.editable && view.props.editable(view.state)) focusTimeoutId.current = (0, $YsDKQ.handleEditorFocus)(view);
                            if ((0, $cbSL1.expValEquals)('platform_editor_no_cursor_on_edit_page_init', 'isEnabled', true) && (0, $eGOwo.fg)('cc_editor_focus_before_editor_on_load')) {
                                if (shouldFocus && view.props.editable && view.props.editable(view.state) && !(0, $bnAxN.isEmptyDocument)(view.state.doc)) (0, $jGMZf.focusEditorElement)(editorId.current);
                            }
                        }
                    } else {
                        const isLivePageWithContent = (__livePage || (0, $cbSL1.expValEquals)('platform_editor_no_cursor_on_edit_page_init', 'isEnabled', true)) && !(0, $bnAxN.isEmptyDocument)(view.state.doc);
                        if (!isLivePageWithContent && shouldFocus && view.props.editable && view.props.editable(view.state)) focusTimeoutId.current = (0, $YsDKQ.handleEditorFocus)(view);
                    }
                }
                // Force React to re-render so consumers get a reference to the editor view
                setEditorView(view);
            }
        } else if (viewRef.current && !node) {
            // When the appearance is changed, React will call handleEditorViewRef with node === null
            // to destroy the old EditorView, before calling this method again with node === div to
            // create the new EditorView
            onEditorDestroyed({
                view: viewRef.current,
                config: config.current,
                eventDispatcher: eventDispatcher,
                transformer: contentTransformer.current
            });
            const wasAnalyticsDisconnected = !eventDispatcher.has((0, $dyNYh.analyticsEventKey), handleAnalyticsEvent);
            // If we disabled event listening for some reason we should re-enable it temporarily while we destroy
            // the view for any analytics that occur there.
            if (wasAnalyticsDisconnected) {
                eventDispatcher.on((0, $dyNYh.analyticsEventKey), handleAnalyticsEvent);
                viewRef.current.destroy(); // Destroys the dom node & all node views
                eventDispatcher.off((0, $dyNYh.analyticsEventKey), handleAnalyticsEvent);
            } else viewRef.current.destroy(); // Destroys the dom node & all node views
            (0, $elRHR.nodeVisibilityManager)(viewRef.current.dom).disconnect();
            viewRef.current = undefined;
        }
    }, [
        createEditorView,
        onEditorCreated,
        eventDispatcher,
        shouldFocus,
        __livePage,
        onEditorDestroyed,
        handleAnalyticsEvent,
        mitigateScrollJump
    ]);
    const createEditor = (0, $eJOHy.useCallback)((assistiveLabel, assistiveDescribedBy)=>{
        return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
            children: [
                (0, $eGOwo.fg)('cc_editor_focus_before_editor_on_load') && /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    tabIndex: -1,
                    "data-focus-id": editorId.current,
                    "data-testid": "react-editor-view-inital-focus-element"
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: `ProseMirror ${(0, $aHrTy.getUAPrefix)()}`,
                    ref: handleEditorViewRef,
                    "aria-label": assistiveLabel || props.intl.formatMessage((0, $erdK2.editorMessages).editorAssistiveLabel),
                    // setting aria-multiline to true when not mobile appearance.
                    //  because somehow mobile tests are failing when it set.
                    //  don't know why that is happening.
                    // Created https://product-fabric.atlassian.net/jira/servicedesk/projects/DTR/queues/issue/DTR-1675
                    //  to investigate further.
                    "aria-multiline": true,
                    role: "textbox",
                    id: $97220bff0cbd31bb$var$EDIT_AREA_ID,
                    "aria-describedby": assistiveDescribedBy,
                    "data-editor-id": editorId.current,
                    "data-vc-ignore-if-no-layout-shift": (0, $eGOwo.fg)('platform_vc_ignore_no_ls_mutation_marker') ? true : undefined
                }, "ProseMirror")
            ]
        });
    }, [
        handleEditorViewRef,
        props.intl
    ]);
    const previousPreset = (0, $5ZVTg.default)(preset);
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (previousPreset && previousPreset !== preset) reconfigureState(props);
    }, [
        reconfigureState,
        previousPreset,
        preset,
        props
    ]);
    const previousDisabledState = (0, $5ZVTg.default)(disabled);
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (viewRef.current && previousDisabledState !== disabled) {
            // Disables the contentEditable attribute of the editor if the editor is disabled
            viewRef.current.setProps({
                editable: (_state)=>!disabled
            });
            const isLivePageWithContent = (__livePage || (0, $cbSL1.expValEquals)('platform_editor_no_cursor_on_edit_page_init', 'isEnabled', true)) && !(0, $bnAxN.isEmptyDocument)(viewRef.current.state.doc);
            if (!disabled && shouldFocus && !isLivePageWithContent) focusTimeoutId.current = (0, $YsDKQ.handleEditorFocus)(viewRef.current);
            if ((0, $cbSL1.expValEquals)('platform_editor_no_cursor_on_edit_page_init', 'isEnabled', true) && (0, $eGOwo.fg)('cc_editor_focus_before_editor_on_load')) {
                if (!disabled && shouldFocus && !(0, $bnAxN.isEmptyDocument)(viewRef.current.state.doc)) (0, $jGMZf.focusEditorElement)(editorId.current);
            }
        }
    }, [
        disabled,
        shouldFocus,
        previousDisabledState,
        __livePage
    ]);
    (0, $2afhI.useFireFullWidthEvent)(nextAppearance, dispatchAnalyticsEvent);
    const editor = (0, $eJOHy.useMemo)(()=>createEditor(props.editorProps.assistiveLabel, props.editorProps.assistiveDescribedBy), // `createEditor` changes a little too frequently - we don't want to recreate the editor view in this case
    // We should follow-up
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        props.editorProps.assistiveLabel,
        props.editorProps.assistiveDescribedBy
    ]);
    // Render tracking is firing too many events in Jira so we are disabling them for now. See - https://product-fabric.atlassian.net/browse/ED-25616
    // Also firing too many events for the legacy content macro, so disabling for now. See - https://product-fabric.atlassian.net/browse/ED-26650
    const renderTrackingEnabled = !(0, $eGOwo.fg)('platform_editor_disable_rerender_tracking_jira') && !featureFlags.lcmPreventRenderTracking;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $g9imq.default).Provider, {
        value: {
            editorRef: editorRef,
            editorView: viewRef.current,
            popupsMountPoint: props.editorProps.popupsMountPoint
        },
        children: [
            renderTrackingEnabled && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $i5btK.RenderTracking), {
                componentProps: props,
                action: (0, $bMFKb.ACTION).RE_RENDERED,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).REACT_EDITOR_VIEW,
                handleAnalyticsEvent: handleAnalyticsEvent,
                useShallow: true
            }),
            props.render ? props.render?.({
                editor: editor,
                view: viewRef.current,
                config: config.current,
                eventDispatcher: eventDispatcher,
                transformer: contentTransformer.current,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                editorRef: editorRef,
                editorAPI: editorAPI
            }) ?? editor : editor
        ]
    });
}
var $97220bff0cbd31bb$export$2e2bcd8739ae039 = (0, $6YFG2.default)($97220bff0cbd31bb$export$e7d1b1cbca007e16);

});
parcelRegister("8MfCL", function(module, exports) {

$parcel$export(module.exports, "PLATFORMS", () => $d58277a1cd1a5d50$export$a8d23193462f2b63);
$parcel$export(module.exports, "MODE", () => $d58277a1cd1a5d50$export$e48589d9e4824227);
$parcel$export(module.exports, "FULL_WIDTH_MODE", () => $d58277a1cd1a5d50$export$57453495b81e2dde);
$parcel$export(module.exports, "BROWSER_FREEZE_INTERACTION_TYPE", () => $d58277a1cd1a5d50$export$60a219cfaef9722);
var $d58277a1cd1a5d50$export$a8d23193462f2b63 = /*#__PURE__*/ function(PLATFORMS) {
    PLATFORMS["NATIVE"] = "mobileNative";
    PLATFORMS["HYBRID"] = "mobileHybrid";
    PLATFORMS["WEB"] = "web";
    return PLATFORMS;
}({});
var $d58277a1cd1a5d50$export$e48589d9e4824227 = /*#__PURE__*/ function(MODE) {
    MODE["RENDERER"] = "renderer";
    MODE["EDITOR"] = "editor";
    return MODE;
}({});
var $d58277a1cd1a5d50$export$57453495b81e2dde = /*#__PURE__*/ function(FULL_WIDTH_MODE) {
    FULL_WIDTH_MODE["FIXED_WIDTH"] = "fixedWidth";
    FULL_WIDTH_MODE["FULL_WIDTH"] = "fullWidth";
    return FULL_WIDTH_MODE;
}({});
var $d58277a1cd1a5d50$export$60a219cfaef9722 = /*#__PURE__*/ function(BROWSER_FREEZE_INTERACTION_TYPE) {
    BROWSER_FREEZE_INTERACTION_TYPE["LOADING"] = "loading";
    BROWSER_FREEZE_INTERACTION_TYPE["TYPING"] = "typing";
    BROWSER_FREEZE_INTERACTION_TYPE["CLICKING"] = "clicking";
    BROWSER_FREEZE_INTERACTION_TYPE["PASTING"] = "pasting";
    return BROWSER_FREEZE_INTERACTION_TYPE;
}({});

});

parcelRegister("2Kn3g", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae227f9278e93289$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
function $ae227f9278e93289$export$2e2bcd8739ae039(callback) {
    const hasRun = (0, $eJOHy.useRef)(false);
    if (!hasRun.current) {
        callback();
        hasRun.current = true;
    }
}

});

parcelRegister("5ZVTg", function(module, exports) {

$parcel$export(module.exports, "default", () => $45ec14eb37dd32c0$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
function $45ec14eb37dd32c0$export$2e2bcd8739ae039(value, initialValue) {
    const ref = (0, $eJOHy.useRef)(initialValue);
    (0, $eJOHy.useEffect)(()=>{
        // Setting the value to ref.current inside an effect, or otherwise the behaviour in staging/prod doesn't match with local
        // In local, the double rendering in react dev mode causes the previous value to be the same as next value immediately after
        // In prod and staging, double rendering is not done since that is a react prod build
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}

});

parcelRegister("elRHR", function(module, exports) {

$parcel$export(module.exports, "nodeVisibilityManager", () => $e7860a8853372d80$export$565ab8668cdfbb7c);
// Use this selector to set the intersection observer boundary for editor's inline node views
// If this does not exist, it will use the IntersectionObserver's default root
const $e7860a8853372d80$var$INTERSECTION_OBSERVER_ROOT_SELECTOR = '[data-editor-scroll-container="true"]';
const $e7860a8853372d80$var$editorObservers = new WeakMap();
const $e7860a8853372d80$var$callbackMap = new WeakMap();
const $e7860a8853372d80$export$565ab8668cdfbb7c = (editorElement)=>{
    // Warning! do not reference editorElement outside of internal functions.
    // editorElement is passed to allow support for multiple editors,
    const unObserveInternal = (nodeElement)=>{
        $e7860a8853372d80$var$editorObservers.get(editorElement)?.unobserve(nodeElement);
        $e7860a8853372d80$var$callbackMap.delete(nodeElement);
    };
    const observe = (observerConfig)=>{
        $e7860a8853372d80$var$callbackMap.set(observerConfig.element, observerConfig);
        $e7860a8853372d80$var$editorObservers.get(editorElement)?.observe(observerConfig.element);
        // return clean up
        return ()=>{
            // consumer needs to unobserve on destroy if their element
            // was observed but never scrolled into view
            unObserveInternal(observerConfig.element);
        };
    };
    const initialiseNodeObserver = ()=>{
        if ($e7860a8853372d80$var$editorObservers.has(editorElement)) return;
        const intersectionObserverOptions = {
            root: editorElement.closest($e7860a8853372d80$var$INTERSECTION_OBSERVER_ROOT_SELECTOR),
            rootMargin: '0px 0px 100px 0px',
            threshold: 0
        };
        const editorObserver = new IntersectionObserver((entries)=>entries.map((entry)=>({
                    entry: entry,
                    callback: $e7860a8853372d80$var$callbackMap.get(entry.target)
                }))// Invoke callbacks together to group browser rendering
            // Avoiding requestAnimationFrame to reduce visual flickering
            .forEach(({ entry: entry, callback: callback })=>{
                if (entry.isIntersecting) {
                    callback?.onFirstVisible();
                    if (entry.target instanceof HTMLElement) // immediately unobserve the element after it is visible
                    unObserveInternal(entry.target);
                }
            }), intersectionObserverOptions);
        $e7860a8853372d80$var$editorObservers.set(editorElement, editorObserver);
    };
    const disconnect = ()=>{
        $e7860a8853372d80$var$editorObservers.get(editorElement)?.disconnect();
        $e7860a8853372d80$var$editorObservers.delete(editorElement);
    };
    return {
        initialiseNodeObserver: initialiseNodeObserver,
        observe: observe,
        disconnect: disconnect
    };
};

});

parcelRegister("dTLXq", function(module, exports) {

$parcel$export(module.exports, "EditorPluginInjectionAPI", () => $704f9873d73e1f00$export$50ccbedb1c6559a0);

var $cSmYj = parcelRequire("cSmYj");

var $6DCNy = parcelRequire("6DCNy");

var $kIy7e = parcelRequire("kIy7e");
function $704f9873d73e1f00$var$hasGetSharedState(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
plugin) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return typeof plugin.getSharedState === 'function';
}
function $704f9873d73e1f00$var$hasActions(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
plugin) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return typeof plugin.actions === 'object';
}
function $704f9873d73e1f00$var$hasCommands(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
plugin) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return typeof plugin.commands === 'object';
}
const $704f9873d73e1f00$var$filterPluginsWithListeners = ({ listeners: listeners, plugins: plugins })=>Array.from(listeners.keys()).map((pluginName)=>plugins.get(pluginName)).filter((plugin)=>plugin !== undefined && $704f9873d73e1f00$var$hasGetSharedState(plugin));
const $704f9873d73e1f00$var$extractSharedStateFromPlugins = ({ oldEditorState: oldEditorState, newEditorState: newEditorState, plugins: plugins })=>{
    const isInitialization = !oldEditorState && newEditorState;
    const result = new Map();
    for (const plugin of plugins){
        if (!plugin || !$704f9873d73e1f00$var$hasGetSharedState(plugin)) continue;
        const nextSharedState = plugin.getSharedState(newEditorState);
        const prevSharedState = !isInitialization && oldEditorState ? plugin.getSharedState(oldEditorState) : undefined;
        const isSamePluginState = (0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(prevSharedState, nextSharedState);
        if (isInitialization || !isSamePluginState) result.set(plugin.name, {
            nextSharedState: nextSharedState,
            prevSharedState: prevSharedState
        });
    }
    return result;
};
const $704f9873d73e1f00$var$THROTTLE_CALLS_FOR_MILLISECONDS = 0;
const $704f9873d73e1f00$var$notifyListenersThrottled = (0, (/*@__PURE__*/$parcel$interopDefault($6DCNy)))(({ listeners: listeners, updatesToNotifyQueue: updatesToNotifyQueue })=>{
    const callbacks = [];
    for (const [pluginName, diffs] of updatesToNotifyQueue.entries()){
        const pluginListeners = listeners.get(pluginName) || [];
        pluginListeners.forEach((callback)=>{
            diffs.forEach((diff)=>{
                callbacks.push(callback.bind(callback, diff));
            });
        });
    }
    updatesToNotifyQueue.clear();
    if (callbacks.length === 0) return;
    callbacks.reverse().forEach((cb)=>{
        cb();
    });
}, $704f9873d73e1f00$var$THROTTLE_CALLS_FOR_MILLISECONDS);
class $704f9873d73e1f00$export$855252f33d470a3f {
}
class $704f9873d73e1f00$var$ActionsAPI {
    createAPI(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    plugin) {
        if (!plugin || !$704f9873d73e1f00$var$hasActions(plugin)) return {};
        return new Proxy(plugin.actions || {}, {
            get: function(target, prop, receiver) {
                // We will be able to track perfomance here
                return Reflect.get(target, prop);
            }
        });
    }
}
class $704f9873d73e1f00$var$EditorCommandsAPI {
    createAPI(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    plugin) {
        if (!plugin || !$704f9873d73e1f00$var$hasCommands(plugin)) return {};
        return new Proxy(plugin.commands || {}, {
            get: function(target, prop, receiver) {
                // We will be able to track perfomance here
                return Reflect.get(target, prop);
            }
        });
    }
}
class $704f9873d73e1f00$export$da7528f3fb233b4a {
    constructor({ getEditorState: getEditorState }){
        this.updatesToNotifyQueue = new Map();
        this.getEditorState = getEditorState;
        this.listeners = new Map();
    }
    createAPI(plugin) {
        if (!plugin) return {
            currentState: ()=>undefined,
            onChange: (sub)=>{
                return ()=>{};
            }
        };
        const pluginName = plugin.name;
        return {
            currentState: ()=>{
                if (!$704f9873d73e1f00$var$hasGetSharedState(plugin)) return undefined;
                const state = this.getEditorState();
                return plugin.getSharedState(state);
            },
            onChange: (sub)=>{
                const pluginListeners = this.listeners.get(pluginName) || new Set();
                pluginListeners.add(sub);
                this.listeners.set(pluginName, pluginListeners);
                return ()=>this.cleanupSubscription(pluginName, sub);
            }
        };
    }
    cleanupSubscription(pluginName, sub) {
        (this.listeners.get(pluginName) || new Set()).delete(sub);
    }
    notifyListeners({ newEditorState: newEditorState, oldEditorState: oldEditorState, plugins: plugins }) {
        const { listeners: listeners, updatesToNotifyQueue: updatesToNotifyQueue } = this;
        const pluginsFiltered = $704f9873d73e1f00$var$filterPluginsWithListeners({
            plugins: plugins,
            listeners: listeners
        });
        const sharedStateDiffs = $704f9873d73e1f00$var$extractSharedStateFromPlugins({
            oldEditorState: oldEditorState,
            newEditorState: newEditorState,
            plugins: pluginsFiltered
        });
        if (sharedStateDiffs.size === 0) return;
        for (const [pluginName, nextDiff] of sharedStateDiffs){
            const currentDiffQueue = updatesToNotifyQueue.get(pluginName) || [];
            updatesToNotifyQueue.set(pluginName, [
                ...currentDiffQueue,
                nextDiff
            ]);
        }
        $704f9873d73e1f00$var$notifyListenersThrottled({
            updatesToNotifyQueue: updatesToNotifyQueue,
            listeners: listeners
        });
    }
    destroy() {
        this.listeners.clear();
        this.updatesToNotifyQueue.clear();
    }
}
const $704f9873d73e1f00$var$editorAPICache = new WeakMap();
class $704f9873d73e1f00$export$50ccbedb1c6559a0 {
    constructor({ getEditorState: getEditorState, getEditorView: getEditorView, fireAnalyticsEvent: fireAnalyticsEvent }){
        this.onEditorViewUpdated = ({ newEditorState: newEditorState, oldEditorState: oldEditorState })=>{
            this.sharedStateAPI.notifyListeners({
                newEditorState: newEditorState,
                oldEditorState: oldEditorState,
                plugins: this.plugins
            });
        };
        this.onEditorPluginInitialized = (plugin)=>{
            this.addPlugin(plugin);
        };
        this.addPlugin = (plugin)=>{
            // Plugins other than `core` are checked by the preset itself
            // For some reason in some tests we have duplicates that are missed.
            // To follow-up in ED-19611
            if (plugin.name === 'core' && this.plugins.has(plugin.name)) throw new Error(`Plugin ${plugin.name} has already been initialised in the Editor API!
        There cannot be duplicate plugins or you will have unexpected behaviour`);
            this.plugins.set(plugin.name, plugin);
        };
        this.getPluginByName = (pluginName)=>{
            const plugin = this.plugins.get(pluginName);
            return plugin;
        };
        this.sharedStateAPI = new $704f9873d73e1f00$export$da7528f3fb233b4a({
            getEditorState: getEditorState
        });
        this.plugins = new Map();
        this.actionsAPI = new $704f9873d73e1f00$var$ActionsAPI();
        this.commandsAPI = new $704f9873d73e1f00$var$EditorCommandsAPI();
        // Special core plugin that is always added
        this.addPlugin((0, $kIy7e.corePlugin)({
            config: {
                getEditorView: getEditorView,
                fireAnalyticsEvent: fireAnalyticsEvent
            }
        }));
    }
    createAPI() {
        const { sharedStateAPI: sharedStateAPI, actionsAPI: actionsAPI, commandsAPI: commandsAPI, getPluginByName: getPluginByName } = this;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return new Proxy({}, {
            get: function(target, prop, receiver) {
                // If we pass this as a prop React hates us
                // Let's just reflect the result and ignore these
                if (prop === 'toJSON') return Reflect.get(target, prop);
                const plugin = getPluginByName(prop);
                if (!plugin) return undefined;
                const sharedState = sharedStateAPI.createAPI(plugin);
                const actions = actionsAPI.createAPI(plugin);
                const commands = commandsAPI.createAPI(plugin);
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const proxyCoreAPI = {
                    sharedState: sharedState,
                    actions: actions,
                    commands: commands
                };
                return proxyCoreAPI;
            }
        });
    }
    api() {
        if (!$704f9873d73e1f00$var$editorAPICache.get(this)) $704f9873d73e1f00$var$editorAPICache.set(this, this.createAPI());
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return $704f9873d73e1f00$var$editorAPICache.get(this);
    }
}

});
parcelRegister("kIy7e", function(module, exports) {

$parcel$export(module.exports, "corePlugin", () => $845d74fa02e6f2aa$export$71ab138dd170c35);

var $3xw6l = parcelRequire("3xw6l");

var $eGOwo = parcelRequire("eGOwo");

var $51k6y = parcelRequire("51k6y");

var $8GLF3 = parcelRequire("8GLF3");

var $eUMHn = parcelRequire("eUMHn");
const $845d74fa02e6f2aa$export$71ab138dd170c35 = ({ config: config })=>{
    // Create the document request throttler per editor (rather than at a module level)
    const scheduleDocumentRequest = (0, $eUMHn.createThrottleSchedule)((0, $eUMHn.returnDocumentRequest));
    return {
        name: 'core',
        actions: {
            execute: (command)=>{
                const editorView = config?.getEditorView();
                if (!editorView || !command) return false;
                const { state: state, dispatch: dispatch } = editorView;
                return (0, $8GLF3.editorCommandToPMCommand)(command)(state, dispatch);
            },
            // Code copied from `EditorActions.focus()`
            focus: (options)=>{
                const editorView = config?.getEditorView();
                if (!editorView || editorView.hasFocus()) return false;
                editorView.focus();
                if (options?.scrollIntoView ?? true) editorView.dispatch(editorView.state.tr.scrollIntoView());
                return true;
            },
            // Code copied from `EditorActions.blur()`
            blur: ()=>{
                const editorView = config?.getEditorView();
                if (!editorView || !editorView.hasFocus()) return false;
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                editorView.dom.blur();
                return true;
            },
            scrollToPos (pos, scrollOptions) {
                const editorView = config?.getEditorView();
                if (!editorView) return false;
                const tr = editorView.state.tr;
                const isValidPos = typeof pos === 'number' && pos >= 0 && pos <= tr.doc.content.size;
                if (!isValidPos) return false;
                const dom = editorView.domAtPos(pos).node;
                if (!(dom instanceof Element)) {
                    // If it's not an element (e.g. #text node), we'll try the parent.
                    // This is expected to cover most of the scenarios, if not, window.scrollTo is an alternative
                    if (dom.parentNode instanceof Element) {
                        dom.parentNode.scrollIntoView(scrollOptions);
                        return true;
                    }
                    return false;
                }
                dom.scrollIntoView(scrollOptions);
                return true;
            },
            replaceDocument: (replaceValue, options)=>{
                const editorView = config?.getEditorView();
                if (!editorView || replaceValue === undefined || replaceValue === null) return false;
                const { state: state } = editorView;
                const { schema: schema } = state;
                const content = options?.skipValidation ? (0, $51k6y.processRawValueWithoutValidation)(schema, replaceValue) : Array.isArray(replaceValue) ? (0, $51k6y.processRawFragmentValue)(schema, replaceValue) : (0, $51k6y.processRawValue)(schema, replaceValue);
                // Don't replace the document if it's the same document, as full size
                // replace transactions cause issues for collaborative editing and
                // content reconciliation (eg. inline comments getting dropped)
                if (// eslint-disable-next-line @atlaskit/platform/no-preconditioning
                (0, $eGOwo.fg)('platform_editor_replace_document_shortcircuit') && content instanceof (0, $3xw6l.Node) && state.doc.eq(content)) return false;
                if (content) {
                    const tr = state.tr.replaceWith(0, state.doc.nodeSize - 2, content);
                    if (options?.scrollIntoView ?? true) editorView.dispatch(tr.scrollIntoView());
                    else editorView.dispatch(tr);
                    return true;
                }
                return false;
            },
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            requestDocument (onReceive, options) {
                const view = config?.getEditorView() ?? null;
                scheduleDocumentRequest(view, onReceive, options?.transformer, config?.fireAnalyticsEvent);
            },
            createTransformer (cb) {
                const view = config?.getEditorView() ?? null;
                if (!view?.state.schema) return undefined;
                return cb(view?.state.schema);
            }
        }
    };
};

});
parcelRegister("8GLF3", function(module, exports) {

$parcel$export(module.exports, "editorCommandToPMCommand", () => $84844af15cb36364$export$bd352a83a17b2af8);
$parcel$export(module.exports, "PassiveTransaction", () => $84844af15cb36364$export$95069e054e554fa9);

var $3lIcL = parcelRequire("3lIcL");
function $84844af15cb36364$export$bd352a83a17b2af8(command) {
    return ({ tr: tr }, dispatch)=>{
        const newTr = command?.({
            tr: tr
        });
        if (!newTr) return false;
        if (newTr instanceof $84844af15cb36364$export$95069e054e554fa9) return true;
        dispatch?.(newTr);
        return true;
    };
}
class $84844af15cb36364$export$95069e054e554fa9 extends (0, $3lIcL.Transaction) {
    // This is very cheeky but this should never be used outside its intended
    // purpose - it will likely crash the editor so we should get an early warning
    // signal
    constructor(){
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        super({});
    }
}

});

parcelRegister("eUMHn", function(module, exports) {

$parcel$export(module.exports, "createThrottleSchedule", () => $b9d5029668f0e8c6$export$6a1dd68d75badcc7);
$parcel$export(module.exports, "returnDocumentRequest", () => $b9d5029668f0e8c6$export$dce79649e5264171);

var $lovmf = parcelRequire("lovmf");

var $3xw6l = parcelRequire("3xw6l");

var $bMFKb = parcelRequire("bMFKb");
const $b9d5029668f0e8c6$var$transformer = new (0, $lovmf.JSONTransformer)();
function $b9d5029668f0e8c6$export$54fd2c36b5cc6731(node) {
    return $b9d5029668f0e8c6$var$transformer.encode(node);
}
function $b9d5029668f0e8c6$export$6a1dd68d75badcc7(callback) {
    let frameId;
    let lastArgs;
    const wrapperFn = (...args)=>{
        lastArgs = args;
        if (frameId) return;
        // If `requestIdleCallback` doesn't exist - fallback to `requestAnimationFrame`
        const delayFunction = globalThis.requestIdleCallback ?? globalThis.requestAnimationFrame;
        frameId = delayFunction(()=>{
            frameId = undefined;
            if (lastArgs) callback(...lastArgs);
        }, {
            timeout: 100
        });
    };
    return wrapperFn;
}
function $b9d5029668f0e8c6$export$dce79649e5264171(editorView, callback, transformer, fireAnalyticsEvent) {
    const { doc: doc, schema: schema } = editorView?.state ?? {};
    if (!doc || !schema) return undefined;
    try {
        const json = $b9d5029668f0e8c6$export$54fd2c36b5cc6731(doc);
        if (typeof transformer === 'undefined') callback(json);
        else {
            const nodeSanitized = (0, $3xw6l.Node).fromJSON(schema, json);
            callback(transformer.encode(nodeSanitized));
        }
    } catch (e) {
        fireAnalyticsEvent?.({
            payload: {
                action: (0, $bMFKb.ACTION).DOCUMENT_PROCESSING_ERROR,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).EDITOR,
                eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    errorMessage: `${e instanceof Error && e.name === 'NodeNestingTransformError' ? 'NodeNestingTransformError - Failed to transform one or more nested tables' : undefined}`
                }
            }
        });
        throw e;
    }
}

});



parcelRegister("g9imq", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7d0384bd404ebe9$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
const $a7d0384bd404ebe9$var$ReactEditorViewContext = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext({});
var $a7d0384bd404ebe9$export$2e2bcd8739ae039 = $a7d0384bd404ebe9$var$ReactEditorViewContext;

});

parcelRegister("bnAxN", function(module, exports) {

$parcel$export(module.exports, "getStepRange", () => $ae49a9482438fce3$export$c8e611b6ac095e6d);
$parcel$export(module.exports, "hasDocAsParent", () => $ae49a9482438fce3$export$f76a7d770092ea11);
$parcel$export(module.exports, "isEmptyDocument", () => $ae49a9482438fce3$export$2da47a16c0b6bcb);
$parcel$export(module.exports, "bracketTyped", () => $ae49a9482438fce3$export$df0539d254c75c33);
$parcel$export(module.exports, "nodesBetweenChanged", () => $ae49a9482438fce3$export$f9e52d2e832a6aae);
$parcel$export(module.exports, "hasVisibleContent", () => $ae49a9482438fce3$export$c9083db5521330d3);
$parcel$export(module.exports, "isSelectionEndOfParagraph", () => $ae49a9482438fce3$export$435c1d4e61a8723b);
$parcel$export(module.exports, "getChangedNodes", () => $ae49a9482438fce3$export$fd9c3e0f31aab835);
$parcel$export(module.exports, "isReplaceDocOperation", () => $ae49a9482438fce3$export$b81ebf241519dbe1);

var $lzEKq = parcelRequire("lzEKq");

var $5Z3Rm = parcelRequire("5Z3Rm");
const $ae49a9482438fce3$export$c8e611b6ac095e6d = (transaction)=>{
    let from = -1;
    let to = -1;
    transaction.mapping.maps.forEach((stepMap, index)=>{
        stepMap.forEach((oldStart, oldEnd)=>{
            const newStart = transaction.mapping.slice(index).map(oldStart, -1);
            const newEnd = transaction.mapping.slice(index).map(oldEnd);
            from = newStart < from || from === -1 ? newStart : from;
            to = newEnd > to || to === -1 ? newEnd : to;
        });
    });
    if (from !== -1) return {
        from: from,
        to: to
    };
    return null;
};
function $ae49a9482438fce3$export$f76a7d770092ea11($anchor) {
    return $anchor.depth === 1;
}
function $ae49a9482438fce3$export$2da47a16c0b6bcb(node) {
    const nodeChild = node.content.firstChild;
    if (node.childCount !== 1 || !nodeChild) return false;
    return (0, $5Z3Rm.isEmptyParagraph)(nodeChild);
}
function $ae49a9482438fce3$export$df0539d254c75c33(state) {
    const { selection: selection } = state;
    const { $cursor: $cursor, $anchor: $anchor } = selection;
    if (!$cursor) return false;
    const node = $cursor.nodeBefore;
    if (!node) return false;
    if (node.type.name === 'text' && node.text === '{') {
        const paragraphNode = $anchor.node();
        return paragraphNode.marks.length === 0 && $ae49a9482438fce3$export$f76a7d770092ea11($anchor);
    }
    return false;
}
function $ae49a9482438fce3$export$f9e52d2e832a6aae(tr, f, startPos) {
    const stepRange = $ae49a9482438fce3$export$c8e611b6ac095e6d(tr);
    if (!stepRange) return;
    tr.doc.nodesBetween(stepRange.from, stepRange.to, f, startPos);
}
function $ae49a9482438fce3$export$c9083db5521330d3(node) {
    const isInlineNodeHasVisibleContent = (inlineNode)=>{
        return inlineNode.isText ? !!inlineNode.textContent.trim() : inlineNode.type.name !== 'hardBreak';
    };
    if (node.isInline) return isInlineNodeHasVisibleContent(node);
    else if (node.isBlock && (node.isLeaf || node.isAtom)) return true;
    else if (!node.childCount) return false;
    for(let index = 0; index < node.childCount; index++){
        const child = node.child(index);
        const invisibleNodeTypes = [
            'paragraph',
            'text',
            'hardBreak'
        ];
        if (!invisibleNodeTypes.includes(child.type.name) || $ae49a9482438fce3$export$c9083db5521330d3(child)) return true;
    }
    return false;
}
const $ae49a9482438fce3$export$435c1d4e61a8723b = (state)=>state.selection.$to.parent.type === state.schema.nodes.paragraph && state.selection.$to.pos === state.doc.resolve(state.selection.$to.pos).end();
function $ae49a9482438fce3$var$getChangedNodesIn({ tr: tr, doc: doc }) {
    const nodes = [];
    const stepRange = $ae49a9482438fce3$export$c8e611b6ac095e6d(tr);
    if (!stepRange) return nodes;
    const from = Math.min(doc.nodeSize - 2, stepRange.from);
    const to = Math.min(doc.nodeSize - 2, stepRange.to);
    doc.nodesBetween(from, to, (node, pos)=>{
        nodes.push({
            node: node,
            pos: pos
        });
    });
    return nodes;
}
function $ae49a9482438fce3$export$fd9c3e0f31aab835(tr) {
    return $ae49a9482438fce3$var$getChangedNodesIn({
        tr: tr,
        doc: tr.doc
    });
}
const $ae49a9482438fce3$export$b81ebf241519dbe1 = (transactions, oldState)=>{
    return transactions.some((tr)=>{
        if (tr.getMeta('replaceDocument')) return true;
        const hasStepReplacingEntireDocument = tr.steps.some((step)=>{
            if (!(step instanceof (0, $lzEKq.ReplaceStep))) return false;
            const isStepReplacingFromDocStart = step.from === 0;
            const isStepReplacingUntilTheEndOfDocument = step.to === oldState.doc.content.size;
            if (!isStepReplacingFromDocStart || !isStepReplacingUntilTheEndOfDocument) return false;
            return true;
        });
        return hasStepReplacingEntireDocument;
    });
};

});
parcelRegister("5Z3Rm", function(module, exports) {

$parcel$export(module.exports, "isEmptyParagraph", () => $31528faad45fc8ad$export$b648602b09795358);
$parcel$export(module.exports, "stepHasSlice", () => $31528faad45fc8ad$export$53780b185b887309);
$parcel$export(module.exports, "stepAddsOneOf", () => $31528faad45fc8ad$export$f4d51ccab05f55c9);
$parcel$export(module.exports, "extractSliceFromStep", () => $31528faad45fc8ad$export$d0a9dfe2556a9577);
$parcel$export(module.exports, "isTextSelection", () => $31528faad45fc8ad$export$38b50bf35e79aaf3);
$parcel$export(module.exports, "isElementInTableCell", () => $31528faad45fc8ad$export$5588122b9eea7733);
$parcel$export(module.exports, "isLastItemMediaGroup", () => $31528faad45fc8ad$export$142c0ee6457f50d6);
$parcel$export(module.exports, "setNodeSelection", () => $31528faad45fc8ad$export$a367515ca2c9ace1);
$parcel$export(module.exports, "setTextSelection", () => $31528faad45fc8ad$export$1df6d14df6b0b758);
$parcel$export(module.exports, "nonNullable", () => $31528faad45fc8ad$export$26128561c93f5847);
$parcel$export(module.exports, "isValidPosition", () => $31528faad45fc8ad$export$de0495c7bd37bf4e);
$parcel$export(module.exports, "isInLayoutColumn", () => $31528faad45fc8ad$export$2de06a6e688827fd);
$parcel$export(module.exports, "filterChildrenBetween", () => $31528faad45fc8ad$export$e46323d96cf32194);
$parcel$export(module.exports, "removeBlockMarks", () => $31528faad45fc8ad$export$fba8af3b998832b9);

var $3lIcL = parcelRequire("3lIcL");

var $lzEKq = parcelRequire("lzEKq");

var $BmspC = parcelRequire("BmspC");

var $cwzAY = parcelRequire("cwzAY");

var $eGOwo = parcelRequire("eGOwo");

var $7SIsS = parcelRequire("7SIsS");
function $31528faad45fc8ad$export$b648602b09795358(node) {
    return !!node && node.type.name === 'paragraph' && !node.childCount;
}
const $31528faad45fc8ad$export$53780b185b887309 = (step)=>step && step.hasOwnProperty('slice');
function $31528faad45fc8ad$export$f4d51ccab05f55c9(step, nodeTypes) {
    let adds = false;
    if (!$31528faad45fc8ad$export$53780b185b887309(step)) return adds;
    step.slice.content.descendants((node)=>{
        if (nodeTypes.has(node.type)) adds = true;
        return !adds;
    });
    return adds;
}
const $31528faad45fc8ad$export$d0a9dfe2556a9577 = (step)=>{
    if (!(step instanceof (0, $lzEKq.ReplaceStep)) && !(step instanceof (0, $lzEKq.ReplaceAroundStep))) return null;
    // @ts-ignore This is by design. Slice is a private property, but accesible, from ReplaceStep.
    // However, we need to read it to found if the step was adding a newline
    const slice = step.slice;
    return slice;
};
const $31528faad45fc8ad$export$38b50bf35e79aaf3 = (selection)=>selection instanceof (0, $3lIcL.TextSelection);
const $31528faad45fc8ad$export$5588122b9eea7733 = (element)=>{
    if ((0, $eGOwo.fg)('platform_editor_nested_tables_column_drag_fix')) return (0, $7SIsS.closest)(element, 'td, th');
    else return (0, $7SIsS.closest)(element, 'td') || (0, $7SIsS.closest)(element, 'th');
};
const $31528faad45fc8ad$export$142c0ee6457f50d6 = (node)=>{
    const { content: content } = node;
    return !!content.lastChild && content.lastChild.type.name === 'mediaGroup';
};
const $31528faad45fc8ad$export$a367515ca2c9ace1 = (view, pos)=>{
    const { state: state, dispatch: dispatch } = view;
    if (!isFinite(pos)) return;
    const tr = state.tr.setSelection((0, $3lIcL.NodeSelection).create(state.doc, pos));
    dispatch(tr);
};
function $31528faad45fc8ad$export$1df6d14df6b0b758(view, anchor, head) {
    const { state: state, dispatch: dispatch } = view;
    const tr = state.tr.setSelection((0, $3lIcL.TextSelection).create(state.doc, anchor, head));
    dispatch(tr);
}
function $31528faad45fc8ad$export$abad69d764760c05(view) {
    const { state: state, dispatch: dispatch } = view;
    const tr = state.tr.setSelection(new (0, $3lIcL.AllSelection)(view.state.doc));
    dispatch(tr);
}
function $31528faad45fc8ad$export$8f10f8581a0e9ba2(view, anchor, head) {
    const { state: state, dispatch: dispatch } = view;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    dispatch(state.tr.setSelection((0, $cwzAY.CellSelection).create(state.doc, anchor, head)));
}
function $31528faad45fc8ad$export$26128561c93f5847(value) {
    return value !== null && value !== undefined;
}
const $31528faad45fc8ad$export$de0495c7bd37bf4e = (pos, state)=>{
    if (typeof pos !== 'number') return false;
    if (pos >= 0 && pos <= state.doc.resolve(0).end()) return true;
    return false;
};
const $31528faad45fc8ad$export$2de06a6e688827fd = (state)=>{
    return (0, $BmspC.hasParentNodeOfType)(state.schema.nodes.layoutSection)(state.selection);
};
function $31528faad45fc8ad$export$e46323d96cf32194(doc, from, to, predicate) {
    const results = [];
    doc.nodesBetween(from, to, (node, pos, parent)=>{
        if (predicate(node, pos, parent)) results.push({
            node: node,
            pos: pos
        });
    });
    return results;
}
const $31528faad45fc8ad$export$fba8af3b998832b9 = (state, marks)=>{
    const { selection: selection, schema: schema } = state;
    let { tr: tr } = state;
    // Marks might not exist in Schema
    const marksToRemove = marks.filter(Boolean);
    if (marksToRemove.length === 0) return undefined;
    /** Saves an extra dispatch */ let blockMarksExists = false;
    const hasMark = (mark)=>marksToRemove.indexOf(mark.type) > -1;
    /**
	 * When you need to toggle the selection
	 * when another type which does not allow alignment is applied
	 */ state.doc.nodesBetween(selection.from, selection.to, (node, pos)=>{
        if (node.type === schema.nodes.paragraph && node.marks.some(hasMark)) {
            blockMarksExists = true;
            const resolvedPos = state.doc.resolve(pos);
            const withoutBlockMarks = node.marks.filter($31528faad45fc8ad$var$not(hasMark));
            tr = tr.setNodeMarkup(resolvedPos.pos, undefined, node.attrs, withoutBlockMarks);
        }
    });
    return blockMarksExists ? tr : undefined;
};
const $31528faad45fc8ad$var$not = (fn)=>(arg)=>!fn(arg);

});


parcelRegister("b7EWj", function(module, exports) {

$parcel$export(module.exports, "Decoration", () => $81901ae0222f0506$export$10e30b733df217ea);
$parcel$export(module.exports, "DecorationSet", () => $81901ae0222f0506$export$93bf62eb445cec98);
$parcel$export(module.exports, "EditorView", () => $81901ae0222f0506$export$eece2fccabbb77c5);

var $3lIcL = parcelRequire("3lIcL");

var $3xw6l = parcelRequire("3xw6l");

var $lzEKq = parcelRequire("lzEKq");
const $81901ae0222f0506$var$domIndex = function(node) {
    for(var index = 0;; index++){
        node = node.previousSibling;
        if (!node) return index;
    }
};
const $81901ae0222f0506$var$parentNode = function(node) {
    let parent = node.assignedSlot || node.parentNode;
    return parent && parent.nodeType == 11 ? parent.host : parent;
};
let $81901ae0222f0506$var$reusedRange = null;
// Note that this will always return the same range, because DOM range
// objects are every expensive, and keep slowing down subsequent DOM
// updates, for some reason.
const $81901ae0222f0506$var$textRange = function(node, from, to) {
    let range = $81901ae0222f0506$var$reusedRange || ($81901ae0222f0506$var$reusedRange = document.createRange());
    range.setEnd(node, to == null ? node.nodeValue.length : to);
    range.setStart(node, from || 0);
    return range;
};
const $81901ae0222f0506$var$clearReusedRange = function() {
    $81901ae0222f0506$var$reusedRange = null;
};
// Scans forward and backward through DOM positions equivalent to the
// given one to see if the two are in the same place (i.e. after a
// text node vs at the end of that text node)
const $81901ae0222f0506$var$isEquivalentPosition = function(node, off, targetNode, targetOff) {
    return targetNode && ($81901ae0222f0506$var$scanFor(node, off, targetNode, targetOff, -1) || $81901ae0222f0506$var$scanFor(node, off, targetNode, targetOff, 1));
};
const $81901ae0222f0506$var$atomElements = /^(img|br|input|textarea|hr)$/i;
function $81901ae0222f0506$var$scanFor(node, off, targetNode, targetOff, dir) {
    for(;;){
        if (node == targetNode && off == targetOff) return true;
        if (off == (dir < 0 ? 0 : $81901ae0222f0506$var$nodeSize(node))) {
            let parent = node.parentNode;
            if (!parent || parent.nodeType != 1 || $81901ae0222f0506$var$hasBlockDesc(node) || $81901ae0222f0506$var$atomElements.test(node.nodeName) || node.contentEditable == "false") return false;
            off = $81901ae0222f0506$var$domIndex(node) + (dir < 0 ? 0 : 1);
            node = parent;
        } else if (node.nodeType == 1) {
            node = node.childNodes[off + (dir < 0 ? -1 : 0)];
            if (node.contentEditable == "false") return false;
            off = dir < 0 ? $81901ae0222f0506$var$nodeSize(node) : 0;
        } else return false;
    }
}
function $81901ae0222f0506$var$nodeSize(node) {
    return node.nodeType == 3 ? node.nodeValue.length : node.childNodes.length;
}
function $81901ae0222f0506$var$textNodeBefore$1(node, offset) {
    for(;;){
        if (node.nodeType == 3 && offset) return node;
        if (node.nodeType == 1 && offset > 0) {
            if (node.contentEditable == "false") return null;
            node = node.childNodes[offset - 1];
            offset = $81901ae0222f0506$var$nodeSize(node);
        } else if (node.parentNode && !$81901ae0222f0506$var$hasBlockDesc(node)) {
            offset = $81901ae0222f0506$var$domIndex(node);
            node = node.parentNode;
        } else return null;
    }
}
function $81901ae0222f0506$var$textNodeAfter$1(node, offset) {
    for(;;){
        if (node.nodeType == 3 && offset < node.nodeValue.length) return node;
        if (node.nodeType == 1 && offset < node.childNodes.length) {
            if (node.contentEditable == "false") return null;
            node = node.childNodes[offset];
            offset = 0;
        } else if (node.parentNode && !$81901ae0222f0506$var$hasBlockDesc(node)) {
            offset = $81901ae0222f0506$var$domIndex(node) + 1;
            node = node.parentNode;
        } else return null;
    }
}
function $81901ae0222f0506$var$isOnEdge(node, offset, parent) {
    for(let atStart = offset == 0, atEnd = offset == $81901ae0222f0506$var$nodeSize(node); atStart || atEnd;){
        if (node == parent) return true;
        let index = $81901ae0222f0506$var$domIndex(node);
        node = node.parentNode;
        if (!node) return false;
        atStart = atStart && index == 0;
        atEnd = atEnd && index == $81901ae0222f0506$var$nodeSize(node);
    }
}
function $81901ae0222f0506$var$hasBlockDesc(dom) {
    let desc;
    for(let cur = dom; cur; cur = cur.parentNode)if (desc = cur.pmViewDesc) break;
    return desc && desc.node && desc.node.isBlock && (desc.dom == dom || desc.contentDOM == dom);
}
// Work around Chrome issue https://bugs.chromium.org/p/chromium/issues/detail?id=447523
// (isCollapsed inappropriately returns true in shadow dom)
const $81901ae0222f0506$var$selectionCollapsed = function(domSel) {
    return domSel.focusNode && $81901ae0222f0506$var$isEquivalentPosition(domSel.focusNode, domSel.focusOffset, domSel.anchorNode, domSel.anchorOffset);
};
function $81901ae0222f0506$var$keyEvent(keyCode, key) {
    let event = document.createEvent("Event");
    event.initEvent("keydown", true, true);
    event.keyCode = keyCode;
    event.key = event.code = key;
    return event;
}
function $81901ae0222f0506$var$deepActiveElement(doc) {
    let elt = doc.activeElement;
    while(elt && elt.shadowRoot)elt = elt.shadowRoot.activeElement;
    return elt;
}
function $81901ae0222f0506$var$caretFromPoint(doc, x, y) {
    if (doc.caretPositionFromPoint) try {
        let pos = doc.caretPositionFromPoint(x, y);
        // Clip the offset, because Chrome will return a text offset
        // into <input> nodes, which can't be treated as a regular DOM
        // offset
        if (pos) return {
            node: pos.offsetNode,
            offset: Math.min($81901ae0222f0506$var$nodeSize(pos.offsetNode), pos.offset)
        };
    } catch (_) {}
    if (doc.caretRangeFromPoint) {
        let range = doc.caretRangeFromPoint(x, y);
        if (range) return {
            node: range.startContainer,
            offset: Math.min($81901ae0222f0506$var$nodeSize(range.startContainer), range.startOffset)
        };
    }
}
const $81901ae0222f0506$var$nav = typeof navigator != "undefined" ? navigator : null;
const $81901ae0222f0506$var$doc = typeof document != "undefined" ? document : null;
const $81901ae0222f0506$var$agent = $81901ae0222f0506$var$nav && $81901ae0222f0506$var$nav.userAgent || "";
const $81901ae0222f0506$var$ie_edge = /Edge\/(\d+)/.exec($81901ae0222f0506$var$agent);
const $81901ae0222f0506$var$ie_upto10 = /MSIE \d/.exec($81901ae0222f0506$var$agent);
const $81901ae0222f0506$var$ie_11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec($81901ae0222f0506$var$agent);
const $81901ae0222f0506$var$ie = !!($81901ae0222f0506$var$ie_upto10 || $81901ae0222f0506$var$ie_11up || $81901ae0222f0506$var$ie_edge);
const $81901ae0222f0506$var$ie_version = $81901ae0222f0506$var$ie_upto10 ? document.documentMode : $81901ae0222f0506$var$ie_11up ? +$81901ae0222f0506$var$ie_11up[1] : $81901ae0222f0506$var$ie_edge ? +$81901ae0222f0506$var$ie_edge[1] : 0;
const $81901ae0222f0506$var$gecko = !$81901ae0222f0506$var$ie && /gecko\/(\d+)/i.test($81901ae0222f0506$var$agent);
$81901ae0222f0506$var$gecko && (/Firefox\/(\d+)/.exec($81901ae0222f0506$var$agent) || [
    0,
    0
])[1];
const $81901ae0222f0506$var$_chrome = !$81901ae0222f0506$var$ie && /Chrome\/(\d+)/.exec($81901ae0222f0506$var$agent);
const $81901ae0222f0506$var$chrome = !!$81901ae0222f0506$var$_chrome;
const $81901ae0222f0506$var$chrome_version = $81901ae0222f0506$var$_chrome ? +$81901ae0222f0506$var$_chrome[1] : 0;
const $81901ae0222f0506$var$safari = !$81901ae0222f0506$var$ie && !!$81901ae0222f0506$var$nav && /Apple Computer/.test($81901ae0222f0506$var$nav.vendor);
// Is true for both iOS and iPadOS for convenience
const $81901ae0222f0506$var$ios = $81901ae0222f0506$var$safari && (/Mobile\/\w+/.test($81901ae0222f0506$var$agent) || !!$81901ae0222f0506$var$nav && $81901ae0222f0506$var$nav.maxTouchPoints > 2);
const $81901ae0222f0506$var$mac = $81901ae0222f0506$var$ios || ($81901ae0222f0506$var$nav ? /Mac/.test($81901ae0222f0506$var$nav.platform) : false);
const $81901ae0222f0506$var$windows = $81901ae0222f0506$var$nav ? /Win/.test($81901ae0222f0506$var$nav.platform) : false;
const $81901ae0222f0506$var$android = /Android \d/.test($81901ae0222f0506$var$agent);
const $81901ae0222f0506$var$webkit = !!$81901ae0222f0506$var$doc && "webkitFontSmoothing" in $81901ae0222f0506$var$doc.documentElement.style;
const $81901ae0222f0506$var$webkit_version = $81901ae0222f0506$var$webkit ? +(/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [
    0,
    0
])[1] : 0;
function $81901ae0222f0506$var$windowRect(doc) {
    let vp = doc.defaultView && doc.defaultView.visualViewport;
    if (vp) return {
        left: 0,
        right: vp.width,
        top: 0,
        bottom: vp.height
    };
    return {
        left: 0,
        right: doc.documentElement.clientWidth,
        top: 0,
        bottom: doc.documentElement.clientHeight
    };
}
function $81901ae0222f0506$var$getSide(value, side) {
    return typeof value == "number" ? value : value[side];
}
function $81901ae0222f0506$var$clientRect(node) {
    let rect = node.getBoundingClientRect();
    // Adjust for elements with style "transform: scale()"
    let scaleX = rect.width / node.offsetWidth || 1;
    let scaleY = rect.height / node.offsetHeight || 1;
    // Make sure scrollbar width isn't included in the rectangle
    return {
        left: rect.left,
        right: rect.left + node.clientWidth * scaleX,
        top: rect.top,
        bottom: rect.top + node.clientHeight * scaleY
    };
}
function $81901ae0222f0506$var$scrollRectIntoView(view, rect, startDOM) {
    let scrollThreshold = view.someProp("scrollThreshold") || 0, scrollMargin = view.someProp("scrollMargin") || 5;
    let doc = view.dom.ownerDocument;
    for(let parent = startDOM || view.dom;; parent = $81901ae0222f0506$var$parentNode(parent)){
        if (!parent) break;
        if (parent.nodeType != 1) continue;
        let elt = parent;
        let atTop = elt == doc.body;
        let bounding = atTop ? $81901ae0222f0506$var$windowRect(doc) : $81901ae0222f0506$var$clientRect(elt);
        let moveX = 0, moveY = 0;
        if (rect.top < bounding.top + $81901ae0222f0506$var$getSide(scrollThreshold, "top")) moveY = -(bounding.top - rect.top + $81901ae0222f0506$var$getSide(scrollMargin, "top"));
        else if (rect.bottom > bounding.bottom - $81901ae0222f0506$var$getSide(scrollThreshold, "bottom")) moveY = rect.bottom - rect.top > bounding.bottom - bounding.top ? rect.top + $81901ae0222f0506$var$getSide(scrollMargin, "top") - bounding.top : rect.bottom - bounding.bottom + $81901ae0222f0506$var$getSide(scrollMargin, "bottom");
        if (rect.left < bounding.left + $81901ae0222f0506$var$getSide(scrollThreshold, "left")) moveX = -(bounding.left - rect.left + $81901ae0222f0506$var$getSide(scrollMargin, "left"));
        else if (rect.right > bounding.right - $81901ae0222f0506$var$getSide(scrollThreshold, "right")) moveX = rect.right - bounding.right + $81901ae0222f0506$var$getSide(scrollMargin, "right");
        if (moveX || moveY) {
            if (atTop) doc.defaultView.scrollBy(moveX, moveY);
            else {
                let startX = elt.scrollLeft, startY = elt.scrollTop;
                if (moveY) elt.scrollTop += moveY;
                if (moveX) elt.scrollLeft += moveX;
                let dX = elt.scrollLeft - startX, dY = elt.scrollTop - startY;
                rect = {
                    left: rect.left - dX,
                    top: rect.top - dY,
                    right: rect.right - dX,
                    bottom: rect.bottom - dY
                };
            }
        }
        if (atTop || /^(fixed|sticky)$/.test(getComputedStyle(parent).position)) break;
    }
}
// Store the scroll position of the editor's parent nodes, along with
// the top position of an element near the top of the editor, which
// will be used to make sure the visible viewport remains stable even
// when the size of the content above changes.
function $81901ae0222f0506$var$storeScrollPos(view) {
    let rect = view.dom.getBoundingClientRect(), startY = Math.max(0, rect.top);
    let refDOM, refTop;
    for(let x = (rect.left + rect.right) / 2, y = startY + 1; y < Math.min(innerHeight, rect.bottom); y += 5){
        let dom = view.root.elementFromPoint(x, y);
        if (!dom || dom == view.dom || !view.dom.contains(dom)) continue;
        let localRect = dom.getBoundingClientRect();
        if (localRect.top >= startY - 20) {
            refDOM = dom;
            refTop = localRect.top;
            break;
        }
    }
    return {
        refDOM: refDOM,
        refTop: refTop,
        stack: $81901ae0222f0506$var$scrollStack(view.dom)
    };
}
function $81901ae0222f0506$var$scrollStack(dom) {
    let stack = [], doc = dom.ownerDocument;
    for(let cur = dom; cur; cur = $81901ae0222f0506$var$parentNode(cur)){
        stack.push({
            dom: cur,
            top: cur.scrollTop,
            left: cur.scrollLeft
        });
        if (dom == doc) break;
    }
    return stack;
}
// Reset the scroll position of the editor's parent nodes to that what
// it was before, when storeScrollPos was called.
function $81901ae0222f0506$var$resetScrollPos({ refDOM: refDOM, refTop: refTop, stack: stack }) {
    let newRefTop = refDOM ? refDOM.getBoundingClientRect().top : 0;
    $81901ae0222f0506$var$restoreScrollStack(stack, newRefTop == 0 ? 0 : newRefTop - refTop);
}
function $81901ae0222f0506$var$restoreScrollStack(stack, dTop) {
    for(let i = 0; i < stack.length; i++){
        let { dom: dom, top: top, left: left } = stack[i];
        if (dom.scrollTop != top + dTop) dom.scrollTop = top + dTop;
        if (dom.scrollLeft != left) dom.scrollLeft = left;
    }
}
let $81901ae0222f0506$var$preventScrollSupported = null;
// Feature-detects support for .focus({preventScroll: true}), and uses
// a fallback kludge when not supported.
function $81901ae0222f0506$var$focusPreventScroll(dom) {
    if (dom.setActive) return dom.setActive(); // in IE
    if ($81901ae0222f0506$var$preventScrollSupported) return dom.focus($81901ae0222f0506$var$preventScrollSupported);
    let stored = $81901ae0222f0506$var$scrollStack(dom);
    dom.focus($81901ae0222f0506$var$preventScrollSupported == null ? {
        get preventScroll () {
            $81901ae0222f0506$var$preventScrollSupported = {
                preventScroll: true
            };
            return true;
        }
    } : undefined);
    if (!$81901ae0222f0506$var$preventScrollSupported) {
        $81901ae0222f0506$var$preventScrollSupported = false;
        $81901ae0222f0506$var$restoreScrollStack(stored, 0);
    }
}
function $81901ae0222f0506$var$findOffsetInNode(node, coords) {
    let closest, dxClosest = 2e8, coordsClosest, offset = 0;
    let rowBot = coords.top, rowTop = coords.top;
    let firstBelow, coordsBelow;
    for(let child = node.firstChild, childIndex = 0; child; child = child.nextSibling, childIndex++){
        let rects;
        if (child.nodeType == 1) rects = child.getClientRects();
        else if (child.nodeType == 3) rects = $81901ae0222f0506$var$textRange(child).getClientRects();
        else continue;
        for(let i = 0; i < rects.length; i++){
            let rect = rects[i];
            if (rect.top <= rowBot && rect.bottom >= rowTop) {
                rowBot = Math.max(rect.bottom, rowBot);
                rowTop = Math.min(rect.top, rowTop);
                let dx = rect.left > coords.left ? rect.left - coords.left : rect.right < coords.left ? coords.left - rect.right : 0;
                if (dx < dxClosest) {
                    closest = child;
                    dxClosest = dx;
                    coordsClosest = dx && closest.nodeType == 3 ? {
                        left: rect.right < coords.left ? rect.right : rect.left,
                        top: coords.top
                    } : coords;
                    if (child.nodeType == 1 && dx) offset = childIndex + (coords.left >= (rect.left + rect.right) / 2 ? 1 : 0);
                    continue;
                }
            } else if (rect.top > coords.top && !firstBelow && rect.left <= coords.left && rect.right >= coords.left) {
                firstBelow = child;
                coordsBelow = {
                    left: Math.max(rect.left, Math.min(rect.right, coords.left)),
                    top: rect.top
                };
            }
            if (!closest && (coords.left >= rect.right && coords.top >= rect.top || coords.left >= rect.left && coords.top >= rect.bottom)) offset = childIndex + 1;
        }
    }
    if (!closest && firstBelow) {
        closest = firstBelow;
        coordsClosest = coordsBelow;
        dxClosest = 0;
    }
    if (closest && closest.nodeType == 3) return $81901ae0222f0506$var$findOffsetInText(closest, coordsClosest);
    if (!closest || dxClosest && closest.nodeType == 1) return {
        node: node,
        offset: offset
    };
    return $81901ae0222f0506$var$findOffsetInNode(closest, coordsClosest);
}
function $81901ae0222f0506$var$findOffsetInText(node, coords) {
    let len = node.nodeValue.length;
    let range = document.createRange();
    for(let i = 0; i < len; i++){
        range.setEnd(node, i + 1);
        range.setStart(node, i);
        let rect = $81901ae0222f0506$var$singleRect(range, 1);
        if (rect.top == rect.bottom) continue;
        if ($81901ae0222f0506$var$inRect(coords, rect)) return {
            node: node,
            offset: i + (coords.left >= (rect.left + rect.right) / 2 ? 1 : 0)
        };
    }
    return {
        node: node,
        offset: 0
    };
}
function $81901ae0222f0506$var$inRect(coords, rect) {
    return coords.left >= rect.left - 1 && coords.left <= rect.right + 1 && coords.top >= rect.top - 1 && coords.top <= rect.bottom + 1;
}
function $81901ae0222f0506$var$targetKludge(dom, coords) {
    let parent = dom.parentNode;
    if (parent && /^li$/i.test(parent.nodeName) && coords.left < dom.getBoundingClientRect().left) return parent;
    return dom;
}
function $81901ae0222f0506$var$posFromElement(view, elt, coords) {
    let { node: node, offset: offset } = $81901ae0222f0506$var$findOffsetInNode(elt, coords), bias = -1;
    if (node.nodeType == 1 && !node.firstChild) {
        let rect = node.getBoundingClientRect();
        bias = rect.left != rect.right && coords.left > (rect.left + rect.right) / 2 ? 1 : -1;
    }
    return view.docView.posFromDOM(node, offset, bias);
}
function $81901ae0222f0506$var$posFromCaret(view, node, offset, coords) {
    // Browser (in caretPosition/RangeFromPoint) will agressively
    // normalize towards nearby inline nodes. Since we are interested in
    // positions between block nodes too, we first walk up the hierarchy
    // of nodes to see if there are block nodes that the coordinates
    // fall outside of. If so, we take the position before/after that
    // block. If not, we call `posFromDOM` on the raw node/offset.
    let outsideBlock = -1;
    for(let cur = node, sawBlock = false;;){
        if (cur == view.dom) break;
        let desc = view.docView.nearestDesc(cur, true), rect;
        if (!desc) return null;
        if (desc.dom.nodeType == 1 && (desc.node.isBlock && desc.parent || !desc.contentDOM) && // Ignore elements with zero-size bounding rectangles
        ((rect = desc.dom.getBoundingClientRect()).width || rect.height)) {
            if (desc.node.isBlock && desc.parent) {
                // Only apply the horizontal test to the innermost block. Vertical for any parent.
                if (!sawBlock && rect.left > coords.left || rect.top > coords.top) outsideBlock = desc.posBefore;
                else if (!sawBlock && rect.right < coords.left || rect.bottom < coords.top) outsideBlock = desc.posAfter;
                sawBlock = true;
            }
            if (!desc.contentDOM && outsideBlock < 0 && !desc.node.isText) {
                // If we are inside a leaf, return the side of the leaf closer to the coords
                let before = desc.node.isBlock ? coords.top < (rect.top + rect.bottom) / 2 : coords.left < (rect.left + rect.right) / 2;
                return before ? desc.posBefore : desc.posAfter;
            }
        }
        cur = desc.dom.parentNode;
    }
    return outsideBlock > -1 ? outsideBlock : view.docView.posFromDOM(node, offset, -1);
}
function $81901ae0222f0506$var$elementFromPoint(element, coords, box) {
    let len = element.childNodes.length;
    if (len && box.top < box.bottom) for(let startI = Math.max(0, Math.min(len - 1, Math.floor(len * (coords.top - box.top) / (box.bottom - box.top)) - 2)), i = startI;;){
        let child = element.childNodes[i];
        if (child.nodeType == 1) {
            let rects = child.getClientRects();
            for(let j = 0; j < rects.length; j++){
                let rect = rects[j];
                if ($81901ae0222f0506$var$inRect(coords, rect)) return $81901ae0222f0506$var$elementFromPoint(child, coords, rect);
            }
        }
        if ((i = (i + 1) % len) == startI) break;
    }
    return element;
}
// Given an x,y position on the editor, get the position in the document.
function $81901ae0222f0506$var$posAtCoords(view, coords) {
    let doc = view.dom.ownerDocument, node, offset = 0;
    let caret = $81901ae0222f0506$var$caretFromPoint(doc, coords.left, coords.top);
    if (caret) ({ node: node, offset: offset } = caret);
    let elt = (view.root.elementFromPoint ? view.root : doc).elementFromPoint(coords.left, coords.top);
    let pos;
    if (!elt || !view.dom.contains(elt.nodeType != 1 ? elt.parentNode : elt)) {
        let box = view.dom.getBoundingClientRect();
        if (!$81901ae0222f0506$var$inRect(coords, box)) return null;
        elt = $81901ae0222f0506$var$elementFromPoint(view.dom, coords, box);
        if (!elt) return null;
    }
    // Safari's caretRangeFromPoint returns nonsense when on a draggable element
    if ($81901ae0222f0506$var$safari) {
        for(let p = elt; node && p; p = $81901ae0222f0506$var$parentNode(p))if (p.draggable) node = undefined;
    }
    elt = $81901ae0222f0506$var$targetKludge(elt, coords);
    if (node) {
        if ($81901ae0222f0506$var$gecko && node.nodeType == 1) {
            // Firefox will sometimes return offsets into <input> nodes, which
            // have no actual children, from caretPositionFromPoint (#953)
            offset = Math.min(offset, node.childNodes.length);
            // It'll also move the returned position before image nodes,
            // even if those are behind it.
            if (offset < node.childNodes.length) {
                let next = node.childNodes[offset], box;
                if (next.nodeName == "IMG" && (box = next.getBoundingClientRect()).right <= coords.left && box.bottom > coords.top) offset++;
            }
        }
        let prev;
        // When clicking above the right side of an uneditable node, Chrome will report a cursor position after that node.
        if ($81901ae0222f0506$var$webkit && offset && node.nodeType == 1 && (prev = node.childNodes[offset - 1]).nodeType == 1 && prev.contentEditable == "false" && prev.getBoundingClientRect().top >= coords.top) offset--;
        // Suspiciously specific kludge to work around caret*FromPoint
        // never returning a position at the end of the document
        if (node == view.dom && offset == node.childNodes.length - 1 && node.lastChild.nodeType == 1 && coords.top > node.lastChild.getBoundingClientRect().bottom) pos = view.state.doc.content.size;
        else if (offset == 0 || node.nodeType != 1 || node.childNodes[offset - 1].nodeName != "BR") pos = $81901ae0222f0506$var$posFromCaret(view, node, offset, coords);
    }
    if (pos == null) pos = $81901ae0222f0506$var$posFromElement(view, elt, coords);
    let desc = view.docView.nearestDesc(elt, true);
    return {
        pos: pos,
        inside: desc ? desc.posAtStart - desc.border : -1
    };
}
function $81901ae0222f0506$var$nonZero(rect) {
    return rect.top < rect.bottom || rect.left < rect.right;
}
function $81901ae0222f0506$var$singleRect(target, bias) {
    let rects = target.getClientRects();
    if (rects.length) {
        let first = rects[bias < 0 ? 0 : rects.length - 1];
        if ($81901ae0222f0506$var$nonZero(first)) return first;
    }
    return Array.prototype.find.call(rects, $81901ae0222f0506$var$nonZero) || target.getBoundingClientRect();
}
const $81901ae0222f0506$var$BIDI = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
// Given a position in the document model, get a bounding box of the
// character at that position, relative to the window.
function $81901ae0222f0506$var$coordsAtPos(view, pos, side) {
    let { node: node, offset: offset, atom: atom } = view.docView.domFromPos(pos, side < 0 ? -1 : 1);
    let supportEmptyRange = $81901ae0222f0506$var$webkit || $81901ae0222f0506$var$gecko;
    if (node.nodeType == 3) {
        // These browsers support querying empty text ranges. Prefer that in
        // bidi context or when at the end of a node.
        if (supportEmptyRange && ($81901ae0222f0506$var$BIDI.test(node.nodeValue) || (side < 0 ? !offset : offset == node.nodeValue.length))) {
            let rect = $81901ae0222f0506$var$singleRect($81901ae0222f0506$var$textRange(node, offset, offset), side);
            // Firefox returns bad results (the position before the space)
            // when querying a position directly after line-broken
            // whitespace. Detect this situation and and kludge around it
            if ($81901ae0222f0506$var$gecko && offset && /\s/.test(node.nodeValue[offset - 1]) && offset < node.nodeValue.length) {
                let rectBefore = $81901ae0222f0506$var$singleRect($81901ae0222f0506$var$textRange(node, offset - 1, offset - 1), -1);
                if (rectBefore.top == rect.top) {
                    let rectAfter = $81901ae0222f0506$var$singleRect($81901ae0222f0506$var$textRange(node, offset, offset + 1), -1);
                    if (rectAfter.top != rect.top) return $81901ae0222f0506$var$flattenV(rectAfter, rectAfter.left < rectBefore.left);
                }
            }
            return rect;
        } else {
            let from = offset, to = offset, takeSide = side < 0 ? 1 : -1;
            if (side < 0 && !offset) {
                to++;
                takeSide = -1;
            } else if (side >= 0 && offset == node.nodeValue.length) {
                from--;
                takeSide = 1;
            } else if (side < 0) from--;
            else to++;
            return $81901ae0222f0506$var$flattenV($81901ae0222f0506$var$singleRect($81901ae0222f0506$var$textRange(node, from, to), takeSide), takeSide < 0);
        }
    }
    let $dom = view.state.doc.resolve(pos - (atom || 0));
    // Return a horizontal line in block context
    if (!$dom.parent.inlineContent) {
        if (atom == null && offset && (side < 0 || offset == $81901ae0222f0506$var$nodeSize(node))) {
            let before = node.childNodes[offset - 1];
            if (before.nodeType == 1) return $81901ae0222f0506$var$flattenH(before.getBoundingClientRect(), false);
        }
        if (atom == null && offset < $81901ae0222f0506$var$nodeSize(node)) {
            let after = node.childNodes[offset];
            if (after.nodeType == 1) return $81901ae0222f0506$var$flattenH(after.getBoundingClientRect(), true);
        }
        return $81901ae0222f0506$var$flattenH(node.getBoundingClientRect(), side >= 0);
    }
    // Inline, not in text node (this is not Bidi-safe)
    if (atom == null && offset && (side < 0 || offset == $81901ae0222f0506$var$nodeSize(node))) {
        let before = node.childNodes[offset - 1];
        let target = before.nodeType == 3 ? $81901ae0222f0506$var$textRange(before, $81901ae0222f0506$var$nodeSize(before) - (supportEmptyRange ? 0 : 1)) : before.nodeType == 1 && (before.nodeName != "BR" || !before.nextSibling) ? before : null;
        if (target) return $81901ae0222f0506$var$flattenV($81901ae0222f0506$var$singleRect(target, 1), false);
    }
    if (atom == null && offset < $81901ae0222f0506$var$nodeSize(node)) {
        let after = node.childNodes[offset];
        while(after.pmViewDesc && after.pmViewDesc.ignoreForCoords)after = after.nextSibling;
        let target = !after ? null : after.nodeType == 3 ? $81901ae0222f0506$var$textRange(after, 0, supportEmptyRange ? 0 : 1) : after.nodeType == 1 ? after : null;
        if (target) return $81901ae0222f0506$var$flattenV($81901ae0222f0506$var$singleRect(target, -1), true);
    }
    // All else failed, just try to get a rectangle for the target node
    return $81901ae0222f0506$var$flattenV($81901ae0222f0506$var$singleRect(node.nodeType == 3 ? $81901ae0222f0506$var$textRange(node) : node, -side), side >= 0);
}
function $81901ae0222f0506$var$flattenV(rect, left) {
    if (rect.width == 0) return rect;
    let x = left ? rect.left : rect.right;
    return {
        top: rect.top,
        bottom: rect.bottom,
        left: x,
        right: x
    };
}
function $81901ae0222f0506$var$flattenH(rect, top) {
    if (rect.height == 0) return rect;
    let y = top ? rect.top : rect.bottom;
    return {
        top: y,
        bottom: y,
        left: rect.left,
        right: rect.right
    };
}
function $81901ae0222f0506$var$withFlushedState(view, state, f) {
    let viewState = view.state, active = view.root.activeElement;
    if (viewState != state) view.updateState(state);
    if (active != view.dom) view.focus();
    try {
        return f();
    } finally{
        if (viewState != state) view.updateState(viewState);
        if (active != view.dom && active) active.focus();
    }
}
// Whether vertical position motion in a given direction
// from a position would leave a text block.
function $81901ae0222f0506$var$endOfTextblockVertical(view, state, dir) {
    let sel = state.selection;
    let $pos = dir == "up" ? sel.$from : sel.$to;
    return $81901ae0222f0506$var$withFlushedState(view, state, ()=>{
        let { node: dom } = view.docView.domFromPos($pos.pos, dir == "up" ? -1 : 1);
        for(;;){
            let nearest = view.docView.nearestDesc(dom, true);
            if (!nearest) break;
            if (nearest.node.isBlock) {
                dom = nearest.contentDOM || nearest.dom;
                break;
            }
            dom = nearest.dom.parentNode;
        }
        let coords = $81901ae0222f0506$var$coordsAtPos(view, $pos.pos, 1);
        for(let child = dom.firstChild; child; child = child.nextSibling){
            let boxes;
            if (child.nodeType == 1) boxes = child.getClientRects();
            else if (child.nodeType == 3) boxes = $81901ae0222f0506$var$textRange(child, 0, child.nodeValue.length).getClientRects();
            else continue;
            for(let i = 0; i < boxes.length; i++){
                let box = boxes[i];
                if (box.bottom > box.top + 1 && (dir == "up" ? coords.top - box.top > (box.bottom - coords.top) * 2 : box.bottom - coords.bottom > (coords.bottom - box.top) * 2)) return false;
            }
        }
        return true;
    });
}
const $81901ae0222f0506$var$maybeRTL = /[\u0590-\u08ac]/;
function $81901ae0222f0506$var$endOfTextblockHorizontal(view, state, dir) {
    let { $head: $head } = state.selection;
    if (!$head.parent.isTextblock) return false;
    let offset = $head.parentOffset, atStart = !offset, atEnd = offset == $head.parent.content.size;
    let sel = view.domSelection();
    if (!sel) return $head.pos == $head.start() || $head.pos == $head.end();
    // If the textblock is all LTR, or the browser doesn't support
    // Selection.modify (Edge), fall back to a primitive approach
    if (!$81901ae0222f0506$var$maybeRTL.test($head.parent.textContent) || !sel.modify) return dir == "left" || dir == "backward" ? atStart : atEnd;
    return $81901ae0222f0506$var$withFlushedState(view, state, ()=>{
        // This is a huge hack, but appears to be the best we can
        // currently do: use `Selection.modify` to move the selection by
        // one character, and see if that moves the cursor out of the
        // textblock (or doesn't move it at all, when at the start/end of
        // the document).
        let { focusNode: oldNode, focusOffset: oldOff, anchorNode: anchorNode, anchorOffset: anchorOffset } = view.domSelectionRange();
        let oldBidiLevel = sel.caretBidiLevel // Only for Firefox
        ;
        sel.modify("move", dir, "character");
        let parentDOM = $head.depth ? view.docView.domAfterPos($head.before()) : view.dom;
        let { focusNode: newNode, focusOffset: newOff } = view.domSelectionRange();
        let result = newNode && !parentDOM.contains(newNode.nodeType == 1 ? newNode : newNode.parentNode) || oldNode == newNode && oldOff == newOff;
        // Restore the previous selection
        try {
            sel.collapse(anchorNode, anchorOffset);
            if (oldNode && (oldNode != anchorNode || oldOff != anchorOffset) && sel.extend) sel.extend(oldNode, oldOff);
        } catch (_) {}
        if (oldBidiLevel != null) sel.caretBidiLevel = oldBidiLevel;
        return result;
    });
}
let $81901ae0222f0506$var$cachedState = null;
let $81901ae0222f0506$var$cachedDir = null;
let $81901ae0222f0506$var$cachedResult = false;
function $81901ae0222f0506$var$endOfTextblock(view, state, dir) {
    if ($81901ae0222f0506$var$cachedState == state && $81901ae0222f0506$var$cachedDir == dir) return $81901ae0222f0506$var$cachedResult;
    $81901ae0222f0506$var$cachedState = state;
    $81901ae0222f0506$var$cachedDir = dir;
    return $81901ae0222f0506$var$cachedResult = dir == "up" || dir == "down" ? $81901ae0222f0506$var$endOfTextblockVertical(view, state, dir) : $81901ae0222f0506$var$endOfTextblockHorizontal(view, state, dir);
}
// View descriptions are data structures that describe the DOM that is
// used to represent the editor's content. They are used for:
//
// - Incremental redrawing when the document changes
//
// - Figuring out what part of the document a given DOM position
//   corresponds to
//
// - Wiring in custom implementations of the editing interface for a
//   given node
//
// They form a doubly-linked mutable tree, starting at `view.docView`.
const $81901ae0222f0506$var$NOT_DIRTY = 0, $81901ae0222f0506$var$CHILD_DIRTY = 1, $81901ae0222f0506$var$CONTENT_DIRTY = 2, $81901ae0222f0506$var$NODE_DIRTY = 3;
// Superclass for the various kinds of descriptions. Defines their
// basic structure and shared methods.
class $81901ae0222f0506$var$ViewDesc {
    constructor(parent, children, dom, // This is the node that holds the child views. It may be null for
    // descs that don't have children.
    contentDOM){
        this.parent = parent;
        this.children = children;
        this.dom = dom;
        this.contentDOM = contentDOM;
        this.dirty = $81901ae0222f0506$var$NOT_DIRTY;
        // An expando property on the DOM node provides a link back to its
        // description.
        dom.pmViewDesc = this;
    }
    // Used to check whether a given description corresponds to a
    // widget/mark/node.
    matchesWidget(widget) {
        return false;
    }
    matchesMark(mark) {
        return false;
    }
    matchesNode(node, outerDeco, innerDeco) {
        return false;
    }
    matchesHack(nodeName) {
        return false;
    }
    // When parsing in-editor content (in domchange.js), we allow
    // descriptions to determine the parse rules that should be used to
    // parse them.
    parseRule() {
        return null;
    }
    // Used by the editor's event handler to ignore events that come
    // from certain descs.
    stopEvent(event) {
        return false;
    }
    // The size of the content represented by this desc.
    get size() {
        let size = 0;
        for(let i = 0; i < this.children.length; i++)size += this.children[i].size;
        return size;
    }
    // For block nodes, this represents the space taken up by their
    // start/end tokens.
    get border() {
        return 0;
    }
    destroy() {
        this.parent = undefined;
        if (this.dom.pmViewDesc == this) this.dom.pmViewDesc = undefined;
        for(let i = 0; i < this.children.length; i++)this.children[i].destroy();
    }
    posBeforeChild(child) {
        for(let i = 0, pos = this.posAtStart;; i++){
            let cur = this.children[i];
            if (cur == child) return pos;
            pos += cur.size;
        }
    }
    get posBefore() {
        return this.parent.posBeforeChild(this);
    }
    get posAtStart() {
        return this.parent ? this.parent.posBeforeChild(this) + this.border : 0;
    }
    get posAfter() {
        return this.posBefore + this.size;
    }
    get posAtEnd() {
        return this.posAtStart + this.size - 2 * this.border;
    }
    localPosFromDOM(dom, offset, bias) {
        // If the DOM position is in the content, use the child desc after
        // it to figure out a position.
        if (this.contentDOM && this.contentDOM.contains(dom.nodeType == 1 ? dom : dom.parentNode)) {
            if (bias < 0) {
                let domBefore, desc;
                if (dom == this.contentDOM) domBefore = dom.childNodes[offset - 1];
                else {
                    while(dom.parentNode != this.contentDOM)dom = dom.parentNode;
                    domBefore = dom.previousSibling;
                }
                while(domBefore && !((desc = domBefore.pmViewDesc) && desc.parent == this))domBefore = domBefore.previousSibling;
                return domBefore ? this.posBeforeChild(desc) + desc.size : this.posAtStart;
            } else {
                let domAfter, desc;
                if (dom == this.contentDOM) domAfter = dom.childNodes[offset];
                else {
                    while(dom.parentNode != this.contentDOM)dom = dom.parentNode;
                    domAfter = dom.nextSibling;
                }
                while(domAfter && !((desc = domAfter.pmViewDesc) && desc.parent == this))domAfter = domAfter.nextSibling;
                return domAfter ? this.posBeforeChild(desc) : this.posAtEnd;
            }
        }
        // Otherwise, use various heuristics, falling back on the bias
        // parameter, to determine whether to return the position at the
        // start or at the end of this view desc.
        let atEnd;
        if (dom == this.dom && this.contentDOM) atEnd = offset > $81901ae0222f0506$var$domIndex(this.contentDOM);
        else if (this.contentDOM && this.contentDOM != this.dom && this.dom.contains(this.contentDOM)) atEnd = dom.compareDocumentPosition(this.contentDOM) & 2;
        else if (this.dom.firstChild) {
            if (offset == 0) for(let search = dom;; search = search.parentNode){
                if (search == this.dom) {
                    atEnd = false;
                    break;
                }
                if (search.previousSibling) break;
            }
            if (atEnd == null && offset == dom.childNodes.length) for(let search = dom;; search = search.parentNode){
                if (search == this.dom) {
                    atEnd = true;
                    break;
                }
                if (search.nextSibling) break;
            }
        }
        return (atEnd == null ? bias > 0 : atEnd) ? this.posAtEnd : this.posAtStart;
    }
    nearestDesc(dom, onlyNodes = false) {
        for(let first = true, cur = dom; cur; cur = cur.parentNode){
            let desc = this.getDesc(cur), nodeDOM;
            if (desc && (!onlyNodes || desc.node)) {
                // If dom is outside of this desc's nodeDOM, don't count it.
                if (first && (nodeDOM = desc.nodeDOM) && !(nodeDOM.nodeType == 1 ? nodeDOM.contains(dom.nodeType == 1 ? dom : dom.parentNode) : nodeDOM == dom)) first = false;
                else return desc;
            }
        }
    }
    getDesc(dom) {
        let desc = dom.pmViewDesc;
        for(let cur = desc; cur; cur = cur.parent)if (cur == this) return desc;
    }
    posFromDOM(dom, offset, bias) {
        for(let scan = dom; scan; scan = scan.parentNode){
            let desc = this.getDesc(scan);
            if (desc) return desc.localPosFromDOM(dom, offset, bias);
        }
        return -1;
    }
    // Find the desc for the node after the given pos, if any. (When a
    // parent node overrode rendering, there might not be one.)
    descAt(pos) {
        for(let i = 0, offset = 0; i < this.children.length; i++){
            let child = this.children[i], end = offset + child.size;
            if (offset == pos && end != offset) {
                while(!child.border && child.children.length)child = child.children[0];
                return child;
            }
            if (pos < end) return child.descAt(pos - offset - child.border);
            offset = end;
        }
    }
    domFromPos(pos, side) {
        if (!this.contentDOM) return {
            node: this.dom,
            offset: 0,
            atom: pos + 1
        };
        // First find the position in the child array
        let i = 0, offset = 0;
        for(let curPos = 0; i < this.children.length; i++){
            let child = this.children[i], end = curPos + child.size;
            if (end > pos || child instanceof $81901ae0222f0506$var$TrailingHackViewDesc) {
                offset = pos - curPos;
                break;
            }
            curPos = end;
        }
        // If this points into the middle of a child, call through
        if (offset) return this.children[i].domFromPos(offset - this.children[i].border, side);
        // Go back if there were any zero-length widgets with side >= 0 before this point
        for(let prev; i && !(prev = this.children[i - 1]).size && prev instanceof $81901ae0222f0506$var$WidgetViewDesc && prev.side >= 0; i--);
        // Scan towards the first useable node
        if (side <= 0) {
            let prev, enter = true;
            for(;; i--, enter = false){
                prev = i ? this.children[i - 1] : null;
                if (!prev || prev.dom.parentNode == this.contentDOM) break;
            }
            if (prev && side && enter && !prev.border && !prev.domAtom) return prev.domFromPos(prev.size, side);
            return {
                node: this.contentDOM,
                offset: prev ? $81901ae0222f0506$var$domIndex(prev.dom) + 1 : 0
            };
        } else {
            let next, enter = true;
            for(;; i++, enter = false){
                next = i < this.children.length ? this.children[i] : null;
                if (!next || next.dom.parentNode == this.contentDOM) break;
            }
            if (next && enter && !next.border && !next.domAtom) return next.domFromPos(0, side);
            return {
                node: this.contentDOM,
                offset: next ? $81901ae0222f0506$var$domIndex(next.dom) : this.contentDOM.childNodes.length
            };
        }
    }
    // Used to find a DOM range in a single parent for a given changed
    // range.
    parseRange(from, to, base = 0) {
        if (this.children.length == 0) return {
            node: this.contentDOM,
            from: from,
            to: to,
            fromOffset: 0,
            toOffset: this.contentDOM.childNodes.length
        };
        let fromOffset = -1, toOffset = -1;
        for(let offset = base, i = 0;; i++){
            let child = this.children[i], end = offset + child.size;
            if (fromOffset == -1 && from <= end) {
                let childBase = offset + child.border;
                // FIXME maybe descend mark views to parse a narrower range?
                if (from >= childBase && to <= end - child.border && child.node && child.contentDOM && this.contentDOM.contains(child.contentDOM)) return child.parseRange(from, to, childBase);
                from = offset;
                for(let j = i; j > 0; j--){
                    let prev = this.children[j - 1];
                    if (prev.size && prev.dom.parentNode == this.contentDOM && !prev.emptyChildAt(1)) {
                        fromOffset = $81901ae0222f0506$var$domIndex(prev.dom) + 1;
                        break;
                    }
                    from -= prev.size;
                }
                if (fromOffset == -1) fromOffset = 0;
            }
            if (fromOffset > -1 && (end > to || i == this.children.length - 1)) {
                to = end;
                for(let j = i + 1; j < this.children.length; j++){
                    let next = this.children[j];
                    if (next.size && next.dom.parentNode == this.contentDOM && !next.emptyChildAt(-1)) {
                        toOffset = $81901ae0222f0506$var$domIndex(next.dom);
                        break;
                    }
                    to += next.size;
                }
                if (toOffset == -1) toOffset = this.contentDOM.childNodes.length;
                break;
            }
            offset = end;
        }
        return {
            node: this.contentDOM,
            from: from,
            to: to,
            fromOffset: fromOffset,
            toOffset: toOffset
        };
    }
    emptyChildAt(side) {
        if (this.border || !this.contentDOM || !this.children.length) return false;
        let child = this.children[side < 0 ? 0 : this.children.length - 1];
        return child.size == 0 || child.emptyChildAt(side);
    }
    domAfterPos(pos) {
        let { node: node, offset: offset } = this.domFromPos(pos, 0);
        if (node.nodeType != 1 || offset == node.childNodes.length) throw new RangeError("No node after pos " + pos);
        return node.childNodes[offset];
    }
    // View descs are responsible for setting any selection that falls
    // entirely inside of them, so that custom implementations can do
    // custom things with the selection. Note that this falls apart when
    // a selection starts in such a node and ends in another, in which
    // case we just use whatever domFromPos produces as a best effort.
    setSelection(anchor, head, view, force = false) {
        // If the selection falls entirely in a child, give it to that child
        let from = Math.min(anchor, head), to = Math.max(anchor, head);
        for(let i = 0, offset = 0; i < this.children.length; i++){
            let child = this.children[i], end = offset + child.size;
            if (from > offset && to < end) return child.setSelection(anchor - offset - child.border, head - offset - child.border, view, force);
            offset = end;
        }
        let anchorDOM = this.domFromPos(anchor, anchor ? -1 : 1);
        let headDOM = head == anchor ? anchorDOM : this.domFromPos(head, head ? -1 : 1);
        let domSel = view.root.getSelection();
        let selRange = view.domSelectionRange();
        let brKludge = false;
        // On Firefox, using Selection.collapse to put the cursor after a
        // BR node for some reason doesn't always work (#1073). On Safari,
        // the cursor sometimes inexplicable visually lags behind its
        // reported position in such situations (#1092).
        if (($81901ae0222f0506$var$gecko || $81901ae0222f0506$var$safari) && anchor == head) {
            let { node: node, offset: offset } = anchorDOM;
            if (node.nodeType == 3) {
                brKludge = !!(offset && node.nodeValue[offset - 1] == "\n");
                // Issue #1128
                if (brKludge && offset == node.nodeValue.length) for(let scan = node, after; scan; scan = scan.parentNode){
                    if (after = scan.nextSibling) {
                        if (after.nodeName == "BR") anchorDOM = headDOM = {
                            node: after.parentNode,
                            offset: $81901ae0222f0506$var$domIndex(after) + 1
                        };
                        break;
                    }
                    let desc = scan.pmViewDesc;
                    if (desc && desc.node && desc.node.isBlock) break;
                }
            } else {
                let prev = node.childNodes[offset - 1];
                brKludge = prev && (prev.nodeName == "BR" || prev.contentEditable == "false");
            }
        }
        // Firefox can act strangely when the selection is in front of an
        // uneditable node. See #1163 and https://bugzilla.mozilla.org/show_bug.cgi?id=1709536
        if ($81901ae0222f0506$var$gecko && selRange.focusNode && selRange.focusNode != headDOM.node && selRange.focusNode.nodeType == 1) {
            let after = selRange.focusNode.childNodes[selRange.focusOffset];
            if (after && after.contentEditable == "false") force = true;
        }
        if (!(force || brKludge && $81901ae0222f0506$var$safari) && $81901ae0222f0506$var$isEquivalentPosition(anchorDOM.node, anchorDOM.offset, selRange.anchorNode, selRange.anchorOffset) && $81901ae0222f0506$var$isEquivalentPosition(headDOM.node, headDOM.offset, selRange.focusNode, selRange.focusOffset)) return;
        // Selection.extend can be used to create an 'inverted' selection
        // (one where the focus is before the anchor), but not all
        // browsers support it yet.
        let domSelExtended = false;
        if ((domSel.extend || anchor == head) && !brKludge) {
            domSel.collapse(anchorDOM.node, anchorDOM.offset);
            try {
                if (anchor != head) domSel.extend(headDOM.node, headDOM.offset);
                domSelExtended = true;
            } catch (_) {
            // In some cases with Chrome the selection is empty after calling
            // collapse, even when it should be valid. This appears to be a bug, but
            // it is difficult to isolate. If this happens fallback to the old path
            // without using extend.
            // Similarly, this could crash on Safari if the editor is hidden, and
            // there was no selection.
            }
        }
        if (!domSelExtended) {
            if (anchor > head) {
                let tmp = anchorDOM;
                anchorDOM = headDOM;
                headDOM = tmp;
            }
            let range = document.createRange();
            range.setEnd(headDOM.node, headDOM.offset);
            range.setStart(anchorDOM.node, anchorDOM.offset);
            domSel.removeAllRanges();
            domSel.addRange(range);
        }
    }
    ignoreMutation(mutation) {
        return !this.contentDOM && mutation.type != "selection";
    }
    get contentLost() {
        return this.contentDOM && this.contentDOM != this.dom && !this.dom.contains(this.contentDOM);
    }
    // Remove a subtree of the element tree that has been touched
    // by a DOM change, so that the next update will redraw it.
    markDirty(from, to) {
        for(let offset = 0, i = 0; i < this.children.length; i++){
            let child = this.children[i], end = offset + child.size;
            if (offset == end ? from <= end && to >= offset : from < end && to > offset) {
                let startInside = offset + child.border, endInside = end - child.border;
                if (from >= startInside && to <= endInside) {
                    this.dirty = from == offset || to == end ? $81901ae0222f0506$var$CONTENT_DIRTY : $81901ae0222f0506$var$CHILD_DIRTY;
                    if (from == startInside && to == endInside && (child.contentLost || child.dom.parentNode != this.contentDOM)) child.dirty = $81901ae0222f0506$var$NODE_DIRTY;
                    else child.markDirty(from - startInside, to - startInside);
                    return;
                } else child.dirty = child.dom == child.contentDOM && child.dom.parentNode == this.contentDOM && !child.children.length ? $81901ae0222f0506$var$CONTENT_DIRTY : $81901ae0222f0506$var$NODE_DIRTY;
            }
            offset = end;
        }
        this.dirty = $81901ae0222f0506$var$CONTENT_DIRTY;
    }
    markParentsDirty() {
        let level = 1;
        for(let node = this.parent; node; node = node.parent, level++){
            let dirty = level == 1 ? $81901ae0222f0506$var$CONTENT_DIRTY : $81901ae0222f0506$var$CHILD_DIRTY;
            if (node.dirty < dirty) node.dirty = dirty;
        }
    }
    get domAtom() {
        return false;
    }
    get ignoreForCoords() {
        return false;
    }
    isText(text) {
        return false;
    }
}
// A widget desc represents a widget decoration, which is a DOM node
// drawn between the document nodes.
class $81901ae0222f0506$var$WidgetViewDesc extends $81901ae0222f0506$var$ViewDesc {
    constructor(parent, widget, view, pos){
        let self, dom = widget.type.toDOM;
        if (typeof dom == "function") dom = dom(view, ()=>{
            if (!self) return pos;
            if (self.parent) return self.parent.posBeforeChild(self);
        });
        if (!widget.type.spec.raw) {
            if (dom.nodeType != 1) {
                let wrap = document.createElement("span");
                wrap.appendChild(dom);
                dom = wrap;
            }
            dom.contentEditable = "false";
            dom.classList.add("ProseMirror-widget");
        }
        super(parent, [], dom, null);
        this.widget = widget;
        this.widget = widget;
        self = this;
    }
    matchesWidget(widget) {
        return this.dirty == $81901ae0222f0506$var$NOT_DIRTY && widget.type.eq(this.widget.type);
    }
    parseRule() {
        return {
            ignore: true
        };
    }
    stopEvent(event) {
        let stop = this.widget.spec.stopEvent;
        return stop ? stop(event) : false;
    }
    ignoreMutation(mutation) {
        return mutation.type != "selection" || this.widget.spec.ignoreSelection;
    }
    destroy() {
        this.widget.type.destroy(this.dom);
        super.destroy();
    }
    get domAtom() {
        return true;
    }
    get side() {
        return this.widget.type.side;
    }
}
class $81901ae0222f0506$var$CompositionViewDesc extends $81901ae0222f0506$var$ViewDesc {
    constructor(parent, dom, textDOM, text){
        super(parent, [], dom, null);
        this.textDOM = textDOM;
        this.text = text;
    }
    get size() {
        return this.text.length;
    }
    localPosFromDOM(dom, offset) {
        if (dom != this.textDOM) return this.posAtStart + (offset ? this.size : 0);
        return this.posAtStart + offset;
    }
    domFromPos(pos) {
        return {
            node: this.textDOM,
            offset: pos
        };
    }
    ignoreMutation(mut) {
        return mut.type === 'characterData' && mut.target.nodeValue == mut.oldValue;
    }
}
// A mark desc represents a mark. May have multiple children,
// depending on how the mark is split. Note that marks are drawn using
// a fixed nesting order, for simplicity and predictability, so in
// some cases they will be split more often than would appear
// necessary.
class $81901ae0222f0506$var$MarkViewDesc extends $81901ae0222f0506$var$ViewDesc {
    constructor(parent, mark, dom, contentDOM, spec){
        super(parent, [], dom, contentDOM);
        this.mark = mark;
        this.spec = spec;
    }
    static create(parent, mark, inline, view) {
        let custom = view.nodeViews[mark.type.name];
        let spec = custom && custom(mark, view, inline);
        if (!spec || !spec.dom) spec = (0, $3xw6l.DOMSerializer).renderSpec(document, mark.type.spec.toDOM(mark, inline), null, mark.attrs);
        return new $81901ae0222f0506$var$MarkViewDesc(parent, mark, spec.dom, spec.contentDOM || spec.dom, spec);
    }
    parseRule() {
        if (this.dirty & $81901ae0222f0506$var$NODE_DIRTY || this.mark.type.spec.reparseInView) return null;
        return {
            mark: this.mark.type.name,
            attrs: this.mark.attrs,
            contentElement: this.contentDOM
        };
    }
    matchesMark(mark) {
        return this.dirty != $81901ae0222f0506$var$NODE_DIRTY && this.mark.eq(mark);
    }
    markDirty(from, to) {
        super.markDirty(from, to);
        // Move dirty info to nearest node view
        if (this.dirty != $81901ae0222f0506$var$NOT_DIRTY) {
            let parent = this.parent;
            while(!parent.node)parent = parent.parent;
            if (parent.dirty < this.dirty) parent.dirty = this.dirty;
            this.dirty = $81901ae0222f0506$var$NOT_DIRTY;
        }
    }
    slice(from, to, view) {
        let copy = $81901ae0222f0506$var$MarkViewDesc.create(this.parent, this.mark, true, view);
        let nodes = this.children, size = this.size;
        if (to < size) nodes = $81901ae0222f0506$var$replaceNodes(nodes, to, size, view);
        if (from > 0) nodes = $81901ae0222f0506$var$replaceNodes(nodes, 0, from, view);
        for(let i = 0; i < nodes.length; i++)nodes[i].parent = copy;
        copy.children = nodes;
        return copy;
    }
    ignoreMutation(mutation) {
        return this.spec.ignoreMutation ? this.spec.ignoreMutation(mutation) : super.ignoreMutation(mutation);
    }
    destroy() {
        if (this.spec.destroy) this.spec.destroy();
        super.destroy();
    }
}
// Node view descs are the main, most common type of view desc, and
// correspond to an actual node in the document. Unlike mark descs,
// they populate their child array themselves.
class $81901ae0222f0506$var$NodeViewDesc extends $81901ae0222f0506$var$ViewDesc {
    constructor(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, view, pos){
        super(parent, [], dom, contentDOM);
        this.node = node;
        this.outerDeco = outerDeco;
        this.innerDeco = innerDeco;
        this.nodeDOM = nodeDOM;
    }
    // By default, a node is rendered using the `toDOM` method from the
    // node type spec. But client code can use the `nodeViews` spec to
    // supply a custom node view, which can influence various aspects of
    // the way the node works.
    //
    // (Using subclassing for this was intentionally decided against,
    // since it'd require exposing a whole slew of finicky
    // implementation details to the user code that they probably will
    // never need.)
    static create(parent, node, outerDeco, innerDeco, view, pos) {
        let custom = view.nodeViews[node.type.name], descObj;
        let spec = custom && custom(node, view, ()=>{
            // (This is a function that allows the custom view to find its
            // own position)
            if (!descObj) return pos;
            if (descObj.parent) return descObj.parent.posBeforeChild(descObj);
        }, outerDeco, innerDeco);
        let dom = spec && spec.dom, contentDOM = spec && spec.contentDOM;
        if (node.isText) {
            if (!dom) dom = document.createTextNode(node.text);
            else if (dom.nodeType != 3) throw new RangeError("Text must be rendered as a DOM text node");
        } else if (!dom) {
            let spec = (0, $3xw6l.DOMSerializer).renderSpec(document, node.type.spec.toDOM(node), null, node.attrs);
            ({ dom: dom, contentDOM: contentDOM } = spec);
        }
        if (!contentDOM && !node.isText && dom.nodeName != "BR") {
            if (!dom.hasAttribute("contenteditable")) dom.contentEditable = "false";
            if (node.type.spec.draggable) dom.draggable = true;
        }
        let nodeDOM = dom;
        dom = $81901ae0222f0506$var$applyOuterDeco(dom, outerDeco, node);
        if (spec) return descObj = new $81901ae0222f0506$var$CustomNodeViewDesc(parent, node, outerDeco, innerDeco, dom, contentDOM || null, nodeDOM, spec, view, pos + 1);
        else if (node.isText) return new $81901ae0222f0506$var$TextViewDesc(parent, node, outerDeco, innerDeco, dom, nodeDOM, view);
        else return new $81901ae0222f0506$var$NodeViewDesc(parent, node, outerDeco, innerDeco, dom, contentDOM || null, nodeDOM, view, pos + 1);
    }
    parseRule() {
        // Experimental kludge to allow opt-in re-parsing of nodes
        if (this.node.type.spec.reparseInView) return null;
        // FIXME the assumption that this can always return the current
        // attrs means that if the user somehow manages to change the
        // attrs in the dom, that won't be picked up. Not entirely sure
        // whether this is a problem
        let rule = {
            node: this.node.type.name,
            attrs: this.node.attrs
        };
        if (this.node.type.whitespace == "pre") rule.preserveWhitespace = "full";
        if (!this.contentDOM) rule.getContent = ()=>this.node.content;
        else if (!this.contentLost) rule.contentElement = this.contentDOM;
        else {
            // Chrome likes to randomly recreate parent nodes when
            // backspacing things. When that happens, this tries to find the
            // new parent.
            for(let i = this.children.length - 1; i >= 0; i--){
                let child = this.children[i];
                if (this.dom.contains(child.dom.parentNode)) {
                    rule.contentElement = child.dom.parentNode;
                    break;
                }
            }
            if (!rule.contentElement) rule.getContent = ()=>(0, $3xw6l.Fragment).empty;
        }
        return rule;
    }
    matchesNode(node, outerDeco, innerDeco) {
        return this.dirty == $81901ae0222f0506$var$NOT_DIRTY && node.eq(this.node) && $81901ae0222f0506$var$sameOuterDeco(outerDeco, this.outerDeco) && innerDeco.eq(this.innerDeco);
    }
    get size() {
        return this.node.nodeSize;
    }
    get border() {
        return this.node.isLeaf ? 0 : 1;
    }
    // Syncs `this.children` to match `this.node.content` and the local
    // decorations, possibly introducing nesting for marks. Then, in a
    // separate step, syncs the DOM inside `this.contentDOM` to
    // `this.children`.
    updateChildren(view, pos) {
        let inline = this.node.inlineContent, off = pos;
        let composition = view.composing ? this.localCompositionInfo(view, pos) : null;
        let localComposition = composition && composition.pos > -1 ? composition : null;
        let compositionInChild = composition && composition.pos < 0;
        let updater = new $81901ae0222f0506$var$ViewTreeUpdater(this, localComposition && localComposition.node, view);
        $81901ae0222f0506$var$iterDeco(this.node, this.innerDeco, (widget, i, insideNode)=>{
            if (widget.spec.marks) updater.syncToMarks(widget.spec.marks, inline, view);
            else if (widget.type.side >= 0 && !insideNode) updater.syncToMarks(i == this.node.childCount ? (0, $3xw6l.Mark).none : this.node.child(i).marks, inline, view);
            // If the next node is a desc matching this widget, reuse it,
            // otherwise insert the widget as a new view desc.
            updater.placeWidget(widget, view, off);
        }, (child, outerDeco, innerDeco, i)=>{
            // Make sure the wrapping mark descs match the node's marks.
            updater.syncToMarks(child.marks, inline, view);
            // Try several strategies for drawing this node
            let compIndex;
            if (updater.findNodeMatch(child, outerDeco, innerDeco, i)) ;
            else if (compositionInChild && view.state.selection.from > off && view.state.selection.to < off + child.nodeSize && (compIndex = updater.findIndexWithChild(composition.node)) > -1 && updater.updateNodeAt(child, outerDeco, innerDeco, compIndex, view)) ;
            else if (updater.updateNextNode(child, outerDeco, innerDeco, view, i, off)) ;
            else // Add it as a new view
            updater.addNode(child, outerDeco, innerDeco, view, off);
            off += child.nodeSize;
        });
        // Drop all remaining descs after the current position.
        updater.syncToMarks([], inline, view);
        if (this.node.isTextblock) updater.addTextblockHacks();
        updater.destroyRest();
        // Sync the DOM if anything changed
        if (updater.changed || this.dirty == $81901ae0222f0506$var$CONTENT_DIRTY) {
            // May have to protect focused DOM from being changed if a composition is active
            if (localComposition) this.protectLocalComposition(view, localComposition);
            $81901ae0222f0506$var$renderDescs(this.contentDOM, this.children, view);
            if ($81901ae0222f0506$var$ios) $81901ae0222f0506$var$iosHacks(this.dom);
        }
    }
    localCompositionInfo(view, pos) {
        // Only do something if both the selection and a focused text node
        // are inside of this node
        let { from: from, to: to } = view.state.selection;
        if (!(view.state.selection instanceof (0, $3lIcL.TextSelection)) || from < pos || to > pos + this.node.content.size) return null;
        let textNode = view.input.compositionNode;
        if (!textNode || !this.dom.contains(textNode.parentNode)) return null;
        if (this.node.inlineContent) {
            // Find the text in the focused node in the node, stop if it's not
            // there (may have been modified through other means, in which
            // case it should overwritten)
            let text = textNode.nodeValue;
            let textPos = $81901ae0222f0506$var$findTextInFragment(this.node.content, text, from - pos, to - pos);
            return textPos < 0 ? null : {
                node: textNode,
                pos: textPos,
                text: text
            };
        } else return {
            node: textNode,
            pos: -1,
            text: ""
        };
    }
    protectLocalComposition(view, { node: node, pos: pos, text: text }) {
        // The node is already part of a local view desc, leave it there
        if (this.getDesc(node)) return;
        // Create a composition view for the orphaned nodes
        let topNode = node;
        for(;; topNode = topNode.parentNode){
            if (topNode.parentNode == this.contentDOM) break;
            while(topNode.previousSibling)topNode.parentNode.removeChild(topNode.previousSibling);
            while(topNode.nextSibling)topNode.parentNode.removeChild(topNode.nextSibling);
            if (topNode.pmViewDesc) topNode.pmViewDesc = undefined;
        }
        let desc = new $81901ae0222f0506$var$CompositionViewDesc(this, topNode, node, text);
        view.input.compositionNodes.push(desc);
        // Patch up this.children to contain the composition view
        this.children = $81901ae0222f0506$var$replaceNodes(this.children, pos, pos + text.length, view, desc);
    }
    // If this desc must be updated to match the given node decoration,
    // do so and return true.
    update(node, outerDeco, innerDeco, view) {
        if (this.dirty == $81901ae0222f0506$var$NODE_DIRTY || !node.sameMarkup(this.node)) return false;
        this.updateInner(node, outerDeco, innerDeco, view);
        return true;
    }
    updateInner(node, outerDeco, innerDeco, view) {
        this.updateOuterDeco(outerDeco);
        this.node = node;
        this.innerDeco = innerDeco;
        if (this.contentDOM) this.updateChildren(view, this.posAtStart);
        this.dirty = $81901ae0222f0506$var$NOT_DIRTY;
    }
    updateOuterDeco(outerDeco) {
        if ($81901ae0222f0506$var$sameOuterDeco(outerDeco, this.outerDeco)) return;
        let needsWrap = this.nodeDOM.nodeType != 1;
        let oldDOM = this.dom;
        this.dom = $81901ae0222f0506$var$patchOuterDeco(this.dom, this.nodeDOM, $81901ae0222f0506$var$computeOuterDeco(this.outerDeco, this.node, needsWrap), $81901ae0222f0506$var$computeOuterDeco(outerDeco, this.node, needsWrap));
        if (this.dom != oldDOM) {
            oldDOM.pmViewDesc = undefined;
            this.dom.pmViewDesc = this;
        }
        this.outerDeco = outerDeco;
    }
    // Mark this node as being the selected node.
    selectNode() {
        if (this.nodeDOM.nodeType == 1) this.nodeDOM.classList.add("ProseMirror-selectednode");
        if (this.contentDOM || !this.node.type.spec.draggable) this.dom.draggable = true;
    }
    // Remove selected node marking from this node.
    deselectNode() {
        if (this.nodeDOM.nodeType == 1) {
            this.nodeDOM.classList.remove("ProseMirror-selectednode");
            if (this.contentDOM || !this.node.type.spec.draggable) this.dom.removeAttribute("draggable");
        }
    }
    get domAtom() {
        return this.node.isAtom;
    }
}
// Create a view desc for the top-level document node, to be exported
// and used by the view class.
function $81901ae0222f0506$var$docViewDesc(doc, outerDeco, innerDeco, dom, view) {
    $81901ae0222f0506$var$applyOuterDeco(dom, outerDeco, doc);
    let docView = new $81901ae0222f0506$var$NodeViewDesc(undefined, doc, outerDeco, innerDeco, dom, dom, dom, view, 0);
    if (docView.contentDOM) docView.updateChildren(view, 0);
    return docView;
}
class $81901ae0222f0506$var$TextViewDesc extends $81901ae0222f0506$var$NodeViewDesc {
    constructor(parent, node, outerDeco, innerDeco, dom, nodeDOM, view){
        super(parent, node, outerDeco, innerDeco, dom, null, nodeDOM, view, 0);
    }
    parseRule() {
        let skip = this.nodeDOM.parentNode;
        while(skip && skip != this.dom && !skip.pmIsDeco)skip = skip.parentNode;
        return {
            skip: skip || true
        };
    }
    update(node, outerDeco, innerDeco, view) {
        if (this.dirty == $81901ae0222f0506$var$NODE_DIRTY || this.dirty != $81901ae0222f0506$var$NOT_DIRTY && !this.inParent() || !node.sameMarkup(this.node)) return false;
        this.updateOuterDeco(outerDeco);
        if ((this.dirty != $81901ae0222f0506$var$NOT_DIRTY || node.text != this.node.text) && node.text != this.nodeDOM.nodeValue) {
            this.nodeDOM.nodeValue = node.text;
            if (view.trackWrites == this.nodeDOM) view.trackWrites = null;
        }
        this.node = node;
        this.dirty = $81901ae0222f0506$var$NOT_DIRTY;
        return true;
    }
    inParent() {
        let parentDOM = this.parent.contentDOM;
        for(let n = this.nodeDOM; n; n = n.parentNode)if (n == parentDOM) return true;
        return false;
    }
    domFromPos(pos) {
        return {
            node: this.nodeDOM,
            offset: pos
        };
    }
    localPosFromDOM(dom, offset, bias) {
        if (dom == this.nodeDOM) return this.posAtStart + Math.min(offset, this.node.text.length);
        return super.localPosFromDOM(dom, offset, bias);
    }
    ignoreMutation(mutation) {
        return mutation.type != "characterData" && mutation.type != "selection";
    }
    slice(from, to, view) {
        let node = this.node.cut(from, to), dom = document.createTextNode(node.text);
        return new $81901ae0222f0506$var$TextViewDesc(this.parent, node, this.outerDeco, this.innerDeco, dom, dom, view);
    }
    markDirty(from, to) {
        super.markDirty(from, to);
        if (this.dom != this.nodeDOM && (from == 0 || to == this.nodeDOM.nodeValue.length)) this.dirty = $81901ae0222f0506$var$NODE_DIRTY;
    }
    get domAtom() {
        return false;
    }
    isText(text) {
        return this.node.text == text;
    }
}
// A dummy desc used to tag trailing BR or IMG nodes created to work
// around contentEditable terribleness.
class $81901ae0222f0506$var$TrailingHackViewDesc extends $81901ae0222f0506$var$ViewDesc {
    parseRule() {
        return {
            ignore: true
        };
    }
    matchesHack(nodeName) {
        return this.dirty == $81901ae0222f0506$var$NOT_DIRTY && this.dom.nodeName == nodeName;
    }
    get domAtom() {
        return true;
    }
    get ignoreForCoords() {
        return this.dom.nodeName == "IMG";
    }
}
// A separate subclass is used for customized node views, so that the
// extra checks only have to be made for nodes that are actually
// customized.
class $81901ae0222f0506$var$CustomNodeViewDesc extends $81901ae0222f0506$var$NodeViewDesc {
    constructor(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, spec, view, pos){
        super(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, view, pos);
        this.spec = spec;
    }
    // A custom `update` method gets to decide whether the update goes
    // through. If it does, and there's a `contentDOM` node, our logic
    // updates the children.
    update(node, outerDeco, innerDeco, view) {
        if (this.dirty == $81901ae0222f0506$var$NODE_DIRTY) return false;
        if (this.spec.update && (this.node.type == node.type || this.spec.multiType)) {
            let result = this.spec.update(node, outerDeco, innerDeco);
            if (result) this.updateInner(node, outerDeco, innerDeco, view);
            return result;
        } else if (!this.contentDOM && !node.isLeaf) return false;
        else return super.update(node, outerDeco, innerDeco, view);
    }
    selectNode() {
        this.spec.selectNode ? this.spec.selectNode() : super.selectNode();
    }
    deselectNode() {
        this.spec.deselectNode ? this.spec.deselectNode() : super.deselectNode();
    }
    setSelection(anchor, head, view, force) {
        this.spec.setSelection ? this.spec.setSelection(anchor, head, view.root) : super.setSelection(anchor, head, view, force);
    }
    destroy() {
        if (this.spec.destroy) this.spec.destroy();
        super.destroy();
    }
    stopEvent(event) {
        return this.spec.stopEvent ? this.spec.stopEvent(event) : false;
    }
    ignoreMutation(mutation) {
        return this.spec.ignoreMutation ? this.spec.ignoreMutation(mutation) : super.ignoreMutation(mutation);
    }
}
// Sync the content of the given DOM node with the nodes associated
// with the given array of view descs, recursing into mark descs
// because this should sync the subtree for a whole node at a time.
function $81901ae0222f0506$var$renderDescs(parentDOM, descs, view) {
    let dom = parentDOM.firstChild, written = false;
    for(let i = 0; i < descs.length; i++){
        let desc = descs[i], childDOM = desc.dom;
        if (childDOM.parentNode == parentDOM) {
            while(childDOM != dom){
                dom = $81901ae0222f0506$var$rm(dom);
                written = true;
            }
            dom = dom.nextSibling;
        } else {
            written = true;
            parentDOM.insertBefore(childDOM, dom);
        }
        if (desc instanceof $81901ae0222f0506$var$MarkViewDesc) {
            let pos = dom ? dom.previousSibling : parentDOM.lastChild;
            $81901ae0222f0506$var$renderDescs(desc.contentDOM, desc.children, view);
            dom = pos ? pos.nextSibling : parentDOM.firstChild;
        }
    }
    while(dom){
        dom = $81901ae0222f0506$var$rm(dom);
        written = true;
    }
    if (written && view.trackWrites == parentDOM) view.trackWrites = null;
}
const $81901ae0222f0506$var$OuterDecoLevel = function(nodeName) {
    if (nodeName) this.nodeName = nodeName;
};
$81901ae0222f0506$var$OuterDecoLevel.prototype = Object.create(null);
const $81901ae0222f0506$var$noDeco = [
    new $81901ae0222f0506$var$OuterDecoLevel
];
function $81901ae0222f0506$var$computeOuterDeco(outerDeco, node, needsWrap) {
    if (outerDeco.length == 0) return $81901ae0222f0506$var$noDeco;
    let top = needsWrap ? $81901ae0222f0506$var$noDeco[0] : new $81901ae0222f0506$var$OuterDecoLevel, result = [
        top
    ];
    for(let i = 0; i < outerDeco.length; i++){
        let attrs = outerDeco[i].type.attrs;
        if (!attrs) continue;
        if (attrs.nodeName) result.push(top = new $81901ae0222f0506$var$OuterDecoLevel(attrs.nodeName));
        for(let name in attrs){
            let val = attrs[name];
            if (val == null) continue;
            if (needsWrap && result.length == 1) result.push(top = new $81901ae0222f0506$var$OuterDecoLevel(node.isInline ? "span" : "div"));
            if (name == "class") top.class = (top.class ? top.class + " " : "") + val;
            else if (name == "style") top.style = (top.style ? top.style + ";" : "") + val;
            else if (name != "nodeName") top[name] = val;
        }
    }
    return result;
}
function $81901ae0222f0506$var$patchOuterDeco(outerDOM, nodeDOM, prevComputed, curComputed) {
    // Shortcut for trivial case
    if (prevComputed == $81901ae0222f0506$var$noDeco && curComputed == $81901ae0222f0506$var$noDeco) return nodeDOM;
    let curDOM = nodeDOM;
    for(let i = 0; i < curComputed.length; i++){
        let deco = curComputed[i], prev = prevComputed[i];
        if (i) {
            let parent;
            if (prev && prev.nodeName == deco.nodeName && curDOM != outerDOM && (parent = curDOM.parentNode) && parent.nodeName.toLowerCase() == deco.nodeName) curDOM = parent;
            else {
                parent = document.createElement(deco.nodeName);
                parent.pmIsDeco = true;
                parent.appendChild(curDOM);
                prev = $81901ae0222f0506$var$noDeco[0];
                curDOM = parent;
            }
        }
        $81901ae0222f0506$var$patchAttributes(curDOM, prev || $81901ae0222f0506$var$noDeco[0], deco);
    }
    return curDOM;
}
function $81901ae0222f0506$var$patchAttributes(dom, prev, cur) {
    for(let name in prev)if (name != "class" && name != "style" && name != "nodeName" && !(name in cur)) dom.removeAttribute(name);
    for(let name in cur)if (name != "class" && name != "style" && name != "nodeName" && cur[name] != prev[name]) dom.setAttribute(name, cur[name]);
    if (prev.class != cur.class) {
        let prevList = prev.class ? prev.class.split(" ").filter(Boolean) : [];
        let curList = cur.class ? cur.class.split(" ").filter(Boolean) : [];
        for(let i = 0; i < prevList.length; i++)if (curList.indexOf(prevList[i]) == -1) dom.classList.remove(prevList[i]);
        for(let i = 0; i < curList.length; i++)if (prevList.indexOf(curList[i]) == -1) dom.classList.add(curList[i]);
        if (dom.classList.length == 0) dom.removeAttribute("class");
    }
    if (prev.style != cur.style) {
        if (prev.style) {
            let prop = /\s*([\w\-\xa1-\uffff]+)\s*:(?:"(?:\\.|[^"])*"|'(?:\\.|[^'])*'|\(.*?\)|[^;])*/g, m;
            while(m = prop.exec(prev.style))dom.style.removeProperty(m[1]);
        }
        if (cur.style) dom.style.cssText += cur.style;
    }
}
function $81901ae0222f0506$var$applyOuterDeco(dom, deco, node) {
    return $81901ae0222f0506$var$patchOuterDeco(dom, dom, $81901ae0222f0506$var$noDeco, $81901ae0222f0506$var$computeOuterDeco(deco, node, dom.nodeType != 1));
}
function $81901ae0222f0506$var$sameOuterDeco(a, b) {
    if (a.length != b.length) return false;
    for(let i = 0; i < a.length; i++)if (!a[i].type.eq(b[i].type)) return false;
    return true;
}
// Remove a DOM node and return its next sibling.
function $81901ae0222f0506$var$rm(dom) {
    let next = dom.nextSibling;
    dom.parentNode.removeChild(dom);
    return next;
}
// Helper class for incrementally updating a tree of mark descs and
// the widget and node descs inside of them.
class $81901ae0222f0506$var$ViewTreeUpdater {
    constructor(top, lock, view){
        this.lock = lock;
        this.view = view;
        // Index into `this.top`'s child array, represents the current
        // update position.
        this.index = 0;
        // When entering a mark, the current top and index are pushed
        // onto this.
        this.stack = [];
        // Tracks whether anything was changed
        this.changed = false;
        this.top = top;
        this.preMatch = $81901ae0222f0506$var$preMatch(top.node.content, top);
    }
    // Destroy and remove the children between the given indices in
    // `this.top`.
    destroyBetween(start, end) {
        if (start == end) return;
        for(let i = start; i < end; i++)this.top.children[i].destroy();
        this.top.children.splice(start, end - start);
        this.changed = true;
    }
    // Destroy all remaining children in `this.top`.
    destroyRest() {
        this.destroyBetween(this.index, this.top.children.length);
    }
    // Sync the current stack of mark descs with the given array of
    // marks, reusing existing mark descs when possible.
    syncToMarks(marks, inline, view) {
        let keep = 0, depth = this.stack.length >> 1;
        let maxKeep = Math.min(depth, marks.length);
        while(keep < maxKeep && (keep == depth - 1 ? this.top : this.stack[keep + 1 << 1]).matchesMark(marks[keep]) && marks[keep].type.spec.spanning !== false)keep++;
        while(keep < depth){
            this.destroyRest();
            this.top.dirty = $81901ae0222f0506$var$NOT_DIRTY;
            this.index = this.stack.pop();
            this.top = this.stack.pop();
            depth--;
        }
        while(depth < marks.length){
            this.stack.push(this.top, this.index + 1);
            let found = -1;
            for(let i = this.index; i < Math.min(this.index + 3, this.top.children.length); i++){
                let next = this.top.children[i];
                if (next.matchesMark(marks[depth]) && !this.isLocked(next.dom)) {
                    found = i;
                    break;
                }
            }
            if (found > -1) {
                if (found > this.index) {
                    this.changed = true;
                    this.destroyBetween(this.index, found);
                }
                this.top = this.top.children[this.index];
            } else {
                let markDesc = $81901ae0222f0506$var$MarkViewDesc.create(this.top, marks[depth], inline, view);
                this.top.children.splice(this.index, 0, markDesc);
                this.top = markDesc;
                this.changed = true;
            }
            this.index = 0;
            depth++;
        }
    }
    // Try to find a node desc matching the given data. Skip over it and
    // return true when successful.
    findNodeMatch(node, outerDeco, innerDeco, index) {
        let found = -1, targetDesc;
        if (index >= this.preMatch.index && (targetDesc = this.preMatch.matches[index - this.preMatch.index]).parent == this.top && targetDesc.matchesNode(node, outerDeco, innerDeco)) found = this.top.children.indexOf(targetDesc, this.index);
        else for(let i = this.index, e = Math.min(this.top.children.length, i + 5); i < e; i++){
            let child = this.top.children[i];
            if (child.matchesNode(node, outerDeco, innerDeco) && !this.preMatch.matched.has(child)) {
                found = i;
                break;
            }
        }
        if (found < 0) return false;
        this.destroyBetween(this.index, found);
        this.index++;
        return true;
    }
    updateNodeAt(node, outerDeco, innerDeco, index, view) {
        let child = this.top.children[index];
        if (child.dirty == $81901ae0222f0506$var$NODE_DIRTY && child.dom == child.contentDOM) child.dirty = $81901ae0222f0506$var$CONTENT_DIRTY;
        if (!child.update(node, outerDeco, innerDeco, view)) return false;
        this.destroyBetween(this.index, index);
        this.index++;
        return true;
    }
    findIndexWithChild(domNode) {
        for(;;){
            let parent = domNode.parentNode;
            if (!parent) return -1;
            if (parent == this.top.contentDOM) {
                let desc = domNode.pmViewDesc;
                if (desc) for(let i = this.index; i < this.top.children.length; i++){
                    if (this.top.children[i] == desc) return i;
                }
                return -1;
            }
            domNode = parent;
        }
    }
    // Try to update the next node, if any, to the given data. Checks
    // pre-matches to avoid overwriting nodes that could still be used.
    updateNextNode(node, outerDeco, innerDeco, view, index, pos) {
        for(let i = this.index; i < this.top.children.length; i++){
            let next = this.top.children[i];
            if (next instanceof $81901ae0222f0506$var$NodeViewDesc) {
                let preMatch = this.preMatch.matched.get(next);
                if (preMatch != null && preMatch != index) return false;
                let nextDOM = next.dom, updated;
                // Can't update if nextDOM is or contains this.lock, except if
                // it's a text node whose content already matches the new text
                // and whose decorations match the new ones.
                let locked = this.isLocked(nextDOM) && !(node.isText && next.node && next.node.isText && next.nodeDOM.nodeValue == node.text && next.dirty != $81901ae0222f0506$var$NODE_DIRTY && $81901ae0222f0506$var$sameOuterDeco(outerDeco, next.outerDeco));
                if (!locked && next.update(node, outerDeco, innerDeco, view)) {
                    this.destroyBetween(this.index, i);
                    if (next.dom != nextDOM) this.changed = true;
                    this.index++;
                    return true;
                } else if (!locked && (updated = this.recreateWrapper(next, node, outerDeco, innerDeco, view, pos))) {
                    this.destroyBetween(this.index, i);
                    this.top.children[this.index] = updated;
                    if (updated.contentDOM) {
                        updated.dirty = $81901ae0222f0506$var$CONTENT_DIRTY;
                        updated.updateChildren(view, pos + 1);
                        updated.dirty = $81901ae0222f0506$var$NOT_DIRTY;
                    }
                    this.changed = true;
                    this.index++;
                    return true;
                }
                break;
            }
        }
        return false;
    }
    // When a node with content is replaced by a different node with
    // identical content, move over its children.
    recreateWrapper(next, node, outerDeco, innerDeco, view, pos) {
        if (next.dirty || node.isAtom || !next.children.length || !next.node.content.eq(node.content) || !$81901ae0222f0506$var$sameOuterDeco(outerDeco, next.outerDeco) || !innerDeco.eq(next.innerDeco)) return null;
        let wrapper = $81901ae0222f0506$var$NodeViewDesc.create(this.top, node, outerDeco, innerDeco, view, pos);
        if (wrapper.contentDOM) {
            wrapper.children = next.children;
            next.children = [];
            for (let ch of wrapper.children)ch.parent = wrapper;
        }
        next.destroy();
        return wrapper;
    }
    // Insert the node as a newly created node desc.
    addNode(node, outerDeco, innerDeco, view, pos) {
        let desc = $81901ae0222f0506$var$NodeViewDesc.create(this.top, node, outerDeco, innerDeco, view, pos);
        if (desc.contentDOM) desc.updateChildren(view, pos + 1);
        this.top.children.splice(this.index++, 0, desc);
        this.changed = true;
    }
    placeWidget(widget, view, pos) {
        let next = this.index < this.top.children.length ? this.top.children[this.index] : null;
        if (next && next.matchesWidget(widget) && (widget == next.widget || !next.widget.type.toDOM.parentNode)) this.index++;
        else {
            let desc = new $81901ae0222f0506$var$WidgetViewDesc(this.top, widget, view, pos);
            this.top.children.splice(this.index++, 0, desc);
            this.changed = true;
        }
    }
    // Make sure a textblock looks and behaves correctly in
    // contentEditable.
    addTextblockHacks() {
        let lastChild = this.top.children[this.index - 1], parent = this.top;
        while(lastChild instanceof $81901ae0222f0506$var$MarkViewDesc){
            parent = lastChild;
            lastChild = parent.children[parent.children.length - 1];
        }
        if (!lastChild || // Empty textblock
        !(lastChild instanceof $81901ae0222f0506$var$TextViewDesc) || /\n$/.test(lastChild.node.text) || this.view.requiresGeckoHackNode && /\s$/.test(lastChild.node.text)) {
            // Avoid bugs in Safari's cursor drawing (#1165) and Chrome's mouse selection (#1152)
            if (($81901ae0222f0506$var$safari || $81901ae0222f0506$var$chrome) && lastChild && lastChild.dom.contentEditable == "false") this.addHackNode("IMG", parent);
            this.addHackNode("BR", this.top);
        }
    }
    addHackNode(nodeName, parent) {
        if (parent == this.top && this.index < parent.children.length && parent.children[this.index].matchesHack(nodeName)) this.index++;
        else {
            let dom = document.createElement(nodeName);
            if (nodeName == "IMG") {
                dom.className = "ProseMirror-separator";
                dom.alt = "";
            }
            if (nodeName == "BR") dom.className = "ProseMirror-trailingBreak";
            let hack = new $81901ae0222f0506$var$TrailingHackViewDesc(this.top, [], dom, null);
            if (parent != this.top) parent.children.push(hack);
            else parent.children.splice(this.index++, 0, hack);
            this.changed = true;
        }
    }
    isLocked(node) {
        return this.lock && (node == this.lock || node.nodeType == 1 && node.contains(this.lock.parentNode));
    }
}
// Iterate from the end of the fragment and array of descs to find
// directly matching ones, in order to avoid overeagerly reusing those
// for other nodes. Returns the fragment index of the first node that
// is part of the sequence of matched nodes at the end of the
// fragment.
function $81901ae0222f0506$var$preMatch(frag, parentDesc) {
    let curDesc = parentDesc, descI = curDesc.children.length;
    let fI = frag.childCount, matched = new Map, matches = [];
    outer: while(fI > 0){
        let desc;
        for(;;){
            if (descI) {
                let next = curDesc.children[descI - 1];
                if (next instanceof $81901ae0222f0506$var$MarkViewDesc) {
                    curDesc = next;
                    descI = next.children.length;
                } else {
                    desc = next;
                    descI--;
                    break;
                }
            } else if (curDesc == parentDesc) break outer;
            else {
                // FIXME
                descI = curDesc.parent.children.indexOf(curDesc);
                curDesc = curDesc.parent;
            }
        }
        let node = desc.node;
        if (!node) continue;
        if (node != frag.child(fI - 1)) break;
        --fI;
        matched.set(desc, fI);
        matches.push(desc);
    }
    return {
        index: fI,
        matched: matched,
        matches: matches.reverse()
    };
}
function $81901ae0222f0506$var$compareSide(a, b) {
    return a.type.side - b.type.side;
}
// This function abstracts iterating over the nodes and decorations in
// a fragment. Calls `onNode` for each node, with its local and child
// decorations. Splits text nodes when there is a decoration starting
// or ending inside of them. Calls `onWidget` for each widget.
function $81901ae0222f0506$var$iterDeco(parent, deco, onWidget, onNode) {
    let locals = deco.locals(parent), offset = 0;
    // Simple, cheap variant for when there are no local decorations
    if (locals.length == 0) {
        for(let i = 0; i < parent.childCount; i++){
            let child = parent.child(i);
            onNode(child, locals, deco.forChild(offset, child), i);
            offset += child.nodeSize;
        }
        return;
    }
    let decoIndex = 0, active = [], restNode = null;
    for(let parentIndex = 0;;){
        let widget, widgets;
        while(decoIndex < locals.length && locals[decoIndex].to == offset){
            let next = locals[decoIndex++];
            if (next.widget) {
                if (!widget) widget = next;
                else (widgets || (widgets = [
                    widget
                ])).push(next);
            }
        }
        if (widget) {
            if (widgets) {
                widgets.sort($81901ae0222f0506$var$compareSide);
                for(let i = 0; i < widgets.length; i++)onWidget(widgets[i], parentIndex, !!restNode);
            } else onWidget(widget, parentIndex, !!restNode);
        }
        let child, index;
        if (restNode) {
            index = -1;
            child = restNode;
            restNode = null;
        } else if (parentIndex < parent.childCount) {
            index = parentIndex;
            child = parent.child(parentIndex++);
        } else break;
        for(let i = 0; i < active.length; i++)if (active[i].to <= offset) active.splice(i--, 1);
        while(decoIndex < locals.length && locals[decoIndex].from <= offset && locals[decoIndex].to > offset)active.push(locals[decoIndex++]);
        let end = offset + child.nodeSize;
        if (child.isText) {
            let cutAt = end;
            if (decoIndex < locals.length && locals[decoIndex].from < cutAt) cutAt = locals[decoIndex].from;
            for(let i = 0; i < active.length; i++)if (active[i].to < cutAt) cutAt = active[i].to;
            if (cutAt < end) {
                restNode = child.cut(cutAt - offset);
                child = child.cut(0, cutAt - offset);
                end = cutAt;
                index = -1;
            }
        } else while(decoIndex < locals.length && locals[decoIndex].to < end)decoIndex++;
        let outerDeco = child.isInline && !child.isLeaf ? active.filter((d)=>!d.inline) : active.slice();
        onNode(child, outerDeco, deco.forChild(offset, child), index);
        offset = end;
    }
}
// List markers in Mobile Safari will mysteriously disappear
// sometimes. This works around that.
function $81901ae0222f0506$var$iosHacks(dom) {
    if (dom.nodeName == "UL" || dom.nodeName == "OL") {
        let oldCSS = dom.style.cssText;
        dom.style.cssText = oldCSS + "; list-style: square !important";
        window.getComputedStyle(dom).listStyle;
        dom.style.cssText = oldCSS;
    }
}
// Find a piece of text in an inline fragment, overlapping from-to
function $81901ae0222f0506$var$findTextInFragment(frag, text, from, to) {
    for(let i = 0, pos = 0; i < frag.childCount && pos <= to;){
        let child = frag.child(i++), childStart = pos;
        pos += child.nodeSize;
        if (!child.isText) continue;
        let str = child.text;
        while(i < frag.childCount){
            let next = frag.child(i++);
            pos += next.nodeSize;
            if (!next.isText) break;
            str += next.text;
        }
        if (pos >= from) {
            if (pos >= to && str.slice(to - text.length - childStart, to - childStart) == text) return to - text.length;
            let found = childStart < to ? str.lastIndexOf(text, to - childStart - 1) : -1;
            if (found >= 0 && found + text.length + childStart >= from) return childStart + found;
            if (from == to && str.length >= to + text.length - childStart && str.slice(to - childStart, to - childStart + text.length) == text) return to;
        }
    }
    return -1;
}
// Replace range from-to in an array of view descs with replacement
// (may be null to just delete). This goes very much against the grain
// of the rest of this code, which tends to create nodes with the
// right shape in one go, rather than messing with them after
// creation, but is necessary in the composition hack.
function $81901ae0222f0506$var$replaceNodes(nodes, from, to, view, replacement) {
    let result = [];
    for(let i = 0, off = 0; i < nodes.length; i++){
        let child = nodes[i], start = off, end = off += child.size;
        if (start >= to || end <= from) result.push(child);
        else {
            if (start < from) result.push(child.slice(0, from - start, view));
            if (replacement) {
                result.push(replacement);
                replacement = undefined;
            }
            if (end > to) result.push(child.slice(to - start, child.size, view));
        }
    }
    return result;
}
function $81901ae0222f0506$var$selectionFromDOM(view, origin = null) {
    let domSel = view.domSelectionRange(), doc = view.state.doc;
    if (!domSel.focusNode) return null;
    let nearestDesc = view.docView.nearestDesc(domSel.focusNode), inWidget = nearestDesc && nearestDesc.size == 0;
    let head = view.docView.posFromDOM(domSel.focusNode, domSel.focusOffset, 1);
    if (head < 0) return null;
    let $head = doc.resolve(head), anchor, selection;
    if ($81901ae0222f0506$var$selectionCollapsed(domSel)) {
        anchor = head;
        while(nearestDesc && !nearestDesc.node)nearestDesc = nearestDesc.parent;
        let nearestDescNode = nearestDesc.node;
        if (nearestDesc && nearestDescNode.isAtom && (0, $3lIcL.NodeSelection).isSelectable(nearestDescNode) && nearestDesc.parent && !(nearestDescNode.isInline && $81901ae0222f0506$var$isOnEdge(domSel.focusNode, domSel.focusOffset, nearestDesc.dom))) {
            let pos = nearestDesc.posBefore;
            selection = new (0, $3lIcL.NodeSelection)(head == pos ? $head : doc.resolve(pos));
        }
    } else {
        if (domSel instanceof view.dom.ownerDocument.defaultView.Selection && domSel.rangeCount > 1) {
            let min = head, max = head;
            for(let i = 0; i < domSel.rangeCount; i++){
                let range = domSel.getRangeAt(i);
                min = Math.min(min, view.docView.posFromDOM(range.startContainer, range.startOffset, 1));
                max = Math.max(max, view.docView.posFromDOM(range.endContainer, range.endOffset, -1));
            }
            if (min < 0) return null;
            [anchor, head] = max == view.state.selection.anchor ? [
                max,
                min
            ] : [
                min,
                max
            ];
            $head = doc.resolve(head);
        } else anchor = view.docView.posFromDOM(domSel.anchorNode, domSel.anchorOffset, 1);
        if (anchor < 0) return null;
    }
    let $anchor = doc.resolve(anchor);
    if (!selection) {
        let bias = origin == "pointer" || view.state.selection.head < $head.pos && !inWidget ? 1 : -1;
        selection = $81901ae0222f0506$var$selectionBetween(view, $anchor, $head, bias);
    }
    return selection;
}
function $81901ae0222f0506$var$editorOwnsSelection(view) {
    return view.editable ? view.hasFocus() : $81901ae0222f0506$var$hasSelection(view) && document.activeElement && document.activeElement.contains(view.dom);
}
function $81901ae0222f0506$var$selectionToDOM(view, force = false) {
    let sel = view.state.selection;
    $81901ae0222f0506$var$syncNodeSelection(view, sel);
    if (!$81901ae0222f0506$var$editorOwnsSelection(view)) return;
    // The delayed drag selection causes issues with Cell Selections
    // in Safari. And the drag selection delay is to workarond issues
    // which only present in Chrome.
    if (!force && view.input.mouseDown && view.input.mouseDown.allowDefault && $81901ae0222f0506$var$chrome) {
        let domSel = view.domSelectionRange(), curSel = view.domObserver.currentSelection;
        if (domSel.anchorNode && curSel.anchorNode && $81901ae0222f0506$var$isEquivalentPosition(domSel.anchorNode, domSel.anchorOffset, curSel.anchorNode, curSel.anchorOffset)) {
            view.input.mouseDown.delayedSelectionSync = true;
            view.domObserver.setCurSelection();
            return;
        }
    }
    view.domObserver.disconnectSelection();
    if (view.cursorWrapper) $81901ae0222f0506$var$selectCursorWrapper(view);
    else {
        let { anchor: anchor, head: head } = sel, resetEditableFrom, resetEditableTo;
        if ($81901ae0222f0506$var$brokenSelectBetweenUneditable && !(sel instanceof (0, $3lIcL.TextSelection))) {
            if (!sel.$from.parent.inlineContent) resetEditableFrom = $81901ae0222f0506$var$temporarilyEditableNear(view, sel.from);
            if (!sel.empty && !sel.$from.parent.inlineContent) resetEditableTo = $81901ae0222f0506$var$temporarilyEditableNear(view, sel.to);
        }
        view.docView.setSelection(anchor, head, view, force);
        if ($81901ae0222f0506$var$brokenSelectBetweenUneditable) {
            if (resetEditableFrom) $81901ae0222f0506$var$resetEditable(resetEditableFrom);
            if (resetEditableTo) $81901ae0222f0506$var$resetEditable(resetEditableTo);
        }
        if (sel.visible) view.dom.classList.remove("ProseMirror-hideselection");
        else {
            view.dom.classList.add("ProseMirror-hideselection");
            if ("onselectionchange" in document) $81901ae0222f0506$var$removeClassOnSelectionChange(view);
        }
    }
    view.domObserver.setCurSelection();
    view.domObserver.connectSelection();
}
// Kludge to work around Webkit not allowing a selection to start/end
// between non-editable block nodes. We briefly make something
// editable, set the selection, then set it uneditable again.
const $81901ae0222f0506$var$brokenSelectBetweenUneditable = $81901ae0222f0506$var$safari || $81901ae0222f0506$var$chrome && $81901ae0222f0506$var$chrome_version < 63;
function $81901ae0222f0506$var$temporarilyEditableNear(view, pos) {
    let { node: node, offset: offset } = view.docView.domFromPos(pos, 0);
    let after = offset < node.childNodes.length ? node.childNodes[offset] : null;
    let before = offset ? node.childNodes[offset - 1] : null;
    if ($81901ae0222f0506$var$safari && after && after.contentEditable == "false") return $81901ae0222f0506$var$setEditable(after);
    if ((!after || after.contentEditable == "false") && (!before || before.contentEditable == "false")) {
        if (after) return $81901ae0222f0506$var$setEditable(after);
        else if (before) return $81901ae0222f0506$var$setEditable(before);
    }
}
function $81901ae0222f0506$var$setEditable(element) {
    element.contentEditable = "true";
    if ($81901ae0222f0506$var$safari && element.draggable) {
        element.draggable = false;
        element.wasDraggable = true;
    }
    return element;
}
function $81901ae0222f0506$var$resetEditable(element) {
    element.contentEditable = "false";
    if (element.wasDraggable) {
        element.draggable = true;
        element.wasDraggable = null;
    }
}
function $81901ae0222f0506$var$removeClassOnSelectionChange(view) {
    let doc = view.dom.ownerDocument;
    doc.removeEventListener("selectionchange", view.input.hideSelectionGuard);
    let domSel = view.domSelectionRange();
    let node = domSel.anchorNode, offset = domSel.anchorOffset;
    doc.addEventListener("selectionchange", view.input.hideSelectionGuard = ()=>{
        if (domSel.anchorNode != node || domSel.anchorOffset != offset) {
            doc.removeEventListener("selectionchange", view.input.hideSelectionGuard);
            setTimeout(()=>{
                if (!$81901ae0222f0506$var$editorOwnsSelection(view) || view.state.selection.visible) view.dom.classList.remove("ProseMirror-hideselection");
            }, 20);
        }
    });
}
function $81901ae0222f0506$var$selectCursorWrapper(view) {
    let domSel = view.domSelection(), range = document.createRange();
    if (!domSel) return;
    let node = view.cursorWrapper.dom, img = node.nodeName == "IMG";
    if (img) range.setStart(node.parentNode, $81901ae0222f0506$var$domIndex(node) + 1);
    else range.setStart(node, 0);
    range.collapse(true);
    domSel.removeAllRanges();
    domSel.addRange(range);
    // Kludge to kill 'control selection' in IE11 when selecting an
    // invisible cursor wrapper, since that would result in those weird
    // resize handles and a selection that considers the absolutely
    // positioned wrapper, rather than the root editable node, the
    // focused element.
    if (!img && !view.state.selection.visible && $81901ae0222f0506$var$ie && $81901ae0222f0506$var$ie_version <= 11) {
        node.disabled = true;
        node.disabled = false;
    }
}
function $81901ae0222f0506$var$syncNodeSelection(view, sel) {
    if (sel instanceof (0, $3lIcL.NodeSelection)) {
        let desc = view.docView.descAt(sel.from);
        if (desc != view.lastSelectedViewDesc) {
            $81901ae0222f0506$var$clearNodeSelection(view);
            if (desc) desc.selectNode();
            view.lastSelectedViewDesc = desc;
        }
    } else $81901ae0222f0506$var$clearNodeSelection(view);
}
// Clear all DOM statefulness of the last node selection.
function $81901ae0222f0506$var$clearNodeSelection(view) {
    if (view.lastSelectedViewDesc) {
        if (view.lastSelectedViewDesc.parent) view.lastSelectedViewDesc.deselectNode();
        view.lastSelectedViewDesc = undefined;
    }
}
function $81901ae0222f0506$var$selectionBetween(view, $anchor, $head, bias) {
    return view.someProp("createSelectionBetween", (f)=>f(view, $anchor, $head)) || (0, $3lIcL.TextSelection).between($anchor, $head, bias);
}
function $81901ae0222f0506$var$hasFocusAndSelection(view) {
    if (view.editable && !view.hasFocus()) return false;
    return $81901ae0222f0506$var$hasSelection(view);
}
function $81901ae0222f0506$var$hasSelection(view) {
    let sel = view.domSelectionRange();
    if (!sel.anchorNode) return false;
    try {
        // Firefox will raise 'permission denied' errors when accessing
        // properties of `sel.anchorNode` when it's in a generated CSS
        // element.
        return view.dom.contains(sel.anchorNode.nodeType == 3 ? sel.anchorNode.parentNode : sel.anchorNode) && (view.editable || view.dom.contains(sel.focusNode.nodeType == 3 ? sel.focusNode.parentNode : sel.focusNode));
    } catch (_) {
        return false;
    }
}
function $81901ae0222f0506$var$anchorInRightPlace(view) {
    let anchorDOM = view.docView.domFromPos(view.state.selection.anchor, 0);
    let domSel = view.domSelectionRange();
    return $81901ae0222f0506$var$isEquivalentPosition(anchorDOM.node, anchorDOM.offset, domSel.anchorNode, domSel.anchorOffset);
}
function $81901ae0222f0506$var$moveSelectionBlock(state, dir) {
    let { $anchor: $anchor, $head: $head } = state.selection;
    let $side = dir > 0 ? $anchor.max($head) : $anchor.min($head);
    let $start = !$side.parent.inlineContent ? $side : $side.depth ? state.doc.resolve(dir > 0 ? $side.after() : $side.before()) : null;
    return $start && (0, $3lIcL.Selection).findFrom($start, dir);
}
function $81901ae0222f0506$var$apply(view, sel) {
    view.dispatch(view.state.tr.setSelection(sel).scrollIntoView());
    return true;
}
function $81901ae0222f0506$var$selectHorizontally(view, dir, mods) {
    let sel = view.state.selection;
    if (sel instanceof (0, $3lIcL.TextSelection)) {
        if (mods.indexOf("s") > -1) {
            let { $head: $head } = sel, node = $head.textOffset ? null : dir < 0 ? $head.nodeBefore : $head.nodeAfter;
            if (!node || node.isText || !node.isLeaf) return false;
            let $newHead = view.state.doc.resolve($head.pos + node.nodeSize * (dir < 0 ? -1 : 1));
            return $81901ae0222f0506$var$apply(view, new (0, $3lIcL.TextSelection)(sel.$anchor, $newHead));
        } else if (!sel.empty) return false;
        else if (view.endOfTextblock(dir > 0 ? "forward" : "backward")) {
            let next = $81901ae0222f0506$var$moveSelectionBlock(view.state, dir);
            if (next && next instanceof (0, $3lIcL.NodeSelection)) return $81901ae0222f0506$var$apply(view, next);
            return false;
        } else if (!($81901ae0222f0506$var$mac && mods.indexOf("m") > -1)) {
            let $head = sel.$head, node = $head.textOffset ? null : dir < 0 ? $head.nodeBefore : $head.nodeAfter, desc;
            if (!node || node.isText) return false;
            let nodePos = dir < 0 ? $head.pos - node.nodeSize : $head.pos;
            if (!(node.isAtom || (desc = view.docView.descAt(nodePos)) && !desc.contentDOM)) return false;
            if ((0, $3lIcL.NodeSelection).isSelectable(node)) return $81901ae0222f0506$var$apply(view, new (0, $3lIcL.NodeSelection)(dir < 0 ? view.state.doc.resolve($head.pos - node.nodeSize) : $head));
            else if ($81901ae0222f0506$var$webkit) // Chrome and Safari will introduce extra pointless cursor
            // positions around inline uneditable nodes, so we have to
            // take over and move the cursor past them (#937)
            return $81901ae0222f0506$var$apply(view, new (0, $3lIcL.TextSelection)(view.state.doc.resolve(dir < 0 ? nodePos : nodePos + node.nodeSize)));
            else return false;
        }
    } else if (sel instanceof (0, $3lIcL.NodeSelection) && sel.node.isInline) return $81901ae0222f0506$var$apply(view, new (0, $3lIcL.TextSelection)(dir > 0 ? sel.$to : sel.$from));
    else {
        let next = $81901ae0222f0506$var$moveSelectionBlock(view.state, dir);
        if (next) return $81901ae0222f0506$var$apply(view, next);
        return false;
    }
}
function $81901ae0222f0506$var$nodeLen(node) {
    return node.nodeType == 3 ? node.nodeValue.length : node.childNodes.length;
}
function $81901ae0222f0506$var$isIgnorable(dom, dir) {
    let desc = dom.pmViewDesc;
    return desc && desc.size == 0 && (dir < 0 || dom.nextSibling || dom.nodeName != "BR");
}
function $81901ae0222f0506$var$skipIgnoredNodes(view, dir) {
    return dir < 0 ? $81901ae0222f0506$var$skipIgnoredNodesBefore(view) : $81901ae0222f0506$var$skipIgnoredNodesAfter(view);
}
// Make sure the cursor isn't directly after one or more ignored
// nodes, which will confuse the browser's cursor motion logic.
function $81901ae0222f0506$var$skipIgnoredNodesBefore(view) {
    let sel = view.domSelectionRange();
    let node = sel.focusNode, offset = sel.focusOffset;
    if (!node) return;
    let moveNode, moveOffset, force = false;
    // Gecko will do odd things when the selection is directly in front
    // of a non-editable node, so in that case, move it into the next
    // node if possible. Issue prosemirror/prosemirror#832.
    if ($81901ae0222f0506$var$gecko && node.nodeType == 1 && offset < $81901ae0222f0506$var$nodeLen(node) && $81901ae0222f0506$var$isIgnorable(node.childNodes[offset], -1)) force = true;
    for(;;){
        if (offset > 0) {
            if (node.nodeType != 1) break;
            else {
                let before = node.childNodes[offset - 1];
                if ($81901ae0222f0506$var$isIgnorable(before, -1)) {
                    moveNode = node;
                    moveOffset = --offset;
                } else if (before.nodeType == 3) {
                    node = before;
                    offset = node.nodeValue.length;
                } else break;
            }
        } else if ($81901ae0222f0506$var$isBlockNode(node)) break;
        else {
            let prev = node.previousSibling;
            while(prev && $81901ae0222f0506$var$isIgnorable(prev, -1)){
                moveNode = node.parentNode;
                moveOffset = $81901ae0222f0506$var$domIndex(prev);
                prev = prev.previousSibling;
            }
            if (!prev) {
                node = node.parentNode;
                if (node == view.dom) break;
                offset = 0;
            } else {
                node = prev;
                offset = $81901ae0222f0506$var$nodeLen(node);
            }
        }
    }
    if (force) $81901ae0222f0506$var$setSelFocus(view, node, offset);
    else if (moveNode) $81901ae0222f0506$var$setSelFocus(view, moveNode, moveOffset);
}
// Make sure the cursor isn't directly before one or more ignored
// nodes.
function $81901ae0222f0506$var$skipIgnoredNodesAfter(view) {
    let sel = view.domSelectionRange();
    let node = sel.focusNode, offset = sel.focusOffset;
    if (!node) return;
    let len = $81901ae0222f0506$var$nodeLen(node);
    let moveNode, moveOffset;
    for(;;){
        if (offset < len) {
            if (node.nodeType != 1) break;
            let after = node.childNodes[offset];
            if ($81901ae0222f0506$var$isIgnorable(after, 1)) {
                moveNode = node;
                moveOffset = ++offset;
            } else break;
        } else if ($81901ae0222f0506$var$isBlockNode(node)) break;
        else {
            let next = node.nextSibling;
            while(next && $81901ae0222f0506$var$isIgnorable(next, 1)){
                moveNode = next.parentNode;
                moveOffset = $81901ae0222f0506$var$domIndex(next) + 1;
                next = next.nextSibling;
            }
            if (!next) {
                node = node.parentNode;
                if (node == view.dom) break;
                offset = len = 0;
            } else {
                node = next;
                offset = 0;
                len = $81901ae0222f0506$var$nodeLen(node);
            }
        }
    }
    if (moveNode) $81901ae0222f0506$var$setSelFocus(view, moveNode, moveOffset);
}
function $81901ae0222f0506$var$isBlockNode(dom) {
    let desc = dom.pmViewDesc;
    return desc && desc.node && desc.node.isBlock;
}
function $81901ae0222f0506$var$textNodeAfter(node, offset) {
    while(node && offset == node.childNodes.length && !$81901ae0222f0506$var$hasBlockDesc(node)){
        offset = $81901ae0222f0506$var$domIndex(node) + 1;
        node = node.parentNode;
    }
    while(node && offset < node.childNodes.length){
        let next = node.childNodes[offset];
        if (next.nodeType == 3) return next;
        if (next.nodeType == 1 && next.contentEditable == "false") break;
        node = next;
        offset = 0;
    }
}
function $81901ae0222f0506$var$textNodeBefore(node, offset) {
    while(node && !offset && !$81901ae0222f0506$var$hasBlockDesc(node)){
        offset = $81901ae0222f0506$var$domIndex(node);
        node = node.parentNode;
    }
    while(node && offset){
        let next = node.childNodes[offset - 1];
        if (next.nodeType == 3) return next;
        if (next.nodeType == 1 && next.contentEditable == "false") break;
        node = next;
        offset = node.childNodes.length;
    }
}
function $81901ae0222f0506$var$setSelFocus(view, node, offset) {
    if (node.nodeType != 3) {
        let before, after;
        if (after = $81901ae0222f0506$var$textNodeAfter(node, offset)) {
            node = after;
            offset = 0;
        } else if (before = $81901ae0222f0506$var$textNodeBefore(node, offset)) {
            node = before;
            offset = before.nodeValue.length;
        }
    }
    let sel = view.domSelection();
    if (!sel) return;
    if ($81901ae0222f0506$var$selectionCollapsed(sel)) {
        let range = document.createRange();
        range.setEnd(node, offset);
        range.setStart(node, offset);
        sel.removeAllRanges();
        sel.addRange(range);
    } else if (sel.extend) sel.extend(node, offset);
    view.domObserver.setCurSelection();
    let { state: state } = view;
    // If no state update ends up happening, reset the selection.
    setTimeout(()=>{
        if (view.state == state) $81901ae0222f0506$var$selectionToDOM(view);
    }, 50);
}
function $81901ae0222f0506$var$findDirection(view, pos) {
    let $pos = view.state.doc.resolve(pos);
    if (!($81901ae0222f0506$var$chrome || $81901ae0222f0506$var$windows) && $pos.parent.inlineContent) {
        let coords = view.coordsAtPos(pos);
        if (pos > $pos.start()) {
            let before = view.coordsAtPos(pos - 1);
            let mid = (before.top + before.bottom) / 2;
            if (mid > coords.top && mid < coords.bottom && Math.abs(before.left - coords.left) > 1) return before.left < coords.left ? "ltr" : "rtl";
        }
        if (pos < $pos.end()) {
            let after = view.coordsAtPos(pos + 1);
            let mid = (after.top + after.bottom) / 2;
            if (mid > coords.top && mid < coords.bottom && Math.abs(after.left - coords.left) > 1) return after.left > coords.left ? "ltr" : "rtl";
        }
    }
    let computed = getComputedStyle(view.dom).direction;
    return computed == "rtl" ? "rtl" : "ltr";
}
// Check whether vertical selection motion would involve node
// selections. If so, apply it (if not, the result is left to the
// browser)
function $81901ae0222f0506$var$selectVertically(view, dir, mods) {
    let sel = view.state.selection;
    if (sel instanceof (0, $3lIcL.TextSelection) && !sel.empty || mods.indexOf("s") > -1) return false;
    if ($81901ae0222f0506$var$mac && mods.indexOf("m") > -1) return false;
    let { $from: $from, $to: $to } = sel;
    if (!$from.parent.inlineContent || view.endOfTextblock(dir < 0 ? "up" : "down")) {
        let next = $81901ae0222f0506$var$moveSelectionBlock(view.state, dir);
        if (next && next instanceof (0, $3lIcL.NodeSelection)) return $81901ae0222f0506$var$apply(view, next);
    }
    if (!$from.parent.inlineContent) {
        let side = dir < 0 ? $from : $to;
        let beyond = sel instanceof (0, $3lIcL.AllSelection) ? (0, $3lIcL.Selection).near(side, dir) : (0, $3lIcL.Selection).findFrom(side, dir);
        return beyond ? $81901ae0222f0506$var$apply(view, beyond) : false;
    }
    return false;
}
function $81901ae0222f0506$var$stopNativeHorizontalDelete(view, dir) {
    if (!(view.state.selection instanceof (0, $3lIcL.TextSelection))) return true;
    let { $head: $head, $anchor: $anchor, empty: empty } = view.state.selection;
    if (!$head.sameParent($anchor)) return true;
    if (!empty) return false;
    if (view.endOfTextblock(dir > 0 ? "forward" : "backward")) return true;
    let nextNode = !$head.textOffset && (dir < 0 ? $head.nodeBefore : $head.nodeAfter);
    if (nextNode && !nextNode.isText) {
        let tr = view.state.tr;
        if (dir < 0) tr.delete($head.pos - nextNode.nodeSize, $head.pos);
        else tr.delete($head.pos, $head.pos + nextNode.nodeSize);
        view.dispatch(tr);
        return true;
    }
    return false;
}
function $81901ae0222f0506$var$switchEditable(view, node, state) {
    view.domObserver.stop();
    node.contentEditable = state;
    view.domObserver.start();
}
// Issue #867 / #1090 / https://bugs.chromium.org/p/chromium/issues/detail?id=903821
// In which Safari (and at some point in the past, Chrome) does really
// wrong things when the down arrow is pressed when the cursor is
// directly at the start of a textblock and has an uneditable node
// after it
function $81901ae0222f0506$var$safariDownArrowBug(view) {
    if (!$81901ae0222f0506$var$safari || view.state.selection.$head.parentOffset > 0) return false;
    let { focusNode: focusNode, focusOffset: focusOffset } = view.domSelectionRange();
    if (focusNode && focusNode.nodeType == 1 && focusOffset == 0 && focusNode.firstChild && focusNode.firstChild.contentEditable == "false") {
        let child = focusNode.firstChild;
        $81901ae0222f0506$var$switchEditable(view, child, "true");
        setTimeout(()=>$81901ae0222f0506$var$switchEditable(view, child, "false"), 20);
    }
    return false;
}
// A backdrop key mapping used to make sure we always suppress keys
// that have a dangerous default effect, even if the commands they are
// bound to return false, and to make sure that cursor-motion keys
// find a cursor (as opposed to a node selection) when pressed. For
// cursor-motion keys, the code in the handlers also takes care of
// block selections.
function $81901ae0222f0506$var$getMods(event) {
    let result = "";
    if (event.ctrlKey) result += "c";
    if (event.metaKey) result += "m";
    if (event.altKey) result += "a";
    if (event.shiftKey) result += "s";
    return result;
}
function $81901ae0222f0506$var$captureKeyDown(view, event) {
    let code = event.keyCode, mods = $81901ae0222f0506$var$getMods(event);
    if (code == 8 || $81901ae0222f0506$var$mac && code == 72 && mods == "c") return $81901ae0222f0506$var$stopNativeHorizontalDelete(view, -1) || $81901ae0222f0506$var$skipIgnoredNodes(view, -1);
    else if (code == 46 && !event.shiftKey || $81901ae0222f0506$var$mac && code == 68 && mods == "c") return $81901ae0222f0506$var$stopNativeHorizontalDelete(view, 1) || $81901ae0222f0506$var$skipIgnoredNodes(view, 1);
    else if (code == 13 || code == 27) return true;
    else if (code == 37 || $81901ae0222f0506$var$mac && code == 66 && mods == "c") {
        let dir = code == 37 ? $81901ae0222f0506$var$findDirection(view, view.state.selection.from) == "ltr" ? -1 : 1 : -1;
        return $81901ae0222f0506$var$selectHorizontally(view, dir, mods) || $81901ae0222f0506$var$skipIgnoredNodes(view, dir);
    } else if (code == 39 || $81901ae0222f0506$var$mac && code == 70 && mods == "c") {
        let dir = code == 39 ? $81901ae0222f0506$var$findDirection(view, view.state.selection.from) == "ltr" ? 1 : -1 : 1;
        return $81901ae0222f0506$var$selectHorizontally(view, dir, mods) || $81901ae0222f0506$var$skipIgnoredNodes(view, dir);
    } else if (code == 38 || $81901ae0222f0506$var$mac && code == 80 && mods == "c") return $81901ae0222f0506$var$selectVertically(view, -1, mods) || $81901ae0222f0506$var$skipIgnoredNodes(view, -1);
    else if (code == 40 || $81901ae0222f0506$var$mac && code == 78 && mods == "c") return $81901ae0222f0506$var$safariDownArrowBug(view) || $81901ae0222f0506$var$selectVertically(view, 1, mods) || $81901ae0222f0506$var$skipIgnoredNodes(view, 1);
    else if (mods == ($81901ae0222f0506$var$mac ? "m" : "c") && (code == 66 || code == 73 || code == 89 || code == 90)) return true;
    return false;
}
function $81901ae0222f0506$var$serializeForClipboard(view, slice) {
    view.someProp("transformCopied", (f)=>{
        slice = f(slice, view);
    });
    let context = [], { content: content, openStart: openStart, openEnd: openEnd } = slice;
    while(openStart > 1 && openEnd > 1 && content.childCount == 1 && content.firstChild.childCount == 1){
        openStart--;
        openEnd--;
        let node = content.firstChild;
        context.push(node.type.name, node.attrs != node.type.defaultAttrs ? node.attrs : null);
        content = node.content;
    }
    let serializer = view.someProp("clipboardSerializer") || (0, $3xw6l.DOMSerializer).fromSchema(view.state.schema);
    let doc = $81901ae0222f0506$var$detachedDoc(), wrap = doc.createElement("div");
    wrap.appendChild(serializer.serializeFragment(content, {
        document: doc
    }));
    let firstChild = wrap.firstChild, needsWrap, wrappers = 0;
    while(firstChild && firstChild.nodeType == 1 && (needsWrap = $81901ae0222f0506$var$wrapMap[firstChild.nodeName.toLowerCase()])){
        for(let i = needsWrap.length - 1; i >= 0; i--){
            let wrapper = doc.createElement(needsWrap[i]);
            while(wrap.firstChild)wrapper.appendChild(wrap.firstChild);
            wrap.appendChild(wrapper);
            wrappers++;
        }
        firstChild = wrap.firstChild;
    }
    if (firstChild && firstChild.nodeType == 1) firstChild.setAttribute("data-pm-slice", `${openStart} ${openEnd}${wrappers ? ` -${wrappers}` : ""} ${JSON.stringify(context)}`);
    let text = view.someProp("clipboardTextSerializer", (f)=>f(slice, view)) || slice.content.textBetween(0, slice.content.size, "\n\n");
    return {
        dom: wrap,
        text: text,
        slice: slice
    };
}
// Read a slice of content from the clipboard (or drop data).
function $81901ae0222f0506$var$parseFromClipboard(view, text, html, plainText, $context) {
    let inCode = $context.parent.type.spec.code;
    let dom, slice;
    if (!html && !text) return null;
    let asText = text && (plainText || inCode || !html);
    if (asText) {
        view.someProp("transformPastedText", (f)=>{
            text = f(text, inCode || plainText, view);
        });
        if (inCode) return text ? new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).from(view.state.schema.text(text.replace(/\r\n?/g, "\n"))), 0, 0) : (0, $3xw6l.Slice).empty;
        let parsed = view.someProp("clipboardTextParser", (f)=>f(text, $context, plainText, view));
        if (parsed) slice = parsed;
        else {
            let marks = $context.marks();
            let { schema: schema } = view.state, serializer = (0, $3xw6l.DOMSerializer).fromSchema(schema);
            dom = document.createElement("div");
            text.split(/(?:\r\n?|\n)+/).forEach((block)=>{
                let p = dom.appendChild(document.createElement("p"));
                if (block) p.appendChild(serializer.serializeNode(schema.text(block, marks)));
            });
        }
    } else {
        view.someProp("transformPastedHTML", (f)=>{
            html = f(html, view);
        });
        dom = $81901ae0222f0506$var$readHTML(html);
        if ($81901ae0222f0506$var$webkit) $81901ae0222f0506$var$restoreReplacedSpaces(dom);
    }
    let contextNode = dom && dom.querySelector("[data-pm-slice]");
    let sliceData = contextNode && /^(\d+) (\d+)(?: -(\d+))? (.*)/.exec(contextNode.getAttribute("data-pm-slice") || "");
    if (sliceData && sliceData[3]) for(let i = +sliceData[3]; i > 0; i--){
        let child = dom.firstChild;
        while(child && child.nodeType != 1)child = child.nextSibling;
        if (!child) break;
        dom = child;
    }
    if (!slice) {
        let parser = view.someProp("clipboardParser") || view.someProp("domParser") || (0, $3xw6l.DOMParser).fromSchema(view.state.schema);
        slice = parser.parseSlice(dom, {
            preserveWhitespace: !!(asText || sliceData),
            context: $context,
            ruleFromNode (dom) {
                if (dom.nodeName == "BR" && !dom.nextSibling && dom.parentNode && !$81901ae0222f0506$var$inlineParents.test(dom.parentNode.nodeName)) return {
                    ignore: true
                };
                return null;
            }
        });
    }
    if (sliceData) slice = $81901ae0222f0506$var$addContext($81901ae0222f0506$var$closeSlice(slice, +sliceData[1], +sliceData[2]), sliceData[4]);
    else {
        slice = (0, $3xw6l.Slice).maxOpen($81901ae0222f0506$var$normalizeSiblings(slice.content, $context), true);
        if (slice.openStart || slice.openEnd) {
            let openStart = 0, openEnd = 0;
            for(let node = slice.content.firstChild; openStart < slice.openStart && !node.type.spec.isolating; openStart++, node = node.firstChild);
            for(let node = slice.content.lastChild; openEnd < slice.openEnd && !node.type.spec.isolating; openEnd++, node = node.lastChild);
            slice = $81901ae0222f0506$var$closeSlice(slice, openStart, openEnd);
        }
    }
    view.someProp("transformPasted", (f)=>{
        slice = f(slice, view);
    });
    return slice;
}
const $81901ae0222f0506$var$inlineParents = /^(a|abbr|acronym|b|cite|code|del|em|i|ins|kbd|label|output|q|ruby|s|samp|span|strong|sub|sup|time|u|tt|var)$/i;
// Takes a slice parsed with parseSlice, which means there hasn't been
// any content-expression checking done on the top nodes, tries to
// find a parent node in the current context that might fit the nodes,
// and if successful, rebuilds the slice so that it fits into that parent.
//
// This addresses the problem that Transform.replace expects a
// coherent slice, and will fail to place a set of siblings that don't
// fit anywhere in the schema.
function $81901ae0222f0506$var$normalizeSiblings(fragment, $context) {
    if (fragment.childCount < 2) return fragment;
    for(let d = $context.depth; d >= 0; d--){
        let parent = $context.node(d);
        let match = parent.contentMatchAt($context.index(d));
        let lastWrap, result = [];
        fragment.forEach((node)=>{
            if (!result) return;
            let wrap = match.findWrapping(node.type), inLast;
            if (!wrap) return result = null;
            if (inLast = result.length && lastWrap.length && $81901ae0222f0506$var$addToSibling(wrap, lastWrap, node, result[result.length - 1], 0)) result[result.length - 1] = inLast;
            else {
                if (result.length) result[result.length - 1] = $81901ae0222f0506$var$closeRight(result[result.length - 1], lastWrap.length);
                let wrapped = $81901ae0222f0506$var$withWrappers(node, wrap);
                result.push(wrapped);
                match = match.matchType(wrapped.type);
                lastWrap = wrap;
            }
        });
        if (result) return (0, $3xw6l.Fragment).from(result);
    }
    return fragment;
}
function $81901ae0222f0506$var$withWrappers(node, wrap, from = 0) {
    for(let i = wrap.length - 1; i >= from; i--)node = wrap[i].create(null, (0, $3xw6l.Fragment).from(node));
    return node;
}
// Used to group adjacent nodes wrapped in similar parents by
// normalizeSiblings into the same parent node
function $81901ae0222f0506$var$addToSibling(wrap, lastWrap, node, sibling, depth) {
    if (depth < wrap.length && depth < lastWrap.length && wrap[depth] == lastWrap[depth]) {
        let inner = $81901ae0222f0506$var$addToSibling(wrap, lastWrap, node, sibling.lastChild, depth + 1);
        if (inner) return sibling.copy(sibling.content.replaceChild(sibling.childCount - 1, inner));
        let match = sibling.contentMatchAt(sibling.childCount);
        if (match.matchType(depth == wrap.length - 1 ? node.type : wrap[depth + 1])) return sibling.copy(sibling.content.append((0, $3xw6l.Fragment).from($81901ae0222f0506$var$withWrappers(node, wrap, depth + 1))));
    }
}
function $81901ae0222f0506$var$closeRight(node, depth) {
    if (depth == 0) return node;
    let fragment = node.content.replaceChild(node.childCount - 1, $81901ae0222f0506$var$closeRight(node.lastChild, depth - 1));
    let fill = node.contentMatchAt(node.childCount).fillBefore((0, $3xw6l.Fragment).empty, true);
    return node.copy(fragment.append(fill));
}
function $81901ae0222f0506$var$closeRange(fragment, side, from, to, depth, openEnd) {
    let node = side < 0 ? fragment.firstChild : fragment.lastChild, inner = node.content;
    if (fragment.childCount > 1) openEnd = 0;
    if (depth < to - 1) inner = $81901ae0222f0506$var$closeRange(inner, side, from, to, depth + 1, openEnd);
    if (depth >= from) inner = side < 0 ? node.contentMatchAt(0).fillBefore(inner, openEnd <= depth).append(inner) : inner.append(node.contentMatchAt(node.childCount).fillBefore((0, $3xw6l.Fragment).empty, true));
    return fragment.replaceChild(side < 0 ? 0 : fragment.childCount - 1, node.copy(inner));
}
function $81901ae0222f0506$var$closeSlice(slice, openStart, openEnd) {
    if (openStart < slice.openStart) slice = new (0, $3xw6l.Slice)($81901ae0222f0506$var$closeRange(slice.content, -1, openStart, slice.openStart, 0, slice.openEnd), openStart, slice.openEnd);
    if (openEnd < slice.openEnd) slice = new (0, $3xw6l.Slice)($81901ae0222f0506$var$closeRange(slice.content, 1, openEnd, slice.openEnd, 0, 0), slice.openStart, openEnd);
    return slice;
}
// Trick from jQuery -- some elements must be wrapped in other
// elements for innerHTML to work. I.e. if you do `div.innerHTML =
// "<td>..</td>"` the table cells are ignored.
const $81901ae0222f0506$var$wrapMap = {
    thead: [
        "table"
    ],
    tbody: [
        "table"
    ],
    tfoot: [
        "table"
    ],
    caption: [
        "table"
    ],
    colgroup: [
        "table"
    ],
    col: [
        "table",
        "colgroup"
    ],
    tr: [
        "table",
        "tbody"
    ],
    td: [
        "table",
        "tbody",
        "tr"
    ],
    th: [
        "table",
        "tbody",
        "tr"
    ]
};
let $81901ae0222f0506$var$_detachedDoc = null;
function $81901ae0222f0506$var$detachedDoc() {
    return $81901ae0222f0506$var$_detachedDoc || ($81901ae0222f0506$var$_detachedDoc = document.implementation.createHTMLDocument("title"));
}
let $81901ae0222f0506$var$_policy = null;
function $81901ae0222f0506$var$maybeWrapTrusted(html) {
    let trustedTypes = window.trustedTypes;
    if (!trustedTypes) return html;
    // With the require-trusted-types-for CSP, Chrome will block
    // innerHTML, even on a detached document. This wraps the string in
    // a way that makes the browser allow us to use its parser again.
    if (!$81901ae0222f0506$var$_policy) $81901ae0222f0506$var$_policy = trustedTypes.createPolicy("ProseMirrorClipboard", {
        createHTML: (s)=>s
    });
    return $81901ae0222f0506$var$_policy.createHTML(html);
}
function $81901ae0222f0506$var$readHTML(html) {
    let metas = /^(\s*<meta [^>]*>)*/.exec(html);
    if (metas) html = html.slice(metas[0].length);
    let elt = $81901ae0222f0506$var$detachedDoc().createElement("div");
    let firstTag = /<([a-z][^>\s]+)/i.exec(html), wrap;
    if (wrap = firstTag && $81901ae0222f0506$var$wrapMap[firstTag[1].toLowerCase()]) html = wrap.map((n)=>"<" + n + ">").join("") + html + wrap.map((n)=>"</" + n + ">").reverse().join("");
    elt.innerHTML = $81901ae0222f0506$var$maybeWrapTrusted(html);
    if (wrap) for(let i = 0; i < wrap.length; i++)elt = elt.querySelector(wrap[i]) || elt;
    return elt;
}
// Webkit browsers do some hard-to-predict replacement of regular
// spaces with non-breaking spaces when putting content on the
// clipboard. This tries to convert such non-breaking spaces (which
// will be wrapped in a plain span on Chrome, a span with class
// Apple-converted-space on Safari) back to regular spaces.
function $81901ae0222f0506$var$restoreReplacedSpaces(dom) {
    let nodes = dom.querySelectorAll($81901ae0222f0506$var$chrome ? "span:not([class]):not([style])" : "span.Apple-converted-space");
    for(let i = 0; i < nodes.length; i++){
        let node = nodes[i];
        if (node.childNodes.length == 1 && node.textContent == "\u00a0" && node.parentNode) node.parentNode.replaceChild(dom.ownerDocument.createTextNode(" "), node);
    }
}
function $81901ae0222f0506$var$addContext(slice, context) {
    if (!slice.size) return slice;
    let schema = slice.content.firstChild.type.schema, array;
    try {
        array = JSON.parse(context);
    } catch (e) {
        return slice;
    }
    let { content: content, openStart: openStart, openEnd: openEnd } = slice;
    for(let i = array.length - 2; i >= 0; i -= 2){
        let type = schema.nodes[array[i]];
        if (!type || type.hasRequiredAttrs()) break;
        content = (0, $3xw6l.Fragment).from(type.create(array[i + 1], content));
        openStart++;
        openEnd++;
    }
    return new (0, $3xw6l.Slice)(content, openStart, openEnd);
}
// A collection of DOM events that occur within the editor, and callback functions
// to invoke when the event fires.
const $81901ae0222f0506$var$handlers = {};
const $81901ae0222f0506$var$editHandlers = {};
const $81901ae0222f0506$var$passiveHandlers = {
    touchstart: true,
    touchmove: true
};
class $81901ae0222f0506$var$InputState {
    constructor(){
        this.shiftKey = false;
        this.mouseDown = null;
        this.lastKeyCode = null;
        this.lastKeyCodeTime = 0;
        this.lastClick = {
            time: 0,
            x: 0,
            y: 0,
            type: ""
        };
        this.lastSelectionOrigin = null;
        this.lastSelectionTime = 0;
        this.lastIOSEnter = 0;
        this.lastIOSEnterFallbackTimeout = -1;
        this.lastFocus = 0;
        this.lastTouch = 0;
        this.lastChromeDelete = 0;
        this.composing = false;
        this.compositionNode = null;
        this.composingTimeout = -1;
        this.compositionNodes = [];
        this.compositionEndedAt = -200000000;
        this.compositionID = 1;
        // Set to a composition ID when there are pending changes at compositionend
        this.compositionPendingChanges = 0;
        this.domChangeCount = 0;
        this.eventHandlers = Object.create(null);
        this.hideSelectionGuard = null;
    }
}
function $81901ae0222f0506$var$initInput(view) {
    for(let event in $81901ae0222f0506$var$handlers){
        let handler = $81901ae0222f0506$var$handlers[event];
        view.dom.addEventListener(event, view.input.eventHandlers[event] = (event)=>{
            if ($81901ae0222f0506$var$eventBelongsToView(view, event) && !$81901ae0222f0506$var$runCustomHandler(view, event) && (view.editable || !(event.type in $81901ae0222f0506$var$editHandlers))) handler(view, event);
        }, $81901ae0222f0506$var$passiveHandlers[event] ? {
            passive: true
        } : undefined);
    }
    // On Safari, for reasons beyond my understanding, adding an input
    // event handler makes an issue where the composition vanishes when
    // you press enter go away.
    if ($81901ae0222f0506$var$safari) view.dom.addEventListener("input", ()=>null);
    $81901ae0222f0506$var$ensureListeners(view);
}
function $81901ae0222f0506$var$setSelectionOrigin(view, origin) {
    view.input.lastSelectionOrigin = origin;
    view.input.lastSelectionTime = Date.now();
}
function $81901ae0222f0506$var$destroyInput(view) {
    view.domObserver.stop();
    for(let type in view.input.eventHandlers)view.dom.removeEventListener(type, view.input.eventHandlers[type]);
    clearTimeout(view.input.composingTimeout);
    clearTimeout(view.input.lastIOSEnterFallbackTimeout);
}
function $81901ae0222f0506$var$ensureListeners(view) {
    view.someProp("handleDOMEvents", (currentHandlers)=>{
        for(let type in currentHandlers)if (!view.input.eventHandlers[type]) view.dom.addEventListener(type, view.input.eventHandlers[type] = (event)=>$81901ae0222f0506$var$runCustomHandler(view, event));
    });
}
function $81901ae0222f0506$var$runCustomHandler(view, event) {
    return view.someProp("handleDOMEvents", (handlers)=>{
        let handler = handlers[event.type];
        return handler ? handler(view, event) || event.defaultPrevented : false;
    });
}
function $81901ae0222f0506$var$eventBelongsToView(view, event) {
    if (!event.bubbles) return true;
    if (event.defaultPrevented) return false;
    for(let node = event.target; node != view.dom; node = node.parentNode)if (!node || node.nodeType == 11 || node.pmViewDesc && node.pmViewDesc.stopEvent(event)) return false;
    return true;
}
function $81901ae0222f0506$var$dispatchEvent(view, event) {
    if (!$81901ae0222f0506$var$runCustomHandler(view, event) && $81901ae0222f0506$var$handlers[event.type] && (view.editable || !(event.type in $81901ae0222f0506$var$editHandlers))) $81901ae0222f0506$var$handlers[event.type](view, event);
}
$81901ae0222f0506$var$editHandlers.keydown = (view, _event)=>{
    let event = _event;
    view.input.shiftKey = event.keyCode == 16 || event.shiftKey;
    if ($81901ae0222f0506$var$inOrNearComposition(view, event)) return;
    view.input.lastKeyCode = event.keyCode;
    view.input.lastKeyCodeTime = Date.now();
    // Suppress enter key events on Chrome Android, because those tend
    // to be part of a confused sequence of composition events fired,
    // and handling them eagerly tends to corrupt the input.
    if ($81901ae0222f0506$var$android && $81901ae0222f0506$var$chrome && event.keyCode == 13) return;
    if (event.keyCode != 229) view.domObserver.forceFlush();
    // On iOS, if we preventDefault enter key presses, the virtual
    // keyboard gets confused. So the hack here is to set a flag that
    // makes the DOM change code recognize that what just happens should
    // be replaced by whatever the Enter key handlers do.
    if ($81901ae0222f0506$var$ios && event.keyCode == 13 && !event.ctrlKey && !event.altKey && !event.metaKey) {
        let now = Date.now();
        view.input.lastIOSEnter = now;
        view.input.lastIOSEnterFallbackTimeout = setTimeout(()=>{
            if (view.input.lastIOSEnter == now) {
                view.someProp("handleKeyDown", (f)=>f(view, $81901ae0222f0506$var$keyEvent(13, "Enter")));
                view.input.lastIOSEnter = 0;
            }
        }, 200);
    } else if (view.someProp("handleKeyDown", (f)=>f(view, event)) || $81901ae0222f0506$var$captureKeyDown(view, event)) event.preventDefault();
    else $81901ae0222f0506$var$setSelectionOrigin(view, "key");
};
$81901ae0222f0506$var$editHandlers.keyup = (view, event)=>{
    if (event.keyCode == 16) view.input.shiftKey = false;
};
$81901ae0222f0506$var$editHandlers.keypress = (view, _event)=>{
    let event = _event;
    if ($81901ae0222f0506$var$inOrNearComposition(view, event) || !event.charCode || event.ctrlKey && !event.altKey || $81901ae0222f0506$var$mac && event.metaKey) return;
    if (view.someProp("handleKeyPress", (f)=>f(view, event))) {
        event.preventDefault();
        return;
    }
    let sel = view.state.selection;
    if (!(sel instanceof (0, $3lIcL.TextSelection)) || !sel.$from.sameParent(sel.$to)) {
        let text = String.fromCharCode(event.charCode);
        if (!/[\r\n]/.test(text) && !view.someProp("handleTextInput", (f)=>f(view, sel.$from.pos, sel.$to.pos, text))) view.dispatch(view.state.tr.insertText(text).scrollIntoView());
        event.preventDefault();
    }
};
function $81901ae0222f0506$var$eventCoords(event) {
    return {
        left: event.clientX,
        top: event.clientY
    };
}
function $81901ae0222f0506$var$isNear(event, click) {
    let dx = click.x - event.clientX, dy = click.y - event.clientY;
    return dx * dx + dy * dy < 100;
}
function $81901ae0222f0506$var$runHandlerOnContext(view, propName, pos, inside, event) {
    if (inside == -1) return false;
    let $pos = view.state.doc.resolve(inside);
    for(let i = $pos.depth + 1; i > 0; i--){
        if (view.someProp(propName, (f)=>i > $pos.depth ? f(view, pos, $pos.nodeAfter, $pos.before(i), event, true) : f(view, pos, $pos.node(i), $pos.before(i), event, false))) return true;
    }
    return false;
}
function $81901ae0222f0506$var$updateSelection(view, selection, origin) {
    if (!view.focused) view.focus();
    if (view.state.selection.eq(selection)) return;
    let tr = view.state.tr.setSelection(selection);
    if (origin == "pointer") tr.setMeta("pointer", true);
    view.dispatch(tr);
}
function $81901ae0222f0506$var$selectClickedLeaf(view, inside) {
    if (inside == -1) return false;
    let $pos = view.state.doc.resolve(inside), node = $pos.nodeAfter;
    if (node && node.isAtom && (0, $3lIcL.NodeSelection).isSelectable(node)) {
        $81901ae0222f0506$var$updateSelection(view, new (0, $3lIcL.NodeSelection)($pos), "pointer");
        return true;
    }
    return false;
}
function $81901ae0222f0506$var$selectClickedNode(view, inside) {
    if (inside == -1) return false;
    let sel = view.state.selection, selectedNode, selectAt;
    if (sel instanceof (0, $3lIcL.NodeSelection)) selectedNode = sel.node;
    let $pos = view.state.doc.resolve(inside);
    for(let i = $pos.depth + 1; i > 0; i--){
        let node = i > $pos.depth ? $pos.nodeAfter : $pos.node(i);
        if ((0, $3lIcL.NodeSelection).isSelectable(node)) {
            if (selectedNode && sel.$from.depth > 0 && i >= sel.$from.depth && $pos.before(sel.$from.depth + 1) == sel.$from.pos) selectAt = $pos.before(sel.$from.depth);
            else selectAt = $pos.before(i);
            break;
        }
    }
    if (selectAt != null) {
        $81901ae0222f0506$var$updateSelection(view, (0, $3lIcL.NodeSelection).create(view.state.doc, selectAt), "pointer");
        return true;
    } else return false;
}
function $81901ae0222f0506$var$handleSingleClick(view, pos, inside, event, selectNode) {
    return $81901ae0222f0506$var$runHandlerOnContext(view, "handleClickOn", pos, inside, event) || view.someProp("handleClick", (f)=>f(view, pos, event)) || (selectNode ? $81901ae0222f0506$var$selectClickedNode(view, inside) : $81901ae0222f0506$var$selectClickedLeaf(view, inside));
}
function $81901ae0222f0506$var$handleDoubleClick(view, pos, inside, event) {
    return $81901ae0222f0506$var$runHandlerOnContext(view, "handleDoubleClickOn", pos, inside, event) || view.someProp("handleDoubleClick", (f)=>f(view, pos, event));
}
function $81901ae0222f0506$var$handleTripleClick(view, pos, inside, event) {
    return $81901ae0222f0506$var$runHandlerOnContext(view, "handleTripleClickOn", pos, inside, event) || view.someProp("handleTripleClick", (f)=>f(view, pos, event)) || $81901ae0222f0506$var$defaultTripleClick(view, inside, event);
}
function $81901ae0222f0506$var$defaultTripleClick(view, inside, event) {
    if (event.button != 0) return false;
    let doc = view.state.doc;
    if (inside == -1) {
        if (doc.inlineContent) {
            $81901ae0222f0506$var$updateSelection(view, (0, $3lIcL.TextSelection).create(doc, 0, doc.content.size), "pointer");
            return true;
        }
        return false;
    }
    let $pos = doc.resolve(inside);
    for(let i = $pos.depth + 1; i > 0; i--){
        let node = i > $pos.depth ? $pos.nodeAfter : $pos.node(i);
        let nodePos = $pos.before(i);
        if (node.inlineContent) $81901ae0222f0506$var$updateSelection(view, (0, $3lIcL.TextSelection).create(doc, nodePos + 1, nodePos + 1 + node.content.size), "pointer");
        else if ((0, $3lIcL.NodeSelection).isSelectable(node)) $81901ae0222f0506$var$updateSelection(view, (0, $3lIcL.NodeSelection).create(doc, nodePos), "pointer");
        else continue;
        return true;
    }
}
function $81901ae0222f0506$var$forceDOMFlush(view) {
    return $81901ae0222f0506$var$endComposition(view);
}
const $81901ae0222f0506$var$selectNodeModifier = $81901ae0222f0506$var$mac ? "metaKey" : "ctrlKey";
$81901ae0222f0506$var$handlers.mousedown = (view, _event)=>{
    let event = _event;
    view.input.shiftKey = event.shiftKey;
    let flushed = $81901ae0222f0506$var$forceDOMFlush(view);
    let now = Date.now(), type = "singleClick";
    if (now - view.input.lastClick.time < 500 && $81901ae0222f0506$var$isNear(event, view.input.lastClick) && !event[$81901ae0222f0506$var$selectNodeModifier]) {
        if (view.input.lastClick.type == "singleClick") type = "doubleClick";
        else if (view.input.lastClick.type == "doubleClick") type = "tripleClick";
    }
    view.input.lastClick = {
        time: now,
        x: event.clientX,
        y: event.clientY,
        type: type
    };
    let pos = view.posAtCoords($81901ae0222f0506$var$eventCoords(event));
    if (!pos) return;
    if (type == "singleClick") {
        if (view.input.mouseDown) view.input.mouseDown.done();
        view.input.mouseDown = new $81901ae0222f0506$var$MouseDown(view, pos, event, !!flushed);
    } else if ((type == "doubleClick" ? $81901ae0222f0506$var$handleDoubleClick : $81901ae0222f0506$var$handleTripleClick)(view, pos.pos, pos.inside, event)) event.preventDefault();
    else $81901ae0222f0506$var$setSelectionOrigin(view, "pointer");
};
class $81901ae0222f0506$var$MouseDown {
    constructor(view, pos, event, flushed){
        this.view = view;
        this.pos = pos;
        this.event = event;
        this.flushed = flushed;
        this.delayedSelectionSync = false;
        this.mightDrag = null;
        this.startDoc = view.state.doc;
        this.selectNode = !!event[$81901ae0222f0506$var$selectNodeModifier];
        this.allowDefault = event.shiftKey;
        let targetNode, targetPos;
        if (pos.inside > -1) {
            targetNode = view.state.doc.nodeAt(pos.inside);
            targetPos = pos.inside;
        } else {
            let $pos = view.state.doc.resolve(pos.pos);
            targetNode = $pos.parent;
            targetPos = $pos.depth ? $pos.before() : 0;
        }
        const target = flushed ? null : event.target;
        const targetDesc = target ? view.docView.nearestDesc(target, true) : null;
        this.target = targetDesc && targetDesc.dom.nodeType == 1 ? targetDesc.dom : null;
        let { selection: selection } = view.state;
        if (event.button == 0 && targetNode.type.spec.draggable && targetNode.type.spec.selectable !== false || selection instanceof (0, $3lIcL.NodeSelection) && selection.from <= targetPos && selection.to > targetPos) this.mightDrag = {
            node: targetNode,
            pos: targetPos,
            addAttr: !!(this.target && !this.target.draggable),
            setUneditable: !!(this.target && $81901ae0222f0506$var$gecko && !this.target.hasAttribute("contentEditable"))
        };
        if (this.target && this.mightDrag && (this.mightDrag.addAttr || this.mightDrag.setUneditable)) {
            this.view.domObserver.stop();
            if (this.mightDrag.addAttr) this.target.draggable = true;
            if (this.mightDrag.setUneditable) setTimeout(()=>{
                if (this.view.input.mouseDown == this) this.target.setAttribute("contentEditable", "false");
            }, 20);
            this.view.domObserver.start();
        }
        view.root.addEventListener("mouseup", this.up = this.up.bind(this));
        view.root.addEventListener("mousemove", this.move = this.move.bind(this));
        $81901ae0222f0506$var$setSelectionOrigin(view, "pointer");
    }
    done() {
        this.view.root.removeEventListener("mouseup", this.up);
        this.view.root.removeEventListener("mousemove", this.move);
        if (this.mightDrag && this.target) {
            this.view.domObserver.stop();
            if (this.mightDrag.addAttr) this.target.removeAttribute("draggable");
            if (this.mightDrag.setUneditable) this.target.removeAttribute("contentEditable");
            this.view.domObserver.start();
        }
        if (this.delayedSelectionSync) setTimeout(()=>$81901ae0222f0506$var$selectionToDOM(this.view));
        this.view.input.mouseDown = null;
    }
    up(event) {
        this.done();
        if (!this.view.dom.contains(event.target)) return;
        let pos = this.pos;
        if (this.view.state.doc != this.startDoc) pos = this.view.posAtCoords($81901ae0222f0506$var$eventCoords(event));
        this.updateAllowDefault(event);
        if (this.allowDefault || !pos) $81901ae0222f0506$var$setSelectionOrigin(this.view, "pointer");
        else if ($81901ae0222f0506$var$handleSingleClick(this.view, pos.pos, pos.inside, event, this.selectNode)) event.preventDefault();
        else if (event.button == 0 && (this.flushed || // Safari ignores clicks on draggable elements
        $81901ae0222f0506$var$safari && this.mightDrag && !this.mightDrag.node.isAtom || // Chrome will sometimes treat a node selection as a
        // cursor, but still report that the node is selected
        // when asked through getSelection. You'll then get a
        // situation where clicking at the point where that
        // (hidden) cursor is doesn't change the selection, and
        // thus doesn't get a reaction from ProseMirror. This
        // works around that.
        $81901ae0222f0506$var$chrome && !this.view.state.selection.visible && Math.min(Math.abs(pos.pos - this.view.state.selection.from), Math.abs(pos.pos - this.view.state.selection.to)) <= 2)) {
            $81901ae0222f0506$var$updateSelection(this.view, (0, $3lIcL.Selection).near(this.view.state.doc.resolve(pos.pos)), "pointer");
            event.preventDefault();
        } else $81901ae0222f0506$var$setSelectionOrigin(this.view, "pointer");
    }
    move(event) {
        this.updateAllowDefault(event);
        $81901ae0222f0506$var$setSelectionOrigin(this.view, "pointer");
        if (event.buttons == 0) this.done();
    }
    updateAllowDefault(event) {
        if (!this.allowDefault && (Math.abs(this.event.x - event.clientX) > 4 || Math.abs(this.event.y - event.clientY) > 4)) this.allowDefault = true;
    }
}
$81901ae0222f0506$var$handlers.touchstart = (view)=>{
    view.input.lastTouch = Date.now();
    $81901ae0222f0506$var$forceDOMFlush(view);
    $81901ae0222f0506$var$setSelectionOrigin(view, "pointer");
};
$81901ae0222f0506$var$handlers.touchmove = (view)=>{
    view.input.lastTouch = Date.now();
    $81901ae0222f0506$var$setSelectionOrigin(view, "pointer");
};
$81901ae0222f0506$var$handlers.contextmenu = (view)=>$81901ae0222f0506$var$forceDOMFlush(view);
function $81901ae0222f0506$var$inOrNearComposition(view, event) {
    if (view.composing) return true;
    // See https://www.stum.de/2016/06/24/handling-ime-events-in-javascript/.
    // On Japanese input method editors (IMEs), the Enter key is used to confirm character
    // selection. On Safari, when Enter is pressed, compositionend and keydown events are
    // emitted. The keydown event triggers newline insertion, which we don't want.
    // This method returns true if the keydown event should be ignored.
    // We only ignore it once, as pressing Enter a second time *should* insert a newline.
    // Furthermore, the keydown event timestamp must be close to the compositionEndedAt timestamp.
    // This guards against the case where compositionend is triggered without the keyboard
    // (e.g. character confirmation may be done with the mouse), and keydown is triggered
    // afterwards- we wouldn't want to ignore the keydown event in this case.
    if ($81901ae0222f0506$var$safari && Math.abs(event.timeStamp - view.input.compositionEndedAt) < 500) {
        view.input.compositionEndedAt = -200000000;
        return true;
    }
    return false;
}
// Drop active composition after 5 seconds of inactivity on Android
const $81901ae0222f0506$var$timeoutComposition = $81901ae0222f0506$var$android ? 5000 : -1;
$81901ae0222f0506$var$editHandlers.compositionstart = $81901ae0222f0506$var$editHandlers.compositionupdate = (view)=>{
    if (!view.composing) {
        view.domObserver.flush();
        let { state: state } = view, $pos = state.selection.$to;
        if (state.selection instanceof (0, $3lIcL.TextSelection) && (state.storedMarks || !$pos.textOffset && $pos.parentOffset && $pos.nodeBefore.marks.some((m)=>m.type.spec.inclusive === false))) {
            // Need to wrap the cursor in mark nodes different from the ones in the DOM context
            view.markCursor = view.state.storedMarks || $pos.marks();
            $81901ae0222f0506$var$endComposition(view, true);
            view.markCursor = null;
        } else {
            $81901ae0222f0506$var$endComposition(view, !state.selection.empty);
            // In firefox, if the cursor is after but outside a marked node,
            // the inserted text won't inherit the marks. So this moves it
            // inside if necessary.
            if ($81901ae0222f0506$var$gecko && state.selection.empty && $pos.parentOffset && !$pos.textOffset && $pos.nodeBefore.marks.length) {
                let sel = view.domSelectionRange();
                for(let node = sel.focusNode, offset = sel.focusOffset; node && node.nodeType == 1 && offset != 0;){
                    let before = offset < 0 ? node.lastChild : node.childNodes[offset - 1];
                    if (!before) break;
                    if (before.nodeType == 3) {
                        let sel = view.domSelection();
                        if (sel) sel.collapse(before, before.nodeValue.length);
                        break;
                    } else {
                        node = before;
                        offset = -1;
                    }
                }
            }
        }
        view.input.composing = true;
    }
    $81901ae0222f0506$var$scheduleComposeEnd(view, $81901ae0222f0506$var$timeoutComposition);
};
$81901ae0222f0506$var$editHandlers.compositionend = (view, event)=>{
    if (view.composing) {
        view.input.composing = false;
        view.input.compositionEndedAt = event.timeStamp;
        view.input.compositionPendingChanges = view.domObserver.pendingRecords().length ? view.input.compositionID : 0;
        view.input.compositionNode = null;
        if (view.input.compositionPendingChanges) Promise.resolve().then(()=>view.domObserver.flush());
        view.input.compositionID++;
        $81901ae0222f0506$var$scheduleComposeEnd(view, 20);
    }
};
function $81901ae0222f0506$var$scheduleComposeEnd(view, delay) {
    clearTimeout(view.input.composingTimeout);
    if (delay > -1) view.input.composingTimeout = setTimeout(()=>$81901ae0222f0506$var$endComposition(view), delay);
}
function $81901ae0222f0506$var$clearComposition(view) {
    if (view.composing) {
        view.input.composing = false;
        view.input.compositionEndedAt = $81901ae0222f0506$var$timestampFromCustomEvent();
    }
    while(view.input.compositionNodes.length > 0)view.input.compositionNodes.pop().markParentsDirty();
}
function $81901ae0222f0506$var$findCompositionNode(view) {
    let sel = view.domSelectionRange();
    if (!sel.focusNode) return null;
    let textBefore = $81901ae0222f0506$var$textNodeBefore$1(sel.focusNode, sel.focusOffset);
    let textAfter = $81901ae0222f0506$var$textNodeAfter$1(sel.focusNode, sel.focusOffset);
    if (textBefore && textAfter && textBefore != textAfter) {
        let descAfter = textAfter.pmViewDesc, lastChanged = view.domObserver.lastChangedTextNode;
        if (textBefore == lastChanged || textAfter == lastChanged) return lastChanged;
        if (!descAfter || !descAfter.isText(textAfter.nodeValue)) return textAfter;
        else if (view.input.compositionNode == textAfter) {
            let descBefore = textBefore.pmViewDesc;
            if (!(!descBefore || !descBefore.isText(textBefore.nodeValue))) return textAfter;
        }
    }
    return textBefore || textAfter;
}
function $81901ae0222f0506$var$timestampFromCustomEvent() {
    let event = document.createEvent("Event");
    event.initEvent("event", true, true);
    return event.timeStamp;
}
/**
@internal
*/ function $81901ae0222f0506$var$endComposition(view, restarting = false) {
    if ($81901ae0222f0506$var$android && view.domObserver.flushingSoon >= 0) return;
    view.domObserver.forceFlush();
    $81901ae0222f0506$var$clearComposition(view);
    if (restarting || view.docView && view.docView.dirty) {
        let sel = $81901ae0222f0506$var$selectionFromDOM(view);
        if (sel && !sel.eq(view.state.selection)) view.dispatch(view.state.tr.setSelection(sel));
        else if ((view.markCursor || restarting) && !view.state.selection.empty) view.dispatch(view.state.tr.deleteSelection());
        else view.updateState(view.state);
        return true;
    }
    return false;
}
function $81901ae0222f0506$var$captureCopy(view, dom) {
    // The extra wrapper is somehow necessary on IE/Edge to prevent the
    // content from being mangled when it is put onto the clipboard
    if (!view.dom.parentNode) return;
    let wrap = view.dom.parentNode.appendChild(document.createElement("div"));
    wrap.appendChild(dom);
    wrap.style.cssText = "position: fixed; left: -10000px; top: 10px";
    let sel = getSelection(), range = document.createRange();
    range.selectNodeContents(dom);
    // Done because IE will fire a selectionchange moving the selection
    // to its start when removeAllRanges is called and the editor still
    // has focus (which will mess up the editor's selection state).
    view.dom.blur();
    sel.removeAllRanges();
    sel.addRange(range);
    setTimeout(()=>{
        if (wrap.parentNode) wrap.parentNode.removeChild(wrap);
        view.focus();
    }, 50);
}
// This is very crude, but unfortunately both these browsers _pretend_
// that they have a clipboard API—all the objects and methods are
// there, they just don't work, and they are hard to test.
const $81901ae0222f0506$var$brokenClipboardAPI = $81901ae0222f0506$var$ie && $81901ae0222f0506$var$ie_version < 15 || $81901ae0222f0506$var$ios && $81901ae0222f0506$var$webkit_version < 604;
$81901ae0222f0506$var$handlers.copy = $81901ae0222f0506$var$editHandlers.cut = (view, _event)=>{
    let event = _event;
    let sel = view.state.selection, cut = event.type == "cut";
    if (sel.empty) return;
    // IE and Edge's clipboard interface is completely broken
    let data = $81901ae0222f0506$var$brokenClipboardAPI ? null : event.clipboardData;
    let slice = sel.content(), { dom: dom, text: text } = $81901ae0222f0506$var$serializeForClipboard(view, slice);
    if (data) {
        event.preventDefault();
        data.clearData();
        data.setData("text/html", dom.innerHTML);
        data.setData("text/plain", text);
    } else $81901ae0222f0506$var$captureCopy(view, dom);
    if (cut) view.dispatch(view.state.tr.deleteSelection().scrollIntoView().setMeta("uiEvent", "cut"));
};
function $81901ae0222f0506$var$sliceSingleNode(slice) {
    return slice.openStart == 0 && slice.openEnd == 0 && slice.content.childCount == 1 ? slice.content.firstChild : null;
}
function $81901ae0222f0506$var$capturePaste(view, event) {
    if (!view.dom.parentNode) return;
    let plainText = view.input.shiftKey || view.state.selection.$from.parent.type.spec.code;
    let target = view.dom.parentNode.appendChild(document.createElement(plainText ? "textarea" : "div"));
    if (!plainText) target.contentEditable = "true";
    target.style.cssText = "position: fixed; left: -10000px; top: 10px";
    target.focus();
    let plain = view.input.shiftKey && view.input.lastKeyCode != 45;
    setTimeout(()=>{
        view.focus();
        if (target.parentNode) target.parentNode.removeChild(target);
        if (plainText) $81901ae0222f0506$var$doPaste(view, target.value, null, plain, event);
        else $81901ae0222f0506$var$doPaste(view, target.textContent, target.innerHTML, plain, event);
    }, 50);
}
function $81901ae0222f0506$var$doPaste(view, text, html, preferPlain, event) {
    let slice = $81901ae0222f0506$var$parseFromClipboard(view, text, html, preferPlain, view.state.selection.$from);
    if (view.someProp("handlePaste", (f)=>f(view, event, slice || (0, $3xw6l.Slice).empty))) return true;
    if (!slice) return false;
    let singleNode = $81901ae0222f0506$var$sliceSingleNode(slice);
    let tr = singleNode ? view.state.tr.replaceSelectionWith(singleNode, preferPlain) : view.state.tr.replaceSelection(slice);
    view.dispatch(tr.scrollIntoView().setMeta("paste", true).setMeta("uiEvent", "paste"));
    return true;
}
function $81901ae0222f0506$var$getText(clipboardData) {
    let text = clipboardData.getData("text/plain") || clipboardData.getData("Text");
    if (text) return text;
    let uris = clipboardData.getData("text/uri-list");
    return uris ? uris.replace(/\r?\n/g, " ") : "";
}
$81901ae0222f0506$var$editHandlers.paste = (view, _event)=>{
    let event = _event;
    // Handling paste from JavaScript during composition is very poorly
    // handled by browsers, so as a dodgy but preferable kludge, we just
    // let the browser do its native thing there, except on Android,
    // where the editor is almost always composing.
    if (view.composing && !$81901ae0222f0506$var$android) return;
    let data = $81901ae0222f0506$var$brokenClipboardAPI ? null : event.clipboardData;
    let plain = view.input.shiftKey && view.input.lastKeyCode != 45;
    if (data && $81901ae0222f0506$var$doPaste(view, $81901ae0222f0506$var$getText(data), data.getData("text/html"), plain, event)) event.preventDefault();
    else $81901ae0222f0506$var$capturePaste(view, event);
};
class $81901ae0222f0506$var$Dragging {
    constructor(slice, move, node){
        this.slice = slice;
        this.move = move;
        this.node = node;
    }
}
const $81901ae0222f0506$var$dragCopyModifier = $81901ae0222f0506$var$mac ? "altKey" : "ctrlKey";
$81901ae0222f0506$var$handlers.dragstart = (view, _event)=>{
    let event = _event;
    let mouseDown = view.input.mouseDown;
    if (mouseDown) mouseDown.done();
    if (!event.dataTransfer) return;
    let sel = view.state.selection;
    let pos = sel.empty ? null : view.posAtCoords($81901ae0222f0506$var$eventCoords(event));
    let node;
    if (pos && pos.pos >= sel.from && pos.pos <= (sel instanceof (0, $3lIcL.NodeSelection) ? sel.to - 1 : sel.to)) ;
    else if (mouseDown && mouseDown.mightDrag) node = (0, $3lIcL.NodeSelection).create(view.state.doc, mouseDown.mightDrag.pos);
    else if (event.target && event.target.nodeType == 1) {
        let desc = view.docView.nearestDesc(event.target, true);
        if (desc && desc.node.type.spec.draggable && desc != view.docView) node = (0, $3lIcL.NodeSelection).create(view.state.doc, desc.posBefore);
    }
    let draggedSlice = (node || view.state.selection).content();
    let { dom: dom, text: text, slice: slice } = $81901ae0222f0506$var$serializeForClipboard(view, draggedSlice);
    // Pre-120 Chrome versions clear files when calling `clearData` (#1472)
    if (!event.dataTransfer.files.length || !$81901ae0222f0506$var$chrome || $81901ae0222f0506$var$chrome_version > 120) event.dataTransfer.clearData();
    event.dataTransfer.setData($81901ae0222f0506$var$brokenClipboardAPI ? "Text" : "text/html", dom.innerHTML);
    // See https://github.com/ProseMirror/prosemirror/issues/1156
    event.dataTransfer.effectAllowed = "copyMove";
    if (!$81901ae0222f0506$var$brokenClipboardAPI) event.dataTransfer.setData("text/plain", text);
    view.dragging = new $81901ae0222f0506$var$Dragging(slice, !event[$81901ae0222f0506$var$dragCopyModifier], node);
};
$81901ae0222f0506$var$handlers.dragend = (view)=>{
    let dragging = view.dragging;
    window.setTimeout(()=>{
        if (view.dragging == dragging) view.dragging = null;
    }, 50);
};
$81901ae0222f0506$var$editHandlers.dragover = $81901ae0222f0506$var$editHandlers.dragenter = (_, e)=>e.preventDefault();
$81901ae0222f0506$var$editHandlers.drop = (view, _event)=>{
    let event = _event;
    let dragging = view.dragging;
    view.dragging = null;
    if (!event.dataTransfer) return;
    let eventPos = view.posAtCoords($81901ae0222f0506$var$eventCoords(event));
    if (!eventPos) return;
    let $mouse = view.state.doc.resolve(eventPos.pos);
    let slice = dragging && dragging.slice;
    if (slice) view.someProp("transformPasted", (f)=>{
        slice = f(slice, view);
    });
    else slice = $81901ae0222f0506$var$parseFromClipboard(view, $81901ae0222f0506$var$getText(event.dataTransfer), $81901ae0222f0506$var$brokenClipboardAPI ? null : event.dataTransfer.getData("text/html"), false, $mouse);
    let move = !!(dragging && !event[$81901ae0222f0506$var$dragCopyModifier]);
    if (view.someProp("handleDrop", (f)=>f(view, event, slice || (0, $3xw6l.Slice).empty, move))) {
        event.preventDefault();
        return;
    }
    if (!slice) return;
    event.preventDefault();
    let insertPos = slice ? (0, $lzEKq.dropPoint)(view.state.doc, $mouse.pos, slice) : $mouse.pos;
    if (insertPos == null) insertPos = $mouse.pos;
    let tr = view.state.tr;
    if (move) {
        let { node: node } = dragging;
        if (node) node.replace(tr);
        else tr.deleteSelection();
    }
    let pos = tr.mapping.map(insertPos);
    let isNode = slice.openStart == 0 && slice.openEnd == 0 && slice.content.childCount == 1;
    let beforeInsert = tr.doc;
    if (isNode) tr.replaceRangeWith(pos, pos, slice.content.firstChild);
    else tr.replaceRange(pos, pos, slice);
    if (tr.doc.eq(beforeInsert)) return;
    let $pos = tr.doc.resolve(pos);
    if (isNode && (0, $3lIcL.NodeSelection).isSelectable(slice.content.firstChild) && $pos.nodeAfter && $pos.nodeAfter.sameMarkup(slice.content.firstChild)) tr.setSelection(new (0, $3lIcL.NodeSelection)($pos));
    else {
        let end = tr.mapping.map(insertPos);
        tr.mapping.maps[tr.mapping.maps.length - 1].forEach((_from, _to, _newFrom, newTo)=>end = newTo);
        tr.setSelection($81901ae0222f0506$var$selectionBetween(view, $pos, tr.doc.resolve(end)));
    }
    view.focus();
    view.dispatch(tr.setMeta("uiEvent", "drop"));
};
$81901ae0222f0506$var$handlers.focus = (view)=>{
    view.input.lastFocus = Date.now();
    if (!view.focused) {
        view.domObserver.stop();
        view.dom.classList.add("ProseMirror-focused");
        view.domObserver.start();
        view.focused = true;
        setTimeout(()=>{
            if (view.docView && view.hasFocus() && !view.domObserver.currentSelection.eq(view.domSelectionRange())) $81901ae0222f0506$var$selectionToDOM(view);
        }, 20);
    }
};
$81901ae0222f0506$var$handlers.blur = (view, _event)=>{
    let event = _event;
    if (view.focused) {
        view.domObserver.stop();
        view.dom.classList.remove("ProseMirror-focused");
        view.domObserver.start();
        if (event.relatedTarget && view.dom.contains(event.relatedTarget)) view.domObserver.currentSelection.clear();
        view.focused = false;
    }
};
$81901ae0222f0506$var$handlers.beforeinput = (view, _event)=>{
    let event = _event;
    // We should probably do more with beforeinput events, but support
    // is so spotty that I'm still waiting to see where they are going.
    // Very specific hack to deal with backspace sometimes failing on
    // Chrome Android when after an uneditable node.
    if ($81901ae0222f0506$var$chrome && $81901ae0222f0506$var$android && event.inputType == "deleteContentBackward") {
        view.domObserver.flushSoon();
        let { domChangeCount: domChangeCount } = view.input;
        setTimeout(()=>{
            if (view.input.domChangeCount != domChangeCount) return; // Event already had some effect
            // This bug tends to close the virtual keyboard, so we refocus
            view.dom.blur();
            view.focus();
            if (view.someProp("handleKeyDown", (f)=>f(view, $81901ae0222f0506$var$keyEvent(8, "Backspace")))) return;
            let { $cursor: $cursor } = view.state.selection;
            // Crude approximation of backspace behavior when no command handled it
            if ($cursor && $cursor.pos > 0) view.dispatch(view.state.tr.delete($cursor.pos - 1, $cursor.pos).scrollIntoView());
        }, 50);
    }
};
// Make sure all handlers get registered
for(let prop in $81901ae0222f0506$var$editHandlers)$81901ae0222f0506$var$handlers[prop] = $81901ae0222f0506$var$editHandlers[prop];
function $81901ae0222f0506$var$compareObjs(a, b) {
    if (a == b) return true;
    for(let p in a)if (a[p] !== b[p]) return false;
    for(let p in b)if (!(p in a)) return false;
    return true;
}
class $81901ae0222f0506$var$WidgetType {
    constructor(toDOM, spec){
        this.toDOM = toDOM;
        this.spec = spec || $81901ae0222f0506$var$noSpec;
        this.side = this.spec.side || 0;
    }
    map(mapping, span, offset, oldOffset) {
        let { pos: pos, deleted: deleted } = mapping.mapResult(span.from + oldOffset, this.side < 0 ? -1 : 1);
        return deleted ? null : new $81901ae0222f0506$export$10e30b733df217ea(pos - offset, pos - offset, this);
    }
    valid() {
        return true;
    }
    eq(other) {
        return this == other || other instanceof $81901ae0222f0506$var$WidgetType && (this.spec.key && this.spec.key == other.spec.key || this.toDOM == other.toDOM && $81901ae0222f0506$var$compareObjs(this.spec, other.spec));
    }
    destroy(node) {
        if (this.spec.destroy) this.spec.destroy(node);
    }
}
class $81901ae0222f0506$var$InlineType {
    constructor(attrs, spec){
        this.attrs = attrs;
        this.spec = spec || $81901ae0222f0506$var$noSpec;
    }
    map(mapping, span, offset, oldOffset) {
        let from = mapping.map(span.from + oldOffset, this.spec.inclusiveStart ? -1 : 1) - offset;
        let to = mapping.map(span.to + oldOffset, this.spec.inclusiveEnd ? 1 : -1) - offset;
        return from >= to ? null : new $81901ae0222f0506$export$10e30b733df217ea(from, to, this);
    }
    valid(_, span) {
        return span.from < span.to;
    }
    eq(other) {
        return this == other || other instanceof $81901ae0222f0506$var$InlineType && $81901ae0222f0506$var$compareObjs(this.attrs, other.attrs) && $81901ae0222f0506$var$compareObjs(this.spec, other.spec);
    }
    static is(span) {
        return span.type instanceof $81901ae0222f0506$var$InlineType;
    }
    destroy() {}
}
class $81901ae0222f0506$var$NodeType {
    constructor(attrs, spec){
        this.attrs = attrs;
        this.spec = spec || $81901ae0222f0506$var$noSpec;
    }
    map(mapping, span, offset, oldOffset) {
        let from = mapping.mapResult(span.from + oldOffset, 1);
        if (from.deleted) return null;
        let to = mapping.mapResult(span.to + oldOffset, -1);
        if (to.deleted || to.pos <= from.pos) return null;
        return new $81901ae0222f0506$export$10e30b733df217ea(from.pos - offset, to.pos - offset, this);
    }
    valid(node, span) {
        let { index: index, offset: offset } = node.content.findIndex(span.from), child;
        return offset == span.from && !(child = node.child(index)).isText && offset + child.nodeSize == span.to;
    }
    eq(other) {
        return this == other || other instanceof $81901ae0222f0506$var$NodeType && $81901ae0222f0506$var$compareObjs(this.attrs, other.attrs) && $81901ae0222f0506$var$compareObjs(this.spec, other.spec);
    }
    destroy() {}
}
/**
Decoration objects can be provided to the view through the
[`decorations` prop](https://prosemirror.net/docs/ref/#view.EditorProps.decorations). They come in
several variants—see the static members of this class for details.
*/ class $81901ae0222f0506$export$10e30b733df217ea {
    /**
    @internal
    */ constructor(/**
    The start position of the decoration.
    */ from, /**
    The end position. Will be the same as `from` for [widget
    decorations](https://prosemirror.net/docs/ref/#view.Decoration^widget).
    */ to, /**
    @internal
    */ type){
        this.from = from;
        this.to = to;
        this.type = type;
    }
    /**
    @internal
    */ copy(from, to) {
        return new $81901ae0222f0506$export$10e30b733df217ea(from, to, this.type);
    }
    /**
    @internal
    */ eq(other, offset = 0) {
        return this.type.eq(other.type) && this.from + offset == other.from && this.to + offset == other.to;
    }
    /**
    @internal
    */ map(mapping, offset, oldOffset) {
        return this.type.map(mapping, this, offset, oldOffset);
    }
    /**
    Creates a widget decoration, which is a DOM node that's shown in
    the document at the given position. It is recommended that you
    delay rendering the widget by passing a function that will be
    called when the widget is actually drawn in a view, but you can
    also directly pass a DOM node. `getPos` can be used to find the
    widget's current document position.
    */ static widget(pos, toDOM, spec) {
        return new $81901ae0222f0506$export$10e30b733df217ea(pos, pos, new $81901ae0222f0506$var$WidgetType(toDOM, spec));
    }
    /**
    Creates an inline decoration, which adds the given attributes to
    each inline node between `from` and `to`.
    */ static inline(from, to, attrs, spec) {
        return new $81901ae0222f0506$export$10e30b733df217ea(from, to, new $81901ae0222f0506$var$InlineType(attrs, spec));
    }
    /**
    Creates a node decoration. `from` and `to` should point precisely
    before and after a node in the document. That node, and only that
    node, will receive the given attributes.
    */ static node(from, to, attrs, spec) {
        return new $81901ae0222f0506$export$10e30b733df217ea(from, to, new $81901ae0222f0506$var$NodeType(attrs, spec));
    }
    /**
    The spec provided when creating this decoration. Can be useful
    if you've stored extra information in that object.
    */ get spec() {
        return this.type.spec;
    }
    /**
    @internal
    */ get inline() {
        return this.type instanceof $81901ae0222f0506$var$InlineType;
    }
    /**
    @internal
    */ get widget() {
        return this.type instanceof $81901ae0222f0506$var$WidgetType;
    }
}
const $81901ae0222f0506$var$none = [], $81901ae0222f0506$var$noSpec = {};
/**
A collection of [decorations](https://prosemirror.net/docs/ref/#view.Decoration), organized in such
a way that the drawing algorithm can efficiently use and compare
them. This is a persistent data structure—it is not modified,
updates create a new value.
*/ class $81901ae0222f0506$export$93bf62eb445cec98 {
    /**
    @internal
    */ constructor(local, children){
        this.local = local.length ? local : $81901ae0222f0506$var$none;
        this.children = children.length ? children : $81901ae0222f0506$var$none;
    }
    /**
    Create a set of decorations, using the structure of the given
    document. This will consume (modify) the `decorations` array, so
    you must make a copy if you want need to preserve that.
    */ static create(doc, decorations) {
        return decorations.length ? $81901ae0222f0506$var$buildTree(decorations, doc, 0, $81901ae0222f0506$var$noSpec) : $81901ae0222f0506$var$empty;
    }
    /**
    Find all decorations in this set which touch the given range
    (including decorations that start or end directly at the
    boundaries) and match the given predicate on their spec. When
    `start` and `end` are omitted, all decorations in the set are
    considered. When `predicate` isn't given, all decorations are
    assumed to match.
    */ find(start, end, predicate) {
        let result = [];
        this.findInner(start == null ? 0 : start, end == null ? 1e9 : end, result, 0, predicate);
        return result;
    }
    findInner(start, end, result, offset, predicate) {
        for(let i = 0; i < this.local.length; i++){
            let span = this.local[i];
            if (span.from <= end && span.to >= start && (!predicate || predicate(span.spec))) result.push(span.copy(span.from + offset, span.to + offset));
        }
        for(let i = 0; i < this.children.length; i += 3)if (this.children[i] < end && this.children[i + 1] > start) {
            let childOff = this.children[i] + 1;
            this.children[i + 2].findInner(start - childOff, end - childOff, result, offset + childOff, predicate);
        }
    }
    /**
    Map the set of decorations in response to a change in the
    document.
    */ map(mapping, doc, options) {
        if (this == $81901ae0222f0506$var$empty || mapping.maps.length == 0) return this;
        return this.mapInner(mapping, doc, 0, 0, options || $81901ae0222f0506$var$noSpec);
    }
    /**
    @internal
    */ mapInner(mapping, node, offset, oldOffset, options) {
        let newLocal;
        for(let i = 0; i < this.local.length; i++){
            let mapped = this.local[i].map(mapping, offset, oldOffset);
            if (mapped && mapped.type.valid(node, mapped)) (newLocal || (newLocal = [])).push(mapped);
            else if (options.onRemove) options.onRemove(this.local[i].spec);
        }
        if (this.children.length) return $81901ae0222f0506$var$mapChildren(this.children, newLocal || [], mapping, node, offset, oldOffset, options);
        else return newLocal ? new $81901ae0222f0506$export$93bf62eb445cec98(newLocal.sort($81901ae0222f0506$var$byPos), $81901ae0222f0506$var$none) : $81901ae0222f0506$var$empty;
    }
    /**
    Add the given array of decorations to the ones in the set,
    producing a new set. Consumes the `decorations` array. Needs
    access to the current document to create the appropriate tree
    structure.
    */ add(doc, decorations) {
        if (!decorations.length) return this;
        if (this == $81901ae0222f0506$var$empty) return $81901ae0222f0506$export$93bf62eb445cec98.create(doc, decorations);
        return this.addInner(doc, decorations, 0);
    }
    addInner(doc, decorations, offset) {
        let children, childIndex = 0;
        doc.forEach((childNode, childOffset)=>{
            let baseOffset = childOffset + offset, found;
            if (!(found = $81901ae0222f0506$var$takeSpansForNode(decorations, childNode, baseOffset))) return;
            if (!children) children = this.children.slice();
            while(childIndex < children.length && children[childIndex] < childOffset)childIndex += 3;
            if (children[childIndex] == childOffset) children[childIndex + 2] = children[childIndex + 2].addInner(childNode, found, baseOffset + 1);
            else children.splice(childIndex, 0, childOffset, childOffset + childNode.nodeSize, $81901ae0222f0506$var$buildTree(found, childNode, baseOffset + 1, $81901ae0222f0506$var$noSpec));
            childIndex += 3;
        });
        let local = $81901ae0222f0506$var$moveSpans(childIndex ? $81901ae0222f0506$var$withoutNulls(decorations) : decorations, -offset);
        for(let i = 0; i < local.length; i++)if (!local[i].type.valid(doc, local[i])) local.splice(i--, 1);
        return new $81901ae0222f0506$export$93bf62eb445cec98(local.length ? this.local.concat(local).sort($81901ae0222f0506$var$byPos) : this.local, children || this.children);
    }
    /**
    Create a new set that contains the decorations in this set, minus
    the ones in the given array.
    */ remove(decorations) {
        if (decorations.length == 0 || this == $81901ae0222f0506$var$empty) return this;
        return this.removeInner(decorations, 0);
    }
    removeInner(decorations, offset) {
        let children = this.children, local = this.local;
        for(let i = 0; i < children.length; i += 3){
            let found;
            let from = children[i] + offset, to = children[i + 1] + offset;
            for(let j = 0, span; j < decorations.length; j++)if (span = decorations[j]) {
                if (span.from > from && span.to < to) {
                    decorations[j] = null;
                    (found || (found = [])).push(span);
                }
            }
            if (!found) continue;
            if (children == this.children) children = this.children.slice();
            let removed = children[i + 2].removeInner(found, from + 1);
            if (removed != $81901ae0222f0506$var$empty) children[i + 2] = removed;
            else {
                children.splice(i, 3);
                i -= 3;
            }
        }
        if (local.length) {
            for(let i = 0, span; i < decorations.length; i++)if (span = decorations[i]) {
                for(let j = 0; j < local.length; j++)if (local[j].eq(span, offset)) {
                    if (local == this.local) local = this.local.slice();
                    local.splice(j--, 1);
                }
            }
        }
        if (children == this.children && local == this.local) return this;
        return local.length || children.length ? new $81901ae0222f0506$export$93bf62eb445cec98(local, children) : $81901ae0222f0506$var$empty;
    }
    forChild(offset, node) {
        if (this == $81901ae0222f0506$var$empty) return this;
        if (node.isLeaf) return $81901ae0222f0506$export$93bf62eb445cec98.empty;
        let child, local;
        for(let i = 0; i < this.children.length; i += 3)if (this.children[i] >= offset) {
            if (this.children[i] == offset) child = this.children[i + 2];
            break;
        }
        let start = offset + 1, end = start + node.content.size;
        for(let i = 0; i < this.local.length; i++){
            let dec = this.local[i];
            if (dec.from < end && dec.to > start && dec.type instanceof $81901ae0222f0506$var$InlineType) {
                let from = Math.max(start, dec.from) - start, to = Math.min(end, dec.to) - start;
                if (from < to) (local || (local = [])).push(dec.copy(from, to));
            }
        }
        if (local) {
            let localSet = new $81901ae0222f0506$export$93bf62eb445cec98(local.sort($81901ae0222f0506$var$byPos), $81901ae0222f0506$var$none);
            return child ? new $81901ae0222f0506$var$DecorationGroup([
                localSet,
                child
            ]) : localSet;
        }
        return child || $81901ae0222f0506$var$empty;
    }
    /**
    @internal
    */ eq(other) {
        if (this == other) return true;
        if (!(other instanceof $81901ae0222f0506$export$93bf62eb445cec98) || this.local.length != other.local.length || this.children.length != other.children.length) return false;
        for(let i = 0; i < this.local.length; i++)if (!this.local[i].eq(other.local[i])) return false;
        for(let i = 0; i < this.children.length; i += 3)if (this.children[i] != other.children[i] || this.children[i + 1] != other.children[i + 1] || !this.children[i + 2].eq(other.children[i + 2])) return false;
        return true;
    }
    /**
    @internal
    */ locals(node) {
        return $81901ae0222f0506$var$removeOverlap(this.localsInner(node));
    }
    /**
    @internal
    */ localsInner(node) {
        if (this == $81901ae0222f0506$var$empty) return $81901ae0222f0506$var$none;
        if (node.inlineContent || !this.local.some($81901ae0222f0506$var$InlineType.is)) return this.local;
        let result = [];
        for(let i = 0; i < this.local.length; i++)if (!(this.local[i].type instanceof $81901ae0222f0506$var$InlineType)) result.push(this.local[i]);
        return result;
    }
    forEachSet(f) {
        f(this);
    }
}
/**
The empty set of decorations.
*/ $81901ae0222f0506$export$93bf62eb445cec98.empty = new $81901ae0222f0506$export$93bf62eb445cec98([], []);
/**
@internal
*/ $81901ae0222f0506$export$93bf62eb445cec98.removeOverlap = $81901ae0222f0506$var$removeOverlap;
const $81901ae0222f0506$var$empty = $81901ae0222f0506$export$93bf62eb445cec98.empty;
// An abstraction that allows the code dealing with decorations to
// treat multiple DecorationSet objects as if it were a single object
// with (a subset of) the same interface.
class $81901ae0222f0506$var$DecorationGroup {
    constructor(members){
        this.members = members;
    }
    map(mapping, doc) {
        const mappedDecos = this.members.map((member)=>member.map(mapping, doc, $81901ae0222f0506$var$noSpec));
        return $81901ae0222f0506$var$DecorationGroup.from(mappedDecos);
    }
    forChild(offset, child) {
        if (child.isLeaf) return $81901ae0222f0506$export$93bf62eb445cec98.empty;
        let found = [];
        for(let i = 0; i < this.members.length; i++){
            let result = this.members[i].forChild(offset, child);
            if (result == $81901ae0222f0506$var$empty) continue;
            if (result instanceof $81901ae0222f0506$var$DecorationGroup) found = found.concat(result.members);
            else found.push(result);
        }
        return $81901ae0222f0506$var$DecorationGroup.from(found);
    }
    eq(other) {
        if (!(other instanceof $81901ae0222f0506$var$DecorationGroup) || other.members.length != this.members.length) return false;
        for(let i = 0; i < this.members.length; i++)if (!this.members[i].eq(other.members[i])) return false;
        return true;
    }
    locals(node) {
        let result, sorted = true;
        for(let i = 0; i < this.members.length; i++){
            let locals = this.members[i].localsInner(node);
            if (!locals.length) continue;
            if (!result) result = locals;
            else {
                if (sorted) {
                    result = result.slice();
                    sorted = false;
                }
                for(let j = 0; j < locals.length; j++)result.push(locals[j]);
            }
        }
        return result ? $81901ae0222f0506$var$removeOverlap(sorted ? result : result.sort($81901ae0222f0506$var$byPos)) : $81901ae0222f0506$var$none;
    }
    // Create a group for the given array of decoration sets, or return
    // a single set when possible.
    static from(members) {
        switch(members.length){
            case 0:
                return $81901ae0222f0506$var$empty;
            case 1:
                return members[0];
            default:
                return new $81901ae0222f0506$var$DecorationGroup(members.every((m)=>m instanceof $81901ae0222f0506$export$93bf62eb445cec98) ? members : members.reduce((r, m)=>r.concat(m instanceof $81901ae0222f0506$export$93bf62eb445cec98 ? m : m.members), []));
        }
    }
    forEachSet(f) {
        for(let i = 0; i < this.members.length; i++)this.members[i].forEachSet(f);
    }
}
function $81901ae0222f0506$var$mapChildren(oldChildren, newLocal, mapping, node, offset, oldOffset, options) {
    let children = oldChildren.slice();
    // Mark the children that are directly touched by changes, and
    // move those that are after the changes.
    for(let i = 0, baseOffset = oldOffset; i < mapping.maps.length; i++){
        let moved = 0;
        mapping.maps[i].forEach((oldStart, oldEnd, newStart, newEnd)=>{
            let dSize = newEnd - newStart - (oldEnd - oldStart);
            for(let i = 0; i < children.length; i += 3){
                let end = children[i + 1];
                if (end < 0 || oldStart > end + baseOffset - moved) continue;
                let start = children[i] + baseOffset - moved;
                if (oldEnd >= start) children[i + 1] = oldStart <= start ? -2 : -1;
                else if (oldStart >= baseOffset && dSize) {
                    children[i] += dSize;
                    children[i + 1] += dSize;
                }
            }
            moved += dSize;
        });
        baseOffset = mapping.maps[i].map(baseOffset, -1);
    }
    // Find the child nodes that still correspond to a single node,
    // recursively call mapInner on them and update their positions.
    let mustRebuild = false;
    for(let i = 0; i < children.length; i += 3)if (children[i + 1] < 0) {
        if (children[i + 1] == -2) {
            mustRebuild = true;
            children[i + 1] = -1;
            continue;
        }
        let from = mapping.map(oldChildren[i] + oldOffset), fromLocal = from - offset;
        if (fromLocal < 0 || fromLocal >= node.content.size) {
            mustRebuild = true;
            continue;
        }
        // Must read oldChildren because children was tagged with -1
        let to = mapping.map(oldChildren[i + 1] + oldOffset, -1), toLocal = to - offset;
        let { index: index, offset: childOffset } = node.content.findIndex(fromLocal);
        let childNode = node.maybeChild(index);
        if (childNode && childOffset == fromLocal && childOffset + childNode.nodeSize == toLocal) {
            let mapped = children[i + 2].mapInner(mapping, childNode, from + 1, oldChildren[i] + oldOffset + 1, options);
            if (mapped != $81901ae0222f0506$var$empty) {
                children[i] = fromLocal;
                children[i + 1] = toLocal;
                children[i + 2] = mapped;
            } else {
                children[i + 1] = -2;
                mustRebuild = true;
            }
        } else mustRebuild = true;
    }
    // Remaining children must be collected and rebuilt into the appropriate structure
    if (mustRebuild) {
        let decorations = $81901ae0222f0506$var$mapAndGatherRemainingDecorations(children, oldChildren, newLocal, mapping, offset, oldOffset, options);
        let built = $81901ae0222f0506$var$buildTree(decorations, node, 0, options);
        newLocal = built.local;
        for(let i = 0; i < children.length; i += 3)if (children[i + 1] < 0) {
            children.splice(i, 3);
            i -= 3;
        }
        for(let i = 0, j = 0; i < built.children.length; i += 3){
            let from = built.children[i];
            while(j < children.length && children[j] < from)j += 3;
            children.splice(j, 0, built.children[i], built.children[i + 1], built.children[i + 2]);
        }
    }
    return new $81901ae0222f0506$export$93bf62eb445cec98(newLocal.sort($81901ae0222f0506$var$byPos), children);
}
function $81901ae0222f0506$var$moveSpans(spans, offset) {
    if (!offset || !spans.length) return spans;
    let result = [];
    for(let i = 0; i < spans.length; i++){
        let span = spans[i];
        result.push(new $81901ae0222f0506$export$10e30b733df217ea(span.from + offset, span.to + offset, span.type));
    }
    return result;
}
function $81901ae0222f0506$var$mapAndGatherRemainingDecorations(children, oldChildren, decorations, mapping, offset, oldOffset, options) {
    // Gather all decorations from the remaining marked children
    function gather(set, oldOffset) {
        for(let i = 0; i < set.local.length; i++){
            let mapped = set.local[i].map(mapping, offset, oldOffset);
            if (mapped) decorations.push(mapped);
            else if (options.onRemove) options.onRemove(set.local[i].spec);
        }
        for(let i = 0; i < set.children.length; i += 3)gather(set.children[i + 2], set.children[i] + oldOffset + 1);
    }
    for(let i = 0; i < children.length; i += 3)if (children[i + 1] == -1) gather(children[i + 2], oldChildren[i] + oldOffset + 1);
    return decorations;
}
function $81901ae0222f0506$var$takeSpansForNode(spans, node, offset) {
    if (node.isLeaf) return null;
    let end = offset + node.nodeSize, found = null;
    for(let i = 0, span; i < spans.length; i++)if ((span = spans[i]) && span.from > offset && span.to < end) {
        (found || (found = [])).push(span);
        spans[i] = null;
    }
    return found;
}
function $81901ae0222f0506$var$withoutNulls(array) {
    let result = [];
    for(let i = 0; i < array.length; i++)if (array[i] != null) result.push(array[i]);
    return result;
}
// Build up a tree that corresponds to a set of decorations. `offset`
// is a base offset that should be subtracted from the `from` and `to`
// positions in the spans (so that we don't have to allocate new spans
// for recursive calls).
function $81901ae0222f0506$var$buildTree(spans, node, offset, options) {
    let children = [], hasNulls = false;
    node.forEach((childNode, localStart)=>{
        let found = $81901ae0222f0506$var$takeSpansForNode(spans, childNode, localStart + offset);
        if (found) {
            hasNulls = true;
            let subtree = $81901ae0222f0506$var$buildTree(found, childNode, offset + localStart + 1, options);
            if (subtree != $81901ae0222f0506$var$empty) children.push(localStart, localStart + childNode.nodeSize, subtree);
        }
    });
    let locals = $81901ae0222f0506$var$moveSpans(hasNulls ? $81901ae0222f0506$var$withoutNulls(spans) : spans, -offset).sort($81901ae0222f0506$var$byPos);
    for(let i = 0; i < locals.length; i++)if (!locals[i].type.valid(node, locals[i])) {
        if (options.onRemove) options.onRemove(locals[i].spec);
        locals.splice(i--, 1);
    }
    return locals.length || children.length ? new $81901ae0222f0506$export$93bf62eb445cec98(locals, children) : $81901ae0222f0506$var$empty;
}
// Used to sort decorations so that ones with a low start position
// come first, and within a set with the same start position, those
// with an smaller end position come first.
function $81901ae0222f0506$var$byPos(a, b) {
    return a.from - b.from || a.to - b.to;
}
// Scan a sorted array of decorations for partially overlapping spans,
// and split those so that only fully overlapping spans are left (to
// make subsequent rendering easier). Will return the input array if
// no partially overlapping spans are found (the common case).
function $81901ae0222f0506$var$removeOverlap(spans) {
    let working = spans;
    for(let i = 0; i < working.length - 1; i++){
        let span = working[i];
        if (span.from != span.to) for(let j = i + 1; j < working.length; j++){
            let next = working[j];
            if (next.from == span.from) {
                if (next.to != span.to) {
                    if (working == spans) working = spans.slice();
                    // Followed by a partially overlapping larger span. Split that
                    // span.
                    working[j] = next.copy(next.from, span.to);
                    $81901ae0222f0506$var$insertAhead(working, j + 1, next.copy(span.to, next.to));
                }
                continue;
            } else {
                if (next.from < span.to) {
                    if (working == spans) working = spans.slice();
                    // The end of this one overlaps with a subsequent span. Split
                    // this one.
                    working[i] = span.copy(span.from, next.from);
                    $81901ae0222f0506$var$insertAhead(working, j, span.copy(next.from, span.to));
                }
                break;
            }
        }
    }
    return working;
}
function $81901ae0222f0506$var$insertAhead(array, i, deco) {
    while(i < array.length && $81901ae0222f0506$var$byPos(deco, array[i]) > 0)i++;
    array.splice(i, 0, deco);
}
// Get the decorations associated with the current props of a view.
function $81901ae0222f0506$var$viewDecorations(view) {
    let found = [];
    view.someProp("decorations", (f)=>{
        let result = f(view.state);
        if (result && result != $81901ae0222f0506$var$empty) found.push(result);
    });
    if (view.cursorWrapper) found.push($81901ae0222f0506$export$93bf62eb445cec98.create(view.state.doc, [
        view.cursorWrapper.deco
    ]));
    return $81901ae0222f0506$var$DecorationGroup.from(found);
}
const $81901ae0222f0506$var$observeOptions = {
    childList: true,
    characterData: true,
    characterDataOldValue: true,
    attributes: true,
    attributeOldValue: true,
    subtree: true
};
// IE11 has very broken mutation observers, so we also listen to DOMCharacterDataModified
const $81901ae0222f0506$var$useCharData = $81901ae0222f0506$var$ie && $81901ae0222f0506$var$ie_version <= 11;
class $81901ae0222f0506$var$SelectionState {
    constructor(){
        this.anchorNode = null;
        this.anchorOffset = 0;
        this.focusNode = null;
        this.focusOffset = 0;
    }
    set(sel) {
        this.anchorNode = sel.anchorNode;
        this.anchorOffset = sel.anchorOffset;
        this.focusNode = sel.focusNode;
        this.focusOffset = sel.focusOffset;
    }
    clear() {
        this.anchorNode = this.focusNode = null;
    }
    eq(sel) {
        return sel.anchorNode == this.anchorNode && sel.anchorOffset == this.anchorOffset && sel.focusNode == this.focusNode && sel.focusOffset == this.focusOffset;
    }
}
class $81901ae0222f0506$var$DOMObserver {
    constructor(view, handleDOMChange){
        this.view = view;
        this.handleDOMChange = handleDOMChange;
        this.queue = [];
        this.flushingSoon = -1;
        this.observer = null;
        this.currentSelection = new $81901ae0222f0506$var$SelectionState;
        this.onCharData = null;
        this.suppressingSelectionUpdates = false;
        this.lastChangedTextNode = null;
        this.observer = window.MutationObserver && new window.MutationObserver((mutations)=>{
            for(let i = 0; i < mutations.length; i++)this.queue.push(mutations[i]);
            // IE11 will sometimes (on backspacing out a single character
            // text node after a BR node) call the observer callback
            // before actually updating the DOM, which will cause
            // ProseMirror to miss the change (see #930)
            if ($81901ae0222f0506$var$ie && $81901ae0222f0506$var$ie_version <= 11 && mutations.some((m)=>m.type == "childList" && m.removedNodes.length || m.type == "characterData" && m.oldValue.length > m.target.nodeValue.length)) this.flushSoon();
            else this.flush();
        });
        if ($81901ae0222f0506$var$useCharData) this.onCharData = (e)=>{
            this.queue.push({
                target: e.target,
                type: "characterData",
                oldValue: e.prevValue
            });
            this.flushSoon();
        };
        this.onSelectionChange = this.onSelectionChange.bind(this);
    }
    flushSoon() {
        if (this.flushingSoon < 0) this.flushingSoon = window.setTimeout(()=>{
            this.flushingSoon = -1;
            this.flush();
        }, 20);
    }
    forceFlush() {
        if (this.flushingSoon > -1) {
            window.clearTimeout(this.flushingSoon);
            this.flushingSoon = -1;
            this.flush();
        }
    }
    start() {
        if (this.observer) {
            this.observer.takeRecords();
            this.observer.observe(this.view.dom, $81901ae0222f0506$var$observeOptions);
        }
        if (this.onCharData) this.view.dom.addEventListener("DOMCharacterDataModified", this.onCharData);
        this.connectSelection();
    }
    stop() {
        if (this.observer) {
            let take = this.observer.takeRecords();
            if (take.length) {
                for(let i = 0; i < take.length; i++)this.queue.push(take[i]);
                window.setTimeout(()=>this.flush(), 20);
            }
            this.observer.disconnect();
        }
        if (this.onCharData) this.view.dom.removeEventListener("DOMCharacterDataModified", this.onCharData);
        this.disconnectSelection();
    }
    connectSelection() {
        this.view.dom.ownerDocument.addEventListener("selectionchange", this.onSelectionChange);
    }
    disconnectSelection() {
        this.view.dom.ownerDocument.removeEventListener("selectionchange", this.onSelectionChange);
    }
    suppressSelectionUpdates() {
        this.suppressingSelectionUpdates = true;
        setTimeout(()=>this.suppressingSelectionUpdates = false, 50);
    }
    onSelectionChange() {
        if (!$81901ae0222f0506$var$hasFocusAndSelection(this.view)) return;
        if (this.suppressingSelectionUpdates) return $81901ae0222f0506$var$selectionToDOM(this.view);
        // Deletions on IE11 fire their events in the wrong order, giving
        // us a selection change event before the DOM changes are
        // reported.
        if ($81901ae0222f0506$var$ie && $81901ae0222f0506$var$ie_version <= 11 && !this.view.state.selection.empty) {
            let sel = this.view.domSelectionRange();
            // Selection.isCollapsed isn't reliable on IE
            if (sel.focusNode && $81901ae0222f0506$var$isEquivalentPosition(sel.focusNode, sel.focusOffset, sel.anchorNode, sel.anchorOffset)) return this.flushSoon();
        }
        this.flush();
    }
    setCurSelection() {
        this.currentSelection.set(this.view.domSelectionRange());
    }
    ignoreSelectionChange(sel) {
        if (!sel.focusNode) return true;
        let ancestors = new Set, container;
        for(let scan = sel.focusNode; scan; scan = $81901ae0222f0506$var$parentNode(scan))ancestors.add(scan);
        for(let scan = sel.anchorNode; scan; scan = $81901ae0222f0506$var$parentNode(scan))if (ancestors.has(scan)) {
            container = scan;
            break;
        }
        let desc = container && this.view.docView.nearestDesc(container);
        if (desc && desc.ignoreMutation({
            type: "selection",
            target: container.nodeType == 3 ? container.parentNode : container
        })) {
            this.setCurSelection();
            return true;
        }
    }
    pendingRecords() {
        if (this.observer) for (let mut of this.observer.takeRecords())this.queue.push(mut);
        return this.queue;
    }
    flush() {
        let { view: view } = this;
        if (!view.docView || this.flushingSoon > -1) return;
        let mutations = this.pendingRecords();
        if (mutations.length) this.queue = [];
        let sel = view.domSelectionRange();
        let newSel = !this.suppressingSelectionUpdates && !this.currentSelection.eq(sel) && $81901ae0222f0506$var$hasFocusAndSelection(view) && !this.ignoreSelectionChange(sel);
        let from = -1, to = -1, typeOver = false, added = [];
        if (view.editable) for(let i = 0; i < mutations.length; i++){
            let result = this.registerMutation(mutations[i], added);
            if (result) {
                from = from < 0 ? result.from : Math.min(result.from, from);
                to = to < 0 ? result.to : Math.max(result.to, to);
                if (result.typeOver) typeOver = true;
            }
        }
        if ($81901ae0222f0506$var$gecko && added.length) {
            let brs = added.filter((n)=>n.nodeName == "BR");
            if (brs.length == 2) {
                let [a, b] = brs;
                if (a.parentNode && a.parentNode.parentNode == b.parentNode) b.remove();
                else a.remove();
            } else {
                let { focusNode: focusNode } = this.currentSelection;
                for (let br of brs){
                    let parent = br.parentNode;
                    if (parent && parent.nodeName == "LI" && (!focusNode || $81901ae0222f0506$var$blockParent(view, focusNode) != parent)) br.remove();
                }
            }
        }
        let readSel = null;
        // If it looks like the browser has reset the selection to the
        // start of the document after focus, restore the selection from
        // the state
        if (from < 0 && newSel && view.input.lastFocus > Date.now() - 200 && Math.max(view.input.lastTouch, view.input.lastClick.time) < Date.now() - 300 && $81901ae0222f0506$var$selectionCollapsed(sel) && (readSel = $81901ae0222f0506$var$selectionFromDOM(view)) && readSel.eq((0, $3lIcL.Selection).near(view.state.doc.resolve(0), 1))) {
            view.input.lastFocus = 0;
            $81901ae0222f0506$var$selectionToDOM(view);
            this.currentSelection.set(sel);
            view.scrollToSelection();
        } else if (from > -1 || newSel) {
            if (from > -1) {
                view.docView.markDirty(from, to);
                $81901ae0222f0506$var$checkCSS(view);
            }
            this.handleDOMChange(from, to, typeOver, added);
            if (view.docView && view.docView.dirty) view.updateState(view.state);
            else if (!this.currentSelection.eq(sel)) $81901ae0222f0506$var$selectionToDOM(view);
            this.currentSelection.set(sel);
        }
    }
    registerMutation(mut, added) {
        // Ignore mutations inside nodes that were already noted as inserted
        if (added.indexOf(mut.target) > -1) return null;
        let desc = this.view.docView.nearestDesc(mut.target);
        if (mut.type == "attributes" && (desc == this.view.docView || mut.attributeName == "contenteditable" || // Firefox sometimes fires spurious events for null/empty styles
        mut.attributeName == "style" && !mut.oldValue && !mut.target.getAttribute("style"))) return null;
        if (!desc || desc.ignoreMutation(mut)) return null;
        if (mut.type == "childList") {
            for(let i = 0; i < mut.addedNodes.length; i++){
                let node = mut.addedNodes[i];
                added.push(node);
                if (node.nodeType == 3) this.lastChangedTextNode = node;
            }
            if (desc.contentDOM && desc.contentDOM != desc.dom && !desc.contentDOM.contains(mut.target)) return {
                from: desc.posBefore,
                to: desc.posAfter
            };
            let prev = mut.previousSibling, next = mut.nextSibling;
            if ($81901ae0222f0506$var$ie && $81901ae0222f0506$var$ie_version <= 11 && mut.addedNodes.length) // IE11 gives us incorrect next/prev siblings for some
            // insertions, so if there are added nodes, recompute those
            for(let i = 0; i < mut.addedNodes.length; i++){
                let { previousSibling: previousSibling, nextSibling: nextSibling } = mut.addedNodes[i];
                if (!previousSibling || Array.prototype.indexOf.call(mut.addedNodes, previousSibling) < 0) prev = previousSibling;
                if (!nextSibling || Array.prototype.indexOf.call(mut.addedNodes, nextSibling) < 0) next = nextSibling;
            }
            let fromOffset = prev && prev.parentNode == mut.target ? $81901ae0222f0506$var$domIndex(prev) + 1 : 0;
            let from = desc.localPosFromDOM(mut.target, fromOffset, -1);
            let toOffset = next && next.parentNode == mut.target ? $81901ae0222f0506$var$domIndex(next) : mut.target.childNodes.length;
            let to = desc.localPosFromDOM(mut.target, toOffset, 1);
            return {
                from: from,
                to: to
            };
        } else if (mut.type == "attributes") return {
            from: desc.posAtStart - desc.border,
            to: desc.posAtEnd + desc.border
        };
        else {
            this.lastChangedTextNode = mut.target;
            return {
                from: desc.posAtStart,
                to: desc.posAtEnd,
                // An event was generated for a text change that didn't change
                // any text. Mark the dom change to fall back to assuming the
                // selection was typed over with an identical value if it can't
                // find another change.
                typeOver: mut.target.nodeValue == mut.oldValue
            };
        }
    }
}
let $81901ae0222f0506$var$cssChecked = new WeakMap();
let $81901ae0222f0506$var$cssCheckWarned = false;
function $81901ae0222f0506$var$checkCSS(view) {
    if ($81901ae0222f0506$var$cssChecked.has(view)) return;
    $81901ae0222f0506$var$cssChecked.set(view, null);
    if ([
        'normal',
        'nowrap',
        'pre-line'
    ].indexOf(getComputedStyle(view.dom).whiteSpace) !== -1) {
        view.requiresGeckoHackNode = $81901ae0222f0506$var$gecko;
        if ($81901ae0222f0506$var$cssCheckWarned) return;
        console["warn"]("ProseMirror expects the CSS white-space property to be set, preferably to 'pre-wrap'. It is recommended to load style/prosemirror.css from the prosemirror-view package.");
        $81901ae0222f0506$var$cssCheckWarned = true;
    }
}
function $81901ae0222f0506$var$rangeToSelectionRange(view, range) {
    let anchorNode = range.startContainer, anchorOffset = range.startOffset;
    let focusNode = range.endContainer, focusOffset = range.endOffset;
    let currentAnchor = view.domAtPos(view.state.selection.anchor);
    // Since such a range doesn't distinguish between anchor and head,
    // use a heuristic that flips it around if its end matches the
    // current anchor.
    if ($81901ae0222f0506$var$isEquivalentPosition(currentAnchor.node, currentAnchor.offset, focusNode, focusOffset)) [anchorNode, anchorOffset, focusNode, focusOffset] = [
        focusNode,
        focusOffset,
        anchorNode,
        anchorOffset
    ];
    return {
        anchorNode: anchorNode,
        anchorOffset: anchorOffset,
        focusNode: focusNode,
        focusOffset: focusOffset
    };
}
// Used to work around a Safari Selection/shadow DOM bug
// Based on https://github.com/codemirror/dev/issues/414 fix
function $81901ae0222f0506$var$safariShadowSelectionRange(view, selection) {
    if (selection.getComposedRanges) {
        let range = selection.getComposedRanges(view.root)[0];
        if (range) return $81901ae0222f0506$var$rangeToSelectionRange(view, range);
    }
    let found;
    function read(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        found = event.getTargetRanges()[0];
    }
    // Because Safari (at least in 2018-2022) doesn't provide regular
    // access to the selection inside a shadowRoot, we have to perform a
    // ridiculous hack to get at it—using `execCommand` to trigger a
    // `beforeInput` event so that we can read the target range from the
    // event.
    view.dom.addEventListener("beforeinput", read, true);
    document.execCommand("indent");
    view.dom.removeEventListener("beforeinput", read, true);
    return found ? $81901ae0222f0506$var$rangeToSelectionRange(view, found) : null;
}
function $81901ae0222f0506$var$blockParent(view, node) {
    for(let p = node.parentNode; p && p != view.dom; p = p.parentNode){
        let desc = view.docView.nearestDesc(p, true);
        if (desc && desc.node.isBlock) return p;
    }
    return null;
}
// Note that all referencing and parsing is done with the
// start-of-operation selection and document, since that's the one
// that the DOM represents. If any changes came in in the meantime,
// the modification is mapped over those before it is applied, in
// readDOMChange.
function $81901ae0222f0506$var$parseBetween(view, from_, to_) {
    let { node: parent, fromOffset: fromOffset, toOffset: toOffset, from: from, to: to } = view.docView.parseRange(from_, to_);
    let domSel = view.domSelectionRange();
    let find;
    let anchor = domSel.anchorNode;
    if (anchor && view.dom.contains(anchor.nodeType == 1 ? anchor : anchor.parentNode)) {
        find = [
            {
                node: anchor,
                offset: domSel.anchorOffset
            }
        ];
        if (!$81901ae0222f0506$var$selectionCollapsed(domSel)) find.push({
            node: domSel.focusNode,
            offset: domSel.focusOffset
        });
    }
    // Work around issue in Chrome where backspacing sometimes replaces
    // the deleted content with a random BR node (issues #799, #831)
    if ($81901ae0222f0506$var$chrome && view.input.lastKeyCode === 8) for(let off = toOffset; off > fromOffset; off--){
        let node = parent.childNodes[off - 1], desc = node.pmViewDesc;
        if (node.nodeName == "BR" && !desc) {
            toOffset = off;
            break;
        }
        if (!desc || desc.size) break;
    }
    let startDoc = view.state.doc;
    let parser = view.someProp("domParser") || (0, $3xw6l.DOMParser).fromSchema(view.state.schema);
    let $from = startDoc.resolve(from);
    let sel = null, doc = parser.parse(parent, {
        topNode: $from.parent,
        topMatch: $from.parent.contentMatchAt($from.index()),
        topOpen: true,
        from: fromOffset,
        to: toOffset,
        preserveWhitespace: $from.parent.type.whitespace == "pre" ? "full" : true,
        findPositions: find,
        ruleFromNode: $81901ae0222f0506$var$ruleFromNode,
        context: $from
    });
    if (find && find[0].pos != null) {
        let anchor = find[0].pos, head = find[1] && find[1].pos;
        if (head == null) head = anchor;
        sel = {
            anchor: anchor + from,
            head: head + from
        };
    }
    return {
        doc: doc,
        sel: sel,
        from: from,
        to: to
    };
}
function $81901ae0222f0506$var$ruleFromNode(dom) {
    let desc = dom.pmViewDesc;
    if (desc) return desc.parseRule();
    else if (dom.nodeName == "BR" && dom.parentNode) {
        // Safari replaces the list item or table cell with a BR
        // directly in the list node (?!) if you delete the last
        // character in a list item or table cell (#708, #862)
        if ($81901ae0222f0506$var$safari && /^(ul|ol)$/i.test(dom.parentNode.nodeName)) {
            let skip = document.createElement("div");
            skip.appendChild(document.createElement("li"));
            return {
                skip: skip
            };
        } else if (dom.parentNode.lastChild == dom || $81901ae0222f0506$var$safari && /^(tr|table)$/i.test(dom.parentNode.nodeName)) return {
            ignore: true
        };
    } else if (dom.nodeName == "IMG" && dom.getAttribute("mark-placeholder")) return {
        ignore: true
    };
    return null;
}
const $81901ae0222f0506$var$isInline = /^(a|abbr|acronym|b|bd[io]|big|br|button|cite|code|data(list)?|del|dfn|em|i|ins|kbd|label|map|mark|meter|output|q|ruby|s|samp|small|span|strong|su[bp]|time|u|tt|var)$/i;
function $81901ae0222f0506$var$readDOMChange(view, from, to, typeOver, addedNodes) {
    let compositionID = view.input.compositionPendingChanges || (view.composing ? view.input.compositionID : 0);
    view.input.compositionPendingChanges = 0;
    if (from < 0) {
        let origin = view.input.lastSelectionTime > Date.now() - 50 ? view.input.lastSelectionOrigin : null;
        let newSel = $81901ae0222f0506$var$selectionFromDOM(view, origin);
        if (newSel && !view.state.selection.eq(newSel)) {
            if ($81901ae0222f0506$var$chrome && $81901ae0222f0506$var$android && view.input.lastKeyCode === 13 && Date.now() - 100 < view.input.lastKeyCodeTime && view.someProp("handleKeyDown", (f)=>f(view, $81901ae0222f0506$var$keyEvent(13, "Enter")))) return;
            let tr = view.state.tr.setSelection(newSel);
            if (origin == "pointer") tr.setMeta("pointer", true);
            else if (origin == "key") tr.scrollIntoView();
            if (compositionID) tr.setMeta("composition", compositionID);
            view.dispatch(tr);
        }
        return;
    }
    let $before = view.state.doc.resolve(from);
    let shared = $before.sharedDepth(to);
    from = $before.before(shared + 1);
    to = view.state.doc.resolve(to).after(shared + 1);
    let sel = view.state.selection;
    let parse = $81901ae0222f0506$var$parseBetween(view, from, to);
    let doc = view.state.doc, compare = doc.slice(parse.from, parse.to);
    let preferredPos, preferredSide;
    // Prefer anchoring to end when Backspace is pressed
    if (view.input.lastKeyCode === 8 && Date.now() - 100 < view.input.lastKeyCodeTime) {
        preferredPos = view.state.selection.to;
        preferredSide = "end";
    } else {
        preferredPos = view.state.selection.from;
        preferredSide = "start";
    }
    view.input.lastKeyCode = null;
    let change = $81901ae0222f0506$var$findDiff(compare.content, parse.doc.content, parse.from, preferredPos, preferredSide);
    if (change) view.input.domChangeCount++;
    if (($81901ae0222f0506$var$ios && view.input.lastIOSEnter > Date.now() - 225 || $81901ae0222f0506$var$android) && addedNodes.some((n)=>n.nodeType == 1 && !$81901ae0222f0506$var$isInline.test(n.nodeName)) && (!change || change.endA >= change.endB) && view.someProp("handleKeyDown", (f)=>f(view, $81901ae0222f0506$var$keyEvent(13, "Enter")))) {
        view.input.lastIOSEnter = 0;
        return;
    }
    if (!change) {
        if (typeOver && sel instanceof (0, $3lIcL.TextSelection) && !sel.empty && sel.$head.sameParent(sel.$anchor) && !view.composing && !(parse.sel && parse.sel.anchor != parse.sel.head)) change = {
            start: sel.from,
            endA: sel.to,
            endB: sel.to
        };
        else {
            if (parse.sel) {
                let sel = $81901ae0222f0506$var$resolveSelection(view, view.state.doc, parse.sel);
                if (sel && !sel.eq(view.state.selection)) {
                    let tr = view.state.tr.setSelection(sel);
                    if (compositionID) tr.setMeta("composition", compositionID);
                    view.dispatch(tr);
                }
            }
            return;
        }
    }
    // Handle the case where overwriting a selection by typing matches
    // the start or end of the selected content, creating a change
    // that's smaller than what was actually overwritten.
    if (view.state.selection.from < view.state.selection.to && change.start == change.endB && view.state.selection instanceof (0, $3lIcL.TextSelection)) {
        if (change.start > view.state.selection.from && change.start <= view.state.selection.from + 2 && view.state.selection.from >= parse.from) change.start = view.state.selection.from;
        else if (change.endA < view.state.selection.to && change.endA >= view.state.selection.to - 2 && view.state.selection.to <= parse.to) {
            change.endB += view.state.selection.to - change.endA;
            change.endA = view.state.selection.to;
        }
    }
    // IE11 will insert a non-breaking space _ahead_ of the space after
    // the cursor space when adding a space before another space. When
    // that happened, adjust the change to cover the space instead.
    if ($81901ae0222f0506$var$ie && $81901ae0222f0506$var$ie_version <= 11 && change.endB == change.start + 1 && change.endA == change.start && change.start > parse.from && parse.doc.textBetween(change.start - parse.from - 1, change.start - parse.from + 1) == " \u00a0") {
        change.start--;
        change.endA--;
        change.endB--;
    }
    let $from = parse.doc.resolveNoCache(change.start - parse.from);
    let $to = parse.doc.resolveNoCache(change.endB - parse.from);
    let $fromA = doc.resolve(change.start);
    let inlineChange = $from.sameParent($to) && $from.parent.inlineContent && $fromA.end() >= change.endA;
    let nextSel;
    // If this looks like the effect of pressing Enter (or was recorded
    // as being an iOS enter press), just dispatch an Enter key instead.
    if (($81901ae0222f0506$var$ios && view.input.lastIOSEnter > Date.now() - 225 && (!inlineChange || addedNodes.some((n)=>n.nodeName == "DIV" || n.nodeName == "P")) || !inlineChange && $from.pos < parse.doc.content.size && !$from.sameParent($to) && (nextSel = (0, $3lIcL.Selection).findFrom(parse.doc.resolve($from.pos + 1), 1, true)) && nextSel.head == $to.pos) && view.someProp("handleKeyDown", (f)=>f(view, $81901ae0222f0506$var$keyEvent(13, "Enter")))) {
        view.input.lastIOSEnter = 0;
        return;
    }
    // Same for backspace
    if (view.state.selection.anchor > change.start && $81901ae0222f0506$var$looksLikeBackspace(doc, change.start, change.endA, $from, $to) && view.someProp("handleKeyDown", (f)=>f(view, $81901ae0222f0506$var$keyEvent(8, "Backspace")))) {
        if ($81901ae0222f0506$var$android && $81901ae0222f0506$var$chrome) view.domObserver.suppressSelectionUpdates(); // #820
        return;
    }
    // Chrome will occasionally, during composition, delete the
    // entire composition and then immediately insert it again. This is
    // used to detect that situation.
    if ($81901ae0222f0506$var$chrome && change.endB == change.start) view.input.lastChromeDelete = Date.now();
    // This tries to detect Android virtual keyboard
    // enter-and-pick-suggestion action. That sometimes (see issue
    // #1059) first fires a DOM mutation, before moving the selection to
    // the newly created block. And then, because ProseMirror cleans up
    // the DOM selection, it gives up moving the selection entirely,
    // leaving the cursor in the wrong place. When that happens, we drop
    // the new paragraph from the initial change, and fire a simulated
    // enter key afterwards.
    if ($81901ae0222f0506$var$android && !inlineChange && $from.start() != $to.start() && $to.parentOffset == 0 && $from.depth == $to.depth && parse.sel && parse.sel.anchor == parse.sel.head && parse.sel.head == change.endA) {
        change.endB -= 2;
        $to = parse.doc.resolveNoCache(change.endB - parse.from);
        setTimeout(()=>{
            view.someProp("handleKeyDown", function(f) {
                return f(view, $81901ae0222f0506$var$keyEvent(13, "Enter"));
            });
        }, 20);
    }
    let chFrom = change.start, chTo = change.endA;
    let tr, storedMarks, markChange;
    if (inlineChange) {
        if ($from.pos == $to.pos) {
            // IE11 sometimes weirdly moves the DOM selection around after
            // backspacing out the first element in a textblock
            if ($81901ae0222f0506$var$ie && $81901ae0222f0506$var$ie_version <= 11 && $from.parentOffset == 0) {
                view.domObserver.suppressSelectionUpdates();
                setTimeout(()=>$81901ae0222f0506$var$selectionToDOM(view), 20);
            }
            tr = view.state.tr.delete(chFrom, chTo);
            storedMarks = doc.resolve(change.start).marksAcross(doc.resolve(change.endA));
        } else if (change.endA == change.endB && (markChange = $81901ae0222f0506$var$isMarkChange($from.parent.content.cut($from.parentOffset, $to.parentOffset), $fromA.parent.content.cut($fromA.parentOffset, change.endA - $fromA.start())))) {
            tr = view.state.tr;
            if (markChange.type == "add") tr.addMark(chFrom, chTo, markChange.mark);
            else tr.removeMark(chFrom, chTo, markChange.mark);
        } else if ($from.parent.child($from.index()).isText && $from.index() == $to.index() - ($to.textOffset ? 0 : 1)) {
            // Both positions in the same text node -- simply insert text
            let text = $from.parent.textBetween($from.parentOffset, $to.parentOffset);
            if (view.someProp("handleTextInput", (f)=>f(view, chFrom, chTo, text))) return;
            tr = view.state.tr.insertText(text, chFrom, chTo);
        }
    }
    if (!tr) tr = view.state.tr.replace(chFrom, chTo, parse.doc.slice(change.start - parse.from, change.endB - parse.from));
    if (parse.sel) {
        let sel = $81901ae0222f0506$var$resolveSelection(view, tr.doc, parse.sel);
        // Chrome will sometimes, during composition, report the
        // selection in the wrong place. If it looks like that is
        // happening, don't update the selection.
        // Edge just doesn't move the cursor forward when you start typing
        // in an empty block or between br nodes.
        if (sel && !($81901ae0222f0506$var$chrome && view.composing && sel.empty && (change.start != change.endB || view.input.lastChromeDelete < Date.now() - 100) && (sel.head == chFrom || sel.head == tr.mapping.map(chTo) - 1) || $81901ae0222f0506$var$ie && sel.empty && sel.head == chFrom)) tr.setSelection(sel);
    }
    if (storedMarks) tr.ensureMarks(storedMarks);
    if (compositionID) tr.setMeta("composition", compositionID);
    view.dispatch(tr.scrollIntoView());
}
function $81901ae0222f0506$var$resolveSelection(view, doc, parsedSel) {
    if (Math.max(parsedSel.anchor, parsedSel.head) > doc.content.size) return null;
    return $81901ae0222f0506$var$selectionBetween(view, doc.resolve(parsedSel.anchor), doc.resolve(parsedSel.head));
}
// Given two same-length, non-empty fragments of inline content,
// determine whether the first could be created from the second by
// removing or adding a single mark type.
function $81901ae0222f0506$var$isMarkChange(cur, prev) {
    let curMarks = cur.firstChild.marks, prevMarks = prev.firstChild.marks;
    let added = curMarks, removed = prevMarks, type, mark, update;
    for(let i = 0; i < prevMarks.length; i++)added = prevMarks[i].removeFromSet(added);
    for(let i = 0; i < curMarks.length; i++)removed = curMarks[i].removeFromSet(removed);
    if (added.length == 1 && removed.length == 0) {
        mark = added[0];
        type = "add";
        update = (node)=>node.mark(mark.addToSet(node.marks));
    } else if (added.length == 0 && removed.length == 1) {
        mark = removed[0];
        type = "remove";
        update = (node)=>node.mark(mark.removeFromSet(node.marks));
    } else return null;
    let updated = [];
    for(let i = 0; i < prev.childCount; i++)updated.push(update(prev.child(i)));
    if ((0, $3xw6l.Fragment).from(updated).eq(cur)) return {
        mark: mark,
        type: type
    };
}
function $81901ae0222f0506$var$looksLikeBackspace(old, start, end, $newStart, $newEnd) {
    if (end - start <= $newEnd.pos - $newStart.pos || // newEnd must point directly at or after the end of the block that newStart points into
    $81901ae0222f0506$var$skipClosingAndOpening($newStart, true, false) < $newEnd.pos) return false;
    let $start = old.resolve(start);
    // Handle the case where, rather than joining blocks, the change just removed an entire block
    if (!$newStart.parent.isTextblock) {
        let after = $start.nodeAfter;
        return after != null && end == start + after.nodeSize;
    }
    // Start must be at the end of a block
    if ($start.parentOffset < $start.parent.content.size || !$start.parent.isTextblock) return false;
    let $next = old.resolve($81901ae0222f0506$var$skipClosingAndOpening($start, true, true));
    // The next textblock must start before end and end near it
    if (!$next.parent.isTextblock || $next.pos > end || $81901ae0222f0506$var$skipClosingAndOpening($next, true, false) < end) return false;
    // The fragments after the join point must match
    return $newStart.parent.content.cut($newStart.parentOffset).eq($next.parent.content);
}
function $81901ae0222f0506$var$skipClosingAndOpening($pos, fromEnd, mayOpen) {
    let depth = $pos.depth, end = fromEnd ? $pos.end() : $pos.pos;
    while(depth > 0 && (fromEnd || $pos.indexAfter(depth) == $pos.node(depth).childCount)){
        depth--;
        end++;
        fromEnd = false;
    }
    if (mayOpen) {
        let next = $pos.node(depth).maybeChild($pos.indexAfter(depth));
        while(next && !next.isLeaf){
            next = next.firstChild;
            end++;
        }
    }
    return end;
}
function $81901ae0222f0506$var$findDiff(a, b, pos, preferredPos, preferredSide) {
    let start = a.findDiffStart(b, pos);
    if (start == null) return null;
    let { a: endA, b: endB } = a.findDiffEnd(b, pos + a.size, pos + b.size);
    if (preferredSide == "end") {
        let adjust = Math.max(0, start - Math.min(endA, endB));
        preferredPos -= endA + adjust - start;
    }
    if (endA < start && a.size < b.size) {
        let move = preferredPos <= start && preferredPos >= endA ? start - preferredPos : 0;
        start -= move;
        if (start && start < b.size && $81901ae0222f0506$var$isSurrogatePair(b.textBetween(start - 1, start + 1))) start += move ? 1 : -1;
        endB = start + (endB - endA);
        endA = start;
    } else if (endB < start) {
        let move = preferredPos <= start && preferredPos >= endB ? start - preferredPos : 0;
        start -= move;
        if (start && start < a.size && $81901ae0222f0506$var$isSurrogatePair(a.textBetween(start - 1, start + 1))) start += move ? 1 : -1;
        endA = start + (endA - endB);
        endB = start;
    }
    return {
        start: start,
        endA: endA,
        endB: endB
    };
}
function $81901ae0222f0506$var$isSurrogatePair(str) {
    if (str.length != 2) return false;
    let a = str.charCodeAt(0), b = str.charCodeAt(1);
    return a >= 0xDC00 && a <= 0xDFFF && b >= 0xD800 && b <= 0xDBFF;
}
/**
@internal
*/ const $81901ae0222f0506$export$38b79e3fdcfcfd68 = $81901ae0222f0506$var$serializeForClipboard;
/**
@internal
*/ const $81901ae0222f0506$export$5d42ca91c11c9e4d = $81901ae0222f0506$var$parseFromClipboard;
/**
@internal
*/ const $81901ae0222f0506$export$76b14d3c719c32fc = $81901ae0222f0506$var$endComposition;
/**
An editor view manages the DOM structure that represents an
editable document. Its state and behavior are determined by its
[props](https://prosemirror.net/docs/ref/#view.DirectEditorProps).
*/ class $81901ae0222f0506$export$eece2fccabbb77c5 {
    /**
    Create a view. `place` may be a DOM node that the editor should
    be appended to, a function that will place it into the document,
    or an object whose `mount` property holds the node to use as the
    document container. If it is `null`, the editor will not be
    added to the document.
    */ constructor(place, props){
        this._root = null;
        /**
        @internal
        */ this.focused = false;
        /**
        Kludge used to work around a Chrome bug @internal
        */ this.trackWrites = null;
        this.mounted = false;
        /**
        @internal
        */ this.markCursor = null;
        /**
        @internal
        */ this.cursorWrapper = null;
        /**
        @internal
        */ this.lastSelectedViewDesc = undefined;
        /**
        @internal
        */ this.input = new $81901ae0222f0506$var$InputState;
        this.prevDirectPlugins = [];
        this.pluginViews = [];
        /**
        Holds `true` when a hack node is needed in Firefox to prevent the
        [space is eaten issue](https://github.com/ProseMirror/prosemirror/issues/651)
        @internal
        */ this.requiresGeckoHackNode = false;
        /**
        When editor content is being dragged, this object contains
        information about the dragged slice and whether it is being
        copied or moved. At any other time, it is null.
        */ this.dragging = null;
        this._props = props;
        this.state = props.state;
        this.directPlugins = props.plugins || [];
        this.directPlugins.forEach($81901ae0222f0506$var$checkStateComponent);
        this.dispatch = this.dispatch.bind(this);
        this.dom = place && place.mount || document.createElement("div");
        if (place) {
            if (place.appendChild) place.appendChild(this.dom);
            else if (typeof place == "function") place(this.dom);
            else if (place.mount) this.mounted = true;
        }
        this.editable = $81901ae0222f0506$var$getEditable(this);
        $81901ae0222f0506$var$updateCursorWrapper(this);
        this.nodeViews = $81901ae0222f0506$var$buildNodeViews(this);
        this.docView = $81901ae0222f0506$var$docViewDesc(this.state.doc, $81901ae0222f0506$var$computeDocDeco(this), $81901ae0222f0506$var$viewDecorations(this), this.dom, this);
        this.domObserver = new $81901ae0222f0506$var$DOMObserver(this, (from, to, typeOver, added)=>$81901ae0222f0506$var$readDOMChange(this, from, to, typeOver, added));
        this.domObserver.start();
        $81901ae0222f0506$var$initInput(this);
        this.updatePluginViews();
    }
    /**
    Holds `true` when a
    [composition](https://w3c.github.io/uievents/#events-compositionevents)
    is active.
    */ get composing() {
        return this.input.composing;
    }
    /**
    The view's current [props](https://prosemirror.net/docs/ref/#view.EditorProps).
    */ get props() {
        if (this._props.state != this.state) {
            let prev = this._props;
            this._props = {};
            for(let name in prev)this._props[name] = prev[name];
            this._props.state = this.state;
        }
        return this._props;
    }
    /**
    Update the view's props. Will immediately cause an update to
    the DOM.
    */ update(props) {
        if (props.handleDOMEvents != this._props.handleDOMEvents) $81901ae0222f0506$var$ensureListeners(this);
        let prevProps = this._props;
        this._props = props;
        if (props.plugins) {
            props.plugins.forEach($81901ae0222f0506$var$checkStateComponent);
            this.directPlugins = props.plugins;
        }
        this.updateStateInner(props.state, prevProps);
    }
    /**
    Update the view by updating existing props object with the object
    given as argument. Equivalent to `view.update(Object.assign({},
    view.props, props))`.
    */ setProps(props) {
        let updated = {};
        for(let name in this._props)updated[name] = this._props[name];
        updated.state = this.state;
        for(let name in props)updated[name] = props[name];
        this.update(updated);
    }
    /**
    Update the editor's `state` prop, without touching any of the
    other props.
    */ updateState(state) {
        this.updateStateInner(state, this._props);
    }
    updateStateInner(state, prevProps) {
        var _a;
        let prev = this.state, redraw = false, updateSel = false;
        // When stored marks are added, stop composition, so that they can
        // be displayed.
        if (state.storedMarks && this.composing) {
            $81901ae0222f0506$var$clearComposition(this);
            updateSel = true;
        }
        this.state = state;
        let pluginsChanged = prev.plugins != state.plugins || this._props.plugins != prevProps.plugins;
        if (pluginsChanged || this._props.plugins != prevProps.plugins || this._props.nodeViews != prevProps.nodeViews) {
            let nodeViews = $81901ae0222f0506$var$buildNodeViews(this);
            if ($81901ae0222f0506$var$changedNodeViews(nodeViews, this.nodeViews)) {
                this.nodeViews = nodeViews;
                redraw = true;
            }
        }
        if (pluginsChanged || prevProps.handleDOMEvents != this._props.handleDOMEvents) $81901ae0222f0506$var$ensureListeners(this);
        this.editable = $81901ae0222f0506$var$getEditable(this);
        $81901ae0222f0506$var$updateCursorWrapper(this);
        let innerDeco = $81901ae0222f0506$var$viewDecorations(this), outerDeco = $81901ae0222f0506$var$computeDocDeco(this);
        let scroll = prev.plugins != state.plugins && !prev.doc.eq(state.doc) ? "reset" : state.scrollToSelection > prev.scrollToSelection ? "to selection" : "preserve";
        let updateDoc = redraw || !this.docView.matchesNode(state.doc, outerDeco, innerDeco);
        if (updateDoc || !state.selection.eq(prev.selection)) updateSel = true;
        let oldScrollPos = scroll == "preserve" && updateSel && this.dom.style.overflowAnchor == null && $81901ae0222f0506$var$storeScrollPos(this);
        if (updateSel) {
            this.domObserver.stop();
            // Work around an issue in Chrome, IE, and Edge where changing
            // the DOM around an active selection puts it into a broken
            // state where the thing the user sees differs from the
            // selection reported by the Selection object (#710, #973,
            // #1011, #1013, #1035).
            let forceSelUpdate = updateDoc && ($81901ae0222f0506$var$ie || $81901ae0222f0506$var$chrome) && !this.composing && !prev.selection.empty && !state.selection.empty && $81901ae0222f0506$var$selectionContextChanged(prev.selection, state.selection);
            if (updateDoc) {
                // If the node that the selection points into is written to,
                // Chrome sometimes starts misreporting the selection, so this
                // tracks that and forces a selection reset when our update
                // did write to the node.
                let chromeKludge = $81901ae0222f0506$var$chrome ? this.trackWrites = this.domSelectionRange().focusNode : null;
                if (this.composing) this.input.compositionNode = $81901ae0222f0506$var$findCompositionNode(this);
                if (redraw || !this.docView.update(state.doc, outerDeco, innerDeco, this)) {
                    this.docView.updateOuterDeco(outerDeco);
                    this.docView.destroy();
                    this.docView = $81901ae0222f0506$var$docViewDesc(state.doc, outerDeco, innerDeco, this.dom, this);
                }
                if (chromeKludge && !this.trackWrites) forceSelUpdate = true;
            }
            // Work around for an issue where an update arriving right between
            // a DOM selection change and the "selectionchange" event for it
            // can cause a spurious DOM selection update, disrupting mouse
            // drag selection.
            if (forceSelUpdate || !(this.input.mouseDown && this.domObserver.currentSelection.eq(this.domSelectionRange()) && $81901ae0222f0506$var$anchorInRightPlace(this))) $81901ae0222f0506$var$selectionToDOM(this, forceSelUpdate);
            else {
                $81901ae0222f0506$var$syncNodeSelection(this, state.selection);
                this.domObserver.setCurSelection();
            }
            this.domObserver.start();
        }
        this.updatePluginViews(prev);
        if (((_a = this.dragging) === null || _a === void 0 ? void 0 : _a.node) && !prev.doc.eq(state.doc)) this.updateDraggedNode(this.dragging, prev);
        if (scroll == "reset") this.dom.scrollTop = 0;
        else if (scroll == "to selection") this.scrollToSelection();
        else if (oldScrollPos) $81901ae0222f0506$var$resetScrollPos(oldScrollPos);
    }
    /**
    @internal
    */ scrollToSelection() {
        let startDOM = this.domSelectionRange().focusNode;
        if (this.someProp("handleScrollToSelection", (f)=>f(this))) ;
        else if (this.state.selection instanceof (0, $3lIcL.NodeSelection)) {
            let target = this.docView.domAfterPos(this.state.selection.from);
            if (target.nodeType == 1) $81901ae0222f0506$var$scrollRectIntoView(this, target.getBoundingClientRect(), startDOM);
        } else $81901ae0222f0506$var$scrollRectIntoView(this, this.coordsAtPos(this.state.selection.head, 1), startDOM);
    }
    destroyPluginViews() {
        let view;
        while(view = this.pluginViews.pop())if (view.destroy) view.destroy();
    }
    updatePluginViews(prevState) {
        if (!prevState || prevState.plugins != this.state.plugins || this.directPlugins != this.prevDirectPlugins) {
            this.prevDirectPlugins = this.directPlugins;
            this.destroyPluginViews();
            for(let i = 0; i < this.directPlugins.length; i++){
                let plugin = this.directPlugins[i];
                if (plugin.spec.view) this.pluginViews.push(plugin.spec.view(this));
            }
            for(let i = 0; i < this.state.plugins.length; i++){
                let plugin = this.state.plugins[i];
                if (plugin.spec.view) this.pluginViews.push(plugin.spec.view(this));
            }
        } else for(let i = 0; i < this.pluginViews.length; i++){
            let pluginView = this.pluginViews[i];
            if (pluginView.update) pluginView.update(this, prevState);
        }
    }
    updateDraggedNode(dragging, prev) {
        let sel = dragging.node, found = -1;
        if (this.state.doc.nodeAt(sel.from) == sel.node) found = sel.from;
        else {
            let movedPos = sel.from + (this.state.doc.content.size - prev.doc.content.size);
            let moved = movedPos > 0 && this.state.doc.nodeAt(movedPos);
            if (moved == sel.node) found = movedPos;
        }
        this.dragging = new $81901ae0222f0506$var$Dragging(dragging.slice, dragging.move, found < 0 ? undefined : (0, $3lIcL.NodeSelection).create(this.state.doc, found));
    }
    someProp(propName, f) {
        let prop = this._props && this._props[propName], value;
        if (prop != null && (value = f ? f(prop) : prop)) return value;
        for(let i = 0; i < this.directPlugins.length; i++){
            let prop = this.directPlugins[i].props[propName];
            if (prop != null && (value = f ? f(prop) : prop)) return value;
        }
        let plugins = this.state.plugins;
        if (plugins) for(let i = 0; i < plugins.length; i++){
            let prop = plugins[i].props[propName];
            if (prop != null && (value = f ? f(prop) : prop)) return value;
        }
    }
    /**
    Query whether the view has focus.
    */ hasFocus() {
        // Work around IE not handling focus correctly if resize handles are shown.
        // If the cursor is inside an element with resize handles, activeElement
        // will be that element instead of this.dom.
        if ($81901ae0222f0506$var$ie) {
            // If activeElement is within this.dom, and there are no other elements
            // setting `contenteditable` to false in between, treat it as focused.
            let node = this.root.activeElement;
            if (node == this.dom) return true;
            if (!node || !this.dom.contains(node)) return false;
            while(node && this.dom != node && this.dom.contains(node)){
                if (node.contentEditable == 'false') return false;
                node = node.parentElement;
            }
            return true;
        }
        return this.root.activeElement == this.dom;
    }
    /**
    Focus the editor.
    */ focus() {
        this.domObserver.stop();
        if (this.editable) $81901ae0222f0506$var$focusPreventScroll(this.dom);
        $81901ae0222f0506$var$selectionToDOM(this);
        this.domObserver.start();
    }
    /**
    Get the document root in which the editor exists. This will
    usually be the top-level `document`, but might be a [shadow
    DOM](https://developer.mozilla.org/en-US/docs/Web/Web_Components/Shadow_DOM)
    root if the editor is inside one.
    */ get root() {
        let cached = this._root;
        if (cached == null) {
            for(let search = this.dom.parentNode; search; search = search.parentNode)if (search.nodeType == 9 || search.nodeType == 11 && search.host) {
                if (!search.getSelection) Object.getPrototypeOf(search).getSelection = ()=>search.ownerDocument.getSelection();
                return this._root = search;
            }
        }
        return cached || document;
    }
    /**
    When an existing editor view is moved to a new document or
    shadow tree, call this to make it recompute its root.
    */ updateRoot() {
        this._root = null;
    }
    /**
    Given a pair of viewport coordinates, return the document
    position that corresponds to them. May return null if the given
    coordinates aren't inside of the editor. When an object is
    returned, its `pos` property is the position nearest to the
    coordinates, and its `inside` property holds the position of the
    inner node that the position falls inside of, or -1 if it is at
    the top level, not in any node.
    */ posAtCoords(coords) {
        return $81901ae0222f0506$var$posAtCoords(this, coords);
    }
    /**
    Returns the viewport rectangle at a given document position.
    `left` and `right` will be the same number, as this returns a
    flat cursor-ish rectangle. If the position is between two things
    that aren't directly adjacent, `side` determines which element
    is used. When < 0, the element before the position is used,
    otherwise the element after.
    */ coordsAtPos(pos, side = 1) {
        return $81901ae0222f0506$var$coordsAtPos(this, pos, side);
    }
    /**
    Find the DOM position that corresponds to the given document
    position. When `side` is negative, find the position as close as
    possible to the content before the position. When positive,
    prefer positions close to the content after the position. When
    zero, prefer as shallow a position as possible.
    
    Note that you should **not** mutate the editor's internal DOM,
    only inspect it (and even that is usually not necessary).
    */ domAtPos(pos, side = 0) {
        return this.docView.domFromPos(pos, side);
    }
    /**
    Find the DOM node that represents the document node after the
    given position. May return `null` when the position doesn't point
    in front of a node or if the node is inside an opaque node view.
    
    This is intended to be able to call things like
    `getBoundingClientRect` on that DOM node. Do **not** mutate the
    editor DOM directly, or add styling this way, since that will be
    immediately overriden by the editor as it redraws the node.
    */ nodeDOM(pos) {
        let desc = this.docView.descAt(pos);
        return desc ? desc.nodeDOM : null;
    }
    /**
    Find the document position that corresponds to a given DOM
    position. (Whenever possible, it is preferable to inspect the
    document structure directly, rather than poking around in the
    DOM, but sometimes—for example when interpreting an event
    target—you don't have a choice.)
    
    The `bias` parameter can be used to influence which side of a DOM
    node to use when the position is inside a leaf node.
    */ posAtDOM(node, offset, bias = -1) {
        let pos = this.docView.posFromDOM(node, offset, bias);
        if (pos == null) throw new RangeError("DOM position not inside the editor");
        return pos;
    }
    /**
    Find out whether the selection is at the end of a textblock when
    moving in a given direction. When, for example, given `"left"`,
    it will return true if moving left from the current cursor
    position would leave that position's parent textblock. Will apply
    to the view's current state by default, but it is possible to
    pass a different state.
    */ endOfTextblock(dir, state) {
        return $81901ae0222f0506$var$endOfTextblock(this, state || this.state, dir);
    }
    /**
    Run the editor's paste logic with the given HTML string. The
    `event`, if given, will be passed to the
    [`handlePaste`](https://prosemirror.net/docs/ref/#view.EditorProps.handlePaste) hook.
    */ pasteHTML(html, event) {
        return $81901ae0222f0506$var$doPaste(this, "", html, false, event || new ClipboardEvent("paste"));
    }
    /**
    Run the editor's paste logic with the given plain-text input.
    */ pasteText(text, event) {
        return $81901ae0222f0506$var$doPaste(this, text, null, true, event || new ClipboardEvent("paste"));
    }
    /**
    Removes the editor from the DOM and destroys all [node
    views](https://prosemirror.net/docs/ref/#view.NodeView).
    */ destroy() {
        if (!this.docView) return;
        $81901ae0222f0506$var$destroyInput(this);
        this.destroyPluginViews();
        if (this.mounted) {
            this.docView.update(this.state.doc, [], $81901ae0222f0506$var$viewDecorations(this), this);
            this.dom.textContent = "";
        } else if (this.dom.parentNode) this.dom.parentNode.removeChild(this.dom);
        this.docView.destroy();
        this.docView = null;
        $81901ae0222f0506$var$clearReusedRange();
    }
    /**
    This is true when the view has been
    [destroyed](https://prosemirror.net/docs/ref/#view.EditorView.destroy) (and thus should not be
    used anymore).
    */ get isDestroyed() {
        return this.docView == null;
    }
    /**
    Used for testing.
    */ dispatchEvent(event) {
        return $81901ae0222f0506$var$dispatchEvent(this, event);
    }
    /**
    Dispatch a transaction. Will call
    [`dispatchTransaction`](https://prosemirror.net/docs/ref/#view.DirectEditorProps.dispatchTransaction)
    when given, and otherwise defaults to applying the transaction to
    the current state and calling
    [`updateState`](https://prosemirror.net/docs/ref/#view.EditorView.updateState) with the result.
    This method is bound to the view instance, so that it can be
    easily passed around.
    */ dispatch(tr) {
        let dispatchTransaction = this._props.dispatchTransaction;
        if (dispatchTransaction) dispatchTransaction.call(this, tr);
        else this.updateState(this.state.apply(tr));
    }
    /**
    @internal
    */ domSelectionRange() {
        let sel = this.domSelection();
        if (!sel) return {
            focusNode: null,
            focusOffset: 0,
            anchorNode: null,
            anchorOffset: 0
        };
        return $81901ae0222f0506$var$safari && this.root.nodeType === 11 && $81901ae0222f0506$var$deepActiveElement(this.dom.ownerDocument) == this.dom && $81901ae0222f0506$var$safariShadowSelectionRange(this, sel) || sel;
    }
    /**
    @internal
    */ domSelection() {
        return this.root.getSelection();
    }
}
function $81901ae0222f0506$var$computeDocDeco(view) {
    let attrs = Object.create(null);
    attrs.class = "ProseMirror";
    attrs.contenteditable = String(view.editable);
    view.someProp("attributes", (value)=>{
        if (typeof value == "function") value = value(view.state);
        if (value) for(let attr in value){
            if (attr == "class") attrs.class += " " + value[attr];
            else if (attr == "style") attrs.style = (attrs.style ? attrs.style + ";" : "") + value[attr];
            else if (!attrs[attr] && attr != "contenteditable" && attr != "nodeName") attrs[attr] = String(value[attr]);
        }
    });
    if (!attrs.translate) attrs.translate = "no";
    return [
        $81901ae0222f0506$export$10e30b733df217ea.node(0, view.state.doc.content.size, attrs)
    ];
}
function $81901ae0222f0506$var$updateCursorWrapper(view) {
    if (view.markCursor) {
        let dom = document.createElement("img");
        dom.className = "ProseMirror-separator";
        dom.setAttribute("mark-placeholder", "true");
        dom.setAttribute("alt", "");
        view.cursorWrapper = {
            dom: dom,
            deco: $81901ae0222f0506$export$10e30b733df217ea.widget(view.state.selection.from, dom, {
                raw: true,
                marks: view.markCursor
            })
        };
    } else view.cursorWrapper = null;
}
function $81901ae0222f0506$var$getEditable(view) {
    return !view.someProp("editable", (value)=>value(view.state) === false);
}
function $81901ae0222f0506$var$selectionContextChanged(sel1, sel2) {
    let depth = Math.min(sel1.$anchor.sharedDepth(sel1.head), sel2.$anchor.sharedDepth(sel2.head));
    return sel1.$anchor.start(depth) != sel2.$anchor.start(depth);
}
function $81901ae0222f0506$var$buildNodeViews(view) {
    let result = Object.create(null);
    function add(obj) {
        for(let prop in obj)if (!Object.prototype.hasOwnProperty.call(result, prop)) result[prop] = obj[prop];
    }
    view.someProp("nodeViews", add);
    view.someProp("markViews", add);
    return result;
}
function $81901ae0222f0506$var$changedNodeViews(a, b) {
    let nA = 0, nB = 0;
    for(let prop in a){
        if (a[prop] != b[prop]) return true;
        nA++;
    }
    for(let _ in b)nB++;
    return nA != nB;
}
function $81901ae0222f0506$var$checkStateComponent(plugin) {
    if (plugin.spec.state || plugin.spec.filterTransaction || plugin.spec.appendTransaction) throw new RangeError("Plugins passed directly to the view must not have a state component");
}

});

parcelRegister("jy3uD", function(module, exports) {

$parcel$export(module.exports, "useProviders", () => $28460a4a7ff5961c$export$e4c19534640d7866);

var $eJOHy = parcelRequire("eJOHy");
const $28460a4a7ff5961c$export$e4c19534640d7866 = ({ editorApi: editorApi, contextIdentifierProvider: contextIdentifierProvider, mediaProvider: mediaProvider, mentionProvider: mentionProvider, cardProvider: cardProvider, emojiProvider: emojiProvider, autoformattingProvider: autoformattingProvider, taskDecisionProvider: taskDecisionProvider })=>{
    (0, $eJOHy.useEffect)(()=>{
        async function setProvider() {
            if (!contextIdentifierProvider) return;
            const provider = await contextIdentifierProvider;
            editorApi?.core?.actions.execute(editorApi?.contextIdentifier?.commands.setProvider({
                contextIdentifierProvider: provider
            }));
        }
        setProvider();
    }, [
        contextIdentifierProvider,
        editorApi
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (mediaProvider) editorApi?.media?.actions.setProvider(mediaProvider);
    }, [
        mediaProvider,
        editorApi
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (mentionProvider) editorApi?.mention?.actions.setProvider(mentionProvider);
    }, [
        mentionProvider,
        editorApi
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (cardProvider) editorApi?.card?.actions.setProvider(cardProvider);
    }, [
        cardProvider,
        editorApi
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (emojiProvider) editorApi?.emoji?.actions.setProvider(emojiProvider);
    }, [
        emojiProvider,
        editorApi
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (autoformattingProvider) editorApi?.customAutoformat?.actions.setProvider(autoformattingProvider);
    }, [
        autoformattingProvider,
        editorApi
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (taskDecisionProvider) editorApi?.taskDecision?.actions.setProvider(taskDecisionProvider);
    }, [
        taskDecisionProvider,
        editorApi
    ]);
};

});

parcelRegister("4wM3w", function(module, exports) {

$parcel$export(module.exports, "getNodesCount", () => $471f23ad30427f69$export$3674f49b2d541ad);
function $471f23ad30427f69$export$3674f49b2d541ad(node) {
    const count = {};
    node.nodesBetween(0, node.nodeSize - 2, (node)=>{
        count[node.type.name] = (count[node.type.name] || 0) + 1;
    });
    return count;
}

});

parcelRegister("i5btK", function(module, exports) {

$parcel$export(module.exports, "RenderTracking", () => $d2210bfe5222be2d$export$fe16de086fea1f5f);

var $eJOHy = parcelRequire("eJOHy");

var $3s8bj = parcelRequire("3s8bj");

var $bMFKb = parcelRequire("bMFKb");

var $4I56P = parcelRequire("4I56P");
function $d2210bfe5222be2d$export$fe16de086fea1f5f(props) {
    const debouncedHandleAnalyticsEvent = (0, $eJOHy.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(props.handleAnalyticsEvent, 500), [
        props.handleAnalyticsEvent
    ]);
    (0, $4I56P.useComponentRenderTracking)({
        onRender: ({ renderCount: renderCount, propsDifference: propsDifference })=>{
            if (!renderCount) return;
            debouncedHandleAnalyticsEvent({
                payload: {
                    action: props.action,
                    actionSubject: props.actionSubject,
                    attributes: {
                        count: renderCount,
                        propsDifference: propsDifference
                    },
                    eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL
                }
            });
        },
        propsDiffingOptions: {
            enabled: true,
            props: props.componentProps,
            propsToIgnore: props.propsToIgnore,
            useShallow: props.useShallow
        },
        zeroBasedCount: true
    });
    return null;
}

});
parcelRegister("4I56P", function(module, exports) {

$parcel$export(module.exports, "useComponentRenderTracking", () => $f04fad825597ef75$export$ebce6d7d8ca67353);

var $eJOHy = parcelRequire("eJOHy");

var $8KLBw = parcelRequire("8KLBw");

var $kBfYv = parcelRequire("kBfYv");
function $f04fad825597ef75$export$ebce6d7d8ca67353({ onRender: onRender, propsDiffingOptions: propsDiffingOptions, zeroBasedCount: zeroBasedCount = true }) {
    const propsRef = (0, $eJOHy.useRef)();
    const renderCountRef = (0, $eJOHy.useRef)(zeroBasedCount ? 0 : 1);
    const { current: componentId } = (0, $eJOHy.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($8KLBw)))());
    (0, $eJOHy.useEffect)(()=>{
        const lastProps = propsRef.current;
        const renderCount = renderCountRef.current;
        let propsDifference;
        if (propsDiffingOptions?.enabled && lastProps) propsDifference = propsDiffingOptions?.useShallow ? (0, $kBfYv.getShallowPropsDifference)(lastProps, propsDiffingOptions.props) : (0, $kBfYv.getPropsDifference)(lastProps, propsDiffingOptions.props, 0, 2, propsDiffingOptions?.propsToIgnore);
        const result = {
            renderCount: renderCount,
            propsDifference: propsDifference,
            componentId: componentId
        };
        onRender(result);
        if (propsDiffingOptions?.enabled) propsRef.current = propsDiffingOptions.props;
        renderCountRef.current = renderCountRef.current + 1;
    }); // No dependencies run on each render
}

});
parcelRegister("kBfYv", function(module, exports) {

$parcel$export(module.exports, "getPropsDifference", () => $fe2c7fa63ac56f38$export$d438af18e3a25d10);
$parcel$export(module.exports, "getShallowPropsDifference", () => $fe2c7fa63ac56f38$export$418b0a935c0a0030);

var $eJOHy = parcelRequire("eJOHy");
const $fe2c7fa63ac56f38$export$74743eda5dda3ccf = Object.keys;
const $fe2c7fa63ac56f38$export$aedd1a2d18cbf42b = (object1, object2)=>{
    const oldKeys = object1 !== null ? $fe2c7fa63ac56f38$export$74743eda5dda3ccf(object1) : [];
    const newKeys = object2 !== null ? $fe2c7fa63ac56f38$export$74743eda5dda3ccf(object2) : [];
    const removed = oldKeys.filter((key)=>!newKeys.includes(key));
    const added = newKeys.filter((key)=>!oldKeys.includes(key));
    const common = oldKeys.filter((key)=>newKeys.includes(key));
    return {
        added: added,
        common: common,
        removed: removed
    };
};
const $fe2c7fa63ac56f38$export$f4c1dafc9df1f03 = (value)=>{
    const valueType = typeof value;
    if (value === null) return 'null';
    else if (value === undefined) return 'undefined';
    else if (valueType === 'string' || valueType === 'number') return value;
    else if (valueType === 'symbol') return value.toString();
    else if (valueType === 'function') return `function:${value.name}`;
    else if (valueType === 'object') return {
        type: 'object',
        keys: Object.keys(value)
    };
};
const $fe2c7fa63ac56f38$export$d438af18e3a25d10 = (object1, object2, curDepth = 0, maxDepth = 2, keysToIgnore = [])=>{
    const { added: added, common: common, removed: removed } = $fe2c7fa63ac56f38$export$aedd1a2d18cbf42b(object1, object2);
    const changed = [];
    common.forEach((key)=>{
        const value1 = object1[key];
        const value2 = object2[key];
        const value1Type = typeof value1;
        const value2Type = typeof value2;
        // Do comparision only if values doesn't match (or reference to same object in memory).
        // Or if key does not exist in keys to ignore.
        if (value1 !== value2 && keysToIgnore.indexOf(key) === -1) {
            // if both key value are objects and not referencing same object in memory.
            //  then get recursive difference.
            if ((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(value1) || (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(value2)) changed.push({
                key: key,
                reactElementChanged: true
            });
            else if (value1Type === 'object' && value2Type === 'object') {
                if (curDepth <= maxDepth) {
                    const difference = $fe2c7fa63ac56f38$export$d438af18e3a25d10(value1, value2, curDepth + 1, maxDepth);
                    changed.push({
                        key: key,
                        difference: difference
                    });
                } else changed.push({
                    key: key,
                    maxDepthReached: true
                });
            } else changed.push({
                key: key,
                oldValue: $fe2c7fa63ac56f38$export$f4c1dafc9df1f03(value1),
                newValue: $fe2c7fa63ac56f38$export$f4c1dafc9df1f03(value2)
            });
        }
    });
    return {
        added: added,
        changed: changed,
        removed: removed
    };
};
const $fe2c7fa63ac56f38$export$418b0a935c0a0030 = (object1, object2)=>{
    const { added: added, common: common, removed: removed } = $fe2c7fa63ac56f38$export$aedd1a2d18cbf42b(object1, object2);
    const changed = common.filter((key)=>object1[key] !== object2[key]);
    return {
        added: added,
        changed: changed,
        removed: removed
    };
};

});



const $96851126f0c152a2$export$646a6982857f2cd5 = 2000;
const $96851126f0c152a2$export$79d7eac6cbb6352d = 3000;
const $96851126f0c152a2$export$7d7bd496a5206996 = 100;

parcelRegister("20Ctl", function(module, exports) {

$parcel$export(module.exports, "fixExcludes", () => $7ef871dfed7bb538$export$ef6c09ff452189fa);
$parcel$export(module.exports, "processPluginsList", () => $7ef871dfed7bb538$export$7265233e78178a4);
$parcel$export(module.exports, "createPMPlugins", () => $7ef871dfed7bb538$export$169329cb2979ef81);
$parcel$export(module.exports, "createErrorReporter", () => $7ef871dfed7bb538$export$e98521bb0cea2db1);

var $hvPOH = parcelRequire("hvPOH");

var $87fb1 = parcelRequire("87fb1");

var $77GEN = parcelRequire("77GEN");
function $7ef871dfed7bb538$export$935d38a2e170d1f3(a, b) {
    return a.rank - b.rank;
}
function $7ef871dfed7bb538$export$ef6c09ff452189fa(marks) {
    const markKeys = Object.keys(marks);
    const markGroups = new Set(markKeys.map((mark)=>marks[mark].group));
    markKeys.forEach((markKey)=>{
        const mark = marks[markKey];
        if (mark.excludes) mark.excludes = mark.excludes.split(' ').filter((group)=>markGroups.has(group)).join(' ');
    });
    return marks;
}
function $7ef871dfed7bb538$export$7265233e78178a4(plugins) {
    /**
	 * First pass to collect pluginsOptions
	 */ const pluginsOptions = plugins.reduce((acc, plugin)=>{
        if (plugin.pluginsOptions) Object.keys(plugin.pluginsOptions).forEach((pluginName)=>{
            if (!acc[pluginName]) acc[pluginName] = [];
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            acc[pluginName].push(plugin.pluginsOptions[pluginName]);
        });
        return acc;
    }, {});
    /**
	 * Process plugins
	 */ return plugins.reduce((acc, plugin)=>{
        if (plugin.pmPlugins) acc.pmPlugins.push(...plugin.pmPlugins(plugin.name ? pluginsOptions[plugin.name] : undefined));
        if (plugin.nodes) acc.nodes.push(...plugin.nodes());
        if (plugin.marks) acc.marks.push(...plugin.marks());
        if (plugin.contentComponent) acc.contentComponents.push(plugin.contentComponent);
        if (plugin.usePluginHook) acc.pluginHooks.push(plugin.usePluginHook);
        if (plugin.primaryToolbarComponent) acc.primaryToolbarComponents.push(plugin.primaryToolbarComponent);
        if (plugin.secondaryToolbarComponent) acc.secondaryToolbarComponents.push(plugin.secondaryToolbarComponent);
        if (plugin.onEditorViewStateUpdated) acc.onEditorViewStateUpdatedCallbacks.push({
            pluginName: plugin.name,
            callback: plugin.onEditorViewStateUpdated
        });
        return acc;
    }, {
        nodes: [],
        marks: [],
        pmPlugins: [],
        contentComponents: [],
        pluginHooks: [],
        primaryToolbarComponents: [],
        secondaryToolbarComponents: [],
        onEditorViewStateUpdatedCallbacks: []
    });
}
function $7ef871dfed7bb538$export$169329cb2979ef81(config) {
    const { editorConfig: editorConfig } = config;
    const pmPlugins = editorConfig.pmPlugins.sort((0, $87fb1.sortByOrder)('plugins')).map(({ plugin: plugin })=>plugin({
            schema: config.schema,
            dispatch: config.dispatch,
            eventDispatcher: config.eventDispatcher,
            providerFactory: config.providerFactory,
            errorReporter: config.errorReporter,
            portalProviderAPI: config.portalProviderAPI,
            nodeViewPortalProviderAPI: config.nodeViewPortalProviderAPI,
            dispatchAnalyticsEvent: config.dispatchAnalyticsEvent,
            featureFlags: config.featureFlags || {},
            getIntl: config.getIntl
        })).filter((plugin)=>typeof plugin !== 'undefined');
    if (config.onEditorStateUpdated !== undefined) return [
        (0, $77GEN.createEditorStateNotificationPlugin)(config.onEditorStateUpdated, config.editorConfig.onEditorViewStateUpdatedCallbacks),
        ...pmPlugins
    ];
    return pmPlugins;
}
function $7ef871dfed7bb538$export$e98521bb0cea2db1(errorReporterHandler) {
    const errorReporter = new (0, $hvPOH.ErrorReporter)();
    if (errorReporterHandler) errorReporter.handler = errorReporterHandler;
    return errorReporter;
}

});
parcelRegister("hvPOH", function(module, exports) {

$parcel$export(module.exports, "ErrorReporter", () => $faec646cd0648651$export$88da0ac32d9c271e);
class $faec646cd0648651$export$88da0ac32d9c271e {
    captureMessage(msg, tags) {
        if (this.handlerStorage) this.handlerStorage.captureMessage(msg, tags);
    }
    captureException(err, tags) {
        if (this.handlerStorage) this.handlerStorage.captureException(err, tags);
    }
    set handler(handler) {
        this.handlerStorage = handler;
    }
    constructor(){
        this.handlerStorage = null;
    }
}

});

parcelRegister("87fb1", function(module, exports) {

$parcel$export(module.exports, "sortByOrder", () => $e9789850f723efcf$export$49afdc3354d5c84e);
$parcel$export(module.exports, "sortByOrderWithTypeName", () => $e9789850f723efcf$export$b4ae7ad1c009d0a1);
// eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
// @deprecated
// @private This rank is not stable and should not be trusted. If you need to change this file, please let the Editor lego team know about it
const $e9789850f723efcf$export$d4a08ec0aa6e0cef = {
    plugins: [
        'featureFlagsContextPlugin',
        'compositionPlugin',
        'inlineCursorTargetPlugin',
        'typeAhead',
        'typeAheadInsertItem',
        'focusHandlerPlugin',
        'frozenEditor',
        'submitEditor',
        'saveOnEnter',
        'customAutoformatting',
        'newlinePreserveMarksPlugin',
        'imageUpload',
        'imageUploadInputRule',
        'clipboard',
        'paste',
        'pasteKeymap',
        'mention',
        'mentionInputRule',
        'mentionKeymap',
        'emoji',
        'placeholderText',
        'emojiInputRule',
        'emojiKeymap',
        'emojiAsciiInputRule',
        'blockType',
        'quickInsert',
        'tasksAndDecisions',
        'blockTypeInputRule',
        'tasksAndDecisionsInputRule',
        'list',
        'typeAheadKeymap',
        'typeAheadInputRule',
        'date',
        'dateKeymap',
        // This should be always after `typeAheadKeymap` & `emojiKeymap`
        'indentationKeymap',
        'textColor',
        'highlight',
        'highlightKeymap',
        'alignmentPlugin',
        'listInputRule',
        'listKeymap',
        'codeBlock',
        'codeBlockIDEKeyBindings',
        'codeBlockKeyMap',
        'textFormatting',
        'textFormattingCursor',
        'textFormattingInputRule',
        'textFormattingSmartRule',
        'textFormattingClear',
        'textFormattingKeymap',
        // task/decisions keymap needs to be above table keymap so can indent actions in a table
        'tasksAndDecisionsKeyMap',
        // expand and table keymaps need to be above selection keymap to add their custom selection behaviour:
        // https://product-fabric.atlassian.net/wiki/spaces/E/pages/1113098008/Selection+Guide#Special-Cases
        'expandKeymap',
        'tableSelectionKeymap',
        'tableKeymap',
        'captionKeymap',
        // media keymap above selection keymap to allow navigating past the mediaSingle node
        'mediaKeymap',
        // selection keymap needs to be above gap cursor keymap so it can set node selections from
        // left/right arrows
        'selectionKeymap',
        'gapCursorKeymap',
        'gapCursor',
        'syncUrlText',
        'fakeCursorToolbarPlugin',
        'hyperLink',
        'table',
        'tableDecorations',
        'hyperlinkInputRule',
        'tablePMColResizing',
        'hyperlinkKeymap',
        'tableColResizing',
        'undoRedoKeyMap',
        'blockTypeKeyMap',
        'tableEditing',
        'filterStepsPlugin',
        'pmCollab',
        'collab',
        'ruleInputRule',
        'ruleKeymap',
        'panel',
        'media',
        'mediaSingleKeymap',
        'mediaEditor',
        'unsupportedContent',
        'jiraIssue',
        'helpDialog',
        'helpDialogKeymap',
        'macro',
        'expand',
        'extension',
        'layout',
        'contextPanel',
        'selectionToolbar',
        'floatingToolbar',
        'clearMarksOnChange',
        'reactNodeView',
        'history',
        'undoRedoPlugin',
        'codeBlockIndent',
        'placeholder',
        'width',
        'maxContentSize',
        'multilineContent',
        'grid',
        'mobileDimensions',
        'scrollGutterPlugin',
        'analytics',
        'findReplace',
        'selection',
        'avatarGroup',
        'viewUpdateSubscription',
        'beforePrimaryToolbar',
        'inlineCode'
    ],
    nodes: [
        'doc',
        'paragraph',
        'text',
        'bulletList',
        'orderedList',
        'listItem',
        'heading',
        'blockquote',
        'codeBlock',
        'rule',
        'panel',
        'mention',
        'confluenceUnsupportedBlock',
        'confluenceUnsupportedInline',
        'unsupportedBlock',
        'unsupportedInline',
        'confluenceJiraIssue',
        'hardBreak',
        'emoji',
        'placeholder',
        'mediaSingle',
        'mediaGroup',
        'table',
        'expand',
        'nestedExpand',
        'media',
        'tableHeader',
        'decisionList',
        'tableRow',
        'decisionItem',
        'tableCell',
        'taskList',
        'taskItem',
        'extension',
        'bodiedExtension',
        'multiBodiedExtension',
        'inlineExtension',
        'layoutSection',
        'layoutColumn',
        'inlineCard',
        'blockCard',
        'embedCard'
    ],
    marks: [
        // Fragment mark is both for inline and block elements
        'fragment',
        // Inline marks
        'link',
        'em',
        'strong',
        'textColor',
        'backgroundColor',
        'strike',
        'subsup',
        'underline',
        'code',
        'typeAheadQuery',
        // Block marks
        'alignment',
        'breakout',
        'indentation',
        'annotation',
        'dataConsumer',
        'border',
        // Unsupported mark
        'unsupportedMark',
        'unsupportedNodeAttribute'
    ]
};
function $e9789850f723efcf$export$49afdc3354d5c84e(item) {
    return function(a, b) {
        return $e9789850f723efcf$export$d4a08ec0aa6e0cef[item].indexOf(a.name) - $e9789850f723efcf$export$d4a08ec0aa6e0cef[item].indexOf(b.name);
    };
}
function $e9789850f723efcf$export$b4ae7ad1c009d0a1(item) {
    return function(a, b) {
        return $e9789850f723efcf$export$d4a08ec0aa6e0cef[item].indexOf(a.type.name) - $e9789850f723efcf$export$d4a08ec0aa6e0cef[item].indexOf(b.type.name);
    };
}

});

parcelRegister("77GEN", function(module, exports) {

$parcel$export(module.exports, "createEditorStateNotificationPlugin", () => $e8e530777077b88e$export$e0355cecc74597d);

var $i8KtF = parcelRequire("i8KtF");

var $3lIcL = parcelRequire("3lIcL");

var $eGOwo = parcelRequire("eGOwo");
const $e8e530777077b88e$var$key = new (0, $3lIcL.PluginKey)('editorStateNotificationPlugin');
const $e8e530777077b88e$export$e0355cecc74597d = (onEditorStateUpdated, onEditorViewStateUpdatedCallbacks)=>{
    let transactions = [];
    return new (0, $i8KtF.SafePlugin)({
        key: $e8e530777077b88e$var$key,
        state: {
            init () {
                return {
                    latestTransaction: undefined
                };
            },
            apply (tr) {
                transactions.push(tr);
                return {
                    latestTransaction: tr
                };
            }
        },
        view: ()=>{
            return {
                update: (view, oldEditorState)=>{
                    const originalTransaction = $e8e530777077b88e$var$key.getState(view.state)?.latestTransaction;
                    if (originalTransaction && (0, $eGOwo.fg)('platform_editor_migrate_state_updates')) {
                        onEditorViewStateUpdatedCallbacks.forEach((entry)=>{
                            entry.callback({
                                originalTransaction: originalTransaction,
                                transactions: transactions,
                                oldEditorState: oldEditorState,
                                newEditorState: view.state
                            });
                        });
                        transactions = [];
                    }
                    onEditorStateUpdated({
                        oldEditorState: oldEditorState,
                        newEditorState: view.state
                    });
                }
            };
        }
    });
};

});
parcelRegister("i8KtF", function(module, exports) {

$parcel$export(module.exports, "SafePlugin", () => $a4dc9f7f39fa0cc1$export$1d44e2741b8f180d);

var $3lIcL = parcelRequire("3lIcL");

var $dcW7A = parcelRequire("dcW7A");
const $a4dc9f7f39fa0cc1$export$286bb6e3f51916b5 = ({ nodeOrMark: nodeOrMark, dom: dom })=>{
    const metadata = (0, $dcW7A.createProseMirrorMetadata)(nodeOrMark);
    Object.entries(metadata).forEach(([name, value])=>{
        dom.setAttribute(name, value);
    });
};
// Wraper to avoid any exception during the get pos operation
// See this https://hello.atlassian.net/wiki/spaces/EDITOR/pages/2849713193/ED-19672+Extensions+Regression
// And this https://discuss.prosemirror.net/t/possible-bug-on-viewdesc-posbeforechild/5783
const $a4dc9f7f39fa0cc1$var$wrapGetPosExceptions = (spec)=>{
    if (!spec?.props?.nodeViews) return spec;
    const unsafeNodeViews = spec.props.nodeViews;
    const safeNodeViews = new Proxy(unsafeNodeViews, {
        get (target, prop, receiver) {
            const safeNodeView = new Proxy(Reflect.get(target, prop, receiver), {
                apply (target, thisArg, argumentsList) {
                    const [node, view, unsafeGetPos, ...more] = argumentsList;
                    const safeGetPos = (()=>{
                        try {
                            return unsafeGetPos();
                        } catch (e) {
                            return;
                        }
                        return;
                    // eslint-disable-next-line no-extra-bind
                    }).bind(thisArg);
                    const result = Reflect.apply(target, thisArg, [
                        node,
                        view,
                        safeGetPos,
                        ...more
                    ]);
                    if (result?.dom instanceof HTMLElement) $a4dc9f7f39fa0cc1$export$286bb6e3f51916b5({
                        nodeOrMark: node,
                        dom: result.dom
                    });
                    return result;
                }
            });
            return safeNodeView;
        }
    });
    spec.props.nodeViews = safeNodeViews;
    return spec;
};
class $a4dc9f7f39fa0cc1$export$1d44e2741b8f180d extends (0, $3lIcL.Plugin) {
    constructor(spec){
        super($a4dc9f7f39fa0cc1$var$wrapGetPosExceptions(spec));
    }
}

});
parcelRegister("dcW7A", function(module, exports) {

$parcel$export(module.exports, "createProseMirrorMetadata", () => $dfff3f43c3f35139$export$3d8be158d19aadd1);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $3xw6l = parcelRequire("3xw6l");
const $dfff3f43c3f35139$var$isPMNode = (nodeOrMark)=>{
    return nodeOrMark instanceof (0, $3xw6l.Node) || Array.isArray(nodeOrMark.marks);
};
const $dfff3f43c3f35139$export$3d8be158d19aadd1 = (nodeOrMark)=>{
    const name = nodeOrMark.type.name;
    const isNode = $dfff3f43c3f35139$var$isPMNode(nodeOrMark);
    const commonAttributes = {
        'data-prosemirror-content-type': isNode ? 'node' : 'mark'
    };
    if (!isNode) return {
        ...commonAttributes,
        ['data-prosemirror-mark-name']: name
    };
    commonAttributes['data-prosemirror-node-name'] = name;
    if (nodeOrMark.type.isBlock) commonAttributes['data-prosemirror-node-block'] = 'true';
    if (nodeOrMark.type.isInline) commonAttributes['data-prosemirror-node-inline'] = 'true';
    return commonAttributes;
};

});




parcelRegister("lAhIB", function(module, exports) {

$parcel$export(module.exports, "getDefaultPresetOptionsFromEditorProps", () => $dd4c359a0cdf2540$export$fdea1e40b8747a5b);
$parcel$export(module.exports, "default", () => $dd4c359a0cdf2540$export$2e2bcd8739ae039);

var $hUQD4 = parcelRequire("hUQD4");

var $7uu4v = parcelRequire("7uu4v");
const $dd4c359a0cdf2540$var$isCodeBlockAllowed = (options)=>{
    const exclude = options && options.allowBlockType && options.allowBlockType.exclude ? options.allowBlockType.exclude : [];
    return exclude.indexOf('codeBlock') === -1;
};
function $dd4c359a0cdf2540$export$f94443780f769f8(props) {
    const { appearance: appearance } = props;
    if ((0, $7uu4v.isFullPage)(appearance)) // Full Page appearance uses a scrollable div wrapper.
    return {
        getScrollElement: ()=>document.querySelector('.fabric-editor-popup-scroll-parent')
    };
    return undefined;
}
function $dd4c359a0cdf2540$export$fdea1e40b8747a5b(props, createAnalyticsEvent) {
    const appearance = props.appearance;
    const cardOptions = props.linking?.smartLinks || props.smartLinks || props.UNSAFE_cards;
    return {
        ...props,
        createAnalyticsEvent: createAnalyticsEvent,
        typeAhead: {
            isMobile: false
        },
        featureFlags: (0, $hUQD4.createFeatureFlagsFromProps)(props.featureFlags),
        paste: {
            cardOptions: cardOptions,
            sanitizePrivateContent: props.sanitizePrivateContent
        },
        base: {
            allowInlineCursorTarget: true,
            allowScrollGutter: $dd4c359a0cdf2540$export$f94443780f769f8(props)
        },
        blockType: {
            lastNodeMustBeParagraph: appearance === 'comment' || appearance === 'chromeless',
            allowBlockType: props.allowBlockType,
            isUndoRedoButtonsEnabled: props.allowUndoRedoButtons
        },
        placeholder: {
            placeholder: props.placeholder,
            placeholderBracketHint: props.placeholderBracketHint
        },
        textFormatting: {
            ...props.textFormatting || {},
            responsiveToolbarMenu: props.textFormatting?.responsiveToolbarMenu != null ? props.textFormatting.responsiveToolbarMenu : props.allowUndoRedoButtons
        },
        submitEditor: props.onSave,
        quickInsert: {
            enableElementBrowser: props.elementBrowser && props.elementBrowser.showModal,
            elementBrowserHelpUrl: props.elementBrowser && props.elementBrowser.helpUrl,
            disableDefaultItems: false,
            headless: false,
            emptyStateHandler: props.elementBrowser && props.elementBrowser.emptyStateHandler,
            prioritySortingFn: props.quickInsert && typeof props.quickInsert !== 'boolean' && props.quickInsert.prioritySortingFn || undefined,
            onInsert: props.quickInsert && typeof props.quickInsert !== 'boolean' && props.quickInsert.onInsert || undefined
        },
        selection: {
            useLongPressSelection: false
        },
        hyperlinkOptions: {
            editorAppearance: props.appearance,
            linkPicker: props.linking?.linkPicker,
            onClickCallback: cardOptions?.onClickCallback,
            platform: 'web'
        },
        codeBlock: {
            ...props.codeBlock,
            useLongPressSelection: false,
            allowCompositionInputOverride: false
        }
    };
}
function $dd4c359a0cdf2540$export$2e2bcd8739ae039(// eslint-disable-next-line @typescript-eslint/no-explicit-any
preset, props, pluginInjectionAPI) {
    const excludes = new Set();
    if (!$dd4c359a0cdf2540$var$isCodeBlockAllowed({
        allowBlockType: props.allowBlockType
    })) excludes.add('codeBlock');
    return preset.build({
        pluginInjectionAPI: pluginInjectionAPI,
        excludePlugins: excludes
    });
}

});

parcelRegister("3bqXX", function(module, exports) {

$parcel$export(module.exports, "createSchema", () => $e8b30a46e98c48b5$export$5f4ce795563f4211);

var $mYA6R = parcelRequire("mYA6R");

var $87fb1 = parcelRequire("87fb1");

var $dcW7A = parcelRequire("dcW7A");

var $3xw6l = parcelRequire("3xw6l");

var $20Ctl = parcelRequire("20Ctl");
const $e8b30a46e98c48b5$export$29c1e593063b23a7 = ({ nodeOrMark: nodeOrMark, domSpec: domSpec })=>{
    if (!Array.isArray(domSpec)) return domSpec;
    const maybeDefinedAttributes = domSpec[1];
    const metadata = (0, $dcW7A.createProseMirrorMetadata)(nodeOrMark);
    const hasDefinedAttributes = typeof maybeDefinedAttributes === 'object' && !Array.isArray(maybeDefinedAttributes);
    if (hasDefinedAttributes) domSpec[1] = Object.assign(maybeDefinedAttributes, metadata);
    else domSpec.splice(1, 0, metadata);
    return domSpec;
};
const $e8b30a46e98c48b5$export$48404bb361c0cbc1 = (toDOM)=>{
    return new Proxy(toDOM, {
        apply (target, thisArg, argumentsList) {
            const domSpec = Reflect.apply(target, thisArg, argumentsList);
            if (!Array.isArray(domSpec)) return domSpec;
            const nodeOrMark = argumentsList[0];
            return $e8b30a46e98c48b5$export$29c1e593063b23a7({
                nodeOrMark: nodeOrMark,
                domSpec: domSpec
            });
        }
    });
};
const $e8b30a46e98c48b5$export$83e999ea28e263f4 = (spec)=>{
    return new Proxy(spec, {
        get (target, prop, receiver) {
            const result = Reflect.get(target, prop, receiver);
            if (prop === 'toDOM' && typeof result === 'function') return $e8b30a46e98c48b5$export$48404bb361c0cbc1(result);
            return result;
        }
    });
};
function $e8b30a46e98c48b5$export$5f4ce795563f4211(editorConfig) {
    const marks = (0, $20Ctl.fixExcludes)(editorConfig.marks.sort((0, $87fb1.sortByOrder)('marks')).reduce((acc, mark)=>{
        acc[mark.name] = $e8b30a46e98c48b5$export$83e999ea28e263f4(mark.mark);
        return acc;
    }, {}));
    const nodes = (0, $mYA6R.sanitizeNodes)(editorConfig.nodes.sort((0, $87fb1.sortByOrder)('nodes')).reduce((acc, node)=>{
        acc[node.name] = $e8b30a46e98c48b5$export$83e999ea28e263f4(node.node);
        return acc;
    }, {}), marks);
    return new (0, $3xw6l.Schema)({
        nodes: nodes,
        marks: marks
    });
}

});

parcelRegister("erdK2", function(module, exports) {

$parcel$export(module.exports, "editorMessages", () => $2286d73db242209a$export$3b488057bfc1868f);

var $7qGN1 = parcelRequire("7qGN1");
const $2286d73db242209a$export$3b488057bfc1868f = (0, $7qGN1.defineMessages)({
    editorAssistiveLabel: {
        id: 'fabric.editor.editorAssistiveLabel',
        defaultMessage: 'Main content area, start typing to enter text.',
        description: 'Text that is read out by screen reader when the main editor is in focus'
    }
});

});

parcelRegister("jGMZf", function(module, exports) {

$parcel$export(module.exports, "focusEditorElement", () => $915a296db7ba8f47$export$32ec9f77297f7957);
function $915a296db7ba8f47$export$32ec9f77297f7957(editorId) {
    const parentElement = document.querySelector(`[data-focus-id="${editorId}"]`);
    if (!(parentElement instanceof HTMLElement)) return;
    parentElement.focus({
        preventScroll: true
    });
}

});

parcelRegister("aHrTy", function(module, exports) {

$parcel$export(module.exports, "getUAPrefix", () => $b5624795138593b4$export$11a24c7b1b4aab81);

var $7EdFW = parcelRequire("7EdFW");
function $b5624795138593b4$export$11a24c7b1b4aab81() {
    if ((0, $7EdFW.browser).chrome) return 'ua-chrome';
    else if ((0, $7EdFW.browser).ie) return 'ua-ie';
    else if ((0, $7EdFW.browser).gecko) return 'ua-firefox';
    else if ((0, $7EdFW.browser).safari) return 'ua-safari';
    return '';
}

});

parcelRegister("YsDKQ", function(module, exports) {

$parcel$export(module.exports, "handleEditorFocus", () => $a4100354ae27cad3$export$ebebb7f5b9271fd7);

var $eJOHy = parcelRequire("eJOHy");

var $3lIcL = parcelRequire("3lIcL");

var $eGOwo = parcelRequire("eGOwo");
function $a4100354ae27cad3$export$ebebb7f5b9271fd7(view) {
    if (view?.hasFocus()) return;
    /**
	 * If startTransition is available (in React 18),
	 * don't use setTimeout as startTransition will be used in ReactEditorViewNext.
	 * setTimeout(fn, 0) will not defer the focus reliably in React 18 with
	 * concurrent rendering.
	 */ const react16OnlySetTimeout = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy)))?.startTransition && (0, $eGOwo.fg)('platform_editor_react_18_autofocus_fix') ? (fn)=>fn() : (fn)=>window.setTimeout(fn, 0);
    return react16OnlySetTimeout(()=>{
        // Due to race conditions during editor lifecycle transitions (e.g. SPA route changes during opening or closing)
        // where the view (and its internal docView) may have been destroyed, the timeout callback may fire on a stale view.
        // Bail out in that scenario to prevent operating on an unmounted view.
        if ((0, $eGOwo.fg)('platform_editor_posfromdom_null_fix')) {
            if (view?.isDestroyed) return;
        }
        if (view?.hasFocus()) return;
        if (!window.getSelection) {
            view?.focus();
            return;
        }
        const domSelection = window.getSelection();
        if (!domSelection || domSelection.rangeCount === 0) {
            view?.focus();
            return;
        }
        const range = domSelection.getRangeAt(0);
        // if selection is outside editor focus and exit
        if (view && range.startContainer.contains(view.dom)) {
            view.focus();
            return;
        }
        // set cursor/selection and focus
        const anchor = view?.posAtDOM(range.startContainer, range.startOffset);
        const head = view?.posAtDOM(range.endContainer, range.endOffset);
        // if anchor or head < 0 focus and exit
        if (anchor && anchor < 0 || head && head < 0) {
            view?.focus();
            return;
        }
        if (view && anchor) {
            const selection = (0, $3lIcL.TextSelection).create(view.state.doc, anchor, head);
            const tr = view.state.tr.setSelection(selection);
            view.dispatch(tr);
            view.focus();
        }
    });
}

});

parcelRegister("l9xeW", function(module, exports) {

$parcel$export(module.exports, "useDispatchTransaction", () => $f8bca0dfb61d7ce4$export$b582387940572fe7);

var $eJOHy = parcelRequire("eJOHy");

var $bMFKb = parcelRequire("bMFKb");
var $jXreb = parcelRequire("jXreb");

var $eh3wX = parcelRequire("eh3wX");

var $eemFN = parcelRequire("eemFN");

var $hvjqZ = parcelRequire("hvjqZ");

var $7e31w = parcelRequire("7e31w");

var $ep3X6 = parcelRequire("ep3X6");

var $kNGyI = parcelRequire("kNGyI");

var $1Jh1r = parcelRequire("1Jh1r");
const $f8bca0dfb61d7ce4$export$b582387940572fe7 = ({ onChange: onChange, dispatchAnalyticsEvent: dispatchAnalyticsEvent, onEditorViewUpdated: onEditorViewUpdated, isRemoteReplaceDocumentTransaction: isRemoteReplaceDocumentTransaction })=>{
    // We need to have a ref to the latest `onChange` since the `dispatchTransaction` gets captured
    const onChangeRef = (0, $eJOHy.useRef)(onChange);
    (0, $eJOHy.useEffect)(()=>{
        onChangeRef.current = onChange;
    }, [
        onChange
    ]);
    const dispatchTransaction = (0, $eJOHy.useCallback)((view, unsafeTransaction)=>{
        if (!view) return;
        const nodes = (0, $7e31w.findChangedNodesFromTransaction)(unsafeTransaction);
        const changedNodesValid = (0, $1Jh1r.validateNodes)(nodes);
        const transaction = new Proxy(unsafeTransaction, (0, $ep3X6.freezeUnsafeTransactionProperties)({
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            pluginKey: 'unknown-reacteditorview'
        }));
        // If the transaction is a remote replaceDocument transaction, we should skip validation.
        // Remote replaceDocument transactions are fired when the document is replaced by initialization of editor-plugin-collab-edit
        // If there is a discrepancy in the ProseMirror schema at initialization, it results in the editor being loaded with no content,
        // giving the user the impression that content has been lost
        const isRemoteReplace = isRemoteReplaceDocumentTransaction ? isRemoteReplaceDocumentTransaction(transaction) : false;
        if (changedNodesValid || isRemoteReplace) {
            const oldEditorState = view.state;
            // go ahead and update the state now we know the transaction is good
            const { state: newEditorState, transactions: transactions } = view.state.applyTransaction(transaction);
            if (newEditorState === oldEditorState) return;
            view.updateState(newEditorState);
            onEditorViewUpdated({
                originalTransaction: transaction,
                transactions: transactions,
                oldEditorState: oldEditorState,
                newEditorState: newEditorState
            });
            if (onChangeRef.current && transaction.docChanged) {
                const source = transaction.getMeta('isRemote') ? 'remote' : 'local';
                const isDirtyChange = (0, $eh3wX.isDirtyTransaction)(transaction);
                (0, $hvjqZ.startMeasure)((0, $kNGyI.EVENT_NAME_ON_CHANGE));
                onChangeRef.current(view, {
                    source: source,
                    isDirtyChange: isDirtyChange
                });
                (0, $hvjqZ.stopMeasure)((0, $kNGyI.EVENT_NAME_ON_CHANGE));
            }
        }
        if (!changedNodesValid) {
            const invalidNodes = nodes.filter((node)=>!(0, $1Jh1r.validNode)(node)).map((node)=>(0, $eemFN.getDocStructure)(node, {
                    compact: true
                }));
            dispatchAnalyticsEvent({
                action: (0, $bMFKb.ACTION).DISPATCHED_INVALID_TRANSACTION,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).EDITOR,
                eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    analyticsEventPayloads: (0, $jXreb.getAnalyticsEventsFromTransaction)(transaction),
                    invalidNodes: invalidNodes,
                    isRemoteReplaceDocumentTransaction: isRemoteReplace
                }
            });
        }
    }, [
        dispatchAnalyticsEvent,
        onEditorViewUpdated,
        isRemoteReplaceDocumentTransaction
    ]);
    return dispatchTransaction;
};

});
parcelRegister("jXreb", function(module, exports) {

$parcel$export(module.exports, "getAnalyticsEventsFromTransaction", () => $e31252f9eb83bc39$export$d9985be1ece4b7ee);

var $ivREi = parcelRequire("ivREi");
function $e31252f9eb83bc39$export$d9985be1ece4b7ee(tr) {
    return tr.steps.filter((step)=>step instanceof (0, $ivREi.AnalyticsStep)).reduce((acc, step)=>[
            ...acc,
            ...step.analyticsEvents
        ], []);
}

});
parcelRegister("ivREi", function(module, exports) {

$parcel$export(module.exports, "AnalyticsStep", () => $d7a4bccb738f760c$export$cc33374693c7fb23);

var $7M3Wu = parcelRequire("7M3Wu");

var $lzEKq = parcelRequire("lzEKq");

var $3xw6l = parcelRequire("3xw6l");
const $d7a4bccb738f760c$export$9126078e8b0f76e4 = 'atlaskit-analytics';
const $d7a4bccb738f760c$export$89a6d622be04d823 = 'atlaskit-analytics-invert';
var $d7a4bccb738f760c$var$HISTORY_ACTIONS = /*#__PURE__*/ function(HISTORY_ACTIONS) {
    HISTORY_ACTIONS["UNDID"] = "undid";
    HISTORY_ACTIONS["REDID"] = "redid";
    return HISTORY_ACTIONS;
}($d7a4bccb738f760c$var$HISTORY_ACTIONS || {});
/** Creates undo event from a normal analytics event */ function $d7a4bccb738f760c$var$createUndoEvent(analyticsEvent) {
    var _analyticsEvent$paylo;
    return {
        ...analyticsEvent,
        payload: {
            action: $d7a4bccb738f760c$var$HISTORY_ACTIONS.UNDID,
            actionSubject: analyticsEvent.payload.actionSubject,
            actionSubjectId: analyticsEvent.payload.action,
            attributes: {
                ...analyticsEvent.payload.attributes,
                actionSubjectId: analyticsEvent.payload.actionSubjectId,
                inputMethod: ((_analyticsEvent$paylo = analyticsEvent.payload.attributes) === null || _analyticsEvent$paylo === void 0 ? void 0 : _analyticsEvent$paylo.inputMethod) || ''
            },
            eventType: 'track'
        }
    };
}
/** Toggles event action between undo & redo */ const $d7a4bccb738f760c$var$toggleEventAction = (analyticsEvent)=>({
        ...analyticsEvent,
        payload: {
            ...analyticsEvent.payload,
            action: analyticsEvent.payload.action === $d7a4bccb738f760c$var$HISTORY_ACTIONS.UNDID ? $d7a4bccb738f760c$var$HISTORY_ACTIONS.REDID : $d7a4bccb738f760c$var$HISTORY_ACTIONS.UNDID
        }
    });
function $d7a4bccb738f760c$var$isHistoryAnalyticsEvent(event) {
    return event.payload.action === $d7a4bccb738f760c$var$HISTORY_ACTIONS.UNDID || event.payload.action === $d7a4bccb738f760c$var$HISTORY_ACTIONS.REDID;
}
class $d7a4bccb738f760c$export$cc33374693c7fb23 extends (0, $lzEKq.Step) {
    constructor(analyticsEvents, actionsToIgnore = [], pos // Used to create the map, prevent splitting history.
    ){
        super();
        (0, $7M3Wu.default)(this, "analyticsEvents", []);
        (0, $7M3Wu.default)(this, "actionsToIgnore", []);
        this.analyticsEvents = analyticsEvents;
        this.actionsToIgnore = actionsToIgnore;
        this.pos = pos;
    }
    /**
   * Generate new undo/redo analytics event when step is inverted
   */ invert() {
        const analyticsEvents = this.analyticsEvents.filter((analyticsEvent)=>this.actionsToIgnore.indexOf(analyticsEvent.payload.action) === -1).map((analyticsEvent)=>{
            if ($d7a4bccb738f760c$var$isHistoryAnalyticsEvent(analyticsEvent)) return $d7a4bccb738f760c$var$toggleEventAction(analyticsEvent);
            else return $d7a4bccb738f760c$var$createUndoEvent(analyticsEvent);
        });
        return new $d7a4bccb738f760c$export$cc33374693c7fb23(analyticsEvents, []);
    }
    apply(doc) {
        return (0, $lzEKq.StepResult).ok(doc);
    }
    map(mapping) {
        let newPos = this.pos;
        if (typeof newPos === 'number') newPos = mapping.map(newPos);
        // Return the same events, this step will never be removed
        return new $d7a4bccb738f760c$export$cc33374693c7fb23(this.analyticsEvents, this.actionsToIgnore, newPos);
    }
    getMap() {
        if (typeof this.pos === 'number') return new (0, $lzEKq.StepMap)([
            this.pos,
            0,
            0
        ]);
        return new (0, $lzEKq.StepMap)([]);
    }
    merge(other) {
        if (other instanceof $d7a4bccb738f760c$export$cc33374693c7fb23) {
            const otherAnalyticsEvents = other.analyticsEvents;
            return new $d7a4bccb738f760c$export$cc33374693c7fb23([
                ...otherAnalyticsEvents,
                ...this.analyticsEvents
            ]);
        }
        return null;
    }
    toJSON() {
        return {
            stepType: $d7a4bccb738f760c$export$9126078e8b0f76e4
        };
    }
    static fromJSON() {
        return new (0, $lzEKq.ReplaceStep)(0, 0, (0, $3xw6l.Slice).empty);
    }
}
/** Register this step with Prosemirror */ (0, $lzEKq.Step).jsonID($d7a4bccb738f760c$export$9126078e8b0f76e4, $d7a4bccb738f760c$export$cc33374693c7fb23);

});


parcelRegister("7e31w", function(module, exports) {

$parcel$export(module.exports, "findChangedNodesFromTransaction", () => $14bf14a539fd661c$export$cdc577fd3f583194);

var $BmspC = parcelRequire("BmspC");

var $eGOwo = parcelRequire("eGOwo");
const $14bf14a539fd661c$export$cdc577fd3f583194 = (tr)=>{
    const nodes = [];
    const steps = tr.steps || [];
    steps.forEach((step)=>{
        step.getMap().forEach((oldStart, oldEnd, newStart, newEnd)=>{
            tr.doc.nodesBetween(newStart, Math.min(newEnd, tr.doc.content.size), (node)=>{
                let nodeToCheck = node;
                if ((0, $eGOwo.fg)('cc_complexit_fe_improve_node_validation')) {
                    const { schema: schema } = tr.selection.$from.doc.type;
                    const parentNode = (0, $BmspC.findParentNode)((node)=>node.type !== schema.nodes.paragraph)(tr.selection);
                    nodeToCheck = parentNode ? parentNode.node : node;
                }
                if (!nodes.find((n)=>n === nodeToCheck)) nodes.push(nodeToCheck);
                return false;
            });
        });
    });
    return nodes;
};

});

parcelRegister("ep3X6", function(module, exports) {

$parcel$export(module.exports, "freezeUnsafeTransactionProperties", () => $35bd4827ea64a1ab$export$668aa008bdae439f);

var $bMFKb = parcelRequire("bMFKb");
const $35bd4827ea64a1ab$export$9f24e92219b6e945 = 'Setting an unsafe property on transaction after dispatch!';
// since selection uses curSelection under the hood, we guard setSelection instead
const $35bd4827ea64a1ab$var$isUnsafeMethod = (prop)=>[
        'setSelection'
    ].includes(prop.toString());
const $35bd4827ea64a1ab$var$isReadOnlyProperty = (prop)=>[
        'doc',
        'docs',
        'steps',
        'selection'
    ].includes(prop.toString());
const $35bd4827ea64a1ab$export$668aa008bdae439f = ({ dispatchAnalyticsEvent: dispatchAnalyticsEvent, pluginKey: pluginKey })=>{
    const isUnsafe = ()=>{
        if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $bMFKb.ACTION).TRANSACTION_MUTATED_AFTER_DISPATCH,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).EDITOR,
            eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL,
            attributes: {
                pluginKey: pluginKey || 'unknown'
            }
        });
        throw new Error($35bd4827ea64a1ab$export$9f24e92219b6e945);
    };
    return {
        get: function(target, prop, receiver) {
            if ($35bd4827ea64a1ab$var$isUnsafeMethod(prop)) isUnsafe();
            return Reflect.get(target, prop, receiver);
        },
        set: function(target, prop, receiver) {
            if ($35bd4827ea64a1ab$var$isReadOnlyProperty(prop)) isUnsafe();
            return Reflect.set(target, prop, receiver);
        }
    };
};

});

parcelRegister("kNGyI", function(module, exports) {

$parcel$export(module.exports, "EVENT_NAME_ON_CHANGE", () => $dfbe61fc04a32540$export$bb82e7cfb8987f35);

var $8LHnV = parcelRequire("8LHnV");

var $hvjqZ = parcelRequire("hvjqZ");

var $hEZNp = parcelRequire("hEZNp");
const $dfbe61fc04a32540$export$5e38f3b295505ec8 = `\u{1F989} EditorView::state::apply`;
const $dfbe61fc04a32540$export$646ca0d076c98ad5 = `\u{1F989} EditorView::updateState`;
const $dfbe61fc04a32540$export$2f488cec9729a7d6 = `\u{1F989} EditorView::onEditorViewStateUpdated`;
const $dfbe61fc04a32540$export$bb82e7cfb8987f35 = `\u{1F989} ReactEditorView::onChange`;
const $dfbe61fc04a32540$export$373baa16b824d295 = `\u{1F989} ReactEditorView::dispatchTransaction`;
const $dfbe61fc04a32540$export$735da5ee20c885d5 = false;
const $dfbe61fc04a32540$var$DEFAULT_SAMPLING_RATE = 100;
const $dfbe61fc04a32540$var$noop = ()=>{};
class $dfbe61fc04a32540$export$7a054319813aafa {
    addMeasureListener(listener) {
        this.measureListeners.push(listener);
    }
    removeMeasureListener(listener) {
        const index = this.measureListeners.indexOf(listener);
        if (index > -1) this.measureListeners.splice(index, 1);
    }
    shouldTrackTransaction(options) {
        const { enabled: trackingEnabled, samplingRate: samplingRate = $dfbe61fc04a32540$var$DEFAULT_SAMPLING_RATE } = options;
        return trackingEnabled && this.dispatchCallCounter === samplingRate;
    }
    constructor(){
        // Counter so we can rate limit the transaction performance tracking
        this.dispatchCallCounter = 0;
        // A map containing the time which measurement starts
        this.measureMap = new Map();
        this.measureListeners = [];
        this.bumpDispatchCounter = (options)=>{
            const { enabled: trackingEnabled, samplingRate: samplingRate = $dfbe61fc04a32540$var$DEFAULT_SAMPLING_RATE } = options;
            if (trackingEnabled) {
                if (this.dispatchCallCounter >= samplingRate) this.dispatchCallCounter = 0;
                this.dispatchCallCounter++;
            }
            return this.dispatchCallCounter;
        };
        this.getMeasureHelpers = (options)=>{
            const { usePerformanceMarks: usePerformanceMarks = $dfbe61fc04a32540$export$735da5ee20c885d5 } = options;
            if (!this.shouldTrackTransaction(options)) return {
                startMeasure: $dfbe61fc04a32540$var$noop,
                stopMeasure: $dfbe61fc04a32540$var$noop
            };
            return {
                startMeasure: usePerformanceMarks ? (0, $hvjqZ.startMeasure) : this.startMeasureSimple,
                stopMeasure: usePerformanceMarks ? (0, $hvjqZ.stopMeasure) : this.stopMeasureSimple
            };
        };
        this.startMeasureSimple = (measureName)=>{
            if (!(0, $8LHnV.isPerformanceAPIAvailable)()) return;
            this.measureMap.set(measureName, performance.now());
        };
        this.stopMeasureSimple = (measureName, onMeasureComplete)=>{
            if (!(0, $8LHnV.isPerformanceAPIAvailable)()) return;
            const startTime = this.measureMap.get(measureName);
            if (startTime) {
                const duration = (0, $hEZNp.getTimeSince)(startTime);
                this.measureMap.delete(measureName);
                if (onMeasureComplete) onMeasureComplete(duration, startTime);
                // Call each subscribed listener
                this.measureListeners.forEach((listener)=>listener({
                        name: measureName,
                        duration: duration,
                        startTime: startTime
                    }));
            }
        };
    }
}

});
parcelRegister("hEZNp", function(module, exports) {

$parcel$export(module.exports, "getTimeSince", () => $53d5d7ad4b40db71$export$a26b90db2c8f1b97);
/**
 * Calculate the difference between performance.now() and the given startTime.
 * This allows for the timing to be overridable during tests.
 *
 * @param startTime DOMHighResTimeStamp
 * @returns DOMHighResTimeStamp
 */ const $53d5d7ad4b40db71$export$a26b90db2c8f1b97 = (startTime)=>performance.now() - startTime;

});


parcelRegister("1Jh1r", function(module, exports) {

$parcel$export(module.exports, "validNode", () => $04d4fe46b198d691$export$4c39e41e39b3c449);
$parcel$export(module.exports, "validateNodes", () => $04d4fe46b198d691$export$996213f7c272fc6f);

var $3xw6l = parcelRequire("3xw6l");

var $92xoS = parcelRequire("92xoS");
// We don't want to use memoize from lodash, because we need to use WeakMap or WeakSet
// to avoid memory leaks, but lodash allow to change the cache type only globally
// like `memoize.Cache = WeakMap`, and we don't want to do that.
// So we use our own cache implementation.
const $04d4fe46b198d691$var$cache = new WeakSet();
// See https://github.com/ProseMirror/prosemirror-model/blob/20d26c9843d6a69a1d417d937c401537ee0b2342/src/node.ts#L303
function $04d4fe46b198d691$var$checkNode(node) {
    if ($04d4fe46b198d691$var$cache.has(node)) return;
    // @ts-expect-error - This is internal ProseMirror API, but we okay with it
    node.type.checkContent(node.content);
    // @ts-expect-error - This is internal ProseMirror API, but we okay with it
    node.type.checkAttrs(node.attrs);
    let copy = (0, $3xw6l.Mark).none;
    for(let i = 0; i < node.marks.length; i++){
        const mark = node.marks[i];
        // @ts-expect-error - This is internal ProseMirror API, but we okay with it
        mark.type.checkAttrs(mark.attrs);
        copy = mark.addToSet(copy);
    }
    if (!(0, $3xw6l.Mark).sameSet(copy, node.marks)) throw new RangeError(`Invalid collection of marks for node ${node.type.name}: ${node.marks.map((m)=>m.type.name)}`);
    node.content.forEach((node)=>$04d4fe46b198d691$var$checkNode(node));
    // The set value should be added in the end of the function,
    // because any previous check can throw an error,
    // and we don't want to add invalid node to the cache.
    $04d4fe46b198d691$var$cache.add(node);
}
const $04d4fe46b198d691$export$4c39e41e39b3c449 = (node)=>{
    try {
        if ((0, $92xoS.editorExperiment)('platform_editor_memoized_node_check', true, {
            exposure: true
        })) $04d4fe46b198d691$var$checkNode(node);
        else node.check();
    } catch (error) {
        return false;
    }
    return true;
};
const $04d4fe46b198d691$export$996213f7c272fc6f = (nodes)=>nodes.every($04d4fe46b198d691$export$4c39e41e39b3c449);

});


parcelRegister("2afhI", function(module, exports) {

$parcel$export(module.exports, "useFireFullWidthEvent", () => $11dfe5e8679f5a9d$export$4998b7b36606f9c3);

var $eJOHy = parcelRequire("eJOHy");

var $bMFKb = parcelRequire("bMFKb");

var $5ZVTg = parcelRequire("5ZVTg");

var $dHHo1 = parcelRequire("dHHo1");
const $11dfe5e8679f5a9d$export$4998b7b36606f9c3 = (appearance, dispatchAnalyticsEvent)=>{
    const previousAppearance = (0, $5ZVTg.default)(appearance);
    (0, $eJOHy.useEffect)(()=>{
        if (appearance !== previousAppearance) {
            if (appearance === 'full-width' || previousAppearance === 'full-width') dispatchAnalyticsEvent({
                action: (0, $bMFKb.ACTION).CHANGED_FULL_WIDTH_MODE,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).EDITOR,
                eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
                attributes: {
                    previousMode: (0, $dHHo1.formatFullWidthAppearance)(previousAppearance),
                    newMode: (0, $dHHo1.formatFullWidthAppearance)(appearance)
                }
            });
        }
    }, [
        appearance,
        previousAppearance,
        dispatchAnalyticsEvent
    ]);
};

});
parcelRegister("dHHo1", function(module, exports) {

$parcel$export(module.exports, "formatFullWidthAppearance", () => $1f21fdcc124e6848$export$47d5b79f3ddf0b92);

var $8MfCL = parcelRequire("8MfCL");
const $1f21fdcc124e6848$export$47d5b79f3ddf0b92 = (appearance)=>{
    if (appearance === 'full-width') return (0, $8MfCL.FULL_WIDTH_MODE).FULL_WIDTH;
    return (0, $8MfCL.FULL_WIDTH_MODE).FIXED_WIDTH;
};

});



parcelRegister("6HxkX", function(module, exports) {

$parcel$export(module.exports, "IntlProviderIfMissingWrapper", () => $b65d45e9e05c381b$export$742fe272b8921eea);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $6YFG2 = parcelRequire("6YFG2");
var $4nehu = parcelRequire("4nehu");
const $b65d45e9e05c381b$var$useCheckIntlContext = ()=>(0, $eJOHy.useContext)((0, $6YFG2.Context)) === null;
function $b65d45e9e05c381b$export$742fe272b8921eea({ children: children }) {
    const missingIntlContext = $b65d45e9e05c381b$var$useCheckIntlContext();
    if (missingIntlContext) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4nehu.default), {
        locale: "en",
        children: children
    });
    return children;
}

});

parcelRegister("gk7i7", function(module, exports) {

$parcel$export(module.exports, "BaseThemeWrapper", () => $da9fa5a563d178aa$export$3de34996b814f0f0);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $loabE = parcelRequire("loabE");

var $7yBx7 = parcelRequire("7yBx7");
// Default value from: `import { fontSize } from '@atlaskit/theme/constants';`
const $da9fa5a563d178aa$var$defaultFontSize = 14;
function $da9fa5a563d178aa$export$3de34996b814f0f0({ baseFontSize: baseFontSize, children: children }) {
    const memoizedTheme = (0, $eJOHy.useMemo)(()=>({
            baseFontSize: baseFontSize || $da9fa5a563d178aa$var$defaultFontSize,
            layoutMaxWidth: (0, $7yBx7.akEditorDefaultLayoutWidth)
        }), [
        baseFontSize
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $loabE.a), {
        theme: memoizedTheme,
        children: children
    });
}

});

parcelRegister("dLePd", function(module, exports) {

$parcel$export(module.exports, "getBaseFontSize", () => $94ef00ed687838d3$export$8e2864079bc476bd);

var $7yBx7 = parcelRequire("7yBx7");
function $94ef00ed687838d3$export$8e2864079bc476bd(appearance) {
    if (appearance === undefined) return 0, $7yBx7.akEditorFullPageDefaultFontSize;
    return ![
        'comment',
        'chromeless'
    ].includes(appearance) ? (0, $7yBx7.akEditorFullPageDefaultFontSize) : undefined;
}

});


parcelRegister("1PCVi", function(module, exports) {

$parcel$export(module.exports, "default", () => $b11c9a982109a0ee$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $bMFKb = parcelRequire("bMFKb");

var $hvjqZ = parcelRequire("hvjqZ");

var $1ZFgR = parcelRequire("1ZFgR");

var $fwDw9 = parcelRequire("fwDw9");

var $iPrw3 = parcelRequire("iPrw3");
function $b11c9a982109a0ee$export$2e2bcd8739ae039(props, createAnalyticsEvent) {
    (0, $iPrw3.default)();
    (0, $eJOHy.useEffect)(()=>{
        (0, $hvjqZ.stopMeasure)((0, $1ZFgR.default).EDITOR_MOUNTED, (0, $fwDw9.default)((0, $bMFKb.ACTION).EDITOR_MOUNTED, props, createAnalyticsEvent));
        return ()=>{
            (0, $hvjqZ.clearMeasure)((0, $1ZFgR.default).EDITOR_MOUNTED);
            (0, $hvjqZ.clearMeasure)((0, $1ZFgR.default).ON_EDITOR_READY_CALLBACK);
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
// Disable Exhaustive Deps here since we only want to stop the measure on mount.
}

});
parcelRegister("fwDw9", function(module, exports) {

$parcel$export(module.exports, "default", () => $95a6074d616ca448$export$2e2bcd8739ae039);

var $bMFKb = parcelRequire("bMFKb");
var $cd124 = parcelRequire("cd124");
function $95a6074d616ca448$export$2e2bcd8739ae039(action, props, createAnalyticsEvent) {
    return async (duration, startTime)=>{
        const contextIdentifier = await props.contextIdentifierProvider;
        const objectId = contextIdentifier?.objectId;
        if (createAnalyticsEvent) (0, $cd124.fireAnalyticsEvent)(createAnalyticsEvent)({
            payload: {
                action: action,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).EDITOR,
                attributes: {
                    duration: duration,
                    startTime: startTime,
                    objectId: objectId
                },
                eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL
            }
        });
    };
}

});

parcelRegister("iPrw3", function(module, exports) {

$parcel$export(module.exports, "default", () => $500d5897eb76031a$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $2Kn3g = parcelRequire("2Kn3g");

var $hvjqZ = parcelRequire("hvjqZ");

var $1ZFgR = parcelRequire("1ZFgR");
function $500d5897eb76031a$export$2e2bcd8739ae039() {
    (0, $2Kn3g.default)(()=>{
        (0, $hvjqZ.startMeasure)((0, $1ZFgR.default).EDITOR_MOUNTED);
    });
}

});


parcelRegister("1NJcR", function(module, exports) {

$parcel$export(module.exports, "default", () => $237036b9f5e87f96$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
const $237036b9f5e87f96$export$d9d7e48a5f16fb4d = (passedProps)=>{
    const memodProps = (0, $eJOHy.useMemo)(()=>{
        // That sounds awful but this is the only way to make sure we didn't missed any EditorProps
        const allProps = {
            preset: passedProps.preset,
            appearance: passedProps.appearance,
            contentComponents: passedProps.contentComponents,
            primaryToolbarIconBefore: passedProps.primaryToolbarIconBefore,
            secondaryToolbarComponents: passedProps.secondaryToolbarComponents,
            persistScrollGutter: passedProps.persistScrollGutter,
            quickInsert: passedProps.quickInsert,
            shouldFocus: passedProps.shouldFocus,
            disabled: passedProps.disabled,
            contextPanel: passedProps.contextPanel,
            errorReporterHandler: passedProps.errorReporterHandler,
            contentTransformerProvider: passedProps.contentTransformerProvider,
            maxHeight: passedProps.maxHeight,
            minHeight: passedProps.minHeight,
            placeholder: passedProps.placeholder,
            placeholderBracketHint: passedProps.placeholderBracketHint,
            defaultValue: passedProps.defaultValue,
            assistiveLabel: passedProps.assistiveLabel,
            assistiveDescribedBy: passedProps.assistiveDescribedBy,
            popupsMountPoint: passedProps.popupsMountPoint,
            popupsBoundariesElement: passedProps.popupsBoundariesElement,
            popupsScrollableElement: passedProps.popupsScrollableElement,
            editorActions: passedProps.editorActions,
            onEditorReady: passedProps.onEditorReady,
            onDestroy: passedProps.onDestroy,
            onChange: passedProps.onChange,
            onCancel: passedProps.onCancel,
            extensionProviders: passedProps.extensionProviders,
            UNSAFE_useAnalyticsContext: passedProps.UNSAFE_useAnalyticsContext,
            useStickyToolbar: passedProps.useStickyToolbar,
            featureFlags: passedProps.featureFlags,
            onSave: passedProps.onSave,
            sanitizePrivateContent: passedProps.sanitizePrivateContent,
            media: passedProps.media,
            collabEdit: passedProps.collabEdit,
            primaryToolbarComponents: passedProps.primaryToolbarComponents,
            performanceTracking: passedProps.performanceTracking,
            inputSamplingLimit: passedProps.inputSamplingLimit,
            allowUndoRedoButtons: passedProps.allowUndoRedoButtons,
            linking: passedProps.linking,
            activityProvider: passedProps.activityProvider,
            searchProvider: passedProps.searchProvider,
            annotationProviders: passedProps.annotationProviders,
            collabEditProvider: passedProps.collabEditProvider,
            presenceProvider: passedProps.presenceProvider,
            emojiProvider: passedProps.emojiProvider,
            taskDecisionProvider: passedProps.taskDecisionProvider,
            legacyImageUploadProvider: passedProps.legacyImageUploadProvider,
            mentionProvider: passedProps.mentionProvider,
            autoformattingProvider: passedProps.autoformattingProvider,
            macroProvider: passedProps.macroProvider,
            contextIdentifierProvider: passedProps.contextIdentifierProvider,
            allowExpand: passedProps.allowExpand,
            allowNestedTasks: passedProps.allowNestedTasks,
            allowBlockType: passedProps.allowBlockType,
            allowTasksAndDecisions: passedProps.allowTasksAndDecisions,
            allowBreakout: passedProps.allowBreakout,
            allowRule: passedProps.allowRule,
            allowHelpDialog: passedProps.allowHelpDialog,
            allowPanel: passedProps.allowPanel,
            allowExtension: passedProps.allowExtension,
            allowConfluenceInlineComment: passedProps.allowConfluenceInlineComment,
            allowTemplatePlaceholders: passedProps.allowTemplatePlaceholders,
            allowDate: passedProps.allowDate,
            allowLayouts: passedProps.allowLayouts,
            allowStatus: passedProps.allowStatus,
            allowTextAlignment: passedProps.allowTextAlignment,
            allowIndentation: passedProps.allowIndentation,
            showIndentationButtons: passedProps.showIndentationButtons,
            allowFindReplace: passedProps.allowFindReplace,
            allowBorderMark: passedProps.allowBorderMark,
            allowFragmentMark: passedProps.allowFragmentMark,
            autoScrollIntoView: passedProps.autoScrollIntoView,
            elementBrowser: passedProps.elementBrowser,
            maxContentSize: passedProps.maxContentSize,
            saveOnEnter: passedProps.saveOnEnter,
            feedbackInfo: passedProps.feedbackInfo,
            mention: passedProps.mention,
            mentionInsertDisplayName: passedProps.mentionInsertDisplayName,
            uploadErrorHandler: passedProps.uploadErrorHandler,
            waitForMediaUpload: passedProps.waitForMediaUpload,
            extensionHandlers: passedProps.extensionHandlers,
            allowTextColor: passedProps.allowTextColor,
            allowTables: passedProps.allowTables,
            insertMenuItems: passedProps.insertMenuItems,
            UNSAFE_cards: passedProps.UNSAFE_cards,
            smartLinks: passedProps.smartLinks,
            allowAnalyticsGASV3: passedProps.allowAnalyticsGASV3,
            codeBlock: passedProps.codeBlock,
            textFormatting: passedProps.textFormatting,
            __livePage: passedProps.__livePage,
            AppearanceComponent: passedProps.AppearanceComponent,
            skipValidation: passedProps.skipValidation
        };
        const defaultProps = {
            appearance: 'comment',
            disabled: false,
            quickInsert: true
        };
        const nextProps = {
            ...defaultProps,
            ...allProps
        };
        return nextProps;
    }, [
        passedProps.preset,
        passedProps.appearance,
        passedProps.contentComponents,
        passedProps.primaryToolbarIconBefore,
        passedProps.secondaryToolbarComponents,
        passedProps.persistScrollGutter,
        passedProps.quickInsert,
        passedProps.shouldFocus,
        passedProps.disabled,
        passedProps.contextPanel,
        passedProps.errorReporterHandler,
        passedProps.contentTransformerProvider,
        passedProps.maxHeight,
        passedProps.minHeight,
        passedProps.placeholder,
        passedProps.placeholderBracketHint,
        passedProps.performanceTracking,
        passedProps.inputSamplingLimit,
        passedProps.defaultValue,
        passedProps.assistiveLabel,
        passedProps.assistiveDescribedBy,
        passedProps.popupsMountPoint,
        passedProps.popupsBoundariesElement,
        passedProps.popupsScrollableElement,
        passedProps.editorActions,
        passedProps.onEditorReady,
        passedProps.onDestroy,
        passedProps.onChange,
        passedProps.onCancel,
        passedProps.extensionProviders,
        passedProps.UNSAFE_useAnalyticsContext,
        passedProps.useStickyToolbar,
        passedProps.featureFlags,
        passedProps.onSave,
        passedProps.sanitizePrivateContent,
        passedProps.media,
        passedProps.collabEdit,
        passedProps.primaryToolbarComponents,
        passedProps.allowUndoRedoButtons,
        passedProps.linking,
        passedProps.activityProvider,
        passedProps.searchProvider,
        passedProps.annotationProviders,
        passedProps.collabEditProvider,
        passedProps.presenceProvider,
        passedProps.emojiProvider,
        passedProps.taskDecisionProvider,
        passedProps.legacyImageUploadProvider,
        passedProps.mentionProvider,
        passedProps.autoformattingProvider,
        passedProps.macroProvider,
        passedProps.contextIdentifierProvider,
        passedProps.allowExpand,
        passedProps.allowNestedTasks,
        passedProps.allowBlockType,
        passedProps.allowTasksAndDecisions,
        passedProps.allowBreakout,
        passedProps.allowRule,
        passedProps.allowHelpDialog,
        passedProps.allowPanel,
        passedProps.allowExtension,
        passedProps.allowConfluenceInlineComment,
        passedProps.allowTemplatePlaceholders,
        passedProps.allowDate,
        passedProps.allowLayouts,
        passedProps.allowStatus,
        passedProps.allowTextAlignment,
        passedProps.allowIndentation,
        passedProps.showIndentationButtons,
        passedProps.allowFindReplace,
        passedProps.allowBorderMark,
        passedProps.allowFragmentMark,
        passedProps.autoScrollIntoView,
        passedProps.elementBrowser,
        passedProps.maxContentSize,
        passedProps.saveOnEnter,
        passedProps.feedbackInfo,
        passedProps.mention,
        passedProps.mentionInsertDisplayName,
        passedProps.uploadErrorHandler,
        passedProps.waitForMediaUpload,
        passedProps.extensionHandlers,
        passedProps.allowTextColor,
        passedProps.allowTables,
        passedProps.insertMenuItems,
        passedProps.UNSAFE_cards,
        passedProps.smartLinks,
        passedProps.allowAnalyticsGASV3,
        passedProps.codeBlock,
        passedProps.textFormatting,
        passedProps.__livePage,
        passedProps.AppearanceComponent,
        passedProps.skipValidation
    ]);
    return memodProps;
};
var $237036b9f5e87f96$export$2e2bcd8739ae039 = $237036b9f5e87f96$export$d9d7e48a5f16fb4d;

});

parcelRegister("fy7ur", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8f673fa8ed7b638$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1RDZV = parcelRequire("1RDZV");

var $daFj4 = parcelRequire("daFj4");

var $anjtc = parcelRequire("anjtc");

var $cenXl = parcelRequire("cenXl");

var $aipJ3 = parcelRequire("aipJ3");
function $e8f673fa8ed7b638$var$useEditorRef(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
preset) {
    const apiRef = (0, $eJOHy.useRef)();
    (0, $eJOHy.useEffect)(()=>{
        return preset?.apiResolver.on((api)=>{
            apiRef.current = api;
        });
    }, [
        preset?.apiResolver
    ]);
    return apiRef;
}
function $e8f673fa8ed7b638$var$prepareProviders(editorActions, apiRef, quickInsert, extensionProviders, createAnalyticsEvent) {
    const extensionProvider = (0, $daFj4.default)(()=>editorActions)(extensionProviders);
    const quickInsertProvider = (0, $anjtc.default)(editorActions, apiRef, extensionProvider, quickInsert, createAnalyticsEvent);
    return {
        extensionProvider: extensionProvider,
        quickInsertProvider: quickInsertProvider
    };
}
function $e8f673fa8ed7b638$export$2e2bcd8739ae039(props, editorActions, createAnalyticsEvent) {
    const { autoformattingProvider: autoformattingProvider, emojiProvider: emojiProvider, mentionProvider: mentionProvider, legacyImageUploadProvider: legacyImageUploadProvider, taskDecisionProvider: taskDecisionProvider, contextIdentifierProvider: contextIdentifierProvider, searchProvider: searchProvider, macroProvider: macroProvider, activityProvider: activityProvider, collabEdit: collabEdit, collabEditProvider: collabEditProvider, presenceProvider: presenceProvider, quickInsert: quickInsert, extensionProviders: extensionProviders } = props;
    const providers = (0, $eJOHy.useMemo)(()=>(0, $cenXl.default)({
            autoformattingProvider: autoformattingProvider,
            emojiProvider: emojiProvider,
            mentionProvider: mentionProvider,
            legacyImageUploadProvider: legacyImageUploadProvider,
            taskDecisionProvider: taskDecisionProvider,
            contextIdentifierProvider: contextIdentifierProvider,
            searchProvider: searchProvider,
            macroProvider: macroProvider,
            activityProvider: activityProvider,
            collabEdit: collabEdit,
            collabEditProvider: collabEditProvider,
            presenceProvider: presenceProvider
        }), [
        autoformattingProvider,
        emojiProvider,
        mentionProvider,
        legacyImageUploadProvider,
        taskDecisionProvider,
        contextIdentifierProvider,
        searchProvider,
        macroProvider,
        activityProvider,
        collabEdit,
        collabEditProvider,
        presenceProvider
    ]);
    const providerFactory = (0, $eJOHy.useRef)(new (0, $1RDZV.default)());
    const editorRef = $e8f673fa8ed7b638$var$useEditorRef(props.preset);
    const preparedProviders = (0, $eJOHy.useMemo)(()=>// Though this will introduce some performance regression related to quick insert
        // loading but we can remove it soon when Forge will move to new API.
        // quickInsert={Promise.resolve(consumerQuickInsert)} is one of the main reason behind this performance issue.
        $e8f673fa8ed7b638$var$prepareProviders(editorActions, editorRef, quickInsert, extensionProviders, createAnalyticsEvent), [
        extensionProviders,
        quickInsert,
        editorActions,
        createAnalyticsEvent,
        editorRef
    ]);
    (0, $eJOHy.useEffect)(()=>{
        (0, $aipJ3.default)(providerFactory.current, providers, preparedProviders.extensionProvider, preparedProviders.quickInsertProvider);
    }, [
        providers,
        preparedProviders
    ]);
    // componentWillUnmount equivalent
    (0, $eJOHy.useEffect)(()=>{
        return ()=>{
            // Disable this next line because it is not a React node
            // so we can safely call destroy on the ref.
            // eslint-disable-next-line react-hooks/exhaustive-deps
            providerFactory.current.destroy();
        };
    }, []);
    return providerFactory.current;
}

});
parcelRegister("daFj4", function(module, exports) {

$parcel$export(module.exports, "default", () => $2801c4168a8fcca6$export$2e2bcd8739ae039);

var $LFmXM = parcelRequire("LFmXM");

var $6m9OE = parcelRequire("6m9OE");
function $2801c4168a8fcca6$var$prepareExtensionProvidersInternal(editorActions, extensionProviders) {
    if (!extensionProviders) return;
    if (typeof extensionProviders === 'function') return (0, $6m9OE.default)(extensionProviders(editorActions));
    return (0, $6m9OE.default)(extensionProviders);
}
const $2801c4168a8fcca6$var$prepareExtensionProvider = (getEditorActions)=>(0, $LFmXM.default)((extensionProviders)=>$2801c4168a8fcca6$var$prepareExtensionProvidersInternal(getEditorActions(), extensionProviders));
var $2801c4168a8fcca6$export$2e2bcd8739ae039 = $2801c4168a8fcca6$var$prepareExtensionProvider;

});
parcelRegister("6m9OE", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1566159a1e1f037$export$2e2bcd8739ae039);

var $alidL = parcelRequire("alidL");
var /**
 * Allow to run methods from the `ExtensionProvider` interface across all providers seamlessly.
 * This handles promise racing and discards rejected promises safely.
 */ $d1566159a1e1f037$export$2e2bcd8739ae039 = (extensionProviders)=>{
    let providersCache = [];
    const { invokeSingle: invokeSingle, invokeList: invokeList } = (0, $alidL.default)(extensionProviders);
    return {
        getExtensions () {
            return invokeList('getExtensions');
        },
        async preload () {
            if (providersCache.length === 0) providersCache = await Promise.all(extensionProviders.map((provider)=>Promise.resolve(provider)));
            await Promise.all(providersCache.map((provider)=>provider?.preload?.()));
        },
        getPreloadedExtension (type, key) {
            if (providersCache.length === 0) // preload() has not been called yet
            return;
            for (const provider of providersCache)try {
                const result = provider?.getPreloadedExtension?.(type, key);
                if (result) return result;
            } catch  {
            // Not every provider will implement this method.
            // In that case we would get error from other providers in the loop
            // and undefined from that particular provider.
            // We can safely ignore it and fallback to the async getExtension when nothing was found.
            }
        },
        getExtension (type, key) {
            return invokeSingle('getExtension', [
                type,
                key
            ]);
        },
        search (keyword) {
            return invokeList('search', [
                keyword
            ]);
        },
        getAutoConverter () {
            return invokeList('getAutoConverter');
        }
    };
};

});
parcelRegister("alidL", function(module, exports) {

$parcel$export(module.exports, "default", () => $27e5a5983c1dac74$export$2e2bcd8739ae039);

var $8eFx0 = parcelRequire("8eFx0");
const $27e5a5983c1dac74$var$flatten = (arr)=>[].concat(...arr);
var /**
 * Allow to run methods from the given provider interface across all providers seamlessly.
 * Handles promise racing and discards rejected promises safely.
 */ $27e5a5983c1dac74$export$2e2bcd8739ae039 = (providers)=>{
    if (providers.length === 0) throw new Error('At least one provider must be provided');
    const getFulfilledProviders = async ()=>{
        const results = await (0, $8eFx0.waitForAllPromises)(providers.map((result)=>Promise.resolve(result)));
        return (0, $8eFx0.getOnlyFulfilled)(results);
    };
    const runInAllProviders = async (mapFunction)=>{
        return (await getFulfilledProviders()).map((provider)=>mapFunction(provider));
    };
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const createCallback = (methodName, args)=>(provider)=>{
            const method = provider[methodName];
            if (typeof method === 'function') return method.apply(provider, args);
            throw new Error(`"${String(methodName)}" isn't a function of the provider`);
        };
    /**
	 * Run a method from the provider which expects to return a single item
	 * @param methodName
	 * @param args
	 */ // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const invokeSingle = async (methodName, args)=>{
        const callback = createCallback(methodName, args);
        return (0, $8eFx0.waitForFirstFulfilledPromise)(await runInAllProviders(callback));
    };
    /**
	 * Run a method in the provider which expectes to return a list of items
	 * @param methodName
	 * @param args
	 */ // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const invokeList = async (methodName, args)=>{
        const callback = createCallback(methodName, args);
        const results = await (0, $8eFx0.waitForAllPromises)(await runInAllProviders(callback));
        const fulfilledResults = (0, $8eFx0.getOnlyFulfilled)(results);
        return $27e5a5983c1dac74$var$flatten(fulfilledResults).filter((result)=>result);
    };
    return {
        invokeSingle: invokeSingle,
        invokeList: invokeList
    };
};

});
parcelRegister("8eFx0", function(module, exports) {

$parcel$export(module.exports, "waitForAllPromises", () => $bdae55c7b39f1d12$export$b43fdcffd84b7b0f);
$parcel$export(module.exports, "waitForFirstFulfilledPromise", () => $bdae55c7b39f1d12$export$cb8861b0e3f3dd6f);
$parcel$export(module.exports, "getOnlyFulfilled", () => $bdae55c7b39f1d12$export$b7581cbf0e22e36b);
var $bdae55c7b39f1d12$export$7103a54af3e45080 = /*#__PURE__*/ function(ResultStatus) {
    ResultStatus["FULFILLED"] = "fulfilled";
    ResultStatus["FAILED"] = "failed";
    return ResultStatus;
}({});
const $bdae55c7b39f1d12$var$isFullfilled = (result)=>result.status === "fulfilled";
const $bdae55c7b39f1d12$var$markFullfilled = (value)=>({
        status: "fulfilled",
        value: value
    });
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bdae55c7b39f1d12$var$markRejected = (error)=>({
        status: "failed",
        reason: error
    });
const $bdae55c7b39f1d12$export$b43fdcffd84b7b0f = (promises)=>{
    return Promise.all(promises.map((result)=>result.then($bdae55c7b39f1d12$var$markFullfilled).catch($bdae55c7b39f1d12$var$markRejected)));
};
const $bdae55c7b39f1d12$export$cb8861b0e3f3dd6f = (promises)=>{
    const rejectReasons = [];
    return new Promise((resolve, reject)=>{
        promises.forEach((promise)=>promise.then((value)=>{
                if (typeof value === 'undefined' || value === null) throw new Error(`Result was not found but the method didn't reject/throw. Please ensure that it doesn't return null or undefined.`);
                resolve(value);
            }).catch((reason)=>{
                rejectReasons.push(reason);
                if (rejectReasons.length === promises.length) reject(reason);
            }));
    });
};
const $bdae55c7b39f1d12$export$b7581cbf0e22e36b = (results)=>results.filter($bdae55c7b39f1d12$var$isFullfilled).map((result)=>result.value);

});




parcelRegister("anjtc", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ec3991611a90ddd$export$2e2bcd8739ae039);

var $cLzGC = parcelRequire("cLzGC");
function $4ec3991611a90ddd$export$2e2bcd8739ae039(editorActions, apiRef, extensionProvider, quickInsert, createAnalyticsEvent) {
    const quickInsertProvider = quickInsert && typeof quickInsert !== 'boolean' && quickInsert.provider;
    const extensionQuickInsertProvider = extensionProvider && (0, $cLzGC.extensionProviderToQuickInsertProvider)(extensionProvider, editorActions, apiRef, createAnalyticsEvent);
    return quickInsertProvider && extensionQuickInsertProvider ? (0, $cLzGC.combineQuickInsertProviders)([
        quickInsertProvider,
        extensionQuickInsertProvider
    ]) : quickInsertProvider || extensionQuickInsertProvider;
}

});
parcelRegister("cLzGC", function(module, exports) {

$parcel$export(module.exports, "extensionProviderToQuickInsertProvider", () => $3995d1230bc1e17d$export$6b0bb34c2583056f);
$parcel$export(module.exports, "combineQuickInsertProviders", () => $3995d1230bc1e17d$export$e3759a254d73dcb7);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $joSn0 = parcelRequire("joSn0");

var $bMFKb = parcelRequire("bMFKb");
var $cd124 = parcelRequire("cd124");

var $g3VjK = parcelRequire("g3VjK");
var $l3kPA = parcelRequire("l3kPA");

var $alidL = parcelRequire("alidL");

var $dyNYh = parcelRequire("dyNYh");

var $eGOwo = parcelRequire("eGOwo");
/**
 * Utils to send analytics event when a extension is inserted using quickInsert
 */ function $3995d1230bc1e17d$var$sendExtensionQuickInsertAnalytics(item, selection, createAnalyticsEvent, source) {
    if (createAnalyticsEvent) {
        const insertLocation = (0, $eGOwo.fg)('platform_nested_nbm_analytics_location') ? (0, $dyNYh.findInsertLocation)(selection) : undefined;
        (0, $cd124.fireAnalyticsEvent)(createAnalyticsEvent)({
            payload: {
                action: (0, $bMFKb.ACTION).INSERTED,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).DOCUMENT,
                actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).EXTENSION,
                attributes: {
                    extensionType: item.extensionType,
                    extensionKey: item.extensionKey,
                    key: item.key,
                    inputMethod: source || (0, $bMFKb.INPUT_METHOD).QUICK_INSERT,
                    ...insertLocation ? {
                        insertLocation: insertLocation
                    } : {}
                },
                eventType: (0, $bMFKb.EVENT_TYPE).TRACK
            }
        });
    }
}
const $3995d1230bc1e17d$var$showDummyAPIWarning = (location)=>{};
const $3995d1230bc1e17d$var$dummyExtensionAPI = {
    editInContextPanel: ()=>$3995d1230bc1e17d$var$showDummyAPIWarning('editInContextPanel'),
    _editInLegacyMacroBrowser: ()=>$3995d1230bc1e17d$var$showDummyAPIWarning('_editInLegacyMacroBrowser'),
    getNodeWithPosByLocalId: ()=>({
            node: null,
            pos: null
        }),
    doc: {
        insertAfter: ()=>$3995d1230bc1e17d$var$showDummyAPIWarning('doc:insertAfter'),
        scrollTo: ()=>$3995d1230bc1e17d$var$showDummyAPIWarning('doc:scrollTo'),
        update: ()=>$3995d1230bc1e17d$var$showDummyAPIWarning('doc:update')
    }
};
async function $3995d1230bc1e17d$export$6b0bb34c2583056f(extensionProvider, editorActions, apiRef, createAnalyticsEvent) {
    const extensions = await extensionProvider.getExtensions();
    return {
        getItems: ()=>{
            const quickInsertItems = (0, $g3VjK.getQuickInsertItemsFromModule)(extensions, (item)=>{
                const Icon = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
                    loader: item.icon,
                    loading: ()=>null
                });
                return {
                    title: item.title,
                    description: item.description,
                    icon: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)(Icon, {
                            label: ""
                        }),
                    keywords: item.keywords,
                    featured: item.featured,
                    categories: item.categories,
                    isDisabledOffline: true,
                    action: (insert, state, source)=>{
                        if (typeof item.node === 'function') {
                            const extensionAPI = apiRef?.current?.extension?.actions?.api();
                            // While this should only run when the extension some setups of editor
                            // may not have the extension API
                            if (extensionAPI) (0, $l3kPA.resolveImport)(item.node(extensionAPI)).then((node)=>{
                                $3995d1230bc1e17d$var$sendExtensionQuickInsertAnalytics(item, state.selection, createAnalyticsEvent, source);
                                if (node) editorActions.replaceSelection(node);
                            });
                            else // Originally it was understood we could only use this if we were using the extension plugin
                            // However there are some edge cases where this is not true (ie. in jira)
                            // Since making it optional now would be a breaking change - instead we can just pass a dummy
                            // extension API to consumers that warns them of using the methods.
                            (0, $l3kPA.resolveImport)(item.node($3995d1230bc1e17d$var$dummyExtensionAPI)).then((node)=>{
                                $3995d1230bc1e17d$var$sendExtensionQuickInsertAnalytics(item, state.selection, createAnalyticsEvent, source);
                                if (node) editorActions.replaceSelection(node);
                            });
                            return insert('');
                        } else {
                            $3995d1230bc1e17d$var$sendExtensionQuickInsertAnalytics(item, state.selection, createAnalyticsEvent, source);
                            return insert(item.node);
                        }
                    }
                };
            });
            return Promise.all(quickInsertItems);
        }
    };
}
async function $3995d1230bc1e17d$export$e3759a254d73dcb7(quickInsertProviders) {
    const { invokeList: invokeList } = (0, $alidL.default)(quickInsertProviders);
    return {
        getItems () {
            return invokeList('getItems');
        }
    };
}

});
parcelRegister("g3VjK", function(module, exports) {

$parcel$export(module.exports, "getQuickInsertItemsFromModule", () => $229d3d4e66a244b5$export$a1d0004a197b97a3);
$parcel$export(module.exports, "getAutoConvertPatternsFromModule", () => $229d3d4e66a244b5$export$60407594ea5edd1c);
$parcel$export(module.exports, "getExtensionAutoConvertersFromProvider", () => $229d3d4e66a244b5$export$38a3a11e6509754a);
$parcel$export(module.exports, "getContextualToolbarItemsFromModule", () => $229d3d4e66a244b5$export$9d13b95c50a2a6c9);

var $l3kPA = parcelRequire("l3kPA");
const $229d3d4e66a244b5$export$3f063810d7bf01bd = (arr, attr, keyRenamer)=>// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    arr.reduce((acc, item)=>{
        acc[keyRenamer(item[attr])] = item;
        return acc;
    }, {});
function $229d3d4e66a244b5$export$30871400b97708b4(manifest, extensionModule) {
    const title = extensionModule.title || manifest.title;
    const key = `${manifest.key}:${extensionModule.key}`;
    const node = (0, $l3kPA.buildAction)(extensionModule.action, manifest);
    if (!node) throw new Error(`Couldn't find any action for ${title} (${key})`);
    return {
        key: key,
        title: title,
        extensionType: manifest.type,
        extensionKey: manifest.key,
        keywords: extensionModule.keywords || manifest.keywords || [],
        featured: extensionModule.featured || false,
        categories: extensionModule.categories || manifest.categories || [],
        description: extensionModule.description || manifest.description,
        summary: manifest.summary,
        documentationUrl: manifest.documentationUrl,
        icon: extensionModule.icon || manifest.icons['48'],
        node: node
    };
}
const $229d3d4e66a244b5$export$a1d0004a197b97a3 = (extensions, transformFunction)=>{
    const items = extensions.map((manifest)=>{
        const modules = manifest.modules.quickInsert || [];
        return modules.map((extensionModule)=>$229d3d4e66a244b5$export$30871400b97708b4(manifest, extensionModule));
    });
    const flatItems = [].concat(...items);
    return flatItems.map(transformFunction);
};
async function $229d3d4e66a244b5$export$60407594ea5edd1c(extensions) {
    const items = await Promise.all(// Ignored via go/ees005
    // eslint-disable-next-line require-await
    extensions.map(async (manifest)=>{
        if (manifest.modules.autoConvert && manifest.modules.autoConvert.url) return manifest.modules.autoConvert.url;
        return [];
    }));
    return [].concat(...items);
}
const $229d3d4e66a244b5$export$5ae7aa0814ef4090 = (autoConvertHandlers)=>(text)=>{
        for (const handler of autoConvertHandlers){
            const result = handler(text);
            if (result) return result;
        }
    };
async function $229d3d4e66a244b5$export$38a3a11e6509754a(extensionProviderPromise) {
    const extensionProvider = await extensionProviderPromise;
    const extensionAutoConverters = await extensionProvider.getAutoConverter();
    return $229d3d4e66a244b5$export$5ae7aa0814ef4090(extensionAutoConverters);
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $229d3d4e66a244b5$var$logError = (msg, ...args)=>{
    // eslint-disable-next-line no-console
    console.error(msg, ...args);
};
const $229d3d4e66a244b5$var$toolbarItemToButtonConfig = (toolbarButton, parentKey)=>{
    const { tooltip: tooltip, tooltipStyle: tooltipStyle, key: key, label: label, ariaLabel: ariaLabel, icon: icon, action: action, disabled: disabled } = toolbarButton;
    const itemKey = [
        parentKey,
        key
    ].join(':');
    if (typeof action !== 'function') $229d3d4e66a244b5$var$logError(`Provided action is not a function for extension toolbar button: ${label} (${itemKey})`);
    let labelAndIcon = {};
    switch(toolbarButton.display){
        case 'icon':
            if (!icon) $229d3d4e66a244b5$var$logError(`icon should be provided for extension toolbar button (${itemKey}), when display is set to 'icon'`);
            labelAndIcon = {
                icon: icon
            };
            break;
        case 'label':
            if (!label) $229d3d4e66a244b5$var$logError(`label should be provided for extension toolbar button (${itemKey}), when display is set to 'label'`);
            labelAndIcon = {
                label: label
            };
            break;
        default:
            if (!label || !icon) $229d3d4e66a244b5$var$logError(`label and icon should be provided for extension toolbar button (${itemKey}), when display is not set or set to 'icon-and-label'`);
            labelAndIcon = {
                icon: icon,
                label: label
            };
            break;
    }
    return {
        key: itemKey,
        ariaLabel: ariaLabel,
        tooltip: tooltip,
        tooltipStyle: tooltipStyle,
        action: action,
        disabled: disabled,
        ...labelAndIcon
    };
};
const $229d3d4e66a244b5$var$compareContext = (contextA, contextB)=>{
    if (contextA.type === contextB.type && contextA.nodeType === contextB.nodeType) {
        if (contextA.type === 'node') return true;
        if (contextA.type === 'extension' && contextB.type === 'extension') return contextA.extensionKey === contextB.extensionKey && contextA.extensionType === contextB.extensionType;
    }
    return false;
};
const $229d3d4e66a244b5$var$hasDuplicateContext = (contextualToolbars)=>{
    if (contextualToolbars.length > 1) {
        const contexts = contextualToolbars.map((contextualToolbar)=>contextualToolbar.context);
        return contexts.find((currentContext, currentIndex)=>currentIndex !== contexts.findIndex((context)=>$229d3d4e66a244b5$var$compareContext(currentContext, context)));
    }
};
const $229d3d4e66a244b5$export$9d13b95c50a2a6c9 = (extensions, node, api)=>{
    return extensions.map((extension)=>{
        if (extension.modules.contextualToolbars) {
            const duplicateContext = $229d3d4e66a244b5$var$hasDuplicateContext(extension.modules.contextualToolbars);
            if (duplicateContext) {
                $229d3d4e66a244b5$var$logError(`[contextualToolbars] Duplicate context detected - ${JSON.stringify(duplicateContext)}.`);
                return [];
            }
            return extension.modules.contextualToolbars.map((contextualToolbar)=>{
                if ($229d3d4e66a244b5$var$shouldAddExtensionItemForNode(contextualToolbar, node)) {
                    const { toolbarItems: toolbarItems } = contextualToolbar;
                    if (typeof toolbarItems === 'function') return toolbarItems(node, api);
                    return toolbarItems;
                }
                return [];
            }).flatMap((toolbarItems)=>toolbarItems.map((toolbarItem)=>{
                    if ($229d3d4e66a244b5$var$isToolbarButton(toolbarItem)) return $229d3d4e66a244b5$var$toolbarItemToButtonConfig(toolbarItem, extension.key);
                    return toolbarItem;
                }));
        }
        return [];
    }).flatMap((extensionToolbarButtons)=>extensionToolbarButtons);
};
const $229d3d4e66a244b5$var$isToolbarButton = (toolbarItem)=>{
    if ('type' in toolbarItem) return false;
    return true;
};
// defines whether to add toolbar item for the given node
function $229d3d4e66a244b5$var$shouldAddExtensionItemForNode(item, node) {
    // if item type is a standard node - should match the nodeType
    if (item.context.type === 'node' && item.context.nodeType === node.type) return true;
    // for other cases should be an extension and match the nodeType ("extension" | "inlineExtension" | "bodiedExtension" | "multiBodiedExtension")
    if (item.context.type !== 'extension' || node.type !== item.context.nodeType) return false;
    // in cases where we need custom exclusion depending on the node
    if (item.context.shouldExclude) {
        if (item.context.shouldExclude(node)) return false;
    }
    const { extensionType: extensionType, extensionKey: extensionKey } = item.context;
    // if extension type is given - should match extension type
    if (extensionType && extensionType !== node.attrs?.extensionType) return false;
    // if extension key is a string
    if (typeof extensionKey === 'string') return extensionKey === node.attrs?.extensionKey;
    // if extension key is an array
    if (Array.isArray(extensionKey) && extensionKey.length) return extensionKey.includes(node.attrs?.extensionKey);
    return false;
}

});



parcelRegister("cenXl", function(module, exports) {

$parcel$export(module.exports, "default", () => $dede0867f120b1e2$export$2e2bcd8739ae039);
function $dede0867f120b1e2$export$2e2bcd8739ae039({ autoformattingProvider: autoformattingProvider, emojiProvider: emojiProvider, mentionProvider: mentionProvider, legacyImageUploadProvider: legacyImageUploadProvider, taskDecisionProvider: taskDecisionProvider, contextIdentifierProvider: contextIdentifierProvider, searchProvider: searchProvider, macroProvider: macroProvider, activityProvider: activityProvider, collabEdit: collabEdit, collabEditProvider: collabEditProvider, presenceProvider: presenceProvider }) {
    return {
        emojiProvider: emojiProvider,
        mentionProvider: mentionProvider,
        autoformattingProvider: autoformattingProvider,
        activityProvider: activityProvider,
        imageUploadProvider: legacyImageUploadProvider,
        taskDecisionProvider: taskDecisionProvider,
        contextIdentifierProvider: contextIdentifierProvider,
        searchProvider: searchProvider,
        presenceProvider: presenceProvider,
        macroProvider: macroProvider,
        collabEditProvider: collabEdit?.provider ? collabEdit.provider : collabEditProvider
    };
}

});

parcelRegister("aipJ3", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0281c993a8017a7$export$2e2bcd8739ae039);
function $f0281c993a8017a7$export$2e2bcd8739ae039(providerFactory, { mentionProvider: mentionProvider, contextIdentifierProvider: contextIdentifierProvider, collabEditProvider: collabEditProvider, activityProvider: activityProvider, presenceProvider: presenceProvider, macroProvider: macroProvider, imageUploadProvider: imageUploadProvider, searchProvider: searchProvider }, extensionProvider, quickInsertProvider) {
    providerFactory.setProvider('mentionProvider', mentionProvider);
    providerFactory.setProvider('contextIdentifierProvider', contextIdentifierProvider);
    providerFactory.setProvider('imageUploadProvider', imageUploadProvider);
    providerFactory.setProvider('collabEditProvider', collabEditProvider);
    providerFactory.setProvider('activityProvider', activityProvider);
    providerFactory.setProvider('searchProvider', searchProvider);
    providerFactory.setProvider('presenceProvider', presenceProvider);
    providerFactory.setProvider('macroProvider', macroProvider);
    if (extensionProvider) providerFactory.setProvider('extensionProvider', Promise.resolve(extensionProvider));
    if (quickInsertProvider) providerFactory.setProvider('quickInsertProvider', quickInsertProvider);
}

});




parcelRegister("hzPqg", function(module, exports) {

$parcel$export(module.exports, "usePreset", () => $92ad4392f2dcd1e5$export$1d81a44583df97d2);

var $eJOHy = parcelRequire("eJOHy");

var $8PuhX = parcelRequire("8PuhX");
function $92ad4392f2dcd1e5$export$1d81a44583df97d2(createPreset, dependencies = []) {
    const [editorApi, setAPI] = (0, $eJOHy.useState)(undefined);
    const preset = (0, $eJOHy.useMemo)(()=>createPreset(new (0, $8PuhX.EditorPresetBuilder)()), // eslint-disable-next-line react-hooks/exhaustive-deps
    dependencies);
    (0, $eJOHy.useLayoutEffect)(()=>{
        return preset.apiResolver.on((api)=>{
            setAPI(api);
        });
    }, [
        preset.apiResolver
    ]);
    return {
        editorApi: editorApi,
        preset: preset
    };
}

});
parcelRegister("8PuhX", function(module, exports) {

$parcel$export(module.exports, "EditorPresetBuilder", () => $259832480ddd66b3$export$dab03ba05a79e5c7);

var $aoyv9 = parcelRequire("aoyv9");
class $259832480ddd66b3$export$dab03ba05a79e5c7 {
    constructor(...more){
        this.apiEmitter = ()=>{};
        this.safeEntry = (plugin)=>Array.isArray(plugin) ? plugin : [
                plugin,
                undefined
            ];
        this.data = [
            ...more
        ];
        this.apiPromise = new Promise((r)=>this.resolver = r);
        this.apiResolver = new $259832480ddd66b3$var$APIDispatcher((emitter)=>this.apiEmitter = emitter);
    }
    add(nextOrTuple) {
        return new $259832480ddd66b3$export$dab03ba05a79e5c7(/**
			 * re-cast this to NewPlugin as we've done all the type
			 * safety, dependency checking, narrowing, during
			 * `SafePresetCheck & VerifyPluginDependencies`
			 */ nextOrTuple, ...this.data);
    }
    maybeAdd(pluginToAdd, shouldAdd) {
        const pluginOrBuilder = typeof shouldAdd === 'function' ? shouldAdd(pluginToAdd, this) : shouldAdd;
        if (pluginOrBuilder instanceof $259832480ddd66b3$export$dab03ba05a79e5c7) return pluginOrBuilder;
        const nextPluginStack = [
            /**
			 * re-cast this to NewPlugin as we've done all the type
			 * safety, dependency checking, narrowing, during
			 * `SafePresetCheck & VerifyPluginDependencies`
			 */ pluginOrBuilder ? pluginToAdd : undefined,
            ...this.data
        ];
        const nextEditorPresetBuilder = new $259832480ddd66b3$export$dab03ba05a79e5c7(...nextPluginStack);
        return nextEditorPresetBuilder;
    }
    has(plugin) {
        return this.data.some((pluginPreset)=>{
            if (Array.isArray(pluginPreset)) return pluginPreset[0] === plugin;
            return pluginPreset === plugin;
        });
    }
    build({ pluginInjectionAPI: pluginInjectionAPI, excludePlugins: maybeExcludePlugins } = {}) {
        const excludePlugins = new Set(maybeExcludePlugins ? maybeExcludePlugins : []);
        const editorPlugins = this.processEditorPlugins({
            pluginInjectionAPI: pluginInjectionAPI,
            excludePlugins: excludePlugins
        });
        if (pluginInjectionAPI) {
            // The pluginInjectionAPI API doesn't have information enough to build a proper type for the API.
            // It is returning a generic type but on top of the Proxy system
            // So, we can safely recast it here
            this.apiEmitter(pluginInjectionAPI.api());
            // Deprecated approach
            this.resolver?.(pluginInjectionAPI.api());
        }
        return this.removeExcludedPlugins(editorPlugins, excludePlugins);
    }
    verifyDuplicatedPlugins() {
        const cache = new Set();
        this.data.filter(Boolean).forEach((pluginEntry)=>{
            const [pluginFn, _] = Array.isArray(pluginEntry) ? pluginEntry : [
                pluginEntry,
                undefined
            ];
            if (cache.has(pluginFn)) throw new Error(`${pluginFn} is already included!`);
            cache.add(pluginFn);
        });
        return true;
    }
    processEditorPlugins({ pluginInjectionAPI: pluginInjectionAPI, excludePlugins: excludePlugins }) {
        this.verifyDuplicatedPlugins();
        const seen = new Set();
        const pluginsDataCopy = this.data.slice();
        const plugins = pluginsDataCopy.reverse().filter(Boolean).map((entry)=>{
            const [fn, config] = this.safeEntry(entry);
            if (seen.has(fn)) return null;
            seen.add(fn);
            if (typeof fn !== 'function') return null;
            const plugin = pluginInjectionAPI ? fn({
                config: config,
                api: pluginInjectionAPI.api()
            }) : fn({
                config: config
            });
            if (plugin && excludePlugins?.has(plugin.name)) return null;
            if (!pluginInjectionAPI) return plugin;
            pluginInjectionAPI.onEditorPluginInitialized(plugin);
            return plugin;
        }).filter(Boolean);
        return plugins;
    }
    removeExcludedPlugins(plugins, excludes) {
        if (excludes) return plugins.filter((plugin)=>!plugin || !excludes.has(plugin.name));
        return plugins;
    }
}
/**
 * WARNING: Internal object
 *
 * Dedicated wrapper around EventDispatcher for public API around the editor API.
 * This only has the public method `on` which is used to listen to updates to the editor API.
 *
 * This shouldn't really be used externally - the `editorAPI` should be accessed via `usePreset`.
 */ class $259832480ddd66b3$var$APIDispatcher {
    constructor(emitter){
        this.emitter = emitter;
        this.eventDispatcher = new (0, $aoyv9.EventDispatcher)();
        this.key = 'api-resolved-event';
        this.initialEvent = undefined;
        this.emitter((v)=>{
            this.initialEvent = v;
            this.eventDispatcher.emit(this.key, v);
        });
    }
    /**
	 * Used to observe Editor API events
	 *
	 * @param cb Callback to listen to the editor API.
	 * This will also emit the last event if the stream has already started.
	 * @returns Cleanup function to cleanup the listener
	 */ on(cb) {
        if (this.initialEvent !== undefined) // Keeps timing consistent with old approach - certain products
        // ie. ai-mate relied on this.
        Promise.resolve().then(()=>cb(this.initialEvent));
        this.eventDispatcher.on(this.key, cb);
        return ()=>{
            this.eventDispatcher.off(this.key, cb);
        };
    }
    destroy() {
        this.eventDispatcher.destroy();
    }
}

});


parcelRegister("1LVxc", function(module, exports) {

$parcel$export(module.exports, "default", () => $336b1a6c1be58861$export$2e2bcd8739ae039);

var $8DB98 = parcelRequire("8DB98");

var $aqskg = parcelRequire("aqskg");
class $336b1a6c1be58861$export$2e2bcd8739ae039 {
    constructor(schema){
        this.schema = schema;
        this.schema = schema;
    }
    serializeFragment(fragment) {
        const result = [];
        fragment.forEach((n)=>{
            result.push((0, $aqskg.reduce)(n, this.schema));
        });
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        return result.join('\n').replace(/\n+/g, '\n');
    }
    static fromSchema(schema = (0, $8DB98.defaultSchema)) {
        return new $336b1a6c1be58861$export$2e2bcd8739ae039(schema);
    }
}

});
parcelRegister("aqskg", function(module, exports) {

$parcel$export(module.exports, "reduce", () => $d8ee4d14254d50da$export$533b26079ad0b4b);

var $iOn6j = parcelRequire("iOn6j");

var $c4jiB = parcelRequire("c4jiB");

var $5u70q = parcelRequire("5u70q");

var $EiR1g = parcelRequire("EiR1g");

var $14Wro = parcelRequire("14Wro");

var $3Vvcc = parcelRequire("3Vvcc");

var $6IeNj = parcelRequire("6IeNj");

var $1wZsI = parcelRequire("1wZsI");

var $6ySZE = parcelRequire("6ySZE");

var $9x58g = parcelRequire("9x58g");

var $deM66 = parcelRequire("deM66");

var $dnx3d = parcelRequire("dnx3d");

var $dX58h = parcelRequire("dX58h");

var $g6zW9 = parcelRequire("g6zW9");

var $bOElj = parcelRequire("bOElj");

var $iI82H = parcelRequire("iI82H");

var $eknNa = parcelRequire("eknNa");

var $jFFK7 = parcelRequire("jFFK7");
const $d8ee4d14254d50da$export$533b26079ad0b4b = (node, schema)=>{
    const reducer = $d8ee4d14254d50da$var$nodeToReducerMapping[node.type.name] || $d8ee4d14254d50da$var$nodeToReducerMapping.unknown;
    return reducer(node, schema);
};
const $d8ee4d14254d50da$var$nodeToReducerMapping = {
    blockquote: $iOn6j.default,
    bulletList: $c4jiB.default,
    date: $5u70q.default,
    decisionItem: $EiR1g.default,
    hardBreak: $14Wro.default,
    heading: $3Vvcc.default,
    inlineCard: $6IeNj.default,
    listItem: $1wZsI.default,
    mediaGroup: $6ySZE.default,
    mention: $9x58g.default,
    orderedList: $deM66.default,
    panel: $dnx3d.default,
    paragraph: $dX58h.default,
    rule: $g6zW9.default,
    status: $bOElj.default,
    table: $iI82H.default,
    taskItem: $eknNa.default,
    unknown: $jFFK7.default
};

});
parcelRegister("iOn6j", function(module, exports) {

$parcel$export(module.exports, "default", () => $814291df79e48746$export$2e2bcd8739ae039);

var $aqskg = parcelRequire("aqskg");
const $814291df79e48746$var$blockquote = (node, schema)=>{
    const result = [];
    node.content.forEach((n)=>{
        result.push((0, $aqskg.reduce)(n, schema));
    });
    return `> ${result.join('')}`;
};
var $814291df79e48746$export$2e2bcd8739ae039 = $814291df79e48746$var$blockquote;

});

parcelRegister("c4jiB", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1dfcef05bc506d9$export$2e2bcd8739ae039);

var $aqskg = parcelRequire("aqskg");
const $b1dfcef05bc506d9$var$bulletList = (node, schema)=>{
    const result = [];
    node.forEach((n)=>{
        result.push(`* ${(0, $aqskg.reduce)(n, schema)}`);
    });
    return result.join('\n');
};
var $b1dfcef05bc506d9$export$2e2bcd8739ae039 = $b1dfcef05bc506d9$var$bulletList;

});

parcelRegister("5u70q", function(module, exports) {

$parcel$export(module.exports, "default", () => $19ccb14051a2b76d$export$2e2bcd8739ae039);

var $dZ5Iy = parcelRequire("dZ5Iy");

var $g9wjI = parcelRequire("g9wjI");
const $19ccb14051a2b76d$var$date = (node, schema)=>{
    return node.attrs.timestamp ? (0, $dZ5Iy.timestampToIsoFormat)(node.attrs.timestamp) : (0, $g9wjI.getText)(node);
};
var $19ccb14051a2b76d$export$2e2bcd8739ae039 = $19ccb14051a2b76d$var$date;

});
parcelRegister("dZ5Iy", function(module, exports) {

$parcel$export(module.exports, "timestampToUTCDate", () => $588f444e520afb69$export$56c3660a4ee2196a);
$parcel$export(module.exports, "todayTimestampInUTC", () => $588f444e520afb69$export$6297728405c48562);
$parcel$export(module.exports, "timestampToString", () => $588f444e520afb69$export$48755a044ef883a0);
$parcel$export(module.exports, "timestampToIsoFormat", () => $588f444e520afb69$export$70a1b7b6fffe4dd1);
$parcel$export(module.exports, "isPastDate", () => $588f444e520afb69$export$e6cc7bfc6e0e363e);
$parcel$export(module.exports, "timestampToTaskContext", () => $588f444e520afb69$export$fbc04a9e57b04a80);

var $btz6U = parcelRequire("btz6U");

var $bf0oy = parcelRequire("bf0oy");
var $588f444e520afb69$var$FORMATS = /*#__PURE__*/ function(FORMATS) {
    FORMATS["ISO_FORMAT"] = "YYYY-MM-DD";
    FORMATS["LOCALIZED_FORMAT"] = "LOCALIZED_FORMAT";
    return FORMATS;
}($588f444e520afb69$var$FORMATS || {});
const $588f444e520afb69$export$56c3660a4ee2196a = (timestamp)=>{
    const date = new Date(Number(timestamp));
    const day = date.getUTCDate();
    const month = date.getUTCMonth() + 1;
    const year = date.getUTCFullYear();
    return {
        day: day,
        month: month,
        year: year
    };
};
const $588f444e520afb69$export$6297728405c48562 = ()=>{
    const today = new Date(Date.now());
    const todayInUTC = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate());
    return todayInUTC.toString();
};
const $588f444e520afb69$var$addLeadingZero = (val)=>{
    if (val < 10) return `0${val}`;
    return val;
};
const $588f444e520afb69$var$capitalizeFirstLetter = (str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
};
const $588f444e520afb69$export$48755a044ef883a0 = (timestamp, intl, pattern)=>{
    if (!intl || pattern === "YYYY-MM-DD") return $588f444e520afb69$export$70a1b7b6fffe4dd1(timestamp);
    const date = new Date(Number(timestamp));
    return intl.formatDate(date, {
        timeZone: 'UTC',
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        formatMatcher: 'best fit'
    });
};
const $588f444e520afb69$export$70a1b7b6fffe4dd1 = (timestamp)=>{
    const date = new Date(Number(timestamp));
    return `${date.getUTCFullYear()}-${$588f444e520afb69$var$addLeadingZero(date.getUTCMonth() + 1)}-${$588f444e520afb69$var$addLeadingZero(date.getUTCDate())}`;
};
const $588f444e520afb69$export$e6cc7bfc6e0e363e = (timestamp)=>{
    return (0, $bf0oy.default)(new Date(Number(timestamp)), new Date(Number($588f444e520afb69$export$6297728405c48562())));
};
const $588f444e520afb69$export$fbc04a9e57b04a80 = (timestamp, intl)=>{
    const curDate = new Date(Number($588f444e520afb69$export$6297728405c48562()));
    const givenDate = new Date(Number(timestamp));
    const distance = (0, $btz6U.default)(givenDate, curDate);
    if (intl && [
        -1,
        0,
        1
    ].indexOf(distance) > -1) return $588f444e520afb69$var$capitalizeFirstLetter(intl.formatRelativeTime(distance, 'day', {
        numeric: 'auto'
    }));
    return $588f444e520afb69$export$48755a044ef883a0(timestamp, intl, "LOCALIZED_FORMAT");
};

});


parcelRegister("EiR1g", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ad4719240189e00$export$2e2bcd8739ae039);

var $aqskg = parcelRequire("aqskg");
const $1ad4719240189e00$var$decisionItem = (node, schema)=>{
    const result = [];
    let previousNodeType = '';
    node.forEach((n)=>{
        const text = (0, $aqskg.reduce)(n, schema);
        if (previousNodeType === 'mention' && !text.startsWith(' ')) result.push(` ${text}`);
        else result.push(text);
        previousNodeType = n.type.name;
    });
    return `<> ${result.join('').trim()}`;
};
var $1ad4719240189e00$export$2e2bcd8739ae039 = $1ad4719240189e00$var$decisionItem;

});

parcelRegister("14Wro", function(module, exports) {

$parcel$export(module.exports, "default", () => $67ba2bd16f9488d6$export$2e2bcd8739ae039);
const $67ba2bd16f9488d6$var$hardBreak = ()=>{
    return '\n';
};
var $67ba2bd16f9488d6$export$2e2bcd8739ae039 = $67ba2bd16f9488d6$var$hardBreak;

});

parcelRegister("3Vvcc", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6711d88b3cbd025$export$2e2bcd8739ae039);

var $aqskg = parcelRequire("aqskg");
const $e6711d88b3cbd025$var$heading = (node, schema)=>{
    const result = [];
    node.forEach((n)=>{
        result.push((0, $aqskg.reduce)(n, schema));
    });
    return result.join('');
};
var $e6711d88b3cbd025$export$2e2bcd8739ae039 = $e6711d88b3cbd025$var$heading;

});

parcelRegister("6IeNj", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e1a756ed65e214d$export$2e2bcd8739ae039);

var $g9wjI = parcelRequire("g9wjI");
const $1e1a756ed65e214d$var$inlineCard = (node, schema)=>{
    return node.attrs.url || node.attrs.data?.url || (0, $g9wjI.getText)(node);
};
var $1e1a756ed65e214d$export$2e2bcd8739ae039 = $1e1a756ed65e214d$var$inlineCard;

});

parcelRegister("1wZsI", function(module, exports) {

$parcel$export(module.exports, "default", () => $5bc040febe608e24$export$2e2bcd8739ae039);

var $aqskg = parcelRequire("aqskg");
const $5bc040febe608e24$var$listItem = (node, schema)=>{
    const result = [];
    node.forEach((n)=>{
        result.push((0, $aqskg.reduce)(n, schema));
    });
    return result.join('\n');
};
var $5bc040febe608e24$export$2e2bcd8739ae039 = $5bc040febe608e24$var$listItem;

});

parcelRegister("6ySZE", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff5eb0444c3b3502$export$2e2bcd8739ae039);
const $ff5eb0444c3b3502$var$mediaGroup = (node)=>{
    // count children which are media files
    // ignore card links
    let childMediaFilesCount = 0;
    node.content.forEach((childNode)=>{
        if (childNode.attrs.type === 'file') childMediaFilesCount += 1;
    });
    if (childMediaFilesCount) {
        const postfix = childMediaFilesCount > 1 ? 'Files' : 'File';
        return `\u{1F4CE} ${childMediaFilesCount} ${postfix}`;
    }
    return '';
};
var $ff5eb0444c3b3502$export$2e2bcd8739ae039 = $ff5eb0444c3b3502$var$mediaGroup;

});

parcelRegister("9x58g", function(module, exports) {

$parcel$export(module.exports, "default", () => $357bdc948e15b537$export$2e2bcd8739ae039);
const $357bdc948e15b537$var$mention = (node, schema)=>{
    if ([
        'all',
        'here'
    ].indexOf(node.attrs.id) !== -1) return `@${node.attrs.id}`;
    return `${node.attrs.text || '@unknown'}`;
};
var $357bdc948e15b537$export$2e2bcd8739ae039 = $357bdc948e15b537$var$mention;

});

parcelRegister("deM66", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7ff775365af6469$export$2e2bcd8739ae039);

var $fCXIH = parcelRequire("fCXIH");

var $aqskg = parcelRequire("aqskg");
const $d7ff775365af6469$var$orderedList = (node, schema)=>{
    const result = [];
    const order = (0, $fCXIH.getOrderFromOrderedListNode)(node);
    node.forEach((n, _offset, index)=>{
        result.push(`${index + order}. ${(0, $aqskg.reduce)(n, schema)}`);
    });
    return result.join('\n');
};
var $d7ff775365af6469$export$2e2bcd8739ae039 = $d7ff775365af6469$var$orderedList;

});

parcelRegister("dnx3d", function(module, exports) {

$parcel$export(module.exports, "default", () => $219c1648a3127a2e$export$2e2bcd8739ae039);

var $aqskg = parcelRequire("aqskg");
const $219c1648a3127a2e$var$panel = (node, schema)=>{
    const result = [];
    node.forEach((n)=>{
        result.push((0, $aqskg.reduce)(n, schema));
    });
    return result.join('\n');
};
var $219c1648a3127a2e$export$2e2bcd8739ae039 = $219c1648a3127a2e$var$panel;

});

parcelRegister("dX58h", function(module, exports) {

$parcel$export(module.exports, "default", () => $55b5d30ee0a92e9f$export$2e2bcd8739ae039);

var $aqskg = parcelRequire("aqskg");
const $55b5d30ee0a92e9f$var$paragraph = (node, schema)=>{
    const result = [];
    let previousNodeType = '';
    node.forEach((n)=>{
        const text = (0, $aqskg.reduce)(n, schema);
        if (previousNodeType === 'mention' && !text.startsWith(' ')) result.push(` ${text}`);
        else result.push(text);
        previousNodeType = n.type.name;
    });
    return result.join('').trim();
};
var $55b5d30ee0a92e9f$export$2e2bcd8739ae039 = $55b5d30ee0a92e9f$var$paragraph;

});

parcelRegister("g6zW9", function(module, exports) {

$parcel$export(module.exports, "default", () => $2faedd5e5cae2ee3$export$2e2bcd8739ae039);
const $2faedd5e5cae2ee3$var$rule = ()=>{
    return '';
};
var $2faedd5e5cae2ee3$export$2e2bcd8739ae039 = $2faedd5e5cae2ee3$var$rule;

});

parcelRegister("bOElj", function(module, exports) {

$parcel$export(module.exports, "default", () => $28d2c37c2076739c$export$2e2bcd8739ae039);

var $g9wjI = parcelRequire("g9wjI");
const $28d2c37c2076739c$var$status = (node, schema)=>{
    return node.attrs.text ? `[ ${node.attrs.text.toUpperCase()} ]` : (0, $g9wjI.getText)(node);
};
var $28d2c37c2076739c$export$2e2bcd8739ae039 = $28d2c37c2076739c$var$status;

});

parcelRegister("iI82H", function(module, exports) {

$parcel$export(module.exports, "default", () => $731aa0da9202d7ff$export$2e2bcd8739ae039);

var $aqskg = parcelRequire("aqskg");
const $731aa0da9202d7ff$var$table = (node, schema)=>{
    const result = [];
    node.forEach((n)=>{
        result.push($731aa0da9202d7ff$var$tableRow(n, schema));
    });
    return result.join('\n');
};
const $731aa0da9202d7ff$var$tableRow = (node, schema)=>{
    const result = [];
    const separator = '|';
    node.forEach((n)=>{
        result.push($731aa0da9202d7ff$var$tableCell(n, schema));
    });
    return `${separator}${result.join(`${separator}`)}${separator}`;
};
const $731aa0da9202d7ff$var$tableCell = (node, schema)=>{
    const result = [];
    node.forEach((n)=>{
        result.push((0, $aqskg.reduce)(n, schema));
    });
    return result.join('\n');
};
var $731aa0da9202d7ff$export$2e2bcd8739ae039 = $731aa0da9202d7ff$var$table;

});

parcelRegister("eknNa", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc9a4a811fcd6b1b$export$2e2bcd8739ae039);

var $aqskg = parcelRequire("aqskg");
const $cc9a4a811fcd6b1b$var$taskItem = (node, schema)=>{
    const result = [];
    let previousNodeType = '';
    const state = node.attrs.state === 'DONE' ? '[x]' : '[]';
    node.forEach((n)=>{
        const text = (0, $aqskg.reduce)(n, schema);
        if (previousNodeType === 'mention' && !text.startsWith(' ')) result.push(` ${text}`);
        else result.push(text);
        previousNodeType = n.type.name;
    });
    return `${state} ${result.join('').trim()}`;
};
var $cc9a4a811fcd6b1b$export$2e2bcd8739ae039 = $cc9a4a811fcd6b1b$var$taskItem;

});

parcelRegister("jFFK7", function(module, exports) {

$parcel$export(module.exports, "default", () => $238cc03aa2c3282b$export$2e2bcd8739ae039);

var $g9wjI = parcelRequire("g9wjI");

var $aqskg = parcelRequire("aqskg");
const $238cc03aa2c3282b$var$unknown = (node, schema)=>{
    const result = [];
    node.forEach((n)=>{
        result.push((0, $aqskg.reduce)(n, schema));
    });
    if (result.length > 0) return result.join('');
    return (0, $g9wjI.getText)(node);
};
var $238cc03aa2c3282b$export$2e2bcd8739ae039 = $238cc03aa2c3282b$var$unknown;

});



parcelRegister("20HYH", function(module, exports) {

$parcel$export(module.exports, "AddItemButton", () => $c015194caaca5251$export$6cb731ac7be1981a);
/* AddItemButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $Ay1uj = parcelRequire("Ay1uj");

var $dcLzM = parcelRequire("dcLzM");

var $5oJwn = parcelRequire("5oJwn");
const $c015194caaca5251$export$6cb731ac7be1981a = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    // TODO: EDITOR-764 - Work to implement in this ticket
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
        isDisabled: true,
        isTooltipDisabled: false,
        label: formatMessage((0, $5oJwn.default).label),
        testId: "editor-ai-add-item-button",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dcLzM))),
        spacing: "compact",
        appearance: "subtle",
        onClick: ()=>{},
        onKeyDown: ()=>{},
        onKeyUp: ()=>{}
    });
};

});
parcelRegister("5oJwn", function(module, exports) {

$parcel$export(module.exports, "default", () => $3cca47dee5601eed$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $3cca47dee5601eed$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    label: {
        id: 'fabric.editor.ai.screens.prompt.addButton.label',
        defaultMessage: 'Add item',
        description: 'Add item button label within the Prompt screen'
    }
});

});


parcelRegister("i3bYv", function(module, exports) {

$parcel$export(module.exports, "LinkPickerButton", () => $f433ca46965272f4$export$b665e181ecd1797);
/* LinkPickerButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $Ay1uj = parcelRequire("Ay1uj");

var $bMFKb = parcelRequire("bMFKb");

var $kLQ9a = parcelRequire("kLQ9a");
var $bSToC = parcelRequire("bSToC");
var $cxXTK = parcelRequire("cxXTK");

var $cV8sz = parcelRequire("cV8sz");

var $4RRMb = parcelRequire("4RRMb");

var $2uW3B = parcelRequire("2uW3B");
const $f433ca46965272f4$var$useSharedState = (0, $kLQ9a.sharedPluginStateHookMigratorFactory)((api)=>{
    const { activeLinkMark: activeLinkMark } = (0, $cxXTK.useSharedPluginStateWithSelector)(api, [
        'hyperlink'
    ], (states)=>{
        return {
            activeLinkMark: states.hyperlinkState?.activeLinkMark
        };
    });
    return {
        activeLinkMark: activeLinkMark
    };
}, (api)=>{
    const { hyperlinkState: hyperlinkState } = (0, $bSToC.useSharedPluginState)(api, [
        'hyperlink'
    ]);
    return {
        activeLinkMark: hyperlinkState?.activeLinkMark
    };
});
const $f433ca46965272f4$export$b665e181ecd1797 = ({ editorApi: editorApi, promptType: promptType })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { activeLinkMark: activeLinkMark } = $f433ca46965272f4$var$useSharedState(editorApi);
    const fireAnalyticsEvent = (0, $4RRMb.useFireAnalyticsEvent)();
    const handleClick = (0, $eJOHy.useCallback)(()=>{
        if (editorApi) {
            const showLinkToolbarAction = editorApi.hyperlink?.commands.showLinkToolbar((0, $bMFKb.INPUT_METHOD).QUICK_INSERT);
            if (showLinkToolbarAction) editorApi.core.actions.execute(showLinkToolbarAction);
        }
        fireAnalyticsEvent({
            payload: {
                action: (0, $bMFKb.ACTION).CLICKED,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).BUTTON,
                actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).AI_PROMPT_LINK_PICKER_BUTTON,
                attributes: {
                    promptType: promptType
                },
                eventType: (0, $bMFKb.EVENT_TYPE).UI
            }
        });
    }, [
        editorApi,
        fireAnalyticsEvent,
        promptType
    ]);
    // The editor can be wrapped in a component that process keyboard events,
    // but we don't need to propagate `Enter`, `Space`, and `Tab` key event to the editor.
    const stopPropagationForActionKeys = (0, $eJOHy.useCallback)((event)=>{
        if ([
            'Enter',
            ' ',
            'Tab'
        ].includes(event.key)) event.stopPropagation();
    }, []);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
        isTooltipDisabled: false,
        label: formatMessage((0, $2uW3B.default).label),
        testId: "link-picker-button",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cV8sz))),
        isSelected: !!activeLinkMark,
        spacing: "compact",
        appearance: "subtle",
        onClick: handleClick,
        onKeyDown: stopPropagationForActionKeys,
        onKeyUp: stopPropagationForActionKeys
    });
};

});
parcelRegister("cxXTK", function(module, exports) {

$parcel$export(module.exports, "useSharedPluginStateWithSelector", () => $a66d3b38505e578c$export$e5d623015ec283cc);

var $eJOHy = parcelRequire("eJOHy");

var $3s8bj = parcelRequire("3s8bj");
/**
 *
 * Directly map object values
 *
 * @private
 * @param object The object to transform
 * @param mapFunction The function to map an old value to new one
 * @returns Object with the same key but transformed values
 *
 */ function $a66d3b38505e578c$var$mapValues(object, mapFunction) {
    return Object.entries(object).reduce((acc, [key, value])=>({
            ...acc,
            [key]: mapFunction(value)
        }), {});
}
// When we use the `useSharedPluginStateWithSelector` example: `useSharedPluginStateWithSelector(api, ['width'], selector)`
// it will re-render every time the component re-renders as the array "['width']" is seen as an update.
// This hook is used to prevent re-renders due to this.
function $a66d3b38505e578c$var$useStaticPlugins(plugins) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $eJOHy.useMemo)(()=>plugins, []);
}
function $a66d3b38505e578c$export$e5d623015ec283cc(injectionApi, plugins, selector) {
    const pluginNames = $a66d3b38505e578c$var$useStaticPlugins(plugins);
    const selectorRef = (0, $eJOHy.useRef)(selector);
    // Create a memoized object containing the named plugins
    const namedExternalPlugins = (0, $eJOHy.useMemo)(()=>pluginNames.reduce((acc, pluginName)=>({
                ...acc,
                [`${String(pluginName)}State`]: injectionApi?.[pluginName]
            }), {}), [
        injectionApi,
        pluginNames
    ]);
    return $a66d3b38505e578c$var$useSharedPluginStateInternal(namedExternalPlugins, selectorRef);
}
function $a66d3b38505e578c$var$useSharedPluginStateInternal(externalPlugins, selector) {
    const refStates = (0, $eJOHy.useRef)($a66d3b38505e578c$var$mapValues(externalPlugins, (value)=>value?.sharedState.currentState()));
    const [pluginStates, setPluginState] = (0, $eJOHy.useState)(()=>selector.current(refStates.current));
    const mounted = (0, $eJOHy.useRef)(false);
    (0, $eJOHy.useLayoutEffect)(()=>{
        const debouncedPluginStateUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(()=>{
            setPluginState((currentPluginStates)=>{
                const nextStates = selector.current({
                    ...refStates.current
                });
                if ($a66d3b38505e578c$var$shallowEqual(nextStates, currentPluginStates)) return currentPluginStates;
                return nextStates;
            });
        });
        // If we re-render this hook due to a change in the external
        // plugins we need to push a state update to ensure we have
        // the most current state.
        if (mounted.current) {
            refStates.current = $a66d3b38505e578c$var$mapValues(externalPlugins, (value)=>value?.sharedState.currentState());
            debouncedPluginStateUpdate();
        }
        const unsubs = Object.entries(externalPlugins).map(([pluginKey, externalPlugin])=>{
            return externalPlugin?.sharedState.onChange(({ nextSharedState: nextSharedState, prevSharedState: prevSharedState })=>{
                if (prevSharedState === nextSharedState) return;
                refStates.current[pluginKey] = nextSharedState;
                debouncedPluginStateUpdate();
            });
        });
        mounted.current = true;
        return ()=>{
            refStates.current = {};
            unsubs.forEach((cb)=>cb?.());
        };
    }, [
        externalPlugins,
        selector
    ]);
    return pluginStates;
}
function $a66d3b38505e578c$var$shallowEqual(objA, objB) {
    if (objA === objB) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for (const key of keysA){
        if (objA[key] !== objB[key]) return false;
    }
    return true;
}

});

parcelRegister("4RRMb", function(module, exports) {

$parcel$export(module.exports, "useFireAnalyticsEvent", () => $706dfdd9f4bf54ed$export$eed8c476984ddfad);

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $cd124 = parcelRequire("cd124");
function $706dfdd9f4bf54ed$export$eed8c476984ddfad() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    return (0, $eJOHy.useMemo)(()=>(0, $cd124.fireAnalyticsEvent)(createAnalyticsEvent), [
        createAnalyticsEvent
    ]);
}

});

parcelRegister("2uW3B", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b47999b27775670$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $9b47999b27775670$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    label: {
        id: 'fabric.editor.ai.screens.prompt.linkPickerButton.label',
        defaultMessage: 'Add link',
        description: 'Link picker button label within the Prompt screen'
    }
});

});


parcelRegister("cHPqZ", function(module, exports) {

$parcel$export(module.exports, "MentionButton", () => $6339b2ab091286f1$export$d16f16312388c7e);
/* MentionButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $Ay1uj = parcelRequire("Ay1uj");

var $bMFKb = parcelRequire("bMFKb");

var $kLQ9a = parcelRequire("kLQ9a");
var $bSToC = parcelRequire("bSToC");
var $cxXTK = parcelRequire("cxXTK");

var $4HB8x = parcelRequire("4HB8x");

var $4RRMb = parcelRequire("4RRMb");

var $jEA4C = parcelRequire("jEA4C");
const $6339b2ab091286f1$var$useSharedState = (0, $kLQ9a.sharedPluginStateHookMigratorFactory)((api)=>{
    const { currentHandler: currentHandler, typeAheadHandler: typeAheadHandler } = (0, $cxXTK.useSharedPluginStateWithSelector)(api, [
        'typeAhead',
        'mention'
    ], (states)=>{
        return {
            currentHandler: states.typeAheadState?.currentHandler,
            typeAheadHandler: states.mentionState?.typeAheadHandler
        };
    });
    return {
        currentHandler: currentHandler,
        typeAheadHandler: typeAheadHandler
    };
}, (api)=>{
    const { typeAheadState: typeAheadState } = (0, $bSToC.useSharedPluginState)(api, [
        'typeAhead'
    ]);
    const { mentionState: mentionState } = (0, $bSToC.useSharedPluginState)(api, [
        'mention'
    ]);
    return {
        currentHandler: typeAheadState?.currentHandler,
        typeAheadHandler: mentionState?.typeAheadHandler
    };
});
const $6339b2ab091286f1$export$d16f16312388c7e = ({ editorApi: editorApi, promptType: promptType })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { currentHandler: currentHandler, typeAheadHandler: typeAheadHandler } = $6339b2ab091286f1$var$useSharedState(editorApi);
    const fireAnalyticsEvent = (0, $4RRMb.useFireAnalyticsEvent)();
    const handleClick = (0, $eJOHy.useCallback)(()=>{
        if (editorApi) editorApi.mention?.actions.openTypeAhead((0, $bMFKb.INPUT_METHOD).QUICK_INSERT);
        fireAnalyticsEvent({
            payload: {
                action: (0, $bMFKb.ACTION).CLICKED,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).BUTTON,
                actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).AI_PROMPT_MENTION_BUTTON,
                attributes: {
                    promptType: promptType
                },
                eventType: (0, $bMFKb.EVENT_TYPE).UI
            }
        });
    }, [
        editorApi,
        fireAnalyticsEvent,
        promptType
    ]);
    const stopPropagationForActionKeys = (0, $eJOHy.useCallback)((event)=>{
        if ([
            'Enter',
            ' ',
            'Tab'
        ].includes(event.key)) event.stopPropagation();
    }, []);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
        isTooltipDisabled: false,
        label: formatMessage((0, $jEA4C.default).label),
        testId: "mention-button",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4HB8x))),
        isSelected: currentHandler?.id && typeAheadHandler?.id && currentHandler.id === typeAheadHandler.id,
        spacing: "compact",
        appearance: "subtle",
        onClick: handleClick,
        onKeyDown: stopPropagationForActionKeys,
        onKeyUp: stopPropagationForActionKeys
    });
};

});
parcelRegister("4HB8x", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a1b019ad514d335985b9dfdb2c8fe134>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $36c7fc296df7b371$var$_react = $36c7fc296df7b371$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $36c7fc296df7b371$var$_baseNew = $36c7fc296df7b371$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $36c7fc296df7b371$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Mention".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for user mentions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $36c7fc296df7b371$var$MentionIcon = (props)=>/*#__PURE__*/ $36c7fc296df7b371$var$_react.default.createElement($36c7fc296df7b371$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 3.25 12.13l.75 1.3A8 8 0 1 1 16 8c0 .842-.28 1.775-.817 2.513-.547.751-1.401 1.344-2.522 1.344-.577 0-1.07-.177-1.462-.507a2.5 2.5 0 0 1-.66-.908C9.387 11.776 7.529 12.346 6 11.464 4.229 10.441 3.926 8.057 4.969 6.25S8.229 3.513 10 4.536c1.12.647 1.66 1.87 1.633 3.105l-.005.13c0 .687.038 1.397.226 1.923.091.255.201.415.313.51.098.083.242.153.494.153.536 0 .976-.27 1.31-.727.342-.47.529-1.091.529-1.63A6.5 6.5 0 0 0 8 1.5m2.133 6.102c.015-.798-.328-1.447-.883-1.767C8.39 5.339 7.02 5.698 6.268 7s-.377 2.67.482 3.165c.86.496 2.23.137 2.982-1.165.244-.422.37-.866.397-1.287z" clip-rule="evenodd"/>`
    }, props));
$36c7fc296df7b371$var$MentionIcon.displayName = 'MentionIcon';
var $36c7fc296df7b371$var$_default = module.exports.default = $36c7fc296df7b371$var$MentionIcon;

});

parcelRegister("jEA4C", function(module, exports) {

$parcel$export(module.exports, "default", () => $a83ff32e7e64d155$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $a83ff32e7e64d155$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    label: {
        id: 'fabric.editor.ai.screens.prompt.mentionButton.label',
        defaultMessage: 'Mention someone or a team',
        description: 'Mention button label within the Prompt screen'
    }
});

});


parcelRegister("ghcZR", function(module, exports) {

$parcel$export(module.exports, "createAIPromptPreset", () => $89ffc6e228fc5bb5$export$cd6e43a807ff0e0d);

var $8PuhX = parcelRequire("8PuhX");
parcelRequire("luHVi");
var $lwALS = parcelRequire("lwALS");
parcelRequire("9HYhn");
var $aflUx = parcelRequire("aflUx");
parcelRequire("1MKcc");
var $9J26c = parcelRequire("9J26c");
parcelRequire("ad5Kp");
var $1sH6J = parcelRequire("1sH6J");
parcelRequire("2gWfu");
var $89YFQ = parcelRequire("89YFQ");
parcelRequire("97XCP");
var $3SsmW = parcelRequire("3SsmW");
parcelRequire("7R4av");
var $aRWgy = parcelRequire("aRWgy");
parcelRequire("b8wHL");
var $lTMvj = parcelRequire("lTMvj");
parcelRequire("cZNzR");
var $4H0bV = parcelRequire("4H0bV");
parcelRequire("30v6T");
var $88434 = parcelRequire("88434");
parcelRequire("iQvAc");
var $d3sAY = parcelRequire("d3sAY");
parcelRequire("3eoq7");
var $iKcba = parcelRequire("iKcba");
parcelRequire("c9xno");
var $7gUM9 = parcelRequire("7gUM9");
parcelRequire("1Z833");
var $eJTQT = parcelRequire("eJTQT");
parcelRequire("1zlWn");
var $9RgM8 = parcelRequire("9RgM8");
parcelRequire("dN5B3");
var $5bKdQ = parcelRequire("5bKdQ");
parcelRequire("7fPgC");
var $7c4bW = parcelRequire("7c4bW");
parcelRequire("1mm8v");
var $jY2lE = parcelRequire("jY2lE");
parcelRequire("85rQi");
var $8EyJv = parcelRequire("8EyJv");
parcelRequire("blBYA");
var $hcgLS = parcelRequire("hcgLS");
parcelRequire("8S3vg");
var $eE2Rw = parcelRequire("eE2Rw");
parcelRequire("avoFZ");
var $ewf7Y = parcelRequire("ewf7Y");
parcelRequire("db6dP");
var $5F9b7 = parcelRequire("5F9b7");
parcelRequire("7PYeO");
var $7x7fd = parcelRequire("7x7fd");
parcelRequire("cb4jP");
var $6nO4A = parcelRequire("6nO4A");
function $89ffc6e228fc5bb5$export$cd6e43a807ff0e0d(options) {
    const cardPluginData = {
        ...options.linking?.smartLinks,
        linkPicker: options.linking?.linkPicker,
        lpLinkPicker: options.featureFlags?.lpLinkPicker ?? false,
        disableFloatingToolbar: true,
        showUpgradeDiscoverability: false,
        // We don't want to show block cards and embed cards in prompt editor.
        allowBlockCards: false,
        allowEmbeds: false
    };
    const preset = new (0, $8PuhX.EditorPresetBuilder)()// Handles feature flagging in Editor.
    .add([
        (0, $iKcba.featureFlagsPlugin),
        options.featureFlags
    ])// Most of analytics events in editor are fired by appending
    //  AnalyticsStep in transaction.
    // Without this plugin, none of those events will be fired.
    // If allowAnalyticsGASV3 is truthy, then analytics plugin will be added.
    .maybeAdd([
        (0, $lwALS.analyticsPlugin),
        {
            createAnalyticsEvent: options.createAnalyticsEvent
        }
    ], Boolean(options.allowAnalyticsGASV3))// Dependency of paste plugin
    .add((0, $9J26c.betterTypeHistoryPlugin))// we need paste plugin to handle paste event.
    .add([
        (0, $8EyJv.pastePlugin),
        {}
    ])// We need clipboard to handle cut and copy and clipboard serialization.
    .add((0, $aRWgy.default))// Handles focus and blur events.
    .add((0, $eJTQT.focusPlugin))// This plugin handles composition events and take care nuances of composition.
    // Need this plugin to have sleek composition support for languages such as Japanese, Chinese
    .add((0, $lTMvj.compositionPlugin))// Editor can't function without this plugin.
    // It takes care of doc, paragraph and text nodes, backbone of any document.
    .add([
        (0, $aflUx.default),
        {}
    ])// Dependency of cardPlugin, floatingToolbarPlugin
    .add((0, $88434.decorationsPlugin))// Depdency of undoRedoButtons
    .add((0, $5F9b7.typeAheadPlugin))// Depdency of undoRedoButtons
    .maybeAdd((0, $5bKdQ.default), true)// We want to support undo/redo through shortcuts.
    .maybeAdd((0, $7x7fd.undoRedoPlugin), true)// We should keep this plugin. It will remove all the marks when doc is empty.
    // It's very lightweight plugin.
    .add((0, $3SsmW.clearMarksOnEmptyDocPlugin))// Dependency of cardPlugin
    .maybeAdd([
        (0, $7c4bW.hyperlinkPlugin),
        {
            disableFloatingToolbar: !options.linkPicker,
            linkPicker: options.linkPicker
        }
    ], !!options.enableLinks).maybeAdd([
        (0, $jY2lE.mentionsPlugin)
    ], !!options.mentionProvider)// Dependency of cardPlugin, gridPlugin
    .add((0, $6nO4A.widthPlugin))// Need placeholder plugin to show placeholder
    .add([
        (0, $hcgLS.placeholderPlugin),
        options.placeholder
    ])// Dependency of floatingToolbarPlugin
    .add((0, $d3sAY.editorDisabledPlugin))// Dependency of floatingToolbarPlugin
    .add((0, $4H0bV.copyButtonPlugin))// Dependency of cardPlugin
    .add((0, $7gUM9.floatingToolbarPlugin))// Need selections plugin to handle selection nuances in editor, support gap cursor and keyboard handling for selection.
    .add([
        (0, $ewf7Y.selectionPlugin),
        {}
    ])// Need to have save on enter functionality. Without this plugin, on enter editor will add line break and then prompt is submited.
    .maybeAdd([
        (0, $eE2Rw.saveOnEnterPlugin),
        options.onSave
    ], !!options.onSave)// Dependency of cardPlugin
    .maybeAdd([
        (0, $9RgM8.gridPlugin),
        {}
    ], true)// Need card plugin to show smart links.
    .maybeAdd([
        (0, $89YFQ.cardPlugin),
        cardPluginData
    ], !!options.enableLinks)// Need this plugin for adding new line on `Shift + Enter` keymap
    .add([
        (0, $1sH6J.blockTypePlugin),
        {
            allowBlockType: {
                exclude: [
                    'heading',
                    'blockquote'
                ]
            }
        }
    ]);
    return preset;
}

});
parcelRegister("luHVi", function(module, exports) {

$parcel$export(module.exports, "analyticsPlugin", () => (parcelRequire("lwALS")).analyticsPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $lwALS = parcelRequire("lwALS");

});
parcelRegister("lwALS", function(module, exports) {

$parcel$export(module.exports, "analyticsPlugin", () => $80719fd57ab3b783$export$f26023c5d4a5ab44);

var $eJOHy = parcelRequire("eJOHy");

var $ivREi = parcelRequire("ivREi");

var $ftN6c = parcelRequire("ftN6c");

var $bMFKb = parcelRequire("bMFKb");
var $cd124 = parcelRequire("cd124");
var $jXreb = parcelRequire("jXreb");

var $8LHnV = parcelRequire("8LHnV");

var $65rqJ = parcelRequire("65rqJ");

var $i8KtF = parcelRequire("i8KtF");

var $L7w1W = parcelRequire("L7w1W");

var $d61jW = parcelRequire("d61jW");

var $dP40l = parcelRequire("dP40l");

var $1UO3X = parcelRequire("1UO3X");

var $6SN10 = parcelRequire("6SN10");
function $80719fd57ab3b783$var$createPlugin(options, featureFlags) {
    if (!options) return;
    const hasRequiredPerformanceAPIs = (0, $8LHnV.isPerformanceAPIAvailable)();
    return new (0, $i8KtF.SafePlugin)({
        key: (0, $1UO3X.analyticsPluginKey),
        state: {
            init: ()=>{
                return {
                    ...options,
                    fireAnalytics: (0, $cd124.fireAnalyticsEvent)(options.createAnalyticsEvent)
                };
            },
            apply: (tr, pluginState, _, state)=>{
                const { createAnalyticsEvent: createAnalyticsEvent } = tr.getMeta((0, $1UO3X.analyticsPluginKey)) ?? {};
                // When the createAnalyticsEvent is reconfigured
                if (options.createAnalyticsEvent && options.createAnalyticsEvent !== pluginState.createAnalyticsEvent || pluginState.createAnalyticsEvent !== createAnalyticsEvent && createAnalyticsEvent) return {
                    ...pluginState,
                    createAnalyticsEvent: options.createAnalyticsEvent ?? createAnalyticsEvent
                };
                if (featureFlags.catchAllTracking) {
                    const analyticsEventWithChannel = (0, $jXreb.getAnalyticsEventsFromTransaction)(tr);
                    if (analyticsEventWithChannel.length > 0) {
                        for (const { payload: payload, channel: channel } of analyticsEventWithChannel)// Measures how much time it takes to update the DOM after each ProseMirror document update
                        // that has an analytics event.
                        if (hasRequiredPerformanceAPIs && tr.docChanged && payload.action !== (0, $bMFKb.ACTION).INSERTED && payload.action !== (0, $bMFKb.ACTION).DELETED) {
                            const measureName = `${payload.actionSubject}:${payload.action}:${payload.actionSubjectId}`;
                            (0, $65rqJ.measureRender)(// NOTE this name could be resulting in misleading data -- where if multiple payloads are
                            // received before a render completes -- the measurement value will be inaccurate (this is
                            // due to measureRender requiring unique measureNames)
                            measureName, ({ duration: duration, distortedDuration: distortedDuration })=>{
                                (0, $cd124.fireAnalyticsEvent)(pluginState.createAnalyticsEvent)({
                                    payload: $80719fd57ab3b783$export$a3e5fcfb76b37e49({
                                        payload: payload,
                                        duration: duration,
                                        distortedDuration: distortedDuration
                                    }),
                                    channel: channel
                                });
                            });
                        }
                    }
                }
                return pluginState;
            }
        }
    });
}
/**
 * Analytics plugin to be added to an `EditorPresetBuilder` and used with `ComposableEditor`
 * from `@atlaskit/editor-core`.
 */ const $80719fd57ab3b783$export$f26023c5d4a5ab44 = ({ config: options = {}, api: api })=>{
    const featureFlags = api?.featureFlags?.sharedState.currentState() || {};
    const analyticsEventPropQueue = new Set();
    return {
        name: 'analytics',
        getSharedState: (editorState)=>{
            if (!editorState) return {
                createAnalyticsEvent: null,
                attachAnalyticsEvent: null,
                performanceTracking: undefined
            };
            const { createAnalyticsEvent: createAnalyticsEvent, performanceTracking: performanceTracking } = (0, $1UO3X.analyticsPluginKey).getState(editorState) ?? {};
            return {
                createAnalyticsEvent: createAnalyticsEvent,
                attachAnalyticsEvent: (0, $L7w1W.createAttachPayloadIntoTransaction)(editorState.selection),
                performanceTracking: performanceTracking
            };
        },
        actions: {
            attachAnalyticsEvent: (payload, channel = (0, $dP40l.editorAnalyticsChannel))=>(tr)=>{
                    const { createAnalyticsEvent: createAnalyticsEvent, attachAnalyticsEvent: attachAnalyticsEvent } = api?.analytics?.sharedState.currentState() ?? {};
                    if (!tr || !createAnalyticsEvent || !attachAnalyticsEvent) {
                        analyticsEventPropQueue.add({
                            payload: payload,
                            channel: channel
                        });
                        return false;
                    }
                    attachAnalyticsEvent({
                        tr: tr,
                        payload: payload,
                        channel: channel
                    });
                    return true;
                },
            fireAnalyticsEvent: (payload, channel = (0, $dP40l.editorAnalyticsChannel), options)=>{
                const { createAnalyticsEvent: createAnalyticsEvent } = api?.analytics?.sharedState.currentState() ?? {};
                if (options?.context) payload = (0, $d61jW.getStateContext)(options.context.selection, payload);
                if (!createAnalyticsEvent) {
                    analyticsEventPropQueue.add({
                        payload: payload,
                        channel: channel
                    });
                    return;
                }
                (0, $cd124.fireAnalyticsEvent)(createAnalyticsEvent, options)({
                    payload: payload,
                    channel: channel
                });
            }
        },
        usePluginHook ({ editorView: editorView }) {
            const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
            (0, $eJOHy.useLayoutEffect)(()=>{
                const { dispatch: dispatch, state: { tr: tr } } = editorView;
                tr.setMeta((0, $1UO3X.analyticsPluginKey), {
                    createAnalyticsEvent: createAnalyticsEvent
                });
                dispatch(tr);
                // Attach all analytics events to the transaction
                analyticsEventPropQueue.forEach(({ payload: payload, channel: channel })=>{
                    createAnalyticsEvent(payload)?.fire(channel ?? (0, $dP40l.editorAnalyticsChannel));
                });
                // Clear the queue
                analyticsEventPropQueue.clear();
            }, [
                createAnalyticsEvent,
                editorView
            ]);
        },
        pmPlugins () {
            return [
                {
                    name: 'analyticsPlugin',
                    plugin: ()=>$80719fd57ab3b783$var$createPlugin(options, featureFlags)
                }
            ];
        },
        onEditorViewStateUpdated ({ originalTransaction: originalTransaction, transactions: transactions, newEditorState: newEditorState }) {
            const pluginState = (0, $1UO3X.analyticsPluginKey).getState(newEditorState);
            if (!pluginState || !pluginState.createAnalyticsEvent) return;
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const steps = transactions.reduce((acc, tr)=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const payloads = tr.steps// Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                .filter((step)=>step instanceof (0, $ivREi.AnalyticsStep)).map((x)=>x.analyticsEvents).reduce((acc, val)=>acc.concat(val), []);
                acc.push(...payloads);
                return acc;
            }, []);
            if (steps.length === 0) return;
            const { createAnalyticsEvent: createAnalyticsEvent } = pluginState;
            const undoAnaltyicsEventTransformer = (0, $6SN10.generateUndoRedoInputSoucePayload)(originalTransaction);
            steps.forEach(({ payload: payload, channel: channel })=>{
                const nextPayload = undoAnaltyicsEventTransformer(payload);
                (0, $cd124.fireAnalyticsEvent)(createAnalyticsEvent)({
                    payload: nextPayload,
                    channel: channel
                });
            });
        }
    };
};
function $80719fd57ab3b783$export$a3e5fcfb76b37e49({ payload: payload, duration: duration, distortedDuration: distortedDuration }) {
    return {
        ...payload,
        attributes: {
            ...payload.attributes,
            duration: duration,
            distortedDuration: distortedDuration
        },
        eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL
    };
}

});
parcelRegister("L7w1W", function(module, exports) {

$parcel$export(module.exports, "createAttachPayloadIntoTransaction", () => $35d40a097a5fe322$export$539ce7f09649e93);

var $ivREi = parcelRequire("ivREi");

var $bMFKb = parcelRequire("bMFKb");

var $d61jW = parcelRequire("d61jW");

var $hUTXv = parcelRequire("hUTXv");
const $35d40a097a5fe322$var$actionsToIgnore = [
    (0, $bMFKb.ACTION).INVOKED,
    (0, $bMFKb.ACTION).OPENED
];
const $35d40a097a5fe322$export$539ce7f09649e93 = (selection)=>({ payload: payload, tr: tr, channel: channel })=>$35d40a097a5fe322$export$dff9776b7883fc5f({
            payload: payload,
            selection: selection,
            tr: tr,
            channel: channel
        });
const $35d40a097a5fe322$export$dff9776b7883fc5f = ({ payload: payload, selection: selection, tr: tr, channel: channel })=>{
    payload = (0, $d61jW.getStateContext)(selection, payload, tr);
    payload = (0, $hUTXv.mapActionSubjectIdToAttributes)(payload);
    const { storedMarks: storedMarks } = tr;
    const pos = tr.mapping.map(selection.$from.pos, -1);
    tr.step(new (0, $ivREi.AnalyticsStep)([
        {
            payload: payload,
            channel: channel
        }
    ], $35d40a097a5fe322$var$actionsToIgnore, pos));
    // When you add a new step all the storedMarks are removed it
    if (storedMarks) tr.setStoredMarks(storedMarks);
};

});
parcelRegister("d61jW", function(module, exports) {

$parcel$export(module.exports, "getStateContext", () => $ebfd02aa5b6eea1c$export$b8d8bec4e31cbd66);

var $bMFKb = parcelRequire("bMFKb");
var $7b6MG = parcelRequire("7b6MG");

var $dyNYh = parcelRequire("dyNYh");

var $3lIcL = parcelRequire("3lIcL");

var $BmspC = parcelRequire("BmspC");

var $cwzAY = parcelRequire("cwzAY");
function $ebfd02aa5b6eea1c$export$ab5b04535d7a5950(selection) {
    let type;
    let position;
    if (selection?.constructor?.name === 'GapCursorSelection') {
        type = (0, $7b6MG.SELECTION_TYPE).GAP_CURSOR;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        position = selection.side;
    } else if (selection instanceof (0, $cwzAY.CellSelection)) type = (0, $7b6MG.SELECTION_TYPE).CELL;
    else if (selection instanceof (0, $3lIcL.NodeSelection)) type = (0, $7b6MG.SELECTION_TYPE).NODE;
    else if (selection.from !== selection.to) type = (0, $7b6MG.SELECTION_TYPE).RANGED;
    else {
        type = (0, $7b6MG.SELECTION_TYPE).CURSOR;
        const { from: from, $from: $from } = selection;
        if (from === $from.start()) position = (0, $7b6MG.SELECTION_POSITION).START;
        else if (from === $from.end()) position = (0, $7b6MG.SELECTION_POSITION).END;
        else position = (0, $7b6MG.SELECTION_POSITION).MIDDLE;
    }
    return {
        type: type,
        position: position
    };
}
function $ebfd02aa5b6eea1c$export$46ac691122c4c55e(oldSelection, newSelection) {
    const { schema: schema } = newSelection.$from.doc.type;
    const { nodes: { paragraph: paragraph, table: table } } = schema;
    if (oldSelection instanceof (0, $cwzAY.CellSelection)) return table.name;
    const insertLocationInfo = (0, $BmspC.findParentNode)((node)=>node.type !== paragraph)(oldSelection);
    let parentNodePos = newSelection.$from.doc.resolve(insertLocationInfo?.start || 0);
    // Keep going one level above the attempted insert position till we find a node that contains the current cursor position in it's range
    while(parentNodePos.end() < newSelection.$from.pos)parentNodePos = newSelection.$from.doc.resolve(parentNodePos.start(Math.max(parentNodePos.depth - 1, 0)));
    return parentNodePos.node().type.name;
}
function $ebfd02aa5b6eea1c$export$b8d8bec4e31cbd66(selection, payload, tr) {
    if (!payload.attributes) return payload;
    const { type: type, position: position } = $ebfd02aa5b6eea1c$export$ab5b04535d7a5950(selection);
    payload.attributes.selectionType = type;
    if (position) payload.attributes.selectionPosition = position;
    const insertLocation = (0, $dyNYh.findInsertLocation)(selection);
    if (tr && payload.action === (0, $bMFKb.ACTION).INSERTED && payload.actionSubject !== (0, $bMFKb.ACTION_SUBJECT).ANNOTATION && payload.actionSubject !== (0, $bMFKb.ACTION_SUBJECT).EDITOR_PLUGIN_AI) payload.attributes.insertedLocation = $ebfd02aa5b6eea1c$export$46ac691122c4c55e(selection, tr.selection);
    if (payload.action === (0, $bMFKb.ACTION).INSERTED && payload.actionSubject === (0, $bMFKb.ACTION_SUBJECT).DOCUMENT && payload.attributes) payload.attributes.insertLocation = insertLocation;
    else payload.attributes.nodeLocation = insertLocation;
    return payload;
}

});
parcelRegister("7b6MG", function(module, exports) {

$parcel$export(module.exports, "SELECTION_TYPE", () => $6c26cf597578895c$export$96527b3d022fe7df);
$parcel$export(module.exports, "SELECTION_POSITION", () => $6c26cf597578895c$export$f64a96dc7664cbe5);
var $6c26cf597578895c$export$96527b3d022fe7df = /*#__PURE__*/ function(SELECTION_TYPE) {
    SELECTION_TYPE["CURSOR"] = "cursor";
    SELECTION_TYPE["RANGED"] = "ranged";
    SELECTION_TYPE["TEXT"] = "text";
    SELECTION_TYPE["NODE"] = "node";
    SELECTION_TYPE["CELL"] = "cell";
    SELECTION_TYPE["GAP_CURSOR"] = "gapCursor";
    return SELECTION_TYPE;
}({});
var $6c26cf597578895c$export$f64a96dc7664cbe5 = /*#__PURE__*/ function(SELECTION_POSITION) {
    SELECTION_POSITION["START"] = "start";
    SELECTION_POSITION["MIDDLE"] = "middle";
    SELECTION_POSITION["END"] = "end";
    SELECTION_POSITION["LEFT"] = "left";
    SELECTION_POSITION["RIGHT"] = "right";
    return SELECTION_POSITION;
}({});

});


parcelRegister("hUTXv", function(module, exports) {

$parcel$export(module.exports, "mapActionSubjectIdToAttributes", () => $90f7f815af8801c6$export$dd48e359ffe98e59);

var $bMFKb = parcelRequire("bMFKb");
function $90f7f815af8801c6$export$dd48e359ffe98e59(payload) {
    const documentInserted = payload.action === (0, $bMFKb.ACTION).INSERTED && payload.actionSubject === (0, $bMFKb.ACTION_SUBJECT).DOCUMENT;
    const textFormatted = payload.action === (0, $bMFKb.ACTION).FORMATTED && payload.actionSubject === (0, $bMFKb.ACTION_SUBJECT).TEXT;
    const hasActionSubjectId = !!payload.actionSubjectId;
    if (hasActionSubjectId && (documentInserted || textFormatted)) payload.attributes = {
        ...payload.attributes,
        // @ts-expect-error
        actionSubjectId: payload.actionSubjectId
    };
    return payload;
}

});


parcelRegister("dP40l", function(module, exports) {

$parcel$export(module.exports, "editorAnalyticsChannel", () => $09420955a474546e$export$1467dbbb3bb418c6);

var $bgewf = parcelRequire("bgewf");
const $09420955a474546e$export$1467dbbb3bb418c6 = (0, $bgewf.FabricChannel).editor;

});

parcelRegister("1UO3X", function(module, exports) {

$parcel$export(module.exports, "analyticsPluginKey", () => $9c73771a868aeb9d$export$c4a4504e8a9a0b2e);

var $3lIcL = parcelRequire("3lIcL");
const $9c73771a868aeb9d$export$c4a4504e8a9a0b2e = new (0, $3lIcL.PluginKey)('analyticsPlugin');

});

parcelRegister("6SN10", function(module, exports) {

$parcel$export(module.exports, "generateUndoRedoInputSoucePayload", () => $d90210338f43b9a5$export$67d130a769494b9b);
const $d90210338f43b9a5$var$getUndoRedoInputSource = (tr)=>{
    // Please, do not copy or use this kind of code below
    return tr.getMeta('undoRedoPlugin$') ?? null;
};
const $d90210338f43b9a5$export$67d130a769494b9b = (tr)=>{
    const undoRedoPluginInputSource = $d90210338f43b9a5$var$getUndoRedoInputSource(tr);
    return (payload)=>{
        const shouldAddHistoryTriggerMethodAttribute = undoRedoPluginInputSource && [
            'undid',
            'redid'
        ].includes(payload.action);
        return !shouldAddHistoryTriggerMethodAttribute ? payload : {
            ...payload,
            attributes: {
                ...payload.attributes,
                historyTriggerMethod: undoRedoPluginInputSource
            }
        };
    };
};

});



parcelRegister("9HYhn", function(module, exports) {

$parcel$export(module.exports, "basePlugin", () => (parcelRequire("aflUx")).default);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $aflUx = parcelRequire("aflUx");

});
parcelRegister("aflUx", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb08d8614905fb69$export$2e2bcd8739ae039);

var $gjQyF = parcelRequire("gjQyF");
var $bK3tx = parcelRequire("bK3tx");
var $53i5t = parcelRequire("53i5t");

var $c9NXO = parcelRequire("c9NXO");

var $dEkUJ = parcelRequire("dEkUJ");

var $kuxd1 = parcelRequire("kuxd1");

var $92xoS = parcelRequire("92xoS");

var $kFUgU = parcelRequire("kFUgU");

var $kccJu = parcelRequire("kccJu");

var $Fp2cl = parcelRequire("Fp2cl");

var $9udmP = parcelRequire("9udmP");

var $hVrgn = parcelRequire("hVrgn");

var $iUuxx = parcelRequire("iUuxx");

var $8hwRf = parcelRequire("8hwRf");

var $2frjn = parcelRequire("2frjn");

var $02sTQ = parcelRequire("02sTQ");

var $htlTO = parcelRequire("htlTO");
function $bb08d8614905fb69$export$edcd20463038b9e1(from, to, tr, callbacks) {
    const { doc: doc } = tr;
    doc.nodesBetween(from, to, (node, pos)=>{
        callbacks.forEach((cb)=>cb({
                tr: tr,
                node: node,
                pos: pos,
                from: from,
                to: to
            }));
    });
}
const $bb08d8614905fb69$var$SMART_TO_ASCII = {
    "\u2026": '...',
    "\u2192": '->',
    "\u2190": '<-',
    "\u2013": '--',
    "\u201C": '"',
    "\u201D": '"',
    "\u2018": "'",
    "\u2019": "'"
};
// eslint-disable-next-line require-unicode-regexp
const $bb08d8614905fb69$var$FIND_SMART_CHAR = new RegExp(`[${Object.keys($bb08d8614905fb69$var$SMART_TO_ASCII).join('')}]`, 'g');
const $bb08d8614905fb69$var$basePlugin = ({ config: options, api: api })=>{
    const featureFlags = api?.featureFlags?.sharedState.currentState() || {};
    const callbacks = [];
    api?.base?.actions.registerMarks(({ tr: tr, node: node, pos: pos, from: from, to: to })=>{
        const { doc: doc } = tr;
        const { schema: schema } = doc.type;
        const { text: textNodeType } = schema.nodes;
        if (node.type === textNodeType && node.text) {
            // Find a valid start and end position because the text may be partially selected.
            const startPositionInSelection = Math.max(pos, from);
            const endPositionInSelection = Math.min(pos + node.nodeSize, to);
            const textForReplacing = doc.textBetween(startPositionInSelection, endPositionInSelection);
            const newText = textForReplacing.replace($bb08d8614905fb69$var$FIND_SMART_CHAR, (match)=>$bb08d8614905fb69$var$SMART_TO_ASCII[match] ?? match);
            const currentStartPos = tr.mapping.map(startPositionInSelection);
            const currentEndPos = tr.mapping.map(endPositionInSelection);
            tr.replaceWith(currentStartPos, currentEndPos, schema.text(newText, node.marks));
        }
    });
    return {
        name: 'base',
        getSharedState (editorState) {
            return {
                keyboardHeight: (0, $02sTQ.getKeyboardHeight)(editorState)
            };
        },
        actions: {
            setKeyboardHeight: $kFUgU.setKeyboardHeight,
            resolveMarks: (from, to, tr)=>$bb08d8614905fb69$export$edcd20463038b9e1(from, to, tr, callbacks),
            registerMarks: (callback)=>{
                callbacks.push(callback);
            }
        },
        pmPlugins () {
            const plugins = [
                {
                    name: 'filterStepsPlugin',
                    plugin: ({ dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>(0, $Fp2cl.default)(dispatchAnalyticsEvent)
                }
            ];
            if ((0, $92xoS.editorExperiment)('platform_editor_exp_lazy_node_views', true, {
                exposure: true
            })) plugins.push({
                name: 'lazyNodeViewDecorationsPlugin',
                plugin: ()=>(0, $iUuxx.createLazyNodeViewDecorationPlugin)()
            });
            // In Chrome, when the selection is placed between adjacent nodes which are not contenteditatble
            // the cursor appears at the right most point of the parent container.
            //
            // In Firefox, when the selection is placed between adjacent nodes which are not contenteditatble
            // no cursor is presented to users.
            //
            // In Safari, when the selection is placed between adjacent nodes which are not contenteditatble
            // it is not possible to navigate with arrow keys.
            //
            // This plugin works around the issues by inserting decorations between
            // inline nodes which are set as contenteditable, and have a zero width space.
            plugins.push({
                name: 'inlineCursorTargetPlugin',
                plugin: ()=>options && options.allowInlineCursorTarget ? (0, $hVrgn.default)() : undefined
            });
            plugins.push({
                name: 'newlinePreserveMarksPlugin',
                plugin: (0, $8hwRf.default)
            }, {
                name: 'frozenEditor',
                plugin: ({ dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
                    return (0, $9udmP.default)(api?.contextIdentifier)(dispatchAnalyticsEvent, (0, $htlTO.inputTracking), undefined);
                }
            }, {
                name: 'history',
                plugin: ()=>(0, $kuxd1.history)()
            }, // should be last :(
            {
                name: 'codeBlockIndent',
                plugin: ()=>(0, $c9NXO.keymap)({
                        ...(0, $dEkUJ.baseKeymap),
                        'Mod-[': ()=>true,
                        'Mod-]': ()=>true
                    })
            });
            if (options && options.allowScrollGutter) plugins.push({
                name: 'scrollGutterPlugin',
                plugin: ()=>(0, $2frjn.default)(options.allowScrollGutter)
            });
            plugins.push({
                name: 'disableSpellcheckingPlugin',
                plugin: ()=>(0, $kccJu.default)(featureFlags)
            });
            return plugins;
        },
        nodes () {
            return [
                {
                    name: 'doc',
                    node: (0, $gjQyF.doc)
                },
                {
                    name: 'paragraph',
                    node: (0, $bK3tx.paragraph)
                },
                {
                    name: 'text',
                    node: (0, $53i5t.text)
                }
            ];
        }
    };
};
var $bb08d8614905fb69$export$2e2bcd8739ae039 = $bb08d8614905fb69$var$basePlugin;

});
parcelRegister("c9NXO", function(module, exports) {

$parcel$export(module.exports, "keymap", () => $ce32827cb979a5c5$export$5043418e2ef368d5);

var $1rXzn = parcelRequire("1rXzn");

var $x7sgX = parcelRequire("x7sgX");

var $i8KtF = parcelRequire("i8KtF");
function $ce32827cb979a5c5$export$5043418e2ef368d5(bindings) {
    return new (0, $i8KtF.SafePlugin)({
        props: {
            handleKeyDown (view, event) {
                const name = (0, $1rXzn.keyName)(event);
                let keyboardEvent = event;
                // We will try to bypass the keycode only if any of mod keys are pressed,
                // to allow users to use non-latin and Dead characters.
                const isModKeyPressed = event.ctrlKey || event.metaKey;
                // Check the unicode of the character to assert that it's not an ASCII character.
                // These are characters outside latin's range.
                // Ignored via go/ees005
                // eslint-disable-next-line require-unicode-regexp
                const isNonLatinKey = name.length === 1 && /[^\u0000-\u007f]/.test(name);
                // The `Dead` key is a key that combines with a following key to produce a combined character.
                // It will have `even.key === 'Dead'` in some browsers but the `keyCode` will be the same as in a qwerty-keyboard.
                // See https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key and https://en.wikipedia.org/wiki/Dead_key
                const isDeadKey = name === 'Dead';
                if (isModKeyPressed && (isNonLatinKey || isDeadKey)) keyboardEvent = new KeyboardEvent(event.type, {
                    // Ignored via go/ees007
                    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
                    // FIXME: The event.keyCode is deprecated (see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/keyCode),
                    // and could be removed in any time, but the w3c-keyname library doesn't provide a way to get
                    // a key by event.code.
                    key: (0, $1rXzn.base)[event.keyCode],
                    code: event.code,
                    ctrlKey: event.ctrlKey,
                    altKey: event.altKey,
                    metaKey: event.metaKey,
                    shiftKey: event.shiftKey
                });
                return (0, $x7sgX.keydownHandler)(bindings)(view, keyboardEvent);
            }
        }
    });
}

});
parcelRegister("1rXzn", function(module, exports) {

$parcel$export(module.exports, "base", () => $10e6855a98fb7649$export$e2253033e6e1df16);
$parcel$export(module.exports, "shift", () => $10e6855a98fb7649$export$fba63a578e423eb);
$parcel$export(module.exports, "keyName", () => $10e6855a98fb7649$export$fb33aafd75404f4c);
var $10e6855a98fb7649$export$e2253033e6e1df16 = {
    8: "Backspace",
    9: "Tab",
    10: "Enter",
    12: "NumLock",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    44: "PrintScreen",
    45: "Insert",
    46: "Delete",
    59: ";",
    61: "=",
    91: "Meta",
    92: "Meta",
    106: "*",
    107: "+",
    108: ",",
    109: "-",
    110: ".",
    111: "/",
    144: "NumLock",
    145: "ScrollLock",
    160: "Shift",
    161: "Shift",
    162: "Control",
    163: "Control",
    164: "Alt",
    165: "Alt",
    173: "-",
    186: ";",
    187: "=",
    188: ",",
    189: "-",
    190: ".",
    191: "/",
    192: "`",
    219: "[",
    220: "\\",
    221: "]",
    222: "'"
};
var $10e6855a98fb7649$export$fba63a578e423eb = {
    48: ")",
    49: "!",
    50: "@",
    51: "#",
    52: "$",
    53: "%",
    54: "^",
    55: "&",
    56: "*",
    57: "(",
    59: ":",
    61: "+",
    173: "_",
    186: ":",
    187: "+",
    188: "<",
    189: "_",
    190: ">",
    191: "?",
    192: "~",
    219: "{",
    220: "|",
    221: "}",
    222: "\""
};
var $10e6855a98fb7649$var$mac = typeof navigator != "undefined" && /Mac/.test(navigator.platform);
var $10e6855a98fb7649$var$ie = typeof navigator != "undefined" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
// Fill in the digit keys
for(var $10e6855a98fb7649$var$i = 0; $10e6855a98fb7649$var$i < 10; $10e6855a98fb7649$var$i++)$10e6855a98fb7649$export$e2253033e6e1df16[48 + $10e6855a98fb7649$var$i] = $10e6855a98fb7649$export$e2253033e6e1df16[96 + $10e6855a98fb7649$var$i] = String($10e6855a98fb7649$var$i);
// The function keys
for(var $10e6855a98fb7649$var$i = 1; $10e6855a98fb7649$var$i <= 24; $10e6855a98fb7649$var$i++)$10e6855a98fb7649$export$e2253033e6e1df16[$10e6855a98fb7649$var$i + 111] = "F" + $10e6855a98fb7649$var$i;
// And the alphabetic keys
for(var $10e6855a98fb7649$var$i = 65; $10e6855a98fb7649$var$i <= 90; $10e6855a98fb7649$var$i++){
    $10e6855a98fb7649$export$e2253033e6e1df16[$10e6855a98fb7649$var$i] = String.fromCharCode($10e6855a98fb7649$var$i + 32);
    $10e6855a98fb7649$export$fba63a578e423eb[$10e6855a98fb7649$var$i] = String.fromCharCode($10e6855a98fb7649$var$i);
}
// For each code that doesn't have a shift-equivalent, copy the base name
for(var $10e6855a98fb7649$var$code in $10e6855a98fb7649$export$e2253033e6e1df16)if (!$10e6855a98fb7649$export$fba63a578e423eb.hasOwnProperty($10e6855a98fb7649$var$code)) $10e6855a98fb7649$export$fba63a578e423eb[$10e6855a98fb7649$var$code] = $10e6855a98fb7649$export$e2253033e6e1df16[$10e6855a98fb7649$var$code];
function $10e6855a98fb7649$export$fb33aafd75404f4c(event) {
    // On macOS, keys held with Shift and Cmd don't reflect the effect of Shift in `.key`.
    // On IE, shift effect is never included in `.key`.
    var ignoreKey = $10e6855a98fb7649$var$mac && event.metaKey && event.shiftKey && !event.ctrlKey && !event.altKey || $10e6855a98fb7649$var$ie && event.shiftKey && event.key && event.key.length == 1 || event.key == "Unidentified";
    var name = !ignoreKey && event.key || (event.shiftKey ? $10e6855a98fb7649$export$fba63a578e423eb : $10e6855a98fb7649$export$e2253033e6e1df16)[event.keyCode] || event.key || "Unidentified";
    // Edge sometimes produces wrong names (Issue #3)
    if (name == "Esc") name = "Escape";
    if (name == "Del") name = "Delete";
    // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/8860571/
    if (name == "Left") name = "ArrowLeft";
    if (name == "Up") name = "ArrowUp";
    if (name == "Right") name = "ArrowRight";
    if (name == "Down") name = "ArrowDown";
    return name;
}

});

parcelRegister("x7sgX", function(module, exports) {

$parcel$export(module.exports, "keymap", () => $0638dd97826018c9$export$5043418e2ef368d5);
$parcel$export(module.exports, "keydownHandler", () => $0638dd97826018c9$export$53f558754f8b9fd1);

var $1rXzn = parcelRequire("1rXzn");

var $3lIcL = parcelRequire("3lIcL");
const $0638dd97826018c9$var$mac = typeof navigator != "undefined" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : false;
function $0638dd97826018c9$var$normalizeKeyName(name) {
    let parts = name.split(/-(?!$)/), result = parts[parts.length - 1];
    if (result == "Space") result = " ";
    let alt, ctrl, shift, meta;
    for(let i = 0; i < parts.length - 1; i++){
        let mod = parts[i];
        if (/^(cmd|meta|m)$/i.test(mod)) meta = true;
        else if (/^a(lt)?$/i.test(mod)) alt = true;
        else if (/^(c|ctrl|control)$/i.test(mod)) ctrl = true;
        else if (/^s(hift)?$/i.test(mod)) shift = true;
        else if (/^mod$/i.test(mod)) {
            if ($0638dd97826018c9$var$mac) meta = true;
            else ctrl = true;
        } else throw new Error("Unrecognized modifier name: " + mod);
    }
    if (alt) result = "Alt-" + result;
    if (ctrl) result = "Ctrl-" + result;
    if (meta) result = "Meta-" + result;
    if (shift) result = "Shift-" + result;
    return result;
}
function $0638dd97826018c9$var$normalize(map) {
    let copy = Object.create(null);
    for(let prop in map)copy[$0638dd97826018c9$var$normalizeKeyName(prop)] = map[prop];
    return copy;
}
function $0638dd97826018c9$var$modifiers(name, event, shift = true) {
    if (event.altKey) name = "Alt-" + name;
    if (event.ctrlKey) name = "Ctrl-" + name;
    if (event.metaKey) name = "Meta-" + name;
    if (shift && event.shiftKey) name = "Shift-" + name;
    return name;
}
/**
Create a keymap plugin for the given set of bindings.

Bindings should map key names to [command](https://prosemirror.net/docs/ref/#commands)-style
functions, which will be called with `(EditorState, dispatch,
EditorView)` arguments, and should return true when they've handled
the key. Note that the view argument isn't part of the command
protocol, but can be used as an escape hatch if a binding needs to
directly interact with the UI.

Key names may be strings like `"Shift-Ctrl-Enter"`—a key
identifier prefixed with zero or more modifiers. Key identifiers
are based on the strings that can appear in
[`KeyEvent.key`](https:developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key).
Use lowercase letters to refer to letter keys (or uppercase letters
if you want shift to be held). You may use `"Space"` as an alias
for the `" "` name.

Modifiers can be given in any order. `Shift-` (or `s-`), `Alt-` (or
`a-`), `Ctrl-` (or `c-` or `Control-`) and `Cmd-` (or `m-` or
`Meta-`) are recognized. For characters that are created by holding
shift, the `Shift-` prefix is implied, and should not be added
explicitly.

You can use `Mod-` as a shorthand for `Cmd-` on Mac and `Ctrl-` on
other platforms.

You can add multiple keymap plugins to an editor. The order in
which they appear determines their precedence (the ones early in
the array get to dispatch first).
*/ function $0638dd97826018c9$export$5043418e2ef368d5(bindings) {
    return new (0, $3lIcL.Plugin)({
        props: {
            handleKeyDown: $0638dd97826018c9$export$53f558754f8b9fd1(bindings)
        }
    });
}
/**
Given a set of bindings (using the same format as
[`keymap`](https://prosemirror.net/docs/ref/#keymap.keymap)), return a [keydown
handler](https://prosemirror.net/docs/ref/#view.EditorProps.handleKeyDown) that handles them.
*/ function $0638dd97826018c9$export$53f558754f8b9fd1(bindings) {
    let map = $0638dd97826018c9$var$normalize(bindings);
    return function(view, event) {
        let name = (0, $1rXzn.keyName)(event), baseName, direct = map[$0638dd97826018c9$var$modifiers(name, event)];
        if (direct && direct(view.state, view.dispatch, view)) return true;
        // A character key
        if (name.length == 1 && name != " ") {
            if (event.shiftKey) {
                // In case the name was already modified by shift, try looking
                // it up without its shift modifier
                let noShift = map[$0638dd97826018c9$var$modifiers(name, event, false)];
                if (noShift && noShift(view.state, view.dispatch, view)) return true;
            }
            if ((event.shiftKey || event.altKey || event.metaKey || name.charCodeAt(0) > 127) && (baseName = (0, $1rXzn.base)[event.keyCode]) && baseName != name) {
                // Try falling back to the keyCode when there's a modifier
                // active or the character produced isn't ASCII, and our table
                // produces a different name from the the keyCode. See #668,
                // #1060
                let fromCode = map[$0638dd97826018c9$var$modifiers(baseName, event)];
                if (fromCode && fromCode(view.state, view.dispatch, view)) return true;
            }
        }
        return false;
    };
}

});


parcelRegister("dEkUJ", function(module, exports) {

$parcel$export(module.exports, "deleteSelection", () => $9eff3bdfd297a823$export$e9a518a637d1e641);
$parcel$export(module.exports, "selectNodeBackward", () => $9eff3bdfd297a823$export$52b8a4af68d19794);
$parcel$export(module.exports, "createParagraphNear", () => $9eff3bdfd297a823$export$d0f80ac1b4510888);
$parcel$export(module.exports, "splitBlock", () => $9eff3bdfd297a823$export$e99155638ff4dff0);
$parcel$export(module.exports, "toggleMark", () => $9eff3bdfd297a823$export$797ad2667b8015a8);
$parcel$export(module.exports, "autoJoin", () => $9eff3bdfd297a823$export$29903073afddcd8b);
$parcel$export(module.exports, "chainCommands", () => $9eff3bdfd297a823$export$146a774cdef7663a);
$parcel$export(module.exports, "baseKeymap", () => $9eff3bdfd297a823$export$4a0c2b85b1f0a889);

var $lzEKq = parcelRequire("lzEKq");

var $3xw6l = parcelRequire("3xw6l");

var $3lIcL = parcelRequire("3lIcL");
/**
Delete the selection, if there is one.
*/ const $9eff3bdfd297a823$export$e9a518a637d1e641 = (state, dispatch)=>{
    if (state.selection.empty) return false;
    if (dispatch) dispatch(state.tr.deleteSelection().scrollIntoView());
    return true;
};
function $9eff3bdfd297a823$var$atBlockStart(state, view) {
    let { $cursor: $cursor } = state.selection;
    if (!$cursor || (view ? !view.endOfTextblock("backward", state) : $cursor.parentOffset > 0)) return null;
    return $cursor;
}
/**
If the selection is empty and at the start of a textblock, try to
reduce the distance between that block and the one before it—if
there's a block directly before it that can be joined, join them.
If not, try to move the selected block closer to the next one in
the document structure by lifting it out of its parent or moving it
into a parent of the previous block. Will use the view for accurate
(bidi-aware) start-of-textblock detection if given.
*/ const $9eff3bdfd297a823$export$979097b097459299 = (state, dispatch, view)=>{
    let $cursor = $9eff3bdfd297a823$var$atBlockStart(state, view);
    if (!$cursor) return false;
    let $cut = $9eff3bdfd297a823$var$findCutBefore($cursor);
    // If there is no node before this, try to lift
    if (!$cut) {
        let range = $cursor.blockRange(), target = range && (0, $lzEKq.liftTarget)(range);
        if (target == null) return false;
        if (dispatch) dispatch(state.tr.lift(range, target).scrollIntoView());
        return true;
    }
    let before = $cut.nodeBefore;
    // Apply the joining algorithm
    if ($9eff3bdfd297a823$var$deleteBarrier(state, $cut, dispatch, -1)) return true;
    // If the node below has no content and the node above is
    // selectable, delete the node below and select the one above.
    if ($cursor.parent.content.size == 0 && ($9eff3bdfd297a823$var$textblockAt(before, "end") || (0, $3lIcL.NodeSelection).isSelectable(before))) for(let depth = $cursor.depth;; depth--){
        let delStep = (0, $lzEKq.replaceStep)(state.doc, $cursor.before(depth), $cursor.after(depth), (0, $3xw6l.Slice).empty);
        if (delStep && delStep.slice.size < delStep.to - delStep.from) {
            if (dispatch) {
                let tr = state.tr.step(delStep);
                tr.setSelection($9eff3bdfd297a823$var$textblockAt(before, "end") ? (0, $3lIcL.Selection).findFrom(tr.doc.resolve(tr.mapping.map($cut.pos, -1)), -1) : (0, $3lIcL.NodeSelection).create(tr.doc, $cut.pos - before.nodeSize));
                dispatch(tr.scrollIntoView());
            }
            return true;
        }
        if (depth == 1 || $cursor.node(depth - 1).childCount > 1) break;
    }
    // If the node before is an atom, delete it
    if (before.isAtom && $cut.depth == $cursor.depth - 1) {
        if (dispatch) dispatch(state.tr.delete($cut.pos - before.nodeSize, $cut.pos).scrollIntoView());
        return true;
    }
    return false;
};
/**
A more limited form of [`joinBackward`]($commands.joinBackward)
that only tries to join the current textblock to the one before
it, if the cursor is at the start of a textblock.
*/ const $9eff3bdfd297a823$export$1dce4f5c74f5f90f = (state, dispatch, view)=>{
    let $cursor = $9eff3bdfd297a823$var$atBlockStart(state, view);
    if (!$cursor) return false;
    let $cut = $9eff3bdfd297a823$var$findCutBefore($cursor);
    return $cut ? $9eff3bdfd297a823$var$joinTextblocksAround(state, $cut, dispatch) : false;
};
/**
A more limited form of [`joinForward`]($commands.joinForward)
that only tries to join the current textblock to the one after
it, if the cursor is at the end of a textblock.
*/ const $9eff3bdfd297a823$export$e796bb96d22be2cd = (state, dispatch, view)=>{
    let $cursor = $9eff3bdfd297a823$var$atBlockEnd(state, view);
    if (!$cursor) return false;
    let $cut = $9eff3bdfd297a823$var$findCutAfter($cursor);
    return $cut ? $9eff3bdfd297a823$var$joinTextblocksAround(state, $cut, dispatch) : false;
};
function $9eff3bdfd297a823$var$joinTextblocksAround(state, $cut, dispatch) {
    let before = $cut.nodeBefore, beforeText = before, beforePos = $cut.pos - 1;
    for(; !beforeText.isTextblock; beforePos--){
        if (beforeText.type.spec.isolating) return false;
        let child = beforeText.lastChild;
        if (!child) return false;
        beforeText = child;
    }
    let after = $cut.nodeAfter, afterText = after, afterPos = $cut.pos + 1;
    for(; !afterText.isTextblock; afterPos++){
        if (afterText.type.spec.isolating) return false;
        let child = afterText.firstChild;
        if (!child) return false;
        afterText = child;
    }
    let step = (0, $lzEKq.replaceStep)(state.doc, beforePos, afterPos, (0, $3xw6l.Slice).empty);
    if (!step || step.from != beforePos || step instanceof (0, $lzEKq.ReplaceStep) && step.slice.size >= afterPos - beforePos) return false;
    if (dispatch) {
        let tr = state.tr.step(step);
        tr.setSelection((0, $3lIcL.TextSelection).create(tr.doc, beforePos));
        dispatch(tr.scrollIntoView());
    }
    return true;
}
function $9eff3bdfd297a823$var$textblockAt(node, side, only = false) {
    for(let scan = node; scan; scan = side == "start" ? scan.firstChild : scan.lastChild){
        if (scan.isTextblock) return true;
        if (only && scan.childCount != 1) return false;
    }
    return false;
}
/**
When the selection is empty and at the start of a textblock, select
the node before that textblock, if possible. This is intended to be
bound to keys like backspace, after
[`joinBackward`](https://prosemirror.net/docs/ref/#commands.joinBackward) or other deleting
commands, as a fall-back behavior when the schema doesn't allow
deletion at the selected point.
*/ const $9eff3bdfd297a823$export$52b8a4af68d19794 = (state, dispatch, view)=>{
    let { $head: $head, empty: empty } = state.selection, $cut = $head;
    if (!empty) return false;
    if ($head.parent.isTextblock) {
        if (view ? !view.endOfTextblock("backward", state) : $head.parentOffset > 0) return false;
        $cut = $9eff3bdfd297a823$var$findCutBefore($head);
    }
    let node = $cut && $cut.nodeBefore;
    if (!node || !(0, $3lIcL.NodeSelection).isSelectable(node)) return false;
    if (dispatch) dispatch(state.tr.setSelection((0, $3lIcL.NodeSelection).create(state.doc, $cut.pos - node.nodeSize)).scrollIntoView());
    return true;
};
function $9eff3bdfd297a823$var$findCutBefore($pos) {
    if (!$pos.parent.type.spec.isolating) for(let i = $pos.depth - 1; i >= 0; i--){
        if ($pos.index(i) > 0) return $pos.doc.resolve($pos.before(i + 1));
        if ($pos.node(i).type.spec.isolating) break;
    }
    return null;
}
function $9eff3bdfd297a823$var$atBlockEnd(state, view) {
    let { $cursor: $cursor } = state.selection;
    if (!$cursor || (view ? !view.endOfTextblock("forward", state) : $cursor.parentOffset < $cursor.parent.content.size)) return null;
    return $cursor;
}
/**
If the selection is empty and the cursor is at the end of a
textblock, try to reduce or remove the boundary between that block
and the one after it, either by joining them or by moving the other
block closer to this one in the tree structure. Will use the view
for accurate start-of-textblock detection if given.
*/ const $9eff3bdfd297a823$export$bf432e340007f9ef = (state, dispatch, view)=>{
    let $cursor = $9eff3bdfd297a823$var$atBlockEnd(state, view);
    if (!$cursor) return false;
    let $cut = $9eff3bdfd297a823$var$findCutAfter($cursor);
    // If there is no node after this, there's nothing to do
    if (!$cut) return false;
    let after = $cut.nodeAfter;
    // Try the joining algorithm
    if ($9eff3bdfd297a823$var$deleteBarrier(state, $cut, dispatch, 1)) return true;
    // If the node above has no content and the node below is
    // selectable, delete the node above and select the one below.
    if ($cursor.parent.content.size == 0 && ($9eff3bdfd297a823$var$textblockAt(after, "start") || (0, $3lIcL.NodeSelection).isSelectable(after))) {
        let delStep = (0, $lzEKq.replaceStep)(state.doc, $cursor.before(), $cursor.after(), (0, $3xw6l.Slice).empty);
        if (delStep && delStep.slice.size < delStep.to - delStep.from) {
            if (dispatch) {
                let tr = state.tr.step(delStep);
                tr.setSelection($9eff3bdfd297a823$var$textblockAt(after, "start") ? (0, $3lIcL.Selection).findFrom(tr.doc.resolve(tr.mapping.map($cut.pos)), 1) : (0, $3lIcL.NodeSelection).create(tr.doc, tr.mapping.map($cut.pos)));
                dispatch(tr.scrollIntoView());
            }
            return true;
        }
    }
    // If the next node is an atom, delete it
    if (after.isAtom && $cut.depth == $cursor.depth - 1) {
        if (dispatch) dispatch(state.tr.delete($cut.pos, $cut.pos + after.nodeSize).scrollIntoView());
        return true;
    }
    return false;
};
/**
When the selection is empty and at the end of a textblock, select
the node coming after that textblock, if possible. This is intended
to be bound to keys like delete, after
[`joinForward`](https://prosemirror.net/docs/ref/#commands.joinForward) and similar deleting
commands, to provide a fall-back behavior when the schema doesn't
allow deletion at the selected point.
*/ const $9eff3bdfd297a823$export$5835b52680b80cfd = (state, dispatch, view)=>{
    let { $head: $head, empty: empty } = state.selection, $cut = $head;
    if (!empty) return false;
    if ($head.parent.isTextblock) {
        if (view ? !view.endOfTextblock("forward", state) : $head.parentOffset < $head.parent.content.size) return false;
        $cut = $9eff3bdfd297a823$var$findCutAfter($head);
    }
    let node = $cut && $cut.nodeAfter;
    if (!node || !(0, $3lIcL.NodeSelection).isSelectable(node)) return false;
    if (dispatch) dispatch(state.tr.setSelection((0, $3lIcL.NodeSelection).create(state.doc, $cut.pos)).scrollIntoView());
    return true;
};
function $9eff3bdfd297a823$var$findCutAfter($pos) {
    if (!$pos.parent.type.spec.isolating) for(let i = $pos.depth - 1; i >= 0; i--){
        let parent = $pos.node(i);
        if ($pos.index(i) + 1 < parent.childCount) return $pos.doc.resolve($pos.after(i + 1));
        if (parent.type.spec.isolating) break;
    }
    return null;
}
/**
Join the selected block or, if there is a text selection, the
closest ancestor block of the selection that can be joined, with
the sibling above it.
*/ const $9eff3bdfd297a823$export$4bb15e6d4372b393 = (state, dispatch)=>{
    let sel = state.selection, nodeSel = sel instanceof (0, $3lIcL.NodeSelection), point;
    if (nodeSel) {
        if (sel.node.isTextblock || !(0, $lzEKq.canJoin)(state.doc, sel.from)) return false;
        point = sel.from;
    } else {
        point = (0, $lzEKq.joinPoint)(state.doc, sel.from, -1);
        if (point == null) return false;
    }
    if (dispatch) {
        let tr = state.tr.join(point);
        if (nodeSel) tr.setSelection((0, $3lIcL.NodeSelection).create(tr.doc, point - state.doc.resolve(point).nodeBefore.nodeSize));
        dispatch(tr.scrollIntoView());
    }
    return true;
};
/**
Join the selected block, or the closest ancestor of the selection
that can be joined, with the sibling after it.
*/ const $9eff3bdfd297a823$export$8dd967a262b064bb = (state, dispatch)=>{
    let sel = state.selection, point;
    if (sel instanceof (0, $3lIcL.NodeSelection)) {
        if (sel.node.isTextblock || !(0, $lzEKq.canJoin)(state.doc, sel.to)) return false;
        point = sel.to;
    } else {
        point = (0, $lzEKq.joinPoint)(state.doc, sel.to, 1);
        if (point == null) return false;
    }
    if (dispatch) dispatch(state.tr.join(point).scrollIntoView());
    return true;
};
/**
Lift the selected block, or the closest ancestor block of the
selection that can be lifted, out of its parent node.
*/ const $9eff3bdfd297a823$export$590e8b2c435046d9 = (state, dispatch)=>{
    let { $from: $from, $to: $to } = state.selection;
    let range = $from.blockRange($to), target = range && (0, $lzEKq.liftTarget)(range);
    if (target == null) return false;
    if (dispatch) dispatch(state.tr.lift(range, target).scrollIntoView());
    return true;
};
/**
If the selection is in a node whose type has a truthy
[`code`](https://prosemirror.net/docs/ref/#model.NodeSpec.code) property in its spec, replace the
selection with a newline character.
*/ const $9eff3bdfd297a823$export$a5d02b4b65e94f91 = (state, dispatch)=>{
    let { $head: $head, $anchor: $anchor } = state.selection;
    if (!$head.parent.type.spec.code || !$head.sameParent($anchor)) return false;
    if (dispatch) dispatch(state.tr.insertText("\n").scrollIntoView());
    return true;
};
function $9eff3bdfd297a823$var$defaultBlockAt(match) {
    for(let i = 0; i < match.edgeCount; i++){
        let { type: type } = match.edge(i);
        if (type.isTextblock && !type.hasRequiredAttrs()) return type;
    }
    return null;
}
/**
When the selection is in a node with a truthy
[`code`](https://prosemirror.net/docs/ref/#model.NodeSpec.code) property in its spec, create a
default block after the code block, and move the cursor there.
*/ const $9eff3bdfd297a823$export$634b78845598ff5b = (state, dispatch)=>{
    let { $head: $head, $anchor: $anchor } = state.selection;
    if (!$head.parent.type.spec.code || !$head.sameParent($anchor)) return false;
    let above = $head.node(-1), after = $head.indexAfter(-1), type = $9eff3bdfd297a823$var$defaultBlockAt(above.contentMatchAt(after));
    if (!type || !above.canReplaceWith(after, after, type)) return false;
    if (dispatch) {
        let pos = $head.after(), tr = state.tr.replaceWith(pos, pos, type.createAndFill());
        tr.setSelection((0, $3lIcL.Selection).near(tr.doc.resolve(pos), 1));
        dispatch(tr.scrollIntoView());
    }
    return true;
};
/**
If a block node is selected, create an empty paragraph before (if
it is its parent's first child) or after it.
*/ const $9eff3bdfd297a823$export$d0f80ac1b4510888 = (state, dispatch)=>{
    let sel = state.selection, { $from: $from, $to: $to } = sel;
    if (sel instanceof (0, $3lIcL.AllSelection) || $from.parent.inlineContent || $to.parent.inlineContent) return false;
    let type = $9eff3bdfd297a823$var$defaultBlockAt($to.parent.contentMatchAt($to.indexAfter()));
    if (!type || !type.isTextblock) return false;
    if (dispatch) {
        let side = (!$from.parentOffset && $to.index() < $to.parent.childCount ? $from : $to).pos;
        let tr = state.tr.insert(side, type.createAndFill());
        tr.setSelection((0, $3lIcL.TextSelection).create(tr.doc, side + 1));
        dispatch(tr.scrollIntoView());
    }
    return true;
};
/**
If the cursor is in an empty textblock that can be lifted, lift the
block.
*/ const $9eff3bdfd297a823$export$a3574cc681852c08 = (state, dispatch)=>{
    let { $cursor: $cursor } = state.selection;
    if (!$cursor || $cursor.parent.content.size) return false;
    if ($cursor.depth > 1 && $cursor.after() != $cursor.end(-1)) {
        let before = $cursor.before();
        if ((0, $lzEKq.canSplit)(state.doc, before)) {
            if (dispatch) dispatch(state.tr.split(before).scrollIntoView());
            return true;
        }
    }
    let range = $cursor.blockRange(), target = range && (0, $lzEKq.liftTarget)(range);
    if (target == null) return false;
    if (dispatch) dispatch(state.tr.lift(range, target).scrollIntoView());
    return true;
};
/**
Create a variant of [`splitBlock`](https://prosemirror.net/docs/ref/#commands.splitBlock) that uses
a custom function to determine the type of the newly split off block.
*/ function $9eff3bdfd297a823$export$8bf8350f33b1e5ab(splitNode) {
    return (state, dispatch)=>{
        let { $from: $from, $to: $to } = state.selection;
        if (state.selection instanceof (0, $3lIcL.NodeSelection) && state.selection.node.isBlock) {
            if (!$from.parentOffset || !(0, $lzEKq.canSplit)(state.doc, $from.pos)) return false;
            if (dispatch) dispatch(state.tr.split($from.pos).scrollIntoView());
            return true;
        }
        if (!$from.depth) return false;
        let types = [];
        let splitDepth, deflt, atEnd = false, atStart = false;
        for(let d = $from.depth;; d--){
            let node = $from.node(d);
            if (node.isBlock) {
                atEnd = $from.end(d) == $from.pos + ($from.depth - d);
                atStart = $from.start(d) == $from.pos - ($from.depth - d);
                deflt = $9eff3bdfd297a823$var$defaultBlockAt($from.node(d - 1).contentMatchAt($from.indexAfter(d - 1)));
                let splitType = splitNode && splitNode($to.parent, atEnd, $from);
                types.unshift(splitType || (atEnd && deflt ? {
                    type: deflt
                } : null));
                splitDepth = d;
                break;
            } else {
                if (d == 1) return false;
                types.unshift(null);
            }
        }
        let tr = state.tr;
        if (state.selection instanceof (0, $3lIcL.TextSelection) || state.selection instanceof (0, $3lIcL.AllSelection)) tr.deleteSelection();
        let splitPos = tr.mapping.map($from.pos);
        let can = (0, $lzEKq.canSplit)(tr.doc, splitPos, types.length, types);
        if (!can) {
            types[0] = deflt ? {
                type: deflt
            } : null;
            can = (0, $lzEKq.canSplit)(tr.doc, splitPos, types.length, types);
        }
        tr.split(splitPos, types.length, types);
        if (!atEnd && atStart && $from.node(splitDepth).type != deflt) {
            let first = tr.mapping.map($from.before(splitDepth)), $first = tr.doc.resolve(first);
            if (deflt && $from.node(splitDepth - 1).canReplaceWith($first.index(), $first.index() + 1, deflt)) tr.setNodeMarkup(tr.mapping.map($from.before(splitDepth)), deflt);
        }
        if (dispatch) dispatch(tr.scrollIntoView());
        return true;
    };
}
/**
Split the parent block of the selection. If the selection is a text
selection, also delete its content.
*/ const $9eff3bdfd297a823$export$e99155638ff4dff0 = $9eff3bdfd297a823$export$8bf8350f33b1e5ab();
/**
Acts like [`splitBlock`](https://prosemirror.net/docs/ref/#commands.splitBlock), but without
resetting the set of active marks at the cursor.
*/ const $9eff3bdfd297a823$export$eeb429476568b72b = (state, dispatch)=>{
    return $9eff3bdfd297a823$export$e99155638ff4dff0(state, dispatch && ((tr)=>{
        let marks = state.storedMarks || state.selection.$to.parentOffset && state.selection.$from.marks();
        if (marks) tr.ensureMarks(marks);
        dispatch(tr);
    }));
};
/**
Move the selection to the node wrapping the current selection, if
any. (Will not select the document node.)
*/ const $9eff3bdfd297a823$export$a37f6aaa9169911d = (state, dispatch)=>{
    let { $from: $from, to: to } = state.selection, pos;
    let same = $from.sharedDepth(to);
    if (same == 0) return false;
    pos = $from.before(same);
    if (dispatch) dispatch(state.tr.setSelection((0, $3lIcL.NodeSelection).create(state.doc, pos)));
    return true;
};
/**
Select the whole document.
*/ const $9eff3bdfd297a823$export$90aca4adda6ff0f5 = (state, dispatch)=>{
    if (dispatch) dispatch(state.tr.setSelection(new (0, $3lIcL.AllSelection)(state.doc)));
    return true;
};
function $9eff3bdfd297a823$var$joinMaybeClear(state, $pos, dispatch) {
    let before = $pos.nodeBefore, after = $pos.nodeAfter, index = $pos.index();
    if (!before || !after || !before.type.compatibleContent(after.type)) return false;
    if (!before.content.size && $pos.parent.canReplace(index - 1, index)) {
        if (dispatch) dispatch(state.tr.delete($pos.pos - before.nodeSize, $pos.pos).scrollIntoView());
        return true;
    }
    if (!$pos.parent.canReplace(index, index + 1) || !(after.isTextblock || (0, $lzEKq.canJoin)(state.doc, $pos.pos))) return false;
    if (dispatch) dispatch(state.tr.join($pos.pos).scrollIntoView());
    return true;
}
function $9eff3bdfd297a823$var$deleteBarrier(state, $cut, dispatch, dir) {
    let before = $cut.nodeBefore, after = $cut.nodeAfter, conn, match;
    let isolated = before.type.spec.isolating || after.type.spec.isolating;
    if (!isolated && $9eff3bdfd297a823$var$joinMaybeClear(state, $cut, dispatch)) return true;
    let canDelAfter = !isolated && $cut.parent.canReplace($cut.index(), $cut.index() + 1);
    if (canDelAfter && (conn = (match = before.contentMatchAt(before.childCount)).findWrapping(after.type)) && match.matchType(conn[0] || after.type).validEnd) {
        if (dispatch) {
            let end = $cut.pos + after.nodeSize, wrap = (0, $3xw6l.Fragment).empty;
            for(let i = conn.length - 1; i >= 0; i--)wrap = (0, $3xw6l.Fragment).from(conn[i].create(null, wrap));
            wrap = (0, $3xw6l.Fragment).from(before.copy(wrap));
            let tr = state.tr.step(new (0, $lzEKq.ReplaceAroundStep)($cut.pos - 1, end, $cut.pos, end, new (0, $3xw6l.Slice)(wrap, 1, 0), conn.length, true));
            let $joinAt = tr.doc.resolve(end + 2 * conn.length);
            if ($joinAt.nodeAfter && $joinAt.nodeAfter.type == before.type && (0, $lzEKq.canJoin)(tr.doc, $joinAt.pos)) tr.join($joinAt.pos);
            dispatch(tr.scrollIntoView());
        }
        return true;
    }
    let selAfter = after.type.spec.isolating || dir > 0 && isolated ? null : (0, $3lIcL.Selection).findFrom($cut, 1);
    let range = selAfter && selAfter.$from.blockRange(selAfter.$to), target = range && (0, $lzEKq.liftTarget)(range);
    if (target != null && target >= $cut.depth) {
        if (dispatch) dispatch(state.tr.lift(range, target).scrollIntoView());
        return true;
    }
    if (canDelAfter && $9eff3bdfd297a823$var$textblockAt(after, "start", true) && $9eff3bdfd297a823$var$textblockAt(before, "end")) {
        let at = before, wrap = [];
        for(;;){
            wrap.push(at);
            if (at.isTextblock) break;
            at = at.lastChild;
        }
        let afterText = after, afterDepth = 1;
        for(; !afterText.isTextblock; afterText = afterText.firstChild)afterDepth++;
        if (at.canReplace(at.childCount, at.childCount, afterText.content)) {
            if (dispatch) {
                let end = (0, $3xw6l.Fragment).empty;
                for(let i = wrap.length - 1; i >= 0; i--)end = (0, $3xw6l.Fragment).from(wrap[i].copy(end));
                let tr = state.tr.step(new (0, $lzEKq.ReplaceAroundStep)($cut.pos - wrap.length, $cut.pos + after.nodeSize, $cut.pos + afterDepth, $cut.pos + after.nodeSize - afterDepth, new (0, $3xw6l.Slice)(end, wrap.length, 0), 0, true));
                dispatch(tr.scrollIntoView());
            }
            return true;
        }
    }
    return false;
}
function $9eff3bdfd297a823$var$selectTextblockSide(side) {
    return function(state, dispatch) {
        let sel = state.selection, $pos = side < 0 ? sel.$from : sel.$to;
        let depth = $pos.depth;
        while($pos.node(depth).isInline){
            if (!depth) return false;
            depth--;
        }
        if (!$pos.node(depth).isTextblock) return false;
        if (dispatch) dispatch(state.tr.setSelection((0, $3lIcL.TextSelection).create(state.doc, side < 0 ? $pos.start(depth) : $pos.end(depth))));
        return true;
    };
}
/**
Moves the cursor to the start of current text block.
*/ const $9eff3bdfd297a823$export$c3a64f3c9604a1b1 = $9eff3bdfd297a823$var$selectTextblockSide(-1);
/**
Moves the cursor to the end of current text block.
*/ const $9eff3bdfd297a823$export$a66c1876556415e5 = $9eff3bdfd297a823$var$selectTextblockSide(1);
// Parameterized commands
/**
Wrap the selection in a node of the given type with the given
attributes.
*/ function $9eff3bdfd297a823$export$6e5e3c49755affd0(nodeType, attrs = null) {
    return function(state, dispatch) {
        let { $from: $from, $to: $to } = state.selection;
        let range = $from.blockRange($to), wrapping = range && (0, $lzEKq.findWrapping)(range, nodeType, attrs);
        if (!wrapping) return false;
        if (dispatch) dispatch(state.tr.wrap(range, wrapping).scrollIntoView());
        return true;
    };
}
/**
Returns a command that tries to set the selected textblocks to the
given node type with the given attributes.
*/ function $9eff3bdfd297a823$export$36987f561c736aad(nodeType, attrs = null) {
    return function(state, dispatch) {
        let applicable = false;
        for(let i = 0; i < state.selection.ranges.length && !applicable; i++){
            let { $from: { pos: from }, $to: { pos: to } } = state.selection.ranges[i];
            state.doc.nodesBetween(from, to, (node, pos)=>{
                if (applicable) return false;
                if (!node.isTextblock || node.hasMarkup(nodeType, attrs)) return;
                if (node.type == nodeType) applicable = true;
                else {
                    let $pos = state.doc.resolve(pos), index = $pos.index();
                    applicable = $pos.parent.canReplaceWith(index, index + 1, nodeType);
                }
            });
        }
        if (!applicable) return false;
        if (dispatch) {
            let tr = state.tr;
            for(let i = 0; i < state.selection.ranges.length; i++){
                let { $from: { pos: from }, $to: { pos: to } } = state.selection.ranges[i];
                tr.setBlockType(from, to, nodeType, attrs);
            }
            dispatch(tr.scrollIntoView());
        }
        return true;
    };
}
function $9eff3bdfd297a823$var$markApplies(doc, ranges, type, enterAtoms) {
    for(let i = 0; i < ranges.length; i++){
        let { $from: $from, $to: $to } = ranges[i];
        let can = $from.depth == 0 ? doc.inlineContent && doc.type.allowsMarkType(type) : false;
        doc.nodesBetween($from.pos, $to.pos, (node, pos)=>{
            if (can || !enterAtoms && node.isAtom && node.isInline && pos >= $from.pos && pos + node.nodeSize <= $to.pos) return false;
            can = node.inlineContent && node.type.allowsMarkType(type);
        });
        if (can) return true;
    }
    return false;
}
function $9eff3bdfd297a823$var$removeInlineAtoms(ranges) {
    let result = [];
    for(let i = 0; i < ranges.length; i++){
        let { $from: $from, $to: $to } = ranges[i];
        $from.doc.nodesBetween($from.pos, $to.pos, (node, pos)=>{
            if (node.isAtom && node.content.size && node.isInline && pos >= $from.pos && pos + node.nodeSize <= $to.pos) {
                if (pos + 1 > $from.pos) result.push(new (0, $3lIcL.SelectionRange)($from, $from.doc.resolve(pos + 1)));
                $from = $from.doc.resolve(pos + 1 + node.content.size);
                return false;
            }
        });
        if ($from.pos < $to.pos) result.push(new (0, $3lIcL.SelectionRange)($from, $to));
    }
    return result;
}
/**
Create a command function that toggles the given mark with the
given attributes. Will return `false` when the current selection
doesn't support that mark. This will remove the mark if any marks
of that type exist in the selection, or add it otherwise. If the
selection is empty, this applies to the [stored
marks](https://prosemirror.net/docs/ref/#state.EditorState.storedMarks) instead of a range of the
document.
*/ function $9eff3bdfd297a823$export$797ad2667b8015a8(markType, attrs = null, options) {
    let removeWhenPresent = (options && options.removeWhenPresent) !== false;
    let enterAtoms = (options && options.enterInlineAtoms) !== false;
    return function(state, dispatch) {
        let { empty: empty, $cursor: $cursor, ranges: ranges } = state.selection;
        if (empty && !$cursor || !$9eff3bdfd297a823$var$markApplies(state.doc, ranges, markType, enterAtoms)) return false;
        if (dispatch) {
            if ($cursor) {
                if (markType.isInSet(state.storedMarks || $cursor.marks())) dispatch(state.tr.removeStoredMark(markType));
                else dispatch(state.tr.addStoredMark(markType.create(attrs)));
            } else {
                let add, tr = state.tr;
                if (!enterAtoms) ranges = $9eff3bdfd297a823$var$removeInlineAtoms(ranges);
                if (removeWhenPresent) add = !ranges.some((r)=>state.doc.rangeHasMark(r.$from.pos, r.$to.pos, markType));
                else add = !ranges.every((r)=>{
                    let missing = false;
                    tr.doc.nodesBetween(r.$from.pos, r.$to.pos, (node, pos, parent)=>{
                        if (missing) return false;
                        missing = !markType.isInSet(node.marks) && !!parent && parent.type.allowsMarkType(markType) && !(node.isText && /^\s*$/.test(node.textBetween(Math.max(0, r.$from.pos - pos), Math.min(node.nodeSize, r.$to.pos - pos))));
                    });
                    return !missing;
                });
                for(let i = 0; i < ranges.length; i++){
                    let { $from: $from, $to: $to } = ranges[i];
                    if (!add) tr.removeMark($from.pos, $to.pos, markType);
                    else {
                        let from = $from.pos, to = $to.pos, start = $from.nodeAfter, end = $to.nodeBefore;
                        let spaceStart = start && start.isText ? /^\s*/.exec(start.text)[0].length : 0;
                        let spaceEnd = end && end.isText ? /\s*$/.exec(end.text)[0].length : 0;
                        if (from + spaceStart < to) {
                            from += spaceStart;
                            to -= spaceEnd;
                        }
                        tr.addMark(from, to, markType.create(attrs));
                    }
                }
                dispatch(tr.scrollIntoView());
            }
        }
        return true;
    };
}
function $9eff3bdfd297a823$var$wrapDispatchForJoin(dispatch, isJoinable) {
    return (tr)=>{
        if (!tr.isGeneric) return dispatch(tr);
        let ranges = [];
        for(let i = 0; i < tr.mapping.maps.length; i++){
            let map = tr.mapping.maps[i];
            for(let j = 0; j < ranges.length; j++)ranges[j] = map.map(ranges[j]);
            map.forEach((_s, _e, from, to)=>ranges.push(from, to));
        }
        // Figure out which joinable points exist inside those ranges,
        // by checking all node boundaries in their parent nodes.
        let joinable = [];
        for(let i = 0; i < ranges.length; i += 2){
            let from = ranges[i], to = ranges[i + 1];
            let $from = tr.doc.resolve(from), depth = $from.sharedDepth(to), parent = $from.node(depth);
            for(let index = $from.indexAfter(depth), pos = $from.after(depth + 1); pos <= to; ++index){
                let after = parent.maybeChild(index);
                if (!after) break;
                if (index && joinable.indexOf(pos) == -1) {
                    let before = parent.child(index - 1);
                    if (before.type == after.type && isJoinable(before, after)) joinable.push(pos);
                }
                pos += after.nodeSize;
            }
        }
        // Join the joinable points
        joinable.sort((a, b)=>a - b);
        for(let i = joinable.length - 1; i >= 0; i--)if ((0, $lzEKq.canJoin)(tr.doc, joinable[i])) tr.join(joinable[i]);
        dispatch(tr);
    };
}
/**
Wrap a command so that, when it produces a transform that causes
two joinable nodes to end up next to each other, those are joined.
Nodes are considered joinable when they are of the same type and
when the `isJoinable` predicate returns true for them or, if an
array of strings was passed, if their node type name is in that
array.
*/ function $9eff3bdfd297a823$export$29903073afddcd8b(command, isJoinable) {
    let canJoin = Array.isArray(isJoinable) ? (node)=>isJoinable.indexOf(node.type.name) > -1 : isJoinable;
    return (state, dispatch, view)=>command(state, dispatch && $9eff3bdfd297a823$var$wrapDispatchForJoin(dispatch, canJoin), view);
}
/**
Combine a number of command functions into a single function (which
calls them one by one until one returns true).
*/ function $9eff3bdfd297a823$export$146a774cdef7663a(...commands) {
    return function(state, dispatch, view) {
        for(let i = 0; i < commands.length; i++)if (commands[i](state, dispatch, view)) return true;
        return false;
    };
}
let $9eff3bdfd297a823$var$backspace = $9eff3bdfd297a823$export$146a774cdef7663a($9eff3bdfd297a823$export$e9a518a637d1e641, $9eff3bdfd297a823$export$979097b097459299, $9eff3bdfd297a823$export$52b8a4af68d19794);
let $9eff3bdfd297a823$var$del = $9eff3bdfd297a823$export$146a774cdef7663a($9eff3bdfd297a823$export$e9a518a637d1e641, $9eff3bdfd297a823$export$bf432e340007f9ef, $9eff3bdfd297a823$export$5835b52680b80cfd);
/**
A basic keymap containing bindings not specific to any schema.
Binds the following keys (when multiple commands are listed, they
are chained with [`chainCommands`](https://prosemirror.net/docs/ref/#commands.chainCommands)):

* **Enter** to `newlineInCode`, `createParagraphNear`, `liftEmptyBlock`, `splitBlock`
* **Mod-Enter** to `exitCode`
* **Backspace** and **Mod-Backspace** to `deleteSelection`, `joinBackward`, `selectNodeBackward`
* **Delete** and **Mod-Delete** to `deleteSelection`, `joinForward`, `selectNodeForward`
* **Mod-Delete** to `deleteSelection`, `joinForward`, `selectNodeForward`
* **Mod-a** to `selectAll`
*/ const $9eff3bdfd297a823$export$eb36e8971b04df36 = {
    "Enter": $9eff3bdfd297a823$export$146a774cdef7663a($9eff3bdfd297a823$export$a5d02b4b65e94f91, $9eff3bdfd297a823$export$d0f80ac1b4510888, $9eff3bdfd297a823$export$a3574cc681852c08, $9eff3bdfd297a823$export$e99155638ff4dff0),
    "Mod-Enter": $9eff3bdfd297a823$export$634b78845598ff5b,
    "Backspace": $9eff3bdfd297a823$var$backspace,
    "Mod-Backspace": $9eff3bdfd297a823$var$backspace,
    "Shift-Backspace": $9eff3bdfd297a823$var$backspace,
    "Delete": $9eff3bdfd297a823$var$del,
    "Mod-Delete": $9eff3bdfd297a823$var$del,
    "Mod-a": $9eff3bdfd297a823$export$90aca4adda6ff0f5
};
/**
A copy of `pcBaseKeymap` that also binds **Ctrl-h** like Backspace,
**Ctrl-d** like Delete, **Alt-Backspace** like Ctrl-Backspace, and
**Ctrl-Alt-Backspace**, **Alt-Delete**, and **Alt-d** like
Ctrl-Delete.
*/ const $9eff3bdfd297a823$export$f292ad8dbd5063c8 = {
    "Ctrl-h": $9eff3bdfd297a823$export$eb36e8971b04df36["Backspace"],
    "Alt-Backspace": $9eff3bdfd297a823$export$eb36e8971b04df36["Mod-Backspace"],
    "Ctrl-d": $9eff3bdfd297a823$export$eb36e8971b04df36["Delete"],
    "Ctrl-Alt-Backspace": $9eff3bdfd297a823$export$eb36e8971b04df36["Mod-Delete"],
    "Alt-Delete": $9eff3bdfd297a823$export$eb36e8971b04df36["Mod-Delete"],
    "Alt-d": $9eff3bdfd297a823$export$eb36e8971b04df36["Mod-Delete"],
    "Ctrl-a": $9eff3bdfd297a823$export$c3a64f3c9604a1b1,
    "Ctrl-e": $9eff3bdfd297a823$export$a66c1876556415e5
};
for(let key in $9eff3bdfd297a823$export$eb36e8971b04df36)$9eff3bdfd297a823$export$f292ad8dbd5063c8[key] = $9eff3bdfd297a823$export$eb36e8971b04df36[key];
const $9eff3bdfd297a823$var$mac = typeof navigator != "undefined" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : typeof os != "undefined" && os.platform ? os.platform() == "darwin" : false;
/**
Depending on the detected platform, this will hold
[`pcBasekeymap`](https://prosemirror.net/docs/ref/#commands.pcBaseKeymap) or
[`macBaseKeymap`](https://prosemirror.net/docs/ref/#commands.macBaseKeymap).
*/ const $9eff3bdfd297a823$export$4a0c2b85b1f0a889 = $9eff3bdfd297a823$var$mac ? $9eff3bdfd297a823$export$f292ad8dbd5063c8 : $9eff3bdfd297a823$export$eb36e8971b04df36;

});

parcelRegister("kuxd1", function(module, exports) {

$parcel$export(module.exports, "closeHistory", () => $eeb05e9b367afde8$export$181a649d919c589e);
$parcel$export(module.exports, "history", () => $eeb05e9b367afde8$export$55abd4691b317664);
$parcel$export(module.exports, "undo", () => $eeb05e9b367afde8$export$21f930c44940fd98);
$parcel$export(module.exports, "redo", () => $eeb05e9b367afde8$export$1688e416fee0a49e);

var $7VXOm = parcelRequire("7VXOm");

var $lzEKq = parcelRequire("lzEKq");

var $3lIcL = parcelRequire("3lIcL");
// ProseMirror's history isn't simply a way to roll back to a previous
// state, because ProseMirror supports applying changes without adding
// them to the history (for example during collaboration).
//
// To this end, each 'Branch' (one for the undo history and one for
// the redo history) keeps an array of 'Items', which can optionally
// hold a step (an actual undoable change), and always hold a position
// map (which is needed to move changes below them to apply to the
// current document).
//
// An item that has both a step and a selection bookmark is the start
// of an 'event' — a group of changes that will be undone or redone at
// once. (It stores only the bookmark, since that way we don't have to
// provide a document until the selection is actually applied, which
// is useful when compressing.)
// Used to schedule history compression
const $eeb05e9b367afde8$var$max_empty_items = 500;
class $eeb05e9b367afde8$var$Branch {
    constructor(items, eventCount){
        this.items = items;
        this.eventCount = eventCount;
    }
    // Pop the latest event off the branch's history and apply it
    // to a document transform.
    popEvent(state, preserveItems) {
        if (this.eventCount == 0) return null;
        let end = this.items.length;
        for(;; end--){
            let next = this.items.get(end - 1);
            if (next.selection) {
                --end;
                break;
            }
        }
        let remap, mapFrom;
        if (preserveItems) {
            remap = this.remapping(end, this.items.length);
            mapFrom = remap.maps.length;
        }
        let transform = state.tr;
        let selection, remaining;
        let addAfter = [], addBefore = [];
        this.items.forEach((item, i)=>{
            if (!item.step) {
                if (!remap) {
                    remap = this.remapping(end, i + 1);
                    mapFrom = remap.maps.length;
                }
                mapFrom--;
                addBefore.push(item);
                return;
            }
            if (remap) {
                addBefore.push(new $eeb05e9b367afde8$var$Item(item.map));
                let step = item.step.map(remap.slice(mapFrom)), map;
                if (step && transform.maybeStep(step).doc) {
                    map = transform.mapping.maps[transform.mapping.maps.length - 1];
                    addAfter.push(new $eeb05e9b367afde8$var$Item(map, undefined, undefined, addAfter.length + addBefore.length));
                }
                mapFrom--;
                if (map) remap.appendMap(map, mapFrom);
            } else transform.maybeStep(item.step);
            if (item.selection) {
                selection = remap ? item.selection.map(remap.slice(mapFrom)) : item.selection;
                remaining = new $eeb05e9b367afde8$var$Branch(this.items.slice(0, end).append(addBefore.reverse().concat(addAfter)), this.eventCount - 1);
                return false;
            }
        }, this.items.length, 0);
        return {
            remaining: remaining,
            transform: transform,
            selection: selection
        };
    }
    // Create a new branch with the given transform added.
    addTransform(transform, selection, histOptions, preserveItems) {
        let newItems = [], eventCount = this.eventCount;
        let oldItems = this.items, lastItem = !preserveItems && oldItems.length ? oldItems.get(oldItems.length - 1) : null;
        for(let i = 0; i < transform.steps.length; i++){
            let step = transform.steps[i].invert(transform.docs[i]);
            let item = new $eeb05e9b367afde8$var$Item(transform.mapping.maps[i], step, selection), merged;
            if (merged = lastItem && lastItem.merge(item)) {
                item = merged;
                if (i) newItems.pop();
                else oldItems = oldItems.slice(0, oldItems.length - 1);
            }
            newItems.push(item);
            if (selection) {
                eventCount++;
                selection = undefined;
            }
            if (!preserveItems) lastItem = item;
        }
        let overflow = eventCount - histOptions.depth;
        if (overflow > $eeb05e9b367afde8$var$DEPTH_OVERFLOW) {
            oldItems = $eeb05e9b367afde8$var$cutOffEvents(oldItems, overflow);
            eventCount -= overflow;
        }
        return new $eeb05e9b367afde8$var$Branch(oldItems.append(newItems), eventCount);
    }
    remapping(from, to) {
        let maps = new (0, $lzEKq.Mapping);
        this.items.forEach((item, i)=>{
            let mirrorPos = item.mirrorOffset != null && i - item.mirrorOffset >= from ? maps.maps.length - item.mirrorOffset : undefined;
            maps.appendMap(item.map, mirrorPos);
        }, from, to);
        return maps;
    }
    addMaps(array) {
        if (this.eventCount == 0) return this;
        return new $eeb05e9b367afde8$var$Branch(this.items.append(array.map((map)=>new $eeb05e9b367afde8$var$Item(map))), this.eventCount);
    }
    // When the collab module receives remote changes, the history has
    // to know about those, so that it can adjust the steps that were
    // rebased on top of the remote changes, and include the position
    // maps for the remote changes in its array of items.
    rebased(rebasedTransform, rebasedCount) {
        if (!this.eventCount) return this;
        let rebasedItems = [], start = Math.max(0, this.items.length - rebasedCount);
        let mapping = rebasedTransform.mapping;
        let newUntil = rebasedTransform.steps.length;
        let eventCount = this.eventCount;
        this.items.forEach((item)=>{
            if (item.selection) eventCount--;
        }, start);
        let iRebased = rebasedCount;
        this.items.forEach((item)=>{
            let pos = mapping.getMirror(--iRebased);
            if (pos == null) return;
            newUntil = Math.min(newUntil, pos);
            let map = mapping.maps[pos];
            if (item.step) {
                let step = rebasedTransform.steps[pos].invert(rebasedTransform.docs[pos]);
                let selection = item.selection && item.selection.map(mapping.slice(iRebased + 1, pos));
                if (selection) eventCount++;
                rebasedItems.push(new $eeb05e9b367afde8$var$Item(map, step, selection));
            } else rebasedItems.push(new $eeb05e9b367afde8$var$Item(map));
        }, start);
        let newMaps = [];
        for(let i = rebasedCount; i < newUntil; i++)newMaps.push(new $eeb05e9b367afde8$var$Item(mapping.maps[i]));
        let items = this.items.slice(0, start).append(newMaps).append(rebasedItems);
        let branch = new $eeb05e9b367afde8$var$Branch(items, eventCount);
        if (branch.emptyItemCount() > $eeb05e9b367afde8$var$max_empty_items) branch = branch.compress(this.items.length - rebasedItems.length);
        return branch;
    }
    emptyItemCount() {
        let count = 0;
        this.items.forEach((item)=>{
            if (!item.step) count++;
        });
        return count;
    }
    // Compressing a branch means rewriting it to push the air (map-only
    // items) out. During collaboration, these naturally accumulate
    // because each remote change adds one. The `upto` argument is used
    // to ensure that only the items below a given level are compressed,
    // because `rebased` relies on a clean, untouched set of items in
    // order to associate old items with rebased steps.
    compress(upto = this.items.length) {
        let remap = this.remapping(0, upto), mapFrom = remap.maps.length;
        let items = [], events = 0;
        this.items.forEach((item, i)=>{
            if (i >= upto) {
                items.push(item);
                if (item.selection) events++;
            } else if (item.step) {
                let step = item.step.map(remap.slice(mapFrom)), map = step && step.getMap();
                mapFrom--;
                if (map) remap.appendMap(map, mapFrom);
                if (step) {
                    let selection = item.selection && item.selection.map(remap.slice(mapFrom));
                    if (selection) events++;
                    let newItem = new $eeb05e9b367afde8$var$Item(map.invert(), step, selection), merged, last = items.length - 1;
                    if (merged = items.length && items[last].merge(newItem)) items[last] = merged;
                    else items.push(newItem);
                }
            } else if (item.map) mapFrom--;
        }, this.items.length, 0);
        return new $eeb05e9b367afde8$var$Branch((0, $7VXOm.default).from(items.reverse()), events);
    }
}
$eeb05e9b367afde8$var$Branch.empty = new $eeb05e9b367afde8$var$Branch((0, $7VXOm.default).empty, 0);
function $eeb05e9b367afde8$var$cutOffEvents(items, n) {
    let cutPoint;
    items.forEach((item, i)=>{
        if (item.selection && n-- == 0) {
            cutPoint = i;
            return false;
        }
    });
    return items.slice(cutPoint);
}
class $eeb05e9b367afde8$var$Item {
    constructor(// The (forward) step map for this item.
    map, // The inverted step
    step, // If this is non-null, this item is the start of a group, and
    // this selection is the starting selection for the group (the one
    // that was active before the first step was applied)
    selection, // If this item is the inverse of a previous mapping on the stack,
    // this points at the inverse's offset
    mirrorOffset){
        this.map = map;
        this.step = step;
        this.selection = selection;
        this.mirrorOffset = mirrorOffset;
    }
    merge(other) {
        if (this.step && other.step && !other.selection) {
            let step = other.step.merge(this.step);
            if (step) return new $eeb05e9b367afde8$var$Item(step.getMap().invert(), step, this.selection);
        }
    }
}
// The value of the state field that tracks undo/redo history for that
// state. Will be stored in the plugin state when the history plugin
// is active.
class $eeb05e9b367afde8$var$HistoryState {
    constructor(done, undone, prevRanges, prevTime, prevComposition){
        this.done = done;
        this.undone = undone;
        this.prevRanges = prevRanges;
        this.prevTime = prevTime;
        this.prevComposition = prevComposition;
    }
}
const $eeb05e9b367afde8$var$DEPTH_OVERFLOW = 20;
// Record a transformation in undo history.
function $eeb05e9b367afde8$var$applyTransaction(history, state, tr, options) {
    let historyTr = tr.getMeta($eeb05e9b367afde8$var$historyKey), rebased;
    if (historyTr) return historyTr.historyState;
    if (tr.getMeta($eeb05e9b367afde8$var$closeHistoryKey)) history = new $eeb05e9b367afde8$var$HistoryState(history.done, history.undone, null, 0, -1);
    let appended = tr.getMeta("appendedTransaction");
    if (tr.steps.length == 0) return history;
    else if (appended && appended.getMeta($eeb05e9b367afde8$var$historyKey)) {
        if (appended.getMeta($eeb05e9b367afde8$var$historyKey).redo) return new $eeb05e9b367afde8$var$HistoryState(history.done.addTransform(tr, undefined, options, $eeb05e9b367afde8$var$mustPreserveItems(state)), history.undone, $eeb05e9b367afde8$var$rangesFor(tr.mapping.maps), history.prevTime, history.prevComposition);
        else return new $eeb05e9b367afde8$var$HistoryState(history.done, history.undone.addTransform(tr, undefined, options, $eeb05e9b367afde8$var$mustPreserveItems(state)), null, history.prevTime, history.prevComposition);
    } else if (tr.getMeta("addToHistory") !== false && !(appended && appended.getMeta("addToHistory") === false)) {
        // Group transforms that occur in quick succession into one event.
        let composition = tr.getMeta("composition");
        let newGroup = history.prevTime == 0 || !appended && history.prevComposition != composition && (history.prevTime < (tr.time || 0) - options.newGroupDelay || !$eeb05e9b367afde8$var$isAdjacentTo(tr, history.prevRanges));
        let prevRanges = appended ? $eeb05e9b367afde8$var$mapRanges(history.prevRanges, tr.mapping) : $eeb05e9b367afde8$var$rangesFor(tr.mapping.maps);
        return new $eeb05e9b367afde8$var$HistoryState(history.done.addTransform(tr, newGroup ? state.selection.getBookmark() : undefined, options, $eeb05e9b367afde8$var$mustPreserveItems(state)), $eeb05e9b367afde8$var$Branch.empty, prevRanges, tr.time, composition == null ? history.prevComposition : composition);
    } else if (rebased = tr.getMeta("rebased")) // Used by the collab module to tell the history that some of its
    // content has been rebased.
    return new $eeb05e9b367afde8$var$HistoryState(history.done.rebased(tr, rebased), history.undone.rebased(tr, rebased), $eeb05e9b367afde8$var$mapRanges(history.prevRanges, tr.mapping), history.prevTime, history.prevComposition);
    else return new $eeb05e9b367afde8$var$HistoryState(history.done.addMaps(tr.mapping.maps), history.undone.addMaps(tr.mapping.maps), $eeb05e9b367afde8$var$mapRanges(history.prevRanges, tr.mapping), history.prevTime, history.prevComposition);
}
function $eeb05e9b367afde8$var$isAdjacentTo(transform, prevRanges) {
    if (!prevRanges) return false;
    if (!transform.docChanged) return true;
    let adjacent = false;
    transform.mapping.maps[0].forEach((start, end)=>{
        for(let i = 0; i < prevRanges.length; i += 2)if (start <= prevRanges[i + 1] && end >= prevRanges[i]) adjacent = true;
    });
    return adjacent;
}
function $eeb05e9b367afde8$var$rangesFor(maps) {
    let result = [];
    for(let i = maps.length - 1; i >= 0 && result.length == 0; i--)maps[i].forEach((_from, _to, from, to)=>result.push(from, to));
    return result;
}
function $eeb05e9b367afde8$var$mapRanges(ranges, mapping) {
    if (!ranges) return null;
    let result = [];
    for(let i = 0; i < ranges.length; i += 2){
        let from = mapping.map(ranges[i], 1), to = mapping.map(ranges[i + 1], -1);
        if (from <= to) result.push(from, to);
    }
    return result;
}
// Apply the latest event from one branch to the document and shift the event
// onto the other branch.
function $eeb05e9b367afde8$var$histTransaction(history, state, redo) {
    let preserveItems = $eeb05e9b367afde8$var$mustPreserveItems(state);
    let histOptions = $eeb05e9b367afde8$var$historyKey.get(state).spec.config;
    let pop = (redo ? history.undone : history.done).popEvent(state, preserveItems);
    if (!pop) return null;
    let selection = pop.selection.resolve(pop.transform.doc);
    let added = (redo ? history.done : history.undone).addTransform(pop.transform, state.selection.getBookmark(), histOptions, preserveItems);
    let newHist = new $eeb05e9b367afde8$var$HistoryState(redo ? added : pop.remaining, redo ? pop.remaining : added, null, 0, -1);
    return pop.transform.setSelection(selection).setMeta($eeb05e9b367afde8$var$historyKey, {
        redo: redo,
        historyState: newHist
    });
}
let $eeb05e9b367afde8$var$cachedPreserveItems = false, $eeb05e9b367afde8$var$cachedPreserveItemsPlugins = null;
// Check whether any plugin in the given state has a
// `historyPreserveItems` property in its spec, in which case we must
// preserve steps exactly as they came in, so that they can be
// rebased.
function $eeb05e9b367afde8$var$mustPreserveItems(state) {
    let plugins = state.plugins;
    if ($eeb05e9b367afde8$var$cachedPreserveItemsPlugins != plugins) {
        $eeb05e9b367afde8$var$cachedPreserveItems = false;
        $eeb05e9b367afde8$var$cachedPreserveItemsPlugins = plugins;
        for(let i = 0; i < plugins.length; i++)if (plugins[i].spec.historyPreserveItems) {
            $eeb05e9b367afde8$var$cachedPreserveItems = true;
            break;
        }
    }
    return $eeb05e9b367afde8$var$cachedPreserveItems;
}
/**
Set a flag on the given transaction that will prevent further steps
from being appended to an existing history event (so that they
require a separate undo command to undo).
*/ function $eeb05e9b367afde8$export$181a649d919c589e(tr) {
    return tr.setMeta($eeb05e9b367afde8$var$closeHistoryKey, true);
}
const $eeb05e9b367afde8$var$historyKey = new (0, $3lIcL.PluginKey)("history");
const $eeb05e9b367afde8$var$closeHistoryKey = new (0, $3lIcL.PluginKey)("closeHistory");
/**
Returns a plugin that enables the undo history for an editor. The
plugin will track undo and redo stacks, which can be used with the
[`undo`](https://prosemirror.net/docs/ref/#history.undo) and [`redo`](https://prosemirror.net/docs/ref/#history.redo) commands.

You can set an `"addToHistory"` [metadata
property](https://prosemirror.net/docs/ref/#state.Transaction.setMeta) of `false` on a transaction
to prevent it from being rolled back by undo.
*/ function $eeb05e9b367afde8$export$55abd4691b317664(config = {}) {
    config = {
        depth: config.depth || 100,
        newGroupDelay: config.newGroupDelay || 500
    };
    return new (0, $3lIcL.Plugin)({
        key: $eeb05e9b367afde8$var$historyKey,
        state: {
            init () {
                return new $eeb05e9b367afde8$var$HistoryState($eeb05e9b367afde8$var$Branch.empty, $eeb05e9b367afde8$var$Branch.empty, null, 0, -1);
            },
            apply (tr, hist, state) {
                return $eeb05e9b367afde8$var$applyTransaction(hist, state, tr, config);
            }
        },
        config: config,
        props: {
            handleDOMEvents: {
                beforeinput (view, e) {
                    let inputType = e.inputType;
                    let command = inputType == "historyUndo" ? $eeb05e9b367afde8$export$21f930c44940fd98 : inputType == "historyRedo" ? $eeb05e9b367afde8$export$1688e416fee0a49e : null;
                    if (!command) return false;
                    e.preventDefault();
                    return command(view.state, view.dispatch);
                }
            }
        }
    });
}
function $eeb05e9b367afde8$var$buildCommand(redo, scroll) {
    return (state, dispatch)=>{
        let hist = $eeb05e9b367afde8$var$historyKey.getState(state);
        if (!hist || (redo ? hist.undone : hist.done).eventCount == 0) return false;
        if (dispatch) {
            let tr = $eeb05e9b367afde8$var$histTransaction(hist, state, redo);
            if (tr) dispatch(scroll ? tr.scrollIntoView() : tr);
        }
        return true;
    };
}
/**
A command function that undoes the last change, if any.
*/ const $eeb05e9b367afde8$export$21f930c44940fd98 = $eeb05e9b367afde8$var$buildCommand(false, true);
/**
A command function that redoes the last undone change, if any.
*/ const $eeb05e9b367afde8$export$1688e416fee0a49e = $eeb05e9b367afde8$var$buildCommand(true, true);
/**
A command function that undoes the last change. Don't scroll the
selection into view.
*/ const $eeb05e9b367afde8$export$24b5d280435f3a3f = $eeb05e9b367afde8$var$buildCommand(false, false);
/**
A command function that redoes the last undone change. Don't
scroll the selection into view.
*/ const $eeb05e9b367afde8$export$3774e54bae7be19b = $eeb05e9b367afde8$var$buildCommand(true, false);
/**
The amount of undoable events available in a given state.
*/ function $eeb05e9b367afde8$export$f8a176c2b9a10bdb(state) {
    let hist = $eeb05e9b367afde8$var$historyKey.getState(state);
    return hist ? hist.done.eventCount : 0;
}
/**
The amount of redoable events available in a given editor state.
*/ function $eeb05e9b367afde8$export$3ffe6b288e7d941b(state) {
    let hist = $eeb05e9b367afde8$var$historyKey.getState(state);
    return hist ? hist.undone.eventCount : 0;
}

});
parcelRegister("7VXOm", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c6c408b4e1a2afa$export$2e2bcd8739ae039);
var $5c6c408b4e1a2afa$var$GOOD_LEAF_SIZE = 200;
// :: class<T> A rope sequence is a persistent sequence data structure
// that supports appending, prepending, and slicing without doing a
// full copy. It is represented as a mostly-balanced tree.
var $5c6c408b4e1a2afa$var$RopeSequence = function RopeSequence() {};
$5c6c408b4e1a2afa$var$RopeSequence.prototype.append = function append(other) {
    if (!other.length) return this;
    other = $5c6c408b4e1a2afa$var$RopeSequence.from(other);
    return !this.length && other || other.length < $5c6c408b4e1a2afa$var$GOOD_LEAF_SIZE && this.leafAppend(other) || this.length < $5c6c408b4e1a2afa$var$GOOD_LEAF_SIZE && other.leafPrepend(this) || this.appendInner(other);
};
// :: (union<[T], RopeSequence<T>>) → RopeSequence<T>
// Prepend an array or other rope to this one, returning a new rope.
$5c6c408b4e1a2afa$var$RopeSequence.prototype.prepend = function prepend(other) {
    if (!other.length) return this;
    return $5c6c408b4e1a2afa$var$RopeSequence.from(other).append(this);
};
$5c6c408b4e1a2afa$var$RopeSequence.prototype.appendInner = function appendInner(other) {
    return new $5c6c408b4e1a2afa$var$Append(this, other);
};
// :: (?number, ?number) → RopeSequence<T>
// Create a rope repesenting a sub-sequence of this rope.
$5c6c408b4e1a2afa$var$RopeSequence.prototype.slice = function slice(from, to) {
    if (from === void 0) from = 0;
    if (to === void 0) to = this.length;
    if (from >= to) return $5c6c408b4e1a2afa$var$RopeSequence.empty;
    return this.sliceInner(Math.max(0, from), Math.min(this.length, to));
};
// :: (number) → T
// Retrieve the element at the given position from this rope.
$5c6c408b4e1a2afa$var$RopeSequence.prototype.get = function get(i) {
    if (i < 0 || i >= this.length) return undefined;
    return this.getInner(i);
};
// :: ((element: T, index: number) → ?bool, ?number, ?number)
// Call the given function for each element between the given
// indices. This tends to be more efficient than looping over the
// indices and calling `get`, because it doesn't have to descend the
// tree for every element.
$5c6c408b4e1a2afa$var$RopeSequence.prototype.forEach = function forEach(f, from, to) {
    if (from === void 0) from = 0;
    if (to === void 0) to = this.length;
    if (from <= to) this.forEachInner(f, from, to, 0);
    else this.forEachInvertedInner(f, from, to, 0);
};
// :: ((element: T, index: number) → U, ?number, ?number) → [U]
// Map the given functions over the elements of the rope, producing
// a flat array.
$5c6c408b4e1a2afa$var$RopeSequence.prototype.map = function map(f, from, to) {
    if (from === void 0) from = 0;
    if (to === void 0) to = this.length;
    var result = [];
    this.forEach(function(elt, i) {
        return result.push(f(elt, i));
    }, from, to);
    return result;
};
// :: (?union<[T], RopeSequence<T>>) → RopeSequence<T>
// Create a rope representing the given array, or return the rope
// itself if a rope was given.
$5c6c408b4e1a2afa$var$RopeSequence.from = function from(values) {
    if (values instanceof $5c6c408b4e1a2afa$var$RopeSequence) return values;
    return values && values.length ? new $5c6c408b4e1a2afa$var$Leaf(values) : $5c6c408b4e1a2afa$var$RopeSequence.empty;
};
var $5c6c408b4e1a2afa$var$Leaf = /*@__PURE__*/ function(RopeSequence) {
    function Leaf(values) {
        RopeSequence.call(this);
        this.values = values;
    }
    if (RopeSequence) Leaf.__proto__ = RopeSequence;
    Leaf.prototype = Object.create(RopeSequence && RopeSequence.prototype);
    Leaf.prototype.constructor = Leaf;
    var prototypeAccessors = {
        length: {
            configurable: true
        },
        depth: {
            configurable: true
        }
    };
    Leaf.prototype.flatten = function flatten() {
        return this.values;
    };
    Leaf.prototype.sliceInner = function sliceInner(from, to) {
        if (from == 0 && to == this.length) return this;
        return new Leaf(this.values.slice(from, to));
    };
    Leaf.prototype.getInner = function getInner(i) {
        return this.values[i];
    };
    Leaf.prototype.forEachInner = function forEachInner(f, from, to, start) {
        for(var i = from; i < to; i++){
            if (f(this.values[i], start + i) === false) return false;
        }
    };
    Leaf.prototype.forEachInvertedInner = function forEachInvertedInner(f, from, to, start) {
        for(var i = from - 1; i >= to; i--){
            if (f(this.values[i], start + i) === false) return false;
        }
    };
    Leaf.prototype.leafAppend = function leafAppend(other) {
        if (this.length + other.length <= $5c6c408b4e1a2afa$var$GOOD_LEAF_SIZE) return new Leaf(this.values.concat(other.flatten()));
    };
    Leaf.prototype.leafPrepend = function leafPrepend(other) {
        if (this.length + other.length <= $5c6c408b4e1a2afa$var$GOOD_LEAF_SIZE) return new Leaf(other.flatten().concat(this.values));
    };
    prototypeAccessors.length.get = function() {
        return this.values.length;
    };
    prototypeAccessors.depth.get = function() {
        return 0;
    };
    Object.defineProperties(Leaf.prototype, prototypeAccessors);
    return Leaf;
}($5c6c408b4e1a2afa$var$RopeSequence);
// :: RopeSequence
// The empty rope sequence.
$5c6c408b4e1a2afa$var$RopeSequence.empty = new $5c6c408b4e1a2afa$var$Leaf([]);
var $5c6c408b4e1a2afa$var$Append = /*@__PURE__*/ function(RopeSequence) {
    function Append(left, right) {
        RopeSequence.call(this);
        this.left = left;
        this.right = right;
        this.length = left.length + right.length;
        this.depth = Math.max(left.depth, right.depth) + 1;
    }
    if (RopeSequence) Append.__proto__ = RopeSequence;
    Append.prototype = Object.create(RopeSequence && RopeSequence.prototype);
    Append.prototype.constructor = Append;
    Append.prototype.flatten = function flatten() {
        return this.left.flatten().concat(this.right.flatten());
    };
    Append.prototype.getInner = function getInner(i) {
        return i < this.left.length ? this.left.get(i) : this.right.get(i - this.left.length);
    };
    Append.prototype.forEachInner = function forEachInner(f, from, to, start) {
        var leftLen = this.left.length;
        if (from < leftLen && this.left.forEachInner(f, from, Math.min(to, leftLen), start) === false) return false;
        if (to > leftLen && this.right.forEachInner(f, Math.max(from - leftLen, 0), Math.min(this.length, to) - leftLen, start + leftLen) === false) return false;
    };
    Append.prototype.forEachInvertedInner = function forEachInvertedInner(f, from, to, start) {
        var leftLen = this.left.length;
        if (from > leftLen && this.right.forEachInvertedInner(f, from - leftLen, Math.max(to, leftLen) - leftLen, start + leftLen) === false) return false;
        if (to < leftLen && this.left.forEachInvertedInner(f, Math.min(from, leftLen), to, start) === false) return false;
    };
    Append.prototype.sliceInner = function sliceInner(from, to) {
        if (from == 0 && to == this.length) return this;
        var leftLen = this.left.length;
        if (to <= leftLen) return this.left.slice(from, to);
        if (from >= leftLen) return this.right.slice(from - leftLen, to - leftLen);
        return this.left.slice(from, leftLen).append(this.right.slice(0, to - leftLen));
    };
    Append.prototype.leafAppend = function leafAppend(other) {
        var inner = this.right.leafAppend(other);
        if (inner) return new Append(this.left, inner);
    };
    Append.prototype.leafPrepend = function leafPrepend(other) {
        var inner = this.left.leafPrepend(other);
        if (inner) return new Append(inner, this.right);
    };
    Append.prototype.appendInner = function appendInner(other) {
        if (this.left.depth >= Math.max(this.right.depth, other.depth) + 1) return new Append(this.left, new Append(this.right, other));
        return new Append(this, other);
    };
    return Append;
}($5c6c408b4e1a2afa$var$RopeSequence);
var $5c6c408b4e1a2afa$export$2e2bcd8739ae039 = $5c6c408b4e1a2afa$var$RopeSequence;

});


parcelRegister("kFUgU", function(module, exports) {

$parcel$export(module.exports, "setKeyboardHeight", () => $da49190bee742ba4$export$b8c3ea160300668d);

var $9P93m = parcelRequire("9P93m");
const $da49190bee742ba4$export$b8c3ea160300668d = (keyboardHeight)=>(state, dispatch)=>{
        const { tr: tr } = state;
        tr.setMeta((0, $9P93m.scrollGutterPluginKey), {
            keyboardHeight: keyboardHeight
        });
        if (dispatch) dispatch(tr);
        return true;
    };

});
parcelRegister("9P93m", function(module, exports) {

$parcel$export(module.exports, "scrollGutterPluginKey", () => $440e0c8ae1a4b410$export$54fdd3c2782161ea);
$parcel$export(module.exports, "getScrollGutterPluginState", () => $440e0c8ae1a4b410$export$a237783470abe542);

var $3lIcL = parcelRequire("3lIcL");
const $440e0c8ae1a4b410$export$54fdd3c2782161ea = new (0, $3lIcL.PluginKey)('scrollGutter');
const $440e0c8ae1a4b410$export$a237783470abe542 = (state)=>{
    if (state) return $440e0c8ae1a4b410$export$54fdd3c2782161ea.getState(state);
};

});


parcelRegister("kccJu", function(module, exports) {

$parcel$export(module.exports, "default", () => $99f225c75744e2a6$export$2e2bcd8739ae039);

var $7EdFW = parcelRequire("7EdFW");

var $i8KtF = parcelRequire("i8KtF");

var $3lIcL = parcelRequire("3lIcL");
function $99f225c75744e2a6$var$getCurrentBrowserAndVersion() {
    switch(true){
        case (0, $7EdFW.browser).chrome === true:
            return {
                browser: 'chrome',
                version: (0, $7EdFW.browser).chrome_version
            };
        case (0, $7EdFW.browser).ie === true:
            return {
                browser: 'ie',
                version: (0, $7EdFW.browser).ie_version
            };
        case (0, $7EdFW.browser).gecko === true:
            return {
                browser: 'gecko',
                version: (0, $7EdFW.browser).gecko_version
            };
        case (0, $7EdFW.browser).safari === true:
            return {
                browser: 'safari',
                version: (0, $7EdFW.browser).safari_version
            };
    }
    return undefined;
}
var $99f225c75744e2a6$export$2e2bcd8739ae039 = (featureFlags)=>new (0, $i8KtF.SafePlugin)({
        key: new (0, $3lIcL.PluginKey)('disableSpellchecking'),
        props: {
            attributes: (editorState)=>{
                if (!featureFlags) return {};
                const browserConfigFeatureFlag = featureFlags.disableSpellcheckByBrowser;
                const userCurrentBrowserAndVersion = $99f225c75744e2a6$var$getCurrentBrowserAndVersion();
                if (!userCurrentBrowserAndVersion || !browserConfigFeatureFlag) return {};
                const browserVersionDisableRange = // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                browserConfigFeatureFlag[userCurrentBrowserAndVersion.browser];
                if (!browserVersionDisableRange || !(0, $7EdFW.browser)[userCurrentBrowserAndVersion.browser]) return {};
                const shouldDisableSpellcheck = !!browserVersionDisableRange.maximum ? userCurrentBrowserAndVersion.version >= browserVersionDisableRange.minimum && userCurrentBrowserAndVersion.version <= browserVersionDisableRange.maximum : (0, $7EdFW.browser)[userCurrentBrowserAndVersion.browser] && userCurrentBrowserAndVersion.version >= browserVersionDisableRange.minimum;
                if (shouldDisableSpellcheck) return {
                    spellcheck: 'false'
                };
                return {};
            }
        }
    });

});

parcelRegister("Fp2cl", function(module, exports) {

$parcel$export(module.exports, "default", () => $08450b8db49816ac$export$2e2bcd8739ae039);

var $bMFKb = parcelRequire("bMFKb");
var $jXreb = parcelRequire("jXreb");

var $i8KtF = parcelRequire("i8KtF");
const $08450b8db49816ac$var$hasInvalidSteps = (tr)=>(tr.steps || []).some((step)=>step.from > step.to);
var $08450b8db49816ac$export$2e2bcd8739ae039 = (dispatchAnalyticsEvent)=>{
    return new (0, $i8KtF.SafePlugin)({
        filterTransaction (transaction) {
            if ($08450b8db49816ac$var$hasInvalidSteps(transaction)) {
                // eslint-disable-next-line no-console
                console.warn('The transaction was blocked because it contains invalid steps', transaction.steps);
                dispatchAnalyticsEvent({
                    action: (0, $bMFKb.ACTION).DISCARDED_INVALID_STEPS_FROM_TRANSACTION,
                    actionSubject: (0, $bMFKb.ACTION_SUBJECT).EDITOR,
                    attributes: {
                        analyticsEventPayloads: (0, $jXreb.getAnalyticsEventsFromTransaction)(transaction)
                    },
                    eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL
                });
                return false;
            }
            return true;
        }
    });
};

});

parcelRegister("9udmP", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ee19c3da06fb608$export$2e2bcd8739ae039);

var $bMFKb = parcelRequire("bMFKb");
var $8MfCL = parcelRequire("8MfCL");

var $9I6lS = parcelRequire("9I6lS");

var $8LHnV = parcelRequire("8LHnV");

var $i8KtF = parcelRequire("i8KtF");

var $dyNYh = parcelRequire("dyNYh");

var $3lIcL = parcelRequire("3lIcL");

var $btBeM = parcelRequire("btBeM");

var $lu3Zd = parcelRequire("lu3Zd");
const $8ee19c3da06fb608$export$70246689264eff75 = new (0, $3lIcL.PluginKey)('frozenEditor');
const $8ee19c3da06fb608$var$DEFAULT_KEYSTROKE_SAMPLING_LIMIT = 100;
const $8ee19c3da06fb608$var$DEFAULT_SLOW_THRESHOLD = 300;
const $8ee19c3da06fb608$export$c8d5b833abcf8e80 = 600;
const $8ee19c3da06fb608$export$47b2879ca9bbf67a = 2000;
const $8ee19c3da06fb608$export$1b622068be977101 = 3000;
const $8ee19c3da06fb608$var$DEFAULT_TRACK_SEVERITY_ENABLED = false;
const $8ee19c3da06fb608$export$5705ac5f923a65e7 = 100;
const $8ee19c3da06fb608$export$1c6feb3429832c55 = 500;
const $8ee19c3da06fb608$var$dispatchLongTaskEvent = (contextIdentifierPlugin)=>(dispatchAnalyticsEvent, view, time, getNodeCount, interactionType, severity)=>{
        const { state: state } = view;
        const nodesCount = getNodeCount(state);
        return dispatchAnalyticsEvent({
            action: (0, $bMFKb.ACTION).BROWSER_FREEZE,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).EDITOR,
            attributes: {
                objectId: contextIdentifierPlugin?.sharedState.currentState()?.contextIdentifierProvider?.objectId,
                freezeTime: time,
                nodeSize: state.doc.nodeSize,
                ...nodesCount,
                interactionType: interactionType,
                severity: severity
            },
            eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL
        });
    };
var $8ee19c3da06fb608$export$2e2bcd8739ae039 = (contextIdentifierPlugin)=>(dispatchAnalyticsEvent, inputTracking, browserFreezeTracking)=>{
        let interactionType;
        let inputLatencyTracker = null;
        if (browserFreezeTracking?.trackInteractionType) interactionType = (0, $btBeM.setInteractionType)((0, $8MfCL.BROWSER_FREEZE_INTERACTION_TYPE).LOADING);
        const samplingRate = inputTracking && typeof inputTracking.samplingRate === 'number' ? inputTracking.samplingRate : $8ee19c3da06fb608$var$DEFAULT_KEYSTROKE_SAMPLING_LIMIT;
        // TODO: ED-26959 - get right values here based on appearance
        const slowThreshold = $8ee19c3da06fb608$var$DEFAULT_SLOW_THRESHOLD;
        // TODO: ED-26959 - get right values here based on appearance
        const freezeThreshold = $8ee19c3da06fb608$export$c8d5b833abcf8e80;
        const allowCountNodes = inputTracking && inputTracking.countNodes;
        let prevNodeCountState = null;
        let prevNodeCount = {};
        // Cache the result as we were calling this multiple times
        // and has potential to be expensive
        const getNodeCount = (state)=>{
            if (state === prevNodeCountState) return prevNodeCount;
            prevNodeCount = allowCountNodes ? (0, $9I6lS.countNodes)(state) : {};
            prevNodeCountState = state;
            return prevNodeCount;
        };
        const shouldTrackSeverity = inputTracking?.trackSeverity || $8ee19c3da06fb608$var$DEFAULT_TRACK_SEVERITY_ENABLED;
        const severityThresholdNormal = inputTracking?.severityNormalThreshold || $8ee19c3da06fb608$export$5705ac5f923a65e7;
        const severityThresholdDegraded = inputTracking?.severityDegradedThreshold || $8ee19c3da06fb608$export$1c6feb3429832c55;
        const createDispatchSample = (action, view)=>(time, severity)=>{
                const { state: state } = view;
                const nodesCount = getNodeCount(state);
                const samplePayload = {
                    action: action,
                    actionSubject: (0, $bMFKb.ACTION_SUBJECT).EDITOR,
                    attributes: {
                        time: time,
                        nodeSize: state.doc.nodeSize,
                        ...nodesCount,
                        objectId: contextIdentifierPlugin?.sharedState.currentState()?.contextIdentifierProvider?.objectId,
                        severity: shouldTrackSeverity ? severity : undefined
                    },
                    eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL
                };
                dispatchAnalyticsEvent(samplePayload);
            };
        const createDispatchAverage = (action, view)=>({ mean: mean, median: median, sampleSize: sampleSize }, severity)=>{
                const { state: state } = view;
                const nodeCount = getNodeCount(state);
                const averagePayload = {
                    action: action,
                    actionSubject: (0, $bMFKb.ACTION_SUBJECT).EDITOR,
                    attributes: {
                        mean: mean,
                        median: median,
                        sampleSize: sampleSize,
                        ...nodeCount,
                        nodeSize: state.doc.nodeSize,
                        severity: shouldTrackSeverity ? severity : undefined,
                        objectId: contextIdentifierPlugin?.sharedState.currentState()?.contextIdentifierProvider?.objectId
                    },
                    eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL
                };
                dispatchAnalyticsEvent(averagePayload);
            };
        return new (0, $i8KtF.SafePlugin)({
            key: $8ee19c3da06fb608$export$70246689264eff75,
            props: (0, $8LHnV.isPerformanceAPIAvailable)() ? {
                handleTextInput (view) {
                    if (browserFreezeTracking?.trackInteractionType) interactionType = (0, $8MfCL.BROWSER_FREEZE_INTERACTION_TYPE).TYPING;
                    if (inputLatencyTracker) {
                        const end = inputLatencyTracker.start();
                        // This is called after all handleTextInput events are executed which means first handleTextInput time incorporates following handleTextInput processing time
                        // Also this is called before browser rendering so it doesn't count it.
                        requestAnimationFrame(end);
                    }
                    return false;
                },
                handleDOMEvents: browserFreezeTracking?.trackInteractionType ? {
                    click: ()=>{
                        interactionType = (0, $btBeM.setInteractionType)((0, $8MfCL.BROWSER_FREEZE_INTERACTION_TYPE).CLICKING);
                        return false;
                    },
                    paste: ()=>{
                        interactionType = (0, $btBeM.setInteractionType)((0, $8MfCL.BROWSER_FREEZE_INTERACTION_TYPE).PASTING);
                        return false;
                    }
                } : undefined
            } : undefined,
            view (view) {
                if (!(0, $8LHnV.isPerformanceObserverAvailable)()) return {};
                inputLatencyTracker = new (0, $lu3Zd.default)({
                    samplingRate: samplingRate,
                    slowThreshold: slowThreshold,
                    normalThreshold: severityThresholdNormal,
                    degradedThreshold: severityThresholdDegraded,
                    dispatchSample: createDispatchSample((0, $bMFKb.ACTION).INPUT_PERF_SAMPLING, view),
                    dispatchAverage: createDispatchAverage((0, $bMFKb.ACTION).INPUT_PERF_SAMPLING_AVG, view),
                    onSlowInput: (time)=>{
                        const { state: state } = view;
                        const nodesCount = getNodeCount(state);
                        dispatchAnalyticsEvent({
                            action: (0, $bMFKb.ACTION).SLOW_INPUT,
                            actionSubject: (0, $bMFKb.ACTION_SUBJECT).EDITOR,
                            attributes: {
                                time: time,
                                nodeSize: state.doc.nodeSize,
                                ...nodesCount,
                                objectId: contextIdentifierPlugin?.sharedState.currentState()?.contextIdentifierProvider?.objectId
                            },
                            eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL
                        });
                    }
                });
                let observer;
                try {
                    observer = new PerformanceObserver((list)=>{
                        const perfEntries = list.getEntries();
                        for(let i = 0; i < perfEntries.length; i++){
                            const { duration: duration } = perfEntries[i];
                            if (duration > freezeThreshold) $8ee19c3da06fb608$var$dispatchLongTaskEvent(contextIdentifierPlugin)(dispatchAnalyticsEvent, view, duration, getNodeCount, browserFreezeTracking?.trackInteractionType ? interactionType : undefined, (0, $dyNYh.getAnalyticsEventSeverity)(duration, // Ignored via go/ees007
                            // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
                            //TODO: get right values here
                            severityThresholdNormal, severityThresholdDegraded));
                        }
                    });
                    // register observer for long task notifications
                    observer.observe({
                        entryTypes: [
                            'longtask'
                        ]
                    });
                } catch (e) {}
                return {
                    destroy: ()=>{
                        inputLatencyTracker?.flush();
                        observer?.disconnect();
                    }
                };
            }
        });
    };

});
parcelRegister("9I6lS", function(module, exports) {

$parcel$export(module.exports, "countNodes", () => $518a979ea155355e$export$1daf15cbaf649dad);
function $518a979ea155355e$export$1daf15cbaf649dad(state) {
    const nodeCount = {};
    const extensionNodeCount = {};
    const nodeTypes = state.schema.nodes;
    const extensionNodeTypes = [
        nodeTypes.extension?.name,
        nodeTypes.inlineExtension?.name,
        nodeTypes.bodiedExtension?.name,
        nodeTypes.multiBodiedExtension?.name
    ];
    state.doc.descendants((node)=>{
        const nodeName = node.type.name;
        if (nodeName in nodeCount) nodeCount[nodeName]++;
        else nodeCount[nodeName] = 1;
        let extensionNodeName = nodeName;
        if (extensionNodeTypes.includes(extensionNodeName) && node.attrs?.extensionType) {
            extensionNodeName = `${node.attrs.extensionType} - ${node.attrs?.extensionKey}`;
            if (extensionNodeName in extensionNodeCount) extensionNodeCount[extensionNodeName]++;
            else extensionNodeCount[extensionNodeName] = 1;
        }
        return true;
    });
    return {
        nodeCount: nodeCount,
        extensionNodeCount: extensionNodeCount
    };
}

});

parcelRegister("btBeM", function(module, exports) {

$parcel$export(module.exports, "setInteractionType", () => $c78204369f8d32c0$export$324d9bc8f4935d84);
/** Allows the possibility of overriding interaction type values in unit tests via jest.mock or spyOn. */ const $c78204369f8d32c0$export$324d9bc8f4935d84 = (value)=>value;

});

parcelRegister("lu3Zd", function(module, exports) {

$parcel$export(module.exports, "default", () => $858fb2d2ea90605a$export$2e2bcd8739ae039);

var $dyNYh = parcelRequire("dyNYh");

var $cDfDI = parcelRequire("cDfDI");
class $858fb2d2ea90605a$export$2e2bcd8739ae039 {
    constructor({ samplingRate: samplingRate, slowThreshold: slowThreshold, normalThreshold: normalThreshold, degradedThreshold: degradedThreshold, dispatchAverage: dispatchAverage, dispatchSample: dispatchSample, onSampleStart: onSampleStart, onSampleEnd: onSampleEnd, onSlowInput: onSlowInput }){
        this.samples = [];
        this.total = 0;
        this.samplingRate = samplingRate;
        this.slowThreshold = slowThreshold;
        this.normalThreshold = normalThreshold;
        this.degradedThreshold = degradedThreshold;
        this.dispatchAverage = dispatchAverage;
        this.dispatchSample = dispatchSample;
        this.onSampleStart = onSampleStart;
        this.onSampleEnd = onSampleEnd;
        this.onSlowInput = onSlowInput;
    }
    start() {
        const currentStart = performance.now();
        if (this.samples.length + 1 === this.samplingRate) this.onSampleStart?.();
        const end = ()=>{
            if (currentStart === null) return;
            let isSlow = false;
            const time = (0, $cDfDI.getTimeSince)(currentStart);
            this.push(time);
            if (time > this.slowThreshold) {
                this.onSlowInput?.(time);
                isSlow = true;
            }
            if (this.samples.length === this.samplingRate) {
                this.flush();
                this.onSampleEnd?.(time, {
                    isSlow: isSlow,
                    severity: this.severity(time)
                });
            }
        };
        return end;
    }
    flush() {
        if (this.samples.length === 0) return;
        this.dispatch();
        this.samples = [];
        this.total = 0;
    }
    dispatch() {
        this.dispatchSample?.(this.getLast(), this.severity(this.getLast()));
        // cache
        const median = this.getMedian();
        this.dispatchAverage?.({
            mean: this.getMean(),
            median: median,
            sampleSize: this.samples.length
        }, this.severity(median));
    }
    push(latency) {
        this.samples.push(latency);
        this.total += latency;
    }
    severity(time) {
        return (0, $dyNYh.getAnalyticsEventSeverity)(time, this.normalThreshold, this.degradedThreshold);
    }
    getLast() {
        return this.samples[this.samples.length - 1];
    }
    getMean() {
        return this.total / this.samples.length;
    }
    getMedian() {
        if (this.samples.length === 1) return this.samples[0];
        this.samples.sort((a, b)=>a - b);
        const middle = (this.samples.length + 1) / 2;
        const floorMiddle = Math.floor(middle);
        const remainder = middle % floorMiddle;
        if (remainder === 0) return this.samples[middle - 1];
        const left = this.samples[floorMiddle - 1];
        const right = this.samples[floorMiddle];
        return (left + right) / 2;
    }
}

});
parcelRegister("cDfDI", function(module, exports) {

$parcel$export(module.exports, "getTimeSince", () => $4733a554f07dbbc9$export$a26b90db2c8f1b97);
/**
 * Calculate the difference between performance.now() and the given startTime.
 * This allows for the timing to be overridable during tests.
 *
 * @param startTime DOMHighResTimeStamp
 * @returns DOMHighResTimeStamp
 */ const $4733a554f07dbbc9$export$a26b90db2c8f1b97 = (startTime)=>performance.now() - startTime;

});



parcelRegister("hVrgn", function(module, exports) {

$parcel$export(module.exports, "default", () => $024d1731ff49b548$export$2e2bcd8739ae039);

var $7EdFW = parcelRequire("7EdFW");

var $i8KtF = parcelRequire("i8KtF");

var $5Z3Rm = parcelRequire("5Z3Rm");


var $3lIcL = parcelRequire("3lIcL");

var $b7EWj = parcelRequire("b7EWj");
const $024d1731ff49b548$export$8836bfc6be4cb708 = new (0, $3lIcL.PluginKey)('inlineCursorTargetPlugin');
const $024d1731ff49b548$var$isInlineNodeView = (node)=>{
    /**
	 * If inlineNodeView is a hardbreak we don't want to add decorations
	 * as it breaks soft line breaks for Japanese/Chinese keyboards.
	 */ const isHardBreak = node?.type === node?.type.schema.nodes.hardBreak;
    return node && node.type.isInline && !node.type.isText && !isHardBreak;
};
var $024d1731ff49b548$export$2e2bcd8739ae039 = ()=>{
    return new (0, $i8KtF.SafePlugin)({
        key: $024d1731ff49b548$export$8836bfc6be4cb708,
        state: {
            init: ()=>({
                    cursorTarget: undefined
                }),
            apply (tr) {
                const { selection: selection, doc: doc } = tr;
                const { $from: $from, $to: $to } = selection;
                // In Safari, if the cursor target is to the right of the cursor it will block selections
                // made with shift + arrowRight and vice versa for shift + arrowLeft. This is due to a
                // contenteditable bug in safari, where editable elements block the selection but we need
                // the cursor target to be editable for the following:
                // - Ability to navigate with down/up arrows when between inline nodes
                // - Ability to navigate with down/up arrows when between the start of a paragraph & an inline node
                // - Ability to click and drag to select an inline node if it is the first node
                // To prevent blocking the selection, we check handleDOMEvents and add meta to
                // the transaction to prevent the plugin from making cursor target decorations.
                const safariShiftSelection = tr.getMeta($024d1731ff49b548$export$8836bfc6be4cb708);
                if (selection && (0, $5Z3Rm.isTextSelection)(selection) && !safariShiftSelection) {
                    const hasInlineNodeViewAfter = $024d1731ff49b548$var$isInlineNodeView($from.nodeAfter);
                    const hasInlineNodeViewBefore = $024d1731ff49b548$var$isInlineNodeView($from.nodeBefore);
                    const isAtStartAndInlineNodeViewAfter = $from.parentOffset === 0 && $024d1731ff49b548$var$isInlineNodeView($from.nodeAfter);
                    const isAtEndAndInlineNodeViewBefore = doc.resolve($from.pos).node().lastChild === $from.nodeBefore && $024d1731ff49b548$var$isInlineNodeView($from.nodeBefore);
                    const createWidget = (side)=>{
                        const node = document.createElement('span');
                        node.contentEditable = 'true';
                        node.setAttribute('aria-hidden', 'true');
                        node.appendChild(document.createTextNode((0, $f9e41f230eb38f84$export$15a09f5ef055bcfa)));
                        node.className = 'cursor-target';
                        const { $from: $from } = selection;
                        const rightPosition = $from.pos;
                        const leftPosition = $from.posAtIndex(Math.max($from.index() - 1, 0));
                        const widgetPos = side === 'left' ? leftPosition : rightPosition;
                        return (0, $b7EWj.Decoration).widget(widgetPos, node, {
                            raw: true,
                            key: 'inlineCursor'
                        });
                    };
                    // Create editable decoration widgets around the current inline node to allow proper cursor navigation.
                    if ((hasInlineNodeViewAfter || isAtEndAndInlineNodeViewBefore) && (hasInlineNodeViewBefore || isAtStartAndInlineNodeViewAfter)) return {
                        cursorTarget: {
                            decorations: [
                                createWidget('left'),
                                createWidget('right')
                            ],
                            positions: {
                                from: $from.pos,
                                to: $to.pos
                            }
                        }
                    };
                }
                return {
                    cursorTarget: undefined
                };
            }
        },
        props: {
            decorations (state) {
                const { doc: doc } = state;
                const { cursorTarget: cursorTarget } = $024d1731ff49b548$export$8836bfc6be4cb708.getState(state);
                if ($024d1731ff49b548$var$cursorTargetHasValidDecorations(cursorTarget)) return (0, $b7EWj.DecorationSet).create(doc, cursorTarget.decorations);
                return null;
            },
            handleDOMEvents: {
                // Workaround to prevent the decorations created by the plugin from
                // blocking shift + arrow left/right selections in safari. When
                // a shift + arrow left/right event is detected, send meta data to the
                // plugin to prevent it from creating decorations.
                // TODO: ED-26959 - We may be able to remove this when playing the following ticket:
                // https://product-fabric.atlassian.net/browse/ED-14938
                keydown: (view, event)=>{
                    if ((0, $7EdFW.browser).safari && event instanceof KeyboardEvent && event.shiftKey && (event.key === 'ArrowLeft' || event.key === 'ArrowRight')) view.dispatch(view.state.tr.setMeta($024d1731ff49b548$export$8836bfc6be4cb708, {
                        cursorTarget: undefined
                    }));
                    return false;
                },
                // Check the DOM to see if there are inline cursor targets
                // after a composition event ends. If so, manually insert the
                // event data in order to prevent contents ending up inside
                // of the cursor target decorations.
                compositionend: (view, incorrectlyTypedEvent)=>{
                    // This is typed by the prosemirror definitions as Event,
                    // this type is incorrect, and it is actually an InputEvent
                    const event = incorrectlyTypedEvent;
                    const { state: state } = view;
                    const { cursorTarget: cursorTarget } = $024d1731ff49b548$export$8836bfc6be4cb708.getState(state);
                    if (cursorTarget !== undefined) {
                        $024d1731ff49b548$var$handleTextInputInsideCursorTargetDecoration({
                            event: event,
                            cursorTarget: cursorTarget,
                            view: view
                        });
                        return true;
                    }
                    return false;
                },
                // Check the DOM to see if there are inline cursor targets
                // before any input event. If so, manually insert the
                // event data in order to prevent contents ending up inside
                // of the cursor target decorations.
                beforeinput: (view, incorrectlyTypedEvent)=>{
                    // This is typed by the prosemirror definitions as Event,
                    // this type is incorrect, and it is actually an InputEvent
                    const event = incorrectlyTypedEvent;
                    const { state: state } = view;
                    const { cursorTarget: cursorTarget } = $024d1731ff49b548$export$8836bfc6be4cb708.getState(state);
                    if (!event.isComposing && cursorTarget !== undefined) {
                        $024d1731ff49b548$var$handleTextInputInsideCursorTargetDecoration({
                            event: event,
                            cursorTarget: cursorTarget,
                            view: view
                        });
                        return true;
                    }
                    return false;
                }
            }
        }
    });
};
function $024d1731ff49b548$var$cursorTargetHasValidDecorations(cursorTarget) {
    if (!cursorTarget || // Decorations can end up as null when the decorations prop is
    // called after the decorations have been removed from the dom.
    // https://github.com/ProseMirror/prosemirror-view/blob/8f0d313a6389b86a335274fba36534ba1cb21f12/src/decoration.js#L30
    cursorTarget.decorations.includes(null)) return false;
    return true;
}
function $024d1731ff49b548$var$handleTextInputInsideCursorTargetDecoration({ event: event, view: view, cursorTarget: cursorTarget }) {
    event.stopPropagation();
    event.preventDefault();
    const content = event.data || '';
    const tr = view.state.tr;
    // ensure any custom handleTextInput handlers are called for the input event
    // ie. type ahead, emoji shortcuts.
    const potentiallyHandleByHandleTextInput = view.someProp('handleTextInput', (f)=>f(view, cursorTarget.positions.from, cursorTarget.positions.to, content));
    if (potentiallyHandleByHandleTextInput) // if a handleTextInput handler has handled the event, we don't want to
    // manually update the document.
    return;
    tr.insertText(content);
    view.dispatch(tr);
}

});

parcelRegister("iUuxx", function(module, exports) {

$parcel$export(module.exports, "createLazyNodeViewDecorationPlugin", () => $d62dcf470f78e135$export$650082547b31be68);

var $hkA3A = parcelRequire("hkA3A");

var $i8KtF = parcelRequire("i8KtF");

var $b7EWj = parcelRequire("b7EWj");
const $d62dcf470f78e135$var$LAZY_NODE_VIEW_DECORATION_CLASS = '__lazy-node-view-decoration__';
function $d62dcf470f78e135$export$650082547b31be68() {
    return new (0, $i8KtF.SafePlugin)({
        key: (0, $hkA3A.lazyNodeViewDecorationPluginKey),
        state: {
            init: ()=>{
                return {
                    decorations: (0, $b7EWj.DecorationSet).empty,
                    nodeTypes: []
                };
            },
            apply (tr, _oldState, newState) {
                const actionPayload = tr.getMeta((0, $hkA3A.lazyNodeViewDecorationPluginKey));
                const pluginState = (0, $hkA3A.lazyNodeViewDecorationPluginKey).getState(newState);
                if (actionPayload?.type === 'add' && actionPayload.nodeTypes.size) {
                    const decorations = [];
                    tr.doc.nodesBetween(0, tr.doc.nodeSize - 2, (node, pos)=>{
                        if (actionPayload.nodeTypes.has(node.type.name)) decorations.push((0, $b7EWj.Decoration).node(pos, pos + node.nodeSize, {
                            class: $d62dcf470f78e135$var$LAZY_NODE_VIEW_DECORATION_CLASS
                        }));
                    });
                    return {
                        decorations: (0, $b7EWj.DecorationSet).create(tr.doc, decorations)
                    };
                }
                if (actionPayload?.type === 'clear') return {
                    decorations: (0, $b7EWj.DecorationSet).empty
                };
                if (tr.docChanged) return {
                    decorations: pluginState?.decorations.map(tr.mapping, tr.doc)
                };
                return pluginState;
            }
        },
        props: {
            decorations: (state)=>{
                return (0, $hkA3A.lazyNodeViewDecorationPluginKey).getState(state)?.decorations;
            }
        },
        view (editorView) {
            return {
                update () {
                    /**
					 * After view update can clean up decorations...
					 */ const pluginState = (0, $hkA3A.lazyNodeViewDecorationPluginKey).getState(editorView.state);
                    if (pluginState.decorations !== (0, $b7EWj.DecorationSet).empty) {
                        const tr = editorView.state.tr;
                        tr.setMeta((0, $hkA3A.lazyNodeViewDecorationPluginKey), {
                            type: 'clear'
                        });
                        editorView.dispatch(tr);
                    }
                }
            };
        }
    });
}

});
parcelRegister("hkA3A", function(module, exports) {

$parcel$export(module.exports, "lazyNodeViewDecorationPluginKey", () => $e3e8f14f61febe2b$export$325659f41b2239a7);
$parcel$export(module.exports, "withLazyLoading", () => $e3e8f14f61febe2b$export$6b97b121e15a69b7);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $3lIcL = parcelRequire("3lIcL");

var $lk39V = parcelRequire("lk39V");

var $b08BT = parcelRequire("b08BT");

var $6D3CR = parcelRequire("6D3CR");
const $e3e8f14f61febe2b$export$325659f41b2239a7 = new (0, $3lIcL.PluginKey)('lazyNodeViewDecoration');
/**
 * 🧱 Internal: Editor FE Platform
 *
 * Controls which node was scheduled to load the original node view code
 */ const $e3e8f14f61febe2b$var$requestedNodesPerEditorView = new WeakMap();
/**
 * 🧱 Internal: Editor FE Platform
 *
 * Caches loaded node view factory functions for each editor view
 */ const $e3e8f14f61febe2b$var$resolvedNodesPerEditorView = new WeakMap();
/**
 * 🧱 Internal: Editor FE Platform
 *
 * Stores editorView -> raf to debounce NodeView updates.
 */ const $e3e8f14f61febe2b$var$debounceToEditorViewMap = new WeakMap();
const $e3e8f14f61febe2b$var$testOnlyIgnoreLazyNodeViewSet = new WeakSet();
function $e3e8f14f61febe2b$export$6c7e823c919edf69(view) {
    $e3e8f14f61febe2b$var$testOnlyIgnoreLazyNodeViewSet.add(view);
}
const $e3e8f14f61febe2b$export$6b97b121e15a69b7 = ({ nodeName: nodeName, loader: loader, getNodeViewOptions: getNodeViewOptions })=>{
    return (node, view, getPos, decorations, innerDecorations)=>{
        let requestedNodes = $e3e8f14f61febe2b$var$requestedNodesPerEditorView.get(view);
        if (!requestedNodes) {
            requestedNodes = new Map();
            $e3e8f14f61febe2b$var$requestedNodesPerEditorView.set(view, requestedNodes);
        }
        const resolvedNodeViews = $e3e8f14f61febe2b$var$resolvedNodesPerEditorView.get(view);
        if (!resolvedNodeViews) $e3e8f14f61febe2b$var$resolvedNodesPerEditorView.set(view, new Map());
        const wasAlreadyRequested = requestedNodes.has(nodeName);
        if (wasAlreadyRequested) {
            const resolvedNodeView = resolvedNodeViews?.get(nodeName);
            if (resolvedNodeView && !$e3e8f14f61febe2b$var$testOnlyIgnoreLazyNodeViewSet.has(view)) return resolvedNodeView(node, view, getPos, decorations, innerDecorations);
            return new (0, $b08BT.LazyNodeView)(node, view, getPos, decorations);
        }
        const loaderPromise = loader().then((nodeViewFuncModule)=>{
            const nodeViewFunc = (node, view, getPos, decorations, innerDecorations)=>{
                const nodeView = nodeViewFuncModule(node, view, getPos, decorations, getNodeViewOptions, innerDecorations);
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = nodeView.dom;
                dom.setAttribute('data-vc', `editor-lnv-loaded--${node.type.name}`);
                const pos = getPos();
                if (pos !== undefined) dom.setAttribute('data-editor-lnv-placeholder-replace', (0, $b08BT.makeNodePlaceholderId)(node.type.name, pos));
                return nodeView;
            };
            $e3e8f14f61febe2b$var$resolvedNodesPerEditorView.get(view)?.set(nodeName, nodeViewFunc);
            /**
			 * Triggering lazyNodeViewDecoration plugin to apply decorations
			 * to nodes with newly loaded NodeViews.
			 */ const [callbackId, nodeTypes] = $e3e8f14f61febe2b$var$debounceToEditorViewMap.get(view) || [
                null,
                new Set()
            ];
            if (callbackId) (0, $lk39V.cancelCallback)(callbackId);
            nodeTypes.add(node.type.name);
            const nextCallbackId = (0, $lk39V.scheduleCallback)(()=>{
                $e3e8f14f61febe2b$var$debounceToEditorViewMap.set(view, [
                    null,
                    new Set()
                ]);
                const tr = view.state.tr;
                tr.setMeta($e3e8f14f61febe2b$export$325659f41b2239a7, {
                    type: 'add',
                    nodeTypes: nodeTypes
                });
                view.dispatch(tr);
            });
            $e3e8f14f61febe2b$var$debounceToEditorViewMap.set(view, [
                nextCallbackId,
                nodeTypes
            ]);
            /**
			 * END triggering LazyNodeViewDecoration plugin
			 */ return nodeViewFunc;
        });
        requestedNodes.set(nodeName, loaderPromise);
        typeof node.type?.spec?.toDOM;
        return new (0, $b08BT.LazyNodeView)(node, view, getPos, decorations);
    };
};

});
parcelRegister("lk39V", function(module, exports) {

$parcel$export(module.exports, "scheduleCallback", () => $8c4668674839fdc0$export$4db3c991f22dbc2d);
$parcel$export(module.exports, "cancelCallback", () => $8c4668674839fdc0$export$b888d8f981c07a46);
const $8c4668674839fdc0$var$hasIdleCallback = 'requestIdleCallback' in window;
const $8c4668674839fdc0$export$4db3c991f22dbc2d = (cb, options)=>{
    return $8c4668674839fdc0$var$hasIdleCallback ? requestIdleCallback(cb, {
        timeout: 5000,
        ...options
    }) : requestAnimationFrame(cb);
};
const $8c4668674839fdc0$export$b888d8f981c07a46 = (id)=>{
    return $8c4668674839fdc0$var$hasIdleCallback ? cancelIdleCallback(id) : cancelAnimationFrame(id);
};

});

parcelRegister("b08BT", function(module, exports) {

$parcel$export(module.exports, "makeNodePlaceholderId", () => $b549a2854d6f21a9$export$f306d9dd555af398);
$parcel$export(module.exports, "LazyNodeView", () => $b549a2854d6f21a9$export$dccb00b9da782c66);

var $5PQOA = parcelRequire("5PQOA");

var $3xw6l = parcelRequire("3xw6l");
const $b549a2854d6f21a9$var$getEditorLineWidth = (0, (/*@__PURE__*/$parcel$interopDefault($5PQOA)))((view)=>{
    return view.dom?.clientWidth;
});
// Copied from ProseMirror NodeView
// https://github.com/ProseMirror/prosemirror-view/blob/cfa73eb969777f63bcb39972594fd4a9110f5a93/src/viewdesc.ts#L1095-L1099
function $b549a2854d6f21a9$var$sameOuterDeco(a, b) {
    if (a.length !== b.length) return false;
    for(let i = 0; i < a.length; i++){
        // @ts-expect-error type actually exist on decoration at runtime
        if (!a[i].type) return false;
        // @ts-expect-error type actually exist on decoration at runtime
        if (!a[i].type.eq(b[i].type)) return false;
    }
    return true;
}
function $b549a2854d6f21a9$export$f306d9dd555af398(nodeType, pos) {
    return `${nodeType}:${pos}`;
}
class $b549a2854d6f21a9$export$dccb00b9da782c66 {
    constructor(node, view, _getPos, outerDeco){
        this.update = (node, outerDeco)=>{
            const prevNode = this.node;
            this.node = node;
            if (!$b549a2854d6f21a9$var$sameOuterDeco(outerDeco, this.outerDeco)) return false;
            // Copying some of the default NodeView update behaviour
            // https://github.com/ProseMirror/prosemirror-view/blob/cfa73eb969777f63bcb39972594fd4a9110f5a93/src/viewdesc.ts#L803
            return !this.node.sameMarkup(prevNode);
        };
        this.node = node;
        this.outerDeco = outerDeco;
        if (typeof node.type?.spec?.toDOM !== 'function') {
            this.dom = document.createElement('div');
            return;
        }
        const toDOMConfiguration = {
            editorLineWidth: $b549a2854d6f21a9$var$getEditorLineWidth(view)
        };
        const fallback = (0, $3xw6l.DOMSerializer).renderSpec(document, node.type.spec.toDOM(node, // We are injecting a second parameter to be used by the toDOM lazy node view implementations
        // @ts-expect-error
        toDOMConfiguration));
        this.dom = fallback.dom;
        this.contentDOM = fallback.contentDOM;
        if (this.dom instanceof HTMLElement) {
            // This attribute is mostly used for debugging purposed
            // It will help us to found out when the node was replaced
            this.dom.setAttribute('data-lazy-node-view', node.type.name);
            // This is used on Libra tests
            // We are using this to make sure all lazy noded were replaced
            // before the test started
            this.dom.setAttribute('data-lazy-node-view-fallback', 'true');
            // This is used by the UFO to identify the node
            this.dom.setAttribute('data-vc', `editor-lnv-fallback--${node.type.name}`);
            const pos = _getPos();
            if (pos !== undefined) // Used for UFO to identify this as a placeholder
            this.dom.setAttribute('data-editor-lnv-placeholder', $b549a2854d6f21a9$export$f306d9dd555af398(node.type.name, pos));
        }
    }
    ignoreMutation() {
        if (this.node.type.isTextblock) return false;
        return true;
    }
}

});

parcelRegister("6D3CR", function(module, exports) {

$parcel$export(module.exports, "convertToInlineCss", () => $7b699afabc4d5eec$export$7da93c9174ab9340);
/**
 * Converts a camelCased CSS property name to a hyphenated CSS property name.
 *
 * @param property - CamelCased CSS property name.
 * @returns Hyphenated CSS property name.
 */ function $7b699afabc4d5eec$var$hyphenate(property) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return property.replace(/[A-Z]/g, (match)=>`-${match.toLowerCase()}`).replace(/^ms/, '-ms');
}
function $7b699afabc4d5eec$export$7da93c9174ab9340(properties) {
    const cssString = Object.entries(properties).sort(([a], [b])=>a.localeCompare(b)).map(([property, value])=>`${property.startsWith('--') ? property : $7b699afabc4d5eec$var$hyphenate(property)}: ${value};`).join(' ');
    return cssString;
}

});



parcelRegister("8hwRf", function(module, exports) {

$parcel$export(module.exports, "default", () => $66790e82e4c518d3$export$2e2bcd8739ae039);

var $i8KtF = parcelRequire("i8KtF");

var $HOLTj = parcelRequire("HOLTj");
var $bnAxN = parcelRequire("bnAxN");

var $x7sgX = parcelRequire("x7sgX");

var $3lIcL = parcelRequire("3lIcL");
const $66790e82e4c518d3$export$2f489388b18569dd = new (0, $3lIcL.PluginKey)('newlinePreserveMarksPlugin');
const $66790e82e4c518d3$var$isSelectionAligned = (state)=>!!state.selection.$to.parent.marks.find((m)=>m.type === state.schema.marks.alignment);
const $66790e82e4c518d3$var$splitBlockPreservingMarks = (state, dispatch)=>{
    if (dispatch) dispatch(state.tr.split(state.tr.mapping.map(state.selection.$from.pos), 1));
    return true;
};
var $66790e82e4c518d3$export$2e2bcd8739ae039 = ()=>new (0, $i8KtF.SafePlugin)({
        key: $66790e82e4c518d3$export$2f489388b18569dd,
        props: {
            handleKeyDown: (0, $x7sgX.keydownHandler)({
                Enter: (0, $HOLTj.filterCommand)([
                    (0, $bnAxN.isSelectionEndOfParagraph),
                    $66790e82e4c518d3$var$isSelectionAligned
                ], $66790e82e4c518d3$var$splitBlockPreservingMarks)
            })
        }
    });

});
parcelRegister("HOLTj", function(module, exports) {

$parcel$export(module.exports, "walkNextNode", () => $fa3fe07496cb04ee$export$a5ae75c0b3dfe1c0);
$parcel$export(module.exports, "walkPrevNode", () => $fa3fe07496cb04ee$export$cab15df6ad89b5a0);
$parcel$export(module.exports, "insertNewLineWithAnalytics", () => $fa3fe07496cb04ee$export$67efd148fa31066c);
$parcel$export(module.exports, "createNewParagraphAbove", () => $fa3fe07496cb04ee$export$fd094c1e3c1540bf);
$parcel$export(module.exports, "createParagraphNear", () => $fa3fe07496cb04ee$export$d0f80ac1b4510888);
$parcel$export(module.exports, "createNewParagraphBelow", () => $fa3fe07496cb04ee$export$d4296e42f66d8dc6);
$parcel$export(module.exports, "deleteEmptyParagraphAndMoveBlockUp", () => $fa3fe07496cb04ee$export$a52ade1f964aef2c);
$parcel$export(module.exports, "insertContentDeleteRange", () => $fa3fe07496cb04ee$export$1a87582f65bdc5db);
$parcel$export(module.exports, "isEmptySelectionAtStart", () => $fa3fe07496cb04ee$export$55f1e30b4664ff16);
$parcel$export(module.exports, "isEmptySelectionAtEnd", () => $fa3fe07496cb04ee$export$aedf35c057f77b82);
$parcel$export(module.exports, "filterCommand", () => $fa3fe07496cb04ee$export$3dea766d36a8935f);

var $3xw6l = parcelRequire("3xw6l");

var $3lIcL = parcelRequire("3lIcL");

var $bMFKb = parcelRequire("bMFKb");

var $asjM0 = parcelRequire("asjM0");

var $6BNUN = parcelRequire("6BNUN");

var $5Z3Rm = parcelRequire("5Z3Rm");

var $9Ssie = parcelRequire("9Ssie");
const $fa3fe07496cb04ee$export$3dea766d36a8935f = (predicates, cmd)=>{
    return function(state, dispatch, view) {
        if (!Array.isArray(predicates)) predicates = [
            predicates
        ];
        if (predicates.some((pred)=>!pred(state, view))) return false;
        return cmd(state, dispatch, view) || false;
    };
};
const $fa3fe07496cb04ee$export$a5ae75c0b3dfe1c0 = ($startPos)=>{
    let $pos = $startPos;
    // invariant 1: don't walk past the end of the document
    // invariant 2: we are at the beginning or
    //              we haven't walked to the start of *any* node
    //              parentOffset includes textOffset.
    while($pos.pos < $pos.doc.nodeSize - 2 && ($pos.pos === $startPos.pos || $pos.parentOffset > 0))$pos = $pos.doc.resolve($pos.pos + 1);
    return {
        $pos: $pos,
        foundNode: $pos.pos < $pos.doc.nodeSize - 2
    };
};
const $fa3fe07496cb04ee$export$cab15df6ad89b5a0 = ($startPos)=>{
    let $pos = $startPos;
    while($pos.pos > 0 && ($pos.pos === $startPos.pos || $pos.parentOffset < $pos.parent.nodeSize - 2))$pos = $pos.doc.resolve($pos.pos - 1);
    return {
        $pos: $pos,
        foundNode: $pos.pos > 0
    };
};
function $fa3fe07496cb04ee$export$c2d9390f63354627() {
    return function(state, dispatch) {
        const { $from: $from } = state.selection;
        const parent = $from.parent;
        const { hardBreak: hardBreak } = state.schema.nodes;
        if (hardBreak) {
            const hardBreakNode = hardBreak.createChecked();
            if (parent && parent.type.validContent((0, $3xw6l.Fragment).from(hardBreakNode))) {
                if (dispatch) dispatch(state.tr.replaceSelectionWith(hardBreakNode, false));
                return true;
            }
        }
        if (state.selection instanceof (0, $3lIcL.TextSelection)) {
            if (dispatch) dispatch(state.tr.insertText('\n'));
            return true;
        }
        return false;
    };
}
const $fa3fe07496cb04ee$export$67efd148fa31066c = (editorAnalyticsAPI)=>(0, $asjM0.withAnalytics)(editorAnalyticsAPI, {
        action: (0, $bMFKb.ACTION).INSERTED,
        actionSubject: (0, $bMFKb.ACTION_SUBJECT).TEXT,
        actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).LINE_BREAK,
        eventType: (0, $bMFKb.EVENT_TYPE).TRACK
    })($fa3fe07496cb04ee$export$c2d9390f63354627());
const $fa3fe07496cb04ee$export$fd094c1e3c1540bf = (state, dispatch)=>{
    const append = false;
    if (!$fa3fe07496cb04ee$var$canMoveUp(state) && $fa3fe07496cb04ee$var$canCreateParagraphNear(state)) {
        $fa3fe07496cb04ee$export$d0f80ac1b4510888(append)(state, dispatch);
        return true;
    }
    return false;
};
const $fa3fe07496cb04ee$export$d4296e42f66d8dc6 = (state, dispatch)=>{
    const append = true;
    if (!$fa3fe07496cb04ee$var$canMoveDown(state) && $fa3fe07496cb04ee$var$canCreateParagraphNear(state)) {
        $fa3fe07496cb04ee$export$d0f80ac1b4510888(append)(state, dispatch);
        return true;
    }
    return false;
};
function $fa3fe07496cb04ee$var$canCreateParagraphNear(state) {
    const { selection: { $from: $from } } = state;
    const node = $from.node($from.depth);
    const insideCodeBlock = !!node && node.type === state.schema.nodes.codeBlock;
    const isNodeSelection = state.selection instanceof (0, $3lIcL.NodeSelection);
    return $from.depth > 1 || isNodeSelection || insideCodeBlock;
}
function $fa3fe07496cb04ee$export$d0f80ac1b4510888(append = true) {
    return function(state, dispatch) {
        const paragraph = state.schema.nodes.paragraph;
        if (!paragraph) return false;
        let insertPos;
        if (state.selection instanceof (0, $3lIcL.TextSelection)) {
            if ($fa3fe07496cb04ee$var$topLevelNodeIsEmptyTextBlock(state)) return false;
            insertPos = $fa3fe07496cb04ee$var$getInsertPosFromTextBlock(state, append);
        } else insertPos = $fa3fe07496cb04ee$var$getInsertPosFromNonTextBlock(state, append);
        const tr = state.tr.insert(insertPos, paragraph.createAndFill());
        tr.setSelection((0, $3lIcL.TextSelection).create(tr.doc, insertPos + 1));
        if (dispatch) dispatch(tr);
        return true;
    };
}
function $fa3fe07496cb04ee$var$getInsertPosFromTextBlock(state, append) {
    const { $from: $from, $to: $to } = state.selection;
    let pos;
    if (!append) pos = $from.start(0);
    else pos = $to.end(0);
    return pos;
}
function $fa3fe07496cb04ee$var$getInsertPosFromNonTextBlock(state, append) {
    const { $from: $from, $to: $to } = state.selection;
    const nodeAtSelection = state.selection instanceof (0, $3lIcL.NodeSelection) && state.doc.nodeAt(state.selection.$anchor.pos);
    const isMediaSelection = nodeAtSelection && nodeAtSelection.type.name === 'mediaGroup';
    let pos;
    if (!append) {
        // The start position is different with text block because it starts from 0
        pos = $from.start($from.depth);
        // The depth is different with text block because it starts from 0
        pos = $from.depth > 0 && !isMediaSelection ? pos - 1 : pos;
    } else {
        pos = $to.end($to.depth);
        pos = $to.depth > 0 && !isMediaSelection ? pos + 1 : pos;
    }
    return pos;
}
function $fa3fe07496cb04ee$var$topLevelNodeIsEmptyTextBlock(state) {
    const topLevelNode = state.selection.$from.node(1);
    return topLevelNode.isTextblock && topLevelNode.type !== state.schema.nodes.codeBlock && topLevelNode.nodeSize === 2;
}
function $fa3fe07496cb04ee$var$canMoveUp(state) {
    const { selection: selection } = state;
    /**
	 * If there's a media element on the selection it will use a gap cursor to move
	 */ if (selection instanceof (0, $3lIcL.NodeSelection) && (0, $9Ssie.isMediaNode)(selection.node)) return true;
    if (selection instanceof (0, $3lIcL.TextSelection)) {
        if (!selection.empty) return true;
    }
    return !$fa3fe07496cb04ee$export$e9083e8cbe24bec0(state);
}
function $fa3fe07496cb04ee$var$canMoveDown(state) {
    const { selection: selection } = state;
    /**
	 * If there's a media element on the selection it will use a gap cursor to move
	 */ if (selection instanceof (0, $3lIcL.NodeSelection) && (0, $9Ssie.isMediaNode)(selection.node)) return true;
    if (selection instanceof (0, $3lIcL.TextSelection)) {
        if (!selection.empty) return true;
    }
    return !$fa3fe07496cb04ee$export$4ca816540352da02(state);
}
function $fa3fe07496cb04ee$export$4ca816540352da02(state) {
    const { selection: selection, doc: doc } = state;
    return doc.nodeSize - selection.$to.pos - 2 === selection.$to.depth;
}
function $fa3fe07496cb04ee$export$e9083e8cbe24bec0(state) {
    const { selection: selection } = state;
    return selection.$from.pos === selection.$from.depth;
}
const $fa3fe07496cb04ee$export$a52ade1f964aef2c = (canNextNodeMoveUp)=>{
    return (state, dispatch, view)=>{
        const { selection: { $from: { pos: pos, parent: parent }, $head: $head, empty: empty }, tr: tr, doc: doc } = state;
        const { $pos: $pos } = $fa3fe07496cb04ee$export$a5ae75c0b3dfe1c0($head);
        const nextPMNode = doc.nodeAt($pos.pos - 1);
        if (empty && nextPMNode && canNextNodeMoveUp(nextPMNode) && (0, $5Z3Rm.isEmptyParagraph)(parent) && view?.endOfTextblock('right')) {
            tr.deleteRange(pos - 1, pos + 1);
            if (dispatch) dispatch(tr);
            return true;
        }
        return false;
    };
};
const $fa3fe07496cb04ee$export$1a87582f65bdc5db = (tr, getSelectionResolvedPos, insertions, deletions)=>{
    insertions.forEach((contentInsert)=>{
        const [content, pos] = contentInsert;
        tr.insert(tr.mapping.map(pos), content);
    });
    deletions.forEach((deleteRange)=>{
        const [firstPos, lastPos] = deleteRange;
        tr.delete(tr.mapping.map(firstPos), tr.mapping.map(lastPos));
    });
    tr.setSelection(new (0, $3lIcL.TextSelection)(getSelectionResolvedPos(tr)));
};
const $fa3fe07496cb04ee$export$55f1e30b4664ff16 = (state)=>{
    const { empty: empty, $from: $from } = state.selection;
    return empty && ($from.parentOffset === 0 || state.selection instanceof (0, $6BNUN.GapCursorSelection));
};
const $fa3fe07496cb04ee$export$aedf35c057f77b82 = (state)=>{
    const { empty: empty, $from: $from } = state.selection;
    return empty && ($from.end() === $from.pos || state.selection instanceof (0, $6BNUN.GapCursorSelection));
};

});
parcelRegister("asjM0", function(module, exports) {

$parcel$export(module.exports, "withAnalytics", () => $40dab61f4313c98f$export$af9baadf0e4f6e13);
function $40dab61f4313c98f$export$af9baadf0e4f6e13(analyticsApi, payload, channel) {
    return (command)=>(state, dispatch, view)=>command(state, (tr)=>{
                if (dispatch) {
                    if (payload instanceof Function) {
                        const dynamicPayload = payload(state);
                        if (dynamicPayload) {
                            analyticsApi?.attachAnalyticsEvent(dynamicPayload, channel)(tr);
                            dispatch(tr);
                        }
                    } else {
                        analyticsApi?.attachAnalyticsEvent(payload, channel)(tr);
                        dispatch(tr);
                    }
                }
            }, view);
}

});



parcelRegister("2frjn", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8dc9c9763c1aa4b$export$2e2bcd8739ae039);

var $i8KtF = parcelRequire("i8KtF");

var $9P93m = parcelRequire("9P93m");
const $a8dc9c9763c1aa4b$var$GUTTER_SIZE_IN_PX = 120;
const $a8dc9c9763c1aa4b$var$GUTTER_SELECTOR_NAME = 'editor-scroll-gutter';
/**
 * Create a gutter element that can be added or removed from the DOM.
 */ function $a8dc9c9763c1aa4b$var$createGutter(gutterSize, parent) {
    const gutter = document.createElement('div');
    gutter.style.paddingBottom = `${gutterSize}px`;
    gutter.setAttribute('data-vc', 'scroll-gutter');
    gutter.id = $a8dc9c9763c1aa4b$var$GUTTER_SELECTOR_NAME;
    if (parent) parent.appendChild(gutter);
    return ()=>parent?.removeChild(gutter);
}
var $a8dc9c9763c1aa4b$export$2e2bcd8739ae039 = (pluginOptions = {})=>{
    const { getScrollElement: getScrollElement, gutterSize: gutterSize = $a8dc9c9763c1aa4b$var$GUTTER_SIZE_IN_PX } = pluginOptions;
    if (!getScrollElement) return undefined;
    return new (0, $i8KtF.SafePlugin)({
        key: (0, $9P93m.scrollGutterPluginKey),
        state: {
            init: ()=>({}),
            apply: (tr, pluginState)=>{
                if (tr.getMeta((0, $9P93m.scrollGutterPluginKey))) return tr.getMeta((0, $9P93m.scrollGutterPluginKey));
                return pluginState;
            }
        },
        props: {
            // Determines the distance (in pixels) between the cursor and the end of the visible viewport at which point,
            // when scrolling the cursor into view, scrolling takes place.
            // Defaults to 0: https://prosemirror.net/docs/ref/#view.EditorProps.scrollThreshold
            scrollThreshold: gutterSize,
            // Determines the extra space (in pixels) that is left above or below the cursor when it is scrolled into view.
            // Defaults to 5: https://prosemirror.net/docs/ref/#view.EditorProps.scrollMargin
            scrollMargin: gutterSize
        },
        view (view) {
            // Store references to avoid lookups on successive checks.
            const scrollElement = getScrollElement(view);
            let editorElement = view.dom instanceof HTMLElement ? view.dom : null;
            let editorParentElement = editorElement?.parentElement;
            let cleanup = ()=>{};
            if (editorParentElement && scrollElement) cleanup = $a8dc9c9763c1aa4b$var$createGutter(gutterSize, editorParentElement);
            return {
                destroy () {
                    cleanup();
                    editorParentElement = editorElement = null;
                }
            };
        }
    });
};

});

parcelRegister("02sTQ", function(module, exports) {

$parcel$export(module.exports, "getKeyboardHeight", () => $8a5f047a5d73bb75$export$af5702f0c69bf4d7);

var $9P93m = parcelRequire("9P93m");
const $8a5f047a5d73bb75$export$af5702f0c69bf4d7 = (state)=>{
    if (state) {
        const scrollGutterPluginState = (0, $9P93m.getScrollGutterPluginState)(state);
        return scrollGutterPluginState ? scrollGutterPluginState.keyboardHeight : undefined;
    }
};

});

parcelRegister("htlTO", function(module, exports) {

$parcel$export(module.exports, "inputTracking", () => $70fbb96fe8b566ba$export$30b652f8daa79df4);
const $70fbb96fe8b566ba$export$30b652f8daa79df4 = {
    enabled: true,
    samplingRate: 100,
    countNodes: true,
    trackSeverity: true,
    trackRenderingTime: false,
    trackSingleKeypress: false,
    // TODO: ED-26959 - change this based on appearance due to SLOs - need to make ticket for both
    severityDegradedThreshold: 273,
    severityNormalThreshold: 143
};

});



parcelRegister("1MKcc", function(module, exports) {

$parcel$export(module.exports, "betterTypeHistoryPlugin", () => (parcelRequire("9J26c")).betterTypeHistoryPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $9J26c = parcelRequire("9J26c");

});
parcelRegister("9J26c", function(module, exports) {

$parcel$export(module.exports, "betterTypeHistoryPlugin", () => $3741766cd8ae5dd8$export$5587393ddd97118a);

var $8b80W = parcelRequire("8b80W");

var $9KHhg = parcelRequire("9KHhg");
/**
 * This plugin is aiming to improve undo behaviour for some of our more custom applications, very specific text
 * paste events, splitting blocks of text, new lines.
 */ const $3741766cd8ae5dd8$export$5587393ddd97118a = ()=>{
    return {
        name: 'betterTypeHistory',
        actions: {
            flagPasteEvent (tr) {
                tr.setMeta((0, $9KHhg.pluginKey), true);
                return tr;
            }
        },
        pmPlugins () {
            return [
                {
                    name: 'betterTypeHistory',
                    plugin: ()=>(0, $8b80W.default)()
                }
            ];
        }
    };
};

});
parcelRegister("8b80W", function(module, exports) {

$parcel$export(module.exports, "default", () => $a52700030bf22dfd$export$2e2bcd8739ae039);

var $i8KtF = parcelRequire("i8KtF");

var $5Z3Rm = parcelRequire("5Z3Rm");

var $kuxd1 = parcelRequire("kuxd1");

var $3xw6l = parcelRequire("3xw6l");

var $3lIcL = parcelRequire("3lIcL");

var $lzEKq = parcelRequire("lzEKq");

var $9KHhg = parcelRequire("9KHhg");
const $a52700030bf22dfd$var$getEnterKeyboardActionStep = (trs)=>{
    const firstTr = trs.length === 1 && trs[0];
    if (!firstTr || !firstTr.docChanged || !firstTr.isGeneric || !(firstTr.selection instanceof (0, $3lIcL.TextSelection))) return null;
    const { selection: selection, steps: steps } = firstTr;
    const replaceSteps = steps.filter((step)=>step instanceof (0, $lzEKq.ReplaceStep) || step instanceof (0, $lzEKq.ReplaceAroundStep));
    if (!selection.$cursor || replaceSteps.length !== 1) return null;
    return replaceSteps[0];
};
const $a52700030bf22dfd$var$isSliceSplittingBlockNode = (slice)=>{
    const hasOnlyTwoChildren = slice.size > 1 && slice.content.childCount === 2;
    if (!hasOnlyTwoChildren) return false;
    const firstNode = slice.content.child(0);
    const secondNode = slice.content.child(1);
    return firstNode && secondNode && firstNode.type === secondNode.type;
};
const $a52700030bf22dfd$var$isSliceAddingNewlineChar = (slice, schema)=>{
    const newLine = (0, $3xw6l.Fragment).from(schema.text('\n'));
    return slice.content.eq(newLine);
};
var $a52700030bf22dfd$export$2e2bcd8739ae039 = ()=>{
    return new (0, $i8KtF.SafePlugin)({
        key: (0, $9KHhg.pluginKey),
        appendTransaction: (transactions, oldState, newState)=>{
            const hasHandlePasteMeta = transactions.find((tran)=>tran.getMeta((0, $9KHhg.pluginKey)));
            if (hasHandlePasteMeta) return (0, $kuxd1.closeHistory)(newState.tr);
            const enterStep = $a52700030bf22dfd$var$getEnterKeyboardActionStep(transactions);
            if (!enterStep) return;
            const slice = (0, $5Z3Rm.extractSliceFromStep)(enterStep);
            const { schema: schema } = newState;
            if (slice && ($a52700030bf22dfd$var$isSliceSplittingBlockNode(slice) || $a52700030bf22dfd$var$isSliceAddingNewlineChar(slice, schema))) return (0, $kuxd1.closeHistory)(newState.tr);
        }
    });
};

});
parcelRegister("9KHhg", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $a682887866156705$export$18d4026d1ea86bb1);

var $3lIcL = parcelRequire("3lIcL");
const $a682887866156705$export$18d4026d1ea86bb1 = new (0, $3lIcL.PluginKey)('betterTypeHistoryPlugin');

});




parcelRegister("ad5Kp", function(module, exports) {

$parcel$export(module.exports, "blockTypePlugin", () => (parcelRequire("1sH6J")).blockTypePlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $1sH6J = parcelRequire("1sH6J");

});
parcelRegister("1sH6J", function(module, exports) {

$parcel$export(module.exports, "blockTypePlugin", () => $c6d92e3bfd5c2d84$export$896c3d927d705025);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $iBSvH = parcelRequire("iBSvH");
var $ewUmv = parcelRequire("ewUmv");
var $8FGKL = parcelRequire("8FGKL");

var $bMFKb = parcelRequire("bMFKb");

var $c9NXO = parcelRequire("c9NXO");
var $6Exgk = parcelRequire("6Exgk");

var $TgnAJ = parcelRequire("TgnAJ");

var $c1NDo = parcelRequire("c1NDo");

var $aBsWC = parcelRequire("aBsWC");

var $eGOwo = parcelRequire("eGOwo");

var $92xoS = parcelRequire("92xoS");

var $aGH6G = parcelRequire("aGH6G");

var $lnss2 = parcelRequire("lnss2");

var $5P4L6 = parcelRequire("5P4L6");

var $8wIsi = parcelRequire("8wIsi");

var $beO9L = parcelRequire("beO9L");

var $jfXjJ = parcelRequire("jfXjJ");
const $c6d92e3bfd5c2d84$var$headingPluginOptions = ({ formatMessage: formatMessage }, isAllowed, editorAnalyticsApi)=>{
    if (!isAllowed) return [];
    return Array.from({
        length: 6
    }, (_v, idx)=>{
        const level = idx + 1;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const descriptionDescriptor = (0, $TgnAJ.messages)[`heading${level}Description`];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const keyshortcut = (0, $6Exgk.tooltip)((0, $c9NXO.keymap)[`toggleHeading${level}`]);
        const id = `heading${level}`;
        return {
            id: id,
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            title: formatMessage((0, $TgnAJ.messages)[id]),
            description: formatMessage(descriptionDescriptor),
            priority: 1300,
            keywords: [
                `h${level}`
            ],
            keyshortcut: keyshortcut,
            icon: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $c1NDo.IconHeading), {
                    level: level
                }),
            action (insert, state) {
                const tr = insert(state.schema.nodes.heading.createChecked({
                    level: level
                }));
                editorAnalyticsApi?.attachAnalyticsEvent({
                    action: (0, $bMFKb.ACTION).FORMATTED,
                    actionSubject: (0, $bMFKb.ACTION_SUBJECT).TEXT,
                    eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
                    actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).FORMAT_HEADING,
                    attributes: {
                        inputMethod: (0, $bMFKb.INPUT_METHOD).QUICK_INSERT,
                        newHeadingLevel: level
                    }
                })(tr);
                return tr;
            }
        };
    });
};
const $c6d92e3bfd5c2d84$var$blockquotePluginOptions = ({ formatMessage: formatMessage }, isAllowed, editorAnalyticsApi)=>{
    if (!isAllowed) return [];
    return [
        {
            id: 'blockquote',
            title: formatMessage((0, $TgnAJ.messages).blockquote),
            description: formatMessage((0, $TgnAJ.messages).blockquoteDescription),
            priority: 1300,
            keyshortcut: '>',
            icon: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $c1NDo.IconQuote), {}),
            action (insert, state) {
                const tr = insert(state.schema.nodes.blockquote.createChecked({}, state.schema.nodes.paragraph.createChecked()));
                editorAnalyticsApi?.attachAnalyticsEvent({
                    action: (0, $bMFKb.ACTION).FORMATTED,
                    actionSubject: (0, $bMFKb.ACTION_SUBJECT).TEXT,
                    eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
                    actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).FORMAT_BLOCK_QUOTE,
                    attributes: {
                        inputMethod: (0, $bMFKb.INPUT_METHOD).QUICK_INSERT
                    }
                })(tr);
                return tr;
            }
        }
    ];
};
const $c6d92e3bfd5c2d84$export$896c3d927d705025 = ({ config: options, api: api })=>{
    const primaryToolbarComponent = ({ popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, toolbarSize: toolbarSize, disabled: disabled, isToolbarReducedSpacing: isToolbarReducedSpacing })=>{
        let isSmall = options && options.isUndoRedoButtonsEnabled ? toolbarSize < (0, $aBsWC.ToolbarSize).XXL : toolbarSize < (0, $aBsWC.ToolbarSize).XL;
        if ((0, $eGOwo.fg)('platform_editor_toolbar_responsive_fixes')) isSmall = toolbarSize < (0, $aBsWC.ToolbarSize).XXL;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jfXjJ.PrimaryToolbarComponent), {
            isSmall: isSmall,
            disabled: disabled,
            isToolbarReducedSpacing: isToolbarReducedSpacing,
            api: api,
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: popupsBoundariesElement,
            popupsScrollableElement: popupsScrollableElement,
            shouldUseDefaultRole: false
        });
    };
    api?.primaryToolbar?.actions.registerComponent({
        name: 'blockType',
        component: primaryToolbarComponent
    });
    return {
        name: 'blockType',
        nodes () {
            const nodes = [
                {
                    name: 'heading',
                    node: (0, $8FGKL.heading)
                },
                {
                    name: 'blockquote',
                    node: (0, $iBSvH.extendedBlockquote)
                },
                {
                    name: 'hardBreak',
                    node: (0, $ewUmv.hardBreak)
                }
            ];
            if (options && options.allowBlockType) {
                const exclude = options.allowBlockType.exclude ? options.allowBlockType.exclude : [];
                return nodes.filter((node)=>exclude.indexOf(node.name) === -1);
            }
            return nodes;
        },
        pmPlugins () {
            return [
                {
                    name: 'blockType',
                    plugin: ({ dispatch: dispatch })=>(0, $8wIsi.createPlugin)(api, dispatch, options && options.lastNodeMustBeParagraph, options?.includeBlockQuoteAsTextstyleOption)
                },
                {
                    name: 'blockTypeInputRule',
                    plugin: ({ schema: schema, featureFlags: featureFlags })=>(0, $lnss2.default)(api?.analytics?.actions, schema, featureFlags)
                },
                // Needs to be lower priority than editor-tables.tableEditing
                // plugin as it is currently swallowing right/down arrow events inside tables
                {
                    name: 'blockTypeKeyMap',
                    plugin: ({ schema: schema, featureFlags: featureFlags })=>(0, $5P4L6.default)(api?.analytics?.actions, schema, featureFlags)
                }
            ];
        },
        actions: {
            insertBlockQuote (inputMethod) {
                return (0, $aGH6G.insertBlockQuoteWithAnalytics)(inputMethod, api?.analytics?.actions);
            }
        },
        commands: {
            setTextLevel (level, inputMethod, fromBlockQuote = false) {
                return (0, $aGH6G.setBlockTypeWithAnalytics)(level, inputMethod, api?.analytics?.actions, fromBlockQuote);
            },
            insertBlockQuote (inputMethod) {
                return (0, $aGH6G.insertBlockQuoteWithAnalyticsCommand)(inputMethod, api?.analytics?.actions);
            },
            clearFormatting (inputMethod) {
                return (0, $aGH6G.clearFormatting)(inputMethod, api?.analytics?.actions);
            }
        },
        getSharedState (editorState) {
            if (!editorState) return;
            return (0, $8wIsi.pluginKey).getState(editorState);
        },
        primaryToolbarComponent: !api?.primaryToolbar ? primaryToolbarComponent : undefined,
        pluginsOptions: {
            selectionToolbar: ()=>{
                const toolbarDocking = (0, $eGOwo.fg)('platform_editor_use_preferences_plugin') ? api?.userPreferences?.sharedState.currentState()?.preferences?.toolbarDockingPosition : api?.selectionToolbar?.sharedState?.currentState()?.toolbarDocking;
                if (toolbarDocking === 'none' && (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1', {
                    exposure: true
                })) {
                    const toolbarCustom = {
                        type: 'custom',
                        render: (view, _idx, _dispatchAnalyticsEvent)=>{
                            if (!view) return;
                            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $beO9L.FloatingToolbarComponent), {
                                api: api
                            });
                        },
                        fallback: []
                    };
                    return {
                        isToolbarAbove: true,
                        items: [
                            toolbarCustom
                        ],
                        rank: 8
                    };
                } else return undefined;
            },
            ...(0, $92xoS.editorExperiment)('platform_editor_insertion', 'control') && {
                quickInsert: (intl)=>{
                    const exclude = options && options.allowBlockType && options.allowBlockType.exclude ? options.allowBlockType.exclude : [];
                    return [
                        ...$c6d92e3bfd5c2d84$var$blockquotePluginOptions(intl, exclude.indexOf('blockquote') === -1, api?.analytics?.actions),
                        ...$c6d92e3bfd5c2d84$var$headingPluginOptions(intl, exclude.indexOf('heading') === -1, api?.analytics?.actions)
                    ];
                }
            }
        }
    };
};

});
parcelRegister("6Exgk", function(module, exports) {

$parcel$export(module.exports, "addAltText", () => $d130671d8acbd866$export$82527b23b485fa7f);
$parcel$export(module.exports, "makeKeyMapWithCommon", () => $d130671d8acbd866$export$7e6b588cc98b34f1);
$parcel$export(module.exports, "navToEditorToolbar", () => $d130671d8acbd866$export$9288bbefb6b7498b);
$parcel$export(module.exports, "navToFloatingToolbar", () => $d130671d8acbd866$export$7be006a99a30f86b);
$parcel$export(module.exports, "askAIQuickInsert", () => $d130671d8acbd866$export$ae37214e128d9cc3);
$parcel$export(module.exports, "toggleBold", () => $d130671d8acbd866$export$183fe6d20e9e58ba);
$parcel$export(module.exports, "toggleItalic", () => $d130671d8acbd866$export$b03177f345903916);
$parcel$export(module.exports, "toggleUnderline", () => $d130671d8acbd866$export$6bcc93697958b66d);
$parcel$export(module.exports, "toggleStrikethrough", () => $d130671d8acbd866$export$6d564ba4eaf138d9);
$parcel$export(module.exports, "toggleSubscript", () => $d130671d8acbd866$export$d26ab98fee0c804);
$parcel$export(module.exports, "toggleSuperscript", () => $d130671d8acbd866$export$4af6b58e12324fd);
$parcel$export(module.exports, "toggleCode", () => $d130671d8acbd866$export$70686c6e7e15ed46);
$parcel$export(module.exports, "pastePlainText", () => $d130671d8acbd866$export$ab06dc742bb20e03);
$parcel$export(module.exports, "clearFormatting", () => $d130671d8acbd866$export$195de5d8e201efd7);
$parcel$export(module.exports, "setNormalText", () => $d130671d8acbd866$export$63c4f0859cc75dc6);
$parcel$export(module.exports, "toggleHeading1", () => $d130671d8acbd866$export$953ab0e6a5d310a9);
$parcel$export(module.exports, "toggleHeading2", () => $d130671d8acbd866$export$192a351cfd6ca247);
$parcel$export(module.exports, "toggleHeading3", () => $d130671d8acbd866$export$fe382f3f4c871c62);
$parcel$export(module.exports, "toggleHeading4", () => $d130671d8acbd866$export$4073e08db19e0e31);
$parcel$export(module.exports, "toggleHeading5", () => $d130671d8acbd866$export$b84e85b2035ddb39);
$parcel$export(module.exports, "toggleHeading6", () => $d130671d8acbd866$export$86b1ac99fd15509b);
$parcel$export(module.exports, "toggleOrderedList", () => $d130671d8acbd866$export$dca848a1b50b6a31);
$parcel$export(module.exports, "toggleBulletList", () => $d130671d8acbd866$export$c0e115f47553645e);
$parcel$export(module.exports, "toggleBlockQuote", () => $d130671d8acbd866$export$34ed0cbd4f7ff88);
$parcel$export(module.exports, "insertNewLine", () => $d130671d8acbd866$export$c2d9390f63354627);
$parcel$export(module.exports, "insertRule", () => $d130671d8acbd866$export$5f13bbad564673d4);
$parcel$export(module.exports, "undo", () => $d130671d8acbd866$export$21f930c44940fd98);
$parcel$export(module.exports, "moveUp", () => $d130671d8acbd866$export$44935f8a884b57b9);
$parcel$export(module.exports, "moveDown", () => $d130671d8acbd866$export$8eba228b343b3599);
$parcel$export(module.exports, "moveLeft", () => $d130671d8acbd866$export$108f27160c89e515);
$parcel$export(module.exports, "moveRight", () => $d130671d8acbd866$export$e2c874fbfec7201);
$parcel$export(module.exports, "indentList", () => $d130671d8acbd866$export$8066a906978eedb2);
$parcel$export(module.exports, "outdentList", () => $d130671d8acbd866$export$959569198ddbbe17);
$parcel$export(module.exports, "redoAlt", () => $d130671d8acbd866$export$c0e41ad67d77f6bb);
$parcel$export(module.exports, "redo", () => $d130671d8acbd866$export$1688e416fee0a49e);
$parcel$export(module.exports, "openHelp", () => $d130671d8acbd866$export$1e2fd7795238a2d3);
$parcel$export(module.exports, "addLink", () => $d130671d8acbd866$export$56b88caa6d8a3bff);
$parcel$export(module.exports, "addInlineComment", () => $d130671d8acbd866$export$fd78ad47ea0892f4);
$parcel$export(module.exports, "submit", () => $d130671d8acbd866$export$853c27de4ce0f746);
$parcel$export(module.exports, "enter", () => $d130671d8acbd866$export$e668df1bcd81e4d2);
$parcel$export(module.exports, "tab", () => $d130671d8acbd866$export$62d58b1c91e8e902);
$parcel$export(module.exports, "indent", () => $d130671d8acbd866$export$79ebfa808dffa5c6);
$parcel$export(module.exports, "outdent", () => $d130671d8acbd866$export$25755c0352544598);
$parcel$export(module.exports, "backspace", () => $d130671d8acbd866$export$1ea584ca7009bcc1);
$parcel$export(module.exports, "deleteKey", () => $d130671d8acbd866$export$9603e93cdf38d7);
$parcel$export(module.exports, "forwardDelete", () => $d130671d8acbd866$export$9e41eded5cb7e706);
$parcel$export(module.exports, "escape", () => $d130671d8acbd866$export$4e7f196112fea3c5);
$parcel$export(module.exports, "nextCell", () => $d130671d8acbd866$export$172699367bb25225);
$parcel$export(module.exports, "previousCell", () => $d130671d8acbd866$export$69838570e03d7193);
$parcel$export(module.exports, "shiftArrowUp", () => $d130671d8acbd866$export$776c0cd47234205a);
$parcel$export(module.exports, "shiftTab", () => $d130671d8acbd866$export$9ad63694f5781e16);
$parcel$export(module.exports, "toggleTable", () => $d130671d8acbd866$export$33b9473b3f67763f);
$parcel$export(module.exports, "focusTableResizer", () => $d130671d8acbd866$export$a57fbe0d9c764ae0);
$parcel$export(module.exports, "addRowBefore", () => $d130671d8acbd866$export$2e3087448cf87857);
$parcel$export(module.exports, "addRowAfter", () => $d130671d8acbd866$export$fbcf51cabbe4a007);
$parcel$export(module.exports, "addColumnAfter", () => $d130671d8acbd866$export$bf95f7b7d259c19f);
$parcel$export(module.exports, "addColumnBefore", () => $d130671d8acbd866$export$717d5ccb817cdecc);
$parcel$export(module.exports, "addRowBeforeVO", () => $d130671d8acbd866$export$5851c701392d3bfd);
$parcel$export(module.exports, "addRowAfterVO", () => $d130671d8acbd866$export$73fa63faf0fd6077);
$parcel$export(module.exports, "addColumnAfterVO", () => $d130671d8acbd866$export$875b853996fced8d);
$parcel$export(module.exports, "addColumnBeforeVO", () => $d130671d8acbd866$export$414418ca306c22bd);
$parcel$export(module.exports, "moveColumnLeft", () => $d130671d8acbd866$export$f092689a35ce978d);
$parcel$export(module.exports, "moveColumnRight", () => $d130671d8acbd866$export$863ee96d9e15383b);
$parcel$export(module.exports, "moveRowDown", () => $d130671d8acbd866$export$13c2dd2d968ada2a);
$parcel$export(module.exports, "moveRowUp", () => $d130671d8acbd866$export$e6749a6fc243b921);
$parcel$export(module.exports, "deleteColumn", () => $d130671d8acbd866$export$f4f2d7d33085c714);
$parcel$export(module.exports, "deleteRow", () => $d130671d8acbd866$export$2ef39e5ffdaff9ed);
$parcel$export(module.exports, "startColumnResizing", () => $d130671d8acbd866$export$8f58457f1327dd26);
$parcel$export(module.exports, "find", () => $d130671d8acbd866$export$71aa6c912b956294);
$parcel$export(module.exports, "alignLeft", () => $d130671d8acbd866$export$ca42dd9a1a0eb501);
$parcel$export(module.exports, "alignCenter", () => $d130671d8acbd866$export$f4a51ff076cc9a09);
$parcel$export(module.exports, "alignRight", () => $d130671d8acbd866$export$faf8793e4a37a5a2);
$parcel$export(module.exports, "toggleTaskItemCheckbox", () => $d130671d8acbd866$export$6f041e7a1d88fa51);
$parcel$export(module.exports, "selectRow", () => $d130671d8acbd866$export$e247ed8cec4832f4);
$parcel$export(module.exports, "selectColumn", () => $d130671d8acbd866$export$c2e8772deb1607ea);
$parcel$export(module.exports, "selectTable", () => $d130671d8acbd866$export$625c5b9bf13f01a8);
$parcel$export(module.exports, "increaseMediaSize", () => $d130671d8acbd866$export$fdeca4160ac263c5);
$parcel$export(module.exports, "decreaseMediaSize", () => $d130671d8acbd866$export$5ec5f857fec297eb);
$parcel$export(module.exports, "activateVideoControls", () => $d130671d8acbd866$export$36141559a83247ee);
$parcel$export(module.exports, "toggleHighlightPalette", () => $d130671d8acbd866$export$ec123199f2fe4770);
$parcel$export(module.exports, "focusToContextMenuTrigger", () => $d130671d8acbd866$export$6b05735f625d1c82);
$parcel$export(module.exports, "continueInRovoChat", () => $d130671d8acbd866$export$54f122e0d55178a9);
$parcel$export(module.exports, "formatShortcut", () => $d130671d8acbd866$export$384a290f8c265cc5);
$parcel$export(module.exports, "tooltip", () => $d130671d8acbd866$export$4e6f96734dfe12f4);
$parcel$export(module.exports, "ToolTipContent", () => $d130671d8acbd866$export$4096cb8ab9668358);
$parcel$export(module.exports, "findKeymapByDescription", () => $d130671d8acbd866$export$c4e6735ce96cc7b3);
$parcel$export(module.exports, "findShortcutByKeymap", () => $d130671d8acbd866$export$d69faf3b7bc3451);
$parcel$export(module.exports, "getAriaKeyshortcuts", () => $d130671d8acbd866$export$6db28e5c399297b0);
$parcel$export(module.exports, "bindKeymapWithCommand", () => $d130671d8acbd866$export$4bced0ac29aaf950);
$parcel$export(module.exports, "bindKeymapArrayWithCommand", () => $d130671d8acbd866$export$e40cfdbcfa26f180);
$parcel$export(module.exports, "bindKeymapWithEditorCommand", () => $d130671d8acbd866$export$b87d3e1cb85f0ba1);
$parcel$export(module.exports, "findKeyMapForBrowser", () => $d130671d8acbd866$export$b2dbe47650bcfa54);
$parcel$export(module.exports, "isCapsLockOnAndModifyKeyboardEvent", () => $d130671d8acbd866$export$f2da701c7659a26c);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $1rXzn = parcelRequire("1rXzn");

var $8GLF3 = parcelRequire("8GLF3");

var $7EdFW = parcelRequire("7EdFW");


var $c9NXO = parcelRequire("c9NXO");
const $d130671d8acbd866$export$82527b23b485fa7f = $d130671d8acbd866$export$7e6b588cc98b34f1('Add Alt Text', 'Mod-Alt-y');
const $d130671d8acbd866$export$9288bbefb6b7498b = $d130671d8acbd866$export$7e6b588cc98b34f1('Navigate to editor toolbar', 'Alt-F9');
const $d130671d8acbd866$export$7be006a99a30f86b = $d130671d8acbd866$export$7e6b588cc98b34f1('Navigate to floating toolbar', 'Alt-F10');
const $d130671d8acbd866$export$ae37214e128d9cc3 = $d130671d8acbd866$export$7e6b588cc98b34f1('Ask AI', "Mod-'");
const $d130671d8acbd866$export$183fe6d20e9e58ba = $d130671d8acbd866$export$7e6b588cc98b34f1('Bold', 'Mod-b');
const $d130671d8acbd866$export$b03177f345903916 = $d130671d8acbd866$export$7e6b588cc98b34f1('Italic', 'Mod-i');
const $d130671d8acbd866$export$6bcc93697958b66d = $d130671d8acbd866$export$7e6b588cc98b34f1('Underline', 'Mod-u');
const $d130671d8acbd866$export$6d564ba4eaf138d9 = $d130671d8acbd866$export$7e6b588cc98b34f1('Strikethrough', 'Mod-Shift-s');
const $d130671d8acbd866$export$d26ab98fee0c804 = $d130671d8acbd866$export$7e6b588cc98b34f1('Subscript', 'Mod-Shift-,');
const $d130671d8acbd866$export$4af6b58e12324fd = $d130671d8acbd866$export$7e6b588cc98b34f1('Superscript', 'Mod-Shift-.');
const $d130671d8acbd866$export$70686c6e7e15ed46 = $d130671d8acbd866$export$7e6b588cc98b34f1('Code', 'Mod-Shift-m');
const $d130671d8acbd866$export$ab06dc742bb20e03 = $d130671d8acbd866$export$7e6b588cc98b34f1('Paste Plain Text', 'Mod-Shift-v');
const $d130671d8acbd866$export$195de5d8e201efd7 = $d130671d8acbd866$export$7e6b588cc98b34f1('Clear formatting', 'Mod-\\');
const $d130671d8acbd866$export$63c4f0859cc75dc6 = $d130671d8acbd866$export$7e6b588cc98b34f1('Normal text', 'Mod-Alt-0');
const $d130671d8acbd866$export$953ab0e6a5d310a9 = $d130671d8acbd866$export$7e6b588cc98b34f1('Heading 1', 'Mod-Alt-1');
const $d130671d8acbd866$export$192a351cfd6ca247 = $d130671d8acbd866$export$7e6b588cc98b34f1('Heading 2', 'Mod-Alt-2');
const $d130671d8acbd866$export$fe382f3f4c871c62 = $d130671d8acbd866$export$7e6b588cc98b34f1('Heading 3', 'Mod-Alt-3');
const $d130671d8acbd866$export$4073e08db19e0e31 = $d130671d8acbd866$export$7e6b588cc98b34f1('Heading 4', 'Mod-Alt-4');
const $d130671d8acbd866$export$b84e85b2035ddb39 = $d130671d8acbd866$export$7e6b588cc98b34f1('Heading 5', 'Mod-Alt-5');
const $d130671d8acbd866$export$86b1ac99fd15509b = $d130671d8acbd866$export$7e6b588cc98b34f1('Heading 6', 'Mod-Alt-6');
const $d130671d8acbd866$export$dca848a1b50b6a31 = $d130671d8acbd866$export$7e6b588cc98b34f1('Numbered list', 'Mod-Shift-7');
const $d130671d8acbd866$export$17f69a767ce93bb3 = $d130671d8acbd866$export$7e6b588cc98b34f1('Cmd + Backspace', 'Mod-Backspace');
const $d130671d8acbd866$export$c0e115f47553645e = $d130671d8acbd866$export$7e6b588cc98b34f1('Bullet list', 'Mod-Shift-8');
const $d130671d8acbd866$export$34ed0cbd4f7ff88 = $d130671d8acbd866$export$7e6b588cc98b34f1('Quote', 'Mod-Shift-9');
const $d130671d8acbd866$export$c2d9390f63354627 = $d130671d8acbd866$export$7e6b588cc98b34f1('Insert new line', 'Shift-Enter');
const $d130671d8acbd866$export$dfd73a1c108b1570 = $d130671d8acbd866$export$7e6b588cc98b34f1('Shift Backspace', 'Shift-Backspace');
const $d130671d8acbd866$export$9e5a9569a07601f2 = $d130671d8acbd866$export$7e6b588cc98b34f1('Split code block', 'Enter');
const $d130671d8acbd866$export$e920ee2eb756d384 = $d130671d8acbd866$export$7e6b588cc98b34f1('Split list item', 'Enter');
const $d130671d8acbd866$export$5f13bbad564673d4 = $d130671d8acbd866$export$7e6b588cc98b34f1('Insert horizontal rule', 'Mod-Shift--');
const $d130671d8acbd866$export$21f930c44940fd98 = $d130671d8acbd866$export$7e6b588cc98b34f1('Undo', 'Mod-z');
const $d130671d8acbd866$export$44935f8a884b57b9 = $d130671d8acbd866$export$7e6b588cc98b34f1('Move up', 'ArrowUp');
const $d130671d8acbd866$export$8eba228b343b3599 = $d130671d8acbd866$export$7e6b588cc98b34f1('Move down', 'ArrowDown');
const $d130671d8acbd866$export$108f27160c89e515 = $d130671d8acbd866$export$7e6b588cc98b34f1('Move left', 'ArrowLeft');
const $d130671d8acbd866$export$e2c874fbfec7201 = $d130671d8acbd866$export$7e6b588cc98b34f1('Move right', 'ArrowRight');
const $d130671d8acbd866$export$8066a906978eedb2 = $d130671d8acbd866$export$7e6b588cc98b34f1('Indent List', 'Tab');
const $d130671d8acbd866$export$959569198ddbbe17 = $d130671d8acbd866$export$7e6b588cc98b34f1('Outdent List', 'Shift-Tab');
const $d130671d8acbd866$export$c0e41ad67d77f6bb = $d130671d8acbd866$export$7e6b588cc98b34f1('Redo', 'Mod-y');
const $d130671d8acbd866$export$1688e416fee0a49e = $d130671d8acbd866$export$d8a7f422d8d42038('Redo', 'Ctrl-y', 'Mod-Shift-z');
const $d130671d8acbd866$export$1e2fd7795238a2d3 = $d130671d8acbd866$export$7e6b588cc98b34f1('Open Help', 'Mod-/');
const $d130671d8acbd866$export$56b88caa6d8a3bff = $d130671d8acbd866$export$7e6b588cc98b34f1('Link', 'Mod-k');
const $d130671d8acbd866$export$fd78ad47ea0892f4 = $d130671d8acbd866$export$7e6b588cc98b34f1('Annotate', 'Mod-Alt-c');
const $d130671d8acbd866$export$853c27de4ce0f746 = $d130671d8acbd866$export$7e6b588cc98b34f1('Submit Content', 'Mod-Enter');
const $d130671d8acbd866$export$e668df1bcd81e4d2 = $d130671d8acbd866$export$7e6b588cc98b34f1('Enter', 'Enter');
const $d130671d8acbd866$export$9f99fe2ed5bb7a29 = $d130671d8acbd866$export$7e6b588cc98b34f1('Shift Enter', 'Shift-Enter');
const $d130671d8acbd866$export$62d58b1c91e8e902 = $d130671d8acbd866$export$7e6b588cc98b34f1('Tab', 'Tab');
const $d130671d8acbd866$export$79ebfa808dffa5c6 = $d130671d8acbd866$export$7e6b588cc98b34f1('Indent', 'Tab');
const $d130671d8acbd866$export$25755c0352544598 = $d130671d8acbd866$export$7e6b588cc98b34f1('Outdent', 'Shift-Tab');
const $d130671d8acbd866$export$1ea584ca7009bcc1 = $d130671d8acbd866$export$7e6b588cc98b34f1('Backspace', 'Backspace');
const $d130671d8acbd866$export$9603e93cdf38d7 = $d130671d8acbd866$export$7e6b588cc98b34f1('Delete', 'Delete');
const $d130671d8acbd866$export$9e41eded5cb7e706 = $d130671d8acbd866$export$d8a7f422d8d42038('Forward Delete', '', 'Ctrl-d');
const $d130671d8acbd866$export$a941ed4b947d12f8 = $d130671d8acbd866$export$7e6b588cc98b34f1('Space', 'Space');
const $d130671d8acbd866$export$4e7f196112fea3c5 = $d130671d8acbd866$export$7e6b588cc98b34f1('Escape', 'Escape');
const $d130671d8acbd866$export$172699367bb25225 = $d130671d8acbd866$export$7e6b588cc98b34f1('Next cell', 'Tab');
const $d130671d8acbd866$export$69838570e03d7193 = $d130671d8acbd866$export$7e6b588cc98b34f1('Previous cell', 'Shift-Tab');
const $d130671d8acbd866$export$776c0cd47234205a = $d130671d8acbd866$export$7e6b588cc98b34f1('Shift ArrowUp', 'Shift-ArrowUp');
const $d130671d8acbd866$export$9ad63694f5781e16 = $d130671d8acbd866$export$7e6b588cc98b34f1('Shift Tab', 'Shift-Tab');
const $d130671d8acbd866$export$33b9473b3f67763f = $d130671d8acbd866$export$7e6b588cc98b34f1('Table', 'Shift-Alt-t');
const $d130671d8acbd866$export$a57fbe0d9c764ae0 = $d130671d8acbd866$export$7e6b588cc98b34f1('Focus Table Resizer', 'Mod-Alt-Shift-r');
const $d130671d8acbd866$export$2e3087448cf87857 = $d130671d8acbd866$export$7e6b588cc98b34f1('Add Row Above', 'Ctrl-Alt-ArrowUp');
const $d130671d8acbd866$export$fbcf51cabbe4a007 = $d130671d8acbd866$export$7e6b588cc98b34f1('Add Row Below', 'Ctrl-Alt-ArrowDown');
const $d130671d8acbd866$export$bf95f7b7d259c19f = $d130671d8acbd866$export$7e6b588cc98b34f1('Add Column After', 'Ctrl-Alt-ArrowRight');
const $d130671d8acbd866$export$717d5ccb817cdecc = $d130671d8acbd866$export$7e6b588cc98b34f1('Add Column Before', 'Ctrl-Alt-ArrowLeft');
const $d130671d8acbd866$export$5851c701392d3bfd = $d130671d8acbd866$export$7e6b588cc98b34f1('Add Row Above', 'Mod-Alt-[');
const $d130671d8acbd866$export$73fa63faf0fd6077 = $d130671d8acbd866$export$7e6b588cc98b34f1('Add Row Below', 'Mod-Alt-]');
const $d130671d8acbd866$export$875b853996fced8d = $d130671d8acbd866$export$7e6b588cc98b34f1('Add Column After', 'Mod-Alt-=');
const $d130671d8acbd866$export$414418ca306c22bd = $d130671d8acbd866$export$7e6b588cc98b34f1('Add Column Before', 'Mod-Alt--');
const $d130671d8acbd866$export$f092689a35ce978d = $d130671d8acbd866$export$7e6b588cc98b34f1('Move Column Left', 'Ctrl-Alt-Shift-ArrowLeft');
const $d130671d8acbd866$export$863ee96d9e15383b = $d130671d8acbd866$export$7e6b588cc98b34f1('Move Column Right', 'Ctrl-Alt-Shift-ArrowRight');
const $d130671d8acbd866$export$13c2dd2d968ada2a = $d130671d8acbd866$export$7e6b588cc98b34f1('Move Row Down', 'Ctrl-Alt-Shift-ArrowDown');
const $d130671d8acbd866$export$e6749a6fc243b921 = $d130671d8acbd866$export$7e6b588cc98b34f1('Move Row Up', 'Ctrl-Alt-Shift-ArrowUp');
const $d130671d8acbd866$export$f4f2d7d33085c714 = $d130671d8acbd866$export$7e6b588cc98b34f1('Delete Column', 'Ctrl-Backspace');
const $d130671d8acbd866$export$2ef39e5ffdaff9ed = $d130671d8acbd866$export$7e6b588cc98b34f1('Delete Row', 'Ctrl-Backspace');
const $d130671d8acbd866$export$8f58457f1327dd26 = $d130671d8acbd866$export$7e6b588cc98b34f1('Activate Column Resize', 'Mod-Alt-Shift-c');
const $d130671d8acbd866$export$af2a99f971a346e6 = $d130671d8acbd866$export$7e6b588cc98b34f1('Cut', 'Mod-x');
const $d130671d8acbd866$export$784d13d8ee351f07 = $d130671d8acbd866$export$7e6b588cc98b34f1('Copy', 'Mod-c');
const $d130671d8acbd866$export$9b6706c8686cfc8e = $d130671d8acbd866$export$7e6b588cc98b34f1('Paste', 'Mod-v');
const $d130671d8acbd866$export$3c1455b21d3e7aab = $d130671d8acbd866$export$7e6b588cc98b34f1('Paste', 'Mod-Shift-v');
const $d130671d8acbd866$export$71aa6c912b956294 = $d130671d8acbd866$export$7e6b588cc98b34f1('Find', 'Mod-f');
const $d130671d8acbd866$export$ca42dd9a1a0eb501 = $d130671d8acbd866$export$7e6b588cc98b34f1('Align Left', 'Mod-Shift-l');
const $d130671d8acbd866$export$f4a51ff076cc9a09 = $d130671d8acbd866$export$7e6b588cc98b34f1('Align Center', 'Mod-Alt-e');
const $d130671d8acbd866$export$faf8793e4a37a5a2 = $d130671d8acbd866$export$7e6b588cc98b34f1('Align Right', 'Mod-Alt-t');
const $d130671d8acbd866$export$6f041e7a1d88fa51 = $d130671d8acbd866$export$7e6b588cc98b34f1('Toggles task item', 'Mod-Alt-Enter');
const $d130671d8acbd866$export$e247ed8cec4832f4 = $d130671d8acbd866$export$5882c1dfa05eb556('Select row', [
    'Mod-Alt-Shift-ArrowLeft',
    'Mod-Alt-Shift-ArrowRight'
]);
const $d130671d8acbd866$export$c2e8772deb1607ea = $d130671d8acbd866$export$5882c1dfa05eb556('Select column', [
    'Mod-Alt-Shift-ArrowDown',
    'Mod-Alt-Shift-ArrowUp'
]);
const $d130671d8acbd866$export$625c5b9bf13f01a8 = $d130671d8acbd866$export$7e6b588cc98b34f1('Select table', 'Mod-a');
const $d130671d8acbd866$export$fdeca4160ac263c5 = $d130671d8acbd866$export$7e6b588cc98b34f1('increase image size', 'Mod-Alt-]');
const $d130671d8acbd866$export$5ec5f857fec297eb = $d130671d8acbd866$export$7e6b588cc98b34f1('increase image size', 'Mod-Alt-[');
const $d130671d8acbd866$export$36141559a83247ee = $d130671d8acbd866$export$7e6b588cc98b34f1('Activate controls panel on video', 'Shift-F10');
const $d130671d8acbd866$export$ec123199f2fe4770 = $d130671d8acbd866$export$7e6b588cc98b34f1('Toggle Highlight Palette', 'Mod-Alt-b');
const $d130671d8acbd866$export$62f87f0ca411e518 = $d130671d8acbd866$export$7e6b588cc98b34f1('Apply Yellow Highlight', 'Mod-Alt-y');
const $d130671d8acbd866$export$6b05735f625d1c82 = $d130671d8acbd866$export$7e6b588cc98b34f1('Focus table context menu trigger', 'Shift-F10');
const $d130671d8acbd866$export$a1bdda43619f945f = $d130671d8acbd866$export$7e6b588cc98b34f1('Move node up in the document', 'Ctrl-Shift-ArrowUp');
const $d130671d8acbd866$export$9bf312985dc8137e = $d130671d8acbd866$export$7e6b588cc98b34f1('Move node down in the document', 'Ctrl-Shift-ArrowDown');
const $d130671d8acbd866$export$c4f661b85fc92fd1 = $d130671d8acbd866$export$7e6b588cc98b34f1('Move node to the left column in the document', 'Ctrl-Shift-Alt-ArrowLeft');
const $d130671d8acbd866$export$61c867f4a21787f6 = $d130671d8acbd866$export$7e6b588cc98b34f1('Move node to the right column in the document', 'Ctrl-Shift-Alt-ArrowRight');
const $d130671d8acbd866$export$ba34d2a4e6aa10e4 = $d130671d8acbd866$export$7e6b588cc98b34f1('Show drag handle for editor element', 'Ctrl-Shift-h');
const $d130671d8acbd866$export$54f122e0d55178a9 = $d130671d8acbd866$export$7e6b588cc98b34f1('Continue in Rovo chat', 'Alt-Enter');
const $d130671d8acbd866$var$arrowKeysMap = {
    // for reference: https://wincent.com/wiki/Unicode_representations_of_modifier_keys
    ARROWLEFT: '\u2190',
    ARROWRIGHT: '\u2192',
    ARROWUP: '\u2191',
    ARROWDOWN: '\u2193'
};
const $d130671d8acbd866$var$tooltipShortcutStyle = /*#__PURE__*/ (0, $1NIU8.css)({
    borderRadius: '2px',
    backgroundColor: "var(--ds-background-inverse-subtle, #00000029)",
    padding: `0 ${"var(--ds-space-025, 2px)"}`,
    // NOTE: This might not actually do anything: https://atlassian.slack.com/archives/CFG3PSQ9E/p1647395052443259?thread_ts=1647394572.556029&cid=CFG3PSQ9E
    label: 'tooltip-shortcut'
});
function $d130671d8acbd866$export$384a290f8c265cc5(keymap) {
    let shortcut;
    if ((0, $7EdFW.browser).mac) // for reference: https://wincent.com/wiki/Unicode_representations_of_modifier_keys
    shortcut = keymap.mac// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    .replace(/Cmd/i, '\u2318')// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    .replace(/Shift/i, '\u21E7')// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    .replace(/Ctrl/i, '\u2303')// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    .replace(/Alt/i, '\u2325')// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    .replace(/Backspace/i, '\u232B')// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    .replace(/Enter/i, '\u23CE');
    else // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    shortcut = keymap.windows.replace(/Backspace/i, '\u232B');
    const keys = shortcut.split('-');
    let lastKey = keys[keys.length - 1];
    if (lastKey.length === 1) // capitalise single letters
    lastKey = lastKey.toUpperCase();
    keys[keys.length - 1] = $d130671d8acbd866$var$arrowKeysMap[lastKey.toUpperCase()] || lastKey;
    return keys.join((0, $7EdFW.browser).mac ? '' : '+');
}
function $d130671d8acbd866$export$4e6f96734dfe12f4(keymap, description) {
    if (keymap) {
        const shortcut = $d130671d8acbd866$export$384a290f8c265cc5(keymap);
        return description ? `${description} ${shortcut}` : shortcut;
    }
    return;
}
const $d130671d8acbd866$export$4096cb8ab9668358 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo(({ description: description, shortcutOverride: shortcutOverride, keymap: keymap })=>{
    const shortcut = shortcutOverride || keymap && $d130671d8acbd866$export$384a290f8c265cc5(keymap);
    return shortcut || description ? /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Fragment), null, description, shortcut && description && '\u00A0', shortcut && /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        css: $d130671d8acbd866$var$tooltipShortcutStyle
    }, shortcut)) : null;
});
const $d130671d8acbd866$export$9f7e5fe6d45c5f7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo(({ helpDescriptors: helpDescriptors })=>{
    const keymapCount = helpDescriptors.length;
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Fragment), null, helpDescriptors.map((descriptor, index)=>// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Fragment), {
            key: index
        }, /*#__PURE__*/ (0, $1NIU8.jsx)($d130671d8acbd866$export$4096cb8ab9668358, descriptor), ' ', index < keymapCount - 1 && /*#__PURE__*/ (0, $1NIU8.jsx)("br", null))));
});
function $d130671d8acbd866$export$c4e6735ce96cc7b3(description) {
    const matches = $d130671d8acbd866$var$ALL.filter((keymap)=>keymap.description.toUpperCase() === description.toUpperCase());
    return matches[0];
}
function $d130671d8acbd866$export$ca66063a345ce3ab(description) {
    const keymap = $d130671d8acbd866$export$c4e6735ce96cc7b3(description);
    if (keymap) return $d130671d8acbd866$export$d69faf3b7bc3451(keymap);
    return;
}
function $d130671d8acbd866$export$d69faf3b7bc3451(keymap) {
    if ((0, $7EdFW.browser).mac) return keymap.mac;
    return keymap.windows;
}
function $d130671d8acbd866$export$6db28e5c399297b0(keymap) {
    let keyShortcuts;
    if (typeof keymap === 'string') keyShortcuts = keymap;
    else if (typeof keymap === 'object') keyShortcuts = keymap[(0, $7EdFW.browser).mac ? 'mac' : 'windows'];
    if (keyShortcuts) return keyShortcuts.toLowerCase().split('-').map((modifier)=>{
        switch(modifier){
            case 'cmd':
                return 'Meta';
            case 'ctrl':
                return 'Control';
            case 'alt':
                return 'Alt';
            case 'shift':
                return 'Shift';
            case 'enter':
                return 'Enter';
            case 'esc':
                return 'Esc';
            case 'tab':
                return 'Tab';
            case 'space':
                return 'Space';
            case 'backspace':
                return 'Backspace';
            case 'arrowup':
                return 'Arrow Up';
            case 'arrowdown':
                return 'Arrow Down';
            default:
                return modifier.split('').join(' ');
        }
    }).join('+');
    else return undefined;
}
const $d130671d8acbd866$var$ALL = [
    $d130671d8acbd866$export$dca848a1b50b6a31,
    $d130671d8acbd866$export$c0e115f47553645e,
    $d130671d8acbd866$export$183fe6d20e9e58ba,
    $d130671d8acbd866$export$b03177f345903916,
    $d130671d8acbd866$export$6bcc93697958b66d,
    $d130671d8acbd866$export$6d564ba4eaf138d9,
    $d130671d8acbd866$export$d26ab98fee0c804,
    $d130671d8acbd866$export$4af6b58e12324fd,
    $d130671d8acbd866$export$70686c6e7e15ed46,
    $d130671d8acbd866$export$63c4f0859cc75dc6,
    $d130671d8acbd866$export$953ab0e6a5d310a9,
    $d130671d8acbd866$export$192a351cfd6ca247,
    $d130671d8acbd866$export$fe382f3f4c871c62,
    $d130671d8acbd866$export$4073e08db19e0e31,
    $d130671d8acbd866$export$b84e85b2035ddb39,
    $d130671d8acbd866$export$86b1ac99fd15509b,
    $d130671d8acbd866$export$34ed0cbd4f7ff88,
    $d130671d8acbd866$export$c2d9390f63354627,
    $d130671d8acbd866$export$5f13bbad564673d4,
    $d130671d8acbd866$export$9e5a9569a07601f2,
    $d130671d8acbd866$export$e920ee2eb756d384,
    $d130671d8acbd866$export$1688e416fee0a49e,
    $d130671d8acbd866$export$21f930c44940fd98,
    $d130671d8acbd866$export$71aa6c912b956294,
    $d130671d8acbd866$export$4e7f196112fea3c5,
    $d130671d8acbd866$export$e668df1bcd81e4d2,
    $d130671d8acbd866$export$9f99fe2ed5bb7a29
];
function $d130671d8acbd866$export$d8a7f422d8d42038(description, windows, mac, common) {
    return {
        description: description,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        windows: windows.replace(/Mod/i, 'Ctrl'),
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        mac: mac.replace(/Mod/i, 'Cmd'),
        common: common
    };
}
function $d130671d8acbd866$export$7e6b588cc98b34f1(description, common) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const windows = common.replace(/Mod/i, 'Ctrl');
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const mac = common.replace(/Mod/i, 'Cmd');
    return $d130671d8acbd866$export$d8a7f422d8d42038(description, windows, mac, common);
}
function $d130671d8acbd866$export$5882c1dfa05eb556(description, shortcuts) {
    const keymapArray = [];
    shortcuts.forEach((shortcut)=>{
        keymapArray.push($d130671d8acbd866$export$7e6b588cc98b34f1(description, shortcut));
    });
    return keymapArray;
}
function $d130671d8acbd866$var$combineWithOldCommand(cmd, oldCmd) {
    return (state, dispatch, editorView)=>{
        return oldCmd(state, dispatch) || cmd(state, dispatch, editorView);
    };
}
function $d130671d8acbd866$export$4bced0ac29aaf950(shortcut, cmd, keymap) {
    const oldCmd = keymap[shortcut];
    keymap[shortcut] = oldCmd ? $d130671d8acbd866$var$combineWithOldCommand(cmd, oldCmd) : cmd;
}
function $d130671d8acbd866$export$e40cfdbcfa26f180(shortcutsArray, cmd, keymap) {
    shortcutsArray.forEach((shortcut)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return $d130671d8acbd866$export$4bced0ac29aaf950(shortcut.common, cmd, keymap);
    });
}
function $d130671d8acbd866$export$b87d3e1cb85f0ba1(shortcut, cmd, keymap) {
    $d130671d8acbd866$export$4bced0ac29aaf950(shortcut, (0, $8GLF3.editorCommandToPMCommand)(cmd), keymap);
}
function $d130671d8acbd866$export$b2dbe47650bcfa54(keyMap) {
    if (keyMap) {
        if ((0, $7EdFW.browser).mac) return keyMap.mac;
        return keyMap.windows;
    }
    return;
}
function $d130671d8acbd866$export$f2da701c7659a26c(event) {
    let keyboardEvent = event;
    const name = (0, $1rXzn.keyName)(event);
    if (event.ctrlKey && event.getModifierState('CapsLock') && !event.getModifierState('Shift') && name.length === 1 && // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    /^[A-Z]/.test(name)) keyboardEvent = new KeyboardEvent('keydown', {
        key: (0, $1rXzn.base)[event.keyCode].toLowerCase(),
        code: event.code,
        ctrlKey: true
    });
    return keyboardEvent;
}

});

parcelRegister("c1NDo", function(module, exports) {

$parcel$export(module.exports, "IconAction", () => $99da9a417e294ba4$export$e40fe94b4cff8ec5);
$parcel$export(module.exports, "IconCode", () => $99da9a417e294ba4$export$e332a83b9159d69d);
$parcel$export(module.exports, "IconDate", () => $99da9a417e294ba4$export$39617668a6028b06);
$parcel$export(module.exports, "IconDecision", () => $99da9a417e294ba4$export$6eb71591d1461541);
$parcel$export(module.exports, "IconDivider", () => $99da9a417e294ba4$export$f2ab17920c9d243);
$parcel$export(module.exports, "IconEmoji", () => $99da9a417e294ba4$export$8bd591d4b34dcafa);
$parcel$export(module.exports, "IconImages", () => $99da9a417e294ba4$export$c17cf1164355efc2);
$parcel$export(module.exports, "IconLayout", () => $99da9a417e294ba4$export$fba0c846789a9d87);
$parcel$export(module.exports, "IconLink", () => $99da9a417e294ba4$export$23da1e9f164f7ea1);
$parcel$export(module.exports, "IconListNumber", () => $99da9a417e294ba4$export$32f6affcc5f19c17);
$parcel$export(module.exports, "IconList", () => $99da9a417e294ba4$export$527d32aa1785fdd4);
$parcel$export(module.exports, "IconMention", () => $99da9a417e294ba4$export$de1d1a07ff53cf53);
$parcel$export(module.exports, "IconPanelError", () => $99da9a417e294ba4$export$a1c6b14f5f0a0c20);
$parcel$export(module.exports, "IconPanelNote", () => $99da9a417e294ba4$export$4d90d09f9e3039e);
$parcel$export(module.exports, "IconPanelSuccess", () => $99da9a417e294ba4$export$cc5c1cc765c068a0);
$parcel$export(module.exports, "IconPanelWarning", () => $99da9a417e294ba4$export$e728578e48814100);
$parcel$export(module.exports, "IconPanel", () => $99da9a417e294ba4$export$18978208c8652af3);
$parcel$export(module.exports, "IconQuote", () => $99da9a417e294ba4$export$2478ed0e296e2752);
$parcel$export(module.exports, "IconStatus", () => $99da9a417e294ba4$export$4635bc8225f90ec6);
$parcel$export(module.exports, "IconOneColumnLayout", () => $99da9a417e294ba4$export$8f1e9e900568bfce);
$parcel$export(module.exports, "IconTwoColumnLayout", () => $99da9a417e294ba4$export$732a7fc4975ab5a4);
$parcel$export(module.exports, "IconThreeColumnLayout", () => $99da9a417e294ba4$export$fdfaf73f45072edb);
$parcel$export(module.exports, "IconFourColumnLayout", () => $99da9a417e294ba4$export$a1588f873a973762);
$parcel$export(module.exports, "IconFiveColumnLayout", () => $99da9a417e294ba4$export$ff1f32987b4c27d9);
$parcel$export(module.exports, "IconHeading", () => $99da9a417e294ba4$export$1a33a10ac24d7971);
$parcel$export(module.exports, "IconFeedback", () => $99da9a417e294ba4$export$e25449dcffb445e);
$parcel$export(module.exports, "IconExpand", () => $99da9a417e294ba4$export$209d03a445a7dc8e);
$parcel$export(module.exports, "IconDatasourceJiraIssue", () => $99da9a417e294ba4$export$c9b1dcefa7c9a7aa);
$parcel$export(module.exports, "IconDatasourceAssetsObjects", () => $99da9a417e294ba4$export$7d6f860161da0fa6);
$parcel$export(module.exports, "IconDatasourceConfluenceSearch", () => $99da9a417e294ba4$export$29a810fd0b8c3f03);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $joSn0 = parcelRequire("joSn0");

const $99da9a417e294ba4$export$e40fe94b4cff8ec5 = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("bo1Hs")).then((module)=>module.default),
    loading: ()=>null
});

const $99da9a417e294ba4$export$e332a83b9159d69d = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("jkdm5")).then((module)=>module.default),
    loading: ()=>null
});

const $99da9a417e294ba4$export$39617668a6028b06 = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("gHCIh")).then((module)=>module.default),
    loading: ()=>null
});

const $99da9a417e294ba4$export$6eb71591d1461541 = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("61nNH")).then((module)=>module.default),
    loading: ()=>null
});

const $99da9a417e294ba4$export$f2ab17920c9d243 = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("3bW0E")).then((module)=>module.default),
    loading: ()=>null
});

const $99da9a417e294ba4$export$8bd591d4b34dcafa = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("NN5zH")).then((module)=>module.default),
    loading: ()=>null
});

const $99da9a417e294ba4$export$c17cf1164355efc2 = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("koz2D")).then((module)=>module.default),
    loading: ()=>null
});

const $99da9a417e294ba4$export$fba0c846789a9d87 = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("bzytr")).then((module)=>module.default),
    loading: ()=>null
});

const $99da9a417e294ba4$export$23da1e9f164f7ea1 = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("cfaMl")).then((module)=>module.default),
    loading: ()=>null
});

const $99da9a417e294ba4$export$32f6affcc5f19c17 = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("2rcSl")).then((module)=>module.default),
    loading: ()=>null
});

const $99da9a417e294ba4$export$527d32aa1785fdd4 = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("8B9Nm")).then((module)=>module.default),
    loading: ()=>null
});

const $99da9a417e294ba4$export$de1d1a07ff53cf53 = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("5zjMq")).then((module)=>module.default),
    loading: ()=>null
});

const $99da9a417e294ba4$export$a1c6b14f5f0a0c20 = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("5jIUp")).then((module)=>module.default),
    loading: ()=>null
});

const $99da9a417e294ba4$export$4d90d09f9e3039e = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("e5Er3")).then((module)=>module.default),
    loading: ()=>null
});

const $99da9a417e294ba4$export$cc5c1cc765c068a0 = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("4xw38")).then((module)=>module.default),
    loading: ()=>null
});

const $99da9a417e294ba4$export$e728578e48814100 = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("6SIV9")).then((module)=>module.default),
    loading: ()=>null
});

const $99da9a417e294ba4$export$18978208c8652af3 = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("h1rms")).then((module)=>module.default),
    loading: ()=>null
});

const $99da9a417e294ba4$export$2478ed0e296e2752 = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("kOlHa")).then((module)=>module.default),
    loading: ()=>null
});

const $99da9a417e294ba4$export$4635bc8225f90ec6 = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("1auFU")).then((module)=>module.default),
    loading: ()=>null
});

const $99da9a417e294ba4$export$8f1e9e900568bfce = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("5ne5c")).then((module)=>module.default),
    loading: ()=>null
});

const $99da9a417e294ba4$export$732a7fc4975ab5a4 = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("611Pj")).then((module)=>module.default),
    loading: ()=>null
});

const $99da9a417e294ba4$export$fdfaf73f45072edb = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("dcSzo")).then((module)=>module.default),
    loading: ()=>null
});

const $99da9a417e294ba4$export$a1588f873a973762 = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("3vLbg")).then((module)=>module.default),
    loading: ()=>null
});

const $99da9a417e294ba4$export$ff1f32987b4c27d9 = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("kdeZx")).then((module)=>module.default),
    loading: ()=>null
});






function $99da9a417e294ba4$var$importHeading(level) {
    switch(level){
        case 1:
            return (parcelRequire("hsyZB"));
        case 2:
            return (parcelRequire("6ld1d"));
        case 3:
            return (parcelRequire("501o7"));
        case 4:
            return (parcelRequire("jyisK"));
        case 5:
            return (parcelRequire("4a5A0"));
        case 6:
        default:
            return (parcelRequire("cExMc"));
    }
}
const $99da9a417e294ba4$export$1a33a10ac24d7971 = ({ level: level, ...props })=>{
    const Icon = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
        loader: ()=>$99da9a417e294ba4$var$importHeading(level).then((module)=>module.default),
        loading: ()=>null
    });
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $gt9Am.jsx)(Icon, {
        ...props
    });
};

const $99da9a417e294ba4$export$e25449dcffb445e = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("kTrGG")).then((module)=>module.default),
    loading: ()=>null
});

const $99da9a417e294ba4$export$209d03a445a7dc8e = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("3Uqfm")).then((module)=>module.default),
    loading: ()=>null
});

const $99da9a417e294ba4$export$c9b1dcefa7c9a7aa = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("l2M8j")).then((module)=>module.default),
    loading: ()=>null
});

const $99da9a417e294ba4$export$7d6f860161da0fa6 = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("9JC0d")).then((module)=>module.default),
    loading: ()=>null
});

const $99da9a417e294ba4$export$29a810fd0b8c3f03 = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("aQV2R")).then((module)=>module.default),
    loading: ()=>null
});

const $99da9a417e294ba4$export$ccbb24eed51aea20 = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("jygIJ")).then((module)=>module.default),
    loading: ()=>null
});

});
parcelRegister("bo1Hs", function(module, exports) {

let $84a3412c3873395c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $84a3412c3873395c$var$load("eCyD4").then(()=>parcelRequire('5BR1H'));

});

parcelRegister("jkdm5", function(module, exports) {

let $e11a3ea33e8470af$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $e11a3ea33e8470af$var$load("a2fIC").then(()=>parcelRequire('dnYd0'));

});

parcelRegister("gHCIh", function(module, exports) {

let $c28eb11f47761f2a$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $c28eb11f47761f2a$var$load("ggzT2").then(()=>parcelRequire('8cnF0'));

});

parcelRegister("61nNH", function(module, exports) {

let $46254c5ca650ba64$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $46254c5ca650ba64$var$load("7tSfp").then(()=>parcelRequire('chn85'));

});

parcelRegister("3bW0E", function(module, exports) {

let $252f65ab98a16399$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $252f65ab98a16399$var$load("2zQPP").then(()=>parcelRequire('2xmbt'));

});

parcelRegister("NN5zH", function(module, exports) {

let $095aa7c11dbbf4bc$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $095aa7c11dbbf4bc$var$load("2MgjY").then(()=>parcelRequire('fOddn'));

});

parcelRegister("koz2D", function(module, exports) {

let $ed913b134841b632$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $ed913b134841b632$var$load("5vF82").then(()=>parcelRequire('bKZy2'));

});

parcelRegister("bzytr", function(module, exports) {

let $86cdb4664b36c0c1$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $86cdb4664b36c0c1$var$load("3lKbh").then(()=>parcelRequire('5OwXS'));

});

parcelRegister("cfaMl", function(module, exports) {

let $8e9f3f29eaeaa4fc$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $8e9f3f29eaeaa4fc$var$load("1U88s").then(()=>parcelRequire('hKgJo'));

});

parcelRegister("2rcSl", function(module, exports) {

let $1c68172f0cf55d72$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $1c68172f0cf55d72$var$load("8S0iX").then(()=>parcelRequire('3RQQj'));

});

parcelRegister("8B9Nm", function(module, exports) {

let $64296084614a4389$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $64296084614a4389$var$load("gcHxg").then(()=>parcelRequire('h2zFV'));

});

parcelRegister("5zjMq", function(module, exports) {

let $40df90840acce20d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $40df90840acce20d$var$load("1GvQW").then(()=>parcelRequire('e6YbY'));

});

parcelRegister("5jIUp", function(module, exports) {

let $3df1900e44f277d2$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $3df1900e44f277d2$var$load("30F0C").then(()=>parcelRequire('iOKaS'));

});

parcelRegister("e5Er3", function(module, exports) {

let $a420e5ec07fa556c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $a420e5ec07fa556c$var$load("kuuFH").then(()=>parcelRequire('gwan4'));

});

parcelRegister("4xw38", function(module, exports) {

let $34e31adaadf1849c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $34e31adaadf1849c$var$load("3yxk6").then(()=>parcelRequire('02KwK'));

});

parcelRegister("6SIV9", function(module, exports) {

let $502aa18d20be34f1$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $502aa18d20be34f1$var$load("05fo1").then(()=>parcelRequire('194qU'));

});

parcelRegister("h1rms", function(module, exports) {

let $c647c108f6b69cfa$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $c647c108f6b69cfa$var$load("fjuAD").then(()=>parcelRequire('hKJ3E'));

});

parcelRegister("kOlHa", function(module, exports) {

let $f2694e61a863dac3$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $f2694e61a863dac3$var$load("coqKm").then(()=>parcelRequire('64g7t'));

});

parcelRegister("1auFU", function(module, exports) {

let $0d9e8503c1a41684$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $0d9e8503c1a41684$var$load("6l2Go").then(()=>parcelRequire('dEEk1'));

});

parcelRegister("5ne5c", function(module, exports) {

let $3e9a06502a726d26$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $3e9a06502a726d26$var$load("26UTw").then(()=>parcelRequire('13yNJ'));

});

parcelRegister("611Pj", function(module, exports) {

let $461440ceb65b5c37$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $461440ceb65b5c37$var$load("4TeWn").then(()=>parcelRequire('hHIWD'));

});

parcelRegister("dcSzo", function(module, exports) {

let $99d6b9cc9b77d8f7$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $99d6b9cc9b77d8f7$var$load("iwHwB").then(()=>parcelRequire('1fv9y'));

});

parcelRegister("3vLbg", function(module, exports) {

let $28e8dd76ae63b6e6$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $28e8dd76ae63b6e6$var$load("gudhZ").then(()=>parcelRequire('5nSWq'));

});

parcelRegister("kdeZx", function(module, exports) {

let $eb70a6946a3f9e25$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $eb70a6946a3f9e25$var$load("kMFx9").then(()=>parcelRequire('fXnqO'));

});

parcelRegister("hsyZB", function(module, exports) {

let $cb6031fe4cc08e62$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $cb6031fe4cc08e62$var$load("d7APn").then(()=>parcelRequire('1RvFs'));

});

parcelRegister("6ld1d", function(module, exports) {

let $49decd7614d1f883$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $49decd7614d1f883$var$load("5Qr6L").then(()=>parcelRequire('3dKZY'));

});

parcelRegister("501o7", function(module, exports) {

let $3a3e0771b060bc23$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $3a3e0771b060bc23$var$load("gQkiB").then(()=>parcelRequire('k60EQ'));

});

parcelRegister("jyisK", function(module, exports) {

let $e3bf839b80c600df$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $e3bf839b80c600df$var$load("uIkuA").then(()=>parcelRequire('acVWB'));

});

parcelRegister("4a5A0", function(module, exports) {

let $307c6ca213d13c52$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $307c6ca213d13c52$var$load("6gOq1").then(()=>parcelRequire('jXADX'));

});

parcelRegister("cExMc", function(module, exports) {

let $93636bbfbeeee0cb$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $93636bbfbeeee0cb$var$load("9Hipf").then(()=>parcelRequire('it43C'));

});

parcelRegister("kTrGG", function(module, exports) {

let $03ece0b5299020b9$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $03ece0b5299020b9$var$load("kyuDP").then(()=>parcelRequire('epf88'));

});

parcelRegister("3Uqfm", function(module, exports) {

let $2d8af6240eceff3b$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $2d8af6240eceff3b$var$load("aJkk9").then(()=>parcelRequire('2RZ4K'));

});

parcelRegister("l2M8j", function(module, exports) {

let $f51f1f1f630bd1e8$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $f51f1f1f630bd1e8$var$load("eCZgn").then(()=>parcelRequire('dUI4N'));

});

parcelRegister("9JC0d", function(module, exports) {

let $7165cb8925a4201f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $7165cb8925a4201f$var$load("8TBzz").then(()=>parcelRequire('jAOOx'));

});

parcelRegister("aQV2R", function(module, exports) {

let $7e6b02ac8256ce8b$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $7e6b02ac8256ce8b$var$load("gwtQ2").then(()=>parcelRequire('9nYy9'));

});

parcelRegister("jygIJ", function(module, exports) {

let $e3be299cdd8cd4f9$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $e3be299cdd8cd4f9$var$load("Bh1ku").then(()=>parcelRequire('hS26u'));

});


parcelRegister("aGH6G", function(module, exports) {

$parcel$export(module.exports, "setBlockTypeWithAnalytics", () => $be8553735b2be0a0$export$3f9af78ebb95cc20);
$parcel$export(module.exports, "setNormalTextWithAnalytics", () => $be8553735b2be0a0$export$283e32d0388e302a);
$parcel$export(module.exports, "setHeadingWithAnalytics", () => $be8553735b2be0a0$export$52d74b15bd103d7f);
$parcel$export(module.exports, "clearFormatting", () => $be8553735b2be0a0$export$195de5d8e201efd7);
$parcel$export(module.exports, "insertBlockQuoteWithAnalytics", () => $be8553735b2be0a0$export$50b4331f407b3ab6);
$parcel$export(module.exports, "insertBlockQuoteWithAnalyticsCommand", () => $be8553735b2be0a0$export$f5e16b3b6b62d83);
$parcel$export(module.exports, "cleanUpAtTheStartOfDocument", () => $be8553735b2be0a0$export$9c6026f8ac831f44);

var $bMFKb = parcelRequire("bMFKb");

var $asjM0 = parcelRequire("asjM0");

var $5Z3Rm = parcelRequire("5Z3Rm");
var $gmvZ4 = parcelRequire("gmvZ4");

var $3xw6l = parcelRequire("3xw6l");

var $cwzAY = parcelRequire("cwzAY");

var $h16z0 = parcelRequire("h16z0");

var $78v0m = parcelRequire("78v0m");

var $l8Eo2 = parcelRequire("l8Eo2");
function $be8553735b2be0a0$export$36987f561c736aad(name) {
    return ({ tr: tr })=>{
        const { nodes: nodes } = tr.doc.type.schema;
        if (name === (0, $h16z0.NORMAL_TEXT).name && nodes.paragraph) return $be8553735b2be0a0$export$63c4f0859cc75dc6()({
            tr: tr
        });
        const headingBlockType = (0, $h16z0.HEADINGS_BY_NAME)[name];
        if (headingBlockType && nodes.heading && headingBlockType.level) return $be8553735b2be0a0$export$c6a04dca1ed03a3c(headingBlockType.level)({
            tr: tr
        });
        return null;
    };
}
function $be8553735b2be0a0$export$c6a04dca1ed03a3c(level, fromBlockQuote) {
    return function({ tr: tr }) {
        const { selection: selection, doc: { type: { schema: schema } } } = tr;
        const ranges = selection instanceof (0, $cwzAY.CellSelection) ? selection.ranges : [
            selection
        ];
        ranges.forEach(({ $from: $from, $to: $to })=>{
            if (fromBlockQuote) {
                const range = $from.blockRange($to);
                if (!range) return;
                const content = $from.node().content;
                const headingNode = schema.nodes.heading.createChecked({
                    level: level
                }, content);
                const slice = new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).from(headingNode), 0, 0);
                tr.replaceRange(range.start, range.end, slice);
            } else tr.setBlockType($from.pos, $to.pos, schema.nodes.heading, {
                level: level
            });
        });
        return tr;
    };
}
function $be8553735b2be0a0$export$3f9af78ebb95cc20(name, inputMethod, editorAnalyticsApi, fromBlockQuote) {
    return ({ tr: tr })=>{
        const { nodes: nodes } = tr.doc.type.schema;
        if (name === 'normal' && nodes.paragraph) return $be8553735b2be0a0$export$283e32d0388e302a(inputMethod, editorAnalyticsApi, fromBlockQuote)({
            tr: tr
        });
        const headingBlockType = (0, $h16z0.HEADINGS_BY_NAME)[name];
        if (headingBlockType && nodes.heading && headingBlockType.level) return $be8553735b2be0a0$export$52d74b15bd103d7f(headingBlockType.level, inputMethod, editorAnalyticsApi, fromBlockQuote)({
            tr: tr
        });
        return null;
    };
}
function $be8553735b2be0a0$export$63c4f0859cc75dc6(fromBlockQuote) {
    return function({ tr: tr }) {
        const { selection: selection, doc: { type: { schema: schema } } } = tr;
        const ranges = selection instanceof (0, $cwzAY.CellSelection) ? selection.ranges : [
            selection
        ];
        ranges.forEach(({ $from: $from, $to: $to })=>{
            if (fromBlockQuote) {
                const range = $from.blockRange($to);
                if (!range) return;
                tr.lift(range, 0);
            } else tr.setBlockType($from.pos, $to.pos, schema.nodes.paragraph);
        });
        return tr;
    };
}
function $be8553735b2be0a0$export$195de5d8e201efd7(inputMethod, editorAnalyticsApi) {
    return function({ tr: tr }) {
        const formattingCleared = [];
        const schema = tr.doc.type.schema;
        (0, $78v0m.FORMATTING_MARK_TYPES).forEach((mark)=>{
            const { from: from, to: to } = tr.selection;
            const markType = schema.marks[mark];
            if (!markType) return;
            if (tr.selection instanceof (0, $cwzAY.CellSelection)) (0, $78v0m.cellSelectionNodesBetween)(tr.selection, tr.doc, (node, pos)=>{
                const isTableCell = node.type === schema.nodes.tableCell || node.type === schema.nodes.tableHeader;
                if (!isTableCell) return true;
                if (tr.doc.rangeHasMark(pos, pos + node.nodeSize, markType)) {
                    formattingCleared.push((0, $78v0m.formatTypes)[mark]);
                    tr.removeMark(pos, pos + node.nodeSize, markType);
                }
                return false;
            });
            else if (tr.doc.rangeHasMark(from, to, markType)) {
                formattingCleared.push((0, $78v0m.formatTypes)[mark]);
                tr.removeMark(from, to, markType);
            }
        });
        (0, $78v0m.FORMATTING_NODE_TYPES).forEach((nodeName)=>{
            const formattedNodeType = schema.nodes[nodeName];
            const { $from: $from, $to: $to } = tr.selection;
            if (tr.selection instanceof (0, $cwzAY.CellSelection)) (0, $78v0m.cellSelectionNodesBetween)(tr.selection, tr.doc, (0, $78v0m.clearNodeFormattingOnSelection)(schema, tr, formattedNodeType, nodeName, formattingCleared));
            else tr.doc.nodesBetween($from.pos, $to.pos, (0, $78v0m.clearNodeFormattingOnSelection)(schema, tr, formattedNodeType, nodeName, formattingCleared));
        });
        tr.setStoredMarks([]);
        if (formattingCleared.length) editorAnalyticsApi?.attachAnalyticsEvent({
            action: (0, $bMFKb.ACTION).FORMATTED,
            eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).TEXT,
            actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).FORMAT_CLEAR,
            attributes: {
                inputMethod: inputMethod,
                formattingCleared: formattingCleared,
                dropdownMenu: 'textStyle'
            }
        })(tr);
        return tr;
    };
}
function $be8553735b2be0a0$var$withCurrentHeadingLevel(fn) {
    return ({ tr: tr })=>{
        // Find all headings and paragraphs of text
        const { heading: heading, paragraph: paragraph } = tr.doc.type.schema.nodes;
        const nodes = (0, $5Z3Rm.filterChildrenBetween)(tr.doc, tr.selection.from, tr.selection.to, (node)=>{
            return node.type === heading || node.type === paragraph;
        });
        // Check each paragraph and/or heading and check for consistent level
        let level;
        for (const node of nodes){
            const nodeLevel = node.node.type === heading ? node.node.attrs.level : 0;
            if (!level) level = nodeLevel;
            else if (nodeLevel !== level) {
                // Conflict in level, therefore inconsistent and undefined
                level = undefined;
                break;
            }
        }
        return fn(level)({
            tr: tr
        });
    };
}
function $be8553735b2be0a0$export$283e32d0388e302a(inputMethod, editorAnalyticsApi, fromBlockQuote) {
    return $be8553735b2be0a0$var$withCurrentHeadingLevel((previousHeadingLevel)=>({ tr: tr })=>{
            editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $bMFKb.ACTION).FORMATTED,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).TEXT,
                eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
                actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).FORMAT_HEADING,
                attributes: {
                    inputMethod: inputMethod,
                    newHeadingLevel: 0,
                    previousHeadingLevel: previousHeadingLevel
                }
            })(tr);
            return $be8553735b2be0a0$export$63c4f0859cc75dc6(fromBlockQuote)({
                tr: tr
            });
        });
}
const $be8553735b2be0a0$export$52d74b15bd103d7f = (newHeadingLevel, inputMethod, editorAnalyticsApi, fromBlockQuote)=>{
    return $be8553735b2be0a0$var$withCurrentHeadingLevel((previousHeadingLevel)=>({ tr: tr })=>{
            editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $bMFKb.ACTION).FORMATTED,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).TEXT,
                eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
                actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).FORMAT_HEADING,
                attributes: {
                    inputMethod: inputMethod,
                    newHeadingLevel: newHeadingLevel,
                    previousHeadingLevel: previousHeadingLevel
                }
            })(tr);
            return $be8553735b2be0a0$export$c6a04dca1ed03a3c(newHeadingLevel, fromBlockQuote)({
                tr: tr
            });
        });
};
function $be8553735b2be0a0$var$insertBlockQuote() {
    return function(state, dispatch) {
        const { nodes: nodes } = state.schema;
        if (nodes.paragraph && nodes.blockquote) return (0, $gmvZ4.wrapSelectionIn)(nodes.blockquote)(state, dispatch);
        return false;
    };
}
const $be8553735b2be0a0$export$50b4331f407b3ab6 = (inputMethod, editorAnalyticsApi)=>{
    return (0, $asjM0.withAnalytics)(editorAnalyticsApi, {
        action: (0, $bMFKb.ACTION).FORMATTED,
        actionSubject: (0, $bMFKb.ACTION_SUBJECT).TEXT,
        eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
        actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).FORMAT_BLOCK_QUOTE,
        attributes: {
            inputMethod: inputMethod
        }
    })($be8553735b2be0a0$var$insertBlockQuote());
};
function $be8553735b2be0a0$export$f5e16b3b6b62d83(inputMethod, editorAnalyticsApi) {
    return $be8553735b2be0a0$var$withCurrentHeadingLevel((previousHeadingLevel)=>({ tr: tr })=>{
            const { nodes: nodes } = tr.doc.type.schema;
            editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $bMFKb.ACTION).FORMATTED,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).TEXT,
                eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
                actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).FORMAT_BLOCK_QUOTE,
                attributes: {
                    inputMethod: inputMethod
                }
            })(tr);
            return (0, $l8Eo2.wrapSelectionInBlockType)(nodes.blockquote)({
                tr: tr
            });
        });
}
const $be8553735b2be0a0$export$9c6026f8ac831f44 = (state, dispatch)=>{
    const { $cursor: $cursor } = state.selection;
    if ($cursor && !$cursor.nodeBefore && !$cursor.nodeAfter && $cursor.pos === 1) {
        const { tr: tr, schema: schema } = state;
        const { paragraph: paragraph } = schema.nodes;
        const { parent: parent } = $cursor;
        /**
		 * Use cases:
		 * 1. Change `heading` to `paragraph`
		 * 2. Remove block marks
		 *
		 * NOTE: We already know it's an empty doc so it's safe to use 0
		 */ tr.setNodeMarkup(0, paragraph, parent.attrs, []);
        if (dispatch) dispatch(tr);
        return true;
    }
    return false;
};

});
parcelRegister("gmvZ4", function(module, exports) {

$parcel$export(module.exports, "wrapSelectionIn", () => $90b1f29b359fa517$export$f63f505240212912);

var $dqHDB = parcelRequire("dqHDB");
function $90b1f29b359fa517$export$f63f505240212912(type) {
    return function(state, dispatch) {
        const tr = (0, $dqHDB.createWrapSelectionTransaction)({
            state: state,
            type: type
        });
        if (dispatch) dispatch(tr);
        return true;
    };
}

});
parcelRegister("dqHDB", function(module, exports) {

$parcel$export(module.exports, "createWrapSelectionTransaction", () => $58cb4f2c5bda693a$export$d5c308539c2b2123);

var $3lIcL = parcelRequire("3lIcL");

var $lzEKq = parcelRequire("lzEKq");

var $BmspC = parcelRequire("BmspC");

var $5Z3Rm = parcelRequire("5Z3Rm");
function $58cb4f2c5bda693a$export$d5c308539c2b2123({ state: state, type: type, nodeAttributes: nodeAttributes }) {
    let { tr: tr } = state;
    const { alignment: alignment, indentation: indentation } = state.schema.marks;
    /** Alignment or Indentation is not valid inside block types */ const removeAlignTr = (0, $5Z3Rm.removeBlockMarks)(state, [
        alignment,
        indentation
    ]);
    tr = removeAlignTr || tr;
    /**Get range and wrapping needed for the selection*/ const { range: range, wrapping: wrapping } = $58cb4f2c5bda693a$export$656aa714448bfa8a(state, type, nodeAttributes);
    if (wrapping) tr.wrap(range, wrapping).scrollIntoView();
    else /** We always want to append a block type */ (0, $BmspC.safeInsert)(type.createAndFill(nodeAttributes))(tr).scrollIntoView();
    return tr;
}
function $58cb4f2c5bda693a$export$656aa714448bfa8a(state, type, // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
nodeAttributes) {
    const { $from: $from, $to: $to, from: from } = state.selection;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let range = $from.blockRange($to);
    const isMediaSelection = state.selection instanceof (0, $3lIcL.NodeSelection) && state.selection.node.type === state.schema.nodes.media;
    /**
	 * To wrap a media group we need to start the range from one position
	 * before a media selection's from position.
	 */ if (isMediaSelection) {
        const prev = from - 1;
        range = state.doc.resolve(from > 0 ? prev : from).blockRange($to);
    }
    let isAllowedChild = true;
    /**
	 * Added a check to avoid wrapping codeblock
	 */ if (state.selection.empty) state.doc.nodesBetween($from.pos, $to.pos, (node)=>{
        if (!isAllowedChild) return false;
        return isAllowedChild = node.type !== state.schema.nodes.codeBlock;
    });
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const wrapping = isAllowedChild && range && (0, $lzEKq.findWrapping)(range, type, nodeAttributes);
    return {
        range: range,
        wrapping: wrapping
    };
}

});


parcelRegister("h16z0", function(module, exports) {

$parcel$export(module.exports, "NORMAL_TEXT", () => $c75cdf0ae0ea8421$export$58d6de174a4025df);
$parcel$export(module.exports, "HEADING_1", () => $c75cdf0ae0ea8421$export$aca53469ff012f69);
$parcel$export(module.exports, "HEADING_2", () => $c75cdf0ae0ea8421$export$8af5e2d4f952c9f0);
$parcel$export(module.exports, "HEADING_3", () => $c75cdf0ae0ea8421$export$4b4c4ef3a93a84d8);
$parcel$export(module.exports, "HEADING_4", () => $c75cdf0ae0ea8421$export$67379271b4d26982);
$parcel$export(module.exports, "HEADING_5", () => $c75cdf0ae0ea8421$export$230d7efa1736763e);
$parcel$export(module.exports, "HEADING_6", () => $c75cdf0ae0ea8421$export$329adfa5d98f30d5);
$parcel$export(module.exports, "BLOCK_QUOTE", () => $c75cdf0ae0ea8421$export$175cdd8bc7e4b125);
$parcel$export(module.exports, "CODE_BLOCK", () => $c75cdf0ae0ea8421$export$cf55d1bff75690da);
$parcel$export(module.exports, "PANEL", () => $c75cdf0ae0ea8421$export$867b449446b85962);
$parcel$export(module.exports, "OTHER", () => $c75cdf0ae0ea8421$export$d46a05f8561f868a);
$parcel$export(module.exports, "TEXT_BLOCK_TYPES", () => $c75cdf0ae0ea8421$export$2ec1d6c4f06d927);
$parcel$export(module.exports, "FORMATTING_NODE_TYPES", () => $c75cdf0ae0ea8421$export$a5cb0c20bd02ce0c);
$parcel$export(module.exports, "FORMATTING_MARK_TYPES", () => $c75cdf0ae0ea8421$export$73b50f8f13648c71);
$parcel$export(module.exports, "WRAPPER_BLOCK_TYPES", () => $c75cdf0ae0ea8421$export$c6516682f7569488);
$parcel$export(module.exports, "getBlockTypesInDropdown", () => $c75cdf0ae0ea8421$export$a1bb601016dd2309);
$parcel$export(module.exports, "HEADINGS_BY_LEVEL", () => $c75cdf0ae0ea8421$export$110c9c3e05131569);
$parcel$export(module.exports, "HEADINGS_BY_NAME", () => $c75cdf0ae0ea8421$export$33dfdcd30c23ea87);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $TgnAJ = parcelRequire("TgnAJ");

var $2DLW5 = parcelRequire("2DLW5");

var $8tfsN = parcelRequire("8tfsN");

var $iaTwJ = parcelRequire("iaTwJ");

var $kMjFB = parcelRequire("kMjFB");

var $g6Zs4 = parcelRequire("g6Zs4");

var $a4Ktd = parcelRequire("a4Ktd");

var $8hNRj = parcelRequire("8hNRj");

var $92xoS = parcelRequire("92xoS");

var $352qR = parcelRequire("352qR");
const $c75cdf0ae0ea8421$export$58d6de174a4025df = {
    name: 'normal',
    title: (0, $TgnAJ.messages).normal,
    nodeName: 'paragraph',
    tagName: 'p',
    icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8hNRj))), {
        label: ""
    }),
    LEGACY_icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $352qR.Text), {})
};
const $c75cdf0ae0ea8421$export$aca53469ff012f69 = {
    name: 'heading1',
    title: (0, $TgnAJ.messages).heading1,
    nodeName: 'heading',
    tagName: 'h1',
    level: 1,
    icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iaTwJ))), {
        label: ""
    }),
    LEGACY_icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $352qR.H1), {})
};
const $c75cdf0ae0ea8421$export$8af5e2d4f952c9f0 = {
    name: 'heading2',
    title: (0, $TgnAJ.messages).heading2,
    nodeName: 'heading',
    tagName: 'h2',
    level: 2,
    icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a4Ktd))), {
        label: ""
    }),
    LEGACY_icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $352qR.H2), {})
};
const $c75cdf0ae0ea8421$export$4b4c4ef3a93a84d8 = {
    name: 'heading3',
    title: (0, $TgnAJ.messages).heading3,
    nodeName: 'heading',
    tagName: 'h3',
    level: 3,
    icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g6Zs4))), {
        label: ""
    }),
    LEGACY_icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $352qR.H3), {})
};
const $c75cdf0ae0ea8421$export$67379271b4d26982 = {
    name: 'heading4',
    title: (0, $TgnAJ.messages).heading4,
    nodeName: 'heading',
    tagName: 'h4',
    level: 4,
    icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8tfsN))), {
        label: ""
    }),
    LEGACY_icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $352qR.H4), {})
};
const $c75cdf0ae0ea8421$export$230d7efa1736763e = {
    name: 'heading5',
    title: (0, $TgnAJ.messages).heading5,
    nodeName: 'heading',
    tagName: 'h5',
    level: 5,
    icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2DLW5))), {
        label: ""
    }),
    LEGACY_icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $352qR.H5), {})
};
const $c75cdf0ae0ea8421$export$329adfa5d98f30d5 = {
    name: 'heading6',
    title: (0, $TgnAJ.messages).heading6,
    nodeName: 'heading',
    tagName: 'h6',
    level: 6,
    icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kMjFB))), {
        label: ""
    }),
    LEGACY_icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $352qR.H6), {})
};
const $c75cdf0ae0ea8421$export$175cdd8bc7e4b125 = {
    name: 'blockquote',
    title: (0, $TgnAJ.messages).blockquote,
    nodeName: 'blockquote',
    tagName: 'blockquote'
};
const $c75cdf0ae0ea8421$export$cf55d1bff75690da = {
    name: 'codeblock',
    title: (0, $TgnAJ.messages).codeblock,
    nodeName: 'codeBlock'
};
const $c75cdf0ae0ea8421$export$867b449446b85962 = {
    name: 'panel',
    title: (0, $TgnAJ.messages).infoPanel,
    nodeName: 'panel'
};
const $c75cdf0ae0ea8421$export$d46a05f8561f868a = {
    name: 'other',
    title: (0, $TgnAJ.messages).other,
    nodeName: ''
};
const $c75cdf0ae0ea8421$export$2ec1d6c4f06d927 = [
    $c75cdf0ae0ea8421$export$58d6de174a4025df,
    $c75cdf0ae0ea8421$export$aca53469ff012f69,
    $c75cdf0ae0ea8421$export$8af5e2d4f952c9f0,
    $c75cdf0ae0ea8421$export$4b4c4ef3a93a84d8,
    $c75cdf0ae0ea8421$export$67379271b4d26982,
    $c75cdf0ae0ea8421$export$230d7efa1736763e,
    $c75cdf0ae0ea8421$export$329adfa5d98f30d5
];
const $c75cdf0ae0ea8421$export$a5cb0c20bd02ce0c = [
    'heading',
    'blockquote'
];
const $c75cdf0ae0ea8421$export$73b50f8f13648c71 = [
    'em',
    'code',
    'strike',
    'strong',
    'underline',
    'textColor',
    'subsup',
    'backgroundColor'
];
const $c75cdf0ae0ea8421$export$c6516682f7569488 = [
    $c75cdf0ae0ea8421$export$175cdd8bc7e4b125,
    $c75cdf0ae0ea8421$export$cf55d1bff75690da,
    $c75cdf0ae0ea8421$export$867b449446b85962
];
const $c75cdf0ae0ea8421$export$237f26fa8dbc0d9a = $c75cdf0ae0ea8421$export$2ec1d6c4f06d927.concat($c75cdf0ae0ea8421$export$c6516682f7569488);
const $c75cdf0ae0ea8421$export$a1bb601016dd2309 = (includeBlockQuoteAsTextstyleOption)=>{
    return (0, $92xoS.editorExperiment)('platform_editor_blockquote_in_text_formatting_menu', true, {
        exposure: true
    }) && includeBlockQuoteAsTextstyleOption ? [
        ...$c75cdf0ae0ea8421$export$2ec1d6c4f06d927,
        $c75cdf0ae0ea8421$export$175cdd8bc7e4b125
    ] : $c75cdf0ae0ea8421$export$2ec1d6c4f06d927;
};
const $c75cdf0ae0ea8421$export$110c9c3e05131569 = $c75cdf0ae0ea8421$export$2ec1d6c4f06d927.reduce((acc, blockType)=>{
    if (blockType.level && blockType.nodeName === 'heading') acc[blockType.level] = blockType;
    return acc;
}, {});
const $c75cdf0ae0ea8421$export$33dfdcd30c23ea87 = $c75cdf0ae0ea8421$export$2ec1d6c4f06d927.reduce((acc, blockType)=>{
    if (blockType.level && blockType.nodeName === 'heading') acc[blockType.name] = blockType;
    return acc;
}, {});

});
parcelRegister("2DLW5", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f20174f511024dbb8c8d349f218c646e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1ec46857d90761b6$var$_react = $1ec46857d90761b6$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $1ec46857d90761b6$var$_baseNew = $1ec46857d90761b6$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $1ec46857d90761b6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextHeadingFive".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for H5 / Heading 5 text style
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1ec46857d90761b6$var$TextHeadingFiveIcon = (props)=>/*#__PURE__*/ $1ec46857d90761b6$var$_react.default.createElement($1ec46857d90761b6$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M16 8.5h-3.75a.75.75 0 0 0-.75.75v3c0 .41.34.75.75.75h2.25v1.5h-3V16h3.13c.76 0 1.38-.62 1.38-1.37v-1.75c0-.76-.62-1.37-1.37-1.37H13V10h3zM2.5 6.25V1H1v12h1.5V7.75H8V13h1.5V1H8v5.25z" clip-rule="evenodd"/>`
    }, props));
$1ec46857d90761b6$var$TextHeadingFiveIcon.displayName = 'TextHeadingFiveIcon';
var $1ec46857d90761b6$var$_default = module.exports.default = $1ec46857d90761b6$var$TextHeadingFiveIcon;

});

parcelRegister("8tfsN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2e1c911275bbc9f09d8b74402467dc96>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $62ad06df3ef188bd$var$_react = $62ad06df3ef188bd$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $62ad06df3ef188bd$var$_baseNew = $62ad06df3ef188bd$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $62ad06df3ef188bd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextHeadingFour".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for H4 / Heading 4 text style
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $62ad06df3ef188bd$var$TextHeadingFourIcon = (props)=>/*#__PURE__*/ $62ad06df3ef188bd$var$_react.default.createElement($62ad06df3ef188bd$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.5 12V8.5H11v3.63c0 .76.62 1.38 1.38 1.38h2.12V16H16V8.5h-1.5V12zm-10-5.75V1H1v12h1.5V7.75H8V13h1.5V1H8v5.25z" clip-rule="evenodd"/>`
    }, props));
$62ad06df3ef188bd$var$TextHeadingFourIcon.displayName = 'TextHeadingFourIcon';
var $62ad06df3ef188bd$var$_default = module.exports.default = $62ad06df3ef188bd$var$TextHeadingFourIcon;

});

parcelRegister("iaTwJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4a96af59b8b25fc6d7b24bf13d8c2c64>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d3b43bae4b75d424$var$_react = $d3b43bae4b75d424$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $d3b43bae4b75d424$var$_baseNew = $d3b43bae4b75d424$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $d3b43bae4b75d424$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextHeadingOne".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for H1 / Heading 1 text style
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d3b43bae4b75d424$var$TextHeadingOneIcon = (props)=>/*#__PURE__*/ $d3b43bae4b75d424$var$_react.default.createElement($d3b43bae4b75d424$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.5 6.25V1H1v12h1.5V7.75H8V13h1.5V1H8v5.25zM12 8.5h1.75a.75.75 0 0 1 .75.75V16H13v-6h-1z" clip-rule="evenodd"/>`
    }, props));
$d3b43bae4b75d424$var$TextHeadingOneIcon.displayName = 'TextHeadingOneIcon';
var $d3b43bae4b75d424$var$_default = module.exports.default = $d3b43bae4b75d424$var$TextHeadingOneIcon;

});

parcelRegister("kMjFB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fd4b564b4f9efff19c6a7ab8cfffa74a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f2078c62da50ef9b$var$_react = $f2078c62da50ef9b$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $f2078c62da50ef9b$var$_baseNew = $f2078c62da50ef9b$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $f2078c62da50ef9b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextHeadingSix".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for H6 / Heading 6 text style
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f2078c62da50ef9b$var$TextHeadingSixIcon = (props)=>/*#__PURE__*/ $f2078c62da50ef9b$var$_react.default.createElement($f2078c62da50ef9b$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15.5 8.5h-2.62c-.76 0-1.37.62-1.37 1.38v4.75c0 .76.62 1.38 1.38 1.38h1.75c.76 0 1.38-.62 1.38-1.37v-1.75c0-.76-.62-1.37-1.37-1.37H13V10h2.5zM13 13h1.5v1.5H13zM2.5 6.25V1H1v12h1.5V7.75H8V13h1.5V1H8v5.25z" clip-rule="evenodd"/>`
    }, props));
$f2078c62da50ef9b$var$TextHeadingSixIcon.displayName = 'TextHeadingSixIcon';
var $f2078c62da50ef9b$var$_default = module.exports.default = $f2078c62da50ef9b$var$TextHeadingSixIcon;

});

parcelRegister("g6Zs4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::69eb91f82b309428a7917986dda5ee35>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bbacdfed018e1198$var$_react = $bbacdfed018e1198$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $bbacdfed018e1198$var$_baseNew = $bbacdfed018e1198$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $bbacdfed018e1198$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextHeadingThree".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for H3 / Heading 3 text style
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bbacdfed018e1198$var$TextHeadingThreeIcon = (props)=>/*#__PURE__*/ $bbacdfed018e1198$var$_react.default.createElement($bbacdfed018e1198$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11.5 8.5h3.13c.76 0 1.38.62 1.38 1.38v4.75c0 .76-.62 1.38-1.37 1.38H11.5v-1.5h3V13h-3v-1.5h3V10h-3zm-9-2.25V1H1v12h1.5V7.75H8V13h1.5V1H8v5.25z" clip-rule="evenodd"/>`
    }, props));
$bbacdfed018e1198$var$TextHeadingThreeIcon.displayName = 'TextHeadingThreeIcon';
var $bbacdfed018e1198$var$_default = module.exports.default = $bbacdfed018e1198$var$TextHeadingThreeIcon;

});

parcelRegister("a4Ktd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1d33290aac1089ceab1f15dfb1bfcf01>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $755e5320e3b8adde$var$_react = $755e5320e3b8adde$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $755e5320e3b8adde$var$_baseNew = $755e5320e3b8adde$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $755e5320e3b8adde$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextHeadingTwo".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for H2 / Heading 2 text style
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $755e5320e3b8adde$var$TextHeadingTwoIcon = (props)=>/*#__PURE__*/ $755e5320e3b8adde$var$_react.default.createElement($755e5320e3b8adde$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11.5 8.5h3.13c.76 0 1.38.62 1.38 1.38v1.75c0 .76-.62 1.38-1.37 1.38H13v1.5h3V16h-3.75a.75.75 0 0 1-.75-.75v-2.37c0-.76.62-1.37 1.38-1.37h1.62V10h-3zm-9-2.25V1H1v12h1.5V7.75H8V13h1.5V1H8v5.25z" clip-rule="evenodd"/>`
    }, props));
$755e5320e3b8adde$var$TextHeadingTwoIcon.displayName = 'TextHeadingTwoIcon';
var $755e5320e3b8adde$var$_default = module.exports.default = $755e5320e3b8adde$var$TextHeadingTwoIcon;

});

parcelRegister("8hNRj", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c514376430cef925ef724f6e20a216ec>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $608696355e141648$var$_react = $608696355e141648$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $608696355e141648$var$_baseNew = $608696355e141648$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $608696355e141648$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Text".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for representing text objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $608696355e141648$var$TextIcon = (props)=>/*#__PURE__*/ $608696355e141648$var$_react.default.createElement($608696355e141648$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.813 2.5H0V1h11v1.5H6.313V15h-1.5zM12 6.5V4h1.5v2.5H16V8h-2.5v5a.5.5 0 0 0 .5.5h2V15h-2a2 2 0 0 1-2-2V8h-2V6.5z" clip-rule="evenodd"/>`
    }, props));
$608696355e141648$var$TextIcon.displayName = 'TextIcon';
var $608696355e141648$var$_default = module.exports.default = $608696355e141648$var$TextIcon;

});

parcelRegister("352qR", function(module, exports) {

$parcel$export(module.exports, "Text", () => $62c59381d0caa582$export$5f1af8db9871e1d6);
$parcel$export(module.exports, "H1", () => $62c59381d0caa582$export$5523b16adee8048);
$parcel$export(module.exports, "H2", () => $62c59381d0caa582$export$cb94397127ac9363);
$parcel$export(module.exports, "H3", () => $62c59381d0caa582$export$746be9e3a3dfff1f);
$parcel$export(module.exports, "H4", () => $62c59381d0caa582$export$cc5e069d64fda823);
$parcel$export(module.exports, "H5", () => $62c59381d0caa582$export$88ef9fdaf11f7a1f);
$parcel$export(module.exports, "H6", () => $62c59381d0caa582$export$a559fb8039b06400);
/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
const $62c59381d0caa582$var$SVGContainer = ({ children: children })=>/*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        style: {
            width: "var(--ds-space-300, 24px)",
            height: "var(--ds-space-300, 24px)",
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center'
        },
        children: children
    });
const $62c59381d0caa582$export$5f1af8db9871e1d6 = ()=>/*#__PURE__*/ (0, $gt9Am.jsx)($62c59381d0caa582$var$SVGContainer, {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("svg", {
            width: "16",
            height: "16",
            viewBox: "0 0 16 16",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M2 1H14V5H12.5V2.5H8.8125V13.5H10.5V15H5.5V13.5H7.3125V2.5H3.5V5H2V1Z",
                fill: "currentColor"
            })
        })
    });
const $62c59381d0caa582$export$5523b16adee8048 = ()=>/*#__PURE__*/ (0, $gt9Am.jsx)($62c59381d0caa582$var$SVGContainer, {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("svg", {
            width: "14",
            height: "14",
            viewBox: "0 0 14 14",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M0 0H1.5V6.25H6V0H7.5V6.25V7.75V14H6V7.75H1.5V14H0V7.75V6.25V0ZM9.85801 12.6959V14H13.9999V12.6959H12.8161V7.83108H11.3138L9.8418 8.86406V10.4342L11.3499 9.31528V12.6959H9.85801Z",
                fill: "currentColor"
            })
        })
    });
const $62c59381d0caa582$export$cb94397127ac9363 = ()=>/*#__PURE__*/ (0, $gt9Am.jsx)($62c59381d0caa582$var$SVGContainer, {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("svg", {
            width: "14",
            height: "14",
            viewBox: "0 0 14 14",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                "clip-rule": "evenodd",
                d: "M1.5 0H0V6.25V7.75V14H1.5V7.75H6V14H7.5V7.75V6.25V0H6V6.25H1.5V0ZM9.2395 12.8296V14H14V12.6553H11.5637V12.573L12.4146 11.875C12.7826 11.5734 13.0772 11.2981 13.2986 11.0491C13.5199 10.8 13.679 10.5635 13.7759 10.3394C13.8755 10.1152 13.9253 9.89111 13.9253 9.66699V9.64624C13.9253 9.28101 13.8285 8.96419 13.6348 8.6958C13.4411 8.42464 13.1685 8.21574 12.8171 8.06909C12.4685 7.91968 12.0562 7.84497 11.5803 7.84497C11.0906 7.84497 10.6617 7.93075 10.2937 8.10229C9.92847 8.27108 9.64347 8.50903 9.43872 8.81616C9.23674 9.12052 9.13574 9.47884 9.13574 9.89111V9.92432H10.7378V9.88696C10.7378 9.74308 10.771 9.6158 10.8374 9.50513C10.9038 9.39445 10.9951 9.30729 11.1113 9.24365C11.2303 9.18001 11.3659 9.14819 11.5181 9.14819C11.6647 9.14819 11.7906 9.1731 11.8958 9.2229C12.0037 9.27271 12.0853 9.34465 12.1406 9.43872C12.1987 9.5328 12.2278 9.64486 12.2278 9.7749V9.79565C12.2278 9.9008 12.1946 10.0115 12.1282 10.1277C12.0645 10.2439 11.9497 10.3878 11.7837 10.5593C11.6177 10.7281 11.3811 10.9467 11.074 11.2151L9.2395 12.8296Z",
                fill: "currentColor"
            })
        })
    });
const $62c59381d0caa582$export$746be9e3a3dfff1f = ()=>/*#__PURE__*/ (0, $gt9Am.jsx)($62c59381d0caa582$var$SVGContainer, {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("svg", {
            width: "14",
            height: "14",
            viewBox: "0 0 14 14",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M1.5 0H0V6.25V7.75V14H1.5V7.75H6V14H7.5V7.75V6.25V0H6V6.25H1.5V0ZM10.219 13.7649C10.5811 13.9216 11.0012 14 11.4794 14C12.0009 14 12.4494 13.9257 12.825 13.7771C13.2005 13.6258 13.4896 13.411 13.6922 13.1327C13.8976 12.8544 14.0002 12.5248 14.0002 12.1438V12.1357C14.0002 11.7575 13.8706 11.4535 13.6112 11.2239C13.3518 10.9942 13.0006 10.8564 12.5575 10.8105V10.7781C12.7709 10.7348 12.9681 10.6565 13.1492 10.543C13.3329 10.4295 13.4801 10.2823 13.5909 10.1013C13.7017 9.91755 13.7571 9.70275 13.7571 9.45688V9.44878C13.7571 9.12186 13.6639 8.83817 13.4774 8.5977C13.291 8.35454 13.0262 8.16541 12.6831 8.03032C12.34 7.89523 11.9347 7.82769 11.4673 7.82769C11.0134 7.82769 10.6162 7.90469 10.2758 8.05869C9.93805 8.20999 9.67057 8.42479 9.47334 8.70308C9.27611 8.98136 9.16533 9.31099 9.14102 9.69194L9.13696 9.75273H10.6851L10.6892 9.71626C10.7027 9.58927 10.7418 9.4785 10.8067 9.38394C10.8715 9.28667 10.9593 9.21237 11.0701 9.16104C11.1836 9.107 11.316 9.07998 11.4673 9.07998C11.6132 9.07998 11.7388 9.10565 11.8442 9.15698C11.9523 9.20562 12.0347 9.27586 12.0914 9.36772C12.1481 9.45959 12.1765 9.56631 12.1765 9.68789V9.696C12.1765 9.81488 12.1427 9.9189 12.0752 10.0081C12.0104 10.0945 11.9158 10.1607 11.7915 10.2066C11.6672 10.2526 11.5159 10.2755 11.3376 10.2755H10.7337V11.4062H11.3376C11.6348 11.4062 11.8618 11.4589 12.0185 11.5643C12.1752 11.667 12.2535 11.8183 12.2535 12.0182V12.0263C12.2535 12.1506 12.2224 12.2614 12.1603 12.3586C12.0982 12.4532 12.009 12.5289 11.8928 12.5856C11.7766 12.6396 11.6375 12.6667 11.4754 12.6667C11.3133 12.6667 11.1728 12.641 11.0539 12.5896C10.935 12.5383 10.8405 12.4681 10.7702 12.3789C10.7 12.2897 10.6567 12.1911 10.6405 12.0831L10.6324 12.0344H8.99512L8.99917 12.0871C9.02889 12.4762 9.14912 12.8139 9.35986 13.1003C9.57061 13.3867 9.857 13.6082 10.219 13.7649Z",
                fill: "currentColor"
            })
        })
    });
const $62c59381d0caa582$export$cc5e069d64fda823 = ()=>/*#__PURE__*/ (0, $gt9Am.jsx)($62c59381d0caa582$var$SVGContainer, {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("svg", {
            width: "14",
            height: "14",
            viewBox: "0 0 14 14",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M1.5 0H0V6.25V7.75V14H1.5V7.75H6V14H7.5V7.75V6.25V0H6V6.25H1.5V0ZM11.542 13.0117V14H13.2607V13.0117H13.9998V11.6195H13.2607V7.79961H10.7428C10.5852 8.05169 10.4291 8.30378 10.2744 8.55586C10.1226 8.80508 9.97077 9.05573 9.81894 9.30781C9.66999 9.5599 9.52103 9.81628 9.37207 10.077C9.22311 10.3348 9.07559 10.5969 8.92949 10.8633C8.7834 11.1268 8.6373 11.3975 8.49121 11.6754V13.0117H11.542ZM11.5936 11.6883H10.0338V11.6023C10.1226 11.4276 10.2143 11.2543 10.3088 11.0824C10.4033 10.9077 10.4993 10.7344 10.5967 10.5625C10.6969 10.3906 10.7972 10.2202 10.8975 10.0512C10.9977 9.8793 11.098 9.71029 11.1982 9.54414C11.3014 9.37799 11.4045 9.21328 11.5076 9.05H11.5936V11.6883Z",
                fill: "currentColor"
            })
        })
    });
const $62c59381d0caa582$export$88ef9fdaf11f7a1f = ()=>/*#__PURE__*/ (0, $gt9Am.jsx)($62c59381d0caa582$var$SVGContainer, {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("svg", {
            width: "14",
            height: "14",
            viewBox: "0 0 14 14",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M1.5 0H0V6.25V7.75V14H1.5V7.75H6V14H7.5V7.75V6.25V0H6V6.25H1.5V0ZM10.2808 13.7551C10.6349 13.9184 11.0527 14 11.5342 14C12.0239 14 12.4542 13.9101 12.825 13.7302C13.1957 13.5476 13.4835 13.2917 13.6882 12.9624C13.8958 12.6331 13.9995 12.2499 13.9995 11.8127V11.8044C13.9995 11.4281 13.9165 11.0961 13.7505 10.8083C13.5872 10.5178 13.3617 10.2896 13.074 10.1235C12.7862 9.95752 12.457 9.87451 12.0862 9.87451C11.887 9.87451 11.703 9.90356 11.5342 9.96167C11.3682 10.0198 11.2243 10.1 11.1025 10.2024C10.9808 10.3048 10.884 10.4237 10.812 10.5593H10.729L10.8203 9.1731H13.6177V7.84497H9.45898L9.22241 11.4973H10.7207C10.7511 11.4392 10.7913 11.3839 10.8411 11.3313C10.8909 11.276 10.9462 11.2275 11.0071 11.186C11.079 11.139 11.1579 11.103 11.2437 11.0781C11.3322 11.0505 11.4277 11.0366 11.53 11.0366C11.6933 11.0366 11.8385 11.0712 11.9658 11.1404C12.0931 11.2068 12.1927 11.2995 12.2646 11.4185C12.3366 11.5374 12.3726 11.6772 12.3726 11.8376V11.8459C12.3726 12.0037 12.3366 12.1448 12.2646 12.2693C12.1927 12.391 12.0931 12.4865 11.9658 12.5557C11.8413 12.6248 11.6974 12.6594 11.5342 12.6594C11.3903 12.6594 11.2616 12.6345 11.1482 12.5847C11.0347 12.5349 10.9393 12.4685 10.8618 12.3855C10.7871 12.2997 10.7318 12.2056 10.6958 12.1033L10.6875 12.0784H9.12695L9.1311 12.1531C9.15047 12.4989 9.25838 12.8116 9.45483 13.0911C9.65405 13.3705 9.92936 13.5919 10.2808 13.7551Z",
                fill: "currentColor"
            })
        })
    });
const $62c59381d0caa582$export$a559fb8039b06400 = ()=>/*#__PURE__*/ (0, $gt9Am.jsx)($62c59381d0caa582$var$SVGContainer, {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("svg", {
            width: "14",
            height: "14",
            viewBox: "0 0 14 14",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M1.5 0H0V6.25V7.75V14H1.5V7.75H6V14H7.5V7.75V6.25V0H6V6.25H1.5V0ZM10.4615 13.7893C10.7857 13.9298 11.1531 14 11.5638 14C12.0501 14 12.4757 13.9068 12.8404 13.7204C13.2052 13.5339 13.4889 13.28 13.6915 12.9584C13.8968 12.6342 13.9995 12.2681 13.9995 11.8602V11.8521C13.9995 11.4873 13.9225 11.1644 13.7685 10.8834C13.6172 10.5998 13.3997 10.3782 13.116 10.2188C12.835 10.0567 12.4973 9.97563 12.1028 9.97563C11.8272 9.97563 11.5935 10.0135 11.4017 10.0891C11.2099 10.1648 11.0532 10.2634 10.9316 10.385C10.81 10.5065 10.7141 10.6389 10.6438 10.7821H10.5547C10.5548 10.7402 10.5561 10.6984 10.5587 10.6565C10.575 10.3539 10.6195 10.0878 10.6925 9.8581C10.7681 9.62845 10.8762 9.44878 11.0167 9.31909C11.1572 9.1894 11.3328 9.12456 11.5436 9.12456C11.6624 9.12456 11.7678 9.14347 11.8597 9.1813C11.9542 9.21912 12.0353 9.27046 12.1028 9.3353C12.1704 9.40015 12.2204 9.47309 12.2528 9.55415L12.2649 9.58252H13.9266L13.9225 9.5582C13.8685 9.23398 13.7334 8.94219 13.5172 8.68281C13.3011 8.42074 13.0215 8.21269 12.6783 8.05869C12.3379 7.90469 11.9542 7.82768 11.5273 7.82768C11.0032 7.82768 10.5466 7.95062 10.1575 8.19648C9.76846 8.44235 9.4672 8.79629 9.25376 9.2583C9.04032 9.71761 8.93359 10.2674 8.93359 10.9078V10.9159C8.93359 11.3941 8.99303 11.8237 9.11191 12.2046C9.23079 12.5856 9.40371 12.9098 9.63066 13.1773C9.86032 13.4421 10.1373 13.6461 10.4615 13.7893ZM10.7492 11.9047C10.7492 12.056 10.7843 12.1925 10.8546 12.3141C10.9275 12.4356 11.0248 12.5316 11.1464 12.6018C11.2707 12.6694 11.4071 12.7031 11.5557 12.7031C11.707 12.7031 11.8435 12.6694 11.965 12.6018C12.0866 12.5316 12.1839 12.4383 12.2568 12.3222C12.3298 12.206 12.3663 12.075 12.3663 11.9291V11.9209C12.3663 11.7696 12.3311 11.6359 12.2609 11.5197C12.1906 11.4035 12.0947 11.3117 11.9731 11.2441C11.8543 11.1766 11.7165 11.1428 11.5598 11.1428C11.4112 11.1428 11.2747 11.1752 11.1504 11.2401C11.0289 11.3022 10.9316 11.39 10.8586 11.5035C10.7857 11.617 10.7492 11.748 10.7492 11.8966V11.9047Z",
                fill: "currentColor"
            })
        })
    });

});


parcelRegister("78v0m", function(module, exports) {

$parcel$export(module.exports, "FORMATTING_NODE_TYPES", () => $16d8796ef7db609e$export$a5cb0c20bd02ce0c);
$parcel$export(module.exports, "FORMATTING_MARK_TYPES", () => $16d8796ef7db609e$export$73b50f8f13648c71);
$parcel$export(module.exports, "formatTypes", () => $16d8796ef7db609e$export$ce157a3b6664c924);
$parcel$export(module.exports, "cellSelectionNodesBetween", () => $16d8796ef7db609e$export$bd443c1dba3019b8);
$parcel$export(module.exports, "clearNodeFormattingOnSelection", () => $16d8796ef7db609e$export$10ed2145ce1a03b1);

var $bMFKb = parcelRequire("bMFKb");

var $lzEKq = parcelRequire("lzEKq");
const $16d8796ef7db609e$export$a5cb0c20bd02ce0c = [
    'heading',
    'blockquote'
];
const $16d8796ef7db609e$export$73b50f8f13648c71 = [
    'em',
    'code',
    'strike',
    'strong',
    'underline',
    'textColor',
    'subsup',
    'backgroundColor'
];
const $16d8796ef7db609e$export$ce157a3b6664c924 = {
    em: (0, $bMFKb.ACTION_SUBJECT_ID).FORMAT_ITALIC,
    code: (0, $bMFKb.ACTION_SUBJECT_ID).FORMAT_CODE,
    strike: (0, $bMFKb.ACTION_SUBJECT_ID).FORMAT_STRIKE,
    strong: (0, $bMFKb.ACTION_SUBJECT_ID).FORMAT_STRONG,
    underline: (0, $bMFKb.ACTION_SUBJECT_ID).FORMAT_UNDERLINE,
    textColor: (0, $bMFKb.ACTION_SUBJECT_ID).FORMAT_COLOR,
    subsup: 'subsup',
    backgroundColor: (0, $bMFKb.ACTION_SUBJECT_ID).FORMAT_BACKGROUND_COLOR
};
const $16d8796ef7db609e$export$bd443c1dba3019b8 = (selection, doc, f, startPos)=>{
    selection.forEachCell((cell, cellPos)=>{
        doc.nodesBetween(cellPos, cellPos + cell.nodeSize, f, startPos);
    });
};
function $16d8796ef7db609e$export$10ed2145ce1a03b1(schema, tr, formattedNodeType, nodeName, formattingCleared) {
    return function(node, pos) {
        if (node.type === formattedNodeType) {
            if (formattedNodeType.isTextblock) {
                tr.setNodeMarkup(pos, schema.nodes.paragraph);
                formattingCleared.push(nodeName);
                return false;
            } else {
                // In case of panel or blockquote
                const fromPos = tr.doc.resolve(pos + 1);
                const toPos = tr.doc.resolve(pos + node.nodeSize - 1);
                const nodeRange = fromPos.blockRange(toPos);
                if (nodeRange) {
                    const targetLiftDepth = (0, $lzEKq.liftTarget)(nodeRange);
                    if (targetLiftDepth || targetLiftDepth === 0) {
                        formattingCleared.push(nodeName);
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        tr.lift(nodeRange, targetLiftDepth);
                    }
                }
            }
        }
        return true;
    };
}

});

parcelRegister("l8Eo2", function(module, exports) {

$parcel$export(module.exports, "wrapSelectionInBlockType", () => $af68f559d9bca524$export$bb05c9a6c853122f);

var $3xw6l = parcelRequire("3xw6l");

var $lzEKq = parcelRequire("lzEKq");
function $af68f559d9bca524$export$bb05c9a6c853122f(nodeType) {
    return ({ tr: tr })=>{
        const { nodes: nodes } = tr.doc.type.schema;
        const { alignment: alignment, indentation: indentation } = tr.doc.type.schema.marks;
        if (nodes.paragraph && nodes.blockquote) {
            /**Remove alignment and indentation marks from the selection */ const marksToRemove = [
                alignment,
                indentation
            ];
            const hasMark = (mark)=>marksToRemove.indexOf(mark.type) > -1;
            const not = (fn)=>(arg)=>!fn(arg);
            /**
			 * When you need to toggle the selection
			 * when another type which does not allow alignment is applied
			 */ tr.doc.nodesBetween(tr.selection.from, tr.selection.to, (node, pos)=>{
                if (node.type === nodes.paragraph && node.marks.some(hasMark)) {
                    const resolvedPos = tr.doc.resolve(pos);
                    const withoutBlockMarks = node.marks.filter(not(hasMark));
                    tr = tr.setNodeMarkup(resolvedPos.pos, undefined, node.attrs, withoutBlockMarks);
                }
            });
            /** Get range and wrapping needed for the selection */ const { $from: $from, $to: $to } = tr.selection;
            const range = $from.blockRange($to);
            const wrapping = range && (0, $lzEKq.findWrapping)(range, nodes.blockquote);
            if (wrapping) /** Wrap the selection */ tr.wrap(range, wrapping).scrollIntoView();
            else {
                /** If wrapping is not possible, replace with a blockquote */ const start = $from.start();
                const end = $to.end();
                const content = $from.node().content;
                const blockquote = nodes.blockquote.create({}, nodes.paragraph.create({}, content));
                const slice = new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).from(blockquote), 0, 0);
                tr.replaceRange(start, end, slice).scrollIntoView();
            }
        }
        return tr;
    };
}

});


parcelRegister("lnss2", function(module, exports) {

$parcel$export(module.exports, "default", () => $e78ff6e25e870e0f$export$2e2bcd8739ae039);

var $bMFKb = parcelRequire("bMFKb");

var $piMVJ = parcelRequire("piMVJ");

var $i8KtF = parcelRequire("i8KtF");

var $leZY6 = parcelRequire("leZY6");

var $jCfsG = parcelRequire("jCfsG");

var $lRu98 = parcelRequire("lRu98");
const $e78ff6e25e870e0f$var$MAX_HEADING_LEVEL = 6;
function $e78ff6e25e870e0f$var$getHeadingLevel(match) {
    return {
        level: match[1].length
    };
}
function $e78ff6e25e870e0f$var$headingRule(nodeType, maxLevel) {
    return (0, $lRu98.createWrappingTextBlockRule)({
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        match: new RegExp('^(#{1,' + maxLevel + '})\\s$'),
        nodeType: nodeType,
        getAttrs: $e78ff6e25e870e0f$var$getHeadingLevel
    });
}
function $e78ff6e25e870e0f$var$blockQuoteRule(nodeType) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return (0, $lRu98.createJoinNodesRule)(/^\s*>\s$/, nodeType);
}
/**
 * Get heading rules
 *
 * @param {Schema} schema
 * @returns {InputRuleWithHandler[]}
 */ function $e78ff6e25e870e0f$var$getHeadingRules(editorAnalyticsAPI, schema) {
    // '# ' for h1, '## ' for h2 and etc
    const hashRule = $e78ff6e25e870e0f$var$headingRule(schema.nodes.heading, $e78ff6e25e870e0f$var$MAX_HEADING_LEVEL);
    const leftNodeReplacementHashRule = (0, $leZY6.createRule)(// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    new RegExp(`${(0, $feddda005efaf7df$export$a96b909f1510512b)}(#{1,6})\\s$`), (state, match, start, end)=>{
        const level = match[1].length;
        return (0, $piMVJ.insertBlock)(state, schema.nodes.heading, start, end, {
            level: level
        });
    });
    // New analytics handler
    const ruleWithHeadingAnalytics = (0, $leZY6.inputRuleWithAnalytics)((_state, matchResult)=>({
            action: (0, $bMFKb.ACTION).FORMATTED,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).TEXT,
            eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
            actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).FORMAT_HEADING,
            attributes: {
                inputMethod: (0, $bMFKb.INPUT_METHOD).FORMATTING,
                newHeadingLevel: $e78ff6e25e870e0f$var$getHeadingLevel(matchResult).level
            }
        }), editorAnalyticsAPI);
    return [
        ruleWithHeadingAnalytics(hashRule),
        ruleWithHeadingAnalytics(leftNodeReplacementHashRule)
    ];
}
/**
 * Get all block quote input rules
 *
 * @param {Schema} schema
 * @returns {InputRuleWithHandler[]}
 */ function $e78ff6e25e870e0f$var$getBlockQuoteRules(editorAnalyticsAPI, schema) {
    // '> ' for blockquote
    const greatherThanRule = $e78ff6e25e870e0f$var$blockQuoteRule(schema.nodes.blockquote);
    const leftNodeReplacementGreatherRule = (0, $leZY6.createRule)(// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    new RegExp(`${(0, $feddda005efaf7df$export$a96b909f1510512b)}\\s*>\\s$`), (state, _match, start, end)=>{
        return (0, $piMVJ.insertBlock)(state, schema.nodes.blockquote, start, end);
    });
    // Analytics V3 handler
    const ruleWithBlockQuoteAnalytics = (0, $leZY6.inputRuleWithAnalytics)({
        action: (0, $bMFKb.ACTION).FORMATTED,
        actionSubject: (0, $bMFKb.ACTION_SUBJECT).TEXT,
        eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
        actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).FORMAT_BLOCK_QUOTE,
        attributes: {
            inputMethod: (0, $bMFKb.INPUT_METHOD).FORMATTING
        }
    }, editorAnalyticsAPI);
    return [
        ruleWithBlockQuoteAnalytics(greatherThanRule),
        ruleWithBlockQuoteAnalytics(leftNodeReplacementGreatherRule)
    ];
}
function $e78ff6e25e870e0f$var$inputRulePlugin(editorAnalyticsAPI, schema, featureFlags) {
    const rules = [];
    if (schema.nodes.heading) rules.push(...$e78ff6e25e870e0f$var$getHeadingRules(editorAnalyticsAPI, schema));
    if (schema.nodes.blockquote) rules.push(...$e78ff6e25e870e0f$var$getBlockQuoteRules(editorAnalyticsAPI, schema));
    if (rules.length !== 0) return new (0, $i8KtF.SafePlugin)((0, $jCfsG.createPlugin)('block-type', rules, {
        isBlockNodeRule: true
    }));
    return;
}
var $e78ff6e25e870e0f$export$2e2bcd8739ae039 = $e78ff6e25e870e0f$var$inputRulePlugin;

});
parcelRegister("leZY6", function(module, exports) {

$parcel$export(module.exports, "inputRuleWithAnalytics", () => $466bcc9a564fee27$export$333ee6e3f01bb8f9);
$parcel$export(module.exports, "createWrappingJoinRule", () => $466bcc9a564fee27$export$6341edfa2d147bc);
$parcel$export(module.exports, "createRule", () => $466bcc9a564fee27$export$56e87122f905fac0);

var $kuxd1 = parcelRequire("kuxd1");

var $lzEKq = parcelRequire("lzEKq");

var $eZyx0 = parcelRequire("eZyx0");
const $466bcc9a564fee27$export$333ee6e3f01bb8f9 = (getPayload, analyticsApi)=>{
    return (originalRule)=>{
        const onHandlerApply = (state, tr, matchResult)=>{
            const payload = typeof getPayload === 'function' ? getPayload(state, matchResult) : getPayload;
            if (payload && payload.attributes) payload.attributes.formatSize = typeof matchResult[0] === 'string' ? matchResult[0].length : 0;
            analyticsApi?.attachAnalyticsEvent(payload)(tr);
            if (originalRule.onHandlerApply) originalRule.onHandlerApply(state, tr, matchResult);
        };
        return {
            ...originalRule,
            onHandlerApply: onHandlerApply
        };
    };
};
const $466bcc9a564fee27$export$6341edfa2d147bc = ({ match: match, nodeType: nodeType, getAttrs: getAttrs, joinPredicate: joinPredicate })=>{
    const handler = (state, match, start, end)=>{
        const attrs = (getAttrs instanceof Function ? getAttrs(match) : getAttrs) || {};
        const tr = state.tr;
        const fixedStart = Math.max(start, 1);
        tr.delete(fixedStart, end);
        const $start = tr.doc.resolve(fixedStart);
        const range = $start.blockRange();
        const wrapping = range && (0, $lzEKq.findWrapping)(range, nodeType, attrs);
        if (!wrapping || !range) return null;
        const parentNodePosMapped = tr.mapping.map(range.start);
        const parentNode = tr.doc.nodeAt(parentNodePosMapped);
        const lastWrap = wrapping[wrapping.length - 1];
        if (parentNode && lastWrap) {
            const allowedMarks = lastWrap.type.allowedMarks(parentNode.marks) || [];
            tr.setNodeMarkup(parentNodePosMapped, parentNode.type, parentNode.attrs, allowedMarks);
        }
        tr.wrap(range, wrapping);
        const before = tr.doc.resolve(fixedStart - 1).nodeBefore;
        if (before && before.type === nodeType && (0, $lzEKq.canJoin)(tr.doc, fixedStart - 1) && (!joinPredicate || joinPredicate(match, before, (0, $eZyx0.JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST).JOINED_TO_LIST_ABOVE))) tr.join(fixedStart - 1);
        return tr;
    };
    return $466bcc9a564fee27$export$56e87122f905fac0(match, handler);
};
const $466bcc9a564fee27$export$56e87122f905fac0 = (match, handler)=>{
    return {
        match: match,
        handler: handler,
        onHandlerApply: (_state, tr)=>{
            (0, $kuxd1.closeHistory)(tr);
        }
    };
};

});
parcelRegister("eZyx0", function(module, exports) {

$parcel$export(module.exports, "DELETE_DIRECTION", () => $e60a8d1b964492b5$export$a9b79b94eb5ffad);
$parcel$export(module.exports, "LIST_TEXT_SCENARIOS", () => $e60a8d1b964492b5$export$c3c848735ee9408a);
$parcel$export(module.exports, "JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST", () => $e60a8d1b964492b5$export$43e6a678b13eb45f);
$parcel$export(module.exports, "OUTDENT_SCENARIOS", () => $e60a8d1b964492b5$export$ed4ba8ac11f6cbc8);
var $e60a8d1b964492b5$export$a9b79b94eb5ffad = /*#__PURE__*/ function(DELETE_DIRECTION) {
    DELETE_DIRECTION["BACKWARD"] = "backward";
    DELETE_DIRECTION["FORWARD"] = "forward";
    return DELETE_DIRECTION;
}({});
var $e60a8d1b964492b5$export$c3c848735ee9408a = /*#__PURE__*/ function(LIST_TEXT_SCENARIOS) {
    LIST_TEXT_SCENARIOS["JOIN_SIBLINGS"] = "joinSiblings";
    LIST_TEXT_SCENARIOS["JOIN_DESCENDANT_TO_PARENT"] = "joinDescendantToParent";
    LIST_TEXT_SCENARIOS["JOIN_TO_SIBLING_DESCENDANT"] = "joinToSiblingDescendant";
    LIST_TEXT_SCENARIOS["JOIN_PARAGRAPH_WITH_LIST"] = "joinParagraphWithList";
    LIST_TEXT_SCENARIOS["JOIN_PARENT_SIBLING_TO_PARENT_CHILD"] = "joinParentSiblingToParentChild";
    LIST_TEXT_SCENARIOS["JOIN_LIST_ITEM_WITH_PARAGRAPH"] = "joinListItemWithParagraph";
    return LIST_TEXT_SCENARIOS;
}({});
var $e60a8d1b964492b5$export$43e6a678b13eb45f = /*#__PURE__*/ function(JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST) {
    JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST["NO_JOIN"] = "noJoin";
    JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST["JOINED_TO_LIST_ABOVE"] = "joinedToListAbove";
    JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST["JOINED_TO_LIST_BELOW"] = "joinedToListBelow";
    return JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST;
}({});
var $e60a8d1b964492b5$export$ed4ba8ac11f6cbc8 = /*#__PURE__*/ function(OUTDENT_SCENARIOS) {
    OUTDENT_SCENARIOS["SPLIT_LIST"] = "splitList";
    return OUTDENT_SCENARIOS;
}({});

});


parcelRegister("jCfsG", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $c1eaadfe01c39748$export$ae829ec7b2625219);

var $kuxd1 = parcelRequire("kuxd1");

var $3lIcL = parcelRequire("3lIcL");

var $dxbYf = parcelRequire("dxbYf");

var $1umm2 = parcelRequire("1umm2");
const $c1eaadfe01c39748$var$hasUnsupportedMarks = (state, start, end, marksNameUnsupported)=>{
    const isUnsupportedMark = (node)=>(marksNameUnsupported || []).includes(node.type.name);
    const $from = state.doc.resolve(start);
    const $to = state.doc.resolve(end);
    const marksInSelection = start === end ? $from.marks() : $from.marksAcross($to);
    return (marksInSelection || []).some(isUnsupportedMark);
};
const $c1eaadfe01c39748$var$isCursorInsideUnsupportedMarks = (state, marksNameUnsupported)=>{
    const { selection: selection } = state;
    if (!(selection instanceof (0, $3lIcL.TextSelection))) return false;
    const { $cursor: $cursor } = selection;
    const isUnsupportedMark = (node)=>marksNameUnsupported.includes(node.type.name);
    return Boolean($cursor?.nodeBefore?.marks?.some(isUnsupportedMark));
};
const $c1eaadfe01c39748$export$ae829ec7b2625219 = (pluginName, rules, options = {})=>{
    const { isBlockNodeRule: isBlockNodeRule = false, allowInsertTextOnDocument: allowInsertTextOnDocument = true } = options;
    const onInputEvent = ({ state: state, from: from, to: to })=>{
        const unsupportedMarks = isBlockNodeRule ? [
            'code',
            'link',
            'typeAheadQuery'
        ] : [
            'code'
        ];
        const $from = state.selection.$from;
        const isInline = state.selection instanceof (0, $3lIcL.NodeSelection) && state.selection.node.type.isInline;
        if ($from.parent.type.spec.code || !(state.selection instanceof (0, $3lIcL.TextSelection)) && !(0, $dxbYf.isGapCursorSelection)(state.selection) && !isInline || $c1eaadfe01c39748$var$hasUnsupportedMarks(state, from, to, unsupportedMarks) || isBlockNodeRule && $c1eaadfe01c39748$var$isCursorInsideUnsupportedMarks(state, unsupportedMarks)) return false;
        return true;
    };
    return (0, $1umm2.createInputRulePlugin)(pluginName, rules, {
        allowInsertTextOnDocument: allowInsertTextOnDocument,
        onInputEvent: onInputEvent,
        onBeforeRegexMatch: (tr)=>{
            (0, $kuxd1.closeHistory)(tr);
        }
    });
};

});
parcelRegister("dxbYf", function(module, exports) {

$parcel$export(module.exports, "isGapCursorSelection", () => $5654d327962dad94$export$b0e17cd4423f50ca);
/**
 * This file is to duplicate types that exist in editor-common
 * so that input-rules does not depend on it.
 *
 * This simplifies our dependencies and makes adoption much easier.
 */ const $5654d327962dad94$export$b0e17cd4423f50ca = (selection)=>{
    // @ts-expect-error
    return Boolean(selection.jsonID === 'gapcursor');
};

});

parcelRegister("1umm2", function(module, exports) {

$parcel$export(module.exports, "createInputRulePlugin", () => $afad2bebb97d7d25$export$dc83f374e2af640d);

var $3lIcL = parcelRequire("3lIcL");


var $9tLbC = parcelRequire("9tLbC");
function $afad2bebb97d7d25$export$dc83f374e2af640d(pluginName, rules, options = {}) {
    const onInputEvent = options?.onInputEvent;
    const onBeforeRegexMatch = options?.onBeforeRegexMatch;
    const allowInsertTextOnDocument = Boolean(options?.allowInsertTextOnDocument);
    const pluginKey = new (0, $3lIcL.PluginKey)(`inputRulePlugin__${pluginName}`);
    const inputEvent = (0, $9tLbC.createInputEventHandler)({
        allowInsertTextOnDocument: allowInsertTextOnDocument,
        pluginKey: pluginKey,
        rules: rules,
        onInputEvent: onInputEvent,
        onBeforeRegexMatch: onBeforeRegexMatch
    });
    return {
        key: pluginKey,
        state: {
            init () {
                return null;
            },
            apply (tr, prev) {
                const stored = tr.getMeta(pluginKey);
                if (stored) return stored;
                return tr.selectionSet || tr.docChanged ? null : prev;
            }
        },
        appendTransaction: (transactions, oldState, newState)=>{
            const transactionWithInputRuleMeta = transactions.find((tr)=>tr.getMeta(pluginKey));
            const pluginState = transactionWithInputRuleMeta?.getMeta(pluginKey);
            if (!pluginState || !transactionWithInputRuleMeta) return null;
            const { matchedRule: matchedRule, from: from, to: to } = pluginState;
            const { result: result } = matchedRule;
            const mappedTo = transactionWithInputRuleMeta.mapping.map(to);
            const tr = matchedRule.handler(newState, result, from, mappedTo);
            if (!tr) return null;
            tr.setMeta((0, $feddda005efaf7df$export$e56dc8305776db1f), true);
            if (matchedRule.onHandlerApply) matchedRule.onHandlerApply(newState, tr, matchedRule.result);
            return tr;
        },
        props: {
            handleTextInput (view, from, to, text) {
                return inputEvent({
                    view: view,
                    from: from,
                    to: to,
                    text: text
                });
            },
            handleDOMEvents: {
                compositionend: (view)=>{
                    setTimeout(()=>{
                        const selection = view.state.selection;
                        if (!(selection instanceof (0, $3lIcL.TextSelection))) return;
                        const { $cursor: $cursor } = selection;
                        if ($cursor) inputEvent({
                            view: view,
                            from: $cursor.pos,
                            to: $cursor.pos,
                            text: ''
                        });
                    });
                    return false;
                }
            }
        },
        // @ts-ignore This is used by prosemirror-view to apply input rules on text input event.
        // However, there is no typing ffor this, yet.
        isInputRules: true
    };
}

});
// ProseMirror uses the Unicode Character 'OBJECT REPLACEMENT CHARACTER' (U+FFFC) as text representation for
// leaf nodes, i.e. nodes that don't have any content or text property (e.g. hardBreak, emoji, mention, rule)
// It was introduced because of https://github.com/ProseMirror/prosemirror/issues/262
// This can be used in an input rule regex to be able to include or exclude such nodes.
const $feddda005efaf7df$export$a96b909f1510512b = '\ufffc';
const $feddda005efaf7df$export$e56dc8305776db1f = 'input_rule_plugin_transaction';
const $feddda005efaf7df$export$af78bb669dec9658 = 500;

parcelRegister("9tLbC", function(module, exports) {

$parcel$export(module.exports, "createInputEventHandler", () => $924a0317ab067bd8$export$9bcba4b183c6bb83);


var $dxbYf = parcelRequire("dxbYf");
const $924a0317ab067bd8$export$9bcba4b183c6bb83 = ({ rules: rules, pluginKey: pluginKey, allowInsertTextOnDocument: allowInsertTextOnDocument, onInputEvent: onInputEvent, onBeforeRegexMatch: onBeforeRegexMatch })=>({ view: view, from: from, to: to, text: text })=>{
        if (view.composing) return false;
        const state = view.state;
        const $from = state.doc.resolve(from);
        if ($from.parent.type.spec.code) return false;
        if (onInputEvent && !onInputEvent({
            state: state,
            from: from,
            to: to
        })) return false;
        const textBefore = $from.parent.textBetween(Math.max(0, $from.parentOffset - (0, $feddda005efaf7df$export$af78bb669dec9658)), $from.parentOffset, undefined, (0, $feddda005efaf7df$export$a96b909f1510512b)) + text;
        const result = $924a0317ab067bd8$var$findMatchOnRules({
            rules: rules,
            textBefore: textBefore,
            from: from,
            to: to,
            state: state
        });
        if (!result) return false;
        const tr = allowInsertTextOnDocument ? state.tr.insertText(text, from, to) : state.tr;
        tr.setMeta((0, $feddda005efaf7df$export$e56dc8305776db1f), true);
        tr.setMeta(pluginKey, {
            textInserted: text,
            from: result.from,
            to: result.to,
            matchedRule: result.matchedRule
        });
        if (onBeforeRegexMatch) onBeforeRegexMatch(tr);
        view.dispatch(tr);
        return true;
    };
function $924a0317ab067bd8$var$findMatchOnRules({ rules: rules, textBefore: textBefore, from: from, to: to, state: state }) {
    for(let i = 0; i < rules.length; i++){
        const rule = rules[i];
        // Some plugins like Typeahead require a whitespace before a trigger character.
        // We want them to fire inside a gap cursor. Yet, a gap cursor is not considered a whitespace,
        // and `textBefore` contains the text in the previous block before the gap cursor.
        // Here is a workaround: if we inside a gap cursor, match the input rule only against the last typed character
        // (which may be a typeahead trigger) and ignore the rest.
        const matchString = (0, $dxbYf.isGapCursorSelection)(state.selection) ? textBefore.at(-1) ?? '' : textBefore;
        const match = rule.match.exec(matchString);
        if (!match) continue;
        const parentNodeStartAt = state.selection.$from.start();
        const offset = Math.max(0, state.selection.$from.parentOffset - (0, $feddda005efaf7df$export$af78bb669dec9658));
        const fromFixed = Math.max(parentNodeStartAt + match.index + offset, 1);
        const transform = rule.handler(state, match, fromFixed, to);
        if (transform) return {
            from: fromFixed,
            to: to,
            matchedRule: {
                ...rule,
                result: match
            }
        };
    }
    return null;
}

});



parcelRegister("lRu98", function(module, exports) {

$parcel$export(module.exports, "isNodeAWrappingBlockNode", () => $a8f166db1835b456$export$3a2c03e35bc6c7a8);
$parcel$export(module.exports, "createJoinNodesRule", () => $a8f166db1835b456$export$1fe8b64ae159a0fa);
$parcel$export(module.exports, "createWrappingTextBlockRule", () => $a8f166db1835b456$export$644b98fd2fd87b8b);
$parcel$export(module.exports, "areBlockTypesDisabled", () => $a8f166db1835b456$export$52adb8d9a3386cb8);
$parcel$export(module.exports, "checkFormattingIsPresent", () => $a8f166db1835b456$export$4b48a1fc423972ea);
$parcel$export(module.exports, "hasBlockQuoteInOptions", () => $a8f166db1835b456$export$bce51f4ee2032263);

var $02q9c = parcelRequire("02q9c");

var $leZY6 = parcelRequire("leZY6");

var $92xoS = parcelRequire("92xoS");

var $h16z0 = parcelRequire("h16z0");
const $a8f166db1835b456$export$3a2c03e35bc6c7a8 = (node)=>{
    if (!node) return false;
    return (0, $h16z0.WRAPPER_BLOCK_TYPES).some((blockNode)=>blockNode.name === node.type.name);
};
const $a8f166db1835b456$export$1fe8b64ae159a0fa = (match, nodeType)=>{
    return (0, $leZY6.createWrappingJoinRule)({
        nodeType: nodeType,
        match: match,
        getAttrs: {},
        joinPredicate: (_, node)=>node.type === nodeType
    });
};
const $a8f166db1835b456$export$644b98fd2fd87b8b = ({ match: match, nodeType: nodeType, getAttrs: getAttrs })=>{
    const handler = (state, match, start, end)=>{
        const fixedStart = Math.max(start, 1);
        const $start = state.doc.resolve(fixedStart);
        const attrs = getAttrs instanceof Function ? getAttrs(match) : getAttrs;
        const nodeBefore = $start.node(-1);
        if (nodeBefore && !nodeBefore.canReplaceWith($start.index(-1), $start.indexAfter(-1), nodeType)) return null;
        return state.tr.delete(fixedStart, end).setBlockType(fixedStart, fixedStart, nodeType, attrs);
    };
    return (0, $leZY6.createRule)(match, handler);
};
/**
 * Function will create a list of wrapper blocks present in a selection.
 */ function $a8f166db1835b456$var$getSelectedWrapperNodes(state) {
    const nodes = [];
    if (state.selection) {
        const { $from: $from, $to: $to } = state.selection;
        const { blockquote: blockquote, panel: panel, orderedList: orderedList, bulletList: bulletList, listItem: listItem, caption: caption, codeBlock: codeBlock, decisionItem: decisionItem, decisionList: decisionList, taskItem: taskItem, taskList: taskList } = state.schema.nodes;
        const wrapperNodes = [
            blockquote,
            panel,
            orderedList,
            bulletList,
            listItem,
            codeBlock,
            decisionItem,
            decisionList,
            taskItem,
            taskList
        ];
        wrapperNodes.push(caption);
        state.doc.nodesBetween($from.pos, $to.pos, (node)=>{
            if (node.isBlock && wrapperNodes.indexOf(node.type) >= 0) nodes.push(node.type);
        });
    }
    return nodes;
}
function $a8f166db1835b456$export$52adb8d9a3386cb8(state) {
    const nodesTypes = $a8f166db1835b456$var$getSelectedWrapperNodes(state);
    const { panel: panel, blockquote: blockquote, bulletList: bulletList, orderedList: orderedList } = state.schema.nodes;
    if ((0, $92xoS.editorExperiment)('platform_editor_blockquote_in_text_formatting_menu', true)) {
        let hasQuote = false;
        let hasNestedListInQuote = false;
        const { $from: $from, $to: $to } = state.selection;
        state.doc.nodesBetween($from.pos, $to.pos, (node)=>{
            if (node.type === blockquote) {
                hasQuote = true;
                node.descendants((child)=>{
                    if (child.type === bulletList || child.type === orderedList) {
                        hasNestedListInQuote = true;
                        return false;
                    }
                    return true;
                });
            }
            return !hasNestedListInQuote;
        });
        return nodesTypes.filter((type)=>type !== panel).length > 0 && (!hasQuote || hasNestedListInQuote);
    }
    return nodesTypes.filter((type)=>type !== panel).length > 0;
}
const $a8f166db1835b456$var$blockStylingIsPresent = (state)=>{
    const { from: from, to: to } = state.selection;
    let isBlockStyling = false;
    state.doc.nodesBetween(from, to, (node)=>{
        if ((0, $h16z0.FORMATTING_NODE_TYPES).indexOf(node.type.name) !== -1) {
            isBlockStyling = true;
            return false;
        }
        return true;
    });
    return isBlockStyling;
};
const $a8f166db1835b456$var$marksArePresent = (state)=>{
    const activeMarkTypes = (0, $h16z0.FORMATTING_MARK_TYPES).filter((mark)=>{
        if (!!state.schema.marks[mark]) {
            const { $from: $from, empty: empty } = state.selection;
            const { marks: marks } = state.schema;
            if (empty) return !!marks[mark].isInSet(state.storedMarks || $from.marks());
            return (0, $02q9c.anyMarkActive)(state, marks[mark]);
        }
        return false;
    });
    return activeMarkTypes.length > 0;
};
const $a8f166db1835b456$export$4b48a1fc423972ea = (state)=>{
    return $a8f166db1835b456$var$marksArePresent(state) || $a8f166db1835b456$var$blockStylingIsPresent(state);
};
const $a8f166db1835b456$export$bce51f4ee2032263 = (dropdownOptions)=>{
    return !!dropdownOptions.find((blockType)=>blockType.name === 'blockquote');
};

});
parcelRegister("02q9c", function(module, exports) {

$parcel$export(module.exports, "anyMarkActive", () => $df38474d8872f1f5$export$3d7a3b3f27c57f56);
$parcel$export(module.exports, "wholeSelectionHasMarks", () => $df38474d8872f1f5$export$a4048c78ac7b54c8);
$parcel$export(module.exports, "isMarkAllowedInRange", () => $df38474d8872f1f5$export$22a8bb98a26ef60);
$parcel$export(module.exports, "isMarkExcluded", () => $df38474d8872f1f5$export$87b559fec4a10a1a);

var $3xw6l = parcelRequire("3xw6l");

var $cwzAY = parcelRequire("cwzAY");
const $df38474d8872f1f5$export$3d7a3b3f27c57f56 = (state, markType)=>{
    const { $from: $from, from: from, to: to, empty: empty } = state.selection;
    if (empty) return !!markType.isInSet(state.storedMarks || $from.marks());
    let rangeHasMark = false;
    if (state.selection instanceof (0, $cwzAY.CellSelection)) state.selection.forEachCell((cell, cellPos)=>{
        const from = cellPos;
        const to = cellPos + cell.nodeSize;
        if (!rangeHasMark) rangeHasMark = state.doc.rangeHasMark(from, to, markType);
    });
    else rangeHasMark = state.doc.rangeHasMark(from, to, markType);
    return rangeHasMark;
};
const $df38474d8872f1f5$var$allMarksAreRuledOut = (marks)=>Array.from(marks.values()).every((mark)=>!mark);
const $df38474d8872f1f5$export$a4048c78ac7b54c8 = (state, markTypes)=>{
    const { $from: $from, from: from, to: to, empty: empty } = state.selection;
    if (empty) return new Map(markTypes.map((markType)=>[
            markType,
            !!markType.isInSet(state.storedMarks || $from.marks())
        ]));
    if (state.selection instanceof (0, $cwzAY.CellSelection)) return $df38474d8872f1f5$var$cellSelectionHasMarks(state.doc, state.selection, markTypes);
    return $df38474d8872f1f5$var$wholeRangeHasMarks(from, to, state.doc, markTypes);
};
const $df38474d8872f1f5$var$cellSelectionHasMarks = (doc, selection, markTypes)=>{
    // Warning: This is micro-optimized and is a total pain to actually read.
    // Will attempt to explain in comments.
    // Start with map of booleans for each mark
    let cellsHaveMarks = new Map(markTypes.map((markType)=>[
            markType,
            true
        ]));
    selection.forEachCell((cell, cellPos)=>{
        // Early exit if all marks are already ruled out
        if ($df38474d8872f1f5$var$allMarksAreRuledOut(cellsHaveMarks)) return;
        const from = cellPos;
        const to = cellPos + cell.nodeSize;
        // On first cell just do a regular check
        if (!cellsHaveMarks) cellsHaveMarks = $df38474d8872f1f5$var$wholeRangeHasMarks(from, to, doc, markTypes);
        else {
            // Find the marks that are still true ie the ones that haven't been ruled out in
            // previous cells. The idea here is to whittle down the list of marks so that we check
            // less and less as we go, giving `wholeRangeHasMarks` more opportunities to exit early
            const marksToCheck = [];
            for (const [markType, hasMark] of cellsHaveMarks)if (hasMark) marksToCheck.push(markType);
            // Look specifically for the marks that are not yet ruled out.
            const cellHasMarks = $df38474d8872f1f5$var$wholeRangeHasMarks(from, to, doc, marksToCheck);
            // Map these results back into the original array of results and repeat!
            for (const [markType, hasMark] of cellHasMarks)cellsHaveMarks.set(markType, hasMark);
        }
    });
    return cellsHaveMarks;
};
const $df38474d8872f1f5$var$wholeRangeHasMarks = (from, to, doc, markTypes)=>{
    const hasMarks = new Map(markTypes.map((markType)=>[
            markType,
            true
        ]));
    doc.nodesBetween(from, to, (node)=>{
        if ($df38474d8872f1f5$var$allMarksAreRuledOut(hasMarks)) // This won't be a true early exit, but will prevent diving into nodes and
        // any checks further down the function.
        return false;
        if (!node.type.isText) return true; // continue traversing
        for (const [markType, hasMark] of hasMarks){
            if (!hasMark) continue; // already ruled out the mark, skip further checks
            const value = markType instanceof (0, $3xw6l.Mark) ? markType.isInSet(node.marks) : node.marks.some((mark)=>mark.type === markType);
            hasMarks.set(markType, value);
        }
    });
    return hasMarks;
};
const $df38474d8872f1f5$export$22a8bb98a26ef60 = (doc, ranges, type)=>{
    for(let i = 0; i < ranges.length; i++){
        const { $from: $from, $to: $to } = ranges[i];
        let can = $from.depth === 0 ? doc.type.allowsMarkType(type) : false;
        doc.nodesBetween($from.pos, $to.pos, (node)=>{
            if (can) return false;
            can = node.inlineContent && node.type.allowsMarkType(type);
            return;
        });
        if (can) return can;
    }
    return false;
};
const $df38474d8872f1f5$export$87b559fec4a10a1a = (type, marks)=>{
    if (marks) return marks.some((mark)=>mark.type !== type && mark.type.excludes(type));
    return false;
};

});



parcelRegister("5P4L6", function(module, exports) {

$parcel$export(module.exports, "default", () => $2115116b1a0d7d22$export$2e2bcd8739ae039);

var $bMFKb = parcelRequire("bMFKb");

var $6Exgk = parcelRequire("6Exgk");
var $c9NXO = parcelRequire("c9NXO");

var $HOLTj = parcelRequire("HOLTj");

var $dEkUJ = parcelRequire("dEkUJ");

var $kuxd1 = parcelRequire("kuxd1");

var $h16z0 = parcelRequire("h16z0");

var $aGH6G = parcelRequire("aGH6G");

var $5WRdy = parcelRequire("5WRdy");

var $8Pvq1 = parcelRequire("8Pvq1");

var $lRu98 = parcelRequire("lRu98");
const $2115116b1a0d7d22$var$backspaceCommand = (0, $dEkUJ.chainCommands)((0, $aGH6G.cleanUpAtTheStartOfDocument), (0, $8Pvq1.deleteBlockContent)((0, $lRu98.isNodeAWrappingBlockNode)), (0, $5WRdy.deleteAndMoveCursor));
const $2115116b1a0d7d22$var$del = (0, $dEkUJ.chainCommands)((0, $HOLTj.deleteEmptyParagraphAndMoveBlockUp)((0, $lRu98.isNodeAWrappingBlockNode)), (0, $8Pvq1.deleteBlockContent)((0, $lRu98.isNodeAWrappingBlockNode)), (0, $5WRdy.deleteAndMoveCursor));
function $2115116b1a0d7d22$export$2e2bcd8739ae039(editorAnalyticsApi, schema, _featureFlags) {
    const list = {};
    (0, $6Exgk.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $6Exgk.insertNewLine).common, (0, $HOLTj.insertNewLineWithAnalytics)(editorAnalyticsApi), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $6Exgk.bindKeymapWithCommand)((0, $6Exgk.moveUp).common, (0, $HOLTj.createNewParagraphAbove), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $6Exgk.bindKeymapWithCommand)((0, $6Exgk.moveDown).common, (0, $HOLTj.createNewParagraphBelow), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $6Exgk.bindKeymapWithCommand)((0, $6Exgk.findKeyMapForBrowser)((0, $6Exgk.redo)), (0, $kuxd1.redo), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $6Exgk.bindKeymapWithCommand)((0, $6Exgk.undo).common, (0, $kuxd1.undo), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $6Exgk.bindKeymapWithCommand)((0, $6Exgk.backspace).common, $2115116b1a0d7d22$var$backspaceCommand, list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $6Exgk.bindKeymapWithCommand)((0, $6Exgk.deleteKey).common, $2115116b1a0d7d22$var$del, list);
    (0, $6Exgk.bindKeymapWithCommand)((0, $6Exgk.forwardDelete).mac, $2115116b1a0d7d22$var$del, list);
    if (schema.nodes[$h16z0.BLOCK_QUOTE.nodeName]) (0, $6Exgk.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $6Exgk.findShortcutByKeymap)((0, $6Exgk.toggleBlockQuote)), (0, $aGH6G.insertBlockQuoteWithAnalytics)((0, $bMFKb.INPUT_METHOD).KEYBOARD, editorAnalyticsApi), list);
    return (0, $c9NXO.keymap)(list);
}

});
parcelRegister("5WRdy", function(module, exports) {

$parcel$export(module.exports, "deleteAndMoveCursor", () => $b01b354482d51f58$export$6c408f720f6b44a7);

var $3lIcL = parcelRequire("3lIcL");
// We should override default behaviour when selection spans node depths or
// ends at a node junction
const $b01b354482d51f58$var$shouldMoveCursorAfterDelete = (state)=>{
    const { selection: { $from: $from, $to: $to } } = state;
    const nodeRange = $from.blockRange($to);
    if (!nodeRange) return false;
    const hasSameAncestor = $from.depth === $to.depth && $from.depth - 1 === nodeRange.depth;
    const toPositionHasNodeAfter = !!$to.nodeAfter;
    if (hasSameAncestor || toPositionHasNodeAfter) return false;
    return true;
};
const $b01b354482d51f58$export$6c408f720f6b44a7 = (state, dispatch)=>{
    if (state.selection.empty || !(state.selection instanceof (0, $3lIcL.TextSelection))) return false;
    if (!$b01b354482d51f58$var$shouldMoveCursorAfterDelete(state)) return false;
    const { tr: tr } = state;
    tr.deleteSelection();
    // Make sure the next position is not out of boundaries
    const previousPosition = Math.min(Math.max(state.selection.$from.pos, 0), tr.doc.content.size);
    // Override default delete behaviour that moves the cursor to first suitable position after selection (postive bias).
    // See. selectionToInsertionEnd. We will override behavior with negative bias (search for suitable cursor position backwards).
    tr.setSelection((0, $3lIcL.Selection).near(tr.doc.resolve(previousPosition), -1));
    if (dispatch) dispatch(tr.scrollIntoView());
    return true;
};

});

parcelRegister("8Pvq1", function(module, exports) {

$parcel$export(module.exports, "deleteBlockContent", () => $aaf6218b92354302$export$9c1a524875bfb8ec);

var $3lIcL = parcelRequire("3lIcL");

var $BmspC = parcelRequire("BmspC");
// function to check whether the selected node is the sole decision item in the decision list
const $aaf6218b92354302$var$isSelectedNodeSoleDecisionItem = (state)=>{
    const isDecisionItemNodeSelected = state.selection instanceof (0, $3lIcL.NodeSelection) && state.selection.node.type.name === 'decisionItem';
    if (!isDecisionItemNodeSelected) return false;
    const decisionList = (0, $BmspC.findParentNodeOfType)([
        state.schema.nodes.decisionList
    ])(state.selection)?.node;
    return decisionList?.childCount === 1;
};
const $aaf6218b92354302$var$isSelectedNodeMediaGroup = (state)=>{
    return Boolean(state.selection instanceof (0, $3lIcL.NodeSelection) && state.selection.node.type.name === 'media' && state.selection.$head.parent.type.name === 'mediaGroup');
};
function $aaf6218b92354302$export$9c1a524875bfb8ec(isNodeAWrappingBlockNode) {
    return (state, dispatch)=>{
        const { tr: tr, selection: { $from: $from, $to: $to }, doc: doc } = state;
        if ($from.pos === $to.pos) return false;
        let selectionCrossesWrappingBlockNode = false;
        doc.nodesBetween($from.pos, $to.pos, (node, pos)=>{
            // Optimisation. If selection crosses wrapping block node
            // short circuit the loop by returning false
            if (isNodeAWrappingBlockNode(node)) {
                selectionCrossesWrappingBlockNode = true;
                return false;
            }
        });
        if (!selectionCrossesWrappingBlockNode) return false;
        const isParentNodeOfTypePanel = (0, $BmspC.hasParentNodeOfType)([
            state.schema.nodes.panel
        ])(state.selection);
        const isParentNodeOfTypeBlockQuote = (0, $BmspC.hasParentNodeOfType)([
            state.schema.nodes.blockquote
        ])(state.selection);
        if ((isParentNodeOfTypePanel || isParentNodeOfTypeBlockQuote) && $aaf6218b92354302$var$isSelectedNodeMediaGroup(state) || isParentNodeOfTypePanel && $aaf6218b92354302$var$isSelectedNodeSoleDecisionItem(state)) {
            tr.setSelection(new (0, $3lIcL.TextSelection)(tr.doc.resolve($from.before())));
            tr.delete($from.before(), $from.after());
        } else tr.delete($from.pos, $to.pos);
        if (dispatch) dispatch(tr);
        return true;
    };
}

});


parcelRegister("8wIsi", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $83ea502db08eb91b$export$18d4026d1ea86bb1);
$parcel$export(module.exports, "createPlugin", () => $83ea502db08eb91b$export$ae829ec7b2625219);

var $bMFKb = parcelRequire("bMFKb");

var $7EdFW = parcelRequire("7EdFW");

var $i8KtF = parcelRequire("i8KtF");

var $3lIcL = parcelRequire("3lIcL");

var $h16z0 = parcelRequire("h16z0");

var $aGH6G = parcelRequire("aGH6G");

var $jCRHz = parcelRequire("jCRHz");

var $lRu98 = parcelRequire("lRu98");
const $83ea502db08eb91b$var$blockTypeForNode = (node, schema)=>{
    if (node.type === schema.nodes.heading) {
        const maybeNode = (0, $h16z0.HEADINGS_BY_LEVEL)[node.attrs['level']];
        if (maybeNode) return maybeNode;
    } else if (node.type === schema.nodes.paragraph) return 0, $h16z0.NORMAL_TEXT;
    else if (node.type === schema.nodes.blockquote) return 0, $h16z0.BLOCK_QUOTE;
    return 0, $h16z0.OTHER;
};
const $83ea502db08eb91b$var$isBlockTypeSchemaSupported = (blockType, state)=>{
    switch(blockType){
        case 0, $h16z0.NORMAL_TEXT:
            return !!state.schema.nodes.paragraph;
        case 0, $h16z0.HEADING_1:
        case 0, $h16z0.HEADING_2:
        case 0, $h16z0.HEADING_3:
        case 0, $h16z0.HEADING_4:
        case 0, $h16z0.HEADING_5:
        case 0, $h16z0.HEADING_6:
            return !!state.schema.nodes.heading;
        case 0, $h16z0.BLOCK_QUOTE:
            return !!state.schema.nodes.blockquote;
        case 0, $h16z0.CODE_BLOCK:
            return !!state.schema.nodes.codeBlock;
        case 0, $h16z0.PANEL:
            return !!state.schema.nodes.panel;
    }
    return;
};
const $83ea502db08eb91b$var$detectBlockType = (availableBlockTypes, state)=>{
    // Before a document is loaded, there is no selection.
    if (!state.selection) return 0, $h16z0.NORMAL_TEXT;
    let blockType;
    const { $from: $from, $to: $to } = state.selection;
    state.doc.nodesBetween($from.pos, $to.pos, (node)=>{
        const nodeBlockType = availableBlockTypes.filter((blockType)=>blockType === $83ea502db08eb91b$var$blockTypeForNode(node, state.schema));
        if (nodeBlockType.length > 0) {
            if (!blockType) blockType = nodeBlockType[0];
            else if (blockType !== (0, $h16z0.OTHER) && blockType !== nodeBlockType[0]) blockType = (0, $h16z0.OTHER);
            return false;
        }
    });
    return blockType || (0, $h16z0.OTHER);
};
const $83ea502db08eb91b$var$autoformatHeading = (headingLevel, editorAnalyticsApi)=>{
    if (headingLevel === 0) return (0, $aGH6G.setNormalTextWithAnalytics)((0, $bMFKb.INPUT_METHOD).FORMATTING, editorAnalyticsApi);
    return (0, $aGH6G.setHeadingWithAnalytics)(headingLevel, (0, $bMFKb.INPUT_METHOD).FORMATTING, editorAnalyticsApi);
};
const $83ea502db08eb91b$export$18d4026d1ea86bb1 = new (0, $3lIcL.PluginKey)('blockTypePlugin');
const $83ea502db08eb91b$export$ae829ec7b2625219 = (editorAPI, // eslint-disable-next-line @typescript-eslint/no-explicit-any
dispatch, lastNodeMustBeParagraph, includeBlockQuoteAsTextstyleOption)=>{
    const editorAnalyticsApi = editorAPI?.analytics?.actions;
    let altKeyLocation = 0;
    return new (0, $i8KtF.SafePlugin)({
        appendTransaction (_transactions, _oldState, newState) {
            if (lastNodeMustBeParagraph) {
                const pos = newState.doc.resolve(newState.doc.content.size - 1);
                const lastNode = pos.node(1);
                const { paragraph: paragraph } = newState.schema.nodes;
                if (lastNode && lastNode.isBlock && lastNode.type !== paragraph) return newState.tr.insert(newState.doc.content.size, newState.schema.nodes.paragraph.create()).setMeta('addToHistory', false);
            }
        },
        state: {
            init (_config, state) {
                const availableBlockTypes = (0, $h16z0.TEXT_BLOCK_TYPES).filter((blockType)=>$83ea502db08eb91b$var$isBlockTypeSchemaSupported(blockType, state));
                const availableWrapperBlockTypes = (0, $h16z0.WRAPPER_BLOCK_TYPES).filter((blockType)=>$83ea502db08eb91b$var$isBlockTypeSchemaSupported(blockType, state));
                const BLOCK_TYPES_IN_DROPDOWN = (0, $h16z0.getBlockTypesInDropdown)(includeBlockQuoteAsTextstyleOption);
                const availableBlockTypesInDropdown = BLOCK_TYPES_IN_DROPDOWN.filter((blockType)=>$83ea502db08eb91b$var$isBlockTypeSchemaSupported(blockType, state));
                const formattingIsPresent = (0, $lRu98.hasBlockQuoteInOptions)(availableBlockTypesInDropdown) ? (0, $lRu98.checkFormattingIsPresent)(state) : undefined;
                return {
                    currentBlockType: $83ea502db08eb91b$var$detectBlockType(availableBlockTypesInDropdown, state),
                    blockTypesDisabled: (0, $lRu98.areBlockTypesDisabled)(state),
                    availableBlockTypes: availableBlockTypes,
                    availableWrapperBlockTypes: availableWrapperBlockTypes,
                    availableBlockTypesInDropdown: availableBlockTypesInDropdown,
                    formattingIsPresent: formattingIsPresent
                };
            },
            apply (_tr, oldPluginState, _oldState, newState) {
                const newPluginState = {
                    ...oldPluginState,
                    currentBlockType: $83ea502db08eb91b$var$detectBlockType(oldPluginState.availableBlockTypesInDropdown, newState),
                    blockTypesDisabled: (0, $lRu98.areBlockTypesDisabled)(newState),
                    formattingIsPresent: (0, $lRu98.hasBlockQuoteInOptions)(oldPluginState.availableBlockTypesInDropdown) ? (0, $lRu98.checkFormattingIsPresent)(newState) : undefined
                };
                if (newPluginState.currentBlockType !== oldPluginState.currentBlockType || newPluginState.blockTypesDisabled !== oldPluginState.blockTypesDisabled || newPluginState.formattingIsPresent !== oldPluginState.formattingIsPresent) dispatch($83ea502db08eb91b$export$18d4026d1ea86bb1, newPluginState);
                return newPluginState;
            }
        },
        key: $83ea502db08eb91b$export$18d4026d1ea86bb1,
        props: {
            /**
			 * As we only want the left alt key to work for headings shortcuts on Windows
			 * we can't use prosemirror-keymap and need to handle these shortcuts specially
			 * Shortcut on Mac: Cmd-Opt-{heading level}
			 * Shortcut on Windows: Ctrl-LeftAlt-{heading level}
			 */ handleKeyDown: (view, event)=>{
                const headingLevel = (0, $jCRHz.HEADING_KEYS).indexOf(event.keyCode);
                if (headingLevel > -1 && event.altKey) {
                    if ((0, $7EdFW.browser).mac && event.metaKey) return editorAPI?.core?.actions.execute($83ea502db08eb91b$var$autoformatHeading(headingLevel, editorAnalyticsApi)) ?? false;
                    else if (!(0, $7EdFW.browser).mac && event.ctrlKey && altKeyLocation !== event.DOM_KEY_LOCATION_RIGHT) return editorAPI?.core?.actions.execute($83ea502db08eb91b$var$autoformatHeading(headingLevel, editorAnalyticsApi)) ?? false;
                } else if (event.key === 'Alt') // event.location is for the current key only; when a user hits Ctrl-Alt-1 the
                // location refers to the location of the '1' key
                // We store the location of the Alt key when it is hit to check against later
                altKeyLocation = event.location;
                else if (!event.altKey) altKeyLocation = 0;
                return false;
            }
        }
    });
};

});
parcelRegister("jCRHz", function(module, exports) {

$parcel$export(module.exports, "HEADING_KEYS", () => $eef3fa157c3caefb$export$442e847723cf0569);
const $eef3fa157c3caefb$var$KEY_0 = 48;
const $eef3fa157c3caefb$var$KEY_1 = 49;
const $eef3fa157c3caefb$var$KEY_2 = 50;
const $eef3fa157c3caefb$var$KEY_3 = 51;
const $eef3fa157c3caefb$var$KEY_4 = 52;
const $eef3fa157c3caefb$var$KEY_5 = 53;
const $eef3fa157c3caefb$var$KEY_6 = 54;
const $eef3fa157c3caefb$export$442e847723cf0569 = [
    $eef3fa157c3caefb$var$KEY_0,
    $eef3fa157c3caefb$var$KEY_1,
    $eef3fa157c3caefb$var$KEY_2,
    $eef3fa157c3caefb$var$KEY_3,
    $eef3fa157c3caefb$var$KEY_4,
    $eef3fa157c3caefb$var$KEY_5,
    $eef3fa157c3caefb$var$KEY_6
];

});


parcelRegister("beO9L", function(module, exports) {

$parcel$export(module.exports, "FloatingToolbarComponent", () => $79cbb34da80cd52a$export$b15abb95157a91c7);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $bMFKb = parcelRequire("bMFKb");

var $kLQ9a = parcelRequire("kLQ9a");
var $bSToC = parcelRequire("bSToC");
var $cxXTK = parcelRequire("cxXTK");

var $92xoS = parcelRequire("92xoS");

var $dcew5 = parcelRequire("dcew5");
const $79cbb34da80cd52a$var$FloatingToolbarSettings = {
    isSmall: true,
    disabled: false,
    isToolbarReducedSpacing: true,
    shouldUseDefaultRole: false
};
const $79cbb34da80cd52a$var$useFloatingToolbarComponentPluginState = (0, $kLQ9a.sharedPluginStateHookMigratorFactory)((api)=>{
    const { currentBlockType: currentBlockType, blockTypesDisabled: blockTypesDisabled, availableBlockTypes: availableBlockTypes, availableBlockTypesInDropdown: availableBlockTypesInDropdown, formattingIsPresent: formattingIsPresent } = (0, $cxXTK.useSharedPluginStateWithSelector)(api, [
        'blockType'
    ], (states)=>({
            currentBlockType: states.blockTypeState?.currentBlockType,
            blockTypesDisabled: states.blockTypeState?.blockTypesDisabled,
            availableBlockTypes: states.blockTypeState?.availableBlockTypes,
            availableBlockTypesInDropdown: states.blockTypeState?.availableBlockTypesInDropdown,
            formattingIsPresent: states.blockTypeState?.formattingIsPresent
        }));
    return {
        currentBlockType: currentBlockType,
        blockTypesDisabled: blockTypesDisabled,
        availableBlockTypes: availableBlockTypes,
        availableBlockTypesInDropdown: availableBlockTypesInDropdown,
        formattingIsPresent: formattingIsPresent
    };
}, (api)=>{
    const { blockTypeState: blockTypeState } = (0, $bSToC.useSharedPluginState)(api, [
        'blockType'
    ]);
    return {
        currentBlockType: blockTypeState?.currentBlockType,
        blockTypesDisabled: blockTypeState?.blockTypesDisabled,
        availableBlockTypes: blockTypeState?.availableBlockTypes,
        availableBlockTypesInDropdown: blockTypeState?.availableBlockTypesInDropdown,
        formattingIsPresent: blockTypeState?.formattingIsPresent
    };
});
function $79cbb34da80cd52a$export$b15abb95157a91c7({ api: api }) {
    const { currentBlockType: currentBlockType, blockTypesDisabled: blockTypesDisabled, availableBlockTypes: availableBlockTypes, availableBlockTypesInDropdown: availableBlockTypesInDropdown, formattingIsPresent: formattingIsPresent } = $79cbb34da80cd52a$var$useFloatingToolbarComponentPluginState(api);
    const boundSetBlockType = (0, $eJOHy.useCallback)((name)=>api?.core?.actions.execute(api?.blockType?.commands?.setTextLevel(name, (0, $bMFKb.INPUT_METHOD).FLOATING_TB)), [
        api
    ]);
    const wrapBlockQuote = (0, $eJOHy.useCallback)(()=>api?.core?.actions.execute(api?.blockType?.commands?.insertBlockQuote((0, $bMFKb.INPUT_METHOD).FLOATING_TB)), [
        api
    ]);
    const clearFormatting = (0, $eJOHy.useCallback)(()=>api?.core?.actions.execute(api?.blockType?.commands?.clearFormatting((0, $bMFKb.INPUT_METHOD).FLOATING_TB)), [
        api
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dcew5.default), {
        isSmall: $79cbb34da80cd52a$var$FloatingToolbarSettings.isSmall,
        isDisabled: $79cbb34da80cd52a$var$FloatingToolbarSettings.disabled,
        isReducedSpacing: (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1') ? false : $79cbb34da80cd52a$var$FloatingToolbarSettings.isToolbarReducedSpacing,
        setTextLevel: boundSetBlockType,
        currentBlockType: currentBlockType,
        blockTypesDisabled: blockTypesDisabled,
        availableBlockTypes: availableBlockTypes,
        availableBlockTypesInDropdown: availableBlockTypesInDropdown,
        formattingIsPresent: formattingIsPresent,
        wrapBlockQuote: wrapBlockQuote,
        clearFormatting: clearFormatting,
        shouldUseDefaultRole: $79cbb34da80cd52a$var$FloatingToolbarSettings.shouldUseDefaultRole,
        api: api
    });
}

});
parcelRegister("dcew5", function(module, exports) {

$parcel$export(module.exports, "default", () => $c726f23a9024491f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $6YFG2 = parcelRequire("6YFG2");

var $6Exgk = parcelRequire("6Exgk");

var $1D5wE = parcelRequire("1D5wE");

var $fcJnk = parcelRequire("fcJnk");

var $aPcNU = parcelRequire("aPcNU");

var $7yBx7 = parcelRequire("7yBx7");

var $8hNRj = parcelRequire("8hNRj");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $92xoS = parcelRequire("92xoS");

var $7I1UL = parcelRequire("7I1UL");

var $h16z0 = parcelRequire("h16z0");

var $h5iWO = parcelRequire("h5iWO");

var $fAjN9 = parcelRequire("fAjN9");
const $c726f23a9024491f$var$buttonWrapperStyles = (0, $1DXK0.xcss)({
    flexShrink: 0
});
// eslint-disable-next-line @repo/internal/react/no-class-components
class $c726f23a9024491f$var$ToolbarBlockType extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).PureComponent {
    componentDidMount() {
        const observer = new (0, $7I1UL.default)(({ typography: typography })=>{
            if (typography !== this.state.typographyTheme) this.setState({
                typographyTheme: typography
            });
        });
        this.setState({
            observer: observer
        });
        observer.observe();
    }
    componentWillUnmount() {
        this.state.observer?.disconnect();
    }
    render() {
        const { active: active, isOpenedByKeyboard: isOpenedByKeyboard } = this.state;
        const { popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, isSmall: isSmall, isReducedSpacing: isReducedSpacing, currentBlockType: currentBlockType, blockTypesDisabled: blockTypesDisabled, availableBlockTypes: availableBlockTypes = [], availableBlockTypesInDropdown: availableBlockTypesInDropdown = [], shouldUseDefaultRole: shouldUseDefaultRole, intl: { formatMessage: formatMessage }, api: api } = this.props;
        const isHeadingDisabled = !availableBlockTypes.some((blockType)=>blockType.nodeName === 'heading');
        if (isHeadingDisabled) return null;
        const blockTypeTitles = availableBlockTypesInDropdown.filter((blockType)=>blockType.name === currentBlockType?.name).map((blockType)=>blockType.title);
        const defaultIcon = /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8hNRj))), {
            label: ""
        });
        const currentIcon = currentBlockType?.icon;
        if (!this.props.isDisabled && !blockTypesDisabled) {
            const items = this.createItems();
            const button = /*#__PURE__*/ (0, $1NIU8.jsx)((0, $h5iWO.BlockTypeButton), {
                isSmall: isSmall,
                isReducedSpacing: isReducedSpacing,
                selected: active,
                disabled: false,
                title: blockTypeTitles[0],
                onClick: this.handleTriggerClick,
                onKeyDown: this.handleTriggerByKeyboard,
                formatMessage: formatMessage,
                "aria-expanded": active,
                blockTypeName: currentBlockType?.name,
                blockTypeIcon: currentIcon || defaultIcon
            });
            return /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
                css: (0, $92xoS.editorExperiment)('platform_editor_blockquote_in_text_formatting_menu', true) ? // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                [
                    (0, $fcJnk.wrapperStyle),
                    (0, $fAjN9.floatingToolbarWrapperStyle)
                ] : // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                (0, $fcJnk.wrapperStyle)
            }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $aPcNU.DropdownMenuWithKeyboardNavigation), {
                items: items,
                onOpenChange: this.onOpenChange,
                onItemActivated: this.handleSelectBlockType,
                isOpen: active,
                mountTo: popupsMountPoint,
                boundariesElement: popupsBoundariesElement,
                scrollableElement: popupsScrollableElement,
                zIndex: (0, $7yBx7.akEditorMenuZIndex),
                fitHeight: 360,
                fitWidth: 106,
                section: {
                    hasSeparator: true
                },
                shouldUseDefaultRole: shouldUseDefaultRole,
                // hasSeparator={true}
                shouldFocusFirstItem: ()=>{
                    if (isOpenedByKeyboard) // eslint-disable-next-line @repo/internal/react/no-set-state-inside-render
                    this.setState({
                        ...this.state,
                        isOpenedByKeyboard: false
                    });
                    return isOpenedByKeyboard;
                }
            }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $8nu6j.default), {
                xcss: $c726f23a9024491f$var$buttonWrapperStyles
            }, button)), !api?.primaryToolbar && /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
                // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                css: (0, $fcJnk.separatorStyles)
            }));
        }
        return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
            css: (0, $fcJnk.wrapperStyle)
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $h5iWO.BlockTypeButton), {
            isSmall: isSmall,
            isReducedSpacing: isReducedSpacing,
            selected: active,
            disabled: true,
            title: blockTypeTitles[0],
            onClick: this.handleTriggerClick,
            onKeyDown: this.handleTriggerByKeyboard,
            formatMessage: formatMessage,
            "aria-expanded": active,
            blockTypeName: currentBlockType?.name,
            blockTypeIcon: currentIcon || defaultIcon
        }), !api?.primaryToolbar && /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            css: (0, $fcJnk.separatorStyles)
        })));
    }
    constructor(...args){
        super(...args), this.state = {
            active: false,
            isOpenedByKeyboard: false,
            typographyTheme: undefined,
            observer: null
        }, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onOpenChange = (attrs)=>{
            this.setState({
                ...this.state,
                active: attrs.isOpen,
                isOpenedByKeyboard: attrs.isOpenedByKeyboard
            });
        }, this.handleTriggerClick = ()=>{
            this.onOpenChange({
                isOpen: !this.state.active,
                isOpenedByKeyboard: false
            });
        }, this.handleTriggerByKeyboard = (event)=>{
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                this.onOpenChange({
                    isOpen: !this.state.active,
                    isOpenedByKeyboard: true
                });
            }
        }, this.createItems = ()=>{
            const { intl: { formatMessage: formatMessage }, currentBlockType: currentBlockType, availableBlockTypesInDropdown: availableBlockTypesInDropdown, formattingIsPresent: formattingIsPresent } = this.props;
            const items = (availableBlockTypesInDropdown ?? []).map((blockType, index)=>{
                const isActive = currentBlockType === blockType;
                const tagName = blockType.tagName || 'p';
                const Tag = tagName;
                const defaultMessage = Array.isArray(blockType.title.defaultMessage) ? blockType.title.defaultMessage.find((message)=>'value' in message) : blockType.title.defaultMessage;
                const description = typeof defaultMessage === 'string' ? defaultMessage : defaultMessage && 'value' in defaultMessage ? defaultMessage.value : '';
                const keyMap = (0, $6Exgk.findKeymapByDescription)(description);
                const icon = blockType?.icon;
                const item = {
                    content: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
                        css: (0, $fAjN9.blockTypeMenuItemStyle)(tagName, isActive, this.state.typographyTheme)
                    }, /*#__PURE__*/ (0, $1NIU8.jsx)(Tag, null, formatMessage(blockType.title))),
                    value: blockType,
                    'aria-label': (0, $6Exgk.tooltip)(keyMap, formatMessage(blockType.title)),
                    key: `${blockType.name}-${index}`,
                    elemBefore: (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1') ? icon : undefined,
                    elemAfter: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
                        css: [
                            (0, $fAjN9.keyboardShortcut),
                            isActive && (0, $fAjN9.keyboardShortcutSelect)
                        ]
                    }, (0, $6Exgk.tooltip)(keyMap)),
                    isActive: isActive
                };
                return item;
            });
            if ((availableBlockTypesInDropdown ?? []).map((blockType)=>blockType.name).includes('blockquote') && (0, $92xoS.editorExperiment)('platform_editor_controls', 'control')) {
                const clearFormattingItem = {
                    content: /*#__PURE__*/ (0, $1NIU8.jsx)("div", null, /*#__PURE__*/ (0, $1NIU8.jsx)("p", null, (0, $1D5wE.toolbarMessages).clearFormatting.defaultMessage)),
                    value: {
                        name: 'clearFormatting'
                    },
                    'aria-label': (0, $6Exgk.tooltip)((0, $6Exgk.clearFormatting), (0, $1D5wE.toolbarMessages).clearFormatting.defaultMessage),
                    key: 'clear-formatting',
                    elemAfter: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
                        css: [
                            (0, $fAjN9.keyboardShortcut)
                        ]
                    }, (0, $6Exgk.tooltip)((0, $6Exgk.clearFormatting))),
                    isActive: false,
                    isDisabled: currentBlockType === (0, $h16z0.NORMAL_TEXT) && !formattingIsPresent
                };
                return [
                    {
                        items: items
                    },
                    {
                        items: [
                            clearFormattingItem
                        ]
                    }
                ];
            }
            return [
                {
                    items: items
                }
            ];
        }, this.handleSelectBlockType = ({ item: item, shouldCloseMenu: shouldCloseMenu = true })=>{
            const blockType = item.value;
            if (blockType.name === 'blockquote') this.props.wrapBlockQuote(blockType.name);
            else if (blockType.name === 'clearFormatting') this.props.clearFormatting();
            else {
                const fromBlockQuote = this.props.currentBlockType?.name === 'blockquote';
                this.props.setTextLevel(blockType.name, fromBlockQuote);
            }
            if (shouldCloseMenu) this.setState({
                ...this.state,
                active: false
            });
        };
    }
}
var $c726f23a9024491f$export$2e2bcd8739ae039 = (0, $6YFG2.default)($c726f23a9024491f$var$ToolbarBlockType);

});
parcelRegister("fcJnk", function(module, exports) {

$parcel$export(module.exports, "buttonGroupStyleBeforeVisualRefresh", () => $0e5673ef90675e29$export$7638a34f4ed2b514);
$parcel$export(module.exports, "buttonGroupStyle", () => $0e5673ef90675e29$export$5897f954e99cc6c0);
$parcel$export(module.exports, "separatorStyles", () => $0e5673ef90675e29$export$39b9f83b35c7456d);
$parcel$export(module.exports, "wrapperStyle", () => $0e5673ef90675e29$export$c4d4f06a25de97f);
$parcel$export(module.exports, "triggerWrapperStyles", () => $0e5673ef90675e29$export$147e2cce6f264c9b);
$parcel$export(module.exports, "triggerWrapperStylesWithPadding", () => $0e5673ef90675e29$export$f2c6a721c78d3c4a);
$parcel$export(module.exports, "disableBlueBorderStyles", () => $0e5673ef90675e29$export$cd86615b96818354);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");
function $0e5673ef90675e29$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0e5673ef90675e29$export$7638a34f4ed2b514 = {
    name: "ewpfso",
    styles: "display:inline-flex;align-items:center;& > div{display:flex;}button:not(#local-media-upload-button){&:not([disabled])::after{border:none;}}"
};
const $0e5673ef90675e29$export$5897f954e99cc6c0 = {
    name: "ioewc",
    styles: "display:inline-flex;align-items:center;& > div{display:flex;}button:not(#local-media-upload-button){&:not([disabled])::after{border:none;}}gap:var(--ds-space-050, 4px);div[role=group]{gap:var(--ds-space-050, 4px);}"
};
const $0e5673ef90675e29$export$39b9f83b35c7456d = /*#__PURE__*/ (0, $1NIU8.css)({
    background: "var(--ds-border, #091E4224)",
    width: '1px',
    height: '24px',
    display: 'inline-block',
    margin: `0 ${"var(--ds-space-100, 8px)"}`,
    userSelect: 'none'
});
const $0e5673ef90675e29$export$c4d4f06a25de97f = {
    name: "1ty89h5",
    styles: "display:flex;align-items:center;> div, > span{display:flex;}> div > div{display:flex;}margin-left:0;min-width:auto;button{&:not([disabled])::after{border:none;}}"
};
const $0e5673ef90675e29$export$147e2cce6f264c9b = {
    name: "wb8qky",
    styles: "display:flex;button{&:not([disabled])::after{border:none;}}"
};
const $0e5673ef90675e29$export$f2c6a721c78d3c4a = {
    name: "4sd07o",
    styles: "display:flex;padding-right:var(--ds-space-025, 2px);button{&:not([disabled])::after{border:none;}}"
};
const $0e5673ef90675e29$export$cd86615b96818354 = {
    name: "ox0lz7",
    styles: "&:not([disabled])::after{border:none;}"
};

});

parcelRegister("aPcNU", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c31c18ac311bc9c$export$2e2bcd8739ae039);
$parcel$export(module.exports, "DropdownMenuItem", () => $9c31c18ac311bc9c$export$ed97964d1871885d);
$parcel$export(module.exports, "DropdownMenuWithKeyboardNavigation", () => $9c31c18ac311bc9c$export$9e0cd5a62a7d99cf);
/* eslint-disable @repo/internal/react/no-class-components */ /**
                                                               * @jsxRuntime classic
                                                               * @jsx jsx
                                                               */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $7yBx7 = parcelRequire("7yBx7");

var $1PYwQ = parcelRequire("1PYwQ");
var $jUgeq = parcelRequire("jUgeq");
var $6YEko = parcelRequire("6YEko");

var $92xoS = parcelRequire("92xoS");

var $k71qx = parcelRequire("k71qx");

var $4utXL = parcelRequire("4utXL");

var $baHgw = parcelRequire("baHgw");

var $dcudV = parcelRequire("dcudV");

var $jRVxI = parcelRequire("jRVxI");

var $avm98 = parcelRequire("avm98");

var $aYKcT = parcelRequire("aYKcT");

var $UpZp1 = parcelRequire("UpZp1");
function $9c31c18ac311bc9c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $9c31c18ac311bc9c$var$wrapper = {
    name: "ul2689",
    styles: "& > div > div{display:flex;}"
};
const $9c31c18ac311bc9c$var$focusedMenuItemStyle = /*#__PURE__*/ (0, $1NIU8.css)({
    boxShadow: `inset 0px 0px 0px 2px ${"var(--ds-border-focused, #388BFF)"}`,
    outline: 'none'
});
const $9c31c18ac311bc9c$var$buttonStyles = (isActive, submenuActive)=>{
    if (isActive) {
        if ((0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1')) /**
       * Hack for item to imitate old dropdown-menu selected styles
       */ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
        return /*#__PURE__*/ (0, $1NIU8.css)("position:relative;&::before{display:block;height:100%;width:2px;position:absolute;left:0;top:0;background:var(--ds-border-selected, transparent);content:'';}>span,>span:hover,>span:active{background:var(--ds-background-selected, #6c798f);color:var(--ds-text-selected, #0C66E4);}:focus>span[aria-disabled='false']{", $9c31c18ac311bc9c$var$focusedMenuItemStyle, ";}:focus-visible,:focus-visible>span[aria-disabled='false']{outline:none;}");
        /**
     * Hack for item to imitate old dropdown-menu selected styles
     */ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
        return /*#__PURE__*/ (0, $1NIU8.css)(">span,>span:hover,>span:active{background:var(--ds-background-selected, #6c798f);color:var(--ds-text-selected, #0C66E4);}:focus>span[aria-disabled='false']{", $9c31c18ac311bc9c$var$focusedMenuItemStyle, ";}:focus-visible,:focus-visible>span[aria-disabled='false']{outline:none;}");
    } else // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    return /*#__PURE__*/ (0, $1NIU8.css)(">span:hover[aria-disabled='false']{color:var(--ds-text, #172B4D);background-color:var(--ds-background-neutral-subtle-hovered, rgb(244, 245, 247));}", !submenuActive && `
					> span:active[aria-disabled='false'] {
						background-color: ${"var(--ds-background-neutral-subtle-pressed, rgb(179, 212, 255))"};
					}`, ">span[aria-disabled='true']{color:var(--ds-text-disabled, #091E424F);}:focus>span[aria-disabled='false']{", $9c31c18ac311bc9c$var$focusedMenuItemStyle, ";}:focus-visible,:focus-visible>span[aria-disabled='false']{outline:none;}"); // The default focus-visible style is removed to ensure consistency across browsers
};
const $9c31c18ac311bc9c$var$DropListWithOutsideClickTargetRef = (props)=>{
    const setOutsideClickTargetRef = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useContext((0, $dcudV.OutsideClickTargetRefContext));
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $jRVxI.default), {
        onDroplistRef: setOutsideClickTargetRef,
        ...props
    });
};
const $9c31c18ac311bc9c$var$DropListWithOutsideListeners = (0, $dcudV.default)($9c31c18ac311bc9c$var$DropListWithOutsideClickTargetRef);
class $9c31c18ac311bc9c$export$2e2bcd8739ae039 extends (0, $eJOHy.PureComponent) {
    renderDropdownMenu() {
        const { target: target, popupPlacement: popupPlacement } = this.state;
        const { items: items, mountTo: mountTo, boundariesElement: boundariesElement, scrollableElement: scrollableElement, offset: offset, fitHeight: fitHeight, fitWidth: fitWidth, isOpen: isOpen, zIndex: zIndex, shouldUseDefaultRole: shouldUseDefaultRole, onItemActivated: onItemActivated, arrowKeyNavigationProviderOptions: arrowKeyNavigationProviderOptions, section: section, allowEnterDefaultBehavior: allowEnterDefaultBehavior, handleEscapeKeydown: handleEscapeKeydown } = this.props;
        // Note that this onSelection function can't be refactored to useMemo for
        // performance gains as it is being used as a dependency in a useEffect in
        // MenuArrowKeyNavigationProvider in order to check for re-renders to adjust
        // focus for accessibility. If this needs to be refactored in future refer
        // back to ED-16740 for context.
        const navigationProviderProps = arrowKeyNavigationProviderOptions.type === (0, $UpZp1.ArrowKeyNavigationType).COLOR ? arrowKeyNavigationProviderOptions : {
            ...arrowKeyNavigationProviderOptions,
            onSelection: (index)=>{
                let result = [];
                if (typeof onItemActivated === 'function') {
                    result = items.reduce((result, group)=>{
                        return result.concat(group.items);
                    }, result);
                    onItemActivated({
                        item: result[index],
                        shouldCloseMenu: false
                    });
                }
            }
        };
        return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $avm98.default), {
            target: isOpen ? target : undefined,
            mountTo: mountTo,
            boundariesElement: boundariesElement,
            scrollableElement: scrollableElement,
            onPlacementChanged: this.updatePopupPlacement,
            fitHeight: fitHeight,
            fitWidth: fitWidth,
            zIndex: zIndex || (0, $7yBx7.akEditorFloatingPanelZIndex),
            offset: offset
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $aYKcT.ArrowKeyNavigationProvider), {
            ...navigationProviderProps,
            handleClose: this.handleCloseAndFocus,
            closeOnTab: true
        }, /*#__PURE__*/ (0, $1NIU8.jsx)($9c31c18ac311bc9c$var$DropListWithOutsideListeners, {
            isOpen: true,
            position: popupPlacement.join(' '),
            shouldFitContainer: true,
            handleClickOutside: this.handleClose,
            handleEscapeKeydown: handleEscapeKeydown || this.handleCloseAndFocus,
            handleEnterKeydown: (e)=>{
                if (!allowEnterDefaultBehavior) e.preventDefault();
                e.stopPropagation();
            },
            targetRef: this.state.target
        }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            style: {
                height: 0,
                minWidth: fitWidth || 0
            }
        }), /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            ref: this.popupRef
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $jUgeq.default), {
            role: shouldUseDefaultRole ? 'group' : 'menu'
        }, items.map((group, index)=>/*#__PURE__*/ (0, $1NIU8.jsx)((0, $6YEko.default), {
                hasSeparator: section?.hasSeparator && index > 0,
                title: section?.title,
                // Ignored via go/ees005
                // eslint-disable-next-line react/no-array-index-key
                key: index
            }, group.items.map((item)=>/*#__PURE__*/ (0, $1NIU8.jsx)($9c31c18ac311bc9c$export$ed97964d1871885d, {
                    key: item.key ?? String(item.content),
                    item: item,
                    onItemActivated: this.props.onItemActivated,
                    shouldUseDefaultRole: this.props.shouldUseDefaultRole,
                    onMouseEnter: this.props.onMouseEnter,
                    onMouseLeave: this.props.onMouseLeave
                })))))))));
    }
    render() {
        const { children: children, isOpen: isOpen } = this.props;
        return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            css: $9c31c18ac311bc9c$var$wrapper
        }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            ref: this.handleRef
        }, children), isOpen ? this.renderDropdownMenu() : null);
    }
    componentDidUpdate(previousProps) {
        const { mountTo: mountTo, isOpen: isOpen } = this.props;
        const isOpenToggled = isOpen !== previousProps.isOpen;
        if (isOpen && isOpenToggled) {
            if (typeof this.props.shouldFocusFirstItem === 'function' && this.props.shouldFocusFirstItem()) {
                const keyboardEvent = new KeyboardEvent('keydown', {
                    key: 'ArrowDown',
                    bubbles: true
                });
                if (mountTo) {
                    mountTo.dispatchEvent(keyboardEvent);
                    return;
                }
                this.state.target?.dispatchEvent(keyboardEvent);
            }
        }
    }
    constructor(...args){
        super(...args), this.state = {
            popupPlacement: [
                'bottom',
                'left'
            ],
            selectionIndex: -1
        }, this.popupRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createRef(), this.handleRef = (target)=>{
            this.setState({
                target: target || undefined
            });
        }, this.updatePopupPlacement = (placement)=>{
            const { popupPlacement: previousPlacement } = this.state;
            if (placement[0] !== previousPlacement[0] || placement[1] !== previousPlacement[1]) this.setState({
                popupPlacement: placement
            });
        }, this.handleCloseAndFocus = (event)=>{
            this.state.target?.querySelector('button')?.focus();
            this.handleClose(event);
        }, this.handleClose = (event)=>{
            const { onOpenChange: onOpenChange } = this.props;
            if (onOpenChange) onOpenChange({
                isOpen: false,
                event: event
            });
        };
    }
}
const $9c31c18ac311bc9c$var$DropdownMenuItemCustomComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef((props, ref)=>{
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        ref: ref,
        ...rest,
        style: {
            // This forces the item container back to be `position: static`, the default value.
            // This ensures the custom nested menu for table color picker still works as now
            // menu items from @atlaskit/menu all have `position: relative` set for the selected borders.
            // The current implementation unfortunately is very brittle. Design System Team will
            // be prioritizing official support for accessible nested menus that we want you to move
            // to in the future.
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'static'
        }
    }, children);
});
function $9c31c18ac311bc9c$export$ed97964d1871885d({ item: item, onItemActivated: onItemActivated, shouldUseDefaultRole: shouldUseDefaultRole, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave }) {
    const [submenuActive, setSubmenuActive] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState(false);
    // onClick and value.name are the action indicators in the handlers
    // If neither are present, don't wrap in an Item.
    if (!item.onClick && !(item.value && item.value.name)) return /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        key: String(item.content)
    }, item.content);
    const _handleSubmenuActive = (event)=>{
        setSubmenuActive(Boolean(event.target instanceof HTMLElement && event.target.closest(`.${(0, $4utXL.DropdownMenuSharedCssClassName).SUBMENU}`)));
    };
    const ariaLabel = item['aria-label'] === '' ? undefined : item['aria-label'] || String(item.content);
    const testId = item['data-testid'] || `dropdown-item__${item.content}`;
    // From time to time we don't want to have any tabIndex on item wrapper
    // especially when we pass any interactive element as a item.content
    const tabIndex = item.wrapperTabIndex === null ? undefined : item.wrapperTabIndex || -1;
    const dropListItem = // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: ()=>$9c31c18ac311bc9c$var$buttonStyles(item.isActive, submenuActive),
        tabIndex: tabIndex,
        "aria-disabled": item.isDisabled ? 'true' : 'false',
        onMouseDown: _handleSubmenuActive
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $1PYwQ.default), {
        item: item,
        key: item.key ?? String(item.content),
        testId: testId,
        role: shouldUseDefaultRole ? 'button' : 'menuitem',
        iconBefore: item.elemBefore,
        iconAfter: item.elemAfter,
        isDisabled: item.isDisabled,
        onClick: ()=>onItemActivated && onItemActivated({
                item: item
            }),
        "aria-label": ariaLabel,
        "aria-pressed": shouldUseDefaultRole ? item.isActive : undefined,
        "aria-keyshortcuts": item['aria-keyshortcuts'],
        onMouseDown: (e)=>{
            e.preventDefault();
        },
        component: $9c31c18ac311bc9c$var$DropdownMenuItemCustomComponent,
        onMouseEnter: ()=>onMouseEnter && onMouseEnter({
                item: item
            }),
        onMouseLeave: ()=>onMouseLeave && onMouseLeave({
                item: item
            }),
        "aria-expanded": item['aria-expanded']
    }, item.content));
    if (item.tooltipDescription) return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $k71qx.default), {
        key: item.key ?? String(item.content),
        content: item.tooltipDescription,
        position: item.tooltipPosition
    }, dropListItem);
    return dropListItem;
}
const $9c31c18ac311bc9c$export$9e0cd5a62a7d99cf = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
({ ...props })=>{
    const keyDownHandlerContext = (0, $eJOHy.useContext)((0, $baHgw.KeyDownHandlerContext));
    // This context is to handle the tab, Arrow Right/Left key events for dropdown.
    // Default context has the void callbacks for above key events
    return /*#__PURE__*/ (0, $1NIU8.jsx)($9c31c18ac311bc9c$export$2e2bcd8739ae039, {
        arrowKeyNavigationProviderOptions: {
            ...props.arrowKeyNavigationProviderOptions,
            keyDownHandlerContext: keyDownHandlerContext
        },
        ...props
    });
});

});
parcelRegister("4utXL", function(module, exports) {

$parcel$export(module.exports, "DropdownMenuSharedCssClassName", () => $ed9f3a9be6d32c7b$export$94c0f60c32e7bd13);
const $ed9f3a9be6d32c7b$export$15eb942addb87cf6 = 'pm-dropdown';
const $ed9f3a9be6d32c7b$export$94c0f60c32e7bd13 = {
    SUBMENU: `${$ed9f3a9be6d32c7b$export$15eb942addb87cf6}-submenu`
};

});

parcelRegister("dcudV", function(module, exports) {

$parcel$export(module.exports, "OutsideClickTargetRefContext", () => $c3af1bbc3f53da0d$export$798d66d2e25c3c95);
$parcel$export(module.exports, "default", () => $c3af1bbc3f53da0d$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $92xoS = parcelRequire("92xoS");

var $g9imq = parcelRequire("g9imq");
const $c3af1bbc3f53da0d$export$798d66d2e25c3c95 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext(()=>Object);
// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
class $c3af1bbc3f53da0d$var$WithOutsideClick extends (0, $eJOHy.PureComponent) {
    componentDidMount() {
        if (this.props.handleClickOutside) {
            const options = this.props.captureClick && (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1') ? {
                capture: true
            } : false;
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('click', this.handleClick, options);
        }
        if (this.props.handleEscapeKeydown) // Attached event to the menu so that 'ESC' events from the opened menu also will be handled.
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        (this.props.popupsMountPoint ? this.props.popupsMountPoint : this.props.editorRef?.current || this.props.targetRef || document)// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .addEventListener('keydown', this.handleKeydown, false);
    }
    componentWillUnmount() {
        if (this.props.handleClickOutside) {
            const options = this.props.captureClick && (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1') ? {
                capture: true
            } : false;
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('click', this.handleClick, options);
        }
        if (this.props.handleEscapeKeydown) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        (this.props.popupsMountPoint ? this.props.popupsMountPoint : this.props.editorRef?.current || this.props.targetRef || document)// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .removeEventListener('keydown', this.handleKeydown, false);
    }
    render() {
        return this.props.children;
    }
    constructor(...args){
        super(...args), this.handleClick = (evt)=>{
            if (!this.props.isActiveComponent || !this.props.handleClickOutside) return;
            const domNode = this.props.outsideClickTargetRef.current?.deref();
            if (!domNode || evt.target instanceof Node && !domNode.contains(evt.target)) {
                this.props.handleClickOutside(evt);
                // When the menus are closed by clicking outside the focus is set on editor.
                if (!this.props.editorView?.hasFocus()) this.props.editorView?.focus();
            }
        }, this.handleKeydown = (evt)=>{
            if (!this.props.isActiveComponent) return;
            if (evt.code === 'Escape' && this.props.handleEscapeKeydown) {
                evt.preventDefault();
                evt.stopPropagation();
                this.props.handleEscapeKeydown(evt);
                // on 'Esc', Focus is handled in 'handleEscapeKeydown'.
                return false;
            } else if (evt.code === 'Enter' && this.props.handleEnterKeydown) this.props.handleEnterKeydown(evt);
            else if (evt.code === 'Tab' && this.props.handleEscapeKeydown && this.props.closeOnTab) // The menus should be closed when the tab is pressed as it takes the focus out of the menu
            this.props.handleEscapeKeydown(evt);
        };
    }
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $c3af1bbc3f53da0d$var$hasIsOpen(props) {
    return 'isOpen' in props;
}
function $c3af1bbc3f53da0d$export$2e2bcd8739ae039(Component) {
    return ({ handleClickOutside: handleClickOutside, handleEnterKeydown: handleEnterKeydown, handleEscapeKeydown: handleEscapeKeydown, closeOnTab: closeOnTab, captureClick: captureClick, ...props })=>{
        const isActiveProp = $c3af1bbc3f53da0d$var$hasIsOpen(props) ? props.isOpen : true;
        const [isActiveComponent, setActiveComponent] = (0, $eJOHy.useState)(false);
        const outsideClickTargetRef = (0, $eJOHy.useRef)(null);
        const setOutsideClickTargetRef = (0, $eJOHy.useCallback)((el)=>{
            outsideClickTargetRef.current = el && new WeakRef(el);
        }, [
            outsideClickTargetRef
        ]);
        (0, $eJOHy.useEffect)(()=>{
            requestAnimationFrame(()=>{
                setActiveComponent(isActiveProp);
            });
        }, [
            isActiveProp
        ]);
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $g9imq.default).Consumer, {
            children: ({ editorView: editorView, popupsMountPoint: popupsMountPoint, editorRef: editorRef })=>/*#__PURE__*/ (0, $gt9Am.jsx)($c3af1bbc3f53da0d$export$798d66d2e25c3c95.Provider, {
                    value: setOutsideClickTargetRef,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)($c3af1bbc3f53da0d$var$WithOutsideClick, {
                        editorView: editorView,
                        editorRef: editorRef,
                        targetRef: props.targetRef,
                        outsideClickTargetRef: outsideClickTargetRef,
                        popupsMountPoint: popupsMountPoint,
                        isActiveComponent: isActiveComponent,
                        handleClickOutside: handleClickOutside,
                        handleEnterKeydown: handleEnterKeydown,
                        handleEscapeKeydown: handleEscapeKeydown,
                        closeOnTab: closeOnTab,
                        captureClick: captureClick,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
                            ...props
                        })
                    })
                })
        });
    };
}

});

parcelRegister("jRVxI", function(module, exports) {

$parcel$export(module.exports, "default", () => $07f9a8a894fda9b5$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $5fWw9 = parcelRequire("5fWw9");

var $dUaMU = parcelRequire("dUaMU");

var $4J0ad = parcelRequire("4J0ad");

var $bPL67 = parcelRequire("bPL67");
const $07f9a8a894fda9b5$var$packageName = "platform-pkg";
const $07f9a8a894fda9b5$var$packageVersion = "0.0.0-use.local";
const $07f9a8a894fda9b5$var$halfFocusRing = 1;
const $07f9a8a894fda9b5$var$dropOffset = '0, 8';
// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
class $07f9a8a894fda9b5$var$DropList extends (0, $eJOHy.Component) {
    render() {
        const { children: children, isOpen: isOpen, position: position, trigger: trigger, onPositioned: onPositioned, testId: testId, id: id } = this.props;
        const layerContent = isOpen ? /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            css: this.menuWrapper,
            "data-role": "droplistContent",
            "data-testid": testId && `${testId}--content`,
            ref: this.handleContentRef,
            id: id,
            role: "presentation"
        }, children) : null;
        return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            css: this.wrapperStyles,
            ref: this.handleDroplistRef
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $bPL67.default), {
            content: layerContent,
            offset: $07f9a8a894fda9b5$var$dropOffset,
            position: position,
            onPositioned: onPositioned
        }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            css: this.triggerStyles,
            ref: this.handleTriggerRef
        }, trigger)));
    }
    constructor(...args){
        super(...args), this.wrapperStyles = /*#__PURE__*/ (0, $1NIU8.css)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            display: this.props.shouldFitContainer ? 'block' : 'inline-flex',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            flex: this.props.shouldFitContainer ? '1 1 auto' : undefined,
            transitionDuration: '0.2s',
            transition: 'box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)'
        }), this.triggerStyles = /*#__PURE__*/ (0, $1NIU8.css)({
            transitionDuration: '0.2s',
            transition: 'box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            display: this.props.shouldFitContainer ? 'block' : 'inline-flex',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            boxSizing: this.props.shouldFitContainer ? 'border-box' : undefined
        }), /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ this.menuWrapper = ()=>{
            return /*#__PURE__*/ (0, $1NIU8.css)({
                color: "var(--ds-text-subtle, #44546F)",
                backgroundColor: "var(--ds-surface-overlay, #FFFFFF)",
                borderRadius: "var(--ds-border-radius, 3px)",
                boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #091E4226, 0px 0px 1px #091E424f)",
                boxSizing: 'border-box',
                overflow: 'auto',
                padding: `${"var(--ds-space-050, 4px)"} 0`,
                maxHeight: '90vh'
            });
        }, /* eslint-enable @atlaskit/design-system/ensure-design-token-usage */ this.componentDidMount = ()=>{
            this.setContentWidth();
            // We use a captured event here to avoid a radio or checkbox dropdown item firing its
            // click event first, which would cause a re-render of the element and prevent DropList
            // from detecting the actual source of this original click event.
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('click', this.handleClickOutside, true);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('keydown', this.handleEsc);
        }, this.componentDidUpdate = ()=>{
            if (this.props.isOpen) this.setContentWidth();
        }, this.componentWillUnmount = ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('click', this.handleClickOutside, true);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('keydown', this.handleEsc);
        }, this.setContentWidth = ()=>{
            const { dropContentRef: dropContentRef, triggerRef: triggerRef } = this;
            const { shouldFitContainer: shouldFitContainer } = this.props;
            // We need to manually set the content width to match the trigger width
            if (shouldFitContainer && dropContentRef && triggerRef) dropContentRef.style.width = `${triggerRef.offsetWidth - $07f9a8a894fda9b5$var$halfFocusRing * 2}px`;
        }, this.handleEsc = (event)=>{
            if ((event.key === 'Escape' || event.key === 'Esc') && this.props.isOpen) this.close(event);
        }, this.handleClickOutside = (event)=>{
            if (this.props.isOpen) {
                if (event.target instanceof Node) {
                    // Rather than check for the target within the entire DropList, we specify the trigger/content.
                    // This aids with future effort in scroll-locking DropList when isMenuFixed is enabled; the scroll
                    // blanket which stretches to the viewport should not stop 'close' from being triggered.
                    const withinTrigger = this.triggerRef && this.triggerRef.contains(event.target);
                    const withinContent = this.dropContentRef && this.dropContentRef.contains(event.target);
                    if (!withinTrigger && !withinContent) this.close(event);
                }
            }
        }, this.close = (event)=>{
            if (this.props.onOpenChange) this.props.onOpenChange({
                isOpen: false,
                event: event
            });
        }, this.handleContentRef = (ref)=>{
            this.dropContentRef = ref;
            // If the dropdown has just been opened, we focus on the containing element so the
            // user can tab to the first dropdown item. We will only receive this ref if isOpen
            // is true or null, so no need to check for truthiness here.
            if (ref) ref.focus();
        }, this.handleDroplistRef = (ref)=>{
            this.props.onDroplistRef?.(ref);
        }, this.handleTriggerRef = (ref)=>{
            this.triggerRef = ref;
        };
    }
}
const $07f9a8a894fda9b5$var$createAndFireEventOnAtlaskit = (0, $5fWw9.default)('atlaskit');
var $07f9a8a894fda9b5$export$2e2bcd8739ae039 = (0, $dUaMU.default)({
    componentName: 'droplist',
    packageName: $07f9a8a894fda9b5$var$packageName,
    packageVersion: $07f9a8a894fda9b5$var$packageVersion
})((0, $4J0ad.default)({
    onOpenChange: $07f9a8a894fda9b5$var$createAndFireEventOnAtlaskit({
        action: 'toggled',
        actionSubject: 'droplist',
        attributes: {
            componentName: 'droplist',
            packageName: $07f9a8a894fda9b5$var$packageName,
            packageVersion: $07f9a8a894fda9b5$var$packageVersion
        }
    })
})($07f9a8a894fda9b5$var$DropList));

});
parcelRegister("bPL67", function(module, exports) {

$parcel$export(module.exports, "default", () => $28d4ef08a9ff10dc$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hUhgh = parcelRequire("hUhgh");

var $bRPNB = parcelRequire("bRPNB");

var $jIGfZ = parcelRequire("jIGfZ");
const $28d4ef08a9ff10dc$var$defaultState = {
    hasExtractedStyles: false,
    // We set these default offsets to prevent a flash of popper content in the wrong position
    // which can cause incorrect height calculations. Popper will calculate these values
    offsets: {
        popper: {
            left: -9999,
            top: -9999,
            position: null
        }
    },
    cssPosition: 'absolute',
    originalHeight: null,
    maxHeight: null
};
class $28d4ef08a9ff10dc$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    static{
        // working with extract-react-types
        this.defaultProps = {
            boundariesElement: 'viewport',
            children: null,
            content: null,
            offset: '0, 0',
            position: 'right middle',
            zIndex: 400,
            lockScroll: false,
            isAlwaysFixed: false,
            onPositioned: ()=>{}
        };
    }
    constructor(props){
        super(props), this.targetRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createRef(), this.contentRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createRef(), this.extractStyles = (state)=>{
            if (state) {
                const popperHeight = state.offsets.popper.height;
                const left = Math.round(state.offsets.popper.left);
                const top = Math.round(state.offsets.popper.top);
                const cssPosition = 'absolute';
                const originalHeight = this.state.originalHeight || popperHeight;
                const maxHeight = this.calculateMaxHeight(originalHeight, popperHeight, top, cssPosition);
                this.setState({
                    cssPosition: // position: fixed or absolute
                    cssPosition,
                    hasExtractedStyles: true,
                    transform: `translate3d(${left}px, ${top}px, 0px)`,
                    originalHeight: originalHeight,
                    maxHeight: maxHeight
                });
            }
        };
        this.state = $28d4ef08a9ff10dc$var$defaultState;
        this.extractStyles = (0, $bRPNB.default)(this.extractStyles.bind(this));
    }
    componentDidMount() {
        this.applyPopper(this.props);
    }
    componentDidUpdate(prevProps, prevState) {
        const { onPositioned: onPositioned } = this.props;
        const { hasExtractedStyles: hasExtractedStyles } = this.state;
        if (this.props !== prevProps) this.applyPopper(this.props);
        // This flag is set the first time the position is calculated from Popper and applied to the content
        if (!prevState.hasExtractedStyles && hasExtractedStyles && onPositioned) onPositioned();
    }
    componentWillUnmount() {
        // this.extractStyles.cancel();
        if (this.popper) this.popper.destroy();
    }
    /* Calculate the max height of the popper if it's height is greater than the viewport to prevent
	 * the bottom of the popper not being viewable.
	 * Only works if the popper uses viewport as the boundary and has a fixed position ancestor.
	 */ calculateMaxHeight(originalHeight, currentHeight, positionTop, cssPosition) {
        let DocumentElementClientHeight = 0;
        if (document.documentElement) DocumentElementClientHeight = document.documentElement.clientHeight;
        if (cssPosition !== 'fixed') return null;
        const viewportHeight = Math.max(DocumentElementClientHeight, window.innerHeight || 0);
        return viewportHeight < originalHeight && currentHeight + positionTop >= viewportHeight - 50 ? viewportHeight - 12 : null;
    }
    applyPopper(props) {
        if (!this.targetRef.current || !this.contentRef.current) return;
        if (this.popper) this.popper.destroy();
        // "new Popper(...)" operation is very expensive when called on virtual DOM.
        // This condition reduces the number of calls so we can run our tests faster
        // (time was reduced from 100s to 13s).
        if (!props.content) return;
        // we wrap our target in a div so that we can safely get a reference to it, but we pass the
        // actual target to popper
        const isAlwaysFixed = false;
        const actualTarget = this.targetRef.current.children[0];
        const popperOpts = {
            placement: (0, $jIGfZ.positionPropToPopperPosition)(props.position),
            onCreate: this.extractStyles,
            onUpdate: this.extractStyles,
            modifiers: {
                applyStyle: {
                    enabled: false
                },
                hide: {
                    enabled: false
                },
                offset: {
                    enabled: true,
                    offset: this.props.offset
                },
                flip: {
                    enabled: false,
                    flipVariations: true,
                    boundariesElement: 'viewport',
                    padding: 0
                },
                preventOverflow: {
                    enabled: false,
                    escapeWithReference: true
                }
            },
            positionFixed: isAlwaysFixed
        };
        if (actualTarget) this.popper = new (0, $hUhgh.default)(actualTarget, this.contentRef.current, popperOpts);
    }
    render() {
        const { transform: transform, hasExtractedStyles: hasExtractedStyles, maxHeight: maxHeight } = this.state;
        const opacity = hasExtractedStyles ? {} : {
            opacity: 0
        };
        return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    ref: this.targetRef,
                    children: this.props.children
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    ref: this.contentRef,
                    style: {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        top: 0,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        left: 0,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        position: 'absolute',
                        transform: // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        transform,
                        maxHeight: maxHeight ? maxHeight : 'auto',
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        ...opacity
                    },
                    children: this.props.content
                })
            ]
        });
    }
}

});
parcelRegister("hUhgh", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0950e6c3380f4ed$export$2e2bcd8739ae039);
/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.15.0
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ var $d0950e6c3380f4ed$var$isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
var $d0950e6c3380f4ed$var$longerTimeoutBrowsers = [
    'Edge',
    'Trident',
    'Firefox'
];
var $d0950e6c3380f4ed$var$timeoutDuration = 0;
for(var $d0950e6c3380f4ed$var$i = 0; $d0950e6c3380f4ed$var$i < $d0950e6c3380f4ed$var$longerTimeoutBrowsers.length; $d0950e6c3380f4ed$var$i += 1)if ($d0950e6c3380f4ed$var$isBrowser && navigator.userAgent.indexOf($d0950e6c3380f4ed$var$longerTimeoutBrowsers[$d0950e6c3380f4ed$var$i]) >= 0) {
    $d0950e6c3380f4ed$var$timeoutDuration = 1;
    break;
}
function $d0950e6c3380f4ed$var$microtaskDebounce(fn) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        window.Promise.resolve().then(function() {
            called = false;
            fn();
        });
    };
}
function $d0950e6c3380f4ed$var$taskDebounce(fn) {
    var scheduled = false;
    return function() {
        if (!scheduled) {
            scheduled = true;
            setTimeout(function() {
                scheduled = false;
                fn();
            }, $d0950e6c3380f4ed$var$timeoutDuration);
        }
    };
}
var $d0950e6c3380f4ed$var$supportsMicroTasks = $d0950e6c3380f4ed$var$isBrowser && window.Promise;
/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/ var $d0950e6c3380f4ed$var$debounce = $d0950e6c3380f4ed$var$supportsMicroTasks ? $d0950e6c3380f4ed$var$microtaskDebounce : $d0950e6c3380f4ed$var$taskDebounce;
/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */ function $d0950e6c3380f4ed$var$isFunction(functionToCheck) {
    var getType = {};
    return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}
/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */ function $d0950e6c3380f4ed$var$getStyleComputedProperty(element, property) {
    if (element.nodeType !== 1) return [];
    // NOTE: 1 DOM access here
    var window1 = element.ownerDocument.defaultView;
    var css = window1.getComputedStyle(element, null);
    return property ? css[property] : css;
}
/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */ function $d0950e6c3380f4ed$var$getParentNode(element) {
    if (element.nodeName === 'HTML') return element;
    return element.parentNode || element.host;
}
/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */ function $d0950e6c3380f4ed$var$getScrollParent(element) {
    // Return body, `getScroll` will take care to get the correct `scrollTop` from it
    if (!element) return document.body;
    switch(element.nodeName){
        case 'HTML':
        case 'BODY':
            return element.ownerDocument.body;
        case '#document':
            return element.body;
    }
    // Firefox want us to check `-x` and `-y` variations as well
    var _getStyleComputedProp = $d0950e6c3380f4ed$var$getStyleComputedProperty(element), overflow = _getStyleComputedProp.overflow, overflowX = _getStyleComputedProp.overflowX, overflowY = _getStyleComputedProp.overflowY;
    if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) return element;
    return $d0950e6c3380f4ed$var$getScrollParent($d0950e6c3380f4ed$var$getParentNode(element));
}
var $d0950e6c3380f4ed$var$isIE11 = $d0950e6c3380f4ed$var$isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var $d0950e6c3380f4ed$var$isIE10 = $d0950e6c3380f4ed$var$isBrowser && /MSIE 10/.test(navigator.userAgent);
/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */ function $d0950e6c3380f4ed$var$isIE(version) {
    if (version === 11) return $d0950e6c3380f4ed$var$isIE11;
    if (version === 10) return $d0950e6c3380f4ed$var$isIE10;
    return $d0950e6c3380f4ed$var$isIE11 || $d0950e6c3380f4ed$var$isIE10;
}
/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */ function $d0950e6c3380f4ed$var$getOffsetParent(element) {
    if (!element) return document.documentElement;
    var noOffsetParent = $d0950e6c3380f4ed$var$isIE(10) ? document.body : null;
    // NOTE: 1 DOM access here
    var offsetParent = element.offsetParent || null;
    // Skip hidden elements which don't have an offsetParent
    while(offsetParent === noOffsetParent && element.nextElementSibling)offsetParent = (element = element.nextElementSibling).offsetParent;
    var nodeName = offsetParent && offsetParent.nodeName;
    if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') return element ? element.ownerDocument.documentElement : document.documentElement;
    // .offsetParent will return the closest TH, TD or TABLE in case
    // no offsetParent is present, I hate this job...
    if ([
        'TH',
        'TD',
        'TABLE'
    ].indexOf(offsetParent.nodeName) !== -1 && $d0950e6c3380f4ed$var$getStyleComputedProperty(offsetParent, 'position') === 'static') return $d0950e6c3380f4ed$var$getOffsetParent(offsetParent);
    return offsetParent;
}
function $d0950e6c3380f4ed$var$isOffsetContainer(element) {
    var nodeName = element.nodeName;
    if (nodeName === 'BODY') return false;
    return nodeName === 'HTML' || $d0950e6c3380f4ed$var$getOffsetParent(element.firstElementChild) === element;
}
/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */ function $d0950e6c3380f4ed$var$getRoot(node) {
    if (node.parentNode !== null) return $d0950e6c3380f4ed$var$getRoot(node.parentNode);
    return node;
}
/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */ function $d0950e6c3380f4ed$var$findCommonOffsetParent(element1, element2) {
    // This check is needed to avoid errors in case one of the elements isn't defined for any reason
    if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) return document.documentElement;
    // Here we make sure to give as "start" the element that comes first in the DOM
    var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
    var start = order ? element1 : element2;
    var end = order ? element2 : element1;
    // Get common ancestor container
    var range = document.createRange();
    range.setStart(start, 0);
    range.setEnd(end, 0);
    var commonAncestorContainer = range.commonAncestorContainer;
    // Both nodes are inside #document
    if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
        if ($d0950e6c3380f4ed$var$isOffsetContainer(commonAncestorContainer)) return commonAncestorContainer;
        return $d0950e6c3380f4ed$var$getOffsetParent(commonAncestorContainer);
    }
    // one of the nodes is inside shadowDOM, find which one
    var element1root = $d0950e6c3380f4ed$var$getRoot(element1);
    if (element1root.host) return $d0950e6c3380f4ed$var$findCommonOffsetParent(element1root.host, element2);
    else return $d0950e6c3380f4ed$var$findCommonOffsetParent(element1, $d0950e6c3380f4ed$var$getRoot(element2).host);
}
/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */ function $d0950e6c3380f4ed$var$getScroll(element) {
    var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';
    var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
    var nodeName = element.nodeName;
    if (nodeName === 'BODY' || nodeName === 'HTML') {
        var html = element.ownerDocument.documentElement;
        var scrollingElement = element.ownerDocument.scrollingElement || html;
        return scrollingElement[upperSide];
    }
    return element[upperSide];
}
/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */ function $d0950e6c3380f4ed$var$includeScroll(rect, element) {
    var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var scrollTop = $d0950e6c3380f4ed$var$getScroll(element, 'top');
    var scrollLeft = $d0950e6c3380f4ed$var$getScroll(element, 'left');
    var modifier = subtract ? -1 : 1;
    rect.top += scrollTop * modifier;
    rect.bottom += scrollTop * modifier;
    rect.left += scrollLeft * modifier;
    rect.right += scrollLeft * modifier;
    return rect;
}
/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */ function $d0950e6c3380f4ed$var$getBordersSize(styles, axis) {
    var sideA = axis === 'x' ? 'Left' : 'Top';
    var sideB = sideA === 'Left' ? 'Right' : 'Bottom';
    return parseFloat(styles['border' + sideA + 'Width'], 10) + parseFloat(styles['border' + sideB + 'Width'], 10);
}
function $d0950e6c3380f4ed$var$getSize(axis, body, html, computedStyle) {
    return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], $d0950e6c3380f4ed$var$isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}
function $d0950e6c3380f4ed$var$getWindowSizes(document1) {
    var body = document1.body;
    var html = document1.documentElement;
    var computedStyle = $d0950e6c3380f4ed$var$isIE(10) && getComputedStyle(html);
    return {
        height: $d0950e6c3380f4ed$var$getSize('Height', body, html, computedStyle),
        width: $d0950e6c3380f4ed$var$getSize('Width', body, html, computedStyle)
    };
}
var $d0950e6c3380f4ed$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var $d0950e6c3380f4ed$var$createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $d0950e6c3380f4ed$var$defineProperty = function(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
};
var $d0950e6c3380f4ed$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */ function $d0950e6c3380f4ed$var$getClientRect(offsets) {
    return $d0950e6c3380f4ed$var$_extends({}, offsets, {
        right: offsets.left + offsets.width,
        bottom: offsets.top + offsets.height
    });
}
/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */ function $d0950e6c3380f4ed$var$getBoundingClientRect(element) {
    var rect = {};
    // IE10 10 FIX: Please, don't ask, the element isn't
    // considered in DOM in some circumstances...
    // This isn't reproducible in IE10 compatibility mode of IE11
    try {
        if ($d0950e6c3380f4ed$var$isIE(10)) {
            rect = element.getBoundingClientRect();
            var scrollTop = $d0950e6c3380f4ed$var$getScroll(element, 'top');
            var scrollLeft = $d0950e6c3380f4ed$var$getScroll(element, 'left');
            rect.top += scrollTop;
            rect.left += scrollLeft;
            rect.bottom += scrollTop;
            rect.right += scrollLeft;
        } else rect = element.getBoundingClientRect();
    } catch (e) {}
    var result = {
        left: rect.left,
        top: rect.top,
        width: rect.right - rect.left,
        height: rect.bottom - rect.top
    };
    // subtract scrollbar size from sizes
    var sizes = element.nodeName === 'HTML' ? $d0950e6c3380f4ed$var$getWindowSizes(element.ownerDocument) : {};
    var width = sizes.width || element.clientWidth || result.right - result.left;
    var height = sizes.height || element.clientHeight || result.bottom - result.top;
    var horizScrollbar = element.offsetWidth - width;
    var vertScrollbar = element.offsetHeight - height;
    // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
    // we make this check conditional for performance reasons
    if (horizScrollbar || vertScrollbar) {
        var styles = $d0950e6c3380f4ed$var$getStyleComputedProperty(element);
        horizScrollbar -= $d0950e6c3380f4ed$var$getBordersSize(styles, 'x');
        vertScrollbar -= $d0950e6c3380f4ed$var$getBordersSize(styles, 'y');
        result.width -= horizScrollbar;
        result.height -= vertScrollbar;
    }
    return $d0950e6c3380f4ed$var$getClientRect(result);
}
function $d0950e6c3380f4ed$var$getOffsetRectRelativeToArbitraryNode(children, parent) {
    var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isIE10 = $d0950e6c3380f4ed$var$isIE(10);
    var isHTML = parent.nodeName === 'HTML';
    var childrenRect = $d0950e6c3380f4ed$var$getBoundingClientRect(children);
    var parentRect = $d0950e6c3380f4ed$var$getBoundingClientRect(parent);
    var scrollParent = $d0950e6c3380f4ed$var$getScrollParent(children);
    var styles = $d0950e6c3380f4ed$var$getStyleComputedProperty(parent);
    var borderTopWidth = parseFloat(styles.borderTopWidth, 10);
    var borderLeftWidth = parseFloat(styles.borderLeftWidth, 10);
    // In cases where the parent is fixed, we must ignore negative scroll in offset calc
    if (fixedPosition && isHTML) {
        parentRect.top = Math.max(parentRect.top, 0);
        parentRect.left = Math.max(parentRect.left, 0);
    }
    var offsets = $d0950e6c3380f4ed$var$getClientRect({
        top: childrenRect.top - parentRect.top - borderTopWidth,
        left: childrenRect.left - parentRect.left - borderLeftWidth,
        width: childrenRect.width,
        height: childrenRect.height
    });
    offsets.marginTop = 0;
    offsets.marginLeft = 0;
    // Subtract margins of documentElement in case it's being used as parent
    // we do this only on HTML because it's the only element that behaves
    // differently when margins are applied to it. The margins are included in
    // the box of the documentElement, in the other cases not.
    if (!isIE10 && isHTML) {
        var marginTop = parseFloat(styles.marginTop, 10);
        var marginLeft = parseFloat(styles.marginLeft, 10);
        offsets.top -= borderTopWidth - marginTop;
        offsets.bottom -= borderTopWidth - marginTop;
        offsets.left -= borderLeftWidth - marginLeft;
        offsets.right -= borderLeftWidth - marginLeft;
        // Attach marginTop and marginLeft because in some circumstances we may need them
        offsets.marginTop = marginTop;
        offsets.marginLeft = marginLeft;
    }
    if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') offsets = $d0950e6c3380f4ed$var$includeScroll(offsets, parent);
    return offsets;
}
function $d0950e6c3380f4ed$var$getViewportOffsetRectRelativeToArtbitraryNode(element) {
    var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var html = element.ownerDocument.documentElement;
    var relativeOffset = $d0950e6c3380f4ed$var$getOffsetRectRelativeToArbitraryNode(element, html);
    var width = Math.max(html.clientWidth, window.innerWidth || 0);
    var height = Math.max(html.clientHeight, window.innerHeight || 0);
    var scrollTop = !excludeScroll ? $d0950e6c3380f4ed$var$getScroll(html) : 0;
    var scrollLeft = !excludeScroll ? $d0950e6c3380f4ed$var$getScroll(html, 'left') : 0;
    var offset = {
        top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
        left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
        width: width,
        height: height
    };
    return $d0950e6c3380f4ed$var$getClientRect(offset);
}
/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */ function $d0950e6c3380f4ed$var$isFixed(element) {
    var nodeName = element.nodeName;
    if (nodeName === 'BODY' || nodeName === 'HTML') return false;
    if ($d0950e6c3380f4ed$var$getStyleComputedProperty(element, 'position') === 'fixed') return true;
    var parentNode = $d0950e6c3380f4ed$var$getParentNode(element);
    if (!parentNode) return false;
    return $d0950e6c3380f4ed$var$isFixed(parentNode);
}
/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */ function $d0950e6c3380f4ed$var$getFixedPositionOffsetParent(element) {
    // This check is needed to avoid errors in case one of the elements isn't defined for any reason
    if (!element || !element.parentElement || $d0950e6c3380f4ed$var$isIE()) return document.documentElement;
    var el = element.parentElement;
    while(el && $d0950e6c3380f4ed$var$getStyleComputedProperty(el, 'transform') === 'none')el = el.parentElement;
    return el || document.documentElement;
}
/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */ function $d0950e6c3380f4ed$var$getBoundaries(popper, reference, padding, boundariesElement) {
    var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    // NOTE: 1 DOM access here
    var boundaries = {
        top: 0,
        left: 0
    };
    var offsetParent = fixedPosition ? $d0950e6c3380f4ed$var$getFixedPositionOffsetParent(popper) : $d0950e6c3380f4ed$var$findCommonOffsetParent(popper, reference);
    // Handle viewport case
    if (boundariesElement === 'viewport') boundaries = $d0950e6c3380f4ed$var$getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
    else {
        // Handle other cases based on DOM element used as boundaries
        var boundariesNode = void 0;
        if (boundariesElement === 'scrollParent') {
            boundariesNode = $d0950e6c3380f4ed$var$getScrollParent($d0950e6c3380f4ed$var$getParentNode(reference));
            if (boundariesNode.nodeName === 'BODY') boundariesNode = popper.ownerDocument.documentElement;
        } else if (boundariesElement === 'window') boundariesNode = popper.ownerDocument.documentElement;
        else boundariesNode = boundariesElement;
        var offsets = $d0950e6c3380f4ed$var$getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);
        // In case of HTML, we need a different computation
        if (boundariesNode.nodeName === 'HTML' && !$d0950e6c3380f4ed$var$isFixed(offsetParent)) {
            var _getWindowSizes = $d0950e6c3380f4ed$var$getWindowSizes(popper.ownerDocument), height = _getWindowSizes.height, width = _getWindowSizes.width;
            boundaries.top += offsets.top - offsets.marginTop;
            boundaries.bottom = height + offsets.top;
            boundaries.left += offsets.left - offsets.marginLeft;
            boundaries.right = width + offsets.left;
        } else // for all the other DOM elements, this one is good
        boundaries = offsets;
    }
    // Add paddings
    padding = padding || 0;
    var isPaddingNumber = typeof padding === 'number';
    boundaries.left += isPaddingNumber ? padding : padding.left || 0;
    boundaries.top += isPaddingNumber ? padding : padding.top || 0;
    boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
    boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;
    return boundaries;
}
function $d0950e6c3380f4ed$var$getArea(_ref) {
    var width = _ref.width, height = _ref.height;
    return width * height;
}
/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $d0950e6c3380f4ed$var$computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
    var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
    if (placement.indexOf('auto') === -1) return placement;
    var boundaries = $d0950e6c3380f4ed$var$getBoundaries(popper, reference, padding, boundariesElement);
    var rects = {
        top: {
            width: boundaries.width,
            height: refRect.top - boundaries.top
        },
        right: {
            width: boundaries.right - refRect.right,
            height: boundaries.height
        },
        bottom: {
            width: boundaries.width,
            height: boundaries.bottom - refRect.bottom
        },
        left: {
            width: refRect.left - boundaries.left,
            height: boundaries.height
        }
    };
    var sortedAreas = Object.keys(rects).map(function(key) {
        return $d0950e6c3380f4ed$var$_extends({
            key: key
        }, rects[key], {
            area: $d0950e6c3380f4ed$var$getArea(rects[key])
        });
    }).sort(function(a, b) {
        return b.area - a.area;
    });
    var filteredAreas = sortedAreas.filter(function(_ref2) {
        var width = _ref2.width, height = _ref2.height;
        return width >= popper.clientWidth && height >= popper.clientHeight;
    });
    var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
    var variation = placement.split('-')[1];
    return computedPlacement + (variation ? '-' + variation : '');
}
/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */ function $d0950e6c3380f4ed$var$getReferenceOffsets(state, popper, reference) {
    var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var commonOffsetParent = fixedPosition ? $d0950e6c3380f4ed$var$getFixedPositionOffsetParent(popper) : $d0950e6c3380f4ed$var$findCommonOffsetParent(popper, reference);
    return $d0950e6c3380f4ed$var$getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}
/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */ function $d0950e6c3380f4ed$var$getOuterSizes(element) {
    var window1 = element.ownerDocument.defaultView;
    var styles = window1.getComputedStyle(element);
    var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
    var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
    var result = {
        width: element.offsetWidth + y,
        height: element.offsetHeight + x
    };
    return result;
}
/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */ function $d0950e6c3380f4ed$var$getOppositePlacement(placement) {
    var hash = {
        left: 'right',
        right: 'left',
        bottom: 'top',
        top: 'bottom'
    };
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return hash[matched];
    });
}
/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */ function $d0950e6c3380f4ed$var$getPopperOffsets(popper, referenceOffsets, placement) {
    placement = placement.split('-')[0];
    // Get popper node sizes
    var popperRect = $d0950e6c3380f4ed$var$getOuterSizes(popper);
    // Add position, width and height to our offsets object
    var popperOffsets = {
        width: popperRect.width,
        height: popperRect.height
    };
    // depending by the popper placement we have to compute its offsets slightly differently
    var isHoriz = [
        'right',
        'left'
    ].indexOf(placement) !== -1;
    var mainSide = isHoriz ? 'top' : 'left';
    var secondarySide = isHoriz ? 'left' : 'top';
    var measurement = isHoriz ? 'height' : 'width';
    var secondaryMeasurement = !isHoriz ? 'height' : 'width';
    popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
    if (placement === secondarySide) popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
    else popperOffsets[secondarySide] = referenceOffsets[$d0950e6c3380f4ed$var$getOppositePlacement(secondarySide)];
    return popperOffsets;
}
/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */ function $d0950e6c3380f4ed$var$find(arr, check) {
    // use native find if supported
    if (Array.prototype.find) return arr.find(check);
    // use `filter` to obtain the same behavior of `find`
    return arr.filter(check)[0];
}
/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */ function $d0950e6c3380f4ed$var$findIndex(arr, prop, value) {
    // use native findIndex if supported
    if (Array.prototype.findIndex) return arr.findIndex(function(cur) {
        return cur[prop] === value;
    });
    // use `find` + `indexOf` if `findIndex` isn't supported
    var match = $d0950e6c3380f4ed$var$find(arr, function(obj) {
        return obj[prop] === value;
    });
    return arr.indexOf(match);
}
/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */ function $d0950e6c3380f4ed$var$runModifiers(modifiers, data, ends) {
    var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, $d0950e6c3380f4ed$var$findIndex(modifiers, 'name', ends));
    modifiersToRun.forEach(function(modifier) {
        if (modifier['function']) // eslint-disable-line dot-notation
        console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
        var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
        if (modifier.enabled && $d0950e6c3380f4ed$var$isFunction(fn)) {
            // Add properties to offsets to make them a complete clientRect object
            // we do this before each modifier to make sure the previous one doesn't
            // mess with these values
            data.offsets.popper = $d0950e6c3380f4ed$var$getClientRect(data.offsets.popper);
            data.offsets.reference = $d0950e6c3380f4ed$var$getClientRect(data.offsets.reference);
            data = fn(data, modifier);
        }
    });
    return data;
}
/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */ function $d0950e6c3380f4ed$var$update() {
    // if popper is destroyed, don't perform any further update
    if (this.state.isDestroyed) return;
    var data = {
        instance: this,
        styles: {},
        arrowStyles: {},
        attributes: {},
        flipped: false,
        offsets: {}
    };
    // compute reference element offsets
    data.offsets.reference = $d0950e6c3380f4ed$var$getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);
    // compute auto placement, store placement inside the data object,
    // modifiers will be able to edit `placement` if needed
    // and refer to originalPlacement to know the original value
    data.placement = $d0950e6c3380f4ed$var$computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);
    // store the computed placement inside `originalPlacement`
    data.originalPlacement = data.placement;
    data.positionFixed = this.options.positionFixed;
    // compute the popper offsets
    data.offsets.popper = $d0950e6c3380f4ed$var$getPopperOffsets(this.popper, data.offsets.reference, data.placement);
    data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';
    // run the modifiers
    data = $d0950e6c3380f4ed$var$runModifiers(this.modifiers, data);
    // the first `update` will call `onCreate` callback
    // the other ones will call `onUpdate` callback
    if (!this.state.isCreated) {
        this.state.isCreated = true;
        this.options.onCreate(data);
    } else this.options.onUpdate(data);
}
/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */ function $d0950e6c3380f4ed$var$isModifierEnabled(modifiers, modifierName) {
    return modifiers.some(function(_ref) {
        var name = _ref.name, enabled = _ref.enabled;
        return enabled && name === modifierName;
    });
}
/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */ function $d0950e6c3380f4ed$var$getSupportedPropertyName(property) {
    var prefixes = [
        false,
        'ms',
        'Webkit',
        'Moz',
        'O'
    ];
    var upperProp = property.charAt(0).toUpperCase() + property.slice(1);
    for(var i = 0; i < prefixes.length; i++){
        var prefix = prefixes[i];
        var toCheck = prefix ? '' + prefix + upperProp : property;
        if (typeof document.body.style[toCheck] !== 'undefined') return toCheck;
    }
    return null;
}
/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */ function $d0950e6c3380f4ed$var$destroy() {
    this.state.isDestroyed = true;
    // touch DOM only if `applyStyle` modifier is enabled
    if ($d0950e6c3380f4ed$var$isModifierEnabled(this.modifiers, 'applyStyle')) {
        this.popper.removeAttribute('x-placement');
        this.popper.style.position = '';
        this.popper.style.top = '';
        this.popper.style.left = '';
        this.popper.style.right = '';
        this.popper.style.bottom = '';
        this.popper.style.willChange = '';
        this.popper.style[$d0950e6c3380f4ed$var$getSupportedPropertyName('transform')] = '';
    }
    this.disableEventListeners();
    // remove the popper if user explicity asked for the deletion on destroy
    // do not use `remove` because IE11 doesn't support it
    if (this.options.removeOnDestroy) this.popper.parentNode.removeChild(this.popper);
    return this;
}
/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */ function $d0950e6c3380f4ed$var$getWindow(element) {
    var ownerDocument = element.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView : window;
}
function $d0950e6c3380f4ed$var$attachToScrollParents(scrollParent, event, callback, scrollParents) {
    var isBody = scrollParent.nodeName === 'BODY';
    var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
    target.addEventListener(event, callback, {
        passive: true
    });
    if (!isBody) $d0950e6c3380f4ed$var$attachToScrollParents($d0950e6c3380f4ed$var$getScrollParent(target.parentNode), event, callback, scrollParents);
    scrollParents.push(target);
}
/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */ function $d0950e6c3380f4ed$var$setupEventListeners(reference, options, state, updateBound) {
    // Resize event listener on window
    state.updateBound = updateBound;
    $d0950e6c3380f4ed$var$getWindow(reference).addEventListener('resize', state.updateBound, {
        passive: true
    });
    // Scroll event listener on scroll parents
    var scrollElement = $d0950e6c3380f4ed$var$getScrollParent(reference);
    $d0950e6c3380f4ed$var$attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
    state.scrollElement = scrollElement;
    state.eventsEnabled = true;
    return state;
}
/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */ function $d0950e6c3380f4ed$var$enableEventListeners() {
    if (!this.state.eventsEnabled) this.state = $d0950e6c3380f4ed$var$setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
}
/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */ function $d0950e6c3380f4ed$var$removeEventListeners(reference, state) {
    // Remove resize event listener on window
    $d0950e6c3380f4ed$var$getWindow(reference).removeEventListener('resize', state.updateBound);
    // Remove scroll event listener on scroll parents
    state.scrollParents.forEach(function(target) {
        target.removeEventListener('scroll', state.updateBound);
    });
    // Reset state
    state.updateBound = null;
    state.scrollParents = [];
    state.scrollElement = null;
    state.eventsEnabled = false;
    return state;
}
/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */ function $d0950e6c3380f4ed$var$disableEventListeners() {
    if (this.state.eventsEnabled) {
        cancelAnimationFrame(this.scheduleUpdate);
        this.state = $d0950e6c3380f4ed$var$removeEventListeners(this.reference, this.state);
    }
}
/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */ function $d0950e6c3380f4ed$var$isNumeric(n) {
    return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}
/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */ function $d0950e6c3380f4ed$var$setStyles(element, styles) {
    Object.keys(styles).forEach(function(prop) {
        var unit = '';
        // add unit if the value is numeric and is one of the following
        if ([
            'width',
            'height',
            'top',
            'right',
            'bottom',
            'left'
        ].indexOf(prop) !== -1 && $d0950e6c3380f4ed$var$isNumeric(styles[prop])) unit = 'px';
        element.style[prop] = styles[prop] + unit;
    });
}
/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */ function $d0950e6c3380f4ed$var$setAttributes(element, attributes) {
    Object.keys(attributes).forEach(function(prop) {
        var value = attributes[prop];
        if (value !== false) element.setAttribute(prop, attributes[prop]);
        else element.removeAttribute(prop);
    });
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */ function $d0950e6c3380f4ed$var$applyStyle(data) {
    // any property present in `data.styles` will be applied to the popper,
    // in this way we can make the 3rd party modifiers add custom styles to it
    // Be aware, modifiers could override the properties defined in the previous
    // lines of this modifier!
    $d0950e6c3380f4ed$var$setStyles(data.instance.popper, data.styles);
    // any property present in `data.attributes` will be applied to the popper,
    // they will be set as HTML attributes of the element
    $d0950e6c3380f4ed$var$setAttributes(data.instance.popper, data.attributes);
    // if arrowElement is defined and arrowStyles has some properties
    if (data.arrowElement && Object.keys(data.arrowStyles).length) $d0950e6c3380f4ed$var$setStyles(data.arrowElement, data.arrowStyles);
    return data;
}
/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */ function $d0950e6c3380f4ed$var$applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
    // compute reference element offsets
    var referenceOffsets = $d0950e6c3380f4ed$var$getReferenceOffsets(state, popper, reference, options.positionFixed);
    // compute auto placement, store placement inside the data object,
    // modifiers will be able to edit `placement` if needed
    // and refer to originalPlacement to know the original value
    var placement = $d0950e6c3380f4ed$var$computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);
    popper.setAttribute('x-placement', placement);
    // Apply `position` to popper before anything else because
    // without the position applied we can't guarantee correct computations
    $d0950e6c3380f4ed$var$setStyles(popper, {
        position: options.positionFixed ? 'fixed' : 'absolute'
    });
    return options;
}
/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */ function $d0950e6c3380f4ed$var$getRoundedOffsets(data, shouldRound) {
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var round = Math.round, floor = Math.floor;
    var noRound = function noRound(v) {
        return v;
    };
    var referenceWidth = round(reference.width);
    var popperWidth = round(popper.width);
    var isVertical = [
        'left',
        'right'
    ].indexOf(data.placement) !== -1;
    var isVariation = data.placement.indexOf('-') !== -1;
    var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
    var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;
    var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
    var verticalToInteger = !shouldRound ? noRound : round;
    return {
        left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
        top: verticalToInteger(popper.top),
        bottom: verticalToInteger(popper.bottom),
        right: horizontalToInteger(popper.right)
    };
}
var $d0950e6c3380f4ed$var$isFirefox = $d0950e6c3380f4ed$var$isBrowser && /Firefox/i.test(navigator.userAgent);
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $d0950e6c3380f4ed$var$computeStyle(data, options) {
    var x = options.x, y = options.y;
    var popper = data.offsets.popper;
    // Remove this legacy support in Popper.js v2
    var legacyGpuAccelerationOption = $d0950e6c3380f4ed$var$find(data.instance.modifiers, function(modifier) {
        return modifier.name === 'applyStyle';
    }).gpuAcceleration;
    if (legacyGpuAccelerationOption !== undefined) console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
    var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;
    var offsetParent = $d0950e6c3380f4ed$var$getOffsetParent(data.instance.popper);
    var offsetParentRect = $d0950e6c3380f4ed$var$getBoundingClientRect(offsetParent);
    // Styles
    var styles = {
        position: popper.position
    };
    var offsets = $d0950e6c3380f4ed$var$getRoundedOffsets(data, window.devicePixelRatio < 2 || !$d0950e6c3380f4ed$var$isFirefox);
    var sideA = x === 'bottom' ? 'top' : 'bottom';
    var sideB = y === 'right' ? 'left' : 'right';
    // if gpuAcceleration is set to `true` and transform is supported,
    //  we use `translate3d` to apply the position to the popper we
    // automatically use the supported prefixed version if needed
    var prefixedProperty = $d0950e6c3380f4ed$var$getSupportedPropertyName('transform');
    // now, let's make a step back and look at this code closely (wtf?)
    // If the content of the popper grows once it's been positioned, it
    // may happen that the popper gets misplaced because of the new content
    // overflowing its reference element
    // To avoid this problem, we provide two options (x and y), which allow
    // the consumer to define the offset origin.
    // If we position a popper on top of a reference element, we can set
    // `x` to `top` to make the popper grow towards its top instead of
    // its bottom.
    var left = void 0, top = void 0;
    if (sideA === 'bottom') {
        // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
        // and not the bottom of the html element
        if (offsetParent.nodeName === 'HTML') top = -offsetParent.clientHeight + offsets.bottom;
        else top = -offsetParentRect.height + offsets.bottom;
    } else top = offsets.top;
    if (sideB === 'right') {
        if (offsetParent.nodeName === 'HTML') left = -offsetParent.clientWidth + offsets.right;
        else left = -offsetParentRect.width + offsets.right;
    } else left = offsets.left;
    if (gpuAcceleration && prefixedProperty) {
        styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
        styles[sideA] = 0;
        styles[sideB] = 0;
        styles.willChange = 'transform';
    } else {
        // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
        var invertTop = sideA === 'bottom' ? -1 : 1;
        var invertLeft = sideB === 'right' ? -1 : 1;
        styles[sideA] = top * invertTop;
        styles[sideB] = left * invertLeft;
        styles.willChange = sideA + ', ' + sideB;
    }
    // Attributes
    var attributes = {
        'x-placement': data.placement
    };
    // Update `data` attributes, styles and arrowStyles
    data.attributes = $d0950e6c3380f4ed$var$_extends({}, attributes, data.attributes);
    data.styles = $d0950e6c3380f4ed$var$_extends({}, styles, data.styles);
    data.arrowStyles = $d0950e6c3380f4ed$var$_extends({}, data.offsets.arrow, data.arrowStyles);
    return data;
}
/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */ function $d0950e6c3380f4ed$var$isModifierRequired(modifiers, requestingName, requestedName) {
    var requesting = $d0950e6c3380f4ed$var$find(modifiers, function(_ref) {
        var name = _ref.name;
        return name === requestingName;
    });
    var isRequired = !!requesting && modifiers.some(function(modifier) {
        return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
    });
    if (!isRequired) {
        var _requesting = '`' + requestingName + '`';
        var requested = '`' + requestedName + '`';
        console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
    }
    return isRequired;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $d0950e6c3380f4ed$var$arrow(data, options) {
    var _data$offsets$arrow;
    // arrow depends on keepTogether in order to work
    if (!$d0950e6c3380f4ed$var$isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) return data;
    var arrowElement = options.element;
    // if arrowElement is a string, suppose it's a CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = data.instance.popper.querySelector(arrowElement);
        // if arrowElement is not found, don't run the modifier
        if (!arrowElement) return data;
    } else // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
        console.warn('WARNING: `arrow.element` must be child of its popper element!');
        return data;
    }
    var placement = data.placement.split('-')[0];
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var isVertical = [
        'left',
        'right'
    ].indexOf(placement) !== -1;
    var len = isVertical ? 'height' : 'width';
    var sideCapitalized = isVertical ? 'Top' : 'Left';
    var side = sideCapitalized.toLowerCase();
    var altSide = isVertical ? 'left' : 'top';
    var opSide = isVertical ? 'bottom' : 'right';
    var arrowElementSize = $d0950e6c3380f4ed$var$getOuterSizes(arrowElement)[len];
    //
    // extends keepTogether behavior making sure the popper and its
    // reference have enough pixels in conjunction
    //
    // top/left side
    if (reference[opSide] - arrowElementSize < popper[side]) data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
    // bottom/right side
    if (reference[side] + arrowElementSize > popper[opSide]) data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
    data.offsets.popper = $d0950e6c3380f4ed$var$getClientRect(data.offsets.popper);
    // compute center of the popper
    var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;
    // Compute the sideValue using the updated popper offsets
    // take popper margin in account because we don't have this info available
    var css = $d0950e6c3380f4ed$var$getStyleComputedProperty(data.instance.popper);
    var popperMarginSide = parseFloat(css['margin' + sideCapitalized], 10);
    var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width'], 10);
    var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;
    // prevent arrowElement from being placed not contiguously to its popper
    sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);
    data.arrowElement = arrowElement;
    data.offsets.arrow = (_data$offsets$arrow = {}, $d0950e6c3380f4ed$var$defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), $d0950e6c3380f4ed$var$defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);
    return data;
}
/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */ function $d0950e6c3380f4ed$var$getOppositeVariation(variation) {
    if (variation === 'end') return 'start';
    else if (variation === 'start') return 'end';
    return variation;
}
/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */ var $d0950e6c3380f4ed$var$placements = [
    'auto-start',
    'auto',
    'auto-end',
    'top-start',
    'top',
    'top-end',
    'right-start',
    'right',
    'right-end',
    'bottom-end',
    'bottom',
    'bottom-start',
    'left-end',
    'left',
    'left-start'
];
// Get rid of `auto` `auto-start` and `auto-end`
var $d0950e6c3380f4ed$var$validPlacements = $d0950e6c3380f4ed$var$placements.slice(3);
/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */ function $d0950e6c3380f4ed$var$clockwise(placement) {
    var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var index = $d0950e6c3380f4ed$var$validPlacements.indexOf(placement);
    var arr = $d0950e6c3380f4ed$var$validPlacements.slice(index + 1).concat($d0950e6c3380f4ed$var$validPlacements.slice(0, index));
    return counter ? arr.reverse() : arr;
}
var $d0950e6c3380f4ed$var$BEHAVIORS = {
    FLIP: 'flip',
    CLOCKWISE: 'clockwise',
    COUNTERCLOCKWISE: 'counterclockwise'
};
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $d0950e6c3380f4ed$var$flip(data, options) {
    // if `inner` modifier is enabled, we can't use the `flip` modifier
    if ($d0950e6c3380f4ed$var$isModifierEnabled(data.instance.modifiers, 'inner')) return data;
    if (data.flipped && data.placement === data.originalPlacement) // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
    var boundaries = $d0950e6c3380f4ed$var$getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);
    var placement = data.placement.split('-')[0];
    var placementOpposite = $d0950e6c3380f4ed$var$getOppositePlacement(placement);
    var variation = data.placement.split('-')[1] || '';
    var flipOrder = [];
    switch(options.behavior){
        case $d0950e6c3380f4ed$var$BEHAVIORS.FLIP:
            flipOrder = [
                placement,
                placementOpposite
            ];
            break;
        case $d0950e6c3380f4ed$var$BEHAVIORS.CLOCKWISE:
            flipOrder = $d0950e6c3380f4ed$var$clockwise(placement);
            break;
        case $d0950e6c3380f4ed$var$BEHAVIORS.COUNTERCLOCKWISE:
            flipOrder = $d0950e6c3380f4ed$var$clockwise(placement, true);
            break;
        default:
            flipOrder = options.behavior;
    }
    flipOrder.forEach(function(step, index) {
        if (placement !== step || flipOrder.length === index + 1) return data;
        placement = data.placement.split('-')[0];
        placementOpposite = $d0950e6c3380f4ed$var$getOppositePlacement(placement);
        var popperOffsets = data.offsets.popper;
        var refOffsets = data.offsets.reference;
        // using floor because the reference offsets may contain decimals we are not going to consider here
        var floor = Math.floor;
        var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);
        var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
        var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
        var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
        var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);
        var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;
        // flip the variation if required
        var isVertical = [
            'top',
            'bottom'
        ].indexOf(placement) !== -1;
        // flips variation if reference element overflows boundaries
        var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);
        // flips variation if popper content overflows boundaries
        var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);
        var flippedVariation = flippedVariationByRef || flippedVariationByContent;
        if (overlapsRef || overflowsBoundaries || flippedVariation) {
            // this boolean to detect any flip loop
            data.flipped = true;
            if (overlapsRef || overflowsBoundaries) placement = flipOrder[index + 1];
            if (flippedVariation) variation = $d0950e6c3380f4ed$var$getOppositeVariation(variation);
            data.placement = placement + (variation ? '-' + variation : '');
            // this object contains `position`, we want to preserve it along with
            // any additional property we may add in the future
            data.offsets.popper = $d0950e6c3380f4ed$var$_extends({}, data.offsets.popper, $d0950e6c3380f4ed$var$getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));
            data = $d0950e6c3380f4ed$var$runModifiers(data.instance.modifiers, data, 'flip');
        }
    });
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $d0950e6c3380f4ed$var$keepTogether(data) {
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var placement = data.placement.split('-')[0];
    var floor = Math.floor;
    var isVertical = [
        'top',
        'bottom'
    ].indexOf(placement) !== -1;
    var side = isVertical ? 'right' : 'bottom';
    var opSide = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';
    if (popper[side] < floor(reference[opSide])) data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
    if (popper[opSide] > floor(reference[side])) data.offsets.popper[opSide] = floor(reference[side]);
    return data;
}
/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */ function $d0950e6c3380f4ed$var$toValue(str, measurement, popperOffsets, referenceOffsets) {
    // separate value from unit
    var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
    var value = +split[1];
    var unit = split[2];
    // If it's not a number it's an operator, I guess
    if (!value) return str;
    if (unit.indexOf('%') === 0) {
        var element = void 0;
        switch(unit){
            case '%p':
                element = popperOffsets;
                break;
            case '%':
            case '%r':
            default:
                element = referenceOffsets;
        }
        var rect = $d0950e6c3380f4ed$var$getClientRect(element);
        return rect[measurement] / 100 * value;
    } else if (unit === 'vh' || unit === 'vw') {
        // if is a vh or vw, we calculate the size based on the viewport
        var size = void 0;
        if (unit === 'vh') size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        else size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        return size / 100 * value;
    } else // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
}
/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */ function $d0950e6c3380f4ed$var$parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
    var offsets = [
        0,
        0
    ];
    // Use height if placement is left or right and index is 0 otherwise use width
    // in this way the first offset will use an axis and the second one
    // will use the other one
    var useHeight = [
        'right',
        'left'
    ].indexOf(basePlacement) !== -1;
    // Split the offset string to obtain a list of values and operands
    // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
    var fragments = offset.split(/(\+|\-)/).map(function(frag) {
        return frag.trim();
    });
    // Detect if the offset string contains a pair of values or a single one
    // they could be separated by comma or space
    var divider = fragments.indexOf($d0950e6c3380f4ed$var$find(fragments, function(frag) {
        return frag.search(/,|\s/) !== -1;
    }));
    if (fragments[divider] && fragments[divider].indexOf(',') === -1) console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
    // If divider is found, we divide the list of values and operands to divide
    // them by ofset X and Y.
    var splitRegex = /\s*,\s*|\s+/;
    var ops = divider !== -1 ? [
        fragments.slice(0, divider).concat([
            fragments[divider].split(splitRegex)[0]
        ]),
        [
            fragments[divider].split(splitRegex)[1]
        ].concat(fragments.slice(divider + 1))
    ] : [
        fragments
    ];
    // Convert the values with units to absolute pixels to allow our computations
    ops = ops.map(function(op, index) {
        // Most of the units rely on the orientation of the popper
        var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
        var mergeWithPrevious = false;
        return op// This aggregates any `+` or `-` sign that aren't considered operators
        // e.g.: 10 + +5 => [10, +, +5]
        .reduce(function(a, b) {
            if (a[a.length - 1] === '' && [
                '+',
                '-'
            ].indexOf(b) !== -1) {
                a[a.length - 1] = b;
                mergeWithPrevious = true;
                return a;
            } else if (mergeWithPrevious) {
                a[a.length - 1] += b;
                mergeWithPrevious = false;
                return a;
            } else return a.concat(b);
        }, [])// Here we convert the string values into number values (in px)
        .map(function(str) {
            return $d0950e6c3380f4ed$var$toValue(str, measurement, popperOffsets, referenceOffsets);
        });
    });
    // Loop trough the offsets arrays and execute the operations
    ops.forEach(function(op, index) {
        op.forEach(function(frag, index2) {
            if ($d0950e6c3380f4ed$var$isNumeric(frag)) offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
        });
    });
    return offsets;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */ function $d0950e6c3380f4ed$var$offset(data, _ref) {
    var offset = _ref.offset;
    var placement = data.placement, _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var basePlacement = placement.split('-')[0];
    var offsets = void 0;
    if ($d0950e6c3380f4ed$var$isNumeric(+offset)) offsets = [
        +offset,
        0
    ];
    else offsets = $d0950e6c3380f4ed$var$parseOffset(offset, popper, reference, basePlacement);
    if (basePlacement === 'left') {
        popper.top += offsets[0];
        popper.left -= offsets[1];
    } else if (basePlacement === 'right') {
        popper.top += offsets[0];
        popper.left += offsets[1];
    } else if (basePlacement === 'top') {
        popper.left += offsets[0];
        popper.top -= offsets[1];
    } else if (basePlacement === 'bottom') {
        popper.left += offsets[0];
        popper.top += offsets[1];
    }
    data.popper = popper;
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $d0950e6c3380f4ed$var$preventOverflow(data, options) {
    var boundariesElement = options.boundariesElement || $d0950e6c3380f4ed$var$getOffsetParent(data.instance.popper);
    // If offsetParent is the reference element, we really want to
    // go one step up and use the next offsetParent as reference to
    // avoid to make this modifier completely useless and look like broken
    if (data.instance.reference === boundariesElement) boundariesElement = $d0950e6c3380f4ed$var$getOffsetParent(boundariesElement);
    // NOTE: DOM access here
    // resets the popper's position so that the document size can be calculated excluding
    // the size of the popper element itself
    var transformProp = $d0950e6c3380f4ed$var$getSupportedPropertyName('transform');
    var popperStyles = data.instance.popper.style; // assignment to help minification
    var top = popperStyles.top, left = popperStyles.left, transform = popperStyles[transformProp];
    popperStyles.top = '';
    popperStyles.left = '';
    popperStyles[transformProp] = '';
    var boundaries = $d0950e6c3380f4ed$var$getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);
    // NOTE: DOM access here
    // restores the original style properties after the offsets have been computed
    popperStyles.top = top;
    popperStyles.left = left;
    popperStyles[transformProp] = transform;
    options.boundaries = boundaries;
    var order = options.priority;
    var popper = data.offsets.popper;
    var check = {
        primary: function primary(placement) {
            var value = popper[placement];
            if (popper[placement] < boundaries[placement] && !options.escapeWithReference) value = Math.max(popper[placement], boundaries[placement]);
            return $d0950e6c3380f4ed$var$defineProperty({}, placement, value);
        },
        secondary: function secondary(placement) {
            var mainSide = placement === 'right' ? 'left' : 'top';
            var value = popper[mainSide];
            if (popper[placement] > boundaries[placement] && !options.escapeWithReference) value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
            return $d0950e6c3380f4ed$var$defineProperty({}, mainSide, value);
        }
    };
    order.forEach(function(placement) {
        var side = [
            'left',
            'top'
        ].indexOf(placement) !== -1 ? 'primary' : 'secondary';
        popper = $d0950e6c3380f4ed$var$_extends({}, popper, check[side](placement));
    });
    data.offsets.popper = popper;
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $d0950e6c3380f4ed$var$shift(data) {
    var placement = data.placement;
    var basePlacement = placement.split('-')[0];
    var shiftvariation = placement.split('-')[1];
    // if shift shiftvariation is specified, run the modifier
    if (shiftvariation) {
        var _data$offsets = data.offsets, reference = _data$offsets.reference, popper = _data$offsets.popper;
        var isVertical = [
            'bottom',
            'top'
        ].indexOf(basePlacement) !== -1;
        var side = isVertical ? 'left' : 'top';
        var measurement = isVertical ? 'width' : 'height';
        var shiftOffsets = {
            start: $d0950e6c3380f4ed$var$defineProperty({}, side, reference[side]),
            end: $d0950e6c3380f4ed$var$defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
        };
        data.offsets.popper = $d0950e6c3380f4ed$var$_extends({}, popper, shiftOffsets[shiftvariation]);
    }
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $d0950e6c3380f4ed$var$hide(data) {
    if (!$d0950e6c3380f4ed$var$isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) return data;
    var refRect = data.offsets.reference;
    var bound = $d0950e6c3380f4ed$var$find(data.instance.modifiers, function(modifier) {
        return modifier.name === 'preventOverflow';
    }).boundaries;
    if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
        // Avoid unnecessary DOM access if visibility hasn't changed
        if (data.hide === true) return data;
        data.hide = true;
        data.attributes['x-out-of-boundaries'] = '';
    } else {
        // Avoid unnecessary DOM access if visibility hasn't changed
        if (data.hide === false) return data;
        data.hide = false;
        data.attributes['x-out-of-boundaries'] = false;
    }
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $d0950e6c3380f4ed$var$inner(data) {
    var placement = data.placement;
    var basePlacement = placement.split('-')[0];
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var isHoriz = [
        'left',
        'right'
    ].indexOf(basePlacement) !== -1;
    var subtractLength = [
        'top',
        'left'
    ].indexOf(basePlacement) === -1;
    popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);
    data.placement = $d0950e6c3380f4ed$var$getOppositePlacement(placement);
    data.offsets.popper = $d0950e6c3380f4ed$var$getClientRect(popper);
    return data;
}
/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */ /**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */ var $d0950e6c3380f4ed$var$modifiers = {
    /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */ shift: {
        /** @prop {number} order=100 - Index used to define the order of execution */ order: 100,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $d0950e6c3380f4ed$var$shift
    },
    /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */ offset: {
        /** @prop {number} order=200 - Index used to define the order of execution */ order: 200,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $d0950e6c3380f4ed$var$offset,
        /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */ offset: 0
    },
    /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */ preventOverflow: {
        /** @prop {number} order=300 - Index used to define the order of execution */ order: 300,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $d0950e6c3380f4ed$var$preventOverflow,
        /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */ priority: [
            'left',
            'right',
            'top',
            'bottom'
        ],
        /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */ padding: 5,
        /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */ boundariesElement: 'scrollParent'
    },
    /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */ keepTogether: {
        /** @prop {number} order=400 - Index used to define the order of execution */ order: 400,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $d0950e6c3380f4ed$var$keepTogether
    },
    /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */ arrow: {
        /** @prop {number} order=500 - Index used to define the order of execution */ order: 500,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $d0950e6c3380f4ed$var$arrow,
        /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */ element: '[x-arrow]'
    },
    /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */ flip: {
        /** @prop {number} order=600 - Index used to define the order of execution */ order: 600,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $d0950e6c3380f4ed$var$flip,
        /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */ behavior: 'flip',
        /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */ padding: 5,
        /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */ boundariesElement: 'viewport',
        /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */ flipVariations: false,
        /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */ flipVariationsByContent: false
    },
    /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */ inner: {
        /** @prop {number} order=700 - Index used to define the order of execution */ order: 700,
        /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */ enabled: false,
        /** @prop {ModifierFn} */ fn: $d0950e6c3380f4ed$var$inner
    },
    /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */ hide: {
        /** @prop {number} order=800 - Index used to define the order of execution */ order: 800,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $d0950e6c3380f4ed$var$hide
    },
    /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */ computeStyle: {
        /** @prop {number} order=850 - Index used to define the order of execution */ order: 850,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $d0950e6c3380f4ed$var$computeStyle,
        /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */ gpuAcceleration: true,
        /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */ x: 'bottom',
        /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */ y: 'right'
    },
    /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */ applyStyle: {
        /** @prop {number} order=900 - Index used to define the order of execution */ order: 900,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $d0950e6c3380f4ed$var$applyStyle,
        /** @prop {Function} */ onLoad: $d0950e6c3380f4ed$var$applyStyleOnLoad,
        /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */ gpuAcceleration: undefined
    }
};
/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */ /**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */ var $d0950e6c3380f4ed$var$Defaults = {
    /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */ placement: 'bottom',
    /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */ positionFixed: false,
    /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */ eventsEnabled: true,
    /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */ removeOnDestroy: false,
    /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */ onCreate: function onCreate() {},
    /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */ onUpdate: function onUpdate() {},
    /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */ modifiers: $d0950e6c3380f4ed$var$modifiers
};
/**
 * @callback onCreate
 * @param {dataObject} data
 */ /**
 * @callback onUpdate
 * @param {dataObject} data
 */ // Utils
// Methods
var $d0950e6c3380f4ed$var$Popper = function() {
    /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */ function Popper(reference, popper) {
        var _this = this;
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        $d0950e6c3380f4ed$var$classCallCheck(this, Popper);
        this.scheduleUpdate = function() {
            return requestAnimationFrame(_this.update);
        };
        // make update() debounced, so that it only runs at most once-per-tick
        this.update = $d0950e6c3380f4ed$var$debounce(this.update.bind(this));
        // with {} we create a new object with the options inside it
        this.options = $d0950e6c3380f4ed$var$_extends({}, Popper.Defaults, options);
        // init state
        this.state = {
            isDestroyed: false,
            isCreated: false,
            scrollParents: []
        };
        // get reference and popper elements (allow jQuery wrappers)
        this.reference = reference && reference.jquery ? reference[0] : reference;
        this.popper = popper && popper.jquery ? popper[0] : popper;
        // Deep merge modifiers options
        this.options.modifiers = {};
        Object.keys($d0950e6c3380f4ed$var$_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function(name) {
            _this.options.modifiers[name] = $d0950e6c3380f4ed$var$_extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
        });
        // Refactoring modifiers' list (Object => Array)
        this.modifiers = Object.keys(this.options.modifiers).map(function(name) {
            return $d0950e6c3380f4ed$var$_extends({
                name: name
            }, _this.options.modifiers[name]);
        })// sort the modifiers by order
        .sort(function(a, b) {
            return a.order - b.order;
        });
        // modifiers have the ability to execute arbitrary code when Popper.js get inited
        // such code is executed in the same order of its modifier
        // they could add new properties to their options configuration
        // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
        this.modifiers.forEach(function(modifierOptions) {
            if (modifierOptions.enabled && $d0950e6c3380f4ed$var$isFunction(modifierOptions.onLoad)) modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
        });
        // fire the first update to position the popper in the right place
        this.update();
        var eventsEnabled = this.options.eventsEnabled;
        if (eventsEnabled) // setup event listeners, they will take care of update the position in specific situations
        this.enableEventListeners();
        this.state.eventsEnabled = eventsEnabled;
    }
    // We can't use class properties because they don't get listed in the
    // class prototype and break stuff like Sinon stubs
    $d0950e6c3380f4ed$var$createClass(Popper, [
        {
            key: 'update',
            value: function update$$1() {
                return $d0950e6c3380f4ed$var$update.call(this);
            }
        },
        {
            key: 'destroy',
            value: function destroy$$1() {
                return $d0950e6c3380f4ed$var$destroy.call(this);
            }
        },
        {
            key: 'enableEventListeners',
            value: function enableEventListeners$$1() {
                return $d0950e6c3380f4ed$var$enableEventListeners.call(this);
            }
        },
        {
            key: 'disableEventListeners',
            value: function disableEventListeners$$1() {
                return $d0950e6c3380f4ed$var$disableEventListeners.call(this);
            }
        }
    ]);
    return Popper;
}();
/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */ $d0950e6c3380f4ed$var$Popper.Utils = (typeof window !== 'undefined' ? window : $parcel$global).PopperUtils;
$d0950e6c3380f4ed$var$Popper.placements = $d0950e6c3380f4ed$var$placements;
$d0950e6c3380f4ed$var$Popper.Defaults = $d0950e6c3380f4ed$var$Defaults;
var $d0950e6c3380f4ed$export$2e2bcd8739ae039 = $d0950e6c3380f4ed$var$Popper;

});

parcelRegister("jIGfZ", function(module, exports) {

$parcel$export(module.exports, "positionPropToPopperPosition", () => $74b597cb03f3a6fd$export$9e6a7c92c66a7cdd);
const $74b597cb03f3a6fd$var$positionMap = {
    'top left': {
        position: 'top-start',
        animation: 'top'
    },
    'top center': {
        position: 'top',
        animation: 'top'
    },
    'top right': {
        position: 'top-end',
        animation: 'top'
    },
    'right top': {
        position: 'right-start',
        animation: 'right'
    },
    'right middle': {
        position: 'right',
        animation: 'right'
    },
    'right bottom': {
        position: 'right-end',
        animation: 'right'
    },
    'bottom left': {
        position: 'bottom-start',
        animation: 'bottom'
    },
    'bottom center': {
        position: 'bottom',
        animation: 'bottom'
    },
    'bottom right': {
        position: 'bottom-end',
        animation: 'bottom'
    },
    'left top': {
        position: 'left-start',
        animation: 'left'
    },
    'left middle': {
        position: 'left',
        animation: 'left'
    },
    'left bottom': {
        position: 'left-end',
        animation: 'left'
    }
};
const $74b597cb03f3a6fd$export$f6c90e9517ee2ce0 = {
    values: [
        'top left',
        'top center',
        'top right',
        'right top',
        'right middle',
        'right bottom',
        'bottom left',
        'bottom center',
        'bottom right',
        'left top',
        'left middle',
        'left bottom'
    ],
    default: 'right middle'
};
function $74b597cb03f3a6fd$var$positionToPopper(position) {
    return position && $74b597cb03f3a6fd$var$positionMap[position] ? $74b597cb03f3a6fd$var$positionMap[position].position : null;
}
function $74b597cb03f3a6fd$export$9e6a7c92c66a7cdd(position) {
    return $74b597cb03f3a6fd$var$positionToPopper(position) || $74b597cb03f3a6fd$var$positionMap[$74b597cb03f3a6fd$export$f6c90e9517ee2ce0.default].position;
}

});



parcelRegister("avm98", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f5ad13b8318551c$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5gCP6 = parcelRequire("5gCP6");

var $bRPNB = parcelRequire("bRPNB");

var $aQK2r = parcelRequire("aQK2r");

var $7yBx7 = parcelRequire("7yBx7");

var $eGOwo = parcelRequire("eGOwo");

var $dwnni = parcelRequire("dwnni");
class $1f5ad13b8318551c$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    static{
        this.defaultProps = {
            offset: [
                0,
                0
            ],
            allowOutOfBound: false
        };
    }
    /**
	 * Calculates new popup position
	 */ calculatePosition(props, popup) {
        const { target: target, fitHeight: fitHeight, fitWidth: fitWidth, boundariesElement: boundariesElement, offset: offset, onPositionCalculated: onPositionCalculated, onPlacementChanged: onPlacementChanged, alignX: alignX, alignY: alignY, stick: stick, forcePlacement: forcePlacement, allowOutOfBounds: allowOutOfBounds, rect: rect, preventOverflow: preventOverflow, absoluteOffset: absoluteOffset } = props;
        if (!target || !popup) return {};
        const placement = (0, $dwnni.calculatePlacement)(target, boundariesElement || document.body, fitWidth, fitHeight, alignX, alignY, forcePlacement, preventOverflow);
        if (onPlacementChanged && this.placement.join('') !== placement.join('')) {
            onPlacementChanged(placement);
            this.placement = placement;
        }
        let position = (0, $dwnni.calculatePosition)({
            placement: placement,
            popup: popup,
            target: target,
            stick: stick,
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            offset: offset,
            allowOutOfBounds: allowOutOfBounds,
            rect: rect
        });
        position = onPositionCalculated ? onPositionCalculated(position) : position;
        if (typeof position.top !== 'undefined' && absoluteOffset?.top) position.top = position.top + absoluteOffset.top;
        if (typeof position.bottom !== 'undefined' && absoluteOffset?.bottom) position.bottom = position.bottom + absoluteOffset.bottom;
        if (typeof position.right !== 'undefined' && absoluteOffset?.right) position.right = position.right + absoluteOffset.right;
        if (typeof position.left !== 'undefined' && absoluteOffset?.left) position.left = position.left + absoluteOffset.left;
        return {
            position: position,
            validPosition: (0, $dwnni.validatePosition)(target)
        };
    }
    updatePosition(props = this.props, state = this.state) {
        const { popup: popup } = state;
        const { position: position, validPosition: validPosition } = this.calculatePosition(props, popup);
        if (position && validPosition) (0, $aQK2r.flushSync)(()=>{
            this.setState({
                position: position,
                validPosition: validPosition
            });
        });
    }
    cannotSetPopup(popup, target, overflowScrollParent) {
        /**
		 * Check whether:
		 * 1. Popup's offset targets which means whether or not its possible to correctly position popup along with given target.
		 * 2. Popup is inside "overflow: scroll" container, but its offset parent isn't.
		 *
		 * Currently Popup isn't capable of position itself correctly in case 2,
		 * Add "position: relative" to "overflow: scroll" container or to some other FloatingPanel wrapper inside it.
		 */ return !target || document.body.contains(target) && popup.offsetParent && // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        !popup.offsetParent.contains(target) || overflowScrollParent && !overflowScrollParent.contains(popup.offsetParent);
    }
    /**
	 * Popup initialization.
	 * Checks whether it's possible to position popup along given target, and if it's not throws an error.
	 */ initPopup(popup) {
        this.popupRef.current = popup;
        const { target: target } = this.props;
        const overflowScrollParent = (0, $dwnni.findOverflowScrollParent)(popup);
        if (this.cannotSetPopup(popup, target, overflowScrollParent)) return;
        this.setState({
            popup: popup
        });
        /**
		 * Some plugins (like image) have async rendering of component in floating toolbar(which is popup).
		 * Now, floating toolbar position depends on it's size.
		 * Size of floating toolbar changes, when async component renders.
		 * There is currently, no way to re position floating toolbar or
		 *  better to not show floating toolbar till all the async component are ready to render.
		 * Also, it is not even Popup's responsibility to take care of it as popup's children are passed
		 *  as a prop.
		 * So, calling scheduledUpdatePosition to position popup on next request animation frame,
		 * which is currently working for most of the floating toolbar and other popups.
		 */ this.scheduledUpdatePosition(this.props);
        if (this.props.focusTrap) this.initFocusTrap();
    }
    /**
	 * Cancels the initialisation of the focus trap if it has not yet occured
	 * Deactivates the focus trap if it exists
	 */ destroyFocusTrap() {
        this.initFocusTrap.cancel();
        this.focusTrap?.deactivate();
    }
    /**
	 * Handle pausing, unpausing, and initialising (if not yet initialised) of the focus trap
	 */ handleChangedFocusTrapProp(prevProps) {
        if (prevProps.focusTrap !== this.props.focusTrap) {
            // If currently set to disable, then pause the trap if it exists
            if (!this.props.focusTrap) return this.focusTrap?.pause();
            // If set to enabled and trap already exists, unpause
            if (this.focusTrap) this.focusTrap.unpause();
            // Else initialise the focus trap
            return this.initFocusTrap();
        }
    }
    componentDidUpdate(prevProps) {
        this.handleChangedFocusTrapProp(prevProps);
        if (this.props !== prevProps) this.scheduledUpdatePosition(prevProps);
    }
    componentDidMount() {
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.addEventListener('resize', this.onResize);
        const { stick: stick } = this.props;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.scrollParentElement = (0, $dwnni.findOverflowScrollParent)(this.props.target);
        if (this.scrollParentElement && this.resizeObserver) this.resizeObserver.observe(this.scrollParentElement);
        if (stick) this.scrollElement = this.scrollParentElement;
        else this.scrollElement = this.props.scrollableElement;
        if (this.scrollElement) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.scrollElement.addEventListener('scroll', this.onResize);
    }
    componentWillUnmount() {
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.removeEventListener('resize', this.onResize);
        if (this.scrollElement) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.scrollElement.removeEventListener('scroll', this.onResize);
        if (this.scrollParentElement && this.resizeObserver) this.resizeObserver.unobserve(this.scrollParentElement);
        this.scheduledUpdatePosition.cancel();
        this.destroyFocusTrap();
        const { onUnmount: onUnmount } = this.props;
        if (onUnmount) onUnmount();
    }
    renderPopup() {
        const { position: position } = this.state;
        const { shouldRenderPopup: shouldRenderPopup } = this.props;
        if (shouldRenderPopup && !shouldRenderPopup(position || {})) return null;
        /**
		 * https://a11y.atlassian.net/browse/A11Y-9995
		 * We set aria-label to undefined if it's null, no more 'Popup' fallback.
		 * It is meaningless for screen readers and causes confusion.
		 */ const ariaLabel = (0, $eGOwo.fg)('editor_a11y_aria_label_removal_popup') ? this.props.ariaLabel ?? undefined : this.props.ariaLabel === null ? undefined : this.props.ariaLabel || 'Popup';
        return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            ref: this.handleRef,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                position: 'absolute',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                zIndex: this.props.zIndex || (0, $7yBx7.akEditorFloatingPanelZIndex),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                ...position,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                ...this.props.style
            },
            "aria-label": ariaLabel,
            "data-testid": "popup-wrapper",
            // Indicates component is an editor pop. Required for focus handling in Message.tsx
            "data-editor-popup": true,
            children: this.props.children
        });
    }
    render() {
        const { target: target, mountTo: mountTo } = this.props;
        const { validPosition: validPosition } = this.state;
        if (!target || !validPosition) return null;
        if (mountTo) return /*#__PURE__*/ (0, $aQK2r.createPortal)(this.renderPopup(), mountTo);
        // Without mountTo property renders popup as is,
        // which means it will be cropped by "overflow: hidden" container.
        return this.renderPopup();
    }
    constructor(...args){
        super(...args), this.rafIds = new Set(), this.state = {
            validPosition: true
        }, this.popupRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createRef(), this.placement = [
            '',
            ''
        ], this.handleRef = (popup)=>{
            if (!popup) return;
            this.initPopup(popup);
        }, this.scheduledUpdatePosition = (0, $bRPNB.default)((props)=>{
            this.updatePosition(this.props);
        }), this.onResize = ()=>this.scheduledUpdatePosition(this.props), this.resizeObserver = window?.ResizeObserver ? new ResizeObserver(()=>{
            this.scheduledUpdatePosition(this.props);
        }) : undefined, /**
	 * Raf scheduled so that it also occurs after the initial update position
	 */ this.initFocusTrap = (0, $bRPNB.default)(()=>{
            const popup = this.popupRef.current;
            if (!popup) return;
            const trapConfig = {
                clickOutsideDeactivates: true,
                escapeDeactivates: true,
                initialFocus: popup,
                fallbackFocus: popup,
                returnFocusOnDeactivate: false
            };
            this.focusTrap = (0, (/*@__PURE__*/$parcel$interopDefault($5gCP6)))(popup, trapConfig);
            this.focusTrap.activate();
        });
    }
}

});
parcelRegister("dwnni", function(module, exports) {

$parcel$export(module.exports, "calculatePlacement", () => $5c938d1514d83d54$export$b81415a09b611cb);
$parcel$export(module.exports, "findOverflowScrollParent", () => $5c938d1514d83d54$export$69742dd9a26edd3e);
$parcel$export(module.exports, "calculatePosition", () => $5c938d1514d83d54$export$b3ceb0cbf1056d98);
$parcel$export(module.exports, "validatePosition", () => $5c938d1514d83d54$export$ab306cb155a0ca1b);
function $5c938d1514d83d54$export$540dbd453ede1ce3(elem) {
    return elem === document.body;
}
function $5c938d1514d83d54$export$ccbedd67ef6e9417(elem) {
    return elem && elem.nodeType === 3;
}
function $5c938d1514d83d54$export$ba5b1093dd832251(target, boundariesElement, fitHeight, alignY, forcePlacement, preventOverflow) {
    if (forcePlacement && alignY) return alignY;
    if (!fitHeight) return 'bottom';
    if ($5c938d1514d83d54$export$ccbedd67ef6e9417(target)) // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    target = target.parentElement;
    const boundariesClientRect = boundariesElement.getBoundingClientRect();
    const { height: boundariesHeight } = boundariesClientRect;
    const boundariesTop = $5c938d1514d83d54$export$540dbd453ede1ce3(boundariesElement) ? 0 : boundariesClientRect.top;
    const { top: targetTop, height: targetHeight } = target.getBoundingClientRect();
    const spaceAbove = targetTop - (boundariesTop - boundariesElement.scrollTop);
    const spaceBelow = boundariesTop + boundariesHeight - (targetTop + targetHeight);
    // Force vertical placement to bottom if the space above doesn't accomodate the fitHeight
    if (preventOverflow) {
        if (spaceAbove <= fitHeight) return 'bottom';
    }
    if (spaceBelow >= fitHeight || spaceBelow >= spaceAbove) return 'bottom';
    return 'top';
}
function $5c938d1514d83d54$export$af26c34d66be95d6(target, boundariesElement, fitWidth, alignX, forcePlacement, preventOverflow) {
    // force placement unless preventOverflow is enabled
    if (forcePlacement && alignX && !preventOverflow) return alignX;
    if (!fitWidth) return alignX || 'left';
    if ($5c938d1514d83d54$export$ccbedd67ef6e9417(target)) // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    target = target.parentElement;
    const { left: targetLeft, width: targetWidth } = target.getBoundingClientRect();
    const { left: boundariesLeft, width: boundariesWidth } = boundariesElement.getBoundingClientRect();
    const spaceLeft = targetLeft - boundariesLeft + targetWidth;
    const spaceRight = boundariesLeft + boundariesWidth - targetLeft;
    if (alignX && spaceLeft > fitWidth && spaceRight > fitWidth) return alignX;
    else if (spaceRight >= fitWidth || spaceRight >= spaceLeft && !alignX) return 'left';
    return 'right';
}
function $5c938d1514d83d54$export$b81415a09b611cb(target, boundariesElement, fitWidth, fitHeight, alignX, alignY, forcePlacement, preventOverflow) {
    return [
        $5c938d1514d83d54$export$ba5b1093dd832251(target, boundariesElement, fitHeight, alignY, forcePlacement, preventOverflow),
        $5c938d1514d83d54$export$af26c34d66be95d6(target, boundariesElement, fitWidth, alignX, forcePlacement, preventOverflow)
    ];
}
const $5c938d1514d83d54$var$calculateHorizontalPlacement = ({ placement: placement, targetLeft: targetLeft, targetRight: targetRight, targetWidth: targetWidth, isPopupParentBody: isPopupParentBody, popupOffsetParentLeft: popupOffsetParentLeft, popupOffsetParentRight: popupOffsetParentRight, popupOffsetParentScrollLeft: popupOffsetParentScrollLeft, popupOffsetParentClientWidth: popupOffsetParentClientWidth, popupClientWidth: popupClientWidth, offset: offset, allowOutOfBounds: allowOutOfBounds = false })=>{
    const position = {};
    if (placement === 'left') position.left = Math.ceil(targetLeft - popupOffsetParentLeft + (isPopupParentBody ? 0 : popupOffsetParentScrollLeft) + offset[0]);
    else if (placement === 'center') position.left = Math.ceil(targetLeft - popupOffsetParentLeft + (isPopupParentBody ? 0 : popupOffsetParentScrollLeft) + offset[0] + targetWidth / 2 - popupClientWidth / 2);
    else if (placement === 'end') {
        const left = Math.ceil(targetRight - popupOffsetParentLeft + (isPopupParentBody ? 0 : popupOffsetParentScrollLeft) + offset[0]);
        position.left = left;
    } else position.right = Math.ceil(popupOffsetParentRight - targetRight - (isPopupParentBody ? 0 : popupOffsetParentScrollLeft) + offset[0]);
    if (!allowOutOfBounds) {
        if (position.left !== undefined) position.left = $5c938d1514d83d54$var$getPopupXInsideParent(position.left, popupClientWidth, popupOffsetParentClientWidth);
        if (position.right !== undefined) position.right = $5c938d1514d83d54$var$getPopupXInsideParent(position.right, popupClientWidth, popupOffsetParentClientWidth);
    }
    return position;
};
const $5c938d1514d83d54$var$getPopupXInsideParent = (x, popupClientWidth, popupOffsetParentClientWidth)=>{
    // minimum distance the popup can be from the edge of its parent
    const minPopupMargin = 1;
    // prevent going too far right
    if (popupOffsetParentClientWidth < x + popupClientWidth) x = popupOffsetParentClientWidth - popupClientWidth - minPopupMargin;
    // prevent going too far left
    return Math.max(minPopupMargin, x);
};
const $5c938d1514d83d54$var$calculateVerticalStickBottom = ({ target: target, targetTop: targetTop, targetHeight: targetHeight, popup: popup, offset: offset, position: position })=>{
    const scrollParent = $5c938d1514d83d54$export$69742dd9a26edd3e(target);
    const newPos = {
        ...position
    };
    if (scrollParent) {
        const topOffsetTop = targetTop - scrollParent.getBoundingClientRect().top;
        const targetEnd = targetHeight + topOffsetTop;
        if (scrollParent.clientHeight - targetEnd <= popup.clientHeight + offset[1] * 2 && topOffsetTop < scrollParent.clientHeight) {
            const scroll = targetEnd - scrollParent.clientHeight + offset[1] * 2;
            let top = newPos.top || 0;
            top = top - (scroll + popup.clientHeight);
            newPos.top = top;
        }
    }
    return newPos;
};
const $5c938d1514d83d54$var$calculateVerticalStickTop = ({ target: target, targetTop: targetTop, targetHeight: targetHeight, popupOffsetParentHeight: popupOffsetParentHeight, popupOffsetParent: popupOffsetParent, offset: offset, position: position, placement: placement })=>{
    const scrollParent = $5c938d1514d83d54$export$69742dd9a26edd3e(target);
    const newPos = {
        ...position
    };
    if (scrollParent) {
        const { top: scrollParentTop } = scrollParent.getBoundingClientRect();
        const topBoundary = targetTop - scrollParentTop;
        const scrollParentScrollTop = scrollParent.scrollTop;
        if (topBoundary < 0) {
            const isBelowNodeBoundary = targetTop + (scrollParentScrollTop - scrollParentTop) + targetHeight + offset[1] < scrollParentScrollTop;
            if (placement === 'top') {
                if (isBelowNodeBoundary) newPos.bottom = popupOffsetParentHeight - (topBoundary + popupOffsetParent.scrollTop + targetHeight);
                else newPos.bottom = topBoundary + (newPos.bottom || 0);
            }
            if (placement === 'start') {
                if (isBelowNodeBoundary) newPos.top = topBoundary + popupOffsetParent.scrollTop + targetHeight;
                else newPos.top = Math.abs(topBoundary) + (newPos.top || 0) + offset[1];
            }
        }
    }
    return newPos;
};
const $5c938d1514d83d54$var$calculateVerticalPlacement = ({ placement: placement, targetTop: targetTop, targetHeight: targetHeight, isPopupParentBody: isPopupParentBody, popupOffsetParentHeight: popupOffsetParentHeight, popupOffsetParentTop: popupOffsetParentTop, popupOffsetParentScrollTop: popupOffsetParentScrollTop, borderBottomWidth: borderBottomWidth, offset: offset })=>{
    const position = {};
    if (placement === 'top') position.bottom = Math.ceil(popupOffsetParentHeight - (targetTop - popupOffsetParentTop) - (isPopupParentBody ? 0 : popupOffsetParentScrollTop) - borderBottomWidth + offset[1]);
    else if (placement === 'start') position.top = Math.ceil(targetTop - popupOffsetParentTop - offset[1] + (isPopupParentBody ? 0 : popupOffsetParentScrollTop));
    else {
        const top = Math.ceil(targetTop - popupOffsetParentTop + targetHeight + (isPopupParentBody ? 0 : popupOffsetParentScrollTop) - borderBottomWidth + offset[1]);
        position.top = top;
    }
    return position;
};
function $5c938d1514d83d54$export$b3ceb0cbf1056d98({ placement: placement, target: target, popup: popup, offset: offset, stick: stick, allowOutOfBounds: allowOutOfBounds = false, rect: rect }) {
    let position = {};
    if (!target || !popup || !popup.offsetParent) return position;
    if ($5c938d1514d83d54$export$ccbedd67ef6e9417(target)) // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    target = target.parentElement;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const popupOffsetParent = popup.offsetParent;
    const offsetParentStyle = popupOffsetParent.style;
    let borderBottomWidth = 0;
    if (offsetParentStyle && offsetParentStyle.borderBottomWidth) borderBottomWidth = parseInt(offsetParentStyle.borderBottomWidth, 10);
    const [verticalPlacement, horizontalPlacement] = placement;
    const { top: popupOffsetParentTop, left: popupOffsetParentLeft, right: popupOffsetParentRight, height: popupOffsetParentHeight } = rect ? rect : popupOffsetParent.getBoundingClientRect();
    const { top: targetTop, left: targetLeft, right: targetRight, height: targetHeight, width: targetWidth } = target.getBoundingClientRect();
    const isPopupParentBody = $5c938d1514d83d54$export$540dbd453ede1ce3(popupOffsetParent);
    const verticalPosition = $5c938d1514d83d54$var$calculateVerticalPlacement({
        placement: verticalPlacement,
        targetTop: targetTop,
        isPopupParentBody: isPopupParentBody,
        popupOffsetParentHeight: popupOffsetParentHeight,
        popupOffsetParentTop: popupOffsetParentTop,
        popupOffsetParentScrollTop: popupOffsetParent.scrollTop || 0,
        targetHeight: targetHeight,
        borderBottomWidth: borderBottomWidth,
        offset: offset
    });
    position = {
        ...position,
        ...verticalPosition
    };
    if ((verticalPlacement === 'top' || verticalPlacement === 'start') && stick) position = $5c938d1514d83d54$var$calculateVerticalStickTop({
        target: target,
        targetTop: targetTop,
        targetHeight: targetHeight,
        popupOffsetParentHeight: popupOffsetParentHeight,
        popupOffsetParent: popupOffsetParent,
        popup: popup,
        offset: offset,
        position: position,
        placement: verticalPlacement
    });
    if (verticalPlacement !== 'top' && verticalPlacement !== 'start' && stick) position = $5c938d1514d83d54$var$calculateVerticalStickBottom({
        target: target,
        targetTop: targetTop,
        targetHeight: targetHeight,
        popup: popup,
        offset: offset,
        position: position
    });
    const horizontalPosition = $5c938d1514d83d54$var$calculateHorizontalPlacement({
        placement: horizontalPlacement,
        targetLeft: targetLeft,
        targetRight: targetRight,
        targetWidth: targetWidth,
        isPopupParentBody: isPopupParentBody,
        popupOffsetParentLeft: popupOffsetParentLeft,
        popupOffsetParentRight: popupOffsetParentRight,
        popupOffsetParentScrollLeft: popupOffsetParent.scrollLeft || 0,
        popupOffsetParentClientWidth: popup.offsetParent.clientWidth,
        popupClientWidth: popup.clientWidth || 0,
        offset: offset,
        allowOutOfBounds: allowOutOfBounds
    });
    position = {
        ...position,
        ...horizontalPosition
    };
    return position;
}
function $5c938d1514d83d54$export$ab306cb155a0ca1b(popup) {
    // popup.offsetParent does not exist if the popup element is not mounted
    if (!popup || !popup.offsetParent) return false;
    return true;
}
function $5c938d1514d83d54$export$69742dd9a26edd3e(popup) {
    let parent = popup;
    if (!parent) return false;
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    while(parent = parent.parentElement){
        // IE11 on Window 8 doesn't show styles from CSS when accessing through element.style property.
        const style = window.getComputedStyle(parent);
        if (style.overflow === 'scroll' || style.overflowX === 'scroll' || style.overflowY === 'scroll' || parent.classList.contains('fabric-editor-popup-scroll-parent')) return parent;
    }
    return false;
}

});


parcelRegister("aYKcT", function(module, exports) {

$parcel$export(module.exports, "ArrowKeyNavigationProvider", () => $ba9790d4043e9bef$export$ee87cc4950b6d6fe);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $g9imq = parcelRequire("g9imq");

var $dNMlg = parcelRequire("dNMlg");

var $4UveB = parcelRequire("4UveB");

var $UpZp1 = parcelRequire("UpZp1");
const $ba9790d4043e9bef$export$ee87cc4950b6d6fe = (props)=>{
    const { children: children, type: type, ...restProps } = props;
    if (type === (0, $UpZp1.ArrowKeyNavigationType).COLOR) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $g9imq.default).Consumer, {
        children: ({ popupsMountPoint: popupsMountPoint, editorView: editorView, editorRef: editorRef })=>editorRef && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dNMlg.ColorPaletteArrowKeyNavigationProvider), {
                selectedRowIndex: props.selectedRowIndex,
                selectedColumnIndex: props.selectedColumnIndex,
                isOpenedByKeyboard: props.isOpenedByKeyboard,
                isPopupPositioned: props.isPopupPositioned,
                editorRef: editorRef,
                popupsMountPoint: popupsMountPoint,
                ...restProps,
                children: children
            })
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $g9imq.default).Consumer, {
        children: ({ popupsMountPoint: popupsMountPoint, editorView: editorView, editorRef: editorRef })=>editorRef && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4UveB.MenuArrowKeyNavigationProvider), {
                editorRef: editorRef,
                popupsMountPoint: popupsMountPoint,
                ...restProps,
                children: children
            })
    });
};

});
parcelRegister("dNMlg", function(module, exports) {

$parcel$export(module.exports, "ColorPaletteArrowKeyNavigationProvider", () => $8f58427aa1024ad4$export$e17115e9cf808589);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
const $8f58427aa1024ad4$export$e17115e9cf808589 = ({ children: children, selectedRowIndex: selectedRowIndex, selectedColumnIndex: selectedColumnIndex, isOpenedByKeyboard: isOpenedByKeyboard, isPopupPositioned: isPopupPositioned, handleClose: handleClose, closeOnTab: closeOnTab, editorRef: editorRef, ignoreEscapeKey: ignoreEscapeKey, popupsMountPoint: popupsMountPoint })=>{
    const wrapperRef = (0, $eJOHy.useRef)(null);
    const currentSelectedColumnIndex = (0, $eJOHy.useRef)(selectedColumnIndex === -1 ? 0 : selectedColumnIndex);
    const currentSelectedRowIndex = (0, $eJOHy.useRef)(selectedRowIndex === -1 ? 0 : selectedRowIndex);
    const element = popupsMountPoint ? popupsMountPoint : editorRef.current;
    const [listenerTargetElement] = (0, $eJOHy.useState)(element);
    const incrementRowIndex = (rowElements, columnElements)=>{
        if (currentSelectedRowIndex.current === rowElements.length - 1) currentSelectedRowIndex.current = 0;
        else currentSelectedRowIndex.current = currentSelectedRowIndex.current + 1;
    };
    const decrementRowIndex = (rowElements, columnElements)=>{
        if (currentSelectedRowIndex.current === 0) currentSelectedRowIndex.current = rowElements.length - 1;
        else currentSelectedRowIndex.current = currentSelectedRowIndex.current - 1;
    };
    (0, $eJOHy.useLayoutEffect)(()=>{
        const incrementColumnIndex = (rowElements, columnElements)=>{
            if (currentSelectedColumnIndex.current === columnElements.length - 1) {
                incrementRowIndex(rowElements, columnElements);
                currentSelectedColumnIndex.current = 0;
            } else currentSelectedColumnIndex.current = currentSelectedColumnIndex.current + 1;
        };
        const decrementColumnIndex = (rowElements, columnElements)=>{
            if (currentSelectedColumnIndex.current === 0) {
                decrementRowIndex(rowElements, columnElements);
                currentSelectedColumnIndex.current = columnElements.length - 1;
            } else currentSelectedColumnIndex.current = currentSelectedColumnIndex.current - 1;
        };
        const focusColorSwatch = ()=>{
            const colorSwatchesRowElements = $8f58427aa1024ad4$var$getColorSwatchesRows(wrapperRef?.current);
            const currentSelectedColorSwatchRowElement = colorSwatchesRowElements[currentSelectedRowIndex.current];
            const focusableElements = $8f58427aa1024ad4$var$getFocusableElements(currentSelectedColorSwatchRowElement);
            if (!focusableElements || focusableElements?.length === 0) return;
            focusableElements[currentSelectedColumnIndex.current]?.focus();
        };
        /**
		 * To handle the key events on the list
		 * @param event
		 */ const handleKeyDown = (event)=>{
            if (event.key === 'Tab' && closeOnTab) {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                handleClose(event);
                return;
            }
            const colorSwatchesRowElements = $8f58427aa1024ad4$var$getColorSwatchesRows(wrapperRef?.current);
            const currentSelectedColorSwatchRowElement = colorSwatchesRowElements[currentSelectedRowIndex.current];
            const focusableElements = $8f58427aa1024ad4$var$getFocusableElements(currentSelectedColorSwatchRowElement);
            switch(event.key){
                case 'ArrowDown':
                    incrementRowIndex(colorSwatchesRowElements, focusableElements);
                    focusColorSwatch();
                    event.preventDefault();
                    break;
                case 'ArrowUp':
                    decrementRowIndex(colorSwatchesRowElements, focusableElements);
                    focusColorSwatch();
                    event.preventDefault();
                    break;
                case 'ArrowLeft':
                    decrementColumnIndex(colorSwatchesRowElements, focusableElements);
                    focusColorSwatch();
                    event.preventDefault();
                    break;
                case 'ArrowRight':
                    incrementColumnIndex(colorSwatchesRowElements, focusableElements);
                    focusColorSwatch();
                    event.preventDefault();
                    break;
                case 'Escape':
                    if (!ignoreEscapeKey) // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    handleClose(event);
                    break;
                default:
                    return;
            }
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        listenerTargetElement && listenerTargetElement.addEventListener('keydown', handleKeyDown);
        // set focus to current selected color swatch if only opened by keyboard
        if (isOpenedByKeyboard && isPopupPositioned) // Using timeout because, we need to wait till color palette is rendered
        //  and visible on screen, then only focus color swatch, otherwise focus will be
        //  moved to body
        setTimeout(()=>{
            focusColorSwatch();
        });
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            listenerTargetElement && listenerTargetElement.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        currentSelectedColumnIndex,
        isOpenedByKeyboard,
        isPopupPositioned,
        wrapperRef,
        handleClose,
        closeOnTab,
        ignoreEscapeKey,
        listenerTargetElement
    ]);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: "custom-key-handler-wrapper",
        ref: wrapperRef,
        children: children
    }));
};
function $8f58427aa1024ad4$var$getColorSwatchesRows(rootNode) {
    if (!rootNode) return [];
    const colorSwatchesRowElements = rootNode.querySelectorAll('div[role=radiogroup]') || [];
    return Array.from(colorSwatchesRowElements);
}
function $8f58427aa1024ad4$var$getFocusableElements(rootNode) {
    if (!rootNode) return [];
    const focusableModalElements = rootNode.querySelectorAll('button[role=radio]:not([disabled])') || [];
    return Array.from(focusableModalElements);
}

});

parcelRegister("4UveB", function(module, exports) {

$parcel$export(module.exports, "MenuArrowKeyNavigationProvider", () => $a5d38829450c5340$export$e12b037790bf03e3);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
const $a5d38829450c5340$var$hasEnabledItems = (list)=>list.some((item)=>item.getAttribute('aria-disabled') !== 'true');
const $a5d38829450c5340$export$e12b037790bf03e3 = ({ children: children, handleClose: handleClose, disableArrowKeyNavigation: disableArrowKeyNavigation, keyDownHandlerContext: keyDownHandlerContext, closeOnTab: closeOnTab, onSelection: onSelection, editorRef: editorRef, popupsMountPoint: popupsMountPoint, disableCloseOnArrowClick: disableCloseOnArrowClick })=>{
    const wrapperRef = (0, $eJOHy.useRef)(null);
    const [currentSelectedItemIndex, setCurrentSelectedItemIndex] = (0, $eJOHy.useState)(-1);
    const element = popupsMountPoint ? [
        popupsMountPoint,
        editorRef.current
    ] : [
        editorRef.current
    ];
    const [listenerTargetElement] = (0, $eJOHy.useState)(element);
    const incrementIndex = (0, $eJOHy.useCallback)((list)=>{
        const currentIndex = currentSelectedItemIndex;
        let nextIndex = (currentIndex + 1) % list.length;
        // Skips disabled items. Previously this function relied on a list of enabled elements which caused a
        // difference between currentIndex and the item index in the menu.
        while(nextIndex !== currentIndex && list[nextIndex].getAttribute('aria-disabled') === 'true')nextIndex = (nextIndex + 1) % list.length;
        setCurrentSelectedItemIndex(nextIndex);
        return nextIndex;
    }, [
        currentSelectedItemIndex
    ]);
    const decrementIndex = (0, $eJOHy.useCallback)((list)=>{
        const currentIndex = currentSelectedItemIndex;
        let nextIndex = (list.length + currentIndex - 1) % list.length;
        while(nextIndex !== currentIndex && list[nextIndex].getAttribute('aria-disabled') === 'true')nextIndex = (list.length + nextIndex - 1) % list.length;
        setCurrentSelectedItemIndex(nextIndex);
        return nextIndex;
    }, [
        currentSelectedItemIndex
    ]);
    // this useEffect uses onSelection in it's dependency list which gets
    // changed as a result of the dropdown menu getting re-rendered in it's
    // parent component. Note that if onSelection gets updated to useMemo
    // this will no longer work.
    (0, $eJOHy.useEffect)(()=>{
        const currentIndex = currentSelectedItemIndex;
        const list = $a5d38829450c5340$var$getFocusableElements(wrapperRef?.current);
        const currentElement = list[currentIndex];
        if (currentElement && currentElement.getAttribute('aria-disabled') === 'true') {
            const focusIndex = incrementIndex(list);
            list[focusIndex]?.focus();
        }
    }, [
        currentSelectedItemIndex,
        onSelection,
        incrementIndex,
        decrementIndex
    ]);
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (disableArrowKeyNavigation) return;
        /**
		 * To handle the key events on the list
		 * @param event
		 */ const handleKeyDown = (event)=>{
            const targetElement = event.target;
            // Tab key on menu items can be handled in the parent components of dropdown menus with KeydownHandlerContext
            if (event.key === 'Tab' && closeOnTab) {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                handleClose(event);
                keyDownHandlerContext?.handleTab();
                return;
            }
            // To trap the focus inside the toolbar using left and right arrow keys
            const focusableElements = $a5d38829450c5340$var$getFocusableElements(wrapperRef?.current);
            if (!focusableElements || focusableElements?.length === 0) return;
            if (targetElement instanceof HTMLElement && !wrapperRef.current?.contains(targetElement)) setCurrentSelectedItemIndex(-1);
            switch(event.key){
                case 'ArrowDown':
                    if ($a5d38829450c5340$var$hasEnabledItems(focusableElements)) {
                        const focusIndex = incrementIndex(focusableElements);
                        focusableElements[focusIndex]?.focus();
                        event.preventDefault();
                    }
                    break;
                case 'ArrowUp':
                    if ($a5d38829450c5340$var$hasEnabledItems(focusableElements)) {
                        const focusIndex = decrementIndex(focusableElements);
                        focusableElements[focusIndex]?.focus();
                        event.preventDefault();
                    }
                    break;
                // ArrowLeft/Right on the menu should close the menus
                // then logic to retain the focus can be handled in the parent components with KeydownHandlerContext
                case 'ArrowLeft':
                    if (targetElement instanceof HTMLElement && !targetElement.closest('.custom-key-handler-wrapper')) return;
                    if (!disableCloseOnArrowClick) // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    handleClose(event);
                    if (targetElement instanceof HTMLElement && !targetElement.closest('[data-testid="editor-floating-toolbar"]')) keyDownHandlerContext?.handleArrowLeft();
                    break;
                case 'ArrowRight':
                    if (targetElement instanceof HTMLElement && !targetElement.closest('.custom-key-handler-wrapper')) return;
                    if (!disableCloseOnArrowClick) // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    handleClose(event);
                    if (targetElement instanceof HTMLElement && !targetElement.closest('[data-testid="editor-floating-toolbar"]')) keyDownHandlerContext?.handleArrowRight();
                    break;
                case 'Escape':
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    handleClose(event);
                    break;
                case 'Enter':
                    if (typeof onSelection === 'function') onSelection(currentSelectedItemIndex);
                    break;
                default:
                    return;
            }
        };
        listenerTargetElement && listenerTargetElement.forEach(function(elem) {
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            elem && elem.addEventListener('keydown', handleKeyDown);
        });
        return ()=>{
            listenerTargetElement && listenerTargetElement.forEach(function(elem) {
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                elem && elem.removeEventListener('keydown', handleKeyDown);
            });
        };
    }, [
        currentSelectedItemIndex,
        wrapperRef,
        handleClose,
        disableArrowKeyNavigation,
        keyDownHandlerContext,
        closeOnTab,
        onSelection,
        incrementIndex,
        decrementIndex,
        listenerTargetElement,
        disableCloseOnArrowClick
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "menu-key-handler-wrapper custom-key-handler-wrapper",
        ref: wrapperRef,
        children: children
    });
};
function $a5d38829450c5340$var$getFocusableElements(rootNode) {
    if (!rootNode) return [];
    const focusableModalElements = rootNode.querySelectorAll('a[href], button:not([disabled]), textarea, input, select, div[tabindex="-1"]') || [];
    return Array.from(focusableModalElements);
}

});

parcelRegister("UpZp1", function(module, exports) {

$parcel$export(module.exports, "ArrowKeyNavigationType", () => $f801a7f63248a4b1$export$26c2c5e2f61f437a);
var $f801a7f63248a4b1$export$26c2c5e2f61f437a = /*#__PURE__*/ function(ArrowKeyNavigationType) {
    ArrowKeyNavigationType["COLOR"] = "color";
    ArrowKeyNavigationType["MENU"] = "menu";
    return ArrowKeyNavigationType;
}({});

});



parcelRegister("h5iWO", function(module, exports) {

$parcel$export(module.exports, "BlockTypeButton", () => $fba0099e23b010e5$export$60665cf15e769742);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $kDaaB = parcelRequire("kDaaB");

var $1D5wE = parcelRequire("1D5wE");

var $is7NW = parcelRequire("is7NW");
var $fcJnk = parcelRequire("fcJnk");

var $9Sic1 = parcelRequire("9Sic1");

var $5lAAn = parcelRequire("5lAAn");

var $8hNRj = parcelRequire("8hNRj");

var $exniU = parcelRequire("exniU");

var $eGOwo = parcelRequire("eGOwo");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $9Letn = parcelRequire("9Letn");

var $h16z0 = parcelRequire("h16z0");

var $fAjN9 = parcelRequire("fAjN9");
const $fba0099e23b010e5$var$buttonContentStyle = (0, $1DXK0.xcss)({
    minWidth: `calc(80px + 2*${"var(--ds-space-075, 6px)"})`,
    overflow: 'hidden',
    padding: 'space.075'
});
const $fba0099e23b010e5$var$buttonContentReducedSpacingStyle = (0, $1DXK0.xcss)({
    padding: 'space.100',
    minWidth: `calc(80px + 2*${"var(--ds-space-100, 8px)"})`
});
const $fba0099e23b010e5$export$60665cf15e769742 = (props)=>{
    const blockTypeName = props.blockTypeName || '';
    const labelTextStyles = props.formatMessage((0, $1D5wE.toolbarMessages).textStyles, {
        blockTypeName: blockTypeName
    });
    const toolipTextStyles = props.formatMessage((0, $1D5wE.toolbarMessages).textStylesTooltip);
    const icon = (0, $9Letn.expValEqualsNoExposure)('platform_editor_controls', 'cohort', 'variant1') && props.blockTypeIcon ? props.blockTypeIcon : /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8hNRj))), {
        label: labelTextStyles,
        spacing: "spacious",
        color: "currentColor",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($exniU)))
    });
    const chevronIconSpacing = (0, $9Letn.expValEqualsNoExposure)('platform_editor_controls', 'cohort', 'variant1') && (props.isSmall || !props.isSmall && (0, $eGOwo.fg)('platform_editor_controls_patch_13')) ? 'spacious' : 'none';
    const shouldUseIconAsButton = props.isSmall || (0, $9Letn.expValEqualsNoExposure)('platform_editor_controls', 'cohort', 'variant1') && (0, $eGOwo.fg)('platform_editor_controls_patch_13');
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $9Sic1.default), {
        spacing: props.isReducedSpacing ? 'none' : 'default',
        selected: props.selected,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "block-type-btn",
        disabled: props.disabled,
        onClick: props.onClick,
        onKeyDown: props.onKeyDown,
        title: toolipTextStyles,
        "aria-label": labelTextStyles,
        "aria-haspopup": true,
        "aria-expanded": props['aria-expanded'],
        iconAfter: /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            css: [
                (0, $fcJnk.wrapperStyle),
                props.isSmall && (0, $fAjN9.wrapperSmallStyle)
            ],
            "data-testid": "toolbar-block-type-text-styles-icon"
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, shouldUseIconAsButton && icon, /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            css: (0, $is7NW.expandIconContainerStyle)
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5lAAn))), {
            spacing: chevronIconSpacing,
            label: "",
            color: "currentColor",
            LEGACY_margin: "0 0 0 -8px",
            size: "small"
        }))))
    }, !shouldUseIconAsButton && /*#__PURE__*/ (0, $1NIU8.jsx)((0, $8nu6j.default), {
        xcss: [
            $fba0099e23b010e5$var$buttonContentStyle,
            props.isReducedSpacing && $fba0099e23b010e5$var$buttonContentReducedSpacingStyle
        ]
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $kDaaB.default), props.title || (0, $h16z0.NORMAL_TEXT).title)));
};

});
parcelRegister("9Sic1", function(module, exports) {

$parcel$export(module.exports, "default", () => $a056acddf837a0c9$export$2e2bcd8739ae039);
// If you make any change here, copy it to above file as well
// and notify about the change in #team-fc-editor-ai-dev channel.
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $bgewf = parcelRequire("bgewf");

var $k71qx = parcelRequire("k71qx");

var $bMFKb = parcelRequire("bMFKb");

var $6Exgk = parcelRequire("6Exgk");

var $e8vrw = parcelRequire("e8vrw");
function $a056acddf837a0c9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a056acddf837a0c9$var$buttonWrapper = {
    name: "15currb",
    styles: "display:flex;height:100%"
};
const $a056acddf837a0c9$var$ToolbarButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef((props, ref)=>{
    const { buttonId: buttonId, testId: testId, className: className = '', href: href, iconAfter: iconAfter, iconBefore: iconBefore, disabled: disabled, selected: selected, spacing: spacing, target: target, children: children, hideTooltip: hideTooltip, title: title, keymap: keymap, titlePosition: titlePosition = 'top', item: item, rel: rel, 'aria-label': ariaLabel, 'aria-haspopup': ariaHasPopup, 'aria-expanded': ariaExpanded, 'aria-pressed': ariaPressed, 'aria-keyshortcuts': ariaKeyShortcuts, 'aria-controls': ariaControls, 'data-ds--level': dataDsLevel, onClick: onClick, onKeyDown: onKeyDown, onItemClick: onItemClick, onFocus: onFocus, onBlur: onBlur, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave } = props;
    const handleClick = (0, $eJOHy.useCallback)((event, analyticsEvent)=>{
        if (disabled) return;
        if (buttonId) analyticsEvent.update((payload)=>({
                ...payload,
                action: (0, $bMFKb.ACTION).CLICKED,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).TOOLBAR_BUTTON,
                actionSubjectId: buttonId,
                eventType: (0, $bMFKb.EVENT_TYPE).UI
            })).fire((0, $bgewf.FabricChannel).editor);
        if (onClick) onClick(event);
        if (item && onItemClick) onItemClick(item);
    }, [
        disabled,
        onClick,
        onItemClick,
        item,
        buttonId
    ]);
    const button = /*#__PURE__*/ (0, $1NIU8.jsx)((0, $e8vrw.default), {
        ref: ref,
        appearance: "subtle",
        testId: testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        href: href,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isDisabled: disabled,
        isSelected: selected,
        onClick: handleClick,
        spacing: spacing || 'default',
        target: target,
        shouldFitContainer: true,
        "aria-expanded": ariaExpanded,
        "aria-controls": ariaControls,
        "aria-haspopup": ariaHasPopup,
        "aria-label": ariaLabel,
        "aria-pressed": ariaPressed,
        "aria-keyshortcuts": ariaKeyShortcuts,
        onKeyDown: onKeyDown,
        onFocus: onFocus,
        onBlur: onBlur,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        "data-ds--level": dataDsLevel,
        rel: rel
    }, children);
    if (!title) return button;
    const tooltipContent = hideTooltip ? null : /*#__PURE__*/ (0, $1NIU8.jsx)((0, $6Exgk.ToolTipContent), {
        description: title,
        keymap: keymap
    });
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $k71qx.default), {
        content: tooltipContent,
        hideTooltipOnClick: true,
        position: titlePosition
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $a056acddf837a0c9$var$buttonWrapper
    }, button));
});
var $a056acddf837a0c9$export$2e2bcd8739ae039 = $a056acddf837a0c9$var$ToolbarButton;

});
parcelRegister("e8vrw", function(module, exports) {

$parcel$export(module.exports, "default", () => $a504faf53112d556$export$2e2bcd8739ae039);
// If you make any change here, copy it to above file as well
//  and notify about the change in #team-fc-editor-ai-dev channel.

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");
var $a504faf53112d556$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef((props, ref)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $goZPP.default), {
        ref: ref,
        ...props,
        // Ignored via go/ees007
        // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
        // TODO: (from codemod) Buttons with "component", "css" or "style" prop can't be automatically migrated with codemods. Please migrate it manually.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            alignItems: 'center'
        }
    });
});

});


parcelRegister("exniU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a9563970426cdd61$var$_react = $a9563970426cdd61$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $a9563970426cdd61$var$_textStyle = $a9563970426cdd61$var$_interopRequireDefault((parcelRequire("6WP1Q")));
function $a9563970426cdd61$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a9563970426cdd61$var$EditorTextStyleIcon = (props)=>/*#__PURE__*/ $a9563970426cdd61$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m6.26 6.678-3.237 9.534a.5.5 0 0 0 .473.66h1.032a.75.75 0 0 0 .717-.53l.648-2.107H9.63l.647 2.107a.75.75 0 0 0 .717.53h1.113a.5.5 0 0 0 .473-.66L9.337 6.677A1 1 0 0 0 8.39 6H7.207a1 1 0 0 0-.947.678M7.736 8.08h.051l1.364 4.453H6.372zm11.113 2.043v-.327a1 1 0 0 1 1-1H20a1 1 0 0 1 1 1v6.078a1 1 0 0 1-1 1h-.151a1 1 0 0 1-1-1v-.312h-.088c-.392.874-1.232 1.439-2.418 1.439-1.975 0-3.221-1.613-3.221-4.182 0-2.546 1.254-4.15 3.221-4.15 1.172 0 2.026.595 2.418 1.454zm-.045 2.712c0-1.47-.685-2.404-1.754-2.404s-1.725.92-1.725 2.404c0 1.491.657 2.395 1.725 2.395 1.076 0 1.754-.911 1.754-2.395"/></svg>`
    }, props, {
        newIcon: $a9563970426cdd61$var$_textStyle.default
    }));
$a9563970426cdd61$var$EditorTextStyleIcon.displayName = 'EditorTextStyleIcon';
var $a9563970426cdd61$var$_default = module.exports.default = $a9563970426cdd61$var$EditorTextStyleIcon;

});
parcelRegister("6WP1Q", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::79f720bc74e9099bd9cc2a24f95932ca>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $50efbe1b581ab665$var$_react = $50efbe1b581ab665$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $50efbe1b581ab665$var$_baseNew = $50efbe1b581ab665$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $50efbe1b581ab665$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextStyle".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for text styles in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $50efbe1b581ab665$var$TextStyleIcon = (props)=>/*#__PURE__*/ $50efbe1b581ab665$var$_react.default.createElement($50efbe1b581ab665$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.799.484A.75.75 0 0 1 7.5 0h1.018a.75.75 0 0 1 .701.485l3.733 9.875a.8.8 0 0 1 .048.265V11h-1.5v-.238L10.456 8H5.55L4.5 10.763V11H3v-.375a.8.8 0 0 1 .049-.266zM6.119 6.5h3.77L8.01 1.524z" clip-rule="evenodd"/>`
    }, props));
$50efbe1b581ab665$var$TextStyleIcon.displayName = 'TextStyleIcon';
var $50efbe1b581ab665$var$_default = module.exports.default = $50efbe1b581ab665$var$TextStyleIcon;

});


parcelRegister("fAjN9", function(module, exports) {

$parcel$export(module.exports, "blockTypeMenuItemStyle", () => $238f8284e8f7479b$export$2e548ca9c55ac73f);
$parcel$export(module.exports, "keyboardShortcut", () => $238f8284e8f7479b$export$54ea58af6cf8bf3a);
$parcel$export(module.exports, "keyboardShortcutSelect", () => $238f8284e8f7479b$export$b09cf4fbc27c2bae);
$parcel$export(module.exports, "wrapperSmallStyle", () => $238f8284e8f7479b$export$4f9ef2b7bddb4c3a);
$parcel$export(module.exports, "floatingToolbarWrapperStyle", () => $238f8284e8f7479b$export$a61e5f64ad28e14a);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $lu6Kl = parcelRequire("lu6Kl");
var $ifrjt = parcelRequire("ifrjt");

var $2dMzB = parcelRequire("2dMzB");

function $238f8284e8f7479b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $238f8284e8f7479b$export$2e548ca9c55ac73f = (tagName, selected, typographyTheme)=>{
    // TEMP FIX: See https://product-fabric.atlassian.net/browse/ED-13878
    const selectedStyle = selected ? `${tagName} { color: ${"var(--ds-text, white)"} !important; }` : '';
    return ()=>/*#__PURE__*/ (0, $1NIU8.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        tagName === 'blockquote' ? (0, $lu6Kl.blockquoteSharedStyles) : (0, $ifrjt.headingsSharedStyles)(typographyTheme), ">{h1, h2, h3, h4, h5, h6{margin-top:0;}blockquote{padding-top:0;padding-bottom:0;margin-top:0;}}", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        selectedStyle);
};
const $238f8284e8f7479b$export$54ea58af6cf8bf3a = /*#__PURE__*/ (0, $1NIU8.css)((0, $2dMzB.shortcutStyle), {
    marginLeft: "var(--ds-space-200, 16px)",
    color: `var(--ds-icon, ${(0, $7bb4c1736002a04a$export$eece5f492e429f08)})`
});
const $238f8284e8f7479b$export$b09cf4fbc27c2bae = /*#__PURE__*/ (0, $1NIU8.css)({
    color: `var(--ds-icon, ${(0, $7bb4c1736002a04a$export$eece5f492e429f08)})`
});
const $238f8284e8f7479b$export$4f9ef2b7bddb4c3a = {
    name: "1eh91m4",
    styles: "margin-left:var(--ds-space-050, 4px);min-width:40px"
};
const $238f8284e8f7479b$export$e1f541b6d8e35681 = {
    name: "1igsh0u",
    styles: "margin-left:var(--ds-space-negative-100, -8px)"
};
const $238f8284e8f7479b$export$a61e5f64ad28e14a = {
    name: "1t1gmw4",
    styles: "[data-role='droplistContent']{max-height:90vh;}"
};

});
parcelRegister("2dMzB", function(module, exports) {

$parcel$export(module.exports, "shortcutStyle", () => $c53387095d02f5bd$export$297e5814a2c821bb);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $7yBx7 = parcelRequire("7yBx7");
const $c53387095d02f5bd$export$297e5814a2c821bb = /*#__PURE__*/ (0, $1NIU8.css)("background-color:var(--ds-background-neutral, #091E420F);color:var(--ds-text-subtle, #44546F);border-radius:var(--ds-border-radius, 3px);padding:var(--ds-space-050, 4px);line-height:12px;font-size:", (0, $7yBx7.relativeFontSizeToBase16)(11.67), ";align-self:flex-end;@media (max-width: ", (0, $7yBx7.akEditorMobileMaxWidth), "px){display:none;}");

});





parcelRegister("jfXjJ", function(module, exports) {

$parcel$export(module.exports, "PrimaryToolbarComponent", () => $9a0f29d20eebff80$export$94516d5cccf573e3);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $bMFKb = parcelRequire("bMFKb");

var $kLQ9a = parcelRequire("kLQ9a");
var $bSToC = parcelRequire("bSToC");
var $cxXTK = parcelRequire("cxXTK");

var $dcew5 = parcelRequire("dcew5");
const $9a0f29d20eebff80$var$usePrimaryToolbarComponentPluginState = (0, $kLQ9a.sharedPluginStateHookMigratorFactory)((api)=>{
    const { currentBlockType: currentBlockType, blockTypesDisabled: blockTypesDisabled, availableBlockTypes: availableBlockTypes, availableBlockTypesInDropdown: availableBlockTypesInDropdown, formattingIsPresent: formattingIsPresent } = (0, $cxXTK.useSharedPluginStateWithSelector)(api, [
        'blockType'
    ], (states)=>({
            currentBlockType: states.blockTypeState?.currentBlockType,
            blockTypesDisabled: states.blockTypeState?.blockTypesDisabled,
            availableBlockTypes: states.blockTypeState?.availableBlockTypes,
            availableBlockTypesInDropdown: states.blockTypeState?.availableBlockTypesInDropdown,
            formattingIsPresent: states.blockTypeState?.formattingIsPresent
        }));
    return {
        currentBlockType: currentBlockType,
        blockTypesDisabled: blockTypesDisabled,
        availableBlockTypes: availableBlockTypes,
        availableBlockTypesInDropdown: availableBlockTypesInDropdown,
        formattingIsPresent: formattingIsPresent
    };
}, (api)=>{
    const { blockTypeState: blockTypeState } = (0, $bSToC.useSharedPluginState)(api, [
        'blockType'
    ]);
    return {
        currentBlockType: blockTypeState?.currentBlockType,
        blockTypesDisabled: blockTypeState?.blockTypesDisabled,
        availableBlockTypes: blockTypeState?.availableBlockTypes,
        availableBlockTypesInDropdown: blockTypeState?.availableBlockTypesInDropdown,
        formattingIsPresent: blockTypeState?.formattingIsPresent
    };
});
function $9a0f29d20eebff80$export$94516d5cccf573e3({ api: api, isSmall: isSmall, disabled: disabled, isToolbarReducedSpacing: isToolbarReducedSpacing, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, shouldUseDefaultRole: shouldUseDefaultRole }) {
    const { currentBlockType: currentBlockType, blockTypesDisabled: blockTypesDisabled, availableBlockTypes: availableBlockTypes, availableBlockTypesInDropdown: availableBlockTypesInDropdown, formattingIsPresent: formattingIsPresent } = $9a0f29d20eebff80$var$usePrimaryToolbarComponentPluginState(api);
    const boundSetBlockType = (name, fromBlockQuote)=>api?.core?.actions.execute(api?.blockType?.commands?.setTextLevel(name, (0, $bMFKb.INPUT_METHOD).TOOLBAR, fromBlockQuote));
    const wrapBlockQuote = ()=>api?.core?.actions.execute(api?.blockType?.commands?.insertBlockQuote((0, $bMFKb.INPUT_METHOD).TOOLBAR));
    const clearFormatting = ()=>api?.core?.actions.execute(api?.blockType?.commands?.clearFormatting((0, $bMFKb.INPUT_METHOD).TOOLBAR));
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dcew5.default), {
        isSmall: isSmall,
        isDisabled: disabled,
        isReducedSpacing: isToolbarReducedSpacing,
        setTextLevel: boundSetBlockType,
        wrapBlockQuote: wrapBlockQuote,
        clearFormatting: clearFormatting,
        currentBlockType: currentBlockType,
        blockTypesDisabled: blockTypesDisabled,
        availableBlockTypes: availableBlockTypes,
        availableBlockTypesInDropdown: availableBlockTypesInDropdown,
        formattingIsPresent: formattingIsPresent,
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        shouldUseDefaultRole: shouldUseDefaultRole,
        api: api
    });
}

});



parcelRegister("2gWfu", function(module, exports) {

$parcel$export(module.exports, "cardPlugin", () => (parcelRequire("89YFQ")).cardPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $89YFQ = parcelRequire("89YFQ");

});
parcelRegister("89YFQ", function(module, exports) {

$parcel$export(module.exports, "cardPlugin", () => $34ed915a9f83181a$export$2a6748328f902e16);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6dRXt = parcelRequire("6dRXt");

var $c1NDo = parcelRequire("c1NDo");

var $7WlTe = parcelRequire("7WlTe");

var $k9y0J = parcelRequire("k9y0J");
var $7BBxG = parcelRequire("7BBxG");

var $eGOwo = parcelRequire("eGOwo");

var $k4KZn = parcelRequire("k4KZn");

var $cJIFZ = parcelRequire("cJIFZ");

var $kmVsW = parcelRequire("kmVsW");

var $ecNk4 = parcelRequire("ecNk4");

var $4AOcQ = parcelRequire("4AOcQ");

var $kDpD9 = parcelRequire("kDpD9");

var $7CcXr = parcelRequire("7CcXr");

var $cuJUr = parcelRequire("cuJUr");

var $gXgTX = parcelRequire("gXgTX");

var $2smZh = parcelRequire("2smZh");

var $5qTHh = parcelRequire("5qTHh");

var $8gCT1 = parcelRequire("8gCT1");

var $6BNOR = parcelRequire("6BNOR");

var $e5Kya = parcelRequire("e5Kya");

var $3YtqI = parcelRequire("3YtqI");
const $34ed915a9f83181a$export$2a6748328f902e16 = ({ config: options = {}, api: api })=>{
    let previousCardProvider;
    const cardPluginEvents = (0, $2smZh.createEventsQueue)();
    api?.base?.actions.registerMarks(({ tr: tr, node: node, pos: pos })=>{
        const { doc: doc } = tr;
        const { schema: schema } = doc.type;
        const { inlineCard: inlineCardNodeType } = schema.nodes;
        if (node.type === inlineCardNodeType) {
            const newText = node.attrs.url;
            const currentPos = tr.mapping.map(pos);
            tr.replaceWith(currentPos, currentPos + node.nodeSize, schema.text(newText, node.marks));
        }
    });
    return {
        name: 'card',
        getSharedState (editorState) {
            if (!editorState) return null;
            return (0, $cuJUr.pluginKey).getState(editorState) || null;
        },
        nodes () {
            const nodes = [
                {
                    name: 'inlineCard',
                    node: (0, $kmVsW.inlineCardSpecWithFixedToDOM)()
                },
                {
                    name: 'blockCard',
                    node: (0, $k4KZn.blockCardSpecWithFixedToDOM)()
                }
            ];
            if (options.allowEmbeds) nodes.push({
                name: 'embedCard',
                node: (0, $cJIFZ.embedCardSpecWithFixedToDOM)()
            });
            return nodes;
        },
        pmPlugins () {
            const allowBlockCards = options.allowBlockCards ?? true;
            const allowResizing = options.allowResizing ?? true;
            const useAlternativePreloader = options.useAlternativePreloader ?? true;
            const allowWrapping = options.allowWrapping ?? true;
            const allowAlignment = options.allowAlignment ?? true;
            const allowDatasource = options.allowDatasource ?? false;
            const showUpgradeDiscoverability = options.showUpgradeDiscoverability ?? true;
            const plugins = [
                {
                    name: 'card',
                    plugin: (0, $7CcXr.createPlugin)({
                        ...options,
                        allowBlockCards: allowBlockCards,
                        allowResizing: allowResizing,
                        useAlternativePreloader: useAlternativePreloader,
                        allowWrapping: allowWrapping,
                        allowAlignment: allowAlignment,
                        allowDatasource: allowDatasource,
                        cardPluginEvents: cardPluginEvents,
                        showUpgradeDiscoverability: showUpgradeDiscoverability
                    }, api)
                }
            ];
            plugins.push({
                name: 'cardKeymap',
                plugin: ({ featureFlags: featureFlags })=>{
                    return (0, $kDpD9.cardKeymap)(featureFlags);
                }
            });
            return plugins;
        },
        contentComponent ({ editorView: editorView, popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement, popupsBoundariesElement: popupsBoundariesElement }) {
            const breakoutEnabled = options.editorAppearance === 'full-page';
            return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6BNOR.EditorSmartCardEvents), {
                        editorView: editorView
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8gCT1.EditorLinkingPlatformAnalytics), {
                        cardPluginEvents: cardPluginEvents,
                        editorView: editorView
                    }),
                    breakoutEnabled && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $e5Kya.default), {
                        api: api,
                        editorView: editorView,
                        mountPoint: popupsMountPoint,
                        scrollableElement: popupsScrollableElement,
                        boundariesElement: popupsBoundariesElement
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5qTHh.default), {
                        api: api,
                        editorView: editorView
                    })
                ]
            });
        },
        actions: {
            setProvider: async (providerPromise)=>{
                const provider = await providerPromise;
                // Prevent someone trying to set the exact same provider twice for performance reasons
                if (previousCardProvider === provider || options?.provider === providerPromise) return false;
                previousCardProvider = provider;
                return api?.core.actions.execute(({ tr: tr })=>(0, $ecNk4.setProvider)(provider)(tr)) ?? false;
            },
            hideLinkToolbar: $ecNk4.hideLinkToolbar,
            queueCardsFromChangedTr: $4AOcQ.queueCardsFromChangedTr,
            getStartingToolbarItems: (0, $3YtqI.getStartingToolbarItems)(options, api),
            getEndingToolbarItems: (0, $3YtqI.getEndingToolbarItems)(options, api)
        },
        pluginsOptions: {
            floatingToolbar: (0, $3YtqI.floatingToolbar)(options, options.lpLinkPicker ?? false, options.linkPicker, api, options.disableFloatingToolbar),
            quickInsert: ({ formatMessage: formatMessage })=>{
                const quickInsertArray = [];
                if (!options.allowDatasource) return quickInsertArray;
                quickInsertArray.push({
                    id: 'datasource',
                    title: formatMessage((0, $eGOwo.fg)('confluence-issue-terminology-refresh') ? (0, $6dRXt.messages).datasourceJiraIssueIssueTermRefresh : (0, $6dRXt.messages).datasourceJiraIssue),
                    description: formatMessage((0, $eGOwo.fg)('confluence-issue-terminology-refresh') ? (0, $6dRXt.messages).datasourceJiraIssueDescriptionIssueTermRefresh : (0, $6dRXt.messages).datasourceJiraIssueDescription),
                    isDisabledOffline: true,
                    categories: [
                        'external-content',
                        'development'
                    ],
                    keywords: [
                        'jira'
                    ],
                    featured: true,
                    icon: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $c1NDo.IconDatasourceJiraIssue), {}),
                    action (insert) {
                        const tr = insert(undefined);
                        (0, $ecNk4.showDatasourceModal)('jira')(tr);
                        return tr;
                    }
                });
                if ((0, $7WlTe.canRenderDatasource)((0, $k9y0J.ASSETS_LIST_OF_LINKS_DATASOURCE_ID))) quickInsertArray.push({
                    id: 'datasource',
                    title: formatMessage((0, $6dRXt.messages).datasourceAssetsObjectsGeneralAvailability),
                    description: formatMessage((0, $6dRXt.messages).datasourceAssetsObjectsDescription),
                    isDisabledOffline: true,
                    categories: [
                        'external-content',
                        'development'
                    ],
                    keywords: [
                        'assets'
                    ],
                    icon: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $c1NDo.IconDatasourceAssetsObjects), {}),
                    action (insert) {
                        const tr = insert(undefined);
                        (0, $ecNk4.showDatasourceModal)('assets')(tr);
                        return tr;
                    }
                });
                if ((0, $gXgTX.isDatasourceConfigEditable)((0, $7BBxG.CONFLUENCE_SEARCH_DATASOURCE_ID))) quickInsertArray.push({
                    id: 'datasource',
                    title: formatMessage((0, $6dRXt.messages).datasourceConfluenceSearch),
                    description: formatMessage((0, $6dRXt.messages).datasourceConfluenceSearchDescription),
                    isDisabledOffline: true,
                    categories: [
                        'external-content',
                        'development'
                    ],
                    keywords: [
                        'confluence'
                    ],
                    featured: true,
                    icon: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $c1NDo.IconDatasourceConfluenceSearch), {}),
                    action (insert) {
                        const tr = insert(undefined);
                        (0, $ecNk4.showDatasourceModal)('confluence-search')(tr);
                        return tr;
                    }
                });
                return quickInsertArray;
            }
        }
    };
};

});
parcelRegister("7WlTe", function(module, exports) {

$parcel$export(module.exports, "getDatasourceType", () => $735e61d500130c4c$export$19af9860957ca153);
$parcel$export(module.exports, "canRenderDatasource", () => $735e61d500130c4c$export$1974047c293dd52e);

var $k9y0J = parcelRequire("k9y0J");
var $7BBxG = parcelRequire("7BBxG");
var $7KhEE = parcelRequire("7KhEE");

var $eGOwo = parcelRequire("eGOwo");
const $735e61d500130c4c$export$19af9860957ca153 = (datasourceId)=>{
    switch(datasourceId){
        case 0, $7KhEE.JIRA_LIST_OF_LINKS_DATASOURCE_ID:
            return 'jira';
        case 0, $k9y0J.ASSETS_LIST_OF_LINKS_DATASOURCE_ID:
            return 'assets';
        case 0, $7BBxG.CONFLUENCE_SEARCH_DATASOURCE_ID:
            return 'confluence-search';
        default:
            return undefined;
    }
};
const $735e61d500130c4c$export$1974047c293dd52e = (datasourceId, defaultValue = true)=>{
    const datasourceType = $735e61d500130c4c$export$19af9860957ca153(datasourceId);
    switch(datasourceType){
        case 'jira':
            return true;
        case 'assets':
            if ((0, $eGOwo.fg)('linking_platform_datasource_assets_objects')) return true;
            return false;
        default:
            return defaultValue;
    }
};

});
parcelRegister("k9y0J", function(module, exports) {

$parcel$export(module.exports, "ASSETS_LIST_OF_LINKS_DATASOURCE_ID", () => $16f3892d5aa02916$export$34a6fbdd67f09ff6);
$parcel$export(module.exports, "default", () => $16f3892d5aa02916$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
const $16f3892d5aa02916$export$34a6fbdd67f09ff6 = '361d618a-3c04-40ad-9b27-3c8ea6927020';

const $16f3892d5aa02916$var$LazyAssetsConfigModal = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("kacac")).then((module)=>({
            default: module.AssetsConfigModal
        })));
const $16f3892d5aa02916$var$AssetsConfigModalWithWrappers = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJOHy.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            "data-testid": 'assets-aql-datasource-table-suspense'
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($16f3892d5aa02916$var$LazyAssetsConfigModal, props));
};
var $16f3892d5aa02916$export$2e2bcd8739ae039 = $16f3892d5aa02916$var$AssetsConfigModalWithWrappers;

});
parcelRegister("kacac", function(module, exports) {

let $eade2d3ba2053832$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $eade2d3ba2053832$var$load("fliVL"),
    $eade2d3ba2053832$var$load("kNFvF"),
    $eade2d3ba2053832$var$load("76n7a"),
    $eade2d3ba2053832$var$load("l253H"),
    $eade2d3ba2053832$var$load("ffQaD"),
    $eade2d3ba2053832$var$load("kvRbA"),
    $eade2d3ba2053832$var$load("gxPBZ")
]).then(()=>parcelRequire('i1bWW'));

});


parcelRegister("7BBxG", function(module, exports) {

$parcel$export(module.exports, "CONFLUENCE_SEARCH_DATASOURCE_ID", () => $aaf2311a623c98ee$export$d9788d6cf1867282);
$parcel$export(module.exports, "default", () => $aaf2311a623c98ee$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
const $aaf2311a623c98ee$export$d9788d6cf1867282 = '768fc736-3af4-4a8f-b27e-203602bff8ca';

const $aaf2311a623c98ee$var$LazyConfluenceSearchConfigModal = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("aQLyR")).then((module)=>({
            default: module.ConfluenceSearchConfigModal
        })));
const $aaf2311a623c98ee$var$ConfluenceSearchConfigModalWithWrappers = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJOHy.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            "data-testid": 'confluence-search-datasource-table-suspense'
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($aaf2311a623c98ee$var$LazyConfluenceSearchConfigModal, props));
};
var $aaf2311a623c98ee$export$2e2bcd8739ae039 = $aaf2311a623c98ee$var$ConfluenceSearchConfigModalWithWrappers;

});
parcelRegister("aQLyR", function(module, exports) {

let $7e63a767a7765e04$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $7e63a767a7765e04$var$load("fliVL"),
    $7e63a767a7765e04$var$load("kNFvF"),
    $7e63a767a7765e04$var$load("76n7a"),
    $7e63a767a7765e04$var$load("l253H"),
    $7e63a767a7765e04$var$load("ffQaD"),
    $7e63a767a7765e04$var$load("kvRbA"),
    $7e63a767a7765e04$var$load("lLdNy")
]).then(()=>parcelRequire('a1XeP'));

});


parcelRegister("7KhEE", function(module, exports) {

$parcel$export(module.exports, "JIRA_LIST_OF_LINKS_DATASOURCE_ID", () => $b6adaf62d6e1c249$export$8ce19958117ece5c);
$parcel$export(module.exports, "default", () => $b6adaf62d6e1c249$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
const $b6adaf62d6e1c249$export$8ce19958117ece5c = 'd8b75300-dfda-4519-b6cd-e49abbd50401';

const $b6adaf62d6e1c249$var$LazyJiraIssuesConfigModal = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("4XMdj")).then((module)=>({
            default: module.JiraIssuesConfigModal
        })));
const $b6adaf62d6e1c249$var$JiraIssuesConfigModalWithWrappers = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJOHy.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            "data-testid": 'jira-datasource-table-suspense'
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b6adaf62d6e1c249$var$LazyJiraIssuesConfigModal, props));
};
var $b6adaf62d6e1c249$export$2e2bcd8739ae039 = $b6adaf62d6e1c249$var$JiraIssuesConfigModalWithWrappers;

});
parcelRegister("4XMdj", function(module, exports) {

let $39d21256ddeb6106$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $39d21256ddeb6106$var$load("fliVL"),
    $39d21256ddeb6106$var$load("kNFvF"),
    $39d21256ddeb6106$var$load("76n7a"),
    $39d21256ddeb6106$var$load("l253H"),
    $39d21256ddeb6106$var$load("ffQaD"),
    $39d21256ddeb6106$var$load("kvRbA"),
    $39d21256ddeb6106$var$load("7FotB")
]).then(()=>parcelRequire('fjaM1'));

});



parcelRegister("k4KZn", function(module, exports) {

$parcel$export(module.exports, "blockCardSpecWithFixedToDOM", () => $cd4942533d0f12a2$export$f664dd11022c8749);

var $5sqgz = parcelRequire("5sqgz");

var $6D3CR = parcelRequire("6D3CR");

const $cd4942533d0f12a2$export$f664dd11022c8749 = ()=>{
    return {
        ...(0, $5sqgz.blockCard),
        toDOM: (node)=>{
            const { url: url } = node.attrs;
            const { data: data } = node.attrs;
            const { layout: layout, width: width, datasource: datasource } = node.attrs;
            const attrs = {
                'data-block-card': '',
                'data-card-url': url || '',
                'data-card-data': data ? JSON.stringify(data) : '',
                'data-datasource': datasource ? JSON.stringify(datasource) : '',
                'data-layout': layout,
                'data-width': `${width}`,
                class: 'blockCardView-content-wrap'
            };
            return [
                'div',
                attrs,
                [
                    'a',
                    {
                        // To match `packages/linking-platform/smart-card/src/view/CardWithUrl/component-lazy/LoadingCardLink.tsx`
                        // Which uses frame styling `packages/linking-platform/smart-card/src/view/InlineCard/Frame/styled.ts`
                        style: (0, $6D3CR.convertToInlineCss)({
                            padding: `${"var(--ds-space-025, 2px)"} 0px`,
                            marginLeft: "var(--ds-space-negative-025, -2px)",
                            display: 'inline',
                            boxDecorationBreak: 'clone',
                            WebkitBoxDecorationBreak: 'clone',
                            borderRadius: "var(--ds-border-radius-100, 4px)",
                            color: `var(--ds-link, ${(0, $7bb4c1736002a04a$export$b3de0ae08da2ce64)})`,
                            lineHeight: '22px',
                            WebkitTransition: '0.1s all ease-in-out',
                            transition: '0.1s all ease-in-out',
                            userSelect: 'text',
                            WebkitUserSelect: 'text',
                            msUserSelect: 'text',
                            MozUserSelect: 'none' // -moz-user-select
                        }),
                        href: url || ''
                    },
                    node?.attrs?.url || ' '
                ]
            ];
        }
    };
};

});

parcelRegister("cJIFZ", function(module, exports) {

$parcel$export(module.exports, "embedCardSpecWithFixedToDOM", () => $9fc0196aaab8dcfd$export$f8faabd3267a007e);
/**
 * Some of these functions and styling are duplicated from their custom node view equivalents
 *
 * WHY?
 * This will eventually move to `@atlaskit/adf-schema` and we cannot reference
 * `@atlaskit/editor-common` from here or it will cause dependency issues.
 *
 * In the long term likely `toDOM` will move back out of `adf-schema` in which
 * case we can consolidate them.
 */ 
var $YIci7 = parcelRequire("YIci7");

var $6D3CR = parcelRequire("6D3CR");

var $7yBx7 = parcelRequire("7yBx7");

// From `packages/editor/editor-common/src/ui/MediaSingle/styled.tsx`
function $9fc0196aaab8dcfd$var$calcMargin(layout) {
    switch(layout){
        case 'wrap-right':
            return '12px auto 12px 12px';
        case 'wrap-left':
            return '12px 12px 12px auto';
        default:
            return '24px auto';
    }
}
// From `packages/editor/editor-common/src/ui/MediaSingle/styled.tsx`
function $9fc0196aaab8dcfd$var$float(layout) {
    switch(layout){
        case 'wrap-right':
            return 'right';
        case 'wrap-left':
            return 'left';
        default:
            return 'none';
    }
}
// From `packages/editor/editor-common/src/media-single/constants.ts`
const $9fc0196aaab8dcfd$var$MEDIA_SINGLE_GUTTER_SIZE = 24;
// From `packages/editor/editor-common/src/ui/MediaSingle/styled.tsx`
function $9fc0196aaab8dcfd$var$calcPxFromPct(pct, lineLength) {
    const maxWidth = lineLength + $9fc0196aaab8dcfd$var$MEDIA_SINGLE_GUTTER_SIZE;
    return maxWidth * pct - $9fc0196aaab8dcfd$var$MEDIA_SINGLE_GUTTER_SIZE;
}
// ED-24488: We can't retrieve the editor width from here easily.
// For now we're using the default line length here, but this will be
// incorrect on smaller devices.
const $9fc0196aaab8dcfd$var$LINE_LENGTH = 760;
const $9fc0196aaab8dcfd$export$f8faabd3267a007e = ()=>{
    return {
        ...(0, $YIci7.embedCard),
        toDOM: (node)=>{
            const { url: url, layout: layout, width: width, originalWidth: originalWidth, originalHeight: originalHeight } = node.attrs;
            const aspectRatio = originalWidth && originalHeight ? originalWidth / originalHeight : (0, $7yBx7.DEFAULT_EMBED_CARD_WIDTH) / (0, $7yBx7.DEFAULT_EMBED_CARD_HEIGHT);
            const attrs = {
                'data-embed-card': '',
                'data-card-url': url,
                'data-layout': layout,
                'data-width': width,
                'data-original-width': originalWidth,
                'data-original-height': originalHeight,
                class: 'embedCardView-content-wrap',
                // From `packages/editor/editor-plugin-card/src/ui/ResizableEmbedCard.tsx`
                style: (0, $6D3CR.convertToInlineCss)({
                    margin: $9fc0196aaab8dcfd$var$calcMargin(layout),
                    width: `${Math.ceil($9fc0196aaab8dcfd$var$calcPxFromPct(width / 100, $9fc0196aaab8dcfd$var$LINE_LENGTH))}px`,
                    marginRight: layout === 'align-end' ? '0' : '',
                    marginLeft: layout === 'align-start' ? '0' : '',
                    float: $9fc0196aaab8dcfd$var$float(layout)
                })
            };
            return [
                'div',
                attrs,
                // This is the only modification to the embed card `toDOM`
                // This is to match the behaviour of Card which lazy loads
                // and uses just a URL as a fallback
                //
                // To match: `packages/linking-platform/smart-card/src/view/CardWithUrl/component-lazy/LoadingCardLink.tsx`
                [
                    'a',
                    {
                        style: (0, $6D3CR.convertToInlineCss)({
                            padding: `${"var(--ds-space-025, 2px)"} 0px`,
                            marginLeft: "var(--ds-space-negative-025, -2px)",
                            display: 'inline',
                            boxDecorationBreak: 'clone',
                            borderRadius: "var(--ds-border-radius-100, 4px)",
                            color: `var(--ds-link, ${(0, $7bb4c1736002a04a$export$b3de0ae08da2ce64)})`,
                            lineHeight: '22px',
                            WebkitTransition: '0.1s all ease-in-out',
                            transition: '0.1s all ease-in-out',
                            userSelect: 'text',
                            WebkitUserSelect: 'text',
                            msUserSelect: 'text',
                            MozUserSelect: 'none' // -moz-user-select
                        })
                    },
                    url ?? ''
                ],
                // From `packages/editor/editor-plugin-card/src/ui/ResizableEmbedCard.tsx`
                // The `getHeightDefiningComponent` that defines the height of the element
                [
                    'span',
                    {
                        style: (0, $6D3CR.convertToInlineCss)({
                            display: 'block',
                            paddingBottom: `calc(${(1 / aspectRatio * 100).toFixed(3)}% + ${"var(--ds-space-400, 32px)"})`
                        })
                    }
                ]
            ];
        }
    };
};

});

parcelRegister("kmVsW", function(module, exports) {

$parcel$export(module.exports, "inlineCardSpecWithFixedToDOM", () => $a2010a48e794b079$export$290edac762b9f37c);

var $3MHOZ = parcelRequire("3MHOZ");

var $6D3CR = parcelRequire("6D3CR");

const $a2010a48e794b079$export$290edac762b9f37c = ()=>{
    return {
        ...(0, $3MHOZ.inlineCard),
        toDOM: (node)=>{
            const wrapperAttrs = {
                class: 'inlineCardView-content-wrap inlineNodeView'
            };
            const cardAttrs = {
                'aria-busy': 'true',
                class: 'card'
            };
            const attrs = {
                'data-inline-card': '',
                href: node.attrs.url || '',
                'data-card-data': node.attrs.data ? JSON.stringify(node.attrs.data) : '',
                // LoadingCardLink used for Suspense in `packages/linking-platform/smart-card/src/view/CardWithUrl/loader.tsx`
                // We need to match the style of LoadingCardLink
                // Which uses frame styling `packages/linking-platform/smart-card/src/view/InlineCard/Frame/styled.ts`, with withoutBackground=true
                style: (0, $6D3CR.convertToInlineCss)({
                    padding: `${"var(--ds-space-025, 2px)"} 0px`,
                    marginLeft: "var(--ds-space-negative-025, -2px)",
                    display: 'inline',
                    boxDecorationBreak: 'clone',
                    WebkitBoxDecorationBreak: 'clone',
                    borderRadius: "var(--ds-border-radius-100, 4px)",
                    color: `var(--ds-link, ${(0, $7bb4c1736002a04a$export$b3de0ae08da2ce64)})`,
                    lineHeight: '22px',
                    WebkitTransition: '0.1s all ease-in-out',
                    transition: '0.1s all ease-in-out',
                    userSelect: 'text',
                    WebkitUserSelect: 'text',
                    msUserSelect: 'text',
                    MozUserSelect: 'none' // -moz-user-select
                })
            };
            if (node.attrs.url) return [
                'span',
                wrapperAttrs,
                [
                    'span',
                    cardAttrs,
                    [
                        'a',
                        attrs,
                        node.attrs.url
                    ]
                ]
            ];
            else return [
                'span',
                wrapperAttrs,
                [
                    'span',
                    cardAttrs,
                    [
                        'a',
                        attrs
                    ]
                ]
            ];
        }
    };
};

});

parcelRegister("ecNk4", function(module, exports) {

$parcel$export(module.exports, "resolveCard", () => $948d9ae8f4d2ea0c$export$2b7045d36e3e01d4);
$parcel$export(module.exports, "queueCards", () => $948d9ae8f4d2ea0c$export$5312e3a17c3f6d3);
$parcel$export(module.exports, "registerCard", () => $948d9ae8f4d2ea0c$export$af5afab36c1f83f6);
$parcel$export(module.exports, "removeCard", () => $948d9ae8f4d2ea0c$export$3301f76e6efaf85e);
$parcel$export(module.exports, "registerRemoveOverlay", () => $948d9ae8f4d2ea0c$export$a3d5a5cb818ce9d9);
$parcel$export(module.exports, "registerSmartCardEvents", () => $948d9ae8f4d2ea0c$export$55288255874724a1);
$parcel$export(module.exports, "setProvider", () => $948d9ae8f4d2ea0c$export$1572b3eade6662f9);
$parcel$export(module.exports, "setDatasourceTableRef", () => $948d9ae8f4d2ea0c$export$f9c5be16586d220a);
$parcel$export(module.exports, "setCardLayout", () => $948d9ae8f4d2ea0c$export$c9a25858ed46807c);
$parcel$export(module.exports, "setCardLayoutAndDatasourceTableRef", () => $948d9ae8f4d2ea0c$export$dd3435a1df9b2a3f);
$parcel$export(module.exports, "showLinkToolbar", () => $948d9ae8f4d2ea0c$export$83c364d103479f90);
$parcel$export(module.exports, "hideLinkToolbar", () => $948d9ae8f4d2ea0c$export$bd1cd60a9b31da5e);
$parcel$export(module.exports, "showDatasourceModal", () => $948d9ae8f4d2ea0c$export$2c79f54b873d04be);
$parcel$export(module.exports, "hideDatasourceModal", () => $948d9ae8f4d2ea0c$export$e545bc176b552938);
$parcel$export(module.exports, "clearOverlayCandidate", () => $948d9ae8f4d2ea0c$export$a2922c2e95ff48f7);
$parcel$export(module.exports, "setDatasourceStash", () => $948d9ae8f4d2ea0c$export$53e36aa41bbce673);
$parcel$export(module.exports, "removeDatasourceStash", () => $948d9ae8f4d2ea0c$export$4b1fde77584594b5);

var $cuJUr = parcelRequire("cuJUr");
const $948d9ae8f4d2ea0c$export$a884a52152489cc3 = (tr, action)=>{
    return tr.setMeta((0, $cuJUr.pluginKey), action);
};
const $948d9ae8f4d2ea0c$export$2b7045d36e3e01d4 = (url)=>(tr)=>$948d9ae8f4d2ea0c$export$a884a52152489cc3(tr, {
            type: 'RESOLVE',
            url: url
        });
const $948d9ae8f4d2ea0c$export$5312e3a17c3f6d3 = (requests)=>(tr)=>$948d9ae8f4d2ea0c$export$a884a52152489cc3(tr, {
            type: 'QUEUE',
            requests: requests
        });
const $948d9ae8f4d2ea0c$export$af5afab36c1f83f6 = (info)=>(tr)=>$948d9ae8f4d2ea0c$export$a884a52152489cc3(tr, {
            type: 'REGISTER',
            info: info
        });
const $948d9ae8f4d2ea0c$export$3301f76e6efaf85e = (info)=>(tr)=>$948d9ae8f4d2ea0c$export$a884a52152489cc3(tr, {
            type: 'REMOVE_CARD',
            info: info
        });
const $948d9ae8f4d2ea0c$export$a3d5a5cb818ce9d9 = (callback, info)=>(tr)=>$948d9ae8f4d2ea0c$export$a884a52152489cc3(tr, {
            type: 'REGISTER_REMOVE_OVERLAY_ON_INSERTED_LINK',
            callback: callback,
            info: info
        });
const $948d9ae8f4d2ea0c$export$55288255874724a1 = (smartLinkEvents)=>(tr)=>$948d9ae8f4d2ea0c$export$a884a52152489cc3(tr, {
            type: 'REGISTER_EVENTS',
            smartLinkEvents: smartLinkEvents
        });
const $948d9ae8f4d2ea0c$export$1572b3eade6662f9 = (cardProvider)=>(tr)=>$948d9ae8f4d2ea0c$export$a884a52152489cc3(tr, {
            type: 'SET_PROVIDER',
            provider: cardProvider
        });
const $948d9ae8f4d2ea0c$export$f9c5be16586d220a = (datasourceTableRef)=>(tr)=>$948d9ae8f4d2ea0c$export$a884a52152489cc3(tr, {
            type: 'SET_DATASOURCE_TABLE_REF',
            datasourceTableRef: datasourceTableRef
        });
const $948d9ae8f4d2ea0c$export$c9a25858ed46807c = (layout)=>(tr)=>$948d9ae8f4d2ea0c$export$a884a52152489cc3(tr, {
            type: 'SET_CARD_LAYOUT',
            layout: layout
        });
const $948d9ae8f4d2ea0c$export$dd3435a1df9b2a3f = ({ layout: layout, datasourceTableRef: datasourceTableRef })=>(tr)=>$948d9ae8f4d2ea0c$export$a884a52152489cc3(tr, {
            type: 'SET_CARD_LAYOUT_AND_DATASOURCE_TABLE_REF',
            layout: layout,
            datasourceTableRef: datasourceTableRef
        });
const $948d9ae8f4d2ea0c$export$83c364d103479f90 = (tr)=>$948d9ae8f4d2ea0c$export$a884a52152489cc3(tr, {
        type: 'SHOW_LINK_TOOLBAR'
    });
const $948d9ae8f4d2ea0c$export$bd1cd60a9b31da5e = (tr)=>$948d9ae8f4d2ea0c$export$a884a52152489cc3(tr, {
        type: 'HIDE_LINK_TOOLBAR'
    });
const $948d9ae8f4d2ea0c$export$2c79f54b873d04be = (modalType)=>(tr)=>$948d9ae8f4d2ea0c$export$a884a52152489cc3(tr, {
            type: 'SHOW_DATASOURCE_MODAL',
            modalType: modalType
        });
const $948d9ae8f4d2ea0c$export$e545bc176b552938 = (tr)=>$948d9ae8f4d2ea0c$export$a884a52152489cc3(tr, {
        type: 'HIDE_DATASOURCE_MODAL'
    });
const $948d9ae8f4d2ea0c$export$a2922c2e95ff48f7 = (tr)=>$948d9ae8f4d2ea0c$export$a884a52152489cc3(tr, {
        type: 'CLEAR_OVERLAY_CANDIDATE'
    });
const $948d9ae8f4d2ea0c$export$53e36aa41bbce673 = (tr, datasourceStash)=>$948d9ae8f4d2ea0c$export$a884a52152489cc3(tr, {
        type: 'SET_DATASOURCE_STASH',
        datasourceStash: datasourceStash
    });
const $948d9ae8f4d2ea0c$export$4b1fde77584594b5 = (tr, url)=>$948d9ae8f4d2ea0c$export$a884a52152489cc3(tr, {
        type: 'REMOVE_DATASOURCE_STASH',
        url: url
    });

});
parcelRegister("cuJUr", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $b5a0e4c4c19277eb$export$18d4026d1ea86bb1);

var $3lIcL = parcelRequire("3lIcL");
const $b5a0e4c4c19277eb$export$18d4026d1ea86bb1 = new (0, $3lIcL.PluginKey)('cardPlugin');

});


parcelRegister("4AOcQ", function(module, exports) {

$parcel$export(module.exports, "replaceQueuedUrlWithCard", () => $6d6ce30678fee3de$export$78f5a0da64579d3e);
$parcel$export(module.exports, "handleFallbackWithAnalytics", () => $6d6ce30678fee3de$export$2bb01cc4a12e0b44);
$parcel$export(module.exports, "queueCardsFromChangedTr", () => $6d6ce30678fee3de$export$f17c48478174211e);
$parcel$export(module.exports, "changeSelectedCardToLink", () => $6d6ce30678fee3de$export$3f14f692ecc2a0d9);
$parcel$export(module.exports, "changeSelectedCardToLinkFallback", () => $6d6ce30678fee3de$export$56a04318a610dc7c);
$parcel$export(module.exports, "updateCard", () => $6d6ce30678fee3de$export$884fcee347ca969b);
$parcel$export(module.exports, "changeSelectedCardToText", () => $6d6ce30678fee3de$export$23c9e012c8c1ce24);
$parcel$export(module.exports, "setSelectedCardAppearance", () => $6d6ce30678fee3de$export$a188ef61ddbb94f);
$parcel$export(module.exports, "updateCardViaDatasource", () => $6d6ce30678fee3de$export$113cdaf1b279f308);
$parcel$export(module.exports, "insertDatasource", () => $6d6ce30678fee3de$export$7f7b236478a618df);

var $cSmYj = parcelRequire("cSmYj");

var $iKozC = parcelRequire("iKozC");

var $bMFKb = parcelRequire("bMFKb");
var $92h4E = parcelRequire("92h4E");
var $97Qim = parcelRequire("97Qim");

var $6C2m6 = parcelRequire("6C2m6");

var $a36Ig = parcelRequire("a36Ig");

var $7TRmB = parcelRequire("7TRmB");
var $grDTV = parcelRequire("grDTV");
var $bnAxN = parcelRequire("bnAxN");
var $51k6y = parcelRequire("51k6y");

var $kuxd1 = parcelRequire("kuxd1");

var $3lIcL = parcelRequire("3lIcL");

var $eGOwo = parcelRequire("eGOwo");

var $92xoS = parcelRequire("92xoS");

var $ecNk4 = parcelRequire("ecNk4");

var $cuJUr = parcelRequire("cuJUr");

var $97hFs = parcelRequire("97hFs");

var $gXgTX = parcelRequire("gXgTX");
/**
 * Attempt to replace the link into the respective card.
 */ function $6d6ce30678fee3de$var$replaceLinksToCards(tr, cardAdf, schema, request) {
    const { inlineCard: inlineCard } = schema.nodes;
    const { url: url } = request;
    if (!(0, $iKozC.isSafeUrl)(url)) return;
    // replace all the outstanding links with their cards
    const pos = tr.mapping.map(request.pos);
    const $pos = tr.doc.resolve(pos);
    const $head = tr.selection.$head;
    const node = tr.doc.nodeAt(pos);
    if (!node || !node.type.isText) return;
    const replaceLink = request.shouldReplaceLink || (0, $97hFs.shouldReplaceLink)(node, request.compareLinkText, url);
    if (!replaceLink) return;
    // ED-5638: add an extra space after inline cards to avoid re-rendering them
    const nodes = [
        cardAdf
    ];
    if (cardAdf.type === inlineCard) nodes.push(schema.text(' '));
    tr.replaceWith(pos, pos + (node.text || url).length, nodes);
    if ((0, $eGOwo.fg)('editor_inline_comments_paste_insert_nodes')) {
        const annotationMarksForPos = (0, $7TRmB.getAnnotationMarksForPos)($head);
        if (annotationMarksForPos && annotationMarksForPos.length > 0) annotationMarksForPos.forEach((annotationMark)=>{
            // Add the annotation mark on to the inlineCard node and the trailing space node.
            tr.addMark(pos, pos + nodes[0].nodeSize + nodes[1].nodeSize, annotationMark);
        });
    }
    return $pos.node($pos.depth - 1).type.name;
}
const $6d6ce30678fee3de$export$78f5a0da64579d3e = (url, cardData, analyticsAction, editorAnalyticsApi, createAnalyticsEvent)=>(editorState, dispatch)=>{
        const state = (0, $cuJUr.pluginKey).getState(editorState);
        if (!state) return false;
        // find the requests for this URL
        const requests = state.requests.filter((req)=>req.url === url);
        // try to transform response to ADF
        const schema = editorState.schema;
        const cardAdf = (0, $51k6y.processRawValue)(schema, cardData);
        const tr = editorState.tr;
        if (cardAdf) {
            // Should prevent any other node than cards? [inlineCard, blockCard].includes(cardAdf.type)
            const nodeContexts = requests.map((request)=>$6d6ce30678fee3de$var$replaceLinksToCards(tr, cardAdf, schema, request)).filter((context)=>!!context); // context exist
            // Send analytics information
            if (nodeContexts.length) {
                const nodeContext = nodeContexts.every((context)=>context === nodeContexts[0]) ? nodeContexts[0] : 'mixed';
                /** For block links v1, default to inline links */ const nodeType = 'inlineCard';
                const [, , domainName] = url.split('/');
                if (state.smartLinkEvents) state.smartLinkEvents.insertSmartLink(domainName, 'inline', createAnalyticsEvent);
                /**
				 * TODO:
				 * What if each request has a different source?
				 * Unlikely, but need to define behaviour.
				 * Ignore analytics event? take first? provide 'mixed' as well?
				 */ const inputMethod = requests[0].source;
                const sourceEvent = requests[0].sourceEvent;
                editorAnalyticsApi?.attachAnalyticsEvent({
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    action: analyticsAction || (0, $bMFKb.ACTION).INSERTED,
                    actionSubject: (0, $bMFKb.ACTION_SUBJECT).DOCUMENT,
                    actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).SMART_LINK,
                    eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
                    attributes: {
                        inputMethod: inputMethod,
                        nodeType: nodeType,
                        nodeContext: nodeContext,
                        fromCurrentDomain: (0, $grDTV.isFromCurrentDomain)(url)
                    },
                    nonPrivacySafeAttributes: {
                        domainName: domainName
                    }
                })(tr);
                (0, $6C2m6.addLinkMetadata)(editorState.selection, tr, {
                    action: analyticsAction,
                    inputMethod: inputMethod,
                    cardAction: 'RESOLVE',
                    sourceEvent: sourceEvent
                });
            }
        }
        if (dispatch) dispatch((0, $ecNk4.resolveCard)(url)((0, $kuxd1.closeHistory)(tr)));
        return true;
    };
const $6d6ce30678fee3de$export$2bb01cc4a12e0b44 = (request, editorAnalyticsApi)=>(state, dispatch)=>{
        const cardState = (0, $cuJUr.pluginKey).getState(state);
        if (!cardState) return false;
        const tr = state.tr;
        if (request.source !== (0, $bMFKb.INPUT_METHOD).FLOATING_TB) editorAnalyticsApi?.attachAnalyticsEvent((0, $grDTV.getLinkCreationAnalyticsEvent)(request.source, request.url))(tr);
        (0, $6C2m6.addLinkMetadata)(state.selection, tr, {
            action: request.analyticsAction,
            inputMethod: request.source,
            sourceEvent: request.sourceEvent
        });
        if (dispatch) dispatch((0, $ecNk4.resolveCard)(request.url)(tr));
        return true;
    };
const $6d6ce30678fee3de$export$f17c48478174211e = (state, tr, source, analyticsAction, normalizeLinkText = true, sourceEvent, appearance = 'inline')=>{
    const { schema: schema } = state;
    const { link: link } = schema.marks;
    const requests = [];
    (0, $bnAxN.nodesBetweenChanged)(tr, (node, pos)=>{
        if (!node.isText) return true;
        const linkMark = node.marks.find((mark)=>mark.type === link);
        if (linkMark) {
            if (!(0, $97hFs.shouldReplaceLink)(node, normalizeLinkText)) return false;
            requests.push({
                url: linkMark.attrs.href,
                pos: pos,
                appearance: appearance,
                compareLinkText: normalizeLinkText,
                source: source,
                analyticsAction: analyticsAction,
                sourceEvent: sourceEvent
            });
        }
        return false;
    });
    if (analyticsAction) (0, $6C2m6.addLinkMetadata)(state.selection, tr, {
        action: analyticsAction
    });
    return (0, $ecNk4.queueCards)(requests)(tr);
};
const $6d6ce30678fee3de$export$717aabd99c4fc685 = (state, tr, source, analyticsAction, normalizeLinkText = true, sourceEvent, previousAppearance)=>{
    const { schema: schema } = state;
    const { link: link } = schema.marks;
    const requests = [];
    (0, $bnAxN.nodesBetweenChanged)(tr, (node, pos)=>{
        if (!node.isText) return true;
        const linkMark = node.marks.find((mark)=>mark.type === link);
        if (linkMark) {
            if (!(0, $97hFs.shouldReplaceLink)(node, normalizeLinkText)) return false;
            requests.push({
                url: linkMark.attrs.href,
                pos: pos,
                appearance: 'inline',
                previousAppearance: previousAppearance,
                compareLinkText: normalizeLinkText,
                source: source,
                analyticsAction: analyticsAction,
                sourceEvent: sourceEvent
            });
        }
        return false;
    });
    (0, $6C2m6.addLinkMetadata)(state.selection, tr, {
        action: analyticsAction
    });
    return (0, $ecNk4.queueCards)(requests)(tr);
};
const $6d6ce30678fee3de$export$c8301558911030d4 = (state, source, appearance, normalizeLinkText = true)=>{
    const { schema: schema } = state;
    const { link: link } = schema.marks;
    const requests = [];
    const createRequest = (linkMark, pos)=>({
            url: linkMark.attrs.href,
            pos: pos,
            appearance: appearance,
            previousAppearance: 'url',
            compareLinkText: normalizeLinkText,
            source: source,
            analyticsAction: (0, $bMFKb.ACTION).CHANGED_TYPE,
            shouldReplaceLink: true
        });
    if ((0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1')) {
        const activeLinkMark = (0, $a36Ig.getActiveLinkMark)(state);
        if (activeLinkMark) {
            const linkMark = activeLinkMark.node.marks.find((mark)=>mark.type === link);
            if (linkMark) requests.push(createRequest(linkMark, activeLinkMark.pos));
        }
    } else state.tr.doc.nodesBetween(state.selection.from, state.selection.to, (node, pos)=>{
        const linkMark = node.marks.find((mark)=>mark.type === link);
        if (linkMark) requests.push(createRequest(linkMark, pos));
    });
    (0, $6C2m6.addLinkMetadata)(state.selection, state.tr, {
        action: (0, $bMFKb.ACTION).CHANGED_TYPE
    });
    return (0, $ecNk4.queueCards)(requests)(state.tr);
};
const $6d6ce30678fee3de$export$3f14f692ecc2a0d9 = (text, href, sendAnalytics, node, pos, editorAnalyticsApi)=>(state, dispatch)=>{
        const selectedNode = state.selection instanceof (0, $3lIcL.NodeSelection) ? state.selection.node : undefined;
        let tr;
        if (node && pos) tr = $6d6ce30678fee3de$var$cardNodeToLinkWithTransaction(state, text, href, node, pos);
        else tr = $6d6ce30678fee3de$var$cardToLinkWithTransaction(state, text, href);
        $6d6ce30678fee3de$var$updateDatasourceStash(tr, selectedNode);
        if (sendAnalytics) {
            if (selectedNode) editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $bMFKb.ACTION).CHANGED_TYPE,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).SMART_LINK,
                eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
                attributes: {
                    newType: (0, $92h4E.SMART_LINK_TYPE).URL,
                    previousType: (0, $gXgTX.appearanceForNodeType)(selectedNode.type)
                }
            })(tr);
        }
        if (dispatch) dispatch(tr.scrollIntoView());
        return true;
    };
const $6d6ce30678fee3de$export$56a04318a610dc7c = (text, href, sendAnalytics, node, pos, editorAnalyticsApi)=>(state, dispatch)=>{
        let tr;
        if (node && pos) tr = $6d6ce30678fee3de$var$cardNodeToLinkWithTransaction(state, text, href, node, pos);
        else tr = $6d6ce30678fee3de$var$cardToLinkWithTransaction(state, text, href);
        if (sendAnalytics) editorAnalyticsApi?.attachAnalyticsEvent({
            action: (0, $bMFKb.ACTION).ERRORED,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).SMART_LINK,
            eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL,
            attributes: {
                error: 'Smart card falling back to link.'
            }
        })(tr);
        if (dispatch) dispatch(tr.scrollIntoView());
        return true;
    };
const $6d6ce30678fee3de$export$884fcee347ca969b = (href, sourceEvent)=>(state, dispatch)=>{
        const selectedNode = state.selection instanceof (0, $3lIcL.NodeSelection) && state.selection.node;
        if (!selectedNode) return false;
        const cardAppearance = (0, $gXgTX.selectedCardAppearance)(state);
        const tr = $6d6ce30678fee3de$var$cardToLinkWithTransaction(state, href, href);
        $6d6ce30678fee3de$export$717aabd99c4fc685(state, tr, (0, $bMFKb.INPUT_METHOD).MANUAL, (0, $bMFKb.ACTION).UPDATED, undefined, sourceEvent, cardAppearance);
        if (dispatch) dispatch(tr.scrollIntoView());
        return true;
    };
function $6d6ce30678fee3de$var$cardToLinkWithTransaction(state, text, href) {
    const selectedNode = state.selection instanceof (0, $3lIcL.NodeSelection) && state.selection.node;
    if (!selectedNode) return state.tr;
    const { link: link } = state.schema.marks;
    const url = selectedNode.attrs.url || selectedNode.attrs.data.url;
    const tr = state.tr.replaceSelectionWith(state.schema.text(text || url, [
        link.create({
            href: href || url
        })
    ]), false);
    return tr;
}
function $6d6ce30678fee3de$var$cardNodeToLinkWithTransaction(state, text, href, node, pos) {
    const { link: link } = state.schema.marks;
    const url = node.attrs.url || node.attrs.data.url;
    return state.tr.replaceWith(pos, pos + node.nodeSize, state.schema.text(text || url, [
        link.create({
            href: href || url
        })
    ]));
}
const $6d6ce30678fee3de$export$23c9e012c8c1ce24 = (text, editorAnalyticsApi)=>(state, dispatch)=>{
        const selectedNode = state.selection instanceof (0, $3lIcL.NodeSelection) && state.selection.node;
        if (!selectedNode) return false;
        const tr = state.tr.replaceSelectionWith(state.schema.text(text), false);
        if (dispatch) {
            (0, $6C2m6.addLinkMetadata)(state.selection, tr, {
                action: (0, $bMFKb.ACTION).UNLINK
            });
            tr.scrollIntoView();
            editorAnalyticsApi?.attachAnalyticsEvent((0, $97Qim.unlinkPayload)((0, $bMFKb.ACTION_SUBJECT_ID).CARD_INLINE))(tr);
            dispatch(tr);
        }
        return true;
    };
const $6d6ce30678fee3de$export$a188ef61ddbb94f = (appearance, editorAnalyticsApi)=>(state, dispatch)=>{
        const selectedNode = state.selection instanceof (0, $3lIcL.NodeSelection) ? state.selection.node : undefined;
        if (!selectedNode) {
            // When there is no selected node, we insert a new one
            // and replace the existing blue link
            const tr = $6d6ce30678fee3de$export$c8301558911030d4(state, (0, $bMFKb.INPUT_METHOD).FLOATING_TB, appearance);
            if (dispatch) {
                (0, $6C2m6.addLinkMetadata)(state.selection, tr, {
                    action: (0, $bMFKb.ACTION).CHANGED_TYPE
                });
                dispatch(tr.scrollIntoView());
            }
            return false;
        }
        if ((0, $gXgTX.appearanceForNodeType)(selectedNode.type) === appearance && !selectedNode.attrs.datasource) return false;
        const attrs = $6d6ce30678fee3de$export$85bb3e53350e35b8(appearance, selectedNode);
        const { from: from, to: to } = state.selection;
        const nodeType = $6d6ce30678fee3de$export$8fa45b4ca74a84b6(appearance, state.schema.nodes);
        const tr = state.tr.setNodeMarkup(from, nodeType, attrs, selectedNode.marks);
        $6d6ce30678fee3de$var$updateDatasourceStash(tr, selectedNode);
        // When the selected card is the last element in the doc we add a new paragraph after it for consistent replacement
        if (tr.doc.nodeSize - 2 === to) tr.insertText(' ', to);
        tr.setSelection((0, $3lIcL.TextSelection).create(tr.doc, to + 1));
        const previousNodePos = from - 1 > 0 ? from - 1 : 0;
        const previousNode = tr.doc.nodeAt(previousNodePos);
        if (previousNode?.type?.name === 'paragraph') tr.delete(previousNodePos, from);
        editorAnalyticsApi?.attachAnalyticsEvent({
            action: (0, $bMFKb.ACTION).CHANGED_TYPE,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).SMART_LINK,
            eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
            attributes: {
                newType: appearance,
                previousType: (0, $gXgTX.appearanceForNodeType)(selectedNode.type)
            }
        })(tr);
        (0, $6C2m6.addLinkMetadata)(state.selection, tr, {
            action: (0, $bMFKb.ACTION).CHANGED_TYPE
        });
        if (dispatch) dispatch(tr.scrollIntoView());
        return true;
    };
const $6d6ce30678fee3de$export$8fa45b4ca74a84b6 = (appearance, linkNodes)=>{
    switch(appearance){
        case 'inline':
            return linkNodes.inlineCard;
        case 'block':
            return linkNodes.blockCard;
        case 'embed':
            return linkNodes.embedCard;
    }
};
const $6d6ce30678fee3de$export$113cdaf1b279f308 = (args)=>{
    const { state: state, node: node, newAdf: newAdf, view: view, sourceEvent: sourceEvent, isDeletingConfig: isDeletingConfig, inputMethod: inputMethod } = args;
    const { tr: tr, selection: { from: from, to: to }, schema: { nodes: schemaNodes } } = state;
    if (newAdf.type === 'blockCard') {
        if (node.attrs?.datasource && newAdf.attrs?.datasource) {
            const newAttrs = newAdf.attrs;
            const oldAttrs = node.attrs;
            const [newViews] = newAttrs.datasource.views ?? [];
            const [oldViews] = oldAttrs.datasource.views ?? [];
            const isColumnChange = !(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(oldViews?.properties?.columns, newViews?.properties?.columns);
            const isUrlChange = newAttrs.url !== oldAttrs.url;
            if (isColumnChange || isUrlChange) tr.setNodeMarkup(from, schemaNodes.blockCard, {
                ...oldAttrs,
                ...newAdf.attrs
            });
        } else if (node.type.isText) {
            // url to datasource
            let link;
            state.doc.nodesBetween(from, to, (node, pos)=>{
                // get the actual start position of a link within the node
                const linkMark = node.marks.find((mark)=>mark.type === state.schema.marks.link);
                if (linkMark) {
                    link = {
                        url: linkMark.attrs.href,
                        text: node.text,
                        pos: pos
                    };
                    return false;
                }
                return true;
            });
            if (link) {
                const newNode = schemaNodes.blockCard.createChecked(newAdf.attrs);
                tr.replaceWith(link.pos, link.pos + (link.text || link.url).length, [
                    newNode
                ]);
            }
        } else // inline or blockCard to datasource
        tr.setNodeMarkup(from, schemaNodes.blockCard, newAdf.attrs);
    } else if (newAdf.type === 'inlineCard') // card type to inlineCard
    tr.setNodeMarkup(from, schemaNodes.inlineCard, newAdf.attrs);
    (0, $6C2m6.addLinkMetadata)(state.selection, tr, {
        action: (0, $bMFKb.ACTION).UPDATED,
        sourceEvent: sourceEvent,
        inputMethod: inputMethod
    });
    if (isDeletingConfig) {
        if (typeof node.attrs.url === 'string') (0, $ecNk4.removeDatasourceStash)(tr, node.attrs.url);
    } else (0, $ecNk4.hideDatasourceModal)(tr);
    view.dispatch(tr.scrollIntoView());
};
const $6d6ce30678fee3de$export$7f7b236478a618df = (state, adf, view, sourceEvent)=>{
    const { tr: tr, selection: { from: from }, schema: { nodes: schemaNodes } } = state;
    const { attrs: attrs, type: type } = adf;
    const schemaNode = type === 'inlineCard' ? schemaNodes.inlineCard : schemaNodes.blockCard;
    const newNode = schemaNode.createChecked(attrs);
    // in future, if we decide to do datasource insertion from the main toolbar, we should probably consider editor-plugin-content-insertion instead of tr.insert
    // this will allow us to deal with insertions from multiple paths in a more consistent way
    newNode && tr.insert(from, newNode);
    (0, $ecNk4.hideDatasourceModal)(tr);
    (0, $6C2m6.addLinkMetadata)(state.selection, tr, {
        action: (0, $bMFKb.ACTION).INSERTED,
        sourceEvent: sourceEvent
    });
    view.dispatch(tr.scrollIntoView());
};
const $6d6ce30678fee3de$export$85bb3e53350e35b8 = (appearance, selectedNode)=>{
    if (appearance === 'embed') return {
        ...selectedNode.attrs,
        layout: 'center'
    };
    if ((0, $gXgTX.isDatasourceNode)(selectedNode)) return {
        url: selectedNode.attrs.url
    };
    return selectedNode.attrs;
};
const $6d6ce30678fee3de$var$updateDatasourceStash = (tr, selectedNode)=>{
    if ((0, $gXgTX.isDatasourceNode)(selectedNode) && !(0, $gXgTX.isDatasourceConfigEditable)(selectedNode.attrs.datasource.id) && selectedNode.attrs.url) (0, $ecNk4.setDatasourceStash)(tr, {
        url: selectedNode.attrs.url,
        views: selectedNode.attrs.datasource.views
    });
};

});
parcelRegister("92h4E", function(module, exports) {

$parcel$export(module.exports, "LAYOUT_TYPE", () => $322b85750f03df92$export$9710eda883ce7be2);
$parcel$export(module.exports, "SMART_LINK_TYPE", () => $322b85750f03df92$export$804a928ffc86c02c);
var $322b85750f03df92$export$9710eda883ce7be2 = /*#__PURE__*/ function(LAYOUT_TYPE) {
    LAYOUT_TYPE["SINGLE_COL"] = "singleColumn";
    LAYOUT_TYPE["TWO_COLS_EQUAL"] = "twoColumnsEqual";
    LAYOUT_TYPE["THREE_COLS_EQUAL"] = "threeColumnsEqual";
    LAYOUT_TYPE["LEFT_SIDEBAR"] = "twoColumnsLeftSidebar";
    LAYOUT_TYPE["RIGHT_SIDEBAR"] = "twoColumnsRightSidebar";
    LAYOUT_TYPE["THREE_WITH_SIDEBARS"] = "threeColumnsWithSidebars ";
    LAYOUT_TYPE["FOUR_COLS_EQUAL"] = "fourColumnsEqual";
    LAYOUT_TYPE["FIVE_COLS_EQUAL"] = "fiveColumnsEqual";
    return LAYOUT_TYPE;
}({});
var $322b85750f03df92$export$804a928ffc86c02c = /*#__PURE__*/ function(SMART_LINK_TYPE) {
    SMART_LINK_TYPE["INLINE_CARD"] = "inline";
    SMART_LINK_TYPE["BLOCK_CARD"] = "block";
    SMART_LINK_TYPE["URL"] = "url";
    return SMART_LINK_TYPE;
}({});

});

parcelRegister("97Qim", function(module, exports) {

$parcel$export(module.exports, "buildEditLinkPayload", () => $7d7b4d8beeabc390$export$7f3c24765adf61f0);
$parcel$export(module.exports, "buildVisitedLinkPayload", () => $7d7b4d8beeabc390$export$e81ec2390acfc152);
$parcel$export(module.exports, "buildVisitedNonHyperLinkPayload", () => $7d7b4d8beeabc390$export$4c5e2a0406e7eae8);
$parcel$export(module.exports, "buildOpenedSettingsPayload", () => $7d7b4d8beeabc390$export$96aa8ae974c8591a);
$parcel$export(module.exports, "unlinkPayload", () => $7d7b4d8beeabc390$export$aab75a08bdd88be4);

var $bMFKb = parcelRequire("bMFKb");
const $7d7b4d8beeabc390$export$7f3c24765adf61f0 = (type)=>{
    return {
        action: (0, $bMFKb.ACTION).CLICKED,
        actionSubject: type === (0, $bMFKb.ACTION_SUBJECT_ID).HYPERLINK ? (0, $bMFKb.ACTION_SUBJECT).HYPERLINK : (0, $bMFKb.ACTION_SUBJECT).SMART_LINK,
        actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).EDIT_LINK,
        attributes: type !== (0, $bMFKb.ACTION_SUBJECT_ID).HYPERLINK ? {
            // @ts-ignore
            display: type
        } : {},
        eventType: (0, $bMFKb.EVENT_TYPE).UI
    };
};
const $7d7b4d8beeabc390$var$mapLinkTypeToCardAppearance = (type)=>{
    switch(type){
        case (0, $bMFKb.ACTION_SUBJECT_ID).CARD_INLINE:
            return 'inline';
        case (0, $bMFKb.ACTION_SUBJECT_ID).CARD_BLOCK:
            return 'block';
        case (0, $bMFKb.ACTION_SUBJECT_ID).EMBEDS:
            return 'embed';
        default:
            return 'url';
    }
};
const $7d7b4d8beeabc390$export$e81ec2390acfc152 = (type)=>{
    return type === (0, $bMFKb.ACTION_SUBJECT_ID).HYPERLINK ? $7d7b4d8beeabc390$var$buildVisitedHyperLinkPayload() : $7d7b4d8beeabc390$export$4c5e2a0406e7eae8(type, (0, $bMFKb.INPUT_METHOD).TOOLBAR);
};
const $7d7b4d8beeabc390$var$buildVisitedHyperLinkPayload = ()=>{
    return {
        action: (0, $bMFKb.ACTION).VISITED,
        actionSubject: (0, $bMFKb.ACTION_SUBJECT).HYPERLINK,
        actionSubjectId: undefined,
        attributes: {
            inputMethod: (0, $bMFKb.INPUT_METHOD).TOOLBAR
        },
        eventType: (0, $bMFKb.EVENT_TYPE).TRACK
    };
};
const $7d7b4d8beeabc390$export$4c5e2a0406e7eae8 = (type, inputMethod)=>{
    return {
        action: (0, $bMFKb.ACTION).VISITED,
        actionSubject: (0, $bMFKb.ACTION_SUBJECT).SMART_LINK,
        actionSubjectId: type,
        attributes: {
            inputMethod: inputMethod
        },
        eventType: (0, $bMFKb.EVENT_TYPE).TRACK
    };
};
const $7d7b4d8beeabc390$export$96aa8ae974c8591a = (type)=>{
    return {
        action: (0, $bMFKb.ACTION).CLICKED,
        actionSubject: (0, $bMFKb.ACTION_SUBJECT).BUTTON,
        actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).GOTO_SMART_LINK_SETTINGS,
        attributes: {
            // @ts-ignore
            inputMethod: (0, $bMFKb.INPUT_METHOD).TOOLBAR,
            display: $7d7b4d8beeabc390$var$mapLinkTypeToCardAppearance(type)
        },
        eventType: (0, $bMFKb.EVENT_TYPE).UI
    };
};
const $7d7b4d8beeabc390$export$aab75a08bdd88be4 = (type)=>{
    return {
        action: (0, $bMFKb.ACTION).UNLINK,
        actionSubject: type === (0, $bMFKb.ACTION_SUBJECT_ID).HYPERLINK ? (0, $bMFKb.ACTION_SUBJECT).HYPERLINK : (0, $bMFKb.ACTION_SUBJECT).SMART_LINK,
        actionSubjectId: type === (0, $bMFKb.ACTION_SUBJECT_ID).HYPERLINK ? undefined : type,
        attributes: {
            inputMethod: (0, $bMFKb.INPUT_METHOD).TOOLBAR
        },
        eventType: (0, $bMFKb.EVENT_TYPE).TRACK
    };
};

});

parcelRegister("6C2m6", function(module, exports) {

$parcel$export(module.exports, "addLinkMetadata", () => $11397821c0b6cc0a$export$e2d4855dca88ecc1);
$parcel$export(module.exports, "getLinkMetadataFromTransaction", () => $11397821c0b6cc0a$export$3aba02526a1e2e78);
$parcel$export(module.exports, "commandWithMetadata", () => $11397821c0b6cc0a$export$76125a95b70625ac);

var $5KmoW = parcelRequire("5KmoW");
function $11397821c0b6cc0a$export$e2d4855dca88ecc1(initialSelection, tr, metadata) {
    const { storedMarks: storedMarks } = tr;
    const pos = tr.mapping.map(initialSelection.$from.pos);
    tr.step(new (0, $5KmoW.LinkMetaStep)(pos, metadata));
    // When you add a new step all the storedMarks are removed it
    if (storedMarks) tr.setStoredMarks(storedMarks);
    return tr;
}
function $11397821c0b6cc0a$export$3aba02526a1e2e78(tr) {
    return tr.steps.reduce((metadata, step)=>{
        if (!(step instanceof (0, $5KmoW.LinkMetaStep))) return metadata;
        return {
            ...metadata,
            ...step.getMetadata()
        };
    }, {});
}
const $11397821c0b6cc0a$export$76125a95b70625ac = (command, metadata)=>{
    return (state, dispatch, view)=>{
        if (!dispatch) return command(state, dispatch, view);
        return command(state, (tr)=>{
            $11397821c0b6cc0a$export$e2d4855dca88ecc1(state.selection, tr, metadata);
            dispatch(tr);
        }, view);
    };
};

});
parcelRegister("5KmoW", function(module, exports) {

$parcel$export(module.exports, "LinkMetaStep", () => $42f2a0144630b4c7$export$40e33c9d27895078);

var $3xw6l = parcelRequire("3xw6l");

var $lzEKq = parcelRequire("lzEKq");
const $42f2a0144630b4c7$export$954e3f6aa93d9ba3 = 'editor-linking-meta';
const $42f2a0144630b4c7$export$2774298c489a128f = 'editor-linking-meta-invert';
class $42f2a0144630b4c7$export$40e33c9d27895078 extends (0, $lzEKq.Step) {
    constructor(pos, metadata, isInverted = false){
        super();
        this.pos = pos;
        this.metadata = metadata;
        this.isInverted = isInverted;
    }
    getMetadata() {
        return this.metadata;
    }
    /**
   * Generate new undo/redo analytics event when step is inverted
   */ invert() {
        /**
     * Omit sourceEvent in history
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { sourceEvent: sourceEvent, ...metadata } = this.metadata;
        return new $42f2a0144630b4c7$export$40e33c9d27895078(this.pos, metadata, true);
    }
    // Should make no modifications to the doc
    apply(doc) {
        return (0, $lzEKq.StepResult).ok(doc);
    }
    map(mapping) {
        let newPos = this.pos;
        if (typeof newPos === 'number') newPos = mapping.map(newPos);
        // Return the same events, this step will never be removed
        return new $42f2a0144630b4c7$export$40e33c9d27895078(newPos, this.metadata, this.isInverted);
    }
    getMap() {
        return new (0, $lzEKq.StepMap)([
            this.pos || 0,
            0,
            0
        ]);
    }
    // Return null to avoid merging events
    merge() {
        return null;
    }
    toJSON() {
        // When serialized we should create a noop Replace step
        return {
            stepType: 'replace',
            from: 0,
            to: 0
        };
    }
    static fromJSON() {
        // This is a "local custom step" once serialized
        // we need to transform it in a no-operation action
        return new (0, $lzEKq.ReplaceStep)(0, 0, (0, $3xw6l.Slice).empty);
    }
}
/** Register this step with Prosemirror */ (0, $lzEKq.Step).jsonID($42f2a0144630b4c7$export$954e3f6aa93d9ba3, $42f2a0144630b4c7$export$40e33c9d27895078);

});


parcelRegister("a36Ig", function(module, exports) {

$parcel$export(module.exports, "isTextAtPos", () => $925ba74d34988a68$export$8476280b1d47554d);
$parcel$export(module.exports, "getLinkPreferencesURLFromENV", () => $925ba74d34988a68$export$e5404273592f5dbd);
$parcel$export(module.exports, "getActiveLinkMark", () => $925ba74d34988a68$export$819e108a65d33088);

var $8RHPx = parcelRequire("8RHPx");

var $92xoS = parcelRequire("92xoS");

function $925ba74d34988a68$export$8476280b1d47554d(pos) {
    return ({ tr: tr })=>{
        const node = tr.doc.nodeAt(pos);
        return !!node && node.isText;
    };
}
function $925ba74d34988a68$export$54fac2c1c66c48ae(pos) {
    return (state)=>{
        const node = state.doc.nodeAt(pos);
        return !!node && !!state.schema.marks.link.isInSet(node.marks);
    };
}
const $925ba74d34988a68$export$e5404273592f5dbd = ()=>{
    return (0, $8RHPx.getATLContextUrl)('id') + (0, $36674f1acadf5cf4$export$f0972e90f14682b1);
};
const $925ba74d34988a68$var$isSelectionInsideLink = (state)=>!!state.doc.type.schema.marks.link.isInSet(state.selection.$from.marks());
const $925ba74d34988a68$var$isEmptySelectionBeforeLink = (state)=>{
    const { $from: $from, $to: $to } = state.selection;
    return $from === $to && !!state.doc.type.schema.marks.link.isInSet($from.nodeAfter?.marks || []);
};
const $925ba74d34988a68$var$isEmptySelectionAfterLink = (state)=>{
    const { $from: $from, $to: $to } = state.selection;
    return $from === $to && !!state.doc.type.schema.marks.link.isInSet($from.nodeBefore?.marks || []);
};
const $925ba74d34988a68$var$isSelectionAroundLink = (state)=>{
    const { $from: $from, $to: $to } = state.selection;
    const node = $from.nodeAfter;
    return !!node && $from.textOffset === 0 && $to.pos - $from.pos === node.nodeSize && !!state.doc.type.schema.marks.link.isInSet(node.marks);
};
const $925ba74d34988a68$export$819e108a65d33088 = (state)=>{
    const { selection: { $from: $from } } = state;
    if ($925ba74d34988a68$var$isSelectionInsideLink(state) || $925ba74d34988a68$var$isSelectionAroundLink(state)) {
        const pos = $from.pos - $from.textOffset;
        const node = state.doc.nodeAt(pos);
        return node && node.isText ? {
            node: node,
            pos: pos
        } : undefined;
    }
    if ($925ba74d34988a68$var$isEmptySelectionBeforeLink(state) && (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1')) {
        // if user clicks right before the link, we want to show the toolbar for the link
        // but only if the link is a single character
        const node = state.doc.nodeAt($from.pos);
        return node && node.isText && node.nodeSize === 1 ? {
            node: node,
            pos: $from.pos
        } : undefined;
    }
    if ($925ba74d34988a68$var$isEmptySelectionAfterLink(state) && (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1')) {
        // if user clicks right after the link, we want to show the toolbar for the link
        // but only if the link is a single character
        // and we return the position of the link
        const node = state.doc.nodeAt($from.pos - 1);
        return node && node.isText && node.nodeSize === 1 ? {
            node: node,
            pos: $from.pos - 1
        } : undefined;
    }
    return undefined;
};

});
const $36674f1acadf5cf4$export$f0972e90f14682b1 = '/manage-profile/link-preferences';


parcelRegister("grDTV", function(module, exports) {

$parcel$export(module.exports, "LinkMatcher", () => $c8bd54d882b6a9e0$export$4490385c12bf3d4);
$parcel$export(module.exports, "normalizeUrl", () => $c8bd54d882b6a9e0$export$6535eb414fa2c8b6);
$parcel$export(module.exports, "linkifyContent", () => $c8bd54d882b6a9e0$export$5a511fa58fab15e6);
$parcel$export(module.exports, "findFilepaths", () => $c8bd54d882b6a9e0$export$d37783fe63e2f0fe);
$parcel$export(module.exports, "isLinkInMatches", () => $c8bd54d882b6a9e0$export$5e652e74655163e5);
$parcel$export(module.exports, "getLinkDomain", () => $c8bd54d882b6a9e0$export$238a6141b3685c21);
$parcel$export(module.exports, "isFromCurrentDomain", () => $c8bd54d882b6a9e0$export$336c6a47b1dfa1bc);
$parcel$export(module.exports, "getLinkCreationAnalyticsEvent", () => $c8bd54d882b6a9e0$export$56039faad4eda709);
$parcel$export(module.exports, "canLinkBeCreatedInRange", () => $c8bd54d882b6a9e0$export$b7392a423e62dc8c);
// File has been copied to packages/editor/editor-plugin-ai/src/provider/markdown-transformer/utils/hyperlink.ts
// If changes are made to this file, please make the same update in the linked file.

var $iKozC = parcelRequire("iKozC");

var $bMFKb = parcelRequire("bMFKb");

var $8YVeS = parcelRequire("8YVeS");

var $gbisc = parcelRequire("gbisc");
const $c8bd54d882b6a9e0$export$893fccbed37586dd = /([a-zA-Z]:|\\)([^\/:*?<>"|]+\\)?([^\/:*?<>"| ]+(?=\s?))?/gim;
const $c8bd54d882b6a9e0$export$dabcc234035f6703 = /^(\$|{)/;
class $c8bd54d882b6a9e0$export$4490385c12bf3d4 {
    static create() {
        class LinkMatcherRegex {
            exec(str) {
                const stringsBySpace = str.slice(0, str.length - 1).split(' ');
                const lastStringBeforeSpace = stringsBySpace[stringsBySpace.length - 1];
                const isLastStringValid = lastStringBeforeSpace.length > 0;
                if (!str.endsWith(' ') || !isLastStringValid) return null;
                if ($c8bd54d882b6a9e0$export$dabcc234035f6703.test(lastStringBeforeSpace)) return null;
                const links = (0, $iKozC.linkify).match(lastStringBeforeSpace);
                if (!links || links.length === 0) return null;
                const lastMatch = links[links.length - 1];
                const lastLink = links[links.length - 1];
                lastLink.input = str.substring(lastMatch.index);
                lastLink.length = lastLink.lastIndex - lastLink.index + 1;
                lastLink.index = str.lastIndexOf(lastStringBeforeSpace) + lastMatch.index;
                return lastLink;
            }
        }
        return new LinkMatcherRegex();
    }
}
function $c8bd54d882b6a9e0$export$6535eb414fa2c8b6(url) {
    if (!url) return '';
    if ((0, $iKozC.isSafeUrl)(url)) return url;
    return (0, $iKozC.normalizeUrl)(url);
}
function $c8bd54d882b6a9e0$export$5a511fa58fab15e6(schema) {
    return (slice)=>(0, $gbisc.mapSlice)(slice, (node, parent)=>{
            const isAllowedInParent = !parent || parent.type !== schema.nodes.codeBlock;
            const link = node.type.schema.marks.link;
            if (link === undefined) throw new Error('Link not in schema - unable to linkify content');
            if (isAllowedInParent && node.isText && !link.isInSet(node.marks)) {
                const linkified = [];
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const text = node.text;
                const matches = $c8bd54d882b6a9e0$var$findLinkMatches(text).filter((0, $8YVeS.shouldAutoLinkifyMatch));
                let pos = 0;
                const filepaths = $c8bd54d882b6a9e0$export$d37783fe63e2f0fe(text);
                matches.forEach((match)=>{
                    if ($c8bd54d882b6a9e0$export$5e652e74655163e5(match.index, filepaths)) return;
                    if (match.index > 0) linkified.push(node.cut(pos, match.index));
                    linkified.push(node.cut(match.index, match.lastIndex).mark(link.create({
                        href: $c8bd54d882b6a9e0$export$6535eb414fa2c8b6(match.url)
                    }).addToSet(node.marks)));
                    pos = match.lastIndex;
                });
                if (pos < text.length) linkified.push(node.cut(pos));
                return linkified;
            }
            return node;
        });
}
function $c8bd54d882b6a9e0$export$238a6141b3685c21(url) {
    // Remove protocol and www., if either exists
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const withoutProtocol = url.toLowerCase().replace(/^(.*):\/\//, '');
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const withoutWWW = withoutProtocol.replace(/^(www\.)/, '');
    // Remove port, fragment, path, query string
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return withoutWWW.replace(/[:\/?#](.*)$/, '');
}
function $c8bd54d882b6a9e0$export$336c6a47b1dfa1bc(url) {
    if (!window || !window.location) return false;
    const currentDomain = window.location.hostname;
    const linkDomain = $c8bd54d882b6a9e0$export$238a6141b3685c21(url);
    return currentDomain === linkDomain;
}
/**
 * Fetch linkify matches from text
 * @param text Input text from a node
 * @returns Array of linkify matches. Returns empty array if text is empty or no matches found;
 */ function $c8bd54d882b6a9e0$var$findLinkMatches(text) {
    if (text === '') return [];
    return (0, $iKozC.linkify).match(text) || [];
}
const $c8bd54d882b6a9e0$export$d37783fe63e2f0fe = (text, offset = 0)=>{
    // Creation of a copy of the RegExp is necessary as lastIndex is stored on it when we run .exec()
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const localRegExp = new RegExp($c8bd54d882b6a9e0$export$893fccbed37586dd);
    let match;
    const matchesList = [];
    const maxFilepathSize = 260;
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    while((match = localRegExp.exec(text)) !== null){
        const start = match.index + offset;
        let end = localRegExp.lastIndex + offset;
        if (end - start > maxFilepathSize) end = start + maxFilepathSize;
         // We don't care about big strings of text that are pretending to be filepaths!!
        matchesList.push({
            startIndex: start,
            endIndex: end
        });
    }
    return matchesList;
};
const $c8bd54d882b6a9e0$export$5e652e74655163e5 = (linkStart, matchesList)=>{
    for(let i = 0; i < matchesList.length; i++){
        if (linkStart >= matchesList[i].startIndex && linkStart < matchesList[i].endIndex) return true;
    }
    return false;
};
function $c8bd54d882b6a9e0$export$56039faad4eda709(inputMethod, url) {
    return {
        action: (0, $bMFKb.ACTION).INSERTED,
        actionSubject: (0, $bMFKb.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).LINK,
        attributes: {
            inputMethod: inputMethod,
            fromCurrentDomain: $c8bd54d882b6a9e0$export$336c6a47b1dfa1bc(url)
        },
        eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
        nonPrivacySafeAttributes: {
            linkDomain: $c8bd54d882b6a9e0$export$238a6141b3685c21(url)
        }
    };
}
const $c8bd54d882b6a9e0$export$b7392a423e62dc8c = (from, to)=>(state)=>{
        if (!state.doc.rangeHasMark(from, to, state.schema.marks.link)) {
            const $from = state.doc.resolve(from);
            const $to = state.doc.resolve(to);
            const link = state.schema.marks.link;
            if ($from.parent === $to.parent && $from.parent.isTextblock) {
                if ($from.parent.type.allowsMarkType(link)) {
                    let allowed = true;
                    state.doc.nodesBetween(from, to, (node)=>{
                        const hasInlineCard = node.type === state.schema.nodes.inlineCard;
                        allowed = allowed && !node.marks.some((m)=>m.type.excludes(link)) && !hasInlineCard;
                        return allowed;
                    });
                    return allowed;
                }
            }
        }
        return false;
    };

});
parcelRegister("8YVeS", function(module, exports) {

$parcel$export(module.exports, "shouldAutoLinkifyMatch", () => $d6bd16a08c4f7ae5$export$e19a09e301eaa6bb);
/** Created by scanning the Wikipedia page for all TLDs and selecting those that are common filenames, along
 * with customer complaints */ const $d6bd16a08c4f7ae5$var$tldsToNotAutoLinkify = [
    'name',
    'zip',
    'doc',
    'mov',
    // Ensure common 2 character file extensions aren't linkified without https prefix
    'md',
    // Postscript
    'ps',
    // C++
    'cc',
    // C#
    'cs',
    // f#
    'fs',
    // Go
    'go',
    // JavaScript
    'js',
    // Perl
    'pl',
    // Perl module
    'pm',
    // Python
    'py',
    // Ruby
    'rb',
    // Rust
    'rs',
    // Bash
    'sh',
    // Typescript
    'ts',
    // C#
    'cs',
    // Visual Basic
    'vb'
];
function $d6bd16a08c4f7ae5$export$977fe75b90bdd614(url) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const startsWithHttpHttps = /^https?:\/\//.test(url);
    if (startsWithHttpHttps) return true;
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const startsWithWWW = /^www\./.test(url);
    if (startsWithWWW) return true;
    try {
        const hostname = new URL(`https://${url}`).hostname;
        const parts = hostname.split('.');
        const tld = parts.length > 1 ? parts[parts.length - 1] : null;
        if (parts[0] === '') // If the domain is an empty string (ie the link is `.com`), it's invalid, so
        // automatically return true
        return true;
        if (!tld) return true;
        return !$d6bd16a08c4f7ae5$var$tldsToNotAutoLinkify.includes(tld);
    } catch (e) {
        return true;
    }
}
function $d6bd16a08c4f7ae5$export$e19a09e301eaa6bb(match) {
    return $d6bd16a08c4f7ae5$export$977fe75b90bdd614(match.raw);
}

});

parcelRegister("gbisc", function(module, exports) {

$parcel$export(module.exports, "getFragmentBackingArray", () => $3eaab404b91bf559$export$7b8536c35e9eb7d2);
$parcel$export(module.exports, "mapFragment", () => $3eaab404b91bf559$export$81fe6b3b714fd0bf);
$parcel$export(module.exports, "mapSlice", () => $3eaab404b91bf559$export$d8264570c5933bbf);
$parcel$export(module.exports, "flatmap", () => $3eaab404b91bf559$export$c575791007f9dbd1);
$parcel$export(module.exports, "mapChildren", () => $3eaab404b91bf559$export$e0baa27f47733a4a);

var $3xw6l = parcelRequire("3xw6l");
function $3eaab404b91bf559$export$7b8536c35e9eb7d2(fragment) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return fragment.content;
}
function $3eaab404b91bf559$export$81fe6b3b714fd0bf(content, callback, parent = null) {
    const children = [];
    for(let i = 0, size = content.childCount; i < size; i++){
        const node = content.child(i);
        const transformed = node.isLeaf ? callback(node, parent, i) : callback(node.copy($3eaab404b91bf559$export$81fe6b3b714fd0bf(node.content, callback, node)), parent, i);
        if (transformed) {
            if (transformed instanceof (0, $3xw6l.Fragment)) children.push(...$3eaab404b91bf559$export$7b8536c35e9eb7d2(transformed));
            else if (Array.isArray(transformed)) children.push(...transformed);
            else children.push(transformed);
        }
    }
    return (0, $3xw6l.Fragment).fromArray(children);
}
function $3eaab404b91bf559$export$d8264570c5933bbf(slice, callback) {
    const fragment = $3eaab404b91bf559$export$81fe6b3b714fd0bf(slice.content, callback);
    return new (0, $3xw6l.Slice)(fragment, slice.openStart, slice.openEnd);
}
function $3eaab404b91bf559$export$c575791007f9dbd1(fragment, callback) {
    const fragmentContent = [];
    for(let i = 0; i < fragment.childCount; i++){
        const child = callback(fragment.child(i), i, fragment);
        if (Array.isArray(child)) fragmentContent.push(...child);
        else fragmentContent.push(child);
    }
    return (0, $3xw6l.Fragment).fromArray(fragmentContent);
}
function $3eaab404b91bf559$export$e0baa27f47733a4a(node, callback) {
    const array = [];
    for(let i = 0; i < node.childCount; i++)array.push(callback(node.child(i), i, node instanceof (0, $3xw6l.Fragment) ? node : node.content));
    return array;
}
const $3eaab404b91bf559$var$findNode = (predicate)=>(slice)=>{
        let foundNode = null;
        slice.content.nodesBetween(0, slice.content.size, (node)=>{
            if (predicate(node)) {
                foundNode = node;
                return false;
            }
            return true;
        });
        return foundNode;
    };
const $3eaab404b91bf559$export$b6ae752d7894ad08 = (predicate)=>(slice)=>{
        return !!$3eaab404b91bf559$var$findNode(predicate)(slice);
    };

});


parcelRegister("97hFs", function(module, exports) {

$parcel$export(module.exports, "shouldReplaceLink", () => $c9b4517f02a891e4$export$f85e921f66e987fa);

var $iKozC = parcelRequire("iKozC");

var $8WSr8 = parcelRequire("8WSr8");
function $c9b4517f02a891e4$export$f85e921f66e987fa(node, compareLinkText = true, compareToUrl) {
    const linkMark = node.marks.find((mark)=>mark.type.name === 'link');
    if (!linkMark) // not a link anymore
    return false;
    // ED-6041: compare normalised link text after linkfy from Markdown transformer
    // instead, since it always decodes URL ('%20' -> ' ') on the link text
    const normalisedHref = (0, $iKozC.normalizeUrl)((0, $8WSr8.md).normalizeLinkText(linkMark.attrs.href));
    const normalizedLinkText = (0, $iKozC.normalizeUrl)((0, $8WSr8.md).normalizeLinkText(node.text || ''));
    if (compareLinkText && normalisedHref !== normalizedLinkText) return false;
    if (compareToUrl) {
        const normalizedUrl = (0, $iKozC.normalizeUrl)((0, $8WSr8.md).normalizeLinkText(compareToUrl));
        if (normalizedUrl !== normalisedHref) return false;
    }
    return true;
}

});
parcelRegister("8WSr8", function(module, exports) {

$parcel$export(module.exports, "md", () => $4c8310abfd36e68a$export$f4de1c043ce6927);
// File has been copied to packages/editor/editor-plugin-ai/src/provider/markdown-transformer/md/index.ts
// If changes are made to this file, please make the same update in the linked file.

var $cciZy = parcelRequire("cciZy");

var $ixJuK = parcelRequire("ixJuK");

var $hvgYN = parcelRequire("hvgYN");

var $5vTT1 = parcelRequire("5vTT1");

var $25i5a = parcelRequire("25i5a");
const $4c8310abfd36e68a$export$f4de1c043ce6927 = (0, (/*@__PURE__*/$parcel$interopDefault($cciZy)))('zero', {
    html: false
});
$4c8310abfd36e68a$export$f4de1c043ce6927.enable([
    // Process html entity - &#123;, &#xAF;, &quot;, ...
    'entity',
    // Process escaped chars and hardbreaks
    'escape',
    'newline'
]);
$4c8310abfd36e68a$export$f4de1c043ce6927.use((0, $25i5a.default));
// enable modified version of linkify plugin
// @see https://product-fabric.atlassian.net/browse/ED-3097
$4c8310abfd36e68a$export$f4de1c043ce6927.use((0, $hvgYN.default));
$4c8310abfd36e68a$export$f4de1c043ce6927.use((0, $5vTT1.default));
$4c8310abfd36e68a$export$f4de1c043ce6927.use((0, $ixJuK.default));

});
parcelRegister("cciZy", function(module, exports) {
'use strict';

module.exports = (parcelRequire("cBFd2"));

});
parcelRegister("cBFd2", function(module, exports) {
// Main parser class
'use strict';

var $l6IUK = parcelRequire("l6IUK");

var $gqPyc = parcelRequire("gqPyc");

var $gOmEB = parcelRequire("gOmEB");

var $5V1yU = parcelRequire("5V1yU");

var $9Xg9R = parcelRequire("9Xg9R");

var $hkcNh = parcelRequire("hkcNh");

var $98vHM = parcelRequire("98vHM");

var $90JXC = parcelRequire("90JXC");

var $4Iqgk = parcelRequire("4Iqgk");



var $92d8e80e58d3750f$var$config = {
    default: (parcelRequire("jbZa8")),
    zero: (parcelRequire("4Ggn6")),
    commonmark: (parcelRequire("5Yj6L"))
};
////////////////////////////////////////////////////////////////////////////////
//
// This validator can prohibit more than really needed to prevent XSS. It's a
// tradeoff to keep code simple and to be secure by default.
//
// If you need different setup - override validator method as you wish. Or
// replace it with dummy function and use external sanitizer.
//
var $92d8e80e58d3750f$var$BAD_PROTO_RE = /^(vbscript|javascript|file|data):/;
var $92d8e80e58d3750f$var$GOOD_DATA_RE = /^data:image\/(gif|png|jpeg|webp);/;
function $92d8e80e58d3750f$var$validateLink(url) {
    // url should be normalized at this point, and existing entities are decoded
    var str = url.trim().toLowerCase();
    return $92d8e80e58d3750f$var$BAD_PROTO_RE.test(str) ? $92d8e80e58d3750f$var$GOOD_DATA_RE.test(str) ? true : false : true;
}
////////////////////////////////////////////////////////////////////////////////
var $92d8e80e58d3750f$var$RECODE_HOSTNAME_FOR = [
    'http:',
    'https:',
    'mailto:'
];
function $92d8e80e58d3750f$var$normalizeLink(url) {
    var parsed = $90JXC.parse(url, true);
    if (parsed.hostname) {
        // Encode hostnames in urls like:
        // `http://host/`, `https://host/`, `mailto:user@host`, `//host/`
        //
        // We don't encode unknown schemas, because it's likely that we encode
        // something we shouldn't (e.g. `skype:name` treated as `skype:host`)
        //
        if (!parsed.protocol || $92d8e80e58d3750f$var$RECODE_HOSTNAME_FOR.indexOf(parsed.protocol) >= 0) try {
            parsed.hostname = $4Iqgk.toASCII(parsed.hostname);
        } catch (er) {}
    }
    return $90JXC.encode($90JXC.format(parsed));
}
function $92d8e80e58d3750f$var$normalizeLinkText(url) {
    var parsed = $90JXC.parse(url, true);
    if (parsed.hostname) {
        // Encode hostnames in urls like:
        // `http://host/`, `https://host/`, `mailto:user@host`, `//host/`
        //
        // We don't encode unknown schemas, because it's likely that we encode
        // something we shouldn't (e.g. `skype:name` treated as `skype:host`)
        //
        if (!parsed.protocol || $92d8e80e58d3750f$var$RECODE_HOSTNAME_FOR.indexOf(parsed.protocol) >= 0) try {
            parsed.hostname = $4Iqgk.toUnicode(parsed.hostname);
        } catch (er) {}
    }
    // add '%' to exclude list because of https://github.com/markdown-it/markdown-it/issues/720
    return $90JXC.decode($90JXC.format(parsed), $90JXC.decode.defaultChars + '%');
}
/**
 * class MarkdownIt
 *
 * Main parser/renderer class.
 *
 * ##### Usage
 *
 * ```javascript
 * // node.js, "classic" way:
 * var MarkdownIt = require('markdown-it'),
 *     md = new MarkdownIt();
 * var result = md.render('# markdown-it rulezz!');
 *
 * // node.js, the same, but with sugar:
 * var md = require('markdown-it')();
 * var result = md.render('# markdown-it rulezz!');
 *
 * // browser without AMD, added to "window" on script load
 * // Note, there are no dash.
 * var md = window.markdownit();
 * var result = md.render('# markdown-it rulezz!');
 * ```
 *
 * Single line rendering, without paragraph wrap:
 *
 * ```javascript
 * var md = require('markdown-it')();
 * var result = md.renderInline('__markdown-it__ rulezz!');
 * ```
 **/ /**
 * new MarkdownIt([presetName, options])
 * - presetName (String): optional, `commonmark` / `zero`
 * - options (Object)
 *
 * Creates parser instanse with given config. Can be called without `new`.
 *
 * ##### presetName
 *
 * MarkdownIt provides named presets as a convenience to quickly
 * enable/disable active syntax rules and options for common use cases.
 *
 * - ["commonmark"](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/commonmark.js) -
 *   configures parser to strict [CommonMark](http://commonmark.org/) mode.
 * - [default](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/default.js) -
 *   similar to GFM, used when no preset name given. Enables all available rules,
 *   but still without html, typographer & autolinker.
 * - ["zero"](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/zero.js) -
 *   all rules disabled. Useful to quickly setup your config via `.enable()`.
 *   For example, when you need only `bold` and `italic` markup and nothing else.
 *
 * ##### options:
 *
 * - __html__ - `false`. Set `true` to enable HTML tags in source. Be careful!
 *   That's not safe! You may need external sanitizer to protect output from XSS.
 *   It's better to extend features via plugins, instead of enabling HTML.
 * - __xhtmlOut__ - `false`. Set `true` to add '/' when closing single tags
 *   (`<br />`). This is needed only for full CommonMark compatibility. In real
 *   world you will need HTML output.
 * - __breaks__ - `false`. Set `true` to convert `\n` in paragraphs into `<br>`.
 * - __langPrefix__ - `language-`. CSS language class prefix for fenced blocks.
 *   Can be useful for external highlighters.
 * - __linkify__ - `false`. Set `true` to autoconvert URL-like text to links.
 * - __typographer__  - `false`. Set `true` to enable [some language-neutral
 *   replacement](https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/replacements.js) +
 *   quotes beautification (smartquotes).
 * - __quotes__ - `“”‘’`, String or Array. Double + single quotes replacement
 *   pairs, when typographer enabled and smartquotes on. For example, you can
 *   use `'«»„“'` for Russian, `'„“‚‘'` for German, and
 *   `['«\xA0', '\xA0»', '‹\xA0', '\xA0›']` for French (including nbsp).
 * - __highlight__ - `null`. Highlighter function for fenced code blocks.
 *   Highlighter `function (str, lang)` should return escaped HTML. It can also
 *   return empty string if the source was not changed and should be escaped
 *   externaly. If result starts with <pre... internal wrapper is skipped.
 *
 * ##### Example
 *
 * ```javascript
 * // commonmark mode
 * var md = require('markdown-it')('commonmark');
 *
 * // default mode
 * var md = require('markdown-it')();
 *
 * // enable everything
 * var md = require('markdown-it')({
 *   html: true,
 *   linkify: true,
 *   typographer: true
 * });
 * ```
 *
 * ##### Syntax highlighting
 *
 * ```js
 * var hljs = require('highlight.js') // https://highlightjs.org/
 *
 * var md = require('markdown-it')({
 *   highlight: function (str, lang) {
 *     if (lang && hljs.getLanguage(lang)) {
 *       try {
 *         return hljs.highlight(str, { language: lang, ignoreIllegals: true }).value;
 *       } catch (__) {}
 *     }
 *
 *     return ''; // use external default escaping
 *   }
 * });
 * ```
 *
 * Or with full wrapper override (if you need assign class to `<pre>`):
 *
 * ```javascript
 * var hljs = require('highlight.js') // https://highlightjs.org/
 *
 * // Actual default values
 * var md = require('markdown-it')({
 *   highlight: function (str, lang) {
 *     if (lang && hljs.getLanguage(lang)) {
 *       try {
 *         return '<pre class="hljs"><code>' +
 *                hljs.highlight(str, { language: lang, ignoreIllegals: true }).value +
 *                '</code></pre>';
 *       } catch (__) {}
 *     }
 *
 *     return '<pre class="hljs"><code>' + md.utils.escapeHtml(str) + '</code></pre>';
 *   }
 * });
 * ```
 *
 **/ function $92d8e80e58d3750f$var$MarkdownIt(presetName, options) {
    if (!(this instanceof $92d8e80e58d3750f$var$MarkdownIt)) return new $92d8e80e58d3750f$var$MarkdownIt(presetName, options);
    if (!options) {
        if (!$l6IUK.isString(presetName)) {
            options = presetName || {};
            presetName = 'default';
        }
    }
    /**
   * MarkdownIt#inline -> ParserInline
   *
   * Instance of [[ParserInline]]. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.inline = new $hkcNh();
    /**
   * MarkdownIt#block -> ParserBlock
   *
   * Instance of [[ParserBlock]]. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.block = new $9Xg9R();
    /**
   * MarkdownIt#core -> Core
   *
   * Instance of [[Core]] chain executor. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.core = new $5V1yU();
    /**
   * MarkdownIt#renderer -> Renderer
   *
   * Instance of [[Renderer]]. Use it to modify output look. Or to add rendering
   * rules for new token types, generated by plugins.
   *
   * ##### Example
   *
   * ```javascript
   * var md = require('markdown-it')();
   *
   * function myToken(tokens, idx, options, env, self) {
   *   //...
   *   return result;
   * };
   *
   * md.renderer.rules['my_token'] = myToken
   * ```
   *
   * See [[Renderer]] docs and [source code](https://github.com/markdown-it/markdown-it/blob/master/lib/renderer.js).
   **/ this.renderer = new $gOmEB();
    /**
   * MarkdownIt#linkify -> LinkifyIt
   *
   * [linkify-it](https://github.com/markdown-it/linkify-it) instance.
   * Used by [linkify](https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/linkify.js)
   * rule.
   **/ this.linkify = new $98vHM();
    /**
   * MarkdownIt#validateLink(url) -> Boolean
   *
   * Link validation function. CommonMark allows too much in links. By default
   * we disable `javascript:`, `vbscript:`, `file:` schemas, and almost all `data:...` schemas
   * except some embedded image types.
   *
   * You can change this behaviour:
   *
   * ```javascript
   * var md = require('markdown-it')();
   * // enable everything
   * md.validateLink = function () { return true; }
   * ```
   **/ this.validateLink = $92d8e80e58d3750f$var$validateLink;
    /**
   * MarkdownIt#normalizeLink(url) -> String
   *
   * Function used to encode link url to a machine-readable format,
   * which includes url-encoding, punycode, etc.
   **/ this.normalizeLink = $92d8e80e58d3750f$var$normalizeLink;
    /**
   * MarkdownIt#normalizeLinkText(url) -> String
   *
   * Function used to decode link url to a human-readable format`
   **/ this.normalizeLinkText = $92d8e80e58d3750f$var$normalizeLinkText;
    // Expose utils & helpers for easy acces from plugins
    /**
   * MarkdownIt#utils -> utils
   *
   * Assorted utility functions, useful to write plugins. See details
   * [here](https://github.com/markdown-it/markdown-it/blob/master/lib/common/utils.js).
   **/ this.utils = $l6IUK;
    /**
   * MarkdownIt#helpers -> helpers
   *
   * Link components parser functions, useful to write plugins. See details
   * [here](https://github.com/markdown-it/markdown-it/blob/master/lib/helpers).
   **/ this.helpers = $l6IUK.assign({}, $gqPyc);
    this.options = {};
    this.configure(presetName);
    if (options) this.set(options);
}
/** chainable
 * MarkdownIt.set(options)
 *
 * Set parser options (in the same format as in constructor). Probably, you
 * will never need it, but you can change options after constructor call.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')()
 *             .set({ html: true, breaks: true })
 *             .set({ typographer, true });
 * ```
 *
 * __Note:__ To achieve the best possible performance, don't modify a
 * `markdown-it` instance options on the fly. If you need multiple configurations
 * it's best to create multiple instances and initialize each with separate
 * config.
 **/ $92d8e80e58d3750f$var$MarkdownIt.prototype.set = function(options) {
    $l6IUK.assign(this.options, options);
    return this;
};
/** chainable, internal
 * MarkdownIt.configure(presets)
 *
 * Batch load of all options and compenent settings. This is internal method,
 * and you probably will not need it. But if you will - see available presets
 * and data structure [here](https://github.com/markdown-it/markdown-it/tree/master/lib/presets)
 *
 * We strongly recommend to use presets instead of direct config loads. That
 * will give better compatibility with next versions.
 **/ $92d8e80e58d3750f$var$MarkdownIt.prototype.configure = function(presets) {
    var self = this, presetName;
    if ($l6IUK.isString(presets)) {
        presetName = presets;
        presets = $92d8e80e58d3750f$var$config[presetName];
        if (!presets) throw new Error('Wrong `markdown-it` preset "' + presetName + '", check name');
    }
    if (!presets) throw new Error('Wrong `markdown-it` preset, can\'t be empty');
    if (presets.options) self.set(presets.options);
    if (presets.components) Object.keys(presets.components).forEach(function(name) {
        if (presets.components[name].rules) self[name].ruler.enableOnly(presets.components[name].rules);
        if (presets.components[name].rules2) self[name].ruler2.enableOnly(presets.components[name].rules2);
    });
    return this;
};
/** chainable
 * MarkdownIt.enable(list, ignoreInvalid)
 * - list (String|Array): rule name or list of rule names to enable
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable list or rules. It will automatically find appropriate components,
 * containing rules with given names. If rule not found, and `ignoreInvalid`
 * not set - throws exception.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')()
 *             .enable(['sub', 'sup'])
 *             .disable('smartquotes');
 * ```
 **/ $92d8e80e58d3750f$var$MarkdownIt.prototype.enable = function(list, ignoreInvalid) {
    var result = [];
    if (!Array.isArray(list)) list = [
        list
    ];
    [
        'core',
        'block',
        'inline'
    ].forEach(function(chain) {
        result = result.concat(this[chain].ruler.enable(list, true));
    }, this);
    result = result.concat(this.inline.ruler2.enable(list, true));
    var missed = list.filter(function(name) {
        return result.indexOf(name) < 0;
    });
    if (missed.length && !ignoreInvalid) throw new Error('MarkdownIt. Failed to enable unknown rule(s): ' + missed);
    return this;
};
/** chainable
 * MarkdownIt.disable(list, ignoreInvalid)
 * - list (String|Array): rule name or list of rule names to disable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * The same as [[MarkdownIt.enable]], but turn specified rules off.
 **/ $92d8e80e58d3750f$var$MarkdownIt.prototype.disable = function(list, ignoreInvalid) {
    var result = [];
    if (!Array.isArray(list)) list = [
        list
    ];
    [
        'core',
        'block',
        'inline'
    ].forEach(function(chain) {
        result = result.concat(this[chain].ruler.disable(list, true));
    }, this);
    result = result.concat(this.inline.ruler2.disable(list, true));
    var missed = list.filter(function(name) {
        return result.indexOf(name) < 0;
    });
    if (missed.length && !ignoreInvalid) throw new Error('MarkdownIt. Failed to disable unknown rule(s): ' + missed);
    return this;
};
/** chainable
 * MarkdownIt.use(plugin, params)
 *
 * Load specified plugin with given params into current parser instance.
 * It's just a sugar to call `plugin(md, params)` with curring.
 *
 * ##### Example
 *
 * ```javascript
 * var iterator = require('markdown-it-for-inline');
 * var md = require('markdown-it')()
 *             .use(iterator, 'foo_replace', 'text', function (tokens, idx) {
 *               tokens[idx].content = tokens[idx].content.replace(/foo/g, 'bar');
 *             });
 * ```
 **/ $92d8e80e58d3750f$var$MarkdownIt.prototype.use = function(plugin /*, params, ... */ ) {
    var args = [
        this
    ].concat(Array.prototype.slice.call(arguments, 1));
    plugin.apply(plugin, args);
    return this;
};
/** internal
 * MarkdownIt.parse(src, env) -> Array
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Parse input string and return list of block tokens (special token type
 * "inline" will contain list of inline tokens). You should not call this
 * method directly, until you write custom renderer (for example, to produce
 * AST).
 *
 * `env` is used to pass data between "distributed" rules and return additional
 * metadata like reference info, needed for the renderer. It also can be used to
 * inject data in specific cases. Usually, you will be ok to pass `{}`,
 * and then pass updated object to renderer.
 **/ $92d8e80e58d3750f$var$MarkdownIt.prototype.parse = function(src, env) {
    if (typeof src !== 'string') throw new Error('Input data should be a String');
    var state = new this.core.State(src, this, env);
    this.core.process(state);
    return state.tokens;
};
/**
 * MarkdownIt.render(src [, env]) -> String
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Render markdown string into html. It does all magic for you :).
 *
 * `env` can be used to inject additional metadata (`{}` by default).
 * But you will not need it with high probability. See also comment
 * in [[MarkdownIt.parse]].
 **/ $92d8e80e58d3750f$var$MarkdownIt.prototype.render = function(src, env) {
    env = env || {};
    return this.renderer.render(this.parse(src, env), this.options, env);
};
/** internal
 * MarkdownIt.parseInline(src, env) -> Array
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * The same as [[MarkdownIt.parse]] but skip all block rules. It returns the
 * block tokens list with the single `inline` element, containing parsed inline
 * tokens in `children` property. Also updates `env` object.
 **/ $92d8e80e58d3750f$var$MarkdownIt.prototype.parseInline = function(src, env) {
    var state = new this.core.State(src, this, env);
    state.inlineMode = true;
    this.core.process(state);
    return state.tokens;
};
/**
 * MarkdownIt.renderInline(src [, env]) -> String
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Similar to [[MarkdownIt.render]] but for single paragraph content. Result
 * will NOT be wrapped into `<p>` tags.
 **/ $92d8e80e58d3750f$var$MarkdownIt.prototype.renderInline = function(src, env) {
    env = env || {};
    return this.renderer.render(this.parseInline(src, env), this.options, env);
};
module.exports = $92d8e80e58d3750f$var$MarkdownIt;

});
parcelRegister("l6IUK", function(module, exports) {

$parcel$export(module.exports, "lib", () => $f5dcff8dfcedf068$export$16c08b91f883959a, (v) => $f5dcff8dfcedf068$export$16c08b91f883959a = v);
$parcel$export(module.exports, "assign", () => $f5dcff8dfcedf068$export$e6e34fd1f2686227, (v) => $f5dcff8dfcedf068$export$e6e34fd1f2686227 = v);
$parcel$export(module.exports, "isString", () => $f5dcff8dfcedf068$export$844ec244b1367d54, (v) => $f5dcff8dfcedf068$export$844ec244b1367d54 = v);
$parcel$export(module.exports, "has", () => $f5dcff8dfcedf068$export$a4f4bb6b1453fff5, (v) => $f5dcff8dfcedf068$export$a4f4bb6b1453fff5 = v);
$parcel$export(module.exports, "unescapeMd", () => $f5dcff8dfcedf068$export$5ccde1ea0c14bb03, (v) => $f5dcff8dfcedf068$export$5ccde1ea0c14bb03 = v);
$parcel$export(module.exports, "unescapeAll", () => $f5dcff8dfcedf068$export$db8a17c6655f7e2c, (v) => $f5dcff8dfcedf068$export$db8a17c6655f7e2c = v);
$parcel$export(module.exports, "isValidEntityCode", () => $f5dcff8dfcedf068$export$644a8f5b13b2a36d, (v) => $f5dcff8dfcedf068$export$644a8f5b13b2a36d = v);
$parcel$export(module.exports, "fromCodePoint", () => $f5dcff8dfcedf068$export$73bfc63873071f74, (v) => $f5dcff8dfcedf068$export$73bfc63873071f74 = v);
$parcel$export(module.exports, "escapeHtml", () => $f5dcff8dfcedf068$export$4cf11838cdc2a8a8, (v) => $f5dcff8dfcedf068$export$4cf11838cdc2a8a8 = v);
$parcel$export(module.exports, "arrayReplaceAt", () => $f5dcff8dfcedf068$export$f78478f71955b6bc, (v) => $f5dcff8dfcedf068$export$f78478f71955b6bc = v);
$parcel$export(module.exports, "isSpace", () => $f5dcff8dfcedf068$export$1d5ccafae59b4926, (v) => $f5dcff8dfcedf068$export$1d5ccafae59b4926 = v);
$parcel$export(module.exports, "isWhiteSpace", () => $f5dcff8dfcedf068$export$3c52dd84024ae72c, (v) => $f5dcff8dfcedf068$export$3c52dd84024ae72c = v);
$parcel$export(module.exports, "isMdAsciiPunct", () => $f5dcff8dfcedf068$export$829a0d33ae4e744, (v) => $f5dcff8dfcedf068$export$829a0d33ae4e744 = v);
$parcel$export(module.exports, "isPunctChar", () => $f5dcff8dfcedf068$export$4888a643af800fc1, (v) => $f5dcff8dfcedf068$export$4888a643af800fc1 = v);
$parcel$export(module.exports, "escapeRE", () => $f5dcff8dfcedf068$export$bc616c8f7dc20d5d, (v) => $f5dcff8dfcedf068$export$bc616c8f7dc20d5d = v);
$parcel$export(module.exports, "normalizeReference", () => $f5dcff8dfcedf068$export$20ef46802c8744b, (v) => $f5dcff8dfcedf068$export$20ef46802c8744b = v);
// Utilities
//
////////////////////////////////////////////////////////////////////////////////
// Re-export libraries commonly used in both markdown-it and its plugins,
// so plugins won't have to depend on them explicitly, which reduces their
// bundled size (e.g. a browser build).
//
var $f5dcff8dfcedf068$export$16c08b91f883959a;
var $f5dcff8dfcedf068$export$e6e34fd1f2686227;
var $f5dcff8dfcedf068$export$844ec244b1367d54;
var $f5dcff8dfcedf068$export$a4f4bb6b1453fff5;
var $f5dcff8dfcedf068$export$5ccde1ea0c14bb03;
var $f5dcff8dfcedf068$export$db8a17c6655f7e2c;
var $f5dcff8dfcedf068$export$644a8f5b13b2a36d;
var $f5dcff8dfcedf068$export$73bfc63873071f74;
// exports.replaceEntities     = replaceEntities;
var $f5dcff8dfcedf068$export$4cf11838cdc2a8a8;
var $f5dcff8dfcedf068$export$f78478f71955b6bc;
var $f5dcff8dfcedf068$export$1d5ccafae59b4926;
var $f5dcff8dfcedf068$export$3c52dd84024ae72c;
var $f5dcff8dfcedf068$export$829a0d33ae4e744;
var $f5dcff8dfcedf068$export$4888a643af800fc1;
var $f5dcff8dfcedf068$export$bc616c8f7dc20d5d;
var $f5dcff8dfcedf068$export$20ef46802c8744b;
'use strict';
function $f5dcff8dfcedf068$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $f5dcff8dfcedf068$var$isString(obj) {
    return $f5dcff8dfcedf068$var$_class(obj) === '[object String]';
}
var $f5dcff8dfcedf068$var$_hasOwnProperty = Object.prototype.hasOwnProperty;
function $f5dcff8dfcedf068$var$has(object, key) {
    return $f5dcff8dfcedf068$var$_hasOwnProperty.call(object, key);
}
// Merge objects
//
function $f5dcff8dfcedf068$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        if (typeof source !== 'object') throw new TypeError(source + 'must be object');
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
// Remove element from array and put another array at those position.
// Useful for some operations with tokens
function $f5dcff8dfcedf068$var$arrayReplaceAt(src, pos, newElements) {
    return [].concat(src.slice(0, pos), newElements, src.slice(pos + 1));
}
////////////////////////////////////////////////////////////////////////////////
function $f5dcff8dfcedf068$var$isValidEntityCode(c) {
    /*eslint no-bitwise:0*/ // broken sequence
    if (c >= 0xD800 && c <= 0xDFFF) return false;
    // never used
    if (c >= 0xFDD0 && c <= 0xFDEF) return false;
    if ((c & 0xFFFF) === 0xFFFF || (c & 0xFFFF) === 0xFFFE) return false;
    // control codes
    if (c >= 0x00 && c <= 0x08) return false;
    if (c === 0x0B) return false;
    if (c >= 0x0E && c <= 0x1F) return false;
    if (c >= 0x7F && c <= 0x9F) return false;
    // out of range
    if (c > 0x10FFFF) return false;
    return true;
}
function $f5dcff8dfcedf068$var$fromCodePoint(c) {
    /*eslint no-bitwise:0*/ if (c > 0xffff) {
        c -= 0x10000;
        var surrogate1 = 0xd800 + (c >> 10), surrogate2 = 0xdc00 + (c & 0x3ff);
        return String.fromCharCode(surrogate1, surrogate2);
    }
    return String.fromCharCode(c);
}
var $f5dcff8dfcedf068$var$UNESCAPE_MD_RE = /\\([!"#$%&'()*+,\-.\/:;<=>?@[\\\]^_`{|}~])/g;
var $f5dcff8dfcedf068$var$ENTITY_RE = /&([a-z#][a-z0-9]{1,31});/gi;
var $f5dcff8dfcedf068$var$UNESCAPE_ALL_RE = new RegExp($f5dcff8dfcedf068$var$UNESCAPE_MD_RE.source + '|' + $f5dcff8dfcedf068$var$ENTITY_RE.source, 'gi');
var $f5dcff8dfcedf068$var$DIGITAL_ENTITY_TEST_RE = /^#((?:x[a-f0-9]{1,8}|[0-9]{1,8}))$/i;

var $3q5w3 = parcelRequire("3q5w3");
function $f5dcff8dfcedf068$var$replaceEntityPattern(match, name) {
    var code;
    if ($f5dcff8dfcedf068$var$has($3q5w3, name)) return $3q5w3[name];
    if (name.charCodeAt(0) === 0x23 /* # */  && $f5dcff8dfcedf068$var$DIGITAL_ENTITY_TEST_RE.test(name)) {
        code = name[1].toLowerCase() === 'x' ? parseInt(name.slice(2), 16) : parseInt(name.slice(1), 10);
        if ($f5dcff8dfcedf068$var$isValidEntityCode(code)) return $f5dcff8dfcedf068$var$fromCodePoint(code);
    }
    return match;
}
/*function replaceEntities(str) {
  if (str.indexOf('&') < 0) { return str; }

  return str.replace(ENTITY_RE, replaceEntityPattern);
}*/ function $f5dcff8dfcedf068$var$unescapeMd(str) {
    if (str.indexOf('\\') < 0) return str;
    return str.replace($f5dcff8dfcedf068$var$UNESCAPE_MD_RE, '$1');
}
function $f5dcff8dfcedf068$var$unescapeAll(str) {
    if (str.indexOf('\\') < 0 && str.indexOf('&') < 0) return str;
    return str.replace($f5dcff8dfcedf068$var$UNESCAPE_ALL_RE, function(match, escaped, entity) {
        if (escaped) return escaped;
        return $f5dcff8dfcedf068$var$replaceEntityPattern(match, entity);
    });
}
////////////////////////////////////////////////////////////////////////////////
var $f5dcff8dfcedf068$var$HTML_ESCAPE_TEST_RE = /[&<>"]/;
var $f5dcff8dfcedf068$var$HTML_ESCAPE_REPLACE_RE = /[&<>"]/g;
var $f5dcff8dfcedf068$var$HTML_REPLACEMENTS = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;'
};
function $f5dcff8dfcedf068$var$replaceUnsafeChar(ch) {
    return $f5dcff8dfcedf068$var$HTML_REPLACEMENTS[ch];
}
function $f5dcff8dfcedf068$var$escapeHtml(str) {
    if ($f5dcff8dfcedf068$var$HTML_ESCAPE_TEST_RE.test(str)) return str.replace($f5dcff8dfcedf068$var$HTML_ESCAPE_REPLACE_RE, $f5dcff8dfcedf068$var$replaceUnsafeChar);
    return str;
}
////////////////////////////////////////////////////////////////////////////////
var $f5dcff8dfcedf068$var$REGEXP_ESCAPE_RE = /[.?*+^$[\]\\(){}|-]/g;
function $f5dcff8dfcedf068$var$escapeRE(str) {
    return str.replace($f5dcff8dfcedf068$var$REGEXP_ESCAPE_RE, '\\$&');
}
////////////////////////////////////////////////////////////////////////////////
function $f5dcff8dfcedf068$var$isSpace(code) {
    switch(code){
        case 0x09:
        case 0x20:
            return true;
    }
    return false;
}
// Zs (unicode class) || [\t\f\v\r\n]
function $f5dcff8dfcedf068$var$isWhiteSpace(code) {
    if (code >= 0x2000 && code <= 0x200A) return true;
    switch(code){
        case 0x09:
        case 0x0A:
        case 0x0B:
        case 0x0C:
        case 0x0D:
        case 0x20:
        case 0xA0:
        case 0x1680:
        case 0x202F:
        case 0x205F:
        case 0x3000:
            return true;
    }
    return false;
}

var $dDBFM = parcelRequire("dDBFM");
// Currently without astral characters support.
function $f5dcff8dfcedf068$var$isPunctChar(ch) {
    return $dDBFM.test(ch);
}
// Markdown ASCII punctuation characters.
//
// !, ", #, $, %, &, ', (, ), *, +, ,, -, ., /, :, ;, <, =, >, ?, @, [, \, ], ^, _, `, {, |, }, or ~
// http://spec.commonmark.org/0.15/#ascii-punctuation-character
//
// Don't confuse with unicode punctuation !!! It lacks some chars in ascii range.
//
function $f5dcff8dfcedf068$var$isMdAsciiPunct(ch) {
    switch(ch){
        case 0x21 /* ! */ :
        case 0x22 /* " */ :
        case 0x23 /* # */ :
        case 0x24 /* $ */ :
        case 0x25 /* % */ :
        case 0x26 /* & */ :
        case 0x27 /* ' */ :
        case 0x28 /* ( */ :
        case 0x29 /* ) */ :
        case 0x2A /* * */ :
        case 0x2B /* + */ :
        case 0x2C /* , */ :
        case 0x2D /* - */ :
        case 0x2E /* . */ :
        case 0x2F /* / */ :
        case 0x3A /* : */ :
        case 0x3B /* ; */ :
        case 0x3C /* < */ :
        case 0x3D /* = */ :
        case 0x3E /* > */ :
        case 0x3F /* ? */ :
        case 0x40 /* @ */ :
        case 0x5B /* [ */ :
        case 0x5C /* \ */ :
        case 0x5D /* ] */ :
        case 0x5E /* ^ */ :
        case 0x5F /* _ */ :
        case 0x60 /* ` */ :
        case 0x7B /* { */ :
        case 0x7C /* | */ :
        case 0x7D /* } */ :
        case 0x7E /* ~ */ :
            return true;
        default:
            return false;
    }
}
// Hepler to unify [reference labels].
//
function $f5dcff8dfcedf068$var$normalizeReference(str) {
    // Trim and collapse whitespace
    //
    str = str.trim().replace(/\s+/g, ' ');
    // In node v10 'ẞ'.toLowerCase() === 'Ṿ', which is presumed to be a bug
    // fixed in v12 (couldn't find any details).
    //
    // So treat this one as a special case
    // (remove this when node v10 is no longer supported).
    //
    if ("\u1E9E".toLowerCase() === "\u1E7E") str = str.replace(/ẞ/g, "\xdf");
    // .toLowerCase().toUpperCase() should get rid of all differences
    // between letter variants.
    //
    // Simple .toLowerCase() doesn't normalize 125 code points correctly,
    // and .toUpperCase doesn't normalize 6 of them (list of exceptions:
    // İ, ϴ, ẞ, Ω, K, Å - those are already uppercased, but have differently
    // uppercased versions).
    //
    // Here's an example showing how it happens. Lets take greek letter omega:
    // uppercase U+0398 (Θ), U+03f4 (ϴ) and lowercase U+03b8 (θ), U+03d1 (ϑ)
    //
    // Unicode entries:
    // 0398;GREEK CAPITAL LETTER THETA;Lu;0;L;;;;;N;;;;03B8;
    // 03B8;GREEK SMALL LETTER THETA;Ll;0;L;;;;;N;;;0398;;0398
    // 03D1;GREEK THETA SYMBOL;Ll;0;L;<compat> 03B8;;;;N;GREEK SMALL LETTER SCRIPT THETA;;0398;;0398
    // 03F4;GREEK CAPITAL THETA SYMBOL;Lu;0;L;<compat> 0398;;;;N;;;;03B8;
    //
    // Case-insensitive comparison should treat all of them as equivalent.
    //
    // But .toLowerCase() doesn't change ϑ (it's already lowercase),
    // and .toUpperCase() doesn't change ϴ (already uppercase).
    //
    // Applying first lower then upper case normalizes any character:
    // '\u0398\u03f4\u03b8\u03d1'.toLowerCase().toUpperCase() === '\u0398\u0398\u0398\u0398'
    //
    // Note: this is equivalent to unicode case folding; unicode normalization
    // is a different step that is not required here.
    //
    // Final result should be uppercased, because it's later stored in an object
    // (this avoid a conflict with Object.prototype members,
    // most notably, `__proto__`)
    //
    return str.toLowerCase().toUpperCase();
}
$f5dcff8dfcedf068$export$16c08b91f883959a = {};

$f5dcff8dfcedf068$export$16c08b91f883959a.mdurl = (parcelRequire("90JXC"));

$f5dcff8dfcedf068$export$16c08b91f883959a.ucmicro = (parcelRequire("1I1Rw"));
$f5dcff8dfcedf068$export$e6e34fd1f2686227 = $f5dcff8dfcedf068$var$assign;
$f5dcff8dfcedf068$export$844ec244b1367d54 = $f5dcff8dfcedf068$var$isString;
$f5dcff8dfcedf068$export$a4f4bb6b1453fff5 = $f5dcff8dfcedf068$var$has;
$f5dcff8dfcedf068$export$5ccde1ea0c14bb03 = $f5dcff8dfcedf068$var$unescapeMd;
$f5dcff8dfcedf068$export$db8a17c6655f7e2c = $f5dcff8dfcedf068$var$unescapeAll;
$f5dcff8dfcedf068$export$644a8f5b13b2a36d = $f5dcff8dfcedf068$var$isValidEntityCode;
$f5dcff8dfcedf068$export$73bfc63873071f74 = $f5dcff8dfcedf068$var$fromCodePoint;
$f5dcff8dfcedf068$export$4cf11838cdc2a8a8 = $f5dcff8dfcedf068$var$escapeHtml;
$f5dcff8dfcedf068$export$f78478f71955b6bc = $f5dcff8dfcedf068$var$arrayReplaceAt;
$f5dcff8dfcedf068$export$1d5ccafae59b4926 = $f5dcff8dfcedf068$var$isSpace;
$f5dcff8dfcedf068$export$3c52dd84024ae72c = $f5dcff8dfcedf068$var$isWhiteSpace;
$f5dcff8dfcedf068$export$829a0d33ae4e744 = $f5dcff8dfcedf068$var$isMdAsciiPunct;
$f5dcff8dfcedf068$export$4888a643af800fc1 = $f5dcff8dfcedf068$var$isPunctChar;
$f5dcff8dfcedf068$export$bc616c8f7dc20d5d = $f5dcff8dfcedf068$var$escapeRE;
$f5dcff8dfcedf068$export$20ef46802c8744b = $f5dcff8dfcedf068$var$normalizeReference;

});
parcelRegister("3q5w3", function(module, exports) {
// HTML5 entities map: { name -> utf16string }
//
'use strict';

/*eslint quotes:0*/ module.exports = (parcelRequire("hHHTu"));

});
parcelRegister("hHHTu", function(module, exports) {
module.exports = JSON.parse('{"Aacute":"\xc1","aacute":"\xe1","Abreve":"\u0102","abreve":"\u0103","ac":"\u223E","acd":"\u223F","acE":"\u223E\u0333","Acirc":"\xc2","acirc":"\xe2","acute":"\xb4","Acy":"\u0410","acy":"\u0430","AElig":"\xc6","aelig":"\xe6","af":"\u2061","Afr":"\uD835\uDD04","afr":"\uD835\uDD1E","Agrave":"\xc0","agrave":"\xe0","alefsym":"\u2135","aleph":"\u2135","Alpha":"\u0391","alpha":"\u03B1","Amacr":"\u0100","amacr":"\u0101","amalg":"\u2A3F","amp":"&","AMP":"&","andand":"\u2A55","And":"\u2A53","and":"\u2227","andd":"\u2A5C","andslope":"\u2A58","andv":"\u2A5A","ang":"\u2220","ange":"\u29A4","angle":"\u2220","angmsdaa":"\u29A8","angmsdab":"\u29A9","angmsdac":"\u29AA","angmsdad":"\u29AB","angmsdae":"\u29AC","angmsdaf":"\u29AD","angmsdag":"\u29AE","angmsdah":"\u29AF","angmsd":"\u2221","angrt":"\u221F","angrtvb":"\u22BE","angrtvbd":"\u299D","angsph":"\u2222","angst":"\xc5","angzarr":"\u237C","Aogon":"\u0104","aogon":"\u0105","Aopf":"\uD835\uDD38","aopf":"\uD835\uDD52","apacir":"\u2A6F","ap":"\u2248","apE":"\u2A70","ape":"\u224A","apid":"\u224B","apos":"\'","ApplyFunction":"\u2061","approx":"\u2248","approxeq":"\u224A","Aring":"\xc5","aring":"\xe5","Ascr":"\uD835\uDC9C","ascr":"\uD835\uDCB6","Assign":"\u2254","ast":"*","asymp":"\u2248","asympeq":"\u224D","Atilde":"\xc3","atilde":"\xe3","Auml":"\xc4","auml":"\xe4","awconint":"\u2233","awint":"\u2A11","backcong":"\u224C","backepsilon":"\u03F6","backprime":"\u2035","backsim":"\u223D","backsimeq":"\u22CD","Backslash":"\u2216","Barv":"\u2AE7","barvee":"\u22BD","barwed":"\u2305","Barwed":"\u2306","barwedge":"\u2305","bbrk":"\u23B5","bbrktbrk":"\u23B6","bcong":"\u224C","Bcy":"\u0411","bcy":"\u0431","bdquo":"\u201E","becaus":"\u2235","because":"\u2235","Because":"\u2235","bemptyv":"\u29B0","bepsi":"\u03F6","bernou":"\u212C","Bernoullis":"\u212C","Beta":"\u0392","beta":"\u03B2","beth":"\u2136","between":"\u226C","Bfr":"\uD835\uDD05","bfr":"\uD835\uDD1F","bigcap":"\u22C2","bigcirc":"\u25EF","bigcup":"\u22C3","bigodot":"\u2A00","bigoplus":"\u2A01","bigotimes":"\u2A02","bigsqcup":"\u2A06","bigstar":"\u2605","bigtriangledown":"\u25BD","bigtriangleup":"\u25B3","biguplus":"\u2A04","bigvee":"\u22C1","bigwedge":"\u22C0","bkarow":"\u290D","blacklozenge":"\u29EB","blacksquare":"\u25AA","blacktriangle":"\u25B4","blacktriangledown":"\u25BE","blacktriangleleft":"\u25C2","blacktriangleright":"\u25B8","blank":"\u2423","blk12":"\u2592","blk14":"\u2591","blk34":"\u2593","block":"\u2588","bne":"=\u20E5","bnequiv":"\u2261\u20E5","bNot":"\u2AED","bnot":"\u2310","Bopf":"\uD835\uDD39","bopf":"\uD835\uDD53","bot":"\u22A5","bottom":"\u22A5","bowtie":"\u22C8","boxbox":"\u29C9","boxdl":"\u2510","boxdL":"\u2555","boxDl":"\u2556","boxDL":"\u2557","boxdr":"\u250C","boxdR":"\u2552","boxDr":"\u2553","boxDR":"\u2554","boxh":"\u2500","boxH":"\u2550","boxhd":"\u252C","boxHd":"\u2564","boxhD":"\u2565","boxHD":"\u2566","boxhu":"\u2534","boxHu":"\u2567","boxhU":"\u2568","boxHU":"\u2569","boxminus":"\u229F","boxplus":"\u229E","boxtimes":"\u22A0","boxul":"\u2518","boxuL":"\u255B","boxUl":"\u255C","boxUL":"\u255D","boxur":"\u2514","boxuR":"\u2558","boxUr":"\u2559","boxUR":"\u255A","boxv":"\u2502","boxV":"\u2551","boxvh":"\u253C","boxvH":"\u256A","boxVh":"\u256B","boxVH":"\u256C","boxvl":"\u2524","boxvL":"\u2561","boxVl":"\u2562","boxVL":"\u2563","boxvr":"\u251C","boxvR":"\u255E","boxVr":"\u255F","boxVR":"\u2560","bprime":"\u2035","breve":"\u02D8","Breve":"\u02D8","brvbar":"\xa6","bscr":"\uD835\uDCB7","Bscr":"\u212C","bsemi":"\u204F","bsim":"\u223D","bsime":"\u22CD","bsolb":"\u29C5","bsol":"\\\\","bsolhsub":"\u27C8","bull":"\u2022","bullet":"\u2022","bump":"\u224E","bumpE":"\u2AAE","bumpe":"\u224F","Bumpeq":"\u224E","bumpeq":"\u224F","Cacute":"\u0106","cacute":"\u0107","capand":"\u2A44","capbrcup":"\u2A49","capcap":"\u2A4B","cap":"\u2229","Cap":"\u22D2","capcup":"\u2A47","capdot":"\u2A40","CapitalDifferentialD":"\u2145","caps":"\u2229\uFE00","caret":"\u2041","caron":"\u02C7","Cayleys":"\u212D","ccaps":"\u2A4D","Ccaron":"\u010C","ccaron":"\u010D","Ccedil":"\xc7","ccedil":"\xe7","Ccirc":"\u0108","ccirc":"\u0109","Cconint":"\u2230","ccups":"\u2A4C","ccupssm":"\u2A50","Cdot":"\u010A","cdot":"\u010B","cedil":"\xb8","Cedilla":"\xb8","cemptyv":"\u29B2","cent":"\xa2","centerdot":"\xb7","CenterDot":"\xb7","cfr":"\uD835\uDD20","Cfr":"\u212D","CHcy":"\u0427","chcy":"\u0447","check":"\u2713","checkmark":"\u2713","Chi":"\u03A7","chi":"\u03C7","circ":"\u02C6","circeq":"\u2257","circlearrowleft":"\u21BA","circlearrowright":"\u21BB","circledast":"\u229B","circledcirc":"\u229A","circleddash":"\u229D","CircleDot":"\u2299","circledR":"\xae","circledS":"\u24C8","CircleMinus":"\u2296","CirclePlus":"\u2295","CircleTimes":"\u2297","cir":"\u25CB","cirE":"\u29C3","cire":"\u2257","cirfnint":"\u2A10","cirmid":"\u2AEF","cirscir":"\u29C2","ClockwiseContourIntegral":"\u2232","CloseCurlyDoubleQuote":"\u201D","CloseCurlyQuote":"\u2019","clubs":"\u2663","clubsuit":"\u2663","colon":":","Colon":"\u2237","Colone":"\u2A74","colone":"\u2254","coloneq":"\u2254","comma":",","commat":"@","comp":"\u2201","compfn":"\u2218","complement":"\u2201","complexes":"\u2102","cong":"\u2245","congdot":"\u2A6D","Congruent":"\u2261","conint":"\u222E","Conint":"\u222F","ContourIntegral":"\u222E","copf":"\uD835\uDD54","Copf":"\u2102","coprod":"\u2210","Coproduct":"\u2210","copy":"\xa9","COPY":"\xa9","copysr":"\u2117","CounterClockwiseContourIntegral":"\u2233","crarr":"\u21B5","cross":"\u2717","Cross":"\u2A2F","Cscr":"\uD835\uDC9E","cscr":"\uD835\uDCB8","csub":"\u2ACF","csube":"\u2AD1","csup":"\u2AD0","csupe":"\u2AD2","ctdot":"\u22EF","cudarrl":"\u2938","cudarrr":"\u2935","cuepr":"\u22DE","cuesc":"\u22DF","cularr":"\u21B6","cularrp":"\u293D","cupbrcap":"\u2A48","cupcap":"\u2A46","CupCap":"\u224D","cup":"\u222A","Cup":"\u22D3","cupcup":"\u2A4A","cupdot":"\u228D","cupor":"\u2A45","cups":"\u222A\uFE00","curarr":"\u21B7","curarrm":"\u293C","curlyeqprec":"\u22DE","curlyeqsucc":"\u22DF","curlyvee":"\u22CE","curlywedge":"\u22CF","curren":"\xa4","curvearrowleft":"\u21B6","curvearrowright":"\u21B7","cuvee":"\u22CE","cuwed":"\u22CF","cwconint":"\u2232","cwint":"\u2231","cylcty":"\u232D","dagger":"\u2020","Dagger":"\u2021","daleth":"\u2138","darr":"\u2193","Darr":"\u21A1","dArr":"\u21D3","dash":"\u2010","Dashv":"\u2AE4","dashv":"\u22A3","dbkarow":"\u290F","dblac":"\u02DD","Dcaron":"\u010E","dcaron":"\u010F","Dcy":"\u0414","dcy":"\u0434","ddagger":"\u2021","ddarr":"\u21CA","DD":"\u2145","dd":"\u2146","DDotrahd":"\u2911","ddotseq":"\u2A77","deg":"\xb0","Del":"\u2207","Delta":"\u0394","delta":"\u03B4","demptyv":"\u29B1","dfisht":"\u297F","Dfr":"\uD835\uDD07","dfr":"\uD835\uDD21","dHar":"\u2965","dharl":"\u21C3","dharr":"\u21C2","DiacriticalAcute":"\xb4","DiacriticalDot":"\u02D9","DiacriticalDoubleAcute":"\u02DD","DiacriticalGrave":"`","DiacriticalTilde":"\u02DC","diam":"\u22C4","diamond":"\u22C4","Diamond":"\u22C4","diamondsuit":"\u2666","diams":"\u2666","die":"\xa8","DifferentialD":"\u2146","digamma":"\u03DD","disin":"\u22F2","div":"\xf7","divide":"\xf7","divideontimes":"\u22C7","divonx":"\u22C7","DJcy":"\u0402","djcy":"\u0452","dlcorn":"\u231E","dlcrop":"\u230D","dollar":"$","Dopf":"\uD835\uDD3B","dopf":"\uD835\uDD55","Dot":"\xa8","dot":"\u02D9","DotDot":"\u20DC","doteq":"\u2250","doteqdot":"\u2251","DotEqual":"\u2250","dotminus":"\u2238","dotplus":"\u2214","dotsquare":"\u22A1","doublebarwedge":"\u2306","DoubleContourIntegral":"\u222F","DoubleDot":"\xa8","DoubleDownArrow":"\u21D3","DoubleLeftArrow":"\u21D0","DoubleLeftRightArrow":"\u21D4","DoubleLeftTee":"\u2AE4","DoubleLongLeftArrow":"\u27F8","DoubleLongLeftRightArrow":"\u27FA","DoubleLongRightArrow":"\u27F9","DoubleRightArrow":"\u21D2","DoubleRightTee":"\u22A8","DoubleUpArrow":"\u21D1","DoubleUpDownArrow":"\u21D5","DoubleVerticalBar":"\u2225","DownArrowBar":"\u2913","downarrow":"\u2193","DownArrow":"\u2193","Downarrow":"\u21D3","DownArrowUpArrow":"\u21F5","DownBreve":"\u0311","downdownarrows":"\u21CA","downharpoonleft":"\u21C3","downharpoonright":"\u21C2","DownLeftRightVector":"\u2950","DownLeftTeeVector":"\u295E","DownLeftVectorBar":"\u2956","DownLeftVector":"\u21BD","DownRightTeeVector":"\u295F","DownRightVectorBar":"\u2957","DownRightVector":"\u21C1","DownTeeArrow":"\u21A7","DownTee":"\u22A4","drbkarow":"\u2910","drcorn":"\u231F","drcrop":"\u230C","Dscr":"\uD835\uDC9F","dscr":"\uD835\uDCB9","DScy":"\u0405","dscy":"\u0455","dsol":"\u29F6","Dstrok":"\u0110","dstrok":"\u0111","dtdot":"\u22F1","dtri":"\u25BF","dtrif":"\u25BE","duarr":"\u21F5","duhar":"\u296F","dwangle":"\u29A6","DZcy":"\u040F","dzcy":"\u045F","dzigrarr":"\u27FF","Eacute":"\xc9","eacute":"\xe9","easter":"\u2A6E","Ecaron":"\u011A","ecaron":"\u011B","Ecirc":"\xca","ecirc":"\xea","ecir":"\u2256","ecolon":"\u2255","Ecy":"\u042D","ecy":"\u044D","eDDot":"\u2A77","Edot":"\u0116","edot":"\u0117","eDot":"\u2251","ee":"\u2147","efDot":"\u2252","Efr":"\uD835\uDD08","efr":"\uD835\uDD22","eg":"\u2A9A","Egrave":"\xc8","egrave":"\xe8","egs":"\u2A96","egsdot":"\u2A98","el":"\u2A99","Element":"\u2208","elinters":"\u23E7","ell":"\u2113","els":"\u2A95","elsdot":"\u2A97","Emacr":"\u0112","emacr":"\u0113","empty":"\u2205","emptyset":"\u2205","EmptySmallSquare":"\u25FB","emptyv":"\u2205","EmptyVerySmallSquare":"\u25AB","emsp13":"\u2004","emsp14":"\u2005","emsp":"\u2003","ENG":"\u014A","eng":"\u014B","ensp":"\u2002","Eogon":"\u0118","eogon":"\u0119","Eopf":"\uD835\uDD3C","eopf":"\uD835\uDD56","epar":"\u22D5","eparsl":"\u29E3","eplus":"\u2A71","epsi":"\u03B5","Epsilon":"\u0395","epsilon":"\u03B5","epsiv":"\u03F5","eqcirc":"\u2256","eqcolon":"\u2255","eqsim":"\u2242","eqslantgtr":"\u2A96","eqslantless":"\u2A95","Equal":"\u2A75","equals":"=","EqualTilde":"\u2242","equest":"\u225F","Equilibrium":"\u21CC","equiv":"\u2261","equivDD":"\u2A78","eqvparsl":"\u29E5","erarr":"\u2971","erDot":"\u2253","escr":"\u212F","Escr":"\u2130","esdot":"\u2250","Esim":"\u2A73","esim":"\u2242","Eta":"\u0397","eta":"\u03B7","ETH":"\xd0","eth":"\xf0","Euml":"\xcb","euml":"\xeb","euro":"\u20AC","excl":"!","exist":"\u2203","Exists":"\u2203","expectation":"\u2130","exponentiale":"\u2147","ExponentialE":"\u2147","fallingdotseq":"\u2252","Fcy":"\u0424","fcy":"\u0444","female":"\u2640","ffilig":"\uFB03","fflig":"\uFB00","ffllig":"\uFB04","Ffr":"\uD835\uDD09","ffr":"\uD835\uDD23","filig":"\uFB01","FilledSmallSquare":"\u25FC","FilledVerySmallSquare":"\u25AA","fjlig":"fj","flat":"\u266D","fllig":"\uFB02","fltns":"\u25B1","fnof":"\u0192","Fopf":"\uD835\uDD3D","fopf":"\uD835\uDD57","forall":"\u2200","ForAll":"\u2200","fork":"\u22D4","forkv":"\u2AD9","Fouriertrf":"\u2131","fpartint":"\u2A0D","frac12":"\xbd","frac13":"\u2153","frac14":"\xbc","frac15":"\u2155","frac16":"\u2159","frac18":"\u215B","frac23":"\u2154","frac25":"\u2156","frac34":"\xbe","frac35":"\u2157","frac38":"\u215C","frac45":"\u2158","frac56":"\u215A","frac58":"\u215D","frac78":"\u215E","frasl":"\u2044","frown":"\u2322","fscr":"\uD835\uDCBB","Fscr":"\u2131","gacute":"\u01F5","Gamma":"\u0393","gamma":"\u03B3","Gammad":"\u03DC","gammad":"\u03DD","gap":"\u2A86","Gbreve":"\u011E","gbreve":"\u011F","Gcedil":"\u0122","Gcirc":"\u011C","gcirc":"\u011D","Gcy":"\u0413","gcy":"\u0433","Gdot":"\u0120","gdot":"\u0121","ge":"\u2265","gE":"\u2267","gEl":"\u2A8C","gel":"\u22DB","geq":"\u2265","geqq":"\u2267","geqslant":"\u2A7E","gescc":"\u2AA9","ges":"\u2A7E","gesdot":"\u2A80","gesdoto":"\u2A82","gesdotol":"\u2A84","gesl":"\u22DB\uFE00","gesles":"\u2A94","Gfr":"\uD835\uDD0A","gfr":"\uD835\uDD24","gg":"\u226B","Gg":"\u22D9","ggg":"\u22D9","gimel":"\u2137","GJcy":"\u0403","gjcy":"\u0453","gla":"\u2AA5","gl":"\u2277","glE":"\u2A92","glj":"\u2AA4","gnap":"\u2A8A","gnapprox":"\u2A8A","gne":"\u2A88","gnE":"\u2269","gneq":"\u2A88","gneqq":"\u2269","gnsim":"\u22E7","Gopf":"\uD835\uDD3E","gopf":"\uD835\uDD58","grave":"`","GreaterEqual":"\u2265","GreaterEqualLess":"\u22DB","GreaterFullEqual":"\u2267","GreaterGreater":"\u2AA2","GreaterLess":"\u2277","GreaterSlantEqual":"\u2A7E","GreaterTilde":"\u2273","Gscr":"\uD835\uDCA2","gscr":"\u210A","gsim":"\u2273","gsime":"\u2A8E","gsiml":"\u2A90","gtcc":"\u2AA7","gtcir":"\u2A7A","gt":">","GT":">","Gt":"\u226B","gtdot":"\u22D7","gtlPar":"\u2995","gtquest":"\u2A7C","gtrapprox":"\u2A86","gtrarr":"\u2978","gtrdot":"\u22D7","gtreqless":"\u22DB","gtreqqless":"\u2A8C","gtrless":"\u2277","gtrsim":"\u2273","gvertneqq":"\u2269\uFE00","gvnE":"\u2269\uFE00","Hacek":"\u02C7","hairsp":"\u200A","half":"\xbd","hamilt":"\u210B","HARDcy":"\u042A","hardcy":"\u044A","harrcir":"\u2948","harr":"\u2194","hArr":"\u21D4","harrw":"\u21AD","Hat":"^","hbar":"\u210F","Hcirc":"\u0124","hcirc":"\u0125","hearts":"\u2665","heartsuit":"\u2665","hellip":"\u2026","hercon":"\u22B9","hfr":"\uD835\uDD25","Hfr":"\u210C","HilbertSpace":"\u210B","hksearow":"\u2925","hkswarow":"\u2926","hoarr":"\u21FF","homtht":"\u223B","hookleftarrow":"\u21A9","hookrightarrow":"\u21AA","hopf":"\uD835\uDD59","Hopf":"\u210D","horbar":"\u2015","HorizontalLine":"\u2500","hscr":"\uD835\uDCBD","Hscr":"\u210B","hslash":"\u210F","Hstrok":"\u0126","hstrok":"\u0127","HumpDownHump":"\u224E","HumpEqual":"\u224F","hybull":"\u2043","hyphen":"\u2010","Iacute":"\xcd","iacute":"\xed","ic":"\u2063","Icirc":"\xce","icirc":"\xee","Icy":"\u0418","icy":"\u0438","Idot":"\u0130","IEcy":"\u0415","iecy":"\u0435","iexcl":"\xa1","iff":"\u21D4","ifr":"\uD835\uDD26","Ifr":"\u2111","Igrave":"\xcc","igrave":"\xec","ii":"\u2148","iiiint":"\u2A0C","iiint":"\u222D","iinfin":"\u29DC","iiota":"\u2129","IJlig":"\u0132","ijlig":"\u0133","Imacr":"\u012A","imacr":"\u012B","image":"\u2111","ImaginaryI":"\u2148","imagline":"\u2110","imagpart":"\u2111","imath":"\u0131","Im":"\u2111","imof":"\u22B7","imped":"\u01B5","Implies":"\u21D2","incare":"\u2105","in":"\u2208","infin":"\u221E","infintie":"\u29DD","inodot":"\u0131","intcal":"\u22BA","int":"\u222B","Int":"\u222C","integers":"\u2124","Integral":"\u222B","intercal":"\u22BA","Intersection":"\u22C2","intlarhk":"\u2A17","intprod":"\u2A3C","InvisibleComma":"\u2063","InvisibleTimes":"\u2062","IOcy":"\u0401","iocy":"\u0451","Iogon":"\u012E","iogon":"\u012F","Iopf":"\uD835\uDD40","iopf":"\uD835\uDD5A","Iota":"\u0399","iota":"\u03B9","iprod":"\u2A3C","iquest":"\xbf","iscr":"\uD835\uDCBE","Iscr":"\u2110","isin":"\u2208","isindot":"\u22F5","isinE":"\u22F9","isins":"\u22F4","isinsv":"\u22F3","isinv":"\u2208","it":"\u2062","Itilde":"\u0128","itilde":"\u0129","Iukcy":"\u0406","iukcy":"\u0456","Iuml":"\xcf","iuml":"\xef","Jcirc":"\u0134","jcirc":"\u0135","Jcy":"\u0419","jcy":"\u0439","Jfr":"\uD835\uDD0D","jfr":"\uD835\uDD27","jmath":"\u0237","Jopf":"\uD835\uDD41","jopf":"\uD835\uDD5B","Jscr":"\uD835\uDCA5","jscr":"\uD835\uDCBF","Jsercy":"\u0408","jsercy":"\u0458","Jukcy":"\u0404","jukcy":"\u0454","Kappa":"\u039A","kappa":"\u03BA","kappav":"\u03F0","Kcedil":"\u0136","kcedil":"\u0137","Kcy":"\u041A","kcy":"\u043A","Kfr":"\uD835\uDD0E","kfr":"\uD835\uDD28","kgreen":"\u0138","KHcy":"\u0425","khcy":"\u0445","KJcy":"\u040C","kjcy":"\u045C","Kopf":"\uD835\uDD42","kopf":"\uD835\uDD5C","Kscr":"\uD835\uDCA6","kscr":"\uD835\uDCC0","lAarr":"\u21DA","Lacute":"\u0139","lacute":"\u013A","laemptyv":"\u29B4","lagran":"\u2112","Lambda":"\u039B","lambda":"\u03BB","lang":"\u27E8","Lang":"\u27EA","langd":"\u2991","langle":"\u27E8","lap":"\u2A85","Laplacetrf":"\u2112","laquo":"\xab","larrb":"\u21E4","larrbfs":"\u291F","larr":"\u2190","Larr":"\u219E","lArr":"\u21D0","larrfs":"\u291D","larrhk":"\u21A9","larrlp":"\u21AB","larrpl":"\u2939","larrsim":"\u2973","larrtl":"\u21A2","latail":"\u2919","lAtail":"\u291B","lat":"\u2AAB","late":"\u2AAD","lates":"\u2AAD\uFE00","lbarr":"\u290C","lBarr":"\u290E","lbbrk":"\u2772","lbrace":"{","lbrack":"[","lbrke":"\u298B","lbrksld":"\u298F","lbrkslu":"\u298D","Lcaron":"\u013D","lcaron":"\u013E","Lcedil":"\u013B","lcedil":"\u013C","lceil":"\u2308","lcub":"{","Lcy":"\u041B","lcy":"\u043B","ldca":"\u2936","ldquo":"\u201C","ldquor":"\u201E","ldrdhar":"\u2967","ldrushar":"\u294B","ldsh":"\u21B2","le":"\u2264","lE":"\u2266","LeftAngleBracket":"\u27E8","LeftArrowBar":"\u21E4","leftarrow":"\u2190","LeftArrow":"\u2190","Leftarrow":"\u21D0","LeftArrowRightArrow":"\u21C6","leftarrowtail":"\u21A2","LeftCeiling":"\u2308","LeftDoubleBracket":"\u27E6","LeftDownTeeVector":"\u2961","LeftDownVectorBar":"\u2959","LeftDownVector":"\u21C3","LeftFloor":"\u230A","leftharpoondown":"\u21BD","leftharpoonup":"\u21BC","leftleftarrows":"\u21C7","leftrightarrow":"\u2194","LeftRightArrow":"\u2194","Leftrightarrow":"\u21D4","leftrightarrows":"\u21C6","leftrightharpoons":"\u21CB","leftrightsquigarrow":"\u21AD","LeftRightVector":"\u294E","LeftTeeArrow":"\u21A4","LeftTee":"\u22A3","LeftTeeVector":"\u295A","leftthreetimes":"\u22CB","LeftTriangleBar":"\u29CF","LeftTriangle":"\u22B2","LeftTriangleEqual":"\u22B4","LeftUpDownVector":"\u2951","LeftUpTeeVector":"\u2960","LeftUpVectorBar":"\u2958","LeftUpVector":"\u21BF","LeftVectorBar":"\u2952","LeftVector":"\u21BC","lEg":"\u2A8B","leg":"\u22DA","leq":"\u2264","leqq":"\u2266","leqslant":"\u2A7D","lescc":"\u2AA8","les":"\u2A7D","lesdot":"\u2A7F","lesdoto":"\u2A81","lesdotor":"\u2A83","lesg":"\u22DA\uFE00","lesges":"\u2A93","lessapprox":"\u2A85","lessdot":"\u22D6","lesseqgtr":"\u22DA","lesseqqgtr":"\u2A8B","LessEqualGreater":"\u22DA","LessFullEqual":"\u2266","LessGreater":"\u2276","lessgtr":"\u2276","LessLess":"\u2AA1","lesssim":"\u2272","LessSlantEqual":"\u2A7D","LessTilde":"\u2272","lfisht":"\u297C","lfloor":"\u230A","Lfr":"\uD835\uDD0F","lfr":"\uD835\uDD29","lg":"\u2276","lgE":"\u2A91","lHar":"\u2962","lhard":"\u21BD","lharu":"\u21BC","lharul":"\u296A","lhblk":"\u2584","LJcy":"\u0409","ljcy":"\u0459","llarr":"\u21C7","ll":"\u226A","Ll":"\u22D8","llcorner":"\u231E","Lleftarrow":"\u21DA","llhard":"\u296B","lltri":"\u25FA","Lmidot":"\u013F","lmidot":"\u0140","lmoustache":"\u23B0","lmoust":"\u23B0","lnap":"\u2A89","lnapprox":"\u2A89","lne":"\u2A87","lnE":"\u2268","lneq":"\u2A87","lneqq":"\u2268","lnsim":"\u22E6","loang":"\u27EC","loarr":"\u21FD","lobrk":"\u27E6","longleftarrow":"\u27F5","LongLeftArrow":"\u27F5","Longleftarrow":"\u27F8","longleftrightarrow":"\u27F7","LongLeftRightArrow":"\u27F7","Longleftrightarrow":"\u27FA","longmapsto":"\u27FC","longrightarrow":"\u27F6","LongRightArrow":"\u27F6","Longrightarrow":"\u27F9","looparrowleft":"\u21AB","looparrowright":"\u21AC","lopar":"\u2985","Lopf":"\uD835\uDD43","lopf":"\uD835\uDD5D","loplus":"\u2A2D","lotimes":"\u2A34","lowast":"\u2217","lowbar":"_","LowerLeftArrow":"\u2199","LowerRightArrow":"\u2198","loz":"\u25CA","lozenge":"\u25CA","lozf":"\u29EB","lpar":"(","lparlt":"\u2993","lrarr":"\u21C6","lrcorner":"\u231F","lrhar":"\u21CB","lrhard":"\u296D","lrm":"\u200E","lrtri":"\u22BF","lsaquo":"\u2039","lscr":"\uD835\uDCC1","Lscr":"\u2112","lsh":"\u21B0","Lsh":"\u21B0","lsim":"\u2272","lsime":"\u2A8D","lsimg":"\u2A8F","lsqb":"[","lsquo":"\u2018","lsquor":"\u201A","Lstrok":"\u0141","lstrok":"\u0142","ltcc":"\u2AA6","ltcir":"\u2A79","lt":"<","LT":"<","Lt":"\u226A","ltdot":"\u22D6","lthree":"\u22CB","ltimes":"\u22C9","ltlarr":"\u2976","ltquest":"\u2A7B","ltri":"\u25C3","ltrie":"\u22B4","ltrif":"\u25C2","ltrPar":"\u2996","lurdshar":"\u294A","luruhar":"\u2966","lvertneqq":"\u2268\uFE00","lvnE":"\u2268\uFE00","macr":"\xaf","male":"\u2642","malt":"\u2720","maltese":"\u2720","Map":"\u2905","map":"\u21A6","mapsto":"\u21A6","mapstodown":"\u21A7","mapstoleft":"\u21A4","mapstoup":"\u21A5","marker":"\u25AE","mcomma":"\u2A29","Mcy":"\u041C","mcy":"\u043C","mdash":"\u2014","mDDot":"\u223A","measuredangle":"\u2221","MediumSpace":"\u205F","Mellintrf":"\u2133","Mfr":"\uD835\uDD10","mfr":"\uD835\uDD2A","mho":"\u2127","micro":"\xb5","midast":"*","midcir":"\u2AF0","mid":"\u2223","middot":"\xb7","minusb":"\u229F","minus":"\u2212","minusd":"\u2238","minusdu":"\u2A2A","MinusPlus":"\u2213","mlcp":"\u2ADB","mldr":"\u2026","mnplus":"\u2213","models":"\u22A7","Mopf":"\uD835\uDD44","mopf":"\uD835\uDD5E","mp":"\u2213","mscr":"\uD835\uDCC2","Mscr":"\u2133","mstpos":"\u223E","Mu":"\u039C","mu":"\u03BC","multimap":"\u22B8","mumap":"\u22B8","nabla":"\u2207","Nacute":"\u0143","nacute":"\u0144","nang":"\u2220\u20D2","nap":"\u2249","napE":"\u2A70\u0338","napid":"\u224B\u0338","napos":"\u0149","napprox":"\u2249","natural":"\u266E","naturals":"\u2115","natur":"\u266E","nbsp":"\xa0","nbump":"\u224E\u0338","nbumpe":"\u224F\u0338","ncap":"\u2A43","Ncaron":"\u0147","ncaron":"\u0148","Ncedil":"\u0145","ncedil":"\u0146","ncong":"\u2247","ncongdot":"\u2A6D\u0338","ncup":"\u2A42","Ncy":"\u041D","ncy":"\u043D","ndash":"\u2013","nearhk":"\u2924","nearr":"\u2197","neArr":"\u21D7","nearrow":"\u2197","ne":"\u2260","nedot":"\u2250\u0338","NegativeMediumSpace":"\u200B","NegativeThickSpace":"\u200B","NegativeThinSpace":"\u200B","NegativeVeryThinSpace":"\u200B","nequiv":"\u2262","nesear":"\u2928","nesim":"\u2242\u0338","NestedGreaterGreater":"\u226B","NestedLessLess":"\u226A","NewLine":"\\n","nexist":"\u2204","nexists":"\u2204","Nfr":"\uD835\uDD11","nfr":"\uD835\uDD2B","ngE":"\u2267\u0338","nge":"\u2271","ngeq":"\u2271","ngeqq":"\u2267\u0338","ngeqslant":"\u2A7E\u0338","nges":"\u2A7E\u0338","nGg":"\u22D9\u0338","ngsim":"\u2275","nGt":"\u226B\u20D2","ngt":"\u226F","ngtr":"\u226F","nGtv":"\u226B\u0338","nharr":"\u21AE","nhArr":"\u21CE","nhpar":"\u2AF2","ni":"\u220B","nis":"\u22FC","nisd":"\u22FA","niv":"\u220B","NJcy":"\u040A","njcy":"\u045A","nlarr":"\u219A","nlArr":"\u21CD","nldr":"\u2025","nlE":"\u2266\u0338","nle":"\u2270","nleftarrow":"\u219A","nLeftarrow":"\u21CD","nleftrightarrow":"\u21AE","nLeftrightarrow":"\u21CE","nleq":"\u2270","nleqq":"\u2266\u0338","nleqslant":"\u2A7D\u0338","nles":"\u2A7D\u0338","nless":"\u226E","nLl":"\u22D8\u0338","nlsim":"\u2274","nLt":"\u226A\u20D2","nlt":"\u226E","nltri":"\u22EA","nltrie":"\u22EC","nLtv":"\u226A\u0338","nmid":"\u2224","NoBreak":"\u2060","NonBreakingSpace":"\xa0","nopf":"\uD835\uDD5F","Nopf":"\u2115","Not":"\u2AEC","not":"\xac","NotCongruent":"\u2262","NotCupCap":"\u226D","NotDoubleVerticalBar":"\u2226","NotElement":"\u2209","NotEqual":"\u2260","NotEqualTilde":"\u2242\u0338","NotExists":"\u2204","NotGreater":"\u226F","NotGreaterEqual":"\u2271","NotGreaterFullEqual":"\u2267\u0338","NotGreaterGreater":"\u226B\u0338","NotGreaterLess":"\u2279","NotGreaterSlantEqual":"\u2A7E\u0338","NotGreaterTilde":"\u2275","NotHumpDownHump":"\u224E\u0338","NotHumpEqual":"\u224F\u0338","notin":"\u2209","notindot":"\u22F5\u0338","notinE":"\u22F9\u0338","notinva":"\u2209","notinvb":"\u22F7","notinvc":"\u22F6","NotLeftTriangleBar":"\u29CF\u0338","NotLeftTriangle":"\u22EA","NotLeftTriangleEqual":"\u22EC","NotLess":"\u226E","NotLessEqual":"\u2270","NotLessGreater":"\u2278","NotLessLess":"\u226A\u0338","NotLessSlantEqual":"\u2A7D\u0338","NotLessTilde":"\u2274","NotNestedGreaterGreater":"\u2AA2\u0338","NotNestedLessLess":"\u2AA1\u0338","notni":"\u220C","notniva":"\u220C","notnivb":"\u22FE","notnivc":"\u22FD","NotPrecedes":"\u2280","NotPrecedesEqual":"\u2AAF\u0338","NotPrecedesSlantEqual":"\u22E0","NotReverseElement":"\u220C","NotRightTriangleBar":"\u29D0\u0338","NotRightTriangle":"\u22EB","NotRightTriangleEqual":"\u22ED","NotSquareSubset":"\u228F\u0338","NotSquareSubsetEqual":"\u22E2","NotSquareSuperset":"\u2290\u0338","NotSquareSupersetEqual":"\u22E3","NotSubset":"\u2282\u20D2","NotSubsetEqual":"\u2288","NotSucceeds":"\u2281","NotSucceedsEqual":"\u2AB0\u0338","NotSucceedsSlantEqual":"\u22E1","NotSucceedsTilde":"\u227F\u0338","NotSuperset":"\u2283\u20D2","NotSupersetEqual":"\u2289","NotTilde":"\u2241","NotTildeEqual":"\u2244","NotTildeFullEqual":"\u2247","NotTildeTilde":"\u2249","NotVerticalBar":"\u2224","nparallel":"\u2226","npar":"\u2226","nparsl":"\u2AFD\u20E5","npart":"\u2202\u0338","npolint":"\u2A14","npr":"\u2280","nprcue":"\u22E0","nprec":"\u2280","npreceq":"\u2AAF\u0338","npre":"\u2AAF\u0338","nrarrc":"\u2933\u0338","nrarr":"\u219B","nrArr":"\u21CF","nrarrw":"\u219D\u0338","nrightarrow":"\u219B","nRightarrow":"\u21CF","nrtri":"\u22EB","nrtrie":"\u22ED","nsc":"\u2281","nsccue":"\u22E1","nsce":"\u2AB0\u0338","Nscr":"\uD835\uDCA9","nscr":"\uD835\uDCC3","nshortmid":"\u2224","nshortparallel":"\u2226","nsim":"\u2241","nsime":"\u2244","nsimeq":"\u2244","nsmid":"\u2224","nspar":"\u2226","nsqsube":"\u22E2","nsqsupe":"\u22E3","nsub":"\u2284","nsubE":"\u2AC5\u0338","nsube":"\u2288","nsubset":"\u2282\u20D2","nsubseteq":"\u2288","nsubseteqq":"\u2AC5\u0338","nsucc":"\u2281","nsucceq":"\u2AB0\u0338","nsup":"\u2285","nsupE":"\u2AC6\u0338","nsupe":"\u2289","nsupset":"\u2283\u20D2","nsupseteq":"\u2289","nsupseteqq":"\u2AC6\u0338","ntgl":"\u2279","Ntilde":"\xd1","ntilde":"\xf1","ntlg":"\u2278","ntriangleleft":"\u22EA","ntrianglelefteq":"\u22EC","ntriangleright":"\u22EB","ntrianglerighteq":"\u22ED","Nu":"\u039D","nu":"\u03BD","num":"#","numero":"\u2116","numsp":"\u2007","nvap":"\u224D\u20D2","nvdash":"\u22AC","nvDash":"\u22AD","nVdash":"\u22AE","nVDash":"\u22AF","nvge":"\u2265\u20D2","nvgt":">\u20D2","nvHarr":"\u2904","nvinfin":"\u29DE","nvlArr":"\u2902","nvle":"\u2264\u20D2","nvlt":"<\u20D2","nvltrie":"\u22B4\u20D2","nvrArr":"\u2903","nvrtrie":"\u22B5\u20D2","nvsim":"\u223C\u20D2","nwarhk":"\u2923","nwarr":"\u2196","nwArr":"\u21D6","nwarrow":"\u2196","nwnear":"\u2927","Oacute":"\xd3","oacute":"\xf3","oast":"\u229B","Ocirc":"\xd4","ocirc":"\xf4","ocir":"\u229A","Ocy":"\u041E","ocy":"\u043E","odash":"\u229D","Odblac":"\u0150","odblac":"\u0151","odiv":"\u2A38","odot":"\u2299","odsold":"\u29BC","OElig":"\u0152","oelig":"\u0153","ofcir":"\u29BF","Ofr":"\uD835\uDD12","ofr":"\uD835\uDD2C","ogon":"\u02DB","Ograve":"\xd2","ograve":"\xf2","ogt":"\u29C1","ohbar":"\u29B5","ohm":"\u03A9","oint":"\u222E","olarr":"\u21BA","olcir":"\u29BE","olcross":"\u29BB","oline":"\u203E","olt":"\u29C0","Omacr":"\u014C","omacr":"\u014D","Omega":"\u03A9","omega":"\u03C9","Omicron":"\u039F","omicron":"\u03BF","omid":"\u29B6","ominus":"\u2296","Oopf":"\uD835\uDD46","oopf":"\uD835\uDD60","opar":"\u29B7","OpenCurlyDoubleQuote":"\u201C","OpenCurlyQuote":"\u2018","operp":"\u29B9","oplus":"\u2295","orarr":"\u21BB","Or":"\u2A54","or":"\u2228","ord":"\u2A5D","order":"\u2134","orderof":"\u2134","ordf":"\xaa","ordm":"\xba","origof":"\u22B6","oror":"\u2A56","orslope":"\u2A57","orv":"\u2A5B","oS":"\u24C8","Oscr":"\uD835\uDCAA","oscr":"\u2134","Oslash":"\xd8","oslash":"\xf8","osol":"\u2298","Otilde":"\xd5","otilde":"\xf5","otimesas":"\u2A36","Otimes":"\u2A37","otimes":"\u2297","Ouml":"\xd6","ouml":"\xf6","ovbar":"\u233D","OverBar":"\u203E","OverBrace":"\u23DE","OverBracket":"\u23B4","OverParenthesis":"\u23DC","para":"\xb6","parallel":"\u2225","par":"\u2225","parsim":"\u2AF3","parsl":"\u2AFD","part":"\u2202","PartialD":"\u2202","Pcy":"\u041F","pcy":"\u043F","percnt":"%","period":".","permil":"\u2030","perp":"\u22A5","pertenk":"\u2031","Pfr":"\uD835\uDD13","pfr":"\uD835\uDD2D","Phi":"\u03A6","phi":"\u03C6","phiv":"\u03D5","phmmat":"\u2133","phone":"\u260E","Pi":"\u03A0","pi":"\u03C0","pitchfork":"\u22D4","piv":"\u03D6","planck":"\u210F","planckh":"\u210E","plankv":"\u210F","plusacir":"\u2A23","plusb":"\u229E","pluscir":"\u2A22","plus":"+","plusdo":"\u2214","plusdu":"\u2A25","pluse":"\u2A72","PlusMinus":"\xb1","plusmn":"\xb1","plussim":"\u2A26","plustwo":"\u2A27","pm":"\xb1","Poincareplane":"\u210C","pointint":"\u2A15","popf":"\uD835\uDD61","Popf":"\u2119","pound":"\xa3","prap":"\u2AB7","Pr":"\u2ABB","pr":"\u227A","prcue":"\u227C","precapprox":"\u2AB7","prec":"\u227A","preccurlyeq":"\u227C","Precedes":"\u227A","PrecedesEqual":"\u2AAF","PrecedesSlantEqual":"\u227C","PrecedesTilde":"\u227E","preceq":"\u2AAF","precnapprox":"\u2AB9","precneqq":"\u2AB5","precnsim":"\u22E8","pre":"\u2AAF","prE":"\u2AB3","precsim":"\u227E","prime":"\u2032","Prime":"\u2033","primes":"\u2119","prnap":"\u2AB9","prnE":"\u2AB5","prnsim":"\u22E8","prod":"\u220F","Product":"\u220F","profalar":"\u232E","profline":"\u2312","profsurf":"\u2313","prop":"\u221D","Proportional":"\u221D","Proportion":"\u2237","propto":"\u221D","prsim":"\u227E","prurel":"\u22B0","Pscr":"\uD835\uDCAB","pscr":"\uD835\uDCC5","Psi":"\u03A8","psi":"\u03C8","puncsp":"\u2008","Qfr":"\uD835\uDD14","qfr":"\uD835\uDD2E","qint":"\u2A0C","qopf":"\uD835\uDD62","Qopf":"\u211A","qprime":"\u2057","Qscr":"\uD835\uDCAC","qscr":"\uD835\uDCC6","quaternions":"\u210D","quatint":"\u2A16","quest":"?","questeq":"\u225F","quot":"\\"","QUOT":"\\"","rAarr":"\u21DB","race":"\u223D\u0331","Racute":"\u0154","racute":"\u0155","radic":"\u221A","raemptyv":"\u29B3","rang":"\u27E9","Rang":"\u27EB","rangd":"\u2992","range":"\u29A5","rangle":"\u27E9","raquo":"\xbb","rarrap":"\u2975","rarrb":"\u21E5","rarrbfs":"\u2920","rarrc":"\u2933","rarr":"\u2192","Rarr":"\u21A0","rArr":"\u21D2","rarrfs":"\u291E","rarrhk":"\u21AA","rarrlp":"\u21AC","rarrpl":"\u2945","rarrsim":"\u2974","Rarrtl":"\u2916","rarrtl":"\u21A3","rarrw":"\u219D","ratail":"\u291A","rAtail":"\u291C","ratio":"\u2236","rationals":"\u211A","rbarr":"\u290D","rBarr":"\u290F","RBarr":"\u2910","rbbrk":"\u2773","rbrace":"}","rbrack":"]","rbrke":"\u298C","rbrksld":"\u298E","rbrkslu":"\u2990","Rcaron":"\u0158","rcaron":"\u0159","Rcedil":"\u0156","rcedil":"\u0157","rceil":"\u2309","rcub":"}","Rcy":"\u0420","rcy":"\u0440","rdca":"\u2937","rdldhar":"\u2969","rdquo":"\u201D","rdquor":"\u201D","rdsh":"\u21B3","real":"\u211C","realine":"\u211B","realpart":"\u211C","reals":"\u211D","Re":"\u211C","rect":"\u25AD","reg":"\xae","REG":"\xae","ReverseElement":"\u220B","ReverseEquilibrium":"\u21CB","ReverseUpEquilibrium":"\u296F","rfisht":"\u297D","rfloor":"\u230B","rfr":"\uD835\uDD2F","Rfr":"\u211C","rHar":"\u2964","rhard":"\u21C1","rharu":"\u21C0","rharul":"\u296C","Rho":"\u03A1","rho":"\u03C1","rhov":"\u03F1","RightAngleBracket":"\u27E9","RightArrowBar":"\u21E5","rightarrow":"\u2192","RightArrow":"\u2192","Rightarrow":"\u21D2","RightArrowLeftArrow":"\u21C4","rightarrowtail":"\u21A3","RightCeiling":"\u2309","RightDoubleBracket":"\u27E7","RightDownTeeVector":"\u295D","RightDownVectorBar":"\u2955","RightDownVector":"\u21C2","RightFloor":"\u230B","rightharpoondown":"\u21C1","rightharpoonup":"\u21C0","rightleftarrows":"\u21C4","rightleftharpoons":"\u21CC","rightrightarrows":"\u21C9","rightsquigarrow":"\u219D","RightTeeArrow":"\u21A6","RightTee":"\u22A2","RightTeeVector":"\u295B","rightthreetimes":"\u22CC","RightTriangleBar":"\u29D0","RightTriangle":"\u22B3","RightTriangleEqual":"\u22B5","RightUpDownVector":"\u294F","RightUpTeeVector":"\u295C","RightUpVectorBar":"\u2954","RightUpVector":"\u21BE","RightVectorBar":"\u2953","RightVector":"\u21C0","ring":"\u02DA","risingdotseq":"\u2253","rlarr":"\u21C4","rlhar":"\u21CC","rlm":"\u200F","rmoustache":"\u23B1","rmoust":"\u23B1","rnmid":"\u2AEE","roang":"\u27ED","roarr":"\u21FE","robrk":"\u27E7","ropar":"\u2986","ropf":"\uD835\uDD63","Ropf":"\u211D","roplus":"\u2A2E","rotimes":"\u2A35","RoundImplies":"\u2970","rpar":")","rpargt":"\u2994","rppolint":"\u2A12","rrarr":"\u21C9","Rrightarrow":"\u21DB","rsaquo":"\u203A","rscr":"\uD835\uDCC7","Rscr":"\u211B","rsh":"\u21B1","Rsh":"\u21B1","rsqb":"]","rsquo":"\u2019","rsquor":"\u2019","rthree":"\u22CC","rtimes":"\u22CA","rtri":"\u25B9","rtrie":"\u22B5","rtrif":"\u25B8","rtriltri":"\u29CE","RuleDelayed":"\u29F4","ruluhar":"\u2968","rx":"\u211E","Sacute":"\u015A","sacute":"\u015B","sbquo":"\u201A","scap":"\u2AB8","Scaron":"\u0160","scaron":"\u0161","Sc":"\u2ABC","sc":"\u227B","sccue":"\u227D","sce":"\u2AB0","scE":"\u2AB4","Scedil":"\u015E","scedil":"\u015F","Scirc":"\u015C","scirc":"\u015D","scnap":"\u2ABA","scnE":"\u2AB6","scnsim":"\u22E9","scpolint":"\u2A13","scsim":"\u227F","Scy":"\u0421","scy":"\u0441","sdotb":"\u22A1","sdot":"\u22C5","sdote":"\u2A66","searhk":"\u2925","searr":"\u2198","seArr":"\u21D8","searrow":"\u2198","sect":"\xa7","semi":";","seswar":"\u2929","setminus":"\u2216","setmn":"\u2216","sext":"\u2736","Sfr":"\uD835\uDD16","sfr":"\uD835\uDD30","sfrown":"\u2322","sharp":"\u266F","SHCHcy":"\u0429","shchcy":"\u0449","SHcy":"\u0428","shcy":"\u0448","ShortDownArrow":"\u2193","ShortLeftArrow":"\u2190","shortmid":"\u2223","shortparallel":"\u2225","ShortRightArrow":"\u2192","ShortUpArrow":"\u2191","shy":"\xad","Sigma":"\u03A3","sigma":"\u03C3","sigmaf":"\u03C2","sigmav":"\u03C2","sim":"\u223C","simdot":"\u2A6A","sime":"\u2243","simeq":"\u2243","simg":"\u2A9E","simgE":"\u2AA0","siml":"\u2A9D","simlE":"\u2A9F","simne":"\u2246","simplus":"\u2A24","simrarr":"\u2972","slarr":"\u2190","SmallCircle":"\u2218","smallsetminus":"\u2216","smashp":"\u2A33","smeparsl":"\u29E4","smid":"\u2223","smile":"\u2323","smt":"\u2AAA","smte":"\u2AAC","smtes":"\u2AAC\uFE00","SOFTcy":"\u042C","softcy":"\u044C","solbar":"\u233F","solb":"\u29C4","sol":"\\/","Sopf":"\uD835\uDD4A","sopf":"\uD835\uDD64","spades":"\u2660","spadesuit":"\u2660","spar":"\u2225","sqcap":"\u2293","sqcaps":"\u2293\uFE00","sqcup":"\u2294","sqcups":"\u2294\uFE00","Sqrt":"\u221A","sqsub":"\u228F","sqsube":"\u2291","sqsubset":"\u228F","sqsubseteq":"\u2291","sqsup":"\u2290","sqsupe":"\u2292","sqsupset":"\u2290","sqsupseteq":"\u2292","square":"\u25A1","Square":"\u25A1","SquareIntersection":"\u2293","SquareSubset":"\u228F","SquareSubsetEqual":"\u2291","SquareSuperset":"\u2290","SquareSupersetEqual":"\u2292","SquareUnion":"\u2294","squarf":"\u25AA","squ":"\u25A1","squf":"\u25AA","srarr":"\u2192","Sscr":"\uD835\uDCAE","sscr":"\uD835\uDCC8","ssetmn":"\u2216","ssmile":"\u2323","sstarf":"\u22C6","Star":"\u22C6","star":"\u2606","starf":"\u2605","straightepsilon":"\u03F5","straightphi":"\u03D5","strns":"\xaf","sub":"\u2282","Sub":"\u22D0","subdot":"\u2ABD","subE":"\u2AC5","sube":"\u2286","subedot":"\u2AC3","submult":"\u2AC1","subnE":"\u2ACB","subne":"\u228A","subplus":"\u2ABF","subrarr":"\u2979","subset":"\u2282","Subset":"\u22D0","subseteq":"\u2286","subseteqq":"\u2AC5","SubsetEqual":"\u2286","subsetneq":"\u228A","subsetneqq":"\u2ACB","subsim":"\u2AC7","subsub":"\u2AD5","subsup":"\u2AD3","succapprox":"\u2AB8","succ":"\u227B","succcurlyeq":"\u227D","Succeeds":"\u227B","SucceedsEqual":"\u2AB0","SucceedsSlantEqual":"\u227D","SucceedsTilde":"\u227F","succeq":"\u2AB0","succnapprox":"\u2ABA","succneqq":"\u2AB6","succnsim":"\u22E9","succsim":"\u227F","SuchThat":"\u220B","sum":"\u2211","Sum":"\u2211","sung":"\u266A","sup1":"\xb9","sup2":"\xb2","sup3":"\xb3","sup":"\u2283","Sup":"\u22D1","supdot":"\u2ABE","supdsub":"\u2AD8","supE":"\u2AC6","supe":"\u2287","supedot":"\u2AC4","Superset":"\u2283","SupersetEqual":"\u2287","suphsol":"\u27C9","suphsub":"\u2AD7","suplarr":"\u297B","supmult":"\u2AC2","supnE":"\u2ACC","supne":"\u228B","supplus":"\u2AC0","supset":"\u2283","Supset":"\u22D1","supseteq":"\u2287","supseteqq":"\u2AC6","supsetneq":"\u228B","supsetneqq":"\u2ACC","supsim":"\u2AC8","supsub":"\u2AD4","supsup":"\u2AD6","swarhk":"\u2926","swarr":"\u2199","swArr":"\u21D9","swarrow":"\u2199","swnwar":"\u292A","szlig":"\xdf","Tab":"\\t","target":"\u2316","Tau":"\u03A4","tau":"\u03C4","tbrk":"\u23B4","Tcaron":"\u0164","tcaron":"\u0165","Tcedil":"\u0162","tcedil":"\u0163","Tcy":"\u0422","tcy":"\u0442","tdot":"\u20DB","telrec":"\u2315","Tfr":"\uD835\uDD17","tfr":"\uD835\uDD31","there4":"\u2234","therefore":"\u2234","Therefore":"\u2234","Theta":"\u0398","theta":"\u03B8","thetasym":"\u03D1","thetav":"\u03D1","thickapprox":"\u2248","thicksim":"\u223C","ThickSpace":"\u205F\u200A","ThinSpace":"\u2009","thinsp":"\u2009","thkap":"\u2248","thksim":"\u223C","THORN":"\xde","thorn":"\xfe","tilde":"\u02DC","Tilde":"\u223C","TildeEqual":"\u2243","TildeFullEqual":"\u2245","TildeTilde":"\u2248","timesbar":"\u2A31","timesb":"\u22A0","times":"\xd7","timesd":"\u2A30","tint":"\u222D","toea":"\u2928","topbot":"\u2336","topcir":"\u2AF1","top":"\u22A4","Topf":"\uD835\uDD4B","topf":"\uD835\uDD65","topfork":"\u2ADA","tosa":"\u2929","tprime":"\u2034","trade":"\u2122","TRADE":"\u2122","triangle":"\u25B5","triangledown":"\u25BF","triangleleft":"\u25C3","trianglelefteq":"\u22B4","triangleq":"\u225C","triangleright":"\u25B9","trianglerighteq":"\u22B5","tridot":"\u25EC","trie":"\u225C","triminus":"\u2A3A","TripleDot":"\u20DB","triplus":"\u2A39","trisb":"\u29CD","tritime":"\u2A3B","trpezium":"\u23E2","Tscr":"\uD835\uDCAF","tscr":"\uD835\uDCC9","TScy":"\u0426","tscy":"\u0446","TSHcy":"\u040B","tshcy":"\u045B","Tstrok":"\u0166","tstrok":"\u0167","twixt":"\u226C","twoheadleftarrow":"\u219E","twoheadrightarrow":"\u21A0","Uacute":"\xda","uacute":"\xfa","uarr":"\u2191","Uarr":"\u219F","uArr":"\u21D1","Uarrocir":"\u2949","Ubrcy":"\u040E","ubrcy":"\u045E","Ubreve":"\u016C","ubreve":"\u016D","Ucirc":"\xdb","ucirc":"\xfb","Ucy":"\u0423","ucy":"\u0443","udarr":"\u21C5","Udblac":"\u0170","udblac":"\u0171","udhar":"\u296E","ufisht":"\u297E","Ufr":"\uD835\uDD18","ufr":"\uD835\uDD32","Ugrave":"\xd9","ugrave":"\xf9","uHar":"\u2963","uharl":"\u21BF","uharr":"\u21BE","uhblk":"\u2580","ulcorn":"\u231C","ulcorner":"\u231C","ulcrop":"\u230F","ultri":"\u25F8","Umacr":"\u016A","umacr":"\u016B","uml":"\xa8","UnderBar":"_","UnderBrace":"\u23DF","UnderBracket":"\u23B5","UnderParenthesis":"\u23DD","Union":"\u22C3","UnionPlus":"\u228E","Uogon":"\u0172","uogon":"\u0173","Uopf":"\uD835\uDD4C","uopf":"\uD835\uDD66","UpArrowBar":"\u2912","uparrow":"\u2191","UpArrow":"\u2191","Uparrow":"\u21D1","UpArrowDownArrow":"\u21C5","updownarrow":"\u2195","UpDownArrow":"\u2195","Updownarrow":"\u21D5","UpEquilibrium":"\u296E","upharpoonleft":"\u21BF","upharpoonright":"\u21BE","uplus":"\u228E","UpperLeftArrow":"\u2196","UpperRightArrow":"\u2197","upsi":"\u03C5","Upsi":"\u03D2","upsih":"\u03D2","Upsilon":"\u03A5","upsilon":"\u03C5","UpTeeArrow":"\u21A5","UpTee":"\u22A5","upuparrows":"\u21C8","urcorn":"\u231D","urcorner":"\u231D","urcrop":"\u230E","Uring":"\u016E","uring":"\u016F","urtri":"\u25F9","Uscr":"\uD835\uDCB0","uscr":"\uD835\uDCCA","utdot":"\u22F0","Utilde":"\u0168","utilde":"\u0169","utri":"\u25B5","utrif":"\u25B4","uuarr":"\u21C8","Uuml":"\xdc","uuml":"\xfc","uwangle":"\u29A7","vangrt":"\u299C","varepsilon":"\u03F5","varkappa":"\u03F0","varnothing":"\u2205","varphi":"\u03D5","varpi":"\u03D6","varpropto":"\u221D","varr":"\u2195","vArr":"\u21D5","varrho":"\u03F1","varsigma":"\u03C2","varsubsetneq":"\u228A\uFE00","varsubsetneqq":"\u2ACB\uFE00","varsupsetneq":"\u228B\uFE00","varsupsetneqq":"\u2ACC\uFE00","vartheta":"\u03D1","vartriangleleft":"\u22B2","vartriangleright":"\u22B3","vBar":"\u2AE8","Vbar":"\u2AEB","vBarv":"\u2AE9","Vcy":"\u0412","vcy":"\u0432","vdash":"\u22A2","vDash":"\u22A8","Vdash":"\u22A9","VDash":"\u22AB","Vdashl":"\u2AE6","veebar":"\u22BB","vee":"\u2228","Vee":"\u22C1","veeeq":"\u225A","vellip":"\u22EE","verbar":"|","Verbar":"\u2016","vert":"|","Vert":"\u2016","VerticalBar":"\u2223","VerticalLine":"|","VerticalSeparator":"\u2758","VerticalTilde":"\u2240","VeryThinSpace":"\u200A","Vfr":"\uD835\uDD19","vfr":"\uD835\uDD33","vltri":"\u22B2","vnsub":"\u2282\u20D2","vnsup":"\u2283\u20D2","Vopf":"\uD835\uDD4D","vopf":"\uD835\uDD67","vprop":"\u221D","vrtri":"\u22B3","Vscr":"\uD835\uDCB1","vscr":"\uD835\uDCCB","vsubnE":"\u2ACB\uFE00","vsubne":"\u228A\uFE00","vsupnE":"\u2ACC\uFE00","vsupne":"\u228B\uFE00","Vvdash":"\u22AA","vzigzag":"\u299A","Wcirc":"\u0174","wcirc":"\u0175","wedbar":"\u2A5F","wedge":"\u2227","Wedge":"\u22C0","wedgeq":"\u2259","weierp":"\u2118","Wfr":"\uD835\uDD1A","wfr":"\uD835\uDD34","Wopf":"\uD835\uDD4E","wopf":"\uD835\uDD68","wp":"\u2118","wr":"\u2240","wreath":"\u2240","Wscr":"\uD835\uDCB2","wscr":"\uD835\uDCCC","xcap":"\u22C2","xcirc":"\u25EF","xcup":"\u22C3","xdtri":"\u25BD","Xfr":"\uD835\uDD1B","xfr":"\uD835\uDD35","xharr":"\u27F7","xhArr":"\u27FA","Xi":"\u039E","xi":"\u03BE","xlarr":"\u27F5","xlArr":"\u27F8","xmap":"\u27FC","xnis":"\u22FB","xodot":"\u2A00","Xopf":"\uD835\uDD4F","xopf":"\uD835\uDD69","xoplus":"\u2A01","xotime":"\u2A02","xrarr":"\u27F6","xrArr":"\u27F9","Xscr":"\uD835\uDCB3","xscr":"\uD835\uDCCD","xsqcup":"\u2A06","xuplus":"\u2A04","xutri":"\u25B3","xvee":"\u22C1","xwedge":"\u22C0","Yacute":"\xdd","yacute":"\xfd","YAcy":"\u042F","yacy":"\u044F","Ycirc":"\u0176","ycirc":"\u0177","Ycy":"\u042B","ycy":"\u044B","yen":"\xa5","Yfr":"\uD835\uDD1C","yfr":"\uD835\uDD36","YIcy":"\u0407","yicy":"\u0457","Yopf":"\uD835\uDD50","yopf":"\uD835\uDD6A","Yscr":"\uD835\uDCB4","yscr":"\uD835\uDCCE","YUcy":"\u042E","yucy":"\u044E","yuml":"\xff","Yuml":"\u0178","Zacute":"\u0179","zacute":"\u017A","Zcaron":"\u017D","zcaron":"\u017E","Zcy":"\u0417","zcy":"\u0437","Zdot":"\u017B","zdot":"\u017C","zeetrf":"\u2128","ZeroWidthSpace":"\u200B","Zeta":"\u0396","zeta":"\u03B6","zfr":"\uD835\uDD37","Zfr":"\u2128","ZHcy":"\u0416","zhcy":"\u0436","zigrarr":"\u21DD","zopf":"\uD835\uDD6B","Zopf":"\u2124","Zscr":"\uD835\uDCB5","zscr":"\uD835\uDCCF","zwj":"\u200D","zwnj":"\u200C"}');

});


parcelRegister("90JXC", function(module, exports) {

$parcel$export(module.exports, "encode", () => $68f7c3f7224c7eb2$export$c564cdbbe6da493, (v) => $68f7c3f7224c7eb2$export$c564cdbbe6da493 = v);
$parcel$export(module.exports, "decode", () => $68f7c3f7224c7eb2$export$2f872c0f2117be69, (v) => $68f7c3f7224c7eb2$export$2f872c0f2117be69 = v);
$parcel$export(module.exports, "format", () => $68f7c3f7224c7eb2$export$d9468344d3651243, (v) => $68f7c3f7224c7eb2$export$d9468344d3651243 = v);
$parcel$export(module.exports, "parse", () => $68f7c3f7224c7eb2$export$98e6a39c04603d36, (v) => $68f7c3f7224c7eb2$export$98e6a39c04603d36 = v);
var $68f7c3f7224c7eb2$export$c564cdbbe6da493;
var $68f7c3f7224c7eb2$export$2f872c0f2117be69;
var $68f7c3f7224c7eb2$export$d9468344d3651243;
var $68f7c3f7224c7eb2$export$98e6a39c04603d36;
'use strict';

$68f7c3f7224c7eb2$export$c564cdbbe6da493 = (parcelRequire("5NeVE"));

$68f7c3f7224c7eb2$export$2f872c0f2117be69 = (parcelRequire("SIvnT"));

$68f7c3f7224c7eb2$export$d9468344d3651243 = (parcelRequire("5llWn"));

$68f7c3f7224c7eb2$export$98e6a39c04603d36 = (parcelRequire("lEeS3"));

});
parcelRegister("5NeVE", function(module, exports) {
'use strict';
var $437d1be9ae335f6e$var$encodeCache = {};
// Create a lookup array where anything but characters in `chars` string
// and alphanumeric chars is percent-encoded.
//
function $437d1be9ae335f6e$var$getEncodeCache(exclude) {
    var i, ch, cache = $437d1be9ae335f6e$var$encodeCache[exclude];
    if (cache) return cache;
    cache = $437d1be9ae335f6e$var$encodeCache[exclude] = [];
    for(i = 0; i < 128; i++){
        ch = String.fromCharCode(i);
        if (/^[0-9a-z]$/i.test(ch)) // always allow unencoded alphanumeric characters
        cache.push(ch);
        else cache.push('%' + ('0' + i.toString(16).toUpperCase()).slice(-2));
    }
    for(i = 0; i < exclude.length; i++)cache[exclude.charCodeAt(i)] = exclude[i];
    return cache;
}
// Encode unsafe characters with percent-encoding, skipping already
// encoded sequences.
//
//  - string       - string to encode
//  - exclude      - list of characters to ignore (in addition to a-zA-Z0-9)
//  - keepEscaped  - don't encode '%' in a correct escape sequence (default: true)
//
function $437d1be9ae335f6e$var$encode(string, exclude, keepEscaped) {
    var i, l, code, nextCode, cache, result = '';
    if (typeof exclude !== 'string') {
        // encode(string, keepEscaped)
        keepEscaped = exclude;
        exclude = $437d1be9ae335f6e$var$encode.defaultChars;
    }
    if (typeof keepEscaped === 'undefined') keepEscaped = true;
    cache = $437d1be9ae335f6e$var$getEncodeCache(exclude);
    for(i = 0, l = string.length; i < l; i++){
        code = string.charCodeAt(i);
        if (keepEscaped && code === 0x25 /* % */  && i + 2 < l) {
            if (/^[0-9a-f]{2}$/i.test(string.slice(i + 1, i + 3))) {
                result += string.slice(i, i + 3);
                i += 2;
                continue;
            }
        }
        if (code < 128) {
            result += cache[code];
            continue;
        }
        if (code >= 0xD800 && code <= 0xDFFF) {
            if (code >= 0xD800 && code <= 0xDBFF && i + 1 < l) {
                nextCode = string.charCodeAt(i + 1);
                if (nextCode >= 0xDC00 && nextCode <= 0xDFFF) {
                    result += encodeURIComponent(string[i] + string[i + 1]);
                    i++;
                    continue;
                }
            }
            result += '%EF%BF%BD';
            continue;
        }
        result += encodeURIComponent(string[i]);
    }
    return result;
}
$437d1be9ae335f6e$var$encode.defaultChars = ";/?:@&=+$,-_.!~*'()#";
$437d1be9ae335f6e$var$encode.componentChars = "-_.!~*'()";
module.exports = $437d1be9ae335f6e$var$encode;

});

parcelRegister("SIvnT", function(module, exports) {
'use strict';
/* eslint-disable no-bitwise */ var $0a479110ee2ce764$var$decodeCache = {};
function $0a479110ee2ce764$var$getDecodeCache(exclude) {
    var i, ch, cache = $0a479110ee2ce764$var$decodeCache[exclude];
    if (cache) return cache;
    cache = $0a479110ee2ce764$var$decodeCache[exclude] = [];
    for(i = 0; i < 128; i++){
        ch = String.fromCharCode(i);
        cache.push(ch);
    }
    for(i = 0; i < exclude.length; i++){
        ch = exclude.charCodeAt(i);
        cache[ch] = '%' + ('0' + ch.toString(16).toUpperCase()).slice(-2);
    }
    return cache;
}
// Decode percent-encoded string.
//
function $0a479110ee2ce764$var$decode(string, exclude) {
    var cache;
    if (typeof exclude !== 'string') exclude = $0a479110ee2ce764$var$decode.defaultChars;
    cache = $0a479110ee2ce764$var$getDecodeCache(exclude);
    return string.replace(/(%[a-f0-9]{2})+/gi, function(seq) {
        var i, l, b1, b2, b3, b4, chr, result = '';
        for(i = 0, l = seq.length; i < l; i += 3){
            b1 = parseInt(seq.slice(i + 1, i + 3), 16);
            if (b1 < 0x80) {
                result += cache[b1];
                continue;
            }
            if ((b1 & 0xE0) === 0xC0 && i + 3 < l) {
                // 110xxxxx 10xxxxxx
                b2 = parseInt(seq.slice(i + 4, i + 6), 16);
                if ((b2 & 0xC0) === 0x80) {
                    chr = b1 << 6 & 0x7C0 | b2 & 0x3F;
                    if (chr < 0x80) result += '\ufffd\ufffd';
                    else result += String.fromCharCode(chr);
                    i += 3;
                    continue;
                }
            }
            if ((b1 & 0xF0) === 0xE0 && i + 6 < l) {
                // 1110xxxx 10xxxxxx 10xxxxxx
                b2 = parseInt(seq.slice(i + 4, i + 6), 16);
                b3 = parseInt(seq.slice(i + 7, i + 9), 16);
                if ((b2 & 0xC0) === 0x80 && (b3 & 0xC0) === 0x80) {
                    chr = b1 << 12 & 0xF000 | b2 << 6 & 0xFC0 | b3 & 0x3F;
                    if (chr < 0x800 || chr >= 0xD800 && chr <= 0xDFFF) result += '\ufffd\ufffd\ufffd';
                    else result += String.fromCharCode(chr);
                    i += 6;
                    continue;
                }
            }
            if ((b1 & 0xF8) === 0xF0 && i + 9 < l) {
                // 111110xx 10xxxxxx 10xxxxxx 10xxxxxx
                b2 = parseInt(seq.slice(i + 4, i + 6), 16);
                b3 = parseInt(seq.slice(i + 7, i + 9), 16);
                b4 = parseInt(seq.slice(i + 10, i + 12), 16);
                if ((b2 & 0xC0) === 0x80 && (b3 & 0xC0) === 0x80 && (b4 & 0xC0) === 0x80) {
                    chr = b1 << 18 & 0x1C0000 | b2 << 12 & 0x3F000 | b3 << 6 & 0xFC0 | b4 & 0x3F;
                    if (chr < 0x10000 || chr > 0x10FFFF) result += '\ufffd\ufffd\ufffd\ufffd';
                    else {
                        chr -= 0x10000;
                        result += String.fromCharCode(0xD800 + (chr >> 10), 0xDC00 + (chr & 0x3FF));
                    }
                    i += 9;
                    continue;
                }
            }
            result += '\ufffd';
        }
        return result;
    });
}
$0a479110ee2ce764$var$decode.defaultChars = ';/?:@&=+$,#';
$0a479110ee2ce764$var$decode.componentChars = '';
module.exports = $0a479110ee2ce764$var$decode;

});

parcelRegister("5llWn", function(module, exports) {
'use strict';
module.exports = function format(url) {
    var result = '';
    result += url.protocol || '';
    result += url.slashes ? '//' : '';
    result += url.auth ? url.auth + '@' : '';
    if (url.hostname && url.hostname.indexOf(':') !== -1) // ipv6 address
    result += '[' + url.hostname + ']';
    else result += url.hostname || '';
    result += url.port ? ':' + url.port : '';
    result += url.pathname || '';
    result += url.search || '';
    result += url.hash || '';
    return result;
};

});

parcelRegister("lEeS3", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
//
// Changes from joyent/node:
//
// 1. No leading slash in paths,
//    e.g. in `url.parse('http://foo?bar')` pathname is ``, not `/`
//
// 2. Backslashes are not replaced with slashes,
//    so `http:\\example.org\` is treated like a relative path
//
// 3. Trailing colon is treated like a part of the path,
//    i.e. in `http://example.org:foo` pathname is `:foo`
//
// 4. Nothing is URL-encoded in the resulting object,
//    (in joyent/node some chars in auth and paths are encoded)
//
// 5. `url.parse()` does not have `parseQueryString` argument
//
// 6. Removed extraneous result properties: `host`, `path`, `query`, etc.,
//    which can be constructed using other parts of the url.
//
function $fc28de6a6437981a$var$Url() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.pathname = null;
}
// Reference: RFC 3986, RFC 1808, RFC 2396
// define these here so at least they only have to be
// compiled once on the first module load.
var $fc28de6a6437981a$var$protocolPattern = /^([a-z0-9.+-]+:)/i, $fc28de6a6437981a$var$portPattern = /:[0-9]*$/, // Special case for a simple path URL
$fc28de6a6437981a$var$simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/, // RFC 2396: characters reserved for delimiting URLs.
// We actually just auto-escape these.
$fc28de6a6437981a$var$delims = [
    '<',
    '>',
    '"',
    '`',
    ' ',
    '\r',
    '\n',
    '\t'
], // RFC 2396: characters not allowed for various reasons.
$fc28de6a6437981a$var$unwise = [
    '{',
    '}',
    '|',
    '\\',
    '^',
    '`'
].concat($fc28de6a6437981a$var$delims), // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
$fc28de6a6437981a$var$autoEscape = [
    '\''
].concat($fc28de6a6437981a$var$unwise), // Characters that are never ever allowed in a hostname.
// Note that any invalid chars are also handled, but these
// are the ones that are *expected* to be seen, so we fast-path
// them.
$fc28de6a6437981a$var$nonHostChars = [
    '%',
    '/',
    '?',
    ';',
    '#'
].concat($fc28de6a6437981a$var$autoEscape), $fc28de6a6437981a$var$hostEndingChars = [
    '/',
    '?',
    '#'
], $fc28de6a6437981a$var$hostnameMaxLen = 255, $fc28de6a6437981a$var$hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/, $fc28de6a6437981a$var$hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, // protocols that can allow "unsafe" and "unwise" chars.
/* eslint-disable no-script-url */ // protocols that never have a hostname.
$fc28de6a6437981a$var$hostlessProtocol = {
    'javascript': true,
    'javascript:': true
}, // protocols that always contain a // bit.
$fc28de6a6437981a$var$slashedProtocol = {
    'http': true,
    'https': true,
    'ftp': true,
    'gopher': true,
    'file': true,
    'http:': true,
    'https:': true,
    'ftp:': true,
    'gopher:': true,
    'file:': true
};
/* eslint-enable no-script-url */ function $fc28de6a6437981a$var$urlParse(url, slashesDenoteHost) {
    if (url && url instanceof $fc28de6a6437981a$var$Url) return url;
    var u = new $fc28de6a6437981a$var$Url();
    u.parse(url, slashesDenoteHost);
    return u;
}
$fc28de6a6437981a$var$Url.prototype.parse = function(url, slashesDenoteHost) {
    var i, l, lowerProto, hec, slashes, rest = url;
    // trim before proceeding.
    // This is to support parse stuff like "  http://foo.com  \n"
    rest = rest.trim();
    if (!slashesDenoteHost && url.split('#').length === 1) {
        // Try fast path regexp
        var simplePath = $fc28de6a6437981a$var$simplePathPattern.exec(rest);
        if (simplePath) {
            this.pathname = simplePath[1];
            if (simplePath[2]) this.search = simplePath[2];
            return this;
        }
    }
    var proto = $fc28de6a6437981a$var$protocolPattern.exec(rest);
    if (proto) {
        proto = proto[0];
        lowerProto = proto.toLowerCase();
        this.protocol = proto;
        rest = rest.substr(proto.length);
    }
    // figure out if it's got a host
    // user@server is *always* interpreted as a hostname, and url
    // resolution will treat //foo/bar as host=foo,path=bar because that's
    // how the browser resolves relative URLs.
    if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
        slashes = rest.substr(0, 2) === '//';
        if (slashes && !(proto && $fc28de6a6437981a$var$hostlessProtocol[proto])) {
            rest = rest.substr(2);
            this.slashes = true;
        }
    }
    if (!$fc28de6a6437981a$var$hostlessProtocol[proto] && (slashes || proto && !$fc28de6a6437981a$var$slashedProtocol[proto])) {
        // there's a hostname.
        // the first instance of /, ?, ;, or # ends the host.
        //
        // If there is an @ in the hostname, then non-host chars *are* allowed
        // to the left of the last @ sign, unless some host-ending character
        // comes *before* the @-sign.
        // URLs are obnoxious.
        //
        // ex:
        // http://a@b@c/ => user:a@b host:c
        // http://a@b?@c => user:a host:c path:/?@c
        // v0.12 TODO(isaacs): This is not quite how Chrome does things.
        // Review our test case against browsers more comprehensively.
        // find the first instance of any hostEndingChars
        var hostEnd = -1;
        for(i = 0; i < $fc28de6a6437981a$var$hostEndingChars.length; i++){
            hec = rest.indexOf($fc28de6a6437981a$var$hostEndingChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // at this point, either we have an explicit point where the
        // auth portion cannot go past, or the last @ char is the decider.
        var auth, atSign;
        if (hostEnd === -1) // atSign can be anywhere.
        atSign = rest.lastIndexOf('@');
        else // atSign must be in auth portion.
        // http://a@b/c@d => host:b auth:a path:/c@d
        atSign = rest.lastIndexOf('@', hostEnd);
        // Now we have a portion which is definitely the auth.
        // Pull that off.
        if (atSign !== -1) {
            auth = rest.slice(0, atSign);
            rest = rest.slice(atSign + 1);
            this.auth = auth;
        }
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for(i = 0; i < $fc28de6a6437981a$var$nonHostChars.length; i++){
            hec = rest.indexOf($fc28de6a6437981a$var$nonHostChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1) hostEnd = rest.length;
        if (rest[hostEnd - 1] === ':') hostEnd--;
        var host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        // pull out port.
        this.parseHost(host);
        // we've indicated that there is a hostname,
        // so even if it's empty, it has to be present.
        this.hostname = this.hostname || '';
        // if hostname begins with [ and ends with ]
        // assume that it's an IPv6 address.
        var ipv6Hostname = this.hostname[0] === '[' && this.hostname[this.hostname.length - 1] === ']';
        // validate a little.
        if (!ipv6Hostname) {
            var hostparts = this.hostname.split(/\./);
            for(i = 0, l = hostparts.length; i < l; i++){
                var part = hostparts[i];
                if (!part) continue;
                if (!part.match($fc28de6a6437981a$var$hostnamePartPattern)) {
                    var newpart = '';
                    for(var j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) // we replace non-ASCII char with a temporary placeholder
                    // we need this to make sure size of hostname is not
                    // broken by replacing non-ASCII by nothing
                    newpart += 'x';
                    else newpart += part[j];
                    // we test again with ASCII char only
                    if (!newpart.match($fc28de6a6437981a$var$hostnamePartPattern)) {
                        var validParts = hostparts.slice(0, i);
                        var notHost = hostparts.slice(i + 1);
                        var bit = part.match($fc28de6a6437981a$var$hostnamePartStart);
                        if (bit) {
                            validParts.push(bit[1]);
                            notHost.unshift(bit[2]);
                        }
                        if (notHost.length) rest = notHost.join('.') + rest;
                        this.hostname = validParts.join('.');
                        break;
                    }
                }
            }
        }
        if (this.hostname.length > $fc28de6a6437981a$var$hostnameMaxLen) this.hostname = '';
        // strip [ and ] from the hostname
        // the host field still retains them, though
        if (ipv6Hostname) this.hostname = this.hostname.substr(1, this.hostname.length - 2);
    }
    // chop off from the tail first.
    var hash = rest.indexOf('#');
    if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
    }
    var qm = rest.indexOf('?');
    if (qm !== -1) {
        this.search = rest.substr(qm);
        rest = rest.slice(0, qm);
    }
    if (rest) this.pathname = rest;
    if ($fc28de6a6437981a$var$slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = '';
    return this;
};
$fc28de6a6437981a$var$Url.prototype.parseHost = function(host) {
    var port = $fc28de6a6437981a$var$portPattern.exec(host);
    if (port) {
        port = port[0];
        if (port !== ':') this.port = port.substr(1);
        host = host.substr(0, host.length - port.length);
    }
    if (host) this.hostname = host;
};
module.exports = $fc28de6a6437981a$var$urlParse;

});


parcelRegister("1I1Rw", function(module, exports) {

$parcel$export(module.exports, "Any", () => $13eb5855fdfbbee7$export$b24b633b1364b94b, (v) => $13eb5855fdfbbee7$export$b24b633b1364b94b = v);
$parcel$export(module.exports, "Cc", () => $13eb5855fdfbbee7$export$15dafbac7aec8a57, (v) => $13eb5855fdfbbee7$export$15dafbac7aec8a57 = v);
$parcel$export(module.exports, "Cf", () => $13eb5855fdfbbee7$export$239cff0cce87eb56, (v) => $13eb5855fdfbbee7$export$239cff0cce87eb56 = v);
$parcel$export(module.exports, "P", () => $13eb5855fdfbbee7$export$56c0d5a1e737357d, (v) => $13eb5855fdfbbee7$export$56c0d5a1e737357d = v);
$parcel$export(module.exports, "Z", () => $13eb5855fdfbbee7$export$dc98b0b04f4c7758, (v) => $13eb5855fdfbbee7$export$dc98b0b04f4c7758 = v);
var $13eb5855fdfbbee7$export$b24b633b1364b94b;
var $13eb5855fdfbbee7$export$15dafbac7aec8a57;
var $13eb5855fdfbbee7$export$239cff0cce87eb56;
var $13eb5855fdfbbee7$export$56c0d5a1e737357d;
var $13eb5855fdfbbee7$export$dc98b0b04f4c7758;
'use strict';

$13eb5855fdfbbee7$export$b24b633b1364b94b = (parcelRequire("hZcCd"));

$13eb5855fdfbbee7$export$15dafbac7aec8a57 = (parcelRequire("iNnZB"));

$13eb5855fdfbbee7$export$239cff0cce87eb56 = (parcelRequire("7wXhr"));

$13eb5855fdfbbee7$export$56c0d5a1e737357d = (parcelRequire("dDBFM"));

$13eb5855fdfbbee7$export$dc98b0b04f4c7758 = (parcelRequire("23KJ1"));

});
parcelRegister("7wXhr", function(module, exports) {
module.exports = /[\xAD\u0600-\u0605\u061C\u06DD\u070F\u08E2\u180E\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u206F\uFEFF\uFFF9-\uFFFB]|\uD804\uDCBD|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|\uDB40[\uDC01\uDC20-\uDC7F]/;

});



parcelRegister("gqPyc", function(module, exports) {

$parcel$export(module.exports, "parseLinkLabel", () => $bf670ff0bedcc008$export$2a2c8612930e58d0, (v) => $bf670ff0bedcc008$export$2a2c8612930e58d0 = v);
$parcel$export(module.exports, "parseLinkDestination", () => $bf670ff0bedcc008$export$22bd24080f95f2b3, (v) => $bf670ff0bedcc008$export$22bd24080f95f2b3 = v);
$parcel$export(module.exports, "parseLinkTitle", () => $bf670ff0bedcc008$export$89650c5477a69db9, (v) => $bf670ff0bedcc008$export$89650c5477a69db9 = v);
// Just a shortcut for bulk export
var $bf670ff0bedcc008$export$2a2c8612930e58d0;
var $bf670ff0bedcc008$export$22bd24080f95f2b3;
var $bf670ff0bedcc008$export$89650c5477a69db9;
'use strict';

$bf670ff0bedcc008$export$2a2c8612930e58d0 = (parcelRequire("75pPh"));

$bf670ff0bedcc008$export$22bd24080f95f2b3 = (parcelRequire("iL3v7"));

$bf670ff0bedcc008$export$89650c5477a69db9 = (parcelRequire("8Gz76"));

});
parcelRegister("75pPh", function(module, exports) {
// Parse link label
//
// this function assumes that first character ("[") already matches;
// returns the end of the label
//
'use strict';
module.exports = function parseLinkLabel(state, start, disableNested) {
    var level, found, marker, prevPos, labelEnd = -1, max = state.posMax, oldPos = state.pos;
    state.pos = start + 1;
    level = 1;
    while(state.pos < max){
        marker = state.src.charCodeAt(state.pos);
        if (marker === 0x5D /* ] */ ) {
            level--;
            if (level === 0) {
                found = true;
                break;
            }
        }
        prevPos = state.pos;
        state.md.inline.skipToken(state);
        if (marker === 0x5B /* [ */ ) {
            if (prevPos === state.pos - 1) // increase level if we find text `[`, which is not a part of any token
            level++;
            else if (disableNested) {
                state.pos = oldPos;
                return -1;
            }
        }
    }
    if (found) labelEnd = state.pos;
    // restore old state
    state.pos = oldPos;
    return labelEnd;
};

});

parcelRegister("iL3v7", function(module, exports) {
// Parse link destination
//
'use strict';

var $l6IUK = parcelRequire("l6IUK");
var $da7f54fa213e8274$require$unescapeAll = $l6IUK.unescapeAll;
module.exports = function parseLinkDestination(str, start, max) {
    var code, level, pos = start, result = {
        ok: false,
        pos: 0,
        lines: 0,
        str: ''
    };
    if (str.charCodeAt(pos) === 0x3C /* < */ ) {
        pos++;
        while(pos < max){
            code = str.charCodeAt(pos);
            if (code === 0x0A /* \n */ ) return result;
            if (code === 0x3C /* < */ ) return result;
            if (code === 0x3E /* > */ ) {
                result.pos = pos + 1;
                result.str = $da7f54fa213e8274$require$unescapeAll(str.slice(start + 1, pos));
                result.ok = true;
                return result;
            }
            if (code === 0x5C /* \ */  && pos + 1 < max) {
                pos += 2;
                continue;
            }
            pos++;
        }
        // no closing '>'
        return result;
    }
    // this should be ... } else { ... branch
    level = 0;
    while(pos < max){
        code = str.charCodeAt(pos);
        if (code === 0x20) break;
        // ascii control characters
        if (code < 0x20 || code === 0x7F) break;
        if (code === 0x5C /* \ */  && pos + 1 < max) {
            if (str.charCodeAt(pos + 1) === 0x20) break;
            pos += 2;
            continue;
        }
        if (code === 0x28 /* ( */ ) {
            level++;
            if (level > 32) return result;
        }
        if (code === 0x29 /* ) */ ) {
            if (level === 0) break;
            level--;
        }
        pos++;
    }
    if (start === pos) return result;
    if (level !== 0) return result;
    result.str = $da7f54fa213e8274$require$unescapeAll(str.slice(start, pos));
    result.pos = pos;
    result.ok = true;
    return result;
};

});

parcelRegister("8Gz76", function(module, exports) {
// Parse link title
//
'use strict';

var $l6IUK = parcelRequire("l6IUK");
var $652d7bc9dc05402f$require$unescapeAll = $l6IUK.unescapeAll;
module.exports = function parseLinkTitle(str, start, max) {
    var code, marker, lines = 0, pos = start, result = {
        ok: false,
        pos: 0,
        lines: 0,
        str: ''
    };
    if (pos >= max) return result;
    marker = str.charCodeAt(pos);
    if (marker !== 0x22 /* " */  && marker !== 0x27 /* ' */  && marker !== 0x28 /* ( */ ) return result;
    pos++;
    // if opening marker is "(", switch it to closing marker ")"
    if (marker === 0x28) marker = 0x29;
    while(pos < max){
        code = str.charCodeAt(pos);
        if (code === marker) {
            result.pos = pos + 1;
            result.lines = lines;
            result.str = $652d7bc9dc05402f$require$unescapeAll(str.slice(start + 1, pos));
            result.ok = true;
            return result;
        } else if (code === 0x28 /* ( */  && marker === 0x29 /* ) */ ) return result;
        else if (code === 0x0A) lines++;
        else if (code === 0x5C /* \ */  && pos + 1 < max) {
            pos++;
            if (str.charCodeAt(pos) === 0x0A) lines++;
        }
        pos++;
    }
    return result;
};

});


parcelRegister("gOmEB", function(module, exports) {
/**
 * class Renderer
 *
 * Generates HTML from parsed token stream. Each instance has independent
 * copy of rules. Those can be rewritten with ease. Also, you can add new
 * rules if you create plugin and adds new token types.
 **/ 'use strict';

var $l6IUK = parcelRequire("l6IUK");
var $c3d2e3746a985ca0$require$assign = $l6IUK.assign;

var $l6IUK = parcelRequire("l6IUK");
var $c3d2e3746a985ca0$require$unescapeAll = $l6IUK.unescapeAll;

var $l6IUK = parcelRequire("l6IUK");
var $c3d2e3746a985ca0$require$escapeHtml = $l6IUK.escapeHtml;
////////////////////////////////////////////////////////////////////////////////
var $c3d2e3746a985ca0$var$default_rules = {};
$c3d2e3746a985ca0$var$default_rules.code_inline = function(tokens, idx, options, env, slf) {
    var token = tokens[idx];
    return '<code' + slf.renderAttrs(token) + '>' + $c3d2e3746a985ca0$require$escapeHtml(token.content) + '</code>';
};
$c3d2e3746a985ca0$var$default_rules.code_block = function(tokens, idx, options, env, slf) {
    var token = tokens[idx];
    return '<pre' + slf.renderAttrs(token) + '><code>' + $c3d2e3746a985ca0$require$escapeHtml(tokens[idx].content) + '</code></pre>\n';
};
$c3d2e3746a985ca0$var$default_rules.fence = function(tokens, idx, options, env, slf) {
    var token = tokens[idx], info = token.info ? $c3d2e3746a985ca0$require$unescapeAll(token.info).trim() : '', langName = '', langAttrs = '', highlighted, i, arr, tmpAttrs, tmpToken;
    if (info) {
        arr = info.split(/(\s+)/g);
        langName = arr[0];
        langAttrs = arr.slice(2).join('');
    }
    if (options.highlight) highlighted = options.highlight(token.content, langName, langAttrs) || $c3d2e3746a985ca0$require$escapeHtml(token.content);
    else highlighted = $c3d2e3746a985ca0$require$escapeHtml(token.content);
    if (highlighted.indexOf('<pre') === 0) return highlighted + '\n';
    // If language exists, inject class gently, without modifying original token.
    // May be, one day we will add .deepClone() for token and simplify this part, but
    // now we prefer to keep things local.
    if (info) {
        i = token.attrIndex('class');
        tmpAttrs = token.attrs ? token.attrs.slice() : [];
        if (i < 0) tmpAttrs.push([
            'class',
            options.langPrefix + langName
        ]);
        else {
            tmpAttrs[i] = tmpAttrs[i].slice();
            tmpAttrs[i][1] += ' ' + options.langPrefix + langName;
        }
        // Fake token just to render attributes
        tmpToken = {
            attrs: tmpAttrs
        };
        return '<pre><code' + slf.renderAttrs(tmpToken) + '>' + highlighted + '</code></pre>\n';
    }
    return '<pre><code' + slf.renderAttrs(token) + '>' + highlighted + '</code></pre>\n';
};
$c3d2e3746a985ca0$var$default_rules.image = function(tokens, idx, options, env, slf) {
    var token = tokens[idx];
    // "alt" attr MUST be set, even if empty. Because it's mandatory and
    // should be placed on proper position for tests.
    //
    // Replace content with actual value
    token.attrs[token.attrIndex('alt')][1] = slf.renderInlineAsText(token.children, options, env);
    return slf.renderToken(tokens, idx, options);
};
$c3d2e3746a985ca0$var$default_rules.hardbreak = function(tokens, idx, options /*, env */ ) {
    return options.xhtmlOut ? '<br />\n' : '<br>\n';
};
$c3d2e3746a985ca0$var$default_rules.softbreak = function(tokens, idx, options /*, env */ ) {
    return options.breaks ? options.xhtmlOut ? '<br />\n' : '<br>\n' : '\n';
};
$c3d2e3746a985ca0$var$default_rules.text = function(tokens, idx /*, options, env */ ) {
    return $c3d2e3746a985ca0$require$escapeHtml(tokens[idx].content);
};
$c3d2e3746a985ca0$var$default_rules.html_block = function(tokens, idx /*, options, env */ ) {
    return tokens[idx].content;
};
$c3d2e3746a985ca0$var$default_rules.html_inline = function(tokens, idx /*, options, env */ ) {
    return tokens[idx].content;
};
/**
 * new Renderer()
 *
 * Creates new [[Renderer]] instance and fill [[Renderer#rules]] with defaults.
 **/ function $c3d2e3746a985ca0$var$Renderer() {
    /**
   * Renderer#rules -> Object
   *
   * Contains render rules for tokens. Can be updated and extended.
   *
   * ##### Example
   *
   * ```javascript
   * var md = require('markdown-it')();
   *
   * md.renderer.rules.strong_open  = function () { return '<b>'; };
   * md.renderer.rules.strong_close = function () { return '</b>'; };
   *
   * var result = md.renderInline(...);
   * ```
   *
   * Each rule is called as independent static function with fixed signature:
   *
   * ```javascript
   * function my_token_render(tokens, idx, options, env, renderer) {
   *   // ...
   *   return renderedHTML;
   * }
   * ```
   *
   * See [source code](https://github.com/markdown-it/markdown-it/blob/master/lib/renderer.js)
   * for more details and examples.
   **/ this.rules = $c3d2e3746a985ca0$require$assign({}, $c3d2e3746a985ca0$var$default_rules);
}
/**
 * Renderer.renderAttrs(token) -> String
 *
 * Render token attributes to string.
 **/ $c3d2e3746a985ca0$var$Renderer.prototype.renderAttrs = function renderAttrs(token) {
    var i, l, result;
    if (!token.attrs) return '';
    result = '';
    for(i = 0, l = token.attrs.length; i < l; i++)result += ' ' + $c3d2e3746a985ca0$require$escapeHtml(token.attrs[i][0]) + '="' + $c3d2e3746a985ca0$require$escapeHtml(token.attrs[i][1]) + '"';
    return result;
};
/**
 * Renderer.renderToken(tokens, idx, options) -> String
 * - tokens (Array): list of tokens
 * - idx (Numbed): token index to render
 * - options (Object): params of parser instance
 *
 * Default token renderer. Can be overriden by custom function
 * in [[Renderer#rules]].
 **/ $c3d2e3746a985ca0$var$Renderer.prototype.renderToken = function renderToken(tokens, idx, options) {
    var nextToken, result = '', needLf = false, token = tokens[idx];
    // Tight list paragraphs
    if (token.hidden) return '';
    // Insert a newline between hidden paragraph and subsequent opening
    // block-level tag.
    //
    // For example, here we should insert a newline before blockquote:
    //  - a
    //    >
    //
    if (token.block && token.nesting !== -1 && idx && tokens[idx - 1].hidden) result += '\n';
    // Add token name, e.g. `<img`
    result += (token.nesting === -1 ? '</' : '<') + token.tag;
    // Encode attributes, e.g. `<img src="foo"`
    result += this.renderAttrs(token);
    // Add a slash for self-closing tags, e.g. `<img src="foo" /`
    if (token.nesting === 0 && options.xhtmlOut) result += ' /';
    // Check if we need to add a newline after this tag
    if (token.block) {
        needLf = true;
        if (token.nesting === 1) {
            if (idx + 1 < tokens.length) {
                nextToken = tokens[idx + 1];
                if (nextToken.type === 'inline' || nextToken.hidden) // Block-level tag containing an inline tag.
                //
                needLf = false;
                else if (nextToken.nesting === -1 && nextToken.tag === token.tag) // Opening tag + closing tag of the same type. E.g. `<li></li>`.
                //
                needLf = false;
            }
        }
    }
    result += needLf ? '>\n' : '>';
    return result;
};
/**
 * Renderer.renderInline(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * The same as [[Renderer.render]], but for single token of `inline` type.
 **/ $c3d2e3746a985ca0$var$Renderer.prototype.renderInline = function(tokens, options, env) {
    var type, result = '', rules = this.rules;
    for(var i = 0, len = tokens.length; i < len; i++){
        type = tokens[i].type;
        if (typeof rules[type] !== 'undefined') result += rules[type](tokens, i, options, env, this);
        else result += this.renderToken(tokens, i, options);
    }
    return result;
};
/** internal
 * Renderer.renderInlineAsText(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * Special kludge for image `alt` attributes to conform CommonMark spec.
 * Don't try to use it! Spec requires to show `alt` content with stripped markup,
 * instead of simple escaping.
 **/ $c3d2e3746a985ca0$var$Renderer.prototype.renderInlineAsText = function(tokens, options, env) {
    var result = '';
    for(var i = 0, len = tokens.length; i < len; i++){
        if (tokens[i].type === 'text') result += tokens[i].content;
        else if (tokens[i].type === 'image') result += this.renderInlineAsText(tokens[i].children, options, env);
        else if (tokens[i].type === 'softbreak') result += '\n';
    }
    return result;
};
/**
 * Renderer.render(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * Takes token stream and generates HTML. Probably, you will never need to call
 * this method directly.
 **/ $c3d2e3746a985ca0$var$Renderer.prototype.render = function(tokens, options, env) {
    var i, len, type, result = '', rules = this.rules;
    for(i = 0, len = tokens.length; i < len; i++){
        type = tokens[i].type;
        if (type === 'inline') result += this.renderInline(tokens[i].children, options, env);
        else if (typeof rules[type] !== 'undefined') result += rules[type](tokens, i, options, env, this);
        else result += this.renderToken(tokens, i, options, env);
    }
    return result;
};
module.exports = $c3d2e3746a985ca0$var$Renderer;

});

parcelRegister("5V1yU", function(module, exports) {
/** internal
 * class Core
 *
 * Top-level rules executor. Glues block/inline parsers and does intermediate
 * transformations.
 **/ 'use strict';

var $c3dcz = parcelRequire("c3dcz");







var $44f37ccc2afb11d4$var$_rules = [
    [
        'normalize',
        (parcelRequire("2F6P7"))
    ],
    [
        'block',
        (parcelRequire("4RLUe"))
    ],
    [
        'inline',
        (parcelRequire("dLNp5"))
    ],
    [
        'linkify',
        (parcelRequire("6QJhn"))
    ],
    [
        'replacements',
        (parcelRequire("9fXv1"))
    ],
    [
        'smartquotes',
        (parcelRequire("dTPyw"))
    ],
    // `text_join` finds `text_special` tokens (for escape sequences)
    // and joins them with the rest of the text
    [
        'text_join',
        (parcelRequire("iAzc8"))
    ]
];
/**
 * new Core()
 **/ function $44f37ccc2afb11d4$var$Core() {
    /**
   * Core#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of core rules.
   **/ this.ruler = new $c3dcz();
    for(var i = 0; i < $44f37ccc2afb11d4$var$_rules.length; i++)this.ruler.push($44f37ccc2afb11d4$var$_rules[i][0], $44f37ccc2afb11d4$var$_rules[i][1]);
}
/**
 * Core.process(state)
 *
 * Executes core chain rules.
 **/ $44f37ccc2afb11d4$var$Core.prototype.process = function(state) {
    var i, l, rules;
    rules = this.ruler.getRules('');
    for(i = 0, l = rules.length; i < l; i++)rules[i](state);
};

$44f37ccc2afb11d4$var$Core.prototype.State = (parcelRequire("c6wci"));
module.exports = $44f37ccc2afb11d4$var$Core;

});
parcelRegister("c3dcz", function(module, exports) {
/**
 * class Ruler
 *
 * Helper class, used by [[MarkdownIt#core]], [[MarkdownIt#block]] and
 * [[MarkdownIt#inline]] to manage sequences of functions (rules):
 *
 * - keep rules in defined order
 * - assign the name to each rule
 * - enable/disable rules
 * - add/replace rules
 * - allow assign rules to additional named chains (in the same)
 * - cacheing lists of active rules
 *
 * You will not need use this class directly until write plugins. For simple
 * rules control use [[MarkdownIt.disable]], [[MarkdownIt.enable]] and
 * [[MarkdownIt.use]].
 **/ 'use strict';
/**
 * new Ruler()
 **/ function $8c600173b50ded2a$var$Ruler() {
    // List of added rules. Each element is:
    //
    // {
    //   name: XXX,
    //   enabled: Boolean,
    //   fn: Function(),
    //   alt: [ name2, name3 ]
    // }
    //
    this.__rules__ = [];
    // Cached rule chains.
    //
    // First level - chain name, '' for default.
    // Second level - diginal anchor for fast filtering by charcodes.
    //
    this.__cache__ = null;
}
////////////////////////////////////////////////////////////////////////////////
// Helper methods, should not be used directly
// Find rule index by name
//
$8c600173b50ded2a$var$Ruler.prototype.__find__ = function(name) {
    for(var i = 0; i < this.__rules__.length; i++){
        if (this.__rules__[i].name === name) return i;
    }
    return -1;
};
// Build rules lookup cache
//
$8c600173b50ded2a$var$Ruler.prototype.__compile__ = function() {
    var self = this;
    var chains = [
        ''
    ];
    // collect unique names
    self.__rules__.forEach(function(rule) {
        if (!rule.enabled) return;
        rule.alt.forEach(function(altName) {
            if (chains.indexOf(altName) < 0) chains.push(altName);
        });
    });
    self.__cache__ = {};
    chains.forEach(function(chain) {
        self.__cache__[chain] = [];
        self.__rules__.forEach(function(rule) {
            if (!rule.enabled) return;
            if (chain && rule.alt.indexOf(chain) < 0) return;
            self.__cache__[chain].push(rule.fn);
        });
    });
};
/**
 * Ruler.at(name, fn [, options])
 * - name (String): rule name to replace.
 * - fn (Function): new rule function.
 * - options (Object): new rule options (not mandatory).
 *
 * Replace rule by name with new function & options. Throws error if name not
 * found.
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * Replace existing typographer replacement rule with new one:
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.core.ruler.at('replacements', function replace(state) {
 *   //...
 * });
 * ```
 **/ $8c600173b50ded2a$var$Ruler.prototype.at = function(name, fn, options) {
    var index = this.__find__(name);
    var opt = options || {};
    if (index === -1) throw new Error('Parser rule not found: ' + name);
    this.__rules__[index].fn = fn;
    this.__rules__[index].alt = opt.alt || [];
    this.__cache__ = null;
};
/**
 * Ruler.before(beforeName, ruleName, fn [, options])
 * - beforeName (String): new rule will be added before this one.
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Add new rule to chain before one with given name. See also
 * [[Ruler.after]], [[Ruler.push]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.block.ruler.before('paragraph', 'my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $8c600173b50ded2a$var$Ruler.prototype.before = function(beforeName, ruleName, fn, options) {
    var index = this.__find__(beforeName);
    var opt = options || {};
    if (index === -1) throw new Error('Parser rule not found: ' + beforeName);
    this.__rules__.splice(index, 0, {
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.after(afterName, ruleName, fn [, options])
 * - afterName (String): new rule will be added after this one.
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Add new rule to chain after one with given name. See also
 * [[Ruler.before]], [[Ruler.push]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.inline.ruler.after('text', 'my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $8c600173b50ded2a$var$Ruler.prototype.after = function(afterName, ruleName, fn, options) {
    var index = this.__find__(afterName);
    var opt = options || {};
    if (index === -1) throw new Error('Parser rule not found: ' + afterName);
    this.__rules__.splice(index + 1, 0, {
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.push(ruleName, fn [, options])
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Push new rule to the end of chain. See also
 * [[Ruler.before]], [[Ruler.after]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.core.ruler.push('my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $8c600173b50ded2a$var$Ruler.prototype.push = function(ruleName, fn, options) {
    var opt = options || {};
    this.__rules__.push({
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.enable(list [, ignoreInvalid]) -> Array
 * - list (String|Array): list of rule names to enable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable rules with given names. If any rule name not found - throw Error.
 * Errors can be disabled by second param.
 *
 * Returns list of found rule names (if no exception happened).
 *
 * See also [[Ruler.disable]], [[Ruler.enableOnly]].
 **/ $8c600173b50ded2a$var$Ruler.prototype.enable = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    var result = [];
    // Search by name and enable
    list.forEach(function(name) {
        var idx = this.__find__(name);
        if (idx < 0) {
            if (ignoreInvalid) return;
            throw new Error('Rules manager: invalid rule name ' + name);
        }
        this.__rules__[idx].enabled = true;
        result.push(name);
    }, this);
    this.__cache__ = null;
    return result;
};
/**
 * Ruler.enableOnly(list [, ignoreInvalid])
 * - list (String|Array): list of rule names to enable (whitelist).
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable rules with given names, and disable everything else. If any rule name
 * not found - throw Error. Errors can be disabled by second param.
 *
 * See also [[Ruler.disable]], [[Ruler.enable]].
 **/ $8c600173b50ded2a$var$Ruler.prototype.enableOnly = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    this.__rules__.forEach(function(rule) {
        rule.enabled = false;
    });
    this.enable(list, ignoreInvalid);
};
/**
 * Ruler.disable(list [, ignoreInvalid]) -> Array
 * - list (String|Array): list of rule names to disable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Disable rules with given names. If any rule name not found - throw Error.
 * Errors can be disabled by second param.
 *
 * Returns list of found rule names (if no exception happened).
 *
 * See also [[Ruler.enable]], [[Ruler.enableOnly]].
 **/ $8c600173b50ded2a$var$Ruler.prototype.disable = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    var result = [];
    // Search by name and disable
    list.forEach(function(name) {
        var idx = this.__find__(name);
        if (idx < 0) {
            if (ignoreInvalid) return;
            throw new Error('Rules manager: invalid rule name ' + name);
        }
        this.__rules__[idx].enabled = false;
        result.push(name);
    }, this);
    this.__cache__ = null;
    return result;
};
/**
 * Ruler.getRules(chainName) -> Array
 *
 * Return array of active functions (rules) for given chain name. It analyzes
 * rules configuration, compiles caches if not exists and returns result.
 *
 * Default chain name is `''` (empty string). It can't be skipped. That's
 * done intentionally, to keep signature monomorphic for high speed.
 **/ $8c600173b50ded2a$var$Ruler.prototype.getRules = function(chainName) {
    if (this.__cache__ === null) this.__compile__();
    // Chain can be empty, if rules disabled. But we still have to return Array.
    return this.__cache__[chainName] || [];
};
module.exports = $8c600173b50ded2a$var$Ruler;

});

parcelRegister("2F6P7", function(module, exports) {
// Normalize input string
'use strict';
// https://spec.commonmark.org/0.29/#line-ending
var $1f04b41d04c68366$var$NEWLINES_RE = /\r\n?|\n/g;
var $1f04b41d04c68366$var$NULL_RE = /\0/g;
module.exports = function normalize(state) {
    var str;
    // Normalize newlines
    str = state.src.replace($1f04b41d04c68366$var$NEWLINES_RE, '\n');
    // Replace NULL characters
    str = str.replace($1f04b41d04c68366$var$NULL_RE, '\uFFFD');
    state.src = str;
};

});

parcelRegister("4RLUe", function(module, exports) {
'use strict';
module.exports = function block(state) {
    var token;
    if (state.inlineMode) {
        token = new state.Token('inline', '', 0);
        token.content = state.src;
        token.map = [
            0,
            1
        ];
        token.children = [];
        state.tokens.push(token);
    } else state.md.block.parse(state.src, state.md, state.env, state.tokens);
};

});

parcelRegister("dLNp5", function(module, exports) {
'use strict';
module.exports = function inline(state) {
    var tokens = state.tokens, tok, i, l;
    // Parse inlines
    for(i = 0, l = tokens.length; i < l; i++){
        tok = tokens[i];
        if (tok.type === 'inline') state.md.inline.parse(tok.content, state.md, state.env, tok.children);
    }
};

});

parcelRegister("6QJhn", function(module, exports) {
// Replace link-like texts with link nodes.
//
// Currently restricted by `md.validateLink()` to http/https/ftp
//
'use strict';

var $l6IUK = parcelRequire("l6IUK");
var $4fcab8ef9c16d34c$require$arrayReplaceAt = $l6IUK.arrayReplaceAt;
function $4fcab8ef9c16d34c$var$isLinkOpen(str) {
    return /^<a[>\s]/i.test(str);
}
function $4fcab8ef9c16d34c$var$isLinkClose(str) {
    return /^<\/a\s*>/i.test(str);
}
module.exports = function linkify(state) {
    var i, j, l, tokens, token, currentToken, nodes, ln, text, pos, lastPos, level, htmlLinkLevel, url, fullUrl, urlText, blockTokens = state.tokens, links;
    if (!state.md.options.linkify) return;
    for(j = 0, l = blockTokens.length; j < l; j++){
        if (blockTokens[j].type !== 'inline' || !state.md.linkify.pretest(blockTokens[j].content)) continue;
        tokens = blockTokens[j].children;
        htmlLinkLevel = 0;
        // We scan from the end, to keep position when new tags added.
        // Use reversed logic in links start/end match
        for(i = tokens.length - 1; i >= 0; i--){
            currentToken = tokens[i];
            // Skip content of markdown links
            if (currentToken.type === 'link_close') {
                i--;
                while(tokens[i].level !== currentToken.level && tokens[i].type !== 'link_open')i--;
                continue;
            }
            // Skip content of html tag links
            if (currentToken.type === 'html_inline') {
                if ($4fcab8ef9c16d34c$var$isLinkOpen(currentToken.content) && htmlLinkLevel > 0) htmlLinkLevel--;
                if ($4fcab8ef9c16d34c$var$isLinkClose(currentToken.content)) htmlLinkLevel++;
            }
            if (htmlLinkLevel > 0) continue;
            if (currentToken.type === 'text' && state.md.linkify.test(currentToken.content)) {
                text = currentToken.content;
                links = state.md.linkify.match(text);
                // Now split string to nodes
                nodes = [];
                level = currentToken.level;
                lastPos = 0;
                // forbid escape sequence at the start of the string,
                // this avoids http\://example.com/ from being linkified as
                // http:<a href="//example.com/">//example.com/</a>
                if (links.length > 0 && links[0].index === 0 && i > 0 && tokens[i - 1].type === 'text_special') links = links.slice(1);
                for(ln = 0; ln < links.length; ln++){
                    url = links[ln].url;
                    fullUrl = state.md.normalizeLink(url);
                    if (!state.md.validateLink(fullUrl)) continue;
                    urlText = links[ln].text;
                    // Linkifier might send raw hostnames like "example.com", where url
                    // starts with domain name. So we prepend http:// in those cases,
                    // and remove it afterwards.
                    //
                    if (!links[ln].schema) urlText = state.md.normalizeLinkText('http://' + urlText).replace(/^http:\/\//, '');
                    else if (links[ln].schema === 'mailto:' && !/^mailto:/i.test(urlText)) urlText = state.md.normalizeLinkText('mailto:' + urlText).replace(/^mailto:/, '');
                    else urlText = state.md.normalizeLinkText(urlText);
                    pos = links[ln].index;
                    if (pos > lastPos) {
                        token = new state.Token('text', '', 0);
                        token.content = text.slice(lastPos, pos);
                        token.level = level;
                        nodes.push(token);
                    }
                    token = new state.Token('link_open', 'a', 1);
                    token.attrs = [
                        [
                            'href',
                            fullUrl
                        ]
                    ];
                    token.level = level++;
                    token.markup = 'linkify';
                    token.info = 'auto';
                    nodes.push(token);
                    token = new state.Token('text', '', 0);
                    token.content = urlText;
                    token.level = level;
                    nodes.push(token);
                    token = new state.Token('link_close', 'a', -1);
                    token.level = --level;
                    token.markup = 'linkify';
                    token.info = 'auto';
                    nodes.push(token);
                    lastPos = links[ln].lastIndex;
                }
                if (lastPos < text.length) {
                    token = new state.Token('text', '', 0);
                    token.content = text.slice(lastPos);
                    token.level = level;
                    nodes.push(token);
                }
                // replace current node
                blockTokens[j].children = tokens = $4fcab8ef9c16d34c$require$arrayReplaceAt(tokens, i, nodes);
            }
        }
    }
};

});

parcelRegister("9fXv1", function(module, exports) {
// Simple typographic replacements
//
// (c) (C) → ©
// (tm) (TM) → ™
// (r) (R) → ®
// +- → ±
// ... → … (also ?.... → ?.., !.... → !..)
// ???????? → ???, !!!!! → !!!, `,,` → `,`
// -- → &ndash;, --- → &mdash;
//
'use strict';
// TODO:
// - fractionals 1/2, 1/4, 3/4 -> ½, ¼, ¾
// - multiplications 2 x 4 -> 2 × 4
var $6bd3ab1d593dcde6$var$RARE_RE = /\+-|\.\.|\?\?\?\?|!!!!|,,|--/;
// Workaround for phantomjs - need regex without /g flag,
// or root check will fail every second time
var $6bd3ab1d593dcde6$var$SCOPED_ABBR_TEST_RE = /\((c|tm|r)\)/i;
var $6bd3ab1d593dcde6$var$SCOPED_ABBR_RE = /\((c|tm|r)\)/ig;
var $6bd3ab1d593dcde6$var$SCOPED_ABBR = {
    c: "\xa9",
    r: "\xae",
    tm: "\u2122"
};
function $6bd3ab1d593dcde6$var$replaceFn(match, name) {
    return $6bd3ab1d593dcde6$var$SCOPED_ABBR[name.toLowerCase()];
}
function $6bd3ab1d593dcde6$var$replace_scoped(inlineTokens) {
    var i, token, inside_autolink = 0;
    for(i = inlineTokens.length - 1; i >= 0; i--){
        token = inlineTokens[i];
        if (token.type === 'text' && !inside_autolink) token.content = token.content.replace($6bd3ab1d593dcde6$var$SCOPED_ABBR_RE, $6bd3ab1d593dcde6$var$replaceFn);
        if (token.type === 'link_open' && token.info === 'auto') inside_autolink--;
        if (token.type === 'link_close' && token.info === 'auto') inside_autolink++;
    }
}
function $6bd3ab1d593dcde6$var$replace_rare(inlineTokens) {
    var i, token, inside_autolink = 0;
    for(i = inlineTokens.length - 1; i >= 0; i--){
        token = inlineTokens[i];
        if (token.type === 'text' && !inside_autolink) {
            if ($6bd3ab1d593dcde6$var$RARE_RE.test(token.content)) token.content = token.content.replace(/\+-/g, "\xb1")// .., ..., ....... -> …
            // but ?..... & !..... -> ?.. & !..
            .replace(/\.{2,}/g, "\u2026").replace(/([?!])…/g, '$1..').replace(/([?!]){4,}/g, '$1$1$1').replace(/,{2,}/g, ',')// em-dash
            .replace(/(^|[^-])---(?=[^-]|$)/mg, '$1\u2014')// en-dash
            .replace(/(^|\s)--(?=\s|$)/mg, '$1\u2013').replace(/(^|[^-\s])--(?=[^-\s]|$)/mg, '$1\u2013');
        }
        if (token.type === 'link_open' && token.info === 'auto') inside_autolink--;
        if (token.type === 'link_close' && token.info === 'auto') inside_autolink++;
    }
}
module.exports = function replace(state) {
    var blkIdx;
    if (!state.md.options.typographer) return;
    for(blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--){
        if (state.tokens[blkIdx].type !== 'inline') continue;
        if ($6bd3ab1d593dcde6$var$SCOPED_ABBR_TEST_RE.test(state.tokens[blkIdx].content)) $6bd3ab1d593dcde6$var$replace_scoped(state.tokens[blkIdx].children);
        if ($6bd3ab1d593dcde6$var$RARE_RE.test(state.tokens[blkIdx].content)) $6bd3ab1d593dcde6$var$replace_rare(state.tokens[blkIdx].children);
    }
};

});

parcelRegister("dTPyw", function(module, exports) {
// Convert straight quotation marks to typographic ones
//
'use strict';

var $l6IUK = parcelRequire("l6IUK");
var $a1e867523fcddfe1$require$isWhiteSpace = $l6IUK.isWhiteSpace;

var $l6IUK = parcelRequire("l6IUK");
var $a1e867523fcddfe1$require$isPunctChar = $l6IUK.isPunctChar;

var $l6IUK = parcelRequire("l6IUK");
var $a1e867523fcddfe1$require$isMdAsciiPunct = $l6IUK.isMdAsciiPunct;
var $a1e867523fcddfe1$var$QUOTE_TEST_RE = /['"]/;
var $a1e867523fcddfe1$var$QUOTE_RE = /['"]/g;
var $a1e867523fcddfe1$var$APOSTROPHE = '\u2019'; /* ’ */ 
function $a1e867523fcddfe1$var$replaceAt(str, index, ch) {
    return str.slice(0, index) + ch + str.slice(index + 1);
}
function $a1e867523fcddfe1$var$process_inlines(tokens, state) {
    var i, token, text, t, pos, max, thisLevel, item, lastChar, nextChar, isLastPunctChar, isNextPunctChar, isLastWhiteSpace, isNextWhiteSpace, canOpen, canClose, j, isSingle, stack, openQuote, closeQuote;
    stack = [];
    for(i = 0; i < tokens.length; i++){
        token = tokens[i];
        thisLevel = tokens[i].level;
        for(j = stack.length - 1; j >= 0; j--){
            if (stack[j].level <= thisLevel) break;
        }
        stack.length = j + 1;
        if (token.type !== 'text') continue;
        text = token.content;
        pos = 0;
        max = text.length;
        /*eslint no-labels:0,block-scoped-var:0*/ OUTER: while(pos < max){
            $a1e867523fcddfe1$var$QUOTE_RE.lastIndex = pos;
            t = $a1e867523fcddfe1$var$QUOTE_RE.exec(text);
            if (!t) break;
            canOpen = canClose = true;
            pos = t.index + 1;
            isSingle = t[0] === "'";
            // Find previous character,
            // default to space if it's the beginning of the line
            //
            lastChar = 0x20;
            if (t.index - 1 >= 0) lastChar = text.charCodeAt(t.index - 1);
            else for(j = i - 1; j >= 0; j--){
                if (tokens[j].type === 'softbreak' || tokens[j].type === 'hardbreak') break; // lastChar defaults to 0x20
                if (!tokens[j].content) continue; // should skip all tokens except 'text', 'html_inline' or 'code_inline'
                lastChar = tokens[j].content.charCodeAt(tokens[j].content.length - 1);
                break;
            }
            // Find next character,
            // default to space if it's the end of the line
            //
            nextChar = 0x20;
            if (pos < max) nextChar = text.charCodeAt(pos);
            else for(j = i + 1; j < tokens.length; j++){
                if (tokens[j].type === 'softbreak' || tokens[j].type === 'hardbreak') break; // nextChar defaults to 0x20
                if (!tokens[j].content) continue; // should skip all tokens except 'text', 'html_inline' or 'code_inline'
                nextChar = tokens[j].content.charCodeAt(0);
                break;
            }
            isLastPunctChar = $a1e867523fcddfe1$require$isMdAsciiPunct(lastChar) || $a1e867523fcddfe1$require$isPunctChar(String.fromCharCode(lastChar));
            isNextPunctChar = $a1e867523fcddfe1$require$isMdAsciiPunct(nextChar) || $a1e867523fcddfe1$require$isPunctChar(String.fromCharCode(nextChar));
            isLastWhiteSpace = $a1e867523fcddfe1$require$isWhiteSpace(lastChar);
            isNextWhiteSpace = $a1e867523fcddfe1$require$isWhiteSpace(nextChar);
            if (isNextWhiteSpace) canOpen = false;
            else if (isNextPunctChar) {
                if (!(isLastWhiteSpace || isLastPunctChar)) canOpen = false;
            }
            if (isLastWhiteSpace) canClose = false;
            else if (isLastPunctChar) {
                if (!(isNextWhiteSpace || isNextPunctChar)) canClose = false;
            }
            if (nextChar === 0x22 /* " */  && t[0] === '"') {
                if (lastChar >= 0x30 /* 0 */  && lastChar <= 0x39 /* 9 */ ) // special case: 1"" - count first quote as an inch
                canClose = canOpen = false;
            }
            if (canOpen && canClose) {
                // Replace quotes in the middle of punctuation sequence, but not
                // in the middle of the words, i.e.:
                //
                // 1. foo " bar " baz - not replaced
                // 2. foo-"-bar-"-baz - replaced
                // 3. foo"bar"baz     - not replaced
                //
                canOpen = isLastPunctChar;
                canClose = isNextPunctChar;
            }
            if (!canOpen && !canClose) {
                // middle of word
                if (isSingle) token.content = $a1e867523fcddfe1$var$replaceAt(token.content, t.index, $a1e867523fcddfe1$var$APOSTROPHE);
                continue;
            }
            if (canClose) // this could be a closing quote, rewind the stack to get a match
            for(j = stack.length - 1; j >= 0; j--){
                item = stack[j];
                if (stack[j].level < thisLevel) break;
                if (item.single === isSingle && stack[j].level === thisLevel) {
                    item = stack[j];
                    if (isSingle) {
                        openQuote = state.md.options.quotes[2];
                        closeQuote = state.md.options.quotes[3];
                    } else {
                        openQuote = state.md.options.quotes[0];
                        closeQuote = state.md.options.quotes[1];
                    }
                    // replace token.content *before* tokens[item.token].content,
                    // because, if they are pointing at the same token, replaceAt
                    // could mess up indices when quote length != 1
                    token.content = $a1e867523fcddfe1$var$replaceAt(token.content, t.index, closeQuote);
                    tokens[item.token].content = $a1e867523fcddfe1$var$replaceAt(tokens[item.token].content, item.pos, openQuote);
                    pos += closeQuote.length - 1;
                    if (item.token === i) pos += openQuote.length - 1;
                    text = token.content;
                    max = text.length;
                    stack.length = j;
                    continue OUTER;
                }
            }
            if (canOpen) stack.push({
                token: i,
                pos: t.index,
                single: isSingle,
                level: thisLevel
            });
            else if (canClose && isSingle) token.content = $a1e867523fcddfe1$var$replaceAt(token.content, t.index, $a1e867523fcddfe1$var$APOSTROPHE);
        }
    }
}
module.exports = function smartquotes(state) {
    /*eslint max-depth:0*/ var blkIdx;
    if (!state.md.options.typographer) return;
    for(blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--){
        if (state.tokens[blkIdx].type !== 'inline' || !$a1e867523fcddfe1$var$QUOTE_TEST_RE.test(state.tokens[blkIdx].content)) continue;
        $a1e867523fcddfe1$var$process_inlines(state.tokens[blkIdx].children, state);
    }
};

});

parcelRegister("iAzc8", function(module, exports) {
// Join raw text tokens with the rest of the text
//
// This is set as a separate rule to provide an opportunity for plugins
// to run text replacements after text join, but before escape join.
//
// For example, `\:)` shouldn't be replaced with an emoji.
//
'use strict';
module.exports = function text_join(state) {
    var j, l, tokens, curr, max, last, blockTokens = state.tokens;
    for(j = 0, l = blockTokens.length; j < l; j++){
        if (blockTokens[j].type !== 'inline') continue;
        tokens = blockTokens[j].children;
        max = tokens.length;
        for(curr = 0; curr < max; curr++)if (tokens[curr].type === 'text_special') tokens[curr].type = 'text';
        for(curr = last = 0; curr < max; curr++)if (tokens[curr].type === 'text' && curr + 1 < max && tokens[curr + 1].type === 'text') // collapse two adjacent text nodes
        tokens[curr + 1].content = tokens[curr].content + tokens[curr + 1].content;
        else {
            if (curr !== last) tokens[last] = tokens[curr];
            last++;
        }
        if (curr !== last) tokens.length = last;
    }
};

});

parcelRegister("c6wci", function(module, exports) {
// Core state object
//
'use strict';

var $8AILn = parcelRequire("8AILn");
function $8cff0547fd21895a$var$StateCore(src, md, env) {
    this.src = src;
    this.env = env;
    this.tokens = [];
    this.inlineMode = false;
    this.md = md; // link to parser instance
}
// re-export Token class to use in core rules
$8cff0547fd21895a$var$StateCore.prototype.Token = $8AILn;
module.exports = $8cff0547fd21895a$var$StateCore;

});
parcelRegister("8AILn", function(module, exports) {
// Token class
'use strict';
/**
 * class Token
 **/ /**
 * new Token(type, tag, nesting)
 *
 * Create new token and fill passed properties.
 **/ function $6414688916872829$var$Token(type, tag, nesting) {
    /**
   * Token#type -> String
   *
   * Type of the token (string, e.g. "paragraph_open")
   **/ this.type = type;
    /**
   * Token#tag -> String
   *
   * html tag name, e.g. "p"
   **/ this.tag = tag;
    /**
   * Token#attrs -> Array
   *
   * Html attributes. Format: `[ [ name1, value1 ], [ name2, value2 ] ]`
   **/ this.attrs = null;
    /**
   * Token#map -> Array
   *
   * Source map info. Format: `[ line_begin, line_end ]`
   **/ this.map = null;
    /**
   * Token#nesting -> Number
   *
   * Level change (number in {-1, 0, 1} set), where:
   *
   * -  `1` means the tag is opening
   * -  `0` means the tag is self-closing
   * - `-1` means the tag is closing
   **/ this.nesting = nesting;
    /**
   * Token#level -> Number
   *
   * nesting level, the same as `state.level`
   **/ this.level = 0;
    /**
   * Token#children -> Array
   *
   * An array of child nodes (inline and img tokens)
   **/ this.children = null;
    /**
   * Token#content -> String
   *
   * In a case of self-closing tag (code, html, fence, etc.),
   * it has contents of this tag.
   **/ this.content = '';
    /**
   * Token#markup -> String
   *
   * '*' or '_' for emphasis, fence string for fence, etc.
   **/ this.markup = '';
    /**
   * Token#info -> String
   *
   * Additional information:
   *
   * - Info string for "fence" tokens
   * - The value "auto" for autolink "link_open" and "link_close" tokens
   * - The string value of the item marker for ordered-list "list_item_open" tokens
   **/ this.info = '';
    /**
   * Token#meta -> Object
   *
   * A place for plugins to store an arbitrary data
   **/ this.meta = null;
    /**
   * Token#block -> Boolean
   *
   * True for block-level tokens, false for inline tokens.
   * Used in renderer to calculate line breaks
   **/ this.block = false;
    /**
   * Token#hidden -> Boolean
   *
   * If it's true, ignore this element when rendering. Used for tight lists
   * to hide paragraphs.
   **/ this.hidden = false;
}
/**
 * Token.attrIndex(name) -> Number
 *
 * Search attribute index by name.
 **/ $6414688916872829$var$Token.prototype.attrIndex = function attrIndex(name) {
    var attrs, i, len;
    if (!this.attrs) return -1;
    attrs = this.attrs;
    for(i = 0, len = attrs.length; i < len; i++){
        if (attrs[i][0] === name) return i;
    }
    return -1;
};
/**
 * Token.attrPush(attrData)
 *
 * Add `[ name, value ]` attribute to list. Init attrs if necessary
 **/ $6414688916872829$var$Token.prototype.attrPush = function attrPush(attrData) {
    if (this.attrs) this.attrs.push(attrData);
    else this.attrs = [
        attrData
    ];
};
/**
 * Token.attrSet(name, value)
 *
 * Set `name` attribute to `value`. Override old value if exists.
 **/ $6414688916872829$var$Token.prototype.attrSet = function attrSet(name, value) {
    var idx = this.attrIndex(name), attrData = [
        name,
        value
    ];
    if (idx < 0) this.attrPush(attrData);
    else this.attrs[idx] = attrData;
};
/**
 * Token.attrGet(name)
 *
 * Get the value of attribute `name`, or null if it does not exist.
 **/ $6414688916872829$var$Token.prototype.attrGet = function attrGet(name) {
    var idx = this.attrIndex(name), value = null;
    if (idx >= 0) value = this.attrs[idx][1];
    return value;
};
/**
 * Token.attrJoin(name, value)
 *
 * Join value to existing attribute via space. Or create new attribute if not
 * exists. Useful to operate with token classes.
 **/ $6414688916872829$var$Token.prototype.attrJoin = function attrJoin(name, value) {
    var idx = this.attrIndex(name);
    if (idx < 0) this.attrPush([
        name,
        value
    ]);
    else this.attrs[idx][1] = this.attrs[idx][1] + ' ' + value;
};
module.exports = $6414688916872829$var$Token;

});



parcelRegister("9Xg9R", function(module, exports) {
/** internal
 * class ParserBlock
 *
 * Block-level tokenizer.
 **/ 'use strict';

var $c3dcz = parcelRequire("c3dcz");











var $73f628630344da6a$var$_rules = [
    // First 2 params - rule name & source. Secondary array - list of rules,
    // which can be terminated by this one.
    [
        'table',
        (parcelRequire("6AMir")),
        [
            'paragraph',
            'reference'
        ]
    ],
    [
        'code',
        (parcelRequire("emojL"))
    ],
    [
        'fence',
        (parcelRequire("fv8TY")),
        [
            'paragraph',
            'reference',
            'blockquote',
            'list'
        ]
    ],
    [
        'blockquote',
        (parcelRequire("aWlef")),
        [
            'paragraph',
            'reference',
            'blockquote',
            'list'
        ]
    ],
    [
        'hr',
        (parcelRequire("7dy3H")),
        [
            'paragraph',
            'reference',
            'blockquote',
            'list'
        ]
    ],
    [
        'list',
        (parcelRequire("6LEge")),
        [
            'paragraph',
            'reference',
            'blockquote'
        ]
    ],
    [
        'reference',
        (parcelRequire("14Fj0"))
    ],
    [
        'html_block',
        (parcelRequire("agiT5")),
        [
            'paragraph',
            'reference',
            'blockquote'
        ]
    ],
    [
        'heading',
        (parcelRequire("9FRBG")),
        [
            'paragraph',
            'reference',
            'blockquote'
        ]
    ],
    [
        'lheading',
        (parcelRequire("aKAqI"))
    ],
    [
        'paragraph',
        (parcelRequire("7QU8N"))
    ]
];
/**
 * new ParserBlock()
 **/ function $73f628630344da6a$var$ParserBlock() {
    /**
   * ParserBlock#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of block rules.
   **/ this.ruler = new $c3dcz();
    for(var i = 0; i < $73f628630344da6a$var$_rules.length; i++)this.ruler.push($73f628630344da6a$var$_rules[i][0], $73f628630344da6a$var$_rules[i][1], {
        alt: ($73f628630344da6a$var$_rules[i][2] || []).slice()
    });
}
// Generate tokens for input range
//
$73f628630344da6a$var$ParserBlock.prototype.tokenize = function(state, startLine, endLine) {
    var ok, i, prevLine, rules = this.ruler.getRules(''), len = rules.length, line = startLine, hasEmptyLines = false, maxNesting = state.md.options.maxNesting;
    while(line < endLine){
        state.line = line = state.skipEmptyLines(line);
        if (line >= endLine) break;
        // Termination condition for nested calls.
        // Nested calls currently used for blockquotes & lists
        if (state.sCount[line] < state.blkIndent) break;
        // If nesting level exceeded - skip tail to the end. That's not ordinary
        // situation and we should not care about content.
        if (state.level >= maxNesting) {
            state.line = endLine;
            break;
        }
        // Try all possible rules.
        // On success, rule should:
        //
        // - update `state.line`
        // - update `state.tokens`
        // - return true
        prevLine = state.line;
        for(i = 0; i < len; i++){
            ok = rules[i](state, line, endLine, false);
            if (ok) {
                if (prevLine >= state.line) throw new Error("block rule didn't increment state.line");
                break;
            }
        }
        // this can only happen if user disables paragraph rule
        if (!ok) throw new Error('none of the block rules matched');
        // set state.tight if we had an empty line before current tag
        // i.e. latest empty line should not count
        state.tight = !hasEmptyLines;
        // paragraph might "eat" one newline after it in nested lists
        if (state.isEmpty(state.line - 1)) hasEmptyLines = true;
        line = state.line;
        if (line < endLine && state.isEmpty(line)) {
            hasEmptyLines = true;
            line++;
            state.line = line;
        }
    }
};
/**
 * ParserBlock.parse(str, md, env, outTokens)
 *
 * Process input string and push block tokens into `outTokens`
 **/ $73f628630344da6a$var$ParserBlock.prototype.parse = function(src, md, env, outTokens) {
    var state;
    if (!src) return;
    state = new this.State(src, md, env, outTokens);
    this.tokenize(state, state.line, state.lineMax);
};

$73f628630344da6a$var$ParserBlock.prototype.State = (parcelRequire("4ASdB"));
module.exports = $73f628630344da6a$var$ParserBlock;

});
parcelRegister("6AMir", function(module, exports) {
// GFM table, https://github.github.com/gfm/#tables-extension-
'use strict';

var $l6IUK = parcelRequire("l6IUK");
var $4ccb918515910368$require$isSpace = $l6IUK.isSpace;
function $4ccb918515910368$var$getLine(state, line) {
    var pos = state.bMarks[line] + state.tShift[line], max = state.eMarks[line];
    return state.src.slice(pos, max);
}
function $4ccb918515910368$var$escapedSplit(str) {
    var result = [], pos = 0, max = str.length, ch, isEscaped = false, lastPos = 0, current = '';
    ch = str.charCodeAt(pos);
    while(pos < max){
        if (ch === 0x7c /* | */ ) {
            if (!isEscaped) {
                // pipe separating cells, '|'
                result.push(current + str.substring(lastPos, pos));
                current = '';
                lastPos = pos + 1;
            } else {
                // escaped pipe, '\|'
                current += str.substring(lastPos, pos - 1);
                lastPos = pos;
            }
        }
        isEscaped = ch === 0x5c /* \ */ ;
        pos++;
        ch = str.charCodeAt(pos);
    }
    result.push(current + str.substring(lastPos));
    return result;
}
module.exports = function table(state, startLine, endLine, silent) {
    var ch, lineText, pos, i, l, nextLine, columns, columnCount, token, aligns, t, tableLines, tbodyLines, oldParentType, terminate, terminatorRules, firstCh, secondCh;
    // should have at least two lines
    if (startLine + 2 > endLine) return false;
    nextLine = startLine + 1;
    if (state.sCount[nextLine] < state.blkIndent) return false;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[nextLine] - state.blkIndent >= 4) return false;
    // first character of the second line should be '|', '-', ':',
    // and no other characters are allowed but spaces;
    // basically, this is the equivalent of /^[-:|][-:|\s]*$/ regexp
    pos = state.bMarks[nextLine] + state.tShift[nextLine];
    if (pos >= state.eMarks[nextLine]) return false;
    firstCh = state.src.charCodeAt(pos++);
    if (firstCh !== 0x7C /* | */  && firstCh !== 0x2D /* - */  && firstCh !== 0x3A /* : */ ) return false;
    if (pos >= state.eMarks[nextLine]) return false;
    secondCh = state.src.charCodeAt(pos++);
    if (secondCh !== 0x7C /* | */  && secondCh !== 0x2D /* - */  && secondCh !== 0x3A /* : */  && !$4ccb918515910368$require$isSpace(secondCh)) return false;
    // if first character is '-', then second character must not be a space
    // (due to parsing ambiguity with list)
    if (firstCh === 0x2D /* - */  && $4ccb918515910368$require$isSpace(secondCh)) return false;
    while(pos < state.eMarks[nextLine]){
        ch = state.src.charCodeAt(pos);
        if (ch !== 0x7C /* | */  && ch !== 0x2D /* - */  && ch !== 0x3A /* : */  && !$4ccb918515910368$require$isSpace(ch)) return false;
        pos++;
    }
    lineText = $4ccb918515910368$var$getLine(state, startLine + 1);
    columns = lineText.split('|');
    aligns = [];
    for(i = 0; i < columns.length; i++){
        t = columns[i].trim();
        if (!t) {
            // allow empty columns before and after table, but not in between columns;
            // e.g. allow ` |---| `, disallow ` ---||--- `
            if (i === 0 || i === columns.length - 1) continue;
            else return false;
        }
        if (!/^:?-+:?$/.test(t)) return false;
        if (t.charCodeAt(t.length - 1) === 0x3A /* : */ ) aligns.push(t.charCodeAt(0) === 0x3A /* : */  ? 'center' : 'right');
        else if (t.charCodeAt(0) === 0x3A /* : */ ) aligns.push('left');
        else aligns.push('');
    }
    lineText = $4ccb918515910368$var$getLine(state, startLine).trim();
    if (lineText.indexOf('|') === -1) return false;
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    columns = $4ccb918515910368$var$escapedSplit(lineText);
    if (columns.length && columns[0] === '') columns.shift();
    if (columns.length && columns[columns.length - 1] === '') columns.pop();
    // header row will define an amount of columns in the entire table,
    // and align row should be exactly the same (the rest of the rows can differ)
    columnCount = columns.length;
    if (columnCount === 0 || columnCount !== aligns.length) return false;
    if (silent) return true;
    oldParentType = state.parentType;
    state.parentType = 'table';
    // use 'blockquote' lists for termination because it's
    // the most similar to tables
    terminatorRules = state.md.block.ruler.getRules('blockquote');
    token = state.push('table_open', 'table', 1);
    token.map = tableLines = [
        startLine,
        0
    ];
    token = state.push('thead_open', 'thead', 1);
    token.map = [
        startLine,
        startLine + 1
    ];
    token = state.push('tr_open', 'tr', 1);
    token.map = [
        startLine,
        startLine + 1
    ];
    for(i = 0; i < columns.length; i++){
        token = state.push('th_open', 'th', 1);
        if (aligns[i]) token.attrs = [
            [
                'style',
                'text-align:' + aligns[i]
            ]
        ];
        token = state.push('inline', '', 0);
        token.content = columns[i].trim();
        token.children = [];
        token = state.push('th_close', 'th', -1);
    }
    token = state.push('tr_close', 'tr', -1);
    token = state.push('thead_close', 'thead', -1);
    for(nextLine = startLine + 2; nextLine < endLine; nextLine++){
        if (state.sCount[nextLine] < state.blkIndent) break;
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
        lineText = $4ccb918515910368$var$getLine(state, nextLine).trim();
        if (!lineText) break;
        if (state.sCount[nextLine] - state.blkIndent >= 4) break;
        columns = $4ccb918515910368$var$escapedSplit(lineText);
        if (columns.length && columns[0] === '') columns.shift();
        if (columns.length && columns[columns.length - 1] === '') columns.pop();
        if (nextLine === startLine + 2) {
            token = state.push('tbody_open', 'tbody', 1);
            token.map = tbodyLines = [
                startLine + 2,
                0
            ];
        }
        token = state.push('tr_open', 'tr', 1);
        token.map = [
            nextLine,
            nextLine + 1
        ];
        for(i = 0; i < columnCount; i++){
            token = state.push('td_open', 'td', 1);
            if (aligns[i]) token.attrs = [
                [
                    'style',
                    'text-align:' + aligns[i]
                ]
            ];
            token = state.push('inline', '', 0);
            token.content = columns[i] ? columns[i].trim() : '';
            token.children = [];
            token = state.push('td_close', 'td', -1);
        }
        token = state.push('tr_close', 'tr', -1);
    }
    if (tbodyLines) {
        token = state.push('tbody_close', 'tbody', -1);
        tbodyLines[1] = nextLine;
    }
    token = state.push('table_close', 'table', -1);
    tableLines[1] = nextLine;
    state.parentType = oldParentType;
    state.line = nextLine;
    return true;
};

});

parcelRegister("emojL", function(module, exports) {
// Code block (4 spaces padded)
'use strict';
module.exports = function code(state, startLine, endLine /*, silent*/ ) {
    var nextLine, last, token;
    if (state.sCount[startLine] - state.blkIndent < 4) return false;
    last = nextLine = startLine + 1;
    while(nextLine < endLine){
        if (state.isEmpty(nextLine)) {
            nextLine++;
            continue;
        }
        if (state.sCount[nextLine] - state.blkIndent >= 4) {
            nextLine++;
            last = nextLine;
            continue;
        }
        break;
    }
    state.line = last;
    token = state.push('code_block', 'code', 0);
    token.content = state.getLines(startLine, last, 4 + state.blkIndent, false) + '\n';
    token.map = [
        startLine,
        state.line
    ];
    return true;
};

});

parcelRegister("fv8TY", function(module, exports) {
// fences (``` lang, ~~~ lang)
'use strict';
module.exports = function fence(state, startLine, endLine, silent) {
    var marker, len, params, nextLine, mem, token, markup, haveEndMarker = false, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (pos + 3 > max) return false;
    marker = state.src.charCodeAt(pos);
    if (marker !== 0x7E /* ~ */  && marker !== 0x60 /* ` */ ) return false;
    // scan marker length
    mem = pos;
    pos = state.skipChars(pos, marker);
    len = pos - mem;
    if (len < 3) return false;
    markup = state.src.slice(mem, pos);
    params = state.src.slice(pos, max);
    if (marker === 0x60 /* ` */ ) {
        if (params.indexOf(String.fromCharCode(marker)) >= 0) return false;
    }
    // Since start is found, we can report success here in validation mode
    if (silent) return true;
    // search end of block
    nextLine = startLine;
    for(;;){
        nextLine++;
        if (nextLine >= endLine) break;
        pos = mem = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        if (pos < max && state.sCount[nextLine] < state.blkIndent) break;
        if (state.src.charCodeAt(pos) !== marker) continue;
        if (state.sCount[nextLine] - state.blkIndent >= 4) continue;
        pos = state.skipChars(pos, marker);
        // closing code fence must be at least as long as the opening one
        if (pos - mem < len) continue;
        // make sure tail has spaces only
        pos = state.skipSpaces(pos);
        if (pos < max) continue;
        haveEndMarker = true;
        break;
    }
    // If a fence has heading spaces, they should be removed from its inner block
    len = state.sCount[startLine];
    state.line = nextLine + (haveEndMarker ? 1 : 0);
    token = state.push('fence', 'code', 0);
    token.info = params;
    token.content = state.getLines(startLine + 1, nextLine, len, true);
    token.markup = markup;
    token.map = [
        startLine,
        state.line
    ];
    return true;
};

});

parcelRegister("aWlef", function(module, exports) {
// Block quotes
'use strict';

var $l6IUK = parcelRequire("l6IUK");
var $7f6fc9bcbb1c78c0$require$isSpace = $l6IUK.isSpace;
module.exports = function blockquote(state, startLine, endLine, silent) {
    var adjustTab, ch, i, initial, l, lastLineEmpty, lines, nextLine, offset, oldBMarks, oldBSCount, oldIndent, oldParentType, oldSCount, oldTShift, spaceAfterMarker, terminate, terminatorRules, token, isOutdented, oldLineMax = state.lineMax, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    // check the block quote marker
    if (state.src.charCodeAt(pos) !== 0x3E /* > */ ) return false;
    // we know that it's going to be a valid blockquote,
    // so no point trying to find the end of it in silent mode
    if (silent) return true;
    oldBMarks = [];
    oldBSCount = [];
    oldSCount = [];
    oldTShift = [];
    terminatorRules = state.md.block.ruler.getRules('blockquote');
    oldParentType = state.parentType;
    state.parentType = 'blockquote';
    // Search the end of the block
    //
    // Block ends with either:
    //  1. an empty line outside:
    //     ```
    //     > test
    //
    //     ```
    //  2. an empty line inside:
    //     ```
    //     >
    //     test
    //     ```
    //  3. another tag:
    //     ```
    //     > test
    //      - - -
    //     ```
    for(nextLine = startLine; nextLine < endLine; nextLine++){
        // check if it's outdented, i.e. it's inside list item and indented
        // less than said list item:
        //
        // ```
        // 1. anything
        //    > current blockquote
        // 2. checking this line
        // ```
        isOutdented = state.sCount[nextLine] < state.blkIndent;
        pos = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        if (pos >= max) break;
        if (state.src.charCodeAt(pos++) === 0x3E /* > */  && !isOutdented) {
            // This line is inside the blockquote.
            // set offset past spaces and ">"
            initial = state.sCount[nextLine] + 1;
            // skip one optional space after '>'
            if (state.src.charCodeAt(pos) === 0x20 /* space */ ) {
                // ' >   test '
                //     ^ -- position start of line here:
                pos++;
                initial++;
                adjustTab = false;
                spaceAfterMarker = true;
            } else if (state.src.charCodeAt(pos) === 0x09 /* tab */ ) {
                spaceAfterMarker = true;
                if ((state.bsCount[nextLine] + initial) % 4 === 3) {
                    // '  >\t  test '
                    //       ^ -- position start of line here (tab has width===1)
                    pos++;
                    initial++;
                    adjustTab = false;
                } else // ' >\t  test '
                //    ^ -- position start of line here + shift bsCount slightly
                //         to make extra space appear
                adjustTab = true;
            } else spaceAfterMarker = false;
            offset = initial;
            oldBMarks.push(state.bMarks[nextLine]);
            state.bMarks[nextLine] = pos;
            while(pos < max){
                ch = state.src.charCodeAt(pos);
                if ($7f6fc9bcbb1c78c0$require$isSpace(ch)) {
                    if (ch === 0x09) offset += 4 - (offset + state.bsCount[nextLine] + (adjustTab ? 1 : 0)) % 4;
                    else offset++;
                } else break;
                pos++;
            }
            lastLineEmpty = pos >= max;
            oldBSCount.push(state.bsCount[nextLine]);
            state.bsCount[nextLine] = state.sCount[nextLine] + 1 + (spaceAfterMarker ? 1 : 0);
            oldSCount.push(state.sCount[nextLine]);
            state.sCount[nextLine] = offset - initial;
            oldTShift.push(state.tShift[nextLine]);
            state.tShift[nextLine] = pos - state.bMarks[nextLine];
            continue;
        }
        // Case 2: line is not inside the blockquote, and the last line was empty.
        if (lastLineEmpty) break;
        // Case 3: another tag found.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) {
            // Quirk to enforce "hard termination mode" for paragraphs;
            // normally if you call `tokenize(state, startLine, nextLine)`,
            // paragraphs will look below nextLine for paragraph continuation,
            // but if blockquote is terminated by another tag, they shouldn't
            state.lineMax = nextLine;
            if (state.blkIndent !== 0) {
                // state.blkIndent was non-zero, we now set it to zero,
                // so we need to re-calculate all offsets to appear as
                // if indent wasn't changed
                oldBMarks.push(state.bMarks[nextLine]);
                oldBSCount.push(state.bsCount[nextLine]);
                oldTShift.push(state.tShift[nextLine]);
                oldSCount.push(state.sCount[nextLine]);
                state.sCount[nextLine] -= state.blkIndent;
            }
            break;
        }
        oldBMarks.push(state.bMarks[nextLine]);
        oldBSCount.push(state.bsCount[nextLine]);
        oldTShift.push(state.tShift[nextLine]);
        oldSCount.push(state.sCount[nextLine]);
        // A negative indentation means that this is a paragraph continuation
        //
        state.sCount[nextLine] = -1;
    }
    oldIndent = state.blkIndent;
    state.blkIndent = 0;
    token = state.push('blockquote_open', 'blockquote', 1);
    token.markup = '>';
    token.map = lines = [
        startLine,
        0
    ];
    state.md.block.tokenize(state, startLine, nextLine);
    token = state.push('blockquote_close', 'blockquote', -1);
    token.markup = '>';
    state.lineMax = oldLineMax;
    state.parentType = oldParentType;
    lines[1] = state.line;
    // Restore original tShift; this might not be necessary since the parser
    // has already been here, but just to make sure we can do that.
    for(i = 0; i < oldTShift.length; i++){
        state.bMarks[i + startLine] = oldBMarks[i];
        state.tShift[i + startLine] = oldTShift[i];
        state.sCount[i + startLine] = oldSCount[i];
        state.bsCount[i + startLine] = oldBSCount[i];
    }
    state.blkIndent = oldIndent;
    return true;
};

});

parcelRegister("7dy3H", function(module, exports) {
// Horizontal rule
'use strict';

var $l6IUK = parcelRequire("l6IUK");
var $54142a9f38955a51$require$isSpace = $l6IUK.isSpace;
module.exports = function hr(state, startLine, endLine, silent) {
    var marker, cnt, ch, token, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    marker = state.src.charCodeAt(pos++);
    // Check hr marker
    if (marker !== 0x2A /* * */  && marker !== 0x2D /* - */  && marker !== 0x5F /* _ */ ) return false;
    // markers can be mixed with spaces, but there should be at least 3 of them
    cnt = 1;
    while(pos < max){
        ch = state.src.charCodeAt(pos++);
        if (ch !== marker && !$54142a9f38955a51$require$isSpace(ch)) return false;
        if (ch === marker) cnt++;
    }
    if (cnt < 3) return false;
    if (silent) return true;
    state.line = startLine + 1;
    token = state.push('hr', 'hr', 0);
    token.map = [
        startLine,
        state.line
    ];
    token.markup = Array(cnt + 1).join(String.fromCharCode(marker));
    return true;
};

});

parcelRegister("6LEge", function(module, exports) {
// Lists
'use strict';

var $l6IUK = parcelRequire("l6IUK");
var $4ed65cd7115d0dcb$require$isSpace = $l6IUK.isSpace;
// Search `[-+*][\n ]`, returns next pos after marker on success
// or -1 on fail.
function $4ed65cd7115d0dcb$var$skipBulletListMarker(state, startLine) {
    var marker, pos, max, ch;
    pos = state.bMarks[startLine] + state.tShift[startLine];
    max = state.eMarks[startLine];
    marker = state.src.charCodeAt(pos++);
    // Check bullet
    if (marker !== 0x2A /* * */  && marker !== 0x2D /* - */  && marker !== 0x2B /* + */ ) return -1;
    if (pos < max) {
        ch = state.src.charCodeAt(pos);
        if (!$4ed65cd7115d0dcb$require$isSpace(ch)) // " -test " - is not a list item
        return -1;
    }
    return pos;
}
// Search `\d+[.)][\n ]`, returns next pos after marker on success
// or -1 on fail.
function $4ed65cd7115d0dcb$var$skipOrderedListMarker(state, startLine) {
    var ch, start = state.bMarks[startLine] + state.tShift[startLine], pos = start, max = state.eMarks[startLine];
    // List marker should have at least 2 chars (digit + dot)
    if (pos + 1 >= max) return -1;
    ch = state.src.charCodeAt(pos++);
    if (ch < 0x30 /* 0 */  || ch > 0x39 /* 9 */ ) return -1;
    for(;;){
        // EOL -> fail
        if (pos >= max) return -1;
        ch = state.src.charCodeAt(pos++);
        if (ch >= 0x30 /* 0 */  && ch <= 0x39 /* 9 */ ) {
            // List marker should have no more than 9 digits
            // (prevents integer overflow in browsers)
            if (pos - start >= 10) return -1;
            continue;
        }
        // found valid marker
        if (ch === 0x29 /* ) */  || ch === 0x2e /* . */ ) break;
        return -1;
    }
    if (pos < max) {
        ch = state.src.charCodeAt(pos);
        if (!$4ed65cd7115d0dcb$require$isSpace(ch)) // " 1.test " - is not a list item
        return -1;
    }
    return pos;
}
function $4ed65cd7115d0dcb$var$markTightParagraphs(state, idx) {
    var i, l, level = state.level + 2;
    for(i = idx + 2, l = state.tokens.length - 2; i < l; i++)if (state.tokens[i].level === level && state.tokens[i].type === 'paragraph_open') {
        state.tokens[i + 2].hidden = true;
        state.tokens[i].hidden = true;
        i += 2;
    }
}
module.exports = function list(state, startLine, endLine, silent) {
    var ch, contentStart, i, indent, indentAfterMarker, initial, isOrdered, itemLines, l, listLines, listTokIdx, markerCharCode, markerValue, max, offset, oldListIndent, oldParentType, oldSCount, oldTShift, oldTight, pos, posAfterMarker, prevEmptyEnd, start, terminate, terminatorRules, token, nextLine = startLine, isTerminatingParagraph = false, tight = true;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[nextLine] - state.blkIndent >= 4) return false;
    // Special case:
    //  - item 1
    //   - item 2
    //    - item 3
    //     - item 4
    //      - this one is a paragraph continuation
    if (state.listIndent >= 0 && state.sCount[nextLine] - state.listIndent >= 4 && state.sCount[nextLine] < state.blkIndent) return false;
    // limit conditions when list can interrupt
    // a paragraph (validation mode only)
    if (silent && state.parentType === 'paragraph') // Next list item should still terminate previous list item;
    //
    // This code can fail if plugins use blkIndent as well as lists,
    // but I hope the spec gets fixed long before that happens.
    //
    {
        if (state.sCount[nextLine] >= state.blkIndent) isTerminatingParagraph = true;
    }
    // Detect list type and position after marker
    if ((posAfterMarker = $4ed65cd7115d0dcb$var$skipOrderedListMarker(state, nextLine)) >= 0) {
        isOrdered = true;
        start = state.bMarks[nextLine] + state.tShift[nextLine];
        markerValue = Number(state.src.slice(start, posAfterMarker - 1));
        // If we're starting a new ordered list right after
        // a paragraph, it should start with 1.
        if (isTerminatingParagraph && markerValue !== 1) return false;
    } else if ((posAfterMarker = $4ed65cd7115d0dcb$var$skipBulletListMarker(state, nextLine)) >= 0) isOrdered = false;
    else return false;
    // If we're starting a new unordered list right after
    // a paragraph, first line should not be empty.
    if (isTerminatingParagraph) {
        if (state.skipSpaces(posAfterMarker) >= state.eMarks[nextLine]) return false;
    }
    // For validation mode we can terminate immediately
    if (silent) return true;
    // We should terminate list on style change. Remember first one to compare.
    markerCharCode = state.src.charCodeAt(posAfterMarker - 1);
    // Start list
    listTokIdx = state.tokens.length;
    if (isOrdered) {
        token = state.push('ordered_list_open', 'ol', 1);
        if (markerValue !== 1) token.attrs = [
            [
                'start',
                markerValue
            ]
        ];
    } else token = state.push('bullet_list_open', 'ul', 1);
    token.map = listLines = [
        nextLine,
        0
    ];
    token.markup = String.fromCharCode(markerCharCode);
    //
    // Iterate list items
    //
    prevEmptyEnd = false;
    terminatorRules = state.md.block.ruler.getRules('list');
    oldParentType = state.parentType;
    state.parentType = 'list';
    while(nextLine < endLine){
        pos = posAfterMarker;
        max = state.eMarks[nextLine];
        initial = offset = state.sCount[nextLine] + posAfterMarker - (state.bMarks[nextLine] + state.tShift[nextLine]);
        while(pos < max){
            ch = state.src.charCodeAt(pos);
            if (ch === 0x09) offset += 4 - (offset + state.bsCount[nextLine]) % 4;
            else if (ch === 0x20) offset++;
            else break;
            pos++;
        }
        contentStart = pos;
        if (contentStart >= max) // trimming space in "-    \n  3" case, indent is 1 here
        indentAfterMarker = 1;
        else indentAfterMarker = offset - initial;
        // If we have more than 4 spaces, the indent is 1
        // (the rest is just indented code block)
        if (indentAfterMarker > 4) indentAfterMarker = 1;
        // "  -  test"
        //  ^^^^^ - calculating total length of this thing
        indent = initial + indentAfterMarker;
        // Run subparser & write tokens
        token = state.push('list_item_open', 'li', 1);
        token.markup = String.fromCharCode(markerCharCode);
        token.map = itemLines = [
            nextLine,
            0
        ];
        if (isOrdered) token.info = state.src.slice(start, posAfterMarker - 1);
        // change current state, then restore it after parser subcall
        oldTight = state.tight;
        oldTShift = state.tShift[nextLine];
        oldSCount = state.sCount[nextLine];
        //  - example list
        // ^ listIndent position will be here
        //   ^ blkIndent position will be here
        //
        oldListIndent = state.listIndent;
        state.listIndent = state.blkIndent;
        state.blkIndent = indent;
        state.tight = true;
        state.tShift[nextLine] = contentStart - state.bMarks[nextLine];
        state.sCount[nextLine] = offset;
        if (contentStart >= max && state.isEmpty(nextLine + 1)) // workaround for this case
        // (list item is empty, list terminates before "foo"):
        // ~~~~~~~~
        //   -
        //
        //     foo
        // ~~~~~~~~
        state.line = Math.min(state.line + 2, endLine);
        else state.md.block.tokenize(state, nextLine, endLine, true);
        // If any of list item is tight, mark list as tight
        if (!state.tight || prevEmptyEnd) tight = false;
        // Item become loose if finish with empty line,
        // but we should filter last element, because it means list finish
        prevEmptyEnd = state.line - nextLine > 1 && state.isEmpty(state.line - 1);
        state.blkIndent = state.listIndent;
        state.listIndent = oldListIndent;
        state.tShift[nextLine] = oldTShift;
        state.sCount[nextLine] = oldSCount;
        state.tight = oldTight;
        token = state.push('list_item_close', 'li', -1);
        token.markup = String.fromCharCode(markerCharCode);
        nextLine = state.line;
        itemLines[1] = nextLine;
        if (nextLine >= endLine) break;
        //
        // Try to check if list is terminated or continued.
        //
        if (state.sCount[nextLine] < state.blkIndent) break;
        // if it's indented more than 3 spaces, it should be a code block
        if (state.sCount[nextLine] - state.blkIndent >= 4) break;
        // fail if terminating block found
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
        // fail if list has another type
        if (isOrdered) {
            posAfterMarker = $4ed65cd7115d0dcb$var$skipOrderedListMarker(state, nextLine);
            if (posAfterMarker < 0) break;
            start = state.bMarks[nextLine] + state.tShift[nextLine];
        } else {
            posAfterMarker = $4ed65cd7115d0dcb$var$skipBulletListMarker(state, nextLine);
            if (posAfterMarker < 0) break;
        }
        if (markerCharCode !== state.src.charCodeAt(posAfterMarker - 1)) break;
    }
    // Finalize list
    if (isOrdered) token = state.push('ordered_list_close', 'ol', -1);
    else token = state.push('bullet_list_close', 'ul', -1);
    token.markup = String.fromCharCode(markerCharCode);
    listLines[1] = nextLine;
    state.line = nextLine;
    state.parentType = oldParentType;
    // mark paragraphs tight if needed
    if (tight) $4ed65cd7115d0dcb$var$markTightParagraphs(state, listTokIdx);
    return true;
};

});

parcelRegister("14Fj0", function(module, exports) {
'use strict';

var $l6IUK = parcelRequire("l6IUK");
var $0c86349554c3af5f$require$normalizeReference = $l6IUK.normalizeReference;

var $l6IUK = parcelRequire("l6IUK");
var $0c86349554c3af5f$require$isSpace = $l6IUK.isSpace;
module.exports = function reference(state, startLine, _endLine, silent) {
    var ch, destEndPos, destEndLineNo, endLine, href, i, l, label, labelEnd, oldParentType, res, start, str, terminate, terminatorRules, title, lines = 0, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine], nextLine = startLine + 1;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (state.src.charCodeAt(pos) !== 0x5B /* [ */ ) return false;
    // Simple check to quickly interrupt scan on [link](url) at the start of line.
    // Can be useful on practice: https://github.com/markdown-it/markdown-it/issues/54
    while(++pos < max)if (state.src.charCodeAt(pos) === 0x5D /* ] */  && state.src.charCodeAt(pos - 1) !== 0x5C /* \ */ ) {
        if (pos + 1 === max) return false;
        if (state.src.charCodeAt(pos + 1) !== 0x3A /* : */ ) return false;
        break;
    }
    endLine = state.lineMax;
    // jump line-by-line until empty one or EOF
    terminatorRules = state.md.block.ruler.getRules('reference');
    oldParentType = state.parentType;
    state.parentType = 'reference';
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    str = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    max = str.length;
    for(pos = 1; pos < max; pos++){
        ch = str.charCodeAt(pos);
        if (ch === 0x5B /* [ */ ) return false;
        else if (ch === 0x5D /* ] */ ) {
            labelEnd = pos;
            break;
        } else if (ch === 0x0A /* \n */ ) lines++;
        else if (ch === 0x5C /* \ */ ) {
            pos++;
            if (pos < max && str.charCodeAt(pos) === 0x0A) lines++;
        }
    }
    if (labelEnd < 0 || str.charCodeAt(labelEnd + 1) !== 0x3A /* : */ ) return false;
    // [label]:   destination   'title'
    //         ^^^ skip optional whitespace here
    for(pos = labelEnd + 2; pos < max; pos++){
        ch = str.charCodeAt(pos);
        if (ch === 0x0A) lines++;
        else if ($0c86349554c3af5f$require$isSpace(ch)) ;
        else break;
    }
    // [label]:   destination   'title'
    //            ^^^^^^^^^^^ parse this
    res = state.md.helpers.parseLinkDestination(str, pos, max);
    if (!res.ok) return false;
    href = state.md.normalizeLink(res.str);
    if (!state.md.validateLink(href)) return false;
    pos = res.pos;
    lines += res.lines;
    // save cursor state, we could require to rollback later
    destEndPos = pos;
    destEndLineNo = lines;
    // [label]:   destination   'title'
    //                       ^^^ skipping those spaces
    start = pos;
    for(; pos < max; pos++){
        ch = str.charCodeAt(pos);
        if (ch === 0x0A) lines++;
        else if ($0c86349554c3af5f$require$isSpace(ch)) ;
        else break;
    }
    // [label]:   destination   'title'
    //                          ^^^^^^^ parse this
    res = state.md.helpers.parseLinkTitle(str, pos, max);
    if (pos < max && start !== pos && res.ok) {
        title = res.str;
        pos = res.pos;
        lines += res.lines;
    } else {
        title = '';
        pos = destEndPos;
        lines = destEndLineNo;
    }
    // skip trailing spaces until the rest of the line
    while(pos < max){
        ch = str.charCodeAt(pos);
        if (!$0c86349554c3af5f$require$isSpace(ch)) break;
        pos++;
    }
    if (pos < max && str.charCodeAt(pos) !== 0x0A) {
        if (title) {
            // garbage at the end of the line after title,
            // but it could still be a valid reference if we roll back
            title = '';
            pos = destEndPos;
            lines = destEndLineNo;
            while(pos < max){
                ch = str.charCodeAt(pos);
                if (!$0c86349554c3af5f$require$isSpace(ch)) break;
                pos++;
            }
        }
    }
    if (pos < max && str.charCodeAt(pos) !== 0x0A) // garbage at the end of the line
    return false;
    label = $0c86349554c3af5f$require$normalizeReference(str.slice(1, labelEnd));
    if (!label) // CommonMark 0.20 disallows empty labels
    return false;
    // Reference can not terminate anything. This check is for safety only.
    /*istanbul ignore if*/ if (silent) return true;
    if (typeof state.env.references === 'undefined') state.env.references = {};
    if (typeof state.env.references[label] === 'undefined') state.env.references[label] = {
        title: title,
        href: href
    };
    state.parentType = oldParentType;
    state.line = startLine + lines + 1;
    return true;
};

});

parcelRegister("agiT5", function(module, exports) {
// HTML block
'use strict';

var $5Ihfj = parcelRequire("5Ihfj");

var $0dDBY = parcelRequire("0dDBY");
var $778a0ca53406637a$require$HTML_OPEN_CLOSE_TAG_RE = $0dDBY.HTML_OPEN_CLOSE_TAG_RE;
// An array of opening and corresponding closing sequences for html tags,
// last argument defines whether it can terminate a paragraph or not
//
var $778a0ca53406637a$var$HTML_SEQUENCES = [
    [
        /^<(script|pre|style|textarea)(?=(\s|>|$))/i,
        /<\/(script|pre|style|textarea)>/i,
        true
    ],
    [
        /^<!--/,
        /-->/,
        true
    ],
    [
        /^<\?/,
        /\?>/,
        true
    ],
    [
        /^<![A-Z]/,
        />/,
        true
    ],
    [
        /^<!\[CDATA\[/,
        /\]\]>/,
        true
    ],
    [
        new RegExp('^</?(' + $5Ihfj.join('|') + ')(?=(\\s|/?>|$))', 'i'),
        /^$/,
        true
    ],
    [
        new RegExp($778a0ca53406637a$require$HTML_OPEN_CLOSE_TAG_RE.source + '\\s*$'),
        /^$/,
        false
    ]
];
module.exports = function html_block(state, startLine, endLine, silent) {
    var i, nextLine, token, lineText, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (!state.md.options.html) return false;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */ ) return false;
    lineText = state.src.slice(pos, max);
    for(i = 0; i < $778a0ca53406637a$var$HTML_SEQUENCES.length; i++){
        if ($778a0ca53406637a$var$HTML_SEQUENCES[i][0].test(lineText)) break;
    }
    if (i === $778a0ca53406637a$var$HTML_SEQUENCES.length) return false;
    if (silent) // true if this sequence can be a terminator, false otherwise
    return $778a0ca53406637a$var$HTML_SEQUENCES[i][2];
    nextLine = startLine + 1;
    // If we are here - we detected HTML block.
    // Let's roll down till block end.
    if (!$778a0ca53406637a$var$HTML_SEQUENCES[i][1].test(lineText)) for(; nextLine < endLine; nextLine++){
        if (state.sCount[nextLine] < state.blkIndent) break;
        pos = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        lineText = state.src.slice(pos, max);
        if ($778a0ca53406637a$var$HTML_SEQUENCES[i][1].test(lineText)) {
            if (lineText.length !== 0) nextLine++;
            break;
        }
    }
    state.line = nextLine;
    token = state.push('html_block', '', 0);
    token.map = [
        startLine,
        nextLine
    ];
    token.content = state.getLines(startLine, nextLine, state.blkIndent, true);
    return true;
};

});
parcelRegister("5Ihfj", function(module, exports) {
// List of valid html blocks names, accorting to commonmark spec
// http://jgm.github.io/CommonMark/spec.html#html-blocks
'use strict';
module.exports = [
    'address',
    'article',
    'aside',
    'base',
    'basefont',
    'blockquote',
    'body',
    'caption',
    'center',
    'col',
    'colgroup',
    'dd',
    'details',
    'dialog',
    'dir',
    'div',
    'dl',
    'dt',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'frame',
    'frameset',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hr',
    'html',
    'iframe',
    'legend',
    'li',
    'link',
    'main',
    'menu',
    'menuitem',
    'nav',
    'noframes',
    'ol',
    'optgroup',
    'option',
    'p',
    'param',
    'section',
    'source',
    'summary',
    'table',
    'tbody',
    'td',
    'tfoot',
    'th',
    'thead',
    'title',
    'tr',
    'track',
    'ul'
];

});

parcelRegister("0dDBY", function(module, exports) {

$parcel$export(module.exports, "HTML_TAG_RE", () => $000a94675f760217$export$6db61d2c3a16e419, (v) => $000a94675f760217$export$6db61d2c3a16e419 = v);
$parcel$export(module.exports, "HTML_OPEN_CLOSE_TAG_RE", () => $000a94675f760217$export$cd48660d06f74639, (v) => $000a94675f760217$export$cd48660d06f74639 = v);
// Regexps to match html elements
var $000a94675f760217$export$6db61d2c3a16e419;
var $000a94675f760217$export$cd48660d06f74639;
'use strict';
var $000a94675f760217$var$attr_name = '[a-zA-Z_:][a-zA-Z0-9:._-]*';
var $000a94675f760217$var$unquoted = '[^"\'=<>`\\x00-\\x20]+';
var $000a94675f760217$var$single_quoted = "'[^']*'";
var $000a94675f760217$var$double_quoted = '"[^"]*"';
var $000a94675f760217$var$attr_value = '(?:' + $000a94675f760217$var$unquoted + '|' + $000a94675f760217$var$single_quoted + '|' + $000a94675f760217$var$double_quoted + ')';
var $000a94675f760217$var$attribute = '(?:\\s+' + $000a94675f760217$var$attr_name + '(?:\\s*=\\s*' + $000a94675f760217$var$attr_value + ')?)';
var $000a94675f760217$var$open_tag = '<[A-Za-z][A-Za-z0-9\\-]*' + $000a94675f760217$var$attribute + '*\\s*\\/?>';
var $000a94675f760217$var$close_tag = '<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>';
var $000a94675f760217$var$comment = '<!---->|<!--(?:-?[^>-])(?:-?[^-])*-->';
var $000a94675f760217$var$processing = '<[?][\\s\\S]*?[?]>';
var $000a94675f760217$var$declaration = '<![A-Z]+\\s+[^>]*>';
var $000a94675f760217$var$cdata = '<!\\[CDATA\\[[\\s\\S]*?\\]\\]>';
var $000a94675f760217$var$HTML_TAG_RE = new RegExp('^(?:' + $000a94675f760217$var$open_tag + '|' + $000a94675f760217$var$close_tag + '|' + $000a94675f760217$var$comment + '|' + $000a94675f760217$var$processing + '|' + $000a94675f760217$var$declaration + '|' + $000a94675f760217$var$cdata + ')');
var $000a94675f760217$var$HTML_OPEN_CLOSE_TAG_RE = new RegExp('^(?:' + $000a94675f760217$var$open_tag + '|' + $000a94675f760217$var$close_tag + ')');
$000a94675f760217$export$6db61d2c3a16e419 = $000a94675f760217$var$HTML_TAG_RE;
$000a94675f760217$export$cd48660d06f74639 = $000a94675f760217$var$HTML_OPEN_CLOSE_TAG_RE;

});


parcelRegister("9FRBG", function(module, exports) {
// heading (#, ##, ...)
'use strict';

var $l6IUK = parcelRequire("l6IUK");
var $70b18692c05fad89$require$isSpace = $l6IUK.isSpace;
module.exports = function heading(state, startLine, endLine, silent) {
    var ch, level, tmp, token, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    ch = state.src.charCodeAt(pos);
    if (ch !== 0x23 /* # */  || pos >= max) return false;
    // count heading level
    level = 1;
    ch = state.src.charCodeAt(++pos);
    while(ch === 0x23 /* # */  && pos < max && level <= 6){
        level++;
        ch = state.src.charCodeAt(++pos);
    }
    if (level > 6 || pos < max && !$70b18692c05fad89$require$isSpace(ch)) return false;
    if (silent) return true;
    // Let's cut tails like '    ###  ' from the end of string
    max = state.skipSpacesBack(max, pos);
    tmp = state.skipCharsBack(max, 0x23, pos); // #
    if (tmp > pos && $70b18692c05fad89$require$isSpace(state.src.charCodeAt(tmp - 1))) max = tmp;
    state.line = startLine + 1;
    token = state.push('heading_open', 'h' + String(level), 1);
    token.markup = '########'.slice(0, level);
    token.map = [
        startLine,
        state.line
    ];
    token = state.push('inline', '', 0);
    token.content = state.src.slice(pos, max).trim();
    token.map = [
        startLine,
        state.line
    ];
    token.children = [];
    token = state.push('heading_close', 'h' + String(level), -1);
    token.markup = '########'.slice(0, level);
    return true;
};

});

parcelRegister("aKAqI", function(module, exports) {
// lheading (---, ===)
'use strict';
module.exports = function lheading(state, startLine, endLine /*, silent*/ ) {
    var content, terminate, i, l, token, pos, max, level, marker, nextLine = startLine + 1, oldParentType, terminatorRules = state.md.block.ruler.getRules('paragraph');
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    oldParentType = state.parentType;
    state.parentType = 'paragraph'; // use paragraph to match terminatorRules
    // jump line-by-line until empty one or EOF
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        //
        // Check for underline in setext header
        //
        if (state.sCount[nextLine] >= state.blkIndent) {
            pos = state.bMarks[nextLine] + state.tShift[nextLine];
            max = state.eMarks[nextLine];
            if (pos < max) {
                marker = state.src.charCodeAt(pos);
                if (marker === 0x2D /* - */  || marker === 0x3D /* = */ ) {
                    pos = state.skipChars(pos, marker);
                    pos = state.skipSpaces(pos);
                    if (pos >= max) {
                        level = marker === 0x3D /* = */  ? 1 : 2;
                        break;
                    }
                }
            }
        }
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    if (!level) // Didn't find valid underline
    return false;
    content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    state.line = nextLine + 1;
    token = state.push('heading_open', 'h' + String(level), 1);
    token.markup = String.fromCharCode(marker);
    token.map = [
        startLine,
        state.line
    ];
    token = state.push('inline', '', 0);
    token.content = content;
    token.map = [
        startLine,
        state.line - 1
    ];
    token.children = [];
    token = state.push('heading_close', 'h' + String(level), -1);
    token.markup = String.fromCharCode(marker);
    state.parentType = oldParentType;
    return true;
};

});

parcelRegister("7QU8N", function(module, exports) {
// Paragraph
'use strict';
module.exports = function paragraph(state, startLine, endLine) {
    var content, terminate, i, l, token, oldParentType, nextLine = startLine + 1, terminatorRules = state.md.block.ruler.getRules('paragraph');
    oldParentType = state.parentType;
    state.parentType = 'paragraph';
    // jump line-by-line until empty one or EOF
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    state.line = nextLine;
    token = state.push('paragraph_open', 'p', 1);
    token.map = [
        startLine,
        state.line
    ];
    token = state.push('inline', '', 0);
    token.content = content;
    token.map = [
        startLine,
        state.line
    ];
    token.children = [];
    token = state.push('paragraph_close', 'p', -1);
    state.parentType = oldParentType;
    return true;
};

});

parcelRegister("4ASdB", function(module, exports) {
// Parser state class
'use strict';

var $8AILn = parcelRequire("8AILn");

var $l6IUK = parcelRequire("l6IUK");
var $358494e0e5c813f5$require$isSpace = $l6IUK.isSpace;
function $358494e0e5c813f5$var$StateBlock(src, md, env, tokens) {
    var ch, s, start, pos, len, indent, offset, indent_found;
    this.src = src;
    // link to parser instance
    this.md = md;
    this.env = env;
    //
    // Internal state vartiables
    //
    this.tokens = tokens;
    this.bMarks = []; // line begin offsets for fast jumps
    this.eMarks = []; // line end offsets for fast jumps
    this.tShift = []; // offsets of the first non-space characters (tabs not expanded)
    this.sCount = []; // indents for each line (tabs expanded)
    // An amount of virtual spaces (tabs expanded) between beginning
    // of each line (bMarks) and real beginning of that line.
    //
    // It exists only as a hack because blockquotes override bMarks
    // losing information in the process.
    //
    // It's used only when expanding tabs, you can think about it as
    // an initial tab length, e.g. bsCount=21 applied to string `\t123`
    // means first tab should be expanded to 4-21%4 === 3 spaces.
    //
    this.bsCount = [];
    // block parser variables
    this.blkIndent = 0; // required block content indent (for example, if we are
    // inside a list, it would be positioned after list marker)
    this.line = 0; // line index in src
    this.lineMax = 0; // lines count
    this.tight = false; // loose/tight mode for lists
    this.ddIndent = -1; // indent of the current dd block (-1 if there isn't any)
    this.listIndent = -1; // indent of the current list block (-1 if there isn't any)
    // can be 'blockquote', 'list', 'root', 'paragraph' or 'reference'
    // used in lists to determine if they interrupt a paragraph
    this.parentType = 'root';
    this.level = 0;
    // renderer
    this.result = '';
    // Create caches
    // Generate markers.
    s = this.src;
    indent_found = false;
    for(start = pos = indent = offset = 0, len = s.length; pos < len; pos++){
        ch = s.charCodeAt(pos);
        if (!indent_found) {
            if ($358494e0e5c813f5$require$isSpace(ch)) {
                indent++;
                if (ch === 0x09) offset += 4 - offset % 4;
                else offset++;
                continue;
            } else indent_found = true;
        }
        if (ch === 0x0A || pos === len - 1) {
            if (ch !== 0x0A) pos++;
            this.bMarks.push(start);
            this.eMarks.push(pos);
            this.tShift.push(indent);
            this.sCount.push(offset);
            this.bsCount.push(0);
            indent_found = false;
            indent = 0;
            offset = 0;
            start = pos + 1;
        }
    }
    // Push fake entry to simplify cache bounds checks
    this.bMarks.push(s.length);
    this.eMarks.push(s.length);
    this.tShift.push(0);
    this.sCount.push(0);
    this.bsCount.push(0);
    this.lineMax = this.bMarks.length - 1; // don't count last fake line
}
// Push new token to "stream".
//
$358494e0e5c813f5$var$StateBlock.prototype.push = function(type, tag, nesting) {
    var token = new $8AILn(type, tag, nesting);
    token.block = true;
    if (nesting < 0) this.level--; // closing tag
    token.level = this.level;
    if (nesting > 0) this.level++; // opening tag
    this.tokens.push(token);
    return token;
};
$358494e0e5c813f5$var$StateBlock.prototype.isEmpty = function isEmpty(line) {
    return this.bMarks[line] + this.tShift[line] >= this.eMarks[line];
};
$358494e0e5c813f5$var$StateBlock.prototype.skipEmptyLines = function skipEmptyLines(from) {
    for(var max = this.lineMax; from < max; from++){
        if (this.bMarks[from] + this.tShift[from] < this.eMarks[from]) break;
    }
    return from;
};
// Skip spaces from given position.
$358494e0e5c813f5$var$StateBlock.prototype.skipSpaces = function skipSpaces(pos) {
    var ch;
    for(var max = this.src.length; pos < max; pos++){
        ch = this.src.charCodeAt(pos);
        if (!$358494e0e5c813f5$require$isSpace(ch)) break;
    }
    return pos;
};
// Skip spaces from given position in reverse.
$358494e0e5c813f5$var$StateBlock.prototype.skipSpacesBack = function skipSpacesBack(pos, min) {
    if (pos <= min) return pos;
    while(pos > min){
        if (!$358494e0e5c813f5$require$isSpace(this.src.charCodeAt(--pos))) return pos + 1;
    }
    return pos;
};
// Skip char codes from given position
$358494e0e5c813f5$var$StateBlock.prototype.skipChars = function skipChars(pos, code) {
    for(var max = this.src.length; pos < max; pos++){
        if (this.src.charCodeAt(pos) !== code) break;
    }
    return pos;
};
// Skip char codes reverse from given position - 1
$358494e0e5c813f5$var$StateBlock.prototype.skipCharsBack = function skipCharsBack(pos, code, min) {
    if (pos <= min) return pos;
    while(pos > min){
        if (code !== this.src.charCodeAt(--pos)) return pos + 1;
    }
    return pos;
};
// cut lines range from source.
$358494e0e5c813f5$var$StateBlock.prototype.getLines = function getLines(begin, end, indent, keepLastLF) {
    var i, lineIndent, ch, first, last, queue, lineStart, line = begin;
    if (begin >= end) return '';
    queue = new Array(end - begin);
    for(i = 0; line < end; line++, i++){
        lineIndent = 0;
        lineStart = first = this.bMarks[line];
        if (line + 1 < end || keepLastLF) // No need for bounds check because we have fake entry on tail.
        last = this.eMarks[line] + 1;
        else last = this.eMarks[line];
        while(first < last && lineIndent < indent){
            ch = this.src.charCodeAt(first);
            if ($358494e0e5c813f5$require$isSpace(ch)) {
                if (ch === 0x09) lineIndent += 4 - (lineIndent + this.bsCount[line]) % 4;
                else lineIndent++;
            } else if (first - lineStart < this.tShift[line]) // patched tShift masked characters to look like spaces (blockquotes, list markers)
            lineIndent++;
            else break;
            first++;
        }
        if (lineIndent > indent) // partially expanding tabs in code blocks, e.g '\t\tfoobar'
        // with indent=2 becomes '  \tfoobar'
        queue[i] = new Array(lineIndent - indent + 1).join(' ') + this.src.slice(first, last);
        else queue[i] = this.src.slice(first, last);
    }
    return queue.join('');
};
// re-export Token class to use in block rules
$358494e0e5c813f5$var$StateBlock.prototype.Token = $8AILn;
module.exports = $358494e0e5c813f5$var$StateBlock;

});


parcelRegister("hkcNh", function(module, exports) {
/** internal
 * class ParserInline
 *
 * Tokenizes paragraph content.
 **/ 'use strict';

var $c3dcz = parcelRequire("c3dcz");












////////////////////////////////////////////////////////////////////////////////
// Parser rules
var $c9ce3a88b0f025ea$var$_rules = [
    [
        'text',
        (parcelRequire("9CTc4"))
    ],
    [
        'linkify',
        (parcelRequire("2BswS"))
    ],
    [
        'newline',
        (parcelRequire("jE0nb"))
    ],
    [
        'escape',
        (parcelRequire("k9EFJ"))
    ],
    [
        'backticks',
        (parcelRequire("fC6en"))
    ],
    [
        'strikethrough',
        (parcelRequire("dT517")).tokenize
    ],
    [
        'emphasis',
        (parcelRequire("ji5vg")).tokenize
    ],
    [
        'link',
        (parcelRequire("7ZRUa"))
    ],
    [
        'image',
        (parcelRequire("3t7o6"))
    ],
    [
        'autolink',
        (parcelRequire("fyaCn"))
    ],
    [
        'html_inline',
        (parcelRequire("9M7vq"))
    ],
    [
        'entity',
        (parcelRequire("i1a7Z"))
    ]
];




// `rule2` ruleset was created specifically for emphasis/strikethrough
// post-processing and may be changed in the future.
//
// Don't use this for anything except pairs (plugins working with `balance_pairs`).
//
var $c9ce3a88b0f025ea$var$_rules2 = [
    [
        'balance_pairs',
        (parcelRequire("6FHxS"))
    ],
    [
        'strikethrough',
        (parcelRequire("dT517")).postProcess
    ],
    [
        'emphasis',
        (parcelRequire("ji5vg")).postProcess
    ],
    // rules for pairs separate '**' into its own text tokens, which may be left unused,
    // rule below merges unused segments back with the rest of the text
    [
        'fragments_join',
        (parcelRequire("9Rdip"))
    ]
];
/**
 * new ParserInline()
 **/ function $c9ce3a88b0f025ea$var$ParserInline() {
    var i;
    /**
   * ParserInline#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of inline rules.
   **/ this.ruler = new $c3dcz();
    for(i = 0; i < $c9ce3a88b0f025ea$var$_rules.length; i++)this.ruler.push($c9ce3a88b0f025ea$var$_rules[i][0], $c9ce3a88b0f025ea$var$_rules[i][1]);
    /**
   * ParserInline#ruler2 -> Ruler
   *
   * [[Ruler]] instance. Second ruler used for post-processing
   * (e.g. in emphasis-like rules).
   **/ this.ruler2 = new $c3dcz();
    for(i = 0; i < $c9ce3a88b0f025ea$var$_rules2.length; i++)this.ruler2.push($c9ce3a88b0f025ea$var$_rules2[i][0], $c9ce3a88b0f025ea$var$_rules2[i][1]);
}
// Skip single token by running all rules in validation mode;
// returns `true` if any rule reported success
//
$c9ce3a88b0f025ea$var$ParserInline.prototype.skipToken = function(state) {
    var ok, i, pos = state.pos, rules = this.ruler.getRules(''), len = rules.length, maxNesting = state.md.options.maxNesting, cache = state.cache;
    if (typeof cache[pos] !== 'undefined') {
        state.pos = cache[pos];
        return;
    }
    if (state.level < maxNesting) for(i = 0; i < len; i++){
        // Increment state.level and decrement it later to limit recursion.
        // It's harmless to do here, because no tokens are created. But ideally,
        // we'd need a separate private state variable for this purpose.
        //
        state.level++;
        ok = rules[i](state, true);
        state.level--;
        if (ok) {
            if (pos >= state.pos) throw new Error("inline rule didn't increment state.pos");
            break;
        }
    }
    else // Too much nesting, just skip until the end of the paragraph.
    //
    // NOTE: this will cause links to behave incorrectly in the following case,
    //       when an amount of `[` is exactly equal to `maxNesting + 1`:
    //
    //       [[[[[[[[[[[[[[[[[[[[[foo]()
    //
    // TODO: remove this workaround when CM standard will allow nested links
    //       (we can replace it by preventing links from being parsed in
    //       validation mode)
    //
    state.pos = state.posMax;
    if (!ok) state.pos++;
    cache[pos] = state.pos;
};
// Generate tokens for input range
//
$c9ce3a88b0f025ea$var$ParserInline.prototype.tokenize = function(state) {
    var ok, i, prevPos, rules = this.ruler.getRules(''), len = rules.length, end = state.posMax, maxNesting = state.md.options.maxNesting;
    while(state.pos < end){
        // Try all possible rules.
        // On success, rule should:
        //
        // - update `state.pos`
        // - update `state.tokens`
        // - return true
        prevPos = state.pos;
        if (state.level < maxNesting) for(i = 0; i < len; i++){
            ok = rules[i](state, false);
            if (ok) {
                if (prevPos >= state.pos) throw new Error("inline rule didn't increment state.pos");
                break;
            }
        }
        if (ok) {
            if (state.pos >= end) break;
            continue;
        }
        state.pending += state.src[state.pos++];
    }
    if (state.pending) state.pushPending();
};
/**
 * ParserInline.parse(str, md, env, outTokens)
 *
 * Process input string and push inline tokens into `outTokens`
 **/ $c9ce3a88b0f025ea$var$ParserInline.prototype.parse = function(str, md, env, outTokens) {
    var i, rules, len;
    var state = new this.State(str, md, env, outTokens);
    this.tokenize(state);
    rules = this.ruler2.getRules('');
    len = rules.length;
    for(i = 0; i < len; i++)rules[i](state);
};

$c9ce3a88b0f025ea$var$ParserInline.prototype.State = (parcelRequire("88Wcs"));
module.exports = $c9ce3a88b0f025ea$var$ParserInline;

});
parcelRegister("9CTc4", function(module, exports) {
// Skip text characters for text token, place those to pending buffer
// and increment current pos
'use strict';
// Rule to skip pure text
// '{}$%@~+=:' reserved for extentions
// !, ", #, $, %, &, ', (, ), *, +, ,, -, ., /, :, ;, <, =, >, ?, @, [, \, ], ^, _, `, {, |, }, or ~
// !!!! Don't confuse with "Markdown ASCII Punctuation" chars
// http://spec.commonmark.org/0.15/#ascii-punctuation-character
function $702279f88976b162$var$isTerminatorChar(ch) {
    switch(ch){
        case 0x0A /* \n */ :
        case 0x21 /* ! */ :
        case 0x23 /* # */ :
        case 0x24 /* $ */ :
        case 0x25 /* % */ :
        case 0x26 /* & */ :
        case 0x2A /* * */ :
        case 0x2B /* + */ :
        case 0x2D /* - */ :
        case 0x3A /* : */ :
        case 0x3C /* < */ :
        case 0x3D /* = */ :
        case 0x3E /* > */ :
        case 0x40 /* @ */ :
        case 0x5B /* [ */ :
        case 0x5C /* \ */ :
        case 0x5D /* ] */ :
        case 0x5E /* ^ */ :
        case 0x5F /* _ */ :
        case 0x60 /* ` */ :
        case 0x7B /* { */ :
        case 0x7D /* } */ :
        case 0x7E /* ~ */ :
            return true;
        default:
            return false;
    }
}
module.exports = function text(state, silent) {
    var pos = state.pos;
    while(pos < state.posMax && !$702279f88976b162$var$isTerminatorChar(state.src.charCodeAt(pos)))pos++;
    if (pos === state.pos) return false;
    if (!silent) state.pending += state.src.slice(state.pos, pos);
    state.pos = pos;
    return true;
}; // Alternative implementation, for memory.
 //
 // It costs 10% of performance, but allows extend terminators list, if place it
 // to `ParcerInline` property. Probably, will switch to it sometime, such
 // flexibility required.
 /*
var TERMINATOR_RE = /[\n!#$%&*+\-:<=>@[\\\]^_`{}~]/;

module.exports = function text(state, silent) {
  var pos = state.pos,
      idx = state.src.slice(pos).search(TERMINATOR_RE);

  // first char is terminator -> empty text
  if (idx === 0) { return false; }

  // no terminator -> text till end of string
  if (idx < 0) {
    if (!silent) { state.pending += state.src.slice(pos); }
    state.pos = state.src.length;
    return true;
  }

  if (!silent) { state.pending += state.src.slice(pos, pos + idx); }

  state.pos += idx;

  return true;
};*/ 

});

parcelRegister("2BswS", function(module, exports) {
// Process links like https://example.org/
'use strict';
// RFC3986: scheme = ALPHA *( ALPHA / DIGIT / "+" / "-" / "." )
var $1e552aca02548a0c$var$SCHEME_RE = /(?:^|[^a-z0-9.+-])([a-z][a-z0-9.+-]*)$/i;
module.exports = function linkify(state, silent) {
    var pos, max, match, proto, link, url, fullUrl, token;
    if (!state.md.options.linkify) return false;
    if (state.linkLevel > 0) return false;
    pos = state.pos;
    max = state.posMax;
    if (pos + 3 > max) return false;
    if (state.src.charCodeAt(pos) !== 0x3A /* : */ ) return false;
    if (state.src.charCodeAt(pos + 1) !== 0x2F /* / */ ) return false;
    if (state.src.charCodeAt(pos + 2) !== 0x2F /* / */ ) return false;
    match = state.pending.match($1e552aca02548a0c$var$SCHEME_RE);
    if (!match) return false;
    proto = match[1];
    link = state.md.linkify.matchAtStart(state.src.slice(pos - proto.length));
    if (!link) return false;
    url = link.url;
    // invalid link, but still detected by linkify somehow;
    // need to check to prevent infinite loop below
    if (url.length <= proto.length) return false;
    // disallow '*' at the end of the link (conflicts with emphasis)
    url = url.replace(/\*+$/, '');
    fullUrl = state.md.normalizeLink(url);
    if (!state.md.validateLink(fullUrl)) return false;
    if (!silent) {
        state.pending = state.pending.slice(0, -proto.length);
        token = state.push('link_open', 'a', 1);
        token.attrs = [
            [
                'href',
                fullUrl
            ]
        ];
        token.markup = 'linkify';
        token.info = 'auto';
        token = state.push('text', '', 0);
        token.content = state.md.normalizeLinkText(url);
        token = state.push('link_close', 'a', -1);
        token.markup = 'linkify';
        token.info = 'auto';
    }
    state.pos += url.length - proto.length;
    return true;
};

});

parcelRegister("jE0nb", function(module, exports) {
// Proceess '\n'
'use strict';

var $l6IUK = parcelRequire("l6IUK");
var $e4d20ad3daa16369$require$isSpace = $l6IUK.isSpace;
module.exports = function newline(state, silent) {
    var pmax, max, ws, pos = state.pos;
    if (state.src.charCodeAt(pos) !== 0x0A /* \n */ ) return false;
    pmax = state.pending.length - 1;
    max = state.posMax;
    // '  \n' -> hardbreak
    // Lookup in pending chars is bad practice! Don't copy to other rules!
    // Pending string is stored in concat mode, indexed lookups will cause
    // convertion to flat mode.
    if (!silent) {
        if (pmax >= 0 && state.pending.charCodeAt(pmax) === 0x20) {
            if (pmax >= 1 && state.pending.charCodeAt(pmax - 1) === 0x20) {
                // Find whitespaces tail of pending chars.
                ws = pmax - 1;
                while(ws >= 1 && state.pending.charCodeAt(ws - 1) === 0x20)ws--;
                state.pending = state.pending.slice(0, ws);
                state.push('hardbreak', 'br', 0);
            } else {
                state.pending = state.pending.slice(0, -1);
                state.push('softbreak', 'br', 0);
            }
        } else state.push('softbreak', 'br', 0);
    }
    pos++;
    // skip heading spaces for next line
    while(pos < max && $e4d20ad3daa16369$require$isSpace(state.src.charCodeAt(pos)))pos++;
    state.pos = pos;
    return true;
};

});

parcelRegister("k9EFJ", function(module, exports) {
// Process escaped chars and hardbreaks
'use strict';

var $l6IUK = parcelRequire("l6IUK");
var $eac4328664b70245$require$isSpace = $l6IUK.isSpace;
var $eac4328664b70245$var$ESCAPED = [];
for(var $eac4328664b70245$var$i = 0; $eac4328664b70245$var$i < 256; $eac4328664b70245$var$i++)$eac4328664b70245$var$ESCAPED.push(0);
'\\!"#$%&\'()*+,./:;<=>?@[]^_`{|}~-'.split('').forEach(function(ch) {
    $eac4328664b70245$var$ESCAPED[ch.charCodeAt(0)] = 1;
});
module.exports = function escape(state, silent) {
    var ch1, ch2, origStr, escapedStr, token, pos = state.pos, max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x5C /* \ */ ) return false;
    pos++;
    // '\' at the end of the inline block
    if (pos >= max) return false;
    ch1 = state.src.charCodeAt(pos);
    if (ch1 === 0x0A) {
        if (!silent) state.push('hardbreak', 'br', 0);
        pos++;
        // skip leading whitespaces from next line
        while(pos < max){
            ch1 = state.src.charCodeAt(pos);
            if (!$eac4328664b70245$require$isSpace(ch1)) break;
            pos++;
        }
        state.pos = pos;
        return true;
    }
    escapedStr = state.src[pos];
    if (ch1 >= 0xD800 && ch1 <= 0xDBFF && pos + 1 < max) {
        ch2 = state.src.charCodeAt(pos + 1);
        if (ch2 >= 0xDC00 && ch2 <= 0xDFFF) {
            escapedStr += state.src[pos + 1];
            pos++;
        }
    }
    origStr = '\\' + escapedStr;
    if (!silent) {
        token = state.push('text_special', '', 0);
        if (ch1 < 256 && $eac4328664b70245$var$ESCAPED[ch1] !== 0) token.content = escapedStr;
        else token.content = origStr;
        token.markup = origStr;
        token.info = 'escape';
    }
    state.pos = pos + 1;
    return true;
};

});

parcelRegister("fC6en", function(module, exports) {
// Parse backticks
'use strict';
module.exports = function backtick(state, silent) {
    var start, max, marker, token, matchStart, matchEnd, openerLength, closerLength, pos = state.pos, ch = state.src.charCodeAt(pos);
    if (ch !== 0x60 /* ` */ ) return false;
    start = pos;
    pos++;
    max = state.posMax;
    // scan marker length
    while(pos < max && state.src.charCodeAt(pos) === 0x60 /* ` */ )pos++;
    marker = state.src.slice(start, pos);
    openerLength = marker.length;
    if (state.backticksScanned && (state.backticks[openerLength] || 0) <= start) {
        if (!silent) state.pending += marker;
        state.pos += openerLength;
        return true;
    }
    matchEnd = pos;
    // Nothing found in the cache, scan until the end of the line (or until marker is found)
    while((matchStart = state.src.indexOf('`', matchEnd)) !== -1){
        matchEnd = matchStart + 1;
        // scan marker length
        while(matchEnd < max && state.src.charCodeAt(matchEnd) === 0x60 /* ` */ )matchEnd++;
        closerLength = matchEnd - matchStart;
        if (closerLength === openerLength) {
            // Found matching closer length.
            if (!silent) {
                token = state.push('code_inline', 'code', 0);
                token.markup = marker;
                token.content = state.src.slice(pos, matchStart).replace(/\n/g, ' ').replace(/^ (.+) $/, '$1');
            }
            state.pos = matchEnd;
            return true;
        }
        // Some different length found, put it in cache as upper limit of where closer can be found
        state.backticks[closerLength] = matchStart;
    }
    // Scanned through the end, didn't find anything
    state.backticksScanned = true;
    if (!silent) state.pending += marker;
    state.pos += openerLength;
    return true;
};

});

parcelRegister("dT517", function(module, exports) {

$parcel$export(module.exports, "tokenize", () => $a1c44db354892de3$export$660b2ee2d4fb4eff, (v) => $a1c44db354892de3$export$660b2ee2d4fb4eff = v);
$parcel$export(module.exports, "postProcess", () => $a1c44db354892de3$export$7b804a0e0ce836d9, (v) => $a1c44db354892de3$export$7b804a0e0ce836d9 = v);
// ~~strike through~~
//
// Insert each marker as a separate text token, and add it to delimiter list
//
var $a1c44db354892de3$export$660b2ee2d4fb4eff;
// Walk through delimiter list and replace text tokens with tags
//
var $a1c44db354892de3$export$7b804a0e0ce836d9;
'use strict';
$a1c44db354892de3$export$660b2ee2d4fb4eff = function strikethrough(state, silent) {
    var i, scanned, token, len, ch, start = state.pos, marker = state.src.charCodeAt(start);
    if (silent) return false;
    if (marker !== 0x7E /* ~ */ ) return false;
    scanned = state.scanDelims(state.pos, true);
    len = scanned.length;
    ch = String.fromCharCode(marker);
    if (len < 2) return false;
    if (len % 2) {
        token = state.push('text', '', 0);
        token.content = ch;
        len--;
    }
    for(i = 0; i < len; i += 2){
        token = state.push('text', '', 0);
        token.content = ch + ch;
        state.delimiters.push({
            marker: marker,
            length: 0,
            token: state.tokens.length - 1,
            end: -1,
            open: scanned.can_open,
            close: scanned.can_close
        });
    }
    state.pos += scanned.length;
    return true;
};
function $a1c44db354892de3$var$postProcess(state, delimiters) {
    var i, j, startDelim, endDelim, token, loneMarkers = [], max = delimiters.length;
    for(i = 0; i < max; i++){
        startDelim = delimiters[i];
        if (startDelim.marker !== 0x7E /* ~ */ ) continue;
        if (startDelim.end === -1) continue;
        endDelim = delimiters[startDelim.end];
        token = state.tokens[startDelim.token];
        token.type = 's_open';
        token.tag = 's';
        token.nesting = 1;
        token.markup = '~~';
        token.content = '';
        token = state.tokens[endDelim.token];
        token.type = 's_close';
        token.tag = 's';
        token.nesting = -1;
        token.markup = '~~';
        token.content = '';
        if (state.tokens[endDelim.token - 1].type === 'text' && state.tokens[endDelim.token - 1].content === '~') loneMarkers.push(endDelim.token - 1);
    }
    // If a marker sequence has an odd number of characters, it's splitted
    // like this: `~~~~~` -> `~` + `~~` + `~~`, leaving one marker at the
    // start of the sequence.
    //
    // So, we have to move all those markers after subsequent s_close tags.
    //
    while(loneMarkers.length){
        i = loneMarkers.pop();
        j = i + 1;
        while(j < state.tokens.length && state.tokens[j].type === 's_close')j++;
        j--;
        if (i !== j) {
            token = state.tokens[j];
            state.tokens[j] = state.tokens[i];
            state.tokens[i] = token;
        }
    }
}
$a1c44db354892de3$export$7b804a0e0ce836d9 = function strikethrough(state) {
    var curr, tokens_meta = state.tokens_meta, max = state.tokens_meta.length;
    $a1c44db354892de3$var$postProcess(state, state.delimiters);
    for(curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $a1c44db354892de3$var$postProcess(state, tokens_meta[curr].delimiters);
};

});

parcelRegister("ji5vg", function(module, exports) {

$parcel$export(module.exports, "tokenize", () => $e0b3f79dfd6fab43$export$660b2ee2d4fb4eff, (v) => $e0b3f79dfd6fab43$export$660b2ee2d4fb4eff = v);
$parcel$export(module.exports, "postProcess", () => $e0b3f79dfd6fab43$export$7b804a0e0ce836d9, (v) => $e0b3f79dfd6fab43$export$7b804a0e0ce836d9 = v);
// Process *this* and _that_
//
// Insert each marker as a separate text token, and add it to delimiter list
//
var $e0b3f79dfd6fab43$export$660b2ee2d4fb4eff;
// Walk through delimiter list and replace text tokens with tags
//
var $e0b3f79dfd6fab43$export$7b804a0e0ce836d9;
'use strict';
$e0b3f79dfd6fab43$export$660b2ee2d4fb4eff = function emphasis(state, silent) {
    var i, scanned, token, start = state.pos, marker = state.src.charCodeAt(start);
    if (silent) return false;
    if (marker !== 0x5F /* _ */  && marker !== 0x2A /* * */ ) return false;
    scanned = state.scanDelims(state.pos, marker === 0x2A);
    for(i = 0; i < scanned.length; i++){
        token = state.push('text', '', 0);
        token.content = String.fromCharCode(marker);
        state.delimiters.push({
            // Char code of the starting marker (number).
            //
            marker: marker,
            // Total length of these series of delimiters.
            //
            length: scanned.length,
            // A position of the token this delimiter corresponds to.
            //
            token: state.tokens.length - 1,
            // If this delimiter is matched as a valid opener, `end` will be
            // equal to its position, otherwise it's `-1`.
            //
            end: -1,
            // Boolean flags that determine if this delimiter could open or close
            // an emphasis.
            //
            open: scanned.can_open,
            close: scanned.can_close
        });
    }
    state.pos += scanned.length;
    return true;
};
function $e0b3f79dfd6fab43$var$postProcess(state, delimiters) {
    var i, startDelim, endDelim, token, ch, isStrong, max = delimiters.length;
    for(i = max - 1; i >= 0; i--){
        startDelim = delimiters[i];
        if (startDelim.marker !== 0x5F /* _ */  && startDelim.marker !== 0x2A /* * */ ) continue;
        // Process only opening markers
        if (startDelim.end === -1) continue;
        endDelim = delimiters[startDelim.end];
        // If the previous delimiter has the same marker and is adjacent to this one,
        // merge those into one strong delimiter.
        //
        // `<em><em>whatever</em></em>` -> `<strong>whatever</strong>`
        //
        isStrong = i > 0 && delimiters[i - 1].end === startDelim.end + 1 && // check that first two markers match and adjacent
        delimiters[i - 1].marker === startDelim.marker && delimiters[i - 1].token === startDelim.token - 1 && // check that last two markers are adjacent (we can safely assume they match)
        delimiters[startDelim.end + 1].token === endDelim.token + 1;
        ch = String.fromCharCode(startDelim.marker);
        token = state.tokens[startDelim.token];
        token.type = isStrong ? 'strong_open' : 'em_open';
        token.tag = isStrong ? 'strong' : 'em';
        token.nesting = 1;
        token.markup = isStrong ? ch + ch : ch;
        token.content = '';
        token = state.tokens[endDelim.token];
        token.type = isStrong ? 'strong_close' : 'em_close';
        token.tag = isStrong ? 'strong' : 'em';
        token.nesting = -1;
        token.markup = isStrong ? ch + ch : ch;
        token.content = '';
        if (isStrong) {
            state.tokens[delimiters[i - 1].token].content = '';
            state.tokens[delimiters[startDelim.end + 1].token].content = '';
            i--;
        }
    }
}
$e0b3f79dfd6fab43$export$7b804a0e0ce836d9 = function emphasis(state) {
    var curr, tokens_meta = state.tokens_meta, max = state.tokens_meta.length;
    $e0b3f79dfd6fab43$var$postProcess(state, state.delimiters);
    for(curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $e0b3f79dfd6fab43$var$postProcess(state, tokens_meta[curr].delimiters);
};

});

parcelRegister("7ZRUa", function(module, exports) {
// Process [link](<to> "stuff")
'use strict';

var $l6IUK = parcelRequire("l6IUK");
var $5d280b49f64c4b8a$require$normalizeReference = $l6IUK.normalizeReference;

var $l6IUK = parcelRequire("l6IUK");
var $5d280b49f64c4b8a$require$isSpace = $l6IUK.isSpace;
module.exports = function link(state, silent) {
    var attrs, code, label, labelEnd, labelStart, pos, res, ref, token, href = '', title = '', oldPos = state.pos, max = state.posMax, start = state.pos, parseReference = true;
    if (state.src.charCodeAt(state.pos) !== 0x5B /* [ */ ) return false;
    labelStart = state.pos + 1;
    labelEnd = state.md.helpers.parseLinkLabel(state, state.pos, true);
    // parser failed to find ']', so it's not a valid link
    if (labelEnd < 0) return false;
    pos = labelEnd + 1;
    if (pos < max && state.src.charCodeAt(pos) === 0x28 /* ( */ ) {
        //
        // Inline link
        //
        // might have found a valid shortcut link, disable reference parsing
        parseReference = false;
        // [link](  <href>  "title"  )
        //        ^^ skipping these spaces
        pos++;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!$5d280b49f64c4b8a$require$isSpace(code) && code !== 0x0A) break;
        }
        if (pos >= max) return false;
        // [link](  <href>  "title"  )
        //          ^^^^^^ parsing link destination
        start = pos;
        res = state.md.helpers.parseLinkDestination(state.src, pos, state.posMax);
        if (res.ok) {
            href = state.md.normalizeLink(res.str);
            if (state.md.validateLink(href)) pos = res.pos;
            else href = '';
            // [link](  <href>  "title"  )
            //                ^^ skipping these spaces
            start = pos;
            for(; pos < max; pos++){
                code = state.src.charCodeAt(pos);
                if (!$5d280b49f64c4b8a$require$isSpace(code) && code !== 0x0A) break;
            }
            // [link](  <href>  "title"  )
            //                  ^^^^^^^ parsing link title
            res = state.md.helpers.parseLinkTitle(state.src, pos, state.posMax);
            if (pos < max && start !== pos && res.ok) {
                title = res.str;
                pos = res.pos;
                // [link](  <href>  "title"  )
                //                         ^^ skipping these spaces
                for(; pos < max; pos++){
                    code = state.src.charCodeAt(pos);
                    if (!$5d280b49f64c4b8a$require$isSpace(code) && code !== 0x0A) break;
                }
            }
        }
        if (pos >= max || state.src.charCodeAt(pos) !== 0x29 /* ) */ ) // parsing a valid shortcut link failed, fallback to reference
        parseReference = true;
        pos++;
    }
    if (parseReference) {
        //
        // Link reference
        //
        if (typeof state.env.references === 'undefined') return false;
        if (pos < max && state.src.charCodeAt(pos) === 0x5B /* [ */ ) {
            start = pos + 1;
            pos = state.md.helpers.parseLinkLabel(state, pos);
            if (pos >= 0) label = state.src.slice(start, pos++);
            else pos = labelEnd + 1;
        } else pos = labelEnd + 1;
        // covers label === '' and label === undefined
        // (collapsed reference link and shortcut reference link respectively)
        if (!label) label = state.src.slice(labelStart, labelEnd);
        ref = state.env.references[$5d280b49f64c4b8a$require$normalizeReference(label)];
        if (!ref) {
            state.pos = oldPos;
            return false;
        }
        href = ref.href;
        title = ref.title;
    }
    //
    // We found the end of the link, and know for a fact it's a valid link;
    // so all that's left to do is to call tokenizer.
    //
    if (!silent) {
        state.pos = labelStart;
        state.posMax = labelEnd;
        token = state.push('link_open', 'a', 1);
        token.attrs = attrs = [
            [
                'href',
                href
            ]
        ];
        if (title) attrs.push([
            'title',
            title
        ]);
        state.linkLevel++;
        state.md.inline.tokenize(state);
        state.linkLevel--;
        token = state.push('link_close', 'a', -1);
    }
    state.pos = pos;
    state.posMax = max;
    return true;
};

});

parcelRegister("3t7o6", function(module, exports) {
// Process ![image](<src> "title")
'use strict';

var $l6IUK = parcelRequire("l6IUK");
var $2869cf98507d2846$require$normalizeReference = $l6IUK.normalizeReference;

var $l6IUK = parcelRequire("l6IUK");
var $2869cf98507d2846$require$isSpace = $l6IUK.isSpace;
module.exports = function image(state, silent) {
    var attrs, code, content, label, labelEnd, labelStart, pos, ref, res, title, token, tokens, start, href = '', oldPos = state.pos, max = state.posMax;
    if (state.src.charCodeAt(state.pos) !== 0x21 /* ! */ ) return false;
    if (state.src.charCodeAt(state.pos + 1) !== 0x5B /* [ */ ) return false;
    labelStart = state.pos + 2;
    labelEnd = state.md.helpers.parseLinkLabel(state, state.pos + 1, false);
    // parser failed to find ']', so it's not a valid link
    if (labelEnd < 0) return false;
    pos = labelEnd + 1;
    if (pos < max && state.src.charCodeAt(pos) === 0x28 /* ( */ ) {
        //
        // Inline link
        //
        // [link](  <href>  "title"  )
        //        ^^ skipping these spaces
        pos++;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!$2869cf98507d2846$require$isSpace(code) && code !== 0x0A) break;
        }
        if (pos >= max) return false;
        // [link](  <href>  "title"  )
        //          ^^^^^^ parsing link destination
        start = pos;
        res = state.md.helpers.parseLinkDestination(state.src, pos, state.posMax);
        if (res.ok) {
            href = state.md.normalizeLink(res.str);
            if (state.md.validateLink(href)) pos = res.pos;
            else href = '';
        }
        // [link](  <href>  "title"  )
        //                ^^ skipping these spaces
        start = pos;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!$2869cf98507d2846$require$isSpace(code) && code !== 0x0A) break;
        }
        // [link](  <href>  "title"  )
        //                  ^^^^^^^ parsing link title
        res = state.md.helpers.parseLinkTitle(state.src, pos, state.posMax);
        if (pos < max && start !== pos && res.ok) {
            title = res.str;
            pos = res.pos;
            // [link](  <href>  "title"  )
            //                         ^^ skipping these spaces
            for(; pos < max; pos++){
                code = state.src.charCodeAt(pos);
                if (!$2869cf98507d2846$require$isSpace(code) && code !== 0x0A) break;
            }
        } else title = '';
        if (pos >= max || state.src.charCodeAt(pos) !== 0x29 /* ) */ ) {
            state.pos = oldPos;
            return false;
        }
        pos++;
    } else {
        //
        // Link reference
        //
        if (typeof state.env.references === 'undefined') return false;
        if (pos < max && state.src.charCodeAt(pos) === 0x5B /* [ */ ) {
            start = pos + 1;
            pos = state.md.helpers.parseLinkLabel(state, pos);
            if (pos >= 0) label = state.src.slice(start, pos++);
            else pos = labelEnd + 1;
        } else pos = labelEnd + 1;
        // covers label === '' and label === undefined
        // (collapsed reference link and shortcut reference link respectively)
        if (!label) label = state.src.slice(labelStart, labelEnd);
        ref = state.env.references[$2869cf98507d2846$require$normalizeReference(label)];
        if (!ref) {
            state.pos = oldPos;
            return false;
        }
        href = ref.href;
        title = ref.title;
    }
    //
    // We found the end of the link, and know for a fact it's a valid link;
    // so all that's left to do is to call tokenizer.
    //
    if (!silent) {
        content = state.src.slice(labelStart, labelEnd);
        state.md.inline.parse(content, state.md, state.env, tokens = []);
        token = state.push('image', 'img', 0);
        token.attrs = attrs = [
            [
                'src',
                href
            ],
            [
                'alt',
                ''
            ]
        ];
        token.children = tokens;
        token.content = content;
        if (title) attrs.push([
            'title',
            title
        ]);
    }
    state.pos = pos;
    state.posMax = max;
    return true;
};

});

parcelRegister("fyaCn", function(module, exports) {
// Process autolinks '<protocol:...>'
'use strict';
/*eslint max-len:0*/ var $b52244839cfe6245$var$EMAIL_RE = /^([a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)$/;
var $b52244839cfe6245$var$AUTOLINK_RE = /^([a-zA-Z][a-zA-Z0-9+.\-]{1,31}):([^<>\x00-\x20]*)$/;
module.exports = function autolink(state, silent) {
    var url, fullUrl, token, ch, start, max, pos = state.pos;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */ ) return false;
    start = state.pos;
    max = state.posMax;
    for(;;){
        if (++pos >= max) return false;
        ch = state.src.charCodeAt(pos);
        if (ch === 0x3C /* < */ ) return false;
        if (ch === 0x3E /* > */ ) break;
    }
    url = state.src.slice(start + 1, pos);
    if ($b52244839cfe6245$var$AUTOLINK_RE.test(url)) {
        fullUrl = state.md.normalizeLink(url);
        if (!state.md.validateLink(fullUrl)) return false;
        if (!silent) {
            token = state.push('link_open', 'a', 1);
            token.attrs = [
                [
                    'href',
                    fullUrl
                ]
            ];
            token.markup = 'autolink';
            token.info = 'auto';
            token = state.push('text', '', 0);
            token.content = state.md.normalizeLinkText(url);
            token = state.push('link_close', 'a', -1);
            token.markup = 'autolink';
            token.info = 'auto';
        }
        state.pos += url.length + 2;
        return true;
    }
    if ($b52244839cfe6245$var$EMAIL_RE.test(url)) {
        fullUrl = state.md.normalizeLink('mailto:' + url);
        if (!state.md.validateLink(fullUrl)) return false;
        if (!silent) {
            token = state.push('link_open', 'a', 1);
            token.attrs = [
                [
                    'href',
                    fullUrl
                ]
            ];
            token.markup = 'autolink';
            token.info = 'auto';
            token = state.push('text', '', 0);
            token.content = state.md.normalizeLinkText(url);
            token = state.push('link_close', 'a', -1);
            token.markup = 'autolink';
            token.info = 'auto';
        }
        state.pos += url.length + 2;
        return true;
    }
    return false;
};

});

parcelRegister("9M7vq", function(module, exports) {
// Process html tags
'use strict';

var $0dDBY = parcelRequire("0dDBY");
var $71de6b3e3fe98feb$require$HTML_TAG_RE = $0dDBY.HTML_TAG_RE;
function $71de6b3e3fe98feb$var$isLinkOpen(str) {
    return /^<a[>\s]/i.test(str);
}
function $71de6b3e3fe98feb$var$isLinkClose(str) {
    return /^<\/a\s*>/i.test(str);
}
function $71de6b3e3fe98feb$var$isLetter(ch) {
    /*eslint no-bitwise:0*/ var lc = ch | 0x20; // to lower case
    return lc >= 0x61 /* a */  && lc <= 0x7a /* z */ ;
}
module.exports = function html_inline(state, silent) {
    var ch, match, max, token, pos = state.pos;
    if (!state.md.options.html) return false;
    // Check start
    max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */  || pos + 2 >= max) return false;
    // Quick fail on second char
    ch = state.src.charCodeAt(pos + 1);
    if (ch !== 0x21 /* ! */  && ch !== 0x3F /* ? */  && ch !== 0x2F /* / */  && !$71de6b3e3fe98feb$var$isLetter(ch)) return false;
    match = state.src.slice(pos).match($71de6b3e3fe98feb$require$HTML_TAG_RE);
    if (!match) return false;
    if (!silent) {
        token = state.push('html_inline', '', 0);
        token.content = match[0];
        if ($71de6b3e3fe98feb$var$isLinkOpen(token.content)) state.linkLevel++;
        if ($71de6b3e3fe98feb$var$isLinkClose(token.content)) state.linkLevel--;
    }
    state.pos += match[0].length;
    return true;
};

});

parcelRegister("i1a7Z", function(module, exports) {
// Process html entity - &#123;, &#xAF;, &quot;, ...
'use strict';

var $3q5w3 = parcelRequire("3q5w3");

var $l6IUK = parcelRequire("l6IUK");
var $d1e02d2d980e258d$require$has = $l6IUK.has;

var $l6IUK = parcelRequire("l6IUK");
var $d1e02d2d980e258d$require$isValidEntityCode = $l6IUK.isValidEntityCode;

var $l6IUK = parcelRequire("l6IUK");
var $d1e02d2d980e258d$require$fromCodePoint = $l6IUK.fromCodePoint;
var $d1e02d2d980e258d$var$DIGITAL_RE = /^&#((?:x[a-f0-9]{1,6}|[0-9]{1,7}));/i;
var $d1e02d2d980e258d$var$NAMED_RE = /^&([a-z][a-z0-9]{1,31});/i;
module.exports = function entity(state, silent) {
    var ch, code, match, token, pos = state.pos, max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x26 /* & */ ) return false;
    if (pos + 1 >= max) return false;
    ch = state.src.charCodeAt(pos + 1);
    if (ch === 0x23 /* # */ ) {
        match = state.src.slice(pos).match($d1e02d2d980e258d$var$DIGITAL_RE);
        if (match) {
            if (!silent) {
                code = match[1][0].toLowerCase() === 'x' ? parseInt(match[1].slice(1), 16) : parseInt(match[1], 10);
                token = state.push('text_special', '', 0);
                token.content = $d1e02d2d980e258d$require$isValidEntityCode(code) ? $d1e02d2d980e258d$require$fromCodePoint(code) : $d1e02d2d980e258d$require$fromCodePoint(0xFFFD);
                token.markup = match[0];
                token.info = 'entity';
            }
            state.pos += match[0].length;
            return true;
        }
    } else {
        match = state.src.slice(pos).match($d1e02d2d980e258d$var$NAMED_RE);
        if (match) {
            if ($d1e02d2d980e258d$require$has($3q5w3, match[1])) {
                if (!silent) {
                    token = state.push('text_special', '', 0);
                    token.content = $3q5w3[match[1]];
                    token.markup = match[0];
                    token.info = 'entity';
                }
                state.pos += match[0].length;
                return true;
            }
        }
    }
    return false;
};

});

parcelRegister("6FHxS", function(module, exports) {
// For each opening emphasis-like marker find a matching closing one
//
'use strict';
function $4db85999f2263c0e$var$processDelimiters(delimiters) {
    var closerIdx, openerIdx, closer, opener, minOpenerIdx, newMinOpenerIdx, isOddMatch, lastJump, openersBottom = {}, max = delimiters.length;
    if (!max) return;
    // headerIdx is the first delimiter of the current (where closer is) delimiter run
    var headerIdx = 0;
    var lastTokenIdx = -2; // needs any value lower than -1
    var jumps = [];
    for(closerIdx = 0; closerIdx < max; closerIdx++){
        closer = delimiters[closerIdx];
        jumps.push(0);
        // markers belong to same delimiter run if:
        //  - they have adjacent tokens
        //  - AND markers are the same
        //
        if (delimiters[headerIdx].marker !== closer.marker || lastTokenIdx !== closer.token - 1) headerIdx = closerIdx;
        lastTokenIdx = closer.token;
        // Length is only used for emphasis-specific "rule of 3",
        // if it's not defined (in strikethrough or 3rd party plugins),
        // we can default it to 0 to disable those checks.
        //
        closer.length = closer.length || 0;
        if (!closer.close) continue;
        // Previously calculated lower bounds (previous fails)
        // for each marker, each delimiter length modulo 3,
        // and for whether this closer can be an opener;
        // https://github.com/commonmark/cmark/commit/34250e12ccebdc6372b8b49c44fab57c72443460
        if (!openersBottom.hasOwnProperty(closer.marker)) openersBottom[closer.marker] = [
            -1,
            -1,
            -1,
            -1,
            -1,
            -1
        ];
        minOpenerIdx = openersBottom[closer.marker][(closer.open ? 3 : 0) + closer.length % 3];
        openerIdx = headerIdx - jumps[headerIdx] - 1;
        newMinOpenerIdx = openerIdx;
        for(; openerIdx > minOpenerIdx; openerIdx -= jumps[openerIdx] + 1){
            opener = delimiters[openerIdx];
            if (opener.marker !== closer.marker) continue;
            if (opener.open && opener.end < 0) {
                isOddMatch = false;
                // from spec:
                //
                // If one of the delimiters can both open and close emphasis, then the
                // sum of the lengths of the delimiter runs containing the opening and
                // closing delimiters must not be a multiple of 3 unless both lengths
                // are multiples of 3.
                //
                if (opener.close || closer.open) {
                    if ((opener.length + closer.length) % 3 === 0) {
                        if (opener.length % 3 !== 0 || closer.length % 3 !== 0) isOddMatch = true;
                    }
                }
                if (!isOddMatch) {
                    // If previous delimiter cannot be an opener, we can safely skip
                    // the entire sequence in future checks. This is required to make
                    // sure algorithm has linear complexity (see *_*_*_*_*_... case).
                    //
                    lastJump = openerIdx > 0 && !delimiters[openerIdx - 1].open ? jumps[openerIdx - 1] + 1 : 0;
                    jumps[closerIdx] = closerIdx - openerIdx + lastJump;
                    jumps[openerIdx] = lastJump;
                    closer.open = false;
                    opener.end = closerIdx;
                    opener.close = false;
                    newMinOpenerIdx = -1;
                    // treat next token as start of run,
                    // it optimizes skips in **<...>**a**<...>** pathological case
                    lastTokenIdx = -2;
                    break;
                }
            }
        }
        if (newMinOpenerIdx !== -1) // If match for this delimiter run failed, we want to set lower bound for
        // future lookups. This is required to make sure algorithm has linear
        // complexity.
        //
        // See details here:
        // https://github.com/commonmark/cmark/issues/178#issuecomment-270417442
        //
        openersBottom[closer.marker][(closer.open ? 3 : 0) + (closer.length || 0) % 3] = newMinOpenerIdx;
    }
}
module.exports = function link_pairs(state) {
    var curr, tokens_meta = state.tokens_meta, max = state.tokens_meta.length;
    $4db85999f2263c0e$var$processDelimiters(state.delimiters);
    for(curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $4db85999f2263c0e$var$processDelimiters(tokens_meta[curr].delimiters);
};

});

parcelRegister("9Rdip", function(module, exports) {
// Clean up tokens after emphasis and strikethrough postprocessing:
// merge adjacent text nodes into one and re-calculate all token levels
//
// This is necessary because initially emphasis delimiter markers (*, _, ~)
// are treated as their own separate text tokens. Then emphasis rule either
// leaves them as text (needed to merge with adjacent text) or turns them
// into opening/closing tags (which messes up levels inside).
//
'use strict';
module.exports = function fragments_join(state) {
    var curr, last, level = 0, tokens = state.tokens, max = state.tokens.length;
    for(curr = last = 0; curr < max; curr++){
        // re-calculate levels after emphasis/strikethrough turns some text nodes
        // into opening/closing tags
        if (tokens[curr].nesting < 0) level--; // closing tag
        tokens[curr].level = level;
        if (tokens[curr].nesting > 0) level++; // opening tag
        if (tokens[curr].type === 'text' && curr + 1 < max && tokens[curr + 1].type === 'text') // collapse two adjacent text nodes
        tokens[curr + 1].content = tokens[curr].content + tokens[curr + 1].content;
        else {
            if (curr !== last) tokens[last] = tokens[curr];
            last++;
        }
    }
    if (curr !== last) tokens.length = last;
};

});

parcelRegister("88Wcs", function(module, exports) {
// Inline parser state
'use strict';

var $8AILn = parcelRequire("8AILn");

var $l6IUK = parcelRequire("l6IUK");
var $5edc3765df6c6534$require$isWhiteSpace = $l6IUK.isWhiteSpace;

var $l6IUK = parcelRequire("l6IUK");
var $5edc3765df6c6534$require$isPunctChar = $l6IUK.isPunctChar;

var $l6IUK = parcelRequire("l6IUK");
var $5edc3765df6c6534$require$isMdAsciiPunct = $l6IUK.isMdAsciiPunct;
function $5edc3765df6c6534$var$StateInline(src, md, env, outTokens) {
    this.src = src;
    this.env = env;
    this.md = md;
    this.tokens = outTokens;
    this.tokens_meta = Array(outTokens.length);
    this.pos = 0;
    this.posMax = this.src.length;
    this.level = 0;
    this.pending = '';
    this.pendingLevel = 0;
    // Stores { start: end } pairs. Useful for backtrack
    // optimization of pairs parse (emphasis, strikes).
    this.cache = {};
    // List of emphasis-like delimiters for current tag
    this.delimiters = [];
    // Stack of delimiter lists for upper level tags
    this._prev_delimiters = [];
    // backtick length => last seen position
    this.backticks = {};
    this.backticksScanned = false;
    // Counter used to disable inline linkify-it execution
    // inside <a> and markdown links
    this.linkLevel = 0;
}
// Flush pending text
//
$5edc3765df6c6534$var$StateInline.prototype.pushPending = function() {
    var token = new $8AILn('text', '', 0);
    token.content = this.pending;
    token.level = this.pendingLevel;
    this.tokens.push(token);
    this.pending = '';
    return token;
};
// Push new token to "stream".
// If pending text exists - flush it as text token
//
$5edc3765df6c6534$var$StateInline.prototype.push = function(type, tag, nesting) {
    if (this.pending) this.pushPending();
    var token = new $8AILn(type, tag, nesting);
    var token_meta = null;
    if (nesting < 0) {
        // closing tag
        this.level--;
        this.delimiters = this._prev_delimiters.pop();
    }
    token.level = this.level;
    if (nesting > 0) {
        // opening tag
        this.level++;
        this._prev_delimiters.push(this.delimiters);
        this.delimiters = [];
        token_meta = {
            delimiters: this.delimiters
        };
    }
    this.pendingLevel = this.level;
    this.tokens.push(token);
    this.tokens_meta.push(token_meta);
    return token;
};
// Scan a sequence of emphasis-like markers, and determine whether
// it can start an emphasis sequence or end an emphasis sequence.
//
//  - start - position to scan from (it should point at a valid marker);
//  - canSplitWord - determine if these markers can be found inside a word
//
$5edc3765df6c6534$var$StateInline.prototype.scanDelims = function(start, canSplitWord) {
    var pos = start, lastChar, nextChar, count, can_open, can_close, isLastWhiteSpace, isLastPunctChar, isNextWhiteSpace, isNextPunctChar, left_flanking = true, right_flanking = true, max = this.posMax, marker = this.src.charCodeAt(start);
    // treat beginning of the line as a whitespace
    lastChar = start > 0 ? this.src.charCodeAt(start - 1) : 0x20;
    while(pos < max && this.src.charCodeAt(pos) === marker)pos++;
    count = pos - start;
    // treat end of the line as a whitespace
    nextChar = pos < max ? this.src.charCodeAt(pos) : 0x20;
    isLastPunctChar = $5edc3765df6c6534$require$isMdAsciiPunct(lastChar) || $5edc3765df6c6534$require$isPunctChar(String.fromCharCode(lastChar));
    isNextPunctChar = $5edc3765df6c6534$require$isMdAsciiPunct(nextChar) || $5edc3765df6c6534$require$isPunctChar(String.fromCharCode(nextChar));
    isLastWhiteSpace = $5edc3765df6c6534$require$isWhiteSpace(lastChar);
    isNextWhiteSpace = $5edc3765df6c6534$require$isWhiteSpace(nextChar);
    if (isNextWhiteSpace) left_flanking = false;
    else if (isNextPunctChar) {
        if (!(isLastWhiteSpace || isLastPunctChar)) left_flanking = false;
    }
    if (isLastWhiteSpace) right_flanking = false;
    else if (isLastPunctChar) {
        if (!(isNextWhiteSpace || isNextPunctChar)) right_flanking = false;
    }
    if (!canSplitWord) {
        can_open = left_flanking && (!right_flanking || isLastPunctChar);
        can_close = right_flanking && (!left_flanking || isNextPunctChar);
    } else {
        can_open = left_flanking;
        can_close = right_flanking;
    }
    return {
        can_open: can_open,
        can_close: can_close,
        length: count
    };
};
// re-export Token class to use in block rules
$5edc3765df6c6534$var$StateInline.prototype.Token = $8AILn;
module.exports = $5edc3765df6c6534$var$StateInline;

});


parcelRegister("98vHM", function(module, exports) {
'use strict';
////////////////////////////////////////////////////////////////////////////////
// Helpers
// Merge objects
//
function $6a6d745e641e5984$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $6a6d745e641e5984$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $6a6d745e641e5984$var$isString(obj) {
    return $6a6d745e641e5984$var$_class(obj) === '[object String]';
}
function $6a6d745e641e5984$var$isObject(obj) {
    return $6a6d745e641e5984$var$_class(obj) === '[object Object]';
}
function $6a6d745e641e5984$var$isRegExp(obj) {
    return $6a6d745e641e5984$var$_class(obj) === '[object RegExp]';
}
function $6a6d745e641e5984$var$isFunction(obj) {
    return $6a6d745e641e5984$var$_class(obj) === '[object Function]';
}
function $6a6d745e641e5984$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
}
////////////////////////////////////////////////////////////////////////////////
var $6a6d745e641e5984$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $6a6d745e641e5984$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        return acc || $6a6d745e641e5984$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
var $6a6d745e641e5984$var$defaultSchemas = {
    'http:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp('^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i');
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    'https:': 'http:',
    'ftp:': 'http:',
    '//': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp('^' + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' + self.re.src_port + self.re.src_host_terminator + self.re.src_path, 'i');
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ':') return 0;
                if (pos >= 3 && text[pos - 3] === '/') return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    'mailto:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp('^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i');
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
/*eslint-disable max-len*/ // RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
var $6a6d745e641e5984$var$tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
var $6a6d745e641e5984$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
/*eslint-enable max-len*/ ////////////////////////////////////////////////////////////////////////////////
function $6a6d745e641e5984$var$resetScanCache(self) {
    self.__index__ = -1;
    self.__text_cache__ = '';
}
function $6a6d745e641e5984$var$createValidator(re) {
    return function(text, pos) {
        var tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $6a6d745e641e5984$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}

// Schemas compiler. Build regexps.
//
function $6a6d745e641e5984$var$compile(self) {
    // Load & clone RE patterns.
    var re = self.re = (parcelRequire("fmrcY"))(self.__opts__);
    // Define dynamic patterns
    var tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($6a6d745e641e5984$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join('|');
    function untpl(tpl) {
        return tpl.replace('%TLDS%', re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), 'i');
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), 'i');
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');
    //
    // Compile each schema
    //
    var aliases = [];
    self.__compiled__ = {}; // Reset compiled data
    function schemaError(name, val) {
        throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        var val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        var compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($6a6d745e641e5984$var$isObject(val)) {
            if ($6a6d745e641e5984$var$isRegExp(val.validate)) compiled.validate = $6a6d745e641e5984$var$createValidator(val.validate);
            else if ($6a6d745e641e5984$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($6a6d745e641e5984$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $6a6d745e641e5984$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($6a6d745e641e5984$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[''] = {
        validate: null,
        normalize: $6a6d745e641e5984$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    var slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($6a6d745e641e5984$var$escapeRE).join('|');
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
    self.re.schema_search = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');
    self.re.schema_at_start = RegExp('^' + self.re.schema_search.source, 'i');
    self.re.pretest = RegExp('(' + self.re.schema_test.source + ')|(' + self.re.host_fuzzy_test.source + ')|@', 'i');
    //
    // Cleanup
    //
    $6a6d745e641e5984$var$resetScanCache(self);
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $6a6d745e641e5984$var$Match(self, shift) {
    var start = self.__index__, end = self.__last_index__, text = self.__text_cache__.slice(start, end);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = self.__schema__.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = start + shift;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = end + shift;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = text;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = text;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = text;
}
function $6a6d745e641e5984$var$createMatch(self, shift) {
    var match = new $6a6d745e641e5984$var$Match(self, shift);
    self.__compiled__[match.schema].normalize(match, self);
    return match;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $6a6d745e641e5984$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $6a6d745e641e5984$var$LinkifyIt)) return new $6a6d745e641e5984$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($6a6d745e641e5984$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $6a6d745e641e5984$var$assign({}, $6a6d745e641e5984$var$defaultOptions, options);
    // Cache last tested result. Used to skip repeating steps on next `match` call.
    this.__index__ = -1;
    this.__last_index__ = -1; // Next scan position
    this.__schema__ = '';
    this.__text_cache__ = '';
    this.__schemas__ = $6a6d745e641e5984$var$assign({}, $6a6d745e641e5984$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $6a6d745e641e5984$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $6a6d745e641e5984$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $6a6d745e641e5984$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $6a6d745e641e5984$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $6a6d745e641e5984$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $6a6d745e641e5984$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $6a6d745e641e5984$var$LinkifyIt.prototype.test = function test(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return false;
    var m, ml, me, len, shift, next, re, tld_pos, at_pos;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) {
                this.__schema__ = m[2];
                this.__index__ = m.index + m[1].length;
                this.__last_index__ = m.index + m[0].length + len;
                break;
            }
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
        // guess schemaless links
        tld_pos = text.search(this.re.host_fuzzy_test);
        if (tld_pos >= 0) {
            // if tld is located after found link - no need to check fuzzy pattern
            if (this.__index__ < 0 || tld_pos < this.__index__) {
                if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                    shift = ml.index + ml[1].length;
                    if (this.__index__ < 0 || shift < this.__index__) {
                        this.__schema__ = '';
                        this.__index__ = shift;
                        this.__last_index__ = ml.index + ml[0].length;
                    }
                }
            }
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
        // guess schemaless emails
        at_pos = text.indexOf('@');
        if (at_pos >= 0) // We can't skip this check, because this cases are possible:
        // 192.168.1.1@gmail.com, my.in@example.com
        {
            if ((me = text.match(this.re.email_fuzzy)) !== null) {
                shift = me.index + me[1].length;
                next = me.index + me[0].length;
                if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                    this.__schema__ = 'mailto:';
                    this.__index__ = shift;
                    this.__last_index__ = next;
                }
            }
        }
    }
    return this.__index__ >= 0;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $6a6d745e641e5984$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $6a6d745e641e5984$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $6a6d745e641e5984$var$LinkifyIt.prototype.match = function match(text) {
    var shift = 0, result = [];
    // Try to take previous element from cache, if .test() called before
    if (this.__index__ >= 0 && this.__text_cache__ === text) {
        result.push($6a6d745e641e5984$var$createMatch(this, shift));
        shift = this.__last_index__;
    }
    // Cut head if cache was used
    var tail = shift ? text.slice(shift) : text;
    // Scan string until end reached
    while(this.test(tail)){
        result.push($6a6d745e641e5984$var$createMatch(this, shift));
        tail = tail.slice(this.__last_index__);
        shift += this.__last_index__;
    }
    if (result.length) return result;
    return null;
};
/**
 * LinkifyIt#matchAtStart(text) -> Match|null
 *
 * Returns fully-formed (not fuzzy) link if it starts at the beginning
 * of the string, and null otherwise.
 **/ $6a6d745e641e5984$var$LinkifyIt.prototype.matchAtStart = function matchAtStart(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return null;
    var m = this.re.schema_at_start.exec(text);
    if (!m) return null;
    var len = this.testSchemaAt(text, m[2], m[0].length);
    if (!len) return null;
    this.__schema__ = m[2];
    this.__index__ = m.index + m[1].length;
    this.__last_index__ = m.index + m[0].length + len;
    return $6a6d745e641e5984$var$createMatch(this, 0);
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $6a6d745e641e5984$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $6a6d745e641e5984$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $6a6d745e641e5984$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $6a6d745e641e5984$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = 'http://' + match.url;
    if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) match.url = 'mailto:' + match.url;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $6a6d745e641e5984$var$LinkifyIt.prototype.onCompile = function onCompile() {};
module.exports = $6a6d745e641e5984$var$LinkifyIt;

});
parcelRegister("fmrcY", function(module, exports) {
'use strict';




module.exports = function(opts) {
    var re = {};
    opts = opts || {};
    // Use direct extract instead of `regenerate` to reduse browserified size
    re.src_Any = (parcelRequire("hZcCd")).source;
    re.src_Cc = (parcelRequire("iNnZB")).source;
    re.src_Z = (parcelRequire("23KJ1")).source;
    re.src_P = (parcelRequire("dDBFM")).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join('|');
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join('|');
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    var text_separators = '[><\uff5c]';
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    ////////////////////////////////////////////////////////////////////////////////
    re.src_ip4 = '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    re.src_auth = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';
    re.src_port = '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
    re.src_host_terminator = '(?=$|' + text_separators + '|' + re.src_ZPCc + ')' + '(?!' + (opts['---'] ? '-(?!--)|' : '-|') + '_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';
    re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-;]).|' + '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' + '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' + '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + "\\'(?=" + re.src_pseudo_letter + '|[-])|' + // allow `I'm_king` if no pair found
    '\\.{2,}[a-zA-Z0-9%/&]|' + // google has many dots in "google search" links (#66, #81).
    // github has ... in commit range links,
    // Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // - params separator
    // until more examples found.
    '\\.(?!' + re.src_ZCc + '|[.]|$)|' + (opts['---'] ? '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
     : '\\-+|') + ',(?!' + re.src_ZCc + '|$)|' + // allow `,,,` in paths
    ';(?!' + re.src_ZCc + '|$)|' + // allow `;` if not followed by space-like char
    '\\!+(?!' + re.src_ZCc + '|[!]|$)|' + // allow `!!!` in paths, but not at the end
    '\\?(?!' + re.src_ZCc + '|[?]|$)' + ')+' + '|\\/' + ')?';
    // Allow anything in markdown spec, forbid quote (") at the first position
    // because emails enclosed in quotes are far more common
    re.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*';
    re.src_xn = 'xn--[a-z0-9\\-]{1,59}';
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    '(?:' + re.src_xn + '|' + re.src_pseudo_letter + '{1,63}' + ')';
    re.src_domain = '(?:' + re.src_xn + '|' + '(?:' + re.src_pseudo_letter + ')' + '|' + '(?:' + re.src_pseudo_letter + '(?:-|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' + ')';
    re.src_host = "(?:(?:(?:(?:" + re.src_domain + ')\\.)*' + re.src_domain /*_root*/  + ')' + ')';
    re.tpl_host_fuzzy = '(?:' + re.src_ip4 + '|' + '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' + ')';
    re.tpl_host_no_ip_fuzzy = '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    ////////////////////////////////////////////////////////////////////////////////
    // Main rules
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = 'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';
    re.tpl_email_fuzzy = '(^|' + text_separators + '|"|\\(|' + re.src_ZCc + ')' + '(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';
    return re;
};

});


parcelRegister("4Iqgk", function(module, exports) {
'use strict';
/** Highest positive signed 32-bit float value */ const $36efa4a9e6f7bc26$var$maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
/** Bootstring parameters */ const $36efa4a9e6f7bc26$var$base = 36;
const $36efa4a9e6f7bc26$var$tMin = 1;
const $36efa4a9e6f7bc26$var$tMax = 26;
const $36efa4a9e6f7bc26$var$skew = 38;
const $36efa4a9e6f7bc26$var$damp = 700;
const $36efa4a9e6f7bc26$var$initialBias = 72;
const $36efa4a9e6f7bc26$var$initialN = 128; // 0x80
const $36efa4a9e6f7bc26$var$delimiter = '-'; // '\x2D'
/** Regular expressions */ const $36efa4a9e6f7bc26$var$regexPunycode = /^xn--/;
const $36efa4a9e6f7bc26$var$regexNonASCII = /[^\0-\x7F]/; // Note: U+007F DEL is excluded too.
const $36efa4a9e6f7bc26$var$regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
/** Error messages */ const $36efa4a9e6f7bc26$var$errors = {
    'overflow': 'Overflow: input needs wider integers to process',
    'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
    'invalid-input': 'Invalid input'
};
/** Convenience shortcuts */ const $36efa4a9e6f7bc26$var$baseMinusTMin = $36efa4a9e6f7bc26$var$base - $36efa4a9e6f7bc26$var$tMin;
const $36efa4a9e6f7bc26$var$floor = Math.floor;
const $36efa4a9e6f7bc26$var$stringFromCharCode = String.fromCharCode;
/*--------------------------------------------------------------------------*/ /**
 * A generic error utility function.
 * @private
 * @param {String} type The error type.
 * @returns {Error} Throws a `RangeError` with the applicable error message.
 */ function $36efa4a9e6f7bc26$var$error(type) {
    throw new RangeError($36efa4a9e6f7bc26$var$errors[type]);
}
/**
 * A generic `Array#map` utility function.
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} callback The function that gets called for every array
 * item.
 * @returns {Array} A new array of values returned by the callback function.
 */ function $36efa4a9e6f7bc26$var$map(array, callback) {
    const result = [];
    let length = array.length;
    while(length--)result[length] = callback(array[length]);
    return result;
}
/**
 * A simple `Array#map`-like wrapper to work with domain name strings or email
 * addresses.
 * @private
 * @param {String} domain The domain name or email address.
 * @param {Function} callback The function that gets called for every
 * character.
 * @returns {String} A new string of characters returned by the callback
 * function.
 */ function $36efa4a9e6f7bc26$var$mapDomain(domain, callback) {
    const parts = domain.split('@');
    let result = '';
    if (parts.length > 1) {
        // In email addresses, only the domain name should be punycoded. Leave
        // the local part (i.e. everything up to `@`) intact.
        result = parts[0] + '@';
        domain = parts[1];
    }
    // Avoid `split(regex)` for IE8 compatibility. See #17.
    domain = domain.replace($36efa4a9e6f7bc26$var$regexSeparators, '\x2E');
    const labels = domain.split('.');
    const encoded = $36efa4a9e6f7bc26$var$map(labels, callback).join('.');
    return result + encoded;
}
/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 * @see `punycode.ucs2.encode`
 * @see <https://mathiasbynens.be/notes/javascript-encoding>
 * @memberOf punycode.ucs2
 * @name decode
 * @param {String} string The Unicode input string (UCS-2).
 * @returns {Array} The new array of code points.
 */ function $36efa4a9e6f7bc26$var$ucs2decode(string) {
    const output = [];
    let counter = 0;
    const length = string.length;
    while(counter < length){
        const value = string.charCodeAt(counter++);
        if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
            // It's a high surrogate, and there is a next character.
            const extra = string.charCodeAt(counter++);
            if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
            else {
                // It's an unmatched surrogate; only append this code unit, in case the
                // next code unit is the high surrogate of a surrogate pair.
                output.push(value);
                counter--;
            }
        } else output.push(value);
    }
    return output;
}
/**
 * Creates a string based on an array of numeric code points.
 * @see `punycode.ucs2.decode`
 * @memberOf punycode.ucs2
 * @name encode
 * @param {Array} codePoints The array of numeric code points.
 * @returns {String} The new Unicode string (UCS-2).
 */ const $36efa4a9e6f7bc26$var$ucs2encode = (codePoints)=>String.fromCodePoint(...codePoints);
/**
 * Converts a basic code point into a digit/integer.
 * @see `digitToBasic()`
 * @private
 * @param {Number} codePoint The basic numeric code point value.
 * @returns {Number} The numeric value of a basic code point (for use in
 * representing integers) in the range `0` to `base - 1`, or `base` if
 * the code point does not represent a value.
 */ const $36efa4a9e6f7bc26$var$basicToDigit = function(codePoint) {
    if (codePoint >= 0x30 && codePoint < 0x3A) return 26 + (codePoint - 0x30);
    if (codePoint >= 0x41 && codePoint < 0x5B) return codePoint - 0x41;
    if (codePoint >= 0x61 && codePoint < 0x7B) return codePoint - 0x61;
    return $36efa4a9e6f7bc26$var$base;
};
/**
 * Converts a digit/integer into a basic code point.
 * @see `basicToDigit()`
 * @private
 * @param {Number} digit The numeric value of a basic code point.
 * @returns {Number} The basic code point whose value (when used for
 * representing integers) is `digit`, which needs to be in the range
 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
 * used; else, the lowercase form is used. The behavior is undefined
 * if `flag` is non-zero and `digit` has no uppercase form.
 */ const $36efa4a9e6f7bc26$var$digitToBasic = function(digit, flag) {
    //  0..25 map to ASCII a..z or A..Z
    // 26..35 map to ASCII 0..9
    return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
};
/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 * @private
 */ const $36efa4a9e6f7bc26$var$adapt = function(delta, numPoints, firstTime) {
    let k = 0;
    delta = firstTime ? $36efa4a9e6f7bc26$var$floor(delta / $36efa4a9e6f7bc26$var$damp) : delta >> 1;
    delta += $36efa4a9e6f7bc26$var$floor(delta / numPoints);
    for(; delta > $36efa4a9e6f7bc26$var$baseMinusTMin * $36efa4a9e6f7bc26$var$tMax >> 1; k += $36efa4a9e6f7bc26$var$base)delta = $36efa4a9e6f7bc26$var$floor(delta / $36efa4a9e6f7bc26$var$baseMinusTMin);
    return $36efa4a9e6f7bc26$var$floor(k + ($36efa4a9e6f7bc26$var$baseMinusTMin + 1) * delta / (delta + $36efa4a9e6f7bc26$var$skew));
};
/**
 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
 * symbols.
 * @memberOf punycode
 * @param {String} input The Punycode string of ASCII-only symbols.
 * @returns {String} The resulting string of Unicode symbols.
 */ const $36efa4a9e6f7bc26$var$decode = function(input) {
    // Don't use UCS-2.
    const output = [];
    const inputLength = input.length;
    let i = 0;
    let n = $36efa4a9e6f7bc26$var$initialN;
    let bias = $36efa4a9e6f7bc26$var$initialBias;
    // Handle the basic code points: let `basic` be the number of input code
    // points before the last delimiter, or `0` if there is none, then copy
    // the first basic code points to the output.
    let basic = input.lastIndexOf($36efa4a9e6f7bc26$var$delimiter);
    if (basic < 0) basic = 0;
    for(let j = 0; j < basic; ++j){
        // if it's not a basic code point
        if (input.charCodeAt(j) >= 0x80) $36efa4a9e6f7bc26$var$error('not-basic');
        output.push(input.charCodeAt(j));
    }
    // Main decoding loop: start just after the last delimiter if any basic code
    // points were copied; start at the beginning otherwise.
    for(let index = basic > 0 ? basic + 1 : 0; index < inputLength;){
        // `index` is the index of the next character to be consumed.
        // Decode a generalized variable-length integer into `delta`,
        // which gets added to `i`. The overflow checking is easier
        // if we increase `i` as we go, then subtract off its starting
        // value at the end to obtain `delta`.
        const oldi = i;
        for(let w = 1, k = $36efa4a9e6f7bc26$var$base;; k += $36efa4a9e6f7bc26$var$base){
            if (index >= inputLength) $36efa4a9e6f7bc26$var$error('invalid-input');
            const digit = $36efa4a9e6f7bc26$var$basicToDigit(input.charCodeAt(index++));
            if (digit >= $36efa4a9e6f7bc26$var$base) $36efa4a9e6f7bc26$var$error('invalid-input');
            if (digit > $36efa4a9e6f7bc26$var$floor(($36efa4a9e6f7bc26$var$maxInt - i) / w)) $36efa4a9e6f7bc26$var$error('overflow');
            i += digit * w;
            const t = k <= bias ? $36efa4a9e6f7bc26$var$tMin : k >= bias + $36efa4a9e6f7bc26$var$tMax ? $36efa4a9e6f7bc26$var$tMax : k - bias;
            if (digit < t) break;
            const baseMinusT = $36efa4a9e6f7bc26$var$base - t;
            if (w > $36efa4a9e6f7bc26$var$floor($36efa4a9e6f7bc26$var$maxInt / baseMinusT)) $36efa4a9e6f7bc26$var$error('overflow');
            w *= baseMinusT;
        }
        const out = output.length + 1;
        bias = $36efa4a9e6f7bc26$var$adapt(i - oldi, out, oldi == 0);
        // `i` was supposed to wrap around from `out` to `0`,
        // incrementing `n` each time, so we'll fix that now:
        if ($36efa4a9e6f7bc26$var$floor(i / out) > $36efa4a9e6f7bc26$var$maxInt - n) $36efa4a9e6f7bc26$var$error('overflow');
        n += $36efa4a9e6f7bc26$var$floor(i / out);
        i %= out;
        // Insert `n` at position `i` of the output.
        output.splice(i++, 0, n);
    }
    return String.fromCodePoint(...output);
};
/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 * @memberOf punycode
 * @param {String} input The string of Unicode symbols.
 * @returns {String} The resulting Punycode string of ASCII-only symbols.
 */ const $36efa4a9e6f7bc26$var$encode = function(input) {
    const output = [];
    // Convert the input in UCS-2 to an array of Unicode code points.
    input = $36efa4a9e6f7bc26$var$ucs2decode(input);
    // Cache the length.
    const inputLength = input.length;
    // Initialize the state.
    let n = $36efa4a9e6f7bc26$var$initialN;
    let delta = 0;
    let bias = $36efa4a9e6f7bc26$var$initialBias;
    // Handle the basic code points.
    for (const currentValue of input)if (currentValue < 0x80) output.push($36efa4a9e6f7bc26$var$stringFromCharCode(currentValue));
    const basicLength = output.length;
    let handledCPCount = basicLength;
    // `handledCPCount` is the number of code points that have been handled;
    // `basicLength` is the number of basic code points.
    // Finish the basic string with a delimiter unless it's empty.
    if (basicLength) output.push($36efa4a9e6f7bc26$var$delimiter);
    // Main encoding loop:
    while(handledCPCount < inputLength){
        // All non-basic code points < n have been handled already. Find the next
        // larger one:
        let m = $36efa4a9e6f7bc26$var$maxInt;
        for (const currentValue of input)if (currentValue >= n && currentValue < m) m = currentValue;
        // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
        // but guard against overflow.
        const handledCPCountPlusOne = handledCPCount + 1;
        if (m - n > $36efa4a9e6f7bc26$var$floor(($36efa4a9e6f7bc26$var$maxInt - delta) / handledCPCountPlusOne)) $36efa4a9e6f7bc26$var$error('overflow');
        delta += (m - n) * handledCPCountPlusOne;
        n = m;
        for (const currentValue of input){
            if (currentValue < n && ++delta > $36efa4a9e6f7bc26$var$maxInt) $36efa4a9e6f7bc26$var$error('overflow');
            if (currentValue === n) {
                // Represent delta as a generalized variable-length integer.
                let q = delta;
                for(let k = $36efa4a9e6f7bc26$var$base;; k += $36efa4a9e6f7bc26$var$base){
                    const t = k <= bias ? $36efa4a9e6f7bc26$var$tMin : k >= bias + $36efa4a9e6f7bc26$var$tMax ? $36efa4a9e6f7bc26$var$tMax : k - bias;
                    if (q < t) break;
                    const qMinusT = q - t;
                    const baseMinusT = $36efa4a9e6f7bc26$var$base - t;
                    output.push($36efa4a9e6f7bc26$var$stringFromCharCode($36efa4a9e6f7bc26$var$digitToBasic(t + qMinusT % baseMinusT, 0)));
                    q = $36efa4a9e6f7bc26$var$floor(qMinusT / baseMinusT);
                }
                output.push($36efa4a9e6f7bc26$var$stringFromCharCode($36efa4a9e6f7bc26$var$digitToBasic(q, 0)));
                bias = $36efa4a9e6f7bc26$var$adapt(delta, handledCPCountPlusOne, handledCPCount === basicLength);
                delta = 0;
                ++handledCPCount;
            }
        }
        ++delta;
        ++n;
    }
    return output.join('');
};
/**
 * Converts a Punycode string representing a domain name or an email address
 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
 * it doesn't matter if you call it on a string that has already been
 * converted to Unicode.
 * @memberOf punycode
 * @param {String} input The Punycoded domain name or email address to
 * convert to Unicode.
 * @returns {String} The Unicode representation of the given Punycode
 * string.
 */ const $36efa4a9e6f7bc26$var$toUnicode = function(input) {
    return $36efa4a9e6f7bc26$var$mapDomain(input, function(string) {
        return $36efa4a9e6f7bc26$var$regexPunycode.test(string) ? $36efa4a9e6f7bc26$var$decode(string.slice(4).toLowerCase()) : string;
    });
};
/**
 * Converts a Unicode string representing a domain name or an email address to
 * Punycode. Only the non-ASCII parts of the domain name will be converted,
 * i.e. it doesn't matter if you call it with a domain that's already in
 * ASCII.
 * @memberOf punycode
 * @param {String} input The domain name or email address to convert, as a
 * Unicode string.
 * @returns {String} The Punycode representation of the given domain name or
 * email address.
 */ const $36efa4a9e6f7bc26$var$toASCII = function(input) {
    return $36efa4a9e6f7bc26$var$mapDomain(input, function(string) {
        return $36efa4a9e6f7bc26$var$regexNonASCII.test(string) ? 'xn--' + $36efa4a9e6f7bc26$var$encode(string) : string;
    });
};
/*--------------------------------------------------------------------------*/ /** Define the public API */ const $36efa4a9e6f7bc26$var$punycode = {
    /**
	 * A string representing the current Punycode.js version number.
	 * @memberOf punycode
	 * @type String
	 */ 'version': '2.3.1',
    /**
	 * An object of methods to convert from JavaScript's internal character
	 * representation (UCS-2) to Unicode code points, and back.
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode
	 * @type Object
	 */ 'ucs2': {
        'decode': $36efa4a9e6f7bc26$var$ucs2decode,
        'encode': $36efa4a9e6f7bc26$var$ucs2encode
    },
    'decode': $36efa4a9e6f7bc26$var$decode,
    'encode': $36efa4a9e6f7bc26$var$encode,
    'toASCII': $36efa4a9e6f7bc26$var$toASCII,
    'toUnicode': $36efa4a9e6f7bc26$var$toUnicode
};
module.exports = $36efa4a9e6f7bc26$var$punycode;

});

parcelRegister("jbZa8", function(module, exports) {
// markdown-it default options
'use strict';
module.exports = {
    options: {
        html: false,
        xhtmlOut: false,
        breaks: false,
        langPrefix: 'language-',
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: '\u201c\u201d\u2018\u2019',
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        maxNesting: 100 // Internal protection, recursion limit
    },
    components: {
        core: {},
        block: {},
        inline: {}
    }
};

});

parcelRegister("4Ggn6", function(module, exports) {
// "Zero" preset, with nothing enabled. Useful for manual configuring of simple
// modes. For example, to parse bold/italic only.
'use strict';
module.exports = {
    options: {
        html: false,
        xhtmlOut: false,
        breaks: false,
        langPrefix: 'language-',
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: '\u201c\u201d\u2018\u2019',
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        maxNesting: 20 // Internal protection, recursion limit
    },
    components: {
        core: {
            rules: [
                'normalize',
                'block',
                'inline',
                'text_join'
            ]
        },
        block: {
            rules: [
                'paragraph'
            ]
        },
        inline: {
            rules: [
                'text'
            ],
            rules2: [
                'balance_pairs',
                'fragments_join'
            ]
        }
    }
};

});

parcelRegister("5Yj6L", function(module, exports) {
// Commonmark default options
'use strict';
module.exports = {
    options: {
        html: true,
        xhtmlOut: true,
        breaks: false,
        langPrefix: 'language-',
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: '\u201c\u201d\u2018\u2019',
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        maxNesting: 20 // Internal protection, recursion limit
    },
    components: {
        core: {
            rules: [
                'normalize',
                'block',
                'inline',
                'text_join'
            ]
        },
        block: {
            rules: [
                'blockquote',
                'code',
                'fence',
                'heading',
                'hr',
                'html_block',
                'lheading',
                'list',
                'reference',
                'paragraph'
            ]
        },
        inline: {
            rules: [
                'autolink',
                'backticks',
                'emphasis',
                'entity',
                'escape',
                'html_inline',
                'image',
                'link',
                'newline',
                'text'
            ],
            rules2: [
                'balance_pairs',
                'emphasis',
                'fragments_join'
            ]
        }
    }
};

});



parcelRegister("ixJuK", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ee9ca0aeb7749da$export$2e2bcd8739ae039);
/*
 * ED-15646
 * Headings in list items are not supported in our schema.
 * As the markdown transformer is used by the paste plugin,
 * certain pastes will strip invalid lines as
 * prosemirror-markdown cannot conform to the schema
 */ function $1ee9ca0aeb7749da$var$handleHeadingOpen(state, token, acc, index) {
    const isInListItem = state.tokens[index - 1]?.type === 'list_item_open';
    if (isInListItem) acc.push(new state.Token('paragraph_open', 'p', 1));
    else acc.push(token);
}
function $1ee9ca0aeb7749da$var$handleHeadingClose(state, token, acc, index) {
    const isInListItem = state.tokens[index + 1]?.type === 'list_item_close';
    if (isInListItem) acc.push(new state.Token('paragraph_close', 'p', -1));
    else acc.push(token);
}
function $1ee9ca0aeb7749da$export$2e2bcd8739ae039(md) {
    md.core.ruler.after('inline', 'ignore-list-heading-md-plugin', function(state) {
        state.tokens = state.tokens.reduce((acc, token, index)=>{
            const { type: type } = token;
            if (type === 'heading_open') $1ee9ca0aeb7749da$var$handleHeadingOpen(state, token, acc, index);
            else if (type === 'heading_close') $1ee9ca0aeb7749da$var$handleHeadingClose(state, token, acc, index);
            else acc.push(token);
            return acc;
        }, []);
    });
}

});

parcelRegister("hvgYN", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecd6c54f35ffc584$export$2e2bcd8739ae039);
// File has been copied to packages/editor/editor-plugin-ai/src/provider/markdown-transformer/md/linkify-md-plugin.ts
// If changes are made to this file, please make the same update in the linked file.
// See https://product-fabric.atlassian.net/browse/ED-3097 for why this file exists.

var $ap5nJ = parcelRequire("ap5nJ");

var $iKozC = parcelRequire("iKozC");

var $grDTV = parcelRequire("grDTV");
var $8YVeS = parcelRequire("8YVeS");
// modified version of the original markdown-it Linkify plugin
// https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/linkify.js
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ecd6c54f35ffc584$var$arrayReplaceAt = (src, pos, newElements)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return [].concat(src.slice(0, pos), newElements, src.slice(pos + 1));
};
const $ecd6c54f35ffc584$var$isLinkOpen = (str)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return /^<a[>\s]/i.test(str);
};
const $ecd6c54f35ffc584$var$isLinkClose = (str)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return /^<\/a\s*>/i.test(str);
};
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ecd6c54f35ffc584$var$linkify = (state)=>{
    const blockTokens = state.tokens;
    const linkify = new (0, (/*@__PURE__*/$parcel$interopDefault($ap5nJ)))();
    for(let j = 0, l = blockTokens.length; j < l; j++){
        if (blockTokens[j].type !== 'inline' || !linkify.pretest(blockTokens[j].content)) continue;
        let tokens = blockTokens[j].children;
        let htmlLinkLevel = 0;
        // We scan from the end, to keep position when new tags added.
        // Use reversed logic in links start/end match
        for(let i = tokens.length - 1; i >= 0; i--){
            const currentToken = tokens[i];
            // Skip content of markdown links
            if (currentToken.type === 'link_close') {
                i--;
                while(tokens[i].level !== currentToken.level && tokens[i].type !== 'link_open')i--;
                continue;
            }
            // Skip content of html tag links
            if (currentToken.type === 'html_inline') {
                if ($ecd6c54f35ffc584$var$isLinkOpen(currentToken.content) && htmlLinkLevel > 0) htmlLinkLevel--;
                if ($ecd6c54f35ffc584$var$isLinkClose(currentToken.content)) htmlLinkLevel++;
            }
            if (htmlLinkLevel > 0) continue;
            if (currentToken.type === 'text' && linkify.test(currentToken.content)) {
                const text = currentToken.content;
                let links = (0, $iKozC.linkifyMatch)(text);
                if (!links.length) links = linkify.match(text) || [];
                links = links.filter((link)=>(0, $8YVeS.shouldAutoLinkifyMatch)(link));
                // Now split string to nodes
                const nodes = [];
                let level = currentToken.level;
                let lastPos = 0;
                const filepaths = (0, $grDTV.findFilepaths)(text);
                for(let ln = 0; ln < links.length; ln++){
                    if ((0, $grDTV.isLinkInMatches)(links[ln].index, filepaths)) continue;
                    const { url: url } = links[ln];
                    const fullUrl = state.md.normalizeLink(url);
                    if (!state.md.validateLink(fullUrl)) continue;
                    let urlText = links[ln].text;
                    // Linkifier might send raw hostnames like "example.com", where url
                    // starts with domain name. So we prepend http:// in those cases,
                    // and remove it afterwards.
                    //
                    if (!links[ln].schema) // Ignored via go/ees005
                    // eslint-disable-next-line require-unicode-regexp
                    urlText = state.md.normalizeLinkText('http://' + urlText).replace(/^http:\/\//, '');
                    else if (links[ln].schema === 'mailto:' && !/^mailto:/i.test(urlText)) // Ignored via go/ees005
                    // eslint-disable-next-line require-unicode-regexp
                    urlText = state.md.normalizeLinkText('mailto:' + urlText).replace(/^mailto:/, '');
                    else urlText = state.md.normalizeLinkText(urlText);
                    const pos = links[ln].index;
                    if (pos > lastPos) {
                        const token = new state.Token('text', '', 0);
                        token.content = text.slice(lastPos, pos);
                        token.level = level;
                        nodes.push(token);
                    }
                    let token = new state.Token('link_open', 'a', 1);
                    token.attrs = [
                        [
                            'href',
                            fullUrl
                        ]
                    ];
                    token.level = level++;
                    token.markup = 'linkify';
                    token.info = 'auto';
                    nodes.push(token);
                    token = new state.Token('text', '', 0);
                    token.content = urlText;
                    token.level = level;
                    nodes.push(token);
                    token = new state.Token('link_close', 'a', -1);
                    token.level = --level;
                    token.markup = 'linkify';
                    token.info = 'auto';
                    nodes.push(token);
                    lastPos = links[ln].lastIndex;
                }
                if (lastPos < text.length) {
                    const token = new state.Token('text', '', 0);
                    token.content = text.slice(lastPos);
                    token.level = level;
                    nodes.push(token);
                }
                // replace current node
                blockTokens[j].children = tokens = $ecd6c54f35ffc584$var$arrayReplaceAt(tokens, i, nodes);
            }
        }
    }
};
var // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$ecd6c54f35ffc584$export$2e2bcd8739ae039 = (md)=>md.core.ruler.push('custom-linkify', $ecd6c54f35ffc584$var$linkify);

});

parcelRegister("5vTT1", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c46f60ab21316a6$export$2e2bcd8739ae039);
// File has been copied to packages/editor/editor-plugin-ai/src/provider/markdown-transformer/md/newline-md-plugin.ts
// If changes are made to this file, please make the same update in the linked file.
// ED-15363: modified version of the original newline plugin
// https://github.com/markdown-it/markdown-it/blob/master/lib/rules_inline/newline.js
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $5c46f60ab21316a6$var$newline = (state, silent)=>{
    let pos = state.pos;
    // ED-15363: unread variables
    // max,
    // ws,
    if (state.src.charCodeAt(pos) !== 0x0a /* \n */ ) return false;
    const pmax = state.pending.length - 1;
    // ED-15363: unread variable
    // max = state.posMax;
    // '  \n' -> hardbreak
    // Lookup in pending chars is bad practice! Don't copy to other rules!
    // Pending string is stored in concat mode, indexed lookups will cause
    // convertion to flat mode.
    if (!silent) {
        if (pmax >= 0 && state.pending.charCodeAt(pmax) === 0x20) {
            if (pmax >= 1 && state.pending.charCodeAt(pmax - 1) === 0x20) // ED-15363: We commented out this logic to preserve trailing whitespaces
            // for each line of text when pasting plain text
            // // Find whitespaces tail of pending chars.
            // ws = pmax - 1;
            // while (ws >= 1 && state.pending.charCodeAt(ws - 1) === 0x20) {
            //   ws--;
            // }
            // state.pending = state.pending.slice(0, ws);
            state.push('hardbreak', 'br', 0);
            else {
                state.pending = state.pending.slice(0, -1);
                state.push('softbreak', 'br', 0);
            }
        } else state.push('softbreak', 'br', 0);
    }
    pos++;
    // ED-15363: We commented out this logic from the original library to
    // preserve leading whitespaces for each line of text when pasting plain
    // text (to preserve whitespace-based indentation).
    // // skip heading spaces for next line
    // while (pos < max && isSpace(state.src.charCodeAt(pos))) {
    //   pos++;
    // }
    state.pos = pos;
    return true;
};
var // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$5c46f60ab21316a6$export$2e2bcd8739ae039 = (md)=>md.inline.ruler.at('newline', $5c46f60ab21316a6$var$newline);

});

parcelRegister("25i5a", function(module, exports) {

$parcel$export(module.exports, "default", () => $48f47d3b3722c3f1$export$2e2bcd8739ae039);
// File has been copied to packages/editor/editor-plugin-ai/src/provider/markdown-transformer/md/paragraph-md-plugin.ts
// If changes are made to this file, please make the same update in the linked file.
// ED-15363: modified version of the original paragraph plugin
// https://github.com/markdown-it/markdown-it/blob/master/lib/rules_block/paragraph.js
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $48f47d3b3722c3f1$var$paragraph = (state, startLine /*, endLine*/ )=>{
    let terminate, i, l, token, nextLine = startLine + 1;
    const terminatorRules = state.md.block.ruler.getRules('paragraph');
    const endLine = state.lineMax;
    const oldParentType = state.parentType;
    state.parentType = 'paragraph';
    // jump line-by-line until empty one or EOF
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    // ED-15363: We removed .trim() from this logic from the original library to
    // preserve leading whitespaces at the beginning and end of paragraph blocks
    // when pasting plain text (to preserve whitespace-based indentation, at the
    // beginning and end of paragraphs).
    // content = state.getLines(startLine, nextLine, state.blkIndent, false) .trim()
    const content = state.getLines(startLine, nextLine, state.blkIndent, false);
    state.line = nextLine;
    token = state.push('paragraph_open', 'p', 1);
    token.map = [
        startLine,
        state.line
    ];
    token = state.push('inline', '', 0);
    token.content = content;
    token.map = [
        startLine,
        state.line
    ];
    token.children = [];
    token = state.push('paragraph_close', 'p', -1);
    state.parentType = oldParentType;
    return true;
};
var // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$48f47d3b3722c3f1$export$2e2bcd8739ae039 = (md)=>md.block.ruler.at('paragraph', $48f47d3b3722c3f1$var$paragraph);

});



parcelRegister("gXgTX", function(module, exports) {

$parcel$export(module.exports, "appearanceForNodeType", () => $000aaea76099b9d6$export$71376de76fa352d1);
$parcel$export(module.exports, "selectedCardAppearance", () => $000aaea76099b9d6$export$a5ff7aecd33e6813);
$parcel$export(module.exports, "titleUrlPairFromNode", () => $000aaea76099b9d6$export$15bc29504ff06986);
$parcel$export(module.exports, "displayInfoForCard", () => $000aaea76099b9d6$export$a6fcef6250c64f76);
$parcel$export(module.exports, "findCardInfo", () => $000aaea76099b9d6$export$f3f2332ef0853029);
$parcel$export(module.exports, "isEmbedSupportedAtPosition", () => $000aaea76099b9d6$export$b31d21baab1bb9f);
$parcel$export(module.exports, "isBlockSupportedAtPosition", () => $000aaea76099b9d6$export$290208dc31723a19);
$parcel$export(module.exports, "getResolvedAttributesFromStore", () => $000aaea76099b9d6$export$a0e5429851d8d8a9);
$parcel$export(module.exports, "isDatasourceConfigEditable", () => $000aaea76099b9d6$export$c677d64dd26b7aa2);
$parcel$export(module.exports, "isDatasourceNode", () => $000aaea76099b9d6$export$962cfe99b8da8614);
$parcel$export(module.exports, "focusEditorView", () => $000aaea76099b9d6$export$bab6ff782a349bd3);
$parcel$export(module.exports, "getAwarenessProps", () => $000aaea76099b9d6$export$ea8b03e32bcc0b2d);

var $3xw6l = parcelRequire("3xw6l");

var $3lIcL = parcelRequire("3lIcL");

var $wq6W1 = parcelRequire("wq6W1");

var $k9y0J = parcelRequire("k9y0J");
var $7BBxG = parcelRequire("7BBxG");
var $7KhEE = parcelRequire("7KhEE");

var $cuJUr = parcelRequire("cuJUr");
const $000aaea76099b9d6$export$71376de76fa352d1 = (spec)=>{
    if (spec.name === 'inlineCard') return 'inline';
    else if (spec.name === 'blockCard') return 'block';
    else if (spec.name === 'embedCard') return 'embed';
    return;
};
const $000aaea76099b9d6$export$a5ff7aecd33e6813 = (state)=>{
    if (state.selection instanceof (0, $3lIcL.NodeSelection)) return $000aaea76099b9d6$export$71376de76fa352d1(state.selection.node.type);
};
const $000aaea76099b9d6$export$15bc29504ff06986 = (node)=>{
    const { attrs: attrs } = node;
    return {
        url: attrs.url || attrs.data && attrs.data.url,
        title: attrs.data && attrs.data.title
    };
};
const $000aaea76099b9d6$export$fe497395c317d106 = (titleUrlPair, info)=>{
    return {
        title: info && info.title || titleUrlPair.title,
        url: info && info.url || titleUrlPair.url
    };
};
const $000aaea76099b9d6$export$a6fcef6250c64f76 = (node, info)=>$000aaea76099b9d6$export$fe497395c317d106($000aaea76099b9d6$export$15bc29504ff06986(node), info);
const $000aaea76099b9d6$export$f3f2332ef0853029 = (state)=>{
    const pluginState = (0, $cuJUr.pluginKey).getState(state);
    if (!pluginState) return undefined;
    return pluginState.cards.find((cardInfo)=>cardInfo.pos === state.selection.from);
};
const $000aaea76099b9d6$var$isAppearanceSupportedInParent = (currentNodePosition, editorState, fragment, currentAppearance)=>{
    const resolvedPosition = editorState.doc.resolve(currentNodePosition);
    const parent = currentAppearance === 'embed' || currentAppearance === 'block' ? resolvedPosition.node() : resolvedPosition.node(-1);
    return parent && parent.type.validContent(fragment);
};
const $000aaea76099b9d6$export$b31d21baab1bb9f = (currentNodePosition, editorState, currentAppearance)=>$000aaea76099b9d6$var$isAppearanceSupportedInParent(currentNodePosition, editorState, (0, $3xw6l.Fragment).from(editorState.schema.nodes.embedCard.createChecked({})), currentAppearance);
const $000aaea76099b9d6$export$290208dc31723a19 = (currentNodePosition, editorState, currentAppearance)=>$000aaea76099b9d6$var$isAppearanceSupportedInParent(currentNodePosition, editorState, (0, $3xw6l.Fragment).from(editorState.schema.nodes.blockCard.createChecked({})), currentAppearance);
const $000aaea76099b9d6$export$a0e5429851d8d8a9 = (url, display, store)=>{
    if (!store) return {};
    const urlState = store?.getState()[url];
    const displayCategory = display === 'url' ? 'link' : undefined;
    return (0, $wq6W1.getResolvedAttributes)({
        url: url,
        displayCategory: displayCategory
    }, urlState?.details);
};
const $000aaea76099b9d6$export$c677d64dd26b7aa2 = (datasourceId)=>{
    const datasourcesWithConfigModal = [
        (0, $7KhEE.JIRA_LIST_OF_LINKS_DATASOURCE_ID),
        (0, $k9y0J.ASSETS_LIST_OF_LINKS_DATASOURCE_ID),
        (0, $7BBxG.CONFLUENCE_SEARCH_DATASOURCE_ID)
    ];
    return datasourcesWithConfigModal.includes(datasourceId);
};
const $000aaea76099b9d6$export$48ba7bd006cffb5e = (attrs)=>{
    // Check is attributes object
    if (!(typeof attrs === 'object' && attrs !== null)) return false;
    // Check datasource attribute is an object
    if (!('datasource' in attrs)) return false;
    if (typeof attrs.datasource !== 'object' || attrs.datasource === null) return false;
    const hasId = 'id' in attrs.datasource && typeof attrs.datasource.id === 'string';
    const hasParameters = 'parameters' in attrs.datasource && typeof attrs.datasource.parameters === 'object' && attrs.datasource.parameters !== null && !Array.isArray(attrs.datasource.parameters);
    const hasViews = 'views' in attrs.datasource && Array.isArray(attrs.datasource.views);
    return hasId && hasParameters && hasViews;
};
const $000aaea76099b9d6$export$962cfe99b8da8614 = (node)=>{
    if (!node) return false;
    return node.type.name === 'blockCard' && $000aaea76099b9d6$export$48ba7bd006cffb5e(node.attrs);
};
const $000aaea76099b9d6$export$bab6ff782a349bd3 = (editorView)=>{
    if (!editorView.hasFocus()) editorView.focus();
};
const $000aaea76099b9d6$export$ea8b03e32bcc0b2d = (editorState, getPos, allowEmbeds, allowBlockCards, disableOverlay = false)=>{
    const getPosFunction = typeof getPos !== 'boolean' ? getPos : undefined;
    const linkPosition = getPosFunction?.();
    const canBeUpgradedToEmbed = !!linkPosition && allowEmbeds ? $000aaea76099b9d6$export$b31d21baab1bb9f(linkPosition, editorState, 'inline') : false;
    const canBeUpgradedToBlock = !!linkPosition && allowBlockCards ? $000aaea76099b9d6$export$290208dc31723a19(linkPosition, editorState, 'inline') : false;
    const isSelected = editorState.selection instanceof (0, $3lIcL.NodeSelection) && editorState.selection?.node?.type === editorState.schema.nodes.inlineCard && editorState.selection?.from === getPosFunction?.();
    return {
        isPulseEnabled: canBeUpgradedToEmbed,
        isOverlayEnabled: !disableOverlay && (canBeUpgradedToEmbed || canBeUpgradedToBlock),
        isSelected: isSelected
    };
};

});
parcelRegister("wq6W1", function(module, exports) {

$parcel$export(module.exports, "getResolvedAttributes", () => $05ccd9b6e0c82253$export$7243431f5325a7b);

var $4g7cp = parcelRequire("4g7cp");

var $6jgT3 = parcelRequire("6jgT3");

var $eGOwo = parcelRequire("eGOwo");
const $05ccd9b6e0c82253$export$7243431f5325a7b = (linkDetails, details, linkStatus, error)=>{
    const status = linkStatus ?? (details && (0, $4g7cp.getStatus)(details));
    const displayCategory = linkDetails.displayCategory === 'link' ? 'link' : (0, $6jgT3.getDisplayCategory)(status);
    return {
        status: status ?? null,
        statusDetails: details?.meta?.requestAccess?.accessType ?? null,
        displayCategory: displayCategory,
        extensionKey: (0, $eGOwo.fg)('platform_bandicoots-smartlink-unresolved-error-key') ? details?.meta?.key ?? error?.extensionKey ?? null : details?.meta?.key ?? null,
        destinationTenantId: details?.meta?.tenantId ?? null,
        destinationActivationId: details?.meta?.activationId ?? null,
        destinationContainerId: details?.meta?.containerId ?? null,
        destinationCategory: details?.meta?.category ?? null,
        destinationProduct: details?.meta?.product ?? null,
        destinationSubproduct: details?.meta?.subproduct ?? null,
        destinationObjectId: details?.meta?.objectId ?? null,
        destinationObjectType: details?.meta?.resourceType ?? null,
        canBeDatasource: (details?.datasources || []).length > 0
    };
};

});
parcelRegister("6jgT3", function(module, exports) {

$parcel$export(module.exports, "getDisplayCategory", () => $e94b2157750adb74$export$28ddbae335bd80b5);
const $e94b2157750adb74$export$28ddbae335bd80b5 = (status)=>{
    return !status || status !== 'not_found' ? 'smartLink' : 'link';
};

});




parcelRegister("kDpD9", function(module, exports) {

$parcel$export(module.exports, "cardKeymap", () => $7d292b16e3e0e8ef$export$fc7a7a088775f35d);

var $7EdFW = parcelRequire("7EdFW");

var $6Exgk = parcelRequire("6Exgk");

var $x7sgX = parcelRequire("x7sgX");

var $3lIcL = parcelRequire("3lIcL");

var $BmspC = parcelRequire("BmspC");
const $7d292b16e3e0e8ef$var$lookupPixel = 10;
const $7d292b16e3e0e8ef$var$getClosestInlineCardPos = (state, editorView, direction)=>{
    const { selection: selection } = state;
    const { parent: parent } = selection.$from;
    const inlineCardType = state.schema.nodes.inlineCard;
    if (!(0, $BmspC.flatten)(parent, false).some(({ node: node })=>node.type === inlineCardType)) return null;
    const coord = editorView.coordsAtPos(selection.$anchor.pos);
    const nearPos = editorView.posAtCoords({
        left: coord.left,
        top: direction === 'up' ? coord.top - $7d292b16e3e0e8ef$var$lookupPixel : coord.bottom + $7d292b16e3e0e8ef$var$lookupPixel
    })?.inside;
    if (typeof nearPos === 'number' && nearPos > -1) {
        const newNode = state.doc.nodeAt(nearPos);
        if (newNode) {
            if (newNode.type !== inlineCardType || (0, $BmspC.findChildren)(parent, (node)=>node === newNode, false).length === 0 || newNode === selection.node) return null;
            return nearPos;
        }
    }
    return null;
};
const $7d292b16e3e0e8ef$var$selectAboveBelowInlineCard = (direction)=>{
    return (state, dispatch, editorView)=>{
        if (!editorView || !dispatch) return false;
        const pos = $7d292b16e3e0e8ef$var$getClosestInlineCardPos(state, editorView, direction);
        if (pos) {
            dispatch(state.tr.setSelection(new (0, $3lIcL.NodeSelection)(state.doc.resolve(pos))));
            return true;
        }
        return false;
    };
};
function $7d292b16e3e0e8ef$export$fc7a7a088775f35d(featureFlags) {
    const list = {};
    // https://bugs.chromium.org/p/chromium/issues/detail?id=1227468 introduced since Chrome 91
    if ((0, $7EdFW.browser).chrome && (0, $7EdFW.browser).chrome_version > 90) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $6Exgk.bindKeymapWithCommand)((0, $6Exgk.moveUp).common, $7d292b16e3e0e8ef$var$selectAboveBelowInlineCard('up'), list);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $6Exgk.bindKeymapWithCommand)((0, $6Exgk.moveDown).common, $7d292b16e3e0e8ef$var$selectAboveBelowInlineCard('down'), list);
    }
    return (0, $x7sgX.keymap)(list);
}

});

parcelRegister("7CcXr", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $f7023b7c834ef2cc$export$ae829ec7b2625219);

var $bRPNB = parcelRequire("bRPNB");

var $T8owb = parcelRequire("T8owb");

var $i8KtF = parcelRequire("i8KtF");

var $hkyHj = parcelRequire("hkyHj");

var $3lIcL = parcelRequire("3lIcL");

var $BmspC = parcelRequire("BmspC");


var $eGOwo = parcelRequire("eGOwo");

var $8NXVj = parcelRequire("8NXVj");

var $9tfE8 = parcelRequire("9tfE8");

var $ewKS2 = parcelRequire("ewKS2");

var $8y3X6 = parcelRequire("8y3X6");

var $59QiN = parcelRequire("59QiN");

var $37WZl = parcelRequire("37WZl");

var $d62Vl = parcelRequire("d62Vl");

var $ecNk4 = parcelRequire("ecNk4");

var $cuJUr = parcelRequire("cuJUr");

var $cPbXA = parcelRequire("cPbXA");

var $9SMdd = parcelRequire("9SMdd");

var $d3z4A = parcelRequire("d3z4A");

var $gXgTX = parcelRequire("gXgTX");
const $f7023b7c834ef2cc$var$LOCAL_STORAGE_DISCOVERY_KEY_SMART_LINK = 'smart-link-upgrade-pulse';
const $f7023b7c834ef2cc$export$ee666af8a9b19e18 = 'card-plugin-element-allow-events';
const $f7023b7c834ef2cc$export$7ae4cd3a66c1e050 = (event)=>{
    if (!(0, $eGOwo.fg)('linking_platform_smart_links_in_live_pages')) return false;
    const target = event.target;
    // Stop events from propogating to prose-mirror and selecting the node and/or
    // opening the toolbar, unless a parent of the target has a defined className
    if (target instanceof HTMLElement && target.closest(`.${$f7023b7c834ef2cc$export$ee666af8a9b19e18}`)) return false;
    return true;
};
const $f7023b7c834ef2cc$var$handleAwarenessOverlay = (view)=>{
    const currentState = (0, $d3z4A.getPluginState)(view.state);
    const overlayCandidatePos = currentState?.overlayCandidatePosition;
    if (overlayCandidatePos) {
        currentState.removeOverlay?.();
        const tr = view.state.tr;
        (0, $ecNk4.clearOverlayCandidate)(tr);
        view.dispatch(tr);
    }
};
const $f7023b7c834ef2cc$export$ae829ec7b2625219 = (options, pluginInjectionApi)=>(pmPluginFactoryParams)=>{
        const { editorAppearance: editorAppearance, allowResizing: allowResizing, useAlternativePreloader: useAlternativePreloader, fullWidthMode: fullWidthMode, actionOptions: actionOptions, cardPluginEvents: cardPluginEvents, showUpgradeDiscoverability: showUpgradeDiscoverability, allowEmbeds: allowEmbeds, allowBlockCards: allowBlockCards, onClickCallback: onClickCallback, __livePage: // @ts-ignore Temporary solution to check for Live Page editor.
        __livePage, isPageSSRed: isPageSSRed, CompetitorPrompt: CompetitorPrompt } = options;
        const enableInlineUpgradeFeatures = !!showUpgradeDiscoverability;
        const inlineCardViewProducer = (0, $T8owb.getInlineNodeViewProducer)({
            pmPluginFactoryParams: pmPluginFactoryParams,
            Component: (0, $8NXVj.InlineCardNodeView),
            extraComponentProps: {
                useAlternativePreloader: useAlternativePreloader,
                actionOptions: actionOptions,
                enableInlineUpgradeFeatures: enableInlineUpgradeFeatures,
                allowEmbeds: allowEmbeds,
                allowBlockCards: allowBlockCards,
                pluginInjectionApi: pluginInjectionApi,
                onClickCallback: onClickCallback,
                __livePage: __livePage,
                isPageSSRed: isPageSSRed,
                CompetitorPrompt: CompetitorPrompt
            },
            ...__livePage && (0, $eGOwo.fg)('linking_platform_smart_links_in_live_pages') && {
                extraNodeViewProps: {
                    stopEvent: $f7023b7c834ef2cc$export$7ae4cd3a66c1e050
                }
            }
        });
        return new (0, $i8KtF.SafePlugin)({
            state: {
                init () {
                    return {
                        requests: [],
                        provider: null,
                        cards: [],
                        datasourceStash: {},
                        showLinkingToolbar: false,
                        smartLinkEvents: undefined,
                        editorAppearance: editorAppearance,
                        showDatasourceModal: false,
                        datasourceModalType: undefined,
                        datasourceTableRef: undefined,
                        layout: undefined
                    };
                },
                apply (tr, pluginState, prevEditorState) {
                    // Update all the positions of outstanding requests and
                    // cards in the plugin state.
                    const pluginStateWithUpdatedPos = (0, $d3z4A.getPluginStateWithUpdatedPos)(pluginState, tr);
                    // apply any actions
                    const meta = tr.getMeta((0, $cuJUr.pluginKey));
                    if (cardPluginEvents) {
                        const events = (0, $59QiN.eventsFromTransaction)(tr, prevEditorState);
                        cardPluginEvents.push(...events);
                    }
                    if (!meta) {
                        if (pluginState.datasourceTableRef) {
                            if (!(tr.selection instanceof (0, $3lIcL.NodeSelection)) || !tr.selection.node.attrs.datasource) // disable resize button when switching from datasource to block card
                            return {
                                ...pluginStateWithUpdatedPos,
                                datasourceTableRef: undefined
                            };
                        }
                    }
                    if (!meta) return pluginStateWithUpdatedPos;
                    if (!enableInlineUpgradeFeatures) return (0, $cPbXA.default)(pluginStateWithUpdatedPos, meta);
                    const newState = (0, $cPbXA.default)(pluginStateWithUpdatedPos, meta);
                    // the code below is related to the "Inline Switcher" project, for more information pls see EDM-7984
                    const isSingleInlineLink = pluginState?.requests?.length === 1 && pluginState.requests[0].appearance === 'inline';
                    const isSmartLinkPulseDiscovered = (0, $d62Vl.isLocalStorageKeyDiscovered)($f7023b7c834ef2cc$var$LOCAL_STORAGE_DISCOVERY_KEY_SMART_LINK);
                    if (meta.type !== 'RESOLVE' || !isSingleInlineLink) return newState;
                    const linkPosition = pluginState.requests[0].pos;
                    const canBeUpgradedToBlock = allowBlockCards && (0, $gXgTX.isBlockSupportedAtPosition)(linkPosition, prevEditorState, 'inline');
                    const canBeUpgradedToEmbed = allowEmbeds && (0, $gXgTX.isEmbedSupportedAtPosition)(linkPosition, prevEditorState, 'inline');
                    if (canBeUpgradedToBlock || canBeUpgradedToEmbed) newState.overlayCandidatePosition = linkPosition;
                    if (!isSmartLinkPulseDiscovered && canBeUpgradedToEmbed) newState.inlineCardAwarenessCandidatePosition = linkPosition;
                    return newState;
                }
            },
            filterTransaction (tr) {
                const isOutsideClicked = tr.getMeta('outsideProsemirrorEditorClicked');
                if (isOutsideClicked) {
                    const isInlineEditingActive = document.getElementById('sllv-active-inline-edit');
                    if (isInlineEditingActive) return false;
                }
                return true;
            },
            view (view) {
                const domAtPos = view.domAtPos.bind(view);
                const rafCancellationCallbacks = [];
                if (options.provider) (0, $9SMdd.handleProvider)('cardProvider', options.provider, view);
                return {
                    update (view, prevState) {
                        const currentState = (0, $d3z4A.getPluginState)(view.state);
                        const oldState = (0, $d3z4A.getPluginState)(prevState);
                        const { state: state, dispatch: dispatch } = view;
                        const { selection: selection, tr: tr, schema: schema } = state;
                        const isBlockCardSelected = selection instanceof (0, $3lIcL.NodeSelection) && selection.node?.type === schema.nodes.blockCard;
                        if (isBlockCardSelected) {
                            // Ignored via go/ees005
                            // eslint-disable-next-line @atlaskit/editor/no-as-casting
                            const datasourceTableRef = // eslint-disable-next-line @atlaskit/editor/no-as-casting
                            (0, $BmspC.findDomRefAtPos)(selection.from, domAtPos)?.querySelector(`.${(0, $hkyHj.DATASOURCE_INNER_CONTAINER_CLASSNAME)}`);
                            const { node: node } = selection;
                            const isDatasource = !!node?.attrs?.datasource;
                            const shouldUpdateTableRef = datasourceTableRef && currentState?.datasourceTableRef !== datasourceTableRef;
                            if (isDatasource && shouldUpdateTableRef) {
                                // since we use the plugin state, which is a shared state, we need to update the datasourceTableRef, layout on each selection
                                const layout = (0, $37WZl.isDatasourceTableLayout)(node.attrs.layout) ? node.attrs.layout : (0, $a358b8ea78408961$export$60efea3f80310017);
                                const isNested = selection.$anchor.depth > 0;
                                // we want to disable resize button when datasource table is nested by not setting then datasourceTableRef on selection
                                if (!isNested) // we use cardAction to set the same meta, hence, we will need to combine both layout+datasourceTableRef in one transaction
                                dispatch((0, $ecNk4.setCardLayoutAndDatasourceTableRef)({
                                    datasourceTableRef: datasourceTableRef,
                                    layout: layout
                                })(tr));
                            }
                        } else if (currentState?.datasourceTableRef) dispatch((0, $ecNk4.setDatasourceTableRef)(undefined)(tr));
                        if (currentState && currentState.provider) {
                            // Find requests in this state that weren't in the old one.
                            const newRequests = (0, $d3z4A.getNewRequests)(oldState, currentState);
                            // Ask the CardProvider to resolve all new requests.
                            const { provider: provider } = currentState;
                            newRequests.forEach((request)=>{
                                /**
								 * Queue each asynchronous resolve request on separate frames.
								 * ---
								 * NB: The promise for each request is queued to take place on separate animation frames. This avoids
								 * the scenario debugged and discovered in EDM-668, wherein the queuing of too many promises in quick succession
								 * leads to the browser's macrotask queue being overwhelmed, locking interactivity of the browser tab.
								 * By using this approach, the browser is free to schedule the resolution of the promises below in between rendering/network/
								 * other tasks as per common implementations of the JavaScript event loop in browsers.
								 */ const invoke = (0, $bRPNB.default)(()=>(0, $9SMdd.resolveWithProvider)(view, provider, request, options, pluginInjectionApi?.analytics?.actions, pluginInjectionApi?.analytics?.sharedState.currentState()?.createAnalyticsEvent ?? undefined));
                                rafCancellationCallbacks.push(invoke.cancel);
                                invoke();
                            });
                        }
                        /**
						 * If there have been any events queued, flush them
						 * so subscribers can now be notified and dispatch
						 * analytics events
						 */ cardPluginEvents?.flush();
                    },
                    destroy () {
                        // Cancel any outstanding raf callbacks.
                        rafCancellationCallbacks.forEach((cancellationCallback)=>cancellationCallback());
                    }
                };
            },
            props: {
                nodeViews: {
                    inlineCard: (0, $8y3X6.lazyInlineCardView)({
                        inlineCardViewProducer: inlineCardViewProducer,
                        isPageSSRed: isPageSSRed
                    }),
                    blockCard: (0, $9tfE8.lazyBlockCardView)({
                        pmPluginFactoryParams: pmPluginFactoryParams,
                        actionOptions: actionOptions,
                        pluginInjectionApi: pluginInjectionApi,
                        onClickCallback: onClickCallback,
                        allowDatasource: options.allowDatasource,
                        inlineCardViewProducer: inlineCardViewProducer,
                        CompetitorPrompt: options.CompetitorPrompt
                    }),
                    embedCard: (0, $ewKS2.lazyEmbedCardView)({
                        allowResizing: allowResizing,
                        fullWidthMode: fullWidthMode,
                        pmPluginFactoryParams: pmPluginFactoryParams,
                        pluginInjectionApi: pluginInjectionApi,
                        actionOptions: actionOptions,
                        onClickCallback: options.onClickCallback,
                        CompetitorPrompt: options.CompetitorPrompt
                    })
                },
                ...enableInlineUpgradeFeatures && {
                    handleKeyDown: (view)=>{
                        $f7023b7c834ef2cc$var$handleAwarenessOverlay(view);
                        return false;
                    },
                    handleClick: (view)=>{
                        $f7023b7c834ef2cc$var$handleAwarenessOverlay(view);
                        return false;
                    }
                }
            },
            key: (0, $cuJUr.pluginKey)
        });
    };

});
const $a358b8ea78408961$export$85183a312807388d = 'media';
const $a358b8ea78408961$export$60efea3f80310017 = 'wide';

parcelRegister("8NXVj", function(module, exports) {

$parcel$export(module.exports, "InlineCard", () => $c2a5fb37b9cb8f45$export$aff6291803939b05);
$parcel$export(module.exports, "InlineCardNodeView", () => $c2a5fb37b9cb8f45$export$2626b4e17577ac62);
$parcel$export(module.exports, "inlineCardNodeView", () => $c2a5fb37b9cb8f45$export$ebfb9e1798b8aa0e);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $bRPNB = parcelRequire("bRPNB");

var $8KLBw = parcelRequire("8KLBw");

var $bMFKb = parcelRequire("bMFKb");

var $kLQ9a = parcelRequire("kLQ9a");
var $bSToC = parcelRequire("bSToC");
var $cxXTK = parcelRequire("cxXTK");

var $551JM = parcelRequire("551JM");

var $dwnni = parcelRequire("dwnni");
var $dfCRV = parcelRequire("dfCRV");

var $3lIcL = parcelRequire("3lIcL");

var $eGOwo = parcelRequire("eGOwo");

var $4cFYC = parcelRequire("4cFYC");

var $8YHJ2 = parcelRequire("8YHJ2");

var $92xoS = parcelRequire("92xoS");

var $ecNk4 = parcelRequire("ecNk4");

var $gXgTX = parcelRequire("gXgTX");

var $iY2av = parcelRequire("iY2av");

var $3YtqI = parcelRequire("3YtqI");

var $gqKWA = parcelRequire("gqKWA");

var $8fpuZ = parcelRequire("8fpuZ");
const $c2a5fb37b9cb8f45$export$aff6291803939b05 = /*#__PURE__*/ (0, $eJOHy.memo)(({ node: node, cardContext: cardContext, actionOptions: actionOptions, useAlternativePreloader: useAlternativePreloader, view: view, getPos: getPos, onClick: propsOnClick, onResolve: onRes, isHovered: isHovered, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, isPageSSRed: isPageSSRed, pluginInjectionApi: pluginInjectionApi })=>{
    const { url: url, data: data } = node.attrs;
    const refId = (0, $eJOHy.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($8KLBw)))());
    (0, $eJOHy.useEffect)(()=>{
        const id = refId.current;
        return ()=>{
            const { tr: tr } = view.state;
            (0, $ecNk4.removeCard)({
                id: id
            })(tr);
            view.dispatch(tr);
        };
    }, [
        getPos,
        view
    ]);
    const scrollContainer = (0, $eJOHy.useMemo)(// Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    ()=>(0, $dwnni.findOverflowScrollParent)(view.dom) || undefined, [
        view.dom
    ]);
    const onResolve = (0, $eJOHy.useCallback)((data)=>{
        if (!getPos || typeof getPos === 'boolean') return;
        const { title: title, url: url } = data;
        // don't dispatch immediately since we might be in the middle of
        // rendering a nodeview
        (0, $bRPNB.default)(()=>{
            // prosemirror-bump-fix
            const pos = getPos();
            if (typeof pos !== 'number') return;
            const tr = view.state.tr;
            (0, $ecNk4.registerCard)({
                title: title,
                url: url,
                pos: pos,
                id: refId.current
            })(tr);
            onRes?.(tr, title);
            view.dispatch(tr);
        })();
    }, [
        getPos,
        view,
        onRes
    ]);
    const onError = (0, $eJOHy.useCallback)((data)=>{
        const { url: url, err: err } = data;
        if (err) throw err;
        onResolve({
            url: url
        });
    }, [
        onResolve
    ]);
    const handleOnClick = (0, $eJOHy.useCallback)((event)=>{
        if (event.metaKey || event.ctrlKey) {
            const { actions: editorAnalyticsApi } = pluginInjectionApi?.analytics ?? {};
            (0, $3YtqI.visitCardLinkAnalytics)(editorAnalyticsApi, (0, $bMFKb.INPUT_METHOD).META_CLICK)(view.state, view.dispatch);
            window.open(url, '_blank');
        } else // only trigger the provided onClick callback if the meta key or ctrl key is not pressed
        propsOnClick?.(event);
    }, [
        propsOnClick,
        url,
        view,
        pluginInjectionApi
    ]);
    const onClick = (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1') && (0, $92xoS.editorExperiment)('platform_editor_smart_link_cmd_ctrl_click', true, {
        exposure: true
    }) ? handleOnClick : propsOnClick;
    const card = (0, $eJOHy.useMemo)(()=>{
        if (isPageSSRed && url && (0, $eGOwo.fg)('platform_ssr_smartlinks_editor')) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8YHJ2.CardSSR), {
            url: url,
            appearance: "inline",
            onClick: onClick,
            container: scrollContainer,
            onResolve: onResolve,
            onError: onError,
            inlinePreloaderStyle: useAlternativePreloader ? 'on-right-without-skeleton' : undefined,
            actionOptions: actionOptions,
            isHovered: isHovered,
            showHoverPreview: showHoverPreview,
            hoverPreviewOptions: hoverPreviewOptions
        }, url);
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4cFYC.Card), {
            url: url ?? data.url,
            appearance: "inline",
            onClick: onClick,
            container: scrollContainer,
            onResolve: onResolve,
            onError: onError,
            inlinePreloaderStyle: useAlternativePreloader ? 'on-right-without-skeleton' : undefined,
            actionOptions: actionOptions,
            isHovered: isHovered,
            showHoverPreview: showHoverPreview,
            hoverPreviewOptions: hoverPreviewOptions
        }, url);
    }, [
        url,
        data,
        onClick,
        scrollContainer,
        onResolve,
        onError,
        useAlternativePreloader,
        actionOptions,
        isHovered,
        showHoverPreview,
        hoverPreviewOptions,
        isPageSSRed
    ]);
    // [WS-2307]: we only render card wrapped into a Provider when the value is ready,
    // otherwise if we got data, we can render the card directly since it doesn't need the Provider
    return cardContext && cardContext.value ? /*#__PURE__*/ (0, $gt9Am.jsx)(cardContext.Provider, {
        value: cardContext.value,
        children: card
    }) : data ? card : null;
});
const $c2a5fb37b9cb8f45$var$WrappedInlineCardWithAwareness = (0, $gqKWA.Card)((0, $8fpuZ.InlineCardWithAwareness), (0, $dfCRV.default));
const $c2a5fb37b9cb8f45$var$WrappedInlineCard = (0, $gqKWA.Card)($c2a5fb37b9cb8f45$export$aff6291803939b05, (0, $dfCRV.default));
const $c2a5fb37b9cb8f45$var$selector = (states)=>{
    return {
        mode: states.editorViewModeState?.mode,
        selection: states.selectionState?.selection
    };
};
const $c2a5fb37b9cb8f45$var$useSharedState = (0, $kLQ9a.sharedPluginStateHookMigratorFactory)((pluginInjectionApi)=>{
    return (0, $cxXTK.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'selection',
        'editorViewMode'
    ], $c2a5fb37b9cb8f45$var$selector);
}, (pluginInjectionApi)=>{
    const { selectionState: selectionState, editorViewModeState: editorViewModeState } = (0, $bSToC.useSharedPluginState)(pluginInjectionApi, [
        'selection',
        'editorViewMode'
    ]);
    return {
        mode: editorViewModeState?.mode,
        selection: selectionState?.selection
    };
});
function $c2a5fb37b9cb8f45$export$2626b4e17577ac62(props) {
    const { useAlternativePreloader: useAlternativePreloader, node: node, view: view, getPos: getPos, actionOptions: actionOptions, allowEmbeds: allowEmbeds, allowBlockCards: allowBlockCards, enableInlineUpgradeFeatures: enableInlineUpgradeFeatures, pluginInjectionApi: pluginInjectionApi, onClickCallback: onClickCallback, __livePage: __livePage, isPageSSRed: isPageSSRed, CompetitorPrompt: CompetitorPrompt } = props;
    const [isOverlayHovered, setIsOverlayHovered] = (0, $eJOHy.useState)(false);
    const { mode: mode, selection: selection } = $c2a5fb37b9cb8f45$var$useSharedState(pluginInjectionApi);
    const floatingToolbarNode = selection instanceof (0, $3lIcL.NodeSelection) && selection.node;
    const url = node.attrs.url;
    const CompetitorPromptComponent = CompetitorPrompt && url ? /*#__PURE__*/ (0, $gt9Am.jsx)(CompetitorPrompt, {
        sourceUrl: url,
        linkType: "inline"
    }) : null;
    if (__livePage && (0, $eGOwo.fg)('linking_platform_smart_links_in_live_pages')) {
        const showHoverPreview = floatingToolbarNode !== node;
        const livePagesHoverCardFadeInDelay = 800;
        const inlineCard = /*#__PURE__*/ (0, $gt9Am.jsx)($c2a5fb37b9cb8f45$var$WrappedInlineCard, {
            isHovered: isOverlayHovered,
            node: node,
            view: view,
            getPos: getPos,
            actionOptions: actionOptions,
            useAlternativePreloader: useAlternativePreloader,
            onClickCallback: onClickCallback,
            showHoverPreview: showHoverPreview,
            hoverPreviewOptions: {
                fadeInDelay: livePagesHoverCardFadeInDelay
            },
            isPageSSRed: isPageSSRed
        });
        return mode === 'view' ? inlineCard : /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iY2av.default), {
                    targetElementPos: getPos(),
                    view: view,
                    isHoveredCallback: setIsOverlayHovered,
                    onOpenLinkClick: (event)=>{
                        (0, $551JM.handleNavigation)({
                            fireAnalyticsEvent: pluginInjectionApi?.analytics?.actions.fireAnalyticsEvent,
                            onClickCallback: onClickCallback,
                            url: url,
                            event: event
                        });
                    },
                    children: inlineCard
                }),
                (0, $eGOwo.fg)('prompt_whiteboard_competitor_link_gate') && CompetitorPromptComponent
            ]
        });
    }
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)($c2a5fb37b9cb8f45$var$WrappedInlineCardWithAwareness, {
                node: node,
                view: view,
                getPos: getPos,
                actionOptions: actionOptions,
                useAlternativePreloader: useAlternativePreloader,
                pluginInjectionApi: pluginInjectionApi,
                onClickCallback: onClickCallback,
                isPageSSRed: isPageSSRed,
                appearance: "inline",
                ...enableInlineUpgradeFeatures && (0, $gXgTX.getAwarenessProps)(view.state, getPos, allowEmbeds, allowBlockCards, mode === 'view')
            }),
            (0, $eGOwo.fg)('prompt_whiteboard_competitor_link_gate') && CompetitorPromptComponent
        ]
    });
}
const $c2a5fb37b9cb8f45$export$ebfb9e1798b8aa0e = ({ inlineCardViewProducer: inlineCardViewProducer })=>(node, view, getPos, decorations)=>{
        return inlineCardViewProducer(node, view, getPos, decorations);
    };

});
parcelRegister("551JM", function(module, exports) {

$parcel$export(module.exports, "handleNavigation", () => $0d66d24a6d8de01c$export$706ad1af8096e280);

var $bMFKb = parcelRequire("bMFKb");
var $8MfCL = parcelRequire("8MfCL");
function $0d66d24a6d8de01c$export$706ad1af8096e280({ url: url, event: event, onClickCallback: onClickCallback, fireAnalyticsEvent: fireAnalyticsEvent }) {
    if (fireAnalyticsEvent) fireAnalyticsEvent({
        action: (0, $bMFKb.ACTION).VISITED,
        actionSubject: (0, $bMFKb.ACTION_SUBJECT).LINK,
        eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
        attributes: {
            platform: (0, $8MfCL.PLATFORMS).WEB,
            mode: (0, $8MfCL.MODE).EDITOR
        }
    });
    if (url) {
        try {
            onClickCallback?.({
                event: event,
                url: url
            });
        } catch  {}
        /**
		 * Links should navigate by default in live pages if:
		 * - the link is the direct target of the click event
		 * - default handling wasn't prevented with `event.preventDefault()`
		 */ if (!event.defaultPrevented) window.location.href = url;
    }
}

});

parcelRegister("4cFYC", function(module, exports) {

$parcel$export(module.exports, "Card", () => $67163b0d69104250$export$60332b2344f7fe41);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $6YFG2 = parcelRequire("6YFG2");
var $4nehu = parcelRequire("4nehu");

var $dUaMU = parcelRequire("dUaMU");
var $4J0ad = parcelRequire("4J0ad");

var $b43DQ = parcelRequire("b43DQ");

var $8BtgY = parcelRequire("8BtgY");
class $67163b0d69104250$var$PlainCard extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).PureComponent {
    render() {
        const content = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8BtgY.CardWithURLRenderer), {
            ...this.props
        });
        return this.props.intl ? content : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4nehu.default), {
            locale: "en",
            children: content
        });
    }
}
const $67163b0d69104250$export$60332b2344f7fe41 = (0, $dUaMU.default)((0, $b43DQ.context))((0, $4J0ad.default)()((0, $6YFG2.default)($67163b0d69104250$var$PlainCard, {
    enforceContext: false
})));

});
parcelRegister("8BtgY", function(module, exports) {

$parcel$export(module.exports, "CardWithURLRenderer", () => $6c611c6f38b38dd4$export$e00a7788e30dc998);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $axOsj = parcelRequire("axOsj");

var $gRw8I = parcelRequire("gRw8I");

var $aXKmr = parcelRequire("aXKmr");

var $bmWcp = parcelRequire("bmWcp");

var $1mLfK = parcelRequire("1mLfK");

var $FoFt2 = parcelRequire("FoFt2");

var $44bDi = parcelRequire("44bDi");

var $1YI3f = parcelRequire("1YI3f");

var $2QXr6 = parcelRequire("2QXr6");

var $k9P6L = parcelRequire("k9P6L");

const $6c611c6f38b38dd4$export$a7690c318cd6a95e = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(0, $FoFt2.importWithRetry)(()=>(parcelRequire("cXd9T"))));
function $6c611c6f38b38dd4$export$e00a7788e30dc998(props) {
    (0, $gRw8I.di)($6c611c6f38b38dd4$export$a7690c318cd6a95e);
    const [id] = (0, $eJOHy.useState)(()=>props.id ? props.id : (0, (/*@__PURE__*/$parcel$interopDefault($aXKmr)))());
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        // ComponentWillUnmount
        return ()=>{
            (0, $2QXr6.clearMarks)(id);
            (0, $2QXr6.clearMeasures)(id);
        };
    }, [
        id
    ]);
    const { url: url, appearance: appearance, isSelected: isSelected, isHovered: isHovered, frameStyle: frameStyle, onClick: onClick, container: container, onResolve: onResolve, onError: onError, testId: testId, actionOptions: actionOptions, inheritDimensions: inheritDimensions, platform: platform, embedIframeRef: embedIframeRef, embedIframeUrlType: embedIframeUrlType, inlinePreloaderStyle: inlinePreloaderStyle, children: children, ui: ui, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, placeholder: placeholder, fallbackComponent: fallbackComponent, removeTextHighlightingFromTitle: removeTextHighlightingFromTitle, resolvingPlaceholder: resolvingPlaceholder, truncateInline: truncateInline, CompetitorPrompt: CompetitorPrompt } = props;
    const isFlexibleUi = (0, $1YI3f.isFlexibleUiCard)(children, ui);
    const analyticsContext = (0, $44bDi.useSmartLinkAnalyticsContext)({
        display: isFlexibleUi ? 'flexible' : appearance,
        id: id,
        url: url ?? ''
    });
    const errorHandler = (0, $eJOHy.useCallback)((error, info)=>{
        const { componentStack: componentStack } = info;
        const errorInfo = {
            componentStack: componentStack
        };
        // NB: APIErrors are thrown in response to Object Resolver Service. We do not
        // fire an event for these, as they do not cover failed UI render events.
        // The rest of the errors caught here are unexpected, and correlate
        // to the reliability of the smart-card front-end components.
        // Likewise, chunk loading errors are not caused by a failure of smart-card rendering.
        if (error.name === 'ChunkLoadError') fireEvent('operational.smartLink.chunkLoadFailed', {
            ...analyticsContext?.attributes,
            display: appearance,
            error: error,
            errorInfo: errorInfo,
            definitionId: null
        });
        else if (error.name !== 'APIError') {
            (0, $1mLfK.startUfoExperience)('smart-link-rendered', id || 'NULL');
            (0, $1mLfK.failUfoExperience)('smart-link-rendered', id || 'NULL');
            (0, $1mLfK.failUfoExperience)('smart-link-authenticated', id || 'NULL');
            fireEvent('ui.smartLink.renderFailed', {
                ...analyticsContext?.attributes,
                display: isFlexibleUi ? 'flexible' : appearance,
                id: id ?? null,
                error: error,
                errorInfo: errorInfo
            });
        }
        onError && onError({
            status: 'errored',
            url: url ?? '',
            err: error
        });
    }, [
        analyticsContext?.attributes,
        appearance,
        fireEvent,
        id,
        isFlexibleUi,
        onError,
        url
    ]);
    if (!url) throw new Error('@atlaskit/smart-card: url property is missing.');
    const defaultFallBackComponent = ()=>null;
    const FallbackComponent = fallbackComponent ?? defaultFallBackComponent;
    const ErrorFallback = ()=>/*#__PURE__*/ (0, $gt9Am.jsx)(FallbackComponent, {});
    const cardWithUrlProps = {
        id: id,
        url: url,
        appearance: appearance,
        onClick: onClick,
        isSelected: isSelected,
        isHovered: isHovered,
        frameStyle: frameStyle,
        container: container,
        onResolve: onResolve,
        onError: onError,
        testId: testId,
        actionOptions: actionOptions,
        inheritDimensions: inheritDimensions,
        platform: platform,
        embedIframeRef: embedIframeRef,
        embedIframeUrlType: embedIframeUrlType,
        inlinePreloaderStyle: inlinePreloaderStyle,
        ui: ui,
        showHoverPreview: showHoverPreview,
        hoverPreviewOptions: hoverPreviewOptions,
        placeholder: placeholder,
        removeTextHighlightingFromTitle: removeTextHighlightingFromTitle,
        resolvingPlaceholder: resolvingPlaceholder,
        truncateInline: truncateInline,
        CompetitorPrompt: CompetitorPrompt
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $axOsj.ErrorBoundary), {
        FallbackComponent: ErrorFallback,
        onError: errorHandler,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Suspense), {
            fallback: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k9P6L.LoadingCardLink), {
                ...cardWithUrlProps
            }),
            children: /*#__PURE__*/ (0, $gt9Am.jsx)($6c611c6f38b38dd4$export$a7690c318cd6a95e, {
                ...cardWithUrlProps,
                children: children
            })
        })
    });
}

});
parcelRegister("bmWcp", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", () => $b236f5372ffdd3ba$export$5bf35293e545f20c);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::1f3587129789e7883af37adad3817cd2>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen smart-card
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");


var $928jS = parcelRequire("928jS");
const $b236f5372ffdd3ba$export$5bf35293e545f20c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const fireEvent = (0, $eJOHy.useCallback)((...params)=>{
        const event = createAnalyticsEvent((0, $928jS.default)(...params));
        event.fire((0, $6462ef276ac974ec$export$3f072f06b90c3985));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEvent: fireEvent
    };
};

});
const $6462ef276ac974ec$export$3f072f06b90c3985 = 'media';

parcelRegister("928jS", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ac9e1681ec36717$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::eb8cd1263459fb798341024dc0c461ea>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen smart-card
 */ const $5ac9e1681ec36717$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $5ac9e1681ec36717$export$2e2bcd8739ae039 = $5ac9e1681ec36717$var$createEventPayload;

});


parcelRegister("1mLfK", function(module, exports) {

$parcel$export(module.exports, "startUfoExperience", () => $e01fd61e15160d33$export$5e9287b6a10f8075);
$parcel$export(module.exports, "succeedUfoExperience", () => $e01fd61e15160d33$export$c5a5cf072c836c0e);
$parcel$export(module.exports, "failUfoExperience", () => $e01fd61e15160d33$export$8dda83bafca11b77);
$parcel$export(module.exports, "addMetadataToExperience", () => $e01fd61e15160d33$export$4084c0df4a03a6af);

var $9iIu4 = parcelRequire("9iIu4");
var $aRnO1 = parcelRequire("aRnO1");
const $e01fd61e15160d33$var$inlineExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $aRnO1.ExperienceTypes).Experience,
    performanceType: (0, $aRnO1.ExperiencePerformanceTypes).InlineResult
};
const $e01fd61e15160d33$var$renderExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $aRnO1.ExperienceTypes).Load,
    performanceType: (0, $aRnO1.ExperiencePerformanceTypes).PageSegmentLoad
};
const $e01fd61e15160d33$var$aiExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $aRnO1.ExperienceTypes).Experience,
    performanceType: (0, $aRnO1.ExperiencePerformanceTypes).InlineResult
};
const $e01fd61e15160d33$var$ufoExperiences = {
    'smart-link-rendered': new (0, $9iIu4.ConcurrentExperience)('smart-link-rendered', $e01fd61e15160d33$var$renderExperience),
    'smart-link-authenticated': new (0, $9iIu4.ConcurrentExperience)('smart-link-authenticated', $e01fd61e15160d33$var$inlineExperience),
    'smart-link-action-invocation': new (0, $9iIu4.ConcurrentExperience)('smart-link-action-invocation', $e01fd61e15160d33$var$inlineExperience),
    'smart-link-ai-summary': new (0, $9iIu4.ConcurrentExperience)('smart-link-ai-summary', $e01fd61e15160d33$var$aiExperience)
};
const $e01fd61e15160d33$export$5e9287b6a10f8075 = (experienceName, id, properties)=>{
    const experience = $e01fd61e15160d33$var$ufoExperiences[experienceName].getInstance(id);
    experience.start();
    if (properties) experience.addMetadata(properties);
};
const $e01fd61e15160d33$export$c5a5cf072c836c0e = (experienceName, id, properties)=>{
    const experience = $e01fd61e15160d33$var$ufoExperiences[experienceName].getInstance(id);
    experience.success({
        metadata: properties
    });
};
const $e01fd61e15160d33$export$8dda83bafca11b77 = (experienceName, id, properties)=>{
    const experience = $e01fd61e15160d33$var$ufoExperiences[experienceName].getInstance(id);
    experience.failure({
        metadata: properties
    });
};
const $e01fd61e15160d33$export$4084c0df4a03a6af = (experienceName, id, properties)=>{
    $e01fd61e15160d33$var$ufoExperiences[experienceName].getInstance(id).addMetadata(properties);
};

});

parcelRegister("FoFt2", function(module, exports) {

$parcel$export(module.exports, "isSpecialEvent", () => $4836221d615e2d0d$export$efca2c4705678489);
$parcel$export(module.exports, "isSpecialKey", () => $4836221d615e2d0d$export$d8de0cd37d316fdf);
$parcel$export(module.exports, "isSpecialClick", () => $4836221d615e2d0d$export$5b1771037ab7c451);
$parcel$export(module.exports, "getIconForFileType", () => $4836221d615e2d0d$export$4d685c85ebc7a1e3);
$parcel$export(module.exports, "getLazyIcons", () => $4836221d615e2d0d$export$92d31eb5326761b6);
$parcel$export(module.exports, "getIframeSandboxAttribute", () => $4836221d615e2d0d$export$9b7e6a102056a387);
$parcel$export(module.exports, "handleOnClick", () => $4836221d615e2d0d$export$ffccab2ae3d093ef);
$parcel$export(module.exports, "isIntersectionObserverSupported", () => $4836221d615e2d0d$export$6c837641a9ab03cb);
$parcel$export(module.exports, "importWithRetry", () => $4836221d615e2d0d$export$aacbf48ace518c5a);
$parcel$export(module.exports, "downloadUrl", () => $4836221d615e2d0d$export$8a96edb1c96563f4);
$parcel$export(module.exports, "openUrl", () => $4836221d615e2d0d$export$a238cfe4a10e6279);
$parcel$export(module.exports, "getPreviewUrlWithTheme", () => $4836221d615e2d0d$export$4470f298c61a79da);
$parcel$export(module.exports, "isIconSizeLarge", () => $4836221d615e2d0d$export$d2b8fb9e780e17e7);
$parcel$export(module.exports, "isProfileType", () => $4836221d615e2d0d$export$6a4545d6b336c401);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $joSn0 = parcelRequire("joSn0");

var $eGOwo = parcelRequire("eGOwo");

var $4CCpn = parcelRequire("4CCpn");

var $5NtHI = parcelRequire("5NtHI");

var $dyU3L = parcelRequire("dyU3L");
const $4836221d615e2d0d$export$efca2c4705678489 = (evt)=>evt.isDefaultPrevented() && ($4836221d615e2d0d$export$e6c5ffa684aac4d7() || $4836221d615e2d0d$export$d8de0cd37d316fdf(evt) || $4836221d615e2d0d$export$5b1771037ab7c451(evt));
const $4836221d615e2d0d$export$e6c5ffa684aac4d7 = ()=>window.parent !== parent;
const $4836221d615e2d0d$export$d8de0cd37d316fdf = (event)=>{
    return (0, $eGOwo.fg)('platform-smart-card-shift-key') ? event.metaKey || event.ctrlKey || event.shiftKey : event.metaKey || event.ctrlKey;
};
const $4836221d615e2d0d$export$5b1771037ab7c451 = (event)=>event.button === 1;
const $4836221d615e2d0d$export$4d685c85ebc7a1e3 = (fileMimeType)=>{
    if (!fileMimeType) return;
    let icon = $4836221d615e2d0d$var$getTypeToIconMap(fileMimeType.toLowerCase());
    if (!icon) return;
    const [label, importCb] = icon;
    if (!importCb) return;
    const Icon = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
        loader: ()=>importCb().then((module)=>module.default),
        loading: ()=>null
    }); // because we're using dynamic loading here, TS will not be able to infer the type
    return /*#__PURE__*/ (0, $gt9Am.jsx)(Icon, {
        label: label,
        testId: "document-file-format-icon"
    });
};
const $4836221d615e2d0d$export$371bef29a3733127 = (fileMimeType)=>{
    let icon = $4836221d615e2d0d$var$getTypeToIconMap(fileMimeType.toLowerCase());
    if (!icon) return;
    const [label] = icon;
    return label;
};


























































































const $4836221d615e2d0d$export$92d31eb5326761b6 = ()=>{
    return {
        [(0, $5NtHI.IconType).Document]: {
            default: ()=>Promise.resolve((parcelRequire("9dPtp")))
        },
        [(0, $5NtHI.IconType).Blog]: {
            default: ()=>Promise.resolve((parcelRequire("4Gz8O")))
        },
        [(0, $5NtHI.IconType).Audio]: {
            default: ()=>(parcelRequire("jGI3w"))
        },
        [(0, $5NtHI.IconType).Code]: {
            default: ()=>(parcelRequire("2l32C"))
        },
        [(0, $5NtHI.IconType).File]: {
            default: ()=>Promise.resolve((parcelRequire("iOphm")))
        },
        [(0, $5NtHI.IconType).Folder]: {
            default: ()=>(parcelRequire("kM5eD"))
        },
        [(0, $5NtHI.IconType).Generic]: {
            default: ()=>Promise.resolve((parcelRequire("iOphm")))
        },
        [(0, $5NtHI.IconType).Image]: {
            default: ()=>(parcelRequire("ipZFl"))
        },
        [(0, $5NtHI.IconType).Presentation]: {
            default: ()=>Promise.resolve((parcelRequire("lQKQC")))
        },
        [(0, $5NtHI.IconType).Spreadsheet]: {
            default: ()=>Promise.resolve((parcelRequire("4VIPx")))
        },
        [(0, $5NtHI.IconType).Video]: {
            default: ()=>(parcelRequire("gy68w"))
        },
        [(0, $5NtHI.IconType).Project]: {
            default: ()=>Promise.resolve((parcelRequire("lG2jM")))
        },
        [(0, $5NtHI.IconType).Template]: {
            default: ()=>Promise.resolve((parcelRequire("kSre2")))
        },
        [(0, $5NtHI.IconType).Forbidden]: {
            default: ()=>(parcelRequire("7lhDi"))
        },
        [(0, $5NtHI.IconType).Default]: {
            default: ()=>Promise.resolve((parcelRequire("av9Of")))
        },
        [(0, $5NtHI.IconType).Archive]: {
            default: ()=>(parcelRequire("PhsZo")),
            large: ()=>(parcelRequire("9bxQV"))
        },
        [(0, $5NtHI.IconType).Executable]: {
            default: ()=>(parcelRequire("3ypIZ")),
            large: ()=>Promise.resolve((parcelRequire("gAsmN")))
        },
        [(0, $5NtHI.IconType).GIF]: {
            default: ()=>(parcelRequire("2N4kX")),
            large: ()=>Promise.resolve((parcelRequire("2Pj0H")))
        },
        [(0, $5NtHI.IconType).GoogleDocs]: {
            default: ()=>(parcelRequire("54Irl")),
            large: ()=>Promise.resolve((parcelRequire("iqmbF")))
        },
        [(0, $5NtHI.IconType).GoogleForms]: {
            default: ()=>(parcelRequire("5JIMH")),
            large: ()=>Promise.resolve((parcelRequire("hLw8T")))
        },
        [(0, $5NtHI.IconType).GoogleSheets]: {
            default: ()=>(parcelRequire("b7X9d")),
            large: ()=>Promise.resolve((parcelRequire("jpYYq")))
        },
        [(0, $5NtHI.IconType).GoogleSlides]: {
            default: ()=>(parcelRequire("2uY1f")),
            large: ()=>Promise.resolve((parcelRequire("4SXVP")))
        },
        [(0, $5NtHI.IconType).MSExcel]: {
            default: ()=>(parcelRequire("8S5KR")),
            large: ()=>Promise.resolve((parcelRequire("91IX3")))
        },
        [(0, $5NtHI.IconType).MSPowerpoint]: {
            default: ()=>(parcelRequire("7lDFg")),
            large: ()=>Promise.resolve((parcelRequire("jb8ZN")))
        },
        [(0, $5NtHI.IconType).MSWord]: {
            default: ()=>(parcelRequire("9IKYh")),
            large: ()=>Promise.resolve((parcelRequire("4w1Xx")))
        },
        [(0, $5NtHI.IconType).PDF]: {
            default: ()=>(parcelRequire("hEMIE")),
            large: ()=>Promise.resolve((parcelRequire("6OBnQ")))
        },
        [(0, $5NtHI.IconType).Sketch]: {
            default: ()=>(parcelRequire("dE7I7")),
            large: ()=>Promise.resolve((parcelRequire("heBKY")))
        },
        // Bitbucket icons
        [(0, $5NtHI.IconType).Branch]: {
            default: ()=>Promise.resolve((parcelRequire("liS9g"))),
            large: ()=>(parcelRequire("7gFcl"))
        },
        [(0, $5NtHI.IconType).Commit]: {
            default: ()=>Promise.resolve((parcelRequire("6wUJL"))),
            large: ()=>(parcelRequire("ij46p"))
        },
        [(0, $5NtHI.IconType).PullRequest]: {
            default: ()=>Promise.resolve((parcelRequire("es92x"))),
            large: ()=>(parcelRequire("2aQhi"))
        },
        [(0, $5NtHI.IconType).Repo]: {
            default: ()=>Promise.resolve((parcelRequire("gSqCA"))),
            large: ()=>(parcelRequire("5fclM"))
        },
        // Jira icons
        [(0, $5NtHI.IconType).Bug]: {
            default: ()=>Promise.resolve((parcelRequire("i3nvV"))),
            large: ()=>(parcelRequire("f9TV4"))
        },
        [(0, $5NtHI.IconType).Change]: {
            default: ()=>Promise.resolve((parcelRequire("59W6U"))),
            large: ()=>(parcelRequire("iFMZJ"))
        },
        [(0, $5NtHI.IconType).Epic]: {
            default: ()=>Promise.resolve((parcelRequire("4VGMo"))),
            large: ()=>(parcelRequire("feyrR"))
        },
        [(0, $5NtHI.IconType).Incident]: {
            default: ()=>Promise.resolve((parcelRequire("h6Xfo"))),
            large: ()=>(parcelRequire("9YhWF"))
        },
        [(0, $5NtHI.IconType).Problem]: {
            default: ()=>Promise.resolve((parcelRequire("erbJ6"))),
            large: ()=>(parcelRequire("gbfzG"))
        },
        [(0, $5NtHI.IconType).ServiceRequest]: {
            default: ()=>Promise.resolve((parcelRequire("8WXuv"))),
            large: ()=>(parcelRequire("5M4VY"))
        },
        [(0, $5NtHI.IconType).Story]: {
            default: ()=>Promise.resolve((parcelRequire("iaeCZ"))),
            large: ()=>(parcelRequire("jc5UC"))
        },
        [(0, $5NtHI.IconType).SubTask]: {
            default: ()=>Promise.resolve((parcelRequire("dV8me"))),
            large: ()=>(parcelRequire("gDPso"))
        },
        [(0, $5NtHI.IconType).Task]: {
            default: ()=>Promise.resolve((parcelRequire("cOjgE"))),
            large: ()=>(parcelRequire("f65Of"))
        },
        // Confluence icons
        [(0, $5NtHI.IconType).LiveDocument]: {
            default: ()=>Promise.resolve((parcelRequire("ilCAi"))),
            large: ()=>Promise.resolve((parcelRequire("hB03j")))
        },
        // Provider icons
        [(0, $5NtHI.IconType).Confluence]: {
            default: ()=>(parcelRequire("9Iwo3")).then(({ ConfluenceIcon: ConfluenceIcon })=>({
                        default: ConfluenceIcon
                    }))
        },
        [(0, $5NtHI.IconType).Jira]: {
            default: ()=>(parcelRequire("5Ak2H")).then(({ JiraIcon: JiraIcon })=>({
                        default: JiraIcon
                    }))
        },
        // Badge icons
        [(0, $5NtHI.IconType).Attachment]: {
            default: ()=>(parcelRequire("gb3jU"))
        },
        [(0, $5NtHI.IconType).CheckItem]: {
            default: ()=>Promise.resolve((parcelRequire("3Y0kU")))
        },
        [(0, $5NtHI.IconType).Component]: {
            default: ()=>(parcelRequire("6n9v8"))
        },
        [(0, $5NtHI.IconType).Comment]: {
            default: ()=>Promise.resolve((parcelRequire("amxqt")))
        },
        [(0, $5NtHI.IconType).View]: {
            default: ()=>Promise.resolve((parcelRequire("dtTJ9")))
        },
        [(0, $5NtHI.IconType).React]: {
            default: ()=>Promise.resolve((parcelRequire("6b4Xr")))
        },
        [(0, $5NtHI.IconType).Vote]: {
            default: ()=>(parcelRequire("eIsTj"))
        },
        [(0, $5NtHI.IconType).PriorityBlocker]: {
            default: ()=>(parcelRequire("f1B8s"))
        },
        [(0, $5NtHI.IconType).PriorityCritical]: {
            default: ()=>(parcelRequire("cmEXk"))
        },
        [(0, $5NtHI.IconType).PriorityHigh]: {
            default: ()=>(parcelRequire("bTWmL"))
        },
        [(0, $5NtHI.IconType).PriorityHighest]: {
            default: ()=>(parcelRequire("iSMal"))
        },
        [(0, $5NtHI.IconType).PriorityLow]: {
            default: ()=>(parcelRequire("jRdgC"))
        },
        [(0, $5NtHI.IconType).PriorityLowest]: {
            default: ()=>(parcelRequire("kRp0o"))
        },
        [(0, $5NtHI.IconType).PriorityMajor]: {
            default: ()=>(parcelRequire("KywEn"))
        },
        [(0, $5NtHI.IconType).PriorityMedium]: {
            default: ()=>(parcelRequire("fHwpk"))
        },
        [(0, $5NtHI.IconType).PriorityMinor]: {
            default: ()=>(parcelRequire("BSiun"))
        },
        [(0, $5NtHI.IconType).PriorityTrivial]: {
            default: ()=>(parcelRequire("8l50I"))
        },
        [(0, $5NtHI.IconType).PriorityUndefined]: {
            default: ()=>(parcelRequire("htWC6"))
        },
        [(0, $5NtHI.IconType).ProgrammingLanguage]: {
            default: ()=>(parcelRequire("cDlzR"))
        },
        [(0, $5NtHI.IconType).Subscriber]: {
            default: ()=>Promise.resolve((parcelRequire("hMpZ8")))
        },
        [(0, $5NtHI.IconType).SubTasksProgress]: {
            default: ()=>(parcelRequire("bMymA"))
        }
    };
};
const $4836221d615e2d0d$var$getTypeToIconMap = (fileFormat)=>{
    const iconDescriptor = (0, $dyU3L.default)(fileFormat);
    if (!iconDescriptor?.icon || !iconDescriptor.label) return null;
    const lazyIcons = $4836221d615e2d0d$export$92d31eb5326761b6();
    return [
        iconDescriptor.label,
        lazyIcons[iconDescriptor.icon]?.default
    ];
};
const $4836221d615e2d0d$export$9b7e6a102056a387 = (isTrusted)=>{
    if (isTrusted) return undefined;
    const sandboxPermissions = 'allow-downloads allow-forms allow-popups allow-popups-to-escape-sandbox allow-presentation allow-same-origin allow-scripts';
    return sandboxPermissions;
};
const $4836221d615e2d0d$export$ffccab2ae3d093ef = (handler)=>(e)=>{
        e.preventDefault();
        e.stopPropagation();
        handler();
    };
const $4836221d615e2d0d$export$6c837641a9ab03cb = ()=>typeof IntersectionObserver !== 'undefined';
const $4836221d615e2d0d$export$e772c8ff12451969 = (ms)=>{
    return new Promise((resolve)=>setTimeout(resolve, ms));
};
const $4836221d615e2d0d$export$aacbf48ace518c5a = async (importFn, retries = 2, interval = 500)=>{
    try {
        return await importFn();
    } catch (error) {
        if (error.name === 'ChunkLoadError' && retries > 0) {
            await $4836221d615e2d0d$export$e772c8ff12451969(interval);
            return $4836221d615e2d0d$export$aacbf48ace518c5a(importFn, retries - 1, interval);
        } else throw error;
    }
};
const $4836221d615e2d0d$export$8a96edb1c96563f4 = async (url)=>{
    if (!url) return;
    const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const iframeName = 'media-download-iframe';
    const link = document.createElement('a');
    let iframe = document.getElementById(iframeName);
    if (!iframe) {
        iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.id = iframeName;
        iframe.name = iframeName;
        document.body.appendChild(iframe);
    }
    link.href = url;
    link.download = url;
    link.target = isIE11 || isSafari ? '_blank' : iframeName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
const $4836221d615e2d0d$export$a238cfe4a10e6279 = async (url)=>{
    if (!url) return;
    window.open(url, '_blank', 'noopener=yes');
};
const $4836221d615e2d0d$export$4470f298c61a79da = (previewUrl, themeState)=>{
    try {
        const url = new URL(previewUrl);
        url.searchParams.append('themeState', (0, $4CCpn.themeObjectToString)(themeState));
        return url.href;
    } catch  {
        return previewUrl;
    }
};
const $4836221d615e2d0d$export$d2b8fb9e780e17e7 = (size)=>size && [
        (0, $5NtHI.SmartLinkSize).Large,
        (0, $5NtHI.SmartLinkSize).XLarge
    ].includes(size);
const $4836221d615e2d0d$export$6a4545d6b336c401 = (type)=>!!(type && type.includes('Profile'));

});
parcelRegister("5NtHI", function(module, exports) {

$parcel$export(module.exports, "CONTENT_URL_SECURITY_AND_PERMISSIONS", () => $fc2e49eaf9e6df05$export$5c881701926acbef);
$parcel$export(module.exports, "CONTENT_URL_3P_ACCOUNT_AUTH", () => $fc2e49eaf9e6df05$export$93d67ab022d9f8d2);
$parcel$export(module.exports, "CONTENT_URL_AI", () => $fc2e49eaf9e6df05$export$70d24f0465ae60f8);
$parcel$export(module.exports, "CONTENT_URL_AI_TROUBLESHOOTING", () => $fc2e49eaf9e6df05$export$a3ed5c4e9d9599b7);
$parcel$export(module.exports, "CONTENT_URL_ACCEPTABLE_USE_POLICY", () => $fc2e49eaf9e6df05$export$73b198e73554a323);
$parcel$export(module.exports, "SmartLinkAlignment", () => $fc2e49eaf9e6df05$export$8910bf86027fe6be);
$parcel$export(module.exports, "SmartLinkDirection", () => $fc2e49eaf9e6df05$export$60831686b0574c86);
$parcel$export(module.exports, "SmartLinkPosition", () => $fc2e49eaf9e6df05$export$d58e6377644d1dcf);
$parcel$export(module.exports, "SmartLinkSize", () => $fc2e49eaf9e6df05$export$51f13ced115cbdae);
$parcel$export(module.exports, "SmartLinkStatus", () => $fc2e49eaf9e6df05$export$61cff06be26816f);
$parcel$export(module.exports, "SmartLinkTheme", () => $fc2e49eaf9e6df05$export$aed0f1e801ad691f);
$parcel$export(module.exports, "SmartLinkInternalTheme", () => $fc2e49eaf9e6df05$export$9aafec380d7005da);
$parcel$export(module.exports, "SmartLinkWidth", () => $fc2e49eaf9e6df05$export$19c60054ee783de6);
$parcel$export(module.exports, "ElementName", () => $fc2e49eaf9e6df05$export$d65b168331104a46);
$parcel$export(module.exports, "ActionName", () => $fc2e49eaf9e6df05$export$9c95d6e1614bad84);
$parcel$export(module.exports, "InternalActionName", () => $fc2e49eaf9e6df05$export$4871a84b35cf8eb9);
$parcel$export(module.exports, "IconType", () => $fc2e49eaf9e6df05$export$13ff1290a9e22e77);
$parcel$export(module.exports, "MediaType", () => $fc2e49eaf9e6df05$export$483c11740a902fcd);
$parcel$export(module.exports, "MediaPlacement", () => $fc2e49eaf9e6df05$export$f9f4737e25ab90fa);
$parcel$export(module.exports, "CardDisplay", () => $fc2e49eaf9e6df05$export$6ca4ef8b3dc2c804);
const $fc2e49eaf9e6df05$export$5c881701926acbef = 'https://support.atlassian.com/confluence-cloud/docs/insert-links-and-anchors/#Smart-links';
const $fc2e49eaf9e6df05$export$93d67ab022d9f8d2 = 'https://support.atlassian.com/confluence-cloud/docs/what-data-is-sent-and-received-when-pasting-a-smart-link/';
const $fc2e49eaf9e6df05$export$70d24f0465ae60f8 = 'https://www.atlassian.com/trust/atlassian-intelligence';
const $fc2e49eaf9e6df05$export$a3ed5c4e9d9599b7 = 'https://status.atlassian.com/';
const $fc2e49eaf9e6df05$export$73b198e73554a323 = 'https://www.atlassian.com/legal/acceptable-use-policy';
var $fc2e49eaf9e6df05$export$8910bf86027fe6be = /*#__PURE__*/ function(SmartLinkAlignment) {
    SmartLinkAlignment["Left"] = "left";
    SmartLinkAlignment["Right"] = "right";
    return SmartLinkAlignment;
}({});
var $fc2e49eaf9e6df05$export$60831686b0574c86 = /*#__PURE__*/ function(SmartLinkDirection) {
    SmartLinkDirection["Horizontal"] = "horizontal";
    SmartLinkDirection["Vertical"] = "vertical";
    return SmartLinkDirection;
}({});
var $fc2e49eaf9e6df05$export$d58e6377644d1dcf = /*#__PURE__*/ function(SmartLinkPosition) {
    SmartLinkPosition["Top"] = "top";
    SmartLinkPosition["Center"] = "center";
    return SmartLinkPosition;
}({});
var $fc2e49eaf9e6df05$export$51f13ced115cbdae = /*#__PURE__*/ function(SmartLinkSize) {
    SmartLinkSize["XLarge"] = "xlarge";
    SmartLinkSize["Large"] = "large";
    SmartLinkSize["Medium"] = "medium";
    SmartLinkSize["Small"] = "small";
    return SmartLinkSize;
}({});
var $fc2e49eaf9e6df05$export$61cff06be26816f = /*#__PURE__*/ function(SmartLinkStatus) {
    SmartLinkStatus["Pending"] = "pending";
    SmartLinkStatus["Resolving"] = "resolving";
    SmartLinkStatus["Resolved"] = "resolved";
    SmartLinkStatus["Forbidden"] = "forbidden";
    SmartLinkStatus["Errored"] = "errored";
    SmartLinkStatus["NotFound"] = "not_found";
    SmartLinkStatus["Unauthorized"] = "unauthorized";
    SmartLinkStatus["Fallback"] = "fallback";
    return SmartLinkStatus;
}({});
var $fc2e49eaf9e6df05$export$aed0f1e801ad691f = /*#__PURE__*/ function(SmartLinkTheme) {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    SmartLinkTheme["Black"] = "black";
    SmartLinkTheme["Link"] = "link";
    return SmartLinkTheme;
}({});
var $fc2e49eaf9e6df05$export$9aafec380d7005da = /*#__PURE__*/ function(SmartLinkInternalTheme) {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    SmartLinkInternalTheme["Grey"] = "grey";
    return SmartLinkInternalTheme;
}({});
var $fc2e49eaf9e6df05$export$19c60054ee783de6 = /*#__PURE__*/ function(SmartLinkWidth) {
    SmartLinkWidth["FitToContent"] = "fit-to-content";
    SmartLinkWidth["Flexible"] = "flexible";
    return SmartLinkWidth;
}({});
var $fc2e49eaf9e6df05$export$d65b168331104a46 = /*#__PURE__*/ function(ElementName) {
    ElementName["AppliedToComponentsCount"] = "AppliedToComponentsCount";
    ElementName["AssignedTo"] = "AssignedTo";
    ElementName["AssignedToGroup"] = "AssignedToGroup";
    ElementName["AttachmentCount"] = "AttachmentCount";
    ElementName["AuthorGroup"] = "AuthorGroup";
    ElementName["ChecklistProgress"] = "ChecklistProgress";
    ElementName["CollaboratorGroup"] = "CollaboratorGroup";
    ElementName["CommentCount"] = "CommentCount";
    ElementName["CreatedBy"] = "CreatedBy";
    ElementName["CreatedOn"] = "CreatedOn";
    ElementName["DueOn"] = "DueOn";
    ElementName["LatestCommit"] = "LatestCommit";
    ElementName["LinkIcon"] = "LinkIcon";
    ElementName["Location"] = "Location";
    ElementName["ModifiedBy"] = "ModifiedBy";
    ElementName["ModifiedOn"] = "ModifiedOn";
    ElementName["OwnedBy"] = "OwnedBy";
    ElementName["OwnedByGroup"] = "OwnedByGroup";
    ElementName["Preview"] = "Preview";
    ElementName["Priority"] = "Priority";
    ElementName["ProgrammingLanguage"] = "ProgrammingLanguage";
    ElementName["Provider"] = "Provider";
    ElementName["ReactCount"] = "ReactCount";
    ElementName["ReadTime"] = "ReadTime";
    ElementName["Snippet"] = "Snippet";
    ElementName["SourceBranch"] = "SourceBranch";
    ElementName["State"] = "State";
    ElementName["SubscriberCount"] = "SubscriberCount";
    ElementName["SubTasksProgress"] = "SubTasksProgress";
    ElementName["StoryPoints"] = "StoryPoints";
    ElementName["TargetBranch"] = "TargetBranch";
    ElementName["TeamMemberCount"] = "TeamMemberCount";
    ElementName["Title"] = "Title";
    ElementName["UserAttributes"] = "UserAttributes";
    ElementName["ViewCount"] = "ViewCount";
    ElementName["VoteCount"] = "VoteCount";
    ElementName["SentOn"] = "SentOn";
    return ElementName;
}({});
var $fc2e49eaf9e6df05$export$9c95d6e1614bad84 = /*#__PURE__*/ function(ActionName) {
    ActionName["CopyLinkAction"] = "CopyLinkAction";
    ActionName["DeleteAction"] = "DeleteAction";
    ActionName["EditAction"] = "EditAction";
    ActionName["FollowAction"] = "FollowAction";
    ActionName["PreviewAction"] = "PreviewAction";
    ActionName["AutomationAction"] = "AutomationAction";
    ActionName["DownloadAction"] = "DownloadAction";
    ActionName["CustomAction"] = "CustomAction";
    return ActionName;
}({});
var $fc2e49eaf9e6df05$export$4871a84b35cf8eb9 = /*#__PURE__*/ function(InternalActionName) {
    InternalActionName["AISummaryAction"] = "AISummaryAction";
    InternalActionName["UnresolvedAction"] = "UnresolvedAction";
    InternalActionName["ViewRelatedLinksAction"] = "ViewRelatedLinksAction";
    return InternalActionName;
}({});
var $fc2e49eaf9e6df05$export$13ff1290a9e22e77 = /*#__PURE__*/ function(IconType) {
    IconType["Archive"] = "FileType:Archive";
    IconType["Audio"] = "FileType:Audio";
    IconType["Blog"] = "FileType:Blog";
    IconType["Code"] = "FileType:Code";
    IconType["Document"] = "FileType:Document";
    IconType["Executable"] = "FileType:Executable";
    IconType["File"] = "FileType:File";
    IconType["Folder"] = "FileType:Folder";
    IconType["Generic"] = "FileType:Generic";
    IconType["GIF"] = "FileType:GIF";
    IconType["GoogleDocs"] = "FileType:GoogleDocs";
    IconType["GoogleForms"] = "FileType:GoogleForms";
    IconType["GoogleSheets"] = "FileType:GoogleSheets";
    IconType["GoogleSlides"] = "FileType:GoogleSlides";
    IconType["Image"] = "FileType.Image";
    IconType["MSExcel"] = "FileType:Excel";
    IconType["MSPowerpoint"] = "FileType:Powerpoint";
    IconType["MSWord"] = "FileType:WordDocument";
    IconType["PDF"] = "FileType:PDF";
    IconType["Presentation"] = "FileType:Presentation";
    IconType["Sketch"] = "FileType:Sketch";
    IconType["Spreadsheet"] = "FileType:Spreadsheet";
    IconType["Template"] = "FileType:Template";
    IconType["Video"] = "FileType:Video";
    // BitBucket?
    IconType["Branch"] = "BitBucket:Branch";
    IconType["Commit"] = "BitBucket:Commit";
    IconType["Project"] = "BitBucket:Project";
    IconType["PullRequest"] = "BitBucket:PullRequest";
    IconType["Repo"] = "BitBucket:Repo";
    // Jira?
    IconType["Bug"] = "Jira:Bug";
    IconType["Change"] = "Jira:Change";
    IconType["Epic"] = "Jira:Epic";
    IconType["Incident"] = "Jira:Incident";
    IconType["Problem"] = "Jira:Problem";
    IconType["ServiceRequest"] = "Jira:ServiceRequest";
    IconType["Story"] = "Jira:Story";
    IconType["SubTask"] = "Jira:SubTask";
    IconType["Task"] = "Jira:Task";
    // Confluence
    IconType["LiveDocument"] = "Confluence:LiveDocument";
    // Provider
    IconType["Confluence"] = "Provider:Confluence";
    IconType["Jira"] = "Provider:Jira";
    // Fallback
    IconType["Default"] = "Default";
    IconType["Error"] = "Default:Error";
    IconType["Forbidden"] = "Default:Forbidden";
    // Badge
    IconType["Attachment"] = "Badge:Attachment";
    IconType["CheckItem"] = "Badge:Task";
    IconType["Comment"] = "Badge:Comment";
    IconType["Component"] = "Badge:Component";
    IconType["View"] = "Badge:View";
    IconType["React"] = "Badge:React";
    IconType["Vote"] = "Badge:Vote";
    IconType["PriorityBlocker"] = "Badge:PriorityBlocker";
    IconType["PriorityCritical"] = "Badge:PriorityCritical";
    IconType["PriorityHigh"] = "Badge:PriorityHigh";
    IconType["PriorityHighest"] = "Badge:PriorityHighest";
    IconType["PriorityLow"] = "Badge:PriorityLow";
    IconType["PriorityLowest"] = "Badge:PriorityLowest";
    IconType["PriorityMajor"] = "Badge:PriorityMajor";
    IconType["PriorityMedium"] = "Badge:PriorityMedium";
    IconType["PriorityMinor"] = "Badge:PriorityMinor";
    IconType["PriorityTrivial"] = "Badge:PriorityTrivial";
    IconType["PriorityUndefined"] = "Badge:PriorityUndefined";
    IconType["ProgrammingLanguage"] = "Badge:ProgrammingLanguage";
    IconType["Subscriber"] = "Badge:Subscriber";
    IconType["SubTasksProgress"] = "Badge:SubTask";
    return IconType;
}({});
var $fc2e49eaf9e6df05$export$483c11740a902fcd = /*#__PURE__*/ function(MediaType) {
    MediaType["Image"] = "image";
    return MediaType;
}({});
var $fc2e49eaf9e6df05$export$f9f4737e25ab90fa = /*#__PURE__*/ function(MediaPlacement) {
    MediaPlacement["Left"] = "left";
    MediaPlacement["Right"] = "right";
    return MediaPlacement;
}({});
var $fc2e49eaf9e6df05$export$6ca4ef8b3dc2c804 = /*#__PURE__*/ function(CardDisplay) {
    CardDisplay["Inline"] = "inline";
    CardDisplay["Block"] = "block";
    CardDisplay["Embed"] = "embed";
    CardDisplay["EmbedPreview"] = "embedPreview";
    CardDisplay["Flexible"] = "flexible";
    CardDisplay["HoverCardPreview"] = "hoverCardPreview";
    return CardDisplay;
}({});

});

parcelRegister("dyU3L", function(module, exports) {

$parcel$export(module.exports, "default", () => $9aa425783d81a7e4$export$2e2bcd8739ae039);

var $5NtHI = parcelRequire("5NtHI");
const $9aa425783d81a7e4$var$extractFileFormatIcon = (fileFormat)=>{
    switch(fileFormat){
        // Generic documents
        case 'folder':
            return {
                icon: (0, $5NtHI.IconType).Folder,
                label: 'Folder'
            };
        case 'text/plain':
        case 'application/vnd.oasis.opendocument.text':
        case 'application/vnd.apple.pages':
            return {
                icon: (0, $5NtHI.IconType).Document,
                label: 'Document'
            };
        case 'application/pdf':
            return {
                icon: (0, $5NtHI.IconType).PDF,
                label: 'PDF document'
            };
        case 'application/vnd.oasis.opendocument.presentation':
        case 'application/vnd.apple.keynote':
            return {
                icon: (0, $5NtHI.IconType).Presentation,
                label: 'Presentation'
            };
        case 'application/vnd.oasis.opendocument.spreadsheet':
        case 'application/vnd.apple.numbers':
            return {
                icon: (0, $5NtHI.IconType).Spreadsheet,
                label: 'Spreadsheet'
            };
        // Google Drive
        case 'application/vnd.google-apps.document':
            return {
                icon: (0, $5NtHI.IconType).GoogleDocs,
                label: 'Google Docs'
            };
        case 'application/vnd.google-apps.form':
            return {
                icon: (0, $5NtHI.IconType).GoogleForms,
                label: 'Google Form'
            };
        case 'application/vnd.google-apps.spreadsheet':
            return {
                icon: (0, $5NtHI.IconType).GoogleSheets,
                label: 'Google Sheets'
            };
        case 'application/vnd.google-apps.presentation':
            return {
                icon: (0, $5NtHI.IconType).GoogleSlides,
                label: 'Google Slides'
            };
        // Microsoft
        case 'application/vnd.ms-excel':
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
            return {
                icon: (0, $5NtHI.IconType).MSExcel,
                label: 'Excel spreadsheet'
            };
        case 'application/vnd.ms-powerpoint':
        case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
            return {
                icon: (0, $5NtHI.IconType).MSPowerpoint,
                label: 'PowerPoint presentation'
            };
        case 'application/msword':
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
            return {
                icon: (0, $5NtHI.IconType).MSWord,
                label: 'Word document'
            };
        case 'image/png':
        case 'image/jpeg':
        case 'image/bmp':
        case 'image/webp':
        case 'image/svg+xml':
            return {
                icon: (0, $5NtHI.IconType).Image,
                label: 'Image'
            };
        case 'image/gif':
            return {
                icon: (0, $5NtHI.IconType).GIF,
                label: 'GIF'
            };
        case 'audio/midi':
        case 'audio/mpeg':
        case 'audio/webm':
        case 'audio/ogg':
        case 'audio/wav':
            return {
                icon: (0, $5NtHI.IconType).Audio,
                label: 'Audio'
            };
        case 'video/mp4':
        case 'video/quicktime':
        case 'video/mov':
        case 'video/webm':
        case 'video/ogg':
        case 'video/x-ms-wmv':
        case 'video/x-msvideo':
            return {
                icon: (0, $5NtHI.IconType).Video,
                label: 'Video'
            };
        // Others
        case 'text/css':
        case 'text/html':
        case 'application/javascript':
            return {
                icon: (0, $5NtHI.IconType).Code,
                label: 'Source Code'
            };
        case 'application/zip':
        case 'application/x-tar':
        case 'application/x-gtar':
        case 'application/x-7z-compressed':
        case 'application/x-apple-diskimage':
        case 'application/vnd.rar':
            return {
                icon: (0, $5NtHI.IconType).Archive,
                label: 'Archive'
            };
        case 'application/dmg':
            return {
                icon: (0, $5NtHI.IconType).Executable,
                label: 'Executable'
            };
        case 'application/sketch':
            return {
                icon: (0, $5NtHI.IconType).Sketch,
                label: 'Sketch'
            };
        case 'application/octet-stream':
            return {
                icon: (0, $5NtHI.IconType).Generic,
                label: 'Binary file'
            };
        case 'application/invision.prototype':
            return {
                icon: (0, $5NtHI.IconType).Generic,
                label: 'Prototype'
            };
        default:
            return undefined;
    }
};
var $9aa425783d81a7e4$export$2e2bcd8739ae039 = $9aa425783d81a7e4$var$extractFileFormatIcon;

});

parcelRegister("9dPtp", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $a49966ca6c4774bc$export$2e2bcd8739ae039);

var $lImMk = parcelRequire("lImMk");

var $gxCW9 = parcelRequire("gxCW9");

var $DtmfJ = parcelRequire("DtmfJ");

var $cPcks = parcelRequire("cPcks");
const $a49966ca6c4774bc$var$PageIconWithColor = (0, $cPcks.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($DtmfJ))), 'blueBold', (0, $cPcks.renderIconPerSize)((0, (/*@__PURE__*/$parcel$interopDefault($lImMk))), (0, (/*@__PURE__*/$parcel$interopDefault($gxCW9)))));
$a49966ca6c4774bc$var$PageIconWithColor.displayName = 'PageIconWithColor';
var $a49966ca6c4774bc$export$2e2bcd8739ae039 = $a49966ca6c4774bc$var$PageIconWithColor;

});
parcelRegister("lImMk", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $fcef605c5c3325f6$var$_react = $fcef605c5c3325f6$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $fcef605c5c3325f6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $fcef605c5c3325f6$var$Document16Icon = (props)=>/*#__PURE__*/ $fcef605c5c3325f6$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m2 3a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2zm0 4a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        size: 'small'
    }));
$fcef605c5c3325f6$var$Document16Icon.displayName = 'Document16Icon';
var $fcef605c5c3325f6$var$_default = module.exports.default = $fcef605c5c3325f6$var$Document16Icon;

});

parcelRegister("gxCW9", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $c0adee7b3af1dc62$var$_react = $c0adee7b3af1dc62$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $c0adee7b3af1dc62$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c0adee7b3af1dc62$var$Document24Icon = (props)=>/*#__PURE__*/ $c0adee7b3af1dc62$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1 18c0 .556.446 1 .995 1h8.01c.54 0 .995-.448.995-1 0-.556-.446-1-.995-1h-8.01c-.54 0-.995.448-.995 1m0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1m0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1m0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1"/></svg>`
    }, props, {
        size: 'medium'
    }));
$c0adee7b3af1dc62$var$Document24Icon.displayName = 'Document24Icon';
var $c0adee7b3af1dc62$var$_default = module.exports.default = $c0adee7b3af1dc62$var$Document24Icon;

});

parcelRegister("cPcks", function(module, exports) {

$parcel$export(module.exports, "renderIconPerSize", () => $5c2d46cff1f07a26$export$28dd5ad82647c000);
$parcel$export(module.exports, "renderIconTile", () => $5c2d46cff1f07a26$export$87c3646d0e299cfe);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1WryD = parcelRequire("1WryD");

var $5NtHI = parcelRequire("5NtHI");

var $FoFt2 = parcelRequire("FoFt2");
const $5c2d46cff1f07a26$export$3acc3fb10995f020 = (size)=>{
    switch(size){
        case (0, $5NtHI.SmartLinkSize).XLarge:
        case (0, $5NtHI.SmartLinkSize).Large:
            return '24';
        default:
            return '16';
    }
};
const $5c2d46cff1f07a26$export$28dd5ad82647c000 = (IconSmall, IconLarge)=>{
    return ({ size: size, ...props })=>{
        if ((0, $FoFt2.isIconSizeLarge)(size)) return /*#__PURE__*/ (0, $gt9Am.jsx)(IconLarge, {
            ...props
        });
        return /*#__PURE__*/ (0, $gt9Am.jsx)(IconSmall, {
            ...props
        });
    };
};
const $5c2d46cff1f07a26$export$87c3646d0e299cfe = (Icon, appearance, LegacyIcon)=>{
    return ({ size: size, ...props })=>{
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1WryD.default), {
            appearance: appearance,
            icon: Icon,
            size: $5c2d46cff1f07a26$export$3acc3fb10995f020(size),
            ...props,
            LEGACY_fallbackComponent: LegacyIcon && /*#__PURE__*/ (0, $gt9Am.jsx)(LegacyIcon, {
                ...props,
                size: size
            })
        });
    };
};

});


parcelRegister("4Gz8O", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $1589456b7a180f6b$export$2e2bcd8739ae039);

var $ihwup = parcelRequire("ihwup");

var $ff2hw = parcelRequire("ff2hw");

var $cPcks = parcelRequire("cPcks");
const $1589456b7a180f6b$var$BlogIconWithColor = (0, $cPcks.renderIconPerSize)((0, $ihwup.default), (0, $ff2hw.default));
$1589456b7a180f6b$var$BlogIconWithColor.displayName = 'BlogIconWithColor';
var $1589456b7a180f6b$export$2e2bcd8739ae039 = $1589456b7a180f6b$var$BlogIconWithColor;

});
parcelRegister("ihwup", function(module, exports) {

$parcel$export(module.exports, "default", () => $6042983cb1b7627c$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::845767e81b63ae055da0ba81295847f0>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1WryD = parcelRequire("1WryD");

var $amerd = parcelRequire("amerd");

var $eGOwo = parcelRequire("eGOwo");

var $37A7r = parcelRequire("37A7r");
/**
 * __16px `blog` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $6042983cb1b7627c$var$Blog16Icon = ({ label: label, testId: testId })=>{
    if ((0, $eGOwo.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1WryD.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($amerd))),
        appearance: "blueBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $37A7r.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $37A7r.default), {
        label: label,
        testId: testId
    });
};
$6042983cb1b7627c$var$Blog16Icon.displayName = 'Blog16Icon';
var $6042983cb1b7627c$export$2e2bcd8739ae039 = $6042983cb1b7627c$var$Blog16Icon;

});
parcelRegister("amerd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::295e96fa490818737b2d2c8ee4291bb5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $78a7288f6e3e8955$var$_react = $78a7288f6e3e8955$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $78a7288f6e3e8955$var$_baseNew = $78a7288f6e3e8955$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $78a7288f6e3e8955$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "QuotationMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: blockquote, comment, testimonial, blogs in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $78a7288f6e3e8955$var$QuotationMarkIcon = (props)=>/*#__PURE__*/ $78a7288f6e3e8955$var$_react.default.createElement($78a7288f6e3e8955$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v6a4 4 0 0 1-4 4v-1.5A2.5 2.5 0 0 0 5.5 10V9H2a2 2 0 0 1-2-2zm5.5 3.5V4a.5.5 0 0 0-.5-.5H2a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5zM9 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v6a4 4 0 0 1-4 4v-1.5a2.5 2.5 0 0 0 2.5-2.5V9H11a2 2 0 0 1-2-2zm5.5 3.5V4a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5z" clip-rule="evenodd"/>`
    }, props));
$78a7288f6e3e8955$var$QuotationMarkIcon.displayName = 'QuotationMarkIcon';
var $78a7288f6e3e8955$var$_default = module.exports.default = $78a7288f6e3e8955$var$QuotationMarkIcon;

});

parcelRegister("37A7r", function(module, exports) {

$parcel$export(module.exports, "default", () => $def8fa9bf18a8fbf$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::387cb99b24103ef6908201cae0580f7c>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kxVLD = parcelRequire("kxVLD");
const $def8fa9bf18a8fbf$var$Blog16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $kxVLD.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M6.972 6.128a2.5 2.5 0 1 0-2.37 2.87q-.416.59-1.016 1.265a.916.916 0 0 0-.058 1.147.607.607 0 0 0 .948.043q2.908-3.331 2.496-5.325m7 0a2.5 2.5 0 1 0-2.37 2.87q-.416.59-1.016 1.265a.916.916 0 0 0-.058 1.147.607.607 0 0 0 .948.043q2.908-3.331 2.496-5.325M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2"/></svg>`,
        ...props,
        size: "small"
    });
$def8fa9bf18a8fbf$var$Blog16Icon.displayName = 'Blog16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$def8fa9bf18a8fbf$export$2e2bcd8739ae039 = $def8fa9bf18a8fbf$var$Blog16Icon;

});


parcelRegister("ff2hw", function(module, exports) {

$parcel$export(module.exports, "default", () => $674c38c84d40fa8d$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bba35c7457f1c82d9d31626969c259a0>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1WryD = parcelRequire("1WryD");

var $amerd = parcelRequire("amerd");

var $eGOwo = parcelRequire("eGOwo");

var $4HJXf = parcelRequire("4HJXf");
/**
 * __24px `blog` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $674c38c84d40fa8d$var$Blog24Icon = ({ label: label, testId: testId })=>{
    if ((0, $eGOwo.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1WryD.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($amerd))),
        appearance: "blueBold",
        size: "24",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4HJXf.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4HJXf.default), {
        label: label,
        testId: testId
    });
};
$674c38c84d40fa8d$var$Blog24Icon.displayName = 'Blog24Icon';
var $674c38c84d40fa8d$export$2e2bcd8739ae039 = $674c38c84d40fa8d$var$Blog24Icon;

});
parcelRegister("4HJXf", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ddb48944e405ac0$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b7682b4d34bd2a783038ec83f3b47a94>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kxVLD = parcelRequire("kxVLD");
const $2ddb48944e405ac0$var$Blog24Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $kxVLD.IconFacade), {
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M10.998 9.035a3.5 3.5 0 1 0-3.046 3.94q-.71 1.254-1.87 2.827a1.17 1.17 0 0 0 .102 1.506.85.85 0 0 0 1.298-.092q4.013-5.52 3.516-8.18m8.895 0a3.5 3.5 0 1 0-3.046 3.94q-.71 1.254-1.87 2.827a1.17 1.17 0 0 0 .102 1.506.85.85 0 0 0 1.298-.092q4.012-5.52 3.516-8.18M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3"/></svg>`,
        ...props,
        size: "medium"
    });
$2ddb48944e405ac0$var$Blog24Icon.displayName = 'Blog24Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$2ddb48944e405ac0$export$2e2bcd8739ae039 = $2ddb48944e405ac0$var$Blog24Icon;

});



parcelRegister("jGI3w", function(module, exports) {

let $e5541d223003f966$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $e5541d223003f966$var$load("lBret").then(()=>parcelRequire('lT9gU'));

});

parcelRegister("2l32C", function(module, exports) {

let $1b3fe6d6c1117eb4$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $1b3fe6d6c1117eb4$var$load("c4Piz").then(()=>parcelRequire('b9JjP'));

});

parcelRegister("kM5eD", function(module, exports) {

let $f1fc59e4d78436bf$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $f1fc59e4d78436bf$var$load("fJRo2").then(()=>parcelRequire('3JiAU'));

});

parcelRegister("ipZFl", function(module, exports) {

let $d68a655378e7bfd3$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $d68a655378e7bfd3$var$load("68koG").then(()=>parcelRequire('htaza'));

});

parcelRegister("gy68w", function(module, exports) {

let $c0c494e4ef1a9465$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $c0c494e4ef1a9465$var$load("gfpt4").then(()=>parcelRequire('idFH3'));

});

parcelRegister("7lhDi", function(module, exports) {

let $55882c19f26a9e19$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $55882c19f26a9e19$var$load("3roEx").then(()=>parcelRequire('eDFE1'));

});

parcelRegister("PhsZo", function(module, exports) {

let $09a2500825b5c11a$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $09a2500825b5c11a$var$load("9mQM4").then(()=>parcelRequire('8UJE5'));

});

parcelRegister("9bxQV", function(module, exports) {

let $6aff6695f59be982$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $6aff6695f59be982$var$load("6TgwN").then(()=>parcelRequire('8ALRN'));

});

parcelRegister("3ypIZ", function(module, exports) {

let $29688079c4b0ee96$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $29688079c4b0ee96$var$load("43EiL").then(()=>parcelRequire('bKXd3'));

});

parcelRegister("2N4kX", function(module, exports) {

let $2083859e6f9dfb04$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $2083859e6f9dfb04$var$load("i35Uh").then(()=>parcelRequire('ccKWN'));

});

parcelRegister("54Irl", function(module, exports) {

let $3b1fcc5c895af309$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $3b1fcc5c895af309$var$load("9vjhq").then(()=>parcelRequire('aSnEf'));

});

parcelRegister("5JIMH", function(module, exports) {

let $42d3e4f963bcfa12$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $42d3e4f963bcfa12$var$load("j5W60").then(()=>parcelRequire('ju9Zq'));

});

parcelRegister("b7X9d", function(module, exports) {

let $819e3aa5538bdbce$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $819e3aa5538bdbce$var$load("gHrjT").then(()=>parcelRequire('4BqrB'));

});

parcelRegister("2uY1f", function(module, exports) {

let $1d1cf0ab40960c11$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $1d1cf0ab40960c11$var$load("hCGN9").then(()=>parcelRequire('cwxjA'));

});

parcelRegister("8S5KR", function(module, exports) {

let $6757d4ae8dcfc90d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $6757d4ae8dcfc90d$var$load("igTGi").then(()=>parcelRequire('llYLq'));

});

parcelRegister("7lDFg", function(module, exports) {

let $55994325bd6a89db$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $55994325bd6a89db$var$load("8A7Un").then(()=>parcelRequire('bxHzv'));

});

parcelRegister("9IKYh", function(module, exports) {

let $713ca8a214b25950$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $713ca8a214b25950$var$load("fnRpB").then(()=>parcelRequire('FXbTY'));

});

parcelRegister("hEMIE", function(module, exports) {

let $cdabf6baf903c352$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $cdabf6baf903c352$var$load("fMJrt").then(()=>parcelRequire('do41j'));

});

parcelRegister("dE7I7", function(module, exports) {

let $9ef4fdf58b078442$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $9ef4fdf58b078442$var$load("cxAqh").then(()=>parcelRequire('gbtcZ'));

});

parcelRegister("7gFcl", function(module, exports) {

let $54a9fc1f3aecb61f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $54a9fc1f3aecb61f$var$load("kvxvv").then(()=>parcelRequire('2j1uF'));

});

parcelRegister("ij46p", function(module, exports) {

let $d53d2eff9115be5f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $d53d2eff9115be5f$var$load("5DW8N").then(()=>parcelRequire('8J7Hh'));

});

parcelRegister("2aQhi", function(module, exports) {

let $1955113bec4b7083$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $1955113bec4b7083$var$load("er5Rw").then(()=>parcelRequire('ktJB5'));

});

parcelRegister("5fclM", function(module, exports) {

let $3d17eef5d89f84ca$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $3d17eef5d89f84ca$var$load("a4ZTh").then(()=>parcelRequire('1O53N'));

});

parcelRegister("f9TV4", function(module, exports) {

let $b09312b6a3314853$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $b09312b6a3314853$var$load("fVZub").then(()=>parcelRequire('jYfQG'));

});

parcelRegister("iFMZJ", function(module, exports) {

let $d9820fa67dfab31f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $d9820fa67dfab31f$var$load("biRPG").then(()=>parcelRequire('gR3IA'));

});

parcelRegister("feyrR", function(module, exports) {

let $b172e28d8f60e9da$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $b172e28d8f60e9da$var$load("5PIwW").then(()=>parcelRequire('dmWJ4'));

});

parcelRegister("9YhWF", function(module, exports) {

let $7427a3392f22aacf$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $7427a3392f22aacf$var$load("1zPk8").then(()=>parcelRequire('eHIwa'));

});

parcelRegister("gbfzG", function(module, exports) {

let $bc79c1329eafb9ee$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $bc79c1329eafb9ee$var$load("hy7F8").then(()=>parcelRequire('lR9WO'));

});

parcelRegister("5M4VY", function(module, exports) {

let $434543426cb0a6c3$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $434543426cb0a6c3$var$load("5UA41").then(()=>parcelRequire('aozTf'));

});

parcelRegister("jc5UC", function(module, exports) {

let $df93b95e4085ac34$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $df93b95e4085ac34$var$load("jQGZH").then(()=>parcelRequire('3mwl5'));

});

parcelRegister("gDPso", function(module, exports) {

let $c1d8341f0ee2b765$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $c1d8341f0ee2b765$var$load("55GNU").then(()=>parcelRequire('7lmhQ'));

});

parcelRegister("f65Of", function(module, exports) {

let $afdbec3699fb9e2d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $afdbec3699fb9e2d$var$load("eiZZR").then(()=>parcelRequire('f8Y7f'));

});

parcelRegister("ilCAi", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $a3170ce3e9e98d41$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c1228c9bdd9840505938b56c7ed44212>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1WryD = parcelRequire("1WryD");

var $cruFS = parcelRequire("cruFS");

var $eGOwo = parcelRequire("eGOwo");

var $7KbsS = parcelRequire("7KbsS");
/**
 * __16px `page-live-doc` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $a3170ce3e9e98d41$var$PageLiveDoc16Icon = ({ label: label, testId: testId })=>{
    if ((0, $eGOwo.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1WryD.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cruFS))),
        appearance: "magentaBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7KbsS.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7KbsS.default), {
        label: label,
        testId: testId
    });
};
$a3170ce3e9e98d41$var$PageLiveDoc16Icon.displayName = 'PageLiveDoc16Icon';
var $a3170ce3e9e98d41$export$2e2bcd8739ae039 = $a3170ce3e9e98d41$var$PageLiveDoc16Icon;

});
parcelRegister("cruFS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::692b62fec4c56cd82ae8d8d02e2d3f2e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $90efccf3a3cdec59$var$_react = $90efccf3a3cdec59$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $90efccf3a3cdec59$var$_baseNew = $90efccf3a3cdec59$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $90efccf3a3cdec59$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PageLiveDoc".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for Live Document content type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $90efccf3a3cdec59$var$PageLiveDocIcon = (props)=>/*#__PURE__*/ $90efccf3a3cdec59$var$_react.default.createElement($90efccf3a3cdec59$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm-9 5H1V7h5zM6 14H1v-1.5h5zm2.72-6.78a.75.75 0 0 1 .79-.17l6 2.25a.75.75 0 0 1-.08 1.43l-2.56.64-.64 2.56a.75.75 0 0 1-1.43.08l-2.25-6a.75.75 0 0 1 .17-.79" clip-rule="evenodd"/>`
    }, props));
$90efccf3a3cdec59$var$PageLiveDocIcon.displayName = 'PageLiveDocIcon';
var $90efccf3a3cdec59$var$_default = module.exports.default = $90efccf3a3cdec59$var$PageLiveDocIcon;

});

parcelRegister("7KbsS", function(module, exports) {

$parcel$export(module.exports, "default", () => $49cedc712f457d93$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bbb561a99c36d24f949f1ade9ed1fa72>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kxVLD = parcelRequire("kxVLD");
const $49cedc712f457d93$var$PageLiveDoc16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $kxVLD.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#cd519d" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m1.293 3.293A1 1 0 0 0 4 5h8a1 1 0 1 0 0-2H4a1 1 0 0 0-.707.293m0 4A1 1 0 0 0 4 9h2a1 1 0 0 0 0-2H4a1 1 0 0 0-.707.293m0 4A1 1 0 0 0 4 13h2a1 1 0 0 0 0-2H4a1 1 0 0 0-.707.293m6.703-4.161a1 1 0 0 0-1.466 1.11l1 4a1 1 0 0 0 1.94 0L11.78 11H13a1 1 0 0 0 .496-1.868z" clip-rule="evenodd"/></svg>`,
        ...props,
        size: "small"
    });
$49cedc712f457d93$var$PageLiveDoc16Icon.displayName = 'PageLiveDoc16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$49cedc712f457d93$export$2e2bcd8739ae039 = $49cedc712f457d93$var$PageLiveDoc16Icon;

});


parcelRegister("hB03j", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $0bd6bb1ec7db3603$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::724c9bd5f0d44d16613664f162286445>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1WryD = parcelRequire("1WryD");

var $cruFS = parcelRequire("cruFS");

var $eGOwo = parcelRequire("eGOwo");

var $kZFQQ = parcelRequire("kZFQQ");
/**
 * __24px `page-live-doc` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $0bd6bb1ec7db3603$var$PageLiveDoc24Icon = ({ label: label, testId: testId })=>{
    if ((0, $eGOwo.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1WryD.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cruFS))),
        appearance: "magentaBold",
        size: "24",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kZFQQ.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kZFQQ.default), {
        label: label,
        testId: testId
    });
};
$0bd6bb1ec7db3603$var$PageLiveDoc24Icon.displayName = 'PageLiveDoc24Icon';
var $0bd6bb1ec7db3603$export$2e2bcd8739ae039 = $0bd6bb1ec7db3603$var$PageLiveDoc24Icon;

});
parcelRegister("kZFQQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6dc3d78982b295d$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c5906433494daa938e0cf018edb0a9fc>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kxVLD = parcelRequire("kxVLD");
const $b6dc3d78982b295d$var$PageLiveDoc24Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $kxVLD.IconFacade), {
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#cd519d" fill-rule="evenodd" d="M24 3a3 3 0 0 0-3-3H3a3 3 0 0 0-3 3v18a3 3 0 0 0 3 3h18a3 3 0 0 0 3-3zM4 6a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1m1 5a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2zm-1 7a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1m10.555-6.832a1 1 0 0 0-1.545.973l1 7a1 1 0 0 0 1.884.306L17.118 17H20a1 1 0 0 0 .555-1.832z" clip-rule="evenodd"/></svg>`,
        ...props,
        size: "medium"
    });
$b6dc3d78982b295d$var$PageLiveDoc24Icon.displayName = 'PageLiveDoc24Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b6dc3d78982b295d$export$2e2bcd8739ae039 = $b6dc3d78982b295d$var$PageLiveDoc24Icon;

});


parcelRegister("9Iwo3", function(module, exports) {

let $7131587aee457d5d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $7131587aee457d5d$var$load("8qkPR").then(()=>parcelRequire('dci17'));

});

parcelRegister("5Ak2H", function(module, exports) {

let $410fdc8d94fecfa7$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $410fdc8d94fecfa7$var$load("fbn5L").then(()=>parcelRequire('C9929'));

});

parcelRegister("gb3jU", function(module, exports) {

let $bc703fbd5be688a8$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $bc703fbd5be688a8$var$load("gKXx1").then(()=>parcelRequire('4KX56'));

});

parcelRegister("6n9v8", function(module, exports) {

let $4a3c42c5d50247c1$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $4a3c42c5d50247c1$var$load("8ug3B").then(()=>parcelRequire('8BBLJ'));

});

parcelRegister("eIsTj", function(module, exports) {

let $ab6b95f1105dbf9f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $ab6b95f1105dbf9f$var$load("7eKSC").then(()=>parcelRequire('eHAfU'));

});

parcelRegister("f1B8s", function(module, exports) {

let $af03c14f83944172$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $af03c14f83944172$var$load("4Eivj").then(()=>parcelRequire('gbfWz'));

});

parcelRegister("cmEXk", function(module, exports) {

let $90074f15857f3006$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $90074f15857f3006$var$load("jYxgH").then(()=>parcelRequire('dRjRH'));

});

parcelRegister("bTWmL", function(module, exports) {

let $8aa21b1448097f6c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $8aa21b1448097f6c$var$load("7Asrt").then(()=>parcelRequire('9Vj9G'));

});

parcelRegister("iSMal", function(module, exports) {

let $dbf2a1df4bf98f13$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $dbf2a1df4bf98f13$var$load("lHw2B").then(()=>parcelRequire('eRvGI'));

});

parcelRegister("jRdgC", function(module, exports) {

let $e74d4222aaf1447b$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $e74d4222aaf1447b$var$load("kjPUS").then(()=>parcelRequire('6l95m'));

});

parcelRegister("kRp0o", function(module, exports) {

let $f2fc277294405d0e$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $f2fc277294405d0e$var$load("iNoMF").then(()=>parcelRequire('fuz0W'));

});

parcelRegister("KywEn", function(module, exports) {

let $08bf140fab0acedd$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $08bf140fab0acedd$var$load("4oVpa").then(()=>parcelRequire('dn2cU'));

});

parcelRegister("fHwpk", function(module, exports) {

let $b6e4029ff0dd119f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $b6e4029ff0dd119f$var$load("66VwL").then(()=>parcelRequire('cAlmw'));

});

parcelRegister("BSiun", function(module, exports) {

let $071d931c65cacbd8$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $071d931c65cacbd8$var$load("giNlE").then(()=>parcelRequire('9HReW'));

});

parcelRegister("8l50I", function(module, exports) {

let $61242be4982e6a7b$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $61242be4982e6a7b$var$load("8vZhS").then(()=>parcelRequire('8Pg2Y'));

});

parcelRegister("htWC6", function(module, exports) {

let $cba29c83f7127a5b$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $cba29c83f7127a5b$var$load("gLziw").then(()=>parcelRequire('lrD2G'));

});

parcelRegister("cDlzR", function(module, exports) {

let $9329dd5d9131bf69$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $9329dd5d9131bf69$var$load("4Z2q8").then(()=>parcelRequire('ka71P'));

});

parcelRegister("bMymA", function(module, exports) {

let $893ed53a3c7667da$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $893ed53a3c7667da$var$load("kzCMD").then(()=>parcelRequire('kmi1F'));

});


parcelRegister("44bDi", function(module, exports) {

$parcel$export(module.exports, "useSmartLinkAnalyticsContext", () => $5c3f03a637d1ec7f$export$ac28ada90c4970b7);
$parcel$export(module.exports, "SmartLinkAnalyticsContext", () => $5c3f03a637d1ec7f$export$eaff10f7ec59c455);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $e2B2h = parcelRequire("e2B2h");

var $wq6W1 = parcelRequire("wq6W1");

var $9kfy2 = parcelRequire("9kfy2");

var $9NiLY = parcelRequire("9NiLY");

var $eGOwo = parcelRequire("eGOwo");

var $5TXKo = parcelRequire("5TXKo");

var $b43DQ = parcelRequire("b43DQ");
const $5c3f03a637d1ec7f$var$getExtendedResolvedAttributes = (linkDetails, details, linkStatus, error)=>({
        definitionId: details?.meta?.definitionId ?? null,
        resourceType: details?.meta?.resourceType ?? null,
        ...(0, $wq6W1.getResolvedAttributes)(linkDetails, details, linkStatus, error)
    });
const $5c3f03a637d1ec7f$var$getSmartLinkAnalyticsContext = ({ display: display, id: id, response: response, source: source, status: status, url: url, error: error })=>{
    const resolvedAttributes = $5c3f03a637d1ec7f$var$getExtendedResolvedAttributes({
        url: url
    }, response, status, error);
    return {
        source: source,
        attributes: {
            ...(0, $b43DQ.context),
            display: display,
            id: id,
            ...resolvedAttributes
        }
    };
};
const $5c3f03a637d1ec7f$export$ac28ada90c4970b7 = ({ display: display, id: id, source: source, url: url })=>{
    const { store: store } = (0, $9kfy2.useSmartLinkContext)();
    const state = store ? (0, $9NiLY.getUrl)(store, url) : undefined;
    return (0, $eJOHy.useMemo)(()=>{
        return $5c3f03a637d1ec7f$var$getSmartLinkAnalyticsContext({
            display: display,
            id: id,
            response: state?.details,
            source: source,
            status: state?.status,
            url: url,
            error: state?.error
        });
    }, [
        display,
        id,
        source,
        state?.details,
        state?.status,
        url,
        state?.error
    ]);
};
const $5c3f03a637d1ec7f$export$eaff10f7ec59c455 = ({ children: children, display: display, id: id, source: source, url: url })=>{
    const { details: details, status: status, error: error } = (0, $5TXKo.useSmartCardState)(url);
    const data = $5c3f03a637d1ec7f$var$getSmartLinkAnalyticsContext({
        display: display,
        id: id,
        response: details,
        source: source,
        status: status,
        url: url,
        error: (0, $eGOwo.fg)('platform_bandicoots-smartlink-unresolved-error-key') ? error : undefined
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $e2B2h.default), {
        data: data,
        children: children
    });
};

});
parcelRegister("5TXKo", function(module, exports) {

$parcel$export(module.exports, "useSmartCardState", () => $644fcc1916cdb207$export$b0444d00ba7313c6);

var $iHcr1 = parcelRequire("iHcr1");

var $9kfy2 = parcelRequire("9kfy2");
const $644fcc1916cdb207$var$PENDING_STATE = {
    status: 'pending'
};
function $644fcc1916cdb207$export$b0444d00ba7313c6(url) {
    const { store: store } = (0, $9kfy2.useSmartLinkContext)();
    const cardState = (0, $iHcr1.useSyncExternalStoreWithSelector)(store.subscribe, store.getState, store.getState, (state)=>state[url]);
    return cardState ?? $644fcc1916cdb207$var$PENDING_STATE;
}

});


parcelRegister("1YI3f", function(module, exports) {

$parcel$export(module.exports, "isFlexibleUiCard", () => $ec5109f5e7b621c7$export$3c94e0f4719f5c2a);
$parcel$export(module.exports, "isStyleCacheProvider", () => $ec5109f5e7b621c7$export$14ff825bfe645006);
$parcel$export(module.exports, "isFlexibleUiBlock", () => $ec5109f5e7b621c7$export$b56fc89cf6e7d1e9);
$parcel$export(module.exports, "isFlexibleUiElement", () => $ec5109f5e7b621c7$export$d7fc505bb0bd5756);
$parcel$export(module.exports, "isFlexibleUiPreviewBlock", () => $ec5109f5e7b621c7$export$c0547b4405cae584);

var $eJOHy = parcelRequire("eJOHy");

var $34CM9 = parcelRequire("34CM9");
var $fqBfo = parcelRequire("fqBfo");
var $8Rjtc = parcelRequire("8Rjtc");
var $lAF2k = parcelRequire("lAF2k");

var $4RG9i = parcelRequire("4RG9i");
const $ec5109f5e7b621c7$export$3c94e0f4719f5c2a = (children, ui)=>{
    if (ui?.removeBlockRestriction) return children && (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.toArray(children)?.length > 0 ? true : false;
    if (children && (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.toArray(children).some((child)=>$ec5109f5e7b621c7$export$df0092b19156b140(child))) return true;
    return false;
};
const $ec5109f5e7b621c7$export$14ff825bfe645006 = (node)=>{
    if (typeof node.type !== 'string' && node.type?.name === 'StyleCacheProvider' && node.props.children) return true;
    else if (typeof node.type !== 'string' && node.type?.name === 'CC' && node.props.children) return true;
    return false;
};
const $ec5109f5e7b621c7$export$b56fc89cf6e7d1e9 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(node)) return false;
    if ($ec5109f5e7b621c7$export$14ff825bfe645006(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(node.props.children, (child)=>{
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $ec5109f5e7b621c7$export$b56fc89cf6e7d1e9(child);
        });
        return isChildrenValid;
    }
    if (Object.values($34CM9).some((type)=>type === node.type)) return true;
    return false;
};
const $ec5109f5e7b621c7$export$d7fc505bb0bd5756 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(node)) return false;
    if (Object.values($4RG9i).some((type)=>type === node.type)) return true;
    if ($ec5109f5e7b621c7$export$14ff825bfe645006(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(node.props.children, (child)=>{
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $ec5109f5e7b621c7$export$d7fc505bb0bd5756(child);
        });
        return isChildrenValid;
    }
    return false;
};
const $ec5109f5e7b621c7$export$df0092b19156b140 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(node)) return false;
    if (node.type === (0, $fqBfo.default)) return true;
    if ($ec5109f5e7b621c7$export$14ff825bfe645006(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(node.props.children, (child)=>{
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $ec5109f5e7b621c7$export$df0092b19156b140(child);
        });
        return isChildrenValid;
    }
    return false;
};
const $ec5109f5e7b621c7$export$c0547b4405cae584 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(node)) return false;
    if (node.type === (0, $8Rjtc.default)) return true;
    if ($ec5109f5e7b621c7$export$14ff825bfe645006(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(node.props.children, (child)=>{
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $ec5109f5e7b621c7$export$c0547b4405cae584(child);
        });
        return isChildrenValid;
    }
    return false;
};
const $ec5109f5e7b621c7$export$43edae7b55c79927 = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(node) && node.type === (0, $lAF2k.default);

});
parcelRegister("34CM9", function(module, exports) {

$parcel$export(module.exports, "FooterBlock", () => (parcelRequire("lAF2k")).default);
$parcel$export(module.exports, "MetadataBlock", () => (parcelRequire("gKsxm")).default);
$parcel$export(module.exports, "PreviewBlock", () => (parcelRequire("8Rjtc")).default);
$parcel$export(module.exports, "SnippetBlock", () => (parcelRequire("5gb8b")).default);
$parcel$export(module.exports, "TitleBlock", () => (parcelRequire("fqBfo")).default);
$parcel$export(module.exports, "CustomBlock", () => (parcelRequire("bIdM1")).default);
$parcel$export(module.exports, "InternalFooterBlock", () => (parcelRequire("3pcXQ")).default);
$parcel$export(module.exports, "AISummaryBlock", () => (parcelRequire("2qnEp")).default);
$parcel$export(module.exports, "AIFooterBlock", () => (parcelRequire("eMgzj")).default);
$parcel$export(module.exports, "ActionBlock", () => (parcelRequire("4cjOx")).default);

var $lAF2k = parcelRequire("lAF2k");

var $gKsxm = parcelRequire("gKsxm");

var $8Rjtc = parcelRequire("8Rjtc");

var $5gb8b = parcelRequire("5gb8b");

var $fqBfo = parcelRequire("fqBfo");

var $bIdM1 = parcelRequire("bIdM1");

var $3pcXQ = parcelRequire("3pcXQ");

var $2qnEp = parcelRequire("2qnEp");

var $eMgzj = parcelRequire("eMgzj");

var $4cjOx = parcelRequire("4cjOx");

});
parcelRegister("lAF2k", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b59a3b7a9f7670d$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $3pcXQ = parcelRequire("3pcXQ");
/**
 * Represents a FooterBlock, designed to contain elements and actions that should appear
 * at the bottom of a link card.
 * @public
 * @param {FooterBlockProps} FooterBlockProps
 * @see Block
 */ const $9b59a3b7a9f7670d$var$FooterBlock = ({ testId: testId = 'smart-footer-block', alwaysShow: alwaysShow, ...props })=>{
    const cardContext = (0, $5FRJ8.useFlexibleCardContext)();
    if (cardContext?.status !== (0, $5NtHI.SmartLinkStatus).Resolved && !alwaysShow) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3pcXQ.default), {
        ...props,
        size: props.size ?? cardContext?.ui?.size,
        testId: testId
    });
};
var $9b59a3b7a9f7670d$export$2e2bcd8739ae039 = $9b59a3b7a9f7670d$var$FooterBlock;

});
parcelRegister("5FRJ8", function(module, exports) {

$parcel$export(module.exports, "FlexibleCardContext", () => $26ead80b20537add$export$13dde4423ab71d62);
$parcel$export(module.exports, "useFlexibleCardContext", () => $26ead80b20537add$export$a8c4167e4e9f26ab);
$parcel$export(module.exports, "useFlexibleUiContext", () => $26ead80b20537add$export$61d7957a243df7aa);
$parcel$export(module.exports, "useFlexibleUiOptionContext", () => $26ead80b20537add$export$e6b5ad18b56e8f51);

var $eJOHy = parcelRequire("eJOHy");
const $26ead80b20537add$export$13dde4423ab71d62 = (0, $eJOHy.createContext)(undefined);
const $26ead80b20537add$export$a8c4167e4e9f26ab = ()=>(0, $eJOHy.useContext)($26ead80b20537add$export$13dde4423ab71d62);
const $26ead80b20537add$export$61d7957a243df7aa = ()=>$26ead80b20537add$export$a8c4167e4e9f26ab()?.data;
const $26ead80b20537add$export$e6b5ad18b56e8f51 = ()=>$26ead80b20537add$export$a8c4167e4e9f26ab()?.ui;

});

parcelRegister("3pcXQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $462a2917906f3b08$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $8GnsF = parcelRequire("8GnsF");

var $eGOwo = parcelRequire("eGOwo");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $6l7Bk = parcelRequire("6l7Bk");

var $6P8F3 = parcelRequire("6P8F3");

var $bIdM1 = parcelRequire("bIdM1");

var $k8J0S = parcelRequire("k8J0S");

var $brTAh = parcelRequire("brTAh");
const $462a2917906f3b08$var$actionGroupStyles = null;
const $462a2917906f3b08$var$safariStyles = null;
const $462a2917906f3b08$var$FooterBlockResolvedView = (props)=>{
    const { actions: actions, testId: testId, onActionMenuOpenChange: onActionMenuOpenChange, size: size = (0, $5NtHI.SmartLinkSize).Medium, hideProvider: hideProvider } = props;
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const hasActions = (0, $eJOHy.useMemo)(()=>(0, $brTAh.filterActionItems)(actions, context)?.length > 0, [
        actions,
        context
    ]);
    const { safari: safari = false } = (0, $eGOwo.fg)('platform-linking-visual-refresh-v2') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eJOHy.useMemo)(()=>(0, $8GnsF.browser)(), []) : {};
    const onDropdownOpenChange = (0, $eJOHy.useCallback)((isOpen)=>{
        if (onActionMenuOpenChange) onActionMenuOpenChange({
            isOpen: isOpen
        });
    }, [
        onActionMenuOpenChange
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bIdM1.default), {
        ...props,
        testId: `${testId}-resolved-view`,
        children: [
            !hideProvider && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6l7Bk.default), {
                appearance: "subtle",
                testId: `${testId}-provider`
            }),
            actions && hasActions ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k8J0S.default), {
                testId: "smart-element-group-actions",
                align: (0, $5NtHI.SmartLinkAlignment).Right,
                direction: (0, $5NtHI.SmartLinkDirection).Horizontal,
                width: (0, $5NtHI.SmartLinkWidth).Flexible,
                className: (0, $hcewu.default)([
                    size === (0, $5NtHI.SmartLinkSize).XLarge && "_c71lxy5q",
                    safari && "_4t3i1osq"
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6P8F3.default), {
                    onDropdownOpenChange: onDropdownOpenChange,
                    items: actions,
                    appearance: "default",
                    size: size
                })
            }) : null
        ]
    });
};
var $462a2917906f3b08$export$2e2bcd8739ae039 = $462a2917906f3b08$var$FooterBlockResolvedView;

});
parcelRegister("6l7Bk", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a8115736e8f2ac6$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4XCp5 = parcelRequire("4XCp5");
const $2a8115736e8f2ac6$var$ProviderElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context?.provider ?? null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4XCp5.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).Provider
    }) : null;
};
var $2a8115736e8f2ac6$export$2e2bcd8739ae039 = $2a8115736e8f2ac6$var$ProviderElement;

});
parcelRegister("4XCp5", function(module, exports) {

$parcel$export(module.exports, "default", () => $e83b25175c466aed$export$2e2bcd8739ae039);
$parcel$export(module.exports, "toBadgeProps", () => $e83b25175c466aed$export$a2fb457791942ba4);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $8IeH1 = parcelRequire("8IeH1");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $b4zhV = parcelRequire("b4zhV");

var $67ulW = parcelRequire("67ulW");

var $9jYtV = parcelRequire("9jYtV");

var $fQH39 = parcelRequire("fQH39");
const $e83b25175c466aed$var$styles = {
    container: "_zulp1b66 _1e0c116y _4cvr1h6o _1ul91ns9",
    icon: "_1e0c116y _v4pn116y _1b94116y _1ii7116y _4t3i7vkz _bna77vkz _1xjx7vkz _17527vkz _ca0qze3t _14bqze3t _1oh2ze3t _i2i3ze3t _u5f3ze3t _3tceze3t _99ztze3t _uhasze3t _n3tdze3t _1ym6ze3t _1m2uze3t _5jw9ze3t _19bvze3t _1xr1ze3t _9n9oze3t _7wy9ze3t _1bsb7vkz _mezj7vkz _e2oo7vkz _w8l57vkz _s7n4nkob _rtqbnkob _e4kmnkob _z239nkob",
    text: "_11c81o8v"
};
const $e83b25175c466aed$var$colorMap = {
    subtle: "_syaz131l",
    default: "_syaz1gjq"
};
const $e83b25175c466aed$var$messageMapper = {
    [(0, $5NtHI.IconType).PriorityBlocker]: (0, $19nmp.messages).priority_blocker,
    [(0, $5NtHI.IconType).PriorityCritical]: (0, $19nmp.messages).priority_critical,
    [(0, $5NtHI.IconType).PriorityHigh]: (0, $19nmp.messages).priority_high,
    [(0, $5NtHI.IconType).PriorityHighest]: (0, $19nmp.messages).priority_highest,
    [(0, $5NtHI.IconType).PriorityLow]: (0, $19nmp.messages).priority_low,
    [(0, $5NtHI.IconType).PriorityLowest]: (0, $19nmp.messages).priority_lowest,
    [(0, $5NtHI.IconType).PriorityMajor]: (0, $19nmp.messages).priority_major,
    [(0, $5NtHI.IconType).PriorityMedium]: (0, $19nmp.messages).priority_medium,
    [(0, $5NtHI.IconType).PriorityMinor]: (0, $19nmp.messages).priority_minor,
    [(0, $5NtHI.IconType).PriorityTrivial]: (0, $19nmp.messages).priority_trivial,
    [(0, $5NtHI.IconType).PriorityUndefined]: (0, $19nmp.messages).priority_undefined
};
const $e83b25175c466aed$var$getFormattedMessageFromIcon = (icon)=>{
    if (icon) {
        const descriptor = $e83b25175c466aed$var$messageMapper[icon];
        if (descriptor) return (0, $fQH39.getFormattedMessage)({
            descriptor: descriptor
        });
    }
};
const $e83b25175c466aed$var$renderAtlaskitIcon = (icon, testId)=>{
    if (icon) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $b4zhV.default), {
        icon: icon,
        label: icon,
        testId: `${testId}-icon`
    });
};
const $e83b25175c466aed$var$renderImageIcon = (url, testId)=>{
    if (url) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $67ulW.default), {
        testId: testId,
        url: url
    });
};
/**
 * A base element that displays some text with an associated icon.
 * @internal
 * @param {BaseBadgeElementProps} BaseBadgeElementProps - The props necessary for the Badge.
 * @see CommentCount
 * @see ViewCount
 * @see ReactCount
 * @see VoteCount
 * @see SubscriberCount
 * @see Priority
 * @see ProgrammingLanguage
 * @see Provider
 */ const $e83b25175c466aed$var$BaseBadgeRefreshNew = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ appearance: appearance = 'default', hideIcon: hideIcon = false, icon: icon, label: label, name: name, testId: testId = 'smart-element-badge', url: url, color: color }, ref)=>{
    const formattedMessageOrLabel = $e83b25175c466aed$var$getFormattedMessageFromIcon(icon) || label;
    const badgeIcon = $e83b25175c466aed$var$renderAtlaskitIcon(icon, testId) || $e83b25175c466aed$var$renderImageIcon(url, testId);
    if (!formattedMessageOrLabel || !badgeIcon) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("span", {
        "data-smart-element": name,
        "data-smart-element-badge": true,
        "data-testid": testId,
        ref: ref,
        style: {
            color: color && (0, $eGOwo.fg)('platform-linking-additional-flexible-element-props') ? color : undefined
        },
        className: (0, $hcewu.default)([
            $e83b25175c466aed$var$styles.container,
            $e83b25175c466aed$var$colorMap[appearance]
        ]),
        children: [
            !hideIcon && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                as: "span",
                xcss: $e83b25175c466aed$var$styles.icon,
                children: badgeIcon
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                as: "span",
                testId: `${testId}-label`,
                xcss: $e83b25175c466aed$var$styles.text,
                children: formattedMessageOrLabel
            })
        ]
    });
});
var $e83b25175c466aed$export$2e2bcd8739ae039 = (0, $9jYtV.withOverrideCss)($e83b25175c466aed$var$BaseBadgeRefreshNew);
const $e83b25175c466aed$export$a2fb457791942ba4 = (label)=>{
    // Don't render the element if its 0
    return label !== '0' && label ? {
        label: label
    } : undefined;
};

});
parcelRegister("b4zhV", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6d5d1de8f417451$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $joSn0 = parcelRequire("joSn0");

var $lgMTT = parcelRequire("lgMTT");

var $4Gz8O = parcelRequire("4Gz8O");

var $9020Y = parcelRequire("9020Y");

var $9dPtp = parcelRequire("9dPtp");

var $5NtHI = parcelRequire("5NtHI");

var $FoFt2 = parcelRequire("FoFt2");
const $d6d5d1de8f417451$var$getIconImportFn = (icon, size)=>{
    const item = (0, $FoFt2.getLazyIcons)()[icon];
    if ((0, $FoFt2.isIconSizeLarge)(size) && item?.large) return item.large;
    return item?.default;
};
const $d6d5d1de8f417451$var$importIcon = (importFn)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
        loader: ()=>importFn().then((module)=>module.default),
        loading: ()=>null
    }); // Because we're using dynamic loading here, TS will not be able to infer the type.
};
const $d6d5d1de8f417451$var$AtlaskitIcon = ({ icon: icon, label: label, testId: testId, size: size = (0, $5NtHI.SmartLinkSize).Medium })=>{
    // Check for synchonously loaded icons first for SSR purposes
    switch(icon){
        case (0, $5NtHI.IconType).Document:
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9dPtp.default), {
                label: label ?? 'document',
                testId: testId,
                size: size
            });
        case (0, $5NtHI.IconType).Blog:
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4Gz8O.default), {
                label: label ?? 'blog',
                testId: testId,
                size: size
            });
        case (0, $5NtHI.IconType).LiveDocument:
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9020Y.default), {
                label: label ?? 'live-doc',
                testId: testId,
                size: size
            });
    }
    const importFn = $d6d5d1de8f417451$var$getIconImportFn(icon, size);
    if (!importFn) return null;
    const ImportedIcon = $d6d5d1de8f417451$var$importIcon(importFn);
    switch(icon){
        case (0, $5NtHI.IconType).Confluence:
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lgMTT.ConfluenceIcon), {
                appearance: "brand",
                testId: testId,
                size: size === (0, $5NtHI.SmartLinkSize).Large || size === (0, $5NtHI.SmartLinkSize).XLarge ? 'small' : 'xxsmall'
            });
        case (0, $5NtHI.IconType).Jira:
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lgMTT.JiraIcon), {
                appearance: "brand",
                testId: testId,
                size: size === (0, $5NtHI.SmartLinkSize).Large || size === (0, $5NtHI.SmartLinkSize).XLarge ? 'small' : 'xxsmall'
            });
        case (0, $5NtHI.IconType).Error:
        case (0, $5NtHI.IconType).Forbidden:
            return /*#__PURE__*/ (0, $gt9Am.jsx)(ImportedIcon, {
                label: label,
                testId: testId,
                LEGACY_size: size === (0, $5NtHI.SmartLinkSize).Large || size === (0, $5NtHI.SmartLinkSize).XLarge ? 'medium' : 'small',
                color: "var(--ds-icon-danger, #C9372C)"
            });
        default:
            return /*#__PURE__*/ (0, $gt9Am.jsx)(ImportedIcon, {
                label: label,
                testId: testId,
                LEGACY_size: size === (0, $5NtHI.SmartLinkSize).Large || size === (0, $5NtHI.SmartLinkSize).XLarge ? 'medium' : 'small',
                size: size
            });
    }
};
var $d6d5d1de8f417451$export$2e2bcd8739ae039 = $d6d5d1de8f417451$var$AtlaskitIcon;

});
parcelRegister("9020Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9e6bf288701895f$export$2e2bcd8739ae039);

var $ilCAi = parcelRequire("ilCAi");

var $hB03j = parcelRequire("hB03j");

var $cPcks = parcelRequire("cPcks");
const $d9e6bf288701895f$var$LiveDocumentIconWithColor = (0, $cPcks.renderIconPerSize)((0, $ilCAi.default), (0, $hB03j.default));
$d9e6bf288701895f$var$LiveDocumentIconWithColor.displayName = 'LiveDocumentIconWithColor';
var $d9e6bf288701895f$export$2e2bcd8739ae039 = $d9e6bf288701895f$var$LiveDocumentIconWithColor;

});


parcelRegister("67ulW", function(module, exports) {

$parcel$export(module.exports, "default", () => $78e2ae224831a17c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $2HNHt = parcelRequire("2HNHt");

var $eGOwo = parcelRequire("eGOwo");

var $65mpR = parcelRequire("65mpR");
const $78e2ae224831a17c$var$styles = {
    roundImg: "_2rko14q2"
};
const $78e2ae224831a17c$var$ImageIcon = ({ defaultIcon: defaultIcon, testId: testId, url: url, width: width, height: height, appearance: appearance = 'square', onError: onError, onLoad: onLoad, hideLoadingSkeleton: hideLoadingSkeleton = false })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $eJOHy.useState)(false);
    // If url changes, reset state
    (0, $eJOHy.useEffect)(()=>{
        setHasImageErrored(false);
    }, [
        url
    ]);
    if (hasImageErrored) return defaultIcon;
    if (hideLoadingSkeleton && (0, $eGOwo.fg)('platform_fix_block_card_img_icon_vc')) return /*#__PURE__*/ (0, $gt9Am.jsx)("img", {
        src: url,
        "data-testid": `${testId}-image`,
        alt: "",
        style: {
            width: width,
            height: height
        },
        onError: ()=>setHasImageErrored(true),
        className: (0, $hcewu.default)([
            appearance === 'round' && (0, $eGOwo.fg)('platform-linking-visual-refresh-v2') && $78e2ae224831a17c$var$styles.roundImg
        ])
    });
    else return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2HNHt))), {
        src: url,
        loading: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $65mpR.LoadingSkeleton), {
            testId: `${testId}-loading`,
            width: width,
            height: height
        }),
        loaded: /*#__PURE__*/ (0, $gt9Am.jsx)("img", {
            src: url,
            "data-testid": `${testId}-image`,
            alt: "",
            style: {
                width: width,
                height: height
            },
            className: (0, $hcewu.default)([
                appearance === 'round' && (0, $eGOwo.fg)('platform-linking-visual-refresh-v2') && $78e2ae224831a17c$var$styles.roundImg
            ])
        }),
        errored: defaultIcon,
        onError: onError,
        onLoad: onLoad
    });
};
var $78e2ae224831a17c$export$2e2bcd8739ae039 = $78e2ae224831a17c$var$ImageIcon;

});
parcelRegister("2HNHt", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $1f862656e4ed4164$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $eJOHy = parcelRequire("eJOHy");
var $1f862656e4ed4164$var$React = $1f862656e4ed4164$var$_interopRequireWildcard($eJOHy);
function $1f862656e4ed4164$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $1f862656e4ed4164$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $1f862656e4ed4164$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $1f862656e4ed4164$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $1f862656e4ed4164$var$loading(image) {
    return {
        image: image,
        isLoaded: false,
        isErrored: false
    };
}
function $1f862656e4ed4164$var$loaded() {
    return {
        isLoaded: true
    };
}
function $1f862656e4ed4164$var$errored() {
    return {
        isErrored: true
    };
}
function $1f862656e4ed4164$var$hasPropsChanged(prevProps, nextProps) {
    var prevSrc = prevProps.src;
    var nextSrc = nextProps.src;
    return prevSrc !== nextSrc;
}
var $1f862656e4ed4164$var$ImageRenderer = function(_React$Component) {
    $1f862656e4ed4164$var$_inherits(ImageRenderer, _React$Component);
    function ImageRenderer() {
        var _ref;
        var _temp, _this, _ret;
        $1f862656e4ed4164$var$_classCallCheck(this, ImageRenderer);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $1f862656e4ed4164$var$_possibleConstructorReturn(this, (_ref = ImageRenderer.__proto__ || Object.getPrototypeOf(ImageRenderer)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.state = {
            isLoaded: false,
            isErrored: false
        }, _this.handleLoad = function() {
            var onLoad = _this.props.onLoad;
            _this.unload();
            _this.setState($1f862656e4ed4164$var$loaded(), function() {
                if (onLoad) onLoad();
            });
        }, _this.handleError = function() {
            var onError = _this.props.onError;
            _this.unload();
            _this.setState($1f862656e4ed4164$var$errored(), function() {
                if (onError) onError();
            });
        }, _temp), $1f862656e4ed4164$var$_possibleConstructorReturn(_this, _ret);
    }
    $1f862656e4ed4164$var$_createClass(ImageRenderer, [
        {
            key: 'load',
            value: function load() {
                var src = this.props.src;
                var image = this.state.image;
                if (image) {
                    image.onload = this.handleLoad;
                    image.onerror = this.handleError;
                    image.src = src;
                }
            }
        },
        {
            key: 'unload',
            value: function unload() {
                var image = this.state.image;
                if (image) {
                    image.onload = undefined;
                    image.onerror = undefined;
                }
            }
        },
        {
            key: 'componentWillMount',
            value: function componentWillMount() {
                if (typeof window === 'undefined') return;
                this.setState($1f862656e4ed4164$var$loading(new Image()));
            }
        },
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.load();
            }
        },
        {
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
                if ($1f862656e4ed4164$var$hasPropsChanged(this.props, nextProps)) this.setState($1f862656e4ed4164$var$loading(new Image()));
            }
        },
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps) {
                if ($1f862656e4ed4164$var$hasPropsChanged(prevProps, this.props)) {
                    this.unload();
                    this.load();
                }
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.unload();
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, loading = _props.loading, loaded = _props.loaded, errored = _props.errored, children = _props.children;
                var _state = this.state, image = _state.image, isLoaded = _state.isLoaded, isErrored = _state.isErrored;
                if (isLoaded && loaded) return loaded;
                if (isErrored && errored) return errored;
                if (!isLoaded && !isErrored && loading) return loading;
                if (children) return children({
                    image: isLoaded ? image : undefined,
                    loaded: isLoaded,
                    errored: isErrored
                });
                return null;
            }
        }
    ]);
    return ImageRenderer;
}($1f862656e4ed4164$var$React.Component);
module.exports.default = $1f862656e4ed4164$var$ImageRenderer;

});

parcelRegister("65mpR", function(module, exports) {

$parcel$export(module.exports, "LoadingSkeleton", () => $dc3223680a49307e$export$44c18d210d5de37b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $dc3223680a49307e$var$animationNameStyles = null;
const $dc3223680a49307e$var$loadingSkeletonStyle = null;
const $dc3223680a49307e$export$44c18d210d5de37b = ({ testId: testId, width: width, height: height })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-testid": testId,
        style: {
            width: width,
            height: height
        },
        className: (0, $hcewu.default)([
            "_2rkoyh40 _uiztglyw _bfhk178v _1itk1bc0 _12vemgnk _1lrw6rms _1e0c1o8l _5sag9cwz _1o51q7pw _tip812c5 _j7hqqkar _1pglp3kn"
        ])
    });
};

});


parcelRegister("9jYtV", function(module, exports) {

$parcel$export(module.exports, "withOverrideCss", () => $641d28b8590b444f$export$e0bdcacb944f1da6);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
function $641d28b8590b444f$export$e0bdcacb944f1da6(Component) {
    return (props)=>{
        const ref = (0, $eJOHy.useRef)(null);
        (0, $eJOHy.useEffect)(()=>{
            if (props?.className && ref.current) ref.current.className = `${ref.current.className} ${props.className}`;
        }, [
            props?.className
        ]);
        return /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
            ...props,
            ref: ref
        });
    };
}

});

parcelRegister("fQH39", function(module, exports) {

$parcel$export(module.exports, "sizeToButtonSpacing", () => $18f1b25c1730b97c$export$9d642f65a919fb93);
$parcel$export(module.exports, "getFormattedMessage", () => $18f1b25c1730b97c$export$f1aa79f2218fb713);
$parcel$export(module.exports, "getFormattedMessageAsString", () => $18f1b25c1730b97c$export$66ecb50a9dd1768);
$parcel$export(module.exports, "getIconWidth", () => $18f1b25c1730b97c$export$fb10bc5609c6347e);
$parcel$export(module.exports, "importIcon", () => $18f1b25c1730b97c$export$6dc831e1a0a7a851);
$parcel$export(module.exports, "getMaxLines", () => $18f1b25c1730b97c$export$c2293adf1794c09);
$parcel$export(module.exports, "getPrimitivesInlineSpaceBySize", () => $18f1b25c1730b97c$export$475c391af8171fec);
$parcel$export(module.exports, "hasWhiteSpace", () => $18f1b25c1730b97c$export$619e376a425cb759);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $joSn0 = parcelRequire("joSn0");

var $5NtHI = parcelRequire("5NtHI");
const $18f1b25c1730b97c$export$9d642f65a919fb93 = {
    [(0, $5NtHI.SmartLinkSize).Small]: 'none',
    [(0, $5NtHI.SmartLinkSize).Medium]: 'compact',
    [(0, $5NtHI.SmartLinkSize).Large]: 'compact',
    [(0, $5NtHI.SmartLinkSize).XLarge]: 'default'
};
const $18f1b25c1730b97c$export$f1aa79f2218fb713 = (message)=>{
    if (message) {
        const { descriptor: descriptor, values: values } = message;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...descriptor,
            values: values
        });
    }
};
const $18f1b25c1730b97c$export$66ecb50a9dd1768 = (intl, message, context)=>{
    const { formatMessage: formatMessage } = intl;
    return message ? formatMessage(message, {
        context: context
    }) : '';
};
const $18f1b25c1730b97c$export$fb10bc5609c6347e = (size)=>{
    switch(size){
        case (0, $5NtHI.SmartLinkSize).XLarge:
        case (0, $5NtHI.SmartLinkSize).Large:
            return "var(--ds-space-300, 24px)";
        case (0, $5NtHI.SmartLinkSize).Medium:
        case (0, $5NtHI.SmartLinkSize).Small:
        default:
            return "var(--ds-space-200, 16px)";
    }
};
const $18f1b25c1730b97c$export$6dc831e1a0a7a851 = (importFn)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
        loader: ()=>importFn().then((module)=>module.default),
        loading: ()=>null
    }); // Because we're using dynamic loading here, TS will not be able to infer the type.
};
const $18f1b25c1730b97c$export$a681bd062fee88a5 = (size)=>{
    // The maximum line height based on all elements in specific size.
    // These heights belongs to AvatarGroup.
    switch(size){
        case (0, $5NtHI.SmartLinkSize).XLarge:
        case (0, $5NtHI.SmartLinkSize).Large:
            return 1.75;
        case (0, $5NtHI.SmartLinkSize).Medium:
        case (0, $5NtHI.SmartLinkSize).Small:
        default:
            return 1.5;
    }
};
const $18f1b25c1730b97c$export$c2293adf1794c09 = (value, defaultValue, max, min)=>{
    if (value > max) return defaultValue;
    if (value < min) return min;
    return value;
};
const $18f1b25c1730b97c$export$475c391af8171fec = (size)=>{
    switch(size){
        case (0, $5NtHI.SmartLinkSize).XLarge:
            return 'space.250';
        case (0, $5NtHI.SmartLinkSize).Large:
            return 'space.200';
        case (0, $5NtHI.SmartLinkSize).Medium:
            return 'space.100';
        case (0, $5NtHI.SmartLinkSize).Small:
        default:
            return 'space.050';
    }
};
const $18f1b25c1730b97c$export$619e376a425cb759 = (str)=>{
    return str.search(/\s/) >= 0;
};

});



parcelRegister("6P8F3", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6bccbbfb4f78611$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $kDaaB = parcelRequire("kDaaB");

var $gRw8I = parcelRequire("gRw8I");

var $48q59 = parcelRequire("48q59");

var $goZPP = parcelRequire("goZPP");

var $7rjYb = parcelRequire("7rjYb");

var $aMdh8 = parcelRequire("aMdh8");

var $k71qx = parcelRequire("k71qx");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $fQH39 = parcelRequire("fQH39");

var $brTAh = parcelRequire("brTAh");

var $a86OV = parcelRequire("a86OV");
const $a6bccbbfb4f78611$var$styles = null;
const $a6bccbbfb4f78611$var$renderActionItems = (items = [], size = (0, $5NtHI.SmartLinkSize).Medium, appearance, asDropDownItems, onActionItemClick)=>items.map((item, idx)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $a86OV.default), {
            item: item,
            size: size,
            appearance: appearance,
            asDropDownItems: asDropDownItems,
            onActionItemClick: onActionItemClick
        }, idx));
/**
 * Creates a group of Action components. Accepts an array of Actions, in addition to some styling
 * preferences.
 * @internal
 * @param {ActionGroupProps} ActionGroupProps
 * @see Action
 */ const $a6bccbbfb4f78611$var$ActionGroup = ({ items: items = [], size: size = (0, $5NtHI.SmartLinkSize).Medium, appearance: appearance, visibleButtonsNum: visibleButtonsNum = 2, onDropdownOpenChange: onDropdownOpenChange })=>{
    (0, $gRw8I.di)((0, $7rjYb.default));
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const ui = (0, $5FRJ8.useFlexibleUiOptionContext)();
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const renderableActionItems = (0, $eJOHy.useMemo)(()=>(0, $brTAh.filterActionItems)(items, context), [
        context,
        items
    ]);
    const isMoreThenTwoItems = renderableActionItems.length > visibleButtonsNum;
    const onOpenChange = (0, $eJOHy.useCallback)((attrs)=>{
        setIsOpen(attrs.isOpen);
        if (onDropdownOpenChange) onDropdownOpenChange(attrs.isOpen);
    }, [
        onDropdownOpenChange
    ]);
    const onActionItemClick = (0, $eJOHy.useCallback)(()=>{
        if (isOpen) onOpenChange({
            isOpen: false
        });
    }, [
        isOpen,
        onOpenChange
    ]);
    const actionButtons = (0, $eJOHy.useMemo)(()=>{
        const actionItems = isMoreThenTwoItems ? renderableActionItems.slice(0, visibleButtonsNum - 1) : renderableActionItems;
        return $a6bccbbfb4f78611$var$renderActionItems(actionItems, size, appearance, false, onActionItemClick);
    }, [
        appearance,
        isMoreThenTwoItems,
        onActionItemClick,
        renderableActionItems,
        size,
        visibleButtonsNum
    ]);
    const moreActionDropdown = (0, $eJOHy.useMemo)(()=>{
        const actionItems = isMoreThenTwoItems ? renderableActionItems.slice(visibleButtonsNum - 1) : [];
        if (actionItems.length > 0) {
            const spacing = (0, $fQH39.sizeToButtonSpacing)[size];
            const moreIcon = /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aMdh8))), {
                label: "more",
                color: "currentColor"
            });
            const formatMessage = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $19nmp.messages).more_actions
            });
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7rjYb.default), {
                isOpen: isOpen,
                onOpenChange: onOpenChange,
                trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
                        content: formatMessage,
                        hideTooltipOnClick: true,
                        testId: "action-group-more-button-tooltip",
                        tag: "span",
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $goZPP.default), {
                            ...props,
                            spacing: spacing,
                            testId: "action-group-more-button",
                            iconBefore: moreIcon,
                            ref: triggerRef
                        })
                    }),
                testId: "action-group-dropdown",
                zIndex: ui?.zIndex,
                children: $a6bccbbfb4f78611$var$renderActionItems(actionItems, size, appearance, true, onActionItemClick)
            });
        }
        return null;
    }, [
        appearance,
        isMoreThenTwoItems,
        isOpen,
        onActionItemClick,
        onOpenChange,
        renderableActionItems,
        size,
        ui?.zIndex,
        visibleButtonsNum
    ]);
    return renderableActionItems.length > 0 ? /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            "_1e0c116y _dzc21h6o _1ilq1i6y",
            "actions-button-group"
        ]),
        "data-action-open": isOpen,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $48q59.default), {
            children: [
                actionButtons,
                moreActionDropdown
            ]
        })
    }) : null;
};
var $a6bccbbfb4f78611$export$2e2bcd8739ae039 = $a6bccbbfb4f78611$var$ActionGroup;

});
parcelRegister("brTAh", function(module, exports) {

$parcel$export(module.exports, "filterActionItems", () => $a0fe758b77d980f4$export$adbd04236f07a7d8);
$parcel$export(module.exports, "renderChildren", () => $a0fe758b77d980f4$export$cd762ccf1a583d69);
$parcel$export(module.exports, "renderElementItems", () => $a0fe758b77d980f4$export$9678d3ca18bd7526);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $1YI3f = parcelRequire("1YI3f");

var $4RG9i = parcelRequire("4RG9i");

var $6P8F3 = parcelRequire("6P8F3");

var $k8J0S = parcelRequire("k8J0S");
const $a0fe758b77d980f4$export$f942619ce67b1a41 = {
    [(0, $5NtHI.ElementName).AssignedTo]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).AssignedToGroup]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).AttachmentCount]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).AuthorGroup]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).AppliedToComponentsCount]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).ChecklistProgress]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).CollaboratorGroup]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).CommentCount]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).CreatedBy]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).CreatedOn]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).DueOn]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).LatestCommit]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).LinkIcon]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).Location]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).ModifiedBy]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).ModifiedOn]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).OwnedBy]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).OwnedByGroup]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).Preview]: [
        'block'
    ],
    [(0, $5NtHI.ElementName).Priority]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).ProgrammingLanguage]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).Provider]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).ReactCount]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).ReadTime]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).Snippet]: [
        'block'
    ],
    [(0, $5NtHI.ElementName).SourceBranch]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).SentOn]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).State]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).SubscriberCount]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).TeamMemberCount]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).SubTasksProgress]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).StoryPoints]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).TargetBranch]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).Title]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).UserAttributes]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).ViewCount]: [
        'inline'
    ],
    [(0, $5NtHI.ElementName).VoteCount]: [
        'inline'
    ]
};
const $a0fe758b77d980f4$export$ff20be09ae01c52e = (size)=>{
    switch(size){
        case (0, $5NtHI.SmartLinkSize).XLarge:
            return 1.25;
        case (0, $5NtHI.SmartLinkSize).Large:
            return 1;
        case (0, $5NtHI.SmartLinkSize).Medium:
            return 0.5;
        case (0, $5NtHI.SmartLinkSize).Small:
        default:
            return 0.25;
    }
};
const $a0fe758b77d980f4$var$isActionGroup = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(node) && node.type === (0, $6P8F3.default);
const $a0fe758b77d980f4$var$isElementDisplayValid = (name, display)=>{
    return $a0fe758b77d980f4$export$f942619ce67b1a41[name]?.includes(display) ?? false;
};
const $a0fe758b77d980f4$export$f2c7ad0961800b16 = (children)=>{
    return Boolean(children.type() === null);
};
const $a0fe758b77d980f4$var$isElementOrElementGroup = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(node) && ((0, $1YI3f.isFlexibleUiElement)(node) || node.type === (0, $k8J0S.default));
const $a0fe758b77d980f4$export$adbd04236f07a7d8 = (items = [], context)=>{
    return items.filter((item)=>{
        switch(item.name){
            case (0, $5NtHI.ActionName).DeleteAction:
            case (0, $5NtHI.ActionName).EditAction:
            case (0, $5NtHI.ActionName).CustomAction:
                // Named and custom actions that user defines.
                return Boolean((0, $5NtHI.ActionName)[item.name]);
            default:
                // Action that require data from the data context to render.
                if (context?.actions === undefined) return false;
                return Boolean(item.name in context.actions ? context.actions[item.name] : undefined);
        }
    });
};
const $a0fe758b77d980f4$export$cd762ccf1a583d69 = (children, size)=>(0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(children, (child)=>{
        if ($a0fe758b77d980f4$var$isElementOrElementGroup(child) || $a0fe758b77d980f4$var$isActionGroup(child)) {
            const node = child;
            const { size: childSize } = node.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).cloneElement(node, {
                size: childSize || size
            });
        }
        return child;
    });
const $a0fe758b77d980f4$export$9678d3ca18bd7526 = (items = [], display = 'inline')=>{
    const elements = items.reduce((acc, curr, idx)=>{
        const { name: name, ...props } = curr;
        const Element = $4RG9i[name];
        const typedProps = props;
        if (Element && $a0fe758b77d980f4$var$isElementDisplayValid(name, display)) {
            const element = /*#__PURE__*/ (0, $gt9Am.jsx)(Element, {
                ...typedProps
            }, idx);
            if (!$a0fe758b77d980f4$export$f2c7ad0961800b16(element)) return [
                ...acc,
                element
            ];
        }
        return acc;
    }, []);
    if (elements.length) return elements;
};

});
parcelRegister("4RG9i", function(module, exports) {

$parcel$export(module.exports, "AssignedTo", () => (parcelRequire("9Xcvc")).default);
$parcel$export(module.exports, "AssignedToGroup", () => (parcelRequire("41Mwl")).default);
$parcel$export(module.exports, "AttachmentCount", () => (parcelRequire("lVTJZ")).default);
$parcel$export(module.exports, "AuthorGroup", () => (parcelRequire("gl0Fx")).default);
$parcel$export(module.exports, "ChecklistProgress", () => (parcelRequire("iCDdz")).default);
$parcel$export(module.exports, "CollaboratorGroup", () => (parcelRequire("cSuZU")).default);
$parcel$export(module.exports, "CommentCount", () => (parcelRequire("gA3VJ")).default);
$parcel$export(module.exports, "CreatedOn", () => (parcelRequire("aiy2i")).default);
$parcel$export(module.exports, "CreatedBy", () => (parcelRequire("k4xpX")).default);
$parcel$export(module.exports, "DueOn", () => (parcelRequire("kCe9K")).default);
$parcel$export(module.exports, "LatestCommit", () => (parcelRequire("kB4Nm")).default);
$parcel$export(module.exports, "LinkIcon", () => (parcelRequire("jPfaa")).default);
$parcel$export(module.exports, "Location", () => (parcelRequire("2Bqsd")).default);
$parcel$export(module.exports, "ModifiedBy", () => (parcelRequire("1FNi6")).default);
$parcel$export(module.exports, "ModifiedOn", () => (parcelRequire("81kl8")).default);
$parcel$export(module.exports, "OwnedBy", () => (parcelRequire("946bQ")).default);
$parcel$export(module.exports, "OwnedByGroup", () => (parcelRequire("4Nd99")).default);
$parcel$export(module.exports, "Preview", () => (parcelRequire("7Byzo")).default);
$parcel$export(module.exports, "Priority", () => (parcelRequire("5kUaD")).default);
$parcel$export(module.exports, "ProgrammingLanguage", () => (parcelRequire("8MxlB")).default);
$parcel$export(module.exports, "Provider", () => (parcelRequire("6l7Bk")).default);
$parcel$export(module.exports, "ReactCount", () => (parcelRequire("lwvSM")).default);
$parcel$export(module.exports, "ReadTime", () => (parcelRequire("2ITMK")).default);
$parcel$export(module.exports, "SentOn", () => (parcelRequire("iw2r2")).default);
$parcel$export(module.exports, "Snippet", () => (parcelRequire("f7w3l")).default);
$parcel$export(module.exports, "SourceBranch", () => (parcelRequire("6Po2h")).default);
$parcel$export(module.exports, "State", () => (parcelRequire("4U5iq")).default);
$parcel$export(module.exports, "SubscriberCount", () => (parcelRequire("jJD7c")).default);
$parcel$export(module.exports, "SubTasksProgress", () => (parcelRequire("7mGkc")).default);
$parcel$export(module.exports, "StoryPoints", () => (parcelRequire("w1OaX")).default);
$parcel$export(module.exports, "TargetBranch", () => (parcelRequire("cwvSG")).default);
$parcel$export(module.exports, "TeamMemberCount", () => (parcelRequire("2j4b1")).default);
$parcel$export(module.exports, "Title", () => (parcelRequire("i6ktq")).default);
$parcel$export(module.exports, "UserAttributes", () => (parcelRequire("iQvIm")).default);
$parcel$export(module.exports, "ViewCount", () => (parcelRequire("bApaO")).default);
$parcel$export(module.exports, "VoteCount", () => (parcelRequire("1IQ2A")).default);
$parcel$export(module.exports, "AppliedToComponentsCount", () => (parcelRequire("lJDNU")).default);
$parcel$export(module.exports, "CustomByAccessTypeElement", () => (parcelRequire("i4NpI")).default);
$parcel$export(module.exports, "CustomByStatusElement", () => (parcelRequire("5d1ks")).default);

var $9Xcvc = parcelRequire("9Xcvc");

var $41Mwl = parcelRequire("41Mwl");

var $lVTJZ = parcelRequire("lVTJZ");

var $gl0Fx = parcelRequire("gl0Fx");

var $iCDdz = parcelRequire("iCDdz");

var $cSuZU = parcelRequire("cSuZU");

var $gA3VJ = parcelRequire("gA3VJ");

var $aiy2i = parcelRequire("aiy2i");

var $k4xpX = parcelRequire("k4xpX");

var $kCe9K = parcelRequire("kCe9K");

var $kB4Nm = parcelRequire("kB4Nm");

var $jPfaa = parcelRequire("jPfaa");

var $2Bqsd = parcelRequire("2Bqsd");

var $1FNi6 = parcelRequire("1FNi6");

var $81kl8 = parcelRequire("81kl8");

var $946bQ = parcelRequire("946bQ");

var $4Nd99 = parcelRequire("4Nd99");

var $7Byzo = parcelRequire("7Byzo");

var $5kUaD = parcelRequire("5kUaD");

var $8MxlB = parcelRequire("8MxlB");

var $6l7Bk = parcelRequire("6l7Bk");

var $lwvSM = parcelRequire("lwvSM");

var $2ITMK = parcelRequire("2ITMK");

var $iw2r2 = parcelRequire("iw2r2");

var $f7w3l = parcelRequire("f7w3l");

var $6Po2h = parcelRequire("6Po2h");

var $4U5iq = parcelRequire("4U5iq");

var $jJD7c = parcelRequire("jJD7c");

var $7mGkc = parcelRequire("7mGkc");

var $w1OaX = parcelRequire("w1OaX");

var $cwvSG = parcelRequire("cwvSG");

var $2j4b1 = parcelRequire("2j4b1");

var $i6ktq = parcelRequire("i6ktq");

var $iQvIm = parcelRequire("iQvIm");

var $bApaO = parcelRequire("bApaO");

var $1IQ2A = parcelRequire("1IQ2A");

var $lJDNU = parcelRequire("lJDNU");

var $i4NpI = parcelRequire("i4NpI");

var $5d1ks = parcelRequire("5d1ks");

});
parcelRegister("9Xcvc", function(module, exports) {

$parcel$export(module.exports, "default", () => $68e65e4967ed5bbb$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $38cBa = parcelRequire("38cBa");
const $68e65e4967ed5bbb$var$AssignedToElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $38cBa.toFormattedTextProps)((0, $19nmp.messages).assigned_to, context.assignedTo) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).AssignedTo
    }) : null;
};
var $68e65e4967ed5bbb$export$2e2bcd8739ae039 = $68e65e4967ed5bbb$var$AssignedToElement;

});
parcelRegister("38cBa", function(module, exports) {

$parcel$export(module.exports, "default", () => $6311575d89bb2b6b$export$2e2bcd8739ae039);
$parcel$export(module.exports, "toFormattedTextProps", () => $6311575d89bb2b6b$export$b9738bf28fb14829);
$parcel$export(module.exports, "toTextProps", () => $6311575d89bb2b6b$export$f12aecc78be3c7bb);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $eGOwo = parcelRequire("eGOwo");

var $fQH39 = parcelRequire("fQH39");
const $6311575d89bb2b6b$var$baseStyle = null;
const $6311575d89bb2b6b$var$fontOverrideStyleMap = {
    'font.body': "_11c82smr",
    'font.body.large': "_11c81ixg",
    'font.body.small': "_11c81o8v",
    'font.body.UNSAFE_small': "_11c8dcr7"
};
const $6311575d89bb2b6b$export$79422073c7118b5b = ({ content: content, maxLines: maxLines = 1, message: message, name: name, className: className, testId: testId = 'smart-element-text', hideFormat: hideFormat = false, color: color, fontSize: fontSize })=>{
    if (!message && !content) return null;
    const dynamicCss = null;
    const newContent = hideFormat && content ? content : (0, $fQH39.getFormattedMessage)(message) || content;
    const oldContent = (0, $fQH39.getFormattedMessage)(message) || content;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-separator": true,
        "data-smart-element": name,
        "data-smart-element-text": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_11c81o8v _1reo15vq _18m915vq _syaz1gjq _o5724jg8 _1e0ccj1k _1ul9idpf _1bto1l2s _1nmz1hna _sudp1e54",
            fontSize !== undefined && (0, $eGOwo.fg)('bandicoots-smart-card-teamwork-context') && $6311575d89bb2b6b$var$fontOverrideStyleMap[fontSize],
            "_1yyjr31u _102k1dud",
            className
        ]),
        style: {
            color: color && (0, $eGOwo.fg)('platform-linking-additional-flexible-element-props') ? color : undefined,
            "--_1erfju8": (0, $awdRS.default)(maxLines)
        },
        children: (0, $eGOwo.fg)('platform-linking-additional-flexible-element-props') ? newContent : oldContent
    });
};
var $6311575d89bb2b6b$export$2e2bcd8739ae039 = $6311575d89bb2b6b$export$79422073c7118b5b;
const $6311575d89bb2b6b$export$b9738bf28fb14829 = (descriptor, context)=>{
    if ((0, $eGOwo.fg)('platform-linking-additional-flexible-element-props')) return context ? {
        message: {
            descriptor: descriptor,
            values: {
                context: context
            }
        },
        content: context
    } : undefined;
    return context ? {
        message: {
            descriptor: descriptor,
            values: {
                context: context
            }
        }
    } : undefined;
};
const $6311575d89bb2b6b$export$f12aecc78be3c7bb = (content)=>{
    return content ? {
        content: content
    } : undefined;
};

});


parcelRegister("41Mwl", function(module, exports) {

$parcel$export(module.exports, "default", () => $54562c55fd1b3586$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $vUns3 = parcelRequire("vUns3");
const $54562c55fd1b3586$var$AssignedToGroupElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $vUns3.toAvatarGroupProps)(context.assignedToGroup, true) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $vUns3.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).AssignedToGroup
    }) : null;
};
var $54562c55fd1b3586$export$2e2bcd8739ae039 = $54562c55fd1b3586$var$AssignedToGroupElement;

});
parcelRegister("vUns3", function(module, exports) {

$parcel$export(module.exports, "default", () => $672b014d8429d73d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "toAvatarGroupProps", () => $672b014d8429d73d$export$91ba8651475968bd);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $lRq8t = parcelRequire("lRq8t");

var $gqBnP = parcelRequire("gqBnP");

var $eGOwo = parcelRequire("eGOwo");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $fQH39 = parcelRequire("fQH39");
const $672b014d8429d73d$var$stylesOld = null;
const $672b014d8429d73d$var$styles = null;
const $672b014d8429d73d$var$stylesMap = {
    xlarge: "_1e0c116y _1kvxu2gc _102oidpf",
    large: "_1e0c116y _1kvxu2gc _102oidpf",
    medium: "_1e0c116y _1kvxu2gc _102oidpf _6fu61k92 _1rrq1k92 _udwj1k92 _10pr1k92",
    small: "_1e0c116y _1kvxu2gc _102oidpf _6fu61k92 _1rrq1k92 _udwj1k92 _10pr1k92"
};
const $672b014d8429d73d$var$getPersonNameWithPrefix = (elementName, personName, intl)=>{
    switch(elementName){
        case (0, $5NtHI.ElementName).AssignedToGroup:
            return (0, $fQH39.getFormattedMessageAsString)(intl, (0, $19nmp.messages).assigned_to, personName);
        case (0, $5NtHI.ElementName).OwnedByGroup:
            return (0, $fQH39.getFormattedMessageAsString)(intl, (0, $19nmp.messages).owned_by, personName);
        case (0, $5NtHI.ElementName).AuthorGroup:
            return (0, $fQH39.getFormattedMessageAsString)(intl, (0, $19nmp.messages).created_by, personName);
        default:
            return personName;
    }
};
/**
 * A base element that displays a group of avatars.
 * @internal
 * @param {BaseAvatarGroupElementProps} BaseAvatarGroupElementProps - The props necessary for the AvatarGroup.
 * @see AuthorGroup
 * @see CollaboratorGroup
 */ const $672b014d8429d73d$var$BaseAvatarGroup = ({ items: items = [], maxCount: maxCount = 4, name: name, className: className, size: size = (0, $5NtHI.SmartLinkSize).Medium, testId: testId = 'smart-element-avatar-group', showNamePrefix: showNamePrefix = false, showFallbackAvatar: showFallbackAvatar = true })=>{
    const intl = (0, $lRq8t.default)();
    const data = (0, $eJOHy.useMemo)(()=>{
        if (!items.length && showFallbackAvatar) switch(name){
            case (0, $5NtHI.ElementName).AssignedToGroup:
                return [
                    {
                        name: (0, $fQH39.getFormattedMessageAsString)(intl, (0, $19nmp.messages).unassigned)
                    }
                ];
            default:
                return [];
        }
        //show a name prefix if there is one Avatar in a group only
        if (name && items.length === 1 && showNamePrefix) return items.map((person)=>{
            return {
                ...person,
                name: $672b014d8429d73d$var$getPersonNameWithPrefix(name, person.name, intl) || person.name
            };
        });
        return items;
    }, [
        name,
        items,
        showNamePrefix,
        showFallbackAvatar,
        intl
    ]);
    if (!data.length) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ...(0, $eGOwo.fg)('platform-linking-enable-avatar-data-separator') ? {
            ['data-separator']: true
        } : {},
        "data-smart-element": name,
        "data-smart-element-avatar-group": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            !(0, $eGOwo.fg)('platform-linking-fix-smart-card-avatar-overrides') && $672b014d8429d73d$var$stylesMap[size],
            (0, $eGOwo.fg)('platform-linking-fix-smart-card-avatar-overrides') ? "_1ul91ns9 _1e0c116y _1kvxu2gc _102oidpf" : "_1ul91ns9",
            className
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gqBnP.default), {
            maxCount: maxCount,
            appearance: "stack",
            size: "small",
            data: data,
            testId: testId
        })
    });
};
var $672b014d8429d73d$export$2e2bcd8739ae039 = $672b014d8429d73d$var$BaseAvatarGroup;
const $672b014d8429d73d$export$91ba8651475968bd = (items, showFallbackAvatar)=>{
    return items ? {
        items: items
    } : showFallbackAvatar ? {
        items: []
    } : undefined;
};

});
parcelRegister("gqBnP", function(module, exports) {

$parcel$export(module.exports, "default", () => $36ee9480fc7b69c2$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $4eDgu = parcelRequire("4eDgu");

var $5DgXR = parcelRequire("5DgXR");


var $3Vuhz = parcelRequire("3Vuhz");

var $llBnk = parcelRequire("llBnk");

var $6YEko = parcelRequire("6YEko");

var $kJsb4 = parcelRequire("kJsb4");

var $k71qx = parcelRequire("k71qx");

var $8nCcr = parcelRequire("8nCcr");

var $1ld2P = parcelRequire("1ld2P");

var $e8NdE = parcelRequire("e8NdE");

var $8Au2G = parcelRequire("8Au2G");

var $8PScB = parcelRequire("8PScB");

var $9YB82 = parcelRequire("9YB82");

var $aeH98 = parcelRequire("aeH98");
const $36ee9480fc7b69c2$var$MAX_COUNT = {
    grid: 11,
    stack: 5
};
function $36ee9480fc7b69c2$var$getOverrides(overrides) {
    return {
        AvatarGroupItem: {
            render: (Component, props, index)=>/*#__PURE__*/ (0, $eJOHy.createElement)(Component, {
                    ...props,
                    key: (0, $aeH98.composeUniqueKey)(props.avatar, index)
                }),
            ...overrides && overrides.AvatarGroupItem
        },
        Avatar: {
            render: (Component, props, index)=>/*#__PURE__*/ (0, $eJOHy.createElement)(Component, {
                    ...props,
                    key: (0, $aeH98.composeUniqueKey)(props, index)
                }),
            ...overrides && overrides.Avatar
        },
        MoreIndicator: {
            render: (Component, props)=>/*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
                    ...props
                }),
            ...overrides && overrides.MoreIndicator
        }
    };
}
/**
 * __Avatar group__
 *
 * An avatar group displays a number of avatars grouped together in a stack or grid.
 *
 * - [Examples](https://atlassian.design/components/avatar-group/examples)
 * - [Code](https://atlassian.design/components/avatar-group/code)
 * - [Usage](https://atlassian.design/components/avatar-group/usage)
 */ const $36ee9480fc7b69c2$var$AvatarGroup = ({ appearance: appearance = 'stack', avatar: avatar = (0, $5DgXR.default), borderColor: borderColor, boundariesElement: boundariesElement, data: data, isTooltipDisabled: isTooltipDisabled, maxCount: maxCount, onAvatarClick: onAvatarClick, onMoreClick: onMoreClick, overrides: overrides, showMoreButtonProps: showMoreButtonProps = {}, size: size = 'medium', testId: testId, label: label = 'avatar group', moreIndicatorLabel: moreIndicatorLabel, tooltipPosition: tooltipPosition = 'bottom', shouldPopupRenderToParent: shouldPopupRenderToParent = false })=>{
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $eJOHy.useState)(false);
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const onClose = (0, $eJOHy.useCallback)(()=>setIsOpen(false), []);
    const handleTriggerClicked = (0, $eJOHy.useCallback)((event)=>{
        const { clientX: clientX, clientY: clientY, type: type } = event;
        // Hitting enter/space is registered as a click with both clientX and clientY === 0
        if (type === 'keydown' || clientX === 0 || clientY === 0) setTriggeredUsingKeyboard(true);
        setIsOpen((isOpen)=>!isOpen);
    }, []);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $llBnk.default)();
    // When a trigger is focused, we want to open the popup
    // the user presses the DownArrow
    (0, $eJOHy.useEffect)(()=>{
        // Set initial value if popup is closed
        if (!isOpen) setTriggeredUsingKeyboard(false);
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $3Vuhz.default;
        // Being safe: we don't want to open the popup if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isOpen) return 0, $3Vuhz.default;
        (0, $4eDgu.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                if (e.key === (0, $9f42f4c07a71299e$export$a80636c6f41931fe)) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                }
            }
        });
        const unbind = ()=>{
            (0, $4eDgu.bind)(window, {
                type: 'keydown',
                listener: function openOnKeyDown(e) {
                    if (e.key === (0, $9f42f4c07a71299e$export$a80636c6f41931fe)) {
                        // prevent page scroll
                        e.preventDefault();
                        handleTriggerClicked(e);
                    }
                }
            });
        };
        return unbind;
    }, [
        isFocused,
        isOpen,
        handleTriggerClicked
    ]);
    function renderMoreDropdown(max, total) {
        if (total <= max) return null;
        const renderMoreButton = ({ 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, onClick: onClick, ...props })=>$36ee9480fc7b69c2$var$getOverrides(overrides).MoreIndicator.render((0, $8PScB.default), {
                buttonProps: showMoreButtonProps,
                borderColor: borderColor,
                count: total - max,
                size: size,
                testId: testId && `${testId}--overflow-menu--trigger`,
                isActive: isOpen,
                moreIndicatorLabel: moreIndicatorLabel,
                'aria-controls': ariaControls,
                'aria-expanded': ariaExpanded,
                'aria-haspopup': ariaHasPopup,
                onClick: onClick,
                ...props
            });
        // bail if the consumer wants to handle onClick
        if (typeof onMoreClick === 'function') return renderMoreButton({
            onClick: onMoreClick
        });
        // split boundariesElement into `boundary` and `rootBoundary` props for Popup
        const boundary = boundariesElement === 'scrollParent' ? 'clippingParents' : undefined;
        const rootBoundary = (()=>{
            if (boundariesElement === 'scrollParent') return undefined;
            return boundariesElement === 'window' ? 'document' : 'viewport';
        })();
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kJsb4.default), {
            isOpen: isOpen,
            onClose: onClose,
            placement: "bottom-end",
            boundary: boundary,
            rootBoundary: rootBoundary,
            shouldFlip: true,
            zIndex: 510,
            shouldRenderToParent: shouldPopupRenderToParent,
            content: ({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $e8NdE.default), {
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8Au2G.default), {
                        onClick: (e)=>e.stopPropagation(),
                        minWidth: 250,
                        maxHeight: 300,
                        setInitialFocusRef: isTriggeredUsingKeyboard ? setInitialFocusRef : undefined,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6YEko.default), {
                            children: data.slice(max).map((avatar, index)=>$36ee9480fc7b69c2$var$getOverrides(overrides).AvatarGroupItem.render((0, $8nCcr.default), {
                                    avatar: avatar,
                                    onAvatarClick: onAvatarClick,
                                    testId: testId && `${testId}--avatar-group-item-${index + max}`,
                                    index: index + max
                                }, // This index holds the true index,
                                // adding up the index of non-overflowed avatars and overflowed avatars.
                                index + max))
                        })
                    })
                }),
            trigger: (triggerProps)=>renderMoreButton({
                    ...triggerProps,
                    ...bindFocus,
                    onClick: handleTriggerClicked
                }),
            testId: testId && `${testId}--overflow-menu`
        });
    }
    const max = maxCount === undefined || maxCount === 0 ? $36ee9480fc7b69c2$var$MAX_COUNT[appearance] : maxCount;
    const total = data.length;
    const maxAvatar = total > max ? max - 1 : max;
    const Group = appearance === 'stack' ? (0, $9YB82.default) : (0, $1ld2P.default);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)(Group, {
        testId: testId && `${testId}--avatar-group`,
        "aria-label": label,
        children: [
            data.slice(0, maxAvatar).map((avatarData, idx)=>{
                const callback = avatarData.onClick || onAvatarClick;
                const finalAvatar = $36ee9480fc7b69c2$var$getOverrides(overrides).Avatar.render(avatar, {
                    ...avatarData,
                    size: size,
                    borderColor: borderColor || avatarData.borderColor,
                    testId: testId && `${testId}--avatar-${idx}`,
                    onClick: callback ? (event, analyticsEvent)=>{
                        callback(event, analyticsEvent, idx);
                    } : undefined,
                    stackIndex: max - idx
                }, idx);
                return !isTooltipDisabled && !avatarData.isDisabled ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
                    content: avatarData.name,
                    testId: testId && `${testId}--tooltip-${idx}`,
                    position: tooltipPosition,
                    children: finalAvatar
                }, (0, $aeH98.composeUniqueKey)(avatarData, idx)) : finalAvatar;
            }),
            renderMoreDropdown(+maxAvatar, total)
        ]
    });
};
var $36ee9480fc7b69c2$export$2e2bcd8739ae039 = $36ee9480fc7b69c2$var$AvatarGroup;

});
/**
 * Character key codes which can be used in keyboard events.
 */ const $9f42f4c07a71299e$export$390330c10ff2b9a1 = 'ArrowUp';
const $9f42f4c07a71299e$export$a80636c6f41931fe = 'ArrowDown';
const $9f42f4c07a71299e$export$4af703091671bc = 'Home';
const $9f42f4c07a71299e$export$e2bc30913faa5db7 = 'End';
const $9f42f4c07a71299e$export$10f6869ed0a7d75b = 'Tab';
const $9f42f4c07a71299e$export$8152f929a25a0ff4 = 'Enter';
const $9f42f4c07a71299e$export$e51a3576c045c8d5 = 'Space';
const $9f42f4c07a71299e$export$2bb790b9008907b4 = 'Escape';

parcelRegister("8nCcr", function(module, exports) {

$parcel$export(module.exports, "default", () => $dcb063c80fc7ca53$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5DgXR = parcelRequire("5DgXR");

var $gyJTO = parcelRequire("gyJTO");

var $7saMl = parcelRequire("7saMl");
var $1PYwQ = parcelRequire("1PYwQ");
var $f58rc = parcelRequire("f58rc");

var $b65Ea = parcelRequire("b65Ea");
const $dcb063c80fc7ca53$var$AvatarGroupItem = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const { avatar: avatar, index: index, onAvatarClick: onAvatarClick, testId: testId } = props;
    const { analyticsContext: analyticsContext, appearance: appearance, as: as, borderColor: borderColor, children: children, href: href, isDisabled: isDisabled, key: key, label: label, name: name, onClick: onClick, presence: presence, size: size, src: src, stackIndex: stackIndex, status: status, tabIndex: tabIndex, target: target, testId: groupItemTestId, ...rest } = avatar;
    const itemRef = (0, $b65Ea.default)();
    const CustomComponent = ({ children: children, className: className, disabled: disabled, draggable: draggable, onClick: onClick, onDragStart: onDragStart, onMouseDown: onMouseDown, ref: ref, tabIndex: tabIndex, 'data-testid': testId, ...props })=>{
        return /*#__PURE__*/ (0, $gt9Am.jsx)("button", {
            type: "button",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            disabled: disabled,
            draggable: draggable,
            onClick: onClick,
            // eslint-disable-next-line @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop
            onDragStart: onDragStart,
            onMouseDown: onMouseDown,
            ref: ref,
            tabIndex: tabIndex,
            "data-testid": testId,
            ...props,
            children: children
        });
    };
    const AvatarIcon = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5DgXR.default), {
        ...rest,
        analyticsContext: analyticsContext,
        appearance: appearance,
        as: as,
        borderColor: "transparent",
        children: children,
        isDisabled: isDisabled,
        label: label,
        name: "",
        presence: presence,
        size: "small",
        src: src,
        stackIndex: stackIndex,
        status: status,
        tabIndex: tabIndex,
        testId: testId && `${testId}--avatar`
    });
    // onClick handler provided with avatar data takes precedence, same as with the normal avatar item
    const callback = onClick || onAvatarClick;
    if (href) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $f58rc.default), {
        ref: (0, $gyJTO.default)([
            ref,
            itemRef
        ]),
        href: href,
        target: target,
        rel: target === '_blank' ? 'noopener noreferrer' : undefined,
        iconBefore: AvatarIcon,
        testId: testId,
        onClick: (event)=>callback && callback(event, undefined, index),
        children: name
    });
    if (typeof callback === 'function') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7saMl.default), {
        ref: (0, $gyJTO.default)([
            ref,
            itemRef
        ]),
        onClick: (event)=>callback && callback(event, undefined, index),
        iconBefore: AvatarIcon,
        testId: testId,
        children: name
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1PYwQ.default), {
        iconBefore: AvatarIcon,
        component: CustomComponent,
        testId: testId,
        children: name
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$dcb063c80fc7ca53$export$2e2bcd8739ae039 = $dcb063c80fc7ca53$var$AvatarGroupItem;

});
parcelRegister("b65Ea", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5c0c66be19727b1$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $e8NdE = parcelRequire("e8NdE");
// The refs stored in the context are used to programatically
// control focus on a user navigates using the keyboard.
function $d5c0c66be19727b1$var$useRegisterItemWithFocusManager() {
    const { registerRef: registerRef } = (0, $eJOHy.useContext)((0, $e8NdE.FocusManagerContext));
    const itemRef = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useEffect)(()=>{
        if (itemRef.current !== null) registerRef(itemRef.current);
    }, [
        registerRef
    ]);
    return itemRef;
}
var $d5c0c66be19727b1$export$2e2bcd8739ae039 = $d5c0c66be19727b1$var$useRegisterItemWithFocusManager;

});
parcelRegister("e8NdE", function(module, exports) {

$parcel$export(module.exports, "FocusManagerContext", () => $d28720e9617ae246$export$f18c1d4fc7326096);
$parcel$export(module.exports, "default", () => $d28720e9617ae246$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $4eDgu = parcelRequire("4eDgu");

var $3Vuhz = parcelRequire("3Vuhz");

var $a8nPO = parcelRequire("a8nPO");
const $d28720e9617ae246$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $eJOHy.createContext)({
    menuItemRefs: [],
    registerRef: (0, $3Vuhz.default)
});
/**
 * Focus manager logic
 */ const $d28720e9617ae246$var$FocusManager = ({ children: children })=>{
    const menuItemRefs = (0, $eJOHy.useRef)([]);
    const registerRef = (0, $eJOHy.useCallback)((ref)=>{
        if (ref && !menuItemRefs.current.includes(ref)) menuItemRefs.current.push(ref);
    }, []);
    // set focus and intentionally rebinding listener and clean up listener on each render
    (0, $eJOHy.useEffect)(()=>{
        (0, $4eDgu.bind)(window, {
            type: 'keydown',
            listener: (0, $a8nPO.default)(menuItemRefs.current)
        });
        const unbind = ()=>{
            (0, $4eDgu.bind)(window, {
                type: 'keydown',
                listener: (0, $a8nPO.default)(menuItemRefs.current)
            });
        };
        return unbind;
    }, []);
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)($d28720e9617ae246$export$f18c1d4fc7326096.Provider, {
        value: contextValue,
        children: children
    });
};
var $d28720e9617ae246$export$2e2bcd8739ae039 = $d28720e9617ae246$var$FocusManager;

});
parcelRegister("a8nPO", function(module, exports) {

$parcel$export(module.exports, "default", () => $f88bdf832caa6c34$export$2e2bcd8739ae039);

const $f88bdf832caa6c34$var$actionMap = {
    [(0, $9f42f4c07a71299e$export$a80636c6f41931fe)]: 'next',
    [(0, $9f42f4c07a71299e$export$390330c10ff2b9a1)]: 'prev',
    [(0, $9f42f4c07a71299e$export$4af703091671bc)]: 'first',
    [(0, $9f42f4c07a71299e$export$e2bc30913faa5db7)]: 'last'
};
/**
 * currentFocusedIdx + 1 will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $f88bdf832caa6c34$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx + 1 < refs.length){
        const isDisabled = refs[currentFocusedIdx + 1].getAttribute('disabled') !== null;
        if (!isDisabled) return refs[currentFocusedIdx + 1];
        currentFocusedIdx++;
    }
};
/**
 * currentFocusedIdx - 1 will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $f88bdf832caa6c34$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx > 0){
        const isDisabled = refs[currentFocusedIdx - 1].getAttribute('disabled') !== null;
        if (!isDisabled) return refs[currentFocusedIdx - 1];
        currentFocusedIdx--;
    }
};
function $f88bdf832caa6c34$export$2e2bcd8739ae039(refs) {
    return (e)=>{
        const currentFocusedIdx = refs.findIndex((el)=>document.activeElement?.isSameNode(el));
        const action = $f88bdf832caa6c34$var$actionMap[e.key];
        switch(action){
            case 'next':
                if (currentFocusedIdx < refs.length - 1) {
                    e.preventDefault();
                    const nextFocusableElement = $f88bdf832caa6c34$var$getNextFocusableElement(refs, currentFocusedIdx);
                    nextFocusableElement?.focus();
                }
                break;
            case 'prev':
                if (currentFocusedIdx > 0) {
                    e.preventDefault();
                    const prevFocusableElement = $f88bdf832caa6c34$var$getPrevFocusableElement(refs, currentFocusedIdx);
                    prevFocusableElement?.focus();
                }
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const nextFocusableElement = $f88bdf832caa6c34$var$getNextFocusableElement(refs, -1);
                nextFocusableElement?.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const prevFocusableElement = $f88bdf832caa6c34$var$getPrevFocusableElement(refs, refs.length);
                prevFocusableElement?.focus();
                break;
            default:
                return;
        }
    };
}

});




parcelRegister("1ld2P", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e7ac3d16cd9447d$export$2e2bcd8739ae039);
/* grid.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $5e7ac3d16cd9447d$var$gutter = "var(--ds-space-negative-050, -4px)";
const $5e7ac3d16cd9447d$var$listStyles = null;
const $5e7ac3d16cd9447d$var$listItemStyles = null;
const $5e7ac3d16cd9447d$var$Grid = ({ children: children, testId: testId, 'aria-label': label })=>/*#__PURE__*/ (0, $gt9Am.jsx)("ul", {
        "data-testid": testId,
        "aria-label": label,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bah1y6m _1n261g80 _19121cl4 _vwz4kb7n _2mzuagmp _6rthze3t _1pfhze3t _12l2r5cr _ahbqr5cr _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t"
        ]),
        children: (0, $eJOHy.Children).map(children, (child)=>child && /*#__PURE__*/ (0, $gt9Am.jsx)("li", {
                className: (0, $hcewu.default)([
                    "_6rthu2gc _1pfhze3t _12l2ze3t _ahbqze3t _y4ti1b66 _bozg1b66"
                ]),
                children: child
            }))
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$5e7ac3d16cd9447d$export$2e2bcd8739ae039 = $5e7ac3d16cd9447d$var$Grid;

});

parcelRegister("8Au2G", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d2b5b7b41d11fa6$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $jUgeq = parcelRequire("jUgeq");

var $e8NdE = parcelRequire("e8NdE");
/**
 * It sets focus to the first avatar when popup is open.
 */ const $1d2b5b7b41d11fa6$var$PopupAvatarGroup = ({ children: children, isLoading: isLoading, maxHeight: maxHeight, maxWidth: maxWidth = 800, minHeight: minHeight, minWidth: minWidth = 320, onClick: onClick, role: role, setInitialFocusRef: setInitialFocusRef, spacing: spacing, testId: testId, ...rest })=>{
    const { menuItemRefs: menuItemRefs } = (0, $eJOHy.useContext)((0, $e8NdE.FocusManagerContext));
    (0, $eJOHy.useEffect)(()=>{
        setInitialFocusRef?.(menuItemRefs[0]);
    }, [
        menuItemRefs,
        setInitialFocusRef
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jUgeq.default), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        minHeight: minHeight,
        minWidth: minWidth,
        onClick: onClick,
        role: role,
        spacing: spacing,
        testId: testId,
        ...rest,
        children: children
    });
};
var $1d2b5b7b41d11fa6$export$2e2bcd8739ae039 = $1d2b5b7b41d11fa6$var$PopupAvatarGroup;

});

parcelRegister("8PScB", function(module, exports) {

$parcel$export(module.exports, "default", () => $cdf80f821318091d$export$2e2bcd8739ae039);
/* more-indicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eGOwo = parcelRequire("eGOwo");
const $cdf80f821318091d$var$boxShadowCssVar = '--avatar-box-shadow';
const $cdf80f821318091d$var$styles = {
    root: "_19itglyw _12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _v564ieh6 _1e0c1txw _vchh18uv _19pkv77o _2hwxv77o _otyrv77o _18u0v77o _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _4cvr1fhb _1bah1h6o _2lx21bp4 _80omtlke _bfhkm7j4 _syaz1fxt _16qs1nhn _t9ec1aqe _1ejjglyw _mizu194a _ra3xnqa1 _1ah3yh40 _128myh40 _irr315ej _30l31fxt _1di6ip91 _9h8h1fxt _1q8w1np6 _jlxit94y",
    circle: "_2rko1q5u",
    active: "_bfhkfg4m _16qsqz53 _syazaqb7 _t9ec1np6 _irr3i1yw _30l3aqb7 _1di619ru _9h8haqb7",
    disabled: "_80om13gf _1peqs237 _1hfkvuon"
};
const $cdf80f821318091d$var$widthHeightMap = {
    xsmall: "_1bsb7vkz _4t3i7vkz",
    small: "_1bsb1tcg _4t3i1tcg",
    medium: "_1bsbzwfg _4t3izwfg",
    large: "_1bsb1ylp _4t3i1ylp",
    xlarge: "_1bsb16xz _4t3i16xz",
    xxlarge: "_1bsb1qr7 _4t3i1qr7"
};
const $cdf80f821318091d$var$borderRadiusMap = {
    xsmall: "_2rkoyh40 _14mjyh40",
    small: "_2rkoyh40 _14mjyh40",
    medium: "_2rko1l7b _14mj1l7b",
    large: "_2rko1l7b _14mj1l7b",
    xlarge: "_2rkoi2wt _14mji2wt",
    xxlarge: "_2rko1crf _14mj1crf"
};
const $cdf80f821318091d$var$fontMap = {
    small: "_11c81o8v",
    medium: "_11c81o8v",
    large: "_11c8dcr7",
    xlarge: "_11c81ixg",
    xxlarge: "_11c81ixg"
};
const $cdf80f821318091d$var$MAX_DISPLAY_COUNT = 99;
const $cdf80f821318091d$var$MoreIndicator = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ appearance: appearance = 'circle', borderColor: // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
borderColor = (0, $eGOwo.fg)('platform-component-visual-refresh') ? "var(--ds-surface, #FFFFFF)" : "var(--ds-border-inverse, #FFFFFF)", size: size = 'medium', count: count = 0, testId: testId, onClick: onClick, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHaspopup, moreIndicatorLabel: moreIndicatorLabel, buttonProps: buttonProps = {}, isActive: isActive }, ref)=>{
    const onClickHander = (0, $eJOHy.useCallback)((event, analyticsEvent)=>{
        if (buttonProps.onClick) buttonProps.onClick(event);
        onClick(event, analyticsEvent);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        buttonProps.onClick,
        onClick
    ]);
    const displayCount = count > $cdf80f821318091d$var$MAX_DISPLAY_COUNT ? $cdf80f821318091d$var$MAX_DISPLAY_COUNT : count;
    const providedAriaLabel = moreIndicatorLabel || buttonProps['aria-label'];
    const ariaLabel = providedAriaLabel ? providedAriaLabel : `${displayCount} more people`;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("button", {
        type: "submit",
        ...buttonProps,
        onClick: onClickHander,
        ref: ref,
        "data-testid": testId,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHaspopup,
        "aria-label": ariaLabel,
        style: {
            [$cdf80f821318091d$var$boxShadowCssVar]: `0 0 0 2px ${borderColor}`
        },
        className: (0, $hcewu.default)([
            $cdf80f821318091d$var$styles.root,
            $cdf80f821318091d$var$borderRadiusMap[size],
            appearance === 'circle' && $cdf80f821318091d$var$styles.circle,
            $cdf80f821318091d$var$widthHeightMap[size],
            $cdf80f821318091d$var$fontMap[size],
            isActive && $cdf80f821318091d$var$styles.active
        ]),
        children: [
            "+",
            displayCount
        ]
    });
});
$cdf80f821318091d$var$MoreIndicator.displayName = 'MoreIndicator';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$cdf80f821318091d$export$2e2bcd8739ae039 = $cdf80f821318091d$var$MoreIndicator;

});

parcelRegister("9YB82", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3bb26966f739c04$export$2e2bcd8739ae039);
/* stack.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $d3bb26966f739c04$var$listStyles = null;
const $d3bb26966f739c04$var$listItemStyles = null;
const $d3bb26966f739c04$var$Stack = ({ children: children, testId: testId, 'aria-label': label })=>/*#__PURE__*/ (0, $gt9Am.jsx)("ul", {
        "data-testid": testId,
        "aria-label": label,
        className: (0, $hcewu.default)([
            "_1e0c1txw _19121cl4 _vwz4kb7n _2mzuagmp _6rthze3t _1pfhze3t _12l2u2gc _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t"
        ]),
        children: (0, $eJOHy.Children).map(children, (child)=>child && /*#__PURE__*/ (0, $gt9Am.jsx)("li", {
                className: (0, $hcewu.default)([
                    "_6rthze3t _1pfhze3t _12l2x0bf _ahbqze3t"
                ]),
                children: child
            }))
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d3bb26966f739c04$export$2e2bcd8739ae039 = $d3bb26966f739c04$var$Stack;

});

parcelRegister("aeH98", function(module, exports) {

$parcel$export(module.exports, "composeUniqueKey", () => $871dcdf2e893338b$export$b067756944994c79);
const $871dcdf2e893338b$export$b067756944994c79 = (props, index)=>{
    if (props.key) return props.key;
    return index;
};

});




parcelRegister("lVTJZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca273e569a0c1d25$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4XCp5 = parcelRequire("4XCp5");
const $ca273e569a0c1d25$var$AttachmentCountElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $4XCp5.toBadgeProps)(context.attachmentCount?.toString()) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4XCp5.default), {
        icon: (0, $5NtHI.IconType).Attachment,
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).AttachmentCount
    }) : null;
};
var $ca273e569a0c1d25$export$2e2bcd8739ae039 = $ca273e569a0c1d25$var$AttachmentCountElement;

});

parcelRegister("gl0Fx", function(module, exports) {

$parcel$export(module.exports, "default", () => $5186dee07e48afde$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $vUns3 = parcelRequire("vUns3");
const $5186dee07e48afde$var$AuthorGroupElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $vUns3.toAvatarGroupProps)(context.authorGroup, false) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $vUns3.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).AuthorGroup
    }) : null;
};
var $5186dee07e48afde$export$2e2bcd8739ae039 = $5186dee07e48afde$var$AuthorGroupElement;

});

parcelRegister("iCDdz", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e60145f3c4ab217$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4XCp5 = parcelRequire("4XCp5");
const $0e60145f3c4ab217$var$ChecklistProgressElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $4XCp5.toBadgeProps)(context.checklistProgress?.toString()) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4XCp5.default), {
        icon: (0, $5NtHI.IconType).CheckItem,
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).ChecklistProgress
    }) : null;
};
var $0e60145f3c4ab217$export$2e2bcd8739ae039 = $0e60145f3c4ab217$var$ChecklistProgressElement;

});

parcelRegister("cSuZU", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3e78c51e7c53936$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $vUns3 = parcelRequire("vUns3");
const $b3e78c51e7c53936$var$CollaboratorGroupElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $vUns3.toAvatarGroupProps)(context.collaboratorGroup, false) : undefined;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $vUns3.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).CollaboratorGroup
    }) : null;
};
var $b3e78c51e7c53936$export$2e2bcd8739ae039 = $b3e78c51e7c53936$var$CollaboratorGroupElement;

});

parcelRegister("gA3VJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $55e7c0307b507f46$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4XCp5 = parcelRequire("4XCp5");
const $55e7c0307b507f46$var$CommentCountElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $4XCp5.toBadgeProps)(context.commentCount?.toString()) : null;
    const { onRender: onRender, ...restProps } = props || {};
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if ((0, $eGOwo.fg)('platform-linking-additional-flexible-element-props')) // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eJOHy.useEffect)(()=>{
        onRender?.(!!data);
    }, [
        data,
        onRender
    ]);
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4XCp5.default), {
        icon: (0, $5NtHI.IconType).Comment,
        ...data,
        ...restProps,
        name: (0, $5NtHI.ElementName).CommentCount
    }) : null;
};
var $55e7c0307b507f46$export$2e2bcd8739ae039 = $55e7c0307b507f46$var$CommentCountElement;

});

parcelRegister("aiy2i", function(module, exports) {

$parcel$export(module.exports, "default", () => $932490ed3e7f327b$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $aKX5a = parcelRequire("aKX5a");
const $932490ed3e7f327b$var$CreatedOnElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $aKX5a.toDateTimeProps)('created', context.createdOn) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aKX5a.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).CreatedOn
    }) : null;
};
var $932490ed3e7f327b$export$2e2bcd8739ae039 = $932490ed3e7f327b$var$CreatedOnElement;

});
parcelRegister("aKX5a", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb039ade903c50b2$export$2e2bcd8739ae039);
$parcel$export(module.exports, "toDateTimeProps", () => $cb039ade903c50b2$export$2d4384e6b150cbe3);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $6wSDf = parcelRequire("6wSDf");

var $kDaaB = parcelRequire("kDaaB");
var $lRq8t = parcelRequire("lRq8t");

var $eGOwo = parcelRequire("eGOwo");

var $19nmp = parcelRequire("19nmp");
const $cb039ade903c50b2$var$styles = null;
const $cb039ade903c50b2$var$typeToDescriptorMap = {
    created: {
        relative: (0, $19nmp.messages).created_on_relative,
        absolute: (0, $19nmp.messages).created_on_absolute
    },
    modified: {
        relative: (0, $19nmp.messages).modified_on_relative,
        absolute: (0, $19nmp.messages).modified_on_absolute
    },
    sent: {
        relative: (0, $19nmp.messages).sent_on_relative,
        absolute: (0, $19nmp.messages).sent_on_absolute
    }
};
const $cb039ade903c50b2$var$fontOverrideStyleMap = {
    'font.body': "_11c82smr",
    'font.body.large': "_11c81ixg",
    'font.body.small': "_11c81o8v",
    'font.body.UNSAFE_small': "_11c8dcr7"
};
/**
 * A base element that displays an ISO Timestamp in text.
 * @internal
 * @param {BaseDateTimeElementProps} BaseDateTimeElementProps - The props necessary for the DateTime element.
 * @see CreatedOn
 * @see ModifiedOn
 * @see SentOn
 */ const $cb039ade903c50b2$var$BaseDateTimeElement = ({ date: date, name: name, className: className, type: type, testId: testId = 'smart-element-date-time', text: text, hideDatePrefix: hideDatePrefix = false, color: color, fontSize: fontSize })=>{
    const { formatRelativeTime: formatRelativeTime, formatDate: formatDate } = (0, $lRq8t.default)();
    if (!type || !date) return null;
    const isLongerThenWeek = Math.abs(date.getTime() - Date.now()) > 604800000;
    let context;
    let typeVariant;
    if (isLongerThenWeek) {
        typeVariant = 'absolute';
        context = formatDate(date, {
            month: 'short',
            day: 'numeric',
            year: 'numeric'
        });
    } else {
        const { value: value, unit: unit } = (0, $6wSDf.selectUnit)(date, Date.now());
        typeVariant = 'relative';
        context = formatRelativeTime(value, unit, {
            numeric: 'auto'
        });
    }
    let content;
    if (hideDatePrefix && (0, $eGOwo.fg)('platform-linking-additional-flexible-element-props')) content = context;
    else if (text) content = `${text} ${context}`;
    else content = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
        ...$cb039ade903c50b2$var$typeToDescriptorMap[type][typeVariant],
        values: {
            context: context
        }
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        style: {
            color: color && (0, $eGOwo.fg)('platform-linking-additional-flexible-element-props') ? color : undefined
        },
        "data-separator": true,
        "data-smart-element": name,
        "data-smart-element-date-time": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_11c81o8v _1reo15vq _18m915vq _syaz1gjq _1e0ccj1k _1ul9idpf _1bto1l2s _1nmz1hna _1yyjkb7n _sudp1e54 _102k7vkz",
            fontSize !== undefined && (0, $eGOwo.fg)('bandicoots-smart-card-teamwork-context') && $cb039ade903c50b2$var$fontOverrideStyleMap[fontSize],
            className
        ]),
        children: content
    });
};
var $cb039ade903c50b2$export$2e2bcd8739ae039 = $cb039ade903c50b2$var$BaseDateTimeElement;
const $cb039ade903c50b2$export$2d4384e6b150cbe3 = (type, dateString)=>{
    return dateString ? {
        date: new Date(dateString),
        type: type
    } : undefined;
};

});


parcelRegister("k4xpX", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f3b49272a6afc71$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $38cBa = parcelRequire("38cBa");
const $3f3b49272a6afc71$var$CreatedByElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $38cBa.toFormattedTextProps)((0, $19nmp.messages).created_by, context.createdBy) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).CreatedBy
    }) : null;
};
var $3f3b49272a6afc71$export$2e2bcd8739ae039 = $3f3b49272a6afc71$var$CreatedByElement;

});

parcelRegister("kCe9K", function(module, exports) {

$parcel$export(module.exports, "default", () => $805a1aa3004ae832$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $cmzNL = parcelRequire("cmzNL");
const $805a1aa3004ae832$var$DueOnElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $cmzNL.toDateLozengeProps)(context.dueOn) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cmzNL.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).DueOn
    }) : null;
};
var $805a1aa3004ae832$export$2e2bcd8739ae039 = $805a1aa3004ae832$var$DueOnElement;

});
parcelRegister("cmzNL", function(module, exports) {

$parcel$export(module.exports, "default", () => $351b36f187c69d22$export$2e2bcd8739ae039);
$parcel$export(module.exports, "toDateLozengeProps", () => $351b36f187c69d22$export$8f9f58f7bac50fbe);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $7qGN1 = parcelRequire("7qGN1");

var $jdqdp = parcelRequire("jdqdp");

var $eGOwo = parcelRequire("eGOwo");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4Frd9 = parcelRequire("4Frd9");
const $351b36f187c69d22$var$styles = null;
/**
 * A base element that displays a Lozenge.
 * @internal
 * @param {BaseLozengeElementProps} BaseLozengeElementProps - The props necessary for the Lozenge element.
 * @see State
 */ const $351b36f187c69d22$var$BaseLozengeElement = ({ action: action, appearance: appearance = 'default', name: name, className: className, style: style, text: text, testId: testId = 'smart-element-lozenge' })=>{
    const ui = (0, $5FRJ8.useFlexibleUiOptionContext)();
    if (!text) return null;
    const lozenge = action ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4Frd9.default), {
        action: action,
        appearance: appearance,
        testId: testId,
        text: text,
        zIndex: ui?.zIndex
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jdqdp.default), {
        appearance: appearance,
        ...(0, $eGOwo.fg)('platform-component-visual-refresh') ? {
            isBold: true
        } : undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        testId: `${testId}-lozenge`,
        children: text
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-smart-element": name,
        "data-smart-element-lozenge": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_1e0c116y _1ul91ns9",
            className
        ]),
        children: lozenge
    });
};
var $351b36f187c69d22$export$2e2bcd8739ae039 = $351b36f187c69d22$var$BaseLozengeElement;
const $351b36f187c69d22$export$8f9f58f7bac50fbe = (dateString)=>{
    if (dateString) {
        const text = Date.parse(dateString) ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7qGN1.FormattedDate), {
            value: new Date(dateString),
            year: "numeric",
            month: "short",
            day: "numeric",
            formatMatcher: "best fit"
        }) : dateString;
        return {
            text: text
        };
    }
};

});
parcelRegister("4Frd9", function(module, exports) {

$parcel$export(module.exports, "default", () => $9074bb98cbadc69e$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $7rjYb = parcelRequire("7rjYb");

var $eGOwo = parcelRequire("eGOwo");

var $bmWcp = parcelRequire("bmWcp");

var $EtcI0 = parcelRequire("EtcI0");

var $6O4ri = parcelRequire("6O4ri");

var $d0InI = parcelRequire("d0InI");

var $kbv8x = parcelRequire("kbv8x");

var $CpyFM = parcelRequire("CpyFM");

var $b43DQ = parcelRequire("b43DQ");

var $hxkmu = parcelRequire("hxkmu");

var $e9seM = parcelRequire("e9seM");

var $5iuU7 = parcelRequire("5iuU7");

var $4dVhH = parcelRequire("4dVhH");

var $htuxE = parcelRequire("htuxE");

var $dsXZb = parcelRequire("dsXZb");
const $9074bb98cbadc69e$var$validateItems = (items = [], text)=>{
    return items.filter((item)=>item.text !== text);
};
const $9074bb98cbadc69e$var$LozengeAction = ({ action: action, appearance: appearance, testId: testId = 'smart-element-lozenge-action', text: text, zIndex: zIndex })=>{
    const [selected, setSelected] = (0, $eJOHy.useState)({
        appearance: appearance,
        text: text
    });
    const [isLoaded, setIsLoaded] = (0, $eJOHy.useState)(false);
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(false);
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const [items, setItems] = (0, $eJOHy.useState)();
    const [errorMessage, setErrorMessage] = (0, $eJOHy.useState)();
    const reload = (0, $kbv8x.default)();
    const invoke = (0, $6O4ri.default)();
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        setSelected({
            text: text,
            appearance: appearance
        });
    }, [
        text,
        appearance
    ]);
    const { url: url, id: linkId, invokePreviewAction: invokePreviewAction } = action?.update?.details || {};
    const handleOpenChange = (0, $eJOHy.useCallback)(async (args)=>{
        setIsOpen(args.isOpen);
        if (args.isOpen) {
            fireEvent('ui.button.clicked.smartLinkStatusLozenge', {});
            fireEvent('track.smartLinkQuickAction.started', {
                smartLinkActionType: (0, $b43DQ.TrackQuickActionType).StatusUpdate
            });
            if (!isLoaded && action?.read) try {
                setIsLoading(true);
                const responseItems = await invoke(action.read, (0, $EtcI0.default));
                const validItems = typeof text === 'string' ? $9074bb98cbadc69e$var$validateItems(responseItems, text) : responseItems;
                setItems(validItems);
                setIsLoaded(true);
                if (validItems?.length === 0) {
                    fireEvent('track.smartLinkQuickAction.failed', (0, $e9seM.permissionLoadErrorAnalyticsPayload));
                    setErrorMessage((0, $eGOwo.fg)('confluence-issue-terminology-refresh') ? (0, $4dVhH.LozengeActionErrorMessages).noDataIssueTermRefresh : (0, $4dVhH.LozengeActionErrorMessages).noData);
                    setIsLoaded(false);
                }
            } catch (err) {
                setErrorMessage((0, $4dVhH.LozengeActionErrorMessages).unknown);
                setIsLoaded(false);
                fireEvent('track.smartLinkQuickAction.failed', (0, $e9seM.unknownLoadErrorAnalyticsPayload));
            } finally{
                setIsLoading(false);
            }
        }
        if (!args.isOpen) setErrorMessage(undefined);
    }, [
        action.read,
        invoke,
        isLoaded,
        text,
        fireEvent
    ]);
    const trigger = (0, $eJOHy.useCallback)((props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $dsXZb.default), {
            ...props,
            appearance: selected.appearance,
            isOpen: isOpen,
            testId: testId,
            text: selected.text
        }), [
        selected.appearance,
        selected.text,
        isOpen,
        testId
    ]);
    const handleItemClick = (0, $eJOHy.useCallback)(async (id, text, appearance)=>{
        try {
            fireEvent('ui.button.clicked.smartLinkStatusListItem', {});
            const updateAction = action?.update;
            if (updateAction && id) {
                setIsLoading(true);
                const request = (0, $CpyFM.default)(updateAction, id);
                await invoke(request);
                setSelected({
                    appearance: appearance,
                    text: text
                });
                setIsLoading(false);
                setIsLoaded(false);
                setIsOpen(false);
                setItems([]);
                fireEvent('track.smartLinkQuickAction.success', {
                    smartLinkActionType: (0, $b43DQ.TrackQuickActionType).StatusUpdate
                });
                if (url) await reload(url, true, undefined, linkId);
            }
        } catch (err) {
            setIsLoading(false);
            if ((0, $d0InI.isInvokeCustomError)(err)) {
                setErrorMessage(err.message);
                fireEvent('track.smartLinkQuickAction.failed', (0, $e9seM.validationUpdateErrorAnalyticsPayload));
            } else {
                setErrorMessage((0, $4dVhH.LozengeActionErrorMessages).updateFailed);
                fireEvent('track.smartLinkQuickAction.failed', (0, $e9seM.unknownUpdateErrorAnalyticsPayload));
            }
        }
    }, [
        action?.update,
        invoke,
        linkId,
        reload,
        url,
        fireEvent
    ]);
    const dropdownItemGroup = (0, $eJOHy.useMemo)(()=>{
        if (errorMessage) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5iuU7.default), {
            errorMessage: errorMessage,
            testId: testId,
            url: url,
            invokePreviewAction: invokePreviewAction
        });
        if (items && items.length > 0) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $htuxE.default), {
            testId: testId,
            items: items,
            onClick: handleItemClick
        });
    }, [
        errorMessage,
        handleItemClick,
        items,
        invokePreviewAction,
        testId,
        url
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7rjYb.default), {
        isLoading: isLoading,
        isOpen: isOpen,
        onOpenChange: handleOpenChange,
        testId: testId,
        trigger: trigger,
        zIndex: zIndex,
        children: dropdownItemGroup
    });
};
var $9074bb98cbadc69e$export$2e2bcd8739ae039 = (0, $hxkmu.default)($9074bb98cbadc69e$var$LozengeAction);

});
parcelRegister("EtcI0", function(module, exports) {

$parcel$export(module.exports, "default", () => $377731e831492625$export$2e2bcd8739ae039);
const $377731e831492625$var$extractLozengeActionItems = (response)=>{
    const items = response?.transitions?.map(({ appearance: appearance, id: id, name: name })=>({
            appearance: appearance ?? 'default',
            id: id,
            text: name
        })) ?? [];
    return items.sort((a, b)=>a.appearance.localeCompare(b.appearance) || a.text.localeCompare(b.text));
};
var $377731e831492625$export$2e2bcd8739ae039 = $377731e831492625$var$extractLozengeActionItems;

});

parcelRegister("6O4ri", function(module, exports) {

$parcel$export(module.exports, "default", () => $b69a1ac7b939ac3b$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $18BbB = parcelRequire("18BbB");

var $9kfy2 = parcelRequire("9kfy2");
const $b69a1ac7b939ac3b$var$useInvoke = ()=>{
    const { connections: connections } = (0, $9kfy2.useSmartLinkContext)();
    const clientExt = (0, $18BbB.useSmartLinkClientExtension)(connections.client);
    return (0, $eJOHy.useCallback)(async (req, cb)=>{
        const response = await clientExt.invoke(req);
        return cb ? cb(response) : response;
    }, [
        clientExt
    ]);
};
var $b69a1ac7b939ac3b$export$2e2bcd8739ae039 = $b69a1ac7b939ac3b$var$useInvoke;

});
parcelRegister("18BbB", function(module, exports) {

$parcel$export(module.exports, "useSmartLinkClientExtension", () => $365002b9ec3223b9$export$303ede4eed148855);

var $eJOHy = parcelRequire("eJOHy");

var $hhFie = parcelRequire("hhFie");

var $5CgrK = parcelRequire("5CgrK");

var $jAAbh = parcelRequire("jAAbh");
const $365002b9ec3223b9$export$303ede4eed148855 = (cardClient)=>{
    const resolverUrl = (0, $jAAbh.useResolverUrl)(cardClient);
    const invoke = (0, $eJOHy.useCallback)(async (data)=>{
        try {
            return await (0, $hhFie.request)('post', `${resolverUrl}/invoke`, data, undefined, [
                200,
                201,
                202,
                203,
                204
            ]);
        } catch (err) {
            // checking if the error is a Response type
            // since we already had a few HOTs caused by comparing with instanceOf',
            // we're verifying the type by the contents
            if (err && err.json && typeof err.json === 'function') {
                const errorBody = await err.json();
                if (errorBody) throw new (0, $5CgrK.InvokeError)(errorBody?.error.message, errorBody?.error.status);
            }
            throw err;
        }
    }, [
        resolverUrl
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            invoke: invoke
        }), [
        invoke
    ]);
};

});
parcelRegister("5CgrK", function(module, exports) {

$parcel$export(module.exports, "SmartLinkActionType", () => $1ec6011516cb04bd$export$6324b7946ad663e9);
$parcel$export(module.exports, "InvokeError", () => $1ec6011516cb04bd$export$d4d72202bff63658);
/**
 * The enum that describes Smart Link action types
 */ var $1ec6011516cb04bd$export$6324b7946ad663e9 = /*#__PURE__*/ function(SmartLinkActionType) {
    SmartLinkActionType["FollowEntityAction"] = "FollowEntityAction";
    SmartLinkActionType["GetStatusTransitionsAction"] = "GetStatusTransitionsAction";
    SmartLinkActionType["StatusUpdateAction"] = "StatusUpdateAction";
    SmartLinkActionType["UnfollowEntityAction"] = "UnfollowEntityAction";
    return SmartLinkActionType;
}({});
class $1ec6011516cb04bd$export$d4d72202bff63658 extends Error {
    constructor(message, errorCode){
        super(message);
        this.errorCode = errorCode;
    }
}

});

parcelRegister("jAAbh", function(module, exports) {

$parcel$export(module.exports, "useResolverUrl", () => $248dfa90412a2e2f$export$d08617a365fbe694);

var $eJOHy = parcelRequire("eJOHy");

var $a5MXk = parcelRequire("a5MXk");
const $248dfa90412a2e2f$export$d08617a365fbe694 = (cardClient)=>(0, $eJOHy.useMemo)(()=>(0, $a5MXk.getResolverUrl)(cardClient?.envKey, cardClient?.baseUrlOverride), [
        cardClient?.baseUrlOverride,
        cardClient?.envKey
    ]);

});



parcelRegister("d0InI", function(module, exports) {

$parcel$export(module.exports, "getInvokeFailureReason", () => $842afed3b5601c74$export$65b3f792dff0bd60);
$parcel$export(module.exports, "isInvokeCustomError", () => $842afed3b5601c74$export$1694272377fa07d8);

var $b43DQ = parcelRequire("b43DQ");
const $842afed3b5601c74$export$65b3f792dff0bd60 = (err)=>{
    if (!$842afed3b5601c74$export$1694272377fa07d8(err)) return (0, $b43DQ.TrackQuickActionFailureReason).UnknownError;
    switch(err?.errorCode){
        case 403:
            return (0, $b43DQ.TrackQuickActionFailureReason).PermissionError;
        default:
            return (0, $b43DQ.TrackQuickActionFailureReason).UnknownError;
    }
};
const $842afed3b5601c74$export$1694272377fa07d8 = (err)=>err?.message !== undefined && err?.errorCode !== undefined;

});

parcelRegister("kbv8x", function(module, exports) {

$parcel$export(module.exports, "default", () => $b139b7122b26d76a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $3jSKi = parcelRequire("3jSKi");

var $9kfy2 = parcelRequire("9kfy2");

var $5NtHI = parcelRequire("5NtHI");

var $1mLfK = parcelRequire("1mLfK");

var $99QxN = parcelRequire("99QxN");
const $b139b7122b26d76a$var$useResolve = ()=>{
    // Request JSON-LD data for the card from ORS, if it has extended
    // its cache lifespan OR there is no data for it currently. Once the data
    // has come back asynchronously, call the useResponse callback to
    // dispatch the resolved action for the card.
    const { store: store, connections: connections } = (0, $9kfy2.useSmartLinkContext)();
    const { getState: getState } = store;
    const { handleResolvedLinkResponse: handleResolvedLinkResponse, handleResolvedLinkError: handleResolvedLinkError } = (0, $99QxN.default)();
    return (0, $eJOHy.useCallback)(async (url, isReloading = false, isMetadataRequest = false, id = '')=>{
        const { details: details } = getState()[url] || {
            status: (0, $5NtHI.SmartLinkStatus).Pending,
            details: undefined
        };
        const hasData = !!(details && details.data || (0, $3jSKi.isEntityPresent)(details));
        if (isReloading || !hasData || isMetadataRequest) return connections.client.fetchData(url, isReloading).then((response)=>handleResolvedLinkResponse(url, response, isReloading, isMetadataRequest)).catch((error)=>handleResolvedLinkError(url, error, undefined, isMetadataRequest));
        else (0, $1mLfK.addMetadataToExperience)('smart-link-rendered', id, {
            cached: true
        });
    }, [
        connections.client,
        getState,
        handleResolvedLinkError,
        handleResolvedLinkResponse
    ]);
};
var $b139b7122b26d76a$export$2e2bcd8739ae039 = $b139b7122b26d76a$var$useResolve;

});
parcelRegister("99QxN", function(module, exports) {

$parcel$export(module.exports, "default", () => $69b217076914baa8$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $aQK2r = parcelRequire("aQK2r");

var $9kfy2 = parcelRequire("9kfy2");

var $ggoTr = parcelRequire("ggoTr");
var $4pUJe = parcelRequire("4pUJe");
var $4g7cp = parcelRequire("4g7cp");

var $5NtHI = parcelRequire("5NtHI");

var $gA511 = parcelRequire("gA511");

const $69b217076914baa8$var$useResponse = ()=>{
    // Takes in the JSON-LD response and dispatch the resolved action for the card.
    // It will dispatch a successful or error action
    const { store: store, config: config } = (0, $9kfy2.useSmartLinkContext)();
    const { getState: getState, dispatch: dispatch } = store;
    const hasAuthFlowSupported = config.authFlow !== 'disabled';
    const setMetadataStatus = (0, $eJOHy.useCallback)((url, metadataStatus)=>{
        dispatch((0, $ggoTr.cardAction)((0, $ggoTr.ACTION_UPDATE_METADATA_STATUS), {
            url: url
        }, undefined, undefined, metadataStatus));
    }, [
        dispatch
    ]);
    const handleResolvedLinkError = (0, $eJOHy.useCallback)((url, error, response, isMetadataRequest)=>{
        const newState = {
            status: (0, $5NtHI.SmartLinkStatus).Pending,
            details: undefined
        };
        const { details: details } = getState()[url] || newState;
        const hasData = !!(details && details.data);
        // If metadata request then set metadata status, return and do not alter link status
        if (isMetadataRequest) {
            setMetadataStatus(url, 'errored');
            return;
        }
        if (error.kind === 'fatal') {
            // If we already have resolved data for this URL in the store, then
            // simply fallback to the previous data.
            if (hasData) dispatch((0, $ggoTr.cardAction)((0, $ggoTr.ACTION_RESOLVED), {
                url: url
            }, details));
            else {
                dispatch((0, $ggoTr.cardAction)((0, $ggoTr.ACTION_ERROR), {
                    url: url
                }, details, error));
                throw error;
            }
        } else if (error.kind === 'auth') dispatch((0, $ggoTr.cardAction)((0, $ggoTr.ACTION_RESOLVED), {
            url: url
        }, (0, $gA511.getUnauthorizedJsonLd)()));
        else if (error.kind === 'fallback') // Fallback to blue link with smart link formatting. Not part of reliability.
        dispatch((0, $ggoTr.cardAction)((0, $ggoTr.ACTION_ERROR_FALLBACK), {
            url: url
        }, response, error));
        else // Fallback to blue link with smart link formatting. Part of reliability.
        dispatch((0, $ggoTr.cardAction)((0, $ggoTr.ACTION_ERROR), {
            url: url
        }, undefined, error));
    }, [
        getState,
        setMetadataStatus,
        dispatch
    ]);
    const handleResolvedLinkSuccess = (0, $eJOHy.useCallback)((resourceUrl, response, isReloading, isMetadataRequest)=>{
        //if a link resolves normally, metadata will also always be resolved
        setMetadataStatus(resourceUrl, 'resolved');
        // Dispatch Analytics and resolved card action - including unauthorized states.
        if (isReloading) dispatch((0, $ggoTr.cardAction)((0, $ggoTr.ACTION_RELOADING), {
            url: resourceUrl
        }, response));
        else dispatch((0, $ggoTr.cardAction)((0, $ggoTr.ACTION_RESOLVED), {
            url: resourceUrl
        }, response, undefined, undefined, isMetadataRequest));
    }, [
        setMetadataStatus,
        dispatch
    ]);
    const handleResolvedLinkResponse = (0, $eJOHy.useCallback)((resourceUrl, response, isReloading = false, isMetadataRequest)=>{
        const hostname = new URL(resourceUrl).hostname;
        const nextStatus = response ? (0, $4g7cp.getStatus)(response) : 'fatal';
        // If we require authorization & do not have an authFlow available,
        // throw an error and render as a normal blue link.
        if ((nextStatus === 'unauthorized' || nextStatus === 'forbidden') && !hasAuthFlowSupported) {
            handleResolvedLinkError(resourceUrl, new (0, $4pUJe.APIError)('fallback', hostname, (0, $9121cfe34e6487d9$export$3e81ce851ffda0ad)), response, isMetadataRequest);
            return;
        }
        // Handle any other errors
        if (!response || nextStatus === 'fatal') {
            handleResolvedLinkError(resourceUrl, new (0, $4pUJe.APIError)('fatal', hostname, (0, $9121cfe34e6487d9$export$45e7dda0d43d7f55)), undefined, isMetadataRequest);
            return;
        }
        // Handle errors of any other kind in the metadata request response
        if (isMetadataRequest && nextStatus !== 'resolved') {
            handleResolvedLinkError(resourceUrl, new (0, $4pUJe.APIError)('error', hostname, (0, $9121cfe34e6487d9$export$338f7d9ccca1975d)), response, isMetadataRequest);
            return;
        }
        /**
			 * Using unstable_batchedUpdates because this store update happens async and triggers a rerender
			 * more info:
			 * https://github.com/facebook/react/blob/v18.2.0/packages/use-sync-external-store/src/useSyncExternalStoreShimClient.js#L113
			 * https://react-redux.js.org/api/batch
			 */ (0, $aQK2r.unstable_batchedUpdates)(()=>{
            handleResolvedLinkSuccess(resourceUrl, response, isReloading, isMetadataRequest);
        });
    }, [
        handleResolvedLinkError,
        handleResolvedLinkSuccess,
        hasAuthFlowSupported
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            handleResolvedLinkError: handleResolvedLinkError,
            handleResolvedLinkResponse: handleResolvedLinkResponse
        }), [
        handleResolvedLinkError,
        handleResolvedLinkResponse
    ]);
};
var $69b217076914baa8$export$2e2bcd8739ae039 = $69b217076914baa8$var$useResponse;

});
parcelRegister("gA511", function(module, exports) {

$parcel$export(module.exports, "getEmptyJsonLd", () => $af7c5b7c4494ebd5$export$2796a804c6e44f63);
$parcel$export(module.exports, "getUnauthorizedJsonLd", () => $af7c5b7c4494ebd5$export$b9482e0f6d365cc7);
$parcel$export(module.exports, "getForbiddenJsonLd", () => $af7c5b7c4494ebd5$export$e32193033a594efb);
const $af7c5b7c4494ebd5$var$emptyData = {
    '@context': {
        '@vocab': 'https://www.w3.org/ns/activitystreams#',
        atlassian: 'https://schema.atlassian.com/ns/vocabulary#',
        schema: 'http://schema.org/'
    },
    '@type': 'Object'
};
const $af7c5b7c4494ebd5$export$2796a804c6e44f63 = ()=>$af7c5b7c4494ebd5$var$emptyData;
const $af7c5b7c4494ebd5$export$b9482e0f6d365cc7 = ()=>({
        meta: {
            visibility: 'restricted',
            access: 'unauthorized',
            auth: [],
            definitionId: 'provider-not-found'
        },
        data: {
            ...$af7c5b7c4494ebd5$var$emptyData
        }
    });
const $af7c5b7c4494ebd5$export$e32193033a594efb = ()=>({
        meta: {
            visibility: 'restricted',
            access: 'forbidden',
            auth: [],
            definitionId: 'provider-not-found'
        },
        data: {
            ...$af7c5b7c4494ebd5$var$emptyData
        }
    });

});

const $9121cfe34e6487d9$export$297c39c8b9bfca0 = 'resolving';
const $9121cfe34e6487d9$export$b64a888338c24e0e = 'errored';
const $9121cfe34e6487d9$export$677b6edfa0002c70 = 'fallback';
const $9121cfe34e6487d9$export$3e81ce851ffda0ad = 'Provider.authFlow is not set to OAuth2.';
const $9121cfe34e6487d9$export$45e7dda0d43d7f55 = 'Fatal error resolving URL';
const $9121cfe34e6487d9$export$338f7d9ccca1975d = 'Error resolving metadata.';



parcelRegister("CpyFM", function(module, exports) {

$parcel$export(module.exports, "default", () => $7cb2d7fc7fdf8041$export$2e2bcd8739ae039);
const $7cb2d7fc7fdf8041$var$createStatusUpdateRequest = (request, id)=>({
        providerKey: request.providerKey,
        action: {
            ...request.action,
            payload: {
                newStatusId: id
            }
        }
    });
var $7cb2d7fc7fdf8041$export$2e2bcd8739ae039 = $7cb2d7fc7fdf8041$var$createStatusUpdateRequest;

});

parcelRegister("hxkmu", function(module, exports) {

$parcel$export(module.exports, "default", () => $808be4e18c85f3f4$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $axOsj = parcelRequire("axOsj");

var $jdqdp = parcelRequire("jdqdp");

var $eGOwo = parcelRequire("eGOwo");
const $808be4e18c85f3f4$var$withErrorBoundary = (Component)=>(props)=>{
        const fallback = (0, $eJOHy.useMemo)(()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $jdqdp.default), {
                appearance: props?.appearance,
                ...(0, $eGOwo.fg)('platform-component-visual-refresh') ? {
                    isBold: true
                } : undefined,
                testId: `${props?.testId ?? 'smart-element-lozenge-action'}-fallback`,
                children: props?.text
            }), [
            props?.appearance,
            props?.testId,
            props?.text
        ]);
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $axOsj.ErrorBoundary), {
            fallback: fallback,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
                ...props
            })
        });
    };
var $808be4e18c85f3f4$export$2e2bcd8739ae039 = $808be4e18c85f3f4$var$withErrorBoundary;

});

parcelRegister("e9seM", function(module, exports) {

$parcel$export(module.exports, "unknownLoadErrorAnalyticsPayload", () => $20533813e4fe1916$export$2a568ff99500df53);
$parcel$export(module.exports, "permissionLoadErrorAnalyticsPayload", () => $20533813e4fe1916$export$2de2d0ccc17b915f);
$parcel$export(module.exports, "unknownUpdateErrorAnalyticsPayload", () => $20533813e4fe1916$export$c1c05f9d51f7c467);
$parcel$export(module.exports, "validationUpdateErrorAnalyticsPayload", () => $20533813e4fe1916$export$618660b8f2aa87e2);
const $20533813e4fe1916$export$2a568ff99500df53 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'UnknownError',
    step: 'load'
};
const $20533813e4fe1916$export$2de2d0ccc17b915f = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'PermissionError',
    step: 'load'
};
const $20533813e4fe1916$export$c1c05f9d51f7c467 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'UnknownError',
    step: 'update'
};
const $20533813e4fe1916$export$618660b8f2aa87e2 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'ValidationError',
    step: 'update'
};

});

parcelRegister("5iuU7", function(module, exports) {

$parcel$export(module.exports, "default", () => $1bafe1b037124149$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $kDaaB = parcelRequire("kDaaB");

var $jYYbf = parcelRequire("jYYbf");
var $aLJ1L = parcelRequire("aLJ1L");

var $d3cA1 = parcelRequire("d3cA1");

var $eGOwo = parcelRequire("eGOwo");


var $bmWcp = parcelRequire("bmWcp");

var $19nmp = parcelRequire("19nmp");

var $7xssH = parcelRequire("7xssH");

var $fQH39 = parcelRequire("fQH39");
const $1bafe1b037124149$var$MAX_LINE_NUMBER = 8;
const $1bafe1b037124149$var$contentStyles = null;
const $1bafe1b037124149$var$linkStyles = null;
const $1bafe1b037124149$var$textStylesBase = null;
const $1bafe1b037124149$var$dropdownItemGroupStyles = null;
const $1bafe1b037124149$var$LozengeActionError = ({ errorMessage: errorMessage, testId: testId, maxLineNumber: maxLineNumber = $1bafe1b037124149$var$MAX_LINE_NUMBER, invokePreviewAction: invokePreviewAction })=>{
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const invoke = (0, $7xssH.default)({});
    const isPreviewAvailable = invokePreviewAction !== undefined;
    const handlePreviewOpen = (0, $eJOHy.useCallback)(()=>{
        if (isPreviewAvailable) {
            fireEvent('ui.button.clicked.smartLinkStatusOpenPreview', {});
            if (invokePreviewAction) invoke(invokePreviewAction);
        }
    }, [
        isPreviewAvailable,
        invoke,
        invokePreviewAction,
        fireEvent
    ]);
    const dynamicCss = null;
    const content = (0, $eJOHy.useMemo)(()=>{
        return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $eJOHy.Fragment), {
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
                    className: (0, $hcewu.default)([
                        "_zulpu2gc _11c81ixg _1reo15vq _18m915vq _1e0c1txw _1ul9idpf _2lx2vrvc _19pkv77o _4cvr1y6m _pqme2smr _102e2smr _ngc01fxt _1t4p1fxt"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d3cA1))), {
                            testId: `${testId}-icon`,
                            LEGACY_size: "medium",
                            color: `var(--ds-icon-danger, ${(0, $7bb4c1736002a04a$export$2837b5a1a71d5c02)})`,
                            LEGACY_secondaryColor: `var(--ds-background-danger, ${(0, $7bb4c1736002a04a$export$4b84fd0e2c617bd)})`,
                            label: 'error',
                            spacing: "spacious"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                            "data-testid": `${testId}-error-message`,
                            className: (0, $hcewu.default)([
                                "_11c81ixg _1reo15vq _18m915vq _o5724jg8 _1e0ccj1k _1bto1l2s _1nmz1hna _sudp1e54",
                                "_1yyj1n6p _102k16q4"
                            ]),
                            style: {
                                "--_t4prqe": (0, $awdRS.default)(maxLineNumber)
                            },
                            children: typeof errorMessage === 'string' ? errorMessage : (0, $fQH39.getFormattedMessage)(errorMessage)
                        })
                    ]
                }),
                isPreviewAvailable ? /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    className: (0, $hcewu.default)([
                        "_zulpu2gc _1reo15vq _18m915vq _11c82smr _1e0c1txw _1ul9idpf _2lx2vrvc _4cvr1h6o _80omtlke _19pku2gc _18u0xy5q _otyrv77o"
                    ]),
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)("a", {
                        target: "_blank",
                        "data-testid": `${testId}-open-embed`,
                        onClick: handlePreviewOpen,
                        children: (0, $eGOwo.fg)('confluence-issue-terminology-refresh') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                            ...(0, $19nmp.messages).open_issue_in_jiraIssueTermRefresh
                        }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                            ...(0, $19nmp.messages).open_issue_in_jira
                        })
                    })
                }) : null
            ]
        });
    }, [
        errorMessage,
        handlePreviewOpen,
        isPreviewAvailable,
        testId,
        dynamicCss
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-testid": `${testId}-error-item-group`,
        className: (0, $hcewu.default)([
            "_14hp1wdt _6pup1kw7 _1eo073ad"
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aLJ1L.default), {
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jYYbf.default), {
                testId: `${testId}-error`,
                children: content
            })
        })
    });
};
var $1bafe1b037124149$export$2e2bcd8739ae039 = $1bafe1b037124149$var$LozengeActionError;

});
parcelRegister("7xssH", function(module, exports) {

$parcel$export(module.exports, "default", () => $28096ecb360b0e22$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $aXKmr = parcelRequire("aXKmr");

var $bmWcp = parcelRequire("bmWcp");

var $2QXr6 = parcelRequire("2QXr6");

var $1mLfK = parcelRequire("1mLfK");
const $28096ecb360b0e22$var$ACTION_EXPERIENCE_NAME = 'smart-link-action-invocation';
/**
 * Invoke client action such as preview, download and open link
 */ const $28096ecb360b0e22$var$useInvokeClientAction = ({ fireEvent: fireEventProp })=>{
    const { fireEvent: defaultFireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const fireEvent = fireEventProp ?? defaultFireEvent;
    return (0, $eJOHy.useCallback)(async ({ actionSubjectId: actionSubjectId, actionType: actionType, actionFn: actionFn, definitionId: definitionId = null, extensionKey: extensionKey, display: display, id: id, resourceType: resourceType = null })=>{
        const experienceId = (0, (/*@__PURE__*/$parcel$interopDefault($aXKmr)))();
        // Begin performance instrumentation.
        const markName = `${experienceId}-${actionType}`;
        $2QXr6.mark(markName, 'pending');
        try {
            // Begin UFO experience
            (0, $1mLfK.startUfoExperience)($28096ecb360b0e22$var$ACTION_EXPERIENCE_NAME, experienceId, {
                actionType: actionType,
                display: display,
                extensionKey: extensionKey,
                invokeType: 'client'
            });
            // Begin analytics instrumentation.
            if (actionSubjectId !== undefined) fireEvent(`ui.button.clicked.${actionSubjectId}`, {
                actionType: actionType ?? null,
                definitionId: definitionId,
                display: display ?? null,
                id: id ?? experienceId,
                resourceType: resourceType
            });
            // Invoke action
            const result = await actionFn();
            $2QXr6.mark(markName, 'resolved');
            (0, $1mLfK.succeedUfoExperience)($28096ecb360b0e22$var$ACTION_EXPERIENCE_NAME, experienceId);
            fireEvent('operational.smartLinkAction.resolved', {
                actionType: actionType ?? null,
                definitionId: definitionId,
                display: display ?? null,
                duration: $2QXr6.getMeasure(markName, 'resolved')?.duration ?? null,
                id: id ?? experienceId,
                resourceType: resourceType
            });
            return result;
        } catch (err) {
            $2QXr6.mark(markName, 'errored');
            (0, $1mLfK.failUfoExperience)($28096ecb360b0e22$var$ACTION_EXPERIENCE_NAME, experienceId);
            const reason = typeof err === 'string' ? err : err?.message;
            fireEvent('operational.smartLinkAction.unresolved', {
                actionType: actionType ?? null,
                definitionId: definitionId,
                display: display ?? null,
                duration: $2QXr6.getMeasure(markName, 'errored')?.duration ?? null,
                id: id ?? experienceId,
                reason: reason,
                resourceType: resourceType
            });
        }
    }, [
        fireEvent
    ]);
};
var $28096ecb360b0e22$export$2e2bcd8739ae039 = $28096ecb360b0e22$var$useInvokeClientAction;

});
parcelRegister("2QXr6", function(module, exports) {

$parcel$export(module.exports, "clearMarks", () => $a922bc214c753b7c$export$1a717feb4df1a945);
$parcel$export(module.exports, "clearMeasures", () => $a922bc214c753b7c$export$de42547d395c8271);
$parcel$export(module.exports, "getMeasure", () => $a922bc214c753b7c$export$d6e97a903ae9a3aa);
$parcel$export(module.exports, "mark", () => $a922bc214c753b7c$export$bf7f2fce5c1cf636);
$parcel$export(module.exports, "create", () => $a922bc214c753b7c$export$185802fd694ee1f5);
const $a922bc214c753b7c$var$isPerformanceAPIAvailable = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && [
        'measure',
        'clearMeasures',
        'clearMarks',
        'getEntriesByName',
        'getEntriesByType'
    ].every((api)=>!!performance[api]);
};
const $a922bc214c753b7c$var$hasPerformanceAPIAvailable = $a922bc214c753b7c$var$isPerformanceAPIAvailable();
const $a922bc214c753b7c$export$fcff3185c7ce7f2b = (id, status)=>`${status}:${id}`;
const $a922bc214c753b7c$export$984df7f61dd7928f = (id, status)=>`time-to-${status}:${id}`;
const $a922bc214c753b7c$export$1a717feb4df1a945 = (id)=>{
    if ($a922bc214c753b7c$var$hasPerformanceAPIAvailable) {
        const marks = performance.getEntriesByType('mark').filter((mark)=>mark.name.includes(id));
        marks.forEach((mark)=>performance.clearMarks(mark.name));
    }
};
const $a922bc214c753b7c$export$de42547d395c8271 = (id)=>{
    if ($a922bc214c753b7c$var$hasPerformanceAPIAvailable) {
        const measures = performance.getEntriesByType('measure').filter((measure)=>measure.name.includes(id));
        measures.forEach((measure)=>performance.clearMeasures(measure.name));
    }
};
const $a922bc214c753b7c$var$getMark = (id, status)=>{
    if ($a922bc214c753b7c$var$hasPerformanceAPIAvailable) {
        const name = $a922bc214c753b7c$export$fcff3185c7ce7f2b(id, status);
        const marks = performance.getEntriesByName(name);
        if (marks.length > 0) return marks[0];
        return undefined;
    }
};
const $a922bc214c753b7c$export$d6e97a903ae9a3aa = (id, status)=>{
    if ($a922bc214c753b7c$var$hasPerformanceAPIAvailable) {
        const name = $a922bc214c753b7c$export$984df7f61dd7928f(id, status);
        const measures = performance.getEntriesByName(name);
        if (measures.length > 0) return measures[0];
        return undefined;
    }
};
const $a922bc214c753b7c$export$bf7f2fce5c1cf636 = (id, status)=>{
    if ($a922bc214c753b7c$var$hasPerformanceAPIAvailable) {
        const name = $a922bc214c753b7c$export$fcff3185c7ce7f2b(id, status);
        performance.mark(name);
    }
};
const $a922bc214c753b7c$export$185802fd694ee1f5 = (id, status)=>{
    if ($a922bc214c753b7c$var$hasPerformanceAPIAvailable) {
        const name = $a922bc214c753b7c$export$984df7f61dd7928f(id, status);
        const measure = $a922bc214c753b7c$export$d6e97a903ae9a3aa(id, status);
        if (!measure) {
            const startMark = $a922bc214c753b7c$var$getMark(id, 'pending');
            const endMark = $a922bc214c753b7c$var$getMark(id, status);
            if (startMark && endMark) performance.measure(name, startMark.name, endMark.name);
        }
    }
};

});



parcelRegister("4dVhH", function(module, exports) {

$parcel$export(module.exports, "LozengeActionErrorMessages", () => $d6614d1ef8f5be72$export$4f2e371a667ad688);

var $19nmp = parcelRequire("19nmp");
const $d6614d1ef8f5be72$export$4f2e371a667ad688 = {
    noData: {
        descriptor: (0, $19nmp.messages)['status_change_permission_error']
    },
    noDataIssueTermRefresh: {
        descriptor: (0, $19nmp.messages)['status_change_permission_errorIssueTermRefresh']
    },
    unknown: {
        descriptor: (0, $19nmp.messages)['status_change_load_error']
    },
    updateFailed: {
        descriptor: (0, $19nmp.messages)['status_change_update_error']
    }
};

});

parcelRegister("htuxE", function(module, exports) {

$parcel$export(module.exports, "default", () => $df529be6a716333d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $aLJ1L = parcelRequire("aLJ1L");

var $aDuBe = parcelRequire("aDuBe");
const $df529be6a716333d$var$dropdownItemGroupStyles = null;
const $df529be6a716333d$var$LozengeActionItemsGroup = ({ items: items, testId: testId, onClick: onClick })=>/*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-testid": `${testId}-item-group`,
        className: (0, $hcewu.default)([
            "_c71l1mjv _18m91wug _1pv01r31 _1m1b1r31 _qh55glyw _lt2aglyw _ph3k1o36 _1twe1o36 _1ll7166n _qprf166n _n6y8usvi _109gusvi _z29hu4to _wlxpu4to _1gfl12x7 _yhjmutpp _1gqn12x7 _11lvutpp _d4lf1f4h _14hp1wdt _6pup1kw7"
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aLJ1L.default), {
            children: items.map((item, idx)=>/*#__PURE__*/ (0, $eJOHy.createElement)((0, $aDuBe.default), {
                    ...item,
                    key: idx,
                    onClick: onClick,
                    testId: `${testId}-item-${idx}`
                }))
        })
    });
var $df529be6a716333d$export$2e2bcd8739ae039 = $df529be6a716333d$var$LozengeActionItemsGroup;

});
parcelRegister("aDuBe", function(module, exports) {

$parcel$export(module.exports, "default", () => $f377c3a55bec1fd7$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $jYYbf = parcelRequire("jYYbf");

var $jdqdp = parcelRequire("jdqdp");

var $eGOwo = parcelRequire("eGOwo");
const $f377c3a55bec1fd7$var$LozengeActionItem = ({ appearance: appearance, id: id, onClick: onClick, testId: testId, text: text })=>{
    const handleClick = (0, $eJOHy.useCallback)((e)=>{
        // Prevent dropdown to close on select item.
        // We want to show loading screen.
        e.stopPropagation();
        if (onClick) onClick(id, text, appearance);
    }, [
        appearance,
        id,
        onClick,
        text
    ]);
    const handleMouseEnter = (0, $eJOHy.useCallback)((e)=>{
        e.currentTarget?.firstElementChild?.focus();
    }, []);
    return(// eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        onMouseEnter: handleMouseEnter,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jYYbf.default), {
            onClick: handleClick,
            testId: testId,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jdqdp.default), {
                appearance: appearance,
                ...(0, $eGOwo.fg)('platform-component-visual-refresh') ? {
                    isBold: true
                } : undefined,
                children: text
            })
        })
    }));
};
var $f377c3a55bec1fd7$export$2e2bcd8739ae039 = $f377c3a55bec1fd7$var$LozengeActionItem;

});


parcelRegister("dsXZb", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d29b99195ec403c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $k0ahr = parcelRequire("k0ahr");

var $5lAAn = parcelRequire("5lAAn");

var $5NHPZ = parcelRequire("5NHPZ");

var $jdqdp = parcelRequire("jdqdp");

var $eGOwo = parcelRequire("eGOwo");

var $8IeH1 = parcelRequire("8IeH1");
const $8d29b99195ec403c$var$styles = {
    chevronDown: "_18u012x7 _1e0c1txw",
    lozengeContainer: "_kkk2n7od _2rkoiti9 _1dqonqa1 _189ee4h9 _1h6d3acm _bfhk18uv _1e0c1txw _4cvr1h6o _4t3i7vkz",
    lozengeContainerSelected: "_1reo15vq _18m915vq _1h6d1p6i"
};
const $8d29b99195ec403c$var$triggerLozengeStyles = null;
const $8d29b99195ec403c$var$triggerButtonStyles = null;
const $8d29b99195ec403c$var$LozengeActionTriggerOld = ({ appearance: appearance, isOpen: isOpen, testId: testId, text: text, triggerRef: triggerRef, ...props })=>{
    const [isBold, setIsBold] = (0, $eJOHy.useState)(false);
    const onMouseEnter = (0, $eJOHy.useCallback)(()=>setIsBold(true), []);
    const onMouseLeave = (0, $eJOHy.useCallback)(()=>setIsBold(false), []);
    const lozenge = (0, $eJOHy.useMemo)(()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $jdqdp.default), {
            appearance: appearance,
            isBold: (0, $eGOwo.fg)('platform-component-visual-refresh') ? true : isBold,
            children: /*#__PURE__*/ (0, $gt9Am.jsxs)("span", {
                className: (0, $hcewu.default)([
                    "_4cvr1h6o _1e0c1txw"
                ]),
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                        children: text
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                        as: "span",
                        xcss: $8d29b99195ec403c$var$styles.chevronDown,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5lAAn))), {
                            color: "currentColor",
                            label: "options",
                            LEGACY_size: "medium",
                            LEGACY_margin: "-4px -8px -4px -7px",
                            size: "small"
                        })
                    })
                ]
            })
        }), [
        appearance,
        isBold,
        text
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("button", {
        type: "button",
        ...props,
        "data-action-open": isOpen,
        "data-testid": `${testId}--trigger`,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        ref: triggerRef,
        className: (0, $hcewu.default)([
            "_kkk2n7od _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _15vhn7od _1dqonqa1 _189eyh40 _1h6d3acm _bfhk18uv _syazn7od _80omtlke _ect4n7od _1wybn7od _zg8ln7od _k48pn7od _vwz4idpf _1p1dn7od _19pkv77o _2hwxv77o _otyrv77o _18u0v77o _mizu1r31 _1guj1r31 _p8tl1r31 _ra3xglyw _pbhaglyw _1q2vglyw _128m1o36 _11ow1o36 _j8b81o36 _1bas14y2 _19h614y2 _1d3914y2 _1ejj1vm4 _1u6l1vm4 _6ssh1vm4"
        ]),
        children: lozenge
    });
};
const $8d29b99195ec403c$var$LozengeActionTrigger = ({ appearance: appearance, isOpen: isOpen, testId: testId, text: text, triggerRef: triggerRef, ...props })=>{
    const [isHovering, setIsHovering] = (0, $eJOHy.useState)(false);
    const [isPressing, setIsPressing] = (0, $eJOHy.useState)(false);
    const [lozengeBackgroundColor, setLozengeBackgroundColor] = (0, $eJOHy.useState)(undefined);
    const [lozengeForegroundColor, setLozengeForegroundColor] = (0, $eJOHy.useState)(undefined);
    const onMouseEnter = (0, $eJOHy.useCallback)(()=>setIsHovering(true), []);
    const onMouseLeave = (0, $eJOHy.useCallback)(()=>setIsHovering(false), []);
    const onMouseOrKeyDown = (0, $eJOHy.useCallback)(()=>setIsPressing(true), []);
    const onMouseOrKeyUp = (0, $eJOHy.useCallback)(()=>setIsPressing(false), []);
    (0, $eJOHy.useEffect)(()=>{
        if (isPressing) {
            setLozengeBackgroundColor("var(--ds-background-selected-pressed, #85B8FF)");
            setLozengeForegroundColor("var(--ds-text-selected, #0C66E4)");
        } else if (isOpen) {
            if (isHovering) setLozengeBackgroundColor("var(--ds-background-selected-hovered, #CCE0FF)");
            else setLozengeBackgroundColor("var(--ds-background-selected, #E9F2FF)");
            setLozengeForegroundColor("var(--ds-text-selected, #0C66E4)");
        } else {
            setLozengeBackgroundColor(undefined);
            setLozengeForegroundColor(undefined);
        }
    }, [
        isPressing,
        isOpen,
        isHovering
    ]);
    const lozenge = (0, $eJOHy.useMemo)(()=>{
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
            xcss: (0, $k0ahr.cx)($8d29b99195ec403c$var$styles.lozengeContainer, (isOpen || isPressing) && $8d29b99195ec403c$var$styles.lozengeContainerSelected),
            as: "span",
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jdqdp.default), {
                appearance: appearance,
                isBold: (0, $eGOwo.fg)('platform-component-visual-refresh') ? true : isHovering,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                style: {
                    backgroundColor: lozengeBackgroundColor,
                    color: lozengeForegroundColor
                },
                children: /*#__PURE__*/ (0, $gt9Am.jsxs)("span", {
                    className: (0, $hcewu.default)([
                        "_4cvr1h6o _1e0c1txw"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                            children: text
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                            as: "span",
                            xcss: $8d29b99195ec403c$var$styles.chevronDown,
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5lAAn))), {
                                color: "currentColor",
                                label: "options",
                                LEGACY_size: "medium",
                                LEGACY_margin: "-4px -8px -4px -7px",
                                size: "small"
                            })
                        })
                    ]
                })
            })
        });
    }, [
        appearance,
        isHovering,
        isPressing,
        text,
        isOpen,
        lozengeBackgroundColor,
        lozengeForegroundColor
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("button", {
        type: "button",
        ...props,
        "data-action-open": isOpen,
        "data-testid": `${testId}--trigger`,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onMouseDown: onMouseOrKeyDown,
        onMouseUp: onMouseOrKeyUp,
        onKeyDown: onMouseOrKeyDown,
        onKeyUp: onMouseOrKeyUp,
        ref: triggerRef,
        className: (0, $hcewu.default)([
            "_kkk2n7od _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _15vhn7od _1dqonqa1 _189eyh40 _1h6d3acm _bfhk18uv _syazn7od _80omtlke _ect4n7od _1wybn7od _zg8ln7od _k48pn7od _vwz4idpf _1p1dn7od _19pkv77o _2hwxv77o _otyrv77o _18u0v77o _mizu1r31 _1guj1r31 _p8tl1r31 _ra3xglyw _pbhaglyw _1q2vglyw _128m1o36 _11ow1o36 _j8b81o36 _1bas14y2 _19h614y2 _1d3914y2 _1ejj1vm4 _1u6l1vm4 _6ssh1vm4"
        ]),
        children: lozenge
    });
};
var $8d29b99195ec403c$export$2e2bcd8739ae039 = (0, $5NHPZ.withFeatureFlaggedComponent)($8d29b99195ec403c$var$LozengeActionTriggerOld, $8d29b99195ec403c$var$LozengeActionTrigger, ()=>(0, $eGOwo.fg)('platform-linking-visual-refresh-v2'));

});
parcelRegister("5NHPZ", function(module, exports) {

$parcel$export(module.exports, "withFeatureFlaggedComponent", () => $1367e932164137d3$export$55dba0d8ccf3da86);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
const $1367e932164137d3$export$55dba0d8ccf3da86 = (ComponentOld, ComponentNext, featureFlagFn)=>{
    return (props)=>{
        // copied from packages/editor/editor-common/src/utils/withFeatureFlaggedComponent.tsx
        // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return featureFlagFn() ? /*#__PURE__*/ (0, $gt9Am.jsx)(ComponentNext, {
            ...props
        }) : /*#__PURE__*/ (0, $gt9Am.jsx)(ComponentOld, {
            ...props
        });
    };
};

});





parcelRegister("kB4Nm", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e36aa41e9ad3ded$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4XCp5 = parcelRequire("4XCp5");
const $9e36aa41e9ad3ded$var$LatestCommitElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $4XCp5.toBadgeProps)(context.latestCommit?.toString()) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4XCp5.default), {
        icon: (0, $5NtHI.IconType).Commit,
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).LatestCommit
    }) : null;
};
var $9e36aa41e9ad3ded$export$2e2bcd8739ae039 = $9e36aa41e9ad3ded$var$LatestCommitElement;

});

parcelRegister("jPfaa", function(module, exports) {

$parcel$export(module.exports, "default", () => $3002c31f53401640$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $d6nZP = parcelRequire("d6nZP");
const $3002c31f53401640$var$LinkIconElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    if (!context) return null;
    if ((0, $eGOwo.fg)('platform-linking-visual-refresh-v2')) {
        const data = (0, $d6nZP.toLinkIconProps)(context?.linkIcon, context.type);
        return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $d6nZP.default), {
            ...data,
            ...props,
            name: (0, $5NtHI.ElementName).LinkIcon
        }) : null;
    }
    const data = typeof context?.linkIcon === 'object' ? context?.linkIcon : undefined;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $d6nZP.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).LinkIcon
    }) : null;
};
var $3002c31f53401640$export$2e2bcd8739ae039 = $3002c31f53401640$var$LinkIconElement;

});
parcelRegister("d6nZP", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a220f00187bff59$export$2e2bcd8739ae039);
$parcel$export(module.exports, "toLinkIconProps", () => $7a220f00187bff59$export$6d33abd591a3f700);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @compiled/shorthand-property-sorting */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $av9Of = parcelRequire("av9Of");

var $eGOwo = parcelRequire("eGOwo");

var $8IeH1 = parcelRequire("8IeH1");

var $5NtHI = parcelRequire("5NtHI");

var $FoFt2 = parcelRequire("FoFt2");

var $b4zhV = parcelRequire("b4zhV");

var $67ulW = parcelRequire("67ulW");

var $fQH39 = parcelRequire("fQH39");
const $7a220f00187bff59$var$styles = {
    container: "_1ul91ns9",
    iconWrapperStyle: "_1e0c1txw _4cvr1h6o _1bah1h6o"
};
const $7a220f00187bff59$var$positionStyleMap = {
    center: "_1wpz1h6o",
    top: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wpz1y6m"
};
const $7a220f00187bff59$var$customRenderStyleMap = {
    xlarge: "_1reo15vq _18m915vq _11c8nf1z _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _1xjx1osq _e2oo1osq _102kz42d",
    large: "_1reo15vq _18m915vq _11c8nf1z _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _1xjx1osq _e2oo1osq _102kz42d",
    medium: "_1reo15vq _18m915vq _11c8nbxd _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _1xjx1osq _e2oo1osq _102kptym",
    small: "_1reo15vq _18m915vq _11c8nbxd _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _1xjx1osq _e2oo1osq _102kptym"
};
const $7a220f00187bff59$var$renderAtlaskitIcon = (icon, testId, size = (0, $5NtHI.SmartLinkSize).Medium)=>{
    if (icon) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $b4zhV.default), {
        icon: icon,
        testId: `${testId}-icon`,
        "aria-hidden": "true",
        label: "" // Since we already set aria-hidden="true", the label should be given an empty string
        ,
        size: size
    });
};
const $7a220f00187bff59$var$renderDefaultIcon = (label, testId)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($av9Of))), {
        label: label,
        testId: `${testId}-default`,
        color: "currentColor"
    });
const $7a220f00187bff59$var$renderImageIcon = (defaultIcon, url, testId, size = (0, $5NtHI.SmartLinkSize).Medium, appearance, hideLoadingSkeleton)=>{
    const width = size === (0, $5NtHI.SmartLinkSize).Large ? "var(--ds-space-300, 24px)" : "var(--ds-space-200, 16px)";
    if (url) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $67ulW.default), {
        defaultIcon: defaultIcon,
        testId: testId,
        url: url,
        width: width,
        height: width,
        ...(0, $eGOwo.fg)('platform-linking-visual-refresh-v2') && {
            appearance: appearance
        },
        hideLoadingSkeleton: hideLoadingSkeleton
    });
};
/**
 * A base element that displays an Icon or favicon.
 * @internal
 * @param props - The props necessary for the Icon element.
 * @see LinkIcon
 */ const $7a220f00187bff59$var$IconElement = ({ icon: icon, overrideIcon: overrideIcon, label: label = 'Link', name: name, position: position = (0, $5NtHI.SmartLinkPosition).Top, className: className, render: render, size: size = (0, $5NtHI.SmartLinkSize).Medium, testId: testId = 'smart-element-icon', url: url, appearance: appearance = 'square', hideLoadingSkeleton: hideLoadingSkeleton })=>{
    const element = (0, $eJOHy.useMemo)(()=>{
        const defaultIcon = $7a220f00187bff59$var$renderDefaultIcon(label, testId);
        return overrideIcon || render?.() || $7a220f00187bff59$var$renderImageIcon(defaultIcon, url, testId, size, (0, $eGOwo.fg)('platform-linking-visual-refresh-v2') ? appearance : undefined, hideLoadingSkeleton) || $7a220f00187bff59$var$renderAtlaskitIcon(icon, testId, size) || defaultIcon;
    }, [
        label,
        testId,
        overrideIcon,
        render,
        url,
        size,
        appearance,
        hideLoadingSkeleton,
        icon
    ]);
    const width = (0, $fQH39.getIconWidth)(size);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-smart-element": name,
        "data-smart-element-icon": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            $7a220f00187bff59$var$styles.container,
            $7a220f00187bff59$var$positionStyleMap[position],
            render && $7a220f00187bff59$var$customRenderStyleMap[size],
            className
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
            xcss: $7a220f00187bff59$var$styles.iconWrapperStyle,
            style: {
                width: width,
                height: width
            },
            children: element
        })
    });
};
var $7a220f00187bff59$export$2e2bcd8739ae039 = $7a220f00187bff59$var$IconElement;
const $7a220f00187bff59$export$6d33abd591a3f700 = (data, type)=>{
    const isDataLinkIcon = (_data)=>{
        return typeof _data === 'object' && _data !== null && ('icon' in _data || 'url' in _data);
    };
    if (!isDataLinkIcon(data)) return typeof data === 'object' ? data : undefined;
    const isImageRound = (0, $FoFt2.isProfileType)(type);
    return {
        ...data,
        appearance: isImageRound ? 'round' : 'square'
    };
};

});


parcelRegister("2Bqsd", function(module, exports) {

$parcel$export(module.exports, "default", () => $684e70f9d4a0e20c$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $8ygPC = parcelRequire("8ygPC");
const $684e70f9d4a0e20c$var$LocationElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context?.location ?? null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8ygPC.default), {
        theme: (0, $5NtHI.SmartLinkInternalTheme).Grey,
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).Location
    }) : null;
};
var $684e70f9d4a0e20c$export$2e2bcd8739ae039 = $684e70f9d4a0e20c$var$LocationElement;

});
parcelRegister("8ygPC", function(module, exports) {

$parcel$export(module.exports, "default", () => $adbc5d7a57662063$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @compiled/shorthand-property-sorting */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $k71qx = parcelRequire("k71qx");

var $5NtHI = parcelRequire("5NtHI");

var $e3qu2 = parcelRequire("e3qu2");

var $fQH39 = parcelRequire("fQH39");
const $adbc5d7a57662063$var$DEFAULT_MAX_LINES = 2;
const $adbc5d7a57662063$var$MAXIMUM_MAX_LINES = 2;
const $adbc5d7a57662063$var$MINIMUM_MAX_LINES = 1;
const $adbc5d7a57662063$var$containerStyles = null;
const $adbc5d7a57662063$var$getMaxLines = (maxLines)=>{
    if (maxLines > $adbc5d7a57662063$var$MAXIMUM_MAX_LINES) return $adbc5d7a57662063$var$DEFAULT_MAX_LINES;
    if (maxLines < $adbc5d7a57662063$var$MINIMUM_MAX_LINES) return $adbc5d7a57662063$var$MINIMUM_MAX_LINES;
    return maxLines;
};
const $adbc5d7a57662063$var$withTooltip = (trigger, content, testId)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
        content: content,
        testId: `${testId}-tooltip`,
        tag: "span",
        children: trigger
    });
const $adbc5d7a57662063$var$linkStyleSizeMap = {
    xlarge: "_11c8lodh _k48pi7a9 _vwz41k8s",
    large: "_11c82smr _k48pi7a9 _vwz41j6v",
    medium: "_11c82smr _k48pi7a9 _vwz41j6v",
    small: "_11c8dcr7 _k48pi7a9 _vwz41j6v"
};
const $adbc5d7a57662063$var$baseAnchorStyle = null;
const $adbc5d7a57662063$var$workBreakStyleMap = {
    true: "_1nmz1hna",
    false: "_1nmz9jpi"
};
const $adbc5d7a57662063$var$anchorConstantsStyles = null;
const $adbc5d7a57662063$var$anchorLineClampMap = {
    1: "_1yyjkb7n",
    2: "_1yyjcs5v"
};
const $adbc5d7a57662063$var$anchorLinkLineHeight1Map = {
    xlarge: "_102k1k8s",
    large: "_102k1j6v",
    medium: "_102k1j6v",
    small: "_102k1j6v"
};
const $adbc5d7a57662063$var$anchorLinkLineHeight2Map = {
    xlarge: "_102k1wto",
    large: "_102kviql",
    medium: "_102kviql",
    small: "_102kviql"
};
const $adbc5d7a57662063$var$themeStyleMap = {
    grey: "_fjv618uv _93u918uv _g2lk18uv _pnzf18uv _hlwq8stv _1e2m8stv _1l4b8stv _ue8d8stv _yni7nqa1 _1bianqa1 _93jhnqa1 _64n6nqa1 _1ray131l _dlb7131l _rnxt131l _1h4d131l _10uedcr7 _ye10131l",
    black: "_syaz1gjq _9oik18uv _1bnx8stv _jf4cnqa1 _30l31gjq _9h8h1fxt",
    link: "_syaz14q2 _9oik18uv _1bnx8stv _jf4cnqa1 _30l314q2 _9h8h16c2"
};
/**
 * A base element that represent an anchor.
 * @internal
 * @param {BaseLinkElementProps} BaseLinkElementProps - The props necessary for the Link element.
 * @see LinkIcon
 */ const $adbc5d7a57662063$var$BaseLinkElement = ({ hideTooltip: hideTooltip, maxLines: maxLines = $adbc5d7a57662063$var$DEFAULT_MAX_LINES, name: name, className: className, size: size = (0, $5NtHI.SmartLinkSize).Medium, testId: testId = 'smart-element-link', text: text, theme: theme = (0, $5NtHI.SmartLinkTheme).Link, url: url, onClick: onClick, target: target = '_blank', anchorRef: anchorRef })=>{
    const onMouseDown = (0, $e3qu2.useMouseDownEvent)();
    const hasSpace = (0, $eJOHy.useMemo)(()=>text ? (0, $fQH39.hasWhiteSpace)(text) : false, [
        text
    ]);
    const anchor = /*#__PURE__*/ (0, $gt9Am.jsx)("a", {
        "data-smart-element": name,
        "data-smart-element-link": true,
        "data-testid": testId,
        onClick: onClick,
        onMouseDown: onMouseDown,
        href: url,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug",
            $adbc5d7a57662063$var$linkStyleSizeMap[size],
            $adbc5d7a57662063$var$anchorLineClampMap[$adbc5d7a57662063$var$getMaxLines(maxLines)],
            "_1reo15vq _18m915vq _1e0ccj1k _1bto1l2s _sudp1e54",
            $adbc5d7a57662063$var$workBreakStyleMap[hasSpace ? 'true' : 'false'],
            $adbc5d7a57662063$var$getMaxLines(maxLines) === 1 && $adbc5d7a57662063$var$anchorLinkLineHeight1Map[size],
            $adbc5d7a57662063$var$getMaxLines(maxLines) === 2 && $adbc5d7a57662063$var$anchorLinkLineHeight2Map[size],
            $adbc5d7a57662063$var$themeStyleMap[theme],
            className
        ]),
        ...target !== '_self' && {
            target: target
        },
        ref: anchorRef,
        children: text
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug"
        ]),
        children: hideTooltip || text === undefined ? anchor : $adbc5d7a57662063$var$withTooltip(anchor, text, testId)
    });
};
var $adbc5d7a57662063$export$2e2bcd8739ae039 = $adbc5d7a57662063$var$BaseLinkElement;
const $adbc5d7a57662063$export$d58e465a9e5297f4 = (text, url)=>{
    return text ? {
        text: text,
        url: url
    } : undefined;
};

});


parcelRegister("1FNi6", function(module, exports) {

$parcel$export(module.exports, "default", () => $59cc5cb27d2f6980$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $38cBa = parcelRequire("38cBa");
const $59cc5cb27d2f6980$var$ModifiedByElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $38cBa.toFormattedTextProps)((0, $19nmp.messages).modified_by, context.modifiedBy) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).ModifiedBy
    }) : null;
};
var $59cc5cb27d2f6980$export$2e2bcd8739ae039 = $59cc5cb27d2f6980$var$ModifiedByElement;

});

parcelRegister("81kl8", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b4cff059a6d0796$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $aKX5a = parcelRequire("aKX5a");
const $5b4cff059a6d0796$var$ModifiedOnElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $aKX5a.toDateTimeProps)('modified', context.modifiedOn) : null;
    const { onRender: onRender, ...restProps } = props || {};
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if ((0, $eGOwo.fg)('platform-linking-additional-flexible-element-props')) // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eJOHy.useEffect)(()=>{
        onRender?.(!!data);
    }, [
        data,
        onRender
    ]);
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aKX5a.default), {
        ...data,
        ...restProps,
        name: (0, $5NtHI.ElementName).ModifiedOn
    }) : null;
};
var $5b4cff059a6d0796$export$2e2bcd8739ae039 = $5b4cff059a6d0796$var$ModifiedOnElement;

});

parcelRegister("946bQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $36681a63387d26b9$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $38cBa = parcelRequire("38cBa");
const $36681a63387d26b9$var$OwnedByElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const { onRender: onRender, textPrefix: textPrefix = 'owned_by', ...restProps } = props || {};
    const data = context ? (0, $38cBa.toFormattedTextProps)((0, $eGOwo.fg)('bandicoots-smart-card-teamwork-context') ? (0, $19nmp.messages)[textPrefix] : (0, $19nmp.messages).owned_by, context?.ownedBy) : null;
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if ((0, $eGOwo.fg)('platform-linking-additional-flexible-element-props')) // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eJOHy.useEffect)(()=>{
        onRender?.(!!data);
    }, [
        data,
        onRender
    ]);
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
        ...data,
        ...restProps,
        name: (0, $5NtHI.ElementName).OwnedBy
    }) : null;
};
var $36681a63387d26b9$export$2e2bcd8739ae039 = $36681a63387d26b9$var$OwnedByElement;

});

parcelRegister("4Nd99", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0ab17b3f9ac16f4$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $vUns3 = parcelRequire("vUns3");
const $d0ab17b3f9ac16f4$var$OwnedByGroupElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $vUns3.toAvatarGroupProps)(context.ownedByGroup, false) : null;
    const { onRender: onRender, ...restProps } = props || {};
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if ((0, $eGOwo.fg)('platform-linking-additional-flexible-element-props')) // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eJOHy.useEffect)(()=>{
        onRender?.(!!data);
    }, [
        data,
        onRender
    ]);
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $vUns3.default), {
        ...data,
        ...restProps,
        name: (0, $5NtHI.ElementName).OwnedByGroup
    }) : null;
};
var $d0ab17b3f9ac16f4$export$2e2bcd8739ae039 = $d0ab17b3f9ac16f4$var$OwnedByGroupElement;

});

parcelRegister("7Byzo", function(module, exports) {

$parcel$export(module.exports, "default", () => $4cb8c392c94261f3$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4YO5T = parcelRequire("4YO5T");
const $4cb8c392c94261f3$var$PreviewElement = (props)=>{
    const { overrideUrl: overrideUrl, ...rest } = props ?? {};
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = overrideUrl ? {
        url: overrideUrl,
        type: (0, $5NtHI.MediaType).Image
    } : context?.preview;
    if (!data) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4YO5T.default), {
        ...rest,
        ...data
    });
};
var $4cb8c392c94261f3$export$2e2bcd8739ae039 = $4cb8c392c94261f3$var$PreviewElement;

});
parcelRegister("4YO5T", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7eb4202b966638f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $67ulW = parcelRequire("67ulW");
/**
 * Media: Image
 * [aspect-ratio: 16 / 9] The context box is fixed to aspect ratio of 16:9.
 * [object-fit: cover] The replaced content is sized to maintain
 * its aspect ratio while filling the element's entire content box.
 * If the object's aspect ratio does not match the aspect ratio of its box,
 * then the object will be clipped to fit.
 * [object-position] Center alignment of the selected replaced element's
 * contents within the element's box.
 */ const $d7eb4202b966638f$var$styles = null;
/**
 * A base element that displays a Media.
 * @internal
 * @param props - The props necessary for the Media element.
 */ const $d7eb4202b966638f$var$MediaElement = ({ name: name, className: className, testId: testId = 'smart-element-media', type: type, url: url, onLoad: onLoad, onError: onError })=>{
    if (!type || !url) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-smart-element": name,
        "data-smart-element-media": type,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_1h1tcq2i _1e0c1txw _1bsb1osq _4t3i1ns9 _jqez1osq _1lg71osq _6slq1osq _x1m21osq _1chb1osq _1usb1osq _5c331osq _l9z01osq _6o691dfr _vr2g1dfr _173baqso _1niwaqso _t0h9stnw _1ulbstnw _byj21ooe _3hvr1ooe _1c0s1ssb _15j31ssb _1npy1ssb _19he1ssb _n3vc1wug _1qj91wug _4fdy1wug _18cv1wug _1aoq15vq _1iqz15vq _6fioj63w _l0jmidpf _12zuh2mm",
            className
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $67ulW.default), {
            testId: `${testId}-image`,
            url: url,
            onError: onError,
            onLoad: onLoad,
            defaultIcon: null
        })
    });
};
var $d7eb4202b966638f$export$2e2bcd8739ae039 = $d7eb4202b966638f$var$MediaElement;

});


parcelRegister("5kUaD", function(module, exports) {

$parcel$export(module.exports, "default", () => $8cb8efb6535893df$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4XCp5 = parcelRequire("4XCp5");
const $8cb8efb6535893df$var$PriorityElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context?.priority ?? null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4XCp5.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).Priority
    }) : null;
};
var $8cb8efb6535893df$export$2e2bcd8739ae039 = $8cb8efb6535893df$var$PriorityElement;

});

parcelRegister("8MxlB", function(module, exports) {

$parcel$export(module.exports, "default", () => $12bbc9fa6baf6ce0$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4XCp5 = parcelRequire("4XCp5");
const $12bbc9fa6baf6ce0$var$ProgrammingLanguageElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $4XCp5.toBadgeProps)(context.programmingLanguage) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4XCp5.default), {
        icon: (0, $5NtHI.IconType).ProgrammingLanguage,
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).ProgrammingLanguage
    }) : null;
};
var $12bbc9fa6baf6ce0$export$2e2bcd8739ae039 = $12bbc9fa6baf6ce0$var$ProgrammingLanguageElement;

});

parcelRegister("lwvSM", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c70b57958761eec$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4XCp5 = parcelRequire("4XCp5");
const $1c70b57958761eec$var$ReactCountElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $4XCp5.toBadgeProps)(context.reactCount?.toString()) : null;
    const { onRender: onRender, ...restProps } = props || {};
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if ((0, $eGOwo.fg)('platform-linking-additional-flexible-element-props')) // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eJOHy.useEffect)(()=>{
        onRender?.(!!data);
    }, [
        data,
        onRender
    ]);
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4XCp5.default), {
        icon: (0, $5NtHI.IconType).React,
        ...data,
        ...restProps,
        name: (0, $5NtHI.ElementName).ReactCount
    }) : null;
};
var $1c70b57958761eec$export$2e2bcd8739ae039 = $1c70b57958761eec$var$ReactCountElement;

});

parcelRegister("2ITMK", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2d9d65227b56648$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $38cBa = parcelRequire("38cBa");
const $b2d9d65227b56648$var$ReadTimeElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $38cBa.toFormattedTextProps)((0, $19nmp.messages).read_time, context.readTime) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).ReadTime
    }) : null;
};
var $b2d9d65227b56648$export$2e2bcd8739ae039 = $b2d9d65227b56648$var$ReadTimeElement;

});

parcelRegister("iw2r2", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e6bf42d4a97c401$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $aKX5a = parcelRequire("aKX5a");
const $0e6bf42d4a97c401$var$SentOnElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $aKX5a.toDateTimeProps)('sent', context.sentOn) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aKX5a.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).SentOn
    }) : null;
};
var $0e6bf42d4a97c401$export$2e2bcd8739ae039 = $0e6bf42d4a97c401$var$SentOnElement;

});

parcelRegister("f7w3l", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5970e5c744f439f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $5FRJ8 = parcelRequire("5FRJ8");

var $38cBa = parcelRequire("38cBa");
const $b5970e5c744f439f$var$SNIPPET_DEFAULT_MAX_LINES = 3;
const $b5970e5c744f439f$var$snippetBaseStyle = null;
const $b5970e5c744f439f$var$SnippetElement = (props)=>{
    const { content: overrideContent, maxLines: maxLines = $b5970e5c744f439f$var$SNIPPET_DEFAULT_MAX_LINES, className: className, ...restOfProps } = props ?? {};
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
        content: overrideContent ?? context?.snippet,
        maxLines: maxLines,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_syaz1fxt _1ul9idpf _181u1kdv _1rkw1kdv _te171kdv _uizt1kdv",
            className
        ]),
        ...restOfProps
    });
};
var $b5970e5c744f439f$export$2e2bcd8739ae039 = $b5970e5c744f439f$var$SnippetElement;

});

parcelRegister("6Po2h", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7164a95a609845f$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $38cBa = parcelRequire("38cBa");
const $f7164a95a609845f$var$SourceBranchElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $38cBa.toTextProps)(context.sourceBranch) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).SourceBranch
    }) : null;
};
var $f7164a95a609845f$export$2e2bcd8739ae039 = $f7164a95a609845f$var$SourceBranchElement;

});

parcelRegister("4U5iq", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd8773a8f5d6e97c$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $cmzNL = parcelRequire("cmzNL");
const $cd8773a8f5d6e97c$var$StateElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context?.state ?? null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cmzNL.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).State
    }) : null;
};
var $cd8773a8f5d6e97c$export$2e2bcd8739ae039 = $cd8773a8f5d6e97c$var$StateElement;

});

parcelRegister("jJD7c", function(module, exports) {

$parcel$export(module.exports, "default", () => $e661b354f8faff8b$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4XCp5 = parcelRequire("4XCp5");
const $e661b354f8faff8b$var$SubscriberCountElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $4XCp5.toBadgeProps)(context.subscriberCount?.toString()) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4XCp5.default), {
        icon: (0, $5NtHI.IconType).Subscriber,
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).SubscriberCount
    }) : null;
};
var $e661b354f8faff8b$export$2e2bcd8739ae039 = $e661b354f8faff8b$var$SubscriberCountElement;

});

parcelRegister("7mGkc", function(module, exports) {

$parcel$export(module.exports, "default", () => $da8be0e62ff3be52$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4XCp5 = parcelRequire("4XCp5");
const $da8be0e62ff3be52$var$SubTasksProgressElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $4XCp5.toBadgeProps)(context.subTasksProgress?.toString()) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4XCp5.default), {
        icon: (0, $5NtHI.IconType).SubTasksProgress,
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).SubTasksProgress
    }) : null;
};
var $da8be0e62ff3be52$export$2e2bcd8739ae039 = $da8be0e62ff3be52$var$SubTasksProgressElement;

});

parcelRegister("w1OaX", function(module, exports) {

$parcel$export(module.exports, "default", () => $6da98c25506acfc3$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $hTi78 = parcelRequire("hTi78");
const $6da98c25506acfc3$var$StoryPointsElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $hTi78.toAtlaskitBadgeProps)(context.storyPoints) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hTi78.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).StoryPoints
    }) : null;
};
var $6da98c25506acfc3$export$2e2bcd8739ae039 = $6da98c25506acfc3$var$StoryPointsElement;

});
parcelRegister("hTi78", function(module, exports) {

$parcel$export(module.exports, "default", () => $5fb2764f8e50f778$export$2e2bcd8739ae039);
$parcel$export(module.exports, "toAtlaskitBadgeProps", () => $5fb2764f8e50f778$export$731812b93bd90554);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $7q9BG = parcelRequire("7q9BG");
const $5fb2764f8e50f778$var$badgeStyles = null;
/**
 * A base element that displays a visual indicator for a numeric value
 * @internal
 * @see StoryPoints
 * */ const $5fb2764f8e50f778$var$BaseAtlaskitElementBadge = ({ value: value, name: name, className: className, testId: testId = 'smart-element-atlaskit-badge' })=>{
    if (!value) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-smart-element": name,
        "data-smart-element-atlaskit-badge": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_4cvr1h6o _1e0c116y _1ul91ns9",
            className
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7q9BG.default), {
            children: value
        })
    });
};
var $5fb2764f8e50f778$export$2e2bcd8739ae039 = $5fb2764f8e50f778$var$BaseAtlaskitElementBadge;
const $5fb2764f8e50f778$export$731812b93bd90554 = (value)=>{
    return value ? {
        value: value
    } : undefined;
};

});


parcelRegister("cwvSG", function(module, exports) {

$parcel$export(module.exports, "default", () => $44a8674c49925bc5$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $38cBa = parcelRequire("38cBa");
const $44a8674c49925bc5$var$TargetBranchElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $38cBa.toTextProps)(context.targetBranch) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).TargetBranch
    }) : null;
};
var $44a8674c49925bc5$export$2e2bcd8739ae039 = $44a8674c49925bc5$var$TargetBranchElement;

});

parcelRegister("2j4b1", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee83b62dd045c6fd$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $38cBa = parcelRequire("38cBa");
const $ee83b62dd045c6fd$var$MAX_TEAM_MEMBER_LIMIT = 50;
const $ee83b62dd045c6fd$var$TeamMemberCountElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    if (!context?.teamMemberCount) return null;
    const count = context?.teamMemberCount && context?.teamMemberCount > $ee83b62dd045c6fd$var$MAX_TEAM_MEMBER_LIMIT ? `${$ee83b62dd045c6fd$var$MAX_TEAM_MEMBER_LIMIT}+` : context?.teamMemberCount?.toString();
    const data = count ? (0, $38cBa.toFormattedTextProps)((0, $19nmp.messages).team_members_count, count) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).TeamMemberCount
    }) : null;
};
var $ee83b62dd045c6fd$export$2e2bcd8739ae039 = $ee83b62dd045c6fd$var$TeamMemberCountElement;

});

parcelRegister("i6ktq", function(module, exports) {

$parcel$export(module.exports, "default", () => $890c0338844dfde1$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $8ygPC = parcelRequire("8ygPC");
const $890c0338844dfde1$var$TitleElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? context?.linkTitle : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8ygPC.default), {
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).Title
    }) : null;
};
var $890c0338844dfde1$export$2e2bcd8739ae039 = $890c0338844dfde1$var$TitleElement;

});

parcelRegister("iQvIm", function(module, exports) {

$parcel$export(module.exports, "default", () => $13574bab0abb9b76$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $38cBa = parcelRequire("38cBa");
const $13574bab0abb9b76$var$UserAttributesElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const renderUserAttributes = (userAttributes)=>{
        if (!userAttributes) return null;
        const attributeKeys = [
            'pronouns',
            'role',
            'department',
            'location'
        ];
        const attributes = [];
        attributeKeys.forEach((key)=>{
            if (userAttributes[key]) {
                const data = (0, $38cBa.toFormattedTextProps)((0, $19nmp.messages).user_attributes, userAttributes[key]);
                if (data) attributes.push(/*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
                    ...data,
                    testId: `smart-element-text-${key}`,
                    ...props,
                    name: (0, $5NtHI.ElementName).UserAttributes
                }, key));
            }
        });
        return attributes.length > 0 ? attributes : null;
    };
    const elements = context ? renderUserAttributes(context.userAttributes) : null;
    return elements ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: elements
    }) : null;
};
var $13574bab0abb9b76$export$2e2bcd8739ae039 = $13574bab0abb9b76$var$UserAttributesElement;

});

parcelRegister("bApaO", function(module, exports) {

$parcel$export(module.exports, "default", () => $32db5b76dc584a40$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4XCp5 = parcelRequire("4XCp5");
const $32db5b76dc584a40$var$ViewCountElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $4XCp5.toBadgeProps)(context.viewCount?.toString()) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4XCp5.default), {
        icon: (0, $5NtHI.IconType).View,
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).ViewCount
    }) : null;
};
var $32db5b76dc584a40$export$2e2bcd8739ae039 = $32db5b76dc584a40$var$ViewCountElement;

});

parcelRegister("1IQ2A", function(module, exports) {

$parcel$export(module.exports, "default", () => $49df200106082223$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4XCp5 = parcelRequire("4XCp5");
const $49df200106082223$var$VoteCountElement = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context ? (0, $4XCp5.toBadgeProps)(context.voteCount?.toString()) : null;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4XCp5.default), {
        icon: (0, $5NtHI.IconType).Vote,
        ...data,
        ...props,
        name: (0, $5NtHI.ElementName).VoteCount
    }) : null;
};
var $49df200106082223$export$2e2bcd8739ae039 = $49df200106082223$var$VoteCountElement;

});

parcelRegister("lJDNU", function(module, exports) {

$parcel$export(module.exports, "default", () => $b64afcea66b05029$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $4XCp5 = parcelRequire("4XCp5");
const $b64afcea66b05029$var$AppliedToComponentsCountElement = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    if (// Check for null and undefined, render if it's 0.
    context?.appliedToComponentsCount === null || context?.appliedToComponentsCount === undefined) return null;
    const label = formatMessage((0, $19nmp.messages).compass_applied_components_count, {
        numberOfComponents: context.appliedToComponentsCount
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4XCp5.default), {
        icon: (0, $5NtHI.IconType).Component,
        label: label,
        ...props
    });
};
var $b64afcea66b05029$export$2e2bcd8739ae039 = $b64afcea66b05029$var$AppliedToComponentsCountElement;

});

parcelRegister("i4NpI", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e868f1df007f5c9$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $38cBa = parcelRequire("38cBa");
const $7e868f1df007f5c9$var$CustomElementByAccessType = ({ className: className, testId: testId = 'custom-by-access-type-element', ...props })=>{
    const context = (0, $5FRJ8.useFlexibleCardContext)();
    const accessType = context?.data?.meta?.accessType;
    const descriptor = props[accessType] ?? props.fallback;
    if (!descriptor) return null;
    const values = context?.data?.actions?.[(0, $5NtHI.InternalActionName).UnresolvedAction]?.values;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
        ...props,
        message: {
            descriptor: descriptor,
            values: values
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: className,
        testId: testId,
        hideFormat: true
    });
};
var $7e868f1df007f5c9$export$2e2bcd8739ae039 = $7e868f1df007f5c9$var$CustomElementByAccessType;

});

parcelRegister("5d1ks", function(module, exports) {

$parcel$export(module.exports, "default", () => $255ff319c604874a$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5FRJ8 = parcelRequire("5FRJ8");
const $255ff319c604874a$var$CustomByStatusElement = ({ className: className, testId: testId = 'custom-by-status-element', ...props })=>{
    const context = (0, $5FRJ8.useFlexibleCardContext)();
    const status = context?.status;
    if (!status) return null;
    const component = props[status];
    if (!component) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-separator": true,
        "data-smart-element": "custom-element",
        "data-smart-element-text": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: className,
        children: component
    });
};
var $255ff319c604874a$export$2e2bcd8739ae039 = $255ff319c604874a$var$CustomByStatusElement;

});


parcelRegister("k8J0S", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ef789dfa4e54c3c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $5NtHI = parcelRequire("5NtHI");

var $brTAh = parcelRequire("brTAh");
const $7ef789dfa4e54c3c$var$alignmentStyleMap = {
    right: "_1dthh9n0 _r291h9n0 _1bahesu3 _y3gnusic",
    left: "_1dthv2br _r291v2br _1bah1y6m _y3gn1e5h"
};
const $7ef789dfa4e54c3c$var$baseStyleBySize = {
    xlarge: "_zulpv47k _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf",
    large: "_zulppxbi _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf",
    medium: "_zulpu2gc _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf",
    small: "_zulp1b66 _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf"
};
const $7ef789dfa4e54c3c$var$baseStyleByDirection = {
    horizontal: "_2lx2vrvc _4cvr1h6o",
    vertical: "_2lx21bp4 _4cvr1y6m"
};
const $7ef789dfa4e54c3c$var$baseStyles = null;
const $7ef789dfa4e54c3c$var$widthStyle = {
    flexible: "_16jlkb7n _1o9z11wp _i0dlf1ug",
    'fit-to-content': ""
};
const $7ef789dfa4e54c3c$var$positionStyle = {
    top: "_1wpz1y6m",
    center: ""
};
const $7ef789dfa4e54c3c$var$horizontalStyleBase = null;
const $7ef789dfa4e54c3c$var$horizontalStyleByHeight = {
    xlarge: "_1e0ccj1k _102k125z",
    large: "_1e0ccj1k _102k125z",
    medium: "_1e0ccj1k _102kz42d",
    small: "_1e0ccj1k _102kz42d"
};
const $7ef789dfa4e54c3c$var$gapStylesLeft = {
    xlarge: "_7yhbv47k _m6ukidpf",
    large: "_7yhbpxbi _m6ukidpf",
    medium: "_7yhbu2gc _m6ukidpf",
    small: "_7yhb1b66 _m6ukidpf"
};
const $7ef789dfa4e54c3c$var$gapStylesRight = {
    xlarge: "_24rcv47k _3dveidpf",
    large: "_24rcpxbi _3dveidpf",
    medium: "_24rcu2gc _3dveidpf",
    small: "_24rc1b66 _3dveidpf"
};
const $7ef789dfa4e54c3c$var$minWidthStyle = null;
/**
 * Creates a group of Action components. Accepts an array of Actions, in addition to some styling
 * preferences.
 * @internal
 * @param {ActionGroupProps} ActionGroupProps
 * @see Action
 */ const $7ef789dfa4e54c3c$var$ElementGroup = ({ align: align = (0, $5NtHI.SmartLinkAlignment).Left, children: children, direction: direction = (0, $5NtHI.SmartLinkDirection).Horizontal, size: size = (0, $5NtHI.SmartLinkSize).Medium, testId: testId = 'smart-element-group', width: width = (0, $5NtHI.SmartLinkWidth).FitToContent, position: position = (0, $5NtHI.SmartLinkPosition).Center, className: className })=>{
    const isHorizontal = direction === (0, $5NtHI.SmartLinkDirection).Horizontal;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-smart-element-group": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            $7ef789dfa4e54c3c$var$baseStyleBySize[size],
            $7ef789dfa4e54c3c$var$baseStyleByDirection[direction],
            "_fiawglyw",
            $7ef789dfa4e54c3c$var$alignmentStyleMap[align],
            "_1ul99by0",
            $7ef789dfa4e54c3c$var$widthStyle[width],
            isHorizontal && "_1reo15vq _18m915vq _1e0c1ule _s7n4nkob _1bto1l2s _1nmz1hna _1yyjkb7n _sudp1e54 _1aaynkob _15tynkob _1iu61nu9 _166k1nu9 _1div1nu9 _bmfb1nu9",
            isHorizontal && $7ef789dfa4e54c3c$var$horizontalStyleByHeight[size],
            isHorizontal && align === (0, $5NtHI.SmartLinkAlignment).Left && $7ef789dfa4e54c3c$var$gapStylesLeft[size],
            isHorizontal && align === (0, $5NtHI.SmartLinkAlignment).Right && $7ef789dfa4e54c3c$var$gapStylesRight[size],
            $7ef789dfa4e54c3c$var$positionStyle[position],
            className
        ]),
        children: (0, $brTAh.renderChildren)(children, size)
    });
};
var $7ef789dfa4e54c3c$export$2e2bcd8739ae039 = $7ef789dfa4e54c3c$var$ElementGroup;

});


parcelRegister("a86OV", function(module, exports) {

$parcel$export(module.exports, "default", () => $26c0c5c54b91a954$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $lHA6U = parcelRequire("lHA6U");
const $26c0c5c54b91a954$var$ActionGroupItem = ({ item: item, size: size, appearance: appearance, asDropDownItems: asDropDownItems, onActionItemClick: onActionItemClick })=>{
    const { name: name, hideContent: hideContent, hideIcon: hideIcon, onClick: onClick, isDisabled: isDisabled, ...props } = item;
    const handleOnClick = (0, $eJOHy.useCallback)(()=>{
        if (onActionItemClick) onActionItemClick();
        if (onClick) onClick();
    }, [
        onActionItemClick,
        onClick
    ]);
    const Action = name in $lHA6U ? $lHA6U[name] : undefined;
    if (!Action) return null;
    const actionProps = {
        ...props
    };
    if (hideContent && !asDropDownItems) actionProps.content = '';
    if (hideIcon) actionProps.icon = undefined;
    if (item?.entryPointWrapper) actionProps.wrapper = item.entryPointWrapper;
    return /*#__PURE__*/ (0, $gt9Am.jsx)(Action, {
        asDropDownItem: asDropDownItems,
        size: size,
        appearance: appearance,
        onClick: handleOnClick,
        isDisabled: isDisabled,
        ...actionProps
    });
};
var $26c0c5c54b91a954$export$2e2bcd8739ae039 = $26c0c5c54b91a954$var$ActionGroupItem;

});
parcelRegister("lHA6U", function(module, exports) {

$parcel$export(module.exports, "CustomAction", () => (parcelRequire("9hHCO")).default);
$parcel$export(module.exports, "DeleteAction", () => (parcelRequire("dckwx")).default);
$parcel$export(module.exports, "EditAction", () => (parcelRequire("c0FsA")).default);
$parcel$export(module.exports, "DownloadAction", () => (parcelRequire("dGv8r")).default);
$parcel$export(module.exports, "FollowAction", () => (parcelRequire("lSW97")).default);
$parcel$export(module.exports, "PreviewAction", () => (parcelRequire("3MDCL")).default);
$parcel$export(module.exports, "CopyLinkAction", () => (parcelRequire("b1dbu")).default);
$parcel$export(module.exports, "UnresolvedAction", () => (parcelRequire("cLrUd")).default);
$parcel$export(module.exports, "AISummaryAction", () => (parcelRequire("2fs4B")).default);
$parcel$export(module.exports, "AutomationAction", () => (parcelRequire("1EoLm")).default);
$parcel$export(module.exports, "ViewRelatedLinksAction", () => (parcelRequire("bKvNh")).default);
$parcel$export(module.exports, "CustomUnresolvedAction", () => (parcelRequire("fd4of")).default);

var $9hHCO = parcelRequire("9hHCO");

var $dckwx = parcelRequire("dckwx");

var $c0FsA = parcelRequire("c0FsA");

var $dGv8r = parcelRequire("dGv8r");

var $lSW97 = parcelRequire("lSW97");

var $3MDCL = parcelRequire("3MDCL");

var $b1dbu = parcelRequire("b1dbu");

var $cLrUd = parcelRequire("cLrUd");

var $2fs4B = parcelRequire("2fs4B");

var $1EoLm = parcelRequire("1EoLm");

var $bKvNh = parcelRequire("bKvNh");

var $fd4of = parcelRequire("fd4of");

});
parcelRegister("9hHCO", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2469864747178fa$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $8ABAe = parcelRequire("8ABAe");

var $fh1oH = parcelRequire("fh1oH");

var $dQnV8 = parcelRequire("dQnV8");

var $cNUXI = parcelRequire("cNUXI");
/**
 * A base action that can be triggered with an on click.
 * @internal
 * @param {ActionProps} ActionProps - The props necessary for the Action.
 */ const $c2469864747178fa$var$Action = ({ as: as, appearance: appearance = 'subtle', content: content, isLoading: isLoading = false, onClick: onClick, size: size = (0, $5NtHI.SmartLinkSize).Medium, testId: testId = 'smart-action', icon: icon, iconPosition: iconPosition = 'before', spaceInline: spaceInline, tooltipMessage: tooltipMessage, tooltipOnHide: tooltipOnHide, hideTooltip: hideTooltip, hideTooltipOnMouseDown: hideTooltipOnMouseDown, style: style, asDropDownItem: asDropDownItem, className: className, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel, wrapper: Wrapper })=>{
    if (!onClick) return null;
    const isStackItem = as === 'stack-item';
    const isDropdownItem = as === 'dropdown-item' || asDropDownItem;
    const actionIcon = icon ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dQnV8.default), {
        asStackItemIcon: isStackItem,
        isDisabled: isDisabled,
        icon: icon,
        size: size,
        testId: testId
    }) : undefined;
    const iconBefore = icon && iconPosition === 'before' ? actionIcon : undefined;
    const iconAfter = icon && iconPosition === 'after' ? actionIcon : undefined;
    if (isStackItem) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cNUXI.default), {
        content: content,
        icon: actionIcon,
        space: spaceInline,
        isDisabled: isDisabled,
        isLoading: isLoading,
        onClick: onClick,
        size: size,
        testId: testId,
        tooltipMessage: tooltipMessage || content,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: style,
        tooltipOnHide: tooltipOnHide,
        hideTooltipOnMouseDown: hideTooltipOnMouseDown,
        hideTooltip: hideTooltip
    });
    if (isDropdownItem) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fh1oH.default), {
        content: content,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isLoading: isLoading,
        onClick: onClick,
        testId: testId
    });
    const button = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8ABAe.default), {
        appearance: appearance,
        content: content,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isLoading: isLoading,
        onClick: onClick,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: className,
        size: size,
        testId: testId,
        tooltipMessage: tooltipMessage || content,
        isDisabled: isDisabled,
        href: href,
        ariaLabel: ariaLabel
    });
    return Wrapper !== undefined ? /*#__PURE__*/ (0, $gt9Am.jsx)(Wrapper, {
        children: button
    }) : button;
};
var $c2469864747178fa$export$2e2bcd8739ae039 = $c2469864747178fa$var$Action;

});
parcelRegister("8ABAe", function(module, exports) {

$parcel$export(module.exports, "default", () => $810b448b0b6757f9$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $cA0Y2 = parcelRequire("cA0Y2");

var $5CSKW = parcelRequire("5CSKW");
var $Ay1uj = parcelRequire("Ay1uj");
var $5bY40 = parcelRequire("5bY40");
var $6K3F5 = parcelRequire("6K3F5");

var $8IeH1 = parcelRequire("8IeH1");

var $k71qx = parcelRequire("k71qx");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $9jYtV = parcelRequire("9jYtV");

var $fQH39 = parcelRequire("fQH39");
const $810b448b0b6757f9$var$IconOnlyLarge = null;
const $810b448b0b6757f9$var$SizeSmall = null;
const $810b448b0b6757f9$var$SizeSmallIconOnly = null;
const $810b448b0b6757f9$var$SizeSmallNotIconOnly = null;
const $810b448b0b6757f9$var$IconButtonAppearanceMap = {
    default: 'default',
    danger: undefined,
    link: 'default',
    primary: 'primary',
    subtle: 'subtle',
    'subtle-link': 'subtle',
    warning: undefined
};
const $810b448b0b6757f9$var$ButtonAppearanceMap = {
    default: 'default',
    danger: 'danger',
    link: 'default',
    primary: 'primary',
    subtle: 'subtle',
    'subtle-link': 'subtle',
    warning: 'warning'
};
const $810b448b0b6757f9$var$tooltipOptions = {
    hideTooltipOnClick: true
};
const $810b448b0b6757f9$var$ActionButtonRefresh = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ appearance: appearance = 'default', content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, size: size, testId: testId, tooltipMessage: tooltipMessage, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel }, ref)=>{
    const iconOnly = !content;
    const onButtonClick = (0, $eJOHy.useCallback)((handler)=>(e)=>{
            e.preventDefault();
            handler();
        }, []);
    const button = (0, $eJOHy.useMemo)(()=>{
        const isLinkButton = !!href;
        const spacing = size === (0, $5NtHI.SmartLinkSize).Large || size === (0, $5NtHI.SmartLinkSize).XLarge ? 'default' : 'compact';
        if (iconOnly) {
            const icon = iconBefore || iconAfter;
            const iconFn = ()=>icon || null;
            if (isLinkButton) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6K3F5.default), {
                appearance: $810b448b0b6757f9$var$IconButtonAppearanceMap[appearance],
                icon: iconFn,
                href: href,
                isDisabled: isDisabled,
                isTooltipDisabled: false,
                label: tooltipMessage,
                onClick: onButtonClick(onClick),
                spacing: spacing,
                testId: testId,
                tooltip: $810b448b0b6757f9$var$tooltipOptions
            });
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                appearance: $810b448b0b6757f9$var$IconButtonAppearanceMap[appearance],
                icon: iconFn,
                isDisabled: isDisabled,
                isLoading: isLoading,
                isTooltipDisabled: false,
                label: tooltipMessage,
                onClick: onButtonClick(onClick),
                spacing: spacing,
                testId: testId,
                tooltip: $810b448b0b6757f9$var$tooltipOptions
            });
        }
        const iconBeforeFn = ()=>iconBefore || null;
        const iconAfterFn = ()=>iconAfter || null;
        if (isLinkButton) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
            content: tooltipMessage,
            hideTooltipOnClick: true,
            testId: `${testId}-tooltip`,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5bY40.default), {
                appearance: $810b448b0b6757f9$var$ButtonAppearanceMap[appearance],
                "aria-label": ariaLabel,
                iconAfter: iconAfterFn,
                iconBefore: iconBeforeFn,
                isDisabled: isDisabled,
                href: href,
                onClick: onButtonClick(onClick),
                spacing: spacing,
                testId: testId,
                children: content
            })
        });
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
            content: tooltipMessage,
            hideTooltipOnClick: true,
            testId: `${testId}-tooltip`,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5CSKW.default), {
                appearance: $810b448b0b6757f9$var$ButtonAppearanceMap[appearance],
                "aria-label": ariaLabel,
                iconAfter: iconAfterFn,
                iconBefore: iconBeforeFn,
                isDisabled: isDisabled,
                isLoading: isLoading,
                onClick: onButtonClick(onClick),
                spacing: spacing,
                testId: testId,
                children: content
            })
        });
    }, [
        appearance,
        ariaLabel,
        content,
        href,
        iconAfter,
        iconBefore,
        iconOnly,
        isDisabled,
        isLoading,
        onButtonClick,
        onClick,
        size,
        testId,
        tooltipMessage
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        testId: `${testId}-button-wrapper`,
        ref: ref,
        children: button
    });
});
const $810b448b0b6757f9$var$ActionButtonRefreshWithOverrideCss = (0, $9jYtV.withOverrideCss)($810b448b0b6757f9$var$ActionButtonRefresh);
const $810b448b0b6757f9$var$ActionButtonNew = ({ appearance: appearance = 'default', content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, size: size, testId: testId, tooltipMessage: tooltipMessage, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel, className: className })=>{
    const iconOnly = !content;
    const onButtonClick = (0, $eJOHy.useCallback)((handler)=>(e)=>{
            e.preventDefault();
            handler();
        }, []);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            size === (0, $5NtHI.SmartLinkSize).Large && iconOnly && "_1gflidpf _or3fidpf _1ddvidpf _1hhaidpf _yhjmidpf _1trnidpf _1fstidpf _1xceidpf _1gqnidpf _1qdmidpf _df2ridpf _j1twidpf _11lvidpf _192bidpf _vbn7idpf _wfu3idpf _1i3bidpf _13gwidpf _4wlcidpf _rehaidpf _mp2fidpf _ro8midpf _1l0qidpf _1bnaidpf _3kh9idpf _i2vxidpf _8pvjidpf _1e1oidpf _1vtwidpf _ijvwidpf _tpwpidpf _1ad8idpf",
            size === (0, $5NtHI.SmartLinkSize).Small && "_11c8dcr7 _k48p1wq8",
            size === (0, $5NtHI.SmartLinkSize).Small && iconOnly && "_1gfl1xvx _or3f1xvx _1ddv1xvx _1hha1xvx _yhjm1xvx _1trn1xvx _1fst1xvx _1xce1xvx _1gqn1xvx _1qdm1xvx _df2r1xvx _j1tw1xvx _11lv1xvx _192b1xvx _vbn71xvx _wfu31xvx",
            size === (0, $5NtHI.SmartLinkSize).Small && !iconOnly && "_11lvpdf9 _192bpdf9 _vbn7pdf9 _wfu3pdf9 _yhjmpdf9 _1trnpdf9 _1fstpdf9 _1xcepdf9",
            className
        ]),
        "data-testid": `${testId}-button-wrapper`,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
            content: tooltipMessage,
            hideTooltipOnClick: true,
            testId: `${testId}-tooltip`,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cA0Y2.default), {
                appearance: appearance,
                iconAfter: iconAfter,
                iconBefore: iconBefore,
                isDisabled: isDisabled,
                isLoading: isLoading,
                onClick: onButtonClick(onClick),
                spacing: (0, $fQH39.sizeToButtonSpacing)[size],
                testId: testId,
                href: href,
                "aria-label": ariaLabel,
                children: content
            })
        })
    });
};
const $810b448b0b6757f9$var$ActionButton = (props)=>{
    const ui = (0, $5FRJ8.useFlexibleUiOptionContext)();
    if (ui?.hideLegacyButton || ui?.removeBlockRestriction) return /*#__PURE__*/ (0, $gt9Am.jsx)($810b448b0b6757f9$var$ActionButtonRefreshWithOverrideCss, {
        ...props
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)($810b448b0b6757f9$var$ActionButtonNew, {
        ...props
    });
};
var $810b448b0b6757f9$export$2e2bcd8739ae039 = $810b448b0b6757f9$var$ActionButton;

});

parcelRegister("fh1oH", function(module, exports) {

$parcel$export(module.exports, "default", () => $4141238200e2a86d$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $jYYbf = parcelRequire("jYYbf");

var $FoFt2 = parcelRequire("FoFt2");
const $4141238200e2a86d$var$ActionDropdownItem = ({ content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $jYYbf.default), {
        elemAfter: iconAfter,
        elemBefore: iconBefore,
        isDisabled: isLoading,
        onClick: (0, $FoFt2.handleOnClick)(onClick),
        testId: testId,
        children: content
    });
var $4141238200e2a86d$export$2e2bcd8739ae039 = $4141238200e2a86d$var$ActionDropdownItem;

});

parcelRegister("dQnV8", function(module, exports) {

$parcel$export(module.exports, "default", () => $182322eb34547fdc$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eGOwo = parcelRequire("eGOwo");

var $5NtHI = parcelRequire("5NtHI");
const $182322eb34547fdc$var$getIconWidth = (size)=>{
    switch(size){
        case (0, $5NtHI.SmartLinkSize).XLarge:
        case (0, $5NtHI.SmartLinkSize).Large:
            return '1.5rem';
        case (0, $5NtHI.SmartLinkSize).Medium:
        case (0, $5NtHI.SmartLinkSize).Small:
        default:
            return '1rem';
    }
};
// TODO: Remove on fg cleanup: platform-visual-refresh-icons
const $182322eb34547fdc$var$iconSizeStyleMap = {
    '1.5rem': "_16jlidpf _1o9zidpf _i0dl1wug _4t3i1k8s _1tke1k8s _c71l1k8s _1bsb1k8s _1ul91k8s _p12f1k8s _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna71k8s _1xjx1k8s _17521k8s _qci81k8s _15iz1k8s _erub1k8s _19l31k8s _1pr21k8s _1u5t1k8s _mezj1k8s _e2oo1k8s _w8l51k8s _1rg21k8s _q7cv1k8s _xwbj1k8s _rtys1k8s _b8nk1k8s _4x201k8s",
    '1rem': "_16jlidpf _1o9zidpf _i0dl1wug _4t3i1j6v _1tke1j6v _c71l1j6v _1bsb1j6v _1ul91j6v _p12f1j6v _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna71j6v _1xjx1j6v _17521j6v _qci81j6v _15iz1j6v _erub1j6v _19l31j6v _1pr21j6v _1u5t1j6v _mezj1j6v _e2oo1j6v _w8l51j6v _1rg21j6v _q7cv1j6v _xwbj1j6v _rtys1j6v _b8nk1j6v _4x201j6v",
    '20px': "_16jlidpf _1o9zidpf _i0dl1wug _4t3igktf _1tkegktf _c71lgktf _1bsbgktf _1ul9gktf _p12fgktf _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna7gktf _1xjxgktf _1752gktf _qci8gktf _15izgktf _erubgktf _19l3gktf _1pr2gktf _1u5tgktf _mezjgktf _e2oogktf _w8l5gktf _1rg2gktf _q7cvgktf _xwbjgktf _rtysgktf _b8nkgktf _4x20gktf"
};
// TODO: Remove on fg cleanup: platform-visual-refresh-icons
const $182322eb34547fdc$var$stackItemIconStylesOld = null;
const $182322eb34547fdc$var$stackItemIconStylesCompiled = null;
const $182322eb34547fdc$var$ActionIcon = ({ size: size, testId: testId, icon: icon, asStackItemIcon: asStackItemIcon })=>{
    if (!(0, $eGOwo.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-testid": `${testId}-icon`,
        className: (0, $hcewu.default)([
            asStackItemIcon && "_1e0c1o8l _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o",
            asStackItemIcon && $182322eb34547fdc$var$iconSizeStyleMap['20px'],
            !asStackItemIcon && $182322eb34547fdc$var$iconSizeStyleMap[$182322eb34547fdc$var$getIconWidth(size)]
        ]),
        children: icon
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-testid": `${testId}-icon`,
        className: (0, $hcewu.default)([
            "_1e0c1o8l"
        ]),
        children: icon
    });
};
var $182322eb34547fdc$export$2e2bcd8739ae039 = $182322eb34547fdc$var$ActionIcon;

});

parcelRegister("cNUXI", function(module, exports) {

$parcel$export(module.exports, "default", () => $d23b94a27dbb965d$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $k71qx = parcelRequire("k71qx");

var $e5DLq = parcelRequire("e5DLq");
const $d23b94a27dbb965d$var$ActionStackItem = ({ content: content, tooltipMessage: tooltipMessage, tooltipOnHide: tooltipOnHide, hideTooltipOnMouseDown: hideTooltipOnMouseDown, hideTooltip: hideTooltip, ...props })=>hideTooltip ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $e5DLq.default), {
        ...props,
        content: content
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
        content: tooltipMessage || content,
        onHide: tooltipOnHide,
        hideTooltipOnMouseDown: hideTooltipOnMouseDown,
        children: (tooltipProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $e5DLq.default), {
                ...props,
                content: content,
                tooltipProps: tooltipProps
            })
    });
var $d23b94a27dbb965d$export$2e2bcd8739ae039 = $d23b94a27dbb965d$var$ActionStackItem;

});
parcelRegister("e5DLq", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d6dc8e23eec4828$export$2e2bcd8739ae039);
/* action-button.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $6qaBj = parcelRequire("6qaBj");

var $8IeH1 = parcelRequire("8IeH1");
var $6djmC = parcelRequire("6djmC");
var $46R8N = parcelRequire("46R8N");

var $7ep4S = parcelRequire("7ep4S");

var $fQH39 = parcelRequire("fQH39");

var $dQnV8 = parcelRequire("dQnV8");
const $0d6dc8e23eec4828$var$styles = {
    button: "_bfhk1w7a _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _1bsb1osq _1ah31i6y _irr3166n _1di61dty",
    content: "_11c81o8v _syaz1fxt"
};
const $0d6dc8e23eec4828$var$ActionButton = ({ content: content, icon: iconOption, isDisabled: isDisabled, isLoading: isLoading, onClick: onClickCallback, size: size, space: spaceOption, testId: testId, tooltipProps: tooltipProps, style: style })=>{
    const space = spaceOption ?? (0, $fQH39.getPrimitivesInlineSpaceBySize)(size);
    const onClick = (0, $eJOHy.useCallback)(()=>{
        if (!isDisabled && !isLoading && onClickCallback) onClickCallback();
    }, [
        isDisabled,
        isLoading,
        onClickCallback
    ]);
    const icon = iconOption && isLoading ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dQnV8.default), {
        asStackItemIcon: true,
        icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {
            testId: `${testId}-loading`
        }),
        size: size
    }) : iconOption;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $46R8N.default), {
        xcss: (0, $6qaBj.cx)($0d6dc8e23eec4828$var$styles.button),
        ...tooltipProps,
        onClick: onClick,
        testId: testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: style,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
            alignBlock: "center",
            grow: "fill",
            space: space,
            children: [
                icon,
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                    xcss: (0, $6qaBj.cx)($0d6dc8e23eec4828$var$styles.content),
                    children: content
                })
            ]
        })
    });
};
var $0d6dc8e23eec4828$export$2e2bcd8739ae039 = $0d6dc8e23eec4828$var$ActionButton;

});



parcelRegister("dckwx", function(module, exports) {

$parcel$export(module.exports, "default", () => $3290b93af8be85b3$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $7pCTe = parcelRequire("7pCTe");

var $19nmp = parcelRequire("19nmp");

var $9hHCO = parcelRequire("9hHCO");
const $3290b93af8be85b3$var$DeleteAction = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $9hHCO.default), {
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).delete
        }),
        icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7pCTe))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Delete"
        }),
        testId: "smart-action-delete-action",
        tooltipMessage: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).delete
        }),
        ...props
    });
var $3290b93af8be85b3$export$2e2bcd8739ae039 = $3290b93af8be85b3$var$DeleteAction;

});

parcelRegister("c0FsA", function(module, exports) {

$parcel$export(module.exports, "default", () => $920fde411498a771$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $bp0jd = parcelRequire("bp0jd");

var $19nmp = parcelRequire("19nmp");

var $9hHCO = parcelRequire("9hHCO");
const $920fde411498a771$var$EditAction = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $9hHCO.default), {
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).edit
        }),
        icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bp0jd))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Edit"
        }),
        testId: "smart-action-edit-action",
        tooltipMessage: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).edit
        }),
        ...props
    });
var $920fde411498a771$export$2e2bcd8739ae039 = $920fde411498a771$var$EditAction;

});
parcelRegister("bp0jd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::631c9d525a923bb24b78f7aa2d70d92c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $84d244d8a31b5641$var$_react = $84d244d8a31b5641$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $84d244d8a31b5641$var$_edit = $84d244d8a31b5641$var$_interopRequireDefault((parcelRequire("gTr6H")));

var $84d244d8a31b5641$var$_edit2 = $84d244d8a31b5641$var$_interopRequireDefault((parcelRequire("dUYQ5")));
function $84d244d8a31b5641$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for EditIcon.
 * This component is EditIcon, with `UNSAFE_fallbackIcon` set to "EditIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $84d244d8a31b5641$var$EditIcon = (props)=>/*#__PURE__*/ $84d244d8a31b5641$var$_react.default.createElement($84d244d8a31b5641$var$_edit.default, Object.assign({
        LEGACY_fallbackIcon: $84d244d8a31b5641$var$_edit2.default
    }, props));
$84d244d8a31b5641$var$EditIcon.Name = 'EditIconMigration';
var $84d244d8a31b5641$var$_default = module.exports.default = $84d244d8a31b5641$var$EditIcon;

});
parcelRegister("dUYQ5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a21fb2aec03ab384$var$_react = $a21fb2aec03ab384$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $a21fb2aec03ab384$var$_edit = $a21fb2aec03ab384$var$_interopRequireDefault((parcelRequire("gTr6H")));
function $a21fb2aec03ab384$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a21fb2aec03ab384$var$EditIcon = (props)=>/*#__PURE__*/ $a21fb2aec03ab384$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.02 19.23a1 1 0 0 0 1.18 1.18l3.81-.78-4.21-4.21zm5.92-2.62-2.12-2.12L16.31 6l2.12 2.12zm9.9-9.9-2.12-2.12A2 2 0 0 0 16.31 4c-.51 0-1.02.2-1.41.59l-9.76 9.76 4.95 4.95 9.76-9.76a2 2 0 0 0 0-2.83"/></svg>`
    }, props, {
        newIcon: $a21fb2aec03ab384$var$_edit.default
    }));
$a21fb2aec03ab384$var$EditIcon.displayName = 'EditIcon';
var $a21fb2aec03ab384$var$_default = module.exports.default = $a21fb2aec03ab384$var$EditIcon;

});



parcelRegister("dGv8r", function(module, exports) {

$parcel$export(module.exports, "default", () => $bea6a5d6049b9822$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $kHcBe = parcelRequire("kHcBe");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $7xssH = parcelRequire("7xssH");

var $9hHCO = parcelRequire("9hHCO");
const $bea6a5d6049b9822$var$DownloadAction = ({ onClick: onClickCallback, ...props })=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const invoke = (0, $7xssH.default)({});
    const data = context?.actions?.[(0, $5NtHI.ActionName).DownloadAction];
    const onClick = (0, $eJOHy.useCallback)(()=>{
        if (data?.invokeAction) {
            invoke(data.invokeAction);
            onClickCallback?.();
        }
    }, [
        data,
        invoke,
        onClickCallback
    ]);
    const isStackItem = props.as === 'stack-item';
    const label = isStackItem ? (0, $19nmp.messages).download_file : (0, $19nmp.messages).download;
    const tooltipMessage = isStackItem ? (0, $19nmp.messages).download_description : (0, $19nmp.messages).download;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9hHCO.default), {
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...label
        }),
        icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kHcBe))), {
            spacing: "spacious",
            color: "currentColor",
            label: "Download"
        }),
        onClick: onClick,
        testId: "smart-action-download-action",
        tooltipMessage: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...tooltipMessage
        }),
        ...data,
        ...props
    }) : null;
};
var $bea6a5d6049b9822$export$2e2bcd8739ae039 = $bea6a5d6049b9822$var$DownloadAction;

});
parcelRegister("kHcBe", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::647640fe09afef5813e2888b2ce1f074>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f11198d3276cd080$var$_react = $f11198d3276cd080$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $f11198d3276cd080$var$_download = $f11198d3276cd080$var$_interopRequireDefault((parcelRequire("5Mb5i")));

var $f11198d3276cd080$var$_download2 = $f11198d3276cd080$var$_interopRequireDefault((parcelRequire("bRp3T")));
function $f11198d3276cd080$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for DownloadIcon.
 * This component is DownloadIcon, with `UNSAFE_fallbackIcon` set to "DownloadIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for file downloads.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f11198d3276cd080$var$DownloadIcon = (props)=>/*#__PURE__*/ $f11198d3276cd080$var$_react.default.createElement($f11198d3276cd080$var$_download.default, Object.assign({
        LEGACY_fallbackIcon: $f11198d3276cd080$var$_download2.default
    }, props));
$f11198d3276cd080$var$DownloadIcon.Name = 'DownloadIconMigration';
var $f11198d3276cd080$var$_default = module.exports.default = $f11198d3276cd080$var$DownloadIcon;

});
parcelRegister("5Mb5i", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a3903aba4213e0f68da56229d9d15d40>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $434a088e5f2bb7a6$var$_react = $434a088e5f2bb7a6$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $434a088e5f2bb7a6$var$_baseNew = $434a088e5f2bb7a6$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $434a088e5f2bb7a6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Download".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for file downloads.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $434a088e5f2bb7a6$var$DownloadIcon = (props)=>/*#__PURE__*/ $434a088e5f2bb7a6$var$_react.default.createElement($434a088e5f2bb7a6$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 1v7.44l2.72-2.72 1.06 1.06-4 4a.75.75 0 0 1-1.06 0l-4-4 1.06-1.06 2.72 2.72V1zM1 13V9h1.5v4a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V9H15v4a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2" clip-rule="evenodd"/>`
    }, props));
$434a088e5f2bb7a6$var$DownloadIcon.displayName = 'DownloadIcon';
var $434a088e5f2bb7a6$var$_default = module.exports.default = $434a088e5f2bb7a6$var$DownloadIcon;

});

parcelRegister("bRp3T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8a2815b0aa140afa$var$_react = $8a2815b0aa140afa$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $8a2815b0aa140afa$var$_download = $8a2815b0aa140afa$var$_interopRequireDefault((parcelRequire("5Mb5i")));
function $8a2815b0aa140afa$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8a2815b0aa140afa$var$DownloadIcon = (props)=>/*#__PURE__*/ $8a2815b0aa140afa$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M10.687 17.292a.983.983 0 0 0-1.397 0 1 1 0 0 0 0 1.407l1.964 1.98a1.08 1.08 0 0 0 1.538 0l1.919-1.933a1 1 0 0 0 0-1.408.983.983 0 0 0-1.398 0l-1.29 1.3z"/><path fill-rule="nonzero" d="M13.001 19.993 13 10.006C13 9.451 12.552 9 12 9s-1 .45-1 1.007l.001 9.987c0 .555.448 1.006 1 1.006s1-.45 1-1.007"/><path d="M7.938 5.48a5 5 0 0 0-.777-.062C4.356 5.418 2 7.62 2 10.498 2 13.409 4.385 16 7.1 16h2.881v-1.993H7.1c-1.657 0-3.115-1.663-3.115-3.508 0-1.778 1.469-3.087 3.104-3.087h.012c.389 0 .686.05.97.15l.17.063c.605.248.875-.246.875-.246l.15-.267c.73-1.347 2.201-2.096 3.716-2.12a4.14 4.14 0 0 1 4.069 3.645l.046.34s.071.525.665.525c.013 0 .012.005.023.005h.254c1.136 0 1.976.959 1.976 2.158 0 1.207-.987 2.342-2.07 2.342h-3.964V16h3.964C20.105 16 22 13.955 22 11.665c0-2-1.312-3.663-3.138-4.074-.707-2.707-3.053-4.552-5.886-4.591-1.975.02-3.901.9-5.038 2.48"/></g></svg>`
    }, props, {
        newIcon: $8a2815b0aa140afa$var$_download.default
    }));
$8a2815b0aa140afa$var$DownloadIcon.displayName = 'DownloadIcon';
var $8a2815b0aa140afa$var$_default = module.exports.default = $8a2815b0aa140afa$var$DownloadIcon;

});



parcelRegister("lSW97", function(module, exports) {

$parcel$export(module.exports, "default", () => $dfe202eda411d4c1$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $fQH39 = parcelRequire("fQH39");

var $5UiT3 = parcelRequire("5UiT3");

var $kxXL5 = parcelRequire("kxXL5");


const $dfe202eda411d4c1$var$importIconMapper = {
    goal: ()=>(parcelRequire("59ZsC")).then(({ GoalIcon: GoalIcon })=>({
                default: GoalIcon
            })),
    projects: ()=>(parcelRequire("b7Rzw")).then(({ ProjectsIcon: ProjectsIcon })=>({
                default: ProjectsIcon
            }))
};
const $dfe202eda411d4c1$var$getIcon = (stackIconType)=>{
    const importFn = $dfe202eda411d4c1$var$importIconMapper[stackIconType];
    if (!importFn) return null;
    return (0, $fQH39.importIcon)(importFn);
};
const $dfe202eda411d4c1$var$FollowAction = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $5NtHI.ActionName).FollowAction];
    if (!context || !actionData) return null;
    const { value: value, isProject: isProject, ...data } = actionData;
    const isStackItem = props.as === 'stack-item';
    const message = value ? (0, $19nmp.messages).follow : (0, $19nmp.messages).unfollow;
    const projectMessage = value ? (0, $19nmp.messages).follow_project : (0, $19nmp.messages).unfollow_project;
    const goalMessage = value ? (0, $19nmp.messages).follow_goal : (0, $19nmp.messages).unfollow_goal;
    const stackMessage = isProject ? projectMessage : goalMessage;
    const label = isStackItem ? stackMessage : message;
    const projectTooltipMessage = value ? (0, $19nmp.messages).follow_project_description : (0, $19nmp.messages).unfollow_project_description;
    const goalTooltipMessage = value ? (0, $19nmp.messages).follow_goal_description : (0, $19nmp.messages).unfollow_goal_description;
    const stackTooltipMessage = isProject ? projectTooltipMessage : goalTooltipMessage;
    const tooltipMessage = isStackItem ? stackTooltipMessage : message;
    const stackIconType = isProject ? 'projects' : 'goal';
    const ImportedIcon = $dfe202eda411d4c1$var$getIcon(stackIconType);
    const followIcon = /*#__PURE__*/ (0, $gt9Am.jsx)(ImportedIcon, {
        label: "Follow",
        testId: `smart-action-follow-action-${stackIconType}-icon`
    });
    const handleError = ()=>{
        const { onError: onErrorCallback } = props;
        const errorMessage = (0, $kxXL5.getFollowActionErrorMessage)(isProject, value);
        onErrorCallback?.({
            title: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...errorMessage
            }),
            appearance: 'error'
        });
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5UiT3.default), {
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...label
        }),
        icon: followIcon,
        testId: "smart-action-follow-action",
        tooltipMessage: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...tooltipMessage
        }),
        ...data,
        ...props,
        onError: handleError
    });
};
var $dfe202eda411d4c1$export$2e2bcd8739ae039 = $dfe202eda411d4c1$var$FollowAction;

});
parcelRegister("5UiT3", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce9aaae704363155$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $bmWcp = parcelRequire("bmWcp");

var $6O4ri = parcelRequire("6O4ri");

var $d0InI = parcelRequire("d0InI");

var $kbv8x = parcelRequire("kbv8x");

var $1rn8a = parcelRequire("1rn8a");

var $9hHCO = parcelRequire("9hHCO");
const $ce9aaae704363155$var$ServerAction = ({ action: action, onClick: onClick, onError: onErrorCallback, ...props })=>{
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(false);
    const invoke = (0, $6O4ri.default)();
    const reload = (0, $kbv8x.default)();
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const handleClick = (0, $eJOHy.useCallback)(async ()=>{
        if (action) {
            const smartLinkActionType = action.action?.actionType;
            try {
                setIsLoading(true);
                if (smartLinkActionType === 'FollowEntityAction' || smartLinkActionType === 'UnfollowEntityAction') fireEvent('ui.button.clicked.smartLinkFollowButton', {});
                else fireEvent(`ui.button.clicked.${smartLinkActionType}`, {});
                fireEvent('track.smartLinkQuickAction.started', {
                    smartLinkActionType: smartLinkActionType
                });
                const request = (0, $1rn8a.default)(action);
                await invoke(request);
                fireEvent('track.smartLinkQuickAction.success', {
                    smartLinkActionType: smartLinkActionType
                });
                if (action.reload && action.reload.url) await reload(action.reload.url, true, undefined, action.reload.id);
                setIsLoading(false);
                if (onClick) onClick();
            } catch (err) {
                setIsLoading(false);
                fireEvent('track.smartLinkQuickAction.failed', {
                    smartLinkActionType: smartLinkActionType,
                    reason: (0, $d0InI.getInvokeFailureReason)(err)
                });
                onErrorCallback?.();
            }
        }
    }, [
        action,
        invoke,
        onClick,
        onErrorCallback,
        reload,
        fireEvent
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9hHCO.default), {
        ...props,
        isLoading: isLoading,
        onClick: handleClick
    });
};
var $ce9aaae704363155$export$2e2bcd8739ae039 = $ce9aaae704363155$var$ServerAction;

});
parcelRegister("1rn8a", function(module, exports) {

$parcel$export(module.exports, "default", () => $6426c76052ace8de$export$2e2bcd8739ae039);
const $6426c76052ace8de$var$createInvokeRequest = (request, payload)=>({
        action: {
            ...request.action,
            payload: payload
        },
        providerKey: request.providerKey
    });
var $6426c76052ace8de$export$2e2bcd8739ae039 = $6426c76052ace8de$var$createInvokeRequest;

});


parcelRegister("kxXL5", function(module, exports) {

$parcel$export(module.exports, "getFollowActionErrorMessage", () => $b87644dc5deec150$export$49248678d3914625);

var $19nmp = parcelRequire("19nmp");
const $b87644dc5deec150$export$49248678d3914625 = (isProject = false, isFollow = false)=>{
    if (isProject && isFollow) return (0, $19nmp.messages).follow_project_error;
    if (isProject && !isFollow) return (0, $19nmp.messages).unfollow_project_error;
    if (!isProject && isFollow) return (0, $19nmp.messages).follow_goal_error;
    if (!isProject && !isFollow) return (0, $19nmp.messages).unfollow_goal_error;
    return (0, $19nmp.messages).generic_error_message;
};

});

parcelRegister("59ZsC", function(module, exports) {

let $3c1d77d2dd928a94$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $3c1d77d2dd928a94$var$load("ffQaD"),
    $3c1d77d2dd928a94$var$load("kvRbA"),
    $3c1d77d2dd928a94$var$load("3nUhw")
]).then(()=>parcelRequire('k96Yq'));

});

parcelRegister("b7Rzw", function(module, exports) {

let $8199e76ea14b9640$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $8199e76ea14b9640$var$load("ffQaD"),
    $8199e76ea14b9640$var$load("kvRbA"),
    $8199e76ea14b9640$var$load("1877j")
]).then(()=>parcelRequire('c6wmU'));

});


parcelRegister("3MDCL", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7238a60227ffb9b$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $1hBh4 = parcelRequire("1hBh4");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $7xssH = parcelRequire("7xssH");

var $9hHCO = parcelRequire("9hHCO");
const $a7238a60227ffb9b$var$PreviewAction = ({ onClick: onClickCallback, ...props })=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const invoke = (0, $7xssH.default)({});
    const data = context?.actions?.[(0, $5NtHI.ActionName).PreviewAction];
    const onClick = (0, $eJOHy.useCallback)(()=>{
        if (data?.invokeAction) {
            invoke(data.invokeAction);
            onClickCallback?.();
        }
    }, [
        data,
        invoke,
        onClickCallback
    ]);
    const isStackItem = props.as === 'stack-item';
    const tooltipMessage = isStackItem ? (0, $19nmp.messages).preview_description : (0, $19nmp.messages).preview_improved;
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9hHCO.default), {
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).preview_improved
        }),
        icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1hBh4))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Open preview"
        }),
        onClick: onClick,
        testId: "smart-action-preview-action",
        tooltipMessage: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...tooltipMessage
        }),
        hideTooltipOnMouseDown: true,
        ...data,
        ...props
    }) : null;
};
var $a7238a60227ffb9b$export$2e2bcd8739ae039 = $a7238a60227ffb9b$var$PreviewAction;

});
parcelRegister("1hBh4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::95f2961def649e58284c9134f09a8716>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0ef44ae728b7e983$var$_react = $0ef44ae728b7e983$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $0ef44ae728b7e983$var$_growDiagonal = $0ef44ae728b7e983$var$_interopRequireDefault((parcelRequire("XhTSt")));

var $0ef44ae728b7e983$var$_actualSize = $0ef44ae728b7e983$var$_interopRequireDefault((parcelRequire("2F5b6")));
function $0ef44ae728b7e983$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for GrowDiagonalIcon.
 * This component is GrowDiagonalIcon, with `UNSAFE_fallbackIcon` set to "MediaServicesActualSizeIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for increasing the size of an element when height and width are changed concurrently.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0ef44ae728b7e983$var$GrowDiagonalIcon = (props)=>/*#__PURE__*/ $0ef44ae728b7e983$var$_react.default.createElement($0ef44ae728b7e983$var$_growDiagonal.default, Object.assign({
        LEGACY_fallbackIcon: $0ef44ae728b7e983$var$_actualSize.default
    }, props));
$0ef44ae728b7e983$var$GrowDiagonalIcon.Name = 'GrowDiagonalIconMigration';
var $0ef44ae728b7e983$var$_default = module.exports.default = $0ef44ae728b7e983$var$GrowDiagonalIcon;

});
parcelRegister("XhTSt", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4fa3a459488ae98c9a4dea821f09e885>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0b23656b9dea9ae5$var$_react = $0b23656b9dea9ae5$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $0b23656b9dea9ae5$var$_baseNew = $0b23656b9dea9ae5$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $0b23656b9dea9ae5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "GrowDiagonal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for increasing the size of an element when height and width are changed concurrently.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0b23656b9dea9ae5$var$GrowDiagonalIcon = (props)=>/*#__PURE__*/ $0b23656b9dea9ae5$var$_react.default.createElement($0b23656b9dea9ae5$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.78 2.28 9.53 7.53 8.47 6.47l5.25-5.25zM1.22 13.72l5.25-5.25 1.06 1.06-5.25 5.25z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M9.5 1h4.75a.75.75 0 0 1 .75.75V6.5h-1.5v-4h-4zm-7 12.5v-4H1v4.75c0 .414.336.75.75.75H6.5v-1.5z" clip-rule="evenodd"/>`
    }, props));
$0b23656b9dea9ae5$var$GrowDiagonalIcon.displayName = 'GrowDiagonalIcon';
var $0b23656b9dea9ae5$var$_default = module.exports.default = $0b23656b9dea9ae5$var$GrowDiagonalIcon;

});

parcelRegister("2F5b6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1f036d580202d537$var$_react = $1f036d580202d537$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $1f036d580202d537$var$_growDiagonal = $1f036d580202d537$var$_interopRequireDefault((parcelRequire("XhTSt")));
function $1f036d580202d537$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1f036d580202d537$var$MediaServicesActualSizeIcon = (props)=>/*#__PURE__*/ $1f036d580202d537$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M16.587 6.003H15A1 1 0 0 1 15 4h3.9l.047.001a.98.98 0 0 1 .736.285l.032.032c.2.2.296.47.284.736l.001.048v3.896a1 1 0 1 1-2 0V7.411l-3.309 3.308a.977.977 0 0 1-1.374-.005l-.032-.032a.976.976 0 0 1-.005-1.374zM7.413 17.997H9A1 1 0 0 1 9 20H5.1l-.047-.001a.98.98 0 0 1-.736-.285l-.032-.032A.98.98 0 0 1 4 18.946v-3.944a1 1 0 1 1 2 0v1.587l3.309-3.308a.977.977 0 0 1 1.374.005l.032.032a.976.976 0 0 1 .005 1.374z"/></svg>`
    }, props, {
        newIcon: $1f036d580202d537$var$_growDiagonal.default
    }));
$1f036d580202d537$var$MediaServicesActualSizeIcon.displayName = 'MediaServicesActualSizeIcon';
var $1f036d580202d537$var$_default = module.exports.default = $1f036d580202d537$var$MediaServicesActualSizeIcon;

});



parcelRegister("b1dbu", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbc64436e41aec7f$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $av9Of = parcelRequire("av9Of");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $7xssH = parcelRequire("7xssH");

var $9hHCO = parcelRequire("9hHCO");
const $cbc64436e41aec7f$var$CopyLinkAction = ({ onClick: onClickCallback, ...props })=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const invoke = (0, $7xssH.default)({});
    const data = context?.actions?.[(0, $5NtHI.ActionName).CopyLinkAction];
    const [tooltipMessage, setTooltipMessage] = (0, $eJOHy.useState)((0, $19nmp.messages).copy_url_to_clipboard);
    const onClick = (0, $eJOHy.useCallback)(()=>{
        if (data?.invokeAction) {
            invoke({
                ...data.invokeAction,
                actionFn: async ()=>{
                    await data.invokeAction?.actionFn();
                    setTooltipMessage((0, $19nmp.messages).copied_url_to_clipboard);
                }
            });
            onClickCallback?.();
        }
    }, [
        data,
        invoke,
        onClickCallback
    ]);
    return data ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9hHCO.default), {
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).copy_url_to_clipboard
        }),
        icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($av9Of))), {
            color: "currentColor",
            label: "copy url",
            LEGACY_size: "medium",
            spacing: "spacious"
        }),
        onClick: onClick,
        testId: "smart-action-copy-link-action",
        tooltipMessage: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...tooltipMessage
        }),
        tooltipOnHide: ()=>setTooltipMessage((0, $19nmp.messages).copy_url_to_clipboard),
        ...data,
        ...props
    }) : null;
};
var $cbc64436e41aec7f$export$2e2bcd8739ae039 = $cbc64436e41aec7f$var$CopyLinkAction;

});

parcelRegister("cLrUd", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c33132973d68a83$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $8IeH1 = parcelRequire("8IeH1");
var $46R8N = parcelRequire("46R8N");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");
const $8c33132973d68a83$var$styles = {
    button: "_1e0c1bgi",
    message: "_1rjcze3t _18zrze3t"
};
const $8c33132973d68a83$var$UnresolvedAction = ({ testId: testId = 'unresolved-action' })=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const data = context?.actions?.[(0, $5NtHI.InternalActionName).UnresolvedAction];
    if (!data) return null;
    const { descriptor: descriptor, onClick: onClick, values: values } = data;
    const hasAction = onClick !== undefined;
    const message = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        testId: `${testId}-errored-view-message`,
        tabIndex: hasAction ? 0 : undefined,
        xcss: $8c33132973d68a83$var$styles.message,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...descriptor,
            values: values
        })
    });
    return hasAction ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $46R8N.default), {
        onClick: data.onClick,
        style: {
            color: `inherit`,
            font: `inherit`,
            textAlign: `inherit`
        },
        xcss: $8c33132973d68a83$var$styles.button,
        children: message
    }) : message;
};
var $8c33132973d68a83$export$2e2bcd8739ae039 = $8c33132973d68a83$var$UnresolvedAction;

});

parcelRegister("2fs4B", function(module, exports) {

$parcel$export(module.exports, "default", () => $b30a89f78a7b1395$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $3IFDE = parcelRequire("3IFDE");
const $b30a89f78a7b1395$var$AISummaryAction = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $5NtHI.InternalActionName).AISummaryAction];
    return actionData ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3IFDE.AISummaryActionComponent), {
        ...actionData,
        ...props
    }) : null;
};
var $b30a89f78a7b1395$export$2e2bcd8739ae039 = $b30a89f78a7b1395$var$AISummaryAction;

});
parcelRegister("3IFDE", function(module, exports) {

$parcel$export(module.exports, "AISummaryActionComponent", () => $f1effd59dd51917b$export$8eed96bc6d982595);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");

var $2LycE = parcelRequire("2LycE");

var $4N9mw = parcelRequire("4N9mw");

var $9ljdO = parcelRequire("9ljdO");
const $f1effd59dd51917b$export$8eed96bc6d982595 = (props)=>{
    (0, $gRw8I.di)((0, $2LycE.default));
    const { url: url, onLoadingChange: onLoadingChange, testId: testId = 'smart-action-ai-summary-action' } = props;
    const { state: { status: status, content: content }, summariseUrl: summariseUrl } = (0, $2LycE.default)(url);
    (0, $eJOHy.useEffect)(()=>{
        onLoadingChange?.(status === 'loading');
    }, [
        onLoadingChange,
        status
    ]);
    return status === 'done' ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9ljdO.CopySummaryAction), {
        ...props,
        testId: testId,
        content: content
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4N9mw.AISummariseAction), {
        ...props,
        testId: testId,
        summariseUrl: summariseUrl,
        status: status
    });
};

});
parcelRegister("2LycE", function(module, exports) {

$parcel$export(module.exports, "default", () => $442e3e8f06b649b8$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $9R3Jd = parcelRequire("9R3Jd");
var $3seWH = parcelRequire("3seWH");

var $bmWcp = parcelRequire("bmWcp");

var $1mLfK = parcelRequire("1mLfK");

var $5TXKo = parcelRequire("5TXKo");

var $5sknP = parcelRequire("5sknP");

var $k2hJv = parcelRequire("k2hJv");
const $442e3e8f06b649b8$var$EXPERIENCE_NAME = 'smart-link-ai-summary';
const $442e3e8f06b649b8$var$useAISummaryAction = (url)=>{
    const { baseUrl: baseUrl, envKey: envKey, product: product } = (0, $k2hJv.useAISummaryConfig)();
    const cardState = (0, $5TXKo.useSmartCardState)(url);
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const data = cardState.details?.data;
    const ari = data && (0, $9R3Jd.extractAri)(data);
    const dataUrl = data && (0, $3seWH.extractLink)(data) || '';
    const onStart = (0, $eJOHy.useCallback)((id)=>{
        (0, $1mLfK.startUfoExperience)($442e3e8f06b649b8$var$EXPERIENCE_NAME, id);
    }, []);
    const onSuccess = (0, $eJOHy.useCallback)((id)=>{
        fireEvent('operational.summary.success', {});
        (0, $1mLfK.succeedUfoExperience)($442e3e8f06b649b8$var$EXPERIENCE_NAME, id);
    }, [
        fireEvent
    ]);
    const onError = (0, $eJOHy.useCallback)((id, reason)=>{
        /**
			 * Errors should only be counted to the SLO if they are not due to acceptable use violations
			 * HIPAA content detected or exceeding context length.
			 */ const isSloError = reason === undefined ? true : ![
            'ACCEPTABLE_USE_VIOLATIONS',
            'HIPAA_CONTENT_DETECTED',
            'EXCEEDING_CONTEXT_LENGTH_ERROR'
        ].includes(reason);
        fireEvent('operational.summary.failed', {
            reason: reason || null,
            isSloError: isSloError
        });
        (0, $1mLfK.failUfoExperience)($442e3e8f06b649b8$var$EXPERIENCE_NAME, id);
    }, [
        fireEvent
    ]);
    return (0, $5sknP.useAISummary)({
        url: dataUrl,
        ari: ari,
        product: product,
        envKey: envKey,
        baseUrl: baseUrl,
        onStart: onStart,
        onSuccess: onSuccess,
        onError: onError
    });
};
var $442e3e8f06b649b8$export$2e2bcd8739ae039 = $442e3e8f06b649b8$var$useAISummaryAction;

});
parcelRegister("5sknP", function(module, exports) {

$parcel$export(module.exports, "useAISummary", () => $6fd5d4bf14cfbb0f$export$becd8f2eba1bbd96);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $bI4It = parcelRequire("bI4It");

var $64EXn = parcelRequire("64EXn");
const $6fd5d4bf14cfbb0f$export$becd8f2eba1bbd96 = (props)=>{
    const { url: url, baseUrl: baseUrl, product: product, ari: ari, envKey: envKey, onError: onError, onStart: onStart, onSuccess: onSuccess } = props;
    const [state, setState] = (0, $eJOHy.useState)((0, $64EXn.AISummariesStore).get(url)?.state || {
        status: 'ready',
        content: ''
    });
    const { locale: locale } = (0, $lRq8t.default)();
    (0, $eJOHy.useEffect)(()=>{
        //do not create a service for the empty URL string when the link data is not yet available,
        //or the service has already been created and cached.
        if (url && !(0, $64EXn.AISummariesStore).get(url)) (0, $64EXn.AISummariesStore).set(url, new (0, $bI4It.AISummaryService)({
            url: url,
            ari: ari,
            baseUrl: baseUrl,
            product: product,
            envKey: envKey,
            locale: locale,
            onError: onError,
            onStart: onStart,
            onSuccess: onSuccess
        }));
        //returns function that calls unsubscribe method
        return (0, $64EXn.AISummariesStore).get(url)?.subscribe(setState);
    }, [
        url,
        baseUrl,
        onError,
        onStart,
        onSuccess,
        product,
        ari,
        envKey,
        locale
    ]);
    const summariseUrl = ()=>{
        return (0, $64EXn.AISummariesStore).get(url)?.summariseUrl();
    };
    return {
        summariseUrl: summariseUrl,
        state: state
    };
};

});
parcelRegister("bI4It", function(module, exports) {

$parcel$export(module.exports, "AISummaryService", () => $ee3df5d12a847ac3$export$73e4b807d5bd74b6);

var $aXKmr = parcelRequire("aXKmr");

var $a5MXk = parcelRequire("a5MXk");

var $eGOwo = parcelRequire("eGOwo");

var $4NcaA = parcelRequire("4NcaA");

var $8hWqs = parcelRequire("8hWqs");

var $9ntiN = parcelRequire("9ntiN");
const $ee3df5d12a847ac3$var$CONVO_AI_ENDPOINT = 'assist/api/ai/v2/ai-feature/smartlinksummary/stream';
class $ee3df5d12a847ac3$export$73e4b807d5bd74b6 {
    constructor(props){
        this.state = {
            content: '',
            status: 'ready'
        };
        this.subscribedStateSetters = new Set();
        this.getRequestUrl = (envKey, baseUrlOverride)=>{
            const path = (0, $eGOwo.fg)('platform-linking-ai-summary-migration-to-convo-ai') ? $ee3df5d12a847ac3$var$CONVO_AI_ENDPOINT : 'assist/chat/v1/invoke_agent/stream';
            if (baseUrlOverride || envKey) {
                const baseUrl = baseUrlOverride || (0, $a5MXk.getBaseUrl)(envKey);
                return (0, $9ntiN.addPath)(baseUrl, path);
            }
            return (0, $9ntiN.addPath)('/gateway/api/', path);
        };
        this.fetchStream = async ()=>{
            const payload = {
                recipient_agent_named_id: 'smartlink_summary_agent',
                agent_input_context: {
                    content_url: this.url,
                    content_ari: this.ari,
                    prompt_id: 'smart_links',
                    summary_output_mimetype: 'text/markdown',
                    locale: this.locale
                },
                ai_feature_input: (0, $eGOwo.fg)('platform-linking-ai-summary-migration-to-convo-ai') ? {
                    content_url: this.url,
                    content_ari: this.ari,
                    locale: this.locale
                } : undefined
            };
            const options = {
                method: 'POST',
                headers: this.config.headers,
                body: JSON.stringify(payload),
                credentials: 'include'
            };
            const response = await fetch(this.config.requestUrl, options);
            if (!response.ok || response.status >= 400) throw new Error(`Status: ${response.status}\n URL: ${this.url}\n StatusText ${response.statusText}`);
            else return (0, $4NcaA.readStream)(response);
        };
        this.config = {
            requestUrl: this.getRequestUrl(props.envKey, props.baseUrl),
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'x-experience-id': 'smart-link',
                'x-product': (0, $9ntiN.getXProductHeaderValue)(props.product)?.toLowerCase() || 'confluence'
            }
        };
        this.url = props.url;
        this.ari = props.ari;
        this.locale = props.locale;
        this.onStart = props.onStart;
        this.onSuccess = props.onSuccess;
        this.onError = props.onError;
    }
    async summariseUrl() {
        this.state = {
            status: 'loading',
            content: ''
        };
        for (const subscriber of this.subscribedStateSetters)subscriber(this.state);
        const id = (0, (/*@__PURE__*/$parcel$interopDefault($aXKmr)))();
        try {
            this.onStart?.(id);
            const stream = await this.fetchStream();
            let bufferContent = '';
            for await (const chunk of stream){
                if (chunk.type === 'ANSWER_PART') {
                    bufferContent += chunk.message.content;
                    for (const subscriber of this.subscribedStateSetters)subscriber({
                        ...this.state,
                        content: bufferContent
                    });
                }
                //if AI Mate service returns cached summary we get the summary text in one piece as the last message
                if (chunk.type === 'FINAL_RESPONSE') bufferContent = (0, $eGOwo.fg)('platform-linking-ai-summary-migration-to-convo-ai') ? chunk.message.content : chunk.message.message.content;
                if (chunk.type === 'ERROR') throw new (0, $8hWqs.ChunkProcessingError)(chunk?.message?.message_template);
            }
            this.onSuccess?.(id);
            this.state = {
                status: 'done',
                content: bufferContent
            };
        } catch (err) {
            let message = err instanceof (0, $8hWqs.ChunkProcessingError) ? err.message : 'UNEXPECTED';
            this.onError?.(id, message);
            this.state = {
                status: 'error',
                content: '',
                error: message
            };
        }
        for (const subscriber of this.subscribedStateSetters)subscriber(this.state);
        return this.state;
    }
    subscribe(stateSetter) {
        this.subscribedStateSetters.add(stateSetter);
        return ()=>{
            this.subscribedStateSetters.delete(stateSetter);
        };
    }
}

});
parcelRegister("4NcaA", function(module, exports) {

$parcel$export(module.exports, "readStream", () => $3c1ef1a29697a261$export$e45226161c660403);

var $9ntiN = parcelRequire("9ntiN");
async function* $3c1ef1a29697a261$export$e45226161c660403(response) {
    const reader = (0, $9ntiN.getBufferReader)(response);
    let doneStreaming = false;
    let chunkBuffer = '';
    do try {
        const { value: value, done: done } = await reader.read();
        doneStreaming = done;
        if (value) {
            const processedChunks = `${chunkBuffer}${value}`.split('\n'); // assumes that all JSON chunks are separated by a new-line;
            chunkBuffer = '';
            for (let chunk of processedChunks)try {
                const jsonChunk = JSON.parse(chunk);
                if (jsonChunk.type === 'ERROR') reader.cancel();
                yield jsonChunk;
            } catch (e) {
                // the chunk may be incomplete, so we'll save it for the next iteration.
                chunkBuffer = chunk;
            }
        }
    } catch (e) {
        // If we abort the call, this exception bubbles up, so we want to catch it and exit gracefully
        if (e instanceof DOMException && e.name === 'AbortError') doneStreaming = true;
        else {
            reader.cancel();
            throw e;
        }
    }
    while (!doneStreaming);
    if (chunkBuffer) {
        const error = new Error(`Not all the data was processed: ${chunkBuffer}`);
        throw error;
    }
}

});
parcelRegister("9ntiN", function(module, exports) {

$parcel$export(module.exports, "getBufferReader", () => $75d74a4f0b187756$export$f6383c3ea1307da9);
$parcel$export(module.exports, "addPath", () => $75d74a4f0b187756$export$4c25481b843feb0b);
$parcel$export(module.exports, "getXProductHeaderValue", () => $75d74a4f0b187756$export$ff2962de2b2c930f);
const $75d74a4f0b187756$export$f6383c3ea1307da9 = (response)=>{
    if (!response.body) throw new Error('Response body is empty');
    return response.body.pipeThrough(new TextDecoderStream()).getReader();
};
const $75d74a4f0b187756$export$4c25481b843feb0b = (baseUrl, path)=>{
    const urlWithTrailingSlash = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
    const pathWithoutLeadingSlash = !path.startsWith('/') ? path : path.substring(1, path.length);
    const url = [
        urlWithTrailingSlash,
        pathWithoutLeadingSlash
    ].join('');
    return url;
};
/**
 * Subset of a map of Jira `ProductTypes` to AI Mate expected values
 * See for more info: https://atlassian.slack.com/archives/C066UP0G0G3/p1716341647677829?thread_ts=1716338063.255939&cid=C066UP0G0G3
 */ const $75d74a4f0b187756$var$AiMateJiraXProduct = {
    JSM: 'JSM',
    JSW: 'JIRA-SOFTWARE',
    JWM: 'JIRA-CORE',
    JPD: 'JPD'
};
/**
 * Checks if `product` is a Jira related product.
 */ const $75d74a4f0b187756$var$isJiraProduct = (product)=>{
    const JIRA_PRODUCTS = [
        'JPD',
        'JSM',
        'JSW',
        'JWM'
    ];
    return product !== undefined && JIRA_PRODUCTS.includes(product);
};
const $75d74a4f0b187756$export$ff2962de2b2c930f = (product)=>{
    if ($75d74a4f0b187756$var$isJiraProduct(product)) return $75d74a4f0b187756$var$AiMateJiraXProduct[product];
    return product;
};

});


parcelRegister("8hWqs", function(module, exports) {

$parcel$export(module.exports, "ChunkProcessingError", () => $424f983e1007104e$export$fcec967a4b7ebd84);
class $424f983e1007104e$export$fcec967a4b7ebd84 extends Error {
    constructor(error){
        super(error);
    }
}
const $424f983e1007104e$export$d8bd0967cb58683 = [
    'NETWORK_ERROR',
    'NO_ANSWER',
    'RATE_LIMIT',
    'NO_AGENT',
    'PLUGIN_ERRORED',
    'OPENAI_RATE_LIMIT_USER_ABUSE',
    'ACCEPTABLE_USE_VIOLATIONS',
    'AI_DISABLED',
    'UNEXPECTED',
    'HIPAA_CONTENT_DETECTED',
    'EXCEEDING_CONTEXT_LENGTH_ERROR'
];

});


parcelRegister("64EXn", function(module, exports) {

$parcel$export(module.exports, "AISummariesStore", () => $6b567d039eac44f3$export$6979339b6d41707e);

var $7xkt0 = parcelRequire("7xkt0");
const $6b567d039eac44f3$var$AI_SUMMARY_CACHE_SIZE = 100;
const $6b567d039eac44f3$export$6979339b6d41707e = new (0, $7xkt0.LRUMap)($6b567d039eac44f3$var$AI_SUMMARY_CACHE_SIZE);

});


parcelRegister("k2hJv", function(module, exports) {

$parcel$export(module.exports, "useAISummaryConfig", () => $3042bebadd8b2921$export$4480af2c00aa7ebe);

var $eJOHy = parcelRequire("eJOHy");

var $9kfy2 = parcelRequire("9kfy2");
const $3042bebadd8b2921$export$4480af2c00aa7ebe = ()=>{
    const { connections: connections, product: product, isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $9kfy2.useSmartLinkContext)();
    return (0, $eJOHy.useMemo)(()=>({
            baseUrl: connections.client.baseUrlOverride,
            envKey: connections.client.envKey,
            product: product,
            isAdminHubAIEnabled: isAdminHubAIEnabled
        }), [
        connections.client.baseUrlOverride,
        connections.client.envKey,
        product,
        isAdminHubAIEnabled
    ]);
};

});


parcelRegister("4N9mw", function(module, exports) {

$parcel$export(module.exports, "AISummariseAction", () => $74950477f844069d$export$75a19de44af58722);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $fOqNz = parcelRequire("fOqNz");

var $bmWcp = parcelRequire("bmWcp");

var $19nmp = parcelRequire("19nmp");

var $jeUcl = parcelRequire("jeUcl");

var $9hHCO = parcelRequire("9hHCO");

var $4XsCU = parcelRequire("4XsCU");
function $74950477f844069d$export$75a19de44af58722({ url: url, onClick: onClickCallback, onError: onErrorCallback, testId: testId, status: status, summariseUrl: summariseUrl, ...props }) {
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const onCompleted = (0, $eJOHy.useCallback)((state)=>{
        if (state?.status === 'error') onErrorCallback?.((0, $4XsCU.getErrorMessage)(state.error));
    }, [
        onErrorCallback
    ]);
    const handleActionClick = (0, $eJOHy.useCallback)(()=>{
        fireEvent('ui.button.clicked.aiSummary', {});
        fireEvent('track.aiInteraction.initiated', {
            aiFeatureName: 'Smart Links Summary',
            proactiveAIGenerated: 0,
            userGeneratedAI: 1
        });
        summariseUrl()?.then(onCompleted, onCompleted);
        onClickCallback?.();
    }, [
        fireEvent,
        onClickCallback,
        onCompleted,
        summariseUrl
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9hHCO.default), {
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).ai_summary_action
        }),
        icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fOqNz))), {
            spacing: "spacious",
            color: "currentColor",
            label: "Summarise with AI",
            LEGACY_fallbackIcon: (0, $jeUcl.default)
        }),
        onClick: handleActionClick,
        testId: `${testId}-summarise-action`,
        isLoading: status === 'loading',
        tooltipMessage: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).ai_summary_action_description
        }),
        ...props
    });
}

});
parcelRegister("fOqNz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b8054c1d672105cf334f7f37a83f0cf2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b830502683dea4c7$var$_react = $b830502683dea4c7$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $b830502683dea4c7$var$_baseNew = $b830502683dea4c7$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $b830502683dea4c7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AtlassianIntelligence".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Atlassian Intelligence products or experiences.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b830502683dea4c7$var$AtlassianIntelligenceIcon = (props)=>/*#__PURE__*/ $b830502683dea4c7$var$_react.default.createElement($b830502683dea4c7$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.25 4V1h1.5v3zM5.47 6.53l-4-4 1.06-1.06 4 4zm4-1.06 4-4 1.06 1.06-4 4zM1 7.25h3v1.5H1zm11 0h3v1.5h-3zM1.47 13.47l4-4 1.06 1.06-4 4zm12 1.06-4-4 1.06-1.06 4 4zM7.25 15v-3h1.5v3z" clip-rule="evenodd"/>`
    }, props));
$b830502683dea4c7$var$AtlassianIntelligenceIcon.displayName = 'AtlassianIntelligenceIcon';
var $b830502683dea4c7$var$_default = module.exports.default = $b830502683dea4c7$var$AtlassianIntelligenceIcon;

});

parcelRegister("jeUcl", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f62baba7cd68ce1$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $2Swhg = parcelRequire("2Swhg");
/**
 * The bulk of this file is originally from
 * https://bitbucket.org/atlassian/barrel/src/master/ui/platform/ui-kit/ai
 * with modifications
 */ const $9f62baba7cd68ce1$var$AiIcon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $2Swhg.default), {
        ...props,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)("g", {
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M17.17 12C17.17 11.4477 17.6177 11 18.17 11H20C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13H18.17C17.6177 13 17.17 12.5523 17.17 12Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M12 3C12.5523 3 13 3.44772 13 4V5.83C13 6.38228 12.5523 6.83 12 6.83C11.4477 6.83 11 6.38228 11 5.83V4C11 3.44772 11.4477 3 12 3Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M3 12C3 11.4477 3.44772 11 4 11H5.83C6.38228 11 6.83 11.4477 6.83 12C6.83 12.5523 6.38228 13 5.83 13H4C3.44772 13 3 12.5523 3 12Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M12 17.17C12.5523 17.17 13 17.6177 13 18.17V20C13 20.5523 12.5523 21 12 21C11.4477 21 11 20.5523 11 20V18.17C11 17.6177 11.4477 17.17 12 17.17Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M14.2929 14.2929C14.6835 13.9024 15.3166 13.9024 15.7071 14.2929L19.7071 18.2929C20.0977 18.6834 20.0977 19.3166 19.7071 19.7071C19.3166 20.0976 18.6835 20.0976 18.2929 19.7071L14.2929 15.7071C13.9024 15.3166 13.9024 14.6834 14.2929 14.2929Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M19.7071 4.29289C20.0977 4.68342 20.0977 5.31658 19.7071 5.70711L15.7071 9.70711C15.3166 10.0976 14.6835 10.0976 14.2929 9.70711C13.9024 9.31658 13.9024 8.68342 14.2929 8.29289L18.2929 4.29289C18.6835 3.90237 19.3166 3.90237 19.7071 4.29289Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M4.29289 4.29289C4.68342 3.90237 5.31658 3.90237 5.70711 4.29289L9.70711 8.29289C10.0976 8.68342 10.0976 9.31658 9.70711 9.70711C9.31658 10.0976 8.68342 10.0976 8.29289 9.70711L4.29289 5.70711C3.90237 5.31658 3.90237 4.68342 4.29289 4.29289Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M9.70711 14.2929C10.0976 14.6834 10.0976 15.3166 9.70711 15.7071L5.70711 19.7071C5.31658 20.0976 4.68342 20.0976 4.29289 19.7071C3.90237 19.3166 3.90237 18.6834 4.29289 18.2929L8.29289 14.2929C8.68342 13.9024 9.31658 13.9024 9.70711 14.2929Z",
                    fill: "var(--ds-icon, #44546F)"
                })
            ]
        })
    });
var $9f62baba7cd68ce1$export$2e2bcd8739ae039 = $9f62baba7cd68ce1$var$AiIcon;

});

parcelRegister("4XsCU", function(module, exports) {

$parcel$export(module.exports, "getErrorMessage", () => $97c2d7f54971c4db$export$82f46aa4e6535a45);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $7tQSx = parcelRequire("7tQSx");

var $2Q7aM = parcelRequire("2Q7aM");

var $hDtQ6 = parcelRequire("hDtQ6");
const $97c2d7f54971c4db$export$82f46aa4e6535a45 = (error)=>{
    const { message: message, url: url } = (0, $7tQSx.getAISummaryErrorMessage)(error);
    return {
        appearance: 'error',
        title: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2Q7aM.default), {
                    reason: error
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...message,
                    values: {
                        a: (chunks)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $hDtQ6.default), {
                                href: url,
                                children: chunks
                            })
                    }
                })
            ]
        })
    };
};

});
parcelRegister("7tQSx", function(module, exports) {

$parcel$export(module.exports, "getIsAISummaryEnabled", () => $9b4bccd413fec8a7$export$d439c74cb206ff29);
$parcel$export(module.exports, "getAISummaryErrorMessage", () => $9b4bccd413fec8a7$export$cd2e891d7f87074d);

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");
const $9b4bccd413fec8a7$export$d439c74cb206ff29 = (isAdminHubAIEnabled = false, response)=>Boolean(isAdminHubAIEnabled && response?.meta?.supportedFeature?.includes('AISummary'));
const $9b4bccd413fec8a7$export$cd2e891d7f87074d = (error)=>{
    switch(error){
        case 'ACCEPTABLE_USE_VIOLATIONS':
            return {
                message: (0, $19nmp.messages).ai_summary_error_acceptable_use_violation,
                url: (0, $5NtHI.CONTENT_URL_ACCEPTABLE_USE_POLICY)
            };
        case 'HIPAA_CONTENT_DETECTED':
            return {
                message: (0, $19nmp.messages).ai_summary_error_hipaa_content_detected
            };
        case 'EXCEEDING_CONTEXT_LENGTH_ERROR':
            return {
                message: (0, $19nmp.messages).ai_summary_error_exceeding_context_length_error
            };
        default:
            return {
                message: (0, $19nmp.messages).ai_summary_error_generic,
                url: (0, $5NtHI.CONTENT_URL_AI_TROUBLESHOOTING)
            };
    }
};

});

parcelRegister("2Q7aM", function(module, exports) {

$parcel$export(module.exports, "default", () => $af835e3708ee9394$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $bmWcp = parcelRequire("bmWcp");
const $af835e3708ee9394$var$AIEventErrorViewed = ({ reason: reason })=>{
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        fireEvent('ui.error.viewed.aiSummary', {
            reason: reason
        });
    }, [
        fireEvent,
        reason
    ]);
    return null;
};
var $af835e3708ee9394$export$2e2bcd8739ae039 = $af835e3708ee9394$var$AIEventErrorViewed;

});

parcelRegister("hDtQ6", function(module, exports) {

$parcel$export(module.exports, "default", () => $4df7b5a8aadcea38$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $eJ9f5 = parcelRequire("eJ9f5");

var $5NtHI = parcelRequire("5NtHI");
const $4df7b5a8aadcea38$var$AILearnMoreAnchor = ({ children: children, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJ9f5.default), {
        href: (0, $5NtHI.CONTENT_URL_AI),
        target: "_blank",
        rel: "noopener noreferrer",
        ...props,
        children: children
    });
var $4df7b5a8aadcea38$export$2e2bcd8739ae039 = $4df7b5a8aadcea38$var$AILearnMoreAnchor;

});



parcelRegister("9ljdO", function(module, exports) {

$parcel$export(module.exports, "CopySummaryAction", () => $d9ba8f475ac91e83$export$cfa1d3eed9a61059);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $4TA31 = parcelRequire("4TA31");

var $bmWcp = parcelRequire("bmWcp");

var $19nmp = parcelRequire("19nmp");

var $9hHCO = parcelRequire("9hHCO");
function $d9ba8f475ac91e83$export$cfa1d3eed9a61059({ url: url, onClick: onClickCallback, testId: testId, content: content, ...props }) {
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const [tooltipMessage, setTooltipMessage] = (0, $eJOHy.useState)((0, $19nmp.messages).copy_summary_action_description);
    const handleCopySummaryClick = (0, $eJOHy.useCallback)(async ()=>{
        fireEvent('ui.button.clicked.copySummary', {});
        await navigator.clipboard.writeText(content ?? '');
        setTooltipMessage((0, $19nmp.messages).copied_summary_action_description);
        onClickCallback?.();
    }, [
        fireEvent,
        onClickCallback,
        content
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9hHCO.default), {
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).copy_summary_action
        }),
        icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4TA31))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Copy Summary"
        }),
        onClick: handleCopySummaryClick,
        testId: `${testId}-copy-summary-action`,
        tooltipMessage: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...tooltipMessage
        }),
        tooltipOnHide: ()=>setTooltipMessage((0, $19nmp.messages).copy_summary_action_description),
        ...props
    });
}

});
parcelRegister("4TA31", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::746afd86dff7a846534476462b8fe4e7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $390842c9527311f0$var$_react = $390842c9527311f0$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $390842c9527311f0$var$_copy = $390842c9527311f0$var$_interopRequireDefault((parcelRequire("lGr6J")));

var $390842c9527311f0$var$_copy2 = $390842c9527311f0$var$_interopRequireDefault((parcelRequire("hZKKB")));
function $390842c9527311f0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CopyIcon.
 * This component is CopyIcon, with `UNSAFE_fallbackIcon` set to "CopyIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for copying data such as text, code or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $390842c9527311f0$var$CopyIcon = (props)=>/*#__PURE__*/ $390842c9527311f0$var$_react.default.createElement($390842c9527311f0$var$_copy.default, Object.assign({
        LEGACY_fallbackIcon: $390842c9527311f0$var$_copy2.default
    }, props));
$390842c9527311f0$var$CopyIcon.Name = 'CopyIconMigration';
var $390842c9527311f0$var$_default = module.exports.default = $390842c9527311f0$var$CopyIcon;

});
parcelRegister("lGr6J", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cbd1068d7fb082440154244857d12f2c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fc928c338a001a7a$var$_react = $fc928c338a001a7a$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fc928c338a001a7a$var$_baseNew = $fc928c338a001a7a$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $fc928c338a001a7a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Copy".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for copying data such as text, code or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fc928c338a001a7a$var$CopyIcon = (props)=>/*#__PURE__*/ $fc928c338a001a7a$var$_react.default.createElement($fc928c338a001a7a$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM16 6v6.75A3.25 3.25 0 0 1 12.75 16H6v-1.5h6.75a1.75 1.75 0 0 0 1.75-1.75V6z" clip-rule="evenodd"/>`
    }, props));
$fc928c338a001a7a$var$CopyIcon.displayName = 'CopyIcon';
var $fc928c338a001a7a$var$_default = module.exports.default = $fc928c338a001a7a$var$CopyIcon;

});

parcelRegister("hZKKB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d19c65e3fa3f02f9$var$_react = $d19c65e3fa3f02f9$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $d19c65e3fa3f02f9$var$_copy = $d19c65e3fa3f02f9$var$_interopRequireDefault((parcelRequire("lGr6J")));
function $d19c65e3fa3f02f9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d19c65e3fa3f02f9$var$CopyIcon = (props)=>/*#__PURE__*/ $d19c65e3fa3f02f9$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M10 19h8V8h-8zM8 7.992C8 6.892 8.902 6 10.009 6h7.982C19.101 6 20 6.893 20 7.992v11.016c0 1.1-.902 1.992-2.009 1.992H10.01A2 2 0 0 1 8 19.008z"/><path d="M5 16V4.992C5 3.892 5.902 3 7.009 3H15v13zm2 0h8V5H7z"/></g></svg>`
    }, props, {
        newIcon: $d19c65e3fa3f02f9$var$_copy.default
    }));
$d19c65e3fa3f02f9$var$CopyIcon.displayName = 'CopyIcon';
var $d19c65e3fa3f02f9$var$_default = module.exports.default = $d19c65e3fa3f02f9$var$CopyIcon;

});





parcelRegister("1EoLm", function(module, exports) {

$parcel$export(module.exports, "default", () => $807f9b07437985a7$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");
var $lRq8t = parcelRequire("lRq8t");

var $dtpha = parcelRequire("dtpha");

var $3cMgR = parcelRequire("3cMgR");

var $bmWcp = parcelRequire("bmWcp");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $fezTc = parcelRequire("fezTc");

var $9hHCO = parcelRequire("9hHCO");

var $4iE29 = parcelRequire("4iE29");

var $kkF5t = parcelRequire("kkF5t");

const $807f9b07437985a7$var$AutomationModal = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("aQZ7P")));
const $807f9b07437985a7$var$AutomationAction = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const modal = (0, $fezTc.useSmartLinkModal)();
    const { onClick: onClickCallback } = props;
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const automationActionData = context?.actions?.[(0, $5NtHI.ActionName).AutomationAction];
    const automationActionOnClick = (0, $eJOHy.useCallback)((automationActionData)=>{
        const { product: product, resourceType: resourceType, baseAutomationUrl: baseAutomationUrl, objectAri: objectAri, siteAri: siteAri, canManageAutomation: canManageAutomation, analyticsSource: analyticsSource, objectName: objectName } = automationActionData;
        fireEvent('ui.button.clicked.automationAction', {});
        const { modalTitle: modalTitle, modalDescription: modalDescription } = (0, $kkF5t.getModalContent)(product, resourceType) || {};
        const automationModalTitle = modalTitle ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...modalTitle
        }) : undefined;
        const automationModalDescription = modalDescription ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...modalDescription,
            values: {
                name: objectName,
                b: (chunks)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                        as: "strong",
                        children: chunks
                    }),
                br: /*#__PURE__*/ (0, $gt9Am.jsx)("br", {})
            }
        }) : undefined;
        modal.open(/*#__PURE__*/ (0, $gt9Am.jsx)($807f9b07437985a7$var$AutomationModal, {
            baseAutomationUrl: baseAutomationUrl,
            objectAri: objectAri,
            siteAri: siteAri,
            canManageAutomation: canManageAutomation,
            analyticsSource: analyticsSource,
            modalTitle: automationModalTitle,
            modalDescription: automationModalDescription,
            onClose: ()=>modal.close()
        }));
        onClickCallback?.();
    }, [
        modal,
        onClickCallback,
        fireEvent
    ]);
    if (!automationActionData) return null;
    const automationActionTitle = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
        ...(0, $19nmp.messages).automation_action_title
    });
    const automationActionTooltip = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
        ...(0, $19nmp.messages).automation_action_tooltip
    });
    const automationActionIconLabel = formatMessage((0, $19nmp.messages).automation_action_icon_label);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9hHCO.default), {
            content: automationActionTitle,
            icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dtpha))), {
                spacing: "spacious",
                LEGACY_fallbackIcon: (0, $4iE29.default),
                color: "currentColor",
                label: automationActionIconLabel
            }),
            testId: "smart-action-automation-action",
            tooltipMessage: automationActionTooltip,
            ...props,
            onClick: ()=>automationActionOnClick(automationActionData)
        })
    });
};
var $807f9b07437985a7$export$2e2bcd8739ae039 = $807f9b07437985a7$var$AutomationAction;

});
parcelRegister("dtpha", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2251b011785916069b749fddb2c5cd02>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9cf1970ee03bcd13$var$_react = $9cf1970ee03bcd13$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $9cf1970ee03bcd13$var$_baseNew = $9cf1970ee03bcd13$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $9cf1970ee03bcd13$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Automation".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved to represent an Automation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9cf1970ee03bcd13$var$AutomationIcon = (props)=>/*#__PURE__*/ $9cf1970ee03bcd13$var$_react.default.createElement($9cf1970ee03bcd13$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M10.377.102a.75.75 0 0 1 .346.847L8.985 7.25h4.265a.75.75 0 0 1 .53 1.28l-7.25 7.25a.75.75 0 0 1-1.253-.73l1.738-6.3H2.75a.75.75 0 0 1-.53-1.28L9.47.22a.75.75 0 0 1 .907-.118M7.43 7.25l1.093-3.96L4.56 7.25zm1.142 1.5-1.093 3.96 3.961-3.96z" clip-rule="evenodd"/>`
    }, props));
$9cf1970ee03bcd13$var$AutomationIcon.displayName = 'AutomationIcon';
var $9cf1970ee03bcd13$var$_default = module.exports.default = $9cf1970ee03bcd13$var$AutomationIcon;

});

parcelRegister("fezTc", function(module, exports) {

$parcel$export(module.exports, "SmartLinkModalProvider", () => $a8c10a96c4151b39$export$bb4eb02a83e1a0f8);
$parcel$export(module.exports, "useSmartLinkModal", () => $a8c10a96c4151b39$export$1fd7f5f21a6d6cb8);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $axOsj = parcelRequire("axOsj");

var $7JfLF = parcelRequire("7JfLF");
const $a8c10a96c4151b39$var$FALLBACK_API = {
    open: ()=>{},
    close: ()=>{}
};
const $a8c10a96c4151b39$export$f4c0a0f23ba57f8c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createContext($a8c10a96c4151b39$var$FALLBACK_API);
const $a8c10a96c4151b39$export$bb4eb02a83e1a0f8 = ({ children: children })=>{
    const [element, setElement] = (0, $eJOHy.useState)(null);
    const api = (0, $eJOHy.useMemo)(()=>({
            open: (modal)=>setElement(/*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Suspense), {
                    fallback: null,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7JfLF.StopPropagation), {
                        children: modal
                    })
                })),
            close: ()=>setElement(null)
        }), []);
    const fallbackRender = (0, $eJOHy.useCallback)(({ resetErrorBoundary: resetErrorBoundary })=>{
        resetErrorBoundary();
        return null;
    }, []);
    const onReset = (0, $eJOHy.useCallback)(()=>setElement(null), []);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)($a8c10a96c4151b39$export$f4c0a0f23ba57f8c.Provider, {
                value: api,
                children: children
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $axOsj.ErrorBoundary), {
                fallbackRender: fallbackRender,
                onReset: onReset,
                children: element
            })
        ]
    });
};
const $a8c10a96c4151b39$export$1fd7f5f21a6d6cb8 = ()=>(0, $eJOHy.useContext)($a8c10a96c4151b39$export$f4c0a0f23ba57f8c);

});
parcelRegister("7JfLF", function(module, exports) {

$parcel$export(module.exports, "StopPropagation", () => $7b6d8602f75ebf94$export$3e100bc08448f36c);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");
const $7b6d8602f75ebf94$var$styles = null;
const $7b6d8602f75ebf94$export$3e100bc08448f36c = ({ children: children })=>{
    const onClick = (0, $eJOHy.useCallback)((e)=>{
        // Prevent click event inside modal from bubble up
        e.stopPropagation();
    }, []);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        onClick: onClick,
        className: (0, $hcewu.default)([
            "_c71lidpf _p12fidpf _kqswstnw"
        ]),
        children: children
    });
};

});


parcelRegister("4iE29", function(module, exports) {

$parcel$export(module.exports, "default", () => $1fe410232594ccf2$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
const $1fe410232594ccf2$var$AutomationManualTriggersGlyph = ({ label: label })=>/*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
        "aria-label": label,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M14 5L10 19",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M14 5L7 12H17L10 19",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
var $1fe410232594ccf2$export$2e2bcd8739ae039 = $1fe410232594ccf2$var$AutomationManualTriggersGlyph;

});

parcelRegister("kkF5t", function(module, exports) {

$parcel$export(module.exports, "getModalContent", () => $c38c894acd6bcefe$export$93e707b363eaf5c8);

var $19nmp = parcelRequire("19nmp");
const $c38c894acd6bcefe$export$93e707b363eaf5c8 = (product, resourceType)=>{
    const modalContentMap = {
        confluence: {
            page: {
                modalTitle: (0, $19nmp.messages).automation_action_confluence_page_modal_title,
                modalDescription: (0, $19nmp.messages).automation_action_confluence_page_modal_description
            }
        }
    };
    return modalContentMap?.[product]?.[resourceType];
};

});

parcelRegister("aQZ7P", function(module, exports) {

let $7e6e2cee59393130$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $7e6e2cee59393130$var$load("kNFvF"),
    $7e6e2cee59393130$var$load("ffQaD"),
    $7e6e2cee59393130$var$load("kvRbA"),
    $7e6e2cee59393130$var$load("kVzfx")
]).then(()=>parcelRequire('kczS3'));

});


parcelRegister("bKvNh", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f8cb4fc04a0fca0$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $eGOwo = parcelRequire("eGOwo");

var $bmWcp = parcelRequire("bmWcp");

var $19nmp = parcelRequire("19nmp");

var $5FRJ8 = parcelRequire("5FRJ8");

var $fezTc = parcelRequire("fezTc");

var $9hHCO = parcelRequire("9hHCO");

var $8wmgQ = parcelRequire("8wmgQ");

const $1f8cb4fc04a0fca0$var$RelatedLinksModal = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("9EkqU")));
const $1f8cb4fc04a0fca0$var$ViewRelatedLinksAction = ({ onClick: onClickCallback, ...props })=>{
    const modal = (0, $fezTc.useSmartLinkModal)();
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const actionData = context?.actions?.ViewRelatedLinksAction;
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const onClick = (0, $eJOHy.useCallback)(()=>{
        const ari = actionData?.ari;
        if (ari) modal.open(/*#__PURE__*/ (0, $gt9Am.jsx)($1f8cb4fc04a0fca0$var$RelatedLinksModal, {
            ari: ari,
            showModal: true,
            onClose: ()=>modal.close()
        }));
        fireEvent('ui.button.clicked.relatedLinks', {});
        onClickCallback?.();
    }, [
        actionData?.ari,
        fireEvent,
        modal,
        onClickCallback
    ]);
    return actionData ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9hHCO.default), {
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $eGOwo.fg)('platform-linking-visual-refresh-v2') ? (0, $19nmp.messages).related_links_view_related_links : (0, $19nmp.messages).related_links_view_related_urls
        }),
        icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8wmgQ.default), {}),
        onClick: onClick,
        testId: "smart-action-view-related-links-action",
        ariaLabel: "View most recent pages or content types coming from or found on this link",
        ...props
    }) : null;
};
var $1f8cb4fc04a0fca0$export$2e2bcd8739ae039 = $1f8cb4fc04a0fca0$var$ViewRelatedLinksAction;

});
parcelRegister("8wmgQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c344254860ed9d13$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $i5stJ = parcelRequire("i5stJ");

var $cAQ2R = parcelRequire("cAQ2R");

var $eGOwo = parcelRequire("eGOwo");
const $c344254860ed9d13$var$rotateSvg = null;
/**
 * ChildIssuesIcon but 180 degrees rotated
 */ const $c344254860ed9d13$var$RelatedLinksActionIcon = ()=>(0, $eGOwo.fg)('platform-linking-visual-refresh-v2') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($i5stJ))), {
        color: "currentColor",
        spacing: "spacious",
        label: "View related links..."
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        className: (0, $hcewu.default)([
            "_t9ec1sub _1e0c1o8l"
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cAQ2R))), {
            color: "currentColor",
            spacing: "spacious",
            label: "View recent links..."
        })
    });
var $c344254860ed9d13$export$2e2bcd8739ae039 = $c344254860ed9d13$var$RelatedLinksActionIcon;

});
parcelRegister("cAQ2R", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1043cc02e149fc19165ba5b91793bff7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $92b137e2440c53b9$var$_react = $92b137e2440c53b9$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $92b137e2440c53b9$var$_childWorkItems = $92b137e2440c53b9$var$_interopRequireDefault((parcelRequire("4V9Yp")));

var $92b137e2440c53b9$var$_childIssues = $92b137e2440c53b9$var$_interopRequireDefault((parcelRequire("8NFT3")));
function $92b137e2440c53b9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChildWorkItemsIcon.
 * This component is ChildWorkItemsIcon, with `UNSAFE_fallbackIcon` set to "ChildIssuesIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for child work items.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $92b137e2440c53b9$var$ChildWorkItemsIcon = (props)=>/*#__PURE__*/ $92b137e2440c53b9$var$_react.default.createElement($92b137e2440c53b9$var$_childWorkItems.default, Object.assign({
        LEGACY_fallbackIcon: $92b137e2440c53b9$var$_childIssues.default
    }, props));
$92b137e2440c53b9$var$ChildWorkItemsIcon.Name = 'ChildWorkItemsIconMigration';
var $92b137e2440c53b9$var$_default = module.exports.default = $92b137e2440c53b9$var$ChildWorkItemsIcon;

});
parcelRegister("4V9Yp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8059ae9af0ca9aea6d8a2945440623bd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $395438d0d367a1e4$var$_react = $395438d0d367a1e4$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $395438d0d367a1e4$var$_baseNew = $395438d0d367a1e4$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $395438d0d367a1e4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChildWorkItems".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for child work items.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $395438d0d367a1e4$var$ChildWorkItemsIcon = (props)=>/*#__PURE__*/ $395438d0d367a1e4$var$_react.default.createElement($395438d0d367a1e4$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M8.5 13.5h5V11h-5zm0-7h5V4h-5zm6.5.25C15 7.44 14.44 8 13.75 8h-5.5C7.56 8 7 7.44 7 6.75V6H2.5v5a.5.5 0 0 0 .5.5h4v-.75c0-.69.56-1.25 1.25-1.25h5.5c.69 0 1.25.56 1.25 1.25v3c0 .69-.56 1.25-1.25 1.25h-5.5C7.56 15 7 14.44 7 13.75V13H3a2 2 0 0 1-2-2V1h1.5v3.5H7v-.75c0-.69.56-1.25 1.25-1.25h5.5c.69 0 1.25.56 1.25 1.25z"/>`
    }, props));
$395438d0d367a1e4$var$ChildWorkItemsIcon.displayName = 'ChildWorkItemsIcon';
var $395438d0d367a1e4$var$_default = module.exports.default = $395438d0d367a1e4$var$ChildWorkItemsIcon;

});

parcelRegister("8NFT3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $66836434d770f8d0$var$_react = $66836434d770f8d0$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $66836434d770f8d0$var$_childWorkItems = $66836434d770f8d0$var$_interopRequireDefault((parcelRequire("4V9Yp")));
function $66836434d770f8d0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $66836434d770f8d0$var$ChildIssuesIcon = (props)=>/*#__PURE__*/ $66836434d770f8d0$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M11 7h2v5h-2zm5 6h2v3h-2zM6 13h2v3H6z"/><path d="M7 11h10a1 1 0 0 1 1 1v1H6v-1a1 1 0 0 1 1-1"/><path fill-rule="nonzero" d="M5 18v1h4v-1zm0-2h4a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-1a2 2 0 0 1 2-2m10 2v1h4v-1zm0-2h4a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-1a2 2 0 0 1 2-2M10 5v1h4V5zm0-2h4a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2"/></g></svg>`
    }, props, {
        newIcon: $66836434d770f8d0$var$_childWorkItems.default
    }));
$66836434d770f8d0$var$ChildIssuesIcon.displayName = 'ChildIssuesIcon';
var $66836434d770f8d0$var$_default = module.exports.default = $66836434d770f8d0$var$ChildIssuesIcon;

});



parcelRegister("9EkqU", function(module, exports) {

let $7067b308d3e627fa$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $7067b308d3e627fa$var$load("6ojIT").then(()=>parcelRequire('3cErl'));

});


parcelRegister("fd4of", function(module, exports) {

$parcel$export(module.exports, "default", () => $875ad99f72c777d8$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $8IeH1 = parcelRequire("8IeH1");
var $46R8N = parcelRequire("46R8N");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");
const $875ad99f72c777d8$var$styles = {
    button: "_1e0c1bgi",
    message: "_1rjcze3t _18zrze3t"
};
const $875ad99f72c777d8$var$validErrorStatuses = [
    (0, $5NtHI.SmartLinkStatus).Forbidden,
    (0, $5NtHI.SmartLinkStatus).Unauthorized
];
const $875ad99f72c777d8$var$validateErrorStatus = (status)=>{
    return status !== undefined && $875ad99f72c777d8$var$validErrorStatuses.includes(status);
};
const $875ad99f72c777d8$var$getMessageDescriptor = (status, accessType, props)=>{
    if (!$875ad99f72c777d8$var$validateErrorStatus(status)) return undefined;
    const message = props?.[status]?.[accessType ?? 'FALLBACK'];
    return message;
};
const $875ad99f72c777d8$var$CustomUnresolvedAction = ({ testId: testId = 'custom-unresolved-action', onlyShowIfAction: onlyShowIfAction = false, Container: Container, ...props })=>{
    const context = (0, $5FRJ8.useFlexibleCardContext)();
    const data = context?.data?.actions?.[(0, $5NtHI.InternalActionName).UnresolvedAction];
    if (!data) return null;
    const { descriptor: descriptor, onClick: onClick, values: values } = data;
    const { status: status } = context;
    const accessType = context?.data?.meta?.accessType;
    const hasAction = onClick !== undefined;
    if (onlyShowIfAction && !hasAction) return null;
    const messageDescriptor = $875ad99f72c777d8$var$getMessageDescriptor(status, accessType, props) ?? descriptor;
    if (!messageDescriptor) return null;
    const message = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        testId: `${testId}-errored-view-message`,
        tabIndex: hasAction ? 0 : undefined,
        xcss: $875ad99f72c777d8$var$styles.message,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...messageDescriptor,
            values: values
        })
    });
    const component = hasAction ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $46R8N.default), {
        onClick: data.onClick,
        style: {
            color: `inherit`,
            font: `inherit`,
            textAlign: `inherit`
        },
        xcss: $875ad99f72c777d8$var$styles.button,
        children: message
    }) : message;
    return Container ? /*#__PURE__*/ (0, $gt9Am.jsx)(Container, {
        children: component
    }) : component;
};
var $875ad99f72c777d8$export$2e2bcd8739ae039 = $875ad99f72c777d8$var$CustomUnresolvedAction;

});




parcelRegister("bIdM1", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b32359b6ff0e19a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $5NtHI = parcelRequire("5NtHI");

var $brTAh = parcelRequire("brTAh");
const $2b32359b6ff0e19a$var$baseBlockStyles = null;
const $2b32359b6ff0e19a$var$highlightRemoveStyles = null;
const $2b32359b6ff0e19a$var$gapStyles = {
    xlarge: "_zulpv47k _1ljqv47k",
    large: "_zulppxbi _1ljqpxbi",
    medium: "_zulpu2gc _1ljqu2gc",
    small: "_zulp1b66 _1ljq1b66"
};
const $2b32359b6ff0e19a$var$directionStyles = {
    vertical: "_2lx21bp4 _4cvr1y6m",
    horizontal: "_2lx2vrvc _4cvr1h6o"
};
/**
 * A block represents a collection of elements and actions that are arranged
 * in a row. All elements and actions should be contained within a Block.
 * @internal
 * @param {ActionGroupProps} ActionGroupProps
 * @see Action
 */ const $2b32359b6ff0e19a$var$Block = ({ children: children, direction: direction = (0, $5NtHI.SmartLinkDirection).Horizontal, size: size = (0, $5NtHI.SmartLinkSize).Medium, testId: testId = 'smart-block', className: className, blockRef: blockRef, onRender: onRender, onTransitionEnd: onTransitionEnd, style: style, placeholderId: placeholderId })=>{
    (0, $eJOHy.useEffect)(()=>{
        onRender && onRender();
    }, [
        onRender
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf _1bah1y6m _fiawglyw _1uzp1mp2 _a6bxmuej _e4i5bjq5 _1gu21oju _5b7tuxlv _17ae1oju",
            "_12ji1snc _1qu2agmp _12y310yn _12ji1kw7 _syaz1kw7 _18ql1j28 _1ifmglyw _181uglyw _1rkwglyw _te17glyw _uiztglyw",
            $2b32359b6ff0e19a$var$directionStyles[direction],
            $2b32359b6ff0e19a$var$gapStyles[size],
            className
        ]),
        "data-smart-block": true,
        "data-testid": testId,
        onTransitionEnd: onTransitionEnd,
        ref: blockRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: style,
        "data-ssr-placeholder": placeholderId,
        "data-ssr-placeholder-replace": placeholderId,
        children: (0, $brTAh.renderChildren)(children, size)
    });
};
var $2b32359b6ff0e19a$export$2e2bcd8739ae039 = $2b32359b6ff0e19a$var$Block;

});



parcelRegister("gKsxm", function(module, exports) {

$parcel$export(module.exports, "default", () => $948e354a880fdc81$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $bIdM1 = parcelRequire("bIdM1");

var $k8J0S = parcelRequire("k8J0S");

var $brTAh = parcelRequire("brTAh");
const $948e354a880fdc81$var$DEFAULT_MAX_LINES = 2;
const $948e354a880fdc81$var$MAXIMUM_MAX_LINES = 2;
const $948e354a880fdc81$var$MINIMUM_MAX_LINES = 1;
const $948e354a880fdc81$var$truncateStyles = {
    '1': "_1reo15vq _18m915vq _1e0ccj1k _1bto1l2s _1nmz1hna _1yyjkb7n _sudp1e54",
    '2': "_1reo15vq _18m915vq _1e0ccj1k _1bto1l2s _1nmz1hna _1yyjcs5v _sudp1e54"
};
const $948e354a880fdc81$var$sizeStyles = {
    xlarge: "_102k8vuz",
    large: "_102k8vuz",
    medium: "_102kckbl",
    small: "_102kckbl"
};
const $948e354a880fdc81$var$getMaxLines = (maxLines)=>{
    if (maxLines > $948e354a880fdc81$var$MAXIMUM_MAX_LINES) return $948e354a880fdc81$var$DEFAULT_MAX_LINES;
    if (maxLines < $948e354a880fdc81$var$MINIMUM_MAX_LINES) return $948e354a880fdc81$var$MINIMUM_MAX_LINES;
    return maxLines;
};
const $948e354a880fdc81$var$ElementItemRenderer = ({ align: align = (0, $5NtHI.SmartLinkAlignment).Left, items: items = [], display: display = 'inline', size: size = (0, $5NtHI.SmartLinkSize).Medium, maxLines: maxLines = $948e354a880fdc81$var$DEFAULT_MAX_LINES })=>{
    const elements = (0, $brTAh.renderElementItems)(items, display);
    return elements && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k8J0S.default), {
        align: align,
        direction: (0, $5NtHI.SmartLinkDirection).Horizontal,
        width: (0, $5NtHI.SmartLinkWidth).Flexible,
        size: size,
        className: (0, $hcewu.default)([
            $948e354a880fdc81$var$truncateStyles[maxLines],
            $948e354a880fdc81$var$sizeStyles[size]
        ]),
        children: elements
    });
};
/**
 * Represents a MetadataBlock, designed to contain groups of metadata in the form of elements.
 * Accepts an array of elements to be shown either primary (left hand side) or secondary (right hand side).
 * @public
 * @param {MetadataBlockProps} MetadataBlockProps
 * @see Block
 */ const $948e354a880fdc81$var$MetadataBlock = ({ maxLines: maxLines = $948e354a880fdc81$var$DEFAULT_MAX_LINES, testId: testId = 'smart-block-metadata', primary: primary = [], secondary: secondary = [], ...blockProps })=>{
    const cardContext = (0, $5FRJ8.useFlexibleCardContext)();
    if (primary.length === 0 && secondary.length === 0 || cardContext?.status !== (0, $5NtHI.SmartLinkStatus).Resolved) return null;
    const size = blockProps?.size ?? cardContext?.ui?.size ?? (0, $5NtHI.SmartLinkSize).Medium;
    const maxLinesTotal = $948e354a880fdc81$var$getMaxLines(maxLines);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bIdM1.default), {
        ...blockProps,
        size: size,
        testId: `${testId}-resolved-view`,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)($948e354a880fdc81$var$ElementItemRenderer, {
                items: primary,
                size: size,
                maxLines: maxLinesTotal
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)($948e354a880fdc81$var$ElementItemRenderer, {
                align: (0, $5NtHI.SmartLinkAlignment).Right,
                items: secondary,
                size: size,
                maxLines: maxLinesTotal
            })
        ]
    });
};
var $948e354a880fdc81$export$2e2bcd8739ae039 = $948e354a880fdc81$var$MetadataBlock;

});

parcelRegister("8Rjtc", function(module, exports) {

$parcel$export(module.exports, "default", () => $56e117ae59d9b928$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5FRJ8 = parcelRequire("5FRJ8");

var $bgqs9 = parcelRequire("bgqs9");
/**
 * Represents a PreviewBlock, which typically contains media or other large format content.
 * @public
 * @param {PreviewBlockProps} PreviewBlock
 * @see Block
 */ const $56e117ae59d9b928$var$PreviewBlock = ({ testId: testId = 'smart-block-preview', overrideUrl: overrideUrl, ...blockProps })=>{
    const ui = (0, $5FRJ8.useFlexibleUiOptionContext)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bgqs9.default), {
        ...blockProps,
        size: blockProps.size ?? ui?.size,
        testId: testId,
        overrideUrl: overrideUrl
    });
};
var $56e117ae59d9b928$export$2e2bcd8739ae039 = $56e117ae59d9b928$var$PreviewBlock;

});
parcelRegister("bgqs9", function(module, exports) {

$parcel$export(module.exports, "default", () => $7730cb1921d134f4$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $5NtHI = parcelRequire("5NtHI");

var $7Byzo = parcelRequire("7Byzo");

var $bIdM1 = parcelRequire("bIdM1");
const $7730cb1921d134f4$var$previewBlockStyleCommon = null;
const $7730cb1921d134f4$var$ignoreContainerPaddingStyle = null;
/**
 * Represents a resolved PreviewBlock, which typically contains media or other large format content.
 * @public
 * @param {PreviewBlock} PreviewBlock
 * @see Block
 */ const $7730cb1921d134f4$var$PreviewBlockResolvedView = ({ ignoreContainerPadding: ignoreContainerPadding = false, onError: onError, placement: placement, testId: testId, overrideUrl: overrideUrl, style: style, className: className, ...blockProps })=>{
    const [dynamicStyles, setDynamicStyles] = (0, $eJOHy.useState)(style ?? {});
    const updateStyles = (0, $eJOHy.useCallback)(()=>{
        if (placement === (0, $5NtHI.MediaPlacement).Left || placement === (0, $5NtHI.MediaPlacement).Right) {
            const containerPadding = ignoreContainerPadding ? '0px' : 'var(--container-padding)';
            const newStyle = {
                ...style,
                position: 'absolute',
                top: containerPadding,
                bottom: containerPadding,
                width: `calc(var(--preview-block-width) - ${containerPadding})`,
                ...placement === (0, $5NtHI.MediaPlacement).Left ? {
                    left: containerPadding
                } : {},
                ...placement === (0, $5NtHI.MediaPlacement).Right ? {
                    right: containerPadding
                } : {}
            };
            setDynamicStyles(newStyle);
        } else if (ignoreContainerPadding) setDynamicStyles({
            ...style
        });
    }, [
        ignoreContainerPadding,
        placement,
        style
    ]);
    (0, $eJOHy.useEffect)(()=>{
        updateStyles();
    }, [
        ignoreContainerPadding,
        placement,
        updateStyles,
        className
    ]);
    const handleOnLoad = (0, $eJOHy.useCallback)(()=>{
        updateStyles();
    }, [
        updateStyles
    ]);
    const handleOnError = (0, $eJOHy.useCallback)(()=>{
        if (onError) onError();
    }, [
        onError
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bIdM1.default), {
        ...blockProps,
        testId: `${testId}-resolved-view`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: dynamicStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            placement && "_1t26n7od _ze72n7od _10aa1osq _rjuj1osq _mr051dfr",
            !placement && ignoreContainerPadding && "_18u01ivi _2hwxc10g _e0oi1ya9 _dmhj1ya9",
            className
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7Byzo.default), {
            onError: handleOnError,
            onLoad: handleOnLoad,
            overrideUrl: overrideUrl
        })
    });
};
var $7730cb1921d134f4$export$2e2bcd8739ae039 = $7730cb1921d134f4$var$PreviewBlockResolvedView;

});


parcelRegister("5gb8b", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbe48527b965b005$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $5MmSu = parcelRequire("5MmSu");

var $f7w3l = parcelRequire("f7w3l");

var $fQH39 = parcelRequire("fQH39");

var $bIdM1 = parcelRequire("bIdM1");
const $fbe48527b965b005$var$DEFAULT_MAX_LINES = 3;
const $fbe48527b965b005$var$MAXIMUM_MAX_LINES = 6;
const $fbe48527b965b005$var$MINIMUM_MAX_LINES = 1;
/**
 * Represents a SnippetBlock, which is used to display longer form text content, like descriptions.
 * @public
 * @param {SnippetBlockProps} SnippetBlockProps
 * @see Block
 */ const $fbe48527b965b005$var$SnippetBlock = ({ maxLines: maxLines = $fbe48527b965b005$var$DEFAULT_MAX_LINES, testId: testId = 'smart-block-snippet', text: text, isHidden: isHidden = false, showFooter: showFooter = true, ...blockProps })=>{
    const context = (0, $eGOwo.fg)('cc-ai-linking-platform-snippet-renderer') ? (0, $5FRJ8.useFlexibleUiContext)() : undefined;
    const renderers = (0, $eGOwo.fg)('cc-ai-linking-platform-snippet-renderer') ? (0, $5MmSu.useSmartLinkRenderers)() : undefined;
    const enableSnippetRenderer = (0, $eGOwo.fg)('cc-ai-linking-platform-snippet-renderer') ? (0, $5FRJ8.useFlexibleUiOptionContext)()?.enableSnippetRenderer : undefined;
    const cardContext = (0, $5FRJ8.useFlexibleCardContext)();
    if (cardContext?.status !== (0, $5NtHI.SmartLinkStatus).Resolved && !text) return null;
    const snippetMaxLines = (0, $fQH39.getMaxLines)(maxLines, $fbe48527b965b005$var$DEFAULT_MAX_LINES, $fbe48527b965b005$var$MAXIMUM_MAX_LINES, $fbe48527b965b005$var$MINIMUM_MAX_LINES);
    const statusTestId = !text ? 'resolved' : 'non-resolved';
    const snippet = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $f7w3l.default), {
        maxLines: snippetMaxLines,
        content: text
    });
    if (!(0, $eGOwo.fg)('cc-ai-linking-platform-snippet-renderer') || !enableSnippetRenderer) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bIdM1.default), {
        ...blockProps,
        size: blockProps.size ?? cardContext?.ui?.size,
        testId: `${testId}-${statusTestId}-view`,
        children: snippet
    });
    const SnippetReplacement = renderers?.snippet;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bIdM1.default), {
        ...blockProps,
        size: blockProps.size ?? cardContext?.ui?.size,
        testId: `${testId}-${statusTestId}-view`,
        children: SnippetReplacement ? /*#__PURE__*/ (0, $gt9Am.jsx)(SnippetReplacement, {
            fallbackText: (text || context?.snippet) ?? '',
            fallbackComponent: snippet,
            contentId: context?.meta?.objectId ?? '',
            contentType: context?.meta?.resourceType ?? '',
            cloudId: context?.meta?.tenantId ?? '',
            maxLines: snippetMaxLines,
            isHidden: isHidden,
            showFooter: showFooter
        }) : snippet
    });
};
var $fbe48527b965b005$export$2e2bcd8739ae039 = $fbe48527b965b005$var$SnippetBlock;

});
parcelRegister("5MmSu", function(module, exports) {

$parcel$export(module.exports, "useSmartLinkRenderers", () => $8065e50e2bfb34aa$export$c3514c024fefef57);

var $eJOHy = parcelRequire("eJOHy");

var $9kfy2 = parcelRequire("9kfy2");
const $8065e50e2bfb34aa$export$c3514c024fefef57 = ()=>{
    const context = (0, $9kfy2.useSmartLinkContext)();
    let renderers = context?.renderers;
    renderers = (0, $eJOHy.useMemo)(()=>renderers, [
        renderers
    ]);
    return renderers;
};

});


parcelRegister("fqBfo", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0af5d75f753a471$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $5NtHI = parcelRequire("5NtHI");

var $e3qu2 = parcelRequire("e3qu2");

var $5FRJ8 = parcelRequire("5FRJ8");

var $i6ktq = parcelRequire("i6ktq");

var $6P8F3 = parcelRequire("6P8F3");

var $gjoE0 = parcelRequire("gjoE0");

var $haRRg = parcelRequire("haRRg");

var $1Ub5D = parcelRequire("1Ub5D");
const $a0af5d75f753a471$var$actionStyles = null;
const $a0af5d75f753a471$var$getTitleBlockViewComponent = (status)=>{
    switch(status){
        case (0, $5NtHI.SmartLinkStatus).Pending:
        case (0, $5NtHI.SmartLinkStatus).Resolving:
            return 0, $1Ub5D.default;
        case (0, $5NtHI.SmartLinkStatus).Resolved:
            return 0, $haRRg.default;
        case (0, $5NtHI.SmartLinkStatus).Unauthorized:
        case (0, $5NtHI.SmartLinkStatus).Forbidden:
        case (0, $5NtHI.SmartLinkStatus).NotFound:
        case (0, $5NtHI.SmartLinkStatus).Errored:
        case (0, $5NtHI.SmartLinkStatus).Fallback:
        default:
            return 0, $gjoE0.default;
    }
};
/**
 * Represents a TitleBlock, which is the foundation of Flexible UI.
 * This contains an icon, the link, and any associated metadata and actions in one block.
 * The TitleBlock will also render differently given the state of the smart link.
 * This can be found in the corresponding Resolving, Resolved and Errored views.
 * @public
 * @param {TitleBlockProps} TitleBlockProps
 * @see Block
 * @see TitleBlockResolvingViewNew
 * @see TitleBlockResolvedViewNew
 * @see TitleBlockErroredViewNew
 */ const $a0af5d75f753a471$var$TitleBlock = ({ actions: actions = [], anchorTarget: anchorTarget, hideTitleTooltip: hideTitleTooltip, maxLines: maxLines, onActionMenuOpenChange: onActionMenuOpenChange, showActionOnHover: showActionOnHover, testId: testId = 'smart-block-title', text: text, icon: icon, hideRetry: hideRetry, metadataPosition: metadataPosition, hideIcon: hideIcon = false, className: className, anchorRef: anchorRef, CompetitorPrompt: CompetitorPrompt, url: url, hideIconLoadingSkeleton: hideIconLoadingSkeleton, ...props })=>{
    const cardContext = (0, $5FRJ8.useFlexibleCardContext)();
    const { status: status = (0, $5NtHI.SmartLinkStatus).Fallback, ui: ui } = cardContext || {};
    const [actionDropdownOpen, setActionDropdownOpen] = (0, $eJOHy.useState)(false);
    const onDropdownOpenChange = (0, $eJOHy.useCallback)((isOpen)=>{
        setActionDropdownOpen(isOpen);
        if (onActionMenuOpenChange) onActionMenuOpenChange({
            isOpen: isOpen
        });
    }, [
        onActionMenuOpenChange
    ]);
    const actionGroup = actions.length > 0 && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6P8F3.default), {
        items: actions,
        visibleButtonsNum: showActionOnHover ? 1 : 2,
        onDropdownOpenChange: onDropdownOpenChange
    });
    const overrideText = !!text ? {
        text: text
    } : {};
    const onMouseDown = (0, $e3qu2.useMouseDownEvent)();
    const title = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $i6ktq.default), {
        hideTooltip: hideTitleTooltip,
        maxLines: maxLines,
        onMouseDown: onMouseDown,
        target: anchorTarget,
        theme: ui?.theme,
        anchorRef: anchorRef,
        ...overrideText
    });
    const Component = $a0af5d75f753a471$var$getTitleBlockViewComponent(status);
    return /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
        ...props,
        actionGroup: actionGroup,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            showActionOnHover && !actionDropdownOpen && "_1bfhidpf _wn5xkb7n _h157kb7n",
            className
        ]),
        testId: testId,
        title: title,
        metadataPosition: metadataPosition,
        hideIcon: hideIcon,
        hideRetry: hideRetry,
        icon: icon,
        hideIconLoadingSkeleton: hideIconLoadingSkeleton,
        size: props.size ?? ui?.size,
        CompetitorPrompt: CompetitorPrompt,
        url: url
    });
};
var $a0af5d75f753a471$export$2e2bcd8739ae039 = $a0af5d75f753a471$var$TitleBlock;

});
parcelRegister("gjoE0", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9925dc77e1d9b77$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $cLrUd = parcelRequire("cLrUd");

var $jPfaa = parcelRequire("jPfaa");

var $bIdM1 = parcelRequire("bIdM1");

var $k8J0S = parcelRequire("k8J0S");
/**
 * Represents an Errored TitleBlock view.
 * This will render when a Smart Link did not successfully resolve.
 * This may be a result of a Smart Link not having the correct credentials,
 * or the backend response was errored or malformed.
 * @see TitleBlock
 */ const $e9925dc77e1d9b77$var$TitleBlockErroredView = ({ actionGroup: actionGroup, hideRetry: hideRetry, retry: retry, position: position, testId: testId, title: title, icon: icon, hideIcon: hideIcon, ...blockProps })=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const showRetry = !hideRetry && Boolean(context?.actions?.[(0, $5NtHI.InternalActionName).UnresolvedAction]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bIdM1.default), {
        ...blockProps,
        testId: `${testId}-errored-view`,
        children: [
            !hideIcon && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jPfaa.default), {
                overrideIcon: icon,
                position: position
            }),
            title,
            showRetry && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k8J0S.default), {
                align: (0, $5NtHI.SmartLinkAlignment).Right,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cLrUd.default), {
                    testId: testId
                })
            }),
            actionGroup
        ]
    });
};
var $e9925dc77e1d9b77$export$2e2bcd8739ae039 = $e9925dc77e1d9b77$var$TitleBlockErroredView;

});

parcelRegister("haRRg", function(module, exports) {

$parcel$export(module.exports, "default", () => $3bf1e0846d3cab95$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eGOwo = parcelRequire("eGOwo");

var $8IeH1 = parcelRequire("8IeH1");

var $5NtHI = parcelRequire("5NtHI");

var $jPfaa = parcelRequire("jPfaa");

var $bIdM1 = parcelRequire("bIdM1");

var $k8J0S = parcelRequire("k8J0S");

var $brTAh = parcelRequire("brTAh");
const $3bf1e0846d3cab95$var$style = null;
const $3bf1e0846d3cab95$var$styles = {
    titleBox: "_1e0c1txw _2lx2vrvc _4cvr1h6o _1bsb1osq"
};
/**
 * This renders a fully resolved TitleBlock.
 * This should render when a Smart Link returns a valid response.
 * @see TitleBlock
 */ const $3bf1e0846d3cab95$var$TitleBlockResolvedView = ({ actionGroup: actionGroup, metadata: metadata = [], position: position, subtitle: subtitle = [], testId: testId, text: text, icon: icon, title: title, metadataPosition: metadataPosition, hideIcon: hideIcon, CompetitorPrompt: CompetitorPrompt, url: url, hideIconLoadingSkeleton: hideIconLoadingSkeleton, ...blockProps })=>{
    const { size: size } = blockProps;
    const metadataElements = (0, $brTAh.renderElementItems)(metadata);
    const subtitleElements = (0, $brTAh.renderElementItems)(subtitle);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bIdM1.default), {
        ...blockProps,
        testId: `${testId}-resolved-view`,
        children: [
            !hideIcon && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jPfaa.default), {
                overrideIcon: icon,
                position: position,
                size: size,
                hideLoadingSkeleton: hideIconLoadingSkeleton
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $k8J0S.default), {
                direction: (0, $5NtHI.SmartLinkDirection).Vertical,
                width: (0, $5NtHI.SmartLinkWidth).Flexible,
                size: blockProps.size,
                className: (0, $hcewu.default)([
                    "_zulp1b66"
                ]),
                children: [
                    CompetitorPrompt && url && (0, $eGOwo.fg)('prompt_whiteboard_competitor_link_gate') ? /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $8IeH1.default), {
                        xcss: $3bf1e0846d3cab95$var$styles.titleBox,
                        children: [
                            title,
                            /*#__PURE__*/ (0, $gt9Am.jsx)(CompetitorPrompt, {
                                sourceUrl: url,
                                linkType: 'card'
                            })
                        ]
                    }) : title,
                    subtitleElements && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k8J0S.default), {
                        direction: (0, $5NtHI.SmartLinkDirection).Horizontal,
                        children: subtitleElements
                    })
                ]
            }),
            metadataElements && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k8J0S.default), {
                direction: (0, $5NtHI.SmartLinkDirection).Horizontal,
                align: (0, $5NtHI.SmartLinkAlignment).Right,
                position: metadataPosition ?? (0, $5NtHI.SmartLinkPosition).Center,
                size: blockProps.size,
                children: metadataElements
            }),
            actionGroup
        ]
    });
};
var $3bf1e0846d3cab95$export$2e2bcd8739ae039 = $3bf1e0846d3cab95$var$TitleBlockResolvedView;

});

parcelRegister("1Ub5D", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9eea7741f2cb919$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $65mpR = parcelRequire("65mpR");

var $fQH39 = parcelRequire("fQH39");

var $bIdM1 = parcelRequire("bIdM1");
/**
 * This represents a TitleBlock for a Smart Link that is currently waiting
 * for a request to finish.
 * This should render when a Smart Link has sent a request.
 * @see TitleBlock
 */ const $f9eea7741f2cb919$var$TitleBlockResolvingView = ({ actionGroup: actionGroup, testId: testId, title: title, hideIcon: hideIcon, ...blockProps })=>{
    const { size: size = (0, $5NtHI.SmartLinkSize).Medium } = blockProps;
    const iconWidth = (0, $fQH39.getIconWidth)(size);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bIdM1.default), {
        ...blockProps,
        testId: `${testId}-resolving-view`,
        children: [
            !hideIcon && /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                style: {
                    width: iconWidth,
                    height: iconWidth
                },
                "data-testid": `${testId}-icon`,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $65mpR.LoadingSkeleton), {
                    width: iconWidth,
                    height: iconWidth,
                    testId: `${testId}-icon-loading`
                })
            }),
            title,
            actionGroup
        ]
    });
};
var $f9eea7741f2cb919$export$2e2bcd8739ae039 = $f9eea7741f2cb919$var$TitleBlockResolvingView;

});


parcelRegister("2qnEp", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4a63c55a864af4f$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $gxvmf = parcelRequire("gxvmf");
/**
 * Represents an AISummaryBlock, designed to summarising link resource
 * content using AI.
 * @public
 * @param {AISummaryBlockProps} AISummaryBlock
 * @see Block
 */ const $d4a63c55a864af4f$var$AISummaryBlock = ({ testId: testId = 'smart-ai-summary-block', ...props })=>{
    const cardContext = (0, $5FRJ8.useFlexibleCardContext)();
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $5NtHI.InternalActionName).AISummaryAction];
    if (cardContext?.status !== (0, $5NtHI.SmartLinkStatus).Resolved) return null;
    if (!actionData?.url) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gxvmf.default), {
        ...props,
        size: props.size ?? cardContext?.ui?.size,
        testId: testId,
        url: actionData.url
    });
};
var $d4a63c55a864af4f$export$2e2bcd8739ae039 = $d4a63c55a864af4f$var$AISummaryBlock;

});
parcelRegister("gxvmf", function(module, exports) {

$parcel$export(module.exports, "default", () => $5839dd28b40ea23d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $gRw8I = parcelRequire("gRw8I");

var $5NtHI = parcelRequire("5NtHI");

var $2LycE = parcelRequire("2LycE");

var $4zxv7 = parcelRequire("4zxv7");

var $ei710 = parcelRequire("ei710");

var $bIdM1 = parcelRequire("bIdM1");

var $cQU20 = parcelRequire("cQU20");
const $5839dd28b40ea23d$var$styles = null;
const $5839dd28b40ea23d$var$AISummaryBlockResolvedView = (props)=>{
    (0, $gRw8I.di)((0, $2LycE.default), (0, $4zxv7.default));
    const { testId: testId, aiSummaryMinHeight: aiSummaryMinHeight = 0, placeholder: placeholder, url: url } = props;
    const { state: { content: content, status: status } } = (0, $2LycE.default)(url);
    const showAISummary = status === 'done' || // We want to display the AI Summary component only when there is content available during the loading process.
    status === 'loading' && !!content;
    const isSummarisedOnMountRef = (0, $eJOHy.useRef)(status === 'done');
    const minHeight = isSummarisedOnMountRef.current ? 0 : aiSummaryMinHeight;
    if (!showAISummary) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Fragment), {
        children: placeholder
    });
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bIdM1.default), {
        ...props,
        direction: (0, $5NtHI.SmartLinkDirection).Vertical,
        testId: `${testId}-resolved-view`,
        /**
   * Enabled for feature discovery to allow box shadow to overflow
   * Cleanup: https://product-fabric.atlassian.net/browse/EDM-8681
   */ className: (0, $hcewu.default)([
            "_1reoewfl _18m9ewfl"
        ]),
        children: [
            status === 'done' && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cQU20.default), {
                fromCache: isSummarisedOnMountRef.current
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ei710.default), {
                minHeight: minHeight,
                show: showAISummary,
                showTransition: !isSummarisedOnMountRef.current,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4zxv7.default), {
                    testId: `${testId}-ai-summary`,
                    minHeight: minHeight,
                    content: content
                })
            })
        ]
    });
};
var $5839dd28b40ea23d$export$2e2bcd8739ae039 = $5839dd28b40ea23d$var$AISummaryBlockResolvedView;

});
parcelRegister("4zxv7", function(module, exports) {

$parcel$export(module.exports, "default", () => $50e0b0d82c1c1601$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $gzZ1I = parcelRequire("gzZ1I");

var $3JG7o = parcelRequire("3JG7o");
const $50e0b0d82c1c1601$var$baseStyle = null;
/**
 * A component to render a response from AI in markdown text.
 * @internal
 * @param {AISummaryProps} AISummaryProps
 */ const $50e0b0d82c1c1601$var$AISummary = ({ content: content = '', className: className, testId: testId = 'ai-summary', minHeight: minHeight = 0 })=>{
    if (!content && minHeight === 0) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gzZ1I.default), {
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_11c81o8v _syaz1gjq _slp31hna _1nmz1hna _o5724jg8 _181u1kdv _1rkw1kdv _te171kdv _uizt1kdv",
            className
        ]),
        children: content,
        options: {
            forceWrapper: true,
            overrides: {
                ul: (0, $3JG7o.default)
            }
        },
        style: {
            minHeight: minHeight
        }
    });
};
var $50e0b0d82c1c1601$export$2e2bcd8739ae039 = $50e0b0d82c1c1601$var$AISummary;

});
parcelRegister("gzZ1I", function(module, exports) {

$parcel$export(module.exports, "default", () => $031d6845af3014cc$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
function $031d6845af3014cc$var$t() {
    return $031d6845af3014cc$var$t = Object.assign ? Object.assign.bind() : function(e) {
        for(var t = 1; t < arguments.length; t++){
            var n = arguments[t];
            for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
        return e;
    }, $031d6845af3014cc$var$t.apply(this, arguments);
}
const $031d6845af3014cc$var$n = [
    "children",
    "options"
], $031d6845af3014cc$export$e0aa44767d8750d5 = {
    blockQuote: "0",
    breakLine: "1",
    breakThematic: "2",
    codeBlock: "3",
    codeFenced: "4",
    codeInline: "5",
    footnote: "6",
    footnoteReference: "7",
    gfmTask: "8",
    heading: "9",
    headingSetext: "10",
    htmlBlock: "11",
    htmlComment: "12",
    htmlSelfClosing: "13",
    image: "14",
    link: "15",
    linkAngleBraceStyleDetector: "16",
    linkBareUrlDetector: "17",
    linkMailtoDetector: "18",
    newlineCoalescer: "19",
    orderedList: "20",
    paragraph: "21",
    ref: "22",
    refImage: "23",
    refLink: "24",
    table: "25",
    tableSeparator: "26",
    text: "27",
    textBolded: "28",
    textEmphasized: "29",
    textEscaped: "30",
    textMarked: "31",
    textStrikethroughed: "32",
    unorderedList: "33"
};
var $031d6845af3014cc$var$i;
!function(e) {
    e[e.MAX = 0] = "MAX", e[e.HIGH = 1] = "HIGH", e[e.MED = 2] = "MED", e[e.LOW = 3] = "LOW", e[e.MIN = 4] = "MIN";
}($031d6845af3014cc$var$i || ($031d6845af3014cc$var$i = {}));
const $031d6845af3014cc$var$l = [
    "allowFullScreen",
    "allowTransparency",
    "autoComplete",
    "autoFocus",
    "autoPlay",
    "cellPadding",
    "cellSpacing",
    "charSet",
    "classId",
    "colSpan",
    "contentEditable",
    "contextMenu",
    "crossOrigin",
    "encType",
    "formAction",
    "formEncType",
    "formMethod",
    "formNoValidate",
    "formTarget",
    "frameBorder",
    "hrefLang",
    "inputMode",
    "keyParams",
    "keyType",
    "marginHeight",
    "marginWidth",
    "maxLength",
    "mediaGroup",
    "minLength",
    "noValidate",
    "radioGroup",
    "readOnly",
    "rowSpan",
    "spellCheck",
    "srcDoc",
    "srcLang",
    "srcSet",
    "tabIndex",
    "useMap"
].reduce((e, t)=>(e[t.toLowerCase()] = t, e), {
    class: "className",
    for: "htmlFor"
}), $031d6845af3014cc$var$a = {
    amp: "&",
    apos: "'",
    gt: ">",
    lt: "<",
    nbsp: "\xa0",
    quot: "\u201C"
}, $031d6845af3014cc$var$o = [
    "style",
    "script"
], $031d6845af3014cc$var$c = /([-A-Z0-9_:]+)(?:\s*=\s*(?:(?:"((?:\\.|[^"])*)")|(?:'((?:\\.|[^'])*)')|(?:\{((?:\\.|{[^}]*?}|[^}])*)\})))?/gi, $031d6845af3014cc$var$s = /mailto:/i, $031d6845af3014cc$var$d = /\n{2,}$/, $031d6845af3014cc$var$p = /^(\s*>[\s\S]*?)(?=\n{2,})/, $031d6845af3014cc$var$u = /^ *> ?/gm, $031d6845af3014cc$var$f = /^ {2,}\n/, $031d6845af3014cc$var$h = /^(?:( *[-*_])){3,} *(?:\n *)+\n/, $031d6845af3014cc$var$m = /^(?: {1,3})?(`{3,}|~{3,}) *(\S+)? *([^\n]*?)?\n([\s\S]*?)(?:\1\n?|$)/, $031d6845af3014cc$var$g = /^(?: {4}[^\n]+\n*)+(?:\n *)+\n?/, $031d6845af3014cc$var$y = /^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/, $031d6845af3014cc$var$k = /^(?:\n *)*\n/, $031d6845af3014cc$var$x = /\r\n?/g, $031d6845af3014cc$var$b = /^\[\^([^\]]+)](:(.*)((\n+ {4,}.*)|(\n(?!\[\^).+))*)/, $031d6845af3014cc$var$v = /^\[\^([^\]]+)]/, $031d6845af3014cc$var$S = /\f/g, $031d6845af3014cc$var$E = /^---[ \t]*\n(.|\n)*\n---[ \t]*\n/, $031d6845af3014cc$var$C = /^\s*?\[(x|\s)\]/, $031d6845af3014cc$var$$ = /^ *(#{1,6}) *([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $031d6845af3014cc$var$w = /^ *(#{1,6}) +([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $031d6845af3014cc$var$z = /^([^\n]+)\n *(=|-){3,} *(?:\n *)+\n/, $031d6845af3014cc$var$L = /^ *(?!<[a-z][^ >/]* ?\/>)<([a-z][^ >/]*) ?((?:[^>]*[^/])?)>\n?(\s*(?:<\1[^>]*?>[\s\S]*?<\/\1>|(?!<\1\b)[\s\S])*?)<\/\1>(?!<\/\1>)\n*/i, $031d6845af3014cc$var$A = /&([a-z0-9]+|#[0-9]{1,6}|#x[0-9a-fA-F]{1,6});/gi, $031d6845af3014cc$var$T = /^<!--[\s\S]*?(?:-->)/, $031d6845af3014cc$var$O = /^(data|aria|x)-[a-z_][a-z\d_.-]*$/, $031d6845af3014cc$var$B = /^ *<([a-z][a-z0-9:]*)(?:\s+((?:<.*?>|[^>])*))?\/?>(?!<\/\1>)(\s*\n)?/i, $031d6845af3014cc$var$M = /^\{.*\}$/, $031d6845af3014cc$var$R = /^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/, $031d6845af3014cc$var$I = /^<([^ >]+@[^ >]+)>/, $031d6845af3014cc$var$U = /^<([^ >]+:\/[^ >]+)>/, $031d6845af3014cc$var$D = /-([a-z])?/gi, $031d6845af3014cc$var$j = /^(\|.*)\n(?: *(\|? *[-:]+ *\|[-| :]*)\n((?:.*\|.*\n)*))?\n?/, $031d6845af3014cc$var$N = /^\[([^\]]*)\]:\s+<?([^\s>]+)>?\s*("([^"]*)")?/, $031d6845af3014cc$var$H = /^!\[([^\]]*)\] ?\[([^\]]*)\]/, $031d6845af3014cc$var$F = /^\[([^\]]*)\] ?\[([^\]]*)\]/, $031d6845af3014cc$var$P = /(\n|^[-*]\s|^#|^ {2,}|^-{2,}|^>\s)/, $031d6845af3014cc$var$_ = /\t/g, $031d6845af3014cc$var$G = /(^ *\||\| *$)/g, $031d6845af3014cc$var$W = /^ *:-+: *$/, $031d6845af3014cc$var$Z = /^ *:-+ *$/, $031d6845af3014cc$var$q = /^ *-+: *$/, $031d6845af3014cc$var$Q = "((?:\\[.*?\\][([].*?[)\\]]|<.*?>(?:.*?<.*?>)?|`.*?`|~~.*?~~|==.*?==|.|\\n)*?)", $031d6845af3014cc$var$V = new RegExp(`^([*_])\\1${$031d6845af3014cc$var$Q}\\1\\1(?!\\1)`), $031d6845af3014cc$var$X = new RegExp(`^([*_])${$031d6845af3014cc$var$Q}\\1(?!\\1|\\w)`), $031d6845af3014cc$var$J = new RegExp(`^==${$031d6845af3014cc$var$Q}==`), $031d6845af3014cc$var$K = new RegExp(`^~~${$031d6845af3014cc$var$Q}~~`), $031d6845af3014cc$var$Y = /^\\([^0-9A-Za-z\s])/, $031d6845af3014cc$var$ee = /^[\s\S]+?(?=[^0-9A-Z\s\u00c0-\uffff&#;.()'"]|\d+\.|\n\n| {2,}\n|\w+:\S|$)/i, $031d6845af3014cc$var$te = /^\n+/, $031d6845af3014cc$var$ne = /^([ \t]*)/, $031d6845af3014cc$var$re = /\\([^\\])/g, $031d6845af3014cc$var$ie = / *\n+$/, $031d6845af3014cc$var$le = /(?:^|\n)( *)$/, $031d6845af3014cc$var$ae = "(?:\\d+\\.)", $031d6845af3014cc$var$oe = "(?:[*+-])";
function $031d6845af3014cc$var$ce(e) {
    return "( *)(" + (1 === e ? $031d6845af3014cc$var$ae : $031d6845af3014cc$var$oe) + ") +";
}
const $031d6845af3014cc$var$se = $031d6845af3014cc$var$ce(1), $031d6845af3014cc$var$de = $031d6845af3014cc$var$ce(2);
function $031d6845af3014cc$var$pe(e) {
    return new RegExp("^" + (1 === e ? $031d6845af3014cc$var$se : $031d6845af3014cc$var$de));
}
const $031d6845af3014cc$var$ue = $031d6845af3014cc$var$pe(1), $031d6845af3014cc$var$fe = $031d6845af3014cc$var$pe(2);
function $031d6845af3014cc$var$he(e) {
    return new RegExp("^" + (1 === e ? $031d6845af3014cc$var$se : $031d6845af3014cc$var$de) + "[^\\n]*(?:\\n(?!\\1" + (1 === e ? $031d6845af3014cc$var$ae : $031d6845af3014cc$var$oe) + " )[^\\n]*)*(\\n|$)", "gm");
}
const $031d6845af3014cc$var$me = $031d6845af3014cc$var$he(1), $031d6845af3014cc$var$ge = $031d6845af3014cc$var$he(2);
function $031d6845af3014cc$var$ye(e) {
    const t = 1 === e ? $031d6845af3014cc$var$ae : $031d6845af3014cc$var$oe;
    return new RegExp("^( *)(" + t + ") [\\s\\S]+?(?:\\n{2,}(?! )(?!\\1" + t + " (?!" + t + " ))\\n*|\\s*\\n*$)");
}
const $031d6845af3014cc$var$ke = $031d6845af3014cc$var$ye(1), $031d6845af3014cc$var$xe = $031d6845af3014cc$var$ye(2);
function $031d6845af3014cc$var$be(e, t) {
    const n = 1 === t, i = n ? $031d6845af3014cc$var$ke : $031d6845af3014cc$var$xe, l = n ? $031d6845af3014cc$var$me : $031d6845af3014cc$var$ge, a = n ? $031d6845af3014cc$var$ue : $031d6845af3014cc$var$fe;
    return {
        match (e, t) {
            const n = $031d6845af3014cc$var$le.exec(t.prevCapture);
            return n && (t.list || !t.inline && !t.simple) ? i.exec(e = n[1] + e) : null;
        },
        order: 1,
        parse (e, t, r) {
            const i = n ? +e[2] : void 0, o = e[0].replace($031d6845af3014cc$var$d, "\n").match(l);
            let c = !1;
            return {
                items: o.map(function(e, n) {
                    const i = a.exec(e)[0].length, l = new RegExp("^ {1," + i + "}", "gm"), s = e.replace(l, "").replace(a, ""), d = n === o.length - 1, p = -1 !== s.indexOf("\n\n") || d && c;
                    c = p;
                    const u = r.inline, f = r.list;
                    let h;
                    r.list = !0, p ? (r.inline = !1, h = s.replace($031d6845af3014cc$var$ie, "\n\n")) : (r.inline = !0, h = s.replace($031d6845af3014cc$var$ie, ""));
                    const m = t(h, r);
                    return r.inline = u, r.list = f, m;
                }),
                ordered: n,
                start: i
            };
        },
        render: (t, n, i)=>e(t.ordered ? "ol" : "ul", {
                key: i.key,
                start: t.type === $031d6845af3014cc$export$e0aa44767d8750d5.orderedList ? t.start : void 0
            }, t.items.map(function(t, r) {
                return e("li", {
                    key: r
                }, n(t, i));
            }))
    };
}
const $031d6845af3014cc$var$ve = new RegExp("^\\[((?:\\[[^\\]]*\\]|[^\\[\\]]|\\](?=[^\\[]*\\]))*)\\]\\(\\s*<?((?:\\([^)]*\\)|[^\\s\\\\]|\\\\.)*?)>?(?:\\s+['\"]([\\s\\S]*?)['\"])?\\s*\\)"), $031d6845af3014cc$var$Se = /^!\[(.*?)\]\( *((?:\([^)]*\)|[^() ])*) *"?([^)"]*)?"?\)/, $031d6845af3014cc$var$Ee = [
    $031d6845af3014cc$var$p,
    $031d6845af3014cc$var$m,
    $031d6845af3014cc$var$g,
    $031d6845af3014cc$var$$,
    $031d6845af3014cc$var$z,
    $031d6845af3014cc$var$w,
    $031d6845af3014cc$var$T,
    $031d6845af3014cc$var$j,
    $031d6845af3014cc$var$me,
    $031d6845af3014cc$var$ke,
    $031d6845af3014cc$var$ge,
    $031d6845af3014cc$var$xe
], $031d6845af3014cc$var$Ce = [
    ...$031d6845af3014cc$var$Ee,
    /^[^\n]+(?:  \n|\n{2,})/,
    $031d6845af3014cc$var$L,
    $031d6845af3014cc$var$B
];
function $031d6845af3014cc$export$c383cdd2a518017a(e) {
    return e.replace(/[ÀÁÂÃÄÅàáâãäåæÆ]/g, "a").replace(/[çÇ]/g, "c").replace(/[ðÐ]/g, "d").replace(/[ÈÉÊËéèêë]/g, "e").replace(/[ÏïÎîÍíÌì]/g, "i").replace(/[Ññ]/g, "n").replace(/[øØœŒÕõÔôÓóÒò]/g, "o").replace(/[ÜüÛûÚúÙù]/g, "u").replace(/[ŸÿÝý]/g, "y").replace(/[^a-z0-9- ]/gi, "").replace(/ /gi, "-").toLowerCase();
}
function $031d6845af3014cc$var$we(e) {
    return $031d6845af3014cc$var$q.test(e) ? "right" : $031d6845af3014cc$var$W.test(e) ? "center" : $031d6845af3014cc$var$Z.test(e) ? "left" : null;
}
function $031d6845af3014cc$var$ze(e, t, n, i) {
    const l = n.inTable;
    n.inTable = !0;
    let a = e.trim().split(/( *(?:`[^`]*`|<.*?>.*?<\/.*?>(?!<\/.*?>)|\\\||\|) *)/).reduce((e, l)=>("|" === l.trim() ? e.push(i ? {
            type: $031d6845af3014cc$export$e0aa44767d8750d5.tableSeparator
        } : {
            type: $031d6845af3014cc$export$e0aa44767d8750d5.text,
            text: l
        }) : "" !== l && e.push.apply(e, t(l, n)), e), []);
    n.inTable = l;
    let o = [
        []
    ];
    return a.forEach(function(e, t) {
        e.type === $031d6845af3014cc$export$e0aa44767d8750d5.tableSeparator ? 0 !== t && t !== a.length - 1 && o.push([]) : (e.type !== $031d6845af3014cc$export$e0aa44767d8750d5.text || null != a[t + 1] && a[t + 1].type !== $031d6845af3014cc$export$e0aa44767d8750d5.tableSeparator || (e.text = e.text.trimEnd()), o[o.length - 1].push(e));
    }), o;
}
function $031d6845af3014cc$var$Le(e, t, n) {
    n.inline = !0;
    const i = e[2] ? e[2].replace($031d6845af3014cc$var$G, "").split("|").map($031d6845af3014cc$var$we) : [], l = e[3] ? function(e, t, n) {
        return e.trim().split("\n").map(function(e) {
            return $031d6845af3014cc$var$ze(e, t, n, !0);
        });
    }(e[3], t, n) : [], a = $031d6845af3014cc$var$ze(e[1], t, n, !!l.length);
    return n.inline = !1, l.length ? {
        align: i,
        cells: l,
        header: a,
        type: $031d6845af3014cc$export$e0aa44767d8750d5.table
    } : {
        children: a,
        type: $031d6845af3014cc$export$e0aa44767d8750d5.paragraph
    };
}
function $031d6845af3014cc$var$Ae(e, t) {
    return null == e.align[t] ? {} : {
        textAlign: e.align[t]
    };
}
function $031d6845af3014cc$var$Te(e) {
    return function(t, n) {
        return n.inline ? e.exec(t) : null;
    };
}
function $031d6845af3014cc$var$Oe(e) {
    return function(t, n) {
        return n.inline || n.simple ? e.exec(t) : null;
    };
}
function $031d6845af3014cc$var$Be(e) {
    return function(t, n) {
        return n.inline || n.simple ? null : e.exec(t);
    };
}
function $031d6845af3014cc$var$Me(e) {
    return function(t) {
        return e.exec(t);
    };
}
function $031d6845af3014cc$var$Re(e, t) {
    if (t.inline || t.simple) return null;
    let n = "";
    e.split("\n").every((e)=>!$031d6845af3014cc$var$Ee.some((t)=>t.test(e)) && (n += e + "\n", e.trim()));
    const r = n.trimEnd();
    return "" == r ? null : [
        n,
        r
    ];
}
function $031d6845af3014cc$export$3e2338ea76b578c9(e) {
    try {
        if (decodeURIComponent(e).replace(/[^A-Za-z0-9/:]/g, "").match(/^\s*(javascript|vbscript|data(?!:image)):/i)) return null;
    } catch (e) {
        return null;
    }
    return e;
}
function $031d6845af3014cc$var$Ue(e) {
    return e.replace($031d6845af3014cc$var$re, "$1");
}
function $031d6845af3014cc$var$De(e, t, n) {
    const r = n.inline || !1, i = n.simple || !1;
    n.inline = !0, n.simple = !0;
    const l = e(t, n);
    return n.inline = r, n.simple = i, l;
}
function $031d6845af3014cc$var$je(e, t, n) {
    const r = n.inline || !1, i = n.simple || !1;
    n.inline = !1, n.simple = !0;
    const l = e(t, n);
    return n.inline = r, n.simple = i, l;
}
function $031d6845af3014cc$var$Ne(e, t, n) {
    const r = n.inline || !1;
    n.inline = !1;
    const i = e(t, n);
    return n.inline = r, i;
}
const $031d6845af3014cc$var$He = (e, t, n)=>({
        children: $031d6845af3014cc$var$De(t, e[1], n)
    });
function $031d6845af3014cc$var$Fe() {
    return {};
}
function $031d6845af3014cc$var$Pe() {
    return null;
}
function $031d6845af3014cc$var$_e(...e) {
    return e.filter(Boolean).join(" ");
}
function $031d6845af3014cc$var$Ge(e, t, n) {
    let r = e;
    const i = t.split(".");
    for(; i.length && (r = r[i[0]], void 0 !== r);)i.shift();
    return r || n;
}
function $031d6845af3014cc$export$69f434acfbdb0b32(n = "", i = {}) {
    function d(e, n, ...r) {
        const l = $031d6845af3014cc$var$Ge(i.overrides, `${e}.props`, {});
        return i.createElement(function(e, t) {
            const n = $031d6845af3014cc$var$Ge(t, e);
            return n ? "function" == typeof n || "object" == typeof n && "render" in n ? n : $031d6845af3014cc$var$Ge(t, `${e}.component`, e) : e;
        }(e, i.overrides), $031d6845af3014cc$var$t({}, n, l, {
            className: $031d6845af3014cc$var$_e(null == n ? void 0 : n.className, l.className) || void 0
        }), ...r);
    }
    function G(t) {
        t = t.replace($031d6845af3014cc$var$E, "");
        let n = !1;
        i.forceInline ? n = !0 : i.forceBlock || (n = !1 === $031d6845af3014cc$var$P.test(t));
        const r = ie(re(n ? t : `${t.trimEnd().replace($031d6845af3014cc$var$te, "")}\n\n`, {
            inline: n
        }));
        for(; "string" == typeof r[r.length - 1] && !r[r.length - 1].trim();)r.pop();
        if (null === i.wrapper) return r;
        const l = i.wrapper || (n ? "span" : "div");
        let a;
        if (r.length > 1 || i.forceWrapper) a = r;
        else {
            if (1 === r.length) return a = r[0], "string" == typeof a ? d("span", {
                key: "outer"
            }, a) : a;
            a = null;
        }
        return $eJOHy.createElement(l, {
            key: "outer"
        }, a);
    }
    function W(t, n) {
        const r = n.match($031d6845af3014cc$var$c);
        return r ? r.reduce(function(n, r, a) {
            const o = r.indexOf("=");
            if (-1 !== o) {
                const c = (function(e) {
                    return -1 !== e.indexOf("-") && null === e.match($031d6845af3014cc$var$O) && (e = e.replace($031d6845af3014cc$var$D, function(e, t) {
                        return t.toUpperCase();
                    })), e;
                })(r.slice(0, o)).trim(), s = function(e) {
                    const t = e[0];
                    return ('"' === t || "'" === t) && e.length >= 2 && e[e.length - 1] === t ? e.slice(1, -1) : e;
                }(r.slice(o + 1).trim()), d = $031d6845af3014cc$var$l[c] || c, p = n[d] = function(e, t, n, r) {
                    return "style" === t ? n.split(/;\s?/).reduce(function(e, t) {
                        const n = t.slice(0, t.indexOf(":"));
                        return e[n.trim().replace(/(-[a-z])/g, (e)=>e[1].toUpperCase())] = t.slice(n.length + 1).trim(), e;
                    }, {}) : "href" === t || "src" === t ? r(n, e, t) : (n.match($031d6845af3014cc$var$M) && (n = n.slice(1, n.length - 1)), "true" === n || "false" !== n && n);
                }(t, c, s, i.sanitizer);
                "string" == typeof p && ($031d6845af3014cc$var$L.test(p) || $031d6845af3014cc$var$B.test(p)) && (n[d] = $eJOHy.cloneElement(G(p.trim()), {
                    key: a
                }));
            } else "style" !== r && (n[$031d6845af3014cc$var$l[r] || r] = !0);
            return n;
        }, {}) : null;
    }
    i.overrides = i.overrides || {}, i.sanitizer = i.sanitizer || $031d6845af3014cc$export$3e2338ea76b578c9, i.slugify = i.slugify || $031d6845af3014cc$export$c383cdd2a518017a, i.namedCodesToUnicode = i.namedCodesToUnicode ? $031d6845af3014cc$var$t({}, $031d6845af3014cc$var$a, i.namedCodesToUnicode) : $031d6845af3014cc$var$a, i.createElement = i.createElement || $eJOHy.createElement;
    const Z = [], q = {}, Q = {
        [$031d6845af3014cc$export$e0aa44767d8750d5.blockQuote]: {
            match: $031d6845af3014cc$var$Be($031d6845af3014cc$var$p),
            order: 1,
            parse: (e, t, n)=>({
                    children: t(e[0].replace($031d6845af3014cc$var$u, ""), n)
                }),
            render: (e, t, n)=>d("blockquote", {
                    key: n.key
                }, t(e.children, n))
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.breakLine]: {
            match: $031d6845af3014cc$var$Me($031d6845af3014cc$var$f),
            order: 1,
            parse: $031d6845af3014cc$var$Fe,
            render: (e, t, n)=>d("br", {
                    key: n.key
                })
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.breakThematic]: {
            match: $031d6845af3014cc$var$Be($031d6845af3014cc$var$h),
            order: 1,
            parse: $031d6845af3014cc$var$Fe,
            render: (e, t, n)=>d("hr", {
                    key: n.key
                })
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.codeBlock]: {
            match: $031d6845af3014cc$var$Be($031d6845af3014cc$var$g),
            order: 0,
            parse: (e)=>({
                    lang: void 0,
                    text: e[0].replace(/^ {4}/gm, "").replace(/\n+$/, "")
                }),
            render: (e, n, r)=>d("pre", {
                    key: r.key
                }, d("code", $031d6845af3014cc$var$t({}, e.attrs, {
                    className: e.lang ? `lang-${e.lang}` : ""
                }), e.text))
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.codeFenced]: {
            match: $031d6845af3014cc$var$Be($031d6845af3014cc$var$m),
            order: 0,
            parse: (e)=>({
                    attrs: W("code", e[3] || ""),
                    lang: e[2] || void 0,
                    text: e[4],
                    type: $031d6845af3014cc$export$e0aa44767d8750d5.codeBlock
                })
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.codeInline]: {
            match: $031d6845af3014cc$var$Oe($031d6845af3014cc$var$y),
            order: 3,
            parse: (e)=>({
                    text: e[2]
                }),
            render: (e, t, n)=>d("code", {
                    key: n.key
                }, e.text)
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.footnote]: {
            match: $031d6845af3014cc$var$Be($031d6845af3014cc$var$b),
            order: 0,
            parse: (e)=>(Z.push({
                    footnote: e[2],
                    identifier: e[1]
                }), {}),
            render: $031d6845af3014cc$var$Pe
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.footnoteReference]: {
            match: $031d6845af3014cc$var$Te($031d6845af3014cc$var$v),
            order: 1,
            parse: (e)=>({
                    target: `#${i.slugify(e[1], $031d6845af3014cc$export$c383cdd2a518017a)}`,
                    text: e[1]
                }),
            render: (e, t, n)=>d("a", {
                    key: n.key,
                    href: i.sanitizer(e.target, "a", "href")
                }, d("sup", {
                    key: n.key
                }, e.text))
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.gfmTask]: {
            match: $031d6845af3014cc$var$Te($031d6845af3014cc$var$C),
            order: 1,
            parse: (e)=>({
                    completed: "x" === e[1].toLowerCase()
                }),
            render: (e, t, n)=>d("input", {
                    checked: e.completed,
                    key: n.key,
                    readOnly: !0,
                    type: "checkbox"
                })
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.heading]: {
            match: $031d6845af3014cc$var$Be(i.enforceAtxHeadings ? $031d6845af3014cc$var$w : $031d6845af3014cc$var$$),
            order: 1,
            parse: (e, t, n)=>({
                    children: $031d6845af3014cc$var$De(t, e[2], n),
                    id: i.slugify(e[2], $031d6845af3014cc$export$c383cdd2a518017a),
                    level: e[1].length
                }),
            render: (e, t, n)=>d(`h${e.level}`, {
                    id: e.id,
                    key: n.key
                }, t(e.children, n))
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.headingSetext]: {
            match: $031d6845af3014cc$var$Be($031d6845af3014cc$var$z),
            order: 0,
            parse: (e, t, n)=>({
                    children: $031d6845af3014cc$var$De(t, e[1], n),
                    level: "=" === e[2] ? 1 : 2,
                    type: $031d6845af3014cc$export$e0aa44767d8750d5.heading
                })
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.htmlBlock]: {
            match: $031d6845af3014cc$var$Me($031d6845af3014cc$var$L),
            order: 1,
            parse (e, t, n) {
                const [, r] = e[3].match($031d6845af3014cc$var$ne), i = new RegExp(`^${r}`, "gm"), l = e[3].replace(i, ""), a = (c = l, $031d6845af3014cc$var$Ce.some((e)=>e.test(c)) ? $031d6845af3014cc$var$Ne : $031d6845af3014cc$var$De);
                var c;
                const s = e[1].toLowerCase(), d = -1 !== $031d6845af3014cc$var$o.indexOf(s), p = (d ? s : e[1]).trim(), u = {
                    attrs: W(p, e[2]),
                    noInnerParse: d,
                    tag: p
                };
                return n.inAnchor = n.inAnchor || "a" === s, d ? u.text = e[3] : u.children = a(t, l, n), n.inAnchor = !1, u;
            },
            render: (e, n, r)=>d(e.tag, $031d6845af3014cc$var$t({
                    key: r.key
                }, e.attrs), e.text || (e.children ? n(e.children, r) : ""))
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.htmlSelfClosing]: {
            match: $031d6845af3014cc$var$Me($031d6845af3014cc$var$B),
            order: 1,
            parse (e) {
                const t = e[1].trim();
                return {
                    attrs: W(t, e[2] || ""),
                    tag: t
                };
            },
            render: (e, n, r)=>d(e.tag, $031d6845af3014cc$var$t({}, e.attrs, {
                    key: r.key
                }))
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.htmlComment]: {
            match: $031d6845af3014cc$var$Me($031d6845af3014cc$var$T),
            order: 1,
            parse: ()=>({}),
            render: $031d6845af3014cc$var$Pe
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.image]: {
            match: $031d6845af3014cc$var$Oe($031d6845af3014cc$var$Se),
            order: 1,
            parse: (e)=>({
                    alt: e[1],
                    target: $031d6845af3014cc$var$Ue(e[2]),
                    title: e[3]
                }),
            render: (e, t, n)=>d("img", {
                    key: n.key,
                    alt: e.alt || void 0,
                    title: e.title || void 0,
                    src: i.sanitizer(e.target, "img", "src")
                })
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.link]: {
            match: $031d6845af3014cc$var$Te($031d6845af3014cc$var$ve),
            order: 3,
            parse: (e, t, n)=>({
                    children: $031d6845af3014cc$var$je(t, e[1], n),
                    target: $031d6845af3014cc$var$Ue(e[2]),
                    title: e[3]
                }),
            render: (e, t, n)=>d("a", {
                    key: n.key,
                    href: i.sanitizer(e.target, "a", "href"),
                    title: e.title
                }, t(e.children, n))
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.linkAngleBraceStyleDetector]: {
            match: $031d6845af3014cc$var$Te($031d6845af3014cc$var$U),
            order: 0,
            parse: (e)=>({
                    children: [
                        {
                            text: e[1],
                            type: $031d6845af3014cc$export$e0aa44767d8750d5.text
                        }
                    ],
                    target: e[1],
                    type: $031d6845af3014cc$export$e0aa44767d8750d5.link
                })
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.linkBareUrlDetector]: {
            match: (e, t)=>t.inAnchor || i.disableAutoLink ? null : $031d6845af3014cc$var$Te($031d6845af3014cc$var$R)(e, t),
            order: 0,
            parse: (e)=>({
                    children: [
                        {
                            text: e[1],
                            type: $031d6845af3014cc$export$e0aa44767d8750d5.text
                        }
                    ],
                    target: e[1],
                    title: void 0,
                    type: $031d6845af3014cc$export$e0aa44767d8750d5.link
                })
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.linkMailtoDetector]: {
            match: $031d6845af3014cc$var$Te($031d6845af3014cc$var$I),
            order: 0,
            parse (e) {
                let t = e[1], n = e[1];
                return $031d6845af3014cc$var$s.test(n) || (n = "mailto:" + n), {
                    children: [
                        {
                            text: t.replace("mailto:", ""),
                            type: $031d6845af3014cc$export$e0aa44767d8750d5.text
                        }
                    ],
                    target: n,
                    type: $031d6845af3014cc$export$e0aa44767d8750d5.link
                };
            }
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.orderedList]: $031d6845af3014cc$var$be(d, 1),
        [$031d6845af3014cc$export$e0aa44767d8750d5.unorderedList]: $031d6845af3014cc$var$be(d, 2),
        [$031d6845af3014cc$export$e0aa44767d8750d5.newlineCoalescer]: {
            match: $031d6845af3014cc$var$Be($031d6845af3014cc$var$k),
            order: 3,
            parse: $031d6845af3014cc$var$Fe,
            render: ()=>"\n"
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.paragraph]: {
            match: $031d6845af3014cc$var$Re,
            order: 3,
            parse: $031d6845af3014cc$var$He,
            render: (e, t, n)=>d("p", {
                    key: n.key
                }, t(e.children, n))
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.ref]: {
            match: $031d6845af3014cc$var$Te($031d6845af3014cc$var$N),
            order: 0,
            parse: (e)=>(q[e[1]] = {
                    target: e[2],
                    title: e[4]
                }, {}),
            render: $031d6845af3014cc$var$Pe
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.refImage]: {
            match: $031d6845af3014cc$var$Oe($031d6845af3014cc$var$H),
            order: 0,
            parse: (e)=>({
                    alt: e[1] || void 0,
                    ref: e[2]
                }),
            render: (e, t, n)=>q[e.ref] ? d("img", {
                    key: n.key,
                    alt: e.alt,
                    src: i.sanitizer(q[e.ref].target, "img", "src"),
                    title: q[e.ref].title
                }) : null
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.refLink]: {
            match: $031d6845af3014cc$var$Te($031d6845af3014cc$var$F),
            order: 0,
            parse: (e, t, n)=>({
                    children: t(e[1], n),
                    fallbackChildren: e[0],
                    ref: e[2]
                }),
            render: (e, t, n)=>q[e.ref] ? d("a", {
                    key: n.key,
                    href: i.sanitizer(q[e.ref].target, "a", "href"),
                    title: q[e.ref].title
                }, t(e.children, n)) : d("span", {
                    key: n.key
                }, e.fallbackChildren)
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.table]: {
            match: $031d6845af3014cc$var$Be($031d6845af3014cc$var$j),
            order: 1,
            parse: $031d6845af3014cc$var$Le,
            render (e, t, n) {
                const r = e;
                return d("table", {
                    key: n.key
                }, d("thead", null, d("tr", null, r.header.map(function(e, i) {
                    return d("th", {
                        key: i,
                        style: $031d6845af3014cc$var$Ae(r, i)
                    }, t(e, n));
                }))), d("tbody", null, r.cells.map(function(e, i) {
                    return d("tr", {
                        key: i
                    }, e.map(function(e, i) {
                        return d("td", {
                            key: i,
                            style: $031d6845af3014cc$var$Ae(r, i)
                        }, t(e, n));
                    }));
                })));
            }
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.text]: {
            match: $031d6845af3014cc$var$Me($031d6845af3014cc$var$ee),
            order: 4,
            parse: (e)=>({
                    text: e[0].replace($031d6845af3014cc$var$A, (e, t)=>i.namedCodesToUnicode[t] ? i.namedCodesToUnicode[t] : e)
                }),
            render: (e)=>e.text
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.textBolded]: {
            match: $031d6845af3014cc$var$Oe($031d6845af3014cc$var$V),
            order: 2,
            parse: (e, t, n)=>({
                    children: t(e[2], n)
                }),
            render: (e, t, n)=>d("strong", {
                    key: n.key
                }, t(e.children, n))
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.textEmphasized]: {
            match: $031d6845af3014cc$var$Oe($031d6845af3014cc$var$X),
            order: 3,
            parse: (e, t, n)=>({
                    children: t(e[2], n)
                }),
            render: (e, t, n)=>d("em", {
                    key: n.key
                }, t(e.children, n))
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.textEscaped]: {
            match: $031d6845af3014cc$var$Oe($031d6845af3014cc$var$Y),
            order: 1,
            parse: (e)=>({
                    text: e[1],
                    type: $031d6845af3014cc$export$e0aa44767d8750d5.text
                })
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.textMarked]: {
            match: $031d6845af3014cc$var$Oe($031d6845af3014cc$var$J),
            order: 3,
            parse: $031d6845af3014cc$var$He,
            render: (e, t, n)=>d("mark", {
                    key: n.key
                }, t(e.children, n))
        },
        [$031d6845af3014cc$export$e0aa44767d8750d5.textStrikethroughed]: {
            match: $031d6845af3014cc$var$Oe($031d6845af3014cc$var$K),
            order: 3,
            parse: $031d6845af3014cc$var$He,
            render: (e, t, n)=>d("del", {
                    key: n.key
                }, t(e.children, n))
        }
    };
    !0 === i.disableParsingRawHTML && (delete Q[$031d6845af3014cc$export$e0aa44767d8750d5.htmlBlock], delete Q[$031d6845af3014cc$export$e0aa44767d8750d5.htmlSelfClosing]);
    const re = function(e) {
        let t = Object.keys(e);
        function n(r, i) {
            let l = [];
            for(i.prevCapture = i.prevCapture || ""; r;){
                let a = 0;
                for(; a < t.length;){
                    const o = t[a], c = e[o], s = c.match(r, i);
                    if (s) {
                        const e = s[0];
                        i.prevCapture += e, r = r.substring(e.length);
                        const t = c.parse(s, n, i);
                        null == t.type && (t.type = o), l.push(t);
                        break;
                    }
                    a++;
                }
            }
            return i.prevCapture = "", l;
        }
        return t.sort(function(t, n) {
            let r = e[t].order, i = e[n].order;
            return r !== i ? r - i : t < n ? -1 : 1;
        }), function(e, t) {
            return n(function(e) {
                return e.replace($031d6845af3014cc$var$x, "\n").replace($031d6845af3014cc$var$S, "").replace($031d6845af3014cc$var$_, "    ");
            }(e), t);
        };
    }(Q), ie = (le = function(e, t) {
        return function(n, r, i) {
            const l = e[n.type].render;
            return t ? t(()=>l(n, r, i), n, r, i) : l(n, r, i);
        };
    }(Q, i.renderRule), function e(t, n = {}) {
        if (Array.isArray(t)) {
            const r = n.key, i = [];
            let l = !1;
            for(let r = 0; r < t.length; r++){
                n.key = r;
                const a = e(t[r], n), o = "string" == typeof a;
                o && l ? i[i.length - 1] += a : null !== a && i.push(a), l = o;
            }
            return n.key = r, i;
        }
        return le(t, e, n);
    });
    var le;
    const ae = G(n);
    return Z.length ? d("div", null, ae, d("footer", {
        key: "footer"
    }, Z.map(function(e) {
        return d("div", {
            id: i.slugify(e.identifier, $031d6845af3014cc$export$c383cdd2a518017a),
            key: e.identifier
        }, e.identifier, ie(re(e.footnote, {
            inline: !0
        })));
    }))) : ae;
}
var $031d6845af3014cc$export$2e2bcd8739ae039 = (t)=>{
    let { children: r = "", options: i } = t, l = function(e, t) {
        if (null == e) return {};
        var n, r, i = {}, l = Object.keys(e);
        for(r = 0; r < l.length; r++)t.indexOf(n = l[r]) >= 0 || (i[n] = e[n]);
        return i;
    }(t, $031d6845af3014cc$var$n);
    return $eJOHy.cloneElement($031d6845af3014cc$export$69f434acfbdb0b32(r, i), l);
};

});

parcelRegister("3JG7o", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f398c5c3f3cb7e7$export$2e2bcd8739ae039);
/* ulist.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");
parcelRequire("eJOHy");
const $8f398c5c3f3cb7e7$var$listStyles = null;
const $8f398c5c3f3cb7e7$var$UList = ({ children: children, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)("ul", {
        ...props,
        className: (0, $hcewu.default)([
            "_19bvv47k _bozgv47k"
        ]),
        children: children
    });
var $8f398c5c3f3cb7e7$export$2e2bcd8739ae039 = $8f398c5c3f3cb7e7$var$UList;

});


parcelRegister("ei710", function(module, exports) {

$parcel$export(module.exports, "default", () => $fda5b98323afadf3$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");
const $fda5b98323afadf3$export$6118ed0013927eb2 = ({ children: children, isFadeIn: isFadeIn = false, minHeight: minHeight = 0, show: show, showTransition: showTransition = false })=>{
    const [height, setHeight] = (0, $eJOHy.useState)(0);
    const ref = (0, $eJOHy.useRef)(null);
    const transition = isFadeIn ? 'height, opacity' : 'height';
    (0, $eJOHy.useEffect)(()=>{
        if (show && ref.current) // set the height of the error message container explicitly to the height
        // of its contents (including anything hidden due to overflow) so that we
        // can animate the height of the container
        setHeight(ref.current.scrollHeight);
        else setHeight(0);
    }, [
        children,
        show
    ]);
    return show ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        style: {
            height: height,
            minHeight: minHeight,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
            lineHeight: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            overflow: 'hidden',
            // a fit for purpose state variable to control when the 'visible' styles should be appled
            opacity: height > 0 ? 1 : 0,
            // we only want to transition opacity and height when the error message is initially shown
            // not if its to be shown on mount
            transitionProperty: showTransition ? transition : 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            transitionDuration: '0.3s'
        },
        ref: ref,
        children: children
    }) : null;
};
var $fda5b98323afadf3$export$2e2bcd8739ae039 = $fda5b98323afadf3$export$6118ed0013927eb2;

});

parcelRegister("cQU20", function(module, exports) {

$parcel$export(module.exports, "default", () => $f73e03b62ddf95ac$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $bmWcp = parcelRequire("bmWcp");
const $f73e03b62ddf95ac$var$AIEventSummaryViewed = ({ fromCache: fromCache = null })=>{
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        fireEvent('ui.summary.viewed', {
            fromCache: fromCache
        });
        if (fromCache) fireEvent('track.aiInteraction.initiated', {
            aiFeatureName: 'Smart Links Summary',
            proactiveAIGenerated: 1,
            userGeneratedAI: 0
        });
    }, [
        fireEvent,
        fromCache
    ]);
    return null;
};
var $f73e03b62ddf95ac$export$2e2bcd8739ae039 = $f73e03b62ddf95ac$var$AIEventSummaryViewed;

});



parcelRegister("eMgzj", function(module, exports) {

$parcel$export(module.exports, "default", () => $a57421ef9d4f6376$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $37K19 = parcelRequire("37K19");
/**
 * Represents a AIFooterBlock, designed to show provider metadata in
 * addition to AI tooltip icons if AI is enabled
 * @param {AIFooterBlockProps} AIFooterBlockProps
 * @see Block
 */ const $a57421ef9d4f6376$var$AIFooterBlock = ({ testId: testId = 'smart-ai-footer-block', ...props })=>{
    const cardContext = (0, $5FRJ8.useFlexibleCardContext)();
    if (cardContext?.status !== (0, $5NtHI.SmartLinkStatus).Resolved) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $37K19.default), {
        ...props,
        size: props.size ?? cardContext?.ui?.size,
        testId: testId
    });
};
var $a57421ef9d4f6376$export$2e2bcd8739ae039 = $a57421ef9d4f6376$var$AIFooterBlock;

});
parcelRegister("37K19", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a90281cb091ec71$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $6l7Bk = parcelRequire("6l7Bk");

var $bIdM1 = parcelRequire("bIdM1");

var $kopBz = parcelRequire("kopBz");
const $3a90281cb091ec71$var$AIFooterBlockResolvedView = (props)=>{
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $5NtHI.InternalActionName).AISummaryAction];
    const { testId: testId } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bIdM1.default), {
        ...props,
        testId: `${testId}-resolved-view`,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6l7Bk.default), {
                appearance: "subtle",
                testId: `${testId}-provider`
            }),
            actionData ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kopBz.AIFooterMetadata), {
                ...actionData,
                testId: `${testId}-ai-metadata`
            }) : null
        ]
    });
};
var $3a90281cb091ec71$export$2e2bcd8739ae039 = $3a90281cb091ec71$var$AIFooterBlockResolvedView;

});
parcelRegister("kopBz", function(module, exports) {

$parcel$export(module.exports, "AIFooterMetadata", () => $bf118c10e8951921$export$175228cc2c92b3b6);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $gRw8I = parcelRequire("gRw8I");

var $fOqNz = parcelRequire("fOqNz");

var $8IeH1 = parcelRequire("8IeH1");
var $6djmC = parcelRequire("6djmC");

var $k71qx = parcelRequire("k71qx");

var $19nmp = parcelRequire("19nmp");

var $2LycE = parcelRequire("2LycE");

var $jeUcl = parcelRequire("jeUcl");

var $bB163 = parcelRequire("bB163");
const $bf118c10e8951921$export$175228cc2c92b3b6 = ({ testId: testId, url: url })=>{
    (0, $gRw8I.di)((0, $2LycE.default));
    const { state: { status: status } } = (0, $2LycE.default)(url);
    if (status !== 'done') return null;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
        space: "space.100",
        testId: testId,
        alignInline: "end",
        grow: "fill",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
                content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...(0, $19nmp.messages).ai_summarized_info_short
                }),
                position: "bottom",
                children: (tooltipProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                        ...tooltipProps,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bB163.InfoIcon), {
                            label: "Information",
                            LEGACY_size: "small",
                            color: "var(--ds-icon-subtle, #626F86)"
                        })
                    })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fOqNz))), {
                label: "AI",
                LEGACY_size: "small",
                LEGACY_fallbackIcon: (0, $jeUcl.default),
                color: "var(--ds-icon-subtle, #626F86)"
            })
        ]
    });
};

});
parcelRegister("bB163", function(module, exports) {

$parcel$export(module.exports, "InfoIcon", () => $ebe2ee8525f34821$export$2957fc44b3d2481);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $2R0ne = parcelRequire("2R0ne");

var $klVDP = parcelRequire("klVDP");
const $ebe2ee8525f34821$export$2957fc44b3d2481 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2R0ne))), {
        color: props.color || 'currentColor',
        LEGACY_fallbackIcon: (0, $klVDP.default),
        ...props
    });

});
parcelRegister("2R0ne", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b0749aecb688ec01c0962b8f7fb609ff>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2140d232e8b0a187$var$_react = $2140d232e8b0a187$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $2140d232e8b0a187$var$_baseNew = $2140d232e8b0a187$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $2140d232e8b0a187$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusInformation".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for information statuses and messaging. 
Filled status icons provide higher visual contrast to draw attention to important information.
For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2140d232e8b0a187$var$StatusInformationIcon = (props)=>/*#__PURE__*/ $2140d232e8b0a187$var$_react.default.createElement($2140d232e8b0a187$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.5 6.75v1.5h.75v4.25h1.5v-5A.75.75 0 0 0 8 6.75zM8 3.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2" clip-rule="evenodd"/>`
    }, props));
$2140d232e8b0a187$var$StatusInformationIcon.displayName = 'StatusInformationIcon';
var $2140d232e8b0a187$var$_default = module.exports.default = $2140d232e8b0a187$var$StatusInformationIcon;

});

parcelRegister("klVDP", function(module, exports) {

$parcel$export(module.exports, "default", () => $95f050f94233fcee$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $95f050f94233fcee$var$InfoIconGlyph = (props)=>/*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M7 5C7 5.55228 7.44772 6 8 6C8.55228 6 9 5.55228 9 5C9 4.44772 8.55228 4 8 4C7.44772 4 7 4.44772 7 5Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "M7.25 7L7.25 12H8.75L8.75 7H7.25Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1ZM2.5 8C2.5 11.0376 4.96243 13.5 8 13.5C11.0376 13.5 13.5 11.0376 13.5 8C13.5 4.96243 11.0376 2.5 8 2.5C4.96243 2.5 2.5 4.96243 2.5 8Z",
                fill: "currentColor"
            })
        ]
    });
/**
 * __InfoIcon__
 */ const $95f050f94233fcee$var$InfoIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.default), {
        label: label,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        testId: testId,
        glyph: $95f050f94233fcee$var$InfoIconGlyph
    });
var $95f050f94233fcee$export$2e2bcd8739ae039 = $95f050f94233fcee$var$InfoIcon;

});





parcelRegister("4cjOx", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a174909684ab758$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $gRw8I = parcelRequire("gRw8I");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $lHA6U = parcelRequire("lHA6U");

var $1dIgp = parcelRequire("1dIgp");
const $3a174909684ab758$var$ignoreContainerPaddingStyles = null;
const $3a174909684ab758$var$DEFAULT_SORT_ORDER = [
    'PreviewAction',
    'CopyLinkAction',
    'AISummaryAction'
];
const $3a174909684ab758$var$sort = (a, b)=>{
    let idxA = $3a174909684ab758$var$DEFAULT_SORT_ORDER.indexOf(a);
    let idxB = $3a174909684ab758$var$DEFAULT_SORT_ORDER.indexOf(b);
    if (idxA === -1) idxA = $3a174909684ab758$var$DEFAULT_SORT_ORDER.length;
    if (idxB === -1) idxB = $3a174909684ab758$var$DEFAULT_SORT_ORDER.length;
    return idxA - idxB;
};
const $3a174909684ab758$export$1af10e3728e3a644 = (size)=>{
    switch(size){
        case (0, $5NtHI.SmartLinkSize).XLarge:
            return "var(--ds-space-300, 24px)";
        case (0, $5NtHI.SmartLinkSize).Large:
            return "var(--ds-space-250, 20px)";
        case (0, $5NtHI.SmartLinkSize).Medium:
            return "var(--ds-space-200, 16px)";
        case (0, $5NtHI.SmartLinkSize).Small:
        default:
            return "var(--ds-space-100, 8px)";
    }
};
const $3a174909684ab758$var$ActionBlock = ({ blockRef: blockRef, onClick: onClickCallback, size: size, spaceInline: spaceInline, className: className, testId: testId = 'smart-block-action' })=>{
    (0, $gRw8I.di)((0, $1dIgp.ActionFooter));
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const ui = (0, $5FRJ8.useFlexibleUiOptionContext)();
    const [message, setMessage] = (0, $eJOHy.useState)();
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(false);
    const onLoadingChange = (0, $eJOHy.useCallback)((isLoading)=>{
        setIsLoading(isLoading);
    }, [
        setIsLoading
    ]);
    const padding = !ui?.hidePadding ? $3a174909684ab758$export$1af10e3728e3a644(ui?.size || (0, $5NtHI.SmartLinkSize).Medium) : undefined;
    const onClick = (0, $eJOHy.useCallback)((name)=>{
        setMessage(undefined);
        onClickCallback?.(name);
    }, [
        onClickCallback
    ]);
    const onError = (0, $eJOHy.useCallback)((error)=>{
        setMessage(error);
    }, []);
    const actions = (0, $eJOHy.useMemo)(()=>{
        if (!context?.actions) return;
        const arr = Object.keys(context.actions);
        arr.sort($3a174909684ab758$var$sort);
        return arr.map((name)=>{
            const Action = name in $lHA6U ? $lHA6U[name] : undefined;
            return Action ? /*#__PURE__*/ (0, $gt9Am.jsx)(Action, {
                as: "stack-item",
                spaceInline: spaceInline,
                onClick: ()=>onClick(name),
                onError: onError,
                onLoadingChange: onLoadingChange,
                size: size || ui?.size,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/no-unsafe-design-token-usage
                style: padding && {
                    paddingInline: padding
                },
                hideTooltip: isLoading
            }, name) : null;
        });
    }, [
        context?.actions,
        spaceInline,
        onError,
        onLoadingChange,
        size,
        ui?.size,
        padding,
        isLoading,
        onClick
    ]);
    return actions ? /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        ref: blockRef,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_1e0c1txw _2lx21bp4 _vchhusvi _16jlkb7n _1bsb129b _18u01ivi _2hwxc10g",
            className
        ]),
        children: [
            actions,
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1dIgp.ActionFooter), {
                message: message,
                testId: testId
            })
        ]
    }) : null;
};
var $3a174909684ab758$export$2e2bcd8739ae039 = $3a174909684ab758$var$ActionBlock;

});
parcelRegister("1dIgp", function(module, exports) {

$parcel$export(module.exports, "ActionFooter", () => $495d2943b4977c6a$export$2d2b754ac238f9aa);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $d3cA1 = parcelRequire("d3cA1");

var $8IeH1 = parcelRequire("8IeH1");
var $6djmC = parcelRequire("6djmC");

var $ei710 = parcelRequire("ei710");
const $495d2943b4977c6a$var$styles = {
    containerStyles: "_kkk2n7od _2rkoglpi _1rjc12x7 _18zru2gc _19pku2gc _2hwxu2gc _otyrze3t _18u0u2gc _1bsb1osq _fiawglyw",
    errorContentStyles: "_bozgv77o",
    titleStyles: "_11c8dcr7 _syaz1gjq"
};
const $495d2943b4977c6a$var$getIcon = (appearance)=>{
    switch(appearance){
        case 'error':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d3cA1))), {
                color: "var(--ds-icon-danger, #C9372C)",
                spacing: "compact",
                label: "Error",
                LEGACY_size: "small",
                testId: "action-error-icon",
                LEGACY_margin: `0 ${"var(--ds-space-negative-025, -2px)"}`,
                size: "small"
            });
        default:
            return null;
    }
};
const $495d2943b4977c6a$export$2d2b754ac238f9aa = ({ message: message, testId: testId })=>{
    if (!message) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        backgroundColor: message.appearance === 'error' ? 'color.background.danger' : undefined,
        testId: `${testId}-footer`,
        style: {
            width: `calc(100% - var(--container-padding-left) - var(--container-padding-right))`
        },
        xcss: $495d2943b4977c6a$var$styles.containerStyles,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ei710.default), {
            isFadeIn: true,
            show: true,
            showTransition: true,
            children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
                alignBlock: "start",
                grow: "fill",
                space: "space.075",
                xcss: $495d2943b4977c6a$var$styles.errorContentStyles,
                children: [
                    message.icon || $495d2943b4977c6a$var$getIcon(message.appearance),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                        xcss: $495d2943b4977c6a$var$styles.titleStyles,
                        children: message.title
                    })
                ]
            })
        })
    });
};

});




parcelRegister("k9P6L", function(module, exports) {

$parcel$export(module.exports, "LoadingCardLink", () => $9acebe3c2480723a$export$1ca0544321134ad6);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kj3Kk = parcelRequire("kj3Kk");

const $9acebe3c2480723a$export$1ca0544321134ad6 = ({ isSelected: isSelected, url: url, placeholder: placeholder })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kj3Kk.CardLinkView), {
        testId: 'lazy-render-placeholder',
        "data-trello-do-not-use-override": "lazy-render-placeholder-trello",
        isSelected: isSelected,
        link: url,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $6ed49f57481afa45$export$4b2b7d155f69aed4),
        placeholder: placeholder
    }, 'lazy-render-key');
};

});
parcelRegister("kj3Kk", function(module, exports) {

$parcel$export(module.exports, "CardLinkView", () => $c60e87c9a02f8e5e$export$ce508304ed2dd145);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $bu0pj = parcelRequire("bu0pj");
class $c60e87c9a02f8e5e$export$ce508304ed2dd145 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).PureComponent {
    render() {
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bu0pj.Frame), {
            withoutBackground: true,
            ...this.props,
            children: this.props.placeholder || this.props.link
        });
    }
}

});
parcelRegister("bu0pj", function(module, exports) {

$parcel$export(module.exports, "Frame", () => $a33467e63cbde9e1$export$b89a827e9254211a);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $e3qu2 = parcelRequire("e3qu2");

var $hFjcp = parcelRequire("hFjcp");
const $a33467e63cbde9e1$export$b89a827e9254211a = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const { isSelected: isSelected, children: children, onClick: onClick, link: link, withoutBackground: withoutBackground, testId: testId, className: className, isHovered: isHovered, truncateInline: truncateInline } = props;
    const handleClick = (0, $eJOHy.useCallback)((event)=>{
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]);
    const handleKeyPress = (0, $eJOHy.useCallback)((event)=>{
        if (event.key !== ' ' && event.key !== 'Enter') return;
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]);
    const handleMouseDown = (0, $e3qu2.useMouseDownEvent)();
    const isInteractive = Boolean(onClick);
    const isAnchor = Boolean(link || onClick);
    // Depending on whenever Frame was given onClick or link itself we display span or anchor elements
    const Wrapper = isAnchor ? (0, $hFjcp.WrapperAnchor) : (0, $hFjcp.WrapperSpan);
    return /*#__PURE__*/ (0, $gt9Am.jsx)(Wrapper, {
        href: link,
        withoutBackground: withoutBackground,
        isSelected: isSelected,
        isInteractive: isInteractive,
        tabIndex: isInteractive ? 0 : undefined,
        role: isInteractive ? 'button' : undefined,
        onClick: handleClick,
        onMouseDown: handleMouseDown,
        onKeyPress: handleKeyPress,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        ref: ref,
        isHovered: isHovered,
        truncateInline: truncateInline,
        children: children
    });
});

});
parcelRegister("hFjcp", function(module, exports) {

$parcel$export(module.exports, "WrapperSpan", () => $410d9f0a7ea732a2$export$8b5c95e985c4ec9a);
$parcel$export(module.exports, "WrapperAnchor", () => $410d9f0a7ea732a2$export$6e4bde711df5c2ab);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");
const $410d9f0a7ea732a2$export$8b5c95e985c4ec9a = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ truncateInline: truncateInline, withoutBackground: withoutBackground, isHovered: isHovered, isInteractive: isInteractive, isSelected: isSelected, href: href, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        ref: ref,
        ...props,
        className: (0, $hcewu.default)([
            "_1yt4x7n9 _2rkoiti9 _v56415x0 _1e0c1nu9 _16d9qvcn _syaz1y58 _1rkwglyw _4cvxmr28",
            truncateInline && "_1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bto1l2s _1nmz9jpi _1e0c1abx _1yyjkb7n _sudp1e54 _nr8z1o8l _1voyv77o _3kwxidpf _jqg5v77o _6vwiidpf",
            withoutBackground ? "_19bvidpf _18u01i6y" : "_19ith6cr _bfhkhp5a _1a3b18uv _4fprglyw _5goinqa1 _9oik18uv _1bnxglyw _jf4cnqa1 _1nrm18uv _c2waglyw _1iohnqa1",
            isHovered && "_1h6dmr28",
            isHovered && !withoutBackground && "_4bfu18uv _1hmsglyw _ajmmnqa1",
            isSelected ? "_12ji1r31 _1qu2glyw _12y31o36 _80omtlke _16qscw00 _uiztglyw _1a3b18uv _4fprglyw _5goinqa1 _9oik18uv _1bnxglyw _jf4cnqa1 _bfw7h6cr _1nrm18uv _c2waglyw _1iohnqa1" : "_uizt1kdv"
        ]),
        children: props.children
    });
});
const $410d9f0a7ea732a2$export$6e4bde711df5c2ab = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ truncateInline: truncateInline, withoutBackground: withoutBackground, isHovered: isHovered, isInteractive: isInteractive, isSelected: isSelected, href: href, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("a", {
        href: href,
        ref: ref,
        ...props,
        className: (0, $hcewu.default)([
            "_1yt4x7n9 _2rkoiti9 _v56415x0 _1e0c1nu9 _16d9qvcn _syaz1y58 _1rkwglyw _4cvxmr28",
            truncateInline && "_1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bto1l2s _1nmz9jpi _1e0c1abx _1yyjkb7n _sudp1e54 _nr8z1o8l _1voyv77o _3kwxidpf _jqg5v77o _6vwiidpf",
            withoutBackground ? "_19bvidpf _18u01i6y" : "_19ith6cr _bfhkhp5a _1a3b18uv _4fprglyw _5goinqa1 _9oik18uv _1bnxglyw _jf4cnqa1 _1nrm18uv _c2waglyw _1iohnqa1",
            isHovered && "_1h6dmr28",
            isHovered && !withoutBackground && "_4bfu18uv _1hmsglyw _ajmmnqa1",
            isSelected ? "_12ji1r31 _1qu2glyw _12y31o36 _80omtlke _16qscw00 _uiztglyw _1a3b18uv _4fprglyw _5goinqa1 _9oik18uv _1bnxglyw _jf4cnqa1 _bfw7h6cr _1nrm18uv _c2waglyw _1iohnqa1" : "_uizt1kdv",
            isInteractive && "_nt751r31 _49pcglyw _1hvw1o36 _1372tlke _7ehicw00 _1j5pglyw _1di629zg"
        ]),
        children: props.children
    });
});
const $410d9f0a7ea732a2$var$baseWrapperStyles = null;
// if the parent instruct the wrapper to be interactive, and the wrapper is in focus, apply selectedStyles
const $410d9f0a7ea732a2$var$interactiveStyles = null;
const $410d9f0a7ea732a2$var$hoveredStyles = null;
const $410d9f0a7ea732a2$var$hoveredWithBackgroundStyles = null;
const $410d9f0a7ea732a2$var$withoutBackgroundStyles = null;
const $410d9f0a7ea732a2$var$withBackgroundStyles = null;
const $410d9f0a7ea732a2$var$truncateStyles = null;
const $410d9f0a7ea732a2$var$notSelectedStyle = null;
const $410d9f0a7ea732a2$var$selectedStyles = null;

});



const $6ed49f57481afa45$export$4b2b7d155f69aed4 = 'smart-link-loading-placeholder';


parcelRegister("cXd9T", function(module, exports) {

let $96e533b7ac04a55f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $96e533b7ac04a55f$var$load("6nRbC").then(()=>parcelRequire('kzwZ8'));

});



parcelRegister("8YHJ2", function(module, exports) {

$parcel$export(module.exports, "CardSSR", () => $265c0be3b7df6739$export$7b5e1b7f9a325b6);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $axOsj = parcelRequire("axOsj");

var $aXKmr = parcelRequire("aXKmr");

var $e2B2h = parcelRequire("e2B2h");

var $eGOwo = parcelRequire("eGOwo");

var $b43DQ = parcelRequire("b43DQ");

var $4oATR = parcelRequire("4oATR");

var $k9P6L = parcelRequire("k9P6L");
const $265c0be3b7df6739$export$7b5e1b7f9a325b6 = (props)=>{
    const [id] = (0, $eJOHy.useState)(()=>props.id ?? (0, (/*@__PURE__*/$parcel$interopDefault($aXKmr)))());
    const cardProps = {
        ...props,
        id: id
    };
    const ErrorFallbackComponent = cardProps.fallbackComponent;
    const errorBoundaryFallbackComponent = ()=>{
        if (ErrorFallbackComponent) return /*#__PURE__*/ (0, $gt9Am.jsx)(ErrorFallbackComponent, {});
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k9P6L.LoadingCardLink), {
            ...cardProps
        });
    };
    if ((0, $eGOwo.fg)('platform_editor_inline_card_selected_state_fix')) {
        const Component = cardProps.appearance === 'inline' ? 'span' : 'div';
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $e2B2h.default), {
            data: (0, $b43DQ.context),
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $axOsj.ErrorBoundary), {
                FallbackComponent: errorBoundaryFallbackComponent,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
                    className: "loader-wrapper",
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4oATR.CardWithUrlContent), {
                        ...cardProps
                    })
                })
            })
        });
    }
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $e2B2h.default), {
        data: (0, $b43DQ.context),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $axOsj.ErrorBoundary), {
            FallbackComponent: errorBoundaryFallbackComponent,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4oATR.CardWithUrlContent), {
                ...cardProps
            })
        })
    });
};

});
parcelRegister("4oATR", function(module, exports) {

$parcel$export(module.exports, "CardWithUrlContent", () => $e563c8affb3daadf$export$7598f5d7c597dd32);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $bmWcp = parcelRequire("bmWcp");

var $5NtHI = parcelRequire("5NtHI");

var $iT7eO = parcelRequire("iT7eO");

var $1mLfK = parcelRequire("1mLfK");

var $03JM4 = parcelRequire("03JM4");

var $fezTc = parcelRequire("fezTc");

var $FoFt2 = parcelRequire("FoFt2");

var $88ISi = parcelRequire("88ISi");

var $liquj = parcelRequire("liquj");

var $44bDi = parcelRequire("44bDi");

var $1YI3f = parcelRequire("1YI3f");

var $2QXr6 = parcelRequire("2QXr6");

var $3u14o = parcelRequire("3u14o");

var $9uyEx = parcelRequire("9uyEx");

var $19G04 = parcelRequire("19G04");

var $6J1DL = parcelRequire("6J1DL");
function $e563c8affb3daadf$var$Component({ id: id, url: url, isSelected: isSelected, isHovered: isHovered, frameStyle: frameStyle, platform: platform, onClick: onClick, appearance: appearance, onResolve: onResolve, onError: onError, testId: testId, actionOptions: actionOptionsProp, inheritDimensions: inheritDimensions, embedIframeRef: embedIframeRef, embedIframeUrlType: embedIframeUrlType, inlinePreloaderStyle: inlinePreloaderStyle, ui: ui, children: children, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, removeTextHighlightingFromTitle: removeTextHighlightingFromTitle, resolvingPlaceholder: resolvingPlaceholder, truncateInline: truncateInline, CompetitorPrompt: CompetitorPrompt, hideIconLoadingSkeleton: hideIconLoadingSkeleton }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    // Get state, actions for this card.
    const { state: state, actions: actions, config: config, renderers: renderers, error: error, isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel } = (0, $iT7eO.useSmartLink)(id, url);
    const ari = (0, $03JM4.getObjectAri)(state.details);
    const name = (0, $03JM4.getObjectName)(state.details);
    const definitionId = (0, $03JM4.getDefinitionId)(state.details);
    const extensionKey = (0, $03JM4.getExtensionKey)(state.details);
    const resourceType = (0, $03JM4.getResourceType)(state.details);
    const services = (0, $03JM4.getServices)(state.details);
    let isFlexibleUi = (0, $eJOHy.useMemo)(()=>(0, $1YI3f.isFlexibleUiCard)(children, ui), [
        children,
        ui
    ]);
    const actionOptions = (0, $88ISi.combineActionOptions)({
        actionOptions: actionOptionsProp,
        platform: platform
    });
    // Setup UI handlers.
    const handleClickWrapper = (0, $eJOHy.useCallback)((event)=>{
        const isModifierKeyPressed = (0, $FoFt2.isSpecialKey)(event) || (0, $FoFt2.isSpecialClick)(event);
        fireEvent('ui.smartLink.clicked', {
            id: id,
            display: isFlexibleUi ? (0, $5NtHI.CardDisplay).Flexible : appearance,
            definitionId: definitionId ?? null,
            isModifierKeyPressed: isModifierKeyPressed
        });
        // If preview panel is available and the user clicked on the link,
        // delegate the click to the preview panel handler
        if (!isModifierKeyPressed && ari && name && openPreviewPanel && isPreviewPanelAvailable?.({
            ari: ari
        })) {
            event.preventDefault();
            event.stopPropagation();
            openPreviewPanel({
                url: url,
                ari: ari,
                name: name,
                iconUrl: (0, $03JM4.getObjectIconUrl)(state.details)
            });
            (0, $liquj.fireLinkClickedEvent)(createAnalyticsEvent)(event, {
                attributes: {
                    clickOutcome: 'previewPanel'
                }
            });
        } else if (!onClick && !isFlexibleUi) {
            const clickUrl = (0, $03JM4.getClickUrl)(url, state.details);
            // Ctrl+left click on mac typically doesn't trigger onClick
            // The event could have potentially had `e.preventDefault()` called on it by now
            // event by smart card internally
            // If it has been called then only then can `isSpecialEvent` be true.
            const target = (0, $FoFt2.isSpecialEvent)(event) ? '_blank' : '_self';
            window.open(clickUrl, target);
            (0, $liquj.fireLinkClickedEvent)(createAnalyticsEvent)(event, {
                attributes: {
                    clickOutcome: target === '_blank' ? 'clickThroughNewTabOrWindow' : 'clickThrough'
                }
            });
        } else {
            if (onClick) onClick(event);
            (0, $liquj.fireLinkClickedEvent)(createAnalyticsEvent)(event);
        }
    }, [
        fireEvent,
        id,
        isFlexibleUi,
        appearance,
        definitionId,
        onClick,
        url,
        state.details,
        ari,
        name,
        isPreviewPanelAvailable,
        openPreviewPanel,
        createAnalyticsEvent
    ]);
    const handleAuthorize = (0, $eJOHy.useCallback)(()=>actions.authorize(appearance), [
        actions,
        appearance
    ]);
    const handleRetry = (0, $eJOHy.useCallback)(()=>{
        actions.reload();
    }, [
        actions
    ]);
    const handleInvoke = (0, $eJOHy.useCallback)((opts)=>actions.invoke(opts, appearance), [
        actions,
        appearance
    ]);
    // NB: for each status change in a Smart Link, a performance mark is created.
    // Measures are sent relative to the first mark, matching what a user sees.
    (0, $eJOHy.useEffect)(()=>{
        $2QXr6.mark(id, state.status);
        if (state.status !== 'pending' && state.status !== 'resolving') {
            $2QXr6.create(id, state.status);
            if (state.status === 'resolved') fireEvent('operational.smartLink.resolved', {
                definitionId: definitionId ?? null,
                duration: $2QXr6.getMeasure(id, state.status)?.duration ?? null
            });
            else if (state.error?.type !== 'ResolveUnsupportedError' && state.error?.type !== 'UnsupportedError') fireEvent('operational.smartLink.unresolved', {
                definitionId: definitionId ?? null,
                reason: state.status,
                error: state.error === undefined ? null : {
                    name: state.error.name,
                    kind: state.error.kind,
                    type: state.error.type
                }
            });
        }
    }, [
        id,
        appearance,
        state.status,
        state.error,
        definitionId,
        extensionKey,
        resourceType,
        fireEvent
    ]);
    // NB: once the smart-card has rendered into an end state, we capture
    // this as a successful render. These can be one of:
    // - the resolved state: when metadata is shown;
    // - the unresolved states: viz. forbidden, not_found, unauthorized, errored.
    (0, $eJOHy.useEffect)(()=>{
        if ((0, $03JM4.isFinalState)(state.status)) {
            (0, $1mLfK.succeedUfoExperience)('smart-link-rendered', id || 'NULL', {
                extensionKey: extensionKey,
                display: isFlexibleUi ? 'flexible' : appearance
            });
            // UFO will disregard this if authentication experience has not yet been started
            (0, $1mLfK.succeedUfoExperience)('smart-link-authenticated', id || 'NULL', {
                display: isFlexibleUi ? 'flexible' : appearance
            });
            fireEvent('ui.smartLink.renderSuccess', {
                display: isFlexibleUi ? 'flexible' : appearance
            });
        }
    }, [
        appearance,
        extensionKey,
        fireEvent,
        id,
        isFlexibleUi,
        state.status
    ]);
    const onIframeDwell = (0, $eJOHy.useCallback)((dwellTime, dwellPercentVisible)=>{
        fireEvent('ui.smartLinkIframe.dwelled', {
            id: id,
            definitionId: definitionId ?? null,
            display: isFlexibleUi ? 'flexible' : appearance,
            dwellPercentVisible: dwellPercentVisible,
            dwellTime: dwellTime
        });
    }, [
        id,
        appearance,
        definitionId,
        isFlexibleUi,
        fireEvent
    ]);
    const onIframeFocus = (0, $eJOHy.useCallback)(()=>{
        fireEvent('ui.smartLinkIframe.focused', {
            id: id,
            definitionId: definitionId ?? null,
            display: isFlexibleUi ? 'flexible' : appearance
        });
    }, [
        id,
        appearance,
        definitionId,
        isFlexibleUi,
        fireEvent
    ]);
    if (isFlexibleUi) {
        let cardState = state;
        if (error) {
            if (error?.name === 'APIError') cardState = {
                status: 'errored'
            };
            else throw error;
        }
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $19G04.default), {
            id: id,
            cardState: cardState,
            onAuthorize: services.length && handleAuthorize || undefined,
            onClick: handleClickWrapper,
            origin: "smartLinkCard",
            renderers: renderers,
            ui: ui,
            showHoverPreview: showHoverPreview,
            hoverPreviewOptions: hoverPreviewOptions,
            actionOptions: actionOptions,
            url: url,
            testId: testId,
            onResolve: onResolve,
            onError: onError,
            children: children
        });
    }
    // We have to keep this last to prevent hook order from being violated
    if (error) throw error;
    switch(appearance){
        case 'inline':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6J1DL.InlineCard), {
                id: id,
                url: url,
                renderers: renderers,
                cardState: state,
                handleAuthorize: services.length && handleAuthorize || undefined,
                handleFrameClick: handleClickWrapper,
                isSelected: isSelected,
                isHovered: isHovered,
                onResolve: onResolve,
                onError: onError,
                testId: testId,
                inlinePreloaderStyle: inlinePreloaderStyle,
                showHoverPreview: showHoverPreview,
                hoverPreviewOptions: hoverPreviewOptions,
                actionOptions: actionOptions,
                removeTextHighlightingFromTitle: removeTextHighlightingFromTitle,
                resolvingPlaceholder: resolvingPlaceholder,
                truncateInline: truncateInline
            });
        case 'block':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3u14o.BlockCard), {
                id: id,
                url: url,
                renderers: renderers,
                authFlow: config && config.authFlow,
                cardState: state,
                handleAuthorize: services.length && handleAuthorize || undefined,
                handleFrameClick: handleClickWrapper,
                isSelected: isSelected,
                onResolve: onResolve,
                onError: onError,
                testId: testId,
                actionOptions: actionOptions,
                CompetitorPrompt: CompetitorPrompt,
                hideIconLoadingSkeleton: hideIconLoadingSkeleton
            });
        case 'embed':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9uyEx.EmbedCard), {
                id: id,
                url: url,
                renderers: renderers,
                cardState: state,
                iframeUrlType: embedIframeUrlType,
                handleAuthorize: services.length && handleAuthorize || undefined,
                handleErrorRetry: handleRetry,
                handleFrameClick: handleClickWrapper,
                handleInvoke: handleInvoke,
                isSelected: isSelected,
                frameStyle: frameStyle,
                platform: platform,
                onResolve: onResolve,
                onError: onError,
                testId: testId,
                inheritDimensions: inheritDimensions,
                actionOptions: actionOptions,
                ref: embedIframeRef,
                onIframeDwell: onIframeDwell,
                onIframeFocus: onIframeFocus,
                CompetitorPrompt: CompetitorPrompt
            });
    }
}
const $e563c8affb3daadf$export$7598f5d7c597dd32 = (props)=>{
    const display = (0, $1YI3f.isFlexibleUiCard)(props.children, props?.ui) ? (0, $5NtHI.CardDisplay).Flexible : props.appearance;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fezTc.SmartLinkModalProvider), {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $44bDi.SmartLinkAnalyticsContext), {
            url: props.url,
            id: props.id,
            display: display,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)($e563c8affb3daadf$var$Component, {
                ...props
            })
        })
    });
};

});
parcelRegister("iT7eO", function(module, exports) {

$parcel$export(module.exports, "useSmartLink", () => $509c107b2b076848$export$9f4e486b1dc3e700);

var $eJOHy = parcelRequire("eJOHy");

var $9kfy2 = parcelRequire("9kfy2");

var $bde0S = parcelRequire("bde0S");

var $2vJUc = parcelRequire("2vJUc");

var $5MmSu = parcelRequire("5MmSu");

var $5TXKo = parcelRequire("5TXKo");
function $509c107b2b076848$export$9f4e486b1dc3e700(id, url) {
    const state = (0, $5TXKo.useSmartCardState)(url);
    const { store: store, isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel } = (0, $9kfy2.useSmartLinkContext)();
    const actions = (0, $bde0S.useSmartCardActions)(id, url);
    const config = (0, $2vJUc.useSmartLinkConfig)();
    const renderers = (0, $5MmSu.useSmartLinkRenderers)();
    // NB: used to propagate errors from hooks to error boundaries.
    const [error, setError] = (0, $eJOHy.useState)(null);
    // Register the current card.
    const register = ()=>{
        actions.register().catch((err)=>setError(err));
    };
    // AFP-2511 TODO: Fix automatic suppressions below
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $eJOHy.useEffect)(register, [
        url,
        store
    ]);
    // Provide the state and card actions to consumers.
    return {
        state: state,
        actions: actions,
        config: config,
        renderers: renderers,
        error: error,
        isPreviewPanelAvailable: isPreviewPanelAvailable,
        openPreviewPanel: openPreviewPanel
    };
}

});
parcelRegister("bde0S", function(module, exports) {

$parcel$export(module.exports, "useSmartCardActions", () => $0b92ec45d8e4fb8b$export$f7c340395f31e832);

var $eJOHy = parcelRequire("eJOHy");

var $9kfy2 = parcelRequire("9kfy2");

var $ggoTr = parcelRequire("ggoTr");

var $ldBiz = parcelRequire("ldBiz");

var $bmWcp = parcelRequire("bmWcp");

var $5NtHI = parcelRequire("5NtHI");

var $1mLfK = parcelRequire("1mLfK");

var $03JM4 = parcelRequire("03JM4");

var $7xssH = parcelRequire("7xssH");

var $kbv8x = parcelRequire("kbv8x");
const $0b92ec45d8e4fb8b$export$f7c340395f31e832 = (id, url)=>{
    const resolveUrl = (0, $kbv8x.default)();
    const invokeClientAction = (0, $7xssH.default)({});
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const { store: store } = (0, $9kfy2.useSmartLinkContext)();
    const { getState: getState, dispatch: dispatch } = store;
    const getSmartLinkState = (0, $eJOHy.useCallback)(()=>{
        const { details: details, status: status, metadataStatus: metadataStatus } = getState()[url] ?? {
            status: (0, $5NtHI.SmartLinkStatus).Pending
        };
        return {
            details: details,
            status: status,
            metadataStatus: metadataStatus
        };
    }, [
        getState,
        url
    ]);
    const setMetadataStatus = (0, $eJOHy.useCallback)((metadataStatus)=>{
        dispatch((0, $ggoTr.cardAction)((0, $ggoTr.ACTION_UPDATE_METADATA_STATUS), {
            url: url
        }, undefined, undefined, metadataStatus));
    }, [
        dispatch,
        url
    ]);
    const resolve = (0, $eJOHy.useCallback)(async (resourceUrl = url, isReloading = false, isMetadataRequest = false)=>resolveUrl(resourceUrl, isReloading, isMetadataRequest, id), [
        id,
        resolveUrl,
        url
    ]);
    const register = (0, $eJOHy.useCallback)(()=>{
        const { details: details } = getSmartLinkState();
        if (!details) {
            dispatch((0, $ggoTr.cardAction)((0, $ggoTr.ACTION_RESOLVING), {
                url: url
            }));
            setMetadataStatus('pending');
        }
        return resolve();
    }, [
        getSmartLinkState,
        resolve,
        dispatch,
        url,
        setMetadataStatus
    ]);
    const reload = (0, $eJOHy.useCallback)(()=>{
        const { details: details } = getSmartLinkState();
        const definitionId = (0, $03JM4.getDefinitionId)(details);
        if (definitionId) (0, $03JM4.getByDefinitionId)(definitionId, getState()).map((url)=>resolve(url, true));
        else resolve(url, true);
    }, [
        getSmartLinkState,
        url,
        getState,
        resolve
    ]);
    const loadMetadata = (0, $eJOHy.useCallback)(()=>{
        const { metadataStatus: metadataStatus } = getSmartLinkState();
        //metadataStatus will be undefined for SSR links only
        if (metadataStatus === undefined) {
            setMetadataStatus('pending');
            return resolve(url, false, true);
        }
    }, [
        getSmartLinkState,
        resolve,
        setMetadataStatus,
        url
    ]);
    const authorize = (0, $eJOHy.useCallback)((appearance)=>{
        const { details: details, status: status } = getSmartLinkState();
        const definitionId = (0, $03JM4.getDefinitionId)(details);
        const extensionKey = (0, $03JM4.getExtensionKey)(details);
        const services = (0, $03JM4.getServices)(details);
        // When authentication is triggered, let GAS know!
        if (status === 'unauthorized') fireEvent('ui.button.clicked.connectAccount', {
            display: appearance,
            definitionId: definitionId ?? null
        });
        if (status === 'forbidden') fireEvent('ui.smartLink.clicked.tryAnotherAccount', {
            display: appearance,
            definitionId: definitionId ?? null
        });
        if (services.length > 0) {
            fireEvent('screen.consentModal.viewed', {
                definitionId: definitionId ?? null
            });
            (0, $ldBiz.auth)(services[0].url).then(()=>{
                fireEvent('track.applicationAccount.connected', {
                    definitionId: definitionId ?? null
                });
                (0, $1mLfK.startUfoExperience)('smart-link-authenticated', id, {
                    extensionKey: extensionKey,
                    status: 'success'
                });
                fireEvent('operational.smartLink.connectSucceeded', {
                    definitionId: definitionId ?? null
                });
                reload();
            }, (err)=>{
                (0, $1mLfK.startUfoExperience)('smart-link-authenticated', id, {
                    extensionKey: extensionKey,
                    status: err.type
                });
                fireEvent('operational.smartLink.connectFailed', {
                    definitionId: definitionId ?? null,
                    reason: err.type ?? null
                });
                if (err.type === 'auth_window_closed') fireEvent('ui.consentModal.closed', {
                    display: appearance,
                    definitionId: definitionId ?? null
                });
                reload();
            });
        }
    }, [
        getSmartLinkState,
        id,
        reload,
        fireEvent
    ]);
    const invoke = (0, $eJOHy.useCallback)(async (opts, appearance)=>{
        const { key: key, action: action } = opts;
        const source = opts.source || appearance;
        if (opts.type === 'client') return await invokeClientAction({
            actionFn: opts.action.promise,
            actionType: action.type,
            display: source,
            extensionKey: key
        });
    }, [
        invokeClientAction
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            register: register,
            reload: reload,
            authorize: authorize,
            invoke: invoke,
            loadMetadata: loadMetadata
        }), [
        register,
        reload,
        authorize,
        invoke,
        loadMetadata
    ]);
};

});
parcelRegister("ldBiz", function(module, exports) {

$parcel$export(module.exports, "auth", () => $3affdc949abfd5e9$export$73693bad9f5880b0);
$parcel$export(module.exports, "AuthError", () => (parcelRequire("kwM7Y")).AuthError);

var $kwM7Y = parcelRequire("kwM7Y");

var $jGjox = parcelRequire("jGjox");
function $3affdc949abfd5e9$export$73693bad9f5880b0(startUrl, windowFeatures) {
    return new Promise((resolve, reject)=>{
        let authWindow = null;
        let authWindowInterval;
        const handleAuthWindowMessage = (event)=>{
            if (event.source !== authWindow) return;
            const { data: data } = event;
            if (typeof data !== 'object') return;
            switch(data.type){
                case 'outbound-auth:success':
                    finish();
                    resolve();
                    break;
                case 'outbound-auth:failure':
                    finish();
                    const errorType = data.errorType.toLowerCase();
                    if ((0, $jGjox.isOfTypeAuthError)(errorType)) reject(new (0, $kwM7Y.AuthError)(data.message, errorType));
                    else reject(new (0, $kwM7Y.AuthError)(data.message));
                    break;
            }
        };
        const handleAuthWindowInterval = ()=>{
            if (authWindow && authWindow.closed) {
                finish();
                reject(new (0, $kwM7Y.AuthError)('The auth window was closed', 'auth_window_closed'));
            }
        };
        const start = ()=>{
            window.addEventListener('message', handleAuthWindowMessage);
            authWindow = window.open(startUrl, startUrl, windowFeatures);
            authWindowInterval = window.setInterval(handleAuthWindowInterval, 500);
        };
        const finish = ()=>{
            clearInterval(authWindowInterval);
            window.removeEventListener('message', handleAuthWindowMessage);
            if (authWindow) {
                authWindow.close();
                authWindow = null;
            }
        };
        start();
    });
}

});
parcelRegister("kwM7Y", function(module, exports) {

$parcel$export(module.exports, "AuthError", () => $4f8710bc730ecae5$export$145273558d58e0ac);
class $4f8710bc730ecae5$export$145273558d58e0ac extends Error {
    constructor(message, type){
        super(message), this.message = message, this.type = type;
        this.name = 'AuthError';
        this.type = type;
        this.message = message;
    }
}

});

parcelRegister("jGjox", function(module, exports) {

$parcel$export(module.exports, "isOfTypeAuthError", () => $b4e26c6b0cd1efbb$export$400e64c8451aa84f);
// See https://tools.ietf.org/html/rfc6749#section-4.1.2.1
// 'auth_window_closed' is returned in addition to types from this RFC,
// representing when the authentication window is closed by the user
// 'authclientoauth2.autherror' is added to represent errors from
// outbound-auth
const $b4e26c6b0cd1efbb$export$400e64c8451aa84f = (inputString)=>{
    return [
        'auth_window_closed',
        'invalid_request',
        'unauthorized_client',
        'access_denied',
        'unsupported_response_type',
        'invalid_scope',
        'server_error',
        'temporarily_unavailable',
        'authclientoauth2.autherror'
    ].includes(inputString);
};

});


parcelRegister("03JM4", function(module, exports) {

$parcel$export(module.exports, "getByDefinitionId", () => $a9130c46b8c7e440$export$f75b0b690ab4dfb9);
$parcel$export(module.exports, "getClickUrl", () => $a9130c46b8c7e440$export$cf3c5acf9e9d0f02);
$parcel$export(module.exports, "getDefinitionId", () => $a9130c46b8c7e440$export$46fa3e7718c82e41);
$parcel$export(module.exports, "getExtensionKey", () => $a9130c46b8c7e440$export$218d96312e385949);
$parcel$export(module.exports, "getObjectAri", () => $a9130c46b8c7e440$export$81164c1570bcd038);
$parcel$export(module.exports, "getObjectName", () => $a9130c46b8c7e440$export$5615361d76a8be5);
$parcel$export(module.exports, "getObjectIconUrl", () => $a9130c46b8c7e440$export$bcf275804417edda);
$parcel$export(module.exports, "getResourceType", () => $a9130c46b8c7e440$export$16c0ebb0de9b767b);
$parcel$export(module.exports, "getServices", () => $a9130c46b8c7e440$export$a009e3a1163d46fb);
$parcel$export(module.exports, "isFinalState", () => $a9130c46b8c7e440$export$d590d08942abc17a);
$parcel$export(module.exports, "hasAuthScopeOverrides", () => $a9130c46b8c7e440$export$3f9446bb21b945a0);

var $70skx = parcelRequire("70skx");
const $a9130c46b8c7e440$export$f75b0b690ab4dfb9 = (definitionId, store)=>{
    const urls = Object.keys(store);
    return urls.filter((url)=>{
        const { details: details } = store[url];
        return details && details.meta.definitionId === definitionId;
    });
};
const $a9130c46b8c7e440$export$cf3c5acf9e9d0f02 = (url, jsonLd)=>{
    if (jsonLd && jsonLd.data) {
        const visitUrl = (0, $70skx.extractVisitUrl)(jsonLd.data);
        if (visitUrl) return visitUrl;
    }
    return url;
};
const $a9130c46b8c7e440$export$46fa3e7718c82e41 = (details)=>details?.meta?.definitionId;
const $a9130c46b8c7e440$export$218d96312e385949 = (details)=>details?.meta?.key;
const $a9130c46b8c7e440$export$81164c1570bcd038 = (details)=>details?.data && 'atlassian:ari' in details.data && details.data['atlassian:ari'] || undefined;
const $a9130c46b8c7e440$export$5615361d76a8be5 = (details)=>details?.data && 'name' in details.data && details.data.name || undefined;
const $a9130c46b8c7e440$export$bcf275804417edda = (details)=>{
    if (details?.data && 'icon' in details.data && details.data.icon) {
        if (typeof details.data.icon === 'object' && 'url' in details.data.icon && details.data.icon.url && typeof details.data.icon.url === 'string') return details.data.icon.url;
    }
    return undefined;
};
const $a9130c46b8c7e440$export$16c0ebb0de9b767b = (details)=>details?.meta?.resourceType;
const $a9130c46b8c7e440$export$e2005c9600188ac7 = (details)=>details?.meta?.product;
const $a9130c46b8c7e440$export$f8fdefc70357968e = (details)=>details?.meta?.subproduct;
const $a9130c46b8c7e440$export$a009e3a1163d46fb = (details)=>details && details.meta.auth || [];
const $a9130c46b8c7e440$export$ac5d414b1ebfab5a = (details)=>details && $a9130c46b8c7e440$export$cd41ae544cfc2a65(details) && $a9130c46b8c7e440$export$795910f5f15a9633(details);
const $a9130c46b8c7e440$export$cd41ae544cfc2a65 = ({ meta: { access: access } })=>access === 'granted';
const $a9130c46b8c7e440$export$795910f5f15a9633 = ({ meta: { visibility: visibility } })=>visibility === 'restricted' || visibility === 'public';
const $a9130c46b8c7e440$export$a752a116d184ffbd = (details)=>{
    return details?.meta?.requestAccess?.accessType;
};
const $a9130c46b8c7e440$export$d590d08942abc17a = (status)=>{
    return [
        'unauthorized',
        'forbidden',
        'errored',
        'resolved',
        'not_found'
    ].indexOf(status) > -1;
};
const $a9130c46b8c7e440$export$66805b16d2a1da7c = (details)=>details?.datasources;
const $a9130c46b8c7e440$export$ba6d13ab7b87c55c = (details)=>{
    const datasources = $a9130c46b8c7e440$export$66805b16d2a1da7c(details);
    return !!datasources && datasources.length > 0;
};
const $a9130c46b8c7e440$export$3f9446bb21b945a0 = (details)=>!!details?.meta.hasScopeOverrides;

});
parcelRegister("70skx", function(module, exports) {

$parcel$export(module.exports, "extractVisitUrl", () => $23c7211e82610c9c$export$c81497d3681f24f4);
const $23c7211e82610c9c$export$c81497d3681f24f4 = (jsonLd)=>{
    return jsonLd['atlassian:visitUrl'];
};

});



parcelRegister("2vJUc", function(module, exports) {

$parcel$export(module.exports, "useSmartLinkConfig", () => $42e17606dc58a0f1$export$5d10838c1e539409);

var $9kfy2 = parcelRequire("9kfy2");
const $42e17606dc58a0f1$export$5d10838c1e539409 = ()=>{
    const context = (0, $9kfy2.useSmartLinkContext)();
    if (context) return context.config;
    return undefined;
};

});


parcelRegister("88ISi", function(module, exports) {

$parcel$export(module.exports, "combineActionOptions", () => $8dae431f81ca4538$export$2ae4cf79c720146a);
const $8dae431f81ca4538$export$2ae4cf79c720146a = ({ actionOptions: actionOptions, platform: platform })=>{
    if (typeof actionOptions !== 'undefined') return actionOptions;
    if (platform === 'mobile') return {
        hide: true
    };
    let exclude = [];
    return {
        hide: false,
        exclude: exclude
    };
};

});

parcelRegister("3u14o", function(module, exports) {

$parcel$export(module.exports, "BlockCard", () => $5cab8467edf2e496$export$d18ccd25c0d2c6b0);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $dLR8J = parcelRequire("dLR8J");

var $9gzoR = parcelRequire("9gzoR");

var $4UV7R = parcelRequire("4UV7R");

var $dDP8i = parcelRequire("dDP8i");

var $kj3Kk = parcelRequire("kj3Kk");

var $fQuyl = parcelRequire("fQuyl");

var $1uPx2 = parcelRequire("1uPx2");

var $eB1dU = parcelRequire("eB1dU");

var $8jMdw = parcelRequire("8jMdw");

var $4fOPS = parcelRequire("4fOPS");
const $5cab8467edf2e496$var$UFOLoadHoldWrapper = ({ children: children })=>{
    return (0, $eGOwo.fg)('platform_renderer_blindspots') ? /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dLR8J.default), {
                name: "smart-card-block-card"
            }),
            children
        ]
    }) : children;
};
const $5cab8467edf2e496$export$d18ccd25c0d2c6b0 = ({ id: id, url: url, cardState: cardState, authFlow: authFlow, handleAuthorize: handleAuthorize, handleFrameClick: handleFrameClick, renderers: renderers, isSelected: isSelected, onResolve: onResolve, onError: onError, testId: testId, actionOptions: actionOptions, CompetitorPrompt: CompetitorPrompt, hideIconLoadingSkeleton: hideIconLoadingSkeleton })=>{
    const { status: status } = cardState;
    const blockCardProps = {
        id: id,
        cardState: cardState,
        url: url,
        testId: testId,
        onClick: (event)=>(0, $dDP8i.handleClickCommon)(event, handleFrameClick),
        onError: onError,
        onResolve: onResolve,
        renderers: renderers,
        actionOptions: actionOptions,
        CompetitorPrompt: CompetitorPrompt,
        hideIconLoadingSkeleton: hideIconLoadingSkeleton
    };
    const { shouldControlDataExport: shouldControlDataExport = false } = (0, $9gzoR.useControlDataExportConfig)();
    switch(status){
        case 'pending':
        case 'resolving':
            return /*#__PURE__*/ (0, $gt9Am.jsx)($5cab8467edf2e496$var$UFOLoadHoldWrapper, {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8jMdw.default), {
                    ...blockCardProps,
                    testId: "smart-block-resolving-view"
                })
            });
        case 'resolved':
            if ((0, $eGOwo.fg)('platform_smart_links_controlled_dsp_export_view')) {
                if ((0, $4UV7R.getIsDataExportEnabled)(shouldControlDataExport, cardState.details)) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4fOPS.default), {
                    ...blockCardProps,
                    onAuthorize: handleAuthorize
                });
            }
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8jMdw.default), {
                ...blockCardProps
            });
        case 'unauthorized':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4fOPS.default), {
                ...blockCardProps,
                onAuthorize: handleAuthorize
            });
        case 'forbidden':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1uPx2.default), {
                ...blockCardProps,
                onAuthorize: handleAuthorize
            });
        case 'not_found':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eB1dU.default), {
                ...blockCardProps,
                onAuthorize: handleAuthorize
            });
        case 'fallback':
        case 'errored':
        default:
            if (onError) onError({
                url: url,
                status: status
            });
            if (authFlow && authFlow === 'disabled') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kj3Kk.CardLinkView), {
                link: url,
                isSelected: isSelected,
                onClick: handleFrameClick,
                testId: `${testId}-${status}`
            });
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fQuyl.default), {
                ...blockCardProps,
                onAuthorize: handleAuthorize
            });
    }
};

});
parcelRegister("9gzoR", function(module, exports) {

$parcel$export(module.exports, "useControlDataExportConfig", () => $99508fe9399992b6$export$f93c47f1b2b3f55b);

var $eJOHy = parcelRequire("eJOHy");

var $9kfy2 = parcelRequire("9kfy2");
const $99508fe9399992b6$export$f93c47f1b2b3f55b = ()=>{
    const { connections: connections, product: product, shouldControlDataExport: shouldControlDataExport } = (0, $9kfy2.useSmartLinkContext)();
    return (0, $eJOHy.useMemo)(()=>({
            baseUrl: connections.client.baseUrlOverride,
            envKey: connections.client.envKey,
            product: product,
            shouldControlDataExport: shouldControlDataExport
        }), [
        connections.client.baseUrlOverride,
        connections.client.envKey,
        product,
        shouldControlDataExport
    ]);
};

});

parcelRegister("4UV7R", function(module, exports) {

$parcel$export(module.exports, "getIsDataExportEnabled", () => $12a2b77c03a84659$export$a019611f39785186);
const $12a2b77c03a84659$export$a019611f39785186 = (shouldControlDataExport = false, response)=>Boolean(shouldControlDataExport && response?.meta?.supportedFeature?.includes('ExportBlocked'));

});

parcelRegister("dDP8i", function(module, exports) {

$parcel$export(module.exports, "handleClickCommon", () => $b32501177a2ef5a6$export$9759a67e215c4598);
const $b32501177a2ef5a6$export$9759a67e215c4598 = (event, onClick)=>{
    if (onClick) {
        event.preventDefault();
        event.stopPropagation();
        onClick(event);
    }
};

});

parcelRegister("fQuyl", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee7e07d7b1d98a1b$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $3Isp2 = parcelRequire("3Isp2");

var $19nmp = parcelRequire("19nmp");

var $38cBa = parcelRequire("38cBa");

var $dX77y = parcelRequire("dX77y");

var $dXXLc = parcelRequire("dXXLc");

var $lc1jH = parcelRequire("lc1jH");
/**
 * This view represents a Block Card with an 'Errored' status.
 *
 * @see SmartLinkStatus
 * @see FlexibleCardProps
 */ const $ee7e07d7b1d98a1b$var$ErroredView = ({ testId: testId = 'smart-block-errored-view', ...props })=>{
    const actions = (0, $eJOHy.useMemo)(()=>props.onAuthorize ? [
            (0, $dX77y.RetryAction)(props.onAuthorize)
        ] : [], [
        props.onAuthorize
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $dXXLc.default), {
        ...props,
        actions: actions,
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3Isp2))), {
                label: "errored-warning-icon",
                color: "var(--ds-icon-warning, #E56910)",
                LEGACY_size: "small",
                testId: `${testId}-warning-icon`
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
                maxLines: 3,
                message: {
                    descriptor: (0, $19nmp.messages).could_not_load_link
                }
            })
        ]
    });
};
var $ee7e07d7b1d98a1b$export$2e2bcd8739ae039 = (0, $lc1jH.withFlexibleUIBlockCardStyle)($ee7e07d7b1d98a1b$var$ErroredView);

});
parcelRegister("dX77y", function(module, exports) {

$parcel$export(module.exports, "RetryAction", () => $bcb724787f99bc8f$export$c527d977b53f7537);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");
const $bcb724787f99bc8f$export$c527d977b53f7537 = (onRetry)=>({
        name: (0, $5NtHI.ActionName).CustomAction,
        onClick: onRetry,
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).try_again
        }),
        testId: 'smart-action-try-again'
    });

});

parcelRegister("dXXLc", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ae672cf08406695$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $8GnsF = parcelRequire("8GnsF");

var $eGOwo = parcelRequire("eGOwo");

var $19G04 = parcelRequire("19G04");

var $bIdM1 = parcelRequire("bIdM1");
var $3pcXQ = parcelRequire("3pcXQ");
var $8Rjtc = parcelRequire("8Rjtc");
var $fqBfo = parcelRequire("fqBfo");

var $g7toL = parcelRequire("g7toL");
const $2ae672cf08406695$var$customBlockStyles = null;
const $2ae672cf08406695$var$titleBlockCss = null;
const $2ae672cf08406695$var$footerBlockCss = null;
const $2ae672cf08406695$var$footerBlockSafariStyles = null;
const $2ae672cf08406695$var$UnresolvedView = ({ actions: actions, cardState: cardState, children: children, onAuthorize: onAuthorize, onClick: onClick, onError: onError, showPreview: showPreview = false, testId: testId, title: title, url: url })=>{
    const { safari: safari = false } = (0, $eGOwo.fg)('platform-linking-visual-refresh-v2') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eJOHy.useMemo)(()=>(0, $8GnsF.browser)(), []) : {};
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $19G04.default), {
        appearance: "block",
        cardState: cardState,
        onAuthorize: onAuthorize,
        onClick: onClick,
        onError: onError,
        origin: "smartLinkCard",
        testId: testId,
        ui: (0, $g7toL.FlexibleCardUiOptions),
        url: url,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fqBfo.default), {
                ...(0, $g7toL.titleBlockOptions),
                hideIcon: !!title,
                text: title,
                className: (0, $hcewu.default)([
                    "_zulpu2gc _13mh1pd9 _2yhz14q2"
                ])
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bIdM1.default), {
                className: (0, $hcewu.default)([
                    "_zulp1b66 _1e0c1txw _4cvr1y6m _1wpz1fhb _7yjtidpf _ngc01fxt"
                ]),
                children: children
            }),
            showPreview && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8Rjtc.default), {
                ...(0, $g7toL.PreviewBlockOptions)
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3pcXQ.default), {
                actions: actions,
                testId: "smart-block-card-footer",
                className: (0, $hcewu.default)([
                    "_4t3i1k8s _1e0c1txw _1bah1yb4 _4cvresu3 _1wpz1fhb",
                    safari && (0, $eGOwo.fg)('platform-linking-visual-refresh-v2') && "_4t3i1osq"
                ])
            })
        ]
    });
};
var $2ae672cf08406695$export$2e2bcd8739ae039 = $2ae672cf08406695$var$UnresolvedView;

});
parcelRegister("19G04", function(module, exports) {

$parcel$export(module.exports, "default", () => $b72b0d53d138fc6a$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $bmWcp = parcelRequire("bmWcp");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $k2hJv = parcelRequire("k2hJv");

var $kbv8x = parcelRequire("kbv8x");

var $dpCTw = parcelRequire("dpCTw");

var $025st = parcelRequire("025st");
/**
 * This represents a Flexible Card: a link represented by a card with metadata.
 * This is the container in which all Flexible UI Blocks and Elements exist.
 * Note: TitleBlock is mandatory for a Flexible Card to render.
 * @see Container
 */ const $b72b0d53d138fc6a$var$FlexibleCard = ({ appearance: appearance = 'flexible', cardState: cardState, children: children, id: id, onAuthorize: onAuthorize, onClick: onClick, onError: onError, onResolve: onResolve, origin: origin, renderers: renderers, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, testId: testId, ui: ui, url: url })=>{
    const aiSummaryConfig = (0, $k2hJv.useAISummaryConfig)();
    const resolve = (0, $kbv8x.default)();
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const { status: cardType, details: details } = cardState;
    const status = cardType;
    const context = (0, $eJOHy.useMemo)(()=>(0, $025st.getContextByStatus)({
            aiSummaryConfig: aiSummaryConfig,
            appearance: appearance,
            fireEvent: fireEvent,
            response: details,
            id: id,
            onAuthorize: onAuthorize,
            onClick: onClick,
            origin: origin,
            renderers: renderers,
            resolve: resolve,
            actionOptions: actionOptions,
            status: status,
            url: url
        }), [
        aiSummaryConfig,
        appearance,
        fireEvent,
        details,
        id,
        onAuthorize,
        onClick,
        origin,
        renderers,
        resolve,
        actionOptions,
        status,
        url
    ]);
    const flexibleCardContext = (0, $eJOHy.useMemo)(()=>({
            data: context,
            status: status,
            ui: ui
        }), [
        context,
        status,
        ui
    ]);
    const { linkTitle: linkTitle } = context || {};
    const title = linkTitle?.text;
    (0, $eJOHy.useEffect)(()=>{
        switch(status){
            case (0, $5NtHI.SmartLinkStatus).Resolved:
                if (onResolve) onResolve({
                    title: title,
                    url: url
                });
                break;
            case (0, $5NtHI.SmartLinkStatus).Errored:
            case (0, $5NtHI.SmartLinkStatus).Fallback:
            case (0, $5NtHI.SmartLinkStatus).Forbidden:
            case (0, $5NtHI.SmartLinkStatus).NotFound:
            case (0, $5NtHI.SmartLinkStatus).Unauthorized:
                if (onError) onError({
                    status: status,
                    url: url
                });
                break;
        }
    }, [
        onError,
        onResolve,
        status,
        title,
        url
    ]);
    const retry = flexibleCardContext.data?.actions?.[(0, $5NtHI.InternalActionName).UnresolvedAction];
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5FRJ8.FlexibleCardContext).Provider, {
        value: flexibleCardContext,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dpCTw.default), {
            testId: testId,
            ...ui,
            onClick: onClick,
            showHoverPreview: showHoverPreview,
            hoverPreviewOptions: hoverPreviewOptions,
            actionOptions: actionOptions,
            status: status,
            retry: retry,
            children: children
        })
    });
};
var $b72b0d53d138fc6a$export$2e2bcd8739ae039 = $b72b0d53d138fc6a$var$FlexibleCard;

});
parcelRegister("dpCTw", function(module, exports) {

$parcel$export(module.exports, "default", () => $2113f7140aee1e4f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $eJOHy = parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");

var $5NtHI = parcelRequire("5NtHI");

var $5FRJ8 = parcelRequire("5FRJ8");

var $hq0iR = parcelRequire("hq0iR");

var $1YI3f = parcelRequire("1YI3f");

var $fqBfo = parcelRequire("fqBfo");

var $hjkWh = parcelRequire("hjkWh");

var $59hpa = parcelRequire("59hpa");
const $2113f7140aee1e4f$export$6f4e0540a2f2295a = (children, context)=>{
    let options = {};
    if ((0, $hq0iR.isFlexUiPreviewPresent)(context)) (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(children, (child)=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(child)) {
            if ((0, $1YI3f.isFlexibleUiPreviewBlock)(child)) {
                const { placement: placement } = child.props;
                if (placement === (0, $5NtHI.MediaPlacement).Left) options.previewOnLeft = true;
                if (placement === (0, $5NtHI.MediaPlacement).Right) options.previewOnRight = true;
            }
        }
    });
    return options;
};
const $2113f7140aee1e4f$var$filterChildren = (children, removeBlockRestriction)=>{
    if (removeBlockRestriction) return children;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(children, (child)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(child) && (0, $1YI3f.isFlexibleUiBlock)(child) ? child : undefined);
};
const $2113f7140aee1e4f$export$f6c7a950371733c8 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(node)) return undefined;
    if (node.type === (0, $fqBfo.default)) return node;
    if ((0, $1YI3f.isStyleCacheProvider)(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid;
        (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.map(node.props.children, (child)=>{
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $2113f7140aee1e4f$export$f6c7a950371733c8(child);
        });
        return isChildrenValid;
    }
    return undefined;
};
const $2113f7140aee1e4f$var$getTitleBlockProps = (children)=>{
    const block = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.toArray(children).map((child)=>$2113f7140aee1e4f$export$f6c7a950371733c8(child)).filter((x)=>x !== undefined).at(0);
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(block)) return block.props;
};
const $2113f7140aee1e4f$var$getLayeredLink = (testId, context, children, onClick)=>{
    const { linkTitle: linkTitle, url: url = '' } = context || {};
    const { anchorTarget: target, text: text } = $2113f7140aee1e4f$var$getTitleBlockProps(children) || {};
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $59hpa.default), {
        onClick: onClick,
        target: target,
        testId: testId,
        text: text || linkTitle?.text,
        url: url
    });
};
const $2113f7140aee1e4f$var$baseStyleCommon = null;
const $2113f7140aee1e4f$var$backgroundStyles = null;
const $2113f7140aee1e4f$var$elevationStyles = null;
const $2113f7140aee1e4f$var$clickableContainerStyles = null;
const $2113f7140aee1e4f$var$gapStyleMap = {
    xlarge: "_zulpr2fv",
    large: "_zulpzu5n",
    medium: "_zulp1bpf",
    small: "_zulpswc3"
};
/**
 * Get container padding based on smart link size
 * Equivalent version for DS primitives space token is getPrimitivesPaddingSpaceBySize()
 * at view/FlexibleCard/components/utils.tsx
 */ const $2113f7140aee1e4f$var$getPadding = (size)=>{
    switch(size){
        case (0, $5NtHI.SmartLinkSize).XLarge:
            return "var(--ds-space-300, 24px)";
        case (0, $5NtHI.SmartLinkSize).Large:
            return "var(--ds-space-250, 20px)";
        case (0, $5NtHI.SmartLinkSize).Medium:
            return "var(--ds-space-200, 16px)";
        case (0, $5NtHI.SmartLinkSize).Small:
        default:
            return "var(--ds-space-100, 8px)";
    }
};
const $2113f7140aee1e4f$var$getGap = (size)=>{
    switch(size){
        case (0, $5NtHI.SmartLinkSize).XLarge:
            return "var(--ds-space-250, 20px)";
        case (0, $5NtHI.SmartLinkSize).Large:
            return "var(--ds-space-200, 16px)";
        case (0, $5NtHI.SmartLinkSize).Medium:
            return "var(--ds-space-100, 8px)";
        case (0, $5NtHI.SmartLinkSize).Small:
        default:
            return "var(--ds-space-050, 4px)";
    }
};
const $2113f7140aee1e4f$var$previewOnLeftStyleMap = {
    xlarge: "_19bver0k _y5vk1ejb",
    large: "_19bv16ru _y5vkv47k",
    medium: "_19bv1g7w _y5vk1eak",
    small: "_19bvlbes _y5vku2gc"
};
const $2113f7140aee1e4f$var$previewOnRightStyleMap = {
    xlarge: "_u5f3er0k _1yob1ejb",
    large: "_u5f316ru _1yobv47k",
    medium: "_u5f31g7w _1yob1eak",
    small: "_u5f3lbes _1yobu2gc"
};
/**
 * A container is a hidden component that build the Flexible Smart Link.
 * All the Flexible UI components are wrapped inside the container.
 * It inherits the ui props from Card component and applies the custom styling
 * accordingly.
 * @internal
 * @see Block
 */ const $2113f7140aee1e4f$var$Container = ({ children: children, clickableContainer: clickableContainer = false, hideBackground: hideBackground = false, hideElevation: hideElevation = false, hidePadding: hidePadding = false, onClick: onClick, retry: retry, showHoverPreview: showHoverPreview = false, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, removeBlockRestriction: removeBlockRestriction = false, size: size = (0, $5NtHI.SmartLinkSize).Medium, status: status, testId: testId = 'smart-links-container' })=>{
    (0, $gRw8I.di)((0, $hjkWh.default));
    const padding = hidePadding ? '0px' : $2113f7140aee1e4f$var$getPadding(size);
    const gap = $2113f7140aee1e4f$var$getGap(size);
    const context = (0, $5FRJ8.useFlexibleUiContext)();
    const { previewOnLeft: previewOnLeft, previewOnRight: previewOnRight } = $2113f7140aee1e4f$export$6f4e0540a2f2295a(children, context);
    const canShowHoverPreview = showHoverPreview && status === 'resolved';
    // `retry` object contains action that can be performed on
    // unresolved link (unauthorized, forbidden, not found, etc.)
    const canShowAuthTooltip = showHoverPreview && status === 'unauthorized' && retry !== undefined;
    const containerPaddingStyles = null;
    const container = /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        "data-smart-link-container": true,
        "data-testid": testId,
        className: (0, $hcewu.default)([
            "_1e0c1txw _2lx21bp4 _1ul9idpf _1reo15vq _kqswh2mm _1pcmkb7n _1v7y1i6y _ufn21i6y",
            $2113f7140aee1e4f$var$gapStyleMap[size],
            !hideBackground && "_bfhkhp5a",
            "_1yt418y6 _jb7v18y6 _y5vk167t _1yob1wow _r37x1r5k",
            previewOnLeft && $2113f7140aee1e4f$var$previewOnLeftStyleMap[size],
            previewOnRight && $2113f7140aee1e4f$var$previewOnRightStyleMap[size],
            !hideElevation && "_19itzgxb _2rkob7nn _19pkv77o _2hwxv77o _otyrv77o _18u0v77o",
            clickableContainer && "_nqwih2mm _18ywh2mm _1nq3h2mm _1t4ckb7n _1nxdkb7n _xnbykb7n"
        ]),
        style: {
            "--_1xumd0e": (0, $awdRS.default)(padding),
            "--_73mooq": (0, $awdRS.default)(previewOnLeft ? gap : padding),
            "--_12k13bg": (0, $awdRS.default)(previewOnRight ? gap : padding)
        },
        children: [
            clickableContainer ? $2113f7140aee1e4f$var$getLayeredLink(testId, context, children, onClick) : null,
            $2113f7140aee1e4f$var$filterChildren(children, removeBlockRestriction)
        ]
    });
    if (context?.url && (canShowHoverPreview || canShowAuthTooltip)) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hjkWh.default), {
        isHoverPreview: canShowHoverPreview,
        isAuthTooltip: canShowAuthTooltip,
        actionOptions: actionOptions,
        testId: testId,
        url: context.url,
        hoverPreviewOptions: hoverPreviewOptions,
        children: container
    });
    return container;
};
var $2113f7140aee1e4f$export$2e2bcd8739ae039 = $2113f7140aee1e4f$var$Container;

});
parcelRegister("hq0iR", function(module, exports) {

$parcel$export(module.exports, "isFlexUiPreviewPresent", () => $0488d9459cc3a179$export$783c1bf8fee63f80);
const $0488d9459cc3a179$export$783c1bf8fee63f80 = (context)=>Boolean(context && context.preview);

});

parcelRegister("hjkWh", function(module, exports) {

$parcel$export(module.exports, "default", () => $68910ca9bc088568$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5NtHI = parcelRequire("5NtHI");

var $3S6ja = parcelRequire("3S6ja");
const $68910ca9bc088568$var$FLEXIBLE_HOVER_CARD_CAN_OPEN_DELAY = 100;
const $68910ca9bc088568$var$HoverCardControl = ({ children: children, isHoverPreview: isHoverPreview, isAuthTooltip: isAuthTooltip, actionOptions: actionOptions, testId: testId, url: url, delay: delay = $68910ca9bc088568$var$FLEXIBLE_HOVER_CARD_CAN_OPEN_DELAY, hoverPreviewOptions: hoverPreviewOptions })=>{
    const [canOpen, setCanOpen] = (0, $eJOHy.useState)(true);
    const mouseStopTimer = (0, $eJOHy.useRef)();
    (0, $eJOHy.useEffect)(()=>{
        return ()=>{
            if (mouseStopTimer.current) clearTimeout(mouseStopTimer.current);
        };
    }, []);
    const onMouseLeave = (0, $eJOHy.useCallback)(()=>{
        if (mouseStopTimer.current) clearTimeout(mouseStopTimer.current);
    }, []);
    const onMouseMove = (0, $eJOHy.useCallback)((e)=>{
        if (mouseStopTimer.current) clearTimeout(mouseStopTimer.current);
        // Never show hover card on action or when action dropdown opens.
        // The code below can be simplified by using :is() and :has()
        // but the pseudo-class isn't support by Firefox yet.
        const action = // Any action button group (title/footer block)
        e.target.closest('.actions-button-group') || // When action dropdown list is opened on action button group or lozenge action
        e.target.closest('[data-smart-link-container]')?.querySelector('[data-action-open="true"]');
        const canOpenOnElement = isAuthTooltip && !action || // EDM-7060: For hover preview, also hide hover card on all elements
        // except title element (link title)
        isHoverPreview && !action && !e.target.closest(`[data-smart-element]:not([data-smart-element="${(0, $5NtHI.ElementName).Title}"])`);
        mouseStopTimer.current = setTimeout(()=>{
            if (canOpen !== canOpenOnElement) setCanOpen(Boolean(canOpenOnElement));
        }, delay);
    }, [
        isAuthTooltip,
        isHoverPreview,
        canOpen,
        delay
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3S6ja.HoverCard), {
        allowEventPropagation: true,
        canOpen: canOpen,
        closeOnChildClick: true,
        actionOptions: actionOptions,
        url: url,
        hoverPreviewOptions: hoverPreviewOptions,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
            onMouseLeave: onMouseLeave,
            onMouseMove: onMouseMove,
            "data-testid": `${testId}-hover-card-wrapper`,
            children: children
        })
    });
};
var $68910ca9bc088568$export$2e2bcd8739ae039 = $68910ca9bc088568$var$HoverCardControl;

});
parcelRegister("3S6ja", function(module, exports) {

$parcel$export(module.exports, "HoverCard", () => $4672c7a0b9a7b840$export$57a077cc9fbe653e);
$parcel$export(module.exports, "StandaloneHoverCard", () => $4672c7a0b9a7b840$export$f1f63acbe6ed8fb0);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $axOsj = parcelRequire("axOsj");

var $gRw8I = parcelRequire("gRw8I");

var $4J0ad = parcelRequire("4J0ad");

var $bmWcp = parcelRequire("bmWcp");

var $5NtHI = parcelRequire("5NtHI");

var $1mLfK = parcelRequire("1mLfK");

var $fezTc = parcelRequire("fezTc");

var $44bDi = parcelRequire("44bDi");

var $ct5r8 = parcelRequire("ct5r8");
const $4672c7a0b9a7b840$var$HoverCardWithErrorBoundary = (props)=>{
    (0, $gRw8I.di)((0, $ct5r8.HoverCardComponent));
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const { url: url, id: id, children: children } = props;
    const analyticsContext = (0, $44bDi.useSmartLinkAnalyticsContext)({
        display: (0, $5NtHI.CardDisplay).HoverCardPreview,
        id: id,
        source: (0, $ct5r8.HOVER_CARD_SOURCE),
        url: url
    });
    const onError = (0, $eJOHy.useCallback)((error, info)=>{
        (0, $1mLfK.startUfoExperience)('smart-link-rendered', id || 'NULL');
        (0, $1mLfK.failUfoExperience)('smart-link-rendered', id || 'NULL');
        (0, $1mLfK.failUfoExperience)('smart-link-authenticated', id || 'NULL');
        fireEvent('ui.smartLink.renderFailed', {
            ...analyticsContext?.attributes,
            display: (0, $5NtHI.CardDisplay).HoverCardPreview,
            id: id ?? null,
            error: error,
            errorInfo: info
        });
    }, [
        analyticsContext,
        id,
        fireEvent
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $axOsj.ErrorBoundary), {
        fallback: children,
        onError: onError,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fezTc.SmartLinkModalProvider), {
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ct5r8.HoverCardComponent), {
                ...props,
                children: children
            })
        })
    });
};
const $4672c7a0b9a7b840$var$HoverCardWithoutAnalyticsContext = (0, $4J0ad.default)()($4672c7a0b9a7b840$var$HoverCardWithErrorBoundary);
const $4672c7a0b9a7b840$export$57a077cc9fbe653e = (props)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)($4672c7a0b9a7b840$var$HoverCardWithoutAnalyticsContext, {
        ...props
    });
};
const $4672c7a0b9a7b840$export$f1f63acbe6ed8fb0 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)($4672c7a0b9a7b840$export$57a077cc9fbe653e, {
        ...props
    });

});
parcelRegister("ct5r8", function(module, exports) {

$parcel$export(module.exports, "HOVER_CARD_SOURCE", () => $bcd82f075ee4a70e$export$421dbc3834daf261);
$parcel$export(module.exports, "HoverCardComponent", () => $bcd82f075ee4a70e$export$e2173dafa6a751bb);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $kJsb4 = parcelRequire("kJsb4");

var $5NtHI = parcelRequire("5NtHI");

var $bde0S = parcelRequire("bde0S");

var $5MmSu = parcelRequire("5MmSu");

var $5TXKo = parcelRequire("5TXKo");

var $44bDi = parcelRequire("44bDi");

var $dNwAf = parcelRequire("dNwAf");

var $awu5s = parcelRequire("awu5s");

var $kj7DC = parcelRequire("kj7DC");
const $bcd82f075ee4a70e$export$421dbc3834daf261 = 'smartLinkPreviewHoverCard';
const $bcd82f075ee4a70e$var$FADE_IN_DELAY = 500;
const $bcd82f075ee4a70e$var$FADE_OUT_DELAY = 300;
const $bcd82f075ee4a70e$var$RESOLVE_DELAY = 100;
const $bcd82f075ee4a70e$export$e2173dafa6a751bb = ({ children: children, url: url, id: id = '', canOpen: canOpen = true, closeOnChildClick: closeOnChildClick = false, actionOptions: actionOptions, allowEventPropagation: allowEventPropagation = false, zIndex: zIndex = (0, $kj7DC.HOVER_CARD_Z_INDEX), noFadeDelay: noFadeDelay = false, hoverPreviewOptions: hoverPreviewOptions, role: role, label: label, titleId: titleId })=>{
    const fadeInDelay = hoverPreviewOptions?.fadeInDelay ?? $bcd82f075ee4a70e$var$FADE_IN_DELAY;
    const [isOpen, setIsOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState(false);
    const fadeOutTimeoutId = (0, $eJOHy.useRef)();
    const fadeInTimeoutId = (0, $eJOHy.useRef)();
    const resolveTimeOutId = (0, $eJOHy.useRef)();
    const mousePos = (0, $eJOHy.useRef)();
    const popupOffset = (0, $eJOHy.useRef)();
    const parentSpan = (0, $eJOHy.useRef)(null);
    const renderers = (0, $5MmSu.useSmartLinkRenderers)();
    const linkState = (0, $5TXKo.useSmartCardState)(url);
    const { loadMetadata: loadMetadata } = (0, $bde0S.useSmartCardActions)(id, url);
    const setMousePosition = (0, $eJOHy.useCallback)((event)=>{
        if (isOpen && canOpen) return;
        mousePos.current = {
            x: event.clientX,
            y: event.clientY
        };
        //If these are undefined then popupOffset is undefined and we fallback to default bottom-start placement
        if ((!isOpen || !canOpen) && parentSpan.current && mousePos.current) {
            const { bottom: bottom, left: left } = parentSpan.current.getBoundingClientRect();
            popupOffset.current = [
                mousePos.current.x - left + (0, $kj7DC.CARD_GAP_PX),
                mousePos.current.y - bottom + (0, $kj7DC.CARD_GAP_PX)
            ];
        }
    }, [
        canOpen,
        isOpen
    ]);
    const hideCard = (0, $eJOHy.useCallback)(()=>{
        setIsOpen(false);
    }, []);
    const initHideCard = (0, $eJOHy.useCallback)(()=>{
        if (fadeInTimeoutId.current) {
            clearTimeout(fadeInTimeoutId.current);
            // because fadeInTimeoutId.current is set by mouseOver which triggers multiple times in a hover,
            // we want to clear out the reference to signify that there's no in-progress fade in event
            fadeInTimeoutId.current = undefined;
        }
        if (resolveTimeOutId.current) {
            clearTimeout(resolveTimeOutId.current);
            // because resolveTimeOutId.current is set by mouseOver which triggers multiple times in a hover,
            // we want to clear out the reference to signify that there's no in-progress resolve event
            resolveTimeOutId.current = undefined;
        }
        if (noFadeDelay) hideCard();
        else fadeOutTimeoutId.current = setTimeout(()=>hideCard(), $bcd82f075ee4a70e$var$FADE_OUT_DELAY);
    }, [
        hideCard,
        noFadeDelay
    ]);
    // clearing out the timeouts in order to avoid memory leaks
    // in case the component unmounts before they execute
    (0, $eJOHy.useEffect)(()=>{
        return ()=>{
            if (fadeOutTimeoutId.current) clearTimeout(fadeOutTimeoutId.current);
            if (fadeInTimeoutId.current) {
                clearTimeout(fadeInTimeoutId.current);
                // because fadeInTimeoutId.current is set by mouseOver which triggers multiple times in a hover,
                // we want to clear out the reference to signify that there's no in-progress fade in event
                fadeInTimeoutId.current = undefined;
            }
            if (resolveTimeOutId.current) {
                clearTimeout(resolveTimeOutId.current);
                // because resolveTimeOutId.current is set by mouseOver which triggers multiple times in a hover,
                // we want to clear out the reference to signify that there's no in-progress resolve event
                resolveTimeOutId.current = undefined;
            }
        };
    }, []);
    // we want to initiate resolve a bit earlier for standalone cards
    // to minimize the loading state
    const initResolve = (0, $eJOHy.useCallback)(()=>{
        // this check covers both non-SSR (status) & SSR case (metadataStatus)
        const isLinkUnresolved = linkState.status === 'pending' || !linkState.metadataStatus;
        if (!resolveTimeOutId.current && isLinkUnresolved) resolveTimeOutId.current = setTimeout(()=>{
            loadMetadata();
        }, $bcd82f075ee4a70e$var$RESOLVE_DELAY);
    }, [
        linkState.metadataStatus,
        linkState.status,
        loadMetadata
    ]);
    const initShowCard = (0, $eJOHy.useCallback)((event)=>{
        // clearing out fadeOutTimeoutId in case it's already counting down to hide the card
        if (fadeOutTimeoutId.current) clearTimeout(fadeOutTimeoutId.current);
        // starting to resolve the hover card if the store doesn't have data about the link yet
        initResolve();
        //Set mouse position in the case it's not already set by onMouseMove, as in the case of scrolling
        setMousePosition(event);
        if (!isOpen && !fadeInTimeoutId.current) {
            // setting a timeout to show a Hover Card after delay runs out
            if (noFadeDelay) setIsOpen(true);
            else fadeInTimeoutId.current = setTimeout(()=>{
                setIsOpen(true);
            }, fadeInDelay);
        }
    }, [
        initResolve,
        isOpen,
        setMousePosition,
        noFadeDelay,
        fadeInDelay
    ]);
    const onActionClick = (0, $eJOHy.useCallback)((actionId)=>{
        if (actionId === (0, $5NtHI.ActionName).PreviewAction || actionId === (0, $5NtHI.ActionName).AutomationAction) hideCard();
    }, [
        hideCard
    ]);
    // Stop hover preview content to propagate event to parent.
    const handleChildClick = (0, $eJOHy.useCallback)((e, closeOnClick)=>{
        if (!allowEventPropagation) e.stopPropagation();
        if (closeOnClick) hideCard();
    }, [
        allowEventPropagation,
        hideCard
    ]);
    const onContextMenuClick = (0, $eJOHy.useCallback)((e)=>handleChildClick(e, true), [
        handleChildClick
    ]);
    const onChildClick = (0, $eJOHy.useCallback)((e)=>handleChildClick(e, closeOnChildClick), [
        closeOnChildClick,
        handleChildClick
    ]);
    const content = (0, $eJOHy.useCallback)(({ update: update })=>{
        const hoverCardContentProps = {
            onMouseEnter: initShowCard,
            onMouseLeave: initHideCard,
            cardState: linkState,
            onActionClick: onActionClick,
            onResolve: update,
            renderers: renderers,
            actionOptions: actionOptions,
            url: url,
            id: id
        };
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $44bDi.SmartLinkAnalyticsContext), {
            url: url,
            display: (0, $5NtHI.CardDisplay).HoverCardPreview,
            id: id,
            source: $bcd82f075ee4a70e$export$421dbc3834daf261,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $awu5s.default), {
                ...hoverCardContentProps
            })
        });
    }, [
        initShowCard,
        initHideCard,
        linkState,
        onActionClick,
        renderers,
        actionOptions,
        url,
        id
    ]);
    const trigger = (0, $eJOHy.useCallback)(({ 'aria-haspopup': ariaHasPopup, 'aria-expanded': ariaExpanded, ...triggerProps })=>/*#__PURE__*/ (0, $gt9Am.jsx)("span", {
            ref: parentSpan,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                ...triggerProps,
                // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
                onMouseOver: initShowCard,
                onMouseLeave: initHideCard,
                onMouseMove: setMousePosition,
                onClick: onChildClick,
                onContextMenu: onContextMenuClick,
                "data-testid": "hover-card-trigger-wrapper",
                ...(0, $eGOwo.fg)('fix_a11y_violation_in_hover_card_trigger') ? {
                    role: 'button'
                } : {},
                children: children
            })
        }), [
        children,
        initHideCard,
        initShowCard,
        onChildClick,
        onContextMenuClick,
        setMousePosition
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kJsb4.default), {
        testId: "hover-card",
        isOpen: isOpen && canOpen,
        onClose: hideCard,
        placement: "bottom-start",
        offset: popupOffset.current,
        autoFocus: false,
        content: content,
        trigger: trigger,
        zIndex: zIndex,
        role: role,
        titleId: titleId,
        label: label,
        // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
        popupComponent: (0, $dNwAf.default)
    });
};

});
parcelRegister("dNwAf", function(module, exports) {

$parcel$export(module.exports, "default", () => $540bc4e78d228f2e$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
/**
 * The purpose of this component is to hide the default Popup border.
 * HoverCard border implementation is in ContentContainer where it can
 * change between the default border and prism border during runtime.
 */ const $540bc4e78d228f2e$var$CustomPopupContainer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef(({ children: children, shouldFitContainer: _, shouldRenderToParent: __, ...props }, ref)=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ...props,
        ref: ref,
        children: children
    }));
var $540bc4e78d228f2e$export$2e2bcd8739ae039 = $540bc4e78d228f2e$var$CustomPopupContainer;

});

parcelRegister("awu5s", function(module, exports) {

$parcel$export(module.exports, "hoverCardClassName", () => $28757f6aaca5ab4f$export$34883cbaea18402d);
$parcel$export(module.exports, "default", () => $28757f6aaca5ab4f$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $9kfy2 = parcelRequire("9kfy2");

var $eGOwo = parcelRequire("eGOwo");

var $bmWcp = parcelRequire("bmWcp");

var $5NtHI = parcelRequire("5NtHI");

var $03JM4 = parcelRequire("03JM4");

var $5TXKo = parcelRequire("5TXKo");

var $FoFt2 = parcelRequire("FoFt2");

var $7tQSx = parcelRequire("7tQSx");

var $liquj = parcelRequire("liquj");

var $kj7DC = parcelRequire("kj7DC");

var $gpl3i = parcelRequire("gpl3i");

var $2bxQs = parcelRequire("2bxQs");

var $8Oxy9 = parcelRequire("8Oxy9");

var $hG20o = parcelRequire("hG20o");

var $1klMO = parcelRequire("1klMO");

var $jwqmr = parcelRequire("jwqmr");
const $28757f6aaca5ab4f$export$34883cbaea18402d = 'smart-links-hover-preview';
const $28757f6aaca5ab4f$var$HoverCardContent = ({ id: id = '', cardState: cardState, onActionClick: onActionClick, onResolve: onResolve, renderers: renderers, url: url, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, actionOptions: actionOptions })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const extensionKey = (0, $eJOHy.useMemo)(()=>(0, $03JM4.getExtensionKey)(cardState.details), [
        cardState.details
    ]);
    const linkState = (0, $5TXKo.useSmartCardState)(url);
    const linkStatus = linkState.status ?? 'pending';
    const definitionId = (0, $eJOHy.useMemo)(()=>(0, $03JM4.getDefinitionId)(cardState.details), [
        cardState.details
    ]);
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $9kfy2.useSmartLinkContext)();
    const isAISummaryEnabled = (0, $7tQSx.getIsAISummaryEnabled)(isAdminHubAIEnabled, cardState.details);
    const services = (0, $03JM4.getServices)(linkState.details);
    const statusRef = (0, $eJOHy.useRef)(linkStatus);
    const fireEventRef = (0, $eJOHy.useRef)(fireEvent);
    const definitionIdRef = (0, $eJOHy.useRef)(definitionId);
    (0, $eJOHy.useEffect)(()=>{
        /**
		 * Must access object value via ref because its not stable
		 * and it can trigger useEffect to re-run below
		 */ if (statusRef.current !== linkStatus) statusRef.current = linkStatus;
        if (fireEventRef.current !== fireEvent) fireEventRef.current = fireEvent;
        if (definitionIdRef.current !== definitionId) definitionIdRef.current = definitionId;
    }, [
        linkStatus,
        fireEvent,
        definitionId
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const previewDisplay = 'card';
        const previewInvokeMethod = 'mouse_hover';
        const cardOpenTime = Date.now();
        const fireEventCurrent = fireEventRef.current;
        fireEventCurrent('ui.hoverCard.viewed', {
            previewDisplay: previewDisplay,
            previewInvokeMethod: previewInvokeMethod,
            definitionId: definitionIdRef.current ?? null
        });
        return ()=>{
            const hoverTime = Date.now() - cardOpenTime;
            fireEventCurrent('ui.hoverCard.dismissed', {
                previewDisplay: previewDisplay,
                previewInvokeMethod: previewInvokeMethod,
                hoverTime: hoverTime,
                definitionId: definitionIdRef.current ?? null
            });
        };
    }, []);
    const onClick = (0, $eJOHy.useCallback)((event)=>{
        const isModifierKeyPressed = (0, $FoFt2.isSpecialEvent)(event);
        fireEvent('ui.smartLink.clicked.titleGoToLink', {
            id: id,
            display: (0, $5NtHI.CardDisplay).HoverCardPreview,
            isModifierKeyPressed: isModifierKeyPressed,
            definitionId: definitionId ?? null
        });
        (0, $liquj.fireLinkClickedEvent)(createAnalyticsEvent)(event);
    }, [
        createAnalyticsEvent,
        id,
        fireEvent,
        definitionId
    ]);
    const data = cardState.details?.data;
    const { subtitle: subtitle } = (0, $gpl3i.getMetadata)(extensionKey, data);
    const titleMaxLines = subtitle && subtitle.length > 0 ? 1 : 2;
    const titleBlockProps = {
        maxLines: titleMaxLines,
        size: (0, $5NtHI.SmartLinkSize).Large,
        position: (0, $5NtHI.SmartLinkPosition).Center,
        subtitle: subtitle
    };
    const uiOptions = (0, $kj7DC.flexibleUiOptions);
    if ((0, $eGOwo.fg)('cc-ai-linking-platform-snippet-renderer')) uiOptions.enableSnippetRenderer = true;
    const flexibleCardProps = {
        appearance: (0, $5NtHI.CardDisplay).HoverCardPreview,
        cardState: cardState,
        onClick: onClick,
        onResolve: onResolve,
        origin: 'smartLinkPreviewHoverCard',
        renderers: renderers,
        actionOptions: actionOptions,
        ui: uiOptions,
        url: url,
        children: null
    };
    const onClickStopPropagation = (0, $eJOHy.useCallback)((e)=>e.stopPropagation(), []);
    const getCardView = (cardState)=>{
        if (cardState.metadataStatus === 'pending') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1klMO.default), {
            flexibleCardProps: flexibleCardProps,
            titleBlockProps: titleBlockProps
        });
        if (cardState.status === 'unauthorized' && services?.length) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jwqmr.default), {
            extensionKey: extensionKey,
            id: id,
            flexibleCardProps: flexibleCardProps,
            url: url
        });
        if (cardState.status === 'forbidden' || cardState.status === 'not_found') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8Oxy9.default), {
            flexibleCardProps: flexibleCardProps
        });
        if (cardState.status === 'resolved') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hG20o.default), {
            cardState: cardState,
            extensionKey: extensionKey,
            flexibleCardProps: flexibleCardProps,
            isAISummaryEnabled: isAISummaryEnabled,
            onActionClick: onActionClick,
            titleBlockProps: titleBlockProps,
            url: url
        });
        return null;
    };
    const cardView = getCardView(cardState);
    return cardView ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2bxQs.default), {
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onClick: onClickStopPropagation,
        isAIEnabled: isAISummaryEnabled,
        url: url,
        children: cardView
    }) : null;
};
var $28757f6aaca5ab4f$export$2e2bcd8739ae039 = $28757f6aaca5ab4f$var$HoverCardContent;

});
parcelRegister("kj7DC", function(module, exports) {

$parcel$export(module.exports, "HOVER_CARD_Z_INDEX", () => $0426ea3ec103c831$export$8245b0eaabf3440c);
$parcel$export(module.exports, "flexibleUiOptions", () => $0426ea3ec103c831$export$8e022b7269e8199a);
$parcel$export(module.exports, "CARD_WIDTH_REM", () => $0426ea3ec103c831$export$a0a37c997fbcd678);
$parcel$export(module.exports, "CARD_GAP_PX", () => $0426ea3ec103c831$export$e7cae8c75d768024);

var $IW7jS = parcelRequire("IW7jS");

var $5NtHI = parcelRequire("5NtHI");
const $0426ea3ec103c831$export$8245b0eaabf3440c = (0, $IW7jS.layers).modal();
const $0426ea3ec103c831$export$8e022b7269e8199a = {
    hideBackground: true,
    hideElevation: true,
    hideLegacyButton: true,
    removeBlockRestriction: true,
    size: (0, $5NtHI.SmartLinkSize).Medium,
    zIndex: $0426ea3ec103c831$export$8245b0eaabf3440c + 1
};
const $0426ea3ec103c831$export$a0a37c997fbcd678 = 24;
const $0426ea3ec103c831$export$e7cae8c75d768024 = 10; // gap between mouse cursor and hover card

});

parcelRegister("gpl3i", function(module, exports) {

$parcel$export(module.exports, "getMetadata", () => $76d8fd2bfb093db5$export$8548546c0aa631e6);

var $dpM2S = parcelRequire("dpM2S");

var $5NtHI = parcelRequire("5NtHI");

var $1UXt3 = parcelRequire("1UXt3");
const $76d8fd2bfb093db5$var$getSimulatedBetterMetadata = (extensionKey, data)=>{
    const types = data ? (0, $dpM2S.extractType)(data) : undefined;
    const defaultMetadata = {
        primary: [
            (0, $5NtHI.ElementName).AuthorGroup,
            (0, $5NtHI.ElementName).ModifiedOn
        ]
    };
    switch(extensionKey){
        case 'bitbucket-object-provider':
        case 'native-bitbucket-object-provider':
            if (types?.includes('atlassian:SourceCodePullRequest')) return {
                primary: [
                    (0, $5NtHI.ElementName).AuthorGroup,
                    (0, $5NtHI.ElementName).ModifiedOn,
                    (0, $5NtHI.ElementName).SubscriberCount,
                    (0, $5NtHI.ElementName).State
                ],
                subtitle: [
                    (0, $5NtHI.ElementName).SourceBranch,
                    (0, $5NtHI.ElementName).TargetBranch
                ]
            };
            if (types?.includes('schema:DigitalDocument')) return {
                primary: [
                    (0, $5NtHI.ElementName).LatestCommit,
                    (0, $5NtHI.ElementName).CollaboratorGroup,
                    (0, $5NtHI.ElementName).ModifiedOn
                ]
            };
            return {
                primary: [
                    (0, $5NtHI.ElementName).AuthorGroup,
                    (0, $5NtHI.ElementName).ModifiedOn
                ]
            };
        case 'confluence-object-provider':
            const primaryAttribution = data && (0, $1UXt3.extractOwnedBy)(data) ? (0, $5NtHI.ElementName).OwnedByGroup : (0, $5NtHI.ElementName).AuthorGroup;
            return {
                primary: [
                    primaryAttribution,
                    (0, $5NtHI.ElementName).ModifiedOn
                ],
                tertiary: [
                    (0, $5NtHI.ElementName).ReactCount,
                    (0, $5NtHI.ElementName).CommentCount,
                    (0, $5NtHI.ElementName).ViewCount
                ]
            };
        case 'jira-object-provider':
            const isJiraTask = data?.['@type']?.includes('atlassian:Task') ?? false;
            return {
                ...defaultMetadata,
                ...isJiraTask && {
                    primary: [
                        (0, $5NtHI.ElementName).AssignedToGroup,
                        (0, $5NtHI.ElementName).State,
                        (0, $5NtHI.ElementName).StoryPoints,
                        (0, $5NtHI.ElementName).Priority
                    ]
                }
            };
        case 'trello-object-provider':
            return {
                primary: [
                    (0, $5NtHI.ElementName).CollaboratorGroup,
                    (0, $5NtHI.ElementName).State,
                    (0, $5NtHI.ElementName).DueOn
                ],
                secondary: [
                    (0, $5NtHI.ElementName).ReactCount,
                    (0, $5NtHI.ElementName).CommentCount,
                    (0, $5NtHI.ElementName).AttachmentCount,
                    (0, $5NtHI.ElementName).ChecklistProgress
                ],
                subtitle: [
                    (0, $5NtHI.ElementName).Location
                ]
            };
        case 'watermelon-object-provider':
            if (types?.includes('atlassian:Project')) return {
                primary: [
                    (0, $5NtHI.ElementName).AuthorGroup,
                    (0, $5NtHI.ElementName).ModifiedOn,
                    (0, $5NtHI.ElementName).State,
                    (0, $5NtHI.ElementName).DueOn
                ]
            };
            return {
                primary: [
                    (0, $5NtHI.ElementName).AuthorGroup,
                    (0, $5NtHI.ElementName).State,
                    (0, $5NtHI.ElementName).DueOn
                ]
            };
        case 'slack-object-provider':
            return {
                primary: [
                    (0, $5NtHI.ElementName).AuthorGroup,
                    (0, $5NtHI.ElementName).SentOn
                ],
                tertiary: [
                    (0, $5NtHI.ElementName).ReactCount,
                    (0, $5NtHI.ElementName).CommentCount
                ]
            };
        case 'google-object-provider':
        case 'figma-object-provider':
            return {
                primary: [
                    (0, $5NtHI.ElementName).AuthorGroup,
                    (0, $5NtHI.ElementName).ModifiedOn
                ]
            };
        default:
            return defaultMetadata;
    }
};
const $76d8fd2bfb093db5$var$AvatarGroupsWithNamePrefix = [
    (0, $5NtHI.ElementName).AssignedToGroup,
    (0, $5NtHI.ElementName).OwnedByGroup,
    (0, $5NtHI.ElementName).AuthorGroup
];
const $76d8fd2bfb093db5$var$toElementItem = (name)=>{
    const showNamePrefix = $76d8fd2bfb093db5$var$AvatarGroupsWithNamePrefix.indexOf(name) !== -1 ? true : undefined;
    const testId = `${name.toLowerCase()}-metadata-element`;
    return {
        name: name,
        showNamePrefix: showNamePrefix,
        testId: testId
    };
};
const $76d8fd2bfb093db5$var$toElementItems = (elementNames)=>{
    if (!elementNames?.length) return;
    return elementNames.filter((name)=>name in (0, $5NtHI.ElementName)).map($76d8fd2bfb093db5$var$toElementItem);
};
const $76d8fd2bfb093db5$export$8548546c0aa631e6 = (extensionKey, data)=>{
    const metadata = $76d8fd2bfb093db5$var$getSimulatedBetterMetadata(extensionKey, data);
    const primary = [].concat(metadata.primary, metadata.tertiary);
    return {
        subtitle: $76d8fd2bfb093db5$var$toElementItems(metadata.subtitle),
        primary: $76d8fd2bfb093db5$var$toElementItems(primary),
        secondary: $76d8fd2bfb093db5$var$toElementItems(metadata.secondary)
    };
};

});
parcelRegister("1UXt3", function(module, exports) {

$parcel$export(module.exports, "extractCommentCount", () => $72576417d80bd61c$export$b68822b76d5d51d5);
$parcel$export(module.exports, "extractAppliedToComponentsCount", () => $72576417d80bd61c$export$4356c594f5c138d6);
$parcel$export(module.exports, "extractDueOn", () => $72576417d80bd61c$export$ac56bd7a37249b48);
$parcel$export(module.exports, "extractViewCount", () => $72576417d80bd61c$export$e57334ce4738e29d);
$parcel$export(module.exports, "extractReactCount", () => $72576417d80bd61c$export$44130aa92252501);
$parcel$export(module.exports, "extractVoteCount", () => $72576417d80bd61c$export$c8bef3d5e550a3a);
$parcel$export(module.exports, "extractOwnedBy", () => $72576417d80bd61c$export$75b4b5a156f48ff3);
$parcel$export(module.exports, "extractAssignedTo", () => $72576417d80bd61c$export$5546969a505305);
$parcel$export(module.exports, "extractPersonAssignedToAsArray", () => $72576417d80bd61c$export$edb8a7a44b91274e);
$parcel$export(module.exports, "extractProgrammingLanguage", () => $72576417d80bd61c$export$43e54589935a1ff);
$parcel$export(module.exports, "extractSourceBranch", () => $72576417d80bd61c$export$949ac6a8325b3fdb);
$parcel$export(module.exports, "extractSubscriberCount", () => $72576417d80bd61c$export$8bd03a7beb5badf1);
$parcel$export(module.exports, "extractTeamMemberCount", () => $72576417d80bd61c$export$9fc8706c6cb5343a);
$parcel$export(module.exports, "extractAttachmentCount", () => $72576417d80bd61c$export$65362ff78a97fd8);
$parcel$export(module.exports, "extractTargetBranch", () => $72576417d80bd61c$export$29b0ac5d2f9890cf);
$parcel$export(module.exports, "extractChecklistProgress", () => $72576417d80bd61c$export$dd980f9881b65d9c);
$parcel$export(module.exports, "extractLocation", () => $72576417d80bd61c$export$9df94c77b0746c3c);
$parcel$export(module.exports, "extractSubTasksProgress", () => $72576417d80bd61c$export$744e3a2674114c1d);
$parcel$export(module.exports, "extractUserAttributes", () => $72576417d80bd61c$export$6052f26bb463e370);
$parcel$export(module.exports, "extractReadTime", () => $72576417d80bd61c$export$cc4028b2878d0675);
$parcel$export(module.exports, "extractSentOn", () => $72576417d80bd61c$export$b592ddecae70b61d);
$parcel$export(module.exports, "extractStoryPoints", () => $72576417d80bd61c$export$bdcea84d1550eb9d);
$parcel$export(module.exports, "extractMetaObjectId", () => $72576417d80bd61c$export$bec1443e3e33b166);
$parcel$export(module.exports, "extractMetaResourceType", () => $72576417d80bd61c$export$11d1314ebbee594e);
$parcel$export(module.exports, "extractMetaTenantId", () => $72576417d80bd61c$export$92037aea7f27bf7f);

var $fGP6b = parcelRequire("fGP6b");
var $aHgka = parcelRequire("aHgka");
var $3a3fF = parcelRequire("3a3fF");
var $hdxEk = parcelRequire("hdxEk");
const $72576417d80bd61c$var$extractLinkName = (link)=>{
    if (link && typeof link === 'object' && link['@type'] === 'Link') return link.name;
};
const $72576417d80bd61c$var$extractValue = (data, key)=>{
    return data?.[key];
};
const $72576417d80bd61c$export$b68822b76d5d51d5 = (data)=>$72576417d80bd61c$var$extractValue(data, 'schema:commentCount');
const $72576417d80bd61c$export$4356c594f5c138d6 = (data)=>$72576417d80bd61c$var$extractValue(data, 'atlassian:appliedToComponentsCount');
const $72576417d80bd61c$export$ac56bd7a37249b48 = (data)=>$72576417d80bd61c$var$extractValue(data, 'endTime');
const $72576417d80bd61c$export$e57334ce4738e29d = (data)=>$72576417d80bd61c$var$extractValue(data, 'atlassian:viewCount');
const $72576417d80bd61c$export$44130aa92252501 = (data)=>$72576417d80bd61c$var$extractValue(data, 'atlassian:reactCount');
const $72576417d80bd61c$export$c8bef3d5e550a3a = (data)=>$72576417d80bd61c$var$extractValue(data, 'atlassian:voteCount');
const $72576417d80bd61c$export$75b4b5a156f48ff3 = (data)=>{
    const persons = (0, $3a3fF.extractPersonOwnedBy)(data);
    if (persons && persons.length) return persons[0].name;
};
const $72576417d80bd61c$export$5546969a505305 = (data)=>{
    const person = (0, $fGP6b.extractPersonAssignedTo)(data);
    if (person) return person.name;
};
const $72576417d80bd61c$export$edb8a7a44b91274e = (data)=>{
    const person = (0, $fGP6b.extractPersonAssignedTo)(data);
    return person ? [
        person
    ] : undefined;
};
const $72576417d80bd61c$export$69b10d653f96288b = (data)=>{
    const persons = (0, $aHgka.extractPersonCreatedBy)(data);
    if (persons && persons.length) return persons[0].name;
};
const $72576417d80bd61c$export$bcb193c84c865ec9 = (data)=>{
    const person = (0, $hdxEk.extractPersonUpdatedBy)(data);
    if (person) return person.name;
};
const $72576417d80bd61c$export$43e54589935a1ff = (data)=>$72576417d80bd61c$var$extractValue(data, 'schema:programmingLanguage');
const $72576417d80bd61c$export$949ac6a8325b3fdb = (data)=>$72576417d80bd61c$var$extractLinkName(data['atlassian:mergeSource']);
const $72576417d80bd61c$export$8bd03a7beb5badf1 = (data)=>$72576417d80bd61c$var$extractValue(data, 'atlassian:subscriberCount');
const $72576417d80bd61c$export$9fc8706c6cb5343a = (data)=>{
    const val = data?.attributedTo ? Array.isArray(data?.attributedTo) ? data?.attributedTo.length : 0 : 0;
    return val;
};
const $72576417d80bd61c$export$65362ff78a97fd8 = (data)=>$72576417d80bd61c$var$extractValue(data, 'atlassian:attachmentCount');
const $72576417d80bd61c$export$29b0ac5d2f9890cf = (data)=>$72576417d80bd61c$var$extractLinkName(data['atlassian:mergeDestination']);
const $72576417d80bd61c$export$dd980f9881b65d9c = (data)=>{
    const checkItemsObj = $72576417d80bd61c$var$extractValue(data, 'atlassian:checkItems');
    return checkItemsObj ? `${checkItemsObj.checkedItems}/${checkItemsObj.totalItems}` : undefined;
};
const $72576417d80bd61c$export$9df94c77b0746c3c = (data)=>{
    const { url: url, name: name } = $72576417d80bd61c$var$extractValue(data, 'location') || {};
    if (url && name && typeof url === 'string') return {
        text: name,
        url: url
    };
};
const $72576417d80bd61c$export$744e3a2674114c1d = (data)=>{
    const subTasksObject = $72576417d80bd61c$var$extractValue(data, 'atlassian:subTasks');
    return subTasksObject && subTasksObject.totalCount ? `${subTasksObject.resolvedCount}/${subTasksObject.totalCount}` : undefined;
};
const $72576417d80bd61c$export$6052f26bb463e370 = (data)=>{
    return data?.userAttributes;
};
const $72576417d80bd61c$export$cc4028b2878d0675 = (data)=>{
    return $72576417d80bd61c$var$extractValue(data, 'atlassian:readTimeInMinutes');
};
const $72576417d80bd61c$export$b592ddecae70b61d = (data)=>{
    return $72576417d80bd61c$var$extractValue(data, 'dateSent');
};
const $72576417d80bd61c$export$bdcea84d1550eb9d = (data)=>{
    return $72576417d80bd61c$var$extractValue(data, 'atlassian:storyPoints');
};
const $72576417d80bd61c$export$bec1443e3e33b166 = (meta)=>meta.objectId;
const $72576417d80bd61c$export$11d1314ebbee594e = (meta)=>meta.resourceType;
const $72576417d80bd61c$export$92037aea7f27bf7f = (meta)=>meta.tenantId;

});
parcelRegister("fGP6b", function(module, exports) {

$parcel$export(module.exports, "extractPersonAssignedTo", () => $5046cec7bbb70f2b$export$38a0979ebf273662);

var $9JeZK = parcelRequire("9JeZK");
const $5046cec7bbb70f2b$export$38a0979ebf273662 = (jsonLd)=>{
    const assignedTo = jsonLd['atlassian:assignedTo'];
    if (assignedTo) return (0, $9JeZK.extractPersonFromJsonLd)(assignedTo);
};

});

parcelRegister("3a3fF", function(module, exports) {

$parcel$export(module.exports, "extractPersonOwnedBy", () => $acd7880777d9e468$export$19ee667f3f7a6ec3);

var $9JeZK = parcelRequire("9JeZK");
const $acd7880777d9e468$export$19ee667f3f7a6ec3 = (jsonLd)=>{
    const ownedBy = jsonLd['atlassian:ownedBy'];
    if (ownedBy) {
        if (Array.isArray(ownedBy)) return ownedBy.map((0, $9JeZK.extractPersonFromJsonLd)).filter((item)=>!!item);
        else {
            const item = (0, $9JeZK.extractPersonFromJsonLd)(ownedBy);
            if (item) return [
                item
            ];
        }
    }
};

});



parcelRegister("2bxQs", function(module, exports) {

$parcel$export(module.exports, "default", () => $cef1c4bd3f25f5fc$export$2e2bcd8739ae039);
/* ContentContainer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $gRw8I = parcelRequire("gRw8I");

var $2LycE = parcelRequire("2LycE");

var $gEJiH = parcelRequire("gEJiH");

var $awu5s = parcelRequire("awu5s");
const $cef1c4bd3f25f5fc$var$NEW_CARD_WIDTH_REM = 25;
const $cef1c4bd3f25f5fc$var$HoverCardContainerStyle = null;
const $cef1c4bd3f25f5fc$var$popupContainerStyles = null;
const $cef1c4bd3f25f5fc$var$ConnectedAIPrismContainer = ({ children: children, isAIEnabled: isAIEnabled = false, testId: testId, url: url, ...props })=>{
    (0, $gRw8I.di)((0, $2LycE.default), (0, $gEJiH.default));
    const { state: { status: status } } = (0, $2LycE.default)(url);
    const [showPrism, setShowPrism] = (0, $eJOHy.useState)(status === 'loading');
    (0, $eJOHy.useEffect)(()=>{
        setShowPrism(status === 'loading');
    }, [
        status
    ]);
    const container = /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            "_11q7glyw _189eidpf _vchhusvi _1bsb1f23 _9spsglyw",
            !isAIEnabled && "_2rkopd34 _bfhk1bhr _16qs1e6u",
            (0, $awu5s.hoverCardClassName)
        ]),
        "data-testid": testId,
        ...props,
        children: children
    });
    return isAIEnabled ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gEJiH.default), {
        isVisible: showPrism,
        testId: `${testId}-prism`,
        children: container
    }) : container;
};
const $cef1c4bd3f25f5fc$var$ContentContainer = ({ children: children, isAIEnabled: isAIEnabled = false, testId: testId, url: url, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)($cef1c4bd3f25f5fc$var$ConnectedAIPrismContainer, {
        isAIEnabled: isAIEnabled,
        url: url,
        testId: testId,
        ...props,
        children: children
    });
var $cef1c4bd3f25f5fc$export$2e2bcd8739ae039 = $cef1c4bd3f25f5fc$var$ContentContainer;

});
parcelRegister("gEJiH", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ac4bb0b0e3771c8$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $58yRG = parcelRequire("58yRG");

var $ic0QK = parcelRequire("ic0QK");

var $aIqUw = parcelRequire("aIqUw");
const $6ac4bb0b0e3771c8$var$contentStyles = null;
const $6ac4bb0b0e3771c8$var$contentStylesPrismVisible = null;
const $6ac4bb0b0e3771c8$var$animatedSvgContainerStyles = {
    true: "_v564fs5d _tzy4kb7n",
    false: "_v564fs5d _tzy4idpf"
};
const $6ac4bb0b0e3771c8$var$popupContainerStyles = null;
const $6ac4bb0b0e3771c8$var$AIPrism = ({ children: children, isGlowing: isGlowing = true, isMoving: isMoving = true, isVisible: isVisible, testId: testId })=>{
    const { colorMode: colorMode = 'light' } = (0, $58yRG.default)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ic0QK.default), {
        palette: (0, $aIqUw.AI_BORDER_PALETTE)[colorMode] ?? (0, $aIqUw.AI_BORDER_PALETTE).light,
        isGlowing: isGlowing,
        isMoving: isMoving,
        testId: testId,
        className: (0, $hcewu.default)([
            $6ac4bb0b0e3771c8$var$animatedSvgContainerStyles[isVisible ? 'true' : 'false']
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            className: (0, $hcewu.default)([
                "_2rkopd34 _bfhk1bhr _16qs1e6u",
                "_v5649spz",
                isVisible && "_16qs1sqb"
            ]),
            children: children
        })
    });
};
var $6ac4bb0b0e3771c8$export$2e2bcd8739ae039 = $6ac4bb0b0e3771c8$var$AIPrism;

});
parcelRegister("ic0QK", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c556e491b590659$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $4gixb = parcelRequire("4gixb");
const $1c556e491b590659$var$borderContainerStyles = null;
const $1c556e491b590659$var$borderContentStyles = null;
/**
 * The bulk of this file is originally from
 * https://bitbucket.org/atlassian/barrel/src/master/ui/platform/ui-kit/ai
 * with modifications.
 */ const $1c556e491b590659$var$AIGlowingBorder = ({ children: children, palette: palette, isMoving: isMoving = true, isGlowing: isGlowing, testId: testId, className: className })=>/*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        "data-testid": testId,
        className: (0, $hcewu.default)([
            "_1e0c1txw _kqswh2mm _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o _1bsb1ns9"
        ]),
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4gixb.default), {
                palette: palette,
                isMoving: isMoving,
                className: className
            }),
            isGlowing && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4gixb.default), {
                palette: palette,
                isMoving: isMoving,
                isGlowing: true,
                className: className
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
                className: (0, $hcewu.default)([
                    "_2rkoftgi _16jlkb7n _1pbykb7n"
                ]),
                children: [
                    children,
                    " "
                ]
            })
        ]
    });
var $1c556e491b590659$export$2e2bcd8739ae039 = $1c556e491b590659$var$AIGlowingBorder;

});
parcelRegister("4gixb", function(module, exports) {

$parcel$export(module.exports, "default", () => $915978962937a033$export$2e2bcd8739ae039);
/* animated-svg-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
let $915978962937a033$var$namespaceUUID = 0;
const $915978962937a033$var$svgStyles = null;
const $915978962937a033$var$blurredStyles = null;
const $915978962937a033$var$notBlurredStyles = null;
/**
 * The bulk of this file is originally from
 * https://bitbucket.org/atlassian/barrel/src/master/ui/platform/ui-kit/ai
 * with modifications.
 */ const $915978962937a033$var$AnimatedSvgContainer = ({ palette: palette, isMoving: isMoving, isGlowing: isGlowing, className: className })=>{
    const svgRef = (0, $eJOHy.useRef)(null);
    const namespaceId = (0, $eJOHy.useRef)();
    if (namespaceId.current === undefined) {
        namespaceId.current = $915978962937a033$var$namespaceUUID;
        $915978962937a033$var$namespaceUUID += 1;
    }
    (0, $eJOHy.useEffect)(()=>{
        if (isMoving) {
            const svg = svgRef.current;
            // Schedule animation to begin before next browser paint
            const beginReq = requestAnimationFrame(()=>{
                svg?.querySelectorAll('animate').forEach((node)=>node.beginElement());
            });
            return ()=>{
                // Ensure any pending animation frame is cancelled as the element animation does not end properly if it
                // begins in the same event tick, i.e. isLoading synchronously changes to true then false.
                cancelAnimationFrame(beginReq);
                requestAnimationFrame(()=>{
                    svg?.querySelectorAll('animate').forEach((node)=>node.endElement());
                });
            };
        }
        return undefined;
    }, [
        isMoving
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_2rko19bv _kqswstnw",
            isGlowing ? "_1bsb1wgc _4t3i1wgc _154i1b66 _1ltv1b66 _kdam1rfl _w6ng15vq _t9ec161g" : "_1ltvidpf _154iidpf _1bsb1osq _4t3i1osq",
            className
        ]),
        ref: svgRef,
        viewBox: "0 0 24 24",
        preserveAspectRatio: "none",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: `${namespaceId.current}_lg1`,
                        gradientUnits: "userSpaceOnUse",
                        x1: "0%",
                        y1: "0",
                        x2: "400%",
                        y2: "0",
                        spreadMethod: "reflect",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "x1",
                                from: "0%",
                                to: "400%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "x2",
                                from: "400%",
                                to: "800%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: palette.blue
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.25",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5",
                                stopColor: palette.yellow
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.75",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: palette.blue
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: `${namespaceId.current}_lg2`,
                        gradientUnits: "userSpaceOnUse",
                        x1: "0",
                        y1: "-100%",
                        x2: "0",
                        y2: "300%",
                        spreadMethod: "reflect",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "y1",
                                from: "-100%",
                                to: "300%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "y2",
                                from: "300%",
                                to: "700%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: palette.blue
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.25",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5",
                                stopColor: palette.yellow
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.75",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: palette.blue
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: `${namespaceId.current}_lg3`,
                        gradientUnits: "userSpaceOnUse",
                        x1: "300%",
                        y1: "0",
                        x2: "700%",
                        y2: "0",
                        spreadMethod: "reflect",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "x1",
                                from: "300%",
                                to: "-100%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "x2",
                                from: "700%",
                                to: "300%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: palette.blue
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.25",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5",
                                stopColor: palette.yellow
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.75",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: palette.blue
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: `${namespaceId.current}_lg4`,
                        gradientUnits: "userSpaceOnUse",
                        x1: "0",
                        y1: "0",
                        x2: "0",
                        y2: "400%",
                        spreadMethod: "reflect",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "y1",
                                from: "0%",
                                to: "-400%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "y2",
                                from: "400%",
                                to: "0%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: palette.blue
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.25",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5",
                                stopColor: palette.yellow
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.75",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: palette.blue
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)("g", {
                strokeWidth: "8",
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        stroke: `url(#${namespaceId.current}_lg1)`,
                        d: "M0 0h24",
                        vectorEffect: "non-scaling-stroke"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        stroke: `url(#${namespaceId.current}_lg2)`,
                        d: "M24 0v24",
                        vectorEffect: "non-scaling-stroke"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        stroke: `url(#${namespaceId.current}_lg3)`,
                        d: "M24 24H0",
                        vectorEffect: "non-scaling-stroke"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        stroke: `url(#${namespaceId.current}_lg4)`,
                        d: "M0 24V0",
                        vectorEffect: "non-scaling-stroke"
                    })
                ]
            })
        ]
    });
};
var $915978962937a033$export$2e2bcd8739ae039 = $915978962937a033$var$AnimatedSvgContainer;

});


parcelRegister("aIqUw", function(module, exports) {

$parcel$export(module.exports, "AI_BORDER_PALETTE", () => $668726bbe5390a04$export$23b7b83c7063ccfe);
const $668726bbe5390a04$export$3088ed82e2905d1e = {
    blueUniqueGradientLight: '#00ACF8',
    blueUniqueGradientDark: '#008BD2',
    blue1000: '#092957',
    blue800: '#0055CC',
    blue700: '#0C66E4',
    blue600: '#1D7AFC',
    blue500: '#388BFF',
    blue300: '#85B8FF',
    blue200: '#CCE0FF',
    blue100: '#E9F2FF',
    teal500: '#37B4C3',
    teal300: '#8BDBE5',
    yellow500: '#CF9F02',
    yellow200: '#F8E6A0',
    red800: '#AE2A19',
    red600: '#E34935',
    orange500: '#F18D13',
    orange300: '#FEC57B'
};
const $668726bbe5390a04$export$23b7b83c7063ccfe = {
    dark: {
        blue: $668726bbe5390a04$export$3088ed82e2905d1e.blue800,
        teal: $668726bbe5390a04$export$3088ed82e2905d1e.teal500,
        yellow: $668726bbe5390a04$export$3088ed82e2905d1e.yellow500
    },
    light: {
        blue: $668726bbe5390a04$export$3088ed82e2905d1e.blue600,
        teal: $668726bbe5390a04$export$3088ed82e2905d1e.teal300,
        yellow: $668726bbe5390a04$export$3088ed82e2905d1e.yellow200
    }
};

});



parcelRegister("8Oxy9", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ec0240a00cb7a69$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $kDaaB = parcelRequire("kDaaB");

var $ftN6c = parcelRequire("ftN6c");

var $goZPP = parcelRequire("goZPP");

var $5CSKW = parcelRequire("5CSKW");

var $hy9OT = parcelRequire("hy9OT");

var $eGOwo = parcelRequire("eGOwo");

var $7r0tl = parcelRequire("7r0tl");

var $4Qxcv = parcelRequire("4Qxcv");

var $19nmp = parcelRequire("19nmp");

var $19G04 = parcelRequire("19G04");

var $bIdM1 = parcelRequire("bIdM1");
var $8Rjtc = parcelRequire("8Rjtc");
const $7ec0240a00cb7a69$var$titleBlockStyles = null;
const $7ec0240a00cb7a69$var$mainTextStyles = null;
const $7ec0240a00cb7a69$var$connectButtonStyles = null;
const $7ec0240a00cb7a69$var$basePreviewStyles = null;
const $7ec0240a00cb7a69$var$HoverCardForbiddenView = ({ flexibleCardProps: flexibleCardProps, testId: testId = 'hover-card-forbidden-view' })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { cardState: cardState, url: url } = flexibleCardProps;
    const meta = cardState.details?.meta;
    const product = (0, $hy9OT.extractSmartLinkProvider)(cardState.details)?.text ?? '';
    const hostname = /*#__PURE__*/ (0, $gt9Am.jsx)("b", {
        children: (0, $4Qxcv.default)(url)
    });
    const { action: action, descriptiveMessageKey: descriptiveMessageKey, titleMessageKey: titleMessageKey, buttonDisabled: buttonDisabled } = (0, $7r0tl.extractRequestAccessContextImproved)({
        jsonLd: meta,
        url: url,
        product: product,
        createAnalyticsEvent: createAnalyticsEvent
    }) ?? {};
    if (!titleMessageKey || !descriptiveMessageKey) return null;
    const ButtonComponent = (0, $eGOwo.fg)('platform-smart-card-remove-legacy-button') ? (0, $5CSKW.default) : (0, $goZPP.default);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $19G04.default), {
        ...flexibleCardProps,
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8Rjtc.default), {
                ignoreContainerPadding: true,
                testId: testId,
                className: (0, $hcewu.default)([
                    "_13lipd34 _qrwqpd34 _otyru2gc"
                ])
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bIdM1.default), {
                testId: `${testId}-title`,
                className: (0, $hcewu.default)([
                    "_1bah1h6o _k48p1pd9 _19pku2gc"
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...(0, $19nmp.messages)[titleMessageKey],
                    values: {
                        product: product
                    }
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bIdM1.default), {
                testId: `${testId}-content`,
                className: (0, $hcewu.default)([
                    "_11c8dcr7 _1e0c1nu9 _1bah1h6o _19pkze3t _y3gn1h6o"
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...(0, $19nmp.messages)[descriptiveMessageKey],
                    values: {
                        product: product,
                        hostname: hostname
                    }
                })
            }),
            action && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bIdM1.default), {
                className: (0, $hcewu.default)([
                    "_1bah1h6o _19pku2gc"
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)(ButtonComponent, {
                    testId: `${testId}-button`,
                    onClick: action?.promise,
                    appearance: "primary",
                    isDisabled: buttonDisabled,
                    children: action?.text
                })
            })
        ]
    });
};
var $7ec0240a00cb7a69$export$2e2bcd8739ae039 = $7ec0240a00cb7a69$var$HoverCardForbiddenView;

});
parcelRegister("7r0tl", function(module, exports) {

$parcel$export(module.exports, "extractRequestAccessContextImproved", () => $acbd55282a01ac89$export$846c1540a86749e6);

var $19nmp = parcelRequire("19nmp");

var $b43DQ = parcelRequire("b43DQ");

var $5OkN2 = parcelRequire("5OkN2");

var $4Qxcv = parcelRequire("4Qxcv");
const $acbd55282a01ac89$export$846c1540a86749e6 = ({ jsonLd: jsonLd, url: url, product: product, createAnalyticsEvent: createAnalyticsEvent })=>{
    const requestAccess = jsonLd?.requestAccess ? {
        ...jsonLd?.requestAccess,
        hostname: (0, $4Qxcv.default)(url)
    } : undefined;
    switch(jsonLd?.requestAccess?.accessType){
        case 'DIRECT_ACCESS':
            return {
                ...requestAccess,
                titleMessageKey: 'direct_access_title',
                descriptiveMessageKey: 'direct_access_description',
                callToActionMessageKey: 'direct_access',
                action: (0, $5OkN2.ForbiddenAction)(()=>{
                    if (createAnalyticsEvent !== undefined) createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'crossJoin',
                        eventType: 'ui'
                    }).fire((0, $b43DQ.ANALYTICS_CHANNEL));
                    window.open(url);
                }, 'direct_access', (0, $19nmp.messages).direct_access, {
                    product: product
                })
            };
        case 'REQUEST_ACCESS':
            return {
                ...requestAccess,
                titleMessageKey: 'default_no_access_title',
                descriptiveMessageKey: 'request_access_description',
                callToActionMessageKey: 'request_access',
                action: (0, $5OkN2.ForbiddenAction)(()=>{
                    if (createAnalyticsEvent !== undefined) createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'requestAccess',
                        eventType: 'ui'
                    }).fire((0, $b43DQ.ANALYTICS_CHANNEL));
                    window.open(url);
                }, 'request_access', (0, $19nmp.messages).request_access)
            };
        case 'PENDING_REQUEST_EXISTS':
            return {
                ...requestAccess,
                titleMessageKey: 'request_access_pending_title',
                descriptiveMessageKey: 'request_access_pending_description',
                callToActionMessageKey: 'request_access_pending',
                action: (0, $5OkN2.ForbiddenAction)(()=>window.open(url), 'request_access_pending', (0, $19nmp.messages).request_access_pending),
                buttonDisabled: true
            };
        case 'DENIED_REQUEST_EXISTS':
            return {
                ...requestAccess,
                titleMessageKey: 'forbidden_title',
                descriptiveMessageKey: 'request_denied_description'
            };
        case 'ACCESS_EXISTS':
            if (jsonLd?.visibility === 'not_found') return {
                ...requestAccess,
                titleMessageKey: 'not_found_title',
                descriptiveMessageKey: 'not_found_description'
            };
            return {
                ...requestAccess,
                titleMessageKey: 'forbidden_title',
                descriptiveMessageKey: 'access_exists_description',
                callToActionMessageKey: 'request_access',
                action: (0, $5OkN2.ForbiddenAction)(()=>{
                    if (createAnalyticsEvent !== undefined) createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'requestAccess',
                        eventType: 'ui'
                    }).fire((0, $b43DQ.ANALYTICS_CHANNEL));
                    window.open(url);
                }, 'access_exists', (0, $19nmp.messages).request_access)
            };
        case 'FORBIDDEN':
            return {
                ...requestAccess,
                titleMessageKey: 'forbidden_title',
                descriptiveMessageKey: 'forbidden_description'
            };
        default:
            return requestAccess;
    }
};

});
parcelRegister("5OkN2", function(module, exports) {

$parcel$export(module.exports, "ForbiddenAction", () => $1cf8e394dba29dd6$export$59f8830fb5467e35);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $19nmp = parcelRequire("19nmp");
const $1cf8e394dba29dd6$export$59f8830fb5467e35 = (handler, id = 'connect-other-account', message = (0, $19nmp.messages).try_another_account, values = {})=>({
        id: id,
        text: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...message,
            values: values
        }),
        promise: ()=>new Promise((resolve)=>resolve(handler())),
        buttonAppearance: 'default'
    });

});

parcelRegister("4Qxcv", function(module, exports) {

$parcel$export(module.exports, "default", () => $37283c298b2f6d8f$export$2e2bcd8739ae039);
const $37283c298b2f6d8f$var$extractHostname = (url)=>{
    try {
        return new URL(url).hostname;
    } catch  {
        return url;
    }
};
var $37283c298b2f6d8f$export$2e2bcd8739ae039 = $37283c298b2f6d8f$var$extractHostname;

});



parcelRegister("hG20o", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7d163d2cd5927fd$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $bmWcp = parcelRequire("bmWcp");

var $5NtHI = parcelRequire("5NtHI");

var $1mLfK = parcelRequire("1mLfK");

var $19G04 = parcelRequire("19G04");

var $4cjOx = parcelRequire("4cjOx");
var $eMgzj = parcelRequire("eMgzj");
var $2qnEp = parcelRequire("2qnEp");
var $gKsxm = parcelRequire("gKsxm");
var $5gb8b = parcelRequire("5gb8b");
var $fqBfo = parcelRequire("fqBfo");

var $gpl3i = parcelRequire("gpl3i");

var $33eto = parcelRequire("33eto");
const $f7d163d2cd5927fd$var$hiddenSnippetStyles = null;
const $f7d163d2cd5927fd$var$titleBlockStyles = null;
const $f7d163d2cd5927fd$var$snippetBlockCss = null;
const $f7d163d2cd5927fd$var$actionBlockCss = null;
const $f7d163d2cd5927fd$var$HoverCardResolvedView = ({ cardState: cardState, extensionKey: extensionKey, flexibleCardProps: flexibleCardProps, isAISummaryEnabled: isAISummaryEnabled, onActionClick: onActionClick, titleBlockProps: titleBlockProps, id: id })=>{
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        // Since this hover view is only rendered on resolved status,
        // there is no need to check for statuses.
        (0, $1mLfK.succeedUfoExperience)('smart-link-rendered', id || 'NULL', {
            extensionKey: extensionKey,
            display: (0, $5NtHI.CardDisplay).HoverCardPreview
        });
        // UFO will disregard this if authentication experience has not yet been started
        (0, $1mLfK.succeedUfoExperience)('smart-link-authenticated', id || 'NULL', {
            display: (0, $5NtHI.CardDisplay).HoverCardPreview
        });
        fireEvent('ui.smartLink.renderSuccess', {
            display: (0, $5NtHI.CardDisplay).HoverCardPreview
        });
    }, [
        extensionKey,
        fireEvent,
        id
    ]);
    const data = cardState.details?.data;
    const { primary: primary, secondary: secondary } = (0, $eJOHy.useMemo)(()=>{
        return (0, $gpl3i.getMetadata)(extensionKey, data);
    }, [
        data,
        extensionKey
    ]);
    const snippetHeight = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef(0);
    const snippetBlockRef = (0, $eJOHy.useRef)(null);
    const onSnippetRender = (0, $eJOHy.useCallback)(()=>{
        snippetHeight.current = snippetBlockRef.current?.getBoundingClientRect().height ?? 0;
    }, []);
    const imagePreview = (0, $33eto.default)({
        fallbackElementHeight: snippetHeight.current,
        response: cardState.details
    });
    const snippet = imagePreview ? null : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5gb8b.default), {
        className: (0, $hcewu.default)([
            "_ca0q1b66"
        ])
    });
    const aiSummaryMinHeight = snippet ? snippetHeight.current : 0;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $19G04.default), {
        ...flexibleCardProps,
        children: [
            imagePreview,
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fqBfo.default), {
                ...titleBlockProps,
                metadataPosition: (0, $5NtHI.SmartLinkPosition).Top,
                className: (0, $hcewu.default)([
                    "_zulpu2gc _quenze3t _oebj1txw _13mh1pd9"
                ])
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gKsxm.default), {
                primary: primary,
                secondary: secondary,
                maxLines: 1,
                size: (0, $5NtHI.SmartLinkSize).Medium
            }),
            isAISummaryEnabled ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2qnEp.default), {
                aiSummaryMinHeight: aiSummaryMinHeight,
                placeholder: snippet
            }) : snippet,
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5gb8b.default), {
                testId: "hidden-snippet",
                onRender: onSnippetRender,
                blockRef: snippetBlockRef,
                isHidden: true,
                className: (0, $hcewu.default)([
                    "_3um015vq _kqswstnw"
                ])
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4cjOx.default), {
                onClick: onActionClick,
                spaceInline: "space.100",
                className: (0, $hcewu.default)([
                    "_n3td1b66"
                ])
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eMgzj.default), {})
        ]
    });
};
var $f7d163d2cd5927fd$export$2e2bcd8739ae039 = $f7d163d2cd5927fd$var$HoverCardResolvedView;

});
parcelRegister("33eto", function(module, exports) {

$parcel$export(module.exports, "default", () => $114e5090f71be87e$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $71sLJ = parcelRequire("71sLJ");

var $8Rjtc = parcelRequire("8Rjtc");
const $114e5090f71be87e$var$ImagePreview = ({ fallbackElementHeight: fallbackElementHeight, response: response })=>{
    const transitionStarted = (0, $eJOHy.useRef)(false);
    const previewBlockRef = (0, $eJOHy.useRef)(null);
    const [showPreview, setShowPreview] = (0, $eJOHy.useState)(true);
    const [dynamicStyles, setDynamicStyles] = (0, $eJOHy.useState)({});
    // Set Preview to a fixed height to enable transitions
    const onPreviewRender = (0, $eJOHy.useCallback)(()=>{
        if (previewBlockRef.current) {
            const previewHeight = previewBlockRef.current?.getBoundingClientRect().height;
            setDynamicStyles({
                borderTopLeftRadius: "var(--ds-border-radius-200, 8px)",
                borderTopRightRadius: "var(--ds-border-radius-200, 8px)",
                marginBottom: "var(--ds-space-100, 8px)",
                ...previewHeight ? {
                    height: `${previewHeight}px`
                } : {}
            });
        }
    }, []);
    // On error set Preview to Fallback height with transition
    const onPreviewError = (0, $eJOHy.useCallback)(()=>{
        if (transitionStarted.current === false) {
            setDynamicStyles({
                transition: 'height 300ms ease-in-out',
                height: `${fallbackElementHeight}px`
            });
            transitionStarted.current = true;
        }
    }, [
        fallbackElementHeight
    ]);
    const onPreviewTransitionEnd = (0, $eJOHy.useCallback)(()=>{
        setShowPreview(false);
    }, []);
    return showPreview && (0, $71sLJ.extractSmartLinkPreviewImage)(response) ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8Rjtc.default), {
        onError: onPreviewError,
        ignoreContainerPadding: true,
        onTransitionEnd: onPreviewTransitionEnd,
        blockRef: previewBlockRef,
        onRender: onPreviewRender,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: dynamicStyles
    }) : null;
};
var $114e5090f71be87e$export$2e2bcd8739ae039 = $114e5090f71be87e$var$ImagePreview;

});
parcelRegister("71sLJ", function(module, exports) {

$parcel$export(module.exports, "extractSmartLinkPreviewImage", () => $5db4479b590c898b$export$a79836076066b8b6);

var $3jSKi = parcelRequire("3jSKi");
var $GcYFq = parcelRequire("GcYFq");

var $eGOwo = parcelRequire("eGOwo");

var $5NtHI = parcelRequire("5NtHI");
const $5db4479b590c898b$var$extractPreview = (data)=>{
    if (!data) return undefined;
    const url = (0, $GcYFq.extractImage)(data);
    return url ? {
        type: (0, $5NtHI.MediaType).Image,
        url: url
    } : undefined;
};
var $5db4479b590c898b$export$2e2bcd8739ae039 = $5db4479b590c898b$var$extractPreview;
const $5db4479b590c898b$export$a79836076066b8b6 = (response)=>{
    if (!response || !response?.data) return undefined;
    if ((0, $3jSKi.isEntityPresent)(response)) {
        const entity = (0, $3jSKi.extractEntity)(response);
        let url = entity?.thumbnail?.externalUrl;
        if (!url && !(0, $eGOwo.fg)('smart_links_noun_support')) {
            const provider = (0, $3jSKi.extractEntityProvider)(response);
            url = provider?.image;
        }
        return url ? {
            type: (0, $5NtHI.MediaType).Image,
            url: url
        } : undefined;
    }
    return $5db4479b590c898b$var$extractPreview(response.data);
};

});
parcelRegister("GcYFq", function(module, exports) {

$parcel$export(module.exports, "extractImage", () => $d2101dc0ce9c996b$export$4c753a1297cb9805);

var $jo2Je = parcelRequire("jo2Je");
const $d2101dc0ce9c996b$export$4c753a1297cb9805 = (jsonLd)=>{
    const image = jsonLd.image;
    if (image) {
        if (typeof image === 'string') return image;
        else if (image['@type'] === 'Link') return (0, $jo2Je.extractUrlFromLinkJsonLd)(image);
        else if (image['@type'] === 'Image') {
            if (image.url) return (0, $jo2Je.extractUrlFromLinkJsonLd)(image.url);
        }
    }
};

});




parcelRegister("1klMO", function(module, exports) {

$parcel$export(module.exports, "default", () => $208dcc57b264b5f9$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $bIdM1 = parcelRequire("bIdM1");

var $6P8F3 = parcelRequire("6P8F3");

var $65mpR = parcelRequire("65mpR");

var $d6nZP = parcelRequire("d6nZP");

var $kj7DC = parcelRequire("kj7DC");
const $208dcc57b264b5f9$var$loadingViewContainer = null;
const $208dcc57b264b5f9$var$skeletonContainer = null;
const $208dcc57b264b5f9$var$titleStyle = null;
const $208dcc57b264b5f9$var$titleBlockStyles = null;
const $208dcc57b264b5f9$var$HoverCardLoadingView = ({ titleBlockProps: titleBlockProps })=>{
    const testId = 'hover-card-loading-view';
    const lineHeightRem = 1.25;
    const skeletonWidth = (0, $kj7DC.CARD_WIDTH_REM) - 2;
    const { size: size, actions: actions } = titleBlockProps;
    const actionGroup = actions?.length && actions?.length > 0 && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6P8F3.default), {
        items: actions,
        visibleButtonsNum: 2
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId,
        className: (0, $hcewu.default)([
            "_1e0c1txw _2lx21bp4 _ca0q1e9d _u5f31e9d _n3td1e9d _19bv1e9d"
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
            className: (0, $hcewu.default)([
                "_zulpud5o _1e0c1txw _2lx21bp4 _4cvr1h6o"
            ]),
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bIdM1.default), {
                    ...titleBlockProps,
                    testId: `${testId}-title-block`,
                    className: (0, $hcewu.default)([
                        "_zulpcxkx _1bsb1osq"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $d6nZP.default), {
                            render: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $65mpR.LoadingSkeleton), {}),
                            size: size
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                            "data-testid": `${testId}-title`,
                            className: (0, $hcewu.default)([
                                "_16jlkb7n _1o9zidpf _i0dl1wug _4t3i1k92 _e2oo1osq"
                            ]),
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $65mpR.LoadingSkeleton), {
                                height: `${lineHeightRem}rem`
                            })
                        }),
                        actionGroup
                    ]
                }),
                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $65mpR.LoadingSkeleton), {
                            width: `${skeletonWidth}rem`,
                            height: `${lineHeightRem}rem`
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $65mpR.LoadingSkeleton), {
                            width: `${skeletonWidth}rem`,
                            height: `${lineHeightRem * 3}rem`
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $65mpR.LoadingSkeleton), {
                            width: `${skeletonWidth}rem`,
                            height: `${lineHeightRem}rem`
                        })
                    ]
                })
            ]
        })
    });
};
var $208dcc57b264b5f9$export$2e2bcd8739ae039 = $208dcc57b264b5f9$var$HoverCardLoadingView;

});

parcelRegister("jwqmr", function(module, exports) {

$parcel$export(module.exports, "default", () => $a30e9762e9a1caf4$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $kDaaB = parcelRequire("kDaaB");

var $hy9OT = parcelRequire("hy9OT");

var $bmWcp = parcelRequire("bmWcp");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");

var $bde0S = parcelRequire("bde0S");

var $03JM4 = parcelRequire("03JM4");

var $5z6NJ = parcelRequire("5z6NJ");

var $19G04 = parcelRequire("19G04");

var $bIdM1 = parcelRequire("bIdM1");

var $6P8F3 = parcelRequire("6P8F3");

var $jPfaa = parcelRequire("jPfaa");
const $a30e9762e9a1caf4$var$connectButtonStyles = null;
const $a30e9762e9a1caf4$var$titleBlockStyles = null;
const $a30e9762e9a1caf4$var$mainTextStyles = null;
const $a30e9762e9a1caf4$var$HoverCardUnauthorisedView = ({ id: id = '', flexibleCardProps: flexibleCardProps, testId: testId = 'hover-card-unauthorised-view', url: url })=>{
    const { cardState: cardState } = flexibleCardProps;
    const providerName = (0, $hy9OT.extractSmartLinkProvider)(cardState.details)?.text;
    const isProductIntegrationSupported = (0, $03JM4.hasAuthScopeOverrides)(cardState.details);
    const { authorize: authorize } = (0, $bde0S.useSmartCardActions)(id, url);
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const handleAuthorize = (0, $eJOHy.useCallback)(()=>{
        if (authorize) {
            fireEvent('track.applicationAccount.authStarted', {});
            authorize((0, $5NtHI.CardDisplay).HoverCardPreview);
        }
    }, [
        authorize,
        fireEvent
    ]);
    const actions = (0, $eJOHy.useMemo)(()=>[
            {
                name: (0, $5NtHI.ActionName).CustomAction,
                content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...(0, $19nmp.messages).connect_unauthorised_account_action,
                    values: {
                        context: providerName
                    }
                }),
                onClick: handleAuthorize
            }
        ], [
        handleAuthorize,
        providerName
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $19G04.default), {
        ...flexibleCardProps,
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bIdM1.default), {
                testId: `${testId}-title`,
                className: (0, $hcewu.default)([
                    "_zulpu2gc _13mh1pd9"
                ]),
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jPfaa.default), {}),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                        ...(0, $19nmp.messages).connect_link_account_card_name,
                        values: {
                            context: providerName
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bIdM1.default), {
                testId: `${testId}-content`,
                className: (0, $hcewu.default)([
                    "_11c8dcr7 _19pku2gc"
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5z6NJ.default), {
                        providerName: providerName,
                        isProductIntegrationSupported: isProductIntegrationSupported
                    })
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bIdM1.default), {
                testId: `${testId}-button`,
                className: (0, $hcewu.default)([
                    "_1bahesu3 _19pku2gc"
                ]),
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6P8F3.default), {
                    items: actions,
                    appearance: "primary"
                })
            })
        ]
    });
};
var $a30e9762e9a1caf4$export$2e2bcd8739ae039 = $a30e9762e9a1caf4$var$HoverCardUnauthorisedView;

});
parcelRegister("5z6NJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b17ec2d366022be$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $lc0OY = parcelRequire("lc0OY");

var $bmWcp = parcelRequire("bmWcp");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");
/**
 * This component is used in unauthorized views of a smart link.
 * It represents the main text that provides a user with information on how to connect their account
 */ const $4b17ec2d366022be$var$UnauthorisedViewContent = ({ providerName: providerName, isProductIntegrationSupported: isProductIntegrationSupported, testId: testId = 'unauthorised-view-content' })=>{
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const handleLearnMoreClick = (0, $eJOHy.useCallback)(()=>{
        fireEvent('ui.button.clicked.learnMore', {});
    }, [
        fireEvent
    ]);
    const learnMoreMessage = isProductIntegrationSupported ? (0, $19nmp.messages).learn_more_about_connecting_account : (0, $19nmp.messages).learn_more_about_smart_links;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            providerName ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $19nmp.messages).connect_unauthorised_account_description,
                values: {
                    context: providerName
                }
            }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $19nmp.messages).connect_unauthorised_account_description_no_provider
            }),
            ' ',
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lc0OY.default), {
                href: isProductIntegrationSupported ? (0, $5NtHI.CONTENT_URL_3P_ACCOUNT_AUTH) : (0, $5NtHI.CONTENT_URL_SECURITY_AND_PERMISSIONS),
                target: "_blank",
                testId: `${testId}-learn-more`,
                onClick: handleLearnMoreClick,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...learnMoreMessage
                })
            })
        ]
    });
};
var $4b17ec2d366022be$export$2e2bcd8739ae039 = $4b17ec2d366022be$var$UnauthorisedViewContent;

});






parcelRegister("59hpa", function(module, exports) {

$parcel$export(module.exports, "default", () => $059fbcc0253de40e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $e3qu2 = parcelRequire("e3qu2");
const $059fbcc0253de40e$var$styles = null;
/**
 * An anchor component to cover the entire container creating a clickable area.
 * @internal
 * @see `clickableContainer`
 */ const $059fbcc0253de40e$var$LayeredLink = ({ onClick: onClick, target: target, testId: testId, text: text, url: url })=>{
    const onMouseDown = (0, $e3qu2.useMouseDownEvent)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)("a", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _154iidpf _1xi2idpf _94n5idpf _1ltvidpf _azhw1osq _o5721q9c _hboxstnw _obkmidpf _a52dkb7n",
            "layered-link"
        ]),
        "data-testid": `${testId}-layered-link`,
        href: url,
        onClick: onClick,
        onMouseDown: onMouseDown,
        target: target,
        tabIndex: -1,
        children: text
    });
};
var $059fbcc0253de40e$export$2e2bcd8739ae039 = $059fbcc0253de40e$var$LayeredLink;

});


parcelRegister("025st", function(module, exports) {

$parcel$export(module.exports, "getContextByStatus", () => $78d5204a1babb283$export$e68aec76e359e401);

var $hy9OT = parcelRequire("hy9OT");

var $eGOwo = parcelRequire("eGOwo");

var $5NtHI = parcelRequire("5NtHI");

var $7r0tl = parcelRequire("7r0tl");

var $4ho8r = parcelRequire("4ho8r");

var $13x9L = parcelRequire("13x9L");

var $71sLJ = parcelRequire("71sLJ");

var $8z78z = parcelRequire("8z78z");

var $kYbGg = parcelRequire("kYbGg");

var $19nmp = parcelRequire("19nmp");

var $FoFt2 = parcelRequire("FoFt2");

var $gA511 = parcelRequire("gA511");
const $78d5204a1babb283$export$e68aec76e359e401 = (params)=>{
    const { onClick: onClick, response: response, status: status, url: url } = params ?? {};
    switch(status){
        case (0, $5NtHI.SmartLinkStatus).Pending:
        case (0, $5NtHI.SmartLinkStatus).Resolving:
            return {
                linkTitle: (0, $13x9L.default)(status, url, response, onClick),
                url: url
            };
        case (0, $5NtHI.SmartLinkStatus).Resolved:
            return (0, $4ho8r.default)(params);
        case (0, $5NtHI.SmartLinkStatus).Unauthorized:
        case (0, $5NtHI.SmartLinkStatus).Forbidden:
        case (0, $5NtHI.SmartLinkStatus).NotFound:
        case (0, $5NtHI.SmartLinkStatus).Errored:
        case (0, $5NtHI.SmartLinkStatus).Fallback:
        default:
            return {
                url: url,
                linkIcon: (0, $8z78z.extractErrorIcon)(response, status),
                linkTitle: (0, $13x9L.default)(status, url, response, onClick),
                preview: (0, $71sLJ.extractSmartLinkPreviewImage)(response),
                provider: (0, $kYbGg.extractSmartLinkProviderIcon)(response),
                actions: {
                    [(0, $5NtHI.InternalActionName).UnresolvedAction]: $78d5204a1babb283$export$f3d3482baaff4bf6(url, status, response, params.onAuthorize)
                },
                ...(0, $eGOwo.fg)('bandicoots-smart-card-teamwork-context') ? {
                    meta: {
                        accessType: response?.meta?.requestAccess?.accessType
                    }
                } : undefined
            };
    }
};
const $78d5204a1babb283$var$getForbiddenMessageKey = (meta)=>{
    const accessType = meta?.requestAccess?.accessType;
    switch(accessType){
        case 'DIRECT_ACCESS':
            return (0, $eGOwo.fg)('confluence-issue-terminology-refresh') ? 'join_to_viewIssueTermRefresh' : 'join_to_view';
        case 'REQUEST_ACCESS':
            return (0, $eGOwo.fg)('confluence-issue-terminology-refresh') ? 'request_access_to_viewIssueTermRefresh' : 'request_access_to_view';
        case 'PENDING_REQUEST_EXISTS':
            return 'pending_request';
        case 'FORBIDDEN':
            return 'forbidden_access';
        case 'DENIED_REQUEST_EXISTS':
            return 'request_denied';
        default:
            return 'restricted_link';
    }
};
const $78d5204a1babb283$export$f3d3482baaff4bf6 = (url, status, response, onAuthorize)=>{
    const provider = (0, $hy9OT.extractSmartLinkProvider)(response);
    const context = provider?.text;
    const values = context ? {
        context: context
    } : undefined;
    switch(status){
        case (0, $5NtHI.SmartLinkStatus).Forbidden:
            const meta = response?.meta ?? (0, $gA511.getForbiddenJsonLd)().meta;
            const access = (0, $7r0tl.extractRequestAccessContextImproved)({
                jsonLd: meta,
                url: url,
                product: context ?? ''
            });
            const messageKey = $78d5204a1babb283$var$getForbiddenMessageKey(meta);
            const descriptor = (0, $19nmp.messages)[messageKey];
            const retry = onAuthorize || access?.action?.promise;
            const onClick = retry && !(access?.buttonDisabled ?? false) ? (0, $FoFt2.handleOnClick)(retry) : undefined;
            return {
                descriptor: descriptor,
                onClick: onClick,
                values: values
            };
        case (0, $5NtHI.SmartLinkStatus).Unauthorized:
            return onAuthorize ? {
                descriptor: (0, $19nmp.messages).connect_link_account_card_name,
                onClick: (0, $FoFt2.handleOnClick)(onAuthorize),
                values: values
            } : undefined;
        case (0, $5NtHI.SmartLinkStatus).NotFound:
            return {
                descriptor: (0, $19nmp.messages).cannot_find_link
            };
    }
};

});
parcelRegister("4ho8r", function(module, exports) {

$parcel$export(module.exports, "default", () => $4044cb6e4b021061$export$2e2bcd8739ae039);

var $3a3fF = parcelRequire("3a3fF");
var $hy9OT = parcelRequire("hy9OT");
var $dpM2S = parcelRequire("dpM2S");

var $eGOwo = parcelRequire("eGOwo");

var $3SqDE = parcelRequire("3SqDE");

var $2YDTG = parcelRequire("2YDTG");

var $jIa7q = parcelRequire("jIa7q");

var $13x9L = parcelRequire("13x9L");

var $71sLJ = parcelRequire("71sLJ");

var $2LW3F = parcelRequire("2LW3F");

var $96cCi = parcelRequire("96cCi");

var $8z78z = parcelRequire("8z78z");

var $kYbGg = parcelRequire("kYbGg");

var $krByh = parcelRequire("krByh");

var $1UXt3 = parcelRequire("1UXt3");
const $4044cb6e4b021061$var$extractFlexibleUiContext = ({ appearance: appearance, fireEvent: fireEvent, id: id, onClick: onClick, origin: origin, renderers: renderers, resolve: resolve, actionOptions: actionOptions, response: response, status: status, aiSummaryConfig: aiSummaryConfig, ...props } = {})=>{
    if (!response) return undefined;
    const data = response.data;
    const meta = response.meta;
    const url = (0, $hy9OT.extractSmartLinkUrl)(response);
    return {
        actions: (0, $2YDTG.extractFlexibleCardActions)({
            actionOptions: actionOptions,
            aiSummaryConfig: aiSummaryConfig,
            appearance: appearance,
            fireEvent: fireEvent,
            id: id,
            origin: origin,
            response: response,
            url: props.url
        }),
        appliedToComponentsCount: (0, $1UXt3.extractAppliedToComponentsCount)(data),
        assignedToGroup: (0, $1UXt3.extractPersonAssignedToAsArray)(data),
        attachmentCount: (0, $1UXt3.extractAttachmentCount)(data),
        authorGroup: (0, $hy9OT.extractSmartLinkAuthorGroup)(response),
        ownedByGroup: (0, $3a3fF.extractPersonOwnedBy)(data),
        collaboratorGroup: (0, $jIa7q.extractPersonsUpdatedBy)(data),
        commentCount: (0, $1UXt3.extractCommentCount)(data),
        viewCount: (0, $1UXt3.extractViewCount)(data),
        reactCount: (0, $1UXt3.extractReactCount)(data),
        voteCount: (0, $1UXt3.extractVoteCount)(data),
        checklistProgress: (0, $1UXt3.extractChecklistProgress)(data),
        createdBy: (0, $hy9OT.extractSmartLinkCreatedBy)(response),
        ownedBy: (0, $1UXt3.extractOwnedBy)(data),
        assignedTo: (0, $1UXt3.extractAssignedTo)(data),
        createdOn: (0, $hy9OT.extractSmartLinkCreatedOn)(response),
        dueOn: (0, $1UXt3.extractDueOn)(data),
        latestCommit: (0, $krByh.extractLatestCommit)(data),
        linkIcon: (0, $8z78z.extractSmartLinkIcon)(response),
        linkTitle: (0, $13x9L.default)(status, props.url, response, onClick),
        location: (0, $1UXt3.extractLocation)(data),
        modifiedBy: (0, $hy9OT.extractSmartLinkModifiedBy)(response),
        modifiedOn: (0, $hy9OT.extractSmartLinkModifiedOn)(response),
        preview: (0, $71sLJ.extractSmartLinkPreviewImage)(response),
        priority: (0, $2LW3F.default)(data),
        provider: (0, $kYbGg.extractSmartLinkProviderIcon)(response),
        programmingLanguage: (0, $1UXt3.extractProgrammingLanguage)(data),
        readTime: (0, $1UXt3.extractReadTime)(data),
        sentOn: (0, $1UXt3.extractSentOn)(data),
        snippet: (0, $3SqDE.extractSmartLinkSummary)(response) || undefined,
        sourceBranch: (0, $1UXt3.extractSourceBranch)(data),
        state: (0, $96cCi.default)(response, actionOptions, id, appearance, origin, fireEvent, resolve),
        subscriberCount: (0, $1UXt3.extractSubscriberCount)(data),
        subTasksProgress: (0, $1UXt3.extractSubTasksProgress)(data),
        storyPoints: (0, $1UXt3.extractStoryPoints)(data),
        targetBranch: (0, $1UXt3.extractTargetBranch)(data),
        ...(0, $eGOwo.fg)('platform-linking-user-attributes-component') && {
            userAttributes: (0, $1UXt3.extractUserAttributes)(data)
        },
        ...(0, $eGOwo.fg)('platform-linking-team-member-count-component') && {
            teamMemberCount: (0, $1UXt3.extractTeamMemberCount)(data)
        },
        url: url,
        ari: (0, $hy9OT.extractSmartLinkAri)(response),
        ...(0, $eGOwo.fg)('platform-linking-visual-refresh-v2') && {
            type: (0, $dpM2S.extractType)(data)
        },
        ...(0, $eGOwo.fg)('cc-ai-linking-platform-snippet-renderer') && {
            meta: {
                objectId: (0, $1UXt3.extractMetaObjectId)(meta),
                resourceType: (0, $1UXt3.extractMetaResourceType)(meta),
                tenantId: (0, $1UXt3.extractMetaTenantId)(meta)
            }
        }
    };
};
var $4044cb6e4b021061$export$2e2bcd8739ae039 = $4044cb6e4b021061$var$extractFlexibleUiContext;

});
parcelRegister("3SqDE", function(module, exports) {

$parcel$export(module.exports, "extractSmartLinkSummary", () => $f7e45c18a3795a6b$export$8c6b9b49f358840);

var $3jSKi = parcelRequire("3jSKi");

var $eGOwo = parcelRequire("eGOwo");
const $f7e45c18a3795a6b$export$db5a8500f6b6286e = (jsonLd)=>{
    if (typeof jsonLd?.summary === 'string') {
        const summary = jsonLd.summary.trim();
        return Boolean(summary) ? summary : undefined;
    }
};
const $f7e45c18a3795a6b$export$8c6b9b49f358840 = (response)=>{
    if ((0, $eGOwo.fg)('smart_links_noun_support')) {
        if ((0, $3jSKi.isEntityPresent)(response)) return (0, $3jSKi.extractEntity)(response)?.description;
    }
    return response?.data && $f7e45c18a3795a6b$export$db5a8500f6b6286e(response.data);
};

});

parcelRegister("2YDTG", function(module, exports) {

$parcel$export(module.exports, "extractFlexibleCardActions", () => $df0887593ff7101f$export$abe8d0ca1daa1755);

var $5NtHI = parcelRequire("5NtHI");

var $4DFm3 = parcelRequire("4DFm3");

var $glHkX = parcelRequire("glHkX");

var $71e7e = parcelRequire("71e7e");

var $9ZYEf = parcelRequire("9ZYEf");

var $7xgpC = parcelRequire("7xgpC");

var $l3lcT = parcelRequire("l3lcT");

var $iJBt4 = parcelRequire("iJBt4");
const $df0887593ff7101f$export$abe8d0ca1daa1755 = ({ actionOptions: actionOptions, aiSummaryConfig: aiSummaryConfig, appearance: appearance, fireEvent: fireEvent, id: id, origin: origin, response: response, url: url })=>{
    const action = {
        [(0, $5NtHI.ActionName).CopyLinkAction]: (0, $71e7e.extractCopyLinkClientAction)({
            actionOptions: actionOptions,
            appearance: appearance,
            id: id,
            response: response
        }),
        [(0, $5NtHI.ActionName).DownloadAction]: (0, $9ZYEf.extractDownloadClientAction)({
            actionOptions: actionOptions,
            appearance: appearance,
            id: id,
            response: response
        }),
        [(0, $5NtHI.ActionName).FollowAction]: (0, $7xgpC.default)(response, actionOptions, id),
        [(0, $5NtHI.ActionName).PreviewAction]: (0, $l3lcT.extractPreviewClientAction)({
            actionOptions: actionOptions,
            appearance: appearance,
            fireEvent: fireEvent,
            id: id,
            origin: origin,
            response: response
        }),
        [(0, $5NtHI.ActionName).AutomationAction]: (0, $glHkX.extractAutomationAction)(response),
        [(0, $5NtHI.InternalActionName).AISummaryAction]: (0, $4DFm3.extractAISummaryAction)(response, url, actionOptions, aiSummaryConfig),
        [(0, $5NtHI.InternalActionName).ViewRelatedLinksAction]: (0, $iJBt4.extractViewRelatedLinksAction)(response)
    };
    return Object.values(action).some((value)=>Boolean(value)) ? action : undefined;
};

});
parcelRegister("4DFm3", function(module, exports) {

$parcel$export(module.exports, "extractAISummaryAction", () => $3a123960ee44ec9b$export$e7f7a50a8b8932df);

var $2fsAU = parcelRequire("2fsAU");

var $7tQSx = parcelRequire("7tQSx");

var $18DG7 = parcelRequire("18DG7");
const $3a123960ee44ec9b$export$e7f7a50a8b8932df = (response, url, actionOptions, aiSummaryConfig)=>{
    if (!(0, $2fsAU.canShowAction)((0, $18DG7.CardAction).AISummaryAction, actionOptions) || !(0, $7tQSx.getIsAISummaryEnabled)(aiSummaryConfig?.isAdminHubAIEnabled, response) || !url) return;
    return {
        url: url
    };
};

});
parcelRegister("2fsAU", function(module, exports) {

$parcel$export(module.exports, "canShowAction", () => $2264131ee11f6725$export$2487b058456cca75);
const $2264131ee11f6725$export$2487b058456cca75 = (action, actionOptions)=>{
    if (typeof actionOptions === 'undefined') return true;
    if (actionOptions.hide || actionOptions.exclude?.includes(action)) return false;
    return true;
};

});


parcelRegister("glHkX", function(module, exports) {

$parcel$export(module.exports, "extractAutomationAction", () => $26db5af86415f15e$export$f913cc6abf3ec084);

var $5NtHI = parcelRequire("5NtHI");
const $26db5af86415f15e$export$f913cc6abf3ec084 = (response)=>{
    if (!response.data) return undefined;
    if (!response?.meta?.supportedFeature?.includes((0, $5NtHI.ActionName).AutomationAction)) return undefined;
    const data = response.data;
    const meta = response.meta;
    const { name: name, 'atlassian:ari': objectAri } = data;
    const { product: product, tenantId: tenantId, resourceType: resourceType } = meta;
    return {
        product: product,
        resourceType: resourceType,
        siteAri: `ari:cloud:${product}::site/${tenantId}`,
        objectName: name,
        objectAri: objectAri,
        // TODO: The admin experience will be a follow up
        canManageAutomation: false,
        baseAutomationUrl: '',
        analyticsSource: 'smartCardAutomationAction'
    };
};

});

parcelRegister("71e7e", function(module, exports) {

$parcel$export(module.exports, "extractCopyLinkClientAction", () => $c1fb7cacddedb674$export$31ddd5c40039ce53);

var $kGroK = parcelRequire("kGroK");
const $c1fb7cacddedb674$export$31ddd5c40039ce53 = (param)=>{
    const invokeAction = (0, $kGroK.extractInvokeCopyLinkAction)(param);
    return invokeAction ? {
        invokeAction: invokeAction
    } : undefined;
};

});
parcelRegister("kGroK", function(module, exports) {

$parcel$export(module.exports, "extractInvokeCopyLinkAction", () => $944dc4c637fc31a2$export$5ec86886067a062d);

var $3seWH = parcelRequire("3seWH");
var $hy9OT = parcelRequire("hy9OT");

var $eGOwo = parcelRequire("eGOwo");

var $5NtHI = parcelRequire("5NtHI");
var $18DG7 = parcelRequire("18DG7");

var $03JM4 = parcelRequire("03JM4");

var $2fsAU = parcelRequire("2fsAU");
const $944dc4c637fc31a2$export$5ec86886067a062d = ({ actionOptions: actionOptions, appearance: appearance, id: id, response: response })=>{
    if (!(0, $2fsAU.canShowAction)((0, $18DG7.CardAction).CopyLinkAction, actionOptions)) return;
    const data = response.data;
    const url = (0, $eGOwo.fg)('smart_links_noun_support') ? (0, $hy9OT.extractSmartLinkUrl)(response) : (0, $3seWH.extractLink)(data);
    if (!url) return;
    return {
        actionFn: async ()=>navigator.clipboard.writeText(url),
        actionSubjectId: 'copyLink',
        actionType: (0, $5NtHI.ActionName).CopyLinkAction,
        definitionId: (0, $03JM4.getDefinitionId)(response),
        display: appearance,
        extensionKey: (0, $03JM4.getExtensionKey)(response),
        id: id,
        resourceType: (0, $03JM4.getResourceType)(response)
    };
};

});


parcelRegister("9ZYEf", function(module, exports) {

$parcel$export(module.exports, "extractDownloadClientAction", () => $8b4fa13cd6f1b67f$export$f6c386869a352b1f);

var $ccFJO = parcelRequire("ccFJO");
const $8b4fa13cd6f1b67f$export$f6c386869a352b1f = (param)=>{
    const invokeAction = (0, $ccFJO.extractInvokeDownloadAction)(param);
    return invokeAction ? {
        invokeAction: invokeAction
    } : undefined;
};

});
parcelRegister("ccFJO", function(module, exports) {

$parcel$export(module.exports, "extractInvokeDownloadAction", () => $0aeada01337c8e80$export$ea97cd34c2ca86de);

var $hy9OT = parcelRequire("hy9OT");

var $eGOwo = parcelRequire("eGOwo");

var $5NtHI = parcelRequire("5NtHI");
var $18DG7 = parcelRequire("18DG7");

var $03JM4 = parcelRequire("03JM4");

var $FoFt2 = parcelRequire("FoFt2");

var $2fsAU = parcelRequire("2fsAU");

var $blyJR = parcelRequire("blyJR");

var $37QDL = parcelRequire("37QDL");
const $0aeada01337c8e80$export$ea97cd34c2ca86de = ({ actionOptions: actionOptions, appearance: appearance, id: id, response: response })=>{
    if (!(0, $2fsAU.canShowAction)((0, $18DG7.CardAction).DownloadAction, actionOptions)) return;
    const data = response.data;
    const downloadActionExists = (0, $blyJR.getActionsFromJsonLd)(data).find((action)=>action['@type'] === 'DownloadAction');
    if (downloadActionExists) {
        const downloadUrl = (0, $eGOwo.fg)('smart_links_noun_support') ? (0, $hy9OT.extractSmartLinkDownloadUrl)(response) : (0, $37QDL.extractDownloadUrl)(data);
        return {
            actionFn: async ()=>(0, $FoFt2.downloadUrl)(downloadUrl),
            actionSubjectId: 'downloadDocument',
            actionType: (0, $5NtHI.ActionName).DownloadAction,
            definitionId: (0, $03JM4.getDefinitionId)(response),
            display: appearance,
            extensionKey: (0, $03JM4.getExtensionKey)(response),
            id: id,
            resourceType: (0, $03JM4.getResourceType)(response)
        };
    }
};

});
parcelRegister("blyJR", function(module, exports) {

$parcel$export(module.exports, "getActionsFromJsonLd", () => $a3fe6b36e98c43c2$export$8f031784a3a03b23);
const $a3fe6b36e98c43c2$export$8f031784a3a03b23 = (jsonLd)=>{
    let actions = jsonLd && jsonLd['schema:potentialAction'];
    if (!actions) return [];
    if (actions && !Array.isArray(actions)) actions = [
        actions
    ];
    return actions;
};

});

parcelRegister("37QDL", function(module, exports) {

$parcel$export(module.exports, "extractDownloadUrl", () => $5db269b02f6f1ef1$export$9682e3ac9d184e95);
const $5db269b02f6f1ef1$export$9682e3ac9d184e95 = (jsonLd)=>{
    if (jsonLd['atlassian:downloadUrl']) return jsonLd['atlassian:downloadUrl'];
};

});



parcelRegister("7xgpC", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d7e2884a85971c9$export$2e2bcd8739ae039);

var $3seWH = parcelRequire("3seWH");
var $dpM2S = parcelRequire("dpM2S");

var $5CgrK = parcelRequire("5CgrK");

var $03JM4 = parcelRequire("03JM4");

var $2fsAU = parcelRequire("2fsAU");

var $18DG7 = parcelRequire("18DG7");

var $bT52P = parcelRequire("bT52P");
const $2d7e2884a85971c9$var$extractFollowAction = (response, actionOptions, id)=>{
    if (!(0, $2fsAU.canShowAction)((0, $18DG7.CardAction).FollowAction, actionOptions)) return;
    const extensionKey = (0, $03JM4.getExtensionKey)(response);
    const data = response?.data;
    const actions = (0, $bT52P.default)(data);
    const type = (0, $dpM2S.extractType)(data);
    const isProject = type?.includes('atlassian:Project');
    if (!extensionKey || actions.length === 0) return;
    const action = actions.find((item)=>{
        if (item?.name === 'UpdateAction') {
            const actionName = item?.dataUpdateAction?.name;
            return actionName === (0, $5CgrK.SmartLinkActionType).FollowEntityAction || actionName === (0, $5CgrK.SmartLinkActionType).UnfollowEntityAction;
        }
        return false;
    });
    if (!action || !action.resourceIdentifiers) return;
    const url = (0, $3seWH.extractLink)(data);
    const reload = url ? {
        id: id,
        url: url
    } : undefined;
    const actionType = action.dataUpdateAction?.name;
    return {
        action: {
            action: {
                actionType: actionType,
                resourceIdentifiers: action.resourceIdentifiers
            },
            providerKey: extensionKey,
            reload: reload
        },
        value: actionType === (0, $5CgrK.SmartLinkActionType).FollowEntityAction,
        isProject: isProject
    };
};
var $2d7e2884a85971c9$export$2e2bcd8739ae039 = $2d7e2884a85971c9$var$extractFollowAction;

});
parcelRegister("bT52P", function(module, exports) {

$parcel$export(module.exports, "default", () => $bfb63d54723b1798$export$2e2bcd8739ae039);
const $bfb63d54723b1798$var$extractServerAction = (data)=>{
    const actions = data?.['atlassian:serverAction'];
    if (!actions) return [];
    if (actions && !Array.isArray(actions)) return [
        actions
    ];
    return actions;
};
var $bfb63d54723b1798$export$2e2bcd8739ae039 = $bfb63d54723b1798$var$extractServerAction;

});


parcelRegister("l3lcT", function(module, exports) {

$parcel$export(module.exports, "extractPreviewClientAction", () => $be48c7ee2c64cc3a$export$9f0d9100b079448);

var $5O37S = parcelRequire("5O37S");
const $be48c7ee2c64cc3a$export$9f0d9100b079448 = (param)=>{
    const invokeAction = (0, $5O37S.extractInvokePreviewAction)(param);
    return invokeAction ? {
        invokeAction: invokeAction
    } : undefined;
};

});
parcelRegister("5O37S", function(module, exports) {

$parcel$export(module.exports, "extractInvokePreviewAction", () => $5a058ee1f9e9b538$export$caf83f49e52ac0bb);

var $3seWH = parcelRequire("3seWH");
var $6OR2o = parcelRequire("6OR2o");
var $9Thyx = parcelRequire("9Thyx");
var $hy9OT = parcelRequire("hy9OT");
var $8T839 = parcelRequire("8T839");

var $eGOwo = parcelRequire("eGOwo");

var $5NtHI = parcelRequire("5NtHI");
var $18DG7 = parcelRequire("18DG7");

var $03JM4 = parcelRequire("03JM4");

var $2fsAU = parcelRequire("2fsAU");

var $aNEbu = parcelRequire("aNEbu");

var $b5GVx = parcelRequire("b5GVx");

var $1jpb6 = parcelRequire("1jpb6");

var $8z78z = parcelRequire("8z78z");

var $ccFJO = parcelRequire("ccFJO");

var $el1MG = parcelRequire("el1MG");
const $5a058ee1f9e9b538$export$caf83f49e52ac0bb = (param)=>{
    const { actionOptions: actionOptions, appearance: display, fireEvent: fireEvent, onClose: onClose, id: id, origin: origin, response: response } = param;
    if (!(0, $2fsAU.canShowAction)((0, $18DG7.CardAction).PreviewAction, actionOptions)) return;
    const data = response.data;
    const meta = response.meta;
    const src = (0, $6OR2o.extractPreview)(data, 'web')?.src;
    if (src) {
        const url = (0, $3seWH.extractLink)(data);
        const extensionKey = (0, $03JM4.getExtensionKey)(response);
        return {
            actionFn: async ()=>(0, $aNEbu.openEmbedModal)({
                    fireEvent: fireEvent,
                    extensionKey: extensionKey,
                    id: id,
                    invokeDownloadAction: (0, $ccFJO.extractInvokeDownloadAction)(param),
                    invokeViewAction: (0, $el1MG.extractInvokeViewAction)(param, true),
                    isSupportTheming: (0, $b5GVx.extractIsSupportTheming)(meta),
                    isTrusted: (0, $1jpb6.extractIsTrusted)(meta),
                    linkIcon: (0, $8z78z.extractLinkIcon)(response),
                    providerName: (0, $eGOwo.fg)('smart_links_noun_support') ? (0, $hy9OT.extractSmartLinkProvider)(response)?.text : (0, $9Thyx.extractProvider)(data)?.text,
                    onClose: onClose,
                    origin: origin,
                    src: (0, $eGOwo.fg)('smart_links_noun_support') ? (0, $hy9OT.extractSmartLinkEmbed)(response)?.src : src,
                    title: (0, $eGOwo.fg)('smart_links_noun_support') ? (0, $hy9OT.extractSmartLinkTitle)(response) : (0, $8T839.extractTitle)(data),
                    url: (0, $eGOwo.fg)('smart_links_noun_support') ? (0, $hy9OT.extractSmartLinkUrl)(response) : url
                }),
            actionSubjectId: 'invokePreviewScreen',
            actionType: (0, $5NtHI.ActionName).PreviewAction,
            display: display,
            extensionKey: extensionKey,
            id: id
        };
    }
};

});
parcelRegister("aNEbu", function(module, exports) {

$parcel$export(module.exports, "openEmbedModal", () => $2e72cab05fd02eba$export$7859f96cd8cff034);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $aQK2r = parcelRequire("aQK2r");

var $4nehu = parcelRequire("4nehu");
const $2e72cab05fd02eba$var$IFRAME_NAME = 'twp-editor-preview-iframe';
const $2e72cab05fd02eba$var$POPUP_MOUNT_POINT_ID = 'twp-editor-preview-iframe';

async function $2e72cab05fd02eba$export$7859f96cd8cff034({ onClose: onClose = ()=>{}, ...props } = {}) {
    let popupMountPoint;
    popupMountPoint = document.getElementById($2e72cab05fd02eba$var$POPUP_MOUNT_POINT_ID);
    if (!popupMountPoint) {
        popupMountPoint = document.createElement('div');
        popupMountPoint.id = $2e72cab05fd02eba$var$POPUP_MOUNT_POINT_ID;
        popupMountPoint.setAttribute('data-testid', 'preview-modal');
        document.body.appendChild(popupMountPoint);
    }
    let Modal = await (parcelRequire("4M5bk"));
    (0, (/*@__PURE__*/$parcel$interopDefault($aQK2r))).render(/*#__PURE__*/ (0, $gt9Am.jsx)((0, $4nehu.default), {
        locale: "en",
        children: /*#__PURE__*/ (0, $gt9Am.jsx)(Modal.default, {
            ...props,
            iframeName: $2e72cab05fd02eba$var$IFRAME_NAME,
            onClose: (_context)=>{
                if (popupMountPoint) (0, (/*@__PURE__*/$parcel$interopDefault($aQK2r))).unmountComponentAtNode(popupMountPoint);
                if (onClose) onClose(_context);
            },
            showModal: true
        })
    }), popupMountPoint);
}

});
parcelRegister("4M5bk", function(module, exports) {

let $379faa16a2da8ae6$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $379faa16a2da8ae6$var$load("ffQaD"),
    $379faa16a2da8ae6$var$load("kvRbA"),
    $379faa16a2da8ae6$var$load("16B8C")
]).then(()=>parcelRequire('lJ0K6'));

});


parcelRegister("b5GVx", function(module, exports) {

$parcel$export(module.exports, "extractIsSupportTheming", () => $d6879f4d400478b0$export$38d755f52cdf4acb);

var $3DgO9 = parcelRequire("3DgO9");
const $d6879f4d400478b0$export$38d755f52cdf4acb = (meta)=>{
    return Boolean(meta?.key && (0, $3DgO9.PROVIDER_KEYS_WITH_THEMING).includes(meta.key));
};

});
parcelRegister("3DgO9", function(module, exports) {

$parcel$export(module.exports, "CONFLUENCE_GENERATOR_ID", () => $a195a16b307c9ed2$export$cee224b5de4d6d66);
$parcel$export(module.exports, "JIRA_GENERATOR_ID", () => $a195a16b307c9ed2$export$f654d825189934a7);
$parcel$export(module.exports, "JIRA_TASK", () => $a195a16b307c9ed2$export$84a73a0383f58180);
$parcel$export(module.exports, "JIRA_SUB_TASK", () => $a195a16b307c9ed2$export$c6c83963a9378a67);
$parcel$export(module.exports, "JIRA_STORY", () => $a195a16b307c9ed2$export$58af3c426c111a6d);
$parcel$export(module.exports, "JIRA_BUG", () => $a195a16b307c9ed2$export$ac9898a63417219e);
$parcel$export(module.exports, "JIRA_EPIC", () => $a195a16b307c9ed2$export$54db5e3fb12e39cd);
$parcel$export(module.exports, "JIRA_INCIDENT", () => $a195a16b307c9ed2$export$2f54a5a217202c85);
$parcel$export(module.exports, "JIRA_SERVICE_REQUEST", () => $a195a16b307c9ed2$export$d097371052bfc411);
$parcel$export(module.exports, "JIRA_CHANGE", () => $a195a16b307c9ed2$export$efd9452ad16c6676);
$parcel$export(module.exports, "JIRA_PROBLEM", () => $a195a16b307c9ed2$export$2e7e70abb5d81f67);
$parcel$export(module.exports, "JIRA_CUSTOM_TASK_TYPE", () => $a195a16b307c9ed2$export$ce25cfc40b280dbc);
$parcel$export(module.exports, "PROVIDER_KEYS_WITH_THEMING", () => $a195a16b307c9ed2$export$fe44ce30fd8d131b);
const $a195a16b307c9ed2$export$cee224b5de4d6d66 = 'https://www.atlassian.com/#Confluence';
const $a195a16b307c9ed2$export$f654d825189934a7 = 'https://www.atlassian.com/#Jira';
const $a195a16b307c9ed2$export$84a73a0383f58180 = 'JiraTask';
const $a195a16b307c9ed2$export$c6c83963a9378a67 = 'JiraSubTask';
const $a195a16b307c9ed2$export$58af3c426c111a6d = 'JiraStory';
const $a195a16b307c9ed2$export$ac9898a63417219e = 'JiraBug';
const $a195a16b307c9ed2$export$54db5e3fb12e39cd = 'JiraEpic';
const $a195a16b307c9ed2$export$2f54a5a217202c85 = 'JiraIncident';
const $a195a16b307c9ed2$export$d097371052bfc411 = 'JiraServiceRequest';
const $a195a16b307c9ed2$export$efd9452ad16c6676 = 'JiraChange';
const $a195a16b307c9ed2$export$2e7e70abb5d81f67 = 'JiraProblem';
const $a195a16b307c9ed2$export$ce25cfc40b280dbc = 'JiraCustomTaskType';
const $a195a16b307c9ed2$export$fe44ce30fd8d131b = [
    'jira-object-provider',
    'confluence-object-provider',
    'watermelon-object-provider'
];

});


parcelRegister("1jpb6", function(module, exports) {

$parcel$export(module.exports, "extractIsTrusted", () => $ec58a694a8b15740$export$4f3ffbb500daac5a);
const $ec58a694a8b15740$export$4f3ffbb500daac5a = (meta)=>{
    return Boolean(meta?.key && meta.key !== 'iframely-object-provider');
};

});

parcelRegister("8z78z", function(module, exports) {

$parcel$export(module.exports, "extractLinkIcon", () => $908dbe215fe49acc$export$43612bed147eae48);
$parcel$export(module.exports, "extractErrorIcon", () => $908dbe215fe49acc$export$bdd29be9b0395931);
$parcel$export(module.exports, "extractSmartLinkIcon", () => $908dbe215fe49acc$export$35040aed9264b11c);

var $3jSKi = parcelRequire("3jSKi");

var $5NtHI = parcelRequire("5NtHI");

var $1zbM5 = parcelRequire("1zbM5");

var $lBR2D = parcelRequire("lBR2D");

var $kYbGg = parcelRequire("kYbGg");
const $908dbe215fe49acc$export$43612bed147eae48 = (response, renderers)=>{
    const data = response.data;
    const render = (0, $1zbM5.default)(data, renderers);
    return {
        ...(0, $lBR2D.default)(data),
        render: render
    };
};
const $908dbe215fe49acc$export$bdd29be9b0395931 = (response, status)=>{
    // Try to get provider icon first.
    if (response) {
        const data = response.data;
        const { icon: icon, url: url } = (0, $kYbGg.default)(data) || {};
        if (icon || url) return {
            icon: icon,
            url: url
        };
    }
    // Otherwise, use fallback icon for each status.
    switch(status){
        case (0, $5NtHI.SmartLinkStatus).Forbidden:
        case (0, $5NtHI.SmartLinkStatus).Unauthorized:
            return {
                icon: (0, $5NtHI.IconType).Forbidden
            };
        case (0, $5NtHI.SmartLinkStatus).NotFound:
            return {
                icon: (0, $5NtHI.IconType).Error
            };
        case (0, $5NtHI.SmartLinkStatus).Errored:
        case (0, $5NtHI.SmartLinkStatus).Fallback:
        default:
            return {
                icon: (0, $5NtHI.IconType).Default
            };
    }
};
const $908dbe215fe49acc$export$35040aed9264b11c = (response, renderers)=>{
    if (!response || !response?.data) return undefined;
    if ((0, $3jSKi.isEntityPresent)(response)) return (0, $3jSKi.extractEntityIcon)(response);
    return $908dbe215fe49acc$export$43612bed147eae48(response, renderers);
};

});
parcelRegister("1zbM5", function(module, exports) {

$parcel$export(module.exports, "default", () => $006269c1cd396984$export$2e2bcd8739ae039);
const $006269c1cd396984$var$sanitizeEmojiValue = (value)=>value && value.replace(/['"]+/g, '').replace(/null/, '') || '';
const $006269c1cd396984$var$extractIconRenderer = (data, renderers)=>{
    const prefix = data['atlassian:titlePrefix'];
    if (prefix?.['@type'] === 'atlassian:Emoji') {
        const emojiId = $006269c1cd396984$var$sanitizeEmojiValue(prefix['text']);
        const emojiRenderer = renderers?.emoji;
        if (emojiId && emojiRenderer) return ()=>emojiRenderer(emojiId);
    }
};
var $006269c1cd396984$export$2e2bcd8739ae039 = $006269c1cd396984$var$extractIconRenderer;

});

parcelRegister("lBR2D", function(module, exports) {

$parcel$export(module.exports, "default", () => $294e9df0fd90b4dc$export$2e2bcd8739ae039);

var $8T839 = parcelRequire("8T839");

var $5NtHI = parcelRequire("5NtHI");

var $abbo9 = parcelRequire("abbo9");

var $aDkpj = parcelRequire("aDkpj");

var $l5kRv = parcelRequire("l5kRv");

var $3DgO9 = parcelRequire("3DgO9");

var $3LiRd = parcelRequire("3LiRd");

var $dyU3L = parcelRequire("dyU3L");

var $imtUu = parcelRequire("imtUu");

var $kYbGg = parcelRequire("kYbGg");

var $6LWK3 = parcelRequire("6LWK3");
const $294e9df0fd90b4dc$var$extractTask = (data, label)=>{
    const { id: id, icon: url } = (0, $l5kRv.extractTaskType)(data) || {};
    const taskType = id?.split('#').pop();
    const taskIcon = url ? {
        label: label,
        url: url
    } : undefined;
    return {
        taskType: taskType,
        taskIcon: taskIcon
    };
};
const $294e9df0fd90b4dc$var$extractType = (jsonLd)=>{
    const type = jsonLd['@type'];
    return Array.isArray(type) ? type.sort((a, b)=>(0, $aDkpj.extractorPriorityMap)[b] - (0, $aDkpj.extractorPriorityMap)[a])[0] : type;
};
const $294e9df0fd90b4dc$var$isJiraProvider = (provider)=>provider === (0, $3DgO9.JIRA_GENERATOR_ID);
function $294e9df0fd90b4dc$var$chooseIcon({ urlIcon: urlIcon, type: type, label: label, data: data, providerIcon: providerIcon }) {
    const providerId = data.generator?.['@id'];
    const fileFormat = data?.['schema:fileFormat'];
    const fileFormatIcon = (0, $dyU3L.default)(fileFormat);
    const documentTypeIcon = $294e9df0fd90b4dc$var$typeToIconDescriptor({
        type: type,
        label: label,
        providerId: providerId,
        data: data
    }) || (0, $3LiRd.default)(type, label, providerId);
    return (0, $abbo9.prioritiseIcon)({
        fileFormatIcon: fileFormatIcon,
        documentTypeIcon: documentTypeIcon,
        urlIcon: urlIcon,
        providerIcon: providerIcon
    });
}
function $294e9df0fd90b4dc$var$typeToIconDescriptor({ type: type, label: label, providerId: providerId, data: data }) {
    switch(type){
        case 'atlassian:Goal':
            return {
                icon: (0, $5NtHI.IconType).Task,
                label: label || 'Goal'
            };
        case 'atlassian:Project':
            return {
                icon: (0, $5NtHI.IconType).Project,
                label: label || 'Project'
            };
        case 'atlassian:SourceCodeCommit':
            return {
                icon: (0, $5NtHI.IconType).Commit,
                label: label || 'Commit'
            };
        case 'atlassian:SourceCodePullRequest':
            return {
                icon: (0, $5NtHI.IconType).PullRequest,
                label: label || 'Pull request'
            };
        case 'atlassian:SourceCodeReference':
            return {
                icon: (0, $5NtHI.IconType).Branch,
                label: label || 'Reference'
            };
        case 'atlassian:SourceCodeRepository':
            return {
                icon: (0, $5NtHI.IconType).Repo,
                label: label || 'Repository'
            };
        case 'atlassian:Task':
            const taskLabel = label || 'Task';
            const taskIconDescriptor = {
                icon: (0, $5NtHI.IconType).Task,
                label: taskLabel
            };
            if ($294e9df0fd90b4dc$var$isJiraProvider(providerId)) {
                const { taskType: taskType, taskIcon: taskIcon } = $294e9df0fd90b4dc$var$extractTask(data);
                return taskType === 'JiraCustomTaskType' ? taskIcon || taskIconDescriptor : (0, $imtUu.default)(taskType, taskLabel);
            }
            return taskIconDescriptor;
        default:
            return undefined;
    }
}
/**
 * Return the icon object given a JSON-LD data object.
 */ const $294e9df0fd90b4dc$var$extractJsonldDataIcon = (data)=>{
    const label = (0, $8T839.extractTitle)(data);
    const type = $294e9df0fd90b4dc$var$extractType(data);
    const urlIcon = (0, $6LWK3.default)(data.icon, label);
    const providerIcon = (0, $kYbGg.default)(data);
    return $294e9df0fd90b4dc$var$chooseIcon({
        urlIcon: urlIcon,
        providerIcon: providerIcon,
        type: type,
        label: label,
        data: data
    });
};
var $294e9df0fd90b4dc$export$2e2bcd8739ae039 = $294e9df0fd90b4dc$var$extractJsonldDataIcon;

});
parcelRegister("abbo9", function(module, exports) {

$parcel$export(module.exports, "prioritiseIcon", () => $2e5b1fff8f67610f$export$65e47eb22a387a86);
/**
 * Options required to prioritise which icon to show
 */ function $2e5b1fff8f67610f$export$65e47eb22a387a86({ fileFormatIcon: fileFormatIcon, documentTypeIcon: documentTypeIcon, urlIcon: urlIcon, providerIcon: providerIcon }) {
    return urlIcon || fileFormatIcon || documentTypeIcon || providerIcon;
}

});

parcelRegister("aDkpj", function(module, exports) {

$parcel$export(module.exports, "extractorPriorityMap", () => $0fdfc5b99e737a37$export$e0deaeb4a2dfe2b4);
const $0fdfc5b99e737a37$export$e0deaeb4a2dfe2b4 = {
    Object: 0,
    Document: 5,
    'schema:TextDigitalDocument': 10,
    'schema:DigitalDocument': 10,
    'schema:BlogPosting': 10,
    'schema:SpreadsheetDigitalDocument': 10,
    'schema:PresentationDigitalDocument': 10,
    'atlassian:Goal': 10,
    'atlassian:Task': 10,
    'atlassian:Project': 10,
    'atlassian:Template': 10,
    'atlassian:SourceCodeCommit': 10,
    'atlassian:SourceCodeRepository': 10,
    'atlassian:SourceCodePullRequest': 10,
    'atlassian:SourceCodeReference': 10,
    'atlassian:UndefinedLink': 10
};

});

parcelRegister("l5kRv", function(module, exports) {

$parcel$export(module.exports, "extractTaskType", () => $30b3c63f6ca4244d$export$ed3fd59180514d27);

var $4moW4 = parcelRequire("4moW4");
const $30b3c63f6ca4244d$export$ed3fd59180514d27 = (jsonLd)=>{
    // TODO: Remove once Jira migrate to the correct type.
    const taskType = jsonLd['atlassian:taskType'] || jsonLd.taskType;
    if (taskType) {
        if (typeof taskType === 'string') return {
            id: taskType
        };
        else if (taskType['@type'] === 'Link') return {
            id: taskType.href
        };
        else return {
            id: taskType['@id'],
            name: taskType.name,
            icon: taskType.icon && (0, $4moW4.extractUrlFromIconJsonLd)(taskType.icon)
        };
    }
};

});

parcelRegister("3LiRd", function(module, exports) {

$parcel$export(module.exports, "default", () => $75b1006362800173$export$2e2bcd8739ae039);

var $9Thyx = parcelRequire("9Thyx");

var $5NtHI = parcelRequire("5NtHI");
/**
 * Computes the relevant icon for a document type.
 *
 * @remark Note that document icons can vary based on the provider. E.g., a
 * provider may choose to re-use one of these document types in their domain,
 * but offer a different SVG icon on the frontend (to map to this type in their
 * domain). See `schema:digitalDocument` for an example of this behaviour. This
 * mechanism will be superseded by backend-driven icon URLs as part of
 * go/j/MODES-5864. Do not add more!
 *
 * @param documentType JSON-LD document type
 * @param label human-readable label to be displayed on the icon
 * @param providerId JSON-LD provider (generator ID)
 * @returns an icon descriptor representing the document type
 */ const $75b1006362800173$var$extractDocumentTypeIcon = (documentType, label, providerId)=>{
    switch(documentType){
        case 'schema:BlogPosting':
            return {
                icon: (0, $5NtHI.IconType).Blog,
                label: label || 'Blog'
            };
        case 'schema:DigitalDocument':
            if (providerId && (0, $9Thyx.isConfluenceGenerator)(providerId)) return {
                icon: (0, $5NtHI.IconType).LiveDocument,
                label: label || 'Live Document'
            };
            else return {
                icon: (0, $5NtHI.IconType).File,
                label: label || 'File'
            };
        case 'schema:TextDigitalDocument':
            return {
                icon: (0, $5NtHI.IconType).Document,
                label: label || 'Document'
            };
        case 'schema:PresentationDigitalDocument':
            return {
                icon: (0, $5NtHI.IconType).Presentation,
                label: label || 'Presentation'
            };
        case 'schema:SpreadsheetDigitalDocument':
            return {
                icon: (0, $5NtHI.IconType).Spreadsheet,
                label: label || 'Spreadsheet'
            };
        case 'atlassian:Template':
            return {
                icon: (0, $5NtHI.IconType).Template,
                label: label || 'Template'
            };
        case 'atlassian:UndefinedLink':
            return {
                icon: (0, $5NtHI.IconType).Document,
                label: label || 'Undefined link'
            };
        default:
            return undefined;
    }
};
var $75b1006362800173$export$2e2bcd8739ae039 = $75b1006362800173$var$extractDocumentTypeIcon;

});

parcelRegister("imtUu", function(module, exports) {

$parcel$export(module.exports, "default", () => $ebe1a8cda0f126bd$export$2e2bcd8739ae039);

var $5NtHI = parcelRequire("5NtHI");
const $ebe1a8cda0f126bd$var$extractJiraTaskIcon = (taskType, label = 'Task')=>{
    switch(taskType){
        case 'JiraBug':
            return {
                icon: (0, $5NtHI.IconType).Bug,
                label: label
            };
        case 'JiraChange':
            return {
                icon: (0, $5NtHI.IconType).Change,
                label: label
            };
        case 'JiraEpic':
            return {
                icon: (0, $5NtHI.IconType).Epic,
                label: label
            };
        case 'JiraIncident':
            return {
                icon: (0, $5NtHI.IconType).Incident,
                label: label
            };
        case 'JiraProblem':
            return {
                icon: (0, $5NtHI.IconType).Problem,
                label: label
            };
        case 'JiraServiceRequest':
            return {
                icon: (0, $5NtHI.IconType).ServiceRequest,
                label: label
            };
        case 'JiraStory':
            return {
                icon: (0, $5NtHI.IconType).Story,
                label: label
            };
        case 'JiraSubTask':
            return {
                icon: (0, $5NtHI.IconType).SubTask,
                label: label
            };
        case 'JiraTask':
        default:
            return {
                icon: (0, $5NtHI.IconType).Task,
                label: label
            };
    }
};
var $ebe1a8cda0f126bd$export$2e2bcd8739ae039 = $ebe1a8cda0f126bd$var$extractJiraTaskIcon;

});

parcelRegister("kYbGg", function(module, exports) {

$parcel$export(module.exports, "default", () => $1bccbab21d09288f$export$2e2bcd8739ae039);
$parcel$export(module.exports, "extractSmartLinkProviderIcon", () => $1bccbab21d09288f$export$5def189f04eea025);

var $3jSKi = parcelRequire("3jSKi");
var $8T839 = parcelRequire("8T839");

var $5NtHI = parcelRequire("5NtHI");

var $3DgO9 = parcelRequire("3DgO9");

var $6LWK3 = parcelRequire("6LWK3");
/**
 * Extracts the provider icon and label from the given JSON-LD data.
 *
 * If the data is from Confluence, the icon will be the Confluence icon and the label will be 'Confluence'.
 * If the data is from Jira, the icon will be the Jira icon and the label will be 'Jira'.
 * If the data is from another provider, the icon and label will be extracted from the generator object.
 *
 * @param data - The JSON-LD data to extract the provider icon and label from.
 * @returns IconDescriptor with optional icon string name, url and label, or `undefined` if the data is not provided.
 */ const $1bccbab21d09288f$var$extractProviderIcon = (data)=>{
    if (!data) return undefined;
    const generator = data.generator;
    const provider = generator?.['@id'];
    const icon = generator?.icon;
    const label = generator?.name || (0, $8T839.extractTitle)(data);
    if (provider === (0, $3DgO9.CONFLUENCE_GENERATOR_ID)) return {
        icon: (0, $5NtHI.IconType).Confluence,
        label: label || 'Confluence'
    };
    if (provider === (0, $3DgO9.JIRA_GENERATOR_ID)) return {
        icon: (0, $5NtHI.IconType).Jira,
        label: label || 'Jira'
    };
    return (0, $6LWK3.default)(icon, label);
};
var $1bccbab21d09288f$export$2e2bcd8739ae039 = $1bccbab21d09288f$var$extractProviderIcon;
const $1bccbab21d09288f$export$5def189f04eea025 = (response)=>{
    if (!response || !response?.data) return undefined;
    if ((0, $3jSKi.isEntityPresent)(response)) {
        const provider = (0, $3jSKi.extractEntityProvider)(response);
        if (!provider) return undefined;
        switch(provider.id){
            case 0, $3DgO9.CONFLUENCE_GENERATOR_ID:
                return {
                    icon: (0, $5NtHI.IconType).Confluence,
                    label: provider.text || 'Confluence'
                };
            case 0, $3DgO9.JIRA_GENERATOR_ID:
                return {
                    icon: (0, $5NtHI.IconType).Jira,
                    label: provider.text || 'Jira'
                };
            default:
                const { generator: generator } = response.meta;
                if (!generator) return undefined;
                return {
                    label: generator.name || (0, $3jSKi.extractEntity)(response)?.displayName,
                    url: generator.icon?.url
                };
        }
    }
    return $1bccbab21d09288f$var$extractProviderIcon(response.data);
};

});
parcelRegister("6LWK3", function(module, exports) {

$parcel$export(module.exports, "default", () => $500a210ebb43c155$export$2e2bcd8739ae039);

var $4moW4 = parcelRequire("4moW4");
/**
 * Extracts the URL icon from the given icon or link object.
 *
 * @param icon - The icon or link object from which to extract the URL icon.
 * @param label - The label for the URL icon.
 * @returns IconDescriptor, which will contain label and url, or undefined
 */ const $500a210ebb43c155$var$extractUrlIcon = (icon, label)=>{
    const url = icon && (0, $4moW4.extractUrlFromIconJsonLd)(icon);
    return url ? {
        label: label,
        url: url
    } : undefined;
};
var $500a210ebb43c155$export$2e2bcd8739ae039 = $500a210ebb43c155$var$extractUrlIcon;

});




parcelRegister("el1MG", function(module, exports) {

$parcel$export(module.exports, "extractInvokeViewAction", () => $8933c20370529de6$export$88c5813cfbbe4e4c);

var $3seWH = parcelRequire("3seWH");

var $18DG7 = parcelRequire("18DG7");

var $03JM4 = parcelRequire("03JM4");

var $FoFt2 = parcelRequire("FoFt2");

var $2fsAU = parcelRequire("2fsAU");

var $blyJR = parcelRequire("blyJR");
const $8933c20370529de6$export$88c5813cfbbe4e4c = ({ actionOptions: actionOptions, appearance: appearance, id: id, response: response }, force)=>{
    if (!(0, $2fsAU.canShowAction)((0, $18DG7.CardAction).ViewAction, actionOptions)) return;
    const data = response.data;
    if (!data) return;
    const url = (0, $3seWH.extractLink)(data);
    const viewActionExists = (0, $blyJR.getActionsFromJsonLd)(data).find((action)=>action['@type'] === 'ViewAction');
    if (url && (viewActionExists || force)) return {
        actionFn: async ()=>(0, $FoFt2.openUrl)(url),
        actionSubjectId: 'shortcutGoToLink',
        actionType: 'ViewAction',
        definitionId: (0, $03JM4.getDefinitionId)(response),
        display: appearance,
        extensionKey: (0, $03JM4.getExtensionKey)(response),
        id: id,
        resourceType: (0, $03JM4.getResourceType)(response)
    };
};

});



parcelRegister("iJBt4", function(module, exports) {

$parcel$export(module.exports, "extractViewRelatedLinksAction", () => $30a13f343fd23d01$export$debae7424a0231b9);

var $9R3Jd = parcelRequire("9R3Jd");
var $hy9OT = parcelRequire("hy9OT");

var $eGOwo = parcelRequire("eGOwo");
const $30a13f343fd23d01$export$debae7424a0231b9 = (response)=>{
    if (!response?.meta?.supportedFeature?.includes('RelatedLinks')) return;
    const ari = (0, $eGOwo.fg)('smart_links_noun_support') ? (0, $hy9OT.extractSmartLinkAri)(response) : (0, $9R3Jd.extractAri)(response.data);
    if (!ari) return;
    return {
        ari: ari
    };
};

});


parcelRegister("jIa7q", function(module, exports) {

$parcel$export(module.exports, "extractPersonsUpdatedBy", () => $afd980b8f5408674$export$216e4f6aa7c169b8);

var $8pdx9 = parcelRequire("8pdx9");
var $9JeZK = parcelRequire("9JeZK");
const $afd980b8f5408674$export$216e4f6aa7c169b8 = (jsonLd)=>{
    if (jsonLd['@type'] === 'atlassian:Project') {
        const members = (0, $8pdx9.extractMembers)(jsonLd);
        if (members && members.length !== 0) return members;
    }
    const updatedBy = jsonLd['atlassian:updatedBy'];
    if (updatedBy) {
        const extractedPersons = (0, $9JeZK.extractPersonFromJsonLd)(updatedBy);
        return extractedPersons ? [
            extractedPersons
        ] : undefined;
    }
};

});
parcelRegister("8pdx9", function(module, exports) {

$parcel$export(module.exports, "extractMembers", () => $491ba0064e87a086$export$6281d080d62a0719);

var $9JeZK = parcelRequire("9JeZK");
const $491ba0064e87a086$export$6281d080d62a0719 = (jsonLd)=>{
    const members = jsonLd['atlassian:member'];
    if (members) {
        if (typeof members === 'string') throw Error('Link[atlassian:members] must be an array or object.');
        else if (members.hasOwnProperty('totalItems')) {
            const collection = members;
            if (collection.items) return collection.items.map((member)=>(0, $9JeZK.extractPersonFromJsonLd)(member)).filter((member)=>!!member);
        } else {
            const memberItem = members;
            const memberItemForLink = (0, $9JeZK.extractPersonFromJsonLd)(memberItem);
            if (memberItemForLink) return [
                memberItemForLink
            ];
        }
    }
};

});


parcelRegister("13x9L", function(module, exports) {

$parcel$export(module.exports, "default", () => $f77867f4004a4594$export$2e2bcd8739ae039);

var $hy9OT = parcelRequire("hy9OT");

var $5NtHI = parcelRequire("5NtHI");
const $f77867f4004a4594$var$extractLinkTitle = (status, propUrl, response, onClick)=>{
    const responseUrl = (0, $hy9OT.extractSmartLinkUrl)(response);
    const url = status === (0, $5NtHI.SmartLinkStatus).Resolved ? responseUrl ?? propUrl : propUrl;
    const name = (0, $hy9OT.extractSmartLinkTitle)(response);
    const text = status === (0, $5NtHI.SmartLinkStatus).Resolved ? name ?? responseUrl ?? propUrl : propUrl;
    return {
        onClick: onClick,
        text: text,
        url: url
    };
};
var $f77867f4004a4594$export$2e2bcd8739ae039 = $f77867f4004a4594$var$extractLinkTitle;

});

parcelRegister("2LW3F", function(module, exports) {

$parcel$export(module.exports, "default", () => $46aad986c1287f3b$export$2e2bcd8739ae039);

var $4moW4 = parcelRequire("4moW4");

var $5NtHI = parcelRequire("5NtHI");
const $46aad986c1287f3b$var$priorityMapper = {
    blocker: (0, $5NtHI.IconType).PriorityBlocker,
    critical: (0, $5NtHI.IconType).PriorityCritical,
    high: (0, $5NtHI.IconType).PriorityHigh,
    highest: (0, $5NtHI.IconType).PriorityHighest,
    low: (0, $5NtHI.IconType).PriorityLow,
    lowest: (0, $5NtHI.IconType).PriorityLowest,
    major: (0, $5NtHI.IconType).PriorityMajor,
    medium: (0, $5NtHI.IconType).PriorityMedium,
    minor: (0, $5NtHI.IconType).PriorityMinor,
    trivial: (0, $5NtHI.IconType).PriorityTrivial,
    undefined: (0, $5NtHI.IconType).PriorityUndefined
};
const $46aad986c1287f3b$var$extractPriority = (data)=>{
    const priority = data['atlassian:priority'];
    if (priority) {
        if (typeof priority === 'string') {
            const icon = $46aad986c1287f3b$var$priorityMapper[priority.toLowerCase()];
            if (icon) return {
                icon: icon,
                label: priority
            };
        } else if (priority['@type'] === 'Object') return {
            label: priority.name,
            url: priority.icon && (0, $4moW4.extractUrlFromIconJsonLd)(priority.icon)
        };
    }
};
var $46aad986c1287f3b$export$2e2bcd8739ae039 = $46aad986c1287f3b$var$extractPriority;

});

parcelRegister("96cCi", function(module, exports) {

$parcel$export(module.exports, "default", () => $599db3951a68070c$export$2e2bcd8739ae039);

var $3seWH = parcelRequire("3seWH");

var $03JM4 = parcelRequire("03JM4");

var $2fsAU = parcelRequire("2fsAU");

var $18DG7 = parcelRequire("18DG7");

var $5O37S = parcelRequire("5O37S");

var $bpSSH = parcelRequire("bpSSH");

var $bT52P = parcelRequire("bT52P");
const $599db3951a68070c$var$toInvokeRequest = (extensionKey, resourceIdentifiers, actionType, details)=>{
    if (!actionType) return;
    return {
        action: {
            actionType: actionType,
            resourceIdentifiers: resourceIdentifiers
        },
        providerKey: extensionKey,
        details: details
    };
};
const $599db3951a68070c$var$extractAction = (response, id, actionOptions, appearance, origin, fireEvent, resolve)=>{
    const extensionKey = (0, $03JM4.getExtensionKey)(response);
    const data = response?.data;
    const actions = (0, $bT52P.default)(data);
    if (!extensionKey || actions.length === 0) return;
    const action = actions.find((item)=>item?.name === 'UpdateAction' && item?.refField === 'tag');
    if (!action || !action.resourceIdentifiers) return;
    const read = $599db3951a68070c$var$toInvokeRequest(extensionKey, action.resourceIdentifiers, action.dataRetrievalAction?.name);
    const url = (0, $3seWH.extractLink)(data);
    const invokePreviewAction = response ? (0, $5O37S.extractInvokePreviewAction)({
        actionOptions: actionOptions,
        appearance: appearance,
        fireEvent: fireEvent,
        id: id,
        onClose: resolve ? ()=>url && resolve(url, true) : undefined,
        origin: origin,
        response: response
    }) : undefined;
    const details = {
        id: id,
        url: url,
        invokePreviewAction: invokePreviewAction
    };
    const update = $599db3951a68070c$var$toInvokeRequest(extensionKey, action.resourceIdentifiers, action.dataUpdateAction?.name, details);
    return read || update ? {
        read: read,
        update: update
    } : undefined;
};
const $599db3951a68070c$var$extractState = (response, actionOptions, id, appearance, origin, fireEvent, resolve)=>{
    if (!response || !response.data) return;
    const lozenge = (0, $bpSSH.extractLozenge)(response?.data);
    if (!lozenge) return;
    if (!(0, $2fsAU.canShowAction)((0, $18DG7.CardAction).ChangeStatusAction, actionOptions)) return lozenge;
    const action = $599db3951a68070c$var$extractAction(response, id, actionOptions, appearance, origin, fireEvent, resolve);
    return {
        ...lozenge,
        action: action
    };
};
var $599db3951a68070c$export$2e2bcd8739ae039 = $599db3951a68070c$var$extractState;

});
parcelRegister("bpSSH", function(module, exports) {

$parcel$export(module.exports, "extractLozenge", () => $c2b51845c5984a0b$export$e5da155556a77bca);

var $dpM2S = parcelRequire("dpM2S");

var $8haf8 = parcelRequire("8haf8");

var $1Kr9e = parcelRequire("1Kr9e");

var $7ncIg = parcelRequire("7ncIg");

var $l5kRv = parcelRequire("l5kRv");
const $c2b51845c5984a0b$export$e5da155556a77bca = (jsonLd)=>{
    const type = (0, $dpM2S.extractType)(jsonLd);
    if (type) {
        if (type.includes('atlassian:Task')) {
            const jsonLdTask = jsonLd;
            const lozengeFromTag = (0, $1Kr9e.extractTag)(jsonLdTask);
            const lozengeFromStatus = (0, $7ncIg.extractTaskStatus)(jsonLdTask);
            const lozengeFromTaskType = $c2b51845c5984a0b$var$extractLozengeFromTaskType(jsonLdTask);
            return lozengeFromTag || lozengeFromStatus || lozengeFromTaskType;
        }
        if (type.includes('atlassian:UndefinedLink')) return {
            text: 'UNDEFINED',
            appearance: 'inprogress'
        };
        // casting it because `extractState` can safely handle missing properties
        return (0, $8haf8.extractState)(jsonLd);
    }
};
const $c2b51845c5984a0b$var$extractLozengeFromTaskType = (jsonLdTask)=>{
    const taskType = (0, $l5kRv.extractTaskType)(jsonLdTask);
    if (taskType && taskType.name) return {
        text: taskType.name,
        appearance: 'success'
    };
};

});
parcelRegister("8haf8", function(module, exports) {

$parcel$export(module.exports, "extractState", () => $76dc1be10470e17b$export$5e4074cbce6574c7);

var $9tSQF = parcelRequire("9tSQF");
// Maps accent color short names to their corresponding background and text colors
const $76dc1be10470e17b$var$lozengeAccentStyles = {
    blue: {
        backgroundColor: "var(--ds-background-accent-blue-subtler, #CCE0FF)",
        color: "var(--ds-text-accent-blue, #0055CC)"
    },
    gray: {
        backgroundColor: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
        color: "var(--ds-text-accent-gray, #44546F)"
    },
    green: {
        backgroundColor: "var(--ds-background-accent-green-subtler, #BAF3DB)",
        color: "var(--ds-text-accent-green, #216E4E)"
    },
    lime: {
        backgroundColor: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
        color: "var(--ds-text-accent-lime, #4C6B1F)"
    },
    magenta: {
        backgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
        color: "var(--ds-text-accent-magenta, #943D73)"
    },
    orange: {
        backgroundColor: "var(--ds-background-accent-orange-subtler, #FEDEC8)",
        color: "var(--ds-text-accent-orange, #A54800)"
    },
    purple: {
        backgroundColor: "var(--ds-background-accent-purple-subtler, #DFD8FD)",
        color: "var(--ds-text-accent-purple, #5E4DB2)"
    },
    red: {
        backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
        color: "var(--ds-text-accent-red, #AE2E24)"
    },
    teal: {
        backgroundColor: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
        color: "var(--ds-text-accent-teal, #206A83)"
    },
    yellow: {
        backgroundColor: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
        color: "var(--ds-text-accent-yellow, #7F5F01)"
    }
};
const $76dc1be10470e17b$export$5e4074cbce6574c7 = (jsonLd)=>{
    const state = jsonLd['atlassian:state'];
    if (state) {
        if (typeof state === 'string') {
            const linkState = state.toLowerCase();
            if (!(0, $9tSQF.OMIT_STATES).includes(linkState)) return {
                text: linkState,
                appearance: (0, $9tSQF.VALID_STATES)[linkState] || 'default'
            };
        } else if (state['@type'] === 'Link' || state['@type'] === 'Object') {
            if (state.name) {
                const accent = state.accent;
                return {
                    text: state.name,
                    appearance: state.appearance || 'default',
                    style: accent ? $76dc1be10470e17b$var$lozengeAccentStyles[accent] : undefined
                };
            }
        }
    }
};

});
parcelRegister("9tSQF", function(module, exports) {

$parcel$export(module.exports, "isValidAppearance", () => $ae66787404c6b4b4$export$ce6b5b303f8e3c99);
$parcel$export(module.exports, "VALID_STATES", () => $ae66787404c6b4b4$export$7b1deaaad25d1dc1);
$parcel$export(module.exports, "OMIT_STATES", () => $ae66787404c6b4b4$export$772610da74ddbc07);
const $ae66787404c6b4b4$var$VALID_APPEARANCES = [
    'default',
    'success',
    'removed',
    'inprogress',
    'new',
    'moved'
];
const $ae66787404c6b4b4$export$ce6b5b303f8e3c99 = (appearance)=>{
    return $ae66787404c6b4b4$var$VALID_APPEARANCES.indexOf(appearance) !== -1;
};
const $ae66787404c6b4b4$export$7b1deaaad25d1dc1 = {
    open: 'inprogress',
    merged: 'success',
    declined: 'removed',
    closed: 'success',
    draft: 'inprogress',
    archived: 'default'
};
const $ae66787404c6b4b4$export$772610da74ddbc07 = [
    'current'
];

});


parcelRegister("1Kr9e", function(module, exports) {

$parcel$export(module.exports, "extractTag", () => $00d711d353e3bb83$export$962a8da34cf78a4f);

var $9tSQF = parcelRequire("9tSQF");
const $00d711d353e3bb83$export$962a8da34cf78a4f = (jsonLd)=>{
    const tag = jsonLd.tag;
    if (tag) {
        if (typeof tag === 'string') return {
            text: tag,
            appearance: 'default'
        };
        else if (Array.isArray(tag)) {
            const tags = tag.map($00d711d353e3bb83$var$extractTagItem).filter((item)=>!!item);
            if (tags.length > 0) return tags.shift();
        } else return $00d711d353e3bb83$var$extractTagItem(tag);
    }
};
const $00d711d353e3bb83$var$extractTagItem = (tag)=>{
    if (typeof tag === 'string') return {
        text: tag,
        appearance: 'default'
    };
    else if (tag['@type'] === 'Link') {
        if (tag.name) return {
            text: tag.name,
            appearance: 'default'
        };
    } else if (tag.name) {
        const appearance = tag.appearance;
        return {
            text: tag.name,
            // Jira currently uses tag.appearance to set the lozenge color. Remove this
            // once we migrate them away from using this old spec.
            appearance: (0, $9tSQF.isValidAppearance)(appearance) && appearance || 'default'
        };
    }
};

});

parcelRegister("7ncIg", function(module, exports) {

$parcel$export(module.exports, "extractTaskStatus", () => $7aa28bf1d699e3b1$export$7698df1946deda72);
const $7aa28bf1d699e3b1$export$7698df1946deda72 = (jsonLd)=>{
    const taskStatus = jsonLd['atlassian:taskStatus'];
    if (taskStatus && taskStatus.name) return {
        text: taskStatus.name,
        appearance: 'success'
    };
};

});



parcelRegister("krByh", function(module, exports) {

$parcel$export(module.exports, "extractLatestCommit", () => $ce13437708ceefb0$export$f222392162cff0d8);
const $ce13437708ceefb0$export$f222392162cff0d8 = (jsonLd)=>{
    const latestCommit = jsonLd['atlassian:latestCommit'];
    if (typeof latestCommit === 'string') return latestCommit;
    if (latestCommit) //todo: change the properties to latestCommit.hash when BE is ready
    return latestCommit ? latestCommit.name : undefined;
};

});




parcelRegister("g7toL", function(module, exports) {

$parcel$export(module.exports, "getSimulatedBetterMetadata", () => $e227bf38409b8990$export$f87d357259b3b7c8);
$parcel$export(module.exports, "FlexibleCardUiOptions", () => $e227bf38409b8990$export$22ebf74c8bee4708);
$parcel$export(module.exports, "titleBlockOptions", () => $e227bf38409b8990$export$45bdb4108909a713);
$parcel$export(module.exports, "PreviewBlockOptions", () => $e227bf38409b8990$export$9671929f11bd4ad8);

var $5NtHI = parcelRequire("5NtHI");

var $1UXt3 = parcelRequire("1UXt3");

var $03JM4 = parcelRequire("03JM4");
const $e227bf38409b8990$var$baseTopMetadata = [
    {
        name: (0, $5NtHI.ElementName).ModifiedOn
    },
    {
        name: (0, $5NtHI.ElementName).AttachmentCount
    },
    {
        name: (0, $5NtHI.ElementName).SubscriberCount
    },
    {
        name: (0, $5NtHI.ElementName).VoteCount
    },
    {
        name: (0, $5NtHI.ElementName).DueOn
    },
    {
        name: (0, $5NtHI.ElementName).ReadTime
    }
];
const $e227bf38409b8990$var$baseBottomMetaData = [
    {
        name: (0, $5NtHI.ElementName).ReactCount
    },
    {
        name: (0, $5NtHI.ElementName).CommentCount
    },
    {
        name: (0, $5NtHI.ElementName).ViewCount
    },
    {
        name: (0, $5NtHI.ElementName).Priority
    },
    {
        name: (0, $5NtHI.ElementName).SubTasksProgress
    },
    {
        name: (0, $5NtHI.ElementName).ChecklistProgress
    }
];
const $e227bf38409b8990$export$f87d357259b3b7c8 = (cardDetails)=>{
    const extensionKey = (0, $03JM4.getExtensionKey)(cardDetails) ?? '';
    const data = cardDetails?.data;
    const defaultTitleMetadata = [
        {
            name: (0, $5NtHI.ElementName).State
        }
    ];
    const defaultTopMetadata = [
        {
            name: (0, $5NtHI.ElementName).AuthorGroup
        },
        {
            name: (0, $5NtHI.ElementName).CreatedBy
        },
        ...$e227bf38409b8990$var$baseTopMetadata
    ];
    const defaultBottomMetadata = $e227bf38409b8990$var$baseBottomMetaData;
    switch(extensionKey){
        case 'bitbucket-object-provider':
        case 'native-bitbucket-object-provider':
            const isFile = data['@type'].includes('schema:DigitalDocument');
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: isFile ? [
                    {
                        name: (0, $5NtHI.ElementName).LatestCommit
                    },
                    {
                        name: (0, $5NtHI.ElementName).CollaboratorGroup
                    },
                    {
                        name: (0, $5NtHI.ElementName).ModifiedOn
                    }
                ] : defaultTopMetadata,
                bottomMetadata: defaultBottomMetadata
            };
        case 'dragonfruit-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: (0, $1UXt3.extractOwnedBy)(data) ? [
                    {
                        name: (0, $5NtHI.ElementName).OwnedByGroup
                    },
                    {
                        name: (0, $5NtHI.ElementName).OwnedBy
                    },
                    ...$e227bf38409b8990$var$baseTopMetadata
                ] : defaultTopMetadata,
                bottomMetadata: [
                    {
                        name: (0, $5NtHI.ElementName).AppliedToComponentsCount
                    },
                    ...$e227bf38409b8990$var$baseBottomMetaData
                ]
            };
        case 'confluence-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: (0, $1UXt3.extractOwnedBy)(data) ? [
                    {
                        name: (0, $5NtHI.ElementName).OwnedByGroup
                    },
                    {
                        name: (0, $5NtHI.ElementName).OwnedBy
                    },
                    ...$e227bf38409b8990$var$baseTopMetadata
                ] : defaultTopMetadata,
                bottomMetadata: defaultBottomMetadata
            };
        case 'jira-object-provider':
            const isJiraTask = data['@type']?.includes('atlassian:Task') ?? false;
            const isJiraPlan = data['atlassian:ownedBy'] ? true : false;
            let topMetadata = [
                {
                    name: (0, $5NtHI.ElementName).AuthorGroup
                },
                {
                    name: (0, $5NtHI.ElementName).CreatedBy
                },
                {
                    name: (0, $5NtHI.ElementName).ModifiedOn
                }
            ];
            if (isJiraTask) topMetadata = [
                {
                    name: (0, $5NtHI.ElementName).AssignedToGroup
                },
                {
                    name: (0, $5NtHI.ElementName).AssignedTo
                },
                {
                    name: (0, $5NtHI.ElementName).ModifiedOn
                }
            ];
            else if (isJiraPlan) topMetadata = [
                {
                    name: (0, $5NtHI.ElementName).OwnedByGroup
                },
                {
                    name: (0, $5NtHI.ElementName).OwnedBy
                }
            ];
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: topMetadata,
                bottomMetadata: [
                    {
                        name: (0, $5NtHI.ElementName).StoryPoints
                    },
                    {
                        name: (0, $5NtHI.ElementName).Priority
                    },
                    {
                        name: (0, $5NtHI.ElementName).SubTasksProgress
                    }
                ]
            };
        case 'slack-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: [
                    {
                        name: (0, $5NtHI.ElementName).AuthorGroup
                    },
                    {
                        name: (0, $5NtHI.ElementName).SentOn
                    }
                ],
                bottomMetadata: [
                    {
                        name: (0, $5NtHI.ElementName).ReactCount
                    },
                    {
                        name: (0, $5NtHI.ElementName).CommentCount
                    }
                ]
            };
        case 'trello-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: [
                    {
                        name: (0, $5NtHI.ElementName).CollaboratorGroup
                    },
                    ...$e227bf38409b8990$var$baseTopMetadata
                ],
                bottomMetadata: defaultBottomMetadata
            };
        case 'legion-object-provider':
        case 'people-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: [
                    {
                        name: (0, $5NtHI.ElementName).AuthorGroup
                    },
                    {
                        name: (0, $5NtHI.ElementName).TeamMemberCount
                    },
                    {
                        name: (0, $5NtHI.ElementName).UserAttributes
                    },
                    ...$e227bf38409b8990$var$baseTopMetadata
                ],
                bottomMetadata: defaultBottomMetadata
            };
        default:
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: defaultTopMetadata,
                bottomMetadata: defaultBottomMetadata
            };
    }
};
const $e227bf38409b8990$export$22ebf74c8bee4708 = {
    hideElevation: true,
    hideLegacyButton: true,
    removeBlockRestriction: true
};
const $e227bf38409b8990$export$45bdb4108909a713 = {
    anchorTarget: '_self',
    position: (0, $5NtHI.SmartLinkPosition).Center,
    hideRetry: true,
    size: (0, $5NtHI.SmartLinkSize).Large
};
const $e227bf38409b8990$export$9671929f11bd4ad8 = {
    placement: (0, $5NtHI.MediaPlacement).Right,
    ignoreContainerPadding: true
};

});


parcelRegister("lc1jH", function(module, exports) {

$parcel$export(module.exports, "withFlexibleUIBlockCardStyle", () => $c6261e336be0cca4$export$36ce1a3a446661ab);
/* withFlexibleUIBlockCardStyle.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $c6261e336be0cca4$var$flexibleBlockCardStyle = null;
const $c6261e336be0cca4$export$36ce1a3a446661ab = (FlexibleBlockCardView)=>(props)=>{
        return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            className: (0, $hcewu.default)([
                "_1g96pd34 _1qo3h6cr"
            ]),
            children: /*#__PURE__*/ (0, $gt9Am.jsx)(FlexibleBlockCardView, {
                ...props
            })
        });
    };

});


parcelRegister("1uPx2", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5e11d03c412e160$export$2e2bcd8739ae039);
/* ForbiddenView.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $lRq8t = parcelRequire("lRq8t");

var $ftN6c = parcelRequire("ftN6c");

var $9QgTI = parcelRequire("9QgTI");

var $jFH1h = parcelRequire("jFH1h");

var $hy9OT = parcelRequire("hy9OT");

var $7r0tl = parcelRequire("7r0tl");

var $4Qxcv = parcelRequire("4Qxcv");

var $19nmp = parcelRequire("19nmp");

var $idDkX = parcelRequire("idDkX");

var $gA511 = parcelRequire("gA511");

var $38cBa = parcelRequire("38cBa");

var $fPNY3 = parcelRequire("fPNY3");

var $dXXLc = parcelRequire("dXXLc");

var $lc1jH = parcelRequire("lc1jH");
const $c5e11d03c412e160$var$textStyles = null;
/**
 * This view represent a Block Card with the 'Forbidden' status.
 * It should have a "Try another account" button that will allow a user to connect another account and view the block card.
 *
 * @see SmartLinkStatus
 * @see FlexibleCardProps
 */ const $c5e11d03c412e160$var$ForbiddenView = ({ testId: testId = 'smart-block-forbidden-view', ...props })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const intl = (0, $lRq8t.default)();
    const { cardState: cardState, onAuthorize: onAuthorize, url: url } = props;
    const details = cardState?.details;
    const cardMetadata = details?.meta ?? (0, $gA511.getForbiddenJsonLd)().meta;
    const provider = (0, $hy9OT.extractSmartLinkProvider)(details);
    const providerName = provider?.text || '';
    const messageContext = (0, $eJOHy.useMemo)(()=>{
        const hostname = /*#__PURE__*/ (0, $gt9Am.jsx)("b", {
            children: (0, $4Qxcv.default)(url)
        });
        return {
            product: providerName,
            hostname: hostname
        };
    }, [
        providerName,
        url
    ]);
    const requestAccessContext = (0, $eJOHy.useMemo)(()=>{
        return (0, $7r0tl.extractRequestAccessContextImproved)({
            jsonLd: cardMetadata,
            url: url,
            product: providerName,
            createAnalyticsEvent: createAnalyticsEvent
        });
    }, [
        cardMetadata,
        providerName,
        url,
        createAnalyticsEvent
    ]);
    const title = (0, $eJOHy.useMemo)(()=>{
        const descriptor = (0, $idDkX.toMessage)((0, $19nmp.messages).invalid_permissions, requestAccessContext?.titleMessageKey);
        return intl.formatMessage(descriptor, {
            product: providerName
        });
    }, [
        intl,
        providerName,
        requestAccessContext?.titleMessageKey
    ]);
    const actions = (0, $eJOHy.useMemo)(()=>{
        let actionFromAccessContext = [];
        const tryAnotherAccountAction = onAuthorize ? [
            (0, $fPNY3.ForbiddenAction)(onAuthorize, 'try_another_account')
        ] : [];
        if (requestAccessContext) {
            const { action: action, callToActionMessageKey: callToActionMessageKey } = requestAccessContext;
            actionFromAccessContext = action && callToActionMessageKey ? [
                (0, $fPNY3.ForbiddenAction)(action.promise, callToActionMessageKey, messageContext, requestAccessContext?.buttonDisabled)
            ] : [];
        }
        return [
            ...tryAnotherAccountAction,
            ...actionFromAccessContext
        ];
    }, [
        onAuthorize,
        requestAccessContext,
        messageContext
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $dXXLc.default), {
        ...props,
        actions: actions,
        showPreview: true,
        testId: testId,
        title: title,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9QgTI))), {
                label: "forbidden-lock-icon",
                color: "var(--ds-icon-danger, #C9372C)",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($jFH1h))),
                LEGACY_size: "small",
                testId: `${testId}-lock-icon`
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
                maxLines: 3,
                message: {
                    descriptor: (0, $idDkX.toMessage)((0, $19nmp.messages).invalid_permissions_description, requestAccessContext?.descriptiveMessageKey),
                    values: messageContext
                },
                className: (0, $hcewu.default)([
                    "_syaz1fxt"
                ])
            })
        ]
    });
};
var $c5e11d03c412e160$export$2e2bcd8739ae039 = (0, $lc1jH.withFlexibleUIBlockCardStyle)($c5e11d03c412e160$var$ForbiddenView);

});
parcelRegister("9QgTI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::86c9de42fef4ccbc35a6164a0094138a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $72a613e9f42e1e21$var$_react = $72a613e9f42e1e21$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $72a613e9f42e1e21$var$_baseNew = $72a613e9f42e1e21$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $72a613e9f42e1e21$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LockLocked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: secure password in textfields, locked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $72a613e9f42e1e21$var$LockLockedIcon = (props)=>/*#__PURE__*/ $72a613e9f42e1e21$var$_react.default.createElement($72a613e9f42e1e21$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A2.5 2.5 0 0 0 5.5 4v3h5V4A2.5 2.5 0 0 0 8 1.5M12 7V4a4 4 0 0 0-8 0v3a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2M4 8.5a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5zM7.25 13v-3h1.5v3z" clip-rule="evenodd"/>`
    }, props));
$72a613e9f42e1e21$var$LockLockedIcon.displayName = 'LockLockedIcon';
var $72a613e9f42e1e21$var$_default = module.exports.default = $72a613e9f42e1e21$var$LockLockedIcon;

});

parcelRegister("jFH1h", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e523377710580c71$var$_react = $e523377710580c71$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $e523377710580c71$var$_lockLocked = $e523377710580c71$var$_interopRequireDefault((parcelRequire("9QgTI")));
function $e523377710580c71$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e523377710580c71$var$LockIcon = (props)=>/*#__PURE__*/ $e523377710580c71$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M16 11V9h-2V7.002A2 2 0 0 0 12 5c-1.102 0-2 .898-2 2.002V9H8v2H7v8h10v-8zm-2 0h-4V9h4zM8 9V7.002A4.004 4.004 0 0 1 12 3a4 4 0 0 1 4 4.002V9h.994A2.01 2.01 0 0 1 19 11.009v7.982c0 1.11-.897 2.009-2.006 2.009H7.006A2.01 2.01 0 0 1 5 18.991V11.01C5 9.899 5.897 9 7.006 9zm0 0h2v2H8zm6 0h2v2h-2z"/><circle cx="12" cy="15" r="2"/></g></svg>`
    }, props, {
        newIcon: $e523377710580c71$var$_lockLocked.default
    }));
$e523377710580c71$var$LockIcon.displayName = 'LockIcon';
var $e523377710580c71$var$_default = module.exports.default = $e523377710580c71$var$LockIcon;

});

parcelRegister("idDkX", function(module, exports) {

$parcel$export(module.exports, "toMessage", () => $d5f398015422946e$export$d14c2a6dee946f52);

var $19nmp = parcelRequire("19nmp");
const $d5f398015422946e$export$d14c2a6dee946f52 = (defaultMessage, key)=>{
    try {
        if (key !== undefined && key in (0, $19nmp.messages)) return (0, $19nmp.messages)[key];
        return defaultMessage;
    } catch  {
        return defaultMessage;
    }
};

});

parcelRegister("fPNY3", function(module, exports) {

$parcel$export(module.exports, "ForbiddenAction", () => $f4b684ab7f00a73c$export$59f8830fb5467e35);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");
const $f4b684ab7f00a73c$export$59f8830fb5467e35 = (onClick, content, context, isDisabled)=>({
        name: (0, $5NtHI.ActionName).CustomAction,
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages)[content],
            values: context
        }),
        onClick: onClick,
        testId: 'smart-action-connect-other-account',
        isDisabled: isDisabled
    });

});


parcelRegister("eB1dU", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa49cd5b8f02fcca$export$2e2bcd8739ae039);
/* NotFoundView.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $lRq8t = parcelRequire("lRq8t");

var $9QgTI = parcelRequire("9QgTI");

var $jFH1h = parcelRequire("jFH1h");

var $hy9OT = parcelRequire("hy9OT");

var $19nmp = parcelRequire("19nmp");

var $38cBa = parcelRequire("38cBa");

var $dXXLc = parcelRequire("dXXLc");

var $lc1jH = parcelRequire("lc1jH");
const $aa49cd5b8f02fcca$var$textStyles = null;
/**
 * This view represents a Block Card with a 'Not_Found' status.
 *
 * @see SmartLinkStatus
 * @see FlexibleCardProps
 */ const $aa49cd5b8f02fcca$var$NotFoundView = ({ testId: testId = 'smart-block-not-found-view', ...props })=>{
    const intl = (0, $lRq8t.default)();
    const { cardState: { details: details } } = props;
    const product = (0, $eJOHy.useMemo)(()=>{
        const provider = (0, $hy9OT.extractSmartLinkProvider)(details);
        return provider?.text ?? '';
    }, [
        details
    ]);
    const title = (0, $eJOHy.useMemo)(()=>intl.formatMessage((0, $19nmp.messages).not_found_title, {
            product: product
        }), [
        intl,
        product
    ]);
    const description = (0, $eJOHy.useMemo)(()=>({
            descriptor: (0, $19nmp.messages).not_found_description
        }), []);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $dXXLc.default), {
        ...props,
        testId: testId,
        title: title,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9QgTI))), {
                label: "not-found-lock-icon",
                color: "var(--ds-icon-danger, #C9372C)",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($jFH1h))),
                LEGACY_size: "small",
                testId: `${testId}-lock-icon`
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $38cBa.default), {
                message: description,
                testId: `${testId}-message`,
                maxLines: 3,
                className: (0, $hcewu.default)([
                    "_syaz1fxt"
                ])
            })
        ]
    });
};
var $aa49cd5b8f02fcca$export$2e2bcd8739ae039 = (0, $lc1jH.withFlexibleUIBlockCardStyle)($aa49cd5b8f02fcca$var$NotFoundView);

});

parcelRegister("8jMdw", function(module, exports) {

$parcel$export(module.exports, "default", () => $d529b5b9d214a4cd$export$2e2bcd8739ae039);
/* ResolvedView.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $8GnsF = parcelRequire("8GnsF");

var $eGOwo = parcelRequire("eGOwo");

var $5NtHI = parcelRequire("5NtHI");

var $19G04 = parcelRequire("19G04");

var $lAF2k = parcelRequire("lAF2k");
var $gKsxm = parcelRequire("gKsxm");
var $8Rjtc = parcelRequire("8Rjtc");
var $5gb8b = parcelRequire("5gb8b");
var $fqBfo = parcelRequire("fqBfo");

var $g7toL = parcelRequire("g7toL");

var $lc1jH = parcelRequire("lc1jH");
const $d529b5b9d214a4cd$var$titleBlockCss = null;
const $d529b5b9d214a4cd$var$footerBlockCss = null;
const $d529b5b9d214a4cd$var$footerBlockSafariStyles = null;
/**
 * This view represents a Block card that has an 'Resolved' status.
 * @see SmartLinkStatus
 * @see FlexibleCardProps
 */ const $d529b5b9d214a4cd$var$ResolvedView = ({ cardState: cardState, onClick: onClick, onError: onError, onResolve: onResolve, actionOptions: actionOptions, testId: testId = 'smart-block-resolved-view', url: url, CompetitorPrompt: CompetitorPrompt, hideIconLoadingSkeleton: hideIconLoadingSkeleton })=>{
    const [isPreviewBlockErrored, setIsPreviewBlockErrored] = (0, $eJOHy.useState)(false);
    const { safari: safari = false } = (0, $eGOwo.fg)('platform-linking-visual-refresh-v2') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eJOHy.useMemo)(()=>(0, $8GnsF.browser)(), []) : {};
    (0, $eJOHy.useEffect)(()=>{
        setIsPreviewBlockErrored(false);
    }, [
        url,
        cardState
    ]);
    const { titleMetadata: titleMetadata, topMetadata: topMetadata, bottomMetadata: bottomMetadata } = (0, $g7toL.getSimulatedBetterMetadata)(cardState.details);
    const footerActions = (0, $eJOHy.useMemo)(()=>[
            {
                name: (0, $5NtHI.ActionName).FollowAction,
                hideIcon: true
            },
            {
                name: (0, $5NtHI.ActionName).PreviewAction,
                hideIcon: true
            },
            {
                name: (0, $5NtHI.ActionName).DownloadAction,
                hideIcon: true
            }
        ], []);
    const uiOptions = (0, $g7toL.FlexibleCardUiOptions);
    if ((0, $eGOwo.fg)('cc-ai-linking-platform-snippet-renderer')) uiOptions.enableSnippetRenderer = true;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $19G04.default), {
        appearance: "block",
        cardState: cardState,
        onClick: onClick,
        onError: onError,
        onResolve: onResolve,
        origin: "smartLinkCard",
        actionOptions: actionOptions,
        testId: testId,
        ui: uiOptions,
        url: url,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fqBfo.default), {
                ...(0, $g7toL.titleBlockOptions),
                metadata: titleMetadata,
                subtitle: [
                    {
                        name: (0, $5NtHI.ElementName).Location
                    }
                ],
                metadataPosition: (0, $5NtHI.SmartLinkPosition).Top,
                CompetitorPrompt: CompetitorPrompt,
                url: url,
                hideIconLoadingSkeleton: hideIconLoadingSkeleton,
                className: (0, $hcewu.default)([
                    "_zulpu2gc _13mh1pd9 _2yhz14q2"
                ])
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gKsxm.default), {
                primary: topMetadata,
                maxLines: 1
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5gb8b.default), {}),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gKsxm.default), {
                primary: bottomMetadata,
                maxLines: 1
            }),
            !isPreviewBlockErrored ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8Rjtc.default), {
                ...(0, $g7toL.PreviewBlockOptions),
                onError: ()=>{
                    setIsPreviewBlockErrored(true);
                }
            }) : null,
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lAF2k.default), {
                actions: footerActions,
                className: (0, $hcewu.default)([
                    "_4t3i1k8s _1e0c1txw _1bah1yb4 _4cvresu3 _1wpz1fhb",
                    safari && (0, $eGOwo.fg)('platform-linking-visual-refresh-v2') && "_4t3i1osq"
                ])
            })
        ]
    });
};
var $d529b5b9d214a4cd$export$2e2bcd8739ae039 = (0, $lc1jH.withFlexibleUIBlockCardStyle)($d529b5b9d214a4cd$var$ResolvedView);

});

parcelRegister("4fOPS", function(module, exports) {

$parcel$export(module.exports, "default", () => $1855e7f6748dd65c$export$2e2bcd8739ae039);
/* UnauthorisedView.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $kDaaB = parcelRequire("kDaaB");

var $hy9OT = parcelRequire("hy9OT");

var $bmWcp = parcelRequire("bmWcp");

var $19nmp = parcelRequire("19nmp");

var $03JM4 = parcelRequire("03JM4");

var $5z6NJ = parcelRequire("5z6NJ");

var $6Xgel = parcelRequire("6Xgel");

var $dXXLc = parcelRequire("dXXLc");

var $lc1jH = parcelRequire("lc1jH");
const $1855e7f6748dd65c$var$contentStyles = null;
/**
 * This view represents a Block card that has an 'Unauthorized' status .
 * It should have a "Connect" button that will allow a user to connect their account and view the block card.
 *
 * @see SmartLinkStatus
 * @see FlexibleCardProps
 */ const $1855e7f6748dd65c$var$UnauthorisedView = ({ testId: testId = 'smart-block-unauthorized-view', ...props })=>{
    const { cardState: cardState, onAuthorize: onAuthorize } = props;
    const providerName = (0, $hy9OT.extractSmartLinkProvider)(cardState.details)?.text;
    const isProductIntegrationSupported = (0, $03JM4.hasAuthScopeOverrides)(cardState.details);
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const handleAuthorize = (0, $eJOHy.useCallback)(()=>{
        if (onAuthorize) {
            fireEvent('track.applicationAccount.authStarted', {});
            onAuthorize();
        }
    }, [
        onAuthorize,
        fireEvent
    ]);
    const content = (0, $eJOHy.useMemo)(()=>onAuthorize ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5z6NJ.default), {
            providerName: providerName,
            isProductIntegrationSupported: isProductIntegrationSupported,
            testId: testId
        }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages)[providerName ? 'unauthorised_account_description' : 'unauthorised_account_description_no_provider'],
            values: {
                context: providerName
            }
        }), [
        isProductIntegrationSupported,
        onAuthorize,
        providerName,
        testId
    ]);
    const actions = (0, $eJOHy.useMemo)(()=>onAuthorize ? [
            (0, $6Xgel.AuthorizeAction)(handleAuthorize, providerName)
        ] : [], [
        handleAuthorize,
        onAuthorize,
        providerName
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dXXLc.default), {
        ...props,
        actions: actions,
        testId: testId,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            "data-testid": `${testId}-content`,
            className: (0, $hcewu.default)([
                "_11c8dcr7 _syaz1fxt _19pku2gc"
            ]),
            children: content
        })
    });
};
var $1855e7f6748dd65c$export$2e2bcd8739ae039 = (0, $lc1jH.withFlexibleUIBlockCardStyle)($1855e7f6748dd65c$var$UnauthorisedView);

});
parcelRegister("6Xgel", function(module, exports) {

$parcel$export(module.exports, "AuthorizeAction", () => $3bad804239ca8758$export$34cef2b72294bd84);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $5NtHI = parcelRequire("5NtHI");

var $19nmp = parcelRequire("19nmp");
const $3bad804239ca8758$export$34cef2b72294bd84 = (onAuthorize, providerName)=>({
        appearance: 'primary',
        name: (0, $5NtHI.ActionName).CustomAction,
        content: providerName ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).connect_unauthorised_account_action,
            values: {
                context: providerName
            }
        }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).connect_link_account_card
        }),
        onClick: onAuthorize,
        testId: 'smart-action-connect-account'
    });

});



parcelRegister("9uyEx", function(module, exports) {

$parcel$export(module.exports, "EmbedCard", () => $05d9abb62f80e331$export$6789d7ecdc77631b);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $eGOwo = parcelRequire("eGOwo");

var $dLR8J = parcelRequire("dLR8J");

var $7r0tl = parcelRequire("7r0tl");

var $7AKPz = parcelRequire("7AKPz");

var $aRZRK = parcelRequire("aRZRK");

var $03JM4 = parcelRequire("03JM4");

var $9gzoR = parcelRequire("9gzoR");

var $gA511 = parcelRequire("gA511");

var $4UV7R = parcelRequire("4UV7R");

var $8jMdw = parcelRequire("8jMdw");

var $eIvWj = parcelRequire("eIvWj");

var $hFl6W = parcelRequire("hFl6W");

var $i53U1 = parcelRequire("i53U1");

var $5RX8x = parcelRequire("5RX8x");

var $h9g6U = parcelRequire("h9g6U");

var $iUsXM = parcelRequire("iUsXM");
const $05d9abb62f80e331$var$UFOLoadHoldWrapper = ({ children: children })=>{
    return (0, $eGOwo.fg)('platform_renderer_blindspots') ? /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dLR8J.default), {
                name: "smart-card-embed-card"
            }),
            children
        ]
    }) : children;
};
const $05d9abb62f80e331$export$6789d7ecdc77631b = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef(({ url: url, cardState: cardState, handleAuthorize: handleAuthorize, handleErrorRetry: handleErrorRetry, handleFrameClick: handleFrameClick, isSelected: isSelected, frameStyle: frameStyle, platform: platform, onResolve: onResolve, onError: onError, testId: testId, inheritDimensions: inheritDimensions, onIframeDwell: onIframeDwell, onIframeFocus: onIframeFocus, iframeUrlType: iframeUrlType, actionOptions: actionOptions, renderers: renderers, CompetitorPrompt: CompetitorPrompt }, iframeRef)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { status: status, details: details } = cardState;
    const extensionKey = (0, $03JM4.getExtensionKey)(details);
    const isProductIntegrationSupported = (0, $03JM4.hasAuthScopeOverrides)(details);
    const { shouldControlDataExport: shouldControlDataExport = false } = (0, $9gzoR.useControlDataExportConfig)();
    switch(status){
        case 'pending':
        case 'resolving':
            return /*#__PURE__*/ (0, $gt9Am.jsx)($05d9abb62f80e331$var$UFOLoadHoldWrapper, {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8jMdw.default), {
                    url: url,
                    cardState: cardState,
                    onClick: handleFrameClick,
                    onError: onError,
                    onResolve: onResolve,
                    renderers: renderers,
                    actionOptions: actionOptions,
                    testId: testId ? `${testId}-resolving-view` : 'embed-card-resolving-view'
                })
            });
        case 'resolved':
            const resolvedViewProps = (0, $7AKPz.extractEmbedProps)(details, platform, iframeUrlType);
            if (onResolve) onResolve({
                title: resolvedViewProps.title,
                url: url,
                aspectRatio: resolvedViewProps.preview?.aspectRatio
            });
            if ((0, $eGOwo.fg)('platform_smart_links_controlled_dsp_export_view')) {
                if ((0, $4UV7R.getIsDataExportEnabled)(shouldControlDataExport, cardState.details)) {
                    const unauthViewProps = (0, $7AKPz.extractEmbedProps)(details, platform);
                    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iUsXM.default), {
                        context: unauthViewProps.context,
                        extensionKey: extensionKey,
                        frameStyle: frameStyle,
                        isProductIntegrationSupported: isProductIntegrationSupported,
                        inheritDimensions: inheritDimensions,
                        isSelected: isSelected,
                        onAuthorize: handleAuthorize,
                        onClick: handleFrameClick,
                        testId: testId,
                        url: unauthViewProps.link
                    });
                }
            }
            if (resolvedViewProps.preview) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $h9g6U.EmbedCardResolvedView), {
                ...resolvedViewProps,
                isSelected: isSelected,
                frameStyle: frameStyle,
                inheritDimensions: inheritDimensions,
                onClick: handleFrameClick,
                ref: iframeRef,
                onIframeDwell: onIframeDwell,
                onIframeFocus: onIframeFocus,
                testId: testId,
                CompetitorPrompt: CompetitorPrompt
            });
            else {
                if (platform === 'mobile') {
                    const resolvedInlineViewProps = (0, $aRZRK.extractInlineProps)(details);
                    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eIvWj.InlineCardResolvedView), {
                        ...resolvedInlineViewProps,
                        isSelected: isSelected,
                        testId: testId,
                        onClick: handleFrameClick
                    });
                }
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8jMdw.default), {
                    url: url,
                    cardState: cardState,
                    onClick: handleFrameClick,
                    onError: onError,
                    onResolve: onResolve,
                    renderers: renderers,
                    actionOptions: actionOptions,
                    testId: testId
                });
            }
        case 'unauthorized':
            if (onError) onError({
                url: url,
                status: status
            });
            const unauthorisedViewProps = (0, $7AKPz.extractEmbedProps)(details, platform);
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iUsXM.default), {
                context: unauthorisedViewProps.context,
                extensionKey: extensionKey,
                frameStyle: frameStyle,
                isProductIntegrationSupported: isProductIntegrationSupported,
                inheritDimensions: inheritDimensions,
                isSelected: isSelected,
                onAuthorize: handleAuthorize,
                onClick: handleFrameClick,
                testId: testId,
                url: unauthorisedViewProps.link
            });
        case 'forbidden':
            if (onError) onError({
                url: url,
                status: status
            });
            const forbiddenViewProps = (0, $7AKPz.extractEmbedProps)(details, platform);
            const cardMetadata = details?.meta ?? (0, $gA511.getForbiddenJsonLd)().meta;
            if (forbiddenViewProps.preview) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $h9g6U.EmbedCardResolvedView), {
                ...forbiddenViewProps,
                title: forbiddenViewProps.link,
                frameStyle: frameStyle,
                isSelected: isSelected,
                inheritDimensions: inheritDimensions,
                onClick: handleFrameClick,
                ref: iframeRef
            });
            const forbiddenAccessContext = (0, $7r0tl.extractRequestAccessContextImproved)({
                jsonLd: cardMetadata,
                url: url,
                product: forbiddenViewProps.context?.text ?? '',
                createAnalyticsEvent: createAnalyticsEvent
            });
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $i53U1.default), {
                context: forbiddenViewProps.context,
                frameStyle: frameStyle,
                inheritDimensions: inheritDimensions,
                isSelected: isSelected,
                onAuthorize: handleAuthorize,
                onClick: handleFrameClick,
                accessContext: forbiddenAccessContext,
                url: forbiddenViewProps.link
            });
        case 'not_found':
            if (onError) onError({
                url: url,
                status: status
            });
            const notFoundViewProps = (0, $7AKPz.extractEmbedProps)(details, platform);
            const notFoundAccessContext = details?.meta ? (0, $7r0tl.extractRequestAccessContextImproved)({
                jsonLd: details?.meta,
                url: url,
                product: notFoundViewProps.context?.text ?? '',
                createAnalyticsEvent: createAnalyticsEvent
            }) : undefined;
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5RX8x.default), {
                context: notFoundViewProps.context,
                frameStyle: frameStyle,
                inheritDimensions: inheritDimensions,
                isSelected: isSelected,
                onClick: handleFrameClick,
                accessContext: notFoundAccessContext,
                url: notFoundViewProps.link
            });
        case 'fallback':
        case 'errored':
        default:
            if (onError) onError({
                url: url,
                status: status
            });
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hFl6W.EmbedCardErroredView), {
                onRetry: handleErrorRetry,
                inheritDimensions: inheritDimensions,
                isSelected: isSelected
            });
    }
});

});
parcelRegister("7AKPz", function(module, exports) {

$parcel$export(module.exports, "extractEmbedProps", () => $bddb5ab530f782ff$export$d6cf81ca6e68bcc3);

var $6OR2o = parcelRequire("6OR2o");
var $hy9OT = parcelRequire("hy9OT");
var $dpM2S = parcelRequire("dpM2S");

var $eGOwo = parcelRequire("eGOwo");

var $gA511 = parcelRequire("gA511");

var $9xgNQ = parcelRequire("9xgNQ");

var $b5GVx = parcelRequire("b5GVx");

var $1jpb6 = parcelRequire("1jpb6");
const $bddb5ab530f782ff$var$extractEmbedPreview = (jsonLd, platform, iframeUrlType)=>{
    const preview = (0, $6OR2o.extractPreview)(jsonLd, platform, iframeUrlType);
    if (preview && preview.src) return {
        ...preview,
        src: preview.src
    };
};
const $bddb5ab530f782ff$export$d6cf81ca6e68bcc3 = (response, platform, iframeUrlType)=>{
    const meta = response?.meta;
    const jsonLd = response?.data || (0, $gA511.getEmptyJsonLd)();
    return {
        link: (0, $hy9OT.extractSmartLinkUrl)(response) || '',
        title: (0, $hy9OT.extractSmartLinkTitle)(response),
        context: (0, $9xgNQ.extractSmartLinkContext)(response),
        preview: (0, $eGOwo.fg)('smart_links_noun_support') ? (0, $hy9OT.extractSmartLinkEmbed)(response, iframeUrlType) : $bddb5ab530f782ff$var$extractEmbedPreview(jsonLd, platform, iframeUrlType),
        isTrusted: (0, $1jpb6.extractIsTrusted)(meta),
        isSupportTheming: (0, $b5GVx.extractIsSupportTheming)(meta),
        ...(0, $eGOwo.fg)('platform-linking-visual-refresh-v2') && {
            type: (0, $dpM2S.extractType)(jsonLd)
        }
    };
};

});
parcelRegister("9xgNQ", function(module, exports) {

$parcel$export(module.exports, "extractSmartLinkContext", () => $81938710ecd918a9$export$6ec4b6b24dec9156);

var $3jSKi = parcelRequire("3jSKi");
var $9Thyx = parcelRequire("9Thyx");
var $4moW4 = parcelRequire("4moW4");

var $gA511 = parcelRequire("gA511");

var $abbo9 = parcelRequire("abbo9");

var $7r0tl = parcelRequire("7r0tl");
function $81938710ecd918a9$export$8dcb07487061d3c1(jsonLd) {
    const provider = (0, $9Thyx.extractProvider)(jsonLd);
    if (!provider) return undefined;
    // If no icon is supplied, return existing context
    if (!jsonLd.icon) return provider;
    const generator = jsonLd.generator;
    const icon = (0, $abbo9.prioritiseIcon)({
        fileFormatIcon: undefined,
        documentTypeIcon: undefined,
        urlIcon: (0, $4moW4.extractUrlFromIconJsonLd)(jsonLd.icon),
        // We still attempt to follow the icon priority function even if no generator (and therefore provider icon) is defined
        providerIcon: generator && typeof generator !== 'string' && generator['@type'] !== 'Link' && (0, $9Thyx.extractProviderIcon)(generator.icon)
    });
    return {
        ...provider,
        icon: icon ? icon : provider.icon
    };
}
function $81938710ecd918a9$export$6ec4b6b24dec9156(response) {
    if ((0, $3jSKi.isEntityPresent)(response)) return (0, $3jSKi.extractEntityProvider)(response);
    return $81938710ecd918a9$export$8dcb07487061d3c1(response?.data || (0, $gA511.getEmptyJsonLd)());
}

});


parcelRegister("aRZRK", function(module, exports) {

$parcel$export(module.exports, "extractInlineProps", () => $56b7d71381ad586c$export$68e1703c529dc7e0);

var $3jSKi = parcelRequire("3jSKi");
var $9Thyx = parcelRequire("9Thyx");
var $hy9OT = parcelRequire("hy9OT");
var $dpM2S = parcelRequire("dpM2S");

var $eGOwo = parcelRequire("eGOwo");

var $gA511 = parcelRequire("gA511");

var $k4P1T = parcelRequire("k4P1T");

var $bpSSH = parcelRequire("bpSSH");

var $7BqfG = parcelRequire("7BqfG");

var $gxXx6 = parcelRequire("gxXx6");

var $3DgO9 = parcelRequire("3DgO9");
const $56b7d71381ad586c$var$extractInlineIcon = (jsonLd, showIconLabel = true)=>{
    const provider = (0, $9Thyx.extractProvider)(jsonLd);
    if (provider && provider.id) {
        if (provider.id === (0, $3DgO9.CONFLUENCE_GENERATOR_ID) || provider.id === (0, $3DgO9.JIRA_GENERATOR_ID)) return (0, $k4P1T.extractIcon)(jsonLd, 'type', showIconLabel);
    }
    return (0, $k4P1T.extractIcon)(jsonLd, 'provider', showIconLabel);
};
/**
 * Should be moved to the smart link-extractor when jsonld is deprecated
 */ const $56b7d71381ad586c$var$extractSmartLinkInlineIcon = (response, showLabel = true)=>{
    if ((0, $3jSKi.isEntityPresent)(response)) {
        const provider = (0, $3jSKi.extractEntityProvider)(response);
        if (provider) return provider.icon;
    // We don't need this for design entities,
    // but we can add it back when we support more entities
    // it requires extractInlineIcon to be moved to the smart link extractor package.
    // see: https://product-fabric.atlassian.net/browse/EDM-12375
    // return extractSmartLinkIcon(response);
    }
    return $56b7d71381ad586c$var$extractInlineIcon(response?.data || (0, $gA511.getEmptyJsonLd)(), showLabel);
};
const $56b7d71381ad586c$export$68e1703c529dc7e0 = (response, renderers, removeTextHighlightingFromTitle, showLabel = true)=>{
    const jsonLd = response?.data || (0, $gA511.getEmptyJsonLd)();
    return {
        link: (0, $hy9OT.extractSmartLinkUrl)(response),
        title: (0, $hy9OT.extractSmartLinkTitle)(response, removeTextHighlightingFromTitle),
        icon: $56b7d71381ad586c$var$extractSmartLinkInlineIcon(response, showLabel),
        // As we migrate to support more entities we can incorporate these fields
        lozenge: (0, $bpSSH.extractLozenge)(jsonLd),
        titleTextColor: (0, $7BqfG.extractTitleTextColor)(jsonLd),
        titlePrefix: (0, $gxXx6.extractTitlePrefix)(jsonLd, renderers, 'inline'),
        ...(0, $eGOwo.fg)('platform-linking-visual-refresh-v2') && {
            type: (0, $dpM2S.extractType)(jsonLd)
        }
    };
};

});
parcelRegister("k4P1T", function(module, exports) {

$parcel$export(module.exports, "extractIcon", () => $0a1959a1b48f0e49$export$64bdf1f5e49e8626);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $liS9g = parcelRequire("liS9g");

var $gSqCA = parcelRequire("gSqCA");

var $6wUJL = parcelRequire("6wUJL");

var $es92x = parcelRequire("es92x");

var $cOjgE = parcelRequire("cOjgE");

var $lG2jM = parcelRequire("lG2jM");

var $9Thyx = parcelRequire("9Thyx");
var $8T839 = parcelRequire("8T839");
var $4moW4 = parcelRequire("4moW4");

var $FoFt2 = parcelRequire("FoFt2");

var $l5kRv = parcelRequire("l5kRv");

var $ip2tE = parcelRequire("ip2tE");

var $l8s0O = parcelRequire("l8s0O");

var $1yraT = parcelRequire("1yraT");

var $abbo9 = parcelRequire("abbo9");

var $aDkpj = parcelRequire("aDkpj");
const $0a1959a1b48f0e49$export$64bdf1f5e49e8626 = (jsonLd, priority = 'type', showIconLabel = true)=>{
    const type = jsonLd['@type'];
    const opts = {
        title: (0, $8T839.extractTitle)(jsonLd),
        provider: (0, $9Thyx.extractProvider)(jsonLd),
        fileFormat: (0, $ip2tE.extractFileFormat)(jsonLd),
        taskType: (0, $l5kRv.extractTaskType)(jsonLd),
        icon: jsonLd.icon && (0, $4moW4.extractUrlFromIconJsonLd)(jsonLd.icon),
        priority: priority,
        showIconLabel: showIconLabel
    };
    if (Array.isArray(type)) {
        const highestPriorityType = type.sort((a, b)=>(0, $aDkpj.extractorPriorityMap)[b] - (0, $aDkpj.extractorPriorityMap)[a])[0];
        return $0a1959a1b48f0e49$var$extractIconByType(highestPriorityType, opts);
    } else return $0a1959a1b48f0e49$var$extractIconByType(type, opts);
};
function $0a1959a1b48f0e49$var$typeToIcon(type, opts) {
    switch(type){
        case 'atlassian:SourceCodeCommit':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6wUJL.default), {
                label: opts.title || 'commit',
                testId: "commit-icon"
            });
        case 'atlassian:Project':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lG2jM))), {
                label: opts.title || 'project',
                LEGACY_size: "small",
                testId: "project-icon",
                color: "currentColor"
            });
        case 'atlassian:SourceCodePullRequest':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $es92x.default), {
                label: opts.title || 'pullRequest',
                testId: "pull-request-icon"
            });
        case 'atlassian:SourceCodeReference':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $liS9g.default), {
                label: opts.title || 'reference',
                testId: "branch-icon"
            });
        case 'atlassian:SourceCodeRepository':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gSqCA.default), {
                label: opts.title || 'repository',
                testId: "repo-icon"
            });
        case 'atlassian:Goal':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cOjgE.default), {
                label: opts.title || 'goal',
                testId: "task-icon"
            });
        case 'atlassian:Task':
            return (0, $1yraT.extractIconFromTask)(opts);
        default:
            return undefined;
    }
}
function $0a1959a1b48f0e49$var$standardisedExtractIcon(type, opts) {
    const iconFromType = $0a1959a1b48f0e49$var$typeToIcon(type, opts);
    const iconFromFileFormat = opts.fileFormat ? (0, $FoFt2.getIconForFileType)(opts.fileFormat) : undefined;
    const iconFromProvider = opts.provider && opts.provider.icon;
    return (0, $abbo9.prioritiseIcon)({
        fileFormatIcon: iconFromFileFormat,
        documentTypeIcon: iconFromType,
        urlIcon: opts.icon,
        providerIcon: iconFromProvider
    });
}
/**
 * Extracts an icon based on the given type.
 *
 * Some types return hardcoded icons, while others follow a priority list on how to pick the icon.
 * If type is not recognized, it will return the icon from the provider, or `undefined` if no icon is found.
 *
 * @param type - The type of the object.
 * @param opts - Options for the icon extraction.
 * @returns The extracted icon as a React node, or `undefined` if no icon is found.
 */ const $0a1959a1b48f0e49$var$extractIconByType = (type, opts)=>{
    switch(type){
        case 'Document':
        case 'schema:BlogPosting':
        case 'schema:DigitalDocument':
        case 'schema:TextDigitalDocument':
        case 'schema:PresentationDigitalDocument':
        case 'schema:SpreadsheetDigitalDocument':
        case 'atlassian:Template':
        case 'atlassian:UndefinedLink':
            return (0, $l8s0O.extractIconFromDocument)(type, opts);
        default:
            return $0a1959a1b48f0e49$var$standardisedExtractIcon(type, opts);
    }
};

});
parcelRegister("liS9g", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $fba6d3a5fd6972fb$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bd5a8d264ca7a1e79e3d50d476094729>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1WryD = parcelRequire("1WryD");

var $awZZu = parcelRequire("awZZu");

var $eGOwo = parcelRequire("eGOwo");

var $cBTRt = parcelRequire("cBTRt");
/**
 * __16px `branch` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $fba6d3a5fd6972fb$var$Branch16Icon = ({ label: label, testId: testId })=>{
    if ((0, $eGOwo.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1WryD.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($awZZu))),
        appearance: "blueBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cBTRt.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cBTRt.default), {
        label: label,
        testId: testId
    });
};
$fba6d3a5fd6972fb$var$Branch16Icon.displayName = 'Branch16Icon';
var $fba6d3a5fd6972fb$export$2e2bcd8739ae039 = $fba6d3a5fd6972fb$var$Branch16Icon;

});
parcelRegister("awZZu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6bb7d4b05cefe88d0219507dc0673c3e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7aacfa98324a1e60$var$_react = $7aacfa98324a1e60$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $7aacfa98324a1e60$var$_baseNew = $7aacfa98324a1e60$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $7aacfa98324a1e60$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Branch".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for branches in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7aacfa98324a1e60$var$BranchIcon = (props)=>/*#__PURE__*/ $7aacfa98324a1e60$var$_react.default.createElement($7aacfa98324a1e60$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.25 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M2 3.25a2.25 2.25 0 1 1 3 2.122V9H3.5V5.372A2.25 2.25 0 0 1 2 3.25m9.75-.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m-2.25.75a2.25 2.25 0 1 1 3 2.122v4.878a3.25 3.25 0 0 1-3.25 3.25H6.372a2.25 2.25 0 1 1 0-1.5H9.25A1.75 1.75 0 0 0 11 10.25V5.372A2.25 2.25 0 0 1 9.5 3.25M4.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$7aacfa98324a1e60$var$BranchIcon.displayName = 'BranchIcon';
var $7aacfa98324a1e60$var$_default = module.exports.default = $7aacfa98324a1e60$var$BranchIcon;

});

parcelRegister("cBTRt", function(module, exports) {

$parcel$export(module.exports, "default", () => $3462a9699ad70391$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::371b0d35eca629b3ebb5e933140aedc3>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kxVLD = parcelRequire("kxVLD");
const $3462a9699ad70391$var$Branch16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $kxVLD.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M10 8.732v.28A1.993 1.993 0 0 1 8.002 11l-.004 2A3.995 3.995 0 0 0 12 9.007v-.274a2 2 0 1 0-2 0m-4-3a2 2 0 1 0-2 0v4.536a2 2 0 1 0 2 0zM2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2"/></svg>`,
        ...props,
        size: "small"
    });
$3462a9699ad70391$var$Branch16Icon.displayName = 'Branch16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$3462a9699ad70391$export$2e2bcd8739ae039 = $3462a9699ad70391$var$Branch16Icon;

});


parcelRegister("gSqCA", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $978ab5b169d02f01$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a2e0cf5105bbbaa2e318211c53ac326e>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1WryD = parcelRequire("1WryD");

var $8lO5P = parcelRequire("8lO5P");

var $eGOwo = parcelRequire("eGOwo");

var $j8Au4 = parcelRequire("j8Au4");
/**
 * __16px `code` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $978ab5b169d02f01$var$Code16Icon = ({ label: label, testId: testId })=>{
    if ((0, $eGOwo.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1WryD.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8lO5P))),
        appearance: "purpleBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $j8Au4.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $j8Au4.default), {
        label: label,
        testId: testId
    });
};
$978ab5b169d02f01$var$Code16Icon.displayName = 'Code16Icon';
var $978ab5b169d02f01$export$2e2bcd8739ae039 = $978ab5b169d02f01$var$Code16Icon;

});
parcelRegister("8lO5P", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::196b600e7960a1af1a5f6fffc09ddaa0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6147244ca1278d21$var$_react = $6147244ca1278d21$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $6147244ca1278d21$var$_baseNew = $6147244ca1278d21$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $6147244ca1278d21$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AngleBrackets".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: code or source code in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6147244ca1278d21$var$AngleBracketsIcon = (props)=>/*#__PURE__*/ $6147244ca1278d21$var$_react.default.createElement($6147244ca1278d21$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m4.315 14.445 6-13.5 1.37.61-6 13.5zM13.982 10l-2.925 2.145.886 1.21 3.75-2.75a.75.75 0 0 0 0-1.21l-3.75-2.75-.886 1.21zM2.018 6l2.926 2.145-.888 1.21-3.75-2.75a.75.75 0 0 1 0-1.21l3.75-2.75.888 1.21z" clip-rule="evenodd"/>`
    }, props));
$6147244ca1278d21$var$AngleBracketsIcon.displayName = 'AngleBracketsIcon';
var $6147244ca1278d21$var$_default = module.exports.default = $6147244ca1278d21$var$AngleBracketsIcon;

});

parcelRegister("j8Au4", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a6502744a03af16$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5a17b0b5d454f4262ba3195f959601cc>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kxVLD = parcelRequire("kxVLD");
const $7a6502744a03af16$var$Code16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $kxVLD.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#6554c0" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m2.92 4.72L2.34 7.3a1 1 0 0 0 0 1.414l2.58 2.578a1 1 0 0 0 1.414-1.416L4.46 8.006l1.873-1.871A1 1 0 1 0 4.92 4.72m4.792 0a1 1 0 0 0 0 1.415l1.874 1.87-1.873 1.87a1 1 0 1 0 1.414 1.416l2.58-2.58a1 1 0 0 0 0-1.414L11.126 4.72a1 1 0 0 0-.706-.292 1 1 0 0 0-.708.293"/></svg>`,
        ...props,
        size: "small"
    });
$7a6502744a03af16$var$Code16Icon.displayName = 'Code16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7a6502744a03af16$export$2e2bcd8739ae039 = $7a6502744a03af16$var$Code16Icon;

});


parcelRegister("6wUJL", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $c727218f2343b747$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e96efea4cb290db7d8f614246fd62e43>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1WryD = parcelRequire("1WryD");

var $7XCnf = parcelRequire("7XCnf");

var $eGOwo = parcelRequire("eGOwo");

var $1OiKX = parcelRequire("1OiKX");
/**
 * __16px `commit` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $c727218f2343b747$var$Commit16Icon = ({ label: label, testId: testId })=>{
    if ((0, $eGOwo.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1WryD.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7XCnf))),
        appearance: "orangeBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1OiKX.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1OiKX.default), {
        label: label,
        testId: testId
    });
};
$c727218f2343b747$var$Commit16Icon.displayName = 'Commit16Icon';
var $c727218f2343b747$export$2e2bcd8739ae039 = $c727218f2343b747$var$Commit16Icon;

});
parcelRegister("7XCnf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::06952e599791aaa8e8e82dba5053d210>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5cbbcf5690c6b367$var$_react = $5cbbcf5690c6b367$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $5cbbcf5690c6b367$var$_baseNew = $5cbbcf5690c6b367$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $5cbbcf5690c6b367$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Commit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for commits in Jira or Bitbucket.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5cbbcf5690c6b367$var$CommitIcon = (props)=>/*#__PURE__*/ $5cbbcf5690c6b367$var$_react.default.createElement($5cbbcf5690c6b367$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.25 5.354a2.751 2.751 0 0 0 0 5.292V16h1.5v-5.353a2.751 2.751 0 0 0 0-5.293V0h-1.5zM8 6.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5" clip-rule="evenodd"/>`
    }, props));
$5cbbcf5690c6b367$var$CommitIcon.displayName = 'CommitIcon';
var $5cbbcf5690c6b367$var$_default = module.exports.default = $5cbbcf5690c6b367$var$CommitIcon;

});

parcelRegister("1OiKX", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd5ceb37ab40bc73$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::50d5a3bab2c708a6de1c7dc72e3a297a>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kxVLD = parcelRequire("kxVLD");
const $bd5ceb37ab40bc73$var$Commit16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $kxVLD.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m6 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-.986 1.834a3.001 3.001 0 0 1 0-5.668A1 1 0 0 1 7 5V3a1 1 0 1 1 2 0v2q0 .085-.014.166a3.001 3.001 0 0 1 0 5.668Q9 10.915 9 11v2a1 1 0 0 1-2 0v-2q0-.085.014-.166"/></svg>`,
        ...props,
        size: "small"
    });
$bd5ceb37ab40bc73$var$Commit16Icon.displayName = 'Commit16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$bd5ceb37ab40bc73$export$2e2bcd8739ae039 = $bd5ceb37ab40bc73$var$Commit16Icon;

});


parcelRegister("es92x", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $44741c921c28f10f$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::499dedcb1e659dc62cb0d811acc9f742>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1WryD = parcelRequire("1WryD");

var $MUJuW = parcelRequire("MUJuW");

var $eGOwo = parcelRequire("eGOwo");

var $3xtgM = parcelRequire("3xtgM");
/**
 * __16px `pull-request` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $44741c921c28f10f$var$PullRequest16Icon = ({ label: label, testId: testId })=>{
    if ((0, $eGOwo.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1WryD.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($MUJuW))),
        appearance: "greenBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3xtgM.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3xtgM.default), {
        label: label,
        testId: testId
    });
};
$44741c921c28f10f$var$PullRequest16Icon.displayName = 'PullRequest16Icon';
var $44741c921c28f10f$export$2e2bcd8739ae039 = $44741c921c28f10f$var$PullRequest16Icon;

});
parcelRegister("MUJuW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a083285ccf5836110a489694f045affe>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $09307dc51f4f46f2$var$_react = $09307dc51f4f46f2$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $09307dc51f4f46f2$var$_baseNew = $09307dc51f4f46f2$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $09307dc51f4f46f2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PullRequest".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pull requests.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $09307dc51f4f46f2$var$PullRequestIcon = (props)=>/*#__PURE__*/ $09307dc51f4f46f2$var$_react.default.createElement($09307dc51f4f46f2$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.25 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M2 3.25a2.25 2.25 0 1 1 3 2.122v5.256a2.251 2.251 0 1 1-1.5 0V5.372A2.25 2.25 0 0 1 2 3.25m6-.75h1.75a2.75 2.75 0 0 1 2.75 2.75v5.378a2.251 2.251 0 1 1-1.5 0V5.25C11 4.56 10.44 4 9.75 4H8zM4.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m7.5 0a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$09307dc51f4f46f2$var$PullRequestIcon.displayName = 'PullRequestIcon';
var $09307dc51f4f46f2$var$_default = module.exports.default = $09307dc51f4f46f2$var$PullRequestIcon;

});

parcelRegister("3xtgM", function(module, exports) {

$parcel$export(module.exports, "default", () => $38a04956c9fd4802$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f46cc1f5eba58da93be626b062afbd6e>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kxVLD = parcelRequire("kxVLD");
const $38a04956c9fd4802$var$PullRequest16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $kxVLD.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#36b37e" fill-rule="evenodd" d="M6.417 6H9a1 1 0 0 1 1 1v1a1 1 0 0 0 2 0V7a3 3 0 0 0-3-3H6.415l.294-.295a1 1 0 1 0-1.413-1.414l-2.003 2a1 1 0 0 0 .001 1.415l2.002 2.001a1 1 0 0 0 1.414-.002 1 1 0 0 0-.001-1.413zM2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m9 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/></svg>`,
        ...props,
        size: "small"
    });
$38a04956c9fd4802$var$PullRequest16Icon.displayName = 'PullRequest16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$38a04956c9fd4802$export$2e2bcd8739ae039 = $38a04956c9fd4802$var$PullRequest16Icon;

});


parcelRegister("cOjgE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $442ecc1a7897d80c$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5cb120ef54d45ebd04018c195938778f>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1WryD = parcelRequire("1WryD");

var $bwM92 = parcelRequire("bwM92");

var $eGOwo = parcelRequire("eGOwo");

var $dSbyY = parcelRequire("dSbyY");
/**
 * __16px `task` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $442ecc1a7897d80c$var$Task16Icon = ({ label: label, testId: testId })=>{
    if ((0, $eGOwo.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1WryD.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bwM92))),
        appearance: "blueBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dSbyY.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dSbyY.default), {
        label: label,
        testId: testId
    });
};
$442ecc1a7897d80c$var$Task16Icon.displayName = 'Task16Icon';
var $442ecc1a7897d80c$export$2e2bcd8739ae039 = $442ecc1a7897d80c$var$Task16Icon;

});
parcelRegister("bwM92", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f1fa22b134d342ddb8339c9dc89d7524>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8648076de2cded56$var$_react = $8648076de2cded56$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $8648076de2cded56$var$_baseNew = $8648076de2cded56$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $8648076de2cded56$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Task".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for tasks in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8648076de2cded56$var$TaskIcon = (props)=>/*#__PURE__*/ $8648076de2cded56$var$_react.default.createElement($8648076de2cded56$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zm9.326 2.98-5 6a.75.75 0 0 1-1.152 0l-2.5-3 1.152-.96L6.75 9.828l4.424-5.308z" clip-rule="evenodd"/>`
    }, props));
$8648076de2cded56$var$TaskIcon.displayName = 'TaskIcon';
var $8648076de2cded56$var$_default = module.exports.default = $8648076de2cded56$var$TaskIcon;

});

parcelRegister("dSbyY", function(module, exports) {

$parcel$export(module.exports, "default", () => $7143582d1b645e3c$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::73d9ff981bcfc769f66de456322c40e3>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kxVLD = parcelRequire("kxVLD");
const $7143582d1b645e3c$var$Task16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $kxVLD.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M0 1.994C0 .893.895 0 1.994 0h12.012C15.107 0 16 .895 16 1.994v12.012A1.995 1.995 0 0 1 14.006 16H1.994A1.995 1.995 0 0 1 0 14.006zM4.667 3C3.747 3 3 3.746 3 4.667v6.666C3 12.253 3.746 13 4.667 13h6.666c.92 0 1.667-.746 1.667-1.667V4.667C13 3.747 12.254 3 11.333 3zM5 5v6h6V5z"/></svg>`,
        ...props,
        size: "small"
    });
$7143582d1b645e3c$var$Task16Icon.displayName = 'Task16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7143582d1b645e3c$export$2e2bcd8739ae039 = $7143582d1b645e3c$var$Task16Icon;

});


parcelRegister("lG2jM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d4ce7dd41e05f3ded01848e6f06d1f7d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fc7f518425e4bcf9$var$_react = $fc7f518425e4bcf9$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fc7f518425e4bcf9$var$_peopleGroup = $fc7f518425e4bcf9$var$_interopRequireDefault((parcelRequire("hxN6p")));

var $fc7f518425e4bcf9$var$_peopleGroup2 = $fc7f518425e4bcf9$var$_interopRequireDefault((parcelRequire("hh8BY")));
function $fc7f518425e4bcf9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PeopleGroupIcon.
 * This component is PeopleGroupIcon, with `UNSAFE_fallbackIcon` set to "PeopleGroupIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a group or collection of people or users.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fc7f518425e4bcf9$var$PeopleGroupIcon = (props)=>/*#__PURE__*/ $fc7f518425e4bcf9$var$_react.default.createElement($fc7f518425e4bcf9$var$_peopleGroup.default, Object.assign({
        LEGACY_fallbackIcon: $fc7f518425e4bcf9$var$_peopleGroup2.default
    }, props));
$fc7f518425e4bcf9$var$PeopleGroupIcon.Name = 'PeopleGroupIconMigration';
var $fc7f518425e4bcf9$var$_default = module.exports.default = $fc7f518425e4bcf9$var$PeopleGroupIcon;

});
parcelRegister("hh8BY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c93ab4407be6cde9$var$_react = $c93ab4407be6cde9$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $c93ab4407be6cde9$var$_peopleGroup = $c93ab4407be6cde9$var$_interopRequireDefault((parcelRequire("hxN6p")));
function $c93ab4407be6cde9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c93ab4407be6cde9$var$PeopleGroupIcon = (props)=>/*#__PURE__*/ $c93ab4407be6cde9$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M8.13 10H4a2 2 0 0 0-2 2v3.73c0 1.31 1.87 2.05 4 2.23V15a3 3 0 0 1 3-3h.35a4 4 0 0 1-1.23-2m7.75 0H20c1.11 0 2 .89 2 2v3.73c0 1.31-1.87 2.05-4 2.23V15a3 3 0 0 0-3-3h-.35a4 4 0 0 0 1.23-2M9.97 5.55a3 3 0 1 0-1.96 3.27 4 4 0 0 1 1.96-3.27M16 8.83a3 3 0 1 0-1.96-3.28A4 4 0 0 1 16 8.83"/><path d="M7 15c0-1.105.887-2 2-2h6c1.105 0 2 .885 2 2v3.73c0 3.027-10 3.027-10 0z"/><circle cx="12" cy="9" r="3"/></g></svg>`
    }, props, {
        newIcon: $c93ab4407be6cde9$var$_peopleGroup.default
    }));
$c93ab4407be6cde9$var$PeopleGroupIcon.displayName = 'PeopleGroupIcon';
var $c93ab4407be6cde9$var$_default = module.exports.default = $c93ab4407be6cde9$var$PeopleGroupIcon;

});


parcelRegister("ip2tE", function(module, exports) {

$parcel$export(module.exports, "extractFileFormat", () => $733ec07b82674776$export$f2d65f02f6888b60);
const $733ec07b82674776$export$f2d65f02f6888b60 = (jsonLd)=>{
    return jsonLd['schema:fileFormat'];
};

});

parcelRegister("l8s0O", function(module, exports) {

$parcel$export(module.exports, "extractIconFromDocument", () => $f67edadeb7739c7c$export$25c24c7f577936d3);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kSre2 = parcelRequire("kSre2");

var $9Thyx = parcelRequire("9Thyx");

var $4Gz8O = parcelRequire("4Gz8O");

var $lQKQC = parcelRequire("lQKQC");

var $iOphm = parcelRequire("iOphm");

var $4VIPx = parcelRequire("4VIPx");

var $9020Y = parcelRequire("9020Y");

var $9dPtp = parcelRequire("9dPtp");

var $FoFt2 = parcelRequire("FoFt2");

var $abbo9 = parcelRequire("abbo9");
const $f67edadeb7739c7c$export$25c24c7f577936d3 = (type, opts)=>{
    const iconFromType = $f67edadeb7739c7c$var$documentTypeToIcon(type, opts);
    const iconFromFileFormat = $f67edadeb7739c7c$var$documentFileFormatToIcon(opts);
    const iconFromProvider = opts.provider && opts.provider.icon;
    return (0, $abbo9.prioritiseIcon)({
        fileFormatIcon: iconFromFileFormat,
        documentTypeIcon: iconFromType,
        urlIcon: opts.icon,
        providerIcon: iconFromProvider
    });
};
const $f67edadeb7739c7c$var$documentFileFormatToIcon = (opts)=>{
    if (opts.fileFormat) return (0, $FoFt2.getIconForFileType)(opts.fileFormat);
};
const $f67edadeb7739c7c$var$documentTypeToIcon = (type, opts)=>{
    switch(type){
        case 'schema:BlogPosting':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4Gz8O.default), {
                label: opts.showIconLabel ? opts.title || 'blog' : '',
                testId: "blog-icon"
            });
        case 'schema:DigitalDocument':
            return $f67edadeb7739c7c$var$digitalDocumentToIcon(opts);
        case 'schema:TextDigitalDocument':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9dPtp.default), {
                label: opts.showIconLabel ? opts.title || 'document' : '',
                testId: "document-icon"
            });
        case 'schema:PresentationDigitalDocument':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lQKQC.default), {
                label: opts.showIconLabel ? opts.title || 'presentation' : '',
                testId: "presentation-icon"
            });
        case 'schema:SpreadsheetDigitalDocument':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4VIPx.default), {
                label: opts.showIconLabel ? opts.title || 'spreadsheet' : '',
                testId: "spreadsheet-icon"
            });
        case 'atlassian:Template':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kSre2))), {
                color: "currentColor",
                label: opts.showIconLabel ? opts.title || 'template' : '',
                testId: "document-filled-icon"
            });
        case 'atlassian:UndefinedLink':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9dPtp.default), {
                label: opts.showIconLabel ? opts.title || 'undefinedLink' : '',
                testId: "document-icon"
            });
    }
};
/**
 * Enables providers to represent `schema:DigitalDocument` in a manner which
 * aligns with their customers when representing provider-specific types, which
 * do not apply across multiple providers.
 * @example Confluence digital documents represent 'live documents', specific to Confluence.
 * @remark This mechanism will be superseded by backend-driven icon URLs as part
 * of go/j/MODES-5864. Do not add more!
 */ const $f67edadeb7739c7c$var$digitalDocumentToIcon = (opts)=>{
    if (opts.provider?.id && (0, $9Thyx.isConfluenceGenerator)(opts.provider.id)) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9020Y.default), {
        label: "live-doc",
        testId: "live-doc-icon"
    });
    else return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iOphm.default), {
        label: opts.showIconLabel ? opts.title || 'file' : '',
        testId: "file-icon"
    });
};

});
parcelRegister("kSre2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1c20e147606d139fd2bd9c488f6dfb0c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f32df82c412cc2b2$var$_react = $f32df82c412cc2b2$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $f32df82c412cc2b2$var$_file = $f32df82c412cc2b2$var$_interopRequireDefault((parcelRequire("jvbqF")));

var $f32df82c412cc2b2$var$_documentFilled = $f32df82c412cc2b2$var$_interopRequireDefault((parcelRequire("ePbAf")));
function $f32df82c412cc2b2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for FileIcon.
 * This component is FileIcon, with `UNSAFE_fallbackIcon` set to "DocumentFilledIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: document, file. Do not use to represent a page — use the dedicated 'Page' icon instead.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f32df82c412cc2b2$var$FileIcon = (props)=>/*#__PURE__*/ $f32df82c412cc2b2$var$_react.default.createElement($f32df82c412cc2b2$var$_file.default, Object.assign({
        LEGACY_fallbackIcon: $f32df82c412cc2b2$var$_documentFilled.default
    }, props));
$f32df82c412cc2b2$var$FileIcon.Name = 'FileIconMigration';
var $f32df82c412cc2b2$var$_default = module.exports.default = $f32df82c412cc2b2$var$FileIcon;

});
parcelRegister("jvbqF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1ac12335f661fcbcd071a3693f0f2aa2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e329c724a11ab833$var$_react = $e329c724a11ab833$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $e329c724a11ab833$var$_baseNew = $e329c724a11ab833$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $e329c724a11ab833$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "File".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: document, file. Do not use to represent a page — use the dedicated 'Page' icon instead.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e329c724a11ab833$var$FileIcon = (props)=>/*#__PURE__*/ $e329c724a11ab833$var$_react.default.createElement($e329c724a11ab833$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 14a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V5.25c0-.52-.206-1.017-.573-1.384L10.134.573A1.96 1.96 0 0 0 8.75 0H4a2 2 0 0 0-2 2zm2 .5a.5.5 0 0 1-.5-.5V2a.5.5 0 0 1 .5-.5h4v3.75c0 .414.336.75.75.75h3.75v8a.5.5 0 0 1-.5.5zm7.94-10H9.5V2.06z" clip-rule="evenodd"/>`
    }, props));
$e329c724a11ab833$var$FileIcon.displayName = 'FileIcon';
var $e329c724a11ab833$var$_default = module.exports.default = $e329c724a11ab833$var$FileIcon;

});

parcelRegister("ePbAf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $acaed063c693be85$var$_react = $acaed063c693be85$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $acaed063c693be85$var$_file = $acaed063c693be85$var$_interopRequireDefault((parcelRequire("jvbqF")));
function $acaed063c693be85$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $acaed063c693be85$var$DocumentFilledIcon = (props)=>/*#__PURE__*/ $acaed063c693be85$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m18.99 8.99.01 1.015V19a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5.275c.469 0 .922.164 1.282.464L18.631 7.7c.227.19.359.471.359.768zM12.02 5 12 8.192a.99.99 0 0 0 .994.991h4z"/></svg>`
    }, props, {
        newIcon: $acaed063c693be85$var$_file.default
    }));
$acaed063c693be85$var$DocumentFilledIcon.displayName = 'DocumentFilledIcon';
var $acaed063c693be85$var$_default = module.exports.default = $acaed063c693be85$var$DocumentFilledIcon;

});


parcelRegister("lQKQC", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $457cf0e778e4e077$export$2e2bcd8739ae039);

var $5cEyJ = parcelRequire("5cEyJ");

var $1TONM = parcelRequire("1TONM");

var $amDP4 = parcelRequire("amDP4");

var $cPcks = parcelRequire("cPcks");
const $457cf0e778e4e077$var$ChartBarIconWithColor = (0, $cPcks.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($amDP4))), 'purpleBold', (0, $cPcks.renderIconPerSize)((0, (/*@__PURE__*/$parcel$interopDefault($5cEyJ))), (0, (/*@__PURE__*/$parcel$interopDefault($1TONM)))));
$457cf0e778e4e077$var$ChartBarIconWithColor.displayName = 'ChartBarIconWithColor';
var $457cf0e778e4e077$export$2e2bcd8739ae039 = $457cf0e778e4e077$var$ChartBarIconWithColor;

});
parcelRegister("5cEyJ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $3c9d88f73aaa21a0$var$_react = $3c9d88f73aaa21a0$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $3c9d88f73aaa21a0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3c9d88f73aaa21a0$var$Presentation16Icon = (props)=>/*#__PURE__*/ $3c9d88f73aaa21a0$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m10 3a1 1 0 0 0-1 1v8a1 1 0 0 0 2 0V4a1 1 0 0 0-1-1M8 6a1 1 0 0 0-1 1v5a1 1 0 0 0 2 0V7a1 1 0 0 0-1-1M4 9a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0v-2a1 1 0 0 0-1-1"/></svg>`
    }, props, {
        size: 'small'
    }));
$3c9d88f73aaa21a0$var$Presentation16Icon.displayName = 'Presentation16Icon';
var $3c9d88f73aaa21a0$var$_default = module.exports.default = $3c9d88f73aaa21a0$var$Presentation16Icon;

});

parcelRegister("amDP4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::938052aeb81071adc088ccde54cc9808>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $78bad9690aef89d2$var$_react = $78bad9690aef89d2$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $78bad9690aef89d2$var$_baseNew = $78bad9690aef89d2$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $78bad9690aef89d2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChartBar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: Reports in JSM, Space Analytics in Confluence, and other graph charts.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $78bad9690aef89d2$var$ChartBarIcon = (props)=>/*#__PURE__*/ $78bad9690aef89d2$var$_react.default.createElement($78bad9690aef89d2$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9.333 1.75a.75.75 0 0 1 .75-.75h4.167a.75.75 0 0 1 .75.75V13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V9.75A.75.75 0 0 1 1.75 9h3.417V5.75a.75.75 0 0 1 .75-.75h3.416zm0 4.75H6.667v7h2.666zm1.5 7H13a.5.5 0 0 0 .5-.5V2.5h-2.667zm-5.666 0v-3H2.5V13a.5.5 0 0 0 .5.5z" clip-rule="evenodd"/>`
    }, props));
$78bad9690aef89d2$var$ChartBarIcon.displayName = 'ChartBarIcon';
var $78bad9690aef89d2$var$_default = module.exports.default = $78bad9690aef89d2$var$ChartBarIcon;

});


parcelRegister("iOphm", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $d1a6648d509434f8$export$2e2bcd8739ae039);

var $hLSBq = parcelRequire("hLSBq");

var $btZ6J = parcelRequire("btZ6J");

var $jvbqF = parcelRequire("jvbqF");

var $cPcks = parcelRequire("cPcks");
const $d1a6648d509434f8$var$FileIconWithColor = (0, $cPcks.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($jvbqF))), 'grayBold', (0, $cPcks.renderIconPerSize)((0, (/*@__PURE__*/$parcel$interopDefault($hLSBq))), (0, (/*@__PURE__*/$parcel$interopDefault($btZ6J)))));
$d1a6648d509434f8$var$FileIconWithColor.displayName = 'FileIconWithColor';
var $d1a6648d509434f8$export$2e2bcd8739ae039 = $d1a6648d509434f8$var$FileIconWithColor;

});
parcelRegister("hLSBq", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $cf012e6694ca1348$var$_react = $cf012e6694ca1348$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $cf012e6694ca1348$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $cf012e6694ca1348$var$Generic16Icon = (props)=>/*#__PURE__*/ $cf012e6694ca1348$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M8 3H5.333C4.597 3 4 3.617 4 4.378v7.244C4 12.382 4.597 13 5.333 13h5.334c.736 0 1.333-.617 1.333-1.378V8h-1.333v3.622H5.333V4.378H8v1.414c0 .736.597 1.333 1.333 1.333h2.334c.184 0 .333-.15.333-.333v-.903a.33.33 0 0 0-.093-.231l-2.164-2.25A1.33 1.33 0 0 0 8.782 3zM0 1.994C0 .893.895 0 1.994 0h12.012C15.107 0 16 .895 16 1.994v12.012A1.995 1.995 0 0 1 14.006 16H1.994A1.995 1.995 0 0 1 0 14.006z"/></svg>`
    }, props, {
        size: 'small'
    }));
$cf012e6694ca1348$var$Generic16Icon.displayName = 'Generic16Icon';
var $cf012e6694ca1348$var$_default = module.exports.default = $cf012e6694ca1348$var$Generic16Icon;

});

parcelRegister("btZ6J", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $85c1cdd5f70b300c$var$_react = $85c1cdd5f70b300c$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $85c1cdd5f70b300c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $85c1cdd5f70b300c$var$Generic24Icon = (props)=>/*#__PURE__*/ $85c1cdd5f70b300c$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M12 4H8a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-6.995h-2V18H8V6h4v2a2 2 0 0 0 2 2h3.5a.5.5 0 0 0 .5-.5V8.213a.5.5 0 0 0-.145-.352L14.61 4.59A2 2 0 0 0 13.19 4zM3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3"/></svg>`
    }, props, {
        size: 'medium'
    }));
$85c1cdd5f70b300c$var$Generic24Icon.displayName = 'Generic24Icon';
var $85c1cdd5f70b300c$var$_default = module.exports.default = $85c1cdd5f70b300c$var$Generic24Icon;

});


parcelRegister("4VIPx", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $261b25b77463fadb$export$2e2bcd8739ae039);

var $avN5P = parcelRequire("avN5P");

var $i9oSq = parcelRequire("i9oSq");

var $hJIkn = parcelRequire("hJIkn");

var $cPcks = parcelRequire("cPcks");
const $261b25b77463fadb$var$ListBulletedIconWithColor = (0, $cPcks.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($hJIkn))), 'greenBold', (0, $cPcks.renderIconPerSize)((0, (/*@__PURE__*/$parcel$interopDefault($avN5P))), (0, (/*@__PURE__*/$parcel$interopDefault($i9oSq)))));
$261b25b77463fadb$var$ListBulletedIconWithColor.displayName = 'ListBulletedIconWithColor';
var $261b25b77463fadb$export$2e2bcd8739ae039 = $261b25b77463fadb$var$ListBulletedIconWithColor;

});
parcelRegister("avN5P", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $7a72e175f7c6772a$var$_react = $7a72e175f7c6772a$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");
function $7a72e175f7c6772a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7a72e175f7c6772a$var$Spreadsheet16Icon = (props)=>/*#__PURE__*/ $7a72e175f7c6772a$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#36b37e" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m2 3a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2zm0 4a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2zm0 4a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2zm5-8a1 1 0 1 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 1 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        size: 'small'
    }));
$7a72e175f7c6772a$var$Spreadsheet16Icon.displayName = 'Spreadsheet16Icon';
var $7a72e175f7c6772a$var$_default = module.exports.default = $7a72e175f7c6772a$var$Spreadsheet16Icon;

});

parcelRegister("hJIkn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c464a7d95484e897372db9f1fff872cb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ce990635ee602485$var$_react = $ce990635ee602485$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $ce990635ee602485$var$_baseNew = $ce990635ee602485$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $ce990635ee602485$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ListBulleted".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: bulleted lists, view all.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ce990635ee602485$var$ListBulletedIcon = (props)=>/*#__PURE__*/ $ce990635ee602485$var$_react.default.createElement($ce990635ee602485$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M.5 4.25a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m0 7.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M16 5H6V3.5h10zm0 7.5H6V11h10z" clip-rule="evenodd"/>`
    }, props));
$ce990635ee602485$var$ListBulletedIcon.displayName = 'ListBulletedIcon';
var $ce990635ee602485$var$_default = module.exports.default = $ce990635ee602485$var$ListBulletedIcon;

});



parcelRegister("1yraT", function(module, exports) {

$parcel$export(module.exports, "extractIconFromTask", () => $4555066ff891e98a$export$321256ed044e3100);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $i3nvV = parcelRequire("i3nvV");

var $59W6U = parcelRequire("59W6U");

var $4VGMo = parcelRequire("4VGMo");

var $h6Xfo = parcelRequire("h6Xfo");

var $8WXuv = parcelRequire("8WXuv");

var $erbJ6 = parcelRequire("erbJ6");

var $iaeCZ = parcelRequire("iaeCZ");

var $dV8me = parcelRequire("dV8me");

var $cOjgE = parcelRequire("cOjgE");

var $3DgO9 = parcelRequire("3DgO9");
const $4555066ff891e98a$var$TaskIcon = (0, $cOjgE.default);
const $4555066ff891e98a$export$321256ed044e3100 = (opts)=>{
    // Render Atlaskit icons for all supported Jira issue types.
    const { taskType: taskType, provider: provider } = opts;
    const taskLabel = opts.title || 'task';
    const defaultIcon = /*#__PURE__*/ (0, $gt9Am.jsx)($4555066ff891e98a$var$TaskIcon, {
        label: taskLabel,
        testId: "default-task-icon"
    });
    if (provider && provider.id === (0, $3DgO9.JIRA_GENERATOR_ID) && taskType && taskType.id) {
        const taskTypeId = taskType.id;
        const taskTypeName = taskTypeId.split('#').pop();
        switch(taskTypeName){
            case 0, $3DgO9.JIRA_TASK:
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cOjgE.default), {
                    label: taskLabel,
                    testId: "jira-task-icon"
                });
            case 0, $3DgO9.JIRA_SUB_TASK:
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dV8me.default), {
                    label: taskLabel,
                    testId: "jira-subtask-icon"
                });
            case 0, $3DgO9.JIRA_STORY:
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iaeCZ.default), {
                    label: taskLabel,
                    testId: "jira-story-icon"
                });
            case 0, $3DgO9.JIRA_BUG:
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $i3nvV.default), {
                    label: taskLabel,
                    testId: "jira-bug-icon"
                });
            case 0, $3DgO9.JIRA_EPIC:
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4VGMo.default), {
                    label: taskLabel,
                    testId: "jira-epic-icon"
                });
            case 0, $3DgO9.JIRA_INCIDENT:
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $h6Xfo.default), {
                    label: taskLabel,
                    testId: "jira-incident-icon"
                });
            case 0, $3DgO9.JIRA_SERVICE_REQUEST:
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8WXuv.default), {
                    label: taskLabel,
                    testId: "jira-service-request-icon"
                });
            case 0, $3DgO9.JIRA_CHANGE:
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $59W6U.default), {
                    label: taskLabel,
                    testId: "jira-change-icon"
                });
            case 0, $3DgO9.JIRA_PROBLEM:
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $erbJ6.default), {
                    label: taskLabel,
                    testId: "jira-problem-icon"
                });
            case 0, $3DgO9.JIRA_CUSTOM_TASK_TYPE:
                return taskType.icon || opts.icon || provider.icon || defaultIcon;
        }
    }
    return defaultIcon;
};

});
parcelRegister("i3nvV", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $7757e0f556678002$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::54f047f6f7bd48e9a2ba7394ee23b095>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1WryD = parcelRequire("1WryD");

var $9UdpB = parcelRequire("9UdpB");

var $eGOwo = parcelRequire("eGOwo");

var $ePICl = parcelRequire("ePICl");
/**
 * __16px `bug` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $7757e0f556678002$var$Bug16Icon = ({ label: label, testId: testId })=>{
    if ((0, $eGOwo.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1WryD.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9UdpB))),
        appearance: "redBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ePICl.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ePICl.default), {
        label: label,
        testId: testId
    });
};
$7757e0f556678002$var$Bug16Icon.displayName = 'Bug16Icon';
var $7757e0f556678002$export$2e2bcd8739ae039 = $7757e0f556678002$var$Bug16Icon;

});
parcelRegister("9UdpB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ab25c6896d727bd4806885f3b789ade9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7363bf5e9aa00467$var$_react = $7363bf5e9aa00467$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $7363bf5e9aa00467$var$_baseNew = $7363bf5e9aa00467$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $7363bf5e9aa00467$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Bug".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: Request types in JSM, bugs in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7363bf5e9aa00467$var$BugIcon = (props)=>/*#__PURE__*/ $7363bf5e9aa00467$var$_react.default.createElement($7363bf5e9aa00467$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 2.5A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 8 2.5m3 1.52V4a3 3 0 0 0-6 0v.02c-.29.05-.553.182-.761.372l-.887-.633-.917-2.064-1.37.61.944 2.125c.09.204.234.38.416.51l1.325.946V7H.5v1.5h3.25v1.149l-1.15.958a1.25 1.25 0 0 0-.318.401L1.08 13.415l1.342.67 1.18-2.36.46-.383A4.25 4.25 0 0 0 8.001 14h.249A4 4 0 0 0 12 11.393l.4.333 1.18 2.36 1.34-.671-1.202-2.407a1.25 1.25 0 0 0-.318-.401l-1.15-.958V8.5h3.25V7h-3.25V5.886l1.325-.946a1.25 1.25 0 0 0 .416-.51l.944-2.125-1.37-.61-.917 2.064-.887.633A1.5 1.5 0 0 0 11 4.02M10.75 10V5.5h-5.5v4.443l.035.226A2.75 2.75 0 0 0 8 12.5h.249a2.5 2.5 0 0 0 2.5-2.5" clip-rule="evenodd"/>`
    }, props));
$7363bf5e9aa00467$var$BugIcon.displayName = 'BugIcon';
var $7363bf5e9aa00467$var$_default = module.exports.default = $7363bf5e9aa00467$var$BugIcon;

});

parcelRegister("ePICl", function(module, exports) {

$parcel$export(module.exports, "default", () => $c67568ee10eb7c6c$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::508e97af907f08dc14fc66e28b081e3b>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kxVLD = parcelRequire("kxVLD");
const $c67568ee10eb7c6c$var$Bug16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $kxVLD.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m6 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8"/></svg>`,
        ...props,
        size: "small"
    });
$c67568ee10eb7c6c$var$Bug16Icon.displayName = 'Bug16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$c67568ee10eb7c6c$export$2e2bcd8739ae039 = $c67568ee10eb7c6c$var$Bug16Icon;

});


parcelRegister("59W6U", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $b85119f148eef897$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ee9d05b0e18fef4787b81f1748fa21a3>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1WryD = parcelRequire("1WryD");

var $4aDUk = parcelRequire("4aDUk");

var $eGOwo = parcelRequire("eGOwo");

var $bqSXM = parcelRequire("bqSXM");
/**
 * __16px `changes` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $b85119f148eef897$var$Changes16Icon = ({ label: label, testId: testId })=>{
    if ((0, $eGOwo.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1WryD.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4aDUk))),
        appearance: "orangeBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bqSXM.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bqSXM.default), {
        label: label,
        testId: testId
    });
};
$b85119f148eef897$var$Changes16Icon.displayName = 'Changes16Icon';
var $b85119f148eef897$export$2e2bcd8739ae039 = $b85119f148eef897$var$Changes16Icon;

});
parcelRegister("4aDUk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c939fd7642839817f37f5fef435fb296>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $30970d602f267700$var$_react = $30970d602f267700$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $30970d602f267700$var$_baseNew = $30970d602f267700$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $30970d602f267700$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Changes".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for changes in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $30970d602f267700$var$ChangesIcon = (props)=>/*#__PURE__*/ $30970d602f267700$var$_react.default.createElement($30970d602f267700$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.78 4.22 11.53.97l-1.06 1.06L12.44 4H2v1.5h10.44l-1.97 1.97 1.06 1.06 3.25-3.25a.75.75 0 0 0 0-1.06M3.56 10.5l1.97-1.97-1.06-1.06-3.25 3.25a.75.75 0 0 0 0 1.06l3.25 3.25 1.06-1.06L3.56 12H14v-1.5z" clip-rule="evenodd"/>`
    }, props));
$30970d602f267700$var$ChangesIcon.displayName = 'ChangesIcon';
var $30970d602f267700$var$_default = module.exports.default = $30970d602f267700$var$ChangesIcon;

});

parcelRegister("bqSXM", function(module, exports) {

$parcel$export(module.exports, "default", () => $5517f3f5f4a6b147$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::281636a4b7ecb1d97df53dcc5763d1a9>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kxVLD = parcelRequire("kxVLD");
const $5517f3f5f4a6b147$var$Changes16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $kxVLD.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M10.58 7H5.467l.866-.865A1 1 0 1 0 4.92 4.72L2.34 7.3a1 1 0 0 0 0 1.414l2.58 2.578a1 1 0 0 0 1.414-1.416L5.456 9h5.134l-.877.876a1 1 0 1 0 1.414 1.415l2.58-2.58a1 1 0 0 0 0-1.414L11.126 4.72a1 1 0 0 0-.706-.292.999.999 0 0 0-.707 1.707zM2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2"/></svg>`,
        ...props,
        size: "small"
    });
$5517f3f5f4a6b147$var$Changes16Icon.displayName = 'Changes16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$5517f3f5f4a6b147$export$2e2bcd8739ae039 = $5517f3f5f4a6b147$var$Changes16Icon;

});


parcelRegister("4VGMo", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $adbcbb4e84b923ab$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5fec5072b15ea4111438ac6700ce61b6>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1WryD = parcelRequire("1WryD");

var $gtN4u = parcelRequire("gtN4u");

var $eGOwo = parcelRequire("eGOwo");

var $3zPlh = parcelRequire("3zPlh");
/**
 * __16px `epic` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $adbcbb4e84b923ab$var$Epic16Icon = ({ label: label, testId: testId })=>{
    if ((0, $eGOwo.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1WryD.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gtN4u))),
        appearance: "purpleBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3zPlh.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3zPlh.default), {
        label: label,
        testId: testId
    });
};
$adbcbb4e84b923ab$var$Epic16Icon.displayName = 'Epic16Icon';
var $adbcbb4e84b923ab$export$2e2bcd8739ae039 = $adbcbb4e84b923ab$var$Epic16Icon;

});
parcelRegister("gtN4u", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::69c5703d29cce34dd1176fbc8fceb659>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bff56b51666b12d4$var$_react = $bff56b51666b12d4$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $bff56b51666b12d4$var$_baseNew = $bff56b51666b12d4$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $bff56b51666b12d4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Epic".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for epics in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bff56b51666b12d4$var$EpicIcon = (props)=>/*#__PURE__*/ $bff56b51666b12d4$var$_react.default.createElement($bff56b51666b12d4$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M10.271.05a.75.75 0 0 1 .479.7v4.635l3.147.63a.75.75 0 0 1 .407 1.24l-7.75 8.5a.75.75 0 0 1-1.304-.505v-4.635l-3.147-.63a.75.75 0 0 1-.407-1.24l7.75-8.5A.75.75 0 0 1 10.27.05M3.698 8.776l3.052.61v3.93l5.552-6.09-3.052-.61v-3.93z" clip-rule="evenodd"/>`
    }, props));
$bff56b51666b12d4$var$EpicIcon.displayName = 'EpicIcon';
var $bff56b51666b12d4$var$_default = module.exports.default = $bff56b51666b12d4$var$EpicIcon;

});

parcelRegister("3zPlh", function(module, exports) {

$parcel$export(module.exports, "default", () => $07e901c858f1e000$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2cb559f656356bdb13b54acac6c1eee2>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kxVLD = parcelRequire("kxVLD");
const $07e901c858f1e000$var$Epic16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $kxVLD.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#6554c0" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m9.912 7.767A.5.5 0 0 0 12 7.5a.5.5 0 0 0-.5-.5H9V3.5a.495.495 0 0 0-.872-.327l-.002-.001-3.977 4.973-.008.009-.028.036.002.004A.5.5 0 0 0 4 8.5a.5.5 0 0 0 .5.5c.028 0 .051-.011.077-.016H7V12.5a.5.5 0 0 0 .5.5c.124 0 .234-.05.321-.124l.004.001.007-.009c.03-.027.051-.059.074-.092l3.934-4.913c.019-.018.031-.039.047-.06l.027-.033z"/></svg>`,
        ...props,
        size: "small"
    });
$07e901c858f1e000$var$Epic16Icon.displayName = 'Epic16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$07e901c858f1e000$export$2e2bcd8739ae039 = $07e901c858f1e000$var$Epic16Icon;

});


parcelRegister("h6Xfo", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $10b82fbbd3c25549$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9beea2179909206f90938b1cce486fe2>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1WryD = parcelRequire("1WryD");

var $ljmsu = parcelRequire("ljmsu");

var $eGOwo = parcelRequire("eGOwo");

var $ewxpd = parcelRequire("ewxpd");
/**
 * __16px `incident` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $10b82fbbd3c25549$var$Incident16Icon = ({ label: label, testId: testId })=>{
    if ((0, $eGOwo.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1WryD.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ljmsu))),
        appearance: "redBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ewxpd.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ewxpd.default), {
        label: label,
        testId: testId
    });
};
$10b82fbbd3c25549$var$Incident16Icon.displayName = 'Incident16Icon';
var $10b82fbbd3c25549$export$2e2bcd8739ae039 = $10b82fbbd3c25549$var$Incident16Icon;

});
parcelRegister("ljmsu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cca747bf584e772ee6e9df3631122996>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f83ccb209af59fed$var$_react = $f83ccb209af59fed$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $f83ccb209af59fed$var$_baseNew = $f83ccb209af59fed$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $f83ccb209af59fed$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Incident".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for incidents in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f83ccb209af59fed$var$IncidentIcon = (props)=>/*#__PURE__*/ $f83ccb209af59fed$var$_react.default.createElement($f83ccb209af59fed$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1a.75.75 0 0 1 .696.471l2.2 5.5 2.612 6.529H15V15H1v-1.5h1.492L7.304 1.471A.75.75 0 0 1 8 1M4.108 13.5h7.784l-.8-2H4.908zm1.4-3.5h4.984l-.8-2H6.308zm1.4-3.5h2.184L8 3.77z" clip-rule="evenodd"/>`
    }, props));
$f83ccb209af59fed$var$IncidentIcon.displayName = 'IncidentIcon';
var $f83ccb209af59fed$var$_default = module.exports.default = $f83ccb209af59fed$var$IncidentIcon;

});

parcelRegister("ewxpd", function(module, exports) {

$parcel$export(module.exports, "default", () => $629cf392ad3aaa3f$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dce0ac1582dc2507da5f80cdb2ca3ec0>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kxVLD = parcelRequire("kxVLD");
const $629cf392ad3aaa3f$var$Incident16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $kxVLD.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M4.785 10h6.43L10.5 8H5.499zM4 11a1 1 0 0 0-1 1v1h10v-1a1 1 0 0 0-1-1zm1.856-4h4.288L8.942 3.632a1 1 0 0 0-1.884 0zM2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2"/></svg>`,
        ...props,
        size: "small"
    });
$629cf392ad3aaa3f$var$Incident16Icon.displayName = 'Incident16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$629cf392ad3aaa3f$export$2e2bcd8739ae039 = $629cf392ad3aaa3f$var$Incident16Icon;

});


parcelRegister("8WXuv", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $67922ee1ec2953f7$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6546d4aeab39dc918bda403f727c61ae>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1WryD = parcelRequire("1WryD");

var $c59mr = parcelRequire("c59mr");

var $eGOwo = parcelRequire("eGOwo");

var $28xc1 = parcelRequire("28xc1");
/**
 * __16px `issue` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $67922ee1ec2953f7$var$Issue16Icon = ({ label: label, testId: testId })=>{
    if ((0, $eGOwo.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1WryD.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($c59mr))),
        appearance: "blueBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $28xc1.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $28xc1.default), {
        label: label,
        testId: testId
    });
};
$67922ee1ec2953f7$var$Issue16Icon.displayName = 'Issue16Icon';
var $67922ee1ec2953f7$export$2e2bcd8739ae039 = $67922ee1ec2953f7$var$Issue16Icon;

});
parcelRegister("c59mr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::16b1a013266ea85d8875a6b5e1d2412a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8cbd368cf037dfb6$var$_react = $8cbd368cf037dfb6$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $8cbd368cf037dfb6$var$_baseNew = $8cbd368cf037dfb6$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $8cbd368cf037dfb6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "WorkItem".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for work items.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8cbd368cf037dfb6$var$WorkItemIcon = (props)=>/*#__PURE__*/ $8cbd368cf037dfb6$var$_react.default.createElement($8cbd368cf037dfb6$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 4a.5.5 0 0 0-.4-.49L14 3.5H2a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5zm-2.927 1.983-4 4.75a.75.75 0 0 1-1.146 0l-2-2.375 1.146-.966L7 9.085l3.427-4.068zM16 12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h12l.204.01A2 2 0 0 1 16 4z"/>`
    }, props));
$8cbd368cf037dfb6$var$WorkItemIcon.displayName = 'WorkItemIcon';
var $8cbd368cf037dfb6$var$_default = module.exports.default = $8cbd368cf037dfb6$var$WorkItemIcon;

});

parcelRegister("28xc1", function(module, exports) {

$parcel$export(module.exports, "default", () => $26d0d6c17f6a21a0$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8a9a249fb572b3dfc8cacf8f2a204c85>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kxVLD = parcelRequire("kxVLD");
const $26d0d6c17f6a21a0$var$Issue16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $kxVLD.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m1 4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1zm1 2v4h8V6z"/></svg>`,
        ...props,
        size: "small"
    });
$26d0d6c17f6a21a0$var$Issue16Icon.displayName = 'Issue16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$26d0d6c17f6a21a0$export$2e2bcd8739ae039 = $26d0d6c17f6a21a0$var$Issue16Icon;

});


parcelRegister("erbJ6", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $a57d8898cb2acd54$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5b69e4602c3c1878109c2ce1bcc3a020>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1WryD = parcelRequire("1WryD");

var $gNXvC = parcelRequire("gNXvC");

var $eGOwo = parcelRequire("eGOwo");

var $kFcVs = parcelRequire("kFcVs");
/**
 * __16px `problem` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $a57d8898cb2acd54$var$Problem16Icon = ({ label: label, testId: testId })=>{
    if ((0, $eGOwo.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1WryD.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gNXvC))),
        appearance: "redBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kFcVs.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kFcVs.default), {
        label: label,
        testId: testId
    });
};
$a57d8898cb2acd54$var$Problem16Icon.displayName = 'Problem16Icon';
var $a57d8898cb2acd54$export$2e2bcd8739ae039 = $a57d8898cb2acd54$var$Problem16Icon;

});
parcelRegister("gNXvC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8ad59de50cbf2d9cd9f6ad629f1ce9da>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c3bf622d2894843f$var$_react = $c3bf622d2894843f$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $c3bf622d2894843f$var$_baseNew = $c3bf622d2894843f$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $c3bf622d2894843f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Problem".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for problem work type priority.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c3bf622d2894843f$var$ProblemIcon = (props)=>/*#__PURE__*/ $c3bf622d2894843f$var$_react.default.createElement($c3bf622d2894843f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M2.343 2.343a8 8 0 1 1 11.314 11.315A8 8 0 0 1 2.343 2.343m.561 1.622a6.5 6.5 0 0 0 9.13 9.13zm9.693-.562a6.5 6.5 0 0 0-8.632-.499l9.13 9.13a6.5 6.5 0 0 0-.498-8.63"/>`
    }, props));
$c3bf622d2894843f$var$ProblemIcon.displayName = 'ProblemIcon';
var $c3bf622d2894843f$var$_default = module.exports.default = $c3bf622d2894843f$var$ProblemIcon;

});

parcelRegister("kFcVs", function(module, exports) {

$parcel$export(module.exports, "default", () => $a016a8b27712b47b$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::03a2258325f093d634d77334f2165e7f>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kxVLD = parcelRequire("kxVLD");
const $a016a8b27712b47b$var$Problem16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $kxVLD.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="m5.968 11.446 5.478-5.478a4 4 0 0 1-5.478 5.478m-1.414-1.414a4 4 0 0 1 5.478-5.478zM2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m6 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12"/></svg>`,
        ...props,
        size: "small"
    });
$a016a8b27712b47b$var$Problem16Icon.displayName = 'Problem16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a016a8b27712b47b$export$2e2bcd8739ae039 = $a016a8b27712b47b$var$Problem16Icon;

});


parcelRegister("iaeCZ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $5d125ca7430036a6$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7dc9560f1e0ba735793d18700483c5f5>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1WryD = parcelRequire("1WryD");

var $hVZow = parcelRequire("hVZow");

var $eGOwo = parcelRequire("eGOwo");

var $ayExB = parcelRequire("ayExB");
/**
 * __16px `story` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $5d125ca7430036a6$var$Story16Icon = ({ label: label, testId: testId })=>{
    if ((0, $eGOwo.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1WryD.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hVZow))),
        appearance: "greenBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ayExB.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ayExB.default), {
        label: label,
        testId: testId
    });
};
$5d125ca7430036a6$var$Story16Icon.displayName = 'Story16Icon';
var $5d125ca7430036a6$export$2e2bcd8739ae039 = $5d125ca7430036a6$var$Story16Icon;

});
parcelRegister("hVZow", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::57b828e09f9287500323fc5bcdd6b33d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d0e76235a9209c86$var$_react = $d0e76235a9209c86$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $d0e76235a9209c86$var$_baseNew = $d0e76235a9209c86$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $d0e76235a9209c86$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Story".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for story work type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d0e76235a9209c86$var$StoryIcon = (props)=>/*#__PURE__*/ $d0e76235a9209c86$var$_react.default.createElement($d0e76235a9209c86$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M11.518 3a.5.5 0 0 0-.5-.5H4.983a.5.5 0 0 0-.5.5v9.806L8 10.333l.431.304 3.087 2.169zm1.5 11.202a.776.776 0 0 1-1.122.694l-.099-.06L8 12.166l-3.796 2.67a.775.775 0 0 1-1.22-.634V3a2 2 0 0 1 2-2h6.035a2 2 0 0 1 2 2z"/>`
    }, props));
$d0e76235a9209c86$var$StoryIcon.displayName = 'StoryIcon';
var $d0e76235a9209c86$var$_default = module.exports.default = $d0e76235a9209c86$var$StoryIcon;

});

parcelRegister("ayExB", function(module, exports) {

$parcel$export(module.exports, "default", () => $a03bb463cddb9827$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9fd8d8228b7585fa76e9cb13da3baf72>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kxVLD = parcelRequire("kxVLD");
const $a03bb463cddb9827$var$Story16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $kxVLD.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#36b37e" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m6 11-2.863 1.822c-.42.38-1.137.111-1.137-.427v-8.19C4 3.54 4.596 3 5.333 3h5.334C11.403 3 12 3.539 12 4.206v8.19c0 .537-.719.806-1.139.426zm0-2.371 2 1.274V5H6v4.902z"/></svg>`,
        ...props,
        size: "small"
    });
$a03bb463cddb9827$var$Story16Icon.displayName = 'Story16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a03bb463cddb9827$export$2e2bcd8739ae039 = $a03bb463cddb9827$var$Story16Icon;

});


parcelRegister("dV8me", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $462b7112313631bd$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::169a13a2ae270c089103a5ea3de6fc67>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1WryD = parcelRequire("1WryD");

var $d67Vm = parcelRequire("d67Vm");

var $eGOwo = parcelRequire("eGOwo");

var $kqL94 = parcelRequire("kqL94");
/**
 * __16px `subtask` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $462b7112313631bd$var$Subtask16Icon = ({ label: label, testId: testId })=>{
    if ((0, $eGOwo.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1WryD.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($d67Vm))),
        appearance: "blueBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kqL94.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kqL94.default), {
        label: label,
        testId: testId
    });
};
$462b7112313631bd$var$Subtask16Icon.displayName = 'Subtask16Icon';
var $462b7112313631bd$export$2e2bcd8739ae039 = $462b7112313631bd$var$Subtask16Icon;

});
parcelRegister("d67Vm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cb1eed99abd44e812ae4cb98f136c93f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9891fb7b92d506c5$var$_react = $9891fb7b92d506c5$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $9891fb7b92d506c5$var$_baseNew = $9891fb7b92d506c5$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $9891fb7b92d506c5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Subtasks".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for subtask work type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9891fb7b92d506c5$var$SubtasksIcon = (props)=>/*#__PURE__*/ $9891fb7b92d506c5$var$_react.default.createElement($9891fb7b92d506c5$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 9.25a.5.5 0 0 0-.5-.5H8.75V13a.5.5 0 0 0 .5.5H13a.5.5 0 0 0 .5-.5zM7.25 3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v3.75a.5.5 0 0 0 .5.5h4.25zm1.5 4.25H13a2 2 0 0 1 2 2V13a2 2 0 0 1-2 2H9.25a2 2 0 0 1-2-2V8.75H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h3.75a2 2 0 0 1 2 2z"/>`
    }, props));
$9891fb7b92d506c5$var$SubtasksIcon.displayName = 'SubtasksIcon';
var $9891fb7b92d506c5$var$_default = module.exports.default = $9891fb7b92d506c5$var$SubtasksIcon;

});

parcelRegister("kqL94", function(module, exports) {

$parcel$export(module.exports, "default", () => $602f9b1db5d82f1d$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4cad22e1176a9874a0c269f62ca4a13d>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kxVLD = parcelRequire("kxVLD");
const $602f9b1db5d82f1d$var$Subtask16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $kxVLD.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M9 7V4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h3v3a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1zM0 1.994C0 .893.895 0 1.994 0h12.012C15.107 0 16 .895 16 1.994v12.012A1.995 1.995 0 0 1 14.006 16H1.994A1.995 1.995 0 0 1 0 14.006zM9 9h2v2H9zM5 5h2v2H5z"/></svg>`,
        ...props,
        size: "small"
    });
$602f9b1db5d82f1d$var$Subtask16Icon.displayName = 'Subtask16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$602f9b1db5d82f1d$export$2e2bcd8739ae039 = $602f9b1db5d82f1d$var$Subtask16Icon;

});




parcelRegister("7BqfG", function(module, exports) {

$parcel$export(module.exports, "extractTitleTextColor", () => $33546c004f5f4832$export$a2afc198e9dada1);


var $aDkpj = parcelRequire("aDkpj");
const $33546c004f5f4832$export$a2afc198e9dada1 = (jsonLd)=>{
    const type = jsonLd['@type'];
    if (Array.isArray(type)) {
        const highestPriorityType = type.sort((a, b)=>(0, $aDkpj.extractorPriorityMap)[b] - (0, $aDkpj.extractorPriorityMap)[a])[0];
        switch(highestPriorityType){
            case 'atlassian:UndefinedLink':
                return `var(--ds-text-danger, ${0, $7bb4c1736002a04a$export$2837b5a1a71d5c02})`;
            default:
                return undefined;
        }
    }
};

});

parcelRegister("gxXx6", function(module, exports) {

$parcel$export(module.exports, "extractTitlePrefix", () => $c5f184c1c3b70b36$export$58d9bc37318dfb32);
const $c5f184c1c3b70b36$var$sanitizeEmojiValue = (value)=>value && value.replace(/['"]+/g, '').replace(/null/, '') || '';
const $c5f184c1c3b70b36$export$58d9bc37318dfb32 = (jsonLd, renderers, type)=>{
    const prefix = jsonLd['atlassian:titlePrefix'];
    if (prefix) // extract and return Emoji Title Prefix
    {
        if (prefix['@type'] === 'atlassian:Emoji') {
            const emojiId = $c5f184c1c3b70b36$var$sanitizeEmojiValue(prefix['text']);
            const hasEmojiPrefix = emojiId.length !== 0;
            const emojiRenderer = renderers?.emoji;
            if (hasEmojiPrefix && emojiRenderer) return emojiRenderer(emojiId, type);
        }
    }
    return undefined;
};

});


parcelRegister("eIvWj", function(module, exports) {

$parcel$export(module.exports, "InlineCardResolvedView", () => $f516ef55418d7e1c$export$6d5912cb4b56390e);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $jdqdp = parcelRequire("jdqdp");

var $eGOwo = parcelRequire("eGOwo");

var $3S6ja = parcelRequire("3S6ja");

var $k6uZC = parcelRequire("k6uZC");

var $bu0pj = parcelRequire("bu0pj");

var $3KRDe = parcelRequire("3KRDe");
class $f516ef55418d7e1c$export$6d5912cb4b56390e extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    renderLozenge() {
        const { lozenge: lozenge } = this.props;
        if (!lozenge) return null;
        const appearance = lozenge.appearance || 'default';
        if ((0, $eGOwo.fg)('platform-linking-visual-refresh-inline-lozenge')) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k6uZC.default), {
            testId: "inline-card-resolved-view-lozenge",
            appearance: appearance,
            style: {
                backgroundColor: lozenge?.style?.backgroundColor,
                color: lozenge?.style?.color
            },
            isBold: (0, $eGOwo.fg)('platform-component-visual-refresh') ? lozenge.isBold !== false : lozenge.isBold,
            children: lozenge.text
        });
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3KRDe.LozengeWrapper), {
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jdqdp.default), {
                testId: "inline-card-resolved-view-lozenge",
                appearance: appearance,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: lozenge.style,
                isBold: (0, $eGOwo.fg)('platform-component-visual-refresh') ? lozenge.isBold !== false : lozenge.isBold,
                children: lozenge.text
            })
        });
    }
    render() {
        const { id: id, title: title = '', isSelected: isSelected, isHovered: isHovered, onClick: onClick, icon: icon, link: link, testId: testId = 'inline-card-resolved-view', titleTextColor: titleTextColor, titlePrefix: titlePrefix, showHoverPreview: showHoverPreview = false, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, truncateInline: truncateInline, type: type } = this.props;
        const inlineCardResolvedView = /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bu0pj.Frame), {
            testId: testId,
            link: link,
            isSelected: isSelected,
            isHovered: isHovered,
            onClick: onClick,
            truncateInline: truncateInline,
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3KRDe.IconAndTitleLayout), {
                    emoji: titlePrefix,
                    icon: icon,
                    title: title,
                    titleTextColor: titleTextColor,
                    ...(0, $eGOwo.fg)('platform-linking-visual-refresh-v2') && {
                        type: type
                    }
                }),
                this.renderLozenge()
            ]
        });
        if (showHoverPreview && link) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3S6ja.HoverCard), {
            id: id,
            url: link,
            actionOptions: actionOptions,
            hoverPreviewOptions: hoverPreviewOptions,
            children: inlineCardResolvedView
        });
        return inlineCardResolvedView;
    }
}

});
parcelRegister("k6uZC", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e6c0fa079b82f37$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $jdqdp = parcelRequire("jdqdp");
const $7e6c0fa079b82f37$var$wrapperStyles = null;
const $7e6c0fa079b82f37$var$InlineLozenge = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        className: (0, $hcewu.default)([
            "_1e0c1o8l _s7n4t94y _19pkidpf _2hwx1b66 _otyridpf _18u0v77o _p12f1osq"
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jdqdp.default), {
            ...props
        })
    });
var $7e6c0fa079b82f37$export$2e2bcd8739ae039 = $7e6c0fa079b82f37$var$InlineLozenge;

});

parcelRegister("3KRDe", function(module, exports) {

$parcel$export(module.exports, "IconAndTitleLayout", () => $5d532ff440b5b275$export$d34be4d513116847);
$parcel$export(module.exports, "IconTitleWrapper", () => $5d532ff440b5b275$export$c73a53738ef9e3f);
$parcel$export(module.exports, "LozengeWrapper", () => $5d532ff440b5b275$export$75180efdd3f4d9c2);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $gRw8I = parcelRequire("gRw8I");

var $2HNHt = parcelRequire("2HNHt");

var $av9Of = parcelRequire("av9Of");

var $eGOwo = parcelRequire("eGOwo");

var $8IeH1 = parcelRequire("8IeH1");

var $FoFt2 = parcelRequire("FoFt2");

var $3aPI4 = parcelRequire("3aPI4");
const $5d532ff440b5b275$var$iconWrapperStyle = null;
const $5d532ff440b5b275$var$iconImageStyle = null;
const $5d532ff440b5b275$var$styles = {
    iconEmptyStyle: "_1bsb7vkz _4t3i1osq _1e0c1o8l _tzy4idpf",
    iconOuterWrapperStyle: "_1e0c1o8l _2hwx1b66 _kqswh2mm",
    iconTitleWrapperStyle: "_o5721jtm _1nmz9jpi _16d9qvcn _ca0qv77o _u5f31b66 _n3tdv77o _19bv1b66",
    linkStyle: "_2rkogqwt",
    noLinkAppearanceStyle: "_syaz131l _18u01b66",
    roundImageStyle: "_2rko14q2"
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled,@atlaskit/design-system/no-html-anchor -- Ignored via go/DSP-18766
const $5d532ff440b5b275$var$LinkAppearance = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_syaz1y58 _9oik18uv _1bnxglyw _jf4cnqa1",
            __cmplp.className
        ])
    });
});
const $5d532ff440b5b275$export$d34be4d513116847 = ({ icon: icon, emoji: emoji, defaultIcon: defaultIcon, onClick: onClick, children: children, title: title, titleColor: titleColor, titleTextColor: titleTextColor, link: link, rightSide: rightSide, testId: testId = 'inline-card-icon-and-title', type: type })=>{
    const renderAtlaskitIcon = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback(()=>{
        if (emoji) return emoji;
        if (!icon || typeof icon === 'string') return null;
        return icon;
    }, [
        emoji,
        icon
    ]);
    const profileType = (0, $eGOwo.fg)('platform-linking-visual-refresh-v2') ? (0, $FoFt2.isProfileType)(type) : false;
    const renderImageIcon = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((errored, testId)=>{
        (0, $gRw8I.di)((0, (/*@__PURE__*/$parcel$interopDefault($2HNHt))));
        if (!icon || typeof icon !== 'string') return null;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2HNHt))), {
            src: icon,
            loaded: /*#__PURE__*/ (0, $gt9Am.jsx)("img", {
                src: icon,
                "data-testid": `${testId}-image`,
                alt: "",
                className: (0, $hcewu.default)([
                    "_c71l7vkz _p12f7vkz _1bsb1osq",
                    profileType && $5d532ff440b5b275$var$styles.roundImageStyle
                ])
            }),
            errored: errored,
            loading: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3aPI4.Shimmer), {
                testId: `${testId}-loading`
            })
        });
    }, [
        icon,
        profileType
    ]);
    const renderIconPlaceholder = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((testId)=>{
        return defaultIcon || /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($av9Of))), {
            label: "link",
            LEGACY_size: "small",
            testId: `${testId}-default`,
            color: "currentColor"
        });
    }, [
        defaultIcon
    ]);
    const renderIcon = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((testId)=>{
        const icon = renderAtlaskitIcon();
        if (icon) return icon;
        const placeholder = renderIconPlaceholder(testId);
        const image = renderImageIcon(placeholder, testId);
        return image || placeholder;
    }, [
        renderAtlaskitIcon,
        renderIconPlaceholder,
        renderImageIcon
    ]);
    const handleClick = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((event)=>{
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]);
    const handleKeyPress = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((event)=>{
        if (event.key !== ' ' && event.key !== 'Enter') return;
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]);
    // maybe consider memoising this after clean up
    const titlePart = /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                as: "span",
                // EDM-12119: This is set here to help with the positioning of the icon to be in the middle of inline display.
                // We cannot set the fix font because inline is taking the parent container font size into account.
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                style: {
                    lineHeight: `1`
                },
                xcss: $5d532ff440b5b275$var$styles.iconOuterWrapperStyle,
                testId: "icon-position-wrapper",
                children: children || /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                            as: "span",
                            xcss: $5d532ff440b5b275$var$styles.iconEmptyStyle,
                            testId: "icon-empty-wrapper"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                            "data-testId": "icon-wrapper",
                            className: (0, $hcewu.default)([
                                "_11c81o8v _2rkoyh40 _1e0c116y _kqswstnw _2hwx1b66 _4t3i7vkz _1bsb7vkz _154i1ssb _1ltv1ssb _t9ec1ooe _uiztglyw"
                            ]),
                            children: renderIcon(testId)
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                as: "span",
                style: {
                    color: titleTextColor
                },
                children: title
            })
        ]
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)($5d532ff440b5b275$export$c73a53738ef9e3f, {
            style: {
                color: titleColor
            },
            testId: testId,
            children: [
                link ? /*#__PURE__*/ (0, $gt9Am.jsx)($5d532ff440b5b275$var$LinkAppearance, {
                    href: link,
                    onClick: handleClick,
                    onKeyPress: handleKeyPress,
                    className: (0, $hcewu.default)([
                        $5d532ff440b5b275$var$styles.linkStyle
                    ]),
                    children: titlePart
                }) : titlePart,
                rightSide ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                    as: "span",
                    xcss: $5d532ff440b5b275$var$styles.noLinkAppearanceStyle,
                    children: rightSide
                }) : null
            ]
        })
    });
};
const $5d532ff440b5b275$export$c73a53738ef9e3f = (props)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        as: "span",
        xcss: $5d532ff440b5b275$var$styles.iconTitleWrapperStyle,
        ...props
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $5d532ff440b5b275$var$LozengeWrapperOldVisualRefresh = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1o8l _s7n4t94y _19pkidpf _2hwx1b66 _otyridpf _18u0v77o",
            __cmplp.className
        ])
    });
});
const $5d532ff440b5b275$export$75180efdd3f4d9c2 = (props)=>{
    // note: This is just to get the types to work due to compiled css weirdness.
    return /*#__PURE__*/ (0, $gt9Am.jsx)($5d532ff440b5b275$var$LozengeWrapperOldVisualRefresh, {
        ...props
    });
};

});
parcelRegister("3aPI4", function(module, exports) {

$parcel$export(module.exports, "Shimmer", () => $4025455d45ae9834$export$809644b82cfe94b1);
/* Icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $klP06 = parcelRequire("klP06");
const $4025455d45ae9834$export$f04a61298a47a40f = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkoyh40 _4t3i7vkz _1bsb7vkz _2hwx1b66 _uiztglyw _kqswstnw _154i1ssb _1ltv1ssb _t9ec1ooe",
            __cmplp.className
        ])
    });
});
const $4025455d45ae9834$export$809644b82cfe94b1 = ({ testId: testId })=>{
    const skeletonCustomStyles = {
        position: 'absolute',
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
        top: '50%',
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
        left: '50%',
        transform: 'translate(-50%, -50%)',
        marginRight: "var(--ds-space-050, 4px)"
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $klP06.SpanSkeleton), {
        width: 16,
        height: 16,
        borderRadius: 2,
        testId: testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: skeletonCustomStyles
    });
};

});
parcelRegister("klP06", function(module, exports) {

$parcel$export(module.exports, "SpanSkeleton", () => $e1fe181bedc556ac$export$85d5658002cae6ce);
$parcel$export(module.exports, "Skeleton", () => $e1fe181bedc556ac$export$8f31e4c4a37b8e9c);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

const $e1fe181bedc556ac$var$placeholderShimmer = null;
const $e1fe181bedc556ac$var$appearanceValues = {
    darkGray: {
        animation: `var(--ds-background-accent-gray-subtle, ${(0, $7bb4c1736002a04a$export$c2e91cbeada39b8b)})`
    },
    gray: {
        animation: `var(--ds-skeleton, ${(0, $7bb4c1736002a04a$export$1ce2d1575d444ceb)})`
    },
    blue: {
        animation: "var(--ds-background-information-hovered, #cce0ff)"
    }
};
const $e1fe181bedc556ac$var$spanSkeletonStyles = null;
const $e1fe181bedc556ac$var$spanSkeletonBackgroundStyleMap = {
    gray: "_bfhk1cs6",
    blue: "_bfhk1hdx",
    darkGray: "_bfhk1gk7"
};
const $e1fe181bedc556ac$export$85d5658002cae6ce = ({ width: width, appearance: appearance = 'gray', height: height = 14, borderRadius: borderRadius = 0, isShimmering: isShimmering = true, testId: testId, style: style = {} })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            height: (typeof height === 'number' ? `${height}px` : height) || 'auto',
            width: (typeof width === 'number' ? `${width}px` : width) || 'auto',
            borderRadius: (typeof borderRadius === 'number' ? `${borderRadius}px` : borderRadius) || 0,
            backgroundImage: `linear-gradient(
    to right,
    transparent 0%,
    ${$e1fe181bedc556ac$var$appearanceValues[appearance].animation} 20%,
    transparent 40%,
    transparent 100%
  )`,
            backgroundSize: isShimmering ? `40px ${height}` : '0px'
        },
        className: (0, $hcewu.default)([
            "_uiztglyw _12vemgnk _j7hq1uu9 _5sag9cwz _1pglp3kn _tip812c5 _1o51q7pw",
            $e1fe181bedc556ac$var$spanSkeletonBackgroundStyleMap[appearance]
        ])
    });
};
const $e1fe181bedc556ac$export$8f31e4c4a37b8e9c = ({ width: width, appearance: appearance = 'gray', height: height = 14, borderRadius: borderRadius = 0, isShimmering: isShimmering = true, testId: testId, style: style = {} })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            height: (typeof height === 'number' ? `${height}px` : height) || 'auto',
            width: (typeof width === 'number' ? `${width}px` : width) || 'auto',
            borderRadius: (typeof borderRadius === 'number' ? `${borderRadius}px` : borderRadius) || 0,
            backgroundImage: `linear-gradient(
    to right,
    transparent 0%,
    ${$e1fe181bedc556ac$var$appearanceValues[appearance].animation} 20%,
    transparent 40%,
    transparent 100%
  )`,
            backgroundSize: isShimmering ? `40px ${height}` : '0px'
        },
        className: (0, $hcewu.default)([
            "_uiztglyw _12vemgnk _j7hq1uu9 _5sag9cwz _1pglp3kn _tip812c5 _1o51q7pw",
            $e1fe181bedc556ac$var$spanSkeletonBackgroundStyleMap[appearance]
        ])
    });
};
var $e1fe181bedc556ac$export$2e2bcd8739ae039 = $e1fe181bedc556ac$export$8f31e4c4a37b8e9c;

});




parcelRegister("hFl6W", function(module, exports) {

$parcel$export(module.exports, "EmbedCardErroredView", () => $35d1688af0eea2fa$export$6819d845957344e);
/* ErroredView.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $goZPP = parcelRequire("goZPP");

var $5CSKW = parcelRequire("5CSKW");

var $d3cA1 = parcelRequire("d3cA1");

var $eGOwo = parcelRequire("eGOwo");

var $8IeH1 = parcelRequire("8IeH1");
var $6djmC = parcelRequire("6djmC");


var $19nmp = parcelRequire("19nmp");

var $05blM = parcelRequire("05blM");
const $35d1688af0eea2fa$var$styles = {
    boxStyles: "_19bv1b66 _u5f31b66"
};
const $35d1688af0eea2fa$export$6819d845957344e = ({ onRetry: onRetry, isSelected: isSelected = false, testId: testId = 'embed-card-errored-view', inheritDimensions: inheritDimensions })=>/*#__PURE__*/ (0, $gt9Am.jsxs)((0, $05blM.Frame), {
        inheritDimensions: inheritDimensions,
        compact: true,
        isSelected: isSelected,
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d3cA1))), {
                LEGACY_size: "small",
                color: `var(--ds-icon-danger, ${(0, $7bb4c1736002a04a$export$4a7404f376229999)})`,
                label: "error-icon"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                xcss: $35d1688af0eea2fa$var$styles.boxStyles,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6djmC.default), {
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                        ...(0, $19nmp.messages).could_not_load_link
                    })
                })
            }),
            (0, $eGOwo.fg)('platform-smart-card-remove-legacy-button') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5CSKW.default), {
                testId: "err-view-retry",
                spacing: "compact",
                onClick: onRetry,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...(0, $19nmp.messages).try_again
                })
            }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $goZPP.default), {
                testId: "err-view-retry",
                appearance: "link",
                spacing: "none",
                onClick: onRetry,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...(0, $19nmp.messages).try_again
                })
            })
        ]
    });

});
parcelRegister("05blM", function(module, exports) {

$parcel$export(module.exports, "Frame", () => $5e19ca37647e9fa5$export$b89a827e9254211a);
/* ErrorFrame.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");
parcelRequire("eJOHy");
const $5e19ca37647e9fa5$export$b89a827e9254211a = (props = {
    isSelected: false,
    isHoverable: false,
    isFluidHeight: false
})=>props.compact ? /*#__PURE__*/ (0, $gt9Am.jsx)($5e19ca37647e9fa5$export$f862a410248f4f00, {
        ...props
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)($5e19ca37647e9fa5$export$7b360cd785b6c366, {
        ...props
    });
const $5e19ca37647e9fa5$var$sharedBaseFrameStyles = null;
const $5e19ca37647e9fa5$var$sharedFrameStyles = null;
const $5e19ca37647e9fa5$var$expandedFrameHoverStyles = null;
const $5e19ca37647e9fa5$var$expandedFrameFluidHeightTrueStyles = null;
const $5e19ca37647e9fa5$var$expandedFrameFluidHeightFalseStyles = null;
const $5e19ca37647e9fa5$var$expandedFrameSelectedStyles = null;
const $5e19ca37647e9fa5$var$expandedFrameNotSelectedStyles = null;
const $5e19ca37647e9fa5$var$expandedFrameStyles = null;
const $5e19ca37647e9fa5$export$7b360cd785b6c366 = ({ children: children, isSelected: isSelected, isHoverable: isHoverable, testId: testId, className: className, isFluidHeight: isFluidHeight })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            "_1bsb1osq _1e0c1txw",
            "_p12fukw8 _bfhkhp5a",
            isHoverable && "_irr3k6hx _d0altlke",
            isFluidHeight ? "_1tkeidpf" : "_1tke68cl",
            isSelected ? "_2rko1l7b _1h6d1can _1dqonqa1 _189eyh40" : "_2rko1lya _1h6d3acm _1dqonqa1 _189eyh40",
            "_1reo15vq _18m915vq _1bah1yb4 _16qs1os1",
            className
        ]),
        "data-trello-do-not-use-override": testId,
        children: children
    });
};
const $5e19ca37647e9fa5$var$compactFrameHoverStyles = null;
const $5e19ca37647e9fa5$var$compactFrameInheritDimensionsTrueStyles = null;
const $5e19ca37647e9fa5$var$compactFrameInheritDimensionsFalseStyles = null;
const $5e19ca37647e9fa5$var$compactFrameAlignStyles = null;
const $5e19ca37647e9fa5$var$compactFrameStyles = null;
const $5e19ca37647e9fa5$var$compactFrameNotSelectedStyles = null;
const $5e19ca37647e9fa5$export$f862a410248f4f00 = ({ children: children, isHoverable: isHoverable, isSelected: isSelected, testId: testId, className: className, inheritDimensions: inheritDimensions })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            "_1bsb1osq _1e0c1txw",
            "_p12fukw8 _bfhkhp5a",
            isHoverable && "_irr3yw9d",
            isSelected && "_2rko1l7b _1h6d1can _1dqonqa1 _189eyh40",
            !isSelected && "_2rko1lya",
            "_1bah1h6o _4cvr1h6o _bfhkiw92",
            inheritDimensions ? "_4t3i1osq" : "_4t3i1ylp",
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bsb1osq",
            className
        ]),
        children: children
    });
};

});


parcelRegister("i53U1", function(module, exports) {

$parcel$export(module.exports, "default", () => $1cede8882a7ef616$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $goZPP = parcelRequire("goZPP");

var $5CSKW = parcelRequire("5CSKW");

var $eGOwo = parcelRequire("eGOwo");

var $19nmp = parcelRequire("19nmp");

var $idDkX = parcelRequire("idDkX");

var $l22Ft = parcelRequire("l22Ft");

var $hVxRW = parcelRequire("hVxRW");
const $1cede8882a7ef616$var$ForbiddenView = ({ context: context, onAuthorize: onAuthorize, accessContext: accessContext, testId: testId = 'embed-card-forbidden-view', ...unresolvedViewProps })=>{
    const { icon: icon, image: image, text: text = '' } = context ?? {};
    const { accessType: accessType, hostname: hostname, titleMessageKey: titleMessageKey, descriptiveMessageKey: descriptiveMessageKey, callToActionMessageKey: callToActionMessageKey, action: action } = accessContext ?? {};
    const values = (0, $eJOHy.useMemo)(()=>{
        const product = context?.text ?? '';
        return {
            context: product,
            product: product,
            hostname: /*#__PURE__*/ (0, $gt9Am.jsx)("b", {
                children: hostname
            })
        };
    }, [
        hostname,
        context?.text
    ]);
    /**
	 * if there is a request access context, but no action to perform, do not show any button.
	 * By default, a "Try another account" button shows, but with request access context, we don't
	 * want to encourage users to try another account, if their request is already pending, etc.
	 */ const button = (0, $eJOHy.useMemo)(()=>{
        const onEmbedCardClick = action?.promise ?? onAuthorize;
        if (!onEmbedCardClick) return null;
        const ButtonComponent = (0, $eGOwo.fg)('platform-smart-card-remove-legacy-button') ? (0, $5CSKW.default) : (0, $goZPP.default);
        return /*#__PURE__*/ (0, $gt9Am.jsx)(ButtonComponent, {
            testId: `button-${action?.id || 'connect-other-account'}`,
            appearance: "primary",
            onClick: onEmbedCardClick,
            isDisabled: accessType === 'PENDING_REQUEST_EXISTS',
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $idDkX.toMessage)((0, $19nmp.messages).try_another_account, callToActionMessageKey),
                values: values
            })
        });
    }, [
        accessType,
        action?.id,
        action?.promise,
        callToActionMessageKey,
        onAuthorize,
        values
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $l22Ft.default), {
        ...unresolvedViewProps,
        icon: icon,
        image: image ?? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hVxRW.ForbiddenSVG), {}),
        testId: testId,
        text: text,
        title: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $idDkX.toMessage)((0, $19nmp.messages).invalid_permissions, titleMessageKey),
            values: values
        }),
        description: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $idDkX.toMessage)((0, $19nmp.messages).invalid_permissions_description, descriptiveMessageKey),
            values: values
        }),
        button: button
    });
};
var $1cede8882a7ef616$export$2e2bcd8739ae039 = $1cede8882a7ef616$var$ForbiddenView;

});
parcelRegister("l22Ft", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe0a8b05351117ab$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $806LH = parcelRequire("806LH");

var $av9Of = parcelRequire("av9Of");

var $2l8bu = parcelRequire("2l8bu");

var $gegRH = parcelRequire("gegRH");
const $fe0a8b05351117ab$var$containerStyles = null;
const $fe0a8b05351117ab$var$contentStyles = null;
const $fe0a8b05351117ab$var$descriptionStyles = null;
const $fe0a8b05351117ab$var$imageStyles = null;
const $fe0a8b05351117ab$var$UnresolvedView = ({ button: button, description: description, frameStyle: frameStyle, icon: iconUrlOrElement, image: imageUrlOrElement, inheritDimensions: inheritDimensions, isSelected: isSelected, onClick: onClick, testId: testId, text: text, title: title, url: url })=>{
    const icon = (0, $eJOHy.useMemo)(()=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(iconUrlOrElement)) return iconUrlOrElement;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gegRH.ImageIcon), {
            src: typeof iconUrlOrElement === 'string' ? iconUrlOrElement : undefined,
            default: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($av9Of))), {
                label: "icon",
                LEGACY_size: "small",
                testId: "embed-card-fallback-icon",
                color: "currentColor"
            })
        });
    }, [
        iconUrlOrElement
    ]);
    const image = (0, $eJOHy.useMemo)(()=>{
        if (!imageUrlOrElement) return null;
        const imageTestId = `${testId}-unresolved-image`;
        if (typeof imageUrlOrElement === 'string') return /*#__PURE__*/ (0, $gt9Am.jsx)("img", {
            "data-testid": imageTestId,
            src: imageUrlOrElement,
            alt: "",
            className: (0, $hcewu.default)([
                "_4t3i68cl _1bsbmgvx _5ral1f51 _rsufaqso"
            ])
        });
        return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            "data-testid": imageTestId,
            className: (0, $hcewu.default)([
                "_4t3i68cl _1bsbmgvx _5ral1f51 _rsufaqso"
            ]),
            children: imageUrlOrElement
        });
    }, [
        imageUrlOrElement,
        testId
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2l8bu.ExpandedFrame), {
        // Scroll bar must be shown for unresolved views to display the connect account button
        allowScrollBar: true,
        setOverflow: true,
        // EDM-9259: Fix embed frame showing on unresolved views when frameStyle is set to hide.
        // Set fallback to 'show' here to maintain the current behaviour when platform.editor.show-embed-card-frame-renderer is OFF.
        // Remove 'show' on platform.editor.show-embed-card-frame-renderer cleanup as frameStyle will be set to 'show' both in renderer and editor.
        // We want all views to be consistent and respect frameStyle instead of
        // having resolved view default to showOnHover and unresolved view default to show.
        // Default frameStyle is set inside <ExpandedFrame />
        frameStyle: frameStyle ?? 'show',
        href: url,
        icon: icon,
        inheritDimensions: inheritDimensions,
        isSelected: isSelected,
        onClick: onClick,
        testId: testId,
        text: text,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            "data-testid": `${testId}-unresolved-container`,
            className: (0, $hcewu.default)([
                "_1e0c11p5 _4t3i1kw7"
            ]),
            children: /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
                className: (0, $hcewu.default)([
                    "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _zulpv47k _1e0c1txw _2lx21bp4 _1bah1h6o _y3gn1h6o _4cvr1h6o _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _p12f1kdj"
                ]),
                children: [
                    image,
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $806LH.default), {
                        size: "large",
                        testId: `${testId}-unresolved-title`,
                        children: title
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                        "data-testid": `${testId}-unresolved-description`,
                        className: (0, $hcewu.default)([
                            "_11c82smr _y3gn1h6o"
                        ]),
                        children: description
                    }),
                    button
                ]
            })
        })
    });
};
var $fe0a8b05351117ab$export$2e2bcd8739ae039 = $fe0a8b05351117ab$var$UnresolvedView;

});
parcelRegister("2l8bu", function(module, exports) {

$parcel$export(module.exports, "ExpandedFrame", () => $5f28b71e696600f5$export$7b360cd785b6c366);
/* ExpandedFrame.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eGOwo = parcelRequire("eGOwo");

var $k71qx = parcelRequire("k71qx");

var $e3qu2 = parcelRequire("e3qu2");

var $dDP8i = parcelRequire("dDP8i");

var $65oSX = parcelRequire("65oSX");
const $5f28b71e696600f5$export$7b360cd785b6c366 = ({ isPlaceholder: isPlaceholder = false, children: children, onClick: onClick, icon: icon, text: text, isSelected: isSelected, frameStyle: frameStyle = 'showOnHover', href: href, minWidth: minWidth, maxWidth: maxWidth, testId: testId = 'expanded-frame', inheritDimensions: inheritDimensions, allowScrollBar: allowScrollBar = false, setOverflow: setOverflow = true, CompetitorPrompt: CompetitorPrompt })=>{
    const isInteractive = ()=>!isPlaceholder && (Boolean(href) || Boolean(onClick));
    const handleClick = (event)=>(0, $dDP8i.handleClickCommon)(event, onClick);
    const handleMouseDown = (0, $e3qu2.useMouseDownEvent)();
    // Note: cleanup fg based on results of prompt_whiteboard_competitor_link experiment
    const CompetitorPromptComponent = CompetitorPrompt && href && (0, $eGOwo.fg)('prompt_whiteboard_competitor_link_gate') ? /*#__PURE__*/ (0, $gt9Am.jsx)(CompetitorPrompt, {
        sourceUrl: href,
        linkType: "embed"
    }) : null;
    const renderHeader = ()=>{
        return frameStyle !== 'hide' && /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
            className: (0, $hcewu.default)([
                $5f28b71e696600f5$var$styles.header,
                "embed-header"
            ]),
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
                    className: (0, $hcewu.default)([
                        $5f28b71e696600f5$var$styles.leftSection
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                            className: (0, $hcewu.default)([
                                $5f28b71e696600f5$var$styles.headerIcon
                            ]),
                            children: icon
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                            className: (0, $hcewu.default)([
                                $5f28b71e696600f5$var$styles.tooltipWrapper
                            ]),
                            children: !isPlaceholder && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
                                content: text,
                                hideTooltipOnMouseDown: true,
                                children: /*#__PURE__*/ (0, $gt9Am.jsx)("a", {
                                    href: href,
                                    onClick: handleClick,
                                    onMouseDown: handleMouseDown,
                                    className: (0, $hcewu.default)([
                                        $5f28b71e696600f5$var$styles.headerAnchor
                                    ]),
                                    children: text
                                })
                            })
                        })
                    ]
                }),
                CompetitorPromptComponent
            ]
        });
    };
    const interactive = isInteractive();
    const showBackgroundAlways = frameStyle === 'show' || isSelected && frameStyle !== 'hide';
    const showBackgroundOnHover = interactive && frameStyle !== 'hide';
    const renderContent = ()=>{
        return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            "data-testid": "embed-content-wrapper",
            // This fixes an issue with input fields in cross domain iframes (ie. databases and jira fields from different domains)
            // See: HOT-107830
            contentEditable: false,
            className: (0, $hcewu.default)([
                $5f28b71e696600f5$var$styles.contentStyle,
                setOverflow && allowScrollBar && $5f28b71e696600f5$var$styles.contentOverflowAuto,
                interactive && !showBackgroundAlways && !showBackgroundOnHover && $5f28b71e696600f5$var$styles.contentInteractiveActiveBorder
            ]),
            children: children
        });
    };
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            $5f28b71e696600f5$var$styles.linkWrapper,
            inheritDimensions && $5f28b71e696600f5$var$styles.linkWrapperInheritDimensions,
            isSelected && frameStyle !== 'hide' && $5f28b71e696600f5$var$styles.linkWrapperSelected,
            showBackgroundAlways && $5f28b71e696600f5$var$styles.linkWrapperBorderAndBackground,
            showBackgroundOnHover && !showBackgroundAlways && $5f28b71e696600f5$var$styles.linkWrapperInteractiveNotHidden,
            (0, $65oSX.className)
        ]),
        style: {
            minWidth: minWidth ? `${minWidth}px` : '',
            maxWidth: maxWidth ? `${maxWidth}px` : ''
        },
        "data-testid": testId,
        "data-trello-do-not-use-override": testId,
        // Due to limitations of testing library, we can't assert ::after
        "data-is-selected": isSelected,
        ...(isPlaceholder || !href) && {
            'data-wrapper-type': 'default',
            'data-is-interactive': isInteractive()
        },
        children: [
            renderHeader(),
            renderContent()
        ]
    });
};
const $5f28b71e696600f5$var$styles = {
    linkWrapper: "_zulpu2gc _kqswh2mm _1e0c1txw _2lx21bp4 _4t3ik5xz _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _uiztglyw _qc5o94zs _14mj1crf _aetrb3bt _18postnw _15l2idpf _32rxidpf _1x88idpf _19doidpf _1hfk18uv _1bqqidpf _u94kidpf _1ifiidpf",
    linkWrapperInheritDimensions: "_4t3i1osq",
    linkWrapperSelected: "_8x3u92p9",
    linkWrapperBorderAndBackground: "_1tqzzgxb _1hfkhp5a _1ifikb7n",
    linkWrapperInteractiveNotHidden: "_hcgvzgxb _4tpuhp5a _x148kb7n",
    header: "_11c8140y _zulp1b66 _1e0c1txw _4cvr1h6o _1bah1yb4 _4t3igktf _1pbykb7n",
    leftSection: "_zulp1b66 _1e0c1txw _4cvr1h6o _1ul9idpf",
    tooltipWrapper: "_1reo15vq _18m915vq",
    headerAnchor: "_11c8140y _1reo15vq _18m915vq _1e0c1ule _1bto1l2s _o5721q9c _9oik18uv _1bnxglyw _jf4cnqa1",
    headerIcon: "_11c8140y _1bsb7vkz _4t3i7vkz",
    contentStyle: "_19it1pvm _2rko1y44 _1reo15vq _18m915vq _v56414au _bfhkhp5a _16jlkb7n _4t3i1osq _1pbykb7n",
    contentInteractiveActiveBorder: "_1jhm1ips",
    contentOverflowAuto: "_1reo1wug _18m91wug"
};

});
parcelRegister("65oSX", function(module, exports) {

$parcel$export(module.exports, "className", () => $11f8274f575811f3$export$2913c0c0b5623090);
$parcel$export(module.exports, "embedHeaderHeight", () => $11f8274f575811f3$export$8f5a73ba0d077b01);
$parcel$export(module.exports, "Image", () => $11f8274f575811f3$export$3e431a229df88919);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-dynamic-styles */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");
const $11f8274f575811f3$export$2913c0c0b5623090 = 'media-card-frame';
const $11f8274f575811f3$export$8f5a73ba0d077b01 = 32;
const $11f8274f575811f3$var$getSizeWithUnit = (value = '100%')=>{
    const unit = typeof value === 'number' ? 'px' : '';
    return `${value}${unit}`;
};
const $11f8274f575811f3$export$3e431a229df88919 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_rcxkve": (0, $awdRS.default)($11f8274f575811f3$var$getSizeWithUnit(__cmplp.size))
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko1sit _1reo15vq _18m915vq _1bsb17ym _4t3i17ym",
            __cmplp.className
        ])
    });
});
const $11f8274f575811f3$export$1cd1efc78cb52ca5 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_13orr8u": (0, $awdRS.default)(`url(${__cmplp.src})`)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko1sit _1bsbckbl _4t3ickbl _1aaxusic _19pk1b66 _2hwxidpf _otyrutpp _18u0utpp _bfhkqrzy _1lrw1dfr _1itk2pcs",
            __cmplp.className
        ])
    });
});

});


parcelRegister("gegRH", function(module, exports) {

$parcel$export(module.exports, "ImageIcon", () => $28cc40acfaa5a547$export$4a122bafaa48b23d);
/* ImageIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");
parcelRequire("eJOHy");

var $2HNHt = parcelRequire("2HNHt");

var $eGOwo = parcelRequire("eGOwo");

var $65oSX = parcelRequire("65oSX");
const $28cc40acfaa5a547$var$styles = {
    roundedImage: "_2rko14q2"
};
const $28cc40acfaa5a547$export$4a122bafaa48b23d = ({ alt: alt = '', src: src, size: size = 16, title: title, default: defaultIcon, appearance: appearance = 'square' })=>{
    // TODO: do we need this?
    if (!src) return defaultIcon || null;
    const LoadedImageComponent = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $65oSX.Image), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hcewu.default)([
            appearance === 'round' && (0, $eGOwo.fg)('platform-linking-visual-refresh-v2') && $28cc40acfaa5a547$var$styles.roundedImage,
            "smart-link-icon"
        ]),
        src: src,
        alt: alt,
        size: size,
        title: title
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2HNHt))), {
        src: src,
        loading: defaultIcon,
        loaded: LoadedImageComponent,
        errored: defaultIcon
    });
};

});


parcelRegister("hVxRW", function(module, exports) {

$parcel$export(module.exports, "ForbiddenSVG", () => $d57be4b9de9beae3$export$f51768a4e7ff128);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
const $d57be4b9de9beae3$export$f51768a4e7ff128 = ()=>/*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
        viewBox: "0 0 168.8372 221.4874",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        height: "100%",
        width: "100%",
        preserveAspectRatio: "xMidYMid meet",
        "data-testid": "forbidden-svg",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                id: "a",
                gradientUnits: "userSpaceOnUse",
                x1: "49.4199",
                x2: "122.662",
                y1: "59.7673",
                y2: "59.7673",
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                        offset: "0",
                        stopColor: "#0065ff"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                        offset: ".2188",
                        stopColor: "#0b6cff"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                        offset: ".5999",
                        stopColor: "#2780ff"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                        offset: "1",
                        stopColor: "#4c9aff"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "m122.662 119.5347h-73.242v-82.9141a36.6211 36.6211 0 0 1 73.2422 0zm-61.2422-12h49.2422v-70.9141a24.6211 24.6211 0 0 0 -49.2422 0z",
                fill: "url(#a)"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "m160.3239 111.17a65.4958 65.4958 0 0 1 -5.657-46.1172l.0022-.0088a5.0533 5.0533 0 0 0 -4.9039-6.273h-130.6932a5.0533 5.0533 0 0 0 -4.9038 6.273l.0015.0057a66.1488 66.1488 0 0 1 -5.7847 46.3674 75.4908 75.4908 0 0 0 65.21 110.0468c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0645-.0009.0969 0h.0027c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0332.0008.0652-.0009.0977 0h.0023c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0026c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0025c.0325.0008.0643-.0009.0968 0h.0032c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0016c.0333.0008.0651-.0009.0975 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0025c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0025c.0333.0008.0651-.0009.0975 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0026c.0332.0008.0652-.0009.0977 0h.0023c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0026c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0031c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0016c.0333.0008.0651-.0009.0975 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0025c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0651-.0009.0975 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0025c.0333.0008.0652-.0009.0977 0h.0023c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024a75.491 75.491 0 0 0 68.8626-110.2939z",
                fill: "#de350b"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "m154.6669 65.0531.0022-.0088a5.0533 5.0533 0 0 0 -4.9039-6.273h-112.8264a5.0533 5.0533 0 0 0 -4.9039 6.273l.0014.0057a66.1491 66.1491 0 0 1 -5.7845 46.3674 75.4854 75.4854 0 1 0 134.072-.2471 65.4957 65.4957 0 0 1 -5.6569-46.1172z",
                fill: "#ff5630"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "m93.3523 213.6q-.8454 0-1.6973-.0205a67.6029 67.6029 0 0 1 -58.3963-98.5383 74.3762 74.3762 0 0 0 7.2113-48.3823h105.7618a73.488 73.488 0 0 0 7.0986 48.16 67.6006 67.6006 0 0 1 -59.9755 98.7811z",
                fill: "#ff7452"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "m90.0071 176.8851a16.3079 16.3079 0 0 1 -16.1149-18.8193l2.23-14.3217a24.1482 24.1482 0 0 1 16.087-41.053c.3821-.0176.7658-.0265 1.1435-.0265a24.1491 24.1491 0 0 1 17.229 41.0809l2.2312 14.32a16.31 16.31 0 0 1 -16.1149 18.8193z",
                fill: "#ff5630"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "m108.481 126.8237a15.0613 15.0613 0 0 1 -4.83 11.0676 7.2219 7.2219 0 0 0 -2.1218 6.4121l2.3594 15.1531a7.2783 7.2783 0 0 1 -7.1916 8.3981h-6.69a7.2783 7.2783 0 0 1 -7.1916-8.3981l2.3872-15.3318a7.2321 7.2321 0 0 0 -2.2684-6.345 15.0639 15.0639 0 0 1 -4.6905-11.7523 15.1293 15.1293 0 0 1 30.2376.7963z",
                fill: "#de350b"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                d: "m82.8151 159.4565a7.2565 7.2565 0 1 0 14.3328 0l-2.3594-15.1531a7.2215 7.2215 0 0 1 2.1217-6.4121 15.1041 15.1041 0 0 0 -6.9452-25.804 15.2678 15.2678 0 0 0 -11.7216 13.94 15.0634 15.0634 0 0 0 4.6906 11.7527 7.232 7.232 0 0 1 2.2683 6.3449z",
                fill: "#344563"
            })
        ]
    });

});


parcelRegister("5RX8x", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fc831c55b9e606a$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $19nmp = parcelRequire("19nmp");

var $idDkX = parcelRequire("idDkX");

var $l22Ft = parcelRequire("l22Ft");

var $KprKQ = parcelRequire("KprKQ");
const $9fc831c55b9e606a$var$NotFoundView = ({ context: context, accessContext: accessContext, testId: testId = 'embed-card-not-found-view', ...unresolvedViewProps })=>{
    const { icon: icon, image: image, text: text = '' } = context ?? {};
    const { titleMessageKey: titleMessageKey, descriptiveMessageKey: descriptiveMessageKey } = accessContext ?? {};
    const values = (0, $eJOHy.useMemo)(()=>({
            product: text
        }), [
        text
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $l22Ft.default), {
        ...unresolvedViewProps,
        icon: icon,
        image: image ?? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $KprKQ.NotFoundSVG), {}),
        testId: testId,
        text: text,
        title: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $idDkX.toMessage)((0, $19nmp.messages).not_found_title, titleMessageKey),
            values: values
        }),
        description: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $idDkX.toMessage)((0, $19nmp.messages).not_found_description, descriptiveMessageKey),
            values: values
        })
    });
};
var $9fc831c55b9e606a$export$2e2bcd8739ae039 = $9fc831c55b9e606a$var$NotFoundView;

});
parcelRegister("KprKQ", function(module, exports) {

$parcel$export(module.exports, "NotFoundSVG", () => $8c23d6ed0b92caba$export$80542c1714a314c8);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
const $8c23d6ed0b92caba$export$80542c1714a314c8 = ()=>/*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        viewBox: "0 0 200.55 269.99",
        height: "100%",
        width: "100%",
        preserveAspectRatio: "xMidYMid meet",
        "data-testid": "not-found-svg",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient",
                        x1: "1316.98",
                        y1: "230.66",
                        x2: "1396.36",
                        y2: "230.66",
                        gradientTransform: "matrix(-1, 0, 0, 1, 1517.54, 0)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#344563"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#6c798f"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "linear-gradient-2",
                        x1: "170.3",
                        y1: "897.49",
                        x2: "365.15",
                        y2: "897.49",
                        gradientTransform: "translate(-125.06 -762.9) rotate(4.81)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0",
                                stopColor: "#fff"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.69",
                                stopColor: "#fff",
                                stopOpacity: "0.1"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("title", {
                children: "Search error"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("g", {
                id: "Layer_2",
                "data-name": "Layer 2",
                children: /*#__PURE__*/ (0, $gt9Am.jsxs)("g", {
                    id: "Objects",
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fill: "#cfd4db",
                            d: "M126.84,210.1l-9.51-9.39,13-13.23,9.52,9.39a18,18,0,0,0,8.82,4.78h0a18.06,18.06,0,0,1,8.82,4.79l38.59,38.09a14.87,14.87,0,0,1,.13,21h0a14.87,14.87,0,0,1-21,.14l-38.59-38.09a18,18,0,0,1-4.9-8.75h0A18,18,0,0,0,126.84,210.1Z"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            id: "_Path_",
                            "data-name": "<Path>",
                            fill: "url(#linear-gradient)",
                            d: "M126.84,210.1l-2.9-2.86a9.31,9.31,0,0,1-.09-13.15h0A9.3,9.3,0,0,1,137,194l2.9,2.86a18,18,0,0,0,8.82,4.78h0a18.06,18.06,0,0,1,8.82,4.79l38.59,38.09a14.87,14.87,0,0,1,.13,21h0a14.87,14.87,0,0,1-21,.14l-38.59-38.09a18,18,0,0,1-4.9-8.75h0A18,18,0,0,0,126.84,210.1Z"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fill: "#091e42",
                            opacity: 0.1,
                            d: "M131.63,218.46a18,18,0,0,0-4.79-8.36l-2.9-2.86a9.31,9.31,0,0,1-.09-13.15h0A9.3,9.3,0,0,1,137,194l2.9,2.86a18,18,0,0,0,8.41,4.68,79.1,79.1,0,0,1-7.72,9.12A77.4,77.4,0,0,1,131.63,218.46Z"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fill: "#344563",
                            d: "M155.47,145.8A77.74,77.74,0,0,0,22.41,91.7,77.24,77.24,0,0,0,0,146.82H0a77.22,77.22,0,0,0,23.13,54.81h0A77.74,77.74,0,0,0,155.47,145.8Z"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            id: "_Clipping_Path_",
                            "data-name": "<Clipping Path>",
                            fill: "#deebff",
                            d: "M35.62,104.74a59.17,59.17,0,1,1-17.06,42A58.81,58.81,0,0,1,35.62,104.74Z"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            id: "_Path_2",
                            "data-name": "<Path>",
                            fill: "#b2d4ff",
                            d: "M39.54,101.12A59.19,59.19,0,1,0,82.69,87.36,58.82,58.82,0,0,0,39.54,101.12Z"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fill: "#cce0ff",
                            d: "M78.09,94.6a59.17,59.17,0,0,0-52.5,23.71,59.2,59.2,0,0,0,99.68,63.28,59.2,59.2,0,0,0-47.18-87Z"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fill: "url(#linear-gradient-2)",
                            d: "M72.77,205.3A59.25,59.25,0,0,0,133.92,165a59.2,59.2,0,0,1-6.42.62c-19.4.74-33.31-8.64-40-13.32-20.19-14-20.75-28.19-33.7-41.34A56,56,0,0,0,40,100.76l-.44.36A59.18,59.18,0,0,0,72.77,205.3Z"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("polygon", {
                            id: "_Path_3",
                            "data-name": "<Path>",
                            fill: "#5e6c84",
                            points: "105.15 132.36 94.03 121.33 78.7 136.79 63.24 121.45 52.22 132.57 67.68 147.9 52.34 163.35 63.45 174.38 78.79 158.92 94.24 174.26 105.27 163.15 89.81 147.81 105.15 132.36"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fill: "#ffc400",
                            d: "M82.29,29.4,72.12.45A.68.68,0,0,0,70.81.6L67.53,28.65l-6.48-.75a.67.67,0,0,0-.72.89l10.17,29a.68.68,0,0,0,1.31-.15l3.28-28.05,6.48.76A.68.68,0,0,0,82.29,29.4Z"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fill: "#ffc400",
                            d: "M50.28,47.8,37.64,39.17a.29.29,0,0,0-.42.39l7,12.21-2.84,1.62a.29.29,0,0,0,0,.5L54,62.52a.3.3,0,0,0,.43-.39l-7-12.21,2.84-1.62A.29.29,0,0,0,50.28,47.8Z"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fill: "none",
                            strokeLinecap: "round",
                            strokeMiterlimit: 10,
                            strokeWidth: "2px",
                            stroke: "#344563",
                            d: "M104.31,36.05c-.7,2.07-9.75-1-10.44,1.11s8.35,5.11,7.66,7.18-9.75-1-10.44,1.12,8.35,5.11,7.66,7.18-9.75-1-10.44,1.12S96.66,58.87,96,61"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fill: "none",
                            strokeLinecap: "round",
                            strokeMiterlimit: 10,
                            strokeWidth: "2px",
                            stroke: "#5e6c84",
                            d: "M125.53,59.72c-1.59,1.49-7.85-5.2-9.45-3.71s4.66,8.19,3.06,9.69-7.86-5.21-9.46-3.72c-.74.7.21,2.51,1.28,4.4"
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                            fill: "none",
                            strokeLinecap: "round",
                            strokeMiterlimit: 10,
                            strokeWidth: "2px",
                            stroke: "#5e6c84",
                            d: "M20.83,59.86c2.17.27,1.06,9.37,3.23,9.63s3.28-8.83,5.46-8.57,1.05,9.37,3.22,9.63c1,.13,1.79-1.76,2.56-3.8"
                        })
                    ]
                })
            })
        ]
    });

});


parcelRegister("h9g6U", function(module, exports) {

$parcel$export(module.exports, "EmbedCardResolvedView", () => $367ff287c16eda7a$export$30f3c6c32b384a8b);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $av9Of = parcelRequire("av9Of");

var $eGOwo = parcelRequire("eGOwo");

var $58yRG = parcelRequire("58yRG");

var $FoFt2 = parcelRequire("FoFt2");

var $2l8bu = parcelRequire("2l8bu");

var $e3qHE = parcelRequire("e3qHE");

var $gegRH = parcelRequire("gegRH");
const $367ff287c16eda7a$export$30f3c6c32b384a8b = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef(({ link: link, context: context, onClick: onClick, isSelected: isSelected, frameStyle: frameStyle, preview: preview, title: title, isTrusted: isTrusted, testId: testId = 'embed-card-resolved-view', inheritDimensions: inheritDimensions, onIframeDwell: onIframeDwell, onIframeFocus: onIframeFocus, isSupportTheming: isSupportTheming, type: type, CompetitorPrompt: CompetitorPrompt }, embedIframeRef)=>{
    const iconFromContext = context?.icon;
    const src = typeof iconFromContext === 'string' ? iconFromContext : undefined;
    const text = title || context?.text;
    const linkGlyph = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useMemo(()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($av9Of))), {
            label: "icon",
            LEGACY_size: "small",
            testId: "embed-card-fallback-icon",
            color: "currentColor"
        }), []);
    const profileType = (0, $FoFt2.isProfileType)(type) && (0, $eGOwo.fg)('platform-linking-visual-refresh-v2');
    let icon = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useMemo(()=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).isValidElement(iconFromContext)) return iconFromContext;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gegRH.ImageIcon), {
            src: src,
            default: linkGlyph,
            ...(0, $eGOwo.fg)('platform-linking-visual-refresh-v2') && {
                appearance: profileType ? 'round' : 'square'
            }
        });
    }, [
        iconFromContext,
        src,
        linkGlyph,
        profileType
    ]);
    const themeState = (0, $58yRG.default)();
    let previewUrl = preview?.src;
    if (previewUrl && isSupportTheming) previewUrl = (0, $FoFt2.getPreviewUrlWithTheme)(previewUrl, themeState);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2l8bu.ExpandedFrame), {
        isSelected: isSelected,
        frameStyle: frameStyle,
        href: link,
        testId: testId,
        icon: icon,
        text: text,
        onClick: onClick,
        inheritDimensions: inheritDimensions,
        setOverflow: false,
        CompetitorPrompt: CompetitorPrompt,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $e3qHE.Frame), {
            url: previewUrl,
            isTrusted: isTrusted,
            testId: testId,
            ref: embedIframeRef,
            onIframeDwell: onIframeDwell,
            onIframeFocus: onIframeFocus,
            title: text
        })
    });
});

});
parcelRegister("e3qHE", function(module, exports) {

$parcel$export(module.exports, "Frame", () => $32febd87e387ddae$export$b89a827e9254211a);
/* Frame.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");

var $FoFt2 = parcelRequire("FoFt2");

var $hprWR = parcelRequire("hprWR");

var $RCgNH = parcelRequire("RCgNH");
function $32febd87e387ddae$var$mergeRefs(refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === 'function') ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}
const $32febd87e387ddae$var$iframeStyles = null;
const $32febd87e387ddae$export$b89a827e9254211a = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef(({ url: url, isTrusted: isTrusted = false, testId: testId, onIframeDwell: onIframeDwell, onIframeFocus: onIframeFocus, title: title }, iframeRef)=>{
    (0, $gRw8I.di)((0, $hprWR.IFrame));
    const [isIframeLoaded, setIframeLoaded] = (0, $eJOHy.useState)(false);
    const [isMouseOver, setMouseOver] = (0, $eJOHy.useState)(false);
    const [isWindowFocused, setWindowFocused] = (0, $eJOHy.useState)(true);
    const ref = (0, $eJOHy.useRef)();
    const mergedRef = $32febd87e387ddae$var$mergeRefs([
        iframeRef,
        ref
    ]);
    const [percentVisible, setPercentVisible] = (0, $eJOHy.useState)(0);
    /**
   * These are the 'percent visible' thresholds at which the intersectionObserver will
   * trigger a state change. Eg. when the user scrolls and moves from 74% to 76%, or
   * vice versa. It's in a state object so that its static for the useEffect
   */ const [threshold] = (0, $eJOHy.useState)([
        0.75,
        0.8,
        0.85,
        0.9,
        0.95,
        1
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!ref || !ref.current) return;
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                setPercentVisible(entry?.intersectionRatio);
            });
        }, {
            threshold: threshold
        });
        observer.observe(ref.current);
        return ()=>{
            observer.disconnect();
        };
    }, [
        threshold,
        mergedRef
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const onBlur = ()=>{
            setWindowFocused(false);
            if (document.activeElement === ref.current) onIframeFocus && onIframeFocus();
        };
        const onFocus = ()=>{
            setWindowFocused(true);
        };
        window.addEventListener('blur', onBlur);
        window.addEventListener('focus', onFocus);
        return ()=>{
            window.removeEventListener('blur', onBlur);
            window.removeEventListener('focus', onFocus);
        };
    }, [
        ref,
        onIframeFocus
    ]);
    if (!url) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $RCgNH.IframeDwellTracker), {
                isIframeLoaded: isIframeLoaded,
                isMouseOver: isMouseOver,
                isWindowFocused: isWindowFocused,
                iframePercentVisible: percentVisible,
                onIframeDwell: onIframeDwell
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hprWR.IFrame), {
                childRef: mergedRef,
                src: url,
                "data-testid": `${testId}-frame`,
                "data-iframe-loaded": isIframeLoaded,
                onMouseEnter: ()=>setMouseOver(true),
                onMouseLeave: ()=>setMouseOver(false),
                allowFullScreen: true,
                scrolling: "yes",
                allow: "autoplay; encrypted-media; clipboard-write",
                onLoad: ()=>{
                    setIframeLoaded(true);
                },
                sandbox: (0, $FoFt2.getIframeSandboxAttribute)(isTrusted),
                title: title,
                className: (0, $hcewu.default)([
                    "_19itidpf _1reo15vq _18m915vq _2rko1l7b _154iidpf _1ltvidpf _1bsb1osq _4t3i1osq _kqswh2mm"
                ])
            })
        ]
    });
});

});
parcelRegister("hprWR", function(module, exports) {

$parcel$export(module.exports, "IFrame", () => $0dab6c672ddaa5a8$export$b32b5f1ee4493319);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
const $0dab6c672ddaa5a8$export$b32b5f1ee4493319 = ({ childRef: childRef, className: className, ...props })=>{
    // eslint-disable-next-line jsx-a11y/iframe-has-title,@atlaskit/ui-styling-standard/no-classname-prop
    return /*#__PURE__*/ (0, $gt9Am.jsx)("iframe", {
        className: className,
        ...props,
        ref: childRef
    });
};

});

parcelRegister("RCgNH", function(module, exports) {

$parcel$export(module.exports, "IframeDwellTracker", () => $069958df693c5c51$export$e3cb965901aecabd);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");
/**
 * A kind of cheap logarithmic backoff. Fire analytics after the user has
 * dwelled for 5 seconds, then 10 seconds, and so on.
 */ const $069958df693c5c51$var$INTERVALS_TO_LOG = [
    5,
    10,
    15,
    20,
    25,
    30,
    45,
    60,
    90,
    120,
    180
];
const $069958df693c5c51$export$e3cb965901aecabd = ({ isIframeLoaded: isIframeLoaded, isMouseOver: isMouseOver, isWindowFocused: isWindowFocused, iframePercentVisible: iframePercentVisible, onIframeDwell: onIframeDwell })=>{
    const [dwell, setDwell] = (0, $eJOHy.useState)({
        time: 0,
        percentVisible: 0
    });
    const dwellTimeoutId = (0, $eJOHy.useRef)();
    // fire analytics when the dwell timer reaches 5 seconds
    (0, $eJOHy.useEffect)(()=>{
        if (dwell.time > 0 && $069958df693c5c51$var$INTERVALS_TO_LOG.includes(dwell.time)) onIframeDwell && onIframeDwell(dwell.time, dwell.percentVisible);
    }, [
        dwell,
        onIframeDwell
    ]);
    // start and stop tracking dwell time
    (0, $eJOHy.useEffect)(()=>{
        const incrementDwellTime = ()=>{
            // callback is called on dwell state changes, so change percentVisible and time together
            setDwell(({ time: time })=>{
                return {
                    time: time + 1,
                    // snapshot of percent visible, rounded down to nearest 5%
                    percentVisible: Math.floor((iframePercentVisible || 0) * 20) * 5
                };
            });
        };
        if (isIframeLoaded && isMouseOver && isWindowFocused && iframePercentVisible > 0.75) {
            if (dwellTimeoutId.current) clearInterval(dwellTimeoutId.current);
            dwellTimeoutId.current = setInterval(incrementDwellTime, 1000);
        }
        return ()=>{
            if (dwellTimeoutId.current) clearInterval(dwellTimeoutId.current);
        };
    }, [
        setDwell,
        isMouseOver,
        isWindowFocused,
        isIframeLoaded,
        iframePercentVisible
    ]);
    return null;
};

});



parcelRegister("iUsXM", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a8ffe7d7e8e9c62$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $goZPP = parcelRequire("goZPP");

var $5CSKW = parcelRequire("5CSKW");

var $eGOwo = parcelRequire("eGOwo");

var $bmWcp = parcelRequire("bmWcp");

var $19nmp = parcelRequire("19nmp");

var $5z6NJ = parcelRequire("5z6NJ");

var $l22Ft = parcelRequire("l22Ft");

var $5x724 = parcelRequire("5x724");
const $9a8ffe7d7e8e9c62$var$UnauthorizedView = ({ context: context, extensionKey: extensionKey, isProductIntegrationSupported: isProductIntegrationSupported, onAuthorize: onAuthorize, testId: testId = 'embed-card-unauthorized-view', ...unresolvedViewProps })=>{
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const handleOnAuthorizeClick = (0, $eJOHy.useCallback)(()=>{
        if (onAuthorize) {
            fireEvent('track.applicationAccount.authStarted', {});
            onAuthorize();
        }
    }, [
        onAuthorize,
        fireEvent
    ]);
    const content = (0, $eJOHy.useMemo)(()=>{
        const ButtonComponent = (0, $eGOwo.fg)('platform-smart-card-remove-legacy-button') ? (0, $5CSKW.default) : (0, $goZPP.default);
        if (onAuthorize) {
            // Our title and button messages always expect the product name to be present
            // while the description support when product name is not present.
            // To be looked at https://product-fabric.atlassian.net/browse/EDM-8173
            const values = {
                context: context?.text ?? ''
            };
            if (values) // title: Connect your {context} account
            // button: Connect to {context}
            return {
                title: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...(0, $19nmp.messages).connect_link_account_card_name,
                    values: values
                }),
                description: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5z6NJ.default), {
                    providerName: context?.text,
                    isProductIntegrationSupported: isProductIntegrationSupported,
                    testId: testId
                }),
                button: /*#__PURE__*/ (0, $gt9Am.jsx)(ButtonComponent, {
                    testId: "connect-account",
                    appearance: "primary",
                    onClick: handleOnAuthorizeClick,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                        ...(0, $19nmp.messages).connect_unauthorised_account_action,
                        values: values
                    })
                })
            };
        }
        const values = context?.text ? {
            context: context?.text
        } : undefined;
        if (values) // title: We can't display private pages from {context}
        // description: You're trying to preview a link to a private {context} page. We recommend you review the URL or contact the page owner.
        return {
            title: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $19nmp.messages).unauthorised_account_name,
                values: values
            }),
            description: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $19nmp.messages).unauthorised_account_description,
                values: values
            })
        };
        // title: We can't display private pages
        // description: You're trying to preview a link to a private page. We recommend you review the URL or contact the page owner.
        return {
            title: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $19nmp.messages).unauthorised_account_name_no_provider
            }),
            description: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $19nmp.messages).unauthorised_account_description_no_provider
            })
        };
    }, [
        context?.text,
        handleOnAuthorizeClick,
        isProductIntegrationSupported,
        onAuthorize,
        testId
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $l22Ft.default), {
        ...unresolvedViewProps,
        ...content,
        icon: context?.icon,
        image: context?.image ?? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5x724.UnauthorizedSVG), {}),
        testId: testId,
        text: context?.text
    });
};
var $9a8ffe7d7e8e9c62$export$2e2bcd8739ae039 = $9a8ffe7d7e8e9c62$var$UnauthorizedView;

});
parcelRegister("5x724", function(module, exports) {

$parcel$export(module.exports, "UnauthorizedSVG", () => $f913a8b5e191dd5f$export$6526edaac83a8c90);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
const $f913a8b5e191dd5f$export$6526edaac83a8c90 = ()=>/*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
        viewBox: "0 0 565 267",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        height: "100%",
        width: "100%",
        preserveAspectRatio: "xMidYMid meet",
        "data-testid": "unauthorized-svg",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsxs)("g", {
                clipPath: "url(#clip0_1375_267)",
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                        width: "563.88",
                        height: "265.81",
                        transform: "translate(0.870117 0.509766)",
                        fill: "white",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M150.05 257.529H143.87L144.52 254.379H150.7L150.05 257.529Z",
                        fill: "#DFE1E5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M181.06 257.531C183.03 257.531 185 257.531 186.97 257.531C186.92 256.481 186.88 255.431 186.83 254.381C185.02 253.691 182.85 253.301 181.08 254.271C181.02 254.301 180.96 254.341 180.9 254.381C180.95 255.431 181.01 256.481 181.06 257.531Z",
                        fill: "#DFE1E5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M141.99 98.8398C110.62 98.8398 85.1801 124.27 85.1801 155.65V206.74C85.1801 238.11 59.7501 263.55 28.3701 263.55H0.870117",
                        stroke: "url(#paint0_linear_1375_267)",
                        strokeWidth: "4.4681",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M420.16 124.399L418.27 121.929L417.53 116.109L417.4 112.789H419.42L421.66 115.439C422.18 116.059 422.62 116.749 422.94 117.499C423.39 118.539 423.63 119.669 423.63 120.809V123.189L420.16 124.399Z",
                        fill: "#D4B696"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M160.63 111.87L159.06 105.6C159.06 105.21 159.37 104.88 159.76 104.86C160.06 105.13 160.4 105.37 160.63 105.26C160.82 105.17 160.76 104.91 160.97 104.78C161.34 104.55 162.03 105.03 162.24 105.18C162.54 105.39 162.74 105.61 162.86 105.76L163.81 106.1C164.14 106.22 164.39 106.5 164.48 106.85L165.67 107.74C166.21 107.82 166.43 110 166.45 110.07L166.04 112.86C166.07 112.97 166.07 113.09 166.05 113.21C165.96 113.65 165.5 113.91 165.07 113.75L161.09 112.32C160.87 112.25 160.7 112.08 160.63 111.87Z",
                        fill: "#A27F68"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M165.73 116.919C166.92 116.499 169.78 120.329 166.77 112.969C166.59 112.519 166.22 110.519 164.39 109.389C162.47 108.209 160.92 109.649 159.28 108.319C158.39 107.599 158.37 106.789 157.23 106.319C156.44 105.989 155.38 105.939 155.19 106.319C154.97 106.749 156.03 107.399 157.51 109.269C158.97 111.119 158.65 111.409 159.96 112.799C160.5 113.369 160.89 113.669 162.06 114.909C162.67 115.559 162.72 115.629 162.97 115.829C163.52 116.269 164.77 117.259 165.73 116.919Z",
                        fill: "#A27F68"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M164.84 175.06C162.1 173.45 162.32 169.37 162.74 163.63C163.81 148.91 166.33 143.51 166.66 135.95C166.88 130.9 166.17 123.59 161.64 114.5C163.73 114.28 165.81 114.06 167.9 113.83C171.82 123.37 173.58 131.57 174.46 137.43C175.59 144.99 175.69 151.82 175.7 154.41C175.73 165.07 174.28 169.57 175.37 173.41C175.42 173.6 175.65 174.22 175.34 174.79C174.3 176.7 167.91 176.86 164.84 175.06Z",
                        fill: "#403294"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        opacity: "0.25",
                        d: "M2.76012 266.319H206.4C207.44 266.319 208.29 265.469 208.29 264.429C208.29 263.389 207.44 262.539 206.4 262.539H2.76012C1.72012 262.539 0.870117 263.389 0.870117 264.429C0.870117 265.469 1.72012 266.319 2.76012 266.319Z",
                        fill: "url(#paint1_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        opacity: "0.25",
                        d: "M562.86 266.319H359.22C358.18 266.319 357.33 265.469 357.33 264.429C357.33 263.389 358.18 262.539 359.22 262.539H562.86C563.9 262.539 564.75 263.389 564.75 264.429C564.75 265.469 563.9 266.319 562.86 266.319Z",
                        fill: "url(#paint2_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M423.62 98.8398C454.99 98.8398 480.43 124.27 480.43 155.65V206.74C480.43 238.11 505.86 263.55 537.24 263.55H564.75",
                        stroke: "url(#paint3_linear_1375_267)",
                        strokeWidth: "4.4681",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M133.69 107.8C131.9 107.8 130.45 106.35 130.45 104.56V93.1502C130.45 91.3602 131.9 89.9102 133.69 89.9102C135.48 89.9102 136.93 91.3602 136.93 93.1502V104.57C136.92 106.35 135.48 107.8 133.69 107.8Z",
                        fill: "#B3BAC5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M140.16 107.8C138.37 107.8 136.92 106.35 136.92 104.56V93.1502C136.92 91.3602 138.37 89.9102 140.16 89.9102C141.95 89.9102 143.4 91.3602 143.4 93.1502V104.57C143.4 106.35 141.95 107.8 140.16 107.8Z",
                        fill: "#B3BAC5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M425.01 107.8C423.22 107.8 421.77 106.35 421.77 104.56V93.1502C421.77 91.3602 423.22 89.9102 425.01 89.9102C426.8 89.9102 428.25 91.3602 428.25 93.1502V104.57C428.25 106.35 426.8 107.8 425.01 107.8Z",
                        fill: "#0052CC"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M431.48 107.8C429.69 107.8 428.24 106.35 428.24 104.56V93.1502C428.24 91.3602 429.69 89.9102 431.48 89.9102C433.27 89.9102 434.72 91.3602 434.72 93.1502V104.57C434.72 106.35 433.27 107.8 431.48 107.8Z",
                        fill: "#0052CC"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        opacity: "0.38",
                        d: "M285 195.54C338.307 195.54 381.52 152.327 381.52 99.02C381.52 45.7135 338.307 2.5 285 2.5C231.694 2.5 188.48 45.7135 188.48 99.02C188.48 152.327 231.694 195.54 285 195.54Z",
                        fill: "url(#paint4_radial_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M346.07 140.879H381.57C404.79 140.879 423.62 122.059 423.62 98.8293C423.62 75.6093 404.8 56.7793 381.57 56.7793H346.07V140.879Z",
                        fill: "url(#paint5_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M237.09 123.26H276.41V116.82H237.09V123.26Z",
                        fill: "url(#paint6_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M237.09 78.2291H276.41V71.7891H237.09V78.2291Z",
                        fill: "url(#paint7_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M325.86 146.589H340.11C343.4 146.589 346.07 143.919 346.07 140.629V57.4092C346.07 54.1192 343.4 51.4492 340.11 51.4492H325.86V146.589Z",
                        fill: "url(#paint8_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M219.54 140.879H184.04C160.82 140.879 141.99 122.059 141.99 98.8293C141.99 75.6093 160.81 56.7793 184.04 56.7793H219.54V140.879Z",
                        fill: "url(#paint9_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M239.76 146.589H225.51C222.22 146.589 219.55 143.919 219.55 140.629V57.4092C219.55 54.1192 222.22 51.4492 225.51 51.4492H239.76V146.589Z",
                        fill: "url(#paint10_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M379.21 146.581C378.91 146.001 378.4 145.181 377.56 144.401C376.28 143.221 374.91 142.761 374.18 142.581C374 142.441 373.77 142.281 373.48 142.131C373.23 142.001 372.97 141.901 372.7 141.831L370.63 141.251C370.29 141.161 370.07 140.831 370.11 140.481C370.15 140.091 370.51 139.801 370.9 139.851L379.42 140.801C380.47 140.921 381.46 140.291 381.79 139.291L382.01 138.651C382.14 138.281 382.5 138.041 382.9 138.091C383.31 138.141 383.62 138.471 383.64 138.871L383.72 140.251C383.86 142.671 383.35 145.091 382.26 147.251L379.21 146.581Z",
                        fill: "#D4B696"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M428.29 185.99C429.39 188.07 430.46 190.28 431.47 192.61C435.75 202.44 437.91 211.78 438.95 219.77C440.03 222.59 441.07 225.54 442.05 228.64C444.86 237.5 446.64 245.84 447.75 253.4C446.13 253.87 444.51 254.34 442.88 254.81C441.2 250.25 438.53 243.08 435.09 234.23C430.76 223.08 428.59 217.5 428.5 217.3C422.43 203.22 419.13 199.32 420.72 193.98C421.29 192.14 422.84 188.93 428.29 185.99Z",
                        fill: "#0065FF"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M412.72 189.539C409.67 199.159 406.62 208.789 403.57 218.409C400.84 230.159 398.1 241.909 395.37 253.659C398.3 254.449 397.22 254.159 400.15 254.939C403.08 247.829 405.94 240.299 408.66 232.359C410.04 228.319 411.33 224.339 412.52 220.439C414.74 216.039 417.2 213.029 419.05 211.089C423.68 206.239 427.59 204.829 430.28 199.479C432.31 195.449 431.64 193.159 431.46 192.609C431.32 192.189 430.95 191.419 430.21 189.889C429.46 188.319 428.81 187.039 428.38 186.189C426.55 186.889 424.48 187.559 422.18 188.119C418.67 188.989 415.46 189.379 412.72 189.539Z",
                        fill: "url(#paint11_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M396.28 246.85C396.21 248.32 395.94 250.38 395.01 252.65C394.37 254.22 392.97 257.51 389.49 259.78C387.45 261.11 385.46 261.59 384.18 261.79C384.26 262.22 384.24 262.13 384.32 262.57C386.73 262.62 391.82 262.66 394.24 262.71C394.59 261.89 395.4 261.57 395.92 261.8C396.41 262.03 396.5 262.7 396.5 262.75C397.32 262.68 398.14 262.61 398.96 262.54C399.23 261.52 399.51 260.49 399.8 259.45C401 255.15 402.31 251.02 403.69 247.08C401.21 247.01 398.74 246.93 396.28 246.85Z",
                        fill: "#344563"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M440.03 247.221C440.92 249.251 441.84 252.641 441.92 253.771C442.06 255.691 442.18 257.271 441.21 258.681C440.55 259.641 439.65 260.141 438.15 260.971C436.98 261.621 435.94 262.021 435.21 262.261C435.3 262.651 435.28 262.571 435.37 262.961C437.57 262.901 439.76 262.831 441.96 262.771C442.52 262.751 443.09 262.731 443.65 262.711C443.66 262.661 443.77 262.191 444.22 261.991C444.67 261.791 445.08 262.031 445.17 262.081C445.49 262.261 445.62 262.541 445.67 262.651C446.19 262.691 446.78 262.721 447.42 262.691C448.09 262.671 448.7 262.601 449.24 262.521C449.09 261.461 448.94 260.401 448.78 259.341C448.69 258.741 448.53 257.681 448.29 256.131C447.73 252.481 447 247.951 446.83 246.881C444.56 247.001 442.29 247.111 440.03 247.221Z",
                        fill: "#344563"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M404.04 166.88C412.13 163.96 417.86 161.43 418.22 161.14C418.55 160.87 418.88 160.59 418.88 160.59C418.98 160.51 419.08 160.42 419.19 160.32C421.82 157.99 427.78 151.82 427.76 142.35C427.73 131.65 420.19 125.19 419.11 124.29C420.82 123.5 422.52 122.71 424.23 121.92C426.36 123.97 432.76 130.64 433.79 141.01C434.72 150.27 430.85 157.43 429.11 160.66C427.36 163.91 425.44 166.35 424.02 167.97C423.92 170.1 424 172.75 424.56 175.73C425.49 180.68 427.37 184.49 428.86 186.96C423.1 188.75 417.33 190.54 411.57 192.33C413.04 189.13 412.78 187.11 412.25 185.86C411.07 183.05 407.94 182.53 406.78 179.13C406.31 177.76 406.36 176.51 406.46 175.69C404.27 175.89 395.01 176.46 386.94 170C375.33 160.7 377 145.5 377.12 144.57C379.19 145.06 381.27 145.55 383.34 146.04C383.04 147.74 383.3 152.66 384.35 155.65C387.27 163.99 396.59 169.11 404.04 166.88Z",
                        fill: "url(#paint12_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M406.52 152.01C406.67 152.06 406.9 152.11 407.25 152.17C408.21 152.33 408.84 152.57 409.24 152.86C410.29 153.59 409.6 155.01 410.51 157.07C410.6 157.28 410.88 157.87 411.03 158.72C411.1 159.15 411.12 159.47 411.12 159.54C411.15 160.21 411.58 161.58 413.11 164.55C412.78 164.46 412.46 164.37 412.13 164.28C411.17 163.91 410.2 163.54 409.24 163.17C407.16 161.78 406.7 161.57 406.7 160.58C406.69 159.4 406.68 157.33 406.62 157.25C405.95 156.6 405.08 156.48 405.74 155.68C406.12 155.23 406.41 154.9 406.51 154.81C406.82 154.53 407.04 153.83 406.52 152.01Z",
                        fill: "#D4B696"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M409.17 152.81C408.97 155.53 409.02 159.86 410.76 164.7C410.8 164.82 410.85 164.95 410.9 165.07C412.74 169.95 418.57 172.14 423.04 169.45C423.19 169.36 423.35 169.26 423.5 169.16C423.53 169.14 423.55 169.12 423.58 169.11C426.31 167.24 426.68 163.37 424.47 160.91C422.98 159.26 422 157.68 421.33 156.36C419.26 152.28 419.55 149.41 416.8 147.81C414.71 146.59 412.02 146.79 411.13 146.85C409.41 146.98 408.61 147.42 408.23 147.7C407.34 148.37 406.86 149.14 406.64 149.56C406.11 150.55 405.98 151.47 405.94 152C406.33 152.02 406.78 152.08 407.26 152.18C408.02 152.34 408.67 152.58 409.17 152.81Z",
                        fill: "#172B4D"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M298 24.3503L293.82 0.940321C293.72 0.390321 292.95 0.360321 292.8 0.890321L286.8 21.9503L281.93 20.5603C281.56 20.4503 281.2 20.7703 281.27 21.1503L285.45 44.5603C285.55 45.1103 286.32 45.1403 286.47 44.6103L292.47 23.5503L297.34 24.9403C297.71 25.0603 298.07 24.7303 298 24.3503Z",
                        fill: "url(#paint13_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M271.23 34.4501L262.63 26.2801C262.45 26.1101 262.17 26.3001 262.26 26.5301L266.06 36.7401L263.69 37.6201C263.53 37.6801 263.49 37.8801 263.61 38.0001L272.21 46.1701C272.39 46.3401 272.67 46.1501 272.58 45.9201L268.78 35.7101L271.15 34.8301C271.31 34.7801 271.35 34.5701 271.23 34.4501Z",
                        fill: "url(#paint14_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M252.19 156.739L248.63 180.259C248.55 180.809 249.26 181.089 249.58 180.639L262.02 162.619L266.18 165.499C266.5 165.719 266.94 165.529 266.99 165.149L270.55 141.629C270.63 141.079 269.92 140.799 269.6 141.249L257.16 159.269L253 156.389C252.69 156.169 252.25 156.359 252.19 156.739Z",
                        fill: "url(#paint15_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M280.79 160.989L286.31 171.489C286.42 171.709 286.75 171.619 286.74 171.379L286.42 160.489L288.95 160.409C289.12 160.399 289.23 160.219 289.15 160.069L283.63 149.569C283.52 149.349 283.19 149.439 283.2 149.679L283.52 160.569L280.99 160.639C280.82 160.659 280.71 160.839 280.79 160.989Z",
                        fill: "url(#paint16_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M210.22 142.149L210.26 142.049C210.88 140.389 211.84 138.869 213.09 137.609L213.57 137.119C213.8 136.879 214.17 136.829 214.46 136.989C214.83 137.199 214.96 137.679 214.73 138.039L214.35 138.639C213.96 139.259 214.44 140.049 215.17 139.989L216.22 139.909C216.41 139.889 216.6 139.889 216.79 139.889H220.09V140.009C220.09 140.589 219.94 141.149 219.65 141.649L219.85 142.479L212.52 144.559L210.22 142.149Z",
                        fill: "#A27F68"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M167.89 212.219C170.43 201.299 170.03 198.249 168.95 195.809C167.16 191.769 163.58 189.559 161.36 188.459C160.58 189.839 159.49 191.959 158.49 194.659C156.66 199.589 156.32 203.239 155.63 207.859C155.11 211.319 154.24 216.299 152.75 222.379C150.92 226.479 149.08 231.349 147.55 236.919C145.75 243.459 144.81 249.419 144.33 254.469C146.45 254.469 148.58 254.469 150.71 254.459C152.73 251.619 154.81 248.339 156.78 244.619C160.42 237.759 162.67 231.309 164.11 225.929C164.85 223.589 165.87 220.159 166.97 215.949C167.26 214.829 167.56 213.629 167.89 212.219Z",
                        fill: "#6554C0"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M176.58 191.57C179.52 198.15 181.75 203.76 183.34 207.95C186.95 217.46 187.57 220.51 187.81 221.82C188.78 227.05 188.69 231 188.5 237.33C188.37 241.83 187.97 247.87 186.83 255C184.86 255.11 182.88 255.22 180.91 255.33C179.04 250.46 177.13 243.9 176.47 235.99C176.11 231.71 176.19 227.83 176.47 224.47C173.58 221.68 170.54 218.48 167.48 214.83C165.05 211.93 162.9 209.11 161 206.41C161 206.41 156.64 199.14 158.38 195.02C158.38 195.01 158.39 194.99 158.4 194.98C158.89 193.79 159.33 192.79 159.55 192.3C160.25 190.75 160.84 189.5 161.25 188.66C163.04 189.3 165.07 189.9 167.32 190.4C170.78 191.17 173.92 191.48 176.58 191.57Z",
                        fill: "url(#paint17_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M172.03 148.42C171.56 148.18 171.05 147.95 170.5 147.72C169.91 147.47 169.34 147.26 168.81 147.09C168.59 146.7 167.07 144.07 163.95 143.52C163.46 143.44 161.77 143.16 160.05 144.06C157.21 145.55 156.37 149.16 156.64 151.67C156.74 152.59 156.91 154.28 158.16 155.58C159.93 157.42 162.29 156.85 162.98 158.45C163.55 159.76 162.18 160.72 162.73 161.65C163.73 163.34 169.99 163.03 171.08 160.08C171.23 159.68 171.48 158.71 170.76 157.19C171.68 155.93 172.61 154.67 173.53 153.42C173.3 152.89 172.96 152.24 172.45 151.55C171.97 150.91 171.49 150.41 171.07 150.05C171.23 149.86 171.41 149.63 171.58 149.35C171.79 149 171.93 148.68 172.03 148.42Z",
                        fill: "#A27F68"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M163.94 151.95C163.79 150.89 164.25 150.56 163.88 149.91C163.46 149.16 162.68 149.28 162.15 148.38C161.99 148.12 161.68 147.58 161.84 147.09C162.25 145.82 165.44 146.23 165.81 145C165.91 144.65 165.76 144.29 165.61 144.04C165.08 143.65 164.2 143.12 163.02 142.93C160.36 142.5 157.52 144.01 156.11 146.43C154.47 149.25 155.11 152.73 156.74 154.54C157.37 155.24 158.63 156.65 160.4 156.92C160.96 157.01 161.84 157.02 162.34 157.67C162.73 158.17 162.66 158.75 162.98 158.84C163.06 158.86 163.36 158.91 164.01 158.08C164.71 157.19 165.56 156.12 165.39 154.83C165.22 153.5 164.16 153.48 163.94 151.95Z",
                        fill: "#42526E"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M171.78 160.529C178.49 163.269 181.57 171.049 181.57 176.839C181.57 180.219 180.53 183.109 179.64 185.569C178.42 188.949 177.51 190.789 176 192.699C171.74 198.069 159.59 197.749 157.75 193.939C157.36 193.139 157.51 192.349 157.55 192.109C159.83 178.359 156.81 163.059 163.89 159.849C166.86 158.499 170.07 159.829 171.78 160.529Z",
                        fill: "#5243AA"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M213.33 144.43C213.47 144.59 213.62 144.74 213.76 144.9C209.95 149.37 203.65 155.67 194.36 160.95C183.21 167.29 172.8 169.3 166.51 170.01C164.79 168.3 162.68 165.68 163.29 163.25C163.79 161.24 166.05 159.77 176.29 157.08C180.37 156.01 185.85 154.7 192.45 153.53C198.37 149.36 204.3 145.18 210.22 141.01C210.23 141.02 210.23 141.02 210.24 141.03L213.33 144.43Z",
                        fill: "url(#paint18_linear_1375_267)"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M416.51 117.27L420.41 121.18L421.77 118.83L417.41 116.13C417.1 115.94 416.71 116 416.47 116.27C416.23 116.56 416.24 117 416.51 117.27Z",
                        fill: "#D4B696"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M185.75 257.109C185.75 257.119 185.76 257.129 185.77 257.139C185.88 257.189 186.19 256.219 186.63 256.019C187.47 255.639 188.86 258.159 191.32 259.779C192.43 260.509 193.53 260.909 194.4 261.129C194.73 261.209 194.96 261.509 194.96 261.849V262.549H180.01C179.98 261.659 180.04 260.509 180.34 259.209C180.53 258.409 180.77 257.699 181.02 257.119H185.75V257.109Z",
                        fill: "#42526E"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M180.08 259.818C181.72 259.818 183.05 261.138 183.09 262.768C182.06 262.768 181.03 262.768 180 262.768V259.818C180.03 259.828 180.06 259.818 180.08 259.818Z",
                        fill: "#B3BAC5"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M148.77 257.109C148.77 257.119 148.78 257.129 148.79 257.139C148.9 257.189 149.21 256.219 149.65 256.019C150.49 255.639 151.88 258.159 154.34 259.779C155.45 260.509 156.55 260.909 157.42 261.129C157.75 261.209 157.98 261.509 157.98 261.849V262.549H143.03C143 261.659 143.06 260.509 143.36 259.209C143.55 258.409 143.79 257.699 144.04 257.119H148.77V257.109Z",
                        fill: "#42526E"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M143.11 259.818C144.75 259.818 146.08 261.138 146.12 262.768C145.09 262.768 144.06 262.768 143.03 262.768V259.818C143.05 259.828 143.08 259.818 143.11 259.818Z",
                        fill: "#B3BAC5"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint0_linear_1375_267",
                        x1: "141.994",
                        y1: "181.192",
                        x2: "0.870117",
                        y2: "181.192",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#C1C7D0"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#C1C7D0",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint1_linear_1375_267",
                        x1: "208.292",
                        y1: "264.428",
                        x2: "0.870117",
                        y2: "264.428",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#091E42"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.8433",
                                stopColor: "#091E42",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint2_linear_1375_267",
                        x1: "357.327",
                        y1: "264.428",
                        x2: "564.748",
                        y2: "264.428",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#091E42"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.8433",
                                stopColor: "#091E42",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint3_linear_1375_267",
                        x1: "423.624",
                        y1: "181.192",
                        x2: "564.748",
                        y2: "181.192",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#0065FF"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.1724",
                                stopColor: "#076AFF",
                                stopOpacity: "0.8007"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.4145",
                                stopColor: "#1976FF",
                                stopOpacity: "0.5208"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.6966",
                                stopColor: "#378BFF",
                                stopOpacity: "0.1947"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.8651",
                                stopColor: "#4C9AFF",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("radialGradient", {
                        id: "paint4_radial_1375_267",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(285 99.0229) scale(96.5182)",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#FFF0B2"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.1584",
                                stopColor: "#FFE587",
                                stopOpacity: "0.8416"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.3589",
                                stopColor: "#FFDA57",
                                stopOpacity: "0.6411"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.5498",
                                stopColor: "#FFD031",
                                stopOpacity: "0.4502"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.7256",
                                stopColor: "#FFC916",
                                stopOpacity: "0.2744"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.8811",
                                stopColor: "#FFC506",
                                stopOpacity: "0.1189"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FFC400",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint5_linear_1375_267",
                        x1: "346.074",
                        y1: "98.8386",
                        x2: "423.624",
                        y2: "98.8386",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#0052CC"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#2684FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint6_linear_1375_267",
                        x1: "237.087",
                        y1: "120.044",
                        x2: "276.412",
                        y2: "120.044",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#7A869A"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#DFE1E5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint7_linear_1375_267",
                        x1: "237.087",
                        y1: "75.0106",
                        x2: "276.412",
                        y2: "75.0106",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#7A869A"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#DFE1E5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint8_linear_1375_267",
                        x1: "335.969",
                        y1: "146.593",
                        x2: "335.969",
                        y2: "51.4514",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#2684FF"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#B2D4FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint9_linear_1375_267",
                        x1: "219.544",
                        y1: "98.8386",
                        x2: "141.994",
                        y2: "98.8386",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#7A869A"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#EBECF0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint10_linear_1375_267",
                        x1: "229.65",
                        y1: "146.593",
                        x2: "229.65",
                        y2: "51.4514",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#C1C7D0"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#F4F5F7"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint11_linear_1375_267",
                        x1: "402.858",
                        y1: "216.64",
                        x2: "421.684",
                        y2: "223.492",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#4C9AFF"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.8134",
                                stopColor: "#0065FF"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.8713",
                                stopColor: "#0065FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint12_linear_1375_267",
                        x1: "376.968",
                        y1: "157.139",
                        x2: "433.936",
                        y2: "157.139",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#B2D4FF"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#2684FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint13_linear_1375_267",
                        x1: "289.638",
                        y1: "45.0027",
                        x2: "289.638",
                        y2: "0.510323",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#FFF0B2"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FFC400"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint14_linear_1375_267",
                        x1: "262.238",
                        y1: "36.2259",
                        x2: "272.592",
                        y2: "36.2259",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#FFC400"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FFF0B2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint15_linear_1375_267",
                        x1: "259.6",
                        y1: "180.859",
                        x2: "259.6",
                        y2: "141.017",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#FFC400"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FFF0B2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint16_linear_1375_267",
                        x1: "284.971",
                        y1: "171.613",
                        x2: "284.971",
                        y2: "149.45",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#FFC400"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FFF0B2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint17_linear_1375_267",
                        x1: "157.982",
                        y1: "221.995",
                        x2: "188.627",
                        y2: "221.995",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "0.3435",
                                stopColor: "#6554C0"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#998DD9"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        id: "paint18_linear_1375_267",
                        x1: "163.185",
                        y1: "155.517",
                        x2: "213.758",
                        y2: "155.517",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#5243AA"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                offset: "1",
                                stopColor: "#8777D9"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("clipPath", {
                        id: "clip0_1375_267",
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
                            width: "563.88",
                            height: "265.81",
                            fill: "white",
                            transform: "translate(0.870117 0.509766)"
                        })
                    })
                ]
            })
        ]
    });

});



parcelRegister("6J1DL", function(module, exports) {

$parcel$export(module.exports, "InlineCard", () => $71d51cdd37301ec2$export$aff6291803939b05);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $hy9OT = parcelRequire("hy9OT");

var $eGOwo = parcelRequire("eGOwo");

var $dLR8J = parcelRequire("dLR8J");

var $5NtHI = parcelRequire("5NtHI");

var $7r0tl = parcelRequire("7r0tl");

var $aRZRK = parcelRequire("aRZRK");

var $03JM4 = parcelRequire("03JM4");

var $gA511 = parcelRequire("gA511");

var $kj3Kk = parcelRequire("kj3Kk");

var $3sgI9 = parcelRequire("3sgI9");

var $6kw7n = parcelRequire("6kw7n");

var $eIvWj = parcelRequire("eIvWj");

var $4dnWW = parcelRequire("4dnWW");

var $kFkj1 = parcelRequire("kFkj1");
const $71d51cdd37301ec2$var$UFOLoadHoldWrapper = ({ children: children })=>{
    return (0, $eGOwo.fg)('platform_renderer_blindspots') ? /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dLR8J.default), {
                name: "smart-card-inline-card"
            }),
            children
        ]
    }) : children;
};
const $71d51cdd37301ec2$export$aff6291803939b05 = ({ id: id, url: url, cardState: cardState, handleAuthorize: handleAuthorize, handleFrameClick: handleFrameClick, isSelected: isSelected, isHovered: isHovered, renderers: renderers, onResolve: onResolve, onError: onError, testId: testId, inlinePreloaderStyle: inlinePreloaderStyle, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, removeTextHighlightingFromTitle: removeTextHighlightingFromTitle, resolvingPlaceholder: resolvingPlaceholder, truncateInline: truncateInline })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { status: status, details: details } = cardState;
    const extensionKey = (0, $03JM4.getExtensionKey)(details);
    const testIdWithStatus = testId ? `${testId}-${status}-view` : undefined;
    const resolvedProps = status === (0, $5NtHI.SmartLinkStatus).Resolved ? (0, $aRZRK.extractInlineProps)(details, renderers, removeTextHighlightingFromTitle, false) : {};
    (0, $eJOHy.useEffect)(()=>{
        switch(status){
            case (0, $5NtHI.SmartLinkStatus).Resolved:
                onResolve?.({
                    url: url,
                    title: resolvedProps.title
                });
                break;
            case (0, $5NtHI.SmartLinkStatus).Errored:
            case (0, $5NtHI.SmartLinkStatus).Fallback:
            case (0, $5NtHI.SmartLinkStatus).Forbidden:
            case (0, $5NtHI.SmartLinkStatus).NotFound:
            case (0, $5NtHI.SmartLinkStatus).Unauthorized:
                if (onError) onError({
                    status: status,
                    url: url
                });
                break;
        }
    }, [
        onError,
        onResolve,
        status,
        url,
        resolvedProps.title
    ]);
    switch(status){
        case 'pending':
        case 'resolving':
            return /*#__PURE__*/ (0, $gt9Am.jsx)($71d51cdd37301ec2$var$UFOLoadHoldWrapper, {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4dnWW.InlineCardResolvingView), {
                    url: url,
                    isSelected: isSelected,
                    onClick: handleFrameClick,
                    testId: testIdWithStatus,
                    inlinePreloaderStyle: inlinePreloaderStyle,
                    resolvingPlaceholder: resolvingPlaceholder,
                    truncateInline: truncateInline
                })
            });
        case 'resolved':
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eIvWj.InlineCardResolvedView), {
                ...resolvedProps,
                id: id,
                showHoverPreview: showHoverPreview,
                hoverPreviewOptions: hoverPreviewOptions,
                actionOptions: actionOptions,
                link: url,
                isSelected: isSelected,
                isHovered: isHovered,
                onClick: handleFrameClick,
                testId: testIdWithStatus,
                truncateInline: truncateInline
            });
        case 'unauthorized':
            const provider = (0, $hy9OT.extractSmartLinkProvider)(details);
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kFkj1.InlineCardUnauthorizedView), {
                icon: provider && provider.icon,
                context: provider && provider.text,
                url: url,
                isSelected: isSelected,
                onClick: handleFrameClick,
                onAuthorise: handleAuthorize,
                testId: testIdWithStatus,
                showHoverPreview: showHoverPreview,
                id: id,
                extensionKey: extensionKey,
                truncateInline: truncateInline
            });
        case 'forbidden':
            const providerForbidden = (0, $hy9OT.extractSmartLinkProvider)(details);
            const cardMetadata = details?.meta ?? (0, $gA511.getForbiddenJsonLd)().meta;
            const requestAccessContext = (0, $7r0tl.extractRequestAccessContextImproved)({
                jsonLd: cardMetadata,
                url: url,
                product: providerForbidden?.text ?? '',
                createAnalyticsEvent: createAnalyticsEvent
            });
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6kw7n.InlineCardForbiddenView), {
                url: url,
                icon: providerForbidden && providerForbidden.icon,
                context: providerForbidden?.text,
                isSelected: isSelected,
                onClick: handleFrameClick,
                onAuthorise: handleAuthorize,
                testId: testIdWithStatus,
                requestAccessContext: requestAccessContext,
                showHoverPreview: showHoverPreview,
                truncateInline: truncateInline
            });
        case 'not_found':
            const providerNotFound = (0, $hy9OT.extractSmartLinkProvider)(details);
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3sgI9.InlineCardErroredView), {
                url: url,
                icon: providerNotFound && providerNotFound.icon,
                isSelected: isSelected,
                message: "Can't find link",
                onClick: handleFrameClick,
                testId: testIdWithStatus || 'inline-card-not-found-view',
                showHoverPreview: showHoverPreview,
                truncateInline: truncateInline
            });
        case 'fallback':
        case 'errored':
        default:
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kj3Kk.CardLinkView), {
                link: url,
                isSelected: isSelected,
                onClick: handleFrameClick,
                testId: testIdWithStatus || 'inline-card-errored-view',
                truncateInline: truncateInline
            });
    }
};

});
parcelRegister("3sgI9", function(module, exports) {

$parcel$export(module.exports, "InlineCardErroredView", () => $f78d8ca0def2e8b6$export$8ae570c871cdb179);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $d3cA1 = parcelRequire("d3cA1");

var $19nmp = parcelRequire("19nmp");

var $3S6ja = parcelRequire("3S6ja");

var $4Rp6r = parcelRequire("4Rp6r");

var $bu0pj = parcelRequire("bu0pj");

var $3KRDe = parcelRequire("3KRDe");
const $f78d8ca0def2e8b6$var$fallbackIcon = ()=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d3cA1))), {
        color: "var(--ds-icon-danger, #C9372C)",
        label: "error",
        LEGACY_size: "small",
        testId: "errored-view-default-icon"
    });
};
const $f78d8ca0def2e8b6$export$8ae570c871cdb179 = ({ url: url, onClick: onClick, isSelected: isSelected, testId: testId = 'inline-card-errored-view', icon: icon, message: message, onRetry: onRetry, truncateInline: truncateInline, showHoverPreview: showHoverPreview })=>{
    const frameRef = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef(null);
    const hashAction = !!onRetry;
    const handleRetry = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((event)=>{
        if (onRetry) {
            event.preventDefault();
            event.stopPropagation();
            onRetry();
        }
    }, [
        onRetry
    ]);
    const renderActionButton = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback(()=>{
        return onRetry && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4Rp6r.ActionButton), {
            onClick: handleRetry,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $19nmp.messages).try_again
            })
        });
    }, [
        handleRetry,
        onRetry
    ]);
    const content = /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bu0pj.Frame), {
        link: hashAction ? undefined : url,
        onClick: hashAction ? undefined : onClick,
        isSelected: isSelected,
        ref: frameRef,
        testId: testId,
        truncateInline: truncateInline,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3KRDe.IconAndTitleLayout), {
                icon: icon || $f78d8ca0def2e8b6$var$fallbackIcon(),
                link: hashAction ? url : undefined,
                title: url,
                onClick: hashAction ? onClick : undefined,
                rightSide: message
            }),
            renderActionButton()
        ]
    });
    if (showHoverPreview) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3S6ja.HoverCard), {
        url: url,
        children: content
    });
    return content;
};

});
parcelRegister("4Rp6r", function(module, exports) {

$parcel$export(module.exports, "ActionButton", () => $36fa193905cb5ef0$export$cfc7921d29ef7b80);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $46R8N = parcelRequire("46R8N");
const $36fa193905cb5ef0$var$styles = {
    button: "_1e0c1bgi",
    innerContainer: "_1e0c1nu9 _1y1m1u8q _16d9qvcn _k48p1wq8 _19bv12x7 _ca0qv77o _n3tdv77o _u5f312x7 _y3gn18uv _o5721btx _1nmz9jpi",
    enabled: "_syaz1fxt _80omtlke _bfhkm7j4 _irr315ej _1di6ip91",
    disabled: "_syaz1lh4 _80om13gf _bfhksyzs"
};
const $36fa193905cb5ef0$export$cfc7921d29ef7b80 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, isDisabled: isDisabled, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $46R8N.default), {
        ...props,
        isDisabled: isDisabled,
        ref: ref,
        // We need to reset Pressable fixed font size to allow inline card to inherit the font size
        // from parent component such as paragraph and heading
        style: {
            font: `inherit`
        },
        xcss: $36fa193905cb5ef0$var$styles.button,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
            tabIndex: isDisabled ? undefined : 0,
            className: (0, $hcewu.default)([
                $36fa193905cb5ef0$var$styles.innerContainer,
                isDisabled ? $36fa193905cb5ef0$var$styles.disabled : $36fa193905cb5ef0$var$styles.enabled
            ]),
            children: children
        })
    });
});

});


parcelRegister("6kw7n", function(module, exports) {

$parcel$export(module.exports, "InlineCardForbiddenView", () => $5783739fd5be2c19$export$ebd227d2573ed3d8);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $9QgTI = parcelRequire("9QgTI");

var $kKPzl = parcelRequire("kKPzl");

var $jdqdp = parcelRequire("jdqdp");

var $eGOwo = parcelRequire("eGOwo");

var $46R8N = parcelRequire("46R8N");


var $19nmp = parcelRequire("19nmp");

var $3S6ja = parcelRequire("3S6ja");

var $4Rp6r = parcelRequire("4Rp6r");

var $k6uZC = parcelRequire("k6uZC");

var $bu0pj = parcelRequire("bu0pj");

var $3KRDe = parcelRequire("3KRDe");
const $5783739fd5be2c19$var$styles = {
    iconWrapper: "_2hwx1i6y _1e0cbu77",
    actionButtonLozengeStyleOld: "_2rkogqwt _bfhk1w7a _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t",
    actionButtonLozengeStyleNew: "_2rkogqwt _bfhk1w7a _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _p12f1osq"
};
const $5783739fd5be2c19$var$fallbackForbiddenIcon = ()=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9QgTI))), {
        label: "error",
        color: "var(--ds-icon-danger, #C9372C)",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($kKPzl))),
        LEGACY_size: "small",
        testId: "forbidden-view-fallback-icon"
    });
};
const $5783739fd5be2c19$export$ebd227d2573ed3d8 = ({ url: url, icon: icon, onClick: onClick, isSelected: isSelected, testId: testId = 'inline-card-forbidden-view', truncateInline: truncateInline, requestAccessContext: requestAccessContext, onAuthorise: onAuthorise, context: context, showHoverPreview: showHoverPreview })=>{
    const frameRef = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef(null);
    const [hasRequestAccessContextMessage] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState(!!requestAccessContext?.callToActionMessageKey);
    const handleRetry = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((event)=>{
        event.preventDefault();
        event.stopPropagation();
        if (onAuthorise) onAuthorise();
        else requestAccessContext?.action?.promise();
    }, [
        onAuthorise,
        requestAccessContext?.action
    ]);
    const renderForbiddenAccessMessage = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback(()=>{
        if (requestAccessContext?.callToActionMessageKey) {
            const { callToActionMessageKey: callToActionMessageKey } = requestAccessContext;
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $19nmp.messages)[callToActionMessageKey],
                values: {
                    product: context
                }
            });
        }
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            ...(0, $19nmp.messages).invalid_permissions,
            children: (formattedMessage)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
                    children: formattedMessage
                })
        });
    }, [
        context,
        requestAccessContext
    ]);
    const renderActionButton = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback(()=>{
        const accessType = requestAccessContext?.accessType;
        if (hasRequestAccessContextMessage) {
            const isDisabled = accessType === 'PENDING_REQUEST_EXISTS';
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4Rp6r.ActionButton), {
                isDisabled: isDisabled,
                onClick: handleRetry,
                testId: "button-connect-other-account",
                children: renderForbiddenAccessMessage()
            });
        }
        if (onAuthorise) {
            if ((0, $eGOwo.fg)('platform-linking-visual-refresh-inline-lozenge')) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $46R8N.default), {
                xcss: $5783739fd5be2c19$var$styles.actionButtonLozengeStyleNew,
                onClick: handleRetry,
                style: {
                    font: `inherit`
                },
                testId: "button-connect-other-account",
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k6uZC.default), {
                    appearance: "moved",
                    ...(0, $eGOwo.fg)('platform-component-visual-refresh') ? {
                        isBold: true
                    } : undefined,
                    children: renderForbiddenAccessMessage()
                })
            });
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3KRDe.LozengeWrapper), {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $46R8N.default), {
                    xcss: $5783739fd5be2c19$var$styles.actionButtonLozengeStyleOld,
                    onClick: handleRetry,
                    testId: "button-connect-other-account",
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jdqdp.default), {
                        appearance: "moved",
                        ...(0, $eGOwo.fg)('platform-component-visual-refresh') ? {
                            isBold: true
                        } : undefined,
                        children: renderForbiddenAccessMessage()
                    })
                })
            });
        }
        return null;
    }, [
        handleRetry,
        hasRequestAccessContextMessage,
        onAuthorise,
        renderForbiddenAccessMessage,
        requestAccessContext?.accessType
    ]);
    const content = /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bu0pj.Frame), {
        testId: testId,
        isSelected: isSelected,
        ref: frameRef,
        truncateInline: truncateInline,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3KRDe.IconAndTitleLayout), {
                icon: icon ? icon : $5783739fd5be2c19$var$fallbackForbiddenIcon(),
                link: url,
                title: url,
                onClick: onClick,
                titleColor: `var(--ds-text-subtle, ${(0, $7bb4c1736002a04a$export$c39c0fe0f26207ae)})`
            }),
            renderActionButton()
        ]
    });
    if (showHoverPreview) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3S6ja.HoverCard), {
        url: url,
        children: content
    });
    return content;
};

});
parcelRegister("kKPzl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f1c01b17c1604b90$var$_react = $f1c01b17c1604b90$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $f1c01b17c1604b90$var$_lockLocked = $f1c01b17c1604b90$var$_interopRequireDefault((parcelRequire("9QgTI")));
function $f1c01b17c1604b90$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f1c01b17c1604b90$var$LockFilledIcon = (props)=>/*#__PURE__*/ $f1c01b17c1604b90$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8 10V8.002A4.004 4.004 0 0 1 12 4a4 4 0 0 1 4 4.002V10a2 2 0 0 1 2 2v6c0 1.105-.902 2-2.009 2H8.01A2 2 0 0 1 6 18v-6c0-1.102.897-1.995 2-2m2 0h4V8.002A2 2 0 0 0 12 6c-1.102 0-2 .898-2 2.002zm2 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/></svg>`
    }, props, {
        newIcon: $f1c01b17c1604b90$var$_lockLocked.default
    }));
$f1c01b17c1604b90$var$LockFilledIcon.displayName = 'LockFilledIcon';
var $f1c01b17c1604b90$var$_default = module.exports.default = $f1c01b17c1604b90$var$LockFilledIcon;

});


parcelRegister("4dnWW", function(module, exports) {

$parcel$export(module.exports, "InlineCardResolvingView", () => $7b3077a1d4f02d91$export$98531adac42f053e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");

var $7ep4S = parcelRequire("7ep4S");

var $bu0pj = parcelRequire("bu0pj");

var $3KRDe = parcelRequire("3KRDe");

var $8a4B6 = parcelRequire("8a4B6");
const $7b3077a1d4f02d91$var$styles = {
    spinnerWrapper: "_11c81o8v _1e0c116y _4cvr1h6o _1bah1h6o _4t3i7vkz _1bsb7vkz"
};
const $7b3077a1d4f02d91$export$98531adac42f053e = ({ url: url, onClick: onClick, isSelected: isSelected, inlinePreloaderStyle: inlinePreloaderStyle, testId: testId = 'inline-card-resolving-view', titleTextColor: titleTextColor, resolvingPlaceholder: resolvingPlaceholder, truncateInline: truncateInline })=>{
    const renderSpinner = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback(()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
            as: "span",
            xcss: $7b3077a1d4f02d91$var$styles.spinnerWrapper,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {
                size: 14
            })
        }), []);
    if (inlinePreloaderStyle === 'on-right-without-skeleton') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bu0pj.Frame), {
        withoutBackground: true,
        testId: testId,
        onClick: onClick,
        isSelected: isSelected,
        truncateInline: truncateInline,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $3KRDe.IconTitleWrapper), {
            children: [
                url,
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8a4B6.RightIconPositionWrapper), {
                    children: renderSpinner()
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bu0pj.Frame), {
        testId: testId,
        onClick: onClick,
        isSelected: isSelected,
        link: url,
        truncateInline: truncateInline,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3KRDe.IconAndTitleLayout), {
            icon: renderSpinner(),
            title: resolvingPlaceholder ?? url,
            titleTextColor: titleTextColor
        })
    });
};

});
parcelRegister("8a4B6", function(module, exports) {

$parcel$export(module.exports, "RightIconPositionWrapper", () => $9116d903068768cf$export$91b164375b8037b5);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $9116d903068768cf$export$91b164375b8037b5 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_18u0v77o _kqswh2mm _1e0c1o8l",
            __cmplp.className
        ])
    });
});

});


parcelRegister("kFkj1", function(module, exports) {

$parcel$export(module.exports, "InlineCardUnauthorizedView", () => $38c365e1bf03afe8$export$ece47728c0503997);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $9QgTI = parcelRequire("9QgTI");

var $kKPzl = parcelRequire("kKPzl");


var $bmWcp = parcelRequire("bmWcp");

var $19nmp = parcelRequire("19nmp");

var $3S6ja = parcelRequire("3S6ja");

var $4Rp6r = parcelRequire("4Rp6r");

var $bu0pj = parcelRequire("bu0pj");

var $3KRDe = parcelRequire("3KRDe");
const $38c365e1bf03afe8$var$fallbackUnauthorizedIcon = ()=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9QgTI))), {
        color: "var(--ds-icon-danger, #C9372C)",
        label: "error",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($kKPzl))),
        LEGACY_size: "small"
    });
};
const $38c365e1bf03afe8$export$ece47728c0503997 = ({ url: url, id: id, icon: icon, onAuthorise: onAuthorise, onClick: onClick, isSelected: isSelected, testId: testId = 'inline-card-unauthorized-view', showHoverPreview: showHoverPreview = false, truncateInline: truncateInline, context: context })=>{
    const frameRef = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef(null);
    const { fireEvent: fireEvent } = (0, $bmWcp.useAnalyticsEvents)();
    const handleConnectAccount = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((event)=>{
        event.preventDefault();
        event.stopPropagation();
        if (onAuthorise) {
            fireEvent('track.applicationAccount.authStarted', {});
            onAuthorise();
        }
    }, [
        fireEvent,
        onAuthorise
    ]);
    const renderActionButton = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback(()=>{
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4Rp6r.ActionButton), {
            onClick: handleConnectAccount,
            testId: "button-connect-account",
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $19nmp.messages).connect_link_account_card_name,
                values: {
                    context: context
                }
            })
        });
    }, [
        handleConnectAccount,
        context
    ]);
    const inlineCardUnauthenticatedView = /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bu0pj.Frame), {
        testId: testId,
        isSelected: isSelected,
        ref: frameRef,
        truncateInline: truncateInline,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3KRDe.IconAndTitleLayout), {
                icon: icon ? icon : $38c365e1bf03afe8$var$fallbackUnauthorizedIcon(),
                title: url,
                link: url,
                onClick: onClick,
                titleColor: `var(--ds-text-subtle, ${(0, $7bb4c1736002a04a$export$c39c0fe0f26207ae)})`
            }),
            renderActionButton()
        ]
    });
    if (onAuthorise && showHoverPreview) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3S6ja.HoverCard), {
        url: url,
        id: id,
        children: inlineCardUnauthenticatedView
    });
    return inlineCardUnauthenticatedView;
};

});




parcelRegister("iY2av", function(module, exports) {

$parcel$export(module.exports, "default", () => $18d1930375b33d5e$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $3uf8Z = parcelRequire("3uf8Z");
function $18d1930375b33d5e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $18d1930375b33d5e$var$ConfigureOverlayWrapperStyles = {
    name: "1sudr34",
    styles: "position:relative;left:var(--ds-space-025, 2px)"
};
const $18d1930375b33d5e$var$OverlayWrapper = ({ view: view, targetElementPos: targetElementPos, children: children, isHoveredCallback: hoverCallback, onOpenLinkClick: onOpenLinkClick })=>{
    const [showConfigureButton, setShowConfigureButton] = (0, $eJOHy.useState)(false);
    const [dropdownOpen, setDropdownOpen] = (0, $eJOHy.useState)(false);
    const onDropdownChange = (0, $eJOHy.useCallback)((isOpen)=>{
        setDropdownOpen(isOpen);
        if (!isOpen) setShowConfigureButton(false);
    }, []);
    return(// eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        onMouseEnter: ()=>{
            setShowConfigureButton(true);
            hoverCallback(true);
        },
        onMouseLeave: ()=>{
            if (!dropdownOpen) {
                setShowConfigureButton(false);
                hoverCallback(false);
            }
        },
        "data-testid": "inline-card-overlay-wrapper"
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        css: $18d1930375b33d5e$var$ConfigureOverlayWrapperStyles
    }, showConfigureButton && /*#__PURE__*/ (0, $1NIU8.jsx)((0, $3uf8Z.OverlayButton), {
        editorView: view,
        targetElementPos: targetElementPos,
        onDropdownChange: onDropdownChange,
        onOpenLinkClick: onOpenLinkClick
    })), children));
};
var $18d1930375b33d5e$export$2e2bcd8739ae039 = $18d1930375b33d5e$var$OverlayWrapper;

});
parcelRegister("3uf8Z", function(module, exports) {

$parcel$export(module.exports, "OverlayButton", () => $fc00550935a2f271$export$8b82a61f37322af9);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $lRq8t = parcelRequire("lRq8t");

var $dUaMU = parcelRequire("dUaMU");

var $3lIcL = parcelRequire("3lIcL");

var $7skWy = parcelRequire("7skWy");

var $k71qx = parcelRequire("k71qx");

var $6dRXt = parcelRequire("6dRXt");

var $9NL13 = parcelRequire("9NL13");

var $8CyhD = parcelRequire("8CyhD");

var $kCZhO = parcelRequire("kCZhO");
function $fc00550935a2f271$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $fc00550935a2f271$var$buttonWrapperStyles = {
    name: "10x6z7s",
    styles: "position:absolute;z-index:100;display:inline-flex;top:50%;transform:translateY(-50%);background:var(--ds-surface-raised, #FFFFFF);border-radius:var(--ds-border-radius, 3px)"
};
const $fc00550935a2f271$var$showDropdownThresholdPx = 50;
const $fc00550935a2f271$export$8b82a61f37322af9 = (0, $dUaMU.default)()(({ editorView: editorView, testId: testId = 'link-configure-overlay-button', targetElementPos: targetElementPos = 0, onDropdownChange: onDropdownChange, onOpenLinkClick: onOpenLinkClick })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const configureLinkLabel = formatMessage((0, $6dRXt.messages).inlineConfigureLink);
    const [showDropdown, setShowDropdown] = (0, $eJOHy.useState)(false);
    const { fireActionClickEvent: fireActionClickEvent, fireLinkClickEvent: fireLinkClickEvent } = (0, $kCZhO.useLinkOverlayAnalyticsEvents)();
    (0, $eJOHy.useLayoutEffect)(()=>{
        let domNode = editorView.nodeDOM(targetElementPos);
        if (domNode?.nodeType === Node.TEXT_NODE) domNode = domNode.parentElement;
        if (domNode instanceof HTMLElement) {
            const { width: width } = domNode.getBoundingClientRect();
            if (width < $fc00550935a2f271$var$showDropdownThresholdPx) setShowDropdown(true);
        }
    }, [
        editorView,
        targetElementPos
    ]);
    const docNode = editorView.state.doc.nodeAt(targetElementPos);
    const nodeEnd = targetElementPos + (docNode?.nodeSize ?? 0);
    const isText = docNode?.isText;
    const handleConfigureClick = (0, $eJOHy.useCallback)(()=>{
        const tr = editorView.state.tr;
        if (isText) tr.setSelection((0, $3lIcL.TextSelection).create(tr.doc, targetElementPos, Math.min(nodeEnd, tr.doc.nodeSize)));
        else tr.setSelection((0, $3lIcL.NodeSelection).create(tr.doc, targetElementPos));
        editorView.dispatch(tr);
    }, [
        editorView,
        isText,
        targetElementPos,
        nodeEnd
    ]);
    const handleConfigureClickWithAnalytics = (0, $eJOHy.useCallback)(()=>{
        fireActionClickEvent('configureLink');
        fireLinkClickEvent();
        handleConfigureClick();
    }, [
        fireLinkClickEvent,
        handleConfigureClick,
        fireActionClickEvent
    ]);
    const { from: from, to: to } = editorView.state.selection;
    const isSelected = from === targetElementPos && to === nodeEnd;
    if (!targetElementPos || isSelected) return null;
    return /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        css: $fc00550935a2f271$var$buttonWrapperStyles,
        "data-testid": testId
    }, showDropdown ? /*#__PURE__*/ (0, $1NIU8.jsx)((0, $9NL13.default), {
        testId: testId,
        onConfigureClick: handleConfigureClick,
        onOpenLinkClick: onOpenLinkClick,
        onDropdownChange: onDropdownChange,
        editorView: editorView
    }) : /*#__PURE__*/ (0, $1NIU8.jsx)((0, $k71qx.default), {
        content: configureLinkLabel,
        hideTooltipOnClick: true,
        testId: `${testId}-tooltip`
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $8CyhD.StyledButton), {
        onClick: handleConfigureClickWithAnalytics,
        iconBefore: /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7skWy))), {
            label: configureLinkLabel,
            LEGACY_size: "small",
            testId: `${testId}-configure-icon`
        })
    })));
});

});
parcelRegister("7skWy", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::59e43c1f00fcc95f49aa5b3733f7f372>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $56db64df0b3e22ba$var$_react = $56db64df0b3e22ba$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $56db64df0b3e22ba$var$_customize = $56db64df0b3e22ba$var$_interopRequireDefault((parcelRequire("iiRWr")));

var $56db64df0b3e22ba$var$_preferences = $56db64df0b3e22ba$var$_interopRequireDefault((parcelRequire("c8Sc8")));
function $56db64df0b3e22ba$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CustomizeIcon.
 * This component is CustomizeIcon, with `UNSAFE_fallbackIcon` set to "PreferencesIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: customize sidebar, customize view, settings.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $56db64df0b3e22ba$var$CustomizeIcon = (props)=>/*#__PURE__*/ $56db64df0b3e22ba$var$_react.default.createElement($56db64df0b3e22ba$var$_customize.default, Object.assign({
        LEGACY_fallbackIcon: $56db64df0b3e22ba$var$_preferences.default
    }, props));
$56db64df0b3e22ba$var$CustomizeIcon.Name = 'CustomizeIconMigration';
var $56db64df0b3e22ba$var$_default = module.exports.default = $56db64df0b3e22ba$var$CustomizeIcon;

});
parcelRegister("iiRWr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c8bb9804f9ea7eaa10f227008c94bcff>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d533c021bfcfd692$var$_react = $d533c021bfcfd692$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $d533c021bfcfd692$var$_baseNew = $d533c021bfcfd692$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $d533c021bfcfd692$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Customize".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: customize sidebar, customize view, settings.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d533c021bfcfd692$var$CustomizeIcon = (props)=>/*#__PURE__*/ $d533c021bfcfd692$var$_react.default.createElement($d533c021bfcfd692$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.375C3 1.615 3.616 1 4.375 1h1.75c.76 0 1.375.616 1.375 1.375v4.25C7.5 7.385 6.884 8 6.125 8h-1.75C3.615 8 3 7.384 3 6.625V5.25H0v-1.5h3zm1.5.125v4H6v-4zM16 5.25H8.5v-1.5H16zM8.5 9.375C8.5 8.615 9.116 8 9.875 8h1.75C12.385 8 13 8.616 13 9.375v1.375h3v1.5h-3v1.375c0 .76-.616 1.375-1.375 1.375h-1.75c-.76 0-1.375-.616-1.375-1.375zM10 9.5v4h1.5v-4zM0 12.25v-1.5h7.5v1.5z" clip-rule="evenodd"/>`
    }, props));
$d533c021bfcfd692$var$CustomizeIcon.displayName = 'CustomizeIcon';
var $d533c021bfcfd692$var$_default = module.exports.default = $d533c021bfcfd692$var$CustomizeIcon;

});

parcelRegister("c8Sc8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8d70455a797b43c6$var$_react = $8d70455a797b43c6$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $8d70455a797b43c6$var$_customize = $8d70455a797b43c6$var$_interopRequireDefault((parcelRequire("iiRWr")));
function $8d70455a797b43c6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8d70455a797b43c6$var$PreferencesIcon = (props)=>/*#__PURE__*/ $8d70455a797b43c6$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M3 7h3v2H3zm0 8h11v2H3zm7-8h11v2H10zm8 8h3v2h-3z"/><path d="M11 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0M9 8a1 1 0 1 0-2 0 1 1 0 0 0 2 0m10 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0m-2 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0"/></g></svg>`
    }, props, {
        newIcon: $8d70455a797b43c6$var$_customize.default
    }));
$8d70455a797b43c6$var$PreferencesIcon.displayName = 'PreferencesIcon';
var $8d70455a797b43c6$var$_default = module.exports.default = $8d70455a797b43c6$var$PreferencesIcon;

});


parcelRegister("9NL13", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ac5097948a5b186$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $lRq8t = parcelRequire("lRq8t");

var $dUaMU = parcelRequire("dUaMU");

var $7rjYb = parcelRequire("7rjYb");
var $jYYbf = parcelRequire("jYYbf");
var $aLJ1L = parcelRequire("aLJ1L");

var $5lAAn = parcelRequire("5lAAn");

var $7skWy = parcelRequire("7skWy");

var $8rAKL = parcelRequire("8rAKL");

var $6dRXt = parcelRequire("6dRXt");

var $8CyhD = parcelRequire("8CyhD");

var $kCZhO = parcelRequire("kCZhO");
const $4ac5097948a5b186$var$SMALL_LINK_TOOLBAR_ANALYTICS_SOURCE = 'smallLinkToolbar';
const $4ac5097948a5b186$var$Dropdown = ({ onConfigureClick: onConfigureClickCallback, onOpenLinkClick: onOpenLinkClickCallback, onDropdownChange: onDropdownChange, editorView: editorView, testId: testId })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const configureLinkLabel = formatMessage((0, $6dRXt.messages).inlineConfigureLink);
    const goToLinkLabel = formatMessage((0, $6dRXt.messages).inlineGoToLink);
    const { fireActionClickEvent: fireActionClickEvent, fireLinkClickEvent: fireLinkClickEvent, fireToolbarViewEvent: fireToolbarViewEvent } = (0, $kCZhO.useLinkOverlayAnalyticsEvents)();
    const focusEditor = (0, $eJOHy.useCallback)(()=>{
        // Fix dropdown giving focus back to the trigger async which is then unmounted and losing focus
        // this is happening deep within atlaskit dropdown as a result of this code: https://github.com/focus-trap/focus-trap/blob/master/index.js#L987
        // use setTimeout to run this async after that call
        setTimeout(()=>editorView.focus(), 0);
    }, [
        editorView
    ]);
    const onOpenChange = (0, $eJOHy.useCallback)(({ isOpen: isOpen, event: event })=>{
        onDropdownChange?.(isOpen);
        if (isOpen) fireToolbarViewEvent();
        if (!isOpen && event instanceof KeyboardEvent) focusEditor();
    }, [
        fireToolbarViewEvent,
        focusEditor,
        onDropdownChange
    ]);
    const onGoToLinkClick = (0, $eJOHy.useCallback)((event)=>{
        fireActionClickEvent('goToLink');
        onOpenLinkClickCallback?.(event);
        focusEditor();
    }, [
        fireActionClickEvent,
        focusEditor,
        onOpenLinkClickCallback
    ]);
    const onConfigureClick = (0, $eJOHy.useCallback)(()=>{
        fireActionClickEvent('configureLink');
        onConfigureClickCallback?.();
        focusEditor();
    }, [
        fireActionClickEvent,
        focusEditor,
        onConfigureClickCallback
    ]);
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $7rjYb.default), {
        trigger: ({ onClick: onClick, triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, $1NIU8.jsx)((0, $8CyhD.StyledButton), {
                innerRef: triggerRef,
                ...props,
                iconBefore: /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5lAAn))), {
                    label: configureLinkLabel,
                    LEGACY_size: "small",
                    size: "small"
                }),
                onClick: (e)=>{
                    onClick?.(e);
                    fireLinkClickEvent();
                }
            }),
        testId: `${testId}-dropdown`,
        onOpenChange: onOpenChange
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $aLJ1L.default), null, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $jYYbf.default), {
        elemBefore: /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8rAKL))), {
            label: goToLinkLabel,
            LEGACY_size: "medium"
        }),
        testId: `${testId}-dropdown-item-open-link`,
        onClick: onGoToLinkClick
    }, goToLinkLabel), /*#__PURE__*/ (0, $1NIU8.jsx)((0, $jYYbf.default), {
        elemBefore: /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7skWy))), {
            label: configureLinkLabel,
            LEGACY_size: "medium"
        }),
        onClick: onConfigureClick,
        testId: `${testId}-dropdown-item-configure`
    }, configureLinkLabel)));
};
var $4ac5097948a5b186$export$2e2bcd8739ae039 = (0, $dUaMU.default)({
    source: $4ac5097948a5b186$var$SMALL_LINK_TOOLBAR_ANALYTICS_SOURCE
})($4ac5097948a5b186$var$Dropdown);

});
parcelRegister("8CyhD", function(module, exports) {

$parcel$export(module.exports, "StyledButton", () => $a85f3c0ab475b4c4$export$2d5d2ba3c7c8c40b);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $goZPP = parcelRequire("goZPP");
function $a85f3c0ab475b4c4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a85f3c0ab475b4c4$var$buttonStyles = {
    name: "1wbjrso",
    styles: "display:flex;background:var(--ds-background-neutral, #091E420F);color:var(--ds-icon, #44546F);&:hover{background:var(--ds-background-neutral-hovered, #091E4224);}&:active{background:var(--ds-background-neutral-pressed, #091E424F);}width:1.375rem;height:1.25rem"
};
const $a85f3c0ab475b4c4$export$2d5d2ba3c7c8c40b = ({ innerRef: innerRef, ...props })=>{
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $goZPP.default), {
        ...props,
        ref: innerRef,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        css: $a85f3c0ab475b4c4$var$buttonStyles
    });
};

});

parcelRegister("kCZhO", function(module, exports) {

$parcel$export(module.exports, "useLinkOverlayAnalyticsEvents", () => $2510b5ab72206780$export$e3984ac3c5c0f603);

var $eJOHy = parcelRequire("eJOHy");

var $bgewf = parcelRequire("bgewf");

var $ftN6c = parcelRequire("ftN6c");

var $bMFKb = parcelRequire("bMFKb");
const $2510b5ab72206780$export$e3984ac3c5c0f603 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    return (0, $eJOHy.useMemo)(()=>({
            /**
			 * When a user clicks go to link or configure link buttons.
			 *
			 * When a link is "wide" the overlay button is the configure button.
			 * When a link is "narrow" the configure button is inside the dropdown.
			 *
			 * @param linkAction 'goToLink' when somebody clicks on the Go to link button
			 * in the chevron menu; 'configureLink' when somebody clicks on the Configure button (whether it's the overlay or in the dropdown)
			 */ fireActionClickEvent: (linkAction)=>{
                createAnalyticsEvent({
                    action: (0, $bMFKb.ACTION).CLICKED,
                    actionSubject: (0, $bMFKb.ACTION_SUBJECT).BUTTON,
                    eventType: (0, $bMFKb.EVENT_TYPE).UI,
                    attributes: {
                        action: linkAction
                    }
                }).fire((0, $bgewf.FabricChannel).media);
            },
            /**
			 * When a user clicks on the dropdown for a short link, or when a user clicks on the configure button for a wide link.
			 */ fireLinkClickEvent: ()=>{
                createAnalyticsEvent({
                    action: (0, $bMFKb.ACTION).CLICKED,
                    actionSubject: (0, $bMFKb.ACTION_SUBJECT).LINK,
                    eventType: (0, $bMFKb.EVENT_TYPE).UI
                }).fire((0, $bgewf.FabricChannel).media);
            },
            fireToolbarViewEvent: ()=>{
                createAnalyticsEvent({
                    action: (0, $bMFKb.ACTION).VIEWED,
                    actionSubject: (0, $bMFKb.ACTION_SUBJECT).INLINE_DIALOG,
                    actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).SMART_LINK_TOOLBAR,
                    eventType: (0, $bMFKb.EVENT_TYPE).UI,
                    attributes: {
                        linkType: 'smallLink'
                    }
                }).fire((0, $bgewf.FabricChannel).media);
            }
        }), [
        createAnalyticsEvent
    ]);
};

});




parcelRegister("3YtqI", function(module, exports) {

$parcel$export(module.exports, "visitCardLinkAnalytics", () => $e4d30f41ed31ac81$export$7ee76be08aa43a42);
$parcel$export(module.exports, "floatingToolbar", () => $e4d30f41ed31ac81$export$4850df084251d287);
$parcel$export(module.exports, "shouldRenderToolbarPulse", () => $e4d30f41ed31ac81$export$ddeab6943680f5be);
$parcel$export(module.exports, "getStartingToolbarItems", () => $e4d30f41ed31ac81$export$bb790f15a666b7f0);
$parcel$export(module.exports, "getEndingToolbarItems", () => $e4d30f41ed31ac81$export$d5ca70670b9f6b9);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $iKozC = parcelRequire("iKozC");

var $bMFKb = parcelRequire("bMFKb");
var $97Qim = parcelRequire("97Qim");

var $1Z6uS = parcelRequire("1Z6uS");
var $6C2m6 = parcelRequire("6C2m6");

var $a36Ig = parcelRequire("a36Ig");

var $80t1d = parcelRequire("80t1d");
var $6dRXt = parcelRequire("6dRXt");
var $h2yqz = parcelRequire("h2yqz");
var $53A9i = parcelRequire("53A9i");
var $4AqYB = parcelRequire("4AqYB");

var $hkyHj = parcelRequire("hkyHj");
var $laqWo = parcelRequire("laqWo");

var $7WlTe = parcelRequire("7WlTe");

var $3lIcL = parcelRequire("3lIcL");

var $BmspC = parcelRequire("BmspC");

var $7yBx7 = parcelRequire("7yBx7");

var $gDKBr = parcelRequire("gDKBr");

var $lGr6J = parcelRequire("lGr6J");

var $4MicW = parcelRequire("4MicW");

var $gTr6H = parcelRequire("gTr6H");

var $25YjY = parcelRequire("25YjY");

var $9itkV = parcelRequire("9itkV");

var $amxqt = parcelRequire("amxqt");

var $2IYY2 = parcelRequire("2IYY2");

var $dQl2w = parcelRequire("dQl2w");

var $8rAKL = parcelRequire("8rAKL");

var $7iUqh = parcelRequire("7iUqh");

var $4F5bb = parcelRequire("4F5bb");

var $eGOwo = parcelRequire("eGOwo");

var $9Letn = parcelRequire("9Letn");

var $92xoS = parcelRequire("92xoS");

var $4AOcQ = parcelRequire("4AOcQ");

var $cuJUr = parcelRequire("cuJUr");

var $gXgTX = parcelRequire("gXgTX");

var $avkZu = parcelRequire("avkZu");

var $2UfVG = parcelRequire("2UfVG");

var $2WxDr = parcelRequire("2WxDr");

var $4i0BY = parcelRequire("4i0BY");

var $lPmSF = parcelRequire("lPmSF");

var $f9t1Y = parcelRequire("f9t1Y");

var $3mqGE = parcelRequire("3mqGE");

var $emx03 = parcelRequire("emx03");
const $e4d30f41ed31ac81$export$3301f76e6efaf85e = (editorAnalyticsApi)=>(0, $6C2m6.commandWithMetadata)((state, dispatch)=>{
        if (!(state.selection instanceof (0, $3lIcL.NodeSelection))) return false;
        const type = state.selection.node.type.name;
        const payload = {
            action: (0, $bMFKb.ACTION).DELETED,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).SMART_LINK,
            actionSubjectId: type,
            attributes: {
                inputMethod: (0, $bMFKb.INPUT_METHOD).FLOATING_TB,
                displayMode: type
            },
            eventType: (0, $bMFKb.EVENT_TYPE).TRACK
        };
        if (dispatch) {
            const { tr: tr } = state;
            (0, $BmspC.removeSelectedNode)(tr);
            editorAnalyticsApi?.attachAnalyticsEvent(payload)(tr);
            dispatch(tr);
        }
        return true;
    }, {
        action: (0, $bMFKb.ACTION).DELETED
    });
const $e4d30f41ed31ac81$export$7ee76be08aa43a42 = (editorAnalyticsApi, inputMethod)=>(state, dispatch)=>{
        if (!(state.selection instanceof (0, $3lIcL.NodeSelection))) return false;
        const { type: type } = state.selection.node;
        if (dispatch) {
            const { tr: tr } = state;
            editorAnalyticsApi?.attachAnalyticsEvent((0, $97Qim.buildVisitedNonHyperLinkPayload)(type.name, inputMethod))(tr);
            dispatch(tr);
        }
        return true;
    };
const $e4d30f41ed31ac81$export$96ed3b1dd32b989d = (editorAnalyticsApi)=>(state, dispatch)=>{
        if (!(state.selection instanceof (0, $3lIcL.NodeSelection))) return false;
        if (dispatch) {
            const { tr: tr, selection: { node: { type: type } } } = state;
            editorAnalyticsApi?.attachAnalyticsEvent((0, $97Qim.buildOpenedSettingsPayload)(type.name))(tr);
            dispatch(tr);
        }
        return true;
    };
const $e4d30f41ed31ac81$export$4850df084251d287 = (cardOptions, lpLinkPicker, linkPickerOptions, pluginInjectionApi, disableFloatingToolbar)=>{
    return (state, intl, providerFactory)=>{
        if (disableFloatingToolbar) return;
        const { inlineCard: inlineCard, blockCard: blockCard, embedCard: embedCard } = state.schema.nodes;
        const nodeType = [
            inlineCard,
            blockCard,
            embedCard
        ];
        const pluginState = (0, $cuJUr.pluginKey).getState(state);
        if (!(state.selection instanceof (0, $3lIcL.NodeSelection))) return;
        const selectedNode = state.selection.node;
        if (!selectedNode) return;
        const isEmbedCard = (0, $gXgTX.appearanceForNodeType)(selectedNode.type) === 'embed';
        /* add an offset to embeds due to extra padding */ const toolbarOffset = isEmbedCard ? {
            offset: [
                0,
                24
            ]
        } : {};
        // Applies padding override for when link picker is currently displayed
        const className = pluginState?.showLinkingToolbar ? (0, $hkyHj.FLOATING_TOOLBAR_LINKPICKER_CLASSNAME) : undefined;
        const isLinkPickerEnabled = !!lpLinkPicker;
        return {
            title: intl.formatMessage((0, $6dRXt.messages).card),
            className: className,
            nodeType: nodeType,
            preventPopupOverflow: isLinkPickerEnabled,
            ...toolbarOffset,
            getDomRef: (view)=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const element = (0, $BmspC.findDomRefAtPos)(view.state.selection.from, view.domAtPos.bind(view));
                if (!element) return undefined;
                if (isEmbedCard) // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                return element.querySelector(`.${(0, $laqWo.richMediaClassName)}`);
                return element;
            },
            items: $e4d30f41ed31ac81$var$generateToolbarItems(state, intl, providerFactory, cardOptions, lpLinkPicker, linkPickerOptions, pluginInjectionApi),
            scrollable: pluginState?.showLinkingToolbar ? false : true,
            ...(0, $2UfVG.editLinkToolbarConfig)(Boolean(pluginState?.showLinkingToolbar), isLinkPickerEnabled)
        };
    };
};
const $e4d30f41ed31ac81$var$unlinkCard = (node, state, editorAnalyticsApi)=>{
    const displayInfo = (0, $gXgTX.displayInfoForCard)(node, (0, $gXgTX.findCardInfo)(state));
    const text = displayInfo.title || displayInfo.url;
    if (text) return (0, $6C2m6.commandWithMetadata)((0, $4AOcQ.changeSelectedCardToText)(text, editorAnalyticsApi), {
        action: (0, $bMFKb.ACTION).UNLINK
    });
    return ()=>false;
};
const $e4d30f41ed31ac81$var$buildAlignmentOptions = (state, intl, widthPluginDependencyApi, analyticsApi, cardOptions)=>{
    if ((0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1')) return (0, $1Z6uS.buildLayoutDropdown)(state, intl, state.schema.nodes.embedCard, widthPluginDependencyApi, analyticsApi, true, true, cardOptions?.allowWrapping, cardOptions?.allowAlignment);
    return (0, $1Z6uS.default)(state, intl, state.schema.nodes.embedCard, widthPluginDependencyApi, analyticsApi, true, true, cardOptions?.allowWrapping, cardOptions?.allowAlignment);
};
const $e4d30f41ed31ac81$var$withToolbarMetadata = (command)=>(0, $6C2m6.commandWithMetadata)(command, {
        inputMethod: (0, $bMFKb.INPUT_METHOD).FLOATING_TB
    });
const $e4d30f41ed31ac81$var$getToolbarViewedItem = (url, display)=>{
    if (!url) return [];
    return [
        {
            type: 'custom',
            fallback: [],
            render: (editorView)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $emx03.ToolbarViewedEvent), {
                    url: url,
                    display: display,
                    editorView: editorView
                }, "edit.link.menu.viewed")
        }
    ];
};
const $e4d30f41ed31ac81$var$generateToolbarItems = (state, intl, providerFactory, cardOptions, lpLinkPicker, linkPicker, pluginInjectionApi)=>(node)=>{
        const { url: url } = (0, $gXgTX.titleUrlPairFromNode)(node);
        const { actions: editorAnalyticsApi } = pluginInjectionApi?.analytics ?? {};
        let metadata = {};
        if (url && !(0, $iKozC.isSafeUrl)(url)) return [];
        else {
            const { title: title } = (0, $gXgTX.displayInfoForCard)(node, (0, $gXgTX.findCardInfo)(state));
            metadata = {
                url: url,
                title: title
            };
        }
        const currentAppearance = (0, $gXgTX.appearanceForNodeType)(node.type);
        const { hoverDecoration: hoverDecoration } = pluginInjectionApi?.decorations?.actions ?? {};
        const isDatasource = (0, $gXgTX.isDatasourceNode)(node);
        const pluginState = (0, $cuJUr.pluginKey).getState(state);
        const annotationApiState = pluginInjectionApi?.annotation?.sharedState.currentState();
        const activeCommentMark = node.marks.find((mark)=>mark.type.name === 'annotation' && annotationApiState?.annotations[mark.attrs.id] === false);
        const isCommentEnabled = annotationApiState && annotationApiState.isVisible && !annotationApiState.bookmark && !annotationApiState.mouseData.isSelecting && !activeCommentMark && node.type === state.schema.nodes.inlineCard;
        const onCommentButtonClick = (state, dispatch)=>{
            if (!pluginInjectionApi?.annotation || !isCommentEnabled) return false;
            pluginInjectionApi?.analytics?.actions?.fireAnalyticsEvent({
                action: (0, $bMFKb.ACTION).CLICKED,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).BUTTON,
                actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).CREATE_INLINE_COMMENT_FROM_HIGHLIGHT_ACTIONS_MENU,
                eventType: (0, $bMFKb.EVENT_TYPE).UI,
                attributes: {
                    source: 'highlightActionsMenu',
                    pageMode: 'edit',
                    sourceNode: 'inlineCard'
                }
            });
            const { setInlineCommentDraftState: setInlineCommentDraftState } = pluginInjectionApi.annotation.actions;
            const command = setInlineCommentDraftState(true, (0, $bMFKb.INPUT_METHOD).FLOATING_TB);
            return command(state, dispatch);
        };
        const shouldRenderDatasourceToolbar = isDatasource && cardOptions.allowDatasource && (0, $7WlTe.canRenderDatasource)(node?.attrs?.datasource?.id);
        if (pluginState?.showLinkingToolbar) return [
            (0, $2UfVG.buildEditLinkToolbar)({
                providerFactory: providerFactory,
                linkPicker: linkPicker,
                node: node,
                pluginInjectionApi: pluginInjectionApi,
                lpLinkPicker: lpLinkPicker
            })
        ];
        else if (shouldRenderDatasourceToolbar) return $e4d30f41ed31ac81$var$getDatasourceButtonGroup(metadata, intl, editorAnalyticsApi, node, hoverDecoration, node.attrs.datasource.id, state, cardOptions, currentAppearance, pluginInjectionApi);
        else {
            const { inlineCard: inlineCard } = state.schema.nodes;
            const editItems = cardOptions.allowDatasource ? [
                {
                    type: 'custom',
                    fallback: [],
                    render: (editorView)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $2WxDr.EditToolbarButton), {
                            url: url,
                            intl: intl,
                            editorAnalyticsApi: editorAnalyticsApi,
                            editorView: editorView,
                            onLinkEditClick: (0, $2UfVG.getEditLinkCallback)(editorAnalyticsApi, true),
                            currentAppearance: currentAppearance
                        }, "edit-toolbar-item")
                }
            ] : [
                {
                    id: 'editor.link.edit',
                    type: 'button',
                    selected: false,
                    metadata: metadata,
                    title: intl.formatMessage((0, $4AqYB.linkToolbarMessages).editLink),
                    showTitle: true,
                    testId: 'link-toolbar-edit-link-button',
                    onClick: (0, $2UfVG.getEditLinkCallback)(editorAnalyticsApi, true)
                },
                {
                    type: 'separator'
                }
            ];
            const commentItems = isCommentEnabled ? [
                {
                    id: 'editor.link.commentLink',
                    type: 'button',
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($gDKBr))),
                    testId: 'inline-card-toolbar-comment-button',
                    iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($amxqt))),
                    title: intl.formatMessage((0, $80t1d.annotationMessages).createComment),
                    showTitle: (0, $92xoS.editorExperiment)('platform_editor_controls', 'control') ? undefined : true,
                    onClick: onCommentButtonClick,
                    disabled: pluginInjectionApi?.connectivity?.sharedState?.currentState()?.mode === 'offline'
                },
                {
                    type: 'separator'
                }
            ] : [];
            const openLinkInputMethod = (0, $bMFKb.INPUT_METHOD).FLOATING_TB;
            const editButtonItems = cardOptions.allowDatasource ? [
                {
                    type: 'custom',
                    fallback: [],
                    render: (editorView)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $2WxDr.EditToolbarButton), {
                            url: url,
                            intl: intl,
                            editorAnalyticsApi: editorAnalyticsApi,
                            editorView: editorView,
                            onLinkEditClick: (0, $2UfVG.getEditLinkCallback)(editorAnalyticsApi, true),
                            currentAppearance: currentAppearance
                        }, "edit-toolbar-item")
                }
            ] : [
                {
                    id: 'editor.link.edit',
                    type: 'button',
                    selected: false,
                    metadata: metadata,
                    title: intl.formatMessage((0, $4AqYB.linkToolbarMessages).editLink),
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($gTr6H))),
                    testId: 'link-toolbar-edit-link-button',
                    onClick: (0, $2UfVG.getEditLinkCallback)(editorAnalyticsApi, true)
                }
            ];
            const toolbarItems = (0, $92xoS.editorExperiment)('platform_editor_controls', 'control') ? [
                ...editItems,
                ...commentItems,
                {
                    id: 'editor.link.openLink',
                    type: 'button',
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($9itkV))),
                    iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($8rAKL))),
                    metadata: metadata,
                    className: 'hyperlink-open-link',
                    title: intl.formatMessage((0, $53A9i.linkMessages).openLink),
                    onClick: $e4d30f41ed31ac81$export$7ee76be08aa43a42(editorAnalyticsApi, openLinkInputMethod),
                    href: url,
                    target: '_blank'
                },
                {
                    type: 'separator'
                },
                ...$e4d30f41ed31ac81$var$getUnlinkButtonGroup(state, intl, node, inlineCard, editorAnalyticsApi),
                {
                    type: 'copy-button',
                    items: [
                        {
                            state: state,
                            formatMessage: intl.formatMessage,
                            nodeType: node.type
                        }
                    ]
                },
                {
                    type: 'separator'
                },
                $e4d30f41ed31ac81$export$62592e141464e202(intl, editorAnalyticsApi, cardOptions.userPreferencesLink),
                {
                    type: 'separator'
                },
                {
                    id: 'editor.link.delete',
                    focusEditoronEnter: true,
                    type: 'button',
                    appearance: 'danger',
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($4MicW))),
                    iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($2IYY2))),
                    onMouseEnter: hoverDecoration?.(node.type, true),
                    onMouseLeave: hoverDecoration?.(node.type, false),
                    onFocus: hoverDecoration?.(node.type, true),
                    onBlur: hoverDecoration?.(node.type, false),
                    title: intl.formatMessage((0, $h2yqz.default).remove),
                    onClick: $e4d30f41ed31ac81$var$withToolbarMetadata($e4d30f41ed31ac81$export$3301f76e6efaf85e(editorAnalyticsApi))
                }
            ] : [
                ...editButtonItems,
                ...(0, $eGOwo.fg)('platform_editor_controls_patch_15') ? [
                    ...$e4d30f41ed31ac81$var$getUnlinkButtonGroup(state, intl, node, inlineCard, editorAnalyticsApi),
                    {
                        type: 'separator',
                        fullHeight: true
                    }
                ] : $e4d30f41ed31ac81$var$getUnlinkButtonGroup(state, intl, node, inlineCard, editorAnalyticsApi),
                {
                    id: 'editor.link.openLink',
                    type: 'button',
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($9itkV))),
                    iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($8rAKL))),
                    metadata: metadata,
                    className: 'hyperlink-open-link',
                    title: intl.formatMessage((0, $53A9i.linkMessages).openLink),
                    onClick: $e4d30f41ed31ac81$export$7ee76be08aa43a42(editorAnalyticsApi, openLinkInputMethod),
                    href: url,
                    target: '_blank'
                },
                ...commentItems.length > 1 ? [
                    {
                        type: 'separator',
                        fullHeight: true
                    },
                    commentItems[0]
                ] : commentItems
            ];
            if (currentAppearance === 'embed') {
                const alignmentOptions = $e4d30f41ed31ac81$var$buildAlignmentOptions(state, intl, pluginInjectionApi?.width, pluginInjectionApi?.analytics?.actions, cardOptions);
                if (alignmentOptions.length && !(0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1')) alignmentOptions.push({
                    type: 'separator'
                });
                toolbarItems.unshift(...alignmentOptions);
            }
            const { allowBlockCards: allowBlockCards, allowEmbeds: allowEmbeds, allowDatasource: allowDatasource, showUpgradeDiscoverability: showUpgradeDiscoverability } = cardOptions;
            // This code will be executed only for appearances such as "inline", "block" & "embed"
            // For url appearance, please see HyperlinkToolbarAppearanceProps
            if (currentAppearance) {
                const showDatasourceAppearance = allowDatasource && url;
                toolbarItems.unshift(...$e4d30f41ed31ac81$var$getToolbarViewedItem(url, currentAppearance), (0, $92xoS.editorExperiment)('platform_editor_controls', 'control') ? {
                    type: 'custom',
                    fallback: [],
                    render: (editorView)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $f9t1Y.LinkToolbarAppearance), {
                            url: url,
                            intl: intl,
                            currentAppearance: currentAppearance,
                            editorView: editorView,
                            editorState: state,
                            allowEmbeds: allowEmbeds,
                            allowBlockCards: allowBlockCards,
                            editorAnalyticsApi: editorAnalyticsApi,
                            showUpgradeDiscoverability: showUpgradeDiscoverability
                        }, "link-appearance")
                } : (0, $3mqGE.getLinkAppearanceDropdown)({
                    url: url,
                    intl: intl,
                    currentAppearance: currentAppearance,
                    editorState: state,
                    allowEmbeds: allowEmbeds,
                    allowBlockCards: allowBlockCards,
                    editorAnalyticsApi: editorAnalyticsApi,
                    allowDatasource: cardOptions.allowDatasource,
                    showUpgradeDiscoverability: showUpgradeDiscoverability,
                    settingsConfig: $e4d30f41ed31ac81$export$62592e141464e202(intl, editorAnalyticsApi, cardOptions.userPreferencesLink),
                    isDatasourceView: isDatasource
                }), ...showDatasourceAppearance && (0, $92xoS.editorExperiment)('platform_editor_controls', 'control') ? [
                    {
                        type: 'custom',
                        fallback: [],
                        render: (editorView)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $avkZu.DatasourceAppearanceButton), {
                                intl: intl,
                                editorAnalyticsApi: editorAnalyticsApi,
                                url: url,
                                editorView: editorView,
                                editorState: state,
                                inputMethod: (0, $bMFKb.INPUT_METHOD).FLOATING_TB
                            })
                    }
                ] : [], ...(0, $9Letn.expValEqualsNoExposure)('platform_editor_controls', 'cohort', 'variant1') ? [] : [
                    {
                        type: 'separator'
                    }
                ]);
            }
            if ((0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1')) {
                const hoverDecorationProps = (nodeType, className)=>({
                        onMouseEnter: hoverDecoration?.(nodeType, true, className),
                        onMouseLeave: hoverDecoration?.(nodeType, false, className),
                        onFocus: hoverDecoration?.(nodeType, true, className),
                        onBlur: hoverDecoration?.(nodeType, false, className)
                    });
                // testId is required to show focus on trigger button on ESC key press
                // see hideOnEsc in platform/packages/editor/editor-plugin-floating-toolbar/src/ui/Dropdown.tsx
                const testId = 'card-overflow-dropdown-trigger';
                const overflowMenuConfig = [
                    {
                        type: 'separator',
                        fullHeight: true
                    },
                    {
                        type: 'overflow-dropdown',
                        testId: testId,
                        options: [
                            {
                                title: intl.formatMessage((0, $h2yqz.default).copyToClipboard),
                                onClick: ()=>{
                                    pluginInjectionApi?.core?.actions.execute(// @ts-ignore
                                    pluginInjectionApi?.floatingToolbar?.commands.copyNode(node.type, (0, $bMFKb.INPUT_METHOD).FLOATING_TB));
                                    return true;
                                },
                                icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lGr6J))), {
                                    label: intl.formatMessage((0, $h2yqz.default).copyToClipboard)
                                }),
                                ...hoverDecorationProps(node.type, (0, $7yBx7.akEditorSelectedNodeClassName))
                            },
                            {
                                title: intl.formatMessage((0, $h2yqz.default).delete),
                                onClick: $e4d30f41ed31ac81$var$withToolbarMetadata($e4d30f41ed31ac81$export$3301f76e6efaf85e(editorAnalyticsApi)),
                                icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4MicW))), {
                                    label: intl.formatMessage((0, $h2yqz.default).delete)
                                }),
                                ...hoverDecorationProps(node.type)
                            }
                        ]
                    }
                ];
                toolbarItems.push(...overflowMenuConfig);
            }
            return toolbarItems;
        }
    };
const $e4d30f41ed31ac81$var$getUnlinkButtonGroup = (state, intl, node, inlineCard, editorAnalyticsApi)=>{
    return node.type === inlineCard ? [
        {
            id: 'editor.link.unlink',
            focusEditoronEnter: true,
            type: 'button',
            title: intl.formatMessage((0, $4AqYB.linkToolbarMessages).unlink),
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($25YjY))),
            iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($dQl2w))),
            onClick: $e4d30f41ed31ac81$var$withToolbarMetadata($e4d30f41ed31ac81$var$unlinkCard(node, state, editorAnalyticsApi))
        },
        ...(0, $9Letn.expValEqualsNoExposure)('platform_editor_controls', 'cohort', 'variant1') ? [] : [
            {
                type: 'separator'
            }
        ]
    ] : [];
};
const $e4d30f41ed31ac81$export$62592e141464e202 = (intl, editorAnalyticsApi, userPreferencesLink)=>{
    return {
        id: 'editor.link.settings',
        type: 'button',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4F5bb))),
        iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($7iUqh))),
        title: intl.formatMessage((0, $4AqYB.linkToolbarMessages).settingsLink),
        onClick: $e4d30f41ed31ac81$export$96ed3b1dd32b989d(editorAnalyticsApi),
        href: userPreferencesLink || (0, $a36Ig.getLinkPreferencesURLFromENV)(),
        target: '_blank'
    };
};
const $e4d30f41ed31ac81$var$getDatasourceButtonGroup = (metadata, intl, editorAnalyticsApi, node, hoverDecoration, datasourceId, state, cardOptions, currentAppearance, pluginInjectionApi)=>{
    const toolbarItems = [];
    const canShowAppearanceSwitch = ()=>{
        // we do not show smart-link or the datasource icons when the node does not have a url to resolve
        if (!metadata.url) return false;
        return true;
    };
    if (canShowAppearanceSwitch()) {
        const { allowBlockCards: allowBlockCards, allowEmbeds: allowEmbeds, showUpgradeDiscoverability: showUpgradeDiscoverability } = cardOptions;
        const { url: url } = metadata;
        if ((0, $92xoS.editorExperiment)('platform_editor_controls', 'control')) toolbarItems.push({
            type: 'custom',
            fallback: [],
            render: (editorView)=>{
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $f9t1Y.LinkToolbarAppearance), {
                    url: url,
                    intl: intl,
                    currentAppearance: currentAppearance,
                    editorView: editorView,
                    editorState: state,
                    allowEmbeds: allowEmbeds,
                    allowBlockCards: allowBlockCards,
                    editorAnalyticsApi: editorAnalyticsApi,
                    showUpgradeDiscoverability: showUpgradeDiscoverability,
                    isDatasourceView: true
                }, "link-appearance");
            }
        }, {
            type: 'custom',
            fallback: [],
            render: (editorView)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $avkZu.DatasourceAppearanceButton), {
                    intl: intl,
                    editorAnalyticsApi: editorAnalyticsApi,
                    url: url,
                    editorView: editorView,
                    editorState: state,
                    selected: true,
                    inputMethod: (0, $bMFKb.INPUT_METHOD).FLOATING_TB
                })
        }, {
            type: 'separator'
        });
        else toolbarItems.push((0, $3mqGE.getLinkAppearanceDropdown)({
            url: url,
            intl: intl,
            currentAppearance: currentAppearance,
            editorState: state,
            allowEmbeds: allowEmbeds,
            allowBlockCards: allowBlockCards,
            editorAnalyticsApi: editorAnalyticsApi,
            allowDatasource: cardOptions.allowDatasource,
            showUpgradeDiscoverability: showUpgradeDiscoverability,
            settingsConfig: $e4d30f41ed31ac81$export$62592e141464e202(intl, editorAnalyticsApi, cardOptions.userPreferencesLink),
            isDatasourceView: true
        }), {
            type: 'separator'
        });
    }
    const openLinkInputMethod = (0, $bMFKb.INPUT_METHOD).FLOATING_TB;
    toolbarItems.push({
        type: 'custom',
        fallback: [],
        render: (editorView)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $2WxDr.EditToolbarButton), {
                datasourceId: datasourceId,
                node: node,
                url: metadata.url,
                intl: intl,
                editorAnalyticsApi: editorAnalyticsApi,
                editorView: editorView,
                onLinkEditClick: (0, $2UfVG.getEditLinkCallback)(editorAnalyticsApi, false),
                currentAppearance: "datasource"
            }, "edit-toolbar-item")
    });
    if (node?.attrs?.url) {
        toolbarItems.push({
            id: 'editor.link.openLink',
            type: 'button',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($9itkV))),
            iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($8rAKL))),
            metadata: metadata,
            className: 'hyperlink-open-link',
            title: intl.formatMessage((0, $53A9i.linkMessages).openLink),
            onClick: $e4d30f41ed31ac81$export$7ee76be08aa43a42(editorAnalyticsApi, openLinkInputMethod),
            href: node.attrs.url,
            target: '_blank'
        });
        if ((0, $92xoS.editorExperiment)('platform_editor_controls', 'control')) toolbarItems.push({
            type: 'separator'
        });
    }
    if ((0, $92xoS.editorExperiment)('platform_editor_controls', 'control')) toolbarItems.push({
        type: 'copy-button',
        supportsViewMode: true,
        items: [
            {
                state: state,
                formatMessage: intl.formatMessage,
                nodeType: node.type
            }
        ]
    }, {
        type: 'separator'
    }, $e4d30f41ed31ac81$export$62592e141464e202(intl, editorAnalyticsApi, cardOptions?.userPreferencesLink), {
        type: 'separator'
    }, {
        id: 'editor.link.delete',
        focusEditoronEnter: true,
        type: 'button',
        appearance: 'danger',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4MicW))),
        iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($2IYY2))),
        onMouseEnter: hoverDecoration?.(node.type, true),
        onMouseLeave: hoverDecoration?.(node.type, false),
        onFocus: hoverDecoration?.(node.type, true),
        onBlur: hoverDecoration?.(node.type, false),
        title: intl.formatMessage((0, $h2yqz.default).remove),
        onClick: $e4d30f41ed31ac81$var$withToolbarMetadata($e4d30f41ed31ac81$export$3301f76e6efaf85e(editorAnalyticsApi))
    });
    else {
        // testId is required to show focus on trigger button on ESC key press
        // see hideOnEsc in platform/packages/editor/editor-plugin-floating-toolbar/src/ui/Dropdown.tsx
        const testId = 'datasource-overflow-dropdown-trigger';
        // When canShowAppearanceSwitch is true, and platform_editor_controls is on, the link appearance dropdown shows, which includes a link preference button
        // So only add the link appearance button when canShowAppearanceSwitch is false
        if (!canShowAppearanceSwitch()) {
            const linkPreferenceButton = $e4d30f41ed31ac81$export$62592e141464e202(intl, editorAnalyticsApi, cardOptions?.userPreferencesLink);
            toolbarItems.push({
                type: 'separator',
                fullHeight: true
            }, linkPreferenceButton, {
                type: 'separator',
                fullHeight: true
            });
        } else toolbarItems.push({
            type: 'separator',
            fullHeight: true
        });
        const overflowMenuConfig = [
            {
                type: 'overflow-dropdown',
                testId: testId,
                options: [
                    {
                        title: intl.formatMessage((0, $h2yqz.default).copyToClipboard),
                        onClick: ()=>{
                            pluginInjectionApi?.core?.actions.execute(// @ts-ignore
                            pluginInjectionApi?.floatingToolbar?.commands.copyNode(node.type, (0, $bMFKb.INPUT_METHOD).FLOATING_TB));
                            return true;
                        },
                        onMouseEnter: hoverDecoration?.(node.type, true, (0, $7yBx7.akEditorSelectedNodeClassName)),
                        onMouseLeave: hoverDecoration?.(node.type, false, (0, $7yBx7.akEditorSelectedNodeClassName)),
                        onFocus: hoverDecoration?.(node.type, true, (0, $7yBx7.akEditorSelectedNodeClassName)),
                        onBlur: hoverDecoration?.(node.type, false, (0, $7yBx7.akEditorSelectedNodeClassName)),
                        icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lGr6J))), {
                            label: intl.formatMessage((0, $h2yqz.default).copyToClipboard)
                        })
                    },
                    {
                        title: intl.formatMessage((0, $h2yqz.default).delete),
                        onClick: $e4d30f41ed31ac81$var$withToolbarMetadata($e4d30f41ed31ac81$export$3301f76e6efaf85e(editorAnalyticsApi)),
                        onMouseEnter: hoverDecoration?.(node.type, true),
                        onMouseLeave: hoverDecoration?.(node.type, false),
                        onFocus: hoverDecoration?.(node.type, true),
                        onBlur: hoverDecoration?.(node.type, false),
                        icon: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4MicW))), {
                            label: intl.formatMessage((0, $h2yqz.default).delete)
                        })
                    }
                ]
            }
        ];
        toolbarItems.push(...overflowMenuConfig);
    }
    return toolbarItems;
};
const $e4d30f41ed31ac81$export$ddeab6943680f5be = (embedEnabled, appearance, status, isDiscoverabilityEnabled)=>{
    return embedEnabled && appearance === 'inline' && status === 'resolved' && isDiscoverabilityEnabled;
};
const $e4d30f41ed31ac81$export$bb790f15a666b7f0 = (options, api)=>{
    return (intl, link, onEditLink, metadata, state)=>{
        const editLinkItem = options.allowDatasource ? [
            {
                type: 'custom',
                fallback: [],
                render: (editorView)=>{
                    if (!editorView) return null;
                    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2WxDr.EditToolbarButton), {
                        intl: intl,
                        editorAnalyticsApi: api?.analytics?.actions,
                        url: link,
                        editorView: editorView,
                        onLinkEditClick: onEditLink,
                        currentAppearance: "url"
                    }, "edit-toolbar-button");
                }
            }
        ] : [
            {
                id: 'editor.link.edit',
                testId: 'editor.link.edit',
                type: 'button',
                onClick: onEditLink,
                title: intl.formatMessage((0, $4AqYB.linkToolbarMessages).editLink),
                showTitle: (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1') ? false : true,
                metadata: metadata,
                icon: (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1') ? (0, (/*@__PURE__*/$parcel$interopDefault($gTr6H))) : undefined
            },
            {
                type: 'separator'
            }
        ];
        if ((0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1')) {
            const hyperlinkAppearance = [
                (0, $lPmSF.getCustomHyperlinkAppearanceDropdown)({
                    url: link,
                    intl: intl,
                    editorAnalyticsApi: api?.analytics?.actions,
                    allowDatasource: options.allowDatasource,
                    editorPluginApi: api,
                    cardOptions: options,
                    settingsConfig: $e4d30f41ed31ac81$export$62592e141464e202(intl, api?.analytics?.actions, options.userPreferencesLink),
                    isDatasourceView: false
                })
            ];
            return [
                {
                    type: 'custom',
                    fallback: [],
                    render: (editorView)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $emx03.ToolbarViewedEvent), {
                            url: link,
                            display: "url",
                            editorView: editorView
                        }, "edit.link.menu.viewed")
                },
                ...hyperlinkAppearance,
                ...editLinkItem
            ];
        }
        return [
            {
                type: 'custom',
                fallback: [],
                render: (editorView)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $emx03.ToolbarViewedEvent), {
                        url: link,
                        display: "url",
                        editorView: editorView
                    }, "edit.link.menu.viewed")
            },
            {
                type: 'custom',
                fallback: [],
                render: (editorView)=>{
                    if (!editorView) return null;
                    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4i0BY.HyperlinkToolbarAppearance), {
                        url: link,
                        intl: intl,
                        editorView: editorView,
                        editorState: editorView.state,
                        cardOptions: options,
                        editorAnalyticsApi: api?.analytics?.actions,
                        editorPluginApi: api
                    }, "link-appearance");
                }
            },
            ...editLinkItem
        ];
    };
};
const $e4d30f41ed31ac81$export$d5ca70670b9f6b9 = (options, api)=>(intl, link)=>{
        /**
		 * Require either provider to be supplied (controls link preferences)
		 * Or explicit user preferences config in order to enable button
		 */ if ((options.provider || options.userPreferencesLink) && (0, $92xoS.editorExperiment)('platform_editor_controls', 'control')) return [
            {
                type: 'separator'
            },
            $e4d30f41ed31ac81$export$62592e141464e202(intl, api?.analytics?.actions, options.userPreferencesLink)
        ];
        return [];
    };

});
parcelRegister("1Z6uS", function(module, exports) {

$parcel$export(module.exports, "alignmentIcons", () => $5751481beccc93da$export$45400139bf999022);
$parcel$export(module.exports, "wrappingIcons", () => $5751481beccc93da$export$88511ca1ca567d46);
$parcel$export(module.exports, "layoutToMessages", () => $5751481beccc93da$export$b978ceeb25a89f87);
$parcel$export(module.exports, "buildLayoutDropdown", () => $5751481beccc93da$export$31e29507a90f6f72);
$parcel$export(module.exports, "default", () => $5751481beccc93da$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $3lIcL = parcelRequire("3lIcL");

var $BmspC = parcelRequire("BmspC");

var $7yBx7 = parcelRequire("7yBx7");

var $1H3iv = parcelRequire("1H3iv");

var $4Iuny = parcelRequire("4Iuny");

var $8JqPQ = parcelRequire("8JqPQ");

var $lJX99 = parcelRequire("lJX99");

var $bpdtz = parcelRequire("bpdtz");

var $dkMBa = parcelRequire("dkMBa");

var $2WniS = parcelRequire("2WniS");

var $fgmtQ = parcelRequire("fgmtQ");

var $cgHXF = parcelRequire("cgHXF");

var $i4pBY = parcelRequire("i4pBY");

var $4Mccv = parcelRequire("4Mccv");

var $8gvqu = parcelRequire("8gvqu");

var $1sHch = parcelRequire("1sHch");

var $8xVOG = parcelRequire("8xVOG");

var $kWoux = parcelRequire("kWoux");

var $bMFKb = parcelRequire("bMFKb");

var $eQTBG = parcelRequire("eQTBG");

var $6Exgk = parcelRequire("6Exgk");

var $h2yqz = parcelRequire("h2yqz");
var $jSSd5 = parcelRequire("jSSd5");

var $1l7GR = parcelRequire("1l7GR");

var $19zEl = parcelRequire("19zEl");
var $5Z3Rm = parcelRequire("5Z3Rm");
const $5751481beccc93da$export$45400139bf999022 = [
    {
        id: 'editor.media.alignLeft',
        value: 'align-start',
        icon: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4Iuny))), {
                color: "currentColor",
                spacing: "spacious",
                label: "media-toolbar-align-left-icon",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($8gvqu)))
            })
    },
    {
        id: 'editor.media.alignCenter',
        value: 'center',
        icon: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1H3iv))), {
                color: "currentColor",
                spacing: "spacious",
                label: "media-toolbar-align-center-icon",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($4Mccv)))
            })
    },
    {
        id: 'editor.media.alignRight',
        value: 'align-end',
        icon: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8JqPQ))), {
                color: "currentColor",
                spacing: "spacious",
                label: "media-toolbar-align-right-icon",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($1sHch)))
            })
    }
];
const $5751481beccc93da$var$alignmentIconsControls = [
    {
        id: 'editor.media.alignLeft',
        value: 'align-start',
        icon: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bpdtz))), {
                color: "currentColor",
                spacing: "spacious",
                label: ""
            }),
        keyboardShortcut: (0, $6Exgk.alignLeft)
    },
    {
        id: 'editor.media.alignCenter',
        value: 'center',
        icon: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lJX99))), {
                color: "currentColor",
                spacing: "spacious",
                label: ""
            }),
        keyboardShortcut: (0, $6Exgk.alignCenter)
    },
    {
        id: 'editor.media.alignRight',
        value: 'align-end',
        icon: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dkMBa))), {
                color: "currentColor",
                spacing: "spacious",
                label: ""
            }),
        keyboardShortcut: (0, $6Exgk.alignRight)
    }
];
const $5751481beccc93da$export$88511ca1ca567d46 = [
    {
        id: 'editor.media.wrapLeft',
        value: 'wrap-left',
        icon: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2WniS))), {
                color: "currentColor",
                spacing: "spacious",
                label: "media-toolbar-wrap-left-icon",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($8xVOG)))
            })
    },
    {
        id: 'editor.media.wrapRight',
        value: 'wrap-right',
        icon: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fgmtQ))), {
                color: "currentColor",
                spacing: "spacious",
                label: "media-toolbar-wrap-right-icon",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($kWoux)))
            })
    }
];
const $5751481beccc93da$var$breakoutIcons = [
    {
        value: 'wide',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cgHXF)))
    },
    {
        value: 'full-width',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($i4pBY)))
    }
];
const $5751481beccc93da$export$b978ceeb25a89f87 = {
    'wrap-left': (0, $jSSd5.toolbarMessages).wrapLeft,
    center: (0, $h2yqz.default).alignImageCenter,
    'wrap-right': (0, $jSSd5.toolbarMessages).wrapRight,
    wide: (0, $h2yqz.default).layoutWide,
    'full-width': (0, $h2yqz.default).layoutFullWidth,
    'align-end': (0, $h2yqz.default).alignImageRight,
    'align-start': (0, $h2yqz.default).alignImageLeft
};
const $5751481beccc93da$var$getNodeWidth = (node, schema)=>{
    const { embedCard: embedCard } = schema.nodes;
    if (node.type === embedCard) return node.attrs.originalWidth || (0, $7yBx7.DEFAULT_EMBED_CARD_WIDTH);
    return node.firstChild && node.firstChild.attrs.width || node.attrs.width;
};
const $5751481beccc93da$var$makeAlign = (layout, nodeType, widthPluginDependencyApi, analyticsApi, allowPixelResizing)=>{
    return (state, dispatch)=>{
        const { node: node } = state.selection;
        const { layout: previousLayoutType } = node.attrs;
        const { mediaSingle: mediaSingle } = state.schema.nodes;
        if (!dispatch) return false;
        const widthPluginState = widthPluginDependencyApi?.sharedState.currentState();
        if (!node || node.type !== nodeType || !widthPluginState) return false;
        const nodeWidth = $5751481beccc93da$var$getNodeWidth(node, state.schema);
        const newAttrs = allowPixelResizing ? {
            ...node.attrs,
            layout: layout
        } : (0, $19zEl.alignAttributes)(layout, node.attrs, undefined, nodeWidth, widthPluginState.lineLength);
        const tr = state.tr.setNodeMarkup(state.selection.from, undefined, newAttrs);
        tr.setMeta('scrollIntoView', false);
        // when image captions are enabled, the wrong node gets selected after
        // setNodeMarkup is called
        tr.setSelection((0, $3lIcL.NodeSelection).create(tr.doc, state.selection.from));
        const { doc: { type: { schema: { nodes: { paragraph: paragraph } } } } } = tr;
        // see https://product-fabric.atlassian.net/browse/ED-15518 insert a new paragraph when an embedded card is wrapped left or right
        if (layout.startsWith('wrap') && paragraph && !tr.doc.nodeAt(state.selection.to) && ((0, $eQTBG.insideTable)(state) || (0, $5Z3Rm.isInLayoutColumn)(state))) {
            const emptyParaghraph = paragraph.createAndFill();
            if (emptyParaghraph) tr.insert(state.selection.to, emptyParaghraph);
        }
        analyticsApi?.attachAnalyticsEvent({
            eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
            action: (0, $bMFKb.ACTION).SELECTED,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT)[node.type === mediaSingle ? 'MEDIA_SINGLE' : 'EMBEDS'],
            actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).RICH_MEDIA_LAYOUT,
            attributes: {
                previousLayoutType: previousLayoutType,
                currentLayoutType: layout
            }
        })(tr);
        dispatch(tr);
        return true;
    };
};
const $5751481beccc93da$var$getToolbarLayout = (layout, allowPixelResizing)=>{
    if ((0, $19zEl.nonWrappedLayouts).includes(layout) && allowPixelResizing) return 'center';
    return layout;
};
const $5751481beccc93da$var$mapIconsToToolbarItem = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
icons, layout, intl, nodeType, widthPluginDependencyApi, analyticsApi, isChangingLayoutDisabled, allowPixelResizing)=>icons.map((toolbarItem)=>{
        const { id: id, value: value } = toolbarItem;
        return {
            id: id,
            type: 'button',
            icon: toolbarItem.icon,
            title: intl.formatMessage($5751481beccc93da$export$b978ceeb25a89f87[value]),
            selected: $5751481beccc93da$var$getToolbarLayout(layout, allowPixelResizing) === value,
            onClick: $5751481beccc93da$var$makeAlign(value, nodeType, widthPluginDependencyApi, analyticsApi, allowPixelResizing),
            ...isChangingLayoutDisabled && {
                disabled: value !== 'center'
            }
        };
    });
const $5751481beccc93da$var$mapIconsToDropdownOptions = ({ icons: icons, layout: layout, intl: intl, nodeType: nodeType, widthPluginDependencyApi: widthPluginDependencyApi, analyticsApi: analyticsApi, isChangingLayoutDisabled: isChangingLayoutDisabled, allowPixelResizing: allowPixelResizing })=>icons.map((layoutOption)=>{
        const { id: id, value: value } = layoutOption;
        return {
            id: id,
            icon: /*#__PURE__*/ (0, $gt9Am.jsx)(layoutOption.icon, {
                label: ""
            }),
            title: intl.formatMessage($5751481beccc93da$export$b978ceeb25a89f87[value]),
            selected: $5751481beccc93da$var$getToolbarLayout(layout, allowPixelResizing) === value,
            onClick: $5751481beccc93da$var$makeAlign(value, nodeType, widthPluginDependencyApi, analyticsApi, allowPixelResizing),
            ...layoutOption.keyboardShortcut && {
                elemAfter: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1l7GR.Shortcut), {
                    children: (0, $6Exgk.tooltip)(layoutOption.keyboardShortcut)
                })
            },
            ...isChangingLayoutDisabled && {
                disabled: value !== 'center'
            }
        };
    });
const $5751481beccc93da$var$shouldHideLayoutToolbar = (selection, { nodes: nodes }, allowResizingInTables)=>{
    return (0, $BmspC.hasParentNodeOfType)([
        nodes.bodiedExtension,
        nodes.extensionFrame,
        nodes.listItem,
        nodes.expand,
        nodes.nestedExpand,
        ...allowResizingInTables ? [] : [
            nodes.table
        ]
    ].filter(Boolean))(selection);
};
const $5751481beccc93da$var$buildLayoutButtons = (state, intl, nodeType, widthPluginDependencyApi, analyticsApi, allowResizing, allowResizingInTables, allowWrapping = true, allowAlignment = true, isChangingLayoutDisabled, allowPixelResizing)=>{
    const { selection: selection } = state;
    if (!(selection instanceof (0, $3lIcL.NodeSelection)) || !selection.node || !nodeType || $5751481beccc93da$var$shouldHideLayoutToolbar(selection, state.schema, allowResizingInTables)) return [];
    const { layout: layout } = selection.node.attrs;
    const alignmentToolbarItems = allowAlignment ? $5751481beccc93da$var$mapIconsToToolbarItem($5751481beccc93da$export$45400139bf999022, layout, intl, nodeType, widthPluginDependencyApi, analyticsApi, isChangingLayoutDisabled, allowPixelResizing) : [];
    const wrappingToolbarItems = allowWrapping ? $5751481beccc93da$var$mapIconsToToolbarItem($5751481beccc93da$export$88511ca1ca567d46, layout, intl, nodeType, widthPluginDependencyApi, analyticsApi, isChangingLayoutDisabled, allowPixelResizing) : [];
    const breakOutToolbarItems = !allowResizing ? $5751481beccc93da$var$mapIconsToToolbarItem($5751481beccc93da$var$breakoutIcons, layout, intl, nodeType, widthPluginDependencyApi, analyticsApi, allowPixelResizing) : [];
    const items = [
        ...alignmentToolbarItems,
        ...$5751481beccc93da$var$getSeparatorBetweenAlignmentAndWrapping(allowAlignment, allowWrapping),
        ...wrappingToolbarItems,
        ...$5751481beccc93da$var$getSeparatorBeforeBreakoutItems(allowAlignment, allowWrapping, allowResizing),
        ...breakOutToolbarItems
    ];
    return items;
};
const $5751481beccc93da$export$31e29507a90f6f72 = (state, intl, nodeType, widthPluginDependencyApi, analyticsApi, allowResizing, allowResizingInTables, allowWrapping = true, allowAlignment = true, isChangingLayoutDisabled, allowPixelResizing)=>{
    const { selection: selection } = state;
    if (!(selection instanceof (0, $3lIcL.NodeSelection)) || !selection.node || !nodeType || $5751481beccc93da$var$shouldHideLayoutToolbar(selection, state.schema, allowResizingInTables)) return [];
    const { layout: layout } = selection.node.attrs;
    const icons = [];
    if (allowAlignment) icons.push(...$5751481beccc93da$var$alignmentIconsControls);
    if (allowWrapping) icons.push(...$5751481beccc93da$export$88511ca1ca567d46);
    if (!allowResizing) icons.push(...$5751481beccc93da$var$breakoutIcons);
    if (icons.length === 0) return [];
    const selectedLayout = $5751481beccc93da$var$getSelectedLayoutIcon(icons, selection.node) || icons[0];
    if (!selectedLayout) return [];
    const alignmentDropdownOptions = $5751481beccc93da$var$mapIconsToDropdownOptions({
        icons: icons,
        layout: layout,
        intl: intl,
        nodeType: nodeType,
        widthPluginDependencyApi: widthPluginDependencyApi,
        analyticsApi: analyticsApi,
        isChangingLayoutDisabled: isChangingLayoutDisabled,
        allowPixelResizing: allowPixelResizing
    });
    return [
        {
            type: 'dropdown',
            title: intl.formatMessage($5751481beccc93da$export$b978ceeb25a89f87[selectedLayout.value]),
            icon: selectedLayout.icon,
            options: alignmentDropdownOptions,
            shouldFitContainer: false,
            testId: `${nodeType.name}-layout-dropdown-trigger-button`
        }
    ];
};
const $5751481beccc93da$var$getSelectedLayoutIcon = (layoutIcons, selectedNode)=>{
    const selectedLayout = selectedNode.attrs.layout;
    return layoutIcons.find((icon)=>icon.value === ((0, $19zEl.nonWrappedLayouts).includes(selectedLayout) ? 'center' : selectedLayout));
};
const $5751481beccc93da$var$getSeparatorBetweenAlignmentAndWrapping = (allowAlignment, allowWrapping)=>allowAlignment && allowWrapping ? [
        {
            type: 'separator'
        }
    ] : [];
const $5751481beccc93da$var$getSeparatorBeforeBreakoutItems = (allowAlignment, allowWrapping, allowResizing)=>!allowResizing && (allowAlignment || allowWrapping) ? [
        {
            type: 'separator'
        }
    ] : [];
var $5751481beccc93da$export$2e2bcd8739ae039 = $5751481beccc93da$var$buildLayoutButtons;

});
parcelRegister("1H3iv", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c29f4a0259814750cfbaa12b98a0b76b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $13bc5d68cdd6f976$var$_react = $13bc5d68cdd6f976$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $13bc5d68cdd6f976$var$_baseNew = $13bc5d68cdd6f976$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $13bc5d68cdd6f976$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AlignImageCenter".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for center aligning media and content.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $13bc5d68cdd6f976$var$AlignImageCenterIcon = (props)=>/*#__PURE__*/ $13bc5d68cdd6f976$var$_react.default.createElement($13bc5d68cdd6f976$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 2.5H1V1h14zm-8.5 4v3h3v-3zM6.375 5h3.25C10.385 5 11 5.616 11 6.375v3.25c0 .76-.616 1.375-1.375 1.375h-3.25C5.615 11 5 10.384 5 9.625v-3.25C5 5.615 5.616 5 6.375 5M15 15H1v-1.5h14z" clip-rule="evenodd"/>`
    }, props));
$13bc5d68cdd6f976$var$AlignImageCenterIcon.displayName = 'AlignImageCenterIcon';
var $13bc5d68cdd6f976$var$_default = module.exports.default = $13bc5d68cdd6f976$var$AlignImageCenterIcon;

});

parcelRegister("4Iuny", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::506bf6a220572205d8f164c0b4e914b9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $36f2d614a756bfcb$var$_react = $36f2d614a756bfcb$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $36f2d614a756bfcb$var$_baseNew = $36f2d614a756bfcb$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $36f2d614a756bfcb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AlignImageLeft".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for left aligning media and content.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $36f2d614a756bfcb$var$AlignImageLeftIcon = (props)=>/*#__PURE__*/ $36f2d614a756bfcb$var$_react.default.createElement($36f2d614a756bfcb$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 2.5H1V1h14zm-12.5 4v3h3v-3zM2.375 5h3.25C6.385 5 7 5.616 7 6.375v3.25C7 10.385 6.384 11 5.625 11h-3.25C1.615 11 1 10.384 1 9.625v-3.25C1 5.615 1.616 5 2.375 5M15 15H1v-1.5h14z" clip-rule="evenodd"/>`
    }, props));
$36f2d614a756bfcb$var$AlignImageLeftIcon.displayName = 'AlignImageLeftIcon';
var $36f2d614a756bfcb$var$_default = module.exports.default = $36f2d614a756bfcb$var$AlignImageLeftIcon;

});

parcelRegister("8JqPQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::21fbbdedad020db28712a646625964de>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $65b757a0f8870b6f$var$_react = $65b757a0f8870b6f$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $65b757a0f8870b6f$var$_baseNew = $65b757a0f8870b6f$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $65b757a0f8870b6f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AlignImageRight".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for right aligning media and content.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $65b757a0f8870b6f$var$AlignImageRightIcon = (props)=>/*#__PURE__*/ $65b757a0f8870b6f$var$_react.default.createElement($65b757a0f8870b6f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 2.5H1V1h14zm-4.5 4v3h3v-3zM10.375 5h3.25C14.385 5 15 5.616 15 6.375v3.25c0 .76-.616 1.375-1.375 1.375h-3.25C9.615 11 9 10.384 9 9.625v-3.25C9 5.615 9.616 5 10.375 5M15 15H1v-1.5h14z" clip-rule="evenodd"/>`
    }, props));
$65b757a0f8870b6f$var$AlignImageRightIcon.displayName = 'AlignImageRightIcon';
var $65b757a0f8870b6f$var$_default = module.exports.default = $65b757a0f8870b6f$var$AlignImageRightIcon;

});

parcelRegister("lJX99", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0081361c361775d250c8deee2b06f0cb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fd3bae342287b32c$var$_react = $fd3bae342287b32c$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fd3bae342287b32c$var$_baseNew = $fd3bae342287b32c$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $fd3bae342287b32c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AlignTextCenter".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: align text center, align center.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fd3bae342287b32c$var$AlignTextCenterIcon = (props)=>/*#__PURE__*/ $fd3bae342287b32c$var$_react.default.createElement($fd3bae342287b32c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12 3.5H4V2h8zm3 5.25H1v-1.5h14zM12 14H4v-1.5h8z" clip-rule="evenodd"/>`
    }, props));
$fd3bae342287b32c$var$AlignTextCenterIcon.displayName = 'AlignTextCenterIcon';
var $fd3bae342287b32c$var$_default = module.exports.default = $fd3bae342287b32c$var$AlignTextCenterIcon;

});

parcelRegister("dkMBa", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5e502391cfc4910fd8e80122508c043b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9b52d74236f48f74$var$_react = $9b52d74236f48f74$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $9b52d74236f48f74$var$_baseNew = $9b52d74236f48f74$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $9b52d74236f48f74$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AlignTextRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: align text right, align content right.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9b52d74236f48f74$var$AlignTextRightIcon = (props)=>/*#__PURE__*/ $9b52d74236f48f74$var$_react.default.createElement($9b52d74236f48f74$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm0 5.25H1v-1.5h14zM15 14H8v-1.5h7z" clip-rule="evenodd"/>`
    }, props));
$9b52d74236f48f74$var$AlignTextRightIcon.displayName = 'AlignTextRightIcon';
var $9b52d74236f48f74$var$_default = module.exports.default = $9b52d74236f48f74$var$AlignTextRightIcon;

});

parcelRegister("2WniS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f6da00ec8512e57c3de0efa89726a9f3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2243131c5a620f1e$var$_react = $2243131c5a620f1e$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $2243131c5a620f1e$var$_baseNew = $2243131c5a620f1e$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $2243131c5a620f1e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ContentWrapLeft".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for left aligning media and content with wrapping enabled.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2243131c5a620f1e$var$ContentWrapLeftIcon = (props)=>/*#__PURE__*/ $2243131c5a620f1e$var$_react.default.createElement($2243131c5a620f1e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 2.5H1V1h14zm-12.5 4v3h3v-3zM2.375 5h3.25C6.385 5 7 5.616 7 6.375v3.25C7 10.385 6.384 11 5.625 11h-3.25C1.615 11 1 10.384 1 9.625v-3.25C1 5.615 1.616 5 2.375 5M15 6.667H9v-1.5h6zm0 4.166H9v-1.5h6zM15 15H1v-1.5h14z" clip-rule="evenodd"/>`
    }, props));
$2243131c5a620f1e$var$ContentWrapLeftIcon.displayName = 'ContentWrapLeftIcon';
var $2243131c5a620f1e$var$_default = module.exports.default = $2243131c5a620f1e$var$ContentWrapLeftIcon;

});

parcelRegister("fgmtQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::90d4f39c8de9988af1e49ad1b0ebf32f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b1c9c9c5e2952c8c$var$_react = $b1c9c9c5e2952c8c$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $b1c9c9c5e2952c8c$var$_baseNew = $b1c9c9c5e2952c8c$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $b1c9c9c5e2952c8c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ContentWrapRight".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for right aligning media and content with wrapping enabled.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b1c9c9c5e2952c8c$var$ContentWrapRightIcon = (props)=>/*#__PURE__*/ $b1c9c9c5e2952c8c$var$_react.default.createElement($b1c9c9c5e2952c8c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 2.5H1V1h14zm-4.5 4v3h3v-3zM10.375 5h3.25C14.385 5 15 5.616 15 6.375v3.25c0 .76-.616 1.375-1.375 1.375h-3.25C9.615 11 9 10.384 9 9.625v-3.25C9 5.615 9.616 5 10.375 5M7 6.667H1v-1.5h6zm0 4.166H1v-1.5h6zM15 15H1v-1.5h14z" clip-rule="evenodd"/>`
    }, props));
$b1c9c9c5e2952c8c$var$ContentWrapRightIcon.displayName = 'ContentWrapRightIcon';
var $b1c9c9c5e2952c8c$var$_default = module.exports.default = $b1c9c9c5e2952c8c$var$ContentWrapRightIcon;

});

parcelRegister("cgHXF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2716122b6a537da8b4672ec6f364530a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8ee91479ed754a42$var$_react = $8ee91479ed754a42$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $8ee91479ed754a42$var$_contentWidthWide = $8ee91479ed754a42$var$_interopRequireDefault((parcelRequire("dweXS")));

var $8ee91479ed754a42$var$_mediaWide = $8ee91479ed754a42$var$_interopRequireDefault((parcelRequire("2dRbb")));
function $8ee91479ed754a42$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ContentWidthWideIcon.
 * This component is ContentWidthWideIcon, with `UNSAFE_fallbackIcon` set to "EditorMediaWideIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for setting media and content to a wide width.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8ee91479ed754a42$var$ContentWidthWideIcon = (props)=>/*#__PURE__*/ $8ee91479ed754a42$var$_react.default.createElement($8ee91479ed754a42$var$_contentWidthWide.default, Object.assign({
        LEGACY_fallbackIcon: $8ee91479ed754a42$var$_mediaWide.default
    }, props));
$8ee91479ed754a42$var$ContentWidthWideIcon.Name = 'ContentWidthWideIconMigration';
var $8ee91479ed754a42$var$_default = module.exports.default = $8ee91479ed754a42$var$ContentWidthWideIcon;

});
parcelRegister("dweXS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bf280c6bc7e165359296875525b3bf6c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9d79df392ff01981$var$_react = $9d79df392ff01981$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $9d79df392ff01981$var$_baseNew = $9d79df392ff01981$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $9d79df392ff01981$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ContentWidthWide".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for setting media and content to a wide width.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9d79df392ff01981$var$ContentWidthWideIcon = (props)=>/*#__PURE__*/ $9d79df392ff01981$var$_react.default.createElement($9d79df392ff01981$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12 2.5H4V1h8zm-10.5 3v5h13v-5zM1.375 4h13.25C15.385 4 16 4.616 16 5.375v5.25c0 .76-.616 1.375-1.375 1.375H1.375C.615 12 0 11.384 0 10.625v-5.25C0 4.615.616 4 1.375 4M12 15H4v-1.5h8z" clip-rule="evenodd"/>`
    }, props));
$9d79df392ff01981$var$ContentWidthWideIcon.displayName = 'ContentWidthWideIcon';
var $9d79df392ff01981$var$_default = module.exports.default = $9d79df392ff01981$var$ContentWidthWideIcon;

});

parcelRegister("2dRbb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $19e60bf8d3edaacc$var$_react = $19e60bf8d3edaacc$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $19e60bf8d3edaacc$var$_contentWidthWide = $19e60bf8d3edaacc$var$_interopRequireDefault((parcelRequire("dweXS")));
function $19e60bf8d3edaacc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $19e60bf8d3edaacc$var$EditorMediaWideIcon = (props)=>/*#__PURE__*/ $19e60bf8d3edaacc$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M7 5h10a1 1 0 0 1 0 2H7a1 1 0 1 1 0-2m0 12h10a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2M4 9h16a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1"/></svg>`
    }, props, {
        newIcon: $19e60bf8d3edaacc$var$_contentWidthWide.default
    }));
$19e60bf8d3edaacc$var$EditorMediaWideIcon.displayName = 'EditorMediaWideIcon';
var $19e60bf8d3edaacc$var$_default = module.exports.default = $19e60bf8d3edaacc$var$EditorMediaWideIcon;

});


parcelRegister("i4pBY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b0b09173036d3d94afd21e9d81369a03>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d27c77a120a03d3a$var$_react = $d27c77a120a03d3a$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $d27c77a120a03d3a$var$_expandHorizontal = $d27c77a120a03d3a$var$_interopRequireDefault((parcelRequire("cc5Qv")));

var $d27c77a120a03d3a$var$_mediaFullWidth = $d27c77a120a03d3a$var$_interopRequireDefault((parcelRequire("cR50m")));
function $d27c77a120a03d3a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ExpandHorizontalIcon.
 * This component is ExpandHorizontalIcon, with `UNSAFE_fallbackIcon` set to "EditorMediaFullWidthIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for expanding an element to its maximum width.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d27c77a120a03d3a$var$ExpandHorizontalIcon = (props)=>/*#__PURE__*/ $d27c77a120a03d3a$var$_react.default.createElement($d27c77a120a03d3a$var$_expandHorizontal.default, Object.assign({
        LEGACY_fallbackIcon: $d27c77a120a03d3a$var$_mediaFullWidth.default
    }, props));
$d27c77a120a03d3a$var$ExpandHorizontalIcon.Name = 'ExpandHorizontalIconMigration';
var $d27c77a120a03d3a$var$_default = module.exports.default = $d27c77a120a03d3a$var$ExpandHorizontalIcon;

});
parcelRegister("cc5Qv", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c9fe0fb92f8f001af056b55b163878fe>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8e0b23e107eb6b4f$var$_react = $8e0b23e107eb6b4f$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $8e0b23e107eb6b4f$var$_baseNew = $8e0b23e107eb6b4f$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $8e0b23e107eb6b4f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ExpandHorizontal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for expanding an element to its maximum width.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8e0b23e107eb6b4f$var$ExpandHorizontalIcon = (props)=>/*#__PURE__*/ $8e0b23e107eb6b4f$var$_react.default.createElement($8e0b23e107eb6b4f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 15V1h1.5v14zm16 0h-1.5V1H16zM3.22 7.47l2.5-2.5 1.06 1.06-1.22 1.22h4.88L9.22 6.03l1.06-1.06 2.5 2.5a.75.75 0 0 1 0 1.06l-2.5 2.5-1.06-1.06 1.22-1.22H5.56l1.22 1.22-1.06 1.06-2.5-2.5a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>`
    }, props));
$8e0b23e107eb6b4f$var$ExpandHorizontalIcon.displayName = 'ExpandHorizontalIcon';
var $8e0b23e107eb6b4f$var$_default = module.exports.default = $8e0b23e107eb6b4f$var$ExpandHorizontalIcon;

});

parcelRegister("cR50m", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $95be5125807f2a94$var$_react = $95be5125807f2a94$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $95be5125807f2a94$var$_expandHorizontal = $95be5125807f2a94$var$_interopRequireDefault((parcelRequire("cc5Qv")));
function $95be5125807f2a94$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $95be5125807f2a94$var$EditorMediaFullWidthIcon = (props)=>/*#__PURE__*/ $95be5125807f2a94$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M7 17h10a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2M4 5h16a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1"/></svg>`
    }, props, {
        newIcon: $95be5125807f2a94$var$_expandHorizontal.default
    }));
$95be5125807f2a94$var$EditorMediaFullWidthIcon.displayName = 'EditorMediaFullWidthIcon';
var $95be5125807f2a94$var$_default = module.exports.default = $95be5125807f2a94$var$EditorMediaFullWidthIcon;

});


parcelRegister("4Mccv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $37a51beb9ea83417$var$_react = $37a51beb9ea83417$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $37a51beb9ea83417$var$_alignImageCenter = $37a51beb9ea83417$var$_interopRequireDefault((parcelRequire("1H3iv")));
function $37a51beb9ea83417$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $37a51beb9ea83417$var$EditorAlignImageCenterIcon = (props)=>/*#__PURE__*/ $37a51beb9ea83417$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6 17h12a1 1 0 0 1 0 2H6a1 1 0 0 1 0-2m4-8h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1M6 5h12a1 1 0 0 1 0 2H6a1 1 0 1 1 0-2"/></svg>`
    }, props, {
        newIcon: $37a51beb9ea83417$var$_alignImageCenter.default
    }));
$37a51beb9ea83417$var$EditorAlignImageCenterIcon.displayName = 'EditorAlignImageCenterIcon';
var $37a51beb9ea83417$var$_default = module.exports.default = $37a51beb9ea83417$var$EditorAlignImageCenterIcon;

});

parcelRegister("8gvqu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $604831f44db738bf$var$_react = $604831f44db738bf$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $604831f44db738bf$var$_alignImageLeft = $604831f44db738bf$var$_interopRequireDefault((parcelRequire("4Iuny")));
function $604831f44db738bf$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $604831f44db738bf$var$EditorAlignImageLeftIcon = (props)=>/*#__PURE__*/ $604831f44db738bf$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6 17h12a1 1 0 0 1 0 2H6a1 1 0 0 1 0-2m0-8h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1m0-4h12a1 1 0 0 1 0 2H6a1 1 0 1 1 0-2"/></svg>`
    }, props, {
        newIcon: $604831f44db738bf$var$_alignImageLeft.default
    }));
$604831f44db738bf$var$EditorAlignImageLeftIcon.displayName = 'EditorAlignImageLeftIcon';
var $604831f44db738bf$var$_default = module.exports.default = $604831f44db738bf$var$EditorAlignImageLeftIcon;

});

parcelRegister("1sHch", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1109e9fd8e567733$var$_react = $1109e9fd8e567733$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $1109e9fd8e567733$var$_alignImageRight = $1109e9fd8e567733$var$_interopRequireDefault((parcelRequire("8JqPQ")));
function $1109e9fd8e567733$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1109e9fd8e567733$var$EditorAlignImageRightIcon = (props)=>/*#__PURE__*/ $1109e9fd8e567733$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6 17h12a1 1 0 0 1 0 2H6a1 1 0 0 1 0-2m8-8h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1M6 5h12a1 1 0 0 1 0 2H6a1 1 0 1 1 0-2"/></svg>`
    }, props, {
        newIcon: $1109e9fd8e567733$var$_alignImageRight.default
    }));
$1109e9fd8e567733$var$EditorAlignImageRightIcon.displayName = 'EditorAlignImageRightIcon';
var $1109e9fd8e567733$var$_default = module.exports.default = $1109e9fd8e567733$var$EditorAlignImageRightIcon;

});

parcelRegister("8xVOG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $638e40f0826547ca$var$_react = $638e40f0826547ca$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $638e40f0826547ca$var$_contentWrapLeft = $638e40f0826547ca$var$_interopRequireDefault((parcelRequire("2WniS")));
function $638e40f0826547ca$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $638e40f0826547ca$var$EditorMediaWrapLeftIcon = (props)=>/*#__PURE__*/ $638e40f0826547ca$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6 17h12a1 1 0 0 1 0 2H6a1 1 0 0 1 0-2m8-8h4a1 1 0 0 1 0 2h-4a1 1 0 0 1 0-2m0 4h4a1 1 0 0 1 0 2h-4a1 1 0 0 1 0-2M6 9h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1m0-4h12a1 1 0 0 1 0 2H6a1 1 0 1 1 0-2"/></svg>`
    }, props, {
        newIcon: $638e40f0826547ca$var$_contentWrapLeft.default
    }));
$638e40f0826547ca$var$EditorMediaWrapLeftIcon.displayName = 'EditorMediaWrapLeftIcon';
var $638e40f0826547ca$var$_default = module.exports.default = $638e40f0826547ca$var$EditorMediaWrapLeftIcon;

});

parcelRegister("kWoux", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f3ec38f0e929e662$var$_react = $f3ec38f0e929e662$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $f3ec38f0e929e662$var$_contentWrapRight = $f3ec38f0e929e662$var$_interopRequireDefault((parcelRequire("fgmtQ")));
function $f3ec38f0e929e662$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f3ec38f0e929e662$var$EditorMediaWrapRightIcon = (props)=>/*#__PURE__*/ $f3ec38f0e929e662$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6 17h12a1 1 0 0 1 0 2H6a1 1 0 0 1 0-2m0-8h4a1 1 0 0 1 0 2H6a1 1 0 0 1 0-2m0 4h4a1 1 0 0 1 0 2H6a1 1 0 0 1 0-2m8-4h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1M6 5h12a1 1 0 0 1 0 2H6a1 1 0 1 1 0-2"/></svg>`
    }, props, {
        newIcon: $f3ec38f0e929e662$var$_contentWrapRight.default
    }));
$f3ec38f0e929e662$var$EditorMediaWrapRightIcon.displayName = 'EditorMediaWrapRightIcon';
var $f3ec38f0e929e662$var$_default = module.exports.default = $f3ec38f0e929e662$var$EditorMediaWrapRightIcon;

});

parcelRegister("eQTBG", function(module, exports) {

$parcel$export(module.exports, "insideTable", () => $45b36e31a8b529d8$export$244bf4b32387ef62);

var $BmspC = parcelRequire("BmspC");
const $45b36e31a8b529d8$export$244bf4b32387ef62 = (state)=>{
    const { table: table, tableCell: tableCell } = state.schema.nodes;
    return (0, $BmspC.hasParentNodeOfType)([
        table,
        tableCell
    ])(state.selection);
};

});

parcelRegister("1l7GR", function(module, exports) {

$parcel$export(module.exports, "Shortcut", () => $e148b39e5e964f4f$export$59451aa6b6270879);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");
parcelRequire("eJOHy");
const $e148b39e5e964f4f$var$shortcutStyle = null;
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- This rule thinks this isn't a `css()` call due to the name mapping
const $e148b39e5e964f4f$var$shortcutStyleUnbounded = null;
function $e148b39e5e964f4f$export$59451aa6b6270879({ children: children }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            "_2rko1sit _1wpzesu3 _ca0q1b66 _n3td1b66 _19bv1b66 _u5f31b66 _syaz1gjq _bfhkm7j4 _1ggkglyw",
            "_1wyb1qpa"
        ]),
        children: children
    });
}

});

parcelRegister("19zEl", function(module, exports) {

$parcel$export(module.exports, "shouldAddDefaultWrappedWidth", () => $b3204125fc08effb$export$7cd5aab2c4f1fb1e);
$parcel$export(module.exports, "nonWrappedLayouts", () => $b3204125fc08effb$export$607795ead6e50626);
$parcel$export(module.exports, "floatingLayouts", () => $b3204125fc08effb$export$7c0073a4d21b222d);
$parcel$export(module.exports, "isRichMediaInsideOfBlockNode", () => $b3204125fc08effb$export$55fb9d6810f2e04b);
$parcel$export(module.exports, "alignAttributes", () => $b3204125fc08effb$export$b2258912a400ba32);
$parcel$export(module.exports, "calculateSnapPoints", () => $b3204125fc08effb$export$de65085e667b4bf1);

var $BmspC = parcelRequire("BmspC");

var $7yBx7 = parcelRequire("7yBx7");

var $24wSW = parcelRequire("24wSW");
const $b3204125fc08effb$export$7cd5aab2c4f1fb1e = (layout, width, lineLength)=>{
    return (0, $24wSW.wrappedLayouts).indexOf(layout) > -1 && lineLength && width && width > 0.5 * lineLength;
};
const $b3204125fc08effb$export$607795ead6e50626 = [
    'center',
    'wide',
    'full-width'
];
const $b3204125fc08effb$export$7c0073a4d21b222d = [
    'wrap-left',
    'wrap-right'
];
const $b3204125fc08effb$export$55fb9d6810f2e04b = (view, pos)=>{
    if (typeof pos !== 'number' || isNaN(pos) || !view) return false;
    const $pos = view.state.doc.resolve(pos);
    const { expand: expand, nestedExpand: nestedExpand, layoutColumn: layoutColumn } = view.state.schema.nodes;
    return !!(0, $BmspC.findParentNodeOfTypeClosestToPos)($pos, [
        expand,
        nestedExpand,
        layoutColumn
    ]);
};
const $b3204125fc08effb$export$b2258912a400ba32 = (layout, oldAttrs, gridSize = 12, originalWidth, lineLength)=>{
    let width = oldAttrs.width;
    const oldLayout = oldAttrs.layout;
    const oldLayoutIsNonWrapped = $b3204125fc08effb$export$607795ead6e50626.indexOf(oldLayout) > -1;
    const newLayoutIsNonWrapped = $b3204125fc08effb$export$607795ead6e50626.indexOf(layout) > -1;
    const newLayoutIsWrapped = (0, $24wSW.wrappedLayouts).indexOf(layout) > -1;
    const oldLayoutIsWrapped = (0, $24wSW.wrappedLayouts).indexOf(oldLayout) > -1;
    if (oldLayoutIsNonWrapped && $b3204125fc08effb$export$7cd5aab2c4f1fb1e(layout, originalWidth, lineLength)) // 'full-width' or 'wide' or 'center' -> 'wrap-left' or 'wrap-right' or 'align-end' or 'align-start'
    {
        if (!width || width >= 100 || oldLayout !== 'center' // == 'full-width' or 'wide'
        ) width = 50;
    } else if (layout !== oldLayout && [
        'full-width',
        'wide'
    ].indexOf(oldLayout) > -1) // 'full-width' -> 'center' or 'wide'
    // 'wide' -> 'center' or 'full-width'
    // unset width
    width = undefined;
    else if (width) {
        const cols = Math.round(width / 100 * gridSize);
        let targetCols = cols;
        if (oldLayoutIsWrapped && newLayoutIsNonWrapped) {
            // wrap -> center needs to align to even grid
            targetCols = Math.floor(targetCols / 2) * 2;
            width = undefined;
        } else if (oldLayoutIsNonWrapped && newLayoutIsWrapped) {
            // Can be here only if
            // 'full-width' or 'wide' or 'center' -> 'wrap-left' or 'wrap-right' or 'align-end' or 'align-start'
            // AND
            // !originalWidth || !lineLength || small image
            // AND
            // width defined!
            // cannot resize to full column width, and cannot resize to 1 column
            if (cols <= 1) targetCols = 2;
            else if (cols >= gridSize) targetCols = 10;
        }
        if (targetCols !== cols) width = targetCols / gridSize * 100;
    }
    return {
        ...oldAttrs,
        layout: layout,
        width: width
    };
};
function $b3204125fc08effb$export$de65085e667b4bf1({ $pos: $pos, akEditorWideLayoutWidth: akEditorWideLayoutWidth, allowBreakoutSnapPoints: allowBreakoutSnapPoints, containerWidth: containerWidth, gridSize: gridSize, gridWidth: gridWidth, insideInlineLike: insideInlineLike, insideLayout: insideLayout, isVideoFile: isVideoFile, lineLength: lineLength, offsetLeft: offsetLeft, wrappedLayout: wrappedLayout }) {
    const snapTargets = [];
    for(let i = 0; i < gridWidth; i++){
        const pxFromColumns = (0, $24wSW.calcPxFromColumns)(i, lineLength, gridWidth);
        snapTargets.push(insideLayout ? pxFromColumns : pxFromColumns - offsetLeft);
    }
    // full width
    snapTargets.push(lineLength - offsetLeft);
    const columns = wrappedLayout || insideInlineLike ? 1 : 2;
    const minimumWidth = (0, $24wSW.calcPxFromColumns)(columns, lineLength, gridSize);
    let snapPoints = snapTargets.filter((width)=>width >= minimumWidth);
    if (!$pos) return snapPoints;
    snapPoints = isVideoFile ? snapPoints.filter((width)=>width > 320) : snapPoints;
    const isTopLevel = $pos.parent.type.name === 'doc';
    if (isTopLevel && allowBreakoutSnapPoints) {
        snapPoints.push(akEditorWideLayoutWidth);
        const fullWidthPoint = containerWidth - (0, $7yBx7.akEditorBreakoutPadding);
        if (fullWidthPoint > akEditorWideLayoutWidth) snapPoints.push(fullWidthPoint);
    }
    // EDM-1107: Ensure new snapPoints are sorted with existing points
    snapPoints = snapPoints.sort((a, b)=>a - b);
    return snapPoints;
}

});
parcelRegister("24wSW", function(module, exports) {

$parcel$export(module.exports, "calcPxFromColumns", () => $41c0bcab9a8da41b$export$1e3701608f0cee80);
$parcel$export(module.exports, "calcColumnsFromPx", () => $41c0bcab9a8da41b$export$10912f14d8d54640);
$parcel$export(module.exports, "calcPctFromPx", () => $41c0bcab9a8da41b$export$55ddb36b3404ec6d);
$parcel$export(module.exports, "wrappedLayouts", () => $41c0bcab9a8da41b$export$405baca3d8bc263d);
$parcel$export(module.exports, "calcMediaPxWidth", () => $41c0bcab9a8da41b$export$5e51fc02b9ada5af);

var $7yBx7 = parcelRequire("7yBx7");

var $1I3aa = parcelRequire("1I3aa");
const $41c0bcab9a8da41b$var$validWidthModes = [
    'center',
    'wrap-left',
    'wrap-right',
    'align-start',
    'align-end'
];
const $41c0bcab9a8da41b$export$adfc02948d64a4f2 = (layout)=>$41c0bcab9a8da41b$var$validWidthModes.indexOf(layout) > -1;
function $41c0bcab9a8da41b$export$1e3701608f0cee80(columns, lineLength, gridSize) {
    const maxWidth = lineLength + (0, $1I3aa.MEDIA_SINGLE_GUTTER_SIZE);
    return maxWidth / gridSize * columns - (0, $1I3aa.MEDIA_SINGLE_GUTTER_SIZE);
}
function $41c0bcab9a8da41b$export$10912f14d8d54640(width, lineLength, gridSize) {
    const maxWidth = lineLength + (0, $1I3aa.MEDIA_SINGLE_GUTTER_SIZE);
    return (width + (0, $1I3aa.MEDIA_SINGLE_GUTTER_SIZE)) * gridSize / maxWidth;
}
function $41c0bcab9a8da41b$export$e70e278a1f662f8d(pct, lineLength) {
    const maxWidth = lineLength + (0, $1I3aa.MEDIA_SINGLE_GUTTER_SIZE);
    return maxWidth * pct - (0, $1I3aa.MEDIA_SINGLE_GUTTER_SIZE);
}
function $41c0bcab9a8da41b$export$55ddb36b3404ec6d(width, lineLength) {
    const maxWidth = lineLength + (0, $1I3aa.MEDIA_SINGLE_GUTTER_SIZE);
    return (width + (0, $1I3aa.MEDIA_SINGLE_GUTTER_SIZE)) / maxWidth;
}
const $41c0bcab9a8da41b$export$405baca3d8bc263d = [
    'wrap-left',
    'wrap-right',
    'align-end',
    'align-start'
];
const $41c0bcab9a8da41b$export$144a1e648ed4962e = (containerWidth, pctWidth, origWidth, origHeight)=>pctWidth && origWidth && origHeight && Math.ceil($41c0bcab9a8da41b$export$e70e278a1f662f8d(pctWidth / 100, containerWidth.lineLength || containerWidth.width));
const $41c0bcab9a8da41b$export$5e51fc02b9ada5af = (opts)=>{
    const { origWidth: origWidth, origHeight: origHeight, layout: layout, pctWidth: pctWidth, containerWidth: containerWidth, resizedPctWidth: resizedPctWidth } = opts;
    const { width: width, lineLength: lineLength } = containerWidth;
    const calculatedPctWidth = $41c0bcab9a8da41b$export$144a1e648ed4962e(containerWidth, pctWidth, origWidth, origHeight);
    const calculatedResizedPctWidth = $41c0bcab9a8da41b$export$144a1e648ed4962e(containerWidth, resizedPctWidth, origWidth, origHeight);
    if (layout === 'wide') {
        if (lineLength) {
            const wideWidth = Math.ceil(lineLength * (0, $7yBx7.breakoutWideScaleRatio));
            return wideWidth > width ? lineLength : wideWidth;
        }
    } else if (layout === 'full-width') return width - (0, $7yBx7.akEditorBreakoutPadding);
    else if (calculatedPctWidth) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if ($41c0bcab9a8da41b$export$405baca3d8bc263d.indexOf(layout) > -1) {
            if (calculatedResizedPctWidth) {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                if (resizedPctWidth < 50) return calculatedResizedPctWidth;
                return calculatedPctWidth;
            }
            return Math.min(calculatedPctWidth, origWidth);
        }
        if (calculatedResizedPctWidth) return calculatedResizedPctWidth;
        return calculatedPctWidth;
    } else if (layout === 'center') {
        if (calculatedResizedPctWidth) return calculatedResizedPctWidth;
        return Math.min(origWidth, lineLength || width);
    } else if (layout && $41c0bcab9a8da41b$export$405baca3d8bc263d.indexOf(layout) !== -1) {
        const halfLineLength = Math.ceil((lineLength || width) / 2);
        return origWidth <= halfLineLength ? origWidth : halfLineLength;
    }
    return origWidth;
};
const $41c0bcab9a8da41b$export$195604d042fd3f87 = (gridWidth, width, height, lineLength, gridSize)=>{
    const pxWidth = $41c0bcab9a8da41b$export$e70e278a1f662f8d(gridWidth / 100, lineLength);
    const columnSpan = Math.round($41c0bcab9a8da41b$export$10912f14d8d54640(pxWidth, lineLength, gridSize));
    const alignedWidth = $41c0bcab9a8da41b$export$1e3701608f0cee80(columnSpan, lineLength, gridSize);
    return {
        height: height / width * alignedWidth,
        width: alignedWidth
    };
};

});
parcelRegister("1I3aa", function(module, exports) {

$parcel$export(module.exports, "MEDIA_SINGLE_DEFAULT_MIN_PIXEL_WIDTH", () => $63e3275bb42d0987$export$5937600f4cc784f0);
$parcel$export(module.exports, "MEDIA_SINGLE_VIDEO_MIN_PIXEL_WIDTH", () => $63e3275bb42d0987$export$71d660e8ca5b8f73);
$parcel$export(module.exports, "MEDIA_SINGLE_SNAP_GAP", () => $63e3275bb42d0987$export$cd11d7d46412c89b);
$parcel$export(module.exports, "MEDIA_SINGLE_ADJACENT_HANDLE_MARGIN", () => $63e3275bb42d0987$export$8c5ac0b0c62a3d21);
$parcel$export(module.exports, "MEDIA_SINGLE_GUTTER_SIZE", () => $63e3275bb42d0987$export$68d0abe4f03863fb);
$parcel$export(module.exports, "DEFAULT_IMAGE_WIDTH", () => $63e3275bb42d0987$export$d722b7527b1834a8);
$parcel$export(module.exports, "DEFAULT_IMAGE_HEIGHT", () => $63e3275bb42d0987$export$da894f7669b4e67c);
$parcel$export(module.exports, "MEDIA_SINGLE_RESIZE_THROTTLE_TIME", () => $63e3275bb42d0987$export$e13825c38da2ce1);
$parcel$export(module.exports, "wrappedLayouts", () => $63e3275bb42d0987$export$405baca3d8bc263d);
$parcel$export(module.exports, "DEFAULT_ROUNDING_INTERVAL", () => $63e3275bb42d0987$export$4d41d008e9cd4f34);
$parcel$export(module.exports, "CAPTION_PLACEHOLDER_ID", () => $63e3275bb42d0987$export$b4b560efd3c61856);
const $63e3275bb42d0987$export$5937600f4cc784f0 = 24;
const $63e3275bb42d0987$export$71d660e8ca5b8f73 = 320;
const $63e3275bb42d0987$export$cd11d7d46412c89b = 3;
const $63e3275bb42d0987$export$71482734bb54ac3 = 10;
const $63e3275bb42d0987$export$fd2b09475ada41cc = 12;
const $63e3275bb42d0987$export$8c5ac0b0c62a3d21 = 8;
const $63e3275bb42d0987$export$68d0abe4f03863fb = $63e3275bb42d0987$export$fd2b09475ada41cc * 2;
const $63e3275bb42d0987$export$d722b7527b1834a8 = 250;
const $63e3275bb42d0987$export$da894f7669b4e67c = 200;
const $63e3275bb42d0987$export$e13825c38da2ce1 = 100;
var $63e3275bb42d0987$export$c84671f46d6a1ca = /*#__PURE__*/ function(Layout) {
    Layout["FULL_WIDTH"] = "full-width";
    Layout["WIDE"] = "wide";
    Layout["CENTER"] = "center";
    Layout["ALIGN_START"] = "align-start";
    Layout["ALIGN_END"] = "align-end";
    Layout["WRAP_RIGHT"] = "wrap-right";
    Layout["WRAP_LEFT"] = "wrap-left";
    return Layout;
}({});
const $63e3275bb42d0987$export$405baca3d8bc263d = [
    'wrap-left',
    'wrap-right',
    'align-end',
    'align-start'
];
const $63e3275bb42d0987$export$4d41d008e9cd4f34 = 0.5;
const $63e3275bb42d0987$export$b4b560efd3c61856 = 'caption-placeholder';

});




parcelRegister("gDKBr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::451c857042316b193f6451d1ac5153c9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c1d470387d991694$var$_react = $c1d470387d991694$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $c1d470387d991694$var$_baseNew = $c1d470387d991694$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $c1d470387d991694$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Comment".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for comments on objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c1d470387d991694$var$CommentIcon = (props)=>/*#__PURE__*/ $c1d470387d991694$var$_react.default.createElement($c1d470387d991694$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 3.125A2.625 2.625 0 0 1 2.625.5h10.75A2.625 2.625 0 0 1 16 3.125v8.25A2.625 2.625 0 0 1 13.375 14H4.449l-3.327 1.901A.75.75 0 0 1 0 15.25zM2.625 2C2.004 2 1.5 2.504 1.5 3.125v10.833L4.05 12.5h9.325c.621 0 1.125-.504 1.125-1.125v-8.25C14.5 2.504 13.996 2 13.375 2zM12 6.5H4V5h8zm-3 3H4V8h5z" clip-rule="evenodd"/>`
    }, props));
$c1d470387d991694$var$CommentIcon.displayName = 'CommentIcon';
var $c1d470387d991694$var$_default = module.exports.default = $c1d470387d991694$var$CommentIcon;

});

parcelRegister("4MicW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::32784ef133e6e682f32ae3035edbf69e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $37a9c4cf545b6d17$var$_react = $37a9c4cf545b6d17$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $37a9c4cf545b6d17$var$_baseNew = $37a9c4cf545b6d17$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $37a9c4cf545b6d17$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Delete".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for removing or deleting an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $37a9c4cf545b6d17$var$DeleteIcon = (props)=>/*#__PURE__*/ $37a9c4cf545b6d17$var$_react.default.createElement($37a9c4cf545b6d17$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5 .75A.75.75 0 0 1 5.75 0h4.5a.75.75 0 0 1 .75.75V2.5h3.5V4h-1v10a2 2 0 0 1-2 2h-7a2 2 0 0 1-2-2V4h-1V2.5H5zM6.5 2.5h3v-1h-3zM4 4v10a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V4zm1.75 9V5.5h1.5V13zm3 0V5.5h1.5V13z" clip-rule="evenodd"/>`
    }, props));
$37a9c4cf545b6d17$var$DeleteIcon.displayName = 'DeleteIcon';
var $37a9c4cf545b6d17$var$_default = module.exports.default = $37a9c4cf545b6d17$var$DeleteIcon;

});

parcelRegister("25YjY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d32cfb464fc797f765cf705a7186f08e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $186ad6f022280ede$var$_react = $186ad6f022280ede$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $186ad6f022280ede$var$_baseNew = $186ad6f022280ede$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $186ad6f022280ede$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LinkBroken".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for removing a link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $186ad6f022280ede$var$LinkBrokenIcon = (props)=>/*#__PURE__*/ $186ad6f022280ede$var$_react.default.createElement($186ad6f022280ede$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 1v3H4.5V1zm2.22 1.22a3.932 3.932 0 1 1 5.56 5.56l-.75.75-1.06-1.06.75-.75a2.432 2.432 0 0 0-3.44-3.44l-.75.75-1.06-1.06zM1 4.5h3V6H1zm1.22 3.72.75-.75 1.06 1.06-.75.75a2.432 2.432 0 0 0 3.44 3.44l.75-.75 1.06 1.06-.75.75a3.932 3.932 0 1 1-5.56-5.56M15 11.5h-3V10h3zM10 15v-3h1.5v3z" clip-rule="evenodd"/>`
    }, props));
$186ad6f022280ede$var$LinkBrokenIcon.displayName = 'LinkBrokenIcon';
var $186ad6f022280ede$var$_default = module.exports.default = $186ad6f022280ede$var$LinkBrokenIcon;

});

parcelRegister("amxqt", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dfb8e24ad0aeafedb3c07855964a196e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $78b5e325967a99e4$var$_react = $78b5e325967a99e4$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $78b5e325967a99e4$var$_comment = $78b5e325967a99e4$var$_interopRequireDefault((parcelRequire("gDKBr")));

var $78b5e325967a99e4$var$_comment2 = $78b5e325967a99e4$var$_interopRequireDefault((parcelRequire("04OD1")));
function $78b5e325967a99e4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CommentIcon.
 * This component is CommentIcon, with `UNSAFE_fallbackIcon` set to "CommentIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for comments on objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $78b5e325967a99e4$var$CommentIcon = (props)=>/*#__PURE__*/ $78b5e325967a99e4$var$_react.default.createElement($78b5e325967a99e4$var$_comment.default, Object.assign({
        LEGACY_fallbackIcon: $78b5e325967a99e4$var$_comment2.default
    }, props));
$78b5e325967a99e4$var$CommentIcon.Name = 'CommentIconMigration';
var $78b5e325967a99e4$var$_default = module.exports.default = $78b5e325967a99e4$var$CommentIcon;

});
parcelRegister("04OD1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $00e7a599837ddc3e$var$_react = $00e7a599837ddc3e$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $00e7a599837ddc3e$var$_comment = $00e7a599837ddc3e$var$_interopRequireDefault((parcelRequire("gDKBr")));
function $00e7a599837ddc3e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $00e7a599837ddc3e$var$CommentIcon = (props)=>/*#__PURE__*/ $00e7a599837ddc3e$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M4.998 11.513c0-3.038 3.141-5.51 7.002-5.51s7.002 2.472 7.002 5.51c0 3.039-3.141 5.51-7.002 5.51s-7.002-2.471-7.002-5.51m14.84 7.771v-.001s-1.564-2.26-.767-3.116l-.037.02C20.261 14.902 21 13.279 21 11.513 21 7.371 16.963 4 12 4s-9 3.37-9 7.513 4.037 7.514 9 7.514c1.42 0 2.76-.285 3.957-.776 1.003 1.022 2.287 1.572 3.24 1.719l.002-.003a.5.5 0 0 0 .164.033.515.515 0 0 0 .474-.716"/><rect width="10" height="2" x="7" y="9" rx="1"/><rect width="5" height="2" x="7" y="12" rx="1"/></g></svg>`
    }, props, {
        newIcon: $00e7a599837ddc3e$var$_comment.default
    }));
$00e7a599837ddc3e$var$CommentIcon.displayName = 'CommentIcon';
var $00e7a599837ddc3e$var$_default = module.exports.default = $00e7a599837ddc3e$var$CommentIcon;

});


parcelRegister("2IYY2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2bce2e8cefeb7a1e23af480e5534534d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1fbefbb1d7554da3$var$_react = $1fbefbb1d7554da3$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $1fbefbb1d7554da3$var$_delete = $1fbefbb1d7554da3$var$_interopRequireDefault((parcelRequire("4MicW")));

var $1fbefbb1d7554da3$var$_remove = $1fbefbb1d7554da3$var$_interopRequireDefault((parcelRequire("f7oSr")));
function $1fbefbb1d7554da3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for DeleteIcon.
 * This component is DeleteIcon, with `UNSAFE_fallbackIcon` set to "EditorRemoveIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for removing or deleting an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1fbefbb1d7554da3$var$DeleteIcon = (props)=>/*#__PURE__*/ $1fbefbb1d7554da3$var$_react.default.createElement($1fbefbb1d7554da3$var$_delete.default, Object.assign({
        LEGACY_fallbackIcon: $1fbefbb1d7554da3$var$_remove.default
    }, props));
$1fbefbb1d7554da3$var$DeleteIcon.Name = 'DeleteIconMigration';
var $1fbefbb1d7554da3$var$_default = module.exports.default = $1fbefbb1d7554da3$var$DeleteIcon;

});
parcelRegister("f7oSr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b01ace88b278d48a$var$_react = $b01ace88b278d48a$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $b01ace88b278d48a$var$_delete = $b01ace88b278d48a$var$_interopRequireDefault((parcelRequire("4MicW")));
function $b01ace88b278d48a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $b01ace88b278d48a$var$EditorRemoveIcon = (props)=>/*#__PURE__*/ $b01ace88b278d48a$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M7 7h10a1 1 0 0 1 0 2H7a1 1 0 1 1 0-2m2.78 11a1 1 0 0 1-.97-.757L7.156 10.62A.5.5 0 0 1 7.64 10h8.72a.5.5 0 0 1 .485.621l-1.656 6.622a1 1 0 0 1-.97.757zM11 6h2a1 1 0 0 1 1 1h-4a1 1 0 0 1 1-1"/></svg>`
    }, props, {
        newIcon: $b01ace88b278d48a$var$_delete.default
    }));
$b01ace88b278d48a$var$EditorRemoveIcon.displayName = 'EditorRemoveIcon';
var $b01ace88b278d48a$var$_default = module.exports.default = $b01ace88b278d48a$var$EditorRemoveIcon;

});


parcelRegister("dQl2w", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::baa7911763e47fa2648a3f279f8d5416>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a14073b85762ade2$var$_react = $a14073b85762ade2$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $a14073b85762ade2$var$_linkBroken = $a14073b85762ade2$var$_interopRequireDefault((parcelRequire("25YjY")));

var $a14073b85762ade2$var$_unlink = $a14073b85762ade2$var$_interopRequireDefault((parcelRequire("bnsEu")));
function $a14073b85762ade2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LinkBrokenIcon.
 * This component is LinkBrokenIcon, with `UNSAFE_fallbackIcon` set to "EditorUnlinkIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for removing a link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a14073b85762ade2$var$LinkBrokenIcon = (props)=>/*#__PURE__*/ $a14073b85762ade2$var$_react.default.createElement($a14073b85762ade2$var$_linkBroken.default, Object.assign({
        LEGACY_fallbackIcon: $a14073b85762ade2$var$_unlink.default
    }, props));
$a14073b85762ade2$var$LinkBrokenIcon.Name = 'LinkBrokenIconMigration';
var $a14073b85762ade2$var$_default = module.exports.default = $a14073b85762ade2$var$LinkBrokenIcon;

});
parcelRegister("bnsEu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $848811633a172475$var$_react = $848811633a172475$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $848811633a172475$var$_linkBroken = $848811633a172475$var$_interopRequireDefault((parcelRequire("25YjY")));
function $848811633a172475$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $848811633a172475$var$EditorUnlinkIcon = (props)=>/*#__PURE__*/ $848811633a172475$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M5 10V9h2v1zm4-5h1v2H9zm7.646 12.354.708-.708 2 2-.708.708zM17 15v-1h2v1zm-3 2h1v2h-1zM7.354 6.646l-.708.708-2-2 .708-.708zm3.567 9.037 1.061-1.062a.75.75 0 1 1 1.06 1.061l-1.06 1.061a3.25 3.25 0 0 1-4.596 0 3.247 3.247 0 0 1 0-4.596l1.06-1.061.703-.703c.793-.63 1.773.35 1.06 1.06l-.702.703-1.06 1.062a1.747 1.747 0 0 0 0 2.474 1.75 1.75 0 0 0 2.474 0m2.658-7.608-1.061 1.061a.75.75 0 0 1-1.06-1.06l1.06-1.062a3.25 3.25 0 0 1 4.596 0 3.247 3.247 0 0 1 0 4.596l-1.06 1.062-.703.702c-.565.565-1.581-.45-1.06-1.06l.702-.703 1.06-1.061a1.747 1.747 0 0 0 0-2.475 1.75 1.75 0 0 0-2.474 0"/></svg>`
    }, props, {
        newIcon: $848811633a172475$var$_linkBroken.default
    }));
$848811633a172475$var$EditorUnlinkIcon.displayName = 'EditorUnlinkIcon';
var $848811633a172475$var$_default = module.exports.default = $848811633a172475$var$EditorUnlinkIcon;

});


parcelRegister("7iUqh", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2a96776728836c727b5d4d4945e79e50>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5515fb41073021ea$var$_react = $5515fb41073021ea$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $5515fb41073021ea$var$_settings = $5515fb41073021ea$var$_interopRequireDefault((parcelRequire("4F5bb")));

var $5515fb41073021ea$var$_settings2 = $5515fb41073021ea$var$_interopRequireDefault((parcelRequire("55Bec")));
function $5515fb41073021ea$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for SettingsIcon.
 * This component is SettingsIcon, with `UNSAFE_fallbackIcon` set to "EditorSettingsIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for any object or user settings.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5515fb41073021ea$var$SettingsIcon = (props)=>/*#__PURE__*/ $5515fb41073021ea$var$_react.default.createElement($5515fb41073021ea$var$_settings.default, Object.assign({
        LEGACY_fallbackIcon: $5515fb41073021ea$var$_settings2.default
    }, props));
$5515fb41073021ea$var$SettingsIcon.Name = 'SettingsIconMigration';
var $5515fb41073021ea$var$_default = module.exports.default = $5515fb41073021ea$var$SettingsIcon;

});
parcelRegister("55Bec", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3b4a4c1d711b248e$var$_react = $3b4a4c1d711b248e$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $3b4a4c1d711b248e$var$_settings = $3b4a4c1d711b248e$var$_interopRequireDefault((parcelRequire("4F5bb")));
function $3b4a4c1d711b248e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3b4a4c1d711b248e$var$EditorSettingsIcon = (props)=>/*#__PURE__*/ $3b4a4c1d711b248e$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12.002 15.504a3.502 3.502 0 1 1 0-7.004 3.502 3.502 0 0 1 0 7.004m6.732-1.987a1.605 1.605 0 0 1-.001-3.034.386.386 0 0 0 .253-.462 7.2 7.2 0 0 0-.672-1.604.384.384 0 0 0-.481-.156c-.31.127-.668.16-1.039.065a1.6 1.6 0 0 1-1.129-1.124 1.64 1.64 0 0 1 .061-1.043.385.385 0 0 0-.157-.48 7.2 7.2 0 0 0-1.59-.665.385.385 0 0 0-.461.252 1.604 1.604 0 0 1-3.032 0 .387.387 0 0 0-.463-.252c-.57.16-1.11.39-1.613.677a.38.38 0 0 0-.159.468 1.611 1.611 0 0 1-2.088 2.108.385.385 0 0 0-.479.158 7.2 7.2 0 0 0-.67 1.604.386.386 0 0 0 .248.46 1.605 1.605 0 0 1 0 3.021.385.385 0 0 0-.249.46c.143.504.34.986.582 1.44.096.179.318.24.502.156.479-.22 1.08-.213 1.693.191a.9.9 0 0 1 .243.242c.424.643.412 1.272.16 1.76a.38.38 0 0 0 .134.506 7.2 7.2 0 0 0 1.697.721.38.38 0 0 0 .459-.251A1.605 1.605 0 0 1 12 17.645c.707 0 1.302.457 1.518 1.09.066.19.265.306.459.251a7.2 7.2 0 0 0 1.677-.71.38.38 0 0 0 .134-.508c-.256-.49-.271-1.12.154-1.766a.9.9 0 0 1 .243-.243c.62-.411 1.228-.413 1.71-.185a.384.384 0 0 0 .505-.153q.367-.683.585-1.443a.385.385 0 0 0-.252-.461"/></svg>`
    }, props, {
        newIcon: $3b4a4c1d711b248e$var$_settings.default
    }));
$3b4a4c1d711b248e$var$EditorSettingsIcon.displayName = 'EditorSettingsIcon';
var $3b4a4c1d711b248e$var$_default = module.exports.default = $3b4a4c1d711b248e$var$EditorSettingsIcon;

});


parcelRegister("avkZu", function(module, exports) {

$parcel$export(module.exports, "DatasourceAppearanceButton", () => $fa79fd9f3589b3eb$export$76de8066d79563a4);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $6dRXt = parcelRequire("6dRXt");

var $knwdo = parcelRequire("knwdo");

var $7WlTe = parcelRequire("7WlTe");

var $3lIcL = parcelRequire("3lIcL");

var $4hDhk = parcelRequire("4hDhk");

var $9kfy2 = parcelRequire("9kfy2");

var $2sLVw = parcelRequire("2sLVw");

var $4AOcQ = parcelRequire("4AOcQ");

var $cuJUr = parcelRequire("cuJUr");

var $g0O72 = parcelRequire("g0O72");

var $XsiSM = parcelRequire("XsiSM");
function $fa79fd9f3589b3eb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $fa79fd9f3589b3eb$var$buttonStyles = {
    name: "1quw0ni",
    styles: "pointer-events:auto"
};
const $fa79fd9f3589b3eb$var$DatasourceAppearanceButtonWithCardContext = ({ cardContext: cardContext, intl: intl, url: url, editorView: editorView, editorState: editorState, selected: selected, inputMethod: inputMethod })=>{
    const { datasourceId: datasourceId, parameters: parameters } = (0, $XsiSM.useFetchDatasourceInfo)({
        isRegularCardNode: true,
        url: url,
        cardContext: cardContext
    });
    const onChangeAppearance = (0, $eJOHy.useCallback)(()=>{
        if (!editorView || !datasourceId || !parameters) return;
        const state = (0, $cuJUr.pluginKey).getState(editorState);
        const newAdf = (0, $4hDhk.buildDatasourceAdf)({
            id: datasourceId,
            parameters: parameters,
            views: state?.datasourceStash[url]?.views ?? [
                {
                    type: 'table'
                }
            ]
        }, url);
        const { selection: selection } = editorState;
        let existingNode;
        // Check if the selection contains a link mark
        const $pos = editorState.doc.resolve(selection.from);
        const isLinkMark = $pos.marks().some((mark)=>mark.type === editorState.schema.marks.link);
        // When selection is a TextNode and a link Mark is present return that node
        if (selection instanceof (0, $3lIcL.NodeSelection)) existingNode = selection.node;
        else if (isLinkMark) existingNode = editorState.doc.nodeAt(selection.from) ?? undefined;
        if (existingNode) (0, $4AOcQ.updateCardViaDatasource)({
            state: editorState,
            node: existingNode,
            newAdf: newAdf,
            view: editorView,
            sourceEvent: undefined,
            isDeletingConfig: true,
            inputMethod: inputMethod
        });
    }, [
        parameters,
        datasourceId,
        inputMethod,
        editorState,
        editorView,
        url
    ]);
    if (!parameters || !datasourceId || !(0, $7WlTe.canRenderDatasource)(datasourceId)) return null;
    if (url) {
        const urlState = cardContext?.store?.getState()[url];
        if (urlState?.error?.kind === 'fatal') return null;
    }
    const buttonLabel = intl.formatMessage((0, $6dRXt.messages).datasourceAppearanceTitle);
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $2sLVw.default), null, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $knwdo.default), {
        css: $fa79fd9f3589b3eb$var$buttonStyles,
        title: buttonLabel,
        icon: /*#__PURE__*/ (0, $1NIU8.jsx)((0, $g0O72.DatasourceIcon), {
            label: buttonLabel
        }),
        selected: selected,
        onClick: onChangeAppearance,
        testId: 'card-datasource-appearance-button'
    }));
};
const $fa79fd9f3589b3eb$export$76de8066d79563a4 = ({ intl: intl, editorAnalyticsApi: editorAnalyticsApi, url: url, editorView: editorView, editorState: editorState, selected: selected, inputMethod: inputMethod })=>{
    const cardContext = (0, $9kfy2.useSmartLinkContext)();
    return /*#__PURE__*/ (0, $1NIU8.jsx)($fa79fd9f3589b3eb$var$DatasourceAppearanceButtonWithCardContext, {
        url: url,
        intl: intl,
        editorAnalyticsApi: editorAnalyticsApi,
        editorView: editorView,
        editorState: editorState,
        cardContext: cardContext,
        selected: selected,
        inputMethod: inputMethod
    });
};

});
parcelRegister("knwdo", function(module, exports) {

$parcel$export(module.exports, "default", () => $a66705cdfb3b2eca$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $abjs4 = parcelRequire("abjs4");

var $92xoS = parcelRequire("92xoS");

var $k71qx = parcelRequire("k71qx");

var $7drWe = parcelRequire("7drWe");

var $cOk3B = parcelRequire("cOk3B");

var $lNCvi = parcelRequire("lNCvi");
const $a66705cdfb3b2eca$var$customSizeAndPadding = {
    minWidth: "var(--ds-space-400, 32px)",
    padding: `0px ${"var(--ds-space-050, 4px)"}`
};
var $a66705cdfb3b2eca$export$2e2bcd8739ae039 = ({ title: title, icon: icon, iconAfter: iconAfter, onClick: onClick, onKeyDown: onKeyDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onFocus: onFocus, onBlur: onBlur, onMount: onMount, onUnmount: onUnmount, selected: selected, disabled: disabled, href: href, target: target, appearance: appearance = 'subtle', children: children, className: className, tooltipContent: tooltipContent, tooltipStyle: tooltipStyle, testId: testId, interactionName: interactionName, hideTooltipOnClick: hideTooltipOnClick = true, ariaHasPopup: ariaHasPopup, tabIndex: tabIndex, areaControls: areaControls, ariaLabel: ariaLabel, isRadioButton: isRadioButton, pulse: pulse, spotlightConfig: spotlightConfig })=>{
    // Check if there's only an icon and add additional styles
    const iconOnly = (icon || iconAfter) && !children;
    const customSpacing = iconOnly ? (0, $lNCvi.iconOnlySpacing) : {};
    const isButtonPressed = ariaHasPopup ? undefined : selected;
    const ariaChecked = isRadioButton ? isButtonPressed : undefined;
    const ariaPressed = isRadioButton ? undefined : isButtonPressed;
    const [spotlightReferenceElement, setSpotlightReferenceElement] = (0, $eJOHy.useState)(null);
    (0, $eJOHy.useEffect)(()=>{
        onMount?.();
        return ()=>onUnmount?.();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const onSpotlightTargetClick = spotlightConfig?.isSpotlightOpen ? spotlightConfig?.onTargetClick : undefined;
    const handleOnClick = (0, $eJOHy.useCallback)((event)=>{
        // fire the spotlight onTargetClick callback if a spotlight is rendered and callback is provided
        onSpotlightTargetClick?.();
        onClick?.(event);
    }, [
        onClick,
        onSpotlightTargetClick
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
                // Only fallback to title for tooltip if title is not shown
                content: tooltipContent || (iconOnly ? title : undefined),
                component: tooltipStyle,
                hideTooltipOnClick: hideTooltipOnClick,
                position: "top",
                children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    onMouseEnter: onMouseEnter,
                    onMouseLeave: onMouseLeave,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7drWe.Pulse), {
                        pulse: pulse || spotlightConfig?.pulse,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $abjs4.default), {
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides -- Ignored via go/DSP-18766
                            className: className,
                            ref: (buttonElement)=>setSpotlightReferenceElement(buttonElement),
                            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
                            theme: (adgTheme, themeProps)=>{
                                const { buttonStyles: buttonStyles, ...rest } = adgTheme(themeProps);
                                return {
                                    buttonStyles: {
                                        ...buttonStyles,
                                        ...customSpacing,
                                        ...appearance === 'danger' && (0, $lNCvi.getButtonStyles)({
                                            appearance: appearance,
                                            state: themeProps.state,
                                            mode: themeProps.mode
                                        }),
                                        ...(0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1') ? $a66705cdfb3b2eca$var$customSizeAndPadding : {}
                                    },
                                    ...rest
                                };
                            },
                            "aria-label": ariaLabel || title,
                            "aria-pressed": ariaPressed,
                            "aria-checked": ariaChecked,
                            role: isRadioButton ? 'radio' : undefined,
                            "aria-expanded": ariaHasPopup ? selected : undefined,
                            "aria-controls": ariaHasPopup ? areaControls : undefined,
                            spacing: (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1') ? 'default' : 'compact',
                            href: href,
                            target: target,
                            appearance: appearance,
                            "aria-haspopup": ariaHasPopup,
                            iconBefore: icon || undefined,
                            iconAfter: iconAfter,
                            onClick: handleOnClick,
                            onKeyDown: onKeyDown,
                            isSelected: selected,
                            isDisabled: disabled,
                            testId: testId,
                            interactionName: interactionName,
                            onFocus: onFocus,
                            onBlur: onBlur,
                            // @ts-ignore
                            // tabIndex set as 0 by default in the design system  ButtonBase component
                            // this is not expected for all buttons, we have to use tabIndex={null} for some cases
                            // should be fixed here https://a11y-internal.atlassian.net/browse/DST-287
                            tabIndex: tabIndex,
                            children: children
                        })
                    })
                })
            }),
            spotlightConfig?.isSpotlightOpen && spotlightReferenceElement && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cOk3B.ButtonSpotlightCard), {
                referenceElement: spotlightReferenceElement,
                ...spotlightConfig.spotlightCardOptions
            })
        ]
    });
};

});
parcelRegister("7drWe", function(module, exports) {

$parcel$export(module.exports, "Pulse", () => $35ce09c36823f610$export$927d63e2511364c0);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fBe2p = parcelRequire("fBe2p");
function $35ce09c36823f610$export$927d63e2511364c0({ pulse: pulse, radius: radius = 3, children: children }) {
    if (pulse) return(// SpotlightPulse shows pulse effect if `pulse` is `undefined`.
    // That's why we need to cast `pulse` to `false` if it's `undefined`.
    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fBe2p.Pulse), {
        radius: radius,
        pulse: pulse ?? false,
        children: children
    }));
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: children
    });
}

});

parcelRegister("cOk3B", function(module, exports) {

$parcel$export(module.exports, "ButtonSpotlightCard", () => $10a34352fe55e5a0$export$beb7ede7fcdf145c);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $3l2IB = parcelRequire("3l2IB");

var $8qmYl = parcelRequire("8qmYl");
const $10a34352fe55e5a0$export$beb7ede7fcdf145c = (props)=>{
    const { referenceElement: referenceElement, placement: placement = 'top-start', ...spotlightCardProps } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8qmYl.Popper), {
        referenceElement: referenceElement,
        placement: placement,
        strategy: "absolute",
        children: ({ ref: ref, style: style })=>// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                ref: ref,
                style: style,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3l2IB.default), {
                    ...spotlightCardProps
                })
            })
    });
};

});

parcelRegister("lNCvi", function(module, exports) {

$parcel$export(module.exports, "iconOnlySpacing", () => $57820a58c354b0f0$export$7d8cec9727d4e603);
$parcel$export(module.exports, "getButtonStyles", () => $57820a58c354b0f0$export$f98ea88a275be66c);

var $eGOwo = parcelRequire("eGOwo");
const $57820a58c354b0f0$export$7d8cec9727d4e603 = {
    '&&': {
        padding: '0px'
    },
    '& > span': {
        margin: '0px'
    }
};
const $57820a58c354b0f0$var$getStyles = (property, { appearance: appearance = 'default', state: state = 'default', mode: mode = 'light' })=>{
    if (!property[appearance] || !property[appearance][state]) return 'initial';
    return property[appearance][state][mode];
};
const $57820a58c354b0f0$var$background = {
    danger: {
        default: {
            light: 'inherit',
            dark: 'inherit'
        },
        hover: {
            light: "var(--ds-background-neutral-subtle-hovered, #091E420F)",
            dark: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
        },
        active: {
            light: "var(--ds-background-neutral-pressed, #091E424F)",
            dark: "var(--ds-background-neutral-pressed, #091E424F)"
        }
    }
};
const $57820a58c354b0f0$var$backgroundVisualRefresh = {
    danger: {
        default: {
            light: 'inherit',
            dark: 'inherit'
        },
        hover: {
            light: "var(--ds-background-danger-hovered, #FFD5D2)",
            dark: "var(--ds-background-danger-hovered, #FFD5D2)"
        },
        active: {
            light: "var(--ds-background-danger-pressed, #FD9891)",
            dark: "var(--ds-background-danger-pressed, #FD9891)"
        }
    }
};
const $57820a58c354b0f0$var$color = {
    danger: {
        default: {
            light: "var(--ds-icon, #44546F)",
            dark: "var(--ds-icon, #44546F)"
        },
        hover: {
            light: "var(--ds-icon-danger, #C9372C)",
            dark: "var(--ds-icon-danger, #C9372C)"
        },
        active: {
            light: "var(--ds-icon-danger, #C9372C)",
            dark: "var(--ds-icon-danger, #C9372C)"
        }
    }
};
const $57820a58c354b0f0$var$colorVisualRefresh = {
    danger: {
        default: {
            light: "var(--ds-icon-subtle, #626F86)",
            dark: "var(--ds-icon-subtle, #626F86)"
        },
        hover: {
            light: "var(--ds-icon-danger, #C9372C)",
            dark: "var(--ds-icon-danger, #C9372C)"
        },
        active: {
            light: "var(--ds-icon-danger, #C9372C)",
            dark: "var(--ds-icon-danger, #C9372C)"
        }
    }
};
const $57820a58c354b0f0$export$f98ea88a275be66c = (props)=>({
        background: $57820a58c354b0f0$var$getStyles(// eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        (0, $eGOwo.fg)('platform-visual-refresh-icons') ? $57820a58c354b0f0$var$backgroundVisualRefresh : $57820a58c354b0f0$var$background, props),
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        color: $57820a58c354b0f0$var$getStyles((0, $eGOwo.fg)('platform-visual-refresh-icons') ? $57820a58c354b0f0$var$colorVisualRefresh : $57820a58c354b0f0$var$color, props)
    });

});


parcelRegister("4hDhk", function(module, exports) {

$parcel$export(module.exports, "buildDatasourceAdf", () => $149cb78e76268254$export$1de3504963fc32f2);
const $149cb78e76268254$export$1de3504963fc32f2 = (datasource, url)=>{
    return {
        type: 'blockCard',
        attrs: {
            url: url,
            datasource: datasource
        }
    };
};

});

parcelRegister("g0O72", function(module, exports) {

$parcel$export(module.exports, "DatasourceIcon", () => $2c540253232fc51d$export$8819453811a57211);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $gLL5P = parcelRequire("gLL5P");

var $lmgo6 = parcelRequire("lmgo6");
var $1DXK0 = parcelRequire("1DXK0");
const $2c540253232fc51d$var$IconDatasourceGlyph = (props)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M0 2C0 0.89543 0.895431 0 2 0H13C14.1046 0 15 0.895431 15 2V13C15 14.1046 14.1046 15 13 15H2C0.89543 15 0 14.1046 0 13V2ZM5 6C5 5.44772 5.44772 5 6 5L12 5C12.5523 5 13 5.44772 13 6C13 6.55229 12.5523 7 12 7L6 7C5.44772 7 5 6.55228 5 6ZM6 8C5.44772 8 5 8.44771 5 9C5 9.55228 5.44772 10 6 10L12 10C12.5523 10 13 9.55229 13 9C13 8.44772 12.5523 8 12 8L6 8ZM5 12C5 11.4477 5.44772 11 6 11L12 11C12.5523 11 13 11.4477 13 12C13 12.5523 12.5523 13 12 13L6 13C5.44772 13 5 12.5523 5 12ZM3 7C3.55228 7 4 6.55228 4 6C4 5.44772 3.55228 5 3 5C2.44772 5 2 5.44772 2 6C2 6.55228 2.44772 7 3 7ZM5 3C5 2.44772 5.44772 2 6 2L12 2C12.5523 2 13 2.44772 13 3C13 3.55229 12.5523 4 12 4L6 4C5.44772 4 5 3.55228 5 3ZM3 4C3.55228 4 4 3.55228 4 3C4 2.44772 3.55228 2 3 2C2.44772 2 2 2.44772 2 3C2 3.55228 2.44772 4 3 4ZM4 9C4 9.55229 3.55228 10 3 10C2.44772 10 2 9.55229 2 9C2 8.44771 2.44772 8 3 8C3.55228 8 4 8.44771 4 9ZM3 13C3.55228 13 4 12.5523 4 12C4 11.4477 3.55228 11 3 11C2.44772 11 2 11.4477 2 12C2 12.5523 2.44772 13 3 13Z",
            fill: 'currentColor'
        })
    });
};
const $2c540253232fc51d$var$wrapperStyles = (0, $1DXK0.xcss)({
    padding: 'space.050',
    justifyContent: 'center',
    alignItems: 'center',
    width: 'space.300',
    height: 'space.300'
});
const $2c540253232fc51d$export$8819453811a57211 = (props)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lmgo6.default), {
        xcss: $2c540253232fc51d$var$wrapperStyles,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gLL5P))), {
            LEGACY_fallbackIcon: $2c540253232fc51d$var$IconDatasourceGlyph,
            label: props?.label
        })
    });
};

});
parcelRegister("gLL5P", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d0cf5658da3b79d5f876ad9c272a691a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c35590cf7bb1748b$var$_react = $c35590cf7bb1748b$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $c35590cf7bb1748b$var$_baseNew = $c35590cf7bb1748b$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $c35590cf7bb1748b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SmartLinkList".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing Smart link embedded link lists.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c35590cf7bb1748b$var$SmartLinkListIcon = (props)=>/*#__PURE__*/ $c35590cf7bb1748b$var$_react.default.createElement($c35590cf7bb1748b$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zm2.5 3H4V4h1.5zm6.5 0H7V4h5zM5.5 8.75H4v-1.5h1.5zm6.5 0H7v-1.5h5zM5.5 12H4v-1.5h1.5zm6.5 0H7v-1.5h5z" clip-rule="evenodd"/>`
    }, props));
$c35590cf7bb1748b$var$SmartLinkListIcon.displayName = 'SmartLinkListIcon';
var $c35590cf7bb1748b$var$_default = module.exports.default = $c35590cf7bb1748b$var$SmartLinkListIcon;

});


parcelRegister("XsiSM", function(module, exports) {

$parcel$export(module.exports, "useFetchDatasourceInfo", () => $a556ec12d04916e0$export$d01c44dffc996c80);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");
const $a556ec12d04916e0$export$d01c44dffc996c80 = ({ isRegularCardNode: isRegularCardNode, url: url, cardContext: cardContext, nodeParameters: nodeParameters })=>{
    const [datasourceId, setDatasourceId] = (0, $eJOHy.useState)(undefined);
    const [parameters, setParameters] = (0, $eJOHy.useState)(nodeParameters);
    // Since fetchData() is async, using this ready check to see if we have the parameters before passing it to the modal.
    // Only non-datasource nodes will be not ready initially since we need to fetch data.
    const [ready, setReady] = (0, $eJOHy.useState)(!isRegularCardNode);
    const [extensionKey, setExtensionKey] = (0, $eJOHy.useState)(undefined);
    (0, $eJOHy.useEffect)(()=>{
        const fetchDatasource = async ()=>{
            try {
                if (!url || !cardContext) {
                    // Don't block rendering of modal of somehow we don't get these two args --> just open with empty params
                    setReady(true);
                    return;
                }
                const response = await cardContext?.connections?.client?.fetchData(url);
                const datasources = response && response.datasources || [];
                setExtensionKey(response?.meta.key);
                setDatasourceId(datasources[0]?.id);
                setParameters(datasources[0]?.parameters);
                setReady(true);
            } catch (e) {
                setDatasourceId(undefined);
                setParameters(undefined);
                setExtensionKey(undefined);
                // If fetch somehow errors, still set ready as true so we don't block the rendering of the modal.
                // It will just open with empty params.
                setReady(true);
            }
        };
        if (isRegularCardNode) fetchDatasource();
    }, [
        isRegularCardNode,
        cardContext,
        url
    ]);
    return {
        datasourceId: datasourceId,
        parameters: parameters,
        ready: ready,
        extensionKey: extensionKey
    };
};

});


parcelRegister("2UfVG", function(module, exports) {

$parcel$export(module.exports, "getEditLinkCallback", () => $fb188bfbbcc65cc5$export$c389e1daeae312a9);
$parcel$export(module.exports, "buildEditLinkToolbar", () => $fb188bfbbcc65cc5$export$dec3901e38d4e7ff);
$parcel$export(module.exports, "editLinkToolbarConfig", () => $fb188bfbbcc65cc5$export$acaefd190fd8ff4d);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $bMFKb = parcelRequire("bMFKb");
var $97Qim = parcelRequire("97Qim");

var $6C2m6 = parcelRequire("6C2m6");

var $bvdaU = parcelRequire("bvdaU");

var $4AqYB = parcelRequire("4AqYB");


var $3lIcL = parcelRequire("3lIcL");

var $ecNk4 = parcelRequire("ecNk4");

var $4AOcQ = parcelRequire("4AOcQ");

var $gXgTX = parcelRequire("gXgTX");
function $fb188bfbbcc65cc5$export$a46cebff622c3cae({ linkPickerOptions: linkPickerOptions = {}, onSubmit: onSubmit, displayText: displayText, displayUrl: displayUrl, providerFactory: providerFactory, view: view, onCancel: onCancel, invokeMethod: invokeMethod, lpLinkPicker: lpLinkPicker, onClose: onClose, onEscapeCallback: onEscapeCallback, onClickAwayCallback: onClickAwayCallback }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bvdaU.HyperlinkAddToolbar), {
        linkPickerOptions: linkPickerOptions,
        onSubmit: onSubmit,
        displayText: displayText,
        displayUrl: displayUrl,
        providerFactory: providerFactory,
        view: view,
        onCancel: onCancel,
        invokeMethod: invokeMethod,
        lpLinkPicker: lpLinkPicker,
        onClose: onClose,
        onEscapeCallback: onEscapeCallback,
        onClickAwayCallback: onClickAwayCallback
    });
}
class $fb188bfbbcc65cc5$export$3d21e16152ee408f extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    componentDidUpdate(prevProps) {
        if (prevProps.node !== this.props.node) this.hideLinkToolbar();
    }
    componentWillUnmount() {
        this.hideLinkToolbar();
    }
    hideLinkToolbar() {
        const { view: view } = this.props;
        view.dispatch((0, $ecNk4.hideLinkToolbar)(view.state.tr));
    }
    render() {
        const { linkPickerOptions: linkPickerOptions, providerFactory: providerFactory, url: url, text: text, view: view, onSubmit: onSubmit, forceFocusSelector: forceFocusSelector, lpLinkPicker: lpLinkPicker } = this.props;
        return /*#__PURE__*/ (0, $gt9Am.jsx)($fb188bfbbcc65cc5$export$a46cebff622c3cae, {
            view: view,
            linkPickerOptions: linkPickerOptions,
            providerFactory: providerFactory,
            displayUrl: url,
            displayText: text,
            // Assumes that the smart card link picker can only ever be invoked by clicking "edit"
            // via the floating toolbar
            invokeMethod: (0, $bMFKb.INPUT_METHOD).FLOATING_TB,
            lpLinkPicker: lpLinkPicker,
            onSubmit: (href, title, displayText, inputMethod, analytic)=>{
                this.hideLinkToolbar();
                if (onSubmit) onSubmit(href, displayText || title, inputMethod, analytic);
            },
            onEscapeCallback: (state, dispatch)=>{
                const { tr: tr } = state;
                (0, $ecNk4.hideLinkToolbar)(tr);
                forceFocusSelector?.(`[aria-label="${(0, $4AqYB.linkToolbarMessages).editLink.defaultMessage}"]`)(tr);
                if (dispatch) {
                    dispatch(tr);
                    return true;
                }
                return false;
            },
            onClickAwayCallback: (state, dispatch)=>{
                const { tr: tr } = state;
                if (dispatch) {
                    dispatch(tr);
                    return true;
                }
                return false;
            }
        });
    }
}
const $fb188bfbbcc65cc5$export$c389e1daeae312a9 = (editorAnalyticsApi, scrollIntoView)=>(state, dispatch)=>{
        let type = 'hyperlink';
        if (state.selection instanceof (0, $3lIcL.NodeSelection)) type = state.selection.node.type.name;
        if (dispatch) {
            const { tr: tr } = state;
            (0, $ecNk4.showLinkToolbar)(tr);
            editorAnalyticsApi?.attachAnalyticsEvent((0, $97Qim.buildEditLinkPayload)(type))(tr);
            tr.setMeta('scrollIntoView', scrollIntoView);
            dispatch(tr);
            return true;
        }
        return false;
    };
const $fb188bfbbcc65cc5$export$dec3901e38d4e7ff = ({ providerFactory: providerFactory, node: node, pluginInjectionApi: pluginInjectionApi, linkPicker: linkPicker, lpLinkPicker: lpLinkPicker })=>{
    return {
        type: 'custom',
        disableArrowNavigation: true,
        fallback: [],
        render: (view, idx)=>{
            if (!view || !providerFactory) return null;
            const displayInfo = (0, $gXgTX.displayInfoForCard)(node, (0, $gXgTX.findCardInfo)(view.state));
            return /*#__PURE__*/ (0, $gt9Am.jsx)($fb188bfbbcc65cc5$export$3d21e16152ee408f, {
                view: view,
                linkPickerOptions: linkPicker,
                providerFactory: providerFactory,
                url: displayInfo.url,
                text: displayInfo.title || '',
                node: node,
                lpLinkPicker: lpLinkPicker,
                forceFocusSelector: pluginInjectionApi?.floatingToolbar?.actions?.forceFocusSelector,
                onSubmit: (newHref, newText, inputMethod, analytic)=>{
                    const urlChanged = newHref !== displayInfo.url;
                    const titleChanged = newText !== displayInfo.title;
                    // If the title is changed in a smartlink, convert to standard blue hyperlink
                    // (even if the url was also changed) - we don't want to lose the custom title.
                    if (titleChanged) return (0, $6C2m6.commandWithMetadata)((0, $4AOcQ.changeSelectedCardToLink)(newText, newHref, undefined, undefined, undefined, pluginInjectionApi?.analytics?.actions), {
                        action: (0, $bMFKb.ACTION).UPDATED,
                        inputMethod: inputMethod,
                        sourceEvent: analytic
                    })(view.state, view.dispatch);
                    if (urlChanged) // If *only* the url is changed in a smart link, reresolve
                    return (0, $4AOcQ.updateCard)(newHref, analytic)(view.state, view.dispatch);
                }
            }, idx);
        }
    };
};
const $fb188bfbbcc65cc5$export$acaefd190fd8ff4d = (showLinkingToolbar, lpLinkPicker)=>{
    return showLinkingToolbar ? {
        height: lpLinkPicker ? (0, $4d66e472a8adb592$export$c635b83728f81640) : (0, $4d66e472a8adb592$export$c04a5ad015d45447),
        width: (0, $4d66e472a8adb592$export$a62aa932daf22ffe),
        forcePlacement: true
    } : {};
};

});
parcelRegister("bvdaU", function(module, exports) {

$parcel$export(module.exports, "HyperlinkAddToolbar", () => $540fb4737fcb7e70$export$8be6a38cd66ace65);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $bMFKb = parcelRequire("bMFKb");

var $4sxxB = parcelRequire("4sxxB");

var $ge12G = parcelRequire("ge12G");

var $4DYEn = parcelRequire("4DYEn");
/**
 * Wraps around the editor's onSubmit handler so that the plugin can interface with the link picker
 */ const $540fb4737fcb7e70$var$onSubmitInterface = (onSubmit)=>({ url: url, title: title, displayText: displayText, rawUrl: rawUrl, meta: meta }, analytic)=>{
        onSubmit(url, title ?? rawUrl, displayText || undefined, meta.inputMethod === 'manual' ? (0, $bMFKb.INPUT_METHOD).MANUAL : (0, $bMFKb.INPUT_METHOD).TYPEAHEAD, analytic);
    };
function $540fb4737fcb7e70$export$8be6a38cd66ace65({ linkPickerOptions: linkPickerOptions = {}, onSubmit: onSubmit, displayText: displayText, displayUrl: displayUrl, providerFactory: providerFactory, view: view, onCancel: onCancel, invokeMethod: invokeMethod, lpLinkPicker: lpLinkPicker, onClose: onClose, onEscapeCallback: onEscapeCallback, onClickAwayCallback: onClickAwayCallback, editorAppearance: editorAppearance, inputMethod: inputMethod, searchSessionId: searchSessionId, timesViewed: timesViewed, isOffline: isOffline }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4sxxB.WithProviders), {
        providers: [
            'activityProvider',
            'searchProvider'
        ],
        providerFactory: providerFactory,
        renderNode: ({ activityProvider: activityProvider, searchProvider: searchProvider })=>{
            // If we're offline fallback to HyperlinkAddToolbarComp as we may not have loaded
            // EditorLinkPicker into the bundle
            if (lpLinkPicker && !Boolean(isOffline)) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ge12G.EditorLinkPicker), {
                view: view,
                invokeMethod: // Provide `invokeMethod` prop as preferred value (card plugin passes as prop) otherwise assume this
                // is being used from inside the hyperlink plugin and use inputMethod from plugin state
                invokeMethod ?? inputMethod,
                editorAppearance: editorAppearance,
                ...linkPickerOptions,
                url: displayUrl,
                displayText: displayText,
                onSubmit: $540fb4737fcb7e70$var$onSubmitInterface(onSubmit),
                onCancel: onCancel,
                onClose: onClose,
                onEscapeCallback: onEscapeCallback,
                onClickAwayCallback: onClickAwayCallback
            });
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4DYEn.default), {
                activityProvider: activityProvider,
                searchProvider: searchProvider,
                onSubmit: onSubmit,
                displayText: displayText,
                displayUrl: displayUrl,
                view: view,
                onEscapeCallback: onEscapeCallback,
                onClickAwayCallback: onClickAwayCallback,
                inputMethod: inputMethod,
                searchSessionId: searchSessionId,
                timesViewed: timesViewed
            });
        }
    });
}

});
parcelRegister("ge12G", function(module, exports) {

$parcel$export(module.exports, "EditorLinkPicker", () => $87b6bbc09a31053d$export$da2f76555f5c8d0a);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $e2B2h = parcelRequire("e2B2h");

var $ie7Le = parcelRequire("ie7Le");

var $dyNYh = parcelRequire("dyNYh");

var $5x7vO = parcelRequire("5x7vO");
const $87b6bbc09a31053d$export$da2f76555f5c8d0a = ({ view: view, onCancel: onCancel, invokeMethod: invokeMethod = '_unknown', editorAppearance: editorAppearance, onClose: onClose, onEscapeCallback: onEscapeCallback, onClickAwayCallback: onClickAwayCallback, ...restProps })=>{
    /**
	 * Track onClose handler in a
	 * ref so that we void needing it in the dependency array
	 * below
	 */ const onCloseRef = (0, $eJOHy.useRef)(onClose);
    (0, $eJOHy.useEffect)(()=>{
        onCloseRef.current = onClose;
    });
    /**
	 * Call onClose on mount, usefull to provide
	 * a handler for performing an action after the component has been
	 * unmounted (e.g. return focus to the editors)
	 */ (0, $eJOHy.useEffect)(()=>()=>onCloseRef.current?.(), []);
    const onEscape = (0, $eJOHy.useCallback)(()=>{
        const { state: state, dispatch: dispatch } = view;
        onEscapeCallback?.(state, dispatch);
        onCancel?.();
    }, [
        view,
        onCancel,
        onEscapeCallback
    ]);
    const onClickAway = (0, $eJOHy.useCallback)(()=>{
        const { state: state, dispatch: dispatch } = view;
        onClickAwayCallback?.(state, dispatch);
        onCancel?.();
    }, [
        view,
        onCancel,
        onClickAwayCallback
    ]);
    const ref = (0, $5x7vO.useEscapeClickaway)(onEscape, onClickAway);
    const analyticsEditorAppearance = (0, $dyNYh.getAnalyticsEditorAppearance)(editorAppearance);
    const analyticsData = (0, $eJOHy.useMemo)(()=>({
            attributes: {
                invokeMethod: invokeMethod,
                location: analyticsEditorAppearance
            },
            // Below is added for the future implementation of Linking Platform namespaced analytic context
            location: analyticsEditorAppearance
        }), [
        invokeMethod,
        analyticsEditorAppearance
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ref: ref,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $e2B2h.default), {
            data: analyticsData,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ie7Le.default), {
                ...restProps,
                onCancel: onEscape
            })
        })
    });
};

});
parcelRegister("ie7Le", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddd7d0de1cad6667$export$2e2bcd8739ae039);
parcelRequire("bn7wb");
var $aAuez = parcelRequire("aAuez");

var $8KszW = parcelRequire("8KszW");

const $ddd7d0de1cad6667$var$LazyLinkPickerComponent = (0, $aAuez.lazyForPaint)(()=>(parcelRequire("wVjWF")).then(({ LinkPicker: LinkPicker })=>({
            default: LinkPicker
        })));
var // Must be a default export to be able to support prop docs
// eslint-disable-next-line import/no-default-export
$ddd7d0de1cad6667$export$2e2bcd8739ae039 = (0, $8KszW.composeLinkPicker)($ddd7d0de1cad6667$var$LazyLinkPickerComponent);

});
parcelRegister("bn7wb", function(module, exports) {

$parcel$export(module.exports, "lazyForPaint", () => (parcelRequire("aAuez")).lazyForPaint);
$parcel$export(module.exports, "lazyAfterPaint", () => (parcelRequire("aAuez")).lazyAfterPaint);
$parcel$export(module.exports, "lazy", () => (parcelRequire("aAuez")).lazy);
$parcel$export(module.exports, "LazySuspense", () => (parcelRequire("7qz8r")).LazySuspense);
$parcel$export(module.exports, "useLazyPhase", () => (parcelRequire("l7ep7")).useLazyPhase);
parcelRequire("7veda");
var $8V4xR = parcelRequire("8V4xR");

var $MkKnc = parcelRequire("MkKnc");

var $aAuez = parcelRequire("aAuez");
parcelRequire("4XKbm");
var $7eb8v = parcelRequire("7eb8v");
var $esFTx = parcelRequire("esFTx");
parcelRequire("jv91R");
var $7qz8r = parcelRequire("7qz8r");
parcelRequire("1llka");
var $l7ep7 = parcelRequire("l7ep7");

var $hrq5I = parcelRequire("hrq5I");

});
parcelRegister("7veda", function(module, exports) {

$parcel$export(module.exports, "getConfig", () => $576673b9f1b70022$export$44487a86467333c3);
$parcel$export(module.exports, "setConfig", () => $576673b9f1b70022$export$940a7873bb071df8);
$parcel$export(module.exports, "MODE", () => (parcelRequire("8V4xR")).MODE);

var $8V4xR = parcelRequire("8V4xR");
const $576673b9f1b70022$var$DEFAULT_CROSS_ORIGIN = undefined;
const $576673b9f1b70022$var$DEFAULT_MANIFEST = {
    publicPath: '/',
    assets: {}
};
const $576673b9f1b70022$var$DEFAULT_MODE = (0, $8V4xR.MODE).HYDRATE;
const $576673b9f1b70022$var$DEFAULT_RETRY = 2;
const $576673b9f1b70022$var$config = {
    crossOrigin: $576673b9f1b70022$var$DEFAULT_CROSS_ORIGIN,
    manifest: $576673b9f1b70022$var$DEFAULT_MANIFEST,
    mode: $576673b9f1b70022$var$DEFAULT_MODE,
    retry: $576673b9f1b70022$var$DEFAULT_RETRY
};
const $576673b9f1b70022$export$44487a86467333c3 = ()=>$576673b9f1b70022$var$config;
const $576673b9f1b70022$export$940a7873bb071df8 = (nextConfig)=>{
    var _nextConfig$crossOrig, _nextConfig$manifest, _nextConfig$mode, _nextConfig$retry;
    $576673b9f1b70022$var$config.crossOrigin = (_nextConfig$crossOrig = nextConfig.crossOrigin) != null ? _nextConfig$crossOrig : $576673b9f1b70022$var$DEFAULT_CROSS_ORIGIN;
    $576673b9f1b70022$var$config.manifest = (_nextConfig$manifest = nextConfig.manifest) != null ? _nextConfig$manifest : $576673b9f1b70022$var$DEFAULT_MANIFEST;
    $576673b9f1b70022$var$config.mode = (_nextConfig$mode = nextConfig.mode) != null ? _nextConfig$mode : $576673b9f1b70022$var$DEFAULT_MODE;
    $576673b9f1b70022$var$config.retry = (_nextConfig$retry = nextConfig.retry) != null ? _nextConfig$retry : $576673b9f1b70022$var$DEFAULT_RETRY;
};

});
parcelRegister("8V4xR", function(module, exports) {

$parcel$export(module.exports, "MODE", () => $67e72c25add85f29$export$e48589d9e4824227);
const $67e72c25add85f29$export$e48589d9e4824227 = {
    RENDER: 'RENDER',
    HYDRATE: 'HYDRATE'
};

});


parcelRegister("MkKnc", function(module, exports) {

var $8h7zW = parcelRequire("8h7zW");

var $7veda = parcelRequire("7veda");
parcelRequire("1llka");
var $eGDOl = parcelRequire("eGDOl");
var $l7ep7 = parcelRequire("l7ep7");

var $a1Dox = parcelRequire("a1Dox");
const $091493b8f27d5831$export$33c5f161e1d4706 = {
    init: (config)=>{
        (0, $7veda.setConfig)(config);
        (0, $eGDOl.LISTENERS).length = 0;
        (0, $l7ep7.setCurrent)(0);
        if (!(0, $a1Dox.isNodeEnvironment)()) (0, $8h7zW.collect)();
    }
};

});
parcelRegister("8h7zW", function(module, exports) {

$parcel$export(module.exports, "collect", () => $6065ca3c1e226813$export$bb44f104e3c54dae);

var $7veda = parcelRequire("7veda");
var $8V4xR = parcelRequire("8V4xR");

var $bzDJE = parcelRequire("bzDJE");

var $9WyUY = parcelRequire("9WyUY");

var $1NKbK = parcelRequire("1NKbK");
const $6065ca3c1e226813$export$bb44f104e3c54dae = ()=>{
    const markers = document.querySelectorAll('input[data-lazy-begin]');
    const { mode: mode } = (0, $7veda.getConfig)();
    for(let i = 0, j = markers.length; i < j; i += 1){
        const el = markers[i];
        const { lazyBegin: lazyBegin } = el.dataset || {};
        const value = mode === (0, $8V4xR.MODE).RENDER ? (0, $9WyUY.cloneElements)(markers[i], lazyBegin) : (0, $1NKbK.refElements)(markers[i], lazyBegin);
        if ((0, $bzDJE.COLLECTED).has(lazyBegin)) (0, $bzDJE.COLLECTED).get(lazyBegin).push(value);
        else (0, $bzDJE.COLLECTED).set(lazyBegin, [
            value
        ]);
    }
};

});
parcelRegister("bzDJE", function(module, exports) {

$parcel$export(module.exports, "PHASE", () => $86d1c92cf7d83ac0$export$2cc7a2eaaea7809f);
$parcel$export(module.exports, "COLLECTED", () => $86d1c92cf7d83ac0$export$4831ef3968ea94ef);
const $86d1c92cf7d83ac0$export$2cc7a2eaaea7809f = {
    PAINT: 0,
    AFTER_PAINT: 1,
    LAZY: 2
};
const $86d1c92cf7d83ac0$export$4831ef3968ea94ef = new Map();

});

parcelRegister("9WyUY", function(module, exports) {

$parcel$export(module.exports, "cloneElements", () => $73d49dd0c38c2a1c$export$c42217d53a7ebafb);
const $73d49dd0c38c2a1c$export$c42217d53a7ebafb = (fromEl, id)=>{
    const fragment = document.createElement('div');
    let el = fromEl;
    while(el = el.nextSibling){
        if (el.dataset && el.dataset.lazyEnd === id) break; // cloneNode is 50% faster than outerHTML/textContent
        fragment.appendChild(el.cloneNode(true));
    }
    return Array.from(fragment.childNodes);
};

});

parcelRegister("1NKbK", function(module, exports) {

$parcel$export(module.exports, "refElements", () => $14fe3218cc4e45c4$export$c69443129766a7fc);
const $14fe3218cc4e45c4$export$c69443129766a7fc = (fromEl, id)=>{
    const result = [];
    let el = fromEl;
    while(el = el.nextSibling){
        if (el.dataset && el.dataset.lazyEnd === id) break;
        result.push(el);
    }
    return result;
};

});


parcelRegister("1llka", function(module, exports) {

$parcel$export(module.exports, "LazyPhaseContext", () => (parcelRequire("l7ep7")).LazyPhaseContext);
$parcel$export(module.exports, "setCurrent", () => (parcelRequire("l7ep7")).setCurrent);
$parcel$export(module.exports, "useLazyPhase", () => (parcelRequire("l7ep7")).useLazyPhase);
$parcel$export(module.exports, "LISTENERS", () => (parcelRequire("eGDOl")).LISTENERS);

var $l7ep7 = parcelRequire("l7ep7");

var $eGDOl = parcelRequire("eGDOl");

var $7Peej = parcelRequire("7Peej");

});
parcelRegister("l7ep7", function(module, exports) {

$parcel$export(module.exports, "setCurrent", () => $f5f56cc3db1024b3$export$5f80f094fd31fffd);
$parcel$export(module.exports, "LazyPhaseContext", () => $f5f56cc3db1024b3$export$5a25eca35e5debcb);
$parcel$export(module.exports, "useLazyPhase", () => $f5f56cc3db1024b3$export$1dc361b277327f88);

var $eJOHy = parcelRequire("eJOHy");

var $bzDJE = parcelRequire("bzDJE");

var $eGDOl = parcelRequire("eGDOl");

var $7Peej = parcelRequire("7Peej");
let $f5f56cc3db1024b3$var$CURRENT_PHASE = (0, $bzDJE.PHASE).PAINT;
const $f5f56cc3db1024b3$export$5f80f094fd31fffd = (phase)=>{
    $f5f56cc3db1024b3$var$CURRENT_PHASE = phase;
    (0, $eGDOl.LISTENERS).slice(0).forEach((listener)=>listener(phase));
};
const $f5f56cc3db1024b3$export$5a25eca35e5debcb = /*#__PURE__*/ (0, $eJOHy.createContext)({
    subscribe: (0, $7Peej.createSubscribe)((0, $eGDOl.LISTENERS)),
    currentValue: ()=>$f5f56cc3db1024b3$var$CURRENT_PHASE,
    api: {
        startNextPhase: ()=>{
            $f5f56cc3db1024b3$export$5f80f094fd31fffd((0, $bzDJE.PHASE).AFTER_PAINT);
        },
        resetPhase: ()=>$f5f56cc3db1024b3$export$5f80f094fd31fffd((0, $bzDJE.PHASE).PAINT)
    }
});
const $f5f56cc3db1024b3$export$1dc361b277327f88 = ()=>{
    const v = (0, $eJOHy.useContext)($f5f56cc3db1024b3$export$5a25eca35e5debcb);
    return v.api;
};

});
parcelRegister("eGDOl", function(module, exports) {

$parcel$export(module.exports, "LISTENERS", () => $ab13de8c68717d57$export$81b9c458a026d68f);
const $ab13de8c68717d57$export$81b9c458a026d68f = [];

});

parcelRegister("7Peej", function(module, exports) {

$parcel$export(module.exports, "createSubscribe", () => $5b2855963721e7ea$export$364097d812234b3f);
const $5b2855963721e7ea$export$364097d812234b3f = (listeners)=>(listener)=>{
        listeners.push(listener);
        return ()=>{
            const index = listeners.indexOf(listener);
            if (index !== -1) listeners.splice(index, 1);
        };
    };

});



parcelRegister("a1Dox", function(module, exports) {

$parcel$export(module.exports, "getExport", () => $74c88e574846d6bd$export$d4c07b1daf44a7f);
$parcel$export(module.exports, "displayNameFromId", () => $74c88e574846d6bd$export$4429f98ef60d2d87);
$parcel$export(module.exports, "isNodeEnvironment", () => $74c88e574846d6bd$export$283635c04a02cc36);
$parcel$export(module.exports, "attrToProp", () => $74c88e574846d6bd$export$62bf630d0de3d781);
$parcel$export(module.exports, "hash", () => (parcelRequire("ed3y6")).default);

var $ed3y6 = parcelRequire("ed3y6");
const $74c88e574846d6bd$export$d4c07b1daf44a7f = (m)=>'default' in m ? m.default : m;
const $74c88e574846d6bd$export$4429f98ef60d2d87 = (id)=>{
    const fName = id.split('/').slice(-3).join('/');
    return fName || 'Component';
};
const $74c88e574846d6bd$export$283635c04a02cc36 = ()=>{
    if (typeof window === 'undefined') return true;
    if (window.name === 'nodejs') return true;
    return false;
};
function $74c88e574846d6bd$export$62bf630d0de3d781(props, attr) {
    switch(attr.name){
        case 'style':
            break;
        case 'class':
            props.className = attr.value;
            break;
        case 'crossorigin':
            props.crossOrigin = attr.value;
            break;
        default:
            props[attr.name] = attr.value;
    }
    return props;
}

});
parcelRegister("ed3y6", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5850857827bd3c9$export$2e2bcd8739ae039);
/* eslint-disable */ // murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function $a5850857827bd3c9$export$2e2bcd8739ae039(str) {
    var l = str.length, h = l ^ l, i = 0, k;
    while(l >= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        k ^= k >>> 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
        l -= 4;
        ++i;
    }
    switch(l){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;
    return (h >>> 0).toString(36);
}

});



parcelRegister("aAuez", function(module, exports) {

$parcel$export(module.exports, "lazyForPaint", () => $7b54b80385d7fc57$export$c952e5f94576010e);
$parcel$export(module.exports, "lazyAfterPaint", () => $7b54b80385d7fc57$export$291dd592399bdafa);
$parcel$export(module.exports, "lazy", () => $7b54b80385d7fc57$export$488013bae63b21da);

var $j5vcn = parcelRequire("j5vcn");

var $7veda = parcelRequire("7veda");

var $bzDJE = parcelRequire("bzDJE");

var $a1Dox = parcelRequire("a1Dox");
var $ed3y6 = parcelRequire("ed3y6");

var $b8XF0 = parcelRequire("b8XF0");

var $jA7rF = parcelRequire("jA7rF");

var $c7s3I = parcelRequire("c7s3I");

var $iFrYh = parcelRequire("iFrYh");

var $dcrQD = parcelRequire("dcrQD");

var $dcUz2 = parcelRequire("dcUz2");

var $2f83m = parcelRequire("2f83m");
function $7b54b80385d7fc57$var$_extends() {
    $7b54b80385d7fc57$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7b54b80385d7fc57$var$_extends.apply(this, arguments);
}
function $7b54b80385d7fc57$var$lazyProxy(_loader, { defer: defer = (0, $bzDJE.PHASE).PAINT, moduleId: moduleId = '', ssr: ssr = true } = {}) {
    const isServer = (0, $a1Dox.isNodeEnvironment)();
    const dataLazyId = (0, $ed3y6.default)(moduleId);
    const LazyInternal = isServer ? (0, $c7s3I.createComponentServer)({
        dataLazyId: dataLazyId,
        defer: defer,
        loader: _loader,
        moduleId: moduleId,
        ssr: ssr
    }) : (0, $jA7rF.createComponentClient)({
        dataLazyId: dataLazyId,
        defer: defer,
        // We separate the preload from the retryable request, as we do not want the preload to contribute to retry
        // attempts, when the the loader fallback is used
        deferred: (0, $iFrYh.createDeferred)({
            loader: ()=>{
                const { retry: maxAttempts } = (0, $7veda.getConfig)();
                return (0, $dcUz2.retry)(_loader, {
                    delay: (0, $b8XF0.RETRY_DELAY),
                    factor: (0, $b8XF0.RETRY_FACTOR),
                    maxAttempts: maxAttempts
                });
            },
            preload: _loader
        }),
        moduleId: moduleId
    });
    LazyInternal.displayName = `Lazy(${(0, $a1Dox.displayNameFromId)(moduleId)})`;
    /**
   * Allows getting module chunks urls
   */ const getAssetUrls = ()=>{
        const { manifest: manifest } = (0, $7veda.getConfig)();
        return (0, $j5vcn.getAssetUrlsFromId)(manifest, moduleId);
    };
    /**
   * Allows imperatively preload/ prefetch the module chunk asset
   */ const preload = (priority)=>{
        const p = priority != null ? priority : defer === (0, $bzDJE.PHASE).PAINT ? (0, $b8XF0.PRIORITY).HIGH : (0, $b8XF0.PRIORITY).LOW;
        return (0, $dcrQD.preloadAsset)({
            loader: _loader,
            moduleId: moduleId,
            priority: p
        });
    };
    return Object.assign(LazyInternal, {
        getAssetUrls: getAssetUrls,
        preload: preload
    });
}
const $7b54b80385d7fc57$export$93ca5d3f8675ae4c = {
    lazyForPaint: {
        ssr: true,
        defer: (0, $bzDJE.PHASE).PAINT
    },
    lazyAfterPaint: {
        ssr: true,
        defer: (0, $bzDJE.PHASE).AFTER_PAINT
    },
    lazy: {
        ssr: false,
        defer: (0, $bzDJE.PHASE).LAZY
    }
};
function $7b54b80385d7fc57$export$c952e5f94576010e(loader, opts) {
    return $7b54b80385d7fc57$var$lazyProxy(loader, $7b54b80385d7fc57$var$_extends({}, $7b54b80385d7fc57$export$93ca5d3f8675ae4c.lazyForPaint, opts || {}));
}
function $7b54b80385d7fc57$export$291dd592399bdafa(loader, opts) {
    return $7b54b80385d7fc57$var$lazyProxy(loader, $7b54b80385d7fc57$var$_extends({}, $7b54b80385d7fc57$export$93ca5d3f8675ae4c.lazyAfterPaint, opts || {}));
}
function $7b54b80385d7fc57$export$488013bae63b21da(loader, opts) {
    return $7b54b80385d7fc57$var$lazyProxy(loader, $7b54b80385d7fc57$var$_extends({}, $7b54b80385d7fc57$export$93ca5d3f8675ae4c.lazy, opts || {}));
}

});
parcelRegister("j5vcn", function(module, exports) {

$parcel$export(module.exports, "getAssetUrlsFromId", () => $de56af5358c8f987$export$303f43e55cf1ef2f);
const $de56af5358c8f987$export$303f43e55cf1ef2f = (manifest, id)=>{
    if (!manifest.assets || !manifest.assets[id]) return;
    return manifest.assets[id].map((asset)=>`${manifest.publicPath}${asset}`);
};

});

parcelRegister("b8XF0", function(module, exports) {

$parcel$export(module.exports, "PRIORITY", () => $81ceb864b052c80d$export$bb34f3538ba26c7e);
$parcel$export(module.exports, "RETRY_DELAY", () => $81ceb864b052c80d$export$a339266ad71b2447);
$parcel$export(module.exports, "RETRY_FACTOR", () => $81ceb864b052c80d$export$ba64c908e55507fe);
const $81ceb864b052c80d$export$bb34f3538ba26c7e = {
    HIGH: 0,
    LOW: 2
};
const $81ceb864b052c80d$export$a339266ad71b2447 = 300;
const $81ceb864b052c80d$export$ba64c908e55507fe = 1;

});

parcelRegister("jA7rF", function(module, exports) {

$parcel$export(module.exports, "createComponentClient", () => $e417279bde8da3e7$export$6898b5504b58699a);

var $eJOHy = parcelRequire("eJOHy");

var $7veda = parcelRequire("7veda");
var $8V4xR = parcelRequire("8V4xR");

var $bzDJE = parcelRequire("bzDJE");
parcelRequire("4XKbm");
var $esFTx = parcelRequire("esFTx");
parcelRequire("1llka");
var $l7ep7 = parcelRequire("l7ep7");
parcelRequire("jv91R");
var $4XL9N = parcelRequire("4XL9N");

var $2f83m = parcelRequire("2f83m");

var $bVeRl = parcelRequire("bVeRl");

var $7fZLe = parcelRequire("7fZLe");

var $hrq5I = parcelRequire("hrq5I");

var $9qVNk = parcelRequire("9qVNk");
function $e417279bde8da3e7$export$6898b5504b58699a({ defer: defer, deferred: deferred, dataLazyId: dataLazyId, moduleId: moduleId }) {
    const ResolvedLazy = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>deferred.promise);
    return (props)=>{
        // use a single piece of state to hold info about progress or eventually
        // throw an error. We do change it via direct mutation as re-renders
        // break Suspense in React 18, making it lose hydration state
        const [status, bubbleError] = (0, $eJOHy.useState)(()=>({
                noWait: undefined,
                phase: defer === (0, $bzDJE.PHASE).AFTER_PAINT ? false : true,
                preloaded: defer === (0, $bzDJE.PHASE).AFTER_PAINT ? false : true,
                started: false
            }));
        const profiler = (0, $eJOHy.useContext)((0, $hrq5I.ProfilerContext)).current;
        const load = ()=>{
            if (status.started || !status.phase || !status.noWait) return;
            status.started = true;
            let onResolve;
            if (profiler) {
                const eventInfo = {
                    identifier: moduleId
                };
                onResolve = ()=>{
                    profiler.onLoadComplete(eventInfo);
                };
                profiler.onLoadStart(eventInfo);
            }
            const result = deferred.start().catch((err)=>{
                // Throw the error within the component lifecycle
                // refer to https://github.com/facebook/react/issues/11409
                bubbleError(()=>{
                    throw (0, $2f83m.createLoaderError)(err);
                });
            });
            if (onResolve) result.then(onResolve);
        }; // Subscribe to LazyWait context, triggering load when until is true
        (0, $9qVNk.useSubscription)({
            context: (0, $esFTx.WaitContext),
            load: load,
            onValue: (v)=>status.noWait = v === 1
        });
        if (defer === (0, $bzDJE.PHASE).AFTER_PAINT) // Subscribe to LazyPhase context, triggering load when own phase starts
        (0, $9qVNk.useSubscription)({
            context: (0, $l7ep7.LazyPhaseContext),
            load: load,
            onValue: (v)=>status.phase = v >= defer
        });
        const { setFallback: setFallback } = (0, $eJOHy.useContext)((0, $4XL9N.LazySuspenseContext));
        (0, $eJOHy.useMemo)(()=>{
            // find SSR content (or fallbacks) wrapped in inputs based on lazyId
            const content = ((0, $bzDJE.COLLECTED).get(dataLazyId) || []).shift();
            if (!content) return; // override Suspense fallback with magic input wrappers
            const component = (0, $7veda.getConfig)().mode === (0, $8V4xR.MODE).RENDER ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bVeRl.PlaceholderFallbackRender), {
                id: dataLazyId,
                content: content
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7fZLe.PlaceholderFallbackHydrate), {
                id: dataLazyId,
                content: content
            });
            setFallback(component);
        }, [
            setFallback
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ResolvedLazy, props);
    };
}

});
parcelRegister("4XKbm", function(module, exports) {

$parcel$export(module.exports, "WaitContext", () => (parcelRequire("esFTx")).WaitContext);

var $esFTx = parcelRequire("esFTx");

var $7eb8v = parcelRequire("7eb8v");

});
parcelRegister("esFTx", function(module, exports) {

$parcel$export(module.exports, "WaitContext", () => $a8742da03f685732$export$9ba3fe09d15de47b);

var $eJOHy = parcelRequire("eJOHy");

var $ddxDA = parcelRequire("ddxDA");
const $a8742da03f685732$export$9ba3fe09d15de47b = /*#__PURE__*/ (0, $eJOHy.createContext)({
    subscribe: ()=>(0, $ddxDA.noopCleanup),
    currentValue: ()=>1
});

});
parcelRegister("ddxDA", function(module, exports) {

$parcel$export(module.exports, "noopCleanup", () => $99f694f5596397af$export$276c7dbda7675aec);
const $99f694f5596397af$export$276c7dbda7675aec = ()=>{};

});


parcelRegister("7eb8v", function(module, exports) {

var $eJOHy = parcelRequire("eJOHy");

var $esFTx = parcelRequire("esFTx");
const $54327a9f9e29fe04$export$7bf6cf03fd32cddb = ({ until: until, children: children })=>{
    const closestWait = (0, $eJOHy.useContext)((0, $esFTx.WaitContext));
    const value = (0, $eJOHy.useRef)(until && closestWait.currentValue() ? 1 : 0);
    const subscribers = (0, $eJOHy.useRef)(new Set());
    const api = (0, $eJOHy.useRef)({
        subscribe: (subscriber)=>{
            subscribers.current.add(subscriber);
            return ()=>{
                subscribers.current.delete(subscriber);
            };
        },
        currentValue: ()=>value.current
    });
    (0, $eJOHy.useEffect)(()=>{
        // Notify subscribers when until prop or closest until value changes
        const notify = ()=>{
            value.current = closestWait.currentValue() && until ? 1 : 0;
            subscribers.current.forEach((subscriber)=>subscriber());
        };
        notify();
        return closestWait.subscribe(notify);
    }, [
        closestWait,
        until
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $esFTx.WaitContext).Provider, {
        value: api.current
    }, children);
};

});


parcelRegister("jv91R", function(module, exports) {

$parcel$export(module.exports, "LazySuspense", () => (parcelRequire("7qz8r")).LazySuspense);
$parcel$export(module.exports, "LazySuspenseContext", () => (parcelRequire("4XL9N")).LazySuspenseContext);

var $7qz8r = parcelRequire("7qz8r");

var $4XL9N = parcelRequire("4XL9N");

});
parcelRegister("7qz8r", function(module, exports) {

$parcel$export(module.exports, "LazySuspense", () => $56863736a86894e9$export$256c542058532d6f);

var $eJOHy = parcelRequire("eJOHy");

var $a1Dox = parcelRequire("a1Dox");

var $4XL9N = parcelRequire("4XL9N");
class $56863736a86894e9$export$256c542058532d6f extends (0, $eJOHy.Component) {
    constructor(props){
        super(props);
        this.state = {
            // Used on server to render fallback down the tree
            fallback: this.props.fallback,
            // Used on client to replace fallback with magic input
            setFallback: (fallback)=>{
                if (this.hydrationFallback === fallback) return;
                this.hydrationFallback = fallback; // Schedule an update so we force switch from the sibling tree
                // back to the suspense boundary
                if (this.mounted) this.forceUpdate();
            },
            name: this.props.name
        };
        this.hydrationFallback = null;
        this.mounted = false;
        this.DynamicFallback = ({ children: children, outsideSuspense: outsideSuspense })=>{
            // eslint-disable-next-line react-hooks/rules-of-hooks
            (0, $eJOHy.useLayoutEffect)(()=>{
                return ()=>{
                    // the effect cleanup is called by the Suspense boundary itself
                    // when both Lazy AND the eventual promises thrown are done
                    // so Suspense will re-render with actual content and we remove
                    // the hydration fallback at the same time
                    if (!outsideSuspense) this.state.setFallback(null);
                };
            }, [
                outsideSuspense
            ]);
            return outsideSuspense ? children(this.hydrationFallback ? this.hydrationFallback : null) : children(this.hydrationFallback ? null : this.props.fallback);
        };
        this.DynamicFallback.displayName = 'DynamicFallback';
    }
    componentDidMount() {
        this.mounted = true;
    }
    renderFallback(outsideSuspense) {
        const { DynamicFallback: DynamicFallback } = this; // Use render prop component to allow switch to hydration fallback
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(DynamicFallback, {
            outsideSuspense: outsideSuspense
        }, (fallback)=>fallback);
    }
    renderServer() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4XL9N.LazySuspenseContext).Provider, {
            value: this.state
        }, this.props.children);
    }
    renderClient() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4XL9N.LazySuspenseContext).Provider, {
            value: this.state
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJOHy.Suspense), {
            fallback: this.renderFallback(false)
        }, this.props.children), (!this.mounted || this.hydrationFallback) && this.renderFallback(true));
    }
    render() {
        return (0, $a1Dox.isNodeEnvironment)() ? this.renderServer() : this.renderClient();
    }
}

});
parcelRegister("4XL9N", function(module, exports) {

$parcel$export(module.exports, "LazySuspenseContext", () => $39d1408803878497$export$c33990e84065970c);

var $eJOHy = parcelRequire("eJOHy");
const $39d1408803878497$export$c33990e84065970c = /*#__PURE__*/ (0, $eJOHy.createContext)({
    fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJOHy.Fragment), null),
    setFallback: ()=>{
        console.warn('Missing <LooselySuspense /> boundary');
    }
});

});



parcelRegister("2f83m", function(module, exports) {

$parcel$export(module.exports, "createLoaderError", () => $1a233ab151dd1ee2$export$c73a6a6f0bf7d425);
const $1a233ab151dd1ee2$export$6aa69c1258005366 = Symbol.for('react-loosely-lazy/loader-error');
const $1a233ab151dd1ee2$export$c73a6a6f0bf7d425 = (error)=>{
    if (typeof error === 'object') return Object.assign(error, {
        [$1a233ab151dd1ee2$export$6aa69c1258005366]: true
    });
    return error;
};
const $1a233ab151dd1ee2$export$16a03aca4a3508b4 = (error)=>Object.getOwnPropertySymbols(error).includes($1a233ab151dd1ee2$export$6aa69c1258005366);

});

parcelRegister("bVeRl", function(module, exports) {

$parcel$export(module.exports, "PlaceholderFallbackRender", () => $8ae08b5f412b712d$export$d55db778a3e1446b);

var $eJOHy = parcelRequire("eJOHy");

var $hrq5I = parcelRequire("hrq5I");
parcelRequire("4XKbm");
var $esFTx = parcelRequire("esFTx");
parcelRequire("jv91R");
var $4XL9N = parcelRequire("4XL9N");
function $8ae08b5f412b712d$var$isLinkPrefetch(el) {
    return el.tagName === 'LINK' && el.rel === 'prefetch';
}
const $8ae08b5f412b712d$var$usePlaceholderRender = (resolveId, content)=>{
    const hydrationRef = (0, $eJOHy.useRef)(null);
    const { current: ssrDomNodes } = (0, $eJOHy.useRef)(content || []);
    const profilerContext = (0, $eJOHy.useContext)((0, $hrq5I.ProfilerContext)).current;
    const waitContext = (0, $eJOHy.useContext)((0, $esFTx.WaitContext));
    const suspenseContext = (0, $eJOHy.useContext)((0, $4XL9N.LazySuspenseContext));
    (0, $eJOHy.useLayoutEffect)(()=>{
        const element = hydrationRef.current;
        const { parentNode: parentNode } = element || {};
        profilerContext === null || profilerContext.placeholderFallBackMounted(resolveId, suspenseContext.name, !waitContext.currentValue());
        if (parentNode && !parentNode.contains(ssrDomNodes[0])) ssrDomNodes.reverse().forEach((node)=>{
            // this fixes an issue with Chrome that re-triggers and cancels prefetch
            // when node is appended again, making network panel quite noisy
            if ($8ae08b5f412b712d$var$isLinkPrefetch(node)) node.rel = '';
            parentNode.insertBefore(node, element.nextSibling);
        });
        return ()=>{
            profilerContext === null || profilerContext.placeholderFallBackUnmounted(resolveId, suspenseContext.name, !waitContext.currentValue());
            ssrDomNodes.forEach((node)=>{
                var _node$parentNode;
                return (_node$parentNode = node.parentNode) == null ? void 0 : _node$parentNode.removeChild(node);
            });
        }; // [hydrationRef.current, ssrDomNodes] are expected to be stable
    // with the second one never changing by design and the first one changing after first render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return hydrationRef;
};
const $8ae08b5f412b712d$export$d55db778a3e1446b = ({ id: id, content: content })=>{
    const placeholderRef = $8ae08b5f412b712d$var$usePlaceholderRender(id, content);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("input", {
        type: "hidden",
        "data-lazy-begin": id,
        ref: placeholderRef
    });
};

});
parcelRegister("hrq5I", function(module, exports) {

$parcel$export(module.exports, "GlobalReactLooselyLazyProfiler", () => $cb29326da0127013$export$e2d53c0cbedd2710);
$parcel$export(module.exports, "ProfilerContext", () => $cb29326da0127013$export$8146ab57a3f7a7cb);

var $eJOHy = parcelRequire("eJOHy");
const $cb29326da0127013$export$e2d53c0cbedd2710 = {
    current: null
};
const $cb29326da0127013$export$8146ab57a3f7a7cb = /*#__PURE__*/ (0, $eJOHy.createContext)($cb29326da0127013$export$e2d53c0cbedd2710);

});


parcelRegister("7fZLe", function(module, exports) {

$parcel$export(module.exports, "PlaceholderFallbackHydrate", () => $5489d785fce022f5$export$ca5b8fbc835d95e4);

var $eJOHy = parcelRequire("eJOHy");

var $a1Dox = parcelRequire("a1Dox");
function $5489d785fce022f5$var$_extends() {
    $5489d785fce022f5$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5489d785fce022f5$var$_extends.apply(this, arguments);
}
const $5489d785fce022f5$export$ca5b8fbc835d95e4 = ({ id: id, content: content })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("input", {
        type: "hidden",
        "data-lazy-begin": id
    }), content.map((el, i)=>{
        const { tagName: tagName = '', childNodes: childNodes = [], attributes: attributes = [] } = el;
        const props = Array.from(attributes).reduce((0, $a1Dox.attrToProp), {
            key: String(i)
        }); // text node
        if (!tagName) return /*#__PURE__*/ (0, $eJOHy.createElement)((0, $eJOHy.Fragment), props, el.textContent); // childless tag
        if (!childNodes.length) return /*#__PURE__*/ (0, $eJOHy.createElement)(tagName.toLowerCase(), props); // tag with content
        return /*#__PURE__*/ (0, $eJOHy.createElement)(tagName.toLowerCase(), $5489d785fce022f5$var$_extends({}, props, {
            dangerouslySetInnerHTML: {
                __html: ''
            },
            suppressHydrationWarning: true
        }));
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("input", {
        type: "hidden",
        "data-lazy-end": id
    }));
};

});

parcelRegister("9qVNk", function(module, exports) {

$parcel$export(module.exports, "useSubscription", () => $6de35f980c3d94e0$export$368b4214baeb914c);

var $eJOHy = parcelRequire("eJOHy");
function $6de35f980c3d94e0$export$368b4214baeb914c({ context: context, load: load, onValue: onValue }) {
    const { subscribe: subscribe, currentValue: currentValue } = (0, $eJOHy.useContext)(context);
    (0, $eJOHy.useMemo)(()=>{
        let unsubscribe = null;
        const check = ()=>{
            const done = onValue(currentValue());
            if (done) load();
            if (done && unsubscribe) unsubscribe();
            return done;
        };
        unsubscribe = !check() ? subscribe(check) : null; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}

});


parcelRegister("c7s3I", function(module, exports) {

$parcel$export(module.exports, "createComponentServer", () => $8d2be766ecc6ab62$export$eb2e4b04351cdd9e);

var $j5vcn = parcelRequire("j5vcn");

var $eJOHy = parcelRequire("eJOHy");

var $7veda = parcelRequire("7veda");

var $bzDJE = parcelRequire("bzDJE");
parcelRequire("jv91R");
var $4XL9N = parcelRequire("4XL9N");

var $a1Dox = parcelRequire("a1Dox");

var $2f83m = parcelRequire("2f83m");
function $8d2be766ecc6ab62$var$load(moduleId, loader) {
    try {
        return (0, $a1Dox.getExport)(loader());
    } catch (err) {
        throw (0, $2f83m.createLoaderError)(err);
    }
}
function $8d2be766ecc6ab62$export$eb2e4b04351cdd9e({ dataLazyId: dataLazyId, defer: defer, loader: loader, moduleId: moduleId, ssr: ssr }) {
    return (props)=>{
        var _getAssetUrlsFromId;
        const Resolved = ssr ? $8d2be766ecc6ab62$var$load(moduleId, loader) : null;
        const { fallback: fallback } = (0, $eJOHy.useContext)((0, $4XL9N.LazySuspenseContext));
        const { crossOrigin: crossOrigin, manifest: manifest } = (0, $7veda.getConfig)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("input", {
            type: "hidden",
            "data-lazy-begin": dataLazyId
        }), defer !== (0, $bzDJE.PHASE).LAZY && ((_getAssetUrlsFromId = (0, $j5vcn.getAssetUrlsFromId)(manifest, moduleId)) == null ? void 0 : _getAssetUrlsFromId.map((url)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("link", {
                key: url,
                rel: defer === (0, $bzDJE.PHASE).PAINT ? 'preload' : 'prefetch',
                href: url,
                crossOrigin: crossOrigin,
                as: "script"
            }))), Resolved ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Resolved, props) : fallback, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("input", {
            type: "hidden",
            "data-lazy-end": dataLazyId
        }));
    };
}

});

parcelRegister("iFrYh", function(module, exports) {

$parcel$export(module.exports, "createDeferred", () => $0381d5b0cf615548$export$e673efccd97e4223);
const $0381d5b0cf615548$export$e673efccd97e4223 = ({ loader: loader, preload: preload })=>{
    let resolve;
    const deferred = {
        promise: new Promise((res)=>{
            resolve = (m)=>{
                let withDefault;
                deferred.result = m;
                if (!m.default) withDefault = {
                    default: m
                };
                res(withDefault ? withDefault : m);
            };
        }),
        result: undefined,
        preload: function(_preload) {
            function preload() {
                return _preload.apply(this, arguments);
            }
            preload.toString = function() {
                return _preload.toString();
            };
            return preload;
        }(()=>{
            if (deferred.result) return;
            preload().then((m)=>{
                deferred.result = m;
            }).catch(()=>{});
        }),
        start: ()=>{
            if (deferred.result) {
                resolve(deferred.result);
                return Promise.resolve();
            } // Make a new loader request when none have started or resolved yet
            return loader().then(resolve);
        }
    };
    return deferred;
};

});

parcelRegister("dcrQD", function(module, exports) {

$parcel$export(module.exports, "preloadAsset", () => $99c1ff5e48fc9639$export$25bad4aa00c45355);

var $j5vcn = parcelRequire("j5vcn");

var $ddxDA = parcelRequire("ddxDA");

var $7veda = parcelRequire("7veda");

var $a1Dox = parcelRequire("a1Dox");

var $b8XF0 = parcelRequire("b8XF0");

var $dfXT0 = parcelRequire("dfXT0");

var $hrq5I = parcelRequire("hrq5I");
function $99c1ff5e48fc9639$export$3af04dbcb01bad4d({ moduleId: moduleId, rel: rel }) {
    const { manifest: manifest } = (0, $7veda.getConfig)();
    const assets = (0, $j5vcn.getAssetUrlsFromId)(manifest, moduleId);
    if (!assets) throw new Error('Unsupported preload strategy');
    const cleanupLinkTags = assets.map((url)=>(0, $dfXT0.insertLinkTag)(url, rel));
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
const $99c1ff5e48fc9639$var$fakePromise = {
    then: ()=>$99c1ff5e48fc9639$var$fakePromise,
    catch: ()=>$99c1ff5e48fc9639$var$fakePromise,
    finally: ()=>$99c1ff5e48fc9639$var$fakePromise
};
function $99c1ff5e48fc9639$export$1046fd6a49d5e7a({ loader: loader, rel: rel }) {
    if (typeof __webpack_require__ === 'undefined' || typeof __webpack_get_script_filename__ === 'undefined') throw new Error('Unsupported preload strategy'); // Replace requireEnsure to create link tags instead of scripts
    const requireEnsure = __webpack_require__.e;
    const cleanupLinkTags = [];
    __webpack_require__.e = function requirePreload(chunkId) {
        const href = __webpack_get_script_filename__(chunkId);
        cleanupLinkTags.push((0, $dfXT0.insertLinkTag)(href, rel));
        return $99c1ff5e48fc9639$var$fakePromise;
    };
    try {
        loader();
    } catch (err) {} // Restore real webpack require ensure
    __webpack_require__.e = requireEnsure;
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
function $99c1ff5e48fc9639$export$eb05139fa4dcf992({ loader: loader }) {
    loader();
    return 0, $ddxDA.noopCleanup;
}
function $99c1ff5e48fc9639$export$25bad4aa00c45355({ loader: loader, moduleId: moduleId, priority: priority }) {
    var _GlobalReactLooselyLa;
    if ((0, $a1Dox.isNodeEnvironment)()) return 0, $ddxDA.noopCleanup;
    (_GlobalReactLooselyLa = (0, $hrq5I.GlobalReactLooselyLazyProfiler).current) == null || _GlobalReactLooselyLa.onPreload(moduleId, priority);
    const rel = priority === (0, $b8XF0.PRIORITY).HIGH ? 'preload' : 'prefetch';
    const preloadStrategies = [
        $99c1ff5e48fc9639$export$3af04dbcb01bad4d,
        $99c1ff5e48fc9639$export$1046fd6a49d5e7a,
        $99c1ff5e48fc9639$export$eb05139fa4dcf992
    ];
    for (const strategy of preloadStrategies)try {
        return strategy({
            loader: loader,
            moduleId: moduleId,
            rel: rel
        });
    } catch (_) {}
    return 0, $ddxDA.noopCleanup;
}

});
parcelRegister("dfXT0", function(module, exports) {

$parcel$export(module.exports, "insertLinkTag", () => $9a6b213a2be2821b$export$6610512821c8a4ce);

var $hrq5I = parcelRequire("hrq5I");

var $ddxDA = parcelRequire("ddxDA");

var $7veda = parcelRequire("7veda");
function $9a6b213a2be2821b$export$6610512821c8a4ce(href, rel) {
    var _document$head;
    // Skip if already preloaded, prefetched, or loaded
    if (document.querySelector(`link[href="${href}"]`) || document.querySelector(`script[src="${href}"]`)) return 0, $ddxDA.noopCleanup;
    const { crossOrigin: crossOrigin } = (0, $7veda.getConfig)();
    const link = document.createElement('link');
    link.rel = rel;
    link.as = 'script';
    if (crossOrigin) link.crossOrigin = crossOrigin;
    link.href = href;
    const profiler = (0, $hrq5I.GlobalReactLooselyLazyProfiler).current;
    let removableListener = null;
    if (profiler) {
        const eventInfo = {
            identifier: href
        };
        const listener = ()=>{
            link.removeEventListener('onload', listener);
            removableListener = null;
            profiler.onLoadComplete(eventInfo);
        };
        link.addEventListener('onload', listener);
        removableListener = listener;
        profiler.onLoadStart(eventInfo);
    }
    (_document$head = document.head) == null || _document$head.appendChild(link);
    return ()=>{
        // Remove the link if it is still in the document head
        if (link.parentNode === document.head) {
            var _document$head2;
            (_document$head2 = document.head) == null || _document$head2.removeChild(link);
        }
        if (removableListener) link.removeEventListener('onload', removableListener);
    };
}

});


parcelRegister("dcUz2", function(module, exports) {

$parcel$export(module.exports, "retry", () => $99d845ced60c5b28$export$9369b12211e1fce4);
const $99d845ced60c5b28$var$calculateDelay = (context, policy)=>{
    const { attempt: attempt } = context;
    const { delay: delay, factor: factor } = policy;
    const retryAttempt = attempt - 1; // Do not use a delay on the first retry, or when the configured delay is 0
    if (retryAttempt === 1 || delay === 0) return 0;
     // Linear factor, like: https://github.com/Polly-Contrib/Polly.Contrib.WaitAndRetry#wait-and-retry-with-linear-back-off
    const add = factor * delay;
    return delay + add * (retryAttempt - 2);
};
const $99d845ced60c5b28$var$sleep = (delay)=>new Promise((resolve)=>setTimeout(resolve, delay));
const $99d845ced60c5b28$var$getPolicy = (configuration)=>{
    var _configuration$delay, _configuration$factor, _configuration$maxAtt;
    return {
        delay: Math.max(0, (_configuration$delay = configuration.delay) != null ? _configuration$delay : 0),
        factor: Math.max(0, (_configuration$factor = configuration.factor) != null ? _configuration$factor : 0),
        maxAttempts: Math.max(0, (_configuration$maxAtt = configuration.maxAttempts) != null ? _configuration$maxAtt : 0)
    };
};
function $99d845ced60c5b28$export$9369b12211e1fce4(retryable, policyConfiguration = {}) {
    const policy = $99d845ced60c5b28$var$getPolicy(policyConfiguration);
    const { maxAttempts: maxAttempts } = policy;
    const context = {
        attempt: 1,
        attemptsRemaining: maxAttempts
    };
    const onError = async (err)=>{
        if (context.attemptsRemaining === 0) throw err;
        context.attempt += 1;
        context.attemptsRemaining -= 1;
        const delay = $99d845ced60c5b28$var$calculateDelay(context, policy);
        if (delay) await $99d845ced60c5b28$var$sleep(delay);
        return retryable().catch(onError);
    };
    return retryable().catch(onError);
}

});



parcelRegister("8KszW", function(module, exports) {

$parcel$export(module.exports, "composeLinkPicker", () => $eb8046ac18ca72c4$export$922eb685ceb4a294);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");
parcelRequire("bn7wb");
var $7qz8r = parcelRequire("7qz8r");

var $e2B2h = parcelRequire("e2B2h");


var $kunAt = parcelRequire("kunAt");

var $iTs0r = parcelRequire("iTs0r");

var $2HYqy = parcelRequire("2HYqy");

var $Y30qr = parcelRequire("Y30qr");
const $eb8046ac18ca72c4$export$800daf5fbbe96aff = {
    linkPickerRoot: 'link-picker-root'
};
const $eb8046ac18ca72c4$export$a2495bb1f182689d = {
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local",
    componentName: (0, $fb78791935341089$export$fc44104665f4d1e5),
    source: (0, $fb78791935341089$export$fc44104665f4d1e5)
};
const $eb8046ac18ca72c4$var$DefaultRootComponent = ({ children: children })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": $eb8046ac18ca72c4$export$800daf5fbbe96aff.linkPickerRoot,
        children: children
    });
};
const $eb8046ac18ca72c4$var$fixedWidthContainerStyles = null;
const $eb8046ac18ca72c4$var$FixedWidthContainer = (props)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        role: "dialog",
        "aria-modal": "false",
        "aria-label": "link-picker",
        ...props,
        className: (0, $hcewu.default)([
            "_1bsb1ubl"
        ])
    });
};
const $eb8046ac18ca72c4$export$922eb685ceb4a294 = (Component)=>{
    return /*#__PURE__*/ (0, $eJOHy.memo)((props)=>{
        const { component: component } = props;
        const RootComponent = component ?? $eb8046ac18ca72c4$var$DefaultRootComponent;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $e2B2h.default), {
            data: $eb8046ac18ca72c4$export$a2495bb1f182689d,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kunAt.LinkPickerSessionProvider), {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Y30qr.MessagesProvider), {
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                        style: {
                            ['--link-picker-width']: props.disableWidth ? '100%' : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                            `${0, $fb78791935341089$export$bf31a09f182d5584}px`,
                            ['--link-picker-padding-left']: props.paddingLeft ?? "var(--ds-space-200, 16px)",
                            ['--link-picker-padding-right']: props.paddingRight ?? "var(--ds-space-200, 16px)",
                            ['--link-picker-padding-top']: props.paddingTop ?? "var(--ds-space-200, 16px)",
                            ['--link-picker-padding-bottom']: props.paddingBottom ?? "var(--ds-space-200, 16px)"
                        },
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)($eb8046ac18ca72c4$var$FixedWidthContainer, {
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iTs0r.ErrorBoundary), {
                                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7qz8r.LazySuspense), {
                                    fallback: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2HYqy.LoaderFallback), {
                                        url: props.url,
                                        hideDisplayText: props.hideDisplayText,
                                        isLoadingPlugins: props.isLoadingPlugins,
                                        plugins: props.plugins
                                    }),
                                    children: /*#__PURE__*/ (0, $gt9Am.jsx)(RootComponent, {
                                        ...props,
                                        "data-testid": $eb8046ac18ca72c4$export$800daf5fbbe96aff.linkPickerRoot,
                                        children: /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
                                            ...props
                                        })
                                    })
                                })
                            })
                        })
                    })
                })
            })
        });
    });
};

});
const $fb78791935341089$export$85183a312807388d = 'media';
const $fb78791935341089$export$fc44104665f4d1e5 = 'linkPicker';
const $fb78791935341089$export$452f1062ecf44be7 = 5;
const $fb78791935341089$export$bf31a09f182d5584 = 342;
const $fb78791935341089$export$542fb16962bf430c = '290px';

parcelRegister("kunAt", function(module, exports) {

$parcel$export(module.exports, "LinkPickerSessionProvider", () => $a9b0b6ac0f090565$export$2f19832fd2d620ca);
$parcel$export(module.exports, "useLinkPickerSessionId", () => $a9b0b6ac0f090565$export$36ecc935abdc3636);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $aXKmr = parcelRequire("aXKmr");

var $0DWCX = parcelRequire("0DWCX");
const $a9b0b6ac0f090565$export$c07727f5eddb98f = 'SESSION_UNINITIALIZED';
const $a9b0b6ac0f090565$export$3285420c698bc605 = /*#__PURE__*/ (0, $eJOHy.createContext)($a9b0b6ac0f090565$export$c07727f5eddb98f);
const $a9b0b6ac0f090565$var$useConstructor = (callback)=>{
    const hasBeenFired = (0, $eJOHy.useRef)(false);
    if (!hasBeenFired.current) {
        callback();
        hasBeenFired.current = true;
    }
    return null;
};
const $a9b0b6ac0f090565$export$2f19832fd2d620ca = ({ children: children })=>{
    const { current: sessionId } = (0, $eJOHy.useRef)((0, $aXKmr.v4)());
    (0, $eJOHy.useEffect)(()=>{
        return ()=>(0, $0DWCX.abortUfoExperience)((0, $0DWCX.ufoExperience).mounted, sessionId);
    }, [
        sessionId
    ]);
    $a9b0b6ac0f090565$var$useConstructor(()=>(0, $0DWCX.startUfoExperience)((0, $0DWCX.ufoExperience).mounted, sessionId));
    return /*#__PURE__*/ (0, $gt9Am.jsx)($a9b0b6ac0f090565$export$3285420c698bc605.Provider, {
        value: sessionId,
        children: children
    });
};
const $a9b0b6ac0f090565$export$36ecc935abdc3636 = ()=>(0, $eJOHy.useContext)($a9b0b6ac0f090565$export$3285420c698bc605);

});
parcelRegister("0DWCX", function(module, exports) {

$parcel$export(module.exports, "ufoExperience", () => $e323e12dc8ed89b1$export$f9c7780c574346a2);
$parcel$export(module.exports, "startUfoExperience", () => $e323e12dc8ed89b1$export$5e9287b6a10f8075);
$parcel$export(module.exports, "succeedUfoExperience", () => $e323e12dc8ed89b1$export$c5a5cf072c836c0e);
$parcel$export(module.exports, "failUfoExperience", () => $e323e12dc8ed89b1$export$8dda83bafca11b77);
$parcel$export(module.exports, "abortUfoExperience", () => $e323e12dc8ed89b1$export$b1021040eb94cdca);

var $9iIu4 = parcelRequire("9iIu4");
var $aRnO1 = parcelRequire("aRnO1");
const $e323e12dc8ed89b1$export$f9c7780c574346a2 = {
    mounted: 'component-mounted'
};
const $e323e12dc8ed89b1$var$ufoExperiences = {
    [$e323e12dc8ed89b1$export$f9c7780c574346a2.mounted]: new (0, $9iIu4.ConcurrentExperience)($e323e12dc8ed89b1$export$f9c7780c574346a2.mounted, {
        type: (0, $aRnO1.ExperienceTypes).Load,
        performanceType: (0, $aRnO1.ExperiencePerformanceTypes).PageSegmentLoad,
        platform: {
            component: 'link-picker'
        }
    })
};
const $e323e12dc8ed89b1$export$5e9287b6a10f8075 = (experienceName, id, metadata)=>{
    const experience = $e323e12dc8ed89b1$var$ufoExperiences[experienceName].getInstance(id);
    experience.start();
    if (metadata) experience.addMetadata(metadata);
};
const $e323e12dc8ed89b1$export$c5a5cf072c836c0e = (experienceName, id, metadata)=>{
    const experience = $e323e12dc8ed89b1$var$ufoExperiences[experienceName].getInstance(id);
    experience.success({
        metadata: metadata
    });
};
const $e323e12dc8ed89b1$export$8dda83bafca11b77 = (experienceName, id, metadata)=>{
    const experience = $e323e12dc8ed89b1$var$ufoExperiences[experienceName].getInstance(id);
    experience.failure({
        metadata: metadata
    });
};
const $e323e12dc8ed89b1$export$b1021040eb94cdca = (experienceName, id, metadata)=>{
    const experience = $e323e12dc8ed89b1$var$ufoExperiences[experienceName].getInstance(id);
    experience.abort({
        metadata: metadata
    });
};

});


parcelRegister("iTs0r", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $7fe0a641749a590b$export$e926676385687eaf);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $0DWCX = parcelRequire("0DWCX");


var $bTQgK = parcelRequire("bTQgK");

var $kunAt = parcelRequire("kunAt");

var $gR1HW = parcelRequire("gR1HW");

var $66Atn = parcelRequire("66Atn");
function $7fe0a641749a590b$export$e926676385687eaf({ children: children }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const linkPickerSessionId = (0, $kunAt.useLinkPickerSessionId)();
    const handleError = (0, $eJOHy.useCallback)((error, info)=>{
        // Fire Analytics event
        createAnalyticsEvent((0, $bTQgK.default)('ui.linkPicker.unhandledErrorCaught', {
            browserInfo: window?.navigator?.userAgent || 'unknown',
            error: error.toString(),
            componentStack: info?.componentStack ?? ''
        })).fire((0, $fb78791935341089$export$85183a312807388d));
        // Fire UFO failed experience
        (0, $0DWCX.failUfoExperience)((0, $0DWCX.ufoExperience).mounted, linkPickerSessionId);
    }, [
        createAnalyticsEvent,
        linkPickerSessionId
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gR1HW.BaseErrorBoundary), {
        onError: handleError,
        ErrorComponent: (0, $66Atn.ErrorBoundaryFallback),
        children: children
    });
}

});
parcelRegister("bTQgK", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf0e8c7ea1346a5c$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::cd5b926575a5c379425d0d72e5339f12>>
 * @codegenCommand yarn workspace @atlaskit/link-picker run codegen-analytics
 */ function $cf0e8c7ea1346a5c$var$createEventPayload(eventKey, attributes) {
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        action: action,
        attributes: attributes
    };
}
var $cf0e8c7ea1346a5c$export$2e2bcd8739ae039 = $cf0e8c7ea1346a5c$var$createEventPayload;

});

parcelRegister("gR1HW", function(module, exports) {

$parcel$export(module.exports, "BaseErrorBoundary", () => $54f25fcbe7560c46$export$688779ac61ee945f);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
class $54f25fcbe7560c46$export$688779ac61ee945f extends (0, $eJOHy.Component) {
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
    componentDidCatch(error, info) {
        const { onError: onError } = this.props;
        onError && onError(error, info);
        this.setState({
            hasError: true
        });
    }
    render() {
        const { children: children, ErrorComponent: ErrorComponent } = this.props;
        const { hasError: hasError } = this.state;
        if (hasError && ErrorComponent) return /*#__PURE__*/ (0, $gt9Am.jsx)(ErrorComponent, {});
        return children;
    }
}

});

parcelRegister("66Atn", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundaryFallback", () => $57609f69915f526c$export$8a28b7e38e4685dd);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $7qGN1 = parcelRequire("7qGN1");
var $lRq8t = parcelRequire("lRq8t");


var $g4Asp = parcelRequire("g4Asp");

var $1KMXo = parcelRequire("1KMXo");

var $2vTuF = parcelRequire("2vTuF");
const $57609f69915f526c$var$errorBoundaryFallbackStyles = null;
const $57609f69915f526c$var$messages = (0, $7qGN1.defineMessages)({
    heading: {
        defaultMessage: 'Something went wrong!',
        description: 'Heading displayed when an unhandled error occurs.',
        id: 'fabric.linkPicker.unhandledError.heading'
    },
    description: {
        defaultMessage: 'Try reloading the page.',
        description: 'Body message shown underneath the heading when an unhandled error occurs.',
        id: 'fabric.linkPicker.unhandledError.description'
    }
});
const $57609f69915f526c$export$8a28b7e38e4685dd = ()=>{
    const intl = (0, $lRq8t.default)();
    const header = intl.formatMessage($57609f69915f526c$var$messages.heading);
    const description = intl.formatMessage($57609f69915f526c$var$messages.description);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2vTuF.MinHeightContainer), {
        minHeight: (0, $fb78791935341089$export$542fb16962bf430c),
        "data-testid": "link-picker-root-error-boundary-ui",
        className: (0, $hcewu.default)([
            "_11c81vhk"
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1KMXo.EmptyState), {
            header: header,
            renderImage: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $g4Asp.GenericErrorSVG), {}),
            description: description
        })
    });
};

});
parcelRegister("g4Asp", function(module, exports) {

$parcel$export(module.exports, "GenericErrorSVG", () => $db1bd415078f212e$export$e54420a1a27457a4);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $db1bd415078f212e$var$SIZE = 96;
const $db1bd415078f212e$var$genericErrorStyles = null;
const $db1bd415078f212e$export$e54420a1a27457a4 = (props)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
        viewBox: "0 0 96 96",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        className: (0, $hcewu.default)([
            "_1bsb16xz _4t3i16xz _1e0c1ule"
        ]),
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                fill: "#fff",
                d: "M64.861 32.06a27.753 27.753 0 0 0-2.667-4.133 28.187 28.187 0 0 0-3.376-3.669c-6.985-6.311-15.57-6.89-23.609-2.53a30.226 30.226 0 0 0-4.056 2.656 30.624 30.624 0 0 0-3.735 3.4c-6.225 6.717-7.82 15.154-3.505 23.462a28.108 28.108 0 0 0 2.698 4.193 27.67 27.67 0 0 0 3.33 3.62c6.94 6.266 15.518 6.85 23.596 2.507a30.492 30.492 0 0 0 4.23-2.758 30.07 30.07 0 0 0 3.593-3.257c6.252-6.692 7.847-15.161 3.494-23.49h.007Z"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                fill: "#DDDEE1",
                d: "M43.092 66.774c-5.306 0-10.382-1.997-14.75-5.938a30.405 30.405 0 0 1-3.62-3.93 30.243 30.243 0 0 1-2.928-4.553c-4.657-8.961-3.247-18.509 3.871-26.192a33.271 33.271 0 0 1 4.025-3.67 32.834 32.834 0 0 1 4.378-2.869c9.209-4.995 18.816-3.951 26.353 2.86a30.945 30.945 0 0 1 3.665 3.98 30.303 30.303 0 0 1 2.898 4.488c4.705 9.003 3.295 18.565-3.868 26.231a32.148 32.148 0 0 1-3.879 3.515 33.415 33.415 0 0 1-4.562 2.975c-3.858 2.073-7.782 3.1-11.583 3.1v.003Zm2.53-45.486c-3.019 0-6.147.84-9.275 2.54a28.433 28.433 0 0 0-3.735 2.448 28.059 28.059 0 0 0-3.442 3.135c-5.746 6.203-6.86 13.566-3.135 20.736a25.395 25.395 0 0 0 2.472 3.83 25.304 25.304 0 0 0 3.044 3.309c5.99 5.41 13.398 6.182 20.862 2.175a28.02 28.02 0 0 0 3.899-2.545 28.03 28.03 0 0 0 3.31-2.999c5.777-6.182 6.883-13.552 3.124-20.75a25.553 25.553 0 0 0-2.44-3.777 25.848 25.848 0 0 0-3.087-3.358c-3.49-3.153-7.442-4.744-11.59-4.744h-.006Z"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                fill: "#DDDEE1",
                d: "M62.822 59.694c-1.235-1.72-2.562-1.71-3.857-.708-1.215.939-1.54 2.21-.244 3.882l1.48 1.913 4.102-3.174-1.48-1.913Z"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                fill: "#DDDEE1",
                d: "m65.334 60.811-6.159 4.762L70.748 80.54l6.16-4.761L65.333 60.81Z"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                fill: "#B7B9BE",
                d: "m64.344 61.577-4.178 3.23 3.925 5.076 4.178-3.23-3.925-5.076Z"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                fill: "#DDDEE1",
                fillRule: "evenodd",
                d: "M55.057 33.452 36.213 52.296l-2.468-2.469 18.844-18.844 2.468 2.469Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                fill: "#DDDEE1",
                fillRule: "evenodd",
                d: "M52.589 52.296 33.745 33.452l2.468-2.469 18.844 18.844-2.468 2.469Z",
                clipRule: "evenodd"
            })
        ]
    });
};

});

parcelRegister("1KMXo", function(module, exports) {

$parcel$export(module.exports, "EmptyState", () => $dc4e666f89d05f99$export$fddf379e22a74b00);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $806LH = parcelRequire("806LH");

var $2sLVw = parcelRequire("2sLVw");
var $3cMgR = parcelRequire("3cMgR");
const $dc4e666f89d05f99$var$styles = {
    containerV2: "_ca0q1ejb _u5f3oahv _19bvoahv _n3td1jfw _y3gn1h6o"
};
const $dc4e666f89d05f99$export$fddf379e22a74b00 = ({ testId: testId, header: header, description: description, action: action, renderImage: renderImage })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $2sLVw.default), {
        xcss: $dc4e666f89d05f99$var$styles.containerV2,
        testId: testId,
        direction: "column",
        alignItems: "center",
        gap: "space.200",
        children: [
            renderImage?.(),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $806LH.default), {
                size: "small",
                as: "h2",
                children: header
            }),
            description && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                as: "p",
                color: "color.text",
                children: description
            }),
            action && action
        ]
    });
};

});

parcelRegister("2vTuF", function(module, exports) {

$parcel$export(module.exports, "MinHeightContainer", () => $536fd4b57d015f9b$export$42134e2a251518b3);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");
const $536fd4b57d015f9b$var$minHeightComponentStyles = null;
const $536fd4b57d015f9b$export$42134e2a251518b3 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ className: className, minHeight: minHeight, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1fhb _1bah1h6o _1tke16li",
            className
        ]),
        ...props,
        style: {
            ['--link-picker-min-height']: minHeight
        }
    });
});

});



parcelRegister("2HYqy", function(module, exports) {

$parcel$export(module.exports, "LoaderFallback", () => $1add3bb7eb9fa4e2$export$d96e921133238c41);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $7ep4S = parcelRequire("7ep4S");

var $2vTuF = parcelRequire("2vTuF");
const $1add3bb7eb9fa4e2$var$styles = null;
const $1add3bb7eb9fa4e2$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITHOUT_DISPLAYTEXT = '495px';
const $1add3bb7eb9fa4e2$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITH_DISPLAYTEXT = '590px';
const $1add3bb7eb9fa4e2$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITH_DISPLAYTEXT = '545px';
const $1add3bb7eb9fa4e2$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITHOUT_DISPLAYTEXT = '450px';
const $1add3bb7eb9fa4e2$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_DISPLAYTEXT = '252px';
const $1add3bb7eb9fa4e2$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITHOUT_DISPLAYTEXT = '155px';
const $1add3bb7eb9fa4e2$var$getEstimatedMinHeight = ({ hideDisplayText: hideDisplayText, isLoadingPlugins: isLoadingPlugins, plugins: plugins, url: url })=>{
    /**
   * "Insert mode" (search results shown initially)
   */ if (!url) {
        /**
     * With tabs
     */ if (plugins && plugins.length > 1 || isLoadingPlugins) return hideDisplayText ? $1add3bb7eb9fa4e2$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITHOUT_DISPLAYTEXT : $1add3bb7eb9fa4e2$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITH_DISPLAYTEXT;
        /**
     * Without tabs
     */ if (plugins?.length === 1) return hideDisplayText ? $1add3bb7eb9fa4e2$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITHOUT_DISPLAYTEXT : $1add3bb7eb9fa4e2$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITH_DISPLAYTEXT;
    }
    return hideDisplayText ? $1add3bb7eb9fa4e2$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITHOUT_DISPLAYTEXT : $1add3bb7eb9fa4e2$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_DISPLAYTEXT;
};
const $1add3bb7eb9fa4e2$export$d96e921133238c41 = (props)=>{
    const minHeight = $1add3bb7eb9fa4e2$var$getEstimatedMinHeight(props);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2vTuF.MinHeightContainer), {
        minHeight: minHeight,
        "data-testid": "link-picker-root-loader-boundary-ui",
        className: (0, $hcewu.default)([
            "_4cvr1h6o"
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {
            testId: "link-picker.component-loading-indicator",
            interactionName: props.name || 'link-picker-loading',
            size: "medium"
        })
    });
};

});

parcelRegister("Y30qr", function(module, exports) {

$parcel$export(module.exports, "MessagesProvider", () => $aa70be8195ee421d$export$54320b51a950d54a);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $34dxJ = parcelRequire("34dxJ");
const $aa70be8195ee421d$export$54320b51a950d54a = ({ children: children })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $34dxJ.LazyMessagesProvider), {
        children: children
    });
};

});
parcelRegister("34dxJ", function(module, exports) {

$parcel$export(module.exports, "LazyMessagesProvider", () => $0ac74dc6ffe13f36$export$d013d33430f9fb4b);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $3JwXA = parcelRequire("3JwXA");

var $5fDnW = parcelRequire("5fDnW");

var $cyJCq = parcelRequire("cyJCq");
const $0ac74dc6ffe13f36$export$d013d33430f9fb4b = ({ children: children })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3JwXA.default), {
        defaultMessages: (0, $5fDnW.default),
        loaderFn: (0, $cyJCq.fetchMessagesForLocale),
        children: children
    });
};

});
parcelRegister("5fDnW", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $5d97aea06f1eadff$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $5d97aea06f1eadff$export$2e2bcd8739ae039 = {
    'fabric.linkPicker.button.cancel': 'Cancel',
    'fabric.linkPicker.button.insert': 'Insert',
    'fabric.linkPicker.button.save': 'Save',
    'fabric.linkPicker.clearLink': 'Clear',
    'fabric.linkPicker.clearLinkText': 'Clear text',
    'fabric.linkPicker.hyperlink.searchLinkResults': '{count, plural, =0 {no results} one {# result} other {# results}} found',
    'fabric.linkPicker.linkAriaLabel': 'Type or paste a link into the field',
    'fabric.linkPicker.linkHelperTextAriaLabel': 'Link display helper text',
    'fabric.linkPicker.linkHelperTextLabel': 'Give this link a title or description',
    'fabric.linkPicker.linkInvalid': 'Enter a valid URL.',
    'fabric.linkPicker.linkLabel': 'Link',
    'fabric.linkPicker.linkPlaceholder': 'Paste a link',
    'fabric.linkPicker.linkTextAriaLabel': 'Link display text',
    'fabric.linkPicker.linkTextLabel': 'Display text (optional)',
    'fabric.linkPicker.linkTextPlaceholder': 'Text to display',
    'fabric.linkPicker.listTitle.recentlyViewed': 'Recently Viewed',
    'fabric.linkPicker.listTitle.results': 'Results',
    'fabric.linkPicker.noEmbed': "Embed view isn't supported for this link. <a>More about why some Smart Links don't display content.</a>",
    'fabric.linkPicker.search.error.description': 'Refresh the page, or contact <a>Atlassian Support</a> if this keeps happening.',
    'fabric.linkPicker.search.error.heading': "We\u2019re having trouble loading data.",
    'fabric.linkPicker.search.error.retry': 'Refresh',
    'fabric.linkPicker.search.linkAriaLabel': 'Suggestions will appear below as you type into the field',
    'fabric.linkPicker.search.linkLabel': 'Search or paste a link',
    'fabric.linkPicker.search.linkPlaceholder': 'Find recent links or paste a new link',
    'fabric.linkPicker.search.noResults.description': 'Try again with a different term.',
    'fabric.linkPicker.search.noResults.heading': "We couldn\u2019t find anything matching your search.",
    'fabric.linkPicker.status.submitting': 'Submitting',
    'fabric.linkPicker.time.message.updated': 'Updated {time}',
    'fabric.linkPicker.time.message.viewed': 'Viewed {time}',
    'fabric.linkPicker.unhandledError.description': 'Try reloading the page.',
    'fabric.linkPicker.unhandledError.heading': 'Something went wrong!',
    foo: 'Default string'
};

});

parcelRegister("cyJCq", function(module, exports) {

$parcel$export(module.exports, "fetchMessagesForLocale", () => $7da9184eca175e75$export$2b153a2030b0feb2);

var $4NLTA = parcelRequire("4NLTA");
const $7da9184eca175e75$export$2b153a2030b0feb2 = async (locale)=>{
    try {
        const localeKey = locale.replace('-', '_');
        if (localeKey in (0, $4NLTA.locales)) {
            const messages = await (0, $4NLTA.locales)[localeKey]();
            return messages.default;
        }
    } catch (e) {
    // ignore
    }
    try {
        const parentLocale = locale.split(/[-_]/)[0];
        if (parentLocale in (0, $4NLTA.locales)) {
            const messages = await (0, $4NLTA.locales)[parentLocale]();
            return messages.default;
        }
    } catch (e) {
    // ignore
    }
};

});
parcelRegister("4NLTA", function(module, exports) {

$parcel$export(module.exports, "locales", () => $25f2380afca4a4c7$export$df1c34db1371eeed);

























const $25f2380afca4a4c7$export$df1c34db1371eeed = {
    cs: ()=>(parcelRequire("37GMS")),
    da: ()=>(parcelRequire("XuPKw")),
    de: ()=>(parcelRequire("8pvPC")),
    en_GB: ()=>(parcelRequire("4IPt4")),
    en_ZZ: ()=>(parcelRequire("iJQqr")),
    en: ()=>Promise.resolve((parcelRequire("5fDnW"))),
    es: ()=>(parcelRequire("bxkfe")),
    fi: ()=>(parcelRequire("dhQaM")),
    fr: ()=>(parcelRequire("gRfsj")),
    hu: ()=>(parcelRequire("3OIWw")),
    it: ()=>(parcelRequire("aWr00")),
    ja: ()=>(parcelRequire("7Kw8I")),
    ko: ()=>(parcelRequire("2BgcM")),
    nb: ()=>(parcelRequire("lHOiT")),
    nl: ()=>(parcelRequire("iKXH0")),
    pl: ()=>(parcelRequire("1MaO2")),
    pt_BR: ()=>(parcelRequire("SsX7Y")),
    ru: ()=>(parcelRequire("19E9N")),
    sv: ()=>(parcelRequire("cMsd1")),
    th: ()=>(parcelRequire("db06c")),
    tr: ()=>(parcelRequire("iWI1j")),
    uk: ()=>(parcelRequire("26Np2")),
    vi: ()=>(parcelRequire("h7iFu")),
    zh_TW: ()=>(parcelRequire("awkLL")),
    zh: ()=>(parcelRequire("ipUwg"))
};

});
parcelRegister("37GMS", function(module, exports) {

let $2463373876685e8c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $2463373876685e8c$var$load("4Lzx5").then(()=>parcelRequire('fFjBZ'));

});

parcelRegister("XuPKw", function(module, exports) {

let $0b2d6dba2da6a412$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $0b2d6dba2da6a412$var$load("knDxd").then(()=>parcelRequire('91VcN'));

});

parcelRegister("8pvPC", function(module, exports) {

let $61f9599de47805bf$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $61f9599de47805bf$var$load("hU95F").then(()=>parcelRequire('5lo1V'));

});

parcelRegister("4IPt4", function(module, exports) {

let $370331f3dfce2c9e$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $370331f3dfce2c9e$var$load("1crI1").then(()=>parcelRequire('ARD7U'));

});

parcelRegister("iJQqr", function(module, exports) {

let $da451895506fce45$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $da451895506fce45$var$load("ahwzx").then(()=>parcelRequire('4FORW'));

});

parcelRegister("bxkfe", function(module, exports) {

let $86627aee58971c55$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $86627aee58971c55$var$load("jMWm4").then(()=>parcelRequire('953q9'));

});

parcelRegister("dhQaM", function(module, exports) {

let $9ac555592adc476f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $9ac555592adc476f$var$load("1WWCk").then(()=>parcelRequire('lQ21i'));

});

parcelRegister("gRfsj", function(module, exports) {

let $c45d95c5660b218e$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $c45d95c5660b218e$var$load("gEXZZ").then(()=>parcelRequire('1TJcy'));

});

parcelRegister("3OIWw", function(module, exports) {

let $2c78e753ad05a77f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $2c78e753ad05a77f$var$load("jzNYH").then(()=>parcelRequire('4PDkD'));

});

parcelRegister("aWr00", function(module, exports) {

let $7f74439fe408bcd6$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $7f74439fe408bcd6$var$load("gJH9A").then(()=>parcelRequire('7bAD1'));

});

parcelRegister("7Kw8I", function(module, exports) {

let $5a45c286b3b50aa3$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $5a45c286b3b50aa3$var$load("3nrLK").then(()=>parcelRequire('2wbVn'));

});

parcelRegister("2BgcM", function(module, exports) {

let $1e4b9b7940c17a35$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $1e4b9b7940c17a35$var$load("5bANX").then(()=>parcelRequire('dF97w'));

});

parcelRegister("lHOiT", function(module, exports) {

let $fcd4a26bfe9a1ce6$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $fcd4a26bfe9a1ce6$var$load("hFl5P").then(()=>parcelRequire('gusPx'));

});

parcelRegister("iKXH0", function(module, exports) {

let $da7ad39342e2d97b$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $da7ad39342e2d97b$var$load("diwMv").then(()=>parcelRequire('fSNMI'));

});

parcelRegister("1MaO2", function(module, exports) {

let $14b2a805814ee880$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $14b2a805814ee880$var$load("agyBn").then(()=>parcelRequire('jMzOa'));

});

parcelRegister("SsX7Y", function(module, exports) {

let $0a3b80a85a674b11$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $0a3b80a85a674b11$var$load("du1Vi").then(()=>parcelRequire('jeFMu'));

});

parcelRegister("19E9N", function(module, exports) {

let $0d75c80838503118$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $0d75c80838503118$var$load("Lui6s").then(()=>parcelRequire('bfFnE'));

});

parcelRegister("cMsd1", function(module, exports) {

let $0266b50e33b07242$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $0266b50e33b07242$var$load("gS7xS").then(()=>parcelRequire('i4tNv'));

});

parcelRegister("db06c", function(module, exports) {

let $997c61167692be37$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $997c61167692be37$var$load("5tsMc").then(()=>parcelRequire('3yZiu'));

});

parcelRegister("iWI1j", function(module, exports) {

let $dcafca40e87d20c9$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $dcafca40e87d20c9$var$load("2qq9U").then(()=>parcelRequire('iLucK'));

});

parcelRegister("26Np2", function(module, exports) {

let $189276aa8d52da15$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $189276aa8d52da15$var$load("3QtHi").then(()=>parcelRequire('8owvt'));

});

parcelRegister("h7iFu", function(module, exports) {

let $c7619235a3716f2c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $c7619235a3716f2c$var$load("aUfCR").then(()=>parcelRequire('4wLiD'));

});

parcelRegister("awkLL", function(module, exports) {

let $7a8d00ecd468604b$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $7a8d00ecd468604b$var$load("2ssec").then(()=>parcelRequire('hfCab'));

});

parcelRegister("ipUwg", function(module, exports) {

let $d68667647297c140$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $d68667647297c140$var$load("bLXUG").then(()=>parcelRequire('7xB1Z'));

});






parcelRegister("wVjWF", function(module, exports) {

let $062f73f846d85318$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $062f73f846d85318$var$load("kNFvF"),
    $062f73f846d85318$var$load("ffQaD"),
    $062f73f846d85318$var$load("kvRbA"),
    $062f73f846d85318$var$load("9g10b")
]).then(()=>parcelRequire('8lrXP'));

});


parcelRegister("5x7vO", function(module, exports) {

$parcel$export(module.exports, "useEscapeClickaway", () => $12fe35c4feeff506$export$886f2fdec3f419af);

var $eJOHy = parcelRequire("eJOHy");
const $12fe35c4feeff506$export$886f2fdec3f419af = (/** Callback to fire when the user presses the escape key */ onEscape, /** Callback to fire when the user clicks an element not contained by the ref */ onClickAway)=>{
    const ref = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useEffect)(()=>{
        const handleClickAway = (event)=>{
            const el = ref.current;
            if (event.target instanceof Element && el && !el.contains(event.target)) onClickAway();
        };
        const handleKeydown = (event)=>{
            if (event.key === 'Escape') {
                event.preventDefault();
                onEscape();
            }
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.addEventListener('mousedown', handleClickAway);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.addEventListener('keydown', handleKeydown);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('mousedown', handleClickAway);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('keydown', handleKeydown);
        };
    }, [
        onClickAway,
        onEscape
    ]);
    return ref;
};

});


parcelRegister("4DYEn", function(module, exports) {

$parcel$export(module.exports, "default", () => $95022feab3ab1638$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $3s8bj = parcelRequire("3s8bj");

var $aQK2r = parcelRequire("aQK2r");

var $7qGN1 = parcelRequire("7qGN1");
var $6YFG2 = parcelRequire("6YFG2");

var $iKozC = parcelRequire("iKozC");

var $4J0ad = parcelRequire("4J0ad");

var $fk1hB = parcelRequire("fk1hB");

var $kXEdL = parcelRequire("kXEdL");

var $bQP4O = parcelRequire("bQP4O");
var $1DXK0 = parcelRequire("1DXK0");

var $k71qx = parcelRequire("k71qx");

var $bMFKb = parcelRequire("bMFKb");
var $cd124 = parcelRequire("cd124");

var $bQBk1 = parcelRequire("bQBk1");
var $8VBqs = parcelRequire("8VBqs");

var $7EdFW = parcelRequire("7EdFW");
var $grDTV = parcelRequire("grDTV");

var $9sG1M = parcelRequire("9sG1M");

var $b2d9j = parcelRequire("b2d9j");

var $gKQQp = parcelRequire("gKQQp");

var $84M54 = parcelRequire("84M54");
function $95022feab3ab1638$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $95022feab3ab1638$export$8dd524ceb40e3d16 = {
    name: "19nbz8q",
    styles: "clip:rect(1px, 1px, 1px, 1px);clip-path:inset(50%);height:1px;width:1px;margin:var(--ds-space-negative-025, -2px);overflow:hidden;padding:0;position:absolute"
};
const $95022feab3ab1638$export$452f1062ecf44be7 = 5;
const $95022feab3ab1638$var$clearTextButtonStyles = (0, $1DXK0.xcss)({
    padding: 'space.0',
    marginRight: 'space.100',
    backgroundColor: 'color.background.neutral.subtle',
    border: 'none'
});
const $95022feab3ab1638$var$clearTextWrapper = {
    name: "154v9b4",
    styles: "position:absolute;right:0"
};
const $95022feab3ab1638$var$containerPadding = /*#__PURE__*/ (0, $1NIU8.css)({
    padding: `${"var(--ds-space-150, 12px)"} ${"var(--ds-space-100, 8px)"}`
});
const $95022feab3ab1638$var$textLabelMargin = {
    name: "1s21os8",
    styles: "margin-top:var(--ds-space-150, 12px)"
};
const $95022feab3ab1638$var$inputLabel = {
    name: "1ta6p52",
    styles: "color:var(--ds-text-subtlest, #626F86);padding-bottom:var(--ds-space-050, 4px);font:var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);font-weight:var(--ds-font-weight-medium, 500)"
};
const $95022feab3ab1638$var$inputWrapperPosition = {
    name: "bjn8wh",
    styles: "position:relative"
};
const $95022feab3ab1638$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    displayText: {
        id: 'fabric.editor.displayText',
        defaultMessage: 'Text to display',
        description: 'Text to display'
    },
    clearText: {
        id: 'fabric.editor.clearLinkText',
        defaultMessage: 'Clear text',
        description: 'Clears text on the link toolbar'
    },
    clearLink: {
        id: 'fabric.editor.clearLink',
        defaultMessage: 'Clear link',
        description: 'Clears link in the link toolbar'
    },
    searchLinkAriaDescription: {
        id: 'fabric.editor.hyperlink.searchLinkAriaDescription',
        defaultMessage: 'Suggestions will appear below as you type into the field',
        description: 'Describes what the search field does for screen reader users.'
    },
    searchLinkResults: {
        id: 'fabric.editor.hyperlink.searchLinkResults',
        defaultMessage: '{count, plural, =0 {no results} one {# result} other {# results}} found',
        description: 'Announce search results for screen-reader users.'
    },
    linkVisibleLabel: {
        id: 'fabric.editor.hyperlink.linkVisibleLabel',
        defaultMessage: 'Paste or search for link',
        description: 'Visible label for link input in hyperlink floating control'
    },
    textVisibleLabel: {
        id: 'fabric.editor.hyperlink.textVisibleLabel',
        defaultMessage: 'Display text (optional)',
        description: 'Visible label for text input in hyperlink floating control'
    }
});
const $95022feab3ab1638$var$defaultIcon = /*#__PURE__*/ (0, $1NIU8.jsx)((0, $fk1hB.default), {
    label: 'page'
});
const $95022feab3ab1638$var$mapActivityProviderResultToLinkSearchItemData = ({ name: name, container: container, iconUrl: iconUrl, objectId: objectId, url: url, viewedTimestamp: viewedTimestamp })=>({
        objectId: objectId,
        name: name,
        container: container,
        iconUrl: iconUrl,
        url: url,
        lastViewedDate: viewedTimestamp ? new Date(viewedTimestamp) : undefined,
        prefetch: true
    });
const $95022feab3ab1638$var$mapSearchProviderResultToLinkSearchItemData = ({ objectId: objectId, container: container, title: title, contentType: contentType, url: url, updatedTimestamp: updatedTimestamp })=>({
        objectId: objectId,
        container: container,
        name: title,
        url: url,
        lastUpdatedDate: updatedTimestamp ? new Date(updatedTimestamp) : undefined,
        icon: contentType && (0, $84M54.mapContentTypeToIcon)[contentType] || $95022feab3ab1638$var$defaultIcon,
        prefetch: false
    });
class $95022feab3ab1638$export$7acbf008e0847b89 extends (0, $eJOHy.PureComponent) {
    constructor(props){
        super(props), /* To prevent double submit */ this.submitted = false, this.urlInputContainer = null, this.displayTextInputContainer = null, this.wrapperRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createRef(), this.quickSearchQueryVersion = 0, this.analyticSource = 'createLinkInlineDialog', this.quickSearch = async (input, items, quickSearchLimit)=>{
            const { searchProvider: searchProvider, displayUrl: displayUrl } = this.state;
            const { searchSessionId: searchSessionId } = this.props;
            if (!searchProvider) return;
            const queryVersion = ++this.quickSearchQueryVersion;
            this.fireAnalytics({
                action: (0, $bMFKb.ACTION).ENTERED,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).TEXT,
                actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).LINK_SEARCH_INPUT,
                attributes: {
                    queryLength: input.length,
                    queryVersion: queryVersion,
                    queryHash: (0, $84M54.sha1)(input),
                    searchSessionId: searchSessionId ?? '',
                    wordCount: (0, $84M54.wordCount)(input),
                    source: this.analyticSource
                },
                nonPrivacySafeAttributes: {
                    query: input
                },
                eventType: (0, $bMFKb.EVENT_TYPE).UI
            });
            const perfStart = performance.now();
            try {
                const searchProviderResultItems = await searchProvider.quickSearch(input, quickSearchLimit);
                const searchItems = $95022feab3ab1638$var$limit((0, $84M54.filterUniqueItems)([
                    ...items,
                    ...searchProviderResultItems.map($95022feab3ab1638$var$mapSearchProviderResultToLinkSearchItemData)
                ], (firstItem, secondItem)=>firstItem.objectId === secondItem.objectId));
                if (displayUrl === input && queryVersion === this.quickSearchQueryVersion) this.setState({
                    items: searchItems,
                    isLoading: false
                });
                const perfStop = performance.now();
                const duration = perfStop - perfStart;
                this.fireAnalytics({
                    action: (0, $bMFKb.ACTION).INVOKED,
                    actionSubject: (0, $bMFKb.ACTION_SUBJECT).SEARCH_RESULT,
                    actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).QUICK_SEARCH,
                    attributes: {
                        duration: duration,
                        count: searchProviderResultItems.length
                    },
                    eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL
                });
                this.fireAnalytics({
                    action: (0, $bMFKb.ACTION).SHOWN,
                    actionSubject: (0, $bMFKb.ACTION_SUBJECT).SEARCH_RESULT,
                    actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).POST_QUERY_SEARCH_RESULTS,
                    attributes: {
                        source: this.analyticSource,
                        postQueryRequestDurationMs: duration,
                        searchSessionId: searchSessionId ?? '',
                        resultCount: searchProviderResultItems.length,
                        results: searchProviderResultItems.map((item)=>({
                                resultContentId: item.objectId,
                                resultType: item.contentType
                            }))
                    },
                    eventType: (0, $bMFKb.EVENT_TYPE).UI
                });
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (err) {
                const perfStop = performance.now();
                const duration = perfStop - perfStart;
                this.fireAnalytics({
                    action: (0, $bMFKb.ACTION).INVOKED,
                    actionSubject: (0, $bMFKb.ACTION_SUBJECT).SEARCH_RESULT,
                    actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).QUICK_SEARCH,
                    attributes: {
                        duration: duration,
                        count: -1,
                        errorCode: err.status
                    },
                    eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL
                });
            }
        }, this.updateInput = async (input)=>{
            const { activityProvider: activityProvider, searchProvider: searchProvider } = this.state;
            this.setState({
                displayUrl: input
            });
            if (activityProvider) {
                if (input.length === 0) this.setState({
                    items: await this.getRecentItems(activityProvider),
                    selectedIndex: -1
                });
                else if ((0, $iKozC.isSafeUrl)(input)) this.setState({
                    items: [],
                    selectedIndex: -1,
                    isLoading: false
                });
                else {
                    const items = await this.getRecentItems(activityProvider, input);
                    const shouldQuerySearchProvider = items.length < $95022feab3ab1638$export$452f1062ecf44be7 && !!searchProvider;
                    this.setState({
                        items: items,
                        isLoading: shouldQuerySearchProvider
                    });
                    if (shouldQuerySearchProvider) this.debouncedQuickSearch(input, items, $95022feab3ab1638$export$452f1062ecf44be7);
                }
            }
        }, this.createClearHandler = (field)=>{
            return async ()=>{
                const { activityProvider: activityProvider } = this.state;
                switch(field){
                    case 'displayUrl':
                        this.setState({
                            [field]: '',
                            items: !!activityProvider ? $95022feab3ab1638$var$limit(await activityProvider.getRecentItems()) : []
                        });
                        if (this.urlInputContainer) this.urlInputContainer.focus();
                        break;
                    case 'displayText':
                        this.setState({
                            [field]: ''
                        });
                        if (this.displayTextInputContainer) this.displayTextInputContainer.focus();
                }
            };
        }, this.handleClickOutside = (event)=>{
            if (event.target instanceof Element && this.wrapperRef.current && !this.wrapperRef.current.contains(event.target)) {
                const { view: { state: state, dispatch: dispatch }, onClickAwayCallback: onClickAwayCallback } = this.props;
                onClickAwayCallback?.(state, dispatch);
            }
        }, this.getScreenReaderText = ()=>{
            const { intl: intl } = this.props;
            const { items: items, selectedIndex: selectedIndex } = this.state;
            if (items.length && selectedIndex > -1) {
                const { name: name, container: container, lastUpdatedDate: lastUpdatedDate, lastViewedDate: lastViewedDate } = items[selectedIndex];
                const date = (0, $gKQQp.transformTimeStamp)(intl, lastViewedDate, lastUpdatedDate);
                return `${name}, ${container}, ${date?.pageAction} ${date?.dateString} ${date?.timeSince || ''}`;
            }
        }, this.isUrlPopulatedWithSelectedItem = ()=>{
            /**
     * When we use ArrowKey to navigate through result items,
     * the URL field will be populated with the content of
     * selected item.
     * This function will check if the URL field is populated
     * with selected item.
     * It can be useful to detect whether we want to insert a
     * smartlink or a hyperlink with customized title
     */ const { items: items, selectedIndex: selectedIndex, displayUrl: displayUrl } = this.state;
            const selectedItem = items[selectedIndex];
            if (selectedItem && selectedItem.url === displayUrl) return true;
            return false;
        }, this.handleSelected = (href, text)=>{
            this.handleInsert(href, text, (0, $bMFKb.INPUT_METHOD).TYPEAHEAD, 'click');
        }, this.handleInsert = (href, title, inputType, interaction)=>{
            const { searchSessionId: searchSessionId, onSubmit: onSubmit } = this.props;
            const { items: items, selectedIndex: selectedIndex, displayText: displayText } = this.state;
            if (onSubmit) {
                this.submitted = true;
                onSubmit(href, title, displayText, inputType);
            }
            if (interaction === 'click' || this.isUrlPopulatedWithSelectedItem()) {
                /**
       * When it's a mouse click even or the selectedItem.url matches displayUrl, we think
       * it's selected from the result list and fire the
       * analytic
       */ const selectedItem = items[selectedIndex];
                this.fireAnalytics({
                    action: (0, $bMFKb.ACTION).SELECTED,
                    actionSubject: (0, $bMFKb.ACTION_SUBJECT).SEARCH_RESULT,
                    attributes: {
                        source: this.analyticSource,
                        searchSessionId: searchSessionId ?? '',
                        trigger: interaction,
                        resultCount: items.length,
                        selectedResultId: selectedItem.objectId,
                        selectedRelativePosition: selectedIndex,
                        prefetch: selectedItem.prefetch ?? false
                    },
                    eventType: (0, $bMFKb.EVENT_TYPE).UI
                });
            }
        }, this.handleMouseEnterResultItem = (objectId)=>{
            const { items: items } = this.state;
            const index = $95022feab3ab1638$var$findIndex(items, (item)=>item.objectId === objectId);
            this.setState({
                selectedIndex: index
            });
        }, this.handleMouseLeaveResultItem = (objectId)=>{
            const { items: items, selectedIndex: selectedIndex } = this.state;
            const index = $95022feab3ab1638$var$findIndex(items, (item)=>item.objectId === objectId);
            // This is to avoid updating index that was set by other mouseenter event
            if (selectedIndex === index) this.setState({
                selectedIndex: -1
            });
        }, this.handleSubmit = ()=>{
            const { displayUrl: displayUrl, selectedIndex: selectedIndex, items: items } = this.state;
            const selectedItem = items[selectedIndex];
            if (this.isUrlPopulatedWithSelectedItem()) this.handleInsert((0, $grDTV.normalizeUrl)(selectedItem.url), selectedItem.name, (0, $bMFKb.INPUT_METHOD).TYPEAHEAD, 'keyboard');
            else if (displayUrl && displayUrl.length > 0) {
                const url = (0, $grDTV.normalizeUrl)(displayUrl);
                if (url) this.handleInsert(url, displayUrl, (0, $bMFKb.INPUT_METHOD).MANUAL, 'notselected');
            }
        }, this.handleClearTextKeyDown = (event)=>{
            const KEY_CODE_TAB = 9;
            const { keyCode: keyCode } = event;
            if (keyCode === KEY_CODE_TAB) {
                if (!this.submitted) {
                    const { displayUrl: displayUrl, displayText: displayText } = this.state;
                    const url = (0, $grDTV.normalizeUrl)(displayUrl);
                    this.handleInsert(url, displayText || displayUrl, (0, $bMFKb.INPUT_METHOD).MANUAL, 'notselected');
                }
                event.preventDefault();
                return;
            }
        }, // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.handleKeyDown = (event)=>{
            const { items: items, selectedIndex: selectedIndex } = this.state;
            const { view: view, onEscapeCallback: onEscapeCallback, searchSessionId: searchSessionId } = this.props;
            const { keyCode: keyCode } = event;
            const KEY_CODE_ESCAPE = 27;
            const KEY_CODE_ARROW_DOWN = 40;
            const KEY_CODE_ARROW_UP = 38;
            if (keyCode === KEY_CODE_ESCAPE) {
                // escape
                event.preventDefault();
                const { state: state, dispatch: dispatch } = view;
                onEscapeCallback?.(state, dispatch);
                return;
            }
            if (!items || !items.length) return;
            let updatedIndex = selectedIndex;
            if (keyCode === KEY_CODE_ARROW_DOWN) {
                // down
                event.preventDefault();
                updatedIndex = (selectedIndex + 1) % items.length;
            } else if (keyCode === KEY_CODE_ARROW_UP) {
                // up
                event.preventDefault();
                updatedIndex = selectedIndex > 0 ? selectedIndex - 1 : items.length - 1;
            }
            if ([
                KEY_CODE_ARROW_DOWN,
                KEY_CODE_ARROW_UP
            ].includes(keyCode) && items[updatedIndex]) {
                this.setState({
                    selectedIndex: updatedIndex,
                    displayUrl: items[updatedIndex].url
                });
                this.fireAnalytics({
                    action: (0, $bMFKb.ACTION).HIGHLIGHTED,
                    actionSubject: (0, $bMFKb.ACTION_SUBJECT).SEARCH_RESULT,
                    attributes: {
                        source: this.analyticSource,
                        searchSessionId: searchSessionId ?? '',
                        selectedResultId: items[updatedIndex].objectId,
                        selectedRelativePosition: updatedIndex
                    },
                    eventType: (0, $bMFKb.EVENT_TYPE).UI
                });
            }
        }, this.updateTextInput = (displayText)=>{
            this.setState({
                displayText: displayText
            });
        }, // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.handleCancel = (e)=>{
            const { view: { state: state, dispatch: dispatch }, onClickAwayCallback: onClickAwayCallback } = this.props;
            e.preventDefault();
            onClickAwayCallback?.(state, dispatch);
        };
        this.state = {
            selectedIndex: -1,
            isLoading: false,
            displayUrl: (0, $grDTV.normalizeUrl)(props.displayUrl),
            displayText: props.displayText,
            items: []
        };
        /* Cache functions */ this.handleClearText = this.createClearHandler('displayUrl');
        this.handleClearDisplayText = this.createClearHandler('displayText');
        this.debouncedQuickSearch = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(this.quickSearch, 400);
        this.fireCustomAnalytics = (0, $cd124.fireAnalyticsEvent)(props.createAnalyticsEvent);
    }
    async componentDidMount() {
        const { timesViewed: timesViewed, inputMethod: inputMethod, searchSessionId: searchSessionId } = this.props;
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.addEventListener('mousedown', this.handleClickOutside);
        this.fireAnalytics({
            action: (0, $bMFKb.ACTION).VIEWED,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).CREATE_LINK_INLINE_DIALOG,
            attributes: {
                timesViewed: timesViewed ?? 0,
                searchSessionId: searchSessionId ?? '',
                trigger: inputMethod ?? ''
            },
            eventType: (0, $bMFKb.EVENT_TYPE).SCREEN
        });
        const [activityProvider, searchProvider] = await Promise.all([
            this.props.activityProvider,
            this.props.searchProvider
        ]);
        // loadInitialLinkSearchResult and updateInput rely on activityProvider being set in state
        (0, $aQK2r.flushSync)(()=>this.setState({
                activityProvider: activityProvider,
                searchProvider: searchProvider
            }));
        await this.loadInitialLinkSearchResult();
    }
    componentWillUnmount() {
        const { searchSessionId: searchSessionId } = this.props;
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.removeEventListener('mousedown', this.handleClickOutside);
        if (!this.submitted) this.fireAnalytics({
            action: (0, $bMFKb.ACTION).DISMISSED,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).CREATE_LINK_INLINE_DIALOG,
            attributes: {
                source: this.analyticSource,
                searchSessionId: searchSessionId ?? '',
                trigger: 'blur'
            },
            eventType: (0, $bMFKb.EVENT_TYPE).UI
        });
    }
    async getRecentItems(activityProvider, query) {
        const { searchSessionId: searchSessionId } = this.props;
        const perfStart = performance.now();
        try {
            const activityRecentItems = $95022feab3ab1638$var$limit(query ? await activityProvider.searchRecent(query) : await activityProvider.getRecentItems());
            const items = activityRecentItems.map($95022feab3ab1638$var$mapActivityProviderResultToLinkSearchItemData);
            const perfStop = performance.now();
            const duration = perfStop - perfStart;
            this.fireAnalytics({
                action: (0, $bMFKb.ACTION).INVOKED,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).SEARCH_RESULT,
                actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).RECENT_ACTIVITIES,
                attributes: {
                    duration: duration,
                    count: items.length
                },
                eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL
            });
            this.fireAnalytics({
                action: (0, $bMFKb.ACTION).SHOWN,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).SEARCH_RESULT,
                actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).PRE_QUERY_SEARCH_RESULTS,
                attributes: {
                    source: this.analyticSource,
                    preQueryRequestDurationMs: duration,
                    searchSessionId: searchSessionId ?? '',
                    resultCount: items.length,
                    results: activityRecentItems.map((item)=>({
                            resultContentId: item.objectId,
                            resultType: item.type ?? ''
                        }))
                },
                eventType: (0, $bMFKb.EVENT_TYPE).UI
            });
            return items;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            const perfStop = performance.now();
            const duration = perfStop - perfStart;
            this.fireAnalytics({
                action: (0, $bMFKb.ACTION).INVOKED,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).SEARCH_RESULT,
                actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).RECENT_ACTIVITIES,
                attributes: {
                    duration: duration,
                    count: -1,
                    errorCode: err.status
                },
                eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL
            });
            return [];
        }
    }
    fireAnalytics(payload) {
        if (this.props.createAnalyticsEvent && this.fireCustomAnalytics) this.fireCustomAnalytics({
            payload: payload
        });
    }
    async loadInitialLinkSearchResult() {
        const { displayUrl: displayUrl, activityProvider: activityProvider } = this.state;
        try {
            if (!displayUrl && activityProvider) {
                this.setState({
                    isLoading: true
                });
                const items = await this.getRecentItems(activityProvider);
                this.setState({
                    items: items
                });
            }
        } finally{
            this.setState({
                isLoading: false
            });
        }
    }
    render() {
        const { items: items, isLoading: isLoading, selectedIndex: selectedIndex, displayUrl: displayUrl, displayText: displayText } = this.state;
        const { intl: { formatMessage: formatMessage }, activityProvider: activityProvider } = this.props;
        const formatClearLinkText = formatMessage($95022feab3ab1638$export$defe85febe8b728c.clearLink);
        const screenReaderDescriptionId = 'search-recent-links-field-description';
        const linkSearchListId = 'hyperlink-search-list';
        const ariaActiveDescendant = selectedIndex > -1 ? `link-search-list-item-${selectedIndex}` : '';
        const linkSearchInputId = 'search-recent-links-field-id';
        const displayTextInputId = 'display-text-filed-id';
        // Added workaround with a screen reader Announcer specifically for VoiceOver + Safari
        // as the Aria design pattern for combobox does not work in this case
        // for details: https://a11y-internal.atlassian.net/browse/AK-740
        const screenReaderText = (0, $7EdFW.browser).safari && this.getScreenReaderText();
        return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            "aria-label": "Hyperlink Edit",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "recent-list",
            "data-testid": "hyperlink-add-toolbar"
        }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            css: [
                (0, $b2d9j.container),
                !!activityProvider && (0, $b2d9j.containerWithProvider),
                $95022feab3ab1638$var$containerPadding
            ],
            ref: this.wrapperRef
        }, /*#__PURE__*/ (0, $1NIU8.jsx)("label", {
            htmlFor: linkSearchInputId,
            css: $95022feab3ab1638$var$inputLabel
        }, formatMessage($95022feab3ab1638$export$defe85febe8b728c.linkVisibleLabel)), /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            css: [
                (0, $b2d9j.inputWrapper),
                $95022feab3ab1638$var$inputWrapperPosition
            ]
        }, screenReaderText && /*#__PURE__*/ (0, $1NIU8.jsx)((0, $bQBk1.default), {
            ariaLive: "assertive",
            text: screenReaderText,
            ariaRelevant: "additions",
            delay: 250
        }), /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            css: $95022feab3ab1638$export$8dd524ceb40e3d16,
            "aria-hidden": "true",
            id: screenReaderDescriptionId
        }, formatMessage($95022feab3ab1638$export$defe85febe8b728c.searchLinkAriaDescription)), /*#__PURE__*/ (0, $1NIU8.jsx)((0, $8VBqs.default), {
            role: "combobox",
            ariaExpanded: true,
            ariaActiveDescendant: ariaActiveDescendant,
            ariaControls: linkSearchListId,
            ariaAutoComplete: true,
            describedById: screenReaderDescriptionId,
            ref: (ele)=>this.urlInputContainer = ele,
            testId: 'link-url',
            onSubmit: this.handleSubmit,
            onChange: this.updateInput,
            autoFocus: {
                preventScroll: true
            },
            onCancel: this.handleCancel,
            defaultValue: displayUrl,
            onKeyDown: this.handleKeyDown,
            inputId: linkSearchInputId
        }), displayUrl && /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            css: $95022feab3ab1638$var$clearTextWrapper
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $k71qx.default), {
            content: formatClearLinkText
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $bQP4O.default), {
            xcss: $95022feab3ab1638$var$clearTextButtonStyles,
            onClick: this.handleClearText
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kXEdL))), {
            label: formatClearLinkText,
            color: "var(--ds-icon-subtle, #626F86)"
        }))))), /*#__PURE__*/ (0, $1NIU8.jsx)("label", {
            htmlFor: displayTextInputId,
            css: [
                $95022feab3ab1638$var$inputLabel,
                $95022feab3ab1638$var$textLabelMargin
            ]
        }, formatMessage($95022feab3ab1638$export$defe85febe8b728c.textVisibleLabel)), /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            css: [
                (0, $b2d9j.inputWrapper),
                $95022feab3ab1638$var$inputWrapperPosition
            ]
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $8VBqs.default), {
            ref: (ele)=>this.displayTextInputContainer = ele,
            testId: 'link-text',
            onChange: this.updateTextInput,
            onCancel: this.handleCancel,
            defaultValue: displayText,
            onSubmit: this.handleSubmit,
            onKeyDown: this.handleKeyDown,
            inputId: displayTextInputId
        }), displayText && /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            css: $95022feab3ab1638$var$clearTextWrapper
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $k71qx.default), {
            content: formatMessage($95022feab3ab1638$export$defe85febe8b728c.clearText)
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $bQP4O.default), {
            xcss: $95022feab3ab1638$var$clearTextButtonStyles,
            onClick: this.handleClearDisplayText,
            onKeyDown: this.handleClearTextKeyDown
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kXEdL))), {
            label: formatMessage($95022feab3ab1638$export$defe85febe8b728c.clearText),
            color: "var(--ds-icon-subtle, #626F86)"
        }))))), /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            css: $95022feab3ab1638$export$8dd524ceb40e3d16,
            "aria-live": "polite",
            "aria-atomic": "true",
            id: "fabric.editor.hyperlink.suggested.results"
        }, displayUrl && formatMessage($95022feab3ab1638$export$defe85febe8b728c.searchLinkResults, {
            count: items.length
        })), /*#__PURE__*/ (0, $1NIU8.jsx)((0, $9sG1M.default), {
            ariaControls: "fabric.editor.hyperlink.suggested.results",
            id: linkSearchListId,
            role: "listbox",
            items: items,
            isLoading: isLoading,
            selectedIndex: selectedIndex,
            onSelect: this.handleSelected,
            onMouseEnter: this.handleMouseEnterResultItem,
            onMouseLeave: this.handleMouseLeaveResultItem
        })));
    }
}
function $95022feab3ab1638$var$findIndex(array, predicate) {
    let index = -1;
    array.some((item, i)=>{
        if (predicate(item)) {
            index = i;
            return true;
        }
        return false;
    });
    return index;
}
function $95022feab3ab1638$var$limit(items) {
    return items.slice(0, $95022feab3ab1638$export$452f1062ecf44be7);
}
const $95022feab3ab1638$export$527bb787d3e8324e = (0, $6YFG2.default)($95022feab3ab1638$export$7acbf008e0847b89);
var $95022feab3ab1638$export$2e2bcd8739ae039 = (0, $4J0ad.default)()($95022feab3ab1638$export$527bb787d3e8324e);

});
parcelRegister("fk1hB", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2dc89233b1e272e$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::79077d9339ad2083a3901f522ad14f6b>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $1WryD = parcelRequire("1WryD");

var $DtmfJ = parcelRequire("DtmfJ");

var $eGOwo = parcelRequire("eGOwo");

var $5NsmF = parcelRequire("5NsmF");
/**
 * __16px `page` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $a2dc89233b1e272e$var$Page16Icon = ({ label: label, testId: testId })=>{
    if ((0, $eGOwo.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1WryD.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($DtmfJ))),
        appearance: "blueBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5NsmF.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5NsmF.default), {
        label: label,
        testId: testId
    });
};
$a2dc89233b1e272e$var$Page16Icon.displayName = 'Page16Icon';
var $a2dc89233b1e272e$export$2e2bcd8739ae039 = $a2dc89233b1e272e$var$Page16Icon;

});
parcelRegister("5NsmF", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f9962a8e371d8db$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8396146cc2fa60842aed7101fb3015b2>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kxVLD = parcelRequire("kxVLD");
const $8f9962a8e371d8db$var$Page16Icon = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $kxVLD.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m2 3a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2zm0 4a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2z"/></svg>`,
        ...props,
        size: "small"
    });
$8f9962a8e371d8db$var$Page16Icon.displayName = 'Page16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$8f9962a8e371d8db$export$2e2bcd8739ae039 = $8f9962a8e371d8db$var$Page16Icon;

});


parcelRegister("bQBk1", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa18ffb3bef34c1e$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
// Note: Flag 'contentRendered' resolves bug with duplicates messages (NVDA + Firefox)
// https://github.com/nvaccess/nvda/labels/bug%2Fdouble-speaking
let $fa18ffb3bef34c1e$var$timer;
const $fa18ffb3bef34c1e$var$Announcer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ ariaAtomic: ariaAtomic = 'true', ariaLive: ariaLive = 'polite', ariaRelevant: ariaRelevant = 'all', role: role = 'status', text: text = '', delay: delay = 0 }, ref)=>{
    const [contentRendered, setContentRendered] = (0, $eJOHy.useState)(false);
    (0, $eJOHy.useEffect)(()=>{
        clearTimeout($fa18ffb3bef34c1e$var$timer);
        setContentRendered(false);
        $fa18ffb3bef34c1e$var$timer = setTimeout(()=>{
            setContentRendered(true);
        }, delay);
        return ()=>clearTimeout($fa18ffb3bef34c1e$var$timer);
    }, [
        text,
        delay
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "assistive",
        ref: ref,
        role: role,
        "aria-atomic": ariaAtomic,
        "aria-relevant": ariaRelevant,
        "aria-live": ariaLive,
        children: contentRendered && /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
            children: text
        })
    });
});
var $fa18ffb3bef34c1e$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)($fa18ffb3bef34c1e$var$Announcer);

});

parcelRegister("8VBqs", function(module, exports) {

$parcel$export(module.exports, "default", () => $d912f19a48e0ba81$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $7EdFW = parcelRequire("7EdFW");

var $ierDl = parcelRequire("ierDl");
const $d912f19a48e0ba81$var$KeyZCode = 90;
const $d912f19a48e0ba81$var$KeyYCode = 89;
class $d912f19a48e0ba81$export$2e2bcd8739ae039 extends (0, $eJOHy.PureComponent) {
    constructor(props){
        super(props), this.onMouseDown = ()=>{
            const { onMouseDown: onMouseDown } = this.props;
            if (onMouseDown) onMouseDown();
        }, // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onBlur = (e)=>{
            const { onBlur: onBlur } = this.props;
            if (onBlur) onBlur(e);
        }, this.handleChange = ()=>{
            const { onChange: onChange } = this.props;
            if (this.input) this.setState({
                value: this.input.value
            });
            if (onChange && this.input) onChange(this.input.value);
        }, // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.handleKeydown = (e)=>{
            const { onUndo: onUndo, onRedo: onRedo, onSubmit: onSubmit, onCancel: onCancel } = this.props;
            if (e.keyCode === 13 && onSubmit) {
                e.preventDefault(); // Prevent from submitting if an editor is inside a form.
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                onSubmit(this.input.value);
            } else if (e.keyCode === 27 && onCancel) onCancel(e);
            else if (typeof onUndo === 'function' && this.isUndoEvent(e)) {
                e.preventDefault();
                onUndo();
            } else if (typeof onRedo === 'function' && this.isRedoEvent(e)) {
                e.preventDefault();
                onRedo();
            }
            if (this.props.onKeyDown) this.props.onKeyDown(e);
        }, this.handleRef = (input)=>{
            if (input instanceof HTMLInputElement) {
                this.input = input;
                if (this.props.autoFocus) // Need this to prevent jumping when we render TextInput inside Portal @see ED-2992
                this.focusTimeoutId = window.setTimeout(()=>this.focus());
            } else this.input = undefined;
        };
        this.state = {
            value: props.defaultValue || ''
        };
    }
    componentDidUpdate(prevProps) {
        if (prevProps.defaultValue !== this.props.defaultValue) this.setState({
            value: this.props.defaultValue
        });
    }
    componentWillUnmount() {
        window.clearTimeout(this.focusTimeoutId);
    }
    render() {
        const { placeholder: placeholder, width: width, maxLength: maxLength, testId: testId, ariaLabel: ariaLabel, describedById: describedById, ariaActiveDescendant: ariaActiveDescendant, ariaControls: ariaControls, ariaExpanded: ariaExpanded, ariaAutoComplete: ariaAutoComplete, role: role, inputId: inputId } = this.props;
        const { value: value } = this.state;
        return /*#__PURE__*/ (0, $1NIU8.jsx)("input", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            css: [
                (0, $ierDl.panelTextInput),
                width !== undefined && (0, $ierDl.panelTextInputWithCustomWidth)(width)
            ],
            role: role,
            "aria-autocomplete": ariaAutoComplete ? 'list' : undefined,
            "aria-expanded": ariaExpanded,
            "aria-controls": ariaControls,
            "aria-activedescendant": ariaActiveDescendant,
            "aria-describedby": describedById,
            "data-testid": testId || '',
            type: "text",
            placeholder: placeholder,
            value: value,
            onChange: this.handleChange,
            onKeyDown: this.handleKeydown,
            onMouseDown: this.onMouseDown,
            onBlur: this.onBlur,
            ref: this.handleRef,
            maxLength: maxLength,
            "aria-label": ariaLabel,
            "aria-required": this.props?.ariaRequired,
            "aria-invalid": this.props?.ariaInvalid,
            id: inputId
        });
    }
    focus() {
        const { input: input } = this;
        if (input) {
            const focusOpts = typeof this.props.autoFocus === 'object' ? this.props.autoFocus : {};
            input.focus(focusOpts);
        }
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    isUndoEvent(event) {
        return event.keyCode === $d912f19a48e0ba81$var$KeyZCode && // cmd + z for mac
        ((0, $7EdFW.browser).mac && event.metaKey && !event.shiftKey || // ctrl + z for non-mac
        !(0, $7EdFW.browser).mac && event.ctrlKey);
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    isRedoEvent(event) {
        return(// ctrl + y for non-mac
        !(0, $7EdFW.browser).mac && event.ctrlKey && event.keyCode === $d912f19a48e0ba81$var$KeyYCode || (0, $7EdFW.browser).mac && event.metaKey && event.shiftKey && event.keyCode === $d912f19a48e0ba81$var$KeyZCode || event.ctrlKey && event.shiftKey && event.keyCode === $d912f19a48e0ba81$var$KeyZCode);
    }
}

});
parcelRegister("ierDl", function(module, exports) {

$parcel$export(module.exports, "panelTextInput", () => $9b77db833ab3fb33$export$b81ddbf3e2eaad80);
$parcel$export(module.exports, "panelTextInputWithCustomWidth", () => $9b77db833ab3fb33$export$c9f899b6422903f6);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $7yBx7 = parcelRequire("7yBx7");
const $9b77db833ab3fb33$export$b81ddbf3e2eaad80 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    'input&': {
        background: 'transparent',
        border: `1px solid ${"var(--ds-border-input, #8590A2)"}`,
        borderRadius: 3,
        boxSizing: 'content-box',
        color: "var(--ds-text, #172B4D)",
        flexGrow: 1,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        fontSize: (0, $7yBx7.relativeFontSizeToBase16)(13),
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: '20px',
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-400, 32px)"} ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"}`,
        minWidth: '145px',
        /* Hides IE10+ built-in [x] clear input button */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&::-ms-clear': {
            display: 'none'
        },
        '&:focus': {
            outline: 'none',
            backgroundColor: "var(--ds-background-input-pressed, #FFFFFF)",
            borderColor: "var(--ds-border-focused, #388BFF)",
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${"var(--ds-border-focused, #388BFF)"}`
        },
        '&::placeholder': {
            color: "var(--ds-text-subtlest, #626F86)"
        }
    }
});
const $9b77db833ab3fb33$export$c9f899b6422903f6 = (width)=>/*#__PURE__*/ (0, $1NIU8.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        'input&': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            width: `${width}px`
        }
    });

});


parcelRegister("9sG1M", function(module, exports) {

$parcel$export(module.exports, "default", () => $68bfecaf9f913500$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $7ep4S = parcelRequire("7ep4S");

var $7PcQo = parcelRequire("7PcQo");
function $68bfecaf9f913500$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $68bfecaf9f913500$var$listContainer = /*#__PURE__*/ (0, $1NIU8.css)({
    paddingTop: 0,
    marginTop: "var(--ds-space-150, 12px)",
    borderTop: `1px solid ${"var(--ds-border, #091E4224)"}`
});
const $68bfecaf9f913500$var$spinnerContainer = {
    name: "q64ud4",
    styles: "text-align:center;min-height:80px;margin-top:var(--ds-space-400, 32px)"
};
const $68bfecaf9f913500$export$ca0620a9deb4a3fe = {
    name: "n1lsvi",
    styles: "padding:0;list-style:none"
};
class $68bfecaf9f913500$export$2e2bcd8739ae039 extends (0, $eJOHy.PureComponent) {
    render() {
        const { onSelect: onSelect, onMouseMove: onMouseMove, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, items: items, selectedIndex: selectedIndex, isLoading: isLoading, ariaControls: ariaControls, role: role, id: id } = this.props;
        let itemsContent;
        let loadingContent;
        if (items && items.length > 0) itemsContent = /*#__PURE__*/ (0, $1NIU8.jsx)("ul", {
            css: $68bfecaf9f913500$export$ca0620a9deb4a3fe,
            id: id,
            role: role,
            "aria-controls": ariaControls,
            "data-testid": `${id}--items`
        }, items.map((item, index)=>/*#__PURE__*/ (0, $1NIU8.jsx)((0, $7PcQo.default), {
                id: `link-search-list-item-${index}`,
                role: role && 'option',
                item: item,
                selected: selectedIndex === index,
                onMouseMove: onMouseMove,
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave,
                onSelect: onSelect,
                key: item.objectId
            })));
        if (isLoading) loadingContent = /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            id: id,
            "data-testid": `${id}--loading`,
            css: $68bfecaf9f913500$var$spinnerContainer
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $7ep4S.default), {
            size: "medium",
            interactionName: "link-search-spinner"
        }));
        return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            css: $68bfecaf9f913500$var$listContainer
        }, itemsContent, loadingContent);
    }
}

});
parcelRegister("7PcQo", function(module, exports) {

$parcel$export(module.exports, "default", () => $7deb9772ab8a12ab$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $6YFG2 = parcelRequire("6YFG2");

var $7yBx7 = parcelRequire("7yBx7");

var $kxAEw = parcelRequire("kxAEw");

var $gKQQp = parcelRequire("gKQQp");
function $7deb9772ab8a12ab$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7deb9772ab8a12ab$export$34e0f9847d4c02dd = /*#__PURE__*/ (0, $1NIU8.css)({
    backgroundColor: 'transparent',
    padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-150, 12px)"}`,
    cursor: 'pointer',
    display: 'flex',
    marginTop: 0
});
const $7deb9772ab8a12ab$export$624ac72e8eeb8e3d = {
    name: "jjwciq",
    styles: "background-color:var(--ds-background-neutral-subtle-hovered, #091E420F)"
};
const $7deb9772ab8a12ab$var$nameWrapper = {
    name: "d3v9zr",
    styles: "overflow:hidden"
};
const $7deb9772ab8a12ab$export$d6a1b4d10134b7d7 = {
    name: "ufq1bc",
    styles: "color:var(--ds-text, #172B4D);overflow:hidden;text-overflow:ellipsis;white-space:nowrap;line-height:20px"
};
const $7deb9772ab8a12ab$export$ff1446d682f75fb9 = /*#__PURE__*/ (0, $1NIU8.css)({
    color: "var(--ds-text-subtlest, #626F86)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '14px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: (0, $7yBx7.relativeFontSizeToBase16)(11)
});
const $7deb9772ab8a12ab$var$iconStyle = {
    name: "r2c2s1",
    styles: "min-width:16px;margin-top:var(--ds-space-050, 4px);margin-right:var(--ds-space-150, 12px);img{max-width:16px;}"
};
// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
class $7deb9772ab8a12ab$var$LinkSearchListItem extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).PureComponent {
    renderIcon() {
        const { item: { icon: icon, iconUrl: iconUrl }, intl: intl } = this.props;
        if (icon) return /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
            css: $7deb9772ab8a12ab$var$iconStyle
        }, icon);
        if (iconUrl) return /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
            css: $7deb9772ab8a12ab$var$iconStyle
        }, /*#__PURE__*/ (0, $1NIU8.jsx)("img", {
            src: iconUrl,
            alt: (0, $kxAEw.getCorrectAltByIconUrl)(iconUrl, intl)
        }));
        return null;
    }
    renderTimeStamp() {
        const { item: item, intl: intl } = this.props;
        const date = (0, $gKQQp.transformTimeStamp)(intl, item.lastViewedDate, item.lastUpdatedDate);
        return date && /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Fragment), null, "\xa0 \u2022", /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "link-search-timestamp",
            "data-test-id": "link-search-timestamp"
        }, "\xa0 ", date.pageAction, " ", date.dateString, " ", date.timeSince || ''));
    }
    render() {
        const { item: item, selected: selected, id: id, role: role } = this.props;
        return(// eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions
        /*#__PURE__*/ (0, $1NIU8.jsx)("li", {
            css: [
                $7deb9772ab8a12ab$export$34e0f9847d4c02dd,
                selected && $7deb9772ab8a12ab$export$624ac72e8eeb8e3d
            ],
            role: role,
            id: id,
            "aria-selected": selected,
            "data-testid": "link-search-list-item",
            onMouseMove: this.handleMouseMove,
            onMouseEnter: this.handleMouseEnter,
            onMouseLeave: this.handleMouseLeave,
            onClick: this.handleSelect
        }, this.renderIcon(), /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
            css: $7deb9772ab8a12ab$var$nameWrapper
        }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            css: $7deb9772ab8a12ab$export$d6a1b4d10134b7d7
        }, item.name), /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            "data-testid": "link-search-list-item-container",
            css: $7deb9772ab8a12ab$export$ff1446d682f75fb9
        }, item.container, this.renderTimeStamp()))));
    }
    constructor(...args){
        super(...args), this.handleSelect = (e)=>{
            e.preventDefault(); // don't let editor lose focus
            const { item: item, onSelect: onSelect } = this.props;
            onSelect(item.url, item.name);
        }, this.handleMouseMove = ()=>{
            const { onMouseMove: onMouseMove, item: item } = this.props;
            onMouseMove && onMouseMove(item.objectId);
        }, this.handleMouseEnter = ()=>{
            const { onMouseEnter: onMouseEnter, item: item } = this.props;
            onMouseEnter && onMouseEnter(item.objectId);
        }, this.handleMouseLeave = ()=>{
            const { onMouseLeave: onMouseLeave, item: item } = this.props;
            onMouseLeave && onMouseLeave(item.objectId);
        };
    }
}
var $7deb9772ab8a12ab$export$2e2bcd8739ae039 = (0, $6YFG2.default)($7deb9772ab8a12ab$var$LinkSearchListItem);

});
parcelRegister("kxAEw", function(module, exports) {

$parcel$export(module.exports, "getCorrectAltByIconUrl", () => $8bd2e99392d17d43$export$ac1fda7301622804);

var $7qGN1 = parcelRequire("7qGN1");
const $8bd2e99392d17d43$var$messages = (0, $7qGN1.defineMessages)({
    story: {
        id: 'fabric.editor.story',
        defaultMessage: 'Story',
        description: 'Alt text for Story'
    },
    epic: {
        id: 'fabric.editor.epic',
        defaultMessage: 'Epic',
        description: 'Alt text for Epic'
    },
    task: {
        id: 'fabric.editor.task',
        defaultMessage: 'Task',
        description: 'Alt text for Task'
    },
    bug: {
        id: 'fabric.editor.bug',
        defaultMessage: 'Bug',
        description: 'Alt text for Bug'
    },
    subTask: {
        id: 'fabric.editor.subTask',
        defaultMessage: 'Sub-task',
        description: 'Alt text for Sub-task'
    },
    improvement: {
        id: 'fabric.editor.improvement',
        defaultMessage: 'Improvement',
        description: 'Alt text for Improvement'
    },
    defaultAltText: {
        id: 'fabric.editor.defaultAltText',
        defaultMessage: 'Document',
        description: 'Default alt text for ListItem image'
    }
});
const $8bd2e99392d17d43$export$ac1fda7301622804 = (iconUrl, intl)=>{
    let alt = intl.formatMessage($8bd2e99392d17d43$var$messages.defaultAltText);
    if (iconUrl.includes('story.svg')) alt = intl.formatMessage($8bd2e99392d17d43$var$messages.story);
    if (iconUrl.includes('epic.svg')) alt = intl.formatMessage($8bd2e99392d17d43$var$messages.epic);
    if (iconUrl.includes('avatarId=10318')) alt = intl.formatMessage($8bd2e99392d17d43$var$messages.task);
    if (iconUrl.includes('avatarId=10303')) alt = intl.formatMessage($8bd2e99392d17d43$var$messages.bug);
    if (iconUrl.includes('avatarId=10518')) alt = intl.formatMessage($8bd2e99392d17d43$var$messages.subTask);
    if (iconUrl.includes('avatarId=10310')) alt = intl.formatMessage($8bd2e99392d17d43$var$messages.improvement);
    return alt;
};

});

parcelRegister("gKQQp", function(module, exports) {

$parcel$export(module.exports, "transformTimeStamp", () => $94d8dacd02b9fa1d$export$439b9bb86eb9f500);

var $btz6U = parcelRequire("btz6U");

var $57raR = parcelRequire("57raR");

var $2QHI9 = parcelRequire("2QHI9");

var $h2yqz = parcelRequire("h2yqz");
const $94d8dacd02b9fa1d$var$renderAbsoluteOrRelativeDate = (timeStamp, pageAction, intl)=>{
    let pageActionText = '';
    switch(pageAction){
        case 'updated':
            pageActionText = intl.formatMessage((0, $h2yqz.default).timeUpdated);
            break;
        case 'viewed':
            pageActionText = intl.formatMessage((0, $h2yqz.default).timeViewed);
            break;
    }
    if ((0, $btz6U.default)(timeStamp, Date.now()) < -7) return {
        pageAction: pageActionText,
        dateString: (0, $57raR.default)(timeStamp, 'MMMM dd, yyyy')
    };
    return {
        pageAction: pageActionText,
        dateString: (0, $2QHI9.default)(timeStamp, Date.now()),
        timeSince: intl.formatMessage((0, $h2yqz.default).timeAgo)
    };
};
const $94d8dacd02b9fa1d$export$439b9bb86eb9f500 = (intl, lastViewedDate, lastUpdatedDate)=>{
    if (lastViewedDate) return $94d8dacd02b9fa1d$var$renderAbsoluteOrRelativeDate(lastViewedDate, 'viewed', intl);
    if (lastUpdatedDate) return $94d8dacd02b9fa1d$var$renderAbsoluteOrRelativeDate(lastUpdatedDate, 'updated', intl);
};

});



parcelRegister("b2d9j", function(module, exports) {

$parcel$export(module.exports, "inputWrapper", () => $17c3be13bb7cbc07$export$248a47518f3a0001);
$parcel$export(module.exports, "container", () => $17c3be13bb7cbc07$export$34e0f9847d4c02dd);
$parcel$export(module.exports, "containerWithProvider", () => $17c3be13bb7cbc07$export$8fb2d297355596b4);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

const $17c3be13bb7cbc07$export$248a47518f3a0001 = /*#__PURE__*/ (0, $1NIU8.css)({
    display: 'flex',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 0,
    padding: `${"var(--ds-space-075, 6px)"} 0`,
    alignItems: 'center'
});
const $17c3be13bb7cbc07$export$34e0f9847d4c02dd = /*#__PURE__*/ (0, $1NIU8.css)({
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
    padding: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $4d66e472a8adb592$export$92a2501826f554f6)}px`,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 'initial'
});
const $17c3be13bb7cbc07$export$8fb2d297355596b4 = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $4d66e472a8adb592$export$a62aa932daf22ffe)}px`
});

});
const $4d66e472a8adb592$export$a62aa932daf22ffe = 420;
const $4d66e472a8adb592$export$92a2501826f554f6 = 360;
const $4d66e472a8adb592$export$c04a5ad015d45447 = 360;
const $4d66e472a8adb592$export$c635b83728f81640 = 570;


parcelRegister("84M54", function(module, exports) {

$parcel$export(module.exports, "filterUniqueItems", () => $346ac22856e3fa3b$export$8437fc55448c6e05);
$parcel$export(module.exports, "mapContentTypeToIcon", () => $346ac22856e3fa3b$export$80e948449ec854a9);
$parcel$export(module.exports, "sha1", () => $346ac22856e3fa3b$export$5091bdda49ba90f5);
$parcel$export(module.exports, "wordCount", () => $346ac22856e3fa3b$export$24d5ff955141c347);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6YFG2 = parcelRequire("6YFG2");

var $jhs3c = parcelRequire("jhs3c");

var $ihwup = parcelRequire("ihwup");

var $i3nvV = parcelRequire("i3nvV");

var $8WXuv = parcelRequire("8WXuv");

var $fk1hB = parcelRequire("fk1hB");

var $iaeCZ = parcelRequire("iaeCZ");

var $cOjgE = parcelRequire("cOjgE");

var $eGOwo = parcelRequire("eGOwo");

var $j7F6W = parcelRequire("j7F6W");
function $346ac22856e3fa3b$export$8437fc55448c6e05(arr, comparator) {
    return arr.filter((firstItem, index, self)=>{
        return self.findIndex((secondItem)=>comparator ? comparator(firstItem, secondItem) : firstItem === secondItem) === index;
    });
}
const $346ac22856e3fa3b$var$Issue16 = (props)=>{
    const { intl: intl } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8WXuv.default), {
        label: intl.formatMessage((0, $eGOwo.fg)('confluence-issue-terminology-refresh') ? (0, $j7F6W.utilMessages).hyperlinkIconIssueLabelIssueTermRefresh : (0, $j7F6W.utilMessages).hyperlinkIconIssueLabel)
    });
};
const $346ac22856e3fa3b$var$Bug16 = (props)=>{
    const { intl: intl } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $i3nvV.default), {
        label: intl.formatMessage((0, $j7F6W.utilMessages).hyperlinkIconBugLabel)
    });
};
const $346ac22856e3fa3b$var$Story16 = (props)=>{
    const { intl: intl } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iaeCZ.default), {
        label: intl.formatMessage((0, $j7F6W.utilMessages).hyperlinkIconStoryLabel)
    });
};
const $346ac22856e3fa3b$var$Task16 = (props)=>{
    const { intl: intl } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cOjgE.default), {
        label: intl.formatMessage((0, $j7F6W.utilMessages).hyperlinkIconTaskLabel)
    });
};
const $346ac22856e3fa3b$var$Page16 = (props)=>{
    const { intl: intl } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fk1hB.default), {
        label: intl.formatMessage((0, $j7F6W.utilMessages).hyperlinkIconPageLabel)
    });
};
const $346ac22856e3fa3b$var$Blog16 = (props)=>{
    const { intl: intl } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ihwup.default), {
        label: intl.formatMessage((0, $j7F6W.utilMessages).hyperlinkIconBlogLabel)
    });
};
const $346ac22856e3fa3b$var$IntlIssue16Icon = (0, $6YFG2.default)($346ac22856e3fa3b$var$Issue16);
const $346ac22856e3fa3b$var$IntlBug16Icon = (0, $6YFG2.default)($346ac22856e3fa3b$var$Bug16);
const $346ac22856e3fa3b$var$IntlStory16Icon = (0, $6YFG2.default)($346ac22856e3fa3b$var$Story16);
const $346ac22856e3fa3b$var$IntlTask16Icon = (0, $6YFG2.default)($346ac22856e3fa3b$var$Task16);
const $346ac22856e3fa3b$var$IntlPage16Icon = (0, $6YFG2.default)($346ac22856e3fa3b$var$Page16);
const $346ac22856e3fa3b$var$IntlBlog16Icon = (0, $6YFG2.default)($346ac22856e3fa3b$var$Blog16);
const $346ac22856e3fa3b$export$80e948449ec854a9 = {
    'jira.issue': /*#__PURE__*/ (0, $gt9Am.jsx)($346ac22856e3fa3b$var$IntlIssue16Icon, {}),
    'jira.issue.bug': /*#__PURE__*/ (0, $gt9Am.jsx)($346ac22856e3fa3b$var$IntlBug16Icon, {}),
    'jira.issue.story': /*#__PURE__*/ (0, $gt9Am.jsx)($346ac22856e3fa3b$var$IntlStory16Icon, {}),
    'jira.issue.task': /*#__PURE__*/ (0, $gt9Am.jsx)($346ac22856e3fa3b$var$IntlTask16Icon, {}),
    'confluence.page': /*#__PURE__*/ (0, $gt9Am.jsx)($346ac22856e3fa3b$var$IntlPage16Icon, {}),
    'confluence.blogpost': /*#__PURE__*/ (0, $gt9Am.jsx)($346ac22856e3fa3b$var$IntlBlog16Icon, {})
};
const $346ac22856e3fa3b$export$5091bdda49ba90f5 = (input)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($jhs3c))).createHash().update(input).digest('hex');
};
const $346ac22856e3fa3b$export$24d5ff955141c347 = (input)=>{
    return input.split(' ').length;
};

});
parcelRegister("j7F6W", function(module, exports) {

$parcel$export(module.exports, "utilMessages", () => $4386b122c8afdcff$export$ecd9e62648c1046a);

var $7qGN1 = parcelRequire("7qGN1");
const $4386b122c8afdcff$export$ecd9e62648c1046a = (0, $7qGN1.defineMessages)({
    hyperlinkIconIssueLabel: {
        id: 'fabric.editor.headingLink.hyperlinkIconIssueLabel',
        defaultMessage: 'Issue',
        description: 'icon label for a jira issue'
    },
    hyperlinkIconBugLabel: {
        id: 'fabric.editor.headingLink.hyperlinkIconBugLabel',
        defaultMessage: 'Bug',
        description: 'icon label for a jira bug'
    },
    hyperlinkIconStoryLabel: {
        id: 'fabric.editor.headingLink.hyperlinkIconStoryLabel',
        defaultMessage: 'Story',
        description: 'icon label for a jira story'
    },
    hyperlinkIconTaskLabel: {
        id: 'fabric.editor.headingLink.hyperlinkIconTaskLabel',
        defaultMessage: 'Task',
        description: 'icon label for a jira task'
    },
    hyperlinkIconPageLabel: {
        id: 'fabric.editor.headingLink.hyperlinkIconPageLabel',
        defaultMessage: 'Page',
        description: 'icon label for a confluence page'
    },
    hyperlinkIconBlogLabel: {
        id: 'fabric.editor.headingLink.hyperlinkIconBlogLabel',
        defaultMessage: 'Blog',
        description: 'icon label for a confluence blog'
    },
    hyperlinkIconIssueLabelIssueTermRefresh: {
        id: 'fabric.editor.headingLink.hyperlinkIconIssueLabel.issue-term-refresh',
        defaultMessage: 'Work Item',
        description: 'icon label for a jira issue'
    }
});

});





parcelRegister("2WxDr", function(module, exports) {

$parcel$export(module.exports, "EditToolbarButton", () => $c23091cb9b9d3e53$export$4f24788e7d04736b);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $kDaaB = parcelRequire("kDaaB");

var $6dRXt = parcelRequire("6dRXt");
var $4AqYB = parcelRequire("4AqYB");

var $knwdo = parcelRequire("knwdo");
var $84CN8 = parcelRequire("84CN8");

var $UpZp1 = parcelRequire("UpZp1");
var $cigQc = parcelRequire("cigQc");

var $5lAAn = parcelRequire("5lAAn");

var $9kfy2 = parcelRequire("9kfy2");

var $7saMl = parcelRequire("7saMl");

var $2sLVw = parcelRequire("2sLVw");

var $92xoS = parcelRequire("92xoS");

var $gXgTX = parcelRequire("gXgTX");

var $8wyKH = parcelRequire("8wyKH");

var $j1KTg = parcelRequire("j1KTg");

var $XsiSM = parcelRequire("XsiSM");

var $eB5cS = parcelRequire("eB5cS");
const $c23091cb9b9d3e53$var$dropdownExpandContainer = /*#__PURE__*/ (0, $1NIU8.css)({
    margin: `0px ${"var(--ds-space-negative-050, -4px)"}`
});
const $c23091cb9b9d3e53$var$EditToolbarButtonWithCardContext = (props)=>{
    const { cardContext: cardContext, currentAppearance: currentAppearance, editorAnalyticsApi: editorAnalyticsApi, editorView: editorView, intl: intl, onLinkEditClick: onLinkEditClick, url: url } = props;
    const { extensionKey: extensionKey, ...response } = (0, $XsiSM.useFetchDatasourceInfo)({
        isRegularCardNode: true,
        url: url,
        cardContext: cardContext
    });
    const datasourceId = response.datasourceId ?? props.datasourceId;
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const containerRef = (0, $eJOHy.useRef)();
    const toggleOpen = ()=>setIsOpen((open)=>!open);
    const onClose = ()=>setIsOpen(false);
    const onEditLink = (0, $eJOHy.useCallback)(()=>{
        if (editorView) {
            onLinkEditClick(editorView.state, editorView.dispatch);
            (0, $gXgTX.focusEditorView)(editorView);
        }
    }, [
        editorView,
        onLinkEditClick
    ]);
    const editVariant = (0, $eJOHy.useMemo)(()=>{
        const hasUrl = url !== null && url !== undefined;
        if (!datasourceId || !(0, $gXgTX.isDatasourceConfigEditable)(datasourceId)) {
            if (hasUrl) return 'edit-link';
            return 'none';
        }
        if (hasUrl) {
            const urlState = cardContext?.store?.getState()[url];
            if (urlState?.error?.kind === 'fatal') return 'edit-link';
            return 'edit-dropdown';
        } else return 'edit-datasource';
    }, [
        cardContext?.store,
        datasourceId,
        url
    ]);
    const onEditDatasource = (0, $eJOHy.useCallback)(()=>{
        if (editorView && datasourceId) {
            (0, $8wyKH.editDatasource)(datasourceId, editorAnalyticsApi, currentAppearance, extensionKey)(editorView.state, editorView.dispatch);
            (0, $gXgTX.focusEditorView)(editorView);
        }
    }, [
        currentAppearance,
        datasourceId,
        editorAnalyticsApi,
        editorView,
        extensionKey
    ]);
    switch(editVariant){
        case 'edit-link':
            return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $2sLVw.default), {
                gap: "space.050"
            }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $knwdo.default), {
                testId: "edit-link",
                onClick: onEditLink
            }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $kDaaB.default), (0, $4AqYB.linkToolbarMessages).editLink)), !(0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1') && /*#__PURE__*/ (0, $1NIU8.jsx)((0, $84CN8.default), null));
        case 'edit-datasource':
            return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $2sLVw.default), {
                gap: "space.050"
            }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $knwdo.default), {
                testId: "edit-datasource",
                tooltipContent: intl.formatMessage((0, $4AqYB.linkToolbarMessages).editDatasourceStandaloneTooltip),
                onClick: onEditDatasource
            }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $kDaaB.default), (0, $4AqYB.linkToolbarMessages).editDatasourceStandalone)), !(0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1') && /*#__PURE__*/ (0, $1NIU8.jsx)((0, $84CN8.default), null));
        case 'edit-dropdown':
            {
                const trigger = /*#__PURE__*/ (0, $1NIU8.jsx)((0, $2sLVw.default), {
                    gap: "space.050"
                }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $knwdo.default), {
                    testId: "edit-dropdown-trigger",
                    iconAfter: /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
                        css: $c23091cb9b9d3e53$var$dropdownExpandContainer
                    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5lAAn))), {
                        label: intl.formatMessage((0, $6dRXt.messages).editDropdownTriggerTitle),
                        size: "small"
                    })),
                    onClick: toggleOpen,
                    selected: isOpen,
                    disabled: false,
                    ariaHasPopup: true
                }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $kDaaB.default), (0, $6dRXt.messages).editDropdownTriggerTitle)), !(0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1') && /*#__PURE__*/ (0, $1NIU8.jsx)((0, $84CN8.default), null));
                return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $2sLVw.default), {
                    ref: containerRef
                }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $cigQc.DropdownContainer), {
                    mountTo: containerRef.current,
                    isOpen: isOpen,
                    handleClickOutside: onClose,
                    handleEscapeKeydown: onClose,
                    trigger: trigger,
                    scrollableElement: containerRef.current,
                    arrowKeyNavigationProviderOptions: {
                        type: (0, $UpZp1.ArrowKeyNavigationType).MENU
                    }
                }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $7saMl.default), {
                    key: "edit.link",
                    onClick: onEditLink,
                    testId: "edit-dropdown-edit-link-item"
                }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $kDaaB.default), (0, $6dRXt.messages).editDropdownEditLinkTitle)), /*#__PURE__*/ (0, $1NIU8.jsx)((0, $7saMl.default), {
                    key: "edit.datasource",
                    onClick: onEditDatasource,
                    testId: "edit-dropdown-edit-datasource-item"
                }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $kDaaB.default), (0, $6dRXt.messages).editDropdownEditDatasourceTitle))));
            }
        case 'none':
        default:
            return null;
    }
};
const $c23091cb9b9d3e53$var$EditToolbarButtonWithUrl = (props)=>{
    const { cardContext: cardContext, currentAppearance: currentAppearance, datasourceId: datasourceIdFromAdf, editorAnalyticsApi: editorAnalyticsApi, editorView: editorView, intl: intl, onLinkEditClick: onLinkEditClick, url: url } = props;
    const { extensionKey: extensionKey, datasourceId: datasourceIdFromUrl } = (0, $XsiSM.useFetchDatasourceInfo)({
        isRegularCardNode: true,
        url: url,
        cardContext: cardContext
    });
    const datasourceId = datasourceIdFromUrl ?? datasourceIdFromAdf;
    const editVariant = (0, $eJOHy.useMemo)(()=>{
        if (!datasourceId || !(0, $gXgTX.isDatasourceConfigEditable)(datasourceId)) return 'edit-link';
        const urlState = cardContext?.store?.getState()[url];
        if (urlState?.error?.kind === 'fatal') return 'edit-link';
        return 'edit-dropdown';
    }, [
        cardContext?.store,
        datasourceId,
        url
    ]);
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eB5cS.default), {
        datasourceId: datasourceId,
        currentAppearance: currentAppearance,
        editorAnalyticsApi: editorAnalyticsApi,
        editVariant: editVariant,
        editorView: editorView,
        extensionKey: extensionKey,
        onLinkEditClick: onLinkEditClick,
        intl: intl
    });
};
const $c23091cb9b9d3e53$var$EditToolbarButtonWithDatasourceId = (props)=>{
    const { currentAppearance: currentAppearance, editorAnalyticsApi: editorAnalyticsApi, editorView: editorView, intl: intl, onLinkEditClick: onLinkEditClick, datasourceId: datasourceId, node: node } = props;
    const fetchData = (0, $eJOHy.useMemo)(()=>{
        try {
            const attrs = node.attrs;
            const parameters = attrs.datasource.parameters;
            const visibleColumnKeys = attrs.datasource.views[0]?.properties?.columns.map((c)=>c.key);
            return {
                parameters: parameters,
                visibleColumnKeys: visibleColumnKeys
            };
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
    }, [
        node.attrs
    ]);
    const { extensionKey: extensionKey } = (0, $j1KTg.useFetchDatasourceDataInfo)({
        datasourceId: datasourceId,
        parameters: fetchData?.parameters,
        visibleColumnKeys: fetchData?.visibleColumnKeys
    });
    const editVariant = (0, $eJOHy.useMemo)(()=>{
        if (!datasourceId || !(0, $gXgTX.isDatasourceConfigEditable)(datasourceId)) return 'none';
        return 'edit-datasource';
    }, [
        datasourceId
    ]);
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eB5cS.default), {
        datasourceId: datasourceId,
        currentAppearance: currentAppearance,
        editorAnalyticsApi: editorAnalyticsApi,
        editVariant: editVariant,
        editorView: editorView,
        extensionKey: extensionKey,
        onLinkEditClick: onLinkEditClick,
        intl: intl
    });
};
const $c23091cb9b9d3e53$export$4f24788e7d04736b = (props)=>{
    const { currentAppearance: currentAppearance, datasourceId: datasourceId, editorAnalyticsApi: editorAnalyticsApi, editorView: editorView, intl: intl, onLinkEditClick: onLinkEditClick, url: url } = props;
    const cardContext = (0, $9kfy2.useSmartLinkContext)();
    if (props.url) return /*#__PURE__*/ (0, $1NIU8.jsx)($c23091cb9b9d3e53$var$EditToolbarButtonWithUrl, {
        datasourceId: datasourceId,
        url: props.url,
        intl: intl,
        editorAnalyticsApi: editorAnalyticsApi,
        editorView: editorView,
        cardContext: cardContext,
        onLinkEditClick: onLinkEditClick,
        currentAppearance: currentAppearance
    });
    if (props.datasourceId && props.node) return /*#__PURE__*/ (0, $1NIU8.jsx)($c23091cb9b9d3e53$var$EditToolbarButtonWithDatasourceId, {
        datasourceId: props.datasourceId,
        node: props.node,
        intl: intl,
        editorAnalyticsApi: editorAnalyticsApi,
        editorView: editorView,
        onLinkEditClick: onLinkEditClick,
        currentAppearance: currentAppearance
    });
    return /*#__PURE__*/ (0, $1NIU8.jsx)($c23091cb9b9d3e53$var$EditToolbarButtonWithCardContext, {
        datasourceId: datasourceId,
        url: url,
        intl: intl,
        editorAnalyticsApi: editorAnalyticsApi,
        editorView: editorView,
        cardContext: cardContext,
        onLinkEditClick: onLinkEditClick,
        currentAppearance: currentAppearance
    });
};

});
parcelRegister("84CN8", function(module, exports) {

$parcel$export(module.exports, "default", () => $62a9c1374f8f3d97$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $92xoS = parcelRequire("92xoS");
function $62a9c1374f8f3d97$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $62a9c1374f8f3d97$var$separator = /*#__PURE__*/ (0, $1NIU8.css)({
    background: "var(--ds-border, #091E4224)",
    width: '1px',
    height: '20px',
    margin: `0 ${"var(--ds-space-050, 4px)"}`,
    alignSelf: 'center'
});
const $62a9c1374f8f3d97$var$separatorNew = {
    name: "876g5t",
    styles: "background:var(--ds-border, #091E4224);width:1px;height:20px;align-self:center"
};
const $62a9c1374f8f3d97$var$separatorFullHeight = {
    name: "1k18kha",
    styles: "height:40px"
};
var $62a9c1374f8f3d97$export$2e2bcd8739ae039 = ({ fullHeight: fullHeight })=>/*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: [
            (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1') ? $62a9c1374f8f3d97$var$separatorNew : $62a9c1374f8f3d97$var$separator,
            fullHeight && $62a9c1374f8f3d97$var$separatorFullHeight
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "separator"
    });

});

parcelRegister("cigQc", function(module, exports) {

$parcel$export(module.exports, "DropdownContainer", () => $c0a99f03c3224fee$export$49166591ec160d97);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $UpZp1 = parcelRequire("UpZp1");

var $aSEqE = parcelRequire("aSEqE");

var $baHgw = parcelRequire("baHgw");
const $c0a99f03c3224fee$export$49166591ec160d97 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo(function DropdownContainer(props) {
    const keyDownHandlerContext = (0, $eJOHy.useContext)((0, $baHgw.KeyDownHandlerContext));
    let newArrowKeyNavigationProviderOptions = props.arrowKeyNavigationProviderOptions;
    // if the dropdown is of type menu, use this keyDownHandlerContext
    if (props.arrowKeyNavigationProviderOptions.type === (0, $UpZp1.ArrowKeyNavigationType).MENU) newArrowKeyNavigationProviderOptions = {
        ...props.arrowKeyNavigationProviderOptions,
        keyDownHandlerContext: keyDownHandlerContext
    };
    return(//This context is to handle the tab, Arrow Right/Left key events for dropdown.
    //Default context has the void callbacks for above key events
    /*#__PURE__*/ (0, $1NIU8.jsx)((0, $aSEqE.default), {
        ...props,
        arrowKeyNavigationProviderOptions: newArrowKeyNavigationProviderOptions
    }));
});

});
parcelRegister("aSEqE", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a3c72f3adb26b0b$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $dcudV = parcelRequire("dcudV");

var $jRVxI = parcelRequire("jRVxI");

var $avm98 = parcelRequire("avm98");

var $dwnni = parcelRequire("dwnni");

var $aYKcT = parcelRequire("aYKcT");
class $2a3c72f3adb26b0b$export$931cbfb6bfb85fc extends (0, $eJOHy.PureComponent) {
    constructor(props){
        super(props), this.handleRef = (setOutsideClickTargetRef)=>(target)=>{
                setOutsideClickTargetRef(target);
                this.setState({
                    target: target || undefined
                });
            }, this.updatePopupPlacement = (placement)=>{
            this.setState({
                popupPlacement: placement
            });
        }, this.handleCloseAndFocus = (event)=>{
            this.state.target?.querySelector('button')?.focus();
            this.handleClose(event);
        }, this.handleClose = (event)=>{
            if (this.props.onOpenChange) this.props.onOpenChange({
                isOpen: false,
                event: event
            });
        };
        this.state = {
            popupPlacement: [
                'bottom',
                'left'
            ]
        };
    }
    componentDidUpdate(prevProps) {
        if (!prevProps.isOpen && this.props.isOpen && this.state.target && (0, $eGOwo.fg)('platform_editor_floating_toolbar_dropdown_flicker')) {
            // Dropdown flickers when opens as placement is calculated in Popup component and updated after the first render.
            // popupPlacement is set to ['bottom', 'left'] by default, but it may not be the correct placement and is required in DropdownList.
            // To avoid flicker we calculate placement here and set it to state when the dropdown opens.
            const initialPlacement = (0, $dwnni.calculatePlacement)(this.state.target, this.props.boundariesElement || document.body, this.props.fitWidth, this.props.fitHeight, this.props.alignX, this.props.alignY, this.props.forcePlacement);
            this.setState({
                popupPlacement: initialPlacement
            });
        }
    }
    renderDropdown() {
        const { target: target, popupPlacement: popupPlacement } = this.state;
        const { children: children, mountTo: mountTo, boundariesElement: boundariesElement, scrollableElement: scrollableElement, onOpenChange: onOpenChange, fitHeight: fitHeight, fitWidth: fitWidth, zIndex: zIndex, arrowKeyNavigationProviderOptions: arrowKeyNavigationProviderOptions, dropdownListId: dropdownListId, alignDropdownWithParentElement: alignDropdownWithParentElement, target: targetProp, forcePlacement: forcePlacement, alignX: alignX, alignY: alignY, offset: offset, shouldFitContainer: shouldFitContainer = true } = this.props;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $avm98.default), {
            target: targetProp ?? (alignDropdownWithParentElement ? // eslint-disable-next-line @atlaskit/editor/no-as-casting
            target?.closest("[data-testid='editor-floating-toolbar']") : target),
            mountTo: mountTo,
            boundariesElement: boundariesElement,
            scrollableElement: scrollableElement,
            onPlacementChanged: forcePlacement ? undefined : this.updatePopupPlacement,
            fitHeight: fitHeight,
            fitWidth: fitWidth,
            zIndex: zIndex,
            allowOutOfBounds: alignDropdownWithParentElement,
            alignX: alignX,
            alignY: alignY,
            forcePlacement: forcePlacement,
            offset: offset,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aYKcT.ArrowKeyNavigationProvider), {
                ...arrowKeyNavigationProviderOptions,
                closeOnTab: true,
                handleClose: this.handleCloseAndFocus,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    style: {
                        height: 0,
                        minWidth: fitWidth || 0
                    },
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jRVxI.default), {
                        isOpen: true,
                        onOpenChange: onOpenChange,
                        position: popupPlacement.join(' '),
                        shouldFitContainer: shouldFitContainer,
                        id: dropdownListId,
                        children: children
                    })
                })
            })
        });
    }
    render() {
        const { trigger: trigger, isOpen: isOpen } = this.props;
        return trigger ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dcudV.OutsideClickTargetRefContext).Consumer, {
            children: (setOutsideClickTargetRef)=>/*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                            ref: this.handleRef(setOutsideClickTargetRef),
                            children: trigger
                        }),
                        isOpen ? this.renderDropdown() : null
                    ]
                })
        }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
            children: isOpen ? this.renderDropdown() : null
        });
    }
}
const $2a3c72f3adb26b0b$var$DropdownWithOuterListeners = (0, $dcudV.default)($2a3c72f3adb26b0b$export$931cbfb6bfb85fc);
var $2a3c72f3adb26b0b$export$2e2bcd8739ae039 = $2a3c72f3adb26b0b$var$DropdownWithOuterListeners;

});


parcelRegister("8wyKH", function(module, exports) {

$parcel$export(module.exports, "editDatasource", () => $2124c113ae29f4f1$export$687401cc190b9ec3);

var $bMFKb = parcelRequire("bMFKb");

var $7WlTe = parcelRequire("7WlTe");

var $ecNk4 = parcelRequire("ecNk4");
const $2124c113ae29f4f1$export$687401cc190b9ec3 = (datasourceId, editorAnalyticsApi, appearance, extensionKey)=>(state, dispatch)=>{
        const datasourceType = (0, $7WlTe.getDatasourceType)(datasourceId);
        if (dispatch && datasourceType) {
            const { tr: tr } = state;
            (0, $ecNk4.showDatasourceModal)(datasourceType)(tr);
            editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $bMFKb.ACTION).CLICKED,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).BUTTON,
                actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).EDIT_DATASOURCE,
                eventType: (0, $bMFKb.EVENT_TYPE).UI,
                attributes: {
                    extensionKey: extensionKey,
                    appearance: appearance
                }
            })(tr);
            dispatch(tr);
            return true;
        }
        return false;
    };

});

parcelRegister("j1KTg", function(module, exports) {

$parcel$export(module.exports, "useFetchDatasourceDataInfo", () => $e071e0a1ffb8afb9$export$25222ec28f4cbba5);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $clMJd = parcelRequire("clMJd");
const $e071e0a1ffb8afb9$export$25222ec28f4cbba5 = ({ datasourceId: datasourceId, parameters: parameters, visibleColumnKeys: visibleColumnKeys })=>{
    const [extensionKey, setExtensionKey] = (0, $eJOHy.useState)(undefined);
    const { getDatasourceData: getDatasourceData } = (0, $clMJd.useDatasourceClientExtension)();
    (0, $eJOHy.useEffect)(()=>{
        const fetchDatasource = async ()=>{
            try {
                if (!datasourceId || !parameters || !visibleColumnKeys) return;
                const datasourceDataRequest = {
                    parameters: parameters,
                    pageSize: (0, $clMJd.DEFAULT_GET_DATASOURCE_DATA_PAGE_SIZE),
                    pageCursor: undefined,
                    fields: visibleColumnKeys,
                    includeSchema: true
                };
                const { meta: meta } = await getDatasourceData(datasourceId, datasourceDataRequest, false);
                setExtensionKey(meta.extensionKey);
            } catch (e) {
                // eslint-disable-next-line no-console
                console.error(e);
                setExtensionKey(undefined);
            }
        };
        fetchDatasource();
    }, [
        getDatasourceData,
        visibleColumnKeys,
        parameters,
        datasourceId
    ]);
    return {
        extensionKey: extensionKey
    };
};

});
parcelRegister("clMJd", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_GET_DATASOURCE_DATA_PAGE_SIZE", () => $fdb62e762fc7b098$export$5e074c0b68e2ce03);
$parcel$export(module.exports, "useDatasourceClientExtension", () => $fdb62e762fc7b098$export$7d812bb756889442);

var $eJOHy = parcelRequire("eJOHy");

var $7xkt0 = parcelRequire("7xkt0");

var $9kfy2 = parcelRequire("9kfy2");

var $hhFie = parcelRequire("hhFie");

var $jAAbh = parcelRequire("jAAbh");
const $fdb62e762fc7b098$var$URL_RESPONSE_CACHE_SIZE = 50;
const $fdb62e762fc7b098$export$f82fcd766a8daa7f = new (0, $7xkt0.LRUMap)($fdb62e762fc7b098$var$URL_RESPONSE_CACHE_SIZE);
const $fdb62e762fc7b098$export$40b1dd31340bd5c2 = new (0, $7xkt0.LRUMap)($fdb62e762fc7b098$var$URL_RESPONSE_CACHE_SIZE);
const $fdb62e762fc7b098$export$15cd58682efec5a5 = new (0, $7xkt0.LRUMap)($fdb62e762fc7b098$var$URL_RESPONSE_CACHE_SIZE);
const $fdb62e762fc7b098$export$5e074c0b68e2ce03 = 20;
const $fdb62e762fc7b098$export$7d812bb756889442 = ()=>{
    const { connections: { client: client } } = (0, $9kfy2.useSmartLinkContext)();
    const resolverUrl = (0, $jAAbh.useResolverUrl)(client);
    const cachedRequest = async (cacheKeyId, data, url, lruMap, force)=>{
        const cacheKeyData = {
            ...data,
            // Sort fields to use cached version of response regardless of the order
            ...'fields' in data ? {
                fields: [
                    ...data.fields || []
                ].sort()
            } : {},
            ...'fieldKeys' in data ? {
                fieldKeys: [
                    ...data.fieldKeys || []
                ].sort()
            } : {}
        };
        const cacheKey = JSON.stringify({
            cacheKeyId: cacheKeyId,
            cacheKeyData: cacheKeyData
        });
        if (force) lruMap.delete(cacheKey);
        let responsePromise = lruMap.get(cacheKey);
        if (responsePromise) return responsePromise;
        const headers = {
            /**
			 * This header exists to enable the backend to process relative time, eg: "today", with respect to user timezone.
			 * eg: used in "confluence-object-provider" to process confluence SLLV requests to filter data for relative time.
			 */ 'origin-timezone': Intl?.DateTimeFormat().resolvedOptions().timeZone
        };
        try {
            responsePromise = (0, $hhFie.request)('post', url, data, headers, [
                200,
                201,
                202,
                203,
                204
            ]);
            lruMap.set(cacheKey, responsePromise);
            return await responsePromise;
        } catch (e) {
            lruMap.delete(cacheKey);
            throw e;
        }
    };
    const uncachedRequest = async (data, url)=>{
        const responsePromise = (0, $hhFie.request)('post', url, data, undefined, [
            200,
            201,
            202,
            203,
            204
        ]);
        return responsePromise;
    };
    const getDatasourceDetails = (0, $eJOHy.useCallback)(async (datasourceId, data, force = false)=>cachedRequest(datasourceId, data, `${resolverUrl}/datasource/${datasourceId}/fetch/details`, $fdb62e762fc7b098$export$f82fcd766a8daa7f, force), [
        resolverUrl
    ]);
    const getDatasourceData = (0, $eJOHy.useCallback)(async (datasourceId, data, force = false)=>cachedRequest(datasourceId, data, `${resolverUrl}/datasource/${datasourceId}/fetch/data`, $fdb62e762fc7b098$export$40b1dd31340bd5c2, force), [
        resolverUrl
    ]);
    const getDatasourceActionsAndPermissions = (0, $eJOHy.useCallback)(async (data, force = false)=>{
        const resolvedCacheIdKey = 'datasourceId' in data ? data.datasourceId : data.integrationKey;
        // This is just to prevent empty string being passed up to ORS and causing issues.
        if (!resolvedCacheIdKey) throw new Error('No target was supplied to retrieve actions for');
        return cachedRequest(resolvedCacheIdKey, data, `${resolverUrl}/actions`, $fdb62e762fc7b098$export$15cd58682efec5a5, force);
    }, [
        resolverUrl
    ]);
    const executeAtomicAction = (0, $eJOHy.useCallback)(async (data)=>uncachedRequest(data, `${resolverUrl}/actions/execute`), [
        resolverUrl
    ]);
    const invalidateDatasourceDataCacheByAri = (0, $eJOHy.useCallback)((ari)=>{
        $fdb62e762fc7b098$export$40b1dd31340bd5c2.forEach(async (value, key)=>{
            const response = await value;
            const targetFound = response.data.items.some((item)=>{
                return item['ari']?.data === ari;
            });
            if (targetFound) $fdb62e762fc7b098$export$40b1dd31340bd5c2.delete(key);
        });
    }, []);
    return (0, $eJOHy.useMemo)(()=>({
            getDatasourceDetails: getDatasourceDetails,
            getDatasourceData: getDatasourceData,
            getDatasourceActionsAndPermissions: getDatasourceActionsAndPermissions,
            executeAtomicAction: executeAtomicAction,
            invalidateDatasourceDataCacheByAri: invalidateDatasourceDataCacheByAri
        }), [
        getDatasourceDetails,
        getDatasourceData,
        getDatasourceActionsAndPermissions,
        executeAtomicAction,
        invalidateDatasourceDataCacheByAri
    ]);
};

});


parcelRegister("eB5cS", function(module, exports) {

$parcel$export(module.exports, "default", () => $7530d013c7b307d8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $kDaaB = parcelRequire("kDaaB");

var $6dRXt = parcelRequire("6dRXt");
var $4AqYB = parcelRequire("4AqYB");

var $knwdo = parcelRequire("knwdo");
var $84CN8 = parcelRequire("84CN8");

var $UpZp1 = parcelRequire("UpZp1");
var $cigQc = parcelRequire("cigQc");

var $gTr6H = parcelRequire("gTr6H");

var $5lAAn = parcelRequire("5lAAn");

var $7saMl = parcelRequire("7saMl");

var $eGOwo = parcelRequire("eGOwo");

var $2sLVw = parcelRequire("2sLVw");

var $9Letn = parcelRequire("9Letn");

var $gXgTX = parcelRequire("gXgTX");

var $8wyKH = parcelRequire("8wyKH");
const $7530d013c7b307d8$var$dropdownExpandContainer = /*#__PURE__*/ (0, $1NIU8.css)({
    margin: `0px ${"var(--ds-space-negative-050, -4px)"}`
});
const $7530d013c7b307d8$var$EditToolbarButtonPresentation = ({ datasourceId: datasourceId, currentAppearance: currentAppearance, editorAnalyticsApi: editorAnalyticsApi, editVariant: editVariant, editorView: editorView, extensionKey: extensionKey, onLinkEditClick: onLinkEditClick, intl: intl })=>{
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const containerRef = (0, $eJOHy.useRef)();
    const toggleOpen = ()=>setIsOpen((open)=>!open);
    const onClose = ()=>setIsOpen(false);
    const onEditLink = (0, $eJOHy.useCallback)(()=>{
        if (editorView) {
            onLinkEditClick(editorView.state, editorView.dispatch);
            (0, $gXgTX.focusEditorView)(editorView);
        }
    }, [
        editorView,
        onLinkEditClick
    ]);
    const onEditDatasource = (0, $eJOHy.useCallback)(()=>{
        if (editorView && datasourceId) {
            (0, $8wyKH.editDatasource)(datasourceId, editorAnalyticsApi, currentAppearance, extensionKey)(editorView.state, editorView.dispatch);
            (0, $gXgTX.focusEditorView)(editorView);
        }
    }, [
        currentAppearance,
        datasourceId,
        editorAnalyticsApi,
        editorView,
        extensionKey
    ]);
    const isControlsOn = (0, $9Letn.expValEqualsNoExposure)('platform_editor_controls', 'cohort', 'variant1');
    const icon = isControlsOn ? /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gTr6H))), {
        label: ""
    }) : undefined;
    const tooltipContent = isControlsOn && (0, $eGOwo.fg)('platform_editor_controls_patch_13') ? intl.formatMessage((0, $4AqYB.linkToolbarMessages).editLink) : undefined;
    switch(editVariant){
        case 'edit-link':
            return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $2sLVw.default), {
                gap: "space.050"
            }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $knwdo.default), {
                testId: "edit-link",
                onClick: onEditLink,
                icon: icon,
                tooltipContent: tooltipContent
            }, !isControlsOn && /*#__PURE__*/ (0, $1NIU8.jsx)((0, $kDaaB.default), (0, $4AqYB.linkToolbarMessages).editLink)), !isControlsOn && /*#__PURE__*/ (0, $1NIU8.jsx)((0, $84CN8.default), null));
        case 'edit-datasource':
            return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $2sLVw.default), {
                gap: "space.050"
            }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $knwdo.default), {
                testId: "edit-datasource",
                tooltipContent: intl.formatMessage((0, $4AqYB.linkToolbarMessages).editDatasourceStandaloneTooltip),
                onClick: onEditDatasource
            }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $kDaaB.default), (0, $4AqYB.linkToolbarMessages).editDatasourceStandalone)), !isControlsOn && /*#__PURE__*/ (0, $1NIU8.jsx)((0, $84CN8.default), null));
        case 'edit-dropdown':
            {
                const trigger = /*#__PURE__*/ (0, $1NIU8.jsx)((0, $2sLVw.default), {
                    gap: "space.050"
                }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $knwdo.default), {
                    testId: "edit-dropdown-trigger",
                    iconAfter: /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
                        css: $7530d013c7b307d8$var$dropdownExpandContainer
                    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5lAAn))), {
                        label: intl.formatMessage((0, $6dRXt.messages).editDropdownTriggerTitle),
                        size: "small"
                    })),
                    onClick: toggleOpen,
                    selected: isOpen,
                    disabled: false,
                    ariaHasPopup: true
                }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $kDaaB.default), (0, $6dRXt.messages).editDropdownTriggerTitle)), !isControlsOn && /*#__PURE__*/ (0, $1NIU8.jsx)((0, $84CN8.default), null));
                return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $2sLVw.default), {
                    ref: containerRef
                }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $cigQc.DropdownContainer), {
                    mountTo: containerRef.current,
                    isOpen: isOpen,
                    handleClickOutside: onClose,
                    handleEscapeKeydown: onClose,
                    trigger: trigger,
                    scrollableElement: containerRef.current,
                    arrowKeyNavigationProviderOptions: {
                        type: (0, $UpZp1.ArrowKeyNavigationType).MENU
                    }
                }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $7saMl.default), {
                    key: "edit.link",
                    onClick: onEditLink,
                    testId: "edit-dropdown-edit-link-item"
                }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $kDaaB.default), (0, $6dRXt.messages).editDropdownEditLinkTitle)), /*#__PURE__*/ (0, $1NIU8.jsx)((0, $7saMl.default), {
                    key: "edit.datasource",
                    onClick: onEditDatasource,
                    testId: "edit-dropdown-edit-datasource-item"
                }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $kDaaB.default), (0, $6dRXt.messages).editDropdownEditDatasourceTitle))));
            }
        case 'none':
        default:
            return null;
    }
};
var $7530d013c7b307d8$export$2e2bcd8739ae039 = $7530d013c7b307d8$var$EditToolbarButtonPresentation;

});


parcelRegister("4i0BY", function(module, exports) {

$parcel$export(module.exports, "HyperlinkToolbarAppearance", () => $09be7edd9f2f3e48$export$33d351e602b13f5c);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $bMFKb = parcelRequire("bMFKb");

var $84CN8 = parcelRequire("84CN8");

var $2sLVw = parcelRequire("2sLVw");

var $avkZu = parcelRequire("avkZu");

var $f9t1Y = parcelRequire("f9t1Y");
function $09be7edd9f2f3e48$export$33d351e602b13f5c(props) {
    const [supportedUrlsMap, setSupportedUrlsMap] = (0, $eJOHy.useState)(new Map());
    const cardProvider = (0, $eJOHy.useRef)(undefined);
    const { url: url, intl: intl, editorView: editorView, editorState: editorState, cardOptions: cardOptions, editorAnalyticsApi: editorAnalyticsApi } = props;
    // Ignored via go/ees005
    // eslint-disable-next-line require-await
    const getProvider = async ()=>{
        if (props.cardOptions?.provider) return props.cardOptions?.provider;
        if (cardProvider.current) return cardProvider.current;
        return new Promise((resolve)=>{
            const cardProvider = props.editorPluginApi?.card?.sharedState?.currentState()?.provider;
            if (cardProvider) resolve(cardProvider);
        });
    };
    const resolveUrl = async (url)=>{
        if (supportedUrlsMap.has(url)) return;
        let isUrlSupported = false;
        try {
            const provider = await getProvider();
            isUrlSupported = await provider?.findPattern(url) ?? false;
        } catch (error) {
            isUrlSupported = false;
        }
        const newMap = new Map(supportedUrlsMap);
        newMap.set(url, isUrlSupported);
        setSupportedUrlsMap(newMap);
    };
    (0, $eJOHy.useEffect)(()=>{
        resolveUrl(url);
    // before migrating from a class to a functional component, we were only reacting to changes in the url
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        url,
        props.cardOptions?.provider,
        props.editorPluginApi
    ]);
    if (!supportedUrlsMap.get(url)) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $2sLVw.default), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $f9t1Y.LinkToolbarAppearance), {
                url: url,
                intl: intl,
                editorView: editorView,
                editorState: editorState,
                allowEmbeds: cardOptions?.allowEmbeds,
                allowBlockCards: cardOptions?.allowBlockCards,
                editorAnalyticsApi: editorAnalyticsApi
            }, "link-appearance"),
            cardOptions?.allowDatasource && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $avkZu.DatasourceAppearanceButton), {
                intl: intl,
                url: url,
                editorState: editorState,
                editorView: editorView,
                editorAnalyticsApi: editorAnalyticsApi,
                inputMethod: (0, $bMFKb.INPUT_METHOD).FLOATING_TB
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $84CN8.default), {})
        ]
    });
}

});
parcelRegister("f9t1Y", function(module, exports) {

$parcel$export(module.exports, "LinkToolbarAppearance", () => $12b1a2d16292732a$export$2a8c6fb42753b13e);
$parcel$export(module.exports, "getUnavailableMessage", () => $12b1a2d16292732a$export$74e77d31eb18de27);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $e2B2h = parcelRequire("e2B2h");

var $bMFKb = parcelRequire("bMFKb");

var $6C2m6 = parcelRequire("6C2m6");
var $8AkZQ = parcelRequire("8AkZQ");
var $5TWRg = parcelRequire("5TWRg");

var $6dRXt = parcelRequire("6dRXt");
var $h2yqz = parcelRequire("h2yqz");

var $9Ssie = parcelRequire("9Ssie");

var $3xw6l = parcelRequire("3xw6l");

var $4AOcQ = parcelRequire("4AOcQ");

var $gXgTX = parcelRequire("gXgTX");

var $d62Vl = parcelRequire("d62Vl");

var $8ATyg = parcelRequire("8ATyg");

var $3YtqI = parcelRequire("3YtqI");

var $lSHus = parcelRequire("lSHus");
class $12b1a2d16292732a$export$2a8c6fb42753b13e extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    render() {
        const { editorView: editorView } = this.props;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lSHus.WithCardContext), {
            children: (cardContext)=>this.renderDropdown(editorView, cardContext && cardContext.value)
        });
    }
    constructor(...args){
        super(...args), this.renderDropdown = (view, cardContext)=>{
            const { url: url, intl: intl, currentAppearance: currentAppearance, editorState: editorState, allowEmbeds: allowEmbeds, allowBlockCards: allowBlockCards = true, editorAnalyticsApi: editorAnalyticsApi, showUpgradeDiscoverability: showUpgradeDiscoverability = true, isDatasourceView: isDatasourceView } = this.props;
            const preview = allowEmbeds && cardContext && url && cardContext.extractors.getPreview(url, 'web');
            const defaultCommand = ()=>false;
            if (url) {
                const urlState = cardContext?.store?.getState()[url];
                if (urlState?.error?.kind === 'fatal') return null;
            }
            const isBlockCardLinkSupportedInParent = allowBlockCards ? (0, $9Ssie.isSupportedInParent)(editorState, (0, $3xw6l.Fragment).from(editorState.schema.nodes.blockCard.createChecked({})), currentAppearance) : false;
            const isEmbedCardLinkSupportedInParent = allowEmbeds ? (0, $9Ssie.isSupportedInParent)(editorState, (0, $3xw6l.Fragment).from(editorState.schema.nodes.embedCard.createChecked({})), currentAppearance) : false;
            const embedOption = allowEmbeds && preview && {
                appearance: 'embed',
                title: intl.formatMessage((0, $6dRXt.messages).embed),
                onClick: (0, $4AOcQ.setSelectedCardAppearance)('embed', editorAnalyticsApi) ?? defaultCommand,
                selected: currentAppearance === 'embed',
                hidden: false,
                testId: 'embed-appearance',
                disabled: !isEmbedCardLinkSupportedInParent,
                tooltip: isEmbedCardLinkSupportedInParent ? undefined : $12b1a2d16292732a$export$74e77d31eb18de27(editorState, intl)
            };
            const blockCardOption = allowBlockCards && {
                appearance: 'block',
                title: intl.formatMessage((0, $6dRXt.messages).block),
                onClick: (0, $4AOcQ.setSelectedCardAppearance)('block', editorAnalyticsApi) ?? defaultCommand,
                selected: currentAppearance === 'block' && !isDatasourceView,
                testId: 'block-appearance',
                disabled: !isBlockCardLinkSupportedInParent,
                tooltip: isBlockCardLinkSupportedInParent ? undefined : $12b1a2d16292732a$export$74e77d31eb18de27(editorState, intl)
            };
            const options = [
                {
                    title: intl.formatMessage((0, $6dRXt.messages).url),
                    onClick: (0, $6C2m6.commandWithMetadata)((0, $4AOcQ.changeSelectedCardToLink)(url, url, true, undefined, undefined, editorAnalyticsApi) ?? defaultCommand, {
                        action: (0, $bMFKb.ACTION).CHANGED_TYPE
                    }),
                    selected: !currentAppearance && !isDatasourceView,
                    testId: 'url-appearance'
                },
                {
                    appearance: 'inline',
                    title: intl.formatMessage((0, $6dRXt.messages).inline),
                    onClick: (0, $4AOcQ.setSelectedCardAppearance)('inline', editorAnalyticsApi) ?? defaultCommand,
                    selected: currentAppearance === 'inline',
                    testId: 'inline-appearance'
                }
            ];
            const dispatchCommand = (fn)=>{
                fn && fn(editorState, view && view.dispatch);
                // Refocus the view to ensure the editor has focus
                if (view && !view.hasFocus()) view.focus();
            };
            if (blockCardOption) options.push(blockCardOption);
            if (embedOption) options.push(embedOption);
            const LinkToolbarButtons = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5TWRg.LinkToolbarButtonGroup), {
                options: options.map((option)=>(0, $8AkZQ.getButtonGroupOption)(intl, dispatchCommand, {
                        ...option,
                        onClick: (0, $6C2m6.commandWithMetadata)(option.onClick, {
                            inputMethod: (0, $bMFKb.INPUT_METHOD).FLOATING_TB
                        })
                    }))
            }, "link-toolbar-button-group");
            const status = url ? cardContext?.store?.getState()[url]?.status : '';
            const embedEnabled = embedOption ? !embedOption.disabled : false;
            if ((0, $3YtqI.shouldRenderToolbarPulse)(embedEnabled, currentAppearance ?? '', status ?? '', showUpgradeDiscoverability)) {
                const resolvedAnalyticsAttributes = (0, $gXgTX.getResolvedAttributesFromStore)(url || '', currentAppearance || null, cardContext?.store);
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $e2B2h.default), {
                    data: {
                        attributes: {
                            ...resolvedAnalyticsAttributes
                        }
                    },
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8ATyg.DiscoveryPulse), {
                        localStorageKey: (0, $d62Vl.LOCAL_STORAGE_DISCOVERY_KEY_TOOLBAR),
                        testId: "toolbar-discovery-pulse",
                        children: LinkToolbarButtons
                    })
                });
            }
            return LinkToolbarButtons;
        };
    }
}
const $12b1a2d16292732a$export$74e77d31eb18de27 = (state, intl)=>{
    try {
        const parentNode = state.selection.$from.node(1);
        const parentName = intl.formatMessage((0, $h2yqz.default)[parentNode.type.name]);
        const tooltip = intl.formatMessage((0, $6dRXt.messages).displayOptionUnavailableInParentNode, {
            node: parentName
        });
        return tooltip;
    } catch (e) {
        return intl.formatMessage((0, $6dRXt.messages).displayOptionUnavailableInParentNode, {
            node: intl.formatMessage((0, $h2yqz.default).defaultBlockNode)
        });
    }
};

});
parcelRegister("8AkZQ", function(module, exports) {

$parcel$export(module.exports, "appearancePropsMap", () => $8a74e46d3009d07d$export$b5524c7a5a82630a);
$parcel$export(module.exports, "getButtonGroupOption", () => $8a74e46d3009d07d$export$9de0d67eaa25f178);

var $FvAEI = parcelRequire("FvAEI");

var $jPzEK = parcelRequire("jPzEK");

var $je1LG = parcelRequire("je1LG");

var $aWGP9 = parcelRequire("aWGP9");

var $6dRXt = parcelRequire("6dRXt");

var $lOVsq = parcelRequire("lOVsq");

var $9CWxx = parcelRequire("9CWxx");

var $gJTEU = parcelRequire("gJTEU");

var $1D0xY = parcelRequire("1D0xY");
const $8a74e46d3009d07d$export$b5524c7a5a82630a = {
    url: {
        title: (0, $6dRXt.messages).urlTitle,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($FvAEI))),
        iconFallback: (0, $1D0xY.IconUrl)
    },
    inline: {
        title: (0, $6dRXt.messages).inlineTitle,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($aWGP9))),
        iconFallback: (0, $gJTEU.IconInline)
    },
    block: {
        title: (0, $6dRXt.messages).blockTitle,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jPzEK))),
        iconFallback: (0, $lOVsq.IconCard)
    },
    embed: {
        title: (0, $6dRXt.messages).embedTitle,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($je1LG))),
        iconFallback: (0, $9CWxx.IconEmbed)
    }
};
const $8a74e46d3009d07d$export$9de0d67eaa25f178 = (intl, dispatchCommand, { disabled: disabled, onClick: onClick, selected: selected, appearance: appearance, testId: testId, tooltip: tooltip })=>{
    const { title: title, icon: icon, iconFallback: iconFallback } = $8a74e46d3009d07d$export$b5524c7a5a82630a[appearance ?? 'url'];
    return {
        title: intl.formatMessage(title),
        icon: icon,
        iconFallback: iconFallback,
        onClick: ()=>dispatchCommand(onClick),
        disabled: Boolean(disabled),
        tooltipContent: tooltip || null,
        testId: testId,
        selected: selected
    };
};

});
parcelRegister("FvAEI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3e2df2c0b677df1945f42cd8e58b7f64>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $07cc559c093f5ea2$var$_react = $07cc559c093f5ea2$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $07cc559c093f5ea2$var$_baseNew = $07cc559c093f5ea2$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $07cc559c093f5ea2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Minus".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: horizontal rule in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $07cc559c093f5ea2$var$MinusIcon = (props)=>/*#__PURE__*/ $07cc559c093f5ea2$var$_react.default.createElement($07cc559c093f5ea2$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 8.75H1v-1.5h14z" clip-rule="evenodd"/>`
    }, props));
$07cc559c093f5ea2$var$MinusIcon.displayName = 'MinusIcon';
var $07cc559c093f5ea2$var$_default = module.exports.default = $07cc559c093f5ea2$var$MinusIcon;

});

parcelRegister("jPzEK", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0c54e3a438f254ab0e6b2d2ef082ee70>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e6fe7059125cd6b3$var$_react = $e6fe7059125cd6b3$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $e6fe7059125cd6b3$var$_baseNew = $e6fe7059125cd6b3$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $e6fe7059125cd6b3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SmartLinkCard".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing Smart link preview cards.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e6fe7059125cd6b3$var$SmartLinkCardIcon = (props)=>/*#__PURE__*/ $e6fe7059125cd6b3$var$_react.default.createElement($e6fe7059125cd6b3$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 4.5a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5h8v-7zm9.5 0v7H14a.5.5 0 0 0 .5-.5V5a.5.5 0 0 0-.5-.5zM0 5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm8.5 2.5H3V6h5.5zM6 10H3V8.5h3z" clip-rule="evenodd"/>`
    }, props));
$e6fe7059125cd6b3$var$SmartLinkCardIcon.displayName = 'SmartLinkCardIcon';
var $e6fe7059125cd6b3$var$_default = module.exports.default = $e6fe7059125cd6b3$var$SmartLinkCardIcon;

});

parcelRegister("je1LG", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::65acd7ea793f30a87884e2e95c9c21a4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dff0b240de09b5fc$var$_react = $dff0b240de09b5fc$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $dff0b240de09b5fc$var$_baseNew = $dff0b240de09b5fc$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $dff0b240de09b5fc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SmartLinkEmbed".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing Smart link embeds.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dff0b240de09b5fc$var$SmartLinkEmbedIcon = (props)=>/*#__PURE__*/ $dff0b240de09b5fc$var$_react.default.createElement($dff0b240de09b5fc$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v4h11V3a.5.5 0 0 0-.5-.5zm10.5 6h-11V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5zm-8-3H4V4h1.5zm6.5 0H7V4h5z" clip-rule="evenodd"/>`
    }, props));
$dff0b240de09b5fc$var$SmartLinkEmbedIcon.displayName = 'SmartLinkEmbedIcon';
var $dff0b240de09b5fc$var$_default = module.exports.default = $dff0b240de09b5fc$var$SmartLinkEmbedIcon;

});

parcelRegister("aWGP9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::40b4b1c775e02fc4e0dc167cf0c4dadb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7f808a250060a3b0$var$_react = $7f808a250060a3b0$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $7f808a250060a3b0$var$_baseNew = $7f808a250060a3b0$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $7f808a250060a3b0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SmartLinkInline".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing inline Smart link lozenges.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7f808a250060a3b0$var$SmartLinkInlineIcon = (props)=>/*#__PURE__*/ $7f808a250060a3b0$var$_react.default.createElement($7f808a250060a3b0$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 6.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2.5v-3zm4 0v3h8a.5.5 0 0 0 .5-.5V7a.5.5 0 0 0-.5-.5zM0 7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$7f808a250060a3b0$var$SmartLinkInlineIcon.displayName = 'SmartLinkInlineIcon';
var $7f808a250060a3b0$var$_default = module.exports.default = $7f808a250060a3b0$var$SmartLinkInlineIcon;

});

parcelRegister("lOVsq", function(module, exports) {

$parcel$export(module.exports, "IconCard", () => $87bec0be7970e9af$export$f215a85d3e7de2fe);
/* eslint-disable @atlaskit/design-system/no-custom-icons */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $87bec0be7970e9af$var$IconCardGlyph = (props)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8 9c-1.10457 0-2 .89543-2 2v10c0 1.1046.89543 2 2 2h16c1.1046 0 2-.8954 2-2V11c0-1.10457-.8954-2-2-2H8Zm0 3c0-.5523.44772-1 1-1h2c.5523 0 1 .4477 1 1v2c0 .5523-.4477 1-1 1H9c-.55228 0-1-.4477-1-1v-2Zm5 1c0-.2761.2239-.5.5-.5h10c.2761 0 .5.2239.5.5s-.2239.5-.5.5h-10c-.2761 0-.5-.2239-.5-.5Zm-4 3c-.55228 0-1 .4477-1 1s.44772 1 1 1h14c.5523 0 1-.4477 1-1s-.4477-1-1-1H9Zm-1 4c0-.5523.44772-1 1-1h6c.5523 0 1 .4477 1 1s-.4477 1-1 1H9c-.55228 0-1-.4477-1-1Z",
            fill: "currentColor"
        })
    });
};
const $87bec0be7970e9af$export$f215a85d3e7de2fe = (props)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.default), {
        glyph: $87bec0be7970e9af$var$IconCardGlyph,
        ...props
    });
};

});

parcelRegister("9CWxx", function(module, exports) {

$parcel$export(module.exports, "IconEmbed", () => $6745db4047c32164$export$6e9714fda61b68c1);
/* eslint-disable @atlaskit/design-system/no-custom-icons */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $6745db4047c32164$var$IconEmbedGlyph = (props)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8 6c-1.10457 0-2 .89543-2 2v16c0 1.1046.89543 2 2 2h16c1.1046 0 2-.8954 2-2V8c0-1.10457-.8954-2-2-2H8Zm1 2c-.55228 0-1 .44772-1 1v2c0 .5523.44772 1 1 1h2c.5523 0 1-.4477 1-1V9c0-.55228-.4477-1-1-1H9Zm4.5 1.5c-.2761 0-.5.22386-.5.5 0 .2761.2239.5.5.5h10c.2761 0 .5-.2239.5-.5 0-.27614-.2239-.5-.5-.5h-10ZM9 14c-.55228 0-1 .4477-1 1v8c0 .5523.44772 1 1 1h14c.5523 0 1-.4477 1-1v-8c0-.5523-.4477-1-1-1H9Zm6 2.5c0 .8284-.6716 1.5-1.5 1.5s-1.5-.6716-1.5-1.5.6716-1.5 1.5-1.5 1.5.6716 1.5 1.5Zm0 5.5-1-1-2 2h8v-1.8L18 19l-3 3Z",
            fill: "currentColor"
        })
    });
};
const $6745db4047c32164$export$6e9714fda61b68c1 = (props)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.default), {
        glyph: $6745db4047c32164$var$IconEmbedGlyph,
        ...props
    });
};

});

parcelRegister("gJTEU", function(module, exports) {

$parcel$export(module.exports, "IconInline", () => $2f4f49e00f368d25$export$f96c97cd8120c1d7);
/* eslint-disable @atlaskit/design-system/no-custom-icons */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $2f4f49e00f368d25$var$IconInlineGlyph = (props)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8 12c-1.10457 0-2 .8954-2 2v4c0 1.1046.89543 2 2 2h16c1.1046 0 2-.8954 2-2v-4c0-1.1046-.8954-2-2-2H8Zm0 3c0-.5523.44772-1 1-1h2c.5523 0 1 .4477 1 1v2c0 .5523-.4477 1-1 1H9c-.55228 0-1-.4477-1-1v-2Zm5 1c0-.2761.2239-.5.5-.5h10c.2761 0 .5.2239.5.5s-.2239.5-.5.5h-10c-.2761 0-.5-.2239-.5-.5Z",
            fill: "currentColor"
        })
    });
};
const $2f4f49e00f368d25$export$f96c97cd8120c1d7 = (props)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.default), {
        glyph: $2f4f49e00f368d25$var$IconInlineGlyph,
        ...props
    });
};

});

parcelRegister("1D0xY", function(module, exports) {

$parcel$export(module.exports, "IconUrl", () => $74fb90195c80f9df$export$faea2896e79f2987);
/* eslint-disable @atlaskit/design-system/no-custom-icons */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $74fb90195c80f9df$var$IconUrlGlyph = (props)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("rect", {
            x: "6",
            y: "15",
            width: "20",
            height: "2",
            rx: "1",
            fill: "currentColor"
        })
    });
};
const $74fb90195c80f9df$export$faea2896e79f2987 = (props)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fL0In.default), {
        glyph: $74fb90195c80f9df$var$IconUrlGlyph,
        ...props
    });
};

});


parcelRegister("5TWRg", function(module, exports) {

$parcel$export(module.exports, "LinkToolbarButtonGroup", () => $57bcb9e98c596496$export$41ba5f90e13b0c51);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $48q59 = parcelRequire("48q59");

var $knwdo = parcelRequire("knwdo");
function $57bcb9e98c596496$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Applying `pointer-events: none;` when disabled allows the Tooltip to be displayed
 */ const $57bcb9e98c596496$var$buttonStyle = {
    name: "1quw0ni",
    styles: "pointer-events:auto"
};
const $57bcb9e98c596496$var$buttonStyleNoneEvent = {
    name: "je8g23",
    styles: "pointer-events:none"
};
const $57bcb9e98c596496$var$DisallowedWrapper = ({ disabled: disabled, ...props })=>{
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", props);
};
/**
 * The button requires `pointer-events: none;` in order to fix the tooltip, hence
 * leaving us without a disabled cursor, the following fixes this:
 */ const $57bcb9e98c596496$var$defaultWrapperStyle = {
    name: "e0dnmk",
    styles: "cursor:pointer"
};
const $57bcb9e98c596496$var$disallowedWrapperStyle = {
    name: "1sfig4b",
    styles: "cursor:not-allowed"
};
const $57bcb9e98c596496$export$41ba5f90e13b0c51 = ({ options: options })=>{
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $48q59.default), null, options.map(({ onClick: onClick, selected: selected, disabled: disabled, testId: testId, tooltipContent: tooltipContent, title: title, icon: icon, iconFallback: iconFallback })=>{
        const ButtonIcon = icon;
        return /*#__PURE__*/ (0, $1NIU8.jsx)($57bcb9e98c596496$var$DisallowedWrapper, {
            css: disabled ? $57bcb9e98c596496$var$disallowedWrapperStyle : $57bcb9e98c596496$var$defaultWrapperStyle,
            key: testId,
            disabled: disabled
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $knwdo.default), {
            css: disabled ? $57bcb9e98c596496$var$buttonStyleNoneEvent : $57bcb9e98c596496$var$buttonStyle,
            title: title,
            icon: /*#__PURE__*/ (0, $1NIU8.jsx)(ButtonIcon, {
                label: title,
                spacing: "spacious",
                LEGACY_size: "medium",
                LEGACY_fallbackIcon: iconFallback
            }),
            selected: selected,
            onClick: onClick,
            testId: testId,
            disabled: disabled,
            tooltipContent: tooltipContent
        }));
    }));
};

});

parcelRegister("d62Vl", function(module, exports) {

$parcel$export(module.exports, "LOCAL_STORAGE_DISCOVERY_KEY_SMART_LINK", () => $63da1a263e8a1d97$export$613f4cbb1d6327d6);
$parcel$export(module.exports, "LOCAL_STORAGE_DISCOVERY_KEY_TOOLBAR", () => $63da1a263e8a1d97$export$b1ab83c904a5352e);
$parcel$export(module.exports, "ONE_DAY_IN_MILLISECONDS", () => $63da1a263e8a1d97$export$2cf27d95188f1c13);
$parcel$export(module.exports, "isLocalStorageKeyDiscovered", () => $63da1a263e8a1d97$export$f029a1bf9ca298da);
$parcel$export(module.exports, "markLocalStorageKeyDiscovered", () => $63da1a263e8a1d97$export$6b9d1ae5ec92c88e);

var $aOPCi = parcelRequire("aOPCi");
const $63da1a263e8a1d97$export$c0fd7e3ed450d078 = '@atlaskit/editor-plugin-card';
const $63da1a263e8a1d97$export$4521957a9ae858f5 = 'discovered';
const $63da1a263e8a1d97$export$613f4cbb1d6327d6 = 'smart-link-upgrade-pulse';
const $63da1a263e8a1d97$export$b1ab83c904a5352e = 'toolbar-upgrade-pulse';
const $63da1a263e8a1d97$export$2cf27d95188f1c13 = 86400000;
const $63da1a263e8a1d97$var$storageClient = new (0, $aOPCi.default)($63da1a263e8a1d97$export$c0fd7e3ed450d078);
const $63da1a263e8a1d97$export$f029a1bf9ca298da = (key)=>{
    try {
        const localStorageValue = $63da1a263e8a1d97$var$storageClient.getItem(key);
        return !!localStorageValue && localStorageValue === $63da1a263e8a1d97$export$4521957a9ae858f5;
    } catch  {
        // If localStorage is not available, don't show feature discovery component. Treat it as 'discovered'.
        return true;
    }
};
const $63da1a263e8a1d97$export$6b9d1ae5ec92c88e = (key, expiration)=>{
    try {
        $63da1a263e8a1d97$var$storageClient.setItemWithExpiry(key, $63da1a263e8a1d97$export$4521957a9ae858f5, expiration);
    } catch  {
    // silent error
    }
};

});

parcelRegister("8ATyg", function(module, exports) {

$parcel$export(module.exports, "DiscoveryPulse", () => $f9e06c9dfb3bb4fb$export$1f5748a1623673d7);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $4Z1Dh = parcelRequire("4Z1Dh");

var $d62Vl = parcelRequire("d62Vl");
const $f9e06c9dfb3bb4fb$export$1f5748a1623673d7 = ({ children: children, localStorageKey: localStorageKey, localStorageKeyExpirationInMs: localStorageKeyExpirationInMs, discoveryMode: discoveryMode = 'iteration', shouldShowPulse: shouldShowPulse, testId: testId, isInline: isInline })=>{
    const discovered = (0, $d62Vl.isLocalStorageKeyDiscovered)(localStorageKey);
    const showPulse = shouldShowPulse ?? !discovered;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        if (showPulse) createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'pulse',
            eventType: 'ui',
            attributes: {
                pulseIdentifier: localStorageKey
            }
        }).fire('media');
    }, [
        createAnalyticsEvent,
        discovered,
        localStorageKey,
        showPulse
    ]);
    const onDiscovery = (0, $eJOHy.useCallback)(()=>{
        if (!discovered) (0, $d62Vl.markLocalStorageKeyDiscovered)(localStorageKey, localStorageKeyExpirationInMs);
    }, [
        discovered,
        localStorageKey,
        localStorageKeyExpirationInMs
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4Z1Dh.Pulse), {
        onAnimationIteration: discoveryMode === 'iteration' ? onDiscovery : undefined,
        onAnimationStart: discoveryMode === 'start' ? onDiscovery : undefined,
        showPulse: showPulse,
        testId: testId,
        isInline: isInline,
        children: children
    });
};

});
parcelRegister("4Z1Dh", function(module, exports) {

$parcel$export(module.exports, "Pulse", () => $c54328386f918dea$export$927d63e2511364c0);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eGOwo = parcelRequire("eGOwo");

var $eJOHy = parcelRequire("eJOHy");
const $c54328386f918dea$var$pulseKeyframes = null;
const $c54328386f918dea$var$pulseStyles = null;
const $c54328386f918dea$var$commonStyles = null;
const $c54328386f918dea$export$927d63e2511364c0 = ({ children: children, showPulse: showPulse = false, onAnimationIteration: onAnimationIteration, onAnimationStart: onAnimationStart, testId: testId = 'discovery-pulse', isInline: isInline = false })=>{
    // this ref is to persist the animation through rerenders
    const pulseStarted = (0, $eJOHy.useRef)(false);
    if (showPulse) pulseStarted.current = true;
    const stopPropagation = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((e)=>{
        e.stopPropagation();
    }, []);
    const WrapperTag = isInline ? 'span' : 'div';
    if ((0, $eGOwo.fg)('platform_ssr_smartlinks_editor')) return /*#__PURE__*/ (0, $gt9Am.jsx)(WrapperTag, {
        "data-testid": testId,
        onAnimationIteration: onAnimationIteration,
        onAnimationStart: onAnimationStart,
        className: (0, $hcewu.default)([
            "_1e0c1nu9",
            pulseStarted.current && "",
            pulseStarted.current && "_2rko1l7b _16qs1tze _j7hq8j16 _5sagw34l _1pgl1trn _tip811wp"
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
            onAnimationIteration: stopPropagation,
            onAnimationStart: stopPropagation,
            children: children
        })
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId,
        onAnimationIteration: onAnimationIteration,
        onAnimationStart: onAnimationStart,
        className: (0, $hcewu.default)([
            "_1e0c1nu9",
            pulseStarted.current && "",
            pulseStarted.current && "_2rko1l7b _16qs1tze _j7hq8j16 _5sagw34l _1pgl1trn _tip811wp"
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
            onAnimationIteration: stopPropagation,
            onAnimationStart: stopPropagation,
            children: children
        })
    });
};
var $c54328386f918dea$export$2e2bcd8739ae039 = $c54328386f918dea$export$927d63e2511364c0;

});


parcelRegister("lSHus", function(module, exports) {

$parcel$export(module.exports, "WithCardContext", () => $cb9112572790410e$export$722ea04dd4ef208e);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $9kfy2 = parcelRequire("9kfy2");
const $cb9112572790410e$export$722ea04dd4ef208e = ({ children: children })=>{
    const cardContext = (0, $9kfy2.useSmartCardContext)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: children(cardContext)
    });
};

});



parcelRegister("lPmSF", function(module, exports) {

$parcel$export(module.exports, "getCustomHyperlinkAppearanceDropdown", () => $90a45a40d0ab0e4e$export$5b48c4cfa5ad82e1);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8AkZQ = parcelRequire("8AkZQ");

var $knwdo = parcelRequire("knwdo");
var $84CN8 = parcelRequire("84CN8");

var $UpZp1 = parcelRequire("UpZp1");
var $cigQc = parcelRequire("cigQc");

var $5lAAn = parcelRequire("5lAAn");

var $eGOwo = parcelRequire("eGOwo");

var $2sLVw = parcelRequire("2sLVw");

var $9Letn = parcelRequire("9Letn");

var $3mqGE = parcelRequire("3mqGE");
const $90a45a40d0ab0e4e$var$CustomHyperlinkDropdown = (props)=>{
    const [supportedUrlsMap, setSupportedUrlsMap] = (0, $eJOHy.useState)(new Map());
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const cardProvider = (0, $eJOHy.useRef)(undefined);
    const containerRef = (0, $eJOHy.useRef)(undefined);
    const { url: url, intl: intl, editorView: editorView, cardOptions: cardOptions, editorAnalyticsApi: editorAnalyticsApi, allowDatasource: allowDatasource, isDatasourceView: isDatasourceView, settingsConfig: settingsConfig } = props;
    // Ignored via go/ees005
    // eslint-disable-next-line require-await
    const getProvider = async ()=>{
        if (props.cardOptions?.provider) return props.cardOptions?.provider;
        if (cardProvider.current) return cardProvider.current;
        return new Promise((resolve)=>{
            const cardProvider = props.editorPluginApi?.card?.sharedState?.currentState()?.provider;
            if (cardProvider) resolve(cardProvider);
        });
    };
    const resolveUrl = async (url)=>{
        if (supportedUrlsMap.has(url)) return;
        let isUrlSupported = false;
        try {
            const provider = await getProvider();
            isUrlSupported = await provider?.findPattern(url) ?? false;
        } catch (error) {
            isUrlSupported = false;
        }
        const newMap = new Map(supportedUrlsMap);
        newMap.set(url, isUrlSupported);
        setSupportedUrlsMap(newMap);
    };
    (0, $eJOHy.useEffect)(()=>{
        resolveUrl(url);
    // before migrating from a class to a functional component, we were only reacting to changes in the url
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        url,
        props.cardOptions?.provider,
        props.editorPluginApi
    ]);
    if (!supportedUrlsMap.get(url)) return null;
    if (!editorView) return null;
    const dispatchCommand = (fn)=>{
        fn && fn(editorView && editorView.state, editorView && editorView.dispatch, editorView);
        // Refocus the view to ensure the editor has focus
        if (editorView && !editorView.hasFocus()) editorView.focus();
    };
    const toggleOpen = ()=>setIsOpen((open)=>!open);
    const close = ()=>setIsOpen(false);
    const currentAppearanceDisplayInformation = (0, $8AkZQ.appearancePropsMap)['url'];
    const title = intl.formatMessage(currentAppearanceDisplayInformation.title);
    const trigger = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $knwdo.default), {
        selected: isOpen,
        title: title,
        "aria-label": title,
        "aria-expanded": isOpen,
        "aria-haspopup": true,
        onClick: toggleOpen,
        icon: currentAppearanceDisplayInformation.icon({
            label: ''
        }),
        iconAfter: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5lAAn))), {
            label: "",
            spacing: "compact",
            size: "small"
        }),
        children: title
    });
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $2sLVw.default), {
        ref: containerRef,
        gap: "space.075",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cigQc.DropdownContainer), {
                mountTo: containerRef.current,
                isOpen: isOpen,
                handleClickOutside: close,
                handleEscapeKeydown: close,
                trigger: trigger,
                scrollableElement: containerRef.current,
                arrowKeyNavigationProviderOptions: {
                    type: (0, $UpZp1.ArrowKeyNavigationType).MENU
                },
                fitHeight: 400,
                fitWidth: 200,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3mqGE.LinkAppearanceMenu), {
                    url: url,
                    intl: intl,
                    currentAppearance: undefined,
                    editorState: editorView.state,
                    allowEmbeds: cardOptions?.allowEmbeds,
                    allowBlockCards: cardOptions?.allowBlockCards,
                    editorAnalyticsApi: editorAnalyticsApi,
                    isDatasourceView: isDatasourceView,
                    allowDatasource: allowDatasource,
                    dispatchCommand: dispatchCommand,
                    settingsConfig: settingsConfig
                })
            }),
            !((0, $9Letn.expValEqualsNoExposure)('platform_editor_controls', 'cohort', 'variant1') && (0, $eGOwo.fg)('platform_editor_controls_patch_15')) && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $84CN8.default), {})
        ]
    });
};
const $90a45a40d0ab0e4e$export$5b48c4cfa5ad82e1 = ({ url: url, intl: intl, editorAnalyticsApi: editorAnalyticsApi, editorPluginApi: editorPluginApi, settingsConfig: settingsConfig, cardOptions: cardOptions, allowDatasource: allowDatasource, isDatasourceView: isDatasourceView })=>{
    return {
        type: 'custom',
        fallback: [],
        render: (editorView)=>{
            if (!editorView) return;
            return /*#__PURE__*/ (0, $gt9Am.jsx)($90a45a40d0ab0e4e$var$CustomHyperlinkDropdown, {
                intl: intl,
                url: url,
                editorAnalyticsApi: editorAnalyticsApi,
                editorPluginApi: editorPluginApi,
                editorView: editorView,
                settingsConfig: settingsConfig,
                cardOptions: cardOptions,
                allowDatasource: allowDatasource,
                isDatasourceView: isDatasourceView
            });
        }
    };
};

});
parcelRegister("3mqGE", function(module, exports) {

$parcel$export(module.exports, "LinkAppearanceMenu", () => $1713fe0921b4410e$export$6ce0ca681c51cdfb);
$parcel$export(module.exports, "getLinkAppearanceDropdown", () => $1713fe0921b4410e$export$1faf5b64d0bbe935);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $bMFKb = parcelRequire("bMFKb");

var $8AkZQ = parcelRequire("8AkZQ");
var $6C2m6 = parcelRequire("6C2m6");
var $eALSB = parcelRequire("eALSB");

var $6dRXt = parcelRequire("6dRXt");
var $4AqYB = parcelRequire("4AqYB");

var $9Ssie = parcelRequire("9Ssie");

var $3xw6l = parcelRequire("3xw6l");

var $9kfy2 = parcelRequire("9kfy2");

var $7saMl = parcelRequire("7saMl");
var $f58rc = parcelRequire("f58rc");
var $jUgeq = parcelRequire("jUgeq");
var $6YEko = parcelRequire("6YEko");

var $4AOcQ = parcelRequire("4AOcQ");

var $4hKro = parcelRequire("4hKro");

var $f9t1Y = parcelRequire("f9t1Y");
const $1713fe0921b4410e$export$6ce0ca681c51cdfb = ({ url: url, intl: intl, currentAppearance: currentAppearance, editorState: editorState, allowEmbeds: allowEmbeds, allowBlockCards: allowBlockCards = true, allowDatasource: allowDatasource, editorAnalyticsApi: editorAnalyticsApi, showUpgradeDiscoverability: showUpgradeDiscoverability = true, isDatasourceView: isDatasourceView, dispatchCommand: dispatchCommand, settingsConfig: settingsConfig })=>{
    const cardContext = (0, $9kfy2.useSmartCardContext)();
    const preview = allowEmbeds && cardContext && url && cardContext.value?.extractors.getPreview(url, 'web');
    const defaultCommand = ()=>false;
    if (url) {
        const urlState = cardContext.value?.store?.getState()[url];
        if (urlState?.error?.kind === 'fatal') return null;
    }
    const isBlockCardLinkSupportedInParent = allowBlockCards ? (0, $9Ssie.isSupportedInParent)(editorState, (0, $3xw6l.Fragment).from(editorState.schema.nodes.blockCard.createChecked({})), currentAppearance) : false;
    const isEmbedCardLinkSupportedInParent = allowEmbeds ? (0, $9Ssie.isSupportedInParent)(editorState, (0, $3xw6l.Fragment).from(editorState.schema.nodes.embedCard.createChecked({})), currentAppearance) : false;
    const embedOption = allowEmbeds && preview && {
        appearance: 'embed',
        title: intl.formatMessage((0, $6dRXt.messages).embed),
        onClick: (0, $4AOcQ.setSelectedCardAppearance)('embed', editorAnalyticsApi) ?? defaultCommand,
        selected: currentAppearance === 'embed',
        hidden: false,
        testId: 'embed-appearance',
        disabled: !isEmbedCardLinkSupportedInParent,
        tooltip: isEmbedCardLinkSupportedInParent ? undefined : (0, $f9t1Y.getUnavailableMessage)(editorState, intl)
    };
    const blockCardOption = allowBlockCards && {
        appearance: 'block',
        title: intl.formatMessage((0, $6dRXt.messages).block),
        onClick: (0, $4AOcQ.setSelectedCardAppearance)('block', editorAnalyticsApi) ?? defaultCommand,
        selected: currentAppearance === 'block' && !isDatasourceView,
        testId: 'block-appearance',
        disabled: !isBlockCardLinkSupportedInParent,
        tooltip: isBlockCardLinkSupportedInParent ? undefined : (0, $f9t1Y.getUnavailableMessage)(editorState, intl)
    };
    const options = [
        {
            title: intl.formatMessage((0, $6dRXt.messages).url),
            onClick: (0, $6C2m6.commandWithMetadata)((0, $4AOcQ.changeSelectedCardToLink)(url, url, true, undefined, undefined, editorAnalyticsApi) ?? defaultCommand, {
                action: (0, $bMFKb.ACTION).CHANGED_TYPE
            }),
            selected: !currentAppearance && !isDatasourceView,
            testId: 'url-appearance'
        },
        {
            appearance: 'inline',
            title: intl.formatMessage((0, $6dRXt.messages).inline),
            onClick: (0, $4AOcQ.setSelectedCardAppearance)('inline', editorAnalyticsApi) ?? defaultCommand,
            selected: currentAppearance === 'inline',
            testId: 'inline-appearance'
        }
    ];
    if (blockCardOption) options.push(blockCardOption);
    if (embedOption) options.push(embedOption);
    const finalOptions = options.map((option)=>(0, $eALSB.getDropdownOption)(intl, dispatchCommand, {
            ...option,
            onClick: (0, $6C2m6.commandWithMetadata)(option.onClick, {
                inputMethod: (0, $bMFKb.INPUT_METHOD).FLOATING_TB
            })
        }));
    let Icon;
    if ('icon' in settingsConfig && settingsConfig.icon !== undefined) Icon = settingsConfig.icon;
    // TODO: ED-26961 - packages/editor/editor-plugin-card/src/ui/LinkToolbarAppearance.tsx supports change boarding via pulse
    // this implementation doesn't
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $jUgeq.default), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6YEko.default), {
                children: [
                    finalOptions.map((option)=>{
                        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7saMl.default), {
                            iconBefore: option.icon,
                            onClick: ()=>option.onClick(),
                            isSelected: option.selected,
                            children: option.title
                        }, option.title);
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4hKro.DatasourceDropdownOption), {
                        allowDatasource: allowDatasource,
                        intl: intl,
                        url: url ?? '',
                        selected: Boolean(isDatasourceView),
                        inputMethod: (0, $bMFKb.INPUT_METHOD).FLOATING_TB,
                        dispatchCommand: dispatchCommand
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6YEko.default), {
                hasSeparator: true,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $f58rc.default), {
                    iconBefore: Icon && /*#__PURE__*/ (0, $gt9Am.jsx)(Icon, {
                        label: "Settings"
                    }),
                    href: 'href' in settingsConfig ? settingsConfig.href : undefined,
                    target: 'target' in settingsConfig ? settingsConfig.target : undefined,
                    children: intl.formatMessage((0, $4AqYB.linkToolbarMessages).preferencesLink)
                })
            })
        ]
    });
};
const $1713fe0921b4410e$export$1faf5b64d0bbe935 = ({ url: url, intl: intl, currentAppearance: currentAppearance, editorState: editorState, allowEmbeds: allowEmbeds, allowBlockCards: allowBlockCards = true, allowDatasource: allowDatasource, editorAnalyticsApi: editorAnalyticsApi, showUpgradeDiscoverability: showUpgradeDiscoverability = true, isDatasourceView: isDatasourceView, settingsConfig: settingsConfig })=>{
    const alignmentItemOptions = {
        render: (props)=>{
            return /*#__PURE__*/ (0, $gt9Am.jsx)($1713fe0921b4410e$export$6ce0ca681c51cdfb, {
                url: url,
                intl: intl,
                currentAppearance: currentAppearance,
                editorState: editorState,
                allowEmbeds: allowEmbeds,
                allowBlockCards: allowBlockCards,
                editorAnalyticsApi: editorAnalyticsApi,
                showUpgradeDiscoverability: showUpgradeDiscoverability,
                isDatasourceView: isDatasourceView,
                allowDatasource: allowDatasource,
                dispatchCommand: props.dispatchCommand,
                settingsConfig: settingsConfig
            });
        },
        width: 200,
        height: 400
    };
    const currentAppearanceDisplayInformation = isDatasourceView ? (0, $4hKro.datasourceDisplayInformation) : (0, $8AkZQ.appearancePropsMap)[currentAppearance ?? 'url'];
    const alignmentToolbarItem = {
        id: 'card-appearance',
        testId: 'card-appearance-dropdown',
        type: 'dropdown',
        options: alignmentItemOptions,
        title: intl.formatMessage(currentAppearanceDisplayInformation.title),
        iconBefore: currentAppearanceDisplayInformation.icon
    };
    return alignmentToolbarItem;
};

});
parcelRegister("eALSB", function(module, exports) {

$parcel$export(module.exports, "getDropdownOption", () => $cd004a4b4e90807e$export$1405b80fcb4301ca);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $8AkZQ = parcelRequire("8AkZQ");
const $cd004a4b4e90807e$export$1405b80fcb4301ca = (intl, dispatchCommand, { disabled: disabled, onClick: onClick, selected: selected, appearance: appearance, testId: testId, tooltip: tooltip })=>{
    const { title: title, icon: Icon } = (0, $8AkZQ.appearancePropsMap)[appearance ?? 'url'];
    return {
        title: intl.formatMessage(title),
        icon: /*#__PURE__*/ (0, $gt9Am.jsx)(Icon, {
            label: intl.formatMessage(title)
        }),
        onClick: ()=>dispatchCommand(onClick),
        disabled: Boolean(disabled),
        testId: testId,
        selected: selected,
        tooltip: tooltip ?? ''
    };
};

});

parcelRegister("4hKro", function(module, exports) {

$parcel$export(module.exports, "datasourceDisplayInformation", () => $6e4089e57dec39ab$export$12f82ee4a2a1a1c9);
$parcel$export(module.exports, "DatasourceDropdownOption", () => $6e4089e57dec39ab$export$b08a863b9d82986d);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6dRXt = parcelRequire("6dRXt");

var $3lIcL = parcelRequire("3lIcL");

var $gLL5P = parcelRequire("gLL5P");

var $4hDhk = parcelRequire("4hDhk");

var $9kfy2 = parcelRequire("9kfy2");

var $7saMl = parcelRequire("7saMl");

var $4AOcQ = parcelRequire("4AOcQ");

var $cuJUr = parcelRequire("cuJUr");

var $XsiSM = parcelRequire("XsiSM");
const $6e4089e57dec39ab$export$12f82ee4a2a1a1c9 = {
    title: (0, $6dRXt.messages).datasourceAppearanceTitle,
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($gLL5P))),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($gLL5P)))
};
const $6e4089e57dec39ab$export$b08a863b9d82986d = ({ allowDatasource: allowDatasource, intl: intl, url: url, selected: selected, inputMethod: inputMethod, dispatchCommand: dispatchCommand })=>{
    const cardContext = (0, $9kfy2.useSmartLinkContext)();
    const { datasourceId: datasourceId, parameters: parameters } = (0, $XsiSM.useFetchDatasourceInfo)({
        isRegularCardNode: true,
        url: url,
        cardContext: cardContext
    });
    if (!allowDatasource || !datasourceId || !parameters) return null;
    const onChangeAppearance = (editorState, _dispatch, view)=>{
        if (!view || !datasourceId || !parameters) return false;
        const state = (0, $cuJUr.pluginKey).getState(editorState);
        const newAdf = (0, $4hDhk.buildDatasourceAdf)({
            id: datasourceId,
            parameters: parameters,
            views: state?.datasourceStash[url]?.views ?? [
                {
                    type: 'table'
                }
            ]
        }, url);
        const { selection: selection } = editorState;
        let existingNode;
        // Check if the selection contains a link mark
        const $pos = editorState.doc.resolve(selection.from);
        const isLinkMark = $pos.marks().some((mark)=>mark.type === editorState.schema.marks.link);
        // When selection is a TextNode and a link Mark is present return that node
        if (selection instanceof (0, $3lIcL.NodeSelection)) existingNode = selection.node;
        else if (isLinkMark) existingNode = editorState.doc.nodeAt(selection.from) ?? undefined;
        if (existingNode) {
            (0, $4AOcQ.updateCardViaDatasource)({
                state: editorState,
                node: existingNode,
                newAdf: newAdf,
                view: view,
                sourceEvent: undefined,
                isDeletingConfig: true,
                inputMethod: inputMethod
            });
            return true;
        }
        return false;
    };
    if (url) {
        const urlState = cardContext?.store?.getState()[url];
        if (urlState?.error?.kind === 'fatal') return null;
    }
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7saMl.default), {
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($gLL5P)))({
            label: intl.formatMessage((0, $6dRXt.messages).datasourceAppearanceTitle)
        }),
        onClick: ()=>dispatchCommand(onChangeAppearance),
        isSelected: selected,
        children: intl.formatMessage((0, $6dRXt.messages).datasourceAppearanceTitle)
    }, intl.formatMessage((0, $6dRXt.messages).datasourceAppearanceTitle));
};

});



parcelRegister("emx03", function(module, exports) {

$parcel$export(module.exports, "ToolbarViewedEvent", () => $e4d1328d7490bc71$export$998ac2a59a1547dd);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $9kfy2 = parcelRequire("9kfy2");

var $gXgTX = parcelRequire("gXgTX");

var $knfyn = parcelRequire("knfyn");
/**
 * Handles firing the toolbar viewed event
 */ const $e4d1328d7490bc71$var$ToolbarViewedEventBase = ({ url: url, display: display, cardContext: cardContext })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const store = cardContext?.store;
    (0, $eJOHy.useEffect)(()=>{
        createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'inlineDialog',
            actionSubjectId: 'editLinkToolbar',
            eventType: 'ui',
            attributes: {
                ...(0, $gXgTX.getResolvedAttributesFromStore)(url, display, store),
                display: display
            }
        }).fire('media');
    }, [
        createAnalyticsEvent,
        display,
        url,
        store
    ]);
    return null;
};
const $e4d1328d7490bc71$export$998ac2a59a1547dd = ({ url: url, display: display, editorView: editorView })=>{
    const cardContext = (0, $9kfy2.useSmartLinkContext)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $knfyn.EditorAnalyticsContext), {
        editorView: editorView,
        children: url ? /*#__PURE__*/ (0, $gt9Am.jsx)($e4d1328d7490bc71$var$ToolbarViewedEventBase, {
            url: url,
            display: display,
            cardContext: cardContext
        }) : null
    });
};

});
parcelRegister("knfyn", function(module, exports) {

$parcel$export(module.exports, "EditorAnalyticsContext", () => $67ee926e5f37b27a$export$b49e513cc101a4b6);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $e2B2h = parcelRequire("e2B2h");

var $dyNYh = parcelRequire("dyNYh");

var $d3z4A = parcelRequire("d3z4A");
const $67ee926e5f37b27a$export$b49e513cc101a4b6 = ({ editorView: editorView, children: children })=>{
    const editorAppearance = editorView ? (0, $d3z4A.getPluginState)(editorView.state)?.editorAppearance : undefined;
    const analyticsEditorAppearance = (0, $dyNYh.getAnalyticsEditorAppearance)(editorAppearance);
    const analyticsData = {
        attributes: {
            location: analyticsEditorAppearance
        },
        // Below is added for the future implementation of Linking Platform namespaced analytic context
        location: analyticsEditorAppearance
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $e2B2h.default), {
        data: analyticsData,
        children: children
    });
};

});
parcelRegister("d3z4A", function(module, exports) {

$parcel$export(module.exports, "getPluginState", () => $7306ff688c4c9c27$export$f05434c51e3762e);
$parcel$export(module.exports, "getPluginStateWithUpdatedPos", () => $7306ff688c4c9c27$export$be237c815d2927d4);
$parcel$export(module.exports, "getNewRequests", () => $7306ff688c4c9c27$export$cd9326e2f6dc42c0);

var $cuJUr = parcelRequire("cuJUr");
const $7306ff688c4c9c27$export$f05434c51e3762e = (editorState)=>(0, $cuJUr.pluginKey).getState(editorState);
const $7306ff688c4c9c27$export$be237c815d2927d4 = (pluginState, tr)=>({
        ...pluginState,
        requests: pluginState.requests.map((request)=>({
                ...request,
                pos: tr.mapping.map(request.pos)
            })),
        cards: pluginState.cards.map((card)=>({
                ...card,
                pos: tr.mapping.map(card.pos)
            }))
    });
const $7306ff688c4c9c27$export$cd9326e2f6dc42c0 = (oldState, currentState)=>{
    if (oldState) return currentState.requests.filter((req)=>!oldState.requests.find((oldReq)=>$7306ff688c4c9c27$var$isSameRequest(oldReq, req)));
    return currentState.requests;
};
const $7306ff688c4c9c27$var$isSameRequest = (requestA, requestB)=>requestA.url === requestB.url && requestA.pos === requestB.pos;

});




parcelRegister("gqKWA", function(module, exports) {

$parcel$export(module.exports, "Card", () => $06cf0cf44d4bf681$export$60332b2344f7fe41);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $iKozC = parcelRequire("iKozC");

var $e2B2h = parcelRequire("e2B2h");

var $kLQ9a = parcelRequire("kLQ9a");
var $bSToC = parcelRequire("bSToC");
var $cxXTK = parcelRequire("cxXTK");

var $dyNYh = parcelRequire("dyNYh");

var $eJ9f5 = parcelRequire("eJ9f5");

var $eGOwo = parcelRequire("eGOwo");

var $4AOcQ = parcelRequire("4AOcQ");

var $d3z4A = parcelRequire("d3z4A");

var $gXgTX = parcelRequire("gXgTX");

var $lSHus = parcelRequire("lSHus");
const $06cf0cf44d4bf681$var$selector = (states)=>{
    return {
        mode: states.editorViewModeState?.mode
    };
};
const $06cf0cf44d4bf681$var$useSharedState = (0, $kLQ9a.sharedPluginStateHookMigratorFactory)((pluginInjectionApi)=>{
    return (0, $cxXTK.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'editorViewMode'
    ], $06cf0cf44d4bf681$var$selector);
}, (pluginInjectionApi)=>{
    const { editorViewModeState: editorViewModeState } = (0, $bSToC.useSharedPluginState)(pluginInjectionApi, [
        'editorViewMode'
    ]);
    return {
        mode: editorViewModeState?.mode
    };
});
const $06cf0cf44d4bf681$var$WithClickHandler = ({ pluginInjectionApi: pluginInjectionApi, url: url, onClickCallback: onClickCallback, children: children, __livePage: __livePage })=>{
    const { mode: mode } = $06cf0cf44d4bf681$var$useSharedState(pluginInjectionApi);
    const onClick = (0, $eJOHy.useCallback)((event)=>{
        if (typeof onClickCallback === 'function') try {
            onClickCallback({
                event: event,
                url: url
            });
        } catch  {}
    }, [
        url,
        onClickCallback
    ]);
    if ((0, $eGOwo.fg)('linking_platform_smart_links_in_live_pages')) {
        // Ignored via go/ees007
        // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
        /**
		 * @todo: Add a check to determine if we're currently in a live page once ED-23920 and plugin
		 * is complete. The logic for which should allow navigation if we're in a live page and no callback
		 * has been provided. E.g.
		 *
		 * const allowNavigation = isLivePage && !onClickCallback;
		 */ const allowNavigation = __livePage && !onClickCallback;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
            children: children({
                onClick: allowNavigation ? undefined : onClick
            })
        });
    }
    // Setting `onClick` to `undefined` ensures clicks on smartcards navigate to the URL.
    // If in view mode and not overriding with onClickCallback option, then allow smartlinks to navigate on click.
    const allowNavigation = mode === 'view' && !onClickCallback;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: children({
            onClick: allowNavigation ? undefined : onClick
        })
    });
};
function $06cf0cf44d4bf681$export$60332b2344f7fe41(SmartCardComponent, UnsupportedComponent) {
    return class extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
        render() {
            const { pluginInjectionApi: pluginInjectionApi, onClickCallback: onClickCallback } = this.props;
            const { url: url } = (0, $gXgTX.titleUrlPairFromNode)(this.props.node);
            if (url && !(0, $iKozC.isSafeUrl)(url)) return /*#__PURE__*/ (0, $gt9Am.jsx)(UnsupportedComponent, {});
            if (this.state.isError) {
                if (url) return (0, $eGOwo.fg)('dst-a11y__replace-anchor-with-link__linking-platfo') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJ9f5.default), {
                    href: url,
                    onClick: (e)=>{
                        e.preventDefault();
                    },
                    children: url
                }) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
                /*#__PURE__*/ (0, $gt9Am.jsx)("a", {
                    href: url,
                    onClick: (e)=>{
                        e.preventDefault();
                    },
                    children: url
                });
                else return /*#__PURE__*/ (0, $gt9Am.jsx)(UnsupportedComponent, {});
            }
            const editorAppearance = (0, $d3z4A.getPluginState)(this.props.view.state)?.editorAppearance;
            const analyticsEditorAppearance = (0, $dyNYh.getAnalyticsEditorAppearance)(editorAppearance);
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $e2B2h.default), {
                data: {
                    attributes: {
                        location: analyticsEditorAppearance
                    },
                    // Below is added for the future implementation of Linking Platform namespaced analytics context
                    location: analyticsEditorAppearance
                },
                children: /*#__PURE__*/ (0, $gt9Am.jsx)($06cf0cf44d4bf681$var$WithClickHandler, {
                    pluginInjectionApi: pluginInjectionApi,
                    onClickCallback: onClickCallback,
                    url: url,
                    __livePage: this.props.__livePage,
                    children: ({ onClick: onClick })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $lSHus.WithCardContext), {
                            children: (cardContext)=>/*#__PURE__*/ (0, $gt9Am.jsx)(SmartCardComponent, {
                                    cardContext: cardContext,
                                    ...this.props,
                                    onClick: onClick
                                }, url)
                        })
                })
            });
        }
        componentDidCatch(error) {
            const maybeAPIError = error;
            // NB: errors received in this component are propagated by the `@atlaskit/smart-card` component.
            // Depending on the kind of error, the expectation for this component is to either:
            // (1) Render a blue link whilst retaining `inlineCard` in the ADF (non-fatal errs);
            // (2) Render a blue link whilst downgrading to `link` in the ADF (fatal errs).
            if (maybeAPIError.kind && maybeAPIError.kind === 'fatal') {
                this.setState({
                    isError: true
                });
                const { view: view, node: node, getPos: getPos, pluginInjectionApi: pluginInjectionApi } = this.props;
                const { url: url } = (0, $gXgTX.titleUrlPairFromNode)(node);
                if (!getPos || typeof getPos === 'boolean') return;
                (0, $4AOcQ.changeSelectedCardToLinkFallback)(undefined, url, true, node, getPos(), pluginInjectionApi?.analytics?.actions)(view.state, view.dispatch);
                return null;
            } else // Otherwise, render a blue link as fallback (above in render()).
            this.setState({
                isError: true
            });
        }
        constructor(...args){
            super(...args), this.state = {
                isError: false
            };
        }
    };
}

});

parcelRegister("8fpuZ", function(module, exports) {

$parcel$export(module.exports, "InlineCardWithAwareness", () => $6cc0cd3f4d3ba3ce$export$2b341c5236b55a2);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kLQ9a = parcelRequire("kLQ9a");
var $bSToC = parcelRequire("bSToC");
var $cxXTK = parcelRequire("cxXTK");

var $92xoS = parcelRequire("92xoS");

var $ecNk4 = parcelRequire("ecNk4");

var $cuJUr = parcelRequire("cuJUr");

var $8xE8A = parcelRequire("8xE8A");

var $lLo5x = parcelRequire("lLo5x");

var $8NXVj = parcelRequire("8NXVj");
const $6cc0cd3f4d3ba3ce$var$selector = (states)=>{
    return {
        mode: states.editorViewModeState?.mode
    };
};
const $6cc0cd3f4d3ba3ce$var$useSharedState = (0, $kLQ9a.sharedPluginStateHookMigratorFactory)((pluginInjectionApi)=>{
    return (0, $cxXTK.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'editorViewMode'
    ], $6cc0cd3f4d3ba3ce$var$selector);
}, (pluginInjectionApi)=>{
    const { editorViewModeState: editorViewModeState } = (0, $bSToC.useSharedPluginState)(pluginInjectionApi, [
        'editorViewMode'
    ]);
    return {
        mode: editorViewModeState?.mode
    };
});
const $6cc0cd3f4d3ba3ce$export$2b341c5236b55a2 = /*#__PURE__*/ (0, $eJOHy.memo)(({ node: node, cardContext: cardContext, actionOptions: actionOptions, useAlternativePreloader: useAlternativePreloader, view: view, getPos: getPos, pluginInjectionApi: pluginInjectionApi, onClick: onClick, isPulseEnabled: isPulseEnabled, isOverlayEnabled: isOverlayEnabled, isSelected: isSelected, isPageSSRed: isPageSSRed, appearance: appearance })=>{
    const [isHovered, setIsHovered] = (0, $eJOHy.useState)(false);
    const [isInserted, setIsInserted] = (0, $eJOHy.useState)(false);
    const [isResolvedViewRendered, setIsResolvedViewRendered] = (0, $eJOHy.useState)(false);
    const editorAppearance = pluginInjectionApi?.card.sharedState.currentState()?.editorAppearance;
    const onResolve = (0, $eJOHy.useCallback)((tr, title)=>{
        const metadata = tr.getMeta((0, $cuJUr.pluginKey));
        if (metadata && metadata.type === 'REGISTER') (0, $ecNk4.registerRemoveOverlay)(()=>setIsInserted(false), metadata.info)(tr);
        else (0, $ecNk4.registerRemoveOverlay)(()=>setIsInserted(false))(tr);
        if (title) setIsResolvedViewRendered(true);
    }, []);
    const markMostRecentlyInsertedLink = (0, $eJOHy.useCallback)((isLinkMostRecentlyInserted)=>{
        if (isOverlayEnabled) setIsInserted(isLinkMostRecentlyInserted);
    }, [
        isOverlayEnabled
    ]);
    const setOverlayHoveredStyles = (0, $eJOHy.useCallback)((isHovered)=>{
        if (isOverlayEnabled) setIsHovered(isHovered);
    }, [
        isOverlayEnabled
    ]);
    const { mode: mode } = $6cc0cd3f4d3ba3ce$var$useSharedState(pluginInjectionApi);
    const innerCardWithOpenButtonOverlay = (0, $eJOHy.useMemo)(()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $lLo5x.default), {
            isVisible: isResolvedViewRendered,
            url: node.attrs.url,
            editorAppearance: editorAppearance,
            editorAnalyticsApi: pluginInjectionApi?.analytics?.actions,
            view: view,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8NXVj.InlineCard), {
                node: node,
                view: view,
                getPos: getPos,
                useAlternativePreloader: useAlternativePreloader,
                actionOptions: actionOptions,
                onResolve: onResolve,
                onClick: onClick,
                cardContext: cardContext,
                isHovered: isHovered,
                isPageSSRed: isPageSSRed,
                pluginInjectionApi: pluginInjectionApi
            })
        }), [
        isResolvedViewRendered,
        node,
        editorAppearance,
        view,
        getPos,
        useAlternativePreloader,
        actionOptions,
        onResolve,
        onClick,
        cardContext,
        isHovered,
        isPageSSRed,
        pluginInjectionApi
    ]);
    const innerCardOriginal = (0, $eJOHy.useMemo)(()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8NXVj.InlineCard), {
            node: node,
            view: view,
            getPos: getPos,
            useAlternativePreloader: useAlternativePreloader,
            actionOptions: actionOptions,
            onResolve: onResolve,
            onClick: onClick,
            cardContext: cardContext,
            isHovered: isHovered,
            isPageSSRed: isPageSSRed,
            pluginInjectionApi: pluginInjectionApi
        }), [
        actionOptions,
        cardContext,
        getPos,
        isHovered,
        node,
        onClick,
        onResolve,
        useAlternativePreloader,
        view,
        isPageSSRed,
        pluginInjectionApi
    ]);
    const shouldShowOpenButtonOverlay = (0, $eJOHy.useMemo)(()=>{
        const shouldShowOpenButtonOverlayInChomeless = editorAppearance === 'chromeless';
        return (mode === 'edit' || editorAppearance === 'comment' || shouldShowOpenButtonOverlayInChomeless) && (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1');
    }, [
        mode,
        editorAppearance
    ]);
    const innerCard = shouldShowOpenButtonOverlay ? innerCardWithOpenButtonOverlay : innerCardOriginal;
    const getPosFunction = typeof getPos === 'function' ? getPos : undefined;
    const placeholderUniqId = getPosFunction?.() || 0;
    return isOverlayEnabled || isPulseEnabled ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8xE8A.AwarenessWrapper), {
        isOverlayEnabled: isOverlayEnabled,
        isPulseEnabled: isPulseEnabled,
        cardContext: cardContext,
        getPos: getPos,
        isHovered: isHovered,
        isInserted: isInserted,
        url: node.attrs.url,
        isSelected: isSelected,
        isResolvedViewRendered: isResolvedViewRendered,
        markMostRecentlyInsertedLink: markMostRecentlyInsertedLink,
        pluginInjectionApi: pluginInjectionApi,
        setOverlayHoveredStyles: setOverlayHoveredStyles,
        appearance: appearance,
        children: innerCard
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "card",
        "data-vc": "editor-plugin-inline-card",
        "data-ssr-placeholder": `editor-plugin-inline-card-${placeholderUniqId}`,
        "data-ssr-placeholder-replace": `editor-plugin-inline-card-${placeholderUniqId}`,
        children: innerCard
    });
});

});
parcelRegister("8xE8A", function(module, exports) {

$parcel$export(module.exports, "AwarenessWrapper", () => $c26b875884029665$export$cc11bcf19366e14b);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $e2B2h = parcelRequire("e2B2h");

var $92xoS = parcelRequire("92xoS");

var $gXgTX = parcelRequire("gXgTX");

var $btRv5 = parcelRequire("btRv5");

var $5DAxT = parcelRequire("5DAxT");

var $d62Vl = parcelRequire("d62Vl");

var $8ATyg = parcelRequire("8ATyg");
function $c26b875884029665$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// editor adds a standard line-height that is bigger than an inline smart link
// due to that the link has a bit of white space around it, which doesn't look right when there is pulse around it
const $c26b875884029665$var$loaderWrapperStyles = {
    name: "8ncb35",
    styles: ".loader-wrapper{line-height:normal;}"
};
const $c26b875884029665$export$cc11bcf19366e14b = ({ cardContext: cardContext, children: children, getPos: getPos, isInserted: isInserted, isOverlayEnabled: isOverlayEnabled, isSelected: isSelected, isResolvedViewRendered: isResolvedViewRendered, isPulseEnabled: isPulseEnabled, markMostRecentlyInsertedLink: markMostRecentlyInsertedLink, pluginInjectionApi: pluginInjectionApi, setOverlayHoveredStyles: setOverlayHoveredStyles, url: url, appearance: appearance })=>{
    const [isHovered, setIsHovered] = (0, $eJOHy.useState)(false);
    const linkPosition = (0, $eJOHy.useMemo)(()=>{
        if (!getPos || typeof getPos === 'boolean') return undefined;
        const pos = getPos();
        return typeof pos === 'number' ? pos : undefined;
    }, [
        getPos
    ]);
    const { shouldShowLinkPulse: shouldShowLinkPulse, shouldShowToolbarPulse: shouldShowToolbarPulse, shouldShowLinkOverlay: shouldShowLinkOverlay, isLinkMostRecentlyInserted: isLinkMostRecentlyInserted } = (0, $btRv5.default)({
        url: url,
        linkPosition: linkPosition || -1,
        cardContext: cardContext?.value,
        pluginInjectionApi: pluginInjectionApi,
        isOverlayEnabled: isOverlayEnabled,
        isPulseEnabled: isPulseEnabled
    });
    // If the toolbar pulse has not yet been invalidated and this is a case where we will be showing it,
    // we need to invalidate the link pulse too. Toolbar pulse will be invalidated in the corresponding component.
    if (isSelected && shouldShowToolbarPulse && !(0, $d62Vl.isLocalStorageKeyDiscovered)((0, $d62Vl.LOCAL_STORAGE_DISCOVERY_KEY_TOOLBAR))) (0, $d62Vl.markLocalStorageKeyDiscovered)((0, $d62Vl.LOCAL_STORAGE_DISCOVERY_KEY_SMART_LINK));
    (0, $eJOHy.useEffect)(()=>{
        if (shouldShowLinkOverlay && isLinkMostRecentlyInserted) markMostRecentlyInsertedLink(true);
    }, [
        isLinkMostRecentlyInserted,
        markMostRecentlyInsertedLink,
        shouldShowLinkOverlay
    ]);
    const handleOverlayChange = (0, $eJOHy.useCallback)((isHovered)=>{
        setIsHovered(isHovered);
        setOverlayHoveredStyles(isHovered);
    }, [
        setOverlayHoveredStyles
    ]);
    const cardWithOverlay = (0, $eJOHy.useMemo)(()=>{
        if (shouldShowLinkOverlay && !(0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1')) return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $5DAxT.default), {
            isSelected: isSelected,
            isVisible: isResolvedViewRendered && (isInserted || isHovered || isSelected),
            onMouseEnter: ()=>handleOverlayChange(true),
            onMouseLeave: ()=>handleOverlayChange(false),
            url: url
        }, children);
        return children;
    }, [
        shouldShowLinkOverlay,
        children,
        isSelected,
        isResolvedViewRendered,
        isInserted,
        isHovered,
        url,
        handleOverlayChange
    ]);
    const isInline = appearance === 'inline';
    const placeholderUniqId = linkPosition || 0;
    return (0, $eJOHy.useMemo)(()=>/*#__PURE__*/ (0, $1NIU8.jsx)("span", {
            css: shouldShowLinkPulse && $c26b875884029665$var$loaderWrapperStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "card",
            "data-vc": "awareness-wrapper",
            "data-ssr-placeholder": `awareness-wrapper-${placeholderUniqId}`,
            "data-ssr-placeholder-replace": `awareness-wrapper-${placeholderUniqId}`
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $e2B2h.default), {
            data: {
                attributes: (0, $gXgTX.getResolvedAttributesFromStore)(url, 'inline', cardContext?.value?.store)
            }
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $8ATyg.DiscoveryPulse), {
            localStorageKey: (0, $d62Vl.LOCAL_STORAGE_DISCOVERY_KEY_SMART_LINK),
            localStorageKeyExpirationInMs: (0, $d62Vl.ONE_DAY_IN_MILLISECONDS),
            discoveryMode: "start",
            shouldShowPulse: isResolvedViewRendered && shouldShowLinkPulse,
            testId: "link-discovery-pulse",
            isInline: isInline
        }, cardWithOverlay))), [
        shouldShowLinkPulse,
        url,
        cardContext?.value?.store,
        isResolvedViewRendered,
        cardWithOverlay,
        isInline,
        placeholderUniqId
    ]);
};

});
parcelRegister("btRv5", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a2279a396d346c9$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $d62Vl = parcelRequire("d62Vl");
const $4a2279a396d346c9$var$useLinkUpgradeDiscoverability = ({ url: url, linkPosition: linkPosition, cardContext: cardContext, pluginInjectionApi: pluginInjectionApi, isPulseEnabled: isPulseEnabled, isOverlayEnabled: isOverlayEnabled })=>{
    const [urlState, setUrlState] = (0, $eJOHy.useState)(cardContext?.store?.getState()[url]);
    const { overlayCandidatePosition: overlayCandidatePosition, inlineCardAwarenessCandidatePosition: inlineCardAwarenessCandidatePosition } = pluginInjectionApi?.card?.sharedState?.currentState() || {};
    (0, $eJOHy.useEffect)(()=>{
        const unsubscribe = cardContext?.store?.subscribe(()=>{
            setUrlState(cardContext?.store?.getState()[url]);
        });
        return ()=>{
            if (unsubscribe) unsubscribe();
        };
    }, [
        cardContext?.store,
        url
    ]);
    const canBeUpgradedToEmbed = (0, $eJOHy.useMemo)(()=>{
        const isResolved = urlState?.status === 'resolved';
        return isResolved && !!cardContext?.extractors?.getPreview(url, 'web');
    }, [
        cardContext?.extractors,
        url,
        urlState?.status
    ]);
    const shouldShowLinkPulse = (0, $eJOHy.useMemo)(()=>{
        return isPulseEnabled && linkPosition === inlineCardAwarenessCandidatePosition && canBeUpgradedToEmbed;
    }, [
        canBeUpgradedToEmbed,
        isPulseEnabled,
        linkPosition,
        inlineCardAwarenessCandidatePosition
    ]);
    const shouldShowLinkOverlay = urlState?.status === 'resolved' && isOverlayEnabled;
    const isLinkMostRecentlyInserted = overlayCandidatePosition === linkPosition;
    const shouldShowToolbarPulse = (0, $eJOHy.useMemo)(()=>isPulseEnabled && !(0, $d62Vl.isLocalStorageKeyDiscovered)((0, $d62Vl.LOCAL_STORAGE_DISCOVERY_KEY_TOOLBAR)) && canBeUpgradedToEmbed, [
        canBeUpgradedToEmbed,
        isPulseEnabled
    ]);
    return {
        shouldShowToolbarPulse: shouldShowToolbarPulse,
        shouldShowLinkPulse: shouldShowLinkPulse,
        shouldShowLinkOverlay: shouldShowLinkOverlay,
        isLinkMostRecentlyInserted: isLinkMostRecentlyInserted
    };
};
var $4a2279a396d346c9$export$2e2bcd8739ae039 = $4a2279a396d346c9$var$useLinkUpgradeDiscoverability;

});

parcelRegister("5DAxT", function(module, exports) {

$parcel$export(module.exports, "default", () => $be88c002bffefa4b$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/no-nested-styles */ /* eslint-disable @atlaskit/design-system/prefer-primitives */ /**
                                                                                                                              * @jsxRuntime classic
                                                                                                                              * @jsx jsx
                                                                                                                              */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $3s8bj = parcelRequire("3s8bj");

var $lRq8t = parcelRequire("lRq8t");

var $6dRXt = parcelRequire("6dRXt");


var $7skWy = parcelRequire("7skWy");


var $aGTdw = parcelRequire("aGTdw");
function $be88c002bffefa4b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $be88c002bffefa4b$var$DEBOUNCE_IN_MS = 5;
const $be88c002bffefa4b$var$ESTIMATED_MIN_WIDTH_IN_PX = 16;
const $be88c002bffefa4b$var$PADDING_IN_PX = 4;
const $be88c002bffefa4b$var$ICON_WIDTH_IN_PX = 14;
const $be88c002bffefa4b$var$ICON_AND_LABEL_CLASSNAME = 'ak-editor-card-overlay-icon-and-label';
const $be88c002bffefa4b$var$OVERLAY_LABEL_CLASSNAME = 'ak-editor-card-overlay-label';
const $be88c002bffefa4b$var$OVERLAY_GRADIENT_CLASSNAME = 'ak-editor-card-overlay-gradient';
const $be88c002bffefa4b$var$OVERLAY_MARKER_CLASSNAME = 'ak-editor-card-overlay-marker';
const $be88c002bffefa4b$var$TEXT_NODE_SELECTOR = [
    'p',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6'
].join(',');
const $be88c002bffefa4b$var$SMART_LINK_BACKGROUND_COLOR = `var(--ds-surface-raised, ${(0, $7bb4c1736002a04a$export$29a4f05edc054374)})`;
const $be88c002bffefa4b$var$SMART_LINK_ACTIVE_COLOR = `var(--ds-background-selected, ${(0, $7bb4c1736002a04a$export$ecfc1dff386a3e7a)})`;
const $be88c002bffefa4b$var$getGradientWithColor = (color)=>{
    return `linear-gradient(270deg, ${color} 0%, rgba(255, 255, 255, 0.00) 100%)`;
};
const $be88c002bffefa4b$var$containerStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    position: 'relative',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 'normal',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':active': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        [`.${$be88c002bffefa4b$var$ICON_AND_LABEL_CLASSNAME}`]: {
            background: $be88c002bffefa4b$var$SMART_LINK_ACTIVE_COLOR
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        [`.${$be88c002bffefa4b$var$OVERLAY_GRADIENT_CLASSNAME}`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            background: $be88c002bffefa4b$var$getGradientWithColor($be88c002bffefa4b$var$SMART_LINK_ACTIVE_COLOR)
        }
    }
});
const $be88c002bffefa4b$var$overlayStyles = {
    name: "1ckkn26",
    styles: "visibility:hidden;position:absolute;display:inline-flex;justify-content:flex-end;align-items:center;vertical-align:text-top;height:1lh;@supports not (height: 1lh){height:1.2em;}overflow:hidden;z-index:2;pointer-events:none"
};
const $be88c002bffefa4b$var$showOverlayStyles = {
    name: "1st01id",
    styles: "position:relative;visibility:visible"
};
const $be88c002bffefa4b$var$iconStyles = {
    name: "ulzjoo",
    styles: "span{display:flex;}"
};
const $be88c002bffefa4b$var$labelStyles = {
    name: "cf1bvh",
    styles: "font:var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);font-weight:var(--ds-font-weight-semibold, 600);width:max-content"
};
const $be88c002bffefa4b$var$iconAndLabelStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    gap: "var(--ds-space-050, 4px)",
    paddingRight: "var(--ds-space-050, 4px)",
    // Margin to avoid the background covering the link border
    marginRight: "var(--ds-space-025, 2px)",
    background: $be88c002bffefa4b$var$SMART_LINK_BACKGROUND_COLOR,
    color: `var(--ds-text-subtlest, ${(0, $7bb4c1736002a04a$export$ad0bacf983b7ddaa)})`
});
const $be88c002bffefa4b$var$overflowingContainerStyles = {
    name: "16sud",
    styles: "display:flex;flex-direction:row-reverse;align-items:center;width:max-content;height:100%"
};
const $be88c002bffefa4b$var$gradientStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    width: '2.5rem',
    height: '100%',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    background: $be88c002bffefa4b$var$getGradientWithColor($be88c002bffefa4b$var$SMART_LINK_BACKGROUND_COLOR)
});
const $be88c002bffefa4b$var$InlineCardOverlay = ({ children: children, isSelected: isSelected = false, isVisible: isVisible = false, testId: testId = 'inline-card-overlay', url: url, ...props })=>{
    const [showOverlay, setShowOverlay] = (0, $eJOHy.useState)(false);
    const [showLabel, setShowLabel] = (0, $eJOHy.useState)(true);
    const [availableWidth, setAvailableWidth] = (0, $eJOHy.useState)(undefined);
    const maxOverlayWidth = (0, $eJOHy.useRef)(0);
    const minOverlayWidth = (0, $eJOHy.useRef)($be88c002bffefa4b$var$ESTIMATED_MIN_WIDTH_IN_PX);
    const parentWidth = (0, $eJOHy.useRef)(0);
    const iconSize = (0, $eJOHy.useRef)('small');
    const containerRef = (0, $eJOHy.useRef)(null);
    const setVisibility = (0, $eJOHy.useCallback)(()=>{
        if (!containerRef.current || !maxOverlayWidth.current) return;
        const marker = (0, $aGTdw.getChildElement)(containerRef, `.${$be88c002bffefa4b$var$OVERLAY_MARKER_CLASSNAME}`);
        if (!marker) return;
        try {
            const oneLine = (0, $aGTdw.isOneLine)(containerRef.current, marker);
            // Get the width of the available space to display overlay.
            // This is the width of the inline link itself. If the inline
            // is wrapped to the next line, this is width of the last line.
            const availableWidth = (0, $aGTdw.getInlineCardAvailableWidth)(containerRef.current, marker) - $be88c002bffefa4b$var$PADDING_IN_PX - // Always leave at least the icon visible
            (oneLine ? $be88c002bffefa4b$var$ICON_WIDTH_IN_PX + $be88c002bffefa4b$var$PADDING_IN_PX : 0);
            setAvailableWidth(availableWidth);
            const canShowLabel = availableWidth > maxOverlayWidth.current;
            setShowLabel(canShowLabel);
            const canShowOverlay = availableWidth > minOverlayWidth.current && !isSelected;
            setShowOverlay(canShowOverlay);
        } catch  {
            // If something goes wrong, hide the overlay all together.
            setShowOverlay(false);
        }
    }, [
        isSelected
    ]);
    (0, $eJOHy.useLayoutEffect)(()=>{
        // Using useLayoutEffect here.
        // 1) We want all to be able to determine whether to display label before
        //    the overlay becomes visible.
        // 2) We need to wait for the refs to be assigned to be able to do determine
        //    the width of the overlay.
        if (!containerRef.current) return;
        // This should run only once
        if (!maxOverlayWidth.current) {
            const iconAndLabel = (0, $aGTdw.getChildElement)(containerRef, `.${$be88c002bffefa4b$var$ICON_AND_LABEL_CLASSNAME}`);
            const label = (0, $aGTdw.getChildElement)(containerRef, `.${$be88c002bffefa4b$var$OVERLAY_LABEL_CLASSNAME}`);
            if (iconAndLabel && label) {
                // Set overlay max (label + icon) and min (icon only) width.
                const { max: max, min: min } = (0, $aGTdw.getOverlayWidths)(iconAndLabel, label);
                maxOverlayWidth.current = max;
                minOverlayWidth.current = min;
                iconSize.current = (0, $aGTdw.getIconSize)(label);
            }
        }
        if (isVisible) setVisibility();
    }, [
        setVisibility,
        isVisible
    ]);
    (0, $eJOHy.useEffect)(()=>{
        // Find the closest block parent to observe size change
        const parent = containerRef?.current?.closest($be88c002bffefa4b$var$TEXT_NODE_SELECTOR);
        if (!parent) return;
        const updateOverlay = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))((entries)=>{
            if (!isVisible) return;
            const size = entries?.[0]?.contentBoxSize?.[0]?.inlineSize;
            if (!size) return;
            if (!parentWidth.current) parentWidth.current = size;
            if (parentWidth.current === size) return;
            parentWidth.current = size;
            setVisibility();
        }, $be88c002bffefa4b$var$DEBOUNCE_IN_MS);
        const observer = new ResizeObserver(updateOverlay);
        observer.observe(parent);
        return ()=>{
            observer.disconnect();
        };
    }, [
        isVisible,
        setVisibility
    ]);
    const intl = (0, $lRq8t.default)();
    const label = intl.formatMessage((0, $6dRXt.messages).inlineOverlay);
    return(// Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        ...props,
        css: $be88c002bffefa4b$var$containerStyles,
        ref: containerRef
    }, children, isVisible && /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        "aria-hidden": "true",
        className: $be88c002bffefa4b$var$OVERLAY_MARKER_CLASSNAME
    }, (0, $f9e41f230eb38f84$export$2b4d00c13dcd3c1f)), /*#__PURE__*/ (0, $1NIU8.jsx)("a", {
        css: [
            $be88c002bffefa4b$var$overlayStyles,
            showOverlay && $be88c002bffefa4b$var$showOverlayStyles
        ],
        style: {
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
            marginLeft: availableWidth && -availableWidth,
            width: availableWidth
        },
        "data-testid": testId,
        href: url,
        onClick: (e)=>e.preventDefault(),
        tabIndex: -1
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        css: $be88c002bffefa4b$var$overflowingContainerStyles
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        css: $be88c002bffefa4b$var$iconAndLabelStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $be88c002bffefa4b$var$ICON_AND_LABEL_CLASSNAME
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        css: $be88c002bffefa4b$var$iconStyles
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7skWy))), {
        label: label,
        LEGACY_size: iconSize.current,
        testId: `${testId}-icon`
    })), showLabel && /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        css: $be88c002bffefa4b$var$labelStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $be88c002bffefa4b$var$OVERLAY_LABEL_CLASSNAME,
        "data-testid": `${testId}-label`
    }, label)), /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        css: $be88c002bffefa4b$var$gradientStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $be88c002bffefa4b$var$OVERLAY_GRADIENT_CLASSNAME,
        "data-testid": `${testId}-gradient`
    }))))));
};
var $be88c002bffefa4b$export$2e2bcd8739ae039 = $be88c002bffefa4b$var$InlineCardOverlay;

});
parcelRegister("aGTdw", function(module, exports) {

$parcel$export(module.exports, "getChildElement", () => $f422809d4c0fb3c8$export$a0e2858e1d1976ea);
$parcel$export(module.exports, "getInlineCardAvailableWidth", () => $f422809d4c0fb3c8$export$ce3ffcce447cf028);
$parcel$export(module.exports, "isOneLine", () => $f422809d4c0fb3c8$export$be02a7fcf666d65d);
$parcel$export(module.exports, "getOverlayWidths", () => $f422809d4c0fb3c8$export$bdfd7a9bf7c62c86);
$parcel$export(module.exports, "getIconSize", () => $f422809d4c0fb3c8$export$3eb7d6130acfda37);
const $f422809d4c0fb3c8$export$a0e2858e1d1976ea = (ref, selector)=>ref.current ? ref.current.querySelector(selector) : undefined;
const $f422809d4c0fb3c8$export$ce3ffcce447cf028 = (startEl, endEl)=>{
    const start = startEl.getBoundingClientRect().left;
    const end = endEl.getBoundingClientRect().left;
    return end - start;
};
const $f422809d4c0fb3c8$export$be02a7fcf666d65d = (startEl, endEl)=>{
    const start = startEl.getBoundingClientRect().top;
    const end = endEl.getBoundingClientRect().top;
    return start === end;
};
const $f422809d4c0fb3c8$export$bdfd7a9bf7c62c86 = (overlayEl, labelEl)=>{
    const max = overlayEl.getBoundingClientRect().width;
    const min = max - labelEl.getBoundingClientRect().width;
    return {
        max: max,
        min: min
    };
};
const $f422809d4c0fb3c8$export$3eb7d6130acfda37 = (labelEl)=>{
    const h2FontSizePx = 20;
    const fontSize = window && parseFloat(window.getComputedStyle(labelEl).fontSize);
    if (!fontSize || fontSize < h2FontSizePx) return 'small';
    return 'medium';
};

});



parcelRegister("lLo5x", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7ea10c19bde96aa$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/no-nested-styles */ /* eslint-disable @atlaskit/design-system/prefer-primitives */ /**
                                                                                                                              * @jsxRuntime classic
                                                                                                                              * @jsx jsx
                                                                                                                              */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $lRq8t = parcelRequire("lRq8t");

var $bMFKb = parcelRequire("bMFKb");

var $6dRXt = parcelRequire("6dRXt");

var $9itkV = parcelRequire("9itkV");

var $lL4G9 = parcelRequire("lL4G9");
var $8nu6j = parcelRequire("8nu6j");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $3YtqI = parcelRequire("3YtqI");
function $b7ea10c19bde96aa$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b7ea10c19bde96aa$var$containerStyles = {
    name: "bjn8wh",
    styles: "position:relative"
};
const $b7ea10c19bde96aa$var$iconWrapperStyles = (0, $1DXK0.xcss)({
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '17px',
    width: '17px'
});
const $b7ea10c19bde96aa$var$hiddenTextStyle = {
    name: "1hr6gib",
    styles: "overflow:hidden;white-space:nowrap;position:absolute;visibility:hidden"
};
const $b7ea10c19bde96aa$var$linkStyles = (0, $1DXK0.xcss)({
    position: 'absolute',
    left: 'space.025',
    top: '-1px',
    display: 'inline-flex',
    alignItems: 'center',
    verticalAlign: 'middle',
    paddingBlock: 'space.025',
    paddingInline: 'space.050',
    gap: 'space.025',
    overflow: 'hidden',
    zIndex: 'card',
    backgroundColor: 'color.background.accent.gray.subtlest',
    borderRadius: "var(--ds-border-radius, 3px)",
    color: 'color.text.subtle',
    textDecoration: 'none',
    whiteSpace: 'nowrap',
    ':hover': {
        backgroundColor: 'elevation.surface.hovered',
        color: 'color.text.subtle',
        textDecoration: 'none'
    }
});
const $b7ea10c19bde96aa$var$MIN_AVAILABLE_SPACE_WITH_LABEL_OVERLAY = 45;
const $b7ea10c19bde96aa$var$ICON_WIDTH = 16;
const $b7ea10c19bde96aa$var$DEFAULT_OPEN_TEXT_WIDTH = 28; // Default open text width in English
const $b7ea10c19bde96aa$var$OpenButtonOverlay = ({ children: children, isVisible: isVisible = false, url: url, editorAppearance: editorAppearance, editorAnalyticsApi: editorAnalyticsApi, view: view })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const label = formatMessage((0, $6dRXt.messages).openButtonTitle);
    const containerRef = (0, $eJOHy.useRef)(null);
    const openButtonRef = (0, $eJOHy.useRef)(null);
    const hiddenTextRef = (0, $eJOHy.useRef)(null);
    const [showLabel, setShowLabel] = (0, $eJOHy.useState)(true);
    const [isHovered, setHovered] = (0, $eJOHy.useState)(false);
    const openTextWidthRef = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (!isVisible || !isHovered) return;
        const cardWidth = containerRef.current?.offsetWidth;
        const openButtonWidth = openButtonRef.current?.offsetWidth;
        // Get the hidden text width
        if (!openTextWidthRef.current) {
            const hiddenText = hiddenTextRef.current;
            if (hiddenText) {
                // Measure the width of the hidden text
                // Temporarily make the element visible to measure its width
                hiddenText.style.visibility = 'hidden';
                hiddenText.style.display = 'inline';
                openTextWidthRef.current = hiddenText.offsetWidth;
                // Reset the hiddenText's display property
                hiddenText.style.display = 'none';
                hiddenText.style.visibility = 'inherit';
            } else openTextWidthRef.current = $b7ea10c19bde96aa$var$DEFAULT_OPEN_TEXT_WIDTH;
        }
        if (!cardWidth || !openButtonWidth) return;
        const openTextWidth = openTextWidthRef.current || $b7ea10c19bde96aa$var$DEFAULT_OPEN_TEXT_WIDTH;
        const canShowLabel = cardWidth - openTextWidth > $b7ea10c19bde96aa$var$MIN_AVAILABLE_SPACE_WITH_LABEL_OVERLAY + $b7ea10c19bde96aa$var$ICON_WIDTH;
        setShowLabel(canShowLabel);
    }, [
        isVisible,
        isHovered
    ]);
    const handleOverlayChange = (isHovered)=>{
        setHovered(isHovered);
    };
    const sendVisitLinkAnalytics = (inputMethod)=>{
        if (editorAnalyticsApi && view) (0, $3YtqI.visitCardLinkAnalytics)(editorAnalyticsApi, inputMethod)(view.state, view.dispatch);
    };
    const handleDoubleClick = ()=>{
        sendVisitLinkAnalytics((0, $bMFKb.INPUT_METHOD).DOUBLE_CLICK);
        // Double click opens the link in a new tab
        window.open(url, '_blank');
    };
    const handleClick = ()=>{
        sendVisitLinkAnalytics((0, $bMFKb.INPUT_METHOD).BUTTON);
    };
    return(// eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        ref: containerRef,
        css: $b7ea10c19bde96aa$var$containerStyles,
        onDoubleClick: handleDoubleClick,
        onMouseEnter: ()=>handleOverlayChange(true),
        onMouseLeave: ()=>handleOverlayChange(false)
    }, children, /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        css: $b7ea10c19bde96aa$var$hiddenTextStyle,
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $5qJVF.default), {
        ref: hiddenTextRef,
        size: "small",
        maxLines: 1
    }, label)), isHovered && /*#__PURE__*/ (0, $1NIU8.jsx)((0, $lL4G9.default), {
        ref: openButtonRef,
        xcss: $b7ea10c19bde96aa$var$linkStyles,
        href: url,
        target: "_blank",
        style: {
            paddingBlock: editorAppearance === 'comment' || editorAppearance === 'chromeless' ? '1px' : "var(--ds-space-025, 2px)"
        },
        onClick: handleClick
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $8nu6j.default), {
        xcss: $b7ea10c19bde96aa$var$iconWrapperStyles,
        "data-inlinecard-button-overlay": "icon-wrapper-line-height"
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9itkV))), {
        label: ""
    })), showLabel && /*#__PURE__*/ (0, $1NIU8.jsx)((0, $5qJVF.default), {
        size: "small",
        color: "color.text.subtle",
        maxLines: 1
    }, label))));
};
var $b7ea10c19bde96aa$export$2e2bcd8739ae039 = $b7ea10c19bde96aa$var$OpenButtonOverlay;

});



parcelRegister("9tfE8", function(module, exports) {

$parcel$export(module.exports, "lazyBlockCardView", () => $5b10e3d784004308$export$7da1e5b9c509a0c1);

var $hkA3A = parcelRequire("hkA3A");

var $92xoS = parcelRequire("92xoS");

var $dGuk9 = parcelRequire("dGuk9");

const $5b10e3d784004308$export$7da1e5b9c509a0c1 = (props)=>{
    if ((0, $92xoS.editorExperiment)('platform_editor_exp_lazy_node_views', false)) return (0, $dGuk9.blockCardNodeView)(props);
    return (0, $hkA3A.withLazyLoading)({
        nodeName: 'blockCard',
        getNodeViewOptions: ()=>{},
        loader: ()=>{
            const result = Promise.resolve((parcelRequire("dGuk9"))).then(({ blockCardNodeView: blockCardNodeView })=>{
                return blockCardNodeView(props);
            });
            return result;
        }
    });
};

});
parcelRegister("dGuk9", function(module, exports) {

$parcel$export(module.exports, "blockCardNodeView", () => $72f8d7f9ddfd52a6$export$8c11099266e71f4);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $bRPNB = parcelRequire("bRPNB");

var $8KLBw = parcelRequire("8KLBw");

var $6j98o = parcelRequire("6j98o");

var $dwnni = parcelRequire("dwnni");
var $93FVZ = parcelRequire("93FVZ");

var $7EdFW = parcelRequire("7EdFW");
var $7WlTe = parcelRequire("7WlTe");

var $4cFYC = parcelRequire("4cFYC");

var $cLBro = parcelRequire("cLBro");

var $ecNk4 = parcelRequire("ecNk4");

var $gXgTX = parcelRequire("gXgTX");

var $gqKWA = parcelRequire("gqKWA");
class $72f8d7f9ddfd52a6$export$780882fb750d3c8d extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).PureComponent {
    constructor(props){
        super(props), this.onResolve = (data)=>{
            const { getPos: getPos, view: view } = this.props;
            if (!getPos || typeof getPos === 'boolean') return;
            const { title: title, url: url } = data;
            // don't dispatch immediately since we might be in the middle of
            // rendering a nodeview
            (0, $bRPNB.default)(()=>{
                const pos = getPos();
                if (typeof pos !== 'number') return;
                view.dispatch((0, $ecNk4.registerCard)({
                    title: title,
                    url: url,
                    pos: pos,
                    id: this.props.id
                })(view.state.tr));
            })();
        }, this.removeCardDispatched = false, this.gapCursorSpan = ()=>{
            // Don't render in EdgeHTMl version <= 18 (Edge version 44)
            // as it forces the edit popup to render 24px lower than it should
            if ((0, $7EdFW.browser).ie && (0, $7EdFW.browser).ie_version < 79) return;
            // render an empty span afterwards to get around Webkit bug
            // that puts caret in next editable text element
            return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                contentEditable: true
            });
        }, this.onError = ({ err: err })=>{
            if (err) throw err;
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.scrollContainer = (0, $dwnni.findOverflowScrollParent)(props.view.dom) || undefined;
    }
    componentWillUnmount() {
        this.removeCard();
    }
    removeCard() {
        if (this.removeCardDispatched) return;
        this.removeCardDispatched = true;
        const { tr: tr } = this.props.view.state;
        (0, $ecNk4.removeCard)({
            id: this.props.id
        })(tr);
        this.props.view.dispatch(tr);
    }
    render() {
        const { node: node, cardContext: cardContext, actionOptions: actionOptions, onClick: onClick, CompetitorPrompt: CompetitorPrompt } = this.props;
        const { url: url, data: data } = node.attrs;
        const cardInner = /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4cFYC.Card), {
                    url: url ?? data.url,
                    container: this.scrollContainer,
                    appearance: "block",
                    onClick: onClick,
                    onResolve: this.onResolve,
                    onError: this.onError,
                    platform: 'web',
                    actionOptions: actionOptions,
                    CompetitorPrompt: CompetitorPrompt
                }, url),
                this.gapCursorSpan()
            ]
        });
        // [WS-2307]: we only render card wrapped into a Provider when the value is ready,
        // otherwise if we got data, we can render the card directly since it doesn't need the Provider
        return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            children: cardContext && cardContext.value ? /*#__PURE__*/ (0, $gt9Am.jsx)(cardContext.Provider, {
                value: cardContext.value,
                children: cardInner
            }) : data ? cardInner : null
        });
    }
}
const $72f8d7f9ddfd52a6$var$WrappedBlockCard = (0, $gqKWA.Card)($72f8d7f9ddfd52a6$export$780882fb750d3c8d, (0, $93FVZ.default));
class $72f8d7f9ddfd52a6$export$d18ccd25c0d2c6b0 extends (0, $6j98o.default) {
    createDomRef() {
        const domRef = document.createElement('div');
        // workaround Chrome bug in https://product-fabric.atlassian.net/browse/ED-5379
        // see also: https://github.com/ProseMirror/prosemirror/issues/884
        this.unsubscribe = this.reactComponentProps.pluginInjectionApi?.editorViewMode?.sharedState.onChange(({ nextSharedState: nextSharedState })=>this.updateContentEditable(nextSharedState, domRef));
        this.updateContentEditable(this.reactComponentProps.pluginInjectionApi?.editorViewMode?.sharedState.currentState(), domRef);
        domRef.setAttribute('spellcheck', 'false');
        return domRef;
    }
    // Need this function to check if the datasource attribute was added or not to a blockCard.
    // If so, we return false so we can get the node to re-render properly as a datasource node instead.
    // Otherwise, the node view will still consider the node as a blockCard and render a regular blockCard.
    validUpdate(currentNode, newNode) {
        const isCurrentNodeBlockCard = !(0, $gXgTX.isDatasourceNode)(currentNode);
        const isNewNodeDatasource = (0, $gXgTX.isDatasourceNode)(newNode);
        // need to return falsy to update node
        return !(isCurrentNodeBlockCard && isNewNodeDatasource);
    }
    update(node, decorations, _innerDecorations) {
        return super.update(node, decorations, _innerDecorations, this.validUpdate);
    }
    render() {
        const { actionOptions: actionOptions, pluginInjectionApi: pluginInjectionApi, onClickCallback: onClickCallback, CompetitorPrompt: CompetitorPrompt } = this.reactComponentProps;
        return /*#__PURE__*/ (0, $gt9Am.jsx)($72f8d7f9ddfd52a6$var$WrappedBlockCard, {
            node: this.node,
            view: this.view,
            getPos: this.getPos,
            actionOptions: actionOptions,
            pluginInjectionApi: pluginInjectionApi,
            onClickCallback: onClickCallback,
            id: this.id,
            CompetitorPrompt: CompetitorPrompt
        });
    }
    destroy() {
        this.unsubscribe?.();
        super.destroy();
    }
    constructor(...args){
        super(...args), this.id = (0, (/*@__PURE__*/$parcel$interopDefault($8KLBw)))(), this.updateContentEditable = (editorViewModeState, divElement)=>{
            divElement.contentEditable = editorViewModeState?.mode === 'view' ? 'false' : 'true';
        };
    }
}
const $72f8d7f9ddfd52a6$export$8c11099266e71f4 = ({ pmPluginFactoryParams: pmPluginFactoryParams, actionOptions: actionOptions, pluginInjectionApi: pluginInjectionApi, onClickCallback: onClickCallback, allowDatasource: allowDatasource, inlineCardViewProducer: inlineCardViewProducer, CompetitorPrompt: CompetitorPrompt })=>(node, view, getPos, decorations)=>{
        const { portalProviderAPI: portalProviderAPI, eventDispatcher: eventDispatcher } = pmPluginFactoryParams;
        const reactComponentProps = {
            actionOptions: actionOptions,
            pluginInjectionApi: pluginInjectionApi,
            onClickCallback: onClickCallback,
            CompetitorPrompt: CompetitorPrompt
        };
        const isDatasource = (0, $gXgTX.isDatasourceNode)(node);
        if (isDatasource) {
            if (allowDatasource && (0, $7WlTe.canRenderDatasource)(node?.attrs?.datasource?.id)) {
                const datasourcePosition = typeof getPos === 'function' && getPos();
                const datasourceResolvedPosition = datasourcePosition && view.state.doc.resolve(datasourcePosition);
                const isNodeNested = !!(datasourceResolvedPosition && datasourceResolvedPosition.depth > 0);
                return new (0, $cLBro.Datasource)({
                    node: node,
                    view: view,
                    getPos: getPos,
                    portalProviderAPI: portalProviderAPI,
                    eventDispatcher: eventDispatcher,
                    pluginInjectionApi: pluginInjectionApi,
                    isNodeNested: isNodeNested
                }).init();
            } else return inlineCardViewProducer(node, view, getPos, decorations);
        }
        return new $72f8d7f9ddfd52a6$export$d18ccd25c0d2c6b0(node, view, getPos, portalProviderAPI, eventDispatcher, reactComponentProps, undefined).init();
    };

});
parcelRegister("6j98o", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f1a3d6048e6e7c1$export$2e2bcd8739ae039);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $eGOwo = parcelRequire("eGOwo");

var $bMFKb = parcelRequire("bMFKb");

var $aoyv9 = parcelRequire("aoyv9");

var $28ffc = parcelRequire("28ffc");

var $lT8fo = parcelRequire("lT8fo");

var $dyNYh = parcelRequire("dyNYh");

var $6dBwJ = parcelRequire("6dBwJ");

var $T8owb = parcelRequire("T8owb");
class $3f1a3d6048e6e7c1$export$2e2bcd8739ae039 {
    constructor(node, view, getPos, portalProviderAPI, eventDispatcher, reactComponentProps, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    reactComponent, viewShouldUpdate){
        this.decorations = [];
        this.handleRef = (node)=>this._handleRef(node);
        this.dispatchAnalyticsEvent = (payload)=>{
            if (this.eventDispatcher) {
                const dispatch = (0, $aoyv9.createDispatch)(this.eventDispatcher);
                dispatch((0, $dyNYh.analyticsEventKey), {
                    payload: payload
                });
            }
        };
        this.node = node;
        this.view = view;
        this.getPos = getPos;
        this.portalProviderAPI = portalProviderAPI;
        this.reactComponentProps = reactComponentProps || {};
        this.reactComponent = reactComponent;
        this._viewShouldUpdate = viewShouldUpdate;
        this.eventDispatcher = eventDispatcher;
        this.key = (0, $6dBwJ.generateUniqueNodeKey)();
    }
    /**
	 * This method exists to move initialization logic out of the constructor,
	 * so object can be initialized properly before calling render first time.
	 *
	 * Example:
	 * Instance properties get added to an object only after super call in
	 * constructor, which leads to some methods being undefined during the
	 * first render.
	 */ init() {
        this.domRef = this.createDomRef();
        this.setDomAttrs(this.node, this.domRef);
        const { dom: contentDOMWrapper, contentDOM: contentDOM } = this.getContentDOM() || {
            dom: undefined,
            contentDOM: undefined
        };
        if (this.domRef && contentDOMWrapper) {
            this.domRef.appendChild(contentDOMWrapper);
            this.contentDOM = contentDOM ? contentDOM : contentDOMWrapper;
            this.contentDOMWrapper = contentDOMWrapper || contentDOM;
        }
        // @see ED-3790
        // something gets messed up during mutation processing inside of a
        // nodeView if DOM structure has nested plain "div"s, it doesn't see the
        // difference between them and it kills the nodeView
        this.domRef.classList.add(`${this.node.type.name}View-content-wrap`);
        const { samplingRate: samplingRate, slowThreshold: slowThreshold, trackingEnabled: trackingEnabled } = (0, $lT8fo.getPerformanceOptions)(this.view);
        trackingEnabled && (0, $lT8fo.startMeasureReactNodeViewRendered)({
            nodeTypeName: this.node.type.name
        });
        this.renderReactComponent(()=>this.render(this.reactComponentProps, this.handleRef));
        trackingEnabled && (0, $lT8fo.stopMeasureReactNodeViewRendered)({
            nodeTypeName: this.node.type.name,
            dispatchAnalyticsEvent: this.dispatchAnalyticsEvent,
            samplingRate: samplingRate,
            slowThreshold: slowThreshold
        });
        return this;
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    renderReactComponent(component) {
        if (!this.domRef || !component) return;
        const componentWithErrorBoundary = ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $28ffc.ErrorBoundary), {
                component: (0, $bMFKb.ACTION_SUBJECT).REACT_NODE_VIEW,
                componentId: this?.node?.type?.name ?? (0, $bMFKb.ACTION_SUBJECT_ID).UNKNOWN_NODE,
                dispatchAnalyticsEvent: this.dispatchAnalyticsEvent,
                children: component()
            });
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.portalProviderAPI.render(componentWithErrorBoundary, this.domRef, this.key);
    }
    createDomRef() {
        if (!this.node.isInline) return document.createElement('div');
        const htmlElement = document.createElement('span');
        return htmlElement;
    }
    getContentDOM() {
        return undefined;
    }
    _handleRef(node) {
        const contentDOM = this.contentDOMWrapper || this.contentDOM;
        // @ts-ignore
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let oldIgnoreMutation;
        let parentOffset = 0; // Remove with feature gate: platform_editor_r18_fix_selection_resync
        let selectionBookmark;
        let mutationsIgnored = false;
        // move the contentDOM node inside the inner reference after rendering
        if (node && contentDOM && !node.contains(contentDOM)) {
            // @ts-ignore - ignoreMutation may not be declared
            oldIgnoreMutation = this.ignoreMutation; // store ref to previous ignoreMutation
            // ignore all mutations caused by ProseMirror's MutationObserver triggering
            // after DOM change, except selection changes
            // @ts-ignore ProseMirror adds selection type to MutationRecord
            this.ignoreMutation = (m)=>{
                const isSelectionMutation = m.type === 'selection';
                if (!isSelectionMutation) mutationsIgnored = true;
                return !isSelectionMutation;
            };
            // capture document selection state before React DOM changes triggers ProseMirror selection change transaction
            if (this.view.state.selection.visible) selectionBookmark = this.view.state.selection.getBookmark();
            // ... and capture parent offset before DOM change
            if (!(0, $eGOwo.fg)('platform_editor_r18_fix_selection_resync')) {
                if (this.view.state.selection?.ranges.length > 0) parentOffset = this.view.state.selection?.ranges[0].$from?.parentOffset ?? 0;
            }
            node.appendChild(contentDOM);
            // After the next frame:
            requestAnimationFrame(()=>{
                // Restore the original mutation handler
                // @ts-ignore - this may not have been declared by implementing class
                this.ignoreMutation = oldIgnoreMutation;
                // Restore the selection only if:
                // - We have a selection bookmark
                // - Mutations were ignored during the table move
                // - The bookmarked selection is different from the current selection.
                if (selectionBookmark && mutationsIgnored) {
                    if ((0, $eGOwo.fg)('platform_editor_r18_fix_selection_resync')) {
                        const resolvedSelection = selectionBookmark.resolve(this.view.state.tr.doc);
                        // Don't set the selection if it's the same as the current selection.
                        if (!resolvedSelection.eq(this.view.state.selection)) {
                            const tr = this.view.state.tr.setSelection(resolvedSelection);
                            tr.setMeta('source', 'ReactNodeView:_handleRef:selection-resync');
                            this.view.dispatch(tr);
                        }
                    } else if (parentOffset > 0) // ... and dispatch expected selection state
                    this.view.dispatch(this.view.state.tr.setSelection(selectionBookmark.resolve(this.view.state.tr.doc)));
                }
            });
        }
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    render(props, forwardRef) {
        return this.reactComponent ? /*#__PURE__*/ (0, $gt9Am.jsx)(this.reactComponent, {
            view: this.view,
            getPos: this.getPos,
            node: this.node,
            forwardRef: forwardRef,
            ...props
        }) : null;
    }
    update(node, decorations, _innerDecorations, validUpdate = ()=>true) {
        // @see https://github.com/ProseMirror/prosemirror/issues/648
        const isValidUpdate = this.node.type === node.type && validUpdate(this.node, node);
        this.decorations = decorations;
        if (!isValidUpdate) return false;
        if (this.domRef && !this.node.sameMarkup(node)) this.setDomAttrs(node, this.domRef);
        // View should not process a re-render if this is false.
        // We dont want to destroy the view, so we return true.
        // TODO: ED-13910 - Fix viewShouldUpdate readonly decoration array
        if (!this.viewShouldUpdate(node, decorations)) {
            this.node = node;
            return true;
        }
        this.node = node;
        this.renderReactComponent(()=>this.render(this.reactComponentProps, this.handleRef));
        return true;
    }
    viewShouldUpdate(nextNode, decorations) {
        if (this._viewShouldUpdate) return this._viewShouldUpdate(nextNode);
        return true;
    }
    /**
	 * Copies the attributes from a ProseMirror Node to a DOM node.
	 * @param node The Prosemirror Node from which to source the attributes
	 */ setDomAttrs(node, element) {
        Object.keys(node.attrs || {}).forEach((attr)=>{
            element.setAttribute(attr, node.attrs[attr]);
        });
    }
    get dom() {
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        return this.domRef;
    }
    destroy() {
        if (!this.domRef) return;
        this.portalProviderAPI.remove(this.key);
        this.domRef = undefined;
        this.contentDOM = undefined;
    }
    static fromComponent(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    component, portalProviderAPI, eventDispatcher, props, viewShouldUpdate) {
        return (node, view, getPos)=>new $3f1a3d6048e6e7c1$export$2e2bcd8739ae039(node, view, getPos, portalProviderAPI, eventDispatcher, props, component, viewShouldUpdate).init();
    }
}

});

parcelRegister("cLBro", function(module, exports) {

$parcel$export(module.exports, "Datasource", () => $eab48a691cf7a3a1$export$9dd55813d0ee0514);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $6j98o = parcelRequire("6j98o");

var $hkyHj = parcelRequire("hkyHj");
var $e2Ny4 = parcelRequire("e2Ny4");

var $dfCRV = parcelRequire("dfCRV");

var $bnh3n = parcelRequire("bnh3n");

var $8KOSq = parcelRequire("8KOSq");

var $9kfy2 = parcelRequire("9kfy2");


var $biUbR = parcelRequire("biUbR");

var $knfyn = parcelRequire("knfyn");
const $eab48a691cf7a3a1$var$getPosSafely = (pos)=>{
    if (!pos || typeof pos === 'boolean') return;
    try {
        return pos();
    } catch (e) {
    // Can blow up in rare cases, when node has been removed.
    }
};
class $eab48a691cf7a3a1$export$1deb9aaa193645a1 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).PureComponent {
    constructor(props){
        super(props), this.getDatasource = ()=>this.props.node.attrs.datasource, this.getTableView = ()=>{
            const views = this.getDatasource().views;
            return views.find((view)=>view.type === 'table') || undefined;
        }, this.handleColumnChange = (columnKeys)=>{
            const { wrappedColumnKeys: wrappedColumnKeys = [], columnCustomSizes: columnCustomSizes = {} } = this.getColumnsInfo();
            this.updateTableProperties(columnKeys, columnCustomSizes, wrappedColumnKeys);
        }, this.handleColumnResize = (key, width)=>{
            const { wrappedColumnKeys: wrappedColumnKeys = [], columnCustomSizes: columnCustomSizes = {}, visibleColumnKeys: visibleColumnKeys = [] } = this.getColumnsInfo();
            const newColumnCustomSizes = {
                ...columnCustomSizes,
                [key]: width
            };
            this.updateTableProperties(visibleColumnKeys, newColumnCustomSizes, wrappedColumnKeys);
        }, this.handleWrappedColumnChange = (key, shouldWrap)=>{
            const { wrappedColumnKeys: wrappedColumnKeys = [], columnCustomSizes: columnCustomSizes = {}, visibleColumnKeys: visibleColumnKeys = [] } = this.getColumnsInfo();
            const wrappedColumnKeysSet = new Set(wrappedColumnKeys);
            if (shouldWrap) wrappedColumnKeysSet.add(key);
            else wrappedColumnKeysSet.delete(key);
            this.updateTableProperties(visibleColumnKeys, columnCustomSizes, Array.from(wrappedColumnKeysSet));
        }, this.onError = ({ err: err })=>{
            if (err) throw err;
        };
    }
    updateTableProperties(columnKeysArg, columnCustomSizes, wrappedColumnKeys) {
        const { state: state, dispatch: dispatch } = this.props.view;
        const pos = $eab48a691cf7a3a1$var$getPosSafely(this.props.getPos);
        if (pos === undefined) return;
        // In case for some reason there are no visible keys stored in ADF, we take them
        // from incoming sets of attributes like column sizes and wrapped column keys
        // columnKeys are needed to update ADF (
        // since attributes (like custom width and wrapped state) only make sense for a visible column )
        // So this part effectively adds a visible column if it wasn't there but attributes were given.
        const columnKeys = columnKeysArg.length > 0 ? columnKeysArg : Array.from(new Set([
            ...Object.keys(columnCustomSizes),
            ...wrappedColumnKeys
        ]));
        const views = [
            {
                type: 'table',
                properties: {
                    columns: columnKeys.map((key)=>{
                        const width = columnCustomSizes[key];
                        const isWrapped = wrappedColumnKeys.includes(key);
                        return {
                            key: key,
                            ...width ? {
                                width: width
                            } : {},
                            ...isWrapped ? {
                                isWrapped: isWrapped
                            } : {}
                        };
                    })
                }
            }
        ];
        const attrs = this.props.node.attrs;
        const tr = state.tr.setNodeMarkup(pos, undefined, {
            ...attrs,
            datasource: {
                ...attrs.datasource,
                views: views
            }
        });
        // Ensures dispatch does not contribute to undo history (otherwise user requires three undo's to revert table)
        tr.setMeta('addToHistory', false);
        tr.setMeta('scrollIntoView', false);
        dispatch(tr);
    }
    getColumnsInfo() {
        const tableView = this.getTableView();
        const columnsProp = tableView?.properties?.columns;
        const visibleColumnKeys = columnsProp?.map(({ key: key })=>key);
        let columnCustomSizes;
        const columnsWithWidth = columnsProp?.filter((c)=>!!c.width);
        if (columnsWithWidth) {
            const keyWidthPairs = columnsWithWidth.map((c)=>[
                    c.key,
                    c.width
                ]);
            columnCustomSizes = Object.fromEntries(keyWidthPairs);
        }
        const wrappedColumnKeys = columnsProp?.filter((c)=>c.isWrapped).map((c)=>c.key);
        return {
            visibleColumnKeys: visibleColumnKeys,
            columnCustomSizes: columnCustomSizes,
            wrappedColumnKeys: wrappedColumnKeys
        };
    }
    render() {
        const datasource = this.getDatasource();
        const attrs = this.props.node.attrs;
        const tableView = this.getTableView();
        if (tableView) {
            const { visibleColumnKeys: visibleColumnKeys, columnCustomSizes: columnCustomSizes, wrappedColumnKeys: wrappedColumnKeys } = this.getColumnsInfo();
            return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $9kfy2.EditorSmartCardProviderValueGuard), null, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $knfyn.EditorAnalyticsContext), {
                editorView: this.props.view
            }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $9kfy2.EditorSmartCardProvider), null, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $8KOSq.default), {
                datasourceId: datasource.id,
                parameters: datasource.parameters,
                visibleColumnKeys: visibleColumnKeys,
                onVisibleColumnKeysChange: this.handleColumnChange,
                url: attrs?.url,
                onColumnResize: this.handleColumnResize,
                columnCustomSizes: columnCustomSizes,
                onWrappedColumnChange: this.handleWrappedColumnChange,
                wrappedColumnKeys: wrappedColumnKeys
            }))));
        }
        return null;
    }
}
class $eab48a691cf7a3a1$export$9dd55813d0ee0514 extends (0, $6j98o.default) {
    constructor(props){
        super(props.node, props.view, props.getPos, props.portalProviderAPI, props.eventDispatcher, props);
        const sharedState = props?.pluginInjectionApi?.width?.sharedState;
        this.tableWidth = sharedState?.currentState()?.width;
        this.isNodeNested = props.isNodeNested;
        sharedState?.onChange(({ nextSharedState: nextSharedState })=>{
            if (nextSharedState?.width && this.tableWidth !== nextSharedState?.width) {
                this.tableWidth = nextSharedState?.width;
                this.update(this.node, []); // required to update the width when page is resized.
            }
        });
    }
    // Need this function to check if the datasource attribute was added or not to a blockCard.
    // If not, we return false so we can get the node to re-render properly as a block node instead.
    // Otherwise, the node view will still consider the node as a Datasource and render a such.
    validUpdate(_, newNode) {
        return !!newNode.attrs?.datasource;
    }
    update(node, decorations, _innerDecorations) {
        return super.update(node, decorations, _innerDecorations, this.validUpdate);
    }
    createDomRef() {
        const domRef = document.createElement('div');
        domRef.setAttribute('contenteditable', 'true');
        domRef.classList.add((0, $e2Ny4.SmartCardSharedCssClassName).DATASOURCE_CONTAINER);
        return domRef;
    }
    /**
   * Node views may render interactive elements that should not have their events reach editor
   *
   * We should the stop editor from handling events from following elements:
   * - typing in input
   * - activating buttons via spacebar
   *
   * Can be used to prevent the editor view from trying to handle some or all DOM events that bubble up from the node view.
   * Events for which this returns true are not handled by the editor.
   * @see {@link https://prosemirror.net/docs/ref/#view.NodeView.stopEvent}
   */ stopEvent(event) {
        const isFormElement = [
            HTMLButtonElement,
            HTMLInputElement
        ].some((element)=>event.target instanceof element);
        if (isFormElement) return true;
        return false;
    }
    render() {
        const { attrs: attrs } = this.node;
        // EDM-10607: Workaround to remove datasource table draggable attribute
        // @ts-ignore TS2341: Property domRef is private
        this.domRef?.setAttribute('draggable', 'false');
        return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $biUbR.DatasourceErrorBoundary), {
            unsupportedComponent: (0, $dfCRV.default),
            view: this.view,
            url: attrs.url,
            datasourceId: attrs?.datasource?.id
        }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $hkyHj.DATASOURCE_INNER_CONTAINER_CLASSNAME),
            style: {
                minWidth: this.isNodeNested ? '100%' : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                (0, $bnh3n.calcBreakoutWidth)(attrs.layout || (0, $a358b8ea78408961$export$60efea3f80310017), this.tableWidth)
            }
        }, /*#__PURE__*/ (0, $1NIU8.jsx)($eab48a691cf7a3a1$export$1deb9aaa193645a1, {
            node: this.node,
            view: this.view,
            getPos: this.getPos
        })));
    }
}

});
parcelRegister("8KOSq", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fcd2e2af5104151$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

const $2fcd2e2af5104151$var$LazyDatasourceTableView = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("i0y3d")).then((module)=>({
            default: module.DatasourceTableView
        })));
const $2fcd2e2af5104151$var$DatasourceTableViewWithWrappers = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJOHy.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            "data-testid": 'datasource-table-view-suspense'
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2fcd2e2af5104151$var$LazyDatasourceTableView, props));
};
var $2fcd2e2af5104151$export$2e2bcd8739ae039 = $2fcd2e2af5104151$var$DatasourceTableViewWithWrappers;

});
parcelRegister("i0y3d", function(module, exports) {

let $d1c2a3dd7d3a29a0$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $d1c2a3dd7d3a29a0$var$load("kNFvF"),
    $d1c2a3dd7d3a29a0$var$load("76n7a"),
    $d1c2a3dd7d3a29a0$var$load("l253H"),
    $d1c2a3dd7d3a29a0$var$load("ffQaD"),
    $d1c2a3dd7d3a29a0$var$load("kvRbA"),
    $d1c2a3dd7d3a29a0$var$load("exQGw")
]).then(()=>parcelRequire('hadck'));

});


parcelRegister("biUbR", function(module, exports) {

$parcel$export(module.exports, "DatasourceErrorBoundary", () => $0096ea0897bcbee6$export$76664c71b9b1a689);
/* eslint-disable @repo/internal/react/no-class-components */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $iKozC = parcelRequire("iKozC");

var $d2DmH = parcelRequire("d2DmH");

var $4AOcQ = parcelRequire("4AOcQ");
class $0096ea0897bcbee6$export$76664c71b9b1a689 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    static getDerivedStateFromError(error) {
        return {
            isError: true,
            error: error
        };
    }
    componentDidCatch(error) {
        if (this.props.handleError) this.props.handleError();
        // prevent re-render children with error
        if (this.state.isError) this.setState({
            isError: true,
            error: error
        });
    }
    render() {
        const { url: url, unsupportedComponent: UnsupportedComponent, view: view, datasourceModalType: datasourceModalType, datasourceId: datasourceId } = this.props;
        if (this.state.isError) {
            if (url && (0, $iKozC.isSafeUrl)(url)) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $d2DmH.LazyLoadedDatasourceRenderFailedAnalyticsWrapper), {
                datasourceId: datasourceId,
                error: this.state.error,
                children: (0, $4AOcQ.setSelectedCardAppearance)('inline', undefined)(view.state, view.dispatch)
            });
            else {
                const unsupportedComponent = UnsupportedComponent ? /*#__PURE__*/ (0, $gt9Am.jsx)(UnsupportedComponent, {}) : null;
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $d2DmH.LazyLoadedDatasourceRenderFailedAnalyticsWrapper), {
                    datasourceModalType: datasourceModalType,
                    datasourceId: datasourceId,
                    error: this.state.error,
                    children: unsupportedComponent
                });
            }
        } else return this.props.children;
    }
    constructor(...args){
        super(...args), this.state = {
            isError: false,
            error: null
        };
    }
}

});
parcelRegister("d2DmH", function(module, exports) {

$parcel$export(module.exports, "LazyLoadedDatasourceRenderFailedAnalyticsWrapper", () => $e573d4ac9205d05d$export$f386473e8f104bcb);

var $eJOHy = parcelRequire("eJOHy");

const $e573d4ac9205d05d$var$LazyDatasourceRenderFailedAnalyticsWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>(parcelRequire("fOdOZ")));
const $e573d4ac9205d05d$export$f386473e8f104bcb = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJOHy.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e573d4ac9205d05d$var$LazyDatasourceRenderFailedAnalyticsWrapper, props));

});
parcelRegister("fOdOZ", function(module, exports) {

let $b8263f288b161b65$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $b8263f288b161b65$var$load("jQLsm").then(()=>parcelRequire('kpPKM'));

});






parcelRegister("ewKS2", function(module, exports) {

$parcel$export(module.exports, "lazyEmbedCardView", () => $c479a49998424a18$export$eb946eb841dd1469);

var $hkA3A = parcelRequire("hkA3A");

var $92xoS = parcelRequire("92xoS");

var $l5Y3W = parcelRequire("l5Y3W");

const $c479a49998424a18$export$eb946eb841dd1469 = (props)=>{
    if ((0, $92xoS.editorExperiment)('platform_editor_exp_lazy_node_views', false)) return (0, $l5Y3W.embedCardNodeView)(props);
    return (0, $hkA3A.withLazyLoading)({
        nodeName: 'embedCard',
        getNodeViewOptions: ()=>{},
        loader: ()=>{
            const result = Promise.resolve((parcelRequire("l5Y3W"))).then(({ embedCardNodeView: embedCardNodeView })=>{
                return embedCardNodeView(props);
            });
            return result;
        }
    });
};

});
parcelRegister("l5Y3W", function(module, exports) {

$parcel$export(module.exports, "embedCardNodeView", () => $6362e5b33e3bb432$export$86904605fa83de6c);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $bRPNB = parcelRequire("bRPNB");

var $8KLBw = parcelRequire("8KLBw");

var $eqD2x = parcelRequire("eqD2x");

var $kLQ9a = parcelRequire("kLQ9a");
var $bSToC = parcelRequire("bSToC");
var $cxXTK = parcelRequire("cxXTK");

var $6j98o = parcelRequire("6j98o");

var $dwnni = parcelRequire("dwnni");
var $jYx9G = parcelRequire("jYx9G");
var $93FVZ = parcelRequire("93FVZ");

var $19zEl = parcelRequire("19zEl");

var $7yBx7 = parcelRequire("7yBx7");

var $4cFYC = parcelRequire("4cFYC");
var $6PcbG = parcelRequire("6PcbG");

var $ecNk4 = parcelRequire("ecNk4");

var $fA0pL = parcelRequire("fA0pL");

var $gqKWA = parcelRequire("gqKWA");
const $6362e5b33e3bb432$var$selector = (states)=>{
    return {
        widthStateLineLength: states.widthState?.lineLength || 0,
        widthStateWidth: states.widthState?.width || 0,
        editorDisabled: states.editorDisabledState?.editorDisabled
    };
};
const $6362e5b33e3bb432$var$useSharedState = (0, $kLQ9a.sharedPluginStateHookMigratorFactory)((pluginInjectionApi)=>{
    return (0, $cxXTK.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'width',
        'editorDisabled'
    ], $6362e5b33e3bb432$var$selector);
}, (pluginInjectionApi)=>{
    const { widthState: widthState, editorDisabledState: editorDisabledState } = (0, $bSToC.useSharedPluginState)(pluginInjectionApi, [
        'width',
        'editorDisabled'
    ]);
    return {
        widthStateLineLength: widthState?.lineLength || 0,
        widthStateWidth: widthState?.width || 0,
        editorDisabled: editorDisabledState?.editorDisabled
    };
});
const $6362e5b33e3bb432$var$CardInner = ({ pluginInjectionApi: pluginInjectionApi, getPosSafely: getPosSafely, getLineLength: getLineLength, view: view, smartCard: smartCard, eventDispatcher: eventDispatcher, updateSize: updateSize, getPos: getPos, aspectRatio: aspectRatio, allowResizing: allowResizing, hasPreview: hasPreview, heightAlone: heightAlone, cardProps: cardProps, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
    const { widthStateLineLength: widthStateLineLength, widthStateWidth: widthStateWidth, editorDisabled: editorDisabled } = $6362e5b33e3bb432$var$useSharedState(pluginInjectionApi);
    const pos = getPosSafely();
    if (pos === undefined) return null;
    const lineLength = getLineLength(view, pos, widthStateLineLength);
    const containerWidth = (0, $19zEl.isRichMediaInsideOfBlockNode)(view, pos) ? lineLength : widthStateWidth;
    if (!allowResizing || !hasPreview) {
        // There are two ways `width` and `height` can be defined here:
        // 1) Either as `heightAlone` as height value and no width
        // 2) or as `1` for height and aspectRation (defined or a default one) as a width
        // See above for how aspectRation is calculated.
        const defaultAspectRatio = (0, $7yBx7.DEFAULT_EMBED_CARD_WIDTH) / (0, $7yBx7.DEFAULT_EMBED_CARD_HEIGHT);
        let richMediaWrapperHeight = 1;
        let richMediaWrapperWidth = aspectRatio || defaultAspectRatio;
        if (heightAlone) {
            richMediaWrapperHeight = heightAlone;
            richMediaWrapperWidth = undefined;
        }
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jYx9G.default), {
            ...cardProps,
            height: richMediaWrapperHeight,
            width: richMediaWrapperWidth,
            nodeType: "embedCard",
            hasFallbackContainer: hasPreview,
            lineLength: lineLength,
            containerWidth: containerWidth,
            children: smartCard
        });
    }
    const displayGrid = (visible, gridType, highlight)=>pluginInjectionApi?.grid?.actions?.displayGrid(view)({
            visible: visible,
            gridType: gridType,
            highlight: highlight
        });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fA0pL.default), {
        ...cardProps,
        height: heightAlone,
        aspectRatio: aspectRatio,
        view: view,
        getPos: getPos,
        lineLength: lineLength,
        gridSize: 12,
        containerWidth: containerWidth,
        displayGrid: displayGrid,
        updateSize: updateSize,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        isResizeDisabled: editorDisabled,
        children: smartCard
    });
};
class $6362e5b33e3bb432$export$61b2782f78272a37 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).PureComponent {
    constructor(props){
        super(props), this.embedIframeRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createRef(), this.state = {
            hasPreview: true
        }, this.getPosSafely = ()=>{
            const { getPos: getPos } = this.props;
            if (!getPos || typeof getPos === 'boolean') return;
            try {
                return getPos();
            } catch (e) {
            // Can blow up in rare cases, when node has been removed.
            }
        }, this.onResolve = (data)=>{
            const { view: view } = this.props;
            const { title: title, url: url, aspectRatio: aspectRatio } = data;
            const { originalHeight: originalHeight, originalWidth: originalWidth } = this.props.node.attrs;
            if (aspectRatio && !originalHeight && !originalWidth) {
                // Assumption here is if ADF already have both height and width set,
                // we will going to use that later on in this class as aspectRatio
                // Most likely we dealing with an embed that received aspectRatio via onResolve previously
                // and now this information already stored in ADF.
                this.setState({
                    initialAspectRatio: aspectRatio
                });
                this.saveOriginalDimensionsAttributes((0, $7yBx7.DEFAULT_EMBED_CARD_HEIGHT), (0, $7yBx7.DEFAULT_EMBED_CARD_HEIGHT) * aspectRatio);
            }
            // don't dispatch immediately since we might be in the middle of
            // rendering a nodeview
            (0, $bRPNB.default)(()=>{
                const pos = this.getPosSafely();
                if (pos === undefined) return;
                return view.dispatch((0, $ecNk4.registerCard)({
                    title: title,
                    url: url,
                    pos: pos,
                    id: this.props.id
                })(view.state.tr));
            })();
            try {
                const cardContext = this.props.cardContext?.value ? this.props.cardContext?.value : undefined;
                const hasPreview = url && cardContext && cardContext.extractors.getPreview(url, 'web');
                if (!hasPreview) this.setState({
                    hasPreview: false
                });
            } catch (e) {}
        }, this.updateSize = (pctWidth, layout)=>{
            const { state: state, dispatch: dispatch } = this.props.view;
            const pos = this.getPosSafely();
            if (pos === undefined) return;
            const tr = state.tr.setNodeMarkup(pos, undefined, {
                ...this.props.node.attrs,
                width: pctWidth,
                layout: layout
            });
            tr.setMeta('scrollIntoView', false);
            dispatch(tr);
            return true;
        }, this.getLineLength = (view, pos, originalLineLength)=>{
            if (typeof pos === 'number' && (0, $19zEl.isRichMediaInsideOfBlockNode)(view, pos)) {
                const $pos = view.state.doc.resolve(pos);
                const domNode = view.nodeDOM($pos.pos);
                if ($pos.nodeAfter && (0, $19zEl.floatingLayouts).indexOf($pos.nodeAfter.attrs.layout) > -1 && domNode && domNode.parentElement) return domNode.parentElement.offsetWidth;
                if (domNode instanceof HTMLElement) return domNode.offsetWidth;
            }
            return originalLineLength;
        }, /**
	 * Even though render is capable of listening and reacting to iframely wrapper iframe sent `resize` events
	 * it's good idea to store latest actual height in ADF, so that when renderer (well, editor as well) is loading
	 * we will show embed window of appropriate size and avoid unnecessary content jumping.
	 */ this.saveOriginalDimensionsAttributes = (height, width)=>{
            const { view: view } = this.props;
            // Please, do not copy or use this kind of code below
            // @ts-ignore
            const fakeTableResizePluginKey = {
                key: 'tableFlexiColumnResizing$',
                getState: (state)=>{
                    // eslint-disable-next-line
                    return state['tableFlexiColumnResizing$'];
                }
            };
            const fakeTableResizeState = fakeTableResizePluginKey.getState(view.state);
            // We are not updating ADF when this function fired while table is resizing.
            // Changing ADF in the middle of resize will break table resize plugin logic
            // (tables will be considered different at the end of the drag and cell size won't be stored)
            // But this is not a big problem, editor user will be seeing latest height anyway (via updated state)
            // And even if page to be saved with slightly outdated height, renderer is capable of reading latest height value
            // when embed loads, and so it won't be a problem.
            if (fakeTableResizeState?.dragging) return;
            (0, $bRPNB.default)(()=>{
                const pos = this.getPosSafely();
                if (pos === undefined) return;
                view.dispatch(view.state.tr.step(new (0, $eqD2x.SetAttrsStep)(pos, {
                    originalHeight: height,
                    originalWidth: width
                })).setMeta('addToHistory', false));
            })();
        }, this.onHeightUpdate = (height)=>{
            this.setState({
                liveHeight: height
            });
            this.saveOriginalDimensionsAttributes(height, undefined);
        }, this.onError = ({ err: err })=>{
            if (err) throw err;
        }, this.removeCardDispatched = false;
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.scrollContainer = (0, $dwnni.findOverflowScrollParent)(props.view.dom) || undefined;
    }
    componentWillUnmount() {
        this.removeCard();
    }
    removeCard() {
        if (this.removeCardDispatched) return;
        this.removeCardDispatched = true;
        const { tr: tr } = this.props.view.state;
        (0, $ecNk4.removeCard)({
            id: this.props.id
        })(tr);
        this.props.view.dispatch(tr);
    }
    render() {
        const { node: node, allowResizing: allowResizing, fullWidthMode: fullWidthMode, view: view, dispatchAnalyticsEvent: dispatchAnalyticsEvent, getPos: getPos, pluginInjectionApi: pluginInjectionApi, actionOptions: actionOptions, onClick: onClick, CompetitorPrompt: CompetitorPrompt } = this.props;
        const { url: url, width: pctWidth, layout: layout, originalHeight: originalHeight, originalWidth: originalWidth } = node.attrs;
        const { hasPreview: hasPreview, liveHeight: liveHeight, initialAspectRatio: initialAspectRatio } = this.state;
        // We don't want to use `originalHeight` when `originalWidth` also present,
        // since `heightAlone` is defined only when just height is available.
        const heightAlone = liveHeight ?? (!originalWidth && originalHeight || undefined);
        const aspectRatio = !heightAlone && // No need getting aspectRatio if heightAlone defined already
        (initialAspectRatio || // If we have initialAspectRatio (coming from iframely) we should go with that
        originalHeight && originalWidth && originalWidth / originalHeight) || // If ADF contains both width and height we get ratio from that
        undefined;
        const cardProps = {
            layout: layout,
            pctWidth: pctWidth,
            fullWidthMode: fullWidthMode
        };
        const smartCard = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4cFYC.Card), {
            url: url,
            appearance: "embed",
            onClick: onClick,
            onResolve: this.onResolve,
            onError: this.onError,
            frameStyle: "show",
            inheritDimensions: true,
            platform: 'web',
            container: this.scrollContainer,
            embedIframeRef: this.embedIframeRef,
            actionOptions: actionOptions,
            CompetitorPrompt: CompetitorPrompt
        }, url);
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6PcbG.EmbedResizeMessageListener), {
            embedIframeRef: this.embedIframeRef,
            onHeightUpdate: this.onHeightUpdate,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)($6362e5b33e3bb432$var$CardInner, {
                pluginInjectionApi: pluginInjectionApi,
                smartCard: smartCard,
                hasPreview: hasPreview,
                getPosSafely: this.getPosSafely,
                view: view,
                getLineLength: this.getLineLength,
                eventDispatcher: this.props.eventDispatcher,
                updateSize: this.updateSize,
                getPos: getPos,
                aspectRatio: aspectRatio,
                allowResizing: allowResizing,
                heightAlone: heightAlone,
                cardProps: cardProps,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent
            })
        });
    }
}
const $6362e5b33e3bb432$var$WrappedBlockCard = (0, $gqKWA.Card)($6362e5b33e3bb432$export$61b2782f78272a37, (0, $93FVZ.default));
class $6362e5b33e3bb432$export$6789d7ecdc77631b extends (0, $6j98o.default) {
    viewShouldUpdate(nextNode) {
        if (this.node.attrs !== nextNode.attrs) return true;
        return super.viewShouldUpdate(nextNode);
    }
    createDomRef() {
        const domRef = document.createElement('div');
        // It is a tradeoff for the bug mentioned that occurs in Chrome: https://product-fabric.atlassian.net/browse/ED-5379, https://github.com/ProseMirror/prosemirror/issues/884
        this.unsubscribe = this.reactComponentProps.pluginInjectionApi?.editorViewMode?.sharedState.onChange(({ nextSharedState: nextSharedState })=>this.updateContentEditable(nextSharedState, domRef));
        this.updateContentEditable(this.reactComponentProps.pluginInjectionApi?.editorViewMode?.sharedState.currentState(), domRef);
        domRef.setAttribute('spellcheck', 'false');
        return domRef;
    }
    render() {
        const { eventDispatcher: eventDispatcher, allowResizing: allowResizing, fullWidthMode: fullWidthMode, dispatchAnalyticsEvent: dispatchAnalyticsEvent, pluginInjectionApi: pluginInjectionApi, onClickCallback: onClickCallback, CompetitorPrompt: CompetitorPrompt } = this.reactComponentProps;
        return /*#__PURE__*/ (0, $gt9Am.jsx)($6362e5b33e3bb432$var$WrappedBlockCard, {
            node: this.node,
            view: this.view,
            eventDispatcher: eventDispatcher,
            getPos: this.getPos,
            allowResizing: allowResizing,
            fullWidthMode: fullWidthMode,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            pluginInjectionApi: pluginInjectionApi,
            onClickCallback: onClickCallback,
            id: this.id,
            CompetitorPrompt: CompetitorPrompt
        });
    }
    destroy() {
        this.unsubscribe?.();
        super.destroy();
    }
    constructor(...args){
        super(...args), this.id = (0, (/*@__PURE__*/$parcel$interopDefault($8KLBw)))(), this.updateContentEditable = (editorViewModeState, divElement)=>{
            divElement.contentEditable = editorViewModeState?.mode === 'view' ? 'false' : 'true';
        };
    }
}
const $6362e5b33e3bb432$export$86904605fa83de6c = ({ allowResizing: allowResizing, fullWidthMode: fullWidthMode, pmPluginFactoryParams: pmPluginFactoryParams, pluginInjectionApi: pluginInjectionApi, actionOptions: actionOptions, onClickCallback: onClickCallback, CompetitorPrompt: CompetitorPrompt })=>(node, view, getPos)=>{
        const { portalProviderAPI: portalProviderAPI, eventDispatcher: eventDispatcher, dispatchAnalyticsEvent: dispatchAnalyticsEvent } = pmPluginFactoryParams;
        const reactComponentProps = {
            eventDispatcher: eventDispatcher,
            allowResizing: allowResizing,
            fullWidthMode: fullWidthMode,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            pluginInjectionApi: pluginInjectionApi,
            actionOptions: actionOptions,
            onClickCallback: onClickCallback,
            CompetitorPrompt: CompetitorPrompt
        };
        return new $6362e5b33e3bb432$export$6789d7ecdc77631b(node, view, getPos, portalProviderAPI, eventDispatcher, reactComponentProps, undefined).init();
    };

});
parcelRegister("eqD2x", function(module, exports) {

$parcel$export(module.exports, "SetAttrsStep", () => $a811c6e78306332a$export$8cfd0a0bfa522949);

var $lzEKq = parcelRequire("lzEKq");

var $3xw6l = parcelRequire("3xw6l");
class $a811c6e78306332a$export$8cfd0a0bfa522949 extends (0, $lzEKq.Step) {
    constructor(pos, attrs){
        super();
        this.pos = pos;
        this.attrs = attrs;
    }
    apply(doc) {
        let target = doc.nodeAt(this.pos);
        if (!target) return (0, $lzEKq.StepResult).fail('No node at given position');
        if (target.isText) return (0, $lzEKq.StepResult).fail('Target is a text node. Attributes are not allowed.');
        const attrs = {
            ...target.attrs || {},
            ...this.attrs || {}
        };
        let newNode = target.type.create(attrs, (0, $3xw6l.Fragment).empty, target.marks);
        let slice = new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).from(newNode), 0, target.isLeaf ? 0 : 1);
        return (0, $lzEKq.StepResult).fromReplace(doc, this.pos, this.pos + 1, slice);
    }
    invert(doc) {
        let target = doc.nodeAt(this.pos);
        return new $a811c6e78306332a$export$8cfd0a0bfa522949(this.pos, target ? target.attrs : {});
    }
    map(mapping) {
        let result = mapping.mapResult(this.pos, 1);
        return result.deleted ? null : new $a811c6e78306332a$export$8cfd0a0bfa522949(result.pos, this.attrs);
    }
    toJSON() {
        return {
            stepType: 'setAttrs',
            pos: this.pos,
            attrs: this.attrs
        };
    }
    static fromJSON(_schema, json) {
        if (typeof json.pos !== 'number' || json.attrs !== null && typeof json.attrs !== 'object') throw new RangeError('Invalid input for SetAttrsStep.fromJSON');
        return new $a811c6e78306332a$export$8cfd0a0bfa522949(json.pos, json.attrs);
    }
}
(0, $lzEKq.Step).jsonID('setAttrs', $a811c6e78306332a$export$8cfd0a0bfa522949);

});

parcelRegister("jYx9G", function(module, exports) {

$parcel$export(module.exports, "default", () => $209fa0d68bd3a102$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $k9JrM = parcelRequire("k9JrM");

var $7yBx7 = parcelRequire("7yBx7");

var $eGOwo = parcelRequire("eGOwo");

var $jgJtD = parcelRequire("jgJtD");

var $1I3aa = parcelRequire("1I3aa");

var $2zJxT = parcelRequire("2zJxT");

var $19zEl = parcelRequire("19zEl");

var $jhKIq = parcelRequire("jhKIq");
function $209fa0d68bd3a102$export$2e2bcd8739ae039({ layout: layout, width: width, height: height, containerWidth: containerWidth = width, isLoading: isLoading = false, pctWidth: pctWidth, size: size, className: className, children: propsChildren, nodeType: nodeType = 'mediaSingle', fullWidthMode: fullWidthMode, lineLength: editorWidth, hasFallbackContainer: hasFallbackContainer = true, handleMediaSingleRef: handleMediaSingleRef, isInsideOfInlineExtension: isInsideOfInlineExtension = false, dataAttributes: dataAttributes }) {
    const isPixelWidth = size?.widthType === 'pixel';
    let mediaSingleWidth = size?.width || pctWidth;
    const children = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Children.toArray(propsChildren);
    if (!mediaSingleWidth && (0, $19zEl.shouldAddDefaultWrappedWidth)(layout, width, editorWidth)) // if width is not available, set to half of editor width
    mediaSingleWidth = isPixelWidth ? editorWidth / 2 : 50;
    // When width is not set we have an absolute height for a given embed.
    // When both width and height are set we use them to determine ratio and use that to define
    // embed height in relation to whatever width of an dom element is in runtime.
    const isHeightOnly = width === undefined;
    if (mediaSingleWidth) {
        const pxWidth = (0, $2zJxT.getMediaSinglePixelWidth)(mediaSingleWidth, editorWidth, size?.widthType, (0, $1I3aa.MEDIA_SINGLE_GUTTER_SIZE));
        if (isHeightOnly) width = pxWidth - (0, $7yBx7.akEditorMediaResizeHandlerPaddingWide);
        else if (width !== undefined) {
            height = height / width * pxWidth;
            width = pxWidth;
        }
    } else if (isHeightOnly) // No mediaSingleWidth can be found on already existing pages with existing embeds
    // It's ok to use Embed specific width, because width can be not set only in embed card.
    // This value will be used only in the case of non `wide` and non `full-width` cases inside MediaSingleDimensionHelper.
    width = (0, $7yBx7.DEFAULT_EMBED_CARD_WIDTH) - (0, $7yBx7.akEditorMediaResizeHandlerPaddingWide);
    // Media wrapper controls the height of the box.
    // We can define this height
    // - via height directly
    // - via paddingBottom (if we have both height and width) which is a css trick to represent a ratio
    let mediaWrapperHeight;
    let paddingBottom;
    if (isHeightOnly) mediaWrapperHeight = height;
    else if (width !== undefined) {
        const mediaWrapperRatio = height / width * 100;
        paddingBottom = `${mediaWrapperRatio.toFixed(3)}%`;
        if (nodeType === 'embedCard') // we want to set ratio of whole box (including header) buy knowing ratio of iframe itself
        // For some reason importing `embedHeaderHeight` from '@atlaskit/smart-card' breaks
        // packages/editor/editor-core/src/plugins/table/__tests__/unit/toolbar.ts 🤷‍️, but we have a test
        // that uses imported value, so it's should be good.
        paddingBottom = `calc(${paddingBottom} + 32px)`;
    }
    const [media, caption] = children;
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        ref: handleMediaSingleRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: (0, $jhKIq.MediaSingleDimensionHelper)({
            width: width,
            layout: layout,
            containerWidth: containerWidth,
            mediaSingleWidth: mediaSingleWidth,
            fullWidthMode: fullWidthMode,
            isExtendedResizeExperienceOn: isPixelWidth,
            isInsideOfInlineExtension: isInsideOfInlineExtension,
            nodeType: nodeType
        }),
        ...(0, $eGOwo.fg)('platform_editor_fix_image_size_diff_during_ssr') ? {} : {
            'data-layout': layout
        },
        "data-width": mediaSingleWidth,
        "data-width-type": size?.widthType || 'percentage',
        "data-node-type": nodeType,
        "data-vc": "media-single",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, (/*@__PURE__*/$parcel$interopDefault($k9JrM)))('rich-media-item mediaSingleView-content-wrap', `image-${layout}`, className, {
            'is-loading': isLoading,
            'rich-media-wrapped': layout === 'wrap-left' || layout === 'wrap-right'
        }),
        ...dataAttributes,
        ...(0, $jgJtD.VcMediaWrapperProps)
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $jhKIq.MediaWrapper), {
        hasFallbackContainer: hasFallbackContainer,
        height: mediaWrapperHeight,
        paddingBottom: paddingBottom
    }, media), caption);
}

});
parcelRegister("2zJxT", function(module, exports) {

$parcel$export(module.exports, "getMediaSinglePixelWidth", () => $80b986ec0541becf$export$a6f4ec2edd25b07e);
$parcel$export(module.exports, "calcMediaSinglePixelWidth", () => $80b986ec0541becf$export$5091b2c0d1cd2361);
$parcel$export(module.exports, "calcMediaSingleMaxWidth", () => $80b986ec0541becf$export$a2e7f6320d796a21);
$parcel$export(module.exports, "getMediaSingleInitialWidth", () => $80b986ec0541becf$export$4ab195f543459515);
$parcel$export(module.exports, "calculateOffsetLeft", () => $80b986ec0541becf$export$ab1f1890e4428242);
$parcel$export(module.exports, "roundToNearest", () => $80b986ec0541becf$export$f72673597dacfcfa);
$parcel$export(module.exports, "calcMinWidth", () => $80b986ec0541becf$export$c7eaa4d46a45395);
$parcel$export(module.exports, "getMaxWidthForNestedNode", () => $80b986ec0541becf$export$4147ff5cc31ec064);
$parcel$export(module.exports, "getMaxWidthForNestedNodeNext", () => $80b986ec0541becf$export$bcefe8f1d5d7bbf3);
$parcel$export(module.exports, "currentMediaNodeWithPos", () => $80b986ec0541becf$export$22e4c8c04f58169d);

var $3lIcL = parcelRequire("3lIcL");

var $7yBx7 = parcelRequire("7yBx7");

var $19zEl = parcelRequire("19zEl");

var $1I3aa = parcelRequire("1I3aa");
function $80b986ec0541becf$export$a6f4ec2edd25b07e(width, editorWidth, widthType = 'percentage', gutterOffset = 0) {
    if (widthType === 'pixel') return width;
    return Math.ceil((editorWidth + gutterOffset) * (width / 100) - gutterOffset);
}
const $80b986ec0541becf$export$5091b2c0d1cd2361 = ({ width: width, widthType: widthType = 'percentage', origWidth: origWidth, layout: layout, contentWidth: contentWidth, containerWidth: containerWidth, gutterOffset: gutterOffset = 0 })=>{
    if (widthType === 'pixel' && width) return width;
    switch(layout){
        case 'wide':
            return $80b986ec0541becf$var$calcLegacyWideWidth(containerWidth, origWidth, contentWidth);
        case 'full-width':
            // legacy and new experience have different definitions of full-width,
            // since it's for new experience, we convert to the new definition
            return $80b986ec0541becf$export$a2e7f6320d796a21(containerWidth);
        default:
            if (width) return Math.ceil(((contentWidth || containerWidth) + gutterOffset) * (width / 100) - gutterOffset);
    }
    // Handle the case of not resized node with wrapped layout
    // It's possible that the node is first inserted with align layout (e.g. jira)
    // in which the legacy image would render the width as min(origWidth, halfContentWidth).
    // However, new experience won't be able to distinguish the two. Thus, we render halfContentWidth
    // to make sure confluence legacy node is renderered correctly
    if ((0, $1I3aa.wrappedLayouts).includes(layout)) return Math.ceil((contentWidth || containerWidth) / 2);
    // set initial width for not resized legacy image
    return $80b986ec0541becf$export$4ab195f543459515(origWidth, // in case containerWidth is 0, we fallback to undefined to use akEditorDefaultLayoutWidth
    contentWidth || containerWidth || undefined);
};
/**
 * Calculate pixel width for legacy media single
 * @param contentWidth editor content width
 * @param containerWidth editor container width
 */ const $80b986ec0541becf$var$calcLegacyWideWidth = (containerWidth, origWidth, contentWidth)=>{
    if (contentWidth) {
        const wideWidth = Math.ceil(contentWidth * (0, $7yBx7.breakoutWideScaleRatio));
        return wideWidth > containerWidth ? contentWidth : wideWidth;
    }
    return origWidth;
};
const $80b986ec0541becf$export$a2e7f6320d796a21 = (containerWidth, editorAppearance)=>{
    const fullWidthPadding = editorAppearance === 'full-page' ? (0, $7yBx7.akEditorGutterPaddingDynamic)() * 2 : (0, $7yBx7.akEditorGutterPadding) * 2;
    return Math.min(containerWidth - fullWidthPadding, (0, $7yBx7.akEditorFullWidthLayoutWidth));
};
const $80b986ec0541becf$export$4ab195f543459515 = (origWidth = (0, $1I3aa.DEFAULT_IMAGE_WIDTH), maxWidth = (0, $7yBx7.akEditorDefaultLayoutWidth), minWidth = (0, $1I3aa.MEDIA_SINGLE_DEFAULT_MIN_PIXEL_WIDTH))=>{
    return Math.max(Math.min(origWidth, maxWidth), minWidth);
};
function $80b986ec0541becf$export$ab1f1890e4428242(insideInlineLike, insideLayout, pmViewDom, wrapper) {
    let offsetLeft = 0;
    if (wrapper && insideInlineLike && !insideLayout) {
        const currentNode = wrapper;
        const boundingRect = currentNode.getBoundingClientRect();
        offsetLeft = boundingRect.left - pmViewDom.getBoundingClientRect().left;
    }
    return offsetLeft;
}
const $80b986ec0541becf$export$f72673597dacfcfa = (value, interval = (0, $1I3aa.DEFAULT_ROUNDING_INTERVAL))=>Math.round(value / interval) * interval;
const $80b986ec0541becf$export$c7eaa4d46a45395 = (isVideoFile, contentWidth)=>{
    return Math.min(contentWidth, isVideoFile ? (0, $1I3aa.MEDIA_SINGLE_VIDEO_MIN_PIXEL_WIDTH) : (0, $1I3aa.MEDIA_SINGLE_DEFAULT_MIN_PIXEL_WIDTH));
};
const $80b986ec0541becf$export$4147ff5cc31ec064 = (view, pos)=>{
    if (typeof pos !== 'number') return null;
    if ((0, $19zEl.isRichMediaInsideOfBlockNode)(view, pos)) {
        const $pos = view.state.doc.resolve(pos);
        const domNode = view.nodeDOM($pos.pos);
        if ($pos.nodeAfter && (0, $19zEl.floatingLayouts).indexOf($pos.nodeAfter.attrs.layout) > -1 && domNode && domNode.parentElement) return domNode.parentElement.offsetWidth;
        if (domNode instanceof HTMLElement) return domNode.offsetWidth;
    }
    return null;
};
const $80b986ec0541becf$var$calcParentPadding = (view, resolvedPos)=>{
    // since table has constant padding, use hardcoded constant instead of query the dom
    const tablePadding = 8;
    const { tableCell: tableCell, tableHeader: tableHeader } = view.state.schema.nodes;
    return [
        tableCell,
        tableHeader
    ].includes(resolvedPos.parent.type) ? tablePadding * 2 : 0;
};
const $80b986ec0541becf$export$bcefe8f1d5d7bbf3 = (view, pos, forInsertion)=>{
    if (typeof pos !== 'number') return null;
    const $pos = view.state.doc.resolve(pos);
    if ($pos && $pos.parent.type.name !== 'doc') return forInsertion ? $80b986ec0541becf$export$7cc71489edfd26f8($pos, view) : $80b986ec0541becf$export$4226a56ec6bfa71c($pos, view);
    return null;
};
const $80b986ec0541becf$export$4226a56ec6bfa71c = (resolvedPos, view)=>{
    const domNode = view.nodeDOM(resolvedPos.pos);
    if (resolvedPos.nodeAfter && (0, $19zEl.floatingLayouts).includes(resolvedPos.nodeAfter.attrs.layout) && domNode && domNode.parentElement) {
        const parentPadding = $80b986ec0541becf$var$calcParentPadding(view, resolvedPos);
        return domNode.parentElement.offsetWidth - parentPadding;
    }
    if (domNode instanceof HTMLElement) return domNode.offsetWidth;
    return null;
};
const $80b986ec0541becf$export$7cc71489edfd26f8 = (resolvedPos, view)=>{
    const parentPos = resolvedPos.before(resolvedPos.depth);
    const parentDomNode = view.nodeDOM(parentPos);
    const parentPadding = $80b986ec0541becf$var$calcParentPadding(view, resolvedPos);
    if (parentDomNode instanceof HTMLElement) return parentDomNode.offsetWidth - parentPadding;
    return null;
};
const $80b986ec0541becf$export$22e4c8c04f58169d = (editorState)=>{
    const { doc: doc, selection: selection, schema: schema } = editorState;
    if (!doc || !selection || !(selection instanceof (0, $3lIcL.NodeSelection)) || selection.node.type !== schema.nodes.mediaSingle) return;
    const pos = selection.$anchor.pos + 1;
    const node = doc.nodeAt(pos);
    if (!node || node.type !== schema.nodes.media) return;
    return {
        node: node,
        pos: pos
    };
};

});

parcelRegister("jhKIq", function(module, exports) {

$parcel$export(module.exports, "MediaSingleDimensionHelper", () => $4e85bca9ec1dc949$export$2b2737a2ef2f5b46);
$parcel$export(module.exports, "MediaWrapper", () => $4e85bca9ec1dc949$export$542000db99cecf28);
$parcel$export(module.exports, "MediaBorderGapFiller", () => $4e85bca9ec1dc949$export$e18e95249d813157);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $7yBx7 = parcelRequire("7yBx7");

var $eGOwo = parcelRequire("eGOwo");

var $fNh22 = parcelRequire("fNh22");

var $19zEl = parcelRequire("19zEl");

var $bnh3n = parcelRequire("bnh3n");
function $4e85bca9ec1dc949$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
function $4e85bca9ec1dc949$var$float(layout) {
    switch(layout){
        case 'wrap-right':
            return 'right';
        case 'wrap-left':
            return 'left';
        default:
            return 'none';
    }
}
function $4e85bca9ec1dc949$var$getWidthIfFullWidthMode(originalWidth, containerWidth, isInsideOfInlineExtension) {
    if (isInsideOfInlineExtension) return originalWidth > (0, $7yBx7.akEditorFullWidthLayoutWidth) ? `${Math.min(containerWidth, (0, $7yBx7.akEditorFullWidthLayoutWidth))}px` : `${originalWidth}px`;
    return originalWidth > (0, $7yBx7.akEditorFullWidthLayoutWidth) ? '100%' : `${originalWidth}px`;
}
function $4e85bca9ec1dc949$var$getWidthIfDefaultMode(originalWidth, containerWidth, isInsideOfInlineExtension) {
    if (isInsideOfInlineExtension) return originalWidth > (0, $7yBx7.akEditorFullPageMaxWidth) ? `${Math.min(containerWidth, (0, $7yBx7.akEditorDefaultLayoutWidth))}px` : `${originalWidth}px`;
    return originalWidth > (0, $7yBx7.akEditorFullPageMaxWidth) ? '100%' : `${originalWidth}px`;
}
function $4e85bca9ec1dc949$export$326222fa0d211f8e(layout, width, containerWidth = 0, fullWidthMode, isResized, isInsideOfInlineExtension) {
    switch(layout){
        case 'align-start':
        case 'align-end':
        case 'wrap-right':
        case 'wrap-left':
            return width > containerWidth / 2 ? 'calc(50% - 12px)' : `${width}px`;
        case 'wide':
            return isInsideOfInlineExtension ? (0, $bnh3n.calcWideWidth)(containerWidth, Infinity, `${containerWidth}px`) : (0, $bnh3n.calcWideWidth)(containerWidth);
        case 'full-width':
            return (0, $bnh3n.calcBreakoutWidth)(layout, containerWidth);
        default:
            return isResized ? `${width}px` : fullWidthMode ? $4e85bca9ec1dc949$var$getWidthIfFullWidthMode(width, containerWidth, isInsideOfInlineExtension) : $4e85bca9ec1dc949$var$getWidthIfDefaultMode(width, containerWidth, isInsideOfInlineExtension);
    }
}
function $4e85bca9ec1dc949$export$e4db998a333a342e(layout, width, containerWidth = 0, fullWidthMode, isResized) {
    switch(layout){
        case 'align-start':
        case 'align-end':
        case 'wrap-right':
        case 'wrap-left':
            return width > containerWidth / 2 ? 'calc(50% - 12px)' : `${width}px`;
        case 'wide':
            return (0, $bnh3n.calcWideWidth)(containerWidth, Infinity, `${containerWidth}px`);
        case 'full-width':
            return (0, $bnh3n.calcBreakoutWidth)(layout, containerWidth);
        default:
            return isResized ? `${width}px` : fullWidthMode ? $4e85bca9ec1dc949$var$getWidthIfFullWidthMode(width, containerWidth) : $4e85bca9ec1dc949$var$getWidthIfDefaultMode(width, containerWidth);
    }
}
function $4e85bca9ec1dc949$export$d48e8f24f681763e(layout, width, containerWidth = 0) {
    switch(layout){
        case 'wide':
            return (0, $bnh3n.calcWideWidth)(containerWidth);
        case 'full-width':
            return (0, $bnh3n.calcBreakoutWidth)(layout, containerWidth);
        default:
            return `${width}px`;
    }
}
function $4e85bca9ec1dc949$var$calcMaxWidth(layout, containerWidth) {
    switch(layout){
        case 'wide':
            return (0, $bnh3n.calcWideWidth)(containerWidth);
        case 'full-width':
            return (0, $bnh3n.calcBreakoutWidth)(layout, containerWidth);
        default:
            return '100%';
    }
}
function $4e85bca9ec1dc949$var$calcMargin(layout) {
    switch(layout){
        case 'wrap-right':
            return '12px auto 12px 12px';
        case 'wrap-left':
            return '12px 12px 12px auto';
        default:
            return '24px auto';
    }
}
function $4e85bca9ec1dc949$var$isImageAligned(layout) {
    switch(layout){
        case 'align-end':
            return 'margin-right: 0';
        case 'align-start':
            return 'margin-left: 0';
        default:
            return '';
    }
}
function $4e85bca9ec1dc949$export$c832331b07480714(widthValue) {
    try {
        if (widthValue.endsWith('px')) {
            const pxWidth = parseInt(widthValue.slice(0, -2));
            return `${pxWidth - pxWidth % 2}px`;
        }
        return widthValue;
    } catch  {
        return widthValue;
    }
}
/**
 * Can't use `.attrs` to handle highly dynamic styles because we are still
 * supporting `styled-components` v1.
 * @param root0
 * @param root0.containerWidth
 * @param root0.fullWidthMode
 * @param root0.isResized
 * @param root0.layout
 * @param root0.mediaSingleWidth
 * @param root0.width
 * @param root0.isExtendedResizeExperienceOn
 * @param root0.isNestedNode
 * @param root0.isInsideOfInlineExtension
 * @param root0.nodeType
 * @example
 */ var $4e85bca9ec1dc949$var$_ref = {
    name: "1bxycju",
    styles: "min-width:100%"
};
const $4e85bca9ec1dc949$export$2b2737a2ef2f5b46 = ({ containerWidth: containerWidth = 0, fullWidthMode: fullWidthMode, isResized: isResized, layout: layout, mediaSingleWidth: mediaSingleWidth, width: width, isExtendedResizeExperienceOn: // original media width
isExtendedResizeExperienceOn, isNestedNode: isNestedNode = false, isInsideOfInlineExtension: isInsideOfInlineExtension = false, nodeType: nodeType })=>{
    const calculatedWidth = $4e85bca9ec1dc949$export$c832331b07480714(isExtendedResizeExperienceOn ? `${mediaSingleWidth || width}px` : mediaSingleWidth ? $4e85bca9ec1dc949$export$d48e8f24f681763e(layout, width || 0, containerWidth) : $4e85bca9ec1dc949$export$326222fa0d211f8e(layout, width || 0, containerWidth, fullWidthMode, isResized, isInsideOfInlineExtension));
    const calculatedMaxWidth = $4e85bca9ec1dc949$export$c832331b07480714(isExtendedResizeExperienceOn ? `${containerWidth}px` : $4e85bca9ec1dc949$var$calcMaxWidth(layout, containerWidth));
    // jest warning: JSDOM version (22) doesn't support the new @container CSS rule
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Needs manual remediation
    return /*#__PURE__*/ (0, $1NIU8.css)("tr &,[data-layout-column] &,[data-node-type='expand'] &,[data-panel-type] &,li &{max-width:100%;}width:", calculatedWidth, ";", layout === 'full-width' && /* This causes issues for new experience where we don't strip layout attributes
   when copying top-level node and pasting into a table/layout,
   because full-width layout will remain, causing node to be edge-to-edge */ !isExtendedResizeExperienceOn && $4e85bca9ec1dc949$var$_ref, "max-width:", (0, $fNh22.isSSR)() && !calculatedMaxWidth.endsWith('%') && (0, $eGOwo.fg)('platform_editor_fix_image_size_diff_during_ssr') ? Math.max(parseInt(calculatedWidth.replace('px', '')), parseInt(calculatedMaxWidth.replace('px', ''))) + 'px' : calculatedMaxWidth, ";", isExtendedResizeExperienceOn && `&[class*='is-resizing'] {
    .new-file-experience-wrapper {
      box-shadow: none !important;
    }

    ${!isNestedNode && (0, $19zEl.nonWrappedLayouts).includes(layout) && `margin-left: 50%;
      transform: translateX(-50%);`}
  }`, " &:not(.is-resizing){transition:width 100ms ease-in;}float:", $4e85bca9ec1dc949$var$float(layout), ";margin:", $4e85bca9ec1dc949$var$calcMargin(layout), ";&[class*='not-resizing']{", isNestedNode ? /* Make nested node appear responsive when resizing table cell */ `max-width: 100%;` : (0, $19zEl.nonWrappedLayouts).includes(layout) && `margin-left: 50%;
        transform: translateX(-50%);`, ";}", $4e85bca9ec1dc949$var$isImageAligned(layout), ";");
};
const $4e85bca9ec1dc949$var$RenderFallbackContainer = ({ hasFallbackContainer: hasFallbackContainer, paddingBottom: paddingBottom, height: height })=>/*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Needs manual remediation
    (0, $1NIU8.css)(hasFallbackContainer ? `
  &::after {
    content: '';
    display: block;
    ${height ? `height: ${height}px;` : paddingBottom ? `padding-bottom: ${paddingBottom};` : ''}

    /* Fixes extra padding problem in Firefox */
    font-size: 0;
    line-height: 0;
  }
  ` : '', ";");
const $4e85bca9ec1dc949$export$9e3fd9f6215dd7b6 = (props)=>/*#__PURE__*/ (0, $1NIU8.css)("position:relative;", $4e85bca9ec1dc949$var$RenderFallbackContainer(props), "&>figure{position:", props.hasFallbackContainer ? 'absolute' : 'relative', ";height:100%;width:100%;}&>div:not([data-comment-badge='true'], [data-media-badges='true']){position:", props.hasFallbackContainer ? 'absolute' : 'relative', ";height:100%;width:100%;}& * [data-mark-annotation-type='inlineComment']{width:100%;height:100%;}&[data-node-type='embedCard']>div{width:100%;}[data-node-type='media']{position:static!important;>div{position:absolute;height:100%;}}");
const $4e85bca9ec1dc949$export$542000db99cecf28 = ({ children: children, ...rest })=>// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $4e85bca9ec1dc949$export$9e3fd9f6215dd7b6(rest)
    }, children);
$4e85bca9ec1dc949$export$542000db99cecf28.displayName = 'WrapperMediaSingle';
const $4e85bca9ec1dc949$export$e18e95249d813157 = ({ borderColor: borderColor })=>{
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            inset: '0px',
            border: `0.5px solid ${borderColor}`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            borderRadius: '1px'
        }
    });
};

});


parcelRegister("6PcbG", function(module, exports) {

$parcel$export(module.exports, "EmbedResizeMessageListener", () => $70e409de76fcb943$export$3482036c37e627f4);

var $eJOHy = parcelRequire("eJOHy");

var $65oSX = parcelRequire("65oSX");
class $70e409de76fcb943$export$3482036c37e627f4 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    componentDidMount() {
        window.addEventListener('message', this.messageCallback);
    }
    componentWillUnmount() {
        window.removeEventListener('message', this.messageCallback);
    }
    render() {
        return this.props.children;
    }
    constructor(...args){
        super(...args), this.messageCallback = (event)=>{
            const { embedIframeRef: embedIframeRef } = this.props;
            const isFromExpectedIframe = embedIframeRef.current && event.source === embedIframeRef.current.contentWindow;
            const isStringData = typeof event.data === 'string';
            if (isFromExpectedIframe && isStringData) try {
                const data = JSON.parse(event.data);
                if (data.method === 'resize' && typeof data.height === 'number') this.onEmbedHeightChange({
                    height: data.height
                });
            } catch (e) {}
        }, this.onEmbedHeightChange = (data)=>{
            const { onHeightUpdate: onHeightUpdate } = this.props;
            const height = data.height + (0, $65oSX.embedHeaderHeight);
            onHeightUpdate(height);
        };
    }
}

});

parcelRegister("fA0pL", function(module, exports) {

$parcel$export(module.exports, "default", () => $ebdab43b559f6ef0$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $24wSW = parcelRequire("24wSW");
var $5a8QC = parcelRequire("5a8QC");
var $hNqkR = parcelRequire("hNqkR");
var $6RBIN = parcelRequire("6RBIN");

var $BmspC = parcelRequire("BmspC");

var $7yBx7 = parcelRequire("7yBx7");

var $65oSX = parcelRequire("65oSX");
class $ebdab43b559f6ef0$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    static{
        this.defaultProps = {
            aspectRatio: (0, $7yBx7.DEFAULT_EMBED_CARD_WIDTH) / (0, $7yBx7.DEFAULT_EMBED_CARD_HEIGHT)
        };
    }
    componentDidUpdate(prevProps) {
        const offsetLeft = this.calcOffsetLeft();
        if (offsetLeft !== this.state.offsetLeft && offsetLeft >= 0) this.setState({
            offsetLeft: offsetLeft
        });
        if (this.props.layout !== prevProps.layout) this.checkLayout(prevProps.layout, this.props.layout);
    }
    get wrappedLayout() {
        return (0, $24wSW.wrappedLayouts).indexOf(this.props.layout) > -1;
    }
    /**
   * When returning to center layout from a wrapped/aligned layout, it might actually
   * be wide or full-width
   */ checkLayout(oldLayout, newLayout) {
        const { resizedPctWidth: resizedPctWidth } = this.state;
        if ((0, $24wSW.wrappedLayouts).indexOf(oldLayout) > -1 && newLayout === 'center' && resizedPctWidth) {
            const layout = this.calcUnwrappedLayout(resizedPctWidth, this.calcPxWidth(newLayout));
            this.props.updateSize(resizedPctWidth, layout);
        }
    }
    get $pos() {
        if (typeof this.props.getPos !== 'function') return null;
        const pos = this.props.getPos();
        if (Number.isNaN(pos) || typeof pos !== 'number') return null;
        // need to pass view because we may not get updated props in time
        return this.props.view.state.doc.resolve(pos);
    }
    /**
   * The maxmimum number of grid columns this node can resize to.
   */ get gridWidth() {
        const { gridSize: gridSize } = this.props;
        return !(this.wrappedLayout || this.insideInlineLike) ? gridSize / 2 : gridSize;
    }
    calcOffsetLeft() {
        let offsetLeft = 0;
        if (this.wrapper && this.insideInlineLike) {
            const currentNode = this.wrapper;
            const boundingRect = currentNode.getBoundingClientRect();
            const pmRect = this.props.view.dom.getBoundingClientRect();
            offsetLeft = boundingRect.left - pmRect.left;
        }
        return offsetLeft;
    }
    get wideLayoutWidth() {
        const { lineLength: lineLength } = this.props;
        if (lineLength) return Math.ceil(lineLength * (0, $7yBx7.breakoutWideScaleRatio));
        else return 0, $7yBx7.akEditorWideLayoutWidth;
    }
    // check if is inside of a table
    isNestedInTable() {
        const { table: table } = this.props.view.state.schema.nodes;
        if (!this.$pos) return false;
        return !!(0, $BmspC.findParentNodeOfTypeClosestToPos)(this.$pos, table);
    }
    calcSnapPoints() {
        const { offsetLeft: offsetLeft } = this.state;
        const { containerWidth: containerWidth, lineLength: lineLength } = this.props;
        const snapTargets = [];
        for(let i = 0; i < this.gridWidth; i++)snapTargets.push((0, $24wSW.calcPxFromColumns)(i, lineLength, this.gridWidth) - offsetLeft);
        // full width
        snapTargets.push(lineLength - offsetLeft);
        const minimumWidth = (0, $24wSW.calcPxFromColumns)(this.wrappedLayout || this.insideInlineLike ? 1 : 2, lineLength, this.props.gridSize);
        const snapPoints = snapTargets.filter((width)=>width >= minimumWidth);
        const $pos = this.$pos;
        if (!$pos) return snapPoints;
        const isTopLevel = $pos.parent.type.name === 'doc';
        if (isTopLevel) {
            snapPoints.push(this.wideLayoutWidth);
            const fullWidthPoint = containerWidth - (0, $7yBx7.akEditorBreakoutPadding);
            if (fullWidthPoint > this.wideLayoutWidth) snapPoints.push(fullWidthPoint);
        }
        return snapPoints;
    }
    get insideInlineLike() {
        const $pos = this.$pos;
        if (!$pos) return false;
        const { listItem: listItem } = this.props.view.state.schema.nodes;
        return !!(0, $BmspC.findParentNodeOfTypeClosestToPos)($pos, [
            listItem
        ]);
    }
    /**
   * Previously height of the box was controlled with paddingTop/paddingBottom trick inside Wrapper.
   * It allowed height to be defined by a given percent ratio and so absolute value was defined by actual width.
   * Also, it was part of styled component, which was fine because it was static through out life time of component.
   *
   * Now, two things changed:
   * 1. If `height` is present we take it as actual height of the box, and hence we don't need
   * (or even can't have, due to lack of width value) paddingTop trick.
   * 2. Since `height` can be changing through out life time of a component, we can't have it as part of styled component,
   * and hence we use `style` prop.
   */ getHeightDefiningComponent() {
        const { height: height, aspectRatio: aspectRatio } = this.props;
        let heightDefiningStyles;
        if (height) heightDefiningStyles = {
            height: `${height}px`
        };
        else // paddingBottom css trick defines ratio of `iframe height (y) + header (32)` to `width (x)`,
        // where is `aspectRatio` defines iframe aspectRatio alone
        // So, visually:
        //
        //            x
        //       ┌──────────┐
        //       │  header  │ 32
        //       ├──────────┤
        //       │          │
        //       │  iframe  │ y
        //       │          │
        //       └──────────┘
        //
        // aspectRatio = x / y
        // paddingBottom = (y + 32) / x
        // which can be achieved with css calc() as (1 / (x/y)) * 100)% + 32px
        heightDefiningStyles = {
            paddingBottom: `calc(${(1 / aspectRatio * 100).toFixed(3)}% + ${0, $65oSX.embedHeaderHeight}px)`
        };
        return /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
            "data-testid": 'resizable-embed-card-height-definer',
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                display: 'block',
                /* Fixes extra padding problem in Firefox */ // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
                fontSize: 0,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
                lineHeight: 0,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                ...heightDefiningStyles
            }
        });
    }
    render() {
        const { layout: layout, pctWidth: pctWidth, containerWidth: containerWidth, fullWidthMode: fullWidthMode, isResizeDisabled: isResizeDisabled, children: children } = this.props;
        const resizerProps = {
            width: this.calcPxWidth(),
            innerPadding: (0, $7yBx7.akEditorMediaResizeHandlerPadding)
        };
        const enable = {};
        (0, $5a8QC.handleSides).forEach((side)=>{
            if (isResizeDisabled) {
                enable[side] = false;
                return;
            }
            const oppositeSide = side === 'left' ? 'right' : 'left';
            enable[side] = [
                'full-width',
                'wide',
                'center'
            ].concat(`wrap-${oppositeSide}`).concat(`align-${(0, $5a8QC.imageAlignmentMap)[oppositeSide]}`).indexOf(layout) > -1;
            if (side === 'left' && this.insideInlineLike) enable[side] = false;
        });
        const nestedInTableHandleStyles = (isNestedInTable)=>{
            if (!isNestedInTable) return;
            return {
                left: {
                    left: `calc(${"var(--ds-space-negative-025, -0.125em)"} * 0.5)`,
                    paddingLeft: '0px'
                },
                right: {
                    right: `calc(${"var(--ds-space-negative-025, -0.125em)"} * 0.5)`,
                    paddingRight: '0px'
                }
            };
        };
        /* eslint-disable  @atlaskit/design-system/consistent-css-prop-usage */ return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            "data-testid": "resizable-embed-card-spacing"
        }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            css: (0, $6RBIN.wrapperStyle)({
                layout: layout,
                isResized: !!pctWidth,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                containerWidth: containerWidth || (0, $7yBx7.DEFAULT_EMBED_CARD_WIDTH),
                fullWidthMode: fullWidthMode
            })
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $hNqkR.default), {
            ...this.props,
            enable: enable,
            calcNewSize: this.calcNewSize,
            snapPoints: this.calcSnapPoints(),
            scaleFactor: !this.wrappedLayout && !this.insideInlineLike ? 2 : 1,
            highlights: this.highlights,
            nodeType: "embed",
            handleStyles: nestedInTableHandleStyles(this.isNestedInTable()),
            ...resizerProps
        }, children, this.getHeightDefiningComponent())));
    /* eslint-enable @atlaskit/design-system/consistent-css-prop-usage */ }
    constructor(...args){
        super(...args), this.state = {
            offsetLeft: this.calcOffsetLeft()
        }, this.calcNewSize = (newWidth, stop)=>{
            const { layout: layout, view: { state: state } } = this.props;
            const newPct = (0, $24wSW.calcPctFromPx)(newWidth, this.props.lineLength) * 100;
            this.setState({
                resizedPctWidth: newPct
            });
            let newLayout = (0, $BmspC.hasParentNodeOfType)(state.schema.nodes.table)(state.selection) ? layout : this.calcUnwrappedLayout(newPct, newWidth);
            if (newPct <= 100) {
                if (this.wrappedLayout && (stop ? newPct !== 100 : true)) newLayout = layout;
                return {
                    width: newPct,
                    layout: newLayout
                };
            } else return {
                width: this.props.pctWidth || null,
                layout: newLayout
            };
        }, this.calcUnwrappedLayout = (pct, width)=>{
            if (pct <= 100) return 'center';
            if (width <= this.wideLayoutWidth) return 'wide';
            return 'full-width';
        }, this.calcColumnLeftOffset = ()=>{
            const { offsetLeft: offsetLeft } = this.state;
            return this.insideInlineLike ? (0, $24wSW.calcColumnsFromPx)(offsetLeft, this.props.lineLength, this.props.gridSize) : 0;
        }, this.calcPxWidth = (useLayout)=>{
            const { layout: layout, pctWidth: pctWidth, lineLength: lineLength, containerWidth: containerWidth, fullWidthMode: fullWidthMode, getPos: getPos, view: { state: state } } = this.props;
            const { resizedPctWidth: resizedPctWidth } = this.state;
            const pos = typeof getPos === 'function' ? getPos() : undefined;
            return (0, $24wSW.calcMediaPxWidth)({
                origWidth: (0, $7yBx7.DEFAULT_EMBED_CARD_WIDTH),
                origHeight: (0, $7yBx7.DEFAULT_EMBED_CARD_HEIGHT),
                pctWidth: pctWidth,
                state: state,
                containerWidth: {
                    width: containerWidth,
                    lineLength: lineLength
                },
                isFullWidthModeEnabled: fullWidthMode,
                layout: useLayout || layout,
                pos: pos,
                resizedPctWidth: resizedPctWidth
            });
        }, this.highlights = (newWidth, snapPoints)=>{
            const snapWidth = (0, $5a8QC.snapTo)(newWidth, snapPoints);
            const { layoutColumn: layoutColumn, table: table, expand: expand, nestedExpand: nestedExpand } = this.props.view.state.schema.nodes;
            if (this.$pos && !!(0, $BmspC.findParentNodeOfTypeClosestToPos)(this.$pos, [
                layoutColumn,
                table,
                expand,
                nestedExpand
            ].filter(Boolean))) return [];
            if (snapWidth > this.wideLayoutWidth) return [
                'full-width'
            ];
            const { layout: layout, lineLength: lineLength, gridSize: gridSize } = this.props;
            const columns = (0, $24wSW.calcColumnsFromPx)(snapWidth, lineLength, gridSize);
            const columnWidth = Math.round(columns);
            const highlight = [];
            if (layout === 'wrap-left' || layout === 'align-start') highlight.push(0, columnWidth);
            else if (layout === 'wrap-right' || layout === 'align-end') highlight.push(gridSize, gridSize - columnWidth);
            else if (this.insideInlineLike) highlight.push(Math.round(columns + this.calcColumnLeftOffset()));
            else highlight.push(Math.floor((gridSize - columnWidth) / 2), Math.ceil((gridSize + columnWidth) / 2));
            return highlight;
        };
    }
}

});
parcelRegister("5a8QC", function(module, exports) {

$parcel$export(module.exports, "snapTo", () => $f81fd80a0945d9e9$export$ce5a040a76868800);
$parcel$export(module.exports, "handleSides", () => $f81fd80a0945d9e9$export$8ee741c8b9b43371);
$parcel$export(module.exports, "imageAlignmentMap", () => $f81fd80a0945d9e9$export$9aaf3d5fbdfcf5c5);
const $f81fd80a0945d9e9$export$ce5a040a76868800 = (target, points)=>{
    return points.length === 0 ? target : points.reduce((point, closest)=>{
        return Math.abs(closest - target) < Math.abs(point - target) ? closest : point;
    });
};
const $f81fd80a0945d9e9$export$8ee741c8b9b43371 = [
    'left',
    'right'
];
const $f81fd80a0945d9e9$export$9aaf3d5fbdfcf5c5 = {
    left: 'start',
    right: 'end'
};

});

parcelRegister("hNqkR", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac72b079712aeef5$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $k9JrM = parcelRequire("k9JrM");

var $8t5kR = parcelRequire("8t5kR");

var $7yBx7 = parcelRequire("7yBx7");

var $bMFKb = parcelRequire("bMFKb");

var $laqWo = parcelRequire("laqWo");

var $A5UFg = parcelRequire("A5UFg");

var $5a8QC = parcelRequire("5a8QC");
const $ac72b079712aeef5$var$getResizeAnalyticsEvent = (type, size, layout)=>{
    const actionSubject = type === 'embed' ? (0, $bMFKb.ACTION_SUBJECT).EMBEDS : (0, $bMFKb.ACTION_SUBJECT).MEDIA_SINGLE;
    return {
        action: (0, $bMFKb.ACTION).EDITED,
        actionSubject: actionSubject,
        actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).RESIZED,
        attributes: {
            size: size,
            layout: layout
        },
        eventType: (0, $bMFKb.EVENT_TYPE).UI
    };
};
const $ac72b079712aeef5$var$getWidthFromSnapPoints = (width, snapPoints)=>{
    if (snapPoints.length) return Math.min(Math.max(width, snapPoints[0]), snapPoints[snapPoints.length - 1]);
    return width;
};
class $ac72b079712aeef5$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    render() {
        const baseHandleStyles = {};
        const handles = {};
        const handleComponent = {};
        const { innerPadding: innerPadding = 0, width: width, pctWidth: pctWidth, selected: selected, layout: layout, enable: enable, children: children, ratio: ratio, handleComponentFunc: handleComponentFunc, handleStyles: handleStyles } = this.props;
        const { isResizing: isResizing } = this.state;
        (0, $5a8QC.handleSides).forEach((side)=>{
            handles[side] = `richMedia-resize-handle-${side}`;
            baseHandleStyles[side] = {
                width: '24px',
                [side]: `${-13 - innerPadding}px`,
                zIndex: (0, $7yBx7.akRichMediaResizeZIndex),
                pointerEvents: 'auto'
            };
            const sideHandleComponent = handleComponentFunc && handleComponentFunc(side);
            if (sideHandleComponent) handleComponent[side] = sideHandleComponent;
        });
        const updatedHandleStyles = {
            left: {
                ...baseHandleStyles.left,
                ...handleStyles?.left
            },
            right: {
                ...baseHandleStyles.right,
                ...handleStyles?.right
            }
        };
        const className = (0, (/*@__PURE__*/$parcel$interopDefault($k9JrM)))((0, $laqWo.richMediaClassName), `image-${layout}`, this.props.className, {
            'is-resizing': isResizing,
            'not-resized': !pctWidth,
            'richMedia-selected': selected,
            'rich-media-wrapped': layout === 'wrap-left' || layout === 'wrap-right'
        });
        let handleWrapperStyle;
        if (ratio) handleWrapperStyle = {
            position: 'absolute',
            width: '100%',
            paddingBottom: `${ratio}%`,
            top: 0,
            pointerEvents: 'none'
        };
        // Ideally, Resizable would let you pass in the component rather than
        // the div. For now, we just apply the same styles using CSS
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8t5kR.Resizable), {
            ref: this.resizable,
            size: {
                width: width,
                height: 'auto'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            handleClasses: handles,
            handleStyles: updatedHandleStyles,
            handleWrapperStyle: handleWrapperStyle,
            handleComponent: handleComponent,
            enable: enable,
            onResize: this.handleResize,
            onResizeStop: this.handleResizeStop,
            onResizeStart: this.handleResizeStart,
            children: children
        });
    }
    constructor(...args){
        super(...args), this.resizable = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createRef(), this.state = {
            isResizing: false
        }, this.handleResizeStart = (event)=>{
            const { innerPadding: innerPadding = 0, highlights: highlights, displayGrid: displayGrid, layout: layout, width: width, snapPoints: snapPoints } = this.props;
            // prevent creating a drag event on Firefox
            event.preventDefault();
            this.setState({
                isResizing: true
            }, ()=>{
                const newHighlights = highlights(width + innerPadding, snapPoints);
                displayGrid?.(newHighlights.length > 0, (0, $A5UFg.gridTypeForLayout)(layout), newHighlights);
            });
        }, this.handleResize = (_event, _direction, _elementRef, delta)=>{
            const { highlights: highlights, calcNewSize: calcNewSize, scaleFactor: scaleFactor, snapPoints: snapPoints, displayGrid: displayGrid, layout: layout, updateSize: updateSize, innerPadding: innerPadding = 0 } = this.props;
            const resizable = this.resizable.current;
            const { isResizing: isResizing } = this.state;
            if (!resizable || !resizable.state.original || !isResizing) return;
            const newWidth = $ac72b079712aeef5$var$getWidthFromSnapPoints(resizable.state.original.width + delta.width * (scaleFactor || 1), snapPoints);
            const newSize = calcNewSize(newWidth + innerPadding, false);
            if (newSize.layout !== layout) updateSize(newSize.width, newSize.layout);
            const newHighlights = highlights(newWidth, snapPoints);
            displayGrid?.(newHighlights.length > 0, (0, $A5UFg.gridTypeForLayout)(newSize.layout), newHighlights);
            resizable.updateSize({
                width: newWidth,
                height: 'auto'
            });
            resizable.setState({
                isResizing: true
            });
        }, this.handleResizeStop = (_event, _direction, _elementRef, delta)=>{
            const { highlights: highlights, calcNewSize: calcNewSize, snapPoints: snapPoints, displayGrid: displayGrid, layout: layout, updateSize: updateSize, dispatchAnalyticsEvent: dispatchAnalyticsEvent, nodeType: nodeType } = this.props;
            const resizable = this.resizable.current;
            const { isResizing: isResizing } = this.state;
            if (!resizable || !resizable.state.original || !isResizing) return;
            const newWidth = $ac72b079712aeef5$var$getWidthFromSnapPoints(resizable.state.original.width + delta.width, snapPoints);
            const snapWidth = (0, $5a8QC.snapTo)(newWidth, snapPoints);
            const newSize = calcNewSize(snapWidth, true);
            const newHighlights = highlights(newWidth, snapPoints);
            if (dispatchAnalyticsEvent) dispatchAnalyticsEvent($ac72b079712aeef5$var$getResizeAnalyticsEvent(nodeType, newSize.width, newSize.layout));
            // show committed grid size
            displayGrid?.(newHighlights.length > 0, (0, $A5UFg.gridTypeForLayout)(newSize.layout), newHighlights);
            this.setState({
                isResizing: false
            }, ()=>{
                updateSize(newSize.width, newSize.layout);
                displayGrid?.(false, (0, $A5UFg.gridTypeForLayout)(layout), []);
            });
        };
    }
}

});
parcelRegister("8t5kR", function(module, exports) {
"use strict";
var $62a52bac726d3cea$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $62a52bac726d3cea$var$__assign = module.exports && module.exports.__assign || function() {
    $62a52bac726d3cea$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $62a52bac726d3cea$var$__assign.apply(this, arguments);
};
var $62a52bac726d3cea$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result["default"] = mod;
    return result;
};
var $62a52bac726d3cea$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $62a52bac726d3cea$var$React = $62a52bac726d3cea$var$__importStar((parcelRequire("eJOHy")));

var $3Mpqp = parcelRequire("3Mpqp");

var $62a52bac726d3cea$var$fast_memoize_1 = $62a52bac726d3cea$var$__importDefault((parcelRequire("3GxS6")));
var $62a52bac726d3cea$var$DEFAULT_SIZE = {
    width: 'auto',
    height: 'auto'
};
var $62a52bac726d3cea$var$clamp = $62a52bac726d3cea$var$fast_memoize_1.default(function(n, min, max) {
    return Math.max(Math.min(n, max), min);
});
var $62a52bac726d3cea$var$snap = $62a52bac726d3cea$var$fast_memoize_1.default(function(n, size) {
    return Math.round(n / size) * size;
});
var $62a52bac726d3cea$var$hasDirection = $62a52bac726d3cea$var$fast_memoize_1.default(function(dir, target) {
    return new RegExp(dir, 'i').test(target);
});
var $62a52bac726d3cea$var$findClosestSnap = $62a52bac726d3cea$var$fast_memoize_1.default(function(n, snapArray, snapGap) {
    if (snapGap === void 0) snapGap = 0;
    var closestGapIndex = snapArray.reduce(function(prev, curr, index) {
        return Math.abs(curr - n) < Math.abs(snapArray[prev] - n) ? index : prev;
    }, 0);
    var gap = Math.abs(snapArray[closestGapIndex] - n);
    return snapGap === 0 || gap < snapGap ? snapArray[closestGapIndex] : n;
});
var $62a52bac726d3cea$var$endsWith = $62a52bac726d3cea$var$fast_memoize_1.default(function(str, searchStr) {
    return str.substr(str.length - searchStr.length, searchStr.length) === searchStr;
});
var $62a52bac726d3cea$var$getStringSize = $62a52bac726d3cea$var$fast_memoize_1.default(function(n) {
    n = n.toString();
    if (n === 'auto') return n;
    if ($62a52bac726d3cea$var$endsWith(n, 'px')) return n;
    if ($62a52bac726d3cea$var$endsWith(n, '%')) return n;
    if ($62a52bac726d3cea$var$endsWith(n, 'vh')) return n;
    if ($62a52bac726d3cea$var$endsWith(n, 'vw')) return n;
    if ($62a52bac726d3cea$var$endsWith(n, 'vmax')) return n;
    if ($62a52bac726d3cea$var$endsWith(n, 'vmin')) return n;
    return n + "px";
});
var $62a52bac726d3cea$var$calculateNewMax = $62a52bac726d3cea$var$fast_memoize_1.default(function(parentSize, maxWidth, maxHeight, minWidth, minHeight) {
    if (maxWidth && typeof maxWidth === 'string' && $62a52bac726d3cea$var$endsWith(maxWidth, '%')) {
        var ratio = Number(maxWidth.replace('%', '')) / 100;
        maxWidth = parentSize.width * ratio;
    }
    if (maxHeight && typeof maxHeight === 'string' && $62a52bac726d3cea$var$endsWith(maxHeight, '%')) {
        var ratio = Number(maxHeight.replace('%', '')) / 100;
        maxHeight = parentSize.height * ratio;
    }
    if (minWidth && typeof minWidth === 'string' && $62a52bac726d3cea$var$endsWith(minWidth, '%')) {
        var ratio = Number(minWidth.replace('%', '')) / 100;
        minWidth = parentSize.width * ratio;
    }
    if (minHeight && typeof minHeight === 'string' && $62a52bac726d3cea$var$endsWith(minHeight, '%')) {
        var ratio = Number(minHeight.replace('%', '')) / 100;
        minHeight = parentSize.height * ratio;
    }
    return {
        maxWidth: typeof maxWidth === 'undefined' ? undefined : Number(maxWidth),
        maxHeight: typeof maxHeight === 'undefined' ? undefined : Number(maxHeight),
        minWidth: typeof minWidth === 'undefined' ? undefined : Number(minWidth),
        minHeight: typeof minHeight === 'undefined' ? undefined : Number(minHeight)
    };
});
var $62a52bac726d3cea$var$definedProps = [
    'style',
    'className',
    'grid',
    'snap',
    'bounds',
    'size',
    'defaultSize',
    'minWidth',
    'minHeight',
    'maxWidth',
    'maxHeight',
    'lockAspectRatio',
    'lockAspectRatioExtraWidth',
    'lockAspectRatioExtraHeight',
    'enable',
    'handleStyles',
    'handleClasses',
    'handleWrapperStyle',
    'handleWrapperClass',
    'children',
    'onResizeStart',
    'onResize',
    'onResizeStop',
    'handleComponent',
    'scale',
    'resizeRatio',
    'snapGap'
];
// HACK: This class is used to calculate % size.
var $62a52bac726d3cea$var$baseClassName = '__resizable_base__';
var $62a52bac726d3cea$var$Resizable = /** @class */ function(_super) {
    $62a52bac726d3cea$var$__extends(Resizable, _super);
    function Resizable(props) {
        var _this = _super.call(this, props) || this;
        _this.ratio = 1;
        _this.resizable = null;
        // For parent boundary
        _this.parentLeft = 0;
        _this.parentTop = 0;
        // For boundary
        _this.resizableLeft = 0;
        _this.resizableTop = 0;
        // For target boundary
        _this.targetLeft = 0;
        _this.targetTop = 0;
        _this.state = {
            isResizing: false,
            resizeCursor: 'auto',
            width: typeof (_this.propsSize && _this.propsSize.width) === 'undefined' ? 'auto' : _this.propsSize && _this.propsSize.width,
            height: typeof (_this.propsSize && _this.propsSize.height) === 'undefined' ? 'auto' : _this.propsSize && _this.propsSize.height,
            direction: 'right',
            original: {
                x: 0,
                y: 0,
                width: 0,
                height: 0
            }
        };
        _this.onResizeStart = _this.onResizeStart.bind(_this);
        _this.onMouseMove = _this.onMouseMove.bind(_this);
        _this.onMouseUp = _this.onMouseUp.bind(_this);
        if (typeof window !== 'undefined') {
            window.addEventListener('mouseup', _this.onMouseUp);
            window.addEventListener('mousemove', _this.onMouseMove);
            window.addEventListener('mouseleave', _this.onMouseUp);
            window.addEventListener('touchmove', _this.onMouseMove);
            window.addEventListener('touchend', _this.onMouseUp);
        }
        return _this;
    }
    Object.defineProperty(Resizable.prototype, "parentNode", {
        get: function() {
            if (!this.resizable) return null;
            return this.resizable.parentNode;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Resizable.prototype, "propsSize", {
        get: function() {
            return this.props.size || this.props.defaultSize || $62a52bac726d3cea$var$DEFAULT_SIZE;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Resizable.prototype, "base", {
        get: function() {
            var parent = this.parentNode;
            if (!parent) return undefined;
            var children = [].slice.call(parent.children);
            for(var _i = 0, children_1 = children; _i < children_1.length; _i++){
                var n = children_1[_i];
                if (n instanceof HTMLElement) {
                    if (n.classList.contains($62a52bac726d3cea$var$baseClassName)) return n;
                }
            }
            return undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Resizable.prototype, "size", {
        get: function() {
            var width = 0;
            var height = 0;
            if (typeof window !== 'undefined' && this.resizable) {
                var orgWidth = this.resizable.offsetWidth;
                var orgHeight = this.resizable.offsetHeight;
                // HACK: Set position `relative` to get parent size.
                //       This is because when re-resizable set `absolute`, I can not get base width correctly.
                var orgPosition = this.resizable.style.position;
                if (orgPosition !== 'relative') this.resizable.style.position = 'relative';
                // INFO: Use original width or height if set auto.
                width = this.resizable.style.width !== 'auto' ? this.resizable.offsetWidth : orgWidth;
                height = this.resizable.style.height !== 'auto' ? this.resizable.offsetHeight : orgHeight;
                // Restore original position
                this.resizable.style.position = orgPosition;
            }
            return {
                width: width,
                height: height
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Resizable.prototype, "sizeStyle", {
        get: function() {
            var _this = this;
            var size = this.props.size;
            var getSize = function(key) {
                if (typeof _this.state[key] === 'undefined' || _this.state[key] === 'auto') return 'auto';
                if (_this.propsSize && _this.propsSize[key] && $62a52bac726d3cea$var$endsWith(_this.propsSize[key].toString(), '%')) {
                    if ($62a52bac726d3cea$var$endsWith(_this.state[key].toString(), '%')) return _this.state[key].toString();
                    var parentSize = _this.getParentSize();
                    var value = Number(_this.state[key].toString().replace('px', ''));
                    var percent = value / parentSize[key] * 100;
                    return percent + "%";
                }
                return $62a52bac726d3cea$var$getStringSize(_this.state[key]);
            };
            var width = size && typeof size.width !== 'undefined' && !this.state.isResizing ? $62a52bac726d3cea$var$getStringSize(size.width) : getSize('width');
            var height = size && typeof size.height !== 'undefined' && !this.state.isResizing ? $62a52bac726d3cea$var$getStringSize(size.height) : getSize('height');
            return {
                width: width,
                height: height
            };
        },
        enumerable: true,
        configurable: true
    });
    Resizable.prototype.getParentSize = function() {
        if (!this.base || !this.parentNode) return {
            width: window.innerWidth,
            height: window.innerHeight
        };
        // INFO: To calculate parent width with flex layout
        var wrapChanged = false;
        var wrap = this.parentNode.style.flexWrap;
        var minWidth = this.base.style.minWidth;
        if (wrap !== 'wrap') {
            wrapChanged = true;
            this.parentNode.style.flexWrap = 'wrap';
        // HACK: Use relative to get parent padding size
        }
        this.base.style.position = 'relative';
        this.base.style.minWidth = '100%';
        var size = {
            width: this.base.offsetWidth,
            height: this.base.offsetHeight
        };
        this.base.style.position = 'absolute';
        if (wrapChanged) this.parentNode.style.flexWrap = wrap;
        this.base.style.minWidth = minWidth;
        return size;
    };
    Resizable.prototype.componentDidMount = function() {
        this.setState({
            width: this.state.width || this.size.width,
            height: this.state.height || this.size.height
        });
        var parent = this.parentNode;
        if (!(parent instanceof HTMLElement)) return;
        if (this.base) return;
        var element = document.createElement('div');
        element.style.width = '100%';
        element.style.height = '100%';
        element.style.position = 'absolute';
        element.style.transform = 'scale(0, 0)';
        element.style.left = '0';
        element.style.flex = '0';
        if (element.classList) element.classList.add($62a52bac726d3cea$var$baseClassName);
        else element.className += $62a52bac726d3cea$var$baseClassName;
        parent.appendChild(element);
    };
    Resizable.prototype.componentWillUnmount = function() {
        if (typeof window !== 'undefined') {
            window.removeEventListener('mouseup', this.onMouseUp);
            window.removeEventListener('mousemove', this.onMouseMove);
            window.removeEventListener('mouseleave', this.onMouseUp);
            window.removeEventListener('touchmove', this.onMouseMove);
            window.removeEventListener('touchend', this.onMouseUp);
            var parent_1 = this.parentNode;
            if (!this.base || !parent_1) return;
            if (!(parent_1 instanceof HTMLElement) || !(this.base instanceof Node)) return;
            parent_1.removeChild(this.base);
        }
    };
    Resizable.prototype.createSizeForCssProperty = function(newSize, kind) {
        var propsSize = this.propsSize && this.propsSize[kind];
        return this.state[kind] === 'auto' && this.state.original[kind] === newSize && (typeof propsSize === 'undefined' || propsSize === 'auto') ? 'auto' : newSize;
    };
    Resizable.prototype.calculateNewMaxFromBoundary = function(maxWidth, maxHeight) {
        if (this.props.bounds === 'parent') {
            var parent_2 = this.parentNode;
            if (parent_2 instanceof HTMLElement) {
                var boundWidth = parent_2.offsetWidth + (this.parentLeft - this.resizableLeft);
                var boundHeight = parent_2.offsetHeight + (this.parentTop - this.resizableTop);
                maxWidth = maxWidth && maxWidth < boundWidth ? maxWidth : boundWidth;
                maxHeight = maxHeight && maxHeight < boundHeight ? maxHeight : boundHeight;
            }
        } else if (this.props.bounds === 'window') {
            if (typeof window !== 'undefined') {
                var boundWidth = window.innerWidth - this.resizableLeft;
                var boundHeight = window.innerHeight - this.resizableTop;
                maxWidth = maxWidth && maxWidth < boundWidth ? maxWidth : boundWidth;
                maxHeight = maxHeight && maxHeight < boundHeight ? maxHeight : boundHeight;
            }
        } else if (this.props.bounds instanceof HTMLElement) {
            var boundWidth = this.props.bounds.offsetWidth + (this.targetLeft - this.resizableLeft);
            var boundHeight = this.props.bounds.offsetHeight + (this.targetTop - this.resizableTop);
            maxWidth = maxWidth && maxWidth < boundWidth ? maxWidth : boundWidth;
            maxHeight = maxHeight && maxHeight < boundHeight ? maxHeight : boundHeight;
        }
        return {
            maxWidth: maxWidth,
            maxHeight: maxHeight
        };
    };
    Resizable.prototype.calculateNewSizeFromDirection = function(clientX, clientY) {
        var scale = this.props.scale || 1;
        var resizeRatio = this.props.resizeRatio || 1;
        var _a = this.state, direction = _a.direction, original = _a.original;
        var _b = this.props, lockAspectRatio = _b.lockAspectRatio, lockAspectRatioExtraHeight = _b.lockAspectRatioExtraHeight, lockAspectRatioExtraWidth = _b.lockAspectRatioExtraWidth;
        var newWidth = original.width;
        var newHeight = original.height;
        var extraHeight = lockAspectRatioExtraHeight || 0;
        var extraWidth = lockAspectRatioExtraWidth || 0;
        if ($62a52bac726d3cea$var$hasDirection('right', direction)) {
            newWidth = original.width + (clientX - original.x) * resizeRatio / scale;
            if (lockAspectRatio) newHeight = (newWidth - extraWidth) / this.ratio + extraHeight;
        }
        if ($62a52bac726d3cea$var$hasDirection('left', direction)) {
            newWidth = original.width - (clientX - original.x) * resizeRatio / scale;
            if (lockAspectRatio) newHeight = (newWidth - extraWidth) / this.ratio + extraHeight;
        }
        if ($62a52bac726d3cea$var$hasDirection('bottom', direction)) {
            newHeight = original.height + (clientY - original.y) * resizeRatio / scale;
            if (lockAspectRatio) newWidth = (newHeight - extraHeight) * this.ratio + extraWidth;
        }
        if ($62a52bac726d3cea$var$hasDirection('top', direction)) {
            newHeight = original.height - (clientY - original.y) * resizeRatio / scale;
            if (lockAspectRatio) newWidth = (newHeight - extraHeight) * this.ratio + extraWidth;
        }
        return {
            newWidth: newWidth,
            newHeight: newHeight
        };
    };
    Resizable.prototype.calculateNewSizeFromAspectRatio = function(newWidth, newHeight, max, min) {
        var _a = this.props, lockAspectRatio = _a.lockAspectRatio, lockAspectRatioExtraHeight = _a.lockAspectRatioExtraHeight, lockAspectRatioExtraWidth = _a.lockAspectRatioExtraWidth;
        var computedMinWidth = typeof min.width === 'undefined' ? 10 : min.width;
        var computedMaxWidth = typeof max.width === 'undefined' || max.width < 0 ? newWidth : max.width;
        var computedMinHeight = typeof min.height === 'undefined' ? 10 : min.height;
        var computedMaxHeight = typeof max.height === 'undefined' || max.height < 0 ? newHeight : max.height;
        var extraHeight = lockAspectRatioExtraHeight || 0;
        var extraWidth = lockAspectRatioExtraWidth || 0;
        if (lockAspectRatio) {
            var extraMinWidth = (computedMinHeight - extraHeight) * this.ratio + extraWidth;
            var extraMaxWidth = (computedMaxHeight - extraHeight) * this.ratio + extraWidth;
            var extraMinHeight = (computedMinWidth - extraWidth) / this.ratio + extraHeight;
            var extraMaxHeight = (computedMaxWidth - extraWidth) / this.ratio + extraHeight;
            var lockedMinWidth = Math.max(computedMinWidth, extraMinWidth);
            var lockedMaxWidth = Math.min(computedMaxWidth, extraMaxWidth);
            var lockedMinHeight = Math.max(computedMinHeight, extraMinHeight);
            var lockedMaxHeight = Math.min(computedMaxHeight, extraMaxHeight);
            newWidth = $62a52bac726d3cea$var$clamp(newWidth, lockedMinWidth, lockedMaxWidth);
            newHeight = $62a52bac726d3cea$var$clamp(newHeight, lockedMinHeight, lockedMaxHeight);
        } else {
            newWidth = $62a52bac726d3cea$var$clamp(newWidth, computedMinWidth, computedMaxWidth);
            newHeight = $62a52bac726d3cea$var$clamp(newHeight, computedMinHeight, computedMaxHeight);
        }
        return {
            newWidth: newWidth,
            newHeight: newHeight
        };
    };
    Resizable.prototype.setBoundingClientRect = function() {
        // For parent boundary
        if (this.props.bounds === 'parent') {
            var parent_3 = this.parentNode;
            if (parent_3 instanceof HTMLElement) {
                var parentRect = parent_3.getBoundingClientRect();
                this.parentLeft = parentRect.left;
                this.parentTop = parentRect.top;
            }
        }
        // For target(html element) boundary
        if (this.props.bounds instanceof HTMLElement) {
            var targetRect = this.props.bounds.getBoundingClientRect();
            this.targetLeft = targetRect.left;
            this.targetTop = targetRect.top;
        }
        // For boundary
        if (this.resizable) {
            var _a = this.resizable.getBoundingClientRect(), left = _a.left, top_1 = _a.top;
            this.resizableLeft = left;
            this.resizableTop = top_1;
        }
    };
    Resizable.prototype.onResizeStart = function(event, direction) {
        var clientX = 0;
        var clientY = 0;
        if (event.nativeEvent instanceof MouseEvent) {
            clientX = event.nativeEvent.clientX;
            clientY = event.nativeEvent.clientY;
            // When user click with right button the resize is stuck in resizing mode
            // until users clicks again, dont continue if right click is used.
            // HACK: MouseEvent does not have `which` from flow-bin v0.68.
            if (event.nativeEvent.which === 3) return;
        } else if (event.nativeEvent instanceof TouchEvent) {
            clientX = event.nativeEvent.touches[0].clientX;
            clientY = event.nativeEvent.touches[0].clientY;
        }
        if (this.props.onResizeStart) {
            if (this.resizable) {
                var startResize = this.props.onResizeStart(event, direction, this.resizable);
                if (startResize === false) return;
            }
        }
        // Fix #168
        if (this.props.size) {
            if (typeof this.props.size.height !== 'undefined' && this.props.size.height !== this.state.height) this.setState({
                height: this.props.size.height
            });
            if (typeof this.props.size.width !== 'undefined' && this.props.size.width !== this.state.width) this.setState({
                width: this.props.size.width
            });
        }
        // For lockAspectRatio case
        this.ratio = typeof this.props.lockAspectRatio === 'number' ? this.props.lockAspectRatio : this.size.width / this.size.height;
        // For boundary
        this.setBoundingClientRect();
        this.setState({
            original: {
                x: clientX,
                y: clientY,
                width: this.size.width,
                height: this.size.height
            },
            isResizing: true,
            resizeCursor: window.getComputedStyle(event.target).cursor || 'auto',
            direction: direction
        });
    };
    Resizable.prototype.onMouseMove = function(event) {
        if (!this.state.isResizing || !this.resizable) return;
        var _a = this.props, maxWidth = _a.maxWidth, maxHeight = _a.maxHeight, minWidth = _a.minWidth, minHeight = _a.minHeight;
        var clientX = event instanceof MouseEvent ? event.clientX : event.touches[0].clientX;
        var clientY = event instanceof MouseEvent ? event.clientY : event.touches[0].clientY;
        var _b = this.state, direction = _b.direction, original = _b.original, width = _b.width, height = _b.height;
        var parentSize = this.getParentSize();
        var max = $62a52bac726d3cea$var$calculateNewMax(parentSize, maxWidth, maxHeight, minWidth, minHeight);
        maxWidth = max.maxWidth;
        maxHeight = max.maxHeight;
        minWidth = max.minWidth;
        minHeight = max.minHeight;
        // Calculate new size
        var _c = this.calculateNewSizeFromDirection(clientX, clientY), newHeight = _c.newHeight, newWidth = _c.newWidth;
        // Calculate max size from boundary settings
        var boundaryMax = this.calculateNewMaxFromBoundary(maxWidth, maxHeight);
        // Calculate new size from aspect ratio
        var newSize = this.calculateNewSizeFromAspectRatio(newWidth, newHeight, {
            width: boundaryMax.maxWidth,
            height: boundaryMax.maxHeight
        }, {
            width: minWidth,
            height: minHeight
        });
        newWidth = newSize.newWidth;
        newHeight = newSize.newHeight;
        if (this.props.grid) {
            var newGridWidth = $62a52bac726d3cea$var$snap(newWidth, this.props.grid[0]);
            var newGridHeight = $62a52bac726d3cea$var$snap(newHeight, this.props.grid[1]);
            var gap = this.props.snapGap || 0;
            newWidth = gap === 0 || Math.abs(newGridWidth - newWidth) <= gap ? newGridWidth : newWidth;
            newHeight = gap === 0 || Math.abs(newGridHeight - newHeight) <= gap ? newGridHeight : newHeight;
        }
        if (this.props.snap && this.props.snap.x) newWidth = $62a52bac726d3cea$var$findClosestSnap(newWidth, this.props.snap.x, this.props.snapGap);
        if (this.props.snap && this.props.snap.y) newHeight = $62a52bac726d3cea$var$findClosestSnap(newHeight, this.props.snap.y, this.props.snapGap);
        var delta = {
            width: newWidth - original.width,
            height: newHeight - original.height
        };
        if (width && typeof width === 'string') {
            if ($62a52bac726d3cea$var$endsWith(width, '%')) {
                var percent = newWidth / parentSize.width * 100;
                newWidth = percent + "%";
            } else if ($62a52bac726d3cea$var$endsWith(width, 'vw')) {
                var vw = newWidth / window.innerWidth * 100;
                newWidth = vw + "vw";
            } else if ($62a52bac726d3cea$var$endsWith(width, 'vh')) {
                var vh = newWidth / window.innerHeight * 100;
                newWidth = vh + "vh";
            }
        }
        if (height && typeof height === 'string') {
            if ($62a52bac726d3cea$var$endsWith(height, '%')) {
                var percent = newHeight / parentSize.height * 100;
                newHeight = percent + "%";
            } else if ($62a52bac726d3cea$var$endsWith(height, 'vw')) {
                var vw = newHeight / window.innerWidth * 100;
                newHeight = vw + "vw";
            } else if ($62a52bac726d3cea$var$endsWith(height, 'vh')) {
                var vh = newHeight / window.innerHeight * 100;
                newHeight = vh + "vh";
            }
        }
        this.setState({
            width: this.createSizeForCssProperty(newWidth, 'width'),
            height: this.createSizeForCssProperty(newHeight, 'height')
        });
        if (this.props.onResize) this.props.onResize(event, direction, this.resizable, delta);
    };
    Resizable.prototype.onMouseUp = function(event) {
        var _a = this.state, isResizing = _a.isResizing, direction = _a.direction, original = _a.original;
        if (!isResizing || !this.resizable) return;
        var delta = {
            width: this.size.width - original.width,
            height: this.size.height - original.height
        };
        if (this.props.onResizeStop) this.props.onResizeStop(event, direction, this.resizable, delta);
        if (this.props.size) this.setState(this.props.size);
        this.setState({
            isResizing: false,
            resizeCursor: 'auto'
        });
    };
    Resizable.prototype.updateSize = function(size) {
        this.setState({
            width: size.width,
            height: size.height
        });
    };
    Resizable.prototype.renderResizer = function() {
        var _this = this;
        var _a = this.props, enable = _a.enable, handleStyles = _a.handleStyles, handleClasses = _a.handleClasses, handleWrapperStyle = _a.handleWrapperStyle, handleWrapperClass = _a.handleWrapperClass, handleComponent = _a.handleComponent;
        if (!enable) return null;
        var resizers = Object.keys(enable).map(function(dir) {
            if (enable[dir] !== false) return $62a52bac726d3cea$var$React.createElement($3Mpqp.Resizer, {
                key: dir,
                direction: dir,
                onResizeStart: _this.onResizeStart,
                replaceStyles: handleStyles && handleStyles[dir],
                className: handleClasses && handleClasses[dir]
            }, handleComponent && handleComponent[dir] ? handleComponent[dir] : null);
            return null;
        });
        // #93 Wrap the resize box in span (will not break 100% width/height)
        return $62a52bac726d3cea$var$React.createElement("span", {
            className: handleWrapperClass,
            style: handleWrapperStyle
        }, resizers);
    };
    Resizable.prototype.render = function() {
        var _this = this;
        var extendsProps = Object.keys(this.props).reduce(function(acc, key) {
            if ($62a52bac726d3cea$var$definedProps.indexOf(key) !== -1) return acc;
            acc[key] = _this.props[key];
            return acc;
        }, {});
        return $62a52bac726d3cea$var$React.createElement("div", $62a52bac726d3cea$var$__assign({
            ref: function(c) {
                if (c) _this.resizable = c;
            },
            style: $62a52bac726d3cea$var$__assign({
                position: 'relative',
                userSelect: this.state.isResizing ? 'none' : 'auto'
            }, this.props.style, this.sizeStyle, {
                maxWidth: this.props.maxWidth,
                maxHeight: this.props.maxHeight,
                minWidth: this.props.minWidth,
                minHeight: this.props.minHeight,
                boxSizing: 'border-box'
            }),
            className: this.props.className
        }, extendsProps), this.state.isResizing && $62a52bac726d3cea$var$React.createElement("div", {
            style: {
                height: '100%',
                width: '100%',
                backgroundColor: 'rgba(0,0,0,0)',
                cursor: "" + (this.state.resizeCursor || 'auto'),
                opacity: 0,
                position: 'fixed',
                zIndex: 9999,
                top: '0',
                left: '0',
                bottom: '0',
                right: '0'
            }
        }), this.props.children, this.renderResizer());
    };
    Resizable.defaultProps = {
        onResizeStart: function() {},
        onResize: function() {},
        onResizeStop: function() {},
        enable: {
            top: true,
            right: true,
            bottom: true,
            left: true,
            topRight: true,
            bottomRight: true,
            bottomLeft: true,
            topLeft: true
        },
        style: {},
        grid: [
            1,
            1
        ],
        lockAspectRatio: false,
        lockAspectRatioExtraWidth: 0,
        lockAspectRatioExtraHeight: 0,
        scale: 1,
        resizeRatio: 1,
        snapGap: 0
    };
    return Resizable;
}($62a52bac726d3cea$var$React.PureComponent);
module.exports.Resizable = $62a52bac726d3cea$var$Resizable;

});
parcelRegister("3Mpqp", function(module, exports) {
"use strict";
var $2c0993a6dda4fb59$var$__assign = module.exports && module.exports.__assign || function() {
    $2c0993a6dda4fb59$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2c0993a6dda4fb59$var$__assign.apply(this, arguments);
};
var $2c0993a6dda4fb59$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result["default"] = mod;
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $2c0993a6dda4fb59$var$React = $2c0993a6dda4fb59$var$__importStar((parcelRequire("eJOHy")));
var $2c0993a6dda4fb59$var$styles = {
    top: {
        width: '100%',
        height: '10px',
        top: '-5px',
        left: '0px',
        cursor: 'row-resize'
    },
    right: {
        width: '10px',
        height: '100%',
        top: '0px',
        right: '-5px',
        cursor: 'col-resize'
    },
    bottom: {
        width: '100%',
        height: '10px',
        bottom: '-5px',
        left: '0px',
        cursor: 'row-resize'
    },
    left: {
        width: '10px',
        height: '100%',
        top: '0px',
        left: '-5px',
        cursor: 'col-resize'
    },
    topRight: {
        width: '20px',
        height: '20px',
        position: 'absolute',
        right: '-10px',
        top: '-10px',
        cursor: 'ne-resize'
    },
    bottomRight: {
        width: '20px',
        height: '20px',
        position: 'absolute',
        right: '-10px',
        bottom: '-10px',
        cursor: 'se-resize'
    },
    bottomLeft: {
        width: '20px',
        height: '20px',
        position: 'absolute',
        left: '-10px',
        bottom: '-10px',
        cursor: 'sw-resize'
    },
    topLeft: {
        width: '20px',
        height: '20px',
        position: 'absolute',
        left: '-10px',
        top: '-10px',
        cursor: 'nw-resize'
    }
};
function $2c0993a6dda4fb59$var$Resizer(props) {
    return $2c0993a6dda4fb59$var$React.createElement("div", {
        className: props.className || '',
        style: $2c0993a6dda4fb59$var$__assign({
            position: 'absolute',
            userSelect: 'none'
        }, $2c0993a6dda4fb59$var$styles[props.direction], props.replaceStyles || {}),
        onMouseDown: function(e) {
            props.onResizeStart(e, props.direction);
        },
        onTouchStart: function(e) {
            props.onResizeStart(e, props.direction);
        }
    }, props.children);
}
module.exports.Resizer = $2c0993a6dda4fb59$var$Resizer;

});

parcelRegister("3GxS6", function(module, exports) {
//
// Main
//
function $2aef918a605bb432$var$memoize(fn, options) {
    var cache = options && options.cache ? options.cache : $2aef918a605bb432$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $2aef918a605bb432$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $2aef918a605bb432$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $2aef918a605bb432$var$isPrimitive(value) {
    return value == null || typeof value === 'number' || typeof value === 'boolean' // || typeof value === "string" 'unsafe' primitive for our needs
    ;
}
function $2aef918a605bb432$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $2aef918a605bb432$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $2aef918a605bb432$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $2aef918a605bb432$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $2aef918a605bb432$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $2aef918a605bb432$var$monadic : $2aef918a605bb432$var$variadic;
    return $2aef918a605bb432$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $2aef918a605bb432$var$strategyVariadic(fn, options) {
    var strategy = $2aef918a605bb432$var$variadic;
    return $2aef918a605bb432$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $2aef918a605bb432$var$strategyMonadic(fn, options) {
    var strategy = $2aef918a605bb432$var$monadic;
    return $2aef918a605bb432$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
//
// Serializer
//
function $2aef918a605bb432$var$serializerDefault() {
    return JSON.stringify(arguments);
}
//
// Cache
//
function $2aef918a605bb432$var$ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
$2aef918a605bb432$var$ObjectWithoutPrototypeCache.prototype.has = function(key) {
    return key in this.cache;
};
$2aef918a605bb432$var$ObjectWithoutPrototypeCache.prototype.get = function(key) {
    return this.cache[key];
};
$2aef918a605bb432$var$ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
    this.cache[key] = value;
};
var $2aef918a605bb432$var$cacheDefault = {
    create: function create() {
        return new $2aef918a605bb432$var$ObjectWithoutPrototypeCache();
    }
};
//
// API
//
module.exports = $2aef918a605bb432$var$memoize;
module.exports.strategies = {
    variadic: $2aef918a605bb432$var$strategyVariadic,
    monadic: $2aef918a605bb432$var$strategyMonadic
};

});


parcelRegister("A5UFg", function(module, exports) {

$parcel$export(module.exports, "gridTypeForLayout", () => $dfda3d7dfdd95a88$export$27813bf9aa3826dc);
const $dfda3d7dfdd95a88$export$27813bf9aa3826dc = (layout)=>layout === 'wrap-left' || layout === 'wrap-right' ? 'wrapped' : 'full';

});


parcelRegister("6RBIN", function(module, exports) {

$parcel$export(module.exports, "wrapperStyle", () => $924c717c7e8aff89$export$c4d4f06a25de97f);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $jhKIq = parcelRequire("jhKIq");
const $924c717c7e8aff89$export$c4d4f06a25de97f = (props)=>/*#__PURE__*/ (0, $1NIU8.css)("&>div{", (0, $jhKIq.MediaSingleDimensionHelper)(props), ";position:relative;clear:both;>div{position:absolute;height:100%;width:100%;}}");

});




parcelRegister("8y3X6", function(module, exports) {

$parcel$export(module.exports, "lazyInlineCardView", () => $7e5265649b07c302$export$cd3f6a9b84ab8435);

var $hkA3A = parcelRequire("hkA3A");

var $eGOwo = parcelRequire("eGOwo");

var $92xoS = parcelRequire("92xoS");

var $8NXVj = parcelRequire("8NXVj");

const $7e5265649b07c302$export$cd3f6a9b84ab8435 = (props)=>{
    const isPageSSRed = props.isPageSSRed || false;
    if ((0, $92xoS.editorExperiment)('platform_editor_exp_lazy_node_views', false) || isPageSSRed && (0, $eGOwo.fg)('platform_ssr_smartlinks_editor')) return (0, $8NXVj.inlineCardNodeView)(props);
    return (0, $hkA3A.withLazyLoading)({
        nodeName: 'inlineCard',
        getNodeViewOptions: ()=>{},
        loader: ()=>{
            const result = Promise.resolve((parcelRequire("8NXVj"))).then(({ inlineCardNodeView: inlineCardNodeView })=>{
                return inlineCardNodeView(props);
            });
            return result;
        }
    });
};

});

parcelRegister("59QiN", function(module, exports) {

$parcel$export(module.exports, "eventsFromTransaction", () => $525975141c778c30$export$c985b35883eaea59);

var $5KmoW = parcelRequire("5KmoW");

var $7gMgW = parcelRequire("7gMgW");

var $bMFKb = parcelRequire("bMFKb");

var $6C2m6 = parcelRequire("6C2m6");

var $9Ssie = parcelRequire("9Ssie");
var $3ADzg = parcelRequire("3ADzg");

var $lzEKq = parcelRequire("lzEKq");

var $cuJUr = parcelRequire("cuJUr");

var $d3z4A = parcelRequire("d3z4A");

var $lRqrn = parcelRequire("lRqrn");

var $3o3Tb = parcelRequire("3o3Tb");
const $525975141c778c30$export$200d2ac836975ed5 = (tr, state)=>{
    const schema = tr.doc.type.schema;
    const removed = [];
    const inserted = [];
    /**
	 * Ideally we have the "before" and "after" states of the "entity"
	 * being updated, but if the update is via a "queue for upgrade"
	 * then we no longer have access to the "before" state, because the "before"
	 * state was replaced with a blue link to be upgraded
	 */ const updated = [];
    const queuedForUpgrade = $525975141c778c30$var$isTransactionQueuedForUpgrade(tr);
    const isResolveReplace = $525975141c778c30$var$isTransactionResolveReplace(tr);
    // History
    const historyMeta = tr.getMeta((0, $3ADzg.pmHistoryPluginKey));
    const isUndo = $525975141c778c30$var$isHistoryMeta(historyMeta) && historyMeta.redo === false;
    const isRedo = $525975141c778c30$var$isHistoryMeta(historyMeta) && historyMeta.redo === true;
    const isUpdate = $525975141c778c30$var$isUpdateTr(tr, isUndo || isRedo);
    for(let i = 0; i < tr.steps.length; i++){
        const step = tr.steps[i];
        const stepMap = step.getMap();
        const removedInStep = [];
        const insertedInStep = [];
        const before = tr.docs[i] ?? tr.before;
        const after = tr.docs[i + 1] ?? tr.doc;
        /**
		 * AddMarkStep and RemoveMarkSteps don't produce stepMap ranges
		 * because there are no "changed tokens" only marks added/removed
		 * So have to check these manually
		 */ if (step instanceof (0, $lzEKq.AddMarkStep)) {
            const addMarkStep = step;
            if ((0, $9Ssie.isLinkMark)(addMarkStep.mark, schema)) {
                const node = after.nodeAt(addMarkStep.from);
                if (node) /**
					 * For url text pasted on plain text
					 */ insertedInStep.push({
                    pos: addMarkStep.from,
                    node: node,
                    nodeContext: (0, $3o3Tb.getNodeContext)(after, addMarkStep.from)
                });
            }
        }
        if (step instanceof (0, $lzEKq.RemoveMarkStep)) {
            const removeMarkStep = step;
            if ((0, $9Ssie.isLinkMark)(removeMarkStep.mark, schema)) {
                const node = before.nodeAt(removeMarkStep.from);
                if (node) removedInStep.push({
                    pos: removeMarkStep.from,
                    node: node,
                    nodeContext: (0, $3o3Tb.getNodeContext)(before, removeMarkStep.from)
                });
            }
        }
        stepMap.forEach((oldStart, oldEnd, newStart, newEnd)=>{
            const before = tr.docs[i];
            const after = tr.docs[i + 1] ?? tr.doc;
            const removedInRange = [];
            const insertedInRange = [];
            // Removed
            removedInRange.push(...(0, $3o3Tb.findInNodeRange)(before, oldStart, oldEnd, (node)=>!!(0, $3o3Tb.getNodeSubject)(node)));
            // Inserted
            insertedInRange.push(...(0, $3o3Tb.findInNodeRange)(after, newStart, newEnd, (node)=>!!(0, $3o3Tb.getNodeSubject)(node)));
            removedInStep.push(...removedInRange);
            insertedInStep.push(...insertedInRange);
        });
        const omitRequestsForUpgrade = (links)=>{
            if (!queuedForUpgrade) return links;
            /**
			 * Skip/filter out links that have been queued, they will be tracked later
			 */ const queuedPositions = $525975141c778c30$var$getQueuedPositions(tr);
            return links.filter((link)=>!queuedPositions.includes(link.pos));
        };
        /**
		 * Skip "deletions" when the transaction is relating to
		 * replacing links queued for upgrade to cards,
		 * because the "deleted" link has not actually been
		 * tracked as "created" yet
		 */ if (!isResolveReplace) removed.push(...removedInStep);
        inserted.push(...omitRequestsForUpgrade(insertedInStep));
    }
    /**
	 * If there are no links changed but the transaction is a "resolve" action
	 * Then this means we have resolved a link but it has failed to upgrade
	 * We should track all resolved links as now being created
	 */ if (inserted.length === 0 && isResolveReplace) {
        const positions = $525975141c778c30$var$getResolvePositions(tr, state);
        inserted.push(...(0, $3o3Tb.findAtPositions)(tr, positions));
    }
    if (!isUpdate) {
        const { inputMethod: inputMethod } = (0, $6C2m6.getLinkMetadataFromTransaction)(tr);
        /**
		 * If there is no identifiable input method, and the links inserted and removed appear to be the same,
		 * then this transaction likely is not intended to be considered to be the insertion and removal of links
		 */ if (!inputMethod && (0, $3o3Tb.areSameNodes)(removed, inserted)) return {
            removed: [],
            inserted: [],
            updated: updated
        };
        return {
            removed: removed,
            inserted: inserted,
            updated: updated
        };
    }
    const updateInserted = [];
    const updateRemoved = [];
    for(let i = 0; i < inserted.length; i++){
        if (isResolveReplace) {
            const newLink = inserted[i];
            // what is the 2nd argument 'assoc = -1' doing here exactly?
            const mappedPos = tr.mapping.map(newLink.pos, -1);
            const previousDisplay = $525975141c778c30$var$getResolveLinkPrevDisplay(state, mappedPos);
            updated.push({
                inserted: inserted[i],
                previous: {
                    display: previousDisplay
                }
            });
            continue;
        }
        if (inserted.length === removed.length) {
            const previousSubject = (0, $3o3Tb.getNodeSubject)(removed[i].node);
            const currentSubject = (0, $3o3Tb.getNodeSubject)(inserted[i].node);
            if ($525975141c778c30$var$isDatasourceUpgrade(previousSubject, currentSubject) || $525975141c778c30$var$isDatasourceDowngrade(previousSubject, currentSubject)) {
                updateInserted.push(inserted[i]);
                updateRemoved.push(removed[i]);
            } else updated.push({
                removed: removed[i],
                inserted: inserted[i]
            });
        }
    }
    return {
        inserted: updateInserted,
        removed: updateRemoved,
        updated: updated
    };
};
/**
 * List of actions to be considered link "updates"
 */ const $525975141c778c30$var$UPDATE_ACTIONS = [
    (0, $bMFKb.ACTION).CHANGED_TYPE,
    (0, $bMFKb.ACTION).UPDATED
];
/**
 * Returns true if the transaction has LinkMetaSteps that indicate the transaction is
 * intended to be perceived as an update to links, rather than insertion+deletion
 */ const $525975141c778c30$var$isUpdateTr = (tr, isUndoOrRedo)=>{
    return !!tr.steps.find((step)=>{
        if (!(step instanceof (0, $5KmoW.LinkMetaStep))) return false;
        const { action: action, cardAction: cardAction } = step.getMetadata();
        /**
		 * Undo of a resolve step should be considered an update
		 * because the user is choosing to update the url back to the un-upgraded display
		 */ if (cardAction === 'RESOLVE' && isUndoOrRedo) return true;
        if (!action) return false;
        return $525975141c778c30$var$UPDATE_ACTIONS.includes(action);
    });
};
const $525975141c778c30$var$hasType = (pluginMeta)=>{
    return typeof pluginMeta === 'object' && pluginMeta !== null && 'type' in pluginMeta;
};
const $525975141c778c30$var$isTransactionQueuedForUpgrade = (tr)=>{
    const pluginMeta = tr.getMeta((0, $cuJUr.pluginKey));
    return $525975141c778c30$var$isMetadataQueue(pluginMeta);
};
const $525975141c778c30$var$isMetadataQueue = (metaData)=>{
    return $525975141c778c30$var$hasType(metaData) && metaData.type === 'QUEUE';
};
const $525975141c778c30$var$isTransactionResolveReplace = (tr)=>{
    const pluginMeta = tr.getMeta((0, $cuJUr.pluginKey));
    return $525975141c778c30$var$isMetadataResolve(pluginMeta);
};
const $525975141c778c30$var$isMetadataResolve = (metaData)=>{
    return $525975141c778c30$var$hasType(metaData) && metaData.type === 'RESOLVE';
};
const $525975141c778c30$var$isHistoryMeta = (meta)=>{
    return typeof meta === 'object' && meta !== null && 'redo' in meta;
};
const $525975141c778c30$var$getQueuedPositions = (tr)=>{
    const pluginMeta = tr.getMeta((0, $cuJUr.pluginKey));
    if (!$525975141c778c30$var$isMetadataQueue(pluginMeta)) return [];
    return pluginMeta.requests.map(({ pos: pos })=>pos);
};
const $525975141c778c30$var$getResolvePositions = (tr, state)=>{
    const cardState = (0, $d3z4A.getPluginState)(state);
    if (!cardState) return [];
    const pluginMeta = tr.getMeta((0, $cuJUr.pluginKey));
    if (!$525975141c778c30$var$isMetadataResolve(pluginMeta)) return [];
    return cardState.requests.filter((request)=>request.url === pluginMeta.url).map((request)=>request.pos);
};
const $525975141c778c30$var$getResolveLinkPrevDisplay = (state, pos)=>{
    const cardState = (0, $d3z4A.getPluginState)(state);
    if (!cardState) return undefined;
    return cardState.requests.find((request)=>request.pos === pos)?.previousAppearance;
};
const $525975141c778c30$var$isDatasourceDowngrade = (previousSubject, currentSubject)=>previousSubject === (0, $lRqrn.EVENT_SUBJECT).DATASOURCE && currentSubject === (0, $lRqrn.EVENT_SUBJECT).LINK;
const $525975141c778c30$var$isDatasourceUpgrade = (previousSubject, currentSubject)=>previousSubject === (0, $lRqrn.EVENT_SUBJECT).LINK && currentSubject === (0, $lRqrn.EVENT_SUBJECT).DATASOURCE;
function $525975141c778c30$export$c985b35883eaea59(tr, state) {
    const events = [];
    try {
        /**
		 * Skip transactions sent by collab (identified by 'isRemote' key)
		 * Skip entire document replace steps
		 * We are only concerned with transactions performed on the document directly by the user
		 */ const isRemote = tr.getMeta('isRemote');
        const isReplaceDocument = tr.getMeta('replaceDocument');
        const isTableSort = tr.steps.find((step)=>step instanceof (0, $7gMgW.TableSortStep));
        if (isRemote || isReplaceDocument || isTableSort) return events;
        const historyMeta = tr.getMeta((0, $3ADzg.pmHistoryPluginKey));
        const isUndo = $525975141c778c30$var$isHistoryMeta(historyMeta) && historyMeta.redo === false;
        const isRedo = $525975141c778c30$var$isHistoryMeta(historyMeta) && historyMeta.redo === true;
        /**
		 * Retrieve metadata from the LinkMetaStep(s) in the transaction
		 */ const { action: action, inputMethod: inputMethod, sourceEvent: sourceEvent } = (0, $6C2m6.getLinkMetadataFromTransaction)(tr);
        const { removed: removed, inserted: inserted, updated: updated } = $525975141c778c30$export$200d2ac836975ed5(tr, state);
        const MAX_LINK_EVENTS = 50;
        if ([
            removed,
            inserted,
            updated
        ].some((arr)=>arr.length > MAX_LINK_EVENTS)) return [];
        for(let i = 0; i < updated.length; i++){
            const update = updated[i];
            const { inserted: inserted } = update;
            const { node: node, nodeContext: nodeContext } = inserted;
            const subject = (0, $3o3Tb.getNodeSubject)(node);
            /**
			 * Not great, wish we had the previous node but we never stored it
			 */ const previousDisplay = 'removed' in update ? (0, $3o3Tb.appearanceForLink)(update.removed.node) : update.previous.display ?? 'unknown';
            if (subject) events.push({
                event: (0, $lRqrn.EVENT).UPDATED,
                subject: subject,
                data: {
                    node: node,
                    nodeContext: nodeContext,
                    action: action,
                    inputMethod: inputMethod,
                    sourceEvent: sourceEvent,
                    isUndo: isUndo,
                    isRedo: isRedo,
                    previousDisplay: previousDisplay
                }
            });
        }
        const pushEvents = (entities, event)=>{
            for(let i = 0; i < entities.length; i++){
                const { node: node, nodeContext: nodeContext } = entities[i];
                const subject = (0, $3o3Tb.getNodeSubject)(node);
                if (subject) events.push({
                    event: event,
                    subject: subject,
                    data: {
                        node: node,
                        nodeContext: nodeContext,
                        action: action,
                        inputMethod: inputMethod,
                        sourceEvent: sourceEvent,
                        isUndo: isUndo,
                        isRedo: isRedo
                    }
                });
            }
        };
        pushEvents(removed, (0, $lRqrn.EVENT).DELETED);
        pushEvents(inserted, (0, $lRqrn.EVENT).CREATED);
        return events;
    } catch (err) {
        return events;
    }
}

});
parcelRegister("7gMgW", function(module, exports) {

$parcel$export(module.exports, "TableSortStep", () => $01d631cb53be220d$export$c1b7e6427b2a2113);

var $3xw6l = parcelRequire("3xw6l");

var $lzEKq = parcelRequire("lzEKq");parcelRequire("iomZG");
var $lzEKq = parcelRequire("lzEKq");
const $01d631cb53be220d$export$3f33e36adb7672cc = 'atlaskit-table-sorting-ordering';
class $01d631cb53be220d$export$c1b7e6427b2a2113 extends (0, $lzEKq.Step) {
    constructor(pos, prev, next){
        super();
        this.prev = prev;
        this.next = next;
        this.pos = pos;
    }
    invert() {
        return new $01d631cb53be220d$export$c1b7e6427b2a2113(this.pos, this.next, this.prev);
    }
    apply(doc) {
        return (0, $lzEKq.StepResult).ok(doc);
    }
    map() {
        return null;
    }
    getMap() {
        return new (0, $lzEKq.StepMap)([
            0,
            0,
            0
        ]);
    }
    toJSON() {
        return {
            stepType: $01d631cb53be220d$export$3f33e36adb7672cc
        };
    }
    static fromJSON() {
        return new (0, $lzEKq.ReplaceStep)(0, 0, (0, $3xw6l.Slice).empty);
    }
}
/** Register this step with Prosemirror */ (0, $lzEKq.Step).jsonID($01d631cb53be220d$export$3f33e36adb7672cc, $01d631cb53be220d$export$c1b7e6427b2a2113);

});
parcelRegister("iomZG", function(module, exports) {

$parcel$export(module.exports, "Step", () => (parcelRequire("lzEKq")).Step);

var $eGOwo = parcelRequire("eGOwo");

var $lzEKq = parcelRequire("lzEKq");
// Using this avoids infinite recursion, as referencing Step.fromJSON inside Step.fromJSON
// will refer to the reassigned version, not the original version
const $d63c4dfa112b8014$var$originalFromJSON = (0, $lzEKq.Step).fromJSON;
(0, $lzEKq.Step).fromJSON = (schema, jsonStep)=>{
    const stepImplementation = $d63c4dfa112b8014$var$originalFromJSON(schema, jsonStep);
    // See https://switcheroo.atlassian.com/ui/gates/4e7e1e8c-9126-4dba-a2a3-1c2b86f81c36/key/platform_editor_metadata_steps
    if (!(0, $eGOwo.fg)('platform_editor_metadata_step')) return stepImplementation;
    return new Proxy(stepImplementation, {
        get (target, prop, receiver) {
            if (prop === 'toJSON') {
                const toJSONfunc = Reflect.get(target, prop, receiver);
                // @ts-expect-error Metadata may or may not exist at this stage, depending on step type,
                // but also additions outside of the type system that others may have done.
                const classMetadata = target.metadata;
                return new Proxy(toJSONfunc, {
                    apply (target, thisArg, argArray) {
                        const originalResult = Reflect.apply(target, thisArg, argArray);
                        const metadata = {
                            ...jsonStep.metadata,
                            ...classMetadata,
                            ...originalResult.metadata
                        };
                        return {
                            ...originalResult,
                            ...Object.keys(metadata).length === 0 ? {} : {
                                metadata: metadata
                            }
                        };
                    }
                });
            }
            return Reflect.get(target, prop, receiver);
        }
    });
};

});


parcelRegister("3ADzg", function(module, exports) {

$parcel$export(module.exports, "pmHistoryPluginKey", () => $f2cf97e1a7db7bda$export$d4f2631252432abf);
$parcel$export(module.exports, "shallowEqual", () => $f2cf97e1a7db7bda$export$d36bdfa510afb180);
$parcel$export(module.exports, "isSelectionInsideLastNodeInDocument", () => $f2cf97e1a7db7bda$export$51bf7c6695e13879);
$parcel$export(module.exports, "isInListItem", () => $f2cf97e1a7db7bda$export$92d47fcf661e090e);
$parcel$export(module.exports, "findFarthestParentNode", () => $f2cf97e1a7db7bda$export$6b982788a5f0ccef);
$parcel$export(module.exports, "insideTableCell", () => $f2cf97e1a7db7bda$export$1350ff12653c84d4);
$parcel$export(module.exports, "checkNodeDown", () => $f2cf97e1a7db7bda$export$d0951c59cd3dac0f);
$parcel$export(module.exports, "isEmptyNode", () => $f2cf97e1a7db7bda$export$641fdf56f693bfbc);
$parcel$export(module.exports, "isNodeEmpty", () => $f2cf97e1a7db7bda$export$cd58ff1081f6abe9);
$parcel$export(module.exports, "isInEmptyLine", () => $f2cf97e1a7db7bda$export$3b68253250b41118);
$parcel$export(module.exports, "isEmptyParagraph", () => (parcelRequire("5Z3Rm")).isEmptyParagraph);
$parcel$export(module.exports, "hasDocAsParent", () => (parcelRequire("bnAxN")).hasDocAsParent);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $BmspC = parcelRequire("BmspC");

var $bnAxN = parcelRequire("bnAxN");

var $5Z3Rm = parcelRequire("5Z3Rm");

var $8YVeS = parcelRequire("8YVeS");

var $7TRmB = parcelRequire("7TRmB");

var $8yKjs = parcelRequire("8yKjs");

var $7EdFW = parcelRequire("7EdFW");

var $hvPOH = parcelRequire("hvPOH");

var $dZ5Iy = parcelRequire("dZ5Iy");

var $5s6bt = parcelRequire("5s6bt");

var $bnh3n = parcelRequire("bnh3n");

var $9Ssie = parcelRequire("9Ssie");

var $bazog = parcelRequire("bazog");

var $gbisc = parcelRequire("gbisc");

var $7SIsS = parcelRequire("7SIsS");


var $dyNYh = parcelRequire("dyNYh");

var $33XK0 = parcelRequire("33XK0");

var $3mTkR = parcelRequire("3mTkR");






var $3AGQm = parcelRequire("3AGQm");

var $bTpHi = parcelRequire("bTpHi");

var $gikGJ = parcelRequire("gikGJ");

var $d3BBj = parcelRequire("d3BBj");

var $gO24W = parcelRequire("gO24W");


var $LjYWw = parcelRequire("LjYWw");


var $lT8fo = parcelRequire("lT8fo");

var $b2Bji = parcelRequire("b2Bji");


var $3Ussg = parcelRequire("3Ussg");




var $64w3F = parcelRequire("64w3F");

var $74dMH = parcelRequire("74dMH");

var $fCXIH = parcelRequire("fCXIH");

var $grDTV = parcelRequire("grDTV");

var $A5UFg = parcelRequire("A5UFg");

var $51k6y = parcelRequire("51k6y");

var $19zEl = parcelRequire("19zEl");


var $7WlTe = parcelRequire("7WlTe");

var $HOLTj = parcelRequire("HOLTj");




var $leZY6 = parcelRequire("leZY6");

var $3vP7W = parcelRequire("3vP7W");

var $dqHDB = parcelRequire("dqHDB");

var $kMoqb = parcelRequire("kMoqb");

var $gmvZ4 = parcelRequire("gmvZ4");

var $hMYvD = parcelRequire("hMYvD");

var $aP4il = parcelRequire("aP4il");


const $f2cf97e1a7db7bda$export$d4f2631252432abf = 'history$';
function $f2cf97e1a7db7bda$export$d36bdfa510afb180(obj1 = {}, obj2 = {}) {
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);
    return keys1.length === keys2.length && keys1.reduce((acc, key)=>acc && obj1[key] === obj2[key], true);
}
function $f2cf97e1a7db7bda$export$51bf7c6695e13879(selection) {
    const docNode = selection.$anchor.node(0);
    const rootNode = selection.$anchor.node(1);
    return docNode.lastChild === rootNode;
}
const $f2cf97e1a7db7bda$export$92d47fcf661e090e = (state)=>{
    return (0, $BmspC.hasParentNodeOfType)(state.schema.nodes.listItem)(state.selection);
};
const $f2cf97e1a7db7bda$export$6b982788a5f0ccef = (predicate)=>($pos)=>{
        let candidate = null;
        for(let i = $pos.depth; i > 0; i--){
            const node = $pos.node(i);
            if (predicate(node)) candidate = {
                pos: i > 0 ? $pos.before(i) : 0,
                start: $pos.start(i),
                depth: i,
                node: node
            };
        }
        return candidate;
    };
const $f2cf97e1a7db7bda$export$1350ff12653c84d4 = (state)=>{
    const { tableCell: tableCell, tableHeader: tableHeader } = state.schema.nodes;
    return (0, $BmspC.hasParentNodeOfType)([
        tableCell,
        tableHeader
    ])(state.selection);
};
/**
 * Traverse the document until an "ancestor" is found. Any nestable block can be an ancestor.
 */ // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $f2cf97e1a7db7bda$var$findAncestorPosition(doc, pos) {
    const nestableBlocks = [
        'blockquote',
        'bulletList',
        'orderedList'
    ];
    if (pos.depth === 1) return pos;
    let node = pos.node(pos.depth);
    let newPos = pos;
    while(pos.depth >= 1){
        pos = doc.resolve(pos.before(pos.depth));
        node = pos.node(pos.depth);
        if (node && nestableBlocks.indexOf(node.type.name) !== -1) newPos = pos;
    }
    return newPos;
}
function $f2cf97e1a7db7bda$export$d0951c59cd3dac0f(selection, doc, filter) {
    const ancestorDepth = $f2cf97e1a7db7bda$var$findAncestorPosition(doc, selection.$to).depth;
    // Top level node
    if (ancestorDepth === 0) return false;
    const res = doc.resolve(selection.$to.after(ancestorDepth));
    return res.nodeAfter ? filter(res.nodeAfter) : false;
}
const $f2cf97e1a7db7bda$export$641fdf56f693bfbc = (schema)=>{
    const { doc: doc, paragraph: paragraph, expand: expand, codeBlock: codeBlock, blockquote: blockquote, panel: panel, heading: heading, listItem: listItem, bulletList: bulletList, orderedList: orderedList, taskList: taskList, taskItem: taskItem, decisionList: decisionList, decisionItem: decisionItem, media: media, mediaGroup: mediaGroup, mediaSingle: mediaSingle } = schema.nodes;
    const innerIsEmptyNode = (node)=>{
        switch(node.type){
            case media:
            case mediaGroup:
            case mediaSingle:
                return false;
            case paragraph:
            case codeBlock:
            case heading:
            case taskItem:
            case decisionItem:
                return node.content.size === 0;
            case expand:
            case blockquote:
            case panel:
            case listItem:
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                return node.content.size === 2 && innerIsEmptyNode(node.content.firstChild);
            case bulletList:
            case orderedList:
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                return node.content.size === 4 && innerIsEmptyNode(node.content.firstChild);
            case taskList:
            case decisionList:
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                return node.content.size === 2 && innerIsEmptyNode(node.content.firstChild);
            case doc:
                let isEmpty = true;
                node.content.forEach((child)=>{
                    isEmpty = isEmpty && innerIsEmptyNode(child);
                });
                return isEmpty;
            default:
                return $f2cf97e1a7db7bda$export$cd58ff1081f6abe9(node);
        }
    };
    return innerIsEmptyNode;
};
function $f2cf97e1a7db7bda$export$cd58ff1081f6abe9(node) {
    if (node && node.textContent) return false;
    if (!node || !node.childCount || node.childCount === 1 && (0, $5Z3Rm.isEmptyParagraph)(node.firstChild)) return true;
    const block = [];
    const nonBlock = [];
    node.forEach((child)=>{
        child.isInline ? nonBlock.push(child) : block.push(child);
    });
    return !nonBlock.length && !block.filter((childNode)=>!!childNode.childCount && !(childNode.childCount === 1 && (0, $5Z3Rm.isEmptyParagraph)(childNode.firstChild)) || childNode.isAtom).length;
}
function $f2cf97e1a7db7bda$export$3b68253250b41118(state) {
    const { selection: selection } = state;
    const { $cursor: $cursor, $anchor: $anchor } = selection;
    if (!$cursor) return false;
    const node = $cursor.node();
    if (!node) return false;
    return (0, $5Z3Rm.isEmptyParagraph)(node) && (0, $bnAxN.hasDocAsParent)($anchor);
}

});
parcelRegister("8yKjs", function(module, exports) {

$parcel$export(module.exports, "getExtensionLozengeData", () => $36b18020509a37b1$export$4fd8ecadd193bea0);
const $36b18020509a37b1$export$4fd8ecadd193bea0 = ({ node: node, type: type })=>{
    if (!node.attrs.parameters) return;
    const { macroMetadata: macroMetadata } = node.attrs.parameters;
    if (macroMetadata && macroMetadata.placeholder) {
        let placeholderData;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        macroMetadata.placeholder.forEach((placeholder)=>{
            if (placeholder.type === type && placeholder.data && placeholder.data.url) placeholderData = placeholder.data;
        });
        return placeholderData;
    }
    return;
};

});

parcelRegister("5s6bt", function(module, exports) {

$parcel$export(module.exports, "withImageLoader", () => $e51a33182b24142b$export$9b0f795b2e33f057);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
const $e51a33182b24142b$export$3a0bcc6ff2e20f36 = (Wrapped)=>class WithImageLoader extends (0, $eJOHy.Component) {
        /**
		 *
		 * @example
		 */ componentDidMount() {
            this.fetchImage(this.props);
        }
        /**
		 *
		 * @param nextProps
		 * @example
		 */ // Ignored via go/ees005
        // eslint-disable-next-line react/no-unsafe
        UNSAFE_componentWillReceiveProps(nextProps) {
            if (nextProps.url !== this.props.url) {
                this.setState({
                    imageStatus: 'loading'
                });
                this.fetchImage(nextProps);
            }
        }
        /**
		 *
		 * @example
		 */ componentWillUnmount() {
            if (this.img) {
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                this.img.removeEventListener('load', this.onLoad);
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                this.img.removeEventListener('error', this.onError);
                this.img = null;
            }
        }
        /**
		 *
		 * @param root0
		 * @param root0.url
		 * @example
		 */ fetchImage({ url: url }) {
            if (url) {
                if (!this.img) {
                    this.img = new Image();
                    // Ignored via go/ees005
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    this.img.addEventListener('load', this.onLoad);
                    // Ignored via go/ees005
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    this.img.addEventListener('error', this.onError);
                }
                this.img.src = url;
            }
        }
        /**
		 *
		 * @example
		 */ render() {
            const { imageStatus: imageStatus } = this.state;
            // Ignored via go/ees005
            // eslint-disable-next-line react/jsx-props-no-spreading
            return /*#__PURE__*/ (0, $gt9Am.jsx)(Wrapped, {
                ...this.props,
                imageStatus: imageStatus
            });
        }
        constructor(...args){
            super(...args), this.state = {
                imageStatus: 'loading'
            }, this.onLoad = ()=>{
                this.setState({
                    imageStatus: 'complete'
                });
                const { onExternalImageLoaded: onExternalImageLoaded } = this.props;
                if (onExternalImageLoaded && this.img) onExternalImageLoaded({
                    width: this.img.naturalWidth,
                    height: this.img.naturalHeight
                });
            }, this.onError = ()=>{
                this.setState({
                    imageStatus: 'error'
                });
            };
        }
    };
const $e51a33182b24142b$var$withImageLoaderNew = (Wrapped)=>class WithImageLoader extends (0, $eJOHy.Component) {
        componentDidMount() {
            this.fetchImage(this.props);
        }
        componentDidUpdate(newProps) {
            if (newProps.url !== this.props.url) {
                this.setState({
                    imageStatus: 'loading'
                });
                this.fetchImage(newProps);
            }
        }
        componentWillUnmount() {
            if (this.img) {
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                this.img.removeEventListener('load', this.onLoad);
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                this.img.removeEventListener('error', this.onError);
                this.img = null;
            }
        }
        fetchImage({ url: url }) {
            if (url) {
                if (!this.img) {
                    this.img = new Image();
                    // Ignored via go/ees005
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    this.img.addEventListener('load', this.onLoad);
                    // Ignored via go/ees005
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    this.img.addEventListener('error', this.onError);
                }
                this.img.src = url;
            }
        }
        render() {
            const { imageStatus: imageStatus } = this.state;
            // Ignored via go/ees005
            // eslint-disable-next-line react/jsx-props-no-spreading
            return /*#__PURE__*/ (0, $gt9Am.jsx)(Wrapped, {
                ...this.props,
                imageStatus: imageStatus
            });
        }
        constructor(...args){
            super(...args), this.state = {
                imageStatus: 'loading'
            }, this.onLoad = ()=>{
                this.setState({
                    imageStatus: 'complete'
                });
                const { onExternalImageLoaded: onExternalImageLoaded } = this.props;
                if (onExternalImageLoaded && this.img) onExternalImageLoaded({
                    width: this.img.naturalWidth,
                    height: this.img.naturalHeight
                });
            }, this.onError = ()=>{
                this.setState({
                    imageStatus: 'error'
                });
            };
        }
    };
const $e51a33182b24142b$export$9b0f795b2e33f057 = (Wrapped)=>{
    return $e51a33182b24142b$var$withImageLoaderNew(Wrapped);
};

});

parcelRegister("bazog", function(module, exports) {

$parcel$export(module.exports, "pluginFactory", () => $01c852007ceaa07b$export$3dd00fb488ab385a);
/**
 * Creates a ProseMirror plugin's state and handles UI updates.
 *
 * Here's a few things to keep in mind:
 * - plugin's state is stored as a single object
 * - `Reducer` specifies how plugin's state changes in response to commands
 * - `Command` describes only what happen, but not how state changes
 * - `mapping` could be used to map ProseMirror positions stored in plugin's state
 *
 * Example:
 *  const { createPluginState, createCommand, getPluginState } = pluginFactory(
 *    reducer,
 *    pluginKey
 *  );
 *
 *  export const createPlugin = (dispatch: Dispatch, initialState) =>
 *    new SafePlugin({
 *      state: createPluginState(dispatch, initialState),
 *      key: pluginKey
 *    });
 *
 * Example of a reducer:
 *
 *  export const reducer = (
 *    state: TablePluginState,
 *    action: TableAction,
 *  ): TablePluginState => {
 *    switch (action.type) {
 *      case 'TOGGLE_CONTEXTUAL_MENU':
 *      return {
 *        ...state,
 *        isContextualMenuOpen: !state.isContextualMenuOpen,
 *      };
 *    default:
 *      return state;
 *    }
 *  };
 *
 *
 * Example of a command:
 *
 * export const toggleContextualMenu = createCommand({
 *   type: 'TOGGLE_CONTEXTUAL_MENU',
 * }, tr => tr.setMeta('addToHistory', false));
 *
 */ // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $01c852007ceaa07b$var$isFunction(x) {
    return typeof x === 'function';
}
function $01c852007ceaa07b$export$3dd00fb488ab385a(pluginKey, reducer, options = {}) {
    const { mapping: mapping, onDocChanged: onDocChanged, onSelectionChanged: onSelectionChanged } = options;
    return {
        createPluginState (dispatch, initialState) {
            return {
                init: (_, state)=>$01c852007ceaa07b$var$isFunction(initialState) ? initialState(state) : initialState,
                apply: (tr, _pluginState, _oldEditorState, newEditorState)=>{
                    const oldPluginState = mapping ? mapping(tr, _pluginState, newEditorState) : _pluginState;
                    let newPluginState = oldPluginState;
                    const meta = tr.getMeta(pluginKey);
                    if (meta) newPluginState = reducer(oldPluginState, meta);
                    if (onDocChanged && tr.docChanged) newPluginState = onDocChanged(tr, newPluginState, newEditorState);
                    else if (onSelectionChanged && tr.selectionSet) newPluginState = onSelectionChanged(tr, newPluginState, newEditorState);
                    if (newPluginState !== oldPluginState) dispatch(pluginKey, newPluginState);
                    return newPluginState;
                }
            };
        },
        createCommand (action, transform) {
            return (state, dispatch)=>{
                if (dispatch) {
                    const tr = transform ? transform(state.tr, state) : state.tr;
                    const resolvedAction = $01c852007ceaa07b$var$isFunction(action) ? action(state) : action;
                    if (tr && resolvedAction) dispatch(tr.setMeta(pluginKey, resolvedAction));
                    else return false;
                }
                return true;
            };
        },
        getPluginState (state) {
            return pluginKey.getState(state);
        }
    };
}

});

parcelRegister("gO24W", function(module, exports) {

$parcel$export(module.exports, "isTextInput", () => $a9c11403540600f0$export$3e6057b9bf6b0bbb);

var $lzEKq = parcelRequire("lzEKq");
const $a9c11403540600f0$export$3e6057b9bf6b0bbb = (tr)=>{
    const [step] = tr.steps;
    if (!step || !(step instanceof (0, $lzEKq.ReplaceStep))) return false;
    const { slice: { content: content }, from: from, to: to } = step;
    const char = content.firstChild;
    return from === to && content.childCount === 1 && !!char && !!char.text && char.text.length === 1;
};

});

parcelRegister("b2Bji", function(module, exports) {

$parcel$export(module.exports, "sniffUserBrowserExtensions", () => $61b3a92b49e227d6$export$4cd1ca2600761f65);
const $61b3a92b49e227d6$var$registerDetectors = (targetExtensions, supportedDetectors)=>{
    const detectors = supportedDetectors.filter((registration)=>targetExtensions.includes(registration.name));
    return detectors.map((detector)=>({
            name: detector.name,
            state: {
                detected: false
            },
            fns: {
                async: detector.fns.async,
                sync: detector.fns.sync
            }
        }));
};
const $61b3a92b49e227d6$var$RACE_COMPLETE = 'race_complete';
const $61b3a92b49e227d6$var$SELECTORS = {
    GRAMMARLY: 'grammarly-extension, grammarly-popups, [data-grammarly-shadow-root]'
};
/**
 * This is the official list of supported browser extension detectors. To add support
 * for detecting an additional browser extension, simply add a (DetectorRegistration)
 * object like below to the list:
 *
 * ```
 * {
 *  name: 'exampleExtension',
 *  fns: {
 *    // a synchronous check that should return true if the extension is detected
 *    sync: () => !!document.querySelector(".some-example-class"),
 *    // an asynchronous check that should invoke 'detected' if the extension is detected.
 *    // it can also invoke 'cleanup' with a callback to schedule cleanup tasks
 *    // (such as disconnecting observers).
 *    async: (detected, cleanup) => {
 *      if (document.querySelector(".some-example-class")) {
 *        detected();
 *      }
 *    }
 *  }
 * }
 * ```
 */ const $61b3a92b49e227d6$var$supportedDetectors = [
    {
        name: 'grammarly',
        fns: {
            sync: ()=>Boolean(document?.querySelector($61b3a92b49e227d6$var$SELECTORS.GRAMMARLY)),
            async: (detected, cleanup)=>{
                // First check to see if grammarly already exists on page
                const exists = Boolean(document?.querySelector($61b3a92b49e227d6$var$SELECTORS.GRAMMARLY));
                if (exists) detected();
                // Otherwise, setup a mutation observer to observe the page and its children
                // for newly added nodes. Collect observed mutations in a queue and in 1 second
                // intervals either process the queue or schedule the processing task for when
                // the user agent's main thread is idle (if possible).
                let queue = [];
                const processQueue = ()=>{
                    for (const mutations of queue){
                        for (const mutation of mutations)if (mutation?.type === 'childList' && mutation?.addedNodes?.length) {
                            const exists = Array.from(mutation.addedNodes).some((node)=>node.parentElement?.querySelector($61b3a92b49e227d6$var$SELECTORS.GRAMMARLY));
                            if (exists) detected();
                        }
                    }
                    queue = [];
                };
                const intervalId = setInterval(()=>{
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    if (typeof window.requestIdleCallback === 'function') // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    window.requestIdleCallback(processQueue);
                    else window.requestAnimationFrame(processQueue);
                }, 1000);
                const observer = new MutationObserver((mutations)=>{
                    queue.push(mutations);
                });
                cleanup(()=>{
                    queue = [];
                    clearInterval(intervalId);
                    observer?.disconnect();
                });
                observer.observe(document.documentElement, {
                    childList: true,
                    subtree: true
                });
            }
        }
    }
];
function $61b3a92b49e227d6$export$4cd1ca2600761f65(options) {
    try {
        // First we filter out supported extensions that aren't requested through options. We also
        // prepare detector objects with some initial internal state (e.g. detector.state.detected = false)
        const detectors = $61b3a92b49e227d6$var$registerDetectors(options.extensions, $61b3a92b49e227d6$var$supportedDetectors);
        // If async mode is enabled, we convert the list of detector objects to a list of promises
        // that resolve when the detector invokes detected() during its asynchronous check.
        // We also track any scheduled cleanup() tasks.
        if (options.async === true) {
            const asyncCleanups = [];
            const asyncDetections = Promise.all(detectors.map((detector)=>{
                return new Promise((resolve)=>{
                    const detected = ()=>{
                        detector.state.detected = true;
                        resolve();
                    };
                    const cleanup = (cb)=>{
                        asyncCleanups.push(cb);
                    };
                    if (typeof detector.fns.async === 'function') detector.fns.async(detected, cleanup);
                    else {
                        detector.state.detected = false;
                        resolve();
                    }
                });
            }));
            // We race all asynchronous checkers against a user-defined timeout (asyncTimeoutMs).
            // When asynchronous checks are finalised first,or if the timeout elapses, we return
            // the list of extensions detected up until that point.
            const globalTimeout = new Promise((resolve)=>setTimeout(resolve, options.asyncTimeoutMs, $61b3a92b49e227d6$var$RACE_COMPLETE));
            return Promise.race([
                asyncDetections,
                globalTimeout
            ]).then(()=>{
                return detectors.filter((detector)=>detector.state.detected).map((detector)=>detector.name);
            })// If there are any errors, we fail safely and silently with zero detected extensions.
            .catch(()=>[]).finally(()=>asyncCleanups.map((cleanup)=>cleanup()));
        } else // If sync mode, we immediately execute synchronous checks
        // and return a list of extensions whose synchronous checks returned true.
        return detectors.filter((detector)=>detector.fns.sync?.()).map((detector)=>detector.name);
    } catch (err) {
        // If there are any unhandled errors, we fail safely and silently with zero detected extensions.
        return options.async ? Promise.resolve([]) : [];
    }
}

});

parcelRegister("64w3F", function(module, exports) {

$parcel$export(module.exports, "autoJoinTr", () => $c136a66e18d8e68e$export$c7c1e59168a7f554);

var $lzEKq = parcelRequire("lzEKq");
function $c136a66e18d8e68e$export$c7c1e59168a7f554(tr, isJoinable) {
    if (Array.isArray(isJoinable)) {
        const types = isJoinable;
        isJoinable = (node)=>types.indexOf(node.type.name) > -1;
    }
    const ranges = [];
    for(let i = 0; i < tr.mapping.maps.length; i++){
        const map = tr.mapping.maps[i];
        for(let j = 0; j < ranges.length; j++)ranges[j] = map.map(ranges[j]);
        map.forEach((_s, _e, from, to)=>ranges.push(from, to));
    }
    // Figure out which joinable points exist inside those ranges,
    // by checking all node boundaries in their parent nodes.
    const joinable = [];
    for(let i = 0; i < ranges.length; i += 2){
        const from = ranges[i];
        const to = ranges[i + 1];
        const $from = tr.doc.resolve(from);
        const depth = $from.sharedDepth(to);
        const parent = $from.node(depth);
        for(let index = $from.indexAfter(depth), pos = $from.after(depth + 1); pos <= to; ++index){
            const after = parent.maybeChild(index);
            if (!after) break;
            if (index && joinable.indexOf(pos) === -1) {
                const before = parent.child(index - 1);
                if (before.type === after.type && isJoinable(before, after)) joinable.push(pos);
            }
            pos += after.nodeSize;
        }
    }
    // Join the joinable points
    joinable.sort((a, b)=>a - b);
    for(let i = joinable.length - 1; i >= 0; i--)if ((0, $lzEKq.canJoin)(tr.doc, joinable[i])) tr.join(joinable[i]);
}

});

parcelRegister("74dMH", function(module, exports) {

$parcel$export(module.exports, "isReferencedSource", () => $2d248134b5fac0e8$export$d35a68bd2e0b55da);
$parcel$export(module.exports, "removeConnectedNodes", () => $2d248134b5fac0e8$export$657e59857351232d);
$parcel$export(module.exports, "getChildrenInfo", () => $2d248134b5fac0e8$export$c98d43680e607ac1);
$parcel$export(module.exports, "getNodeName", () => $2d248134b5fac0e8$export$651544f548703224);
const $2d248134b5fac0e8$export$d35a68bd2e0b55da = (state, node)=>{
    if (!node) return false;
    let found = false;
    // Handle nodes having 2 uuids. They could have a localId or a fragment. Regardless this needs
    // to check if either id is used by a data consumer.
    const localIds = new Set([
        node.attrs?.localId,
        node.marks?.find((mark)=>mark.type === state.schema.marks.fragment)?.attrs?.localId
    ].filter(Boolean));
    // If there are no uuids on the node then it's not possible for it to be referenced anywhere.
    if (!localIds.size) return false;
    state.doc.descendants((node)=>{
        if (found) return false;
        const dataConsumer = node.marks.find((mark)=>mark.type === state.schema.marks.dataConsumer);
        if (!dataConsumer) return true;
        found = dataConsumer.attrs.sources?.some((src)=>localIds.has(src)) ?? false;
        return !found;
    });
    return found;
};
const $2d248134b5fac0e8$export$82b9f8f75cc709b4 = (state)=>{
    const result = {};
    const { doc: doc, schema: schema } = state;
    // Keeps a map of all raw ids -> to their preferred normalised varient. A node with both fragmentMark & localId will
    // have both ids mapped here to the same normalized version.
    const normalizedIds = new Map();
    const dataConsumerSources = new Map();
    // Perform a prelim scan creating the initial id to connection link mappings.
    // This will also save a list of data sources consumed per node.
    doc.descendants((node, pos)=>{
        let dataConsumer;
        let fragmentMark;
        node.marks.some((mark)=>{
            if (mark.type === schema.marks.dataConsumer) dataConsumer = mark;
            else if (mark.type === schema.marks.fragment) fragmentMark = mark;
            // Stop searching marks if we've found both consumer and fragment.
            return !!dataConsumer && !!fragmentMark;
        });
        // If node cannot be referenced by any means then abort.
        if (!fragmentMark && !node.attrs?.localId) return true;
        const normalizedId = fragmentMark?.attrs?.localId ?? node.attrs?.localId;
        if (!normalizedId) return true;
        if (!!fragmentMark?.attrs?.localId) normalizedIds.set(fragmentMark.attrs.localId, normalizedId);
        if (!!node.attrs?.localId) normalizedIds.set(node.attrs.localId, normalizedId);
        if (!!result[normalizedId]) // Duplicate ID has been found, we'll care about the first one for now.
        return true;
        result[normalizedId] = {
            localId: normalizedId,
            name: fragmentMark?.attrs?.name,
            node: node,
            pos: pos,
            targets: []
        };
        if (!!dataConsumer && dataConsumer.attrs.sources.length) dataConsumerSources.set(normalizedId, dataConsumer.attrs.sources);
        // Do not descend into children of a node which has a dataConsumer attached. This assumes all children of the node cannot
        // be referenced by another node.
        return !dataConsumer;
    });
    // This 2nd-pass only looks at the consumer sources and updates all connections with the correct id refs.
    for (const [localId, sources] of dataConsumerSources)// This is a ref to the node (connection link) which contains the consumer.
    sources.forEach((src)=>{
        const normalizedId = normalizedIds.get(src) ?? src;
        const srcLink = result[normalizedId];
        if (srcLink && normalizedId !== localId) srcLink.targets.push(localId);
    });
    return result;
};
const $2d248134b5fac0e8$export$657e59857351232d = (state, node)=>{
    if (!node) return state.tr;
    const selectedLocalIds = $2d248134b5fac0e8$var$getSelectedLocalIds(state, node);
    const allNodes = $2d248134b5fac0e8$export$82b9f8f75cc709b4(state);
    const idsToBeDeleted = $2d248134b5fac0e8$var$getIdsToBeDeleted(selectedLocalIds, allNodes);
    if (!idsToBeDeleted?.length) return state.tr;
    const { tr: tr } = state;
    let newTr = tr;
    idsToBeDeleted.forEach((id)=>{
        if (!allNodes[id]) return;
        const { node: node, pos: pos } = allNodes[id];
        newTr = newTr.delete(newTr.mapping.map(pos), newTr.mapping.map(node.nodeSize + pos));
    });
    return newTr;
};
// find all ids need to be remove connected to selected extension
const $2d248134b5fac0e8$var$getIdsToBeDeleted = (selectedIds, allNodes)=>{
    if (!selectedIds.size) return [];
    let searchSet = [
        ...selectedIds
    ];
    const deletedIds = new Set();
    while(searchSet.length){
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const id = searchSet.pop();
        if (allNodes[id]) {
            deletedIds.add(allNodes[id].localId);
            searchSet = searchSet.concat(allNodes[id]?.targets.filter((targetId)=>!deletedIds.has(allNodes[targetId]?.localId)) ?? []);
        }
    }
    return Array.from(deletedIds);
};
const $2d248134b5fac0e8$export$c98d43680e607ac1 = (state, node)=>{
    let allChildrenHadName = true;
    if (!node) return [];
    const childrenIdSet = new Set();
    const childrenInfoArray = [];
    const allNodes = $2d248134b5fac0e8$export$82b9f8f75cc709b4(state);
    const selectedNodeIds = $2d248134b5fac0e8$var$getSelectedLocalIds(state, node);
    selectedNodeIds.forEach((id)=>{
        if (allNodes[id]) allNodes[id].targets.forEach(childrenIdSet.add, childrenIdSet);
    });
    for (const id of childrenIdSet)if (!$2d248134b5fac0e8$var$getNodeNameById(id, allNodes)) {
        allChildrenHadName = false;
        break;
    } else childrenInfoArray.push({
        id: id,
        name: $2d248134b5fac0e8$var$getNodeNameById(id, allNodes),
        amount: $2d248134b5fac0e8$var$getChildrenNodeAmount(id, allNodes)
    });
    return allChildrenHadName ? childrenInfoArray : [];
};
const $2d248134b5fac0e8$var$getChildrenNodeAmount = (id, allNodes)=>{
    const searchTerms = new Set([
        id
    ]);
    const traverseHistory = new Map();
    const childrenIds = new Set();
    traverseHistory.set(id, false);
    while(searchTerms.size > 0){
        const [currTerm] = searchTerms;
        const targets = $2d248134b5fac0e8$var$getNodeTargetsById(currTerm, allNodes);
        targets.forEach((target)=>{
            const isTargetCounted = traverseHistory.get(target);
            if (!isTargetCounted) {
                searchTerms.add(target);
                childrenIds.add(target);
            }
            target !== id && childrenIds.add(target);
        });
        traverseHistory.set(currTerm, true);
        searchTerms.delete(currTerm);
    }
    return childrenIds.size;
};
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $2d248134b5fac0e8$var$getNodeTargetsById = (id, allNodes)=>{
    if (!id || !allNodes[id]) return [];
    return allNodes[id].targets;
};
const $2d248134b5fac0e8$var$getNodeNameById = (id, allNodes)=>{
    if (typeof id === 'object') {
        let name;
        id.forEach((localId)=>{
            name = name ?? allNodes[localId]?.name;
        });
        return name || null;
    }
    if (!id || !allNodes[id]) return null;
    return allNodes[id].name;
};
const $2d248134b5fac0e8$var$getSelectedLocalIds = (state, node)=>{
    if (!node) return new Set([]);
    const localIds = new Set([
        node.attrs?.localId,
        node.marks?.find((mark)=>mark.type === state.schema.marks.fragment)?.attrs?.localId
    ].filter(Boolean));
    return localIds;
};
const $2d248134b5fac0e8$export$651544f548703224 = (state, node)=>{
    return node?.marks?.find((mark)=>mark.type === state.schema.marks.fragment)?.attrs?.name ?? '';
};

});

parcelRegister("3vP7W", function(module, exports) {

$parcel$export(module.exports, "dedupe", () => $2f17aa2200094e4c$export$f3a259b74a77132f);
function $2f17aa2200094e4c$export$f3a259b74a77132f(list = [], iteratee = (p)=>p) {
    /**
              .,
    .      _,'f----.._
    |\ ,-'"/  |     ,'
    |,_  ,--.      /
    /,-. ,'`.     (_
    f  o|  o|__     "`-.
    ,-._.,--'_ `.   _.,-`
    `"' ___.,'` j,-'
      `-.__.,--'
    Gotta go fast!
 */ const seen = new Set();
    list.forEach((l)=>seen.add(iteratee(l)));
    return list.filter((l)=>{
        const it = iteratee(l);
        if (seen.has(it)) {
            seen.delete(it);
            return true;
        }
        return false;
    });
}

});

parcelRegister("kMoqb", function(module, exports) {

$parcel$export(module.exports, "transformNodeIntoListItem", () => $00404095a85c8de8$export$f4c81471ccea5042);

var $3xw6l = parcelRequire("3xw6l");

var $3lIcL = parcelRequire("3lIcL");

var $BmspC = parcelRequire("BmspC");

var $fCXIH = parcelRequire("fCXIH");
// Taken from `editor-plugin-content-insertion`
function $00404095a85c8de8$var$setSelectionToValidTextNode(tr, node, from) {
    const sliceInserted = (0, $3xw6l.Slice).maxOpen((0, $3xw6l.Fragment).from(node));
    const openPosition = Math.min(from + (node.isAtom ? node.nodeSize : sliceInserted.openStart), tr.doc.content.size);
    const FORWARD_DIRECTION = 1;
    const nextSelection = (0, $3lIcL.TextSelection).findFrom(tr.doc.resolve(openPosition), FORWARD_DIRECTION, true);
    if (nextSelection) return tr.setSelection(nextSelection);
}
function $00404095a85c8de8$export$f4c81471ccea5042(tr, node) {
    const { $to: $to, $from: $from, to: to, from: from } = tr.selection;
    const { orderedList: orderedList, bulletList: bulletList, listItem: listItem } = tr.doc.type.schema.nodes;
    const startLinePosition = $from.start();
    const parentStartPosition = $from.depth === 0 ? 0 : $from.before();
    // Setting the start position
    const startMapped = startLinePosition === from ? parentStartPosition : from;
    // Selected nodes
    const selectionParentListItemNode = (0, $BmspC.findParentNodeOfType)(listItem)(tr.selection);
    const selectionParentListNodeWithPos = (0, $BmspC.findParentNodeOfType)([
        bulletList,
        orderedList
    ])(tr.selection);
    const selectionParentListNode = selectionParentListNodeWithPos?.node;
    if (!selectionParentListNodeWithPos) return tr;
    // Offsets
    const listWrappingOffset = $to.depth - selectionParentListNodeWithPos.depth + 1; // difference in depth between to position and list node
    const listItemWrappingOffset = $to.depth - selectionParentListNodeWithPos.depth; // difference in depth between to position and list item node
    // Anything to do with nested lists should safeInsert and not be handled here
    const grandParentListNode = (0, $BmspC.findParentNodeOfTypeClosestToPos)(tr.doc.resolve(selectionParentListNodeWithPos.pos), [
        bulletList,
        orderedList
    ]);
    const selectionIsInNestedList = !!grandParentListNode;
    let selectedListItemHasNestedList = false;
    selectionParentListItemNode?.node.content.forEach((child)=>{
        if ((0, $fCXIH.isListNode)(child)) selectedListItemHasNestedList = true;
    });
    if (selectedListItemHasNestedList || selectionIsInNestedList) return (0, $BmspC.safeInsert)(node)(tr).scrollIntoView();
    // Check if node after the insert position is listItem
    const isNodeAfterInsertPositionIsListItem = tr.doc.nodeAt(to + listItemWrappingOffset)?.type === listItem;
    let replaceTo;
    if (isNodeAfterInsertPositionIsListItem) replaceTo = to + listItemWrappingOffset;
    else if (!isNodeAfterInsertPositionIsListItem) replaceTo = to;
    else replaceTo = to + listWrappingOffset;
    // handle the insertion of the slice
    tr.replaceWith(startMapped, replaceTo, node).scrollIntoView();
    // Get the next list items position (used later to find the split out ordered list)
    const indexOfNextListItem = $to.indexAfter($to.depth - listItemWrappingOffset);
    const positionOfNextListItem = tr.doc.resolve(selectionParentListNodeWithPos.pos + 1).posAtIndex(indexOfNextListItem);
    // Place the selection at the replaced location
    $00404095a85c8de8$var$setSelectionToValidTextNode(tr, node, from);
    // Find the ordered list node after the pasted content so we can set it's order
    const mappedPositionOfNextListItem = tr.mapping.map(positionOfNextListItem);
    if (mappedPositionOfNextListItem > tr.doc.nodeSize) return tr;
    const nodeAfterPastedContentResolvedPos = (0, $BmspC.findParentNodeOfTypeClosestToPos)(tr.doc.resolve(mappedPositionOfNextListItem), [
        orderedList
    ]);
    // Work out the new split out lists 'order' (the number it starts from)
    const originalParentOrderedListNodeOrder = selectionParentListNode?.attrs.order;
    const nodeOfOriginalList = (0, $BmspC.findParentNodeOfTypeClosestToPos)(tr.doc.resolve(from - 1), [
        orderedList
    ]);
    const numOfListItemsInOriginalList = nodeOfOriginalList?.node.childCount;
    // Set the new split out lists order attribute
    if (typeof originalParentOrderedListNodeOrder === 'number' && numOfListItemsInOriginalList && nodeAfterPastedContentResolvedPos && // We only want to apply the node markup if we're referring to the split
    // list rather than the original
    nodeOfOriginalList?.node !== nodeAfterPastedContentResolvedPos?.node) tr.setNodeMarkup(nodeAfterPastedContentResolvedPos.pos, orderedList, {
        ...nodeAfterPastedContentResolvedPos.node.attrs,
        order: originalParentOrderedListNodeOrder + numOfListItemsInOriginalList
    });
    return tr;
}

});

parcelRegister("hMYvD", function(module, exports) {

$parcel$export(module.exports, "calculateToolbarPositionAboveSelection", () => $dcba559a41e7cc63$export$5966a251e0deb6ac);
$parcel$export(module.exports, "calculateToolbarPositionTrackHead", () => $dcba559a41e7cc63$export$4fdfbe77de19eec);
$parcel$export(module.exports, "calculateToolbarPositionOnCellSelection", () => $dcba559a41e7cc63$export$2d9cc331fb808a87);

var $BmspC = parcelRequire("BmspC");

var $cwzAY = parcelRequire("cwzAY");
const $dcba559a41e7cc63$var$MAXIMUM_BROWSER_SCROLLBAR_WIDTH = 20;
const $dcba559a41e7cc63$export$5966a251e0deb6ac = (toolbarTitle)=>(editorView, nextPos)=>{
        const toolbar = document.querySelector(`div[aria-label="${toolbarTitle}"]`);
        if (!toolbar) return nextPos;
        // scroll wrapper for full page, fall back to document body
        // Ignored via go/ees007
        // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
        // TODO: look into using getScrollGutterOptions()
        const scrollWrapper = editorView.dom.closest('.fabric-editor-popup-scroll-parent') || document.body;
        const wrapperBounds = scrollWrapper.getBoundingClientRect();
        const selection = window && window.getSelection();
        const range = selection && !selection.isCollapsed && selection.getRangeAt(0);
        if (!range) return nextPos;
        const toolbarRect = toolbar.getBoundingClientRect();
        const { head: head, anchor: anchor } = editorView.state.selection;
        const topCoords = editorView.coordsAtPos(Math.min(head, anchor));
        const bottomCoords = editorView.coordsAtPos(Math.max(head, anchor) - Math.min(range.endOffset, 1));
        let top = (topCoords.top || 0) - toolbarRect.height * 1.5;
        let left = 0;
        // If not on the same line
        if (topCoords.top !== bottomCoords.top) {
            // selecting downwards
            if (head > anchor) left = Math.max(topCoords.right, bottomCoords.right);
            else left = Math.min(topCoords.left, bottomCoords.left);
            /*
        short selection above a long paragraph
        eg. short {<}heading
        The purpose of this text is to show the selection range{>}.
        The horizontal positioning should center around "heading",
        not where it ends at "range".
        Note: if it was "head<b>ing</b>" then it would only center
        around "head". Undesireable but matches the current renderer.
      */ const cliffPosition = range.getClientRects()[0];
            if (cliffPosition.right < left) left = cliffPosition.left + cliffPosition.width / 2;
        } else // Otherwise center on the single line selection
        left = topCoords.left + (bottomCoords.right - topCoords.left) / 2;
        left -= toolbarRect.width / 2;
        // Place toolbar below selection if not sufficient space above
        if (top < wrapperBounds.top) ({ top: top, left: left } = $dcba559a41e7cc63$var$getCoordsBelowSelection(bottomCoords, toolbarRect));
        // remap positions from browser document to wrapperBounds
        return {
            top: top - wrapperBounds.top + scrollWrapper.scrollTop,
            left: Math.max(0, left - wrapperBounds.left)
        };
    };
const $dcba559a41e7cc63$export$4fdfbe77de19eec = (toolbarTitle)=>(editorView, nextPos)=>{
        const toolbar = document.querySelector(`div[aria-label="${toolbarTitle}"]`);
        if (!toolbar) return nextPos;
        // scroll wrapper for full page, fall back to document body
        // Ignored via go/ees007
        // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
        // TODO: look into using getScrollGutterOptions()
        const scrollWrapper = editorView.dom.closest('.fabric-editor-popup-scroll-parent') || document.body;
        const wrapperBounds = scrollWrapper.getBoundingClientRect();
        const selection = window && window.getSelection();
        const range = selection && !selection.isCollapsed && selection.getRangeAt(0);
        if (!range) return nextPos;
        const toolbarRect = toolbar.getBoundingClientRect();
        const { head: head, anchor: anchor } = editorView.state.selection;
        const topCoords = editorView.coordsAtPos(Math.min(head, anchor));
        const bottomCoords = editorView.coordsAtPos(Math.max(head, anchor) - Math.min(range.endOffset, 1));
        let top;
        // If not the same line, display toolbar below.
        if (head > anchor && topCoords.top !== bottomCoords.top) // We are taking the previous pos to the maxium, so avoid end of line positions
        // returning the next line's rect.
        top = (bottomCoords.top || 0) + toolbarRect.height / 1.15;
        else top = (topCoords.top || 0) - toolbarRect.height * 1.5;
        let left = (head > anchor ? bottomCoords.right : topCoords.left) - toolbarRect.width / 2;
        // Place toolbar below selection if not sufficient space above
        if (top < wrapperBounds.top) ({ top: top, left: left } = $dcba559a41e7cc63$var$getCoordsBelowSelection(bottomCoords, toolbarRect));
        let leftCoord = Math.max(0, left - wrapperBounds.left);
        if (leftCoord + toolbarRect.width > wrapperBounds.width) {
            const scrollbarWidth = $dcba559a41e7cc63$var$MAXIMUM_BROWSER_SCROLLBAR_WIDTH;
            leftCoord = Math.max(0, wrapperBounds.width - (toolbarRect.width + scrollbarWidth));
        }
        // remap positions from browser document to wrapperBounds
        return {
            top: top - wrapperBounds.top + scrollWrapper.scrollTop,
            left: leftCoord
        };
    };
/**
 * Returns the coordintes at the bottom the selection.
 */ const $dcba559a41e7cc63$var$getCoordsBelowSelection = (bottomCoords, toolbarRect)=>{
    return {
        top: (bottomCoords.top || 0) + toolbarRect.height / 1.15,
        left: bottomCoords.right - toolbarRect.width / 2
    };
};
const $dcba559a41e7cc63$var$cellSelectionToolbarOffsetTop = 10;
const $dcba559a41e7cc63$var$scrollbarWidth = 20;
const $dcba559a41e7cc63$var$offsetTopOnColumnSelection = 4;
const $dcba559a41e7cc63$export$2d9cc331fb808a87 = (toolbarTitle)=>(editorView, nextPos)=>{
        const toolbar = document.querySelector(`div[aria-label="${toolbarTitle}"]`);
        if (!toolbar) return nextPos;
        const { selection: selection } = editorView.state;
        if (!(selection instanceof (0, $cwzAY.CellSelection))) return nextPos;
        const { $anchorCell: $anchorCell, $headCell: $headCell } = selection;
        const domAtPos = editorView.domAtPos.bind(editorView);
        const anchorCellDOM = (0, $BmspC.findDomRefAtPos)($anchorCell.pos, domAtPos);
        const headCellDOM = (0, $BmspC.findDomRefAtPos)($headCell.pos, domAtPos);
        if (!(anchorCellDOM instanceof HTMLElement) || !(headCellDOM instanceof HTMLElement)) return nextPos;
        const anchorCellRect = anchorCellDOM.getBoundingClientRect();
        const headCellRect = headCellDOM.getBoundingClientRect();
        const toolbarRect = toolbar.getBoundingClientRect();
        let top;
        if (headCellRect.top <= anchorCellRect.top) // Display Selection toolbar at the top of the selection
        top = headCellRect.top - toolbarRect.height - $dcba559a41e7cc63$var$cellSelectionToolbarOffsetTop;
        else // Display Selection toolbar at the bottom of the selection
        top = headCellRect.bottom + $dcba559a41e7cc63$var$cellSelectionToolbarOffsetTop;
        // scroll wrapper for full page, fall back to document body
        // Ignored via go/ees007
        // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
        // TODO: look into using getScrollGutterOptions()
        const scrollWrapper = editorView.dom.closest('.fabric-editor-popup-scroll-parent') || document.body;
        const wrapperBounds = scrollWrapper.getBoundingClientRect();
        // Place toolbar below selection if not sufficient space above
        if (top < wrapperBounds.top && headCellRect.top <= anchorCellRect.top) top = anchorCellRect.bottom + $dcba559a41e7cc63$var$cellSelectionToolbarOffsetTop;
        let left;
        if (headCellRect.left < anchorCellRect.left) left = headCellRect.left;
        else if (headCellRect.left === anchorCellRect.left) left = headCellRect.left + headCellRect.width / 2;
        else left = headCellRect.right;
        // If a user selected multiple columns via clicking on a drag handle
        // (clicking first on the left column and then shift clicking on the right column),
        // the $headcell stays in place and $anchorcell changes position. If they clicked on the right column
        // and then shift clicked on the left, the $headCell will change while $anchor stays in place.
        // Where is no way to know if user was dragging to select the cells or clicking on the drag handle.
        // So if all cells in columns are selected, we will align the Text Formatting toolbar
        // relative to center of the selected area.
        if (selection.isColSelection()) {
            if (headCellRect.left < anchorCellRect.left) left = headCellRect.left + (anchorCellRect.right - headCellRect.left) / 2;
            else if (headCellRect.left === anchorCellRect.left) left;
            else left = anchorCellRect.left + (headCellRect.right - anchorCellRect.left) / 2;
            // When column is selected, adjust top position to ensure that the toolbar does not
            // touch column drag handle
            top = top - $dcba559a41e7cc63$var$offsetTopOnColumnSelection;
        }
        let adjustedLeft = Math.max(0, left - toolbarRect.width / 2 - wrapperBounds.left);
        if (adjustedLeft + toolbarRect.width > wrapperBounds.width) adjustedLeft = Math.max(0, wrapperBounds.width - (toolbarRect.width + $dcba559a41e7cc63$var$scrollbarWidth));
        // If the toolbar is to be placed at the bottom of the selection (it happens when
        // there is no sufficient space above) and the bottom of the selection is not in the view,
        // place the toolbar at the bottom of the visible part of selection
        if (selection.isColSelection() && top + toolbarRect.height > wrapperBounds.bottom) top = top - (top - wrapperBounds.bottom) - (toolbarRect.height + 2 * $dcba559a41e7cc63$var$cellSelectionToolbarOffsetTop);
        return {
            top: top - wrapperBounds.top + scrollWrapper.scrollTop,
            left: adjustedLeft
        };
    };

});

parcelRegister("aP4il", function(module, exports) {

$parcel$export(module.exports, "findNodePosByLocalIds", () => $0fd236b6b958ecf0$export$947fc26275418e36);
const $0fd236b6b958ecf0$export$947fc26275418e36 = (state, ids, option = {})=>{
    if (ids.length === 0) return [];
    const nodes = [];
    const localIdSet = new Set(ids);
    if (option.includeDocNode && localIdSet.has(state.doc.attrs?.localId)) nodes.push({
        node: state.doc,
        pos: 0
    });
    state.doc.descendants((node, pos)=>{
        if (localIdSet.has(node.attrs?.localId)) nodes.push({
            node: node,
            pos: pos
        });
        // stop traversing once we found all the nodes
        return localIdSet.size !== nodes.length;
    });
    return nodes;
};

});


parcelRegister("lRqrn", function(module, exports) {

$parcel$export(module.exports, "EVENT", () => $f794ae6f9c3610c1$export$e39a34cfd532e15);
$parcel$export(module.exports, "EVENT_SUBJECT", () => $f794ae6f9c3610c1$export$97c6cb64ce06a88a);
var $f794ae6f9c3610c1$export$e39a34cfd532e15 = /*#__PURE__*/ function(EVENT) {
    EVENT["CREATED"] = "created";
    EVENT["UPDATED"] = "updated";
    EVENT["DELETED"] = "deleted";
    return EVENT;
}({});
var $f794ae6f9c3610c1$export$97c6cb64ce06a88a = /*#__PURE__*/ function(EVENT_SUBJECT) {
    EVENT_SUBJECT["LINK"] = "link";
    EVENT_SUBJECT["DATASOURCE"] = "datasource";
    return EVENT_SUBJECT;
}({});

});

parcelRegister("3o3Tb", function(module, exports) {

$parcel$export(module.exports, "getNodeSubject", () => $0ec7da70acd2cfb3$export$d3d4c2526aede29a);
$parcel$export(module.exports, "appearanceForLink", () => $0ec7da70acd2cfb3$export$599e1b655555ab1d);
$parcel$export(module.exports, "getUrl", () => $0ec7da70acd2cfb3$export$94df0e59ebebf4a7);
$parcel$export(module.exports, "getNodeContext", () => $0ec7da70acd2cfb3$export$c63a892fcfc539bc);
$parcel$export(module.exports, "findAtPositions", () => $0ec7da70acd2cfb3$export$7ea2145b3909e5c6);
$parcel$export(module.exports, "findInNodeRange", () => $0ec7da70acd2cfb3$export$dbc52ec0d340ce50);
$parcel$export(module.exports, "areSameNodes", () => $0ec7da70acd2cfb3$export$1f3592a520a7960d);

var $gXgTX = parcelRequire("gXgTX");

var $lRqrn = parcelRequire("lRqrn");
function $0ec7da70acd2cfb3$export$962cfe99b8da8614(node) {
    return 'datasource' in node.attrs && !!node.attrs.datasource;
}
const $0ec7da70acd2cfb3$export$26ada819291bd8df = (node)=>{
    if ($0ec7da70acd2cfb3$export$962cfe99b8da8614(node)) return false;
    if (!!(0, $gXgTX.appearanceForNodeType)(node.type)) return true;
    return $0ec7da70acd2cfb3$var$hasLinkMark(node);
};
function $0ec7da70acd2cfb3$export$d3d4c2526aede29a(node) {
    if ($0ec7da70acd2cfb3$export$962cfe99b8da8614(node)) return (0, $lRqrn.EVENT_SUBJECT).DATASOURCE;
    if ($0ec7da70acd2cfb3$export$26ada819291bd8df(node)) return (0, $lRqrn.EVENT_SUBJECT).LINK;
    return null;
}
function $0ec7da70acd2cfb3$export$599e1b655555ab1d(node) {
    const appearance = (0, $gXgTX.appearanceForNodeType)(node.type);
    if (appearance) return appearance;
    return 'url';
}
const $0ec7da70acd2cfb3$var$getLinkMark = (node)=>{
    if (node.marks) for(let i = 0; i < node.marks.length; i++){
        const mark = node.marks[i];
        if (mark.type.name === 'link') return mark;
    }
};
const $0ec7da70acd2cfb3$var$hasLinkMark = (node)=>{
    return !!$0ec7da70acd2cfb3$var$getLinkMark(node);
};
function $0ec7da70acd2cfb3$export$94df0e59ebebf4a7(node) {
    return node.attrs?.url ?? $0ec7da70acd2cfb3$var$getLinkMark(node)?.attrs?.href;
}
const $0ec7da70acd2cfb3$export$c63a892fcfc539bc = (doc, pos)=>{
    const $pos = doc.resolve(pos);
    const maxDepth = 3;
    for(let i = 0; i <= maxDepth; i++){
        const node = $pos.node($pos.depth - i);
        if (node && node.type.name !== 'paragraph') return node.type.name;
    }
    return 'unknown';
};
const $0ec7da70acd2cfb3$export$7ea2145b3909e5c6 = (tr, positions)=>{
    const entities = [];
    for(let i = 0; i < positions.length; i++){
        const pos = positions[i];
        const node = tr.doc.nodeAt(pos);
        if (!node) continue;
        const nodeContext = $0ec7da70acd2cfb3$export$c63a892fcfc539bc(tr.doc, pos);
        entities.push({
            pos: pos,
            node: node,
            nodeContext: nodeContext
        });
    }
    return entities;
};
const $0ec7da70acd2cfb3$export$dbc52ec0d340ce50 = (doc, from, to, predicate)=>{
    const entities = [];
    doc.nodesBetween(from, to, (node, pos)=>{
        if (predicate(node)) {
            const entirelyInRange = pos >= from && pos + node.nodeSize <= to;
            if (entirelyInRange) {
                const nodeContext = $0ec7da70acd2cfb3$export$c63a892fcfc539bc(doc, pos);
                entities.push({
                    pos: pos,
                    node: node,
                    nodeContext: nodeContext
                });
            }
        }
    });
    return entities;
};
const $0ec7da70acd2cfb3$export$1f3592a520a7960d = (setA, setB)=>{
    if (setA.length !== setB.length) return false;
    for(let i = 0; i < setA.length; i++){
        const a = setA[i];
        const b = setB[i];
        if ($0ec7da70acd2cfb3$export$94df0e59ebebf4a7(a.node) !== $0ec7da70acd2cfb3$export$94df0e59ebebf4a7(b.node) || $0ec7da70acd2cfb3$export$599e1b655555ab1d(a.node) !== $0ec7da70acd2cfb3$export$599e1b655555ab1d(b.node)) return false;
    }
    return true;
};

});


parcelRegister("37WZl", function(module, exports) {

$parcel$export(module.exports, "getDatasource", () => $9f75cf3afb5df461$export$32844f9f273856e4);
$parcel$export(module.exports, "isDatasourceTableLayout", () => $9f75cf3afb5df461$export$8467cbb601c13bfc);

var $BmspC = parcelRequire("BmspC");

var $gXgTX = parcelRequire("gXgTX");

var $kYlvy = parcelRequire("kYlvy");
const $9f75cf3afb5df461$export$32844f9f273856e4 = (editorView)=>{
    const { selection: selection, schema: schema } = editorView.state;
    const { blockCard: blockCard } = schema.nodes;
    const findResult = (0, $BmspC.findSelectedNodeOfType)([
        blockCard
    ])(selection);
    if (findResult && (0, $gXgTX.isDatasourceNode)(findResult.node)) return {
        ...findResult,
        node: findResult.node
    };
    return {
        node: undefined,
        pos: undefined
    };
};
const $9f75cf3afb5df461$export$8467cbb601c13bfc = (layout)=>{
    return (0, $kYlvy.DATASOURCE_TABLE_LAYOUTS).some((l)=>l === layout);
};

});
parcelRegister("kYlvy", function(module, exports) {

$parcel$export(module.exports, "DATASOURCE_TABLE_LAYOUTS", () => $2fe98f27d6420e0f$export$3f155c85880510c8);
const $2fe98f27d6420e0f$export$3f155c85880510c8 = [
    'full-width',
    'center',
    'wide'
];

});


parcelRegister("cPbXA", function(module, exports) {

$parcel$export(module.exports, "default", () => $915da1eebef7d82e$export$2e2bcd8739ae039);
const $915da1eebef7d82e$var$queue = (state, action)=>{
    return {
        ...state,
        requests: state.requests.concat(action.requests)
    };
};
const $915da1eebef7d82e$var$resolve = (state, action)=>{
    const requests = state.requests.reduce((requests, request)=>{
        if (request.url !== action.url) requests.push(request);
        return requests;
    }, []);
    return {
        ...state,
        requests: requests
    };
};
const $915da1eebef7d82e$var$register = (state, action)=>{
    return {
        ...state,
        cards: state.cards.filter((card)=>card.pos !== action.info.pos).concat(action.info)
    };
};
const $915da1eebef7d82e$var$removeCard = (state, action)=>{
    return {
        ...state,
        cards: state.cards.filter((card)=>card.id !== action.info.id)
    };
};
const $915da1eebef7d82e$var$setProvider = (state, action)=>{
    return {
        ...state,
        provider: action.provider
    };
};
const $915da1eebef7d82e$var$setCardLayout = (state, action)=>{
    return {
        ...state,
        layout: action.layout
    };
};
const $915da1eebef7d82e$var$setDatasourceTableRef = (state, action)=>{
    return {
        ...state,
        datasourceTableRef: action.datasourceTableRef
    };
};
const $915da1eebef7d82e$var$setCardLayoutDatasourceTableRef = (state, action)=>{
    return {
        ...state,
        datasourceTableRef: action.datasourceTableRef,
        layout: action.layout
    };
};
const $915da1eebef7d82e$var$registerEvents = (state, action)=>{
    return {
        ...state,
        smartLinkEvents: action.smartLinkEvents
    };
};
const $915da1eebef7d82e$var$setLinkToolbar = (state, action)=>{
    return {
        ...state,
        showLinkingToolbar: action.type === 'SHOW_LINK_TOOLBAR'
    };
};
const $915da1eebef7d82e$var$showDatasourceModal = (state, action)=>{
    return {
        ...state,
        showDatasourceModal: true,
        datasourceModalType: action.type === 'SHOW_DATASOURCE_MODAL' ? action.modalType : undefined
    };
};
const $915da1eebef7d82e$var$hideDatasourceModal = (state)=>{
    return {
        ...state,
        showDatasourceModal: false,
        datasourceModalType: undefined
    };
};
const $915da1eebef7d82e$var$clearOverlayCandidate = (state)=>{
    return {
        ...state,
        overlayCandidatePosition: undefined
    };
};
const $915da1eebef7d82e$var$registerRemoveOverlayOnInsertedLink = (state, action)=>{
    return {
        ...state,
        cards: action.info ? state.cards.filter((card)=>card.pos !== action.info?.pos).concat(action.info) : state.cards,
        removeOverlay: action.callback
    };
};
const $915da1eebef7d82e$var$setDatasourceStash = (state, action)=>{
    return {
        ...state,
        datasourceStash: {
            ...state.datasourceStash,
            [action.datasourceStash.url]: {
                views: action.datasourceStash.views
            }
        }
    };
};
const $915da1eebef7d82e$var$removeDatasourceStash = (state, action)=>{
    const { [action.url]: _, ...datasourceStash } = state.datasourceStash;
    return {
        ...state,
        datasourceStash: datasourceStash
    };
};
var $915da1eebef7d82e$export$2e2bcd8739ae039 = (state, action)=>{
    switch(action.type){
        case 'QUEUE':
            return $915da1eebef7d82e$var$queue(state, action);
        case 'SET_PROVIDER':
            return $915da1eebef7d82e$var$setProvider(state, action);
        case 'RESOLVE':
            return $915da1eebef7d82e$var$resolve(state, action);
        case 'REGISTER':
            return $915da1eebef7d82e$var$register(state, action);
        case 'REMOVE_CARD':
            return $915da1eebef7d82e$var$removeCard(state, action);
        case 'REGISTER_EVENTS':
            return $915da1eebef7d82e$var$registerEvents(state, action);
        case 'SET_DATASOURCE_TABLE_REF':
            return $915da1eebef7d82e$var$setDatasourceTableRef(state, action);
        case 'SET_CARD_LAYOUT':
            return $915da1eebef7d82e$var$setCardLayout(state, action);
        case 'SET_CARD_LAYOUT_AND_DATASOURCE_TABLE_REF':
            return $915da1eebef7d82e$var$setCardLayoutDatasourceTableRef(state, action);
        case 'SHOW_LINK_TOOLBAR':
        case 'HIDE_LINK_TOOLBAR':
            return $915da1eebef7d82e$var$setLinkToolbar(state, action);
        case 'SHOW_DATASOURCE_MODAL':
            return $915da1eebef7d82e$var$showDatasourceModal(state, action);
        case 'HIDE_DATASOURCE_MODAL':
            return $915da1eebef7d82e$var$hideDatasourceModal(state);
        case 'CLEAR_OVERLAY_CANDIDATE':
            return $915da1eebef7d82e$var$clearOverlayCandidate(state);
        case 'REGISTER_REMOVE_OVERLAY_ON_INSERTED_LINK':
            return $915da1eebef7d82e$var$registerRemoveOverlayOnInsertedLink(state, action);
        case 'SET_DATASOURCE_STASH':
            return $915da1eebef7d82e$var$setDatasourceStash(state, action);
        case 'REMOVE_DATASOURCE_STASH':
            return $915da1eebef7d82e$var$removeDatasourceStash(state, action);
    }
};

});

parcelRegister("9SMdd", function(module, exports) {

$parcel$export(module.exports, "resolveWithProvider", () => $ebd33bedd2a57f47$export$2007d0af08977743);
$parcel$export(module.exports, "handleProvider", () => $ebd33bedd2a57f47$export$96766f42428c9e7f);

var $7WlTe = parcelRequire("7WlTe");parcelRequire("3ADzg");
var $bnAxN = parcelRequire("bnAxN");

var $ecNk4 = parcelRequire("ecNk4");

var $4AOcQ = parcelRequire("4AOcQ");
const $ebd33bedd2a57f47$var$isFreshlyPastedOnNewLine = (view)=>{
    const { selection: selection } = view.state;
    const { $cursor: $cursor, $anchor: $anchor } = selection;
    if (!$cursor) return false;
    if (!(0, $bnAxN.hasDocAsParent)($anchor)) return false;
    const node = $cursor.node();
    if (!node) return false;
    if (node.type.name !== 'paragraph') return false;
    return node.childCount === 1; // The pasted blue link itself
};
const $ebd33bedd2a57f47$export$2007d0af08977743 = (view, provider, request, options, editorAnalyticsApi, createAnalyticsEvent)=>{
    const isEmbedFriendlyLocation = $ebd33bedd2a57f47$var$isFreshlyPastedOnNewLine(view);
    // When user manually changes appearance from blue link to smart link, we should respect that,
    const shouldForceAppearance = // This flag is set to true only in one place atm:
    // packages/editor/editor-core/src/plugins/card/pm-plugins/doc.ts @ convertHyperlinkToSmartCard
    // Which is used when user switching from URL to smart link appearance.
    !!request.shouldReplaceLink;
    const handleResolve = provider.resolve(request.url, request.appearance, shouldForceAppearance, isEmbedFriendlyLocation).then($ebd33bedd2a57f47$var$handleResolved(view, request, editorAnalyticsApi, createAnalyticsEvent, options), $ebd33bedd2a57f47$var$handleRejected(view, request, editorAnalyticsApi));
    return handleResolve;
};
const $ebd33bedd2a57f47$var$updateCardType = (resolvedCard, options)=>{
    if (resolvedCard.type === 'blockCard' && 'datasource' in resolvedCard.attrs) {
        const datasourceId = resolvedCard.attrs.datasource.id;
        if (!options.allowDatasource || !(0, $7WlTe.canRenderDatasource)(datasourceId)) {
            delete resolvedCard.attrs.datasource;
            resolvedCard.type = 'inlineCard';
            return;
        }
    }
    if (resolvedCard?.type === 'blockCard' && !options.allowBlockCards || resolvedCard?.type === 'embedCard' && !options.allowEmbeds) {
        // clean out the 'layout' attr from an embedCard type that should be transformed into the inlineCard type.
        if (resolvedCard.type === 'embedCard') // eslint-disable-next-line @typescript-eslint/no-explicit-any
        delete resolvedCard.attrs.layout;
        resolvedCard.type = 'inlineCard';
    }
};
const $ebd33bedd2a57f47$var$handleResolved = (view, request, editorAnalyticsApi, createAnalyticsEvent, options)=>(resolvedCard)=>{
        $ebd33bedd2a57f47$var$updateCardType(resolvedCard, options);
        (0, $4AOcQ.replaceQueuedUrlWithCard)(request.url, resolvedCard, request.analyticsAction, editorAnalyticsApi, createAnalyticsEvent)(view.state, view.dispatch);
        return resolvedCard;
    };
const $ebd33bedd2a57f47$var$handleRejected = (view, request, editorAnalyticsApi)=>()=>{
        (0, $4AOcQ.handleFallbackWithAnalytics)(request, editorAnalyticsApi)(view.state, view.dispatch);
    };
const $ebd33bedd2a57f47$export$96766f42428c9e7f = (_, provider, view)=>{
    if (!provider) return;
    provider.then((cardProvider)=>{
        const { state: state, dispatch: dispatch } = view;
        dispatch((0, $ecNk4.setProvider)(cardProvider)(state.tr));
    });
};

});


parcelRegister("2smZh", function(module, exports) {

$parcel$export(module.exports, "createEventsQueue", () => $c187c9fec5b70a04$export$5115a388c364848d);
const $c187c9fec5b70a04$export$5115a388c364848d = ()=>{
    const queue = [];
    const subscribers = new Set();
    const subscribe = (subscriber)=>{
        subscribers.add(subscriber);
        return ()=>{
            subscribers.delete(subscriber);
        };
    };
    const push = (...events)=>{
        queue.push(...events);
    };
    const flush = ()=>{
        while(queue.length){
            const event = queue.shift();
            if (event) subscribers.forEach((subscriber)=>{
                subscriber(event);
            });
        }
    };
    const getSize = ()=>queue.length;
    return {
        push: push,
        flush: flush,
        subscribe: subscribe,
        getSize: getSize
    };
};

});

parcelRegister("5qTHh", function(module, exports) {

$parcel$export(module.exports, "default", () => $33b3b092bcc326ae$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kLQ9a = parcelRequire("kLQ9a");
var $bSToC = parcelRequire("bSToC");
var $cxXTK = parcelRequire("cxXTK");

var $k9y0J = parcelRequire("k9y0J");
var $7BBxG = parcelRequire("7BBxG");
var $7KhEE = parcelRequire("7KhEE");

var $9kfy2 = parcelRequire("9kfy2");

var $92xoS = parcelRequire("92xoS");

var $biUbR = parcelRequire("biUbR");

var $4aqeJ = parcelRequire("4aqeJ");
const $33b3b092bcc326ae$var$selector = (states)=>{
    return {
        cardState: undefined,
        showDatasourceModal: states.cardState?.showDatasourceModal,
        datasourceModalType: states.cardState?.datasourceModalType
    };
};
const $33b3b092bcc326ae$var$useSharedState = (0, $kLQ9a.sharedPluginStateHookMigratorFactory)((pluginInjectionApi)=>{
    return (0, $cxXTK.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'card'
    ], $33b3b092bcc326ae$var$selector);
}, (pluginInjectionApi)=>{
    const { cardState: cardState } = (0, $bSToC.useSharedPluginState)(pluginInjectionApi, [
        'card'
    ]);
    return {
        cardState: cardState,
        showDatasourceModal: cardState?.showDatasourceModal,
        datasourceModalType: cardState?.datasourceModalType
    };
});
const $33b3b092bcc326ae$var$ModalWithState = ({ api: api, editorView: editorView })=>{
    const cardContext = (0, $9kfy2.useSmartLinkContext)();
    const { cardState: cardState, showDatasourceModal: showDatasourceModal, datasourceModalType: datasourceModalType } = $33b3b092bcc326ae$var$useSharedState(api);
    if (!cardState && (0, $92xoS.editorExperiment)('platform_editor_usesharedpluginstateselector', false)) return null;
    if (!showDatasourceModal || !datasourceModalType) return null;
    const { datasourceId: datasourceId, componentType: componentType } = $33b3b092bcc326ae$export$aeed689b34941117[datasourceModalType];
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $biUbR.DatasourceErrorBoundary), {
        view: editorView,
        datasourceModalType: datasourceModalType,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4aqeJ.DatasourceModal), {
            view: editorView,
            cardContext: cardContext,
            datasourceId: datasourceId,
            componentType: componentType
        })
    });
};
const $33b3b092bcc326ae$var$SafeModalWithState = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo(({ api: api, editorView: editorView })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9kfy2.EditorSmartCardProviderValueGuard), {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($33b3b092bcc326ae$var$ModalWithState, {
            api: api,
            editorView: editorView
        })
    });
});
const $33b3b092bcc326ae$export$aeed689b34941117 = {
    jira: {
        componentType: (0, $7KhEE.default),
        datasourceId: (0, $7KhEE.JIRA_LIST_OF_LINKS_DATASOURCE_ID)
    },
    'confluence-search': {
        componentType: (0, $7BBxG.default),
        datasourceId: (0, $7BBxG.CONFLUENCE_SEARCH_DATASOURCE_ID)
    },
    assets: {
        componentType: (0, $k9y0J.default),
        datasourceId: (0, $k9y0J.ASSETS_LIST_OF_LINKS_DATASOURCE_ID)
    }
};
var $33b3b092bcc326ae$export$2e2bcd8739ae039 = $33b3b092bcc326ae$var$SafeModalWithState;

});
parcelRegister("4aqeJ", function(module, exports) {

$parcel$export(module.exports, "DatasourceModal", () => $bb039312424500f8$export$95702e90d329951a);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $3lIcL = parcelRequire("3lIcL");

var $ecNk4 = parcelRequire("ecNk4");

var $4AOcQ = parcelRequire("4AOcQ");

var $XsiSM = parcelRequire("XsiSM");
const $bb039312424500f8$export$95702e90d329951a = ({ view: view, cardContext: cardContext, datasourceId: defaultDatasourceId, componentType: Component })=>{
    const { state: state } = view;
    const existingNode = $bb039312424500f8$var$getExistingNode(state);
    const { dispatch: dispatch, state: { tr: transaction } } = view;
    const onClose = (0, $eJOHy.useCallback)(()=>{
        dispatch((0, $ecNk4.hideDatasourceModal)(transaction));
    }, [
        dispatch,
        transaction
    ]);
    const updateAdf = $bb039312424500f8$var$useUpdateAdf(view, existingNode);
    const isRegularCardNode = !!(existingNode && !existingNode?.attrs?.datasource);
    const { id: datasourceId = defaultDatasourceId, views: views = [], parameters: nodeParameters } = existingNode?.attrs?.datasource || {};
    const { visibleColumnKeys: visibleColumnKeys, wrappedColumnKeys: wrappedColumnKeys, columnCustomSizes: columnCustomSizes } = $bb039312424500f8$var$resolveColumnsConfig(views);
    const { parameters: parameters, ready: ready } = (0, $XsiSM.useFetchDatasourceInfo)({
        isRegularCardNode: isRegularCardNode,
        url: existingNode?.attrs.url,
        cardContext: cardContext,
        nodeParameters: nodeParameters
    });
    if (!ready) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
        datasourceId: datasourceId,
        viewMode: isRegularCardNode ? 'inline' : 'table',
        parameters: parameters,
        url: existingNode?.attrs.url,
        visibleColumnKeys: visibleColumnKeys,
        columnCustomSizes: columnCustomSizes,
        wrappedColumnKeys: wrappedColumnKeys,
        onCancel: onClose,
        onInsert: updateAdf
    });
};
const $bb039312424500f8$var$useUpdateAdf = (view, existingNode)=>{
    return (0, $eJOHy.useCallback)((newAdf, analyticEvent)=>{
        if (analyticEvent) analyticEvent.update((payload)=>({
                ...payload,
                attributes: {
                    ...payload.attributes,
                    inputMethod: 'datasource_config'
                }
            }));
        if (existingNode) (0, $4AOcQ.updateCardViaDatasource)({
            state: view.state,
            node: existingNode,
            newAdf: newAdf,
            view: view,
            sourceEvent: analyticEvent
        });
        else (0, $4AOcQ.insertDatasource)(view.state, newAdf, view, analyticEvent);
    }, [
        existingNode,
        view
    ]);
};
const $bb039312424500f8$var$getExistingNode = (state)=>{
    const { selection: selection } = state;
    let existingNode;
    // Check if the selection contains a link mark
    const isLinkMark = state.doc.resolve(selection.from).marks().some((mark)=>mark.type === state.schema.marks.link);
    // When selection is a TextNode and a link Mark is present return that node
    if (selection instanceof (0, $3lIcL.NodeSelection)) existingNode = selection.node;
    else if (isLinkMark) existingNode = state.doc.nodeAt(selection.from) ?? undefined;
    return existingNode;
};
const $bb039312424500f8$var$resolveColumnsConfig = (views)=>{
    const [tableView] = views;
    const visibleColumnKeys = [];
    const wrappedColumnKeys = [];
    const columnCustomSizes = {};
    const columns = tableView?.properties?.columns;
    if (columns) for (const { key: key, width: width, isWrapped: isWrapped } of columns){
        visibleColumnKeys.push(key);
        if (width) columnCustomSizes[key] = width;
        if (isWrapped) wrappedColumnKeys.push(key);
    }
    return {
        visibleColumnKeys: visibleColumnKeys,
        wrappedColumnKeys: wrappedColumnKeys,
        columnCustomSizes: columnCustomSizes
    };
};

});


parcelRegister("8gCT1", function(module, exports) {

$parcel$export(module.exports, "EditorLinkingPlatformAnalytics", () => $577440179ad2723e$export$c083a9ed3df8f5ac);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $9kfy2 = parcelRequire("9kfy2");

var $knfyn = parcelRequire("knfyn");

var $1YIrv = parcelRequire("1YIrv");

var $1JOoi = parcelRequire("1JOoi");
class $577440179ad2723e$export$c083a9ed3df8f5ac extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).PureComponent {
    render() {
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9kfy2.EditorSmartCardProvider), {
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9kfy2.EditorSmartCardProviderValueGuard), {
                children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $knfyn.EditorAnalyticsContext), {
                    editorView: this.props.editorView,
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1JOoi.LinkEventsBinding), {
                            ...this.props
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1YIrv.DatasourceEventsBinding), {
                            ...this.props
                        })
                    ]
                })
            })
        });
    }
}

});
parcelRegister("1YIrv", function(module, exports) {

$parcel$export(module.exports, "DatasourceEventsBinding", () => $6a086352ad0326a1$export$bddcbec746c26287);

var $eJOHy = parcelRequire("eJOHy");

var $5EMLi = parcelRequire("5EMLi");

var $6AXE6 = parcelRequire("6AXE6");

var $lRqrn = parcelRequire("lRqrn");

var $W7NLq = parcelRequire("W7NLq");
function $6a086352ad0326a1$var$getDatasourceDisplay(datasourceAttrs) {
    return datasourceAttrs.datasource.views[0]?.type;
}
function $6a086352ad0326a1$var$getDisplayedColumnCount(datasourceAttrs) {
    return datasourceAttrs.datasource.views[0]?.properties?.columns?.length ?? undefined;
}
function $6a086352ad0326a1$var$getSearchMethod(creationMethod, metadata) {
    if (creationMethod === 'editor_paste' || creationMethod === 'editor_type') return '';
    const { sourceEvent: sourceEvent } = metadata;
    if (sourceEvent instanceof (0, $5EMLi.default)) {
        const event = sourceEvent;
        return event.payload.attributes?.searchMethod;
    }
    return 'unknown';
}
function $6a086352ad0326a1$var$getAnalyticAttributesFromNode(datasourceAttrs, metadata) {
    const { url: url, datasource: { id: datasourceId, parameters: parameters } } = datasourceAttrs;
    const display = $6a086352ad0326a1$var$getDatasourceDisplay(datasourceAttrs);
    let inputMethod = '';
    let actions = [];
    if (metadata.inputMethod) inputMethod = (0, $W7NLq.getMethod)(metadata) ?? '';
    else if (metadata.sourceEvent instanceof (0, $5EMLi.default)) {
        inputMethod = metadata.sourceEvent.payload.attributes?.inputMethod;
        actions = metadata.sourceEvent.payload.attributes?.actions;
    }
    const displayedColumnCount = $6a086352ad0326a1$var$getDisplayedColumnCount(datasourceAttrs);
    const searchMethod = $6a086352ad0326a1$var$getSearchMethod(inputMethod, metadata);
    return {
        actions: actions,
        inputMethod: inputMethod,
        datasourceId: datasourceId,
        display: display,
        displayedColumnCount: displayedColumnCount,
        parameters: parameters,
        searchMethod: searchMethod,
        url: url
    };
}
const $6a086352ad0326a1$export$bddcbec746c26287 = ({ cardPluginEvents: cardPluginEvents })=>{
    const { datasourceCreated: datasourceCreated, datasourceUpdated: datasourceUpdated, datasourceDeleted: datasourceDeleted } = (0, $6AXE6.useDatasourceLifecycleAnalytics)();
    const eventHandlers = (0, $eJOHy.useMemo)(()=>{
        return {
            [(0, $lRqrn.EVENT).CREATED]: ({ node: node, nodeContext: nodeContext, ...metadata })=>{
                const attributes = $6a086352ad0326a1$var$getAnalyticAttributesFromNode(node.attrs, metadata);
                const { actions: actions, inputMethod: inputMethod, datasourceId: datasourceId, display: display, displayedColumnCount: displayedColumnCount, parameters: parameters, searchMethod: searchMethod, url: url } = attributes;
                datasourceCreated({
                    datasourceId: datasourceId,
                    parameters: parameters,
                    url: url
                }, null, {
                    actions: actions,
                    creationMethod: inputMethod,
                    display: display,
                    ...typeof displayedColumnCount === 'number' ? {
                        displayedColumnCount: displayedColumnCount
                    } : {},
                    nodeContext: nodeContext,
                    searchMethod: searchMethod
                });
            },
            [(0, $lRqrn.EVENT).UPDATED]: ({ node: node, nodeContext: nodeContext, ...metadata })=>{
                const attributes = $6a086352ad0326a1$var$getAnalyticAttributesFromNode(node.attrs, metadata);
                const { actions: actions, datasourceId: datasourceId, display: display, displayedColumnCount: displayedColumnCount, inputMethod: inputMethod, parameters: parameters, searchMethod: searchMethod, url: url } = attributes;
                datasourceUpdated({
                    datasourceId: datasourceId,
                    parameters: parameters,
                    url: url
                }, null, {
                    actions: actions,
                    display: display,
                    displayedColumnCount: displayedColumnCount,
                    nodeContext: nodeContext,
                    searchMethod: searchMethod,
                    updateMethod: inputMethod
                });
            },
            [(0, $lRqrn.EVENT).DELETED]: ({ node: node, nodeContext: nodeContext, ...metadata })=>{
                const attributes = $6a086352ad0326a1$var$getAnalyticAttributesFromNode(node.attrs, metadata);
                const { datasourceId: datasourceId, display: display, displayedColumnCount: displayedColumnCount, inputMethod: inputMethod, parameters: parameters, searchMethod: searchMethod, url: url } = attributes;
                datasourceDeleted({
                    datasourceId: datasourceId,
                    parameters: parameters,
                    url: url
                }, null, {
                    deleteMethod: inputMethod,
                    display: display,
                    displayedColumnCount: displayedColumnCount,
                    nodeContext: nodeContext,
                    searchMethod: searchMethod
                });
            }
        };
    }, [
        datasourceCreated,
        datasourceUpdated,
        datasourceDeleted
    ]);
    /**
	 * Subscribe to datasource events
	 */ (0, $eJOHy.useEffect)(()=>{
        const unsubscribe = cardPluginEvents.subscribe(({ event: event, subject: subject, data: data })=>{
            if (subject === (0, $lRqrn.EVENT_SUBJECT).DATASOURCE) eventHandlers[event](data);
        });
        return ()=>unsubscribe();
    }, [
        eventHandlers,
        cardPluginEvents
    ]);
    return null;
};

});
parcelRegister("6AXE6", function(module, exports) {

$parcel$export(module.exports, "useSmartLinkLifecycleAnalytics", () => $2a91e04be98b0368$export$612752b1e088a45e);
$parcel$export(module.exports, "useDatasourceLifecycleAnalytics", () => $2a91e04be98b0368$export$c82e48d9fd97c55b);

var $eJOHy = parcelRequire("eJOHy");

var $5fWw9 = parcelRequire("5fWw9");
var $ftN6c = parcelRequire("ftN6c");

var $9kfy2 = parcelRequire("9kfy2");


var $cVDam = parcelRequire("cVDam");

var $1Q8LJ = parcelRequire("1Q8LJ");

var $clMJd = parcelRequire("clMJd");

const $2a91e04be98b0368$export$612752b1e088a45e = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { store: store, connections: { client: client } } = (0, $9kfy2.useSmartLinkContext)();
    return (0, $eJOHy.useMemo)(()=>{
        const factory = (action)=>(...args)=>{
                try {
                    (0, $1Q8LJ.runWhenIdle)(()=>{
                        (0, $5fWw9.default)((0, $c3e0cb3b46228483$export$3f072f06b90c3985))((0, $cVDam.default)('operational.fireAnalyticEvent.commenced', {
                            action: action
                        }))(createAnalyticsEvent);
                    });
                    (0, $1Q8LJ.runWhenIdle)(async ()=>{
                        const { default: fireEvent } = await (parcelRequire("gfMR6"));
                        fireEvent(action, createAnalyticsEvent, client, store)(...args);
                    });
                } catch (error) {
                    (0, $5fWw9.default)((0, $c3e0cb3b46228483$export$3f072f06b90c3985))((0, $cVDam.default)('operational.fireAnalyticEvent.failed', {
                        error: error instanceof Error ? error.toString() : '',
                        action: action
                    }))(createAnalyticsEvent);
                }
            };
        return {
            linkCreated: factory('created'),
            linkUpdated: factory('updated'),
            linkDeleted: factory('deleted')
        };
    }, [
        client,
        store,
        createAnalyticsEvent
    ]);
};

const $2a91e04be98b0368$export$c82e48d9fd97c55b = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { getDatasourceData: getDatasourceData } = (0, $clMJd.useDatasourceClientExtension)();
    return (0, $eJOHy.useMemo)(()=>{
        const factory = (action)=>(...args)=>{
                try {
                    (0, $1Q8LJ.runWhenIdle)(()=>{
                        (0, $5fWw9.default)((0, $c3e0cb3b46228483$export$3f072f06b90c3985))((0, $cVDam.default)('operational.fireAnalyticEvent.commenced', {
                            action: action
                        }))(createAnalyticsEvent);
                    });
                    (0, $1Q8LJ.runWhenIdle)(async ()=>{
                        const { fireDatasourceEvent: fireDatasourceEvent } = await (parcelRequire("gfMR6"));
                        fireDatasourceEvent(action, createAnalyticsEvent, getDatasourceData)(...args);
                    });
                } catch (error) {
                    (0, $5fWw9.default)((0, $c3e0cb3b46228483$export$3f072f06b90c3985))((0, $cVDam.default)('operational.fireAnalyticEvent.failed', {
                        error: error instanceof Error ? error.toString() : '',
                        action: action
                    }))(createAnalyticsEvent);
                }
            };
        return {
            datasourceCreated: factory('created'),
            datasourceUpdated: factory('updated'),
            datasourceDeleted: factory('deleted')
        };
    }, [
        createAnalyticsEvent,
        getDatasourceData
    ]);
};

});
const $c3e0cb3b46228483$export$3f072f06b90c3985 = 'media';

parcelRegister("cVDam", function(module, exports) {

$parcel$export(module.exports, "default", () => $54b2c4f9a9703e95$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::c64352804e2dc1a0b65a6765b7979b51>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen link-analytics
 */ const $54b2c4f9a9703e95$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $54b2c4f9a9703e95$export$2e2bcd8739ae039 = $54b2c4f9a9703e95$var$createEventPayload;

});

parcelRegister("1Q8LJ", function(module, exports) {

$parcel$export(module.exports, "runWhenIdle", () => $2f6d947b6fd04516$export$51d09170c61ebe04);
/* eslint-disable compat/compat */ const $2f6d947b6fd04516$export$51d09170c61ebe04 = (callback)=>window.requestIdleCallback ? window.requestIdleCallback(callback, {
        timeout: 5000
    }) : window.requestAnimationFrame(callback);

});

parcelRegister("gfMR6", function(module, exports) {

let $bd53f1c2dc7d2c49$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $bd53f1c2dc7d2c49$var$load("9WvZw").then(()=>parcelRequire('b9zHn'));

});


parcelRegister("W7NLq", function(module, exports) {

$parcel$export(module.exports, "getMethod", () => $62601cf19458d1d8$export$8793fab959da70d1);
$parcel$export(module.exports, "getUpdateType", () => $62601cf19458d1d8$export$df2aa842dc5172b0);
$parcel$export(module.exports, "getDeleteType", () => $62601cf19458d1d8$export$1cf3d8365b174bde);
$parcel$export(module.exports, "getSourceEventFromMetadata", () => $62601cf19458d1d8$export$b3b4df0d75d4c011);

var $5EMLi = parcelRequire("5EMLi");

var $bMFKb = parcelRequire("bMFKb");
/**
 * If the metadata is for a history event,
 * returns undo/redo instead of instead of what fn(metadata) would have otherwise
 * returned
 */ const $62601cf19458d1d8$var$withHistoryMethod = (fn)=>{
    return (metadata)=>{
        const { isUndo: isUndo, isRedo: isRedo } = metadata;
        if (isUndo) return 'undo';
        if (isRedo) return 'redo';
        return fn(metadata);
    };
};
const $62601cf19458d1d8$export$8793fab959da70d1 = $62601cf19458d1d8$var$withHistoryMethod(({ inputMethod: inputMethod, sourceEvent: sourceEvent })=>{
    inputMethod = inputMethod ?? sourceEvent?.payload?.attributes?.inputMethod;
    switch(inputMethod){
        case (0, $bMFKb.INPUT_METHOD).CLIPBOARD:
            return 'editor_paste';
        case (0, $bMFKb.INPUT_METHOD).FLOATING_TB:
            return 'editor_floatingToolbar';
        case (0, $bMFKb.INPUT_METHOD).AUTO_DETECT:
        case (0, $bMFKb.INPUT_METHOD).FORMATTING:
            return 'editor_type';
        case (0, $bMFKb.INPUT_METHOD).TYPEAHEAD:
            return 'linkpicker_searchResult';
        case (0, $bMFKb.INPUT_METHOD).MANUAL:
            return 'linkpicker_manual';
        case (0, $bMFKb.INPUT_METHOD).DATASOURCE:
            return 'datasource_config';
        default:
            return 'unknown';
    }
});
const $62601cf19458d1d8$export$df2aa842dc5172b0 = $62601cf19458d1d8$var$withHistoryMethod(({ action: action })=>{
    switch(action){
        case (0, $bMFKb.ACTION).CHANGED_TYPE:
            return 'display_update';
        case (0, $bMFKb.ACTION).UPDATED:
            return 'link_update';
        default:
            return 'unknown';
    }
});
const $62601cf19458d1d8$export$1cf3d8365b174bde = $62601cf19458d1d8$var$withHistoryMethod(({ action: action })=>{
    if (action === (0, $bMFKb.ACTION).UNLINK) return 'unlink';
    return 'delete';
});
const $62601cf19458d1d8$export$b3b4df0d75d4c011 = (metadata)=>{
    return metadata.sourceEvent instanceof (0, $5EMLi.default) ? metadata.sourceEvent : null;
};

});


parcelRegister("1JOoi", function(module, exports) {

$parcel$export(module.exports, "LinkEventsBinding", () => $4289ecc82af7781d$export$aa142efb89c75ed5);

var $eJOHy = parcelRequire("eJOHy");

var $6AXE6 = parcelRequire("6AXE6");

var $lRqrn = parcelRequire("lRqrn");

var $3o3Tb = parcelRequire("3o3Tb");

var $W7NLq = parcelRequire("W7NLq");
/**
 * Set display category as `link` if not displaying the link as a smart card
 */ const $4289ecc82af7781d$var$displayCategoryFromDisplay = (display)=>{
    if (display === 'url') return 'link';
};
const $4289ecc82af7781d$export$aa142efb89c75ed5 = ({ cardPluginEvents: cardPluginEvents })=>{
    /**
	 * These callbacks internally use window.requestIdleCallback/requestAnimationFrame
	 * to defer any heavy operations involving network
	 *
	 * The callbacks themselves should not be deferred, they should be called syncronously the moment
	 * the events take place.
	 */ const { linkCreated: linkCreated, linkUpdated: linkUpdated, linkDeleted: linkDeleted } = (0, $6AXE6.useSmartLinkLifecycleAnalytics)();
    const linkEvents = (0, $eJOHy.useMemo)(()=>{
        return {
            [(0, $lRqrn.EVENT).CREATED]: ({ node: node, nodeContext: nodeContext, ...metadata })=>{
                const url = (0, $3o3Tb.getUrl)(node);
                if (!url) return;
                const display = (0, $3o3Tb.appearanceForLink)(node);
                const displayCategory = $4289ecc82af7781d$var$displayCategoryFromDisplay(display);
                const sourceEvent = (0, $W7NLq.getSourceEventFromMetadata)(metadata);
                const creationMethod = (0, $W7NLq.getMethod)(metadata);
                linkCreated({
                    url: url,
                    displayCategory: displayCategory
                }, sourceEvent, {
                    display: display,
                    nodeContext: nodeContext,
                    creationMethod: creationMethod
                });
            },
            [(0, $lRqrn.EVENT).UPDATED]: ({ node: node, nodeContext: nodeContext, previousDisplay: previousDisplay, ...metadata })=>{
                const url = (0, $3o3Tb.getUrl)(node);
                if (!url) return;
                const display = (0, $3o3Tb.appearanceForLink)(node);
                const displayCategory = $4289ecc82af7781d$var$displayCategoryFromDisplay(display);
                const sourceEvent = (0, $W7NLq.getSourceEventFromMetadata)(metadata);
                const updateMethod = (0, $W7NLq.getMethod)(metadata);
                const updateType = (0, $W7NLq.getUpdateType)(metadata);
                linkUpdated({
                    url: url,
                    displayCategory: displayCategory
                }, sourceEvent, {
                    display: display,
                    previousDisplay: previousDisplay,
                    nodeContext: nodeContext,
                    updateMethod: updateMethod,
                    updateType: updateType
                });
            },
            [(0, $lRqrn.EVENT).DELETED]: ({ node: node, nodeContext: nodeContext, ...metadata })=>{
                const url = (0, $3o3Tb.getUrl)(node);
                if (!url) return;
                const display = (0, $3o3Tb.appearanceForLink)(node);
                const displayCategory = $4289ecc82af7781d$var$displayCategoryFromDisplay(display);
                const sourceEvent = (0, $W7NLq.getSourceEventFromMetadata)(metadata);
                const deleteMethod = (0, $W7NLq.getMethod)(metadata);
                const deleteType = (0, $W7NLq.getDeleteType)(metadata);
                linkDeleted({
                    url: url,
                    displayCategory: displayCategory
                }, sourceEvent, {
                    display: display,
                    nodeContext: nodeContext,
                    deleteMethod: deleteMethod,
                    deleteType: deleteType
                });
            }
        };
    }, [
        linkCreated,
        linkUpdated,
        linkDeleted
    ]);
    /**
	 * Subscribe to link events
	 */ (0, $eJOHy.useEffect)(()=>{
        const unsubscribe = cardPluginEvents.subscribe(({ event: event, subject: subject, data: data })=>{
            if (subject === (0, $lRqrn.EVENT_SUBJECT).LINK) linkEvents[event](data);
        });
        return ()=>unsubscribe();
    }, [
        linkEvents,
        cardPluginEvents
    ]);
    return null;
};

});


parcelRegister("6BNOR", function(module, exports) {

$parcel$export(module.exports, "EditorSmartCardEvents", () => $095bee3f7d0485b8$export$e7d7ea2bc9a806d9);

var $eJOHy = parcelRequire("eJOHy");

var $ettNQ = parcelRequire("ettNQ");

var $ecNk4 = parcelRequire("ecNk4");
const $095bee3f7d0485b8$export$e7d7ea2bc9a806d9 = ({ editorView: editorView })=>{
    const events = (0, $ettNQ.useSmartLinkEvents)();
    (0, $eJOHy.useEffect)(()=>{
        if (!events) return;
        editorView.dispatch((0, $ecNk4.registerSmartCardEvents)(events)(editorView.state.tr));
    }, [
        events,
        editorView
    ]);
    return null;
};

});
parcelRegister("ettNQ", function(module, exports) {

$parcel$export(module.exports, "useSmartLinkEvents", () => $6b9d8190953f47e0$export$ed70996d478e16d3);

var $eJOHy = parcelRequire("eJOHy");

var $b43DQ = parcelRequire("b43DQ");
function $6b9d8190953f47e0$export$ed70996d478e16d3() {
    /**
	 * this utility maybe extended in the future to include
	 * more contextual info about SLs
	 */ const events = (0, $eJOHy.useMemo)(()=>new (0, $b43DQ.SmartLinkEvents)(), []);
    return events;
}

});


parcelRegister("e5Kya", function(module, exports) {

$parcel$export(module.exports, "default", () => $6014f4049f8dfc58$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $6YFG2 = parcelRequire("6YFG2");

var $kLQ9a = parcelRequire("kLQ9a");
var $bSToC = parcelRequire("bSToC");
var $cxXTK = parcelRequire("cxXTK");

var $avm98 = parcelRequire("avm98");

var $9Sic1 = parcelRequire("9Sic1");

var $bnh3n = parcelRequire("bnh3n");

var $XRx2v = parcelRequire("XRx2v");

var $b9jOK = parcelRequire("b9jOK");



var $ecNk4 = parcelRequire("ecNk4");

var $gXgTX = parcelRequire("gXgTX");

var $37WZl = parcelRequire("37WZl");
const $6014f4049f8dfc58$var$toolbarButtonWrapperStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    background: `${`var(--ds-background-neutral, ${(0, $7bb4c1736002a04a$export$8d43898f60b96a82)})`}`,
    color: `${`var(--ds-icon, ${(0, $7bb4c1736002a04a$export$e2ef2124cf4024b1)})`}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':hover': {
        background: `${`var(--ds-background-neutral-hovered, ${(0, $7bb4c1736002a04a$export$e62e8919cca44969)})`}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        color: `${"var(--ds-icon, white)"} !important`
    }
});
const $6014f4049f8dfc58$export$b5a1df4e06cdc467 = ({ onLayoutChange: onLayoutChange, layout: layout = (0, $a358b8ea78408961$export$60efea3f80310017), intl: { formatMessage: formatMessage }, mountPoint: mountPoint, boundariesElement: boundariesElement, scrollableElement: scrollableElement, targetElement: targetElement, testId: testId = 'datasource-table-layout-button' })=>{
    const handleClick = (0, $eJOHy.useCallback)(()=>{
        onLayoutChange && onLayoutChange((0, $bnh3n.getNextBreakoutMode)(layout));
    }, [
        layout,
        onLayoutChange
    ]);
    const title = (0, $eJOHy.useMemo)(()=>{
        return formatMessage((0, $bnh3n.getTitle)(layout));
    }, [
        formatMessage,
        layout
    ]);
    if (!targetElement) return null;
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $avm98.default), {
        mountTo: mountPoint,
        boundariesElement: boundariesElement,
        scrollableElement: scrollableElement,
        target: targetElement,
        alignY: "start",
        alignX: "end",
        forcePlacement: true,
        stick: true,
        ariaLabel: title
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $9Sic1.default), {
        testId: testId,
        css: $6014f4049f8dfc58$var$toolbarButtonWrapperStyles,
        title: title,
        onClick: handleClick,
        iconBefore: layout === 'full-width' ? /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b9jOK))), {
            label: title
        }) : /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($XRx2v))), {
            label: title
        })
    }));
};
const $6014f4049f8dfc58$var$selector = (states)=>{
    return {
        layout: states.cardState?.layout,
        datasourceTableRef: states.cardState?.datasourceTableRef
    };
};
const $6014f4049f8dfc58$var$useSharedState = (0, $kLQ9a.sharedPluginStateHookMigratorFactory)((pluginInjectionApi)=>{
    return (0, $cxXTK.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'card'
    ], $6014f4049f8dfc58$var$selector);
}, (pluginInjectionApi)=>{
    const { cardState: cardState } = (0, $bSToC.useSharedPluginState)(pluginInjectionApi, [
        'card'
    ]);
    return {
        layout: cardState?.layout,
        datasourceTableRef: cardState?.datasourceTableRef
    };
});
const $6014f4049f8dfc58$var$LayoutButtonWrapper = ({ editorView: editorView, mountPoint: mountPoint, scrollableElement: scrollableElement, boundariesElement: boundariesElement, intl: intl, api: api })=>{
    const { node: node, pos: pos } = (0, $37WZl.getDatasource)(editorView);
    const { layout: layout = node?.attrs?.layout || undefined, datasourceTableRef: datasourceTableRef } = $6014f4049f8dfc58$var$useSharedState(api);
    const isDatasource = (0, $gXgTX.isDatasourceNode)(node);
    if (!isDatasource) return null;
    const onLayoutChange = (layout)=>{
        if (pos === undefined) return;
        const { state: state, dispatch: dispatch } = editorView;
        // If the button does not re-render due to no card state change, node reference will be stale
        const datasourceNode = (0, $37WZl.getDatasource)(editorView).node ?? node;
        const tr = state.tr.setNodeMarkup(pos, undefined, {
            ...datasourceNode?.attrs,
            layout: layout
        });
        tr.setMeta('scrollIntoView', false);
        dispatch((0, $ecNk4.setCardLayout)(layout)(tr));
    };
    return /*#__PURE__*/ (0, $1NIU8.jsx)($6014f4049f8dfc58$export$b5a1df4e06cdc467, {
        mountPoint: mountPoint,
        scrollableElement: scrollableElement,
        boundariesElement: boundariesElement,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        targetElement: datasourceTableRef,
        layout: (0, $37WZl.isDatasourceTableLayout)(layout) ? layout : undefined,
        onLayoutChange: onLayoutChange,
        intl: intl
    });
};
var $6014f4049f8dfc58$export$2e2bcd8739ae039 = (0, $6YFG2.default)($6014f4049f8dfc58$var$LayoutButtonWrapper);

});
parcelRegister("XRx2v", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f66a5317b716408a42d96f72b3784ae4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0b3f091f4b45231b$var$_react = $0b3f091f4b45231b$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $0b3f091f4b45231b$var$_growHorizontal = $0b3f091f4b45231b$var$_interopRequireDefault((parcelRequire("2Vw4P")));

var $0b3f091f4b45231b$var$_expand = $0b3f091f4b45231b$var$_interopRequireDefault((parcelRequire("62Ipf")));
function $0b3f091f4b45231b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for GrowHorizontalIcon.
 * This component is GrowHorizontalIcon, with `UNSAFE_fallbackIcon` set to "EditorExpandIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for increasing the width of an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0b3f091f4b45231b$var$GrowHorizontalIcon = (props)=>/*#__PURE__*/ $0b3f091f4b45231b$var$_react.default.createElement($0b3f091f4b45231b$var$_growHorizontal.default, Object.assign({
        LEGACY_fallbackIcon: $0b3f091f4b45231b$var$_expand.default
    }, props));
$0b3f091f4b45231b$var$GrowHorizontalIcon.Name = 'GrowHorizontalIconMigration';
var $0b3f091f4b45231b$var$_default = module.exports.default = $0b3f091f4b45231b$var$GrowHorizontalIcon;

});
parcelRegister("2Vw4P", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::da1cd6bc83afe2b3eb4120a294491d29>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2219c96d4f20c5a5$var$_react = $2219c96d4f20c5a5$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $2219c96d4f20c5a5$var$_baseNew = $2219c96d4f20c5a5$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $2219c96d4f20c5a5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "GrowHorizontal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for increasing the width of an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2219c96d4f20c5a5$var$GrowHorizontalIcon = (props)=>/*#__PURE__*/ $2219c96d4f20c5a5$var$_react.default.createElement($2219c96d4f20c5a5$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m.22 7.47 3.5-3.5 1.06 1.06-2.22 2.22H7v1.5H2.56l2.22 2.22-1.06 1.06-3.5-3.5a.75.75 0 0 1 0-1.06m13.22-.22-2.22-2.22 1.06-1.06 3.5 3.5a.75.75 0 0 1 0 1.06l-3.5 3.5-1.06-1.06 2.22-2.22H9v-1.5z" clip-rule="evenodd"/>`
    }, props));
$2219c96d4f20c5a5$var$GrowHorizontalIcon.displayName = 'GrowHorizontalIcon';
var $2219c96d4f20c5a5$var$_default = module.exports.default = $2219c96d4f20c5a5$var$GrowHorizontalIcon;

});

parcelRegister("62Ipf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $46656020ad5723f8$var$_react = $46656020ad5723f8$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $46656020ad5723f8$var$_growHorizontal = $46656020ad5723f8$var$_interopRequireDefault((parcelRequire("2Vw4P")));
function $46656020ad5723f8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $46656020ad5723f8$var$EditorExpandIcon = (props)=>/*#__PURE__*/ $46656020ad5723f8$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M18.062 11 16.5 9.914A1 1 0 1 1 17.914 8.5l2.616 2.616c.28.167.47.5.47.884s-.19.717-.47.884L17.914 15.5a1 1 0 0 1-1.414-1.414L18.062 13h-3.68c-.487 0-.882-.448-.882-1s.395-1 .882-1zM3.47 12.884c-.28-.167-.47-.5-.47-.884s.19-.717.47-.884L6.086 8.5A1 1 0 0 1 7.5 9.914L5.938 11h3.68c.487 0 .882.448.882 1s-.395 1-.882 1h-3.68L7.5 14.086A1 1 0 0 1 6.086 15.5z"/></svg>`
    }, props, {
        newIcon: $46656020ad5723f8$var$_growHorizontal.default
    }));
$46656020ad5723f8$var$EditorExpandIcon.displayName = 'EditorExpandIcon';
var $46656020ad5723f8$var$_default = module.exports.default = $46656020ad5723f8$var$EditorExpandIcon;

});


parcelRegister("b9jOK", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::25091e321a5cc356e731192d00270521>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $021841aed66ae90e$var$_react = $021841aed66ae90e$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $021841aed66ae90e$var$_shrinkHorizontal = $021841aed66ae90e$var$_interopRequireDefault((parcelRequire("gaTij")));

var $021841aed66ae90e$var$_collapse = $021841aed66ae90e$var$_interopRequireDefault((parcelRequire("ddWy7")));
function $021841aed66ae90e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ShrinkHorizontalIcon.
 * This component is ShrinkHorizontalIcon, with `UNSAFE_fallbackIcon` set to "EditorCollapseIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for contracting or reducing the width of an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $021841aed66ae90e$var$ShrinkHorizontalIcon = (props)=>/*#__PURE__*/ $021841aed66ae90e$var$_react.default.createElement($021841aed66ae90e$var$_shrinkHorizontal.default, Object.assign({
        LEGACY_fallbackIcon: $021841aed66ae90e$var$_collapse.default
    }, props));
$021841aed66ae90e$var$ShrinkHorizontalIcon.Name = 'ShrinkHorizontalIconMigration';
var $021841aed66ae90e$var$_default = module.exports.default = $021841aed66ae90e$var$ShrinkHorizontalIcon;

});
parcelRegister("gaTij", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6a9e4799467251fb8d42dd325d017373>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0309f16ea5d9cfbe$var$_react = $0309f16ea5d9cfbe$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $0309f16ea5d9cfbe$var$_baseNew = $0309f16ea5d9cfbe$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $0309f16ea5d9cfbe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ShrinkHorizontal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for contracting or reducing the width of an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0309f16ea5d9cfbe$var$ShrinkHorizontalIcon = (props)=>/*#__PURE__*/ $0309f16ea5d9cfbe$var$_react.default.createElement($0309f16ea5d9cfbe$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.25 8.75H0v-1.5h6.25zm3.5-1.5H16v1.5H9.75z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M5.19 8 2.22 5.03l1.06-1.06 3.5 3.5a.75.75 0 0 1 0 1.06l-3.5 3.5-1.06-1.06zm4.03-.53 3.5-3.5 1.06 1.06L10.81 8l2.97 2.97-1.06 1.06-3.5-3.5a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>`
    }, props));
$0309f16ea5d9cfbe$var$ShrinkHorizontalIcon.displayName = 'ShrinkHorizontalIcon';
var $0309f16ea5d9cfbe$var$_default = module.exports.default = $0309f16ea5d9cfbe$var$ShrinkHorizontalIcon;

});

parcelRegister("ddWy7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9a09e7ec56b9f71c$var$_react = $9a09e7ec56b9f71c$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $9a09e7ec56b9f71c$var$_shrinkHorizontal = $9a09e7ec56b9f71c$var$_interopRequireDefault((parcelRequire("gaTij")));
function $9a09e7ec56b9f71c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9a09e7ec56b9f71c$var$EditorCollapseIcon = (props)=>/*#__PURE__*/ $9a09e7ec56b9f71c$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M8.062 11 6.5 9.914A1 1 0 0 1 7.914 8.5l2.616 2.616c.28.167.47.5.47.884s-.19.717-.47.884L7.914 15.5A1 1 0 1 1 6.5 14.086L8.062 13h-3.68c-.487 0-.882-.448-.882-1s.395-1 .882-1zm5.408 1.884c-.28-.167-.47-.5-.47-.884s.19-.717.47-.884L16.086 8.5A1 1 0 0 1 17.5 9.914L15.938 11h3.68c.487 0 .882.448.882 1s-.395 1-.882 1h-3.68l1.562 1.086a1 1 0 0 1-1.414 1.414z"/></svg>`
    }, props, {
        newIcon: $9a09e7ec56b9f71c$var$_shrinkHorizontal.default
    }));
$9a09e7ec56b9f71c$var$EditorCollapseIcon.displayName = 'EditorCollapseIcon';
var $9a09e7ec56b9f71c$var$_default = module.exports.default = $9a09e7ec56b9f71c$var$EditorCollapseIcon;

});





parcelRegister("97XCP", function(module, exports) {

$parcel$export(module.exports, "clearMarksOnEmptyDocPlugin", () => (parcelRequire("3SsmW")).clearMarksOnEmptyDocPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $3SsmW = parcelRequire("3SsmW");

});
parcelRegister("3SsmW", function(module, exports) {

$parcel$export(module.exports, "clearMarksOnEmptyDocPlugin", () => $4f40543be4631c84$export$30b76f1055cbb7e9);

var $i8KtF = parcelRequire("i8KtF");

var $bnAxN = parcelRequire("bnAxN");

var $3lIcL = parcelRequire("3lIcL");
const $4f40543be4631c84$var$pluginKey = new (0, $3lIcL.PluginKey)('clearMarksOnChangeToEmptyDocumentPlugin');
function $4f40543be4631c84$var$createPlugin() {
    return new (0, $i8KtF.SafePlugin)({
        key: $4f40543be4631c84$var$pluginKey,
        appendTransaction: (_transactions, oldState, newState)=>{
            // ED-2973: When a user clears the editor's content, remove the current active marks
            if (!(0, $bnAxN.isEmptyDocument)(oldState.doc) && (0, $bnAxN.isEmptyDocument)(newState.doc)) return newState.tr.setStoredMarks([]);
            return;
        }
    });
}
const $4f40543be4631c84$export$30b76f1055cbb7e9 = ()=>({
        name: 'clearMarksOnEmptyDoc',
        pmPlugins () {
            return [
                {
                    name: 'clearMarksOnChange',
                    plugin: $4f40543be4631c84$var$createPlugin
                }
            ];
        }
    });

});


parcelRegister("7R4av", function(module, exports) {

$parcel$export(module.exports, "clipboardPlugin", () => (parcelRequire("aRWgy")).default);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $aRWgy = parcelRequire("aRWgy");

});
parcelRegister("aRWgy", function(module, exports) {

$parcel$export(module.exports, "default", () => $3094c678279ce88d$export$2e2bcd8739ae039);

var $7SxPn = parcelRequire("7SxPn");
const $3094c678279ce88d$var$clipboard = ()=>({
        name: 'clipboard',
        pmPlugins () {
            return [
                {
                    name: 'clipboard',
                    plugin: (options)=>(0, $7SxPn.createPlugin)(options)
                }
            ];
        }
    });
var $3094c678279ce88d$export$2e2bcd8739ae039 = $3094c678279ce88d$var$clipboard;

});
parcelRegister("7SxPn", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $f013e70751363d6a$export$ae829ec7b2625219);

var $bMFKb = parcelRequire("bMFKb");

var $58hN2 = parcelRequire("58hN2");

var $i8KtF = parcelRequire("i8KtF");

var $3xw6l = parcelRequire("3xw6l");

var $BmspC = parcelRequire("BmspC");

var $eGOwo = parcelRequire("eGOwo");

var $3exxz = parcelRequire("3exxz");
var $f013e70751363d6a$export$304e24f67740de29 = /*#__PURE__*/ function(ClipboardEventType) {
    ClipboardEventType["CUT"] = "CUT";
    ClipboardEventType["COPY"] = "COPY";
    return ClipboardEventType;
}({});
let $f013e70751363d6a$var$lastEventType = null;
const $f013e70751363d6a$export$ae829ec7b2625219 = ({ dispatchAnalyticsEvent: dispatchAnalyticsEvent, schema: schema })=>{
    let editorView;
    const getEditorView = ()=>editorView;
    return new (0, $i8KtF.SafePlugin)({
        key: (0, $3exxz.clipboardPluginKey),
        view: (view)=>{
            editorView = view;
            return {
                update: (view)=>{
                    editorView = view;
                }
            };
        },
        props: {
            handleDOMEvents: {
                cut: (view)=>{
                    $f013e70751363d6a$export$47cf4f31f028e0c9("CUT");
                    return $f013e70751363d6a$export$e8eabed2709e2a33(view, dispatchAnalyticsEvent, (0, $bMFKb.ACTION).CUT);
                },
                copy: (view)=>{
                    $f013e70751363d6a$export$47cf4f31f028e0c9("COPY");
                    return $f013e70751363d6a$export$e8eabed2709e2a33(view, dispatchAnalyticsEvent, (0, $bMFKb.ACTION).COPIED);
                }
            },
            clipboardSerializer: $f013e70751363d6a$export$33f65796de3575a9(schema, getEditorView)
        }
    });
};
const $f013e70751363d6a$export$33f65796de3575a9 = (schema, getEditorView)=>{
    const oldSerializer = (0, $3xw6l.DOMSerializer).fromSchema(schema);
    const newSerializer = new (0, $3xw6l.DOMSerializer)(oldSerializer.nodes, oldSerializer.marks);
    const originalSerializeFragment = newSerializer.serializeFragment.bind(newSerializer);
    newSerializer.serializeFragment = (content, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    options = {}, target)=>{
        const editorView = getEditorView();
        const selection = editorView.state.selection;
        // We do not need to handle when a user copies a tableRow + other content.
        // In that scenario it already wraps the Row with correct Table and attributes.
        if (!options.tableWrapperExists) {
            let i = 0;
            while(i < content.childCount){
                if (content.maybeChild(i)?.type.name === 'table') {
                    options.tableWrapperExists = true;
                    break;
                }
                i++;
            }
        }
        // When the content being copied includes a tableRow that is not already wrapped with a table,
        // We will wrap it with one ourselves, while preserving the parent table's attributes.
        if (content.firstChild?.type.name === 'tableRow' && !options.tableWrapperExists) {
            // We only want 1 table wrapping the rows.
            // tableWrapperExist is a custom prop added solely for the purposes of this recursive algorithm.
            // The function is recursively called for each node in the tree captured in the fragment.
            // For recursive logic see the bind call above and the prosemirror-model (https://github.com/ProseMirror/prosemirror-model/blob/master/src/to_dom.js#L44
            // and https://github.com/ProseMirror/prosemirror-model/blob/master/src/to_dom.js#L87)
            options.tableWrapperExists = true;
            const parentTable = (0, $BmspC.findParentNodeOfType)(schema.nodes.table)(selection);
            const attributes = parentTable?.node.attrs;
            const newTable = schema.nodes.table;
            // Explicitly remove local id since we are creating a new table and it should have a unique local id which will be generated.
            const newTableNode = newTable.createChecked({
                ...attributes,
                localId: undefined
            }, content);
            const newContent = (0, $3xw6l.Fragment).from(newTableNode);
            // Pass updated content into original ProseMirror serializeFragment function.
            // Currently incorrectly typed in @Types. See this GitHub thread: https://github.com/DefinitelyTyped/DefinitelyTyped/pull/57668
            //@ts-ignore
            return originalSerializeFragment(newContent, options, target);
        }
        // Remove annotations from media nodes when copying to clipboard, only do this for copy operations
        // and keep existing content nodes from the parent.
        if ($f013e70751363d6a$var$lastEventType === "COPY" && content.firstChild?.type.name === 'media') {
            const mediaNode = content.firstChild;
            const strippedMediaNode = schema.nodes.media.createChecked(mediaNode.attrs, mediaNode.content, mediaNode.marks?.filter((mark)=>mark.type.name !== 'annotation'));
            if ((0, $eGOwo.fg)('platform_editor_fix_captions_on_copy')) {
                // Content for media parents can include multiple content nodes (media and captions). We now take that
                // into consideration when we are stripping annotations
                let contentArray = [
                    strippedMediaNode
                ];
                content.forEach((node)=>{
                    if (node.type.name !== 'media') contentArray = [
                        ...contentArray,
                        node
                    ];
                });
                const newContent = (0, $3xw6l.Fragment).fromArray(contentArray);
                // Currently incorrectly typed, see comment above
                //@ts-ignore
                return originalSerializeFragment(newContent, options, target);
            } else {
                const newContent = (0, $3xw6l.Fragment).from(strippedMediaNode);
                // Currently incorrectly typed, see comment above
                //@ts-ignore
                return originalSerializeFragment(newContent, options, target);
            }
        }
        // If we're not copying any rows or media nodes, just run default serializeFragment function.
        // Currently incorrectly typed in @Types. See this GitHub thread: https://github.com/DefinitelyTyped/DefinitelyTyped/pull/57668
        //@ts-ignore
        return originalSerializeFragment(content, options, target);
    };
    return newSerializer;
};
const $f013e70751363d6a$export$e8eabed2709e2a33 = (view, dispatchAnalyticsEvent, action)=>{
    const clipboardAnalyticsPayload = (0, $58hN2.getAnalyticsPayload)(view.state, action);
    if (clipboardAnalyticsPayload) dispatchAnalyticsEvent(clipboardAnalyticsPayload);
    // return false so we don't block any other plugins' cut or copy handlers
    // from running just because we are sending an analytics event
    return false;
};
const $f013e70751363d6a$export$47cf4f31f028e0c9 = (eventType)=>$f013e70751363d6a$var$lastEventType = eventType;

});
parcelRegister("58hN2", function(module, exports) {

$parcel$export(module.exports, "copyToClipboard", () => $4462298816d64b27$export$2cdf1b96a9f86d16);
$parcel$export(module.exports, "copyHTMLToClipboard", () => $4462298816d64b27$export$8b344d2a6a3e9af3);
$parcel$export(module.exports, "copyHTMLToClipboardPolyfill", () => $4462298816d64b27$export$97e18ff8b98c7078);
$parcel$export(module.exports, "getAnalyticsPayload", () => $4462298816d64b27$export$4feda93c1c6b2d80);
$parcel$export(module.exports, "getNodeCopiedAnalyticsPayload", () => $4462298816d64b27$export$f8811fa45a00fd64);
// Ignored via go/ees005
// eslint-disable-next-line import/no-namespace

var $4OJ8P = parcelRequire("4OJ8P");

var $3lIcL = parcelRequire("3lIcL");

var $bMFKb = parcelRequire("bMFKb");

var $7xtnm = parcelRequire("7xtnm");
const $4462298816d64b27$var$isClipboardApiSupported = ()=>!!navigator.clipboard && typeof navigator.clipboard.writeText === 'function';
const $4462298816d64b27$var$isIEClipboardApiSupported = ()=>// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.clipboardData && typeof window.clipboardData.setData === 'function';
const $4462298816d64b27$var$isExtensionNode = (node)=>{
    if (node === 'extension' || node === 'bodiedExtension' || node === 'inlineExtension' || node === 'multiBodiedExtension') return true;
    return false;
};
const $4462298816d64b27$export$2cdf1b96a9f86d16 = async (textToCopy)=>{
    if ($4462298816d64b27$var$isClipboardApiSupported()) try {
        await navigator.clipboard.writeText(textToCopy);
    } catch (error) {
        throw new Error('Clipboard api is not supported');
    }
    else if ($4462298816d64b27$var$isIEClipboardApiSupported()) try {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        await window.clipboardData.setData('text', textToCopy);
    } catch (error) {
        throw new Error('IE clipboard api is not supported');
    }
    else throw new Error('Clipboard api is not supported');
};
const $4462298816d64b27$export$8b344d2a6a3e9af3 = async (elementToCopy, plainTextToCopy)=>{
    // @ts-ignore
    if ($4462298816d64b27$var$isClipboardApiSupported() && typeof ClipboardItem !== 'undefined') try {
        const data = new ClipboardItem({
            'text/plain': new Blob([
                plainTextToCopy || elementToCopy.innerText
            ], {
                type: 'text/plain'
            }),
            'text/html': new Blob([
                elementToCopy.innerHTML
            ], {
                type: 'text/html'
            })
        });
        // @ts-ignore
        await navigator.clipboard.write([
            data
        ]);
    } catch (error) {
        throw new Error('Clipboard api is not supported');
    }
    else if (!!document && typeof document === 'object') try {
        // ED-17083 extension copy seems have issue with ClipboardItem API
        // Hence of use of this polyfill
        $4462298816d64b27$export$97e18ff8b98c7078(elementToCopy, plainTextToCopy);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
    }
};
const $4462298816d64b27$export$97e18ff8b98c7078 = async (elementToCopy, plainTextToCopy)=>{
    const dt = new $4OJ8P.ClipboardItem({
        'text/html': new Blob([
            elementToCopy.innerHTML
        ], {
            type: 'text/html'
        }),
        'text/plain': new Blob([
            plainTextToCopy || elementToCopy.innerText
        ], {
            type: 'text/plain'
        })
    });
    await $4OJ8P.write([
        dt
    ]);
};
const $4462298816d64b27$export$4feda93c1c6b2d80 = (state, action)=>{
    const { selection: selection, doc: doc } = state;
    const selectionAnalyticsPayload = (0, $7xtnm.getNodeSelectionAnalyticsPayload)(selection) || (0, $7xtnm.getRangeSelectionAnalyticsPayload)(selection, doc) || (0, $7xtnm.getAllSelectionAnalyticsPayload)(selection) || (0, $7xtnm.getCellSelectionAnalyticsPayload)(state);
    if (selectionAnalyticsPayload) {
        const { actionSubjectId: selectionActionSubjectId } = selectionAnalyticsPayload;
        const node = selectionAnalyticsPayload.attributes?.node;
        const content = [];
        let extensionType;
        let extensionKey;
        switch(selectionActionSubjectId){
            case (0, $bMFKb.ACTION_SUBJECT_ID).NODE:
                if (node) {
                    content.push(node);
                    if ($4462298816d64b27$var$isExtensionNode(node)) {
                        extensionType = selection.node.attrs.extensionType;
                        extensionKey = selection.node.attrs.extensionKey;
                    }
                }
                break;
            case (0, $bMFKb.ACTION_SUBJECT_ID).RANGE:
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                content.push(...selectionAnalyticsPayload.attributes.nodes);
                break;
            case (0, $bMFKb.ACTION_SUBJECT_ID).ALL:
                content.push('all');
                break;
            case (0, $bMFKb.ACTION_SUBJECT_ID).CELL:
                {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    const { selectedCells: selectedCells } = selectionAnalyticsPayload.attributes;
                    content.push(...Array(selectedCells).fill('tableCell'));
                    break;
                }
        }
        if ($4462298816d64b27$var$isExtensionNode(node)) return {
            eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
            action: action,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).DOCUMENT,
            attributes: {
                content: content,
                extensionKey: extensionKey,
                extensionType: extensionType
            }
        };
        return {
            eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
            action: action,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).DOCUMENT,
            attributes: {
                content: content
            }
        };
    }
    if (selection instanceof (0, $3lIcL.TextSelection) && selection.$cursor) return {
        eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
        action: action,
        actionSubject: (0, $bMFKb.ACTION_SUBJECT).DOCUMENT,
        attributes: {
            content: [
                'caret'
            ]
        }
    };
};
const $4462298816d64b27$export$f8811fa45a00fd64 = (node, inputMethod)=>{
    const nodeType = node.type.name;
    let extensionType;
    let extensionKey;
    if ($4462298816d64b27$var$isExtensionNode(nodeType)) {
        extensionType = node.attrs.extensionType;
        extensionKey = node.attrs.extensionKey;
    }
    const payload = {
        eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
        action: (0, $bMFKb.ACTION).COPIED,
        actionSubject: (0, $bMFKb.ACTION_SUBJECT).DOCUMENT,
        attributes: {
            content: [
                nodeType
            ],
            inputMethod: inputMethod,
            nodeType: nodeType,
            ...extensionType ? {
                extensionType: extensionType
            } : {},
            ...extensionKey ? {
                extensionKey: extensionKey
            } : {}
        }
    };
    return payload;
};

});
parcelRegister("4OJ8P", function(module, exports) {

$parcel$export(module.exports, "ClipboardItem", () => $381ed90e93d28ded$export$3b1380c0957dc8fe);
$parcel$export(module.exports, "write", () => $381ed90e93d28ded$export$68d8715fc104d294);
// src/clipboard-polyfill/ClipboardItem/data-types.ts
var $381ed90e93d28ded$var$TEXT_PLAIN = "text/plain";
var $381ed90e93d28ded$var$TEXT_HTML = "text/html";
// src/clipboard-polyfill/debug.ts
var $381ed90e93d28ded$var$debugLogImpl = (s)=>{};
function $381ed90e93d28ded$var$debugLog(s) {
    $381ed90e93d28ded$var$debugLogImpl(s);
}
function $381ed90e93d28ded$export$e014146e87162c32(logFn) {
    $381ed90e93d28ded$var$debugLogImpl = logFn;
}
var $381ed90e93d28ded$var$showWarnings = true;
function $381ed90e93d28ded$export$ba5c9528becaaf25() {
    $381ed90e93d28ded$var$showWarnings = false;
}
function $381ed90e93d28ded$var$shouldShowWarnings() {
    return $381ed90e93d28ded$var$showWarnings;
}
function $381ed90e93d28ded$var$warnOrLog() {
    (console.warn || console.log).apply(console, arguments);
}
var $381ed90e93d28ded$var$warn = $381ed90e93d28ded$var$warnOrLog.bind("[clipboard-polyfill]");
// src/clipboard-polyfill/builtins/window-globalThis.ts
var $381ed90e93d28ded$var$originalWindow = typeof window === "undefined" ? void 0 : window;
var $381ed90e93d28ded$var$originalGlobalThis = typeof globalThis === "undefined" ? void 0 : globalThis;
// src/clipboard-polyfill/builtins/promise-constructor.ts
var $381ed90e93d28ded$var$_a, $381ed90e93d28ded$var$_b, $381ed90e93d28ded$var$_c;
var $381ed90e93d28ded$var$promiseConstructorImpl = ($381ed90e93d28ded$var$_c = ($381ed90e93d28ded$var$_a = $381ed90e93d28ded$var$originalWindow) == null ? void 0 : $381ed90e93d28ded$var$_a.Promise) != null ? $381ed90e93d28ded$var$_c : ($381ed90e93d28ded$var$_b = $381ed90e93d28ded$var$originalGlobalThis) == null ? void 0 : $381ed90e93d28ded$var$_b.Promise;
function $381ed90e93d28ded$var$getPromiseConstructor() {
    if (!$381ed90e93d28ded$var$promiseConstructorImpl) throw new Error("No `Promise` implementation available for `clipboard-polyfill`. Consider using: https://github.com/lgarron/clipboard-polyfill#flat-file-version-with-promise-included");
    return $381ed90e93d28ded$var$promiseConstructorImpl;
}
// src/clipboard-polyfill/builtins/builtin-globals.ts
var $381ed90e93d28ded$var$originalNavigator = typeof navigator === "undefined" ? void 0 : navigator;
var $381ed90e93d28ded$var$originalNavigatorClipboard = $381ed90e93d28ded$var$originalNavigator == null ? void 0 : $381ed90e93d28ded$var$originalNavigator.clipboard;
var $381ed90e93d28ded$var$_a2;
var $381ed90e93d28ded$var$originalNavigatorClipboardRead = ($381ed90e93d28ded$var$_a2 = $381ed90e93d28ded$var$originalNavigatorClipboard == null ? void 0 : $381ed90e93d28ded$var$originalNavigatorClipboard.read) == null ? void 0 : $381ed90e93d28ded$var$_a2.bind($381ed90e93d28ded$var$originalNavigatorClipboard);
var $381ed90e93d28ded$var$_a3;
var $381ed90e93d28ded$var$originalNavigatorClipboardReadText = ($381ed90e93d28ded$var$_a3 = $381ed90e93d28ded$var$originalNavigatorClipboard == null ? void 0 : $381ed90e93d28ded$var$originalNavigatorClipboard.readText) == null ? void 0 : $381ed90e93d28ded$var$_a3.bind($381ed90e93d28ded$var$originalNavigatorClipboard);
var $381ed90e93d28ded$var$_a4;
var $381ed90e93d28ded$var$originalNavigatorClipboardWrite = ($381ed90e93d28ded$var$_a4 = $381ed90e93d28ded$var$originalNavigatorClipboard == null ? void 0 : $381ed90e93d28ded$var$originalNavigatorClipboard.write) == null ? void 0 : $381ed90e93d28ded$var$_a4.bind($381ed90e93d28ded$var$originalNavigatorClipboard);
var $381ed90e93d28ded$var$_a5;
var $381ed90e93d28ded$var$originalNavigatorClipboardWriteText = ($381ed90e93d28ded$var$_a5 = $381ed90e93d28ded$var$originalNavigatorClipboard == null ? void 0 : $381ed90e93d28ded$var$originalNavigatorClipboard.writeText) == null ? void 0 : $381ed90e93d28ded$var$_a5.bind($381ed90e93d28ded$var$originalNavigatorClipboard);
var $381ed90e93d28ded$var$_a6;
var $381ed90e93d28ded$var$originalWindowClipboardItem = ($381ed90e93d28ded$var$_a6 = $381ed90e93d28ded$var$originalWindow) == null ? void 0 : $381ed90e93d28ded$var$_a6.ClipboardItem;
var $381ed90e93d28ded$var$promiseConstructor = $381ed90e93d28ded$var$getPromiseConstructor();
// src/clipboard-polyfill/strategies/internet-explorer.ts
var $381ed90e93d28ded$var$ieWindow = $381ed90e93d28ded$var$originalWindow;
function $381ed90e93d28ded$var$seemToBeInIE() {
    return typeof ClipboardEvent === "undefined" && typeof ($381ed90e93d28ded$var$ieWindow == null ? void 0 : $381ed90e93d28ded$var$ieWindow.clipboardData) !== "undefined" && typeof ($381ed90e93d28ded$var$ieWindow == null ? void 0 : $381ed90e93d28ded$var$ieWindow.clipboardData.setData) !== "undefined";
}
function $381ed90e93d28ded$var$writeTextIE(text) {
    if (!$381ed90e93d28ded$var$ieWindow.clipboardData) return false;
    var success = $381ed90e93d28ded$var$ieWindow.clipboardData.setData("Text", text);
    if (success) $381ed90e93d28ded$var$debugLog("writeTextIE worked");
    return success;
}
function $381ed90e93d28ded$var$readTextIE() {
    if (!$381ed90e93d28ded$var$ieWindow.clipboardData) throw new Error("Cannot read IE clipboard Data ");
    var text = $381ed90e93d28ded$var$ieWindow.clipboardData.getData("Text");
    if (text === "") throw new Error("Empty clipboard or could not read plain text from clipboard");
    return text;
}
// src/clipboard-polyfill/strategies/dom.ts
function $381ed90e93d28ded$var$copyListener(tracker, data, e) {
    $381ed90e93d28ded$var$debugLog("listener called");
    tracker.success = true;
    for(var type in data){
        var value = data[type];
        var clipboardData = e.clipboardData;
        clipboardData.setData(type, value);
        if (type === $381ed90e93d28ded$var$TEXT_PLAIN && clipboardData.getData(type) !== value) {
            $381ed90e93d28ded$var$debugLog("setting text/plain failed");
            tracker.success = false;
        }
    }
    e.preventDefault();
}
function $381ed90e93d28ded$var$execCopy(data) {
    var tracker = {
        success: false
    };
    var listener = $381ed90e93d28ded$var$copyListener.bind(this, tracker, data);
    document.addEventListener("copy", listener);
    try {
        document.execCommand("copy");
    } finally{
        document.removeEventListener("copy", listener);
    }
    return tracker.success;
}
function $381ed90e93d28ded$var$copyUsingTempSelection(e, data) {
    $381ed90e93d28ded$var$selectionSet(e);
    var success = $381ed90e93d28ded$var$execCopy(data);
    $381ed90e93d28ded$var$selectionClear();
    return success;
}
function $381ed90e93d28ded$var$copyUsingTempElem(data) {
    var tempElem = document.createElement("div");
    tempElem.setAttribute("style", "-webkit-user-select: text !important");
    tempElem.textContent = "temporary element";
    document.body.appendChild(tempElem);
    var success = $381ed90e93d28ded$var$copyUsingTempSelection(tempElem, data);
    document.body.removeChild(tempElem);
    return success;
}
function $381ed90e93d28ded$var$copyTextUsingDOM(str) {
    $381ed90e93d28ded$var$debugLog("copyTextUsingDOM");
    var tempElem = document.createElement("div");
    tempElem.setAttribute("style", "-webkit-user-select: text !important");
    var spanParent = tempElem;
    if (tempElem.attachShadow) {
        $381ed90e93d28ded$var$debugLog("Using shadow DOM.");
        spanParent = tempElem.attachShadow({
            mode: "open"
        });
    }
    var span = document.createElement("span");
    span.innerText = str;
    spanParent.appendChild(span);
    document.body.appendChild(tempElem);
    $381ed90e93d28ded$var$selectionSet(span);
    var result = document.execCommand("copy");
    $381ed90e93d28ded$var$selectionClear();
    document.body.removeChild(tempElem);
    return result;
}
function $381ed90e93d28ded$var$selectionSet(elem) {
    var sel = document.getSelection();
    if (sel) {
        var range = document.createRange();
        range.selectNodeContents(elem);
        sel.removeAllRanges();
        sel.addRange(range);
    }
}
function $381ed90e93d28ded$var$selectionClear() {
    var sel = document.getSelection();
    if (sel) sel.removeAllRanges();
}
// src/clipboard-polyfill/implementations/write-fallback.ts
function $381ed90e93d28ded$var$writeFallback(stringItem) {
    var hasTextPlain = $381ed90e93d28ded$var$TEXT_PLAIN in stringItem;
    if ($381ed90e93d28ded$var$seemToBeInIE()) {
        if (!hasTextPlain) throw new Error("No `text/plain` value was specified.");
        if ($381ed90e93d28ded$var$writeTextIE(stringItem[$381ed90e93d28ded$var$TEXT_PLAIN])) return true;
        else throw new Error("Copying failed, possibly because the user rejected it.");
    }
    if ($381ed90e93d28ded$var$execCopy(stringItem)) {
        $381ed90e93d28ded$var$debugLog("regular execCopy worked");
        return true;
    }
    if (navigator.userAgent.indexOf("Edge") > -1) {
        $381ed90e93d28ded$var$debugLog('UA "Edge" => assuming success');
        return true;
    }
    if ($381ed90e93d28ded$var$copyUsingTempSelection(document.body, stringItem)) {
        $381ed90e93d28ded$var$debugLog("copyUsingTempSelection worked");
        return true;
    }
    if ($381ed90e93d28ded$var$copyUsingTempElem(stringItem)) {
        $381ed90e93d28ded$var$debugLog("copyUsingTempElem worked");
        return true;
    }
    if ($381ed90e93d28ded$var$copyTextUsingDOM(stringItem[$381ed90e93d28ded$var$TEXT_PLAIN])) {
        $381ed90e93d28ded$var$debugLog("copyTextUsingDOM worked");
        return true;
    }
    return false;
}
// src/clipboard-polyfill/promise/promise-compat.ts
function $381ed90e93d28ded$var$promiseRecordMap(keys, f) {
    var promiseList = [];
    for(var i in keys){
        var key = keys[i];
        promiseList.push(f(key));
    }
    return $381ed90e93d28ded$var$promiseConstructor.all(promiseList).then((vList)=>{
        var dataOut = {};
        for(var i2 = 0; i2 < keys.length; i2++)dataOut[keys[i2]] = vList[i2];
        return dataOut;
    });
}
var $381ed90e93d28ded$var$voidPromise = $381ed90e93d28ded$var$promiseConstructor.resolve();
var $381ed90e93d28ded$var$truePromiseFn = ()=>$381ed90e93d28ded$var$promiseConstructor.resolve(true);
var $381ed90e93d28ded$var$falsePromise = $381ed90e93d28ded$var$promiseConstructor.resolve(false);
function $381ed90e93d28ded$var$rejectThrownErrors(executor) {
    return new $381ed90e93d28ded$var$promiseConstructor((resolve, reject)=>{
        try {
            resolve(executor());
        } catch (e) {
            reject(e);
        }
    });
}
// src/clipboard-polyfill/implementations/text.ts
function $381ed90e93d28ded$var$stringToStringItem(s) {
    var stringItem = {};
    stringItem[$381ed90e93d28ded$var$TEXT_PLAIN] = s;
    return stringItem;
}
function $381ed90e93d28ded$export$bec150f75a9b8f11(s) {
    return $381ed90e93d28ded$var$rejectThrownErrors(()=>{
        if ($381ed90e93d28ded$var$originalNavigatorClipboardWriteText) {
            $381ed90e93d28ded$var$debugLog("Using `navigator.clipboard.writeText()`.");
            return $381ed90e93d28ded$var$originalNavigatorClipboardWriteText(s).catch($381ed90e93d28ded$var$writeTextStringFallback);
        }
        return $381ed90e93d28ded$var$promiseConstructor.resolve($381ed90e93d28ded$var$writeTextStringFallback(s));
    });
}
function $381ed90e93d28ded$var$writeTextStringFallback(s) {
    if (!$381ed90e93d28ded$var$writeFallback($381ed90e93d28ded$var$stringToStringItem(s))) throw new Error("writeText() failed");
}
function $381ed90e93d28ded$export$bee0113684d8879b() {
    return $381ed90e93d28ded$var$rejectThrownErrors(()=>{
        if ($381ed90e93d28ded$var$originalNavigatorClipboardReadText) {
            $381ed90e93d28ded$var$debugLog("Using `navigator.clipboard.readText()`.");
            return $381ed90e93d28ded$var$originalNavigatorClipboardReadText();
        }
        if ($381ed90e93d28ded$var$seemToBeInIE()) {
            var result = $381ed90e93d28ded$var$readTextIE();
            return $381ed90e93d28ded$var$promiseConstructor.resolve(result);
        }
        throw new Error("Read is not supported in your browser.");
    });
}
// src/clipboard-polyfill/ClipboardItem/check.ts
function $381ed90e93d28ded$var$hasItemWithType(clipboardItems, typeName) {
    for(var i in clipboardItems){
        var item = clipboardItems[i];
        if (item.types.indexOf(typeName) !== -1) return true;
    }
    return false;
}
// src/clipboard-polyfill/ClipboardItem/ClipboardItemPolyfill.ts
function $381ed90e93d28ded$var$ClipboardItemPolyfillImpl(items, options) {
    var _a7;
    var types = Object.keys(items);
    var _items = {};
    for(var type in items){
        var item = items[type];
        if (typeof item === "string") _items[type] = $381ed90e93d28ded$var$stringToBlob(type, item);
        else _items[type] = item;
    }
    var presentationStyle = (_a7 = options == null ? void 0 : options.presentationStyle) != null ? _a7 : "unspecified";
    function getType(type2) {
        return $381ed90e93d28ded$var$promiseConstructor.resolve(_items[type2]);
    }
    return {
        types: types,
        presentationStyle: presentationStyle,
        getType: getType
    };
}
var $381ed90e93d28ded$export$3b1380c0957dc8fe = $381ed90e93d28ded$var$ClipboardItemPolyfillImpl;
// src/clipboard-polyfill/ClipboardItem/convert.ts
function $381ed90e93d28ded$var$stringToBlob(type, str) {
    return new Blob([
        str
    ], {
        type: type
    });
}
function $381ed90e93d28ded$var$blobToString(blob) {
    return new $381ed90e93d28ded$var$promiseConstructor((resolve, reject)=>{
        var fileReader = new FileReader();
        fileReader.addEventListener("load", ()=>{
            var result = fileReader.result;
            if (typeof result === "string") resolve(result);
            else reject("could not convert blob to string");
        });
        fileReader.readAsText(blob);
    });
}
function $381ed90e93d28ded$var$clipboardItemToGlobalClipboardItem(clipboardItem) {
    return $381ed90e93d28ded$var$promiseRecordMap(clipboardItem.types, function(type) {
        return clipboardItem.getType(type);
    }).then((items)=>{
        return new Promise((resolve, reject)=>{
            var options = {};
            if (clipboardItem.presentationStyle) options.presentationStyle = clipboardItem.presentationStyle;
            if ($381ed90e93d28ded$var$originalWindowClipboardItem) resolve(new $381ed90e93d28ded$var$originalWindowClipboardItem(items, options));
            else reject("window.ClipboardItem is not defined");
        });
    });
}
function $381ed90e93d28ded$var$textToClipboardItem(text) {
    var items = {};
    items[$381ed90e93d28ded$var$TEXT_PLAIN] = $381ed90e93d28ded$var$stringToBlob(text, $381ed90e93d28ded$var$TEXT_PLAIN);
    return new $381ed90e93d28ded$export$3b1380c0957dc8fe(items);
}
function $381ed90e93d28ded$var$getTypeAsString(clipboardItem, type) {
    return clipboardItem.getType(type).then((text)=>{
        return $381ed90e93d28ded$var$blobToString(text);
    });
}
function $381ed90e93d28ded$var$toStringItem(data) {
    return $381ed90e93d28ded$var$promiseRecordMap(data.types, function(type) {
        return $381ed90e93d28ded$var$getTypeAsString(data, type);
    });
}
// src/clipboard-polyfill/implementations/blob.ts
function $381ed90e93d28ded$export$68d8715fc104d294(data) {
    return $381ed90e93d28ded$var$rejectThrownErrors(()=>{
        if ($381ed90e93d28ded$var$originalNavigatorClipboardWrite && $381ed90e93d28ded$var$originalWindowClipboardItem) {
            var originalNavigatorClipboardWriteCached = $381ed90e93d28ded$var$originalNavigatorClipboardWrite;
            $381ed90e93d28ded$var$debugLog("Using `navigator.clipboard.write()`.");
            return $381ed90e93d28ded$var$promiseConstructor.all(data.map($381ed90e93d28ded$var$clipboardItemToGlobalClipboardItem)).then((globalClipboardItems)=>{
                return originalNavigatorClipboardWriteCached(globalClipboardItems).then($381ed90e93d28ded$var$truePromiseFn).catch((e)=>{
                    if (!$381ed90e93d28ded$var$hasItemWithType(data, $381ed90e93d28ded$var$TEXT_PLAIN) && !$381ed90e93d28ded$var$hasItemWithType(data, $381ed90e93d28ded$var$TEXT_HTML)) throw e;
                    return $381ed90e93d28ded$var$falsePromise;
                });
            });
        }
        return $381ed90e93d28ded$var$falsePromise;
    }).then((success)=>{
        if (success) return $381ed90e93d28ded$var$voidPromise;
        var hasTextPlain = $381ed90e93d28ded$var$hasItemWithType(data, $381ed90e93d28ded$var$TEXT_PLAIN);
        if ($381ed90e93d28ded$var$shouldShowWarnings() && !hasTextPlain) $381ed90e93d28ded$var$debugLog("clipboard.write() was called without a `text/plain` data type. On some platforms, this may result in an empty clipboard. Call suppressWarnings() to suppress this warning.");
        return $381ed90e93d28ded$var$toStringItem(data[0]).then((stringItem)=>{
            if (!$381ed90e93d28ded$var$writeFallback(stringItem)) throw new Error("write() failed");
        });
    });
}
function $381ed90e93d28ded$export$aafa59e2e03f2942() {
    return $381ed90e93d28ded$var$rejectThrownErrors(()=>{
        if ($381ed90e93d28ded$var$originalNavigatorClipboardRead) {
            $381ed90e93d28ded$var$debugLog("Using `navigator.clipboard.read()`.");
            return $381ed90e93d28ded$var$originalNavigatorClipboardRead();
        }
        return $381ed90e93d28ded$export$bee0113684d8879b().then((text)=>{
            return [
                $381ed90e93d28ded$var$textToClipboardItem(text)
            ];
        });
    });
}

});

parcelRegister("7xtnm", function(module, exports) {

$parcel$export(module.exports, "getNodeSelectionAnalyticsPayload", () => $09c262605d5c0f03$export$3162c38157c33ee6);
$parcel$export(module.exports, "getAllSelectionAnalyticsPayload", () => $09c262605d5c0f03$export$9f3a063378bdcaa1);
$parcel$export(module.exports, "getCellSelectionAnalyticsPayload", () => $09c262605d5c0f03$export$dcdd07dcad6adb98);
$parcel$export(module.exports, "getRangeSelectionAnalyticsPayload", () => $09c262605d5c0f03$export$bf6883b886d952b0);
$parcel$export(module.exports, "createSelectionClickHandler", () => $09c262605d5c0f03$export$563f7987ca7936f1);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $3lIcL = parcelRequire("3lIcL");

var $cwzAY = parcelRequire("cwzAY");

var $4fn0w = parcelRequire("4fn0w");

var $bMFKb = parcelRequire("bMFKb");

var $5n5Zn = parcelRequire("5n5Zn");

var $6BNUN = parcelRequire("6BNUN");

var $gEqKI = parcelRequire("gEqKI");

var $cm19r = parcelRequire("cm19r");

var $8TSsQ = parcelRequire("8TSsQ");

var $6zZWQ = parcelRequire("6zZWQ");

var $3N6pN = parcelRequire("3N6pN");

var $iqjsw = parcelRequire("iqjsw");
function $09c262605d5c0f03$export$3162c38157c33ee6(selection) {
    if (selection instanceof (0, $3lIcL.NodeSelection)) return {
        action: (0, $bMFKb.ACTION).SELECTED,
        actionSubject: (0, $bMFKb.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).NODE,
        eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
        attributes: {
            node: selection.node.type.name
        }
    };
}
function $09c262605d5c0f03$export$9f3a063378bdcaa1(selection) {
    if (selection instanceof (0, $3lIcL.AllSelection)) return {
        action: (0, $bMFKb.ACTION).SELECTED,
        actionSubject: (0, $bMFKb.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).ALL,
        eventType: (0, $bMFKb.EVENT_TYPE).TRACK
    };
}
function $09c262605d5c0f03$export$dcdd07dcad6adb98(state) {
    if (state.selection instanceof (0, $cwzAY.CellSelection)) {
        const rect = (0, $4fn0w.selectedRect)(state);
        const selectedCells = rect.map.cellsInRect(rect).length;
        const totalCells = rect.map.map.length;
        return {
            action: (0, $bMFKb.ACTION).SELECTED,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).DOCUMENT,
            actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).CELL,
            eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
            attributes: {
                selectedCells: selectedCells,
                totalCells: totalCells
            }
        };
    }
}
function $09c262605d5c0f03$export$bf6883b886d952b0(selection, doc) {
    if (selection instanceof (0, $3lIcL.TextSelection) && selection.from !== selection.to) {
        const { from: from, to: to, anchor: anchor, head: head } = selection;
        const nodes = [];
        doc.nodesBetween(from, to, (node, pos)=>{
            // We want to send top-level nodes only, ie.the nodes that would have the selection styling
            // We allow text nodes that are not fully covered as they are a special case
            if (node.isText || pos >= from && pos + node.nodeSize <= to) {
                nodes.push(node.type.name);
                return false;
            }
        });
        return {
            action: (0, $bMFKb.ACTION).SELECTED,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).DOCUMENT,
            actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).RANGE,
            eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
            attributes: {
                from: anchor,
                to: head,
                nodes: nodes
            }
        };
    }
}
const $09c262605d5c0f03$export$cbcb4f775d907a9e = (pos)=>(state, dispatch)=>{
        if (dispatch) dispatch(state.tr.setSelection(new (0, $3lIcL.NodeSelection)(state.doc.resolve(pos))));
        return true;
    };
function $09c262605d5c0f03$export$563f7987ca7936f1(nodes, isValidTarget, options) {
    return function handleClickOn(view, pos, node, nodePos, event, direct) {
        if (options.useLongPressSelection) return false;
        if (direct && nodes.indexOf(node.type.name) !== -1) {
            const target = event.target;
            if (target instanceof HTMLElement && isValidTarget(target)) {
                const selectionPos = options.getNodeSelectionPos ? options.getNodeSelectionPos(view.state, nodePos) : nodePos;
                $09c262605d5c0f03$export$cbcb4f775d907a9e(selectionPos)(view.state, view.dispatch);
                return true;
            }
        }
        return false;
    };
}

});
parcelRegister("4fn0w", function(module, exports) {

$parcel$export(module.exports, "selectedRect", () => $351d80593845a142$export$39ce22e69aa9ed17);

var $cwzAY = parcelRequire("cwzAY");

var $2vA54 = parcelRequire("2vA54");

var $a57M0 = parcelRequire("a57M0");
function $351d80593845a142$export$39ce22e69aa9ed17(state) {
    const sel = state.selection;
    const $pos = (0, $a57M0.selectionCell)(sel);
    if (!$pos) throw new Error(`selectedRect: invalid $pos for selection`);
    const table = $pos.node(-1);
    const tableStart = $pos.start(-1);
    const map = (0, $2vA54.TableMap).get(table);
    let rect;
    if (sel instanceof (0, $cwzAY.CellSelection)) rect = map.rectBetween(sel.$anchorCell.pos - tableStart, sel.$headCell.pos - tableStart);
    else rect = map.findCell($pos.pos - tableStart);
    rect.tableStart = tableStart;
    rect.map = map;
    rect.table = table;
    return rect;
}

});
parcelRegister("a57M0", function(module, exports) {

$parcel$export(module.exports, "selectionCell", () => $519e662fb5a9bfe0$export$aad75348c8f2d244);

var $cSPHa = parcelRequire("cSPHa");

var $6dtFv = parcelRequire("6dtFv");
function $519e662fb5a9bfe0$export$aad75348c8f2d244(selection) {
    if ((0, $6dtFv.isSelectionType)(selection, 'cell')) return selection.$anchorCell.pos > selection.$headCell.pos ? selection.$anchorCell : selection.$headCell;
    if ((0, $6dtFv.isSelectionType)(selection, 'node') && selection.node.type.spec.tableRole === 'cell') return selection.$anchor;
    return (0, $cSPHa.cellAround)(selection.$head) || (0, $cSPHa.cellNear)(selection.$head);
}

});
parcelRegister("6dtFv", function(module, exports) {

$parcel$export(module.exports, "isSelectionType", () => $05939f259ca4311e$export$626dcc173023aed7);
function $05939f259ca4311e$export$626dcc173023aed7(selection, type) {
    if (!selection) return false;
    const serialized = selection.toJSON();
    return serialized.type === type;
}

});



parcelRegister("5n5Zn", function(module, exports) {

$parcel$export(module.exports, "RelativeSelectionPos", () => $2fdbd9918acdbc6c$export$cb9005d223ae8de7);
var $2fdbd9918acdbc6c$export$cb9005d223ae8de7 = /*#__PURE__*/ function(RelativeSelectionPos) {
    RelativeSelectionPos["Before"] = "Before";
    RelativeSelectionPos["Start"] = "Start";
    RelativeSelectionPos["Inside"] = "Inside";
    RelativeSelectionPos["End"] = "End";
    return RelativeSelectionPos;
}({});

});

parcelRegister("6zZWQ", function(module, exports) {

$parcel$export(module.exports, "setGapCursorSelection", () => $46b7320c96bd71cd$export$a8946811e8b82dd);

var $6BNUN = parcelRequire("6BNUN");
function $46b7320c96bd71cd$export$a8946811e8b82dd(view, pos, side) {
    const { state: state } = view;
    view.dispatch(state.tr.setSelection(new (0, $6BNUN.GapCursorSelection)(state.doc.resolve(pos), side)));
}

});

parcelRegister("iqjsw", function(module, exports) {

$parcel$export(module.exports, "isSelectionAtStartOfNode", () => $40db8b6c9f98bf36$export$2543715425b0bf0b);
$parcel$export(module.exports, "isSelectionAtEndOfNode", () => $40db8b6c9f98bf36$export$5762916b8b83bc6d);
$parcel$export(module.exports, "atTheEndOfDoc", () => $40db8b6c9f98bf36$export$4ca816540352da02);
$parcel$export(module.exports, "atTheBeginningOfDoc", () => $40db8b6c9f98bf36$export$e9083e8cbe24bec0);
$parcel$export(module.exports, "atTheEndOfBlock", () => $40db8b6c9f98bf36$export$6f303ca7dac350ae);
$parcel$export(module.exports, "endPositionOfParent", () => $40db8b6c9f98bf36$export$8e09b50c60354750);
$parcel$export(module.exports, "atTheBeginningOfBlock", () => $40db8b6c9f98bf36$export$8351d833af62ae68);
$parcel$export(module.exports, "startPositionOfParent", () => $40db8b6c9f98bf36$export$ced77c72038c89cb);

var $3lIcL = parcelRequire("3lIcL");

var $eGOwo = parcelRequire("eGOwo");

var $6BNUN = parcelRequire("6BNUN");
const $40db8b6c9f98bf36$export$2543715425b0bf0b = ($pos, parentNode)=>{
    if (!parentNode) return false;
    for(let i = $pos.depth + 1; i > 0; i--){
        const node = $pos.node(i);
        if (node && node.eq(parentNode)) break;
        if (i > 1 && $pos.before(i) !== $pos.before(i - 1) + 1) return false;
    }
    return true;
};
const $40db8b6c9f98bf36$export$5762916b8b83bc6d = ($pos, parentNode)=>{
    if (!parentNode) return false;
    for(let i = $pos.depth + 1; i > 0; i--){
        const node = $pos.node(i);
        if (node && node.eq(parentNode)) break;
        if (i > 1 && $pos.after(i) !== $pos.after(i - 1) - 1) return false;
    }
    return true;
};
function $40db8b6c9f98bf36$export$4ca816540352da02(state) {
    const { selection: selection, doc: doc } = state;
    return doc.nodeSize - selection.$to.pos - 2 === selection.$to.depth;
}
function $40db8b6c9f98bf36$export$e9083e8cbe24bec0(state) {
    const { selection: selection } = state;
    return selection.$from.pos === selection.$from.depth;
}
function $40db8b6c9f98bf36$export$6f303ca7dac350ae(state) {
    const { selection: selection } = state;
    const { $to: $to } = selection;
    if (selection instanceof (0, $6BNUN.GapCursorSelection)) return false;
    if (selection instanceof (0, $3lIcL.NodeSelection) && selection.node.isBlock) return true;
    return $40db8b6c9f98bf36$export$8e09b50c60354750($to) === $to.pos + 1;
}
function $40db8b6c9f98bf36$export$8351d833af62ae68(state) {
    const { selection: selection } = state;
    const { $from: $from } = selection;
    if (selection instanceof (0, $6BNUN.GapCursorSelection)) return false;
    if (selection instanceof (0, $3lIcL.NodeSelection) && selection.node.isBlock) return true;
    return $40db8b6c9f98bf36$export$ced77c72038c89cb($from) === $from.pos;
}
function $40db8b6c9f98bf36$export$ced77c72038c89cb(resolvedPos) {
    return resolvedPos.start(resolvedPos.depth);
}
function $40db8b6c9f98bf36$export$8e09b50c60354750(resolvedPos) {
    return resolvedPos.end(resolvedPos.depth) + 1;
}
const $40db8b6c9f98bf36$export$748c2428d313e6d0 = ($anchor, $head)=>{
    const sharedDepth = $anchor.sharedDepth($head.pos) + 1;
    const $from = $anchor.min($head);
    const $to = $anchor.max($head);
    const fromDepth = $from.depth;
    const toDepth = $to.depth;
    let selectionStart;
    let selectionEnd;
    const selectionHasGrandparent = toDepth > 1 && fromDepth > 1;
    const selectionIsAcrossDiffParents = selectionHasGrandparent && !$to.parent.isTextblock && !$to.sameParent($from);
    const selectionIsAcrossTextBlocksWithDiffParents = selectionHasGrandparent && $to.parent.isTextblock && $to.before(toDepth - 1) !== $from.before(fromDepth - 1);
    if (toDepth > fromDepth) {
        if ((0, $eGOwo.fg)('platform_editor_elements_dnd_multi_select_patch_1')) {
            selectionStart = $from.before(sharedDepth);
            selectionEnd = $to.after(sharedDepth);
        } else {
            selectionStart = fromDepth ? $from.before() : $from.pos;
            selectionEnd = fromDepth ? $to.after(fromDepth) : $to.after(1);
        }
    } else if (toDepth < fromDepth) {
        if ((0, $eGOwo.fg)('platform_editor_elements_dnd_multi_select_patch_1')) {
            selectionStart = $from.before(sharedDepth);
            selectionEnd = $to.after(sharedDepth);
        } else {
            selectionStart = toDepth ? $from.before(toDepth) : $from.before(1);
            selectionEnd = toDepth ? $to.after() : $to.pos;
        }
    } else if (selectionIsAcrossDiffParents || selectionIsAcrossTextBlocksWithDiffParents) {
        // when selection from/to share same depth with different parents, hoist up the selection to the parent of the highest depth in the selection
        if ((0, $eGOwo.fg)('platform_editor_elements_dnd_multi_select_patch_1')) {
            selectionStart = $from.before(sharedDepth);
            selectionEnd = $to.after(sharedDepth);
        } else {
            selectionStart = $from.before(fromDepth - 1);
            selectionEnd = $to.after(toDepth - 1);
        }
    } else if (!$from.node().inlineContent) // when selection might be a Node selection, return what was passed in
    return {
        $anchor: $anchor,
        $head: $head
    };
    else {
        selectionStart = fromDepth ? $from.before() : $from.pos;
        selectionEnd = toDepth ? $to.after() : $to.pos;
    }
    const $expandedFrom = $anchor.doc.resolve(selectionStart);
    const $expandedTo = $anchor.doc.resolve(selectionEnd);
    return {
        $anchor: $anchor === $from ? $expandedFrom : $expandedTo,
        $head: $head === $to ? $expandedTo : $expandedFrom
    };
};

});



parcelRegister("3exxz", function(module, exports) {

$parcel$export(module.exports, "clipboardPluginKey", () => $8b2b01696d09b032$export$7ff3d0e65871bad3);

var $3lIcL = parcelRequire("3lIcL");
const $8b2b01696d09b032$export$7ff3d0e65871bad3 = new (0, $3lIcL.PluginKey)('clipboardPlugin');

});




parcelRegister("b8wHL", function(module, exports) {

$parcel$export(module.exports, "compositionPlugin", () => (parcelRequire("lTMvj")).compositionPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $lTMvj = parcelRequire("lTMvj");

});
parcelRegister("lTMvj", function(module, exports) {

$parcel$export(module.exports, "compositionPlugin", () => $9084af76a60c3c01$export$afd1652ef5208b);

var $2lXaz = parcelRequire("2lXaz");

var $3fHwZ = parcelRequire("3fHwZ");
const $9084af76a60c3c01$export$afd1652ef5208b = ()=>{
    return {
        name: 'composition',
        getSharedState (editorState) {
            if (!editorState) return {
                isComposing: false
            };
            return {
                isComposing: !!(0, $3fHwZ.pluginKey).getState(editorState)?.isComposing
            };
        },
        pmPlugins () {
            return [
                {
                    name: 'composition',
                    plugin: ()=>(0, $2lXaz.default)()
                }
            ];
        }
    };
};

});
parcelRegister("2lXaz", function(module, exports) {

$parcel$export(module.exports, "default", () => $44b1a75a37d715e3$export$2e2bcd8739ae039);

var $i8KtF = parcelRequire("i8KtF");


var $3fHwZ = parcelRequire("3fHwZ");
const $44b1a75a37d715e3$var$isLinux = ()=>navigator.userAgent.indexOf('Linux') >= 0;
var $44b1a75a37d715e3$export$2e2bcd8739ae039 = ()=>new (0, $i8KtF.SafePlugin)({
        key: (0, $3fHwZ.pluginKey),
        state: {
            init: ()=>({
                    isComposing: false,
                    zeroWidthSpacePos: undefined
                }),
            apply: (tr, value)=>{
                const isComposing = tr.getMeta((0, $3fHwZ.pluginKey));
                const zeroWidthSpacePos = tr.getMeta('zeroWidthSpacePos');
                if (typeof isComposing === 'undefined') return value;
                return {
                    isComposing: isComposing,
                    zeroWidthSpacePos: zeroWidthSpacePos
                };
            }
        },
        props: {
            handleDOMEvents: {
                compositionstart: (view, event)=>{
                    const { tr: tr } = view.state;
                    tr.setMeta((0, $3fHwZ.pluginKey), true);
                    // only apply for linux and cursor is at start of line
                    if ($44b1a75a37d715e3$var$isLinux() && view.state.selection.$from.parentOffset === 0) {
                        tr.insertText((0, $f9e41f230eb38f84$export$15a09f5ef055bcfa));
                        // remember the position of inserted zero width space
                        tr.setMeta('zeroWidthSpacePos', view.state.selection.$from.pos);
                    }
                    view.dispatch(tr);
                    return false;
                },
                compositionend: (view, event)=>{
                    const { tr: tr } = view.state;
                    tr.setMeta((0, $3fHwZ.pluginKey), false);
                    if ($44b1a75a37d715e3$var$isLinux()) {
                        const zeroWidthSpacePos = (0, $3fHwZ.pluginKey).getState(view.state)?.zeroWidthSpacePos;
                        if (typeof zeroWidthSpacePos !== 'undefined') tr.deleteRange(zeroWidthSpacePos, zeroWidthSpacePos + 1);
                        tr.setMeta('zeroWidthSpacePos', undefined);
                    }
                    view.dispatch(tr);
                    return false;
                }
            }
        }
    });

});
parcelRegister("3fHwZ", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $56ec35762a00da13$export$18d4026d1ea86bb1);

var $3lIcL = parcelRequire("3lIcL");
const $56ec35762a00da13$export$18d4026d1ea86bb1 = new (0, $3lIcL.PluginKey)('compositionPlugin');

});




parcelRegister("cZNzR", function(module, exports) {

$parcel$export(module.exports, "copyButtonPlugin", () => (parcelRequire("4H0bV")).copyButtonPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $4H0bV = parcelRequire("4H0bV");

});
parcelRegister("4H0bV", function(module, exports) {

$parcel$export(module.exports, "copyButtonPlugin", () => $564122ed4bc3c3af$export$ea22bdb37423f02c);

var $hTRyK = parcelRequire("hTRyK");

var $8p4Ku = parcelRequire("8p4Ku");
const $564122ed4bc3c3af$export$ea22bdb37423f02c = ({ api: api })=>({
        name: 'copyButton',
        pmPlugins () {
            return [
                {
                    name: 'copyButton',
                    plugin: ()=>(0, $hTRyK.default)()
                }
            ];
        },
        actions: {
            processCopyButtonItems: (0, $8p4Ku.processCopyButtonItems)(api?.analytics?.actions, api)
        }
    });

});
parcelRegister("hTRyK", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9c58c3677587314$export$2e2bcd8739ae039);

var $i8KtF = parcelRequire("i8KtF");

var $b7EWj = parcelRequire("b7EWj");

var $6XtUa = parcelRequire("6XtUa");
function $e9c58c3677587314$export$6867b9cd7a8c8a75({ $pos: $pos, markType: markType }) {
    const hasMark = $pos.doc.rangeHasMark($pos.pos, Math.min($pos.pos + 1, $pos.doc.nodeSize), markType);
    if (!hasMark) return false;
    if ($pos.parent.childCount === 1) {
        const nodePosition = $pos.pos;
        const maybeNode = $pos.doc.nodeAt(nodePosition);
        if (!maybeNode || !maybeNode.isText) return false;
        const start = $pos.pos - $pos.parentOffset;
        const end = start + maybeNode.nodeSize;
        return {
            start: start,
            end: end
        };
    }
    if ($pos.parent.childCount > 1) {
        const start = $pos.pos - $pos.textOffset;
        const maybeTextNode = $pos.doc.nodeAt(start);
        if (!maybeTextNode || !maybeTextNode.isText) return false;
        const end = start + maybeTextNode.nodeSize;
        return {
            start: start,
            end: end
        };
    }
    return false;
}
function $e9c58c3677587314$var$getMarkSelectionDecorationStartAndEnd({ markType: markType, transaction: transaction }) {
    const anchorPositions = $e9c58c3677587314$export$6867b9cd7a8c8a75({
        $pos: transaction.selection.$anchor,
        markType: markType
    });
    if (anchorPositions) return {
        ...anchorPositions,
        markType: markType
    };
    const headPositions = $e9c58c3677587314$export$6867b9cd7a8c8a75({
        $pos: transaction.selection.$head,
        markType: markType
    });
    if (headPositions) return {
        ...headPositions,
        markType: markType
    };
    return undefined;
}
function $e9c58c3677587314$export$ea22bdb37423f02c() {
    return new (0, $i8KtF.SafePlugin)({
        key: (0, $6XtUa.copyButtonPluginKey),
        state: {
            init () {
                return {
                    copied: false,
                    markSelection: undefined
                };
            },
            apply (tr, currentPluginState) {
                const meta = tr.getMeta((0, $6XtUa.copyButtonPluginKey));
                if (meta?.copied !== undefined) return {
                    copied: meta.copied,
                    markSelection: undefined
                };
                if (meta?.showSelection) return {
                    copied: currentPluginState.copied,
                    markSelection: $e9c58c3677587314$var$getMarkSelectionDecorationStartAndEnd({
                        markType: meta.markType,
                        transaction: tr
                    })
                };
                if (meta?.removeSelection) return {
                    copied: currentPluginState.copied,
                    markSelection: undefined
                };
                if (currentPluginState.markSelection) return {
                    copied: currentPluginState.copied,
                    markSelection: $e9c58c3677587314$var$getMarkSelectionDecorationStartAndEnd({
                        markType: currentPluginState.markSelection.markType,
                        transaction: tr
                    })
                };
                return currentPluginState;
            }
        },
        props: {
            decorations (_state) {
                // Showing visual hints for the hyperlink copy button has been disabled
                // due to an issue where invalid hyperlink marks cause the floating toolbar
                // to jump around when the copy button is hovered.
                // See the following bug for details -- once that is resolved -- the visual
                // hints can be re enabled.
                // https://product-fabric.atlassian.net/browse/DTR-722
                // const copyButtonPluginState = copyButtonPluginKey.getState(
                //   state,
                // ) as CopyButtonPluginState;
                // if (copyButtonPluginState.markSelection) {
                //   const { start, end } = copyButtonPluginState.markSelection;
                //   return DecorationSet.create(state.doc, [
                //     Decoration.inline(start, end, {
                //       class: 'ProseMirror-fake-text-selection',
                //     }),
                //   ]);
                // }
                return (0, $b7EWj.DecorationSet).empty;
            }
        }
    });
}
var $e9c58c3677587314$export$2e2bcd8739ae039 = $e9c58c3677587314$export$ea22bdb37423f02c;

});
parcelRegister("6XtUa", function(module, exports) {

$parcel$export(module.exports, "copyButtonPluginKey", () => $bfc4a395a71e5ec3$export$e41a18c2cdafffa9);

var $3lIcL = parcelRequire("3lIcL");
const $bfc4a395a71e5ec3$export$e41a18c2cdafffa9 = new (0, $3lIcL.PluginKey)('copyButtonPlugin');

});


parcelRegister("8p4Ku", function(module, exports) {

$parcel$export(module.exports, "processCopyButtonItems", () => $ef5cce76d7c36fc7$export$f61ed03c42ac876f);

var $h2yqz = parcelRequire("h2yqz");

var $4TA31 = parcelRequire("4TA31");

var $jBChJ = parcelRequire("jBChJ");

var $6XtUa = parcelRequire("6XtUa");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $ef5cce76d7c36fc7$var$isSeparator(item) {
    return item?.type === 'separator';
}
function $ef5cce76d7c36fc7$var$isNodeOptions(options) {
    return 'nodeType' in options && options.nodeType !== undefined;
}
function $ef5cce76d7c36fc7$export$518afae27d2d4b23(options, hoverDecoration, editorAnalyticsApi, api) {
    const { state: state, formatMessage: formatMessage, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onFocus: onFocus, onBlur: onBlur } = options;
    const copyButtonState = (0, $6XtUa.copyButtonPluginKey).getState(state);
    let buttonActionHandlers;
    if ($ef5cce76d7c36fc7$var$isNodeOptions(options)) buttonActionHandlers = {
        onClick: (0, $jBChJ.createToolbarCopyCommandForNode)(options.nodeType, editorAnalyticsApi, api, formatMessage((0, $h2yqz.default).copiedToClipboard)),
        // Note for future changes: these two handlers should perform
        // the same action.
        onMouseEnter: onMouseEnter || hoverDecoration?.(options.nodeType, true, 'ak-editor-selected-node'),
        onFocus: onFocus || hoverDecoration?.(options.nodeType, true, 'ak-editor-selected-node'),
        // Note for future changes: these two handlers should perform
        // the same action.
        onMouseLeave: (0, $jBChJ.resetCopiedState)(options.nodeType, hoverDecoration, onMouseLeave),
        onBlur: (0, $jBChJ.resetCopiedState)(options.nodeType, hoverDecoration, onBlur)
    };
    else buttonActionHandlers = {
        onClick: (0, $jBChJ.createToolbarCopyCommandForMark)(options.markType, editorAnalyticsApi),
        onMouseEnter: (0, $jBChJ.getProvideMarkVisualFeedbackForCopyButtonCommand)(options.markType),
        onFocus: (0, $jBChJ.getProvideMarkVisualFeedbackForCopyButtonCommand)(options.markType),
        onMouseLeave: (0, $jBChJ.removeMarkVisualFeedbackForCopyButtonCommand),
        onBlur: (0, $jBChJ.removeMarkVisualFeedbackForCopyButtonCommand)
    };
    return {
        id: 'editor.floatingToolbar.copy',
        type: 'button',
        appearance: 'subtle',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4TA31))),
        title: formatMessage(copyButtonState?.copied ? (0, $h2yqz.default).copiedToClipboard : (0, $h2yqz.default).copyToClipboard),
        ...buttonActionHandlers,
        hideTooltipOnClick: false,
        tabIndex: null
    };
}
const $ef5cce76d7c36fc7$export$f61ed03c42ac876f = (editorAnalyticsApi, api)=>(state)=>{
        return (items, hoverDecoration)=>items.flatMap((item)=>{
                switch(item.type){
                    case 'copy-button':
                        if (item?.hidden) return [];
                        return item?.items.map((copyButtonItem)=>$ef5cce76d7c36fc7$var$isSeparator(copyButtonItem) ? copyButtonItem : $ef5cce76d7c36fc7$export$518afae27d2d4b23(copyButtonItem, hoverDecoration, editorAnalyticsApi, api));
                    default:
                        return [
                            item
                        ];
                }
            });
    };

});
parcelRegister("jBChJ", function(module, exports) {

$parcel$export(module.exports, "createToolbarCopyCommandForMark", () => $44f34e302f022356$export$61f33363e77ed28);
$parcel$export(module.exports, "getProvideMarkVisualFeedbackForCopyButtonCommand", () => $44f34e302f022356$export$5887c7b152626490);
$parcel$export(module.exports, "removeMarkVisualFeedbackForCopyButtonCommand", () => $44f34e302f022356$export$e52b1d5c60d367b8);
$parcel$export(module.exports, "createToolbarCopyCommandForNode", () => $44f34e302f022356$export$be806b3b778a7682);
$parcel$export(module.exports, "resetCopiedState", () => $44f34e302f022356$export$3e0b07341e7576a);

var $bMFKb = parcelRequire("bMFKb");

var $7EdFW = parcelRequire("7EdFW");

var $58hN2 = parcelRequire("58hN2");

var $e5Nsc = parcelRequire("e5Nsc");

var $3lIcL = parcelRequire("3lIcL");

var $eGOwo = parcelRequire("eGOwo");

var $6XtUa = parcelRequire("6XtUa");
function $44f34e302f022356$export$61f33363e77ed28(markType, editorAnalyticsApi) {
    function command(state, dispatch) {
        const textNode = state.tr.selection.$head.parent.maybeChild(state.tr.selection.$head.index());
        if (!textNode) return false;
        if (dispatch) {
            // As calling copyHTMLToClipboard causes side effects -- we only run this when
            // dispatch is provided -- as otherwise the consumer is only testing to see if
            // the action is availble.
            const domNode = (0, $e5Nsc.toDOM)(textNode, state.schema);
            if (domNode) {
                const div = document.createElement('div');
                const p = document.createElement('p');
                div.appendChild(p);
                p.appendChild(domNode);
                // The "1 1" refers to the start and end depth of the slice
                // since we're copying the text inside a paragraph, it will always be 1 1
                // https://github.com/ProseMirror/prosemirror-view/blob/master/src/clipboard.ts#L32
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                div.firstChild.setAttribute('data-pm-slice', '1 1 []');
                // If we're copying a hyperlink, we'd copy the url as the fallback plain text
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const linkUrl = domNode.getAttribute('href');
                (0, $58hN2.copyHTMLToClipboard)(div, markType.name === 'link' && linkUrl ? linkUrl : undefined);
            }
            const copyToClipboardTr = state.tr;
            copyToClipboardTr.setMeta((0, $6XtUa.copyButtonPluginKey), {
                copied: true
            });
            const analyticsPayload = (0, $58hN2.getAnalyticsPayload)(state, (0, $bMFKb.ACTION).COPIED);
            if (analyticsPayload && editorAnalyticsApi) {
                analyticsPayload.attributes.inputMethod = (0, $bMFKb.INPUT_METHOD).FLOATING_TB;
                analyticsPayload.attributes.markType = markType.name;
                editorAnalyticsApi?.attachAnalyticsEvent?.(analyticsPayload)(copyToClipboardTr);
            }
            dispatch(copyToClipboardTr);
        }
        return true;
    }
    return command;
}
function $44f34e302f022356$export$5887c7b152626490(markType) {
    function provideMarkVisualFeedbackForCopyButtonCommand(state, dispatch) {
        const tr = state.tr;
        tr.setMeta((0, $6XtUa.copyButtonPluginKey), {
            showSelection: true,
            markType: markType
        });
        if (dispatch) dispatch(tr);
        return true;
    }
    return provideMarkVisualFeedbackForCopyButtonCommand;
}
function $44f34e302f022356$export$e52b1d5c60d367b8(state, dispatch) {
    const tr = state.tr;
    tr.setMeta((0, $6XtUa.copyButtonPluginKey), {
        removeSelection: true
    });
    const copyButtonState = (0, $6XtUa.copyButtonPluginKey).getState(state);
    if (copyButtonState?.copied) tr.setMeta((0, $6XtUa.copyButtonPluginKey), {
        copied: false
    });
    if (dispatch) dispatch(tr);
    return true;
}
const $44f34e302f022356$export$be806b3b778a7682 = (nodeType, editorAnalyticsApi, api, onClickMessage)=>(state, dispatch)=>{
        const { tr: tr, schema: schema } = state;
        // This command should only be triggered by the Copy button in the floating toolbar
        // which is only visible when selection is inside the target node
        const contentNodeWithPos = (0, $e5Nsc.getSelectedNodeOrNodeParentByNodeType)({
            nodeType: nodeType,
            selection: tr.selection
        });
        if (!contentNodeWithPos) return false;
        const copyToClipboardTr = tr;
        copyToClipboardTr.setMeta((0, $6XtUa.copyButtonPluginKey), {
            copied: true
        });
        const analyticsPayload = (0, $58hN2.getAnalyticsPayload)(state, (0, $bMFKb.ACTION).COPIED);
        if (analyticsPayload && editorAnalyticsApi) {
            analyticsPayload.attributes.inputMethod = (0, $bMFKb.INPUT_METHOD).FLOATING_TB;
            analyticsPayload.attributes.nodeType = contentNodeWithPos.node.type.name;
            editorAnalyticsApi?.attachAnalyticsEvent?.(analyticsPayload)(copyToClipboardTr);
        }
        if (dispatch) {
            // As calling copyHTMLToClipboard causes side effects -- we only run this when
            // dispatch is provided -- as otherwise the consumer is only testing to see if
            // the action is availble.
            const domNode = (0, $e5Nsc.toDOM)(contentNodeWithPos.node, schema);
            if (domNode) {
                const div = document.createElement('div');
                div.appendChild(domNode);
                // if copying inline content
                if (contentNodeWithPos.node.type.inlineContent) // The "1 1" refers to the start and end depth of the slice
                // since we're copying the text inside a paragraph, it will always be 1 1
                // https://github.com/ProseMirror/prosemirror-view/blob/master/src/clipboard.ts#L32
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                div.firstChild.setAttribute('data-pm-slice', '1 1 []');
                else // The "0 0" refers to the start and end depth of the slice
                // since we're copying the block node only, it will always be 0 0
                // https://github.com/ProseMirror/prosemirror-view/blob/master/src/clipboard.ts#L32
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                div.firstChild.setAttribute('data-pm-slice', '0 0 []');
                // ED-17083 safari seems have bugs for extension copy because exntension do not have a child text(innerText) and it will not recognized as html in clipboard, this could be merge into one if this extension fixed children issue or safari fix the copy bug
                // MEX-2528 safari has a bug related to the mediaSingle node with border or link. The image tag within the clipboard is not recognized as HTML when using the ClipboardItem API. To address this, we have to switch to ClipboardPolyfill
                if ((0, $7EdFW.browser).safari && state.selection instanceof (0, $3lIcL.NodeSelection) && (state.selection.node.type === state.schema.nodes.extension || state.selection.node.type === state.schema.nodes.mediaSingle)) (0, $58hN2.copyHTMLToClipboardPolyfill)(div);
                else (0, $58hN2.copyHTMLToClipboard)(div);
            }
            copyToClipboardTr.setMeta('scrollIntoView', false);
            dispatch(copyToClipboardTr);
        }
        /**
		 * A11y-10275 This prop api drilled from the plugin all the way down to the usage
		 * because it's the safest way to ensure accessibilityUtils is available and not
		 * undefined.
		 *
		 * see thread https://atlassian.slack.com/archives/C02CDUS3SUS/p1744256326459569
		 */ if (onClickMessage && (0, $eGOwo.fg)('editor_a11y_aria_announcement_for_copied_status')) api?.accessibilityUtils?.actions.ariaNotify(onClickMessage, {
            priority: 'important'
        });
        return true;
    };
const $44f34e302f022356$export$3e0b07341e7576a = (nodeType, hoverDecoration, onMouseLeave)=>(state, dispatch)=>{
        let customTr = state.tr;
        // Avoid multipe dispatch
        // https://product-fabric.atlassian.net/wiki/spaces/E/pages/2241659456/All+about+dispatch+and+why+there+shouldn+t+be+multiple#How-do-I-avoid-them%3F
        const customDispatch = (tr)=>{
            customTr = tr;
        };
        onMouseLeave ? onMouseLeave(state, customDispatch) : hoverDecoration?.(nodeType, false)(state, customDispatch);
        const copyButtonState = (0, $6XtUa.copyButtonPluginKey).getState(state);
        if (copyButtonState?.copied) customTr.setMeta((0, $6XtUa.copyButtonPluginKey), {
            copied: false
        });
        if (dispatch) dispatch(customTr);
        return true;
    };

});
parcelRegister("e5Nsc", function(module, exports) {

$parcel$export(module.exports, "getSelectedNodeOrNodeParentByNodeType", () => $4be08fc0f886407d$export$64477bc469482fd0);
$parcel$export(module.exports, "toDOM", () => $4be08fc0f886407d$export$289411c5a7970646);

var $3xw6l = parcelRequire("3xw6l");

var $BmspC = parcelRequire("BmspC");
function $4be08fc0f886407d$export$64477bc469482fd0({ nodeType: nodeType, selection: selection }) {
    let node = (0, $BmspC.findSelectedNodeOfType)(nodeType)(selection);
    if (!node) node = (0, $BmspC.findParentNodeOfType)(nodeType)(selection);
    return node;
}
const $4be08fc0f886407d$export$289411c5a7970646 = (node, schema)=>{
    return (0, $3xw6l.DOMSerializer).fromSchema(schema).serializeNode(node);
};

});





parcelRegister("30v6T", function(module, exports) {

$parcel$export(module.exports, "decorationsPlugin", () => (parcelRequire("88434")).decorationsPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $88434 = parcelRequire("88434");

});
parcelRegister("88434", function(module, exports) {

$parcel$export(module.exports, "decorationsPlugin", () => $dd7c9b5c239a1620$export$1c07ef1814918eb5);

var $lFhVg = parcelRequire("lFhVg");
const $dd7c9b5c239a1620$export$1c07ef1814918eb5 = ()=>({
        name: 'decorations',
        pmPlugins () {
            return [
                {
                    name: 'decorationPlugin',
                    plugin: ()=>(0, $lFhVg.default)()
                }
            ];
        },
        actions: {
            hoverDecoration: $lFhVg.hoverDecoration,
            removeDecoration: $lFhVg.removeDecoration
        },
        getSharedState (editorState) {
            if (!editorState) return {
                decoration: undefined
            };
            return (0, $lFhVg.decorationStateKey).getState(editorState);
        }
    });

});
parcelRegister("lFhVg", function(module, exports) {

$parcel$export(module.exports, "decorationStateKey", () => $1dc8fc1d38aeb2a7$export$385f768f10dabdd5);
$parcel$export(module.exports, "removeDecoration", () => $1dc8fc1d38aeb2a7$export$ea377ae2b4b58797);
$parcel$export(module.exports, "hoverDecoration", () => $1dc8fc1d38aeb2a7$export$fbf24964a8aac61c);
$parcel$export(module.exports, "default", () => $1dc8fc1d38aeb2a7$export$2e2bcd8739ae039);

var $i8KtF = parcelRequire("i8KtF");

var $3lIcL = parcelRequire("3lIcL");

var $BmspC = parcelRequire("BmspC");

var $b7EWj = parcelRequire("b7EWj");
const $1dc8fc1d38aeb2a7$export$385f768f10dabdd5 = new (0, $3lIcL.PluginKey)('decorationPlugin');
var $1dc8fc1d38aeb2a7$export$92a1a3b7554e9387 = /*#__PURE__*/ function(ACTIONS) {
    ACTIONS[ACTIONS["DECORATION_ADD"] = 0] = "DECORATION_ADD";
    ACTIONS[ACTIONS["DECORATION_REMOVE"] = 1] = "DECORATION_REMOVE";
    return ACTIONS;
}({});
const $1dc8fc1d38aeb2a7$export$ea377ae2b4b58797 = (state, dispatch)=>{
    const { tr: tr } = state;
    const { decoration: decoration } = $1dc8fc1d38aeb2a7$export$385f768f10dabdd5.getState(state);
    if (decoration && dispatch) {
        dispatch(tr.setMeta($1dc8fc1d38aeb2a7$export$385f768f10dabdd5, {
            action: 1
        }));
        return true;
    }
    return false;
};
const $1dc8fc1d38aeb2a7$export$fbf24964a8aac61c = (nodeType, add, className = 'danger')=>(state, dispatch)=>{
        let from;
        let parentNode;
        if (state.selection instanceof (0, $3lIcL.NodeSelection)) {
            const selectedNode = state.selection.node;
            const nodeTypes = Array.isArray(nodeType) ? nodeType : [
                nodeType
            ];
            const isNodeTypeMatching = nodeTypes.indexOf(selectedNode.type) > -1;
            // This adds danger styling if the selected node is the one that requires
            // the decoration to be added, e.g. if a layout is selected and the user
            // hovers over the layout's delete button.
            if (isNodeTypeMatching) {
                from = state.selection.from;
                parentNode = selectedNode;
            }
        }
        // This adds danger styling if the selection is not a node selection, OR if
        // the selected node is a child of the one that requires the decoration to
        // be added, e.g. if a decision item is selected inside a layout and the
        // user hovers over the layout's delete button.
        const foundParentNode = (0, $BmspC.findParentNodeOfType)(nodeType)(state.selection);
        if (from === undefined && foundParentNode) {
            from = foundParentNode.pos;
            parentNode = foundParentNode.node;
        }
        // Note: can't use !from as from could be 0, which is falsy but valid
        if (from === undefined || parentNode === undefined) return false;
        if (dispatch) dispatch(state.tr.setMeta($1dc8fc1d38aeb2a7$export$385f768f10dabdd5, {
            action: add ? 0 : 1,
            data: (0, $b7EWj.Decoration).node(from, from + parentNode.nodeSize, {
                class: className
            }, {
                key: 'decorationNode'
            })
        }).setMeta('addToHistory', false));
        return true;
    };
var $1dc8fc1d38aeb2a7$export$2e2bcd8739ae039 = ()=>{
    return new (0, $i8KtF.SafePlugin)({
        key: $1dc8fc1d38aeb2a7$export$385f768f10dabdd5,
        state: {
            init: ()=>({
                    decoration: undefined
                }),
            apply (tr, pluginState) {
                if (pluginState.decoration) {
                    const mapResult = tr.mapping.mapResult(pluginState.decoration.from);
                    if (mapResult.deleted) pluginState = {
                        decoration: undefined
                    };
                }
                const meta = tr.getMeta($1dc8fc1d38aeb2a7$export$385f768f10dabdd5);
                if (!meta) return pluginState;
                switch(meta.action){
                    case 0:
                        return {
                            decoration: meta.data
                        };
                    case 1:
                        return {
                            decoration: undefined
                        };
                    default:
                        return pluginState;
                }
            }
        },
        props: {
            decorations (state) {
                const { doc: doc } = state;
                const { decoration: decoration } = $1dc8fc1d38aeb2a7$export$385f768f10dabdd5.getState(state);
                if (decoration) return (0, $b7EWj.DecorationSet).create(doc, [
                    decoration
                ]);
                return null;
            }
        }
    });
};

});



parcelRegister("iQvAc", function(module, exports) {

$parcel$export(module.exports, "editorDisabledPlugin", () => (parcelRequire("d3sAY")).editorDisabledPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $d3sAY = parcelRequire("d3sAY");

});
parcelRegister("d3sAY", function(module, exports) {

$parcel$export(module.exports, "editorDisabledPlugin", () => $7b74f9ec744b951a$export$db5fb3a4c4390f03);

var $bRPNB = parcelRequire("bRPNB");

var $i8KtF = parcelRequire("i8KtF");

var $bazog = parcelRequire("bazog");

var $3lIcL = parcelRequire("3lIcL");
const $7b74f9ec744b951a$var$pluginKey = new (0, $3lIcL.PluginKey)('editorDisabledPlugin');
function $7b74f9ec744b951a$var$reducer(_pluginState, meta) {
    return meta;
}
const { getPluginState: $7b74f9ec744b951a$var$getPluginState } = (0, $bazog.pluginFactory)($7b74f9ec744b951a$var$pluginKey, $7b74f9ec744b951a$var$reducer);
/*
Stores the state of the editor enabled/disabled for panel and floating
toolbar to subscribe to through useSharedPluginState. Otherwise the NodeViews
won't re-render when it changes.
*/ function $7b74f9ec744b951a$var$createPlugin(dispatch, options) {
    const scheduleEditorDisabledUpdate = (0, $bRPNB.default)((view)=>{
        if ($7b74f9ec744b951a$var$getPluginState(view.state).editorDisabled !== !view.editable) {
            const disabledMeta = {
                editorDisabled: !view.editable
            };
            const tr = view.state.tr.setMeta($7b74f9ec744b951a$var$pluginKey, disabledMeta).setMeta('editorDisabledPlugin', disabledMeta);
            tr.setMeta('isLocal', true);
            view.dispatch(tr);
        }
    });
    return new (0, $i8KtF.SafePlugin)({
        key: $7b74f9ec744b951a$var$pluginKey,
        state: {
            init: ()=>{
                return {
                    editorDisabled: options?.initialDisabledState ?? false
                };
            },
            apply: (tr, pluginState)=>{
                const meta = tr.getMeta($7b74f9ec744b951a$var$pluginKey);
                if (meta) return pluginState.editorDisabled !== meta.editorDisabled ? {
                    ...pluginState,
                    ...meta
                } : pluginState;
                return pluginState;
            }
        },
        view: (view)=>{
            // schedule on mount
            scheduleEditorDisabledUpdate(view);
            return {
                update (view) {
                    scheduleEditorDisabledUpdate(view);
                },
                destroy () {
                    scheduleEditorDisabledUpdate.cancel();
                }
            };
        }
    });
}
const $7b74f9ec744b951a$export$db5fb3a4c4390f03 = ({ config: options = {}, api: api })=>({
        name: 'editorDisabled',
        getSharedState (editorState) {
            if (!editorState) return {
                editorDisabled: false
            };
            const pluginState = $7b74f9ec744b951a$var$pluginKey.getState(editorState);
            if (!pluginState) return {
                editorDisabled: false
            };
            return pluginState;
        },
        pmPlugins: ()=>[
                {
                    name: 'editorDisabled',
                    plugin: ({ dispatch: dispatch })=>$7b74f9ec744b951a$var$createPlugin(dispatch, options)
                }
            ]
    });

});


parcelRegister("3eoq7", function(module, exports) {

$parcel$export(module.exports, "featureFlagsPlugin", () => (parcelRequire("iKcba")).featureFlagsPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $iKcba = parcelRequire("iKcba");

});
parcelRegister("iKcba", function(module, exports) {

$parcel$export(module.exports, "featureFlagsPlugin", () => $a1f3b6f04e13ae1a$export$79626a094e303f80);

var $i8KtF = parcelRequire("i8KtF");

var $3lIcL = parcelRequire("3lIcL");
const $a1f3b6f04e13ae1a$var$pluginKey = new (0, $3lIcL.PluginKey)('featureFlags');
const $a1f3b6f04e13ae1a$export$79626a094e303f80 = ({ config: featureFlags = {} })=>({
        name: 'featureFlags',
        getSharedState (editorState) {
            if (!editorState) return featureFlags || {};
            return $a1f3b6f04e13ae1a$var$pluginKey.getState(editorState) || featureFlags || {};
        },
        pmPlugins () {
            return [
                {
                    name: 'featureFlags',
                    plugin: ()=>new (0, $i8KtF.SafePlugin)({
                            key: $a1f3b6f04e13ae1a$var$pluginKey,
                            state: {
                                init: ()=>({
                                        ...featureFlags
                                    }),
                                apply: (_, pluginState)=>pluginState
                            }
                        })
                }
            ];
        }
    });

});


parcelRegister("c9xno", function(module, exports) {

$parcel$export(module.exports, "floatingToolbarPlugin", () => (parcelRequire("7gUM9")).floatingToolbarPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $7gUM9 = parcelRequire("7gUM9");

});
parcelRegister("7gUM9", function(module, exports) {

$parcel$export(module.exports, "floatingToolbarPlugin", () => $b1b0f95ea4c121e3$export$baed971c987bc0e);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $7mF43 = parcelRequire("7mF43");

var $bMFKb = parcelRequire("bMFKb");

var $fNh22 = parcelRequire("fNh22");

var $28ffc = parcelRequire("28ffc");

var $bSToC = parcelRequire("bSToC");

var $4sxxB = parcelRequire("4sxxB");

var $i8KtF = parcelRequire("i8KtF");

var $avm98 = parcelRequire("avm98");

var $3lIcL = parcelRequire("3lIcL");

var $BmspC = parcelRequire("BmspC");

var $eGOwo = parcelRequire("eGOwo");

var $92xoS = parcelRequire("92xoS");

var $h9coN = parcelRequire("h9coN");

var $cIMBE = parcelRequire("cIMBE");

var $bYdnm = parcelRequire("bYdnm");

var $2M0rW = parcelRequire("2M0rW");

var $3v3t0 = parcelRequire("3v3t0");

var $ho7Ph = parcelRequire("ho7Ph");

var $hNNR4 = parcelRequire("hNNR4");

var $7es7V = parcelRequire("7es7V");

var $jFFUB = parcelRequire("jFFUB");
const $b1b0f95ea4c121e3$export$c5f0b4d19f5b8d4b = (selection, configs)=>{
    // node selections always take precedence, see if
    let configPair;
    configs.find((config)=>{
        const node = (0, $BmspC.findSelectedNodeOfType)(config.nodeType)(selection);
        if (node) configPair = {
            node: node.node,
            pos: node.pos,
            config: config
        };
        return !!node;
    });
    if (configPair) return configPair;
    // create mapping of node type name to configs
    const configByNodeType = {};
    configs.forEach((config)=>{
        if (Array.isArray(config.nodeType)) config.nodeType.forEach((nodeType)=>{
            configByNodeType[nodeType.name] = config;
        });
        else configByNodeType[config.nodeType.name] = config;
    });
    // search up the tree from selection
    const { $from: $from } = selection;
    for(let i = $from.depth; i > 0; i--){
        const node = $from.node(i);
        const matchedConfig = configByNodeType[node.type.name];
        if (matchedConfig) return {
            config: matchedConfig,
            node: node,
            pos: $from.pos
        };
    }
    // if it is AllSelection (can be result of Cmd+A) - use first node
    if (selection instanceof (0, $3lIcL.AllSelection)) {
        const docNode = $from.node(0);
        let matchedConfig = null;
        const firstChild = (0, $ho7Ph.findNode)(docNode, (node)=>{
            matchedConfig = configByNodeType[node.type.name];
            return !!matchedConfig;
        });
        if (firstChild && matchedConfig) return {
            config: matchedConfig,
            node: firstChild,
            pos: $from.pos
        };
    }
    return;
};
const $b1b0f95ea4c121e3$var$getDomRefFromSelection = (view, dispatchAnalyticsEvent)=>{
    try {
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        return (0, $BmspC.findDomRefAtPos)(view.state.selection.from, view.domAtPos.bind(view));
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // eslint-disable-next-line no-console
        console.warn(error);
        if (dispatchAnalyticsEvent) {
            const payload = {
                action: (0, $bMFKb.ACTION).ERRORED,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).CONTENT_COMPONENT,
                eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    component: (0, $bMFKb.CONTENT_COMPONENT).FLOATING_TOOLBAR,
                    selection: view.state.selection.toJSON(),
                    position: view.state.selection.from,
                    docSize: view.state.doc.nodeSize,
                    error: error.toString(),
                    // @ts-expect-error - Object literal may only specify known properties, 'errorStack' does not exist in type
                    // This error was introduced after upgrading to TypeScript 5
                    errorStack: error.stack || undefined
                }
            };
            dispatchAnalyticsEvent(payload);
        }
    }
};
function $b1b0f95ea4c121e3$var$filterUndefined(x) {
    return !!x;
}
const $b1b0f95ea4c121e3$export$baed971c987bc0e = ({ api: api })=>{
    return {
        name: 'floatingToolbar',
        pmPlugins (floatingToolbarHandlers = []) {
            const plugins = [
                {
                    // Should be after all toolbar plugins
                    name: 'floatingToolbar',
                    plugin: ({ providerFactory: providerFactory, getIntl: getIntl })=>$b1b0f95ea4c121e3$export$5c1ec0ef773ca0cc({
                            floatingToolbarHandlers: floatingToolbarHandlers,
                            providerFactory: providerFactory,
                            getIntl: getIntl
                        })
                },
                {
                    name: 'floatingToolbarData',
                    plugin: ({ dispatch: dispatch })=>(0, $2M0rW.createPlugin)(dispatch)
                },
                {
                    name: 'forceFocus',
                    plugin: ()=>(0, $cIMBE.default)()
                }
            ];
            return plugins;
        },
        actions: {
            forceFocusSelector: $cIMBE.forceFocusSelector
        },
        commands: {
            copyNode: (nodeType, inputMethod)=>(0, $h9coN.copyNode)(nodeType, api?.analytics?.actions, inputMethod)
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const interactionState = api?.interaction?.sharedState.currentState()?.interactionState;
            const configWithNodeInfo = interactionState !== 'hasNotHadInteraction' ? $b1b0f95ea4c121e3$export$18d4026d1ea86bb1.getState(editorState)?.getConfigWithNodeInfo?.(editorState) ?? undefined : undefined;
            return {
                configWithNodeInfo: configWithNodeInfo,
                floatingToolbarData: (0, $3v3t0.pluginKey).getState(editorState)
            };
        },
        contentComponent ({ popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, editorView: editorView, providerFactory: providerFactory, dispatchAnalyticsEvent: dispatchAnalyticsEvent }) {
            return /*#__PURE__*/ (0, $gt9Am.jsx)($b1b0f95ea4c121e3$export$2dda1e4a1d1f6a81, {
                editorView: editorView,
                pluginInjectionApi: api,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement,
                providerFactory: providerFactory,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent
            });
        }
    };
};
function $b1b0f95ea4c121e3$export$2dda1e4a1d1f6a81({ pluginInjectionApi: pluginInjectionApi, editorView: editorView, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, providerFactory: providerFactory, dispatchAnalyticsEvent: dispatchAnalyticsEvent }) {
    const { floatingToolbarState: floatingToolbarState, editorDisabledState: editorDisabledState, editorViewModeState: editorViewModeState, userIntentState: userIntentState, blockControlsState: // @ts-expect-error - excluded from FloatingToolbarPlugin dependencies to avoid circular dependency
    blockControlsState } = (0, $bSToC.useSharedPluginState)(pluginInjectionApi, [
        'floatingToolbar',
        'editorDisabled',
        'editorViewMode',
        'userIntent',
        // @ts-expect-error - excluded from FloatingToolbarPlugin dependencies to avoid circular dependency
        'blockControls'
    ]);
    const { configWithNodeInfo: configWithNodeInfo, floatingToolbarData: floatingToolbarData } = floatingToolbarState ?? {};
    if ((0, $fNh22.isSSR)()) return null;
    if (!configWithNodeInfo || !configWithNodeInfo.config || typeof configWithNodeInfo.config?.visible !== 'undefined' && !configWithNodeInfo.config?.visible) return null;
    if (userIntentState?.currentUserIntent === 'dragging') return null;
    // TODO: ED-27539 - This feature is unreleased and rendering logic needs to be move userIntentState which is not ready yet
    // if (blockControlsState?.isMenuOpen && editorExperiment('platform_editor_controls', 'variant1')) {
    // 	return null;
    // }
    const { config: config, node: node } = configWithNodeInfo;
    let { items: items } = config;
    const { groupLabel: groupLabel } = config;
    const { title: title, getDomRef: getDomRef = $b1b0f95ea4c121e3$var$getDomRefFromSelection, align: align = 'center', className: className = '', height: height, width: width, zIndex: zIndex, offset: offset = [
        0,
        12
    ], forcePlacement: forcePlacement, preventPopupOverflow: preventPopupOverflow, onPositionCalculated: onPositionCalculated, absoluteOffset: absoluteOffset = {
        top: 0,
        left: 0,
        right: 0,
        bottom: 0
    }, focusTrap: focusTrap, mediaAssistiveMessage: mediaAssistiveMessage = '', stick: stick = true } = config;
    const targetRef = getDomRef(editorView, dispatchAnalyticsEvent);
    const isEditorDisabled = editorDisabledState && editorDisabledState.editorDisabled;
    const isInViewMode = editorViewModeState?.mode === 'view';
    if (!targetRef || isEditorDisabled && !isInViewMode) return null;
    // TODO: MODES-3950 - Update this view mode specific logic once we refactor view mode.
    //       We should inverse the responsibility here: A blacklist for toolbar items in view mode, rather than this white list.
    //       Also consider moving this logic to the more specific toolbar plugins (media and selection).
    const iterableItems = Array.isArray(items) ? items : items?.(node);
    if (isInViewMode) {
        // Typescript note: Not all toolbar item types have the `supportsViewMode` prop.
        const toolbarItemViewModeProp = 'supportsViewMode';
        items = iterableItems.filter((item)=>toolbarItemViewModeProp in item && !!item[toolbarItemViewModeProp]);
    }
    if ((0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1')) {
        // Consolidate floating toolbar items
        const toolbarItemsArray = Array.isArray(items) ? items : items?.(node);
        const overflowDropdownItems = toolbarItemsArray.filter((item)=>item.type === 'overflow-dropdown');
        if (overflowDropdownItems.length > 1) {
            const consolidatedOverflowDropdown = (0, $jFFUB.consolidateOverflowDropdownItems)(overflowDropdownItems);
            const otherItems = toolbarItemsArray.filter((item)=>item.type !== 'overflow-dropdown');
            if (otherItems.length > 0) // remove the last separators
            while(otherItems.at(-1)?.type === 'separator')otherItems.pop();
            items = [
                ...otherItems,
                {
                    type: 'separator',
                    fullHeight: true,
                    supportsViewMode: true
                },
                consolidatedOverflowDropdown
            ];
        }
        // Apply analytics to dropdown
        if (overflowDropdownItems.length > 0 && dispatchAnalyticsEvent && (0, $eGOwo.fg)('platform_editor_overflow_dropdown_click_analytics')) {
            const currentItems = Array.isArray(items) ? items : items?.(node);
            const updatedItems = currentItems.map((item)=>{
                if (item.type !== 'overflow-dropdown') return item;
                const originalOnClick = item.onClick;
                return {
                    ...item,
                    onClick: ()=>{
                        const editorContentMode = pluginInjectionApi?.editorViewMode?.sharedState.currentState()?.mode;
                        dispatchAnalyticsEvent({
                            action: (0, $bMFKb.ACTION).CLICKED,
                            actionSubject: (0, $bMFKb.ACTION_SUBJECT).BUTTON,
                            actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).FLOATING_TOOLBAR_OVERFLOW,
                            eventType: (0, $bMFKb.EVENT_TYPE).UI,
                            attributes: {
                                editorContentMode: editorContentMode
                            }
                        });
                        // Call original onClick if it exists
                        originalOnClick?.();
                    }
                };
            });
            items = updatedItems;
        }
    }
    let customPositionCalculation;
    const toolbarItems = pluginInjectionApi?.copyButton?.actions.processCopyButtonItems(editorView.state)(Array.isArray(items) ? items : items(node), pluginInjectionApi?.decorations?.actions.hoverDecoration);
    if (onPositionCalculated) customPositionCalculation = (nextPos)=>{
        return onPositionCalculated(editorView, nextPos);
    };
    const dispatchCommand = (fn)=>fn && fn(editorView.state, editorView.dispatch, editorView);
    // Confirm dialog
    const { confirmDialogForItem: confirmDialogForItem } = floatingToolbarData || {};
    const confirmButtonItem = confirmDialogForItem ? // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    toolbarItems[confirmDialogForItem] : undefined;
    const scrollable = config.scrollable;
    const confirmDialogOptions = typeof confirmButtonItem?.confirmDialog === 'function' ? confirmButtonItem?.confirmDialog() : confirmButtonItem?.confirmDialog;
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $28ffc.ErrorBoundary), {
        component: (0, $bMFKb.ACTION_SUBJECT).FLOATING_TOOLBAR_PLUGIN,
        componentId: (0, (/*@__PURE__*/$parcel$interopDefault($7mF43)))(title),
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        fallbackComponent: null,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $avm98.default), {
                ariaLabel: title,
                offset: offset,
                target: targetRef,
                alignY: "bottom",
                forcePlacement: forcePlacement,
                fitHeight: height,
                fitWidth: width,
                absoluteOffset: absoluteOffset,
                alignX: align,
                stick: stick,
                zIndex: zIndex,
                mountTo: popupsMountPoint,
                boundariesElement: popupsBoundariesElement,
                scrollableElement: popupsScrollableElement,
                onPositionCalculated: customPositionCalculation,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: scrollable ? {
                    maxWidth: '100%'
                } : {},
                focusTrap: focusTrap,
                preventOverflow: preventPopupOverflow,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4sxxB.WithProviders), {
                    providerFactory: providerFactory,
                    providers: [
                        'extensionProvider'
                    ],
                    renderNode: (providers)=>{
                        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7es7V.ToolbarLoader), {
                            target: targetRef,
                            // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            items: toolbarItems,
                            groupLabel: groupLabel,
                            node: node,
                            dispatchCommand: dispatchCommand,
                            editorView: editorView,
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                            className: className,
                            focusEditor: ()=>editorView.focus(),
                            providerFactory: providerFactory,
                            popupsMountPoint: popupsMountPoint,
                            popupsBoundariesElement: popupsBoundariesElement,
                            popupsScrollableElement: popupsScrollableElement,
                            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                            extensionsProvider: providers.extensionProvider,
                            scrollable: scrollable,
                            api: pluginInjectionApi,
                            mediaAssistiveMessage: mediaAssistiveMessage
                        });
                    }
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hNNR4.ConfirmationModal), {
                testId: "ak-floating-toolbar-confirmation-modal",
                options: confirmDialogOptions,
                onConfirm: (isChecked = false)=>{
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    if (!!confirmDialogOptions.onConfirm) // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    dispatchCommand(confirmDialogOptions.onConfirm(isChecked));
                    else // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    dispatchCommand(confirmButtonItem.onClick);
                },
                onClose: ()=>{
                    dispatchCommand((0, $bYdnm.hideConfirmDialog)());
                    // Need to set focus to Editor here,
                    // As when the Confirmation dialog pop up, and user interacts with the dialog, Editor loses focus.
                    // So when Confirmation dialog is closed, Editor does not have the focus, then cursor goes to the position 1 of the doc,
                    // instead of the cursor position before the dialog pop up.
                    if (!editorView.hasFocus()) editorView.focus();
                }
            })
        ]
    });
}
const $b1b0f95ea4c121e3$export$18d4026d1ea86bb1 = new (0, $3lIcL.PluginKey)('floatingToolbarPluginKey');
/**
 * Clean up floating toolbar configs from undesired properties.
 */ function $b1b0f95ea4c121e3$var$sanitizeFloatingToolbarConfig(config) {
    // Cleanup from non existing node types
    if (Array.isArray(config.nodeType)) return {
        ...config,
        nodeType: config.nodeType.filter($b1b0f95ea4c121e3$var$filterUndefined)
    };
    return config;
}
function $b1b0f95ea4c121e3$export$5c1ec0ef773ca0cc(options) {
    const { floatingToolbarHandlers: floatingToolbarHandlers, providerFactory: providerFactory, getIntl: getIntl } = options;
    const intl = getIntl();
    const getConfigWithNodeInfo = (editorState)=>{
        let activeConfigs = [];
        for(let index = 0; index < floatingToolbarHandlers.length; index++){
            const handler = floatingToolbarHandlers[index];
            const config = handler(editorState, intl, providerFactory, activeConfigs);
            if (config) {
                if (config.__suppressAllToolbars && (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1')) {
                    activeConfigs = undefined;
                    break;
                }
                activeConfigs.push($b1b0f95ea4c121e3$var$sanitizeFloatingToolbarConfig(config));
            }
        }
        const relevantConfig = activeConfigs && $b1b0f95ea4c121e3$export$c5f0b4d19f5b8d4b(editorState.selection, activeConfigs);
        return relevantConfig;
    };
    const apply = ()=>{
        const newPluginState = {
            getConfigWithNodeInfo: getConfigWithNodeInfo
        };
        return newPluginState;
    };
    return new (0, $i8KtF.SafePlugin)({
        key: $b1b0f95ea4c121e3$export$18d4026d1ea86bb1,
        state: {
            init: ()=>{
                // Use this point to preload the UI
                (0, $7es7V.ToolbarLoader).preload();
                return {
                    getConfigWithNodeInfo: getConfigWithNodeInfo
                };
            },
            apply: apply
        }
    });
}

});
parcelRegister("h9coN", function(module, exports) {

$parcel$export(module.exports, "copyNode", () => $70d8ebd0ac083768$export$978ef9948557240e);

var $7EdFW = parcelRequire("7EdFW");

var $58hN2 = parcelRequire("58hN2");

var $e5Nsc = parcelRequire("e5Nsc");

var $3lIcL = parcelRequire("3lIcL");
const $70d8ebd0ac083768$export$978ef9948557240e = (nodeType, editorAnalyticsApi, inputMethod)=>({ tr: tr })=>{
        // const { tr, schema } = state;
        // This command should only be triggered by the Copy button in the floating toolbar
        // which is only visible when selection is inside the target node
        const contentNodeWithPos = (0, $e5Nsc.getSelectedNodeOrNodeParentByNodeType)({
            nodeType: nodeType,
            selection: tr.selection
        });
        if (!contentNodeWithPos) return tr;
        const schema = tr.doc.type.schema;
        const copyToClipboardTr = tr;
        const domNode = (0, $e5Nsc.toDOM)(contentNodeWithPos.node, schema);
        if (domNode) {
            const div = document.createElement('div');
            div.appendChild(domNode);
            // if copying inline content
            if (contentNodeWithPos.node.type.inlineContent) // The "1 1" refers to the start and end depth of the slice
            // since we're copying the text inside a paragraph, it will always be 1 1
            // https://github.com/ProseMirror/prosemirror-view/blob/master/src/clipboard.ts#L32
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            div.firstChild.setAttribute('data-pm-slice', '1 1 []');
            else // The "0 0" refers to the start and end depth of the slice
            // since we're copying the block node only, it will always be 0 0
            // https://github.com/ProseMirror/prosemirror-view/blob/master/src/clipboard.ts#L32
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            div.firstChild.setAttribute('data-pm-slice', '0 0 []');
            // ED-17083 safari seems have bugs for extension copy because exntension do not have a child text(innerText) and it will not recognized as html in clipboard, this could be merge into one if this extension fixed children issue or safari fix the copy bug
            // MEX-2528 safari has a bug related to the mediaSingle node with border or link. The image tag within the clipboard is not recognized as HTML when using the ClipboardItem API. To address this, we have to switch to ClipboardPolyfill
            if ((0, $7EdFW.browser).safari && tr.selection instanceof (0, $3lIcL.NodeSelection) && (tr.selection.node.type === schema.nodes.extension || tr.selection.node.type === schema.nodes.mediaSingle)) (0, $58hN2.copyHTMLToClipboardPolyfill)(div);
            else (0, $58hN2.copyHTMLToClipboard)(div);
        }
        if (editorAnalyticsApi) {
            const analyticsPayload = (0, $58hN2.getNodeCopiedAnalyticsPayload)(contentNodeWithPos.node, inputMethod);
            editorAnalyticsApi.attachAnalyticsEvent(analyticsPayload)(copyToClipboardTr);
        }
        copyToClipboardTr.setMeta('scrollIntoView', false);
        return copyToClipboardTr;
    };

});

parcelRegister("cIMBE", function(module, exports) {

$parcel$export(module.exports, "default", () => $6186217194205868$export$2e2bcd8739ae039);
$parcel$export(module.exports, "forceFocusSelector", () => $6186217194205868$export$1470545de94762f5);
$parcel$export(module.exports, "checkShouldForceFocusAndApply", () => $6186217194205868$export$a2ced8424a9be595);

var $i8KtF = parcelRequire("i8KtF");

var $3lIcL = parcelRequire("3lIcL");
const $6186217194205868$export$ded15a80767f6af7 = new (0, $3lIcL.PluginKey)('forceFocusStatePlugin');
var /**
 * Used in cases where a floating toolbar button opens a submenu which destroys
 * the button, but the user has pressed ESC to close the submenu and focus needs
 * to move back to the button. */ $6186217194205868$export$2e2bcd8739ae039 = ()=>new (0, $i8KtF.SafePlugin)({
        key: $6186217194205868$export$ded15a80767f6af7,
        state: {
            init: ()=>({
                    selector: null
                }),
            apply: (tr, prevState)=>{
                const meta = tr.getMeta($6186217194205868$export$ded15a80767f6af7);
                if (meta && 'selector' in meta) return {
                    selector: meta.selector
                };
                return prevState;
            }
        }
    });
const $6186217194205868$export$1470545de94762f5 = (selector)=>(tr)=>{
        return tr.setMeta($6186217194205868$export$ded15a80767f6af7, {
            selector: selector
        });
    };
function $6186217194205868$export$a2ced8424a9be595(view) {
    const state = view?.state;
    if (state) {
        const { selector: selector } = $6186217194205868$export$ded15a80767f6af7.getState(state);
        if (selector) {
            const focusableElement = document.querySelector(selector);
            if (focusableElement) {
                focusableElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                    inline: 'nearest'
                });
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                focusableElement.focus();
                const { state: { tr: tr }, dispatch: dispatch } = view;
                dispatch($6186217194205868$export$1470545de94762f5(null)(tr));
            }
        }
    }
}

});

parcelRegister("bYdnm", function(module, exports) {

$parcel$export(module.exports, "showConfirmDialog", () => $2ab9456e5c0e5923$export$c0076bd4afc29e7a);
$parcel$export(module.exports, "hideConfirmDialog", () => $2ab9456e5c0e5923$export$5a3c1357cfd1045c);

var $dZNtB = parcelRequire("dZNtB");
const $2ab9456e5c0e5923$export$c0076bd4afc29e7a = (buttonIndex)=>(0, $dZNtB.createCommand)({
        type: 'SHOW_CONFIRM_DIALOG',
        data: {
            buttonIndex: buttonIndex
        }
    }, (tr)=>tr.setMeta('addToHistory', false));
const $2ab9456e5c0e5923$export$5a3c1357cfd1045c = ()=>(0, $dZNtB.createCommand)({
        type: 'HIDE_CONFIRM_DIALOG'
    }, (tr)=>tr.setMeta('addToHistory', false));

});
parcelRegister("dZNtB", function(module, exports) {

$parcel$export(module.exports, "createPluginState", () => $d5d414125912cd48$export$656c7661095efe2e);
$parcel$export(module.exports, "createCommand", () => $d5d414125912cd48$export$8d4021544bdece00);

var $bazog = parcelRequire("bazog");

var $3v3t0 = parcelRequire("3v3t0");

var $5fIEN = parcelRequire("5fIEN");
const { createPluginState: $d5d414125912cd48$export$656c7661095efe2e, createCommand: $d5d414125912cd48$export$8d4021544bdece00, getPluginState: $d5d414125912cd48$export$f05434c51e3762e } = (0, $bazog.pluginFactory)((0, $3v3t0.pluginKey), (0, $5fIEN.reducer));

});
parcelRegister("3v3t0", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $5705c173e2bd1077$export$18d4026d1ea86bb1);

var $3lIcL = parcelRequire("3lIcL");
const $5705c173e2bd1077$export$18d4026d1ea86bb1 = new (0, $3lIcL.PluginKey)('floatingToolbarData');

});

parcelRegister("5fIEN", function(module, exports) {

$parcel$export(module.exports, "reducer", () => $54989e4408e8c6c4$export$1650419e431d3ba3);
const $54989e4408e8c6c4$export$1650419e431d3ba3 = (pluginState, action)=>{
    switch(action.type){
        case 'SHOW_CONFIRM_DIALOG':
            return {
                ...pluginState,
                confirmDialogForItem: action.data.buttonIndex
            };
        case 'HIDE_CONFIRM_DIALOG':
            return {
                ...pluginState,
                confirmDialogForItem: undefined
            };
        default:
            return pluginState;
    }
};

});



parcelRegister("2M0rW", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $5fa7b329811e3008$export$ae829ec7b2625219);

var $i8KtF = parcelRequire("i8KtF");

var $dZNtB = parcelRequire("dZNtB");

var $3v3t0 = parcelRequire("3v3t0");
const $5fa7b329811e3008$export$ae829ec7b2625219 = (dispatch)=>{
    return new (0, $i8KtF.SafePlugin)({
        state: (0, $dZNtB.createPluginState)(dispatch, {}),
        key: (0, $3v3t0.pluginKey)
    });
};

});

parcelRegister("ho7Ph", function(module, exports) {

$parcel$export(module.exports, "findNode", () => $97cced9edf09bb43$export$5b92d7a8b5d33ee2);
function $97cced9edf09bb43$export$5b92d7a8b5d33ee2(parent, predicate) {
    let matchedNode;
    parent.descendants((node)=>{
        // dont run predicate if node already found
        if (matchedNode) return false;
        if (predicate(node)) {
            matchedNode = node;
            return false;
        }
        return true;
    });
    return matchedNode;
}

});

parcelRegister("hNNR4", function(module, exports) {

$parcel$export(module.exports, "ConfirmationModal", () => $490644b4f8b9075d$export$1f33f980da756c46);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6YFG2 = parcelRequire("6YFG2");

var $956it = parcelRequire("956it");

var $ils3V = parcelRequire("ils3V");

var $hhZ9w = parcelRequire("hhZ9w");
const $490644b4f8b9075d$var$ConfirmationModalImpl = (props)=>{
    const { options: options } = props;
    const renderModel = (isReferentialityDialog = false)=>// Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        isReferentialityDialog ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ils3V.CheckboxModal), {
            ...props
        }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hhZ9w.SimpleModal), {
            ...props
        });
    return options ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $956it.default), {
        children: renderModel(options?.isReferentialityDialog)
    }) : null;
};
const $490644b4f8b9075d$export$1f33f980da756c46 = (0, $6YFG2.default)($490644b4f8b9075d$var$ConfirmationModalImpl);

});
parcelRegister("ils3V", function(module, exports) {

$parcel$export(module.exports, "CheckboxModal", () => $9bebfd3a35e9a96e$export$9c828de50258a892);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5CSKW = parcelRequire("5CSKW");

var $86tBw = parcelRequire("86tBw");

var $jn2od = parcelRequire("jn2od");

var $fmSFT = parcelRequire("fmSFT");
var $ik0CA = parcelRequire("ik0CA");
var $kseeK = parcelRequire("kseeK");
var $2qG7I = parcelRequire("2qG7I");
var $5a9Ro = parcelRequire("5a9Ro");

var $3cMgR = parcelRequire("3cMgR");
const $9bebfd3a35e9a96e$export$9c828de50258a892 = (props)=>{
    const [isChecked, setCheckbox] = (0, $eJOHy.useState)(false);
    const { onConfirm: onConfirm, onClose: onClose, options: options, intl: { formatMessage: formatMessage }, testId: testId } = props;
    const heading = options?.title || formatMessage((0, $jn2od.default).confirmModalDefaultHeading);
    const okButtonLabel = options?.okButtonLabel || formatMessage((0, $jn2od.default).confirmModalOK);
    const cancelButtonLabel = options?.cancelButtonLabel || formatMessage((0, $jn2od.default).confirmModalCancel);
    const checkboxlabel = options?.checkboxLabel;
    const childrenInfo = options?.getChildrenInfo?.();
    const ListComponent = ({ nodes: nodes })=>{
        if (nodes.length === 0) return null;
        return /*#__PURE__*/ (0, $gt9Am.jsx)("ul", {
            children: nodes.map((node)=>// Ignored via go/ees005
                // eslint-disable-next-line react/jsx-props-no-spreading
                /*#__PURE__*/ (0, $eJOHy.createElement)(ListItem, {
                    ...node,
                    key: node.id
                }))
        });
    };
    const ListItem = (props)=>{
        const { id: id, name: name, amount: amount } = props;
        return /*#__PURE__*/ (0, $gt9Am.jsx)("li", {
            id: id,
            children: formatMessage((0, $jn2od.default).confirmModalListUnit, {
                name: name,
                amount: amount
            })
        });
    };
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $fmSFT.default), {
        onClose: onClose,
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2qG7I.default), {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5a9Ro.default), {
                    appearance: "warning",
                    children: heading
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $ik0CA.default), {
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                        as: "p",
                        children: options?.message
                    }),
                    !!childrenInfo?.length && /*#__PURE__*/ (0, $gt9Am.jsx)(ListComponent, {
                        nodes: childrenInfo
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                        as: "p",
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $86tBw.default), {
                            isChecked: isChecked,
                            onChange: ()=>setCheckbox(!isChecked),
                            label: checkboxlabel,
                            testId: testId ? `${testId}-checkbox` : undefined
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $kseeK.default), {
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5CSKW.default), {
                        appearance: "default",
                        onClick: onClose,
                        testId: testId ? `${testId}-cancel-button` : undefined,
                        children: cancelButtonLabel
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5CSKW.default), {
                        appearance: "warning",
                        onClick: ()=>{
                            onConfirm(isChecked);
                            onClose();
                        },
                        testId: testId ? `${testId}-confirm-button` : undefined,
                        children: okButtonLabel
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("jn2od", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a3c8b280992071c$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $2a3c8b280992071c$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    confirmModalDefaultHeading: {
        id: 'fabric.editor.floatingToolbar.confirmModalHeading',
        defaultMessage: 'Are you sure?',
        description: 'Default heading of floating toolbar confirmation modal.'
    },
    confirmModalOK: {
        id: 'fabric.editor.floatingToolbar.confirmModalOK',
        defaultMessage: 'OK',
        description: 'OK button for floating toolbar confirmation modal.'
    },
    confirmModalCancel: {
        id: 'fabric.editor.floatingToolbar.confirmModalCancel',
        defaultMessage: 'Cancel',
        description: 'Cancel button for floating toolbar confirmation modal.'
    },
    confirmModalListUnit: {
        id: 'fabric.editor.floatingToolbar.confirmModalConnectedUnit',
        defaultMessage: '{name}{amount, plural, =0 {} one { (+1 connected element)} other { (+# connected elements)}}',
        description: 'Text displayed in confirmation modal which highlights the nodes and the amount of connected nodes that will be deleted'
    },
    confirmDeleteLinkedModalMessage: {
        id: 'fabric.editor.extension.confirmDeleteLinkedModalMessage',
        defaultMessage: 'Deleting {nodeName} will break anything connected to it.',
        description: 'Message for confirm modal when deleting a extension linked to an data consumer.'
    },
    floatingToolbarAriaLabel: {
        id: 'fabric.editor.floatingToolbar.floatingToolbarAriaLabel',
        defaultMessage: 'Floating Toolbar',
        description: "a floating toolbar's aria label"
    },
    floatingToolbarAnnouncer: {
        id: 'fabric.editor.floatingToolbar.floatingToolbarAnnouncer',
        defaultMessage: 'Floating toolbar controls have been opened',
        description: 'message that will be announced to screenreaders that the floating toolbar is opened'
    },
    floatingToolbarScrollLeft: {
        id: 'fabric.editor.floatingToolbar.scrollLeft',
        defaultMessage: 'Scroll left',
        description: 'Button to scroll left when the toolbar is in the overflow state'
    },
    floatingToolbarScrollRight: {
        id: 'fabric.editor.floatingToolbar.scrollRight',
        defaultMessage: 'Scroll right',
        description: 'Button to scroll right when the toolbar is in the overflow state'
    }
});

});


parcelRegister("hhZ9w", function(module, exports) {

$parcel$export(module.exports, "SimpleModal", () => $4ae2a3c0a4fe208b$export$f96c193e316d2274);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5CSKW = parcelRequire("5CSKW");

var $jn2od = parcelRequire("jn2od");

var $fmSFT = parcelRequire("fmSFT");
var $ik0CA = parcelRequire("ik0CA");
var $kseeK = parcelRequire("kseeK");
var $2qG7I = parcelRequire("2qG7I");
var $5a9Ro = parcelRequire("5a9Ro");

var $3cMgR = parcelRequire("3cMgR");
const $4ae2a3c0a4fe208b$export$f96c193e316d2274 = (props)=>{
    const { onConfirm: onConfirm, onClose: onClose, options: options, intl: { formatMessage: formatMessage }, testId: testId } = props;
    const heading = options?.title || formatMessage((0, $jn2od.default).confirmModalDefaultHeading);
    const okButtonLabel = options?.okButtonLabel || formatMessage((0, $jn2od.default).confirmModalOK);
    const cancelButtonLabel = options?.cancelButtonLabel || formatMessage((0, $jn2od.default).confirmModalCancel);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $fmSFT.default), {
        onClose: onClose,
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2qG7I.default), {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5a9Ro.default), {
                    appearance: "warning",
                    children: heading
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ik0CA.default), {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                    as: "p",
                    children: options?.message
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $kseeK.default), {
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5CSKW.default), {
                        appearance: "default",
                        onClick: onClose,
                        testId: testId ? `${testId}-cancel-button` : undefined,
                        children: cancelButtonLabel
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5CSKW.default), {
                        appearance: "warning",
                        onClick: ()=>{
                            onConfirm();
                            onClose();
                        },
                        testId: testId ? `${testId}-confirm-button` : undefined,
                        children: okButtonLabel
                    })
                ]
            })
        ]
    });
};

});


parcelRegister("7es7V", function(module, exports) {

$parcel$export(module.exports, "ToolbarLoader", () => $6551aa3ec07d588b$export$8f0e0160298415aa);

var $joSn0 = parcelRequire("joSn0");

const $6551aa3ec07d588b$export$8f0e0160298415aa = (0, (/*@__PURE__*/$parcel$interopDefault($joSn0)))({
    loader: ()=>(parcelRequire("8qsED")).then((mod)=>mod.default),
    loading: ()=>null
});

});
parcelRegister("8qsED", function(module, exports) {

let $6226fa9fc540283c$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $6226fa9fc540283c$var$load("76n7a"),
    $6226fa9fc540283c$var$load("l253H"),
    $6226fa9fc540283c$var$load("bS9bR")
]).then(()=>parcelRequire('28qTE'));

});


parcelRegister("jFFUB", function(module, exports) {

$parcel$export(module.exports, "consolidateOverflowDropdownItems", () => $5a480ea441738f5f$export$2f5751d7b477f660);
const $5a480ea441738f5f$export$2f5751d7b477f660 = (overflowDropdowns)=>{
    if (overflowDropdowns.length <= 1) return overflowDropdowns[0];
    const combinedItems = overflowDropdowns.reduce((acc, item)=>{
        if (item.options) acc.push(...item.options);
        return acc;
    }, []);
    // To filter out items that have a rank property, sort them by rank in descending order (highest rank first)
    const rankedItems = combinedItems.filter((item)=>'rank' in item && typeof item.rank === 'number').sort((a, b)=>(b.rank || 0) - (a.rank || 0));
    const unrankedItems = combinedItems.filter((item)=>!('rank' in item && typeof item.rank === 'number'));
    const sortedItems = [
        ...rankedItems,
        ...unrankedItems
    ];
    const largestDropdownWidth = overflowDropdowns.reduce((acc, item)=>{
        if (item.dropdownWidth && item.dropdownWidth > acc) return item.dropdownWidth;
        return acc;
    }, 0);
    return {
        type: 'overflow-dropdown',
        dropdownWidth: largestDropdownWidth,
        options: sortedItems
    };
};

});



parcelRegister("1Z833", function(module, exports) {

$parcel$export(module.exports, "focusPlugin", () => (parcelRequire("eJTQT")).focusPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $eJTQT = parcelRequire("eJTQT");

});
parcelRegister("eJTQT", function(module, exports) {

$parcel$export(module.exports, "focusPlugin", () => $54d51906962afa3c$export$78540d08bd386fba);

var $eGNwa = parcelRequire("eGNwa");
const $54d51906962afa3c$export$78540d08bd386fba = ({ api: api })=>{
    return {
        name: 'focus',
        getSharedState (editorState) {
            if (!editorState) return {
                hasFocus: false
            };
            return {
                hasFocus: Boolean((0, $eGNwa.key).getState(editorState)?.hasFocus)
            };
        },
        pmPlugins () {
            return [
                {
                    name: 'focusHandlerPlugin',
                    plugin: (0, $eGNwa.createPlugin)
                }
            ];
        }
    };
};

});
parcelRegister("eGNwa", function(module, exports) {

$parcel$export(module.exports, "key", () => $2c2482bf167fec96$export$df61b30b684217c0);
$parcel$export(module.exports, "createPlugin", () => $2c2482bf167fec96$export$ae829ec7b2625219);

var $i8KtF = parcelRequire("i8KtF");

var $3lIcL = parcelRequire("3lIcL");
const $2c2482bf167fec96$export$df61b30b684217c0 = new (0, $3lIcL.PluginKey)('focusPluginHandler');
const $2c2482bf167fec96$export$ae829ec7b2625219 = ()=>new (0, $i8KtF.SafePlugin)({
        key: $2c2482bf167fec96$export$df61b30b684217c0,
        state: {
            init () {
                return {
                    hasFocus: false
                };
            },
            apply (tr, oldPluginState) {
                const meta = tr.getMeta($2c2482bf167fec96$export$df61b30b684217c0);
                if (typeof meta === 'boolean') {
                    if (meta !== oldPluginState.hasFocus) return {
                        hasFocus: meta
                    };
                }
                return oldPluginState;
            }
        },
        props: {
            handleDOMEvents: {
                focus: (view)=>{
                    const focusState = $2c2482bf167fec96$export$df61b30b684217c0.getState(view.state);
                    if (!focusState?.hasFocus) view.dispatch(view.state.tr.setMeta($2c2482bf167fec96$export$df61b30b684217c0, true));
                    return false;
                },
                blur: (view)=>{
                    const focusState = $2c2482bf167fec96$export$df61b30b684217c0.getState(view.state);
                    if (focusState?.hasFocus) view.dispatch(view.state.tr.setMeta($2c2482bf167fec96$export$df61b30b684217c0, false));
                    return false;
                }
            }
        }
    });

});



parcelRegister("1zlWn", function(module, exports) {

$parcel$export(module.exports, "gridPlugin", () => (parcelRequire("9RgM8")).gridPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $9RgM8 = parcelRequire("9RgM8");

});
parcelRegister("9RgM8", function(module, exports) {

$parcel$export(module.exports, "gridPlugin", () => $3307d2aadda2e40d$export$c090e341e8f725a9);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $loabE = parcelRequire("loabE");

var $k9JrM = parcelRequire("k9JrM");

var $kLQ9a = parcelRequire("kLQ9a");
var $bSToC = parcelRequire("bSToC");
var $cxXTK = parcelRequire("cxXTK");

var $i8KtF = parcelRequire("i8KtF");

var $3lIcL = parcelRequire("3lIcL");

var $7yBx7 = parcelRequire("7yBx7");
const $3307d2aadda2e40d$export$bc90872e265d166e = 12;
const $3307d2aadda2e40d$var$key = new (0, $3lIcL.PluginKey)('gridPlugin');
const $3307d2aadda2e40d$var$createDisplayGrid = (view)=>(props)=>{
        const { dispatch: dispatch, state: state } = view;
        const tr = state.tr.setMeta($3307d2aadda2e40d$var$key, props);
        dispatch(tr);
        return true;
    };
const $3307d2aadda2e40d$var$sides = [
    'left',
    'right'
];
const $3307d2aadda2e40d$var$overflowHighlight = (highlights, side, start, size)=>{
    if (!highlights.length) return false;
    const numericHighlights = highlights.filter((highlight)=>typeof highlight === 'number');
    const minHighlight = Math.min(...numericHighlights);
    const maxHighlight = Math.max(...numericHighlights);
    if (side === 'left') return minHighlight < 0 && minHighlight <= -start && (typeof size === 'number' ? minHighlight >= -(start + size) : true);
    else return maxHighlight > $3307d2aadda2e40d$export$bc90872e265d166e && maxHighlight >= $3307d2aadda2e40d$export$bc90872e265d166e + start && (typeof size === 'number' ? maxHighlight <= $3307d2aadda2e40d$export$bc90872e265d166e + size : true);
};
const $3307d2aadda2e40d$var$gutterGridLines = (editorMaxWidth, editorWidth, highlights, shouldCalcBreakoutGridLines)=>{
    const gridLines = [];
    if (!shouldCalcBreakoutGridLines) return gridLines;
    const wideSpacing = (editorMaxWidth * (0, $7yBx7.breakoutWideScaleRatio) - editorMaxWidth) / 2;
    $3307d2aadda2e40d$var$sides.forEach((side)=>{
        gridLines.push(/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, (/*@__PURE__*/$parcel$interopDefault($k9JrM)))('gridLine', $3307d2aadda2e40d$var$overflowHighlight(highlights, side, 0, 4) ? 'highlight' : ''),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                position: 'absolute',
                [side]: `-${wideSpacing}px`
            }
        }, side));
        gridLines.push(/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, (/*@__PURE__*/$parcel$interopDefault($k9JrM)))('gridLine', highlights.indexOf('full-width') > -1 ? 'highlight' : ''),
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                position: 'absolute',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                [side]: `-${(editorWidth - editorMaxWidth - (0, $7yBx7.akEditorBreakoutPadding)) / 2}px`
            }
        }, side + '-bk'));
    });
    return gridLines;
};
const $3307d2aadda2e40d$var$lineLengthGridLines = (highlights)=>{
    const gridLines = [];
    const gridSpacing = 100 / $3307d2aadda2e40d$export$bc90872e265d166e;
    for(let i = 0; i <= $3307d2aadda2e40d$export$bc90872e265d166e; i++){
        const style = {
            paddingLeft: `${gridSpacing}%`
        };
        gridLines.push(/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, (/*@__PURE__*/$parcel$interopDefault($k9JrM)))('gridLine', highlights.indexOf(i) > -1 ? 'highlight' : ''),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: i < $3307d2aadda2e40d$export$bc90872e265d166e ? style : undefined
        }, i));
    }
    return gridLines;
};
const $3307d2aadda2e40d$var$Grid = ({ highlight: highlight, shouldCalcBreakoutGridLines: shouldCalcBreakoutGridLines, theme: theme, containerElement: containerElement, editorWidth: editorWidth, gridType: gridType, visible: visible })=>{
    const editorMaxWidth = theme.layoutMaxWidth;
    const gridLines = [
        ...$3307d2aadda2e40d$var$lineLengthGridLines(highlight),
        ...$3307d2aadda2e40d$var$gutterGridLines(editorMaxWidth, editorWidth, highlight, shouldCalcBreakoutGridLines)
    ];
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: "gridParent",
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, (/*@__PURE__*/$parcel$interopDefault($k9JrM)))('gridContainer', gridType),
            style: {
                height: `${containerElement.scrollHeight}px`,
                display: visible ? 'block' : 'none'
            },
            "data-testid": "gridContainer",
            children: gridLines
        })
    }));
};
const $3307d2aadda2e40d$var$ThemedGrid = (0, $loabE.b)($3307d2aadda2e40d$var$Grid);
const $3307d2aadda2e40d$var$selector = (states)=>{
    return {
        width: states.widthState?.width,
        visible: states.gridState?.visible,
        gridType: states.gridState?.gridType,
        highlight: states.gridState?.highlight
    };
};
const $3307d2aadda2e40d$var$useSharedState = (0, $kLQ9a.sharedPluginStateHookMigratorFactory)((api)=>{
    return (0, $cxXTK.useSharedPluginStateWithSelector)(api, [
        'width',
        'grid'
    ], $3307d2aadda2e40d$var$selector);
}, (api)=>{
    const { widthState: widthState, gridState: gridState } = (0, $bSToC.useSharedPluginState)(api, [
        'width',
        'grid'
    ]);
    return {
        width: widthState?.width,
        visible: gridState?.visible,
        gridType: gridState?.gridType,
        highlight: gridState?.highlight
    };
});
const $3307d2aadda2e40d$var$ContentComponent = ({ api: api, editorView: editorView, options: options })=>{
    const { width: width, visible: visible, gridType: gridType, highlight: highlight } = $3307d2aadda2e40d$var$useSharedState(api);
    if (visible === undefined || !highlight) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)($3307d2aadda2e40d$var$ThemedGrid, {
        shouldCalcBreakoutGridLines: options && options.shouldCalcBreakoutGridLines,
        editorWidth: width ?? (0, $7yBx7.akEditorFullPageMaxWidth),
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        containerElement: editorView.dom,
        visible: visible,
        gridType: gridType ?? 'full',
        highlight: highlight
    });
};
const $3307d2aadda2e40d$var$EMPTY_STATE = {
    visible: false,
    highlight: []
};
const $3307d2aadda2e40d$var$gridPMPlugin = new (0, $i8KtF.SafePlugin)({
    key: $3307d2aadda2e40d$var$key,
    state: {
        init () {
            return $3307d2aadda2e40d$var$EMPTY_STATE;
        },
        apply (tr, currentPluginState) {
            const nextPluginState = tr.getMeta($3307d2aadda2e40d$var$key);
            if (nextPluginState) return nextPluginState;
            return currentPluginState;
        }
    }
});
const $3307d2aadda2e40d$export$c090e341e8f725a9 = ({ config: options, api: api })=>{
    return {
        name: 'grid',
        getSharedState (editorState) {
            if (!editorState) return null;
            return $3307d2aadda2e40d$var$key.getState(editorState) || null;
        },
        actions: {
            displayGrid: $3307d2aadda2e40d$var$createDisplayGrid
        },
        pmPlugins () {
            return [
                {
                    name: 'grid',
                    plugin: ()=>$3307d2aadda2e40d$var$gridPMPlugin
                }
            ];
        },
        contentComponent: ({ editorView: editorView })=>/*#__PURE__*/ (0, $gt9Am.jsx)($3307d2aadda2e40d$var$ContentComponent, {
                editorView: editorView,
                options: options,
                api: api
            })
    };
};

});


parcelRegister("dN5B3", function(module, exports) {

$parcel$export(module.exports, "historyPlugin", () => (parcelRequire("5bKdQ")).default);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $5bKdQ = parcelRequire("5bKdQ");

});
parcelRegister("5bKdQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b34cff514a56c9cd$export$2e2bcd8739ae039);

var $i8KtF = parcelRequire("i8KtF");

var $bazog = parcelRequire("bazog");

var $gAW9G = parcelRequire("gAW9G");

var $lAlcn = parcelRequire("lAlcn");

var $eNFw5 = parcelRequire("eNFw5");

var $2AaJx = parcelRequire("2AaJx");
const $b34cff514a56c9cd$var$getInitialState = ()=>({
        canUndo: false,
        canRedo: false
    });
const { createPluginState: $b34cff514a56c9cd$var$createPluginState, getPluginState: $b34cff514a56c9cd$var$getPluginState } = (0, $bazog.pluginFactory)((0, $2AaJx.historyPluginKey), (0, $lAlcn.default));
const $b34cff514a56c9cd$var$createPlugin = (dispatch)=>new (0, $i8KtF.SafePlugin)({
        state: $b34cff514a56c9cd$var$createPluginState(dispatch, $b34cff514a56c9cd$var$getInitialState),
        key: (0, $2AaJx.historyPluginKey),
        appendTransaction: (transactions, oldState, newState)=>{
            if (transactions.find((tr)=>tr.docChanged && tr.getMeta('addToHistory') !== false)) {
                const pmHistoryPluginState = (0, $eNFw5.getPmHistoryPluginState)(newState);
                if (!pmHistoryPluginState) return;
                const canUndo = pmHistoryPluginState.done.eventCount > 0;
                const canRedo = pmHistoryPluginState.undone.eventCount > 0;
                const { canUndo: prevCanUndo, canRedo: prevCanRedo } = $b34cff514a56c9cd$var$getPluginState(newState);
                if (canUndo !== prevCanUndo || canRedo !== prevCanRedo) {
                    const action = {
                        type: (0, $gAW9G.HistoryActionTypes).UPDATE,
                        canUndo: canUndo,
                        canRedo: canRedo
                    };
                    return newState.tr.setMeta((0, $2AaJx.historyPluginKey), action);
                }
            }
        }
    });
const $b34cff514a56c9cd$var$historyPlugin = ({ api: api })=>({
        name: 'history',
        pmPlugins () {
            return [
                {
                    name: 'history',
                    plugin: ({ dispatch: dispatch })=>$b34cff514a56c9cd$var$createPlugin(dispatch)
                }
            ];
        },
        getSharedState: (editorState)=>{
            if (!editorState) return undefined;
            const historyPluginState = (0, $2AaJx.historyPluginKey).getState(editorState);
            if (!historyPluginState) return undefined;
            const { done: done, undone: undone } = (0, $eNFw5.getPmHistoryPluginState)(editorState) ?? {};
            return {
                canUndo: historyPluginState.canUndo,
                canRedo: historyPluginState.canRedo,
                done: {
                    eventCount: done?.eventCount ?? 0
                },
                undone: {
                    eventCount: undone?.eventCount ?? 0
                }
            };
        },
        commands: {
            updatePluginState: ({ tr: tr })=>{
                const { done: done, undone: undone } = api?.history.sharedState.currentState() ?? {};
                if (done === undefined || undone === undefined) return tr;
                const canUndo = done.eventCount > 0;
                const canRedo = undone.eventCount > 0;
                const action = {
                    type: (0, $gAW9G.HistoryActionTypes).UPDATE,
                    canUndo: canUndo,
                    canRedo: canRedo
                };
                return tr.setMeta((0, $2AaJx.historyPluginKey), action);
            }
        }
    });
var $b34cff514a56c9cd$export$2e2bcd8739ae039 = $b34cff514a56c9cd$var$historyPlugin;

});
parcelRegister("gAW9G", function(module, exports) {

$parcel$export(module.exports, "HistoryActionTypes", () => $7cba2b4b7404edff$export$324bf1d9598f1f30);
var $7cba2b4b7404edff$export$324bf1d9598f1f30 = /*#__PURE__*/ function(HistoryActionTypes) {
    HistoryActionTypes["UPDATE"] = "UPDATE";
    return HistoryActionTypes;
}({});

});

parcelRegister("lAlcn", function(module, exports) {

$parcel$export(module.exports, "default", () => $86fa056c92ae84a5$export$2e2bcd8739ae039);

var $gAW9G = parcelRequire("gAW9G");
const $86fa056c92ae84a5$var$reducer = (state, action)=>{
    switch(action.type){
        case (0, $gAW9G.HistoryActionTypes).UPDATE:
            return {
                canUndo: action.canUndo,
                canRedo: action.canRedo
            };
    }
    return state;
};
var $86fa056c92ae84a5$export$2e2bcd8739ae039 = $86fa056c92ae84a5$var$reducer;

});

parcelRegister("eNFw5", function(module, exports) {

$parcel$export(module.exports, "getPmHistoryPluginState", () => $0893038c241d2c40$export$6bcebd7b5d7b9325);

var $3ADzg = parcelRequire("3ADzg");
// Internal prosemirror history plugin does not export its plugin key.
// Previously we searched through all the plugins to find the history plugin
// but it's faster to look up the plugin directly via `getState`.
const $0893038c241d2c40$var$fakePluginKey = {
    key: (0, $3ADzg.pmHistoryPluginKey),
    getState: (state)=>{
        // The plugin key is used to index state
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return state[0, $3ADzg.pmHistoryPluginKey];
    },
    get (state) {
        return state.plugins.find(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (plugin)=>plugin.key === (0, $3ADzg.pmHistoryPluginKey));
    }
};
const $0893038c241d2c40$export$6bcebd7b5d7b9325 = (state)=>{
    return $0893038c241d2c40$var$fakePluginKey.getState(state);
};

});

parcelRegister("2AaJx", function(module, exports) {

$parcel$export(module.exports, "historyPluginKey", () => $ec3e67edf8f70736$export$8869884044241c3c);

var $3lIcL = parcelRequire("3lIcL");
const $ec3e67edf8f70736$export$8869884044241c3c = new (0, $3lIcL.PluginKey)('historyPlugin');

});



parcelRegister("7fPgC", function(module, exports) {

$parcel$export(module.exports, "hyperlinkPlugin", () => (parcelRequire("7c4bW")).hyperlinkPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $7c4bW = parcelRequire("7c4bW");

});
parcelRegister("7c4bW", function(module, exports) {

$parcel$export(module.exports, "hyperlinkPlugin", () => $6c47c03ecfef6936$export$8143923e8601d272);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $h9kgv = parcelRequire("h9kgv");

var $bMFKb = parcelRequire("bMFKb");

var $6Exgk = parcelRequire("6Exgk");

var $4axGb = parcelRequire("4axGb");

var $46A2h = parcelRequire("46A2h");

var $8GLF3 = parcelRequire("8GLF3");

var $c1NDo = parcelRequire("c1NDo");

var $grDTV = parcelRequire("grDTV");

var $9ucqS = parcelRequire("9ucqS");

var $eGOwo = parcelRequire("eGOwo");

var $92xoS = parcelRequire("92xoS");

var $eBKSl = parcelRequire("eBKSl");

var $2mlVO = parcelRequire("2mlVO");

var $fqUwN = parcelRequire("fqUwN");

var $5uCg0 = parcelRequire("5uCg0");

var $jfXvp = parcelRequire("jfXvp");

var $68iXk = parcelRequire("68iXk");

var $4W4Vf = parcelRequire("4W4Vf");
const $6c47c03ecfef6936$var$getPosFromActiveLinkMark = (state)=>{
    if (state === undefined) return undefined;
    switch(state.type){
        case 'EDIT':
        case 'EDIT_INSERTED':
            return state.pos;
        case 'INSERT':
            return undefined;
    }
};
const $6c47c03ecfef6936$var$selectionToolbarLinkButtonTestId = 'ak-editor-selection-toolbar-link-button';
const $6c47c03ecfef6936$export$8143923e8601d272 = ({ config: options = {}, api: api })=>{
    let primaryToolbarComponent;
    return {
        name: 'hyperlink',
        marks () {
            return [
                {
                    name: 'link',
                    mark: (0, $h9kgv.link)
                }
            ];
        },
        commands: {
            showLinkToolbar: (inputMethod = (0, $bMFKb.INPUT_METHOD).TOOLBAR)=>(0, $eBKSl.showLinkToolbar)(inputMethod, api?.analytics?.actions),
            updateLink: (href, text)=>{
                const linkMark = api?.hyperlink?.sharedState.currentState()?.activeLinkMark;
                const pos = $6c47c03ecfef6936$var$getPosFromActiveLinkMark(linkMark);
                if (pos === undefined) return ()=>null;
                return (0, $eBKSl.updateLinkEditorCommand)(href, text, pos);
            },
            removeLink: ()=>{
                const linkMark = api?.hyperlink?.sharedState.currentState()?.activeLinkMark;
                const pos = $6c47c03ecfef6936$var$getPosFromActiveLinkMark(linkMark);
                if (pos === undefined) return ()=>null;
                return (0, $eBKSl.removeLinkEditorCommand)(pos, api?.analytics?.actions);
            }
        },
        actions: {
            hideLinkToolbar: (0, $eBKSl.hideLinkToolbarSetMeta),
            insertLink: (inputMethod, from, to, href, title, displayText, cardsAvailable = false, sourceEvent, appearance)=>(0, $eBKSl.insertLinkWithAnalytics)(inputMethod, from, to, href, api?.card?.actions, api?.analytics?.actions, title, displayText, cardsAvailable, sourceEvent, appearance),
            updateLink: (0, $eBKSl.updateLink)
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            return (0, $jfXvp.stateKey).getState(editorState);
        },
        pmPlugins () {
            return [
                {
                    name: 'hyperlink',
                    plugin: ({ dispatch: dispatch, getIntl: getIntl })=>(0, $jfXvp.plugin)(dispatch, getIntl(), options?.editorAppearance, api, options?.onClickCallback, // @ts-ignore Temporary solution to check for Live Page editor.
                        options.__livePage)
                },
                {
                    name: 'fakeCursorToolbarPlugin',
                    plugin: ()=>(0, $2mlVO.default)
                },
                {
                    name: 'hyperlinkInputRule',
                    plugin: ({ schema: schema })=>(0, $fqUwN.createInputRulePlugin)(schema, api?.analytics?.actions)
                },
                {
                    name: 'hyperlinkKeymap',
                    plugin: ()=>(0, $5uCg0.createKeymapPlugin)(api?.analytics?.actions)
                },
                {
                    name: 'hyperlinkToolbarButtons',
                    plugin: ()=>{
                        const hasCard = !!api?.card?.actions;
                        return (0, $68iXk.toolbarButtonsPlugin)(hasCard ? {
                            skipAnalytics: true
                        } : undefined);
                    }
                }
            ];
        },
        pluginsOptions: {
            quickInsert: ({ formatMessage: formatMessage })=>[
                    {
                        id: 'hyperlink',
                        title: formatMessage((0, $46A2h.toolbarInsertBlockMessages).link),
                        description: formatMessage((0, $46A2h.toolbarInsertBlockMessages).linkDescription),
                        keywords: [
                            'hyperlink',
                            'url'
                        ],
                        priority: 1200,
                        keyshortcut: (0, $6Exgk.tooltip)((0, $6Exgk.addLink)),
                        icon: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $c1NDo.IconLink), {}),
                        action (insert, state) {
                            const tr = insert(undefined);
                            tr.setMeta((0, $jfXvp.stateKey), {
                                type: (0, $4axGb.LinkAction).SHOW_INSERT_TOOLBAR,
                                inputMethod: (0, $bMFKb.INPUT_METHOD).QUICK_INSERT
                            });
                            const analyticsAttached = api?.analytics?.actions?.attachAnalyticsEvent?.({
                                action: (0, $bMFKb.ACTION).INVOKED,
                                actionSubject: (0, $bMFKb.ACTION_SUBJECT).TYPEAHEAD,
                                actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).TYPEAHEAD_LINK,
                                attributes: {
                                    inputMethod: (0, $bMFKb.INPUT_METHOD).QUICK_INSERT
                                },
                                eventType: (0, $bMFKb.EVENT_TYPE).UI
                            })(tr);
                            return analyticsAttached !== false ? tr : false;
                        }
                    }
                ],
            floatingToolbar: (0, $4W4Vf.getToolbarConfig)(options, api),
            selectionToolbar: (state, { formatMessage: formatMessage })=>{
                const toolbarDocking = (0, $eGOwo.fg)('platform_editor_use_preferences_plugin') ? api?.userPreferences?.sharedState.currentState()?.preferences.toolbarDockingPosition : api?.selectionToolbar?.sharedState?.currentState()?.toolbarDocking;
                if (toolbarDocking === 'none' && (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1', {
                    exposure: true
                })) {
                    const toolbarButton = ()=>{
                        const { from: from, to: to } = state.selection;
                        const isEnabled = (0, $grDTV.canLinkBeCreatedInRange)(from, to)(state);
                        const title = formatMessage((0, $46A2h.toolbarInsertBlockMessages).link);
                        return {
                            type: 'button',
                            disabled: !isEnabled,
                            testId: `${$6c47c03ecfef6936$var$selectionToolbarLinkButtonTestId}`,
                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($9ucqS))),
                            title: title,
                            tooltipContent: (0, $6Exgk.tooltip)((0, $6Exgk.addLink), title),
                            showTitle: false,
                            onClick: (state, dispatch)=>{
                                return (0, $8GLF3.editorCommandToPMCommand)((0, $eBKSl.showLinkToolbar)((0, $bMFKb.INPUT_METHOD).FLOATING_TB, api?.analytics?.actions))(state, dispatch);
                            }
                        };
                    };
                    return {
                        isToolbarAbove: true,
                        items: [
                            toolbarButton()
                        ],
                        rank: 2
                    };
                } else return undefined;
            },
            primaryToolbarComponent: !api?.primaryToolbar && (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1', {
                exposure: true
            }) ? primaryToolbarComponent : undefined
        }
    };
};

});
parcelRegister("4axGb", function(module, exports) {

$parcel$export(module.exports, "LinkAction", () => $db469bd5a248a7ca$export$6dcc1033b74c9344);
$parcel$export(module.exports, "InsertStatus", () => $db469bd5a248a7ca$export$8dcc3cd59f9a0726);
var $db469bd5a248a7ca$export$6dcc1033b74c9344 = /*#__PURE__*/ function(LinkAction) {
    LinkAction["SHOW_INSERT_TOOLBAR"] = "SHOW_INSERT_TOOLBAR";
    LinkAction["HIDE_TOOLBAR"] = "HIDE_TOOLBAR";
    LinkAction["SELECTION_CHANGE"] = "SELECTION_CHANGE";
    LinkAction["INSERT_LINK_TOOLBAR"] = "INSERT";
    LinkAction["EDIT_INSERTED_TOOLBAR"] = "EDIT_INSERTED_TOOLBAR";
    LinkAction["SET_CONFIGURE_BUTTON_TARGET_POS"] = "SET_CONFIGURE_BUTTON_TARGET_POS";
    LinkAction["SET_CONFIGURE_DROPDOWN_OPEN"] = "SET_CONFIGURE_DROPDOWN_OPEN";
    return LinkAction;
}({});
var $db469bd5a248a7ca$export$8dcc3cd59f9a0726 = /*#__PURE__*/ function(InsertStatus) {
    InsertStatus["EDIT_LINK_TOOLBAR"] = "EDIT";
    InsertStatus["INSERT_LINK_TOOLBAR"] = "INSERT";
    InsertStatus["EDIT_INSERTED_TOOLBAR"] = "EDIT_INSERTED";
    return InsertStatus;
}({});

});

parcelRegister("9ucqS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bb119a22bda01c1dc796d8c652f466ee>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6e808f42332e9d94$var$_react = $6e808f42332e9d94$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $6e808f42332e9d94$var$_link = $6e808f42332e9d94$var$_interopRequireDefault((parcelRequire("cV8sz")));

var $6e808f42332e9d94$var$_link2 = $6e808f42332e9d94$var$_interopRequireDefault((parcelRequire("frcEo")));
function $6e808f42332e9d94$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LinkIcon.
 * This component is LinkIcon, with `UNSAFE_fallbackIcon` set to "EditorLinkIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6e808f42332e9d94$var$LinkIcon = (props)=>/*#__PURE__*/ $6e808f42332e9d94$var$_react.default.createElement($6e808f42332e9d94$var$_link.default, Object.assign({
        LEGACY_fallbackIcon: $6e808f42332e9d94$var$_link2.default
    }, props));
$6e808f42332e9d94$var$LinkIcon.Name = 'LinkIconMigration';
var $6e808f42332e9d94$var$_default = module.exports.default = $6e808f42332e9d94$var$LinkIcon;

});
parcelRegister("frcEo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b3d330c229d7652a$var$_react = $b3d330c229d7652a$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $b3d330c229d7652a$var$_link = $b3d330c229d7652a$var$_interopRequireDefault((parcelRequire("cV8sz")));
function $b3d330c229d7652a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $b3d330c229d7652a$var$EditorLinkIcon = (props)=>/*#__PURE__*/ $b3d330c229d7652a$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M12.654 8.764a.858.858 0 0 1-1.213-1.213l1.214-1.214a3.717 3.717 0 0 1 5.257 0 3.714 3.714 0 0 1 .001 5.258l-1.214 1.214-.804.804a3.72 3.72 0 0 1-5.263.005.858.858 0 0 1 1.214-1.214c.781.782 2.05.78 2.836-.005l.804-.803 1.214-1.214a2 2 0 0 0-.001-2.831 2 2 0 0 0-2.83 0zm-.808 6.472a.858.858 0 0 1 1.213 1.213l-1.214 1.214a3.717 3.717 0 0 1-5.257 0 3.714 3.714 0 0 1-.001-5.258l1.214-1.214.804-.804a3.72 3.72 0 0 1 5.263-.005.858.858 0 0 1-1.214 1.214 2.005 2.005 0 0 0-2.836.005l-.804.803L7.8 13.618a2 2 0 0 0 .001 2.831 2 2 0 0 0 2.83 0z"/></svg>`
    }, props, {
        newIcon: $b3d330c229d7652a$var$_link.default
    }));
$b3d330c229d7652a$var$EditorLinkIcon.displayName = 'EditorLinkIcon';
var $b3d330c229d7652a$var$_default = module.exports.default = $b3d330c229d7652a$var$EditorLinkIcon;

});


parcelRegister("eBKSl", function(module, exports) {

$parcel$export(module.exports, "updateLinkEditorCommand", () => $2caeb89afa51b896$export$1f68f6e2d4509ef7);
$parcel$export(module.exports, "updateLink", () => $2caeb89afa51b896$export$468bc07728835ac4);
$parcel$export(module.exports, "insertLinkWithAnalytics", () => $2caeb89afa51b896$export$61f4de3ecc2b935b);
$parcel$export(module.exports, "removeLink", () => $2caeb89afa51b896$export$91d8072017908bea);
$parcel$export(module.exports, "removeLinkEditorCommand", () => $2caeb89afa51b896$export$32e967ed59808fd);
$parcel$export(module.exports, "editInsertedLink", () => $2caeb89afa51b896$export$8eb8ea8f98f386b5);
$parcel$export(module.exports, "showLinkToolbar", () => $2caeb89afa51b896$export$83c364d103479f90);
$parcel$export(module.exports, "hideLinkToolbar", () => $2caeb89afa51b896$export$bd1cd60a9b31da5e);
$parcel$export(module.exports, "hideLinkToolbarSetMeta", () => $2caeb89afa51b896$export$534add8453a7a184);
$parcel$export(module.exports, "onEscapeCallback", () => $2caeb89afa51b896$export$34daa751a305794c);
$parcel$export(module.exports, "onClickAwayCallback", () => $2caeb89afa51b896$export$e72685a867c8a4f2);

var $bMFKb = parcelRequire("bMFKb");
var $97Qim = parcelRequire("97Qim");

var $6C2m6 = parcelRequire("6C2m6");

var $asjM0 = parcelRequire("asjM0");

var $a36Ig = parcelRequire("a36Ig");
var $4axGb = parcelRequire("4axGb");

var $8GLF3 = parcelRequire("8GLF3");

var $grDTV = parcelRequire("grDTV");

var $3lIcL = parcelRequire("3lIcL");

var $jfXvp = parcelRequire("jfXvp");
function $2caeb89afa51b896$var$setLinkHrefEditorCommand(href, pos, editorAnalyticsApi, to, isTabPressed) {
    return ({ tr: tr })=>{
        if (!(0, $a36Ig.isTextAtPos)(pos)({
            tr: tr
        })) return null;
        const $pos = tr.doc.resolve(pos);
        const node = tr.doc.nodeAt(pos);
        const linkMark = tr.doc.type.schema.marks.link;
        const mark = linkMark.isInSet(node.marks);
        const url = (0, $grDTV.normalizeUrl)(href);
        if (mark && mark.attrs.href === url) return null;
        const rightBound = to && pos !== to ? to : pos - $pos.textOffset + node.nodeSize;
        tr.removeMark(pos, rightBound, linkMark);
        if (href.trim()) tr.addMark(pos, rightBound, linkMark.create({
            ...mark && mark.attrs || {},
            href: url
        }));
        else editorAnalyticsApi?.attachAnalyticsEvent((0, $97Qim.unlinkPayload)((0, $bMFKb.ACTION_SUBJECT_ID).HYPERLINK))(tr);
        if (!isTabPressed) tr.setMeta((0, $jfXvp.stateKey), {
            type: (0, $4axGb.LinkAction).HIDE_TOOLBAR
        });
        return tr;
    };
}
function $2caeb89afa51b896$export$911a683cdd8a2ccf(href, pos, editorAnalyticsApi, to, isTabPressed) {
    return (0, $8GLF3.editorCommandToPMCommand)($2caeb89afa51b896$var$setLinkHrefEditorCommand(href, pos, editorAnalyticsApi, to, isTabPressed));
}
function $2caeb89afa51b896$export$1f68f6e2d4509ef7(href, text, pos, to) {
    return ({ tr: tr })=>{
        const $pos = tr.doc.resolve(pos);
        const node = tr.doc.nodeAt(pos);
        if (!node) return null;
        const url = (0, $grDTV.normalizeUrl)(href);
        const mark = tr.doc.type.schema.marks.link.isInSet(node.marks);
        const linkMark = tr.doc.type.schema.marks.link;
        const rightBound = to && pos !== to ? to : pos - $pos.textOffset + node.nodeSize;
        if (!url && text) {
            tr.removeMark(pos, rightBound, linkMark);
            tr.insertText(text, pos, rightBound);
        } else if (!url) return null;
        else {
            tr.insertText(text, pos, rightBound);
            // Casting to LinkAttributes to prevent wrong attributes been passed (Example ED-7951)
            const linkAttrs = {
                ...mark && mark.attrs || {},
                href: url
            };
            tr.addMark(pos, pos + text.length, linkMark.create(linkAttrs));
            tr.setMeta((0, $jfXvp.stateKey), {
                type: (0, $4axGb.LinkAction).HIDE_TOOLBAR
            });
        }
        return tr;
    };
}
function $2caeb89afa51b896$export$468bc07728835ac4(href, text, pos, to) {
    return (0, $8GLF3.editorCommandToPMCommand)($2caeb89afa51b896$export$1f68f6e2d4509ef7(href, text, pos, to));
}
function $2caeb89afa51b896$export$c13c4fbf8f656592(from, to, incomingHref, incomingTitle, displayText, source, sourceEvent, appearance = 'inline', cardApiActions) {
    return (state, dispatch)=>{
        const link = state.schema.marks.link;
        const { tr: tr } = state;
        if (incomingHref.trim()) {
            const normalizedUrl = (0, $grDTV.normalizeUrl)(incomingHref);
            // NB: in this context, `currentText` represents text which has been
            // highlighted in the Editor, upon which a link is is being added.
            const currentText = (0, $jfXvp.stateKey).getState(state)?.activeText;
            let markEnd = to;
            const text = displayText || incomingTitle || incomingHref;
            if (!displayText || displayText !== currentText) {
                tr.insertText(text, from, to);
                // new block created to wrap the link
                if (tr.mapping.map(from) === from + text.length + 2) // +1 is for the block's opening tag
                markEnd = from + text.length + 1;
                else markEnd = from + text.length;
            }
            tr.addMark(from, markEnd, link.create({
                href: normalizedUrl
            }));
            tr.setSelection((0, $3lIcL.Selection).near(tr.doc.resolve(markEnd)));
            if (!displayText || displayText === incomingHref) {
                const queueCardsFromChangedTr = cardApiActions?.queueCardsFromChangedTr;
                if (queueCardsFromChangedTr) queueCardsFromChangedTr?.(state, tr, // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                source, (0, $bMFKb.ACTION).INSERTED, false, sourceEvent, appearance);
                else (0, $6C2m6.addLinkMetadata)(state.selection, tr, {
                    action: (0, $bMFKb.ACTION).INSERTED,
                    inputMethod: source,
                    sourceEvent: sourceEvent
                });
            } else /**
				 * Add link metadata because queue cards would have otherwise handled this for us
				 */ (0, $6C2m6.addLinkMetadata)(state.selection, tr, {
                action: (0, $bMFKb.ACTION).INSERTED,
                inputMethod: source,
                sourceEvent: sourceEvent
            });
            tr.setMeta((0, $jfXvp.stateKey), {
                type: (0, $4axGb.LinkAction).HIDE_TOOLBAR
            });
            if (dispatch) dispatch(tr);
            return true;
        }
        tr.setMeta((0, $jfXvp.stateKey), {
            type: (0, $4axGb.LinkAction).HIDE_TOOLBAR
        });
        if (dispatch) dispatch(tr);
        return false;
    };
}
const $2caeb89afa51b896$export$61f4de3ecc2b935b = (inputMethod, from, to, href, cardActions, editorAnalyticsApi, title, displayText, cardsAvailable = false, sourceEvent, appearance)=>{
    // If smart cards are available, we send analytics for hyperlinks when a smart link is rejected.
    if (cardsAvailable && !title && !displayText) return $2caeb89afa51b896$export$c13c4fbf8f656592(from, to, href, title, displayText, inputMethod, sourceEvent, appearance, cardActions);
    return (0, $asjM0.withAnalytics)(editorAnalyticsApi, (0, $grDTV.getLinkCreationAnalyticsEvent)(inputMethod, href))($2caeb89afa51b896$export$c13c4fbf8f656592(from, to, href, title, displayText, inputMethod, sourceEvent, appearance, cardActions));
};
function $2caeb89afa51b896$export$91d8072017908bea(pos, editorAnalyticsApi) {
    return (0, $6C2m6.commandWithMetadata)($2caeb89afa51b896$export$911a683cdd8a2ccf('', pos, editorAnalyticsApi), {
        action: (0, $bMFKb.ACTION).UNLINK
    });
}
function $2caeb89afa51b896$export$32e967ed59808fd(pos, editorAnalyticsApi) {
    return ({ tr: tr })=>{
        $2caeb89afa51b896$var$setLinkHrefEditorCommand('', pos, editorAnalyticsApi)({
            tr: tr
        });
        (0, $6C2m6.addLinkMetadata)(tr.selection, tr, {
            action: (0, $bMFKb.ACTION).UNLINK
        });
        return tr;
    };
}
function $2caeb89afa51b896$export$8eb8ea8f98f386b5(editorAnalyticsApi) {
    return (state, dispatch)=>{
        if (dispatch) {
            const { tr: tr } = state;
            tr.setMeta((0, $jfXvp.stateKey), {
                type: (0, $4axGb.LinkAction).EDIT_INSERTED_TOOLBAR,
                inputMethod: (0, $bMFKb.INPUT_METHOD).FLOATING_TB
            });
            editorAnalyticsApi?.attachAnalyticsEvent((0, $97Qim.buildEditLinkPayload)((0, $bMFKb.ACTION_SUBJECT_ID).HYPERLINK))(tr);
            dispatch(tr);
        }
        return true;
    };
}
function $2caeb89afa51b896$export$83c364d103479f90(inputMethod, editorAnalyticsApi) {
    return ({ tr: tr })=>{
        const newTr = tr.setMeta((0, $jfXvp.stateKey), {
            type: (0, $4axGb.LinkAction).SHOW_INSERT_TOOLBAR,
            inputMethod: inputMethod
        });
        editorAnalyticsApi?.attachAnalyticsEvent({
            action: (0, $bMFKb.ACTION).INVOKED,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).TYPEAHEAD,
            actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).TYPEAHEAD_LINK,
            attributes: {
                inputMethod: inputMethod
            },
            eventType: (0, $bMFKb.EVENT_TYPE).UI
        })(newTr);
        return newTr;
    };
}
function $2caeb89afa51b896$export$bd1cd60a9b31da5e() {
    return function(state, dispatch) {
        if (dispatch) dispatch($2caeb89afa51b896$export$534add8453a7a184(state.tr));
        return true;
    };
}
const $2caeb89afa51b896$export$534add8453a7a184 = (tr)=>{
    return tr.setMeta((0, $jfXvp.stateKey), {
        type: (0, $4axGb.LinkAction).HIDE_TOOLBAR
    });
};
const $2caeb89afa51b896$export$34daa751a305794c = (cardActions)=>(state, dispatch)=>{
        const { tr: tr } = state;
        $2caeb89afa51b896$export$534add8453a7a184(tr);
        cardActions?.hideLinkToolbar?.(tr);
        if (dispatch) {
            dispatch(tr);
            return true;
        }
        return false;
    };
const $2caeb89afa51b896$export$e72685a867c8a4f2 = (state, dispatch)=>{
    if (dispatch) {
        $2caeb89afa51b896$export$bd1cd60a9b31da5e()(state, dispatch);
        return true;
    }
    return false;
};

});
parcelRegister("jfXvp", function(module, exports) {

$parcel$export(module.exports, "stateKey", () => $a09ab5ad2f7d9456$export$77b371d6becc8882);
$parcel$export(module.exports, "plugin", () => $a09ab5ad2f7d9456$export$ca524d3785e2543);

var $aXKmr = parcelRequire("aXKmr");

var $a36Ig = parcelRequire("a36Ig");
var $551JM = parcelRequire("551JM");
var $4axGb = parcelRequire("4axGb");

var $i8KtF = parcelRequire("i8KtF");

var $grDTV = parcelRequire("grDTV");
var $3ADzg = parcelRequire("3ADzg");

var $3xw6l = parcelRequire("3xw6l");

var $3lIcL = parcelRequire("3lIcL");

var $b7EWj = parcelRequire("b7EWj");

var $eGOwo = parcelRequire("eGOwo");

var $6QVPB = parcelRequire("6QVPB");
const $a09ab5ad2f7d9456$var$mapTransactionToState = (state, tr)=>{
    if (!state) return undefined;
    else if (state.type === (0, $4axGb.InsertStatus).EDIT_LINK_TOOLBAR || state.type === (0, $4axGb.InsertStatus).EDIT_INSERTED_TOOLBAR) {
        const { pos: pos, deleted: deleted } = tr.mapping.mapResult(state.pos, 1);
        const node = tr.doc.nodeAt(pos);
        // If the position was not deleted & it is still a link
        if (!deleted && !!node.type.schema.marks.link.isInSet(node.marks)) {
            if (node === state.node && pos === state.pos) return state;
            return {
                ...state,
                pos: pos,
                node: node
            };
        }
        // If the position has been deleted, then require a navigation to show the toolbar again
        return;
    } else if (state.type === (0, $4axGb.InsertStatus).INSERT_LINK_TOOLBAR) return {
        ...state,
        from: tr.mapping.map(state.from),
        to: tr.mapping.map(state.to)
    };
    return;
};
const $a09ab5ad2f7d9456$var$toState = (state, action, editorState)=>{
    // Show insert or edit toolbar
    if (!state) switch(action){
        case (0, $4axGb.LinkAction).SHOW_INSERT_TOOLBAR:
            {
                const { from: from, to: to } = editorState.selection;
                if ((0, $grDTV.canLinkBeCreatedInRange)(from, to)(editorState)) return {
                    type: (0, $4axGb.InsertStatus).INSERT_LINK_TOOLBAR,
                    from: from,
                    to: to
                };
                return undefined;
            }
        case (0, $4axGb.LinkAction).SELECTION_CHANGE:
            // If the user has moved their cursor, see if they're in a link
            const link = (0, $a36Ig.getActiveLinkMark)(editorState);
            if (link) return {
                ...link,
                type: (0, $4axGb.InsertStatus).EDIT_LINK_TOOLBAR
            };
            return undefined;
        default:
            return undefined;
    }
    // Update toolbar state if selection changes, or if toolbar is hidden
    if (state.type === (0, $4axGb.InsertStatus).EDIT_LINK_TOOLBAR) switch(action){
        case (0, $4axGb.LinkAction).EDIT_INSERTED_TOOLBAR:
            {
                const link = (0, $a36Ig.getActiveLinkMark)(editorState);
                if (link) {
                    if (link.pos === state.pos && link.node === state.node) return {
                        ...state,
                        type: (0, $4axGb.InsertStatus).EDIT_INSERTED_TOOLBAR
                    };
                    return {
                        ...link,
                        type: (0, $4axGb.InsertStatus).EDIT_INSERTED_TOOLBAR
                    };
                }
                return undefined;
            }
        case (0, $4axGb.LinkAction).SELECTION_CHANGE:
            const link1 = (0, $a36Ig.getActiveLinkMark)(editorState);
            if (link1) {
                if (link1.pos === state.pos && link1.node === state.node) // Make sure we return the same object, if it's the same link
                return state;
                return {
                    ...link1,
                    type: (0, $4axGb.InsertStatus).EDIT_LINK_TOOLBAR
                };
            }
            return undefined;
        case (0, $4axGb.LinkAction).HIDE_TOOLBAR:
            return undefined;
        default:
            return state;
    }
    // Remove toolbar if user changes selection or toolbar is hidden
    if (state.type === (0, $4axGb.InsertStatus).INSERT_LINK_TOOLBAR) switch(action){
        case (0, $4axGb.LinkAction).SELECTION_CHANGE:
        case (0, $4axGb.LinkAction).HIDE_TOOLBAR:
            return undefined;
        default:
            return state;
    }
    return;
};
const $a09ab5ad2f7d9456$var$getActiveText = (selection)=>{
    const currentSlice = selection.content();
    if (currentSlice.size === 0) return;
    if (currentSlice.content.childCount === 1 && currentSlice.content.firstChild && selection instanceof (0, $3lIcL.TextSelection)) return currentSlice.content.firstChild.textContent;
    return;
};
const $a09ab5ad2f7d9456$export$77b371d6becc8882 = new (0, $3lIcL.PluginKey)('hyperlinkPlugin');
const $a09ab5ad2f7d9456$export$ca524d3785e2543 = (dispatch, intl, editorAppearance, pluginInjectionApi, onClickCallback, __livePage)=>new (0, $i8KtF.SafePlugin)({
        state: {
            init (_, state) {
                const canInsertLink = (0, $grDTV.canLinkBeCreatedInRange)(state.selection.from, state.selection.to)(state);
                return {
                    activeText: $a09ab5ad2f7d9456$var$getActiveText(state.selection),
                    canInsertLink: canInsertLink,
                    timesViewed: 0,
                    activeLinkMark: $a09ab5ad2f7d9456$var$toState(undefined, (0, $4axGb.LinkAction).SELECTION_CHANGE, state),
                    editorAppearance: editorAppearance
                };
            },
            apply (tr, pluginState, oldState, newState) {
                let state = pluginState;
                const action = tr.getMeta($a09ab5ad2f7d9456$export$77b371d6becc8882) && tr.getMeta($a09ab5ad2f7d9456$export$77b371d6becc8882).type;
                const inputMethod = tr.getMeta($a09ab5ad2f7d9456$export$77b371d6becc8882) && tr.getMeta($a09ab5ad2f7d9456$export$77b371d6becc8882).inputMethod;
                if (tr.docChanged) state = {
                    activeText: state.activeText,
                    canInsertLink: (0, $grDTV.canLinkBeCreatedInRange)(newState.selection.from, newState.selection.to)(newState),
                    timesViewed: state.timesViewed,
                    inputMethod: inputMethod,
                    activeLinkMark: $a09ab5ad2f7d9456$var$mapTransactionToState(state.activeLinkMark, tr),
                    editorAppearance: editorAppearance
                };
                if (action) {
                    const stateForAnalytics = [
                        (0, $4axGb.LinkAction).SHOW_INSERT_TOOLBAR,
                        (0, $4axGb.LinkAction).EDIT_INSERTED_TOOLBAR
                    ].includes(action) ? {
                        timesViewed: ++state.timesViewed,
                        searchSessionId: (0, (/*@__PURE__*/$parcel$interopDefault($aXKmr)))()
                    } : {
                        timesViewed: state.timesViewed,
                        searchSessionId: state.searchSessionId
                    };
                    state = {
                        ...__livePage && (0, $eGOwo.fg)('linking_platform_smart_links_in_live_pages') && state,
                        activeText: state.activeText,
                        canInsertLink: state.canInsertLink,
                        inputMethod: inputMethod,
                        activeLinkMark: $a09ab5ad2f7d9456$var$toState(state.activeLinkMark, action, newState),
                        editorAppearance: editorAppearance,
                        ...stateForAnalytics
                    };
                    if ((0, $eGOwo.fg)('linking_platform_smart_links_in_live_pages')) {
                        const isViewMode = pluginInjectionApi?.editorViewMode?.sharedState.currentState()?.mode === 'view';
                        if (__livePage && !isViewMode) {
                            if (action === (0, $4axGb.LinkAction).SET_CONFIGURE_DROPDOWN_OPEN) {
                                const configureDropdownOpen = tr.getMeta($a09ab5ad2f7d9456$export$77b371d6becc8882).isOpen;
                                // Hide overlay when the dropdown is closed (state is updated to false)
                                const decorations = configureDropdownOpen ? {} : {
                                    decorations: (0, $b7EWj.DecorationSet).empty
                                };
                                state = {
                                    ...state,
                                    ...decorations,
                                    configureDropdownOpen: configureDropdownOpen
                                };
                            }
                            if (action === (0, $4axGb.LinkAction).SET_CONFIGURE_BUTTON_TARGET_POS) {
                                const configureButtonTargetPos = tr.getMeta($a09ab5ad2f7d9456$export$77b371d6becc8882).pos;
                                const targetPosHasChanged = pluginState.configureButtonTargetPos !== configureButtonTargetPos;
                                let decorations = pluginState.decorations;
                                if (targetPosHasChanged && state.configureDropdownOpen !== true) {
                                    if (configureButtonTargetPos === undefined) decorations = (0, $b7EWj.DecorationSet).empty;
                                    else {
                                        const decoration = (0, $b7EWj.Decoration).widget(configureButtonTargetPos, (view)=>{
                                            return (0, $6QVPB.ButtonWrapper)({
                                                editorView: view,
                                                pos: configureButtonTargetPos,
                                                stateKey: $a09ab5ad2f7d9456$export$77b371d6becc8882,
                                                intl: intl,
                                                onOpenLinkClick: (event)=>{
                                                    if (configureButtonTargetPos === undefined || typeof configureButtonTargetPos !== 'number') return;
                                                    const node = view.state.tr.doc.nodeAt(configureButtonTargetPos);
                                                    if (node === null) return;
                                                    const url = node.marks.find((mark)=>mark.type.name === 'link')?.attrs.href;
                                                    if (!url) return;
                                                    (0, $551JM.handleNavigation)({
                                                        fireAnalyticsEvent: pluginInjectionApi?.analytics?.actions.fireAnalyticsEvent,
                                                        onClickCallback: onClickCallback,
                                                        url: url,
                                                        event: event
                                                    });
                                                }
                                            });
                                        });
                                        decorations = (0, $b7EWj.DecorationSet).create(newState.doc, [
                                            decoration
                                        ]);
                                    }
                                }
                                state = {
                                    ...state,
                                    configureButtonTargetPos: configureButtonTargetPos,
                                    decorations: decorations
                                };
                            }
                        }
                    }
                }
                const hasPositionChanged = oldState.selection.from !== newState.selection.from || oldState.selection.to !== newState.selection.to;
                if (tr.selectionSet && hasPositionChanged) state = {
                    activeText: $a09ab5ad2f7d9456$var$getActiveText(newState.selection),
                    canInsertLink: (0, $grDTV.canLinkBeCreatedInRange)(newState.selection.from, newState.selection.to)(newState),
                    activeLinkMark: $a09ab5ad2f7d9456$var$toState(state.activeLinkMark, (0, $4axGb.LinkAction).SELECTION_CHANGE, newState),
                    timesViewed: state.timesViewed,
                    searchSessionId: state.searchSessionId,
                    inputMethod: inputMethod,
                    editorAppearance: editorAppearance
                };
                if (!(0, $3ADzg.shallowEqual)(state, pluginState)) dispatch($a09ab5ad2f7d9456$export$77b371d6becc8882, state);
                return state;
            }
        },
        key: $a09ab5ad2f7d9456$export$77b371d6becc8882,
        props: {
            decorations: (state)=>{
                if (__livePage && (0, $eGOwo.fg)('linking_platform_smart_links_in_live_pages')) {
                    const { decorations: decorations } = $a09ab5ad2f7d9456$export$77b371d6becc8882.getState(state) ?? {};
                    return decorations;
                } else return (0, $b7EWj.DecorationSet).empty;
            },
            handleDOMEvents: {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                mouseup: (_, event)=>{
                    // this prevents redundant selection transaction when clicking on link
                    // link state will be update on slection change which happens on mousedown
                    if ($a09ab5ad2f7d9456$var$isLinkDirectTarget(event)) {
                        event.preventDefault();
                        return true;
                    }
                    return false;
                },
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                mousedown: (view, event)=>{
                    // since link clicks are disallowed by browsers inside contenteditable
                    // so we need to handle shift+click selection ourselves in this case
                    if (!event.shiftKey || !$a09ab5ad2f7d9456$var$isLinkDirectTarget(event)) return false;
                    const { state: state } = view;
                    const { selection: { $anchor: $anchor } } = state;
                    const newPosition = view.posAtCoords({
                        left: event.clientX,
                        top: event.clientY
                    });
                    if (newPosition?.pos != null && newPosition.pos !== $anchor.pos) {
                        const tr = state.tr.setSelection((0, $3lIcL.TextSelection).create(state.doc, $anchor.pos, newPosition.pos));
                        view.dispatch(tr);
                        return true;
                    }
                    return false;
                }
            },
            ...__livePage && (0, $eGOwo.fg)('linking_platform_smart_links_in_live_pages') && {
                markViews: {
                    link: (mark, view, inline)=>{
                        const toDOM = mark.type.spec.toDOM;
                        if (!toDOM) throw new Error('toDom method missing');
                        const dom = (0, $3xw6l.DOMSerializer).renderSpec(document, toDOM(mark, inline)).dom;
                        if (!(dom instanceof HTMLElement)) throw new Error('Error rendering hyperlink spec to dom');
                        const setTargetElementPos = (val)=>{
                            const tr = view.state.tr;
                            tr.setMeta($a09ab5ad2f7d9456$export$77b371d6becc8882, {
                                type: (0, $4axGb.LinkAction).SET_CONFIGURE_BUTTON_TARGET_POS,
                                pos: val
                            });
                            view.dispatch(tr);
                        };
                        dom.onmouseenter = ()=>{
                            const { activeLinkMark: activeLinkMark, configureButtonTargetPos: configureButtonTargetPos } = $a09ab5ad2f7d9456$export$77b371d6becc8882.getState(view.state) ?? {};
                            if (!activeLinkMark) {
                                const nodePos = view.posAtDOM(dom, -1);
                                if (nodePos !== configureButtonTargetPos) setTargetElementPos(nodePos);
                            }
                        };
                        dom.onmouseleave = ()=>{
                            const { configureButtonTargetPos: configureButtonTargetPos } = $a09ab5ad2f7d9456$export$77b371d6becc8882.getState(view.state) ?? {};
                            if (configureButtonTargetPos !== undefined) setTargetElementPos(undefined);
                        };
                        dom.onclick = (event)=>{
                            if ($a09ab5ad2f7d9456$var$isDirectTarget(event, dom)) {
                                const url = mark.attrs.href;
                                // event is globalThis.MouseEvent, while handleNavigation
                                // (and editor-common OnClickCallback) require React.MouseEvent
                                const reactMouseEvent = event;
                                (0, $551JM.handleNavigation)({
                                    fireAnalyticsEvent: pluginInjectionApi?.analytics?.actions.fireAnalyticsEvent,
                                    onClickCallback: onClickCallback,
                                    url: url,
                                    event: reactMouseEvent
                                });
                            }
                        };
                        return {
                            dom: dom
                        };
                    }
                }
            }
        }
    });
function $a09ab5ad2f7d9456$var$isLinkDirectTarget(event) {
    return event?.target instanceof HTMLElement && event.target.tagName === 'A';
}
function $a09ab5ad2f7d9456$var$isDirectTarget(event, element) {
    return event?.target instanceof HTMLElement && event.target === element;
}

});
parcelRegister("6QVPB", function(module, exports) {

$parcel$export(module.exports, "ButtonWrapper", () => $735b8fae8d69fce9$export$d53c836cccbb0d90);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $aQK2r = parcelRequire("aQK2r");

var $4nehu = parcelRequire("4nehu");

var $4axGb = parcelRequire("4axGb");
var $3uf8Z = parcelRequire("3uf8Z");
const $735b8fae8d69fce9$export$d53c836cccbb0d90 = ({ editorView: editorView, pos: pos, stateKey: stateKey, intl: intl, onOpenLinkClick: onOpenLinkClick })=>{
    const wrapper = document.createElement('span');
    wrapper.style.position = 'relative';
    const nonBreakingCharacter = '\u2060';
    const onDropdownChange = (isOpen)=>{
        editorView.dispatch(editorView.state.tr.setMeta(stateKey, {
            type: (0, $4axGb.LinkAction).SET_CONFIGURE_DROPDOWN_OPEN,
            isOpen: isOpen
        }));
    };
    (0, $aQK2r.render)(/*#__PURE__*/ (0, $gt9Am.jsxs)((0, $4nehu.default), {
        locale: intl.locale || 'en',
        messages: intl.messages,
        formats: intl.formats,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3uf8Z.OverlayButton), {
                targetElementPos: pos,
                editorView: editorView,
                onDropdownChange: onDropdownChange,
                onOpenLinkClick: onOpenLinkClick
            }),
            nonBreakingCharacter
        ]
    }), wrapper);
    return wrapper;
};

});



parcelRegister("2mlVO", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6690882379d5cd9$export$2e2bcd8739ae039);

var $4axGb = parcelRequire("4axGb");

var $i8KtF = parcelRequire("i8KtF");

var $b7EWj = parcelRequire("b7EWj");

var $SUgiK = parcelRequire("SUgiK");

var $jfXvp = parcelRequire("jfXvp");
const $c6690882379d5cd9$var$createTextCursor = (pos)=>{
    const node = document.createElement('div');
    node.className = 'ProseMirror-fake-text-cursor';
    return (0, $b7EWj.Decoration).widget(pos, node, {
        key: 'hyperlink-text-cursor'
    });
};
const $c6690882379d5cd9$var$createTextSelection = (from, to)=>(0, $b7EWj.Decoration).inline(from, to, {
        class: 'ProseMirror-fake-text-selection'
    });
const $c6690882379d5cd9$var$getInsertLinkToolbarState = (editorState)=>{
    const state = (0, $jfXvp.stateKey).getState(editorState);
    if (state && state.activeLinkMark) {
        if (state.activeLinkMark.type === (0, $4axGb.InsertStatus).INSERT_LINK_TOOLBAR) return state.activeLinkMark;
    }
    return undefined;
};
const $c6690882379d5cd9$var$fakeCursorToolbarPlugin = new (0, $i8KtF.SafePlugin)({
    key: (0, $SUgiK.fakeCursorForToolbarPluginKey),
    state: {
        init () {
            return (0, $b7EWj.DecorationSet).empty;
        },
        apply (tr, pluginState, oldState, newState) {
            const oldInsertToolbarState = $c6690882379d5cd9$var$getInsertLinkToolbarState(oldState);
            const insertToolbarState = $c6690882379d5cd9$var$getInsertLinkToolbarState(newState);
            // Map DecorationSet if it still refers to the same position in the document
            if (oldInsertToolbarState && insertToolbarState) {
                const { from: from, to: to } = insertToolbarState;
                const oldFrom = tr.mapping.map(oldInsertToolbarState.from);
                const oldTo = tr.mapping.map(oldInsertToolbarState.to);
                if (oldFrom === from && oldTo === to) return pluginState.map(tr.mapping, tr.doc);
            }
            // Update DecorationSet if new insert toolbar, or if we have moved to a different position in the doc
            if (insertToolbarState) {
                const { from: from, to: to } = insertToolbarState;
                return (0, $b7EWj.DecorationSet).create(tr.doc, [
                    from === to ? $c6690882379d5cd9$var$createTextCursor(from) : $c6690882379d5cd9$var$createTextSelection(from, to)
                ]);
            }
            return (0, $b7EWj.DecorationSet).empty;
        }
    },
    props: {
        decorations (state) {
            return (0, $SUgiK.fakeCursorForToolbarPluginKey).getState(state);
        }
    }
});
var $c6690882379d5cd9$export$2e2bcd8739ae039 = $c6690882379d5cd9$var$fakeCursorToolbarPlugin;

});
parcelRegister("SUgiK", function(module, exports) {

$parcel$export(module.exports, "fakeCursorForToolbarPluginKey", () => $cc1318b17cd4d0a7$export$38c00ed3b117ab26);

var $3lIcL = parcelRequire("3lIcL");
const $cc1318b17cd4d0a7$export$38c00ed3b117ab26 = new (0, $3lIcL.PluginKey)('fakeCursorToolbarPlugin');

});


parcelRegister("fqUwN", function(module, exports) {

$parcel$export(module.exports, "createInputRulePlugin", () => $3eb08c293b79df06$export$dc83f374e2af640d);

var $bMFKb = parcelRequire("bMFKb");

var $6C2m6 = parcelRequire("6C2m6");

var $i8KtF = parcelRequire("i8KtF");

var $leZY6 = parcelRequire("leZY6");
var $grDTV = parcelRequire("grDTV");
var $8YVeS = parcelRequire("8YVeS");

var $jCfsG = parcelRequire("jCfsG");

var $68iXk = parcelRequire("68iXk");
function $3eb08c293b79df06$export$8d0400fab1d2ed11(regexp, editorAnalyticsApi) {
    // Plain typed text (eg, typing 'www.google.com') should convert to a hyperlink
    return (0, $leZY6.createRule)(regexp, (state, match, start, end)=>{
        const { schema: schema } = state;
        if (state.doc.rangeHasMark(start, end, schema.marks.link)) return null;
        const link = match;
        // Property 'url' does not exist on type 'RegExpExecArray', the type of `match`.
        // This check is in case the match is not a Linkify match, which has a url property.
        if (link.url === undefined) return null;
        if (!(0, $8YVeS.shouldAutoLinkifyMatch)(link)) return null;
        const url = (0, $grDTV.normalizeUrl)(link.url);
        // Not previously handled; don't create a link if the URL is empty.
        // This will only happen if the `regexp` matches more links than the normalizeUrl validation;
        // if they both use the same linkify instance this shouldn't happen.
        if (url === '') return null;
        const markType = schema.mark('link', {
            href: url
        });
        // Need access to complete text to check if last URL is part of a filepath before linkifying
        const nodeBefore = state.selection.$from.nodeBefore;
        if (!nodeBefore || !nodeBefore.isText || !nodeBefore.text) return null;
        const filepaths = (0, $grDTV.findFilepaths)(nodeBefore.text, // The position referenced by 'start' is relative to the start of the document, findFilepaths deals with index in a node only.
        start - (nodeBefore.text.length - link.text.length));
        if ((0, $grDTV.isLinkInMatches)(start, filepaths)) {
            const tr = state.tr;
            return tr;
        }
        const from = start;
        const to = Math.min(start + link.text.length, state.doc.content.size);
        const tr = state.tr.addMark(from, to, markType);
        // Keep old behavior that will delete the space after the link
        if (to === end) tr.insertText(' ');
        (0, $6C2m6.addLinkMetadata)(state.selection, tr, {
            inputMethod: (0, $bMFKb.INPUT_METHOD).AUTO_DETECT
        });
        const skipAnalytics = (0, $68iXk.toolbarKey).getState(state)?.skipAnalytics ?? false;
        if (skipAnalytics) return tr;
        editorAnalyticsApi?.attachAnalyticsEvent((0, $grDTV.getLinkCreationAnalyticsEvent)((0, $bMFKb.INPUT_METHOD).AUTO_DETECT, url))(tr);
        return tr;
    });
}
function $3eb08c293b79df06$export$dc83f374e2af640d(schema, editorAnalyticsApi) {
    if (!schema.marks.link) return;
    const urlWithASpaceRule = $3eb08c293b79df06$export$8d0400fab1d2ed11((0, $grDTV.LinkMatcher).create(), editorAnalyticsApi);
    // [something](link) should convert to a hyperlink
    // eslint-disable-next-line require-unicode-regexp
    const markdownLinkRule = (0, $leZY6.createRule)(/(^|[^!])\[(.*?)\]\((\S+)\)$/, (state, match, start, end)=>{
        const { schema: schema } = state;
        const [, prefix, linkText, linkUrl] = match;
        // We don't filter this match here by shouldAutoLinkifyMatch
        // because the intent of creating a link is clear
        const url = (0, $grDTV.normalizeUrl)(linkUrl).trim();
        const markType = schema.mark('link', {
            href: url
        });
        const tr = state.tr.replaceWith(start + prefix.length, end, schema.text((linkText || '').trim(), [
            markType
        ]));
        (0, $6C2m6.addLinkMetadata)(state.selection, tr, {
            inputMethod: (0, $bMFKb.INPUT_METHOD).FORMATTING
        });
        const skipAnalytics = (0, $68iXk.toolbarKey).getState(state)?.skipAnalytics ?? false;
        if (skipAnalytics) return tr;
        editorAnalyticsApi?.attachAnalyticsEvent((0, $grDTV.getLinkCreationAnalyticsEvent)((0, $bMFKb.INPUT_METHOD).FORMATTING, url))(tr);
        return tr;
    });
    return new (0, $i8KtF.SafePlugin)((0, $jCfsG.createPlugin)('hyperlink', [
        urlWithASpaceRule,
        markdownLinkRule
    ]));
}
var $3eb08c293b79df06$export$2e2bcd8739ae039 = $3eb08c293b79df06$export$dc83f374e2af640d;

});
parcelRegister("68iXk", function(module, exports) {

$parcel$export(module.exports, "toolbarKey", () => $13c7c9663eae5dc5$export$6cbac557ea601778);
$parcel$export(module.exports, "toolbarButtonsPlugin", () => $13c7c9663eae5dc5$export$faf11097578346af);

var $i8KtF = parcelRequire("i8KtF");

var $3lIcL = parcelRequire("3lIcL");
const $13c7c9663eae5dc5$export$6cbac557ea601778 = new (0, $3lIcL.PluginKey)('hyperlinkToolbarItems');
const $13c7c9663eae5dc5$export$faf11097578346af = (initialState)=>{
    return new (0, $i8KtF.SafePlugin)({
        key: $13c7c9663eae5dc5$export$6cbac557ea601778,
        state: {
            init: (_, __)=>{
                return initialState;
            },
            apply: (tr, pluginState)=>{
                const metaState = tr.getMeta($13c7c9663eae5dc5$export$6cbac557ea601778);
                if (metaState) return metaState;
                return pluginState;
            }
        }
    });
};

});


parcelRegister("5uCg0", function(module, exports) {

$parcel$export(module.exports, "createKeymapPlugin", () => $4d42e10b25d4a341$export$1d7b13ce0747fbd);

var $iKozC = parcelRequire("iKozC");

var $bMFKb = parcelRequire("bMFKb");

var $6C2m6 = parcelRequire("6C2m6");

var $6Exgk = parcelRequire("6Exgk");

var $grDTV = parcelRequire("grDTV");
var $8YVeS = parcelRequire("8YVeS");

var $x7sgX = parcelRequire("x7sgX");

var $eBKSl = parcelRequire("eBKSl");

var $jfXvp = parcelRequire("jfXvp");

var $68iXk = parcelRequire("68iXk");
function $4d42e10b25d4a341$export$1d7b13ce0747fbd(editorAnalyticsApi) {
    const list = {};
    (0, $6Exgk.bindKeymapWithEditorCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $6Exgk.addLink).common, (0, $eBKSl.showLinkToolbar)((0, $bMFKb.INPUT_METHOD).SHORTCUT, editorAnalyticsApi), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $6Exgk.bindKeymapWithCommand)((0, $6Exgk.enter).common, $4d42e10b25d4a341$var$mayConvertLastWordToHyperlink(editorAnalyticsApi), list);
    (0, $6Exgk.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $6Exgk.insertNewLine).common, $4d42e10b25d4a341$var$mayConvertLastWordToHyperlink(editorAnalyticsApi), list);
    (0, $6Exgk.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $6Exgk.escape).common, (state, dispatch, view)=>{
        const hyperlinkPlugin = (0, $jfXvp.stateKey).getState(state);
        if (hyperlinkPlugin.activeLinkMark) {
            (0, $eBKSl.hideLinkToolbar)()(state, dispatch);
            if (view) view.focus();
            return false;
        }
        return false;
    }, list);
    return (0, $x7sgX.keymap)(list);
}
/**
 * Convert the last word before the selection to a hyperlink if it's a valid URL with a tld we want to linkify
 */ const $4d42e10b25d4a341$var$mayConvertLastWordToHyperlink = (editorAnalyticsApi)=>{
    return function(state, dispatch) {
        const skipAnalytics = (0, $68iXk.toolbarKey).getState(state)?.skipAnalytics ?? false;
        const nodeBefore = state.selection.$from.nodeBefore;
        if (!nodeBefore || !nodeBefore.isText || !nodeBefore.text) return false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const words = nodeBefore.text.split(' ');
        const lastWord = words[words.length - 1];
        const match = (0, $iKozC.getLinkMatch)(lastWord);
        if (match) {
            if (!(0, $8YVeS.shouldAutoLinkifyMatch)(match)) return false;
            const hyperlinkedText = match.raw;
            const start = state.selection.$from.pos - hyperlinkedText.length;
            const end = state.selection.$from.pos;
            if (state.doc.rangeHasMark(start, end, state.schema.marks.link)) return false;
            const url = match.url;
            const markType = state.schema.mark('link', {
                href: url
            });
            const filepaths = (0, $grDTV.findFilepaths)(nodeBefore.text, start - (nodeBefore.text.length - hyperlinkedText.length));
            if ((0, $grDTV.isLinkInMatches)(start, filepaths)) return false;
            const tr = state.tr.addMark(start, end, markType);
            if (dispatch) {
                (0, $6C2m6.addLinkMetadata)(state.selection, tr, {
                    inputMethod: (0, $bMFKb.INPUT_METHOD).AUTO_DETECT
                });
                if (skipAnalytics) dispatch(tr);
                else {
                    editorAnalyticsApi?.attachAnalyticsEvent((0, $grDTV.getLinkCreationAnalyticsEvent)((0, $bMFKb.INPUT_METHOD).AUTO_DETECT, url))(tr);
                    dispatch(tr);
                }
            }
        }
        return false;
    };
};
var $4d42e10b25d4a341$export$2e2bcd8739ae039 = $4d42e10b25d4a341$export$1d7b13ce0747fbd;

});

parcelRegister("4W4Vf", function(module, exports) {

$parcel$export(module.exports, "getToolbarConfig", () => $a780a0ad71bf734c$export$86ce8f8241c20a3);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $iKozC = parcelRequire("iKozC");

var $bMFKb = parcelRequire("bMFKb");
var $97Qim = parcelRequire("97Qim");

var $6C2m6 = parcelRequire("6C2m6");

var $kLQ9a = parcelRequire("kLQ9a");
var $bSToC = parcelRequire("bSToC");
var $cxXTK = parcelRequire("cxXTK");

var $bvdaU = parcelRequire("bvdaU");

var $53A9i = parcelRequire("53A9i");
var $4AqYB = parcelRequire("4AqYB");


var $grDTV = parcelRequire("grDTV");

var $3lIcL = parcelRequire("3lIcL");

var $BmspC = parcelRequire("BmspC");

var $gTr6H = parcelRequire("gTr6H");

var $dQl2w = parcelRequire("dQl2w");

var $8rAKL = parcelRequire("8rAKL");

var $eGOwo = parcelRequire("eGOwo");

var $9Letn = parcelRequire("9Letn");

var $92xoS = parcelRequire("92xoS");

var $eBKSl = parcelRequire("eBKSl");

var $jfXvp = parcelRequire("jfXvp");

var $68iXk = parcelRequire("68iXk");
/* type guard for edit links */ function $a780a0ad71bf734c$var$isEditLink(linkMark) {
    return linkMark.pos !== undefined;
}
const $a780a0ad71bf734c$var$dispatchAnalytics = (dispatch, state, analyticsBuilder, editorAnalyticsApi)=>{
    if (dispatch) {
        const { tr: tr } = state;
        editorAnalyticsApi?.attachAnalyticsEvent(analyticsBuilder((0, $bMFKb.ACTION_SUBJECT_ID).HYPERLINK))(tr);
        dispatch(tr);
    }
};
const $a780a0ad71bf734c$var$visitHyperlink = (editorAnalyticsApi)=>(state, dispatch)=>{
        $a780a0ad71bf734c$var$dispatchAnalytics(dispatch, state, (0, $97Qim.buildVisitedLinkPayload), editorAnalyticsApi);
        return true;
    };
function $a780a0ad71bf734c$var$getLinkText(activeLinkMark, state) {
    if (!activeLinkMark.node) return undefined;
    const textToUrl = (0, $grDTV.normalizeUrl)(activeLinkMark.node.text);
    const linkMark = activeLinkMark.node.marks.find((mark)=>mark.type === state.schema.marks.link);
    const linkHref = linkMark && linkMark.attrs.href;
    if (textToUrl === linkHref) return undefined;
    return activeLinkMark.node.text;
}
const $a780a0ad71bf734c$var$selector = (states)=>{
    return {
        timesViewed: states.hyperlinkState?.timesViewed,
        inputMethod: states.hyperlinkState?.inputMethod,
        searchSessionId: states.hyperlinkState?.searchSessionId
    };
};
const $a780a0ad71bf734c$var$useSharedState = (0, $kLQ9a.sharedPluginStateHookMigratorFactory)((api)=>{
    return (0, $cxXTK.useSharedPluginStateWithSelector)(api, [
        'hyperlink'
    ], $a780a0ad71bf734c$var$selector);
}, (api)=>{
    const { hyperlinkState: hyperlinkState } = (0, $bSToC.useSharedPluginState)(api, [
        'hyperlink'
    ]);
    return {
        timesViewed: hyperlinkState?.timesViewed,
        inputMethod: hyperlinkState?.inputMethod,
        searchSessionId: hyperlinkState?.searchSessionId
    };
});
function $a780a0ad71bf734c$export$a46cebff622c3cae({ linkPickerOptions: linkPickerOptions = {}, onSubmit: onSubmit, displayText: displayText, displayUrl: displayUrl, providerFactory: providerFactory, view: view, onCancel: onCancel, invokeMethod: invokeMethod, lpLinkPicker: lpLinkPicker, onClose: onClose, onEscapeCallback: onEscapeCallback, onClickAwayCallback: onClickAwayCallback, pluginInjectionApi: pluginInjectionApi }) {
    const { timesViewed: timesViewed, inputMethod: inputMethod, searchSessionId: searchSessionId } = $a780a0ad71bf734c$var$useSharedState(pluginInjectionApi);
    // This is constant rather than dynamic - because if someone's already got a hyperlink toolbar open,
    // we don't want to dynamically change it on them as this would cause data loss if they've already
    // started typing in the fields.
    const isOffline = (0, $eJOHy.useRef)(pluginInjectionApi?.connectivity?.sharedState.currentState()?.mode === 'offline');
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bvdaU.HyperlinkAddToolbar), {
        linkPickerOptions: linkPickerOptions,
        onSubmit: onSubmit,
        displayText: displayText,
        displayUrl: displayUrl,
        providerFactory: providerFactory,
        view: view,
        onCancel: onCancel,
        invokeMethod: invokeMethod,
        lpLinkPicker: lpLinkPicker,
        onClose: onClose,
        onEscapeCallback: onEscapeCallback,
        onClickAwayCallback: onClickAwayCallback,
        timesViewed: timesViewed,
        inputMethod: inputMethod,
        searchSessionId: searchSessionId,
        isOffline: isOffline.current
    });
}
const $a780a0ad71bf734c$export$86ce8f8241c20a3 = (options, pluginInjectionApi)=>(state, intl, providerFactory)=>{
        if (options.disableFloatingToolbar) return;
        const linkState = (0, $jfXvp.stateKey).getState(state);
        const activeLinkMark = linkState?.activeLinkMark;
        // If range selection, we don't show hyperlink floating toolbar.
        // Text Formattting toolbar is shown instaed.
        if (state.selection instanceof (0, $3lIcL.TextSelection) && state.selection.to !== state.selection.from && activeLinkMark?.type === 'EDIT' && (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1')) return;
        const { formatMessage: formatMessage } = intl;
        const editorCardActions = pluginInjectionApi?.card?.actions;
        const editorAnalyticsApi = pluginInjectionApi?.analytics?.actions;
        const lpLinkPicker = options.lpLinkPicker ?? true;
        if (activeLinkMark) {
            const hyperLinkToolbar = {
                title: 'Hyperlink floating controls',
                nodeType: [
                    state.schema.nodes.text,
                    state.schema.nodes.paragraph,
                    state.schema.nodes.heading,
                    state.schema.nodes.taskItem,
                    state.schema.nodes.decisionItem,
                    state.schema.nodes.caption
                ].filter((nodeType)=>!!nodeType),
                align: 'left',
                className: activeLinkMark.type.match('INSERT|EDIT_INSERTED') ? 'hyperlink-floating-toolbar' : '',
                // getDomRef by default uses view.state.selection.from to position the toolbar.
                // However, when the user clicks in right after the link the view.state.selection.from references to the dom after the selection.
                // So instead we want to use the activeLinkMark.pos which has been calculated as the position before the click so that would be the link node
                getDomRef: activeLinkMark && (activeLinkMark.type === 'EDIT_INSERTED' || activeLinkMark.type === 'EDIT') && (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1') ? (view)=>{
                    const domRef = (0, $BmspC.findDomRefAtPos)(activeLinkMark.pos, view.domAtPos.bind(view));
                    return domRef instanceof HTMLElement ? domRef : undefined;
                } : undefined
            };
            switch(activeLinkMark.type){
                case 'EDIT':
                    {
                        const { pos: pos, node: node } = activeLinkMark;
                        const linkMark = node.marks.filter((mark)=>mark.type === state.schema.marks.link);
                        const link = linkMark[0] && linkMark[0].attrs.href;
                        const isValidUrl = (0, $iKozC.isSafeUrl)(link);
                        const labelOpenLink = formatMessage(isValidUrl ? (0, $53A9i.linkMessages).openLink : (0, $4AqYB.linkToolbarMessages).unableToOpenLink);
                        // TODO: ED-14403 - investigate why these are not translating?
                        const labelUnlink = formatMessage((0, $4AqYB.linkToolbarMessages).unlink);
                        const editLink = formatMessage((0, $4AqYB.linkToolbarMessages).editLink);
                        const metadata = {
                            url: link,
                            title: ''
                        };
                        if (activeLinkMark.node.text) metadata.title = activeLinkMark.node.text;
                        const isEditorControlsOn = (0, $9Letn.expValEqualsNoExposure)('platform_editor_controls', 'cohort', 'variant1');
                        const cardActions = pluginInjectionApi?.card?.actions;
                        const startingToolbarItems = cardActions?.getStartingToolbarItems(intl, link, (0, $eBKSl.editInsertedLink)(editorAnalyticsApi), metadata, isEditorControlsOn ? state : undefined) ?? [
                            {
                                id: 'editor.link.edit',
                                testId: 'editor.link.edit',
                                type: 'button',
                                onClick: (0, $eBKSl.editInsertedLink)(editorAnalyticsApi),
                                title: editLink,
                                showTitle: isEditorControlsOn ? false : true,
                                metadata: metadata,
                                icon: isEditorControlsOn ? (0, (/*@__PURE__*/$parcel$interopDefault($gTr6H))) : undefined
                            },
                            {
                                type: 'separator'
                            }
                        ];
                        const openLinkButton = {
                            id: 'editor.link.openLink',
                            testId: 'editor.link.openLink',
                            type: 'button',
                            disabled: !isValidUrl,
                            target: '_blank',
                            href: isValidUrl ? link : undefined,
                            onClick: $a780a0ad71bf734c$var$visitHyperlink(editorAnalyticsApi),
                            title: labelOpenLink,
                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($8rAKL))),
                            className: 'hyperlink-open-link',
                            metadata: metadata,
                            tabIndex: null
                        };
                        const unlinkButton = {
                            id: 'editor.link.unlink',
                            testId: 'editor.link.unlink',
                            type: 'button',
                            onClick: (0, $6C2m6.commandWithMetadata)((0, $eBKSl.removeLink)(pos, editorAnalyticsApi), {
                                inputMethod: (0, $bMFKb.INPUT_METHOD).FLOATING_TB
                            }),
                            title: labelUnlink,
                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($dQl2w))),
                            tabIndex: null
                        };
                        const items = [
                            ...startingToolbarItems,
                            ...isEditorControlsOn && (0, $eGOwo.fg)('platform_editor_controls_patch_15') ? [
                                unlinkButton,
                                {
                                    type: 'separator',
                                    fullHeight: true
                                },
                                openLinkButton,
                                {
                                    type: 'separator',
                                    fullHeight: true
                                }
                            ] : [
                                openLinkButton,
                                {
                                    type: 'separator'
                                },
                                unlinkButton,
                                {
                                    type: 'separator'
                                }
                            ],
                            {
                                type: 'copy-button',
                                items: [
                                    {
                                        state: state,
                                        formatMessage: formatMessage,
                                        markType: state.schema.marks.link
                                    }
                                ]
                            },
                            ...cardActions?.getEndingToolbarItems(intl, link) ?? []
                        ];
                        return {
                            ...hyperLinkToolbar,
                            height: 32,
                            width: 250,
                            items: items,
                            scrollable: true
                        };
                    }
                case 'EDIT_INSERTED':
                case 'INSERT':
                    {
                        let link;
                        if ($a780a0ad71bf734c$var$isEditLink(activeLinkMark) && activeLinkMark.node) {
                            const linkMark = activeLinkMark.node.marks.filter((mark)=>mark.type === state.schema.marks.link);
                            link = linkMark[0] && linkMark[0].attrs.href;
                        }
                        const displayText = $a780a0ad71bf734c$var$isEditLink(activeLinkMark) ? $a780a0ad71bf734c$var$getLinkText(activeLinkMark, state) : linkState.activeText;
                        const popupHeight = lpLinkPicker ? (0, $4d66e472a8adb592$export$c635b83728f81640) : (0, $4d66e472a8adb592$export$c04a5ad015d45447);
                        return {
                            ...hyperLinkToolbar,
                            preventPopupOverflow: true,
                            height: popupHeight,
                            width: (0, $4d66e472a8adb592$export$a62aa932daf22ffe),
                            items: [
                                {
                                    type: 'custom',
                                    fallback: [],
                                    disableArrowNavigation: true,
                                    render: (view, idx)=>{
                                        if (!view) return null;
                                        return /*#__PURE__*/ (0, $gt9Am.jsx)($a780a0ad71bf734c$export$a46cebff622c3cae, {
                                            pluginInjectionApi: pluginInjectionApi,
                                            view: view,
                                            linkPickerOptions: options?.linkPicker,
                                            lpLinkPicker: lpLinkPicker,
                                            displayUrl: link,
                                            displayText: displayText || '',
                                            providerFactory: providerFactory,
                                            onCancel: ()=>view.focus(),
                                            onEscapeCallback: (0, $eBKSl.onEscapeCallback)(editorCardActions),
                                            onClickAwayCallback: (0, $eBKSl.onClickAwayCallback),
                                            onSubmit: (href, title = '', displayText, inputMethod, analytic)=>{
                                                const isEdit = $a780a0ad71bf734c$var$isEditLink(activeLinkMark);
                                                const action = isEdit ? (0, $bMFKb.ACTION).UPDATED : (0, $bMFKb.ACTION).INSERTED;
                                                const skipAnalytics = (0, $68iXk.toolbarKey).getState(state)?.skipAnalytics ?? false;
                                                const command = isEdit ? (0, $6C2m6.commandWithMetadata)((0, $eBKSl.updateLink)(href, displayText || title, activeLinkMark.pos), {
                                                    action: action,
                                                    inputMethod: inputMethod,
                                                    sourceEvent: analytic
                                                }) : (0, $eBKSl.insertLinkWithAnalytics)(inputMethod, activeLinkMark.from, activeLinkMark.to, href, editorCardActions, editorAnalyticsApi, title, displayText, skipAnalytics, analytic);
                                                command(view.state, view.dispatch, view);
                                                view.focus();
                                            }
                                        }, idx);
                                    }
                                }
                            ]
                        };
                    }
            }
        }
        return;
    };

});



parcelRegister("1mm8v", function(module, exports) {

$parcel$export(module.exports, "mentionsPlugin", () => (parcelRequire("jY2lE")).mentionsPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $jY2lE = parcelRequire("jY2lE");

});
parcelRegister("jY2lE", function(module, exports) {

$parcel$export(module.exports, "mentionsPlugin", () => $8de9c3fed0a102db$export$280dfabe1535ae84);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $aXKmr = parcelRequire("aXKmr");

var $bMFKb = parcelRequire("bMFKb");

var $h6V7a = parcelRequire("h6V7a");
var $46A2h = parcelRequire("46A2h");

var $4sxxB = parcelRequire("4sxxB");

var $c1NDo = parcelRequire("c1NDo");

var $231b4 = parcelRequire("231b4");

var $49R7i = parcelRequire("49R7i");

var $eGOwo = parcelRequire("eGOwo");

var $eYubO = parcelRequire("eYubO");

var $kI2WD = parcelRequire("kI2WD");

var $3DgvR = parcelRequire("3DgvR");

var $edPF9 = parcelRequire("edPF9");

var $afCpp = parcelRequire("afCpp");

var $6EDdM = parcelRequire("6EDdM");
const $8de9c3fed0a102db$var$processName = (name, intl)=>{
    const unknownLabel = intl.formatMessage((0, $h6V7a.mentionMessages).unknownLabel);
    if (name.status === (0, $49R7i.MentionNameStatus).OK) return `@${name.name || unknownLabel}`;
    else return `@${unknownLabel}`;
};
/**
 * We will need to clean this up once mentionProvider is
 * put inside mention plugin.
 * See: https://product-fabric.atlassian.net/browse/ED-26011
 */ function $8de9c3fed0a102db$var$Component({ mentionProvider: mentionProvider, api: api }) {
    const mentionProviderMemo = (0, $eJOHy.useMemo)(()=>{
        return mentionProvider;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const intl = (0, $lRq8t.default)();
    (0, $eJOHy.useEffect)(()=>{
        mentionProviderMemo?.then((mentionProviderSync)=>{
            api?.base?.actions?.registerMarks(({ tr: tr, node: node, pos: pos })=>{
                const { doc: doc } = tr;
                const { schema: schema } = doc.type;
                const { mention: mentionNodeType } = schema.nodes;
                const { id: id } = node.attrs;
                if (node.type === mentionNodeType) {
                    if ((0, $231b4.isResolvingMentionProvider)(mentionProviderSync)) {
                        const nameDetail = mentionProviderSync?.resolveMentionName(id);
                        let newText;
                        if ((0, $49R7i.isPromise)(nameDetail)) newText = `@${intl.formatMessage((0, $h6V7a.mentionMessages).unknownLabel)}`;
                        else newText = $8de9c3fed0a102db$var$processName(nameDetail, intl);
                        const currentPos = tr.mapping.map(pos);
                        tr.replaceWith(currentPos, currentPos + node.nodeSize, schema.text(newText, node.marks));
                    }
                }
            });
        });
    }, [
        mentionProviderMemo,
        api,
        intl
    ]);
    return null;
}
const $8de9c3fed0a102db$export$280dfabe1535ae84 = ({ config: options, api: api })=>{
    const sessionId = (0, (/*@__PURE__*/$parcel$interopDefault($aXKmr)))();
    let previousMediaProvider;
    const fireEvent = (payload, channel)=>{
        const fireAnalyticsEvent = api?.analytics?.actions?.fireAnalyticsEvent;
        if (!fireAnalyticsEvent) return;
        if (payload.attributes && !payload.attributes.sessionId) payload.attributes.sessionId = sessionId;
        fireAnalyticsEvent(payload, channel);
    };
    const typeAhead = (0, $6EDdM.createTypeAheadConfig)({
        sanitizePrivateContent: options?.sanitizePrivateContent,
        mentionInsertDisplayName: options?.insertDisplayName,
        HighlightComponent: options?.HighlightComponent,
        handleMentionsChanged: options?.handleMentionsChanged,
        fireEvent: fireEvent,
        api: api
    });
    return {
        name: 'mention',
        nodes () {
            return [
                {
                    name: 'mention',
                    node: (0, $kI2WD.mentionNodeSpec)()
                }
            ];
        },
        pmPlugins () {
            return [
                {
                    name: 'mention',
                    plugin: (pmPluginFactoryParams)=>(0, $edPF9.createMentionPlugin)({
                            pmPluginFactoryParams: pmPluginFactoryParams,
                            fireEvent: fireEvent,
                            options: options,
                            api: api
                        })
                }
            ];
        },
        contentComponent ({ providerFactory: providerFactory }) {
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4sxxB.WithProviders), {
                providers: [
                    'mentionProvider'
                ],
                providerFactory: providerFactory,
                renderNode: ({ mentionProvider: mentionProvider })=>{
                    return /*#__PURE__*/ (0, $gt9Am.jsx)($8de9c3fed0a102db$var$Component, {
                        mentionProvider: mentionProvider,
                        api: api
                    });
                }
            });
        },
        secondaryToolbarComponent ({ editorView: editorView, disabled: disabled }) {
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $afCpp.SecondaryToolbarComponent), {
                editorView: editorView,
                api: api,
                disabled: disabled,
                typeAhead: typeAhead
            });
        },
        commands: {
            insertMention: (0, $eYubO.insertMention)({
                sanitizePrivateContent: options?.sanitizePrivateContent ?? false,
                mentionInsertDisplayName: options?.insertDisplayName ?? false,
                api: api
            })
        },
        actions: {
            openTypeAhead (inputMethod) {
                return Boolean(api?.typeAhead?.actions?.open({
                    triggerHandler: typeAhead,
                    inputMethod: inputMethod
                }));
            },
            announceMentionsInsertion: (mentionChanges)=>{
                if (options?.handleMentionsChanged) options.handleMentionsChanged(mentionChanges);
            },
            setProvider: async (providerPromise)=>{
                if (!(0, $eGOwo.fg)('platform_editor_mention_provider_via_plugin_config')) return false;
                const provider = await providerPromise;
                // Prevent someone trying to set the exact same provider twice for performance reasons
                if (previousMediaProvider === provider) return false;
                previousMediaProvider = provider;
                return api?.core.actions.execute(({ tr: tr })=>tr.setMeta((0, $3DgvR.mentionPluginKey), {
                        action: (0, $edPF9.ACTIONS).SET_PROVIDER,
                        params: {
                            provider: provider
                        }
                    })) ?? false;
            }
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const mentionPluginState = (0, $3DgvR.mentionPluginKey).getState(editorState);
            return {
                ...mentionPluginState,
                typeAheadHandler: typeAhead
            };
        },
        pluginsOptions: {
            quickInsert: ({ formatMessage: formatMessage })=>[
                    {
                        id: 'mention',
                        title: formatMessage((0, $46A2h.toolbarInsertBlockMessages).mention),
                        description: formatMessage((0, $46A2h.toolbarInsertBlockMessages).mentionDescription),
                        keywords: [
                            'team',
                            'user'
                        ],
                        priority: 400,
                        keyshortcut: '@',
                        icon: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $c1NDo.IconMention), {}),
                        action (insert, state) {
                            const tr = insert(undefined);
                            const pluginState = (0, $3DgvR.mentionPluginKey).getState(state);
                            if (pluginState && pluginState.canInsertMention === false) return false;
                            api?.typeAhead?.actions.openAtTransaction({
                                triggerHandler: typeAhead,
                                inputMethod: (0, $bMFKb.INPUT_METHOD).QUICK_INSERT
                            })(tr);
                            return tr;
                        }
                    }
                ],
            typeAhead: typeAhead
        }
    };
};

});
parcelRegister("eYubO", function(module, exports) {

$parcel$export(module.exports, "createSingleMentionFragment", () => $226c4458288e9ff2$export$c39c34a625f03dcd);
$parcel$export(module.exports, "insertMention", () => $226c4458288e9ff2$export$8c4314a90d4c5fc1);

var $aXKmr = parcelRequire("aXKmr");

var $7TRmB = parcelRequire("7TRmB");

var $3xw6l = parcelRequire("3xw6l");

var $231b4 = parcelRequire("231b4");

var $eGOwo = parcelRequire("eGOwo");
const $226c4458288e9ff2$export$c39c34a625f03dcd = ({ mentionInsertDisplayName: mentionInsertDisplayName, mentionProvider: mentionProvider, tr: tr, sanitizePrivateContent: sanitizePrivateContent })=>({ name: name, id: id, userType: userType, nickname: nickname, localId: localId, accessLevel: accessLevel, isXProductUser: isXProductUser })=>{
        const schema = tr.doc.type.schema;
        const trimmedNickname = nickname && nickname.startsWith('@') ? nickname.slice(1) : nickname;
        const renderName = mentionInsertDisplayName || !trimmedNickname ? name : trimmedNickname;
        if (isXProductUser && mentionProvider && mentionProvider.inviteXProductUser) mentionProvider.inviteXProductUser(id, name);
        // Don't insert into document if document data is sanitized.
        const text = sanitizePrivateContent ? '' : `@${renderName}`;
        if (sanitizePrivateContent && (0, $231b4.isResolvingMentionProvider)(mentionProvider)) // Cache (locally) for later rendering
        mentionProvider.cacheMentionName(id, renderName);
        const annotationMarksForPos = (0, $eGOwo.fg)(// eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        'editor_inline_comments_paste_insert_nodes') ? (0, $7TRmB.getAnnotationMarksForPos)(tr.selection.$head) : undefined;
        const mentionNode = schema.nodes.mention.createChecked({
            text: text,
            id: id,
            accessLevel: accessLevel,
            userType: userType === 'DEFAULT' ? null : userType,
            localId: localId ?? (0, (/*@__PURE__*/$parcel$interopDefault($aXKmr)))()
        }, null, // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        (0, $eGOwo.fg)('editor_inline_comments_paste_insert_nodes') ? annotationMarksForPos : undefined);
        const space = schema.text(' ', // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        (0, $eGOwo.fg)('editor_inline_comments_paste_insert_nodes') ? annotationMarksForPos : undefined);
        return (0, $3xw6l.Fragment).from([
            mentionNode,
            space
        ]);
    };
const $226c4458288e9ff2$export$8c4314a90d4c5fc1 = ({ sanitizePrivateContent: sanitizePrivateContent, api: api, mentionInsertDisplayName: mentionInsertDisplayName })=>({ name: name, id: id, userType: userType, localId: localId, nickname: nickname, accessLevel: accessLevel, isXProductUser: isXProductUser })=>{
        return ({ tr: tr })=>{
            const mentionProvider = api?.mention.sharedState.currentState()?.mentionProvider;
            const mentionFragment = $226c4458288e9ff2$export$c39c34a625f03dcd({
                sanitizePrivateContent: sanitizePrivateContent,
                mentionProvider: mentionProvider,
                mentionInsertDisplayName: mentionInsertDisplayName,
                tr: tr
            })({
                name: name,
                id: id,
                userType: userType,
                nickname: nickname,
                localId: localId,
                accessLevel: accessLevel,
                isXProductUser: isXProductUser
            });
            return tr.insert(tr.selection.from, mentionFragment);
        };
    };

});

parcelRegister("kI2WD", function(module, exports) {

$parcel$export(module.exports, "mentionNodeSpec", () => $4237455725eedb17$export$a9cde69b487c37ac);

var $7axvl = parcelRequire("7axvl");

var $6D3CR = parcelRequire("6D3CR");

const $4237455725eedb17$var$isSSR = Boolean(undefined);
const $4237455725eedb17$export$a9cde69b487c37ac = ()=>{
    if ($4237455725eedb17$var$isSSR) return 0, $7axvl.mention;
    return {
        ...(0, $7axvl.mention),
        toDOM: (node)=>{
            // packages/elements/mention/src/components/Mention/index.tsx
            const mentionAttrs = {
                'aria-busy': 'true',
                contenteditable: 'false',
                'data-access-level': '',
                'data-mention-id': node.attrs.id,
                'data-prosemirror-content-type': 'node',
                'data-prosemirror-node-inline': 'true',
                'data-prosemirror-node-name': 'mention',
                style: (0, $6D3CR.convertToInlineCss)({
                    display: 'inline',
                    border: `1px solid transparent`,
                    background: `var(--ds-background-neutral, ${(0, $7bb4c1736002a04a$export$920c0d5c49070351)})`,
                    color: "var(--ds-text-subtle, #44546F)",
                    borderRadius: '20px',
                    cursor: 'pointer',
                    padding: '0 0.3em 2px 0.23em',
                    wordBreak: 'break-word'
                })
            };
            return [
                'span',
                mentionAttrs,
                node.attrs.text
            ];
        }
    };
};

});

parcelRegister("3DgvR", function(module, exports) {

$parcel$export(module.exports, "mentionPluginKey", () => $3392c23c6863d1e3$export$617302757e30e37c);

var $3lIcL = parcelRequire("3lIcL");
const $3392c23c6863d1e3$export$617302757e30e37c = new (0, $3lIcL.PluginKey)('mentionPlugin');

});

parcelRegister("edPF9", function(module, exports) {

$parcel$export(module.exports, "ACTIONS", () => $c02d1bc3a65a993c$export$92a1a3b7554e9387);
$parcel$export(module.exports, "createMentionPlugin", () => $c02d1bc3a65a993c$export$36c073f17660f60f);

var $bMFKb = parcelRequire("bMFKb");

var $i8KtF = parcelRequire("i8KtF");

var $BmspC = parcelRequire("BmspC");

var $bPSqT = parcelRequire("bPSqT");

var $49R7i = parcelRequire("49R7i");

var $eGOwo = parcelRequire("eGOwo");

var $8n29V = parcelRequire("8n29V");


var $3DgvR = parcelRequire("3DgvR");

var $953G4 = parcelRequire("953G4");
const $c02d1bc3a65a993c$export$92a1a3b7554e9387 = {
    SET_PROVIDER: 'SET_PROVIDER'
};
const $c02d1bc3a65a993c$var$PACKAGE_NAME = "platform-pkg";
const $c02d1bc3a65a993c$var$PACKAGE_VERSION = "0.0.0-use.local";
const $c02d1bc3a65a993c$var$setProvider = (provider)=>(state, dispatch)=>{
        if (dispatch) dispatch(state.tr.setMeta((0, $3DgvR.mentionPluginKey), {
            action: $c02d1bc3a65a993c$export$92a1a3b7554e9387.SET_PROVIDER,
            params: {
                provider: provider
            }
        }));
        return true;
    };
function $c02d1bc3a65a993c$export$36c073f17660f60f({ pmPluginFactoryParams: pmPluginFactoryParams, fireEvent: fireEvent, options: options, api: api }) {
    let mentionProvider;
    const sendAnalytics = (event, actionSubject, action, attributes)=>{
        if (event === (0, $bPSqT.SLI_EVENT_TYPE) || event === (0, $bPSqT.SMART_EVENT_TYPE)) fireEvent({
            action: action,
            actionSubject: actionSubject,
            eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL,
            attributes: {
                packageName: $c02d1bc3a65a993c$var$PACKAGE_NAME,
                packageVersion: $c02d1bc3a65a993c$var$PACKAGE_VERSION,
                componentName: (0, $49R7i.ComponentNames).MENTION,
                ...attributes
            }
        }, 'fabricElements');
    };
    return new (0, $i8KtF.SafePlugin)({
        key: (0, $3DgvR.mentionPluginKey),
        state: {
            init (_, state) {
                const canInsertMention = (0, $953G4.canMentionBeCreatedInRange)(state.selection.from, state.selection.to)(state);
                return {
                    canInsertMention: canInsertMention
                };
            },
            apply (tr, pluginState, oldState, newState) {
                const { action: action, params: params } = tr.getMeta((0, $3DgvR.mentionPluginKey)) || {
                    action: null,
                    params: null
                };
                let hasNewPluginState = false;
                let newPluginState = pluginState;
                const hasPositionChanged = oldState.selection.from !== newState.selection.from || oldState.selection.to !== newState.selection.to;
                if (tr.docChanged || tr.selectionSet && hasPositionChanged) {
                    newPluginState = {
                        ...pluginState,
                        canInsertMention: (0, $953G4.canMentionBeCreatedInRange)(newState.selection.from, newState.selection.to)(newState)
                    };
                    hasNewPluginState = true;
                }
                switch(action){
                    case $c02d1bc3a65a993c$export$92a1a3b7554e9387.SET_PROVIDER:
                        newPluginState = {
                            ...newPluginState,
                            mentionProvider: params.provider
                        };
                        hasNewPluginState = true;
                        break;
                }
                if (hasNewPluginState) pmPluginFactoryParams.dispatch((0, $3DgvR.mentionPluginKey), newPluginState);
                return newPluginState;
            }
        },
        props: {
            nodeViews: {
                mention: (node, view, getPos, decorations, innerDecorations)=>{
                    return new (0, $8n29V.MentionNodeView)(node, {
                        options: options,
                        api: api,
                        portalProviderAPI: pmPluginFactoryParams.portalProviderAPI
                    });
                }
            }
        },
        view (editorView) {
            const providerHandler = (name, providerPromise)=>{
                switch(name){
                    case 'mentionProvider':
                        if (!providerPromise) {
                            fireEvent({
                                action: (0, $bMFKb.ACTION).ERRORED,
                                actionSubject: (0, $bMFKb.ACTION_SUBJECT).MENTION,
                                actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).MENTION_PROVIDER,
                                eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL,
                                attributes: {
                                    reason: (0, $73214003dd41c88d$export$eceeecffdf63fc89)
                                }
                            });
                            return $c02d1bc3a65a993c$var$setProvider(undefined)(editorView.state, editorView.dispatch);
                        }
                        providerPromise.then((provider)=>{
                            if (mentionProvider) mentionProvider.unsubscribe('mentionPlugin');
                            mentionProvider = provider;
                            $c02d1bc3a65a993c$var$setProvider(provider)(editorView.state, editorView.dispatch);
                            provider.subscribe('mentionPlugin', undefined, undefined, undefined, undefined, sendAnalytics);
                        }).catch(()=>{
                            fireEvent({
                                action: (0, $bMFKb.ACTION).ERRORED,
                                actionSubject: (0, $bMFKb.ACTION_SUBJECT).MENTION,
                                actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).MENTION_PROVIDER,
                                eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL,
                                attributes: {
                                    reason: (0, $73214003dd41c88d$export$7d0bcf8324b20190)
                                }
                            });
                            return $c02d1bc3a65a993c$var$setProvider(undefined)(editorView.state, editorView.dispatch);
                        });
                        break;
                }
                return;
            };
            const providerViaConfig = (0, $eGOwo.fg)('platform_editor_mention_provider_via_plugin_config');
            if (providerViaConfig && options?.mentionProvider) providerHandler('mentionProvider', options?.mentionProvider);
            else pmPluginFactoryParams.providerFactory.subscribe('mentionProvider', providerHandler);
            return {
                destroy () {
                    if (pmPluginFactoryParams.providerFactory) pmPluginFactoryParams.providerFactory.unsubscribe('mentionProvider', providerHandler);
                    if (mentionProvider) mentionProvider.unsubscribe('mentionPlugin');
                },
                update (view, prevState) {
                    const newState = view.state;
                    if (options?.handleMentionsChanged) {
                        const mentionSchema = newState.schema.nodes.mention;
                        const mentionNodesBefore = (0, $BmspC.findChildrenByType)(prevState.doc, mentionSchema);
                        const mentionLocalIdsAfter = new Set((0, $BmspC.findChildrenByType)(newState.doc, mentionSchema).map(({ node: node })=>node.attrs.localId));
                        if (mentionNodesBefore.length > mentionLocalIdsAfter.size) {
                            const deletedMentions = mentionNodesBefore.filter(({ node: node })=>!mentionLocalIdsAfter.has(node.attrs.localId)).map(({ node: node })=>({
                                    type: 'deleted',
                                    id: node.attrs.id,
                                    localId: node.attrs.localId
                                }));
                            if (deletedMentions.length > 0) options.handleMentionsChanged(deletedMentions);
                        }
                    }
                }
            };
        }
    });
}

});
parcelRegister("8n29V", function(module, exports) {

$parcel$export(module.exports, "MentionNodeView", () => $ecb3df442da2656f$export$ed501823ec7e75de);

var $7EdFW = parcelRequire("7EdFW");


var $3xw6l = parcelRequire("3xw6l");

var $231b4 = parcelRequire("231b4");
var $49R7i = parcelRequire("49R7i");

var $49R7i = parcelRequire("49R7i");

var $3rz18 = parcelRequire("3rz18");
const $ecb3df442da2656f$var$primitiveClassName = 'editor-mention-primitive';
const $ecb3df442da2656f$var$getAccessibilityLabelFromName = (name)=>name.replace(/^@/u, '');
const $ecb3df442da2656f$var$toDOM = (node)=>{
    // packages/elements/mention/src/components/Mention/index.tsx
    const mentionAttrs = {
        contenteditable: 'false',
        'data-access-level': node.attrs.accessLevel,
        'data-mention-id': node.attrs.id,
        'data-prosemirror-content-type': 'node',
        'data-prosemirror-node-inline': 'true',
        'data-prosemirror-node-name': 'mention',
        'data-prosemirror-node-view-type': 'vanilla',
        class: 'mentionView-content-wrap inlineNodeView'
    };
    return [
        'span',
        mentionAttrs,
        [
            'span',
            {
                class: 'zeroWidthSpaceContainer'
            },
            [
                'span',
                {
                    class: 'inlineNodeViewAddZeroWidthSpace'
                },
                (0, $f9e41f230eb38f84$export$15a09f5ef055bcfa)
            ]
        ],
        [
            'span',
            {
                spellcheck: 'false',
                class: $ecb3df442da2656f$var$primitiveClassName
            },
            node.attrs.text || "@\u2026"
        ],
        (0, $7EdFW.browser).android ? [
            'span',
            {
                class: 'zeroWidthSpaceContainer',
                contenteditable: 'false'
            },
            [
                'span',
                {
                    class: 'inlineNodeViewAddZeroWidthSpace'
                },
                (0, $f9e41f230eb38f84$export$15a09f5ef055bcfa)
            ]
        ] : [
            'span',
            {
                class: 'inlineNodeViewAddZeroWidthSpace'
            },
            (0, $f9e41f230eb38f84$export$15a09f5ef055bcfa)
        ]
    ];
};
const $ecb3df442da2656f$var$processName = (name)=>{
    return name.status === (0, $49R7i.MentionNameStatus).OK ? `@${name.name || ''}` : `@_|unknown|_`;
};
const $ecb3df442da2656f$var$handleProviderName = async (mentionProvider, node)=>{
    if ((0, $231b4.isResolvingMentionProvider)(mentionProvider) && node.attrs.id && !node.attrs.text) {
        const nameDetail = mentionProvider?.resolveMentionName(node.attrs.id);
        const resolvedNameDetail = await nameDetail;
        return $ecb3df442da2656f$var$processName(resolvedNameDetail);
    }
};
const $ecb3df442da2656f$var$getNewState = (isHighlighted, isRestricted)=>{
    if (isHighlighted) return 'self';
    if (isRestricted) return 'restricted';
    return 'default';
};
class $ecb3df442da2656f$export$ed501823ec7e75de {
    constructor(node, config){
        this.state = 'default';
        const { options: options, api: api, portalProviderAPI: portalProviderAPI } = config;
        const { dom: dom, contentDOM: contentDOM } = (0, $3xw6l.DOMSerializer).renderSpec(document, $ecb3df442da2656f$var$toDOM(node));
        this.dom = dom;
        this.contentDOM = contentDOM;
        this.config = config;
        this.node = node;
        this.domElement = dom instanceof HTMLElement ? dom : undefined;
        this.mentionPrimitiveElement = this.domElement ? this.domElement.querySelector(`.${$ecb3df442da2656f$var$primitiveClassName}`) ?? undefined : undefined;
        const { mentionProvider: mentionProvider } = api?.mention.sharedState.currentState() ?? {};
        this.updateState(mentionProvider);
        this.cleanup = api?.mention.sharedState.onChange(({ nextSharedState: nextSharedState })=>{
            this.updateState(nextSharedState?.mentionProvider);
        });
        const { destroyProfileCard: destroyProfileCard, removeProfileCard: removeProfileCard } = (0, $3rz18.profileCardRenderer)({
            dom: dom,
            options: options,
            portalProviderAPI: portalProviderAPI,
            node: node,
            api: api
        });
        // Accessibility attributes - based on `packages/people-and-teams/profilecard/src/components/User/ProfileCardTrigger.tsx`
        if (this.domElement && options?.profilecardProvider) {
            if (node.attrs.text) this.domElement.setAttribute('aria-label', $ecb3df442da2656f$var$getAccessibilityLabelFromName(node.attrs.text));
            this.domElement.setAttribute('aria-expanded', 'false');
            this.domElement.setAttribute('role', 'button');
            this.domElement.setAttribute('tabindex', '0');
            this.domElement.setAttribute('aria-haspopup', 'dialog');
        }
        this.destroyProfileCard = destroyProfileCard;
        this.removeProfileCard = removeProfileCard;
    }
    setClassList(state) {
        this.mentionPrimitiveElement?.classList.toggle('mention-self', state === 'self');
        this.mentionPrimitiveElement?.classList.toggle('mention-restricted', state === 'restricted');
    }
    setTextContent(name) {
        if (name && !this.node.attrs.text && this.mentionPrimitiveElement) this.mentionPrimitiveElement.textContent = name;
    }
    async updateState(mentionProvider) {
        const isHighlighted = mentionProvider?.shouldHighlightMention({
            id: this.node.attrs.id
        }) ?? false;
        const newState = $ecb3df442da2656f$var$getNewState(isHighlighted, (0, $49R7i.isRestricted)(this.node.attrs.accessLevel));
        if (newState !== this.state) {
            this.setClassList(newState);
            this.state = newState;
        }
        const name = await $ecb3df442da2656f$var$handleProviderName(mentionProvider, this.node);
        this.setTextContent(name);
        if (name && this.domElement && this.config.options?.profilecardProvider) this.domElement.setAttribute('aria-label', $ecb3df442da2656f$var$getAccessibilityLabelFromName(name));
    }
    nodeIsEqual(nextNode) {
        if (this.config.options?.sanitizePrivateContent) {
            // Compare nodes but ignore the text parameter as it may be sanitized
            const nextNodeAttrs = {
                ...nextNode.attrs,
                text: this.node.attrs.text
            };
            return this.node.hasMarkup(nextNode.type, nextNodeAttrs, nextNode.marks);
        }
        return this.node.sameMarkup(nextNode);
    }
    update(node) {
        if (!this.nodeIsEqual(node)) return false;
        this.node = node;
        return true;
    }
    destroy() {
        this.cleanup?.();
        this.destroyProfileCard?.();
    }
    deselectNode() {
        this.removeProfileCard?.();
    }
}

});
parcelRegister("3rz18", function(module, exports) {

$parcel$export(module.exports, "profileCardRenderer", () => $677f837d27a502b0$export$6adf928fbc333163);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $4eDgu = parcelRequire("4eDgu");

var $8KLBw = parcelRequire("8KLBw");

var $3lIcL = parcelRequire("3lIcL");

var $d6yAM = parcelRequire("d6yAM");
const $677f837d27a502b0$export$6adf928fbc333163 = ({ dom: dom, options: options, portalProviderAPI: portalProviderAPI, node: node, api: api })=>{
    let renderingProfileCard = false;
    const key = (0, (/*@__PURE__*/$parcel$interopDefault($8KLBw)))();
    let cleanupSelection;
    const removeProfileCard = ()=>{
        if (dom instanceof HTMLElement) dom.setAttribute('aria-expanded', 'false');
        portalProviderAPI.remove(key);
        renderingProfileCard = false;
        cleanupSelection?.();
    };
    const listenerCleanup = (0, $4eDgu.bind)(dom, {
        type: 'click',
        listener: ()=>{
            if (dom instanceof HTMLElement && options?.profilecardProvider && !renderingProfileCard) {
                dom.setAttribute('aria-expanded', 'true');
                renderingProfileCard = true;
                portalProviderAPI.render(()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $d6yAM.ProfileCardComponent), {
                        activeMention: node,
                        profilecardProvider: options?.profilecardProvider,
                        dom: dom,
                        closeComponent: removeProfileCard
                    }), dom, key);
                // If we change the selection we should also remove the profile card. The "deselectNode"
                // should usually catch this, but it's possible (ie. on triple click) for this not to be called
                // which means the profile card gets stuck open until you click + change selection
                cleanupSelection = api?.selection?.sharedState.onChange(({ nextSharedState: nextSharedState })=>{
                    const selection = nextSharedState?.selection;
                    if (selection instanceof (0, $3lIcL.NodeSelection) ? selection.node === node : false) return;
                    removeProfileCard?.();
                });
            }
        }
    });
    return {
        destroyProfileCard: ()=>{
            listenerCleanup();
            removeProfileCard?.();
        },
        removeProfileCard: removeProfileCard
    };
};

});
parcelRegister("d6yAM", function(module, exports) {

$parcel$export(module.exports, "ProfileCardComponent", () => $1a30414022733ce7$export$cbc1b955d6cce80d);
/* ProfileCardComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $4eDgu = parcelRequire("4eDgu");

var $1GAK3 = parcelRequire("1GAK3");

var $4IcLA = parcelRequire("4IcLA");
const $1a30414022733ce7$var$styles = {
    loadingStyles: "_2rkoglpi _16qs1cd0"
};
const $1a30414022733ce7$var$LoadingWrapper = ({ children: children, isLoading: isLoading })=>isLoading ? /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            $1a30414022733ce7$var$styles.loadingStyles
        ]),
        children: children
    }) : children;
const $1a30414022733ce7$export$2776629671584a76 = ({ id: id, provider: provider })=>{
    const [data, setData] = (0, $eJOHy.useState)();
    const [reportingLinesData, setReportingLinesData] = (0, $eJOHy.useState)(undefined);
    const [shouldShowGiveKudos, setShouldShowGiveKudos] = (0, $eJOHy.useState)(false);
    const [teamCentralBaseUrl, setTeamCentralBaseUrl] = (0, $eJOHy.useState)(undefined);
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(false);
    const [hasError, setHasError] = (0, $eJOHy.useState)(false);
    // From: packages/people-and-teams/profilecard/src/components/User/ProfileCardTrigger.tsx
    (0, $eJOHy.useEffect)(()=>{
        const fetchData = async ()=>{
            if (!id || !provider) return;
            setIsLoading(true);
            try {
                const [data, reportingLines, shouldGiveKudos, teamCentralBaseUrl] = await Promise.all([
                    provider?.resourceClient.getProfile(provider?.cloudId || '', id, ()=>{}),
                    provider?.resourceClient.getReportingLines(id),
                    provider?.resourceClient.shouldShowGiveKudos(),
                    provider?.resourceClient.getTeamCentralBaseUrl({
                        withOrgContext: true,
                        withSiteContext: true
                    })
                ]);
                setData(data);
                setReportingLinesData(reportingLines);
                setShouldShowGiveKudos(shouldGiveKudos ?? false);
                setTeamCentralBaseUrl(teamCentralBaseUrl);
                setHasError(false);
            } catch (e) {
                setHasError(true);
            } finally{
                setIsLoading(false);
            }
        };
        fetchData();
    }, [
        id,
        provider
    ]);
    return {
        data: data,
        reportingLinesData: reportingLinesData,
        shouldShowGiveKudos: shouldShowGiveKudos,
        teamCentralBaseUrl: teamCentralBaseUrl,
        isLoading: isLoading,
        hasError: hasError
    };
};
function $1a30414022733ce7$export$cbc1b955d6cce80d({ profilecardProvider: profilecardProvider, activeMention: activeMention, dom: dom, closeComponent: closeComponent }) {
    const [provider, setProvider] = (0, $eJOHy.useState)(undefined);
    (0, $eJOHy.useEffect)(()=>{
        profilecardProvider?.then((p)=>{
            setProvider(p);
        });
    }, [
        profilecardProvider
    ]);
    const { id: id, text: text, accessLevel: accessLevel } = activeMention.attrs ?? {};
    const actions = (0, $eJOHy.useMemo)(()=>provider?.getActions(id, text ?? '', accessLevel), [
        accessLevel,
        id,
        provider,
        text
    ]);
    const { data: data, reportingLinesData: reportingLinesData, shouldShowGiveKudos: shouldShowGiveKudos, teamCentralBaseUrl: teamCentralBaseUrl, isLoading: isLoading, hasError: hasError } = $1a30414022733ce7$export$2776629671584a76({
        id: id,
        provider: provider
    });
    (0, $eJOHy.useEffect)(()=>{
        return (0, $4eDgu.bind)(window, {
            type: 'keydown',
            listener: (e)=>{
                if (e.key === 'Escape') closeComponent();
            }
        });
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4IcLA.Popup), {
        referenceElement: dom,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($1a30414022733ce7$var$LoadingWrapper, {
            isLoading: isLoading,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1GAK3.ProfileCardLazy), {
                avatarUrl: data?.avatarUrl,
                accountType: data?.accountType,
                status: data?.status,
                statusModifiedDate: data?.statusModifiedDate,
                timestring: data?.timestring,
                isCurrentUser: data?.isCurrentUser,
                isBot: data?.isBot,
                fullName: data?.fullName,
                userId: id,
                cloudId: provider?.cloudId,
                actions: actions,
                isLoading: isLoading,
                location: data?.location,
                companyName: data?.companyName,
                customLozenges: data?.customLozenges,
                nickname: data?.nickname,
                email: data?.email,
                hasError: hasError,
                reportingLines: reportingLinesData,
                isKudosEnabled: shouldShowGiveKudos,
                teamCentralBaseUrl: teamCentralBaseUrl
            })
        })
    });
}

});
parcelRegister("1GAK3", function(module, exports) {

$parcel$export(module.exports, "ProfileCardLazy", () => $500dc3728366069c$export$403d297463f226af);

var $eJOHy = parcelRequire("eJOHy");

const $500dc3728366069c$export$403d297463f226af = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("2ly6c")));

});
parcelRegister("2ly6c", function(module, exports) {

let $1b57fe43f319ccc2$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $1b57fe43f319ccc2$var$load("ffQaD"),
    $1b57fe43f319ccc2$var$load("kvRbA"),
    $1b57fe43f319ccc2$var$load("2wjWj")
]).then(()=>parcelRequire('k60Oj'));

});


parcelRegister("4IcLA", function(module, exports) {

$parcel$export(module.exports, "Popup", () => $9bbf4f5d89c17e4e$export$129a32eedafa97c5);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8qmYl = parcelRequire("8qmYl");

var $67YQP = parcelRequire("67YQP");

var $IW7jS = parcelRequire("IW7jS");

var $k06jL = parcelRequire("k06jL");
const $9bbf4f5d89c17e4e$export$51eddd7655ca235a = ({ children: children, update: update })=>{
    // Ref used here to skip update on first render (when refs haven't been set)
    const isFirstRenderRef = (0, $eJOHy.useRef)(true);
    (0, $eJOHy.useEffect)(()=>{
        if (isFirstRenderRef.current) {
            isFirstRenderRef.current = false;
            return;
        }
        // callback function from popper that repositions pop-up on content Update
        update();
    }, [
        update,
        children
    ]);
    return children;
};
function $9bbf4f5d89c17e4e$export$129a32eedafa97c5({ referenceElement: referenceElement, children: children }) {
    const [targetRef, setPopupRef] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState(null);
    (0, $k06jL.useFocusTrap)({
        targetRef: targetRef
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Suspense), {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $67YQP.default), {
            zIndex: (0, $IW7jS.layers).modal(),
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8qmYl.Popper), {
                referenceElement: referenceElement,
                offset: [
                    0,
                    8
                ],
                placement: "bottom-end",
                strategy: "fixed",
                children: ({ ref: ref, style: style, update: update })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                        ref: (node)=>{
                            if (node) {
                                if (typeof ref === 'function') ref(node);
                                else ref.current = node;
                                setPopupRef(node);
                            }
                        },
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                        style: style,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)($9bbf4f5d89c17e4e$export$51eddd7655ca235a, {
                            update: update,
                            children: children
                        })
                    })
            })
        })
    });
}

});
parcelRegister("k06jL", function(module, exports) {

$parcel$export(module.exports, "useFocusTrap", () => $6efe33d299cdb2b1$export$5562a1f223a0d314);
/**
 * Custom hook to add focus trap
 * used for focus trap in ReactionPicker
 * copied from useFocusManager in @atlaskit/popup
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $5gCP6 = parcelRequire("5gCP6");
const $6efe33d299cdb2b1$export$5562a1f223a0d314 = ({ targetRef: targetRef })=>{
    (0, $eJOHy.useEffect)(()=>{
        if (!targetRef) return;
        const trapConfig = {
            clickOutsideDeactivates: true,
            escapeDeactivates: true,
            initialFocus: targetRef,
            fallbackFocus: targetRef,
            returnFocusOnDeactivate: true
        };
        const focusTrap = (0, (/*@__PURE__*/$parcel$interopDefault($5gCP6)))(targetRef, trapConfig);
        // wait for the popup to reposition itself before we focus
        let frameId = requestAnimationFrame(()=>{
            frameId = null;
            focusTrap.activate();
        });
        return ()=>{
            if (frameId !== null) {
                cancelAnimationFrame(frameId);
                frameId = null;
            }
            focusTrap.deactivate();
        };
    }, [
        targetRef
    ]);
};

});





const $73214003dd41c88d$export$7d0bcf8324b20190 = 'REJECTED';
const $73214003dd41c88d$export$eceeecffdf63fc89 = 'UNDEFINED';

parcelRegister("953G4", function(module, exports) {

$parcel$export(module.exports, "getMentionPluginState", () => $304b3aa2ada3741f$export$1e2b0e72eff65e51);
$parcel$export(module.exports, "canMentionBeCreatedInRange", () => $304b3aa2ada3741f$export$bdc4118452fb5868);

var $BmspC = parcelRequire("BmspC");

var $3DgvR = parcelRequire("3DgvR");
function $304b3aa2ada3741f$export$1e2b0e72eff65e51(state) {
    return (0, $3DgvR.mentionPluginKey).getState(state);
}
const $304b3aa2ada3741f$export$bdc4118452fb5868 = (from, to)=>(state)=>{
        const $from = state.doc.resolve(from);
        const $to = state.doc.resolve(to);
        const mention = state.schema.nodes.mention.createChecked();
        if ($from.parent === $to.parent && (0, $BmspC.canInsert)($from, mention)) return true;
        return false;
    };

});


parcelRegister("afCpp", function(module, exports) {

$parcel$export(module.exports, "SecondaryToolbarComponent", () => $ab4468b409d4217f$export$124ea4367cf7d1fc);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $bMFKb = parcelRequire("bMFKb");

var $kLQ9a = parcelRequire("kLQ9a");
var $bSToC = parcelRequire("bSToC");
var $cxXTK = parcelRequire("cxXTK");

var $e5wdx = parcelRequire("e5wdx");
const $ab4468b409d4217f$var$selector = (states)=>{
    return {
        mentionProvider: states.mentionState?.mentionProvider
    };
};
const $ab4468b409d4217f$var$useSharedMentionState = (0, $kLQ9a.sharedPluginStateHookMigratorFactory)((api)=>{
    return (0, $cxXTK.useSharedPluginStateWithSelector)(api, [
        'mention'
    ], $ab4468b409d4217f$var$selector);
}, (api)=>{
    const { mentionState: mentionState } = (0, $bSToC.useSharedPluginState)(api, [
        'mention'
    ]);
    return {
        mentionProvider: mentionState?.mentionProvider
    };
});
function $ab4468b409d4217f$export$124ea4367cf7d1fc({ editorView: editorView, api: api, typeAhead: typeAhead, disabled: disabled }) {
    const { mentionProvider: mentionProvider } = $ab4468b409d4217f$var$useSharedMentionState(api);
    const openMentionTypeAhead = (0, $eJOHy.useCallback)(()=>{
        api?.typeAhead?.actions?.open({
            triggerHandler: typeAhead,
            inputMethod: (0, $bMFKb.INPUT_METHOD).INSERT_MENU
        });
    }, [
        api,
        typeAhead
    ]);
    return !mentionProvider ? null : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $e5wdx.default), {
        editorView: editorView,
        onInsertMention: openMentionTypeAhead,
        isDisabled: disabled || api?.typeAhead?.actions.isAllowed(editorView.state)
    });
}

});
parcelRegister("e5wdx", function(module, exports) {

$parcel$export(module.exports, "default", () => $6277dd34d211c0d0$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $6YFG2 = parcelRequire("6YFG2");

var $h6V7a = parcelRequire("h6V7a");

var $2pk5j = parcelRequire("2pk5j");
var $9Sic1 = parcelRequire("9Sic1");

var $hyxYz = parcelRequire("hyxYz");
// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
class $6277dd34d211c0d0$var$ToolbarMention extends (0, $eJOHy.PureComponent) {
    render() {
        const mentionStringTranslated = this.props.intl.formatMessage((0, $h6V7a.mentionMessages).mentionsIconLabel);
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9Sic1.default), {
            testId: this.props.testId,
            buttonId: (0, $2pk5j.TOOLBAR_ACTION_SUBJECT_ID).MENTION,
            spacing: "none",
            onClick: this.handleInsertMention,
            disabled: this.props.isDisabled,
            title: mentionStringTranslated + '@',
            iconBefore: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hyxYz))), {
                label: mentionStringTranslated
            })
        });
    }
    constructor(...args){
        super(...args), this.handleInsertMention = ()=>{
            if (!this.props.editorView) return false;
            this.props.onInsertMention();
            return true;
        };
    }
}
var $6277dd34d211c0d0$export$2e2bcd8739ae039 = (0, $6YFG2.default)($6277dd34d211c0d0$var$ToolbarMention);

});
parcelRegister("2pk5j", function(module, exports) {

$parcel$export(module.exports, "TOOLBAR_ACTION_SUBJECT_ID", () => $690552fbaaa0f530$export$f90c25d407b3694a);
var $690552fbaaa0f530$export$f90c25d407b3694a = /*#__PURE__*/ function(TOOLBAR_ACTION_SUBJECT_ID) {
    TOOLBAR_ACTION_SUBJECT_ID["FIND_REPLACE"] = "findReplace";
    TOOLBAR_ACTION_SUBJECT_ID["EMOJI"] = "emoji";
    TOOLBAR_ACTION_SUBJECT_ID["ORDERED_LIST"] = "orderedList";
    TOOLBAR_ACTION_SUBJECT_ID["BULLET_LIST"] = "bulletList";
    TOOLBAR_ACTION_SUBJECT_ID["MEDIA"] = "media";
    TOOLBAR_ACTION_SUBJECT_ID["MENTION"] = "mention";
    TOOLBAR_ACTION_SUBJECT_ID["DECISION_LIST"] = "decisionList";
    TOOLBAR_ACTION_SUBJECT_ID["TASK_LIST"] = "taskList";
    TOOLBAR_ACTION_SUBJECT_ID["TEXT_COLOR"] = "color";
    TOOLBAR_ACTION_SUBJECT_ID["BACKGROUND_COLOR"] = "backgroundColor";
    TOOLBAR_ACTION_SUBJECT_ID["TEXT_FORMATTING_STRONG"] = "strong";
    TOOLBAR_ACTION_SUBJECT_ID["TEXT_FORMATTING_ITALIC"] = "italic";
    TOOLBAR_ACTION_SUBJECT_ID["TEXT_FORMATTING_UNDERLINE"] = "underline";
    TOOLBAR_ACTION_SUBJECT_ID["UNDO"] = "undo";
    TOOLBAR_ACTION_SUBJECT_ID["REDO"] = "redo";
    TOOLBAR_ACTION_SUBJECT_ID["INDENT"] = "indent";
    TOOLBAR_ACTION_SUBJECT_ID["OUTDENT"] = "outdent";
    TOOLBAR_ACTION_SUBJECT_ID["RECORD_VIDEO"] = "recordVideo";
    TOOLBAR_ACTION_SUBJECT_ID["AI"] = "atlassian-intelligence";
    return TOOLBAR_ACTION_SUBJECT_ID;
}({});

});

parcelRegister("hyxYz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8421189d331f9e049ee797d0467057ff>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cc7ff793be7dd205$var$_react = $cc7ff793be7dd205$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $cc7ff793be7dd205$var$_mention = $cc7ff793be7dd205$var$_interopRequireDefault((parcelRequire("4HB8x")));

var $cc7ff793be7dd205$var$_mention2 = $cc7ff793be7dd205$var$_interopRequireDefault((parcelRequire("6cJsV")));
function $cc7ff793be7dd205$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for MentionIcon.
 * This component is MentionIcon, with `UNSAFE_fallbackIcon` set to "EditorMentionIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for user mentions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cc7ff793be7dd205$var$MentionIcon = (props)=>/*#__PURE__*/ $cc7ff793be7dd205$var$_react.default.createElement($cc7ff793be7dd205$var$_mention.default, Object.assign({
        LEGACY_fallbackIcon: $cc7ff793be7dd205$var$_mention2.default
    }, props));
$cc7ff793be7dd205$var$MentionIcon.Name = 'MentionIconMigration';
var $cc7ff793be7dd205$var$_default = module.exports.default = $cc7ff793be7dd205$var$MentionIcon;

});
parcelRegister("6cJsV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4847218fcbdc0a18$var$_react = $4847218fcbdc0a18$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $4847218fcbdc0a18$var$_mention = $4847218fcbdc0a18$var$_interopRequireDefault((parcelRequire("4HB8x")));
function $4847218fcbdc0a18$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4847218fcbdc0a18$var$EditorMentionIcon = (props)=>/*#__PURE__*/ $4847218fcbdc0a18$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12.062 13.93c-.904 0-1.451-.734-1.451-1.945 0-1.226.538-1.952 1.467-1.952.928 0 1.422.764 1.422 1.967 0 1.195-.502 1.93-1.438 1.93M12 5c-3.925 0-7 3.075-7 7 0 4.596 3.521 7 7 7 .874 0 1.613-.09 2.258-.279a.751.751 0 0 0-.42-1.44c-.506.147-1.108.22-1.838.22-2.649 0-5.5-1.722-5.5-5.5 0-3.085 2.415-5.5 5.5-5.5 3.239 0 5.5 1.952 5.5 4.75 0 2.045-1.044 3-1.75 3-.007 0-.75-.11-.75-.75v-4a.75.75 0 1 0-1.5 0v.187c-.347-.585-1.017-.952-1.796-.952C10.103 8.736 9 10.04 9 11.938c0 1.984 1.103 3.312 2.753 3.312.865 0 1.51-.387 1.865-1.076.334 1.016 1.37 1.576 2.132 1.576 1.598 0 3.25-1.683 3.25-4.5C19 7.628 16.058 5 12 5"/></svg>`
    }, props, {
        newIcon: $4847218fcbdc0a18$var$_mention.default
    }));
$4847218fcbdc0a18$var$EditorMentionIcon.displayName = 'EditorMentionIcon';
var $4847218fcbdc0a18$var$_default = module.exports.default = $4847218fcbdc0a18$var$EditorMentionIcon;

});




parcelRegister("6EDdM", function(module, exports) {

$parcel$export(module.exports, "createTypeAheadConfig", () => $f397b18df29592aa$export$90e81ee10e57772b);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $aXKmr = parcelRequire("aXKmr");

var $7k8dr = parcelRequire("7k8dr");

var $7TRmB = parcelRequire("7TRmB");

var $3xw6l = parcelRequire("3xw6l");

var $BmspC = parcelRequire("BmspC");

var $bksYB = parcelRequire("bksYB");
var $3Kcmc = parcelRequire("3Kcmc");

var $231b4 = parcelRequire("231b4");

var $eGOwo = parcelRequire("eGOwo");

var $92xoS = parcelRequire("92xoS");

var $eYubO = parcelRequire("eYubO");

var $953G4 = parcelRequire("953G4");

var $aN0Mz = parcelRequire("aN0Mz");

var $19b2u = parcelRequire("19b2u");

var $ba0Gj = parcelRequire("ba0Gj");
const $f397b18df29592aa$var$createInviteItem = ({ mentionProvider: mentionProvider, onInviteItemMount: onInviteItemMount })=>({
        title: (0, $aN0Mz.INVITE_ITEM_DESCRIPTION).id,
        render: ({ isSelected: isSelected, onClick: onClick, onHover: onHover })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $aN0Mz.default), {
                productName: mentionProvider ? mentionProvider.productName : undefined,
                selected: isSelected,
                onMount: onInviteItemMount,
                onMouseEnter: onHover,
                onSelection: onClick,
                userRole: mentionProvider.userRole
            }),
        mention: (0, $aN0Mz.INVITE_ITEM_DESCRIPTION)
    });
const $f397b18df29592aa$var$withInviteItem = ({ mentionProvider: mentionProvider, firstQueryWithoutResults: firstQueryWithoutResults, currentQuery: currentQuery, onInviteItemMount: onInviteItemMount })=>(mentionItems)=>{
        const inviteItem = $f397b18df29592aa$var$createInviteItem({
            mentionProvider: mentionProvider,
            onInviteItemMount: onInviteItemMount
        });
        const keepInviteItem = (0, $ba0Gj.shouldKeepInviteItem)(currentQuery, firstQueryWithoutResults);
        if (mentionItems.length === 0) return keepInviteItem ? [
            inviteItem
        ] : [];
        return [
            ...mentionItems,
            // invite item should be shown at the bottom
            inviteItem
        ];
    };
const $f397b18df29592aa$export$f476360102d72b2 = (mention)=>{
    return {
        title: mention.id,
        render: ({ isSelected: isSelected, onClick: onClick, onHover: onHover })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $3Kcmc.default), {
                mention: mention,
                selected: isSelected,
                onMouseEnter: onHover,
                onSelection: onClick
            }),
        getCustomComponentHeight: ()=>{
            return 0, $bksYB.MENTION_ITEM_HEIGHT;
        },
        mention: mention
    };
};
function $f397b18df29592aa$export$fc10aeed3a532e2a(fn) {
    // Cache results here
    const seen = new Map();
    function memoized(mention) {
        // Check cache for hits
        const hit = seen.get(mention.id);
        if (hit) return hit;
        // Generate new result and cache it
        const result = fn(mention);
        seen.set(mention.id, result);
        return result;
    }
    return {
        call: memoized,
        clear: seen.clear.bind(seen)
    };
}
const $f397b18df29592aa$var$memoizedToItem = $f397b18df29592aa$export$fc10aeed3a532e2a($f397b18df29592aa$export$f476360102d72b2);
const $f397b18df29592aa$var$buildAndSendElementsTypeAheadAnalytics = (fireEvent)=>({ query: query, mentions: mentions, stats: stats })=>{
        let duration = 0;
        let userOrTeamIds = null;
        let teams = null;
        let xProductMentionsLength = 0;
        if (!(0, $ba0Gj.isTeamStats)(stats)) {
            // is from primary mention endpoint which could be just user mentions or user/team mentions
            duration = stats && stats.duration;
            teams = null;
            userOrTeamIds = mentions.map((mention)=>mention.id);
            xProductMentionsLength = mentions.filter((mention)=>mention.isXProductUser).length;
        } else {
            // is from dedicated team-only mention endpoint
            duration = stats && stats.teamMentionDuration;
            userOrTeamIds = null;
            teams = mentions.map((mention)=>(0, $ba0Gj.isTeamType)(mention.userType) ? {
                    teamId: mention.id,
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    includesYou: mention.context.includesYou,
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    memberCount: mention.context.memberCount
                } : null).filter((m)=>!!m);
        }
        const payload = (0, $19b2u.buildTypeAheadRenderedPayload)(duration, userOrTeamIds, query, teams, xProductMentionsLength);
        fireEvent(payload, 'fabric-elements');
    };
/**
 * When a team mention is selected, we render a team link and list of member/user mentions
 * in editor content
 */ const $f397b18df29592aa$var$buildNodesForTeamMention = (schema, selectedMention, mentionProvider, sanitizePrivateContent)=>{
    const { nodes: nodes, marks: marks } = schema;
    const { name: name, id: teamId, accessLevel: accessLevel, context: context } = selectedMention;
    // build team link
    const defaultTeamLink = `${window.location.origin}/people/team/${teamId}`;
    const teamLink = context && context.teamLink ? context.teamLink : defaultTeamLink;
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    const teamLinkNode = (0, $eGOwo.fg)('team-mention-inline-smartlink') ? schema.nodes.inlineCard.create({
        url: teamLink
    }) : // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    schema.text(name, [
        marks.link.create({
            href: teamLink
        })
    ]);
    const openBracketText = schema.text('(');
    const closeBracketText = schema.text(')');
    const emptySpaceText = schema.text(' ');
    const inlineNodes = [
        teamLinkNode,
        emptySpaceText,
        openBracketText
    ];
    const members = context && context.members ? context.members : [];
    members.forEach((member, index)=>{
        const { name: name, id: id } = member;
        const mentionName = `@${name}`;
        const text = sanitizePrivateContent ? '' : mentionName;
        if (sanitizePrivateContent && (0, $231b4.isResolvingMentionProvider)(mentionProvider)) mentionProvider.cacheMentionName(id, name);
        const userMentionNode = nodes.mention.createChecked({
            text: text,
            id: member.id,
            accessLevel: accessLevel,
            userType: 'DEFAULT',
            localId: (0, (/*@__PURE__*/$parcel$interopDefault($aXKmr)))()
        });
        inlineNodes.push(userMentionNode);
        // should not add empty space after the last user mention.
        if (index !== members.length - 1) inlineNodes.push(emptySpaceText);
    });
    inlineNodes.push(closeBracketText);
    return (0, $3xw6l.Fragment).fromArray(inlineNodes);
};
const $f397b18df29592aa$export$90e81ee10e57772b = ({ sanitizePrivateContent: sanitizePrivateContent, mentionInsertDisplayName: mentionInsertDisplayName, fireEvent: fireEvent, HighlightComponent: HighlightComponent, api: api, handleMentionsChanged: handleMentionsChanged })=>{
    let sessionId = (0, (/*@__PURE__*/$parcel$interopDefault($aXKmr)))();
    let firstQueryWithoutResults = null;
    const subscriptionKeys = new Set();
    const typeAhead = {
        id: (0, $7k8dr.TypeAheadAvailableNodes).MENTION,
        trigger: '@',
        // Custom regex must have a capture group around trigger
        // so it's possible to use it without needing to scan through all triggers again
        customRegex: '\\(?(@)',
        getHighlight: (state)=>{
            const CustomHighlightComponent = HighlightComponent;
            if (CustomHighlightComponent) return /*#__PURE__*/ (0, $gt9Am.jsx)(CustomHighlightComponent, {});
            return null;
        },
        getItems ({ query: query, editorState: editorState }) {
            const pluginState = (0, $953G4.getMentionPluginState)(editorState);
            if (!pluginState?.mentionProvider) return Promise.resolve([]);
            const { mentionProvider: mentionProvider } = pluginState;
            const { contextIdentifierProvider: contextIdentifierProvider } = api?.contextIdentifier?.sharedState.currentState() ?? {};
            return new Promise((resolve, reject)=>{
                const key = `loadingMentionsForTypeAhead_${(0, (/*@__PURE__*/$parcel$interopDefault($aXKmr)))()}`;
                const mentionsSubscribeCallback = (mentions, resultQuery = '', stats)=>{
                    if (query !== resultQuery) return;
                    mentionProvider.unsubscribe(key);
                    subscriptionKeys.delete(key);
                    const mentionItems = mentions.map((mention)=>$f397b18df29592aa$var$memoizedToItem.call(mention));
                    $f397b18df29592aa$var$buildAndSendElementsTypeAheadAnalytics(fireEvent)({
                        query: query,
                        mentions: mentions,
                        stats: stats
                    });
                    if (mentions.length === 0 && firstQueryWithoutResults === null) firstQueryWithoutResults = query;
                    if (!mentionProvider.shouldEnableInvite || mentionItems.length > 2) resolve(mentionItems);
                    else {
                        const items = $f397b18df29592aa$var$withInviteItem({
                            mentionProvider: mentionProvider,
                            firstQueryWithoutResults: firstQueryWithoutResults || '',
                            currentQuery: query,
                            onInviteItemMount: ()=>{
                                fireEvent((0, $19b2u.buildTypeAheadInviteItemViewedPayload)(sessionId, contextIdentifierProvider, mentionProvider.userRole));
                            }
                        })(mentionItems);
                        resolve(items);
                    }
                };
                subscriptionKeys.add(key);
                mentionProvider.subscribe(key, mentionsSubscribeCallback, ()=>{
                    if ((0, $92xoS.editorExperiment)('platform_editor_offline_editing_web', true)) {
                        mentionProvider.unsubscribe(key);
                        subscriptionKeys.delete(key);
                        reject('FETCH_ERROR');
                    }
                });
                mentionProvider.filter(query || '', {
                    ...contextIdentifierProvider,
                    sessionId: sessionId
                });
            });
        },
        onOpen: ()=>{
            firstQueryWithoutResults = null;
        },
        selectItem (state, item, insert, { mode: mode, stats: stats, query: query, sourceListItem: sourceListItem }) {
            const { schema: schema } = state;
            const pluginState = (0, $953G4.getMentionPluginState)(state);
            const { mentionProvider: mentionProvider } = pluginState;
            const { id: id, name: name, nickname: nickname, accessLevel: accessLevel, userType: userType, isXProductUser: isXProductUser } = item.mention;
            const trimmedNickname = nickname && nickname.startsWith('@') ? nickname.slice(1) : nickname;
            const renderName = mentionInsertDisplayName || !trimmedNickname ? name : trimmedNickname;
            const { contextIdentifierProvider: contextIdentifierProvider } = api?.contextIdentifier?.sharedState.currentState() ?? {};
            const mentionContext = {
                ...contextIdentifierProvider,
                sessionId: sessionId
            };
            if (mentionProvider && !(0, $ba0Gj.isInviteItem)(item.mention)) mentionProvider.recordMentionSelection(item.mention, mentionContext);
            // use same timer as StatsModifier
            const pickerElapsedTime = stats.startedAt ? performance.now() - stats.startedAt : 0;
            if (mentionProvider && mentionProvider.shouldEnableInvite && (0, $ba0Gj.isInviteItem)(item.mention)) {
                // Don't fire event and the callback with selection by space press
                if (mode !== 'space') {
                    fireEvent((0, $19b2u.buildTypeAheadInviteItemClickedPayload)(pickerElapsedTime, stats.keyCount.arrowUp, stats.keyCount.arrowDown, sessionId, mode, query, contextIdentifierProvider, mentionProvider.userRole));
                    if (mentionProvider.onInviteItemClick) mentionProvider.onInviteItemClick('mention');
                }
                return state.tr;
            }
            let taskListId, taskItemId;
            const taskList = (0, $BmspC.findParentNodeOfType)(state.schema.nodes.taskList)(state.selection);
            if (taskList) {
                taskListId = taskList.node.attrs.localId;
                const taskItem = (0, $BmspC.findParentNodeOfType)(state.schema.nodes.taskItem)(state.selection);
                if (taskItem) taskItemId = taskItem.node.attrs.localId;
            }
            const mentionLocalId = (0, (/*@__PURE__*/$parcel$interopDefault($aXKmr)))();
            if (handleMentionsChanged) {
                if (taskItemId) handleMentionsChanged([
                    {
                        type: 'added',
                        localId: mentionLocalId,
                        id: id,
                        taskLocalId: taskItemId,
                        method: 'typed'
                    }
                ]);
                else handleMentionsChanged([
                    {
                        type: 'added',
                        localId: mentionLocalId,
                        id: id,
                        method: 'typed'
                    }
                ]);
            }
            fireEvent((0, $19b2u.buildTypeAheadInsertedPayload)(pickerElapsedTime, stats.keyCount.arrowUp, stats.keyCount.arrowDown, sessionId, mode, item.mention, mentionLocalId, sourceListItem.map((x)=>x.mention), query, contextIdentifierProvider, taskListId, taskItemId));
            sessionId = (0, (/*@__PURE__*/$parcel$interopDefault($aXKmr)))();
            if (mentionProvider && (0, $ba0Gj.isTeamType)(userType)) return insert($f397b18df29592aa$var$buildNodesForTeamMention(schema, item.mention, mentionProvider, sanitizePrivateContent));
            if (isXProductUser && mentionProvider && mentionProvider.inviteXProductUser) mentionProvider.inviteXProductUser(id, name);
            // This replaces logic below
            if ((0, $eGOwo.fg)('platform_mention_insert_mention_refactor')) return insert((0, $eYubO.createSingleMentionFragment)({
                mentionProvider: mentionProvider,
                mentionInsertDisplayName: mentionInsertDisplayName,
                tr: state.tr,
                sanitizePrivateContent: sanitizePrivateContent
            })({
                name: name,
                id: id,
                userType: userType,
                nickname: nickname,
                localId: mentionLocalId,
                accessLevel: accessLevel,
                isXProductUser: isXProductUser
            }));
            // Don't insert into document if document data is sanitized.
            const text = sanitizePrivateContent ? '' : `@${renderName}`;
            if (sanitizePrivateContent && (0, $231b4.isResolvingMentionProvider)(mentionProvider)) // Cache (locally) for later rendering
            mentionProvider.cacheMentionName(id, renderName);
            const annotationMarksForPos = (0, $eGOwo.fg)(// eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
            'editor_inline_comments_paste_insert_nodes') ? (0, $7TRmB.getAnnotationMarksForPos)(state.tr.selection.$head) : undefined;
            const mentionNode = schema.nodes.mention.createChecked({
                text: text,
                id: id,
                accessLevel: accessLevel,
                userType: userType === 'DEFAULT' ? null : userType,
                localId: mentionLocalId
            }, null, // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
            (0, $eGOwo.fg)('editor_inline_comments_paste_insert_nodes') ? annotationMarksForPos : undefined);
            const space = schema.text(' ', // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
            (0, $eGOwo.fg)('editor_inline_comments_paste_insert_nodes') ? annotationMarksForPos : undefined);
            return insert((0, $3xw6l.Fragment).from([
                mentionNode,
                space
            ]));
        },
        dismiss ({ editorState: editorState, query: query, stats: stats, wasItemInserted: wasItemInserted }) {
            firstQueryWithoutResults = null;
            const pickerElapsedTime = stats.startedAt ? performance.now() - stats.startedAt : 0;
            if (!wasItemInserted) fireEvent((0, $19b2u.buildTypeAheadCancelPayload)(pickerElapsedTime, stats.keyCount.arrowUp, stats.keyCount.arrowDown, sessionId, query || ''), 'fabric-elements');
            const pluginState = (0, $953G4.getMentionPluginState)(editorState);
            if (pluginState?.mentionProvider) {
                const mentionProvider = pluginState.mentionProvider;
                for (const key of subscriptionKeys)mentionProvider.unsubscribe(key);
            }
            subscriptionKeys.clear();
            sessionId = (0, (/*@__PURE__*/$parcel$interopDefault($aXKmr)))();
        }
    };
    return typeAhead;
};

});
parcelRegister("7k8dr", function(module, exports) {

$parcel$export(module.exports, "TypeAheadAvailableNodes", () => $1ac3d3cd18da0878$export$8c4c885c87e5cc07);
$parcel$export(module.exports, "SelectItemMode", () => $1ac3d3cd18da0878$export$4d7d0343c6d95a0e);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $4drex = parcelRequire("4drex");
var $1ac3d3cd18da0878$export$8c4c885c87e5cc07 = /*#__PURE__*/ function(TypeAheadAvailableNodes) {
    TypeAheadAvailableNodes["EMOJI"] = "emojiTypeAhead";
    TypeAheadAvailableNodes["MENTION"] = "mentionTypeAhead";
    TypeAheadAvailableNodes["QUICK_INSERT"] = "quickInsertTypeAhead";
    return TypeAheadAvailableNodes;
}({});
var $1ac3d3cd18da0878$export$4d7d0343c6d95a0e = /*#__PURE__*/ function(SelectItemMode) {
    SelectItemMode["SHIFT_ENTER"] = "shift-enter";
    SelectItemMode["ENTER"] = "enter";
    SelectItemMode["SPACE"] = "space";
    SelectItemMode["SELECTED"] = "selected";
    SelectItemMode["TAB"] = "tab";
    return SelectItemMode;
}({});

});
parcelRegister("4drex", function(module, exports) {

$parcel$export(module.exports, "typeAheadListMessages", () => $d1e71c029c5281e2$export$940a17143b866527);

var $7qGN1 = parcelRequire("7qGN1");
const $d1e71c029c5281e2$export$940a17143b866527 = (0, $7qGN1.defineMessages)({
    typeAheadPopupLabel: {
        id: 'fabric.editor.typeAhead.popupLabel',
        defaultMessage: 'Typeahead results',
        description: 'the result of a typeahead, similar to autocomplete results+'
    },
    quickInsertPopupLabel: {
        id: 'fabric.editor.typeAhead.quickInsertPopupLabel',
        defaultMessage: 'Shortcuts for inserts and formatting',
        description: 'the result of a quick insert typeahead, similar to autocomplete results+'
    },
    quickInsertInputLabel: {
        id: 'fabric.editor.typeAhead.quickInsertInputLabel',
        defaultMessage: 'Begin typing to search or filter shortcut options',
        description: 'assisitve text for typeahed input field'
    },
    quickInsertInputPlaceholderLabel: {
        id: 'fabric.editor.typeAhead.quickInsertInputPlaceholderLabel',
        defaultMessage: 'Search',
        description: 'placeholder for typeahed input field'
    },
    emojiPopupLabel: {
        id: 'fabric.editor.typeahead.emojiPopupLabel',
        defaultMessage: 'Emoji shortcuts',
        description: 'the result of a emoji typeahead, similar to autocomplete results+'
    },
    emojiInputLabel: {
        id: 'fabric.editor.typeahead.emojiInputLabel',
        defaultMessage: 'Begin typing to search or filter emoji options',
        description: 'assisitve text for typeahed input field'
    },
    mentionPopupLabel: {
        id: 'fabric.editor.typeahead.mentionPopupLabel',
        defaultMessage: 'Users you can tag',
        description: 'the aria label of a mention typeahead popup'
    },
    mentionInputLabel: {
        id: 'fabric.editor.typeahead.mentionInputLabel',
        defaultMessage: 'Begin typing to search for users to tag',
        description: 'assisitve text for typeahed input field'
    },
    metionListItemLabel: {
        id: 'fabric.editor.typeahead.metionListItemLabel',
        defaultMessage: 'User {name} @{shortName}',
        description: 'assistive text for user mention items username and nickname'
    },
    emojiListItemLabel: {
        id: 'fabric.editor.typeahead.emojiListItemLabel',
        defaultMessage: 'Emoji {name} Text Shortcut {shortcut}',
        description: 'assistive text for emoji name and shortcut'
    },
    inputQueryAssistiveLabel: {
        id: 'fabric.editor.inputQueryAssistiveTxt',
        defaultMessage: 'When autocomplete results are available use up and down arrows to review and enter to select. Touch device users, explore by touch or with swipe gestures.',
        description: 'Assistive text to the user when using typeahead shortcut'
    },
    searchResultsLabel: {
        id: 'fabric.editor.searchResults',
        defaultMessage: '{itemsLength, plural, one {# search result} other {# search results}} available. Use Up and Down arrow keys to navigate amongst the options. Press Enter to select an option.',
        description: 'Assistive text to the user when using typeahead shortcut and it preceeds with a number - Ex: 10 search results available'
    },
    noSearchResultsLabel: {
        id: 'fabric.editor.noSearchResults',
        defaultMessage: 'No search results',
        description: 'Assistive text to the user when using typeahead shortcut'
    },
    descriptionLabel: {
        id: 'fabric.editor.description',
        defaultMessage: 'Description',
        description: 'Description'
    },
    shortcutLabel: {
        id: 'fabric.editor.shortcut',
        defaultMessage: 'Text shortcut',
        description: 'Text shortcut'
    },
    typeAheadErrorFallbackHeading: {
        id: 'fabric.editor.typeAheadErrorFallbackHeading',
        defaultMessage: 'Something went wrong!',
        description: 'Error message heading shown when typeahead items fail to load'
    },
    typeAheadErrorFallbackDesc: {
        id: 'fabric.editor.typeAheadErrorFallbackDescription',
        defaultMessage: 'Please try again.',
        description: 'Error message description shown when typeahead items fail to load'
    },
    viewAllInserts: {
        id: 'fablric.editor.viewAllInserts',
        defaultMessage: 'View all inserts',
        description: 'a text on a button that opens a side panel with a list of all insertable editor elements'
    },
    emptySearchResults: {
        id: 'fabric.editor.emptySearchResults',
        defaultMessage: "We couldn't find any results.",
        description: 'a message displayed when there are no search results'
    },
    emptySearchResultsSuggestion: {
        id: 'fabric.editor.emptySearchResultsSuggestion',
        defaultMessage: 'Select {buttonName} to browse inserts.',
        description: 'a prompt to suggest user to click a button to browse inserts when there are no search results'
    }
});

});


parcelRegister("bksYB", function(module, exports) {

$parcel$export(module.exports, "RowStyle", () => $bd988c3bd4429d86$export$be24b091af3609e7);
$parcel$export(module.exports, "AvatarStyle", () => $bd988c3bd4429d86$export$141d6bfd196b561);
$parcel$export(module.exports, "NameSectionStyle", () => $bd988c3bd4429d86$export$159b59de9966d2d3);
$parcel$export(module.exports, "FullNameStyle", () => $bd988c3bd4429d86$export$d1c198a7fd873fad);
$parcel$export(module.exports, "InfoSectionStyle", () => $bd988c3bd4429d86$export$50ad5d386685fccb);
$parcel$export(module.exports, "TimeStyle", () => $bd988c3bd4429d86$export$cf4c6e54e715dfd9);
$parcel$export(module.exports, "MENTION_ITEM_HEIGHT", () => $bd988c3bd4429d86$export$934cc98367d9ca68);
$parcel$export(module.exports, "MentionItemStyle", () => $bd988c3bd4429d86$export$cf80dda9d7a88a01);
$parcel$export(module.exports, "AccessSectionStyle", () => $bd988c3bd4429d86$export$7bf9a8fa7c04527a);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766


var $aWILV = parcelRequire("aWILV");
const $bd988c3bd4429d86$export$be24b091af3609e7 = /*#__PURE__*/ (0, $aWILV.default)("div", {
    target: "e1b3haxs7"
})({
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    overflow: 'hidden',
    padding: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-150, 12px)"}`,
    textOverflow: 'ellipsis',
    verticalAlign: 'middle'
});
const $bd988c3bd4429d86$export$141d6bfd196b561 = /*#__PURE__*/ (0, $aWILV.default)("span", {
    target: "e1b3haxs6"
})((props)=>({
        position: 'relative',
        flex: 'initial',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: props.restricted ? '0.5' : 'inherit'
    }));
const $bd988c3bd4429d86$export$159b59de9966d2d3 = /*#__PURE__*/ (0, $aWILV.default)("div", {
    target: "e1b3haxs5"
})((props)=>({
        flex: 1,
        minWidth: 0,
        marginLeft: "var(--ds-space-150, 12px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: props.restricted ? '0.5' : 'inherit'
    }));
const $bd988c3bd4429d86$export$d1c198a7fd873fad = /*#__PURE__*/ (0, $aWILV.default)("span", {
    target: "e1b3haxs4"
})({
    display: 'block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    color: `var(--ds-text, ${(0, $7bb4c1736002a04a$export$fbda843f0a27fe96)})`
});
const $bd988c3bd4429d86$export$50ad5d386685fccb = /*#__PURE__*/ (0, $aWILV.default)("div", {
    target: "e1b3haxs3"
})((props)=>({
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'right',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: props.restricted ? '0.5' : 'inherit',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&': {
            /* Lozenge */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '& > span': {
                marginBottom: "var(--ds-space-025, 2px)"
            }
        }
    }));
const $bd988c3bd4429d86$export$cf4c6e54e715dfd9 = /*#__PURE__*/ (0, $aWILV.default)("div", {
    target: "e1b3haxs2"
})({
    marginLeft: "var(--ds-space-250, 20px)",
    flex: 'none',
    color: `var(--ds-text-subtlest, ${(0, $7bb4c1736002a04a$export$d6447c357493214f)})`,
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $bd988c3bd4429d86$export$934cc98367d9ca68 = 48;
const $bd988c3bd4429d86$export$cf80dda9d7a88a01 = /*#__PURE__*/ (0, $aWILV.default)("div", {
    target: "e1b3haxs1"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: props.selected ? `var(--ds-background-selected, ${0, $7bb4c1736002a04a$export$3e51e8f1440314ba})` : 'transparent',
        display: 'block',
        overflow: 'hidden',
        listStyleType: 'none',
        height: `${$bd988c3bd4429d86$export$934cc98367d9ca68}px`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 1.2,
        cursor: 'pointer'
    }));
const $bd988c3bd4429d86$export$7bf9a8fa7c04527a = /*#__PURE__*/ (0, $aWILV.default)("div", {
    target: "e1b3haxs0"
})({
    paddingLeft: "var(--ds-space-050, 4px)",
    color: `var(--ds-text-subtle, ${(0, $7bb4c1736002a04a$export$c39c0fe0f26207ae)})`
});

});

parcelRegister("3Kcmc", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b1968dc7a50e402$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $5DgXR = parcelRequire("5DgXR");

var $jdqdp = parcelRequire("jdqdp");

var $eGOwo = parcelRequire("eGOwo");


var $eJOHy = parcelRequire("eJOHy");

var $7MiYh = parcelRequire("7MiYh");

var $49R7i = parcelRequire("49R7i");

var $9pZhV = parcelRequire("9pZhV");

var $gIOoz = parcelRequire("gIOoz");

var $21z29 = parcelRequire("21z29");

var $ac0eK = parcelRequire("ac0eK");

var $bksYB = parcelRequire("bksYB");

var $fuTmQ = parcelRequire("fuTmQ");

var $1ESZE = parcelRequire("1ESZE");

var $eQ8jX = parcelRequire("eQ8jX");

var $6vxzE = parcelRequire("6vxzE");
function $8b1968dc7a50e402$var$renderLozenge(lozenge) {
    if (typeof lozenge === 'string') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jdqdp.default), {
        children: lozenge
    });
    if (typeof lozenge === 'object') {
        const { appearance: appearance, text: text } = lozenge;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jdqdp.default), {
            appearance: appearance,
            children: text
        });
    }
    return null;
}
function $8b1968dc7a50e402$var$renderTime(time) {
    if (time) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bksYB.TimeStyle), {
        children: time
    });
    return null;
}
class $8b1968dc7a50e402$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).PureComponent {
    render() {
        const { mention: mention, selected: selected } = this.props;
        const { id: id, highlight: highlight, avatarUrl: avatarUrl, presence: presence, name: name, mentionName: mentionName, lozenge: lozenge, accessLevel: accessLevel, isXProductUser: isXProductUser } = mention;
        const { status: status, time: time } = presence || {};
        const restricted = (0, $49R7i.isRestricted)(accessLevel);
        const nameHighlights = highlight && highlight.name;
        const borderColor = selected ? `var(--ds-border, ${0, $7bb4c1736002a04a$export$3e51e8f1440314ba})` : undefined;
        const xProductUserInfoIconColor = selected ? "var(--ds-icon-selected, #0C66E4)" : "var(--ds-icon, #44546F)";
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eQ8jX.default), {
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bksYB.MentionItemStyle), {
                selected: selected,
                onMouseDown: this.onMentionSelected,
                onMouseMove: this.onMentionMenuItemMouseMove,
                onMouseEnter: this.onMentionMenuItemMouseEnter,
                "data-mention-item": true,
                "data-testid": `mention-item-${id}`,
                "data-mention-id": id,
                "data-mention-name": mentionName,
                "data-selected": selected,
                children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bksYB.RowStyle), {
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bksYB.AvatarStyle), {
                            restricted: restricted,
                            children: (0, $eGOwo.fg)('team-avatar-in-mention-picker') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6vxzE.MentionAvatar), {
                                selected: selected,
                                mention: mention
                            }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5DgXR.default), {
                                src: avatarUrl,
                                size: "medium",
                                presence: status,
                                borderColor: borderColor
                            })
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bksYB.NameSectionStyle), {
                            restricted: restricted,
                            children: [
                                (0, $fuTmQ.renderHighlight)((0, $bksYB.FullNameStyle), name, nameHighlights),
                                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1ESZE.default), {
                                    mention: mention
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $bksYB.InfoSectionStyle), {
                            restricted: restricted,
                            children: [
                                $8b1968dc7a50e402$var$renderLozenge(lozenge),
                                $8b1968dc7a50e402$var$renderTime(time)
                            ]
                        }),
                        restricted ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Suspense, {
                            fallback: null,
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $21z29.default), {
                                name: name,
                                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bksYB.AccessSectionStyle), {
                                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9pZhV.NoAccessLabel), {
                                        children: (text)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $ac0eK.default), {
                                                label: text
                                            })
                                    })
                                })
                            })
                        }) : null,
                        isXProductUser && /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7MiYh))), {
                            color: xProductUserInfoIconColor,
                            label: ''
                        })
                    ]
                })
            })
        });
    }
    constructor(...args){
        super(...args), // internal, used for callbacks
        this.onMentionSelected = (event)=>{
            if ((0, $gIOoz.leftClick)(event) && this.props.onSelection) {
                event.preventDefault();
                this.props.onSelection(this.props.mention, event);
            }
        }, this.onMentionMenuItemMouseMove = (event)=>{
            if (this.props.onMouseMove) this.props.onMouseMove(this.props.mention, event);
        }, this.onMentionMenuItemMouseEnter = (event)=>{
            if (this.props.onMouseEnter) this.props.onMouseEnter(this.props.mention, event);
        };
    }
}

});
parcelRegister("9pZhV", function(module, exports) {

$parcel$export(module.exports, "UnknownUserError", () => $2f0cb1eb1c5f7ba5$export$98e06fe7a6174253);
$parcel$export(module.exports, "NoAccessWarning", () => $2f0cb1eb1c5f7ba5$export$58bd5a2057b6b855);
$parcel$export(module.exports, "NoAccessLabel", () => $2f0cb1eb1c5f7ba5$export$da9f8ce14593162f);
$parcel$export(module.exports, "getMessagesForLocale", () => $2f0cb1eb1c5f7ba5$export$d0a3169680473b6c);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");
var $lRq8t = parcelRequire("lRq8t");

var $a6i5A = parcelRequire("a6i5A");
const $2f0cb1eb1c5f7ba5$export$392a0c6a82ab0e50 = (messageDescriptor)=>({ values: values, children: children })=>{
        const { formatMessage: formatMessage } = (0, $lRq8t.default)();
        const message = formatMessage(messageDescriptor, values);
        if (typeof children === 'function') return children(message);
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
            values: values,
            ...messageDescriptor
        });
    };
const $2f0cb1eb1c5f7ba5$export$98e06fe7a6174253 = $2f0cb1eb1c5f7ba5$export$392a0c6a82ab0e50((0, $a6i5A.messages).unknownUserError);
const $2f0cb1eb1c5f7ba5$export$58bd5a2057b6b855 = $2f0cb1eb1c5f7ba5$export$392a0c6a82ab0e50((0, $a6i5A.messages).noAccessWarning);
const $2f0cb1eb1c5f7ba5$export$da9f8ce14593162f = $2f0cb1eb1c5f7ba5$export$392a0c6a82ab0e50((0, $a6i5A.messages).noAccessLabel);
const $2f0cb1eb1c5f7ba5$export$4a258ffee7316766 = $2f0cb1eb1c5f7ba5$export$392a0c6a82ab0e50((0, $a6i5A.messages).defaultHeadline);
const $2f0cb1eb1c5f7ba5$export$702321a50d74536e = $2f0cb1eb1c5f7ba5$export$392a0c6a82ab0e50((0, $a6i5A.messages).defaultAdvisedAction);
const $2f0cb1eb1c5f7ba5$export$ed7f16088a93ae9d = $2f0cb1eb1c5f7ba5$export$392a0c6a82ab0e50((0, $a6i5A.messages).loginAgain);
const $2f0cb1eb1c5f7ba5$export$3ab158df56460d1c = $2f0cb1eb1c5f7ba5$export$392a0c6a82ab0e50((0, $a6i5A.messages).differentText);































const $2f0cb1eb1c5f7ba5$export$d0a3169680473b6c = async (locale)=>{
    switch(locale){
        case 'cs':
            return (parcelRequire("4szku")).then((mod)=>mod.default);
        case 'da':
            return (parcelRequire("9XDd9")).then((mod)=>mod.default);
        case 'de':
            return (parcelRequire("gx10p")).then((mod)=>mod.default);
        case 'en':
            return (parcelRequire("kiqhP")).then((mod)=>mod.default);
        case 'en_GB':
            return (parcelRequire("9APxG")).then((mod)=>mod.default);
        case 'en_ZZ':
            return (parcelRequire("k5ES4")).then((mod)=>mod.default);
        case 'es':
            return (parcelRequire("1FVE8")).then((mod)=>mod.default);
        case 'et':
            return (parcelRequire("bIIAX")).then((mod)=>mod.default);
        case 'fi':
            return (parcelRequire("4gV7R")).then((mod)=>mod.default);
        case 'fr':
            return (parcelRequire("2HZe0")).then((mod)=>mod.default);
        case 'hu':
            return (parcelRequire("4bhkm")).then((mod)=>mod.default);
        case 'is':
            return (parcelRequire("9Pn8d")).then((mod)=>mod.default);
        case 'it':
            return (parcelRequire("4Kxe3")).then((mod)=>mod.default);
        case 'ja':
            return (parcelRequire("iC4yX")).then((mod)=>mod.default);
        case 'ko':
            return (parcelRequire("4jPuq")).then((mod)=>mod.default);
        case 'nb':
            return (parcelRequire("7PtEj")).then((mod)=>mod.default);
        case 'nl':
            return (parcelRequire("kRcpS")).then((mod)=>mod.default);
        case 'pl':
            return (parcelRequire("cWfxa")).then((mod)=>mod.default);
        case 'pt_BR':
        case 'pt-BR':
            return (parcelRequire("kAXic")).then((mod)=>mod.default);
        case 'pt_PT':
        case 'pt-PT':
            return (parcelRequire("6SNM9")).then((mod)=>mod.default);
        case 'ro':
            return (parcelRequire("g7WOD")).then((mod)=>mod.default);
        case 'ru':
            return (parcelRequire("ixd7L")).then((mod)=>mod.default);
        case 'sk':
            return (parcelRequire("js02x")).then((mod)=>mod.default);
        case 'sv':
            return (parcelRequire("o2tWm")).then((mod)=>mod.default);
        case 'th':
            return (parcelRequire("kLzEb")).then((mod)=>mod.default);
        case 'tr':
            return (parcelRequire("aWxcl")).then((mod)=>mod.default);
        case 'uk':
            return (parcelRequire("1nmV8")).then((mod)=>mod.default);
        case 'vi':
            return (parcelRequire("gb2xf")).then((mod)=>mod.default);
        case 'zh_TW':
            return (parcelRequire("7IMPm")).then((mod)=>mod.default);
        case 'zh':
            return (parcelRequire("3yZRX")).then((mod)=>mod.default);
        default:
            {
                const fragments = locale.split(/[_-]/);
                if (fragments.length === 2) return $2f0cb1eb1c5f7ba5$export$d0a3169680473b6c(fragments[0]);
                else return (parcelRequire("kiqhP")).then((mod)=>mod.default);
            }
    }
};

});
parcelRegister("a6i5A", function(module, exports) {

$parcel$export(module.exports, "messages", () => $fdd92d7113791d0a$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $fdd92d7113791d0a$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    unknownUserError: {
        id: 'fabric.mention.unknow.user.error',
        defaultMessage: 'Unknown user {userId}',
        description: 'Mention user name could not be found or look up failed'
    },
    noAccessWarning: {
        id: 'fabric.mention.noAccess.warning',
        defaultMessage: "{name} won't be notified as they have no access",
        description: "Warning message to show that the mentioned user won't be notified"
    },
    noAccessLabel: {
        id: 'fabric.mention.noAccess.label',
        defaultMessage: 'No access',
        description: 'Label for no access icon'
    },
    defaultHeadline: {
        id: 'fabric.mention.error.defaultHeadline',
        defaultMessage: 'Something went wrong',
        description: 'Error message shown when there is an error communicating with backend'
    },
    defaultAdvisedAction: {
        id: 'fabric.mention.error.defaultAction',
        defaultMessage: 'Try again in a few seconds',
        description: 'Default advised action when an error occurs'
    },
    loginAgain: {
        id: 'fabric.mention.error.loginAgain',
        defaultMessage: 'Try logging out then in again',
        description: 'Login again message when there is an authentication error occurs'
    },
    differentText: {
        id: 'fabric.mention.error.differentText',
        defaultMessage: 'Try entering different text',
        description: 'Enter different text message when a forbidden error occurs'
    },
    memberCountWithoutYou: {
        id: 'fabric.elements.mentions.team.member.count',
        defaultMessage: "Team \u2022 {0, plural, one {1 member} other {{0} members}}",
        description: 'Byline to show the number of members in the team when the current user is not a member of the team'
    },
    memberCountWithYou: {
        id: 'fabric.elements.mentions.team.member.count.including.you',
        defaultMessage: "Team \u2022 {0, plural, one {1 member} other {{0} members}}, including you",
        description: 'Byline to show the number of members in the team when the current user is also a member of the team'
    },
    plus50MembersWithoutYou: {
        id: 'fabric.elements.mentions.team.member.50plus',
        defaultMessage: "Team \u2022 50+ members",
        description: 'Byline to show the number of members in the team when the number exceeds 50'
    },
    plus50MembersWithYou: {
        id: 'fabric.elements.mentions.team.member.50plus.including.you',
        defaultMessage: "Team \u2022 50+ members, including you",
        description: 'Byline to show the number of members in the team when the number exceeds 50 and also includes the current user'
    },
    xProductMentionDescription: {
        id: 'fabric.elements.mentions.xproduct.mention.description',
        defaultMessage: 'Needs access to Confluence',
        description: 'Description for a x-product mention item in the mention list in Confluence'
    }
});

});

parcelRegister("4szku", function(module, exports) {

let $33f52ea63eb00ea2$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $33f52ea63eb00ea2$var$load("5EqMw").then(()=>parcelRequire('2EsuB'));

});

parcelRegister("9XDd9", function(module, exports) {

let $74080a3d69fd32f2$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $74080a3d69fd32f2$var$load("18eMn").then(()=>parcelRequire('jy2NA'));

});

parcelRegister("gx10p", function(module, exports) {

let $c090821939b5fe78$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $c090821939b5fe78$var$load("9yF73").then(()=>parcelRequire('cMOoZ'));

});

parcelRegister("kiqhP", function(module, exports) {

let $ec69e10ecbe9df07$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $ec69e10ecbe9df07$var$load("7n0BP").then(()=>parcelRequire('8iZ79'));

});

parcelRegister("9APxG", function(module, exports) {

let $6fbf75151ad7f75e$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $6fbf75151ad7f75e$var$load("hyqM1").then(()=>parcelRequire('35wYa'));

});

parcelRegister("k5ES4", function(module, exports) {

let $ea03fa7340a60b18$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $ea03fa7340a60b18$var$load("YxfNT").then(()=>parcelRequire('fuRMK'));

});

parcelRegister("1FVE8", function(module, exports) {

let $1386562285117e84$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $1386562285117e84$var$load("9eAO5").then(()=>parcelRequire('3eJc8'));

});

parcelRegister("bIIAX", function(module, exports) {

let $88866573880029f7$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $88866573880029f7$var$load("32vaB").then(()=>parcelRequire('il84e'));

});

parcelRegister("4gV7R", function(module, exports) {

let $31c4f80400c27ac9$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $31c4f80400c27ac9$var$load("leYa9").then(()=>parcelRequire('5ymPj'));

});

parcelRegister("2HZe0", function(module, exports) {

let $1f8f16eb06b4aeee$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $1f8f16eb06b4aeee$var$load("hzekf").then(()=>parcelRequire('4fX4g'));

});

parcelRegister("4bhkm", function(module, exports) {

let $30b5a1583ad26914$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $30b5a1583ad26914$var$load("3hppq").then(()=>parcelRequire('4Wl86'));

});

parcelRegister("9Pn8d", function(module, exports) {

let $727ad1edcb0c7b02$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $727ad1edcb0c7b02$var$load("71qoR").then(()=>parcelRequire('2HdNw'));

});

parcelRegister("4Kxe3", function(module, exports) {

let $37553b3d9a1870d2$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $37553b3d9a1870d2$var$load("kZ9Jj").then(()=>parcelRequire('cvwB6'));

});

parcelRegister("iC4yX", function(module, exports) {

let $d8cf50ad44d9b333$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $d8cf50ad44d9b333$var$load("01BCB").then(()=>parcelRequire('5aO99'));

});

parcelRegister("4jPuq", function(module, exports) {

let $3250e095fb630129$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $3250e095fb630129$var$load("9n2u9").then(()=>parcelRequire('4vSeO'));

});

parcelRegister("7PtEj", function(module, exports) {

let $5b344b83cdcbdcc4$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $5b344b83cdcbdcc4$var$load("aVj0b").then(()=>parcelRequire('42yuB'));

});

parcelRegister("kRcpS", function(module, exports) {

let $f2f263843d4b9006$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $f2f263843d4b9006$var$load("4OI9P").then(()=>parcelRequire('8uMOi'));

});

parcelRegister("cWfxa", function(module, exports) {

let $96b6f38b6f93ad0a$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $96b6f38b6f93ad0a$var$load("9J4QP").then(()=>parcelRequire('9VAR9'));

});

parcelRegister("kAXic", function(module, exports) {

let $efe529aef976fd1b$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $efe529aef976fd1b$var$load("lF2XI").then(()=>parcelRequire('12Lpf'));

});

parcelRegister("6SNM9", function(module, exports) {

let $502e659c51433f7f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $502e659c51433f7f$var$load("1HsGI").then(()=>parcelRequire('jedO8'));

});

parcelRegister("g7WOD", function(module, exports) {

let $bbdaec5f1e41c332$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $bbdaec5f1e41c332$var$load("lXnsR").then(()=>parcelRequire('fr01P'));

});

parcelRegister("ixd7L", function(module, exports) {

let $d7e57d44b60ad313$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $d7e57d44b60ad313$var$load("8qZjs").then(()=>parcelRequire('471XU'));

});

parcelRegister("js02x", function(module, exports) {

let $e290a9c43457bbfa$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $e290a9c43457bbfa$var$load("e9lyC").then(()=>parcelRequire('alq7p'));

});

parcelRegister("o2tWm", function(module, exports) {

let $04842adc54830709$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $04842adc54830709$var$load("31jpa").then(()=>parcelRequire('gLqyT'));

});

parcelRegister("kLzEb", function(module, exports) {

let $f1e3d93145a1904d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $f1e3d93145a1904d$var$load("3phC6").then(()=>parcelRequire('cxEzV'));

});

parcelRegister("aWxcl", function(module, exports) {

let $7f79129e486d4127$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $7f79129e486d4127$var$load("gQN5G").then(()=>parcelRequire('i4k66'));

});

parcelRegister("1nmV8", function(module, exports) {

let $1009b7f5e99c4d0f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $1009b7f5e99c4d0f$var$load("eYOjB").then(()=>parcelRequire('6zdul'));

});

parcelRegister("gb2xf", function(module, exports) {

let $bc6fa3e5809d48f7$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $bc6fa3e5809d48f7$var$load("jaR1c").then(()=>parcelRequire('llxNs'));

});

parcelRegister("7IMPm", function(module, exports) {

let $59f2849821bd0f61$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $59f2849821bd0f61$var$load("a5Ksd").then(()=>parcelRequire('fc11e'));

});

parcelRegister("3yZRX", function(module, exports) {

let $29848a0500f15cfc$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $29848a0500f15cfc$var$load("jUx2Z").then(()=>parcelRequire('4raZH'));

});


parcelRegister("gIOoz", function(module, exports) {

$parcel$export(module.exports, "leftClick", () => $eb25f12cf119707c$export$34ebdaf2c517ae75);
function $eb25f12cf119707c$export$fd3cd03f8ac42187(event) {
    return {
        x: event.clientX,
        y: event.clientY
    };
}
function $eb25f12cf119707c$export$de744e30016241b0(oldPosition, newPosition) {
    if (!oldPosition || oldPosition.x !== newPosition.x || oldPosition.y !== newPosition.y) return true;
    return false;
}
function $eb25f12cf119707c$export$34ebdaf2c517ae75(event) {
    return event.button === 0 && !event.altKey && !event.ctrlKey && !event.metaKey && !event.shiftKey;
}

});

parcelRegister("21z29", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a684ea7707ceeb8$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

const $8a684ea7707ceeb8$var$AsyncNoAccessTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).lazy(()=>(parcelRequire("1a81O")).then((module)=>{
        return {
            default: module.NoAccessTooltip
        };
    }));
var $8a684ea7707ceeb8$export$2e2bcd8739ae039 = $8a684ea7707ceeb8$var$AsyncNoAccessTooltip;

});
parcelRegister("1a81O", function(module, exports) {

let $0d8cf3e1bb9884e2$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $0d8cf3e1bb9884e2$var$load("kCPaP").then(()=>parcelRequire('4aHpv'));

});


parcelRegister("ac0eK", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc301f7c0508525d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

const $fc301f7c0508525d$var$AsyncLockCircleIcon = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("dOzYA")).then((module)=>({
            default: module.default
        })));
var $fc301f7c0508525d$export$2e2bcd8739ae039 = $fc301f7c0508525d$var$AsyncLockCircleIcon;

});
parcelRegister("dOzYA", function(module, exports) {

let $a0ebda01449eae3f$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $a0ebda01449eae3f$var$load("cVUuJ").then(()=>parcelRequire('6fCl5'));

});


parcelRegister("fuTmQ", function(module, exports) {

$parcel$export(module.exports, "renderHighlight", () => $de8238d276a0423c$export$2bcf43b01d5314f5);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");
function $de8238d276a0423c$export$2bcf43b01d5314f5(ReactComponent, value, highlights, prefix) {
    if (!value) return null;
    const parts = [];
    const prefixText = prefix || '';
    let lastIndex = 0;
    if (highlights) {
        for(let i = 0; i < highlights.length; i++){
            const h = highlights[i];
            const start = h.start;
            const end = h.end;
            if (start > lastIndex) parts.push({
                value: value.substring(lastIndex, start),
                matches: false
            });
            parts.push({
                value: value.substring(start, end + 1),
                matches: true
            });
            lastIndex = end + 1;
        }
        if (lastIndex < value.length) parts.push({
            value: value.substring(lastIndex, value.length),
            matches: false
        });
    } else parts.push({
        value: value,
        matches: false
    });
    return /*#__PURE__*/ (0, $gt9Am.jsxs)(ReactComponent, {
        children: [
            prefixText,
            parts.map((part, index)=>{
                if (part.matches) return /*#__PURE__*/ (0, $gt9Am.jsx)("b", {
                    children: part.value
                }, index);
                return part.value;
            })
        ]
    });
}

});

parcelRegister("1ESZE", function(module, exports) {

$parcel$export(module.exports, "default", () => $c67c28ad1bc64931$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $49R7i = parcelRequire("49R7i");

var $jLTAi = parcelRequire("jLTAi");

var $fV4c7 = parcelRequire("fV4c7");

var $fwHuS = parcelRequire("fwHuS");

var $a6i5A = parcelRequire("a6i5A");
class $c67c28ad1bc64931$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).PureComponent {
    render() {
        const { userType: userType, isXProductUser: isXProductUser } = this.props.mention;
        if (isXProductUser) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fwHuS.DescriptionBylineStyle), {
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                ...(0, $a6i5A.messages).xProductMentionDescription
            })
        });
        switch(userType){
            case (0, $49R7i.UserType)[(0, $49R7i.UserType).TEAM]:
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fV4c7.default), {
                    mention: this.props.mention
                });
            default:
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jLTAi.default), {
                    mention: this.props.mention
                });
        }
    }
}

});
parcelRegister("jLTAi", function(module, exports) {

$parcel$export(module.exports, "default", () => $5dff065bc18caee1$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $fuTmQ = parcelRequire("fuTmQ");

var $fwHuS = parcelRequire("fwHuS");
class $5dff065bc18caee1$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).PureComponent {
    render() {
        const { highlight: highlight, name: name, nickname: nickname } = this.props.mention;
        const nicknameHighlights = highlight && highlight.nickname;
        if (name === nickname) return null;
        return (0, $fuTmQ.renderHighlight)((0, $fwHuS.DescriptionBylineStyle), nickname, nicknameHighlights, '@');
    }
}

});
parcelRegister("fwHuS", function(module, exports) {

$parcel$export(module.exports, "DescriptionBylineStyle", () => $2580ceaa8c816c94$export$607100a5f9cc9977);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766


var $aWILV = parcelRequire("aWILV");
const $2580ceaa8c816c94$export$607100a5f9cc9977 = /*#__PURE__*/ (0, $aWILV.default)("span", {
    target: "e1bkpfff0"
})({
    color: `var(--ds-text-subtlest, ${(0, $7bb4c1736002a04a$export$d6447c357493214f)})`,
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    marginTop: "var(--ds-space-025, 2px)",
    display: 'block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});

});


parcelRegister("fV4c7", function(module, exports) {

$parcel$export(module.exports, "default", () => $130a8f8ad9e92449$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");

var $fwHuS = parcelRequire("fwHuS");

var $a6i5A = parcelRequire("a6i5A");
class $130a8f8ad9e92449$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).PureComponent {
    render() {
        const { context: context } = this.props.mention;
        if (!context) return null;
        const includesYou = context.includesYou;
        const memberCount = context.memberCount;
        return this.renderByline(memberCount, includesYou);
    }
    constructor(...args){
        super(...args), this.renderByline = (memberCount, includesYou)=>{
            if (includesYou) {
                if (memberCount > 50) return this.getBylineComponent(/*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...(0, $a6i5A.messages).plus50MembersWithYou
                }));
                return this.getBylineComponent(/*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...(0, $a6i5A.messages).memberCountWithYou,
                    values: {
                        0: memberCount
                    }
                }));
            } else {
                if (memberCount > 50) return this.getBylineComponent(/*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...(0, $a6i5A.messages).plus50MembersWithoutYou
                }));
                return this.getBylineComponent(/*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                    ...(0, $a6i5A.messages).memberCountWithoutYou,
                    values: {
                        0: memberCount
                    }
                }));
            }
        }, this.getBylineComponent = (message)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fwHuS.DescriptionBylineStyle), {
                children: message
            });
    }
}

});


parcelRegister("eQ8jX", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2080416dc299e9c$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $4nehu = parcelRequire("4nehu");
var $lRq8t = parcelRequire("lRq8t");

var $9pZhV = parcelRequire("9pZhV");
const $b2080416dc299e9c$var$EMPTY = {};
const $b2080416dc299e9c$var$useI18n = (locale)=>{
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState($b2080416dc299e9c$var$EMPTY);
    (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useEffect(()=>{
        let aborted = false;
        setMessages($b2080416dc299e9c$var$EMPTY);
        (0, $9pZhV.getMessagesForLocale)(locale).then((messages)=>{
            if (!aborted) setMessages(messages);
        }).catch((error)=>{
            // eslint-disable-next-line no-console
            console.error(error);
        });
        return ()=>{
            aborted = true;
        };
    }, [
        locale
    ]);
    return messages;
};
const $b2080416dc299e9c$var$MessagesIntlProvider = (props)=>{
    const { children: children } = props;
    const intl = (0, $lRq8t.default)();
    const messages = $b2080416dc299e9c$var$useI18n(intl.locale);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4nehu.default), {
        ...intl,
        messages: messages,
        children: children
    });
};
var $b2080416dc299e9c$export$2e2bcd8739ae039 = $b2080416dc299e9c$var$MessagesIntlProvider;

});

parcelRegister("6vxzE", function(module, exports) {

$parcel$export(module.exports, "MentionAvatar", () => $95852078b8a8a7c3$export$35f495c0dc0a1015);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $5DgXR = parcelRequire("5DgXR");

var $6qS8z = parcelRequire("6qS8z");

var $49R7i = parcelRequire("49R7i");
const $95852078b8a8a7c3$export$35f495c0dc0a1015 = ({ mention: mention, selected: selected })=>{
    const { avatarUrl: avatarUrl, presence: presence } = mention;
    const borderColor = selected ? "var(--ds-border, #091E4224)" : undefined;
    const { status: status } = presence || {};
    if ((0, $49R7i.isTeamMention)(mention)) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6qS8z.default), {
        src: avatarUrl,
        size: "medium",
        borderColor: borderColor
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5DgXR.default), {
        src: avatarUrl,
        size: "medium",
        presence: status,
        borderColor: borderColor
    });
};

});


parcelRegister("aN0Mz", function(module, exports) {

$parcel$export(module.exports, "INVITE_ITEM_DESCRIPTION", () => $abcbc32d99f59217$export$75621ed4176efc9e);
$parcel$export(module.exports, "default", () => $abcbc32d99f59217$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $kDaaB = parcelRequire("kDaaB");
var $6YFG2 = parcelRequire("6YFG2");

var $h6V7a = parcelRequire("h6V7a");

var $jQjGM = parcelRequire("jQjGM");

const $abcbc32d99f59217$var$mentionItemStyle = null;
const $abcbc32d99f59217$var$mentionItemSelectedStyle = null;
const $abcbc32d99f59217$var$rowStyle = null;
const $abcbc32d99f59217$var$avatarStyle = null;
const $abcbc32d99f59217$var$nameSectionStyle = null;
const $abcbc32d99f59217$var$capitalizedStyle = null;
const $abcbc32d99f59217$export$75621ed4176efc9e = {
    id: 'invite-teammate'
};
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $abcbc32d99f59217$var$leftClick = (event)=>{
    return event.button === 0 && !event.altKey && !event.ctrlKey && !event.metaKey && !event.shiftKey;
};
const $abcbc32d99f59217$var$InviteItem = ({ productName: productName, onMount: onMount, onMouseEnter: onMouseEnter, onSelection: onSelection, selected: selected, userRole: userRole, intl: intl })=>{
    const onSelected = (0, $eJOHy.useCallback)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (event)=>{
        if ($abcbc32d99f59217$var$leftClick(event) && onSelection) {
            event.preventDefault();
            onSelection($abcbc32d99f59217$export$75621ed4176efc9e, event);
        }
    }, [
        onSelection
    ]);
    const onItemMouseEnter = (0, $eJOHy.useCallback)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (event)=>{
        if (onMouseEnter) onMouseEnter($abcbc32d99f59217$export$75621ed4176efc9e, event);
    }, [
        onMouseEnter
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (onMount) onMount();
    }, [
        onMount
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        onMouseDown: onSelected,
        onMouseEnter: onItemMouseEnter,
        "data-id": $abcbc32d99f59217$export$75621ed4176efc9e.id,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _bfhk18uv _1e0c1ule _2mzuglyw _80omtlke",
            selected && "_bfhk14ae"
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
            className: (0, $hcewu.default)([
                "_1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _2lx2vrvc _1n261g80 _ca0q12x7 _n3td12x7 _19bvdlk8 _u5f3dlk8 _1bto1l2s _s7n4nkob"
            ]),
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                    className: (0, $hcewu.default)([
                        "_16jlidpf _1o9zkb7n _i0dl1wug _1e0c1txw _4cvr1h6o _1bah1h6o _kqswh2mm _1bsb14no _4t3i14no"
                    ]),
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jQjGM))), {
                        label: intl.formatMessage((0, $h6V7a.mentionMessages).mentionsAddLabel),
                        color: `var(--ds-icon-subtle, ${(0, $7bb4c1736002a04a$export$e2ef2124cf4024b1)})`
                    })
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    "data-testid": "name-section",
                    className: (0, $hcewu.default)([
                        "_16jlkb7n _1o9zkb7n _i0dlf1ug _1ul9idpf _18u0dlk8 _syaz1n3s"
                    ]),
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kDaaB.default), {
                        ...(0, $h6V7a.mentionMessages).inviteItemTitle,
                        values: {
                            userRole: userRole || 'basic',
                            productName: /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                                "data-testid": "capitalized-message",
                                className: (0, $hcewu.default)([
                                    "_1p1d1dk0"
                                ]),
                                children: productName
                            })
                        }
                    })
                })
            ]
        })
    });
};
var $abcbc32d99f59217$export$2e2bcd8739ae039 = (0, $6YFG2.default)($abcbc32d99f59217$var$InviteItem);

});

parcelRegister("19b2u", function(module, exports) {

$parcel$export(module.exports, "buildTypeAheadCancelPayload", () => $8b8d1a4fa2140b27$export$e1d5d51810b7e165);
$parcel$export(module.exports, "buildTypeAheadInviteItemViewedPayload", () => $8b8d1a4fa2140b27$export$c102b710f5c857c4);
$parcel$export(module.exports, "buildTypeAheadInviteItemClickedPayload", () => $8b8d1a4fa2140b27$export$e4c4d872dcfe2b15);
$parcel$export(module.exports, "buildTypeAheadInsertedPayload", () => $8b8d1a4fa2140b27$export$84030a552533cdf8);
$parcel$export(module.exports, "buildTypeAheadRenderedPayload", () => $8b8d1a4fa2140b27$export$901fb6651fc13b0e);

var $bMFKb = parcelRequire("bMFKb");

var $49R7i = parcelRequire("49R7i");

var $ba0Gj = parcelRequire("ba0Gj");
const $8b8d1a4fa2140b27$var$componentName = 'mention';
const $8b8d1a4fa2140b27$var$emptyQueryResponse = {
    queryLength: 0,
    spaceInQuery: false
};
const $8b8d1a4fa2140b27$var$extractAttributesFromQuery = (query)=>{
    if (query) return {
        queryLength: query.length,
        spaceInQuery: query.indexOf(' ') !== -1
    };
    return $8b8d1a4fa2140b27$var$emptyQueryResponse;
};
const $8b8d1a4fa2140b27$export$e1d5d51810b7e165 = (duration, upKeyCount, downKeyCount, sessionId, query)=>{
    const { queryLength: queryLength, spaceInQuery: spaceInQuery } = $8b8d1a4fa2140b27$var$extractAttributesFromQuery(query);
    return {
        action: (0, $bMFKb.ACTION).CANCELLED,
        actionSubject: (0, $bMFKb.ACTION_SUBJECT).MENTION_TYPEAHEAD,
        eventType: (0, $bMFKb.EVENT_TYPE).UI,
        attributes: {
            componentName: $8b8d1a4fa2140b27$var$componentName,
            duration: duration,
            queryLength: queryLength,
            spaceInQuery: spaceInQuery,
            upKeyCount: upKeyCount,
            downKeyCount: downKeyCount,
            sessionId: sessionId
        }
    };
};
const $8b8d1a4fa2140b27$var$getPosition = (mentionList, selectedMention)=>{
    if (mentionList) {
        const index = mentionList.findIndex((mention)=>mention.id === selectedMention.id);
        return index === -1 ? undefined : index;
    }
    return;
};
const $8b8d1a4fa2140b27$var$isClicked = (insertType)=>insertType === 'selected';
const $8b8d1a4fa2140b27$export$c102b710f5c857c4 = (sessionId, contextIdentifierProvider, userRole)=>{
    const { containerId: containerId, objectId: objectId, childObjectId: childObjectId } = contextIdentifierProvider || {};
    return {
        action: (0, $bMFKb.ACTION).RENDERED,
        actionSubject: (0, $bMFKb.ACTION_SUBJECT).INVITE_ITEM,
        eventType: (0, $bMFKb.EVENT_TYPE).UI,
        attributes: {
            componentName: $8b8d1a4fa2140b27$var$componentName,
            containerId: containerId,
            objectId: objectId,
            childObjectId: childObjectId,
            userRole: userRole,
            sessionId: sessionId
        }
    };
};
const $8b8d1a4fa2140b27$export$e4c4d872dcfe2b15 = (duration, upKeyCount, downKeyCount, sessionId, insertType, query, contextIdentifierProvider, userRole)=>{
    const { queryLength: queryLength, spaceInQuery: spaceInQuery } = $8b8d1a4fa2140b27$var$extractAttributesFromQuery(query);
    const { containerId: containerId, objectId: objectId, childObjectId: childObjectId } = contextIdentifierProvider || {};
    return {
        action: $8b8d1a4fa2140b27$var$isClicked(insertType) ? (0, $bMFKb.ACTION).CLICKED : (0, $bMFKb.ACTION).PRESSED,
        actionSubject: (0, $bMFKb.ACTION_SUBJECT).INVITE_ITEM,
        eventType: (0, $bMFKb.EVENT_TYPE).UI,
        attributes: {
            componentName: $8b8d1a4fa2140b27$var$componentName,
            duration: duration,
            queryLength: queryLength,
            spaceInQuery: spaceInQuery,
            upKeyCount: upKeyCount,
            downKeyCount: downKeyCount,
            containerId: containerId,
            objectId: objectId,
            childObjectId: childObjectId,
            userRole: userRole,
            sessionId: sessionId,
            keyboardKey: $8b8d1a4fa2140b27$var$isClicked(insertType) ? undefined : insertType
        }
    };
};
const $8b8d1a4fa2140b27$export$84030a552533cdf8 = (duration, upKeyCount, downKeyCount, sessionId, insertType, mention, mentionLocalId, mentionList, query, contextIdentifierProvider, taskListId, taskItemId)=>{
    const { queryLength: queryLength, spaceInQuery: spaceInQuery } = $8b8d1a4fa2140b27$var$extractAttributesFromQuery(query);
    let containerId;
    let objectId;
    let childObjectId;
    if (contextIdentifierProvider) {
        containerId = contextIdentifierProvider.containerId || undefined;
        objectId = contextIdentifierProvider.objectId || undefined;
        childObjectId = contextIdentifierProvider.childObjectId || undefined;
    }
    return {
        action: $8b8d1a4fa2140b27$var$isClicked(insertType) ? (0, $bMFKb.ACTION).CLICKED : (0, $bMFKb.ACTION).PRESSED,
        actionSubject: (0, $bMFKb.ACTION_SUBJECT).MENTION_TYPEAHEAD,
        eventType: (0, $bMFKb.EVENT_TYPE).UI,
        containerId: containerId,
        objectId: objectId,
        childObjectId: childObjectId,
        attributes: {
            sessionId: sessionId,
            duration: duration,
            position: $8b8d1a4fa2140b27$var$getPosition(mentionList, mention),
            keyboardKey: $8b8d1a4fa2140b27$var$isClicked(insertType) ? undefined : insertType,
            source: mention.source,
            queryLength: queryLength,
            spaceInQuery: spaceInQuery,
            isSpecial: (0, $49R7i.isSpecialMention)(mention),
            accessLevel: mention.accessLevel || '',
            userType: mention.userType,
            userId: mention.id,
            upKeyCount: upKeyCount,
            downKeyCount: downKeyCount,
            memberCount: (0, $ba0Gj.isTeamType)(mention.userType) && mention.context ? mention.context.memberCount : null,
            includesYou: (0, $ba0Gj.isTeamType)(mention.userType) && mention.context ? mention.context.includesYou : null,
            taskListId: taskListId,
            taskItemId: taskItemId,
            localId: mentionLocalId,
            containerId: containerId,
            objectId: objectId,
            childObjectId: childObjectId
        }
    };
};
const $8b8d1a4fa2140b27$export$901fb6651fc13b0e = (duration, userIds, query, teams, xProductMentionsLength)=>{
    const { queryLength: queryLength, spaceInQuery: spaceInQuery } = $8b8d1a4fa2140b27$var$extractAttributesFromQuery(query);
    const actionSubject = userIds ? (0, $bMFKb.ACTION_SUBJECT).MENTION_TYPEAHEAD : (0, $bMFKb.ACTION_SUBJECT).TEAM_MENTION_TYPEAHEAD;
    return {
        action: (0, $bMFKb.ACTION).RENDERED,
        actionSubject: actionSubject,
        eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL,
        attributes: {
            componentName: $8b8d1a4fa2140b27$var$componentName,
            duration: duration,
            userIds: userIds,
            teams: teams,
            queryLength: queryLength,
            spaceInQuery: spaceInQuery,
            xProductMentionsLength: xProductMentionsLength
        }
    };
};

});
parcelRegister("ba0Gj", function(module, exports) {

$parcel$export(module.exports, "isTeamType", () => $25a70ec8689a66f9$export$6ddb6ef001273170);
$parcel$export(module.exports, "isTeamStats", () => $25a70ec8689a66f9$export$c427182c53a1ba5);
$parcel$export(module.exports, "isInviteItem", () => $25a70ec8689a66f9$export$f5a334b5a28d1e01);
$parcel$export(module.exports, "shouldKeepInviteItem", () => $25a70ec8689a66f9$export$16a134d4e1b461dc);

var $aN0Mz = parcelRequire("aN0Mz");
const $25a70ec8689a66f9$export$6ddb6ef001273170 = (userType)=>userType === 'TEAM';
const $25a70ec8689a66f9$export$c427182c53a1ba5 = (stat)=>stat && !isNaN(stat.teamMentionDuration);
const $25a70ec8689a66f9$export$f5a334b5a28d1e01 = (mention)=>mention && mention.id === (0, $aN0Mz.INVITE_ITEM_DESCRIPTION).id;
const $25a70ec8689a66f9$export$16a134d4e1b461dc = (query, firstQueryWithoutResults)=>{
    if (!firstQueryWithoutResults) return true;
    const lastIndexWithResults = firstQueryWithoutResults.length - 1;
    let suffix = query.slice(lastIndexWithResults);
    if (query[lastIndexWithResults - 1] === ' ') suffix = ' ' + suffix;
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const depletedExtraWords = /\s[^\s]+\s/.test(suffix);
    return !depletedExtraWords;
};

});





parcelRegister("85rQi", function(module, exports) {

$parcel$export(module.exports, "pastePlugin", () => (parcelRequire("8EyJv")).pastePlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $8EyJv = parcelRequire("8EyJv");

});
parcelRegister("8EyJv", function(module, exports) {

$parcel$export(module.exports, "pastePlugin", () => $778928956fab3494$export$2d7f4bd9c1268cd7);

var $0YStE = parcelRequire("0YStE");

var $bZVQL = parcelRequire("bZVQL");

var $3Elhj = parcelRequire("3Elhj");
const $778928956fab3494$export$2d7f4bd9c1268cd7 = ({ config: config, api: api })=>{
    const { cardOptions: cardOptions, sanitizePrivateContent: sanitizePrivateContent, isFullPage: isFullPage } = config ?? {};
    const featureFlags = api?.featureFlags?.sharedState.currentState() || {};
    const editorAnalyticsAPI = api?.analytics?.actions;
    return {
        name: 'paste',
        pmPlugins () {
            return [
                {
                    name: 'paste',
                    plugin: ({ schema: schema, providerFactory: providerFactory, dispatchAnalyticsEvent: dispatchAnalyticsEvent, dispatch: dispatch })=>(0, $0YStE.createPlugin)(schema, dispatchAnalyticsEvent, dispatch, featureFlags, api, cardOptions, sanitizePrivateContent, providerFactory)
                },
                {
                    name: 'moveAnalyticsPlugin',
                    plugin: ({ dispatch: dispatch })=>{
                        return isFullPage ? (0, $bZVQL.createPlugin)(dispatch, editorAnalyticsAPI) : undefined;
                    }
                }
            ];
        },
        getSharedState: (editorState)=>{
            if (!editorState) return {
                lastContentPasted: null
            };
            const pluginState = (0, $3Elhj.pluginKey).getState(editorState);
            return {
                lastContentPasted: pluginState.lastContentPasted
            };
        }
    };
};

});
parcelRegister("0YStE", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $a6f16289cbc0bfec$export$ae829ec7b2625219);

var $aXKmr = parcelRequire("aXKmr");

var $bMFKb = parcelRequire("bMFKb");
var $j0X5g = parcelRequire("j0X5g");

var $6C2m6 = parcelRequire("6C2m6");

var $eQTBG = parcelRequire("eQTBG");

var $g3VjK = parcelRequire("g3VjK");

var $ayT4n = parcelRequire("ayT4n");
var $8WSr8 = parcelRequire("8WSr8");

var $65rqJ = parcelRequire("65rqJ");

var $i8KtF = parcelRequire("i8KtF");

var $iZ2Kf = parcelRequire("iZ2Kf");
var $k2X9Z = parcelRequire("k2X9Z");
var $1Snbj = parcelRequire("1Snbj");
var $4Gpco = parcelRequire("4Gpco");
var $j6af7 = parcelRequire("j6af7");

var $7TRmB = parcelRequire("7TRmB");
var $5Z3Rm = parcelRequire("5Z3Rm");
var $grDTV = parcelRequire("grDTV");
var $gbisc = parcelRequire("gbisc");

var $4jPLX = parcelRequire("4jPLX");

var $3xw6l = parcelRequire("3xw6l");

var $BmspC = parcelRequire("BmspC");

var $5yEGu = parcelRequire("5yEGu");

var $eGOwo = parcelRequire("eGOwo");

var $92xoS = parcelRequire("92xoS");

var $6UQpI = parcelRequire("6UQpI");

var $1CqHB = parcelRequire("1CqHB");

var $5pNJd = parcelRequire("5pNJd");

var $3kq4u = parcelRequire("3kq4u");

var $18m7e = parcelRequire("18m7e");

var $3Elhj = parcelRequire("3Elhj");

var $bFyUX = parcelRequire("bFyUX");

var $di4lu = parcelRequire("di4lu");

var $1nSqW = parcelRequire("1nSqW");

var $2kOjB = parcelRequire("2kOjB");
const $a6f16289cbc0bfec$export$eedfdbc6a6bc1442 = (state)=>{
    const { blockquote: blockquote } = state.schema.nodes;
    return (0, $BmspC.hasParentNodeOfType)(blockquote)(state.selection);
};
const $a6f16289cbc0bfec$var$PASTE = 'Editor Paste Plugin Paste Duration';
function $a6f16289cbc0bfec$export$ae829ec7b2625219(schema, dispatchAnalyticsEvent, dispatch, featureFlags, pluginInjectionApi, cardOptions, sanitizePrivateContent, providerFactory) {
    const editorAnalyticsAPI = pluginInjectionApi?.analytics?.actions;
    const atlassianMarkDownParser = new (0, $4jPLX.MarkdownTransformer)(schema, (0, $8WSr8.md));
    function getMarkdownSlice(text, openStart, openEnd) {
        const textInput = escapeBackslashExceptCodeblock(text);
        const doc = atlassianMarkDownParser.parse((0, $bFyUX.escapeLinks)(textInput));
        if (doc && doc.content) return new (0, $3xw6l.Slice)(doc.content, openStart, openEnd);
        return;
    }
    function escapeBackslashExceptCodeblock(textInput) {
        const codeToken = '```';
        if (!textInput.includes(codeToken)) // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        return textInput.replace(/\\/g, '\\\\');
        let isInsideCodeblock = false;
        let textSplitByNewLine = textInput.split('\n');
        // In the splitted array, we traverse through every line and check if it will be parsed as a codeblock.
        textSplitByNewLine = textSplitByNewLine.map((text)=>{
            if (text === codeToken) isInsideCodeblock = !isInsideCodeblock;
            else if (text.startsWith(codeToken) && isInsideCodeblock === false) // if there is some text after the ``` mark , it gets counted as language attribute only at the start of codeblock
            isInsideCodeblock = true;
            if (!isInsideCodeblock) // only escape text which is not inside a codeblock
            // Ignored via go/ees005
            // eslint-disable-next-line require-unicode-regexp
            text = text.replace(/\\/g, '\\\\');
            return text;
        });
        textInput = textSplitByNewLine.join('\n');
        return textInput;
    }
    let extensionAutoConverter;
    async function setExtensionAutoConverter(name, extensionProviderPromise) {
        if (name !== 'extensionProvider' || !extensionProviderPromise) return;
        try {
            extensionAutoConverter = await (0, $g3VjK.getExtensionAutoConvertersFromProvider)(extensionProviderPromise);
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
    }
    if (providerFactory) providerFactory.subscribe('extensionProvider', setExtensionAutoConverter);
    let mostRecentPasteEvent;
    let pastedFromBitBucket = false;
    return new (0, $i8KtF.SafePlugin)({
        key: (0, $3Elhj.pluginKey),
        state: (0, $3Elhj.createPluginState)(dispatch, {
            pastedMacroPositions: {},
            lastContentPasted: null
        }),
        props: {
            clipboardTextSerializer: // For serialising to plain text
            $18m7e.clipboardTextSerializer,
            handleDOMEvents: {
                paste: (view, event)=>{
                    mostRecentPasteEvent = event;
                    return false;
                }
            },
            handlePaste (view, rawEvent, slice) {
                const event = rawEvent;
                if (!event.clipboardData) return false;
                let text = event.clipboardData.getData('text/plain');
                const html = event.clipboardData.getData('text/html');
                const uriList = event.clipboardData.getData('text/uri-list');
                // Links copied from iOS Safari share button only have the text/uri-list data type
                // ProseMirror don't do anything with this type so we want to make our own open slice
                // with url as text content so link is pasted inline
                if (uriList && !text && !html) {
                    text = uriList;
                    slice = new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).from(schema.text(text)), 1, 1);
                }
                if (text?.includes('\r')) // Ignored via go/ees005
                // eslint-disable-next-line require-unicode-regexp
                text = text.replace(/\r/g, '');
                // Strip Legacy Content Macro (LCM) extensions on paste
                if (!(0, $eGOwo.fg)('platform_editor_legacy_content_macro_insert')) slice = (0, $j6af7.transformSliceToRemoveLegacyContentMacro)(slice, schema);
                const isPastedFile = (0, $ayT4n.isPastedFile)(event);
                const isPlainText = text && !html;
                const isRichText = !!html;
                // Bail if copied content has files
                if (isPastedFile) {
                    if (!html) /**
						 * Microsoft Office, Number, Pages, etc. adds an image to clipboard
						 * with other mime-types so we don't let the event reach media.
						 * The detection ration here is that if the payload has both `html` and
						 * `files`, then it could be one of above or an image copied from web.
						 * Here, we don't have html, so we return true to allow default event behaviour
						 */ return true;
                    /**
					 * We want to return false for external copied image to allow
					 * it to be uploaded by the client.
					 *
					 * Scenario where we are pasting an external image inside a block quote
					 * is skipped and handled in handleRichText
					 */ if ((0, $bFyUX.htmlContainsSingleFile)(html) && !$a6f16289cbc0bfec$export$eedfdbc6a6bc1442(view.state)) return true;
                    /**
					 * https://product-fabric.atlassian.net/browse/ED-21993
					 * stopImmediatePropagation will run the first event attached to the same element
					 * Which chould have race condition issue
					 */ event.stopPropagation();
                }
                const { state: state } = view;
                const content = (0, $3kq4u.getContentNodeTypes)(slice.content);
                const pasteId = (0, (/*@__PURE__*/$parcel$interopDefault($aXKmr)))();
                const measureName = `${$a6f16289cbc0bfec$var$PASTE}_${pasteId}`;
                (0, $65rqJ.measureRender)(measureName, ({ duration: duration, distortedDuration: distortedDuration })=>{
                    const payload = (0, $3kq4u.createPasteMeasurePayload)({
                        view: view,
                        duration: duration,
                        content: content,
                        distortedDuration: distortedDuration
                    });
                    if (payload) dispatchAnalyticsEvent(payload);
                });
                // creating a custom dispatch because we want to add a meta whenever we do a paste.
                const dispatch = (tr)=>{
                    // https://product-fabric.atlassian.net/browse/ED-12633
                    // don't add closeHistory call if we're pasting a text inside placeholder text as we want the whole action
                    // to be atomic
                    const { placeholder: placeholder } = state.schema.nodes;
                    const isPastingTextInsidePlaceholderText = state.doc.resolve(state.selection.$anchor.pos).nodeAfter?.type === placeholder;
                    // Don't add closeHistory if we're pasting over layout columns, as we will appendTransaction
                    // to cleanup the layout's structure and we want to keep the paste and re-structuring as
                    // one event.
                    const isPastingOverLayoutColumns = (0, $BmspC.hasParentNodeOfType)(state.schema.nodes.layoutColumn)(state.selection);
                    // don't add closeHistory call if we're pasting a table, as some tables may involve additional
                    // appendedTransactions to repair them (if they're partial or incomplete) and we don't want
                    // to split those repairing transactions in prosemirror-history when they're being added to the
                    // "done" stack
                    const isPastingTable = tr.steps.some((step)=>{
                        const slice = (0, $5Z3Rm.extractSliceFromStep)(step);
                        let tableExists = false;
                        slice?.content?.forEach((node)=>{
                            if (node.type === state.schema.nodes.table) tableExists = true;
                        });
                        return tableExists;
                    });
                    if (!isPastingTextInsidePlaceholderText && !isPastingTable && !isPastingOverLayoutColumns && pluginInjectionApi?.betterTypeHistory) tr = pluginInjectionApi?.betterTypeHistory?.actions.flagPasteEvent(tr);
                    const isDocChanged = tr.docChanged;
                    (0, $6C2m6.addLinkMetadata)(view.state.selection, tr, {
                        action: isPlainText ? (0, $bMFKb.ACTION).PASTED_AS_PLAIN : (0, $bMFKb.ACTION).PASTED,
                        inputMethod: (0, $bMFKb.INPUT_METHOD).CLIPBOARD
                    });
                    // handleMacroAutoConvert dispatches twice
                    // we make sure to call paste options toolbar
                    // only for a valid paste action
                    if (isDocChanged) {
                        const pasteStartPos = Math.min(state.selection.anchor, state.selection.head);
                        const pasteEndPos = tr.selection.to;
                        const contentPasted = {
                            pasteStartPos: pasteStartPos,
                            pasteEndPos: pasteEndPos,
                            text: text,
                            isShiftPressed: Boolean(// eslint-disable-next-line @typescript-eslint/no-explicit-any
                            view.shiftKey || view.input?.shiftKey),
                            isPlainText: Boolean(isPlainText),
                            pastedSlice: tr.doc.slice(pasteStartPos, pasteEndPos),
                            pastedAt: Date.now(),
                            pasteSource: (0, $bFyUX.getPasteSource)(event)
                        };
                        tr.setMeta((0, $3Elhj.pluginKey), {
                            type: (0, $6UQpI.PastePluginActionTypes).ON_PASTE,
                            contentPasted: contentPasted
                        });
                    }
                    // the handlePaste definition overrides the generic prosemirror behaviour which would previously
                    // include a uiEvent meta of paste. To align with the docs (https://prosemirror.net/docs/ref/#state.Transaction)
                    // This will re-add the uiEvent meta.
                    view.dispatch(tr.setMeta('uiEvent', 'paste'));
                };
                slice = (0, $1nSqW.handleParagraphBlockMarks)(state, slice);
                slice = (0, $di4lu.handleVSCodeBlock)({
                    state: state,
                    slice: slice,
                    event: event,
                    text: text
                });
                const plainTextPasteSlice = (0, $grDTV.linkifyContent)(state.schema)(slice);
                if ((0, $3kq4u.handlePasteAsPlainTextWithAnalytics)(editorAnalyticsAPI)(view, event, plainTextPasteSlice)(state, dispatch, view)) return true;
                if ((0, $eGOwo.fg)('platform_editor_fix_captions_on_copy')) {
                    if ((0, $3kq4u.handlePasteIntoCaptionWithAnalytics)(editorAnalyticsAPI)(view, event, slice, (0, $j0X5g.PasteTypes).richText)(state, dispatch)) // Create a custom handler to avoid handling with handleRichText method
                    // As SafeInsert is used inside handleRichText which caused some bad UX like this:
                    // https://product-fabric.atlassian.net/browse/MEX-1520
                    // Converting caption to plain text needs to be handled before transformSliceForMedia
                    // as createChecked will fail when trying to create a mediaSingle node with a caption
                    // that is not plain text.
                    return true;
                }
                // transform slices based on destination
                slice = (0, $5pNJd.transformSliceForMedia)(slice, schema, pluginInjectionApi)(state.selection);
                let markdownSlice;
                if (isPlainText) {
                    markdownSlice = getMarkdownSlice(text, slice.openStart, slice.openEnd);
                    // https://product-fabric.atlassian.net/browse/ED-15134
                    // Lists are not allowed within Blockquotes at this time. Attempting to
                    // paste a markdown list ie. ">- foo" will yeild a markdownSlice of size 0.
                    // Rather then blocking the paste action with no UI feedback, this will instead
                    // force a "paste as plain text" action by clearing the markdownSlice.
                    markdownSlice = !markdownSlice?.size ? undefined : markdownSlice;
                    if (markdownSlice) {
                        // linkify text prior to converting to macro
                        if ((0, $3kq4u.handlePasteLinkOnSelectedTextWithAnalytics)(editorAnalyticsAPI)(view, event, markdownSlice, (0, $j0X5g.PasteTypes).markdown)(state, dispatch)) return true;
                        // run macro autoconvert prior to other conversions
                        if ((0, $1nSqW.handleMacroAutoConvert)(text, markdownSlice, pluginInjectionApi?.card?.actions?.queueCardsFromChangedTr, pluginInjectionApi?.extension?.actions?.runMacroAutoConvert, cardOptions, extensionAutoConverter)(state, dispatch, view)) {
                            // TODO: ED-26959 - handleMacroAutoConvert dispatch twice, so we can't use the helper
                            (0, $3kq4u.sendPasteAnalyticsEvent)(editorAnalyticsAPI)(view, event, markdownSlice, {
                                type: (0, $j0X5g.PasteTypes).markdown
                            });
                            return true;
                        }
                    }
                }
                slice = (0, $bFyUX.transformUnsupportedBlockCardToInline)(slice, state, cardOptions);
                // Handles edge case so that when copying text from the top level of the document
                // it can be pasted into nodes like panels/actions/decisions without removing them.
                // Overriding openStart to be 1 when only pasting a paragraph makes the preferred
                // depth favour the text, rather than the paragraph node.
                // https://github.com/ProseMirror/prosemirror-transform/blob/master/src/replace.js#:~:text=Transform.prototype.-,replaceRange,-%3D%20function(from%2C%20to
                const selectionDepth = state.selection.$head.depth;
                const selectionParentNode = state.selection.$head.node(selectionDepth - 1);
                const selectionParentType = selectionParentNode?.type;
                const edgeCaseNodeTypes = [
                    schema.nodes?.panel,
                    schema.nodes?.taskList,
                    schema.nodes?.decisionList
                ];
                if (slice.openStart === 0 && slice.openEnd !== 1 && selectionParentNode && edgeCaseNodeTypes.includes(selectionParentType)) // @ts-ignore - [unblock prosemirror bump] assigning to readonly prop
                slice.openStart = 1;
                // If we're in a code block, append the text contents of clipboard inside it
                if ((0, $3kq4u.handleCodeBlockWithAnalytics)(editorAnalyticsAPI)(view, event, slice, text)(state, dispatch)) return true;
                if ((0, $3kq4u.handleMediaSingleWithAnalytics)(editorAnalyticsAPI)(view, event, slice, isPastedFile ? (0, $j0X5g.PasteTypes).binary : (0, $j0X5g.PasteTypes).richText, pluginInjectionApi?.media?.actions.insertMediaAsMediaSingle)(state, dispatch, view)) return true;
                if ((0, $3kq4u.handleSelectedTableWithAnalytics)(editorAnalyticsAPI)(view, event, slice)(state, dispatch)) return true;
                let isNestedMarkdownTable = false;
                // if paste a markdown table inside a table cell, we should treat it as a table slice
                const isParentNodeTdOrTh = selectionParentType === schema.nodes.tableCell || selectionParentType === schema.nodes.tableHeader;
                isNestedMarkdownTable = !!(markdownSlice && isPlainText && isParentNodeTdOrTh && (0, $3kq4u.getContentNodeTypes)(markdownSlice.content).includes(schema.nodes.table?.name));
                slice = isNestedMarkdownTable ? markdownSlice : slice;
                // get editor-tables to handle pasting tables if it can
                // otherwise, just the replace the selection with the content
                if ((0, $5yEGu.handlePaste)(view, event, slice, {
                    pasteSource: (0, $bFyUX.getPasteSource)(event)
                })) {
                    (0, $3kq4u.sendPasteAnalyticsEvent)(editorAnalyticsAPI)(view, event, slice, {
                        type: (0, $j0X5g.PasteTypes).richText
                    });
                    return true;
                }
                // handle paste of nested tables to ensure nesting limits are respected
                if ((0, $3kq4u.handleNestedTablePasteWithAnalytics)(editorAnalyticsAPI, (0, $eGOwo.fg)('platform_editor_use_nested_table_pm_nodes'))(view, event, slice)(state, dispatch)) return true;
                if ((0, $3kq4u.handlePasteIntoTaskAndDecisionWithAnalytics)(view, event, slice, isPlainText ? (0, $j0X5g.PasteTypes).plain : (0, $j0X5g.PasteTypes).richText, pluginInjectionApi)(state, dispatch)) return true;
                // If the clipboard only contains plain text, attempt to parse it as Markdown
                if (isPlainText && markdownSlice && !isNestedMarkdownTable) {
                    if ((0, $3kq4u.handlePastePreservingMarksWithAnalytics)(view, event, markdownSlice, (0, $j0X5g.PasteTypes).markdown, pluginInjectionApi)(state, dispatch)) return true;
                    return (0, $3kq4u.handleMarkdownWithAnalytics)(view, event, markdownSlice, pluginInjectionApi)(state, dispatch);
                }
                if (isRichText && $a6f16289cbc0bfec$export$eedfdbc6a6bc1442(state)) {
                    //If pasting inside blockquote
                    //Skip the blockquote node and keep remaining nodes as they are
                    //prevent doing this if there is list inside blockquote as the list is pasted incorrectly inside blockquote due to wrong openStart and openEnd
                    const { blockquote: blockquote } = schema.nodes;
                    const children = [];
                    (0, $gbisc.mapChildren)(slice.content, (node)=>{
                        if (node.type === blockquote && !(0, $BmspC.contains)(node, state.schema.nodes.listItem)) for(let i = 0; i < node.childCount; i++)children.push(node.child(i));
                        else children.push(node);
                    });
                    slice = new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).fromArray(children), slice.openStart, slice.openEnd);
                }
                // finally, handle rich-text copy-paste
                if (isRichText || isNestedMarkdownTable) {
                    // linkify the text where possible
                    slice = (0, $grDTV.linkifyContent)(state.schema)(slice);
                    if ((0, $3kq4u.handlePasteLinkOnSelectedTextWithAnalytics)(editorAnalyticsAPI)(view, event, slice, (0, $j0X5g.PasteTypes).richText)(state, dispatch)) return true;
                    // run macro autoconvert prior to other conversions
                    if ((0, $1nSqW.handleMacroAutoConvert)(text, slice, pluginInjectionApi?.card?.actions?.queueCardsFromChangedTr, pluginInjectionApi?.extension?.actions?.runMacroAutoConvert, cardOptions, extensionAutoConverter)(state, dispatch, view)) {
                        // TODO: ED-26959 - handleMacroAutoConvert dispatch twice, so we can't use the helper
                        (0, $3kq4u.sendPasteAnalyticsEvent)(editorAnalyticsAPI)(view, event, slice, {
                            type: (0, $j0X5g.PasteTypes).richText
                        });
                        return true;
                    }
                    // handle the case when copy content from a table cell inside bodied extension
                    if ((0, $1nSqW.handleTableContentPasteInBodiedExtension)(slice)(state, dispatch)) return true;
                    // remove annotation marks from the pasted data if they are not present in the document
                    // for the cases when they are pasted from external pages
                    if (slice.content.size && (0, $7TRmB.containsAnyAnnotations)(slice, state)) pluginInjectionApi?.annotation?.actions.stripNonExistingAnnotations(slice, state);
                    if ((0, $3kq4u.handlePastePreservingMarksWithAnalytics)(view, event, slice, (0, $j0X5g.PasteTypes).richText, pluginInjectionApi)(state, dispatch)) return true;
                    // Check that we are pasting in a location that does not accept
                    // breakout marks, if so we strip the mark and paste. Note that
                    // breakout marks are only valid in the root document.
                    if (selectionParentType !== state.schema.nodes.doc) {
                        const sliceCopy = (0, $3xw6l.Slice).fromJSON(state.schema, slice.toJSON() || {});
                        sliceCopy.content.descendants((node)=>{
                            // @ts-ignore - [unblock prosemirror bump] assigning to readonly prop
                            node.marks = node.marks.filter((mark)=>mark.type.name !== 'breakout');
                            // as breakout marks should only be on top level nodes,
                            // we don't traverse the entire document
                            return false;
                        });
                        slice = sliceCopy;
                    }
                    if ((0, $3kq4u.handleExpandWithAnalytics)(editorAnalyticsAPI)(view, event, slice)(state, dispatch)) return true;
                    if (!(0, $eQTBG.insideTable)(state)) slice = (0, $1Snbj.transformSliceNestedExpandToExpand)(slice, state.schema);
                    if (!(0, $eGOwo.fg)('platform_editor_fix_captions_on_copy')) {
                        if ((0, $3kq4u.handlePasteIntoCaptionWithAnalytics)(editorAnalyticsAPI)(view, event, slice, (0, $j0X5g.PasteTypes).richText)(state, dispatch)) // Create a custom handler to avoid handling with handleRichText method
                        // As SafeInsert is used inside handleRichText which caused some bad UX like this:
                        // https://product-fabric.atlassian.net/browse/MEX-1520
                        return true;
                    }
                    if ((0, $3kq4u.handlePastePanelOrDecisionIntoListWithAnalytics)(editorAnalyticsAPI)(view, event, slice, pluginInjectionApi?.list?.actions.findRootParentListNode)(state, dispatch)) return true;
                    if ((0, $3kq4u.handlePasteNonNestableBlockNodesIntoListWithAnalytics)(editorAnalyticsAPI)(view, event, slice)(state, dispatch)) return true;
                    return (0, $3kq4u.handleRichTextWithAnalytics)(view, event, slice, pluginInjectionApi)(state, dispatch);
                }
                return false;
            },
            transformPasted (slice) {
                if (sanitizePrivateContent) slice = (0, $1nSqW.handleMention)(slice, schema);
                /* Bitbucket copies diffs as multiple adjacent code blocks
				 * so we merge ALL adjacent code blocks to support paste here */ if (pastedFromBitBucket) slice = (0, $k2X9Z.transformSliceToJoinAdjacentCodeBlocks)(slice);
                slice = (0, $k2X9Z.transformSingleLineCodeBlockToCodeMark)(slice, schema);
                slice = (0, $5pNJd.transformSliceToCorrectMediaWrapper)(slice, schema);
                slice = (0, $5pNJd.transformSliceToMediaSingleWithNewExperience)(slice, schema, pluginInjectionApi);
                slice = (0, $4Gpco.transformSliceToDecisionList)(slice, schema);
                // splitting linebreaks into paragraphs must happen before upgrading text to lists
                slice = (0, $1CqHB.splitParagraphs)(slice, schema);
                slice = (0, $1CqHB.upgradeTextToLists)(slice, schema);
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                if (slice.content.childCount && slice.content.lastChild.type === schema.nodes.codeBlock) slice = new (0, $3xw6l.Slice)(slice.content, 0, 0);
                if (!(0, $92xoS.editorExperiment)('single_column_layouts', true)) slice = (0, $iZ2Kf.transformSingleColumnLayout)(slice, schema);
                slice = (0, $j6af7.transformSliceToRemoveMacroId)(slice, schema);
                return slice;
            },
            transformPastedHTML (html) {
                // Fix for issue ED-4438
                // text from google docs should not be pasted as inline code
                if (html.indexOf('id="docs-internal-guid-') >= 0) {
                    // Ignored via go/ees005
                    // eslint-disable-next-line require-unicode-regexp
                    html = html.replace(/white-space:pre/g, '');
                    // Ignored via go/ees005
                    // eslint-disable-next-line require-unicode-regexp
                    html = html.replace(/white-space:pre-wrap/g, '');
                }
                // Partial fix for ED-7331: During a copy/paste from the legacy tinyMCE
                // confluence editor, if we encounter an incomplete table (e.g. table elements
                // not wrapped in <table>), we try to rebuild a complete, valid table if possible.
                if (mostRecentPasteEvent && (0, $2kOjB.isPastedFromTinyMCEConfluence)(mostRecentPasteEvent, html) && (0, $2kOjB.htmlHasIncompleteTable)(html)) {
                    const completeTableHtml = (0, $2kOjB.tryRebuildCompleteTableHtml)(html);
                    if (completeTableHtml) html = completeTableHtml;
                }
                if (!(0, $bFyUX.isPastedFromWord)(html) && !(0, $bFyUX.isPastedFromExcel)(html) && html.indexOf('<img ') >= 0) html = (0, $5pNJd.unwrapNestedMediaElements)(html);
                // https://product-fabric.atlassian.net/browse/ED-11714
                // Checking for edge case when copying a list item containing links from Notion
                // The html from this case is invalid with duplicate nested links
                if ((0, $bFyUX.htmlHasInvalidLinkTags)(html)) html = (0, $bFyUX.removeDuplicateInvalidLinks)(html);
                // Fix for ED-13568: Code blocks being copied/pasted when next to each other get merged
                pastedFromBitBucket = html.indexOf('data-qa="code-line"') >= 0;
                mostRecentPasteEvent = null;
                return html;
            }
        }
    });
}

});
parcelRegister("j0X5g", function(module, exports) {

$parcel$export(module.exports, "PasteTypes", () => $bfeab86471e5953a$export$2ba12a8680458b1e);
$parcel$export(module.exports, "PasteContents", () => $bfeab86471e5953a$export$a82556f999b47168);
const $bfeab86471e5953a$export$2ba12a8680458b1e = {
    richText: 'richText',
    plain: 'plain',
    markdown: 'markdown',
    binary: 'binary'
};
const $bfeab86471e5953a$export$602c33ed77663fbf = {
    fabricEditor: 'fabric-editor',
    applePages: 'apple-pages',
    googleSpreadsheets: 'google-spreadsheets',
    googleDocs: 'google-docs',
    microsoftExcel: 'microsoft-excel',
    microsoftWord: 'microsoft-word',
    dropboxPaper: 'dropbox-paper',
    uncategorized: 'uncategorized'
};
const $bfeab86471e5953a$export$a82556f999b47168 = {
    text: 'text',
    url: 'url',
    code: 'code',
    mediaSingle: 'mediaSingle',
    mediaCard: 'mediaCard',
    mediaGroup: 'mediaGroup',
    tableCells: 'tableCells',
    table: 'table',
    expand: 'expand',
    nestedExpand: 'nestedExpand',
    mixed: 'mixed',
    blockquote: 'blockquote',
    blockCard: 'blockCard',
    bodiedExtension: 'bodiedExtension',
    multiBodiedExtension: 'multiBodiedExtension',
    bulletList: 'bulletList',
    codeBlock: 'codeBlock',
    decisionList: 'decisionList',
    decisionItem: 'decisionItem',
    extension: 'extension',
    heading: 'heading',
    layoutSection: 'layoutSection',
    orderedList: 'orderedList',
    panel: 'panel',
    rule: 'rule',
    tableHeader: 'tableHeader',
    tableRow: 'tableRow',
    taskItem: 'taskItem',
    uncategorized: 'uncategorized'
};

});

parcelRegister("ayT4n", function(module, exports) {

$parcel$export(module.exports, "isPastedFile", () => $dea5e46e68396a3b$export$30c8e5e50a78a591);
function $dea5e46e68396a3b$export$e20225b4cda674a8(type, item) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const isDOMStringList = (t)=>!t.indexOf && !!t.contains;
    return isDOMStringList(type) ? type.contains(item) : type.indexOf(item) > -1;
}
function $dea5e46e68396a3b$export$30c8e5e50a78a591(rawEvent) {
    const { clipboardData: clipboardData } = rawEvent;
    if (!clipboardData) return false;
    return $dea5e46e68396a3b$export$e20225b4cda674a8(clipboardData.types, 'Files');
}

});

parcelRegister("iZ2Kf", function(module, exports) {

$parcel$export(module.exports, "transformSingleColumnLayout", () => $6c7dd00049a48457$export$ca45027befc3fad2);
$parcel$export(module.exports, "transformSliceToRemoveOpenLayoutNodes", () => $6c7dd00049a48457$export$82cc8566682e5cf4);

var $3xw6l = parcelRequire("3xw6l");

var $gbisc = parcelRequire("gbisc");
const $6c7dd00049a48457$var$isLayoutNode = (node)=>node.type === node.type.schema.nodes.layoutSection || node.type === node.type.schema.nodes.layoutColumn;
function $6c7dd00049a48457$export$5fc4db161d3fef1f(maybeLayoutSection) {
    const fragment = (0, $gbisc.mapFragment)((0, $3xw6l.Fragment).from(maybeLayoutSection), (node)=>{
        return $6c7dd00049a48457$var$isLayoutNode(node) ? node.content : node;
    });
    const nodes = [];
    fragment.forEach((i)=>nodes.push(i));
    return nodes;
}
function $6c7dd00049a48457$export$238984649a055433(node, i) {
    return i === 0 ? $6c7dd00049a48457$export$5fc4db161d3fef1f(node) : node;
}
function $6c7dd00049a48457$export$38d10d1907db60ca(node, i, fragment) {
    return i === fragment.childCount - 1 ? $6c7dd00049a48457$export$5fc4db161d3fef1f(node) : node;
}
const $6c7dd00049a48457$export$ca45027befc3fad2 = (slice, schema)=>{
    if (slice.content.childCount === 1 && slice.openStart === 0 && slice.openEnd === 0) {
        if (slice.content.firstChild?.type === schema.nodes.layoutColumn) {
            const newSlice = new (0, $3xw6l.Slice)(slice.content.firstChild.content, 0, 0);
            return newSlice;
        } else if (slice.content.firstChild?.type === schema.nodes.layoutSection && slice.content.firstChild.childCount === 1 && slice.content.firstChild.firstChild?.type === schema.nodes.layoutColumn) {
            const newSlice = new (0, $3xw6l.Slice)(slice.content.firstChild.firstChild.content, 0, 0);
            return newSlice;
        }
    }
    return slice;
};
function $6c7dd00049a48457$export$82cc8566682e5cf4(slice, schema) {
    // Case 1: A slice entirely within a single layoutSection
    if (slice.openStart && slice.openEnd && slice.content.childCount === 1) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const maybeLayoutSection = slice.content.firstChild;
        if (maybeLayoutSection.type === schema.nodes.layoutSection) return new (0, $3xw6l.Slice)((0, $gbisc.flatmap)(slice.content, $6c7dd00049a48457$export$238984649a055433), // '-2' here because we've removed the layoutSection/layoutColumn; reducing the open depth.
        slice.openStart - 2, slice.openEnd - 2);
    }
    // Case 2: A slice starting inside a layoutSection and finishing outside
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    if (slice.openStart && slice.content.firstChild.type === schema.nodes.layoutSection) slice = new (0, $3xw6l.Slice)((0, $gbisc.flatmap)(slice.content, $6c7dd00049a48457$export$238984649a055433), slice.openStart - 2, slice.openEnd);
    // Case 3: A slice starting outside a layoutSection and finishing inside
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    if (slice.openEnd && slice.content.lastChild.type === schema.nodes.layoutSection) slice = new (0, $3xw6l.Slice)((0, $gbisc.flatmap)(slice.content, $6c7dd00049a48457$export$38d10d1907db60ca), slice.openStart, slice.openEnd - 2);
    // Case 2 & 3 also handles a slice starting in one layoutSection & finishing in a different layoutSection
    return slice;
}

});

parcelRegister("k2X9Z", function(module, exports) {

$parcel$export(module.exports, "transformSliceToJoinAdjacentCodeBlocks", () => $f1a235c7a15c8b24$export$5a682e48ed34e262);
$parcel$export(module.exports, "transformSingleLineCodeBlockToCodeMark", () => $f1a235c7a15c8b24$export$d1dc8019f50dded8);
$parcel$export(module.exports, "findCodeBlock", () => $f1a235c7a15c8b24$export$8435d1ef36841a34);

var $3xw6l = parcelRequire("3xw6l");

var $BmspC = parcelRequire("BmspC");

var $gbisc = parcelRequire("gbisc");
function $f1a235c7a15c8b24$var$joinCodeBlocks(left, right) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const textContext = `${left.textContent}\n${right.textContent}`;
    return left.type.create(left.attrs, left.type.schema.text(textContext));
}
function $f1a235c7a15c8b24$var$mergeAdjacentCodeBlocks(fragment) {
    const children = [];
    fragment.forEach((maybeCodeBlock)=>{
        if (maybeCodeBlock.type === maybeCodeBlock.type.schema.nodes.codeBlock) {
            const peekAtPrevious = children[children.length - 1];
            if (peekAtPrevious && peekAtPrevious.type === maybeCodeBlock.type) // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return children.push($f1a235c7a15c8b24$var$joinCodeBlocks(children.pop(), maybeCodeBlock));
        }
        return children.push(maybeCodeBlock);
    });
    return (0, $3xw6l.Fragment).from(children);
}
function $f1a235c7a15c8b24$export$5a682e48ed34e262(slice) {
    slice = (0, $gbisc.mapSlice)(slice, (node)=>{
        return node.isBlock && !node.isTextblock ? node.copy($f1a235c7a15c8b24$var$mergeAdjacentCodeBlocks(node.content)) : node;
    });
    // mapSlice won't be able to merge adjacent top-level code-blocks
    return new (0, $3xw6l.Slice)($f1a235c7a15c8b24$var$mergeAdjacentCodeBlocks(slice.content), slice.openStart, slice.openEnd);
}
const $f1a235c7a15c8b24$export$d1dc8019f50dded8 = (slice, schema)=>{
    if (slice.content.childCount === 1 && (slice.openStart || slice.openEnd)) {
        const maybeCodeBlock = slice.content.firstChild;
        if (maybeCodeBlock && maybeCodeBlock.type === schema.nodes.codeBlock) {
            if (maybeCodeBlock.textContent && maybeCodeBlock.textContent.indexOf('\n') === -1) return new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).from(schema.text(maybeCodeBlock.textContent, [
                schema.marks.code.create()
            ])), 0, 0);
        }
    }
    return slice;
};
const $f1a235c7a15c8b24$export$8435d1ef36841a34 = (state, selection)=>{
    const { codeBlock: codeBlock } = state.schema.nodes;
    return (0, $BmspC.findSelectedNodeOfType)(codeBlock)(selection || state.selection) || (0, $BmspC.findParentNodeOfType)(codeBlock)(selection || state.selection);
};

});

parcelRegister("1Snbj", function(module, exports) {

$parcel$export(module.exports, "findExpand", () => $a1268ea093b48e7a$export$fd7bf9c73fdd6f30);
$parcel$export(module.exports, "transformSliceToRemoveOpenExpand", () => $a1268ea093b48e7a$export$6d57e15bdf5e650f);
$parcel$export(module.exports, "transformSliceToRemoveOpenNestedExpand", () => $a1268ea093b48e7a$export$74dbe7cb6b933cde);
$parcel$export(module.exports, "transformSliceNestedExpandToExpand", () => $a1268ea093b48e7a$export$fd33fafbf6b5abc7);
$parcel$export(module.exports, "transformSliceExpandToNestedExpand", () => $a1268ea093b48e7a$export$447e90e618548243);

var $3xw6l = parcelRequire("3xw6l");

var $BmspC = parcelRequire("BmspC");

var $gbisc = parcelRequire("gbisc");
const $a1268ea093b48e7a$export$fd7bf9c73fdd6f30 = (state, selection)=>{
    const { expand: expand, nestedExpand: nestedExpand } = state.schema.nodes;
    return (0, $BmspC.findSelectedNodeOfType)([
        expand,
        nestedExpand
    ])(selection || state.selection) || (0, $BmspC.findParentNodeOfType)([
        expand,
        nestedExpand
    ])(selection || state.selection);
};
const $a1268ea093b48e7a$export$6d57e15bdf5e650f = (slice, schema)=>{
    if (slice.openStart > 1 && slice.openEnd > 1 && slice.content.childCount === 1 && slice.content.firstChild && slice.content.firstChild.type === schema.nodes.expand) return new (0, $3xw6l.Slice)(slice.content.firstChild.content, slice.openStart - 1, slice.openEnd - 1);
    return slice;
};
const $a1268ea093b48e7a$export$74dbe7cb6b933cde = (slice, schema)=>{
    if (slice.openStart > 1 && slice.openEnd > 1 && slice.content.childCount === 1 && slice.content.firstChild && slice.content.firstChild.type === schema.nodes.nestedExpand) return new (0, $3xw6l.Slice)(slice.content.firstChild.content, slice.openStart - 1, slice.openEnd - 1);
    return slice;
};
const $a1268ea093b48e7a$export$fd33fafbf6b5abc7 = (slice, schema)=>{
    const { expand: expand, nestedExpand: nestedExpand } = schema.nodes;
    const children = [];
    (0, $gbisc.mapChildren)(slice.content, (node)=>{
        if (node.type === nestedExpand) children.push(expand.createChecked(node.attrs, node.content, node.marks));
        else children.push(node);
    });
    return new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).fromArray(children), slice.openStart, slice.openEnd);
};
const $a1268ea093b48e7a$export$447e90e618548243 = (slice)=>{
    const children = [];
    try {
        (0, $gbisc.mapChildren)(slice.content, (currentNode)=>{
            const { expand: expand, nestedExpand: nestedExpand } = currentNode.type.schema.nodes;
            if (currentNode.type === expand) {
                const nestedExpandNode = nestedExpand.createChecked(currentNode.attrs, currentNode.content, currentNode.marks);
                if (nestedExpandNode) children.push(nestedExpandNode);
            } else children.push(currentNode);
        });
    } catch (e) {
        // Will throw error if unable to convert expand to nested expand.
        // Example: expand containing a table being converted to nested expand containing table.
        return null;
    }
    return new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).fromArray(children), slice.openStart, slice.openEnd);
};

});

parcelRegister("4Gpco", function(module, exports) {

$parcel$export(module.exports, "transformSliceToDecisionList", () => $d84bfd6becaef3e6$export$65d21b4bef5d424b);

var $3xw6l = parcelRequire("3xw6l");
const $d84bfd6becaef3e6$export$65d21b4bef5d424b = (slice, schema)=>{
    const node = slice.content.firstChild;
    if (slice.content.childCount === 1 && node && node.type.name === 'decisionItem') {
        const decisionListWrapperNode = schema.nodes.decisionList.create({}, node);
        return new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).from(decisionListWrapperNode), slice.openStart, slice.openEnd);
    }
    return slice;
};

});

parcelRegister("j6af7", function(module, exports) {

$parcel$export(module.exports, "transformSliceToRemoveOpenBodiedExtension", () => $d43eea8e1a58258d$export$c50f82e6f2cff97d);
$parcel$export(module.exports, "transformSliceToRemoveOpenMultiBodiedExtension", () => $d43eea8e1a58258d$export$d2a1206296dcfa47);
$parcel$export(module.exports, "transformSliceToRemoveLegacyContentMacro", () => $d43eea8e1a58258d$export$23ce34395aea8526);
$parcel$export(module.exports, "transformSliceToRemoveMacroId", () => $d43eea8e1a58258d$export$c20bd22f1bffad40);

var $2OrIX = parcelRequire("2OrIX");

var $3xw6l = parcelRequire("3xw6l");

var $gbisc = parcelRequire("gbisc");
const $d43eea8e1a58258d$export$c50f82e6f2cff97d = (slice, schema)=>{
    const { bodiedExtension: bodiedExtension } = schema.nodes;
    const fragment = (0, $gbisc.mapFragment)(slice.content, (node, parent, index)=>{
        if (node.type === bodiedExtension && !parent) {
            const currentNodeIsAtStartAndIsOpen = slice.openStart && index === 0;
            const currentNodeIsAtEndAndIsOpen = slice.openEnd && index + 1 === slice.content.childCount;
            if (currentNodeIsAtStartAndIsOpen || currentNodeIsAtEndAndIsOpen) return node.content;
        }
        return node;
    });
    // If the first/last child has changed - then we know we've removed a bodied extension & to decrement the open depth
    return new (0, $3xw6l.Slice)(fragment, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    fragment.firstChild && fragment.firstChild.type !== slice.content.firstChild.type ? slice.openStart - 1 : slice.openStart, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    fragment.lastChild && fragment.lastChild.type !== slice.content.lastChild.type ? slice.openEnd - 1 : slice.openEnd);
};
const $d43eea8e1a58258d$export$d2a1206296dcfa47 = (slice, schema)=>{
    const { multiBodiedExtension: multiBodiedExtension, extensionFrame: extensionFrame } = schema.nodes;
    let depthToReduce = 2; // Removing MBE and extensionFrame
    // Edge case where the slice does not contain extensionFrames under MBE, happens when multiple block nodes get copied from a frame
    if (slice.content.firstChild?.type === multiBodiedExtension && slice.content.firstChild?.firstChild?.type !== extensionFrame) depthToReduce = 1;
    const fragment = (0, $gbisc.mapFragment)(slice.content, (node, parent, index)=>{
        if (node.type === multiBodiedExtension && !parent || node.type === extensionFrame) {
            const currentNodeIsAtStartAndIsOpen = slice.openStart >= depthToReduce && index === 0;
            const currentNodeIsAtEndAndIsOpen = slice.openEnd >= depthToReduce && index + 1 === slice.content.childCount;
            if (currentNodeIsAtStartAndIsOpen || currentNodeIsAtEndAndIsOpen) return node.content;
        }
        if (node.type === multiBodiedExtension) /* While pasting on the same page, macroId does not change until the page is published and causes collision with the existing macroId
			 *  where switching tabs of one node changes the tabs for the other node, so we put a random macroId at paste to avoid collision
			 */ {
            if (node.attrs.parameters?.macroMetadata?.macroId?.value) node.attrs.parameters.macroMetadata.macroId.value = (0, $2OrIX.uuid).generate();
        }
        return node;
    });
    // If the first/last child has changed - then we know we've removed MBE and extensionFrame and need to decrement the open depth
    return new (0, $3xw6l.Slice)(fragment, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    fragment.firstChild && fragment.firstChild.type !== slice.content.firstChild.type ? slice.openStart - depthToReduce : slice.openStart, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    fragment.lastChild && fragment.lastChild.type !== slice.content.lastChild.type ? slice.openEnd - depthToReduce : slice.openEnd);
};
const $d43eea8e1a58258d$var$LEGACY_CONTENT_MACRO_EXTENSION_TYPE = 'com.atlassian.confluence.migration', $d43eea8e1a58258d$var$LEGACY_CONTENT_MACRO_EXTENSION_KEY = 'legacy-content';
const $d43eea8e1a58258d$var$isLegacyContentMacroExtension = (extensionNode)=>extensionNode.attrs?.extensionType === $d43eea8e1a58258d$var$LEGACY_CONTENT_MACRO_EXTENSION_TYPE && extensionNode.attrs?.extensionKey === $d43eea8e1a58258d$var$LEGACY_CONTENT_MACRO_EXTENSION_KEY;
const $d43eea8e1a58258d$export$23ce34395aea8526 = (slice, schema)=>{
    const { extension: extension } = schema.nodes;
    return (0, $gbisc.mapSlice)(slice, (node)=>{
        if (node.type === extension && $d43eea8e1a58258d$var$isLegacyContentMacroExtension(node)) // Strip the node
        return null;
        return node;
    });
};
const $d43eea8e1a58258d$export$c20bd22f1bffad40 = (slice, schema)=>{
    const { extension: extension, inlineExtension: inlineExtension } = schema.nodes;
    return (0, $gbisc.mapSlice)(slice, (node)=>{
        if ([
            extension,
            inlineExtension
        ].includes(node.type) && typeof node.attrs.parameters?.macroMetadata?.macroId?.value !== 'undefined') // Strip the macroId. While pasting on the same page, macroId does not change until the page
        // is published and causes collision with the existing macroId where switching tabs of one
        // node changes the tabs for the other node
        delete node.attrs.parameters.macroMetadata.macroId;
        return node;
    });
};

});

parcelRegister("4jPLX", function(module, exports) {

$parcel$export(module.exports, "MarkdownTransformer", () => $294df2a1bcb8e230$export$267fd7ead7cc4561);

var $8DB98 = parcelRequire("8DB98");

var $cciZy = parcelRequire("cciZy");

var $5bsyn = parcelRequire("5bsyn");

var $8AXx4 = parcelRequire("8AXx4");

var $eyCU5 = parcelRequire("eyCU5");
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $294df2a1bcb8e230$var$filterMdToPmSchemaMapping(schema, map) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return Object.keys(map).reduce((newMap, key)=>{
        const value = map[key];
        const block = value.block || value.node;
        const mark = value.mark;
        if (block && schema.nodes[block] || mark && schema.marks[mark]) newMap[key] = value;
        return newMap;
    }, {});
}
const $294df2a1bcb8e230$var$pmSchemaToMdMapping = {
    nodes: {
        blockquote: 'blockquote',
        paragraph: 'paragraph',
        rule: 'hr',
        // lheading (---, ===)
        heading: [
            'heading',
            'lheading'
        ],
        codeBlock: [
            'code',
            'fence'
        ],
        listItem: 'list',
        image: 'image'
    },
    marks: {
        em: 'emphasis',
        strong: 'text',
        link: [
            'link',
            'autolink',
            'reference',
            'linkify'
        ],
        strike: 'strikethrough',
        code: 'backticks'
    }
};
const $294df2a1bcb8e230$var$mdToPmMapping = {
    blockquote: {
        block: 'blockquote'
    },
    paragraph: {
        block: 'paragraph'
    },
    em: {
        mark: 'em'
    },
    strong: {
        mark: 'strong'
    },
    link: {
        mark: 'link',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: (tok)=>({
                href: tok.attrGet('href'),
                title: tok.attrGet('title') || null
            })
    },
    hr: {
        node: 'rule'
    },
    heading: {
        block: 'heading',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: (tok)=>({
                level: +tok.tag.slice(1)
            })
    },
    softbreak: {
        node: 'hardBreak'
    },
    hardbreak: {
        node: 'hardBreak'
    },
    code_block: {
        block: 'codeBlock'
    },
    list_item: {
        block: 'listItem'
    },
    bullet_list: {
        block: 'bulletList'
    },
    ordered_list: {
        block: 'orderedList',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: (tok)=>({
                order: typeof tok.attrGet('start') === 'number' ? tok.attrGet('start') : 1
            })
    },
    code_inline: {
        mark: 'code'
    },
    fence: {
        block: 'codeBlock',
        // we trim any whitespaces around language definition
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: (tok)=>({
                language: tok.info && tok.info.trim() || null
            })
    },
    media_single: {
        block: 'mediaSingle',
        attrs: ()=>({})
    },
    media: {
        node: 'media',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: (tok)=>{
            return {
                url: tok.attrGet('url'),
                alt: tok.attrGet('alt'),
                type: 'external'
            };
        }
    },
    emoji: {
        node: 'emoji',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: (tok)=>({
                shortName: `:${tok.markup}:`,
                text: tok.content
            })
    },
    table: {
        block: 'table'
    },
    tr: {
        block: 'tableRow'
    },
    th: {
        block: 'tableHeader'
    },
    td: {
        block: 'tableCell'
    },
    s: {
        mark: 'strike'
    },
    task_list: {
        block: 'taskList'
    },
    task_item: {
        block: 'taskItem',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: (tok)=>({
                state: tok.meta
            })
    }
};
const $294df2a1bcb8e230$var$md = (0, (/*@__PURE__*/$parcel$interopDefault($cciZy)))('zero', {
    html: false
});
$294df2a1bcb8e230$var$md.enable([
    // Process html entity - &#123;, &#xAF;, &quot;, ...
    'entity',
    // Process escaped chars and hardbreaks
    'escape'
]);
class $294df2a1bcb8e230$export$267fd7ead7cc4561 {
    constructor(schema = (0, $8DB98.defaultSchema), tokenizer = $294df2a1bcb8e230$var$md){
        // Enable markdown plugins based on schema
        [
            'nodes',
            'marks'
        ].forEach((key)=>{
            for(const idx in $294df2a1bcb8e230$var$pmSchemaToMdMapping[key])if (schema[key][idx]) tokenizer.enable($294df2a1bcb8e230$var$pmSchemaToMdMapping[key][idx]);
        });
        if (schema.nodes.table) tokenizer.use((0, $5bsyn.markdownItTable));
        if (schema.nodes.media && schema.nodes.mediaSingle) tokenizer.use((0, $eyCU5.markdownItMedia));
        this.markdownParser = new (0, $8AXx4.MarkdownParser)(schema, tokenizer, $294df2a1bcb8e230$var$filterMdToPmSchemaMapping(schema, $294df2a1bcb8e230$var$mdToPmMapping));
    }
    encode(_node) {
        throw new Error('This is not implemented yet');
    }
    parse(content) {
        return this.markdownParser.parse(content);
    }
}

});
parcelRegister("5bsyn", function(module, exports) {

$parcel$export(module.exports, "markdownItTable", () => $3c6420f8bc70654d$export$26a6b72a65821214);

var $dMwKU = parcelRequire("dMwKU");
var $3c6420f8bc70654d$export$26a6b72a65821214 = function markdownItTable(md, options) {
    md.block.ruler.before('paragraph', 'table', (0, (/*@__PURE__*/$parcel$interopDefault($dMwKU))), {
        alt: [
            'paragraph',
            'reference'
        ]
    });
};

});
parcelRegister("dMwKU", function(module, exports) {
// Copied from https://github.com/markdown-it/markdown-it/blob/master/lib/rules_block/table.js
function $a0892a9f119b1133$var$isSpace(code) {
    switch(code){
        case 0x09:
        case 0x20:
            return true;
    }
    return false;
}
function $a0892a9f119b1133$var$getLine(state, line) {
    var pos = state.bMarks[line] + state.blkIndent, max = state.eMarks[line];
    return state.src.substr(pos, max - pos);
}
function $a0892a9f119b1133$var$escapedSplit(str) {
    var result = [], pos = 0, max = str.length, ch, escapes = 0, lastPos = 0, backTicked = false, lastBackTick = 0;
    ch = str.charCodeAt(pos);
    while(pos < max){
        if (ch === 0x60 /* ` */ ) {
            if (backTicked) {
                // make \` close code sequence, but not open it;
                // the reason is: `\` is correct code block
                backTicked = false;
                lastBackTick = pos;
            } else if (escapes % 2 === 0) {
                backTicked = true;
                lastBackTick = pos;
            }
        } else if (ch === 0x7c /* | */  && escapes % 2 === 0 && !backTicked) {
            result.push(str.substring(lastPos, pos));
            lastPos = pos + 1;
        }
        if (ch === 0x5c /* \ */ ) escapes++;
        else escapes = 0;
        pos++;
        // If there was an un-closed backtick, go back to just after
        // the last backtick, but as if it was a normal character
        if (pos === max && backTicked) {
            backTicked = false;
            pos = lastBackTick + 1;
        }
        ch = str.charCodeAt(pos);
    }
    result.push(str.substring(lastPos));
    return result;
}
module.exports = function table(state, startLine, endLine, silent) {
    var ch, lineText, pos, i, nextLine, columns, columnCount, token, aligns, t, tableLines, tbodyLines;
    // should have at least two lines
    if (startLine + 2 > endLine) return false;
    nextLine = startLine + 1;
    if (state.sCount[nextLine] < state.blkIndent) return false;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[nextLine] - state.blkIndent >= 4) return false;
    // first character of the second line should be '|', '-', ':',
    // and no other characters are allowed but spaces;
    // basically, this is the equivalent of /^[-:|][-:|\s]*$/ regexp
    pos = state.bMarks[nextLine] + state.tShift[nextLine];
    if (pos >= state.eMarks[nextLine]) return false;
    ch = state.src.charCodeAt(pos++);
    if (ch !== 0x7c /* | */  && ch !== 0x2d /* - */  && ch !== 0x3a /* : */ ) return false;
    while(pos < state.eMarks[nextLine]){
        ch = state.src.charCodeAt(pos);
        if (ch !== 0x7c /* | */  && ch !== 0x2d /* - */  && ch !== 0x3a /* : */  && !$a0892a9f119b1133$var$isSpace(ch)) return false;
        pos++;
    }
    lineText = $a0892a9f119b1133$var$getLine(state, startLine + 1);
    columns = lineText.split('|');
    aligns = [];
    for(i = 0; i < columns.length; i++){
        t = columns[i].trim();
        if (!t) {
            // allow empty columns before and after table, but not in between columns;
            // e.g. allow ` |---| `, disallow ` ---||--- `
            if (i === 0 || i === columns.length - 1) continue;
            else return false;
        }
        if (!/^:?-+:?$/.test(t)) return false;
        if (t.charCodeAt(t.length - 1) === 0x3a /* : */ ) aligns.push(t.charCodeAt(0) === 0x3a /* : */  ? 'center' : 'right');
        else if (t.charCodeAt(0) === 0x3a /* : */ ) aligns.push('left');
        else aligns.push('');
    }
    lineText = $a0892a9f119b1133$var$getLine(state, startLine).trim();
    if (lineText.indexOf('|') === -1) return false;
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    columns = $a0892a9f119b1133$var$escapedSplit(lineText.replace(/^\||\|$/g, ''));
    // header row will define an amount of columns in the entire table,
    // and align row shouldn't be smaller than that (the rest of the rows can)
    columnCount = columns.length;
    if (columnCount > aligns.length) return false;
    if (silent) return true;
    token = state.push('table_open', 'table', 1);
    token.map = tableLines = [
        startLine,
        0
    ];
    // token     = state.push('thead_open', 'thead', 1);
    // token.map = [ startLine, startLine + 1 ];
    token = state.push('tr_open', 'tr', 1);
    token.map = [
        startLine,
        startLine + 1
    ];
    for(i = 0; i < columns.length; i++){
        token = state.push('th_open', 'th', 1);
        token.map = [
            startLine,
            startLine + 1
        ];
        if (aligns[i]) token.attrs = [
            [
                'style',
                'text-align:' + aligns[i]
            ]
        ];
        token = state.push('paragraph_open', 'p', 1);
        token = state.push('inline', '', 0);
        token.content = columns[i].trim();
        token.map = [
            startLine,
            startLine + 1
        ];
        token.children = [];
        token = state.push('paragraph_close', 'p', -1);
        token = state.push('th_close', 'th', -1);
    }
    token = state.push('tr_close', 'tr', -1);
    // token     = state.push('thead_close', 'thead', -1);
    // token     = state.push('tbody_open', 'tbody', 1);
    token.map = tbodyLines = [
        startLine + 2,
        0
    ];
    var oldLineMax = state.lineMax;
    for(nextLine = startLine + 2; nextLine < endLine; nextLine++){
        if (state.sCount[nextLine] < state.blkIndent) break;
        lineText = $a0892a9f119b1133$var$getLine(state, nextLine).trim();
        if (lineText.indexOf('|') === -1) break;
        if (state.sCount[nextLine] - state.blkIndent >= 4) break;
        columns = $a0892a9f119b1133$var$escapedSplit(lineText.replace(/^\||\|$/g, ''));
        token = state.push('tr_open', 'tr', 1);
        for(var _i = 0, offset = 1; _i < columns.length; _i++){
            token = state.push('td_open', 'td', 1);
            if (aligns[_i]) token.attrs = [
                [
                    'style',
                    'text-align:' + aligns[_i]
                ]
            ];
            // https://github.com/markdown-it/markdown-it/blob/e6f19eab4204122e85e4a342e0c1c8486ff40c2d/lib/rules_block/state_block.js#L25
            // bMarks => line begin offsets for fast jumps
            // eMarks => line end offsets for fast jumps
            // tShift => offsets of the first non-space characters (tabs not expanded)
            // sCount => indents for each line (tabs expanded)
            // Move bMarks when first char is ' ' for > to work
            var shift = columns[_i][0] === ' ' || /^(\d+\.|\*|-)$/.test(columns[_i].trim()) ? 1 : 0;
            state.bMarks[nextLine] += offset + shift;
            offset = (columns[_i] || '').length + (shift ? 0 : 1);
            state.eMarks[nextLine] = state.bMarks[nextLine] + offset - 1;
            state.lineMax = 1;
            state.md.block.tokenize(state, nextLine, nextLine + 1);
            token = state.push('td_close', 'td', -1);
        }
        token = state.push('tr_close', 'tr', -1);
    }
    // token = state.push('tbody_close', 'tbody', -1);
    state.lineMax = oldLineMax;
    token = state.push('table_close', 'table', -1);
    tableLines[1] = tbodyLines[1] = nextLine;
    state.line = nextLine;
    return true;
};

});


parcelRegister("8AXx4", function(module, exports) {

$parcel$export(module.exports, "MarkdownParser", () => $641fdd6fa7cf2027$export$a64f782182dea128);
$parcel$export(module.exports, "MarkdownSerializer", () => $641fdd6fa7cf2027$export$ae9f6f04acb6c60c);
$parcel$export(module.exports, "MarkdownSerializerState", () => $641fdd6fa7cf2027$export$61055fa707e69319);

var $3xw6l = parcelRequire("3xw6l");

var $cciZy = parcelRequire("cciZy");
/**
Document schema for the data model used by CommonMark.
*/ const $641fdd6fa7cf2027$export$4902baddc787debb = new (0, $3xw6l.Schema)({
    nodes: {
        doc: {
            content: "block+"
        },
        paragraph: {
            content: "inline*",
            group: "block",
            parseDOM: [
                {
                    tag: "p"
                }
            ],
            toDOM () {
                return [
                    "p",
                    0
                ];
            }
        },
        blockquote: {
            content: "block+",
            group: "block",
            parseDOM: [
                {
                    tag: "blockquote"
                }
            ],
            toDOM () {
                return [
                    "blockquote",
                    0
                ];
            }
        },
        horizontal_rule: {
            group: "block",
            parseDOM: [
                {
                    tag: "hr"
                }
            ],
            toDOM () {
                return [
                    "div",
                    [
                        "hr"
                    ]
                ];
            }
        },
        heading: {
            attrs: {
                level: {
                    default: 1
                }
            },
            content: "(text | image)*",
            group: "block",
            defining: true,
            parseDOM: [
                {
                    tag: "h1",
                    attrs: {
                        level: 1
                    }
                },
                {
                    tag: "h2",
                    attrs: {
                        level: 2
                    }
                },
                {
                    tag: "h3",
                    attrs: {
                        level: 3
                    }
                },
                {
                    tag: "h4",
                    attrs: {
                        level: 4
                    }
                },
                {
                    tag: "h5",
                    attrs: {
                        level: 5
                    }
                },
                {
                    tag: "h6",
                    attrs: {
                        level: 6
                    }
                }
            ],
            toDOM (node) {
                return [
                    "h" + node.attrs.level,
                    0
                ];
            }
        },
        code_block: {
            content: "text*",
            group: "block",
            code: true,
            defining: true,
            marks: "",
            attrs: {
                params: {
                    default: ""
                }
            },
            parseDOM: [
                {
                    tag: "pre",
                    preserveWhitespace: "full",
                    getAttrs: (node)=>({
                            params: node.getAttribute("data-params") || ""
                        })
                }
            ],
            toDOM (node) {
                return [
                    "pre",
                    node.attrs.params ? {
                        "data-params": node.attrs.params
                    } : {},
                    [
                        "code",
                        0
                    ]
                ];
            }
        },
        ordered_list: {
            content: "list_item+",
            group: "block",
            attrs: {
                order: {
                    default: 1
                },
                tight: {
                    default: false
                }
            },
            parseDOM: [
                {
                    tag: "ol",
                    getAttrs (dom) {
                        return {
                            order: dom.hasAttribute("start") ? +dom.getAttribute("start") : 1,
                            tight: dom.hasAttribute("data-tight")
                        };
                    }
                }
            ],
            toDOM (node) {
                return [
                    "ol",
                    {
                        start: node.attrs.order == 1 ? null : node.attrs.order,
                        "data-tight": node.attrs.tight ? "true" : null
                    },
                    0
                ];
            }
        },
        bullet_list: {
            content: "list_item+",
            group: "block",
            attrs: {
                tight: {
                    default: false
                }
            },
            parseDOM: [
                {
                    tag: "ul",
                    getAttrs: (dom)=>({
                            tight: dom.hasAttribute("data-tight")
                        })
                }
            ],
            toDOM (node) {
                return [
                    "ul",
                    {
                        "data-tight": node.attrs.tight ? "true" : null
                    },
                    0
                ];
            }
        },
        list_item: {
            content: "block+",
            defining: true,
            parseDOM: [
                {
                    tag: "li"
                }
            ],
            toDOM () {
                return [
                    "li",
                    0
                ];
            }
        },
        text: {
            group: "inline"
        },
        image: {
            inline: true,
            attrs: {
                src: {},
                alt: {
                    default: null
                },
                title: {
                    default: null
                }
            },
            group: "inline",
            draggable: true,
            parseDOM: [
                {
                    tag: "img[src]",
                    getAttrs (dom) {
                        return {
                            src: dom.getAttribute("src"),
                            title: dom.getAttribute("title"),
                            alt: dom.getAttribute("alt")
                        };
                    }
                }
            ],
            toDOM (node) {
                return [
                    "img",
                    node.attrs
                ];
            }
        },
        hard_break: {
            inline: true,
            group: "inline",
            selectable: false,
            parseDOM: [
                {
                    tag: "br"
                }
            ],
            toDOM () {
                return [
                    "br"
                ];
            }
        }
    },
    marks: {
        em: {
            parseDOM: [
                {
                    tag: "i"
                },
                {
                    tag: "em"
                },
                {
                    style: "font-style=italic"
                },
                {
                    style: "font-style=normal",
                    clearMark: (m)=>m.type.name == "em"
                }
            ],
            toDOM () {
                return [
                    "em"
                ];
            }
        },
        strong: {
            parseDOM: [
                {
                    tag: "strong"
                },
                {
                    tag: "b",
                    getAttrs: (node)=>node.style.fontWeight != "normal" && null
                },
                {
                    style: "font-weight=400",
                    clearMark: (m)=>m.type.name == "strong"
                },
                {
                    style: "font-weight",
                    getAttrs: (value)=>/^(bold(er)?|[5-9]\d{2,})$/.test(value) && null
                }
            ],
            toDOM () {
                return [
                    "strong"
                ];
            }
        },
        link: {
            attrs: {
                href: {},
                title: {
                    default: null
                }
            },
            inclusive: false,
            parseDOM: [
                {
                    tag: "a[href]",
                    getAttrs (dom) {
                        return {
                            href: dom.getAttribute("href"),
                            title: dom.getAttribute("title")
                        };
                    }
                }
            ],
            toDOM (node) {
                return [
                    "a",
                    node.attrs
                ];
            }
        },
        code: {
            parseDOM: [
                {
                    tag: "code"
                }
            ],
            toDOM () {
                return [
                    "code"
                ];
            }
        }
    }
});
// @ts-ignore
function $641fdd6fa7cf2027$var$maybeMerge(a, b) {
    if (a.isText && b.isText && (0, $3xw6l.Mark).sameSet(a.marks, b.marks)) return a.withText(a.text + b.text);
}
// Object used to track the context of a running parse.
class $641fdd6fa7cf2027$var$MarkdownParseState {
    constructor(schema, tokenHandlers){
        this.schema = schema;
        this.tokenHandlers = tokenHandlers;
        this.stack = [
            {
                type: schema.topNodeType,
                attrs: null,
                content: [],
                marks: (0, $3xw6l.Mark).none
            }
        ];
    }
    top() {
        return this.stack[this.stack.length - 1];
    }
    push(elt) {
        if (this.stack.length) this.top().content.push(elt);
    }
    // Adds the given text to the current position in the document,
    // using the current marks as styling.
    addText(text) {
        if (!text) return;
        let top = this.top(), nodes = top.content, last = nodes[nodes.length - 1];
        let node = this.schema.text(text, top.marks), merged;
        if (last && (merged = $641fdd6fa7cf2027$var$maybeMerge(last, node))) nodes[nodes.length - 1] = merged;
        else nodes.push(node);
    }
    // Adds the given mark to the set of active marks.
    openMark(mark) {
        let top = this.top();
        top.marks = mark.addToSet(top.marks);
    }
    // Removes the given mark from the set of active marks.
    closeMark(mark) {
        let top = this.top();
        top.marks = mark.removeFromSet(top.marks);
    }
    parseTokens(toks) {
        for(let i = 0; i < toks.length; i++){
            let tok = toks[i];
            let handler = this.tokenHandlers[tok.type];
            if (!handler) throw new Error("Token type `" + tok.type + "` not supported by Markdown parser");
            handler(this, tok, toks, i);
        }
    }
    // Add a node at the current position.
    addNode(type, attrs, content) {
        let top = this.top();
        let node = type.createAndFill(attrs, content, top ? top.marks : []);
        if (!node) return null;
        this.push(node);
        return node;
    }
    // Wrap subsequent content in a node of the given type.
    openNode(type, attrs) {
        this.stack.push({
            type: type,
            attrs: attrs,
            content: [],
            marks: (0, $3xw6l.Mark).none
        });
    }
    // Close and return the node that is currently on top of the stack.
    closeNode() {
        let info = this.stack.pop();
        return this.addNode(info.type, info.attrs, info.content);
    }
}
function $641fdd6fa7cf2027$var$attrs(spec, token, tokens, i) {
    if (spec.getAttrs) return spec.getAttrs(token, tokens, i);
    else if (spec.attrs instanceof Function) return spec.attrs(token);
    else return spec.attrs;
}
// Code content is represented as a single token with a `content`
// property in Markdown-it.
function $641fdd6fa7cf2027$var$noCloseToken(spec, type) {
    return spec.noCloseToken || type == "code_inline" || type == "code_block" || type == "fence";
}
function $641fdd6fa7cf2027$var$withoutTrailingNewline(str) {
    return str[str.length - 1] == "\n" ? str.slice(0, str.length - 1) : str;
}
function $641fdd6fa7cf2027$var$noOp() {}
function $641fdd6fa7cf2027$var$tokenHandlers(schema, tokens) {
    let handlers = Object.create(null);
    for(let type in tokens){
        let spec = tokens[type];
        if (spec.block) {
            let nodeType = schema.nodeType(spec.block);
            if ($641fdd6fa7cf2027$var$noCloseToken(spec, type)) handlers[type] = (state, tok, tokens, i)=>{
                state.openNode(nodeType, $641fdd6fa7cf2027$var$attrs(spec, tok, tokens, i));
                state.addText($641fdd6fa7cf2027$var$withoutTrailingNewline(tok.content));
                state.closeNode();
            };
            else {
                handlers[type + "_open"] = (state, tok, tokens, i)=>state.openNode(nodeType, $641fdd6fa7cf2027$var$attrs(spec, tok, tokens, i));
                handlers[type + "_close"] = (state)=>state.closeNode();
            }
        } else if (spec.node) {
            let nodeType = schema.nodeType(spec.node);
            handlers[type] = (state, tok, tokens, i)=>state.addNode(nodeType, $641fdd6fa7cf2027$var$attrs(spec, tok, tokens, i));
        } else if (spec.mark) {
            let markType = schema.marks[spec.mark];
            if ($641fdd6fa7cf2027$var$noCloseToken(spec, type)) handlers[type] = (state, tok, tokens, i)=>{
                state.openMark(markType.create($641fdd6fa7cf2027$var$attrs(spec, tok, tokens, i)));
                state.addText($641fdd6fa7cf2027$var$withoutTrailingNewline(tok.content));
                state.closeMark(markType);
            };
            else {
                handlers[type + "_open"] = (state, tok, tokens, i)=>state.openMark(markType.create($641fdd6fa7cf2027$var$attrs(spec, tok, tokens, i)));
                handlers[type + "_close"] = (state)=>state.closeMark(markType);
            }
        } else if (spec.ignore) {
            if ($641fdd6fa7cf2027$var$noCloseToken(spec, type)) handlers[type] = $641fdd6fa7cf2027$var$noOp;
            else {
                handlers[type + "_open"] = $641fdd6fa7cf2027$var$noOp;
                handlers[type + "_close"] = $641fdd6fa7cf2027$var$noOp;
            }
        } else throw new RangeError("Unrecognized parsing spec " + JSON.stringify(spec));
    }
    handlers.text = (state, tok)=>state.addText(tok.content);
    handlers.inline = (state, tok)=>state.parseTokens(tok.children);
    handlers.softbreak = handlers.softbreak || ((state)=>state.addText(" "));
    return handlers;
}
/**
A configuration of a Markdown parser. Such a parser uses
[markdown-it](https://github.com/markdown-it/markdown-it) to
tokenize a file, and then runs the custom rules it is given over
the tokens to create a ProseMirror document tree.
*/ class $641fdd6fa7cf2027$export$a64f782182dea128 {
    /**
    Create a parser with the given configuration. You can configure
    the markdown-it parser to parse the dialect you want, and provide
    a description of the ProseMirror entities those tokens map to in
    the `tokens` object, which maps token names to descriptions of
    what to do with them. Such a description is an object, and may
    have the following properties:
    */ constructor(/**
    The parser's document schema.
    */ schema, /**
    This parser's markdown-it tokenizer.
    */ tokenizer, /**
    The value of the `tokens` object used to construct this
    parser. Can be useful to copy and modify to base other parsers
    on.
    */ tokens){
        this.schema = schema;
        this.tokenizer = tokenizer;
        this.tokens = tokens;
        this.tokenHandlers = $641fdd6fa7cf2027$var$tokenHandlers(schema, tokens);
    }
    /**
    Parse a string as [CommonMark](http://commonmark.org/) markup,
    and create a ProseMirror document as prescribed by this parser's
    rules.
    
    The second argument, when given, is passed through to the
    [Markdown
    parser](https://markdown-it.github.io/markdown-it/#MarkdownIt.parse).
    */ parse(text, markdownEnv = {}) {
        let state = new $641fdd6fa7cf2027$var$MarkdownParseState(this.schema, this.tokenHandlers), doc;
        state.parseTokens(this.tokenizer.parse(text, markdownEnv));
        do doc = state.closeNode();
        while (state.stack.length);
        return doc || this.schema.topNodeType.createAndFill();
    }
}
function $641fdd6fa7cf2027$var$listIsTight(tokens, i) {
    while(++i < tokens.length)if (tokens[i].type != "list_item_open") return tokens[i].hidden;
    return false;
}
/**
A parser parsing unextended [CommonMark](http://commonmark.org/),
without inline HTML, and producing a document in the basic schema.
*/ const $641fdd6fa7cf2027$export$7517583227ad0cb8 = new $641fdd6fa7cf2027$export$a64f782182dea128($641fdd6fa7cf2027$export$4902baddc787debb, (0, (/*@__PURE__*/$parcel$interopDefault($cciZy)))("commonmark", {
    html: false
}), {
    blockquote: {
        block: "blockquote"
    },
    paragraph: {
        block: "paragraph"
    },
    list_item: {
        block: "list_item"
    },
    bullet_list: {
        block: "bullet_list",
        getAttrs: (_, tokens, i)=>({
                tight: $641fdd6fa7cf2027$var$listIsTight(tokens, i)
            })
    },
    ordered_list: {
        block: "ordered_list",
        getAttrs: (tok, tokens, i)=>({
                order: +tok.attrGet("start") || 1,
                tight: $641fdd6fa7cf2027$var$listIsTight(tokens, i)
            })
    },
    heading: {
        block: "heading",
        getAttrs: (tok)=>({
                level: +tok.tag.slice(1)
            })
    },
    code_block: {
        block: "code_block",
        noCloseToken: true
    },
    fence: {
        block: "code_block",
        getAttrs: (tok)=>({
                params: tok.info || ""
            }),
        noCloseToken: true
    },
    hr: {
        node: "horizontal_rule"
    },
    image: {
        node: "image",
        getAttrs: (tok)=>({
                src: tok.attrGet("src"),
                title: tok.attrGet("title") || null,
                alt: tok.children[0] && tok.children[0].content || null
            })
    },
    hardbreak: {
        node: "hard_break"
    },
    em: {
        mark: "em"
    },
    strong: {
        mark: "strong"
    },
    link: {
        mark: "link",
        getAttrs: (tok)=>({
                href: tok.attrGet("href"),
                title: tok.attrGet("title") || null
            })
    },
    code_inline: {
        mark: "code",
        noCloseToken: true
    }
});
const $641fdd6fa7cf2027$var$blankMark = {
    open: "",
    close: "",
    mixable: true
};
/**
A specification for serializing a ProseMirror document as
Markdown/CommonMark text.
*/ class $641fdd6fa7cf2027$export$ae9f6f04acb6c60c {
    /**
    Construct a serializer with the given configuration. The `nodes`
    object should map node names in a given schema to function that
    take a serializer state and such a node, and serialize the node.
    */ constructor(/**
    The node serializer functions for this serializer.
    */ nodes, /**
    The mark serializer info.
    */ marks, options = {}){
        this.nodes = nodes;
        this.marks = marks;
        this.options = options;
    }
    /**
    Serialize the content of the given node to
    [CommonMark](http://commonmark.org/).
    */ serialize(content, options = {}) {
        options = Object.assign({}, this.options, options);
        let state = new $641fdd6fa7cf2027$export$61055fa707e69319(this.nodes, this.marks, options);
        state.renderContent(content);
        return state.out;
    }
}
/**
A serializer for the [basic schema](https://prosemirror.net/docs/ref/#schema).
*/ const $641fdd6fa7cf2027$export$f996452ca6e9a0ae = new $641fdd6fa7cf2027$export$ae9f6f04acb6c60c({
    blockquote (state, node) {
        state.wrapBlock("> ", null, node, ()=>state.renderContent(node));
    },
    code_block (state, node) {
        // Make sure the front matter fences are longer than any dash sequence within it
        const backticks = node.textContent.match(/`{3,}/gm);
        const fence = backticks ? backticks.sort().slice(-1)[0] + "`" : "```";
        state.write(fence + (node.attrs.params || "") + "\n");
        state.text(node.textContent, false);
        // Add a newline to the current content before adding closing marker
        state.write("\n");
        state.write(fence);
        state.closeBlock(node);
    },
    heading (state, node) {
        state.write(state.repeat("#", node.attrs.level) + " ");
        state.renderInline(node, false);
        state.closeBlock(node);
    },
    horizontal_rule (state, node) {
        state.write(node.attrs.markup || "---");
        state.closeBlock(node);
    },
    bullet_list (state, node) {
        state.renderList(node, "  ", ()=>(node.attrs.bullet || "*") + " ");
    },
    ordered_list (state, node) {
        let start = node.attrs.order || 1;
        let maxW = String(start + node.childCount - 1).length;
        let space = state.repeat(" ", maxW + 2);
        state.renderList(node, space, (i)=>{
            let nStr = String(start + i);
            return state.repeat(" ", maxW - nStr.length) + nStr + ". ";
        });
    },
    list_item (state, node) {
        state.renderContent(node);
    },
    paragraph (state, node) {
        state.renderInline(node);
        state.closeBlock(node);
    },
    image (state, node) {
        state.write("![" + state.esc(node.attrs.alt || "") + "](" + node.attrs.src.replace(/[\(\)]/g, "\\$&") + (node.attrs.title ? ' "' + node.attrs.title.replace(/"/g, '\\"') + '"' : "") + ")");
    },
    hard_break (state, node, parent, index) {
        for(let i = index + 1; i < parent.childCount; i++)if (parent.child(i).type != node.type) {
            state.write("\\\n");
            return;
        }
    },
    text (state, node) {
        state.text(node.text, !state.inAutolink);
    }
}, {
    em: {
        open: "*",
        close: "*",
        mixable: true,
        expelEnclosingWhitespace: true
    },
    strong: {
        open: "**",
        close: "**",
        mixable: true,
        expelEnclosingWhitespace: true
    },
    link: {
        open (state, mark, parent, index) {
            state.inAutolink = $641fdd6fa7cf2027$var$isPlainURL(mark, parent, index);
            return state.inAutolink ? "<" : "[";
        },
        close (state, mark, parent, index) {
            let { inAutolink: inAutolink } = state;
            state.inAutolink = undefined;
            return inAutolink ? ">" : "](" + mark.attrs.href.replace(/[\(\)"]/g, "\\$&") + (mark.attrs.title ? ` "${mark.attrs.title.replace(/"/g, '\\"')}"` : "") + ")";
        },
        mixable: true
    },
    code: {
        open (_state, _mark, parent, index) {
            return $641fdd6fa7cf2027$var$backticksFor(parent.child(index), -1);
        },
        close (_state, _mark, parent, index) {
            return $641fdd6fa7cf2027$var$backticksFor(parent.child(index - 1), 1);
        },
        escape: false
    }
});
function $641fdd6fa7cf2027$var$backticksFor(node, side) {
    let ticks = /`+/g, m, len = 0;
    if (node.isText) while(m = ticks.exec(node.text))len = Math.max(len, m[0].length);
    let result = len > 0 && side > 0 ? " `" : "`";
    for(let i = 0; i < len; i++)result += "`";
    if (len > 0 && side < 0) result += " ";
    return result;
}
function $641fdd6fa7cf2027$var$isPlainURL(link, parent, index) {
    if (link.attrs.title || !/^\w+:/.test(link.attrs.href)) return false;
    let content = parent.child(index);
    if (!content.isText || content.text != link.attrs.href || content.marks[content.marks.length - 1] != link) return false;
    return index == parent.childCount - 1 || !link.isInSet(parent.child(index + 1).marks);
}
/**
This is an object used to track state and expose
methods related to markdown serialization. Instances are passed to
node and mark serialization methods (see `toMarkdown`).
*/ class $641fdd6fa7cf2027$export$61055fa707e69319 {
    /**
    @internal
    */ constructor(/**
    @internal
    */ nodes, /**
    @internal
    */ marks, /**
    The options passed to the serializer.
    */ options){
        this.nodes = nodes;
        this.marks = marks;
        this.options = options;
        /**
        @internal
        */ this.delim = "";
        /**
        @internal
        */ this.out = "";
        /**
        @internal
        */ this.closed = null;
        /**
        @internal
        */ this.inAutolink = undefined;
        /**
        @internal
        */ this.atBlockStart = false;
        /**
        @internal
        */ this.inTightList = false;
        if (typeof this.options.tightLists == "undefined") this.options.tightLists = false;
        if (typeof this.options.hardBreakNodeName == "undefined") this.options.hardBreakNodeName = "hard_break";
    }
    /**
    @internal
    */ flushClose(size = 2) {
        if (this.closed) {
            if (!this.atBlank()) this.out += "\n";
            if (size > 1) {
                let delimMin = this.delim;
                let trim = /\s+$/.exec(delimMin);
                if (trim) delimMin = delimMin.slice(0, delimMin.length - trim[0].length);
                for(let i = 1; i < size; i++)this.out += delimMin + "\n";
            }
            this.closed = null;
        }
    }
    /**
    @internal
    */ getMark(name) {
        let info = this.marks[name];
        if (!info) {
            if (this.options.strict !== false) throw new Error(`Mark type \`${name}\` not supported by Markdown renderer`);
            info = $641fdd6fa7cf2027$var$blankMark;
        }
        return info;
    }
    /**
    Render a block, prefixing each line with `delim`, and the first
    line in `firstDelim`. `node` should be the node that is closed at
    the end of the block, and `f` is a function that renders the
    content of the block.
    */ wrapBlock(delim, firstDelim, node, f) {
        let old = this.delim;
        this.write(firstDelim != null ? firstDelim : delim);
        this.delim += delim;
        f();
        this.delim = old;
        this.closeBlock(node);
    }
    /**
    @internal
    */ atBlank() {
        return /(^|\n)$/.test(this.out);
    }
    /**
    Ensure the current content ends with a newline.
    */ ensureNewLine() {
        if (!this.atBlank()) this.out += "\n";
    }
    /**
    Prepare the state for writing output (closing closed paragraphs,
    adding delimiters, and so on), and then optionally add content
    (unescaped) to the output.
    */ write(content) {
        this.flushClose();
        if (this.delim && this.atBlank()) this.out += this.delim;
        if (content) this.out += content;
    }
    /**
    Close the block for the given node.
    */ closeBlock(node) {
        this.closed = node;
    }
    /**
    Add the given text to the document. When escape is not `false`,
    it will be escaped.
    */ text(text, escape = true) {
        let lines = text.split("\n");
        for(let i = 0; i < lines.length; i++){
            this.write();
            // Escape exclamation marks in front of links
            if (!escape && lines[i][0] == "[" && /(^|[^\\])\!$/.test(this.out)) this.out = this.out.slice(0, this.out.length - 1) + "\\!";
            this.out += escape ? this.esc(lines[i], this.atBlockStart) : lines[i];
            if (i != lines.length - 1) this.out += "\n";
        }
    }
    /**
    Render the given node as a block.
    */ render(node, parent, index) {
        if (this.nodes[node.type.name]) this.nodes[node.type.name](this, node, parent, index);
        else {
            if (this.options.strict !== false) throw new Error("Token type `" + node.type.name + "` not supported by Markdown renderer");
            else if (!node.type.isLeaf) {
                if (node.type.inlineContent) this.renderInline(node);
                else this.renderContent(node);
                if (node.isBlock) this.closeBlock(node);
            }
        }
    }
    /**
    Render the contents of `parent` as block nodes.
    */ renderContent(parent) {
        parent.forEach((node, _, i)=>this.render(node, parent, i));
    }
    /**
    Render the contents of `parent` as inline content.
    */ renderInline(parent, fromBlockStart = true) {
        this.atBlockStart = fromBlockStart;
        let active = [], trailing = "";
        let progress = (node, offset, index)=>{
            let marks = node ? node.marks : [];
            // Remove marks from `hard_break` that are the last node inside
            // that mark to prevent parser edge cases with new lines just
            // before closing marks.
            if (node && node.type.name === this.options.hardBreakNodeName) marks = marks.filter((m)=>{
                if (index + 1 == parent.childCount) return false;
                let next = parent.child(index + 1);
                return m.isInSet(next.marks) && (!next.isText || /\S/.test(next.text));
            });
            let leading = trailing;
            trailing = "";
            // If whitespace has to be expelled from the node, adjust
            // leading and trailing accordingly.
            if (node && node.isText && marks.some((mark)=>{
                let info = this.getMark(mark.type.name);
                return info && info.expelEnclosingWhitespace && !mark.isInSet(active);
            })) {
                let [_, lead, rest] = /^(\s*)(.*)$/m.exec(node.text);
                if (lead) {
                    leading += lead;
                    node = rest ? node.withText(rest) : null;
                    if (!node) marks = active;
                }
            }
            if (node && node.isText && marks.some((mark)=>{
                let info = this.getMark(mark.type.name);
                return info && info.expelEnclosingWhitespace && (index == parent.childCount - 1 || !mark.isInSet(parent.child(index + 1).marks));
            })) {
                let [_, rest, trail] = /^(.*?)(\s*)$/m.exec(node.text);
                if (trail) {
                    trailing = trail;
                    node = rest ? node.withText(rest) : null;
                    if (!node) marks = active;
                }
            }
            let inner = marks.length ? marks[marks.length - 1] : null;
            let noEsc = inner && this.getMark(inner.type.name).escape === false;
            let len = marks.length - (noEsc ? 1 : 0);
            // Try to reorder 'mixable' marks, such as em and strong, which
            // in Markdown may be opened and closed in different order, so
            // that order of the marks for the token matches the order in
            // active.
            outer: for(let i = 0; i < len; i++){
                let mark = marks[i];
                if (!this.getMark(mark.type.name).mixable) break;
                for(let j = 0; j < active.length; j++){
                    let other = active[j];
                    if (!this.getMark(other.type.name).mixable) break;
                    if (mark.eq(other)) {
                        if (i > j) marks = marks.slice(0, j).concat(mark).concat(marks.slice(j, i)).concat(marks.slice(i + 1, len));
                        else if (j > i) marks = marks.slice(0, i).concat(marks.slice(i + 1, j)).concat(mark).concat(marks.slice(j, len));
                        continue outer;
                    }
                }
            }
            // Find the prefix of the mark set that didn't change
            let keep = 0;
            while(keep < Math.min(active.length, len) && marks[keep].eq(active[keep]))++keep;
            // Close the marks that need to be closed
            while(keep < active.length)this.text(this.markString(active.pop(), false, parent, index), false);
            // Output any previously expelled trailing whitespace outside the marks
            if (leading) this.text(leading);
            // Open the marks that need to be opened
            if (node) {
                while(active.length < len){
                    let add = marks[active.length];
                    active.push(add);
                    this.text(this.markString(add, true, parent, index), false);
                    this.atBlockStart = false;
                }
                // Render the node. Special case code marks, since their content
                // may not be escaped.
                if (noEsc && node.isText) this.text(this.markString(inner, true, parent, index) + node.text + this.markString(inner, false, parent, index + 1), false);
                else this.render(node, parent, index);
                this.atBlockStart = false;
            }
            // After the first non-empty text node is rendered, the end of output
            // is no longer at block start.
            //
            // FIXME: If a non-text node writes something to the output for this
            // block, the end of output is also no longer at block start. But how
            // can we detect that?
            if ((node === null || node === void 0 ? void 0 : node.isText) && node.nodeSize > 0) this.atBlockStart = false;
        };
        parent.forEach(progress);
        progress(null, 0, parent.childCount);
        this.atBlockStart = false;
    }
    /**
    Render a node's content as a list. `delim` should be the extra
    indentation added to all lines except the first in an item,
    `firstDelim` is a function going from an item index to a
    delimiter for the first line of the item.
    */ renderList(node, delim, firstDelim) {
        if (this.closed && this.closed.type == node.type) this.flushClose(3);
        else if (this.inTightList) this.flushClose(1);
        let isTight = typeof node.attrs.tight != "undefined" ? node.attrs.tight : this.options.tightLists;
        let prevTight = this.inTightList;
        this.inTightList = isTight;
        node.forEach((child, _, i)=>{
            if (i && isTight) this.flushClose(1);
            this.wrapBlock(delim, firstDelim(i), node, ()=>this.render(child, node, i));
        });
        this.inTightList = prevTight;
    }
    /**
    Escape the given string so that it can safely appear in Markdown
    content. If `startOfLine` is true, also escape characters that
    have special meaning only at the start of the line.
    */ esc(str, startOfLine = false) {
        str = str.replace(/[`*\\~\[\]_]/g, (m, i)=>m == "_" && i > 0 && i + 1 < str.length && str[i - 1].match(/\w/) && str[i + 1].match(/\w/) ? m : "\\" + m);
        if (startOfLine) str = str.replace(/^(\+[ ]|[\-*>])/, "\\$&").replace(/^(\s*)(#{1,6})(\s|$)/, '$1\\$2$3').replace(/^(\s*\d+)\.\s/, "$1\\. ");
        if (this.options.escapeExtraCharacters) str = str.replace(this.options.escapeExtraCharacters, "\\$&");
        return str;
    }
    /**
    @internal
    */ quote(str) {
        let wrap = str.indexOf('"') == -1 ? '""' : str.indexOf("'") == -1 ? "''" : "()";
        return wrap[0] + str + wrap[1];
    }
    /**
    Repeat the given string `n` times.
    */ repeat(str, n) {
        let out = "";
        for(let i = 0; i < n; i++)out += str;
        return out;
    }
    /**
    Get the markdown string for a given opening or closing mark.
    */ markString(mark, open, parent, index) {
        let info = this.getMark(mark.type.name);
        let value = open ? info.open : info.close;
        return typeof value == "string" ? value : value(this, mark, parent, index);
    }
    /**
    Get leading and trailing whitespace from a string. Values of
    leading or trailing property of the return object will be undefined
    if there is no match.
    */ getEnclosingWhitespace(text) {
        return {
            leading: (text.match(/^(\s+)/) || [
                undefined
            ])[0],
            trailing: (text.match(/(\s+)$/) || [
                undefined
            ])[0]
        };
    }
}

});

parcelRegister("eyCU5", function(module, exports) {

$parcel$export(module.exports, "markdownItMedia", () => $8cff57ddc400605b$export$c8dcbd316b71f8cf);
function $8cff57ddc400605b$var$createRule() {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const regx = /!\[([^\]]*)\]\(([^)]*?)\s*(?:"([^")]*)"\s*)?\)/g;
    const validParentTokens = [
        'th_open',
        'td_open',
        'list_item_open',
        'blockquote_open'
    ];
    /**
	 * This function looks for strings that matches ![description](url) inside Inline-tokens.
	 * It will then split the Inline-token with content before and after the image, example:
	 *
	 * Input (tokens):
	 *   paragraph_open
	 *   inline - content: Hello ![](image.jpg) World!
	 *   paragraph_close
	 * Output (tokens):
	 *   paragraph_open
	 *   inline - content: Hello
	 *   paragraph_close
	 *   media_single_open
	 *   media
	 *   media_single_close
	 *   paragraph_open
	 *   inline - content: World!
	 *   paragraph_close
	 *
	 * This is applied before the inline content is parsed, to ensure that the formatting of
	 * remaining inline content (bold, links, etc.) is kept intact!
	 */ return function media(State) {
        const getUrl = (str)=>{
            const res = State.md.helpers.parseLinkDestination(str, str.indexOf('(') + 1, str.length);
            if (res.ok) {
                const href = State.md.normalizeLink(res.str);
                if (State.md.validateLink(href)) return href;
            }
            return '';
        };
        const createMediaTokens = (url, alt = '')=>{
            const mediaSingleOpen = new State.Token('media_single_open', '', 1);
            const media = new State.Token('media', '', 0);
            media.attrs = [
                [
                    'url',
                    getUrl(url)
                ],
                [
                    'type',
                    'external'
                ],
                [
                    'alt',
                    alt
                ]
            ];
            const mediaSingleClose = new State.Token('media_single_close', '', -1);
            return [
                mediaSingleOpen,
                media,
                mediaSingleClose
            ];
        };
        const createInlineTokens = (str, openingTokens, closingTokens)=>{
            if (!str || str.length === 0) return [];
            const inlineBefore = new State.Token('inline', '', 1);
            inlineBefore.content = str;
            inlineBefore.children = [];
            return [
                ...openingTokens,
                inlineBefore,
                ...closingTokens
            ];
        };
        let processedTokens = [];
        const newTokens = State.tokens.reduce((tokens, token, i, arr)=>{
            const matchAll = Array.from(token.content.matchAll(regx));
            if (token.type === 'inline' && matchAll.length) {
                const openingTokens = [];
                let cursor = i - 1;
                let previousToken = arr[cursor];
                let subTree = [];
                while(previousToken && previousToken.level > 0 && validParentTokens.indexOf(previousToken.type) === -1){
                    openingTokens.unshift(previousToken);
                    cursor--;
                    previousToken = arr[cursor];
                }
                if (validParentTokens.indexOf(previousToken.type) === -1) openingTokens.unshift(previousToken);
                else cursor++;
                const closingTokens = openingTokens.map((token)=>new State.Token(token.type.replace('_open', '_close'), token.tag, -1)).reverse();
                let inlineContentStack = token.content;
                matchAll.forEach((match, j)=>{
                    const [matchString, alt, url] = match;
                    const start = inlineContentStack.indexOf(matchString);
                    const contentBefore = inlineContentStack.substr(0, start);
                    inlineContentStack = inlineContentStack.substr(start + matchString.length);
                    subTree = [
                        ...subTree,
                        ...createInlineTokens(contentBefore, openingTokens, closingTokens),
                        ...createMediaTokens(url, alt)
                    ];
                });
                if (inlineContentStack.length) subTree = [
                    ...subTree,
                    ...createInlineTokens(inlineContentStack, openingTokens, closingTokens)
                ];
                processedTokens = [
                    ...processedTokens,
                    ...closingTokens.map((c)=>c.type)
                ];
                tokens = [
                    ...tokens.slice(0, cursor),
                    ...subTree
                ];
            } else if (processedTokens.indexOf(token.type) !== -1) // Ignore token if it's already processed
            processedTokens.splice(processedTokens.indexOf(token.type), 1);
            else tokens.push(token);
            return tokens;
        }, []);
        State.tokens = newTokens;
        return true;
    };
}
const $8cff57ddc400605b$export$c8dcbd316b71f8cf = (md)=>{
    md.core.ruler.before('inline', 'media', $8cff57ddc400605b$var$createRule());
};

});


parcelRegister("5yEGu", function(module, exports) {

$parcel$export(module.exports, "handlePaste", () => $dd6e18e2f6e110dd$export$5dbcc300324fed87);

var $3xw6l = parcelRequire("3xw6l");

var $BmspC = parcelRequire("BmspC");

var $eGOwo = parcelRequire("eGOwo");

var $92xoS = parcelRequire("92xoS");

var $cwzAY = parcelRequire("cwzAY");

var $2vA54 = parcelRequire("2vA54");

var $a57M0 = parcelRequire("a57M0");

var $3n5hT = parcelRequire("3n5hT");

var $7lSnz = parcelRequire("7lSnz");

var $kR2ZR = parcelRequire("kR2ZR");
const $dd6e18e2f6e110dd$var$SKIP_NESTED_TABLE_PASTE_SOURCES = [
    'microsoft-excel',
    'google-spreadsheets'
];
function $dd6e18e2f6e110dd$export$5dbcc300324fed87(view, event, slice, options) {
    if (!(0, $7lSnz.isInTable)(view.state)) return false;
    const { schema: schema } = view.state;
    const isNestingAllowed = (0, $92xoS.editorExperiment)('nested-tables-in-tables', true);
    const isPasteFullTableInsideEmptyCellEnabled = (0, $eGOwo.fg)('platform_editor_paste_full_table_inside_empty_cell');
    const isPartialTablePaste = slice.content.childCount === 1 && slice.content.firstChild?.type === schema.nodes.table && slice.openStart !== 0 && slice.openEnd !== 0;
    const sel = view.state.selection;
    const isCellSelection = sel instanceof (0, $cwzAY.CellSelection);
    if (isPasteFullTableInsideEmptyCellEnabled && isNestingAllowed && !isPartialTablePaste && // If the selection is not a cell selection, and the selection is empty then we can insert a nested table
    !isCellSelection && sel.empty && !(options && $dd6e18e2f6e110dd$var$SKIP_NESTED_TABLE_PASTE_SOURCES.includes(options.pasteSource))) {
        const cellRes = (0, $BmspC.findParentNode)((node)=>node.type === schema.nodes.tableCell || node.type === schema.nodes.tableHeader)(sel);
        if (cellRes) {
            const canInsertNestedTable = cellRes.node.contentMatchAt(0).matchType(schema.nodes.table)?.validEnd;
            if (canInsertNestedTable) return false;
        }
    }
    let cells = (0, $kR2ZR.pastedCells)(slice);
    if (isCellSelection) {
        if (!cells) cells = {
            width: 1,
            height: 1,
            rows: [
                (0, $3xw6l.Fragment).from((0, $kR2ZR.fitSlice)((0, $3n5hT.tableNodeTypes)(view.state.schema).cell, slice))
            ]
        };
        const table = sel.$anchorCell.node(-1);
        const start = sel.$anchorCell.start(-1);
        const tableMap = (0, $2vA54.TableMap).get(table);
        const rect = tableMap.rectBetween(sel.$anchorCell.pos - start, sel.$headCell.pos - start);
        cells = (0, $kR2ZR.clipCells)(cells, rect.right - rect.left, rect.bottom - rect.top);
        (0, $kR2ZR.insertCells)(view.state, view.dispatch, start, rect, $dd6e18e2f6e110dd$var$clearColumnWidthOfCells(cells, rect, tableMap));
        return true;
    }
    if (cells) {
        const $cell = (0, $a57M0.selectionCell)(sel);
        if (!$cell) throw new Error(`handlePaste: no cell found`);
        const start = $cell.start(-1);
        const rect = (0, $2vA54.TableMap).get($cell.node(-1)).findCell($cell.pos - start);
        const tableMap = (0, $2vA54.TableMap).get($cell.node(-1));
        (0, $kR2ZR.insertCells)(view.state, view.dispatch, start, rect, $dd6e18e2f6e110dd$var$clearColumnWidthOfCells(cells, rect, tableMap));
        return true;
    }
    return false;
}
// Clear the pasted cells column widths so that it maintains
// the column widths of the destination table only if the pasted
// cells overlap with existing cells in the destination table.
// If the table grows on paste, keep the column widhts of the
// original table.
const $dd6e18e2f6e110dd$var$clearColumnWidthOfCells = (cells, rect, table)=>{
    const overlappingCells = [];
    for (const row of cells.rows){
        let colNum = rect.left;
        for(let index = 0; index < row.childCount; index++){
            const cell = row.child(index);
            if (colNum + cell.attrs.colspan <= table.width) {
                overlappingCells.push(cell);
                colNum += cell.attrs.colspan;
            } else break;
        }
    }
    for (const cell of overlappingCells)// TODO: ED-13910 - unblock Prosemirror bump
    // @ts-ignore
    cell.attrs.colwidth = null;
    return cells;
};

});
parcelRegister("3n5hT", function(module, exports) {

$parcel$export(module.exports, "tableNodeTypes", () => $eab552a4fa2f4da5$export$c7782132717464bc);
function $eab552a4fa2f4da5$export$c7782132717464bc(schema) {
    let result = schema.cached.tableNodeTypes;
    if (!result) {
        result = {};
        // eslint-disable-next-line no-param-reassign
        schema.cached.tableNodeTypes = result;
        // eslint-disable-next-line guard-for-in
        for(const name in schema.nodes){
            const type = schema.nodes[name];
            const role = type.spec.tableRole;
            if (role) result[role] = type;
        }
    }
    return result;
}

});

parcelRegister("kR2ZR", function(module, exports) {

$parcel$export(module.exports, "pastedCells", () => $61689dc703b4f6c3$export$f6d8f52489457fc4);
$parcel$export(module.exports, "fitSlice", () => $61689dc703b4f6c3$export$f09c6b3b06d884fb);
$parcel$export(module.exports, "clipCells", () => $61689dc703b4f6c3$export$cdcebd68073bc3f);
$parcel$export(module.exports, "insertCells", () => $61689dc703b4f6c3$export$e0b94385c1fdc132);
// Utilities used for copy/paste handling.
//
// This module handles pasting cell content into tables, or pasting
// anything into a cell selection, as replacing a block of cells with
// the content of the selection. When pasting cells into a cell, that
// involves placing the block of pasted content so that its top left
// aligns with the selection cell, optionally extending the table to
// the right or bottom to make sure it is large enough. Pasting into a
// cell selection is different, here the cells in the selection are
// clipped to the selection's rectangle, optionally repeating the
// pasted cells when they are smaller than the selection.

var $3xw6l = parcelRequire("3xw6l");

var $lzEKq = parcelRequire("lzEKq");

var $cwzAY = parcelRequire("cwzAY");

var $2vA54 = parcelRequire("2vA54");

var $9K0SW = parcelRequire("9K0SW");

var $4fn0w = parcelRequire("4fn0w");

var $3n5hT = parcelRequire("3n5hT");

var $RshmT = parcelRequire("RshmT");
// Utilities to help with copying and pasting table cells
/**
 * Replace any header cells with table cells.
 *
 * @param schema
 * @param cells
 * @returns Fragment with header cells converted to table cells
 */ function $61689dc703b4f6c3$var$stripHeaderType(schema, cells) {
    const newCells = [];
    cells.forEach((cell)=>{
        // Convert to cell type if not already
        const cellNodeType = (0, $3n5hT.tableNodeTypes)(schema).cell;
        const tableCell = cell.type === cellNodeType ? cell : cellNodeType.createAndFill(cell.attrs, cell.content, cell.marks) ?? cell;
        newCells.push(tableCell);
    });
    return (0, $3xw6l.Fragment).from(newCells);
}
function $61689dc703b4f6c3$export$f6d8f52489457fc4(slice) {
    if (!slice.size) return null;
    let { content: content, openStart: openStart, openEnd: openEnd } = slice;
    if (!content.firstChild) throw new Error('pastedCells: no firstChild defined for content');
    while(content.childCount === 1 && (openStart > 0 && openEnd > 0 || content.firstChild.type.spec.tableRole === 'table')){
        openStart--;
        openEnd--;
        content = content.firstChild.content;
        if (!content.firstChild) throw new Error('pastedCells: no firstChild defined for content');
    }
    const first = content.firstChild;
    const role = first.type.spec.tableRole;
    const { schema: schema } = first.type;
    const rows = [];
    if (role === 'row') for(let i = 0; i < content.childCount; i++){
        let cells = content.child(i).content;
        const left = i ? 0 : Math.max(0, openStart - 1);
        const right = i < content.childCount - 1 ? 0 : Math.max(0, openEnd - 1);
        if (left || right) cells = $61689dc703b4f6c3$export$f09c6b3b06d884fb((0, $3n5hT.tableNodeTypes)(schema).row, new (0, $3xw6l.Slice)(cells, left, right)).content;
        rows.push(cells);
    }
    else if (role === 'cell' || role === 'header_cell') rows.push(openStart || openEnd ? $61689dc703b4f6c3$export$f09c6b3b06d884fb((0, $3n5hT.tableNodeTypes)(schema).row, new (0, $3xw6l.Slice)(content, openStart, openEnd)).content : content);
    else return null;
    const rowsWithoutHeaders = rows.map((row)=>$61689dc703b4f6c3$var$stripHeaderType(schema, row));
    return $61689dc703b4f6c3$var$ensureRectangular(schema, rowsWithoutHeaders);
}
// : (Schema, [Fragment]) → {width: number, height: number, rows: [Fragment]}
// Compute the width and height of a set of cells, and make sure each
// row has the same number of cells.
function $61689dc703b4f6c3$var$ensureRectangular(schema, rowsFragment) {
    const rows = rowsFragment;
    const widths = [];
    for(let i = 0; i < rows.length; i++){
        const row = rows[i];
        for(let j = row.childCount - 1; j >= 0; j--){
            const { rowspan: rowspan, colspan: colspan } = row.child(j).attrs;
            for(let r = i; r < i + rowspan; r++)widths[r] = (widths[r] || 0) + colspan;
        }
    }
    let width = 0;
    for(let r = 0; r < widths.length; r++)width = Math.max(width, widths[r]);
    for(let r = 0; r < widths.length; r++){
        if (r >= rows.length) rows.push((0, $3xw6l.Fragment).empty);
        if (widths[r] < width) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const empty = (0, $3n5hT.tableNodeTypes)(schema).cell.createAndFill();
            const cells = [];
            for(let i = widths[r]; i < width; i++)cells.push(empty);
            rows[r] = rows[r].append((0, $3xw6l.Fragment).from(cells));
        }
    }
    return {
        height: rows.length,
        width: width,
        rows: rows
    };
}
function $61689dc703b4f6c3$export$f09c6b3b06d884fb(nodeType, slice) {
    const node = nodeType.createAndFill();
    if (!node) throw new Error(`fitSlice: unable to create node`);
    const tr = new (0, $lzEKq.Transform)(node).replace(0, node.content.size, slice);
    return tr.doc;
}
function $61689dc703b4f6c3$export$cdcebd68073bc3f({ width: currentWidth, height: currentHeight, rows: currentRows }, newWidth, newHeight) {
    let rows = currentRows;
    let width = currentWidth;
    let height = currentHeight;
    if (width !== newWidth) {
        const added = [];
        const newRows = [];
        for(let row = 0; row < rows.length; row++){
            const frag = rows[row];
            const cells = [];
            for(let col = added[row] || 0, i = 0; col < newWidth; i++){
                let cell = frag.child(i % frag.childCount);
                if (col + cell.attrs.colspan > newWidth) cell = cell.type.create((0, $9K0SW.removeColSpan)(cell.attrs, cell.attrs.colspan, col + cell.attrs.colspan - newWidth), cell.content);
                cells.push(cell);
                col += cell.attrs.colspan;
                for(let j = 1; j < cell.attrs.rowspan; j++)added[row + j] = (added[row + j] || 0) + cell.attrs.colspan;
            }
            newRows.push((0, $3xw6l.Fragment).from(cells));
        }
        rows = newRows;
        width = newWidth;
    }
    if (height !== newHeight) {
        const newRows = [];
        for(let row = 0, i = 0; row < newHeight; row++, i++){
            const cells = [];
            const source = rows[i % height];
            for(let j = 0; j < source.childCount; j++){
                let cell = source.child(j);
                if (row + cell.attrs.rowspan > newHeight) cell = cell.type.create({
                    ...cell.attrs,
                    rowspan: Math.max(1, newHeight - cell.attrs.rowspan)
                }, cell.content);
                cells.push(cell);
            }
            newRows.push((0, $3xw6l.Fragment).from(cells));
        }
        rows = newRows;
        height = newHeight;
    }
    return {
        width: width,
        height: height,
        rows: rows
    };
}
// Make sure a table has at least the given width and height. Return
// true if something was changed.
function $61689dc703b4f6c3$var$growTable(tr, map, table, start, width, height, mapFrom) {
    const { schema: schema } = tr.doc.type;
    const types = (0, $3n5hT.tableNodeTypes)(schema);
    let empty;
    let emptyHead;
    if (width > map.width) for(let row = 0, rowEnd = 0; row < map.height; row++){
        const rowNode = table.child(row);
        rowEnd += rowNode.nodeSize;
        const cells = [];
        let add;
        if (rowNode.lastChild == null || rowNode.lastChild.type === types.cell) // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        add = empty || (empty = types.cell.createAndFill());
        else // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        add = emptyHead || (emptyHead = types.header_cell.createAndFill());
        for(let i = map.width; i < width; i++)cells.push(add);
        tr.insert(tr.mapping.slice(mapFrom).map(rowEnd - 1 + start), cells);
    }
    if (height > map.height) {
        const cells = [];
        for(let i = 0, k = (map.height - 1) * map.width; i < Math.max(map.width, width); i++){
            let header;
            if (i >= map.width) header = false;
            else {
                const mappedPos = map.map[k + i];
                const node = table.nodeAt(mappedPos);
                if (!node) throw new Error(`growTable: no node found at pos ${mappedPos}`);
                header = node.type === types.header_cell;
            }
            cells.push(header ? // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            emptyHead || (emptyHead = types.header_cell.createAndFill()) : // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            empty || (empty = types.cell.createAndFill()));
        }
        const emptyRow = types.row.create(null, (0, $3xw6l.Fragment).from(cells));
        const rows = [];
        for(let i = map.height; i < height; i++)rows.push(emptyRow);
        tr.insert(tr.mapping.slice(mapFrom).map(start + table.nodeSize - 2), rows);
    }
    return !!(empty || emptyHead);
}
// Make sure the given line (left, top) to (right, top) doesn't cross
// any rowspan cells by splitting cells that cross it. Return true if
// something changed.
function $61689dc703b4f6c3$var$isolateHorizontal(tr, map, table, start, left, right, top, mapFrom) {
    if (top === 0 || top === map.height) return false;
    let found = false;
    for(let col = left; col < right; col++){
        const index = top * map.width + col;
        const pos = map.map[index];
        if (map.map[index - map.width] === pos) {
            found = true;
            const cell = table.nodeAt(pos);
            if (!cell) throw new Error(`isolateHorizontal: no cell found at pos ${pos}`);
            const { top: cellTop, left: cellLeft } = map.findCell(pos);
            tr.setNodeMarkup(tr.mapping.slice(mapFrom).map(pos + start), undefined, {
                ...cell.attrs,
                rowspan: top - cellTop
            });
            const newCell = cell.type.createAndFill({
                ...cell.attrs,
                rowspan: cellTop + cell.attrs.rowspan - top
            });
            if (!newCell) throw new Error('isolateHorizontal: failed to create cell');
            tr.insert(tr.mapping.slice(mapFrom).map(map.positionAt(top, cellLeft, table)), newCell);
            col += cell.attrs.colspan - 1;
        }
    }
    return found;
}
// Make sure the given line (left, top) to (left, bottom) doesn't
// cross any colspan cells by splitting cells that cross it. Return
// true if something changed.
function $61689dc703b4f6c3$var$isolateVertical(tr, map, table, start, top, bottom, left, mapFrom) {
    if (left === 0 || left === map.width) return false;
    let found = false;
    for(let row = top; row < bottom; row++){
        const index = row * map.width + left;
        const pos = map.map[index];
        if (map.map[index - 1] === pos) {
            found = true;
            const cell = table.nodeAt(pos);
            if (!cell) throw new Error(`isolateVertical: could not find cell at pos ${pos}`);
            const cellLeft = map.colCount(pos);
            const updatePos = tr.mapping.slice(mapFrom).map(pos + start);
            tr.setNodeMarkup(updatePos, undefined, (0, $9K0SW.removeColSpan)(cell.attrs, left - cellLeft, cell.attrs.colspan - (left - cellLeft)));
            const newCell = cell.type.createAndFill((0, $9K0SW.removeColSpan)(cell.attrs, 0, left - cellLeft));
            if (!newCell) throw new Error('isolateVertical: failed to create cell');
            tr.insert(updatePos + cell.nodeSize, newCell);
            row += cell.attrs.rowspan - 1;
        }
    }
    return found;
}
function $61689dc703b4f6c3$var$applyHeaderCells(tr, tableMap, state, tableStart, table, headerRowEnabled, headerColumnEnabled) {
    const { schema: schema } = state;
    const setMarkup = (tr, row, col, headerEnabled)=>{
        const cellPos = tableStart + tableMap.positionAt(row, col, table);
        const cell = tr.doc.nodeAt(cellPos);
        const newType = headerEnabled ? schema.nodes.tableHeader : schema.nodes.tableCell;
        const isCellTypeChanged = newType !== cell?.type;
        const isCellTypeValid = !!cell && [
            schema.nodes.tableCell,
            schema.nodes.tableHeader
        ].includes(cell.type);
        if (isCellTypeChanged && isCellTypeValid) tr.setNodeMarkup(cellPos, newType, cell?.attrs, cell?.marks);
    };
    // For row === 0 && col === 0 it is enabled if either are enabled
    setMarkup(tr, 0, 0, headerColumnEnabled || headerRowEnabled);
    // Header Column
    for(let col = 1; col < tableMap.width; col++)setMarkup(tr, 0, col, headerRowEnabled);
    // Header Row
    for(let row = 1; row < tableMap.height; row++)setMarkup(tr, row, 0, headerColumnEnabled);
}
function $61689dc703b4f6c3$export$e0b94385c1fdc132(state, dispatch, tableStart, rect, cells) {
    let table = state.doc;
    const newRect = (0, $4fn0w.selectedRect)(state);
    const types = (0, $3n5hT.tableNodeTypes)(state.schema);
    // Get if the header row and column are enabled on the original table
    const headerRowEnabled = (0, $RshmT.isHeaderEnabledByType)('row', newRect, types);
    const headerColumnEnabled = (0, $RshmT.isHeaderEnabledByType)('column', newRect, types);
    if (tableStart) {
        table = state.doc.nodeAt(tableStart - 1);
        if (!table) throw new Error(`insertCells: could not find table at pos ${tableStart - 1}`);
    }
    let map = (0, $2vA54.TableMap).get(table);
    const { top: top, left: left } = rect;
    const right = left + cells.width;
    const bottom = top + cells.height;
    const { tr: tr } = state;
    let mapFrom = 0;
    function recomp() {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        table = tableStart ? tr.doc.nodeAt(tableStart - 1) : tr.doc;
        map = (0, $2vA54.TableMap).get(table);
        mapFrom = tr.mapping.maps.length;
    }
    // Prepare the table to be large enough and not have any cells
    // crossing the boundaries of the rectangle that we want to
    // insert into. If anything about it changes, recompute the table
    // map so that subsequent operations can see the current shape.
    if ($61689dc703b4f6c3$var$growTable(tr, map, table, tableStart, right, bottom, mapFrom)) recomp();
    if ($61689dc703b4f6c3$var$isolateHorizontal(tr, map, table, tableStart, left, right, top, mapFrom)) recomp();
    if ($61689dc703b4f6c3$var$isolateHorizontal(tr, map, table, tableStart, left, right, bottom, mapFrom)) recomp();
    if ($61689dc703b4f6c3$var$isolateVertical(tr, map, table, tableStart, top, bottom, left, mapFrom)) recomp();
    if ($61689dc703b4f6c3$var$isolateVertical(tr, map, table, tableStart, top, bottom, right, mapFrom)) recomp();
    for(let row = top; row < bottom; row++){
        const from = map.positionAt(row, left, table);
        const to = map.positionAt(row, right, table);
        tr.replace(tr.mapping.slice(mapFrom).map(from + tableStart), tr.mapping.slice(mapFrom).map(to + tableStart), new (0, $3xw6l.Slice)(cells.rows[row - top], 0, 0));
    }
    recomp();
    $61689dc703b4f6c3$var$applyHeaderCells(tr, map, state, tableStart, table, headerRowEnabled, headerColumnEnabled);
    tr.setSelection(new (0, $cwzAY.CellSelection)(tr.doc.resolve(tableStart + map.map[top * map.width + left]), tr.doc.resolve(tableStart + map.map[(bottom - 1) * map.width + right - 1])));
    dispatch(tr);
}

});
parcelRegister("RshmT", function(module, exports) {

$parcel$export(module.exports, "isHeaderEnabledByType", () => $7fc921fd6f4a57e0$export$96946e3333d0ccc6);
$parcel$export(module.exports, "toggleHeader", () => $7fc921fd6f4a57e0$export$dee0ccd8d8f5a56e);

var $2vA54 = parcelRequire("2vA54");

var $4fn0w = parcelRequire("4fn0w");

var $3n5hT = parcelRequire("3n5hT");

var $7lSnz = parcelRequire("7lSnz");
function $7fc921fd6f4a57e0$export$96946e3333d0ccc6(type, rect, types) {
    // Get cell positions for first row or first column
    const cellPositions = rect.map.cellsInRect({
        left: 0,
        top: 0,
        right: type === 'row' ? rect.map.width : 1,
        bottom: type === 'column' ? rect.map.height : 1
    });
    for(let i = 0; i < cellPositions.length; i++){
        const cell = rect.table.nodeAt(cellPositions[i]);
        if (cell && cell.type !== types.header_cell) return false;
    }
    return true;
}
function $7fc921fd6f4a57e0$export$dee0ccd8d8f5a56e(type) {
    return function(state, dispatch) {
        if (!(0, $7lSnz.isInTable)(state)) return false;
        if (dispatch) {
            const types = (0, $3n5hT.tableNodeTypes)(state.schema);
            const rect = (0, $4fn0w.selectedRect)(state), tr = state.tr;
            const isHeaderRowEnabled = $7fc921fd6f4a57e0$export$96946e3333d0ccc6('row', rect, types);
            const isHeaderColumnEnabled = $7fc921fd6f4a57e0$export$96946e3333d0ccc6('column', rect, types);
            const isHeaderEnabled = type === 'column' ? isHeaderRowEnabled : type === 'row' ? isHeaderColumnEnabled : false;
            const selectionStartsAt = isHeaderEnabled ? 1 : 0;
            const cellsRect = type === 'column' ? new (0, $2vA54.Rect)(0, selectionStartsAt, 1, rect.map.height) : type === 'row' ? new (0, $2vA54.Rect)(selectionStartsAt, 0, rect.map.width, 1) : rect;
            let newType;
            if (type === 'column') newType = isHeaderColumnEnabled ? types.cell : types.header_cell;
            else if (type === 'row') newType = isHeaderRowEnabled ? types.cell : types.header_cell;
            else newType = types.cell;
            rect.map.cellsInRect(cellsRect).forEach((relativeCellPos)=>{
                const cellPos = relativeCellPos + rect.tableStart;
                const cell = tr.doc.nodeAt(cellPos);
                if (cell) tr.setNodeMarkup(cellPos, newType, cell.attrs);
            });
            dispatch(tr);
        }
        return true;
    };
}

});



parcelRegister("6UQpI", function(module, exports) {

$parcel$export(module.exports, "PastePluginActionTypes", () => $dd0a13d89c3f070e$export$ad3c0356f902fd97);
var $dd0a13d89c3f070e$export$ad3c0356f902fd97 = /*#__PURE__*/ function(PastePluginActionTypes) {
    PastePluginActionTypes["START_TRACKING_PASTED_MACRO_POSITIONS"] = "START_TRACKING_PASTED_MACRO_POSITIONS";
    PastePluginActionTypes["STOP_TRACKING_PASTED_MACRO_POSITIONS"] = "STOP_TRACKING_PASTED_MACRO_POSITIONS";
    PastePluginActionTypes["ON_PASTE"] = "ON_PASTE";
    return PastePluginActionTypes;
}({});

});

parcelRegister("1CqHB", function(module, exports) {

$parcel$export(module.exports, "startTrackingPastedMacroPositions", () => $ac53801a06635672$export$4a47d257a3fdbe1c);
$parcel$export(module.exports, "stopTrackingPastedMacroPositions", () => $ac53801a06635672$export$68f98dcea8e59d59);
$parcel$export(module.exports, "upgradeTextToLists", () => $ac53801a06635672$export$df231bdf1595dd19);
$parcel$export(module.exports, "splitParagraphs", () => $ac53801a06635672$export$f2dc3112f5c2bd10);

var $fCXIH = parcelRequire("fCXIH");
var $gbisc = parcelRequire("gbisc");

var $dEkUJ = parcelRequire("dEkUJ");

var $3xw6l = parcelRequire("3xw6l");

var $3lIcL = parcelRequire("3lIcL");

var $6UQpI = parcelRequire("6UQpI");

var $3Elhj = parcelRequire("3Elhj");
const $ac53801a06635672$export$4a47d257a3fdbe1c = (pastedMacroPositions)=>(0, $3Elhj.createCommand)(()=>{
        return {
            type: (0, $6UQpI.PastePluginActionTypes).START_TRACKING_PASTED_MACRO_POSITIONS,
            pastedMacroPositions: pastedMacroPositions
        };
    });
const $ac53801a06635672$export$68f98dcea8e59d59 = (pastedMacroPositionKeys)=>(0, $3Elhj.createCommand)(()=>{
        return {
            type: (0, $6UQpI.PastePluginActionTypes).STOP_TRACKING_PASTED_MACRO_POSITIONS,
            pastedMacroPositionKeys: pastedMacroPositionKeys
        };
    });
// matchers for text lists
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $ac53801a06635672$var$bullets = /^\s*[\*\-\u2022](\s+|\s+$)/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $ac53801a06635672$var$numbers = /^\s*\d[\.\)](\s+|$)/;
const $ac53801a06635672$var$isListItem = (node, schema)=>{
    return Boolean(node && node.type === schema.nodes.listItem);
};
const $ac53801a06635672$var$getListType = (node, schema)=>{
    if (!node || !node.text) return null;
    const { bulletList: bulletList, orderedList: orderedList } = schema.nodes;
    return [
        {
            node: bulletList,
            matcher: $ac53801a06635672$var$bullets
        },
        {
            node: orderedList,
            matcher: $ac53801a06635672$var$numbers
        }
    ].reduce((lastMatch, listType)=>{
        if (lastMatch) return lastMatch;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const match = node.text.match(listType.matcher);
        return match ? [
            listType.node,
            match[0].length
        ] : lastMatch;
    }, null);
};
const $ac53801a06635672$export$252a79c29aea3669 = (content, schema)=>{
    const wrapperContent = [];
    let nextContent = [];
    content.forEach((node)=>{
        if (node.type === schema.nodes.hardBreak) {
            if (nextContent.length !== 0) wrapperContent.push(nextContent);
            nextContent = [
                node
            ];
        } else nextContent.push(node);
    });
    wrapperContent.push(nextContent);
    return wrapperContent;
};
const $ac53801a06635672$export$5bfe14e0df30e39c = (node, parent, schema)=>{
    const content = (0, $gbisc.mapChildren)(node.content, (node)=>node);
    const linesSplitByHardbreaks = $ac53801a06635672$export$252a79c29aea3669(content, schema);
    const { paragraph: paragraph, hardBreak: hardBreak, listItem: listItem, orderedList: orderedList } = schema.nodes;
    const splitListsAndParagraphs = [];
    let paragraphParts = [];
    // Ignored via go/ees005
    // eslint-disable-next-line no-var
    for(var index = 0; index < linesSplitByHardbreaks.length; index = index + 1){
        const line = linesSplitByHardbreaks[index];
        let listMatch;
        if (index === 0) {
            if (line[0]?.type === hardBreak) {
                paragraphParts.push(line);
                continue;
            } else // the first line the potential list item is at postion 0
            listMatch = $ac53801a06635672$var$getListType(line[0], schema);
        } else {
            // lines after the first the potential list item is at postion 1
            if (line.length === 1) {
                // if the line only has a line break return as is
                paragraphParts.push(line);
                continue;
            }
            listMatch = $ac53801a06635672$var$getListType(line[1], schema);
        }
        if (!listMatch || // CONFCLOUD-79708: If we are inside a list - let's not try to upgrade list as it resolves
        // to invalid content
        $ac53801a06635672$var$isListItem(parent, schema)) {
            // if there is not list match return as is
            paragraphParts.push(line);
            continue;
        }
        const [nodeType, length] = listMatch;
        const firstNonHardBreakNode = line.find((node)=>node.type !== hardBreak);
        const chunksWithoutLeadingHardBreaks = line.slice(line.findIndex((node)=>node.type !== hardBreak));
        // retain text after bullet or number-dot e.g. 1. Hello
        const startingText = firstNonHardBreakNode?.text?.substr(length);
        const restOfChunk = startingText ? [
            schema.text(startingText, firstNonHardBreakNode?.marks),
            ...chunksWithoutLeadingHardBreaks.slice(1)
        ] : chunksWithoutLeadingHardBreaks.slice(1);
        // convert to list
        const listItemNode = listItem?.createAndFill(undefined, paragraph.createChecked(undefined, restOfChunk));
        if (!listItemNode) {
            paragraphParts.push(line);
            continue;
        }
        const attrs = nodeType === orderedList ? {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            order: parseInt(firstNonHardBreakNode.text.split('.')[0])
        } : undefined;
        const newList = nodeType.createChecked(attrs, [
            listItemNode
        ]);
        if (paragraphParts.length !== 0 && paragraph.validContent((0, $3xw6l.Fragment).from(paragraphParts.flat()))) {
            splitListsAndParagraphs.push(paragraph.createAndFill(node.attrs, paragraphParts.flat(), node.marks));
            paragraphParts = [];
        }
        splitListsAndParagraphs.push(newList);
    }
    if (paragraphParts.length !== 0 && paragraph.validContent((0, $3xw6l.Fragment).from(paragraphParts.flat()))) splitListsAndParagraphs.push(schema.nodes.paragraph.createAndFill(node.attrs, paragraphParts.flat(), node.marks));
    const result = splitListsAndParagraphs.flat();
    // try to join
    const mockState = (0, $3lIcL.EditorState).create({
        schema: schema
    });
    let joinedListsTr;
    const mockDispatch = (tr)=>{
        joinedListsTr = tr;
    };
    // Return false to prevent replaceWith from wrapping the text node in a paragraph
    // paragraph since that will be done later. If it's done here, it will fail
    // the paragraph.validContent check.
    // Dont return false if there are lists, as they arent validContent for paragraphs
    // and will result in hanging textNodes
    (0, $dEkUJ.autoJoin)((state, dispatch)=>{
        if (!dispatch) return false;
        const containsList = result.some((node)=>node.type === schema.nodes.bulletList || node.type === schema.nodes.orderedList);
        if (result.some((node)=>node.isText) && !containsList) return false;
        dispatch(state.tr.replaceWith(0, 2, result));
        return true;
    }, (before, after)=>(0, $fCXIH.isListNode)(before) && (0, $fCXIH.isListNode)(after))(mockState, mockDispatch);
    const fragment = joinedListsTr ? joinedListsTr.doc.content : (0, $3xw6l.Fragment).from(result);
    return fragment;
};
const $ac53801a06635672$export$df231bdf1595dd19 = (slice, schema)=>{
    return (0, $gbisc.mapSlice)(slice, (node, parent)=>{
        if (node.type === schema.nodes.paragraph) return $ac53801a06635672$export$5bfe14e0df30e39c(node, parent, schema);
        return node;
    });
};
const $ac53801a06635672$export$f2dc3112f5c2bd10 = (slice, schema)=>{
    // exclude Text nodes with a code mark, since we transform those later
    // into a codeblock
    let hasCodeMark = false;
    slice.content.forEach((child)=>{
        hasCodeMark = hasCodeMark || child.marks.some((mark)=>mark.type === schema.marks.code);
    });
    // slice might just be a raw text string
    if (schema.nodes.paragraph.validContent(slice.content) && !hasCodeMark) {
        const replSlice = $ac53801a06635672$export$b2e3d6bb71a327f1({
            fragment: slice.content,
            schema: schema
        });
        return new (0, $3xw6l.Slice)(replSlice, slice.openStart + 1, slice.openEnd + 1);
    }
    return (0, $gbisc.mapSlice)(slice, (node)=>{
        if (node.type === schema.nodes.paragraph) return $ac53801a06635672$export$b2e3d6bb71a327f1({
            fragment: node.content,
            blockMarks: node.marks,
            schema: schema
        });
        return node;
    });
};
const $ac53801a06635672$export$b2e3d6bb71a327f1 = ({ fragment: fragment, blockMarks: blockMarks = [], schema: schema })=>{
    const paragraphs = [];
    let curChildren = [];
    let lastNode = null;
    const { hardBreak: hardBreak, paragraph: paragraph } = schema.nodes;
    fragment.forEach((node, i)=>{
        const isNodeValidContentForParagraph = schema.nodes.paragraph.validContent((0, $3xw6l.Fragment).from(node));
        if (!isNodeValidContentForParagraph) {
            paragraphs.push(node);
            return;
        }
        // ED-14725 Fixed the issue that it make duplicated line
        // when pasting <br /> from google docs.
        if (i === 0 && node.type === hardBreak) {
            paragraphs.push(paragraph.createChecked(undefined, curChildren, [
                ...blockMarks
            ]));
            lastNode = node;
            return;
        } else if (lastNode && lastNode.type === hardBreak && node.type === hardBreak) {
            // double hardbreak
            // backtrack a little; remove the trailing hardbreak we added last loop
            curChildren.pop();
            // create a new paragraph
            paragraphs.push(paragraph.createChecked(undefined, curChildren, [
                ...blockMarks
            ]));
            curChildren = [];
            return;
        }
        // add to this paragraph
        curChildren.push(node);
        lastNode = node;
    });
    if (curChildren.length) paragraphs.push(paragraph.createChecked(undefined, curChildren, [
        ...blockMarks
    ]));
    return (0, $3xw6l.Fragment).from(paragraphs.length ? paragraphs : // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    [
        paragraph.createAndFill(undefined, undefined, [
            ...blockMarks
        ])
    ]);
};

});
parcelRegister("3Elhj", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $d82332805bdbc0be$export$18d4026d1ea86bb1);
$parcel$export(module.exports, "createPluginState", () => $d82332805bdbc0be$export$656c7661095efe2e);
$parcel$export(module.exports, "createCommand", () => $d82332805bdbc0be$export$8d4021544bdece00);
$parcel$export(module.exports, "getPluginState", () => $d82332805bdbc0be$export$f05434c51e3762e);

var $bazog = parcelRequire("bazog");

var $3lIcL = parcelRequire("3lIcL");

var $9SwZE = parcelRequire("9SwZE");
const $d82332805bdbc0be$export$18d4026d1ea86bb1 = new (0, $3lIcL.PluginKey)('pastePlugin');
const { createPluginState: $d82332805bdbc0be$export$656c7661095efe2e, createCommand: $d82332805bdbc0be$export$8d4021544bdece00, getPluginState: $d82332805bdbc0be$export$f05434c51e3762e } = (0, $bazog.pluginFactory)($d82332805bdbc0be$export$18d4026d1ea86bb1, (0, $9SwZE.reducer), {
    mapping: (tr, pluginState)=>{
        if (tr.docChanged) {
            let atLeastOnePositionChanged = false;
            const positionsMappedThroughChanges = Object.entries(pluginState.pastedMacroPositions).reduce((acc, [key, position])=>{
                const mappedPosition = tr.mapping.map(position);
                if (position !== mappedPosition) atLeastOnePositionChanged = true;
                acc[key] = tr.mapping.map(position);
                return acc;
            }, {});
            if (atLeastOnePositionChanged) return {
                ...pluginState,
                pastedMacroPositions: positionsMappedThroughChanges
            };
        }
        return pluginState;
    }
});

});
parcelRegister("9SwZE", function(module, exports) {

$parcel$export(module.exports, "reducer", () => $55714805b49ba3de$export$1650419e431d3ba3);

var $6UQpI = parcelRequire("6UQpI");
const $55714805b49ba3de$export$1650419e431d3ba3 = (state, action)=>{
    switch(action.type){
        case (0, $6UQpI.PastePluginActionTypes).START_TRACKING_PASTED_MACRO_POSITIONS:
            return {
                ...state,
                pastedMacroPositions: {
                    ...state.pastedMacroPositions,
                    ...action.pastedMacroPositions
                }
            };
        case (0, $6UQpI.PastePluginActionTypes).STOP_TRACKING_PASTED_MACRO_POSITIONS:
            {
                const filteredMacroPositions = Object.fromEntries(Object.entries(state.pastedMacroPositions).filter(([key])=>!action.pastedMacroPositionKeys.includes(key)));
                return {
                    ...state,
                    pastedMacroPositions: filteredMacroPositions
                };
            }
        case (0, $6UQpI.PastePluginActionTypes).ON_PASTE:
            return {
                ...state,
                lastContentPasted: action.contentPasted
            };
        default:
            return state;
    }
};

});



parcelRegister("5pNJd", function(module, exports) {

$parcel$export(module.exports, "transformSliceForMedia", () => $f04cfeb9928ddc35$export$5ed9534d355a0a0f);
$parcel$export(module.exports, "transformSliceToCorrectMediaWrapper", () => $f04cfeb9928ddc35$export$bd95a8dd607682c8);
$parcel$export(module.exports, "transformSliceToMediaSingleWithNewExperience", () => $f04cfeb9928ddc35$export$77944619eaa3fcd3);
$parcel$export(module.exports, "unwrapNestedMediaElements", () => $f04cfeb9928ddc35$export$3b69af3aaae9ee54);

var $1I3aa = parcelRequire("1I3aa");

var $gbisc = parcelRequire("gbisc");
var $7SIsS = parcelRequire("7SIsS");

var $BmspC = parcelRequire("BmspC");

var $3xaEP = parcelRequire("3xaEP");
function $f04cfeb9928ddc35$export$5ed9534d355a0a0f(slice, schema, api) {
    const { mediaSingle: mediaSingle, layoutSection: layoutSection, table: table, bulletList: bulletList, orderedList: orderedList, expand: expand, nestedExpand: nestedExpand } = schema.nodes;
    return (selection)=>{
        let newSlice = slice;
        if ((0, $BmspC.hasParentNodeOfType)([
            layoutSection,
            table,
            bulletList,
            orderedList,
            expand,
            nestedExpand
        ])(selection)) newSlice = (0, $gbisc.mapSlice)(newSlice, (node)=>{
            const mediaState = api?.media?.sharedState.currentState();
            const extendedOrLegacyAttrs = mediaState?.mediaOptions?.allowPixelResizing ? {
                layout: node.attrs.layout,
                widthType: node.attrs.widthType,
                width: node.attrs.width
            } : {
                layout: node.attrs.layout
            };
            let attrs = {};
            if ((0, $BmspC.hasParentNodeOfType)([
                layoutSection,
                table
            ])(selection)) // Supports layouts
            attrs = {
                ...extendedOrLegacyAttrs
            };
            else if ((0, $BmspC.hasParentNodeOfType)([
                bulletList,
                orderedList,
                expand,
                nestedExpand
            ])(selection)) // does not support other layouts
            attrs = {
                ...extendedOrLegacyAttrs,
                layout: 'center'
            };
            return node.type.name === 'mediaSingle' ? mediaSingle.createChecked(attrs, node.content, node.marks) : node;
        });
        return newSlice;
    };
}
const $f04cfeb9928ddc35$export$fb85bc5d6d9ef19b = (fileType)=>{
    return !!fileType && (fileType.indexOf('image/') > -1 || fileType.indexOf('video/') > -1);
};
const $f04cfeb9928ddc35$export$bd95a8dd607682c8 = (slice, schema)=>{
    const { mediaGroup: mediaGroup, mediaSingle: mediaSingle, media: media } = schema.nodes;
    return (0, $gbisc.mapSlice)(slice, (node, parent)=>{
        if (!parent && node.type === media) {
            if (mediaSingle && ($f04cfeb9928ddc35$export$fb85bc5d6d9ef19b(node.attrs.__fileMimeType) || node.attrs.type === 'external')) return mediaSingle.createChecked({}, node);
            else return mediaGroup.createChecked({}, [
                node
            ]);
        }
        return node;
    });
};
const $f04cfeb9928ddc35$export$77944619eaa3fcd3 = (slice, schema, api)=>{
    const { mediaInline: mediaInline, mediaSingle: mediaSingle, media: media } = schema.nodes;
    const newSlice = (0, $gbisc.mapSlice)(slice, (node)=>{
        // This logic is duplicated in editor-plugin-ai where external images can be inserted
        // from external sources through the use of AI.  The editor-plugin-ai package is avoiding
        // sharing dependencies with editor-core to support products using it with various versions
        // of editor packages.
        // The duplication is in the following file:
        // packages/editor/editor-plugin-ai/src/prebuilt/content-transformers/markdown-to-pm/markdown-transformer.ts
        if (node.type === mediaSingle) {
            const mediaState = api?.media?.sharedState.currentState();
            return mediaState?.mediaOptions?.allowPixelResizing ? mediaSingle.createChecked({
                width: node.attrs.width || (0, $1I3aa.DEFAULT_IMAGE_WIDTH),
                widthType: node.attrs.widthType || 'pixel',
                layout: node.attrs.layout
            }, node.content, node.marks) : node;
        }
        return node;
    });
    return (0, $gbisc.mapSlice)(newSlice, (node)=>{
        const __mediaTraceId = (0, $3xaEP.getRandomHex)(8);
        if (node.type === media) {
            api?.core.actions.execute(api?.media?.commands.trackMediaPaste(node.attrs));
            return media.createChecked({
                ...node.attrs,
                __external: node.attrs.type === 'external',
                __mediaTraceId: node.attrs.type === 'external' ? null : __mediaTraceId
            }, node.content, node.marks);
        }
        if (node.type.name === 'mediaInline') {
            api?.core.actions.execute(api?.media?.commands.trackMediaPaste(node.attrs));
            return mediaInline.createChecked({
                ...node.attrs,
                __mediaTraceId: __mediaTraceId
            }, node.content, node.marks);
        }
        return node;
    });
};
/**
 * Check base styles to see if an element will be invisible when rendered in a document.
 * @param element
 */ const $f04cfeb9928ddc35$var$isElementInvisible = (element)=>{
    return element.style.opacity === '0' || element.style.display === 'none' || element.style.visibility === 'hidden';
};
const $f04cfeb9928ddc35$var$VALID_TAGS_CONTAINER = [
    'DIV',
    'TD',
    'BLOCKQUOTE'
];
function $f04cfeb9928ddc35$var$canContainImage(element) {
    if (!element) return false;
    return $f04cfeb9928ddc35$var$VALID_TAGS_CONTAINER.indexOf(element.tagName) !== -1;
}
const $f04cfeb9928ddc35$export$3b69af3aaae9ee54 = (html)=>{
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const wrapper = doc.body;
    // Remove Google Doc's wrapper <b> el
    const docsWrapper = wrapper.querySelector('b[id^="docs-internal-guid-"]');
    if (docsWrapper) (0, $7SIsS.unwrap)(wrapper, docsWrapper);
    const imageTags = wrapper.querySelectorAll('img');
    if (!imageTags.length) return html;
    imageTags.forEach((imageTag)=>{
        // Capture the immediate parent, we may remove the media from here later.
        const mediaParent = imageTag.parentElement;
        if (!mediaParent) return;
        // If either the parent or the image itself contains styles that would make
        // them invisible on copy, dont paste them.
        if ($f04cfeb9928ddc35$var$isElementInvisible(mediaParent) || $f04cfeb9928ddc35$var$isElementInvisible(imageTag)) {
            mediaParent.removeChild(imageTag);
            return;
        }
        // If its wrapped by a valid container we assume its safe to bypass.
        // ProseMirror should handle these cases properly.
        if ($f04cfeb9928ddc35$var$canContainImage(mediaParent) || mediaParent instanceof HTMLSpanElement && mediaParent.closest('[class*="emoji-common"]')) return;
        // Find the top most element that the parent has a valid container for the image.
        // Stop just before found the wrapper
        const insertBeforeElement = (0, $7SIsS.walkUpTreeUntil)(mediaParent, (element)=>{
            // If is at the top just use this element as reference
            if (element.parentElement === wrapper) return true;
            return $f04cfeb9928ddc35$var$canContainImage(element.parentElement);
        });
        // Here we try to insert the media right after its top most valid parent element
        // Unless its the last element in our structure then we will insert above it.
        if (insertBeforeElement && insertBeforeElement.parentElement) {
            // Insert as close as possible to the most closest valid element index in the tree.
            insertBeforeElement.parentElement.insertBefore(imageTag, insertBeforeElement.nextElementSibling || insertBeforeElement);
            // Attempt to clean up lines left behind by the image
            mediaParent.innerText = mediaParent.innerText.trim();
            // Walk up and delete empty elements left over after removing the image tag
            (0, $7SIsS.removeNestedEmptyEls)(mediaParent);
        }
    });
    // If last child is a hardbreak we don't want it
    if (wrapper.lastElementChild && wrapper.lastElementChild.tagName === 'BR') wrapper.removeChild(wrapper.lastElementChild);
    return wrapper.innerHTML;
};

});

parcelRegister("3kq4u", function(module, exports) {

$parcel$export(module.exports, "sendPasteAnalyticsEvent", () => $4cfeb607ceb33f88$export$5ee87eef0a304a1b);
$parcel$export(module.exports, "handlePasteAsPlainTextWithAnalytics", () => $4cfeb607ceb33f88$export$69d6e3902009956e);
$parcel$export(module.exports, "handlePasteIntoTaskAndDecisionWithAnalytics", () => $4cfeb607ceb33f88$export$e3873690443e0966);
$parcel$export(module.exports, "handlePasteIntoCaptionWithAnalytics", () => $4cfeb607ceb33f88$export$e1d2fb186881c383);
$parcel$export(module.exports, "handleCodeBlockWithAnalytics", () => $4cfeb607ceb33f88$export$9fea421173ba6d7d);
$parcel$export(module.exports, "handleMediaSingleWithAnalytics", () => $4cfeb607ceb33f88$export$b49fd82cf59cd44e);
$parcel$export(module.exports, "handlePastePreservingMarksWithAnalytics", () => $4cfeb607ceb33f88$export$ef36b80b79d1d973);
$parcel$export(module.exports, "handleMarkdownWithAnalytics", () => $4cfeb607ceb33f88$export$d7489d309972091e);
$parcel$export(module.exports, "handleRichTextWithAnalytics", () => $4cfeb607ceb33f88$export$3ef868f9e7157717);
$parcel$export(module.exports, "handlePastePanelOrDecisionIntoListWithAnalytics", () => $4cfeb607ceb33f88$export$2d195c5439ce2ebc);
$parcel$export(module.exports, "handlePasteNonNestableBlockNodesIntoListWithAnalytics", () => $4cfeb607ceb33f88$export$bbc9709b7b4a2f6);
$parcel$export(module.exports, "handleExpandWithAnalytics", () => $4cfeb607ceb33f88$export$6681e5bfb9c8b704);
$parcel$export(module.exports, "handleNestedTablePasteWithAnalytics", () => $4cfeb607ceb33f88$export$7dc8d4c52517a2f7);
$parcel$export(module.exports, "handleSelectedTableWithAnalytics", () => $4cfeb607ceb33f88$export$6dbadac5ea22dd7a);
$parcel$export(module.exports, "handlePasteLinkOnSelectedTextWithAnalytics", () => $4cfeb607ceb33f88$export$b36a7c9ea20b7bbf);
$parcel$export(module.exports, "createPasteMeasurePayload", () => $4cfeb607ceb33f88$export$5dd5834ba1e07721);
$parcel$export(module.exports, "getContentNodeTypes", () => $4cfeb607ceb33f88$export$629ff5588e070c83);

var $bMFKb = parcelRequire("bMFKb");
var $j0X5g = parcelRequire("j0X5g");

var $grDTV = parcelRequire("grDTV");
var $gbisc = parcelRequire("gbisc");

var $BmspC = parcelRequire("BmspC");

var $bFyUX = parcelRequire("bFyUX");

var $1nSqW = parcelRequire("1nSqW");
const $4cfeb607ceb33f88$var$contentToPasteContent = {
    url: (0, $j0X5g.PasteContents).url,
    paragraph: (0, $j0X5g.PasteContents).text,
    bulletList: (0, $j0X5g.PasteContents).bulletList,
    orderedList: (0, $j0X5g.PasteContents).orderedList,
    heading: (0, $j0X5g.PasteContents).heading,
    blockquote: (0, $j0X5g.PasteContents).blockquote,
    codeBlock: (0, $j0X5g.PasteContents).codeBlock,
    panel: (0, $j0X5g.PasteContents).panel,
    rule: (0, $j0X5g.PasteContents).rule,
    mediaSingle: (0, $j0X5g.PasteContents).mediaSingle,
    mediaCard: (0, $j0X5g.PasteContents).mediaCard,
    mediaGroup: (0, $j0X5g.PasteContents).mediaGroup,
    table: (0, $j0X5g.PasteContents).table,
    tableCells: (0, $j0X5g.PasteContents).tableCells,
    tableHeader: (0, $j0X5g.PasteContents).tableHeader,
    tableRow: (0, $j0X5g.PasteContents).tableRow,
    decisionList: (0, $j0X5g.PasteContents).decisionList,
    decisionItem: (0, $j0X5g.PasteContents).decisionItem,
    taskList: (0, $j0X5g.PasteContents).taskItem,
    extension: (0, $j0X5g.PasteContents).extension,
    bodiedExtension: (0, $j0X5g.PasteContents).bodiedExtension,
    blockCard: (0, $j0X5g.PasteContents).blockCard,
    layoutSection: (0, $j0X5g.PasteContents).layoutSection
};
const $4cfeb607ceb33f88$var$nodeToActionSubjectId = {
    blockquote: (0, $bMFKb.ACTION_SUBJECT_ID).PASTE_BLOCKQUOTE,
    blockCard: (0, $bMFKb.ACTION_SUBJECT_ID).PASTE_BLOCK_CARD,
    bodiedExtension: (0, $bMFKb.ACTION_SUBJECT_ID).PASTE_BODIED_EXTENSION,
    bulletList: (0, $bMFKb.ACTION_SUBJECT_ID).PASTE_BULLET_LIST,
    codeBlock: (0, $bMFKb.ACTION_SUBJECT_ID).PASTE_CODE_BLOCK,
    decisionList: (0, $bMFKb.ACTION_SUBJECT_ID).PASTE_DECISION_LIST,
    extension: (0, $bMFKb.ACTION_SUBJECT_ID).PASTE_EXTENSION,
    heading: (0, $bMFKb.ACTION_SUBJECT_ID).PASTE_HEADING,
    mediaGroup: (0, $bMFKb.ACTION_SUBJECT_ID).PASTE_MEDIA_GROUP,
    mediaSingle: (0, $bMFKb.ACTION_SUBJECT_ID).PASTE_MEDIA_SINGLE,
    orderedList: (0, $bMFKb.ACTION_SUBJECT_ID).PASTE_ORDERED_LIST,
    panel: (0, $bMFKb.ACTION_SUBJECT_ID).PASTE_PANEL,
    rule: (0, $bMFKb.ACTION_SUBJECT_ID).PASTE_RULE,
    table: (0, $bMFKb.ACTION_SUBJECT_ID).PASTE_TABLE,
    tableCell: (0, $bMFKb.ACTION_SUBJECT_ID).PASTE_TABLE_CELL,
    tableHeader: (0, $bMFKb.ACTION_SUBJECT_ID).PASTE_TABLE_HEADER,
    tableRow: (0, $bMFKb.ACTION_SUBJECT_ID).PASTE_TABLE_ROW,
    taskList: (0, $bMFKb.ACTION_SUBJECT_ID).PASTE_TASK_LIST
};
function $4cfeb607ceb33f88$export$234c310f1a4fffd6({ schema: schema, slice: slice }) {
    const { nodes: { paragraph: paragraph }, marks: { link: link } } = schema;
    const nodeOrMarkName = new Set();
    slice.content.forEach((node)=>{
        if (node.type === paragraph && node.content.size === 0) // Skip empty paragraph
        return;
        if (node.type.name === 'text' && link.isInSet(node.marks)) {
            nodeOrMarkName.add('url');
            return;
        }
        // Check node contain link
        if (node.type === paragraph && node.rangeHasMark(0, node.nodeSize - 2, link)) {
            nodeOrMarkName.add('url');
            return;
        }
        nodeOrMarkName.add(node.type.name);
    });
    if (nodeOrMarkName.size > 1) return (0, $j0X5g.PasteContents).mixed;
    if (nodeOrMarkName.size === 0) return (0, $j0X5g.PasteContents).uncategorized;
    const type = nodeOrMarkName.values().next().value;
    const pasteContent = $4cfeb607ceb33f88$var$contentToPasteContent[type];
    return pasteContent ? pasteContent : (0, $j0X5g.PasteContents).uncategorized;
}
function $4cfeb607ceb33f88$export$d26f991ad03d8827(slice) {
    let traceId;
    (0, $gbisc.mapSlice)(slice, (node)=>{
        if (node.type.name === 'media' || node.type.name === 'mediaInline') traceId = node.attrs.__mediaTraceId;
        return node;
    });
    return traceId;
}
function $4cfeb607ceb33f88$var$getActionSubjectId({ selection: selection, schema: schema }) {
    const { nodes: { paragraph: paragraph, listItem: listItem, taskItem: taskItem, decisionItem: decisionItem } } = schema;
    const parent = (0, $BmspC.findParentNode)((node)=>{
        if (node.type !== paragraph && node.type !== listItem && node.type !== taskItem && node.type !== decisionItem) return true;
        return false;
    })(selection);
    if (!parent) return (0, $bMFKb.ACTION_SUBJECT_ID).PASTE_PARAGRAPH;
    const parentType = parent.node.type;
    const actionSubjectId = $4cfeb607ceb33f88$var$nodeToActionSubjectId[parentType.name];
    return actionSubjectId ? actionSubjectId : (0, $bMFKb.ACTION_SUBJECT_ID).PASTE_PARAGRAPH;
}
function $4cfeb607ceb33f88$var$createPasteAsPlainPayload(actionSubjectId, text, linksInPasteCount) {
    return {
        action: (0, $bMFKb.ACTION).PASTED_AS_PLAIN,
        actionSubject: (0, $bMFKb.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: actionSubjectId,
        eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
        attributes: {
            inputMethod: (0, $bMFKb.INPUT_METHOD).KEYBOARD,
            pasteSize: text.length,
            linksInPasteCount: linksInPasteCount
        }
    };
}
function $4cfeb607ceb33f88$var$createPastePayload(actionSubjectId, attributes, linkDomain) {
    return {
        action: (0, $bMFKb.ACTION).PASTED,
        actionSubject: (0, $bMFKb.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: actionSubjectId,
        eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
        attributes: {
            inputMethod: (0, $bMFKb.INPUT_METHOD).KEYBOARD,
            ...attributes
        },
        ...linkDomain && linkDomain.length > 0 ? {
            nonPrivacySafeAttributes: {
                linkDomain: linkDomain
            }
        } : {}
    };
}
function $4cfeb607ceb33f88$var$createPasteAnalyticsPayloadBySelection(event, slice, pasteContext, pluginInjectionApi) {
    return (selection)=>{
        const text = event.clipboardData ? event.clipboardData.getData('text/plain') || event.clipboardData.getData('text/uri-list') : '';
        const actionSubjectId = $4cfeb607ceb33f88$var$getActionSubjectId({
            selection: selection,
            schema: selection.$from.doc.type.schema
        });
        const pasteSize = slice.size;
        const content = $4cfeb607ceb33f88$export$234c310f1a4fffd6({
            schema: selection.$from.doc.type.schema,
            slice: slice
        });
        const linkUrls = [];
        const mediaTraceId = $4cfeb607ceb33f88$export$d26f991ad03d8827(slice);
        // If we have a link among the pasted content, grab the
        // domain and send it up with the analytics event
        if (content === (0, $j0X5g.PasteContents).url || content === (0, $j0X5g.PasteContents).mixed) (0, $gbisc.mapSlice)(slice, (node)=>{
            const linkMark = node.marks.find((mark)=>mark.type.name === 'link');
            if (linkMark) linkUrls.push(linkMark.attrs.href);
            return node;
        });
        if (pasteContext.asPlain) return $4cfeb607ceb33f88$var$createPasteAsPlainPayload(actionSubjectId, text, linkUrls.length);
        const source = (0, $bFyUX.getPasteSource)(event);
        const mentionIds = [];
        const mentionLocalIds = [];
        slice.content.descendants((node)=>{
            if (node.type.name === 'mention') {
                mentionIds.push(node.attrs.id);
                mentionLocalIds.push(node.attrs.localId);
            }
        });
        if (pluginInjectionApi?.mention?.actions?.announceMentionsInsertion) {
            const mentionsInserted = [];
            slice.content.descendants((node)=>{
                if (node.type.name === 'mention') mentionsInserted.push({
                    type: 'added',
                    id: node.attrs.id,
                    localId: node.attrs.localId,
                    method: 'pasted'
                });
                if (node.type.name === 'taskItem') {
                    node.content.forEach((nodeContent)=>{
                        if (nodeContent.type.name === 'mention') mentionsInserted.push({
                            type: 'added',
                            localId: nodeContent.attrs.localId,
                            id: nodeContent.attrs.id,
                            taskLocalId: node.attrs.localId,
                            method: 'pasted'
                        });
                    });
                    return false;
                }
            });
            pluginInjectionApi?.mention?.actions?.announceMentionsInsertion(mentionsInserted);
        }
        if (pasteContext.type === (0, $j0X5g.PasteTypes).plain) return $4cfeb607ceb33f88$var$createPastePayload(actionSubjectId, {
            pasteSize: text.length,
            type: pasteContext.type,
            content: (0, $j0X5g.PasteContents).text,
            source: source,
            hyperlinkPasteOnText: false,
            linksInPasteCount: linkUrls.length,
            mentionIds: mentionIds,
            mentionLocalIds: mentionLocalIds,
            pasteSplitList: pasteContext.pasteSplitList
        });
        const linkDomains = linkUrls.map((0, $grDTV.getLinkDomain));
        return $4cfeb607ceb33f88$var$createPastePayload(actionSubjectId, {
            type: pasteContext.type,
            pasteSize: pasteSize,
            content: content,
            source: source,
            hyperlinkPasteOnText: !!pasteContext.hyperlinkPasteOnText,
            linksInPasteCount: linkUrls.length,
            mediaTraceId: mediaTraceId,
            mentionIds: mentionIds,
            mentionLocalIds: mentionLocalIds,
            pasteSplitList: pasteContext.pasteSplitList
        }, linkDomains);
    };
}
function $4cfeb607ceb33f88$export$a30e064bd28e927f(view, event, slice, pasteContext) {
    return $4cfeb607ceb33f88$var$createPasteAnalyticsPayloadBySelection(event, slice, pasteContext)(view.state.selection);
}
const $4cfeb607ceb33f88$export$5ee87eef0a304a1b = (editorAnalyticsAPI)=>(view, event, slice, pasteContext)=>{
        const tr = view.state.tr;
        const payload = $4cfeb607ceb33f88$export$a30e064bd28e927f(view, event, slice, pasteContext);
        editorAnalyticsAPI?.attachAnalyticsEvent(payload)(tr);
        view.dispatch(tr);
    };
const $4cfeb607ceb33f88$export$69d6e3902009956e = (editorAnalyticsAPI)=>(view, event, slice)=>$4cfeb607ceb33f88$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($4cfeb607ceb33f88$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: (0, $j0X5g.PasteTypes).plain,
            asPlain: true
        }))((0, $1nSqW.handlePasteAsPlainText)(slice, event, editorAnalyticsAPI));
const $4cfeb607ceb33f88$export$e3873690443e0966 = (view, event, slice, type, pluginInjectionApi)=>$4cfeb607ceb33f88$var$injectAnalyticsPayloadBeforeCommand(pluginInjectionApi?.analytics?.actions)($4cfeb607ceb33f88$var$createPasteAnalyticsPayloadBySelection(event, slice, {
        type: type
    }))((0, $1nSqW.handlePasteIntoTaskOrDecisionOrPanel)(slice, pluginInjectionApi?.card?.actions?.queueCardsFromChangedTr));
const $4cfeb607ceb33f88$export$e1d2fb186881c383 = (editorAnalyticsAPI)=>(view, event, slice, type)=>$4cfeb607ceb33f88$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($4cfeb607ceb33f88$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: type
        }))((0, $1nSqW.handlePasteIntoCaption)(slice));
const $4cfeb607ceb33f88$export$9fea421173ba6d7d = (editorAnalyticsAPI)=>(view, event, slice, text)=>$4cfeb607ceb33f88$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($4cfeb607ceb33f88$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: (0, $j0X5g.PasteTypes).plain
        }))((0, $1nSqW.handleCodeBlock)(text));
const $4cfeb607ceb33f88$export$b49fd82cf59cd44e = (editorAnalyticsAPI)=>(view, event, slice, type, insertMediaAsMediaSingle)=>$4cfeb607ceb33f88$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($4cfeb607ceb33f88$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: type
        }))((0, $1nSqW.handleMediaSingle)((0, $bMFKb.INPUT_METHOD).CLIPBOARD, insertMediaAsMediaSingle)(slice));
const $4cfeb607ceb33f88$export$ef36b80b79d1d973 = (view, event, slice, type, pluginInjectionApi)=>$4cfeb607ceb33f88$var$injectAnalyticsPayloadBeforeCommand(pluginInjectionApi?.analytics?.actions)($4cfeb607ceb33f88$var$createPasteAnalyticsPayloadBySelection(event, slice, {
        type: type
    }))((0, $1nSqW.handlePastePreservingMarks)(slice, pluginInjectionApi?.card?.actions?.queueCardsFromChangedTr));
const $4cfeb607ceb33f88$export$d7489d309972091e = (view, event, slice, pluginInjectionApi)=>$4cfeb607ceb33f88$var$injectAnalyticsPayloadBeforeCommand(pluginInjectionApi?.analytics?.actions)($4cfeb607ceb33f88$var$createPasteAnalyticsPayloadBySelection(event, slice, {
        type: (0, $j0X5g.PasteTypes).markdown
    }))((0, $1nSqW.handleMarkdown)(slice, pluginInjectionApi?.card?.actions?.queueCardsFromChangedTr));
const $4cfeb607ceb33f88$export$3ef868f9e7157717 = (view, event, slice, pluginInjectionApi)=>$4cfeb607ceb33f88$var$injectAnalyticsPayloadBeforeCommand(pluginInjectionApi?.analytics?.actions)($4cfeb607ceb33f88$var$createPasteAnalyticsPayloadBySelection(event, slice, {
        type: (0, $j0X5g.PasteTypes).richText
    }, pluginInjectionApi))((0, $1nSqW.handleRichText)(slice, pluginInjectionApi?.card?.actions?.queueCardsFromChangedTr));
const $4cfeb607ceb33f88$var$injectAnalyticsPayloadBeforeCommand = (editorAnalyticsAPI)=>(createPayloadByTransaction)=>{
        return (mainCommand)=>{
            return (state, dispatch, view)=>{
                let originalTransaction = state.tr;
                const fakeDispatch = (tr)=>{
                    originalTransaction = tr;
                };
                const result = mainCommand(state, fakeDispatch, view);
                if (!result) return false;
                if (dispatch && originalTransaction.docChanged) {
                    // it needs to know the selection before the changes
                    const payload = createPayloadByTransaction(state.selection);
                    editorAnalyticsAPI?.attachAnalyticsEvent(payload)(originalTransaction);
                    dispatch(originalTransaction);
                }
                return true;
            };
        };
    };
const $4cfeb607ceb33f88$export$2d195c5439ce2ebc = (editorAnalyticsAPI)=>(view, event, slice, findRootParentListNode)=>$4cfeb607ceb33f88$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($4cfeb607ceb33f88$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: (0, $j0X5g.PasteTypes).richText
        }))((0, $1nSqW.handlePastePanelOrDecisionContentIntoList)(slice, findRootParentListNode));
const $4cfeb607ceb33f88$export$bbc9709b7b4a2f6 = (editorAnalyticsAPI)=>(view, event, slice)=>$4cfeb607ceb33f88$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($4cfeb607ceb33f88$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: (0, $j0X5g.PasteTypes).richText,
            pasteSplitList: true
        }))((0, $1nSqW.handlePasteNonNestableBlockNodesIntoList)(slice));
const $4cfeb607ceb33f88$export$6681e5bfb9c8b704 = (editorAnalyticsAPI)=>(view, event, slice)=>$4cfeb607ceb33f88$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($4cfeb607ceb33f88$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: (0, $j0X5g.PasteTypes).richText,
            pasteSplitList: true
        }))((0, $1nSqW.handleExpandPaste)(slice));
const $4cfeb607ceb33f88$export$7dc8d4c52517a2f7 = (editorAnalyticsAPI, isNestingTablesSupported)=>(view, event, slice)=>$4cfeb607ceb33f88$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($4cfeb607ceb33f88$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: (0, $j0X5g.PasteTypes).richText,
            pasteSplitList: true
        }))((0, $1nSqW.handleNestedTablePaste)(slice, isNestingTablesSupported));
const $4cfeb607ceb33f88$export$6dbadac5ea22dd7a = (editorAnalyticsAPI)=>(view, event, slice)=>$4cfeb607ceb33f88$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($4cfeb607ceb33f88$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: (0, $j0X5g.PasteTypes).richText
        }))((0, $1nSqW.handleSelectedTable)(editorAnalyticsAPI)(slice));
const $4cfeb607ceb33f88$export$b36a7c9ea20b7bbf = (editorAnalyticsAPI)=>(view, event, slice, type)=>$4cfeb607ceb33f88$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($4cfeb607ceb33f88$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: type,
            hyperlinkPasteOnText: true
        }))((0, $1nSqW.handlePasteLinkOnSelectedText)(slice));
const $4cfeb607ceb33f88$export$5dd5834ba1e07721 = ({ view: view, duration: duration, content: content, distortedDuration: distortedDuration })=>{
    const pasteIntoNode = $4cfeb607ceb33f88$var$getActionSubjectId({
        selection: view.state.selection,
        schema: view.state.schema
    });
    return {
        action: (0, $bMFKb.ACTION).PASTED_TIMED,
        actionSubject: (0, $bMFKb.ACTION_SUBJECT).EDITOR,
        eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL,
        attributes: {
            pasteIntoNode: pasteIntoNode,
            content: content,
            time: duration,
            distortedDuration: distortedDuration
        }
    };
};
const $4cfeb607ceb33f88$export$629ff5588e070c83 = (content)=>{
    let nodeTypes = new Set();
    if (content.size) content.forEach((node)=>{
        if (node.content && node.content.size) nodeTypes = new Set([
            ...nodeTypes,
            ...$4cfeb607ceb33f88$export$629ff5588e070c83(node.content)
        ]);
        nodeTypes.add(node.type.name);
    });
    return Array.from(nodeTypes);
};

});
parcelRegister("bFyUX", function(module, exports) {

$parcel$export(module.exports, "isPastedFromWord", () => $a06a9e339294e95a$export$6ba9f527e53e4ac1);
$parcel$export(module.exports, "isPastedFromExcel", () => $a06a9e339294e95a$export$8d0b7622c89b176c);
$parcel$export(module.exports, "htmlContainsSingleFile", () => $a06a9e339294e95a$export$41d193509f55b76e);
$parcel$export(module.exports, "getPasteSource", () => $a06a9e339294e95a$export$e45b5b7458bacd81);
$parcel$export(module.exports, "escapeLinks", () => $a06a9e339294e95a$export$8acd10161c5f8b07);
$parcel$export(module.exports, "hasOnlyNodesOfType", () => $a06a9e339294e95a$export$a4568554bf9b43cd);
$parcel$export(module.exports, "applyTextMarksToSlice", () => $a06a9e339294e95a$export$3bf611fd421c1669);
$parcel$export(module.exports, "isEmptyNode", () => $a06a9e339294e95a$export$641fdf56f693bfbc);
$parcel$export(module.exports, "isCursorSelectionAtTextStartOrEnd", () => $a06a9e339294e95a$export$ee1d3ec5b3695690);
$parcel$export(module.exports, "isSelectionInsidePanel", () => $a06a9e339294e95a$export$3befc640b7d49184);
$parcel$export(module.exports, "htmlHasInvalidLinkTags", () => $a06a9e339294e95a$export$3c3a613abe5bb97d);
$parcel$export(module.exports, "removeDuplicateInvalidLinks", () => $a06a9e339294e95a$export$35ca1bb0581efaf3);
$parcel$export(module.exports, "addReplaceSelectedTableAnalytics", () => $a06a9e339294e95a$export$4f704994f6a89bd1);
$parcel$export(module.exports, "transformUnsupportedBlockCardToInline", () => $a06a9e339294e95a$export$9ffea5586131a948);

var $bMFKb = parcelRequire("bMFKb");
var $ey7La = parcelRequire("ey7La");

var $87fb1 = parcelRequire("87fb1");

var $9Ssie = parcelRequire("9Ssie");
var $gbisc = parcelRequire("gbisc");

var $3xw6l = parcelRequire("3xw6l");

var $3lIcL = parcelRequire("3lIcL");

var $BmspC = parcelRequire("BmspC");

var $exwOR = parcelRequire("exwOR");
var $bctVO = parcelRequire("bctVO");

var $bajro = parcelRequire("bajro");

var $eGOwo = parcelRequire("eGOwo");
function $a06a9e339294e95a$export$6ba9f527e53e4ac1(html) {
    return !!html && html.indexOf('urn:schemas-microsoft-com:office:word') >= 0;
}
function $a06a9e339294e95a$export$8d0b7622c89b176c(html) {
    return !!html && html.indexOf('urn:schemas-microsoft-com:office:excel') >= 0;
}
function $a06a9e339294e95a$var$isPastedFromDropboxPaper(html) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return !!html && !!html.match(/class=\"\s?author-d-.+"/gim);
}
function $a06a9e339294e95a$var$isPastedFromGoogleDocs(html) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return !!html && !!html.match(/id=\"docs-internal-guid-.+"/gim);
}
function $a06a9e339294e95a$var$isPastedFromGoogleSpreadSheets(html) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return !!html && !!html.match(/data-sheets-.+=/gim);
}
function $a06a9e339294e95a$var$isPastedFromPages(html) {
    return !!html && html.indexOf('content="Cocoa HTML Writer"') >= 0;
}
function $a06a9e339294e95a$var$isPastedFromFabricEditor(html) {
    return !!html && html.indexOf('data-pm-slice="') >= 0;
}
const $a06a9e339294e95a$export$6186a6a0af6a6a9d = (text)=>{
    return !!text && text.trim().split('\n').length === 1;
};
function $a06a9e339294e95a$export$41d193509f55b76e(html) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return !!html.match(/<img .*>/) && !(0, $bajro.isMediaBlobUrl)(html);
}
function $a06a9e339294e95a$export$e45b5b7458bacd81(event) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const html = event.clipboardData.getData('text/html');
    if ($a06a9e339294e95a$var$isPastedFromDropboxPaper(html)) return 'dropbox-paper';
    else if ($a06a9e339294e95a$export$6ba9f527e53e4ac1(html)) return 'microsoft-word';
    else if ($a06a9e339294e95a$export$8d0b7622c89b176c(html)) return 'microsoft-excel';
    else if ($a06a9e339294e95a$var$isPastedFromGoogleDocs(html)) return 'google-docs';
    else if ($a06a9e339294e95a$var$isPastedFromGoogleSpreadSheets(html)) return 'google-spreadsheets';
    else if ($a06a9e339294e95a$var$isPastedFromPages(html)) return 'apple-pages';
    else if ($a06a9e339294e95a$var$isPastedFromFabricEditor(html)) return 'fabric-editor';
    return 'uncategorized';
}
function $a06a9e339294e95a$export$8acd10161c5f8b07(text) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return text.replace(/(\[([^\]]+)\]\()?((https?|ftp|jamfselfservice):\/\/[^\s>"]+)/g, (str)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        return str.match(/^(https?|ftp|jamfselfservice):\/\/[^\s>"]+$/) ? `<${str}>` : str;
    });
}
function $a06a9e339294e95a$export$a4568554bf9b43cd(...nodeTypes) {
    return (slice)=>{
        let hasOnlyNodesOfType = true;
        slice.content.descendants((node)=>{
            hasOnlyNodesOfType = hasOnlyNodesOfType && nodeTypes.indexOf(node.type) > -1;
            return hasOnlyNodesOfType;
        });
        return hasOnlyNodesOfType;
    };
}
function $a06a9e339294e95a$export$3bf611fd421c1669(schema, marks) {
    return (slice)=>{
        const { marks: { code: codeMark, link: linkMark, annotation: annotationMark } } = schema;
        if (!Array.isArray(marks) || marks.length === 0) return slice;
        const sliceCopy = (0, $3xw6l.Slice).fromJSON(schema, slice.toJSON() || {});
        // allow links and annotations to be pasted
        const allowedMarksToPaste = [
            linkMark,
            annotationMark
        ];
        sliceCopy.content.descendants((node, _pos, parent)=>{
            if (node.isText && parent && parent.isBlock) {
                // @ts-ignore - [unblock prosemirror bump] assigning to readonly prop
                node.marks = [
                    // remove all marks from pasted slice when applying code mark
                    // and exclude all marks that are not allowed to be pasted
                    ...node.marks && !codeMark.isInSet(marks) && node.marks.filter((mark)=>allowedMarksToPaste.includes(mark.type)) || [],
                    // add marks to a slice if they're allowed in parent node
                    // and exclude link marks
                    ...parent.type.allowedMarks(marks).filter((mark)=>mark.type !== linkMark)
                ].sort((0, $87fb1.sortByOrderWithTypeName)('marks'));
                return false;
            }
            if ((0, $eGOwo.fg)('editor_inline_comments_paste_insert_nodes')) {
                if (node.isInline && [
                    'inlineCard',
                    'emoji',
                    'status',
                    'date',
                    'mention'
                ].includes(node.type.name) && parent && parent.isBlock) // @ts-ignore - [unblock prosemirror bump] assigning to readonly prop
                node.marks = [
                    ...node.marks,
                    ...parent.type.allowedMarks(marks).filter((mark)=>mark.type === schema.marks.annotation)
                ];
            }
            return true;
        });
        return sliceCopy;
    };
}
function $a06a9e339294e95a$export$641fdf56f693bfbc(node) {
    if (!node) return false;
    const { type: nodeType } = node;
    const emptyNode = nodeType.createAndFill();
    return emptyNode && emptyNode.nodeSize === node.nodeSize && emptyNode.content.eq(node.content) && (0, $3xw6l.Mark).sameSet(emptyNode.marks, node.marks);
}
function $a06a9e339294e95a$export$ee1d3ec5b3695690(selection) {
    return selection instanceof (0, $3lIcL.TextSelection) && selection.empty && selection.$cursor && (!selection.$cursor.nodeBefore || !selection.$cursor.nodeAfter);
}
function $a06a9e339294e95a$export$c7c9ca5cba02ff5a(node) {
    return Boolean(node && node.type.name === 'panel');
}
function $a06a9e339294e95a$export$3befc640b7d49184(selection) {
    if (selection instanceof (0, $3lIcL.NodeSelection) && $a06a9e339294e95a$export$c7c9ca5cba02ff5a(selection.node)) return selection.node;
    const { doc: { type: { schema: { nodes: { panel: panel } } } } } = selection.$from;
    const panelPosition = (0, $BmspC.findParentNodeOfType)(panel)(selection);
    if (panelPosition) return panelPosition.node;
    return null;
}
const $a06a9e339294e95a$export$3c3a613abe5bb97d = (html)=>{
    return !!html && (html.includes('</a></a>') || html.includes('"></a><a'));
};
const $a06a9e339294e95a$export$35ca1bb0581efaf3 = (html)=>{
    if ($a06a9e339294e95a$export$3c3a613abe5bb97d(html)) {
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        const htmlArray = html.split(/(?=<a)/);
        const htmlArrayWithoutInvalidLinks = htmlArray.filter((item)=>{
            return !(item.includes('<a') && item.includes('"></a>')) && !(item.includes('<a') && !item.includes('</a>'));
        });
        const fixedHtml = htmlArrayWithoutInvalidLinks.join('')// Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        .replace(/<\/a><\/a>/gi, '</a>')// Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        .replace(/<a>/gi, '<a');
        return fixedHtml;
    }
    return html;
};
const $a06a9e339294e95a$export$4f704994f6a89bd1 = (state, tr, editorAnalyticsAPI)=>{
    if ((0, $bctVO.isTableSelected)(state.selection)) {
        const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $exwOR.getSelectedTableInfo)(state.selection);
        editorAnalyticsAPI?.attachAnalyticsEvent({
            action: (0, $ey7La.TABLE_ACTION).REPLACED,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).TABLE,
            attributes: {
                totalColumnCount: totalColumnCount,
                totalRowCount: totalRowCount,
                inputMethod: (0, $bMFKb.INPUT_METHOD).CLIPBOARD
            },
            eventType: (0, $bMFKb.EVENT_TYPE).TRACK
        })(tr);
        return tr;
    }
    return state.tr;
};
const $a06a9e339294e95a$export$9ffea5586131a948 = (slice, state, cardOptions)=>{
    const { blockCard: blockCard, inlineCard: inlineCard } = state.schema.nodes;
    const children = [];
    (0, $gbisc.mapChildren)(slice.content, (node, i, frag)=>{
        if (node.type === blockCard && !$a06a9e339294e95a$var$isBlockCardSupported(state, frag, cardOptions?.allowBlockCards ?? false)) children.push(inlineCard.createChecked(node.attrs, node.content, node.marks));
        else children.push(node);
    });
    return new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).fromArray(children), slice.openStart, slice.openEnd);
};
/**
 * Function to determine if a block card is supported by the editor
 * @param state
 * @param frag
 * @param allowBlockCards
 * @returns
 */ const $a06a9e339294e95a$var$isBlockCardSupported = (state, frag, allowBlockCards)=>{
    return allowBlockCards && (0, $9Ssie.isSupportedInParent)(state, frag);
};

});
parcelRegister("ey7La", function(module, exports) {

$parcel$export(module.exports, "TABLE_ACTION", () => $1d46e73d9b1920d5$export$1627223e090990cf);
$parcel$export(module.exports, "TABLE_OVERFLOW_CHANGE_TRIGGER", () => $1d46e73d9b1920d5$export$e0b2ad636c1c8ab4);
$parcel$export(module.exports, "TABLE_STATUS", () => $1d46e73d9b1920d5$export$90dde066fa32cf2f);
$parcel$export(module.exports, "TABLE_DISPLAY_MODE", () => $1d46e73d9b1920d5$export$a62a68f32aa71693);
$parcel$export(module.exports, "CHANGE_ALIGNMENT_REASON", () => $1d46e73d9b1920d5$export$ba2dfc055a59d951);
var $1d46e73d9b1920d5$export$1627223e090990cf = /*#__PURE__*/ function(TABLE_ACTION) {
    TABLE_ACTION["DELETED"] = "deleted";
    TABLE_ACTION["CLEARED"] = "cleared";
    TABLE_ACTION["COLLAPSED"] = "collapsed";
    TABLE_ACTION["MERGED"] = "merged";
    TABLE_ACTION["SPLIT"] = "split";
    TABLE_ACTION["COLORED"] = "colored";
    TABLE_ACTION["TOGGLED_HEADER_COLUMN"] = "toggledHeaderColumn";
    TABLE_ACTION["TOGGLED_HEADER_ROW"] = "toggledHeaderRow";
    TABLE_ACTION["TOGGLED_NUMBER_COLUMN"] = "toggledNumberColumn";
    TABLE_ACTION["CHANGED_BREAKOUT_MODE"] = "changedBreakoutMode";
    TABLE_ACTION["CUT"] = "cut";
    TABLE_ACTION["COPIED"] = "copied";
    TABLE_ACTION["ADDED_ROW"] = "addedRow";
    TABLE_ACTION["ADDED_COLUMN"] = "addedColumn";
    TABLE_ACTION["DELETED_ROW"] = "deletedRow";
    TABLE_ACTION["DELETED_COLUMN"] = "deletedColumn";
    TABLE_ACTION["SORTED_COLUMN"] = "sortedColumn";
    TABLE_ACTION["REPLACED"] = "replaced";
    TABLE_ACTION["ATTEMPTED_TABLE_WIDTH_CHANGE"] = "attemptedTableWidthChange";
    TABLE_ACTION["DISTRIBUTED_COLUMNS_WIDTHS"] = "distributedColumnsWidths";
    TABLE_ACTION["FIXED"] = "fixed";
    TABLE_ACTION["RESIZED"] = "resized";
    TABLE_ACTION["RESIZE_PERF_SAMPLING"] = "resizePerfSampling";
    TABLE_ACTION["COLUMN_RESIZED"] = "columnResized";
    TABLE_ACTION["OVERFLOW_CHANGED"] = "overflowChanged";
    TABLE_ACTION["INITIAL_OVERFLOW_CAPTURED"] = "initialOverflowCaptured";
    TABLE_ACTION["MOVED_ROW"] = "movedRow";
    TABLE_ACTION["MOVED_COLUMN"] = "movedColumn";
    TABLE_ACTION["CLONED_ROW"] = "clonedRow";
    TABLE_ACTION["CLONED_COLUMN"] = "clonedColumn";
    /**
	 * This is a unique action that's used to track legacy table move behaviour flow of insert+copy+paste. Please use
	 * the MOVED_ROW | MOVED_COLUMN actions if you want to track events which move row/cols in a single step.
	 */ TABLE_ACTION["ROW_OR_COLUMN_MOVED"] = "rowOrColumnMoved";
    TABLE_ACTION["CHANGED_DISPLAY_MODE"] = "changedDisplayMode";
    TABLE_ACTION["CHANGED_ALIGNMENT"] = "changedAlignment";
    // Temporary to track usage of CONFCLOUD-78239 bug
    TABLE_ACTION["TABLE_CELL_BACKGROUND_FIXED"] = "tableCellBackgroundFixed";
    return TABLE_ACTION;
}({});
var $1d46e73d9b1920d5$export$6b0804bad09b61c6 = /*#__PURE__*/ function(TABLE_BREAKOUT) {
    TABLE_BREAKOUT["WIDE"] = "wide";
    TABLE_BREAKOUT["FULL_WIDTH"] = "fullWidth";
    TABLE_BREAKOUT["NORMAL"] = "normal";
    return TABLE_BREAKOUT;
}({});
var $1d46e73d9b1920d5$export$e0b2ad636c1c8ab4 = /*#__PURE__*/ function(TABLE_OVERFLOW_CHANGE_TRIGGER) {
    TABLE_OVERFLOW_CHANGE_TRIGGER["EXTERNAL"] = "external";
    TABLE_OVERFLOW_CHANGE_TRIGGER["ADDED_COLUMN"] = "addedColumn";
    TABLE_OVERFLOW_CHANGE_TRIGGER["DELETED_COLUMN"] = "deletedColumn";
    TABLE_OVERFLOW_CHANGE_TRIGGER["RESIZED_COLUMN"] = "resizedColumn";
    TABLE_OVERFLOW_CHANGE_TRIGGER["ENABLED_NUMBERED_COLUMN"] = "enabledNumberedColumn";
    TABLE_OVERFLOW_CHANGE_TRIGGER["DISABLED_NUMBERED_COLUMN"] = "disabledNumberedColumn";
    TABLE_OVERFLOW_CHANGE_TRIGGER["DISTRIBUTED_COLUMNS"] = "distributedColumnsWidths";
    TABLE_OVERFLOW_CHANGE_TRIGGER["RESIZED"] = "resizedTable";
    return TABLE_OVERFLOW_CHANGE_TRIGGER;
}({});
var $1d46e73d9b1920d5$export$90dde066fa32cf2f = /*#__PURE__*/ function(TABLE_STATUS) {
    TABLE_STATUS["SUCCESS"] = "success";
    TABLE_STATUS["CANCELLED"] = "cancelled";
    TABLE_STATUS["INVALID"] = "invalid";
    return TABLE_STATUS;
}({});
var $1d46e73d9b1920d5$export$a62a68f32aa71693 = /*#__PURE__*/ function(TABLE_DISPLAY_MODE) {
    TABLE_DISPLAY_MODE["FIXED"] = "fixed";
    TABLE_DISPLAY_MODE["DEFAULT"] = "default";
    TABLE_DISPLAY_MODE["INITIAL"] = "initial";
    return TABLE_DISPLAY_MODE;
}({});
var $1d46e73d9b1920d5$export$ba2dfc055a59d951 = /*#__PURE__*/ function(CHANGE_ALIGNMENT_REASON) {
    CHANGE_ALIGNMENT_REASON["TABLE_RESIZING"] = "tableResizing";
    CHANGE_ALIGNMENT_REASON["TABLE_COLUMN_RESIZED"] = "tableColumnResized";
    CHANGE_ALIGNMENT_REASON["EDITOR_APPEARANCE_CHANGED"] = "editorAppearanceChanged";
    CHANGE_ALIGNMENT_REASON["TOOLBAR_OPTION_CHANGED"] = "toolbarOptionChanged";
    return CHANGE_ALIGNMENT_REASON;
}({});

});

parcelRegister("exwOR", function(module, exports) {

$parcel$export(module.exports, "getSelectedTableInfo", () => $76d59b70b17f9a56$export$d2cf64960b17e12e);
$parcel$export(module.exports, "getSelectedCellInfo", () => $76d59b70b17f9a56$export$277d5394a2608229);

var $2vA54 = parcelRequire("2vA54");

var $kuDbA = parcelRequire("kuDbA");

var $hs2hB = parcelRequire("hs2hB");
function $76d59b70b17f9a56$export$d2cf64960b17e12e(selection) {
    let map;
    let totalRowCount = 0;
    let totalColumnCount = 0;
    const table = (0, $kuDbA.findTable)(selection);
    if (table) {
        map = (0, $2vA54.TableMap).get(table.node);
        totalRowCount = map.height;
        totalColumnCount = map.width;
    }
    return {
        table: table,
        map: map,
        totalRowCount: totalRowCount,
        totalColumnCount: totalColumnCount
    };
}
function $76d59b70b17f9a56$export$277d5394a2608229(selection) {
    let horizontalCells = 1;
    let verticalCells = 1;
    let totalCells = 1;
    const { table: table, map: map, totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = $76d59b70b17f9a56$export$d2cf64960b17e12e(selection);
    if (table && map) {
        const rect = (0, $hs2hB.getSelectionRect)(selection);
        if (rect) {
            totalCells = map.cellsInRect(rect).length;
            horizontalCells = rect.right - rect.left;
            verticalCells = rect.bottom - rect.top;
        }
    }
    return {
        totalRowCount: totalRowCount,
        totalColumnCount: totalColumnCount,
        horizontalCells: horizontalCells,
        verticalCells: verticalCells,
        totalCells: totalCells
    };
}

});
parcelRegister("kuDbA", function(module, exports) {

$parcel$export(module.exports, "findTable", () => $b569d06a5ec21d0c$export$1ae6a0a4f7784fc4);
$parcel$export(module.exports, "findTableClosestToPos", () => $b569d06a5ec21d0c$export$9323c80f9a3e899f);
$parcel$export(module.exports, "findCellClosestToPos", () => $b569d06a5ec21d0c$export$3ac56532a0bf4018);
$parcel$export(module.exports, "findCellRectClosestToPos", () => $b569d06a5ec21d0c$export$68680ae223aebfa7);

var $BmspC = parcelRequire("BmspC");

var $2vA54 = parcelRequire("2vA54");
const $b569d06a5ec21d0c$export$1ae6a0a4f7784fc4 = (selection)=>(0, $BmspC.findParentNode)((node)=>node.type.spec.tableRole && node.type.spec.tableRole === 'table')(selection);
const $b569d06a5ec21d0c$export$9323c80f9a3e899f = ($pos)=>{
    const predicate = (node)=>node.type.spec.tableRole && node.type.spec.tableRole === 'table';
    return (0, $BmspC.findParentNodeClosestToPos)($pos, predicate);
};
const $b569d06a5ec21d0c$export$3ac56532a0bf4018 = ($pos)=>{
    const predicate = (node)=>// Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        node.type.spec.tableRole && /cell/i.test(node.type.spec.tableRole);
    return (0, $BmspC.findParentNodeClosestToPos)($pos, predicate);
};
const $b569d06a5ec21d0c$export$68680ae223aebfa7 = ($pos)=>{
    const cell = $b569d06a5ec21d0c$export$3ac56532a0bf4018($pos);
    if (cell) {
        const table = $b569d06a5ec21d0c$export$9323c80f9a3e899f($pos);
        if (table) {
            const map = (0, $2vA54.TableMap).get(table.node);
            const cellPos = cell.pos - table.start;
            return map.rectBetween(cellPos, cellPos);
        }
    }
};

});

parcelRegister("hs2hB", function(module, exports) {

$parcel$export(module.exports, "getSelectionRect", () => $66110a9b78781fc4$export$aa946c0ed562e2ed);

var $2vA54 = parcelRequire("2vA54");

var $6dtFv = parcelRequire("6dtFv");
const $66110a9b78781fc4$export$aa946c0ed562e2ed = (selection)=>{
    if (!(0, $6dtFv.isSelectionType)(selection, 'cell')) return;
    const start = selection.$anchorCell.start(-1);
    const map = (0, $2vA54.TableMap).get(selection.$anchorCell.node(-1));
    return map.rectBetween(selection.$anchorCell.pos - start, selection.$headCell.pos - start);
};

});


parcelRegister("bctVO", function(module, exports) {

$parcel$export(module.exports, "isColumnSelected", () => $d039a68c7fe73dcc$export$8db1cdcc0c397a6d);
$parcel$export(module.exports, "isRowSelected", () => $d039a68c7fe73dcc$export$710e11cf672b86c);
$parcel$export(module.exports, "isTableSelected", () => $d039a68c7fe73dcc$export$5d08de4a0eeb0408);

var $2vA54 = parcelRequire("2vA54");

var $6dtFv = parcelRequire("6dtFv");
const $d039a68c7fe73dcc$export$d06743a3adc2076d = (rect)=>(selection)=>{
        if (!(0, $6dtFv.isSelectionType)(selection, 'cell')) return false;
        const map = (0, $2vA54.TableMap).get(selection.$anchorCell.node(-1));
        const start = selection.$anchorCell.start(-1);
        const cells = map.cellsInRect(rect);
        const selectedCells = map.cellsInRect(map.rectBetween(selection.$anchorCell.pos - start, selection.$headCell.pos - start));
        for(let i = 0, count = cells.length; i < count; i++){
            if (selectedCells.indexOf(cells[i]) === -1) return false;
        }
        return true;
    };
const $d039a68c7fe73dcc$export$8db1cdcc0c397a6d = (columnIndex)=>(selection)=>{
        if ((0, $6dtFv.isSelectionType)(selection, 'cell')) {
            const map = (0, $2vA54.TableMap).get(selection.$anchorCell.node(-1));
            return $d039a68c7fe73dcc$export$d06743a3adc2076d({
                left: columnIndex,
                right: columnIndex + 1,
                top: 0,
                bottom: map.height
            })(selection);
        }
        return false;
    };
const $d039a68c7fe73dcc$export$710e11cf672b86c = (rowIndex)=>(selection)=>{
        if ((0, $6dtFv.isSelectionType)(selection, 'cell')) {
            const map = (0, $2vA54.TableMap).get(selection.$anchorCell.node(-1));
            return $d039a68c7fe73dcc$export$d06743a3adc2076d({
                left: 0,
                right: map.width,
                top: rowIndex,
                bottom: rowIndex + 1
            })(selection);
        }
        return false;
    };
const $d039a68c7fe73dcc$export$5d08de4a0eeb0408 = (selection)=>{
    if ((0, $6dtFv.isSelectionType)(selection, 'cell')) {
        const map = (0, $2vA54.TableMap).get(selection.$anchorCell.node(-1));
        return $d039a68c7fe73dcc$export$d06743a3adc2076d({
            left: 0,
            right: map.width,
            top: 0,
            bottom: map.height
        })(selection);
    }
    return false;
};

});


parcelRegister("1nSqW", function(module, exports) {

$parcel$export(module.exports, "handleMention", () => $a3cc84ee80caab1f$export$7097a0398467de9c);
$parcel$export(module.exports, "handlePasteIntoTaskOrDecisionOrPanel", () => $a3cc84ee80caab1f$export$af959912bf89ae42);
$parcel$export(module.exports, "handlePasteNonNestableBlockNodesIntoList", () => $a3cc84ee80caab1f$export$b8a52be876d0b84f);
$parcel$export(module.exports, "handlePastePanelOrDecisionContentIntoList", () => $a3cc84ee80caab1f$export$3fd7f6d89a9d2cac);
$parcel$export(module.exports, "handlePasteLinkOnSelectedText", () => $a3cc84ee80caab1f$export$5e27b285bdcc71bf);
$parcel$export(module.exports, "handlePasteAsPlainText", () => $a3cc84ee80caab1f$export$efe55f809fabb910);
$parcel$export(module.exports, "handlePastePreservingMarks", () => $a3cc84ee80caab1f$export$de618421675f910e);
$parcel$export(module.exports, "handleMacroAutoConvert", () => $a3cc84ee80caab1f$export$d23738992a74c3a9);
$parcel$export(module.exports, "handleMarkdown", () => $a3cc84ee80caab1f$export$4b83e18c607f848f);
$parcel$export(module.exports, "handleCodeBlock", () => $a3cc84ee80caab1f$export$98135102f7ccdef2);
$parcel$export(module.exports, "handleMediaSingle", () => $a3cc84ee80caab1f$export$5fb647c5a57bac64);
$parcel$export(module.exports, "handleTableContentPasteInBodiedExtension", () => $a3cc84ee80caab1f$export$36e0fe2cadced224);
$parcel$export(module.exports, "handleNestedTablePaste", () => $a3cc84ee80caab1f$export$113227139658cc8d);
$parcel$export(module.exports, "handleExpandPaste", () => $a3cc84ee80caab1f$export$a497757c6eac4530);
$parcel$export(module.exports, "handleParagraphBlockMarks", () => $a3cc84ee80caab1f$export$feb0d61bf65d9267);
$parcel$export(module.exports, "handleRichText", () => $a3cc84ee80caab1f$export$f9c7e15c780a77d0);
$parcel$export(module.exports, "handlePasteIntoCaption", () => $a3cc84ee80caab1f$export$d399a86cc775ad7e);
$parcel$export(module.exports, "handleSelectedTable", () => $a3cc84ee80caab1f$export$4ce587bb5876886d);

var $8KLBw = parcelRequire("8KLBw");

var $bMFKb = parcelRequire("bMFKb");

var $eQTBG = parcelRequire("eQTBG");

var $02q9c = parcelRequire("02q9c");

var $lQJJa = parcelRequire("lQJJa");

var $6BNUN = parcelRequire("6BNUN");

var $grDTV = parcelRequire("grDTV");
var $3ADzg = parcelRequire("3ADzg");
var $9Ssie = parcelRequire("9Ssie");
var $fCXIH = parcelRequire("fCXIH");
var $gbisc = parcelRequire("gbisc");

var $kuxd1 = parcelRequire("kuxd1");

var $3xw6l = parcelRequire("3xw6l");

var $3lIcL = parcelRequire("3lIcL");

var $BmspC = parcelRequire("BmspC");

var $8hKAd = parcelRequire("8hKAd");

var $92xoS = parcelRequire("92xoS");

var $1CqHB = parcelRequire("1CqHB");

var $3Elhj = parcelRequire("3Elhj");

var $3CAWf = parcelRequire("3CAWf");

var $es8xl = parcelRequire("es8xl");

var $bFyUX = parcelRequire("bFyUX");
const $a3cc84ee80caab1f$var$insideExpand = (state)=>{
    const { expand: expand, nestedExpand: nestedExpand } = state.schema.nodes;
    return (0, $BmspC.hasParentNodeOfType)([
        expand,
        nestedExpand
    ])(state.selection);
};
/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Compose 1 to n functions.
 * @param func first function
 * @param funcs additional functions
 */ function $a3cc84ee80caab1f$var$compose(func, ...funcs) {
    const allFuncs = [
        func,
        ...funcs
    ];
    return function composed(raw) {
        return allFuncs.reduceRight((memo, func)=>func(memo), raw);
    };
}
function $a3cc84ee80caab1f$export$7097a0398467de9c(slice, schema) {
    return (0, $gbisc.mapSlice)(slice, (node)=>{
        // We should move this to the mention plugin when we refactor how paste works in the future
        // For now we can just null check mention exists in the schema to ensure we don't crash if it doesn't
        // exist.
        if (node.type.name === schema.nodes.mention?.name) {
            const mention = node.attrs;
            const newMention = {
                ...mention,
                text: ''
            };
            return schema.nodes.mention.create(newMention, node.content, node.marks);
        }
        return node;
    });
}
function $a3cc84ee80caab1f$export$af959912bf89ae42(slice, queueCardsFromChangedTr) {
    return (state, dispatch)=>{
        const { schema: schema, tr: { selection: selection } } = state;
        const { marks: { code: codeMark }, nodes: { decisionItem: decisionItem, emoji: emoji, hardBreak: hardBreak, mention: mention, paragraph: paragraph, taskItem: taskItem, text: text, panel: panel, bulletList: bulletList, orderedList: orderedList, taskList: taskList, listItem: listItem, expand: expand, heading: heading, codeBlock: codeBlock } } = schema;
        const selectionIsValidNode = state.selection instanceof (0, $3lIcL.NodeSelection) && [
            'decisionList',
            'decisionItem',
            'taskList',
            'taskItem'
        ].includes(state.selection.node.type.name);
        const selectionHasValidParentNode = (0, $BmspC.hasParentNodeOfType)([
            decisionItem,
            taskItem,
            panel
        ])(state.selection);
        const selectionIsCodeBlock = (0, $BmspC.hasParentNodeOfType)([
            codeBlock
        ])(state.selection);
        const panelNode = (0, $bFyUX.isSelectionInsidePanel)(selection);
        const selectionIsPanel = Boolean(panelNode);
        // we avoid handling codeBlock-in-panel use case in this function
        // returning false will allow code to flow into `handleCodeBlock` function
        if (selectionIsPanel && selectionIsCodeBlock) return false;
        // Some types of content should be handled by the default handler, not this function.
        // Check through slice content to see if it contains an invalid node.
        let sliceIsInvalid = false;
        let sliceHasTask = false;
        slice.content.nodesBetween(0, slice.content.size, (node)=>{
            if (node.type === bulletList || node.type === orderedList || node.type === expand || node.type === heading || node.type === listItem) sliceIsInvalid = true;
            if (selectionIsPanel && node.type === taskList) sliceHasTask = true;
        });
        // If the selection is a panel,
        // and the slice's first node is a paragraph
        // and it is not from a depth that would indicate it being from inside from another node (e.g. text from a decision)
        // then we can rely on the default behaviour.
        const selectionIsTaskOrDecision = (0, $BmspC.hasParentNode)((node)=>node.type === taskItem || node.type === decisionItem)(selection);
        const sliceIsAPanelReceivingLowDepthText = selectionIsPanel && !selectionIsTaskOrDecision && slice.content.firstChild?.type === paragraph && slice.openEnd < 2;
        if (sliceIsInvalid || sliceIsAPanelReceivingLowDepthText || !selectionIsValidNode && !selectionHasValidParentNode) return false;
        const filters = [
            (0, $grDTV.linkifyContent)(schema)
        ];
        const selectionMarks = selection.$head.marks();
        if (selection instanceof (0, $3lIcL.TextSelection) && Array.isArray(selectionMarks) && selectionMarks.length > 0 && (0, $bFyUX.hasOnlyNodesOfType)(paragraph, text, emoji, mention, hardBreak)(slice) && (!codeMark.isInSet(selectionMarks) || (0, $02q9c.anyMarkActive)(state, codeMark) // check if there is a code mark anywhere in the selection
        )) filters.push((0, $bFyUX.applyTextMarksToSlice)(schema, selection.$head.marks()));
        const transformedSlice = $a3cc84ee80caab1f$var$compose.apply(null, filters)(slice);
        const isFirstChildTaskNode = transformedSlice.content.firstChild.type === taskList || transformedSlice.content.firstChild.type === taskItem;
        const tr = (0, $kuxd1.closeHistory)(state.tr);
        if (panelNode && sliceHasTask && slice.content.firstChild?.type === panel && (0, $bFyUX.isEmptyNode)(panelNode) && selection.$from.node() === selection.$to.node()) return Boolean((0, $es8xl.insertSliceInsideOfPanelNodeSelected)(panelNode)({
            tr: tr,
            slice: slice
        }));
        const transformedSliceIsValidNode = (transformedSlice.content.firstChild.type.inlineContent || [
            'decisionList',
            'decisionItem',
            'taskItem',
            'taskList',
            'panel'
        ].includes(transformedSlice.content.firstChild.type.name)) && (!(0, $3ADzg.isInListItem)(state) || (0, $3ADzg.isInListItem)(state) && isFirstChildTaskNode);
        // If the slice or the selection are valid nodes to handle,
        // and the slice is not a whole node (i.e. openStart is 1 and openEnd is 0)
        // or the slice's first node is a paragraph,
        // then we can replace the selection with our slice.
        const pastingIntoExtendedPanel = selectionIsPanel && panel.validContent(transformedSlice.content);
        if ((transformedSliceIsValidNode || selectionIsValidNode) && !pastingIntoExtendedPanel && !(transformedSlice.openStart === 1 && transformedSlice.openEnd === 0 || // Whole codeblock node has reverse slice depths.
        transformedSlice.openStart === 0 && transformedSlice.openEnd === 1) || transformedSlice.content.firstChild?.type === paragraph) tr.replaceSelection(transformedSlice).scrollIntoView();
        else {
            const isWholeContentSelected = selection.$from.pos === selection.$from.start() && selection.$to.end() === selection.$to.pos;
            if (pastingIntoExtendedPanel && selection.$from.pos !== selection.$to.pos && !isWholeContentSelected) // Do a replaceSelection if the entire panel content isn't selected
            //tr.replaceSelection(transformedSlice).scrollIntoView();
            tr.replaceSelection(new (0, $3xw6l.Slice)(transformedSlice.content, 0, transformedSlice.openEnd)).scrollIntoView();
            else if ([
                'mediaSingle'
            ].includes(transformedSlice.content.firstChild.type.name) && selectionIsPanel) {
                const parentNode = (0, $BmspC.findParentNodeOfType)(panel)(selection);
                if (selectionIsPanel && parentNode && (0, $3ADzg.isNodeEmpty)(parentNode.node)) {
                    tr.insert(selection.$from.pos, transformedSlice.content).scrollIntoView();
                    // Place the cursor at the the end of the insersertion
                    const endPos = tr.selection.from + transformedSlice.size;
                    tr.setSelection(new (0, $3lIcL.TextSelection)(tr.doc.resolve(endPos)));
                } else tr.replaceSelection(transformedSlice).scrollIntoView();
            } else {
                if (pastingIntoExtendedPanel && isWholeContentSelected) // if the entire panel content is selected, doing a replaceSelection removes the panel as well. Hence we do delete followed by safeInsert
                tr.delete(selection.$from.pos, selection.$to.pos);
                // This maintains both the selection (destination) and the slice (paste content).
                (0, $BmspC.safeInsert)(transformedSlice.content)(tr).scrollIntoView();
                if (transformedSlice.content.lastChild?.type?.name === 'rule') tr.setSelection((0, $3lIcL.TextSelection).near(tr.doc.resolve(tr.selection.$from.pos + transformedSlice.content.size)));
                else {
                    // safeInsert doesn't set correct cursor position
                    // it moves the cursor to beginning of the node
                    // we manually shift the cursor to end of the node
                    const nextPos = tr.doc.resolve(tr.selection.$from.end());
                    tr.setSelection(new (0, $3lIcL.TextSelection)(nextPos));
                }
            }
        }
        queueCardsFromChangedTr?.(state, tr, (0, $bMFKb.INPUT_METHOD).CLIPBOARD);
        if (dispatch) dispatch(tr);
        return true;
    };
}
function $a3cc84ee80caab1f$export$b8a52be876d0b84f(slice) {
    return (state, dispatch)=>{
        const { tr: tr } = state;
        const { selection: selection } = tr;
        const { $from: $from, $to: $to, from: from, to: to } = selection;
        const { orderedList: orderedList, bulletList: bulletList, listItem: listItem } = state.schema.nodes;
        // Selected nodes
        const selectionParentListItemNode = (0, $BmspC.findParentNodeOfType)(listItem)(selection);
        const selectionParentListNodeWithPos = (0, $BmspC.findParentNodeOfType)([
            bulletList,
            orderedList
        ])(selection);
        const selectionParentListNode = selectionParentListNodeWithPos?.node;
        // Slice info
        const sliceContent = slice.content;
        const sliceIsListItems = (0, $fCXIH.isListNode)(sliceContent.firstChild) && (0, $fCXIH.isListNode)(sliceContent.lastChild);
        // Find case of slices that can be inserted into a list item
        // (eg. paragraphs, list items, code blocks, media single)
        // These scenarios already get handled elsewhere and don't need to split the list
        let sliceContainsBlockNodesOtherThanThoseAllowedInListItem = false;
        slice.content.forEach((child)=>{
            if (!listItem || child.isBlock && !listItem.spec.content?.includes(child.type.name)) sliceContainsBlockNodesOtherThanThoseAllowedInListItem = true;
        });
        if (!selectionParentListItemNode || !sliceContent || (0, $BmspC.canInsert)($from, sliceContent) || // eg. inline nodes that can be inserted in a list item
        !sliceContainsBlockNodesOtherThanThoseAllowedInListItem || sliceIsListItems || !selectionParentListNodeWithPos) return false;
        // Offsets
        const listWrappingOffset = $to.depth - selectionParentListNodeWithPos.depth + 1; // difference in depth between to position and list node
        const listItemWrappingOffset = $to.depth - selectionParentListNodeWithPos.depth; // difference in depth between to position and list item node
        // Anything to do with nested lists should safeInsert and not be handled here
        if ($a3cc84ee80caab1f$export$67c0f4368bb304c3(state)) return false;
        // Node after the insert position
        const nodeAfterInsertPositionIsListItem = tr.doc.nodeAt(to + listItemWrappingOffset)?.type.name === 'listItem';
        // Get the next list items position (used later to find the split out ordered list)
        const indexOfNextListItem = $to.indexAfter($to.depth - listItemWrappingOffset);
        const positionOfNextListItem = tr.doc.resolve(selectionParentListNodeWithPos.pos + 1).posAtIndex(indexOfNextListItem);
        // These nodes paste as plain text by default so need to be handled differently
        const sliceContainsNodeThatPastesAsPlainText = sliceContent.firstChild && [
            'taskItem',
            'taskList',
            'heading',
            'blockquote'
        ].includes(sliceContent.firstChild.type.name);
        // Work out position to replace up to
        let replaceTo;
        if (sliceContainsNodeThatPastesAsPlainText && nodeAfterInsertPositionIsListItem) replaceTo = to + listItemWrappingOffset;
        else if (sliceContainsNodeThatPastesAsPlainText || !nodeAfterInsertPositionIsListItem) replaceTo = to;
        else replaceTo = to + listWrappingOffset;
        // handle the insertion of the slice
        if (slice.content.firstChild?.type.name === 'blockquote' && (0, $BmspC.contains)(slice.content.firstChild, state.schema.nodes.listItem)) (0, $3CAWf.insertSliceInsideBlockquote)({
            tr: tr,
            slice: slice
        });
        else if (sliceContainsNodeThatPastesAsPlainText || nodeAfterInsertPositionIsListItem || sliceContent.childCount > 1 && sliceContent.firstChild?.type.name !== 'paragraph') tr.replaceWith(from, replaceTo, sliceContent).scrollIntoView();
        else // When the selection is not at the end of a list item
        // eg. middle of list item, start of list item
        tr.replaceSelection(slice).scrollIntoView();
        // Find the ordered list node after the pasted content so we can set it's order
        const mappedPositionOfNextListItem = tr.mapping.map(positionOfNextListItem);
        if (mappedPositionOfNextListItem > tr.doc.nodeSize) return false;
        const nodeAfterPastedContentResolvedPos = (0, $BmspC.findParentNodeOfTypeClosestToPos)(tr.doc.resolve(mappedPositionOfNextListItem), [
            orderedList
        ]);
        // Work out the new split out lists 'order' (the number it starts from)
        const originalParentOrderedListNodeOrder = selectionParentListNode?.attrs.order;
        const numOfListItemsInOriginalList = (0, $BmspC.findParentNodeOfTypeClosestToPos)(tr.doc.resolve(from - 1), [
            orderedList
        ])?.node.childCount;
        // Set the new split out lists order attribute
        if (typeof originalParentOrderedListNodeOrder === 'number' && numOfListItemsInOriginalList && nodeAfterPastedContentResolvedPos) tr.setNodeMarkup(nodeAfterPastedContentResolvedPos.pos, orderedList, {
            ...nodeAfterPastedContentResolvedPos.node.attrs,
            order: originalParentOrderedListNodeOrder + numOfListItemsInOriginalList
        });
        // dispatch transaction
        if (tr.docChanged) {
            if (dispatch) dispatch(tr);
            return true;
        }
        return false;
    };
}
const $a3cc84ee80caab1f$export$c2473d50cf33051b = (selection, findRootParentListNode)=>{
    const { $from: $from, $to: $to, from: from, to: to } = selection;
    const selectionParentListItemNodeResolvedPos = findRootParentListNode ? findRootParentListNode($from) || findRootParentListNode($to) : null;
    const selectionParentListNode = selectionParentListItemNodeResolvedPos?.parent;
    if (!selectionParentListItemNodeResolvedPos || !selectionParentListNode) return false;
    const startOfEntireList = $from.pos < $to.pos ? selectionParentListItemNodeResolvedPos.pos + $from.depth - 1 : selectionParentListItemNodeResolvedPos.pos + $to.depth - 1;
    const endOfEntireList = $from.pos < $to.pos ? selectionParentListItemNodeResolvedPos.pos + selectionParentListNode.nodeSize - $to.depth - 1 : selectionParentListItemNodeResolvedPos.pos + selectionParentListNode.nodeSize - $from.depth - 1;
    if (!startOfEntireList || !endOfEntireList) return false;
    if (from < to) return startOfEntireList >= $from.pos && endOfEntireList <= $to.pos;
    else if (from > to) return startOfEntireList >= $to.pos && endOfEntireList <= $from.pos;
    else return false;
};
function $a3cc84ee80caab1f$export$3fd7f6d89a9d2cac(slice, findRootParentListNode) {
    return (state, dispatch)=>{
        const { schema: schema, tr: tr } = state;
        const { selection: selection } = tr;
        // Check this pasting action is related to copy content from panel node into a selected the list node
        const blockNode = slice.content.firstChild;
        const isSliceWholeNode = slice.openStart === 0 && slice.openEnd === 0;
        const selectionParentListItemNode = selection.$to.node(selection.$to.depth - 1);
        const sliceIsWholeNodeButShouldNotReplaceSelection = isSliceWholeNode && !$a3cc84ee80caab1f$export$c2473d50cf33051b(selection, findRootParentListNode);
        if (!selectionParentListItemNode || selectionParentListItemNode?.type !== schema.nodes.listItem || !blockNode || ![
            'panel',
            'decisionList'
        ].includes(blockNode?.type.name) || slice.content.childCount > 1 || blockNode?.content.firstChild === undefined || sliceIsWholeNodeButShouldNotReplaceSelection) return false;
        // Paste the panel node contents extracted instead of pasting the entire panel node
        tr.replaceSelection(slice).scrollIntoView();
        if (dispatch) dispatch(tr);
        return true;
    };
}
function $a3cc84ee80caab1f$export$5e27b285bdcc71bf(slice) {
    return (state, dispatch)=>{
        const { schema: schema, selection: selection, selection: { from: from, to: to }, tr: tr } = state;
        let linkMark;
        // check if we have a link on the clipboard
        if (slice.content.childCount === 1 && (0, $9Ssie.isParagraph)(slice.content.child(0), schema)) {
            const paragraph = slice.content.child(0);
            if (paragraph.content.childCount === 1 && (0, $9Ssie.isText)(paragraph.content.child(0), schema)) {
                const text = paragraph.content.child(0);
                // If pasteType is plain text, then
                //  @atlaskit/editor-markdown-transformer in getMarkdownSlice decode
                //  url before setting text property of text node.
                //  However href of marks will be without decoding.
                //  So, if there is character (e.g space) in url eligible escaping then
                //  mark.attrs.href will not be equal to text.text.
                //  That's why decoding mark.attrs.href before comparing.
                // However, if pasteType is richText, that means url in text.text
                //  and href in marks, both won't be decoded.
                linkMark = text.marks.find((mark)=>(0, $9Ssie.isLinkMark)(mark, schema) && (mark.attrs.href === text.text || decodeURI(mark.attrs.href) === text.text));
            }
        }
        // if we have a link, apply it to the selected text if we have any and it's allowed
        if (linkMark && selection instanceof (0, $3lIcL.TextSelection) && !selection.empty && (0, $grDTV.canLinkBeCreatedInRange)(from, to)(state)) {
            tr.addMark(from, to, linkMark);
            if (dispatch) dispatch(tr);
            return true;
        }
        return false;
    };
}
function $a3cc84ee80caab1f$export$efe55f809fabb910(slice, _event, editorAnalyticsAPI) {
    return (state, dispatch, view)=>{
        if (!view) return false;
        // prosemirror-bump-fix
        // Yes, this is wrong by default. But, we need to keep the private PAI usage to unblock the prosemirror bump
        // So, this code will make sure we are checking for both version (current and the newest prosemirror-view version
        const isShiftKeyPressed = // eslint-disable-next-line @typescript-eslint/no-explicit-any
        view.shiftKey || view.input?.shiftKey;
        // In case of SHIFT+CMD+V ("Paste and Match Style") we don't want to run the usual
        // fuzzy matching of content. ProseMirror already handles this scenario and will
        // provide us with slice containing paragraphs with plain text, which we decorate
        // with "stored marks".
        // @see prosemirror-view/src/clipboard.js:parseFromClipboard()).
        // @see prosemirror-view/src/input.js:doPaste().
        if (isShiftKeyPressed) {
            let tr = (0, $kuxd1.closeHistory)(state.tr);
            const { selection: selection } = tr;
            // <- using the same internal flag that prosemirror-view is using
            // if user has selected table we need custom logic to replace the table
            tr = (0, $8hKAd.replaceSelectedTable)(state, slice);
            // add analytics after replacing selected table
            tr = (0, $bFyUX.addReplaceSelectedTableAnalytics)(state, tr, editorAnalyticsAPI);
            // otherwise just replace the selection
            if (!tr.docChanged) tr.replaceSelection(slice);
            (state.storedMarks || []).forEach((mark)=>{
                tr.addMark(selection.from, selection.from + slice.size, mark);
            });
            tr.scrollIntoView();
            if (dispatch) dispatch(tr);
            return true;
        }
        return false;
    };
}
function $a3cc84ee80caab1f$export$de618421675f910e(slice, queueCardsFromChangedTr) {
    return (state, dispatch)=>{
        const { schema: schema, tr: { selection: selection } } = state;
        const { marks: { code: codeMark, annotation: annotationMark }, nodes: { bulletList: bulletList, emoji: emoji, hardBreak: hardBreak, heading: heading, listItem: listItem, mention: mention, orderedList: orderedList, text: text } } = schema;
        if (!(selection instanceof (0, $3lIcL.TextSelection))) return false;
        const selectionMarks = selection.$head.marks();
        if (selectionMarks.length === 0) return false;
        // special case for codeMark: will preserve mark only if codeMark is currently active
        // won't preserve mark if cursor is on the edge on the mark (namely inactive)
        const hasActiveCodeMark = codeMark && codeMark.isInSet(selectionMarks) && (0, $02q9c.anyMarkActive)(state, codeMark);
        const hasAnnotationMark = annotationMark && annotationMark.isInSet(selectionMarks);
        const selectionIsHeading = (0, $BmspC.hasParentNodeOfType)([
            heading
        ])(state.selection);
        // if the pasted data is one of the node types below
        // we apply current selection marks to the pasted slice
        if ((0, $bFyUX.hasOnlyNodesOfType)(bulletList, hardBreak, heading, listItem, text, emoji, mention, orderedList)(slice) || selectionIsHeading || hasActiveCodeMark || hasAnnotationMark) {
            const transformedSlice = (0, $bFyUX.applyTextMarksToSlice)(schema, selectionMarks)(slice);
            const tr = (0, $kuxd1.closeHistory)(state.tr).replaceSelection(transformedSlice).setStoredMarks(selectionMarks).scrollIntoView();
            queueCardsFromChangedTr?.(state, tr, (0, $bMFKb.INPUT_METHOD).CLIPBOARD);
            if (dispatch) dispatch(tr);
            return true;
        }
        return false;
    };
}
async function $a3cc84ee80caab1f$var$getSmartLinkAdf(text, type, cardOptions) {
    if (!cardOptions.provider) throw Error('No card provider found');
    const provider = await cardOptions.provider;
    return await provider.resolve(text, type);
}
function $a3cc84ee80caab1f$var$insertAutoMacro(slice, macro, view, from, to) {
    if (view) {
        // insert the text or linkified/md-converted clipboard data
        const selection = view.state.tr.selection;
        let tr;
        let before;
        if (typeof from === 'number' && typeof to === 'number') {
            tr = view.state.tr.replaceRange(from, to, slice);
            before = tr.mapping.map(from, -1);
        } else {
            tr = view.state.tr.replaceSelection(slice);
            before = tr.mapping.map(selection.from, -1);
        }
        view.dispatch(tr);
        // replace the text with the macro as a separate transaction
        // so the autoconversion generates 2 undo steps
        view.dispatch((0, $kuxd1.closeHistory)(view.state.tr).replaceRangeWith(before, before + slice.size, macro).scrollIntoView());
        return true;
    }
    return false;
}
function $a3cc84ee80caab1f$export$d23738992a74c3a9(text, slice, queueCardsFromChangedTr, runMacroAutoConvert, cardsOptions, extensionAutoConverter) {
    return (state, dispatch, view)=>{
        let macro = null;
        // try to use auto convert from extension provider first
        if (extensionAutoConverter) {
            const extension = extensionAutoConverter(text);
            if (extension) macro = (0, $3xw6l.Node).fromJSON(state.schema, extension);
        }
        // then try from macro provider (which will be removed some time in the future)
        if (!macro) macro = runMacroAutoConvert?.(state, text) ?? null;
        if (macro) {
            /**
			 * if FF enabled, run through smart links and check for result
			 */ if (cardsOptions && cardsOptions.resolveBeforeMacros && cardsOptions.resolveBeforeMacros.length) {
                if (cardsOptions.resolveBeforeMacros.indexOf(macro.attrs.extensionKey) < 0) return $a3cc84ee80caab1f$var$insertAutoMacro(slice, macro, view);
                if (!view) throw new Error('View is missing');
                const trackingId = (0, (/*@__PURE__*/$parcel$interopDefault($8KLBw)))();
                const trackingFrom = `handleMacroAutoConvert-from-${trackingId}`;
                const trackingTo = `handleMacroAutoConvert-to-${trackingId}`;
                (0, $1CqHB.startTrackingPastedMacroPositions)({
                    [trackingFrom]: state.selection.from,
                    [trackingTo]: state.selection.to
                })(state, dispatch);
                $a3cc84ee80caab1f$var$getSmartLinkAdf(text, 'inline', cardsOptions).then(()=>{
                    // we use view.state rather than state because state becomes a stale
                    // state reference after getSmartLinkAdf's async work
                    const { pastedMacroPositions: pastedMacroPositions } = (0, $3Elhj.getPluginState)(view.state);
                    if (dispatch) $a3cc84ee80caab1f$export$4b83e18c607f848f(slice, queueCardsFromChangedTr, pastedMacroPositions[trackingFrom], pastedMacroPositions[trackingTo])(view.state, dispatch);
                }).catch(()=>{
                    const { pastedMacroPositions: pastedMacroPositions } = (0, $3Elhj.getPluginState)(view.state);
                    $a3cc84ee80caab1f$var$insertAutoMacro(slice, macro, view, pastedMacroPositions[trackingFrom], pastedMacroPositions[trackingTo]);
                }).finally(()=>{
                    (0, $1CqHB.stopTrackingPastedMacroPositions)([
                        trackingFrom,
                        trackingTo
                    ])(view.state, dispatch);
                });
                return true;
            }
            return $a3cc84ee80caab1f$var$insertAutoMacro(slice, macro, view);
        }
        return !!macro;
    };
}
function $a3cc84ee80caab1f$export$98135102f7ccdef2(text) {
    return (state, dispatch)=>{
        const { codeBlock: codeBlock } = state.schema.nodes;
        if (text && (0, $BmspC.hasParentNodeOfType)(codeBlock)(state.selection)) {
            const tr = (0, $kuxd1.closeHistory)(state.tr);
            tr.scrollIntoView();
            if (dispatch) dispatch(tr.insertText(text));
            return true;
        }
        return false;
    };
}
function $a3cc84ee80caab1f$var$isOnlyMedia(state, slice) {
    const { media: media } = state.schema.nodes;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return slice.content.childCount === 1 && slice.content.firstChild.type === media;
}
function $a3cc84ee80caab1f$var$isOnlyMediaSingle(state, slice) {
    const { mediaSingle: mediaSingle } = state.schema.nodes;
    return(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    mediaSingle && slice.content.childCount === 1 && slice.content.firstChild.type === mediaSingle);
}
function $a3cc84ee80caab1f$export$5fb647c5a57bac64(inputMethod, insertMediaAsMediaSingle) {
    return function(slice) {
        return (state, dispatch, view)=>{
            if (view) {
                if ($a3cc84ee80caab1f$var$isOnlyMedia(state, slice)) // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                return insertMediaAsMediaSingle?.(view, slice.content.firstChild, inputMethod) ?? false;
                if ((0, $eQTBG.insideTable)(state) && $a3cc84ee80caab1f$var$isOnlyMediaSingle(state, slice)) {
                    const tr = state.tr.replaceSelection(slice);
                    const nextPos = tr.doc.resolve(tr.mapping.map(state.selection.$from.pos));
                    if (dispatch) dispatch(tr.setSelection(new (0, $6BNUN.GapCursorSelection)(nextPos, (0, $6BNUN.Side).RIGHT)));
                    return true;
                }
            }
            return false;
        };
    };
}
const $a3cc84ee80caab1f$var$hasTopLevelExpand = (slice)=>{
    let hasExpand = false;
    slice.content.forEach((node)=>{
        if (node.type.name === 'expand' || node.type.name === 'nestedExpand') hasExpand = true;
    });
    return hasExpand;
};
function $a3cc84ee80caab1f$export$36e0fe2cadced224(slice) {
    return (state, dispatch)=>{
        const isInsideBodyExtension = (0, $BmspC.hasParentNodeOfType)(state.schema.nodes.bodiedExtension)(state.selection);
        if (!(0, $eQTBG.insideTable)(state) || !isInsideBodyExtension) return false;
        const { bodiedExtension: bodiedExtension } = state.schema.nodes;
        const newSlice = (0, $gbisc.mapSlice)(slice, (maybeNode)=>{
            if (maybeNode.type === bodiedExtension) return bodiedExtension.createChecked(maybeNode.attrs, maybeNode.content, maybeNode.marks);
            return maybeNode;
        });
        if (dispatch) {
            dispatch(state.tr.replaceSelection(newSlice));
            return true;
        }
        return false;
    };
}
function $a3cc84ee80caab1f$export$113227139658cc8d(slice, isNestingTablesSupported) {
    return (state, dispatch)=>{
        if (!isNestingTablesSupported || !(0, $eQTBG.insideTable)(state)) return false;
        const { schema: schema, selection: selection } = state;
        let sliceHasTable = false;
        slice.content.forEach((node)=>{
            if (node.type === state.schema.nodes.table) sliceHasTable = true;
        });
        if (sliceHasTable) {
            if ((0, $92xoS.editorExperiment)('nested-tables-in-tables', true, {
                exposure: true
            })) /* TEST COHORT */ // if slice has table - if pasting to deeply nested location place paste after top table
            {
                if ((0, $lQJJa.getParentOfTypeCount)(schema.nodes.table)(selection.$from) > 1) {
                    const positionAfterTopTable = (0, $lQJJa.getPositionAfterTopParentNodeOfType)(schema.nodes.table)(selection.$from);
                    let { tr: tr } = state;
                    tr = (0, $BmspC.safeInsert)(slice.content, positionAfterTopTable)(tr);
                    tr.scrollIntoView();
                    if (dispatch) {
                        dispatch(tr);
                        return true;
                    }
                }
            } else {
                /* CONTROL COHORT */ // if slice has table - place paste after top table
                const positionAfterTopTable = (0, $lQJJa.getPositionAfterTopParentNodeOfType)(schema.nodes.table)(selection.$from);
                let { tr: tr } = state;
                tr = (0, $BmspC.safeInsert)(slice.content, positionAfterTopTable)(tr);
                tr.scrollIntoView();
                if (dispatch) {
                    dispatch(tr);
                    return true;
                }
            }
        }
        return false;
    };
}
function $a3cc84ee80caab1f$export$a497757c6eac4530(slice) {
    return (state, dispatch)=>{
        const isInsideNestableExpand = !!$a3cc84ee80caab1f$var$insideExpand(state);
        // Do not handle expand if it's not being pasted into a table or expand
        // OR if it's nested within another node when being pasted into a table/expand
        if (!(0, $eQTBG.insideTable)(state) && !isInsideNestableExpand || !$a3cc84ee80caab1f$var$hasTopLevelExpand(slice)) return false;
        const { expand: expand, nestedExpand: nestedExpand } = state.schema.nodes;
        let { tr: tr } = state;
        let hasExpand = false;
        const newSlice = (0, $gbisc.mapSlice)(slice, (maybeNode)=>{
            if (maybeNode.type === expand || maybeNode.type === nestedExpand) {
                hasExpand = true;
                try {
                    return nestedExpand.createChecked(maybeNode.attrs, maybeNode.content, maybeNode.marks);
                } catch (e) {
                    tr = (0, $BmspC.safeInsert)(maybeNode, tr.selection.$to.pos)(tr);
                    return (0, $3xw6l.Fragment).empty;
                }
            }
            return maybeNode;
        });
        if (hasExpand && dispatch) {
            // If the slice is a subset, we can let PM replace the selection
            // it will insert as text where it can't place the node.
            // Otherwise we use safeInsert to insert below instead of
            // replacing/splitting the current node.
            if (slice.openStart > 1 && slice.openEnd > 1) dispatch(tr.replaceSelection(newSlice));
            else dispatch((0, $BmspC.safeInsert)(newSlice.content)(tr));
            return true;
        }
        return false;
    };
}
function $a3cc84ee80caab1f$export$4b83e18c607f848f(markdownSlice, queueCardsFromChangedTr, from, to) {
    return (state, dispatch)=>{
        const tr = (0, $kuxd1.closeHistory)(state.tr);
        const pastesFrom = typeof from === 'number' ? from : tr.selection.from;
        if (typeof from === 'number' && typeof to === 'number') tr.replaceRange(from, to, markdownSlice);
        else tr.replaceSelection(markdownSlice);
        const textPosition = tr.doc.resolve(Math.min(pastesFrom + markdownSlice.size, tr.doc.content.size));
        tr.setSelection((0, $3lIcL.TextSelection).near(textPosition, -1));
        queueCardsFromChangedTr?.(state, tr, (0, $bMFKb.INPUT_METHOD).CLIPBOARD);
        if (dispatch) dispatch(tr.scrollIntoView());
        return true;
    };
}
function $a3cc84ee80caab1f$var$removePrecedingBackTick(tr) {
    const { $from: { nodeBefore: nodeBefore }, from: from } = tr.selection;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    if (nodeBefore && nodeBefore.isText && nodeBefore.text.endsWith('`')) tr.delete(from - 1, from);
}
function $a3cc84ee80caab1f$var$hasInlineCode(state, slice) {
    return slice.content.firstChild && slice.content.firstChild.marks.some((m)=>m.type === state.schema.marks.code);
}
function $a3cc84ee80caab1f$var$rollupLeafListItems(list, leafListItems) {
    list.content.forEach((child)=>{
        if ((0, $fCXIH.isListNode)(child) || (0, $fCXIH.isListItemNode)(child) && (0, $fCXIH.isListNode)(child.firstChild)) $a3cc84ee80caab1f$var$rollupLeafListItems(child, leafListItems);
        else leafListItems.push(child);
    });
}
function $a3cc84ee80caab1f$var$shouldFlattenList(state, slice) {
    const node = slice.content.firstChild;
    return node && (0, $eQTBG.insideTable)(state) && (0, $fCXIH.isListNode)(node) && slice.openStart > slice.openEnd;
}
function $a3cc84ee80caab1f$var$sliceHasTopLevelMarks(slice) {
    let hasTopLevelMarks = false;
    slice.content.descendants((node)=>{
        if (node.marks.length > 0) hasTopLevelMarks = true;
        return false;
    });
    return hasTopLevelMarks;
}
function $a3cc84ee80caab1f$var$getTopLevelMarkTypesInSlice(slice) {
    const markTypes = new Set();
    slice.content.descendants((node)=>{
        node.marks.map((mark)=>mark.type).forEach((markType)=>markTypes.add(markType));
        return false;
    });
    return markTypes;
}
function $a3cc84ee80caab1f$export$feb0d61bf65d9267(state, slice) {
    if (slice.content.size === 0) return slice;
    const { schema: schema, selection: { $from: $from } } = state;
    // If no paragraph in the slice contains marks, there's no need for special handling
    // Note: this doesn't check for marks applied to lower level nodes such as text
    if (!$a3cc84ee80caab1f$var$sliceHasTopLevelMarks(slice)) return slice;
    // If pasting a single paragraph into pre-existing content, match destination formatting
    const destinationHasContent = $from.parent.textContent.length > 0;
    if (slice.content.childCount === 1 && destinationHasContent) return slice;
    // Check the parent of (paragraph -> text) because block marks are assigned to a wrapper
    // element around the paragraph node
    const grandparent = $from.node(Math.max(0, $from.depth - 1));
    const markTypesInSlice = $a3cc84ee80caab1f$var$getTopLevelMarkTypesInSlice(slice);
    const forbiddenMarkTypes = [];
    for (const markType of markTypesInSlice)if (!grandparent.type.allowsMarkType(markType)) forbiddenMarkTypes.push(markType);
    if (forbiddenMarkTypes.length === 0) {
        // In a slice containing one or more paragraphs at the document level (not wrapped in
        // another node), the first paragraph will only have its text content captured and pasted
        // since openStart is 1. We decrement the open depth of the slice so it retains any block
        // marks applied to it. We only care about the depth at the start of the selection so
        // there's no need to change openEnd - the rest of the slice gets pasted correctly.
        const openStart = Math.max(0, slice.openStart - 1);
        return new (0, $3xw6l.Slice)(slice.content, openStart, slice.openEnd);
    }
    // If the paragraph or heading contains marks forbidden by the parent node
    // (e.g. alignment/indentation), drop those marks from the slice
    return (0, $gbisc.mapSlice)(slice, (node)=>{
        if (node.type === schema.nodes.paragraph) return schema.nodes.paragraph.createChecked(undefined, node.content, node.marks.filter((mark)=>!forbiddenMarkTypes.includes(mark.type)));
        else if (node.type === schema.nodes.heading) // Preserve heading attributes to keep formatting
        return schema.nodes.heading.createChecked(node.attrs, node.content, node.marks.filter((mark)=>!forbiddenMarkTypes.includes(mark.type)));
        return node;
    });
}
function $a3cc84ee80caab1f$export$79d83373d2946ba6(slice) {
    if (!slice.content.firstChild) return slice;
    const listToFlatten = slice.content.firstChild;
    const leafListItems = [];
    $a3cc84ee80caab1f$var$rollupLeafListItems(listToFlatten, leafListItems);
    const contentWithFlattenedList = slice.content.replaceChild(0, listToFlatten.type.createChecked(listToFlatten.attrs, leafListItems));
    return new (0, $3xw6l.Slice)(contentWithFlattenedList, slice.openEnd, slice.openEnd);
}
function $a3cc84ee80caab1f$export$f9c7e15c780a77d0(slice, queueCardsFromChangedTr) {
    return (state, dispatch)=>{
        const { codeBlock: codeBlock, heading: heading, paragraph: paragraph, panel: panel } = state.schema.nodes;
        const { selection: selection, schema: schema } = state;
        const firstChildOfSlice = slice.content?.firstChild;
        const lastChildOfSlice = slice.content?.lastChild;
        // In case user is pasting inline code,
        // any backtick ` immediately preceding it should be removed.
        let tr = state.tr;
        if ($a3cc84ee80caab1f$var$hasInlineCode(state, slice)) $a3cc84ee80caab1f$var$removePrecedingBackTick(tr);
        if ($a3cc84ee80caab1f$var$shouldFlattenList(state, slice)) slice = $a3cc84ee80caab1f$export$79d83373d2946ba6(slice);
        (0, $kuxd1.closeHistory)(tr);
        const isFirstChildListNode = (0, $fCXIH.isListNode)(firstChildOfSlice);
        const isLastChildListNode = (0, $fCXIH.isListNode)(lastChildOfSlice);
        const isSliceContentListNodes = isFirstChildListNode || isLastChildListNode;
        const isFirstChildTaskListNode = firstChildOfSlice?.type?.name === 'taskList';
        const isLastChildTaskListNode = lastChildOfSlice?.type?.name === 'taskList';
        const isSliceContentTaskListNodes = isFirstChildTaskListNode || isLastChildTaskListNode;
        // We want to use safeInsert to insert invalid content, as it inserts at the closest non schema violating position
        // rather than spliting the selection parent node in half (which is what replaceSelection does)
        // Exception is paragraph and heading nodes, these should be split, provided their parent supports the pasted content
        const textNodes = [
            heading,
            paragraph
        ];
        const selectionParent = selection.$to.node(selection.$to.depth - 1);
        const noNeedForSafeInsert = selection.$to.node().type.validContent(slice.content) || textNodes.includes(selection.$to.node().type) && selectionParent.type.validContent(slice.content);
        const panelParentOverCurrentSelection = (0, $BmspC.findParentNodeOfType)(panel)(tr.selection);
        const isTargetPanelEmpty = panelParentOverCurrentSelection && panelParentOverCurrentSelection.node?.content.size === 2;
        if (!isSliceContentTaskListNodes && (isSliceContentListNodes || isTargetPanelEmpty)) (0, $3CAWf.insertSliceForLists)({
            tr: tr,
            slice: slice,
            schema: schema
        });
        else if (noNeedForSafeInsert) {
            if (firstChildOfSlice?.type?.name === 'blockquote' && firstChildOfSlice?.content.firstChild?.type.name && [
                'bulletList',
                'orderedList',
                'mediaSingle'
            ].includes(firstChildOfSlice?.content.firstChild?.type.name)) // checks if parent node is a blockquote and child node is either a bulletlist or orderedlist or mediaSingle
            (0, $3CAWf.insertSliceInsideBlockquote)({
                tr: tr,
                slice: slice
            });
            else {
                tr.replaceSelection(slice);
                // when cursor is inside a table cell, and slice.content.lastChild is a panel, expand, or decisionList
                // need to make sure the cursor position is is right after the panel, expand, or decisionList
                // still in the same table cell, see issue: https://product-fabric.atlassian.net/browse/ED-17862
                const shouldUpdateCursorPosAfterPaste = [
                    'panel',
                    'nestedExpand',
                    'decisionList',
                    'codeBlock'
                ].includes(slice.content.lastChild?.type?.name || '');
                const lastChild = slice.content.lastChild;
                const $nextPos = tr.doc.resolve(tr.mapping.map(selection.from));
                const nextSelection = lastChild?.type.isTextblock ? (0, $3lIcL.TextSelection).findFrom($nextPos, -1, true) : new (0, $6BNUN.GapCursorSelection)($nextPos, (0, $6BNUN.Side).RIGHT);
                if (nextSelection) tr.setSelection(nextSelection);
                else if ((0, $3ADzg.insideTableCell)(state) && shouldUpdateCursorPosAfterPaste) {
                    const nextPos = tr.doc.resolve(tr.mapping.map(selection.$from.pos));
                    tr.setSelection(new (0, $6BNUN.GapCursorSelection)(nextPos, (0, $6BNUN.Side).RIGHT));
                }
            }
        } else {
            // need to scan the slice if there's a block node or list items inside it
            let sliceHasList = false;
            slice.content.nodesBetween(0, slice.content.size, (node, start)=>{
                if (node.type === state.schema.nodes.listItem) {
                    sliceHasList = true;
                    return false;
                }
            });
            if ((0, $3ADzg.insideTableCell)(state) && (0, $3ADzg.isInListItem)(state) && (0, $BmspC.canInsert)(selection.$from, slice.content) && (0, $BmspC.canInsert)(selection.$to, slice.content) || sliceHasList) tr.replaceSelection(slice);
            else if ($a3cc84ee80caab1f$export$f0f8559835c0f076(state, slice) && !$a3cc84ee80caab1f$export$67c0f4368bb304c3(state)) (0, $3CAWf.insertSliceForTaskInsideList)({
                tr: tr,
                slice: slice
            });
            else {
                // need safeInsert rather than replaceSelection, so that nodes aren't split in half
                // e.g. when pasting a layout into a table, replaceSelection splits the table in half and adds the layout in the middle
                tr = (0, $BmspC.safeInsert)(slice.content, tr.selection.$to.pos)(tr);
                if ($a3cc84ee80caab1f$export$f0f8559835c0f076(state, slice)) (0, $3CAWf.updateSelectionAfterReplace)({
                    tr: tr
                });
            }
        }
        tr.setStoredMarks([]);
        if (tr.selection.empty && tr.selection.$from.parent.type === codeBlock) tr.setSelection((0, $3lIcL.TextSelection).near(tr.selection.$from, 1));
        tr.scrollIntoView();
        // queue link cards, ignoring any errors
        queueCardsFromChangedTr?.(state, tr, (0, $bMFKb.INPUT_METHOD).CLIPBOARD);
        if (dispatch) dispatch(tr);
        return true;
    };
}
function $a3cc84ee80caab1f$export$d399a86cc775ad7e(slice) {
    return (state, dispatch)=>{
        const { caption: caption } = state.schema.nodes;
        const tr = state.tr;
        if ((0, $BmspC.hasParentNodeOfType)(caption)(state.selection)) {
            // We let PM replace the selection and it will insert as text where it can't place the node
            // This is totally fine as caption is just a simple block that only contains inline contents
            // And it is more in line with WYSIWYG expectations
            tr.replaceSelection(slice).scrollIntoView();
            if (dispatch) dispatch(tr);
            return true;
        }
        return false;
    };
}
const $a3cc84ee80caab1f$export$4ce587bb5876886d = (editorAnalyticsAPI)=>(slice)=>(state, dispatch)=>{
            let tr = (0, $8hKAd.replaceSelectedTable)(state, slice);
            // add analytics after replacing selected table
            tr = (0, $bFyUX.addReplaceSelectedTableAnalytics)(state, tr, editorAnalyticsAPI);
            if (tr.docChanged) {
                if (dispatch) dispatch(tr);
                return true;
            }
            return false;
        };
function $a3cc84ee80caab1f$export$f0f8559835c0f076(state, slice) {
    return Boolean((0, $3ADzg.isInListItem)(state) && [
        'taskList',
        'taskItem'
    ].includes(slice.content.firstChild?.type?.name || ''));
}
function $a3cc84ee80caab1f$export$67c0f4368bb304c3(state) {
    const { selection: selection, tr: tr } = state;
    const { orderedList: orderedList, bulletList: bulletList, listItem: listItem } = state.schema.nodes;
    const selectionParentListItemNode = (0, $BmspC.findParentNodeOfType)(listItem)(selection);
    const selectionParentListNodeWithPos = (0, $BmspC.findParentNodeOfType)([
        bulletList,
        orderedList
    ])(selection);
    if (!selectionParentListItemNode || !selectionParentListNodeWithPos) return false;
    const grandParentListNode = (0, $BmspC.findParentNodeOfTypeClosestToPos)(tr.doc.resolve(selectionParentListNodeWithPos.pos), [
        bulletList,
        orderedList
    ]);
    const selectionIsInNestedList = !!grandParentListNode;
    let selectedListItemHasNestedList = false;
    selectionParentListItemNode.node.content.forEach((child)=>{
        if ((0, $fCXIH.isListNode)(child)) selectedListItemHasNestedList = true;
    });
    return selectedListItemHasNestedList || selectionIsInNestedList;
}

});
parcelRegister("lQJJa", function(module, exports) {

$parcel$export(module.exports, "getParentOfTypeCount", () => $2852433c0b4a990b$export$d5cbd8b17958f08b);
$parcel$export(module.exports, "getPositionAfterTopParentNodeOfType", () => $2852433c0b4a990b$export$ae584b8f0be37f04);
$parcel$export(module.exports, "isSelectionTableNestedInTable", () => $2852433c0b4a990b$export$3dd46fa6c35aa514);

var $kuDbA = parcelRequire("kuDbA");
const $2852433c0b4a990b$export$d5cbd8b17958f08b = (nodeType)=>($pos)=>{
        let count = 0;
        // Loop through parent nodes from bottom to top
        for(let depth = $pos.depth; depth > 0; depth--){
            const node = $pos.node(depth);
            // Count the table nodes
            if (node.type === nodeType) count++;
        }
        return count;
    };
const $2852433c0b4a990b$export$ae584b8f0be37f04 = (nodeType)=>($pos)=>{
        // Loop through parent nodes from top to bottom
        for(let depth = 1; depth <= $pos.depth; depth++){
            const node = $pos.node(depth);
            // Count the table nodes
            if (node.type === nodeType) return $pos.after(depth);
        }
    };
const $2852433c0b4a990b$export$3dd46fa6c35aa514 = (state)=>{
    const table = (0, $kuDbA.findTable)(state.selection);
    if (!table) return false;
    const parent = state.doc.resolve(table.pos).parent;
    const nodeTypes = state.schema.nodes;
    return [
        nodeTypes.tableHeader,
        nodeTypes.tableCell
    ].includes(parent.type);
};

});

parcelRegister("8hKAd", function(module, exports) {

$parcel$export(module.exports, "replaceSelectedTable", () => $149d5104da03519c$export$ea73b328547c6ad5);

var $3xw6l = parcelRequire("3xw6l");

var $3lIcL = parcelRequire("3lIcL");

var $kuDbA = parcelRequire("kuDbA");

var $bctVO = parcelRequire("bctVO");
const $149d5104da03519c$export$ea73b328547c6ad5 = (state, content)=>{
    if ((0, $bctVO.isTableSelected)(state.selection)) {
        const table = (0, $kuDbA.findTable)(state.selection);
        if (table) {
            const slice = typeof content === 'string' ? new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).from(state.schema.text(content)), 0, 0) : content;
            const tr = state.tr.replace(table.pos, table.pos + table.node.nodeSize, slice);
            tr.setSelection((0, $3lIcL.TextSelection).create(tr.doc, table.pos + slice.size + 1));
            return tr;
        }
    }
    return state.tr;
};

});

parcelRegister("3CAWf", function(module, exports) {

$parcel$export(module.exports, "insertSliceForLists", () => $2c28ee3918adf3eb$export$9beec16307c108ac);
$parcel$export(module.exports, "insertSliceInsideBlockquote", () => $2c28ee3918adf3eb$export$2dee216d0a70c94e);
$parcel$export(module.exports, "updateSelectionAfterReplace", () => $2c28ee3918adf3eb$export$e57c13697a8b8195);
$parcel$export(module.exports, "insertSliceForTaskInsideList", () => $2c28ee3918adf3eb$export$2982aac953f7c8b6);

var $fCXIH = parcelRequire("fCXIH");

var $3xw6l = parcelRequire("3xw6l");

var $3lIcL = parcelRequire("3lIcL");

var $lzEKq = parcelRequire("lzEKq");

var $BmspC = parcelRequire("BmspC");

var $bFyUX = parcelRequire("bFyUX");

var $es8xl = parcelRequire("es8xl");
function $2c28ee3918adf3eb$export$9beec16307c108ac({ tr: tr, slice: slice, schema: schema }) {
    const { selection: selection, selection: { $to: $to, $from: $from } } = tr;
    const { $cursor: $cursor } = selection;
    const panelNode = (0, $bFyUX.isSelectionInsidePanel)(selection);
    const selectionIsInsideList = $from.blockRange($to, (0, $fCXIH.isListNode));
    if (!$cursor && selectionIsInsideList) return (0, $es8xl.insertSliceIntoRangeSelectionInsideList)({
        tr: tr,
        slice: slice
    });
    // if inside an empty panel, try and insert content inside it rather than replace it
    if (panelNode && (0, $bFyUX.isEmptyNode)(panelNode) && $from.node() === $to.node()) return (0, $es8xl.insertSliceInsideOfPanelNodeSelected)(panelNode)({
        tr: tr,
        slice: slice,
        schema: schema
    });
    if (!$cursor || selectionIsInsideList) return tr.replaceSelection(slice);
    if ((0, $bFyUX.isEmptyNode)(tr.doc.resolve($cursor.pos).node())) return (0, $es8xl.insertSliceIntoEmptyNode)({
        tr: tr,
        slice: slice
    });
    // When pasting a single list item into an action or decision, we skip the special "insert at node edge"
    // logic so that prosemirror pastes the list's content into the action/decision, rather than
    // pasting a whole list node directly after the action/decision item. (But we still preserve the
    // existing "insert at" node edge" behaviour if dealing with a list with more than one item, so that
    // it still inserts whole list node after the action/decision item).
    const pastingIntoActionOrDecision = Boolean((0, $BmspC.findParentNodeOfType)([
        schema.nodes.taskList,
        schema.nodes.decisionList
    ])(selection));
    const oneListItem = slice.content.childCount === 1 && (0, $fCXIH.isListNode)(slice.content.firstChild) && slice.content.firstChild?.childCount === 1;
    if (!(pastingIntoActionOrDecision && oneListItem) && (0, $bFyUX.isCursorSelectionAtTextStartOrEnd)(selection)) return (0, $es8xl.insertSliceAtNodeEdge)({
        tr: tr,
        slice: slice
    });
    tr.replaceSelection(slice);
}
function $2c28ee3918adf3eb$export$2dee216d0a70c94e({ tr: tr, slice: slice }) {
    //insert blockquote explicitly and set the selection in blockquote since replaceSelection will only insert the list
    const { schema: schema } = tr.doc.type;
    tr.replaceSelection(new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).from(schema.nodes.blockquote.createAndFill()), 0, 0));
    $2c28ee3918adf3eb$export$e57c13697a8b8195({
        tr: tr
    });
    tr.replaceSelection(slice);
}
function $2c28ee3918adf3eb$export$e57c13697a8b8195({ tr: tr }) {
    // ProseMirror doesn't give a proper way to tell us where something was inserted.
    // However, we can know "how" it inserted something.
    //
    // So, instead of weird depth calculations, we can use the step produced by the transform.
    // For instance:
    //    The `replaceStep.to and replaceStep.from`, tell us the real position
    //    where the content will be insert.
    //    Then, we can use the `tr.mapping.map` to the updated position after the replace operation
    const replaceStep = tr.steps[0];
    if (!(replaceStep instanceof (0, $lzEKq.ReplaceStep))) return tr;
    const nextPosition = tr.mapping.map(replaceStep.to);
    // The findFrom will make search for both: TextSelection and NodeSelections.
    const nextSelection = (0, $3lIcL.Selection).findFrom(tr.doc.resolve(Math.min(nextPosition, tr.doc.content.size)), -1);
    if (nextSelection) tr.setSelection(nextSelection);
}
function $2c28ee3918adf3eb$export$2982aac953f7c8b6({ tr: tr, slice: slice }) {
    const { schema: schema } = tr.doc.type;
    //To avoid the list being replaced with the tasklist, enclose the slice within a taskItem.
    const selectionBeforeReplace = tr.selection.from;
    tr.replaceSelection(new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).from(schema.nodes.taskItem.createAndFill()), 0, 0));
    const nextSelection = (0, $3lIcL.Selection).near(tr.doc.resolve(selectionBeforeReplace + 1));
    tr.setSelection(nextSelection);
    tr.replaceSelection(slice);
}

});
parcelRegister("es8xl", function(module, exports) {

$parcel$export(module.exports, "insertSliceIntoEmptyNode", () => $911edaf88608fe46$export$d69afd888d46c7c);
$parcel$export(module.exports, "insertSliceAtNodeEdge", () => $911edaf88608fe46$export$7b48cb097052829);
$parcel$export(module.exports, "insertSliceIntoRangeSelectionInsideList", () => $911edaf88608fe46$export$eee44e0848f600ea);
$parcel$export(module.exports, "insertSliceInsideOfPanelNodeSelected", () => $911edaf88608fe46$export$778b6ddd10a6aad3);
parcelRequire("3ADzg");
var $5Z3Rm = parcelRequire("5Z3Rm");

var $3xw6l = parcelRequire("3xw6l");

var $3lIcL = parcelRequire("3lIcL");

var $lzEKq = parcelRequire("lzEKq");

var $BmspC = parcelRequire("BmspC");
function $911edaf88608fe46$export$d69afd888d46c7c({ tr: tr, slice: slice }) {
    tr.replaceSelection(slice);
}
function $911edaf88608fe46$export$7b48cb097052829({ tr: tr, slice: slice }) {
    const { selection: selection } = tr;
    const { $cursor: $cursor } = selection;
    if (!$cursor) return;
    const position = !$cursor.nodeBefore ? $cursor.before() : $cursor.after();
    tr.replaceRange(position, position, slice);
    const startSlicePosition = tr.doc.resolve(Math.min(position + slice.content.size - slice.openEnd, tr.doc.content.size));
    const direction = -1;
    tr.setSelection((0, $3lIcL.TextSelection).near(startSlicePosition, direction));
}
function $911edaf88608fe46$export$eee44e0848f600ea({ tr: tr, slice: slice }) {
    const { selection: { $to: $to, $from: $from, to: to, from: from } } = tr;
    // when the selection is inside of the same list item
    // we can use a normal replace
    if ($from.sameParent($to) || $from.depth === $to.depth) return tr.replaceSelection(slice);
    // if pasting a list inside another list, ensure no empty list items get added
    const newRange = $from.blockRange($to);
    if (!newRange) return;
    const startPos = from;
    const endPos = $to.nodeAfter ? to : to + 2;
    const newSlice = tr.doc.slice(endPos, newRange.end);
    tr.deleteRange(startPos, newRange.end);
    const mapped = tr.mapping.map(startPos);
    tr.replaceRange(mapped, mapped, slice);
    if (newSlice.size <= 0) return;
    const newSelection = (0, $3lIcL.TextSelection).near(tr.doc.resolve(tr.mapping.map(mapped)), -1);
    // @ts-ignore - [unblock prosemirror bump] assigning to readonly prop
    newSlice.openEnd = newSlice.openStart;
    tr.replaceRange(newSelection.from, newSelection.from, newSlice);
    tr.setSelection((0, $3lIcL.TextSelection).near(tr.doc.resolve(newSelection.from), -1));
}
function $911edaf88608fe46$export$778b6ddd10a6aad3(panelNode) {
    return ({ tr: tr, slice: slice, schema: schema })=>{
        const { selection: selection, selection: { $to: $to, $from: $from } } = tr;
        const { from: panelPosition } = selection;
        // if content of slice isn't valid for a panel node, insert the invalid node and following content after
        if (panelNode && !panelNode.type.validContent((0, $3xw6l.Fragment).from(slice.content))) {
            let insertPosition = $to.pos + 1;
            /* Adapting above logic to handle MBE, as it currently assumes that slice can be safely inserted after the panel node, which is not the case for MBE
         If insertPosition is in MBE and current slice contains invalid content for MBE, we need to insert the slice after the MBE node
      */ if (schema) {
                const mbeParentOfPanel = (0, $BmspC.findParentNodeOfType)(schema.nodes.multiBodiedExtension)(selection);
                if (mbeParentOfPanel && !mbeParentOfPanel.node.type.validContent((0, $3xw6l.Fragment).from(slice.content))) insertPosition = mbeParentOfPanel.start + mbeParentOfPanel.node.nodeSize - 1;
            }
            tr.replaceRange(insertPosition, insertPosition, slice);
            // need to delete the empty paragraph at the top of the panel
            const parentNode = tr.doc.resolve($from.before()).node();
            if (parentNode && parentNode.childCount > 1 && parentNode.firstChild?.type.name === 'paragraph' && (0, $5Z3Rm.isEmptyParagraph)(parentNode.firstChild)) {
                const startPosDelete = tr.doc.resolve($from.before()).posAtIndex(0);
                const endPosDelete = tr.doc.resolve($from.before()).posAtIndex(1);
                const SIZE_OF_EMPTY_PARAGRAPH = 2; // {startPos}<p>{startPos + 1}</p>{endPos}
                if (endPosDelete - startPosDelete === SIZE_OF_EMPTY_PARAGRAPH) tr.delete(startPosDelete, endPosDelete);
            }
            tr.setSelection((0, $3lIcL.TextSelection).near(tr.doc.resolve(insertPosition + slice.content.size - slice.openStart - slice.openEnd + 1)));
            return;
        }
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const temporaryDoc = new (0, $lzEKq.Transform)(tr.doc.type.createAndFill());
        temporaryDoc.replaceRange(0, temporaryDoc.doc.content.size, slice);
        const sliceWithoutInvalidListSurrounding = temporaryDoc.doc.slice(0);
        const newPanel = panelNode.copy(sliceWithoutInvalidListSurrounding.content);
        const panelNodeSelected = selection instanceof (0, $3lIcL.NodeSelection) ? selection.node : null;
        const replaceFrom = panelNodeSelected ? panelPosition : tr.doc.resolve(panelPosition).start();
        const replaceTo = panelNodeSelected ? panelPosition + panelNodeSelected.nodeSize : replaceFrom;
        tr.replaceRangeWith(replaceFrom, replaceTo, newPanel);
        tr.setSelection((0, $3lIcL.TextSelection).near(tr.doc.resolve($from.pos + newPanel.content.size), -1));
    };
}

});




parcelRegister("18m7e", function(module, exports) {

$parcel$export(module.exports, "clipboardTextSerializer", () => $84ef1cfd6a78bfd8$export$31d6ecfc7a959697);
function $84ef1cfd6a78bfd8$export$31d6ecfc7a959697(slice) {
    const blockSeparator = '\n\n';
    return slice.content.textBetween(0, slice.content.size, blockSeparator, (leafNode)=>{
        switch(leafNode.type.name){
            case 'hardBreak':
                return '\n';
            case 'text':
                return leafNode.text;
            case 'inlineCard':
                return leafNode.attrs.url;
            case 'blockCard':
                return leafNode.attrs.url;
            // Note: Due to relying on an async fetch of the Mention name by the Node's React component,
            // pasting a mention does not actually work for the in-product Mention implementation.
            // However, this is also true of the previous implementation.
            // Bug ticket: https://product-fabric.atlassian.net/browse/ED-23076
            case 'mention':
                return leafNode.attrs.text;
            default:
                // Unsupported node
                return leafNode.text ?? '';
        }
    });
}

});

parcelRegister("di4lu", function(module, exports) {

$parcel$export(module.exports, "handleVSCodeBlock", () => $d8f5c77ceac2d361$export$d920fedcc56c4475);

var $236Qa = parcelRequire("236Qa");

var $gbisc = parcelRequire("gbisc");
function $d8f5c77ceac2d361$var$safelyGetVSCodeLanguage(editorData) {
    try {
        const vscodeData = editorData ? JSON.parse(editorData) : undefined;
        return vscodeData?.mode;
    } catch (_e) {}
}
function $d8f5c77ceac2d361$export$d920fedcc56c4475({ state: state, slice: slice, text: text, event: event }) {
    const vscodeData = event?.clipboardData?.getData('vscode-editor-data');
    const language = $d8f5c77ceac2d361$var$safelyGetVSCodeLanguage(vscodeData);
    if (text && language && (0, $236Qa.SUPPORTED_LANGUAGES).some((l)=>l.alias[0] === language)) {
        const { schema: schema } = state;
        slice = (0, $gbisc.mapSlice)(slice, (node)=>{
            if (node.type.name === schema.nodes.codeBlock?.name) return schema.nodes.codeBlock.createChecked({
                language: language
            }, schema.text(text));
            return node;
        });
    }
    return slice;
}

});
parcelRegister("236Qa", function(module, exports) {

$parcel$export(module.exports, "SUPPORTED_LANGUAGES", () => $32521280e8fb1b12$export$7c77c3a9bb93870d);
// The full list of languages that can potentially be supported is found in
// https://prismjs.com/#supported-languages

const $32521280e8fb1b12$export$7c77c3a9bb93870d = [
    {
        name: 'PHP',
        alias: [
            'php',
            'php3',
            'php4',
            'php5'
        ],
        value: 'php'
    },
    {
        name: 'Java',
        alias: [
            'java'
        ],
        value: 'java'
    },
    {
        name: 'CSharp',
        alias: [
            'csharp',
            'c#'
        ],
        value: 'cs'
    },
    {
        name: 'Python',
        alias: [
            'python',
            'py'
        ],
        value: 'python'
    },
    {
        name: 'JavaScript',
        alias: [
            'javascript',
            'js'
        ],
        value: 'javascript'
    },
    {
        name: 'Html',
        alias: [
            'html'
        ],
        value: 'xml'
    },
    {
        name: 'C++',
        alias: [
            'c++',
            'cpp',
            'clike'
        ],
        value: 'cpp'
    },
    {
        name: 'Ruby',
        alias: [
            'ruby',
            'rb',
            'duby'
        ],
        value: 'ruby'
    },
    {
        name: 'Objective-C',
        alias: [
            'objective-c',
            'objectivec',
            'obj-c',
            'objc'
        ],
        value: 'objectivec'
    },
    {
        name: 'C',
        alias: [
            'c'
        ],
        value: 'cpp'
    },
    {
        name: 'Swift',
        alias: [
            'swift'
        ],
        value: 'swift'
    },
    {
        name: 'TeX',
        alias: [
            'tex',
            'latex'
        ],
        value: 'tex'
    },
    {
        name: 'Shell',
        alias: [
            'shell',
            'bash',
            'sh',
            'ksh',
            'zsh'
        ],
        value: 'shell'
    },
    {
        name: 'Scala',
        alias: [
            'scala'
        ],
        value: 'scala'
    },
    {
        name: 'Go',
        alias: [
            'go'
        ],
        value: 'go'
    },
    {
        name: 'ActionScript',
        alias: [
            'actionscript',
            'actionscript3',
            'as'
        ],
        value: 'actionscript'
    },
    {
        name: 'ColdFusion',
        alias: [
            'coldfusion'
        ],
        value: 'xml'
    },
    {
        name: 'JavaFX',
        alias: [
            'javafx',
            'jfx'
        ],
        value: 'java'
    },
    {
        name: 'VbNet',
        alias: [
            'vbnet',
            'vb.net',
            'vfp',
            'clipper',
            'xbase'
        ],
        value: 'vbnet'
    },
    {
        name: 'JSON',
        alias: [
            'json'
        ],
        value: 'json'
    },
    {
        name: 'MATLAB',
        alias: [
            'matlab'
        ],
        value: 'matlab'
    },
    {
        name: 'Groovy',
        alias: [
            'groovy'
        ],
        value: 'groovy'
    },
    {
        name: 'SQL',
        alias: [
            'sql',
            'postgresql',
            'postgres',
            'plpgsql',
            'psql',
            'postgresql-console',
            'postgres-console',
            'tsql',
            't-sql',
            'mysql',
            'sqlite'
        ],
        value: 'sql'
    },
    {
        name: 'R',
        alias: [
            'r'
        ],
        value: 'r'
    },
    {
        name: 'Perl',
        alias: [
            'perl',
            'pl'
        ],
        value: 'perl'
    },
    {
        name: 'Lua',
        alias: [
            'lua'
        ],
        value: 'lua'
    },
    {
        name: 'Pascal',
        alias: [
            'pas',
            'pascal',
            'objectpascal',
            'delphi'
        ],
        value: 'pascal'
    },
    {
        name: 'XML',
        alias: [
            'xml'
        ],
        value: 'xml'
    },
    {
        name: 'TypeScript',
        alias: [
            'typescript',
            'ts'
        ],
        value: 'typescript'
    },
    {
        name: 'CoffeeScript',
        alias: [
            'coffeescript',
            'coffee-script',
            'coffee'
        ],
        value: 'coffeescript'
    },
    {
        name: 'Haskell',
        alias: [
            'haskell',
            'hs'
        ],
        value: 'haskell'
    },
    {
        name: 'Puppet',
        alias: [
            'puppet'
        ],
        value: 'puppet'
    },
    {
        name: 'Arduino',
        alias: [
            'arduino'
        ],
        value: 'arduino'
    },
    {
        name: 'Fortran',
        alias: [
            'fortran'
        ],
        value: 'fortran'
    },
    {
        name: 'Erlang',
        alias: [
            'erlang',
            'erl'
        ],
        value: 'erlang'
    },
    {
        name: 'PowerShell',
        alias: [
            'powershell',
            'posh',
            'ps1',
            'psm1'
        ],
        value: 'powershell'
    },
    {
        name: 'Haxe',
        alias: [
            'haxe',
            'hx',
            'hxsl'
        ],
        value: 'haxe'
    },
    {
        name: 'Elixir',
        alias: [
            'elixir',
            'ex',
            'exs'
        ],
        value: 'elixir'
    },
    {
        name: 'Verilog',
        alias: [
            'verilog',
            'v'
        ],
        value: 'verilog'
    },
    {
        name: 'Rust',
        alias: [
            'rust'
        ],
        value: 'rust'
    },
    {
        name: 'VHDL',
        alias: [
            'vhdl'
        ],
        value: 'vhdl'
    },
    {
        name: 'Sass',
        alias: [
            'sass'
        ],
        value: 'less'
    },
    {
        name: 'OCaml',
        alias: [
            'ocaml'
        ],
        value: 'ocaml'
    },
    {
        name: 'Dart',
        alias: [
            'dart'
        ],
        value: 'dart'
    },
    {
        name: 'CSS',
        alias: [
            'css'
        ],
        value: 'css'
    },
    {
        name: 'reStructuredText',
        alias: [
            'restructuredtext',
            'rst',
            'rest'
        ],
        value: 'rest'
    },
    {
        name: 'Kotlin',
        alias: [
            'kotlin'
        ],
        value: 'kotlin'
    },
    {
        name: 'D',
        alias: [
            'd'
        ],
        value: 'd'
    },
    {
        name: 'Octave',
        alias: [
            'octave'
        ],
        value: 'matlab'
    },
    {
        name: 'QML',
        alias: [
            'qbs',
            'qml'
        ],
        value: 'qml'
    },
    {
        name: 'Prolog',
        alias: [
            'prolog'
        ],
        value: 'prolog'
    },
    {
        name: 'FoxPro',
        alias: [
            'foxpro',
            'purebasic'
        ],
        value: 'purebasic'
    },
    {
        name: 'Scheme',
        alias: [
            'scheme',
            'scm'
        ],
        value: 'scheme'
    },
    {
        name: 'CUDA',
        alias: [
            'cuda',
            'cu'
        ],
        value: 'cpp'
    },
    {
        name: 'Julia',
        alias: [
            'julia',
            'jl'
        ],
        value: 'julia'
    },
    {
        name: 'Racket',
        alias: [
            'racket',
            'rkt'
        ],
        value: 'lisp'
    },
    {
        name: 'Ada',
        alias: [
            'ada',
            'ada95',
            'ada2005'
        ],
        value: 'ada'
    },
    {
        name: 'Tcl',
        alias: [
            'tcl'
        ],
        value: 'tcl'
    },
    {
        name: 'Mathematica',
        alias: [
            'mathematica',
            'mma',
            'nb'
        ],
        value: 'mathematica'
    },
    {
        name: 'Autoit',
        alias: [
            'autoit'
        ],
        value: 'autoit'
    },
    {
        name: 'StandardML',
        alias: [
            'standardmL',
            'sml',
            'standardml'
        ],
        value: 'sml'
    },
    {
        name: 'Objective-J',
        alias: [
            'objective-j',
            'objectivej',
            'obj-j',
            'objj'
        ],
        value: 'objectivec'
    },
    {
        name: 'Smalltalk',
        alias: [
            'smalltalk',
            'squeak',
            'st'
        ],
        value: 'smalltalk'
    },
    {
        name: 'Vala',
        alias: [
            'vala',
            'vapi'
        ],
        value: 'vala'
    },
    {
        name: 'LiveScript',
        alias: [
            'livescript',
            'live-script'
        ],
        value: 'livescript'
    },
    {
        name: 'XQuery',
        alias: [
            'xquery',
            'xqy',
            'xq',
            'xql',
            'xqm'
        ],
        value: 'xquery'
    },
    {
        name: 'PlainText',
        alias: [
            'text',
            'plaintext'
        ],
        value: 'text'
    },
    {
        name: 'Yaml',
        alias: [
            'yaml',
            'yml'
        ],
        value: 'yaml'
    },
    {
        name: 'GraphQL',
        alias: [
            'graphql'
        ],
        value: 'graphql'
    },
    {
        name: 'AppleScript',
        alias: [
            'applescript'
        ],
        value: 'applescript'
    },
    {
        name: 'Clojure',
        alias: [
            'clojure'
        ],
        value: 'clojure'
    },
    {
        name: 'Diff',
        alias: [
            'diff'
        ],
        value: 'diff'
    },
    {
        name: 'VisualBasic',
        alias: [
            'visualbasic'
        ],
        value: 'visual-basic'
    },
    {
        name: 'JSX',
        alias: [
            'jsx'
        ],
        value: 'jsx'
    },
    {
        name: 'TSX',
        alias: [
            'tsx'
        ],
        value: 'tsx'
    },
    {
        name: 'SplunkSPL',
        alias: [
            'splunk-spl'
        ],
        value: 'splunk-spl'
    },
    {
        name: 'Dockerfile',
        alias: [
            'docker',
            'dockerfile'
        ],
        value: 'dockerfile'
    },
    {
        name: 'HCL',
        alias: [
            'hcl',
            'terraform'
        ],
        value: 'hcl'
    },
    {
        name: 'NGINX',
        alias: [
            'nginx'
        ],
        value: 'nginx'
    },
    {
        name: 'Protocol Buffers',
        alias: [
            'protobuf',
            'proto'
        ],
        value: 'protobuf'
    },
    {
        name: 'Handlebars',
        alias: [
            'handlebars',
            'mustache'
        ],
        value: 'handlebars'
    },
    {
        name: 'Gherkin',
        alias: [
            'gherkin',
            'cucumber'
        ],
        value: 'gherkin'
    },
    {
        name: 'ABAP',
        alias: [
            'abap'
        ],
        value: 'abap'
    }
];

});


parcelRegister("2kOjB", function(module, exports) {

$parcel$export(module.exports, "isPastedFromTinyMCEConfluence", () => $925803403a610d61$export$4a3cccc9bf9da386);
$parcel$export(module.exports, "htmlHasIncompleteTable", () => $925803403a610d61$export$120b137b77798e76);
$parcel$export(module.exports, "tryRebuildCompleteTableHtml", () => $925803403a610d61$export$253f7bda9f1e0696);

var $lsLcV = parcelRequire("lsLcV");
const $925803403a610d61$var$isPastedFromTinyMCE = (pasteEvent)=>{
    return pasteEvent?.clipboardData?.types?.some((mimeType)=>mimeType === 'x-tinymce/html') ?? false;
};
const $925803403a610d61$export$4a3cccc9bf9da386 = (pasteEvent, html)=>{
    return $925803403a610d61$var$isPastedFromTinyMCE(pasteEvent) && !!html && // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    !!html.match(/class=\"\s?(confluenceTd|confluenceTh|confluenceTable).+"/gim);
};
const $925803403a610d61$export$4552e3fc797fc52a = (html)=>{
    const parser = new DOMParser();
    const nonTableWrappedDoc = parser.parseFromString(html, 'text/html');
    const tableWrappedDoc = parser.parseFromString(`<table>${html}</table>`, 'text/html');
    tableWrappedDoc.body.querySelectorAll('meta').forEach((meta)=>{
        tableWrappedDoc.head.prepend(meta);
    });
    return {
        tableWrappedDoc: tableWrappedDoc,
        nonTableWrappedDoc: nonTableWrappedDoc
    };
};
const $925803403a610d61$var$exactlyDivisible = (larger, smaller)=>larger % smaller === 0;
const $925803403a610d61$var$getTableElementsInfo = (doc)=>{
    const cellCount = doc.querySelectorAll('td').length;
    const thCount = doc.querySelectorAll('th').length;
    const mergedCellCount = doc.querySelectorAll('td[colspan]:not([colspan="1"])').length;
    let hasThAfterTd = false;
    const thsAndCells = doc.querySelectorAll('th,td');
    for(let i = 0, cellFound = false; i < thsAndCells.length; i++){
        if (cellFound && thsAndCells[i].nodeName === 'TH') {
            hasThAfterTd = true;
            break;
        }
        if (thsAndCells[i].nodeName === 'TD') cellFound = true;
    }
    const onlyTh = thCount > 0 && cellCount === 0;
    const onlyCells = cellCount > 0 && thCount === 0;
    const hasCompleteRow = // we take header-only and cell-only tables to be
    // row-complete
    onlyTh || onlyCells || // if headers and cells can "fit" against each other,
    // then we assume a complete row exists
    ($925803403a610d61$var$exactlyDivisible(thCount, cellCount) || $925803403a610d61$var$exactlyDivisible(cellCount, thCount)) && // all numbers are divisible by 1, so we carve out a specific
    // check for when there is only 1 table cell, and more than 1
    // table header.
    !(thCount > 1 && cellCount === 1);
    return {
        cellCount: cellCount,
        thCount: thCount,
        mergedCellCount: mergedCellCount,
        hasThAfterTd: hasThAfterTd,
        hasIncompleteRow: !hasCompleteRow
    };
};
const $925803403a610d61$var$configureTableRows = (doc, colsInRow)=>{
    const tableHeadersAndCells = Array.from(doc.body.querySelectorAll('th,td'));
    const evenlySplitChunks = (0, (/*@__PURE__*/$parcel$interopDefault($lsLcV)))(tableHeadersAndCells, colsInRow);
    const tableBody = doc.body.querySelector('tbody');
    evenlySplitChunks.forEach((chunk)=>{
        const tr = doc.createElement('tr');
        tableBody?.append(tr);
        tr.append(...chunk);
    });
    // We remove any leftover empty rows which may cause fabric editor
    // to no-op when parsing the table
    const emptyRows = Array.from(tableBody.querySelectorAll('tr'))?.filter((row)=>row.innerHTML.trim().length === 0);
    emptyRows.forEach((row)=>row.remove());
    return doc.body.innerHTML;
};
const $925803403a610d61$var$fillIncompleteRowWithEmptyCells = (doc, thCount, cellCount)=>{
    let extraCellsCount = 0;
    while(!$925803403a610d61$var$exactlyDivisible(cellCount + extraCellsCount, thCount))extraCellsCount++;
    const extraEmptyCells = Array.from(Array(extraCellsCount)).map(()=>doc.createElement('td'));
    const lastCell = doc.body.querySelector('td:last-of-type');
    lastCell?.parentElement?.append(...extraEmptyCells);
    return {
        updatedCellCount: cellCount + extraCellsCount
    };
};
const $925803403a610d61$export$d749bb0e238929f2 = (doc)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line prefer-const
    let { cellCount: cellCount, thCount: thCount, mergedCellCount: mergedCellCount, hasThAfterTd: hasThAfterTd, hasIncompleteRow: hasIncompleteRow } = $925803403a610d61$var$getTableElementsInfo(doc);
    if (mergedCellCount || hasThAfterTd) // bail out to avoid handling more complex table structures
    return doc.body.innerHTML;
    if (!thCount) // if no table headers exist for reference, fallback to a single column table structure
    return $925803403a610d61$var$configureTableRows(doc, 1);
    if (hasIncompleteRow) {
        // if shift-click selection copies a partial table row to the clipboard,
        // and we do have table headers for reference, then we add empty table cells
        // to fill out the partial row
        const { updatedCellCount: updatedCellCount } = $925803403a610d61$var$fillIncompleteRowWithEmptyCells(doc, thCount, cellCount);
        cellCount = updatedCellCount;
    }
    for(let possibleColsInRow = thCount; possibleColsInRow > 0; possibleColsInRow--){
        if ($925803403a610d61$var$exactlyDivisible(thCount, possibleColsInRow) && $925803403a610d61$var$exactlyDivisible(cellCount, possibleColsInRow)) return $925803403a610d61$var$configureTableRows(doc, possibleColsInRow);
    }
    return doc.body.innerHTML;
};
const $925803403a610d61$export$120b137b77798e76 = (html)=>{
    return !html.includes('<table ') && (html.includes('<td ') || html.includes('<th '));
};
const $925803403a610d61$export$253f7bda9f1e0696 = (incompleteTableHtml)=>{
    // first we try wrapping the table elements with <table> and let DOMParser try to rebuild
    // a valid DOM tree. we also keep the non-wrapped table for comparison purposes.
    const { nonTableWrappedDoc: nonTableWrappedDoc, tableWrappedDoc: tableWrappedDoc } = $925803403a610d61$export$4552e3fc797fc52a(incompleteTableHtml);
    const didPreserveTableElements = Boolean(!nonTableWrappedDoc.body.querySelector('th, td') && tableWrappedDoc.body.querySelector('th, td'));
    const isExpectedStructure = tableWrappedDoc.querySelectorAll('body > table:only-child') && !tableWrappedDoc.querySelector(`body > table > tbody > tr > :not(th,td)`);
    // if DOMParser saves table elements that we would otherwise lose, and
    // if the table html is what we'd expect (a single table, with no extraneous
    // elements in table rows other than th, td), then we can now also try to
    // rebuild table rows/columns.
    if (didPreserveTableElements && isExpectedStructure) {
        const completeTableHtml = $925803403a610d61$export$d749bb0e238929f2(tableWrappedDoc);
        return completeTableHtml;
    }
    return null;
};

});


parcelRegister("bZVQL", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $8291d311f670335e$export$ae829ec7b2625219);

var $bMFKb = parcelRequire("bMFKb");

var $i8KtF = parcelRequire("i8KtF");

var $eGOwo = parcelRequire("eGOwo");

var $11STq = parcelRequire("11STq");

var $3X4gE = parcelRequire("3X4gE");

var $fZ8OQ = parcelRequire("fZ8OQ");

var $6Jk3D = parcelRequire("6Jk3D");

var $eAYGw = parcelRequire("eAYGw");
const $8291d311f670335e$export$ae829ec7b2625219 = (dispatch, editorAnalyticsAPI)=>{
    // This variable is used to distinguish between copy and cut events in transformCopied.
    let isCutEvent = false;
    return new (0, $i8KtF.SafePlugin)({
        key: (0, $fZ8OQ.pluginKey),
        state: (0, $3X4gE.createPluginState)(dispatch, (0, $6Jk3D.defaultState)),
        props: {
            handleDOMEvents: {
                cut: ()=>{
                    isCutEvent = true;
                }
            },
            handlePaste: ({ state: state, dispatch: dispatch }, event, slice)=>{
                // The state was cleaned after previous paste. We don't need to update plugin state
                // with 'contentPasted' if currentActions array doesn't have 'copiedOrCut'.
                const { contentMoved: contentMoved } = (0, $3X4gE.getPluginState)(state);
                const hasCutAction = contentMoved.currentActions.includes('contentCut');
                if (!hasCutAction) return;
                const { content: content } = slice;
                const nodeName = content.firstChild?.type.name;
                if (!nodeName || !contentMoved?.nodeName || !(0, $eAYGw.isCursorSelectionAtTopLevel)(state.selection)) return;
                const { tr: tr } = state;
                editorAnalyticsAPI?.attachAnalyticsEvent({
                    action: (0, $bMFKb.ACTION).MOVED,
                    actionSubject: (0, $bMFKb.ACTION_SUBJECT).DOCUMENT,
                    actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).NODE,
                    eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
                    attributes: {
                        // keep nodeName from copied slice
                        nodeType: contentMoved?.nodeName,
                        nodeDepth: contentMoved?.nodeDepth,
                        destinationNodeDepth: (0, $eAYGw.getParentNodeDepth)(state.selection),
                        nodeTypes: contentMoved?.nodeTypes,
                        hasSelectedMultipleNodes: contentMoved?.hasSelectedMultipleNodes
                    }
                })(tr);
                // reset to default state
                const updatedTr = (0, $11STq.resetContentMovedTransform)()(tr);
                dispatch(updatedTr);
            },
            transformCopied: (slice, { state: state, dispatch: dispatch })=>{
                // We want to listen only to 'cut' events
                if (!isCutEvent) return slice;
                let resetState = false;
                const { content: content, size: size } = slice;
                const { selection: selection } = state;
                // Note: the following is not the case once `platform_editor_element_drag_and_drop_multiselect` is enabled
                // we now want to track cut events for multiple nodes
                // Content should be just one node, so we added a check for slice.content.childCount === 1;
                // 1. It is possible to select a table by dragging the mouse over the table's rows.
                // As a result, slice will contain rows without tableNode itself and the childCount will be the number of rows.
                // From a user's perspective the whole table is selected and copied and on paste a table will indeed be created.
                // 2. Some block nodes can get selected when a user drags the mouse from the paragraph above the node to
                // the paragraph below the node. Visually only the node in between is selected, in reality, three nodes are
                // in the slice.
                // These cases are ignored and moveContent event won't be counted.
                const isMultiSelectTrackingEnabled = (0, $eGOwo.fg)('platform_editor_track_node_types');
                const nodeName = content.firstChild?.type.name || '';
                let nodeTypes, hasSelectedMultipleNodes = false;
                if (content.childCount > 1) {
                    if (isMultiSelectTrackingEnabled) {
                        if ((0, $eAYGw.containsExcludedNode)(content)) resetState = true;
                        else {
                            const attributes = (0, $eAYGw.getMultipleSelectionAttributes)(content);
                            nodeTypes = attributes.nodeTypes;
                            hasSelectedMultipleNodes = attributes.hasSelectedMultipleNodes;
                        }
                    } else resetState = true;
                } else if (content.childCount === 1) {
                    // Some nodes are not relevant as they are parts of nodes, not whole nodes (like tableCell, tableHeader instead of table node)
                    // Some nodes like lists, taskList(item), decisionList(item) requires tricky checks that we want to avoid doing.
                    // These nodes were added to excludedNodes array.
                    if (!resetState && (0, $eAYGw.isExcludedNode)(nodeName)) resetState = true;
                    if (!resetState && !(0, $eAYGw.isEntireNestedParagraphOrHeadingSelected)(selection)) resetState = true;
                    if (!resetState && (0, $eAYGw.isInlineNode)(nodeName) && (0, $eAYGw.isNestedInlineNode)(selection)) resetState = true;
                    if (!resetState && (0, $eAYGw.isNestedInTable)(state)) resetState = true;
                } else resetState = true;
                if (resetState) (0, $11STq.resetContentMoved)()(state, dispatch);
                else {
                    let newState = {
                        size: size,
                        nodeName: nodeName,
                        nodeDepth: (0, $eAYGw.getParentNodeDepth)(selection)
                    };
                    if (isMultiSelectTrackingEnabled) newState = {
                        ...newState,
                        nodeTypes: nodeTypes ?? nodeName,
                        hasSelectedMultipleNodes: hasSelectedMultipleNodes
                    };
                    (0, $11STq.updateContentMoved)(newState, 'contentCut')(state, dispatch);
                }
                isCutEvent = false;
                return slice;
            }
        }
    });
};

});
parcelRegister("11STq", function(module, exports) {

$parcel$export(module.exports, "updateContentMoved", () => $5d23ff2758ee6cab$export$7c2867f48317a29d);
$parcel$export(module.exports, "resetContentMoved", () => $5d23ff2758ee6cab$export$56834735aa39d3eb);
$parcel$export(module.exports, "resetContentMovedTransform", () => $5d23ff2758ee6cab$export$47c45651eb91dff0);

var $ejKvo = parcelRequire("ejKvo");

var $3X4gE = parcelRequire("3X4gE");

var $fZ8OQ = parcelRequire("fZ8OQ");
const $5d23ff2758ee6cab$export$7c2867f48317a29d = (nextState, nextAction)=>(0, $3X4gE.createCommand)((state)=>{
        const { contentMoved: contentMoved } = (0, $3X4gE.getPluginState)(state);
        const data = {
            currentActions: [
                ...contentMoved.currentActions,
                nextAction
            ],
            size: nextState?.size || contentMoved.size,
            nodeName: nextState?.nodeName,
            nodeDepth: nextState?.nodeDepth,
            nodeTypes: nextState?.nodeTypes,
            hasSelectedMultipleNodes: nextState?.hasSelectedMultipleNodes
        };
        return {
            type: (0, $ejKvo.MoveAnalyticPluginTypes).UpdateMovedAction,
            data: data
        };
    }, (tr)=>tr.setMeta('addToHistory', false));
const $5d23ff2758ee6cab$export$56834735aa39d3eb = ()=>(0, $3X4gE.createCommand)(()=>{
        return {
            type: (0, $ejKvo.MoveAnalyticPluginTypes).RemoveMovedAction
        };
    }, (tr)=>tr.setMeta('addToHistory', false));
const $5d23ff2758ee6cab$export$47c45651eb91dff0 = ()=>(tr)=>{
        const payload = {
            type: (0, $ejKvo.MoveAnalyticPluginTypes).RemoveMovedAction
        };
        return tr.setMeta((0, $fZ8OQ.pluginKey), payload);
    };

});
parcelRegister("ejKvo", function(module, exports) {

$parcel$export(module.exports, "MoveAnalyticPluginTypes", () => $9e3f55173d4bc4af$export$a5fa3822909c7e0);
var $9e3f55173d4bc4af$export$a5fa3822909c7e0 = /*#__PURE__*/ function(MoveAnalyticPluginTypes) {
    MoveAnalyticPluginTypes[MoveAnalyticPluginTypes["UpdateMovedAction"] = 0] = "UpdateMovedAction";
    MoveAnalyticPluginTypes[MoveAnalyticPluginTypes["RemoveMovedAction"] = 1] = "RemoveMovedAction";
    return MoveAnalyticPluginTypes;
}({});

});

parcelRegister("3X4gE", function(module, exports) {

$parcel$export(module.exports, "createPluginState", () => $8a3050d70e39e4b3$export$656c7661095efe2e);
$parcel$export(module.exports, "createCommand", () => $8a3050d70e39e4b3$export$8d4021544bdece00);
$parcel$export(module.exports, "getPluginState", () => $8a3050d70e39e4b3$export$f05434c51e3762e);

var $bazog = parcelRequire("bazog");

var $fZ8OQ = parcelRequire("fZ8OQ");

var $drN56 = parcelRequire("drN56");
const { createPluginState: $8a3050d70e39e4b3$export$656c7661095efe2e, createCommand: $8a3050d70e39e4b3$export$8d4021544bdece00, getPluginState: $8a3050d70e39e4b3$export$f05434c51e3762e } = (0, $bazog.pluginFactory)((0, $fZ8OQ.pluginKey), (0, $drN56.reducer));

});
parcelRegister("fZ8OQ", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $3f18de7a3374001d$export$18d4026d1ea86bb1);

var $3lIcL = parcelRequire("3lIcL");
const $3f18de7a3374001d$export$18d4026d1ea86bb1 = new (0, $3lIcL.PluginKey)('moveAnalyticsPlugin');

});

parcelRegister("drN56", function(module, exports) {

$parcel$export(module.exports, "reducer", () => $016f8413be251327$export$1650419e431d3ba3);

var $ejKvo = parcelRequire("ejKvo");

var $6Jk3D = parcelRequire("6Jk3D");
const $016f8413be251327$export$1650419e431d3ba3 = (state, action)=>{
    switch(action.type){
        case (0, $ejKvo.MoveAnalyticPluginTypes).UpdateMovedAction:
            return {
                ...state,
                contentMoved: {
                    ...state.contentMoved,
                    ...action.data
                }
            };
        case (0, $ejKvo.MoveAnalyticPluginTypes).RemoveMovedAction:
            return {
                ...state,
                contentMoved: (0, $6Jk3D.defaultState).contentMoved
            };
        default:
            return state;
    }
};

});
parcelRegister("6Jk3D", function(module, exports) {

$parcel$export(module.exports, "defaultState", () => $29e6b5eadf465ed9$export$49d5fc8cba920a0);
// For an event to be considered a move content event we want to ensure that
// cut had happened and was followed by paste. So our currentActions array should
// look like this ['contentCut', 'contentPasted'];
// After removing appendTransaction we don't update currentActions with 'contentPasted'
// but leaving it as array in case we decide to change it back or add 'contentCopied'.
const $29e6b5eadf465ed9$export$49d5fc8cba920a0 = {
    contentMoved: {
        nodeName: undefined,
        size: undefined,
        nodeDepth: undefined,
        currentActions: [],
        nodeTypes: undefined,
        hasSelectedMultipleNodes: undefined
    }
};

});




parcelRegister("eAYGw", function(module, exports) {

$parcel$export(module.exports, "isExcludedNode", () => $ccbbbefe2a50a3c9$export$75248da1527ddfc1);
$parcel$export(module.exports, "isCursorSelectionAtTopLevel", () => $ccbbbefe2a50a3c9$export$14f96cade94e47c);
$parcel$export(module.exports, "isInlineNode", () => $ccbbbefe2a50a3c9$export$82ae59a0847ee78b);
$parcel$export(module.exports, "isNestedInlineNode", () => $ccbbbefe2a50a3c9$export$8cd6af93b47990b9);
$parcel$export(module.exports, "isNestedInTable", () => $ccbbbefe2a50a3c9$export$78b714f3f17d88b0);
$parcel$export(module.exports, "getParentNodeDepth", () => $ccbbbefe2a50a3c9$export$568289ef11d607ce);
$parcel$export(module.exports, "isEntireNestedParagraphOrHeadingSelected", () => $ccbbbefe2a50a3c9$export$b6cb43348b690a2d);
$parcel$export(module.exports, "containsExcludedNode", () => $ccbbbefe2a50a3c9$export$c4a09517c4982d7c);
$parcel$export(module.exports, "getMultipleSelectionAttributes", () => $ccbbbefe2a50a3c9$export$f3a535d61fe1eda3);

var $BmspC = parcelRequire("BmspC");

var $cwzAY = parcelRequire("cwzAY");

var $eGOwo = parcelRequire("eGOwo");
const $ccbbbefe2a50a3c9$var$excludedNodes = [
    'caption',
    'layoutColumn',
    'listItem',
    'tableHeader',
    'tableCell',
    'tableRow',
    'text',
    'placeholder',
    'unsupportedBlock',
    'unsupportedInline',
    'hardBreak',
    'confluenceUnsupportedBlock',
    'confluenceUnsupportedInline',
    'taskItem',
    'decisionItem'
];
const $ccbbbefe2a50a3c9$export$75248da1527ddfc1 = (nodeName)=>$ccbbbefe2a50a3c9$var$excludedNodes.includes(nodeName);
const $ccbbbefe2a50a3c9$export$14f96cade94e47c = (selection)=>{
    const { from: from, to: to, $from: $from } = selection;
    if (from !== to) return false;
    return $from.parentOffset === 0;
};
const $ccbbbefe2a50a3c9$var$inlineNodes = [
    'emoji',
    'date',
    'status',
    'mention',
    'mediaInline',
    'inlineCard',
    'inlineExtension'
];
const $ccbbbefe2a50a3c9$export$82ae59a0847ee78b = (nodeName)=>{
    return $ccbbbefe2a50a3c9$var$inlineNodes.includes(nodeName);
};
const $ccbbbefe2a50a3c9$export$8cd6af93b47990b9 = (selection)=>{
    if (selection.$from.depth !== 1) return true;
    // check if the node is a part of a larger paragraph or heading
    const parentSize = selection.$from.parent.content.size;
    const contentSize = selection.content().size;
    const parentChildCount = selection.$from.parent.childCount;
    // when the node was copied and pasted, it won't have extra space the parent has only one child
    if (parentChildCount === 1) return false;
    // some inline nodes (like date and emoji) when inserted have extra space that is stores as a child
    if (parentChildCount === 2 && parentSize - contentSize === 1) return false;
    return true;
};
const $ccbbbefe2a50a3c9$export$78b714f3f17d88b0 = (state)=>{
    const { schema: schema, selection: selection } = state;
    if (selection instanceof (0, $cwzAY.CellSelection)) return false;
    const { table: table } = schema.nodes;
    const tableNode = (0, $BmspC.findParentNodeOfTypeClosestToPos)(selection.$from, table);
    if (!tableNode) return false;
    return true;
};
const $ccbbbefe2a50a3c9$export$568289ef11d607ce = (selection)=>{
    const parentNode = (0, $BmspC.findParentNodeClosestToPos)(selection.$from, ()=>true);
    if (!parentNode) return 0;
    return parentNode.node.type.name === 'heading' || parentNode.node.type.name === 'paragraph' ? parentNode.depth - 1 : parentNode.depth;
};
const $ccbbbefe2a50a3c9$export$b6cb43348b690a2d = (selection)=>{
    const { $from: $from, $to: $to } = selection;
    return $from.textOffset === 0 && $to.textOffset === 0;
};
const $ccbbbefe2a50a3c9$export$c4a09517c4982d7c = (content)=>{
    for(let i = 0; i < content.childCount; i++){
        const nodeName = content.maybeChild(i)?.type.name || '';
        if ($ccbbbefe2a50a3c9$export$75248da1527ddfc1(nodeName)) return true;
    }
    return false;
};
const $ccbbbefe2a50a3c9$export$f3a535d61fe1eda3 = (content)=>{
    const nodeTypes = [];
    if (content.size) content.forEach((node)=>{
        nodeTypes.push(node.type.name);
    });
    return {
        nodeTypes: (0, $eGOwo.fg)('platform_editor_track_node_types') ? [
            ...new Set(nodeTypes)
        ].sort().join(',') : undefined,
        hasSelectedMultipleNodes: nodeTypes.length > 1
    };
};

});




parcelRegister("blBYA", function(module, exports) {

$parcel$export(module.exports, "placeholderPlugin", () => (parcelRequire("hcgLS")).placeholderPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $hcgLS = parcelRequire("hcgLS");

});
parcelRegister("hcgLS", function(module, exports) {

$parcel$export(module.exports, "placeholderPlugin", () => $146d7ff1496fddb0$export$ecbe4cfe6671ba88);

var $dfJR8 = parcelRequire("dfJR8");

var $i8KtF = parcelRequire("i8KtF");

var $bnAxN = parcelRequire("bnAxN");
var $7EdFW = parcelRequire("7EdFW");parcelRequire("3ADzg");
var $5Z3Rm = parcelRequire("5Z3Rm");

var $3lIcL = parcelRequire("3lIcL");

var $BmspC = parcelRequire("BmspC");

var $b7EWj = parcelRequire("b7EWj");

var $92xoS = parcelRequire("92xoS");
const $146d7ff1496fddb0$export$18d4026d1ea86bb1 = new (0, $3lIcL.PluginKey)('placeholderPlugin');
function $146d7ff1496fddb0$var$getPlaceholderState(editorState) {
    return $146d7ff1496fddb0$export$18d4026d1ea86bb1.getState(editorState);
}
const $146d7ff1496fddb0$export$53e9a5af7ff64f3e = 'placeholder-test-id';
const $146d7ff1496fddb0$var$nodeTypesWithLongPlaceholderText = [
    'expand',
    'panel'
];
const $146d7ff1496fddb0$var$nodeTypesWithShortPlaceholderText = [
    'tableCell',
    'tableHeader'
];
function $146d7ff1496fddb0$export$980ea07f18fbfea9(editorState, placeholderText, pos = 1) {
    const placeholderDecoration = document.createElement('span');
    let placeholderNodeWithText = placeholderDecoration;
    placeholderDecoration.setAttribute('data-testid', $146d7ff1496fddb0$export$53e9a5af7ff64f3e);
    placeholderDecoration.className = 'placeholder-decoration';
    // PM sets contenteditable to false on Decorations so Firefox doesn't display the flashing cursor
    // So adding an extra span which will contain the placeholder text
    if ((0, $7EdFW.browser).gecko) {
        const placeholderNode = document.createElement('span');
        placeholderNode.setAttribute('contenteditable', 'true'); // explicitly overriding the default Decoration behaviour
        placeholderDecoration.appendChild(placeholderNode);
        placeholderNodeWithText = placeholderNode;
    }
    placeholderNodeWithText.textContent = placeholderText || ' ';
    // ME-2289 Tapping on backspace in empty editor hides and displays the keyboard
    // Add a editable buff node as the cursor moving forward is inevitable
    // when backspace in GBoard composition
    if ((0, $7EdFW.browser).android && (0, $7EdFW.browser).chrome) {
        const buffNode = document.createElement('span');
        buffNode.setAttribute('class', 'placeholder-android');
        buffNode.setAttribute('contenteditable', 'true');
        buffNode.textContent = ' ';
        placeholderDecoration.appendChild(buffNode);
    }
    const isTargetNested = editorState.doc.resolve(pos).depth > 1;
    // only truncate text for nested nodes, otherwise applying 'overflow: hidden;' to top level nodes
    // creates issues with quick insert button
    if (isTargetNested && (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1')) placeholderDecoration.classList.add('placeholder-decoration-hide-overflow');
    return (0, $b7EWj.DecorationSet).create(editorState.doc, [
        (0, $b7EWj.Decoration).widget(pos, placeholderDecoration, {
            side: 0,
            key: `placeholder ${placeholderText}`
        })
    ]);
}
function $146d7ff1496fddb0$var$setPlaceHolderState(placeholderText, pos) {
    return {
        hasPlaceholder: true,
        placeholderText: placeholderText,
        pos: pos ? pos : 1
    };
}
const $146d7ff1496fddb0$var$emptyPlaceholder = (placeholderText)=>({
        hasPlaceholder: false,
        placeholderText: placeholderText
    });
function $146d7ff1496fddb0$var$createPlaceHolderStateFrom({ isEditorFocused: isEditorFocused, editorState: editorState, isTypeAheadOpen: isTypeAheadOpen, defaultPlaceholderText: defaultPlaceholderText, intl: intl, bracketPlaceholderText: bracketPlaceholderText, emptyLinePlaceholder: emptyLinePlaceholder }) {
    if (isTypeAheadOpen?.(editorState)) return $146d7ff1496fddb0$var$emptyPlaceholder(defaultPlaceholderText);
    if (defaultPlaceholderText && (0, $bnAxN.isEmptyDocument)(editorState.doc)) return $146d7ff1496fddb0$var$setPlaceHolderState(defaultPlaceholderText);
    if (isEditorFocused && (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1')) {
        const { $from: $from, $to: $to } = editorState.selection;
        if ($from.pos !== $to.pos) return $146d7ff1496fddb0$var$emptyPlaceholder(defaultPlaceholderText);
        const parentNode = $from.node($from.depth - 1);
        const parentType = parentNode?.type.name;
        if (emptyLinePlaceholder && parentType === 'doc') {
            const isEmptyLine = (0, $5Z3Rm.isEmptyParagraph)($from.parent);
            if (isEmptyLine) return $146d7ff1496fddb0$var$setPlaceHolderState(emptyLinePlaceholder, $from.pos);
        }
        const isEmptyNode = parentNode?.childCount === 1 && parentNode.firstChild?.content.size === 0 && parentNode.firstChild?.type.name === 'paragraph';
        if ($146d7ff1496fddb0$var$nodeTypesWithShortPlaceholderText.includes(parentType) && isEmptyNode) {
            const table = (0, $BmspC.findParentNode)((node)=>node.type === editorState.schema.nodes.table)(editorState.selection);
            if (!table) return $146d7ff1496fddb0$var$emptyPlaceholder(defaultPlaceholderText);
            const isFirstCell = table?.node.firstChild?.content.firstChild === parentNode;
            if (isFirstCell) return $146d7ff1496fddb0$var$setPlaceHolderState(intl.formatMessage((0, $dfJR8.placeholderTextMessages).shortEmptyNodePlaceholderText), $from.pos);
        }
        if ($146d7ff1496fddb0$var$nodeTypesWithLongPlaceholderText.includes(parentType) && isEmptyNode) return $146d7ff1496fddb0$var$setPlaceHolderState(intl.formatMessage((0, $dfJR8.placeholderTextMessages).longEmptyNodePlaceholderText), $from.pos);
        return $146d7ff1496fddb0$var$emptyPlaceholder(defaultPlaceholderText);
    }
    if (bracketPlaceholderText && (0, $bnAxN.bracketTyped)(editorState) && isEditorFocused) {
        const { $from: $from } = editorState.selection;
        // Space is to account for positioning of the bracket
        const bracketHint = '  ' + bracketPlaceholderText;
        return $146d7ff1496fddb0$var$setPlaceHolderState(bracketHint, $from.pos - 1);
    }
    return $146d7ff1496fddb0$var$emptyPlaceholder(defaultPlaceholderText);
}
function $146d7ff1496fddb0$export$ae829ec7b2625219(intl, defaultPlaceholderText, bracketPlaceholderText, emptyLinePlaceholder, api) {
    if (!defaultPlaceholderText && !bracketPlaceholderText) return;
    return new (0, $i8KtF.SafePlugin)({
        key: $146d7ff1496fddb0$export$18d4026d1ea86bb1,
        state: {
            init: (_, state)=>$146d7ff1496fddb0$var$createPlaceHolderStateFrom({
                    isEditorFocused: Boolean(api?.focus?.sharedState.currentState()?.hasFocus),
                    editorState: state,
                    isTypeAheadOpen: api?.typeAhead?.actions.isOpen,
                    defaultPlaceholderText: defaultPlaceholderText,
                    bracketPlaceholderText: bracketPlaceholderText,
                    emptyLinePlaceholder: emptyLinePlaceholder,
                    intl: intl
                }),
            apply: (tr, placeholderState, _oldEditorState, newEditorState)=>{
                const meta = tr.getMeta($146d7ff1496fddb0$export$18d4026d1ea86bb1);
                const isEditorFocused = Boolean(api?.focus?.sharedState.currentState()?.hasFocus);
                if (meta?.placeholderText !== undefined) return $146d7ff1496fddb0$var$createPlaceHolderStateFrom({
                    isEditorFocused: isEditorFocused,
                    editorState: newEditorState,
                    isTypeAheadOpen: api?.typeAhead?.actions.isOpen,
                    defaultPlaceholderText: meta.placeholderText,
                    bracketPlaceholderText: bracketPlaceholderText,
                    emptyLinePlaceholder: emptyLinePlaceholder,
                    intl: intl
                });
                return $146d7ff1496fddb0$var$createPlaceHolderStateFrom({
                    isEditorFocused: isEditorFocused,
                    editorState: newEditorState,
                    isTypeAheadOpen: api?.typeAhead?.actions.isOpen,
                    defaultPlaceholderText: placeholderState?.placeholderText ?? defaultPlaceholderText,
                    bracketPlaceholderText: bracketPlaceholderText,
                    emptyLinePlaceholder: emptyLinePlaceholder,
                    intl: intl
                });
            }
        },
        props: {
            decorations (editorState) {
                const { hasPlaceholder: hasPlaceholder, placeholderText: placeholderText, pos: pos } = $146d7ff1496fddb0$var$getPlaceholderState(editorState);
                const compositionPluginState = api?.composition?.sharedState.currentState();
                if (hasPlaceholder && placeholderText && pos !== undefined && !compositionPluginState?.isComposing) return $146d7ff1496fddb0$export$980ea07f18fbfea9(editorState, placeholderText, pos);
                return;
            }
        }
    });
}
const $146d7ff1496fddb0$export$ecbe4cfe6671ba88 = ({ config: options, api: api })=>{
    let currentPlaceholder = options?.placeholder;
    return {
        name: 'placeholder',
        commands: {
            setPlaceholder: (placeholderText)=>({ tr: tr })=>{
                    if (currentPlaceholder !== placeholderText) {
                        currentPlaceholder = placeholderText;
                        return tr.setMeta($146d7ff1496fddb0$export$18d4026d1ea86bb1, {
                            placeholderText: placeholderText
                        });
                    }
                    return null;
                }
        },
        pmPlugins () {
            return [
                {
                    name: 'placeholder',
                    plugin: ({ getIntl: getIntl })=>$146d7ff1496fddb0$export$ae829ec7b2625219(getIntl(), options && options.placeholder, options && options.placeholderBracketHint, options && options.emptyLinePlaceholder, api)
                }
            ];
        }
    };
};

});


parcelRegister("8S3vg", function(module, exports) {

$parcel$export(module.exports, "saveOnEnterPlugin", () => (parcelRequire("eE2Rw")).saveOnEnterPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $eE2Rw = parcelRequire("eE2Rw");

});
parcelRegister("eE2Rw", function(module, exports) {

$parcel$export(module.exports, "saveOnEnterPlugin", () => $ab33c91dcd7a9583$export$8ba1e5775ae443a6);

var $bMFKb = parcelRequire("bMFKb");

var $dyNYh = parcelRequire("dyNYh");

var $x7sgX = parcelRequire("x7sgX");
const $ab33c91dcd7a9583$export$ae829ec7b2625219 = (eventDispatch, onSave)=>{
    if (!onSave) return;
    return (0, $x7sgX.keymap)({
        Enter (state, _dispatch, editorView) {
            if (editorView && $ab33c91dcd7a9583$var$canSaveOnEnter(editorView)) {
                eventDispatch((0, $dyNYh.analyticsEventKey), $ab33c91dcd7a9583$var$analyticsPayload(state));
                onSave(editorView);
                return true;
            }
            return false;
        }
    });
};
function $ab33c91dcd7a9583$var$canSaveOnEnter(editorView) {
    const { $cursor: $cursor } = editorView.state.selection;
    const { decisionItem: decisionItem, paragraph: paragraph, taskItem: taskItem } = editorView.state.schema.nodes;
    return !$cursor || $cursor.parent.type === paragraph && $cursor.depth === 1 || $cursor.parent.type === decisionItem && !$ab33c91dcd7a9583$var$isEmptyAtCursor($cursor) || $cursor.parent.type === taskItem && !$ab33c91dcd7a9583$var$isEmptyAtCursor($cursor);
}
function $ab33c91dcd7a9583$var$isEmptyAtCursor($cursor) {
    const { content: content } = $cursor.parent;
    return !(content && content.size);
}
const $ab33c91dcd7a9583$var$analyticsPayload = (state)=>({
        payload: {
            action: (0, $bMFKb.ACTION).STOPPED,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).EDITOR,
            actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).SAVE,
            attributes: {
                inputMethod: (0, $bMFKb.INPUT_METHOD).SHORTCUT,
                documentSize: state.doc.nodeSize
            },
            eventType: (0, $bMFKb.EVENT_TYPE).UI
        }
    });
const $ab33c91dcd7a9583$export$8ba1e5775ae443a6 = ({ config: onSave })=>({
        name: 'saveOnEnter',
        pmPlugins () {
            return [
                {
                    name: 'saveOnEnter',
                    plugin: ({ dispatch: dispatch })=>$ab33c91dcd7a9583$export$ae829ec7b2625219(dispatch, onSave)
                }
            ];
        }
    });

});


parcelRegister("avoFZ", function(module, exports) {

$parcel$export(module.exports, "selectionPlugin", () => (parcelRequire("ewf7Y")).selectionPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $ewf7Y = parcelRequire("ewf7Y");

});
parcelRegister("ewf7Y", function(module, exports) {

$parcel$export(module.exports, "selectionPlugin", () => $394468fcb45bcae8$export$35a6a08064a865b4);

var $jPzSh = parcelRequire("jPzSh");

var $7l5OF = parcelRequire("7l5OF");

var $fBvx8 = parcelRequire("fBvx8");

var $1K5XD = parcelRequire("1K5XD");

var $9CzUQ = parcelRequire("9CzUQ");

var $2UiR6 = parcelRequire("2UiR6");

var $jBulN = parcelRequire("jBulN");

var $5xOwf = parcelRequire("5xOwf");

var $eTc0n = parcelRequire("eTc0n");
const $394468fcb45bcae8$var$displayGapCursor = (toggle)=>({ tr: tr })=>{
        return tr.setMeta((0, $9CzUQ.gapCursorPluginKey), {
            displayGapCursor: toggle
        });
    };
const $394468fcb45bcae8$var$clearManualSelection = ()=>({ tr: tr })=>{
        const currMeta = tr.getMeta((0, $eTc0n.selectionPluginKey));
        return tr.setMeta((0, $eTc0n.selectionPluginKey), {
            ...currMeta,
            manualSelection: {}
        });
    };
const $394468fcb45bcae8$var$setManualSelection = (anchor, head)=>({ tr: tr })=>{
        const currMeta = tr.getMeta((0, $eTc0n.selectionPluginKey));
        return tr.setMeta((0, $eTc0n.selectionPluginKey), {
            ...currMeta,
            manualSelection: {
                anchor: anchor,
                head: head
            }
        });
    };
const $394468fcb45bcae8$export$35a6a08064a865b4 = ({ api: api, config: options })=>({
        name: 'selection',
        commands: {
            displayGapCursor: $394468fcb45bcae8$var$displayGapCursor,
            clearManualSelection: $394468fcb45bcae8$var$clearManualSelection,
            setManualSelection: $394468fcb45bcae8$var$setManualSelection
        },
        actions: {
            selectNearNode: ({ selectionRelativeToNode: selectionRelativeToNode, selection: selection })=>(state)=>{
                    return (0, $7l5OF.selectNearNode)(selectionRelativeToNode, selection)({
                        tr: state.tr
                    }) || state.tr;
                }
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const pluginState = (0, $eTc0n.selectionPluginKey).getState(editorState);
            return {
                selectionRelativeToNode: pluginState?.selectionRelativeToNode,
                selection: pluginState?.selection
            };
        },
        pmPlugins () {
            return [
                {
                    name: 'selection',
                    plugin: ({ dispatch: dispatch, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>(0, $5xOwf.createPlugin)(api, dispatch, dispatchAnalyticsEvent, options)
                },
                {
                    name: 'selectionKeymap',
                    plugin: (0, $2UiR6.default)
                },
                {
                    name: 'gapCursorKeymap',
                    plugin: ()=>(0, $fBvx8.default)()
                },
                {
                    name: 'gapCursor',
                    plugin: ()=>(0, $1K5XD.default)
                },
                {
                    name: 'markBoundaryCursor',
                    plugin: ()=>(0, $jBulN.createMarkBoundaryCursorPlugin)()
                },
                {
                    name: 'autoExpandSelectionRangeOnInlineNode',
                    plugin: ()=>(0, $jPzSh.createAutoExpandSelectionRangeOnInlineNodePlugin)()
                }
            ];
        }
    });
var $394468fcb45bcae8$export$2e2bcd8739ae039 = $394468fcb45bcae8$export$35a6a08064a865b4;

});
parcelRegister("jPzSh", function(module, exports) {

$parcel$export(module.exports, "createAutoExpandSelectionRangeOnInlineNodePlugin", () => $eb961db1498253ff$export$b5faf98028194323);

var $i8KtF = parcelRequire("i8KtF");

var $3lIcL = parcelRequire("3lIcL");

var $jgXAI = parcelRequire("jgXAI");
const $eb961db1498253ff$export$b5faf98028194323 = ()=>{
    let mouseDownElement = null;
    return new (0, $i8KtF.SafePlugin)({
        key: (0, $jgXAI.autoExpandSelectionRangeOnInlineNodePluginKey),
        props: {
            handleDOMEvents: {
                mousedown: (_view, event)=>{
                    // Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    mouseDownElement = event.target;
                },
                mouseup: (view, event)=>{
                    // Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    const mouseUpElement = event.target;
                    // terminate early if mouse down and mouse up elements are the same -> e.g a click event
                    // or mouse down doesn't trigger
                    if (!mouseDownElement || mouseDownElement === mouseUpElement) {
                        mouseDownElement = null;
                        return;
                    }
                    // reset mouse down element after mouse up event
                    // so that we can detect the next mouse down event is triggered right after mouse up event or not
                    mouseDownElement = null;
                    // terminate early if mouse up event is not fired on inline node
                    if (!$eb961db1498253ff$var$isMouseUpOnSupportedNode(mouseUpElement)) return;
                    const { dispatch: dispatch, state: state } = view;
                    const { selection: selection } = state;
                    // terminate early if current selection is not a text selection -> e.g. table cell selection
                    if (!(selection instanceof (0, $3lIcL.TextSelection))) return;
                    // find the document position of the mouse up element
                    const elementStartPosition = view.posAtDOM(mouseUpElement, 0);
                    // find out the direction of selection
                    const isAnchorBeforeElement = selection.$anchor.pos <= elementStartPosition;
                    const expandedSelectionHeadPosition = isAnchorBeforeElement ? elementStartPosition + 1 : elementStartPosition;
                    // expand the selection to include the mouse up element
                    const tr = state.tr.setSelection((0, $3lIcL.TextSelection).create(state.doc, selection.$anchor.pos, expandedSelectionHeadPosition));
                    dispatch(tr);
                }
            }
        }
    });
};
const $eb961db1498253ff$var$isMouseUpOnSupportedNode = (mouseUpElement)=>{
    const supportedNodes = [
        'emoji',
        'status',
        'date',
        'mention',
        'inlineCard'
    ];
    const supportedNodeViewContentClassNamesList = supportedNodes.map((nodeType)=>`.${nodeType}View-content-wrap`).join(', ');
    return !!mouseUpElement.closest(supportedNodeViewContentClassNamesList);
};

});
parcelRegister("jgXAI", function(module, exports) {

$parcel$export(module.exports, "autoExpandSelectionRangeOnInlineNodePluginKey", () => $4ca724eca13ceb40$export$e6805678cce429a4);

var $3lIcL = parcelRequire("3lIcL");
const $4ca724eca13ceb40$export$e6805678cce429a4 = new (0, $3lIcL.PluginKey)('autoExpandSelectionRangeOnInlineNodePlugin');

});


parcelRegister("7l5OF", function(module, exports) {

$parcel$export(module.exports, "selectNearNode", () => $0f204d8c0b32af69$export$c7d22caae2fd3756);
$parcel$export(module.exports, "arrowRight", () => $0f204d8c0b32af69$export$680a8d7c28b0860);
$parcel$export(module.exports, "arrowLeft", () => $0f204d8c0b32af69$export$3ff8c533d254ed7c);
/* eslint-disable import/no-extraneous-dependencies */ 
var $6BNUN = parcelRequire("6BNUN");
var $cm19r = parcelRequire("cm19r");
var $5n5Zn = parcelRequire("5n5Zn");
parcelRequire("3ADzg");
var $5Z3Rm = parcelRequire("5Z3Rm");
var $3ADzg = parcelRequire("3ADzg");

var $3lIcL = parcelRequire("3lIcL");

var $eTc0n = parcelRequire("eTc0n");

var $jCgC5 = parcelRequire("jCgC5");

var $7bAHr = parcelRequire("7bAHr");

var $hFP0U = parcelRequire("hFP0U");
const $0f204d8c0b32af69$export$c7d22caae2fd3756 = (selectionRelativeToNode, selection)=>({ tr: tr })=>{
        tr.setMeta((0, $eTc0n.selectionPluginKey), {
            type: (0, $jCgC5.SelectionActionTypes).SET_RELATIVE_SELECTION,
            selectionRelativeToNode: selectionRelativeToNode
        });
        if (selection) return tr.setSelection(selection);
        return tr;
    };
const $0f204d8c0b32af69$export$56a7f03ce3f93e52 = (selectionRelativeToNode, selection)=>(0, $7bAHr.createCommand)({
        type: (0, $jCgC5.SelectionActionTypes).SET_RELATIVE_SELECTION,
        selectionRelativeToNode: selectionRelativeToNode
    }, (tr)=>{
        return $0f204d8c0b32af69$export$c7d22caae2fd3756(selectionRelativeToNode, selection)({
            tr: tr
        }) || tr;
    });
const $0f204d8c0b32af69$export$680a8d7c28b0860 = (state, dispatch)=>{
    const { selection: selection } = state;
    if (selection instanceof (0, $6BNUN.GapCursorSelection)) return $0f204d8c0b32af69$var$arrowRightFromGapCursor(selection)(state, dispatch);
    else if (selection instanceof (0, $3lIcL.NodeSelection)) return $0f204d8c0b32af69$var$arrowRightFromNode(selection)(state, dispatch);
    else if (selection instanceof (0, $3lIcL.TextSelection)) return $0f204d8c0b32af69$var$arrowRightFromText(selection)(state, dispatch);
    return false;
};
const $0f204d8c0b32af69$export$3ff8c533d254ed7c = (state, dispatch)=>{
    const { selection: selection } = state;
    if (selection instanceof (0, $6BNUN.GapCursorSelection)) return $0f204d8c0b32af69$var$arrowLeftFromGapCursor(selection)(state, dispatch);
    else if (selection instanceof (0, $3lIcL.NodeSelection)) return $0f204d8c0b32af69$var$arrowLeftFromNode(selection)(state, dispatch);
    else if (selection instanceof (0, $3lIcL.TextSelection)) return $0f204d8c0b32af69$var$arrowLeftFromText(selection)(state, dispatch);
    return false;
};
const $0f204d8c0b32af69$var$arrowRightFromGapCursor = (selection)=>(state, dispatch)=>{
        const { $from: $from, $to: $to, side: side } = selection;
        if (side === (0, $6BNUN.Side).LEFT) {
            const selectableNode = (0, $hFP0U.findSelectableContainerAfter)($to, state.doc);
            if (selectableNode) return $0f204d8c0b32af69$export$56a7f03ce3f93e52((0, $5n5Zn.RelativeSelectionPos).Start, (0, $3lIcL.NodeSelection).create(state.doc, selectableNode.pos))(state, dispatch);
        } else if (side === (0, $6BNUN.Side).RIGHT && (0, $hFP0U.isSelectionAtEndOfParentNode)($from, selection)) {
            const selectableNode = (0, $hFP0U.findSelectableContainerParent)(selection);
            if (selectableNode) return $0f204d8c0b32af69$export$56a7f03ce3f93e52((0, $5n5Zn.RelativeSelectionPos).End, (0, $3lIcL.NodeSelection).create(state.doc, selectableNode.pos))(state, dispatch);
        }
        return false;
    };
const $0f204d8c0b32af69$var$arrowLeftFromGapCursor = (selection)=>(state, dispatch)=>{
        const { $from: $from, side: side } = selection;
        const { selectionRelativeToNode: selectionRelativeToNode } = (0, $7bAHr.getPluginState)(state);
        if (side === (0, $6BNUN.Side).RIGHT) {
            const selectableNode = (0, $hFP0U.findSelectableContainerBefore)($from, state.doc);
            if (selectableNode) return $0f204d8c0b32af69$export$56a7f03ce3f93e52((0, $5n5Zn.RelativeSelectionPos).End, (0, $3lIcL.NodeSelection).create(state.doc, selectableNode.pos))(state, dispatch);
        } else if (side === (0, $6BNUN.Side).LEFT && (0, $hFP0U.isSelectionAtStartOfParentNode)($from, selection)) {
            if (selectionRelativeToNode === (0, $5n5Zn.RelativeSelectionPos).Before) {
                const $parent = state.doc.resolve(selection.$from.before(selection.$from.depth));
                if ($parent) {
                    const selectableNode = (0, $hFP0U.findSelectableContainerBefore)($parent, state.doc);
                    if (selectableNode && (0, $cm19r.isIgnored)(selectableNode.node)) // selection is inside node without gap cursor preceeded by another node without gap cursor - set node selection for previous node
                    return $0f204d8c0b32af69$export$56a7f03ce3f93e52((0, $5n5Zn.RelativeSelectionPos).End, (0, $3lIcL.NodeSelection).create(state.doc, selectableNode.pos))(state, dispatch);
                }
                // we don't return this as we want to reset the relative pos, but not block other plugins
                // from responding to arrow left key
                $0f204d8c0b32af69$export$56a7f03ce3f93e52()(state, dispatch);
            } else {
                const selectableNode = (0, $hFP0U.findSelectableContainerParent)(selection);
                if (selectableNode) return $0f204d8c0b32af69$export$56a7f03ce3f93e52((0, $5n5Zn.RelativeSelectionPos).Start, (0, $3lIcL.NodeSelection).create(state.doc, selectableNode.pos))(state, dispatch);
            }
        }
        return false;
    };
const $0f204d8c0b32af69$var$arrowRightFromNode = (selection)=>(state, dispatch)=>{
        const { node: node, from: from, $to: $to } = selection;
        const { selectionRelativeToNode: selectionRelativeToNode } = (0, $7bAHr.getPluginState)(state);
        if (node.isAtom) {
            if ((0, $hFP0U.isSelectionAtEndOfParentNode)($to, selection) && (node.isInline || (0, $cm19r.isIgnored)(node))) // selection is for inline node or atom node which is ignored by gap-cursor and that is the last child of its parent node - set text selection after it
            return $0f204d8c0b32af69$var$findAndSetTextSelection((0, $5n5Zn.RelativeSelectionPos).End, state.doc.resolve(from + 1), (0, $eTc0n.SelectionDirection).After)(state, dispatch);
            return false;
        } else if (selectionRelativeToNode === (0, $5n5Zn.RelativeSelectionPos).Start) // selection is for container node - set selection inside it at the start
        return $0f204d8c0b32af69$var$setSelectionInsideAtNodeStart((0, $5n5Zn.RelativeSelectionPos).Inside, node, from)(state, dispatch);
        else if ((0, $cm19r.isIgnored)(node) && (!selectionRelativeToNode || selectionRelativeToNode === (0, $5n5Zn.RelativeSelectionPos).End)) {
            const selectableNode = (0, $hFP0U.findSelectableContainerAfter)($to, state.doc);
            if (selectableNode && (0, $cm19r.isIgnored)(selectableNode.node)) // selection is for node without gap cursor followed by another node without gap cursor - set node selection for next node
            return $0f204d8c0b32af69$export$56a7f03ce3f93e52((0, $5n5Zn.RelativeSelectionPos).Start, (0, $3lIcL.NodeSelection).create(state.doc, selectableNode.pos))(state, dispatch);
        }
        return false;
    };
const $0f204d8c0b32af69$var$arrowLeftFromNode = (selection)=>(state, dispatch)=>{
        const { node: node, from: from, to: to, $from: $from } = selection;
        const { selectionRelativeToNode: selectionRelativeToNode } = (0, $7bAHr.getPluginState)(state);
        if (node.isAtom) {
            if ((0, $hFP0U.isSelectionAtStartOfParentNode)($from, selection) && (node.isInline || (0, $cm19r.isIgnored)(node))) // selection is for inline node or atom node which is ignored by gap-cursor and that is the first child of its parent node - set text selection before it
            return $0f204d8c0b32af69$var$findAndSetTextSelection((0, $5n5Zn.RelativeSelectionPos).Start, state.doc.resolve(from), (0, $eTc0n.SelectionDirection).Before)(state, dispatch);
            return false;
        } else if (selectionRelativeToNode === (0, $5n5Zn.RelativeSelectionPos).End) // selection is for container node - set selection inside it at the end
        return $0f204d8c0b32af69$export$7c9ae5d21795cde4((0, $5n5Zn.RelativeSelectionPos).Inside, node, from, to)(state, dispatch);
        else if (!selectionRelativeToNode || selectionRelativeToNode === (0, $5n5Zn.RelativeSelectionPos).Inside) // selection is for container node - set selection inside it at the start
        // (this is a special case when the user selects by clicking node)
        return $0f204d8c0b32af69$var$setSelectionInsideAtNodeStart((0, $5n5Zn.RelativeSelectionPos).Before, node, from)(state, dispatch);
        else if ((0, $cm19r.isIgnored)(node) && selectionRelativeToNode === (0, $5n5Zn.RelativeSelectionPos).Start) {
            // selection is for node without gap cursor preceeded by another node without gap cursor - set node selection for previous node
            const selectableNode = (0, $hFP0U.findSelectableContainerBefore)($from, state.doc);
            if (selectableNode && (0, $cm19r.isIgnored)(selectableNode.node)) return $0f204d8c0b32af69$export$56a7f03ce3f93e52((0, $5n5Zn.RelativeSelectionPos).End, (0, $3lIcL.NodeSelection).create(state.doc, selectableNode.pos))(state, dispatch);
        }
        return false;
    };
const $0f204d8c0b32af69$var$arrowRightFromText = (selection)=>(state, dispatch)=>{
        if ((0, $hFP0U.isSelectionAtEndOfParentNode)(selection.$to, selection)) {
            const selectableNode = (0, $hFP0U.findSelectableContainerParent)(selection);
            if (selectableNode) return $0f204d8c0b32af69$export$56a7f03ce3f93e52((0, $5n5Zn.RelativeSelectionPos).End, (0, $3lIcL.NodeSelection).create(state.doc, selectableNode.pos))(state, dispatch);
        }
        return false;
    };
const $0f204d8c0b32af69$var$arrowLeftFromText = (selection)=>(state, dispatch)=>{
        const { selectionRelativeToNode: selectionRelativeToNode } = (0, $7bAHr.getPluginState)(state);
        if (selectionRelativeToNode === (0, $5n5Zn.RelativeSelectionPos).Before) {
            const selectableNode = (0, $hFP0U.findSelectableContainerBefore)(selection.$from, state.doc);
            if (selectableNode && (0, $cm19r.isIgnored)(selectableNode.node)) // selection is inside node without gap cursor preceeded by another node without gap cursor - set node selection for previous node
            return $0f204d8c0b32af69$export$56a7f03ce3f93e52((0, $5n5Zn.RelativeSelectionPos).End, (0, $3lIcL.NodeSelection).create(state.doc, selectableNode.pos))(state, dispatch);
            // we don't return this as we want to reset the relative pos, but not block other plugins
            // from responding to arrow left key
            $0f204d8c0b32af69$export$56a7f03ce3f93e52(undefined)(state, dispatch);
        } else if ((0, $hFP0U.isSelectionAtStartOfParentNode)(selection.$from, selection)) {
            const selectableNode = (0, $hFP0U.findSelectableContainerParent)(selection);
            if (selectableNode) return $0f204d8c0b32af69$export$56a7f03ce3f93e52((0, $5n5Zn.RelativeSelectionPos).Start, (0, $3lIcL.NodeSelection).create(state.doc, selectableNode.pos))(state, dispatch);
        }
        return false;
    };
const $0f204d8c0b32af69$var$findAndSetTextSelection = (selectionRelativeToNode, $pos, dir)=>(state, dispatch)=>{
        const sel = (0, $3lIcL.Selection).findFrom($pos, dir, true);
        if (sel) return $0f204d8c0b32af69$export$56a7f03ce3f93e52(selectionRelativeToNode, sel)(state, dispatch);
        return false;
    };
const $0f204d8c0b32af69$var$setSelectionInsideAtNodeStart = (selectionRelativeToNode, node, pos)=>(state, dispatch)=>{
        if ((0, $3ADzg.isNodeEmpty)(node)) return $0f204d8c0b32af69$var$findAndSetTextSelection(selectionRelativeToNode, state.doc.resolve(pos), (0, $eTc0n.SelectionDirection).After)(state, dispatch);
        const selectableNode = (0, $hFP0U.findFirstChildNodeToSelect)(node);
        if (selectableNode) {
            const { node: childNode, pos: childPos } = selectableNode;
            const selectionPos = pos + childPos + 1;
            if (childNode.isText || childNode.isAtom && (0, $cm19r.isIgnored)(childNode) || childNode.isInline) //selection is for text node, inline node or atom node which is ignored by gap-cursor. set selection before it.
            return $0f204d8c0b32af69$var$findAndSetTextSelection(selectionRelativeToNode, state.doc.resolve(selectionPos), (0, $eTc0n.SelectionDirection).Before)(state, dispatch);
            else if ((0, $5Z3Rm.isEmptyParagraph)(childNode)) return $0f204d8c0b32af69$var$findAndSetTextSelection(selectionRelativeToNode, state.doc.resolve(selectionPos + 1), (0, $eTc0n.SelectionDirection).Before)(state, dispatch);
            else if (!(0, $cm19r.isIgnored)(node)) return $0f204d8c0b32af69$export$56a7f03ce3f93e52(selectionRelativeToNode, new (0, $6BNUN.GapCursorSelection)(state.doc.resolve(selectionPos), (0, $6BNUN.Side).LEFT))(state, dispatch);
            else if ((0, $hFP0U.isSelectableContainerNode)(node)) return $0f204d8c0b32af69$export$56a7f03ce3f93e52(selectionRelativeToNode, (0, $3lIcL.NodeSelection).create(state.doc, selectionPos))(state, dispatch);
        }
        return false;
    };
const $0f204d8c0b32af69$export$7c9ae5d21795cde4 = (selectionRelativeToNode, node, from, to)=>(state, dispatch)=>{
        if ((0, $3ADzg.isNodeEmpty)(node)) return $0f204d8c0b32af69$var$findAndSetTextSelection(selectionRelativeToNode, state.doc.resolve(to), (0, $eTc0n.SelectionDirection).Before)(state, dispatch);
        const selectableNode = (0, $hFP0U.findLastChildNodeToSelect)(node);
        if (selectableNode) {
            const { node: childNode, pos: childPos } = selectableNode;
            const selectionPos = from + childPos + childNode.nodeSize;
            if (childNode.isText || childNode.isAtom && (0, $cm19r.isIgnored)(childNode) || childNode.isInline) //selection is for text node, inline node or atom node which is ignored by gap-cursor. set selection after it.
            return $0f204d8c0b32af69$var$findAndSetTextSelection(selectionRelativeToNode, state.doc.resolve(selectionPos + 1), (0, $eTc0n.SelectionDirection).After)(state, dispatch);
            else if ((0, $5Z3Rm.isEmptyParagraph)(childNode)) return $0f204d8c0b32af69$var$findAndSetTextSelection(selectionRelativeToNode, state.doc.resolve(selectionPos), (0, $eTc0n.SelectionDirection).After)(state, dispatch);
            else if (!(0, $cm19r.isIgnored)(node)) return $0f204d8c0b32af69$export$56a7f03ce3f93e52(selectionRelativeToNode, new (0, $6BNUN.GapCursorSelection)(state.doc.resolve(selectionPos + 1), (0, $6BNUN.Side).RIGHT))(state, dispatch);
            else if ((0, $hFP0U.isSelectableContainerNode)(node)) return $0f204d8c0b32af69$export$56a7f03ce3f93e52(selectionRelativeToNode, (0, $3lIcL.NodeSelection).create(state.doc, selectionPos))(state, dispatch);
        }
        return false;
    };

});
parcelRegister("eTc0n", function(module, exports) {

$parcel$export(module.exports, "selectionPluginKey", () => $188599739b44fd34$export$e530ba00b008a680);
$parcel$export(module.exports, "SelectionDirection", () => $188599739b44fd34$export$5c80dd1df5708938);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json


var $3lIcL = parcelRequire("3lIcL");
const $188599739b44fd34$export$e530ba00b008a680 = new (0, $3lIcL.PluginKey)('selection');
var $188599739b44fd34$export$5c80dd1df5708938 = /*#__PURE__*/ function(SelectionDirection) {
    SelectionDirection[SelectionDirection["Before"] = -1] = "Before";
    SelectionDirection[SelectionDirection["After"] = 1] = "After";
    return SelectionDirection;
}({});

});

parcelRegister("jCgC5", function(module, exports) {

$parcel$export(module.exports, "SelectionActionTypes", () => $c6b117f6c8c70d84$export$ab4e2275d2998c63);
var $c6b117f6c8c70d84$export$ab4e2275d2998c63 = /*#__PURE__*/ function(SelectionActionTypes) {
    SelectionActionTypes["SET_DECORATIONS"] = "SET_DECORATIONS";
    SelectionActionTypes["SET_RELATIVE_SELECTION"] = "SET_RELATIVE_SELECTION";
    return SelectionActionTypes;
}({});

});

parcelRegister("7bAHr", function(module, exports) {

$parcel$export(module.exports, "createCommand", () => $b6fa31dbd550a188$export$8d4021544bdece00);
$parcel$export(module.exports, "getPluginState", () => $b6fa31dbd550a188$export$f05434c51e3762e);
$parcel$export(module.exports, "createPluginState", () => $b6fa31dbd550a188$export$656c7661095efe2e);

var $bazog = parcelRequire("bazog");

var $3lIcL = parcelRequire("3lIcL");

var $b7EWj = parcelRequire("b7EWj");

var $cwzAY = parcelRequire("cwzAY");

var $eTc0n = parcelRequire("eTc0n");

var $4krFs = parcelRequire("4krFs");

var $hFP0U = parcelRequire("hFP0U");
const $b6fa31dbd550a188$var$handleDocChanged = (tr, pluginState)=>{
    // in some collab edge cases mapping decorations could throw an error
    try {
        if (pluginState.decorationSet.find().length === 0 && (!tr.selectionSet || (0, $hFP0U.getDecorations)(tr).find().length === 0)) return pluginState;
        const decorationSet = pluginState.decorationSet.map(tr.mapping, tr.doc);
        return {
            ...pluginState,
            decorationSet: decorationSet
        };
    } catch (error) {
        return {
            ...pluginState,
            decorationSet: (0, $b7EWj.DecorationSet).empty
        };
    }
};
const $b6fa31dbd550a188$var$handleSelectionChanged = (tr, pluginState)=>{
    // Reset relative selection pos when user clicks to select a node
    if ((tr.selection instanceof (0, $3lIcL.NodeSelection) && (0, $hFP0U.isSelectableContainerNode)(tr.selection.node) || tr.selection instanceof (0, $cwzAY.CellSelection)) && !tr.getMeta((0, $eTc0n.selectionPluginKey))) return {
        ...pluginState,
        selectionRelativeToNode: undefined
    };
    return pluginState;
};
const { createCommand: $b6fa31dbd550a188$export$8d4021544bdece00, getPluginState: $b6fa31dbd550a188$export$f05434c51e3762e, createPluginState: $b6fa31dbd550a188$export$656c7661095efe2e } = (0, $bazog.pluginFactory)((0, $eTc0n.selectionPluginKey), (0, $4krFs.reducer), {
    onDocChanged: $b6fa31dbd550a188$var$handleDocChanged,
    onSelectionChanged: $b6fa31dbd550a188$var$handleSelectionChanged
});

});
parcelRegister("4krFs", function(module, exports) {

$parcel$export(module.exports, "reducer", () => $4881806283fb9b80$export$1650419e431d3ba3);

var $jCgC5 = parcelRequire("jCgC5");
function $4881806283fb9b80$export$1650419e431d3ba3(pluginState, action) {
    switch(action.type){
        case (0, $jCgC5.SelectionActionTypes).SET_DECORATIONS:
            return {
                ...pluginState,
                decorationSet: action.decorationSet,
                selection: action.selection
            };
        case (0, $jCgC5.SelectionActionTypes).SET_RELATIVE_SELECTION:
            return {
                ...pluginState,
                selectionRelativeToNode: action.selectionRelativeToNode
            };
        default:
            return pluginState;
    }
}

});

parcelRegister("hFP0U", function(module, exports) {

$parcel$export(module.exports, "getDecorations", () => $ae5d3b5b1a5104d6$export$968abecb43309c32);
$parcel$export(module.exports, "shouldRecalcDecorations", () => $ae5d3b5b1a5104d6$export$8f1ae47b39045ce2);
$parcel$export(module.exports, "isSelectableContainerNode", () => $ae5d3b5b1a5104d6$export$be9646888fa9d884);
$parcel$export(module.exports, "findSelectableContainerParent", () => $ae5d3b5b1a5104d6$export$15e7624ccd1acbba);
$parcel$export(module.exports, "findSelectableContainerBefore", () => $ae5d3b5b1a5104d6$export$5a13616ef7dc6dd);
$parcel$export(module.exports, "findSelectableContainerAfter", () => $ae5d3b5b1a5104d6$export$f64170c1c72ca928);
$parcel$export(module.exports, "findFirstChildNodeToSelect", () => $ae5d3b5b1a5104d6$export$12f3aca2cb5b5ae9);
$parcel$export(module.exports, "findLastChildNodeToSelect", () => $ae5d3b5b1a5104d6$export$b5a7c30cdb2d437f);
$parcel$export(module.exports, "isSelectionAtStartOfParentNode", () => $ae5d3b5b1a5104d6$export$f80a5aec143de6c6);
$parcel$export(module.exports, "isSelectionAtEndOfParentNode", () => $ae5d3b5b1a5104d6$export$1ab0c837d3abb951);

var $cm19r = parcelRequire("cm19r");
var $iqjsw = parcelRequire("iqjsw");
parcelRequire("3ADzg");
var $5Z3Rm = parcelRequire("5Z3Rm");
var $fCXIH = parcelRequire("fCXIH");

var $3lIcL = parcelRequire("3lIcL");

var $BmspC = parcelRequire("BmspC");

var $b7EWj = parcelRequire("b7EWj");

var $7yBx7 = parcelRequire("7yBx7");

var $eGOwo = parcelRequire("eGOwo");

var $eTc0n = parcelRequire("eTc0n");
const $ae5d3b5b1a5104d6$export$968abecb43309c32 = (tr, manualSelection)=>{
    let selection = tr.selection;
    if (selection instanceof (0, $3lIcL.NodeSelection)) return (0, $b7EWj.DecorationSet).create(tr.doc, [
        (0, $b7EWj.Decoration).node(selection.from, selection.to, {
            class: (0, $7yBx7.akEditorSelectedNodeClassName)
        })
    ]);
    if (selection instanceof (0, $3lIcL.TextSelection) || selection instanceof (0, $3lIcL.AllSelection)) {
        if (manualSelection && manualSelection.anchor >= 0 && manualSelection.head >= 0 && manualSelection.anchor <= tr.doc.nodeSize && manualSelection.head <= tr.doc.nodeSize) selection = (0, $3lIcL.TextSelection).create(tr.doc, manualSelection.anchor, manualSelection.head);
        const decorations = $ae5d3b5b1a5104d6$export$299033b282ee8671(selection, tr.doc).map(({ node: node, pos: pos })=>{
            return (0, $b7EWj.Decoration).node(pos, pos + node.nodeSize, {
                class: (0, $7yBx7.akEditorSelectedNodeClassName)
            });
        });
        return (0, $b7EWj.DecorationSet).create(tr.doc, decorations);
    }
    return (0, $b7EWj.DecorationSet).empty;
};
const $ae5d3b5b1a5104d6$var$topLevelBlockNodesThatHaveSelectionStyles = [
    'table',
    'panel',
    'expand',
    'layoutSection',
    'decisionList',
    'decisionItem',
    'codeBlock'
];
const $ae5d3b5b1a5104d6$export$299033b282ee8671 = (selection, doc)=>{
    const nodes = [];
    if (selection.from !== selection.to) {
        const { from: from, to: to } = selection;
        doc.nodesBetween(from, to, (node, pos)=>{
            const withinSelection = from <= pos && pos + node.nodeSize <= to;
            // The reason we need to check for these nodes is to stop
            // traversing their children if they are within a selection -
            // this is to prevent selection styles from being added to
            // the children as well as the parent node.
            // Example scenario is if an entire table has been selected
            // we should not traverse its children so we can apply the
            // selection styles to the table. But if an entire tableRow
            // has been selected (but the parent table has not) we should
            // traverse it as it could contain other nodes that need
            // selection styles. I couldn’t see a clear way to differentiate
            // without explicitly stating which nodes should be traversed
            // and which shouldn’t.
            const isTopLevelNodeThatHasSelectionStyles = $ae5d3b5b1a5104d6$var$topLevelBlockNodesThatHaveSelectionStyles.includes(node.type.name);
            // If the node is a top-level block node and completely sits within
            // the selection, we do not recurse it's children to prevent selection
            // styles being added to its child nodes. The expected behaviour
            // is that selection styles are only added to the parent.
            if (node && withinSelection && isTopLevelNodeThatHasSelectionStyles) {
                nodes.push({
                    node: node,
                    pos: pos
                });
                return false;
            // Otherwise we recurse the children and return them so we can apply
            // selection styles. Text is handled by the browser.
            } else if (node && withinSelection && !node.isText) nodes.push({
                node: node,
                pos: pos
            });
            return true;
        });
    }
    return nodes;
};
function $ae5d3b5b1a5104d6$export$8f1ae47b39045ce2({ oldEditorState: oldEditorState, newEditorState: newEditorState }) {
    const oldSelection = oldEditorState.selection;
    const newSelection = newEditorState.selection;
    const oldPluginState = (0, $eTc0n.selectionPluginKey).getState(oldEditorState);
    const newPluginState = (0, $eTc0n.selectionPluginKey).getState(newEditorState);
    if (!oldPluginState || !newPluginState) return false;
    // If selection is unchanged, no need to recalculate
    if (oldSelection.eq(newSelection)) {
        // We need this special case for NodeSelection, as Prosemirror still thinks the
        // selections are equal when the node has changed
        if (oldSelection instanceof (0, $3lIcL.NodeSelection) && newSelection instanceof (0, $3lIcL.NodeSelection)) {
            const oldDecorations = oldPluginState.decorationSet.find();
            const newDecorations = newPluginState.decorationSet.find();
            // There might not be old or new decorations if the node selection is for a text node
            // This wouldn't have happened intentionally, but we need to handle this case regardless
            if (oldDecorations.length > 0 && newDecorations.length > 0) return !oldDecorations[0].eq(newDecorations[0]);
            return !(oldDecorations.length === 0 && newDecorations.length === 0);
        }
        return false;
    }
    // There's no point updating decorations if going from one standard TextSelection to another
    if (oldSelection instanceof (0, $3lIcL.TextSelection) && newSelection instanceof (0, $3lIcL.TextSelection) && oldSelection.from === oldSelection.to && newSelection.from === newSelection.to) return false;
    return true;
}
const $ae5d3b5b1a5104d6$export$be9646888fa9d884 = (node)=>!!(node && !node.isAtom && (0, $3lIcL.NodeSelection).isSelectable(node));
const $ae5d3b5b1a5104d6$export$e6eb31f83412b327 = (node)=>!!(node && (node.isText || (0, $5Z3Rm.isEmptyParagraph)(node) || (0, $3lIcL.NodeSelection).isSelectable(node)));
const $ae5d3b5b1a5104d6$export$15e7624ccd1acbba = (selection)=>{
    let foundNodeThatSupportsGapCursor = false;
    const selectableNode = (0, $BmspC.findParentNode)((node)=>{
        const isSelectable = $ae5d3b5b1a5104d6$export$be9646888fa9d884(node);
        if (!isSelectable && !(0, $cm19r.isIgnored)(node)) foundNodeThatSupportsGapCursor = true;
        return isSelectable;
    })(selection);
    if (!foundNodeThatSupportsGapCursor) return selectableNode;
};
const $ae5d3b5b1a5104d6$export$5a13616ef7dc6dd = ($pos, doc)=>{
    // prosemirror just returns the same pos from Selection.findFrom when
    // parent.inlineContent is true, so we move position back one here
    // to counteract that
    if ($pos.parent.inlineContent && $ae5d3b5b1a5104d6$export$be9646888fa9d884($pos.parent)) $pos = doc.resolve($pos.start() - 1);
    const selectionBefore = (0, $3lIcL.Selection).findFrom($pos, -1);
    if (selectionBefore) {
        const $selectionBefore = doc.resolve(selectionBefore.from);
        for(let i = $pos.depth + 1; i <= $selectionBefore.depth; i++){
            const node = $selectionBefore.node(i);
            if ($ae5d3b5b1a5104d6$export$be9646888fa9d884(node)) return {
                node: node,
                pos: $selectionBefore.start(i) - 1
            };
            if (i > $pos.depth + 1 && !(0, $cm19r.isIgnored)(node)) return;
        }
        /**
		 * Stick to the default left selection behaviour,
		 * useful for mediaSingleWithCaption
		 */ if (selectionBefore instanceof (0, $3lIcL.NodeSelection) && (0, $3lIcL.NodeSelection).isSelectable(selectionBefore.node)) return {
            node: selectionBefore.node,
            pos: selectionBefore.from
        };
    }
};
const $ae5d3b5b1a5104d6$export$f64170c1c72ca928 = ($pos, doc)=>{
    const selectionAfter = (0, $3lIcL.Selection).findFrom($pos, 1);
    if (selectionAfter) {
        const $selectionAfter = doc.resolve(selectionAfter.from);
        for(let i = $pos.depth + 1; i <= $selectionAfter.depth; i++){
            const node = $selectionAfter.node(i);
            if ($ae5d3b5b1a5104d6$export$be9646888fa9d884(node)) return {
                node: node,
                pos: $selectionAfter.start(i) - 1
            };
            if (i > $pos.depth + 1 && !(0, $cm19r.isIgnored)(node)) return;
        }
    }
};
const $ae5d3b5b1a5104d6$export$12f3aca2cb5b5ae9 = (parent)=>(0, $BmspC.flatten)(parent).find((child)=>$ae5d3b5b1a5104d6$export$e6eb31f83412b327(child.node) || !(0, $cm19r.isIgnored)(child.node));
const $ae5d3b5b1a5104d6$export$b5a7c30cdb2d437f = (parent)=>{
    let child;
    parent.descendants((node, pos)=>{
        if ($ae5d3b5b1a5104d6$export$e6eb31f83412b327(node) || !(0, $cm19r.isIgnored)(node)) {
            child = {
                node: node,
                pos: pos
            };
            return false;
        }
    });
    if (child) return child;
};
const $ae5d3b5b1a5104d6$export$f80a5aec143de6c6 = ($pos, selection)=>(0, $iqjsw.isSelectionAtStartOfNode)($pos, $ae5d3b5b1a5104d6$export$15e7624ccd1acbba(selection)?.node);
const $ae5d3b5b1a5104d6$export$1ab0c837d3abb951 = ($pos, selection)=>{
    // If the current position is at the end of its parent node's content.
    const isAtTheEndOfCurrentLevel = $pos.parent.content.size === $pos.parentOffset;
    if (!isAtTheEndOfCurrentLevel) return false;
    // If at the root or parent is selectable, we're at the end
    if ($pos.depth === 0 || (0, $3lIcL.NodeSelection).isSelectable($pos.parent)) return isAtTheEndOfCurrentLevel;
    // Handle lists: if in a list inside container and not at the end, return false
    if ((0, $BmspC.hasParentNode)((0, $fCXIH.isListItemNode))(selection) && $ae5d3b5b1a5104d6$export$7eb6f464328bf47e($pos, selection) && (0, $eGOwo.fg)('platform_editor_fix_right_arrow_bug_list_in_layout')) return false;
    // Default: if at end of parent's parent
    const $after = $pos.doc.resolve($pos.after());
    return $after.parent.content.size === $after.parentOffset;
};
const $ae5d3b5b1a5104d6$export$7eb6f464328bf47e = ($pos, selection)=>{
    const isInContainerNode = (0, $BmspC.hasParentNode)($ae5d3b5b1a5104d6$export$5f94d2e4ba42a5c7)(selection);
    if (!isInContainerNode) return false;
    const parentList = (0, $BmspC.findParentNodeClosestToPos)($pos, (0, $fCXIH.isListItemNode));
    if (!parentList) return false;
    const $parentListPos = $pos.doc.resolve(parentList.pos);
    const topLevelList = $ae5d3b5b1a5104d6$export$b0ac99e4524eec5a($pos);
    if (!topLevelList) return false;
    const $afterTopLevelList = $pos.doc.resolve(topLevelList.pos + topLevelList.node.nodeSize);
    const nodeAfterTopLevelList = $afterTopLevelList.nodeAfter;
    const grandParentList = (0, $BmspC.findParentNodeClosestToPos)($pos.doc.resolve($parentListPos.before()), (0, $fCXIH.isListItemNode));
    const grandParentListPos = grandParentList ? $pos.doc.resolve(grandParentList.pos) : undefined;
    const isLastListItemInParent = // Check if the current list item is the last child in its parent list
    $parentListPos.index() === $parentListPos.parent.childCount - 1 && // Check if there is no grandparent list, or if the grandparent list item is also the last child in its parent
    (!grandParentList || grandParentListPos && grandParentListPos.index() === grandParentListPos.parent.childCount - 1);
    if (!isLastListItemInParent || nodeAfterTopLevelList) return true;
    return false;
};
const $ae5d3b5b1a5104d6$export$5f94d2e4ba42a5c7 = (node)=>{
    const { layoutColumn: layoutColumn, panel: panel, expand: expand } = node?.type?.schema?.nodes || {};
    return Boolean(node && node.type && [
        panel,
        expand,
        layoutColumn
    ].includes(node.type));
};
const $ae5d3b5b1a5104d6$export$b0ac99e4524eec5a = (pos)=>{
    const { bulletList: bulletList, orderedList: orderedList } = pos.doc.type.schema.nodes;
    let currentDepth = pos.depth;
    let topLevelList;
    while(currentDepth > 0){
        const node = pos.node(currentDepth);
        if ([
            bulletList,
            orderedList
        ].includes(node.type)) topLevelList = {
            node: node,
            pos: pos.before(currentDepth)
        };
        currentDepth--;
    }
    return topLevelList;
};

});



parcelRegister("fBvx8", function(module, exports) {

$parcel$export(module.exports, "default", () => $62fec714ebfb177c$export$2e2bcd8739ae039);

var $6Exgk = parcelRequire("6Exgk");

var $6BNUN = parcelRequire("6BNUN");

var $dEkUJ = parcelRequire("dEkUJ");

var $x7sgX = parcelRequire("x7sgX");

var $4emAy = parcelRequire("4emAy");

var $4sLrM = parcelRequire("4sLrM");
function $62fec714ebfb177c$export$2e2bcd8739ae039() {
    const map = {};
    (0, $6Exgk.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $6Exgk.insertNewLine).common, (state, dispatch, view)=>{
        const isInGapCursor = state.selection instanceof (0, $6BNUN.GapCursorSelection);
        // Only operate in gap cursor
        if (!isInGapCursor) return false;
        return (0, $dEkUJ.createParagraphNear)(state, dispatch);
    }, map);
    (0, $6Exgk.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $6Exgk.moveLeft).common, (state, dispatch, view)=>{
        const endOfTextblock = view ? view.endOfTextblock.bind(view) : undefined;
        return (0, $4emAy.arrow)((0, $4sLrM.Direction).LEFT, endOfTextblock)(state, dispatch, view);
    }, map);
    (0, $6Exgk.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $6Exgk.moveRight).common, (state, dispatch, view)=>{
        const endOfTextblock = view ? view.endOfTextblock.bind(view) : undefined;
        return (0, $4emAy.arrow)((0, $4sLrM.Direction).RIGHT, endOfTextblock)(state, dispatch);
    }, map);
    (0, $6Exgk.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $6Exgk.moveUp).common, (state, dispatch, view)=>{
        const endOfTextblock = view ? view.endOfTextblock.bind(view) : undefined;
        return (0, $4emAy.arrow)((0, $4sLrM.Direction).UP, endOfTextblock)(state, dispatch);
    }, map);
    (0, $6Exgk.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $6Exgk.moveDown).common, (state, dispatch, view)=>{
        const endOfTextblock = view ? view.endOfTextblock.bind(view) : undefined;
        return (0, $4emAy.arrow)((0, $4sLrM.Direction).DOWN, endOfTextblock)(state, dispatch);
    }, map);
    // default PM's Backspace doesn't handle removing block nodes when cursor is after it
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $6Exgk.bindKeymapWithCommand)((0, $6Exgk.backspace).common, (0, $4emAy.deleteNode)((0, $4sLrM.Direction).BACKWARD), map);
    // handle Delete key (remove node after the cursor)
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $6Exgk.bindKeymapWithCommand)((0, $6Exgk.deleteKey).common, (0, $4emAy.deleteNode)((0, $4sLrM.Direction).FORWARD), map);
    return (0, $x7sgX.keymap)(map);
}

});
parcelRegister("4emAy", function(module, exports) {

$parcel$export(module.exports, "arrow", () => $235480d12f45f96e$export$f2120bbfa5450bd2);
$parcel$export(module.exports, "deleteNode", () => $235480d12f45f96e$export$b05da9e94a08038f);

var $iqjsw = parcelRequire("iqjsw");
var $6BNUN = parcelRequire("6BNUN");
var $8TSsQ = parcelRequire("8TSsQ");

var $9Ssie = parcelRequire("9Ssie");
var $bTpHi = parcelRequire("bTpHi");


var $3lIcL = parcelRequire("3lIcL");

var $BmspC = parcelRequire("BmspC");

var $9CzUQ = parcelRequire("9CzUQ");

var $4sLrM = parcelRequire("4sLrM");

var $9Vsci = parcelRequire("9Vsci");
const $235480d12f45f96e$export$1c8a4d720fa6d473 = (direction, state, $pos)=>{
    const { doc: doc, schema: schema } = state;
    switch(direction){
        case (0, $4sLrM.Direction).UP:
            if ((0, $iqjsw.atTheBeginningOfDoc)(state)) return false;
            return (0, $bTpHi.isPositionNearTableRow)($pos, schema, 'before') || (0, $9Vsci.isTextBlockNearPos)(doc, schema, $pos, -1) || (0, $9Ssie.isNodeBeforeMediaNode)($pos, state);
        case (0, $4sLrM.Direction).DOWN:
            return(// end of a paragraph
            (0, $iqjsw.atTheEndOfDoc)(state) || (0, $9Vsci.isTextBlockNearPos)(doc, schema, $pos, 1) || (0, $bTpHi.isPositionNearTableRow)($pos, schema, 'after') || $pos.nodeBefore?.type.name === 'text' && !$pos.nodeAfter);
        default:
            return false;
    }
};
// These cases should be handled using the handleMediaGapCursor function
function $235480d12f45f96e$var$shouldHandleMediaGapCursor(dir, state) {
    const { selection: selection } = state;
    const upArrowFromGapCursorIntoMedia = selection instanceof (0, $6BNUN.GapCursorSelection) && dir === (0, $4sLrM.Direction).UP && selection.$from.nodeBefore && (0, $9Ssie.isMediaNode)(selection.$from.nodeBefore);
    const downArrowFromGapCursorIntoMediaGroup = selection instanceof (0, $6BNUN.GapCursorSelection) && dir === (0, $4sLrM.Direction).DOWN && selection.$from.nodeAfter?.type.name === 'mediaGroup';
    return upArrowFromGapCursorIntoMedia || downArrowFromGapCursorIntoMediaGroup;
}
// Handle media gap cursor for up/down arrow into media nodes
// Should check this case by using shouldHandleMediaGapCursor first
function $235480d12f45f96e$var$handleMediaGapCursor(dir, state) {
    const { selection: selection, tr: tr } = state;
    const $pos = (0, $4sLrM.isBackward)(dir) ? selection.$from : selection.$to;
    if (dir === (0, $4sLrM.Direction).UP && selection.$from.nodeBefore && (0, $9Ssie.isMediaNode)(selection.$from.nodeBefore)) {
        const nodeBeforePos = (0, $BmspC.findPositionOfNodeBefore)(tr.selection);
        if (nodeBeforePos && selection.side === 'right' && tr.doc.nodeAt(nodeBeforePos)?.type.name === 'mediaSingle') tr.setSelection(new (0, $3lIcL.NodeSelection)(tr.doc.resolve(nodeBeforePos))).scrollIntoView();
        else if (nodeBeforePos || nodeBeforePos === 0) tr.setSelection(new (0, $6BNUN.GapCursorSelection)(tr.doc.resolve(nodeBeforePos), (0, $6BNUN.Side).LEFT)).scrollIntoView();
    }
    if (dir === (0, $4sLrM.Direction).DOWN && selection.$from.nodeAfter) {
        const nodeAfterPos = selection.side === 'right' ? $pos.pos : $pos.pos + selection.$from.nodeAfter.nodeSize;
        if (nodeAfterPos) tr.setSelection(new (0, $6BNUN.GapCursorSelection)(tr.doc.resolve(nodeAfterPos), (0, $6BNUN.Side).LEFT)).scrollIntoView();
    }
    return tr;
}
const $235480d12f45f96e$export$f2120bbfa5450bd2 = (dir, endOfTextblock)=>(state, dispatch, view)=>{
        const { doc: doc, selection: selection, tr: tr } = state;
        let $pos = (0, $4sLrM.isBackward)(dir) ? selection.$from : selection.$to;
        let mustMove = selection.empty;
        // start from text selection
        if (selection instanceof (0, $3lIcL.TextSelection)) {
            // if cursor is in the middle of a text node, do nothing
            if (!endOfTextblock || !endOfTextblock(dir.toString())) return false;
            // UP/DOWN jumps to the nearest texblock skipping gapcursor whenever possible
            if ($235480d12f45f96e$export$1c8a4d720fa6d473(dir, state, $pos)) return false;
            // otherwise resolve previous/next position
            $pos = doc.resolve((0, $4sLrM.isBackward)(dir) ? $pos.before() : $pos.after());
            mustMove = false;
        }
        if (selection instanceof (0, $3lIcL.NodeSelection)) {
            if (selection.node.isInline) return false;
            if (dir === (0, $4sLrM.Direction).UP && !(0, $iqjsw.atTheBeginningOfDoc)(state) && !(0, $9Ssie.isNodeBeforeMediaNode)($pos, state) || dir === (0, $4sLrM.Direction).DOWN) // We dont add gap cursor on node selections going up and down
            // Except we do if we're going up for a block node which is the
            // first node in the document OR the node before is a media node
            return false;
        }
        // Handle media gap cursor for up/down arrow into media nodes
        if ($235480d12f45f96e$var$shouldHandleMediaGapCursor(dir, state)) {
            const updatedTr = $235480d12f45f96e$var$handleMediaGapCursor(dir, state);
            if (dispatch) dispatch(updatedTr);
            return true;
        }
        // when jumping between block nodes at the same depth, we need to reverse cursor without changing ProseMirror position
        if (selection instanceof (0, $6BNUN.GapCursorSelection) && // next node allow gap cursor position
        (0, $8TSsQ.isValidTargetNode)((0, $4sLrM.isBackward)(dir) ? $pos.nodeBefore : $pos.nodeAfter) && // gap cursor changes block node
        ((0, $4sLrM.isBackward)(dir) && selection.side === (0, $6BNUN.Side).LEFT || (0, $4sLrM.isForward)(dir) && selection.side === (0, $6BNUN.Side).RIGHT)) {
            // reverse cursor position
            if (dispatch) dispatch(tr.setSelection(new (0, $6BNUN.GapCursorSelection)($pos, selection.side === (0, $6BNUN.Side).RIGHT ? (0, $6BNUN.Side).LEFT : (0, $6BNUN.Side).RIGHT)).scrollIntoView());
            return true;
        }
        if (view) {
            const domAtPos = view.domAtPos.bind(view);
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            const target = (0, $BmspC.findDomRefAtPos)($pos.pos, domAtPos);
            if (target && target.textContent === (0, $f9e41f230eb38f84$export$15a09f5ef055bcfa)) return false;
        }
        const nextSelection = (0, $6BNUN.GapCursorSelection).findFrom($pos, (0, $4sLrM.isBackward)(dir) ? -1 : 1, mustMove);
        if (!nextSelection) return false;
        if (!(0, $8TSsQ.isValidTargetNode)((0, $4sLrM.isForward)(dir) ? nextSelection.$from.nodeBefore : nextSelection.$from.nodeAfter)) {
            // reverse cursor position
            if (dispatch) dispatch(tr.setSelection(new (0, $6BNUN.GapCursorSelection)(nextSelection.$from, (0, $4sLrM.isForward)(dir) ? (0, $6BNUN.Side).LEFT : (0, $6BNUN.Side).RIGHT)).scrollIntoView());
            return true;
        }
        if (dispatch) dispatch(tr.setSelection(nextSelection).scrollIntoView());
        return true;
    };
const $235480d12f45f96e$export$b05da9e94a08038f = (dir)=>(state, dispatch)=>{
        if (state.selection instanceof (0, $6BNUN.GapCursorSelection)) {
            const { $from: $from, $anchor: $anchor } = state.selection;
            let { tr: tr } = state;
            if ((0, $4sLrM.isBackward)(dir)) {
                if (state.selection.side === 'left') {
                    tr.setSelection(new (0, $6BNUN.GapCursorSelection)($anchor, (0, $6BNUN.Side).RIGHT));
                    if (dispatch) dispatch(tr);
                    return true;
                }
                tr = (0, $BmspC.removeNodeBefore)(state.tr);
            } else if ($from.nodeAfter) tr = tr.delete($from.pos, $from.pos + $from.nodeAfter.nodeSize);
            if (dispatch) dispatch(tr.setSelection((0, $3lIcL.Selection).near(tr.doc.resolve(tr.mapping.map(state.selection.$from.pos)))).scrollIntoView());
            return true;
        }
        return false;
    };
// This function captures clicks outside of the ProseMirror contentEditable area
// see also description of "handleClick" in gap-cursor pm-plugin
const $235480d12f45f96e$var$captureCursorCoords = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
event, editorRef, posAtCoords, tr)=>{
    const rect = editorRef.getBoundingClientRect();
    // capture clicks before the first block element
    if (event.clientY < rect.top) return {
        position: 0,
        side: (0, $6BNUN.Side).LEFT
    };
    if (rect.left > 0) {
        // calculate start position of a node that is vertically at the same level
        const coords = posAtCoords({
            left: rect.left,
            top: event.clientY
        });
        if (coords && coords.inside > -1) {
            const $from = tr.doc.resolve(coords.inside);
            const start = $from.before(1);
            const side = event.clientX < rect.left ? (0, $6BNUN.Side).LEFT : (0, $6BNUN.Side).RIGHT;
            let position;
            if (side === (0, $6BNUN.Side).LEFT) position = start;
            else {
                const node = tr.doc.nodeAt(start);
                if (node) position = start + node.nodeSize;
            }
            return {
                position: position,
                side: side
            };
        }
    }
    return null;
};
const $235480d12f45f96e$export$1b305efb24649ca5 = (tr, // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
event, editorRef, posAtCoords, editorFocused)=>{
    const cursorCoords = $235480d12f45f96e$var$captureCursorCoords(event, editorRef, posAtCoords, tr);
    if (!cursorCoords) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const $pos = cursorCoords.position !== undefined ? tr.doc.resolve(cursorCoords.position) : null;
    if ($pos === null) return;
    const isGapCursorAllowed = cursorCoords.side === (0, $6BNUN.Side).LEFT ? (0, $8TSsQ.isValidTargetNode)($pos.nodeAfter) : (0, $8TSsQ.isValidTargetNode)($pos.nodeBefore);
    if (isGapCursorAllowed && (0, $6BNUN.GapCursorSelection).valid($pos)) {
        // this forces PM to re-render the decoration node if we change the side of the gap cursor, it doesn't do it by default
        if (tr.selection instanceof (0, $6BNUN.GapCursorSelection)) tr.setSelection((0, $3lIcL.Selection).near($pos));
        else tr.setSelection(new (0, $6BNUN.GapCursorSelection)($pos, cursorCoords.side));
    } else if (editorFocused === false) {
        const selectionTemp = (0, $3lIcL.Selection).findFrom($pos, cursorCoords.side === (0, $6BNUN.Side).LEFT ? 1 : -1, true);
        if (selectionTemp) tr.setSelection(selectionTemp);
    }
};
const $235480d12f45f96e$export$ddeed8e54d88a7b0 = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
event, editorRef, posAtCoords, editorFocused)=>(state, dispatch)=>{
        const { tr: tr } = state;
        $235480d12f45f96e$export$1b305efb24649ca5(tr, event, editorRef, posAtCoords, editorFocused);
        if (tr.selectionSet && dispatch) {
            dispatch(tr);
            return true;
        }
        return false;
    };
const $235480d12f45f96e$export$a3664bef63da9388 = (state)=>{
    return Boolean((0, $9CzUQ.gapCursorPluginKey).get(state));
};

});
parcelRegister("9CzUQ", function(module, exports) {

$parcel$export(module.exports, "gapCursorPluginKey", () => $f6523cfbe63b752c$export$21af267ac39e2110);

var $3lIcL = parcelRequire("3lIcL");
const $f6523cfbe63b752c$export$21af267ac39e2110 = new (0, $3lIcL.PluginKey)('gapCursorPlugin');

});

parcelRegister("4sLrM", function(module, exports) {

$parcel$export(module.exports, "Direction", () => $b68d15876886eb46$export$cacd6541cfeeb6c1);
$parcel$export(module.exports, "isBackward", () => $b68d15876886eb46$export$4d894a9a195acd59);
$parcel$export(module.exports, "isForward", () => $b68d15876886eb46$export$9439bc4ba99faca1);
var $b68d15876886eb46$export$cacd6541cfeeb6c1 = /*#__PURE__*/ function(Direction) {
    Direction["UP"] = "up";
    Direction["RIGHT"] = "right";
    Direction["DOWN"] = "down";
    Direction["LEFT"] = "left";
    Direction["BACKWARD"] = "backward";
    Direction["FORWARD"] = "forward";
    return Direction;
}({});
function $b68d15876886eb46$export$4d894a9a195acd59(dir) {
    return [
        "up",
        "left",
        "backward"
    ].indexOf(dir) !== -1;
}
function $b68d15876886eb46$export$9439bc4ba99faca1(dir) {
    return [
        "right",
        "down",
        "forward"
    ].indexOf(dir) !== -1;
}

});

parcelRegister("9Vsci", function(module, exports) {

$parcel$export(module.exports, "isLeftCursor", () => $b51e3bb87b604d5e$export$2b745dec73894c8a);
$parcel$export(module.exports, "isTextBlockNearPos", () => $b51e3bb87b604d5e$export$84353379d6171bb9);
$parcel$export(module.exports, "getLayoutModeFromTargetNode", () => $b51e3bb87b604d5e$export$698eab35981fecbc);
$parcel$export(module.exports, "isIgnoredClick", () => $b51e3bb87b604d5e$export$e5da7366668fb130);
$parcel$export(module.exports, "getComputedStyleForLayoutMode", () => $b51e3bb87b604d5e$export$b5b7287d8577df27);

var $1I3aa = parcelRequire("1I3aa");

var $6BNUN = parcelRequire("6BNUN");

var $cjLtO = parcelRequire("cjLtO");
var $iCwuj = parcelRequire("iCwuj");

var $92xoS = parcelRequire("92xoS");
const $b51e3bb87b604d5e$export$2b745dec73894c8a = (side)=>side === (0, $6BNUN.Side).LEFT;
function $b51e3bb87b604d5e$export$ed28bfac31d0c2ef(doc, $pos, schema, dir = -1) {
    let $currentPos = $pos;
    let currentNode = null;
    const { mediaSingle: mediaSingle, media: media, mediaGroup: mediaGroup } = schema.nodes;
    do {
        $currentPos = doc.resolve(dir === -1 ? $currentPos.before() : $currentPos.after());
        if (!$currentPos) return null;
        currentNode = (dir === -1 ? $currentPos.nodeBefore : $currentPos.nodeAfter) || $currentPos.parent;
        if (!currentNode || currentNode.type === schema.nodes.doc) return null;
        if (currentNode.type === mediaSingle || currentNode.type === media || currentNode.type === mediaGroup) return currentNode;
    }while ($currentPos.depth > 0);
    return null;
}
const $b51e3bb87b604d5e$export$84353379d6171bb9 = (doc, schema, $pos, dir)=>{
    let $currentPos = $pos;
    let currentNode = dir === -1 ? $currentPos.nodeBefore : $currentPos.nodeAfter;
    // If next node is a text or a text block bail out early.
    if (currentNode && (currentNode.isTextblock || currentNode.isText)) return true;
    while($currentPos.depth > 0){
        $currentPos = doc.resolve(dir === -1 ? $currentPos.before() : $currentPos.after());
        if (!$currentPos) return false;
        currentNode = (dir === -1 ? $currentPos.nodeBefore : $currentPos.nodeAfter) || $currentPos.parent;
        if (!currentNode || currentNode.type === schema.nodes.doc) return false;
        if (currentNode.isTextblock) return true;
    }
    let childNode = currentNode;
    while(childNode && childNode.firstChild){
        childNode = childNode.firstChild;
        if (childNode && (childNode.isTextblock || childNode.isText)) return true;
    }
    return false;
};
function $b51e3bb87b604d5e$export$698eab35981fecbc(node) {
    let layout;
    if (node.attrs.layout) layout = node.attrs.layout;
    if (node.marks && node.marks.length) layout = (node.marks.find((mark)=>mark.type.name === 'breakout') || {
        attrs: {
            mode: ''
        }
    }).attrs.mode;
    if (node.type.name === 'table' && node.attrs.width) layout = 'fixed-width';
    if ([
        'wide',
        'full-width',
        'fixed-width'
    ].indexOf(layout) === -1) return '';
    return layout;
}
const $b51e3bb87b604d5e$export$e5da7366668fb130 = (elem)=>{
    if (elem?.nodeName === 'BUTTON' || elem?.closest('button')) return true;
    // check if we're clicking an image caption placeholder
    if (elem?.closest(`[data-id="${(0, $1I3aa.CAPTION_PLACEHOLDER_ID)}"]`)) return true;
    // check if target node has a parent table node
    let tableWrap;
    let node = elem;
    while(node){
        if (node.className && (node.getAttribute('class') || '').indexOf((0, $cjLtO.TableSharedCssClassName).TABLE_CONTAINER) > -1) {
            tableWrap = node;
            break;
        }
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        node = node.parentNode;
    }
    if (tableWrap) {
        const rowControls = tableWrap.querySelector(`.${(0, $cjLtO.TableSharedCssClassName).TABLE_ROW_CONTROLS_WRAPPER}`);
        const isColumnControlsDecoration = elem && elem.classList && elem.classList.contains((0, $cjLtO.TableSharedCssClassName).TABLE_COLUMN_CONTROLS_DECORATIONS);
        return rowControls && rowControls.contains(elem) || isColumnControlsDecoration;
    }
    // Check if unsupported node selection
    // (without this, selection requires double clicking in FF due to posAtCoords differences)
    if (elem?.closest(`.${(0, $iCwuj.UnsupportedSharedCssClassName).BLOCK_CONTAINER}`)) return true;
    return false;
};
const $b51e3bb87b604d5e$export$b5b7287d8577df27 = (dom, node, style)=>{
    if (node && node.type.name === 'table') {
        const tableContainer = dom.querySelector('.pm-table-container');
        if (tableContainer) return window.getComputedStyle(tableContainer);
    }
    if ((0, $92xoS.editorExperiment)('advanced_layouts', true) && node && node.type.name === 'layoutSection') {
        const layoutSectionContainer = dom.querySelector('.layout-section-container');
        if (layoutSectionContainer) return window.getComputedStyle(layoutSectionContainer);
    }
    return style;
};

});



parcelRegister("1K5XD", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbce9f67f93c8a64$export$2e2bcd8739ae039);

var $i8KtF = parcelRequire("i8KtF");

var $6BNUN = parcelRequire("6BNUN");
var $3N6pN = parcelRequire("3N6pN");
var $gEqKI = parcelRequire("gEqKI");

var $3lIcL = parcelRequire("3lIcL");

var $BmspC = parcelRequire("BmspC");

var $b7EWj = parcelRequire("b7EWj");

var $cwzAY = parcelRequire("cwzAY");

var $9CzUQ = parcelRequire("9CzUQ");

var $4emAy = parcelRequire("4emAy");

var $4sLrM = parcelRequire("4sLrM");

var $9Vsci = parcelRequire("9Vsci");

var $j0wSp = parcelRequire("j0wSp");
const $bbce9f67f93c8a64$var$plugin = new (0, $i8KtF.SafePlugin)({
    key: (0, $9CzUQ.gapCursorPluginKey),
    state: {
        init: ()=>({
                selectionIsGapCursor: false,
                displayGapCursor: true
            }),
        apply: (tr, pluginState, _oldState, newState)=>{
            const meta = tr.getMeta((0, $9CzUQ.gapCursorPluginKey));
            const selectionIsGapCursor = newState.selection instanceof (0, $6BNUN.GapCursorSelection);
            return {
                selectionIsGapCursor: selectionIsGapCursor,
                // only attempt to hide gap cursor if selection is gap cursor
                displayGapCursor: selectionIsGapCursor ? meta?.displayGapCursor ?? pluginState.displayGapCursor : true
            };
        }
    },
    view: (view)=>{
        /**
		 * If the selection is at the beginning of a document and is a NodeSelection,
		 * convert to a GapCursor selection. This is to stop users accidentally replacing
		 * the first node of a document by accident.
		 */ if (view.state.selection.anchor === 0 && view.state.selection instanceof (0, $3lIcL.NodeSelection)) // This is required otherwise the dispatch doesn't trigger in the correct place
        window.requestAnimationFrame(()=>{
            view.dispatch(view.state.tr.setSelection(new (0, $6BNUN.GapCursorSelection)(view.state.doc.resolve(0), (0, $6BNUN.Side).LEFT)));
        });
        return {
            update (view) {
                const { selectionIsGapCursor: selectionIsGapCursor } = (0, $9CzUQ.gapCursorPluginKey).getState(view.state);
                /**
				 * Starting with prosemirror-view 1.19.4, cursor wrapper that previously was hiding cursor doesn't exist:
				 * https://github.com/ProseMirror/prosemirror-view/commit/4a56bc7b7e61e96ef879d1dae1014ede0fc09e43
				 *
				 * Because it was causing issues with RTL: https://github.com/ProseMirror/prosemirror/issues/948
				 *
				 * This is the work around which uses `caret-color: transparent` in order to hide regular caret,
				 * when gap cursor is visible.
				 *
				 * Browser support is pretty good: https://caniuse.com/#feat=css-caret-color
				 */ view.dom.classList.toggle((0, $3N6pN.hideCaretModifier), selectionIsGapCursor);
            }
        };
    },
    props: {
        decorations: (editorState)=>{
            const { doc: doc, selection: selection } = editorState;
            const { displayGapCursor: displayGapCursor } = (0, $9CzUQ.gapCursorPluginKey).getState(editorState);
            if (selection instanceof (0, $6BNUN.GapCursorSelection) && displayGapCursor) {
                const { $from: $from, side: side } = selection;
                // render decoration DOM node always to the left of the target node even if selection points to the right
                // otherwise positioning of the right gap cursor is a nightmare when the target node has a nodeView with vertical margins
                let position = selection.head;
                const isRightCursor = side === (0, $6BNUN.Side).RIGHT;
                if (isRightCursor && $from.nodeBefore) {
                    const nodeBeforeStart = (0, $BmspC.findPositionOfNodeBefore)(selection);
                    if (typeof nodeBeforeStart === 'number') position = nodeBeforeStart;
                }
                const node = isRightCursor ? $from.nodeBefore : $from.nodeAfter;
                const layoutMode = node && (0, $9Vsci.getLayoutModeFromTargetNode)(node);
                return (0, $b7EWj.DecorationSet).create(doc, [
                    (0, $b7EWj.Decoration).widget(position, (0, $j0wSp.toDOM), {
                        key: `${(0, $6BNUN.JSON_ID)}-${side}-${layoutMode}`,
                        side: layoutMode ? -1 : 0
                    })
                ]);
            }
            return null;
        },
        // render gap cursor only when its valid
        createSelectionBetween (view, $anchor, $head) {
            if (view && view.state && view.state.selection instanceof (0, $cwzAY.CellSelection)) // Do not show GapCursor when there is a CellSection happening
            return null;
            if ($anchor.pos === $head.pos && (0, $6BNUN.GapCursorSelection).valid($head)) return new (0, $6BNUN.GapCursorSelection)($head);
            return null;
        },
        handleClick (view, nodePos, event) {
            const posAtCoords = view.posAtCoords({
                left: event.clientX,
                top: event.clientY
            });
            if (!posAtCoords || (0, $9Vsci.isIgnoredClick)(event.target instanceof HTMLElement ? event.target : null)) return false;
            const isInsideTheTarget = posAtCoords.pos === posAtCoords.inside;
            if (isInsideTheTarget) return false;
            const leftSideOffsetX = 20;
            const side = event.offsetX > leftSideOffsetX ? (0, $6BNUN.Side).RIGHT : (0, $6BNUN.Side).LEFT;
            const $pos = view.state.doc.resolve(nodePos);
            // In the new prosemirror-view posAtCoords  is not returning a precise value for our media nodes
            if ($pos.parent?.type.name === 'mediaSingle') {
                const $insidePos = view.state.doc.resolve(Math.max(posAtCoords.inside, 0));
                // We don't have GapCursors problems when the node target is inside the root level
                if ($insidePos.depth <= 1) return false;
                const mediaGapCursor = !$pos.nodeBefore ? $pos.before() : $pos.after();
                return (0, $gEqKI.setGapCursorAtPos)(mediaGapCursor, side)(view.state, view.dispatch);
            }
            const docSize = view.state.doc.content.size;
            const nodeInside = posAtCoords.inside < 0 || posAtCoords.inside > docSize ? null : view.state.doc.nodeAt(posAtCoords.inside);
            if (nodeInside?.isAtom) return false;
            return (0, $gEqKI.setGapCursorAtPos)(nodePos, side)(view.state, view.dispatch);
        },
        handleDOMEvents: {
            /**
			 * Android composition events aren't handled well by Prosemirror
			 * We've added a couple of beforeinput hooks to help PM out when trying to delete
			 * certain nodes. We can remove these when PM has better composition support.
			 * @see https://github.com/ProseMirror/prosemirror/issues/543
			 */ // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            beforeinput: (view, event)=>{
                if (event.inputType === 'deleteContentBackward' && view.state.selection instanceof (0, $6BNUN.GapCursorSelection)) {
                    event.preventDefault();
                    return (0, $4emAy.deleteNode)((0, $4sLrM.Direction).BACKWARD)(view.state, view.dispatch);
                }
                return false;
            }
        }
    }
});
var $bbce9f67f93c8a64$export$2e2bcd8739ae039 = $bbce9f67f93c8a64$var$plugin;

});
parcelRegister("j0wSp", function(module, exports) {

$parcel$export(module.exports, "toDOM", () => $c649040d44680000$export$289411c5a7970646);

var $6BNUN = parcelRequire("6BNUN");

var $eGOwo = parcelRequire("eGOwo");

var $9Vsci = parcelRequire("9Vsci");
/**
 * We have a couple of nodes that require us to compute style
 * on different elements, ideally all nodes should be able to
 * compute the appropriate styles based on their wrapper.
 */ const $c649040d44680000$var$nestedCases = {
    'tableView-content-wrap': 'table',
    'mediaSingleView-content-wrap': '.rich-media-item',
    'bodiedExtensionView-content-wrap': '.extension-container',
    'multiBodiedExtensionView-content-wrap': '.multiBodiedExtension--container',
    'embedCardView-content-wrap': '.rich-media-item',
    'datasourceView-content-wrap': '.datasourceView-content-inner-wrap'
};
const $c649040d44680000$var$computeNestedStyle = (dom)=>{
    const foundKey = Object.keys($c649040d44680000$var$nestedCases).find((className)=>dom.classList.contains(className));
    const nestedSelector = foundKey && $c649040d44680000$var$nestedCases[foundKey];
    if (nestedSelector) {
        const nestedElement = dom.querySelector(nestedSelector);
        if (nestedElement) return window.getComputedStyle(nestedElement);
    }
};
const $c649040d44680000$var$measureHeight = (style)=>{
    return $c649040d44680000$var$measureValue(style, [
        'height',
        'padding-top',
        'padding-bottom',
        'border-top-width',
        'border-bottom-width'
    ]);
};
const $c649040d44680000$var$measureWidth = (style)=>{
    return $c649040d44680000$var$measureValue(style, [
        'width',
        'padding-left',
        'padding-right',
        'border-left-width',
        'border-right-width'
    ]);
};
const $c649040d44680000$var$measureValue = (style, measureValues)=>{
    const [base, ...contentBoxValues] = measureValues;
    const measures = [
        style.getPropertyValue(base)
    ];
    const boxSizing = style.getPropertyValue('box-sizing');
    if (boxSizing === 'content-box') contentBoxValues.forEach((value)=>{
        measures.push(style.getPropertyValue(value));
    });
    let result = 0;
    for(let i = 0; i < measures.length; i++)result += parseFloat(measures[i]);
    return result;
};
const $c649040d44680000$var$mutateElementStyle = (element, style, side)=>{
    element.style.transform = style.getPropertyValue('transform');
    if ((0, $9Vsci.isLeftCursor)(side)) {
        element.style.width = style.getPropertyValue('width');
        element.style.marginLeft = style.getPropertyValue('margin-left');
    } else {
        const marginRight = parseFloat(style.getPropertyValue('margin-right'));
        if (marginRight > 0) element.style.marginLeft = `-${Math.abs(marginRight)}px`;
        else element.style.paddingRight = `${Math.abs(marginRight)}px`;
    }
};
const $c649040d44680000$export$289411c5a7970646 = (view, getPos)=>{
    const selection = view.state.selection;
    const { $from: $from, side: side } = selection;
    const isRightCursor = side === (0, $6BNUN.Side).RIGHT;
    const node = isRightCursor ? $from.nodeBefore : $from.nodeAfter;
    const nodeStart = getPos();
    // @ts-ignore - [unblock prosemirror bump] nodeStart can be undefined
    const dom = view.nodeDOM(nodeStart);
    const element = document.createElement('span');
    element.className = `ProseMirror-gapcursor ${isRightCursor ? '-right' : '-left'}`;
    element.appendChild(document.createElement('span'));
    if (dom instanceof HTMLElement && element.firstChild) {
        const style = $c649040d44680000$var$computeNestedStyle(dom) || window.getComputedStyle(dom);
        const gapCursor = element.firstChild;
        gapCursor.style.height = `${$c649040d44680000$var$measureHeight(style)}px`;
        const layoutMode = node && (0, $9Vsci.getLayoutModeFromTargetNode)(node);
        if (nodeStart !== 0 || layoutMode || node?.type.name === 'table') gapCursor.style.marginTop = style.getPropertyValue('margin-top');
        // Tables nested inside other elements such as layouts, expands and other tables do not have fixed width
        const isNestedTable = (0, $eGOwo.fg)('platform_editor_nested_tables_gap_cursor') ? node?.type.name === 'table' && selection.$to.depth > 0 : false;
        if (layoutMode && !isNestedTable) {
            gapCursor.setAttribute('layout', layoutMode);
            const breakoutModeStyle = (0, $9Vsci.getComputedStyleForLayoutMode)(dom, node, style);
            gapCursor.style.width = `${$c649040d44680000$var$measureWidth(breakoutModeStyle)}px`;
        } else $c649040d44680000$var$mutateElementStyle(gapCursor, style, selection.side);
    }
    return element;
};

});


parcelRegister("2UiR6", function(module, exports) {

$parcel$export(module.exports, "default", () => $7065f6b8ecd3573a$export$2e2bcd8739ae039);

var $6Exgk = parcelRequire("6Exgk");

var $x7sgX = parcelRequire("x7sgX");

var $7l5OF = parcelRequire("7l5OF");
function $7065f6b8ecd3573a$var$keymapPlugin() {
    const list = {};
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $6Exgk.bindKeymapWithCommand)((0, $6Exgk.moveRight).common, (0, $7l5OF.arrowRight), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $6Exgk.bindKeymapWithCommand)((0, $6Exgk.moveLeft).common, (0, $7l5OF.arrowLeft), list);
    return (0, $x7sgX.keymap)(list);
}
var $7065f6b8ecd3573a$export$2e2bcd8739ae039 = $7065f6b8ecd3573a$var$keymapPlugin;

});

parcelRegister("jBulN", function(module, exports) {

$parcel$export(module.exports, "createMarkBoundaryCursorPlugin", () => $6f12a32154f3e5ac$export$d3a8cfe12ba42d22);

var $i8KtF = parcelRequire("i8KtF");

var $b7EWj = parcelRequire("b7EWj");

var $bk0UA = parcelRequire("bk0UA");

var $2Ekgz = parcelRequire("2Ekgz");

var $2kYv3 = parcelRequire("2kYv3");
const $6f12a32154f3e5ac$export$d3a8cfe12ba42d22 = ()=>{
    return new (0, $i8KtF.SafePlugin)({
        key: (0, $bk0UA.markBoundaryCursorPluginKey),
        state: {
            init: ()=>({
                    decorations: (0, $b7EWj.DecorationSet).empty
                }),
            apply (tr, currentState) {
                const { selection: selection, storedMarks: storedMarks, doc: doc, selectionSet: selectionSet, storedMarksSet: storedMarksSet, docChanged: docChanged } = tr;
                if (!selectionSet && !storedMarksSet && !docChanged) return currentState;
                const side = (0, $2kYv3.getActiveMarksSide)({
                    selection: selection,
                    storedMarks: storedMarks
                });
                if (!side) return {
                    decorations: (0, $b7EWj.DecorationSet).empty
                };
                return {
                    decorations: (0, $b7EWj.DecorationSet).create(doc, [
                        (0, $2Ekgz.createMarkBoundaryCursorDecoration)(selection.head, side)
                    ])
                };
            }
        },
        props: {
            decorations: (state)=>{
                return (0, $bk0UA.markBoundaryCursorPluginKey).getState(state)?.decorations;
            }
        }
    });
};

});
parcelRegister("bk0UA", function(module, exports) {

$parcel$export(module.exports, "markBoundaryCursorPluginKey", () => $4fa134998f407481$export$220fecd6a5c51ffb);

var $3lIcL = parcelRequire("3lIcL");
const $4fa134998f407481$export$220fecd6a5c51ffb = new (0, $3lIcL.PluginKey)('markBoundaryCursorPlugin');

});

parcelRegister("2Ekgz", function(module, exports) {

$parcel$export(module.exports, "createMarkBoundaryCursorDecoration", () => $a55137e1533a042c$export$499e8e2917534a4d);

var $b7EWj = parcelRequire("b7EWj");
const $a55137e1533a042c$var$containerStyle = `
	position: relative;
`;
const $a55137e1533a042c$var$caretStyle = `
	position: absolute;
	height: 100%;
	width: 1px;
	left: -0.5px;
	bottom: 0;
	background-color: ${"var(--ds-text, #172B4D)"};
`;
const $a55137e1533a042c$var$toDOM = ()=>{
    const container = document.createElement('span');
    container.className = 'ProseMirror-mark-boundary-cursor';
    container.setAttribute('style', $a55137e1533a042c$var$containerStyle);
    const caret = document.createElement('div');
    caret.setAttribute('style', $a55137e1533a042c$var$caretStyle);
    caret.animate?.([
        {
            opacity: 1
        },
        {
            opacity: 1,
            offset: 0.5
        },
        {
            opacity: 0,
            offset: 0.5
        },
        {
            opacity: 0
        }
    ], {
        duration: 1000,
        iterations: Infinity
    });
    container.appendChild(caret);
    return container;
};
const $a55137e1533a042c$export$499e8e2917534a4d = (pos, side)=>{
    return (0, $b7EWj.Decoration).widget(pos, $a55137e1533a042c$var$toDOM, {
        key: 'mark-boundary-cursor',
        side: side
    });
};

});

parcelRegister("2kYv3", function(module, exports) {

$parcel$export(module.exports, "getActiveMarksSide", () => $a77f24fbb70b061f$export$8f6a177d567e1134);

var $5Z3Rm = parcelRequire("5Z3Rm");

var $3xw6l = parcelRequire("3xw6l");

var $cPLWh = parcelRequire("cPLWh");

var $3L9rS = parcelRequire("3L9rS");
function $a77f24fbb70b061f$export$8f6a177d567e1134({ selection: selection, storedMarks: storedMarks }) {
    if (!(0, $5Z3Rm.isTextSelection)(selection) || !selection.empty) return (0, $cPLWh.MarksSide).None;
    const { nodeBefore: nodeBefore, nodeAfter: nodeAfter } = selection.$head;
    const leftMarks = nodeBefore?.marks ?? [];
    const rightMarks = nodeAfter?.marks ?? [];
    if ((0, $3xw6l.Mark).sameSet(leftMarks, rightMarks)) return (0, $cPLWh.MarksSide).None;
    return (0, $3L9rS.getInlineCodeCursorSide)({
        leftMarks: leftMarks,
        rightMarks: rightMarks,
        storedMarks: storedMarks
    });
}

});
parcelRegister("cPLWh", function(module, exports) {

$parcel$export(module.exports, "MarksSide", () => $7f20b3e6410570a4$export$6705e1762430d43f);
var $7f20b3e6410570a4$export$6705e1762430d43f = /*#__PURE__*/ function(MarksSide) {
    MarksSide[MarksSide["None"] = 0] = "None";
    MarksSide[MarksSide["Left"] = -1] = "Left";
    MarksSide[MarksSide["Right"] = 1] = "Right";
    return MarksSide;
}({});

});

parcelRegister("3L9rS", function(module, exports) {

$parcel$export(module.exports, "getInlineCodeCursorSide", () => $c21df65f68a68cf1$export$325621c34246ee7d);

var $cPLWh = parcelRequire("cPLWh");
function $c21df65f68a68cf1$export$325621c34246ee7d({ leftMarks: leftMarks, rightMarks: rightMarks, storedMarks: storedMarks }) {
    const isInlineCodeToLeft = leftMarks.some((mark)=>mark.type.name === 'code');
    const isInlineCodeToRight = rightMarks.some((mark)=>mark.type.name === 'code');
    const isInlineCodeBeingStored = !!storedMarks && storedMarks?.some((mark)=>mark.type.name === 'code');
    const isStoredMarksBeingCleared = !!storedMarks && storedMarks.length === 0;
    // This condition covers two scenarios:
    // a) When the cursor is on the left side of the inline code, and is expected to be
    // positioned within the inline code after pressing arrow right
    // b) When the cursor is on the right side of the inline code, and is expected to be
    // positioned outside of the inline code after pressing arrow right
    // in both of these cases the cursor needs to be corrected to be positioned inline
    // with the node to the right
    // NOTE: In editor-plugin-text-formatting there is logic on left/right key press
    // which dispatches a transaction to update the stored marks
    if (isInlineCodeToRight && isInlineCodeBeingStored || isInlineCodeToLeft && isStoredMarksBeingCleared) return (0, $cPLWh.MarksSide).Right;
    return (0, $cPLWh.MarksSide).None;
}

});



parcelRegister("5xOwf", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $28d0b3ebfa39740a$export$ae829ec7b2625219);

var $i8KtF = parcelRequire("i8KtF");

var $3lIcL = parcelRequire("3lIcL");

var $b7EWj = parcelRequire("b7EWj");

var $cbSL1 = parcelRequire("cbSL1");

var $92xoS = parcelRequire("92xoS");

var $eTc0n = parcelRequire("eTc0n");

var $jCgC5 = parcelRequire("jCgC5");

var $fBGyi = parcelRequire("fBGyi");

var $b7grw = parcelRequire("b7grw");

var $cZanI = parcelRequire("cZanI");

var $7bAHr = parcelRequire("7bAHr");

var $hFP0U = parcelRequire("hFP0U");
const $28d0b3ebfa39740a$export$53ac33307b5acee9 = (state)=>({
        decorationSet: (0, $hFP0U.getDecorations)(state.tr),
        selection: state.selection
    });
const $28d0b3ebfa39740a$export$ae829ec7b2625219 = (api, dispatch, dispatchAnalyticsEvent, options = {})=>{
    return new (0, $i8KtF.SafePlugin)({
        key: (0, $eTc0n.selectionPluginKey),
        state: (0, $7bAHr.createPluginState)(dispatch, $28d0b3ebfa39740a$export$53ac33307b5acee9),
        appendTransaction (transactions, oldEditorState, newEditorState) {
            const { tr: tr } = newEditorState;
            let manualSelection;
            if ((0, $92xoS.editorExperiment)('platform_editor_element_drag_and_drop_multiselect', true)) // Start at most recent transaction, look for manualSelection meta
            for(let i = transactions.length - 1; i >= 0; i--){
                manualSelection = transactions[i].getMeta((0, $eTc0n.selectionPluginKey))?.manualSelection;
                if (manualSelection) break;
            }
            if (!(0, $hFP0U.shouldRecalcDecorations)({
                oldEditorState: oldEditorState,
                newEditorState: newEditorState
            }) && !manualSelection) return;
            tr.setMeta((0, $eTc0n.selectionPluginKey), {
                type: (0, $jCgC5.SelectionActionTypes).SET_DECORATIONS,
                selection: tr.selection,
                decorationSet: (0, $hFP0U.getDecorations)(tr, manualSelection)
            });
            return tr;
        },
        filterTransaction (tr, state) {
            // Prevent single click selecting atom nodes on mobile (we want to select with long press gesture instead)
            if (options.useLongPressSelection && tr.selectionSet && tr.selection instanceof (0, $3lIcL.NodeSelection) && !tr.getMeta((0, $eTc0n.selectionPluginKey))) return false;
            // Prevent prosemirror's mutation observer overriding a node selection with a text selection
            // for exact same range - this was cause of being unable to change dates in collab:
            // https://product-fabric.atlassian.net/browse/ED-10645
            if (state.selection instanceof (0, $3lIcL.NodeSelection) && tr.selection instanceof (0, $3lIcL.TextSelection) && state.selection.from === tr.selection.from && state.selection.to === tr.selection.to) return false;
            return true;
        },
        props: {
            createSelectionBetween: (0, $fBGyi.onCreateSelectionBetween),
            decorations (state) {
                const interactionState = api?.interaction?.sharedState.currentState()?.interactionState;
                // Do not show selection decorations for live pages where the user has not
                // interacted with the page. We do not show cursor until interaction and we do not
                // want to show selections either.
                if ((options.__livePage || (0, $cbSL1.expValEquals)('platform_editor_no_cursor_on_edit_page_init', 'isEnabled', true)) && interactionState === 'hasNotHadInteraction') return (0, $b7EWj.DecorationSet).empty;
                return (0, $7bAHr.getPluginState)(state).decorationSet;
            },
            handleDOMEvents: {
                keydown: (0, $b7grw.createOnKeydown)({
                    __livePage: options.__livePage
                }),
                // Without this event, it is not possible to click and drag to select the first node in the
                // document if the node is a block with content (e.g. a panel with a paragraph inside).
                mouseout: (0, $cZanI.onMouseOut)
            }
        }
    });
};

});
parcelRegister("fBGyi", function(module, exports) {

$parcel$export(module.exports, "onCreateSelectionBetween", () => $08c8be08e078fbed$export$ba3a236bf89a370d);

var $3lIcL = parcelRequire("3lIcL");
const $08c8be08e078fbed$var$DOC_START_POS = 0;
function $08c8be08e078fbed$var$isNodeContentEmpty(maybeNode) {
    return maybeNode?.content.size === 0 || maybeNode?.textContent === '';
}
function $08c8be08e078fbed$var$findEmptySelectableParentNodePosition($pos) {
    const { doc: doc } = $pos;
    if ($pos.pos > doc.content.size) return null;
    if ($08c8be08e078fbed$var$isCurrentNodeAtomOrEmptySelectable($pos)) return $pos;
    if ($pos.nodeBefore !== null) return null;
    if ($pos.depth === 0 && $pos.pos === 0) return $pos;
    const positionLevelUp = $pos.before();
    const resolvedPositionLevelUp = doc.resolve(positionLevelUp);
    return $08c8be08e078fbed$var$findEmptySelectableParentNodePosition(resolvedPositionLevelUp);
}
const $08c8be08e078fbed$var$isCurrentNodeAtomOrEmptySelectable = ($pos)=>{
    //ED-20209: Using $resolvedJustBeforeNodePos so that $resolvedJustBeforeNodePos.nodeAfter return the node at $pos.pos even if that is an atomic node
    if ($pos.pos === $08c8be08e078fbed$var$DOC_START_POS) return false;
    const justBeforeNodePos = $pos.pos - 1;
    const $resolvedjustBeforePos = $pos.doc.resolve(justBeforeNodePos);
    const maybeNode = $resolvedjustBeforePos.nodeAfter;
    if (!maybeNode || !maybeNode.isBlock) return false;
    if (maybeNode.isAtom) return true;
    return $08c8be08e078fbed$var$isNodeContentEmpty(maybeNode) && (0, $3lIcL.NodeSelection).isSelectable(maybeNode);
};
function $08c8be08e078fbed$var$findNextSelectionPosition({ $targetHead: $targetHead, $anchor: $anchor, doc: doc }) {
    const direction = $anchor.pos < $targetHead.pos ? 'down' : 'up';
    //ED-20209: If the targetHead position is just before some node, Then return $targetHead and not select any node.
    let maybeNode = null;
    // prosemirror calls 'createSelectionBetween' for native 'drop' events, it passes $anchor
    // and $head which are based on a transformed document, but only provides the original
    // doc. Need to remap the $head pos to last element in doc to avoid RangeErrors.
    if ($targetHead.pos >= doc.nodeSize) maybeNode = doc.resolve(doc.nodeSize - 2).nodeBefore;
    else if ($targetHead.pos !== $08c8be08e078fbed$var$DOC_START_POS) {
        const justBeforeHeadPos = $targetHead.pos - 1;
        const $resolvedJustBeforeHeadPos = doc.resolve(justBeforeHeadPos);
        maybeNode = $resolvedJustBeforeHeadPos.nodeAfter;
    }
    if (maybeNode === null) {
        maybeNode = $targetHead.nodeAfter;
        if (maybeNode !== null) $targetHead = doc.resolve($targetHead.pos + 1);
        else return null;
    }
    const maybeNextPosition = $08c8be08e078fbed$var$findEmptySelectableParentNodePosition($targetHead);
    if (maybeNextPosition) {
        const justBeforeMaybeNextPos = maybeNextPosition.pos - 1;
        if (direction === 'up') return doc.resolve(Math.max(justBeforeMaybeNextPos, 0));
        else {
            const maybeNextNode = doc.resolve(justBeforeMaybeNextPos).nodeAfter;
            if (maybeNextNode) return doc.resolve(Math.min(justBeforeMaybeNextPos + maybeNextNode.nodeSize, doc.content.size));
        }
    }
    return null;
}
const $08c8be08e078fbed$export$ba3a236bf89a370d = (view, $anchor, $head)=>{
    if ($anchor.pos === $head.pos) return null;
    if ($anchor.depth === $head.depth && $anchor.sameParent($head)) return null;
    // If the head is targeting a paragraph on root, then let ProseMirror handle the text selection
    if ($head.depth === 1 && $head.parent?.type.name === 'paragraph') return null;
    // If head is at the beginning of a non-empty textblock, let ProseMirror handle the text selection
    if ($head.parent?.isTextblock && !$08c8be08e078fbed$var$isNodeContentEmpty($head.parent) && $head.parentOffset === 0) return null;
    const $nextHeadPosition = $08c8be08e078fbed$var$findNextSelectionPosition({
        $targetHead: $head,
        $anchor: $anchor,
        doc: view.state.doc
    });
    if (!$nextHeadPosition) return null;
    const forcedTextSelection = (0, $3lIcL.TextSelection).create(view.state.doc, $anchor.pos, $nextHeadPosition.pos);
    return forcedTextSelection;
};

});

parcelRegister("b7grw", function(module, exports) {

$parcel$export(module.exports, "createOnKeydown", () => $27d30eafdc20067b$export$1bff6ff05fed49a5);

var $yNZd3 = parcelRequire("yNZd3");

var $3lIcL = parcelRequire("3lIcL");

var $eGOwo = parcelRequire("eGOwo");
/*
 * The way expand was built, no browser recognize selection on it.
 * For instance, when a selection going to a "collapsed" expand
 * the browser will try to send the cursor to inside the expand content (wrong),
 * this behavior is caused because the expand content is never true hidden
 * we just set the height to 1px.
 *
 * So, we need to capture a possible selection event
 * when a collapsed expand is the next node in the common depth.
 * If that is true, we create a new TextSelection and stop the event bubble
 */ const $27d30eafdc20067b$var$isCollapsedExpand = (node, { __livePage: __livePage })=>{
    let currentExpandedState;
    if (__livePage && (0, $eGOwo.fg)('platform-editor-single-player-expand')) currentExpandedState = node ? !(0, $yNZd3.expandedState).get(node) : undefined;
    else if (__livePage) currentExpandedState = node?.attrs.__expanded;
    else currentExpandedState = !node?.attrs.__expanded;
    return Boolean(node && [
        'expand',
        'nestedExpand'
    ].includes(node.type.name) && currentExpandedState);
};
/**
 * ED-18072 - Cannot shift + arrow past bodied extension if it is not empty
 */ const $27d30eafdc20067b$var$isBodiedExtension = (node)=>{
    return Boolean(node && [
        'bodiedExtension'
    ].includes(node.type.name));
};
/**
 * ED-19861 - [Regression] keyboard selections within action items are unpredicatable
 * Table was added to the list of problematic nodes because the desired behaviour when Shift+Up from outside the
 * table is to select the table node itself, rather than the table cell content. Previously this behaviour was handled
 * in `packages/editor/editor-core/src/plugins/selection/pm-plugins/events/create-selection-between.ts` but there was
 * a bug in `create-selection-between` which after fixing the bug that code was no longer handling table selection
 * correctly, so to fix that table was added here.
 */ const $27d30eafdc20067b$var$isTable = (node)=>{
    return Boolean(node && [
        'table'
    ].includes(node.type.name));
};
const $27d30eafdc20067b$var$isProblematicNode = (node, { __livePage: __livePage })=>{
    return $27d30eafdc20067b$var$isCollapsedExpand(node, {
        __livePage: __livePage
    }) || $27d30eafdc20067b$var$isBodiedExtension(node) || $27d30eafdc20067b$var$isTable(node);
};
const $27d30eafdc20067b$var$findFixedProblematicNodePosition = (doc, $head, direction, { __livePage: __livePage })=>{
    if ($head.pos === 0 || $head.depth === 0) return null;
    if (direction === 'up') {
        const pos = $head.before();
        const $posResolved = $head.doc.resolve(pos);
        const maybeProblematicNode = $posResolved.nodeBefore;
        if (maybeProblematicNode && $27d30eafdc20067b$var$isProblematicNode(maybeProblematicNode, {
            __livePage: __livePage
        })) {
            const nodeSize = maybeProblematicNode.nodeSize;
            const nodeStartPosition = pos - nodeSize;
            // ($head.pos - 1) will correspond to (nodeStartPosition + nodeSize) when we are at the start of the text node
            const isAtEndOfProblematicNode = $head.pos - 1 === nodeStartPosition + nodeSize;
            if (isAtEndOfProblematicNode) {
                const startPosNode = Math.max(nodeStartPosition, 0);
                const $startPosNode = $head.doc.resolve(Math.min(startPosNode, $head.doc.content.size));
                return $startPosNode;
            }
        }
    }
    if (direction === 'down') {
        const pos = $head.after();
        const maybeProblematicNode = doc.nodeAt(pos);
        if (maybeProblematicNode && $27d30eafdc20067b$var$isProblematicNode(maybeProblematicNode, {
            __livePage: __livePage
        }) && $head.pos + 1 === pos) {
            const nodeSize = maybeProblematicNode.nodeSize;
            const nodePosition = pos + nodeSize;
            const startPosNode = Math.max(nodePosition, 0);
            const $startPosNode = $head.doc.resolve(Math.min(startPosNode, $head.doc.content.size));
            return $startPosNode;
        }
    }
    return null;
};
const $27d30eafdc20067b$var$isSelectionLineShortcutWhenCursorIsInsideInlineNode = (view, event)=>{
    if (!event.shiftKey || !event.metaKey) return false;
    const selection = view.state.selection;
    if (!(selection instanceof (0, $3lIcL.TextSelection))) return false;
    if (!selection.$cursor) return false;
    const isSelectingInlineNodeForward = event.key === 'ArrowRight' && Boolean(selection.$cursor.nodeAfter?.isInline);
    const isSelectingInlineNodeBackward = event.key === 'ArrowLeft' && Boolean(selection.$cursor.nodeBefore?.isInline);
    return isSelectingInlineNodeForward || isSelectingInlineNodeBackward;
};
const $27d30eafdc20067b$var$isNavigatingVerticallyWhenCursorIsInsideInlineNode = (view, event)=>{
    if (event.shiftKey || event.metaKey) return false;
    const selection = view.state?.selection;
    if (!(selection instanceof (0, $3lIcL.TextSelection))) return false;
    if (!selection.$cursor) return false;
    const isNavigatingInlineNodeDownward = event.key === 'ArrowDown' && Boolean(selection.$cursor.nodeBefore?.isInline) && Boolean(selection.$cursor.nodeAfter?.isInline);
    return isNavigatingInlineNodeDownward;
};
function $27d30eafdc20067b$export$1bff6ff05fed49a5({ __livePage: __livePage = false }) {
    function onKeydown(view, event) {
        /*
		 * This workaround is needed for some specific situations.
		 * - expand collapse
		 * - bodied extension
		 */ if (!(event instanceof KeyboardEvent)) return false;
        // Override the default behaviour to make sure that the selection always extends to
        // the start of the document and not just the first inline position.
        if (event.shiftKey && event.metaKey && event.key === 'ArrowUp') {
            const selection = (0, $3lIcL.TextSelection).create(view.state.doc, view.state.selection.$anchor.pos, 0);
            view.dispatch(view.state.tr.setSelection(selection));
            event.preventDefault();
            return true;
        }
        if ($27d30eafdc20067b$var$isSelectionLineShortcutWhenCursorIsInsideInlineNode(view, event)) return true;
        if ($27d30eafdc20067b$var$isNavigatingVerticallyWhenCursorIsInsideInlineNode(view, event)) return true;
        if (!event.shiftKey || event.ctrlKey || event.metaKey) return false;
        if (![
            'ArrowUp',
            'ArrowDown',
            'ArrowRight',
            'ArrowLeft',
            'Home',
            'End'
        ].includes(event.key)) return false;
        const { doc: doc, selection: { $head: $head, $anchor: $anchor } } = view.state;
        if (event.key === 'ArrowRight' && $head.nodeAfter || event.key === 'ArrowLeft' && $head.nodeBefore) return false;
        const direction = [
            'ArrowLeft',
            'ArrowUp',
            'Home'
        ].includes(event.key) ? 'up' : 'down';
        const $fixedProblematicNodePosition = $27d30eafdc20067b$var$findFixedProblematicNodePosition(doc, $head, direction, {
            __livePage: __livePage
        });
        if ($fixedProblematicNodePosition) {
            // an offset is used here so that left arrow selects the first character before the node (consistent with arrow right)
            const headOffset = event.key === 'ArrowLeft' ? -1 : 0;
            const head = $fixedProblematicNodePosition.pos + headOffset;
            const forcedTextSelection = (0, $3lIcL.TextSelection).create(view.state.doc, $anchor.pos, head);
            const tr = view.state.tr;
            tr.setSelection(forcedTextSelection);
            view.dispatch(tr);
            event.preventDefault();
            return true;
        }
        return false;
    }
    return onKeydown;
}

});
parcelRegister("yNZd3", function(module, exports) {

$parcel$export(module.exports, "expandedState", () => $152428080f526901$export$de2a5eca4f1cacc0);
$parcel$export(module.exports, "isExpandCollapsed", () => $152428080f526901$export$785b8bfd794fa7b6);
const $152428080f526901$export$de2a5eca4f1cacc0 = new WeakMap();
const $152428080f526901$export$785b8bfd794fa7b6 = (node)=>{
    return !$152428080f526901$export$de2a5eca4f1cacc0.get(node) ?? false;
};

});


parcelRegister("cZanI", function(module, exports) {

$parcel$export(module.exports, "onMouseOut", () => $2b91b67b4e8b8b16$export$65a11040da641544);

var $3lIcL = parcelRequire("3lIcL");
function $2b91b67b4e8b8b16$export$53f3d8e656ab0334(selection) {
    if (selection.empty) return false;
    const { $anchor: $anchor, $head: $head } = selection;
    // Head must be at the start of its parent node's content
    if ($head.parentOffset !== 0) return false;
    // Head must be nested (e.g., in a panel > paragraph, not directly in doc)
    if ($head.depth <= 1) return false;
    // Head must be in the first top-level block (before depth 1 is 0)
    if ($head.before(1) !== 0) return false;
    // Selection must not span within a shared deeper structure
    if ($head.sharedDepth($anchor.pos) !== 0) return false;
    // Head must be in the first block at every level
    let isFirstBlockInTree = true;
    for(let i = $head.depth - 1; i >= 0; i--)if ($head.index(i) !== 0) {
        isFirstBlockInTree = false;
        break;
    }
    if (!isFirstBlockInTree) return false;
    return true;
}
function $2b91b67b4e8b8b16$export$65a11040da641544(view, event) {
    // Only trigger during a mouse drag
    if (event.buttons === 0) return false;
    if (view.state.selection instanceof (0, $3lIcL.TextSelection) && $2b91b67b4e8b8b16$export$53f3d8e656ab0334(view.state.selection)) {
        // Set selection with head at document start (position 0)
        const selection = new (0, $3lIcL.TextSelection)(view.state.doc.resolve(view.state.selection.$anchor.pos), view.state.doc.resolve(0));
        view.dispatch(view.state.tr.setSelection(selection));
        return true;
    }
    return false;
}

});




parcelRegister("db6dP", function(module, exports) {

$parcel$export(module.exports, "typeAheadPlugin", () => (parcelRequire("5F9b7")).typeAheadPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $5F9b7 = parcelRequire("5F9b7");

});
parcelRegister("5F9b7", function(module, exports) {

$parcel$export(module.exports, "typeAheadPlugin", () => $fe52624c7c765b7f$export$a023c922ef32b883);
/**
 *
 * Revamped typeahead using decorations instead of the `typeAheadQuery` mark
 *
 * https://product-fabric.atlassian.net/wiki/spaces/E/pages/2992177582/Technical+TypeAhead+Data+Flow
 *
 *
 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $anaPs = parcelRequire("anaPs");

var $bMFKb = parcelRequire("bMFKb");

var $i8KtF = parcelRequire("i8KtF");

var $7k8dr = parcelRequire("7k8dr");

var $b7EWj = parcelRequire("b7EWj");

var $eGOwo = parcelRequire("eGOwo");

var $azYbd = parcelRequire("azYbd");

var $cg71Z = parcelRequire("cg71Z");

var $PKsUR = parcelRequire("PKsUR");

var $2NBlM = parcelRequire("2NBlM");

var $3ATVn = parcelRequire("3ATVn");

var $kPuXt = parcelRequire("kPuXt");

var $kGFcc = parcelRequire("kGFcc");

var $akqoF = parcelRequire("akqoF");

var $elKSH = parcelRequire("elKSH");

var $7EuRs = parcelRequire("7EuRs");
const $fe52624c7c765b7f$var$createOpenAtTransaction = (editorAnalyticsAPI)=>(props)=>(tr)=>{
            const { triggerHandler: triggerHandler, inputMethod: inputMethod, query: query, removePrefixTriggerOnCancel: removePrefixTriggerOnCancel } = props;
            (0, $PKsUR.openTypeAheadAtCursor)({
                triggerHandler: triggerHandler,
                inputMethod: inputMethod,
                query: query,
                removePrefixTriggerOnCancel: removePrefixTriggerOnCancel
            })({
                tr: tr
            });
            // This function is called from the editor-plugin-emoji and editor-plugin-type-ahead
            // createOpenAtTransaction <- createOpenTypeAhead <- actions.open
            // 	<- emoji-plugin (Not used)
            //  <- type-ahead-plugin (Used)
            // and this caused the analytics event to be fired twice, as other places are relying on the
            // `onEditorViewStateUpdated` method to fire the analytics event
            // We want to disable this event
            if (!(0, $eGOwo.fg)('platform_editor_controls_patch_analytics_3')) editorAnalyticsAPI?.attachAnalyticsEvent({
                action: (0, $bMFKb.ACTION).INVOKED,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).TYPEAHEAD,
                actionSubjectId: triggerHandler.id,
                attributes: {
                    inputMethod: inputMethod
                },
                eventType: (0, $bMFKb.EVENT_TYPE).UI
            })(tr);
            return true;
        };
const $fe52624c7c765b7f$var$createOpenTypeAhead = (editorViewRef, editorAnalyticsAPI)=>(props)=>{
        if (!editorViewRef.current) return false;
        const { current: view } = editorViewRef;
        const { tr: tr } = view.state;
        $fe52624c7c765b7f$var$createOpenAtTransaction(editorAnalyticsAPI)(props)(tr);
        view.dispatch(tr);
        return true;
    };
const $fe52624c7c765b7f$var$createInsertTypeAheadItem = (editorViewRef)=>(props)=>{
        if (!editorViewRef.current) return false;
        const { current: view } = editorViewRef;
        const { triggerHandler: triggerHandler, contentItem: contentItem, query: query, sourceListItem: sourceListItem, mode: mode } = props;
        (0, $cg71Z.insertTypeAheadItem)(view)({
            handler: triggerHandler,
            item: contentItem,
            mode: mode || (0, $7k8dr.SelectItemMode).SELECTED,
            query: query,
            sourceListItem: sourceListItem
        });
        return true;
    };
const $fe52624c7c765b7f$var$createFindHandlerByTrigger = (editorViewRef)=>(trigger)=>{
        if (!editorViewRef.current) return null;
        const { current: view } = editorViewRef;
        return (0, $elKSH.findHandler)(trigger, view.state);
    };
const $fe52624c7c765b7f$var$createCloseTypeAhead = (editorViewRef)=>(options)=>{
        if (!editorViewRef.current) return false;
        const { current: view } = editorViewRef;
        const currentQuery = (0, $elKSH.getTypeAheadQuery)(view.state) || '';
        const { state: state } = view;
        let tr = state.tr;
        if (options.attachCommand) {
            const fakeDispatch = (customTr)=>{
                tr = customTr;
            };
            options.attachCommand(state, fakeDispatch);
        }
        (0, $azYbd.closeTypeAhead)(tr);
        if (options.insertCurrentQueryAsRawText && currentQuery && currentQuery.length > 0) {
            const handler = (0, $elKSH.getTypeAheadHandler)(state);
            if (!handler) return false;
            const text = handler.trigger.concat(currentQuery);
            tr.replaceSelectionWith(state.schema.text(text));
        }
        view.dispatch(tr);
        if (!view.hasFocus()) view.focus();
        return true;
    };
const $fe52624c7c765b7f$export$a023c922ef32b883 = ({ api: api })=>{
    const popupMountRef = {
        current: null
    };
    const editorViewRef = {
        current: null
    };
    return {
        name: 'typeAhead',
        marks () {
            // We need to keep this to make sure
            // All documents with typeahead marks will be loaded normally
            return [
                {
                    name: 'typeAheadQuery',
                    mark: (0, $anaPs.typeAheadQuery)
                }
            ];
        },
        pmPlugins (typeAhead = []) {
            return [
                {
                    name: 'typeAhead',
                    plugin: ({ dispatch: dispatch, getIntl: getIntl, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI })=>(0, $kGFcc.createPlugin)({
                            getIntl: getIntl,
                            popupMountRef: popupMountRef,
                            reactDispatch: dispatch,
                            typeAheadHandlers: typeAhead,
                            nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
                            api: api
                        })
                },
                {
                    name: 'typeAheadEditorViewRef',
                    plugin: ()=>{
                        return new (0, $i8KtF.SafePlugin)({
                            view (view) {
                                editorViewRef.current = view;
                                return {
                                    destroy () {
                                        editorViewRef.current = null;
                                    }
                                };
                            }
                        });
                    }
                },
                {
                    name: 'typeAheadInsertItem',
                    plugin: (0, $3ATVn.createPlugin)
                },
                {
                    name: 'typeAheadInputRule',
                    plugin: ({ schema: schema, featureFlags: featureFlags })=>(0, $2NBlM.inputRulePlugin)(schema, typeAhead, featureFlags)
                }
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return {
                query: '',
                isOpen: false,
                isAllowed: false,
                currentHandler: undefined,
                decorationSet: (0, $b7EWj.DecorationSet).empty,
                decorationElement: null,
                triggerHandler: undefined,
                items: [],
                errorInfo: null,
                selectedIndex: 0
            };
            const isOpen = (0, $elKSH.isTypeAheadOpen)(editorState);
            const state = (0, $elKSH.getPluginState)(editorState);
            return {
                query: (0, $elKSH.getTypeAheadQuery)(editorState) || '',
                currentHandler: (0, $elKSH.getTypeAheadHandler)(editorState),
                isOpen: isOpen,
                isAllowed: !isOpen,
                decorationSet: state?.decorationSet ?? (0, $b7EWj.DecorationSet).empty,
                decorationElement: state?.decorationElement ?? null,
                triggerHandler: state?.triggerHandler,
                items: state?.items ?? [],
                errorInfo: state?.errorInfo ?? null,
                selectedIndex: state?.selectedIndex ?? 0
            };
        },
        actions: {
            isOpen: (0, $elKSH.isTypeAheadOpen),
            isAllowed: (0, $elKSH.isTypeAheadAllowed),
            open: $fe52624c7c765b7f$var$createOpenTypeAhead(editorViewRef, api?.analytics?.actions),
            openAtTransaction: $fe52624c7c765b7f$var$createOpenAtTransaction(api?.analytics?.actions),
            findHandlerByTrigger: $fe52624c7c765b7f$var$createFindHandlerByTrigger(editorViewRef),
            insert: $fe52624c7c765b7f$var$createInsertTypeAheadItem(editorViewRef),
            close: $fe52624c7c765b7f$var$createCloseTypeAhead(editorViewRef)
        },
        contentComponent ({ editorView: editorView, containerElement: containerElement, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, wrapperElement: wrapperElement }) {
            popupMountRef.current = {
                popupsMountPoint: popupsMountPoint || wrapperElement || undefined,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement || containerElement || undefined
            };
            return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7EuRs.ContentComponent), {
                editorView: editorView,
                popupMountRef: popupMountRef,
                api: api
            });
        },
        onEditorViewStateUpdated ({ originalTransaction: originalTransaction, oldEditorState: oldEditorState, newEditorState: newEditorState }) {
            const oldPluginState = (0, $elKSH.getPluginState)(oldEditorState);
            const newPluginState = (0, $elKSH.getPluginState)(newEditorState);
            if (!oldPluginState || !newPluginState) return;
            const { triggerHandler: oldTriggerHandler } = oldPluginState;
            const { triggerHandler: newTriggerHandler } = newPluginState;
            const isANewHandler = oldTriggerHandler !== newTriggerHandler;
            if (oldTriggerHandler?.dismiss && isANewHandler) {
                const typeAheadMessage = originalTransaction.getMeta((0, $kPuXt.pluginKey));
                const wasItemInserted = typeAheadMessage && typeAheadMessage.action === 'INSERT_RAW_QUERY';
                oldTriggerHandler.dismiss({
                    editorState: newEditorState,
                    query: oldPluginState.query,
                    stats: (oldPluginState.stats || new (0, $akqoF.StatsModifier)()).serialize(),
                    wasItemInserted: wasItemInserted
                });
            }
            if (newTriggerHandler?.onOpen && isANewHandler) {
                if ((0, $eGOwo.fg)('platform_editor_ease_of_use_metrics')) api?.metrics?.commands.handleIntentToStartEdit({
                    shouldStartTimer: false,
                    shouldPersistActiveSession: true
                });
                newTriggerHandler.onOpen(newEditorState);
            }
            const oldIsOpen = (0, $elKSH.isTypeAheadOpen)(oldEditorState);
            const newIsOpen = (0, $elKSH.isTypeAheadOpen)(newEditorState);
            if (newTriggerHandler && isANewHandler) {
                // if the typeahead opens another typeahead via the quickInsert we do NOT want to fire this analytic event (mentions and emojis) as it is already being fired from editor-plugin-analytics
                const isDuplicateInvokedEvent = newPluginState.inputMethod === (0, $bMFKb.INPUT_METHOD).QUICK_INSERT && Object.values((0, $7k8dr.TypeAheadAvailableNodes)).includes(newTriggerHandler.id);
                if (!isDuplicateInvokedEvent) {
                    if ((0, $eGOwo.fg)('platform_editor_controls_patch_analytics_3')) api?.analytics?.actions?.fireAnalyticsEvent({
                        action: (0, $bMFKb.ACTION).INVOKED,
                        actionSubject: (0, $bMFKb.ACTION_SUBJECT).TYPEAHEAD,
                        actionSubjectId: newTriggerHandler.id || 'not_set',
                        attributes: {
                            inputMethod: newPluginState.inputMethod || (0, $bMFKb.INPUT_METHOD).KEYBOARD
                        },
                        eventType: (0, $bMFKb.EVENT_TYPE).UI
                    }, undefined, {
                        context: {
                            selection: newEditorState.selection
                        }
                    });
                    else api?.analytics?.actions?.fireAnalyticsEvent({
                        action: (0, $bMFKb.ACTION).INVOKED,
                        actionSubject: (0, $bMFKb.ACTION_SUBJECT).TYPEAHEAD,
                        actionSubjectId: newTriggerHandler.id || 'not_set',
                        attributes: {
                            inputMethod: newPluginState.inputMethod || (0, $bMFKb.INPUT_METHOD).KEYBOARD
                        },
                        eventType: (0, $bMFKb.EVENT_TYPE).UI
                    });
                }
            } else if (oldIsOpen && !newIsOpen && (0, $eGOwo.fg)('platform_editor_ease_of_use_metrics')) api?.core.actions.execute(api?.metrics?.commands.startActiveSessionTimer());
        }
    };
};

});
parcelRegister("azYbd", function(module, exports) {

$parcel$export(module.exports, "closeTypeAhead", () => $42233d5a860bd9e9$export$daba40574d0568e3);

var $ckKJp = parcelRequire("ckKJp");

var $kPuXt = parcelRequire("kPuXt");
const $42233d5a860bd9e9$export$daba40574d0568e3 = (tr)=>{
    return tr.setMeta((0, $kPuXt.pluginKey), {
        action: (0, $ckKJp.ACTIONS).CLOSE_TYPE_AHEAD
    });
};

});
parcelRegister("ckKJp", function(module, exports) {

$parcel$export(module.exports, "ACTIONS", () => $b11d849867a039e6$export$92a1a3b7554e9387);
var $b11d849867a039e6$export$92a1a3b7554e9387 = /*#__PURE__*/ function(ACTIONS) {
    ACTIONS["OPEN_TYPEAHEAD_AT_CURSOR"] = "OPEN_TYPEAHEAD_AT_CURSOR";
    ACTIONS["CLOSE_TYPE_AHEAD"] = "CLOSE_TYPE_AHEAD";
    ACTIONS["CHANGE_QUERY"] = "CHANGE_QUERY";
    ACTIONS["INSERT_ITEM"] = "INSERT_ITEM";
    ACTIONS["INSERT_RAW_QUERY"] = "INSERT_RAW_QUERY";
    ACTIONS["UPDATE_LIST_ITEMS"] = "UPDATE_LIST_ITEMS";
    ACTIONS["UPDATE_LIST_ERROR"] = "UPDATE_LIST_ERROR";
    ACTIONS["CLEAR_LIST_ERROR"] = "CLEAR_LIST_ERROR";
    ACTIONS["UPDATE_SELECTED_INDEX"] = "UPDATE_SELECTED_INDEX";
    return ACTIONS;
}({});

});

parcelRegister("kPuXt", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $7d79ad45f0f0254a$export$18d4026d1ea86bb1);

var $3lIcL = parcelRequire("3lIcL");
const $7d79ad45f0f0254a$export$18d4026d1ea86bb1 = new (0, $3lIcL.PluginKey)('typeAheadPlugin');

});


parcelRegister("cg71Z", function(module, exports) {

$parcel$export(module.exports, "insertTypeAheadItem", () => $3cc15d77a03bb294$export$173ade35125a6637);

var $3YJ2y = parcelRequire("3YJ2y");

var $7k8dr = parcelRequire("7k8dr");

var $kuxd1 = parcelRequire("kuxd1");

var $3xw6l = parcelRequire("3xw6l");

var $ckKJp = parcelRequire("ckKJp");

var $kPuXt = parcelRequire("kPuXt");

var $akqoF = parcelRequire("akqoF");

var $elKSH = parcelRequire("elKSH");

var $azYbd = parcelRequire("azYbd");

var $95mAm = parcelRequire("95mAm");
const $3cc15d77a03bb294$var$validateNode = ({ schema: schema, maybeNode: maybeNode })=>{
    if (!maybeNode) return null;
    if (maybeNode instanceof (0, $3xw6l.Node) || maybeNode instanceof (0, $3xw6l.Fragment)) return maybeNode;
    if (typeof maybeNode === 'string') return schema.text(maybeNode);
    try {
        return (0, $3xw6l.Node).fromJSON(schema, maybeNode);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        return null;
    }
};
const $3cc15d77a03bb294$var$createInsertCallback = ({ editorState: state, handler: handler, query: query, wasInsertedBySpace: wasInsertedBySpace, selectedIndex: selectedIndex, textStartPosition: textStartPosition, textInserted: textInserted })=>(maybeNode, opts = {})=>{
        const { tr: tr } = state;
        const position = {
            start: textStartPosition,
            end: textStartPosition + (wasInsertedBySpace ? textInserted.length : 0)
        };
        const node = $3cc15d77a03bb294$var$validateNode({
            schema: state.schema,
            maybeNode: maybeNode
        });
        if (!node) {
            (0, $azYbd.closeTypeAhead)(tr);
            // In this kind of situation we need to
            // delete the raw text query
            tr.delete(position.start, position.end);
            return tr;
        }
        node instanceof (0, $3xw6l.Node) && node.isBlock ? (0, $95mAm.insertBlockNode)({
            node: node,
            tr: tr,
            position: position
        }) : (0, $95mAm.insertInlineNodeOrFragment)({
            maybeFragment: node,
            tr: tr,
            position: position,
            selectInlineNode: Boolean(opts.selectInlineNode)
        });
        (0, $kuxd1.closeHistory)(tr);
        if (wasInsertedBySpace) return tr;
        const config = {
            stage: (0, $3YJ2y.InsertTypeAheadStages).INSERTING_ITEM,
            query: query,
            selectedIndex: selectedIndex,
            trigger: handler.trigger
        };
        tr.step(new (0, $3YJ2y.InsertTypeAheadStep)(config));
        return tr;
    };
const $3cc15d77a03bb294$var$createDeleteRawTextCallback = ({ trigger: trigger, selectedIndex: selectedIndex, position: position, query: query, wasInsertedBySpace: wasInsertedBySpace, insertItem: insertItem })=>{
    return (newState)=>{
        const tr = newState.tr;
        (0, $kuxd1.closeHistory)(tr);
        if (!wasInsertedBySpace) {
            tr.delete(position.start, position.end);
            const config = {
                stage: (0, $3YJ2y.InsertTypeAheadStages).DELETING_RAW_QUERY,
                selectedIndex: selectedIndex,
                query: query,
                trigger: trigger
            };
            tr.step(new (0, $3YJ2y.InsertTypeAheadStep)(config));
        }
        tr.setMeta((0, $kPuXt.pluginKey), {
            action: (0, $ckKJp.ACTIONS).INSERT_ITEM,
            params: insertItem
        });
        return tr;
    };
};
const $3cc15d77a03bb294$export$173ade35125a6637 = (view)=>({ item: item, handler: handler, mode: mode, query: query, sourceListItem: sourceListItem })=>{
        const pluginState = (0, $elKSH.getPluginState)(view.state);
        if (!pluginState) return;
        const stats = (pluginState.stats || new (0, $akqoF.StatsModifier)()).serialize();
        const meta = {
            mode: mode,
            query: query,
            stats: stats,
            sourceListItem: sourceListItem
        };
        const { tr: tr } = view.state;
        const trigger = handler.trigger;
        let text = `${trigger}${query}`;
        if (mode === (0, $7k8dr.SelectItemMode).SPACE) text = text.trim().concat(' ');
        // We want to always persist selectedIndex as -1 upon selecting an item from typeahead
        // in order to retain exist focus behaviour when undoing
        const selectedIndex = -1;
        const wasInsertedBySpace = mode === (0, $7k8dr.SelectItemMode).SPACE;
        const { selection: { from: textStartPosition } } = tr;
        const insertItem = (newEditorSate)=>{
            const insertCallback = $3cc15d77a03bb294$var$createInsertCallback({
                editorState: newEditorSate,
                query: query,
                mode: mode,
                handler: handler,
                wasInsertedBySpace: wasInsertedBySpace,
                selectedIndex: selectedIndex,
                textInserted: text,
                textStartPosition: textStartPosition
            });
            let wasInsertCallbackCalled = false;
            // Some wierd plugins doesn't call the insert item callback
            // For example, the link quick insert item
            // For those cases we need to make sure we are closing the typeahead
            const proxyHandler = {
                apply: function(target, _thisContext, argumentsList) {
                    wasInsertCallbackCalled = true;
                    return target(...argumentsList);
                }
            };
            const insertCallbackProxy = new Proxy(insertCallback, proxyHandler);
            const nextTr = handler.selectItem(newEditorSate, item, insertCallbackProxy, meta);
            if (!wasInsertCallbackCalled && nextTr) {
                (0, $kuxd1.closeHistory)(nextTr);
                // In some cases we need to re-open the typeahead
                // e.g.: addign mentions from the quick insert
                //
                // Today, the QuickInsert API doesn't have a tool
                // to help on this. So the code below will close the typeahead
                // only if there is no previous metadata about typeahead in the
                // next transaction
                if (!nextTr.getMeta((0, $kPuXt.pluginKey))) (0, $azYbd.closeTypeAhead)(nextTr);
            }
            return nextTr;
        };
        const position = {
            start: tr.selection.from,
            end: tr.selection.from + text.length
        };
        tr.setMeta((0, $kPuXt.pluginKey), {
            action: (0, $ckKJp.ACTIONS).INSERT_RAW_QUERY,
            params: $3cc15d77a03bb294$var$createDeleteRawTextCallback({
                wasInsertedBySpace: wasInsertedBySpace,
                selectedIndex: selectedIndex,
                insertItem: insertItem,
                position: position,
                query: query,
                trigger: trigger
            })
        });
        tr.insertText(text);
        (0, $kuxd1.closeHistory)(tr);
        view.dispatch(tr);
        view.focus();
    };

});
parcelRegister("3YJ2y", function(module, exports) {

$parcel$export(module.exports, "InsertTypeAheadStages", () => $2e59e9bc5a2ec7d1$export$1b2be0bed116d664);
$parcel$export(module.exports, "InsertTypeAheadStep", () => $2e59e9bc5a2ec7d1$export$5ca6d15deb246b5d);

var $3xw6l = parcelRequire("3xw6l");

var $lzEKq = parcelRequire("lzEKq");
const $2e59e9bc5a2ec7d1$export$2f0b0962a5993fe0 = 'atlaskit-insert-type-ahead';
let $2e59e9bc5a2ec7d1$export$1b2be0bed116d664 = /*#__PURE__*/ function(InsertTypeAheadStages) {
    InsertTypeAheadStages["DELETING_RAW_QUERY"] = "DELETING_RAW_QUERY";
    InsertTypeAheadStages["INSERTING_ITEM"] = "INSERTING_ITEM";
    return InsertTypeAheadStages;
}({});
class $2e59e9bc5a2ec7d1$export$5ca6d15deb246b5d extends (0, $lzEKq.Step) {
    constructor({ stage: stage, query: query, trigger: trigger, selectedIndex: selectedIndex }, isInvertStep = false){
        super();
        this.isInvertStep = isInvertStep;
        this.stage = stage;
        this.query = query;
        this.trigger = trigger;
        this.selectedIndex = selectedIndex;
    }
    invert() {
        const config = {
            stage: this.stage,
            query: this.query,
            trigger: this.trigger,
            selectedIndex: this.selectedIndex
        };
        return new $2e59e9bc5a2ec7d1$export$5ca6d15deb246b5d(config, !this.isInvertStep);
    }
    apply(doc) {
        return (0, $lzEKq.StepResult).ok(doc);
    }
    merge() {
        return null;
    }
    isInsertionStep() {
        return !this.isInvertStep;
    }
    isUndoingStep() {
        return this.isInvertStep;
    }
    map() {
        const config = {
            stage: this.stage,
            query: this.query,
            trigger: this.trigger,
            selectedIndex: this.selectedIndex
        };
        // Return the same events, this step will never be removed
        return new $2e59e9bc5a2ec7d1$export$5ca6d15deb246b5d(config, this.isInvertStep);
    }
    getMap() {
        return new (0, $lzEKq.StepMap)([
            0,
            0,
            0
        ]);
    }
    toJSON() {
        // When serialized we should create a noop Replace step
        return {
            stepType: 'replace',
            from: 0,
            to: 0
        };
    }
    static fromJSON() {
        // This is a "local custom step" once serialized
        // we need to transform it in a no-operation action
        return new (0, $lzEKq.ReplaceStep)(0, 0, (0, $3xw6l.Slice).empty);
    }
}
/** Register this step with Prosemirror */ (0, $lzEKq.Step).jsonID($2e59e9bc5a2ec7d1$export$2f0b0962a5993fe0, $2e59e9bc5a2ec7d1$export$5ca6d15deb246b5d);

});

parcelRegister("akqoF", function(module, exports) {

$parcel$export(module.exports, "StatsModifier", () => $77674b3b26f0c92c$export$630efe5940bb4d41);
class $77674b3b26f0c92c$export$630efe5940bb4d41 {
    constructor(){
        this.startedAt = 0;
        this.endedAt = 0;
        this.keyCount = {
            arrowUp: 0,
            arrowDown: 0
        };
        this.increaseArrowUp = ()=>{
            this.keyCount.arrowUp += 1;
        };
        this.increaseArrowDown = ()=>{
            this.keyCount.arrowDown += 1;
        };
        this.serialize = ()=>{
            return {
                startedAt: this.startedAt,
                endedAt: performance.now(),
                keyCount: {
                    arrowUp: this.keyCount?.arrowUp || 0,
                    arrowDown: this.keyCount?.arrowDown || 0
                }
            };
        };
        this.startedAt = performance.now();
        this.keyCount = {
            arrowUp: 0,
            arrowDown: 0
        };
    }
}

});

parcelRegister("elKSH", function(module, exports) {

$parcel$export(module.exports, "isTypeAheadHandler", () => $f852c50a6a396796$export$be092076596418f1);
$parcel$export(module.exports, "isTypeAheadOpen", () => $f852c50a6a396796$export$564dcc295d6ce147);
$parcel$export(module.exports, "getPluginState", () => $f852c50a6a396796$export$f05434c51e3762e);
$parcel$export(module.exports, "getTypeAheadHandler", () => $f852c50a6a396796$export$c1eba975d6442029);
$parcel$export(module.exports, "getTypeAheadQuery", () => $f852c50a6a396796$export$7a55deb43cd1340e);
$parcel$export(module.exports, "isTypeAheadAllowed", () => $f852c50a6a396796$export$74b0f581633f8412);
$parcel$export(module.exports, "findHandler", () => $f852c50a6a396796$export$2bae95e359577df4);
$parcel$export(module.exports, "skipForwardToSafeItem", () => $f852c50a6a396796$export$84a03e6192df0237);
$parcel$export(module.exports, "moveSelectedIndex", () => $f852c50a6a396796$export$f985e98ceae7c8f6);
$parcel$export(module.exports, "getTypeAheadListAriaLabels", () => $f852c50a6a396796$export$19cacaa810ba988a);

var $7k8dr = parcelRequire("7k8dr");
var $4drex = parcelRequire("4drex");

var $92xoS = parcelRequire("92xoS");

var $lKOUs = parcelRequire("lKOUs");

var $gclLy = parcelRequire("gclLy");

var $kPuXt = parcelRequire("kPuXt");

var $akqoF = parcelRequire("akqoF");
const $f852c50a6a396796$export$be092076596418f1 = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
handler)=>{
    return handler && Object.values((0, $7k8dr.TypeAheadAvailableNodes)).includes(handler.id) && typeof handler.trigger === 'string' && typeof handler.selectItem === 'function' && typeof handler.getItems === 'function';
};
const $f852c50a6a396796$export$564dcc295d6ce147 = (editorState)=>{
    return !!(0, $kPuXt.pluginKey)?.getState(editorState)?.decorationSet?.find().length;
};
const $f852c50a6a396796$export$f05434c51e3762e = (editorState)=>{
    return (0, $kPuXt.pluginKey).getState(editorState);
};
const $f852c50a6a396796$export$c1eba975d6442029 = (editorState)=>{
    return (0, $kPuXt.pluginKey).getState(editorState)?.triggerHandler;
};
const $f852c50a6a396796$export$7a55deb43cd1340e = (editorState)=>{
    return (0, $kPuXt.pluginKey).getState(editorState)?.query;
};
const $f852c50a6a396796$export$74b0f581633f8412 = (state)=>{
    const isOpen = $f852c50a6a396796$export$564dcc295d6ce147(state);
    // if the TypeAhead is open
    // we should not allow it
    return !isOpen;
};
const $f852c50a6a396796$export$2bae95e359577df4 = (id, state)=>{
    const pluginState = (0, $kPuXt.pluginKey).getState(state);
    if (!pluginState || !pluginState.typeAheadHandlers || pluginState.typeAheadHandlers.length === 0) return null;
    const { typeAheadHandlers: typeAheadHandlers } = pluginState;
    return typeAheadHandlers.find((h)=>h.id === id) || null;
};
const $f852c50a6a396796$export$84a03e6192df0237 = ({ currentIndex: currentIndex, nextIndex: nextIndex, listSize: listSize, itemIsDisabled: itemIsDisabled })=>{
    // Use a loop to find the next selectable item
    for(let idx = nextIndex; idx < listSize; idx++){
        if (!itemIsDisabled(idx)) return idx;
    }
    // We got to the end of the list ^, now try from the start
    if ((0, $92xoS.editorExperiment)('platform_editor_offline_editing_web', true)) for(let idx = 0; idx < nextIndex; idx++){
        if (!itemIsDisabled(idx)) return idx;
    }
    // If no selectable items are found, return currentIndex
    return currentIndex;
};
const $f852c50a6a396796$export$723aff40bcdce278 = ({ currentIndex: currentIndex, nextIndex: nextIndex, listSize: listSize, itemIsDisabled: itemIsDisabled })=>{
    // Use a loop to find the next non-selectable item when going backwards
    for(let idx = nextIndex; idx >= 0; idx--){
        if (!itemIsDisabled(idx)) return idx;
    }
    // We got to the start of the list ^, now try from the end
    if ((0, $92xoS.editorExperiment)('platform_editor_offline_editing_web', true)) for(let idx = listSize; idx > nextIndex; idx--){
        if (!itemIsDisabled(idx)) return idx;
    }
    // If no non-selectable items are found, return currentIndex
    return currentIndex;
};
const $f852c50a6a396796$export$89c7a133a9db5167 = ({ trigger: trigger, editorState: editorState })=>{
    const pluginState = (0, $kPuXt.pluginKey).getState(editorState);
    if (!pluginState || !pluginState.typeAheadHandlers || pluginState.typeAheadHandlers.length === 0) return null;
    const { typeAheadHandlers: typeAheadHandlers } = pluginState;
    return typeAheadHandlers.find((h)=>h.trigger === trigger) || null;
};
const $f852c50a6a396796$export$f985e98ceae7c8f6 = ({ editorView: editorView, direction: direction, api: api })=>()=>{
        const typeAheadState = $f852c50a6a396796$export$f05434c51e3762e(editorView.state);
        if (!typeAheadState) return;
        const { selectedIndex: selectedIndex, items: items } = typeAheadState;
        const stats = typeAheadState.stats instanceof (0, $akqoF.StatsModifier) ? typeAheadState.stats : new (0, $akqoF.StatsModifier)();
        let nextIndex;
        const isDisabled = (idx)=>(0, $gclLy.itemIsDisabled)(items[idx], api);
        if (direction === 'next') {
            stats.increaseArrowDown();
            /**
			 * See: https://product-fabric.atlassian.net/browse/ED-17200
			 * `selectedIndex` is forced to -1 now to not immediately focus the typeahead
			 * and only do so when there is explicit logic to focus into the typeahead
			 * options.
			 *
			 * This check for "set index to 1 when -1"
			 * - is a temporary workaround to get back the previous behaviour without
			 *    entirely reverting the a11y improvements
			 *
			 */ if (selectedIndex === -1 && items.length > 1) // If the first item is disabled we actually want to skip to the 3rd item
            // on the first arrow down
            nextIndex = isDisabled(0) && items.length > 2 ? 2 : 1;
            else nextIndex = selectedIndex >= items.length - 1 ? 0 : selectedIndex + 1;
            nextIndex = $f852c50a6a396796$export$84a03e6192df0237({
                currentIndex: selectedIndex,
                nextIndex: nextIndex,
                listSize: items.length,
                itemIsDisabled: isDisabled
            });
        } else {
            stats.increaseArrowUp();
            nextIndex = selectedIndex <= 0 ? items.length - 1 : selectedIndex - 1;
            nextIndex = $f852c50a6a396796$export$723aff40bcdce278({
                currentIndex: selectedIndex,
                nextIndex: nextIndex,
                listSize: items.length,
                itemIsDisabled: isDisabled
            });
        }
        (0, $lKOUs.updateSelectedIndex)(nextIndex, api)(editorView.state, editorView.dispatch);
    };
const $f852c50a6a396796$export$19cacaa810ba988a = (trigger, intl, item)=>{
    switch(trigger){
        case '@':
            return {
                popupAriaLabel: intl.formatMessage((0, $4drex.typeAheadListMessages).mentionPopupLabel),
                listItemAriaLabel: intl.formatMessage((0, $4drex.typeAheadListMessages).metionListItemLabel, {
                    name: item?.mention?.name || '',
                    shortName: item?.mention?.mentionName || ''
                })
            };
        case '/':
            return {
                popupAriaLabel: intl.formatMessage((0, $4drex.typeAheadListMessages).quickInsertPopupLabel),
                listItemAriaLabel: intl.formatMessage((0, $4drex.typeAheadListMessages).emojiListItemLabel, {
                    name: item?.title || '',
                    shortcut: item?.emoji?.shortName || ''
                })
            };
        case ':':
            return {
                popupAriaLabel: intl.formatMessage((0, $4drex.typeAheadListMessages).emojiPopupLabel),
                listItemAriaLabel: intl.formatMessage((0, $4drex.typeAheadListMessages).emojiListItemLabel, {
                    name: item?.emoji?.name || '',
                    shortcut: item?.emoji?.shortName || ''
                })
            };
        default:
            return {
                popupAriaLabel: intl.formatMessage((0, $4drex.typeAheadListMessages).typeAheadPopupLabel)
            };
    }
};

});
parcelRegister("lKOUs", function(module, exports) {

$parcel$export(module.exports, "updateSelectedIndex", () => $514d7afb771706f4$export$9993709486a96a6b);

var $ckKJp = parcelRequire("ckKJp");

var $gclLy = parcelRequire("gclLy");

var $kPuXt = parcelRequire("kPuXt");
const $514d7afb771706f4$export$9993709486a96a6b = (selectedIndex, api)=>{
    return (state, dispatch)=>{
        const pluginState = (0, $kPuXt.pluginKey).getState(state);
        if (pluginState?.selectedIndex === selectedIndex) return false;
        // If the new index is disabled ignore this call, we can use the previous index
        if ((0, $gclLy.itemIsDisabled)(pluginState?.items[selectedIndex], api)) return false;
        const tr = state.tr;
        tr.setMeta((0, $kPuXt.pluginKey), {
            action: (0, $ckKJp.ACTIONS).UPDATE_SELECTED_INDEX,
            params: {
                selectedIndex: selectedIndex
            }
        });
        if (dispatch) dispatch(tr);
        return true;
    };
};

});
parcelRegister("gclLy", function(module, exports) {

$parcel$export(module.exports, "itemIsDisabled", () => $df63d4403d4e0caf$export$1ebf03cc1b973f80);
const $df63d4403d4e0caf$export$1ebf03cc1b973f80 = (item, api)=>{
    const isOffline = api?.connectivity?.sharedState.currentState()?.mode === 'offline';
    return isOffline && item?.isDisabledOffline === true;
};

});



parcelRegister("95mAm", function(module, exports) {

$parcel$export(module.exports, "insertBlockNode", () => $fbff0dd4802d0e7b$export$faec73a52dd47a2c);
$parcel$export(module.exports, "insertInlineNodeOrFragment", () => $fbff0dd4802d0e7b$export$a6d430434014dc1c);

var $j6ZdO = parcelRequire("j6ZdO");

var $kMoqb = parcelRequire("kMoqb");

var $3xw6l = parcelRequire("3xw6l");

var $3lIcL = parcelRequire("3lIcL");
function $fbff0dd4802d0e7b$var$findInsertPoint(doc, pos, nodeToInsert) {
    const $pos = doc.resolve(pos);
    const createInsertPosition = (from, to)=>({
            from: from,
            to: to || from
        });
    // Search for a valid position for nodeToInsert in progressively higher levels
    for(let level = $pos.depth; level >= 0; level--){
        const nodeAtLevel = $pos.node(level);
        // Try to replace the empty paragraph in the level above
        // Scenario:
        //   doc(
        //     table(
        //       row(
        //         cell(
        //           p('{<>}'),
        //         ),
        //       )
        //     )
        //   )
        const levelAbove = Math.max(level - 1, 0);
        const parentNode = $pos.node(levelAbove);
        // Special case: when this is true, the 'to' position should be the end
        // of the empty paragraph
        const isNodeAtLevelEmptyParagraph = nodeAtLevel.type.name === 'paragraph' && nodeAtLevel.content.size === 0;
        const indexAtLevelAbove = $pos.index(levelAbove);
        const canReplaceNodeAtLevelAbove = parentNode.canReplaceWith(indexAtLevelAbove, indexAtLevelAbove, nodeToInsert.type);
        if (isNodeAtLevelEmptyParagraph && canReplaceNodeAtLevelAbove) {
            const from = $pos.posAtIndex(indexAtLevelAbove, levelAbove);
            return createInsertPosition(from, from + nodeAtLevel.nodeSize);
        }
        // Try to insert this node right after the node in the level above
        // Scenario:
        //   doc(
        //     panel(
        //       p('{<>}'),
        //     )
        //   )
        const indexAfterAtLevelAbove = $pos.indexAfter(levelAbove);
        const canInsertNodeAtLevelAbove = parentNode.canReplaceWith(indexAfterAtLevelAbove, indexAfterAtLevelAbove, nodeToInsert.type);
        if (canInsertNodeAtLevelAbove) return createInsertPosition($pos.posAtIndex(indexAfterAtLevelAbove, levelAbove));
    }
    return createInsertPosition(0);
}
const $fbff0dd4802d0e7b$export$faec73a52dd47a2c = ({ node: node, tr: tr, position: position })=>{
    const { start: start, end: end } = position;
    if (node.isText) return tr.replaceWith(start, end, node);
    if (node.isBlock) {
        tr.delete(start, end);
        const mappedStart = tr.mapping.map(start);
        const nodeNormalized = (0, $j6ZdO.normaliseNestedLayout)(tr, node);
        const { listItem: listItem } = tr.doc.type.schema.nodes;
        // Handle edge cases if it's in a list or that it's inserting a node in the same node type
        /* e.g.
		 * panel (
		 *   1. text (insertion)
		 * )
		 * at insertion, text is parent (0), listItem is grandParent (-1), list is greatGrandparent (-2), panel is ggreatGrandParent (-3)
		 */ const grandParentNodeType = tr.selection.$from.node(-1)?.type;
        const ggreatGrandParentNodeType = tr.selection.$from.node(-3)?.type;
        if (grandParentNodeType === listItem && !(ggreatGrandParentNodeType === node.type)) return (0, $kMoqb.transformNodeIntoListItem)(tr, nodeNormalized);
        // Handle edge cases for hr and mediaSingle
        const inserted = (0, $j6ZdO.safeInsert)(nodeNormalized, mappedStart)(tr);
        if (inserted) return tr;
        const sliceInserted = (0, $3xw6l.Slice).maxOpen((0, $3xw6l.Fragment).from(nodeNormalized));
        const { from: from, to: to } = $fbff0dd4802d0e7b$var$findInsertPoint(tr.doc, mappedStart, nodeNormalized);
        tr.replaceWith(from, to, node);
        const openPosition = Math.min(from + (node.isAtom ? node.nodeSize : sliceInserted.openStart), tr.doc.content.size);
        const FORWARD_DIRECTION = 1;
        const nextSelection = (0, $3lIcL.TextSelection).findFrom(tr.doc.resolve(openPosition), FORWARD_DIRECTION, true);
        if (nextSelection) return tr.setSelection(nextSelection);
    }
    return tr;
};
const $fbff0dd4802d0e7b$export$a6d430434014dc1c = ({ maybeFragment: maybeFragment, tr: tr, position: position, selectInlineNode: selectInlineNode })=>{
    const { start: start, end: end } = position;
    const fragment = maybeFragment instanceof (0, $3xw6l.Node) ? (0, $3xw6l.Fragment).from(maybeFragment) : maybeFragment;
    tr.replaceWith(start, end, fragment);
    if (selectInlineNode) return tr.setSelection((0, $3lIcL.NodeSelection).create(tr.doc, start));
    return tr.setSelection((0, $3lIcL.TextSelection).near(tr.doc.resolve(start + fragment.size)));
};

});
parcelRegister("j6ZdO", function(module, exports) {

$parcel$export(module.exports, "normaliseNestedLayout", () => $384898e2fc47703e$export$9a3d0d2a50538e52);
$parcel$export(module.exports, "safeInsert", () => $384898e2fc47703e$export$5fe92db78385e37c);
$parcel$export(module.exports, "shouldSplitSelectedNodeOnNodeInsertion", () => $384898e2fc47703e$export$b80431b156693a98);
$parcel$export(module.exports, "insertSelectedItem", () => $384898e2fc47703e$export$e3c00faab58641c5);
$parcel$export(module.exports, "contentAllowedInCodeBlock", () => $384898e2fc47703e$export$b6980e4b8ea578a5);
$parcel$export(module.exports, "fragmentContainsNodeType", () => $384898e2fc47703e$export$2b1594c8921b5b2e);

var $3xw6l = parcelRequire("3xw6l");

var $3lIcL = parcelRequire("3lIcL");

var $lzEKq = parcelRequire("lzEKq");

var $BmspC = parcelRequire("BmspC");

var $6BNUN = parcelRequire("6BNUN");
parcelRequire("3ADzg");
var $5Z3Rm = parcelRequire("5Z3Rm");
var $fCXIH = parcelRequire("fCXIH");
var $384898e2fc47703e$export$cbdce50c60b34c89 = /*#__PURE__*/ function(LookDirection) {
    LookDirection["Before"] = "before";
    LookDirection["After"] = "after";
    return LookDirection;
}({});
const $384898e2fc47703e$export$9a3d0d2a50538e52 = ({ selection: selection, doc: doc }, node)=>{
    if (selection.$from.depth > 1) {
        if (node.attrs.layout && node.attrs.layout !== 'default') return node.type.createChecked({
            ...node.attrs,
            layout: 'default'
        }, node.content, node.marks);
        // If its a breakout layout, we can remove the mark
        // Since default isn't a valid breakout mode.
        const breakoutMark = doc.type.schema.marks.breakout;
        if (breakoutMark && breakoutMark.isInSet(node.marks)) {
            const newMarks = breakoutMark.removeFromSet(node.marks);
            return node.type.createChecked(node.attrs, node.content, newMarks);
        }
    }
    return node;
};
const $384898e2fc47703e$var$isLastChild = ($pos, doc)=>doc.resolve($pos.after()).node().lastChild === $pos.node();
const $384898e2fc47703e$var$isFirstChild = ($pos, doc)=>doc.resolve($pos.before()).node().firstChild === $pos.node();
const $384898e2fc47703e$var$nodeIsInsideAList = (tr)=>{
    const { nodes: nodes } = tr.doc.type.schema;
    return (0, $BmspC.hasParentNodeOfType)([
        nodes.orderedList,
        nodes.bulletList
    ])(tr.selection);
};
const $384898e2fc47703e$var$selectionIsInsideAPanel = (tr)=>{
    const { nodes: nodes } = tr.doc.type.schema;
    return (0, $BmspC.hasParentNodeOfType)(nodes.panel)(tr.selection);
};
const $384898e2fc47703e$var$selectionIsInNestedList = (tr)=>{
    const { nodes: nodes } = tr.doc.type.schema;
    const parentListNode = (0, $BmspC.findParentNodeOfType)([
        nodes.orderedList,
        nodes.bulletList
    ])(tr.selection);
    if (!parentListNode) return false;
    return (0, $fCXIH.isListItemNode)(tr.doc.resolve(parentListNode.pos).parent);
};
const $384898e2fc47703e$var$insertBeforeOrAfter = (tr, lookDirection, $parentPos, $proposedPosition, content)=>{
    /**
	 * This block caters for the first item in a parent with the cursor being at the very start
	 * or the last item with the cursor being at the very end
	 *
	 * e.g.
	 * ul
	 *  li {<>}Scenario one
	 *  li
	 *  li Scenario two{<>}
	 */ if ($384898e2fc47703e$var$isFirstChild($proposedPosition, tr.doc) && lookDirection === "before" || $384898e2fc47703e$var$isLastChild($proposedPosition, tr.doc) && lookDirection === "after") return tr.insert($parentPos[lookDirection](), content);
    return tr.insert($proposedPosition[lookDirection](), content);
};
// Ignored via go/ees007
// eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
// FIXME: A more sustainable and configurable way to choose when to split
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $384898e2fc47703e$var$shouldSplit = (nodeType, schemaNodes)=>{
    return [
        schemaNodes.bulletList,
        schemaNodes.orderedList,
        schemaNodes.panel
    ].includes(nodeType);
};
const $384898e2fc47703e$export$5fe92db78385e37c = (content, position)=>(tr)=>{
        const { nodes: nodes } = tr.doc.type.schema;
        const whitelist = [
            nodes.rule,
            nodes.mediaSingle
        ];
        if (content instanceof (0, $3xw6l.Fragment) || !whitelist.includes(content.type)) return null;
        // Check for selection
        if (!tr.selection.empty || (0, $BmspC.isNodeSelection)(tr.selection)) // NOT IMPLEMENTED
        return null;
        const { $from: $from } = tr.selection;
        const $insertPos = position ? tr.doc.resolve(position) : (0, $BmspC.isNodeSelection)(tr.selection) ? tr.doc.resolve($from.pos + 1) : $from;
        let lookDirection;
        const insertPosEnd = $insertPos.end();
        const insertPosStart = $insertPos.start();
        // When parent node is an empty paragraph,
        // check the empty paragraph is the first or last node of its parent.
        if ((0, $5Z3Rm.isEmptyParagraph)($insertPos.parent)) {
            if ($384898e2fc47703e$var$isLastChild($insertPos, tr.doc)) lookDirection = "after";
            else if ($384898e2fc47703e$var$isFirstChild($insertPos, tr.doc)) lookDirection = "before";
        } else {
            if ($insertPos.pos === insertPosEnd) lookDirection = "after";
            else if ($insertPos.pos === insertPosStart) lookDirection = "before";
        }
        const grandParentNodeType = tr.selection.$from.node(-1)?.type;
        const parentNodeType = tr.selection.$from.parent.type;
        // if there is no direction, and cannot split for this particular node
        const noDirectionAndShouldNotSplit = !lookDirection && !$384898e2fc47703e$export$b80431b156693a98({
            parentNodeType: parentNodeType,
            grandParentNodeType: grandParentNodeType,
            content: content
        });
        const ruleNodeInANestedListNode = content.type === nodes.rule && $384898e2fc47703e$var$selectionIsInNestedList(tr);
        const nonRuleNodeInListNode = !(content.type === nodes.rule) && $384898e2fc47703e$var$nodeIsInsideAList(tr);
        if (ruleNodeInANestedListNode || noDirectionAndShouldNotSplit && nonRuleNodeInListNode || noDirectionAndShouldNotSplit && !$384898e2fc47703e$var$nodeIsInsideAList(tr)) // node to be inserted is an invalid child of selection so insert below selected node
        return (0, $BmspC.safeInsert)(content, tr.selection.from)(tr);
        // if node is a rule and that is a flat list splitting and not at the end of a list
        const { from: from, to: to } = tr.selection;
        const ruleTypeInAList = content.type === nodes.rule && $384898e2fc47703e$var$nodeIsInsideAList(tr);
        if (ruleTypeInAList && !($insertPos.pos === insertPosEnd)) return tr.replaceRange(from, to, new (0, $3xw6l.Slice)((0, $3xw6l.Fragment).from(nodes.rule.createChecked()), 0, 0));
        if (!lookDirection) // fallback to consumer for now
        return null;
        // Replace empty paragraph
        if ((0, $5Z3Rm.isEmptyParagraph)($insertPos.parent) && (0, $BmspC.canInsert)(tr.doc.resolve($insertPos[lookDirection]()), content)) return $384898e2fc47703e$var$finaliseInsert(tr.replaceWith($insertPos.before(), $insertPos.after(), content), -1);
        let $proposedPosition = $insertPos;
        while($proposedPosition.depth > 0){
            const $parentPos = tr.doc.resolve($proposedPosition[lookDirection]());
            const parentNode = $parentPos.node();
            // Insert at position (before or after target pos)
            if ((0, $BmspC.canInsert)($proposedPosition, content)) return $384898e2fc47703e$var$finaliseInsert(tr.insert($proposedPosition.pos, content), content.nodeSize);
            // If we can't insert, and we think we should split, we fallback to consumer for now
            if ($384898e2fc47703e$var$shouldSplit(parentNode.type, tr.doc.type.schema.nodes)) {
                const nextTr = $384898e2fc47703e$var$finaliseInsert($384898e2fc47703e$var$insertBeforeOrAfter(tr, lookDirection, $parentPos, $proposedPosition, content), content.nodeSize);
                // Move selection to the closest text node, otherwise it defaults to the whatever the lookDirection is set to above
                if ([
                    nodes.orderedList,
                    nodes.bulletList
                ].includes(parentNode.type) && nextTr) return nextTr.setSelection((0, $3lIcL.TextSelection).between(nextTr.selection.$from, nextTr.selection.$from));
                else return nextTr;
            }
            // Can not insert into current parent, step up one parent
            $proposedPosition = $parentPos;
        }
        return $384898e2fc47703e$var$finaliseInsert(tr.insert($proposedPosition.pos, content), content.nodeSize);
    };
const $384898e2fc47703e$var$finaliseInsert = (tr, nodeLength)=>{
    const lastStep = tr.steps[tr.steps.length - 1];
    if (!(lastStep instanceof (0, $lzEKq.ReplaceStep) || lastStep instanceof (0, $lzEKq.ReplaceAroundStep))) return null;
    // Place gap cursor after the newly inserted node
    const gapCursorPos = lastStep.to + lastStep.slice.openStart + nodeLength;
    return tr.setSelection(new (0, $6BNUN.GapCursorSelection)(tr.doc.resolve(gapCursorPos), (0, $6BNUN.Side).RIGHT)).scrollIntoView();
};
const $384898e2fc47703e$export$e3c00faab58641c5 = (maybeNode, opts = {})=>(state, tr, start)=>{
        if (!maybeNode) return tr;
        const isInputFragment = maybeNode instanceof (0, $3xw6l.Fragment);
        let node;
        try {
            node = maybeNode instanceof (0, $3xw6l.Node) || isInputFragment ? maybeNode : typeof maybeNode === 'string' ? state.schema.text(maybeNode) : (0, $3xw6l.Node).fromJSON(state.schema, maybeNode);
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
            return tr;
        }
        if (node instanceof (0, $3xw6l.Node) && node.isText) tr = tr.replaceWith(start, start, node);
        else if (node instanceof (0, $3xw6l.Node) && node.isBlock) {
            /**
			 *
			 * Rule has unique insertion behaviour
			 * so using this safeInsert function in order to handle specific cases in flat list vs nested list
			 * instead of a generic pmSafeInsert (i.e appending at the end)
			 *
			 */ const selectionInsideAPanel = $384898e2fc47703e$var$selectionIsInsideAPanel(tr);
            if (node.type.name === 'rule' && !selectionInsideAPanel && // ED-17438 If the selection is not an empty paragraph we want to use pmSafeInsert
            // This fixes a bug where if a rule was inserted using safeInsert and the selection
            // was an empty paragraph it would not be inserted
            !(0, $5Z3Rm.isEmptyParagraph)(tr.selection.$from.parent)) tr = $384898e2fc47703e$export$5fe92db78385e37c(node, tr.selection.from)(tr) ?? tr;
            else tr = (0, $BmspC.safeInsert)($384898e2fc47703e$export$9a3d0d2a50538e52(state, node), undefined, true)(tr);
        /**
			 *
			 * Replacing a type ahead query mark with an inline node.
			 *
			 */ } else if (node instanceof (0, $3xw6l.Node) && node.isInline || isInputFragment) {
            const fragment = isInputFragment ? node : (0, $3xw6l.Fragment).fromArray([
                node,
                state.schema.text(' ')
            ]);
            tr = tr.replaceWith(start, start, fragment);
            if (opts.selectInlineNode) // Select inserted node
            tr = tr.setSelection((0, $3lIcL.NodeSelection).create(tr.doc, start));
            else // Placing cursor after node + space.
            tr = tr.setSelection((0, $3lIcL.Selection).near(tr.doc.resolve(start + fragment.size)));
        }
        return tr;
    };
const $384898e2fc47703e$export$b80431b156693a98 = ({ parentNodeType: parentNodeType, grandParentNodeType: grandParentNodeType, content: content })=>{
    if (parentNodeType.name === 'doc' || parentNodeType.name === 'paragraph' && grandParentNodeType.validContent((0, $3xw6l.Fragment).from(content))) return true;
    return false;
};
function $384898e2fc47703e$export$b6980e4b8ea578a5(state) {
    const { $from: $from, $to: $to } = state.selection;
    let isAllowedChild = true;
    state.doc.nodesBetween($from.pos, $to.pos, (node, pos)=>{
        const withinSelection = $from.pos <= pos && pos + node.nodeSize <= $to.pos;
        if (!withinSelection) return;
        if (!isAllowedChild) return false;
        return isAllowedChild = node.type === state.schema.nodes.listItem || node.type === state.schema.nodes.bulletList || node.type === state.schema.nodes.orderedList || node.type === state.schema.nodes.paragraph || node.isInline || node.type === state.schema.nodes.panel || node.isText;
    });
    return isAllowedChild;
}
function $384898e2fc47703e$export$2b1594c8921b5b2e(fragment, nodeType) {
    let doesContainNodeType = false;
    fragment.descendants((node)=>{
        if (node.type === nodeType) {
            doesContainNodeType = true;
            // Stop looking
            return false;
        }
        return true;
    });
    return doesContainNodeType;
}

});



parcelRegister("PKsUR", function(module, exports) {

$parcel$export(module.exports, "openTypeAheadAtCursor", () => $98ba95404114ccbe$export$e7ce737179b76875);

var $6BNUN = parcelRequire("6BNUN");

var $3lIcL = parcelRequire("3lIcL");

var $ckKJp = parcelRequire("ckKJp");

var $kPuXt = parcelRequire("kPuXt");
const $98ba95404114ccbe$export$adbec20dbbf15a6b = (props)=>(tr)=>{
        const { triggerHandler: triggerHandler, inputMethod: inputMethod, query: query, removePrefixTriggerOnCancel: removePrefixTriggerOnCancel } = props;
        tr.setMeta((0, $kPuXt.pluginKey), {
            action: (0, $ckKJp.ACTIONS).OPEN_TYPEAHEAD_AT_CURSOR,
            params: {
                triggerHandler: triggerHandler,
                inputMethod: inputMethod,
                query: query,
                removePrefixTriggerOnCancel: removePrefixTriggerOnCancel
            }
        });
    };
const $98ba95404114ccbe$export$e7ce737179b76875 = ({ triggerHandler: triggerHandler, inputMethod: inputMethod, query: query, removePrefixTriggerOnCancel: removePrefixTriggerOnCancel })=>({ tr: tr })=>{
        $98ba95404114ccbe$export$adbec20dbbf15a6b({
            triggerHandler: triggerHandler,
            inputMethod: inputMethod,
            query: query,
            removePrefixTriggerOnCancel: removePrefixTriggerOnCancel
        })(tr);
        const { selection: selection } = tr;
        const isInline = selection instanceof (0, $3lIcL.NodeSelection) && selection.node.type.isInline;
        if (!(selection instanceof (0, $3lIcL.TextSelection) || selection instanceof (0, $6BNUN.GapCursorSelection) || selection instanceof (0, $3lIcL.NodeSelection))) return tr;
        if (selection instanceof (0, $6BNUN.GapCursorSelection)) {
            // Create space for the typeahead menu in gap cursor
            tr.insertText(' ');
            // delete 1 pos before wherever selection is now - that will delete the empty space
            tr.delete(tr.selection.from - 1, tr.selection.from);
        } else {
            if (selection instanceof (0, $3lIcL.NodeSelection)) {
                if (isInline) {
                    tr.deleteSelection();
                    return tr;
                }
                return tr;
            }
            if (!selection.$cursor) {
                tr.deleteSelection();
                return tr;
            }
            // Search & Destroy placeholder
            const cursorPos = selection.$cursor.pos;
            const nodeAtCursor = tr.doc.nodeAt(cursorPos);
            const isPlaceholderAtCursorPosition = nodeAtCursor && nodeAtCursor.type.name === 'placeholder';
            if (nodeAtCursor && isPlaceholderAtCursorPosition) tr.delete(cursorPos, cursorPos + nodeAtCursor.nodeSize);
            // ME-2375 remove the superfluous '@' inserted before decoration
            // by composition (https://github.com/ProseMirror/prosemirror/issues/903)
            //
            // Update:
            // Now also handles any use case with superfluous typeahead triggers (ie. '@', ':', '/')
            // being inserted due to composition by checking if we have the trigger
            // directly before the typeahead. This should not happen unless it has
            // been eroneously added because we require whitespace/newline for typeahead.
            if (cursorPos >= 2 && !!selection?.$head?.parent?.textContent && selection.$head.parent.textContent.endsWith?.(triggerHandler.trigger)) tr.delete(cursorPos - 1, cursorPos);
        }
        return tr;
    };

});

parcelRegister("2NBlM", function(module, exports) {

$parcel$export(module.exports, "inputRulePlugin", () => $269e188109c30278$export$568a7ed6897c4817);

var $bMFKb = parcelRequire("bMFKb");

var $i8KtF = parcelRequire("i8KtF");

var $leZY6 = parcelRequire("leZY6");

var $jCfsG = parcelRequire("jCfsG");

var $PKsUR = parcelRequire("PKsUR");
function $269e188109c30278$export$568a7ed6897c4817(schema, typeAheads, featureFlags) {
    if (!typeAheads || typeAheads.length === 0) return;
    const rules = typeAheads.reduce((acc, typeAhead)=>{
        const trigger = typeAhead.customRegex || typeAhead.trigger;
        if (!trigger) return acc;
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        const regex = new RegExp(`(^|[.!?\\s${(0, $feddda005efaf7df$export$a96b909f1510512b)}])(${trigger})$`);
        acc.push((0, $leZY6.createRule)(regex, (state, match)=>{
            return (0, $PKsUR.openTypeAheadAtCursor)({
                triggerHandler: typeAhead,
                inputMethod: (0, $bMFKb.INPUT_METHOD).KEYBOARD
            })({
                tr: state.tr
            });
        }));
        return acc;
    }, []);
    const plugin = new (0, $i8KtF.SafePlugin)((0, $jCfsG.createPlugin)('type-ahead', rules, {
        allowInsertTextOnDocument: false
    }));
    return plugin;
}
var $269e188109c30278$export$2e2bcd8739ae039 = $269e188109c30278$export$568a7ed6897c4817;

});

parcelRegister("3ATVn", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $6333d97ddf57772c$export$ae829ec7b2625219);

var $i8KtF = parcelRequire("i8KtF");

var $ckKJp = parcelRequire("ckKJp");

var $guQP2 = parcelRequire("guQP2");
function $6333d97ddf57772c$export$ae829ec7b2625219() {
    return new (0, $i8KtF.SafePlugin)({
        appendTransaction (transactions, _oldState, newState) {
            const insertItemCallback = (0, $guQP2.isInsertionTransaction)(transactions, (0, $ckKJp.ACTIONS).INSERT_ITEM);
            if (insertItemCallback) {
                const tr = insertItemCallback(newState);
                if (tr) return tr;
            }
        }
    });
}

});
parcelRegister("guQP2", function(module, exports) {

$parcel$export(module.exports, "isInsertionTransaction", () => $bbcd41ccec1baf9f$export$e715282b081c154e);

var $kPuXt = parcelRequire("kPuXt");
const $bbcd41ccec1baf9f$export$e715282b081c154e = (transactions, action)=>{
    const tr = transactions.find((tr)=>tr.getMeta((0, $kPuXt.pluginKey))?.action === action);
    if (!tr) return null;
    return tr.getMeta((0, $kPuXt.pluginKey))?.params;
};

});


parcelRegister("kGFcc", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $7134c4fdfa61f393$export$ae829ec7b2625219);

var $3YJ2y = parcelRequire("3YJ2y");

var $i8KtF = parcelRequire("i8KtF");

var $7SIsS = parcelRequire("7SIsS");

var $b7EWj = parcelRequire("b7EWj");

var $eGOwo = parcelRequire("eGOwo");

var $ckKJp = parcelRequire("ckKJp");

var $eQTrE = parcelRequire("eQTrE");

var $8IPtW = parcelRequire("8IPtW");

var $guQP2 = parcelRequire("guQP2");

var $kPuXt = parcelRequire("kPuXt");

var $ln6bC = parcelRequire("ln6bC");
const $7134c4fdfa61f393$var$hasValidTypeAheadStep = (tr)=>{
    const steps = tr.steps.filter((step)=>step instanceof (0, $3YJ2y.InsertTypeAheadStep));
    // There are some cases, like collab rebase, where the steps are re-applied
    // We should not re open the type-ahead for those cases
    if (steps.length === 1) return steps[0];
    return null;
};
function $7134c4fdfa61f393$export$ae829ec7b2625219({ reactDispatch: reactDispatch, popupMountRef: popupMountRef, typeAheadHandlers: typeAheadHandlers, getIntl: getIntl, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI, api: api }) {
    const intl = getIntl();
    const { createDecorations: createDecorations, removeDecorations: removeDecorations } = (0, $8IPtW.factoryDecorations)({
        intl: intl,
        nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
        popupMountRef: popupMountRef,
        api: api
    });
    const reducer = (0, $ln6bC.createReducer)({
        createDecorations: createDecorations,
        removeDecorations: removeDecorations,
        typeAheadHandlers: typeAheadHandlers,
        popupMountRef: popupMountRef
    });
    return new (0, $i8KtF.SafePlugin)({
        key: (0, $kPuXt.pluginKey),
        state: {
            init () {
                return {
                    typeAheadHandlers: typeAheadHandlers,
                    query: '',
                    decorationSet: (0, $b7EWj.DecorationSet).empty,
                    decorationElement: null,
                    items: [],
                    errorInfo: null,
                    selectedIndex: -1,
                    stats: null,
                    inputMethod: null,
                    removePrefixTriggerOnCancel: undefined
                };
            },
            apply (tr, currentPluginState, oldEditorState, state) {
                const customStep = $7134c4fdfa61f393$var$hasValidTypeAheadStep(tr);
                const nextPluginState = reducer(tr, currentPluginState, customStep);
                if (currentPluginState !== nextPluginState) reactDispatch((0, $kPuXt.pluginKey), nextPluginState);
                return nextPluginState;
            }
        },
        appendTransaction (transactions, _oldState, newState) {
            const insertItemCallback = (0, $guQP2.isInsertionTransaction)(transactions, (0, $ckKJp.ACTIONS).INSERT_RAW_QUERY);
            if (insertItemCallback) {
                const tr = insertItemCallback(newState);
                if (tr) {
                    if ((0, $eGOwo.fg)('platform_editor_ease_of_use_metrics')) api?.metrics?.commands.startActiveSessionTimer()({
                        tr: tr
                    });
                    return tr;
                }
            }
        },
        view () {
            return {
                update (editorView) {}
            };
        },
        props: {
            decorations: (state)=>{
                return (0, $kPuXt.pluginKey).getState(state)?.decorationSet;
            },
            handleDOMEvents: {
                compositionend: (view, event)=>{
                    return false;
                },
                click: (view, event)=>{
                    const { target: target } = event;
                    // ProseMirror view listen to any click event inside of it
                    // When this event is coming from the typeahead
                    // we should tell to ProseMirror to sit down and relax
                    // cuz we know what we are doing (I hope)
                    if (target instanceof HTMLElement && (0, $7SIsS.closest)(target, `[data-type-ahead=${(0, $eQTrE.TYPE_AHEAD_DECORATION_DATA_ATTRIBUTE)}]`)) return true;
                    return false;
                }
            }
        }
    });
}

});
parcelRegister("eQTrE", function(module, exports) {

$parcel$export(module.exports, "TYPE_AHEAD_DECORATION_KEY", () => $ba23b5b1eaa1f638$export$65dc1d975bd3407b);
$parcel$export(module.exports, "TYPE_AHEAD_DECORATION_DATA_ATTRIBUTE", () => $ba23b5b1eaa1f638$export$be8a8259777b339f);
$parcel$export(module.exports, "TYPE_AHEAD_POPUP_CONTENT_CLASS", () => $ba23b5b1eaa1f638$export$a5cdf6890cae94d6);
$parcel$export(module.exports, "TYPE_AHEAD_DECORATION_ELEMENT_ID", () => $ba23b5b1eaa1f638$export$a38374e9651d6165);
$parcel$export(module.exports, "CloseSelectionOptions", () => $ba23b5b1eaa1f638$export$fc2dc87cf13c1ab1);
const $ba23b5b1eaa1f638$export$65dc1d975bd3407b = 'typeahead_decoration_key';
const $ba23b5b1eaa1f638$export$be8a8259777b339f = 'typeaheadDecoration';
const $ba23b5b1eaa1f638$export$a5cdf6890cae94d6 = 'fabric-editor-typeahead';
const $ba23b5b1eaa1f638$export$a38374e9651d6165 = 'typeahaed_decoration_element_id';
var $ba23b5b1eaa1f638$export$fc2dc87cf13c1ab1 = /*#__PURE__*/ function(CloseSelectionOptions) {
    CloseSelectionOptions["BEFORE_TEXT_INSERTED"] = "BEFORE_TEXT_INSERTED";
    CloseSelectionOptions["AFTER_TEXT_INSERTED"] = "AFTER_TEXT_INSERTED";
    return CloseSelectionOptions;
}({});

});

parcelRegister("8IPtW", function(module, exports) {

$parcel$export(module.exports, "factoryDecorations", () => $3d796e5e1d3db3b5$export$116b677c5744e397);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $4nehu = parcelRequire("4nehu");

var $aXKmr = parcelRequire("aXKmr");

var $1rXzn = parcelRequire("1rXzn");

var $kuxd1 = parcelRequire("kuxd1");

var $3lIcL = parcelRequire("3lIcL");

var $b7EWj = parcelRequire("b7EWj");

var $eGOwo = parcelRequire("eGOwo");


var $1c5dC = parcelRequire("1c5dC");

var $azYbd = parcelRequire("azYbd");

var $eQTrE = parcelRequire("eQTrE");

var $akqoF = parcelRequire("akqoF");

var $elKSH = parcelRequire("elKSH");
const $3d796e5e1d3db3b5$export$116b677c5744e397 = ({ intl: intl, popupMountRef: popupMountRef, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI, api: api })=>{
    const createDecorations = (tr, { triggerHandler: triggerHandler, inputMethod: inputMethod, reopenQuery: reopenQuery })=>{
        const { selection: selection } = tr;
        if (!(selection instanceof (0, $3lIcL.TextSelection)) || !selection.$cursor) return {
            decorationSet: (0, $b7EWj.DecorationSet).empty,
            stats: null,
            decorationElement: null
        };
        const decorationId = `decoration_id_${(0, $eQTrE.TYPE_AHEAD_DECORATION_KEY)}_${(0, (/*@__PURE__*/$parcel$interopDefault($aXKmr)))()}`;
        const { $cursor: $cursor } = selection;
        const typeaheadComponent = document.createElement('mark');
        const stats = new (0, $akqoF.StatsModifier)();
        let shouldFocusCursorInsideQuery = true;
        const deco = (0, $b7EWj.Decoration).widget($cursor.pos, (editorView, getDecorationPositionUnsafe)=>{
            const getDecorationPosition = ()=>{
                try {
                    return getDecorationPositionUnsafe();
                } catch (e) {
                    return undefined;
                }
            };
            typeaheadComponent.setAttribute('id', decorationId);
            typeaheadComponent.setAttribute('role', 'search');
            typeaheadComponent.dataset.typeAheadQuery = 'true';
            typeaheadComponent.dataset.trigger = triggerHandler.trigger;
            // This line below seems weird,
            // we need that cuz the clickAreaHelper
            // will try to hijack any click event coming
            // from the inside of the Editor
            // packages/editor/editor-core/src/ui/Addon/click-area-helper.ts
            typeaheadComponent.dataset.editorPopup = 'true';
            typeaheadComponent.dataset.typeAhead = (0, $eQTrE.TYPE_AHEAD_DECORATION_DATA_ATTRIBUTE);
            typeaheadComponent.style.color = `var(--ds-text-accent-blue, ${0, $7bb4c1736002a04a$export$b3de0ae08da2ce64})`;
            typeaheadComponent.style.backgroundColor = 'transparent';
            const onUndoRedo = (inputType)=>{
                if (![
                    'historyUndo',
                    'historyRedo'
                ].includes(inputType)) return false;
                const hasReopenQuery = typeof reopenQuery === 'string' && reopenQuery.trim().length > 0;
                const currentQuery = (0, $elKSH.getTypeAheadQuery)(editorView.state);
                if (hasReopenQuery || currentQuery?.length === 0) {
                    const command = inputType === 'historyUndo' ? (0, $kuxd1.undo) : (0, $kuxd1.redo);
                    let tr = editorView.state.tr;
                    const fakeDispatch = (customTr)=>{
                        tr = customTr;
                    };
                    const result = command(editorView.state, fakeDispatch);
                    if (result) {
                        (0, $azYbd.closeTypeAhead)(tr);
                        editorView.dispatch(tr);
                        editorView.focus();
                    }
                    return result;
                }
                return false;
            };
            nodeViewPortalProviderAPI.render(()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $4nehu.default), {
                    defaultLocale: intl.defaultLocale || 'en-US',
                    locale: intl.locale || 'en-US',
                    messages: intl.messages,
                    formats: intl.formats,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1c5dC.WrapperTypeAhead), {
                        triggerHandler: triggerHandler,
                        editorView: editorView,
                        anchorElement: typeaheadComponent,
                        inputMethod: inputMethod,
                        getDecorationPosition: getDecorationPosition,
                        shouldFocusCursorInsideQuery: shouldFocusCursorInsideQuery,
                        popupsMountPoint: popupMountRef.current?.popupsMountPoint,
                        popupsBoundariesElement: popupMountRef.current?.popupsBoundariesElement,
                        popupsScrollableElement: popupMountRef.current?.popupsScrollableElement,
                        onUndoRedo: onUndoRedo,
                        reopenQuery: reopenQuery,
                        api: api
                    })
                }), typeaheadComponent, decorationId);
            shouldFocusCursorInsideQuery = false;
            return typeaheadComponent;
        }, {
            isTypeAheadDecoration: true,
            key: decorationId,
            side: 0,
            stopEvent: (e)=>{
                const key = (0, $1rXzn.keyName)(e);
                const sel = document.getSelection();
                if ('ArrowLeft' === key && sel?.anchorOffset === 0) return false;
                return true;
            },
            ignoreSelection: false
        });
        return {
            decorationSet: (0, $b7EWj.DecorationSet).create(tr.doc, [
                deco
            ]),
            decorationElement: typeaheadComponent,
            stats: stats
        };
    };
    const removeDecorations = (decorationSet)=>{
        if (!decorationSet || decorationSet === (0, $b7EWj.DecorationSet).empty) return false;
        const typeAheadDecorations = decorationSet.find(undefined, undefined, (spec)=>{
            return spec.isTypeAheadDecoration;
        });
        if (!typeAheadDecorations || typeAheadDecorations.length === 0) return false;
        typeAheadDecorations.forEach(({ spec: spec })=>{
            if (!spec.key) return;
            const decoElement = document.querySelector(`#${spec.key}`);
            if (!decoElement) return;
            nodeViewPortalProviderAPI.remove(spec.key);
        });
        if ((0, $eGOwo.fg)('platform_editor_ease_of_use_metrics')) api?.core.actions.execute(api?.metrics?.commands.startActiveSessionTimer());
        return true;
    };
    return {
        createDecorations: createDecorations,
        removeDecorations: removeDecorations
    };
};

});
parcelRegister("1c5dC", function(module, exports) {

$parcel$export(module.exports, "WrapperTypeAhead", () => $ee5d0ebf046b4732$export$970faf6afe0d9376);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $bMFKb = parcelRequire("bMFKb");

var $7k8dr = parcelRequire("7k8dr");

var $eGOwo = parcelRequire("eGOwo");

var $92xoS = parcelRequire("92xoS");

var $2FODv = parcelRequire("2FODv");

var $8YhWI = parcelRequire("8YhWI");

var $gclLy = parcelRequire("gclLy");

var $elKSH = parcelRequire("elKSH");

var $l9ZHZ = parcelRequire("l9ZHZ");

var $3dFNR = parcelRequire("3dFNR");

var $ef4z4 = parcelRequire("ef4z4");

var $9nAiS = parcelRequire("9nAiS");
const $ee5d0ebf046b4732$export$970faf6afe0d9376 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo(({ triggerHandler: triggerHandler, editorView: editorView, anchorElement: anchorElement, shouldFocusCursorInsideQuery: shouldFocusCursorInsideQuery, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, inputMethod: inputMethod, getDecorationPosition: getDecorationPosition, reopenQuery: reopenQuery, onUndoRedo: onUndoRedo, api: api })=>{
    // @ts-ignore
    const openElementBrowserModal = triggerHandler?.openElementBrowserModal;
    let showMoreOptionsButton = false;
    if ((0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1')) showMoreOptionsButton = !!triggerHandler?.getMoreOptionsButtonConfig;
    const [closed, setClosed] = (0, $eJOHy.useState)(false);
    const [query, setQuery] = (0, $eJOHy.useState)(reopenQuery || '');
    const queryRef = (0, $eJOHy.useRef)(query);
    const editorViewRef = (0, $eJOHy.useRef)(editorView);
    const items = (0, $3dFNR.useLoadItems)(triggerHandler, editorView, query, showMoreOptionsButton, api);
    (0, $eJOHy.useEffect)(()=>{
        if (!closed && (0, $eGOwo.fg)('platform_editor_ease_of_use_metrics')) api?.core.actions.execute(api?.metrics?.commands.handleIntentToStartEdit({
            shouldStartTimer: false,
            shouldPersistActiveSession: true
        }));
    }, [
        closed,
        api
    ]);
    (0, $eJOHy.useLayoutEffect)(()=>{
        queryRef.current = query;
    }, [
        query
    ]);
    const [onItemInsert, onTextInsert] = (0, $l9ZHZ.useItemInsert)(triggerHandler, editorView, items, api);
    const selectNextItem = (0, $eJOHy.useMemo)(()=>(0, $elKSH.moveSelectedIndex)({
            editorView: editorView,
            direction: 'next',
            api: api
        }), [
        editorView,
        api
    ]);
    const selectPreviousItem = (0, $eJOHy.useMemo)(()=>(0, $elKSH.moveSelectedIndex)({
            editorView: editorView,
            direction: 'previous',
            api: api
        }), [
        editorView,
        api
    ]);
    const cancel = (0, $eJOHy.useCallback)(({ setSelectionAt: setSelectionAt, addPrefixTrigger: addPrefixTrigger, text: text, forceFocusOnEditor: forceFocusOnEditor })=>{
        if ((0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1')) (0, $2FODv.fireTypeAheadClosedAnalyticsEvent)(api, (0, $bMFKb.ACTION).CANCELLED, !!queryRef.current, (0, $bMFKb.INPUT_METHOD).KEYBOARD, (0, $elKSH.getPluginState)(editorView.state)?.inputMethod);
        setClosed(true);
        const fullquery = addPrefixTrigger ? `${triggerHandler.trigger}${text}` : text;
        onTextInsert({
            forceFocusOnEditor: forceFocusOnEditor,
            setSelectionAt: setSelectionAt,
            text: fullquery
        });
    }, [
        triggerHandler.trigger,
        onTextInsert,
        api,
        editorView.state
    ]);
    const insertSelectedItem = (0, $eJOHy.useCallback)((mode = (0, $7k8dr.SelectItemMode).SELECTED)=>{
        const { current: view } = editorViewRef;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const { selectedIndex: selectedIndex } = (0, $elKSH.getPluginState)(view.state);
        const safeSelectedIndex = (0, $elKSH.skipForwardToSafeItem)({
            currentIndex: selectedIndex,
            nextIndex: 1,
            listSize: items.length,
            itemIsDisabled: (idx)=>(0, $gclLy.itemIsDisabled)(items[idx], api)
        });
        // If the only safe index is -1 then none are safe - do not insert item
        if (safeSelectedIndex === -1) return;
        if ((0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1')) (0, $2FODv.fireTypeAheadClosedAnalyticsEvent)(api, (0, $bMFKb.ACTION).INSERTED, !!queryRef.current, (0, $bMFKb.INPUT_METHOD).KEYBOARD, (0, $elKSH.getPluginState)(editorView.state)?.inputMethod);
        setClosed(true);
        queueMicrotask(()=>{
            onItemInsert({
                mode: mode,
                index: selectedIndex,
                query: queryRef.current
            });
        });
    }, [
        items,
        api,
        editorView.state,
        onItemInsert
    ]);
    const showTypeAheadPopupList = (0, $eJOHy.useCallback)(()=>{}, []);
    const closePopup = (0, $eJOHy.useCallback)(()=>{
        setClosed(true);
    }, []);
    (0, $eJOHy.useEffect)(()=>{
        const { current: view } = editorViewRef;
        const pluginState = (0, $elKSH.getPluginState)(view.state);
        if (query.length === 0 || query === pluginState?.query || !pluginState?.triggerHandler) return;
        (0, $8YhWI.updateQuery)(query)(view.state, view.dispatch);
    }, [
        query,
        reopenQuery
    ]);
    (0, $ef4z4.useOnForceSelect)({
        triggerHandler: triggerHandler,
        items: items,
        query: query,
        editorView: editorView,
        closePopup: closePopup
    });
    if (closed) return null;
    if (!triggerHandler) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $9nAiS.InputQuery), {
        triggerQueryPrefix: triggerHandler?.trigger,
        onQueryChange: setQuery,
        onItemSelect: insertSelectedItem,
        selectNextItem: selectNextItem,
        selectPreviousItem: selectPreviousItem,
        onQueryFocus: showTypeAheadPopupList,
        cancel: cancel,
        forceFocus: shouldFocusCursorInsideQuery,
        onUndoRedo: onUndoRedo,
        reopenQuery: reopenQuery,
        editorView: editorView,
        items: items
    });
});
$ee5d0ebf046b4732$export$970faf6afe0d9376.displayName = 'WrapperTypeAhead';

});
parcelRegister("2FODv", function(module, exports) {

$parcel$export(module.exports, "fireTypeAheadClosedAnalyticsEvent", () => $bcb6305ac1f091ff$export$4a6068dadc2c7771);

var $bMFKb = parcelRequire("bMFKb");
const $bcb6305ac1f091ff$export$4a6068dadc2c7771 = (api, closeAction, hasQuery, inputMethod, invocationMethod = null)=>{
    api?.analytics?.actions.fireAnalyticsEvent({
        action: (0, $bMFKb.ACTION).CLOSED,
        actionSubject: (0, $bMFKb.ACTION_SUBJECT).TYPEAHEAD,
        actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).TYPEAHEAD_QUICK_INSERT,
        attributes: {
            inputMethod: inputMethod,
            closeAction: closeAction,
            hasQuery: hasQuery,
            invocationMethod: invocationMethod
        },
        eventType: (0, $bMFKb.EVENT_TYPE).TRACK
    });
};

});

parcelRegister("8YhWI", function(module, exports) {

$parcel$export(module.exports, "updateQuery", () => $3e4d76c2d243fd19$export$4d1bf8b2f67bcb1);

var $ckKJp = parcelRequire("ckKJp");

var $kPuXt = parcelRequire("kPuXt");
const $3e4d76c2d243fd19$export$4d1bf8b2f67bcb1 = (query)=>{
    return (state, dispatch)=>{
        const pluginState = (0, $kPuXt.pluginKey).getState(state);
        if (pluginState?.query === query) return false;
        const tr = state.tr;
        tr.setMeta((0, $kPuXt.pluginKey), {
            action: (0, $ckKJp.ACTIONS).CHANGE_QUERY,
            params: {
                query: query
            }
        });
        if (dispatch) dispatch(tr);
        return true;
    };
};

});

parcelRegister("l9ZHZ", function(module, exports) {

$parcel$export(module.exports, "useItemInsert", () => $582391ca569d663d$export$3a3385069392b26f);

var $eJOHy = parcelRequire("eJOHy");

var $7k8dr = parcelRequire("7k8dr");

var $eGOwo = parcelRequire("eGOwo");

var $azYbd = parcelRequire("azYbd");

var $cg71Z = parcelRequire("cg71Z");

var $gvgnX = parcelRequire("gvgnX");

var $eQTrE = parcelRequire("eQTrE");

var $gclLy = parcelRequire("gclLy");
const $582391ca569d663d$var$onlyHasViewMoreItem = (items)=>items.at(0)?.title === 'View more';
const $582391ca569d663d$var$insertRawQuery = ({ view: view, setSelectionAt: setSelectionAt, text: text, forceFocusOnEditor: forceFocusOnEditor })=>{
    const { tr: tr, schema: schema } = view.state;
    (0, $azYbd.closeTypeAhead)(tr);
    if (text.length > 0) {
        tr.replaceSelectionWith(schema.text(text));
        if (setSelectionAt === (0, $eQTrE.CloseSelectionOptions).BEFORE_TEXT_INSERTED) (0, $gvgnX.setSelectionBeforeQuery)(text)(tr);
    }
    view.dispatch(tr);
    if (forceFocusOnEditor) view.focus();
};
const $582391ca569d663d$export$3a3385069392b26f = (triggerHandler, editorView, items, api)=>{
    const editorViewRef = (0, $eJOHy.useRef)(editorView);
    const itemsRef = (0, $eJOHy.useRef)(items);
    const onTextInsert = (0, $eJOHy.useCallback)(({ setSelectionAt: setSelectionAt, text: text, forceFocusOnEditor: forceFocusOnEditor })=>{
        if (!triggerHandler) return;
        const { current: view } = editorViewRef;
        $582391ca569d663d$var$insertRawQuery({
            view: view,
            setSelectionAt: setSelectionAt,
            text: text,
            forceFocusOnEditor: forceFocusOnEditor
        });
    }, [
        triggerHandler
    ]);
    const onItemInsert = (0, $eJOHy.useCallback)(({ mode: mode, index: index, query: query })=>{
        const sourceListItem = itemsRef.current;
        if (sourceListItem.length === 0 || !triggerHandler || // View more item is only added for keyboard navigation and should not be considered as a valid item to be inserted
        $582391ca569d663d$var$onlyHasViewMoreItem(sourceListItem) && (0, $eGOwo.fg)('platform_editor_controls_patch_13')) {
            const text = `${triggerHandler.trigger}${query}`;
            onTextInsert({
                forceFocusOnEditor: true,
                setSelectionAt: (0, $eQTrE.CloseSelectionOptions).AFTER_TEXT_INSERTED,
                text: text
            });
            return;
        }
        const itemToInsert = sourceListItem[index];
        if (!itemToInsert) return;
        const isDisabled = (0, $gclLy.itemIsDisabled)(itemToInsert, api);
        if (isDisabled) return;
        const { current: view } = editorViewRef;
        (0, $cg71Z.insertTypeAheadItem)(view)({
            item: itemToInsert,
            handler: triggerHandler,
            mode: mode,
            query: query,
            sourceListItem: sourceListItem
        });
    }, [
        triggerHandler,
        onTextInsert,
        api
    ]);
    const onItemMatch = (0, $eJOHy.useCallback)(({ mode: mode, query: query })=>{
        const _items = itemsRef.current;
        if (_items && _items.length > 1) return false;
        if (_items.length === 1 && // View more item is only added for keyboard navigation and should not be considered as a valid item to be inserted
        (!$582391ca569d663d$var$onlyHasViewMoreItem(_items) || !(0, $eGOwo.fg)('platform_editor_controls_patch_13'))) queueMicrotask(()=>{
            onItemInsert({
                mode: mode,
                query: query,
                index: 0
            });
        });
        else {
            const text = `${triggerHandler.trigger}${query}`;
            queueMicrotask(()=>{
                onTextInsert({
                    forceFocusOnEditor: true,
                    setSelectionAt: (0, $eQTrE.CloseSelectionOptions).AFTER_TEXT_INSERTED,
                    text: mode === (0, $7k8dr.SelectItemMode).SPACE ? text.concat(' ') : text
                });
            });
        }
        return true;
    }, [
        onItemInsert,
        triggerHandler,
        onTextInsert
    ]);
    (0, $eJOHy.useLayoutEffect)(()=>{
        itemsRef.current = items;
    }, [
        items
    ]);
    return [
        onItemInsert,
        onTextInsert,
        onItemMatch
    ];
};

});
parcelRegister("gvgnX", function(module, exports) {

$parcel$export(module.exports, "setSelectionBeforeQuery", () => $bd14cdb8e4324b21$export$5af11333ab9d7643);

var $3lIcL = parcelRequire("3lIcL");
const $bd14cdb8e4324b21$export$5af11333ab9d7643 = (rawText)=>(tr)=>{
        const currentPosition = tr.selection.$from.pos;
        const positionBeforeRawText = Math.max(currentPosition - rawText.length, 0);
        const resolvedPositionBeforeText = tr.doc.resolve(positionBeforeRawText);
        const nextSelection = (0, $3lIcL.TextSelection).findFrom(resolvedPositionBeforeText, -1, true);
        if (nextSelection) tr.setSelection(nextSelection);
    };

});


parcelRegister("3dFNR", function(module, exports) {

$parcel$export(module.exports, "useLoadItems", () => $2203402fc89469b4$export$36f5628e43bc3fcd);

var $eJOHy = parcelRequire("eJOHy");

var $92xoS = parcelRequire("92xoS");

var $97PVA = parcelRequire("97PVA");

var $hRexy = parcelRequire("hRexy");

var $7iDjN = parcelRequire("7iDjN");
const $2203402fc89469b4$var$EMPTY_LIST_ITEM = [];
const $2203402fc89469b4$export$36f5628e43bc3fcd = (triggerHandler, editorView, query, showViewMore, api)=>{
    const [items, setItems] = (0, $eJOHy.useState)($2203402fc89469b4$var$EMPTY_LIST_ITEM);
    const componentIsMounted = (0, $eJOHy.useRef)(true);
    const editorViewRef = (0, $eJOHy.useRef)(editorView);
    (0, $eJOHy.useEffect)(()=>{
        const getItems = triggerHandler?.getItems;
        if (!getItems) {
            setItems($2203402fc89469b4$var$EMPTY_LIST_ITEM);
            return;
        }
        const options = {
            query: query || '',
            editorState: editorView.state
        };
        const { current: view } = editorViewRef;
        if ((0, $92xoS.editorExperiment)('platform_editor_offline_editing_web', true)) // Clear any existing error state before making a new request
        queueMicrotask(()=>{
            api?.core.actions.execute((0, $97PVA.clearListError)());
        });
        getItems(options).then((result)=>{
            const list = result.length > 0 ? result : $2203402fc89469b4$var$EMPTY_LIST_ITEM;
            if (componentIsMounted.current) setItems(list);
            // Add a placeholder item for view more button so that it can be traversed with arrow keys
            const viewMoreItem = {
                title: 'View more'
            };
            queueMicrotask(()=>{
                (0, $7iDjN.updateListItem)(showViewMore ? list.concat(viewMoreItem) : list)(view.state, view.dispatch);
            });
        }).catch((e)=>{
            if ((0, $92xoS.editorExperiment)('platform_editor_offline_editing_web', true)) {
                if (e) {
                    if (componentIsMounted.current) setItems($2203402fc89469b4$var$EMPTY_LIST_ITEM);
                    queueMicrotask(()=>{
                        (0, $hRexy.updateListError)(e)(view.state, view.dispatch);
                    });
                }
            }
        });
    // ignore because EditorView is mutable but we don't want to
    // call loadItems when it changes, only when the query changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        triggerHandler,
        query
    ]);
    (0, $eJOHy.useEffect)(()=>{
        return ()=>{
            componentIsMounted.current = false;
        };
    }, []);
    return items;
};

});
parcelRegister("97PVA", function(module, exports) {

$parcel$export(module.exports, "clearListError", () => $7c04a0d45d4226ee$export$265c9044700bb67);

var $ckKJp = parcelRequire("ckKJp");

var $kPuXt = parcelRequire("kPuXt");
const $7c04a0d45d4226ee$export$265c9044700bb67 = ()=>{
    return ({ tr: tr })=>{
        tr.setMeta((0, $kPuXt.pluginKey), {
            action: (0, $ckKJp.ACTIONS).CLEAR_LIST_ERROR,
            params: {
                errorInfo: null
            }
        });
        return tr;
    };
};

});

parcelRegister("hRexy", function(module, exports) {

$parcel$export(module.exports, "updateListError", () => $308020a74a1dbd4a$export$4f4014ebb73e8d41);

var $ckKJp = parcelRequire("ckKJp");

var $kPuXt = parcelRequire("kPuXt");
const $308020a74a1dbd4a$export$4f4014ebb73e8d41 = (errorInfo)=>{
    return (state, dispatch)=>{
        const tr = state.tr;
        tr.setMeta((0, $kPuXt.pluginKey), {
            action: (0, $ckKJp.ACTIONS).UPDATE_LIST_ERROR,
            params: {
                errorInfo: errorInfo,
                items: []
            }
        });
        if (dispatch) dispatch(tr);
        return true;
    };
};

});

parcelRegister("7iDjN", function(module, exports) {

$parcel$export(module.exports, "updateListItem", () => $6c9247b388dd3896$export$e482099e4c227d2);

var $ckKJp = parcelRequire("ckKJp");

var $kPuXt = parcelRequire("kPuXt");
const $6c9247b388dd3896$export$e482099e4c227d2 = (items)=>{
    return (state, dispatch)=>{
        const tr = state.tr;
        tr.setMeta((0, $kPuXt.pluginKey), {
            action: (0, $ckKJp.ACTIONS).UPDATE_LIST_ITEMS,
            params: {
                items: items
            }
        });
        if (dispatch) dispatch(tr);
        return true;
    };
};

});


parcelRegister("ef4z4", function(module, exports) {

$parcel$export(module.exports, "useOnForceSelect", () => $6687075e6e53d9cd$export$4715c10ec9ca9321);

var $eJOHy = parcelRequire("eJOHy");

var $7k8dr = parcelRequire("7k8dr");

var $cg71Z = parcelRequire("cg71Z");
const $6687075e6e53d9cd$export$4715c10ec9ca9321 = ({ triggerHandler: triggerHandler, items: items, query: query, editorView: editorView, closePopup: closePopup })=>{
    const editorViewRef = (0, $eJOHy.useRef)(editorView);
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (!query || typeof triggerHandler.forceSelect !== 'function') return;
        const item = triggerHandler.forceSelect({
            items: items,
            query: query,
            editorState: editorViewRef.current.state
        });
        if (!item) return;
        const { current: view } = editorViewRef;
        closePopup();
        queueMicrotask(()=>{
            (0, $cg71Z.insertTypeAheadItem)(view)({
                item: item,
                mode: (0, $7k8dr.SelectItemMode).SPACE,
                query: query,
                handler: triggerHandler,
                sourceListItem: items
            });
        });
    }, [
        triggerHandler,
        closePopup,
        query,
        items
    ]);
};

});

parcelRegister("9nAiS", function(module, exports) {

$parcel$export(module.exports, "InputQuery", () => $cd70b04d74cf89b3$export$efc9b80896822e63);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $lRq8t = parcelRequire("lRq8t");

var $1rXzn = parcelRequire("1rXzn");

var $7EdFW = parcelRequire("7EdFW");

var $7k8dr = parcelRequire("7k8dr");
var $4drex = parcelRequire("4drex");

var $b7eFx = parcelRequire("b7eFx");

var $BmspC = parcelRequire("BmspC");

var $7yBx7 = parcelRequire("7yBx7");

var $eGOwo = parcelRequire("eGOwo");

var $92xoS = parcelRequire("92xoS");

var $eQTrE = parcelRequire("eQTrE");

var $elKSH = parcelRequire("elKSH");
function $cd70b04d74cf89b3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $cd70b04d74cf89b3$var$placeholderStyles = {
    name: "1onny3l",
    styles: "&::after{content:attr(data-place-holder);color:var(--ds-text-subtlest, #626F86);position:relative;padding:var(--ds-space-025, 2px);left:var(--ds-space-negative-050, -4px);background-color:var(--ds-background-neutral, #091E420F);border-radius:3px;}"
};
const $cd70b04d74cf89b3$var$queryWithoutPlaceholderStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    '&::after': {
        content: `''`
    }
});
const $cd70b04d74cf89b3$var$querySpanStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    outline: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& input': {
        width: '5px',
        border: 'none',
        background: 'transparent',
        padding: 0,
        margin: 0,
        // TODO: ED-17022 - Fixes firefox caret position
        // Do not migrate font when em is used as unit
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '1em',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: (0, $7yBx7.blockNodesVerticalMargin),
        caretColor: "var(--ds-text-accent-blue, #0052CC)"
    }
});
const $cd70b04d74cf89b3$var$isNavigationKey = (event)=>{
    return [
        'Enter',
        'Tab',
        'ArrowDown',
        'ArrowUp'
    ].includes(event.key);
};
const $cd70b04d74cf89b3$var$isUndoRedoShortcut = (event)=>{
    const key = (0, $1rXzn.keyName)(event);
    if (event.ctrlKey && key === 'y') return 'historyRedo';
    if ((event.ctrlKey || event.metaKey) && event.shiftKey && key === 'Z') return 'historyRedo';
    if ((event.ctrlKey || event.metaKey) && key === 'z') return 'historyUndo';
    return false;
};
const $cd70b04d74cf89b3$var$getAriaLabel = (triggerPrefix, intl)=>{
    switch(triggerPrefix){
        case '@':
            return (0, $4drex.typeAheadListMessages).mentionInputLabel;
        case '/':
            return (0, $4drex.typeAheadListMessages).quickInsertInputLabel;
        case ':':
            return (0, $4drex.typeAheadListMessages).emojiInputLabel;
        default:
            return (0, $4drex.typeAheadListMessages).quickInsertInputLabel;
    }
};
const $cd70b04d74cf89b3$export$efc9b80896822e63 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo(({ triggerQueryPrefix: triggerQueryPrefix, cancel: cancel, onQueryChange: onQueryChange, onItemSelect: onItemSelect, selectNextItem: selectNextItem, selectPreviousItem: selectPreviousItem, forceFocus: forceFocus, reopenQuery: reopenQuery, onQueryFocus: onQueryFocus, onUndoRedo: onUndoRedo, editorView: editorView, items: items })=>{
    const ref = (0, $eJOHy.useRef)(document.createElement('span'));
    const inputRef = (0, $eJOHy.useRef)(null);
    const [query, setQuery] = (0, $eJOHy.useState)(null);
    const isEditorInsertionEnabled = (0, $92xoS.editorExperiment)('platform_editor_insertion', 'variant1');
    const isEditorControlsEnabled = (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1');
    const isSearchPlaceholderEnabled = isEditorInsertionEnabled || (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1') && (0, $eGOwo.fg)('platform_editor_quick_insert_placeholder');
    const selection = editorView.state.selection;
    const { table: table } = editorView.state.schema.nodes;
    const [showPlaceholder, setShowPlaceholder] = (0, $eJOHy.useState)(isSearchPlaceholderEnabled && triggerQueryPrefix === '/' && // When triggered in very narrow table column, placeholder becomes ellipsis only
    // hence we disable it for now and revisit this scenario in ED-27480
    !(0, $BmspC.findParentNodeOfType)(table)(selection));
    const cleanedInputContent = (0, $eJOHy.useCallback)(()=>{
        const raw = ref.current?.textContent || '';
        return raw;
    }, []);
    const onKeyUp = (0, $eJOHy.useCallback)((event)=>{
        const text = cleanedInputContent();
        onQueryChange(text);
    }, [
        onQueryChange,
        cleanedInputContent
    ]);
    const onInput = (0, $eJOHy.useCallback)(()=>{
        if (cleanedInputContent()) setShowPlaceholder(false);
    }, [
        cleanedInputContent
    ]);
    const [isInFocus, setInFocus] = (0, $eJOHy.useState)(false);
    const checkKeyEvent = (0, $eJOHy.useCallback)((event)=>{
        const key = (0, $1rXzn.keyName)(event);
        const sel = document.getSelection();
        const raw = ref.current?.textContent || '';
        const text = cleanedInputContent();
        let stopDefault = false;
        const { selectedIndex: selectedIndex, removePrefixTriggerOnCancel: removePrefixTriggerOnCancel } = (0, $elKSH.getPluginState)(editorView.state) || {};
        setInFocus(true);
        switch(key){
            case ' ':
                // space key
                if (text.length === 0) {
                    cancel({
                        forceFocusOnEditor: true,
                        text: ' ',
                        addPrefixTrigger: isEditorControlsEnabled ? !removePrefixTriggerOnCancel : true,
                        setSelectionAt: (0, $eQTrE.CloseSelectionOptions).AFTER_TEXT_INSERTED
                    });
                    stopDefault = true;
                }
                break;
            case 'Escape':
            case 'PageUp':
            case 'PageDown':
            case 'Home':
                cancel({
                    text: text,
                    forceFocusOnEditor: true,
                    addPrefixTrigger: isEditorControlsEnabled ? !removePrefixTriggerOnCancel : true,
                    setSelectionAt: (0, $eQTrE.CloseSelectionOptions).AFTER_TEXT_INSERTED
                });
                stopDefault = true;
                break;
            case 'Backspace':
                if (raw.length === 0 || sel?.anchorOffset === 0) {
                    event.stopPropagation();
                    event.preventDefault();
                    cancel({
                        forceFocusOnEditor: true,
                        text: text,
                        addPrefixTrigger: false,
                        setSelectionAt: (0, $eQTrE.CloseSelectionOptions).BEFORE_TEXT_INSERTED
                    });
                }
                break;
            case 'Enter':
                // TODO: ED-14758 - Under the W3C specification, any keycode sent under IME would return a keycode 229
                // event.isComposing can't be used alone as this also included a virtual keyboard under a keyboardless device, therefore, it seems the best practice would be intercepting the event as below.
                // Some suggested the other workaround maybe listen on`keypress` instead of `keydown`
                if (!event.isComposing && event.which !== 229 && event.keyCode !== 229) {
                    if (selectedIndex === -1) {
                        /**
             * TODO DTR-1401: (also see ED-17200) There are two options
             * here, either
             * - set the index directly to 1 in WrapperTypeAhead.tsx's
             *   `insertSelectedItem` at the cost of breaking some of the a11y
             *   focus changes,
             * - or do this jank at the cost of some small analytics noise.
             *
             * The focus behaviour still needs cleanup
             */ selectPreviousItem();
                        selectNextItem();
                    }
                    onItemSelect(event.shiftKey ? (0, $7k8dr.SelectItemMode).SHIFT_ENTER : (0, $7k8dr.SelectItemMode).ENTER);
                }
                break;
            case 'Tab':
                if (selectedIndex === -1) {
                    /**
           * TODO DTR-1401: (also see ED-17200) There are two options
           * here, either
           * - set the index directly to 1 in WrapperTypeAhead.tsx's
           *   `insertSelectedItem` at the cost of breaking some of the a11y
           *   focus changes,
           * - or do this jank at the cost of some small analytics noise.
           *
           */ selectPreviousItem();
                    selectNextItem();
                }
                // TODO: DTR-1401 - why is this calling select item when hitting tab? fix this in DTR-1401
                onItemSelect((0, $7k8dr.SelectItemMode).TAB);
                break;
            case 'ArrowDown':
                selectNextItem();
                break;
            case 'ArrowUp':
                selectPreviousItem();
                break;
        }
        const undoRedoType = $cd70b04d74cf89b3$var$isUndoRedoShortcut(event);
        if (onUndoRedo && undoRedoType && onUndoRedo(undoRedoType)) stopDefault = true;
        if ($cd70b04d74cf89b3$var$isNavigationKey(event) || stopDefault) {
            event.stopPropagation();
            event.preventDefault();
            return false;
        }
    }, [
        onUndoRedo,
        onItemSelect,
        selectNextItem,
        selectPreviousItem,
        cancel,
        cleanedInputContent,
        editorView.state,
        isEditorControlsEnabled
    ]);
    const onClick = (0, $eJOHy.useCallback)((event)=>{
        event.stopPropagation();
        event.preventDefault();
        onQueryFocus();
        inputRef.current?.focus();
        return false;
    }, [
        onQueryFocus
    ]);
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (!ref.current) return;
        const { current: element } = ref;
        const { removePrefixTriggerOnCancel: removePrefixTriggerOnCancel } = (0, $elKSH.getPluginState)(editorView.state) || {};
        const onFocusIn = (event)=>{
            onQueryFocus();
        };
        const keyDown = (event)=>{
            const key = (0, $1rXzn.keyName)(event);
            if ([
                'ArrowLeft',
                'ArrowRight'
            ].includes(key) && document.getSelection && document.getSelection()) {
                const q = ref.current?.textContent || '';
                const sel = document.getSelection();
                const isMovingRight = sel && 'ArrowRight' === key && sel.anchorOffset === q.length;
                const isMovingLeft = sel && 'ArrowLeft' === key && (sel.anchorOffset === 0 || event.metaKey);
                if (!isMovingRight && !isMovingLeft) return;
                cancel({
                    forceFocusOnEditor: true,
                    addPrefixTrigger: isEditorControlsEnabled ? !removePrefixTriggerOnCancel : true,
                    text: cleanedInputContent(),
                    setSelectionAt: isMovingRight ? (0, $eQTrE.CloseSelectionOptions).AFTER_TEXT_INSERTED : (0, $eQTrE.CloseSelectionOptions).BEFORE_TEXT_INSERTED
                });
                event.preventDefault();
                event.stopPropagation();
                return;
            }
            checkKeyEvent(event);
        };
        const onFocusOut = (event)=>{
            const { relatedTarget: relatedTarget } = event;
            // Given the user is changing the focus
            // When the target is inside the TypeAhead Popup
            // Then the popup should stay open
            if (relatedTarget instanceof HTMLElement && relatedTarget.closest && relatedTarget.closest(`.${(0, $eQTrE.TYPE_AHEAD_POPUP_CONTENT_CLASS)}`)) return;
            // Chrome and Edge may emit focusout events without direct input.
            // This path handles dismissals that don't involve item selection, so we ignore these events.
            // In Edge this also lead to duplication in the trigger character (@, /, :) as `cancel` would be called twice
            if (((0, $7EdFW.browser).ie || (0, $7EdFW.browser).chrome) && !(window.getSelection()?.type === 'Range') && // eslint-disable-next-line @typescript-eslint/no-explicit-any
            !event.sourceCapabilities) return;
            cancel({
                addPrefixTrigger: isEditorControlsEnabled ? !removePrefixTriggerOnCancel : true,
                text: cleanedInputContent(),
                setSelectionAt: (0, $eQTrE.CloseSelectionOptions).BEFORE_TEXT_INSERTED,
                forceFocusOnEditor: false
            });
        };
        const close = ()=>{
            cancel({
                addPrefixTrigger: false,
                text: '',
                forceFocusOnEditor: true,
                setSelectionAt: (0, $eQTrE.CloseSelectionOptions).BEFORE_TEXT_INSERTED
            });
        };
        const beforeinput = (e)=>{
            setInFocus(false);
            const { target: target } = e;
            if (e.isComposing || !(target instanceof HTMLElement)) return;
            if (e.inputType === 'historyUndo' && target.textContent?.length === 0) {
                e.preventDefault();
                e.stopPropagation();
                close();
                return;
            }
            if (e.data != null && inputRef.current === null) {
                setQuery('');
                // We need to change the content on Safari
                // and set the cursor at the right place
                if ((0, $7EdFW.browser).safari) {
                    e.preventDefault();
                    const dataElement = document.createTextNode(e.data);
                    element.appendChild(dataElement);
                    const sel = window.getSelection();
                    const range = document.createRange();
                    range.setStart(dataElement, dataElement.length);
                    range.collapse(true);
                    sel?.removeAllRanges();
                    sel?.addRange(range);
                }
            }
        };
        const onInput = ()=>{};
        if ((0, $7EdFW.browser).safari) {
            // On Safari, for reasons beyond my understanding,
            // The undo behavior is totally different from other browsers
            // That why we need to have an specific branch only for Safari.
            const onInput = (e)=>{
                const { target: target } = e;
                if (!(e instanceof InputEvent) || e.isComposing || !(target instanceof HTMLElement)) return;
                if (e.inputType === 'historyUndo' && target.textContent?.length === 1) {
                    e.preventDefault();
                    e.stopPropagation();
                    close();
                    return;
                }
            };
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element.addEventListener('input', onInput);
        }
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element.addEventListener('focusout', onFocusOut);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element.addEventListener('focusin', onFocusIn);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element.addEventListener('keydown', keyDown);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element.addEventListener('beforeinput', beforeinput);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element.removeEventListener('focusout', onFocusOut);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element.removeEventListener('focusin', onFocusIn);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element.removeEventListener('keydown', keyDown);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element.removeEventListener('beforeinput', beforeinput);
            if ((0, $7EdFW.browser).safari) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element.removeEventListener('input', onInput);
        };
    }, [
        triggerQueryPrefix,
        cleanedInputContent,
        onQueryFocus,
        cancel,
        checkKeyEvent,
        editorView.state,
        isEditorControlsEnabled
    ]);
    (0, $eJOHy.useLayoutEffect)(()=>{
        const hasReopenQuery = typeof reopenQuery === 'string' && reopenQuery.trim().length > 0;
        if (ref.current && forceFocus) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            setQuery(hasReopenQuery ? reopenQuery : null);
            requestAnimationFrame(()=>{
                if (!ref?.current) return;
                const sel = window.getSelection();
                if (sel && hasReopenQuery && ref.current.lastChild instanceof Text) {
                    const lastChild = ref.current.lastChild;
                    const range = document.createRange();
                    range.setStart(ref.current.lastChild, lastChild.length);
                    range.collapse(true);
                    sel.removeAllRanges();
                    sel.addRange(range);
                }
                ref.current.focus();
                setInFocus(true);
            });
        }
    }, [
        forceFocus,
        reopenQuery
    ]);
    const classNames = (0, $eJOHy.useMemo)(()=>{
        const classes = [];
        if (showPlaceholder) {
            // to avoid the placeholder wrapped to next line when triggered at the end of the line
            // see placeholderWrapStyles in editor-core/src/ui/ContentStyles/index.tsx
            classes.push('placeholder-decoration-wrap');
            if (selection.$from.depth > 1) // to hide placeholder overflow as ellipsis
            // see placeholderWrapStyles in editor-core/src/ui/ContentStyles/index.tsx
            classes.push('placeholder-decoration-hide-overflow');
        }
        return classes.join(' ');
    }, [
        showPlaceholder,
        selection
    ]);
    const assistiveHintID = (0, $eQTrE.TYPE_AHEAD_DECORATION_ELEMENT_ID) + '__assistiveHint';
    const intl = (0, $lRq8t.default)();
    /**
   When we migrated to emotion from styled component, we started getting this error.
   jsx-a11y/interactive-supports-focus
   Task added in https://product-fabric.atlassian.net/wiki/spaces/E/pages/3182068181/Potential+improvements#Moderate-changes.
  */ return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $eJOHy.Fragment), null, triggerQueryPrefix, /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        css: [
            $cd70b04d74cf89b3$var$querySpanStyles,
            isSearchPlaceholderEnabled && $cd70b04d74cf89b3$var$queryWithoutPlaceholderStyles,
            showPlaceholder && $cd70b04d74cf89b3$var$placeholderStyles
        ],
        contentEditable: true,
        ref: ref,
        onKeyUp: onKeyUp,
        onClick: onClick,
        onInput: isSearchPlaceholderEnabled ? onInput : undefined,
        role: "combobox",
        "aria-controls": (0, $eQTrE.TYPE_AHEAD_DECORATION_ELEMENT_ID),
        "aria-autocomplete": "list",
        "aria-expanded": items.length !== 0,
        "aria-labelledby": assistiveHintID,
        suppressContentEditableWarning: true,
        "data-query-prefix": triggerQueryPrefix,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: classNames,
        "data-place-holder": intl.formatMessage((0, $4drex.typeAheadListMessages).quickInsertInputPlaceholderLabel)
    }, query === null ? /*#__PURE__*/ (0, $1NIU8.jsx)("input", {
        ref: inputRef,
        type: "text",
        "aria-label": intl.formatMessage($cd70b04d74cf89b3$var$getAriaLabel(triggerQueryPrefix, intl))
    }) : query), /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        id: assistiveHintID,
        style: {
            display: 'none'
        }
    }, intl.formatMessage((0, $4drex.typeAheadListMessages).inputQueryAssistiveLabel)), /*#__PURE__*/ (0, $1NIU8.jsx)((0, $b7eFx.AssistiveText), {
        assistiveText: items.length === 0 ? intl.formatMessage((0, $4drex.typeAheadListMessages).noSearchResultsLabel, {
            itemsLength: items.length
        }) : '',
        isInFocus: items.length === 0 || isInFocus,
        id: (0, $eQTrE.TYPE_AHEAD_DECORATION_ELEMENT_ID)
    }));
});
$cd70b04d74cf89b3$export$efc9b80896822e63.displayName = 'InputQuery';

});
parcelRegister("b7eFx", function(module, exports) {

$parcel$export(module.exports, "AssistiveText", () => $7787e9fb83d703bf$export$568f929105953699);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $3s8bj = parcelRequire("3s8bj");
function $7787e9fb83d703bf$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7787e9fb83d703bf$var$assitiveTextStyles = {
    name: "v66mgv",
    styles: "border:0;clip:rect(0 0 0 0);height:1px;marginbottom:-1px;marginright:-1px;overflow:hidden;padding:0;position:absolute;whitespace:nowrap;width:1px"
};
const $7787e9fb83d703bf$export$568f929105953699 = ({ assistiveText: assistiveText = '', isInFocus: isInFocus = false, id: id = '', statusDebounceMillis: statusDebounceMillis = 1400 })=>{
    const [bump, setBump] = (0, $eJOHy.useState)(false);
    const [debounced, setDebounced] = (0, $eJOHy.useState)(false);
    const [silenced, setSilenced] = (0, $eJOHy.useState)(false);
    const debounceStatusUpdate = (0, $eJOHy.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(()=>{
            const shouldSilence = !isInFocus;
            setBump((prevBump)=>!prevBump);
            setDebounced(true);
            setSilenced(shouldSilence);
        }), [
        isInFocus
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!debounced) {
            debounceStatusUpdate();
            return ()=>{
                debounceStatusUpdate.cancel();
            };
        }
    }, [
        assistiveText,
        isInFocus,
        debounced,
        debounceStatusUpdate
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (debounced) {
            setBump((prevBump)=>!prevBump);
            setDebounced(true);
            setSilenced(!isInFocus);
        }
    }, [
        assistiveText,
        isInFocus,
        debounced
    ]);
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $7787e9fb83d703bf$var$assitiveTextStyles
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        "data-testid": id + '__status--A',
        id: id + '__status--A',
        role: "status",
        "aria-atomic": "true",
        "aria-live": "polite"
    }, !silenced && debounced && bump ? assistiveText : ''), /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        "data-testid": id + '__status--B',
        id: id + '__status--B',
        role: "status",
        "aria-atomic": "true",
        "aria-live": "polite"
    }, !silenced && debounced && !bump ? assistiveText : ''));
};

});




parcelRegister("ln6bC", function(module, exports) {

$parcel$export(module.exports, "createReducer", () => $93f7a9637f86d44b$export$473eb76d322d0290);

var $3YJ2y = parcelRequire("3YJ2y");

var $bMFKb = parcelRequire("bMFKb");

var $b7EWj = parcelRequire("b7EWj");

var $ckKJp = parcelRequire("ckKJp");

var $kPuXt = parcelRequire("kPuXt");

var $elKSH = parcelRequire("elKSH");
const $93f7a9637f86d44b$var$shouldForceOpen = (step)=>{
    if (!(step instanceof (0, $3YJ2y.InsertTypeAheadStep))) return false;
    const isDeletionRawQueryOperation = step.isInsertionStep() && step.stage === (0, $3YJ2y.InsertTypeAheadStages).DELETING_RAW_QUERY;
    const isUndoingInsertionItem = step.isUndoingStep() && step.stage === (0, $3YJ2y.InsertTypeAheadStages).INSERTING_ITEM;
    return isDeletionRawQueryOperation || isUndoingInsertionItem;
};
const $93f7a9637f86d44b$var$shouldForceClose = (step)=>{
    if (!(step instanceof (0, $3YJ2y.InsertTypeAheadStep))) return false;
    const isInsertingItem = step.isInsertionStep() && step.stage === (0, $3YJ2y.InsertTypeAheadStages).INSERTING_ITEM;
    const isUndoingDeletionRawQuery = step.isUndoingStep() && step.stage === (0, $3YJ2y.InsertTypeAheadStages).DELETING_RAW_QUERY;
    return isInsertingItem || isUndoingDeletionRawQuery;
};
const $93f7a9637f86d44b$var$createFindHandler = (typeAheadHandlers)=>(step)=>{
        if (!(step instanceof (0, $3YJ2y.InsertTypeAheadStep))) return null;
        const handler = typeAheadHandlers.find((h)=>h.trigger === step.trigger);
        return handler || null;
    };
const $93f7a9637f86d44b$export$473eb76d322d0290 = ({ typeAheadHandlers: typeAheadHandlers, removeDecorations: removeDecorations, createDecorations: createDecorations })=>{
    const findHandler = $93f7a9637f86d44b$var$createFindHandler(typeAheadHandlers);
    const openMenu = (currentPluginState, { tr: tr, triggerHandler: triggerHandler, inputMethod: inputMethod, reopenQuery: reopenQuery, selectedIndex: selectedIndex, removePrefixTriggerOnCancel: removePrefixTriggerOnCancel })=>{
        removeDecorations(currentPluginState.decorationSet);
        const { decorationSet: decorationSet, decorationElement: decorationElement, stats: stats } = createDecorations(tr, {
            triggerHandler: triggerHandler,
            inputMethod: inputMethod,
            reopenQuery: reopenQuery
        });
        return {
            ...currentPluginState,
            stats: stats,
            decorationSet: decorationSet,
            triggerHandler: triggerHandler,
            decorationElement: decorationElement,
            inputMethod: inputMethod,
            selectedIndex: typeof selectedIndex === 'number' ? selectedIndex : -1,
            items: [],
            query: reopenQuery || '',
            removePrefixTriggerOnCancel: removePrefixTriggerOnCancel
        };
    };
    const closeMenu = (currentPluginState)=>{
        removeDecorations(currentPluginState.decorationSet);
        return {
            ...currentPluginState,
            inputMethod: null,
            query: '',
            decorationElement: null,
            decorationSet: (0, $b7EWj.DecorationSet).empty,
            stats: null,
            triggerHandler: undefined,
            items: [],
            removePrefixTriggerOnCancel: undefined
        };
    };
    return (tr, currentPluginState, typeAheadStepOverride)=>{
        const meta = tr.getMeta((0, $kPuXt.pluginKey)) || {};
        // This code below controls when we should force
        // the menu to open or close during undo/redo operations
        const overrideHandler = findHandler(typeAheadStepOverride);
        if (typeAheadStepOverride && overrideHandler && $93f7a9637f86d44b$var$shouldForceOpen(typeAheadStepOverride)) return openMenu(currentPluginState, {
            tr: tr,
            triggerHandler: overrideHandler,
            inputMethod: (0, $bMFKb.INPUT_METHOD).KEYBOARD,
            reopenQuery: typeAheadStepOverride.query,
            selectedIndex: typeAheadStepOverride.selectedIndex
        });
        else if ($93f7a9637f86d44b$var$shouldForceClose(typeAheadStepOverride)) return closeMenu(currentPluginState);
        const { action: action, params: params } = meta || {};
        const shouldOpenMenu = action === (0, $ckKJp.ACTIONS).OPEN_TYPEAHEAD_AT_CURSOR && (0, $elKSH.isTypeAheadHandler)(params?.triggerHandler);
        const selectionChanged = tr.selectionSet && (tr.isGeneric || Boolean(tr.getMeta('pointer')));
        const shouldCloseMenu = [
            (0, $ckKJp.ACTIONS).CLOSE_TYPE_AHEAD,
            (0, $ckKJp.ACTIONS).INSERT_ITEM
        ].includes(action) || selectionChanged;
        const shouldUpdateQuery = action === (0, $ckKJp.ACTIONS).CHANGE_QUERY;
        const shouldUpdateListItems = action === (0, $ckKJp.ACTIONS).UPDATE_LIST_ITEMS;
        const shouldUpdateListError = action === (0, $ckKJp.ACTIONS).UPDATE_LIST_ERROR;
        const shouldUpdateSelectedIndex = action === (0, $ckKJp.ACTIONS).UPDATE_SELECTED_INDEX;
        const shouldClearListError = action === (0, $ckKJp.ACTIONS).CLEAR_LIST_ERROR;
        if (shouldOpenMenu) return openMenu(currentPluginState, {
            tr: tr,
            triggerHandler: params.triggerHandler,
            inputMethod: params.inputMethod,
            reopenQuery: params.query,
            removePrefixTriggerOnCancel: params.removePrefixTriggerOnCancel
        });
        else if (shouldCloseMenu) return closeMenu(currentPluginState);
        else if (shouldUpdateQuery) return {
            ...currentPluginState,
            query: params.query
        };
        else if (shouldUpdateListError) {
            const { errorInfo: errorInfo } = params;
            return {
                ...currentPluginState,
                errorInfo: errorInfo,
                items: [],
                selectedIndex: -1
            };
        } else if (shouldUpdateListItems) {
            const { items: items } = params;
            const { selectedIndex: selectedIndex } = currentPluginState;
            return {
                ...currentPluginState,
                items: items,
                selectedIndex: Math.max(selectedIndex >= items.length ? items.length - 1 : selectedIndex, -1)
            };
        } else if (shouldUpdateSelectedIndex) return {
            ...currentPluginState,
            selectedIndex: params.selectedIndex
        };
        else if (shouldClearListError) return {
            ...currentPluginState,
            errorInfo: null
        };
        if (tr.docChanged) {
            const { decorationSet: decorationSet } = currentPluginState;
            const onRemove = ()=>{
                // Make sure we are unmounting the component
                // from the react tree when this decoration is removed
                removeDecorations(currentPluginState.decorationSet);
            };
            const mappedDecorationSet = decorationSet.map(tr.mapping, tr.doc, {
                onRemove: onRemove
            });
            // return same pluginState if decorationSet did not change
            if (mappedDecorationSet === currentPluginState.decorationSet) return currentPluginState;
            return {
                ...currentPluginState,
                decorationSet: mappedDecorationSet
            };
        }
        return currentPluginState;
    };
};

});


parcelRegister("7EuRs", function(module, exports) {

$parcel$export(module.exports, "ContentComponent", () => $9d2301ec1aae957c$export$2dda1e4a1d1f6a81);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $kLQ9a = parcelRequire("kLQ9a");
var $bSToC = parcelRequire("bSToC");
var $cxXTK = parcelRequire("cxXTK");

var $7k8dr = parcelRequire("7k8dr");

var $92xoS = parcelRequire("92xoS");

var $ccZYC = parcelRequire("ccZYC");

var $eKKzu = parcelRequire("eKKzu");
const $9d2301ec1aae957c$var$useSharedState = (0, $kLQ9a.sharedPluginStateHookMigratorFactory)((api)=>{
    const { triggerHandler: triggerHandler, items: items, errorInfo: errorInfo, decorationElement: decorationElement, decorationSet: decorationSet, query: query, selectedIndex: selectedIndex } = (0, $cxXTK.useSharedPluginStateWithSelector)(api, [
        'typeAhead'
    ], (states)=>({
            triggerHandler: states.typeAheadState?.triggerHandler,
            items: states.typeAheadState?.items,
            errorInfo: states.typeAheadState?.errorInfo,
            decorationElement: states.typeAheadState?.decorationElement,
            decorationSet: states.typeAheadState?.decorationSet,
            query: states.typeAheadState?.query,
            selectedIndex: states.typeAheadState?.selectedIndex
        }));
    return {
        triggerHandler: triggerHandler,
        items: items,
        errorInfo: errorInfo,
        decorationElement: decorationElement,
        decorationSet: decorationSet,
        query: query,
        selectedIndex: selectedIndex
    };
}, (api)=>{
    const { typeAheadState: typeAheadState } = (0, $bSToC.useSharedPluginState)(api, [
        'typeAhead'
    ]);
    return {
        triggerHandler: typeAheadState?.triggerHandler,
        items: typeAheadState?.items,
        errorInfo: typeAheadState?.errorInfo,
        decorationElement: typeAheadState?.decorationElement,
        decorationSet: typeAheadState?.decorationSet,
        query: typeAheadState?.query,
        selectedIndex: typeAheadState?.selectedIndex
    };
});
function $9d2301ec1aae957c$export$2dda1e4a1d1f6a81({ api: api, editorView: editorView, popupMountRef: popupMountRef }) {
    const { triggerHandler: triggerHandler, items: items, errorInfo: errorInfo, decorationElement: decorationElement, decorationSet: decorationSet, query: query, selectedIndex: selectedIndex } = $9d2301ec1aae957c$var$useSharedState(api);
    if (items === undefined || decorationSet === undefined || errorInfo === undefined || decorationElement === undefined || query === undefined || selectedIndex === undefined) return null;
    if (// TODO: ED-26959 - Also requires a check for editor appearance (needs to be enabled for full-page/full-width editor only ?)
    !(0, $92xoS.editorExperiment)('platform_editor_insertion', 'control') && triggerHandler?.id === (0, $7k8dr.TypeAheadAvailableNodes).QUICK_INSERT) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ccZYC.TypeAheadMenu), {
        editorView: editorView,
        popupMountRef: popupMountRef,
        typeAheadState: {
            triggerHandler: triggerHandler,
            items: items,
            errorInfo: errorInfo,
            decorationElement: decorationElement,
            decorationSet: decorationSet,
            query: query
        },
        api: api
    });
    else return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eKKzu.TypeAheadMenu), {
        editorView: editorView,
        popupMountRef: popupMountRef,
        typeAheadState: {
            triggerHandler: triggerHandler,
            items: items,
            errorInfo: errorInfo,
            decorationElement: decorationElement,
            decorationSet: decorationSet,
            query: query
        },
        selectedIndex: selectedIndex,
        api: api
    });
}

});
parcelRegister("ccZYC", function(module, exports) {

$parcel$export(module.exports, "TypeAheadMenu", () => $377c694aba1822a9$export$b11addef9209139);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $7k8dr = parcelRequire("7k8dr");

var $lKOUs = parcelRequire("lKOUs");

var $l9ZHZ = parcelRequire("l9ZHZ");

var $lweSp = parcelRequire("lweSp");
const $377c694aba1822a9$export$b11addef9209139 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo(({ editorView: editorView, popupMountRef: popupMountRef, typeAheadState: typeAheadState, api: api })=>{
    const isOpen = typeAheadState.decorationSet.find().length > 0;
    const { triggerHandler: triggerHandler, items: items, errorInfo: errorInfo, decorationElement: decorationElement, decorationSet: decorationSet, query: query } = typeAheadState;
    const [onItemInsert, onTextInsert] = (0, $l9ZHZ.useItemInsert)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    triggerHandler, editorView, items, api);
    const setSelectedItem = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback(({ index: nextIndex })=>{
        queueMicrotask(()=>{
            (0, $lKOUs.updateSelectedIndex)(nextIndex, api)(editorView.state, editorView.dispatch);
        });
    }, [
        editorView,
        api
    ]);
    const insertItem = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((mode = (0, $7k8dr.SelectItemMode).SELECTED, index)=>{
        queueMicrotask(()=>{
            onItemInsert({
                mode: mode,
                index: index,
                query: query
            });
        });
    }, [
        onItemInsert,
        query
    ]);
    const cancel = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback(({ setSelectionAt: setSelectionAt, addPrefixTrigger: addPrefixTrigger, forceFocusOnEditor: forceFocusOnEditor })=>{
        const fullQuery = addPrefixTrigger ? `${triggerHandler?.trigger}${query}` : query;
        onTextInsert({
            forceFocusOnEditor: forceFocusOnEditor,
            setSelectionAt: setSelectionAt,
            text: fullQuery
        });
    }, [
        triggerHandler,
        onTextInsert,
        query
    ]);
    if (!isOpen || !triggerHandler || !(decorationElement instanceof HTMLElement) || items.length === 0 && !errorInfo) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lweSp.TypeAheadPopup), {
        editorView: editorView,
        popupsMountPoint: popupMountRef.current?.popupsMountPoint,
        popupsBoundariesElement: popupMountRef.current?.popupsBoundariesElement,
        popupsScrollableElement: popupMountRef.current?.popupsScrollableElement,
        anchorElement: decorationElement,
        triggerHandler: triggerHandler,
        items: items,
        errorInfo: errorInfo,
        // selectedIndex={selectedIndex}
        setSelectedItem: setSelectedItem,
        onItemInsert: insertItem,
        decorationSet: decorationSet,
        isEmptyQuery: !query,
        query: query,
        cancel: cancel,
        api: api
    });
});

});
parcelRegister("lweSp", function(module, exports) {

$parcel$export(module.exports, "TypeAheadPopup", () => $eca9707f48496564$export$fbc0702507873a7d);
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $bRPNB = parcelRequire("bRPNB");

var $lRq8t = parcelRequire("lRq8t");

var $bMFKb = parcelRequire("bMFKb");

var $4DFTL = parcelRequire("4DFTL");

var $dwnni = parcelRequire("dwnni");
var $avm98 = parcelRequire("avm98");

var $1eH5X = parcelRequire("1eH5X");
var $dGNvX = parcelRequire("dGNvX");

var $7yBx7 = parcelRequire("7yBx7");

var $dcLzM = parcelRequire("dcLzM");

var $eGOwo = parcelRequire("eGOwo");


var $eQTrE = parcelRequire("eQTrE");

var $nMpI6 = parcelRequire("nMpI6");
const $eca9707f48496564$var$DEFAULT_TYPEAHEAD_MENU_HEIGHT = 520;
// const DEFAULT_TYPEAHEAD_MENU_HEIGHT_NEW = 480;
const $eca9707f48496564$var$ITEM_PADDING = 12;
const $eca9707f48496564$var$INSERT_PANEL_WIDTH = 320;
const $eca9707f48496564$var$typeAheadContent = /*#__PURE__*/ (0, $1NIU8.css)({
    background: `var(--ds-surface-overlay, ${(0, $7bb4c1736002a04a$export$29a4f05edc054374)})`,
    borderRadius: "var(--ds-border-radius, 3px)",
    boxShadow: `var(--ds-shadow-overlay, ${`0 0 1px ${(0, $7bb4c1736002a04a$export$d2d3bedfb276cac0)}, 0 4px 8px -2px ${(0, $7bb4c1736002a04a$export$7d3359664e8bb0e5)}`})`,
    padding: `${"var(--ds-space-050, 4px)"} 0`,
    width: '280px',
    maxHeight: '520px' /* ~5.5 visibile items */ ,
    overflowY: 'auto',
    MsOverflowStyle: '-ms-autohiding-scrollbar',
    position: 'relative'
});
const $eca9707f48496564$var$OFFSET = [
    0,
    8
];
const $eca9707f48496564$export$fbc0702507873a7d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo((props)=>{
    const { triggerHandler: triggerHandler, anchorElement: anchorElement, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, items: items, errorInfo: errorInfo, onItemInsert: onItemInsert, isEmptyQuery: isEmptyQuery, cancel: cancel, api: api, query: query, setSelectedItem: setSelectedItem } = props;
    const ref = (0, $eJOHy.useRef)(null);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const defaultMenuHeight = $eca9707f48496564$var$DEFAULT_TYPEAHEAD_MENU_HEIGHT;
    const startTime = (0, $eJOHy.useMemo)(()=>performance.now(), // In case those props changes
    // we need to recreate the startTime
    [
        items,
        isEmptyQuery,
        triggerHandler
    ] // eslint-disable-line react-hooks/exhaustive-deps
    );
    (0, $eJOHy.useEffect)(()=>{
        if (!api?.analytics?.actions?.fireAnalyticsEvent) return;
        const stopTime = performance.now();
        const time = stopTime - startTime;
        api?.analytics?.actions?.fireAnalyticsEvent({
            action: (0, $bMFKb.ACTION).RENDERED,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).TYPEAHEAD,
            eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL,
            attributes: {
                time: time,
                items: items.length,
                initial: isEmptyQuery
            }
        });
    }, [
        startTime,
        items,
        isEmptyQuery,
        // In case the current triggerHandler changes
        // e.g: Inserting a mention using the quick insert
        // we need to send the event again
        // eslint-disable-next-line react-hooks/exhaustive-deps
        triggerHandler,
        api
    ]);
    // useEffect(() => {
    // 	if (!api?.analytics?.actions?.fireAnalyticsEvent) {
    // 		return;
    // 	}
    // 	api?.analytics?.actions?.fireAnalyticsEvent({
    // 		action: ACTION.VIEWED,
    // 		actionSubject: ACTION_SUBJECT.TYPEAHEAD_ITEM,
    // 		eventType: EVENT_TYPE.OPERATIONAL,
    // 		attributes: {
    // 			index: selectedIndex,
    // 			items: items.length,
    // 		},
    // 	});
    // }, [
    // 	items,
    // 	api,
    // 	selectedIndex,
    // 	// In case the current triggerHandler changes
    // 	// e.g: Inserting a mention using the quick insert
    // 	// we need to send the event again
    // 	// eslint-disable-next-line react-hooks/exhaustive-deps
    // 	triggerHandler,
    // ]);
    const [fitHeight, setFitHeight] = (0, $eJOHy.useState)(defaultMenuHeight);
    const getFitHeight = (0, $eJOHy.useCallback)(()=>{
        if (!anchorElement || !popupsMountPoint) return;
        const target = anchorElement;
        const { top: targetTop, height: targetHeight } = target.getBoundingClientRect();
        const boundariesElement = popupsBoundariesElement || document.body;
        const { height: boundariesHeight, top: boundariesTop } = boundariesElement.getBoundingClientRect();
        // Calculating the space above and space below our decoration
        const spaceAbove = targetTop - (boundariesTop - boundariesElement.scrollTop);
        const spaceBelow = boundariesTop + boundariesHeight - (targetTop + targetHeight);
        // Keep default height if more than enough space
        if (spaceBelow >= defaultMenuHeight) return setFitHeight(defaultMenuHeight);
        // Determines whether typeahead will fit above or below decoration
        // and return the space available.
        const newFitHeight = spaceBelow >= spaceAbove ? spaceBelow : spaceAbove;
        // Each typeahead item has some padding
        // We want to leave some space at the top so first item
        // is not partially cropped
        const fitHeightWithSpace = newFitHeight - $eca9707f48496564$var$ITEM_PADDING * 2;
        // Ensure typeahead height is max its default height
        const minFitHeight = Math.min(defaultMenuHeight, fitHeightWithSpace);
        return setFitHeight(minFitHeight);
    }, [
        anchorElement,
        defaultMenuHeight,
        popupsBoundariesElement,
        popupsMountPoint
    ]);
    const getFitHeightDebounced = (0, $bRPNB.default)(getFitHeight);
    (0, $eJOHy.useLayoutEffect)(()=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const scrollableElement = popupsScrollableElement || (0, $dwnni.findOverflowScrollParent)(anchorElement);
        getFitHeight();
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.addEventListener('resize', getFitHeightDebounced);
        if (scrollableElement) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        scrollableElement.addEventListener('scroll', getFitHeightDebounced);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            window.removeEventListener('resize', getFitHeightDebounced);
            if (scrollableElement) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            scrollableElement.removeEventListener('scroll', getFitHeightDebounced);
        };
    }, [
        anchorElement,
        popupsScrollableElement,
        getFitHeightDebounced,
        getFitHeight
    ]);
    (0, $eJOHy.useLayoutEffect)(()=>{
        const focusOut = (event)=>{
            const { relatedTarget: relatedTarget } = event;
            // Given the user is changing the focus
            // When the target is inside the TypeAhead Popup
            // Then the popup should stay open
            if (relatedTarget instanceof HTMLElement && relatedTarget.closest && (relatedTarget.closest(`.${(0, $eQTrE.TYPE_AHEAD_POPUP_CONTENT_CLASS)}`) || relatedTarget.closest(`[data-type-ahead="${(0, $eQTrE.TYPE_AHEAD_DECORATION_DATA_ATTRIBUTE)}"]`))) return;
            // Handles cases like emoji and @ typeaheads that open new typeaheads
            const isTextSelected = window.getSelection()?.type === 'Range';
            if ((0, $eGOwo.fg)('platform_editor_legacy_content_macro_typeahead_fix')) {
                const innerEditor = anchorElement.closest('.extension-editable-area');
                if (innerEditor) {
                    // When there is no related target, we default to not closing the popup
                    let newFocusInsideCurrentEditor = !relatedTarget;
                    if (relatedTarget instanceof HTMLElement) // check if the new focus is inside inner editor, keep popup opens
                    newFocusInsideCurrentEditor = innerEditor.contains(relatedTarget);
                    if (!isTextSelected && newFocusInsideCurrentEditor) return;
                } else {
                    // if the current focus in outer editor, keep the existing behaviour, do not close the pop up if text is not selected
                    if (!isTextSelected) return;
                }
            } else {
                if (!isTextSelected) return;
            }
            cancel({
                addPrefixTrigger: true,
                setSelectionAt: (0, $eQTrE.CloseSelectionOptions).AFTER_TEXT_INSERTED,
                forceFocusOnEditor: false
            });
        };
        const { current: element } = ref;
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element?.addEventListener('focusout', focusOut);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element?.removeEventListener('focusout', focusOut);
        };
    }, [
        ref,
        cancel,
        anchorElement
    ]);
    // TODO: ED-17443 - When you press escape on typeahead panel, it should remove focus and close the panel
    // This is the expected keyboard behaviour advised by the Accessibility team
    (0, $eJOHy.useLayoutEffect)(()=>{
        const escape = (event)=>{
            if (event.key === 'Escape') cancel({
                addPrefixTrigger: true,
                setSelectionAt: (0, $eQTrE.CloseSelectionOptions).AFTER_TEXT_INSERTED,
                forceFocusOnEditor: true
            });
        };
        const { current: element } = ref;
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element?.addEventListener('keydown', escape);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element?.removeEventListener('keydown', escape);
        };
    }, [
        ref,
        cancel
    ]);
    const handleViewAllItemsClick = (0, $eJOHy.useCallback)(()=>{
        const showContextPanel = api?.contextPanel?.actions?.showPanel;
        if (!showContextPanel || !items) return;
        // Opens main editor controls side panel
        showContextPanel({
            id: 'editor-element-insert-sidebar-panel',
            headerComponentElements: {
                headerLabel: (0, $4DFTL.elementInsertSidePanel).title,
                HeaderIcon: ()=>/*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dcLzM))), {
                        label: formatMessage((0, $4DFTL.elementInsertSidePanel).title)
                    })
            },
            BodyComponent: ()=>{
                return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $dGNvX.SideInsertPanel), {
                    items: items,
                    onItemInsert: onItemInsert
                });
            }
        }, 'push', $eca9707f48496564$var$INSERT_PANEL_WIDTH);
        // Closes typeahead
        cancel({
            addPrefixTrigger: true,
            setSelectionAt: (0, $eQTrE.CloseSelectionOptions).AFTER_TEXT_INSERTED,
            forceFocusOnEditor: true
        });
    }, [
        api,
        cancel,
        formatMessage,
        items,
        onItemInsert
    ]);
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $avm98.default), {
        zIndex: (0, $7yBx7.akEditorFloatingDialogZIndex),
        target: anchorElement,
        mountTo: popupsMountPoint,
        boundariesElement: popupsBoundariesElement,
        scrollableElement: popupsScrollableElement,
        fitHeight: fitHeight,
        fitWidth: 280,
        offset: $eca9707f48496564$var$OFFSET,
        ariaLabel: null,
        preventOverflow: true
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: [
            $eca9707f48496564$var$typeAheadContent
        ],
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $eQTrE.TYPE_AHEAD_POPUP_CONTENT_CLASS),
        ref: ref
    }, errorInfo ? /*#__PURE__*/ (0, $1NIU8.jsx)((0, $nMpI6.TypeAheadErrorFallback), null) : /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $1eH5X.QuickInsertPanel), {
        items: items,
        onItemInsert: onItemInsert,
        query: query,
        setSelectedItem: setSelectedItem,
        onViewAllItemsClick: Boolean(api?.contextPanel) ? handleViewAllItemsClick : undefined
    }))));
});
$eca9707f48496564$export$fbc0702507873a7d.displayName = 'TypeAheadPopup';

});
parcelRegister("1eH5X", function(module, exports) {

$parcel$export(module.exports, "QuickInsertPanel", () => $ccd11f0d9a88743c$export$c4b59221ed3995fe);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $7k8dr = parcelRequire("7k8dr");

var $6YEko = parcelRequire("6YEko");

var $8nu6j = parcelRequire("8nu6j");
var $dW738 = parcelRequire("dW738");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $inQ44 = parcelRequire("inQ44");

var $i8VaZ = parcelRequire("i8VaZ");

var $aG5mc = parcelRequire("aG5mc");

var $e1oUK = parcelRequire("e1oUK");

var $3CAGn = parcelRequire("3CAGn");
const $ccd11f0d9a88743c$var$navButtonContainerStyles = (0, $1DXK0.xcss)({
    paddingTop: 'space.0',
    paddingBottom: 'space.0',
    paddingLeft: 'space.200',
    paddingRight: 'space.200'
});
const $ccd11f0d9a88743c$var$DefaultView = ({ suggested: suggested, itemsRegistry: itemsRegistry, categoryRegistry: categoryRegistry, onItemSelected: onItemSelected, onCategorySelected: onCategorySelected, setSelectedItem: setSelectedItem })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $dW738.default), {
        children: [
            suggested && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $i8VaZ.ListButtonGroupWithHeading), {
                id: suggested.id,
                items: suggested.items.slice(0, 6),
                label: suggested.label,
                onItemSelected: onItemSelected,
                setSelectedItem: setSelectedItem,
                startingIndex: 0
            }),
            (0, $inQ44.CategoriesStructure).map((category)=>{
                const { defautltItems: defautltItems } = category;
                const items = defautltItems.length > 0 ? defautltItems.map((itemIdOrTitle)=>itemsRegistry[itemIdOrTitle]).filter((item)=>item) : categoryRegistry[category.id] ? categoryRegistry[category.id].slice(0, 5) : [];
                return items.length > 0 && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6YEko.default), {
                    hasSeparator: true,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
                        xcss: $ccd11f0d9a88743c$var$navButtonContainerStyles,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $e1oUK.LinkNavButton), {
                            id: category.id,
                            label: category.title,
                            onClick: onCategorySelected
                        })
                    })
                }, category.id);
            })
        ]
    });
};
const $ccd11f0d9a88743c$var$CategoryView = ({ categoryRegistry: categoryRegistry, selectedCategory: selectedCategory, onItemSelected: onItemSelected, onBackButtonClicked: onBackButtonClicked })=>{
    const categoryData = (0, $inQ44.PredefinedCategories).get(selectedCategory);
    const categoryLevelItems = categoryRegistry[selectedCategory] || [];
    let startingIndex = categoryLevelItems.length;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dW738.default), {
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $3CAGn.SubPanelWithBackButton), {
            label: categoryData.title,
            buttonLabel: "Back to all items",
            onClick: onBackButtonClicked,
            children: [
                categoryLevelItems.length > 0 && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $i8VaZ.ListButtonGroup), {
                    id: categoryData.id,
                    items: categoryLevelItems,
                    onItemSelected: onItemSelected,
                    startingIndex: 0
                }),
                categoryData && categoryData.subcategories.map(({ id: id, title: title })=>{
                    if (categoryRegistry[id]) {
                        const list = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $i8VaZ.ListButtonGroupWithHeading), {
                            id: id,
                            label: title,
                            items: categoryRegistry[id],
                            onItemSelected: onItemSelected,
                            startingIndex: startingIndex
                        });
                        startingIndex += categoryRegistry[id].length;
                        return list;
                    }
                })
            ]
        })
    });
};
const $ccd11f0d9a88743c$var$SearchView = ({ items: items, onItemSelected: onItemSelected, setSelectedItem: setSelectedItem })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $i8VaZ.ListButtonGroup), {
        id: 'search',
        items: items,
        onItemSelected: onItemSelected,
        setSelectedItem: setSelectedItem,
        startingIndex: 0
    });
};
const $ccd11f0d9a88743c$var$EmptySearchView = ()=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
        padding: "space.300",
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $dW738.default), {
            space: "space.0",
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5qJVF.default), {
                    align: "center",
                    as: "p",
                    children: "We couldn't find any results."
                }),
                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $5qJVF.default), {
                    align: "center",
                    as: "p",
                    children: [
                        "Select ",
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5qJVF.default), {
                            weight: "medium",
                            children: "View all"
                        }),
                        " to browser inserts."
                    ]
                })
            ]
        })
    });
};
const $ccd11f0d9a88743c$export$c4b59221ed3995fe = /*#__PURE__*/ (0, $eJOHy.memo)(({ items: items, onItemInsert: onItemInsert, onViewAllItemsClick: onViewAllItemsClick, query: query, setSelectedItem: setSelectedItem })=>{
    const onItemSelect = (0, $eJOHy.useCallback)((index)=>{
        onItemInsert((0, $7k8dr.SelectItemMode).SELECTED, index);
    }, [
        onItemInsert
    ]);
    const { suggested: suggested, categoryRegistry: categoryRegistry, itemsRegistry: itemsRegistry, selectedCategory: selectedCategory, searchItems: searchItems, setSelectedCategory: setSelectedCategory } = (0, $inQ44.useItems)(items, query);
    const showViewAllItems = Boolean(onViewAllItemsClick);
    const view = searchItems ? searchItems.length > 0 ? /*#__PURE__*/ (0, $gt9Am.jsx)($ccd11f0d9a88743c$var$SearchView, {
        items: searchItems,
        onItemSelected: onItemSelect,
        setSelectedItem: setSelectedItem
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)($ccd11f0d9a88743c$var$EmptySearchView, {}) : selectedCategory ? /*#__PURE__*/ (0, $gt9Am.jsx)($ccd11f0d9a88743c$var$CategoryView, {
        categoryRegistry: categoryRegistry,
        selectedCategory: selectedCategory,
        onItemSelected: onItemSelect,
        onBackButtonClicked: ()=>setSelectedCategory(undefined)
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)($ccd11f0d9a88743c$var$DefaultView, {
        suggested: suggested,
        itemsRegistry: itemsRegistry,
        categoryRegistry: categoryRegistry,
        onItemSelected: onItemSelect,
        onCategorySelected: (categoryId)=>{
            setSelectedCategory(categoryId);
        },
        setSelectedItem: setSelectedItem
    });
    if (showViewAllItems) return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            view,
            showViewAllItems && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aG5mc.ViewAllButtonItem), {
                isViewAllInserts: true,
                label: 'View all inserts',
                onClick: onViewAllItemsClick ? onViewAllItemsClick : ()=>{}
            })
        ]
    });
    else return view;
});

});
parcelRegister("inQ44", function(module, exports) {

$parcel$export(module.exports, "CategoriesStructure", () => $40fe34ab6d5092d7$export$55e347ea2fcfe5fb);
$parcel$export(module.exports, "PredefinedCategories", () => $40fe34ab6d5092d7$export$55985cbdefca4b42);
$parcel$export(module.exports, "useItems", () => $40fe34ab6d5092d7$export$7bfdd97581ca93c);

var $eJOHy = parcelRequire("eJOHy");

var $6Exgk = parcelRequire("6Exgk");

var $12rg6 = parcelRequire("12rg6");

var $LbAHp = parcelRequire("LbAHp");
const $40fe34ab6d5092d7$var$transformBrowserElementItem = (item)=>{
    return {
        index: item.tempKey,
        title: item.title,
        description: item.description,
        showDescription: Boolean(item?.id) && item.id !== 'datasource' ? false : true,
        keyshortcut: item.keyshortcut ? (0, $6Exgk.makeKeyMapWithCommon)('', item.keyshortcut) : undefined,
        renderIcon: item.icon
    };
};
const $40fe34ab6d5092d7$export$55e347ea2fcfe5fb = [
    {
        id: 'media',
        title: 'Media',
        subcategories: [],
        // defaultItems and array or native elements' ids or titles of an extensions
        // TODO: ED-26961 - how should we identify extensions in prod?
        // Note: only 'media' or 'media-insert' will be available, so we'll display only 5 default items
        defautltItems: [
            'media',
            'media-insert',
            'emoji',
            'hyperlink',
            'loom',
            'Create whiteboard'
        ]
    },
    {
        id: 'structure',
        title: 'Structure',
        subcategories: [
            {
                id: 'text structure',
                title: 'Text structure'
            },
            {
                id: 'page structure',
                title: 'Page structure'
            },
            {
                id: 'connect pages',
                title: 'Connect pages'
            },
            {
                id: 'navigation',
                title: 'Navigation'
            },
            {
                id: 'search',
                title: 'Search'
            }
        ],
        defautltItems: [
            'date',
            'decision',
            'status',
            'table',
            'Table of contents'
        ]
    },
    {
        id: 'data',
        title: 'Data',
        subcategories: [
            {
                id: 'charts',
                title: 'Charts'
            },
            {
                id: 'gadgets',
                title: 'Gadgets'
            },
            {
                id: 'jira',
                title: 'Jira'
            },
            {
                id: 'labels',
                title: 'Labels'
            },
            {
                id: 'reports',
                title: 'Reports'
            },
            {
                id: 'timelines',
                title: 'Timelines'
            }
        ],
        defautltItems: [
            'Create database',
            'Filter by label',
            'Chart',
            'Create Jira issue',
            'Content Report Table'
        ]
    },
    {
        id: 'collaborate',
        title: 'Collaborate',
        subcategories: [],
        defautltItems: [
            'mention',
            'Contributors',
            'Contributors Summary',
            'User Profile',
            'Spaces List'
        ]
    },
    {
        id: 'ai',
        title: 'Atlassian Intelligence',
        subcategories: [],
        defautltItems: []
    },
    {
        id: 'apps',
        title: 'Apps',
        subcategories: [],
        defautltItems: []
    }
];
const $40fe34ab6d5092d7$export$55985cbdefca4b42 = new Map();
$40fe34ab6d5092d7$export$55e347ea2fcfe5fb.forEach((categoryData)=>{
    $40fe34ab6d5092d7$export$55985cbdefca4b42.set(categoryData.id, categoryData);
    categoryData.subcategories.forEach((subcategoryData)=>{
        $40fe34ab6d5092d7$export$55985cbdefca4b42.set(subcategoryData.id, subcategoryData);
    });
});
const $40fe34ab6d5092d7$var$parseCategories = (itemCategories)=>{
    if (!itemCategories) return [
        'apps'
    ];
    const filteredCategories = itemCategories.filter((category)=>{
        return $40fe34ab6d5092d7$export$55985cbdefca4b42.has(category.toLocaleLowerCase());
    });
    return filteredCategories.length > 0 ? filteredCategories : [
        'apps'
    ];
};
const $40fe34ab6d5092d7$var$suggestedIds = [
    'table',
    'action',
    'codeblock',
    'infopanel',
    'threecolumnslayout',
    'emoji',
    'rule',
    'expand'
];
const $40fe34ab6d5092d7$export$7bfdd97581ca93c = (quickInsertPanelItems, query)=>{
    const [searchText, setSearchText] = (0, $eJOHy.useState)(query);
    const [selectedCategory, setSelectedCategory] = (0, $eJOHy.useState)();
    const insertPanelItems = (0, $eJOHy.useMemo)(()=>(0, $12rg6.getMappedItems)(quickInsertPanelItems), [
        quickInsertPanelItems
    ]);
    const categoryRegistry = {};
    const itemsRegistry = {};
    const suggestedItems = [];
    insertPanelItems.forEach((item)=>{
        const categories = $40fe34ab6d5092d7$var$parseCategories(item.categories);
        const preparedItem = $40fe34ab6d5092d7$var$transformBrowserElementItem(item);
        categories.forEach((category)=>{
            category = category.toLocaleLowerCase();
            if (categoryRegistry[category]) categoryRegistry[category].push(preparedItem);
            else categoryRegistry[category] = [
                preparedItem
            ];
        });
        const itemKey = item.id || item.title;
        itemsRegistry[itemKey] = preparedItem;
        for(let i = 0; i < $40fe34ab6d5092d7$var$suggestedIds.length; i++){
            const realSuggestedItems = suggestedItems.filter((item)=>item);
            if (realSuggestedItems.length < $40fe34ab6d5092d7$var$suggestedIds.length && itemKey === $40fe34ab6d5092d7$var$suggestedIds[i]) suggestedItems[i] = preparedItem;
        }
    });
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    const suggested = {
        id: 'suggested',
        label: 'Suggestions',
        items: suggestedItems
    }; // TODO define the id and label as constants
    // when query gets updated from the prop drilling it won't cause a re-render of the hook
    // as it will be treated only as default state, so for now combinbing searchText and query here
    // we need to find a better more performant solution for the search (after the demo)
    const combinedSearchText = (0, $eJOHy.useMemo)(()=>searchText || query, [
        query,
        searchText
    ]);
    const searchItems = (0, $eJOHy.useMemo)(()=>{
        if (!combinedSearchText) return undefined;
        const filteredItems = (0, $LbAHp.find)(combinedSearchText, insertPanelItems);
        return filteredItems.map((item)=>$40fe34ab6d5092d7$var$transformBrowserElementItem(item));
    }, [
        insertPanelItems,
        combinedSearchText
    ]);
    return {
        suggested: suggested,
        categoryRegistry: categoryRegistry,
        itemsRegistry: itemsRegistry,
        selectedCategory: selectedCategory,
        searchItems: searchItems,
        setSearchText: setSearchText,
        setSelectedCategory: setSelectedCategory
    };
};

});
parcelRegister("12rg6", function(module, exports) {

$parcel$export(module.exports, "getMappedItems", () => $3d986e0a51248d06$export$c9a8cf32755faa87);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $l8Loi = parcelRequire("l8Loi");

var $5Fohz = parcelRequire("5Fohz");

var $iHaKK = parcelRequire("iHaKK");

var $8lO5P = parcelRequire("8lO5P");

var $btkTq = parcelRequire("btkTq");

var $kXFxs = parcelRequire("kXFxs");

var $euu4D = parcelRequire("euu4D");

var $1U4zO = parcelRequire("1U4zO");

var $fJNLD = parcelRequire("fJNLD");

var $6BR9Q = parcelRequire("6BR9Q");

var $9Nvwv = parcelRequire("9Nvwv");

var $cV8sz = parcelRequire("cV8sz");

var $4HB8x = parcelRequire("4HB8x");

var $amerd = parcelRequire("amerd");

var $bwM92 = parcelRequire("bwM92");

var $bTWCd = parcelRequire("bTWCd");
const $3d986e0a51248d06$var$getItemData = (item, tempKey)=>{
    const itemId = item.id;
    const itemTitle = item.title;
    if (itemId && itemId !== 'datasource') switch(itemId){
        case 'action':
            return {
                ...item,
                icon: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bwM92))), {
                        label: ""
                    }),
                categories: [
                    'text structure'
                ],
                shouldDisplayAtTop: true,
                tempKey: tempKey
            };
        case 'media-insert':
            return {
                ...item,
                icon: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fJNLD))), {
                        label: ""
                    }),
                categories: [
                    'media'
                ],
                shouldDisplayAtTop: true,
                tempKey: tempKey
            };
        case 'mention':
            return {
                ...item,
                icon: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4HB8x))), {
                        label: ""
                    }),
                categories: [
                    'collaborate'
                ],
                shouldDisplayAtTop: true,
                tempKey: tempKey
            };
        case 'emoji':
            return {
                ...item,
                icon: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($euu4D))), {
                        label: ""
                    }),
                categories: [
                    'media'
                ],
                shouldDisplayAtTop: true,
                tempKey: tempKey
            };
        case 'expand':
            return {
                ...item,
                icon: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5Fohz))), {
                        label: ""
                    }),
                categories: [
                    'page structure'
                ],
                shouldDisplayAtTop: true,
                tempKey: tempKey
            };
        case 'table':
            return {
                ...item,
                icon: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1U4zO))), {
                        label: ""
                    }),
                categories: [
                    'page structure'
                ],
                shouldDisplayAtTop: true,
                tempKey: tempKey
            };
        case 'codeblock':
            return {
                ...item,
                icon: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8lO5P))), {
                        label: ""
                    }),
                categories: [
                    'text structure'
                ],
                shouldDisplayAtTop: true,
                tempKey: tempKey
            };
        case 'status':
            return {
                ...item,
                icon: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iHaKK))), {
                        label: ""
                    }),
                categories: [
                    'text structure'
                ],
                shouldDisplayAtTop: true,
                tempKey: tempKey
            };
        case 'infopanel':
            return {
                ...item,
                icon: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6BR9Q))), {
                        label: ""
                    }),
                categories: [
                    'page structure'
                ],
                shouldDisplayAtTop: true,
                title: 'Panel',
                tempKey: tempKey
            };
        case 'date':
            return {
                ...item,
                icon: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($btkTq))), {
                        label: ""
                    }),
                categories: [
                    'date'
                ],
                shouldDisplayAtTop: true,
                tempKey: tempKey
            };
        case 'loom':
            return {
                ...item,
                icon: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bTWCd))), {
                        label: ""
                    }),
                categories: [
                    'media'
                ],
                shouldDisplayAtTop: true,
                tempKey: tempKey
            };
        case 'decision':
            return {
                ...item,
                icon: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kXFxs))), {
                        label: ""
                    }),
                categories: [
                    'text structure'
                ],
                shouldDisplayAtTop: true,
                tempKey: tempKey
            };
        case 'threecolumnslayout':
            return {
                ...item,
                icon: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9Nvwv))), {
                        label: ""
                    }),
                categories: [
                    'page structure'
                ],
                shouldDisplayAtTop: true,
                title: 'Layout',
                tempKey: tempKey
            };
        case 'hyperlink':
            return {
                ...item,
                icon: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cV8sz))), {
                        label: ""
                    }),
                categories: [
                    'media'
                ],
                shouldDisplayAtTop: true,
                tempKey: tempKey
            };
        case 'rule':
            return {
                ...item,
                icon: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($l8Loi))), {
                        label: ""
                    }),
                categories: [
                    'page structure'
                ],
                shouldDisplayAtTop: true,
                tempKey: tempKey
            };
        case 'blockquote':
            return {
                ...item,
                icon: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($amerd))), {
                        label: ""
                    }),
                categories: [
                    'text structure'
                ],
                shouldDisplayAtTop: true,
                tempKey: tempKey
            };
    }
    else if (itemTitle) switch(itemTitle){
        case 'Assets':
            return {
                ...item,
                categories: [
                    'data'
                ],
                tempKey: tempKey
            };
        case 'Jira Issues':
        case 'Jira Road Map':
            return {
                ...item,
                categories: [
                    'jira'
                ],
                tempKey: tempKey
            };
        case 'Labels List':
        case 'Related Labels':
        case 'Labels Gadget':
        case 'Popular Labels':
            return {
                ...item,
                categories: [
                    'labels'
                ],
                tempKey: tempKey
            };
        case 'Version Report':
        case 'Time to First Response':
        case 'Decision report':
        case 'Two Dimensional Filter Statistics':
        case 'Task report':
        case 'Issue Statistics':
        case 'Page Properties Report':
            return {
                ...item,
                categories: [
                    'reports'
                ],
                tempKey: tempKey
            };
        case 'Opsgenie Incident Timeline EU':
        case 'Opsgenie Incident Timeline':
        case 'Jira timeline':
        case 'JSM Incident Timeline EU':
        case 'JSM Incident Timeline':
        case 'Resolution Time':
            return {
                ...item,
                categories: [
                    'timelines'
                ],
                tempKey: tempKey
            };
        case 'Create database':
        case 'Filter by label':
        case 'Chart':
        case 'Create Jira issue':
        case 'Content Report Table':
            return {
                ...item,
                categories: [
                    'data'
                ],
                shouldDisplayAtTop: true,
                tempKey: tempKey
            };
        case 'Heat Map':
        case 'Pie Chart':
        case 'Time Since Chart':
        case 'Recently Created Chart':
        case 'Created vs. Resolved Chart':
        case 'Average Age Chart':
            return {
                ...item,
                categories: [
                    'charts'
                ],
                tempKey: tempKey
            };
        case 'Agile Wallboard Gadget':
        case 'Sprint Burndown Gadget':
            return {
                ...item,
                categories: [
                    'gadgets'
                ],
                tempKey: tempKey
            };
        case 'Anchor link':
        case 'Child pages':
        case 'Page Index':
            return {
                ...item,
                categories: [
                    'navigation'
                ],
                tempKey: tempKey
            };
        case 'Table of contents':
            return {
                ...item,
                categories: [
                    'page structure'
                ],
                tempKey: tempKey
            };
        case 'Insert Confluence list':
        case 'Live Search':
        case 'Page Tree Search':
        case 'Page Tree':
            return {
                ...item,
                categories: [
                    'search'
                ],
                tempKey: tempKey
            };
        case 'Excerpt':
        case 'Recently Updated Dashboard':
        case 'Create from Template':
            return {
                ...item,
                categories: [
                    'connect pages'
                ],
                tempKey: tempKey
            };
        case 'Powerpoint':
        case 'Excel':
        case 'Iframe':
        case 'Profile Picture':
        case 'Blog Posts':
        case 'Gallery':
        case 'Word':
        case 'PDF':
        case 'Widget Connector':
            return {
                ...item,
                categories: [
                    'media'
                ],
                tempKey: tempKey
            };
        case 'Create whiteboard':
            return {
                ...item,
                categories: [
                    'media'
                ],
                shouldDisplayAtTop: true,
                tempKey: tempKey
            };
        case 'Contributors':
        case 'Contributors Summary':
        case 'User List':
        case 'Voted Issues':
        case 'User Profile':
        case 'Spaces List':
            return {
                ...item,
                categories: [
                    'collaborate'
                ],
                tempKey: tempKey
            };
        case 'Gliffy Diagram':
            return {
                ...item,
                categories: [
                    'apps'
                ],
                tempKey: tempKey
            };
        default:
            return {
                ...item,
                tempKey: tempKey
            };
    }
    return {
        ...item,
        categories: [
            'apps'
        ],
        tempKey: // category: 'apps',
        // subCategory: undefined,
        tempKey
    };
};
const $3d986e0a51248d06$export$c9a8cf32755faa87 = (items)=>{
    return items.map((item, index)=>$3d986e0a51248d06$var$getItemData(item, index));
};

});
parcelRegister("l8Loi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::42c245ec8a5b0fa184f110b30fb6ce93>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f63f1b2ea61437e3$var$_react = $f63f1b2ea61437e3$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $f63f1b2ea61437e3$var$_baseNew = $f63f1b2ea61437e3$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $f63f1b2ea61437e3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "DividerElement".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for inserting divider elements in Confluence
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f63f1b2ea61437e3$var$DividerElementIcon = (props)=>/*#__PURE__*/ $f63f1b2ea61437e3$var$_react.default.createElement($f63f1b2ea61437e3$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14 15v-2.5a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2V15h1.5v-2.5A.5.5 0 0 1 4 12h8a.5.5 0 0 1 .5.5V15zm2-7.75H0v1.5h16zM2 3.5a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V1h-1.5v2.5a.5.5 0 0 1-.5.5H4a.5.5 0 0 1-.5-.5V1H2z" clip-rule="evenodd"/>`
    }, props));
$f63f1b2ea61437e3$var$DividerElementIcon.displayName = 'DividerElementIcon';
var $f63f1b2ea61437e3$var$_default = module.exports.default = $f63f1b2ea61437e3$var$DividerElementIcon;

});

parcelRegister("5Fohz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a282fcec9b1cefd6b5b937a5b07c1f5e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $42039e0ef4ab9b94$var$_react = $42039e0ef4ab9b94$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $42039e0ef4ab9b94$var$_baseNew = $42039e0ef4ab9b94$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $42039e0ef4ab9b94$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ExpandElement".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for inserting expand elements in Confluence
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $42039e0ef4ab9b94$var$ExpandElementIcon = (props)=>/*#__PURE__*/ $42039e0ef4ab9b94$var$_react.default.createElement($42039e0ef4ab9b94$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h12v1.5H3a.5.5 0 0 0-.5.5v12H1z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M7.48 8.42 4.61 5.67l1.04-1.08L8 6.84l2.36-2.25 1.04 1.08-2.87 2.75a.75.75 0 0 1-1.04 0M15 12H4.5v-1.5H15zm0 3H4.5v-1.5H15z" clip-rule="evenodd"/>`
    }, props));
$42039e0ef4ab9b94$var$ExpandElementIcon.displayName = 'ExpandElementIcon';
var $42039e0ef4ab9b94$var$_default = module.exports.default = $42039e0ef4ab9b94$var$ExpandElementIcon;

});

parcelRegister("iHaKK", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f3dcba78c5e5642b8396cd93a41d6ef1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d9c49578a1a4196a$var$_react = $d9c49578a1a4196a$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $d9c49578a1a4196a$var$_baseNew = $d9c49578a1a4196a$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $d9c49578a1a4196a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Lozenge".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for inserting status lozenges in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d9c49578a1a4196a$var$LozengeIcon = (props)=>/*#__PURE__*/ $d9c49578a1a4196a$var$_react.default.createElement($d9c49578a1a4196a$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5V6a.5.5 0 0 0-.5-.5zm11 3.25H3v-1.5h10z" clip-rule="evenodd"/>`
    }, props));
$d9c49578a1a4196a$var$LozengeIcon.displayName = 'LozengeIcon';
var $d9c49578a1a4196a$var$_default = module.exports.default = $d9c49578a1a4196a$var$LozengeIcon;

});

parcelRegister("kXFxs", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::be0b9c9537e0b69b1d3c8d2587861fe5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f4298a06d23defad$var$_react = $f4298a06d23defad$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $f4298a06d23defad$var$_baseNew = $f4298a06d23defad$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $f4298a06d23defad$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Decision".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for decisions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f4298a06d23defad$var$DecisionIcon = (props)=>/*#__PURE__*/ $f4298a06d23defad$var$_react.default.createElement($f4298a06d23defad$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m13.97.97-4.5 4.5 1.06 1.06 4.5-4.5zM3.56 2.5H8V1H1.75a.75.75 0 0 0-.75.75V8h1.5V3.56l4.604 4.604a.5.5 0 0 1 .146.354V15h1.5V8.518a2 2 0 0 0-.586-1.414z" clip-rule="evenodd"/>`
    }, props));
$f4298a06d23defad$var$DecisionIcon.displayName = 'DecisionIcon';
var $f4298a06d23defad$var$_default = module.exports.default = $f4298a06d23defad$var$DecisionIcon;

});

parcelRegister("euu4D", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ed0744cae5af6a1635a1b9234b867386>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a8cb3213f8552b4b$var$_react = $a8cb3213f8552b4b$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $a8cb3213f8552b4b$var$_baseNew = $a8cb3213f8552b4b$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $a8cb3213f8552b4b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Emoji".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Editor as a category for Emoji's.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a8cb3213f8552b4b$var$EmojiIcon = (props)=>/*#__PURE__*/ $a8cb3213f8552b4b$var$_react.default.createElement($a8cb3213f8552b4b$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m4.5-1.75a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m4.5 0a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m-2.915 3.783c.486.378 1.14.717 1.915.717s1.43-.34 1.915-.717a4.4 4.4 0 0 0 .721-.714l.005-.007-.001.002.61.436.61.436-.001.002-.002.003-.006.007-.016.023-.056.071q-.07.091-.2.235c-.17.189-.42.439-.744.69-.64.497-1.61 1.033-2.835 1.033s-2.196-.536-2.835-1.033a6 6 0 0 1-.944-.925l-.056-.071-.016-.023-.006-.007-.002-.003v-.001s-.001-.001.609-.437l.61-.436-.001-.002.005.007.03.04q.045.056.139.161c.126.14.313.327.552.513" clip-rule="evenodd"/>`
    }, props));
$a8cb3213f8552b4b$var$EmojiIcon.displayName = 'EmojiIcon';
var $a8cb3213f8552b4b$var$_default = module.exports.default = $a8cb3213f8552b4b$var$EmojiIcon;

});

parcelRegister("1U4zO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7de7b5804889990b150be57e7707dfe0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $162e923fc261d827$var$_react = $162e923fc261d827$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $162e923fc261d827$var$_baseNew = $162e923fc261d827$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $162e923fc261d827$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Grid".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: spaces in Confluence, and grid view, all content in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $162e923fc261d827$var$GridIcon = (props)=>/*#__PURE__*/ $162e923fc261d827$var$_react.default.createElement($162e923fc261d827$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v4.25h4.75V2.5zm5.75 0v4.75h4.75V3a.5.5 0 0 0-.5-.5zm4.75 6.25H8.75v4.75H13a.5.5 0 0 0 .5-.5zM7.25 13.5V8.75H2.5V13a.5.5 0 0 0 .5.5z" clip-rule="evenodd"/>`
    }, props));
$162e923fc261d827$var$GridIcon.displayName = 'GridIcon';
var $162e923fc261d827$var$_default = module.exports.default = $162e923fc261d827$var$GridIcon;

});

parcelRegister("fJNLD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::92d4dfc113a3924af0f8a9fba22d539c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b751a9bb99d4e227$var$_react = $b751a9bb99d4e227$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $b751a9bb99d4e227$var$_baseNew = $b751a9bb99d4e227$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $b751a9bb99d4e227$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Image".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: images, image upload.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b751a9bb99d4e227$var$ImageIcon = (props)=>/*#__PURE__*/ $b751a9bb99d4e227$var$_react.default.createElement($b751a9bb99d4e227$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M5.75 4a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5"/><path fill="currentcolor" fill-rule="evenodd" d="M13 1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2zM3 2.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h.644l6.274-7.723.053-.058a.75.75 0 0 1 1.06 0L13.5 8.19V3a.5.5 0 0 0-.5-.5zm2.575 11H13a.5.5 0 0 0 .5-.5v-2.69l-2.943-2.943z" clip-rule="evenodd"/>`
    }, props));
$b751a9bb99d4e227$var$ImageIcon.displayName = 'ImageIcon';
var $b751a9bb99d4e227$var$_default = module.exports.default = $b751a9bb99d4e227$var$ImageIcon;

});

parcelRegister("6BR9Q", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8a02f6f2bebc5924b5c7f92f48f61953>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4cff6ecfc53acec2$var$_react = $4cff6ecfc53acec2$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $4cff6ecfc53acec2$var$_baseNew = $4cff6ecfc53acec2$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $4cff6ecfc53acec2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "InformationCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: For highlighting information when less visual emphasis is needed within the UI compared to the filled information status icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4cff6ecfc53acec2$var$InformationCircleIcon = (props)=>/*#__PURE__*/ $4cff6ecfc53acec2$var$_react.default.createElement($4cff6ecfc53acec2$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m7.25.25H6.5v-1.5H8a.75.75 0 0 1 .75.75v5h-1.5z" clip-rule="evenodd"/><path fill="currentcolor" d="M9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$4cff6ecfc53acec2$var$InformationCircleIcon.displayName = 'InformationCircleIcon';
var $4cff6ecfc53acec2$var$_default = module.exports.default = $4cff6ecfc53acec2$var$InformationCircleIcon;

});

parcelRegister("9Nvwv", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::455753a667f20f1d7529d077b0a47e9b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $72212488ee4829d1$var$_react = $72212488ee4829d1$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $72212488ee4829d1$var$_baseNew = $72212488ee4829d1$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $72212488ee4829d1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LayoutThreeColumns".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for 3 column layout option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $72212488ee4829d1$var$LayoutThreeColumnsIcon = (props)=>/*#__PURE__*/ $72212488ee4829d1$var$_react.default.createElement($72212488ee4829d1$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 2.375C0 1.615.616 1 1.375 1h1.5c.76 0 1.375.616 1.375 1.375v11.25c0 .76-.616 1.375-1.375 1.375h-1.5C.615 15 0 14.384 0 13.625zm1.5.125v11h1.25v-11zm4.25-.125C5.75 1.615 6.366 1 7.125 1h1.75c.76 0 1.375.616 1.375 1.375v11.25c0 .76-.616 1.375-1.375 1.375h-1.75c-.76 0-1.375-.616-1.375-1.375zm1.5.125v11h1.5v-11zm4.5-.125c0-.76.616-1.375 1.375-1.375h1.5C15.385 1 16 1.616 16 2.375v11.25c0 .76-.616 1.375-1.375 1.375h-1.5c-.76 0-1.375-.616-1.375-1.375zm1.5.125v11h1.25v-11z" clip-rule="evenodd"/>`
    }, props));
$72212488ee4829d1$var$LayoutThreeColumnsIcon.displayName = 'LayoutThreeColumnsIcon';
var $72212488ee4829d1$var$_default = module.exports.default = $72212488ee4829d1$var$LayoutThreeColumnsIcon;

});

parcelRegister("bTWCd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0d7f4cbe44d53d27d30976de2191c923>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8aa24c8f6652c10c$var$_react = $8aa24c8f6652c10c$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $8aa24c8f6652c10c$var$_baseNew = $8aa24c8f6652c10c$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $8aa24c8f6652c10c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Video".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for representing video content across Atlassian and Loom.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8aa24c8f6652c10c$var$VideoIcon = (props)=>/*#__PURE__*/ $8aa24c8f6652c10c$var$_react.default.createElement($8aa24c8f6652c10c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 4a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5v-7A.5.5 0 0 0 10 4zm-2 .5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v.218l2.137-1.203A1.25 1.25 0 0 1 16 4.605v6.79a1.25 1.25 0 0 1-1.863 1.09L12 11.282v.218a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm12 5.061 2.5 1.407V5.032L12 6.44z" clip-rule="evenodd"/>`
    }, props));
$8aa24c8f6652c10c$var$VideoIcon.displayName = 'VideoIcon';
var $8aa24c8f6652c10c$var$_default = module.exports.default = $8aa24c8f6652c10c$var$VideoIcon;

});


parcelRegister("LbAHp", function(module, exports) {

$parcel$export(module.exports, "find", () => $583415a7ae6ba102$export$71aa6c912b956294);

var $jKEuU = parcelRequire("jKEuU");
// Copied from platform/packages/editor/editor-common/src/quick-insert/utils.ts
const $583415a7ae6ba102$var$options = {
    threshold: 0.3,
    includeScore: true,
    keys: [
        {
            name: 'title',
            weight: 0.57
        },
        {
            name: 'priority',
            weight: 0.3
        },
        {
            name: 'keywords',
            weight: 0.08
        },
        {
            name: 'description',
            weight: 0.04
        },
        {
            name: 'keyshortcut',
            weight: 0.01
        }
    ]
};
// If an item has an id, it is a native editor element
// for the demo we could also use item.shouldDisplayAtTop (can potentially be
// replaced by item.isEditorExtention or something similar).
// For now, let's test search usring id as it is closer to production implementation.
const $583415a7ae6ba102$var$prioritySortingFn = (items)=>{
    return (a, b)=>{
        if (items[a.idx].id && items[b.idx].id) return a.score - b.score;
        else if (items[a.idx].id) return -1;
        else return 1;
    };
};
function $583415a7ae6ba102$export$71aa6c912b956294(query, items) {
    if (query === '') // Copy and sort list by priority
    return items.slice(0).sort((a, b)=>(a.priority || Number.POSITIVE_INFINITY) - (b.priority || Number.POSITIVE_INFINITY));
    const fuseOptions = {
        ...$583415a7ae6ba102$var$options,
        sortFn: $583415a7ae6ba102$var$prioritySortingFn(items)
    };
    const fuse = new (0, $jKEuU.default)(items, fuseOptions);
    return fuse.search(query).map((result)=>result.item);
}

});
parcelRegister("jKEuU", function(module, exports) {

$parcel$export(module.exports, "default", () => $e611ba2c9fb0d567$export$2e2bcd8739ae039);
/**
 * Fuse.js v6.6.2 - Lightweight fuzzy-search (http://fusejs.io)
 *
 * Copyright (c) 2022 Kiro Risk (http://kiro.me)
 * All Rights Reserved. Apache Software License 2.0
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 */ function $e611ba2c9fb0d567$var$isArray(value) {
    return !Array.isArray ? $e611ba2c9fb0d567$var$getTag(value) === '[object Array]' : Array.isArray(value);
}
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/baseToString.js
const $e611ba2c9fb0d567$var$INFINITY = 1 / 0;
function $e611ba2c9fb0d567$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    let result = value + '';
    return result == '0' && 1 / value == -$e611ba2c9fb0d567$var$INFINITY ? '-0' : result;
}
function $e611ba2c9fb0d567$var$toString(value) {
    return value == null ? '' : $e611ba2c9fb0d567$var$baseToString(value);
}
function $e611ba2c9fb0d567$var$isString(value) {
    return typeof value === 'string';
}
function $e611ba2c9fb0d567$var$isNumber(value) {
    return typeof value === 'number';
}
// Adapted from: https://github.com/lodash/lodash/blob/master/isBoolean.js
function $e611ba2c9fb0d567$var$isBoolean(value) {
    return value === true || value === false || $e611ba2c9fb0d567$var$isObjectLike(value) && $e611ba2c9fb0d567$var$getTag(value) == '[object Boolean]';
}
function $e611ba2c9fb0d567$var$isObject(value) {
    return typeof value === 'object';
}
// Checks if `value` is object-like.
function $e611ba2c9fb0d567$var$isObjectLike(value) {
    return $e611ba2c9fb0d567$var$isObject(value) && value !== null;
}
function $e611ba2c9fb0d567$var$isDefined(value) {
    return value !== undefined && value !== null;
}
function $e611ba2c9fb0d567$var$isBlank(value) {
    return !value.trim().length;
}
// Gets the `toStringTag` of `value`.
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/getTag.js
function $e611ba2c9fb0d567$var$getTag(value) {
    return value == null ? value === undefined ? '[object Undefined]' : '[object Null]' : Object.prototype.toString.call(value);
}
const $e611ba2c9fb0d567$var$EXTENDED_SEARCH_UNAVAILABLE = 'Extended search is not available';
const $e611ba2c9fb0d567$var$INCORRECT_INDEX_TYPE = "Incorrect 'index' type";
const $e611ba2c9fb0d567$var$LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY = (key)=>`Invalid value for key ${key}`;
const $e611ba2c9fb0d567$var$PATTERN_LENGTH_TOO_LARGE = (max)=>`Pattern length exceeds max of ${max}.`;
const $e611ba2c9fb0d567$var$MISSING_KEY_PROPERTY = (name)=>`Missing ${name} property in key`;
const $e611ba2c9fb0d567$var$INVALID_KEY_WEIGHT_VALUE = (key)=>`Property 'weight' in key '${key}' must be a positive integer`;
const $e611ba2c9fb0d567$var$hasOwn = Object.prototype.hasOwnProperty;
class $e611ba2c9fb0d567$var$KeyStore {
    constructor(keys){
        this._keys = [];
        this._keyMap = {};
        let totalWeight = 0;
        keys.forEach((key)=>{
            let obj = $e611ba2c9fb0d567$var$createKey(key);
            totalWeight += obj.weight;
            this._keys.push(obj);
            this._keyMap[obj.id] = obj;
            totalWeight += obj.weight;
        });
        // Normalize weights so that their sum is equal to 1
        this._keys.forEach((key)=>{
            key.weight /= totalWeight;
        });
    }
    get(keyId) {
        return this._keyMap[keyId];
    }
    keys() {
        return this._keys;
    }
    toJSON() {
        return JSON.stringify(this._keys);
    }
}
function $e611ba2c9fb0d567$var$createKey(key) {
    let path = null;
    let id = null;
    let src = null;
    let weight = 1;
    let getFn = null;
    if ($e611ba2c9fb0d567$var$isString(key) || $e611ba2c9fb0d567$var$isArray(key)) {
        src = key;
        path = $e611ba2c9fb0d567$var$createKeyPath(key);
        id = $e611ba2c9fb0d567$var$createKeyId(key);
    } else {
        if (!$e611ba2c9fb0d567$var$hasOwn.call(key, 'name')) throw new Error($e611ba2c9fb0d567$var$MISSING_KEY_PROPERTY('name'));
        const name = key.name;
        src = name;
        if ($e611ba2c9fb0d567$var$hasOwn.call(key, 'weight')) {
            weight = key.weight;
            if (weight <= 0) throw new Error($e611ba2c9fb0d567$var$INVALID_KEY_WEIGHT_VALUE(name));
        }
        path = $e611ba2c9fb0d567$var$createKeyPath(name);
        id = $e611ba2c9fb0d567$var$createKeyId(name);
        getFn = key.getFn;
    }
    return {
        path: path,
        id: id,
        weight: weight,
        src: src,
        getFn: getFn
    };
}
function $e611ba2c9fb0d567$var$createKeyPath(key) {
    return $e611ba2c9fb0d567$var$isArray(key) ? key : key.split('.');
}
function $e611ba2c9fb0d567$var$createKeyId(key) {
    return $e611ba2c9fb0d567$var$isArray(key) ? key.join('.') : key;
}
function $e611ba2c9fb0d567$var$get(obj, path) {
    let list = [];
    let arr = false;
    const deepGet = (obj, path, index)=>{
        if (!$e611ba2c9fb0d567$var$isDefined(obj)) return;
        if (!path[index]) // If there's no path left, we've arrived at the object we care about.
        list.push(obj);
        else {
            let key = path[index];
            const value = obj[key];
            if (!$e611ba2c9fb0d567$var$isDefined(value)) return;
            // If we're at the last value in the path, and if it's a string/number/bool,
            // add it to the list
            if (index === path.length - 1 && ($e611ba2c9fb0d567$var$isString(value) || $e611ba2c9fb0d567$var$isNumber(value) || $e611ba2c9fb0d567$var$isBoolean(value))) list.push($e611ba2c9fb0d567$var$toString(value));
            else if ($e611ba2c9fb0d567$var$isArray(value)) {
                arr = true;
                // Search each item in the array.
                for(let i = 0, len = value.length; i < len; i += 1)deepGet(value[i], path, index + 1);
            } else if (path.length) // An object. Recurse further.
            deepGet(value, path, index + 1);
        }
    };
    // Backwards compatibility (since path used to be a string)
    deepGet(obj, $e611ba2c9fb0d567$var$isString(path) ? path.split('.') : path, 0);
    return arr ? list : list[0];
}
const $e611ba2c9fb0d567$var$MatchOptions = {
    // Whether the matches should be included in the result set. When `true`, each record in the result
    // set will include the indices of the matched characters.
    // These can consequently be used for highlighting purposes.
    includeMatches: false,
    // When `true`, the matching function will continue to the end of a search pattern even if
    // a perfect match has already been located in the string.
    findAllMatches: false,
    // Minimum number of characters that must be matched before a result is considered a match
    minMatchCharLength: 1
};
const $e611ba2c9fb0d567$var$BasicOptions = {
    // When `true`, the algorithm continues searching to the end of the input even if a perfect
    // match is found before the end of the same input.
    isCaseSensitive: false,
    // When true, the matching function will continue to the end of a search pattern even if
    includeScore: false,
    // List of properties that will be searched. This also supports nested properties.
    keys: [],
    // Whether to sort the result list, by score
    shouldSort: true,
    // Default sort function: sort by ascending score, ascending index
    sortFn: (a, b)=>a.score === b.score ? a.idx < b.idx ? -1 : 1 : a.score < b.score ? -1 : 1
};
const $e611ba2c9fb0d567$var$FuzzyOptions = {
    // Approximately where in the text is the pattern expected to be found?
    location: 0,
    // At what point does the match algorithm give up. A threshold of '0.0' requires a perfect match
    // (of both letters and location), a threshold of '1.0' would match anything.
    threshold: 0.6,
    // Determines how close the match must be to the fuzzy location (specified above).
    // An exact letter match which is 'distance' characters away from the fuzzy location
    // would score as a complete mismatch. A distance of '0' requires the match be at
    // the exact location specified, a threshold of '1000' would require a perfect match
    // to be within 800 characters of the fuzzy location to be found using a 0.8 threshold.
    distance: 100
};
const $e611ba2c9fb0d567$var$AdvancedOptions = {
    // When `true`, it enables the use of unix-like search commands
    useExtendedSearch: false,
    // The get function to use when fetching an object's properties.
    // The default will search nested paths *ie foo.bar.baz*
    getFn: $e611ba2c9fb0d567$var$get,
    // When `true`, search will ignore `location` and `distance`, so it won't matter
    // where in the string the pattern appears.
    // More info: https://fusejs.io/concepts/scoring-theory.html#fuzziness-score
    ignoreLocation: false,
    // When `true`, the calculation for the relevance score (used for sorting) will
    // ignore the field-length norm.
    // More info: https://fusejs.io/concepts/scoring-theory.html#field-length-norm
    ignoreFieldNorm: false,
    // The weight to determine how much field length norm effects scoring.
    fieldNormWeight: 1
};
var $e611ba2c9fb0d567$var$Config = {
    ...$e611ba2c9fb0d567$var$BasicOptions,
    ...$e611ba2c9fb0d567$var$MatchOptions,
    ...$e611ba2c9fb0d567$var$FuzzyOptions,
    ...$e611ba2c9fb0d567$var$AdvancedOptions
};
const $e611ba2c9fb0d567$var$SPACE = /[^ ]+/g;
// Field-length norm: the shorter the field, the higher the weight.
// Set to 3 decimals to reduce index size.
function $e611ba2c9fb0d567$var$norm(weight = 1, mantissa = 3) {
    const cache = new Map();
    const m = Math.pow(10, mantissa);
    return {
        get (value) {
            const numTokens = value.match($e611ba2c9fb0d567$var$SPACE).length;
            if (cache.has(numTokens)) return cache.get(numTokens);
            // Default function is 1/sqrt(x), weight makes that variable
            const norm = 1 / Math.pow(numTokens, 0.5 * weight);
            // In place of `toFixed(mantissa)`, for faster computation
            const n = parseFloat(Math.round(norm * m) / m);
            cache.set(numTokens, n);
            return n;
        },
        clear () {
            cache.clear();
        }
    };
}
class $e611ba2c9fb0d567$var$FuseIndex {
    constructor({ getFn: getFn = $e611ba2c9fb0d567$var$Config.getFn, fieldNormWeight: fieldNormWeight = $e611ba2c9fb0d567$var$Config.fieldNormWeight } = {}){
        this.norm = $e611ba2c9fb0d567$var$norm(fieldNormWeight, 3);
        this.getFn = getFn;
        this.isCreated = false;
        this.setIndexRecords();
    }
    setSources(docs = []) {
        this.docs = docs;
    }
    setIndexRecords(records = []) {
        this.records = records;
    }
    setKeys(keys = []) {
        this.keys = keys;
        this._keysMap = {};
        keys.forEach((key, idx)=>{
            this._keysMap[key.id] = idx;
        });
    }
    create() {
        if (this.isCreated || !this.docs.length) return;
        this.isCreated = true;
        // List is Array<String>
        if ($e611ba2c9fb0d567$var$isString(this.docs[0])) this.docs.forEach((doc, docIndex)=>{
            this._addString(doc, docIndex);
        });
        else // List is Array<Object>
        this.docs.forEach((doc, docIndex)=>{
            this._addObject(doc, docIndex);
        });
        this.norm.clear();
    }
    // Adds a doc to the end of the index
    add(doc) {
        const idx = this.size();
        if ($e611ba2c9fb0d567$var$isString(doc)) this._addString(doc, idx);
        else this._addObject(doc, idx);
    }
    // Removes the doc at the specified index of the index
    removeAt(idx) {
        this.records.splice(idx, 1);
        // Change ref index of every subsquent doc
        for(let i = idx, len = this.size(); i < len; i += 1)this.records[i].i -= 1;
    }
    getValueForItemAtKeyId(item, keyId) {
        return item[this._keysMap[keyId]];
    }
    size() {
        return this.records.length;
    }
    _addString(doc, docIndex) {
        if (!$e611ba2c9fb0d567$var$isDefined(doc) || $e611ba2c9fb0d567$var$isBlank(doc)) return;
        let record = {
            v: doc,
            i: docIndex,
            n: this.norm.get(doc)
        };
        this.records.push(record);
    }
    _addObject(doc, docIndex) {
        let record = {
            i: docIndex,
            $: {}
        };
        // Iterate over every key (i.e, path), and fetch the value at that key
        this.keys.forEach((key, keyIndex)=>{
            let value = key.getFn ? key.getFn(doc) : this.getFn(doc, key.path);
            if (!$e611ba2c9fb0d567$var$isDefined(value)) return;
            if ($e611ba2c9fb0d567$var$isArray(value)) {
                let subRecords = [];
                const stack = [
                    {
                        nestedArrIndex: -1,
                        value: value
                    }
                ];
                while(stack.length){
                    const { nestedArrIndex: nestedArrIndex, value: value } = stack.pop();
                    if (!$e611ba2c9fb0d567$var$isDefined(value)) continue;
                    if ($e611ba2c9fb0d567$var$isString(value) && !$e611ba2c9fb0d567$var$isBlank(value)) {
                        let subRecord = {
                            v: value,
                            i: nestedArrIndex,
                            n: this.norm.get(value)
                        };
                        subRecords.push(subRecord);
                    } else if ($e611ba2c9fb0d567$var$isArray(value)) value.forEach((item, k)=>{
                        stack.push({
                            nestedArrIndex: k,
                            value: item
                        });
                    });
                }
                record.$[keyIndex] = subRecords;
            } else if ($e611ba2c9fb0d567$var$isString(value) && !$e611ba2c9fb0d567$var$isBlank(value)) {
                let subRecord = {
                    v: value,
                    n: this.norm.get(value)
                };
                record.$[keyIndex] = subRecord;
            }
        });
        this.records.push(record);
    }
    toJSON() {
        return {
            keys: this.keys,
            records: this.records
        };
    }
}
function $e611ba2c9fb0d567$var$createIndex(keys, docs, { getFn: getFn = $e611ba2c9fb0d567$var$Config.getFn, fieldNormWeight: fieldNormWeight = $e611ba2c9fb0d567$var$Config.fieldNormWeight } = {}) {
    const myIndex = new $e611ba2c9fb0d567$var$FuseIndex({
        getFn: getFn,
        fieldNormWeight: fieldNormWeight
    });
    myIndex.setKeys(keys.map($e611ba2c9fb0d567$var$createKey));
    myIndex.setSources(docs);
    myIndex.create();
    return myIndex;
}
function $e611ba2c9fb0d567$var$parseIndex(data, { getFn: getFn = $e611ba2c9fb0d567$var$Config.getFn, fieldNormWeight: fieldNormWeight = $e611ba2c9fb0d567$var$Config.fieldNormWeight } = {}) {
    const { keys: keys, records: records } = data;
    const myIndex = new $e611ba2c9fb0d567$var$FuseIndex({
        getFn: getFn,
        fieldNormWeight: fieldNormWeight
    });
    myIndex.setKeys(keys);
    myIndex.setIndexRecords(records);
    return myIndex;
}
function $e611ba2c9fb0d567$var$computeScore$1(pattern, { errors: errors = 0, currentLocation: currentLocation = 0, expectedLocation: expectedLocation = 0, distance: distance = $e611ba2c9fb0d567$var$Config.distance, ignoreLocation: ignoreLocation = $e611ba2c9fb0d567$var$Config.ignoreLocation } = {}) {
    const accuracy = errors / pattern.length;
    if (ignoreLocation) return accuracy;
    const proximity = Math.abs(expectedLocation - currentLocation);
    if (!distance) // Dodge divide by zero error.
    return proximity ? 1.0 : accuracy;
    return accuracy + proximity / distance;
}
function $e611ba2c9fb0d567$var$convertMaskToIndices(matchmask = [], minMatchCharLength = $e611ba2c9fb0d567$var$Config.minMatchCharLength) {
    let indices = [];
    let start = -1;
    let end = -1;
    let i = 0;
    for(let len = matchmask.length; i < len; i += 1){
        let match = matchmask[i];
        if (match && start === -1) start = i;
        else if (!match && start !== -1) {
            end = i - 1;
            if (end - start + 1 >= minMatchCharLength) indices.push([
                start,
                end
            ]);
            start = -1;
        }
    }
    // (i-1 - start) + 1 => i - start
    if (matchmask[i - 1] && i - start >= minMatchCharLength) indices.push([
        start,
        i - 1
    ]);
    return indices;
}
// Machine word size
const $e611ba2c9fb0d567$var$MAX_BITS = 32;
function $e611ba2c9fb0d567$var$search(text, pattern, patternAlphabet, { location: location = $e611ba2c9fb0d567$var$Config.location, distance: distance = $e611ba2c9fb0d567$var$Config.distance, threshold: threshold = $e611ba2c9fb0d567$var$Config.threshold, findAllMatches: findAllMatches = $e611ba2c9fb0d567$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $e611ba2c9fb0d567$var$Config.minMatchCharLength, includeMatches: includeMatches = $e611ba2c9fb0d567$var$Config.includeMatches, ignoreLocation: ignoreLocation = $e611ba2c9fb0d567$var$Config.ignoreLocation } = {}) {
    if (pattern.length > $e611ba2c9fb0d567$var$MAX_BITS) throw new Error($e611ba2c9fb0d567$var$PATTERN_LENGTH_TOO_LARGE($e611ba2c9fb0d567$var$MAX_BITS));
    const patternLen = pattern.length;
    // Set starting location at beginning text and initialize the alphabet.
    const textLen = text.length;
    // Handle the case when location > text.length
    const expectedLocation = Math.max(0, Math.min(location, textLen));
    // Highest score beyond which we give up.
    let currentThreshold = threshold;
    // Is there a nearby exact match? (speedup)
    let bestLocation = expectedLocation;
    // Performance: only computer matches when the minMatchCharLength > 1
    // OR if `includeMatches` is true.
    const computeMatches = minMatchCharLength > 1 || includeMatches;
    // A mask of the matches, used for building the indices
    const matchMask = computeMatches ? Array(textLen) : [];
    let index;
    // Get all exact matches, here for speed up
    while((index = text.indexOf(pattern, bestLocation)) > -1){
        let score = $e611ba2c9fb0d567$var$computeScore$1(pattern, {
            currentLocation: index,
            expectedLocation: expectedLocation,
            distance: distance,
            ignoreLocation: ignoreLocation
        });
        currentThreshold = Math.min(score, currentThreshold);
        bestLocation = index + patternLen;
        if (computeMatches) {
            let i = 0;
            while(i < patternLen){
                matchMask[index + i] = 1;
                i += 1;
            }
        }
    }
    // Reset the best location
    bestLocation = -1;
    let lastBitArr = [];
    let finalScore = 1;
    let binMax = patternLen + textLen;
    const mask = 1 << patternLen - 1;
    for(let i = 0; i < patternLen; i += 1){
        // Scan for the best match; each iteration allows for one more error.
        // Run a binary search to determine how far from the match location we can stray
        // at this error level.
        let binMin = 0;
        let binMid = binMax;
        while(binMin < binMid){
            const score = $e611ba2c9fb0d567$var$computeScore$1(pattern, {
                errors: i,
                currentLocation: expectedLocation + binMid,
                expectedLocation: expectedLocation,
                distance: distance,
                ignoreLocation: ignoreLocation
            });
            if (score <= currentThreshold) binMin = binMid;
            else binMax = binMid;
            binMid = Math.floor((binMax - binMin) / 2 + binMin);
        }
        // Use the result from this iteration as the maximum for the next.
        binMax = binMid;
        let start = Math.max(1, expectedLocation - binMid + 1);
        let finish = findAllMatches ? textLen : Math.min(expectedLocation + binMid, textLen) + patternLen;
        // Initialize the bit array
        let bitArr = Array(finish + 2);
        bitArr[finish + 1] = (1 << i) - 1;
        for(let j = finish; j >= start; j -= 1){
            let currentLocation = j - 1;
            let charMatch = patternAlphabet[text.charAt(currentLocation)];
            if (computeMatches) // Speed up: quick bool to int conversion (i.e, `charMatch ? 1 : 0`)
            matchMask[currentLocation] = +!!charMatch;
            // First pass: exact match
            bitArr[j] = (bitArr[j + 1] << 1 | 1) & charMatch;
            // Subsequent passes: fuzzy match
            if (i) bitArr[j] |= (lastBitArr[j + 1] | lastBitArr[j]) << 1 | 1 | lastBitArr[j + 1];
            if (bitArr[j] & mask) {
                finalScore = $e611ba2c9fb0d567$var$computeScore$1(pattern, {
                    errors: i,
                    currentLocation: currentLocation,
                    expectedLocation: expectedLocation,
                    distance: distance,
                    ignoreLocation: ignoreLocation
                });
                // This match will almost certainly be better than any existing match.
                // But check anyway.
                if (finalScore <= currentThreshold) {
                    // Indeed it is
                    currentThreshold = finalScore;
                    bestLocation = currentLocation;
                    // Already passed `loc`, downhill from here on in.
                    if (bestLocation <= expectedLocation) break;
                    // When passing `bestLocation`, don't exceed our current distance from `expectedLocation`.
                    start = Math.max(1, 2 * expectedLocation - bestLocation);
                }
            }
        }
        // No hope for a (better) match at greater error levels.
        const score = $e611ba2c9fb0d567$var$computeScore$1(pattern, {
            errors: i + 1,
            currentLocation: expectedLocation,
            expectedLocation: expectedLocation,
            distance: distance,
            ignoreLocation: ignoreLocation
        });
        if (score > currentThreshold) break;
        lastBitArr = bitArr;
    }
    const result = {
        isMatch: bestLocation >= 0,
        // Count exact matches (those with a score of 0) to be "almost" exact
        score: Math.max(0.001, finalScore)
    };
    if (computeMatches) {
        const indices = $e611ba2c9fb0d567$var$convertMaskToIndices(matchMask, minMatchCharLength);
        if (!indices.length) result.isMatch = false;
        else if (includeMatches) result.indices = indices;
    }
    return result;
}
function $e611ba2c9fb0d567$var$createPatternAlphabet(pattern) {
    let mask = {};
    for(let i = 0, len = pattern.length; i < len; i += 1){
        const char = pattern.charAt(i);
        mask[char] = (mask[char] || 0) | 1 << len - i - 1;
    }
    return mask;
}
class $e611ba2c9fb0d567$var$BitapSearch {
    constructor(pattern, { location: location = $e611ba2c9fb0d567$var$Config.location, threshold: threshold = $e611ba2c9fb0d567$var$Config.threshold, distance: distance = $e611ba2c9fb0d567$var$Config.distance, includeMatches: includeMatches = $e611ba2c9fb0d567$var$Config.includeMatches, findAllMatches: findAllMatches = $e611ba2c9fb0d567$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $e611ba2c9fb0d567$var$Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = $e611ba2c9fb0d567$var$Config.isCaseSensitive, ignoreLocation: ignoreLocation = $e611ba2c9fb0d567$var$Config.ignoreLocation } = {}){
        this.options = {
            location: location,
            threshold: threshold,
            distance: distance,
            includeMatches: includeMatches,
            findAllMatches: findAllMatches,
            minMatchCharLength: minMatchCharLength,
            isCaseSensitive: isCaseSensitive,
            ignoreLocation: ignoreLocation
        };
        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
        this.chunks = [];
        if (!this.pattern.length) return;
        const addChunk = (pattern, startIndex)=>{
            this.chunks.push({
                pattern: pattern,
                alphabet: $e611ba2c9fb0d567$var$createPatternAlphabet(pattern),
                startIndex: startIndex
            });
        };
        const len = this.pattern.length;
        if (len > $e611ba2c9fb0d567$var$MAX_BITS) {
            let i = 0;
            const remainder = len % $e611ba2c9fb0d567$var$MAX_BITS;
            const end = len - remainder;
            while(i < end){
                addChunk(this.pattern.substr(i, $e611ba2c9fb0d567$var$MAX_BITS), i);
                i += $e611ba2c9fb0d567$var$MAX_BITS;
            }
            if (remainder) {
                const startIndex = len - $e611ba2c9fb0d567$var$MAX_BITS;
                addChunk(this.pattern.substr(startIndex), startIndex);
            }
        } else addChunk(this.pattern, 0);
    }
    searchIn(text) {
        const { isCaseSensitive: isCaseSensitive, includeMatches: includeMatches } = this.options;
        if (!isCaseSensitive) text = text.toLowerCase();
        // Exact match
        if (this.pattern === text) {
            let result = {
                isMatch: true,
                score: 0
            };
            if (includeMatches) result.indices = [
                [
                    0,
                    text.length - 1
                ]
            ];
            return result;
        }
        // Otherwise, use Bitap algorithm
        const { location: location, distance: distance, threshold: threshold, findAllMatches: findAllMatches, minMatchCharLength: minMatchCharLength, ignoreLocation: ignoreLocation } = this.options;
        let allIndices = [];
        let totalScore = 0;
        let hasMatches = false;
        this.chunks.forEach(({ pattern: pattern, alphabet: alphabet, startIndex: startIndex })=>{
            const { isMatch: isMatch, score: score, indices: indices } = $e611ba2c9fb0d567$var$search(text, pattern, alphabet, {
                location: location + startIndex,
                distance: distance,
                threshold: threshold,
                findAllMatches: findAllMatches,
                minMatchCharLength: minMatchCharLength,
                includeMatches: includeMatches,
                ignoreLocation: ignoreLocation
            });
            if (isMatch) hasMatches = true;
            totalScore += score;
            if (isMatch && indices) allIndices = [
                ...allIndices,
                ...indices
            ];
        });
        let result = {
            isMatch: hasMatches,
            score: hasMatches ? totalScore / this.chunks.length : 1
        };
        if (hasMatches && includeMatches) result.indices = allIndices;
        return result;
    }
}
class $e611ba2c9fb0d567$var$BaseMatch {
    constructor(pattern){
        this.pattern = pattern;
    }
    static isMultiMatch(pattern) {
        return $e611ba2c9fb0d567$var$getMatch(pattern, this.multiRegex);
    }
    static isSingleMatch(pattern) {
        return $e611ba2c9fb0d567$var$getMatch(pattern, this.singleRegex);
    }
    search() {}
}
function $e611ba2c9fb0d567$var$getMatch(pattern, exp) {
    const matches = pattern.match(exp);
    return matches ? matches[1] : null;
}
// Token: 'file
class $e611ba2c9fb0d567$var$ExactMatch extends $e611ba2c9fb0d567$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'exact';
    }
    static get multiRegex() {
        return /^="(.*)"$/;
    }
    static get singleRegex() {
        return /^=(.*)$/;
    }
    search(text) {
        const isMatch = text === this.pattern;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                this.pattern.length - 1
            ]
        };
    }
}
// Token: !fire
class $e611ba2c9fb0d567$var$InverseExactMatch extends $e611ba2c9fb0d567$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'inverse-exact';
    }
    static get multiRegex() {
        return /^!"(.*)"$/;
    }
    static get singleRegex() {
        return /^!(.*)$/;
    }
    search(text) {
        const index = text.indexOf(this.pattern);
        const isMatch = index === -1;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
// Token: ^file
class $e611ba2c9fb0d567$var$PrefixExactMatch extends $e611ba2c9fb0d567$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'prefix-exact';
    }
    static get multiRegex() {
        return /^\^"(.*)"$/;
    }
    static get singleRegex() {
        return /^\^(.*)$/;
    }
    search(text) {
        const isMatch = text.startsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                this.pattern.length - 1
            ]
        };
    }
}
// Token: !^fire
class $e611ba2c9fb0d567$var$InversePrefixExactMatch extends $e611ba2c9fb0d567$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'inverse-prefix-exact';
    }
    static get multiRegex() {
        return /^!\^"(.*)"$/;
    }
    static get singleRegex() {
        return /^!\^(.*)$/;
    }
    search(text) {
        const isMatch = !text.startsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
// Token: .file$
class $e611ba2c9fb0d567$var$SuffixExactMatch extends $e611ba2c9fb0d567$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'suffix-exact';
    }
    static get multiRegex() {
        return /^"(.*)"\$$/;
    }
    static get singleRegex() {
        return /^(.*)\$$/;
    }
    search(text) {
        const isMatch = text.endsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                text.length - this.pattern.length,
                text.length - 1
            ]
        };
    }
}
// Token: !.file$
class $e611ba2c9fb0d567$var$InverseSuffixExactMatch extends $e611ba2c9fb0d567$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'inverse-suffix-exact';
    }
    static get multiRegex() {
        return /^!"(.*)"\$$/;
    }
    static get singleRegex() {
        return /^!(.*)\$$/;
    }
    search(text) {
        const isMatch = !text.endsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
class $e611ba2c9fb0d567$var$FuzzyMatch extends $e611ba2c9fb0d567$var$BaseMatch {
    constructor(pattern, { location: location = $e611ba2c9fb0d567$var$Config.location, threshold: threshold = $e611ba2c9fb0d567$var$Config.threshold, distance: distance = $e611ba2c9fb0d567$var$Config.distance, includeMatches: includeMatches = $e611ba2c9fb0d567$var$Config.includeMatches, findAllMatches: findAllMatches = $e611ba2c9fb0d567$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $e611ba2c9fb0d567$var$Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = $e611ba2c9fb0d567$var$Config.isCaseSensitive, ignoreLocation: ignoreLocation = $e611ba2c9fb0d567$var$Config.ignoreLocation } = {}){
        super(pattern);
        this._bitapSearch = new $e611ba2c9fb0d567$var$BitapSearch(pattern, {
            location: location,
            threshold: threshold,
            distance: distance,
            includeMatches: includeMatches,
            findAllMatches: findAllMatches,
            minMatchCharLength: minMatchCharLength,
            isCaseSensitive: isCaseSensitive,
            ignoreLocation: ignoreLocation
        });
    }
    static get type() {
        return 'fuzzy';
    }
    static get multiRegex() {
        return /^"(.*)"$/;
    }
    static get singleRegex() {
        return /^(.*)$/;
    }
    search(text) {
        return this._bitapSearch.searchIn(text);
    }
}
// Token: 'file
class $e611ba2c9fb0d567$var$IncludeMatch extends $e611ba2c9fb0d567$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'include';
    }
    static get multiRegex() {
        return /^'"(.*)"$/;
    }
    static get singleRegex() {
        return /^'(.*)$/;
    }
    search(text) {
        let location = 0;
        let index;
        const indices = [];
        const patternLen = this.pattern.length;
        // Get all exact matches
        while((index = text.indexOf(this.pattern, location)) > -1){
            location = index + patternLen;
            indices.push([
                index,
                location - 1
            ]);
        }
        const isMatch = !!indices.length;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: indices
        };
    }
}
// ❗Order is important. DO NOT CHANGE.
const $e611ba2c9fb0d567$var$searchers = [
    $e611ba2c9fb0d567$var$ExactMatch,
    $e611ba2c9fb0d567$var$IncludeMatch,
    $e611ba2c9fb0d567$var$PrefixExactMatch,
    $e611ba2c9fb0d567$var$InversePrefixExactMatch,
    $e611ba2c9fb0d567$var$InverseSuffixExactMatch,
    $e611ba2c9fb0d567$var$SuffixExactMatch,
    $e611ba2c9fb0d567$var$InverseExactMatch,
    $e611ba2c9fb0d567$var$FuzzyMatch
];
const $e611ba2c9fb0d567$var$searchersLen = $e611ba2c9fb0d567$var$searchers.length;
// Regex to split by spaces, but keep anything in quotes together
const $e611ba2c9fb0d567$var$SPACE_RE = / +(?=(?:[^\"]*\"[^\"]*\")*[^\"]*$)/;
const $e611ba2c9fb0d567$var$OR_TOKEN = '|';
// Return a 2D array representation of the query, for simpler parsing.
// Example:
// "^core go$ | rb$ | py$ xy$" => [["^core", "go$"], ["rb$"], ["py$", "xy$"]]
function $e611ba2c9fb0d567$var$parseQuery(pattern, options = {}) {
    return pattern.split($e611ba2c9fb0d567$var$OR_TOKEN).map((item)=>{
        let query = item.trim().split($e611ba2c9fb0d567$var$SPACE_RE).filter((item)=>item && !!item.trim());
        let results = [];
        for(let i = 0, len = query.length; i < len; i += 1){
            const queryItem = query[i];
            // 1. Handle multiple query match (i.e, once that are quoted, like `"hello world"`)
            let found = false;
            let idx = -1;
            while(!found && ++idx < $e611ba2c9fb0d567$var$searchersLen){
                const searcher = $e611ba2c9fb0d567$var$searchers[idx];
                let token = searcher.isMultiMatch(queryItem);
                if (token) {
                    results.push(new searcher(token, options));
                    found = true;
                }
            }
            if (found) continue;
            // 2. Handle single query matches (i.e, once that are *not* quoted)
            idx = -1;
            while(++idx < $e611ba2c9fb0d567$var$searchersLen){
                const searcher = $e611ba2c9fb0d567$var$searchers[idx];
                let token = searcher.isSingleMatch(queryItem);
                if (token) {
                    results.push(new searcher(token, options));
                    break;
                }
            }
        }
        return results;
    });
}
// These extended matchers can return an array of matches, as opposed
// to a singl match
const $e611ba2c9fb0d567$var$MultiMatchSet = new Set([
    $e611ba2c9fb0d567$var$FuzzyMatch.type,
    $e611ba2c9fb0d567$var$IncludeMatch.type
]);
/**
 * Command-like searching
 * ======================
 *
 * Given multiple search terms delimited by spaces.e.g. `^jscript .python$ ruby !java`,
 * search in a given text.
 *
 * Search syntax:
 *
 * | Token       | Match type                 | Description                            |
 * | ----------- | -------------------------- | -------------------------------------- |
 * | `jscript`   | fuzzy-match                | Items that fuzzy match `jscript`       |
 * | `=scheme`   | exact-match                | Items that are `scheme`                |
 * | `'python`   | include-match              | Items that include `python`            |
 * | `!ruby`     | inverse-exact-match        | Items that do not include `ruby`       |
 * | `^java`     | prefix-exact-match         | Items that start with `java`           |
 * | `!^earlang` | inverse-prefix-exact-match | Items that do not start with `earlang` |
 * | `.js$`      | suffix-exact-match         | Items that end with `.js`              |
 * | `!.go$`     | inverse-suffix-exact-match | Items that do not end with `.go`       |
 *
 * A single pipe character acts as an OR operator. For example, the following
 * query matches entries that start with `core` and end with either`go`, `rb`,
 * or`py`.
 *
 * ```
 * ^core go$ | rb$ | py$
 * ```
 */ class $e611ba2c9fb0d567$var$ExtendedSearch {
    constructor(pattern, { isCaseSensitive: isCaseSensitive = $e611ba2c9fb0d567$var$Config.isCaseSensitive, includeMatches: includeMatches = $e611ba2c9fb0d567$var$Config.includeMatches, minMatchCharLength: minMatchCharLength = $e611ba2c9fb0d567$var$Config.minMatchCharLength, ignoreLocation: ignoreLocation = $e611ba2c9fb0d567$var$Config.ignoreLocation, findAllMatches: findAllMatches = $e611ba2c9fb0d567$var$Config.findAllMatches, location: location = $e611ba2c9fb0d567$var$Config.location, threshold: threshold = $e611ba2c9fb0d567$var$Config.threshold, distance: distance = $e611ba2c9fb0d567$var$Config.distance } = {}){
        this.query = null;
        this.options = {
            isCaseSensitive: isCaseSensitive,
            includeMatches: includeMatches,
            minMatchCharLength: minMatchCharLength,
            findAllMatches: findAllMatches,
            ignoreLocation: ignoreLocation,
            location: location,
            threshold: threshold,
            distance: distance
        };
        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
        this.query = $e611ba2c9fb0d567$var$parseQuery(this.pattern, this.options);
    }
    static condition(_, options) {
        return options.useExtendedSearch;
    }
    searchIn(text) {
        const query = this.query;
        if (!query) return {
            isMatch: false,
            score: 1
        };
        const { includeMatches: includeMatches, isCaseSensitive: isCaseSensitive } = this.options;
        text = isCaseSensitive ? text : text.toLowerCase();
        let numMatches = 0;
        let allIndices = [];
        let totalScore = 0;
        // ORs
        for(let i = 0, qLen = query.length; i < qLen; i += 1){
            const searchers = query[i];
            // Reset indices
            allIndices.length = 0;
            numMatches = 0;
            // ANDs
            for(let j = 0, pLen = searchers.length; j < pLen; j += 1){
                const searcher = searchers[j];
                const { isMatch: isMatch, indices: indices, score: score } = searcher.search(text);
                if (isMatch) {
                    numMatches += 1;
                    totalScore += score;
                    if (includeMatches) {
                        const type = searcher.constructor.type;
                        if ($e611ba2c9fb0d567$var$MultiMatchSet.has(type)) allIndices = [
                            ...allIndices,
                            ...indices
                        ];
                        else allIndices.push(indices);
                    }
                } else {
                    totalScore = 0;
                    numMatches = 0;
                    allIndices.length = 0;
                    break;
                }
            }
            // OR condition, so if TRUE, return
            if (numMatches) {
                let result = {
                    isMatch: true,
                    score: totalScore / numMatches
                };
                if (includeMatches) result.indices = allIndices;
                return result;
            }
        }
        // Nothing was matched
        return {
            isMatch: false,
            score: 1
        };
    }
}
const $e611ba2c9fb0d567$var$registeredSearchers = [];
function $e611ba2c9fb0d567$var$register(...args) {
    $e611ba2c9fb0d567$var$registeredSearchers.push(...args);
}
function $e611ba2c9fb0d567$var$createSearcher(pattern, options) {
    for(let i = 0, len = $e611ba2c9fb0d567$var$registeredSearchers.length; i < len; i += 1){
        let searcherClass = $e611ba2c9fb0d567$var$registeredSearchers[i];
        if (searcherClass.condition(pattern, options)) return new searcherClass(pattern, options);
    }
    return new $e611ba2c9fb0d567$var$BitapSearch(pattern, options);
}
const $e611ba2c9fb0d567$var$LogicalOperator = {
    AND: '$and',
    OR: '$or'
};
const $e611ba2c9fb0d567$var$KeyType = {
    PATH: '$path',
    PATTERN: '$val'
};
const $e611ba2c9fb0d567$var$isExpression = (query)=>!!(query[$e611ba2c9fb0d567$var$LogicalOperator.AND] || query[$e611ba2c9fb0d567$var$LogicalOperator.OR]);
const $e611ba2c9fb0d567$var$isPath = (query)=>!!query[$e611ba2c9fb0d567$var$KeyType.PATH];
const $e611ba2c9fb0d567$var$isLeaf = (query)=>!$e611ba2c9fb0d567$var$isArray(query) && $e611ba2c9fb0d567$var$isObject(query) && !$e611ba2c9fb0d567$var$isExpression(query);
const $e611ba2c9fb0d567$var$convertToExplicit = (query)=>({
        [$e611ba2c9fb0d567$var$LogicalOperator.AND]: Object.keys(query).map((key)=>({
                [key]: query[key]
            }))
    });
// When `auto` is `true`, the parse function will infer and initialize and add
// the appropriate `Searcher` instance
function $e611ba2c9fb0d567$var$parse(query, options, { auto: auto = true } = {}) {
    const next = (query)=>{
        let keys = Object.keys(query);
        const isQueryPath = $e611ba2c9fb0d567$var$isPath(query);
        if (!isQueryPath && keys.length > 1 && !$e611ba2c9fb0d567$var$isExpression(query)) return next($e611ba2c9fb0d567$var$convertToExplicit(query));
        if ($e611ba2c9fb0d567$var$isLeaf(query)) {
            const key = isQueryPath ? query[$e611ba2c9fb0d567$var$KeyType.PATH] : keys[0];
            const pattern = isQueryPath ? query[$e611ba2c9fb0d567$var$KeyType.PATTERN] : query[key];
            if (!$e611ba2c9fb0d567$var$isString(pattern)) throw new Error($e611ba2c9fb0d567$var$LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY(key));
            const obj = {
                keyId: $e611ba2c9fb0d567$var$createKeyId(key),
                pattern: pattern
            };
            if (auto) obj.searcher = $e611ba2c9fb0d567$var$createSearcher(pattern, options);
            return obj;
        }
        let node = {
            children: [],
            operator: keys[0]
        };
        keys.forEach((key)=>{
            const value = query[key];
            if ($e611ba2c9fb0d567$var$isArray(value)) value.forEach((item)=>{
                node.children.push(next(item));
            });
        });
        return node;
    };
    if (!$e611ba2c9fb0d567$var$isExpression(query)) query = $e611ba2c9fb0d567$var$convertToExplicit(query);
    return next(query);
}
// Practical scoring function
function $e611ba2c9fb0d567$var$computeScore(results, { ignoreFieldNorm: ignoreFieldNorm = $e611ba2c9fb0d567$var$Config.ignoreFieldNorm }) {
    results.forEach((result)=>{
        let totalScore = 1;
        result.matches.forEach(({ key: key, norm: norm, score: score })=>{
            const weight = key ? key.weight : null;
            totalScore *= Math.pow(score === 0 && weight ? Number.EPSILON : score, (weight || 1) * (ignoreFieldNorm ? 1 : norm));
        });
        result.score = totalScore;
    });
}
function $e611ba2c9fb0d567$var$transformMatches(result, data) {
    const matches = result.matches;
    data.matches = [];
    if (!$e611ba2c9fb0d567$var$isDefined(matches)) return;
    matches.forEach((match)=>{
        if (!$e611ba2c9fb0d567$var$isDefined(match.indices) || !match.indices.length) return;
        const { indices: indices, value: value } = match;
        let obj = {
            indices: indices,
            value: value
        };
        if (match.key) obj.key = match.key.src;
        if (match.idx > -1) obj.refIndex = match.idx;
        data.matches.push(obj);
    });
}
function $e611ba2c9fb0d567$var$transformScore(result, data) {
    data.score = result.score;
}
function $e611ba2c9fb0d567$var$format(results, docs, { includeMatches: includeMatches = $e611ba2c9fb0d567$var$Config.includeMatches, includeScore: includeScore = $e611ba2c9fb0d567$var$Config.includeScore } = {}) {
    const transformers = [];
    if (includeMatches) transformers.push($e611ba2c9fb0d567$var$transformMatches);
    if (includeScore) transformers.push($e611ba2c9fb0d567$var$transformScore);
    return results.map((result)=>{
        const { idx: idx } = result;
        const data = {
            item: docs[idx],
            refIndex: idx
        };
        if (transformers.length) transformers.forEach((transformer)=>{
            transformer(result, data);
        });
        return data;
    });
}
class $e611ba2c9fb0d567$export$2e2bcd8739ae039 {
    constructor(docs, options = {}, index){
        this.options = {
            ...$e611ba2c9fb0d567$var$Config,
            ...options
        };
        this.options.useExtendedSearch;
        this._keyStore = new $e611ba2c9fb0d567$var$KeyStore(this.options.keys);
        this.setCollection(docs, index);
    }
    setCollection(docs, index) {
        this._docs = docs;
        if (index && !(index instanceof $e611ba2c9fb0d567$var$FuseIndex)) throw new Error($e611ba2c9fb0d567$var$INCORRECT_INDEX_TYPE);
        this._myIndex = index || $e611ba2c9fb0d567$var$createIndex(this.options.keys, this._docs, {
            getFn: this.options.getFn,
            fieldNormWeight: this.options.fieldNormWeight
        });
    }
    add(doc) {
        if (!$e611ba2c9fb0d567$var$isDefined(doc)) return;
        this._docs.push(doc);
        this._myIndex.add(doc);
    }
    remove(predicate = ()=>false) {
        const results = [];
        for(let i = 0, len = this._docs.length; i < len; i += 1){
            const doc = this._docs[i];
            if (predicate(doc, i)) {
                this.removeAt(i);
                i -= 1;
                len -= 1;
                results.push(doc);
            }
        }
        return results;
    }
    removeAt(idx) {
        this._docs.splice(idx, 1);
        this._myIndex.removeAt(idx);
    }
    getIndex() {
        return this._myIndex;
    }
    search(query, { limit: limit = -1 } = {}) {
        const { includeMatches: includeMatches, includeScore: includeScore, shouldSort: shouldSort, sortFn: sortFn, ignoreFieldNorm: ignoreFieldNorm } = this.options;
        let results = $e611ba2c9fb0d567$var$isString(query) ? $e611ba2c9fb0d567$var$isString(this._docs[0]) ? this._searchStringList(query) : this._searchObjectList(query) : this._searchLogical(query);
        $e611ba2c9fb0d567$var$computeScore(results, {
            ignoreFieldNorm: ignoreFieldNorm
        });
        if (shouldSort) results.sort(sortFn);
        if ($e611ba2c9fb0d567$var$isNumber(limit) && limit > -1) results = results.slice(0, limit);
        return $e611ba2c9fb0d567$var$format(results, this._docs, {
            includeMatches: includeMatches,
            includeScore: includeScore
        });
    }
    _searchStringList(query) {
        const searcher = $e611ba2c9fb0d567$var$createSearcher(query, this.options);
        const { records: records } = this._myIndex;
        const results = [];
        // Iterate over every string in the index
        records.forEach(({ v: text, i: idx, n: norm })=>{
            if (!$e611ba2c9fb0d567$var$isDefined(text)) return;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) results.push({
                item: text,
                idx: idx,
                matches: [
                    {
                        score: score,
                        value: text,
                        norm: norm,
                        indices: indices
                    }
                ]
            });
        });
        return results;
    }
    _searchLogical(query) {
        const expression = $e611ba2c9fb0d567$var$parse(query, this.options);
        const evaluate = (node, item, idx)=>{
            if (!node.children) {
                const { keyId: keyId, searcher: searcher } = node;
                const matches = this._findMatches({
                    key: this._keyStore.get(keyId),
                    value: this._myIndex.getValueForItemAtKeyId(item, keyId),
                    searcher: searcher
                });
                if (matches && matches.length) return [
                    {
                        idx: idx,
                        item: item,
                        matches: matches
                    }
                ];
                return [];
            }
            const res = [];
            for(let i = 0, len = node.children.length; i < len; i += 1){
                const child = node.children[i];
                const result = evaluate(child, item, idx);
                if (result.length) res.push(...result);
                else if (node.operator === $e611ba2c9fb0d567$var$LogicalOperator.AND) return [];
            }
            return res;
        };
        const records = this._myIndex.records;
        const resultMap = {};
        const results = [];
        records.forEach(({ $: item, i: idx })=>{
            if ($e611ba2c9fb0d567$var$isDefined(item)) {
                let expResults = evaluate(expression, item, idx);
                if (expResults.length) {
                    // Dedupe when adding
                    if (!resultMap[idx]) {
                        resultMap[idx] = {
                            idx: idx,
                            item: item,
                            matches: []
                        };
                        results.push(resultMap[idx]);
                    }
                    expResults.forEach(({ matches: matches })=>{
                        resultMap[idx].matches.push(...matches);
                    });
                }
            }
        });
        return results;
    }
    _searchObjectList(query) {
        const searcher = $e611ba2c9fb0d567$var$createSearcher(query, this.options);
        const { keys: keys, records: records } = this._myIndex;
        const results = [];
        // List is Array<Object>
        records.forEach(({ $: item, i: idx })=>{
            if (!$e611ba2c9fb0d567$var$isDefined(item)) return;
            let matches = [];
            // Iterate over every key (i.e, path), and fetch the value at that key
            keys.forEach((key, keyIndex)=>{
                matches.push(...this._findMatches({
                    key: key,
                    value: item[keyIndex],
                    searcher: searcher
                }));
            });
            if (matches.length) results.push({
                idx: idx,
                item: item,
                matches: matches
            });
        });
        return results;
    }
    _findMatches({ key: key, value: value, searcher: searcher }) {
        if (!$e611ba2c9fb0d567$var$isDefined(value)) return [];
        let matches = [];
        if ($e611ba2c9fb0d567$var$isArray(value)) value.forEach(({ v: text, i: idx, n: norm })=>{
            if (!$e611ba2c9fb0d567$var$isDefined(text)) return;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) matches.push({
                score: score,
                key: key,
                value: text,
                idx: idx,
                norm: norm,
                indices: indices
            });
        });
        else {
            const { v: text, n: norm } = value;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) matches.push({
                score: score,
                key: key,
                value: text,
                norm: norm,
                indices: indices
            });
        }
        return matches;
    }
}
$e611ba2c9fb0d567$export$2e2bcd8739ae039.version = '6.6.2';
$e611ba2c9fb0d567$export$2e2bcd8739ae039.createIndex = $e611ba2c9fb0d567$var$createIndex;
$e611ba2c9fb0d567$export$2e2bcd8739ae039.parseIndex = $e611ba2c9fb0d567$var$parseIndex;
$e611ba2c9fb0d567$export$2e2bcd8739ae039.config = $e611ba2c9fb0d567$var$Config;
$e611ba2c9fb0d567$export$2e2bcd8739ae039.parseQuery = $e611ba2c9fb0d567$var$parse;
$e611ba2c9fb0d567$var$register($e611ba2c9fb0d567$var$ExtendedSearch);

});



parcelRegister("i8VaZ", function(module, exports) {

$parcel$export(module.exports, "ListButtonGroupWithHeading", () => $7b302e46fd2fd29a$export$3f355796bb73d7b);
$parcel$export(module.exports, "ListButtonGroup", () => $7b302e46fd2fd29a$export$645edeb616ed3f65);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $806LH = parcelRequire("806LH");

var $6YEko = parcelRequire("6YEko");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $aG5mc = parcelRequire("aG5mc");
const $7b302e46fd2fd29a$var$headingContainerStyles = (0, $1DXK0.xcss)({
    paddingTop: 'space.075',
    paddingBottom: 'space.150',
    paddingLeft: 'space.300',
    paddingRight: 'space.300'
});
const $7b302e46fd2fd29a$var$itemsContainerStyles = (0, $1DXK0.xcss)({
    paddingTop: 'space.0',
    paddingBottom: 'space.0',
    paddingLeft: 'space.200',
    paddingRight: 'space.200'
});
const $7b302e46fd2fd29a$var$ListButtonGroupBase = /*#__PURE__*/ (0, $eJOHy.memo)(({ id: id, label: label, items: items, hasSeparator: hasSeparator, onItemSelected: onItemSelected, setSelectedItem: setSelectedItem, startingIndex: startingIndex })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6YEko.default), {
        hasSeparator: hasSeparator,
        children: [
            label && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
                xcss: [
                    $7b302e46fd2fd29a$var$headingContainerStyles
                ],
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $806LH.default), {
                    size: 'xsmall',
                    as: "span",
                    children: label
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
                xcss: [
                    $7b302e46fd2fd29a$var$itemsContainerStyles
                ],
                children: items.map((item, index)=>{
                    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aG5mc.ListButtonItem), {
                        index: item.index,
                        isSelected: startingIndex === undefined ? undefined : startingIndex + index === 0,
                        title: item.title,
                        description: item.description,
                        showDescription: item.showDescription,
                        attributes: item.attributes,
                        keyshortcut: item.keyshortcut,
                        renderIcon: item.renderIcon,
                        onItemSelected: (index)=>onItemSelected?.(index, id),
                        setSelectedItem: setSelectedItem
                    }, item.index);
                })
            })
        ]
    });
});
const $7b302e46fd2fd29a$export$3f355796bb73d7b = /*#__PURE__*/ (0, $eJOHy.memo)(({ id: id, label: label, items: items, hasSeparator: hasSeparator, onItemSelected: onItemSelected, setSelectedItem: setSelectedItem, startingIndex: startingIndex })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)($7b302e46fd2fd29a$var$ListButtonGroupBase, {
        id: id,
        label: label,
        items: items,
        hasSeparator: hasSeparator,
        onItemSelected: onItemSelected,
        setSelectedItem: setSelectedItem,
        startingIndex: startingIndex
    });
});
const $7b302e46fd2fd29a$export$645edeb616ed3f65 = /*#__PURE__*/ (0, $eJOHy.memo)(({ id: id, items: items, hasSeparator: hasSeparator, onItemSelected: onItemSelected, setSelectedItem: setSelectedItem, startingIndex: startingIndex })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)($7b302e46fd2fd29a$var$ListButtonGroupBase, {
        id: id,
        items: items,
        hasSeparator: hasSeparator,
        onItemSelected: onItemSelected,
        setSelectedItem: setSelectedItem,
        startingIndex: startingIndex
    });
});

});
parcelRegister("aG5mc", function(module, exports) {

$parcel$export(module.exports, "ListButtonItem", () => $f7545874d9b727de$export$74006863e39733dc);
$parcel$export(module.exports, "ViewAllButtonItem", () => $f7545874d9b727de$export$5beeafc8353ee1ed);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $6Exgk = parcelRequire("6Exgk");

var $cQxBL = parcelRequire("cQxBL");

var $jdqdp = parcelRequire("jdqdp");

var $7saMl = parcelRequire("7saMl");

var $8nu6j = parcelRequire("8nu6j");
var $3Wh6p = parcelRequire("3Wh6p");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $k71qx = parcelRequire("k71qx");

var $98uII = parcelRequire("98uII");
const $f7545874d9b727de$var$shortcutStyles = (0, $1DXK0.xcss)({
    color: 'color.text.subtle',
    font: 'font.body.small',
    backgroundColor: 'color.background.accent.gray.subtlest',
    borderRadius: 'border.radius',
    borderStyle: 'none'
});
const $f7545874d9b727de$var$selectedColorStyles = (0, $1DXK0.xcss)({
    color: 'color.text.selected'
});
const $f7545874d9b727de$var$disabledShortcutStyles = (0, $1DXK0.xcss)({
    color: 'color.text.disabled',
    backgroundColor: 'color.background.disabled'
});
const $f7545874d9b727de$var$viewAllStyles = (0, $1DXK0.xcss)({
    background: "var(--ds-surface-overlay, #FFFFFF)",
    position: 'sticky',
    bottom: '-4px',
    width: '100%',
    height: '40px',
    borderTop: `1px solid ${"var(--ds-border, #091E4224)"}`
});
const $f7545874d9b727de$var$ListButtonItemBase = /*#__PURE__*/ (0, $eJOHy.memo)(({ index: index, title: title, description: description, keyshortcut: keyshortcut, isSelected: isSelected, isDisabled: isDisabled, showDescription: showDescription = false, renderContent: renderContent, renderIcon: renderIcon, renderElementAfter: renderElementAfter, onItemSelected: onItemSelected })=>{
    const beforeElement = (0, $eJOHy.useMemo)(()=>{
        if (!renderIcon) return null;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $98uII.IconRenderer), {
            children: renderIcon()
        });
    }, [
        renderIcon
    ]);
    const afterElement = (0, $eJOHy.useMemo)(()=>renderElementAfter?.(), [
        renderElementAfter
    ]);
    const content = (0, $eJOHy.useMemo)(()=>renderContent?.(), [
        renderContent
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6Exgk.ToolTipContent), {
            description: title,
            keymap: keyshortcut
        }),
        position: "top",
        ignoreTooltipPointerEvents: true,
        children: (tooltipProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $7saMl.default), {
                ...tooltipProps,
                iconBefore: beforeElement,
                iconAfter: afterElement,
                description: showDescription ? description : undefined,
                shouldDescriptionWrap: true,
                isSelected: isSelected,
                isDisabled: isDisabled,
                onClick: ()=>onItemSelected?.(index),
                children: content
            })
    });
});
const $f7545874d9b727de$export$74006863e39733dc = /*#__PURE__*/ (0, $eJOHy.memo)((props)=>{
    const { keyshortcut: keyshortcut, isSelected: isSelected, isDisabled: isDisabled, attributes: attributes, title: title, setSelectedItem: setSelectedItem, index: index } = props;
    const shortcutComponent = (0, $eJOHy.useCallback)(()=>{
        const shortcut = keyshortcut && (0, $6Exgk.formatShortcut)(keyshortcut);
        if (!shortcut) return null;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
            paddingInline: "space.025",
            paddingBlock: "space.025",
            xcss: [
                $f7545874d9b727de$var$shortcutStyles,
                isSelected && $f7545874d9b727de$var$selectedColorStyles,
                isDisabled && $f7545874d9b727de$var$disabledShortcutStyles
            ],
            children: shortcut
        });
    }, [
        isDisabled,
        isSelected,
        keyshortcut
    ]);
    const contentComponent = (0, $eJOHy.useCallback)(()=>{
        return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $3Wh6p.default), {
            space: "space.100",
            alignBlock: 'center',
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5qJVF.default), {
                    children: title
                }),
                attributes?.new && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jdqdp.default), {
                    appearance: "new",
                    children: "New"
                })
            ]
        });
    }, [
        attributes?.new,
        title
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (isSelected) setSelectedItem?.({
            index: index
        });
    }, [
        isSelected,
        setSelectedItem,
        index
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($f7545874d9b727de$var$ListButtonItemBase, {
        ...props,
        renderContent: contentComponent,
        renderElementAfter: shortcutComponent
    });
});
const $f7545874d9b727de$export$5beeafc8353ee1ed = /*#__PURE__*/ (0, $eJOHy.memo)(({ label: label, onClick: onClick, isViewAllInserts: isViewAllInserts = false })=>{
    const contentComponent = (0, $eJOHy.useCallback)(()=>{
        return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $3Wh6p.default), {
            space: "space.100",
            alignBlock: 'center',
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5qJVF.default), {
                    color: 'color.text.selected',
                    children: label
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
                    xcss: [
                        $f7545874d9b727de$var$selectedColorStyles
                    ],
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cQxBL))), {
                        label: label,
                        size: "small"
                    })
                })
            ]
        });
    }, [
        label
    ]);
    return isViewAllInserts ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
        xcss: $f7545874d9b727de$var$viewAllStyles,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($f7545874d9b727de$var$ListButtonItemBase, {
            index: -1,
            title: label,
            onItemSelected: onClick,
            renderContent: contentComponent,
            isViewAll: true
        })
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)($f7545874d9b727de$var$ListButtonItemBase, {
        index: -1,
        title: label,
        onItemSelected: onClick,
        renderContent: contentComponent
    });
});

});
parcelRegister("98uII", function(module, exports) {

$parcel$export(module.exports, "IconRenderer", () => $4541f922652033ea$export$32ff197eed95e568);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");
function $4541f922652033ea$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $4541f922652033ea$var$iconWrapperStyles = {
    name: "e42xni",
    styles: "max-width:var(--ds-space-500, 40px);max-height:var(--ds-space-500, 40px);div{max-width:var(--ds-space-500, 40px);max-height:var(--ds-space-500, 40px);}span{max-width:var(--ds-space-500, 40px);max-height:var(--ds-space-500, 40px);}"
};
const $4541f922652033ea$export$32ff197eed95e568 = /*#__PURE__*/ (0, $eJOHy.memo)(({ children: children })=>{
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: [
            $4541f922652033ea$var$iconWrapperStyles
        ]
    }, children);
});

});



parcelRegister("e1oUK", function(module, exports) {

$parcel$export(module.exports, "LinkNavButton", () => $edc823050c34b2a5$export$98ce6410d0ba022);
$parcel$export(module.exports, "ExpandableNavButton", () => $edc823050c34b2a5$export$6f3d5e896fa382de);
$parcel$export(module.exports, "BackNavButton", () => $edc823050c34b2a5$export$b83dc6f7d9624732);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $Ay1uj = parcelRequire("Ay1uj");

var $806LH = parcelRequire("806LH");

var $aqu01 = parcelRequire("aqu01");

var $1OQKp = parcelRequire("1OQKp");

var $cQxBL = parcelRequire("cQxBL");

var $1vA1E = parcelRequire("1vA1E");

var $jdqdp = parcelRequire("jdqdp");

var $8nu6j = parcelRequire("8nu6j");
var $3Wh6p = parcelRequire("3Wh6p");
var $bQP4O = parcelRequire("bQP4O");
var $1DXK0 = parcelRequire("1DXK0");

var $k71qx = parcelRequire("k71qx");
const $edc823050c34b2a5$var$buttonStyles = (0, $1DXK0.xcss)({
    display: 'inline-flex',
    flexShrink: 0,
    boxSizing: 'border-box',
    position: 'relative',
    alignItems: 'baseline',
    justifyContent: 'center',
    textAlign: 'center',
    verticalAlign: 'middle',
    height: 'auto',
    minHeight: 'space.400',
    width: '100%',
    paddingBlock: 'space.075',
    paddingInline: 'space.100',
    borderRadius: 'border.radius.100',
    borderWidth: 'border.width.0',
    font: 'font.body',
    fontWeight: 'font.weight.medium',
    transition: 'opacity 0.3s, background 0.1s ease-out',
    backgroundColor: 'color.background.neutral.subtle',
    color: 'color.text.subtle',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered',
        color: 'color.text.subtle'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed',
        color: 'color.text.subtle'
    }
});
const $edc823050c34b2a5$var$selectedButtonStyles = (0, $1DXK0.xcss)({
    backgroundColor: 'color.background.selected',
    color: 'color.text.selected',
    ':visited': {
        color: 'color.text.selected'
    },
    ':hover': {
        color: 'color.text.selected',
        backgroundColor: 'color.background.selected.hovered'
    },
    ':active': {
        color: 'color.text.selected',
        backgroundColor: 'color.background.selected.pressed'
    }
});
const $edc823050c34b2a5$var$disabledButtonStyles = (0, $1DXK0.xcss)({
    cursor: 'not-allowed',
    backgroundColor: 'color.background.disabled',
    color: 'color.text.disabled',
    ':hover': {
        backgroundColor: 'color.background.disabled',
        color: 'color.text.disabled'
    },
    ':active': {
        backgroundColor: 'color.background.disabled',
        color: 'color.text.disabled'
    },
    '::after': {
        content: 'none'
    }
});
const $edc823050c34b2a5$var$headingContainerStyles = (0, $1DXK0.xcss)({
    textAlign: 'left',
    color: 'color.text.accent.orange'
});
const $edc823050c34b2a5$var$ButtonBase = /*#__PURE__*/ (0, $eJOHy.memo)(({ id: id, mode: mode, label: label, isSelected: isSelected, isDisabled: isDisabled, isExpanded: isExpanded, attributes: attributes, onClick: onClick })=>{
    const iconComponent = (0, $eJOHy.useMemo)(()=>{
        let Icon;
        let iconLabel;
        switch(mode){
            case 'expandable':
                Icon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($1vA1E))) : (0, (/*@__PURE__*/$parcel$interopDefault($1OQKp)));
                iconLabel = isExpanded ? `Collapse ${label} inserts` : `Expand ${label} inserts`;
                break;
            default:
                Icon = (0, (/*@__PURE__*/$parcel$interopDefault($cQxBL)));
                iconLabel = `View all ${label} inserts`;
        }
        return /*#__PURE__*/ (0, $gt9Am.jsx)(Icon, {
            label: iconLabel,
            size: "small"
        });
    }, [
        isExpanded,
        label,
        mode
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
        content: label,
        position: "top",
        ignoreTooltipPointerEvents: true,
        children: (tooltipProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $bQP4O.default), {
                ...tooltipProps,
                type: "button",
                isDisabled: isDisabled,
                onClick: ()=>onClick?.(id),
                xcss: [
                    $edc823050c34b2a5$var$buttonStyles,
                    isSelected && $edc823050c34b2a5$var$selectedButtonStyles,
                    isDisabled && $edc823050c34b2a5$var$disabledButtonStyles
                ],
                children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $3Wh6p.default), {
                    as: "span",
                    spread: "space-between",
                    alignBlock: "center",
                    space: 'space.100',
                    grow: "fill",
                    shouldWrap: false,
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $3Wh6p.default), {
                            alignBlock: "center",
                            space: "space.100",
                            shouldWrap: false,
                            children: [
                                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
                                    xcss: $edc823050c34b2a5$var$headingContainerStyles,
                                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $806LH.default), {
                                        size: 'xsmall',
                                        as: "span",
                                        children: label
                                    })
                                }),
                                attributes?.new && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
                                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jdqdp.default), {
                                        appearance: "new",
                                        children: "New"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
                            children: iconComponent
                        })
                    ]
                })
            })
    });
});
const $edc823050c34b2a5$export$98ce6410d0ba022 = /*#__PURE__*/ (0, $eJOHy.memo)((props)=>// eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $gt9Am.jsx)($edc823050c34b2a5$var$ButtonBase, {
        mode: "navigation",
        ...props
    }));
const $edc823050c34b2a5$export$6f3d5e896fa382de = /*#__PURE__*/ (0, $eJOHy.memo)((props)=>// eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $gt9Am.jsx)($edc823050c34b2a5$var$ButtonBase, {
        mode: "expandable",
        ...props
    }));
const $edc823050c34b2a5$export$b83dc6f7d9624732 = /*#__PURE__*/ (0, $eJOHy.memo)(({ label: label, onClick: onClick })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
        content: label,
        position: "top",
        ignoreTooltipPointerEvents: true,
        children: (tooltipProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                ...tooltipProps,
                label: label,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($aqu01))),
                appearance: "subtle",
                spacing: "compact",
                onClick: onClick
            })
    });
});

});

parcelRegister("3CAGn", function(module, exports) {

$parcel$export(module.exports, "SubPanelWithBackButton", () => $f412aca0504822bc$export$bc997d97789f130b);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $806LH = parcelRequire("806LH");

var $3Wh6p = parcelRequire("3Wh6p");
var $dW738 = parcelRequire("dW738");
var $1DXK0 = parcelRequire("1DXK0");

var $e1oUK = parcelRequire("e1oUK");
const $f412aca0504822bc$var$itemContainerStyles = (0, $1DXK0.xcss)({
    paddingTop: 'space.100',
    paddingBottom: 'space.025',
    paddingLeft: 'space.250',
    paddingRight: 'space.250'
});
const $f412aca0504822bc$export$bc997d97789f130b = /*#__PURE__*/ (0, $eJOHy.memo)(({ label: label, buttonLabel: buttonLabel, onClick: onClick, children: children })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $dW738.default), {
        space: "space.0",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $3Wh6p.default), {
                alignBlock: "center",
                alignInline: "start",
                space: 'space.050',
                xcss: $f412aca0504822bc$var$itemContainerStyles,
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $e1oUK.BackNavButton), {
                        onClick: onClick,
                        label: buttonLabel
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $806LH.default), {
                        size: 'xsmall',
                        as: "span",
                        children: label
                    })
                ]
            }),
            children
        ]
    });
});

});


parcelRegister("dGNvX", function(module, exports) {

$parcel$export(module.exports, "SideInsertPanel", () => $3fd5c58ed843354c$export$dfdc13f605e27090);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $7k8dr = parcelRequire("7k8dr");

var $78OnL = parcelRequire("78OnL");

var $inQ44 = parcelRequire("inQ44");

var $1BNzE = parcelRequire("1BNzE");

var $1zKwc = parcelRequire("1zKwc");

var $i8VaZ = parcelRequire("i8VaZ");

var $hOT1n = parcelRequire("hOT1n");

var $3CAGn = parcelRequire("3CAGn");
const $3fd5c58ed843354c$var$DefaultView = ({ suggested: suggested, itemsRegistry: itemsRegistry, categoryRegistry: categoryRegistry, onItemSelected: onItemSelected, onCategorySelected: onCategorySelected })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $78OnL.default), {
        children: [
            suggested && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1zKwc.IconButtonGroup), {
                id: suggested.id,
                items: suggested.items,
                label: suggested.label,
                onItemSelected: onItemSelected
            }),
            (0, $inQ44.CategoriesStructure).map((category, i)=>{
                const { defautltItems: defautltItems } = category;
                const items = defautltItems.length > 0 ? defautltItems.map((itemIdOrTitle)=>itemsRegistry[itemIdOrTitle]).filter((item)=>item) : categoryRegistry[category.id] ? categoryRegistry[category.id].slice(0, 5) : [];
                const shoudldShowSeparator = i === 0 && !suggested ? false : true;
                return items.length > 0 && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1BNzE.ExpandablePanel), {
                    id: category.id,
                    label: category.title,
                    items: items,
                    hasSeparator: shoudldShowSeparator,
                    onItemSelected: onItemSelected,
                    onViewAllSelected: onCategorySelected
                }, category.id);
            })
        ]
    });
};
const $3fd5c58ed843354c$var$CategoryView = ({ categoryRegistry: categoryRegistry, selectedCategory: selectedCategory, onItemSelected: onItemSelected, onBackButtonClicked: onBackButtonClicked })=>{
    const categoryData = (0, $inQ44.PredefinedCategories).get(selectedCategory);
    const categoryLevelItems = categoryRegistry[selectedCategory] || [];
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $78OnL.default), {
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $3CAGn.SubPanelWithBackButton), {
            label: categoryData.title,
            buttonLabel: "Back to all items",
            onClick: onBackButtonClicked,
            children: [
                categoryLevelItems.length > 0 && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $i8VaZ.ListButtonGroup), {
                    id: categoryData.id,
                    items: categoryLevelItems,
                    onItemSelected: onItemSelected
                }),
                categoryData && categoryData.subcategories.map(({ id: id, title: title })=>{
                    return categoryRegistry[id] && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $i8VaZ.ListButtonGroupWithHeading), {
                        id: id,
                        label: title,
                        items: categoryRegistry[id],
                        onItemSelected: onItemSelected
                    });
                })
            ]
        })
    });
};
const $3fd5c58ed843354c$var$SearchView = ({ items: items, onItemSelected: onItemSelected })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $i8VaZ.ListButtonGroup), {
        id: 'search',
        items: items,
        onItemSelected: onItemSelected
    });
};
const $3fd5c58ed843354c$export$dfdc13f605e27090 = ({ items: items, onItemInsert: onItemInsert })=>{
    const onItemSelect = (0, $eJOHy.useCallback)((index)=>{
        onItemInsert((0, $7k8dr.SelectItemMode).SELECTED, index);
    }, [
        onItemInsert
    ]);
    const { categoryRegistry: categoryRegistry, itemsRegistry: itemsRegistry, selectedCategory: selectedCategory, searchItems: searchItems, setSearchText: setSearchText, setSelectedCategory: setSelectedCategory } = (0, $inQ44.useItems)(items);
    const view = searchItems ? /*#__PURE__*/ (0, $gt9Am.jsx)($3fd5c58ed843354c$var$SearchView, {
        items: searchItems,
        onItemSelected: onItemSelect
    }) : selectedCategory ? /*#__PURE__*/ (0, $gt9Am.jsx)($3fd5c58ed843354c$var$CategoryView, {
        categoryRegistry: categoryRegistry,
        selectedCategory: selectedCategory,
        onItemSelected: onItemSelect,
        onBackButtonClicked: ()=>setSelectedCategory(undefined)
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)($3fd5c58ed843354c$var$DefaultView, {
        suggested: undefined,
        itemsRegistry: itemsRegistry,
        categoryRegistry: categoryRegistry,
        onItemSelected: onItemSelect,
        onCategorySelected: (categoryId)=>{
            setSelectedCategory(categoryId);
        }
    });
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $78OnL.default), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hOT1n.SearchPanel), {
                onChange: (event)=>{
                    setSearchText(event.target.value);
                }
            }),
            view
        ]
    });
};

});
parcelRegister("1BNzE", function(module, exports) {

$parcel$export(module.exports, "ExpandablePanel", () => $7be9acb2f99e9dc1$export$dbf21a0adc6a9ee0);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $6YEko = parcelRequire("6YEko");

var $8nu6j = parcelRequire("8nu6j");
var $dW738 = parcelRequire("dW738");
var $1DXK0 = parcelRequire("1DXK0");

var $aG5mc = parcelRequire("aG5mc");

var $e1oUK = parcelRequire("e1oUK");
const $7be9acb2f99e9dc1$var$headingContainerStyles = (0, $1DXK0.xcss)({
    paddingTop: 'space.100',
    paddingBottom: 'space.075',
    paddingLeft: 'space.300',
    paddingRight: 'space.300'
});
const $7be9acb2f99e9dc1$var$itemsContainerStyles = (0, $1DXK0.xcss)({
    paddingTop: 'space.0',
    paddingBottom: 'space.150',
    paddingLeft: 'space.200',
    paddingRight: 'space.200'
});
const $7be9acb2f99e9dc1$export$dbf21a0adc6a9ee0 = /*#__PURE__*/ (0, $eJOHy.memo)(({ id: id, label: label, items: items, hasSeparator: hasSeparator, attributes: attributes, onItemSelected: onItemSelected, onViewAllSelected: onViewAllSelected })=>{
    const [isExpanded, setIsExpanded] = (0, $eJOHy.useState)(true);
    // Dirty fix for AI label
    const shortAIlabel = label === 'Atlassian Intelligence';
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6YEko.default), {
        hasSeparator: hasSeparator,
        children: [
            label && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
                xcss: [
                    $7be9acb2f99e9dc1$var$headingContainerStyles
                ],
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $e1oUK.ExpandableNavButton), {
                    id: id,
                    label: label,
                    isExpanded: isExpanded,
                    attributes: attributes,
                    onClick: ()=>setIsExpanded(!isExpanded)
                })
            }),
            isExpanded && /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $dW738.default), {
                space: "space.025",
                xcss: [
                    $7be9acb2f99e9dc1$var$itemsContainerStyles
                ],
                children: [
                    items.map((item)=>{
                        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aG5mc.ListButtonItem), {
                            index: item.index,
                            title: item.title,
                            description: item.description,
                            showDescription: item.showDescription,
                            attributes: item.attributes,
                            keyshortcut: item.keyshortcut,
                            renderIcon: item.renderIcon,
                            onItemSelected: (index)=>onItemSelected?.(index, id)
                        }, item.index);
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $aG5mc.ViewAllButtonItem), {
                        label: `View all ${shortAIlabel ? 'AI' : label.toLocaleLowerCase()} options`,
                        onClick: ()=>onViewAllSelected?.(id)
                    })
                ]
            })
        ]
    });
});

});

parcelRegister("1zKwc", function(module, exports) {

$parcel$export(module.exports, "IconButtonGroup", () => $536e7d2b2fab4a10$export$62ad8bbf2c8664a6);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $806LH = parcelRequire("806LH");

var $6YEko = parcelRequire("6YEko");

var $8nu6j = parcelRequire("8nu6j");
var $3Wh6p = parcelRequire("3Wh6p");
var $1DXK0 = parcelRequire("1DXK0");

var $jZxjL = parcelRequire("jZxjL");
const $536e7d2b2fab4a10$var$headingContainerStyles = (0, $1DXK0.xcss)({
    paddingTop: 'space.0',
    paddingBottom: 'space.075',
    paddingLeft: 'space.300',
    paddingRight: 'space.300'
});
const $536e7d2b2fab4a10$var$buttonsContainerStyles = (0, $1DXK0.xcss)({
    paddingTop: 'space.150',
    paddingBottom: 'space.200',
    paddingLeft: 'space.300',
    paddingRight: 'space.300'
});
const $536e7d2b2fab4a10$export$62ad8bbf2c8664a6 = /*#__PURE__*/ (0, $eJOHy.memo)(({ id: id, label: label, items: items, hasSeparator: hasSeparator, onItemSelected: onItemSelected })=>{
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6YEko.default), {
        hasSeparator: hasSeparator,
        children: [
            label && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
                xcss: [
                    $536e7d2b2fab4a10$var$headingContainerStyles
                ],
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $806LH.default), {
                    size: 'xsmall',
                    as: "span",
                    children: label
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
                xcss: [
                    $536e7d2b2fab4a10$var$buttonsContainerStyles
                ],
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3Wh6p.default), {
                    as: "span",
                    spread: "space-between",
                    alignBlock: "center",
                    space: "space.050",
                    rowSpace: "space.150",
                    grow: "fill",
                    shouldWrap: true,
                    children: items.map((item)=>{
                        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jZxjL.IconButtonItem), {
                            index: item.index,
                            title: item.title,
                            description: item.description,
                            showDescription: item.showDescription,
                            attributes: item.attributes,
                            keyshortcut: item.keyshortcut,
                            renderIcon: item.renderIcon,
                            onItemSelected: (index)=>onItemSelected?.(index, id)
                        }, item.index);
                    })
                })
            })
        ]
    }));
});

});
parcelRegister("jZxjL", function(module, exports) {

$parcel$export(module.exports, "IconButtonItem", () => $b147335e221d4081$export$b2bea3403fa20e61);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $6Exgk = parcelRequire("6Exgk");

var $8nu6j = parcelRequire("8nu6j");
var $bQP4O = parcelRequire("bQP4O");
var $dW738 = parcelRequire("dW738");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $k71qx = parcelRequire("k71qx");

var $98uII = parcelRequire("98uII");
const $b147335e221d4081$var$WIDTH = '60px';
const $b147335e221d4081$var$largeButtonStyles = (0, $1DXK0.xcss)({
    display: 'inline-flex',
    flexShrink: 0,
    boxSizing: 'border-box',
    position: 'relative',
    alignItems: 'baseline',
    justifyContent: 'center',
    textAlign: 'center',
    verticalAlign: 'middle',
    height: `${$b147335e221d4081$var$WIDTH}`,
    width: `${$b147335e221d4081$var$WIDTH}`,
    borderRadius: 'border.radius.100',
    borderWidth: 'border.width.0',
    font: 'font.body',
    fontWeight: 'font.weight.medium',
    transition: 'opacity 0.3s, background 0.1s ease-out',
    backgroundColor: 'color.background.neutral.subtle',
    color: 'color.text.subtle',
    '::after': {
        position: 'absolute',
        inset: 'space.0',
        content: '""',
        borderRadius: 'inherit',
        borderStyle: 'solid',
        borderWidth: 'border.width',
        borderColor: 'color.border',
        pointerEvents: 'none'
    },
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered',
        color: 'color.text.subtle'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed',
        color: 'color.text.subtle'
    }
});
const $b147335e221d4081$var$selectedButtonStyles = (0, $1DXK0.xcss)({
    backgroundColor: 'color.background.selected',
    color: 'color.text.selected',
    '::after': {
        content: '""',
        borderColor: 'color.border.selected'
    },
    ':visited': {
        color: 'color.text.selected'
    },
    ':hover': {
        color: 'color.text.selected',
        backgroundColor: 'color.background.selected.hovered'
    },
    ':active': {
        color: 'color.text.selected',
        backgroundColor: 'color.background.selected.pressed'
    }
});
const $b147335e221d4081$var$disabledButtonStyles = (0, $1DXK0.xcss)({
    cursor: 'not-allowed',
    backgroundColor: 'color.background.disabled',
    color: 'color.text.disabled',
    ':hover': {
        backgroundColor: 'color.background.disabled',
        color: 'color.text.disabled'
    },
    ':active': {
        backgroundColor: 'color.background.disabled',
        color: 'color.text.disabled'
    },
    '::after': {
        content: 'none'
    }
});
const $b147335e221d4081$var$iconStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    flexGrow: 0,
    flexShrink: 0,
    alignSelf: 'center',
    userSelect: 'none'
});
const $b147335e221d4081$var$textStyles = (0, $1DXK0.xcss)({
    width: `${$b147335e221d4081$var$WIDTH}`
});
const $b147335e221d4081$var$LargeIconButtonWithRef = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)(({ icon: icon, isSelected: isSelected, isDisabled: isDisabled, onClick: onClick, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bQP4O.default), {
        ...rest,
        ref: ref,
        type: "button",
        isDisabled: isDisabled,
        onClick: onClick,
        xcss: [
            $b147335e221d4081$var$largeButtonStyles,
            isSelected && $b147335e221d4081$var$selectedButtonStyles,
            isDisabled && $b147335e221d4081$var$disabledButtonStyles
        ],
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
            as: "span",
            xcss: $b147335e221d4081$var$iconStyles,
            children: icon
        })
    });
}));
const $b147335e221d4081$export$b2bea3403fa20e61 = /*#__PURE__*/ (0, $eJOHy.memo)(({ index: index, title: title, keyshortcut: keyshortcut, isSelected: isSelected, isDisabled: isDisabled, renderIcon: renderIcon, onItemSelected: onItemSelected })=>{
    const iconComponent = (0, $eJOHy.useMemo)(()=>{
        if (!renderIcon) return null;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $98uII.IconRenderer), {
            children: renderIcon()
        });
    }, [
        renderIcon
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6Exgk.ToolTipContent), {
            description: title,
            keymap: keyshortcut
        }),
        position: "top",
        ignoreTooltipPointerEvents: true,
        children: (tooltipProps)=>/*#__PURE__*/ (0, $gt9Am.jsxs)((0, $dW738.default), {
                alignInline: "center",
                space: "space.050",
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)($b147335e221d4081$var$LargeIconButtonWithRef, {
                        ...tooltipProps,
                        icon: iconComponent,
                        isSelected: isSelected,
                        isDisabled: isDisabled,
                        onClick: ()=>onItemSelected?.(index)
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
                        xcss: $b147335e221d4081$var$textStyles,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5qJVF.default), {
                            align: "center",
                            maxLines: 1,
                            color: isDisabled ? 'color.text.disabled' : isSelected ? 'color.text.selected' : 'color.text.subtle',
                            size: "small",
                            children: title
                        })
                    })
                ]
            })
    });
});

});


parcelRegister("hOT1n", function(module, exports) {

$parcel$export(module.exports, "SearchPanel", () => $d122cc989a305b5e$export$ea47151d20780fe9);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $dt3aG = parcelRequire("dt3aG");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $sY9BV = parcelRequire("sY9BV");
const $d122cc989a305b5e$var$searchPanelStyles = (0, $1DXK0.xcss)({
    paddingTop: 'space.025',
    paddingBottom: 'space.150',
    paddingLeft: 'space.300',
    paddingRight: 'space.300'
});
const $d122cc989a305b5e$var$searchIconStyles = (0, $1DXK0.xcss)({
    paddingTop: 'space.050',
    paddingBottom: 'space.0',
    paddingLeft: 'space.100',
    paddingRight: 'space.0'
});
const $d122cc989a305b5e$export$ea47151d20780fe9 = /*#__PURE__*/ (0, $eJOHy.memo)(({ onChange: onChange })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
        xcss: [
            $d122cc989a305b5e$var$searchPanelStyles
        ],
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $sY9BV.default), {
            name: "search",
            id: "search-textfield",
            placeholder: "Find or describe...",
            elemBeforeInput: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
                xcss: $d122cc989a305b5e$var$searchIconStyles,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dt3aG))), {
                    label: "search",
                    color: "var(--ds-text-subtlest, #626F86)"
                })
            }),
            onChange: onChange
        })
    });
});

});


parcelRegister("nMpI6", function(module, exports) {

$parcel$export(module.exports, "TypeAheadErrorFallback", () => $04065a8b18020a11$export$71ea07f9d4f4ab38);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $lRq8t = parcelRequire("lRq8t");

var $4drex = parcelRequire("4drex");

var $5UqNW = parcelRequire("5UqNW");

var $fj8dX = parcelRequire("fj8dX");
function $04065a8b18020a11$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $04065a8b18020a11$var$minHeightComponentStyles = {
    name: "2omrkj",
    styles: "display:flex;align-items:stretch;justify-content:center;min-height:290px"
};
const $04065a8b18020a11$export$71ea07f9d4f4ab38 = ()=>{
    const intl = (0, $lRq8t.default)();
    const header = intl.formatMessage((0, $4drex.typeAheadListMessages).typeAheadErrorFallbackHeading);
    const description = intl.formatMessage((0, $4drex.typeAheadListMessages).typeAheadErrorFallbackDesc);
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        "data-testid": "typeahead-error-boundary-ui",
        css: $04065a8b18020a11$var$minHeightComponentStyles
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $5UqNW.EmptyState), {
        header: header,
        renderImage: ()=>/*#__PURE__*/ (0, $1NIU8.jsx)((0, $fj8dX.GenericErrorSVG), null),
        description: description
    }));
};

});
parcelRegister("5UqNW", function(module, exports) {

$parcel$export(module.exports, "EmptyState", () => $4a443bb570ba9792$export$fddf379e22a74b00);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $806LH = parcelRequire("806LH");

var $lmgo6 = parcelRequire("lmgo6");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");
const $4a443bb570ba9792$var$containerStyles = (0, $1DXK0.xcss)({
    marginBlockStart: 'space.600',
    marginBlockEnd: 'space.600',
    textAlign: 'center'
});
const $4a443bb570ba9792$export$fddf379e22a74b00 = ({ testId: testId, header: header, description: description, renderImage: renderImage })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $lmgo6.default), {
        xcss: $4a443bb570ba9792$var$containerStyles,
        testId: testId,
        direction: "column",
        alignItems: "center",
        gap: "space.300",
        children: [
            renderImage?.(),
            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $lmgo6.default), {
                direction: "column",
                alignItems: "center",
                gap: "space.200",
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $806LH.default), {
                        size: "medium",
                        as: "h2",
                        children: header
                    }),
                    description && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5qJVF.default), {
                        as: "p",
                        color: "color.text",
                        children: description
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("fj8dX", function(module, exports) {

$parcel$export(module.exports, "GenericErrorSVG", () => $2ef11100883f2881$export$e54420a1a27457a4);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");
const $2ef11100883f2881$var$HEIGHT = 90;
const $2ef11100883f2881$var$genericErrorStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    height: `${$2ef11100883f2881$var$HEIGHT}px`,
    display: 'block'
});
const $2ef11100883f2881$export$e54420a1a27457a4 = (props)=>{
    const id = 'link-picker-ui-generic-error-svg';
    return /*#__PURE__*/ (0, $1NIU8.jsx)("svg", {
        height: "90",
        viewBox: "0 0 164 212",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        css: $2ef11100883f2881$var$genericErrorStyles,
        ...props
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("path", {
        d: "m95.43 74.16 66.44 115.08c5.84 10.12-1.46 22.76-13.14 22.76H15.85c-11.68 0-18.98-12.65-13.14-22.76L69.15 74.16c5.84-10.12 20.44-10.12 26.28 0Zm-7.56 83.55 2.88-44.35c.34-5.29-3.86-9.78-9.16-9.78-5.31 0-9.51 4.48-9.16 9.78l2.88 44.35a6.3 6.3 0 0 0 6.28 5.89c3.31 0 6.06-2.58 6.28-5.89Zm-15.84 23.54c0 5.66 4.76 10.1 10.39 9.58 4.85-.45 8.73-4.5 8.83-9.37.11-5.45-4.31-9.94-9.73-9.94-5.23-.01-9.49 4.37-9.49 9.73Z",
        fill: `url(#${id})`
    }), /*#__PURE__*/ (0, $1NIU8.jsx)("path", {
        opacity: ".6",
        d: "M93.35 27.17 85.94.45c-.17-.62-1.07-.58-1.19.05l-4.66 25.1-5.8-1.08a.612.612 0 0 0-.7.76L81 52c.17.62 1.07.58 1.19-.05l4.66-25.1 5.8 1.08c.45.08.82-.33.7-.76ZM66.77 41.81 55.9 33.26c-.22-.18-.53.07-.41.33l5.53 11.43-2.66 1.29c-.18.09-.2.33-.05.45l10.87 8.55c.22.18.53-.07.41-.33l-5.53-11.43 2.66-1.29c.17-.08.2-.33.05-.45Z",
        fill: "#C1C7D0"
    }), /*#__PURE__*/ (0, $1NIU8.jsx)("path", {
        opacity: ".6",
        d: "M102.78 56.75a.993.993 0 0 1-.92-1.38c-.24-.77-2.29-2.85-3.54-4.11-2.97-3.01-4.93-5-3.84-6.49 1.09-1.48 3.58-.22 7.35 1.7 1.32.67 3.35 1.7 4.45 2.03-.64-.95-2.24-2.58-3.28-3.63-2.97-3.01-4.93-5-3.84-6.49 1.08-1.48 3.58-.22 7.34 1.7 1.32.67 3.34 1.7 4.45 2.03-.64-.95-2.24-2.57-3.28-3.62-2.97-3.01-4.93-5-3.84-6.49 1.08-1.48 3.57-.22 7.34 1.7 1.58.8 4.18 2.13 4.98 2.13a1.005 1.005 0 0 1 1.46 1.36c-1.09 1.48-3.57.22-7.34-1.7-1.32-.67-3.34-1.7-4.44-2.03.64.95 2.24 2.57 3.28 3.62 2.97 3.01 4.93 5 3.84 6.49-1.08 1.48-3.57.22-7.34-1.7-1.32-.67-3.35-1.7-4.45-2.03.64.95 2.24 2.57 3.28 3.63 2.97 3.01 4.93 5 3.84 6.49-1.09 1.48-3.58.22-7.35-1.7-1.32-.67-3.35-1.71-4.45-2.03.64.95 2.24 2.58 3.28 3.63 2.97 3.01 4.93 5 3.84 6.49-.21.26-.51.4-.82.4Zm5.56 14.32c-.35 0-.69-.19-.88-.52-1.04-1.88-2.22-4.02-.91-5.21 1.31-1.2 3.34.18 5.49 1.63.87.59 2.26 1.53 2.93 1.71-.12-.68-.93-2.15-1.45-3.07-1.26-2.27-2.45-4.41-1.14-5.61 1.31-1.2 3.34.18 5.49 1.63.96.65 2.54 1.72 3.1 1.74a1 1 0 0 1 1.27 1.54c-1.31 1.2-3.34-.17-5.49-1.63-.87-.59-2.26-1.53-2.93-1.71.12.68.93 2.15 1.45 3.07 1.26 2.27 2.45 4.41 1.14 5.61-1.31 1.2-3.34-.18-5.49-1.63-.87-.59-2.26-1.53-2.93-1.71.12.68.93 2.14 1.22 2.67.27.48.09 1.09-.39 1.36-.15.09-.32.13-.48.13Zm-54.32-2.89c-.22 0-.44-.04-.67-.14-1.64-.69-1.24-3.11-.81-5.67.17-1.04.45-2.7.33-3.38-.57.39-1.56 1.75-2.18 2.6-1.53 2.09-2.99 4.07-4.62 3.38a.991.991 0 0 1-.53-1.31c.2-.48.73-.72 1.21-.57.52-.21 1.65-1.75 2.34-2.68 1.53-2.09 2.98-4.08 4.62-3.38 1.64.69 1.24 3.11.81 5.67-.17 1.04-.45 2.7-.33 3.38.57-.39 1.56-1.75 2.18-2.6 1.53-2.09 2.98-4.08 4.62-3.38 1.63.69 1.24 3.09.89 5.21-.09.54-.6.91-1.15.83-.54-.09-.92-.6-.83-1.15.1-.59.37-2.24.26-2.92-.57.39-1.56 1.75-2.18 2.6-1.33 1.79-2.59 3.51-3.96 3.51Z",
        fill: "#B3BAC5"
    }), /*#__PURE__*/ (0, $1NIU8.jsx)("defs", null, /*#__PURE__*/ (0, $1NIU8.jsx)("linearGradient", {
        id: id,
        x1: "26.169",
        y1: "228.621",
        x2: "138.408",
        y2: "116.382",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("stop", {
        stopColor: "#C1C7D0"
    }), /*#__PURE__*/ (0, $1NIU8.jsx)("stop", {
        offset: ".297",
        stopColor: "#C6CBD4",
        stopOpacity: ".881"
    }), /*#__PURE__*/ (0, $1NIU8.jsx)("stop", {
        offset: ".63",
        stopColor: "#D3D7DE",
        stopOpacity: ".748"
    }), /*#__PURE__*/ (0, $1NIU8.jsx)("stop", {
        offset: ".98",
        stopColor: "#E9EBEF",
        stopOpacity: ".608"
    }), /*#__PURE__*/ (0, $1NIU8.jsx)("stop", {
        offset: "1",
        stopColor: "#EBECF0",
        stopOpacity: ".6"
    }))));
};

});




parcelRegister("eKKzu", function(module, exports) {

$parcel$export(module.exports, "TypeAheadMenu", () => $e0fdd2bc686666bc$export$b11addef9209139);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $7k8dr = parcelRequire("7k8dr");

var $92xoS = parcelRequire("92xoS");

var $lKOUs = parcelRequire("lKOUs");

var $l9ZHZ = parcelRequire("l9ZHZ");

var $gTtZl = parcelRequire("gTtZl");
const $e0fdd2bc686666bc$export$b11addef9209139 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo(({ editorView: editorView, popupMountRef: popupMountRef, typeAheadState: typeAheadState, selectedIndex: selectedIndex, api: api })=>{
    const isOpen = typeAheadState.decorationSet.find().length > 0;
    const { triggerHandler: triggerHandler, items: items, errorInfo: errorInfo, decorationElement: decorationElement, decorationSet: decorationSet, query: query } = typeAheadState;
    const [onItemInsert, onTextInsert, onItemMatch] = (0, $l9ZHZ.useItemInsert)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    triggerHandler, editorView, items, api);
    const setSelectedItem = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback(({ index: nextIndex })=>{
        queueMicrotask(()=>{
            (0, $lKOUs.updateSelectedIndex)(nextIndex, api)(editorView.state, editorView.dispatch);
        });
    }, [
        editorView,
        api
    ]);
    const insertItem = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((mode = (0, $7k8dr.SelectItemMode).SELECTED, index)=>{
        queueMicrotask(()=>{
            onItemInsert({
                mode: mode,
                index: index,
                query: query
            });
        });
    }, [
        onItemInsert,
        query
    ]);
    const cancel = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback(({ setSelectionAt: setSelectionAt, addPrefixTrigger: addPrefixTrigger, forceFocusOnEditor: forceFocusOnEditor })=>{
        const fullQuery = addPrefixTrigger ? `${triggerHandler?.trigger}${query}` : query;
        onTextInsert({
            forceFocusOnEditor: forceFocusOnEditor,
            setSelectionAt: setSelectionAt,
            text: fullQuery
        });
    }, [
        triggerHandler,
        onTextInsert,
        query
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useEffect(()=>{
        if (!isOpen || !query) return;
        const isLastCharSpace = query[query.length - 1] === ' ';
        if (!isLastCharSpace) return;
        const result = onItemMatch({
            mode: (0, $7k8dr.SelectItemMode).SPACE,
            query: query.trim()
        });
        if (!result) return;
    }, [
        isOpen,
        query,
        onItemMatch
    ]);
    // @ts-ignore
    const openElementBrowserModal = triggerHandler?.openElementBrowserModal;
    let showMoreOptionsButton = false;
    if ((0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1')) showMoreOptionsButton = !!triggerHandler?.getMoreOptionsButtonConfig;
    if (!isOpen || !triggerHandler || !(decorationElement instanceof HTMLElement) || !openElementBrowserModal && items.length === 0 && !errorInfo) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gTtZl.TypeAheadPopup), {
        editorView: editorView,
        popupsMountPoint: popupMountRef.current?.popupsMountPoint,
        popupsBoundariesElement: popupMountRef.current?.popupsBoundariesElement,
        popupsScrollableElement: popupMountRef.current?.popupsScrollableElement,
        anchorElement: decorationElement,
        triggerHandler: triggerHandler,
        items: items,
        errorInfo: errorInfo,
        selectedIndex: selectedIndex,
        setSelectedItem: setSelectedItem,
        onItemInsert: insertItem,
        decorationSet: decorationSet,
        isEmptyQuery: !query,
        cancel: cancel,
        api: api,
        showMoreOptionsButton: showMoreOptionsButton
    });
});

});
parcelRegister("gTtZl", function(module, exports) {

$parcel$export(module.exports, "TypeAheadPopup", () => $c7acae6bbc4703ed$export$fbc0702507873a7d);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $bRPNB = parcelRequire("bRPNB");

var $bMFKb = parcelRequire("bMFKb");

var $kLQ9a = parcelRequire("kLQ9a");
var $bSToC = parcelRequire("bSToC");
var $cxXTK = parcelRequire("cxXTK");

var $7k8dr = parcelRequire("7k8dr");

var $dwnni = parcelRequire("dwnni");
var $avm98 = parcelRequire("avm98");

var $7yBx7 = parcelRequire("7yBx7");

var $eGOwo = parcelRequire("eGOwo");


var $92xoS = parcelRequire("92xoS");

var $2FODv = parcelRequire("2FODv");

var $eQTrE = parcelRequire("eQTrE");

var $elKSH = parcelRequire("elKSH");

var $nMpI6 = parcelRequire("nMpI6");

var $97XBp = parcelRequire("97XBp");
function $c7acae6bbc4703ed$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $c7acae6bbc4703ed$var$DEFAULT_TYPEAHEAD_MENU_HEIGHT = 380;
const $c7acae6bbc4703ed$var$VIEWMORE_BUTTON_HEIGHT = 53;
const $c7acae6bbc4703ed$var$DEFAULT_TYPEAHEAD_MENU_HEIGHT_NEW = 480;
const $c7acae6bbc4703ed$var$ITEM_PADDING = 12;
const $c7acae6bbc4703ed$var$typeAheadContent = /*#__PURE__*/ (0, $1NIU8.css)({
    background: `var(--ds-surface-overlay, ${(0, $7bb4c1736002a04a$export$29a4f05edc054374)})`,
    borderRadius: "var(--ds-border-radius, 3px)",
    boxShadow: `var(--ds-shadow-overlay, ${`0 0 1px ${(0, $7bb4c1736002a04a$export$d2d3bedfb276cac0)}, 0 4px 8px -2px ${(0, $7bb4c1736002a04a$export$7d3359664e8bb0e5)}`})`,
    padding: `${"var(--ds-space-050, 4px)"} 0`,
    width: '320px',
    maxHeight: '380px' /* ~5.5 visibile items */ ,
    overflowY: 'auto',
    MsOverflowStyle: '-ms-autohiding-scrollbar',
    position: 'relative'
});
const $c7acae6bbc4703ed$var$typeAheadContentOverride = /*#__PURE__*/ (0, $1NIU8.css)({
    maxHeight: `${$c7acae6bbc4703ed$var$DEFAULT_TYPEAHEAD_MENU_HEIGHT_NEW}px`
});
const $c7acae6bbc4703ed$var$typeAheadWrapperWithViewMoreOverride = {
    name: "1fttcpj",
    styles: "display:flex;flex-direction:column"
};
const $c7acae6bbc4703ed$var$Highlight = ({ state: state, triggerHandler: triggerHandler })=>{
    if (!triggerHandler?.getHighlight) return null;
    return triggerHandler.getHighlight(state);
};
const $c7acae6bbc4703ed$var$OFFSET = [
    0,
    8
];
const $c7acae6bbc4703ed$var$useSharedState = (0, $kLQ9a.sharedPluginStateHookMigratorFactory)((api)=>{
    const { moreElementsInQuickInsertView: moreElementsInQuickInsertView } = (0, $cxXTK.useSharedPluginStateWithSelector)(api, [
        'featureFlags'
    ], (states)=>({
            moreElementsInQuickInsertView: states.featureFlagsState?.moreElementsInQuickInsertView
        }));
    return {
        moreElementsInQuickInsertView: moreElementsInQuickInsertView
    };
}, (api)=>{
    const { featureFlagsState: featureFlagsState } = (0, $bSToC.useSharedPluginState)(api, [
        'featureFlags'
    ]);
    return {
        moreElementsInQuickInsertView: featureFlagsState?.moreElementsInQuickInsertView
    };
});
const $c7acae6bbc4703ed$export$fbc0702507873a7d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo((props)=>{
    const { editorView: editorView, triggerHandler: triggerHandler, anchorElement: anchorElement, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, items: items, errorInfo: errorInfo, selectedIndex: selectedIndex, onItemInsert: onItemInsert, isEmptyQuery: isEmptyQuery, cancel: cancel, api: api, showMoreOptionsButton: showMoreOptionsButton } = props;
    const ref = (0, $eJOHy.useRef)(null);
    const { moreElementsInQuickInsertView: moreElementsInQuickInsertView } = $c7acae6bbc4703ed$var$useSharedState(api);
    const moreElementsInQuickInsertViewEnabled = moreElementsInQuickInsertView && triggerHandler.id === (0, $7k8dr.TypeAheadAvailableNodes).QUICK_INSERT;
    const isEditorControlsEnabled = (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1');
    const defaultMenuHeight = (0, $eJOHy.useMemo)(()=>moreElementsInQuickInsertViewEnabled ? $c7acae6bbc4703ed$var$DEFAULT_TYPEAHEAD_MENU_HEIGHT_NEW : $c7acae6bbc4703ed$var$DEFAULT_TYPEAHEAD_MENU_HEIGHT, [
        moreElementsInQuickInsertViewEnabled
    ]);
    const activityStateRef = (0, $eJOHy.useRef)({
        inputMethod: null,
        closeAction: null,
        invocationMethod: (0, $elKSH.getPluginState)(editorView.state)?.inputMethod
    });
    const startTime = (0, $eJOHy.useMemo)(()=>performance.now(), // In case those props changes
    // we need to recreate the startTime
    [
        items,
        isEmptyQuery,
        triggerHandler
    ] // eslint-disable-line react-hooks/exhaustive-deps
    );
    (0, $eJOHy.useEffect)(()=>{
        if (!api?.analytics?.actions?.fireAnalyticsEvent) return;
        const stopTime = performance.now();
        const time = stopTime - startTime;
        api?.analytics?.actions?.fireAnalyticsEvent({
            action: (0, $bMFKb.ACTION).RENDERED,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).TYPEAHEAD,
            eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL,
            attributes: {
                time: time,
                items: items.length,
                initial: isEmptyQuery
            }
        });
    }, [
        startTime,
        items,
        isEmptyQuery,
        // In case the current triggerHandler changes
        // e.g: Inserting a mention using the quick insert
        // we need to send the event again
        // eslint-disable-next-line react-hooks/exhaustive-deps
        triggerHandler,
        api
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!api?.analytics?.actions?.fireAnalyticsEvent) return;
        api?.analytics?.actions?.fireAnalyticsEvent({
            action: (0, $bMFKb.ACTION).VIEWED,
            actionSubject: (0, $bMFKb.ACTION_SUBJECT).TYPEAHEAD_ITEM,
            eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL,
            attributes: {
                index: selectedIndex,
                items: items.length
            }
        });
    }, [
        items,
        api,
        selectedIndex,
        // In case the current triggerHandler changes
        // e.g: Inserting a mention using the quick insert
        // we need to send the event again
        // eslint-disable-next-line react-hooks/exhaustive-deps
        triggerHandler
    ]);
    const [fitHeight, setFitHeight] = (0, $eJOHy.useState)(defaultMenuHeight);
    const fitHeightWithViewMore = (0, $eJOHy.useMemo)(()=>{
        if (showMoreOptionsButton) return fitHeight - $c7acae6bbc4703ed$var$VIEWMORE_BUTTON_HEIGHT;
        return fitHeight;
    }, [
        fitHeight,
        showMoreOptionsButton
    ]);
    const getFitHeight = (0, $eJOHy.useCallback)(()=>{
        if (!anchorElement || !popupsMountPoint) return;
        const target = anchorElement;
        const { top: targetTop, height: targetHeight } = target.getBoundingClientRect();
        const boundariesElement = popupsBoundariesElement || document.body;
        const { height: boundariesHeight, top: boundariesTop } = boundariesElement.getBoundingClientRect();
        // Calculating the space above and space below our decoration
        const spaceAbove = targetTop - (boundariesTop - boundariesElement.scrollTop);
        const spaceBelow = boundariesTop + boundariesHeight - (targetTop + targetHeight);
        // Keep default height if more than enough space
        if (spaceBelow >= defaultMenuHeight) return setFitHeight(defaultMenuHeight);
        // Determines whether typeahead will fit above or below decoration
        // and return the space available.
        const newFitHeight = spaceBelow >= spaceAbove ? spaceBelow : spaceAbove;
        // Each typeahead item has some padding
        // We want to leave some space at the top so first item
        // is not partially cropped
        const fitHeightWithSpace = newFitHeight - $c7acae6bbc4703ed$var$ITEM_PADDING * 2;
        // Ensure typeahead height is max its default height
        const minFitHeight = Math.min(defaultMenuHeight, fitHeightWithSpace);
        return setFitHeight(minFitHeight);
    }, [
        anchorElement,
        defaultMenuHeight,
        popupsBoundariesElement,
        popupsMountPoint
    ]);
    const getFitHeightDebounced = (0, $bRPNB.default)(getFitHeight);
    (0, $eJOHy.useLayoutEffect)(()=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const scrollableElement = popupsScrollableElement || (0, $dwnni.findOverflowScrollParent)(anchorElement);
        getFitHeight();
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.addEventListener('resize', getFitHeightDebounced);
        if (scrollableElement) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        scrollableElement.addEventListener('scroll', getFitHeightDebounced);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            window.removeEventListener('resize', getFitHeightDebounced);
            if (scrollableElement) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            scrollableElement.removeEventListener('scroll', getFitHeightDebounced);
        };
    }, [
        anchorElement,
        popupsScrollableElement,
        getFitHeightDebounced,
        getFitHeight
    ]);
    (0, $eJOHy.useLayoutEffect)(()=>{
        const { removePrefixTriggerOnCancel: removePrefixTriggerOnCancel } = (0, $elKSH.getPluginState)(editorView.state) || {};
        const focusOut = (event)=>{
            const { relatedTarget: relatedTarget } = event;
            // Given the user is changing the focus
            // When the target is inside the TypeAhead Popup
            // Then the popup should stay open
            if (relatedTarget instanceof HTMLElement && relatedTarget.closest && (relatedTarget.closest(`.${(0, $eQTrE.TYPE_AHEAD_POPUP_CONTENT_CLASS)}`) || relatedTarget.closest(`[data-type-ahead="${(0, $eQTrE.TYPE_AHEAD_DECORATION_DATA_ATTRIBUTE)}"]`))) return;
            // Handles cases like emoji (:) and mention (@) typeaheads that open new typeaheads
            const isTextSelected = window.getSelection()?.type === 'Range';
            if ((0, $eGOwo.fg)('platform_editor_legacy_content_macro_typeahead_fix')) {
                const innerEditor = anchorElement.closest('.extension-editable-area');
                if (innerEditor) {
                    // When there is no related target, we default to not closing the popup
                    let newFocusInsideCurrentEditor = !relatedTarget;
                    if (relatedTarget instanceof HTMLElement) // check if the new focus is inside inner editor, keep popup opens
                    newFocusInsideCurrentEditor = innerEditor.contains(relatedTarget);
                    if (!isTextSelected && newFocusInsideCurrentEditor) return;
                } else {
                    // if the current focus in outer editor, keep the existing behaviour, do not close the pop up if text is not selected
                    if (!isTextSelected) return;
                }
            } else {
                if (!isTextSelected) return;
            }
            cancel({
                addPrefixTrigger: isEditorControlsEnabled ? !removePrefixTriggerOnCancel : true,
                setSelectionAt: (0, $eQTrE.CloseSelectionOptions).AFTER_TEXT_INSERTED,
                forceFocusOnEditor: false
            });
        };
        const { current: element } = ref;
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element?.addEventListener('focusout', focusOut);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element?.removeEventListener('focusout', focusOut);
        };
    }, [
        ref,
        cancel,
        editorView.state,
        isEditorControlsEnabled,
        anchorElement
    ]);
    // TODO: ED-17443 - When you press escape on typeahead panel, it should remove focus and close the panel
    // This is the expected keyboard behaviour advised by the Accessibility team
    (0, $eJOHy.useLayoutEffect)(()=>{
        const { removePrefixTriggerOnCancel: removePrefixTriggerOnCancel } = (0, $elKSH.getPluginState)(editorView.state) || {};
        const escape = (event)=>{
            if (event.key === 'Escape') {
                activityStateRef.current.inputMethod = (0, $bMFKb.INPUT_METHOD).KEYBOARD;
                cancel({
                    addPrefixTrigger: isEditorControlsEnabled ? !removePrefixTriggerOnCancel : true,
                    setSelectionAt: (0, $eQTrE.CloseSelectionOptions).AFTER_TEXT_INSERTED,
                    forceFocusOnEditor: true
                });
            }
        };
        const { current: element } = ref;
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element?.addEventListener('keydown', escape);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element?.removeEventListener('keydown', escape);
        };
    }, [
        ref,
        cancel,
        editorView.state,
        isEditorControlsEnabled
    ]);
    // @ts-ignore
    const openElementBrowserModal = triggerHandler?.openElementBrowserModal;
    const onMoreOptionsClicked = (0, $eJOHy.useCallback)(()=>{
        if (// eslint-disable-next-line @atlaskit/platform/no-preconditioning
        openElementBrowserModal && (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1') && triggerHandler.id === (0, $7k8dr.TypeAheadAvailableNodes).QUICK_INSERT) activityStateRef.current = {
            inputMethod: (0, $bMFKb.INPUT_METHOD).MOUSE,
            closeAction: (0, $bMFKb.ACTION).VIEW_MORE,
            invocationMethod: activityStateRef.current.invocationMethod
        };
    }, [
        openElementBrowserModal,
        triggerHandler.id
    ]);
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $avm98.default), {
        zIndex: (0, $7yBx7.akEditorFloatingDialogZIndex),
        target: anchorElement,
        mountTo: popupsMountPoint,
        boundariesElement: popupsBoundariesElement,
        scrollableElement: popupsScrollableElement,
        fitHeight: fitHeight,
        fitWidth: 340,
        offset: $c7acae6bbc4703ed$var$OFFSET,
        ariaLabel: null,
        preventOverflow: true,
        onUnmount: ()=>{
            if (selectedIndex > -1 && (0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1')) {
                // if selectedIndex is -1, it means that the user has not selected any item
                // will be handled by WrapperTypeAhead
                (0, $2FODv.fireTypeAheadClosedAnalyticsEvent)(api, activityStateRef.current.closeAction || (0, $bMFKb.ACTION).CANCELLED, !isEmptyQuery, activityStateRef.current.inputMethod || (0, $bMFKb.INPUT_METHOD).MOUSE, activityStateRef.current.invocationMethod);
                // reset activity state
                activityStateRef.current = {
                    inputMethod: null,
                    closeAction: null,
                    invocationMethod: null
                };
            }
        }
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: [
            $c7acae6bbc4703ed$var$typeAheadContent,
            moreElementsInQuickInsertViewEnabled && $c7acae6bbc4703ed$var$typeAheadContentOverride,
            showMoreOptionsButton && $c7acae6bbc4703ed$var$typeAheadWrapperWithViewMoreOverride
        ],
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $eQTrE.TYPE_AHEAD_POPUP_CONTENT_CLASS),
        ref: ref
    }, errorInfo ? /*#__PURE__*/ (0, $1NIU8.jsx)((0, $nMpI6.TypeAheadErrorFallback), null) : /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, $1NIU8.jsx)($c7acae6bbc4703ed$var$Highlight, {
        state: editorView.state,
        triggerHandler: triggerHandler
    }), /*#__PURE__*/ (0, $1NIU8.jsx)((0, $97XBp.TypeAheadList), {
        items: items,
        selectedIndex: selectedIndex,
        onItemClick: (mode, index, inputMethod)=>{
            if ((0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1')) activityStateRef.current = {
                inputMethod: inputMethod || null,
                closeAction: (0, $bMFKb.ACTION).INSERTED,
                invocationMethod: activityStateRef.current.invocationMethod
            };
            onItemInsert(mode, index);
        },
        fitHeight: fitHeightWithViewMore,
        editorView: editorView,
        decorationElement: anchorElement,
        triggerHandler: triggerHandler,
        moreElementsInQuickInsertViewEnabled: moreElementsInQuickInsertViewEnabled,
        api: api,
        showMoreOptionsButton: showMoreOptionsButton,
        onMoreOptionsClicked: onMoreOptionsClicked
    }))));
});
$c7acae6bbc4703ed$export$fbc0702507873a7d.displayName = 'TypeAheadPopup';

});
parcelRegister("97XBp", function(module, exports) {

$parcel$export(module.exports, "TypeAheadList", () => $82d4adc319c78782$export$81b66b5b19964713);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $6YFG2 = parcelRequire("6YFG2");
var $lRq8t = parcelRequire("lRq8t");

var $35QbZ = parcelRequire("35QbZ");

var $h5TVk = parcelRequire("h5TVk");

var $bMFKb = parcelRequire("bMFKb");

var $46A2h = parcelRequire("46A2h");

var $7k8dr = parcelRequire("7k8dr");
var $4drex = parcelRequire("4drex");

var $b7eFx = parcelRequire("b7eFx");

var $jUgeq = parcelRequire("jUgeq");

var $eGOwo = parcelRequire("eGOwo");

var $8IeH1 = parcelRequire("8IeH1");
var $3cMgR = parcelRequire("3cMgR");

var $azYbd = parcelRequire("azYbd");

var $lKOUs = parcelRequire("lKOUs");

var $eQTrE = parcelRequire("eQTrE");

var $elKSH = parcelRequire("elKSH");

var $ajlZ9 = parcelRequire("ajlZ9");

var $3mtr1 = parcelRequire("3mtr1");

var $9aOK1 = parcelRequire("9aOK1");
const $82d4adc319c78782$var$LIST_ITEM_ESTIMATED_HEIGHT = 64;
const $82d4adc319c78782$var$LIST_WIDTH = 320;
const $82d4adc319c78782$var$list = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    button: {
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-150, 12px)"}`
    }
});
const $82d4adc319c78782$var$TypeaheadAssistiveTextPureComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo(({ numberOfResults: numberOfResults })=>{
    const intl = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $b7eFx.AssistiveText), {
        assistiveText: intl.formatMessage((0, $4drex.typeAheadListMessages).searchResultsLabel, {
            itemsLength: numberOfResults
        }),
        // when the popup is open its always in focus
        isInFocus: true,
        id: (0, $eQTrE.TYPE_AHEAD_DECORATION_ELEMENT_ID) + '__popup'
    });
});
const $82d4adc319c78782$var$TypeAheadListComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo(({ items: items, selectedIndex: selectedIndex, editorView: editorView, onItemClick: onItemClick, intl: intl, fitHeight: fitHeight, decorationElement: decorationElement, triggerHandler: triggerHandler, moreElementsInQuickInsertViewEnabled: moreElementsInQuickInsertViewEnabled, api: api, showMoreOptionsButton: showMoreOptionsButton, onMoreOptionsClicked: onMoreOptionsClicked })=>{
    const listRef = (0, $eJOHy.useRef)();
    const listContainerRef = (0, $eJOHy.useRef)(null);
    const lastVisibleIndexes = (0, $eJOHy.useRef)({
        overscanStartIndex: 0,
        overscanStopIndex: 0,
        startIndex: 0,
        stopIndex: 0
    });
    // Exclude view more item from the count
    const itemsLength = showMoreOptionsButton ? Math.max(items.length - 1, 0) : items.length;
    const estimatedHeight = itemsLength * $82d4adc319c78782$var$LIST_ITEM_ESTIMATED_HEIGHT;
    const [height, setHeight] = (0, $eJOHy.useState)(Math.min(estimatedHeight, fitHeight));
    const [cache, setCache] = (0, $eJOHy.useState)(new (0, $35QbZ.CellMeasurerCache)({
        fixedWidth: true,
        defaultHeight: $82d4adc319c78782$var$LIST_ITEM_ESTIMATED_HEIGHT
    }));
    const onItemsRendered = (0, $eJOHy.useCallback)((props)=>{
        lastVisibleIndexes.current = props;
    }, []);
    const actions = (0, $eJOHy.useMemo)(()=>({
            onItemClick: onItemClick
        }), [
        onItemClick
    ]);
    const isNavigationKey = (event)=>{
        return [
            'ArrowDown',
            'ArrowUp',
            'Tab',
            'Enter'
        ].includes(event.key);
    };
    const focusTargetElement = (0, $eJOHy.useCallback)(()=>{
        //To reset the selected index
        (0, $lKOUs.updateSelectedIndex)(-1, api)(editorView.state, editorView.dispatch);
        listRef.current.scrollToRow(0);
        decorationElement?.querySelector(`[role='combobox']`)?.focus();
    }, [
        editorView,
        listRef,
        decorationElement,
        api
    ]);
    const selectNextItem = (0, $eJOHy.useMemo)(()=>(0, $elKSH.moveSelectedIndex)({
            editorView: editorView,
            direction: 'next',
            api: api
        }), [
        editorView,
        api
    ]);
    const selectPreviousItem = (0, $eJOHy.useMemo)(()=>(0, $elKSH.moveSelectedIndex)({
            editorView: editorView,
            direction: 'previous',
            api: api
        }), [
        editorView,
        api
    ]);
    const lastVisibleStartIndex = lastVisibleIndexes.current.startIndex;
    const lastVisibleStopIndex = lastVisibleIndexes.current.stopIndex;
    const onScroll = (0, $eJOHy.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ({ scrollUpdateWasRequested: scrollUpdateWasRequested })=>{
        if (!scrollUpdateWasRequested) return;
        // In case the user scroll to a non-visible item like press ArrowUp from the first index
        // We will force the scroll calling the scrollToItem in the useEffect hook
        // When the scroll happens and we render the elements,
        // we still need calculate the items height and re-draw the List.
        // It is possible the item selected became invisible again (because the items height changed)
        // So, we need to wait for height to be calculated. Then we need to check
        // if the selected item is visible or not. If it isn't visible we call the scrollToItem again.
        //
        // We can't do this check in the first frame because that frame is being used by the resetScreenThrottled
        // to calculate each height. THen, we can schedule a new frame when this one finishs.
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                const isViewMoreSelected = showMoreOptionsButton && selectedIndex === itemsLength;
                const isSelectedItemVisible = selectedIndex >= lastVisibleStartIndex && selectedIndex <= lastVisibleStopIndex || // view more is always visible, hence no scrolling
                isViewMoreSelected;
                //Should scroll to the list item only when the selectedIndex >= 0 and item is not visible
                if (!isSelectedItemVisible && selectedIndex !== -1) listRef.current.scrollToRow(selectedIndex);
                else if (selectedIndex === -1) listRef.current.scrollToRow(0);
            });
        });
    }, [
        selectedIndex,
        lastVisibleStartIndex,
        lastVisibleStopIndex,
        itemsLength,
        showMoreOptionsButton
    ]);
    const onMouseMove = (event, index)=>{
        event.preventDefault();
        event.stopPropagation();
        if (selectedIndex === index) return;
        (0, $lKOUs.updateSelectedIndex)(index, api)(editorView.state, editorView.dispatch);
    };
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (!listRef.current) return;
        const isViewMoreSelected = showMoreOptionsButton && selectedIndex === itemsLength;
        const isSelectedItemVisible = selectedIndex >= lastVisibleStartIndex && selectedIndex <= lastVisibleStopIndex || // view more is always visible, hence no scrolling
        isViewMoreSelected;
        //Should scroll to the list item only when the selectedIndex >= 0 and item is not visible
        if (!isSelectedItemVisible && selectedIndex !== -1) listRef.current.scrollToRow(selectedIndex);
        else if (selectedIndex === -1) listRef.current.scrollToRow(0);
    }, [
        selectedIndex,
        lastVisibleStartIndex,
        lastVisibleStopIndex,
        itemsLength,
        showMoreOptionsButton
    ]);
    (0, $eJOHy.useLayoutEffect)(()=>{
        setCache(new (0, $35QbZ.CellMeasurerCache)({
            fixedWidth: true,
            defaultHeight: $82d4adc319c78782$var$LIST_ITEM_ESTIMATED_HEIGHT
        }));
        // When query is updated, sometimes the scroll position of the menu is not at the top
        // Scrolling back to top for consistency
        requestAnimationFrame(()=>{
            if (listContainerRef.current?.firstChild) // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            listContainerRef.current.firstChild.scrollTo(0, 0);
        });
    }, [
        items
    ]);
    (0, $eJOHy.useLayoutEffect)(()=>{
        // Exclude view more item from the count
        const itemsToRender = showMoreOptionsButton ? items.slice(0, -1) : items;
        const height = Math.min(itemsToRender.reduce((prevValue, currentValue, index)=>{
            return prevValue + cache.rowHeight({
                index: index
            });
        }, 0), fitHeight);
        setHeight(height);
    }, [
        items,
        cache,
        fitHeight,
        showMoreOptionsButton
    ]);
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (!listContainerRef.current) return;
        const { current: element } = listContainerRef;
        /**
     * To handle the key events on the list
     * @param event
     * @example
     */ const handleKeyDown = (event)=>{
            if (isNavigationKey(event)) switch(event.key){
                case 'ArrowDown':
                    selectNextItem();
                    event.preventDefault();
                    event.stopPropagation();
                    break;
                case 'ArrowUp':
                    selectPreviousItem();
                    event.preventDefault();
                    event.stopPropagation();
                    break;
                // TODO: DTR-1401 - why is this calling item click when hitting tab? fix this in DTR-1401
                case 'Tab':
                    //Tab key quick inserts the selected item.
                    onItemClick((0, $7k8dr.SelectItemMode).TAB, selectedIndex, (0, $bMFKb.INPUT_METHOD).KEYBOARD);
                    event.preventDefault();
                    break;
                case 'Enter':
                    //Enter key quick inserts the selected item.
                    if (!event.isComposing || event.which !== 229 && event.keyCode !== 229) {
                        onItemClick(event.shiftKey ? (0, $7k8dr.SelectItemMode).SHIFT_ENTER : (0, $7k8dr.SelectItemMode).ENTER, selectedIndex, (0, $bMFKb.INPUT_METHOD).KEYBOARD);
                        event.preventDefault();
                    }
                    break;
                default:
                    event.preventDefault();
            }
            else //All the remaining keys sets focus on the typeahead query(inputQuery.tsx))
            focusTargetElement();
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element?.addEventListener('keydown', handleKeyDown);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element?.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        editorView.state,
        focusTargetElement,
        selectNextItem,
        selectPreviousItem,
        selectedIndex,
        onItemClick,
        itemsLength
    ]);
    const firstOnlineSupportedRow = (0, $eJOHy.useMemo)(()=>{
        return items.findIndex((item)=>item.isDisabledOffline !== true);
    }, [
        items
    ]);
    const config = triggerHandler?.getMoreOptionsButtonConfig?.(intl);
    const handleClick = ()=>{
        if (onMoreOptionsClicked) onMoreOptionsClicked();
        api?.core.actions.execute(({ tr: tr })=>{
            (0, $azYbd.closeTypeAhead)(tr);
            config?.onClick({
                tr: tr
            });
            return tr;
        });
    };
    const renderRow = ({ index: index, key: key, style: style, parent: parent, isScrolling: isScrolling, isVisible: isVisible })=>{
        const currentItem = items[index];
        return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $35QbZ.CellMeasurer), {
            key: key,
            cache: cache,
            parent: parent,
            columnIndex: 0,
            rowIndex: index
        }, (0, $eGOwo.fg)('platform_editor_typeahead_dynamic_height_fix') ? ({ measure: measure, registerChild: registerChild })=>/*#__PURE__*/ (0, $1NIU8.jsx)((0, $ajlZ9.ListRow), {
                registerChild: registerChild,
                measure: measure,
                index: index,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                style: style,
                isVisible: isVisible,
                isScrolling: isScrolling,
                onMouseMove: (e)=>onMouseMove(e, index)
            }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $9aOK1.TypeAheadListItem), {
                key: items[index].title,
                item: currentItem,
                firstOnlineSupportedIndex: firstOnlineSupportedRow,
                itemsLength: itemsLength,
                itemIndex: index,
                selectedIndex: selectedIndex,
                onItemClick: (mode, index)=>{
                    actions.onItemClick(mode, index, (0, $bMFKb.INPUT_METHOD).MOUSE);
                },
                ariaLabel: (0, $elKSH.getTypeAheadListAriaLabels)(triggerHandler?.trigger, intl, currentItem).listItemAriaLabel,
                moreElementsInQuickInsertViewEnabled: moreElementsInQuickInsertViewEnabled,
                api: api
            })) : /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: style,
            "data-index": index
        }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            "data-testid": `list-item-height-observed-${index}`,
            onMouseMove: (e)=>onMouseMove(e, index)
        }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $9aOK1.TypeAheadListItem), {
            key: items[index].title,
            item: currentItem,
            firstOnlineSupportedIndex: firstOnlineSupportedRow,
            itemsLength: itemsLength,
            itemIndex: index,
            selectedIndex: selectedIndex,
            onItemClick: (mode, index)=>{
                actions.onItemClick(mode, index, (0, $bMFKb.INPUT_METHOD).MOUSE);
            },
            ariaLabel: (0, $elKSH.getTypeAheadListAriaLabels)(triggerHandler?.trigger, intl, currentItem).listItemAriaLabel,
            moreElementsInQuickInsertViewEnabled: moreElementsInQuickInsertViewEnabled,
            api: api
        }))));
    };
    const popupAriaLabel = (0, $elKSH.getTypeAheadListAriaLabels)(triggerHandler?.trigger, intl).popupAriaLabel;
    if (!Array.isArray(items)) return null;
    const menuGroupId = decorationElement.querySelector(`[role='combobox']`)?.getAttribute('aria-controls') || (0, $eQTrE.TYPE_AHEAD_DECORATION_ELEMENT_ID);
    const EmptyResultView = /*#__PURE__*/ (0, $1NIU8.jsx)((0, $8IeH1.default), {
        paddingBlock: "space.150",
        paddingInline: "space.250"
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $3cMgR.default), {
        align: "center",
        as: "p"
    }, intl.formatMessage((0, $4drex.typeAheadListMessages).emptySearchResults)), /*#__PURE__*/ (0, $1NIU8.jsx)((0, $3cMgR.default), {
        align: "center",
        as: "p"
    }, intl.formatMessage((0, $4drex.typeAheadListMessages).emptySearchResultsSuggestion, {
        buttonName: /*#__PURE__*/ (0, $1NIU8.jsx)((0, $3cMgR.default), {
            weight: "medium"
        }, intl.formatMessage((0, $46A2h.toolbarInsertBlockMessages).viewMore))
    })));
    const ListContent = /*#__PURE__*/ (0, $1NIU8.jsx)((0, $h5TVk.List), {
        rowRenderer: renderRow,
        ref: listRef,
        // Skip rendering the view more button in the list
        rowCount: itemsLength,
        rowHeight: cache.rowHeight,
        onRowsRendered: onItemsRendered,
        width: $82d4adc319c78782$var$LIST_WIDTH,
        onScroll: onScroll,
        height: height,
        overscanRowCount: 3,
        // We need to make this walkaround to make TS happy, cannot pass undefined otherwise ReactVirualized will make it equal to "grid" which we want to avoid
        // https://github.com/bvaughn/react-virtualized/blob/master/source/Grid/Grid.js#L260
        "aria-label": null,
        containerRole: "presentation",
        role: "listbox",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: [
            /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $1NIU8.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
                button: {
                    padding: `${"var(--ds-space-150, 12px)"} ${"var(--ds-space-150, 12px)"} 11px`,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                    'span:last-child span:last-child': {
                        whiteSpace: 'normal'
                    }
                }
            }),
            moreElementsInQuickInsertViewEnabled && $82d4adc319c78782$var$list
        ]
    });
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $jUgeq.default), {
        "aria-label": popupAriaLabel,
        "aria-relevant": "additions removals"
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        id: menuGroupId,
        ref: listContainerRef
    }, !showMoreOptionsButton || itemsLength ? ListContent : EmptyResultView, showMoreOptionsButton && config && /*#__PURE__*/ (0, $1NIU8.jsx)((0, $3mtr1.MoreOptions), {
        title: config.title,
        ariaLabel: config.ariaLabel,
        onClick: handleClick,
        isFocused: selectedIndex === itemsLength,
        iconBefore: config.iconBefore
    }), /*#__PURE__*/ (0, $1NIU8.jsx)($82d4adc319c78782$var$TypeaheadAssistiveTextPureComponent, {
        numberOfResults: itemsLength.toString()
    })));
});
const $82d4adc319c78782$export$81b66b5b19964713 = (0, $6YFG2.default)($82d4adc319c78782$var$TypeAheadListComponent);
$82d4adc319c78782$export$81b66b5b19964713.displayName = 'TypeAheadList';

});
parcelRegister("35QbZ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CellMeasurerCache = module.exports.CellMeasurer = undefined;

var $yf0ml = parcelRequire("yf0ml");
var $240a5306f44d8457$var$_CellMeasurer2 = $240a5306f44d8457$var$_interopRequireDefault($yf0ml);

var $lzsUS = parcelRequire("lzsUS");
var $240a5306f44d8457$var$_CellMeasurerCache2 = $240a5306f44d8457$var$_interopRequireDefault($lzsUS);
function $240a5306f44d8457$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports.default = $240a5306f44d8457$var$_CellMeasurer2.default;
module.exports.CellMeasurer = $240a5306f44d8457$var$_CellMeasurer2.default;
module.exports.CellMeasurerCache = $240a5306f44d8457$var$_CellMeasurerCache2.default;

});
parcelRegister("yf0ml", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1nR2i = parcelRequire("1nR2i");
var $066ed0bb0d3c192f$var$_getPrototypeOf2 = $066ed0bb0d3c192f$var$_interopRequireDefault($1nR2i);

var $jK0mf = parcelRequire("jK0mf");
var $066ed0bb0d3c192f$var$_classCallCheck3 = $066ed0bb0d3c192f$var$_interopRequireDefault($jK0mf);

var $7kKnu = parcelRequire("7kKnu");
var $066ed0bb0d3c192f$var$_createClass3 = $066ed0bb0d3c192f$var$_interopRequireDefault($7kKnu);

var $dopow = parcelRequire("dopow");
var $066ed0bb0d3c192f$var$_possibleConstructorReturn3 = $066ed0bb0d3c192f$var$_interopRequireDefault($dopow);

var $2G5Ta = parcelRequire("2G5Ta");
var $066ed0bb0d3c192f$var$_inherits3 = $066ed0bb0d3c192f$var$_interopRequireDefault($2G5Ta);

var $eJOHy = parcelRequire("eJOHy");
var $066ed0bb0d3c192f$var$React = $066ed0bb0d3c192f$var$_interopRequireWildcard($eJOHy);

var $aQK2r = parcelRequire("aQK2r");
parcelRequire("bZRz7");

var $cT3Ey = parcelRequire("cT3Ey");
var $066ed0bb0d3c192f$var$_propTypes2 = $066ed0bb0d3c192f$var$_interopRequireDefault($cT3Ey);
function $066ed0bb0d3c192f$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $066ed0bb0d3c192f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Wraps a cell and measures its rendered content.
 * Measurements are stored in a per-cell cache.
 * Cached-content is not be re-measured.
 */ var $066ed0bb0d3c192f$var$CellMeasurer = function(_React$PureComponent) {
    (0, $066ed0bb0d3c192f$var$_inherits3.default)(CellMeasurer, _React$PureComponent);
    function CellMeasurer() {
        var _ref;
        var _temp, _this, _ret;
        (0, $066ed0bb0d3c192f$var$_classCallCheck3.default)(this, CellMeasurer);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = (0, $066ed0bb0d3c192f$var$_possibleConstructorReturn3.default)(this, (_ref = CellMeasurer.__proto__ || (0, $066ed0bb0d3c192f$var$_getPrototypeOf2.default)(CellMeasurer)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this._measure = function() {
            var _this$props = _this.props, cache = _this$props.cache, _this$props$columnInd = _this$props.columnIndex, columnIndex = _this$props$columnInd === undefined ? 0 : _this$props$columnInd, parent = _this$props.parent, _this$props$rowIndex = _this$props.rowIndex, rowIndex = _this$props$rowIndex === undefined ? _this.props.index || 0 : _this$props$rowIndex;
            var _this$_getCellMeasure = _this._getCellMeasurements(), height = _this$_getCellMeasure.height, width = _this$_getCellMeasure.width;
            if (height !== cache.getHeight(rowIndex, columnIndex) || width !== cache.getWidth(rowIndex, columnIndex)) {
                cache.set(rowIndex, columnIndex, width, height);
                if (parent && typeof parent.recomputeGridSize === 'function') parent.recomputeGridSize({
                    columnIndex: columnIndex,
                    rowIndex: rowIndex
                });
            }
        }, _temp), (0, $066ed0bb0d3c192f$var$_possibleConstructorReturn3.default)(_this, _ret);
    }
    (0, $066ed0bb0d3c192f$var$_createClass3.default)(CellMeasurer, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this._maybeMeasureCell();
            }
        },
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate() {
                this._maybeMeasureCell();
            }
        },
        {
            key: 'render',
            value: function render() {
                var children = this.props.children;
                return typeof children === 'function' ? children({
                    measure: this._measure
                }) : children;
            }
        },
        {
            key: '_getCellMeasurements',
            value: function _getCellMeasurements() {
                var cache = this.props.cache;
                var node = (0, $aQK2r.findDOMNode)(this);
                // TODO Check for a bad combination of fixedWidth and missing numeric width or vice versa with height
                if (node && node.ownerDocument && node.ownerDocument.defaultView && node instanceof node.ownerDocument.defaultView.HTMLElement) {
                    var styleWidth = node.style.width;
                    var styleHeight = node.style.height;
                    // If we are re-measuring a cell that has already been measured,
                    // It will have a hard-coded width/height from the previous measurement.
                    // The fact that we are measuring indicates this measurement is probably stale,
                    // So explicitly clear it out (eg set to "auto") so we can recalculate.
                    // See issue #593 for more info.
                    // Even if we are measuring initially- if we're inside of a MultiGrid component,
                    // Explicitly clear width/height before measuring to avoid being tainted by another Grid.
                    // eg top/left Grid renders before bottom/right Grid
                    // Since the CellMeasurerCache is shared between them this taints derived cell size values.
                    if (!cache.hasFixedWidth()) node.style.width = 'auto';
                    if (!cache.hasFixedHeight()) node.style.height = 'auto';
                    var height = Math.ceil(node.offsetHeight);
                    var width = Math.ceil(node.offsetWidth);
                    // Reset after measuring to avoid breaking styles; see #660
                    if (styleWidth) node.style.width = styleWidth;
                    if (styleHeight) node.style.height = styleHeight;
                    return {
                        height: height,
                        width: width
                    };
                } else return {
                    height: 0,
                    width: 0
                };
            }
        },
        {
            key: '_maybeMeasureCell',
            value: function _maybeMeasureCell() {
                var _props = this.props, cache = _props.cache, _props$columnIndex = _props.columnIndex, columnIndex = _props$columnIndex === undefined ? 0 : _props$columnIndex, parent = _props.parent, _props$rowIndex = _props.rowIndex, rowIndex = _props$rowIndex === undefined ? this.props.index || 0 : _props$rowIndex;
                if (!cache.has(rowIndex, columnIndex)) {
                    var _getCellMeasurements2 = this._getCellMeasurements(), height = _getCellMeasurements2.height, width = _getCellMeasurements2.width;
                    cache.set(rowIndex, columnIndex, width, height);
                    // If size has changed, let Grid know to re-render.
                    if (parent && typeof parent.invalidateCellSizeAfterRender === 'function') parent.invalidateCellSizeAfterRender({
                        columnIndex: columnIndex,
                        rowIndex: rowIndex
                    });
                }
            }
        }
    ]);
    return CellMeasurer;
}($066ed0bb0d3c192f$var$React.PureComponent);
// Used for DEV mode warning check
$066ed0bb0d3c192f$var$CellMeasurer.__internalCellMeasurerFlag = false;
$066ed0bb0d3c192f$var$CellMeasurer.propTypes = null;
module.exports.default = $066ed0bb0d3c192f$var$CellMeasurer;

});
parcelRegister("1nR2i", function(module, exports) {

module.exports = {
    "default": (parcelRequire("eU9F0")),
    __esModule: true
};

});
parcelRegister("eU9F0", function(module, exports) {
parcelRequire("kqxjQ");

module.exports = (parcelRequire("h9BqL")).Object.getPrototypeOf;

});
parcelRegister("kqxjQ", function(module, exports) {
// 19.1.2.9 Object.getPrototypeOf(O)

var $9IOcn = parcelRequire("9IOcn");

var $fuXB7 = parcelRequire("fuXB7");

(parcelRequire("6rscv"))('getPrototypeOf', function() {
    return function getPrototypeOf(it) {
        return $fuXB7($9IOcn(it));
    };
});

});
parcelRegister("9IOcn", function(module, exports) {
// 7.1.13 ToObject(argument)

var $iojCL = parcelRequire("iojCL");
module.exports = function(it) {
    return Object($iojCL(it));
};

});
parcelRegister("iojCL", function(module, exports) {
// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it) {
    if (it == undefined) throw TypeError("Can't call method on  " + it);
    return it;
};

});


parcelRegister("fuXB7", function(module, exports) {
// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)

var $2k1EH = parcelRequire("2k1EH");

var $9IOcn = parcelRequire("9IOcn");

var $b487e33d08476ef6$var$IE_PROTO = (parcelRequire("dqUYm"))('IE_PROTO');
var $b487e33d08476ef6$var$ObjectProto = Object.prototype;
module.exports = Object.getPrototypeOf || function(O) {
    O = $9IOcn(O);
    if ($2k1EH(O, $b487e33d08476ef6$var$IE_PROTO)) return O[$b487e33d08476ef6$var$IE_PROTO];
    if (typeof O.constructor == 'function' && O instanceof O.constructor) return O.constructor.prototype;
    return O instanceof Object ? $b487e33d08476ef6$var$ObjectProto : null;
};

});
parcelRegister("2k1EH", function(module, exports) {
var $1b0ebbbf46784288$var$hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key) {
    return $1b0ebbbf46784288$var$hasOwnProperty.call(it, key);
};

});

parcelRegister("dqUYm", function(module, exports) {

var $9c79e5a684320090$var$shared = (parcelRequire("he9HP"))('keys');

var $d07cI = parcelRequire("d07cI");
module.exports = function(key) {
    return $9c79e5a684320090$var$shared[key] || ($9c79e5a684320090$var$shared[key] = $d07cI(key));
};

});
parcelRegister("he9HP", function(module, exports) {

var $h9BqL = parcelRequire("h9BqL");

var $ea50F = parcelRequire("ea50F");
var $c8ab45da1606111a$var$SHARED = '__core-js_shared__';
var $c8ab45da1606111a$var$store = $ea50F[$c8ab45da1606111a$var$SHARED] || ($ea50F[$c8ab45da1606111a$var$SHARED] = {});

(module.exports = function(key, value) {
    return $c8ab45da1606111a$var$store[key] || ($c8ab45da1606111a$var$store[key] = value !== undefined ? value : {});
})('versions', []).push({
    version: $h9BqL.version,
    mode: (parcelRequire("336Nq")) ? 'pure' : 'global',
    copyright: "\xa9 2020 Denis Pushkarev (zloirock.ru)"
});

});
parcelRegister("h9BqL", function(module, exports) {
var $c7d04fe055d04aa8$var$core = module.exports = {
    version: '2.6.12'
};
if (typeof __e == 'number') __e = $c7d04fe055d04aa8$var$core; // eslint-disable-line no-undef

});

parcelRegister("ea50F", function(module, exports) {
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var $a4f5e2b85dab3797$var$global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if (typeof __g == 'number') __g = $a4f5e2b85dab3797$var$global; // eslint-disable-line no-undef

});

parcelRegister("336Nq", function(module, exports) {
module.exports = true;

});


parcelRegister("d07cI", function(module, exports) {
var $9770dd0be1eab494$var$id = 0;
var $9770dd0be1eab494$var$px = Math.random();
module.exports = function(key) {
    return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++$9770dd0be1eab494$var$id + $9770dd0be1eab494$var$px).toString(36));
};

});



parcelRegister("6rscv", function(module, exports) {
// most Object methods by ES6 should accept primitives

var $1VdgD = parcelRequire("1VdgD");

var $h9BqL = parcelRequire("h9BqL");

var $60hL6 = parcelRequire("60hL6");
module.exports = function(KEY, exec) {
    var fn = ($h9BqL.Object || {})[KEY] || Object[KEY];
    var exp = {};
    exp[KEY] = exec(fn);
    $1VdgD($1VdgD.S + $1VdgD.F * $60hL6(function() {
        fn(1);
    }), 'Object', exp);
};

});
parcelRegister("1VdgD", function(module, exports) {

var $ea50F = parcelRequire("ea50F");

var $h9BqL = parcelRequire("h9BqL");

var $hFYx0 = parcelRequire("hFYx0");

var $2fICR = parcelRequire("2fICR");

var $2k1EH = parcelRequire("2k1EH");
var $166567f03e3e0b37$var$PROTOTYPE = 'prototype';
var $166567f03e3e0b37$var$$export = function(type, name, source) {
    var IS_FORCED = type & $166567f03e3e0b37$var$$export.F;
    var IS_GLOBAL = type & $166567f03e3e0b37$var$$export.G;
    var IS_STATIC = type & $166567f03e3e0b37$var$$export.S;
    var IS_PROTO = type & $166567f03e3e0b37$var$$export.P;
    var IS_BIND = type & $166567f03e3e0b37$var$$export.B;
    var IS_WRAP = type & $166567f03e3e0b37$var$$export.W;
    var exports = IS_GLOBAL ? $h9BqL : $h9BqL[name] || ($h9BqL[name] = {});
    var expProto = exports[$166567f03e3e0b37$var$PROTOTYPE];
    var target = IS_GLOBAL ? $ea50F : IS_STATIC ? $ea50F[name] : ($ea50F[name] || {})[$166567f03e3e0b37$var$PROTOTYPE];
    var key, own, out;
    if (IS_GLOBAL) source = name;
    for(key in source){
        // contains in native
        own = !IS_FORCED && target && target[key] !== undefined;
        if (own && $2k1EH(exports, key)) continue;
        // export native or passed
        out = own ? target[key] : source[key];
        // prevent global pollution for namespaces
        exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key] : IS_BIND && own ? $hFYx0(out, $ea50F) : IS_WRAP && target[key] == out ? function(C) {
            var F = function(a, b, c) {
                if (this instanceof C) {
                    switch(arguments.length){
                        case 0:
                            return new C();
                        case 1:
                            return new C(a);
                        case 2:
                            return new C(a, b);
                    }
                    return new C(a, b, c);
                }
                return C.apply(this, arguments);
            };
            F[$166567f03e3e0b37$var$PROTOTYPE] = C[$166567f03e3e0b37$var$PROTOTYPE];
            return F;
        // make static versions for prototype methods
        }(out) : IS_PROTO && typeof out == 'function' ? $hFYx0(Function.call, out) : out;
        // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
        if (IS_PROTO) {
            (exports.virtual || (exports.virtual = {}))[key] = out;
            // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
            if (type & $166567f03e3e0b37$var$$export.R && expProto && !expProto[key]) $2fICR(expProto, key, out);
        }
    }
};
// type bitmap
$166567f03e3e0b37$var$$export.F = 1; // forced
$166567f03e3e0b37$var$$export.G = 2; // global
$166567f03e3e0b37$var$$export.S = 4; // static
$166567f03e3e0b37$var$$export.P = 8; // proto
$166567f03e3e0b37$var$$export.B = 16; // bind
$166567f03e3e0b37$var$$export.W = 32; // wrap
$166567f03e3e0b37$var$$export.U = 64; // safe
$166567f03e3e0b37$var$$export.R = 128; // real proto method for `library`
module.exports = $166567f03e3e0b37$var$$export;

});
parcelRegister("hFYx0", function(module, exports) {
// optional / simple context binding

var $ixKF3 = parcelRequire("ixKF3");
module.exports = function(fn, that, length) {
    $ixKF3(fn);
    if (that === undefined) return fn;
    switch(length){
        case 1:
            return function(a) {
                return fn.call(that, a);
            };
        case 2:
            return function(a, b) {
                return fn.call(that, a, b);
            };
        case 3:
            return function(a, b, c) {
                return fn.call(that, a, b, c);
            };
    }
    return function() {
        return fn.apply(that, arguments);
    };
};

});
parcelRegister("ixKF3", function(module, exports) {
module.exports = function(it) {
    if (typeof it != 'function') throw TypeError(it + ' is not a function!');
    return it;
};

});


parcelRegister("2fICR", function(module, exports) {

var $6SgFA = parcelRequire("6SgFA");

var $65sdk = parcelRequire("65sdk");

module.exports = (parcelRequire("2ZZjJ")) ? function(object, key, value) {
    return $6SgFA.f(object, key, $65sdk(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};

});
parcelRegister("6SgFA", function(module, exports) {

$parcel$export(module.exports, "f", () => $5014b779d90da306$export$2d1720544b23b823, (v) => $5014b779d90da306$export$2d1720544b23b823 = v);
var $5014b779d90da306$export$2d1720544b23b823;

var $gH7sg = parcelRequire("gH7sg");

var $d5nHr = parcelRequire("d5nHr");

var $cBMOE = parcelRequire("cBMOE");
var $5014b779d90da306$var$dP = Object.defineProperty;

$5014b779d90da306$export$2d1720544b23b823 = (parcelRequire("2ZZjJ")) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
    $gH7sg(O);
    P = $cBMOE(P, true);
    $gH7sg(Attributes);
    if ($d5nHr) try {
        return $5014b779d90da306$var$dP(O, P, Attributes);
    } catch (e) {}
    if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
};

});
parcelRegister("gH7sg", function(module, exports) {

var $4Us5Z = parcelRequire("4Us5Z");
module.exports = function(it) {
    if (!$4Us5Z(it)) throw TypeError(it + ' is not an object!');
    return it;
};

});
parcelRegister("4Us5Z", function(module, exports) {
module.exports = function(it) {
    return typeof it === 'object' ? it !== null : typeof it === 'function';
};

});


parcelRegister("d5nHr", function(module, exports) {



module.exports = !(parcelRequire("2ZZjJ")) && !(parcelRequire("60hL6"))(function() {
    return Object.defineProperty((parcelRequire("1uU7O"))('div'), 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRegister("2ZZjJ", function(module, exports) {
// Thank's IE8 for his funny defineProperty

module.exports = !(parcelRequire("60hL6"))(function() {
    return Object.defineProperty({}, 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRegister("60hL6", function(module, exports) {
module.exports = function(exec) {
    try {
        return !!exec();
    } catch (e) {
        return true;
    }
};

});


parcelRegister("1uU7O", function(module, exports) {

var $4Us5Z = parcelRequire("4Us5Z");

var $ea50F = parcelRequire("ea50F");
var $117421055f7b9992$require$document = $ea50F.document;
// typeof document.createElement is 'object' in old IE
var $117421055f7b9992$var$is = $4Us5Z($117421055f7b9992$require$document) && $4Us5Z($117421055f7b9992$require$document.createElement);
module.exports = function(it) {
    return $117421055f7b9992$var$is ? $117421055f7b9992$require$document.createElement(it) : {};
};

});


parcelRegister("cBMOE", function(module, exports) {
// 7.1.1 ToPrimitive(input [, PreferredType])

var $4Us5Z = parcelRequire("4Us5Z");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S) {
    if (!$4Us5Z(it)) return it;
    var fn, val;
    if (S && typeof (fn = it.toString) == 'function' && !$4Us5Z(val = fn.call(it))) return val;
    if (typeof (fn = it.valueOf) == 'function' && !$4Us5Z(val = fn.call(it))) return val;
    if (!S && typeof (fn = it.toString) == 'function' && !$4Us5Z(val = fn.call(it))) return val;
    throw TypeError("Can't convert object to primitive value");
};

});


parcelRegister("65sdk", function(module, exports) {
module.exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};

});







parcelRegister("jK0mf", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $e5f2973ee8973115$export$1e511d4a378977f5, (v) => $e5f2973ee8973115$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $e5f2973ee8973115$export$2e2bcd8739ae039, (v) => $e5f2973ee8973115$export$2e2bcd8739ae039 = v);
var $e5f2973ee8973115$export$1e511d4a378977f5;
var $e5f2973ee8973115$export$2e2bcd8739ae039;
"use strict";
$e5f2973ee8973115$export$1e511d4a378977f5 = true;
$e5f2973ee8973115$export$2e2bcd8739ae039 = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};

});

parcelRegister("7kKnu", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $556e6054c02a9e52$export$1e511d4a378977f5, (v) => $556e6054c02a9e52$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $556e6054c02a9e52$export$2e2bcd8739ae039, (v) => $556e6054c02a9e52$export$2e2bcd8739ae039 = v);
var $556e6054c02a9e52$export$1e511d4a378977f5;
var $556e6054c02a9e52$export$2e2bcd8739ae039;
"use strict";
$556e6054c02a9e52$export$1e511d4a378977f5 = true;

var $dYGWP = parcelRequire("dYGWP");
var $556e6054c02a9e52$var$_defineProperty2 = $556e6054c02a9e52$var$_interopRequireDefault($dYGWP);
function $556e6054c02a9e52$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$556e6054c02a9e52$export$2e2bcd8739ae039 = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            (0, $556e6054c02a9e52$var$_defineProperty2.default)(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

});
parcelRegister("dYGWP", function(module, exports) {

module.exports = {
    "default": (parcelRequire("8S65L")),
    __esModule: true
};

});
parcelRegister("8S65L", function(module, exports) {
parcelRequire("gXidU");

var $h9BqL = parcelRequire("h9BqL");
var $6758179be15c23ed$require$$Object = $h9BqL.Object;
module.exports = function defineProperty(it, key, desc) {
    return $6758179be15c23ed$require$$Object.defineProperty(it, key, desc);
};

});
parcelRegister("gXidU", function(module, exports) {

var $1VdgD = parcelRequire("1VdgD");


// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$1VdgD($1VdgD.S + $1VdgD.F * !(parcelRequire("2ZZjJ")), 'Object', {
    defineProperty: (parcelRequire("6SgFA")).f
});

});




parcelRegister("dopow", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $9c013719b8ab6b7a$export$1e511d4a378977f5, (v) => $9c013719b8ab6b7a$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $9c013719b8ab6b7a$export$2e2bcd8739ae039, (v) => $9c013719b8ab6b7a$export$2e2bcd8739ae039 = v);
var $9c013719b8ab6b7a$export$1e511d4a378977f5;
var $9c013719b8ab6b7a$export$2e2bcd8739ae039;
"use strict";
$9c013719b8ab6b7a$export$1e511d4a378977f5 = true;

var $f3S2g = parcelRequire("f3S2g");
var $9c013719b8ab6b7a$var$_typeof3 = $9c013719b8ab6b7a$var$_interopRequireDefault($f3S2g);
function $9c013719b8ab6b7a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$9c013719b8ab6b7a$export$2e2bcd8739ae039 = function(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && ((typeof call === "undefined" ? "undefined" : (0, $9c013719b8ab6b7a$var$_typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

});
parcelRegister("f3S2g", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $af710d29b99786ea$export$1e511d4a378977f5, (v) => $af710d29b99786ea$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $af710d29b99786ea$export$2e2bcd8739ae039, (v) => $af710d29b99786ea$export$2e2bcd8739ae039 = v);
var $af710d29b99786ea$export$1e511d4a378977f5;
var $af710d29b99786ea$export$2e2bcd8739ae039;
"use strict";
$af710d29b99786ea$export$1e511d4a378977f5 = true;

var $1wM3S = parcelRequire("1wM3S");
var $af710d29b99786ea$var$_iterator2 = $af710d29b99786ea$var$_interopRequireDefault($1wM3S);

var $8GP5W = parcelRequire("8GP5W");
var $af710d29b99786ea$var$_symbol2 = $af710d29b99786ea$var$_interopRequireDefault($8GP5W);
var $af710d29b99786ea$var$_typeof = typeof $af710d29b99786ea$var$_symbol2.default === "function" && typeof $af710d29b99786ea$var$_iterator2.default === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof $af710d29b99786ea$var$_symbol2.default === "function" && obj.constructor === $af710d29b99786ea$var$_symbol2.default && obj !== $af710d29b99786ea$var$_symbol2.default.prototype ? "symbol" : typeof obj;
};
function $af710d29b99786ea$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$af710d29b99786ea$export$2e2bcd8739ae039 = typeof $af710d29b99786ea$var$_symbol2.default === "function" && $af710d29b99786ea$var$_typeof($af710d29b99786ea$var$_iterator2.default) === "symbol" ? function(obj) {
    return typeof obj === "undefined" ? "undefined" : $af710d29b99786ea$var$_typeof(obj);
} : function(obj) {
    return obj && typeof $af710d29b99786ea$var$_symbol2.default === "function" && obj.constructor === $af710d29b99786ea$var$_symbol2.default && obj !== $af710d29b99786ea$var$_symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : $af710d29b99786ea$var$_typeof(obj);
};

});
parcelRegister("1wM3S", function(module, exports) {

module.exports = {
    "default": (parcelRequire("3QuHU")),
    __esModule: true
};

});
parcelRegister("3QuHU", function(module, exports) {
parcelRequire("b94Z9");
parcelRequire("1v3Fn");

module.exports = (parcelRequire("bdk15")).f('iterator');

});
parcelRegister("b94Z9", function(module, exports) {
'use strict';

var $81d466f73211b776$var$$at = (parcelRequire("jQqZW"))(true);

// 21.1.3.27 String.prototype[@@iterator]()
(parcelRequire("f4Hks"))(String, 'String', function(iterated) {
    this._t = String(iterated); // target
    this._i = 0; // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function() {
    var O = this._t;
    var index = this._i;
    var point;
    if (index >= O.length) return {
        value: undefined,
        done: true
    };
    point = $81d466f73211b776$var$$at(O, index);
    this._i += point.length;
    return {
        value: point,
        done: false
    };
});

});
parcelRegister("jQqZW", function(module, exports) {

var $ltpLS = parcelRequire("ltpLS");

var $iojCL = parcelRequire("iojCL");
// true  -> String#at
// false -> String#codePointAt
module.exports = function(TO_STRING) {
    return function(that, pos) {
        var s = String($iojCL(that));
        var i = $ltpLS(pos);
        var l = s.length;
        var a, b;
        if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
        a = s.charCodeAt(i);
        return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
    };
};

});
parcelRegister("ltpLS", function(module, exports) {
// 7.1.4 ToInteger
var $fa204c08ab638536$var$ceil = Math.ceil;
var $fa204c08ab638536$var$floor = Math.floor;
module.exports = function(it) {
    return isNaN(it = +it) ? 0 : (it > 0 ? $fa204c08ab638536$var$floor : $fa204c08ab638536$var$ceil)(it);
};

});


parcelRegister("f4Hks", function(module, exports) {
'use strict';

var $336Nq = parcelRequire("336Nq");

var $1VdgD = parcelRequire("1VdgD");

var $iNFG6 = parcelRequire("iNFG6");

var $2fICR = parcelRequire("2fICR");

var $jAn1n = parcelRequire("jAn1n");

var $aaTjp = parcelRequire("aaTjp");

var $3BGsZ = parcelRequire("3BGsZ");

var $fuXB7 = parcelRequire("fuXB7");

var $af98d6f99f059c0e$var$ITERATOR = (parcelRequire("jsTob"))('iterator');
var $af98d6f99f059c0e$var$BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var $af98d6f99f059c0e$var$FF_ITERATOR = '@@iterator';
var $af98d6f99f059c0e$var$KEYS = 'keys';
var $af98d6f99f059c0e$var$VALUES = 'values';
var $af98d6f99f059c0e$var$returnThis = function() {
    return this;
};
module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
    $aaTjp(Constructor, NAME, next);
    var getMethod = function(kind) {
        if (!$af98d6f99f059c0e$var$BUGGY && kind in proto) return proto[kind];
        switch(kind){
            case $af98d6f99f059c0e$var$KEYS:
                return function keys() {
                    return new Constructor(this, kind);
                };
            case $af98d6f99f059c0e$var$VALUES:
                return function values() {
                    return new Constructor(this, kind);
                };
        }
        return function entries() {
            return new Constructor(this, kind);
        };
    };
    var TAG = NAME + ' Iterator';
    var DEF_VALUES = DEFAULT == $af98d6f99f059c0e$var$VALUES;
    var VALUES_BUG = false;
    var proto = Base.prototype;
    var $native = proto[$af98d6f99f059c0e$var$ITERATOR] || proto[$af98d6f99f059c0e$var$FF_ITERATOR] || DEFAULT && proto[DEFAULT];
    var $default = $native || getMethod(DEFAULT);
    var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
    var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
    var methods, key, IteratorPrototype;
    // Fix native
    if ($anyNative) {
        IteratorPrototype = $fuXB7($anyNative.call(new Base()));
        if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
            // Set @@toStringTag to native iterators
            $3BGsZ(IteratorPrototype, TAG, true);
            // fix for some old engines
            if (!$336Nq && typeof IteratorPrototype[$af98d6f99f059c0e$var$ITERATOR] != 'function') $2fICR(IteratorPrototype, $af98d6f99f059c0e$var$ITERATOR, $af98d6f99f059c0e$var$returnThis);
        }
    }
    // fix Array#{values, @@iterator}.name in V8 / FF
    if (DEF_VALUES && $native && $native.name !== $af98d6f99f059c0e$var$VALUES) {
        VALUES_BUG = true;
        $default = function values() {
            return $native.call(this);
        };
    }
    // Define iterator
    if ((!$336Nq || FORCED) && ($af98d6f99f059c0e$var$BUGGY || VALUES_BUG || !proto[$af98d6f99f059c0e$var$ITERATOR])) $2fICR(proto, $af98d6f99f059c0e$var$ITERATOR, $default);
    // Plug for library
    $jAn1n[NAME] = $default;
    $jAn1n[TAG] = $af98d6f99f059c0e$var$returnThis;
    if (DEFAULT) {
        methods = {
            values: DEF_VALUES ? $default : getMethod($af98d6f99f059c0e$var$VALUES),
            keys: IS_SET ? $default : getMethod($af98d6f99f059c0e$var$KEYS),
            entries: $entries
        };
        if (FORCED) {
            for(key in methods)if (!(key in proto)) $iNFG6(proto, key, methods[key]);
        } else $1VdgD($1VdgD.P + $1VdgD.F * ($af98d6f99f059c0e$var$BUGGY || VALUES_BUG), NAME, methods);
    }
    return methods;
};

});
parcelRegister("iNFG6", function(module, exports) {

module.exports = (parcelRequire("2fICR"));

});

parcelRegister("jAn1n", function(module, exports) {
module.exports = {};

});

parcelRegister("aaTjp", function(module, exports) {
'use strict';

var $eP7J8 = parcelRequire("eP7J8");

var $65sdk = parcelRequire("65sdk");

var $3BGsZ = parcelRequire("3BGsZ");
var $7685be5d46dbd3a6$var$IteratorPrototype = {};


// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
(parcelRequire("2fICR"))($7685be5d46dbd3a6$var$IteratorPrototype, (parcelRequire("jsTob"))('iterator'), function() {
    return this;
});
module.exports = function(Constructor, NAME, next) {
    Constructor.prototype = $eP7J8($7685be5d46dbd3a6$var$IteratorPrototype, {
        next: $65sdk(1, next)
    });
    $3BGsZ(Constructor, NAME + ' Iterator');
};

});
parcelRegister("eP7J8", function(module, exports) {
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])

var $gH7sg = parcelRequire("gH7sg");

var $iyYcd = parcelRequire("iyYcd");

var $clOgA = parcelRequire("clOgA");

var $acabd284dd3abc94$var$IE_PROTO = (parcelRequire("dqUYm"))('IE_PROTO');
var $acabd284dd3abc94$var$Empty = function() {};
var $acabd284dd3abc94$var$PROTOTYPE = 'prototype';


// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $acabd284dd3abc94$var$createDict = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = (parcelRequire("1uU7O"))('iframe');
    var i = $clOgA.length;
    var lt = '<';
    var gt = '>';
    var iframeDocument;
    iframe.style.display = 'none';
    (parcelRequire("bsGy8")).appendChild(iframe);
    iframe.src = 'javascript:'; // eslint-disable-line no-script-url
    // createDict = iframe.contentWindow.Object;
    // html.removeChild(iframe);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
    iframeDocument.close();
    $acabd284dd3abc94$var$createDict = iframeDocument.F;
    while(i--)delete $acabd284dd3abc94$var$createDict[$acabd284dd3abc94$var$PROTOTYPE][$clOgA[i]];
    return $acabd284dd3abc94$var$createDict();
};
module.exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $acabd284dd3abc94$var$Empty[$acabd284dd3abc94$var$PROTOTYPE] = $gH7sg(O);
        result = new $acabd284dd3abc94$var$Empty();
        $acabd284dd3abc94$var$Empty[$acabd284dd3abc94$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$acabd284dd3abc94$var$IE_PROTO] = O;
    } else result = $acabd284dd3abc94$var$createDict();
    return Properties === undefined ? result : $iyYcd(result, Properties);
};

});
parcelRegister("iyYcd", function(module, exports) {

var $6SgFA = parcelRequire("6SgFA");

var $gH7sg = parcelRequire("gH7sg");

var $f49xG = parcelRequire("f49xG");

module.exports = (parcelRequire("2ZZjJ")) ? Object.defineProperties : function defineProperties(O, Properties) {
    $gH7sg(O);
    var keys = $f49xG(Properties);
    var length = keys.length;
    var i = 0;
    var P;
    while(length > i)$6SgFA.f(O, P = keys[i++], Properties[P]);
    return O;
};

});
parcelRegister("f49xG", function(module, exports) {
// 19.1.2.14 / 15.2.3.14 Object.keys(O)

var $56isG = parcelRequire("56isG");

var $clOgA = parcelRequire("clOgA");
module.exports = Object.keys || function keys(O) {
    return $56isG(O, $clOgA);
};

});
parcelRegister("56isG", function(module, exports) {

var $2k1EH = parcelRequire("2k1EH");

var $kOF1h = parcelRequire("kOF1h");

var $3b6bd5665d9e9f5d$var$arrayIndexOf = (parcelRequire("fzEzO"))(false);

var $3b6bd5665d9e9f5d$var$IE_PROTO = (parcelRequire("dqUYm"))('IE_PROTO');
module.exports = function(object, names) {
    var O = $kOF1h(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)if (key != $3b6bd5665d9e9f5d$var$IE_PROTO) $2k1EH(O, key) && result.push(key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($2k1EH(O, key = names[i++])) ~$3b6bd5665d9e9f5d$var$arrayIndexOf(result, key) || result.push(key);
    return result;
};

});
parcelRegister("kOF1h", function(module, exports) {
// to indexed object, toObject with fallback for non-array-like ES3 strings

var $aokPx = parcelRequire("aokPx");

var $iojCL = parcelRequire("iojCL");
module.exports = function(it) {
    return $aokPx($iojCL(it));
};

});
parcelRegister("aokPx", function(module, exports) {
// fallback for non-array-like ES3 and non-enumerable old V8 strings

var $c4I03 = parcelRequire("c4I03");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it) {
    return $c4I03(it) == 'String' ? it.split('') : Object(it);
};

});
parcelRegister("c4I03", function(module, exports) {
var $0244c625fdfa1f38$var$toString = {}.toString;
module.exports = function(it) {
    return $0244c625fdfa1f38$var$toString.call(it).slice(8, -1);
};

});



parcelRegister("fzEzO", function(module, exports) {
// false -> Array#indexOf
// true  -> Array#includes

var $kOF1h = parcelRequire("kOF1h");

var $h9XHT = parcelRequire("h9XHT");

var $cEixM = parcelRequire("cEixM");
module.exports = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $kOF1h($this);
        var length = $h9XHT(O.length);
        var index = $cEixM(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++)if (IS_INCLUDES || index in O) {
            if (O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};

});
parcelRegister("h9XHT", function(module, exports) {
// 7.1.15 ToLength

var $ltpLS = parcelRequire("ltpLS");
var $c7e1977b7e8c28f6$var$min = Math.min;
module.exports = function(it) {
    return it > 0 ? $c7e1977b7e8c28f6$var$min($ltpLS(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

});

parcelRegister("cEixM", function(module, exports) {

var $ltpLS = parcelRequire("ltpLS");
var $93579add973f9bea$var$max = Math.max;
var $93579add973f9bea$var$min = Math.min;
module.exports = function(index, length) {
    index = $ltpLS(index);
    return index < 0 ? $93579add973f9bea$var$max(index + length, 0) : $93579add973f9bea$var$min(index, length);
};

});



parcelRegister("clOgA", function(module, exports) {
// IE 8- don't enum bug keys
module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');

});



parcelRegister("bsGy8", function(module, exports) {

var $ea50F = parcelRequire("ea50F");
var $858350b57c4e0418$require$document = $ea50F.document;
module.exports = $858350b57c4e0418$require$document && $858350b57c4e0418$require$document.documentElement;

});


parcelRegister("3BGsZ", function(module, exports) {

var $6SgFA = parcelRequire("6SgFA");
var $2a05c4c9f64965e8$require$def = $6SgFA.f;

var $2k1EH = parcelRequire("2k1EH");

var $2a05c4c9f64965e8$var$TAG = (parcelRequire("jsTob"))('toStringTag');
module.exports = function(it, tag, stat) {
    if (it && !$2k1EH(it = stat ? it : it.prototype, $2a05c4c9f64965e8$var$TAG)) $2a05c4c9f64965e8$require$def(it, $2a05c4c9f64965e8$var$TAG, {
        configurable: true,
        value: tag
    });
};

});
parcelRegister("jsTob", function(module, exports) {

var $e2bb98fb5e1d7510$var$store = (parcelRequire("he9HP"))('wks');

var $d07cI = parcelRequire("d07cI");

var $ea50F = parcelRequire("ea50F");
var $e2bb98fb5e1d7510$require$Symbol = $ea50F.Symbol;
var $e2bb98fb5e1d7510$var$USE_SYMBOL = typeof $e2bb98fb5e1d7510$require$Symbol == 'function';
var $e2bb98fb5e1d7510$var$$exports = module.exports = function(name) {
    return $e2bb98fb5e1d7510$var$store[name] || ($e2bb98fb5e1d7510$var$store[name] = $e2bb98fb5e1d7510$var$USE_SYMBOL && $e2bb98fb5e1d7510$require$Symbol[name] || ($e2bb98fb5e1d7510$var$USE_SYMBOL ? $e2bb98fb5e1d7510$require$Symbol : $d07cI)('Symbol.' + name));
};
$e2bb98fb5e1d7510$var$$exports.store = $e2bb98fb5e1d7510$var$store;

});





parcelRegister("1v3Fn", function(module, exports) {
parcelRequire("fAKcX");

var $ea50F = parcelRequire("ea50F");

var $2fICR = parcelRequire("2fICR");

var $jAn1n = parcelRequire("jAn1n");

var $117b87c540a40693$var$TO_STRING_TAG = (parcelRequire("jsTob"))('toStringTag');
var $117b87c540a40693$var$DOMIterables = "CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(',');
for(var $117b87c540a40693$var$i = 0; $117b87c540a40693$var$i < $117b87c540a40693$var$DOMIterables.length; $117b87c540a40693$var$i++){
    var $117b87c540a40693$var$NAME = $117b87c540a40693$var$DOMIterables[$117b87c540a40693$var$i];
    var $117b87c540a40693$var$Collection = $ea50F[$117b87c540a40693$var$NAME];
    var $117b87c540a40693$var$proto = $117b87c540a40693$var$Collection && $117b87c540a40693$var$Collection.prototype;
    if ($117b87c540a40693$var$proto && !$117b87c540a40693$var$proto[$117b87c540a40693$var$TO_STRING_TAG]) $2fICR($117b87c540a40693$var$proto, $117b87c540a40693$var$TO_STRING_TAG, $117b87c540a40693$var$NAME);
    $jAn1n[$117b87c540a40693$var$NAME] = $jAn1n.Array;
}

});
parcelRegister("fAKcX", function(module, exports) {
'use strict';

var $6trQN = parcelRequire("6trQN");

var $38wsA = parcelRequire("38wsA");

var $jAn1n = parcelRequire("jAn1n");

var $kOF1h = parcelRequire("kOF1h");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = (parcelRequire("f4Hks"))(Array, 'Array', function(iterated, kind) {
    this._t = $kOF1h(iterated); // target
    this._i = 0; // next index
    this._k = kind; // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function() {
    var O = this._t;
    var kind = this._k;
    var index = this._i++;
    if (!O || index >= O.length) {
        this._t = undefined;
        return $38wsA(1);
    }
    if (kind == 'keys') return $38wsA(0, index);
    if (kind == 'values') return $38wsA(0, O[index]);
    return $38wsA(0, [
        index,
        O[index]
    ]);
}, 'values');
// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
$jAn1n.Arguments = $jAn1n.Array;
$6trQN('keys');
$6trQN('values');
$6trQN('entries');

});
parcelRegister("6trQN", function(module, exports) {
module.exports = function() {};

});

parcelRegister("38wsA", function(module, exports) {
module.exports = function(done, value) {
    return {
        value: value,
        done: !!done
    };
};

});



parcelRegister("bdk15", function(module, exports) {

$parcel$export(module.exports, "f", () => $82a06f76b6697323$export$2d1720544b23b823, (v) => $82a06f76b6697323$export$2d1720544b23b823 = v);
var $82a06f76b6697323$export$2d1720544b23b823;

$82a06f76b6697323$export$2d1720544b23b823 = (parcelRequire("jsTob"));

});



parcelRegister("8GP5W", function(module, exports) {

module.exports = {
    "default": (parcelRequire("lvq29")),
    __esModule: true
};

});
parcelRegister("lvq29", function(module, exports) {
parcelRequire("bCjQA");
parcelRequire("aNa7C");
parcelRequire("ct4oh");
parcelRequire("kKlzg");

module.exports = (parcelRequire("h9BqL")).Symbol;

});
parcelRegister("bCjQA", function(module, exports) {
'use strict';

var $ea50F = parcelRequire("ea50F");

var $2k1EH = parcelRequire("2k1EH");

var $2ZZjJ = parcelRequire("2ZZjJ");

var $1VdgD = parcelRequire("1VdgD");

var $iNFG6 = parcelRequire("iNFG6");

var $QLuwN = parcelRequire("QLuwN");
var $8752a391aba63985$require$META = $QLuwN.KEY;

var $60hL6 = parcelRequire("60hL6");

var $he9HP = parcelRequire("he9HP");

var $3BGsZ = parcelRequire("3BGsZ");

var $d07cI = parcelRequire("d07cI");

var $jsTob = parcelRequire("jsTob");

var $bdk15 = parcelRequire("bdk15");

var $e2jN7 = parcelRequire("e2jN7");

var $9QjLo = parcelRequire("9QjLo");

var $kUUlR = parcelRequire("kUUlR");

var $gH7sg = parcelRequire("gH7sg");

var $4Us5Z = parcelRequire("4Us5Z");

var $9IOcn = parcelRequire("9IOcn");

var $kOF1h = parcelRequire("kOF1h");

var $cBMOE = parcelRequire("cBMOE");

var $65sdk = parcelRequire("65sdk");

var $eP7J8 = parcelRequire("eP7J8");

var $eR1K6 = parcelRequire("eR1K6");

var $2YAEc = parcelRequire("2YAEc");

var $29Vta = parcelRequire("29Vta");

var $6SgFA = parcelRequire("6SgFA");

var $f49xG = parcelRequire("f49xG");
var $8752a391aba63985$var$gOPD = $2YAEc.f;
var $8752a391aba63985$var$dP = $6SgFA.f;
var $8752a391aba63985$var$gOPN = $eR1K6.f;
var $8752a391aba63985$var$$Symbol = $ea50F.Symbol;
var $8752a391aba63985$var$$JSON = $ea50F.JSON;
var $8752a391aba63985$var$_stringify = $8752a391aba63985$var$$JSON && $8752a391aba63985$var$$JSON.stringify;
var $8752a391aba63985$var$PROTOTYPE = 'prototype';
var $8752a391aba63985$var$HIDDEN = $jsTob('_hidden');
var $8752a391aba63985$var$TO_PRIMITIVE = $jsTob('toPrimitive');
var $8752a391aba63985$var$isEnum = {}.propertyIsEnumerable;
var $8752a391aba63985$var$SymbolRegistry = $he9HP('symbol-registry');
var $8752a391aba63985$var$AllSymbols = $he9HP('symbols');
var $8752a391aba63985$var$OPSymbols = $he9HP('op-symbols');
var $8752a391aba63985$var$ObjectProto = Object[$8752a391aba63985$var$PROTOTYPE];
var $8752a391aba63985$var$USE_NATIVE = typeof $8752a391aba63985$var$$Symbol == 'function' && !!$29Vta.f;
var $8752a391aba63985$var$QObject = $ea50F.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var $8752a391aba63985$var$setter = !$8752a391aba63985$var$QObject || !$8752a391aba63985$var$QObject[$8752a391aba63985$var$PROTOTYPE] || !$8752a391aba63985$var$QObject[$8752a391aba63985$var$PROTOTYPE].findChild;
// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var $8752a391aba63985$var$setSymbolDesc = $2ZZjJ && $60hL6(function() {
    return $eP7J8($8752a391aba63985$var$dP({}, 'a', {
        get: function() {
            return $8752a391aba63985$var$dP(this, 'a', {
                value: 7
            }).a;
        }
    })).a != 7;
}) ? function(it, key, D) {
    var protoDesc = $8752a391aba63985$var$gOPD($8752a391aba63985$var$ObjectProto, key);
    if (protoDesc) delete $8752a391aba63985$var$ObjectProto[key];
    $8752a391aba63985$var$dP(it, key, D);
    if (protoDesc && it !== $8752a391aba63985$var$ObjectProto) $8752a391aba63985$var$dP($8752a391aba63985$var$ObjectProto, key, protoDesc);
} : $8752a391aba63985$var$dP;
var $8752a391aba63985$var$wrap = function(tag) {
    var sym = $8752a391aba63985$var$AllSymbols[tag] = $eP7J8($8752a391aba63985$var$$Symbol[$8752a391aba63985$var$PROTOTYPE]);
    sym._k = tag;
    return sym;
};
var $8752a391aba63985$var$isSymbol = $8752a391aba63985$var$USE_NATIVE && typeof $8752a391aba63985$var$$Symbol.iterator == 'symbol' ? function(it) {
    return typeof it == 'symbol';
} : function(it) {
    return it instanceof $8752a391aba63985$var$$Symbol;
};
var $8752a391aba63985$var$$defineProperty = function defineProperty(it, key, D) {
    if (it === $8752a391aba63985$var$ObjectProto) $8752a391aba63985$var$$defineProperty($8752a391aba63985$var$OPSymbols, key, D);
    $gH7sg(it);
    key = $cBMOE(key, true);
    $gH7sg(D);
    if ($2k1EH($8752a391aba63985$var$AllSymbols, key)) {
        if (!D.enumerable) {
            if (!$2k1EH(it, $8752a391aba63985$var$HIDDEN)) $8752a391aba63985$var$dP(it, $8752a391aba63985$var$HIDDEN, $65sdk(1, {}));
            it[$8752a391aba63985$var$HIDDEN][key] = true;
        } else {
            if ($2k1EH(it, $8752a391aba63985$var$HIDDEN) && it[$8752a391aba63985$var$HIDDEN][key]) it[$8752a391aba63985$var$HIDDEN][key] = false;
            D = $eP7J8(D, {
                enumerable: $65sdk(0, false)
            });
        }
        return $8752a391aba63985$var$setSymbolDesc(it, key, D);
    }
    return $8752a391aba63985$var$dP(it, key, D);
};
var $8752a391aba63985$var$$defineProperties = function defineProperties(it, P) {
    $gH7sg(it);
    var keys = $9QjLo(P = $kOF1h(P));
    var i = 0;
    var l = keys.length;
    var key;
    while(l > i)$8752a391aba63985$var$$defineProperty(it, key = keys[i++], P[key]);
    return it;
};
var $8752a391aba63985$var$$create = function create(it, P) {
    return P === undefined ? $eP7J8(it) : $8752a391aba63985$var$$defineProperties($eP7J8(it), P);
};
var $8752a391aba63985$var$$propertyIsEnumerable = function propertyIsEnumerable(key) {
    var E = $8752a391aba63985$var$isEnum.call(this, key = $cBMOE(key, true));
    if (this === $8752a391aba63985$var$ObjectProto && $2k1EH($8752a391aba63985$var$AllSymbols, key) && !$2k1EH($8752a391aba63985$var$OPSymbols, key)) return false;
    return E || !$2k1EH(this, key) || !$2k1EH($8752a391aba63985$var$AllSymbols, key) || $2k1EH(this, $8752a391aba63985$var$HIDDEN) && this[$8752a391aba63985$var$HIDDEN][key] ? E : true;
};
var $8752a391aba63985$var$$getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
    it = $kOF1h(it);
    key = $cBMOE(key, true);
    if (it === $8752a391aba63985$var$ObjectProto && $2k1EH($8752a391aba63985$var$AllSymbols, key) && !$2k1EH($8752a391aba63985$var$OPSymbols, key)) return;
    var D = $8752a391aba63985$var$gOPD(it, key);
    if (D && $2k1EH($8752a391aba63985$var$AllSymbols, key) && !($2k1EH(it, $8752a391aba63985$var$HIDDEN) && it[$8752a391aba63985$var$HIDDEN][key])) D.enumerable = true;
    return D;
};
var $8752a391aba63985$var$$getOwnPropertyNames = function getOwnPropertyNames(it) {
    var names = $8752a391aba63985$var$gOPN($kOF1h(it));
    var result = [];
    var i = 0;
    var key;
    while(names.length > i)if (!$2k1EH($8752a391aba63985$var$AllSymbols, key = names[i++]) && key != $8752a391aba63985$var$HIDDEN && key != $8752a391aba63985$require$META) result.push(key);
    return result;
};
var $8752a391aba63985$var$$getOwnPropertySymbols = function getOwnPropertySymbols(it) {
    var IS_OP = it === $8752a391aba63985$var$ObjectProto;
    var names = $8752a391aba63985$var$gOPN(IS_OP ? $8752a391aba63985$var$OPSymbols : $kOF1h(it));
    var result = [];
    var i = 0;
    var key;
    while(names.length > i)if ($2k1EH($8752a391aba63985$var$AllSymbols, key = names[i++]) && (IS_OP ? $2k1EH($8752a391aba63985$var$ObjectProto, key) : true)) result.push($8752a391aba63985$var$AllSymbols[key]);
    return result;
};



// 19.4.1.1 Symbol([description])
if (!$8752a391aba63985$var$USE_NATIVE) {
    $8752a391aba63985$var$$Symbol = function Symbol() {
        if (this instanceof $8752a391aba63985$var$$Symbol) throw TypeError('Symbol is not a constructor!');
        var tag = $d07cI(arguments.length > 0 ? arguments[0] : undefined);
        var $set = function(value) {
            if (this === $8752a391aba63985$var$ObjectProto) $set.call($8752a391aba63985$var$OPSymbols, value);
            if ($2k1EH(this, $8752a391aba63985$var$HIDDEN) && $2k1EH(this[$8752a391aba63985$var$HIDDEN], tag)) this[$8752a391aba63985$var$HIDDEN][tag] = false;
            $8752a391aba63985$var$setSymbolDesc(this, tag, $65sdk(1, value));
        };
        if ($2ZZjJ && $8752a391aba63985$var$setter) $8752a391aba63985$var$setSymbolDesc($8752a391aba63985$var$ObjectProto, tag, {
            configurable: true,
            set: $set
        });
        return $8752a391aba63985$var$wrap(tag);
    };
    $iNFG6($8752a391aba63985$var$$Symbol[$8752a391aba63985$var$PROTOTYPE], 'toString', function toString() {
        return this._k;
    });
    $2YAEc.f = $8752a391aba63985$var$$getOwnPropertyDescriptor;
    $6SgFA.f = $8752a391aba63985$var$$defineProperty;
    (parcelRequire("7f2RC")).f = $eR1K6.f = $8752a391aba63985$var$$getOwnPropertyNames;
    (parcelRequire("7NEQF")).f = $8752a391aba63985$var$$propertyIsEnumerable;
    $29Vta.f = $8752a391aba63985$var$$getOwnPropertySymbols;
    if ($2ZZjJ && !(parcelRequire("336Nq"))) $iNFG6($8752a391aba63985$var$ObjectProto, 'propertyIsEnumerable', $8752a391aba63985$var$$propertyIsEnumerable, true);
    $bdk15.f = function(name) {
        return $8752a391aba63985$var$wrap($jsTob(name));
    };
}
$1VdgD($1VdgD.G + $1VdgD.W + $1VdgD.F * !$8752a391aba63985$var$USE_NATIVE, {
    Symbol: $8752a391aba63985$var$$Symbol
});
for(var $8752a391aba63985$var$es6Symbols = // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'.split(','), $8752a391aba63985$var$j = 0; $8752a391aba63985$var$es6Symbols.length > $8752a391aba63985$var$j;)$jsTob($8752a391aba63985$var$es6Symbols[$8752a391aba63985$var$j++]);
for(var $8752a391aba63985$var$wellKnownSymbols = $f49xG($jsTob.store), $8752a391aba63985$var$k = 0; $8752a391aba63985$var$wellKnownSymbols.length > $8752a391aba63985$var$k;)$e2jN7($8752a391aba63985$var$wellKnownSymbols[$8752a391aba63985$var$k++]);
$1VdgD($1VdgD.S + $1VdgD.F * !$8752a391aba63985$var$USE_NATIVE, 'Symbol', {
    // 19.4.2.1 Symbol.for(key)
    'for': function(key) {
        return $2k1EH($8752a391aba63985$var$SymbolRegistry, key += '') ? $8752a391aba63985$var$SymbolRegistry[key] : $8752a391aba63985$var$SymbolRegistry[key] = $8752a391aba63985$var$$Symbol(key);
    },
    // 19.4.2.5 Symbol.keyFor(sym)
    keyFor: function keyFor(sym) {
        if (!$8752a391aba63985$var$isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
        for(var key in $8752a391aba63985$var$SymbolRegistry)if ($8752a391aba63985$var$SymbolRegistry[key] === sym) return key;
    },
    useSetter: function() {
        $8752a391aba63985$var$setter = true;
    },
    useSimple: function() {
        $8752a391aba63985$var$setter = false;
    }
});
$1VdgD($1VdgD.S + $1VdgD.F * !$8752a391aba63985$var$USE_NATIVE, 'Object', {
    // 19.1.2.2 Object.create(O [, Properties])
    create: $8752a391aba63985$var$$create,
    // 19.1.2.4 Object.defineProperty(O, P, Attributes)
    defineProperty: $8752a391aba63985$var$$defineProperty,
    // 19.1.2.3 Object.defineProperties(O, Properties)
    defineProperties: $8752a391aba63985$var$$defineProperties,
    // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
    getOwnPropertyDescriptor: $8752a391aba63985$var$$getOwnPropertyDescriptor,
    // 19.1.2.7 Object.getOwnPropertyNames(O)
    getOwnPropertyNames: $8752a391aba63985$var$$getOwnPropertyNames,
    // 19.1.2.8 Object.getOwnPropertySymbols(O)
    getOwnPropertySymbols: $8752a391aba63985$var$$getOwnPropertySymbols
});
// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var $8752a391aba63985$var$FAILS_ON_PRIMITIVES = $60hL6(function() {
    $29Vta.f(1);
});
$1VdgD($1VdgD.S + $1VdgD.F * $8752a391aba63985$var$FAILS_ON_PRIMITIVES, 'Object', {
    getOwnPropertySymbols: function getOwnPropertySymbols(it) {
        return $29Vta.f($9IOcn(it));
    }
});
// 24.3.2 JSON.stringify(value [, replacer [, space]])
$8752a391aba63985$var$$JSON && $1VdgD($1VdgD.S + $1VdgD.F * (!$8752a391aba63985$var$USE_NATIVE || $60hL6(function() {
    var S = $8752a391aba63985$var$$Symbol();
    // MS Edge converts symbol values to JSON as {}
    // WebKit converts symbol values to JSON as null
    // V8 throws on boxed symbols
    return $8752a391aba63985$var$_stringify([
        S
    ]) != '[null]' || $8752a391aba63985$var$_stringify({
        a: S
    }) != '{}' || $8752a391aba63985$var$_stringify(Object(S)) != '{}';
})), 'JSON', {
    stringify: function stringify(it) {
        var args = [
            it
        ];
        var i = 1;
        var replacer, $replacer;
        while(arguments.length > i)args.push(arguments[i++]);
        $replacer = replacer = args[1];
        if (!$4Us5Z(replacer) && it === undefined || $8752a391aba63985$var$isSymbol(it)) return; // IE8 returns string on undefined
        if (!$kUUlR(replacer)) replacer = function(key, value) {
            if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
            if (!$8752a391aba63985$var$isSymbol(value)) return value;
        };
        args[1] = replacer;
        return $8752a391aba63985$var$_stringify.apply($8752a391aba63985$var$$JSON, args);
    }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$8752a391aba63985$var$$Symbol[$8752a391aba63985$var$PROTOTYPE][$8752a391aba63985$var$TO_PRIMITIVE] || (parcelRequire("2fICR"))($8752a391aba63985$var$$Symbol[$8752a391aba63985$var$PROTOTYPE], $8752a391aba63985$var$TO_PRIMITIVE, $8752a391aba63985$var$$Symbol[$8752a391aba63985$var$PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
$3BGsZ($8752a391aba63985$var$$Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
$3BGsZ(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
$3BGsZ($ea50F.JSON, 'JSON', true);

});
parcelRegister("QLuwN", function(module, exports) {

var $09e9b23e5ce26d0f$var$META = (parcelRequire("d07cI"))('meta');

var $4Us5Z = parcelRequire("4Us5Z");

var $2k1EH = parcelRequire("2k1EH");

var $6SgFA = parcelRequire("6SgFA");
var $09e9b23e5ce26d0f$require$setDesc = $6SgFA.f;
var $09e9b23e5ce26d0f$var$id = 0;
var $09e9b23e5ce26d0f$var$isExtensible = Object.isExtensible || function() {
    return true;
};

var $09e9b23e5ce26d0f$var$FREEZE = !(parcelRequire("60hL6"))(function() {
    return $09e9b23e5ce26d0f$var$isExtensible(Object.preventExtensions({}));
});
var $09e9b23e5ce26d0f$var$setMeta = function(it) {
    $09e9b23e5ce26d0f$require$setDesc(it, $09e9b23e5ce26d0f$var$META, {
        value: {
            i: 'O' + ++$09e9b23e5ce26d0f$var$id,
            w: {} // weak collections IDs
        }
    });
};
var $09e9b23e5ce26d0f$var$fastKey = function(it, create) {
    // return primitive with prefix
    if (!$4Us5Z(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
    if (!$2k1EH(it, $09e9b23e5ce26d0f$var$META)) {
        // can't set metadata to uncaught frozen object
        if (!$09e9b23e5ce26d0f$var$isExtensible(it)) return 'F';
        // not necessary to add metadata
        if (!create) return 'E';
        // add missing metadata
        $09e9b23e5ce26d0f$var$setMeta(it);
    // return object ID
    }
    return it[$09e9b23e5ce26d0f$var$META].i;
};
var $09e9b23e5ce26d0f$var$getWeak = function(it, create) {
    if (!$2k1EH(it, $09e9b23e5ce26d0f$var$META)) {
        // can't set metadata to uncaught frozen object
        if (!$09e9b23e5ce26d0f$var$isExtensible(it)) return true;
        // not necessary to add metadata
        if (!create) return false;
        // add missing metadata
        $09e9b23e5ce26d0f$var$setMeta(it);
    // return hash weak collections IDs
    }
    return it[$09e9b23e5ce26d0f$var$META].w;
};
// add metadata on freeze-family methods calling
var $09e9b23e5ce26d0f$var$onFreeze = function(it) {
    if ($09e9b23e5ce26d0f$var$FREEZE && $09e9b23e5ce26d0f$var$meta.NEED && $09e9b23e5ce26d0f$var$isExtensible(it) && !$2k1EH(it, $09e9b23e5ce26d0f$var$META)) $09e9b23e5ce26d0f$var$setMeta(it);
    return it;
};
var $09e9b23e5ce26d0f$var$meta = module.exports = {
    KEY: $09e9b23e5ce26d0f$var$META,
    NEED: false,
    fastKey: $09e9b23e5ce26d0f$var$fastKey,
    getWeak: $09e9b23e5ce26d0f$var$getWeak,
    onFreeze: $09e9b23e5ce26d0f$var$onFreeze
};

});

parcelRegister("e2jN7", function(module, exports) {

var $ea50F = parcelRequire("ea50F");

var $h9BqL = parcelRequire("h9BqL");

var $336Nq = parcelRequire("336Nq");

var $bdk15 = parcelRequire("bdk15");

var $6SgFA = parcelRequire("6SgFA");
var $a3809ab5a1f78be5$require$defineProperty = $6SgFA.f;
module.exports = function(name) {
    var $Symbol = $h9BqL.Symbol || ($h9BqL.Symbol = $336Nq ? {} : $ea50F.Symbol || {});
    if (name.charAt(0) != '_' && !(name in $Symbol)) $a3809ab5a1f78be5$require$defineProperty($Symbol, name, {
        value: $bdk15.f(name)
    });
};

});

parcelRegister("9QjLo", function(module, exports) {
// all enumerable object keys, includes symbols

var $f49xG = parcelRequire("f49xG");

var $29Vta = parcelRequire("29Vta");

var $7NEQF = parcelRequire("7NEQF");
module.exports = function(it) {
    var result = $f49xG(it);
    var getSymbols = $29Vta.f;
    if (getSymbols) {
        var symbols = getSymbols(it);
        var isEnum = $7NEQF.f;
        var i = 0;
        var key;
        while(symbols.length > i)if (isEnum.call(it, key = symbols[i++])) result.push(key);
    }
    return result;
};

});
parcelRegister("29Vta", function(module, exports) {

$parcel$export(module.exports, "f", () => $1929004539fa1d59$export$2d1720544b23b823, (v) => $1929004539fa1d59$export$2d1720544b23b823 = v);
var $1929004539fa1d59$export$2d1720544b23b823;
$1929004539fa1d59$export$2d1720544b23b823 = Object.getOwnPropertySymbols;

});

parcelRegister("7NEQF", function(module, exports) {

$parcel$export(module.exports, "f", () => $5adccbac77835174$export$2d1720544b23b823, (v) => $5adccbac77835174$export$2d1720544b23b823 = v);
var $5adccbac77835174$export$2d1720544b23b823;
$5adccbac77835174$export$2d1720544b23b823 = ({}).propertyIsEnumerable;

});


parcelRegister("kUUlR", function(module, exports) {
// 7.2.2 IsArray(argument)

var $c4I03 = parcelRequire("c4I03");
module.exports = Array.isArray || function isArray(arg) {
    return $c4I03(arg) == 'Array';
};

});

parcelRegister("eR1K6", function(module, exports) {

$parcel$export(module.exports, "f", () => $ad075df79e25c0cc$export$2d1720544b23b823, (v) => $ad075df79e25c0cc$export$2d1720544b23b823 = v);
// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var $ad075df79e25c0cc$export$2d1720544b23b823;

var $kOF1h = parcelRequire("kOF1h");

var $7f2RC = parcelRequire("7f2RC");
var $ad075df79e25c0cc$require$gOPN = $7f2RC.f;
var $ad075df79e25c0cc$var$toString = {}.toString;
var $ad075df79e25c0cc$var$windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
var $ad075df79e25c0cc$var$getWindowNames = function(it) {
    try {
        return $ad075df79e25c0cc$require$gOPN(it);
    } catch (e) {
        return $ad075df79e25c0cc$var$windowNames.slice();
    }
};
$ad075df79e25c0cc$export$2d1720544b23b823 = function getOwnPropertyNames(it) {
    return $ad075df79e25c0cc$var$windowNames && $ad075df79e25c0cc$var$toString.call(it) == '[object Window]' ? $ad075df79e25c0cc$var$getWindowNames(it) : $ad075df79e25c0cc$require$gOPN($kOF1h(it));
};

});
parcelRegister("7f2RC", function(module, exports) {

$parcel$export(module.exports, "f", () => $545c27cb2d1e3586$export$2d1720544b23b823, (v) => $545c27cb2d1e3586$export$2d1720544b23b823 = v);
// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $545c27cb2d1e3586$export$2d1720544b23b823;

var $56isG = parcelRequire("56isG");

var $545c27cb2d1e3586$var$hiddenKeys = (parcelRequire("clOgA")).concat('length', 'prototype');
$545c27cb2d1e3586$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $56isG(O, $545c27cb2d1e3586$var$hiddenKeys);
};

});


parcelRegister("2YAEc", function(module, exports) {

$parcel$export(module.exports, "f", () => $22ad9cc291bf8d00$export$2d1720544b23b823, (v) => $22ad9cc291bf8d00$export$2d1720544b23b823 = v);
var $22ad9cc291bf8d00$export$2d1720544b23b823;

var $7NEQF = parcelRequire("7NEQF");

var $65sdk = parcelRequire("65sdk");

var $kOF1h = parcelRequire("kOF1h");

var $cBMOE = parcelRequire("cBMOE");

var $2k1EH = parcelRequire("2k1EH");

var $d5nHr = parcelRequire("d5nHr");
var $22ad9cc291bf8d00$var$gOPD = Object.getOwnPropertyDescriptor;

$22ad9cc291bf8d00$export$2d1720544b23b823 = (parcelRequire("2ZZjJ")) ? $22ad9cc291bf8d00$var$gOPD : function getOwnPropertyDescriptor(O, P) {
    O = $kOF1h(O);
    P = $cBMOE(P, true);
    if ($d5nHr) try {
        return $22ad9cc291bf8d00$var$gOPD(O, P);
    } catch (e) {}
    if ($2k1EH(O, P)) return $65sdk(!$7NEQF.f.call(O, P), O[P]);
};

});


parcelRegister("aNa7C", function(module, exports) {

});

parcelRegister("ct4oh", function(module, exports) {

(parcelRequire("e2jN7"))('asyncIterator');

});

parcelRegister("kKlzg", function(module, exports) {

(parcelRequire("e2jN7"))('observable');

});





parcelRegister("2G5Ta", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $1f341269e45c3877$export$1e511d4a378977f5, (v) => $1f341269e45c3877$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $1f341269e45c3877$export$2e2bcd8739ae039, (v) => $1f341269e45c3877$export$2e2bcd8739ae039 = v);
var $1f341269e45c3877$export$1e511d4a378977f5;
var $1f341269e45c3877$export$2e2bcd8739ae039;
"use strict";
$1f341269e45c3877$export$1e511d4a378977f5 = true;

var $4tXXW = parcelRequire("4tXXW");
var $1f341269e45c3877$var$_setPrototypeOf2 = $1f341269e45c3877$var$_interopRequireDefault($4tXXW);

var $eaYGn = parcelRequire("eaYGn");
var $1f341269e45c3877$var$_create2 = $1f341269e45c3877$var$_interopRequireDefault($eaYGn);

var $f3S2g = parcelRequire("f3S2g");
var $1f341269e45c3877$var$_typeof3 = $1f341269e45c3877$var$_interopRequireDefault($f3S2g);
function $1f341269e45c3877$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$1f341269e45c3877$export$2e2bcd8739ae039 = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, $1f341269e45c3877$var$_typeof3.default)(superClass)));
    subClass.prototype = (0, $1f341269e45c3877$var$_create2.default)(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $1f341269e45c3877$var$_setPrototypeOf2.default ? (0, $1f341269e45c3877$var$_setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

});
parcelRegister("4tXXW", function(module, exports) {

module.exports = {
    "default": (parcelRequire("hEveR")),
    __esModule: true
};

});
parcelRegister("hEveR", function(module, exports) {
parcelRequire("iNGqd");

module.exports = (parcelRequire("h9BqL")).Object.setPrototypeOf;

});
parcelRegister("iNGqd", function(module, exports) {
// 19.1.3.19 Object.setPrototypeOf(O, proto)

var $1VdgD = parcelRequire("1VdgD");

$1VdgD($1VdgD.S, 'Object', {
    setPrototypeOf: (parcelRequire("6B4nF")).set
});

});
parcelRegister("6B4nF", function(module, exports) {
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */ 
var $4Us5Z = parcelRequire("4Us5Z");

var $gH7sg = parcelRequire("gH7sg");
var $4cd998ad50462ac3$var$check = function(O, proto) {
    $gH7sg(O);
    if (!$4Us5Z(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};


module.exports = {
    set: Object.setPrototypeOf || ('__proto__' in {} ? function(test, buggy, set) {
        try {
            set = (parcelRequire("hFYx0"))(Function.call, (parcelRequire("2YAEc")).f(Object.prototype, '__proto__').set, 2);
            set(test, []);
            buggy = !(test instanceof Array);
        } catch (e) {
            buggy = true;
        }
        return function setPrototypeOf(O, proto) {
            $4cd998ad50462ac3$var$check(O, proto);
            if (buggy) O.__proto__ = proto;
            else set(O, proto);
            return O;
        };
    }({}, false) : undefined),
    check: $4cd998ad50462ac3$var$check
};

});




parcelRegister("eaYGn", function(module, exports) {

module.exports = {
    "default": (parcelRequire("d9SSJ")),
    __esModule: true
};

});
parcelRegister("d9SSJ", function(module, exports) {
parcelRequire("bDxet");

var $h9BqL = parcelRequire("h9BqL");
var $9946affdaea0a35f$require$$Object = $h9BqL.Object;
module.exports = function create(P, D) {
    return $9946affdaea0a35f$require$$Object.create(P, D);
};

});
parcelRegister("bDxet", function(module, exports) {

var $1VdgD = parcelRequire("1VdgD");

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$1VdgD($1VdgD.S, 'Object', {
    create: (parcelRequire("eP7J8"))
});

});




parcelRegister("bZRz7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bpfrpt_proptype_CellMeasureCache = undefined;

var $cT3Ey = parcelRequire("cT3Ey");
var $8bbef1304bce827b$var$_propTypes2 = $8bbef1304bce827b$var$_interopRequireDefault($cT3Ey);
function $8bbef1304bce827b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $8bbef1304bce827b$var$bpfrpt_proptype_CellMeasureCache = null;
module.exports.bpfrpt_proptype_CellMeasureCache = $8bbef1304bce827b$var$bpfrpt_proptype_CellMeasureCache;

});


parcelRegister("lzsUS", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DEFAULT_WIDTH = module.exports.DEFAULT_HEIGHT = undefined;

var $jK0mf = parcelRequire("jK0mf");
var $fb434c0d23e9390a$var$_classCallCheck3 = $fb434c0d23e9390a$var$_interopRequireDefault($jK0mf);

var $7kKnu = parcelRequire("7kKnu");
var $fb434c0d23e9390a$var$_createClass3 = $fb434c0d23e9390a$var$_interopRequireDefault($7kKnu);
parcelRequire("bZRz7");
function $fb434c0d23e9390a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $fb434c0d23e9390a$var$DEFAULT_HEIGHT = module.exports.DEFAULT_HEIGHT = 30;
var $fb434c0d23e9390a$var$DEFAULT_WIDTH = module.exports.DEFAULT_WIDTH = 100;
// Enables more intelligent mapping of a given column and row index to an item ID.
// This prevents a cell cache from being invalidated when its parent collection is modified.
/**
 * Caches measurements for a given cell.
 */ var $fb434c0d23e9390a$var$CellMeasurerCache = function() {
    function CellMeasurerCache() {
        var _this = this;
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, $fb434c0d23e9390a$var$_classCallCheck3.default)(this, CellMeasurerCache);
        this._cellHeightCache = {};
        this._cellWidthCache = {};
        this._columnWidthCache = {};
        this._rowHeightCache = {};
        this._columnCount = 0;
        this._rowCount = 0;
        this.columnWidth = function(_ref) {
            var index = _ref.index;
            var key = _this._keyMapper(0, index);
            return _this._columnWidthCache.hasOwnProperty(key) ? _this._columnWidthCache[key] : _this._defaultWidth;
        };
        this.rowHeight = function(_ref2) {
            var index = _ref2.index;
            var key = _this._keyMapper(index, 0);
            return _this._rowHeightCache.hasOwnProperty(key) ? _this._rowHeightCache[key] : _this._defaultHeight;
        };
        var defaultHeight = params.defaultHeight, defaultWidth = params.defaultWidth, fixedHeight = params.fixedHeight, fixedWidth = params.fixedWidth, keyMapper = params.keyMapper, minHeight = params.minHeight, minWidth = params.minWidth;
        this._hasFixedHeight = fixedHeight === true;
        this._hasFixedWidth = fixedWidth === true;
        this._minHeight = minHeight || 0;
        this._minWidth = minWidth || 0;
        this._keyMapper = keyMapper || $fb434c0d23e9390a$var$defaultKeyMapper;
        this._defaultHeight = Math.max(this._minHeight, typeof defaultHeight === 'number' ? defaultHeight : $fb434c0d23e9390a$var$DEFAULT_HEIGHT);
        this._defaultWidth = Math.max(this._minWidth, typeof defaultWidth === 'number' ? defaultWidth : $fb434c0d23e9390a$var$DEFAULT_WIDTH);
    }
    (0, $fb434c0d23e9390a$var$_createClass3.default)(CellMeasurerCache, [
        {
            key: 'clear',
            value: function clear(rowIndex) {
                var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                var key = this._keyMapper(rowIndex, columnIndex);
                delete this._cellHeightCache[key];
                delete this._cellWidthCache[key];
                this._updateCachedColumnAndRowSizes(rowIndex, columnIndex);
            }
        },
        {
            key: 'clearAll',
            value: function clearAll() {
                this._cellHeightCache = {};
                this._cellWidthCache = {};
                this._columnWidthCache = {};
                this._rowHeightCache = {};
                this._rowCount = 0;
                this._columnCount = 0;
            }
        },
        {
            key: 'hasFixedHeight',
            value: function hasFixedHeight() {
                return this._hasFixedHeight;
            }
        },
        {
            key: 'hasFixedWidth',
            value: function hasFixedWidth() {
                return this._hasFixedWidth;
            }
        },
        {
            key: 'getHeight',
            value: function getHeight(rowIndex) {
                var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                if (this._hasFixedHeight) return this._defaultHeight;
                else {
                    var _key = this._keyMapper(rowIndex, columnIndex);
                    return this._cellHeightCache.hasOwnProperty(_key) ? Math.max(this._minHeight, this._cellHeightCache[_key]) : this._defaultHeight;
                }
            }
        },
        {
            key: 'getWidth',
            value: function getWidth(rowIndex) {
                var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                if (this._hasFixedWidth) return this._defaultWidth;
                else {
                    var _key2 = this._keyMapper(rowIndex, columnIndex);
                    return this._cellWidthCache.hasOwnProperty(_key2) ? Math.max(this._minWidth, this._cellWidthCache[_key2]) : this._defaultWidth;
                }
            }
        },
        {
            key: 'has',
            value: function has(rowIndex) {
                var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                var key = this._keyMapper(rowIndex, columnIndex);
                return this._cellHeightCache.hasOwnProperty(key);
            }
        },
        {
            key: 'set',
            value: function set(rowIndex, columnIndex, width, height) {
                var key = this._keyMapper(rowIndex, columnIndex);
                if (columnIndex >= this._columnCount) this._columnCount = columnIndex + 1;
                if (rowIndex >= this._rowCount) this._rowCount = rowIndex + 1;
                // Size is cached per cell so we don't have to re-measure if cells are re-ordered.
                this._cellHeightCache[key] = height;
                this._cellWidthCache[key] = width;
                this._updateCachedColumnAndRowSizes(rowIndex, columnIndex);
            }
        },
        {
            key: '_updateCachedColumnAndRowSizes',
            value: function _updateCachedColumnAndRowSizes(rowIndex, columnIndex) {
                // :columnWidth and :rowHeight are derived based on all cells in a column/row.
                // Pre-cache these derived values for faster lookup later.
                // Reads are expected to occur more frequently than writes in this case.
                // Only update non-fixed dimensions though to avoid doing unnecessary work.
                if (!this._hasFixedWidth) {
                    var columnWidth = 0;
                    for(var i = 0; i < this._rowCount; i++)columnWidth = Math.max(columnWidth, this.getWidth(i, columnIndex));
                    var columnKey = this._keyMapper(0, columnIndex);
                    this._columnWidthCache[columnKey] = columnWidth;
                }
                if (!this._hasFixedHeight) {
                    var rowHeight = 0;
                    for(var _i = 0; _i < this._columnCount; _i++)rowHeight = Math.max(rowHeight, this.getHeight(rowIndex, _i));
                    var rowKey = this._keyMapper(rowIndex, 0);
                    this._rowHeightCache[rowKey] = rowHeight;
                }
            }
        },
        {
            key: 'defaultHeight',
            get: function get() {
                return this._defaultHeight;
            }
        },
        {
            key: 'defaultWidth',
            get: function get() {
                return this._defaultWidth;
            }
        }
    ]);
    return CellMeasurerCache;
}();
module.exports.default = $fb434c0d23e9390a$var$CellMeasurerCache;
function $fb434c0d23e9390a$var$defaultKeyMapper(rowIndex, columnIndex) {
    return rowIndex + '-' + columnIndex;
}

});


parcelRegister("h5TVk", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bpfrpt_proptype_RowRendererParams = module.exports.List = module.exports.default = undefined;

var $arFM4 = parcelRequire("arFM4");
Object.defineProperty(module.exports, 'default', {
    enumerable: true,
    get: function get() {
        return $c71e488e4a645612$var$_interopRequireDefault($arFM4).default;
    }
});
Object.defineProperty(module.exports, 'List', {
    enumerable: true,
    get: function get() {
        return $c71e488e4a645612$var$_interopRequireDefault($arFM4).default;
    }
});

var $9j0W6 = parcelRequire("9j0W6");
function $c71e488e4a645612$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports.bpfrpt_proptype_RowRendererParams = $9j0W6.bpfrpt_proptype_RowRendererParams;

});
parcelRegister("arFM4", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $izRwq = parcelRequire("izRwq");
var $79acd4832ecb1c85$var$_extends3 = $79acd4832ecb1c85$var$_interopRequireDefault($izRwq);

var $cwG55 = parcelRequire("cwG55");
var $79acd4832ecb1c85$var$_getOwnPropertyDescriptor2 = $79acd4832ecb1c85$var$_interopRequireDefault($cwG55);

var $1nR2i = parcelRequire("1nR2i");
var $79acd4832ecb1c85$var$_getPrototypeOf2 = $79acd4832ecb1c85$var$_interopRequireDefault($1nR2i);

var $jK0mf = parcelRequire("jK0mf");
var $79acd4832ecb1c85$var$_classCallCheck3 = $79acd4832ecb1c85$var$_interopRequireDefault($jK0mf);

var $7kKnu = parcelRequire("7kKnu");
var $79acd4832ecb1c85$var$_createClass3 = $79acd4832ecb1c85$var$_interopRequireDefault($7kKnu);

var $dopow = parcelRequire("dopow");
var $79acd4832ecb1c85$var$_possibleConstructorReturn3 = $79acd4832ecb1c85$var$_interopRequireDefault($dopow);

var $2G5Ta = parcelRequire("2G5Ta");
var $79acd4832ecb1c85$var$_inherits3 = $79acd4832ecb1c85$var$_interopRequireDefault($2G5Ta);

var $kNNa3 = parcelRequire("kNNa3");
var $79acd4832ecb1c85$var$_Grid2 = $79acd4832ecb1c85$var$_interopRequireDefault($kNNa3);

var $eJOHy = parcelRequire("eJOHy");
var $79acd4832ecb1c85$var$React = $79acd4832ecb1c85$var$_interopRequireWildcard($eJOHy);

var $frReV = parcelRequire("frReV");
var $79acd4832ecb1c85$var$_clsx2 = $79acd4832ecb1c85$var$_interopRequireDefault($frReV);
parcelRequire("9j0W6");

var $cT3Ey = parcelRequire("cT3Ey");
var $79acd4832ecb1c85$var$_propTypes2 = $79acd4832ecb1c85$var$_interopRequireDefault($cT3Ey);
function $79acd4832ecb1c85$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $79acd4832ecb1c85$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * It is inefficient to create and manage a large list of DOM elements within a scrolling container
 * if only a few of those elements are visible. The primary purpose of this component is to improve
 * performance by only rendering the DOM nodes that a user is able to see based on their current
 * scroll position.
 *
 * This component renders a virtualized list of elements with either fixed or dynamic heights.
 */ var $79acd4832ecb1c85$var$List = function(_React$PureComponent) {
    (0, $79acd4832ecb1c85$var$_inherits3.default)(List, _React$PureComponent);
    function List() {
        var _ref;
        var _temp, _this, _ret;
        (0, $79acd4832ecb1c85$var$_classCallCheck3.default)(this, List);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = (0, $79acd4832ecb1c85$var$_possibleConstructorReturn3.default)(this, (_ref = List.__proto__ || (0, $79acd4832ecb1c85$var$_getPrototypeOf2.default)(List)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this._cellRenderer = function(_ref2) {
            var parent = _ref2.parent, rowIndex = _ref2.rowIndex, style = _ref2.style, isScrolling = _ref2.isScrolling, isVisible = _ref2.isVisible, key = _ref2.key;
            var rowRenderer = _this.props.rowRenderer;
            // TRICKY The style object is sometimes cached by Grid.
            // This prevents new style objects from bypassing shallowCompare().
            // However as of React 16, style props are auto-frozen (at least in dev mode)
            // Check to make sure we can still modify the style before proceeding.
            // https://github.com/facebook/react/commit/977357765b44af8ff0cfea327866861073095c12#commitcomment-20648713
            var _Object$getOwnPropert = (0, $79acd4832ecb1c85$var$_getOwnPropertyDescriptor2.default)(style, 'width'), writable = _Object$getOwnPropert.writable;
            if (writable) // By default, List cells should be 100% width.
            // This prevents them from flowing under a scrollbar (if present).
            style.width = '100%';
            return rowRenderer({
                index: rowIndex,
                style: style,
                isScrolling: isScrolling,
                isVisible: isVisible,
                key: key,
                parent: parent
            });
        }, _this._setRef = function(ref) {
            _this.Grid = ref;
        }, _this._onScroll = function(_ref3) {
            var clientHeight = _ref3.clientHeight, scrollHeight = _ref3.scrollHeight, scrollTop = _ref3.scrollTop;
            var onScroll = _this.props.onScroll;
            onScroll({
                clientHeight: clientHeight,
                scrollHeight: scrollHeight,
                scrollTop: scrollTop
            });
        }, _this._onSectionRendered = function(_ref4) {
            var rowOverscanStartIndex = _ref4.rowOverscanStartIndex, rowOverscanStopIndex = _ref4.rowOverscanStopIndex, rowStartIndex = _ref4.rowStartIndex, rowStopIndex = _ref4.rowStopIndex;
            var onRowsRendered = _this.props.onRowsRendered;
            onRowsRendered({
                overscanStartIndex: rowOverscanStartIndex,
                overscanStopIndex: rowOverscanStopIndex,
                startIndex: rowStartIndex,
                stopIndex: rowStopIndex
            });
        }, _temp), (0, $79acd4832ecb1c85$var$_possibleConstructorReturn3.default)(_this, _ret);
    }
    (0, $79acd4832ecb1c85$var$_createClass3.default)(List, [
        {
            key: 'forceUpdateGrid',
            value: function forceUpdateGrid() {
                if (this.Grid) this.Grid.forceUpdate();
            }
        },
        {
            key: 'getOffsetForRow',
            value: function getOffsetForRow(_ref5) {
                var alignment = _ref5.alignment, index = _ref5.index;
                if (this.Grid) {
                    var _Grid$getOffsetForCel = this.Grid.getOffsetForCell({
                        alignment: alignment,
                        rowIndex: index,
                        columnIndex: 0
                    }), _scrollTop = _Grid$getOffsetForCel.scrollTop;
                    return _scrollTop;
                }
                return 0;
            }
        },
        {
            key: 'invalidateCellSizeAfterRender',
            value: function invalidateCellSizeAfterRender(_ref6) {
                var columnIndex = _ref6.columnIndex, rowIndex = _ref6.rowIndex;
                if (this.Grid) this.Grid.invalidateCellSizeAfterRender({
                    rowIndex: rowIndex,
                    columnIndex: columnIndex
                });
            }
        },
        {
            key: 'measureAllRows',
            value: function measureAllRows() {
                if (this.Grid) this.Grid.measureAllCells();
            }
        },
        {
            key: 'recomputeGridSize',
            value: function recomputeGridSize() {
                var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref7$columnIndex = _ref7.columnIndex, columnIndex = _ref7$columnIndex === undefined ? 0 : _ref7$columnIndex, _ref7$rowIndex = _ref7.rowIndex, rowIndex = _ref7$rowIndex === undefined ? 0 : _ref7$rowIndex;
                if (this.Grid) this.Grid.recomputeGridSize({
                    rowIndex: rowIndex,
                    columnIndex: columnIndex
                });
            }
        },
        {
            key: 'recomputeRowHeights',
            value: function recomputeRowHeights() {
                var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                if (this.Grid) this.Grid.recomputeGridSize({
                    rowIndex: index,
                    columnIndex: 0
                });
            }
        },
        {
            key: 'scrollToPosition',
            value: function scrollToPosition() {
                var scrollTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                if (this.Grid) this.Grid.scrollToPosition({
                    scrollTop: scrollTop
                });
            }
        },
        {
            key: 'scrollToRow',
            value: function scrollToRow() {
                var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                if (this.Grid) this.Grid.scrollToCell({
                    columnIndex: 0,
                    rowIndex: index
                });
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, className = _props.className, noRowsRenderer = _props.noRowsRenderer, scrollToIndex = _props.scrollToIndex, width = _props.width;
                var classNames = (0, $79acd4832ecb1c85$var$_clsx2.default)('ReactVirtualized__List', className);
                return $79acd4832ecb1c85$var$React.createElement($79acd4832ecb1c85$var$_Grid2.default, (0, $79acd4832ecb1c85$var$_extends3.default)({}, this.props, {
                    autoContainerWidth: true,
                    cellRenderer: this._cellRenderer,
                    className: classNames,
                    columnWidth: width,
                    columnCount: 1,
                    noContentRenderer: noRowsRenderer,
                    onScroll: this._onScroll,
                    onSectionRendered: this._onSectionRendered,
                    ref: this._setRef,
                    scrollToRow: scrollToIndex
                }));
            }
        }
    ]);
    return List;
}($79acd4832ecb1c85$var$React.PureComponent);
$79acd4832ecb1c85$var$List.defaultProps = {
    autoHeight: false,
    estimatedRowSize: 30,
    onScroll: function onScroll() {},
    noRowsRenderer: function noRowsRenderer() {
        return null;
    },
    onRowsRendered: function onRowsRendered() {},
    overscanIndicesGetter: $kNNa3.accessibilityOverscanIndicesGetter,
    overscanRowCount: 10,
    scrollToAlignment: 'auto',
    scrollToIndex: -1,
    style: {}
};
$79acd4832ecb1c85$var$List.propTypes = null;
module.exports.default = $79acd4832ecb1c85$var$List;

});
parcelRegister("izRwq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $d865033b5037152b$export$1e511d4a378977f5, (v) => $d865033b5037152b$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $d865033b5037152b$export$2e2bcd8739ae039, (v) => $d865033b5037152b$export$2e2bcd8739ae039 = v);
var $d865033b5037152b$export$1e511d4a378977f5;
var $d865033b5037152b$export$2e2bcd8739ae039;
"use strict";
$d865033b5037152b$export$1e511d4a378977f5 = true;

var $3ny3M = parcelRequire("3ny3M");
var $d865033b5037152b$var$_assign2 = $d865033b5037152b$var$_interopRequireDefault($3ny3M);
function $d865033b5037152b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$d865033b5037152b$export$2e2bcd8739ae039 = $d865033b5037152b$var$_assign2.default || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

});
parcelRegister("3ny3M", function(module, exports) {

module.exports = {
    "default": (parcelRequire("aJlqc")),
    __esModule: true
};

});
parcelRegister("aJlqc", function(module, exports) {
parcelRequire("9HxL5");

module.exports = (parcelRequire("h9BqL")).Object.assign;

});
parcelRegister("9HxL5", function(module, exports) {
// 19.1.3.1 Object.assign(target, source)

var $1VdgD = parcelRequire("1VdgD");

$1VdgD($1VdgD.S + $1VdgD.F, 'Object', {
    assign: (parcelRequire("j3SKw"))
});

});
parcelRegister("j3SKw", function(module, exports) {
'use strict';

var $2ZZjJ = parcelRequire("2ZZjJ");

var $f49xG = parcelRequire("f49xG");

var $29Vta = parcelRequire("29Vta");

var $7NEQF = parcelRequire("7NEQF");

var $9IOcn = parcelRequire("9IOcn");

var $aokPx = parcelRequire("aokPx");
var $de08c43c136e4a2e$var$$assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$de08c43c136e4a2e$var$$assign || (parcelRequire("60hL6"))(function() {
    var A = {};
    var B = {};
    // eslint-disable-next-line no-undef
    var S = Symbol();
    var K = 'abcdefghijklmnopqrst';
    A[S] = 7;
    K.split('').forEach(function(k) {
        B[k] = k;
    });
    return $de08c43c136e4a2e$var$$assign({}, A)[S] != 7 || Object.keys($de08c43c136e4a2e$var$$assign({}, B)).join('') != K;
}) ? function assign(target, source) {
    var T = $9IOcn(target);
    var aLen = arguments.length;
    var index = 1;
    var getSymbols = $29Vta.f;
    var isEnum = $7NEQF.f;
    while(aLen > index){
        var S = $aokPx(arguments[index++]);
        var keys = getSymbols ? $f49xG(S).concat(getSymbols(S)) : $f49xG(S);
        var length = keys.length;
        var j = 0;
        var key;
        while(length > j){
            key = keys[j++];
            if (!$2ZZjJ || isEnum.call(S, key)) T[key] = S[key];
        }
    }
    return T;
} : $de08c43c136e4a2e$var$$assign;

});





parcelRegister("cwG55", function(module, exports) {

module.exports = {
    "default": (parcelRequire("gKt2e")),
    __esModule: true
};

});
parcelRegister("gKt2e", function(module, exports) {
parcelRequire("6s03e");

var $h9BqL = parcelRequire("h9BqL");
var $c31776f0a2a3de7d$require$$Object = $h9BqL.Object;
module.exports = function getOwnPropertyDescriptor(it, key) {
    return $c31776f0a2a3de7d$require$$Object.getOwnPropertyDescriptor(it, key);
};

});
parcelRegister("6s03e", function(module, exports) {
// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)

var $kOF1h = parcelRequire("kOF1h");

var $2YAEc = parcelRequire("2YAEc");
var $4b2565bb70eb0585$require$$getOwnPropertyDescriptor = $2YAEc.f;

(parcelRequire("6rscv"))('getOwnPropertyDescriptor', function() {
    return function getOwnPropertyDescriptor(it, key) {
        return $4b2565bb70eb0585$require$$getOwnPropertyDescriptor($kOF1h(it), key);
    };
});

});



parcelRegister("kNNa3", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bpfrpt_proptype_Scroll = module.exports.bpfrpt_proptype_CellRendererParams = module.exports.bpfrpt_proptype_RenderedSection = module.exports.bpfrpt_proptype_OverscanIndicesGetter = module.exports.bpfrpt_proptype_CellSize = module.exports.bpfrpt_proptype_CellPosition = module.exports.bpfrpt_proptype_Alignment = module.exports.bpfrpt_proptype_NoContentRenderer = module.exports.defaultOverscanIndicesGetter = module.exports.defaultCellRangeRenderer = module.exports.accessibilityOverscanIndicesGetter = module.exports.Grid = module.exports.default = undefined;

var $3BVva = parcelRequire("3BVva");
Object.defineProperty(module.exports, 'default', {
    enumerable: true,
    get: function get() {
        return $f24e849c268b67c2$var$_interopRequireDefault($3BVva).default;
    }
});
Object.defineProperty(module.exports, 'Grid', {
    enumerable: true,
    get: function get() {
        return $f24e849c268b67c2$var$_interopRequireDefault($3BVva).default;
    }
});

var $hcTHf = parcelRequire("hcTHf");
Object.defineProperty(module.exports, 'accessibilityOverscanIndicesGetter', {
    enumerable: true,
    get: function get() {
        return $f24e849c268b67c2$var$_interopRequireDefault($hcTHf).default;
    }
});

var $4lqYK = parcelRequire("4lqYK");
Object.defineProperty(module.exports, 'defaultCellRangeRenderer', {
    enumerable: true,
    get: function get() {
        return $f24e849c268b67c2$var$_interopRequireDefault($4lqYK).default;
    }
});

var $5F8bn = parcelRequire("5F8bn");
Object.defineProperty(module.exports, 'defaultOverscanIndicesGetter', {
    enumerable: true,
    get: function get() {
        return $f24e849c268b67c2$var$_interopRequireDefault($5F8bn).default;
    }
});

var $5XjzC = parcelRequire("5XjzC");
function $f24e849c268b67c2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports.bpfrpt_proptype_NoContentRenderer = $5XjzC.bpfrpt_proptype_NoContentRenderer;
module.exports.bpfrpt_proptype_Alignment = $5XjzC.bpfrpt_proptype_Alignment;
module.exports.bpfrpt_proptype_CellPosition = $5XjzC.bpfrpt_proptype_CellPosition;
module.exports.bpfrpt_proptype_CellSize = $5XjzC.bpfrpt_proptype_CellSize;
module.exports.bpfrpt_proptype_OverscanIndicesGetter = $5XjzC.bpfrpt_proptype_OverscanIndicesGetter;
module.exports.bpfrpt_proptype_RenderedSection = $5XjzC.bpfrpt_proptype_RenderedSection;
module.exports.bpfrpt_proptype_CellRendererParams = $5XjzC.bpfrpt_proptype_CellRendererParams;
module.exports.bpfrpt_proptype_Scroll = $5XjzC.bpfrpt_proptype_Scroll;

});
parcelRegister("3BVva", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DEFAULT_SCROLLING_RESET_TIME_INTERVAL = undefined;

var $3ny3M = parcelRequire("3ny3M");
var $2a116e6b7adfcc6d$var$_assign2 = $2a116e6b7adfcc6d$var$_interopRequireDefault($3ny3M);

var $izRwq = parcelRequire("izRwq");
var $2a116e6b7adfcc6d$var$_extends3 = $2a116e6b7adfcc6d$var$_interopRequireDefault($izRwq);

var $1nR2i = parcelRequire("1nR2i");
var $2a116e6b7adfcc6d$var$_getPrototypeOf2 = $2a116e6b7adfcc6d$var$_interopRequireDefault($1nR2i);

var $jK0mf = parcelRequire("jK0mf");
var $2a116e6b7adfcc6d$var$_classCallCheck3 = $2a116e6b7adfcc6d$var$_interopRequireDefault($jK0mf);

var $7kKnu = parcelRequire("7kKnu");
var $2a116e6b7adfcc6d$var$_createClass3 = $2a116e6b7adfcc6d$var$_interopRequireDefault($7kKnu);

var $dopow = parcelRequire("dopow");
var $2a116e6b7adfcc6d$var$_possibleConstructorReturn3 = $2a116e6b7adfcc6d$var$_interopRequireDefault($dopow);

var $2G5Ta = parcelRequire("2G5Ta");
var $2a116e6b7adfcc6d$var$_inherits3 = $2a116e6b7adfcc6d$var$_interopRequireDefault($2G5Ta);

var $eJOHy = parcelRequire("eJOHy");
var $2a116e6b7adfcc6d$var$React = $2a116e6b7adfcc6d$var$_interopRequireWildcard($eJOHy);

var $frReV = parcelRequire("frReV");
var $2a116e6b7adfcc6d$var$_clsx2 = $2a116e6b7adfcc6d$var$_interopRequireDefault($frReV);

var $lcv9d = parcelRequire("lcv9d");
var $2a116e6b7adfcc6d$var$_calculateSizeAndPositionDataAndUpdateScrollOffset2 = $2a116e6b7adfcc6d$var$_interopRequireDefault($lcv9d);

var $bNRtZ = parcelRequire("bNRtZ");
var $2a116e6b7adfcc6d$var$_ScalingCellSizeAndPositionManager2 = $2a116e6b7adfcc6d$var$_interopRequireDefault($bNRtZ);

var $cV315 = parcelRequire("cV315");
var $2a116e6b7adfcc6d$var$_createCallbackMemoizer2 = $2a116e6b7adfcc6d$var$_interopRequireDefault($cV315);

var $5F8bn = parcelRequire("5F8bn");
var $2a116e6b7adfcc6d$var$_defaultOverscanIndicesGetter2 = $2a116e6b7adfcc6d$var$_interopRequireDefault($5F8bn);

var $co45v = parcelRequire("co45v");
var $2a116e6b7adfcc6d$var$_updateScrollIndexHelper2 = $2a116e6b7adfcc6d$var$_interopRequireDefault($co45v);

var $4lqYK = parcelRequire("4lqYK");
var $2a116e6b7adfcc6d$var$_defaultCellRangeRenderer2 = $2a116e6b7adfcc6d$var$_interopRequireDefault($4lqYK);

var $5YzJ9 = parcelRequire("5YzJ9");
var $2a116e6b7adfcc6d$var$_scrollbarSize2 = $2a116e6b7adfcc6d$var$_interopRequireDefault($5YzJ9);

var $b4FuJ = parcelRequire("b4FuJ");

var $csq0B = parcelRequire("csq0B");
parcelRequire("5XjzC");

var $cT3Ey = parcelRequire("cT3Ey");
var $2a116e6b7adfcc6d$var$_propTypes2 = $2a116e6b7adfcc6d$var$_interopRequireDefault($cT3Ey);
function $2a116e6b7adfcc6d$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $2a116e6b7adfcc6d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Specifies the number of milliseconds during which to disable pointer events while a scroll is in progress.
 * This improves performance and makes scrolling smoother.
 */ var $2a116e6b7adfcc6d$var$DEFAULT_SCROLLING_RESET_TIME_INTERVAL = module.exports.DEFAULT_SCROLLING_RESET_TIME_INTERVAL = 150;
/**
 * Controls whether the Grid updates the DOM element's scrollLeft/scrollTop based on the current state or just observes it.
 * This prevents Grid from interrupting mouse-wheel animations (see issue #2).
 */ var $2a116e6b7adfcc6d$var$SCROLL_POSITION_CHANGE_REASONS = {
    OBSERVED: 'observed',
    REQUESTED: 'requested'
};
var $2a116e6b7adfcc6d$var$renderNull = function renderNull() {
    return null;
};
/**
 * Renders tabular data with virtualization along the vertical and horizontal axes.
 * Row heights and column widths must be known ahead of time and specified as properties.
 */ var $2a116e6b7adfcc6d$var$Grid = function(_React$PureComponent) {
    (0, $2a116e6b7adfcc6d$var$_inherits3.default)(Grid, _React$PureComponent);
    // Invokes onSectionRendered callback only when start/stop row or column indices change
    function Grid(props) {
        (0, $2a116e6b7adfcc6d$var$_classCallCheck3.default)(this, Grid);
        var _this = (0, $2a116e6b7adfcc6d$var$_possibleConstructorReturn3.default)(this, (Grid.__proto__ || (0, $2a116e6b7adfcc6d$var$_getPrototypeOf2.default)(Grid)).call(this, props));
        _this._onGridRenderedMemoizer = (0, $2a116e6b7adfcc6d$var$_createCallbackMemoizer2.default)();
        _this._onScrollMemoizer = (0, $2a116e6b7adfcc6d$var$_createCallbackMemoizer2.default)(false);
        _this._deferredInvalidateColumnIndex = null;
        _this._deferredInvalidateRowIndex = null;
        _this._recomputeScrollLeftFlag = false;
        _this._recomputeScrollTopFlag = false;
        _this._horizontalScrollBarSize = 0;
        _this._verticalScrollBarSize = 0;
        _this._scrollbarPresenceChanged = false;
        _this._renderedColumnStartIndex = 0;
        _this._renderedColumnStopIndex = 0;
        _this._renderedRowStartIndex = 0;
        _this._renderedRowStopIndex = 0;
        _this._styleCache = {};
        _this._cellCache = {};
        _this._debounceScrollEndedCallback = function() {
            _this._disablePointerEventsTimeoutId = null;
            // isScrolling is used to determine if we reset styleCache
            _this.setState({
                isScrolling: false,
                needToResetStyleCache: false
            });
        };
        _this._invokeOnGridRenderedHelper = function() {
            var onSectionRendered = _this.props.onSectionRendered;
            _this._onGridRenderedMemoizer({
                callback: onSectionRendered,
                indices: {
                    columnOverscanStartIndex: _this._columnStartIndex,
                    columnOverscanStopIndex: _this._columnStopIndex,
                    columnStartIndex: _this._renderedColumnStartIndex,
                    columnStopIndex: _this._renderedColumnStopIndex,
                    rowOverscanStartIndex: _this._rowStartIndex,
                    rowOverscanStopIndex: _this._rowStopIndex,
                    rowStartIndex: _this._renderedRowStartIndex,
                    rowStopIndex: _this._renderedRowStopIndex
                }
            });
        };
        _this._setScrollingContainerRef = function(ref) {
            _this._scrollingContainer = ref;
        };
        _this._onScroll = function(event) {
            // In certain edge-cases React dispatches an onScroll event with an invalid target.scrollLeft / target.scrollTop.
            // This invalid event can be detected by comparing event.target to this component's scrollable DOM element.
            // See issue #404 for more information.
            if (event.target === _this._scrollingContainer) _this.handleScrollEvent(event.target);
        };
        var columnSizeAndPositionManager = new $2a116e6b7adfcc6d$var$_ScalingCellSizeAndPositionManager2.default({
            cellCount: props.columnCount,
            cellSizeGetter: function cellSizeGetter(params) {
                return Grid._wrapSizeGetter(props.columnWidth)(params);
            },
            estimatedCellSize: Grid._getEstimatedColumnSize(props)
        });
        var rowSizeAndPositionManager = new $2a116e6b7adfcc6d$var$_ScalingCellSizeAndPositionManager2.default({
            cellCount: props.rowCount,
            cellSizeGetter: function cellSizeGetter(params) {
                return Grid._wrapSizeGetter(props.rowHeight)(params);
            },
            estimatedCellSize: Grid._getEstimatedRowSize(props)
        });
        _this.state = {
            instanceProps: {
                columnSizeAndPositionManager: columnSizeAndPositionManager,
                rowSizeAndPositionManager: rowSizeAndPositionManager,
                prevColumnWidth: props.columnWidth,
                prevRowHeight: props.rowHeight,
                prevColumnCount: props.columnCount,
                prevRowCount: props.rowCount,
                prevIsScrolling: props.isScrolling === true,
                prevScrollToColumn: props.scrollToColumn,
                prevScrollToRow: props.scrollToRow,
                scrollbarSize: 0,
                scrollbarSizeMeasured: false
            },
            isScrolling: false,
            scrollDirectionHorizontal: $5F8bn.SCROLL_DIRECTION_FORWARD,
            scrollDirectionVertical: $5F8bn.SCROLL_DIRECTION_FORWARD,
            scrollLeft: 0,
            scrollTop: 0,
            scrollPositionChangeReason: null,
            needToResetStyleCache: false
        };
        if (props.scrollToRow > 0) _this._initialScrollTop = _this._getCalculatedScrollTop(props, _this.state);
        if (props.scrollToColumn > 0) _this._initialScrollLeft = _this._getCalculatedScrollLeft(props, _this.state);
        return _this;
    }
    /**
   * Gets offsets for a given cell and alignment.
   */ (0, $2a116e6b7adfcc6d$var$_createClass3.default)(Grid, [
        {
            key: 'getOffsetForCell',
            value: function getOffsetForCell() {
                var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$alignment = _ref.alignment, alignment = _ref$alignment === undefined ? this.props.scrollToAlignment : _ref$alignment, _ref$columnIndex = _ref.columnIndex, columnIndex = _ref$columnIndex === undefined ? this.props.scrollToColumn : _ref$columnIndex, _ref$rowIndex = _ref.rowIndex, rowIndex = _ref$rowIndex === undefined ? this.props.scrollToRow : _ref$rowIndex;
                var offsetProps = (0, $2a116e6b7adfcc6d$var$_extends3.default)({}, this.props, {
                    scrollToAlignment: alignment,
                    scrollToColumn: columnIndex,
                    scrollToRow: rowIndex
                });
                return {
                    scrollLeft: this._getCalculatedScrollLeft(offsetProps),
                    scrollTop: this._getCalculatedScrollTop(offsetProps)
                };
            }
        },
        {
            key: 'getTotalRowsHeight',
            value: function getTotalRowsHeight() {
                return this.state.instanceProps.rowSizeAndPositionManager.getTotalSize();
            }
        },
        {
            key: 'getTotalColumnsWidth',
            value: function getTotalColumnsWidth() {
                return this.state.instanceProps.columnSizeAndPositionManager.getTotalSize();
            }
        },
        {
            key: 'handleScrollEvent',
            value: function handleScrollEvent(_ref2) {
                var _ref2$scrollLeft = _ref2.scrollLeft, scrollLeftParam = _ref2$scrollLeft === undefined ? 0 : _ref2$scrollLeft, _ref2$scrollTop = _ref2.scrollTop, scrollTopParam = _ref2$scrollTop === undefined ? 0 : _ref2$scrollTop;
                // On iOS, we can arrive at negative offsets by swiping past the start.
                // To prevent flicker here, we make playing in the negative offset zone cause nothing to happen.
                if (scrollTopParam < 0) return;
                // Prevent pointer events from interrupting a smooth scroll
                this._debounceScrollEnded();
                var _props = this.props, autoHeight = _props.autoHeight, autoWidth = _props.autoWidth, height = _props.height, width = _props.width;
                var instanceProps = this.state.instanceProps;
                // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
                // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
                // This causes a series of rapid renders that is slow for long lists.
                // We can avoid that by doing some simple bounds checking to ensure that scroll offsets never exceed their bounds.
                var scrollbarSize = instanceProps.scrollbarSize;
                var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
                var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
                var scrollLeft = Math.min(Math.max(0, totalColumnsWidth - width + scrollbarSize), scrollLeftParam);
                var scrollTop = Math.min(Math.max(0, totalRowsHeight - height + scrollbarSize), scrollTopParam);
                // Certain devices (like Apple touchpad) rapid-fire duplicate events.
                // Don't force a re-render if this is the case.
                // The mouse may move faster then the animation frame does.
                // Use requestAnimationFrame to avoid over-updating.
                if (this.state.scrollLeft !== scrollLeft || this.state.scrollTop !== scrollTop) {
                    // Track scrolling direction so we can more efficiently overscan rows to reduce empty space around the edges while scrolling.
                    // Don't change direction for an axis unless scroll offset has changed.
                    var _scrollDirectionHorizontal = scrollLeft !== this.state.scrollLeft ? scrollLeft > this.state.scrollLeft ? $5F8bn.SCROLL_DIRECTION_FORWARD : $5F8bn.SCROLL_DIRECTION_BACKWARD : this.state.scrollDirectionHorizontal;
                    var _scrollDirectionVertical = scrollTop !== this.state.scrollTop ? scrollTop > this.state.scrollTop ? $5F8bn.SCROLL_DIRECTION_FORWARD : $5F8bn.SCROLL_DIRECTION_BACKWARD : this.state.scrollDirectionVertical;
                    var newState = {
                        isScrolling: true,
                        scrollDirectionHorizontal: _scrollDirectionHorizontal,
                        scrollDirectionVertical: _scrollDirectionVertical,
                        scrollPositionChangeReason: $2a116e6b7adfcc6d$var$SCROLL_POSITION_CHANGE_REASONS.OBSERVED
                    };
                    if (!autoHeight) newState.scrollTop = scrollTop;
                    if (!autoWidth) newState.scrollLeft = scrollLeft;
                    newState.needToResetStyleCache = false;
                    this.setState(newState);
                }
                this._invokeOnScrollMemoizer({
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop,
                    totalColumnsWidth: totalColumnsWidth,
                    totalRowsHeight: totalRowsHeight
                });
            }
        },
        {
            key: 'invalidateCellSizeAfterRender',
            value: function invalidateCellSizeAfterRender(_ref3) {
                var columnIndex = _ref3.columnIndex, rowIndex = _ref3.rowIndex;
                this._deferredInvalidateColumnIndex = typeof this._deferredInvalidateColumnIndex === 'number' ? Math.min(this._deferredInvalidateColumnIndex, columnIndex) : columnIndex;
                this._deferredInvalidateRowIndex = typeof this._deferredInvalidateRowIndex === 'number' ? Math.min(this._deferredInvalidateRowIndex, rowIndex) : rowIndex;
            }
        },
        {
            key: 'measureAllCells',
            value: function measureAllCells() {
                var _props2 = this.props, columnCount = _props2.columnCount, rowCount = _props2.rowCount;
                var instanceProps = this.state.instanceProps;
                instanceProps.columnSizeAndPositionManager.getSizeAndPositionOfCell(columnCount - 1);
                instanceProps.rowSizeAndPositionManager.getSizeAndPositionOfCell(rowCount - 1);
            }
        },
        {
            key: 'recomputeGridSize',
            value: function recomputeGridSize() {
                var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref4$columnIndex = _ref4.columnIndex, columnIndex = _ref4$columnIndex === undefined ? 0 : _ref4$columnIndex, _ref4$rowIndex = _ref4.rowIndex, rowIndex = _ref4$rowIndex === undefined ? 0 : _ref4$rowIndex;
                var _props3 = this.props, scrollToColumn = _props3.scrollToColumn, scrollToRow = _props3.scrollToRow;
                var instanceProps = this.state.instanceProps;
                instanceProps.columnSizeAndPositionManager.resetCell(columnIndex);
                instanceProps.rowSizeAndPositionManager.resetCell(rowIndex);
                // Cell sizes may be determined by a function property.
                // In this case the cDU handler can't know if they changed.
                // Store this flag to let the next cDU pass know it needs to recompute the scroll offset.
                this._recomputeScrollLeftFlag = scrollToColumn >= 0 && (this.state.scrollDirectionHorizontal === $5F8bn.SCROLL_DIRECTION_FORWARD ? columnIndex <= scrollToColumn : columnIndex >= scrollToColumn);
                this._recomputeScrollTopFlag = scrollToRow >= 0 && (this.state.scrollDirectionVertical === $5F8bn.SCROLL_DIRECTION_FORWARD ? rowIndex <= scrollToRow : rowIndex >= scrollToRow);
                // Clear cell cache in case we are scrolling;
                // Invalid row heights likely mean invalid cached content as well.
                this._styleCache = {};
                this._cellCache = {};
                this.forceUpdate();
            }
        },
        {
            key: 'scrollToCell',
            value: function scrollToCell(_ref5) {
                var columnIndex = _ref5.columnIndex, rowIndex = _ref5.rowIndex;
                var columnCount = this.props.columnCount;
                var props = this.props;
                // Don't adjust scroll offset for single-column grids (eg List, Table).
                // This can cause a funky scroll offset because of the vertical scrollbar width.
                if (columnCount > 1 && columnIndex !== undefined) this._updateScrollLeftForScrollToColumn((0, $2a116e6b7adfcc6d$var$_extends3.default)({}, props, {
                    scrollToColumn: columnIndex
                }));
                if (rowIndex !== undefined) this._updateScrollTopForScrollToRow((0, $2a116e6b7adfcc6d$var$_extends3.default)({}, props, {
                    scrollToRow: rowIndex
                }));
            }
        },
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                var _props4 = this.props, getScrollbarSize = _props4.getScrollbarSize, height = _props4.height, scrollLeft = _props4.scrollLeft, scrollToColumn = _props4.scrollToColumn, scrollTop = _props4.scrollTop, scrollToRow = _props4.scrollToRow, width = _props4.width;
                var instanceProps = this.state.instanceProps;
                // Reset initial offsets to be ignored in browser
                this._initialScrollTop = 0;
                this._initialScrollLeft = 0;
                // If cell sizes have been invalidated (eg we are using CellMeasurer) then reset cached positions.
                // We must do this at the start of the method as we may calculate and update scroll position below.
                this._handleInvalidatedGridSize();
                // If this component was first rendered server-side, scrollbar size will be undefined.
                // In that event we need to remeasure.
                if (!instanceProps.scrollbarSizeMeasured) this.setState(function(prevState) {
                    var stateUpdate = (0, $2a116e6b7adfcc6d$var$_extends3.default)({}, prevState, {
                        needToResetStyleCache: false
                    });
                    stateUpdate.instanceProps.scrollbarSize = getScrollbarSize();
                    stateUpdate.instanceProps.scrollbarSizeMeasured = true;
                    return stateUpdate;
                });
                if (typeof scrollLeft === 'number' && scrollLeft >= 0 || typeof scrollTop === 'number' && scrollTop >= 0) {
                    var stateUpdate = Grid._getScrollToPositionStateUpdate({
                        prevState: this.state,
                        scrollLeft: scrollLeft,
                        scrollTop: scrollTop
                    });
                    if (stateUpdate) {
                        stateUpdate.needToResetStyleCache = false;
                        this.setState(stateUpdate);
                    }
                }
                // refs don't work in `react-test-renderer`
                if (this._scrollingContainer) {
                    // setting the ref's scrollLeft and scrollTop.
                    // Somehow in MultiGrid the main grid doesn't trigger a update on mount.
                    if (this._scrollingContainer.scrollLeft !== this.state.scrollLeft) this._scrollingContainer.scrollLeft = this.state.scrollLeft;
                    if (this._scrollingContainer.scrollTop !== this.state.scrollTop) this._scrollingContainer.scrollTop = this.state.scrollTop;
                }
                // Don't update scroll offset if the size is 0; we don't render any cells in this case.
                // Setting a state may cause us to later thing we've updated the offce when we haven't.
                var sizeIsBiggerThanZero = height > 0 && width > 0;
                if (scrollToColumn >= 0 && sizeIsBiggerThanZero) this._updateScrollLeftForScrollToColumn();
                if (scrollToRow >= 0 && sizeIsBiggerThanZero) this._updateScrollTopForScrollToRow();
                // Update onRowsRendered callback
                this._invokeOnGridRenderedHelper();
                // Initialize onScroll callback
                this._invokeOnScrollMemoizer({
                    scrollLeft: scrollLeft || 0,
                    scrollTop: scrollTop || 0,
                    totalColumnsWidth: instanceProps.columnSizeAndPositionManager.getTotalSize(),
                    totalRowsHeight: instanceProps.rowSizeAndPositionManager.getTotalSize()
                });
                this._maybeCallOnScrollbarPresenceChange();
            }
        },
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps, prevState) {
                var _this2 = this;
                var _props5 = this.props, autoHeight = _props5.autoHeight, autoWidth = _props5.autoWidth, columnCount = _props5.columnCount, height = _props5.height, rowCount = _props5.rowCount, scrollToAlignment = _props5.scrollToAlignment, scrollToColumn = _props5.scrollToColumn, scrollToRow = _props5.scrollToRow, width = _props5.width;
                var _state = this.state, scrollLeft = _state.scrollLeft, scrollPositionChangeReason = _state.scrollPositionChangeReason, scrollTop = _state.scrollTop, instanceProps = _state.instanceProps;
                // If cell sizes have been invalidated (eg we are using CellMeasurer) then reset cached positions.
                // We must do this at the start of the method as we may calculate and update scroll position below.
                this._handleInvalidatedGridSize();
                // Handle edge case where column or row count has only just increased over 0.
                // In this case we may have to restore a previously-specified scroll offset.
                // For more info see bvaughn/react-virtualized/issues/218
                var columnOrRowCountJustIncreasedFromZero = columnCount > 0 && prevProps.columnCount === 0 || rowCount > 0 && prevProps.rowCount === 0;
                // Make sure requested changes to :scrollLeft or :scrollTop get applied.
                // Assigning to scrollLeft/scrollTop tells the browser to interrupt any running scroll animations,
                // And to discard any pending async changes to the scroll position that may have happened in the meantime (e.g. on a separate scrolling thread).
                // So we only set these when we require an adjustment of the scroll position.
                // See issue #2 for more information.
                if (scrollPositionChangeReason === $2a116e6b7adfcc6d$var$SCROLL_POSITION_CHANGE_REASONS.REQUESTED) {
                    // @TRICKY :autoHeight and :autoWidth properties instructs Grid to leave :scrollTop and :scrollLeft management to an external HOC (eg WindowScroller).
                    // In this case we should avoid checking scrollingContainer.scrollTop and scrollingContainer.scrollLeft since it forces layout/flow.
                    if (!autoWidth && scrollLeft >= 0 && (scrollLeft !== this._scrollingContainer.scrollLeft || columnOrRowCountJustIncreasedFromZero)) this._scrollingContainer.scrollLeft = scrollLeft;
                    if (!autoHeight && scrollTop >= 0 && (scrollTop !== this._scrollingContainer.scrollTop || columnOrRowCountJustIncreasedFromZero)) this._scrollingContainer.scrollTop = scrollTop;
                }
                // Special case where the previous size was 0:
                // In this case we don't show any windowed cells at all.
                // So we should always recalculate offset afterwards.
                var sizeJustIncreasedFromZero = (prevProps.width === 0 || prevProps.height === 0) && height > 0 && width > 0;
                // Update scroll offsets if the current :scrollToColumn or :scrollToRow values requires it
                // @TODO Do we also need this check or can the one in componentWillUpdate() suffice?
                if (this._recomputeScrollLeftFlag) {
                    this._recomputeScrollLeftFlag = false;
                    this._updateScrollLeftForScrollToColumn(this.props);
                } else (0, $2a116e6b7adfcc6d$var$_updateScrollIndexHelper2.default)({
                    cellSizeAndPositionManager: instanceProps.columnSizeAndPositionManager,
                    previousCellsCount: prevProps.columnCount,
                    previousCellSize: prevProps.columnWidth,
                    previousScrollToAlignment: prevProps.scrollToAlignment,
                    previousScrollToIndex: prevProps.scrollToColumn,
                    previousSize: prevProps.width,
                    scrollOffset: scrollLeft,
                    scrollToAlignment: scrollToAlignment,
                    scrollToIndex: scrollToColumn,
                    size: width,
                    sizeJustIncreasedFromZero: sizeJustIncreasedFromZero,
                    updateScrollIndexCallback: function updateScrollIndexCallback() {
                        return _this2._updateScrollLeftForScrollToColumn(_this2.props);
                    }
                });
                if (this._recomputeScrollTopFlag) {
                    this._recomputeScrollTopFlag = false;
                    this._updateScrollTopForScrollToRow(this.props);
                } else (0, $2a116e6b7adfcc6d$var$_updateScrollIndexHelper2.default)({
                    cellSizeAndPositionManager: instanceProps.rowSizeAndPositionManager,
                    previousCellsCount: prevProps.rowCount,
                    previousCellSize: prevProps.rowHeight,
                    previousScrollToAlignment: prevProps.scrollToAlignment,
                    previousScrollToIndex: prevProps.scrollToRow,
                    previousSize: prevProps.height,
                    scrollOffset: scrollTop,
                    scrollToAlignment: scrollToAlignment,
                    scrollToIndex: scrollToRow,
                    size: height,
                    sizeJustIncreasedFromZero: sizeJustIncreasedFromZero,
                    updateScrollIndexCallback: function updateScrollIndexCallback() {
                        return _this2._updateScrollTopForScrollToRow(_this2.props);
                    }
                });
                // Update onRowsRendered callback if start/stop indices have changed
                this._invokeOnGridRenderedHelper();
                // Changes to :scrollLeft or :scrollTop should also notify :onScroll listeners
                if (scrollLeft !== prevState.scrollLeft || scrollTop !== prevState.scrollTop) {
                    var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
                    var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
                    this._invokeOnScrollMemoizer({
                        scrollLeft: scrollLeft,
                        scrollTop: scrollTop,
                        totalColumnsWidth: totalColumnsWidth,
                        totalRowsHeight: totalRowsHeight
                    });
                }
                this._maybeCallOnScrollbarPresenceChange();
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                if (this._disablePointerEventsTimeoutId) (0, $csq0B.cancelAnimationTimeout)(this._disablePointerEventsTimeoutId);
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props6 = this.props, autoContainerWidth = _props6.autoContainerWidth, autoHeight = _props6.autoHeight, autoWidth = _props6.autoWidth, className = _props6.className, containerProps = _props6.containerProps, containerRole = _props6.containerRole, containerStyle = _props6.containerStyle, height = _props6.height, id = _props6.id, noContentRenderer = _props6.noContentRenderer, role = _props6.role, style = _props6.style, tabIndex = _props6.tabIndex, width = _props6.width;
                var _state2 = this.state, instanceProps = _state2.instanceProps, needToResetStyleCache = _state2.needToResetStyleCache;
                var isScrolling = this._isScrolling();
                var gridStyle = {
                    boxSizing: 'border-box',
                    direction: 'ltr',
                    height: autoHeight ? 'auto' : height,
                    position: 'relative',
                    width: autoWidth ? 'auto' : width,
                    WebkitOverflowScrolling: 'touch',
                    willChange: 'transform'
                };
                if (needToResetStyleCache) this._styleCache = {};
                // calculate _styleCache here
                // if state.isScrolling (not from _isScrolling) then reset
                if (!this.state.isScrolling) this._resetStyleCache();
                // calculate children to render here
                this._calculateChildrenToRender(this.props, this.state);
                var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
                var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
                // Force browser to hide scrollbars when we know they aren't necessary.
                // Otherwise once scrollbars appear they may not disappear again.
                // For more info see issue #116
                var verticalScrollBarSize = totalRowsHeight > height ? instanceProps.scrollbarSize : 0;
                var horizontalScrollBarSize = totalColumnsWidth > width ? instanceProps.scrollbarSize : 0;
                if (horizontalScrollBarSize !== this._horizontalScrollBarSize || verticalScrollBarSize !== this._verticalScrollBarSize) {
                    this._horizontalScrollBarSize = horizontalScrollBarSize;
                    this._verticalScrollBarSize = verticalScrollBarSize;
                    this._scrollbarPresenceChanged = true;
                }
                // Also explicitly init styles to 'auto' if scrollbars are required.
                // This works around an obscure edge case where external CSS styles have not yet been loaded,
                // But an initial scroll index of offset is set as an external prop.
                // Without this style, Grid would render the correct range of cells but would NOT update its internal offset.
                // This was originally reported via clauderic/react-infinite-calendar/issues/23
                gridStyle.overflowX = totalColumnsWidth + verticalScrollBarSize <= width ? 'hidden' : 'auto';
                gridStyle.overflowY = totalRowsHeight + horizontalScrollBarSize <= height ? 'hidden' : 'auto';
                var childrenToDisplay = this._childrenToDisplay;
                var showNoContentRenderer = childrenToDisplay.length === 0 && height > 0 && width > 0;
                return $2a116e6b7adfcc6d$var$React.createElement('div', (0, $2a116e6b7adfcc6d$var$_extends3.default)({
                    ref: this._setScrollingContainerRef
                }, containerProps, {
                    'aria-label': this.props['aria-label'],
                    'aria-readonly': this.props['aria-readonly'],
                    className: (0, $2a116e6b7adfcc6d$var$_clsx2.default)('ReactVirtualized__Grid', className),
                    id: id,
                    onScroll: this._onScroll,
                    role: role,
                    style: (0, $2a116e6b7adfcc6d$var$_extends3.default)({}, gridStyle, style),
                    tabIndex: tabIndex
                }), childrenToDisplay.length > 0 && $2a116e6b7adfcc6d$var$React.createElement('div', {
                    className: 'ReactVirtualized__Grid__innerScrollContainer',
                    role: containerRole,
                    style: (0, $2a116e6b7adfcc6d$var$_extends3.default)({
                        width: autoContainerWidth ? 'auto' : totalColumnsWidth,
                        height: totalRowsHeight,
                        maxWidth: totalColumnsWidth,
                        maxHeight: totalRowsHeight,
                        overflow: 'hidden',
                        pointerEvents: isScrolling ? 'none' : '',
                        position: 'relative'
                    }, containerStyle)
                }, childrenToDisplay), showNoContentRenderer && noContentRenderer());
            }
        },
        {
            key: '_calculateChildrenToRender',
            value: function _calculateChildrenToRender() {
                var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
                var cellRenderer = props.cellRenderer, cellRangeRenderer = props.cellRangeRenderer, columnCount = props.columnCount, deferredMeasurementCache = props.deferredMeasurementCache, height = props.height, overscanColumnCount = props.overscanColumnCount, overscanIndicesGetter = props.overscanIndicesGetter, overscanRowCount = props.overscanRowCount, rowCount = props.rowCount, width = props.width, isScrollingOptOut = props.isScrollingOptOut;
                var scrollDirectionHorizontal = state.scrollDirectionHorizontal, scrollDirectionVertical = state.scrollDirectionVertical, instanceProps = state.instanceProps;
                var scrollTop = this._initialScrollTop > 0 ? this._initialScrollTop : state.scrollTop;
                var scrollLeft = this._initialScrollLeft > 0 ? this._initialScrollLeft : state.scrollLeft;
                var isScrolling = this._isScrolling(props, state);
                this._childrenToDisplay = [];
                // Render only enough columns and rows to cover the visible area of the grid.
                if (height > 0 && width > 0) {
                    var visibleColumnIndices = instanceProps.columnSizeAndPositionManager.getVisibleCellRange({
                        containerSize: width,
                        offset: scrollLeft
                    });
                    var visibleRowIndices = instanceProps.rowSizeAndPositionManager.getVisibleCellRange({
                        containerSize: height,
                        offset: scrollTop
                    });
                    var horizontalOffsetAdjustment = instanceProps.columnSizeAndPositionManager.getOffsetAdjustment({
                        containerSize: width,
                        offset: scrollLeft
                    });
                    var verticalOffsetAdjustment = instanceProps.rowSizeAndPositionManager.getOffsetAdjustment({
                        containerSize: height,
                        offset: scrollTop
                    });
                    // Store for _invokeOnGridRenderedHelper()
                    this._renderedColumnStartIndex = visibleColumnIndices.start;
                    this._renderedColumnStopIndex = visibleColumnIndices.stop;
                    this._renderedRowStartIndex = visibleRowIndices.start;
                    this._renderedRowStopIndex = visibleRowIndices.stop;
                    var overscanColumnIndices = overscanIndicesGetter({
                        direction: 'horizontal',
                        cellCount: columnCount,
                        overscanCellsCount: overscanColumnCount,
                        scrollDirection: scrollDirectionHorizontal,
                        startIndex: typeof visibleColumnIndices.start === 'number' ? visibleColumnIndices.start : 0,
                        stopIndex: typeof visibleColumnIndices.stop === 'number' ? visibleColumnIndices.stop : -1
                    });
                    var overscanRowIndices = overscanIndicesGetter({
                        direction: 'vertical',
                        cellCount: rowCount,
                        overscanCellsCount: overscanRowCount,
                        scrollDirection: scrollDirectionVertical,
                        startIndex: typeof visibleRowIndices.start === 'number' ? visibleRowIndices.start : 0,
                        stopIndex: typeof visibleRowIndices.stop === 'number' ? visibleRowIndices.stop : -1
                    });
                    // Store for _invokeOnGridRenderedHelper()
                    var columnStartIndex = overscanColumnIndices.overscanStartIndex;
                    var columnStopIndex = overscanColumnIndices.overscanStopIndex;
                    var rowStartIndex = overscanRowIndices.overscanStartIndex;
                    var rowStopIndex = overscanRowIndices.overscanStopIndex;
                    // Advanced use-cases (eg CellMeasurer) require batched measurements to determine accurate sizes.
                    if (deferredMeasurementCache) {
                        // If rows have a dynamic height, scan the rows we are about to render.
                        // If any have not yet been measured, then we need to render all columns initially,
                        // Because the height of the row is equal to the tallest cell within that row,
                        // (And so we can't know the height without measuring all column-cells first).
                        if (!deferredMeasurementCache.hasFixedHeight()) {
                            for(var rowIndex = rowStartIndex; rowIndex <= rowStopIndex; rowIndex++)if (!deferredMeasurementCache.has(rowIndex, 0)) {
                                columnStartIndex = 0;
                                columnStopIndex = columnCount - 1;
                                break;
                            }
                        }
                        // If columns have a dynamic width, scan the columns we are about to render.
                        // If any have not yet been measured, then we need to render all rows initially,
                        // Because the width of the column is equal to the widest cell within that column,
                        // (And so we can't know the width without measuring all row-cells first).
                        if (!deferredMeasurementCache.hasFixedWidth()) {
                            for(var columnIndex = columnStartIndex; columnIndex <= columnStopIndex; columnIndex++)if (!deferredMeasurementCache.has(0, columnIndex)) {
                                rowStartIndex = 0;
                                rowStopIndex = rowCount - 1;
                                break;
                            }
                        }
                    }
                    this._childrenToDisplay = cellRangeRenderer({
                        cellCache: this._cellCache,
                        cellRenderer: cellRenderer,
                        columnSizeAndPositionManager: instanceProps.columnSizeAndPositionManager,
                        columnStartIndex: columnStartIndex,
                        columnStopIndex: columnStopIndex,
                        deferredMeasurementCache: deferredMeasurementCache,
                        horizontalOffsetAdjustment: horizontalOffsetAdjustment,
                        isScrolling: isScrolling,
                        isScrollingOptOut: isScrollingOptOut,
                        parent: this,
                        rowSizeAndPositionManager: instanceProps.rowSizeAndPositionManager,
                        rowStartIndex: rowStartIndex,
                        rowStopIndex: rowStopIndex,
                        scrollLeft: scrollLeft,
                        scrollTop: scrollTop,
                        styleCache: this._styleCache,
                        verticalOffsetAdjustment: verticalOffsetAdjustment,
                        visibleColumnIndices: visibleColumnIndices,
                        visibleRowIndices: visibleRowIndices
                    });
                    // update the indices
                    this._columnStartIndex = columnStartIndex;
                    this._columnStopIndex = columnStopIndex;
                    this._rowStartIndex = rowStartIndex;
                    this._rowStopIndex = rowStopIndex;
                }
            }
        },
        {
            key: '_debounceScrollEnded',
            value: function _debounceScrollEnded() {
                var scrollingResetTimeInterval = this.props.scrollingResetTimeInterval;
                if (this._disablePointerEventsTimeoutId) (0, $csq0B.cancelAnimationTimeout)(this._disablePointerEventsTimeoutId);
                this._disablePointerEventsTimeoutId = (0, $csq0B.requestAnimationTimeout)(this._debounceScrollEndedCallback, scrollingResetTimeInterval);
            }
        },
        {
            key: '_handleInvalidatedGridSize',
            /**
     * Check for batched CellMeasurer size invalidations.
     * This will occur the first time one or more previously unmeasured cells are rendered.
     */ value: function _handleInvalidatedGridSize() {
                if (typeof this._deferredInvalidateColumnIndex === 'number' && typeof this._deferredInvalidateRowIndex === 'number') {
                    var columnIndex = this._deferredInvalidateColumnIndex;
                    var rowIndex = this._deferredInvalidateRowIndex;
                    this._deferredInvalidateColumnIndex = null;
                    this._deferredInvalidateRowIndex = null;
                    this.recomputeGridSize({
                        columnIndex: columnIndex,
                        rowIndex: rowIndex
                    });
                }
            }
        },
        {
            key: '_invokeOnScrollMemoizer',
            value: function _invokeOnScrollMemoizer(_ref6) {
                var _this3 = this;
                var scrollLeft = _ref6.scrollLeft, scrollTop = _ref6.scrollTop, totalColumnsWidth = _ref6.totalColumnsWidth, totalRowsHeight = _ref6.totalRowsHeight;
                this._onScrollMemoizer({
                    callback: function callback(_ref7) {
                        var scrollLeft = _ref7.scrollLeft, scrollTop = _ref7.scrollTop;
                        var _props7 = _this3.props, height = _props7.height, onScroll = _props7.onScroll, width = _props7.width;
                        onScroll({
                            clientHeight: height,
                            clientWidth: width,
                            scrollHeight: totalRowsHeight,
                            scrollLeft: scrollLeft,
                            scrollTop: scrollTop,
                            scrollWidth: totalColumnsWidth
                        });
                    },
                    indices: {
                        scrollLeft: scrollLeft,
                        scrollTop: scrollTop
                    }
                });
            }
        },
        {
            key: '_isScrolling',
            value: function _isScrolling() {
                var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
                // If isScrolling is defined in props, use it to override the value in state
                // This is a performance optimization for WindowScroller + Grid
                return Object.hasOwnProperty.call(props, 'isScrolling') ? Boolean(props.isScrolling) : Boolean(state.isScrolling);
            }
        },
        {
            key: '_maybeCallOnScrollbarPresenceChange',
            value: function _maybeCallOnScrollbarPresenceChange() {
                if (this._scrollbarPresenceChanged) {
                    var _onScrollbarPresenceChange = this.props.onScrollbarPresenceChange;
                    this._scrollbarPresenceChanged = false;
                    _onScrollbarPresenceChange({
                        horizontal: this._horizontalScrollBarSize > 0,
                        size: this.state.instanceProps.scrollbarSize,
                        vertical: this._verticalScrollBarSize > 0
                    });
                }
            }
        },
        {
            key: 'scrollToPosition',
            /**
     * Scroll to the specified offset(s).
     * Useful for animating position changes.
     */ value: function scrollToPosition(_ref8) {
                var scrollLeft = _ref8.scrollLeft, scrollTop = _ref8.scrollTop;
                var stateUpdate = Grid._getScrollToPositionStateUpdate({
                    prevState: this.state,
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop
                });
                if (stateUpdate) {
                    stateUpdate.needToResetStyleCache = false;
                    this.setState(stateUpdate);
                }
            }
        },
        {
            key: '_getCalculatedScrollLeft',
            value: function _getCalculatedScrollLeft() {
                var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
                return Grid._getCalculatedScrollLeft(props, state);
            }
        },
        {
            key: '_updateScrollLeftForScrollToColumn',
            value: function _updateScrollLeftForScrollToColumn() {
                var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
                var stateUpdate = Grid._getScrollLeftForScrollToColumnStateUpdate(props, state);
                if (stateUpdate) {
                    stateUpdate.needToResetStyleCache = false;
                    this.setState(stateUpdate);
                }
            }
        },
        {
            key: '_getCalculatedScrollTop',
            value: function _getCalculatedScrollTop() {
                var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
                return Grid._getCalculatedScrollTop(props, state);
            }
        },
        {
            key: '_resetStyleCache',
            value: function _resetStyleCache() {
                var styleCache = this._styleCache;
                var cellCache = this._cellCache;
                var isScrollingOptOut = this.props.isScrollingOptOut;
                // Reset cell and style caches once scrolling stops.
                // This makes Grid simpler to use (since cells commonly change).
                // And it keeps the caches from growing too large.
                // Performance is most sensitive when a user is scrolling.
                // Don't clear visible cells from cellCache if isScrollingOptOut is specified.
                // This keeps the cellCache to a resonable size.
                this._cellCache = {};
                this._styleCache = {};
                // Copy over the visible cell styles so avoid unnecessary re-render.
                for(var rowIndex = this._rowStartIndex; rowIndex <= this._rowStopIndex; rowIndex++)for(var columnIndex = this._columnStartIndex; columnIndex <= this._columnStopIndex; columnIndex++){
                    var key = rowIndex + '-' + columnIndex;
                    this._styleCache[key] = styleCache[key];
                    if (isScrollingOptOut) this._cellCache[key] = cellCache[key];
                }
            }
        },
        {
            key: '_updateScrollTopForScrollToRow',
            value: function _updateScrollTopForScrollToRow() {
                var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
                var stateUpdate = Grid._getScrollTopForScrollToRowStateUpdate(props, state);
                if (stateUpdate) {
                    stateUpdate.needToResetStyleCache = false;
                    this.setState(stateUpdate);
                }
            }
        }
    ], [
        {
            key: 'getDerivedStateFromProps',
            value: function getDerivedStateFromProps(nextProps, prevState) {
                var newState = {};
                if (nextProps.columnCount === 0 && prevState.scrollLeft !== 0 || nextProps.rowCount === 0 && prevState.scrollTop !== 0) {
                    newState.scrollLeft = 0;
                    newState.scrollTop = 0;
                // only use scroll{Left,Top} from props if scrollTo{Column,Row} isn't specified
                // scrollTo{Column,Row} should override scroll{Left,Top}
                } else if (nextProps.scrollLeft !== prevState.scrollLeft && nextProps.scrollToColumn < 0 || nextProps.scrollTop !== prevState.scrollTop && nextProps.scrollToRow < 0) (0, $2a116e6b7adfcc6d$var$_assign2.default)(newState, Grid._getScrollToPositionStateUpdate({
                    prevState: prevState,
                    scrollLeft: nextProps.scrollLeft,
                    scrollTop: nextProps.scrollTop
                }));
                var instanceProps = prevState.instanceProps;
                // Initially we should not clearStyleCache
                newState.needToResetStyleCache = false;
                if (nextProps.columnWidth !== instanceProps.prevColumnWidth || nextProps.rowHeight !== instanceProps.prevRowHeight) // Reset cache. set it to {} in render
                newState.needToResetStyleCache = true;
                instanceProps.columnSizeAndPositionManager.configure({
                    cellCount: nextProps.columnCount,
                    estimatedCellSize: Grid._getEstimatedColumnSize(nextProps),
                    cellSizeGetter: Grid._wrapSizeGetter(nextProps.columnWidth)
                });
                instanceProps.rowSizeAndPositionManager.configure({
                    cellCount: nextProps.rowCount,
                    estimatedCellSize: Grid._getEstimatedRowSize(nextProps),
                    cellSizeGetter: Grid._wrapSizeGetter(nextProps.rowHeight)
                });
                if (instanceProps.prevColumnCount === 0 || instanceProps.prevRowCount === 0) {
                    instanceProps.prevColumnCount = 0;
                    instanceProps.prevRowCount = 0;
                }
                // If scrolling is controlled outside this component, clear cache when scrolling stops
                if (nextProps.autoHeight && nextProps.isScrolling === false && instanceProps.prevIsScrolling === true) (0, $2a116e6b7adfcc6d$var$_assign2.default)(newState, {
                    isScrolling: false
                });
                var maybeStateA = void 0;
                var maybeStateB = void 0;
                (0, $2a116e6b7adfcc6d$var$_calculateSizeAndPositionDataAndUpdateScrollOffset2.default)({
                    cellCount: instanceProps.prevColumnCount,
                    cellSize: typeof instanceProps.prevColumnWidth === 'number' ? instanceProps.prevColumnWidth : null,
                    computeMetadataCallback: function computeMetadataCallback() {
                        return instanceProps.columnSizeAndPositionManager.resetCell(0);
                    },
                    computeMetadataCallbackProps: nextProps,
                    nextCellsCount: nextProps.columnCount,
                    nextCellSize: typeof nextProps.columnWidth === 'number' ? nextProps.columnWidth : null,
                    nextScrollToIndex: nextProps.scrollToColumn,
                    scrollToIndex: instanceProps.prevScrollToColumn,
                    updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
                        maybeStateA = Grid._getScrollLeftForScrollToColumnStateUpdate(nextProps, prevState);
                    }
                });
                (0, $2a116e6b7adfcc6d$var$_calculateSizeAndPositionDataAndUpdateScrollOffset2.default)({
                    cellCount: instanceProps.prevRowCount,
                    cellSize: typeof instanceProps.prevRowHeight === 'number' ? instanceProps.prevRowHeight : null,
                    computeMetadataCallback: function computeMetadataCallback() {
                        return instanceProps.rowSizeAndPositionManager.resetCell(0);
                    },
                    computeMetadataCallbackProps: nextProps,
                    nextCellsCount: nextProps.rowCount,
                    nextCellSize: typeof nextProps.rowHeight === 'number' ? nextProps.rowHeight : null,
                    nextScrollToIndex: nextProps.scrollToRow,
                    scrollToIndex: instanceProps.prevScrollToRow,
                    updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
                        maybeStateB = Grid._getScrollTopForScrollToRowStateUpdate(nextProps, prevState);
                    }
                });
                instanceProps.prevColumnCount = nextProps.columnCount;
                instanceProps.prevColumnWidth = nextProps.columnWidth;
                instanceProps.prevIsScrolling = nextProps.isScrolling === true;
                instanceProps.prevRowCount = nextProps.rowCount;
                instanceProps.prevRowHeight = nextProps.rowHeight;
                instanceProps.prevScrollToColumn = nextProps.scrollToColumn;
                instanceProps.prevScrollToRow = nextProps.scrollToRow;
                // getting scrollBarSize (moved from componentWillMount)
                instanceProps.scrollbarSize = nextProps.getScrollbarSize();
                if (instanceProps.scrollbarSize === undefined) {
                    instanceProps.scrollbarSizeMeasured = false;
                    instanceProps.scrollbarSize = 0;
                } else instanceProps.scrollbarSizeMeasured = true;
                newState.instanceProps = instanceProps;
                return (0, $2a116e6b7adfcc6d$var$_extends3.default)({}, newState, maybeStateA, maybeStateB);
            }
        },
        {
            key: '_getEstimatedColumnSize',
            value: function _getEstimatedColumnSize(props) {
                return typeof props.columnWidth === 'number' ? props.columnWidth : props.estimatedColumnSize;
            }
        },
        {
            key: '_getEstimatedRowSize',
            value: function _getEstimatedRowSize(props) {
                return typeof props.rowHeight === 'number' ? props.rowHeight : props.estimatedRowSize;
            }
        },
        {
            key: '_getScrollToPositionStateUpdate',
            /**
     * Get the updated state after scrolling to
     * scrollLeft and scrollTop
     */ value: function _getScrollToPositionStateUpdate(_ref9) {
                var prevState = _ref9.prevState, scrollLeft = _ref9.scrollLeft, scrollTop = _ref9.scrollTop;
                var newState = {
                    scrollPositionChangeReason: $2a116e6b7adfcc6d$var$SCROLL_POSITION_CHANGE_REASONS.REQUESTED
                };
                if (typeof scrollLeft === 'number' && scrollLeft >= 0) {
                    newState.scrollDirectionHorizontal = scrollLeft > prevState.scrollLeft ? $5F8bn.SCROLL_DIRECTION_FORWARD : $5F8bn.SCROLL_DIRECTION_BACKWARD;
                    newState.scrollLeft = scrollLeft;
                }
                if (typeof scrollTop === 'number' && scrollTop >= 0) {
                    newState.scrollDirectionVertical = scrollTop > prevState.scrollTop ? $5F8bn.SCROLL_DIRECTION_FORWARD : $5F8bn.SCROLL_DIRECTION_BACKWARD;
                    newState.scrollTop = scrollTop;
                }
                if (typeof scrollLeft === 'number' && scrollLeft >= 0 && scrollLeft !== prevState.scrollLeft || typeof scrollTop === 'number' && scrollTop >= 0 && scrollTop !== prevState.scrollTop) return newState;
                return null;
            }
        },
        {
            key: '_wrapSizeGetter',
            value: function _wrapSizeGetter(value) {
                return typeof value === 'function' ? value : function() {
                    return value;
                };
            }
        },
        {
            key: '_getCalculatedScrollLeft',
            value: function _getCalculatedScrollLeft(nextProps, prevState) {
                var columnCount = nextProps.columnCount, height = nextProps.height, scrollToAlignment = nextProps.scrollToAlignment, scrollToColumn = nextProps.scrollToColumn, width = nextProps.width;
                var scrollLeft = prevState.scrollLeft, instanceProps = prevState.instanceProps;
                if (columnCount > 0) {
                    var finalColumn = columnCount - 1;
                    var targetIndex = scrollToColumn < 0 ? finalColumn : Math.min(finalColumn, scrollToColumn);
                    var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
                    var scrollBarSize = instanceProps.scrollbarSizeMeasured && totalRowsHeight > height ? instanceProps.scrollbarSize : 0;
                    return instanceProps.columnSizeAndPositionManager.getUpdatedOffsetForIndex({
                        align: scrollToAlignment,
                        containerSize: width - scrollBarSize,
                        currentOffset: scrollLeft,
                        targetIndex: targetIndex
                    });
                }
                return 0;
            }
        },
        {
            key: '_getScrollLeftForScrollToColumnStateUpdate',
            value: function _getScrollLeftForScrollToColumnStateUpdate(nextProps, prevState) {
                var scrollLeft = prevState.scrollLeft;
                var calculatedScrollLeft = Grid._getCalculatedScrollLeft(nextProps, prevState);
                if (typeof calculatedScrollLeft === 'number' && calculatedScrollLeft >= 0 && scrollLeft !== calculatedScrollLeft) return Grid._getScrollToPositionStateUpdate({
                    prevState: prevState,
                    scrollLeft: calculatedScrollLeft,
                    scrollTop: -1
                });
                return null;
            }
        },
        {
            key: '_getCalculatedScrollTop',
            value: function _getCalculatedScrollTop(nextProps, prevState) {
                var height = nextProps.height, rowCount = nextProps.rowCount, scrollToAlignment = nextProps.scrollToAlignment, scrollToRow = nextProps.scrollToRow, width = nextProps.width;
                var scrollTop = prevState.scrollTop, instanceProps = prevState.instanceProps;
                if (rowCount > 0) {
                    var finalRow = rowCount - 1;
                    var targetIndex = scrollToRow < 0 ? finalRow : Math.min(finalRow, scrollToRow);
                    var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
                    var scrollBarSize = instanceProps.scrollbarSizeMeasured && totalColumnsWidth > width ? instanceProps.scrollbarSize : 0;
                    return instanceProps.rowSizeAndPositionManager.getUpdatedOffsetForIndex({
                        align: scrollToAlignment,
                        containerSize: height - scrollBarSize,
                        currentOffset: scrollTop,
                        targetIndex: targetIndex
                    });
                }
                return 0;
            }
        },
        {
            key: '_getScrollTopForScrollToRowStateUpdate',
            value: function _getScrollTopForScrollToRowStateUpdate(nextProps, prevState) {
                var scrollTop = prevState.scrollTop;
                var calculatedScrollTop = Grid._getCalculatedScrollTop(nextProps, prevState);
                if (typeof calculatedScrollTop === 'number' && calculatedScrollTop >= 0 && scrollTop !== calculatedScrollTop) return Grid._getScrollToPositionStateUpdate({
                    prevState: prevState,
                    scrollLeft: -1,
                    scrollTop: calculatedScrollTop
                });
                return null;
            }
        }
    ]);
    return Grid;
}($2a116e6b7adfcc6d$var$React.PureComponent);
$2a116e6b7adfcc6d$var$Grid.defaultProps = {
    'aria-label': 'grid',
    'aria-readonly': true,
    autoContainerWidth: false,
    autoHeight: false,
    autoWidth: false,
    cellRangeRenderer: $2a116e6b7adfcc6d$var$_defaultCellRangeRenderer2.default,
    containerRole: 'rowgroup',
    containerStyle: {},
    estimatedColumnSize: 100,
    estimatedRowSize: 30,
    getScrollbarSize: $2a116e6b7adfcc6d$var$_scrollbarSize2.default,
    noContentRenderer: $2a116e6b7adfcc6d$var$renderNull,
    onScroll: function onScroll() {},
    onScrollbarPresenceChange: function onScrollbarPresenceChange() {},
    onSectionRendered: function onSectionRendered() {},
    overscanColumnCount: 0,
    overscanIndicesGetter: $2a116e6b7adfcc6d$var$_defaultOverscanIndicesGetter2.default,
    overscanRowCount: 10,
    role: 'grid',
    scrollingResetTimeInterval: $2a116e6b7adfcc6d$var$DEFAULT_SCROLLING_RESET_TIME_INTERVAL,
    scrollToAlignment: 'auto',
    scrollToColumn: -1,
    scrollToRow: -1,
    style: {},
    tabIndex: 0,
    isScrollingOptOut: false
};
$2a116e6b7adfcc6d$var$Grid.propTypes = null;
(0, $b4FuJ.polyfill)($2a116e6b7adfcc6d$var$Grid);
module.exports.default = $2a116e6b7adfcc6d$var$Grid;

});
parcelRegister("frReV", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "clsx", () => $02e702ca0c5d0b54$export$4f5d2d50c9deca37);
$parcel$export(module.exports, "default", () => $02e702ca0c5d0b54$export$2e2bcd8739ae039);
function $02e702ca0c5d0b54$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $02e702ca0c5d0b54$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $02e702ca0c5d0b54$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $02e702ca0c5d0b54$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $02e702ca0c5d0b54$export$2e2bcd8739ae039 = $02e702ca0c5d0b54$export$4f5d2d50c9deca37;

});

parcelRegister("lcv9d", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f6f2e13ec4da8ccb$var$calculateSizeAndPositionDataAndUpdateScrollOffset;
function $f6f2e13ec4da8ccb$var$calculateSizeAndPositionDataAndUpdateScrollOffset(_ref) {
    var cellCount = _ref.cellCount, cellSize = _ref.cellSize, computeMetadataCallback = _ref.computeMetadataCallback, computeMetadataCallbackProps = _ref.computeMetadataCallbackProps, nextCellsCount = _ref.nextCellsCount, nextCellSize = _ref.nextCellSize, nextScrollToIndex = _ref.nextScrollToIndex, scrollToIndex = _ref.scrollToIndex, updateScrollOffsetForScrollToIndex = _ref.updateScrollOffsetForScrollToIndex;
    // Don't compare cell sizes if they are functions because inline functions would cause infinite loops.
    // In that event users should use the manual recompute methods to inform of changes.
    if (cellCount !== nextCellsCount || (typeof cellSize === 'number' || typeof nextCellSize === 'number') && cellSize !== nextCellSize) {
        computeMetadataCallback(computeMetadataCallbackProps);
        // Updated cell metadata may have hidden the previous scrolled-to item.
        // In this case we should also update the scrollTop to ensure it stays visible.
        if (scrollToIndex >= 0 && scrollToIndex === nextScrollToIndex) updateScrollOffsetForScrollToIndex();
    }
} /**
 * Helper method that determines when to recalculate row or column metadata.
 */ 

});

parcelRegister("bNRtZ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $5qr3v = parcelRequire("5qr3v");
var $897dc1dceff349a9$var$_objectWithoutProperties3 = $897dc1dceff349a9$var$_interopRequireDefault($5qr3v);

var $jK0mf = parcelRequire("jK0mf");
var $897dc1dceff349a9$var$_classCallCheck3 = $897dc1dceff349a9$var$_interopRequireDefault($jK0mf);

var $7kKnu = parcelRequire("7kKnu");
var $897dc1dceff349a9$var$_createClass3 = $897dc1dceff349a9$var$_interopRequireDefault($7kKnu);

var $hoayS = parcelRequire("hoayS");
var $897dc1dceff349a9$var$_CellSizeAndPositionManager2 = $897dc1dceff349a9$var$_interopRequireDefault($hoayS);

var $ljP9U = parcelRequire("ljP9U");
parcelRequire("5XjzC");
function $897dc1dceff349a9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Extends CellSizeAndPositionManager and adds scaling behavior for lists that are too large to fit within a browser's native limits.
 */ /**
 * Browsers have scroll offset limitations (eg Chrome stops scrolling at ~33.5M pixels where as Edge tops out at ~1.5M pixels).
 * After a certain position, the browser won't allow the user to scroll further (even via JavaScript scroll offset adjustments).
 * This util picks a lower ceiling for max size and artificially adjusts positions within to make it transparent for users.
 */ var $897dc1dceff349a9$var$ScalingCellSizeAndPositionManager = function() {
    function ScalingCellSizeAndPositionManager(_ref) {
        var _ref$maxScrollSize = _ref.maxScrollSize, maxScrollSize = _ref$maxScrollSize === undefined ? (0, $ljP9U.getMaxElementSize)() : _ref$maxScrollSize, params = (0, $897dc1dceff349a9$var$_objectWithoutProperties3.default)(_ref, [
            'maxScrollSize'
        ]);
        (0, $897dc1dceff349a9$var$_classCallCheck3.default)(this, ScalingCellSizeAndPositionManager);
        // Favor composition over inheritance to simplify IE10 support
        this._cellSizeAndPositionManager = new $897dc1dceff349a9$var$_CellSizeAndPositionManager2.default(params);
        this._maxScrollSize = maxScrollSize;
    }
    (0, $897dc1dceff349a9$var$_createClass3.default)(ScalingCellSizeAndPositionManager, [
        {
            key: 'areOffsetsAdjusted',
            value: function areOffsetsAdjusted() {
                return this._cellSizeAndPositionManager.getTotalSize() > this._maxScrollSize;
            }
        },
        {
            key: 'configure',
            value: function configure(params) {
                this._cellSizeAndPositionManager.configure(params);
            }
        },
        {
            key: 'getCellCount',
            value: function getCellCount() {
                return this._cellSizeAndPositionManager.getCellCount();
            }
        },
        {
            key: 'getEstimatedCellSize',
            value: function getEstimatedCellSize() {
                return this._cellSizeAndPositionManager.getEstimatedCellSize();
            }
        },
        {
            key: 'getLastMeasuredIndex',
            value: function getLastMeasuredIndex() {
                return this._cellSizeAndPositionManager.getLastMeasuredIndex();
            }
        },
        {
            key: 'getOffsetAdjustment',
            value: function getOffsetAdjustment(_ref2) {
                var containerSize = _ref2.containerSize, offset = _ref2.offset;
                var totalSize = this._cellSizeAndPositionManager.getTotalSize();
                var safeTotalSize = this.getTotalSize();
                var offsetPercentage = this._getOffsetPercentage({
                    containerSize: containerSize,
                    offset: offset,
                    totalSize: safeTotalSize
                });
                return Math.round(offsetPercentage * (safeTotalSize - totalSize));
            }
        },
        {
            key: 'getSizeAndPositionOfCell',
            value: function getSizeAndPositionOfCell(index) {
                return this._cellSizeAndPositionManager.getSizeAndPositionOfCell(index);
            }
        },
        {
            key: 'getSizeAndPositionOfLastMeasuredCell',
            value: function getSizeAndPositionOfLastMeasuredCell() {
                return this._cellSizeAndPositionManager.getSizeAndPositionOfLastMeasuredCell();
            }
        },
        {
            key: 'getTotalSize',
            value: function getTotalSize() {
                return Math.min(this._maxScrollSize, this._cellSizeAndPositionManager.getTotalSize());
            }
        },
        {
            key: 'getUpdatedOffsetForIndex',
            value: function getUpdatedOffsetForIndex(_ref3) {
                var _ref3$align = _ref3.align, align = _ref3$align === undefined ? 'auto' : _ref3$align, containerSize = _ref3.containerSize, currentOffset = _ref3.currentOffset, targetIndex = _ref3.targetIndex;
                currentOffset = this._safeOffsetToOffset({
                    containerSize: containerSize,
                    offset: currentOffset
                });
                var offset = this._cellSizeAndPositionManager.getUpdatedOffsetForIndex({
                    align: align,
                    containerSize: containerSize,
                    currentOffset: currentOffset,
                    targetIndex: targetIndex
                });
                return this._offsetToSafeOffset({
                    containerSize: containerSize,
                    offset: offset
                });
            }
        },
        {
            key: 'getVisibleCellRange',
            value: function getVisibleCellRange(_ref4) {
                var containerSize = _ref4.containerSize, offset = _ref4.offset;
                offset = this._safeOffsetToOffset({
                    containerSize: containerSize,
                    offset: offset
                });
                return this._cellSizeAndPositionManager.getVisibleCellRange({
                    containerSize: containerSize,
                    offset: offset
                });
            }
        },
        {
            key: 'resetCell',
            value: function resetCell(index) {
                this._cellSizeAndPositionManager.resetCell(index);
            }
        },
        {
            key: '_getOffsetPercentage',
            value: function _getOffsetPercentage(_ref5) {
                var containerSize = _ref5.containerSize, offset = _ref5.offset, totalSize = _ref5.totalSize;
                return totalSize <= containerSize ? 0 : offset / (totalSize - containerSize);
            }
        },
        {
            key: '_offsetToSafeOffset',
            value: function _offsetToSafeOffset(_ref6) {
                var containerSize = _ref6.containerSize, offset = _ref6.offset;
                var totalSize = this._cellSizeAndPositionManager.getTotalSize();
                var safeTotalSize = this.getTotalSize();
                if (totalSize === safeTotalSize) return offset;
                else {
                    var offsetPercentage = this._getOffsetPercentage({
                        containerSize: containerSize,
                        offset: offset,
                        totalSize: totalSize
                    });
                    return Math.round(offsetPercentage * (safeTotalSize - containerSize));
                }
            }
        },
        {
            key: '_safeOffsetToOffset',
            value: function _safeOffsetToOffset(_ref7) {
                var containerSize = _ref7.containerSize, offset = _ref7.offset;
                var totalSize = this._cellSizeAndPositionManager.getTotalSize();
                var safeTotalSize = this.getTotalSize();
                if (totalSize === safeTotalSize) return offset;
                else {
                    var offsetPercentage = this._getOffsetPercentage({
                        containerSize: containerSize,
                        offset: offset,
                        totalSize: safeTotalSize
                    });
                    return Math.round(offsetPercentage * (totalSize - containerSize));
                }
            }
        }
    ]);
    return ScalingCellSizeAndPositionManager;
}();
module.exports.default = $897dc1dceff349a9$var$ScalingCellSizeAndPositionManager;

});
parcelRegister("5qr3v", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $3f345e2494beb275$export$1e511d4a378977f5, (v) => $3f345e2494beb275$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $3f345e2494beb275$export$2e2bcd8739ae039, (v) => $3f345e2494beb275$export$2e2bcd8739ae039 = v);
var $3f345e2494beb275$export$1e511d4a378977f5;
var $3f345e2494beb275$export$2e2bcd8739ae039;
"use strict";
$3f345e2494beb275$export$1e511d4a378977f5 = true;
$3f345e2494beb275$export$2e2bcd8739ae039 = function(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
};

});

parcelRegister("hoayS", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $jK0mf = parcelRequire("jK0mf");
var $ca8cdee274c95e93$var$_classCallCheck3 = $ca8cdee274c95e93$var$_interopRequireDefault($jK0mf);

var $7kKnu = parcelRequire("7kKnu");
var $ca8cdee274c95e93$var$_createClass3 = $ca8cdee274c95e93$var$_interopRequireDefault($7kKnu);
parcelRequire("5XjzC");
function $ca8cdee274c95e93$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Just-in-time calculates and caches size and position information for a collection of cells.
 */ var $ca8cdee274c95e93$var$CellSizeAndPositionManager = function() {
    // Used in deferred mode to track which cells have been queued for measurement.
    // Cache of size and position data for cells, mapped by cell index.
    // Note that invalid values may exist in this map so only rely on cells up to this._lastMeasuredIndex
    function CellSizeAndPositionManager(_ref) {
        var cellCount = _ref.cellCount, cellSizeGetter = _ref.cellSizeGetter, estimatedCellSize = _ref.estimatedCellSize;
        (0, $ca8cdee274c95e93$var$_classCallCheck3.default)(this, CellSizeAndPositionManager);
        this._cellSizeAndPositionData = {};
        this._lastMeasuredIndex = -1;
        this._lastBatchedIndex = -1;
        this._cellSizeGetter = cellSizeGetter;
        this._cellCount = cellCount;
        this._estimatedCellSize = estimatedCellSize;
    }
    // Measurements for cells up to this index can be trusted; cells afterward should be estimated.
    (0, $ca8cdee274c95e93$var$_createClass3.default)(CellSizeAndPositionManager, [
        {
            key: 'areOffsetsAdjusted',
            value: function areOffsetsAdjusted() {
                return false;
            }
        },
        {
            key: 'configure',
            value: function configure(_ref2) {
                var cellCount = _ref2.cellCount, estimatedCellSize = _ref2.estimatedCellSize, cellSizeGetter = _ref2.cellSizeGetter;
                this._cellCount = cellCount;
                this._estimatedCellSize = estimatedCellSize;
                this._cellSizeGetter = cellSizeGetter;
            }
        },
        {
            key: 'getCellCount',
            value: function getCellCount() {
                return this._cellCount;
            }
        },
        {
            key: 'getEstimatedCellSize',
            value: function getEstimatedCellSize() {
                return this._estimatedCellSize;
            }
        },
        {
            key: 'getLastMeasuredIndex',
            value: function getLastMeasuredIndex() {
                return this._lastMeasuredIndex;
            }
        },
        {
            key: 'getOffsetAdjustment',
            value: function getOffsetAdjustment() {
                return 0;
            }
        },
        {
            key: 'getSizeAndPositionOfCell',
            value: function getSizeAndPositionOfCell(index) {
                if (index < 0 || index >= this._cellCount) throw Error('Requested index ' + index + ' is outside of range 0..' + this._cellCount);
                if (index > this._lastMeasuredIndex) {
                    var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
                    var _offset = lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size;
                    for(var i = this._lastMeasuredIndex + 1; i <= index; i++){
                        var _size = this._cellSizeGetter({
                            index: i
                        });
                        // undefined or NaN probably means a logic error in the size getter.
                        // null means we're using CellMeasurer and haven't yet measured a given index.
                        if (_size === undefined || isNaN(_size)) throw Error('Invalid size returned for cell ' + i + ' of value ' + _size);
                        else if (_size === null) {
                            this._cellSizeAndPositionData[i] = {
                                offset: _offset,
                                size: 0
                            };
                            this._lastBatchedIndex = index;
                        } else {
                            this._cellSizeAndPositionData[i] = {
                                offset: _offset,
                                size: _size
                            };
                            _offset += _size;
                            this._lastMeasuredIndex = index;
                        }
                    }
                }
                return this._cellSizeAndPositionData[index];
            }
        },
        {
            key: 'getSizeAndPositionOfLastMeasuredCell',
            value: function getSizeAndPositionOfLastMeasuredCell() {
                return this._lastMeasuredIndex >= 0 ? this._cellSizeAndPositionData[this._lastMeasuredIndex] : {
                    offset: 0,
                    size: 0
                };
            }
        },
        {
            key: 'getTotalSize',
            value: function getTotalSize() {
                var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
                var totalSizeOfMeasuredCells = lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size;
                var numUnmeasuredCells = this._cellCount - this._lastMeasuredIndex - 1;
                var totalSizeOfUnmeasuredCells = numUnmeasuredCells * this._estimatedCellSize;
                return totalSizeOfMeasuredCells + totalSizeOfUnmeasuredCells;
            }
        },
        {
            key: 'getUpdatedOffsetForIndex',
            value: function getUpdatedOffsetForIndex(_ref3) {
                var _ref3$align = _ref3.align, align = _ref3$align === undefined ? 'auto' : _ref3$align, containerSize = _ref3.containerSize, currentOffset = _ref3.currentOffset, targetIndex = _ref3.targetIndex;
                if (containerSize <= 0) return 0;
                var datum = this.getSizeAndPositionOfCell(targetIndex);
                var maxOffset = datum.offset;
                var minOffset = maxOffset - containerSize + datum.size;
                var idealOffset = void 0;
                switch(align){
                    case 'start':
                        idealOffset = maxOffset;
                        break;
                    case 'end':
                        idealOffset = minOffset;
                        break;
                    case 'center':
                        idealOffset = maxOffset - (containerSize - datum.size) / 2;
                        break;
                    default:
                        idealOffset = Math.max(minOffset, Math.min(maxOffset, currentOffset));
                        break;
                }
                var totalSize = this.getTotalSize();
                return Math.max(0, Math.min(totalSize - containerSize, idealOffset));
            }
        },
        {
            key: 'getVisibleCellRange',
            value: function getVisibleCellRange(params) {
                var containerSize = params.containerSize, offset = params.offset;
                var totalSize = this.getTotalSize();
                if (totalSize === 0) return {};
                var maxOffset = offset + containerSize;
                var start = this._findNearestCell(offset);
                var datum = this.getSizeAndPositionOfCell(start);
                offset = datum.offset + datum.size;
                var stop = start;
                while(offset < maxOffset && stop < this._cellCount - 1){
                    stop++;
                    offset += this.getSizeAndPositionOfCell(stop).size;
                }
                return {
                    start: start,
                    stop: stop
                };
            }
        },
        {
            key: 'resetCell',
            value: function resetCell(index) {
                this._lastMeasuredIndex = Math.min(this._lastMeasuredIndex, index - 1);
            }
        },
        {
            key: '_binarySearch',
            value: function _binarySearch(high, low, offset) {
                while(low <= high){
                    var middle = low + Math.floor((high - low) / 2);
                    var _currentOffset = this.getSizeAndPositionOfCell(middle).offset;
                    if (_currentOffset === offset) return middle;
                    else if (_currentOffset < offset) low = middle + 1;
                    else if (_currentOffset > offset) high = middle - 1;
                }
                if (low > 0) return low - 1;
                else return 0;
            }
        },
        {
            key: '_exponentialSearch',
            value: function _exponentialSearch(index, offset) {
                var interval = 1;
                while(index < this._cellCount && this.getSizeAndPositionOfCell(index).offset < offset){
                    index += interval;
                    interval *= 2;
                }
                return this._binarySearch(Math.min(index, this._cellCount - 1), Math.floor(index / 2), offset);
            }
        },
        {
            key: '_findNearestCell',
            value: function _findNearestCell(offset) {
                if (isNaN(offset)) throw Error('Invalid offset ' + offset + ' specified');
                // Our search algorithms find the nearest match at or below the specified offset.
                // So make sure the offset is at least 0 or no match will be found.
                offset = Math.max(0, offset);
                var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
                var lastMeasuredIndex = Math.max(0, this._lastMeasuredIndex);
                if (lastMeasuredCellSizeAndPosition.offset >= offset) // If we've already measured cells within this range just use a binary search as it's faster.
                return this._binarySearch(lastMeasuredIndex, 0, offset);
                else // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
                // The exponential search avoids pre-computing sizes for the full set of cells as a binary search would.
                // The overall complexity for this approach is O(log n).
                return this._exponentialSearch(lastMeasuredIndex, offset);
            }
        }
    ]);
    return CellSizeAndPositionManager;
}();
module.exports.default = $ca8cdee274c95e93$var$CellSizeAndPositionManager;

});
parcelRegister("5XjzC", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bpfrpt_proptype_VisibleCellRange = module.exports.bpfrpt_proptype_Alignment = module.exports.bpfrpt_proptype_OverscanIndicesGetter = module.exports.bpfrpt_proptype_OverscanIndices = module.exports.bpfrpt_proptype_OverscanIndicesGetterParams = module.exports.bpfrpt_proptype_RenderedSection = module.exports.bpfrpt_proptype_ScrollbarPresenceChange = module.exports.bpfrpt_proptype_Scroll = module.exports.bpfrpt_proptype_NoContentRenderer = module.exports.bpfrpt_proptype_CellSize = module.exports.bpfrpt_proptype_CellSizeGetter = module.exports.bpfrpt_proptype_CellRangeRenderer = module.exports.bpfrpt_proptype_CellRangeRendererParams = module.exports.bpfrpt_proptype_StyleCache = module.exports.bpfrpt_proptype_CellCache = module.exports.bpfrpt_proptype_CellRenderer = module.exports.bpfrpt_proptype_CellRendererParams = module.exports.bpfrpt_proptype_CellPosition = undefined;

var $eJOHy = parcelRequire("eJOHy");
var $4561a5562e7eef46$var$React = $4561a5562e7eef46$var$_interopRequireWildcard($eJOHy);

var $bNRtZ = parcelRequire("bNRtZ");
var $4561a5562e7eef46$var$_ScalingCellSizeAndPositionManager2 = $4561a5562e7eef46$var$_interopRequireDefault($bNRtZ);

var $cT3Ey = parcelRequire("cT3Ey");
var $4561a5562e7eef46$var$_propTypes2 = $4561a5562e7eef46$var$_interopRequireDefault($cT3Ey);
function $4561a5562e7eef46$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $4561a5562e7eef46$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
var $4561a5562e7eef46$var$bpfrpt_proptype_CellPosition = null;
var $4561a5562e7eef46$var$bpfrpt_proptype_CellRendererParams = null;
var $4561a5562e7eef46$var$bpfrpt_proptype_CellRenderer = null;
var $4561a5562e7eef46$var$bpfrpt_proptype_CellCache = null;
var $4561a5562e7eef46$var$bpfrpt_proptype_StyleCache = null;
var $4561a5562e7eef46$var$bpfrpt_proptype_CellRangeRendererParams = null;
var $4561a5562e7eef46$var$bpfrpt_proptype_CellRangeRenderer = null;
var $4561a5562e7eef46$var$bpfrpt_proptype_CellSizeGetter = null;
var $4561a5562e7eef46$var$bpfrpt_proptype_CellSize = null;
var $4561a5562e7eef46$var$bpfrpt_proptype_NoContentRenderer = null;
var $4561a5562e7eef46$var$bpfrpt_proptype_Scroll = null;
var $4561a5562e7eef46$var$bpfrpt_proptype_ScrollbarPresenceChange = null;
var $4561a5562e7eef46$var$bpfrpt_proptype_RenderedSection = null;
var $4561a5562e7eef46$var$bpfrpt_proptype_OverscanIndicesGetterParams = null;
var $4561a5562e7eef46$var$bpfrpt_proptype_OverscanIndices = null;
var $4561a5562e7eef46$var$bpfrpt_proptype_OverscanIndicesGetter = null;
var $4561a5562e7eef46$var$bpfrpt_proptype_Alignment = null;
var $4561a5562e7eef46$var$bpfrpt_proptype_VisibleCellRange = null;
module.exports.bpfrpt_proptype_CellPosition = $4561a5562e7eef46$var$bpfrpt_proptype_CellPosition;
module.exports.bpfrpt_proptype_CellRendererParams = $4561a5562e7eef46$var$bpfrpt_proptype_CellRendererParams;
module.exports.bpfrpt_proptype_CellRenderer = $4561a5562e7eef46$var$bpfrpt_proptype_CellRenderer;
module.exports.bpfrpt_proptype_CellCache = $4561a5562e7eef46$var$bpfrpt_proptype_CellCache;
module.exports.bpfrpt_proptype_StyleCache = $4561a5562e7eef46$var$bpfrpt_proptype_StyleCache;
module.exports.bpfrpt_proptype_CellRangeRendererParams = $4561a5562e7eef46$var$bpfrpt_proptype_CellRangeRendererParams;
module.exports.bpfrpt_proptype_CellRangeRenderer = $4561a5562e7eef46$var$bpfrpt_proptype_CellRangeRenderer;
module.exports.bpfrpt_proptype_CellSizeGetter = $4561a5562e7eef46$var$bpfrpt_proptype_CellSizeGetter;
module.exports.bpfrpt_proptype_CellSize = $4561a5562e7eef46$var$bpfrpt_proptype_CellSize;
module.exports.bpfrpt_proptype_NoContentRenderer = $4561a5562e7eef46$var$bpfrpt_proptype_NoContentRenderer;
module.exports.bpfrpt_proptype_Scroll = $4561a5562e7eef46$var$bpfrpt_proptype_Scroll;
module.exports.bpfrpt_proptype_ScrollbarPresenceChange = $4561a5562e7eef46$var$bpfrpt_proptype_ScrollbarPresenceChange;
module.exports.bpfrpt_proptype_RenderedSection = $4561a5562e7eef46$var$bpfrpt_proptype_RenderedSection;
module.exports.bpfrpt_proptype_OverscanIndicesGetterParams = $4561a5562e7eef46$var$bpfrpt_proptype_OverscanIndicesGetterParams;
module.exports.bpfrpt_proptype_OverscanIndices = $4561a5562e7eef46$var$bpfrpt_proptype_OverscanIndices;
module.exports.bpfrpt_proptype_OverscanIndicesGetter = $4561a5562e7eef46$var$bpfrpt_proptype_OverscanIndicesGetter;
module.exports.bpfrpt_proptype_Alignment = $4561a5562e7eef46$var$bpfrpt_proptype_Alignment;
module.exports.bpfrpt_proptype_VisibleCellRange = $4561a5562e7eef46$var$bpfrpt_proptype_VisibleCellRange;

});


parcelRegister("ljP9U", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $f8530e60fe6fe659$var$DEFAULT_MAX_ELEMENT_SIZE = 1500000;
var $f8530e60fe6fe659$var$CHROME_MAX_ELEMENT_SIZE = 1.67771e7;
var $f8530e60fe6fe659$var$isBrowser = function isBrowser() {
    return typeof window !== 'undefined';
};
var $f8530e60fe6fe659$var$isChrome = function isChrome() {
    return !!window.chrome;
};
var $f8530e60fe6fe659$var$getMaxElementSize = module.exports.getMaxElementSize = function getMaxElementSize() {
    if ($f8530e60fe6fe659$var$isBrowser()) {
        if ($f8530e60fe6fe659$var$isChrome()) return $f8530e60fe6fe659$var$CHROME_MAX_ELEMENT_SIZE;
    }
    return $f8530e60fe6fe659$var$DEFAULT_MAX_ELEMENT_SIZE;
};

});


parcelRegister("cV315", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $cmcDV = parcelRequire("cmcDV");
var $967d25e6933cccd2$var$_keys2 = $967d25e6933cccd2$var$_interopRequireDefault($cmcDV);
module.exports.default = $967d25e6933cccd2$var$createCallbackMemoizer;
function $967d25e6933cccd2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Helper utility that updates the specified callback whenever any of the specified indices have changed.
 */ function $967d25e6933cccd2$var$createCallbackMemoizer() {
    var requireAllKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var cachedIndices = {};
    return function(_ref) {
        var callback = _ref.callback, indices = _ref.indices;
        var keys = (0, $967d25e6933cccd2$var$_keys2.default)(indices);
        var allInitialized = !requireAllKeys || keys.every(function(key) {
            var value = indices[key];
            return Array.isArray(value) ? value.length > 0 : value >= 0;
        });
        var indexChanged = keys.length !== (0, $967d25e6933cccd2$var$_keys2.default)(cachedIndices).length || keys.some(function(key) {
            var cachedValue = cachedIndices[key];
            var value = indices[key];
            return Array.isArray(value) ? cachedValue.join(',') !== value.join(',') : cachedValue !== value;
        });
        cachedIndices = indices;
        if (allInitialized && indexChanged) callback(indices);
    };
}

});
parcelRegister("cmcDV", function(module, exports) {

module.exports = {
    "default": (parcelRequire("dDtJM")),
    __esModule: true
};

});
parcelRegister("dDtJM", function(module, exports) {
parcelRequire("3nRiT");

module.exports = (parcelRequire("h9BqL")).Object.keys;

});
parcelRegister("3nRiT", function(module, exports) {
// 19.1.2.14 Object.keys(O)

var $9IOcn = parcelRequire("9IOcn");

var $f49xG = parcelRequire("f49xG");

(parcelRequire("6rscv"))('keys', function() {
    return function keys(it) {
        return $f49xG($9IOcn(it));
    };
});

});




parcelRegister("5F8bn", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SCROLL_DIRECTION_VERTICAL = module.exports.SCROLL_DIRECTION_HORIZONTAL = module.exports.SCROLL_DIRECTION_FORWARD = module.exports.SCROLL_DIRECTION_BACKWARD = undefined;
module.exports.default = $41f720fbdada94bc$var$defaultOverscanIndicesGetter;
parcelRequire("5XjzC");
var $41f720fbdada94bc$var$SCROLL_DIRECTION_BACKWARD = module.exports.SCROLL_DIRECTION_BACKWARD = -1;
var $41f720fbdada94bc$var$SCROLL_DIRECTION_FORWARD = module.exports.SCROLL_DIRECTION_FORWARD = 1;
var $41f720fbdada94bc$var$SCROLL_DIRECTION_HORIZONTAL = module.exports.SCROLL_DIRECTION_HORIZONTAL = 'horizontal';
var $41f720fbdada94bc$var$SCROLL_DIRECTION_VERTICAL = module.exports.SCROLL_DIRECTION_VERTICAL = 'vertical';
/**
 * Calculates the number of cells to overscan before and after a specified range.
 * This function ensures that overscanning doesn't exceed the available cells.
 */ function $41f720fbdada94bc$var$defaultOverscanIndicesGetter(_ref) {
    var cellCount = _ref.cellCount, overscanCellsCount = _ref.overscanCellsCount, scrollDirection = _ref.scrollDirection, startIndex = _ref.startIndex, stopIndex = _ref.stopIndex;
    if (scrollDirection === $41f720fbdada94bc$var$SCROLL_DIRECTION_FORWARD) return {
        overscanStartIndex: Math.max(0, startIndex),
        overscanStopIndex: Math.min(cellCount - 1, stopIndex + overscanCellsCount)
    };
    else return {
        overscanStartIndex: Math.max(0, startIndex - overscanCellsCount),
        overscanStopIndex: Math.min(cellCount - 1, stopIndex)
    };
}

});

parcelRegister("co45v", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $904ae5aeca2dd9e3$var$updateScrollIndexHelper;

var $bNRtZ = parcelRequire("bNRtZ");
var $904ae5aeca2dd9e3$var$_ScalingCellSizeAndPositionManager2 = $904ae5aeca2dd9e3$var$_interopRequireDefault($bNRtZ);
parcelRequire("5XjzC");
function $904ae5aeca2dd9e3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Helper function that determines when to update scroll offsets to ensure that a scroll-to-index remains visible.
 * This function also ensures that the scroll ofset isn't past the last column/row of cells.
 */ function $904ae5aeca2dd9e3$var$updateScrollIndexHelper(_ref) {
    var cellSize = _ref.cellSize, cellSizeAndPositionManager = _ref.cellSizeAndPositionManager, previousCellsCount = _ref.previousCellsCount, previousCellSize = _ref.previousCellSize, previousScrollToAlignment = _ref.previousScrollToAlignment, previousScrollToIndex = _ref.previousScrollToIndex, previousSize = _ref.previousSize, scrollOffset = _ref.scrollOffset, scrollToAlignment = _ref.scrollToAlignment, scrollToIndex = _ref.scrollToIndex, size = _ref.size, sizeJustIncreasedFromZero = _ref.sizeJustIncreasedFromZero, updateScrollIndexCallback = _ref.updateScrollIndexCallback;
    var cellCount = cellSizeAndPositionManager.getCellCount();
    var hasScrollToIndex = scrollToIndex >= 0 && scrollToIndex < cellCount;
    var sizeHasChanged = size !== previousSize || sizeJustIncreasedFromZero || !previousCellSize || typeof cellSize === 'number' && cellSize !== previousCellSize;
    // If we have a new scroll target OR if height/row-height has changed,
    // We should ensure that the scroll target is visible.
    if (hasScrollToIndex && (sizeHasChanged || scrollToAlignment !== previousScrollToAlignment || scrollToIndex !== previousScrollToIndex)) updateScrollIndexCallback(scrollToIndex);
    else if (!hasScrollToIndex && cellCount > 0 && (size < previousSize || cellCount < previousCellsCount)) // We need to ensure that the current scroll offset is still within the collection's range.
    // To do this, we don't need to measure everything; CellMeasurer would perform poorly.
    // Just check to make sure we're still okay.
    // Only adjust the scroll position if we've scrolled below the last set of rows.
    {
        if (scrollOffset > cellSizeAndPositionManager.getTotalSize() - size) updateScrollIndexCallback(cellCount - 1);
    }
}

});

parcelRegister("4lqYK", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $329e0d01543fddb9$var$defaultCellRangeRenderer;
parcelRequire("5XjzC");
/**
 * Default implementation of cellRangeRenderer used by Grid.
 * This renderer supports cell-caching while the user is scrolling.
 */ function $329e0d01543fddb9$var$defaultCellRangeRenderer(_ref) {
    var cellCache = _ref.cellCache, cellRenderer = _ref.cellRenderer, columnSizeAndPositionManager = _ref.columnSizeAndPositionManager, columnStartIndex = _ref.columnStartIndex, columnStopIndex = _ref.columnStopIndex, deferredMeasurementCache = _ref.deferredMeasurementCache, horizontalOffsetAdjustment = _ref.horizontalOffsetAdjustment, isScrolling = _ref.isScrolling, isScrollingOptOut = _ref.isScrollingOptOut, parent = _ref.parent, rowSizeAndPositionManager = _ref.rowSizeAndPositionManager, rowStartIndex = _ref.rowStartIndex, rowStopIndex = _ref.rowStopIndex, styleCache = _ref.styleCache, verticalOffsetAdjustment = _ref.verticalOffsetAdjustment, visibleColumnIndices = _ref.visibleColumnIndices, visibleRowIndices = _ref.visibleRowIndices;
    var renderedCells = [];
    // Browsers have native size limits for elements (eg Chrome 33M pixels, IE 1.5M pixes).
    // User cannot scroll beyond these size limitations.
    // In order to work around this, ScalingCellSizeAndPositionManager compresses offsets.
    // We should never cache styles for compressed offsets though as this can lead to bugs.
    // See issue #576 for more.
    var areOffsetsAdjusted = columnSizeAndPositionManager.areOffsetsAdjusted() || rowSizeAndPositionManager.areOffsetsAdjusted();
    var canCacheStyle = !isScrolling && !areOffsetsAdjusted;
    for(var rowIndex = rowStartIndex; rowIndex <= rowStopIndex; rowIndex++){
        var rowDatum = rowSizeAndPositionManager.getSizeAndPositionOfCell(rowIndex);
        for(var columnIndex = columnStartIndex; columnIndex <= columnStopIndex; columnIndex++){
            var columnDatum = columnSizeAndPositionManager.getSizeAndPositionOfCell(columnIndex);
            var isVisible = columnIndex >= visibleColumnIndices.start && columnIndex <= visibleColumnIndices.stop && rowIndex >= visibleRowIndices.start && rowIndex <= visibleRowIndices.stop;
            var key = rowIndex + '-' + columnIndex;
            var style = void 0;
            // Cache style objects so shallow-compare doesn't re-render unnecessarily.
            if (canCacheStyle && styleCache[key]) style = styleCache[key];
            else // In deferred mode, cells will be initially rendered before we know their size.
            // Don't interfere with CellMeasurer's measurements by setting an invalid size.
            if (deferredMeasurementCache && !deferredMeasurementCache.has(rowIndex, columnIndex)) // Position not-yet-measured cells at top/left 0,0,
            // And give them width/height of 'auto' so they can grow larger than the parent Grid if necessary.
            // Positioning them further to the right/bottom influences their measured size.
            style = {
                height: 'auto',
                left: 0,
                position: 'absolute',
                top: 0,
                width: 'auto'
            };
            else {
                style = {
                    height: rowDatum.size,
                    left: columnDatum.offset + horizontalOffsetAdjustment,
                    position: 'absolute',
                    top: rowDatum.offset + verticalOffsetAdjustment,
                    width: columnDatum.size
                };
                styleCache[key] = style;
            }
            var cellRendererParams = {
                columnIndex: columnIndex,
                isScrolling: isScrolling,
                isVisible: isVisible,
                key: key,
                parent: parent,
                rowIndex: rowIndex,
                style: style
            };
            var renderedCell = void 0;
            // Avoid re-creating cells while scrolling.
            // This can lead to the same cell being created many times and can cause performance issues for "heavy" cells.
            // If a scroll is in progress- cache and reuse cells.
            // This cache will be thrown away once scrolling completes.
            // However if we are scaling scroll positions and sizes, we should also avoid caching.
            // This is because the offset changes slightly as scroll position changes and caching leads to stale values.
            // For more info refer to issue #395
            //
            // If isScrollingOptOut is specified, we always cache cells.
            // For more info refer to issue #1028
            if ((isScrollingOptOut || isScrolling) && !horizontalOffsetAdjustment && !verticalOffsetAdjustment) {
                if (!cellCache[key]) cellCache[key] = cellRenderer(cellRendererParams);
                renderedCell = cellCache[key];
            // If the user is no longer scrolling, don't cache cells.
            // This makes dynamic cell content difficult for users and would also lead to a heavier memory footprint.
            } else renderedCell = cellRenderer(cellRendererParams);
            if (renderedCell == null || renderedCell === false) continue;
            renderedCells.push(renderedCell);
        }
    }
    return renderedCells;
}
function $329e0d01543fddb9$var$warnAboutMissingStyle(parent, renderedCell) {}

});

parcelRegister("5YzJ9", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $459e450d69d7f007$export$2e2bcd8739ae039);

var $9MCmp = parcelRequire("9MCmp");
var $459e450d69d7f007$var$size;
function $459e450d69d7f007$export$2e2bcd8739ae039(recalc) {
    if (!$459e450d69d7f007$var$size && $459e450d69d7f007$var$size !== 0 || recalc) {
        if (0, $9MCmp.default) {
            var scrollDiv = document.createElement('div');
            scrollDiv.style.position = 'absolute';
            scrollDiv.style.top = '-9999px';
            scrollDiv.style.width = '50px';
            scrollDiv.style.height = '50px';
            scrollDiv.style.overflow = 'scroll';
            document.body.appendChild(scrollDiv);
            $459e450d69d7f007$var$size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
            document.body.removeChild(scrollDiv);
        }
    }
    return $459e450d69d7f007$var$size;
}

});
parcelRegister("9MCmp", function(module, exports) {

$parcel$export(module.exports, "default", () => $71f65a509935e3e4$export$2e2bcd8739ae039);
var $71f65a509935e3e4$export$2e2bcd8739ae039 = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

});


parcelRegister("b4FuJ", function(module, exports) {

$parcel$export(module.exports, "polyfill", () => $8100416702899bbe$export$cea1c58a6db52bca);
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $8100416702899bbe$var$componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function $8100416702899bbe$var$componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function $8100416702899bbe$var$componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
$8100416702899bbe$var$componentWillMount.__suppressDeprecationWarning = true;
$8100416702899bbe$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
$8100416702899bbe$var$componentWillUpdate.__suppressDeprecationWarning = true;
function $8100416702899bbe$export$cea1c58a6db52bca(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error('Can only polyfill class components');
    if (typeof Component.getDerivedStateFromProps !== 'function' && typeof prototype.getSnapshotBeforeUpdate !== 'function') return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === 'function') foundWillMountName = 'componentWillMount';
    else if (typeof prototype.UNSAFE_componentWillMount === 'function') foundWillMountName = 'UNSAFE_componentWillMount';
    if (typeof prototype.componentWillReceiveProps === 'function') foundWillReceivePropsName = 'componentWillReceiveProps';
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
    if (typeof prototype.componentWillUpdate === 'function') foundWillUpdateName = 'componentWillUpdate';
    else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') foundWillUpdateName = 'UNSAFE_componentWillUpdate';
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
        throw Error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + componentName + ' uses ' + newApiName + ' but also contains the following legacy lifecycles:' + (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') + (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') + (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') + '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-async-component-lifecycle-hooks');
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === 'function') {
        prototype.componentWillMount = $8100416702899bbe$var$componentWillMount;
        prototype.componentWillReceiveProps = $8100416702899bbe$var$componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
        if (typeof prototype.componentDidUpdate !== 'function') throw new Error('Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype');
        prototype.componentWillUpdate = $8100416702899bbe$var$componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}

});

parcelRegister("csq0B", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bpfrpt_proptype_AnimationTimeoutId = module.exports.requestAnimationTimeout = module.exports.cancelAnimationTimeout = undefined;

var $jAIsH = parcelRequire("jAIsH");
var $911c46544e85c4db$var$_promise2 = $911c46544e85c4db$var$_interopRequireDefault($jAIsH);

var $41HVR = parcelRequire("41HVR");

var $cT3Ey = parcelRequire("cT3Ey");
var $911c46544e85c4db$var$_propTypes2 = $911c46544e85c4db$var$_interopRequireDefault($cT3Ey);
function $911c46544e85c4db$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $911c46544e85c4db$var$bpfrpt_proptype_AnimationTimeoutId = null;
var $911c46544e85c4db$var$cancelAnimationTimeout = module.exports.cancelAnimationTimeout = function cancelAnimationTimeout(frame) {
    return (0, $41HVR.caf)(frame.id);
};
/**
 * Recursively calls requestAnimationFrame until a specified delay has been met or exceeded.
 * When the delay time has been reached the function you're timing out will be called.
 *
 * Credit: Joe Lambert (https://gist.github.com/joelambert/1002116#file-requesttimeout-js)
 */ var $911c46544e85c4db$var$requestAnimationTimeout = module.exports.requestAnimationTimeout = function requestAnimationTimeout(callback, delay) {
    var start = void 0;
    // wait for end of processing current event handler, because event handler may be long
    $911c46544e85c4db$var$_promise2.default.resolve().then(function() {
        start = Date.now();
    });
    var timeout = function timeout() {
        if (Date.now() - start >= delay) callback.call();
        else frame.id = (0, $41HVR.raf)(timeout);
    };
    var frame = {
        id: (0, $41HVR.raf)(timeout)
    };
    return frame;
};
module.exports.bpfrpt_proptype_AnimationTimeoutId = $911c46544e85c4db$var$bpfrpt_proptype_AnimationTimeoutId;

});
parcelRegister("jAIsH", function(module, exports) {

module.exports = {
    "default": (parcelRequire("b4MBT")),
    __esModule: true
};

});
parcelRegister("b4MBT", function(module, exports) {
parcelRequire("aNa7C");
parcelRequire("b94Z9");
parcelRequire("1v3Fn");
parcelRequire("iq1FW");
parcelRequire("eQUCL");
parcelRequire("epvg0");

module.exports = (parcelRequire("h9BqL")).Promise;

});
parcelRegister("iq1FW", function(module, exports) {
'use strict';

var $336Nq = parcelRequire("336Nq");

var $ea50F = parcelRequire("ea50F");

var $hFYx0 = parcelRequire("hFYx0");

var $81poE = parcelRequire("81poE");

var $1VdgD = parcelRequire("1VdgD");

var $4Us5Z = parcelRequire("4Us5Z");

var $ixKF3 = parcelRequire("ixKF3");

var $9WtHg = parcelRequire("9WtHg");

var $aknuJ = parcelRequire("aknuJ");

var $jiWwf = parcelRequire("jiWwf");

var $jLJLq = parcelRequire("jLJLq");
var $d68bf46eee655889$require$task = $jLJLq.set;

var $d68bf46eee655889$var$microtask = (parcelRequire("dAxWL"))();

var $hk7NP = parcelRequire("hk7NP");

var $fM013 = parcelRequire("fM013");

var $hWqWi = parcelRequire("hWqWi");

var $gjAwb = parcelRequire("gjAwb");
var $d68bf46eee655889$var$PROMISE = 'Promise';
var $d68bf46eee655889$var$TypeError = $ea50F.TypeError;
var $d68bf46eee655889$var$process = $ea50F.process;
var $d68bf46eee655889$var$versions = $d68bf46eee655889$var$process && $d68bf46eee655889$var$process.versions;
var $d68bf46eee655889$var$v8 = $d68bf46eee655889$var$versions && $d68bf46eee655889$var$versions.v8 || '';
var $d68bf46eee655889$var$$Promise = $ea50F[$d68bf46eee655889$var$PROMISE];
var $d68bf46eee655889$var$isNode = $81poE($d68bf46eee655889$var$process) == 'process';
var $d68bf46eee655889$var$empty = function() {};
var $d68bf46eee655889$var$Internal, $d68bf46eee655889$var$newGenericPromiseCapability, $d68bf46eee655889$var$OwnPromiseCapability, $d68bf46eee655889$var$Wrapper;
var $d68bf46eee655889$var$newPromiseCapability = $d68bf46eee655889$var$newGenericPromiseCapability = $hk7NP.f;

var $d68bf46eee655889$var$USE_NATIVE = !!function() {
    try {
        // correct subclassing with @@species support
        var promise = $d68bf46eee655889$var$$Promise.resolve(1);
        var FakePromise = (promise.constructor = {})[(parcelRequire("jsTob"))('species')] = function(exec) {
            exec($d68bf46eee655889$var$empty, $d68bf46eee655889$var$empty);
        };
        // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
        return ($d68bf46eee655889$var$isNode || typeof PromiseRejectionEvent == 'function') && promise.then($d68bf46eee655889$var$empty) instanceof FakePromise && $d68bf46eee655889$var$v8.indexOf('6.6') !== 0 && $hWqWi.indexOf('Chrome/66') === -1;
    } catch (e) {}
}();
// helpers
var $d68bf46eee655889$var$isThenable = function(it) {
    var then;
    return $4Us5Z(it) && typeof (then = it.then) == 'function' ? then : false;
};
var $d68bf46eee655889$var$notify = function(promise, isReject) {
    if (promise._n) return;
    promise._n = true;
    var chain = promise._c;
    $d68bf46eee655889$var$microtask(function() {
        var value = promise._v;
        var ok = promise._s == 1;
        var i = 0;
        var run = function(reaction) {
            var handler = ok ? reaction.ok : reaction.fail;
            var resolve = reaction.resolve;
            var reject = reaction.reject;
            var domain = reaction.domain;
            var result, then, exited;
            try {
                if (handler) {
                    if (!ok) {
                        if (promise._h == 2) $d68bf46eee655889$var$onHandleUnhandled(promise);
                        promise._h = 1;
                    }
                    if (handler === true) result = value;
                    else {
                        if (domain) domain.enter();
                        result = handler(value); // may throw
                        if (domain) {
                            domain.exit();
                            exited = true;
                        }
                    }
                    if (result === reaction.promise) reject($d68bf46eee655889$var$TypeError('Promise-chain cycle'));
                    else if (then = $d68bf46eee655889$var$isThenable(result)) then.call(result, resolve, reject);
                    else resolve(result);
                } else reject(value);
            } catch (e) {
                if (domain && !exited) domain.exit();
                reject(e);
            }
        };
        while(chain.length > i)run(chain[i++]); // variable length - can't use forEach
        promise._c = [];
        promise._n = false;
        if (isReject && !promise._h) $d68bf46eee655889$var$onUnhandled(promise);
    });
};
var $d68bf46eee655889$var$onUnhandled = function(promise) {
    $d68bf46eee655889$require$task.call($ea50F, function() {
        var value = promise._v;
        var unhandled = $d68bf46eee655889$var$isUnhandled(promise);
        var result, handler, console;
        if (unhandled) {
            result = $fM013(function() {
                if ($d68bf46eee655889$var$isNode) $d68bf46eee655889$var$process.emit('unhandledRejection', value, promise);
                else if (handler = $ea50F.onunhandledrejection) handler({
                    promise: promise,
                    reason: value
                });
                else if ((console = $ea50F.console) && console.error) console.error('Unhandled promise rejection', value);
            });
            // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
            promise._h = $d68bf46eee655889$var$isNode || $d68bf46eee655889$var$isUnhandled(promise) ? 2 : 1;
        }
        promise._a = undefined;
        if (unhandled && result.e) throw result.v;
    });
};
var $d68bf46eee655889$var$isUnhandled = function(promise) {
    return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var $d68bf46eee655889$var$onHandleUnhandled = function(promise) {
    $d68bf46eee655889$require$task.call($ea50F, function() {
        var handler;
        if ($d68bf46eee655889$var$isNode) $d68bf46eee655889$var$process.emit('rejectionHandled', promise);
        else if (handler = $ea50F.onrejectionhandled) handler({
            promise: promise,
            reason: promise._v
        });
    });
};
var $d68bf46eee655889$var$$reject = function(value) {
    var promise = this;
    if (promise._d) return;
    promise._d = true;
    promise = promise._w || promise; // unwrap
    promise._v = value;
    promise._s = 2;
    if (!promise._a) promise._a = promise._c.slice();
    $d68bf46eee655889$var$notify(promise, true);
};
var $d68bf46eee655889$var$$resolve = function(value) {
    var promise = this;
    var then;
    if (promise._d) return;
    promise._d = true;
    promise = promise._w || promise; // unwrap
    try {
        if (promise === value) throw $d68bf46eee655889$var$TypeError("Promise can't be resolved itself");
        if (then = $d68bf46eee655889$var$isThenable(value)) $d68bf46eee655889$var$microtask(function() {
            var wrapper = {
                _w: promise,
                _d: false
            }; // wrap
            try {
                then.call(value, $hFYx0($d68bf46eee655889$var$$resolve, wrapper, 1), $hFYx0($d68bf46eee655889$var$$reject, wrapper, 1));
            } catch (e) {
                $d68bf46eee655889$var$$reject.call(wrapper, e);
            }
        });
        else {
            promise._v = value;
            promise._s = 1;
            $d68bf46eee655889$var$notify(promise, false);
        }
    } catch (e) {
        $d68bf46eee655889$var$$reject.call({
            _w: promise,
            _d: false
        }, e); // wrap
    }
};

// constructor polyfill
if (!$d68bf46eee655889$var$USE_NATIVE) {
    // 25.4.3.1 Promise(executor)
    $d68bf46eee655889$var$$Promise = function Promise(executor) {
        $9WtHg(this, $d68bf46eee655889$var$$Promise, $d68bf46eee655889$var$PROMISE, '_h');
        $ixKF3(executor);
        $d68bf46eee655889$var$Internal.call(this);
        try {
            executor($hFYx0($d68bf46eee655889$var$$resolve, this, 1), $hFYx0($d68bf46eee655889$var$$reject, this, 1));
        } catch (err) {
            $d68bf46eee655889$var$$reject.call(this, err);
        }
    };
    // eslint-disable-next-line no-unused-vars
    $d68bf46eee655889$var$Internal = function Promise(executor) {
        this._c = []; // <- awaiting reactions
        this._a = undefined; // <- checked in isUnhandled reactions
        this._s = 0; // <- state
        this._d = false; // <- done
        this._v = undefined; // <- value
        this._h = 0; // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
        this._n = false; // <- notify
    };
    $d68bf46eee655889$var$Internal.prototype = (parcelRequire("aAnRC"))($d68bf46eee655889$var$$Promise.prototype, {
        // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
        then: function then(onFulfilled, onRejected) {
            var reaction = $d68bf46eee655889$var$newPromiseCapability($jiWwf(this, $d68bf46eee655889$var$$Promise));
            reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
            reaction.fail = typeof onRejected == 'function' && onRejected;
            reaction.domain = $d68bf46eee655889$var$isNode ? $d68bf46eee655889$var$process.domain : undefined;
            this._c.push(reaction);
            if (this._a) this._a.push(reaction);
            if (this._s) $d68bf46eee655889$var$notify(this, false);
            return reaction.promise;
        },
        // 25.4.5.1 Promise.prototype.catch(onRejected)
        'catch': function(onRejected) {
            return this.then(undefined, onRejected);
        }
    });
    $d68bf46eee655889$var$OwnPromiseCapability = function() {
        var promise = new $d68bf46eee655889$var$Internal();
        this.promise = promise;
        this.resolve = $hFYx0($d68bf46eee655889$var$$resolve, promise, 1);
        this.reject = $hFYx0($d68bf46eee655889$var$$reject, promise, 1);
    };
    $hk7NP.f = $d68bf46eee655889$var$newPromiseCapability = function(C) {
        return C === $d68bf46eee655889$var$$Promise || C === $d68bf46eee655889$var$Wrapper ? new $d68bf46eee655889$var$OwnPromiseCapability(C) : $d68bf46eee655889$var$newGenericPromiseCapability(C);
    };
}
$1VdgD($1VdgD.G + $1VdgD.W + $1VdgD.F * !$d68bf46eee655889$var$USE_NATIVE, {
    Promise: $d68bf46eee655889$var$$Promise
});

(parcelRequire("3BGsZ"))($d68bf46eee655889$var$$Promise, $d68bf46eee655889$var$PROMISE);

(parcelRequire("bwMXI"))($d68bf46eee655889$var$PROMISE);

$d68bf46eee655889$var$Wrapper = (parcelRequire("h9BqL"))[$d68bf46eee655889$var$PROMISE];
// statics
$1VdgD($1VdgD.S + $1VdgD.F * !$d68bf46eee655889$var$USE_NATIVE, $d68bf46eee655889$var$PROMISE, {
    // 25.4.4.5 Promise.reject(r)
    reject: function reject(r) {
        var capability = $d68bf46eee655889$var$newPromiseCapability(this);
        var $$reject = capability.reject;
        $$reject(r);
        return capability.promise;
    }
});
$1VdgD($1VdgD.S + $1VdgD.F * ($336Nq || !$d68bf46eee655889$var$USE_NATIVE), $d68bf46eee655889$var$PROMISE, {
    // 25.4.4.6 Promise.resolve(x)
    resolve: function resolve(x) {
        return $gjAwb($336Nq && this === $d68bf46eee655889$var$Wrapper ? $d68bf46eee655889$var$$Promise : this, x);
    }
});

$1VdgD($1VdgD.S + $1VdgD.F * !($d68bf46eee655889$var$USE_NATIVE && (parcelRequire("1Rvur"))(function(iter) {
    $d68bf46eee655889$var$$Promise.all(iter)['catch']($d68bf46eee655889$var$empty);
})), $d68bf46eee655889$var$PROMISE, {
    // 25.4.4.1 Promise.all(iterable)
    all: function all(iterable) {
        var C = this;
        var capability = $d68bf46eee655889$var$newPromiseCapability(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = $fM013(function() {
            var values = [];
            var index = 0;
            var remaining = 1;
            $aknuJ(iterable, false, function(promise) {
                var $index = index++;
                var alreadyCalled = false;
                values.push(undefined);
                remaining++;
                C.resolve(promise).then(function(value) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[$index] = value;
                    --remaining || resolve(values);
                }, reject);
            });
            --remaining || resolve(values);
        });
        if (result.e) reject(result.v);
        return capability.promise;
    },
    // 25.4.4.4 Promise.race(iterable)
    race: function race(iterable) {
        var C = this;
        var capability = $d68bf46eee655889$var$newPromiseCapability(C);
        var reject = capability.reject;
        var result = $fM013(function() {
            $aknuJ(iterable, false, function(promise) {
                C.resolve(promise).then(capability.resolve, reject);
            });
        });
        if (result.e) reject(result.v);
        return capability.promise;
    }
});

});
parcelRegister("81poE", function(module, exports) {
// getting tag from 19.1.3.6 Object.prototype.toString()

var $c4I03 = parcelRequire("c4I03");

var $5d721df652d9a004$var$TAG = (parcelRequire("jsTob"))('toStringTag');
// ES3 wrong here
var $5d721df652d9a004$var$ARG = $c4I03(function() {
    return arguments;
}()) == 'Arguments';
// fallback for IE11 Script Access Denied error
var $5d721df652d9a004$var$tryGet = function(it, key) {
    try {
        return it[key];
    } catch (e) {}
};
module.exports = function(it) {
    var O, T, B;
    return it === undefined ? 'Undefined' : it === null ? 'Null' : typeof (T = $5d721df652d9a004$var$tryGet(O = Object(it), $5d721df652d9a004$var$TAG)) == 'string' ? T : $5d721df652d9a004$var$ARG ? $c4I03(O) : (B = $c4I03(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

});

parcelRegister("9WtHg", function(module, exports) {
module.exports = function(it, Constructor, name, forbiddenField) {
    if (!(it instanceof Constructor) || forbiddenField !== undefined && forbiddenField in it) throw TypeError(name + ': incorrect invocation!');
    return it;
};

});

parcelRegister("aknuJ", function(module, exports) {

var $hFYx0 = parcelRequire("hFYx0");

var $euUc1 = parcelRequire("euUc1");

var $bujJe = parcelRequire("bujJe");

var $gH7sg = parcelRequire("gH7sg");

var $h9XHT = parcelRequire("h9XHT");

var $h7p8N = parcelRequire("h7p8N");
var $784dff355a92ffe6$var$BREAK = {};
var $784dff355a92ffe6$var$RETURN = {};
var $784dff355a92ffe6$var$exports = module.exports = function(iterable, entries, fn, that, ITERATOR) {
    var iterFn = ITERATOR ? function() {
        return iterable;
    } : $h7p8N(iterable);
    var f = $hFYx0(fn, that, entries ? 2 : 1);
    var index = 0;
    var length, step, iterator, result;
    if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
    // fast case for arrays with default iterator
    if ($bujJe(iterFn)) for(length = $h9XHT(iterable.length); length > index; index++){
        result = entries ? f($gH7sg(step = iterable[index])[0], step[1]) : f(iterable[index]);
        if (result === $784dff355a92ffe6$var$BREAK || result === $784dff355a92ffe6$var$RETURN) return result;
    }
    else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done;){
        result = $euUc1(iterator, f, step.value, entries);
        if (result === $784dff355a92ffe6$var$BREAK || result === $784dff355a92ffe6$var$RETURN) return result;
    }
};
$784dff355a92ffe6$var$exports.BREAK = $784dff355a92ffe6$var$BREAK;
$784dff355a92ffe6$var$exports.RETURN = $784dff355a92ffe6$var$RETURN;

});
parcelRegister("euUc1", function(module, exports) {
// call something on iterator step with safe closing on error

var $gH7sg = parcelRequire("gH7sg");
module.exports = function(iterator, fn, value, entries) {
    try {
        return entries ? fn($gH7sg(value)[0], value[1]) : fn(value);
    // 7.4.6 IteratorClose(iterator, completion)
    } catch (e) {
        var ret = iterator['return'];
        if (ret !== undefined) $gH7sg(ret.call(iterator));
        throw e;
    }
};

});

parcelRegister("bujJe", function(module, exports) {
// check on default Array iterator

var $jAn1n = parcelRequire("jAn1n");

var $85d1ccb7f3e0908f$var$ITERATOR = (parcelRequire("jsTob"))('iterator');
var $85d1ccb7f3e0908f$var$ArrayProto = Array.prototype;
module.exports = function(it) {
    return it !== undefined && ($jAn1n.Array === it || $85d1ccb7f3e0908f$var$ArrayProto[$85d1ccb7f3e0908f$var$ITERATOR] === it);
};

});

parcelRegister("h7p8N", function(module, exports) {

var $81poE = parcelRequire("81poE");

var $c7669798071aa139$var$ITERATOR = (parcelRequire("jsTob"))('iterator');

var $jAn1n = parcelRequire("jAn1n");

module.exports = (parcelRequire("h9BqL")).getIteratorMethod = function(it) {
    if (it != undefined) return it[$c7669798071aa139$var$ITERATOR] || it['@@iterator'] || $jAn1n[$81poE(it)];
};

});


parcelRegister("jiWwf", function(module, exports) {
// 7.3.20 SpeciesConstructor(O, defaultConstructor)

var $gH7sg = parcelRequire("gH7sg");

var $ixKF3 = parcelRequire("ixKF3");

var $e0dd176f334c9146$var$SPECIES = (parcelRequire("jsTob"))('species');
module.exports = function(O, D) {
    var C = $gH7sg(O).constructor;
    var S;
    return C === undefined || (S = $gH7sg(C)[$e0dd176f334c9146$var$SPECIES]) == undefined ? D : $ixKF3(S);
};

});

parcelRegister("jLJLq", function(module, exports) {

var $hFYx0 = parcelRequire("hFYx0");

var $7USoQ = parcelRequire("7USoQ");

var $bsGy8 = parcelRequire("bsGy8");

var $1uU7O = parcelRequire("1uU7O");

var $ea50F = parcelRequire("ea50F");
var $e645e7e34afb5223$var$process = $ea50F.process;
var $e645e7e34afb5223$var$setTask = $ea50F.setImmediate;
var $e645e7e34afb5223$var$clearTask = $ea50F.clearImmediate;
var $e645e7e34afb5223$var$MessageChannel = $ea50F.MessageChannel;
var $e645e7e34afb5223$var$Dispatch = $ea50F.Dispatch;
var $e645e7e34afb5223$var$counter = 0;
var $e645e7e34afb5223$var$queue = {};
var $e645e7e34afb5223$var$ONREADYSTATECHANGE = 'onreadystatechange';
var $e645e7e34afb5223$var$defer, $e645e7e34afb5223$var$channel, $e645e7e34afb5223$var$port;
var $e645e7e34afb5223$var$run = function() {
    var id = +this;
    // eslint-disable-next-line no-prototype-builtins
    if ($e645e7e34afb5223$var$queue.hasOwnProperty(id)) {
        var fn = $e645e7e34afb5223$var$queue[id];
        delete $e645e7e34afb5223$var$queue[id];
        fn();
    }
};
var $e645e7e34afb5223$var$listener = function(event) {
    $e645e7e34afb5223$var$run.call(event.data);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!$e645e7e34afb5223$var$setTask || !$e645e7e34afb5223$var$clearTask) {
    $e645e7e34afb5223$var$setTask = function setImmediate(fn) {
        var args = [];
        var i = 1;
        while(arguments.length > i)args.push(arguments[i++]);
        $e645e7e34afb5223$var$queue[++$e645e7e34afb5223$var$counter] = function() {
            // eslint-disable-next-line no-new-func
            $7USoQ(typeof fn == 'function' ? fn : Function(fn), args);
        };
        $e645e7e34afb5223$var$defer($e645e7e34afb5223$var$counter);
        return $e645e7e34afb5223$var$counter;
    };
    $e645e7e34afb5223$var$clearTask = function clearImmediate(id) {
        delete $e645e7e34afb5223$var$queue[id];
    };
    // Node.js 0.8-
    if ((parcelRequire("c4I03"))($e645e7e34afb5223$var$process) == 'process') $e645e7e34afb5223$var$defer = function(id) {
        $e645e7e34afb5223$var$process.nextTick($hFYx0($e645e7e34afb5223$var$run, id, 1));
    };
    else if ($e645e7e34afb5223$var$Dispatch && $e645e7e34afb5223$var$Dispatch.now) $e645e7e34afb5223$var$defer = function(id) {
        $e645e7e34afb5223$var$Dispatch.now($hFYx0($e645e7e34afb5223$var$run, id, 1));
    };
    else if ($e645e7e34afb5223$var$MessageChannel) {
        $e645e7e34afb5223$var$channel = new $e645e7e34afb5223$var$MessageChannel();
        $e645e7e34afb5223$var$port = $e645e7e34afb5223$var$channel.port2;
        $e645e7e34afb5223$var$channel.port1.onmessage = $e645e7e34afb5223$var$listener;
        $e645e7e34afb5223$var$defer = $hFYx0($e645e7e34afb5223$var$port.postMessage, $e645e7e34afb5223$var$port, 1);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if ($ea50F.addEventListener && typeof postMessage == 'function' && !$ea50F.importScripts) {
        $e645e7e34afb5223$var$defer = function(id) {
            $ea50F.postMessage(id + '', '*');
        };
        $ea50F.addEventListener('message', $e645e7e34afb5223$var$listener, false);
    // IE8-
    } else if ($e645e7e34afb5223$var$ONREADYSTATECHANGE in $1uU7O('script')) $e645e7e34afb5223$var$defer = function(id) {
        $bsGy8.appendChild($1uU7O('script'))[$e645e7e34afb5223$var$ONREADYSTATECHANGE] = function() {
            $bsGy8.removeChild(this);
            $e645e7e34afb5223$var$run.call(id);
        };
    };
    else $e645e7e34afb5223$var$defer = function(id) {
        setTimeout($hFYx0($e645e7e34afb5223$var$run, id, 1), 0);
    };
}
module.exports = {
    set: $e645e7e34afb5223$var$setTask,
    clear: $e645e7e34afb5223$var$clearTask
};

});
parcelRegister("7USoQ", function(module, exports) {
// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function(fn, args, that) {
    var un = that === undefined;
    switch(args.length){
        case 0:
            return un ? fn() : fn.call(that);
        case 1:
            return un ? fn(args[0]) : fn.call(that, args[0]);
        case 2:
            return un ? fn(args[0], args[1]) : fn.call(that, args[0], args[1]);
        case 3:
            return un ? fn(args[0], args[1], args[2]) : fn.call(that, args[0], args[1], args[2]);
        case 4:
            return un ? fn(args[0], args[1], args[2], args[3]) : fn.call(that, args[0], args[1], args[2], args[3]);
    }
    return fn.apply(that, args);
};

});


parcelRegister("dAxWL", function(module, exports) {

var $ea50F = parcelRequire("ea50F");

var $jLJLq = parcelRequire("jLJLq");
var $9e48f847cd2ffbef$require$macrotask = $jLJLq.set;
var $9e48f847cd2ffbef$var$Observer = $ea50F.MutationObserver || $ea50F.WebKitMutationObserver;
var $9e48f847cd2ffbef$var$process = $ea50F.process;
var $9e48f847cd2ffbef$var$Promise = $ea50F.Promise;

var $9e48f847cd2ffbef$var$isNode = (parcelRequire("c4I03"))($9e48f847cd2ffbef$var$process) == 'process';
module.exports = function() {
    var head, last, notify;
    var flush = function() {
        var parent, fn;
        if ($9e48f847cd2ffbef$var$isNode && (parent = $9e48f847cd2ffbef$var$process.domain)) parent.exit();
        while(head){
            fn = head.fn;
            head = head.next;
            try {
                fn();
            } catch (e) {
                if (head) notify();
                else last = undefined;
                throw e;
            }
        }
        last = undefined;
        if (parent) parent.enter();
    };
    // Node.js
    if ($9e48f847cd2ffbef$var$isNode) notify = function() {
        $9e48f847cd2ffbef$var$process.nextTick(flush);
    };
    else if ($9e48f847cd2ffbef$var$Observer && !($ea50F.navigator && $ea50F.navigator.standalone)) {
        var toggle = true;
        var node = document.createTextNode('');
        new $9e48f847cd2ffbef$var$Observer(flush).observe(node, {
            characterData: true
        }); // eslint-disable-line no-new
        notify = function() {
            node.data = toggle = !toggle;
        };
    // environments with maybe non-completely correct, but existent Promise
    } else if ($9e48f847cd2ffbef$var$Promise && $9e48f847cd2ffbef$var$Promise.resolve) {
        // Promise.resolve without an argument throws an error in LG WebOS 2
        var promise = $9e48f847cd2ffbef$var$Promise.resolve(undefined);
        notify = function() {
            promise.then(flush);
        };
    // for other environments - macrotask based on:
    // - setImmediate
    // - MessageChannel
    // - window.postMessag
    // - onreadystatechange
    // - setTimeout
    } else notify = function() {
        // strange IE + webpack dev server bug - use .call(global)
        $9e48f847cd2ffbef$require$macrotask.call($ea50F, flush);
    };
    return function(fn) {
        var task = {
            fn: fn,
            next: undefined
        };
        if (last) last.next = task;
        if (!head) {
            head = task;
            notify();
        }
        last = task;
    };
};

});

parcelRegister("hk7NP", function(module, exports) {

$parcel$export(module.exports, "f", () => $c9ca5b64667f5370$export$2d1720544b23b823, (v) => $c9ca5b64667f5370$export$2d1720544b23b823 = v);
var $c9ca5b64667f5370$export$2d1720544b23b823;
'use strict';

var $ixKF3 = parcelRequire("ixKF3");
function $c9ca5b64667f5370$var$PromiseCapability(C) {
    var resolve, reject;
    this.promise = new C(function($$resolve, $$reject) {
        if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
        resolve = $$resolve;
        reject = $$reject;
    });
    this.resolve = $ixKF3(resolve);
    this.reject = $ixKF3(reject);
}
$c9ca5b64667f5370$export$2d1720544b23b823 = function(C) {
    return new $c9ca5b64667f5370$var$PromiseCapability(C);
};

});

parcelRegister("fM013", function(module, exports) {
module.exports = function(exec) {
    try {
        return {
            e: false,
            v: exec()
        };
    } catch (e) {
        return {
            e: true,
            v: e
        };
    }
};

});

parcelRegister("hWqWi", function(module, exports) {

var $ea50F = parcelRequire("ea50F");
var $d0fcc00630fea3d9$var$navigator = $ea50F.navigator;
module.exports = $d0fcc00630fea3d9$var$navigator && $d0fcc00630fea3d9$var$navigator.userAgent || '';

});

parcelRegister("gjAwb", function(module, exports) {

var $gH7sg = parcelRequire("gH7sg");

var $4Us5Z = parcelRequire("4Us5Z");

var $hk7NP = parcelRequire("hk7NP");
module.exports = function(C, x) {
    $gH7sg(C);
    if ($4Us5Z(x) && x.constructor === C) return x;
    var promiseCapability = $hk7NP.f(C);
    var resolve = promiseCapability.resolve;
    resolve(x);
    return promiseCapability.promise;
};

});

parcelRegister("aAnRC", function(module, exports) {

var $2fICR = parcelRequire("2fICR");
module.exports = function(target, src, safe) {
    for(var key in src)if (safe && target[key]) target[key] = src[key];
    else $2fICR(target, key, src[key]);
    return target;
};

});

parcelRegister("bwMXI", function(module, exports) {
'use strict';

var $ea50F = parcelRequire("ea50F");

var $h9BqL = parcelRequire("h9BqL");

var $6SgFA = parcelRequire("6SgFA");

var $2ZZjJ = parcelRequire("2ZZjJ");

var $8648a9b74f2faec1$var$SPECIES = (parcelRequire("jsTob"))('species');
module.exports = function(KEY) {
    var C = typeof $h9BqL[KEY] == 'function' ? $h9BqL[KEY] : $ea50F[KEY];
    if ($2ZZjJ && C && !C[$8648a9b74f2faec1$var$SPECIES]) $6SgFA.f(C, $8648a9b74f2faec1$var$SPECIES, {
        configurable: true,
        get: function() {
            return this;
        }
    });
};

});

parcelRegister("1Rvur", function(module, exports) {

var $15b32aee99c798b1$var$ITERATOR = (parcelRequire("jsTob"))('iterator');
var $15b32aee99c798b1$var$SAFE_CLOSING = false;
try {
    var $15b32aee99c798b1$var$riter = [
        7
    ][$15b32aee99c798b1$var$ITERATOR]();
    $15b32aee99c798b1$var$riter['return'] = function() {
        $15b32aee99c798b1$var$SAFE_CLOSING = true;
    };
    // eslint-disable-next-line no-throw-literal
    Array.from($15b32aee99c798b1$var$riter, function() {
        throw 2;
    });
} catch (e) {}
module.exports = function(exec, skipClosing) {
    if (!skipClosing && !$15b32aee99c798b1$var$SAFE_CLOSING) return false;
    var safe = false;
    try {
        var arr = [
            7
        ];
        var iter = arr[$15b32aee99c798b1$var$ITERATOR]();
        iter.next = function() {
            return {
                done: safe = true
            };
        };
        arr[$15b32aee99c798b1$var$ITERATOR] = function() {
            return iter;
        };
        exec(arr);
    } catch (e) {}
    return safe;
};

});


parcelRegister("eQUCL", function(module, exports) {
// https://github.com/tc39/proposal-promise-finally
'use strict';

var $1VdgD = parcelRequire("1VdgD");

var $h9BqL = parcelRequire("h9BqL");

var $ea50F = parcelRequire("ea50F");

var $jiWwf = parcelRequire("jiWwf");

var $gjAwb = parcelRequire("gjAwb");
$1VdgD($1VdgD.P + $1VdgD.R, 'Promise', {
    'finally': function(onFinally) {
        var C = $jiWwf(this, $h9BqL.Promise || $ea50F.Promise);
        var isFunction = typeof onFinally == 'function';
        return this.then(isFunction ? function(x) {
            return $gjAwb(C, onFinally()).then(function() {
                return x;
            });
        } : onFinally, isFunction ? function(e) {
            return $gjAwb(C, onFinally()).then(function() {
                throw e;
            });
        } : onFinally);
    }
});

});

parcelRegister("epvg0", function(module, exports) {
'use strict';

var $1VdgD = parcelRequire("1VdgD");

var $hk7NP = parcelRequire("hk7NP");

var $fM013 = parcelRequire("fM013");
$1VdgD($1VdgD.S, 'Promise', {
    'try': function(callbackfn) {
        var promiseCapability = $hk7NP.f(this);
        var result = $fM013(callbackfn);
        (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
        return promiseCapability.promise;
    }
});

});



parcelRegister("41HVR", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
// Properly handle server-side rendering.
var $2ee95578c904f878$var$win = void 0;
if (typeof window !== 'undefined') $2ee95578c904f878$var$win = window;
else if (typeof self !== 'undefined') $2ee95578c904f878$var$win = self;
else $2ee95578c904f878$var$win = {};
// requestAnimationFrame() shim by Paul Irish
// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
var $2ee95578c904f878$var$request = $2ee95578c904f878$var$win.requestAnimationFrame || $2ee95578c904f878$var$win.webkitRequestAnimationFrame || $2ee95578c904f878$var$win.mozRequestAnimationFrame || $2ee95578c904f878$var$win.oRequestAnimationFrame || $2ee95578c904f878$var$win.msRequestAnimationFrame || function(callback) {
    return $2ee95578c904f878$var$win.setTimeout(callback, 1000 / 60);
};
var $2ee95578c904f878$var$cancel = $2ee95578c904f878$var$win.cancelAnimationFrame || $2ee95578c904f878$var$win.webkitCancelAnimationFrame || $2ee95578c904f878$var$win.mozCancelAnimationFrame || $2ee95578c904f878$var$win.oCancelAnimationFrame || $2ee95578c904f878$var$win.msCancelAnimationFrame || function(id) {
    $2ee95578c904f878$var$win.clearTimeout(id);
};
var $2ee95578c904f878$var$raf = module.exports.raf = $2ee95578c904f878$var$request;
var $2ee95578c904f878$var$caf = module.exports.caf = $2ee95578c904f878$var$cancel;

});



parcelRegister("hcTHf", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SCROLL_DIRECTION_VERTICAL = module.exports.SCROLL_DIRECTION_HORIZONTAL = module.exports.SCROLL_DIRECTION_FORWARD = module.exports.SCROLL_DIRECTION_BACKWARD = undefined;
module.exports.default = $c86ec2d8aaeee133$var$defaultOverscanIndicesGetter;
parcelRequire("5XjzC");
var $c86ec2d8aaeee133$var$SCROLL_DIRECTION_BACKWARD = module.exports.SCROLL_DIRECTION_BACKWARD = -1;
var $c86ec2d8aaeee133$var$SCROLL_DIRECTION_FORWARD = module.exports.SCROLL_DIRECTION_FORWARD = 1;
var $c86ec2d8aaeee133$var$SCROLL_DIRECTION_HORIZONTAL = module.exports.SCROLL_DIRECTION_HORIZONTAL = 'horizontal';
var $c86ec2d8aaeee133$var$SCROLL_DIRECTION_VERTICAL = module.exports.SCROLL_DIRECTION_VERTICAL = 'vertical';
/**
 * Calculates the number of cells to overscan before and after a specified range.
 * This function ensures that overscanning doesn't exceed the available cells.
 */ function $c86ec2d8aaeee133$var$defaultOverscanIndicesGetter(_ref) {
    var cellCount = _ref.cellCount, overscanCellsCount = _ref.overscanCellsCount, scrollDirection = _ref.scrollDirection, startIndex = _ref.startIndex, stopIndex = _ref.stopIndex;
    // Make sure we render at least 1 cell extra before and after (except near boundaries)
    // This is necessary in order to support keyboard navigation (TAB/SHIFT+TAB) in some cases
    // For more info see issues #625
    overscanCellsCount = Math.max(1, overscanCellsCount);
    if (scrollDirection === $c86ec2d8aaeee133$var$SCROLL_DIRECTION_FORWARD) return {
        overscanStartIndex: Math.max(0, startIndex - 1),
        overscanStopIndex: Math.min(cellCount - 1, stopIndex + overscanCellsCount)
    };
    else return {
        overscanStartIndex: Math.max(0, startIndex - overscanCellsCount),
        overscanStopIndex: Math.min(cellCount - 1, stopIndex + 1)
    };
}

});


parcelRegister("9j0W6", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bpfrpt_proptype_Scroll = module.exports.bpfrpt_proptype_RenderedRows = module.exports.bpfrpt_proptype_RowRenderer = module.exports.bpfrpt_proptype_RowRendererParams = undefined;

var $eJOHy = parcelRequire("eJOHy");
var $6c669d48109b6ee3$var$React = $6c669d48109b6ee3$var$_interopRequireWildcard($eJOHy);

var $cT3Ey = parcelRequire("cT3Ey");
var $6c669d48109b6ee3$var$_propTypes2 = $6c669d48109b6ee3$var$_interopRequireDefault($cT3Ey);
function $6c669d48109b6ee3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $6c669d48109b6ee3$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
var $6c669d48109b6ee3$var$bpfrpt_proptype_RowRendererParams = null;
var $6c669d48109b6ee3$var$bpfrpt_proptype_RowRenderer = null;
var $6c669d48109b6ee3$var$bpfrpt_proptype_RenderedRows = null;
var $6c669d48109b6ee3$var$bpfrpt_proptype_Scroll = null;
module.exports.bpfrpt_proptype_RowRendererParams = $6c669d48109b6ee3$var$bpfrpt_proptype_RowRendererParams;
module.exports.bpfrpt_proptype_RowRenderer = $6c669d48109b6ee3$var$bpfrpt_proptype_RowRenderer;
module.exports.bpfrpt_proptype_RenderedRows = $6c669d48109b6ee3$var$bpfrpt_proptype_RenderedRows;
module.exports.bpfrpt_proptype_Scroll = $6c669d48109b6ee3$var$bpfrpt_proptype_Scroll;

});



parcelRegister("ajlZ9", function(module, exports) {

$parcel$export(module.exports, "ListRow", () => $eb23442c0a9644c5$export$c36f87108246a02a);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
function $eb23442c0a9644c5$export$c36f87108246a02a({ children: children, registerChild: registerChild, measure: measure, index: index, style: style, isVisible: isVisible, isScrolling: isScrolling, onMouseMove: onMouseMove }) {
    const childElementRef = (0, $eJOHy.useRef)(null);
    const setListElementRef = (element)=>{
        registerChild?.(element ?? undefined);
    };
    (0, $eJOHy.useEffect)(()=>{
        // Do not measure if the row is not visible or is scrolling for performance reasons.
        if (!childElementRef.current || !isVisible || isScrolling) return;
        const observer = new ResizeObserver(()=>measure());
        observer.observe(childElementRef.current);
        return ()=>observer.disconnect();
    }, [
        isScrolling,
        isVisible,
        measure
    ]);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ref: setListElementRef,
        style: style,
        "data-index": index,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            ref: childElementRef,
            "data-testid": `list-item-height-observed-${index}`,
            onMouseMove: onMouseMove,
            children: children
        })
    }));
}

});

parcelRegister("3mtr1", function(module, exports) {

$parcel$export(module.exports, "MoreOptions", () => $1736df5f7314d253$export$76421314069e32e1);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $7saMl = parcelRequire("7saMl");
var $6YEko = parcelRequire("6YEko");

const $1736df5f7314d253$var$buttonStyles = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > button:hover': {
        backgroundColor: `var(--ds-background-neutral-subtle-hovered, ${(0, $7bb4c1736002a04a$export$3e51e8f1440314ba)})`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > button:focus': {
        backgroundColor: `var(--ds-background-neutral-subtle-hovered, ${(0, $7bb4c1736002a04a$export$3e51e8f1440314ba)})`
    }
});
const $1736df5f7314d253$export$76421314069e32e1 = ({ onClick: onClick, isFocused: isFocused, title: title, ariaLabel: ariaLabel, iconBefore: iconBefore })=>{
    const ref = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useEffect)(()=>{
        if (isFocused && ref.current) ref.current.focus();
    }, [
        isFocused
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!ref.current) return;
        const { current: element } = ref;
        const handleEnter = (e)=>{
            if (e.key === 'Enter') {
                onClick();
                // Prevent keydown listener in TypeaheadList from handling Enter pressed
                e.stopPropagation();
            } else if (e.key === 'Tab') {
                // TypeaheadList will try to insert selected item on Tab press
                // hence stop propagation to prevent that and treat this as noop
                e.stopPropagation();
                e.preventDefault();
            }
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element?.addEventListener('keydown', handleEnter);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element?.removeEventListener('keydown', handleEnter);
        };
    });
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $6YEko.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        css: $1736df5f7314d253$var$buttonStyles
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $7saMl.default), {
        ref: ref,
        onClick: onClick,
        iconBefore: iconBefore,
        "aria-label": ariaLabel,
        testId: "type-ahead-more-options-button"
    }, title)));
};

});

parcelRegister("9aOK1", function(module, exports) {

$parcel$export(module.exports, "TypeAheadListItem", () => $29897f3555837a9c$export$913373331e95c13e);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $1NIU8 = parcelRequire("1NIU8");

var $lRq8t = parcelRequire("lRq8t");

var $kLQ9a = parcelRequire("kLQ9a");
var $bSToC = parcelRequire("bSToC");
var $cxXTK = parcelRequire("cxXTK");

var $ehOis = parcelRequire("ehOis");

var $7k8dr = parcelRequire("7k8dr");
var $4drex = parcelRequire("4drex");

var $7yBx7 = parcelRequire("7yBx7");

var $2dMzB = parcelRequire("2dMzB");

var $7saMl = parcelRequire("7saMl");

function $29897f3555837a9c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $29897f3555837a9c$export$cfa784b45fc7b21d = /*#__PURE__*/ (0, $1NIU8.css)({
    width: "var(--ds-space-500, 40px)",
    height: "var(--ds-space-500, 40px)",
    overflow: 'hidden',
    border: `1px solid ${"var(--ds-border, rgba(223, 225, 229, 0.5))"}`,
    borderRadius: "var(--ds-border-radius, 3px)",
    boxSizing: 'border-box',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    div: {
        width: "var(--ds-space-500, 40px)",
        height: "var(--ds-space-500, 40px)"
    }
});
const $29897f3555837a9c$var$itemIconSize = {
    name: "4y81cs",
    styles: "width:var(--ds-space-400, 32px);height:var(--ds-space-400, 32px);svg:first-of-type{width:var(--ds-space-400, 32px);height:var(--ds-space-400, 32px);}div{width:var(--ds-space-400, 32px);height:var(--ds-space-400, 32px);}"
};
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $29897f3555837a9c$var$itemBody = {
    name: "dblrt7",
    styles: "display:flex;flex-direction:row;flex-wrap:nowrap;justify-content:space-between"
};
const $29897f3555837a9c$var$itemText = /*#__PURE__*/ (0, $1NIU8.css)({
    whiteSpace: 'initial',
    color: `${`var(--ds-text, ${(0, $7bb4c1736002a04a$export$7d61b15e0da132af)})`}`
});
const $29897f3555837a9c$var$itemTitle = {
    name: "1v4psb4",
    styles: "line-height:1.4"
};
const $29897f3555837a9c$var$itemTitleOverride = {
    name: "1th4nak",
    styles: "font:var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
const $29897f3555837a9c$var$itemDescription = /*#__PURE__*/ (0, $1NIU8.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/use-tokens-typography
    fontSize: `${(0, $7yBx7.relativeFontSizeToBase16)(12)};`,
    color: `${`var(--ds-text-subtlest, ${(0, $7bb4c1736002a04a$export$f563ee71e9ee74cd)})`};`,
    marginTop: `${"var(--ds-space-050, 4px)"};`
});
const $29897f3555837a9c$var$itemDescriptionOverride = {
    name: "7ynmig",
    styles: "font:var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);margin-top:0"
};
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $29897f3555837a9c$var$itemAfter = {
    name: "ou8xsw",
    styles: "flex:0 0 auto"
};
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Ignored via go/DSP-18766
const $29897f3555837a9c$var$customRenderItemDivStyle = /*#__PURE__*/ (0, $1NIU8.css)("overflow:hidden;&:focus{box-shadow:inset 2px 0px 0px ", `var(--ds-border-focused, ${(0, $7bb4c1736002a04a$export$b3de0ae08da2ce64)})`, ";background-color:", `var(--ds-background-neutral-subtle-hovered, ${(0, $7bb4c1736002a04a$export$3e51e8f1440314ba)})`, ";outline:none;}");
/**
 * This CSS emulates the desired behaviour with :focus-visible for firefox.
 * Firefox unfortunately does not register keyboard focus if user mouseDown and drag a typeahead item
 * resulting in focus-visible style not drawn.
 */ const $29897f3555837a9c$var$selectionFrame = {
    '& > button:focus': {
        boxShadow: `inset 2px 0px 0px ${`var(--ds-border-focused, ${(0, $7bb4c1736002a04a$export$b3de0ae08da2ce64)})`};`,
        backgroundColor: `${`var(--ds-background-neutral-subtle-hovered, ${(0, $7bb4c1736002a04a$export$3e51e8f1440314ba)})`}`,
        outline: 'none',
        '&:active': {
            boxShadow: 'none'
        }
    },
    '& > button:hover': {
        backgroundColor: 'inherit',
        outline: 'none'
    }
};
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Ignored via go/DSP-18766
const $29897f3555837a9c$var$selectedStyle = /*#__PURE__*/ (0, $1NIU8.css)("background-color:", `var(--ds-background-neutral-subtle-hovered, ${(0, $7bb4c1736002a04a$export$3e51e8f1440314ba)})`, ";box-shadow:inset 2px 0px 0px ", `var(--ds-border-focused, ${(0, $7bb4c1736002a04a$export$b3de0ae08da2ce64)})`, ";");
const $29897f3555837a9c$var$disabledStyle = {
    name: "16lzvw8",
    styles: "color:var(--ds-text-disabled, #091E424F)"
};
const $29897f3555837a9c$var$FallbackIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo(({ label: label })=>{
    return /*#__PURE__*/ (0, $1NIU8.jsx)((0, $ehOis.default), null);
});
const $29897f3555837a9c$var$noop = ()=>{};
const $29897f3555837a9c$var$CustomItemComponentWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo((props)=>{
    const { customRenderItem: customRenderItem, isSelected: isSelected, itemIsDisabled: itemIsDisabled, ariaLabel: ariaLabel, itemsLength: itemsLength, customItemRef: customItemRef, insertSelectedItem: insertSelectedItem, itemIndex: itemIndex } = props;
    const Comp = customRenderItem;
    const listItemClasses = (0, $eJOHy.useMemo)(()=>{
        return [
            $29897f3555837a9c$var$customRenderItemDivStyle,
            isSelected && !itemIsDisabled && $29897f3555837a9c$var$selectedStyle,
            itemIsDisabled && $29897f3555837a9c$var$disabledStyle
        ];
    }, [
        isSelected,
        itemIsDisabled
    ]);
    return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        "aria-selected": isSelected,
        role: "option",
        "aria-label": ariaLabel,
        "aria-setsize": itemsLength,
        "aria-posinset": itemIndex,
        tabIndex: 0,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: listItemClasses,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `ak-typeahead-item ${isSelected ? 'typeahead-selected-item' : ''}`,
        //CSS classes added for test cases purpose
        ref: customItemRef
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        "aria-hidden": true
    }, /*#__PURE__*/ (0, $1NIU8.jsx)(Comp, {
        onClick: insertSelectedItem,
        isSelected: false,
        onHover: $29897f3555837a9c$var$noop
    })));
});
const $29897f3555837a9c$var$useSharedState = (0, $kLQ9a.sharedPluginStateHookMigratorFactory)((api)=>{
    const { mode: mode } = (0, $cxXTK.useSharedPluginStateWithSelector)(api, [
        'connectivity'
    ], (states)=>{
        return {
            mode: states.connectivityState?.mode
        };
    });
    return {
        connectivityMode: mode
    };
}, (api)=>{
    const { connectivityState: connectivityState } = (0, $bSToC.useSharedPluginState)(api, [
        'connectivity'
    ]);
    return {
        connectivityMode: connectivityState?.mode
    };
});
const $29897f3555837a9c$export$913373331e95c13e = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo(({ item: item, itemsLength: itemsLength, selectedIndex: selectedIndex, onItemClick: onItemClick, itemIndex: itemIndex, ariaLabel: ariaLabel, moreElementsInQuickInsertViewEnabled: moreElementsInQuickInsertViewEnabled, api: api, firstOnlineSupportedIndex: firstOnlineSupportedIndex })=>{
    const { connectivityMode: connectivityMode } = $29897f3555837a9c$var$useSharedState(api);
    const isItemDisabled = (item)=>connectivityMode === 'offline' && (item?.isDisabledOffline ?? false);
    const itemIsDisabled = isItemDisabled(item);
    const isFirstEnabledIndex = connectivityMode === 'offline' && itemIndex === firstOnlineSupportedIndex && selectedIndex === -1;
    /**
   * To select and highlight the first Item when no item is selected
   * However selectedIndex remains -1, So that user does not skip the first item when down arrow key is used from typeahead query(inputQuery.tsx)
   */ let isSelected = false;
    // Feature gated - connectivity is only available on desktop and behind a feature gate on full page mode
    if (connectivityMode === undefined) isSelected = itemIndex === selectedIndex || selectedIndex === -1 && itemIndex === 0;
    else isSelected = itemIndex === selectedIndex || selectedIndex === -1 && (itemIndex === 0 || isFirstEnabledIndex) && !itemIsDisabled;
    // Assistive text
    const intl = (0, $lRq8t.default)();
    const descriptionText = item.description ? `${item.description}.` : '';
    const shortcutText = item.keyshortcut ? ` ${intl.formatMessage((0, $4drex.typeAheadListMessages).shortcutLabel)} ${item.keyshortcut}.` : '';
    const { icon: icon, title: title, render: customRenderItem } = item;
    const elementIcon = (0, $eJOHy.useMemo)(()=>{
        return /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
            css: [
                $29897f3555837a9c$export$cfa784b45fc7b21d,
                moreElementsInQuickInsertViewEnabled && $29897f3555837a9c$var$itemIconSize
            ]
        }, icon ? icon() : /*#__PURE__*/ (0, $1NIU8.jsx)($29897f3555837a9c$var$FallbackIcon, {
            label: title
        }));
    }, [
        icon,
        title,
        moreElementsInQuickInsertViewEnabled
    ]);
    const insertSelectedItem = (0, $eJOHy.useCallback)(()=>{
        if (itemIsDisabled) return;
        onItemClick((0, $7k8dr.SelectItemMode).SELECTED, itemIndex);
    }, [
        onItemClick,
        itemIndex,
        itemIsDisabled
    ]);
    const customItemRef = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef(null);
    const buttonItemRef = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef(null);
    const shouldUpdateFocus = selectedIndex === itemIndex && !isFirstEnabledIndex;
    const listItemClasses = (0, $eJOHy.useMemo)(()=>{
        return [
            $29897f3555837a9c$var$selectionFrame,
            isSelected && !itemIsDisabled && $29897f3555837a9c$var$selectedStyle
        ];
    }, [
        isSelected,
        itemIsDisabled
    ]);
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (shouldUpdateFocus) customItemRef?.current?.focus();
    }, [
        customItemRef,
        shouldUpdateFocus
    ]);
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (shouldUpdateFocus) buttonItemRef?.current?.focus();
    }, [
        buttonItemRef,
        shouldUpdateFocus
    ]);
    if (customRenderItem) return /*#__PURE__*/ (0, $1NIU8.jsx)($29897f3555837a9c$var$CustomItemComponentWrapper, {
        itemIsDisabled: itemIsDisabled,
        customRenderItem: customRenderItem,
        isSelected: isSelected,
        ariaLabel: ariaLabel,
        itemsLength: itemsLength,
        customItemRef: customItemRef,
        insertSelectedItem: insertSelectedItem,
        itemIndex: itemIndex
    });
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        css: listItemClasses
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $7saMl.default), {
        onClick: insertSelectedItem,
        iconBefore: elementIcon,
        isSelected: isSelected,
        "aria-selected": isSelected,
        "aria-label": title,
        // TODO: ED-26959 - aria-description is in draft for ARIA 1.3.
        // For now replace it with aria-describedby.
        // eslint-disable-next-line jsx-a11y/aria-props
        "aria-description": `${descriptionText} ${shortcutText}`,
        "aria-setsize": itemsLength,
        "aria-posinset": itemIndex,
        role: "option",
        ref: buttonItemRef,
        isDisabled: itemIsDisabled,
        // @ts-ignore
        css: listItemClasses
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        "aria-hidden": true
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: [
            $29897f3555837a9c$var$itemText
        ]
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $29897f3555837a9c$var$itemBody
    }, /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: [
            $29897f3555837a9c$var$itemTitle,
            moreElementsInQuickInsertViewEnabled && $29897f3555837a9c$var$itemTitleOverride,
            itemIsDisabled && $29897f3555837a9c$var$disabledStyle
        ]
    }, item.title), /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: $29897f3555837a9c$var$itemAfter
    }, item.keyshortcut && /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: (0, $2dMzB.shortcutStyle)
    }, item.keyshortcut))), /*#__PURE__*/ (0, $1NIU8.jsx)("div", {
        css: [
            $29897f3555837a9c$var$itemDescription,
            moreElementsInQuickInsertViewEnabled && $29897f3555837a9c$var$itemDescriptionOverride,
            itemIsDisabled && $29897f3555837a9c$var$disabledStyle
        ]
    }, item.description))))));
});

});
parcelRegister("ehOis", function(module, exports) {

$parcel$export(module.exports, "default", () => $62cead323ec6543a$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $9phuu = parcelRequire("9phuu");
function $62cead323ec6543a$export$2e2bcd8739ae039() {
    const { iconThemed: iconThemed } = (0, $9phuu.useIconThemed)();
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("svg", {
        focusable: "false",
        "aria-hidden": true,
        width: 40,
        height: 40,
        viewBox: "0 0 40 40",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        x1: "-26.046%",
                        y1: "100%",
                        x2: "62.626%",
                        y2: "0%",
                        id: "fallback-a",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#B3BAC5",
                                offset: "0%"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#A5ADBA",
                                offset: "100%"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsxs)("linearGradient", {
                        x1: "-12.24%",
                        y1: "100%",
                        x2: "82.44%",
                        y2: "0%",
                        id: "fallback-b",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#5A6977",
                                offset: "0%"
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsx)("stop", {
                                stopColor: "#454F59",
                                offset: "100%"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)("g", {
                fill: "none",
                fillRule: "evenodd",
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        fill: iconThemed({
                            light: '#FFF',
                            dark: '#161A1D'
                        }),
                        d: "M0 0h40v40H0z"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        fill: iconThemed({
                            light: '#DFE1E6',
                            dark: '#738496'
                        }),
                        d: "M20 16h12v12H20z"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        fill: iconThemed({
                            light: 'url(#fallback-a)',
                            dark: 'url(#fallback-b)'
                        }),
                        d: "M8 16h12v12H8z"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        d: "M20 16c-4 .5-6.029 2.5-6.086 6-.057 3.5-2.028 5.5-5.914 6h12V16z",
                        fill: iconThemed({
                            light: '#A5ADBA',
                            dark: '#454F59'
                        })
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        fill: iconThemed({
                            light: '#B3BAC5',
                            dark: '#454F59'
                        }),
                        d: "M17.5 13h5v3h-5z"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        fill: iconThemed({
                            light: '#A5ADBA',
                            dark: '#454F59'
                        }),
                        d: "M10 13h5v3h-5z"
                    }),
                    /*#__PURE__*/ (0, $gt9Am.jsx)("path", {
                        fill: iconThemed({
                            light: '#DFE1E6',
                            dark: '#738496'
                        }),
                        d: "M25 13h5v3h-5z"
                    })
                ]
            })
        ]
    });
}

});
parcelRegister("9phuu", function(module, exports) {

$parcel$export(module.exports, "useIconThemed", () => $ab6df4a546216f42$export$a38bb9a8c9e5bc30);

var $58yRG = parcelRequire("58yRG");
const $ab6df4a546216f42$export$a38bb9a8c9e5bc30 = ()=>{
    const { colorMode: colorMode } = (0, $58yRG.default)();
    return {
        iconThemed: (colors)=>{
            return colorMode && colorMode === 'dark' ? colors['dark'] : colors['light'];
        }
    };
};

});









parcelRegister("7PYeO", function(module, exports) {

$parcel$export(module.exports, "undoRedoPlugin", () => (parcelRequire("7x7fd")).undoRedoPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $7x7fd = parcelRequire("7x7fd");

});
parcelRegister("7x7fd", function(module, exports) {

$parcel$export(module.exports, "undoRedoPlugin", () => $5158f565596032d3$export$dcdc7fc7ecd3098);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $bMFKb = parcelRequire("bMFKb");

var $i8KtF = parcelRequire("i8KtF");

var $kuxd1 = parcelRequire("kuxd1");

var $92xoS = parcelRequire("92xoS");

var $jvN3K = parcelRequire("jvN3K");

var $fPFkB = parcelRequire("fPFkB");

var $jf4Bo = parcelRequire("jf4Bo");

var $f8UNf = parcelRequire("f8UNf");

var $11Bry = parcelRequire("11Bry");

var $jblf6 = parcelRequire("jblf6");
const $5158f565596032d3$export$dcdc7fc7ecd3098 = ({ api: api })=>{
    const editorViewRef = {
        current: null
    };
    const primaryToolbarComponent = ({ editorView: editorView, disabled: disabled, isToolbarReducedSpacing: isToolbarReducedSpacing })=>{
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $jblf6.default), {
            isReducedSpacing: isToolbarReducedSpacing,
            disabled: disabled,
            editorView: editorView,
            api: api
        });
    };
    api?.primaryToolbar?.actions.registerComponent({
        name: 'undoRedoPlugin',
        component: primaryToolbarComponent
    });
    const handleUndo = (inputSource)=>{
        if (!editorViewRef.current) return false;
        return (0, $11Bry.forceFocus)(editorViewRef.current, api)((0, $jvN3K.attachInputMetaWithAnalytics)(api?.analytics?.actions)(inputSource || (0, $fPFkB.InputSource).EXTERNAL, (0, $bMFKb.ACTION).UNDO_PERFORMED)((0, $kuxd1.undo)));
    };
    const handleRedo = (inputSource)=>{
        if (!editorViewRef.current) return false;
        return (0, $11Bry.forceFocus)(editorViewRef.current, api)((0, $jvN3K.attachInputMetaWithAnalytics)(api?.analytics?.actions)(inputSource || (0, $fPFkB.InputSource).EXTERNAL, (0, $bMFKb.ACTION).REDO_PERFORMED)((0, $kuxd1.redo)));
    };
    return {
        name: 'undoRedoPlugin',
        actions: {
            undo: handleUndo,
            redo: handleRedo
        },
        pmPlugins () {
            const plugins = [
                {
                    name: 'undoRedoKeyMap',
                    plugin: ()=>(0, $jf4Bo.keymapPlugin)(api)
                },
                {
                    name: 'undoRedoPlugin',
                    plugin: (options)=>(0, $f8UNf.createPlugin)(options)
                }
            ];
            if ((0, $92xoS.editorExperiment)('platform_editor_controls', 'variant1', {
                exposure: false
            })) plugins.push({
                name: 'undoRedoGetEditorViewReferencePlugin',
                plugin: ()=>{
                    return new (0, $i8KtF.SafePlugin)({
                        view: (editorView)=>{
                            editorViewRef.current = editorView;
                            return {
                                destroy: ()=>{
                                    editorViewRef.current = null;
                                }
                            };
                        }
                    });
                }
            });
            return plugins;
        },
        primaryToolbarComponent: !api?.primaryToolbar ? primaryToolbarComponent : undefined
    };
};

});
parcelRegister("jvN3K", function(module, exports) {

$parcel$export(module.exports, "attachInputMeta", () => $d75f7687ad1db32a$export$84d159245233a2bb);
$parcel$export(module.exports, "attachInputMetaWithAnalytics", () => $d75f7687ad1db32a$export$5b05f10224c3caf8);

var $bMFKb = parcelRequire("bMFKb");

var $asjM0 = parcelRequire("asjM0");

var $fPFkB = parcelRequire("fPFkB");

var $kqSR6 = parcelRequire("kqSR6");
const $d75f7687ad1db32a$export$84d159245233a2bb = (inputSource)=>(command)=>(state, dispatch)=>{
            let customTr = state.tr;
            const fakeDispatch = (tr)=>{
                customTr = tr;
            };
            command(state, fakeDispatch);
            if (!customTr || !customTr.docChanged) return false;
            customTr.setMeta((0, $kqSR6.pluginKey), inputSource);
            if (dispatch) dispatch(customTr);
            return true;
        };
const $d75f7687ad1db32a$var$inputSourceToInputMethod = (inputSource)=>{
    switch(inputSource){
        case (0, $fPFkB.InputSource).EXTERNAL:
            return (0, $bMFKb.INPUT_METHOD).EXTERNAL;
        case (0, $fPFkB.InputSource).KEYBOARD:
            return (0, $bMFKb.INPUT_METHOD).KEYBOARD;
        case (0, $fPFkB.InputSource).TOOLBAR:
            return (0, $bMFKb.INPUT_METHOD).TOOLBAR;
        default:
            return (0, $bMFKb.INPUT_METHOD).EXTERNAL;
    }
};
const $d75f7687ad1db32a$export$5b05f10224c3caf8 = (editorAnalyticsAPI)=>(inputSource, action)=>(command)=>$d75f7687ad1db32a$export$84d159245233a2bb(inputSource)((0, $asjM0.withAnalytics)(editorAnalyticsAPI, {
                eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
                action: action,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).EDITOR,
                attributes: {
                    inputMethod: $d75f7687ad1db32a$var$inputSourceToInputMethod(inputSource)
                }
            })(command));

});
parcelRegister("fPFkB", function(module, exports) {

$parcel$export(module.exports, "InputSource", () => $72ae06c597f8cb38$export$c3de12c0810a343d);

var $bMFKb = parcelRequire("bMFKb");
var $72ae06c597f8cb38$export$c3de12c0810a343d = /*#__PURE__*/ function(InputSource) {
    InputSource[InputSource["TOOLBAR"] = (0, $bMFKb.INPUT_METHOD).TOOLBAR] = "TOOLBAR";
    InputSource[InputSource["KEYBOARD"] = (0, $bMFKb.INPUT_METHOD).KEYBOARD] = "KEYBOARD";
    InputSource[InputSource["EXTERNAL"] = (0, $bMFKb.INPUT_METHOD).EXTERNAL] = "EXTERNAL";
    return InputSource;
}({});

});

parcelRegister("kqSR6", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $473f2ab148b92cf8$export$18d4026d1ea86bb1);

var $3lIcL = parcelRequire("3lIcL");
const $473f2ab148b92cf8$export$18d4026d1ea86bb1 = new (0, $3lIcL.PluginKey)('undoRedoPlugin');

});


parcelRegister("jf4Bo", function(module, exports) {

$parcel$export(module.exports, "keymapPlugin", () => $225e904905b1b745$export$e832373cff8dec22);

var $6Exgk = parcelRequire("6Exgk");

var $i8KtF = parcelRequire("i8KtF");

var $x7sgX = parcelRequire("x7sgX");

var $eGOwo = parcelRequire("eGOwo");

var $g7OpL = parcelRequire("g7OpL");
function $225e904905b1b745$export$e832373cff8dec22(api) {
    const list = {};
    (0, $6Exgk.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $6Exgk.findKeyMapForBrowser)((0, $6Exgk.redo)), (0, $g7OpL.redoFromKeyboardWithAnalytics)(api?.analytics?.actions), list);
    if ((0, $eGOwo.fg)('platform_editor_cmd_y_mac_redo_shortcut')) (0, $6Exgk.bindKeymapWithCommand)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $6Exgk.findKeyMapForBrowser)((0, $6Exgk.redoAlt)), (0, $g7OpL.redoFromKeyboardWithAnalytics)(api?.analytics?.actions), list);
    (0, $6Exgk.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $6Exgk.undo).common, (0, $g7OpL.undoFromKeyboardWithAnalytics)(api?.analytics?.actions), list);
    return new (0, $i8KtF.SafePlugin)({
        props: {
            handleKeyDown (view, event) {
                const keyboardEvent = (0, $6Exgk.isCapsLockOnAndModifyKeyboardEvent)(event);
                return (0, $x7sgX.keydownHandler)(list)(view, keyboardEvent);
            }
        }
    });
}

});
parcelRegister("g7OpL", function(module, exports) {

$parcel$export(module.exports, "undoFromKeyboardWithAnalytics", () => $7b0dfd7da88bc31d$export$4c45d895aa8430e8);
$parcel$export(module.exports, "redoFromKeyboardWithAnalytics", () => $7b0dfd7da88bc31d$export$1f3073e8f226f307);
$parcel$export(module.exports, "undoFromToolbarWithAnalytics", () => $7b0dfd7da88bc31d$export$a9ef7677c700995e);
$parcel$export(module.exports, "redoFromToolbarWithAnalytics", () => $7b0dfd7da88bc31d$export$1746c262152d0cc4);

var $bMFKb = parcelRequire("bMFKb");

var $kuxd1 = parcelRequire("kuxd1");

var $jvN3K = parcelRequire("jvN3K");

var $fPFkB = parcelRequire("fPFkB");
const $7b0dfd7da88bc31d$export$1d1a6834315b2876 = (0, $jvN3K.attachInputMeta)((0, $fPFkB.InputSource).KEYBOARD)((0, $kuxd1.undo));
const $7b0dfd7da88bc31d$export$b51f9da6d7e523d2 = (0, $jvN3K.attachInputMeta)((0, $fPFkB.InputSource).KEYBOARD)((0, $kuxd1.redo));
const $7b0dfd7da88bc31d$export$841850d252e034f0 = (0, $jvN3K.attachInputMeta)((0, $fPFkB.InputSource).TOOLBAR)((0, $kuxd1.undo));
const $7b0dfd7da88bc31d$export$11ad0a77a5cc0ccf = (0, $jvN3K.attachInputMeta)((0, $fPFkB.InputSource).TOOLBAR)((0, $kuxd1.redo));
const $7b0dfd7da88bc31d$export$4c45d895aa8430e8 = (editorAnalyticsAPI)=>(0, $jvN3K.attachInputMetaWithAnalytics)(editorAnalyticsAPI)((0, $fPFkB.InputSource).KEYBOARD, (0, $bMFKb.ACTION).UNDO_PERFORMED)((0, $kuxd1.undo));
const $7b0dfd7da88bc31d$export$1f3073e8f226f307 = (editorAnalyticsAPI)=>(0, $jvN3K.attachInputMetaWithAnalytics)(editorAnalyticsAPI)((0, $fPFkB.InputSource).KEYBOARD, (0, $bMFKb.ACTION).REDO_PERFORMED)((0, $kuxd1.redo));
const $7b0dfd7da88bc31d$export$a9ef7677c700995e = (editorAnalyticsAPI)=>(0, $jvN3K.attachInputMetaWithAnalytics)(editorAnalyticsAPI)((0, $fPFkB.InputSource).TOOLBAR, (0, $bMFKb.ACTION).UNDO_PERFORMED)((0, $kuxd1.undo));
const $7b0dfd7da88bc31d$export$1746c262152d0cc4 = (editorAnalyticsAPI)=>(0, $jvN3K.attachInputMetaWithAnalytics)(editorAnalyticsAPI)((0, $fPFkB.InputSource).TOOLBAR, (0, $bMFKb.ACTION).REDO_PERFORMED)((0, $kuxd1.redo));

});


parcelRegister("f8UNf", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $f909e353a6678d69$export$ae829ec7b2625219);

var $i8KtF = parcelRequire("i8KtF");

var $kqSR6 = parcelRequire("kqSR6");
const $f909e353a6678d69$export$ae829ec7b2625219 = ({ dispatch: dispatch })=>{
    return new (0, $i8KtF.SafePlugin)({
        key: (0, $kqSR6.pluginKey)
    });
};

});

parcelRegister("11Bry", function(module, exports) {

$parcel$export(module.exports, "forceFocus", () => $2a05b775e79f2493$export$4126ecb6f20789f0);
const $2a05b775e79f2493$export$2c9048c8abe91d0d = (editorView, api)=>(command)=>{
        if (!editorView) return false;
        if (api?.typeAhead?.actions?.isOpen(editorView.state)) api?.typeAhead?.actions?.close({
            attachCommand: command,
            insertCurrentQueryAsRawText: false
        });
        else command(editorView.state, editorView.dispatch);
        return true;
    };
const $2a05b775e79f2493$export$4126ecb6f20789f0 = (editorView, api)=>(command)=>{
        const result = $2a05b775e79f2493$export$2c9048c8abe91d0d(editorView, api)(command);
        if (result && !editorView.hasFocus()) editorView.focus();
        return result;
    };

});

parcelRegister("jblf6", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4c04e1f4b5c9215$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $1NIU8 = parcelRequire("1NIU8");

var $6YFG2 = parcelRequire("6YFG2");

var $kLQ9a = parcelRequire("kLQ9a");
var $bSToC = parcelRequire("bSToC");
var $cxXTK = parcelRequire("cxXTK");

var $6Exgk = parcelRequire("6Exgk");

var $iW8Cl = parcelRequire("iW8Cl");

var $fcJnk = parcelRequire("fcJnk");

var $2pk5j = parcelRequire("2pk5j");
var $9Sic1 = parcelRequire("9Sic1");

var $f3diu = parcelRequire("f3diu");

var $6Sw2l = parcelRequire("6Sw2l");

var $eGOwo = parcelRequire("eGOwo");

var $g7OpL = parcelRequire("g7OpL");

var $11Bry = parcelRequire("11Bry");
const $c4c04e1f4b5c9215$var$useSharedState = (0, $kLQ9a.sharedPluginStateHookMigratorFactory)((api)=>{
    const { canRedo: canRedo, canUndo: canUndo } = (0, $cxXTK.useSharedPluginStateWithSelector)(api, [
        'history'
    ], (states)=>({
            canUndo: states.historyState?.canUndo,
            canRedo: states.historyState?.canRedo
        }));
    return {
        canUndo: canUndo,
        canRedo: canRedo
    };
}, (api)=>{
    const { historyState: historyState } = (0, $bSToC.useSharedPluginState)(api, [
        'history'
    ]);
    return {
        canUndo: historyState?.canUndo,
        canRedo: historyState?.canRedo
    };
});
const $c4c04e1f4b5c9215$export$4a0f2fb817767d20 = ({ disabled: disabled, isReducedSpacing: isReducedSpacing, editorView: editorView, api: api, intl: { formatMessage: formatMessage } })=>{
    const { canUndo: canUndo, canRedo: canRedo } = $c4c04e1f4b5c9215$var$useSharedState(api);
    const handleUndo = ()=>{
        (0, $11Bry.forceFocus)(editorView, api)((0, $g7OpL.undoFromToolbarWithAnalytics)(api?.analytics?.actions));
    };
    const handleRedo = ()=>{
        (0, $11Bry.forceFocus)(editorView, api)((0, $g7OpL.redoFromToolbarWithAnalytics)(api?.analytics?.actions));
    };
    const labelUndo = formatMessage((0, $iW8Cl.messages).undo);
    const labelRedo = formatMessage((0, $iW8Cl.messages).redo);
    const redoKeymap = (0, $eGOwo.fg)('platform_editor_cmd_y_mac_redo_shortcut') ? (0, $6Exgk.redoAlt) : (0, $6Exgk.redo);
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        css: // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-registration, @atlaskit/platform/ensure-feature-flag-prefix
        (0, $eGOwo.fg)('platform-visual-refresh-icons') ? // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
        (0, $fcJnk.buttonGroupStyle) : // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
        (0, $fcJnk.buttonGroupStyleBeforeVisualRefresh)
    }, /*#__PURE__*/ (0, $1NIU8.jsx)((0, $9Sic1.default), {
        buttonId: (0, $2pk5j.TOOLBAR_ACTION_SUBJECT_ID).UNDO,
        spacing: isReducedSpacing ? 'none' : 'default',
        onClick: handleUndo,
        disabled: !canUndo || disabled,
        "aria-label": (0, $6Exgk.tooltip)((0, $6Exgk.undo), labelUndo),
        "aria-keyshortcuts": (0, $6Exgk.getAriaKeyshortcuts)((0, $6Exgk.undo)),
        title: /*#__PURE__*/ (0, $1NIU8.jsx)((0, $6Exgk.ToolTipContent), {
            description: labelUndo,
            keymap: (0, $6Exgk.undo)
        }),
        iconBefore: /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6Sw2l))), {
            label: "",
            color: "currentColor",
            spacing: "spacious"
        }),
        testId: "ak-editor-toolbar-button-undo"
    }), /*#__PURE__*/ (0, $1NIU8.jsx)((0, $9Sic1.default), {
        spacing: isReducedSpacing ? 'none' : 'default',
        buttonId: (0, $2pk5j.TOOLBAR_ACTION_SUBJECT_ID).REDO,
        onClick: handleRedo,
        disabled: !canRedo || disabled,
        title: /*#__PURE__*/ (0, $1NIU8.jsx)((0, $6Exgk.ToolTipContent), {
            description: labelRedo,
            keymap: redoKeymap
        }),
        iconBefore: /*#__PURE__*/ (0, $1NIU8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f3diu))), {
            label: "",
            color: "currentColor",
            spacing: "spacious"
        }),
        testId: "ak-editor-toolbar-button-redo",
        "aria-label": (0, $6Exgk.tooltip)(redoKeymap, labelRedo),
        "aria-keyshortcuts": (0, $6Exgk.getAriaKeyshortcuts)(redoKeymap)
    }), !api?.primaryToolbar && /* eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $1NIU8.jsx)("span", {
        css: (0, $fcJnk.separatorStyles)
    })));
};
var $c4c04e1f4b5c9215$export$2e2bcd8739ae039 = (0, $6YFG2.default)($c4c04e1f4b5c9215$export$4a0f2fb817767d20);

});
parcelRegister("f3diu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d059f3ea6105a0395a3e73a1cc411ccd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $af51735ccfb871b5$var$_react = $af51735ccfb871b5$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $af51735ccfb871b5$var$_redo = $af51735ccfb871b5$var$_interopRequireDefault((parcelRequire("koO2z")));

var $af51735ccfb871b5$var$_redo2 = $af51735ccfb871b5$var$_interopRequireDefault((parcelRequire("f87hJ")));
function $af51735ccfb871b5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for RedoIcon.
 * This component is RedoIcon, with `UNSAFE_fallbackIcon` set to "RedoIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for redo in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $af51735ccfb871b5$var$RedoIcon = (props)=>/*#__PURE__*/ $af51735ccfb871b5$var$_react.default.createElement($af51735ccfb871b5$var$_redo.default, Object.assign({
        LEGACY_fallbackIcon: $af51735ccfb871b5$var$_redo2.default
    }, props));
$af51735ccfb871b5$var$RedoIcon.Name = 'RedoIconMigration';
var $af51735ccfb871b5$var$_default = module.exports.default = $af51735ccfb871b5$var$RedoIcon;

});
parcelRegister("koO2z", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8f579057b3cb3a0df31aba248715041d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ed9cdd8d1e61d1b9$var$_react = $ed9cdd8d1e61d1b9$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $ed9cdd8d1e61d1b9$var$_baseNew = $ed9cdd8d1e61d1b9$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $ed9cdd8d1e61d1b9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Redo".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for redo in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ed9cdd8d1e61d1b9$var$RedoIcon = (props)=>/*#__PURE__*/ $ed9cdd8d1e61d1b9$var$_react.default.createElement($ed9cdd8d1e61d1b9$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m14.78 4.72-3.5-3.5-1.06 1.06 2.22 2.22H5.75a4.75 4.75 0 1 0 0 9.5H8v-1.5H5.75a3.25 3.25 0 0 1 0-6.5h6.69l-2.22 2.22 1.06 1.06 3.5-3.5a.75.75 0 0 0 0-1.06" clip-rule="evenodd"/>`
    }, props));
$ed9cdd8d1e61d1b9$var$RedoIcon.displayName = 'RedoIcon';
var $ed9cdd8d1e61d1b9$var$_default = module.exports.default = $ed9cdd8d1e61d1b9$var$RedoIcon;

});

parcelRegister("f87hJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b03d41071f793c81$var$_react = $b03d41071f793c81$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $b03d41071f793c81$var$_redo = $b03d41071f793c81$var$_interopRequireDefault((parcelRequire("koO2z")));
function $b03d41071f793c81$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $b03d41071f793c81$var$RedoIcon = (props)=>/*#__PURE__*/ $b03d41071f793c81$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M4.101 13.569c-.247.5-.026 1.095.493 1.333.52.237 1.142.025 1.388-.473C7.011 12.351 9.193 11 11.63 11c2.266 0 4.319 1.167 5.425 3.021.286.479.922.645 1.421.371a.98.98 0 0 0 .386-1.366C17.389 10.557 14.65 9 11.63 9c-3.247 0-6.158 1.802-7.529 4.569"/><path d="M17.497 10v3h-2.995a1 1 0 1 0 0 2h3.896c.608 0 1.102-.493 1.102-1.1V10a1.001 1.001 0 0 0-2.003 0"/></g></svg>`
    }, props, {
        newIcon: $b03d41071f793c81$var$_redo.default
    }));
$b03d41071f793c81$var$RedoIcon.displayName = 'RedoIcon';
var $b03d41071f793c81$var$_default = module.exports.default = $b03d41071f793c81$var$RedoIcon;

});


parcelRegister("6Sw2l", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2818f986336a4a51aa47fe5286974737>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5020a3146797c819$var$_react = $5020a3146797c819$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $5020a3146797c819$var$_undo = $5020a3146797c819$var$_interopRequireDefault((parcelRequire("fwcMD")));

var $5020a3146797c819$var$_undo2 = $5020a3146797c819$var$_interopRequireDefault((parcelRequire("2YhMX")));
function $5020a3146797c819$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for UndoIcon.
 * This component is UndoIcon, with `UNSAFE_fallbackIcon` set to "UndoIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for undo in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5020a3146797c819$var$UndoIcon = (props)=>/*#__PURE__*/ $5020a3146797c819$var$_react.default.createElement($5020a3146797c819$var$_undo.default, Object.assign({
        LEGACY_fallbackIcon: $5020a3146797c819$var$_undo2.default
    }, props));
$5020a3146797c819$var$UndoIcon.Name = 'UndoIconMigration';
var $5020a3146797c819$var$_default = module.exports.default = $5020a3146797c819$var$UndoIcon;

});
parcelRegister("fwcMD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2edf8e8e6d811ed80e747695771356e6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b4c3c2af49004355$var$_react = $b4c3c2af49004355$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $b4c3c2af49004355$var$_baseNew = $b4c3c2af49004355$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $b4c3c2af49004355$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Undo".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for undo in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b4c3c2af49004355$var$UndoIcon = (props)=>/*#__PURE__*/ $b4c3c2af49004355$var$_react.default.createElement($b4c3c2af49004355$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m1.22 4.72 3.5-3.5 1.06 1.06L3.56 4.5h6.69a4.75 4.75 0 1 1 0 9.5H8v-1.5h2.25a3.25 3.25 0 0 0 0-6.5H3.56l2.22 2.22-1.06 1.06-3.5-3.5a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>`
    }, props));
$b4c3c2af49004355$var$UndoIcon.displayName = 'UndoIcon';
var $b4c3c2af49004355$var$_default = module.exports.default = $b4c3c2af49004355$var$UndoIcon;

});

parcelRegister("2YhMX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $229efbd4faa5d242$var$_react = $229efbd4faa5d242$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $229efbd4faa5d242$var$_undo = $229efbd4faa5d242$var$_interopRequireDefault((parcelRequire("fwcMD")));
function $229efbd4faa5d242$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $229efbd4faa5d242$var$UndoIcon = (props)=>/*#__PURE__*/ $229efbd4faa5d242$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M5.138 13.026a.98.98 0 0 0 .386 1.366 1.066 1.066 0 0 0 1.421-.371C8.051 12.167 10.104 11 12.37 11c2.437 0 4.619 1.351 5.648 3.429.246.498.868.71 1.388.473.519-.238.74-.833.493-1.333C18.528 10.802 15.618 9 12.37 9c-3.02 0-5.759 1.557-7.232 4.026"/><path d="M4.5 10v3.9c0 .607.494 1.1 1.102 1.1h3.896a1 1 0 1 0 0-2H6.503v-3A1 1 0 0 0 4.5 10"/></g></svg>`
    }, props, {
        newIcon: $229efbd4faa5d242$var$_undo.default
    }));
$229efbd4faa5d242$var$UndoIcon.displayName = 'UndoIcon';
var $229efbd4faa5d242$var$_default = module.exports.default = $229efbd4faa5d242$var$UndoIcon;

});





parcelRegister("cb4jP", function(module, exports) {

$parcel$export(module.exports, "widthPlugin", () => (parcelRequire("6nO4A")).widthPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $6nO4A = parcelRequire("6nO4A");

});
parcelRegister("6nO4A", function(module, exports) {

$parcel$export(module.exports, "widthPlugin", () => $72e85f3fdeab57b6$export$8cdf857cb01de6dc);

var $1DmqU = parcelRequire("1DmqU");

var $92xoS = parcelRequire("92xoS");

var $entno = parcelRequire("entno");

var $9SRPl = parcelRequire("9SRPl");

var $cDlCx = parcelRequire("cDlCx");
const $72e85f3fdeab57b6$var$useResizeWidthObserverHook = (0, $1DmqU.conditionalHooksFactory)(()=>(0, $92xoS.editorExperiment)('platform_editor_stop_width_reflows', true, {
        exposure: true
    }), (0, $cDlCx.useResizeWidthObserver), (0, $cDlCx.useResizeWidthObserverLegacy));
const $72e85f3fdeab57b6$export$8cdf857cb01de6dc = ()=>{
    return {
        name: 'width',
        pmPlugins: ()=>[
                {
                    name: 'width',
                    plugin: ({ dispatch: dispatch })=>(0, $entno.createPlugin)(dispatch)
                }
            ],
        getSharedState: (editorState)=>{
            if (!editorState) return undefined;
            return (0, $9SRPl.pluginKey).getState(editorState);
        },
        usePluginHook: $72e85f3fdeab57b6$var$useResizeWidthObserverHook
    };
};

});
parcelRegister("entno", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $4d2585b75b5727d8$export$ae829ec7b2625219);

var $i8KtF = parcelRequire("i8KtF");

var $7yBx7 = parcelRequire("7yBx7");

var $92xoS = parcelRequire("92xoS");

var $9SRPl = parcelRequire("9SRPl");
function $4d2585b75b5727d8$export$ae829ec7b2625219(dispatch) {
    return new (0, $i8KtF.SafePlugin)({
        key: (0, $9SRPl.pluginKey),
        state: {
            init: ()=>{
                if ((0, $92xoS.editorExperiment)('platform_editor_stop_width_reflows', true)) return {
                    // Optimise for default laptop MDPI width - this will update with the resize observer
                    width: (0, $7yBx7.VIEWPORT_SIZES).laptopMDPI.width,
                    // Use the default width - if full width or small it will update with resize observer
                    lineLength: (0, $7yBx7.akEditorDefaultLayoutWidth)
                };
                else return {
                    width: document.body.offsetWidth
                };
            },
            apply (tr, pluginState) {
                const meta = tr.getMeta((0, $9SRPl.pluginKey));
                if (!meta) return pluginState;
                const newPluginState = (0, $92xoS.editorExperiment)('platform_editor_stop_width_reflows', true) ? {
                    width: meta.width ?? pluginState?.width,
                    lineLength: meta.lineLength ?? pluginState?.lineLength
                } : {
                    ...pluginState,
                    ...meta
                };
                if (newPluginState && (pluginState.width !== newPluginState.width || pluginState.lineLength !== newPluginState.lineLength)) {
                    dispatch((0, $9SRPl.pluginKey), newPluginState);
                    return newPluginState;
                }
                return pluginState;
            }
        }
    });
}

});
parcelRegister("9SRPl", function(module, exports) {

$parcel$export(module.exports, "pluginKey", () => $4c7a23609e8b8f98$export$18d4026d1ea86bb1);

var $3lIcL = parcelRequire("3lIcL");
const $4c7a23609e8b8f98$export$18d4026d1ea86bb1 = new (0, $3lIcL.PluginKey)('widthPlugin');

});


parcelRegister("cDlCx", function(module, exports) {

$parcel$export(module.exports, "useResizeWidthObserver", () => $9c432c80c3e11e9f$export$b0f894529c6bfe0a);
$parcel$export(module.exports, "useResizeWidthObserverLegacy", () => $9c432c80c3e11e9f$export$9a025523457e85c9);

var $eJOHy = parcelRequire("eJOHy");

var $9SRPl = parcelRequire("9SRPl");

var $hdv9o = parcelRequire("hdv9o");
const $9c432c80c3e11e9f$export$33d12d97a81b0d33 = (props)=>(editorView)=>{
        const { dispatch: dispatch, state: { tr: tr } } = editorView;
        tr.setMeta((0, $9SRPl.pluginKey), props);
        dispatch(tr);
    };
function $9c432c80c3e11e9f$export$b0f894529c6bfe0a({ editorView: editorView, containerElement: containerElement }) {
    (0, $hdv9o.useRefreshWidthOnTransition)(containerElement);
    (0, $eJOHy.useEffect)(()=>{
        const resizeWidth = (entries)=>{
            if (entries.length < 1) return;
            const fullAreaSize = entries.find((entry)=>entry.target === containerElement);
            const editorViewDOMSize = entries.find((entry)=>entry.target === editorView.dom);
            const width = fullAreaSize?.borderBoxSize[0]?.inlineSize;
            const lineLength = editorViewDOMSize?.borderBoxSize[0]?.inlineSize;
            $9c432c80c3e11e9f$export$33d12d97a81b0d33({
                width: width,
                lineLength: lineLength
            })(editorView);
        };
        const resizeObserver = new ResizeObserver(resizeWidth);
        if (containerElement) resizeObserver.observe(containerElement);
        if (editorView.dom) resizeObserver.observe(editorView.dom);
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        containerElement,
        editorView
    ]);
}
const $9c432c80c3e11e9f$export$9a025523457e85c9 = ({ editorView: editorView, containerElement: containerElement })=>{
    (0, $hdv9o.useRefreshWidthOnTransition)(containerElement);
    (0, $eJOHy.useEffect)(()=>{
        const newState = {
            lineLength: editorView.dom.clientWidth,
            width: containerElement?.offsetWidth
        };
        $9c432c80c3e11e9f$export$33d12d97a81b0d33(newState)(editorView);
    }, [
        editorView,
        editorView.dom.clientWidth,
        containerElement
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const resizeWidth = (entries)=>{
            if (entries.length !== 1) return;
            const [fullAreaSize] = entries;
            if (!fullAreaSize || !Array.isArray(fullAreaSize.borderBoxSize)) return;
            const width = fullAreaSize.borderBoxSize[0].inlineSize;
            const lineLength = editorView.dom.clientWidth;
            $9c432c80c3e11e9f$export$33d12d97a81b0d33({
                width: width,
                lineLength: lineLength
            })(editorView);
        };
        const resizeObserver = new ResizeObserver(resizeWidth);
        if (containerElement) resizeObserver.observe(containerElement);
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        containerElement,
        editorView
    ]);
};

});
parcelRegister("hdv9o", function(module, exports) {

$parcel$export(module.exports, "useRefreshWidthOnTransition", () => $fba52ff2970fce91$export$b72edfd730e58e7c);

var $eJOHy = parcelRequire("eJOHy");

var $4eDgu = parcelRequire("4eDgu");
// List of names for transition end events across browsers
const $fba52ff2970fce91$var$transitionEventNames = [
    'transitionend',
    'oTransitionEnd',
    'webkitTransitionEnd'
];
const $fba52ff2970fce91$export$b72edfd730e58e7c = (containerElement)=>{
    const [_, setLastWidthEvent] = (0, $eJOHy.useState)();
    (0, $eJOHy.useEffect)(()=>{
        if (!containerElement) return;
        /**
		 * Update the plugin components once the transition
		 * to full width / default mode completes
		 */ const forceComponentUpdate = (event)=>{
            // Only trigger an update if the transition is on a property containing `width`
            // This will cater for media and the content area itself currently.
            if (event.propertyName.includes('width')) setLastWidthEvent(event);
        };
        return (0, $4eDgu.bindAll)(containerElement, $fba52ff2970fce91$var$transitionEventNames.map((name)=>({
                type: name,
                listener: forceComponentUpdate
            })));
    }, [
        containerElement
    ]);
};

});






parcelRegister("aJ1QD", function(module, exports) {

$parcel$export(module.exports, "createJiraEditorPluginAIOptions", () => $d99f01bed7e90bd3$export$c89a9ef89805e05e);
/**
 * We may eventually need to split the Jira presets out to the various
 * - JSW
 * - JSM
 * - JWM
 * - JPD
 *
 * Variations, however we'll start simple for now.
 */ /**
 * Please reference
 * https://hello.atlassian.net/wiki/spaces/CONF/pages/2714833063/Gen+AI+in+Editor+EAP2+-+Product-specific+requirements
 * Also see: https://hello.atlassian.net/wiki/spaces/EDAI/pages/2731933104/Editor+AI+EAP+Part+2+Dev+Documentation+Prebuilt+Providers+Plugin+Presets
 */ 
var $kGUp7 = parcelRequire("kGUp7");

var $9WxJC = parcelRequire("9WxJC");

var $j0e54 = parcelRequire("j0e54");

var $4JeDV = parcelRequire("4JeDV");

var $bCJJn = parcelRequire("bCJJn");

var $8vHCf = parcelRequire("8vHCf");

var $cYuuz = parcelRequire("cYuuz");

var $ch4Q9 = parcelRequire("ch4Q9");

var $aZgQ3 = parcelRequire("aZgQ3");

var $79pRH = parcelRequire("79pRH");

var $dAngv = parcelRequire("dAngv");
const $d99f01bed7e90bd3$export$c89a9ef89805e05e = (options)=>{
    // Now deprecated - migrate to handleFeedbackSubmission
    const onExperienceEvent = options?.onExperienceEvent || {
        THUMBS_UP: ()=>{},
        THUMBS_DOWN: ()=>{},
        REVIEW_STATE_ENTERED: ()=>{},
        EXPERIENCE_COMPLETE: ()=>{}
    };
    // Suggest response is only enabled for JSM
    const isSuggestResponseEnabled = options.allowSuggestResponse && options.issueId !== undefined && options.product === 'JSM';
    return {
        aiGlobalOptIn: options.aiGlobalOptIn,
        baseGenerate: (0, $8vHCf.freeGenerate),
        configItemWithOptions: [
            !!options.allowIssueReformatter && (0, $cYuuz.createImproveDescriptionWithOptions)({
                getAdditionalProps: options.getAdditionalProps || (()=>({}))
            }),
            !!isSuggestResponseEnabled && (0, $4JeDV.createDraftReplyWithOptions)(options.issueId),
            (0, $aZgQ3.summarizeWritingWithOptions),
            (0, $bCJJn.improveWritingWithOptions),
            (0, $bCJJn.fixSpellingAndGrammarWithOptions),
            !isSuggestResponseEnabled && (0, $9WxJC.brainstormWithOptions),
            (0, $ch4Q9.makeShorterWithOptions),
            (0, $j0e54.changeToneToProfessionalWithOptions),
            (0, $j0e54.changeToneToEmpatheticWithOptions),
            (0, $j0e54.changeToneToCasualWithOptions),
            (0, $j0e54.changeToneToNeutralWithOptions),
            (0, $j0e54.changeToneToEducationalWithOptions),
            ...(0, $79pRH.translationConfigItemWithOptions)
        ].filter((0, $kGUp7.isEditorPluginAIConfigItemWithOptions)),
        disableAISelectionToolbar: true,
        product: options.product,
        objectId: options.issueId,
        getFetchCustomHeaders: options?.getFetchCustomHeaders || (0, $dAngv._getFetchCustomHeaders),
        onExperienceEvent: onExperienceEvent,
        handleFeedbackSubmission: options?.handleFeedbackSubmission,
        AIButtonWrapper: options.AIButtonWrapper,
        PromptEditor: options.PromptEditor,
        disableInterrogation: options.disableInterrogation ?? false,
        getChannelVariables: options.getChannelVariables,
        actionSideEffects: options.actionSideEffects,
        actionOverrides: options.actionOverrides,
        isRovoEnabled: options.isRovoEnabled ?? true,
        showRovoAgentsInCommandPalette: options.showRovoAgentsInCommandPalette ?? true,
        aiLifeCycleDynamicAttributesGetter: options.aiLifeCycleDynamicAttributesGetter,
        auditLogSettings: options.auditLogSettings,
        getAdditionalProps: options.getAdditionalProps
    };
};

});
parcelRegister("kGUp7", function(module, exports) {

$parcel$export(module.exports, "isEditorPluginAIConfigItemWithOptions", () => $90a0b6d2634bf83a$export$77a7a46521e984a3);
$parcel$export(module.exports, "getEditorPluginAIConfigItemActions", () => $90a0b6d2634bf83a$export$a64e27216c5d7416);
$parcel$export(module.exports, "getVisibleEditorPluginAIConfigItems", () => $90a0b6d2634bf83a$export$2dd2807afbd4a532);
$parcel$export(module.exports, "getAllEditorPluginAIConfigItems", () => $90a0b6d2634bf83a$export$2527a005bbcba079);
$parcel$export(module.exports, "getTranslatedItemTitle", () => $90a0b6d2634bf83a$export$d97f37f32ae9d000);
$parcel$export(module.exports, "getTranslatedPromptLabel", () => $90a0b6d2634bf83a$export$4539b8c6808af330);
function $90a0b6d2634bf83a$export$2c6858d7c847006(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
value) {
    return 'selection' in value && typeof value.selection === 'string';
}
function $90a0b6d2634bf83a$export$77a7a46521e984a3(item) {
    return !!item;
}
function $90a0b6d2634bf83a$export$475f2e7e3b5c59c4({ editorView: editorView, positions: positions, isEmpty: isEmpty, item: item }) {
    const { triggers: triggers } = item;
    const doc = editorView.state.doc;
    // Size of the doc with a single empty paragraph is 4
    const docSize = doc.nodeSize - 4;
    const selectionSize = positions[1] - positions[0];
    if (triggers.canShow && !triggers.canShow({
        editorView: editorView,
        docSize: docSize,
        selectionSize: selectionSize
    })) return false;
    const emptyOptions = triggers.empty;
    const emptyEnabled = emptyOptions.enabled;
    const docMinSize = emptyOptions.docMinSize ?? 0;
    const docMaxSize = emptyOptions.docMaxSize ?? Number.MAX_SAFE_INTEGER;
    const selectionOptions = triggers.selection;
    const selectionEnabled = selectionOptions.enabled;
    const selectionMinSize = selectionOptions.selectionMinSize ?? 1;
    const selectionMaxSize = selectionOptions.selectionMaxSize ?? Number.MAX_SAFE_INTEGER;
    if (isEmpty) {
        if (!emptyEnabled || docSize < docMinSize || docSize > docMaxSize) return false;
    } else {
        if (!selectionEnabled || selectionSize < selectionMinSize || selectionSize > selectionMaxSize) return false;
    }
    return true;
}
function $90a0b6d2634bf83a$export$a64e27216c5d7416({ isEmpty: isEmpty, configItem: configItem }) {
    if (!configItem) return [];
    const actions = (isEmpty ? configItem.actions.empty : configItem.actions.selection) ?? [];
    return actions;
}
function $90a0b6d2634bf83a$export$2dd2807afbd4a532({ configItemWithOptions: configItemWithOptions, editorView: editorView, positions: positions, isEmpty: isEmpty }) {
    const arr = [];
    configItemWithOptions.forEach((item)=>{
        if (!item) return;
        if ($90a0b6d2634bf83a$export$475f2e7e3b5c59c4({
            editorView: editorView,
            positions: positions,
            isEmpty: isEmpty,
            item: item
        })) arr.push(item.config);
    });
    return arr;
}
function $90a0b6d2634bf83a$export$2527a005bbcba079({ configItemWithOptions: configItemWithOptions }) {
    const arr = [];
    configItemWithOptions.forEach((item)=>{
        if (!item) return;
        arr.push(item.config);
    });
    return arr;
}
function $90a0b6d2634bf83a$export$d97f37f32ae9d000(configItem, formatMessage) {
    // for agents return the saved agent name in the same language as it was saved
    if (configItem.agent) {
        const presetTitle = `@${configItem.agent.name}`;
        return presetTitle || formatMessage(configItem.title);
    }
    // adding beta label for the translation prompts
    if (configItem.key.startsWith('Translate to')) return formatMessage(configItem.title);
    // for all other items return the i18n-ed title
    return formatMessage(configItem.title);
}
function $90a0b6d2634bf83a$export$4539b8c6808af330(configItem, formatMessage) {
    /**
	 * When the config item is silently using agent behind the scenes for prompt
	 * then don't show the prompt label
	 */ if (!configItem.silentAgentPrompt && configItem.agent) // for agents return the saved agent name in the same language as it was saved
    return `@${configItem.agent.name}`;
    // intentionally fall back to undefined as this value is checked to verify if we need to show the prompt input
    return configItem.promptLabel ? formatMessage(configItem.promptLabel) : undefined;
}

});

parcelRegister("9WxJC", function(module, exports) {

$parcel$export(module.exports, "brainstormWithOptions", () => $b20e22ccad8bab5e$export$dddd8d441293ae3);

var $eJOHy = parcelRequire("eJOHy");

var $izZqh = parcelRequire("izZqh");

var $3GBY8 = parcelRequire("3GBY8");

var $lxVNh = parcelRequire("lxVNh");

var $inU6j = parcelRequire("inU6j");
const $b20e22ccad8bab5e$export$683185be8e4be56f = {
    key: (0, $inU6j.CONFIG_ITEM_KEYS).BRAINSTORM,
    title: (0, $izZqh.aiConfigItemMessages).brainstormTitle,
    description: (0, $izZqh.aiConfigItemMessages).brainstormDescription,
    icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3GBY8.BrainstormIcon), null),
    promptLabel: (0, $izZqh.aiConfigItemMessages).brainstormPromptLabel,
    promptHint: (0, $izZqh.aiConfigItemMessages).brainstormPromptHint,
    doNotHighlightDocWhenSelectionIsEmpty: true,
    agentId: 'editor_agent',
    intentSchemaId: 'brainstorm_intent_schema.json',
    featureId: 'brainstorm',
    alwaysNoDocAndSelection: true,
    actions: {
        empty: [
            (0, $lxVNh.createInsertAtCurrentPosition)({
                appearance: 'primary'
            })
        ]
    },
    getBackendModel: ()=>{
        return 'assistance-service';
    }
};
const $b20e22ccad8bab5e$export$dddd8d441293ae3 = {
    config: $b20e22ccad8bab5e$export$683185be8e4be56f,
    triggers: {
        empty: {
            enabled: true,
            docMinSize: 0
        },
        selection: {
            enabled: false
        }
    }
};

});
parcelRegister("izZqh", function(module, exports) {

$parcel$export(module.exports, "aiConfigItemMessages", () => $887c31c2aa01f47c$export$e990f5ed7dd48de5);

var $7qGN1 = parcelRequire("7qGN1");
const $887c31c2aa01f47c$export$e990f5ed7dd48de5 = (0, $7qGN1.defineMessages)({
    // Agent config messages
    agentConfigTitle: {
        id: 'fabric.editor.ai.config.item.agent.title',
        defaultMessage: 'Atlassian Intelligence Rovo Agent',
        description: 'Title for the menu item of the Atlassian Intelligence agent without a predefined name.'
    },
    agentConfigDescription: {
        id: 'fabric.editor.ai.config.item.range.agent.description',
        defaultMessage: 'No description',
        description: 'Subtitle for the menu item of the Atlassian Intelligence agent without a predefined description.'
    },
    agentConfigPromptHint: {
        id: 'fabric.editor.ai.config.item.range.agent.prompt.hint',
        defaultMessage: 'Tell the Agent to write anything or choose from below',
        description: 'Hint text for the prompt input when interacting with the Atlassian Intelligence'
    },
    // Config action messages
    configActionInsert: {
        id: 'fabric.editor.ai.config.item.action.insert',
        defaultMessage: 'Insert',
        description: 'Inserts the response at the current location'
    },
    configActionInsertAtTop: {
        id: 'fabric.editor.ai.config.item.action.insertAtTop',
        defaultMessage: 'Insert at top',
        description: 'Inserts the response at the start of the content'
    },
    configActionInsertBelow: {
        id: 'fabric.editor.ai.config.item.action.insertBelow',
        defaultMessage: 'Insert below',
        description: 'Inserts the response below the current location'
    },
    configActionInsertBelowOriginal: {
        id: 'fabric.editor.ai.config.item.action.insertBelowOriginal',
        defaultMessage: 'Insert below original',
        description: 'Inserts the response below the original content'
    },
    configActionReplace: {
        id: 'fabric.editor.ai.config.item.action.replace',
        defaultMessage: 'Replace',
        description: 'Replaces the existing or selected content with the response'
    },
    configActionReplaceTitle: {
        id: 'fabric.editor.ai.config.item.action.replaceTitle',
        defaultMessage: 'Replace title',
        description: 'Replaces the existing Confluence document title with the generated title'
    },
    configActionReplaceTitleTooLongDisabledTooltip: {
        id: 'fabric.editor.ai.config.item.action.replaceTitleTooLongDisabledTooltip',
        defaultMessage: 'Title cannot exceed {maxLength} characters',
        description: 'Tooltip that appears over disabled action button when disabled because of title being too long'
    },
    configActionContinueInChatLabel: {
        id: 'fabric.editor.ai.config.item.action.rovoAgents.continueInChatLabel',
        defaultMessage: 'Open in Chat',
        description: 'Tooltip and label for Open in Chat button'
    },
    configActionContinueChatLabel: {
        id: 'fabric.editor.ai.config.item.action.rovoAgents.contineChatLabel',
        defaultMessage: 'Continue in chat',
        description: 'Tooltip and label for Continue in chat button'
    },
    configActionEdit: {
        id: 'fabric.editor.ai.config.item.action.edit',
        defaultMessage: 'Edit',
        description: 'Edit underlying editor at the current location with AI generated content'
    },
    // Atlas shorten update messages
    atlasShortenUpdatetitle: {
        id: 'fabric.editor.ai.config.item.atlas-shorten-update.title',
        defaultMessage: 'Shorten update',
        description: 'Describes an option to use Atlassian Intelligence to shorten the content currently selected by the user'
    },
    atlasShortenUpdateDescription: {
        id: 'fabric.editor.ai.config.item.atlas-shorten-update.description',
        defaultMessage: 'Shortens the content to make it more concise',
        description: 'Description for the the Atlassian Intelligence "Shorten update".'
    },
    // Brainstorm messages
    brainstormTitle: {
        id: 'fabric.editor.ai.config.item.brainstorm.title',
        defaultMessage: 'Brainstorm',
        description: 'Title for "Brainstorm" Atlassian Intelligence feature shown in editor typeahead and element browser.'
    },
    brainstormDescription: {
        id: 'fabric.editor.ai.config.item.brainstorm.description',
        defaultMessage: 'Generates a list of ideas for a topic you provide',
        description: 'Describes the "Brainstorm" Atlassian Intelligence feature shown in editor typeahead and element browser.'
    },
    brainstormPromptLabel: {
        id: 'fabric.editor.ai.config.item.brainstorm.promptLabel',
        defaultMessage: 'Brainstorm',
        description: 'Label text in the prompt input.'
    },
    brainstormPromptHint: {
        id: 'fabric.editor.ai.config.item.brainstorm.promptHint',
        defaultMessage: 'Tell me the topic...',
        description: 'Placeholder text in the prompt input guiding user interaction.'
    },
    // Change tone messages
    changeToneNestingParentTitlePostGA: {
        id: 'fabric.editor.ai.config.item.changeTone.nestingParentTitlePostGA',
        defaultMessage: 'Change tone to ...',
        description: 'Describes a (nested) option to use Atlassian Intelligence to change the tone of content currently selected by the user'
    },
    changeToneNeutralToneTitle: {
        id: 'fabric.editor.ai.config.item.changeTone.neutralTone.title',
        defaultMessage: 'Change tone to neutral',
        description: 'Describes an option to use Atlassian Intellgience to change the tone of content currently selected by the user'
    },
    changeToneNeutralToneShortTitle: {
        id: 'fabric.editor.ai.config.item.changeTone.neutralTone.shortTitle',
        defaultMessage: 'Neutral',
        description: 'Describes an option to use Atlassian Intellgience to change the tone of content currently selected by the user'
    },
    changeToneNeutralToneDescription: {
        id: 'fabric.editor.ai.config.item.changeTone.neutralTone.description',
        defaultMessage: 'Changes the tone of the content to neutral',
        description: 'Desciption for the Atlassian Intellgience "Change tone to neutral" option'
    },
    changeToneNeutralToneSelectionToolbarDropdownItemTitle: {
        id: 'fabric.editor.ai.config.item.changeTone.neutralTone.selectionToolbar.dropdownItem.title',
        defaultMessage: 'Neutral',
        description: 'Title for Atlassian Intelligence "Change tone to neutral" in editor selection floating toolbar'
    },
    changeToneProfessionalToneTitle: {
        id: 'fabric.editor.ai.config.item.changeTone.professionalTone.title',
        defaultMessage: 'Change tone to professional',
        description: 'Describes an option to use Atlassian Intellgience to change the tone of content currently selected by the user'
    },
    changeToneProfessionalToneShortTitle: {
        id: 'fabric.editor.ai.config.item.changeTone.professionalTone.shortTitle',
        defaultMessage: 'Professional',
        description: 'Describes an option to use Atlassian Intellgience to change the tone of content currently selected by the user'
    },
    changeToneProfessionalToneDescription: {
        id: 'fabric.editor.ai.config.item.changeTone.professionalTone.description',
        defaultMessage: 'Changes the tone of the content to professional',
        description: 'Desciption for the Atlassian Intellgience "Change tone to professional" option'
    },
    changeToneProfessionalToneSelectionToolbarDropdownItemTitle: {
        id: 'fabric.editor.ai.config.item.changeTone.professionalTone.selectionToolbar.dropdownItem.title',
        defaultMessage: 'Professional',
        description: 'Title for Atlassian Intelligence "Change tone to professional" in editor selection floating toolbar'
    },
    changeToneCasualToneTitle: {
        id: 'fabric.editor.ai.config.item.changeTone.casualTone.title',
        defaultMessage: 'Change tone to casual',
        description: 'Describes an option to use Atlassian Intellgience to change the tone of content currently selected by the user'
    },
    changeToneCasualToneShortTitle: {
        id: 'fabric.editor.ai.config.item.changeTone.casualTone.shortTitle',
        defaultMessage: 'Casual',
        description: 'Describes an option to use Atlassian Intellgience to change the tone of content currently selected by the user'
    },
    changeToneCasualToneDescription: {
        id: 'fabric.editor.ai.config.item.changeTone.casualTone.description',
        defaultMessage: 'Changes the tone of the content to casual',
        description: 'Desciption for the Atlassian Intellgience "Change tone to casual" option'
    },
    changeToneCasualToneSelectionToolbarDropdownItemTitle: {
        id: 'fabric.editor.ai.config.item.changeTone.casualTone.selectionToolbar.dropdownItem.title',
        defaultMessage: 'Casual',
        description: 'Title for Atlassian Intelligence "Change tone to casual" in editor selection floating toolbar'
    },
    changeToneEducationalToneTitle: {
        id: 'fabric.editor.ai.config.item.changeTone.educationalTone.title',
        defaultMessage: 'Change tone to educational',
        description: 'Describes an option to use Atlassian Intellgience to change the tone of content currently selected by the user'
    },
    changeToneEducationalToneShortTitle: {
        id: 'fabric.editor.ai.config.item.changeTone.educationalTone.shortTitle',
        defaultMessage: 'Educational',
        description: 'Describes an option to use Atlassian Intellgience to change the tone of content currently selected by the user'
    },
    changeToneEducationalToneDescription: {
        id: 'fabric.editor.ai.config.item.changeTone.educationalTone.description',
        defaultMessage: 'Changes the tone of the content to educational',
        description: 'Desciption for the Atlassian Intellgience "Change tone to educational" option'
    },
    changeToneEducationalToneSelectionToolbarDropdownItemTitle: {
        id: 'fabric.editor.ai.config.item.changeTone.educationalTone.selectionToolbar.dropdownItem.title',
        defaultMessage: 'Educational',
        description: 'Title for Atlassian Intelligence "Change tone to educational" in editor selection floating toolbar'
    },
    changeToneEmpatheticToneTitle: {
        id: 'fabric.editor.ai.config.item.changeTone.empatheticTone.title',
        defaultMessage: 'Change tone to empathetic',
        description: 'Describes an option to use Atlassian Intellgience to change the tone of content currently selected by the user'
    },
    changeToneEmpatheticToneShortTitle: {
        id: 'fabric.editor.ai.config.item.changeTone.empatheticTone.shortTitle',
        defaultMessage: 'Empathetic',
        description: 'Describes an option to use Atlassian Intellgience to change the tone of content currently selected by the user'
    },
    changeToneEmpatheticToneDescription: {
        id: 'fabric.editor.ai.config.item.changeTone.empatheticTone.description',
        defaultMessage: 'Changes the tone of the content to empathetic',
        description: 'Desciption for the Atlassian Intellgience "Change tone to empathetic" option'
    },
    changeToneEmpatheticToneSelectionToolbarDropdownItemTitle: {
        id: 'fabric.editor.ai.config.item.changeTone.empatheticTone.selectionToolbar.dropdownItem.title',
        defaultMessage: 'Empathetic',
        description: 'Title for Atlassian Intelligence "Change tone to empathetic" in editor selection floating toolbar'
    },
    // Convert to bullet list messages
    convertToBulletListTitle: {
        id: 'fabric.editor.ai.config.item.convertToBulletList.title',
        defaultMessage: 'Convert to bulleted list',
        description: 'Describes an option to use Atlassian Intelligence to reformat content currently selected by the user to a bulleted list'
    },
    convertToBulletListDescription: {
        id: 'fabric.editor.ai.config.item.convertToBulletList.description',
        defaultMessage: 'Reformats content to a bulleted list',
        description: 'Description for the the Atlassian Intelligence "Convert to bulleted list".'
    },
    // Convert to table messages
    convertToTableTitle: {
        id: 'fabric.editor.ai.config.item.convertToTable.title',
        defaultMessage: 'Convert to table',
        description: 'Describes an option to use Atlassian Intelligence to reformat content currently selected by the user to a table with headings'
    },
    convertToTableDescription: {
        id: 'fabric.editor.ai.config.item.convertToTable.description',
        defaultMessage: 'Reformats content to a table with headings',
        description: 'Description for the the Atlassian Intelligence "Convert to table".'
    },
    // Draft reply messages
    draftReplyTitle: {
        id: 'fabric.editor.ai.config.item.draftReply.title',
        defaultMessage: 'Draft reply',
        description: 'Title for "Draft reply" Atlassian Intelligence feature shown in editor typeahead and element browser.'
    },
    draftReplyDescription: {
        id: 'fabric.editor.ai.config.item.draftReply.description',
        defaultMessage: "Drafts a reply based on issues similar to the one you\u2019re working on",
        description: 'Describes the "Draft reply" Atlassian Intelligence feature shown in editor typeahead and element browser.'
    },
    // Enhance messages
    improveWritingTitle: {
        id: 'fabric.editor.ai.config.item.enhance.improveWriting.title',
        defaultMessage: 'Improve writing',
        description: 'Describes an option to use Atlassian Intellgience to improve the writing of content currently selected by the user'
    },
    improveWritingSelectionToolbarDropdownItemTitle: {
        id: 'fabric.editor.ai.config.item.enhance.improveWriting.selectionToolbar.dropdownItem.title',
        defaultMessage: 'Improve writing',
        description: 'Title for Atlassian Intelligence "improve writing" in editor selection floating toolbar'
    },
    fixSpellingGrammarTitle: {
        id: 'fabric.editor.ai.config.item.enhance.fixSpellingGrammar.title',
        defaultMessage: 'Fix spelling & grammar',
        description: 'Describes an option to use Atlassian Intellgience to improve the writing of content currently selected by the user'
    },
    improveWritingDescription: {
        id: 'fabric.editor.ai.config.item.enhance.improveWriting.description',
        defaultMessage: 'Enhances clarity, structure, and tone for better engagement and comprehension',
        description: 'Description for the the Atlassian Intelligence "Improve Writing".'
    },
    fixSpellingGrammarDescription: {
        id: 'fabric.editor.ai.config.item.enhance.fixSpellingGrammar.description',
        defaultMessage: 'Fixes spelling and grammar mistakes',
        description: 'Description for the the Atlassian Intelligence "Fix Spelling & Grammar".'
    },
    fixSpellingGrammarSelectionToolbarDropdownItemTitle: {
        id: 'fabric.editor.ai.config.item.enhance.fixSpellingGrammar.selectionToolbar.dropdownItem.title',
        defaultMessage: 'Spelling & grammar',
        description: 'Title for Atlassian Intelligence "fix spelling grammar" in editor selection floating toolbar'
    },
    // Find action items messages
    findActionItemsTitle: {
        id: 'fabric.editor.ai.config.item.findActionItems.title',
        defaultMessage: 'Find action items',
        description: 'Title for "Find Action Items" Atlassian Intelligence feature shown in editor typeahead and element browser.'
    },
    findActionItemsDescription: {
        id: 'fabric.editor.ai.config.item.findActionItems.description',
        defaultMessage: 'Finds action items in the content you provide',
        description: 'Describes the "Find Action Items" Atlassian Intelligence feature shown in editor typeahead and element browser.'
    },
    // Free generate messages
    freeGeneratePromptHint: {
        id: 'fabric.editor.ai.config.item.generateContent.promptHint',
        defaultMessage: 'Write with AI or select from below',
        description: 'Placeholder text in the prompt input guiding user interaction.'
    },
    // Free generate disabled messages
    freeGenerateDisabledPromptHint: {
        id: 'fabric.editor.ai.config.item.freeGenerate.disabled.promptHint',
        defaultMessage: 'Select from below (free generate is disabled in Elevate at this time)',
        description: 'Placeholder text in the prompt input guiding user interaction.'
    },
    // Improve description messages
    reformatWithTemplateDescription: {
        id: 'fabric.editor.ai.config.item.improveDescription.default.description',
        defaultMessage: 'Restructure the issue description based on the issue type',
        description: 'Description for the Atlassian Intelligence "Improve description" feature.'
    },
    improveDescription: {
        id: 'fabric.editor.ai.config.item.improveDescription.default.title.experiment.one',
        defaultMessage: 'Improve description',
        description: 'Describes an option to use Atlassian Intelligence to improve the issue description currently selected by the user.'
    },
    // Make longer messages
    makeLongerTitle: {
        id: 'fabric.editor.ai.config.item.makeLonger.title',
        defaultMessage: 'Make longer',
        description: 'Describes an option to use Atlassian Intelligence to make the content longer currently selected by the user'
    },
    makeLongerDescription: {
        id: 'fabric.editor.ai.config.item.makeLonger.description',
        defaultMessage: 'Expands the content based on the context you provide',
        description: 'Description for the the Atlassian Intelligence "Make longer".'
    },
    // Make shorter messages
    makeShorterTitle: {
        id: 'fabric.editor.ai.config.item.shorten.title',
        defaultMessage: 'Make shorter',
        description: 'Describes an option to use Atlassian Intelligence to shorten the content currently selected by the user'
    },
    makeShorterDescription: {
        id: 'fabric.editor.ai.config.item.shorten.description',
        defaultMessage: 'Shortens the content to make it more concise',
        description: 'Description for the the Atlassian Intelligence "Shorten".'
    },
    makeShorterSelectionToolbarDropdownItemTitle: {
        id: 'fabric.editor.ai.config.item.shorten.selectionToolbar.dropdownItem.title',
        defaultMessage: 'Make shorter',
        description: 'Title for Atlassian Intelligence "Shorten" in editor selection floating toolbar'
    },
    // PR Description messages
    prDescriptionTitle: {
        id: 'fabric.editor.ai.config.item.bb.pr.description.title',
        defaultMessage: 'Create pull request description',
        description: 'Title for "Create pull request description" Atlassian Intelligence feature shown in editor typeahead and element browser.'
    },
    prDescriptionDescription: {
        id: 'fabric.editor.ai.config.item.bb.pr.description.description',
        defaultMessage: 'Creates a pull request description with a summary of changes',
        description: 'Describes the "Create pull request description" Atlassian Intelligence feature shown in editor typeahead and element browser.'
    },
    // Rephrase messages
    rephraseTitle: {
        id: 'fabric.editor.ai.config.item.rephrase.title',
        defaultMessage: 'Rephrase',
        description: 'Describes an option to use Atlassian Intelligence to rephrase the content currently selected by the user'
    },
    rephraseDescription: {
        id: 'fabric.editor.ai.config.item.rephrase.description',
        defaultMessage: 'Creates a suggestion for rewriting your sentences',
        description: 'Description for the the Atlassian Intelligence "Rephrase".'
    },
    // Suggest title messages
    suggestTitleTitle: {
        id: 'fabric.editor.ai.config.item.suggest.title',
        defaultMessage: 'Suggest a title',
        description: 'Describes an option to use Atlassian Intellgience to suggest an appropriate title for the content currently selected by the user'
    },
    suggestTitleDescription: {
        id: 'fabric.editor.ai.config.item.suggest.description',
        defaultMessage: 'Suggests a title for content you provide',
        description: 'Describes "Suggest a Title" Atlassian Intelligence feature to suggest an appropriate title for the content currently selected by the user'
    },
    // Summarize writing messages
    summarizeWritingtitle: {
        id: 'fabric.editor.ai.config.item.summarize.title',
        defaultMessage: 'Summarize writing',
        description: 'Describes an option to use Atlassian Intellgience to summarize the content currently selected by the user'
    },
    summarizeWritingDescription: {
        id: 'fabric.editor.ai.config.item.summarize.description',
        defaultMessage: "Creates a summary of the text you're working on, highlighting key points",
        description: 'Describes "Summarize writing" Atlassian Intelligence feature to summarize the content currently selected by the user'
    },
    summarizeWritingSelectionToolbarDropdownItemTitle: {
        id: 'fabric.editor.ai.config.item.summarize.dropdownItem.title',
        defaultMessage: 'Summarize writing',
        description: 'Title for Atlassian Intelligence "Summarize writing" in editor selection floating toolbar'
    }
});

});

parcelRegister("3GBY8", function(module, exports) {

$parcel$export(module.exports, "BrainstormIcon", () => $bd5f07f236202765$export$ced89349fedce38);

var $eJOHy = parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");

var $cfSUy = parcelRequire("cfSUy");
const $bd5f07f236202765$var$IconGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        role: "presentation",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M7.04101 4.052C8.35608 2.73768 10.1392 1.99937 11.9985 1.99937C13.8578 1.99937 15.6409 2.73768 16.956 4.052C17.581 4.67653 18.0768 5.4181 18.415 6.23433C18.7533 7.05056 18.9274 7.92545 18.9274 8.809C18.9274 9.69254 18.7533 10.5674 18.415 11.3837C18.0768 12.1999 17.581 12.9415 16.956 13.566L16.841 13.678L16.724 13.787L15.998 14.446L16 15.83L15.998 15.862V18.001C15.9976 18.7657 15.7051 19.5014 15.1804 20.0577C14.6557 20.6139 13.9384 20.9489 13.175 20.994L12.998 20.999H10.998C10.2333 20.9988 9.49752 20.7066 8.94104 20.1821C8.38455 19.6576 8.04938 18.9404 8.00401 18.177L7.99801 18.001V14.445L7.27301 13.785C6.01548 12.6426 5.23697 11.0665 5.09394 9.37352C4.95091 7.68057 5.45397 5.99622 6.50201 4.659L6.66401 4.46L6.82001 4.283C6.89182 4.20392 6.96551 4.12756 7.04101 4.052ZM13.998 16.83H9.99801V18.002C9.99831 18.2469 10.0885 18.4832 10.2514 18.666C10.4144 18.8489 10.6387 18.9656 10.882 18.994L10.998 19.001H12.998C13.2431 19.0012 13.4798 18.9114 13.663 18.7486C13.8462 18.5858 13.9633 18.3614 13.992 18.118L13.998 18.002V16.83ZM15.54 5.466C15.0613 4.98771 14.4907 4.61131 13.8626 4.3595C13.2345 4.10769 12.5619 3.98567 11.8854 4.00081C11.2089 4.01595 10.5424 4.16792 9.92623 4.44758C9.31003 4.72724 8.75684 5.12878 8.30001 5.628C7.48334 6.52552 7.04311 7.70273 7.07048 8.91589C7.09784 10.129 7.5907 11.2852 8.44701 12.145L8.61701 12.308L9.67001 13.264C9.84765 13.4255 9.96123 13.6456 9.99001 13.884L9.99701 14.004V14.831H13.997V14.004C13.9971 13.7638 14.0838 13.5316 14.241 13.35L14.325 13.264L15.46 12.231L15.54 12.153C15.9793 11.714 16.3277 11.1928 16.5654 10.6191C16.8032 10.0454 16.9255 9.43049 16.9255 8.80949C16.9255 8.1885 16.8032 7.57358 16.5654 6.99989C16.3277 6.4262 15.9793 5.90497 15.54 5.466Z"
    }));
const $bd5f07f236202765$export$ced89349fedce38 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cfSUy))), {
        label: "",
        spacing: "spacious",
        // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        LEGACY_fallbackIcon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
                glyph: $bd5f07f236202765$var$IconGlyph,
                ...props
            }),
        LEGACY_secondaryColor: "var(--ds-icon, #44546F)"
    });

});

parcelRegister("lxVNh", function(module, exports) {

$parcel$export(module.exports, "createInsertAtTop", () => $8ae4b98fe91c6555$export$9e309baaf0e9d41b);
$parcel$export(module.exports, "createInsertBelow", () => $8ae4b98fe91c6555$export$2a99e23257616a3);
$parcel$export(module.exports, "createInsertAtCurrentPosition", () => $8ae4b98fe91c6555$export$6641dbc1b651cf28);
$parcel$export(module.exports, "createReplace", () => $8ae4b98fe91c6555$export$ab7194c13d7567bc);
$parcel$export(module.exports, "createReplaceExistingConfluenceTitle", () => $8ae4b98fe91c6555$export$bac6a2ed25caf91c);

var $izZqh = parcelRequire("izZqh");

var $j6ZdO = parcelRequire("j6ZdO");

var $3xw6l = parcelRequire("3xw6l");

var $BmspC = parcelRequire("BmspC");

var $eGOwo = parcelRequire("eGOwo");

var $13b12 = parcelRequire("13b12");

var $7Oshf = parcelRequire("7Oshf");

var $jMwDb = parcelRequire("jMwDb");

var $hICRK = parcelRequire("hICRK");

var $gsejj = parcelRequire("gsejj");
const $8ae4b98fe91c6555$export$9e309baaf0e9d41b = ({ appearance: appearance })=>({
        type: 'markdown',
        title: (0, $izZqh.aiConfigItemMessages).configActionInsertAtTop,
        appearance: appearance,
        run ({ editorView: editorView, pmFragment: pmFragment }) {
            const { state: state } = editorView;
            const transaction = state.tr;
            const slice = new (0, $3xw6l.Slice)(pmFragment, 0, 0);
            transaction.replace(0, 0, slice);
            (0, $gsejj.beforeDispatchAITransaction)(transaction, state);
            editorView.dispatch(transaction);
        },
        icon: (0, $hICRK.InsertAtTopIcon)
    });
const $8ae4b98fe91c6555$export$2a99e23257616a3 = ({ appearance: appearance })=>({
        type: 'markdown',
        title: (0, $eGOwo.fg)('platform_editor_ai_in_document_streaming') ? (0, $izZqh.aiConfigItemMessages).configActionInsertBelowOriginal : (0, $izZqh.aiConfigItemMessages).configActionInsertBelow,
        appearance: appearance,
        run ({ editorView: editorView, positions: positions, pmFragment: pmFragment, triggeredFor: triggeredFor }) {
            const { state: state } = editorView;
            const transaction = state.tr;
            if ((0, $j6ZdO.fragmentContainsNodeType)(pmFragment, state.schema.nodes.table) && (0, $gsejj.shouldInsertAfterTable)({
                selection: state.selection,
                tableSchema: state.schema.nodes.table
            }) && (0, $eGOwo.fg)('platform_editor_use_nested_table_pm_nodes')) (0, $gsejj.insertContentAfterTable)({
                pmFragment: pmFragment,
                transaction: transaction
            });
            else if (triggeredFor?.isBlock) {
                const insertPos = positions[1];
                (0, $BmspC.safeInsert)(pmFragment, insertPos)(transaction);
                (0, $gsejj.beforeDispatchingTransactionForBlocks)(pmFragment, transaction, editorView.state);
            } else {
                let insertPos;
                try {
                    insertPos = state.doc.resolve(positions[1]).after();
                } catch (error) {
                    insertPos = positions[1];
                }
                (0, $BmspC.safeInsert)(pmFragment, insertPos)(transaction);
            }
            (0, $gsejj.beforeDispatchAITransaction)(transaction, state);
            editorView.dispatch(transaction);
        },
        icon: (0, $jMwDb.InsertAtOrBelowIcon)
    });
const $8ae4b98fe91c6555$export$6641dbc1b651cf28 = ({ appearance: appearance, isRovoAgentAction: isRovoAgentAction, title: title = (0, $izZqh.aiConfigItemMessages).configActionInsert })=>({
        type: 'markdown',
        title: title,
        appearance: appearance,
        isRovoAgentAction: isRovoAgentAction,
        run ({ editorView: editorView, positions: positions, pmFragment: pmFragment }) {
            const tr = (0, $gsejj.insertAIContentAtCurrentPosition)({
                editorView: editorView,
                positions: positions,
                pmFragment: pmFragment
            });
            if (isRovoAgentAction) (0, $gsejj.beforeDispatchAIRovoAgentTransaction)(tr);
            editorView.dispatch(tr);
        },
        icon: (0, $jMwDb.InsertAtOrBelowIcon)
    });
const $8ae4b98fe91c6555$export$ab7194c13d7567bc = ({ appearance: appearance, isRovoAgentAction: isRovoAgentAction })=>({
        type: 'markdown',
        title: (0, $izZqh.aiConfigItemMessages).configActionReplace,
        appearance: appearance,
        isRovoAgentAction: isRovoAgentAction,
        run ({ editorView: editorView, positions: positions, pmFragment: pmFragment, selectionMetaData: selectionMetaData, triggeredFor: triggeredFor }) {
            const tr = triggeredFor?.isBlock ? (0, $gsejj.replaceWithAIContentForBlock)({
                editorView: editorView,
                positions: positions,
                pmFragment: pmFragment,
                triggeredFor: triggeredFor
            }) : (0, $gsejj.replaceWithAIContent)({
                editorView: editorView,
                positions: positions,
                pmFragment: pmFragment,
                selectionMetaData: selectionMetaData
            });
            if (isRovoAgentAction) (0, $gsejj.beforeDispatchAIRovoAgentTransaction)(tr);
            editorView.dispatch(tr);
        }
    });
const $8ae4b98fe91c6555$export$bac6a2ed25caf91c = ({ appearance: appearance })=>({
        type: 'markdown',
        title: (0, $izZqh.aiConfigItemMessages).configActionReplaceTitle,
        appearance: appearance,
        getDisabledState: ({ markdown: markdown, formatMessage: formatMessage })=>{
            const responseLength = markdown?.length ?? 0;
            // Source: next/packages/editor-title/src/EditorTitle.tsx
            const MAX_TITLE_LENGTH = 255;
            if (responseLength >= MAX_TITLE_LENGTH) return {
                isDisabled: true,
                tooltip: formatMessage((0, $izZqh.aiConfigItemMessages).configActionReplaceTitleTooLongDisabledTooltip, {
                    maxLength: MAX_TITLE_LENGTH
                })
            };
            return {
                isDisabled: false
            };
        },
        run ({ editorView: editorView, pmFragment: pmFragment }) {
            const fragmentToInsert = pmFragment;
            let textContent = '';
            fragmentToInsert.forEach((node)=>{
                textContent += node.textContent;
            });
            const confluenceTitle = document.querySelector('textarea[data-ai-suggest-title-target="true"]');
            if (confluenceTitle) {
                const sourceEditorId = (0, $7Oshf.findEditorIdFromView)(editorView);
                if (sourceEditorId) (0, $13b12.eventHub).publishFromEditor({
                    event: 'replace title in confluence',
                    data: {
                        analyticSourceId: 'confluenceTitleToolbar',
                        sourceEditorId: sourceEditorId,
                        title: textContent
                    }
                });
                confluenceTitle.scrollIntoView();
            }
        }
    });

});
parcelRegister("13b12", function(module, exports) {

$parcel$export(module.exports, "eventHub", () => $9b03a7ae4232e3b3$export$e17a52e5da72c4cb);
class $9b03a7ae4232e3b3$var$EventHub {
    constructor(){
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.subscribers = new Map();
        this.subscribers = new Map();
    }
    /**
	 * Subscribes to a specific Editor AI event, registering a callback function that will be invoked whenever the event is published.
	 *
	 * @param {Object} params - The subscription parameters.
	 * @param {T} params.event - The name of the event to subscribe to.
	 * @param {(data: EventDataMap[T]) => void} params.callback - The callback function to invoke when the event is published.
	 * It receives the event data as its parameter.
	 * @returns {Object} An object containing the `unsubscribe` method to remove the subscription when it's no longer needed.
	 *
	 * @example
	 * // Subscribing to an event
	 * const subscription = eventHub.subscribe({
	 *   event: 'start prompt',
	 *   callback: (data) => {
	 *     console.log('Received start prompt event:', data);
	 *   },
	 * });
	 *
	 * // Later, to unsubscribe
	 * subscription.unsubscribe();
	 */ subscribe({ event: event, callback: callback }) {
        const callbacks = this.subscribers.get(event) || [];
        this.subscribers.set(event, [
            ...callbacks,
            callback
        ]);
        return {
            unsubscribe: ()=>{
                const callbacks = this.subscribers.get(event)?.filter((sub)=>sub !== callback) || [];
                if (callbacks.length > 0) this.subscribers.set(event, callbacks);
                else this.subscribers.delete(event);
            }
        };
    }
    /**
	 * Publishes an Editor AI event to a target editor. (This will usually be an event like 'start prompt').
	 *
	 * @param {Object} params - The event parameters.
	 * @param {T} params.event - The name of the event to publish.
	 * @param {ToEditorEventDataMap[T]} params.data - The data associated with the event, specific to the event type.
	 * @returns {void}
	 *
	 * @example
	 * // Publishing an event to the editor
	 * eventHub.publishToEditor({
	 *   event: 'start prompt',
	 *   data: {
	 *     prompt: 'issue reformatter',
	 *     targetEditorId,
	 *     analyticSourceId: 'jiraIssueReformatterExternalButton',
	 *   },
	 * });
	 */ publishToEditor({ event: event, data: data }) {
        const callbacks = this.subscribers.get(event) || [];
        callbacks.forEach((callback)=>{
            callback(data);
        });
    }
    /**
	 * Publishes an event originating from the editor, invoking all registered subscribers for that event.
	 *
	 * @param {Object} params - The event parameters.
	 * @param {T} params.event - The name of the event to publish.
	 * @param {FromEditorEventDataMap[T]} params.data - The data associated with the event, specific to the event type.
	 * @returns {void}
	 *
	 * @example
	 * // Publishing an event from the editor
	 * eventHub.publishFromEditor({
	 *   event: 'replace title in confluence',
	 *   data: {
	 *     analyticSourceId: 'confluenceTitleToolbar',
	 *     sourceEditorId,
	 *     title: textContent,
	 *   },
	 * });
	 */ publishFromEditor({ event: event, data: data }) {
        const callbacks = this.subscribers.get(event) || [];
        callbacks.forEach((callback)=>{
            callback(data);
        });
    }
}
const $9b03a7ae4232e3b3$export$e17a52e5da72c4cb = new $9b03a7ae4232e3b3$var$EventHub();

});

parcelRegister("7Oshf", function(module, exports) {

$parcel$export(module.exports, "findEditorIdFromView", () => $8708c9ff5f5be6d9$export$700cb401385d6bf2);
const $8708c9ff5f5be6d9$export$700cb401385d6bf2 = (editorView)=>{
    return editorView.dom?.dataset?.editorId;
};

});

parcelRegister("jMwDb", function(module, exports) {

$parcel$export(module.exports, "InsertAtOrBelowIcon", () => $1c66986f9a7b2efc$export$d91f61e80e507e8e);

var $eJOHy = parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");

var $jgBA1 = parcelRequire("jgBA1");
const $1c66986f9a7b2efc$var$IconGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        width: 14,
        height: "100%",
        viewBox: "0 0 14 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: props.className,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: props.style,
        "aria-label": props['aria-label'],
        "aria-hidden": props['aria-hidden'],
        focusable: props.focusable,
        role: props.role,
        tabIndex: props.tabIndex,
        "data-testid": props['data-testid'],
        id: props.id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M15 6.49999L1 6.49999L1 4.99999L15 4.99999V6.49999ZM15 2.49999L1 2.49999L1 0.999987L15 0.999987L15 2.49999Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M1.75 11C2.16421 11 2.5 10.6642 2.5 10.25C2.5 9.83578 2.16421 9.49999 1.75 9.49999C1.33579 9.49999 1 9.83578 1 10.25C1 10.6642 1.33579 11 1.75 11Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M1.75 15C2.16421 15 2.5 14.6642 2.5 14.25C2.5 13.8358 2.16421 13.5 1.75 13.5C1.33579 13.5 1 13.8358 1 14.25C1 14.6642 1.33579 15 1.75 15Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M5.625 10.25C5.625 10.6642 5.28921 11 4.875 11C4.46079 11 4.125 10.6642 4.125 10.25C4.125 9.83578 4.46079 9.49999 4.875 9.49999C5.28921 9.49999 5.625 9.83578 5.625 10.25Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M4.875 15C5.28921 15 5.625 14.6642 5.625 14.25C5.625 13.8358 5.28921 13.5 4.875 13.5C4.46079 13.5 4.125 13.8358 4.125 14.25C4.125 14.6642 4.46079 15 4.875 15Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M8.75 10.25C8.75 10.6642 8.41421 11 8 11C7.58579 11 7.25 10.6642 7.25 10.25C7.25 9.83578 7.58579 9.49999 8 9.49999C8.41421 9.49999 8.75 9.83578 8.75 10.25Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M8 15C8.41421 15 8.75 14.6642 8.75 14.25C8.75 13.8358 8.41421 13.5 8 13.5C7.58579 13.5 7.25 13.8358 7.25 14.25C7.25 14.6642 7.58579 15 8 15Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M11.875 10.25C11.875 10.6642 11.5392 11 11.125 11C10.7108 11 10.375 10.6642 10.375 10.25C10.375 9.83578 10.7108 9.49999 11.125 9.49999C11.5392 9.49999 11.875 9.83578 11.875 10.25Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M14.25 11C14.6642 11 15 10.6642 15 10.25C15 9.83578 14.6642 9.49999 14.25 9.49999C13.8358 9.49999 13.5 9.83578 13.5 10.25C13.5 10.6642 13.8358 11 14.25 11Z",
        fill: "currentColor"
    }));
const $1c66986f9a7b2efc$export$d91f61e80e507e8e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jgBA1))), {
        label: "",
        spacing: "spacious",
        LEGACY_fallbackIcon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
                glyph: $1c66986f9a7b2efc$var$IconGlyph,
                label: props.label,
                size: props.size,
                primaryColor: props.primaryColor,
                secondaryColor: props.secondaryColor,
                testId: props.testId
            }),
        LEGACY_secondaryColor: "var(--ds-icon, #44546F)"
    });

});
parcelRegister("jgBA1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d63ca31b758327203174915ec4fdd417>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e06ca98f6ab9c73a$var$_react = $e06ca98f6ab9c73a$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $e06ca98f6ab9c73a$var$_baseNew = $e06ca98f6ab9c73a$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $e06ca98f6ab9c73a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextConclusionAdd".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Confluence Editor AI action for generating a conclusion
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e06ca98f6ab9c73a$var$TextConclusionAddIcon = (props)=>/*#__PURE__*/ $e06ca98f6ab9c73a$var$_react.default.createElement($e06ca98f6ab9c73a$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 6.5H1V5h14zm0-4H1V1h14z" clip-rule="evenodd"/><path fill="currentcolor" d="M1.75 11a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m0 4a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m3.88-4.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M4.88 15a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m3.87-4.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M8 15a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m3.88-4.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m2.37.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5"/>`
    }, props));
$e06ca98f6ab9c73a$var$TextConclusionAddIcon.displayName = 'TextConclusionAddIcon';
var $e06ca98f6ab9c73a$var$_default = module.exports.default = $e06ca98f6ab9c73a$var$TextConclusionAddIcon;

});


parcelRegister("hICRK", function(module, exports) {

$parcel$export(module.exports, "InsertAtTopIcon", () => $3dca2d3c5ab934cb$export$d8090035f79e82b5);

var $eJOHy = parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");

var $ezbHS = parcelRequire("ezbHS");
const $3dca2d3c5ab934cb$var$IconGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        width: 14,
        height: "100%",
        viewBox: "0 0 14 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: props.className,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: props.style,
        "aria-label": props['aria-label'],
        "aria-hidden": props['aria-hidden'],
        focusable: props.focusable,
        role: props.role,
        tabIndex: props.tabIndex,
        "data-testid": props['data-testid'],
        id: props.id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M15 9.5L1 9.5L1 11L15 11V9.5ZM8 13.5L1 13.5L1 15L8 15V13.5Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M1.75 5C2.16421 5 2.5 5.33579 2.5 5.75C2.5 6.16421 2.16421 6.5 1.75 6.5C1.33579 6.5 1 6.16421 1 5.75C1 5.33579 1.33579 5 1.75 5Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M1.75 1C2.16421 1 2.5 1.33579 2.5 1.75C2.5 2.16421 2.16421 2.5 1.75 2.5C1.33579 2.5 1 2.16421 1 1.75C1 1.33579 1.33579 1 1.75 1Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M5.625 5.75C5.625 5.33579 5.28921 5 4.875 5C4.46079 5 4.125 5.33579 4.125 5.75C4.125 6.16421 4.46079 6.5 4.875 6.5C5.28921 6.5 5.625 6.16421 5.625 5.75Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M4.875 1C5.28921 1 5.625 1.33579 5.625 1.75C5.625 2.16421 5.28921 2.5 4.875 2.5C4.46079 2.5 4.125 2.16421 4.125 1.75C4.125 1.33579 4.46079 1 4.875 1Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M8.75 5.75C8.75 5.33579 8.41421 5 8 5C7.58579 5 7.25 5.33579 7.25 5.75C7.25 6.16421 7.58579 6.5 8 6.5C8.41421 6.5 8.75 6.16421 8.75 5.75Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M8 1C8.41421 1 8.75 1.33579 8.75 1.75C8.75 2.16421 8.41421 2.5 8 2.5C7.58579 2.5 7.25 2.16421 7.25 1.75C7.25 1.33579 7.58579 1 8 1Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M11.875 5.75C11.875 5.33579 11.5392 5 11.125 5C10.7108 5 10.375 5.33579 10.375 5.75C10.375 6.16421 10.7108 6.5 11.125 6.5C11.5392 6.5 11.875 6.16421 11.875 5.75Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M11.125 1C11.5392 1 11.875 1.33579 11.875 1.75C11.875 2.16421 11.5392 2.5 11.125 2.5C10.7108 2.5 10.375 2.16421 10.375 1.75C10.375 1.33579 10.7108 1 11.125 1Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M15 5.75C15 5.33579 14.6642 5 14.25 5C13.8358 5 13.5 5.33579 13.5 5.75C13.5 6.16421 13.8358 6.5 14.25 6.5C14.6642 6.5 15 6.16421 15 5.75Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M14.25 1C14.6642 1 15 1.33579 15 1.75C15 2.16421 14.6642 2.5 14.25 2.5C13.8358 2.5 13.5 2.16421 13.5 1.75C13.5 1.33579 13.8358 1 14.25 1Z",
        fill: "currentColor"
    }));
const $3dca2d3c5ab934cb$export$d8090035f79e82b5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ezbHS))), {
        label: "",
        spacing: "spacious",
        LEGACY_fallbackIcon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
                glyph: $3dca2d3c5ab934cb$var$IconGlyph,
                label: props.label,
                size: props.size,
                primaryColor: props.primaryColor,
                secondaryColor: props.secondaryColor,
                testId: props.testId
            }),
        LEGACY_secondaryColor: "var(--ds-icon, #44546F)"
    });

});
parcelRegister("ezbHS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c0f629b8a9775fb58cae489ff4e22f86>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a9ad6a46daa0a746$var$_react = $a9ad6a46daa0a746$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $a9ad6a46daa0a746$var$_baseNew = $a9ad6a46daa0a746$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $a9ad6a46daa0a746$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextIntroductionAdd".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Confluence Editor AI action for generating an introduction
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a9ad6a46daa0a746$var$TextIntroductionAddIcon = (props)=>/*#__PURE__*/ $a9ad6a46daa0a746$var$_react.default.createElement($a9ad6a46daa0a746$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 9.5H1V11h14zm-7 4H1V15h7z" clip-rule="evenodd"/><path fill="currentcolor" d="M1.75 5a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5m0-4a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5m3.88 4.75a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0M4.88 1a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5m3.87 4.75a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0M8 1a.75.75 0 1 1 0 1.5A.75.75 0 0 1 8 1m3.88 4.75a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0M11.13 1a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5M15 5.75a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0M14.25 1a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5"/>`
    }, props));
$a9ad6a46daa0a746$var$TextIntroductionAddIcon.displayName = 'TextIntroductionAddIcon';
var $a9ad6a46daa0a746$var$_default = module.exports.default = $a9ad6a46daa0a746$var$TextIntroductionAddIcon;

});


parcelRegister("gsejj", function(module, exports) {

$parcel$export(module.exports, "beforeDispatchAITransaction", () => $b7b24b92a721a6cc$export$336eb673e6d24058);
$parcel$export(module.exports, "beforeDispatchingTransactionForBlocks", () => $b7b24b92a721a6cc$export$7b46ef9a312ebccb);
$parcel$export(module.exports, "beforeDispatchAIRovoAgentTransaction", () => $b7b24b92a721a6cc$export$cfdd8b8691129358);
$parcel$export(module.exports, "shouldInsertAfterTable", () => $b7b24b92a721a6cc$export$f00c638dfda8b9e2);
$parcel$export(module.exports, "insertContentAfterTable", () => $b7b24b92a721a6cc$export$a6a8eefd91a14ea5);
$parcel$export(module.exports, "replaceWithAIContentForBlock", () => $b7b24b92a721a6cc$export$841048b11479358);
$parcel$export(module.exports, "replaceWithAIContent", () => $b7b24b92a721a6cc$export$60bccdedcf767536);
$parcel$export(module.exports, "insertAIContentAtCurrentPosition", () => $b7b24b92a721a6cc$export$7dc11dddc9c93a89);

var $bMFKb = parcelRequire("bMFKb");

var $j6ZdO = parcelRequire("j6ZdO");

var $lQJJa = parcelRequire("lQJJa");

var $3xw6l = parcelRequire("3xw6l");

var $3lIcL = parcelRequire("3lIcL");

var $BmspC = parcelRequire("BmspC");

var $eGOwo = parcelRequire("eGOwo");

var $92xoS = parcelRequire("92xoS");

var $iHdh6 = parcelRequire("iHdh6");

var $fTjL5 = parcelRequire("fTjL5");

var $7WEOG = parcelRequire("7WEOG");

var $9QNCj = parcelRequire("9QNCj");
function $b7b24b92a721a6cc$export$336eb673e6d24058(tr, editorState) {
    /**
	 * DO NOT REMOVE isAiContentTransformation from transaction meta.
	 * Proactive AI S+G rely on isAiContentTransformation meta to
	 * 	ignore changes in document made by AI modal.
	 * Why ignore it?
	 * - Response returned from AI does not require Spelling and Grammar check.
	 * - We have assumed that it's already correct from S+G perspective.
	 */ tr.setMeta('isAiContentTransformation', true);
    const firstReplaceStep = (0, $fTjL5.findFirstReplaceStep)(tr.steps);
    if (!firstReplaceStep) {
        // Ideally we should always have replace step for for AI transaction.
        // But in case if there isn't we want to fire analytic event so we can monitor it.
        (0, $9QNCj.addAnalytics)({
            editorState: editorState,
            tr: tr,
            payload: {
                action: 'failed',
                actionSubject: 'editorPluginAI',
                actionSubjectId: 'experienceApplication',
                attributes: {
                    errorType: 'replaceStepNotFound'
                },
                eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL
            }
        });
        return tr;
    }
    const validPositionToSet = (0, $fTjL5.getValidEndTextPosition)({
        step: firstReplaceStep,
        doc: tr.doc
    });
    if (validPositionToSet !== 0) tr.setSelection((0, $3lIcL.TextSelection).create(tr.doc, validPositionToSet));
    return tr;
}
function $b7b24b92a721a6cc$export$7b46ef9a312ebccb(fragment, tr, state) {
    const supportedNodeTypes = (0, $7WEOG.getSupportedNodesForAIModal)(state);
    // Here we are checking if there is text node at first level.
    // Then we will highlight all nodes.
    let areTopLevelBlockElements = true;
    fragment.forEach((node)=>{
        areTopLevelBlockElements = areTopLevelBlockElements && supportedNodeTypes.has(node.type);
    });
    if (areTopLevelBlockElements) return tr.setMeta('isAiContentTransformationForBlocks', true);
    return tr;
}
function $b7b24b92a721a6cc$export$cfdd8b8691129358(tr) {
    /**
	 * DO NOT REMOVE
	 * This is used when distinguishing content generated by a Rovo agent
	 */ tr.setMeta('isAiRovoAgentContentTransformation', true);
    return tr;
}
function $b7b24b92a721a6cc$var$getLastContentDepth({ pmFragment: pmFragment }) {
    let depth = 0;
    let currentNode = pmFragment;
    while(currentNode.firstChild){
        depth++;
        currentNode = currentNode.firstChild;
    }
    return depth;
}
function $b7b24b92a721a6cc$var$isSelectionAtParagraphStart($pos) {
    const node = $pos.parent;
    return !!node && (node.type.name === 'paragraph' || node.type.name === 'heading') && !$pos.parentOffset;
}
function $b7b24b92a721a6cc$var$isFragmentSingleParagraph(fragment) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return fragment.childCount === 1 && fragment.firstChild.type.name === 'paragraph';
}
function $b7b24b92a721a6cc$var$isSelectionInTaskOrDecisionNode($pos) {
    const node = $pos.parent;
    return !!node && (node.type.name === 'decisionList' || node.type.name === 'decisionItem' || node.type.name === 'taskList' || node.type.name === 'taskItem');
}
function $b7b24b92a721a6cc$export$f00c638dfda8b9e2({ selection: selection, tableSchema: tableSchema }) {
    const isNestedTablesDisabled = (0, $92xoS.editorExperiment)('nested-tables-in-tables', false, {
        exposure: true
    });
    const parentTableCount = (0, $lQJJa.getParentOfTypeCount)(tableSchema)(selection.$from);
    const hasParentTable = (0, $BmspC.hasParentNodeOfType)(tableSchema)(selection);
    return hasParentTable && (isNestedTablesDisabled || parentTableCount > 1);
}
const $b7b24b92a721a6cc$export$a6a8eefd91a14ea5 = ({ pmFragment: pmFragment, transaction: transaction })=>{
    const tableSchema = transaction.doc.type.schema.nodes.table;
    const fromPos = transaction.selection.$from;
    const positionAfterTopTable = (0, $lQJJa.getPositionAfterTopParentNodeOfType)(tableSchema)(fromPos);
    return (0, $BmspC.safeInsert)(pmFragment, positionAfterTopTable)(transaction);
};
const $b7b24b92a721a6cc$export$841048b11479358 = ({ editorView: editorView, positions: positions, pmFragment: pmFragment, triggeredFor: triggeredFor })=>{
    const { state: state } = editorView;
    let transaction = state.tr;
    const slice = pmFragment.size === 0 && (0, $eGOwo.fg)('platform_editor_ai_replace_content_empty_slice') ? (0, $3xw6l.Slice).empty : new (0, $3xw6l.Slice)(pmFragment, 0, 0);
    if (pmFragment.size === 0 && (0, $eGOwo.fg)('platform_editor_ai_replace_content_empty_slice')) transaction = (0, $9QNCj.addAnalytics)({
        editorState: state,
        tr: transaction,
        payload: {
            action: 'fallback',
            actionSubject: 'editorPluginAI',
            actionSubjectId: 'replaceWithEmptyAIContent',
            eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL,
            attributes: {
                isBlock: true,
                isSelectionEmpty: positions[0] === positions[1]
            }
        }
    });
    try {
        // If you can't replace the range, use safeInsert
        transaction = transaction.replaceRange(positions[0], positions[1], slice);
    } catch (error) {
        // If you can't replace the range, use safeInsert
        transaction = (0, $BmspC.safeInsert)(pmFragment, undefined, true)((0, $9QNCj.addAnalytics)({
            editorState: state,
            tr: transaction,
            payload: {
                action: 'fallback',
                actionSubject: 'editorPluginAI',
                actionSubjectId: 'proseMirrorReplace',
                eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    target: 'replaceWithAIContentForBlock',
                    isSelectionEmpty: positions[0] === positions[1],
                    errorMessage: (0, $iHdh6.ErrorUtils).extractErrorMessage(error),
                    isReplacementEmpty: pmFragment.size === 0
                }
            }
        }));
    }
    return $b7b24b92a721a6cc$export$336eb673e6d24058($b7b24b92a721a6cc$export$7b46ef9a312ebccb(pmFragment, transaction, state), state);
};
const $b7b24b92a721a6cc$export$60bccdedcf767536 = ({ editorView: editorView, positions: positions, pmFragment: pmFragment, selectionMetaData: selectionMetaData, options: options = {
    replaceDocOnEmptySelection: true
} })=>{
    const { state: state } = editorView;
    let transaction = state.tr;
    const endPositionDepth = state.doc.resolve(positions[1]).depth;
    const lastFragmentDepth = $b7b24b92a721a6cc$var$getLastContentDepth({
        pmFragment: pmFragment
    });
    // selectionMetaData will always be undefined when platform_editor_ai_iw_adf_streaming is disabled
    const sliceOpenStart = selectionMetaData?.sliceOpenStart || 1;
    const sliceOpenEnd = selectionMetaData?.sliceOpenEnd || Math.min(endPositionDepth, lastFragmentDepth);
    const slice = pmFragment.size === 0 && (0, $eGOwo.fg)('platform_editor_ai_replace_content_empty_slice') ? (0, $3xw6l.Slice).empty : new (0, $3xw6l.Slice)(pmFragment, sliceOpenStart, sliceOpenEnd);
    if (pmFragment.size === 0 && (0, $eGOwo.fg)('platform_editor_ai_replace_content_empty_slice')) transaction = (0, $9QNCj.addAnalytics)({
        editorState: state,
        tr: transaction,
        payload: {
            action: 'fallback',
            actionSubject: 'editorPluginAI',
            actionSubjectId: 'replaceWithEmptyAIContent',
            eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL,
            attributes: {
                isBlock: false,
                isSelectionEmpty: positions[0] === positions[1]
            }
        }
    });
    if ((0, $j6ZdO.fragmentContainsNodeType)(pmFragment, transaction.doc.type.schema.nodes.table) && $b7b24b92a721a6cc$export$f00c638dfda8b9e2({
        selection: transaction.selection,
        tableSchema: transaction.doc.type.schema.nodes.table
    }) && (0, $eGOwo.fg)('platform_editor_use_nested_table_pm_nodes')) return $b7b24b92a721a6cc$export$a6a8eefd91a14ea5({
        pmFragment: pmFragment,
        transaction: transaction
    });
    else {
        // We check if the positions are the same if so we replace the whole document
        // This is a quick spike so real implementation might need to be different
        // You might need to create a new replace action
        if (options.replaceDocOnEmptySelection && positions[0] === positions[1]) transaction = transaction.replaceRange(0, state.doc.content.size, slice);
        else try {
            transaction = transaction.replaceRange(positions[0], positions[1], slice);
        // If you can't replace the range, use safeInsert
        } catch (error) {
            transaction = (0, $BmspC.safeInsert)(pmFragment, undefined, true)((0, $9QNCj.addAnalytics)({
                editorState: state,
                tr: transaction,
                payload: {
                    action: 'fallback',
                    actionSubject: 'editorPluginAI',
                    actionSubjectId: 'proseMirrorReplace',
                    eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL,
                    attributes: {
                        target: 'replaceWithAIContent',
                        isSelectionEmpty: positions[0] === positions[1],
                        errorMessage: (0, $iHdh6.ErrorUtils).extractErrorMessage(error),
                        isReplacementEmpty: pmFragment.size === 0
                    }
                }
            }));
        }
        return $b7b24b92a721a6cc$export$336eb673e6d24058(transaction, state);
    }
};
const $b7b24b92a721a6cc$export$7dc11dddc9c93a89 = ({ editorView: editorView, positions: positions, pmFragment: pmFragment })=>{
    const { state: state } = editorView;
    const transaction = state.tr;
    const pos = positions[0];
    const $pos = state.doc.resolve(pos);
    const isParagraphStart = $b7b24b92a721a6cc$var$isSelectionAtParagraphStart($pos);
    // if selection is at the beginning of paragraph,
    // insert before the cursor so that it inserts without an extra new line
    const insertPos = isParagraphStart ? pos - 1 : pos;
    // if selection is inside decision or task node AND pmFragment is a single paragraph
    // strip the paragraph so it can insert inside the decision/task
    let fragmentToInsert = pmFragment;
    if ($b7b24b92a721a6cc$var$isSelectionInTaskOrDecisionNode($pos) && $b7b24b92a721a6cc$var$isFragmentSingleParagraph(pmFragment)) // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    fragmentToInsert = pmFragment.firstChild.content;
    if ((0, $j6ZdO.fragmentContainsNodeType)(pmFragment, transaction.doc.type.schema.nodes.table) && $b7b24b92a721a6cc$export$f00c638dfda8b9e2({
        selection: transaction.selection,
        tableSchema: transaction.doc.type.schema.nodes.table
    }) && (0, $eGOwo.fg)('platform_editor_use_nested_table_pm_nodes')) return $b7b24b92a721a6cc$export$a6a8eefd91a14ea5({
        pmFragment: pmFragment,
        transaction: transaction
    });
    else return $b7b24b92a721a6cc$export$336eb673e6d24058(transaction.insert(insertPos, fragmentToInsert), state);
};

});
parcelRegister("iHdh6", function(module, exports) {

$parcel$export(module.exports, "ErrorUtils", () => $932dfd1f81a69a83$export$7edca8cfa9634e37);
class $932dfd1f81a69a83$export$7edca8cfa9634e37 {
    static{
        this.redactSensitiveInfo = (str)=>{
            const redacted = str// Ignored via go/ees005
            // eslint-disable-next-line require-unicode-regexp
            .replace(/[^,\s]+\@[^,\s]+/g, '[REDACTED EMAIL]')// Ignored via go/ees005
            // eslint-disable-next-line require-unicode-regexp
            .replace(/[^,\s]+\.[^,\s]+/g, '[REDACTED URL]');
            return redacted;
        };
    }
    static extractErrorMessage(error) {
        if (error instanceof Error) return $932dfd1f81a69a83$export$7edca8cfa9634e37.redactSensitiveInfo(error.message || 'unknown-error');
        else return $932dfd1f81a69a83$export$7edca8cfa9634e37.redactSensitiveInfo(String(error));
    }
}

});

parcelRegister("fTjL5", function(module, exports) {

$parcel$export(module.exports, "getValidEndTextPosition", () => $b318e7dd59345274$export$a2bf0757549da456);
$parcel$export(module.exports, "findFirstReplaceStep", () => $b318e7dd59345274$export$ec5fde712084a8ed);
$parcel$export(module.exports, "getGeneratedDecorationFromTransaction", () => $b318e7dd59345274$export$9d1e89ce90c0a9a);
$parcel$export(module.exports, "getGeneratedNodeDecorationsFromTransaction", () => $b318e7dd59345274$export$a6a2b5778b599ea1);
/**
 * Figure out what to do with these, possibly export/shift into editor-common
 * during move into editor-core
 */ 
var $lzEKq = parcelRequire("lzEKq");

var $d0vZq = parcelRequire("d0vZq");
function $b318e7dd59345274$var$getClosestValidTextPositionBefore({ pos: pos, doc: doc }) {
    let validPos = pos;
    while(validPos > 0){
        if (doc.resolve(validPos).parent.inlineContent) break;
        validPos--;
    }
    return validPos;
}
function $b318e7dd59345274$var$getClosestValidTextPositionAfter({ pos: pos, doc: doc }) {
    let validPos = pos;
    let isValidPos = false;
    while(isValidPos === false){
        if (doc.resolve(validPos).parent.inlineContent) {
            isValidPos = true;
            break;
        }
        validPos++;
    }
    return validPos;
}
function $b318e7dd59345274$var$findLastChildWithTextContent(content) {
    if (content.childCount <= 0) return null;
    let count = content.childCount - 1;
    const validNode = content.child(count);
    while(count >= 0){
        if (content.child(count).textContent !== '') break;
        count--;
    }
    return validNode;
}
function $b318e7dd59345274$var$getEndPosition({ step: step, doc: doc }) {
    let validPos = step.from + step.slice.size;
    let isValidPos = false;
    // Fragments can contain empty nodes, find the last childNode that has textContent
    const validNode = $b318e7dd59345274$var$findLastChildWithTextContent(step.slice.content);
    // Return start position if there are no valid nodes
    if (!validNode) return step.from;
    // Find textContent of last childNode with textContent
    const textContent = validNode.textContent;
    // Loop through endPos and find position where textBetween start and endPos matches textContent from last childNode in step
    // Check slice created between the positions to ensure no empty child nodes
    while(isValidPos === false && validPos > 0){
        const textBetween = doc.textBetween(step.from, validPos);
        const slice = doc.slice(step.from, validPos);
        if (textBetween.endsWith(textContent) && slice.content.lastChild?.textContent !== '') {
            isValidPos = true;
            break;
        }
        validPos--;
    }
    return validPos;
}
function $b318e7dd59345274$var$getValidStartTextPosition({ pos: pos, doc: doc }) {
    let startPos = pos;
    let isValidPos = false;
    while(isValidPos === false){
        if (doc.nodeAt(startPos)) {
            isValidPos = true;
            break;
        }
        startPos++;
    }
    return $b318e7dd59345274$var$getClosestValidTextPositionAfter({
        pos: startPos,
        doc: doc
    });
}
function $b318e7dd59345274$export$a2bf0757549da456({ step: step, doc: doc }) {
    const endPos = $b318e7dd59345274$var$getEndPosition({
        step: step,
        doc: doc
    });
    return $b318e7dd59345274$var$getClosestValidTextPositionBefore({
        pos: endPos,
        doc: doc
    });
}
function $b318e7dd59345274$export$ec5fde712084a8ed(steps) {
    const step = steps.find((step)=>step instanceof (0, $lzEKq.ReplaceStep) || step instanceof (0, $lzEKq.ReplaceAroundStep));
    if (!step) return null;
    return step;
}
function $b318e7dd59345274$export$9d1e89ce90c0a9a(transaction) {
    const step = $b318e7dd59345274$export$ec5fde712084a8ed(transaction.steps);
    if (!step) return null;
    const validStartDecorationPos = $b318e7dd59345274$var$getValidStartTextPosition({
        pos: step.from,
        doc: transaction.doc
    });
    const validEndDecorationPos = $b318e7dd59345274$export$a2bf0757549da456({
        step: step,
        doc: transaction.doc
    });
    return (0, $d0vZq.createGeneratedContentDecorations)(validStartDecorationPos, validEndDecorationPos);
}
function $b318e7dd59345274$export$a6a2b5778b599ea1(transaction) {
    const replaceSteps = transaction.steps.filter((step)=>step instanceof (0, $lzEKq.ReplaceStep) || step instanceof (0, $lzEKq.ReplaceAroundStep));
    if (replaceSteps.length === 0) return [];
    return replaceSteps.map((step)=>{
        const startPos = step.from;
        const node = transaction.doc.nodeAt(startPos);
        if (node) {
            const endPos = startPos + node.nodeSize;
            return (0, $d0vZq.createGeneratedNodeDecorations)(startPos, endPos);
        }
    }).filter((decoration)=>decoration !== undefined);
}

});
parcelRegister("d0vZq", function(module, exports) {

$parcel$export(module.exports, "createWidgetDecoration", () => $d6c55c4efa49683e$export$6428b9f2a07e29a5);
$parcel$export(module.exports, "createInlineDecoration", () => $d6c55c4efa49683e$export$1690e22aee311809);
$parcel$export(module.exports, "createGeneratedContentDecorations", () => $d6c55c4efa49683e$export$ee67e3280dab453d);
$parcel$export(module.exports, "createGeneratedNodeDecorations", () => $d6c55c4efa49683e$export$21c5d318062e995c);
$parcel$export(module.exports, "createOpenAIModalCommand", () => $d6c55c4efa49683e$export$2c80ad35b3530be1);
$parcel$export(module.exports, "createEndAIExperienceCommand", () => $d6c55c4efa49683e$export$d547a4e9ddb6b51);
$parcel$export(module.exports, "createUpdateEndWidgetDecorationPositionCommand", () => $d6c55c4efa49683e$export$e580b88af920547a);

var $bMFKb = parcelRequire("bMFKb");

var $3lIcL = parcelRequire("3lIcL");

var $BmspC = parcelRequire("BmspC");

var $b7EWj = parcelRequire("b7EWj");

var $eGOwo = parcelRequire("eGOwo");

var $lopBx = parcelRequire("lopBx");

var $5HAva = parcelRequire("5HAva");

var $7WEOG = parcelRequire("7WEOG");

var $cVpKV = parcelRequire("cVpKV");

var $9QNCj = parcelRequire("9QNCj");

var $d8IMr = parcelRequire("d8IMr");

var $gNwqL = parcelRequire("gNwqL");
const $d6c55c4efa49683e$export$6428b9f2a07e29a5 = (pos, type, key)=>{
    const widgetSpanElement = document.createElement('span');
    // Firefox needs content inside the span in order to add height to the element.
    // Otherwise, the height is set to 0 which prevents the start and
    // end widgets from rendering correctly and produces incorrect measurements
    // when we need to determine where to place the modal under the content.
    // Zero width spaces have been known to introduce some strange selection
    // behaviour in the Editor, however this approach works for our use case
    // in the ai-plugin where we do not expect users to be making selections
    // over ai-highlighted content in the same way they select regular content
    // in the Editor, this is also not intended to be a permanent fix post EAP.
    if (!(0, $eGOwo.fg)('platform_editor_ai_in_editor_streaming') && !(0, $eGOwo.fg)('platform_editor_ai_in_document_streaming')) widgetSpanElement.appendChild(document.createTextNode('\u200b'));
    widgetSpanElement.setAttribute('data-testid', `ai-modal-${type}-widget`);
    widgetSpanElement.className = `ai-modal-${type}-widget`;
    widgetSpanElement.contentEditable = 'false';
    const endSide = (0, $eGOwo.fg)('platform_editor_ai_in_editor_streaming') || (0, $eGOwo.fg)('platform_editor_ai_in_document_streaming') ? 1 : -1;
    return (0, $b7EWj.Decoration).widget(pos, widgetSpanElement, {
        side: type === 'start' ? 0 : endSide,
        key: key ?? `${type}WidgetDecoration`
    });
};
const $d6c55c4efa49683e$export$1690e22aee311809 = (from, to)=>{
    return (0, $b7EWj.Decoration).inline(from, to, {
        class: 'ai-selection-highlight',
        'data-testid': 'ai-selection-highlight'
    }, {
        key: 'inlineDecoration'
    });
};
const $d6c55c4efa49683e$export$ee67e3280dab453d = (from, to)=>{
    const startWidgetDecoration = $d6c55c4efa49683e$export$6428b9f2a07e29a5(from, 'start', 'generatedStartWidget');
    const highlightInlineDecoration = (0, $b7EWj.Decoration).inline(from, to, {
        class: 'ai-generated-content-highlight',
        'data-testid': 'ai-generated-content-highlight'
    }, {
        key: 'generatedInlineDecoration'
    });
    const endWidgetDecoration = $d6c55c4efa49683e$export$6428b9f2a07e29a5(to, 'end', 'generatedEndWidget');
    return [
        startWidgetDecoration,
        highlightInlineDecoration,
        endWidgetDecoration
    ];
};
const $d6c55c4efa49683e$export$50894b1f0083184 = (from, to)=>{
    return (0, $b7EWj.Decoration).node(from, to, {
        class: 'ai-selection-node',
        'data-testid': 'ai-selection-node'
    }, {
        key: 'ai-nodeDecoration'
    });
};
const $d6c55c4efa49683e$export$21c5d318062e995c = (from, to)=>{
    return (0, $b7EWj.Decoration).node(from, to, {
        class: 'ai-generated-node-highlight',
        'data-testid': 'ai-generated-node-highlight'
    }, {
        key: 'generatedNodeDecoration'
    });
};
function $d6c55c4efa49683e$var$getInitialPositions(selection) {
    switch(true){
        case selection instanceof (0, $3lIcL.AllSelection):
            return {
                startPos: selection.from + 1,
                endPos: selection.to - 1
            };
        default:
            return {
                startPos: selection.from,
                endPos: selection.to
            };
    }
}
const $d6c55c4efa49683e$export$4379c9f48a526c4d = ({ state: state })=>{
    const { selection: selection } = state;
    let from, to;
    if (selection instanceof (0, $3lIcL.NodeSelection)) {
        from = selection.from;
        to = selection.to;
    } else if ((0, $7WEOG.isCellSelection)(state)) {
        const findResult = (0, $BmspC.findParentNodeOfType)(state.schema.nodes.table)(selection);
        if (findResult) {
            const { depth: depth } = findResult;
            from = selection.$from.before(depth);
            to = selection.$from.after(depth);
        }
    } else {
        const { selection: selection } = state;
        const supportedNodes = (0, $7WEOG.getSupportedNodesForAIModal)(state);
        const findResult = (0, $BmspC.findParentNode)((node)=>supportedNodes.has(node.type))(selection);
        if (findResult) {
            const { depth: depth } = findResult;
            from = selection.$from.before(depth);
            to = selection.$from.after(depth);
        }
    }
    if (from !== undefined && to !== undefined) return [
        $d6c55c4efa49683e$export$50894b1f0083184(from, to)
    ];
    return [];
};
const $d6c55c4efa49683e$export$8b0c0139da7bc378 = ({ state: state, configItem: configItem, lastTriggeredFrom: lastTriggeredFrom, initialPositions: initialPositions })=>{
    /**
	 * We add selection highlight decoration based on the current selection state of the document and the config item in the command palette
	 * If the selection is empty and the document is not empty -> we decorate the entire document unless the config item specifies otherwise
	 */ let useCurrentSelectionForHighlight = true;
    // when clicking `browse agents` then selecting an agent, the state.selection is already cleared
    // so we need to use initialPositions to check if the selection is empty
    if (initialPositions[0] === initialPositions[1] && state.doc.content.size !== 0) useCurrentSelectionForHighlight = !!configItem.doNotHighlightDocWhenSelectionIsEmpty;
    /**
	 * EXPERIMENTAL: For experimental flow where 'Suggest title' in
	 * Confluence title toolbar will trigger the 'Suggest a title' flow in Editor AI.
	 * Forces whole document selection, even if an existing selection exists.
	 */ if ((0, $5HAva.isConfluenceTitleToolbarSuggestTitle)({
        configItem: configItem,
        lastTriggeredFrom: lastTriggeredFrom
    })) useCurrentSelectionForHighlight = false;
    const { startPos: startPos, endPos: endPos } = useCurrentSelectionForHighlight ? {
        startPos: initialPositions[0],
        endPos: initialPositions[1]
    } : $d6c55c4efa49683e$var$getInitialPositions(new (0, $3lIcL.AllSelection)(state.doc));
    const highlightInlineDecoration = $d6c55c4efa49683e$export$1690e22aee311809(startPos, endPos);
    let widgetDecorations = [];
    if ((0, $eGOwo.fg)('platform_editor_ai_in_editor_streaming') || (0, $eGOwo.fg)('platform_editor_ai_in_document_streaming')) {
        const [_, end] = (0, $d8IMr.expandPositionsToDocDepth)({
            doc: state.doc,
            startPos: startPos,
            endPos: endPos
        });
        const endWidgetDecoration = $d6c55c4efa49683e$export$6428b9f2a07e29a5(end, 'end');
        widgetDecorations = [
            endWidgetDecoration
        ];
    } else {
        const startWidgetDecoration = $d6c55c4efa49683e$export$6428b9f2a07e29a5(initialPositions[0], 'start');
        const endWidgetDecoration = $d6c55c4efa49683e$export$6428b9f2a07e29a5(initialPositions[1], 'end');
        widgetDecorations = initialPositions[0] === initialPositions[1] ? [
            endWidgetDecoration
        ] : [
            startWidgetDecoration,
            endWidgetDecoration
        ];
    }
    return [
        ...widgetDecorations,
        highlightInlineDecoration
    ];
};
const $d6c55c4efa49683e$export$2c80ad35b3530be1 = ({ state: state, configItem: configItem, lastTriggeredFrom: lastTriggeredFrom, triggerMethod: triggerMethod, aiGlobalOptIn: aiGlobalOptIn, initialPrompt: initialPrompt, positions: positions, triggeredFor: triggeredFor, adjustSelection: adjustSelection, nudgeMetrics: /**
	 * Nudge metrics will be used passed in analytics events.
	 * It includes detailed metrics for improve writing nudge.
	 * It is currently only set when "Improve writing" is triggered from the
	 * "Improve writing" nudge.
	 */ nudgeMetrics, locale: locale })=>{
    /**
	 * WARNING: Do not remove the isFedRamp check.
	 * This is to ensure that AI functionality is not enabled in FedRamp environments.
	 */ if (aiGlobalOptIn.status === 'disabled' || (0, $lopBx.isFedRamp)()) /**
		 * If the user has opted out of AI, or if user is in FedRamp environment,
		 * do not show the modal it's unclear how this function would be triggered as
		 * all entry points should be removed already
		 */ return ()=>false;
    if (aiGlobalOptIn.status === 'disabled-opt-in') {
        aiGlobalOptIn.triggerOptInFlow();
        return (0, $gNwqL.createCommand)({}, (tr)=>{
            (0, $9QNCj.addAnalytics)({
                editorState: state,
                tr: tr,
                payload: {
                    action: 'triggerOptInFlow',
                    actionSubject: 'editorPluginAI',
                    actionSubjectId: 'aiGlobalOptIn',
                    attributes: {
                        experienceType: (0, $cVpKV.convertExperienceName)(configItem.key),
                        lastTriggeredFrom: lastTriggeredFrom,
                        selectionType: state.selection.empty ? 'empty' : 'range'
                    },
                    eventType: (0, $bMFKb.EVENT_TYPE).UI
                }
            });
            return tr;
        });
    }
    const { from: from, to: to } = state.selection;
    const aiDecorationExperiencePluginState = (0, $gNwqL.getPluginState)(state);
    const decorationPluginStateInitialPositions = aiDecorationExperiencePluginState.initialPositions;
    let initialPositions = decorationPluginStateInitialPositions || [
        from,
        to
    ];
    // No need to expand selection for block nodes
    if (((0, $eGOwo.fg)('platform_editor_ai_in_editor_streaming') || (0, $eGOwo.fg)('platform_editor_ai_in_document_streaming')) && !triggeredFor?.isBlock) {
        const selectionPositions = decorationPluginStateInitialPositions ? {
            startPos: state.doc.resolve(decorationPluginStateInitialPositions[0]),
            endPos: state.doc.resolve(decorationPluginStateInitialPositions[1])
        } : {
            startPos: state.selection.$from,
            endPos: state.selection.$to
        };
        const [start, end] = (0, $d8IMr.expandSelectionForAIExperience)({
            selectionPositions: selectionPositions,
            /**
			 * Currently locale is optional because making it mandatory will require
			 * 	big changes across many files and change in public api as well.
			 * So we will currently fallback to "en-GB" if it is not provided.
			 */ locale: locale ?? 'en-GB'
        });
        initialPositions = [
            start,
            end
        ];
    }
    let modalDecorationSet = (0, $b7EWj.DecorationSet).empty;
    if (triggeredFor?.isBlock) {
        // First get the positions that the decorations will be added to the document at
        const decorations = $d6c55c4efa49683e$export$4379c9f48a526c4d({
            state: state
        });
        if (decorations.length) modalDecorationSet = modalDecorationSet.add(state.doc, decorations);
    } else {
        const decorations = $d6c55c4efa49683e$export$8b0c0139da7bc378({
            state: state,
            configItem: configItem,
            lastTriggeredFrom: lastTriggeredFrom,
            initialPositions: initialPositions
        });
        if (decorations.length) modalDecorationSet = modalDecorationSet.add(state.doc, decorations);
    }
    // This "command" is later picked up by a state reducer
    const action = {
        type: 'SHOW_MODAL',
        data: {
            lastTriggeredFrom: lastTriggeredFrom,
            triggerMethod: triggerMethod,
            modalDecorationSet: modalDecorationSet,
            configItem: configItem,
            modalMountedTimeStamp: Date.now(),
            initialPrompt: initialPrompt,
            triggeredFor: triggeredFor,
            initialPositions: initialPositions,
            nudgeMetrics: nudgeMetrics
        }
    };
    if ((0, $eGOwo.fg)('platform_editor_ai_in_document_streaming')) return (0, $gNwqL.createCommand)(action);
    // Clear the selection after opening the modal to hide annotation toolbar
    return (0, $gNwqL.createCommand)(action, (tr)=>{
        const selection = tr.selection;
        const { to: to, from: from } = selection;
        if (!triggeredFor?.isBlock && to !== from) tr.setSelection((0, $3lIcL.TextSelection).create(tr.doc, to));
        return tr;
    });
};
const $d6c55c4efa49683e$export$d547a4e9ddb6b51 = (modalDecorationSet, preserveEditorSelectionOnComplete)=>{
    const action = {
        type: 'END_EXPERIENCE',
        data: modalDecorationSet && !preserveEditorSelectionOnComplete ? {
            modalDecorationSet: modalDecorationSet
        } : {}
    };
    return (0, $gNwqL.createCommand)(action, (tr)=>{
        if (preserveEditorSelectionOnComplete) {
            const inlineDeco = modalDecorationSet?.find(undefined, undefined, (spec)=>spec.key === 'inlineDecoration')?.[0];
            if (inlineDeco) tr.setSelection((0, $3lIcL.TextSelection).create(tr.doc, inlineDeco.from, Math.min(inlineDeco.to, tr.doc.content.size)));
        } else if ((0, $eGOwo.fg)('platform_editor_ai_in_document_streaming')) tr.setSelection((0, $3lIcL.TextSelection).create(tr.doc, Math.min(tr.selection.to, tr.doc.content.size)));
        return tr;
    });
};
const $d6c55c4efa49683e$export$e580b88af920547a = (state, endWidgetDecorationPosition)=>{
    const aiDecorationExperiencePluginState = (0, $gNwqL.getPluginState)(state);
    const modalDecorationSet = aiDecorationExperiencePluginState.modalDecorationSet;
    const decorationWidget = modalDecorationSet.find(undefined, undefined, (spec)=>spec.key === 'endWidgetDecoration');
    let updated = modalDecorationSet.remove(decorationWidget);
    const updatedEndWidgetDecoration = $d6c55c4efa49683e$export$6428b9f2a07e29a5(endWidgetDecorationPosition, 'end');
    updated = updated.add(state.doc, [
        updatedEndWidgetDecoration
    ]);
    return (0, $gNwqL.createCommand)({
        type: 'UPDATE_MODAL_DECORATION_SET',
        data: {
            modalDecorationSet: updated
        }
    });
};

});
parcelRegister("5HAva", function(module, exports) {

$parcel$export(module.exports, "isConfluenceTitleToolbarSuggestTitle", () => $75cd0948b6bb8fb8$export$fc21f0ec31fe4ec0);

var $inU6j = parcelRequire("inU6j");
const $75cd0948b6bb8fb8$export$fc21f0ec31fe4ec0 = ({ configItem: configItem, lastTriggeredFrom: lastTriggeredFrom })=>{
    if (!configItem || !lastTriggeredFrom) return false;
    return configItem.key === (0, $inU6j.CONFIG_ITEM_KEYS).SUGGEST_A_TITLE && lastTriggeredFrom === 'confluenceTitleToolbar';
};

});
parcelRegister("inU6j", function(module, exports) {

$parcel$export(module.exports, "CONFIG_ITEM_KEYS", () => $5b4448c15cf200d4$export$a48b28ab7ec6401c);

var $5pJQx = parcelRequire("5pJQx");
var $5b4448c15cf200d4$export$a48b28ab7ec6401c = /*#__PURE__*/ function(CONFIG_ITEM_KEYS) {
    CONFIG_ITEM_KEYS["ADD_STRUCTURE"] = "Add structure";
    CONFIG_ITEM_KEYS["BRAINSTORM"] = "Brainstorm";
    CONFIG_ITEM_KEYS["CHANGE_TONE_TO_CASUAL"] = "Change tone to casual";
    CONFIG_ITEM_KEYS["CHANGE_TONE_TO_EDUCATIONAL"] = "Change tone to educational";
    CONFIG_ITEM_KEYS["CHANGE_TONE_TO_EMPATHETIC"] = "Change tone to empathetic";
    CONFIG_ITEM_KEYS["CHANGE_TONE_TO_NEUTRAL"] = "Change tone to neutral";
    CONFIG_ITEM_KEYS["CHANGE_TONE_TO_PROFESSIONAL"] = "Change tone to professional";
    CONFIG_ITEM_KEYS["CREATE_PULL_REQUEST_DESCRIPTION"] = "Create pull request description";
    CONFIG_ITEM_KEYS["DESCRIBE_YOUR_PULL_REQUEST"] = "Describe your pull request";
    CONFIG_ITEM_KEYS["FIND_ACTION_ITEMS"] = "Find action items";
    CONFIG_ITEM_KEYS["FIX_SPELLING_AND_GRAMMAR"] = "Fix spelling & grammar";
    CONFIG_ITEM_KEYS["FREE_GENERATE"] = "AI (Atlassian Intelligence)";
    CONFIG_ITEM_KEYS["FREE_GENERATE_EDITOR_AGENT"] = "AI (Atlassian Intelligence) Editor Agent";
    CONFIG_ITEM_KEYS["IMPROVE_WRITING"] = "Improve writing";
    CONFIG_ITEM_KEYS["MAKE_SHORTER"] = "Make shorter";
    CONFIG_ITEM_KEYS["ROVO_AGENT"] = "Rovo agent";
    CONFIG_ITEM_KEYS["SHORTEN_UPDATE"] = "Shorten update";
    CONFIG_ITEM_KEYS["SUGGEST_A_TITLE"] = "Suggest a title";
    CONFIG_ITEM_KEYS["SUGGEST_REPONSE"] = "Suggest a response";
    CONFIG_ITEM_KEYS["SUMMARISE_WRITING"] = "Summarize writing";
    CONFIG_ITEM_KEYS["MAKE_LONGER"] = "Make longer";
    CONFIG_ITEM_KEYS["REPHRASE"] = "Rephrase";
    CONFIG_ITEM_KEYS["ADD_INTRODUCTION"] = "Add introduction";
    CONFIG_ITEM_KEYS["ADD_CONCLUSION"] = "Add conclusion";
    CONFIG_ITEM_KEYS["CONVERT_TO_BULLETED_LIST"] = "Convert to bulleted list";
    CONFIG_ITEM_KEYS["CONVERT_TO_TABLE"] = "Convert to table";
    CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_CHINESE_SIMPLIFIED"] = `Translate to ${(0, $5pJQx.SupportedTranslationLanguages).ChineseSimplified}`] = "TRANSLATE_TO_CHINESE_SIMPLIFIED";
    CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_CHINESE_TRADITIONAL"] = `Translate to ${(0, $5pJQx.SupportedTranslationLanguages).ChineseTraditional}`] = "TRANSLATE_TO_CHINESE_TRADITIONAL";
    CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_CZECH"] = `Translate to ${(0, $5pJQx.SupportedTranslationLanguages).Czech}`] = "TRANSLATE_TO_CZECH";
    CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_DANISH"] = `Translate to ${(0, $5pJQx.SupportedTranslationLanguages).Danish}`] = "TRANSLATE_TO_DANISH";
    CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_DUTCH"] = `Translate to ${(0, $5pJQx.SupportedTranslationLanguages).Dutch}`] = "TRANSLATE_TO_DUTCH";
    CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_ENGLISH"] = `Translate to ${(0, $5pJQx.SupportedTranslationLanguages).English}`] = "TRANSLATE_TO_ENGLISH";
    CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_FINNISH"] = `Translate to ${(0, $5pJQx.SupportedTranslationLanguages).Finnish}`] = "TRANSLATE_TO_FINNISH";
    CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_FRENCH"] = `Translate to ${(0, $5pJQx.SupportedTranslationLanguages).French}`] = "TRANSLATE_TO_FRENCH";
    CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_GERMAN"] = `Translate to ${(0, $5pJQx.SupportedTranslationLanguages).German}`] = "TRANSLATE_TO_GERMAN";
    CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_HUNGARIAN"] = `Translate to ${(0, $5pJQx.SupportedTranslationLanguages).Hungarian}`] = "TRANSLATE_TO_HUNGARIAN";
    CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_ITALIAN"] = `Translate to ${(0, $5pJQx.SupportedTranslationLanguages).Italian}`] = "TRANSLATE_TO_ITALIAN";
    CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_JAPANESE"] = `Translate to ${(0, $5pJQx.SupportedTranslationLanguages).Japanese}`] = "TRANSLATE_TO_JAPANESE";
    CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_KOREAN"] = `Translate to ${(0, $5pJQx.SupportedTranslationLanguages).Korean}`] = "TRANSLATE_TO_KOREAN";
    CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_NORWEGIAN"] = `Translate to ${(0, $5pJQx.SupportedTranslationLanguages).Norwegian}`] = "TRANSLATE_TO_NORWEGIAN";
    CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_POLISH"] = `Translate to ${(0, $5pJQx.SupportedTranslationLanguages).Polish}`] = "TRANSLATE_TO_POLISH";
    CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_PORTUGUESE_BRAZILIAN"] = `Translate to ${(0, $5pJQx.SupportedTranslationLanguages).PortugueseBrazilian}`] = "TRANSLATE_TO_PORTUGUESE_BRAZILIAN";
    CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_RUSSIAN"] = `Translate to ${(0, $5pJQx.SupportedTranslationLanguages).Russian}`] = "TRANSLATE_TO_RUSSIAN";
    CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_SPANISH"] = `Translate to ${(0, $5pJQx.SupportedTranslationLanguages).Spanish}`] = "TRANSLATE_TO_SPANISH";
    CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_SWEDISH"] = `Translate to ${(0, $5pJQx.SupportedTranslationLanguages).Swedish}`] = "TRANSLATE_TO_SWEDISH";
    CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_TURKISH"] = `Translate to ${(0, $5pJQx.SupportedTranslationLanguages).Turkish}`] = "TRANSLATE_TO_TURKISH";
    CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_THAI"] = `Translate to ${(0, $5pJQx.SupportedTranslationLanguages).Thai}`] = "TRANSLATE_TO_THAI";
    CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_UKRAINIAN"] = `Translate to ${(0, $5pJQx.SupportedTranslationLanguages).Ukrainian}`] = "TRANSLATE_TO_UKRAINIAN";
    CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_VIETNAMESE"] = `Translate to ${(0, $5pJQx.SupportedTranslationLanguages).Vietnamese}`] = "TRANSLATE_TO_VIETNAMESE";
    CONFIG_ITEM_KEYS["EXPERIMENTAL_PROMPT_PLACEHOLDER"] = "Experimental prompt placeholder";
    return CONFIG_ITEM_KEYS;
}({});

});
parcelRegister("5pJQx", function(module, exports) {

$parcel$export(module.exports, "SupportedTranslationLanguages", () => $09c0086ff5802de3$export$c5e4fced70735903);
$parcel$export(module.exports, "supportedTranslationLanguagesPopularOrder", () => $09c0086ff5802de3$export$20cfed69f1ef38ea);
$parcel$export(module.exports, "refinementSupportedTranslationLanguages", () => $09c0086ff5802de3$export$9e88c4e080b12be6);
var $09c0086ff5802de3$export$c5e4fced70735903 = /*#__PURE__*/ function(SupportedTranslationLanguages) {
    SupportedTranslationLanguages["ChineseSimplified"] = "chineseSimplified";
    SupportedTranslationLanguages["ChineseTraditional"] = "chineseTraditional";
    SupportedTranslationLanguages["Czech"] = "czech";
    SupportedTranslationLanguages["Danish"] = "danish";
    SupportedTranslationLanguages["Dutch"] = "dutch";
    SupportedTranslationLanguages["English"] = "english";
    SupportedTranslationLanguages["Finnish"] = "finnish";
    SupportedTranslationLanguages["French"] = "french";
    SupportedTranslationLanguages["German"] = "german";
    SupportedTranslationLanguages["Hungarian"] = "hungarian";
    SupportedTranslationLanguages["Italian"] = "italian";
    SupportedTranslationLanguages["Japanese"] = "japanese";
    SupportedTranslationLanguages["Korean"] = "korean";
    SupportedTranslationLanguages["Norwegian"] = "norwegian";
    SupportedTranslationLanguages["Polish"] = "polish";
    SupportedTranslationLanguages["PortugueseBrazilian"] = "portugueseBrazilian";
    SupportedTranslationLanguages["Russian"] = "russian";
    SupportedTranslationLanguages["Spanish"] = "spanish";
    SupportedTranslationLanguages["Swedish"] = "swedish";
    SupportedTranslationLanguages["Turkish"] = "turkish";
    SupportedTranslationLanguages["Thai"] = "thai";
    SupportedTranslationLanguages["Ukrainian"] = "ukrainian";
    SupportedTranslationLanguages["Vietnamese"] = "vietnamese";
    return SupportedTranslationLanguages;
}({});
const $09c0086ff5802de3$export$20cfed69f1ef38ea = [
    "english",
    "german",
    "japanese",
    "french",
    "korean",
    "spanish",
    "portugueseBrazilian",
    "russian",
    "dutch",
    "chineseSimplified",
    "polish",
    "italian",
    "chineseTraditional",
    "norwegian",
    "swedish",
    "czech",
    "finnish",
    "danish",
    "hungarian",
    "turkish",
    "thai",
    "ukrainian",
    "vietnamese"
];
const $09c0086ff5802de3$export$9e88c4e080b12be6 = [
    "english",
    "german",
    "french",
    "spanish",
    "japanese",
    "portugueseBrazilian",
    "chineseSimplified",
    "korean"
];

});



parcelRegister("7WEOG", function(module, exports) {

$parcel$export(module.exports, "getSupportedNodesForAIModal", () => $2d3a4a31cfe5c0e7$export$74e7028cbce2b0e1);
$parcel$export(module.exports, "isCellSelection", () => $2d3a4a31cfe5c0e7$export$73f561bc8b894934);
const $2d3a4a31cfe5c0e7$export$74e7028cbce2b0e1 = ({ schema: { nodes: nodes } })=>new Set([
        nodes.table
    ]);
const $2d3a4a31cfe5c0e7$export$73f561bc8b894934 = (state, selection)=>{
    const { tableHeader: tableHeader, tableCell: tableCell, tabeRow: tabeRow, table: table } = state.schema.nodes;
    const { $from: $from } = selection || state.selection;
    const parent = $from.parent;
    return [
        tableHeader,
        tableCell,
        tabeRow,
        table
    ].includes(parent.type);
};

});

parcelRegister("cVpKV", function(module, exports) {

$parcel$export(module.exports, "convertExperienceName", () => $a567edc52bc9bcd6$export$42373263ca9a5144);
$parcel$export(module.exports, "createAnalyticsFlow", () => $a567edc52bc9bcd6$export$7e715b9b9acf423a);

var $8KLBw = parcelRequire("8KLBw");

var $bgewf = parcelRequire("bgewf");

var $bMFKb = parcelRequire("bMFKb");

var $59rsN = parcelRequire("59rsN");

var $ix3s9 = parcelRequire("ix3s9");

var $inU6j = parcelRequire("inU6j");

var $9QNCj = parcelRequire("9QNCj");
function $a567edc52bc9bcd6$export$42373263ca9a5144(experienceName, invokedFrom) {
    // The Proactive Description Completer are using the shared config item key with issue reformatter
    // Need to get the correct experience name from invokedFrom
    // This is temp solution to distinguish two experience
    // We are planning to add a new config item key for Proactive Description Completer
    if (invokedFrom === 'jiraProactiveDescriptionCompleterFooterButton' && experienceName === (0, $inU6j.CONFIG_ITEM_KEYS).ADD_STRUCTURE) return 'proactiveDescriptionCompleter';
    if (experienceName === (0, $inU6j.CONFIG_ITEM_KEYS).EXPERIMENTAL_PROMPT_PLACEHOLDER) {
        /**
		 * We only check for experiment value here as the config item would not exist
		 * if the experiment is not enabled / is misconfigured.
		 */ const getExperimentValue = (0, $59rsN.default).getExperimentValue;
        const analyticsExperienceName = getExperimentValue('platform_editor_ai-prompts-placeholder', 'analytics_experience_name', '');
        return analyticsExperienceName || experienceName;
    }
    return experienceName;
}
function $a567edc52bc9bcd6$export$7e715b9b9acf423a({ fireAIAnalyticsEvent: fireAIAnalyticsEvent, invokeAttributes: invokeAttributes }) {
    const startTime = performance.now();
    const stepTracker = {};
    const aiSessionId = (0, (/*@__PURE__*/$parcel$interopDefault($8KLBw)))();
    let prevStepEnd = performance.now();
    let prevStepName;
    let experienceName;
    let adhocAttributes = {};
    let commonAttributes = {};
    let dynamicAttributes = {};
    let aiLifeCycleDynamicAttributesGetter;
    let finished = false;
    let contentCopiedSometime = false;
    const sawAupViolation = false;
    let interactionsCounter = 0;
    let lastAiInteractionID;
    let queuedStepArgs = {
        stepName: 'invoke',
        attributes: invokeAttributes
    };
    /**
	 * A util function to get dynamic attributes for the AI lifecyle
	 * The previously registered getter is invoked when the lifecyle begins
	 * The resolved attributes are then used until the lifecycle ends
	 */ const getAiLifeCycleDynamicAttributes = ({ init: init })=>{
        if (init && aiLifeCycleDynamicAttributesGetter) dynamicAttributes = aiLifeCycleDynamicAttributesGetter();
        return dynamicAttributes;
    };
    const getAgentAttributes = ()=>{
        return {
            agentName: commonAttributes.agentName,
            agentId: commonAttributes.agentId,
            agentCreatorType: commonAttributes.agentCreatorType,
            agentExternalConfigReference: commonAttributes.agentExternalConfigReference,
            agentIsDefault: commonAttributes.agentIsDefault
        };
    };
    const analyticsFlow = {
        aiSessionId: aiSessionId,
        /**
		 * Add a step to the queue to be fired on next screen.
		 * @example
		 * ```tsx
		 * const analyticsFlow = useAnalyticsFlow();
		 * analyticsFlow.enqueueStep({ stepName, attributes });
		 * ```
		 */ enqueueStep: (stepArgs)=>{
            // If the user has already finished the experience, we fire an operational error and return
            if (finished) {
                fireAIAnalyticsEvent($a567edc52bc9bcd6$var$createErrorPayload({
                    aiSessionId: aiSessionId,
                    errorSubType: 'userFlowAlreadyFinished',
                    errorProperties: {
                        stepArgs: stepArgs,
                        queuedStepArgs: queuedStepArgs
                    }
                }));
                return;
            }
            if (stepArgs.stepName === 'loading') {
                lastAiInteractionID = `${aiSessionId}-${++interactionsCounter}`;
                fireAIAnalyticsEvent({
                    payload: (0, $ix3s9.createUnifiedAnalyticsPayload)({
                        action: (0, $bMFKb.ACTION).INITIATED,
                        interactionID: commonAttributes.channelId ?? lastAiInteractionID,
                        experienceName: $a567edc52bc9bcd6$export$42373263ca9a5144(experienceName ?? '', invokeAttributes.invokedFrom),
                        isProactive: false,
                        invokedFrom: invokeAttributes.invokedFrom,
                        nudgeMetrics: commonAttributes.nudgeMetrics,
                        attributes: {
                            ...getAiLifeCycleDynamicAttributes({
                                init: true
                            }),
                            ...getAgentAttributes()
                        }
                    })
                });
            }
            if (stepArgs.stepName === 'complete') {
                const attributes = stepArgs?.attributes ?? {};
                const actionTaken = 'actionTaken' in attributes ? attributes.actionTaken : undefined;
                const promptType = 'promptType' in attributes ? attributes.promptType : undefined;
                const refinementCount = 'refinementCount' in attributes ? attributes.refinementCount : undefined;
                fireAIAnalyticsEvent({
                    payload: (0, $ix3s9.createUnifiedAnalyticsPayload)({
                        action: (0, $bMFKb.ACTION).ACTIONED,
                        interactionID: commonAttributes.channelId ?? lastAiInteractionID,
                        experienceName: $a567edc52bc9bcd6$export$42373263ca9a5144(experienceName ?? '', invokeAttributes.invokedFrom),
                        isProactive: false,
                        invokedFrom: invokeAttributes.invokedFrom,
                        nudgeMetrics: commonAttributes.nudgeMetrics,
                        attributes: {
                            ...getAiLifeCycleDynamicAttributes({
                                init: false
                            }),
                            ...getAgentAttributes(),
                            promptType: promptType,
                            refinementCount: refinementCount,
                            aiResultAction: actionTaken?.toLowerCase()
                        },
                        traceIds: commonAttributes.traceIds
                    })
                });
            }
            // If there is already a queued step, we fire an operational error and return
            if (queuedStepArgs !== undefined) {
                fireAIAnalyticsEvent($a567edc52bc9bcd6$var$createErrorPayload({
                    aiSessionId: aiSessionId,
                    errorSubType: 'cannotEnqueueMoreThanOneEvent',
                    errorProperties: {
                        stepArgs: stepArgs,
                        queuedStepArgs: queuedStepArgs
                    }
                }));
                return;
            }
            queuedStepArgs = stepArgs;
        },
        fireQueuedStep: (target)=>{
            // If the user has already finished the experience, we fire an operational error and return
            if (finished) {
                fireAIAnalyticsEvent($a567edc52bc9bcd6$var$createErrorPayload({
                    aiSessionId: aiSessionId,
                    errorSubType: 'userFlowAlreadyFinished',
                    errorProperties: {
                        target: target,
                        queuedStepArgs: queuedStepArgs
                    }
                }));
                return;
            }
            // If there is no queued step, we fire an operational error and return
            if (!queuedStepArgs) {
                fireAIAnalyticsEvent($a567edc52bc9bcd6$var$createErrorPayload({
                    aiSessionId: aiSessionId,
                    errorSubType: 'noEventExistsToBeFired',
                    errorProperties: {
                        target: target
                    }
                }));
                return;
            }
            queuedStepArgs.attributes = {
                ...queuedStepArgs.attributes,
                ...adhocAttributes,
                ...commonAttributes,
                invokedFrom: invokeAttributes.invokedFrom,
                nudgeMetrics: commonAttributes.nudgeMetrics,
                invokedFor: invokeAttributes.invokedFor,
                triggerMethod: invokeAttributes.triggerMethod,
                target: target
            };
            if (target === 'failed' || target === 'apiError') fireAIAnalyticsEvent({
                payload: (0, $ix3s9.createUnifiedAnalyticsPayload)({
                    action: (0, $bMFKb.ACTION).ERROR,
                    interactionID: commonAttributes.channelId ?? lastAiInteractionID,
                    experienceName: $a567edc52bc9bcd6$export$42373263ca9a5144(experienceName ?? '', invokeAttributes.invokedFrom),
                    isProactive: false,
                    invokedFrom: invokeAttributes.invokedFrom,
                    nudgeMetrics: commonAttributes.nudgeMetrics,
                    attributes: {
                        ...getAiLifeCycleDynamicAttributes({
                            init: false
                        }),
                        ...getAgentAttributes(),
                        aiErrorMessage: (0, $9QNCj.isErrorStepAttributes)(queuedStepArgs?.attributes) ? queuedStepArgs?.attributes?.errorKey ?? queuedStepArgs?.attributes?.errorType : 'Unknown error',
                        aiErrorCode: (0, $9QNCj.isErrorStepAttributes)(queuedStepArgs.attributes) ? queuedStepArgs.attributes?.statusCode ?? 500 : 500
                    },
                    traceIds: commonAttributes.traceIds
                })
            });
            if (target === 'preview') fireAIAnalyticsEvent({
                payload: (0, $ix3s9.createUnifiedAnalyticsPayload)({
                    action: (0, $bMFKb.ACTION).VIEWED,
                    interactionID: commonAttributes.channelId ?? lastAiInteractionID,
                    experienceName: $a567edc52bc9bcd6$export$42373263ca9a5144(experienceName ?? '', invokeAttributes.invokedFrom),
                    isProactive: false,
                    invokedFrom: invokeAttributes.invokedFrom,
                    nudgeMetrics: commonAttributes.nudgeMetrics,
                    attributes: {
                        ...getAiLifeCycleDynamicAttributes({
                            init: false
                        }),
                        ...getAgentAttributes()
                    },
                    traceIds: commonAttributes.traceIds
                })
            });
            // Add target to attributes and fire the event
            fireUserFlowStep(queuedStepArgs);
            // Remove the queued event
            queuedStepArgs = undefined;
        },
        /**
		 * This is useful when you want to add attributes to the current step
		 * but you don't know them at the time of enqueuing the step.
		 *
		 * It's safe to fire this on dismount -- because the step is enqueued in the dismount
		 * of a parent component (where AnalyticsFlowContextProvider is setup).
		 *
		 * @example
		 * ```tsx
		 * const analyticsFlow = useAnalyticsFlow();
		 * React.useEffect(() => {
		 *  return () => {
		 *    // add attribute on dismount
		 *    analyticsFlow.addAttributes({ loadingTime })
		 *  }
		 * })
		 * ```
		 */ addAttributes: (attributes)=>{
            // The user copying the content is being treated as a potential success indicator
            // This is a weak signal as we don't know if the user actually used the copied content
            // and might expect the user to copy the content in cases where the generation failed.
            if ('contentCopied' in attributes && attributes.contentCopied) contentCopiedSometime = true;
            adhocAttributes = {
                ...adhocAttributes,
                ...attributes
            };
        },
        getAiLifeCycleDynamicAttributes: getAiLifeCycleDynamicAttributes,
        /**
		 * Editor-AI can be invoked in various contexts.
		 * In some of those scenarios, we want to register additional attributes to understand how the respective feature is performing.
		 *
		 * For example, when the Issue Reformatter is used, we want to understand analytics such as
		 *  - The issue-type of the issue where the issue reformatter was invoked
		 *  - Whether the feature was used from Issue-View or GIC
		 *  - Product type such as JWM and JSW
		 *
		 * This method registers a attribute getter function.
		 * The function will be invoked when the feature is first run (i.e. along with `aiInteraction Initiated`)
		 * The resolved values will then be unchanged until the AI lifecyle is completed
		 * i.e. The same values will be used for all events such as `aiResult Viewed` and `aiResult dismissed`
		 *
		 * In the current version, this method accepts one getter function, and assumes that there aren't multiple functions.
		 * In future, this can be tweaked to allow multiple getters.
		 * Such improvements need to be done carefully so that the getters are also unregistered accordingly
		 */ registerAiLifeCycleDynamicAttributesGetter: (getter)=>{
            aiLifeCycleDynamicAttributesGetter = getter;
        },
        /**
		 * Common attributes will be retained for the rest of the analytics flow
		 * until it is updated again
		 *
		 * Example uses: keeping track of which backendModel has been selected
		 */ updateCommonAttributes: (attributes)=>{
            commonAttributes = {
                ...commonAttributes,
                ...attributes
            };
        },
        getLastAiInteractionId: ()=>lastAiInteractionID,
        getUserFlowCommonAttributes: (configItem)=>{
            return {
                agentName: configItem.agent?.creatorType === 'SYSTEM' ? configItem.agent?.name : undefined,
                agentId: configItem.agent?.id,
                agentCreatorType: configItem.agent?.creatorType,
                agentExternalConfigReference: configItem.agent?.externalConfigReference,
                agentIsDefault: configItem.agent?.isDefault,
                adfPrompt: configItem.adfPrompt
            };
        }
    };
    return analyticsFlow;
    function fireUserFlowStep({ stepName: stepName, attributes: attributes = {} }) {
        if (!stepTracker[stepName]) stepTracker[stepName] = 1;
        else stepTracker[stepName] = stepTracker[stepName] + 1;
        if (attributes.experienceName) experienceName = $a567edc52bc9bcd6$export$42373263ca9a5144(attributes.experienceName, invokeAttributes.invokedFrom);
        const stepAttributes = {
            ...commonAttributes,
            // the duration is currently being overriden in the complete step
            duration: Math.round(performance.now() - prevStepEnd),
            ...attributes,
            aiSessionId: aiSessionId,
            experienceName: experienceName,
            source: prevStepName,
            invokedFrom: attributes.invokedFrom,
            nudgeMetrics: attributes.nudgeMetrics,
            triggerMethod: attributes.triggerMethod,
            isInvokedFromEmptyPage: attributes.isInvokedFromEmptyPage,
            stepOccurrence: String(stepTracker[stepName]),
            sawAupViolation: sawAupViolation,
            includeKnowledgeFromCurrentPage: attributes.includeKnowledgeFromCurrentPage
        };
        // add totalDuration only to the final step
        // and set the experience as finished
        if (!attributes.target) {
            stepAttributes.totalDuration = Math.round(performance.now() - startTime);
            stepAttributes.contentCopiedSometime = contentCopiedSometime;
            finished = true;
        }
        // adding interaction ID to the events coming after the loading step, + final complete step
        if (stepAttributes.source === 'loading' || stepName === 'complete') stepAttributes.aiInteractionID = lastAiInteractionID;
        const payload = {
            action: stepName,
            actionSubject: 'editorPluginAI',
            actionSubjectId: 'userFlow',
            attributes: stepAttributes,
            eventType: (0, $bMFKb.EVENT_TYPE).UI
        };
        //each step is a starting point for measuring duration for next step
        prevStepEnd = performance.now();
        //reset previous step name and custom attributes
        prevStepName = stepName;
        adhocAttributes = {};
        fireAIAnalyticsEvent({
            payload: payload
        });
        if (finished) fireAIAnalyticsEvent({
            payload: {
                ...payload,
                action: 'finished',
                attributes: {
                    ...payload.attributes,
                    // override source to be the previous last step in the flow
                    source: stepName
                }
            }
        });
    }
}
/**
 * Creates an operational error payload
 */ function $a567edc52bc9bcd6$var$createErrorPayload({ errorSubType: errorSubType, errorProperties: errorProperties }) {
    return {
        payload: {
            action: 'unhandledErrorCaught',
            actionSubject: 'editorPluginAI',
            actionSubjectId: 'experienceApplication',
            attributes: {
                errorType: 'userFlowAnalyticsError',
                errorSubType: errorSubType,
                ...errorProperties
            },
            eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL
        },
        channel: (0, $bgewf.FabricChannel).editor
    };
}

});
parcelRegister("ix3s9", function(module, exports) {

$parcel$export(module.exports, "createUnifiedAnalyticsPayload", () => $915df4d03eb4a566$export$b0cd7b0ace1e359d);

var $bMFKb = parcelRequire("bMFKb");
function $915df4d03eb4a566$var$createAIUnifiedCommonAttributes(interactionID, experienceName, isProactive, traceIds, invokedFrom, nudgeMetrics) {
    return {
        singleInstrumentationID: interactionID ?? '',
        aiInteractionID: interactionID ?? '',
        aiFeatureName: 'Editor AI',
        aiExperienceName: experienceName ?? 'unknown',
        isAIFeature: 1,
        proactiveAIGenerated: !!isProactive ? 1 : 0,
        userGeneratedAI: !isProactive ? 1 : 0,
        traceIds: traceIds,
        invokedFrom: invokedFrom,
        nudgeMetrics: nudgeMetrics
    };
}
function $915df4d03eb4a566$export$b0cd7b0ace1e359d({ action: action, interactionID: interactionID, attributes: attributes, experienceName: experienceName, isProactive: isProactive, invokedFrom: invokedFrom, traceIds: traceIds, nudgeMetrics: nudgeMetrics }) {
    const unifiedAnalyticsAttributes = $915df4d03eb4a566$var$createAIUnifiedCommonAttributes(interactionID, experienceName, isProactive, traceIds, invokedFrom, nudgeMetrics);
    switch(action){
        case (0, $bMFKb.ACTION).ACTIONED:
            return {
                action: action,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).AI_RESULT,
                actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).EDITOR_PLUGIN_AI,
                eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
                attributes: {
                    aiResultAction: 'unknown',
                    ...unifiedAnalyticsAttributes,
                    ...attributes
                }
            };
        case (0, $bMFKb.ACTION).VIEWED:
        case (0, $bMFKb.ACTION).ERROR:
            return {
                action: action,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).AI_RESULT,
                actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).EDITOR_PLUGIN_AI,
                eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
                attributes: {
                    ...unifiedAnalyticsAttributes,
                    ...attributes
                }
            };
        case (0, $bMFKb.ACTION).INITIATED:
        case (0, $bMFKb.ACTION).DISMISSED:
            return {
                action: action,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).AI_INTERACTION,
                actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).EDITOR_PLUGIN_AI,
                eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
                attributes: {
                    ...unifiedAnalyticsAttributes,
                    ...attributes
                }
            };
        case (0, $bMFKb.ACTION).SUBMITTED:
            return {
                action: action,
                actionSubject: (0, $bMFKb.ACTION_SUBJECT).AI_FEEDBACK,
                actionSubjectId: (0, $bMFKb.ACTION_SUBJECT_ID).EDITOR_PLUGIN_AI,
                eventType: (0, $bMFKb.EVENT_TYPE).TRACK,
                attributes: {
                    // If feedback result is not explicitly set then we should assume negative, since people are more likely to
                    // report negative experiences than they are positive ones.
                    aiFeedbackResult: 'down',
                    ...unifiedAnalyticsAttributes,
                    ...attributes
                }
            };
    }
}

});

parcelRegister("9QNCj", function(module, exports) {

$parcel$export(module.exports, "addAnalytics", () => $3164de021bab249e$export$5bef18c22bfe95d);
$parcel$export(module.exports, "useFireAIAnalyticsEvent", () => $3164de021bab249e$export$5098b64908ee530);
$parcel$export(module.exports, "isErrorStepAttributes", () => $3164de021bab249e$export$1256d4293be5e625);

var $eJOHy = parcelRequire("eJOHy");

var $ivREi = parcelRequire("ivREi");

var $bgewf = parcelRequire("bgewf");

var $ftN6c = parcelRequire("ftN6c");

var $6LyC9 = parcelRequire("6LyC9");
function $3164de021bab249e$export$e65dc2451c080d01(payload) {
    const packageInfo = (0, $6LyC9.getPackageInfo)();
    const attributes = payload.attributes || {};
    return {
        ...payload,
        attributes: {
            ...attributes,
            aiPluginPackageName: packageInfo.packageName,
            aiPluginPackageVersion: packageInfo.packageVersion
        }
    };
}
// This utils is referenced from packages/editor/editor-core/src/analytics-api/attach-payload-into-transaction.ts
// Note: this adds extra step to a transaction which effectively marks it as docChanged and can cause editor onchange to fire on dispatch
function $3164de021bab249e$var$attachPayloadIntoTransaction({ editorState: editorState, payload: payload, channel: channel = (0, $bgewf.FabricChannel).editor }) {
    return (tr)=>{
        const { storedMarks: storedMarks } = tr;
        const pos = tr.mapping.map(editorState.selection.$from.pos, -1);
        tr.step(new (0, $ivREi.AnalyticsStep)([
            {
                payload: $3164de021bab249e$export$e65dc2451c080d01(payload),
                channel: channel
            }
        ], [], // We don't understand now why we need position in AnalyticsStep.
        // So we are keeping same as it is in original util.
        // Below comment is taken from original util from packages/editor/editor-core/src/analytics-api/attach-payload-into-transaction.ts
        // We need to create the step based on a position, this prevent split history for relative changes.
        pos));
        // We don't understand now why we need to store marks again in transaction.
        // So we are keeping same as it is in original util.
        // Below comment is taken from original util from packages/editor/editor-core/src/analytics-api/attach-payload-into-transaction.ts
        // When you add a new step all the storedMarks are removed it
        if (storedMarks) tr.setStoredMarks(storedMarks);
        return true;
    };
}
function $3164de021bab249e$export$5bef18c22bfe95d({ editorState: editorState, tr: tr, payload: payload, channel: channel = (0, $bgewf.FabricChannel).editor, addToHistory: addToHistory = true }) {
    $3164de021bab249e$var$attachPayloadIntoTransaction({
        editorState: editorState,
        payload: payload,
        channel: channel
    })(tr);
    if (!addToHistory) tr.setMeta('addToHistory', false);
    return tr;
}
function $3164de021bab249e$export$af9baadf0e4f6e13({ payload: payload, channel: channel = (0, $bgewf.FabricChannel).editor }) {
    return (command)=>(state, dispatch, view)=>command(state, (tr)=>{
                if (dispatch) {
                    if (payload instanceof Function) {
                        const dynamicPayload = payload(state);
                        if (dynamicPayload) dispatch($3164de021bab249e$export$5bef18c22bfe95d({
                            editorState: state,
                            tr: tr,
                            payload: dynamicPayload,
                            channel: channel
                        }));
                    } else dispatch($3164de021bab249e$export$5bef18c22bfe95d({
                        editorState: state,
                        tr: tr,
                        payload: payload,
                        channel: channel
                    }));
                }
            }, view);
}
function $3164de021bab249e$export$12ef4e1e68d53406(createAnalyticsEvent) {
    return ({ payload: payload, channel: channel = (0, $bgewf.FabricChannel).editor })=>{
        if (!createAnalyticsEvent) return;
        const fireEvent = ()=>createAnalyticsEvent($3164de021bab249e$export$e65dc2451c080d01(payload))?.fire(channel);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (window.requestIdleCallback) // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        window.requestIdleCallback(fireEvent);
        else if (window.requestAnimationFrame) // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        window.requestAnimationFrame(fireEvent);
        else setTimeout(fireEvent, 0);
    };
}
function $3164de021bab249e$export$5098b64908ee530() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const fireAIAnalyticsEvent = (0, $eJOHy.useCallback)((args)=>$3164de021bab249e$export$12ef4e1e68d53406(createAnalyticsEvent)(args), [
        createAnalyticsEvent
    ]);
    return fireAIAnalyticsEvent;
}
function $3164de021bab249e$export$511854ca6705eca5(channelId, lastAiInteractionID) {
    return channelId ?? lastAiInteractionID ?? '';
}
function $3164de021bab249e$export$1256d4293be5e625(step) {
    if (!step) return false;
    return 'errorKey' in step || 'errorType' in step || 'statusCode' in step;
}

});
parcelRegister("6LyC9", function(module, exports) {

$parcel$export(module.exports, "getPackageInfo", () => $6464c23cc5f1408c$export$cd17d76da7967240);
const $6464c23cc5f1408c$var$packageName = "platform-pkg";
const $6464c23cc5f1408c$var$packageVersion = "0.0.0-use.local";
function $6464c23cc5f1408c$export$cd17d76da7967240() {
    return {
        packageName: $6464c23cc5f1408c$var$packageName,
        packageVersion: $6464c23cc5f1408c$var$packageVersion
    };
}

});



parcelRegister("d8IMr", function(module, exports) {

$parcel$export(module.exports, "expandPositionsToDocDepth", () => $af52c3031de41b78$export$f09cc099cd10bb0d);
$parcel$export(module.exports, "expandSelectionForAIExperience", () => $af52c3031de41b78$export$188100af2e354326);
const $af52c3031de41b78$export$f09cc099cd10bb0d = ({ doc: doc, startPos: startPos, endPos: endPos })=>{
    const $startPos = doc.resolve(startPos);
    const $endPos = doc.resolve(endPos);
    const start = $startPos.depth === 0 ? startPos : Math.max($startPos.start(1) - 1, 0);
    const end = $endPos.depth === 0 ? endPos : Math.min($endPos.end(1) + 1, doc.content.size);
    return [
        start,
        end
    ];
};
function $af52c3031de41b78$var$getWordsFromTextUsingSegmenter(text, locale) {
    const segmenter = new Intl.Segmenter(locale, {
        granularity: 'word'
    });
    const segments = Array.from(segmenter.segment(text));
    const words = segments.filter((segment)=>segment.isWordLike);
    return words.map((word)=>({
            text: word.segment,
            index: word.index
        }));
}
function $af52c3031de41b78$var$getWordsFromTextUsingRegex(text) {
    const result = [];
    const regex = /\S+/gu;
    const matches = text.matchAll(regex);
    for (const match of matches)result.push({
        text: match[0],
        index: match.index
    });
    return result;
}
function $af52c3031de41b78$var$getWordsFromText(text, locale) {
    if (Intl.Segmenter) return $af52c3031de41b78$var$getWordsFromTextUsingSegmenter(text, locale);
    return $af52c3031de41b78$var$getWordsFromTextUsingRegex(text);
}
function $af52c3031de41b78$var$expandSelectionToCompleteWords({ selectionPositions: selectionPositions, locale: locale }) {
    const startPos = selectionPositions.startPos.pos;
    const endPos = selectionPositions.endPos.pos;
    const doc = selectionPositions.startPos.doc;
    let newStartPos = startPos;
    let newEndPos = endPos;
    let startPosTextNode;
    let endPosTextNode;
    let startPosTextNodePos;
    let endPosTextNodePos;
    doc.nodesBetween(startPos, endPos, (node, nodePos)=>{
        if (!startPosTextNode && node.isText) {
            startPosTextNode = node;
            startPosTextNodePos = nodePos;
        }
        if (node.isText) {
            endPosTextNode = node;
            endPosTextNodePos = nodePos;
        }
    });
    if (startPosTextNode && startPosTextNode.isText && startPosTextNode.text && startPosTextNodePos) {
        const words = $af52c3031de41b78$var$getWordsFromText(startPosTextNode.text, locale);
        const startPosInText = startPos - startPosTextNodePos;
        const selectionStartWord = words.find((word)=>word.index < startPosInText && word.index + word.text.length > startPosInText);
        newStartPos = selectionStartWord ? selectionStartWord.index + startPosTextNodePos : startPos;
    }
    if (endPosTextNode && endPosTextNode.isText && endPosTextNode.text && endPosTextNodePos) {
        const words = $af52c3031de41b78$var$getWordsFromText(endPosTextNode.text, locale);
        const endPosInText = endPos - endPosTextNodePos;
        const selectionEndWord = words.find((word)=>word.index < endPosInText && word.index + word.text.length > endPosInText);
        newEndPos = selectionEndWord ? selectionEndWord.index + selectionEndWord.text.length + endPosTextNodePos : endPos;
    }
    return [
        newStartPos,
        newEndPos
    ];
}
function $af52c3031de41b78$export$188100af2e354326({ selectionPositions: selectionPositions, locale: locale }) {
    return $af52c3031de41b78$var$expandSelectionToCompleteWords({
        selectionPositions: selectionPositions,
        locale: locale
    });
}

});

parcelRegister("gNwqL", function(module, exports) {

$parcel$export(module.exports, "createInitialState", () => $d496b317fadeecff$export$de5e90bd767c5d82);
$parcel$export(module.exports, "createPluginState", () => $d496b317fadeecff$export$656c7661095efe2e);
$parcel$export(module.exports, "createCommand", () => $d496b317fadeecff$export$8d4021544bdece00);
$parcel$export(module.exports, "getPluginState", () => $d496b317fadeecff$export$f05434c51e3762e);

var $bMFKb = parcelRequire("bMFKb");

var $bazog = parcelRequire("bazog");

var $b7EWj = parcelRequire("b7EWj");

var $iHdh6 = parcelRequire("iHdh6");

var $d0vZq = parcelRequire("d0vZq");

var $ihG6b = parcelRequire("ihG6b");

var $9HEjT = parcelRequire("9HEjT");

var $3Y9NC = parcelRequire("3Y9NC");

var $fTjL5 = parcelRequire("fTjL5");
/**
 * This creates a function which is called inside the prosemirror plugin state apply method via the
 * pluginFactory.
 *
 * The docChanged is called for every transaction where the docChanged property of the transaction is true,
 * and the returned value is set to the PluginState value.
 *
 * It takes a dispatchAnalyticsEvent in order to track whether the mapping we use to build a new PluginState
 * is throwing any errors.  This is a temporary measure to track whether we are hitting any edge cases
 * where the mapping is throwing errors. If we find that this is happening, we will revisit the approach
 * to building a new PluginState.
 *
 * The state being built here is used to  from the document used to;
 * - both apply and remove decorations to display the AI modal,
 * - apply decorations following the insertion of AI generated content, to highlight the inserted content (these are removed in the selectionChanged below).
 *
 * In future the intention is to seperate these concerns into seperate plugins.
 */ function $d496b317fadeecff$var$onDocChanged(tr, pluginState) {
    const { dispatchAnalyticsEvent: dispatchAnalyticsEvent } = pluginState;
    // In some collab edge cases mapping decorations could throw an error
    // The ProseMirror .mapping approach has a “dangerous” axiom:
    // Besides the initial state, a document will always “change” through a Transaction
    // However, in some conditions we may reconfigure the EditorState, and a new document
    // will be created without a transaction.
    // This try/catch intends to track cases of this happening and see if it impacts users
    try {
        // Check if transaction is from inserting AI generated content for blocks
        const isAiContentTransformationForBlocks = tr.getMeta('isAiContentTransformationForBlocks');
        // Return with generated content decoration for blocks
        if (isAiContentTransformationForBlocks) {
            const newDecorations = (0, $fTjL5.getGeneratedNodeDecorationsFromTransaction)(tr);
            if (newDecorations.length) return {
                ...pluginState,
                modalDecorationSet: (0, $b7EWj.DecorationSet).create(tr.doc, newDecorations)
            };
        }
        // Check if transaction is from inserting AI generated content
        const generatedContentMeta = tr.getMeta('isAiContentTransformation');
        // Return with generated content decoration
        if (generatedContentMeta) {
            const newDecoration = (0, $fTjL5.getGeneratedDecorationFromTransaction)(tr);
            if (!newDecoration) throw new Error('Did not expect not to find new content in a `isAiContentTransformation` transaction?');
            return {
                ...pluginState,
                modalDecorationSet: (0, $b7EWj.DecorationSet).create(tr.doc, newDecoration)
            };
        }
        // If there is no existing modal decoration -- exit early
        if (pluginState.modalDecorationSet === (0, $b7EWj.DecorationSet).empty) return pluginState;
        // Check if generated AI decorations already exist
        const hasGeneratedContentDecoration = (0, $3Y9NC.hasGeneratedContentDecorations)(pluginState);
        const isRemote = tr.getMeta('isRemote') ?? false;
        /**
		 * Make sure it isn't a selection change from an appendTransaction
		 */ const selectionWasSet = tr.selectionSet && tr.getMeta('appendedTransaction') === undefined;
        /**
		 * Remove decorations if
		 * - current user interacts with doc
		 *   - and it is not an appendedTransaction
		 */ if (hasGeneratedContentDecoration && !isRemote && selectionWasSet) return {
            ...pluginState,
            modalDecorationSet: (0, $b7EWj.DecorationSet).empty
        };
        // Map the modal decorationSet against the transaction
        const mappedModalDecorationSet = pluginState.modalDecorationSet.map(tr.mapping, tr.doc);
        // return mapped decoration set for case where other users in collab are making changes to doc
        if (hasGeneratedContentDecoration) return {
            ...pluginState,
            modalDecorationSet: mappedModalDecorationSet
        };
        // Find the start/inline/end decoration
        const decorations = mappedModalDecorationSet.find();
        let inlineDecoration = decorations.find((d)=>d.spec.key === 'inlineDecoration');
        let startDecoration = decorations.find((d)=>d.spec.key === 'startWidgetDecoration');
        let endDecoration = decorations.find((d)=>d.spec.key === 'endWidgetDecoration');
        const nodeDecoration = decorations.find((d)=>d.spec.key === 'ai-nodeDecoration');
        // AI experience was triggered by quick insert, no start widget or inline decoration
        if (nodeDecoration || endDecoration && !startDecoration && !inlineDecoration) return {
            ...pluginState,
            modalDecorationSet: mappedModalDecorationSet
        };
        /**
		 * If document change, it will cause inlineDecoration to collapse to same position.
		 * We then won't need the AI model as all content between position has been deleted.
		 */ const inlineDecorationHasContent = !!inlineDecoration && inlineDecoration.from !== inlineDecoration.to;
        // Return with no decorations if inline decoration does not exist
        // Handles edge case where the inline decoration can't be deleted at the start
        // of a doc even when it has no content
        // OR if it has no content (eg. selection is just empty paragraphs)
        if (!inlineDecoration || !inlineDecorationHasContent) return {
            ...pluginState,
            modalDecorationSet: (0, $b7EWj.DecorationSet).empty
        };
        // Handle the case where doc changes move inlineDecoration to position 0
        // We cannot add text before inline decoration if from position is 0
        // Remove and recreate inline decoration starting at position 1
        if (inlineDecoration.from === 0) inlineDecoration = (0, $d0vZq.createInlineDecoration)(inlineDecoration.from || 1, inlineDecoration.to || 1);
        // Create and add start widget into DecorationSet if it's been deleted
        if (!startDecoration) startDecoration = (0, $d0vZq.createWidgetDecoration)(inlineDecoration.from, 'start');
        // Create and add end widget into DecorationSet if it doesn't exist
        if (!endDecoration) endDecoration = (0, $d0vZq.createWidgetDecoration)(inlineDecoration.to, 'end');
        return {
            ...pluginState,
            modalDecorationSet: (0, $b7EWj.DecorationSet).create(tr.doc, [
                startDecoration,
                inlineDecoration,
                endDecoration
            ])
        };
    } catch (error) {
        const analyticsPayload = {
            action: 'unhandledErrorCaught',
            actionSubject: 'editorPluginAI',
            actionSubjectId: 'decorationPluginFactory',
            attributes: {
                errorType: 'handleDocChangedError',
                errorMessage: (0, $iHdh6.ErrorUtils).extractErrorMessage(error)
            },
            eventType: (0, $bMFKb.EVENT_TYPE).OPERATIONAL
        };
        dispatchAnalyticsEvent(analyticsPayload);
        return {
            ...pluginState,
            modalDecorationSet: (0, $b7EWj.DecorationSet).empty
        };
    }
}
/**
 * This function is called inside the prosemirror plugin state apply method via the pluginFactory.
 *
 * The docChanged is called for every transaction where the selectionSet property of the transaction is true,
 * and the returned value is set to the PluginState value.
 *
 * The state transformation here is being used to remove the decorations that are added when the AI experience has inserted content.
 *
 * These are added inside docChanged above.
 *
 * In future the intention is to seperate this concerns into seperate plugin (currently the majority of this file is dealing
 * with decorations related to the presentation of a modal for the AI experience).
 */ function $d496b317fadeecff$var$onSelectionChanged(_tr, pluginState) {
    if (pluginState.modalDecorationSet === (0, $b7EWj.DecorationSet).empty || pluginState.configItem) return pluginState;
    if ((0, $3Y9NC.hasGeneratedContentDecorations)(pluginState)) return {
        ...pluginState,
        modalDecorationSet: (0, $b7EWj.DecorationSet).empty
    };
    return pluginState;
}
// if in the future we need to map other state, we can rename this to mappingInitialPositions
// and add another mapping function for the other state
// this is to avoid having a single function that does too many things
function $d496b317fadeecff$var$mapping(tr, pluginState) {
    const { initialPositions: initialPositions } = pluginState;
    if (!initialPositions) return pluginState;
    const mappedInitialPositions = [
        tr.mapping.map(initialPositions[0]),
        tr.mapping.map(initialPositions[1])
    ];
    if (mappedInitialPositions[0] === initialPositions[0] && mappedInitialPositions[1] === initialPositions[1]) return pluginState;
    return {
        ...pluginState,
        initialPositions: mappedInitialPositions
    };
}
const $d496b317fadeecff$export$de5e90bd767c5d82 = (dispatchAnalyticsEvent)=>(state)=>{
        return {
            /**
			 * Longer term it would be good to expand the decorationset to include
			 * the entire selection, as well as the 'valid inline position' to place
			 * an inline widget visualising start+end of valid selections
			 */ modalDecorationSet: (0, $b7EWj.DecorationSet).empty,
            dispatchAnalyticsEvent: /**
			 * This takes a dispatchAnalyticsEvent in order to support firing analytics events in case
			 * mapping logic used in the onDocChanged passed to the pluginFactory throws an error.
			 */ dispatchAnalyticsEvent
        };
    };
const { createPluginState: $d496b317fadeecff$export$656c7661095efe2e, createCommand: $d496b317fadeecff$export$8d4021544bdece00, getPluginState: $d496b317fadeecff$export$f05434c51e3762e } = (0, $bazog.pluginFactory)((0, $ihG6b.aiExperienceDecorationPluginKey), (0, $9HEjT.reducer), {
    mapping: $d496b317fadeecff$var$mapping,
    onDocChanged: $d496b317fadeecff$var$onDocChanged,
    onSelectionChanged: $d496b317fadeecff$var$onSelectionChanged
});

});
parcelRegister("ihG6b", function(module, exports) {

$parcel$export(module.exports, "aiExperienceDecorationPluginKey", () => $56eda2c97606ba36$export$32db9543f41e636c);

var $3lIcL = parcelRequire("3lIcL");
const $56eda2c97606ba36$export$32db9543f41e636c = new (0, $3lIcL.PluginKey)('aiExperienceDecoration');

});

parcelRegister("9HEjT", function(module, exports) {

$parcel$export(module.exports, "reducer", () => $14dd89f4a32b111a$export$1650419e431d3ba3);

var $b7EWj = parcelRequire("b7EWj");
function $14dd89f4a32b111a$export$1650419e431d3ba3(state, action) {
    switch(action.type){
        case 'END_EXPERIENCE':
            // When the experience ends the plugin state needs to reset everything back to the initial plugin state
            return {
                modalDecorationSet: (0, $b7EWj.DecorationSet).empty,
                dispatchAnalyticsEvent: state.dispatchAnalyticsEvent,
                initialPositions: undefined,
                ...action.data
            };
        case 'SHOW_MODAL':
            return {
                ...state,
                ...action.data
            };
        case 'UPDATE_MODAL_DECORATION_SET':
            return {
                ...state,
                modalDecorationSet: action.data.modalDecorationSet
            };
        default:
            return state;
    }
}

});

parcelRegister("3Y9NC", function(module, exports) {

$parcel$export(module.exports, "hasGeneratedContentDecorations", () => $35be45dc0ca563ad$export$4306d8811b2d2e31);
const $35be45dc0ca563ad$export$4306d8811b2d2e31 = (state)=>state.modalDecorationSet.find(undefined, undefined, (spec)=>spec.key === 'generatedInlineDecoration' || spec.key === 'generatedNodeDecoration' || spec.key === 'generatedStartWidget' || spec.key === 'generatedEndWidget').length > 0;

});







parcelRegister("j0e54", function(module, exports) {

$parcel$export(module.exports, "changeToneToNeutralWithOptions", () => $b7ff62136108312c$export$13defcd58be14c80);
$parcel$export(module.exports, "changeToneToProfessionalWithOptions", () => $b7ff62136108312c$export$12bb87036588b312);
$parcel$export(module.exports, "changeToneToCasualWithOptions", () => $b7ff62136108312c$export$124661226d751077);
$parcel$export(module.exports, "changeToneToEducationalWithOptions", () => $b7ff62136108312c$export$bc06489e9b94a1b8);
$parcel$export(module.exports, "changeToneToEmpatheticWithOptions", () => $b7ff62136108312c$export$6c0e9fb8d5e538d3);

var $eJOHy = parcelRequire("eJOHy");

var $izZqh = parcelRequire("izZqh");

var $39Wx8 = parcelRequire("39Wx8");

var $cab8f = parcelRequire("cab8f");

var $7lQJd = parcelRequire("7lQJd");

var $hmtiR = parcelRequire("hmtiR");

var $z2YLc = parcelRequire("z2YLc");

var $9KRmu = parcelRequire("9KRmu");

var $lxVNh = parcelRequire("lxVNh");

var $inU6j = parcelRequire("inU6j");
function $b7ff62136108312c$var$createChangeToneOption({ key: key, title: title, description: description, intentSchemaId: intentSchemaId, featureId: featureId, icon: icon, shortTitle: shortTitle }) {
    return {
        key: key,
        title: title,
        description: description,
        icon: icon,
        showInRefineDropdown: true,
        intentSchemaId: intentSchemaId,
        featureId: featureId,
        nestingConfig: {
            id: 'change-tone-to',
            parentTestId: 'change-tone-to',
            parentTitle: (0, $izZqh.aiConfigItemMessages).changeToneNestingParentTitlePostGA,
            shortTitle: shortTitle,
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($39Wx8))), {
                    label: "",
                    spacing: "spacious"
                })
        },
        actions: {
            empty: [
                (0, $lxVNh.createInsertBelow)({
                    appearance: 'secondary'
                }),
                (0, $lxVNh.createReplace)({
                    appearance: 'primary'
                })
            ],
            selection: [
                (0, $lxVNh.createInsertBelow)({
                    appearance: 'secondary'
                }),
                (0, $lxVNh.createReplace)({
                    appearance: 'primary'
                })
            ]
        },
        getBackendModel: ()=>{
            return 'assistance-service';
        }
    };
}
const $b7ff62136108312c$export$6f5f338379adfef = $b7ff62136108312c$var$createChangeToneOption({
    key: (0, $inU6j.CONFIG_ITEM_KEYS).CHANGE_TONE_TO_NEUTRAL,
    title: (0, $izZqh.aiConfigItemMessages).changeToneNeutralToneTitle,
    shortTitle: (0, $izZqh.aiConfigItemMessages).changeToneNeutralToneShortTitle,
    description: (0, $izZqh.aiConfigItemMessages).changeToneNeutralToneDescription,
    intentSchemaId: 'change_tone_neutral_intent_schema.json',
    featureId: 'change_tone_neutral',
    icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $z2YLc.ToneNeutralIcon), null)
});
const $b7ff62136108312c$export$13defcd58be14c80 = {
    config: $b7ff62136108312c$export$6f5f338379adfef,
    triggers: {
        empty: {
            enabled: true,
            docMinSize: 1
        },
        selection: {
            enabled: true
        }
    }
};
const $b7ff62136108312c$export$9db9bd2fafdb3554 = $b7ff62136108312c$var$createChangeToneOption({
    key: (0, $inU6j.CONFIG_ITEM_KEYS).CHANGE_TONE_TO_PROFESSIONAL,
    title: (0, $izZqh.aiConfigItemMessages).changeToneProfessionalToneTitle,
    shortTitle: (0, $izZqh.aiConfigItemMessages).changeToneProfessionalToneShortTitle,
    description: (0, $izZqh.aiConfigItemMessages).changeToneProfessionalToneDescription,
    intentSchemaId: 'change_tone_professional_intent_schema.json',
    featureId: 'change_tone_professional',
    icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9KRmu.ToneProfessionalIcon), null)
});
const $b7ff62136108312c$export$12bb87036588b312 = {
    config: $b7ff62136108312c$export$9db9bd2fafdb3554,
    triggers: {
        empty: {
            enabled: true,
            docMinSize: 1
        },
        selection: {
            enabled: true
        }
    }
};
const $b7ff62136108312c$export$86a519e0af50dd89 = $b7ff62136108312c$var$createChangeToneOption({
    key: (0, $inU6j.CONFIG_ITEM_KEYS).CHANGE_TONE_TO_CASUAL,
    title: (0, $izZqh.aiConfigItemMessages).changeToneCasualToneTitle,
    shortTitle: (0, $izZqh.aiConfigItemMessages).changeToneCasualToneShortTitle,
    description: (0, $izZqh.aiConfigItemMessages).changeToneCasualToneDescription,
    intentSchemaId: 'change_tone_business_casual_intent_schema.json',
    featureId: 'change_tone_casual',
    icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cab8f.ToneCasualIcon), null)
});
const $b7ff62136108312c$export$124661226d751077 = {
    config: $b7ff62136108312c$export$86a519e0af50dd89,
    triggers: {
        empty: {
            enabled: true,
            docMinSize: 1
        },
        selection: {
            enabled: true
        }
    }
};
const $b7ff62136108312c$export$693b6bda4adcfa2a = $b7ff62136108312c$var$createChangeToneOption({
    key: (0, $inU6j.CONFIG_ITEM_KEYS).CHANGE_TONE_TO_EDUCATIONAL,
    title: (0, $izZqh.aiConfigItemMessages).changeToneEducationalToneTitle,
    shortTitle: (0, $izZqh.aiConfigItemMessages).changeToneEducationalToneShortTitle,
    description: (0, $izZqh.aiConfigItemMessages).changeToneEducationalToneDescription,
    intentSchemaId: 'change_tone_educational_intent_schema.json',
    featureId: 'change_tone_educational',
    icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7lQJd.ToneEducationalIcon), null)
});
const $b7ff62136108312c$export$bc06489e9b94a1b8 = {
    config: $b7ff62136108312c$export$693b6bda4adcfa2a,
    triggers: {
        empty: {
            enabled: true,
            docMinSize: 1
        },
        selection: {
            enabled: true
        }
    }
};
const $b7ff62136108312c$export$a20a30955e450d41 = $b7ff62136108312c$var$createChangeToneOption({
    key: (0, $inU6j.CONFIG_ITEM_KEYS).CHANGE_TONE_TO_EMPATHETIC,
    title: (0, $izZqh.aiConfigItemMessages).changeToneEmpatheticToneTitle,
    shortTitle: (0, $izZqh.aiConfigItemMessages).changeToneEmpatheticToneShortTitle,
    description: (0, $izZqh.aiConfigItemMessages).changeToneEmpatheticToneDescription,
    intentSchemaId: 'change_tone_empathetic_intent_schema.json',
    featureId: 'change_tone_empathetic',
    icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hmtiR.ToneEmpatheticIcon), null)
});
const $b7ff62136108312c$export$6c0e9fb8d5e538d3 = {
    config: $b7ff62136108312c$export$a20a30955e450d41,
    triggers: {
        empty: {
            enabled: true,
            docMinSize: 1
        },
        selection: {
            enabled: true
        }
    }
};

});
parcelRegister("39Wx8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7122854feb0d3dc40d41eb59fb3bbcf1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $24cf9de135af4937$var$_react = $24cf9de135af4937$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $24cf9de135af4937$var$_baseNew = $24cf9de135af4937$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $24cf9de135af4937$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Microphone".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: record sounds in Trello.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $24cf9de135af4937$var$MicrophoneIcon = (props)=>/*#__PURE__*/ $24cf9de135af4937$var$_react.default.createElement($24cf9de135af4937$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A1.5 1.5 0 0 0 6.5 3v4a1.5 1.5 0 1 0 3 0V3A1.5 1.5 0 0 0 8 1.5M5 3a3 3 0 0 1 6 0v4a3 3 0 0 1-6 0zM3.5 7a4.5 4.5 0 0 0 9 0H14c0 3.06-2.29 5.585-5.25 5.954V14.5H12V16H4v-1.5h3.25v-1.546A6 6 0 0 1 2 7z" clip-rule="evenodd"/>`
    }, props));
$24cf9de135af4937$var$MicrophoneIcon.displayName = 'MicrophoneIcon';
var $24cf9de135af4937$var$_default = module.exports.default = $24cf9de135af4937$var$MicrophoneIcon;

});

parcelRegister("cab8f", function(module, exports) {

$parcel$export(module.exports, "ToneCasualIcon", () => $59cd81f13a2dd92f$export$8b4784439604ca83);

var $eJOHy = parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");

var $1BjZZ = parcelRequire("1BjZZ");
const $59cd81f13a2dd92f$var$IconGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: "presentation",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("g", {
        clipPath: "url(#clip0_11_3586)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 21C10.8181 21 9.64778 20.7672 8.55585 20.3149C7.46392 19.8626 6.47177 19.1997 5.63604 18.364C4.80031 17.5282 4.13738 16.5361 3.68508 15.4442C3.23279 14.3522 3 13.1819 3 12C3 10.8181 3.23279 9.64778 3.68508 8.55585C4.13738 7.46392 4.80031 6.47177 5.63604 5.63604C6.47177 4.80031 7.46392 4.13738 8.55585 3.68508C9.64778 3.23279 10.8181 3 12 3C14.3869 3 16.6761 3.94821 18.364 5.63604C20.0518 7.32387 21 9.61305 21 12C21 14.3869 20.0518 16.6761 18.364 18.364C16.6761 20.0518 14.3869 21 12 21ZM12 19C13.3843 18.9996 14.7375 18.5889 15.8884 17.8196C17.0393 17.0504 17.9364 15.9572 18.4661 14.6782C18.9959 13.3993 19.1346 11.992 18.8648 10.6342C18.5949 9.27645 17.9286 8.02916 16.95 7.05C16.136 6.23608 15.1338 5.63546 14.0323 5.30135C12.9307 4.96723 11.7637 4.90994 10.6347 5.13453C9.50574 5.35913 8.44955 5.85868 7.55973 6.58895C6.6699 7.31922 5.9739 8.25766 5.53338 9.32115C5.09285 10.3846 4.92139 11.5404 5.03419 12.6859C5.14699 13.8315 5.54057 14.9316 6.18006 15.8888C6.81955 16.8459 7.68521 17.6306 8.70038 18.1733C9.71554 18.716 10.8489 18.9999 12 19ZM8.05 14.197C7.883 13.72 8.152 13.206 8.651 13.047C9.151 12.888 9.69 13.146 9.856 13.622C9.916 13.796 10.081 14.109 10.351 14.418C10.777 14.906 11.307 15.182 12 15.182C12.693 15.182 13.223 14.906 13.65 14.418C13.92 14.108 14.083 13.796 14.144 13.622C14.31 13.146 14.85 12.888 15.349 13.047C15.848 13.206 16.117 13.72 15.951 14.197C15.76 14.707 15.475 15.177 15.112 15.582C14.348 16.458 13.306 17 12 17C10.694 17 9.652 16.458 8.888 15.582C8.5247 15.1765 8.24017 14.7068 8.049 14.197H8.05ZM9.5 11C9.10218 11 8.72064 10.842 8.43934 10.5607C8.15804 10.2794 8 9.89782 8 9.5C8 9.10218 8.15804 8.72064 8.43934 8.43934C8.72064 8.15804 9.10218 8 9.5 8C9.89782 8 10.2794 8.15804 10.5607 8.43934C10.842 8.72064 11 9.10218 11 9.5C11 9.89782 10.842 10.2794 10.5607 10.5607C10.2794 10.842 9.89782 11 9.5 11ZM14.5 11C14.1022 11 13.7206 10.842 13.4393 10.5607C13.158 10.2794 13 9.89782 13 9.5C13 9.10218 13.158 8.72064 13.4393 8.43934C13.7206 8.15804 14.1022 8 14.5 8C14.8978 8 15.2794 8.15804 15.5607 8.43934C15.842 8.72064 16 9.10218 16 9.5C16 9.89782 15.842 10.2794 15.5607 10.5607C15.2794 10.842 14.8978 11 14.5 11Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M5.503 8.957C5.503 8.55917 5.66103 8.17764 5.94234 7.89634C6.22364 7.61503 6.60517 7.457 7.003 7.457H9.826C10.0367 7.45714 10.2451 7.50168 10.4374 7.58772C10.6298 7.67377 10.8019 7.79938 10.9425 7.95637C11.083 8.11337 11.189 8.29822 11.2533 8.49888C11.3177 8.69955 11.339 8.91153 11.316 9.121L11.147 10.664C11.1066 11.0312 10.9321 11.3706 10.657 11.6171C10.3819 11.8637 10.0254 12 9.656 12H7.003C6.60517 12 6.22364 11.842 5.94234 11.5607C5.66103 11.2794 5.503 10.8978 5.503 10.5V8.957ZM12.678 9.013C12.6556 8.80375 12.6774 8.59213 12.7421 8.39188C12.8068 8.19163 12.9129 8.00723 13.0535 7.85066C13.1941 7.6941 13.3661 7.56888 13.5583 7.48314C13.7505 7.3974 13.9586 7.35306 14.169 7.353H16.979C17.3768 7.353 17.7584 7.51103 18.0397 7.79234C18.321 8.07364 18.479 8.45517 18.479 8.853V10.5C18.479 10.8978 18.321 11.2794 18.0397 11.5607C17.7584 11.842 17.3768 12 16.979 12H14.346C13.976 11.9999 13.619 11.863 13.3438 11.6156C13.0686 11.3683 12.8945 11.0279 12.855 10.66L12.678 9.013Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M10.5 8H13.5V9.5H10.5V8Z",
        fill: "currentColor"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("clipPath", {
        id: "clip0_11_3586"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("rect", {
        width: "24",
        height: "24",
        fill: "currentColor"
    }))));
const $59cd81f13a2dd92f$export$8b4784439604ca83 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1BjZZ))), {
        color: "currentColor",
        label: "",
        spacing: "spacious",
        // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        LEGACY_fallbackIcon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
                glyph: $59cd81f13a2dd92f$var$IconGlyph,
                ...props
            })
    });

});
parcelRegister("1BjZZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b3744a0898e07a67d450ee84c82a52a0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $12a8c2825c7e4ab5$var$_react = $12a8c2825c7e4ab5$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $12a8c2825c7e4ab5$var$_baseNew = $12a8c2825c7e4ab5$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $12a8c2825c7e4ab5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "EmojiCasual".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing a casual or relaxed tone or sentiment.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $12a8c2825c7e4ab5$var$EmojiCasualIcon = (props)=>/*#__PURE__*/ $12a8c2825c7e4ab5$var$_react.default.createElement($12a8c2825c7e4ab5$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m1.776 6.119.279 1.3A2 2 0 0 0 4.01 9h1.054a2.625 2.625 0 0 0 2.61-2.345L7.8 5.5h.4l.124 1.155A2.625 2.625 0 0 0 10.935 9h1.054a2 2 0 0 0 1.956-1.58l.279-1.301a6.5 6.5 0 1 1-12.448 0M13.124 4A6.49 6.49 0 0 0 8 1.5c-2.08 0-3.934.977-5.124 2.5zm-.302 1.5H9.71l.106.995A1.125 1.125 0 0 0 10.935 7.5h1.054a.5.5 0 0 0 .49-.395zm-6.532 0H3.178l.344 1.605a.5.5 0 0 0 .489.395h1.054c.575 0 1.058-.433 1.119-1.005zM.847 4.413A8 8 0 0 1 8 0a8 8 0 1 1 0 16A8 8 0 0 1 .847 4.413m5.238 6.12c.486.378 1.14.717 1.915.717s1.43-.34 1.915-.717a4.4 4.4 0 0 0 .69-.675l.031-.04.005-.006-.001.002.61.436.61.436-.001.002-.002.003-.006.007-.016.023-.056.071q-.07.091-.2.235c-.17.189-.42.439-.744.69-.64.497-1.61 1.033-2.835 1.033s-2.196-.536-2.835-1.033a6 6 0 0 1-.944-.925l-.056-.071-.016-.023-.006-.007-.002-.003v-.001s-.001-.001.609-.437l.61-.436-.001-.002.005.007.03.04q.045.056.139.161c.126.14.313.327.552.513m4.556-.721" clip-rule="evenodd"/>`
    }, props));
$12a8c2825c7e4ab5$var$EmojiCasualIcon.displayName = 'EmojiCasualIcon';
var $12a8c2825c7e4ab5$var$_default = module.exports.default = $12a8c2825c7e4ab5$var$EmojiCasualIcon;

});


parcelRegister("7lQJd", function(module, exports) {

$parcel$export(module.exports, "ToneEducationalIcon", () => $661ea9ee149de50d$export$61c3f03f8b900938);

var $eJOHy = parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");

var $hDcr6 = parcelRequire("hDcr6");
const $661ea9ee149de50d$var$IconGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: "presentation",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M18.636 15H7C6.46957 15 5.96086 15.2107 5.58579 15.5858C5.21071 15.9609 5 16.4696 5 17C5 17.5304 5.21071 18.0391 5.58579 18.4142C5.96086 18.7893 6.46957 19 7 19H19",
        stroke: "currentColor",
        strokeWidth: "2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M19 15V5H7C6.46957 5 5.96086 5.21071 5.58579 5.58579C5.21071 5.96086 5 6.46957 5 7V17",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M19 19C18.4696 19 17.9609 18.7893 17.5858 18.4142C17.2107 18.0391 17 17.5304 17 17C17 16.4696 17.2107 15.9609 17.5858 15.5858C17.9609 15.2107 18.4696 15 19 15",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round"
    }));
const $661ea9ee149de50d$export$61c3f03f8b900938 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hDcr6))), {
        label: "",
        color: "currentColor",
        spacing: "spacious",
        // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        LEGACY_fallbackIcon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
                glyph: $661ea9ee149de50d$var$IconGlyph,
                ...props
            }),
        LEGACY_secondaryColor: "none"
    });

});
parcelRegister("hDcr6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2f078cf7ed8db2e1f9409b35a601c2b9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cd5fb9bdc9f0e58b$var$_react = $cd5fb9bdc9f0e58b$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $cd5fb9bdc9f0e58b$var$_baseNew = $cd5fb9bdc9f0e58b$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $cd5fb9bdc9f0e58b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Glasses".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Changing tone of written content to Educational with Atlassian Intelligence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cd5fb9bdc9f0e58b$var$GlassesIcon = (props)=>/*#__PURE__*/ $cd5fb9bdc9f0e58b$var$_react.default.createElement($cd5fb9bdc9f0e58b$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m4.81 2.433-1.804.82c-.353.16-.599.491-.65.875l-.433 3.246A3.5 3.5 0 0 1 3.5 7c1.184 0 2.23.587 2.863 1.486A3 3 0 0 1 8 8c.604 0 1.167.179 1.637.486A3.5 3.5 0 0 1 12.5 7c.567 0 1.103.135 1.577.374l-.433-3.246a1.13 1.13 0 0 0-.65-.875l-1.804-.82.62-1.366 1.805.82A2.63 2.63 0 0 1 15.13 3.93l.76 5.697A3.505 3.505 0 0 1 12.5 14a3.5 3.5 0 0 1-3.453-4.074A1.5 1.5 0 0 0 8 9.5a1.5 1.5 0 0 0-1.047.426q.046.281.047.574a3.5 3.5 0 1 1-6.89-.873L.87 3.93a2.63 2.63 0 0 1 1.515-2.043l1.805-.82zM1.5 10.546a2 2 0 1 0 .083-.618zm12.917-.618.082.618a2 2 0 1 1-.082-.618" clip-rule="evenodd"/>`
    }, props));
$cd5fb9bdc9f0e58b$var$GlassesIcon.displayName = 'GlassesIcon';
var $cd5fb9bdc9f0e58b$var$_default = module.exports.default = $cd5fb9bdc9f0e58b$var$GlassesIcon;

});


parcelRegister("hmtiR", function(module, exports) {

$parcel$export(module.exports, "ToneEmpatheticIcon", () => $54a15cd1cf19fab8$export$e378d926184098e);

var $eJOHy = parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");

var $6psOp = parcelRequire("6psOp");
const $54a15cd1cf19fab8$var$IconGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        role: "presentation",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M11.121 5.385L11.278 5.535L11.985 6.242L12.692 5.536C13.6168 4.61388 14.8658 4.09021 16.1717 4.07699C17.4777 4.06378 18.7369 4.56205 19.6803 5.46527C20.6236 6.36848 21.1761 7.60494 21.2195 8.91022C21.263 10.2155 20.7941 11.486 19.913 12.45L19.763 12.607L18.352 14.018L12.71 19.704C12.5359 19.8796 12.3028 19.9845 12.0559 19.9983C11.809 20.0122 11.5657 19.934 11.373 19.779L11.292 19.706L5.62 14.02L4.207 12.607C3.27965 11.6833 2.75151 10.4327 2.73597 9.12391C2.72044 7.81509 3.21875 6.55236 4.12391 5.60688C5.02907 4.6614 6.26889 4.10856 7.57714 4.06707C8.8854 4.02559 10.1578 4.49877 11.121 5.385ZM18.349 11.192C18.8975 10.6395 19.2097 9.89545 19.2197 9.11701C19.2297 8.33857 18.9367 7.58673 18.4026 7.02032C17.8686 6.45391 17.1352 6.1173 16.3575 6.0816C15.5798 6.0459 14.8187 6.31391 14.235 6.829L14.107 6.949L12.692 8.364C12.5592 8.49619 12.3921 8.58855 12.2095 8.63062C12.0269 8.67268 11.8362 8.66277 11.659 8.602C11.5158 8.55271 11.3858 8.47129 11.279 8.364L9.863 6.95C9.31051 6.40153 8.56645 6.08931 7.78801 6.0793C7.00958 6.0693 6.25773 6.36228 5.69132 6.89637C5.12492 7.43045 4.7883 8.1638 4.7526 8.94148C4.7169 9.71916 4.98491 10.4803 5.5 11.064L5.621 11.192L7.036 12.607L11.998 17.582L16.932 12.609L18.349 11.192Z"
    }));
const $54a15cd1cf19fab8$export$e378d926184098e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6psOp))), {
        label: "",
        color: "currentColor",
        spacing: "spacious",
        // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        LEGACY_fallbackIcon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
                glyph: $54a15cd1cf19fab8$var$IconGlyph,
                ...props
            }),
        LEGACY_secondaryColor: "var(--ds-icon, #44546F)"
    });

});
parcelRegister("6psOp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c1393486c01906de1ea3b52391dc4070>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4aab6d5efcea1f01$var$_react = $4aab6d5efcea1f01$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $4aab6d5efcea1f01$var$_baseNew = $4aab6d5efcea1f01$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $4aab6d5efcea1f01$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Heart".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: emoji symbols in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4aab6d5efcea1f01$var$HeartIcon = (props)=>/*#__PURE__*/ $4aab6d5efcea1f01$var$_react.default.createElement($4aab6d5efcea1f01$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.036 2.75a2.86 2.86 0 0 0-2.144.913 3.3 3.3 0 0 0-.656 1.064A3.9 3.9 0 0 0 2 6.112c0 .83.216 1.666.672 2.518.468.862 1.14 1.722 2.033 2.577q1.344 1.283 3.206 2.475a1 1 0 0 0 .09.047 1 1 0 0 0 .095-.047q1.862-1.193 3.199-2.474c.893-.856 1.563-1.716 2.026-2.578.46-.852.679-1.688.679-2.517 0-.522-.084-.98-.241-1.382l-.003-.007a3.2 3.2 0 0 0-.648-1.06l-.003-.003a2.8 2.8 0 0 0-.95-.672l-.002-.001a2.9 2.9 0 0 0-1.19-.237c-.525 0-.958.133-1.326.382l-.004.002a3 3 0 0 0-.975 1.085l-.66 1.205-.657-1.207a3 3 0 0 0-.971-1.085c-.367-.249-.802-.382-1.334-.382M3.248 1.612a4.4 4.4 0 0 1 1.788-.362c.801 0 1.535.207 2.174.64q.439.296.791.682.356-.388.797-.684c.638-.43 1.37-.638 2.166-.638.63 0 1.229.118 1.787.362q.836.361 1.454 1.028c.414.442.73.962.953 1.549a5.3 5.3 0 0 1 .342 1.923c0 1.105-.294 2.184-.858 3.23-.552 1.025-1.327 2.007-2.31 2.949Q10.87 13.69 8.9 14.948l-.006.004a2 2 0 0 1-.362.18A1.3 1.3 0 0 1 8 15.25c-.205 0-.389-.058-.532-.118a2.3 2.3 0 0 1-.355-.18l-.006-.004q-1.97-1.258-3.438-2.656l-.001-.001c-.983-.941-1.76-1.923-2.316-2.948l-.002-.004C.79 8.294.5 7.216.5 6.112c0-.683.108-1.326.335-1.921l.001-.004a4.8 4.8 0 0 1 .961-1.55 4.4 4.4 0 0 1 1.45-1.025" clip-rule="evenodd"/>`
    }, props));
$4aab6d5efcea1f01$var$HeartIcon.displayName = 'HeartIcon';
var $4aab6d5efcea1f01$var$_default = module.exports.default = $4aab6d5efcea1f01$var$HeartIcon;

});


parcelRegister("z2YLc", function(module, exports) {

$parcel$export(module.exports, "ToneNeutralIcon", () => $3daa51d9115d66e2$export$53c14326c671fdf0);

var $eJOHy = parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");

var $ggW8r = parcelRequire("ggW8r");
const $3daa51d9115d66e2$var$IconGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: "presentation",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12Z",
        stroke: "currentColor",
        strokeWidth: "2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M11 9.5C11 8.67157 10.3284 8 9.5 8C8.67157 8 8 8.67157 8 9.5C8 10.3284 8.67157 11 9.5 11C10.3284 11 11 10.3284 11 9.5Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M16 9.5C16 8.67157 15.3284 8 14.5 8C13.6716 8 13 8.67157 13 9.5C13 10.3284 13.6716 11 14.5 11C15.3284 11 16 10.3284 16 9.5Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M15 13.5H9C8.44772 13.5 8 13.9477 8 14.5C8 15.0523 8.44772 15.5 9 15.5H15C15.5523 15.5 16 15.0523 16 14.5C16 13.9477 15.5523 13.5 15 13.5Z",
        fill: "currentColor"
    }));
const $3daa51d9115d66e2$export$53c14326c671fdf0 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ggW8r))), {
        color: "currentColor",
        label: "",
        spacing: "spacious",
        // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        LEGACY_fallbackIcon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
                glyph: $3daa51d9115d66e2$var$IconGlyph,
                ...props
            })
    });

});
parcelRegister("ggW8r", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ccaa4ed6916e7a1d68590f7443a48f02>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bd8b3c68e3c0c4a1$var$_react = $bd8b3c68e3c0c4a1$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $bd8b3c68e3c0c4a1$var$_baseNew = $bd8b3c68e3c0c4a1$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $bd8b3c68e3c0c4a1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "EmojiNeutral".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing a neutral tone or sentiment.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bd8b3c68e3c0c4a1$var$EmojiNeutralIcon = (props)=>/*#__PURE__*/ $bd8b3c68e3c0c4a1$var$_react.default.createElement($bd8b3c68e3c0c4a1$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m4.5-1.75a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m4.5 0a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m2.25 3.25V11h-6.5V9.5z" clip-rule="evenodd"/>`
    }, props));
$bd8b3c68e3c0c4a1$var$EmojiNeutralIcon.displayName = 'EmojiNeutralIcon';
var $bd8b3c68e3c0c4a1$var$_default = module.exports.default = $bd8b3c68e3c0c4a1$var$EmojiNeutralIcon;

});


parcelRegister("9KRmu", function(module, exports) {

$parcel$export(module.exports, "ToneProfessionalIcon", () => $831f8757dd121660$export$d11b06b5c6e28f63);

var $eJOHy = parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");

var $jUPb8 = parcelRequire("jUPb8");
const $831f8757dd121660$var$IconGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        role: "presentation",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M6 20C5.49542 20.0002 5.00943 19.8096 4.63945 19.4665C4.26947 19.1234 4.04284 18.6532 4.005 18.15L4 18V10C3.99984 9.49542 4.19041 9.00943 4.5335 8.63945C4.87659 8.26947 5.34684 8.04284 5.85 8.005L6 8H8V6C7.99984 5.49542 8.19041 5.00943 8.5335 4.63945C8.87659 4.26947 9.34685 4.04284 9.85 4.005L10 4H14C14.5046 3.99984 14.9906 4.19041 15.3605 4.5335C15.7305 4.87659 15.9572 5.34684 15.995 5.85L16 6V8H18C18.5044 8.00009 18.9901 8.19077 19.3599 8.53384C19.7297 8.8769 19.9562 9.34702 19.994 9.85L20 10V18C19.9999 18.5044 19.8092 18.9901 19.4662 19.3599C19.1231 19.7297 18.653 19.9562 18.15 19.994L18 20H6ZM8 10H6V18H7.999L8 10ZM14 10H10L9.999 18H14V10ZM18 10H16V18H18V10ZM14 6H10V8H14V6Z"
    }));
const $831f8757dd121660$export$d11b06b5c6e28f63 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jUPb8))), {
        label: "",
        color: "currentColor",
        spacing: "spacious",
        // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        LEGACY_fallbackIcon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
                glyph: $831f8757dd121660$var$IconGlyph,
                ...props
            }),
        LEGACY_secondaryColor: "var(--ds-icon, #44546F)"
    });

});
parcelRegister("jUPb8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e2b10cb2fb36d0ad7bfa02e0b0408651>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e7faf24c55cf874a$var$_react = $e7faf24c55cf874a$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $e7faf24c55cf874a$var$_baseNew = $e7faf24c55cf874a$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $e7faf24c55cf874a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Briefcase".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: Job title in Atlas, Operations in JSM.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e7faf24c55cf874a$var$BriefcaseIcon = (props)=>/*#__PURE__*/ $e7faf24c55cf874a$var$_react.default.createElement($e7faf24c55cf874a$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 2.5a.5.5 0 0 0-.5.5v1h5V3a.5.5 0 0 0-.5-.5zM12 4V3a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v1H3a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM3 5.5a.5.5 0 0 0-.5.5v2h11V6a.5.5 0 0 0-.5-.5zm10.5 4H8.75V11h-1.5V9.5H2.5V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5z" clip-rule="evenodd"/>`
    }, props));
$e7faf24c55cf874a$var$BriefcaseIcon.displayName = 'BriefcaseIcon';
var $e7faf24c55cf874a$var$_default = module.exports.default = $e7faf24c55cf874a$var$BriefcaseIcon;

});



parcelRegister("4JeDV", function(module, exports) {

$parcel$export(module.exports, "createDraftReplyWithOptions", () => $d04e141ed498d804$export$a01b8dc4d6dfd2c6);

var $eJOHy = parcelRequire("eJOHy");

var $izZqh = parcelRequire("izZqh");

var $eGOwo = parcelRequire("eGOwo");

var $3GBY8 = parcelRequire("3GBY8");

var $lxVNh = parcelRequire("lxVNh");

var $inU6j = parcelRequire("inU6j");
const $d04e141ed498d804$export$e9e009236e196c6e = (issueId)=>({
        key: (0, $inU6j.CONFIG_ITEM_KEYS).SUGGEST_REPONSE,
        title: (0, $izZqh.aiConfigItemMessages).draftReplyTitle,
        description: (0, $izZqh.aiConfigItemMessages).draftReplyDescription,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3GBY8.BrainstormIcon), null),
        endpoint: `/gateway/api/firebolt/1/agent-response/issues/${issueId}/stream`,
        intentSchemaId: 'brainstorm_intent_schema.json',
        featureId: 'brainstorm',
        alwaysNoDocAndSelection: true,
        actions: {
            empty: [
                (0, $lxVNh.createInsertAtCurrentPosition)({
                    appearance: 'primary'
                })
            ],
            selection: [
                (0, $lxVNh.createInsertAtCurrentPosition)({
                    appearance: 'primary'
                })
            ]
        },
        getBackendModel: ()=>{
            return 'assistance-service';
        },
        statusLozengeType: (0, $eGOwo.fg)('platform_remove_jsm_beta_tags') ? undefined : 'beta'
    });
const $d04e141ed498d804$export$a01b8dc4d6dfd2c6 = (issueId)=>({
        config: $d04e141ed498d804$export$e9e009236e196c6e(issueId),
        triggers: {
            empty: {
                enabled: true,
                docMinSize: 0
            },
            selection: {
                enabled: false
            }
        }
    });

});

parcelRegister("bCJJn", function(module, exports) {

$parcel$export(module.exports, "improveWriting", () => $d53366ba382acc8e$export$144a75c8acc1ab6b);
$parcel$export(module.exports, "improveWritingWithOptions", () => $d53366ba382acc8e$export$d332380ea195650);
$parcel$export(module.exports, "fixSpellingAndGrammarWithOptions", () => $d53366ba382acc8e$export$76de7c1ccbf13f30);

var $eJOHy = parcelRequire("eJOHy");

var $izZqh = parcelRequire("izZqh");

var $4w3GG = parcelRequire("4w3GG");

var $btRs9 = parcelRequire("btRs9");

var $lxVNh = parcelRequire("lxVNh");

var $inU6j = parcelRequire("inU6j");
const $d53366ba382acc8e$export$144a75c8acc1ab6b = {
    key: (0, $inU6j.CONFIG_ITEM_KEYS).IMPROVE_WRITING,
    title: (0, $izZqh.aiConfigItemMessages).improveWritingTitle,
    description: (0, $izZqh.aiConfigItemMessages).improveWritingDescription,
    icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $btRs9.ImproveWritingIcon), null),
    intentSchemaId: 'improve_quality_intent_schema.json',
    featureId: 'improve_writing',
    actions: {
        empty: [
            (0, $lxVNh.createInsertBelow)({
                appearance: 'secondary'
            }),
            (0, $lxVNh.createReplace)({
                appearance: 'primary'
            })
        ],
        selection: [
            (0, $lxVNh.createInsertBelow)({
                appearance: 'secondary'
            }),
            (0, $lxVNh.createReplace)({
                appearance: 'primary'
            })
        ]
    },
    getBackendModel: ()=>{
        return 'assistance-service';
    },
    canToggleDiffPreview: true
};
const $d53366ba382acc8e$export$d332380ea195650 = {
    config: $d53366ba382acc8e$export$144a75c8acc1ab6b,
    triggers: {
        empty: {
            enabled: true,
            docMinSize: 1
        },
        selection: {
            enabled: true
        }
    }
};
const $d53366ba382acc8e$export$1319dbd4bdd28dd9 = {
    config: $d53366ba382acc8e$export$144a75c8acc1ab6b,
    triggers: {
        empty: {
            enabled: false
        },
        selection: {
            enabled: true
        }
    }
};
const $d53366ba382acc8e$export$f6fbbd65001c33d0 = {
    key: (0, $inU6j.CONFIG_ITEM_KEYS).FIX_SPELLING_AND_GRAMMAR,
    title: (0, $izZqh.aiConfigItemMessages).fixSpellingGrammarTitle,
    description: (0, $izZqh.aiConfigItemMessages).fixSpellingGrammarDescription,
    icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4w3GG.FixSpellingIcon), null),
    intentSchemaId: 'grammar_spelling_intent_schema.json',
    featureId: 'fix_spelling_grammar',
    actions: {
        empty: [
            (0, $lxVNh.createReplace)({
                appearance: 'primary'
            })
        ],
        selection: [
            (0, $lxVNh.createReplace)({
                appearance: 'primary'
            })
        ]
    },
    getBackendModel: ()=>{
        return 'assistance-service';
    }
};
const $d53366ba382acc8e$export$76de7c1ccbf13f30 = {
    config: $d53366ba382acc8e$export$f6fbbd65001c33d0,
    triggers: {
        empty: {
            enabled: true,
            docMinSize: 1
        },
        selection: {
            enabled: true
        }
    }
};

});
parcelRegister("4w3GG", function(module, exports) {

$parcel$export(module.exports, "FixSpellingIcon", () => $45f0f1416cd891d6$export$34a519f008c9006c);

var $eJOHy = parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");

var $3zF1S = parcelRequire("3zF1S");
const $45f0f1416cd891d6$var$IconGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M12 4C12.676 4 13.284 4.399 13.556 5.008L13.609 5.142L16.944 14.67C17.0283 14.9108 17.0173 15.1748 16.9134 15.4078C16.8094 15.6408 16.6203 15.8252 16.3848 15.9234C16.1493 16.0215 15.8851 16.0259 15.6465 15.9357C15.4078 15.8455 15.2127 15.6674 15.101 15.438L15.056 15.33L14.232 12.973L14.117 12.993L14 13H10C9.92255 12.9999 9.84536 12.9909 9.77 12.973L8.944 15.33C8.86313 15.5614 8.70011 15.755 8.4859 15.8741C8.27169 15.9932 8.0212 16.0294 7.782 15.976L7.67 15.944C7.43863 15.8631 7.24502 15.7001 7.12593 15.4859C7.00684 15.2717 6.97057 15.0212 7.024 14.782L7.056 14.67L10.391 5.142C10.5078 4.80818 10.7255 4.51893 11.0139 4.31432C11.3024 4.10971 11.6473 3.99987 12.001 4H12ZM12 6.598L10.46 11H13.542L12.002 6.598H12Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M14 17L16 19L20 15",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }));
const $45f0f1416cd891d6$export$34a519f008c9006c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3zF1S))), {
        label: "",
        color: "currentColor",
        spacing: "spacious",
        // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        LEGACY_fallbackIcon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
                glyph: $45f0f1416cd891d6$var$IconGlyph,
                ...props
            })
    });

});
parcelRegister("3zF1S", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::312d12f517ad523b2b40c676e4ea46df>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $29a47788d45721d9$var$_react = $29a47788d45721d9$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $29a47788d45721d9$var$_baseNew = $29a47788d45721d9$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $29a47788d45721d9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextSpellcheck".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for spellchecking.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $29a47788d45721d9$var$TextSpellcheckIcon = (props)=>/*#__PURE__*/ $29a47788d45721d9$var$_react.default.createElement($29a47788d45721d9$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.67.494A.75.75 0 0 1 5.375 0h.75a.75.75 0 0 1 .705.494l3.625 10a.8.8 0 0 1 .045.256V11H9.06l-.015.006L9.043 11H9v-.118L7.955 8h-4.41L2.5 10.882V11h-.043l-.002.006L2.44 11H1v-.25a.8.8 0 0 1 .045-.256zM4.088 6.5h3.324L5.75 1.916z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="m13.928 9.265 1.144.97-4.667 5.5a.75.75 0 0 1-1.144 0l-2.333-2.75 1.144-.97 1.761 2.076z" clip-rule="evenodd"/>`
    }, props));
$29a47788d45721d9$var$TextSpellcheckIcon.displayName = 'TextSpellcheckIcon';
var $29a47788d45721d9$var$_default = module.exports.default = $29a47788d45721d9$var$TextSpellcheckIcon;

});


parcelRegister("btRs9", function(module, exports) {

$parcel$export(module.exports, "ImproveWritingIcon", () => $8ba90a5bad879489$export$1be00499caf729a1);

var $eJOHy = parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");

var $hnnug = parcelRequire("hnnug");
const $8ba90a5bad879489$var$IconGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        role: "presentation",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M8.45366 7.76225L6.37618 5.68477C6.16881 5.4774 5.8326 5.4774 5.62524 5.68477L5.62453 5.68548C5.41716 5.89284 5.41716 6.22906 5.62453 6.43642L7.70201 8.5139C7.90938 8.72127 8.24559 8.72127 8.45296 8.5139L8.45366 8.5132C8.66103 8.30583 8.66103 7.96962 8.45366 7.76225Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M17.6911 5.69892L15.5853 7.80468C15.3858 8.00424 15.3858 8.32779 15.5853 8.52735C15.7849 8.7269 16.1084 8.7269 16.308 8.52735L18.4138 6.42158C18.6133 6.22203 18.6133 5.89848 18.4138 5.69892C18.2142 5.49936 17.8907 5.49936 17.6911 5.69892Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M7.64164 15.6144L5.58538 17.6706C5.37215 17.8838 5.37215 18.2296 5.58538 18.4428L5.58608 18.4435C5.79931 18.6567 6.14502 18.6567 6.35824 18.4435L8.41451 16.3872C8.62774 16.174 8.62774 15.8283 8.41451 15.6151L8.4138 15.6144C8.20058 15.4011 7.85487 15.4011 7.64164 15.6144Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M6.5 11.5H3.5C3.22386 11.5 3 11.7239 3 12C3 12.2761 3.22386 12.5 3.5 12.5H6.5C6.77614 12.5 7 12.2761 7 12C7 11.7239 6.77614 11.5 6.5 11.5Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M20.5 11.5H17.5C17.2239 11.5 17 11.7239 17 12C17 12.2761 17.2239 12.5 17.5 12.5H20.5C20.7761 12.5 21 12.2761 21 12C21 11.7239 20.7761 11.5 20.5 11.5Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M12.5 6.5V3.5C12.5 3.22386 12.2761 3 12 3C11.7239 3 11.5 3.22386 11.5 3.5V6.5C11.5 6.77614 11.7239 7 12 7C12.2761 7 12.5 6.77614 12.5 6.5Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M12.5 20.5V17.5C12.5 17.2239 12.2761 17 12 17C11.7239 17 11.5 17.2239 11.5 17.5V20.5C11.5 20.7761 11.7239 21 12 21C12.2761 21 12.5 20.7761 12.5 20.5Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.62 12.913L11.854 11.146C11.7602 11.0521 11.633 10.9993 11.5004 10.9992C11.3677 10.9991 11.2404 11.0517 11.1465 11.1455C11.0526 11.2392 10.9998 11.3665 10.9997 11.4991C10.9996 11.6318 11.0522 11.7591 11.146 11.853L12.913 13.62L13.62 12.913ZM12.56 10.439C12.277 10.1659 11.898 10.0149 11.5047 10.0185C11.1114 10.0221 10.7353 10.18 10.4573 10.4582C10.1793 10.7365 10.0217 11.1128 10.0185 11.5061C10.0153 11.8994 10.1666 12.2782 10.44 12.561L17.51 19.631C17.6483 19.7743 17.8138 19.8887 17.9967 19.9674C18.1797 20.0461 18.3765 20.0875 18.5757 20.0894C18.7748 20.0912 18.9724 20.0533 19.1568 19.978C19.3411 19.9027 19.5087 19.7914 19.6496 19.6506C19.7905 19.5098 19.9019 19.3424 19.9774 19.1581C20.053 18.9738 20.091 18.7763 20.0894 18.5771C20.0877 18.3779 20.0464 18.1811 19.9679 17.998C19.8894 17.815 19.7752 17.6494 19.632 17.511L12.56 10.439Z"
    }));
const $8ba90a5bad879489$export$1be00499caf729a1 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hnnug))), {
        label: "",
        color: "currentColor",
        spacing: "spacious",
        // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        LEGACY_fallbackIcon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
                glyph: $8ba90a5bad879489$var$IconGlyph,
                ...props
            }),
        LEGACY_secondaryColor: "var(--ds-icon, #44546F)"
    });

});
parcelRegister("hnnug", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b57d69a7e6f53846886bde82f36883e5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ca66cdb6a42a606b$var$_react = $ca66cdb6a42a606b$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $ca66cdb6a42a606b$var$_baseNew = $ca66cdb6a42a606b$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $ca66cdb6a42a606b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "MagicWand".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ca66cdb6a42a606b$var$MagicWandIcon = (props)=>/*#__PURE__*/ $ca66cdb6a42a606b$var$_react.default.createElement($ca66cdb6a42a606b$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M9.027 3.911a1.376 1.376 0 0 1 1.841-.094l.105.094 1.116 1.116a1.376 1.376 0 0 1 0 1.946l-8.616 8.616a1.376 1.376 0 0 1-1.946 0L.411 14.473a1.376 1.376 0 0 1 0-1.946zM1.561 13.5l.939.94L7.938 9 7 8.061zm13.431-4.067-1.06 1.06-1.415-1.414 1.061-1.06zM8.061 7l.938.938L10.939 6l-.94-.94zM16 5v1.5h-2V5zM7.982 2.422l-1.06 1.06-1.414-1.414 1.06-1.06zm7.01-.354-1.414 1.414-1.06-1.06 1.414-1.414zM11 0v2H9.5V0z"/>`
    }, props));
$ca66cdb6a42a606b$var$MagicWandIcon.displayName = 'MagicWandIcon';
var $ca66cdb6a42a606b$var$_default = module.exports.default = $ca66cdb6a42a606b$var$MagicWandIcon;

});



parcelRegister("8vHCf", function(module, exports) {

$parcel$export(module.exports, "freeGenerate", () => $045b85e4fbe76c42$export$647e613dda1ecf45);

var $eJOHy = parcelRequire("eJOHy");

var $izZqh = parcelRequire("izZqh");

var $fOqNz = parcelRequire("fOqNz");

var $8mzmn = parcelRequire("8mzmn");

var $lxVNh = parcelRequire("lxVNh");

var $inU6j = parcelRequire("inU6j");
const $045b85e4fbe76c42$export$647e613dda1ecf45 = {
    key: (0, $inU6j.CONFIG_ITEM_KEYS).FREE_GENERATE,
    title: (0, $8mzmn.default).aiButtonTitle,
    description: (0, $8mzmn.default).aiUniversalLongCallToAction,
    promptHint: (0, $izZqh.aiConfigItemMessages).freeGeneratePromptHint,
    icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fOqNz))), {
            label: "",
            spacing: "spacious"
        }),
    doNotHighlightDocWhenSelectionIsEmpty: true,
    agentId: 'editor_agent',
    canTogglePageKnowledge: true,
    quickInsertPriority: Number.NEGATIVE_INFINITY,
    intentSchemaId: 'custom_free_generate_intent_schema.json',
    featureId: 'free_generate',
    actions: {
        empty: [
            (0, $lxVNh.createInsertAtCurrentPosition)({
                appearance: 'primary'
            })
        ],
        selection: [
            (0, $lxVNh.createInsertBelow)({
                appearance: 'secondary'
            }),
            (0, $lxVNh.createReplace)({
                appearance: 'primary'
            })
        ]
    },
    getBackendModel: ()=>{
        return 'assistance-service';
    },
    withContextMutation: (configItem, { latestPromptResponse: latestPromptResponse })=>{
        return latestPromptResponse ? {
            ...configItem,
            intentSchemaId: 'custom_with_interrogation_intent_schema.json',
            featureId: 'interrogation'
        } : configItem;
    }
};

});
parcelRegister("8mzmn", function(module, exports) {

$parcel$export(module.exports, "default", () => $c497f6c6cd1432b2$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $c497f6c6cd1432b2$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    aiUniversalLongCallToAction: {
        id: 'fabric.editor.ai.shared.aiUniversalLongCallToAction',
        defaultMessage: 'Let Atlassian Intelligence assist your writing',
        description: 'Call-to-action text for activating the AI, used universally across UI elements like hover buttons, tooltips, and menu entries'
    },
    aiUniversalShortCallToAction: {
        id: 'fabric.editor.ai.shared.aiUniversalShortCallToAction',
        defaultMessage: 'Write',
        description: 'Call-to-action text for activating the AI, used universally across UI elements like buttons and menu entries'
    },
    aiProactiveButtonLabel: {
        id: 'fabric.editor.ai.shared.aiProactiveButtonLabel',
        defaultMessage: 'Suggestions',
        description: 'Call-to-action text for activating Proactive AI for inline AI suggestions.'
    },
    aiProactiveDescriptor: {
        id: 'fabric.editor.ai.shared.aiProactiveDescriptor.non-final',
        defaultMessage: '{count, plural, =0 {Open suggested edits} =1 {New suggested edit} =2 {Two new suggested edits} =3 {Three new suggested edits} =4 {Four new suggested edits} other {More than four new suggested edits}}',
        description: 'Tooltip text for Proactive AI button to activate the inline writing suggestions'
    },
    aiProactiveCloseDescriptor: {
        id: 'fabric.editor.ai.shared.aiProactiveDescriptorClose.non-final',
        defaultMessage: 'Close suggested edits',
        description: 'Tooltip text for Proactive AI button to close the inline writing suggestions'
    },
    aiUniversalDescriptor: {
        id: 'fabric.editor.ai.shared.aiUniversalDescriptor',
        defaultMessage: 'Writing assistant',
        description: 'Descriptive text for activating the AI, used universally across UI elements like hover buttons, tooltips, and menu entries'
    },
    aiButtonTitle: {
        id: 'fabric.editor.ai.shared.generateContent.aiButtonTitle',
        defaultMessage: 'AI (Atlassian Intelligence)',
        description: 'Title for Atlassian Intelligence feature shown in editor typeahead and element browser.'
    },
    betaLabel: {
        id: 'fabric.editor.ai.shared.betaLabel',
        defaultMessage: 'Beta',
        description: 'The label describing the beta status of an Atlassian Intelligence prompt'
    }
});

});


parcelRegister("cYuuz", function(module, exports) {

$parcel$export(module.exports, "createImproveDescriptionWithOptions", () => $d0584188434d3fcb$export$b8d167b10029e62f);

var $eJOHy = parcelRequire("eJOHy");

var $izZqh = parcelRequire("izZqh");

var $eGOwo = parcelRequire("eGOwo");

var $aXRNt = parcelRequire("aXRNt");

var $dAngv = parcelRequire("dAngv");

var $lxVNh = parcelRequire("lxVNh");

var $inU6j = parcelRequire("inU6j");
const $d0584188434d3fcb$var$getIssueType = (issueType)=>{
    switch(issueType){
        case 'bug':
            return 'Bug';
        case 'story':
            return 'Story';
        case 'epic':
            return 'Epic';
        case 'task':
        default:
            return 'Task'; // Default to 'Task' if issueType is not recognized
    }
};
const $d0584188434d3fcb$export$74b0275d64d18c50 = (options)=>({
        key: (0, $inU6j.CONFIG_ITEM_KEYS).ADD_STRUCTURE,
        title: (0, $izZqh.aiConfigItemMessages).improveDescription,
        description: (0, $izZqh.aiConfigItemMessages).reformatWithTemplateDescription,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aXRNt.IssueReformatterIcon), null),
        ...(0, $eGOwo.fg)('migrate_issue_reformatter_to_aiwc_endpoint') ? {
            endpoint: (0, $dAngv.jiraIssueReformatterApiURL)
        } : {},
        experienceId: 'issue-reformatter',
        intentSchemaId: 'issue_reformatter_intent_schema.json',
        featureId: 'issue_reformatter',
        alwaysNeedDoc: true,
        getRequestPayload: ({ locale: locale, doc: doc })=>{
            if ((0, $eGOwo.fg)('migrate_issue_reformatter_to_aiwc_endpoint')) {
                // additional props come from Issue View
                const { issue_summary: issue_summary, project_id: project_id, issue_type_label: issue_type_label, linked_urls: linked_urls } = options.getAdditionalProps?.();
                // all context is required except linked_urls
                const context = {
                    project_id: project_id,
                    summary: issue_summary,
                    description: doc,
                    ...{
                        links: linked_urls
                    } ?? []
                };
                const issue_type = $d0584188434d3fcb$var$getIssueType(issue_type_label);
                // see https://hello.atlassian.net/wiki/spaces/AIDO/pages/5306581134/PWDC+Issue+Reformatter+API+Contracts
                const ai_feature_input = {
                    source: 'JIRA',
                    locale: locale,
                    context: context,
                    response_type: 'NO_SCHEMA',
                    suggested_issues_config: {
                        use_template: true,
                        max_issues: 1,
                        suggested_issue_field_types: [
                            {
                                issue_type: issue_type,
                                fields: [
                                    {
                                        field_name: 'Description',
                                        field_type: 'Paragraph'
                                    }
                                ]
                            }
                        ]
                    }
                };
                return {
                    ai_feature_input: ai_feature_input
                };
            }
            return {
                recipient_agent_named_id: 'jira_issue_reformatter_agent',
                agent_input_context: {
                    locale: locale,
                    issue_description: doc,
                    ...options.getAdditionalProps?.()
                }
            };
        },
        actions: {
            empty: [
                (0, $lxVNh.createInsertBelow)({
                    appearance: 'secondary'
                }),
                (0, $lxVNh.createReplace)({
                    appearance: 'primary'
                })
            ],
            selection: [
                (0, $lxVNh.createInsertBelow)({
                    appearance: 'secondary'
                }),
                (0, $lxVNh.createReplace)({
                    appearance: 'primary'
                })
            ]
        },
        getBackendModel: ()=>'assistance-service'
    });
const $d0584188434d3fcb$export$b8d167b10029e62f = (options)=>({
        config: $d0584188434d3fcb$export$74b0275d64d18c50(options),
        triggers: {
            empty: {
                enabled: true,
                docMinSize: 1
            },
            selection: {
                enabled: true
            }
        }
    });

});
parcelRegister("aXRNt", function(module, exports) {

$parcel$export(module.exports, "IssueReformatterIcon", () => $8e8c06410462877a$export$80f4f0d1d6bfe69e);

var $eJOHy = parcelRequire("eJOHy");
const $8e8c06410462877a$export$80f4f0d1d6bfe69e = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M15 6H9C8.44772 6 8 6.44772 8 7C8 7.55228 8.44772 8 9 8H15C15.5523 8 16 7.55228 16 7C16 6.44772 15.5523 6 15 6Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M15 9H9C8.44772 9 8 9.44772 8 10C8 10.5523 8.44772 11 9 11H15C15.5523 11 16 10.5523 16 10C16 9.44772 15.5523 9 15 9Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M11 12H9C8.44772 12 8 12.4477 8 13C8 13.5523 8.44772 14 9 14H11C11.5523 14 12 13.5523 12 13C12 12.4477 11.5523 12 11 12Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M7 4V20H17V4H7ZM5 3.99C5 2.892 5.897 2 7.006 2H16.994C18.102 2 19 2.898 19 3.99V20.01C19 21.109 18.103 22 16.994 22H7.006C6.4765 22.0008 5.96822 21.7919 5.59231 21.419C5.21639 21.0461 5.00344 20.5395 5 20.01V3.99Z"
    }));
};

});

parcelRegister("dAngv", function(module, exports) {

$parcel$export(module.exports, "_getFetchCustomHeaders", () => $82aae3757e96f684$export$bd1a8b310b130c9d);
$parcel$export(module.exports, "convoAIStatelessApiURL", () => $82aae3757e96f684$export$4388fb67ca0987b2);
$parcel$export(module.exports, "convoAIApiUrl", () => $82aae3757e96f684$export$fab0701b0fe45e18);
$parcel$export(module.exports, "convoAIRovoApiURL", () => $82aae3757e96f684$export$90e6b91c68d8e307);
$parcel$export(module.exports, "convoAIAuditLogApiURL", () => $82aae3757e96f684$export$603c96e42632fe6);
$parcel$export(module.exports, "jiraIssueReformatterApiURL", () => $82aae3757e96f684$export$73e2b01807265672);
$parcel$export(module.exports, "deriveProactiveAIApiUrl", () => $82aae3757e96f684$export$2f9e5a704d3d0517);
$parcel$export(module.exports, "getAPIName", () => $82aae3757e96f684$export$8ee8ab4f2557589a);
$parcel$export(module.exports, "isTargetingNewConvoAIEndpoint", () => $82aae3757e96f684$export$8d185844757568fd);

var $eGOwo = parcelRequire("eGOwo");

var $9Letn = parcelRequire("9Letn");
function $82aae3757e96f684$export$bd1a8b310b130c9d() {
    const currentHost = window.location.origin;
    switch(true){
        case currentHost === 'https://statlas.prod.atl-paas.net':
            // Update this to add custom headers when run in atlaskit branch deploys
            // ie.
            // {
            //   'X-CloudID': 'Magic string'
            // }
            return {};
        default:
            return {};
    }
}
function $82aae3757e96f684$export$9167f99f9be83b24() {
    const { origin: origin = '', port: port = '', hostname: hostname = '' } = typeof window.location !== 'undefined' ? window.location : {};
    if (hostname === 'localhost' && port !== '8081' || [
        'atlaskit-website-staging.stg-east.frontend.public.atl-paas.net',
        'statlas.prod.atl-paas.net',
        'atlaskit.atlassian.com'
    ].some((h)=>hostname === h)) return 'https://pug.jira-dev.com';
    return origin;
}
const $82aae3757e96f684$export$4388fb67ca0987b2 = `${$82aae3757e96f684$export$9167f99f9be83b24()}/gateway/api/assist/chat/v1/invoke_agent/stream`;
const $82aae3757e96f684$export$fab0701b0fe45e18 = `${$82aae3757e96f684$export$9167f99f9be83b24()}/gateway/api/assist/api/ai/v2/ai-feature/editor-ai/stream`;
const $82aae3757e96f684$export$90e6b91c68d8e307 = `${$82aae3757e96f684$export$9167f99f9be83b24()}/gateway/api/assist/rovo/v1/editor/conversation`; // + `/${channelID}/message/stream` at the end;
const $82aae3757e96f684$export$603c96e42632fe6 = `${$82aae3757e96f684$export$9167f99f9be83b24()}/gateway/api/ai/v2/ai-feature/audit-logs`;
const $82aae3757e96f684$export$73e2b01807265672 = `${$82aae3757e96f684$export$9167f99f9be83b24()}/gateway/api/assist/ai/v2/ai-feature/jira/issue/source-type/work-item/suggestions/stream`;
function $82aae3757e96f684$export$2f9e5a704d3d0517() {
    return `${$82aae3757e96f684$export$9167f99f9be83b24()}/gateway/api/assist/ai/v2/ai-feature/proactive`;
}
const $82aae3757e96f684$export$8ee8ab4f2557589a = (endpoint)=>{
    switch(endpoint){
        case $82aae3757e96f684$export$4388fb67ca0987b2:
            return 'assistance-service';
        case $82aae3757e96f684$export$fab0701b0fe45e18:
            return 'convo-ai';
        case $82aae3757e96f684$export$90e6b91c68d8e307:
            return 'rovo-agent';
        case $82aae3757e96f684$export$603c96e42632fe6:
            return 'audit-logs';
        case $82aae3757e96f684$export$73e2b01807265672:
            return 'jira-issue-reformatter';
        case $82aae3757e96f684$export$2f9e5a704d3d0517():
            return 'proactive-ai';
        default:
            return 'unknown-api';
    }
};
/**
 * This is part 1 of intent schema IDs that will be migrated to the Convo AI endpoint and will be
 * enabled when the feature flag `editor_ai_convo_ai_endpoint_202505` is enabled.
 */ const $82aae3757e96f684$var$convoAIMigratedIntentsPart1 = new Set([
    'find_action_items',
    'change_tone_casual',
    'change_tone_educational',
    'change_tone_empathetic',
    'change_tone_neutral',
    'change_tone_professional',
    'fix_spelling_grammar',
    'improve_writing',
    'make_longer',
    'rephrase',
    'make_shorter',
    'suggest_title',
    'summarize_writing',
    'translate',
    'atlas_make_shorter'
]);
/**
 * This is part 2 of intent schema IDs that will be migrated to the Convo AI endpoint and will be
 * enabled when the feature flag `platform_editor_ai_convo_ai_migration_part2` is enabled.
 */ const $82aae3757e96f684$var$convoAIMigratedIntentsPart2 = new Set([
    'bitbucket_pr_description',
    'brainstorm',
    'free_generate',
    'interrogation'
]);
/**
 * There are new ADF intents that are only available on the new Convo AI endpoint.
 */ const $82aae3757e96f684$var$adfIntents = new Set([
    'improve_writing_adf_gemini25flash',
    'improve_writing_adf_gemini20flash',
    'improve_writing_adf_gpt4mini',
    'improve_writing_adf_gpt41mini'
]);
const $82aae3757e96f684$export$8d185844757568fd = (featureId)=>{
    if (!featureId) return false;
    return $82aae3757e96f684$var$adfIntents.has(featureId) && (0, $9Letn.expValEqualsNoExposure)('platform_editor_ai_iw_adf_streaming', 'isEnabled', true) || $82aae3757e96f684$var$convoAIMigratedIntentsPart1.has(featureId) && (0, $eGOwo.fg)('editor_ai_convo_ai_endpoint_202505') || $82aae3757e96f684$var$convoAIMigratedIntentsPart2.has(featureId) && (0, $eGOwo.fg)('platform_editor_ai_convo_ai_migration_part2');
};

});


parcelRegister("ch4Q9", function(module, exports) {

$parcel$export(module.exports, "makeShorterWithOptions", () => $d1e1596bfe03642d$export$cf8706c71bd8ab7d);

var $eJOHy = parcelRequire("eJOHy");

var $izZqh = parcelRequire("izZqh");

var $ag4rp = parcelRequire("ag4rp");

var $lxVNh = parcelRequire("lxVNh");

var $inU6j = parcelRequire("inU6j");
const $d1e1596bfe03642d$export$1792ed3292533f02 = {
    key: (0, $inU6j.CONFIG_ITEM_KEYS).MAKE_SHORTER,
    title: (0, $izZqh.aiConfigItemMessages).makeShorterTitle,
    description: (0, $izZqh.aiConfigItemMessages).makeShorterDescription,
    icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ag4rp.MakeShorterIcon), null),
    showInRefineDropdown: true,
    intentSchemaId: 'shorten_intent_schema.json',
    featureId: 'make_shorter',
    actions: {
        empty: [
            (0, $lxVNh.createInsertBelow)({
                appearance: 'secondary'
            }),
            (0, $lxVNh.createReplace)({
                appearance: 'primary'
            })
        ],
        selection: [
            (0, $lxVNh.createInsertBelow)({
                appearance: 'secondary'
            }),
            (0, $lxVNh.createReplace)({
                appearance: 'primary'
            })
        ]
    },
    getBackendModel: ()=>{
        return 'assistance-service';
    }
};
const $d1e1596bfe03642d$export$cf8706c71bd8ab7d = {
    config: $d1e1596bfe03642d$export$1792ed3292533f02,
    triggers: {
        empty: {
            enabled: true,
            docMinSize: 1
        },
        selection: {
            enabled: true
        }
    }
};

});
parcelRegister("ag4rp", function(module, exports) {

$parcel$export(module.exports, "MakeShorterIcon", () => $015040bf12f153b8$export$bd44f97e799f79a6);

var $eJOHy = parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");

var $giSOD = parcelRequire("giSOD");
const $015040bf12f153b8$var$IconGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        role: "presentation",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M11 13H7C6.44772 13 6 13.4477 6 14C6 14.5523 6.44772 15 7 15H11C11.5523 15 12 14.5523 12 14C12 13.4477 11.5523 13 11 13Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M17 9H7C6.44772 9 6 9.44772 6 10C6 10.5523 6.44772 11 7 11H17C17.5523 11 18 10.5523 18 10C18 9.44772 17.5523 9 17 9Z"
    }));
const $015040bf12f153b8$export$bd44f97e799f79a6 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($giSOD))), {
        label: "",
        color: "currentColor",
        spacing: "spacious",
        // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        LEGACY_fallbackIcon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
                glyph: $015040bf12f153b8$var$IconGlyph,
                ...props
            }),
        LEGACY_secondaryColor: "var(--ds-icon, #44546F)"
    });

});
parcelRegister("giSOD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::05be2231dbaf9aa0d7dffd1684187c72>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bde8d90ce71d9498$var$_react = $bde8d90ce71d9498$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $bde8d90ce71d9498$var$_baseNew = $bde8d90ce71d9498$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $bde8d90ce71d9498$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextShorten".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for shortening text content with Atlassian Intelligence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bde8d90ce71d9498$var$TextShortenIcon = (props)=>/*#__PURE__*/ $bde8d90ce71d9498$var$_react.default.createElement($bde8d90ce71d9498$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 6.5H1V5h14zM8 11H1V9.5h7z" clip-rule="evenodd"/>`
    }, props));
$bde8d90ce71d9498$var$TextShortenIcon.displayName = 'TextShortenIcon';
var $bde8d90ce71d9498$var$_default = module.exports.default = $bde8d90ce71d9498$var$TextShortenIcon;

});



parcelRegister("aZgQ3", function(module, exports) {

$parcel$export(module.exports, "summarizeWritingWithOptions", () => $70938f49210ba0df$export$a0bf62522ec7a604);

var $eJOHy = parcelRequire("eJOHy");

var $izZqh = parcelRequire("izZqh");
var $d7OCi = parcelRequire("d7OCi");

var $39Q1F = parcelRequire("39Q1F");

var $lxVNh = parcelRequire("lxVNh");

var $inU6j = parcelRequire("inU6j");
const $70938f49210ba0df$export$5dae1cd728cdd936 = {
    key: (0, $inU6j.CONFIG_ITEM_KEYS).SUMMARISE_WRITING,
    title: (0, $izZqh.aiConfigItemMessages).summarizeWritingtitle,
    description: (0, $izZqh.aiConfigItemMessages).summarizeWritingDescription,
    icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $39Q1F.SummarizeIcon), null),
    showInRefineDropdown: true,
    intentSchemaId: 'summarize_intent_schema.json',
    featureId: 'summarize_writing',
    actions: {
        empty: [
            (0, $lxVNh.createInsertAtCurrentPosition)({
                appearance: 'primary'
            })
        ],
        selection: [
            (0, $lxVNh.createInsertBelow)({
                appearance: 'secondary'
            }),
            (0, $lxVNh.createReplace)({
                appearance: 'primary'
            })
        ]
    },
    getBackendModel: ()=>{
        return 'assistance-service';
    }
};
const $70938f49210ba0df$export$a0bf62522ec7a604 = {
    config: $70938f49210ba0df$export$5dae1cd728cdd936,
    triggers: {
        empty: {
            enabled: true,
            docMinSize: 1
        },
        selection: {
            enabled: true
        }
    }
};
const $70938f49210ba0df$export$afe1e087747ab29 = {
    config: {
        ...$70938f49210ba0df$export$5dae1cd728cdd936,
        description: (0, $d7OCi.aiMessages).atlasSummarizePageConfigItemDescription
    },
    triggers: {
        empty: {
            enabled: true,
            docMinSize: 1
        },
        selection: {
            enabled: false
        }
    }
};

});
parcelRegister("39Q1F", function(module, exports) {

$parcel$export(module.exports, "SummarizeIcon", () => $5bfe4c5f1e782869$export$71f01d1a809741f7);

var $eJOHy = parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");

var $8qRZP = parcelRequire("8qRZP");
const $5bfe4c5f1e782869$var$IconGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        width: "24",
        height: "25",
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: "presentation",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M18 16.5H6C5.44772 16.5 5 16.9477 5 17.5C5 18.0523 5.44772 18.5 6 18.5H18C18.5523 18.5 19 18.0523 19 17.5C19 16.9477 18.5523 16.5 18 16.5Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M18 6.5H14C13.4477 6.5 13 6.94772 13 7.5C13 8.05228 13.4477 8.5 14 8.5H18C18.5523 8.5 19 8.05228 19 7.5C19 6.94772 18.5523 6.5 18 6.5Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M18 11.5H6C5.44772 11.5 5 11.9477 5 12.5C5 13.0523 5.44772 13.5 6 13.5H18C18.5523 13.5 19 13.0523 19 12.5C19 11.9477 18.5523 11.5 18 11.5Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M5.375 7.661C5.375 8.14424 5.76675 8.536 6.25 8.536C6.73325 8.536 7.125 8.14424 7.125 7.661C7.125 7.17775 6.73325 6.786 6.25 6.786C5.76675 6.786 5.375 7.17775 5.375 7.661Z",
        fill: "currentColor",
        stroke: "currentColor",
        strokeWidth: "1.75"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M9.375 7.661C9.375 8.14424 9.76675 8.536 10.25 8.536C10.7332 8.536 11.125 8.14424 11.125 7.661C11.125 7.17775 10.7332 6.786 10.25 6.786C9.76675 6.786 9.375 7.17775 9.375 7.661Z",
        fill: "currentColor",
        stroke: "currentColor",
        strokeWidth: "1.75"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M5.07 7.989C4.682 6.493 5.481 5.164 6.77 4.955M9.07 7.989C8.682 6.493 9.481 5.164 10.77 4.955",
        fill: "currentColor",
        strokeLinecap: "round"
    }));
const $5bfe4c5f1e782869$export$71f01d1a809741f7 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8qRZP))), {
        label: "",
        color: "currentColor",
        spacing: "spacious",
        // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        LEGACY_fallbackIcon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
                glyph: $5bfe4c5f1e782869$var$IconGlyph,
                ...props
            })
    });

});
parcelRegister("8qRZP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d4df587d0c3f1832e97f8caba30d1552>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $623aa2fb7937c488$var$_react = $623aa2fb7937c488$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $623aa2fb7937c488$var$_baseNew = $623aa2fb7937c488$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $623aa2fb7937c488$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeTextSummary".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for summarizing content with Atlassian Intelligence & Loom
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $623aa2fb7937c488$var$AiGenerativeTextSummaryIcon = (props)=>/*#__PURE__*/ $623aa2fb7937c488$var$_react.default.createElement($623aa2fb7937c488$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 1h14v1.5H1zm0 4.166h14v1.5H1zm10.796 4.328a.75.75 0 0 1 1.41 0l.615 1.687 1.686.615a.75.75 0 0 1 0 1.41l-1.686.615-.615 1.686a.75.75 0 0 1-1.41 0l-.615-1.686-1.687-.615a.75.75 0 0 1 0-1.41l1.687-.615zM1 9.333h7v1.5H1zm0 4.166h5v1.5H1z" clip-rule="evenodd"/>`
    }, props));
$623aa2fb7937c488$var$AiGenerativeTextSummaryIcon.displayName = 'AiGenerativeTextSummaryIcon';
var $623aa2fb7937c488$var$_default = module.exports.default = $623aa2fb7937c488$var$AiGenerativeTextSummaryIcon;

});



parcelRegister("79pRH", function(module, exports) {

$parcel$export(module.exports, "translationConfigItemWithOptions", () => $77fc7d5bf21d1ad3$export$f79e42233d7b78a9);

var $eJOHy = parcelRequire("eJOHy");

var $7dnXt = parcelRequire("7dnXt");

var $jYvZn = parcelRequire("jYvZn");

var $lxVNh = parcelRequire("lxVNh");

var $lxSgB = parcelRequire("lxSgB");
const $77fc7d5bf21d1ad3$var$supportedTranslationLanguages = (0, $lxSgB.getSortedSupportedTranslationLanguages)();
const $77fc7d5bf21d1ad3$var$translationConfigItemsArr = $77fc7d5bf21d1ad3$var$supportedTranslationLanguages.map((language)=>{
    const lang = (0, $7dnXt.aiLanguageMessages)[language];
    if (!lang) return false;
    const configItem = {
        key: `Translate to ${language}`,
        title: (0, $7dnXt.aiLanguageMessages)[`${language}Title`],
        description: (0, $7dnXt.aiLanguageMessages)[`${language}Description`],
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYvZn.TranslateIcon), null),
        showInRefineDropdown: (0, $lxSgB.isRefinementSupport)(language),
        nestingConfig: {
            id: 'translate-to',
            parentTestId: 'translate-to',
            parentTitle: (0, $7dnXt.aiLanguageMessages).nestingParentTitlePostGA,
            shortTitle: lang,
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYvZn.TranslateIcon), null)
        },
        intentSchemaId: 'translate_intent_schema.json',
        featureId: 'translate',
        lang: lang.defaultMessage,
        actions: {
            empty: [
                (0, $lxVNh.createInsertBelow)({
                    appearance: 'secondary'
                }),
                (0, $lxVNh.createReplace)({
                    appearance: 'primary'
                })
            ],
            selection: [
                (0, $lxVNh.createInsertBelow)({
                    appearance: 'secondary'
                }),
                (0, $lxVNh.createReplace)({
                    appearance: 'primary'
                })
            ]
        }
    };
    return [
        language,
        configItem
    ];
}).filter(Boolean);
const $77fc7d5bf21d1ad3$export$92a3f158c5aa8500 = Object.fromEntries($77fc7d5bf21d1ad3$var$translationConfigItemsArr.filter(Boolean));
const $77fc7d5bf21d1ad3$export$c9f99cf066285ff1 = Object.values($77fc7d5bf21d1ad3$export$92a3f158c5aa8500);
const $77fc7d5bf21d1ad3$export$f79e42233d7b78a9 = $77fc7d5bf21d1ad3$export$c9f99cf066285ff1.map((config)=>({
        config: config,
        triggers: {
            empty: {
                enabled: true,
                docMinSize: 1
            },
            selection: {
                enabled: true
            }
        }
    }));
const $77fc7d5bf21d1ad3$export$58be4f46859bb368 = $77fc7d5bf21d1ad3$export$c9f99cf066285ff1.map((config)=>({
        config: config,
        triggers: {
            empty: {
                enabled: false
            },
            selection: {
                enabled: true
            }
        }
    }));

});
parcelRegister("7dnXt", function(module, exports) {

$parcel$export(module.exports, "aiLanguageMessages", () => $dc321224caba6a5d$export$b71056f6af7927e9);
// eslint-disable-next-line no-restricted-imports

var $7qGN1 = parcelRequire("7qGN1");
const $dc321224caba6a5d$export$b71056f6af7927e9 = (0, $7qGN1.defineMessages)({
    // Language Messages
    nestingParentTitle: {
        id: 'fabric.editor.ai.config.item.translate.nestingParentTitle.ga',
        defaultMessage: 'Translate',
        description: 'The nested title which shows in the generative-ai-modal'
    },
    nestingParentTitlePostGA: {
        id: 'fabric.editor.ai.config.item.translate.nestingParentTitlePostGA',
        defaultMessage: 'Translate to ...',
        description: 'The nested title which shows in the generative-ai-modal'
    },
    chineseSimplified: {
        id: 'fabric.editor.ai.config.item.translate.chineseSimplified',
        defaultMessage: 'Chinese (Simplified)',
        description: 'Language string referenced in UIs involving the translation AI prompt for Chinese (Simplified)'
    },
    chineseTraditional: {
        id: 'fabric.editor.ai.config.item.translate.chineseTraditional',
        defaultMessage: 'Chinese (Traditional)',
        description: 'Language string referenced in UIs involving the translation AI prompt for Chinese (Traditional)'
    },
    czech: {
        id: 'fabric.editor.ai.config.item.translate.czech',
        defaultMessage: 'Czech',
        description: 'Language string referenced in UIs involving the translation AI prompt for Czech'
    },
    danish: {
        id: 'fabric.editor.ai.config.item.translate.danish',
        defaultMessage: 'Danish',
        description: 'Language string referenced in UIs involving the translation AI prompt for Danish'
    },
    dutch: {
        id: 'fabric.editor.ai.config.item.translate.dutch',
        defaultMessage: 'Dutch',
        description: 'Language string referenced in UIs involving the translation AI prompt for Dutch'
    },
    english: {
        id: 'fabric.editor.ai.config.item.translate.english',
        defaultMessage: 'English',
        description: 'Language string referenced in UIs involving the translation AI prompt for English'
    },
    finnish: {
        id: 'fabric.editor.ai.config.item.translate.finnish',
        defaultMessage: 'Finnish',
        description: 'Language string referenced in UIs involving the translation AI prompt for Finnish'
    },
    french: {
        id: 'fabric.editor.ai.config.item.translate.french',
        defaultMessage: 'French',
        description: 'Language string referenced in UIs involving the translation AI prompt for French'
    },
    german: {
        id: 'fabric.editor.ai.config.item.translate.german',
        defaultMessage: 'German',
        description: 'Language string referenced in UIs involving the translation AI prompt for German'
    },
    hungarian: {
        id: 'fabric.editor.ai.config.item.translate.hungarian',
        defaultMessage: 'Hungarian',
        description: 'Language string referenced in UIs involving the translation AI prompt for Hungarian'
    },
    italian: {
        id: 'fabric.editor.ai.config.item.translate.italian',
        defaultMessage: 'Italian',
        description: 'Language string referenced in UIs involving the translation AI prompt for Italian'
    },
    japanese: {
        id: 'fabric.editor.ai.config.item.translate.japanese',
        defaultMessage: 'Japanese',
        description: 'Language string referenced in UIs involving the translation AI prompt for Japanese'
    },
    korean: {
        id: 'fabric.editor.ai.config.item.translate.korean',
        defaultMessage: 'Korean',
        description: 'Language string referenced in UIs involving the translation AI prompt for Korean'
    },
    norwegian: {
        id: 'fabric.editor.ai.config.item.translate.norwegian',
        defaultMessage: 'Norwegian',
        description: 'Language string referenced in UIs involving the translation AI prompt for Norwegian'
    },
    polish: {
        id: 'fabric.editor.ai.config.item.translate.polish',
        defaultMessage: 'Polish',
        description: 'Language string referenced in UIs involving the translation AI prompt for Polish'
    },
    portugueseBrazilian: {
        id: 'fabric.editor.ai.config.item.translate.portugueseBrazilian',
        defaultMessage: 'Portuguese (Brazilian)',
        description: 'Language string referenced in UIs involving the translation AI prompt for Portuguese (Brazilian)'
    },
    russian: {
        id: 'fabric.editor.ai.config.item.translate.russian',
        defaultMessage: 'Russian',
        description: 'Language string referenced in UIs involving the translation AI prompt for Russian'
    },
    spanish: {
        id: 'fabric.editor.ai.config.item.translate.spanish',
        defaultMessage: 'Spanish',
        description: 'Language string referenced in UIs involving the translation AI prompt for Spanish'
    },
    swedish: {
        id: 'fabric.editor.ai.config.item.translate.swedish',
        defaultMessage: 'Swedish',
        description: 'Language string referenced in UIs involving the translation AI prompt for Swedish'
    },
    turkish: {
        id: 'fabric.editor.ai.config.item.translate.turkish',
        defaultMessage: 'Turkish',
        description: 'Language string referenced in UIs involving the translation AI prompt for Turkish'
    },
    thai: {
        id: 'fabric.editor.ai.config.item.translate.thai',
        defaultMessage: 'Thai',
        description: 'Language string referenced in UIs involving the translation AI prompt for Thai'
    },
    ukrainian: {
        id: 'fabric.editor.ai.config.item.translate.ukrainian',
        defaultMessage: 'Ukrainian',
        description: 'Language string referenced in UIs involving the translation AI prompt for Ukrainian'
    },
    vietnamese: {
        id: 'fabric.editor.ai.config.item.translate.vietnamese',
        defaultMessage: 'Vietnamese',
        description: 'Language string referenced in UIs involving the translation AI prompt for Vietnamese'
    },
    // Translate to messages
    chineseSimplifiedTitle: {
        id: 'fabric.editor.ai.config.item.translateTo.chineseSimplified.title',
        defaultMessage: 'Translate to Chinese (Simplified)',
        description: 'Title of a prompt that translates the selected content into Chinese (Simplified)'
    },
    chineseSimplifiedDescription: {
        id: 'fabric.editor.ai.config.item.translateTo.chineseSimplified.description',
        defaultMessage: "Translates the text you're working on to Chinese (Simplified)",
        description: 'Description for prompt that translates selected content into Chinese (Simplified)'
    },
    chineseTraditionalTitle: {
        id: 'fabric.editor.ai.config.item.translateTo.chineseTraditional.title',
        defaultMessage: 'Translate to Chinese (Traditional)',
        description: 'Title of a prompt that translates the selected content into Chinese (Traditional)'
    },
    chineseTraditionalDescription: {
        id: 'fabric.editor.ai.config.item.translateTo.chineseTraditional.description',
        defaultMessage: "Translates the text you're working on to Chinese (Traditional)",
        description: 'Description for prompt that translates selected content into Chinese (Traditional)'
    },
    czechTitle: {
        id: 'fabric.editor.ai.config.item.translateTo.czech.title',
        defaultMessage: 'Translate to Czech',
        description: 'Title of a prompt that translates the selected content into Czech'
    },
    czechDescription: {
        id: 'fabric.editor.ai.config.item.translateTo.czech.description',
        defaultMessage: "Translates the text you're working on to Czech",
        description: 'Description for prompt that translates selected content into Czech'
    },
    danishTitle: {
        id: 'fabric.editor.ai.config.item.translateTo.danish.title',
        defaultMessage: 'Translate to Danish',
        description: 'Title of a prompt that translates the selected content into Danish'
    },
    danishDescription: {
        id: 'fabric.editor.ai.config.item.translateTo.danish.description',
        defaultMessage: "Translates the text you're working on to Danish",
        description: 'Description for prompt that translates selected content into Danish'
    },
    dutchTitle: {
        id: 'fabric.editor.ai.config.item.translateTo.dutch.title',
        defaultMessage: 'Translate to Dutch',
        description: 'Title of a prompt that translates the selected content into Dutch'
    },
    dutchDescription: {
        id: 'fabric.editor.ai.config.item.translateTo.dutch.description',
        defaultMessage: "Translates the text you're working on to Dutch",
        description: 'Description for prompt that translates selected content into Dutch'
    },
    englishTitle: {
        id: 'fabric.editor.ai.config.item.translateTo.english.title',
        defaultMessage: 'Translate to English',
        description: 'Title of a prompt that translates the selected content into English'
    },
    englishDescription: {
        id: 'fabric.editor.ai.config.item.translateTo.english.description',
        defaultMessage: "Translates the text you're working on to English",
        description: 'Description for prompt that translates selected content into English'
    },
    finnishTitle: {
        id: 'fabric.editor.ai.config.item.translateTo.finnish.title',
        defaultMessage: 'Translate to Finnish',
        description: 'Title of a prompt that translates the selected content into Finnish'
    },
    finnishDescription: {
        id: 'fabric.editor.ai.config.item.translateTo.finnish.description',
        defaultMessage: "Translates the text you're working on to Finnish",
        description: 'Description for prompt that translates selected content into Finnish'
    },
    frenchTitle: {
        id: 'fabric.editor.ai.config.item.translateTo.french.title',
        defaultMessage: 'Translate to French',
        description: 'Title of a prompt that translates the selected content into French'
    },
    frenchDescription: {
        id: 'fabric.editor.ai.config.item.translateTo.french.description',
        defaultMessage: "Translates the text you're working on to French",
        description: 'Description for prompt that translates selected content into French'
    },
    germanTitle: {
        id: 'fabric.editor.ai.config.item.translateTo.german.title',
        defaultMessage: 'Translate to German',
        description: 'Title of a prompt that translates the selected content into German'
    },
    germanDescription: {
        id: 'fabric.editor.ai.config.item.translateTo.german.description',
        defaultMessage: "Translates the text you're working on to German",
        description: 'Description for prompt that translates selected content into German'
    },
    hungarianTitle: {
        id: 'fabric.editor.ai.config.item.translateTo.hungarian.title',
        defaultMessage: 'Translate to Hungarian',
        description: 'Title of a prompt that translates the selected content into Hungarian'
    },
    hungarianDescription: {
        id: 'fabric.editor.ai.config.item.translateTo.hungarian.description',
        defaultMessage: "Translates the text you're working on to Hungarian",
        description: 'Description for prompt that translates selected content into Hungarian'
    },
    italianTitle: {
        id: 'fabric.editor.ai.config.item.translateTo.italian.title',
        defaultMessage: 'Translate to Italian',
        description: 'Title of a prompt that translates the selected content into Italian'
    },
    italianDescription: {
        id: 'fabric.editor.ai.config.item.translateTo.italian.description',
        defaultMessage: "Translates the text you're working on to Italian",
        description: 'Description for prompt that translates selected content into Italian'
    },
    japaneseTitle: {
        id: 'fabric.editor.ai.config.item.translateTo.japanese.title',
        defaultMessage: 'Translate to Japanese',
        description: 'Title of a prompt that translates the selected content into Japanese'
    },
    japaneseDescription: {
        id: 'fabric.editor.ai.config.item.translateTo.japanese.description',
        defaultMessage: "Translates the text you're working on to Japanese",
        description: 'Description for prompt that translates selected content into Japanese'
    },
    koreanTitle: {
        id: 'fabric.editor.ai.config.item.translateTo.korean.title',
        defaultMessage: 'Translate to Korean',
        description: 'Title of a prompt that translates the selected content into Korean'
    },
    koreanDescription: {
        id: 'fabric.editor.ai.config.item.translateTo.korean.description',
        defaultMessage: "Translates the text you're working on to Korean",
        description: 'Description for prompt that translates selected content into Korean'
    },
    norwegianTitle: {
        id: 'fabric.editor.ai.config.item.translateTo.norwegian.title',
        defaultMessage: 'Translate to Norwegian',
        description: 'Title of a prompt that translates the selected content into Norwegian'
    },
    norwegianDescription: {
        id: 'fabric.editor.ai.config.item.translateTo.norwegian.description',
        defaultMessage: "Translates the text you're working on to Norwegian",
        description: 'Description for prompt that translates selected content into Norwegian'
    },
    polishTitle: {
        id: 'fabric.editor.ai.config.item.translateTo.polish.title',
        defaultMessage: 'Translate to Polish',
        description: 'Title of a prompt that translates the selected content into Polish'
    },
    polishDescription: {
        id: 'fabric.editor.ai.config.item.translateTo.polish.description',
        defaultMessage: "Translates the text you're working on to Polish",
        description: 'Description for prompt that translates selected content into Polish'
    },
    portugueseBrazilianTitle: {
        id: 'fabric.editor.ai.config.item.translateTo.portugueseBrazilian.title',
        defaultMessage: 'Translate to Portuguese (Brazilian)',
        description: 'Title of a prompt that translates the selected content into Portuguese (Brazilian)'
    },
    portugueseBrazilianDescription: {
        id: 'fabric.editor.ai.config.item.translateTo.portugueseBrazilian.description',
        defaultMessage: "Translates the text you're working on to Portuguese (Brazilian)",
        description: 'Description for prompt that translates selected content into Portuguese (Brazilian)'
    },
    russianTitle: {
        id: 'fabric.editor.ai.config.item.translateTo.russian.title',
        defaultMessage: 'Translate to Russian',
        description: 'Title of a prompt that translates the selected content into Russian'
    },
    russianDescription: {
        id: 'fabric.editor.ai.config.item.translateTo.russian.description',
        defaultMessage: "Translates the text you're working on to Russian",
        description: 'Description for prompt that translates selected content into Russian'
    },
    spanishTitle: {
        id: 'fabric.editor.ai.config.item.translateTo.spanish.title',
        defaultMessage: 'Translate to Spanish',
        description: 'Title of a prompt that translates the selected content into Spanish'
    },
    spanishDescription: {
        id: 'fabric.editor.ai.config.item.translateTo.spanish.description',
        defaultMessage: "Translates the text you're working on to Spanish",
        description: 'Description for prompt that translates selected content into Spanish'
    },
    swedishTitle: {
        id: 'fabric.editor.ai.config.item.translateTo.swedish.title',
        defaultMessage: 'Translate to Swedish',
        description: 'Title of a prompt that translates the selected content into Swedish'
    },
    swedishDescription: {
        id: 'fabric.editor.ai.config.item.translateTo.swedish.description',
        defaultMessage: "Translates the text you're working on to Swedish",
        description: 'Description for prompt that translates selected content into Swedish'
    },
    turkishTitle: {
        id: 'fabric.editor.ai.config.item.translateTo.turkish.title',
        defaultMessage: 'Translate to Turkish',
        description: 'Title of a prompt that translates the selected content into Turkish'
    },
    turkishDescription: {
        id: 'fabric.editor.ai.config.item.translateTo.turkish.description',
        defaultMessage: "Translates the text you're working on to Turkish",
        description: 'Description for prompt that translates selected content into Turkish'
    },
    thaiTitle: {
        id: 'fabric.editor.ai.config.item.translateTo.thai.title',
        defaultMessage: 'Translate to Thai',
        description: 'Title of a prompt that translates the selected content into Thai'
    },
    thaiDescription: {
        id: 'fabric.editor.ai.config.item.translateTo.thai.description',
        defaultMessage: "Translates the text you're working on to Thai",
        description: 'Description for prompt that translates selected content into Thai'
    },
    ukrainianTitle: {
        id: 'fabric.editor.ai.config.item.translateTo.ukrainian.title',
        defaultMessage: 'Translate to Ukrainian',
        description: 'Title of a prompt that translates the selected content into Ukrainian'
    },
    ukrainianDescription: {
        id: 'fabric.editor.ai.config.item.translateTo.ukrainian.description',
        defaultMessage: "Translates the text you're working on to Ukrainian",
        description: 'Description for prompt that translates selected content into Ukrainian'
    },
    vietnameseTitle: {
        id: 'fabric.editor.ai.config.item.translateTo.vietnamese.title',
        defaultMessage: 'Translate to Vietnamese',
        description: 'Title of a prompt that translates the selected content into Vietnamese'
    },
    vietnameseDescription: {
        id: 'fabric.editor.ai.config.item.translateTo.vietnamese.description',
        defaultMessage: "Translates the text you're working on to Vietnamese",
        description: 'Description for prompt that translates selected content into Vietnamese'
    }
});

});

parcelRegister("jYvZn", function(module, exports) {

$parcel$export(module.exports, "TranslateIcon", () => $87eebd50928a8285$export$d1fe1d52e2885c4e);

var $eJOHy = parcelRequire("eJOHy");

var $iBgxn = parcelRequire("iBgxn");

var $1gtOK = parcelRequire("1gtOK");
const $87eebd50928a8285$export$d1fe1d52e2885c4e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1gtOK))), {
        label: "",
        color: "currentColor",
        spacing: "spacious",
        LEGACY_fallbackIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iBgxn))), {
                label: "",
                spacing: "spacious"
            })
    });

});
parcelRegister("1gtOK", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e225d3a586abb6eec4725e9317596327>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0ebe6a329de333ab$var$_react = $0ebe6a329de333ab$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $0ebe6a329de333ab$var$_baseNew = $0ebe6a329de333ab$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $0ebe6a329de333ab$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Translate".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing language translations.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0ebe6a329de333ab$var$TranslateIcon = (props)=>/*#__PURE__*/ $0ebe6a329de333ab$var$_react.default.createElement($0ebe6a329de333ab$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.395 4.5H0V3h4V1h1.5v2h4v1.5H6.911c-.252 1.771-.704 3.325-1.338 4.685.471.522.973.973 1.479 1.323l-.854 1.234a10 10 0 0 1-1.377-1.17 12.2 12.2 0 0 1-2.991 3.275l-.91-1.194a10.7 10.7 0 0 0 2.867-3.276 12.5 12.5 0 0 1-1.74-3.114l1.405-.526c.265.706.633 1.418 1.073 2.087.385-.982.68-2.085.87-3.324m5.17 1.945A.75.75 0 0 1 11.25 6h.5a.75.75 0 0 1 .685.445l3.5 7.875a.75.75 0 0 1 .065.305V15h-1.5v-.216L13.707 13H9.293L8.5 14.784V15H7v-.375a.75.75 0 0 1 .065-.305zM9.96 11.5h3.08L11.5 8.034z" clip-rule="evenodd"/>`
    }, props));
$0ebe6a329de333ab$var$TranslateIcon.displayName = 'TranslateIcon';
var $0ebe6a329de333ab$var$_default = module.exports.default = $0ebe6a329de333ab$var$TranslateIcon;

});


parcelRegister("lxSgB", function(module, exports) {

$parcel$export(module.exports, "getSortedSupportedTranslationLanguages", () => $4b1e0af54dc55216$export$a288aff1b8104a05);
$parcel$export(module.exports, "isRefinementSupport", () => $4b1e0af54dc55216$export$9429b43310621fcf);

var $5pJQx = parcelRequire("5pJQx");
const $4b1e0af54dc55216$export$a288aff1b8104a05 = ()=>{
    return 0, $5pJQx.supportedTranslationLanguagesPopularOrder;
};
const $4b1e0af54dc55216$export$f54f1bab33a30a3f = (latestPrompt)=>typeof latestPrompt?.presetTitle?.title?.defaultMessage === 'string' && latestPrompt?.presetTitle?.title?.defaultMessage?.includes('Translate to');
const $4b1e0af54dc55216$export$9429b43310621fcf = (language)=>(0, $5pJQx.refinementSupportedTranslationLanguages).includes(language);

});



parcelRegister("ivqdF", function(module, exports) {

$parcel$export(module.exports, "useIsPremium", () => $b1a6792f3a792a23$export$1bb5840a003dc643);
$parcel$export(module.exports, "useOptInStatus", () => $b1a6792f3a792a23$export$5e56b08674e48311);
$parcel$export(module.exports, "useAIOptIn", () => $b1a6792f3a792a23$export$49e57b9044cda91c);

var $eJOHy = parcelRequire("eJOHy");

var $8RHPx = parcelRequire("8RHPx");
var $lopBx = parcelRequire("lopBx");

var $ln6Iy = parcelRequire("ln6Iy");

var $bmoS1 = parcelRequire("bmoS1");

var $3ASEn = parcelRequire("3ASEn");

var $bNexr = parcelRequire("bNexr");

var $g9Vr6 = parcelRequire("g9Vr6");

var $a9ldn = parcelRequire("a9ldn");

var $8vyDv = parcelRequire("8vyDv");

var $lUto7 = parcelRequire("lUto7");

var $7jTnu = parcelRequire("7jTnu");

var $fbqHd = parcelRequire("fbqHd");

var $fgQXu = parcelRequire("fgQXu");
const $b1a6792f3a792a23$var$DISABLED = 'disabled';
const $b1a6792f3a792a23$var$DISABLED_OPT_IN = 'disabled-opt-in';
const $b1a6792f3a792a23$var$ENABLED = 'enabled';
const $b1a6792f3a792a23$export$1bb5840a003dc643 = ()=>{
    const appEditions = (0, $8vyDv.useAppEditions)();
    const issueKey = (0, $bmoS1.useIssueKey)();
    const projectKey = (0, $bNexr.useProjectKey)(issueKey);
    const projectType = (0, $bNexr.useProjectType)(projectKey);
    if (!appEditions) return false;
    // currently admin hub AI BE endpoint for JWM already defaults to JSW value
    // so we reflect same logic for JWM here
    switch(projectType){
        case 0, $ln6Iy.CORE_PROJECT:
        case 0, $ln6Iy.SOFTWARE_PROJECT:
            return appEditions.software === (0, $a9ldn.PREMIUM_EDITION);
        case 0, $ln6Iy.SERVICE_DESK_PROJECT:
            return appEditions.serviceDesk === (0, $a9ldn.PREMIUM_EDITION);
        case 0, $ln6Iy.PRODUCT_DISCOVERY_PROJECT:
            if ((0, $7jTnu.fg)('jira_ai_standard_rollout_rm_premium_checks_gravity')) return appEditions.productDiscovery === (0, $a9ldn.PREMIUM_EDITION);
            return false;
        default:
            return false;
    }
};
const $b1a6792f3a792a23$export$10e0dafdd792475b = ()=>{
    // upsell us for standard but not free subscription admins
    const appEditions = (0, $8vyDv.useAppEditions)();
    const issueKey = (0, $bmoS1.useIssueKey)();
    const projectKey = (0, $bNexr.useProjectKey)(issueKey);
    const projectType = (0, $bNexr.useProjectType)(projectKey);
    if (!appEditions) return false;
    switch(projectType){
        case 0, $ln6Iy.CORE_PROJECT:
            return appEditions.core === (0, $a9ldn.STANDARD_EDITION);
        case 0, $ln6Iy.SOFTWARE_PROJECT:
            return appEditions.software === (0, $a9ldn.STANDARD_EDITION);
        case 0, $ln6Iy.SERVICE_DESK_PROJECT:
            return appEditions.serviceDesk === (0, $a9ldn.STANDARD_EDITION);
        default:
            return false;
    }
};
const $b1a6792f3a792a23$export$bd66bcf1f00b19d2 = ()=>{
    const isOrgAdmin = (0, $lUto7.useIsSiteAdmin)();
    const isPremium = $b1a6792f3a792a23$export$1bb5840a003dc643();
    const isSupportedENV = !(0, $lopBx.isFedRamp)();
    return isOrgAdmin && isPremium && isSupportedENV;
};
const $b1a6792f3a792a23$export$1276193c77ae88bf = ()=>{
    const isOrgAdmin = (0, $lUto7.useIsSiteAdmin)();
    const isStandard = $b1a6792f3a792a23$export$10e0dafdd792475b();
    const isSupportedENV = !(0, $lopBx.isFedRamp)();
    return isOrgAdmin && isStandard && isSupportedENV;
};
const $b1a6792f3a792a23$export$5e56b08674e48311 = (isAIOptedIn, product)=>{
    const canOptIn = $b1a6792f3a792a23$export$bd66bcf1f00b19d2();
    const canStartPremiumTrial = $b1a6792f3a792a23$export$1276193c77ae88bf();
    if ((0, $lopBx.isFedRamp)()) return $b1a6792f3a792a23$var$DISABLED;
    // AI Upsell In Editor Experiment - implicitly checks product, fedramp, if edition is FREE and user is an admin
    const { experimentValue: aiUpsellInEditorCohort } = (0, $7jTnu.fg)('jira_free_ai_in_editor_v2_gate') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $3ASEn.useAIUpsellInEditorRequirements)(product) : {
        experimentValue: 'not-enrolled'
    };
    if (aiUpsellInEditorCohort === 'variation') return $b1a6792f3a792a23$var$DISABLED_OPT_IN;
    const isValidForGlobalOptIn = [
        product !== 'JPD',
        canOptIn
    ].every((condition)=>condition === true);
    const isValidForPremiumTrial = canStartPremiumTrial && product !== 'JPD';
    const globalOptInEnabled = isValidForGlobalOptIn || isValidForPremiumTrial ? $b1a6792f3a792a23$var$DISABLED_OPT_IN : $b1a6792f3a792a23$var$DISABLED;
    return isAIOptedIn ? $b1a6792f3a792a23$var$ENABLED : globalOptInEnabled;
};
const $b1a6792f3a792a23$export$49e57b9044cda91c = ({ editorPluginAIConfig: editorPluginAIConfig })=>{
    const { isAiOptInEnabled: isAiOptInEnabled, product: product } = editorPluginAIConfig || {};
    const optInStatus = $b1a6792f3a792a23$export$5e56b08674e48311(isAiOptInEnabled, product);
    const isOrgAdmin = (0, $lUto7.useIsSiteAdmin)();
    const [showOptInModal, setShowOptInModal] = (0, $eJOHy.useState)(false);
    const [showPremiumTrialModal, setShowPremiumTrialModal] = (0, $eJOHy.useState)(false);
    const { data: orgId } = (0, $g9Vr6.useOrgId)();
    const canStartTrial = $b1a6792f3a792a23$export$1276193c77ae88bf();
    // AI Upsell In Editor Experiment
    const { isExperimentEnabled: isAIUpsellInEditorFreeEnabled, triggerUpsellFlow: triggerAIUpsellInEditorFreeFlow, UpsellModal: AIUpsellInEditorFreeModal } = (0, $7jTnu.fg)('jira_free_ai_in_editor_v2_gate') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $3ASEn.useAIUpsellInEditorFree)(optInStatus, product) : {
        isExperimentEnabled: false,
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        triggerUpsellFlow: ()=>{},
        UpsellModal: null
    };
    // Callback that will be called when AI buttons are clicked and opt in status is disabled-op-in
    const triggerOptInFlow = (0, $eJOHy.useCallback)(()=>{
        setShowOptInModal(true);
    }, [
        setShowOptInModal
    ]);
    // alt callback for standard admins to trigger a premium upsell in order to opt in
    const triggerUpsellFlow = (0, $eJOHy.useCallback)(()=>{
        setShowPremiumTrialModal(true);
    }, [
        setShowPremiumTrialModal
    ]);
    const aiOptInModal = (0, $eJOHy.useMemo)(()=>{
        const onCloseModal = ()=>setShowOptInModal(false);
        const adminLink = `${(0, $8RHPx.getATLContextUrl)('admin')}/o/${orgId}/atlassian-intelligence`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fgQXu.OptInModal), {
            showOptInModal: showOptInModal,
            isOrgAdmin: isOrgAdmin,
            onCloseModal: onCloseModal,
            adminLink: adminLink
        });
    }, [
        orgId,
        isOrgAdmin,
        showOptInModal
    ]);
    const aiUpsellModal = (0, $eJOHy.useMemo)(()=>{
        const onCloseModal = ()=>setShowPremiumTrialModal(false);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fbqHd.AIUpsellPremiumTrialEntryPointContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fgQXu.OptInUpsellModal), {
            "data-testid": "platform-react-hooks-use-ai-opt-in.upsell-modal",
            showPremiumTrialModal: showPremiumTrialModal,
            onCloseModal: onCloseModal
        }));
    }, [
        showPremiumTrialModal
    ]);
    if ((0, $lopBx.isFedRamp)()) return {
        optInStatus: $b1a6792f3a792a23$var$DISABLED,
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        triggerOptInFlow: ()=>{},
        AIOptInModal: null
    };
    if (isAIUpsellInEditorFreeEnabled) return {
        optInStatus: optInStatus,
        triggerOptInFlow: triggerAIUpsellInEditorFreeFlow,
        AIOptInModal: AIUpsellInEditorFreeModal
    };
    if (optInStatus === $b1a6792f3a792a23$var$DISABLED || optInStatus === $b1a6792f3a792a23$var$ENABLED) return {
        optInStatus: optInStatus,
        triggerOptInFlow: triggerOptInFlow,
        AIOptInModal: null
    };
    if (canStartTrial && optInStatus === $b1a6792f3a792a23$var$DISABLED_OPT_IN) return {
        optInStatus: optInStatus,
        triggerOptInFlow: triggerUpsellFlow,
        AIOptInModal: aiUpsellModal
    };
    return {
        optInStatus: optInStatus,
        triggerOptInFlow: triggerOptInFlow,
        AIOptInModal: aiOptInModal
    };
};

});
parcelRegister("3ASEn", function(module, exports) {

$parcel$export(module.exports, "useAIUpsellInEditorRequirements", () => $7196f41a17032ef3$export$38bfb0ec25eaa6b2);
$parcel$export(module.exports, "useAIUpsellInEditorFree", () => $7196f41a17032ef3$export$beacfd188d344f95);
$parcel$export(module.exports, "AIUpsellButtonWrapper", () => $7196f41a17032ef3$export$c44b9b0347b51c37);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $lopBx = parcelRequire("lopBx");

var $ln6Iy = parcelRequire("ln6Iy");

var $epTsa = parcelRequire("epTsa");

var $dtWnM = parcelRequire("dtWnM");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $a9ldn = parcelRequire("a9ldn");

var $8vyDv = parcelRequire("8vyDv");

var $lUto7 = parcelRequire("lUto7");

var $7jTnu = parcelRequire("7jTnu");

var $8JLU7 = parcelRequire("8JLU7");

var $ecGT4 = parcelRequire("ecGT4");
const $7196f41a17032ef3$var$useGetSupportedProjectType = (product)=>{
    const siteHasOnlyJira = (0, $8JLU7.useSiteHasOnlyJira)();
    switch(product){
        case 'JSW':
            return 0, $ln6Iy.SOFTWARE_PROJECT;
        case 'JSM':
            return 0, $ln6Iy.SERVICE_DESK_PROJECT;
        case 'JWM':
            // If tenant is configured with only JWM and JSW, we can provide an upgrade link for JSW
            return siteHasOnlyJira ? (0, $ln6Iy.SOFTWARE_PROJECT) : undefined;
        case 'JPD':
        default:
            return undefined;
    }
};
const $7196f41a17032ef3$var$useGetSupportedEdition = (product)=>{
    const appEditions = (0, $8vyDv.useAppEditions)();
    const projectType = $7196f41a17032ef3$var$useGetSupportedProjectType(product);
    if (!appEditions) return undefined;
    if (projectType) return (0, $a9ldn.getEditionForProject)(projectType, appEditions);
    return undefined;
};
const $7196f41a17032ef3$export$38bfb0ec25eaa6b2 = (product)=>{
    const isOrgAdmin = (0, $lUto7.useIsSiteAdmin)();
    const supportedEdition = $7196f41a17032ef3$var$useGetSupportedEdition(product);
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [config, fireExperimentExposure] = (0, $epTsa.UNSAFE_noExposureExp)('jira_free_ai_in_editor_v2_experiment');
    const statsigExperimentValue = config.get('cohort', 'not-enrolled');
    const siteMeetsRequirements = // eslint-disable-next-line jira/ff/no-preconditioning
    (0, $7jTnu.fg)('jira_free_ai_in_editor_v2_gate') && supportedEdition === (0, $a9ldn.FREE_EDITION) && isOrgAdmin && !(0, $lopBx.isFedRamp)();
    const experimentValue = siteMeetsRequirements ? statsigExperimentValue : 'not-enrolled';
    const fireExposure = (0, $eJOHy.useCallback)(()=>{
        fireExperimentExposure();
    }, [
        fireExperimentExposure
    ]);
    return {
        siteMeetsRequirements: siteMeetsRequirements,
        experimentValue: experimentValue,
        statsigExperimentValue: statsigExperimentValue,
        fireExperimentExposure: fireExposure
    };
};
const $7196f41a17032ef3$export$beacfd188d344f95 = (optInStatus, product)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [showUpsellModal, setShowUpsellModal] = (0, $eJOHy.useState)(false);
    const { siteMeetsRequirements: siteMeetsRequirements, statsigExperimentValue: statsigExperimentValue, fireExperimentExposure: fireExperimentExposure } = $7196f41a17032ef3$export$38bfb0ec25eaa6b2(product);
    const projectType = $7196f41a17032ef3$var$useGetSupportedProjectType(product);
    const siteMeetsOptInRequirements = siteMeetsRequirements && // optInStatus 'disabled' means they are on control, 'disabled-opt-in' on variation
    optInStatus !== 'enabled';
    const experimentValue = siteMeetsOptInRequirements ? statsigExperimentValue : 'not-enrolled';
    // If the site is not FREE, or not on JSW/JSM, or the user is not billable, they are not enrolled
    const isEnrolledInExperiment = experimentValue !== 'not-enrolled';
    const isExperimentEnabled = isEnrolledInExperiment && experimentValue === 'variation';
    const triggerUpsellFlow = (0, $eJOHy.useCallback)(()=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            action: 'triggerUpsellFlow',
            actionSubject: 'aiUpsellInEditorFree'
        }), 'aiUpsellInEditorFreeTrigger', {});
        setShowUpsellModal(true);
        (0, $ecGT4.setUpsellButtonWrapperClicked)(true);
    }, [
        createAnalyticsEvent
    ]);
    const UpsellModal = (0, $eJOHy.useMemo)(()=>showUpsellModal && projectType ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dtWnM.AsyncAiUpsellInEditorFreeModal), {
            projectType: projectType,
            testId: "platform-react-hooks-use-ai-upsell-in-editor-free.growth-ai-upsell-in-editor-modal",
            onModalClose: ()=>setShowUpsellModal(false)
        }) : null, [
        showUpsellModal,
        projectType
    ]);
    return {
        isEnrolledInExperiment: isEnrolledInExperiment,
        isExperimentEnabled: isExperimentEnabled,
        fireExperimentExposure: fireExperimentExposure,
        triggerUpsellFlow: triggerUpsellFlow,
        UpsellModal: UpsellModal
    };
};
const $7196f41a17032ef3$export$c44b9b0347b51c37 = ({ children: children })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const isClicked = (0, $ecGT4.getUpsellButtonWrapperClicked)();
    const hasFired = (0, $eJOHy.useRef)(false);
    (0, $eJOHy.useEffect)(()=>{
        if (!hasFired.current) {
            (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'button viewed', 'aiUpsellInEditorFreeToolbarButton', {});
            hasFired.current = true;
        }
    }, [
        createAnalyticsEvent
    ]);
    return !isClicked ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7196f41a17032ef3$var$AIUpsellButtonContainer, {
        "data-testid": "platform-react-hooks-use-ai-upsell-in-editor-free.ai-upsell-button-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7196f41a17032ef3$var$AIUpsellButtonInner, null, children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $7196f41a17032ef3$var$AIUpsellButtonContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko44q7 _11q7otc5 _ca0qt94y _u5f3t94y _n3tdt94y _19bvt94y _1e0c116y",
            __cmplp.className
        ])
    });
});
const $7196f41a17032ef3$var$AIUpsellButtonInner = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko1sit _bfhkvuon",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dtWnM", function(module, exports) {

$parcel$export(module.exports, "AsyncAiUpsellInEditorFreeModal", () => $0812a48fe511f837$export$827041a383456a6a);

var $eJOHy = parcelRequire("eJOHy");

var $h47gY = parcelRequire("h47gY");

var $bQWwW = parcelRequire("bQWwW");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $0812a48fe511f837$var$LazyAiUpsellInEditorFreeModal = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("9pFSN")), {
    ssr: false,
    moduleId: "./src/packages/growth/ai-upsell-in-editor-free-modal/src/ui/index.tsx"
});
const $0812a48fe511f837$export$827041a383456a6a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
        id: "asyncAiUpsellInEditorFreeModal",
        packageName: "jira-growth-ai-upsell-in-editor-free-modal",
        teamName: "growth-tako",
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0812a48fe511f837$var$LazyAiUpsellInEditorFreeModal, props));

});
parcelRegister("9pFSN", function(module, exports) {

let $6da6efe2ee0c3778$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $6da6efe2ee0c3778$var$load("ffQaD"),
    $6da6efe2ee0c3778$var$load("kvRbA"),
    $6da6efe2ee0c3778$var$load("1GehQ")
]).then(()=>parcelRequire('2Honi'));

});


parcelRegister("ecGT4", function(module, exports) {

$parcel$export(module.exports, "getUpsellButtonWrapperClicked", () => $bb9787aee3f3a8f5$export$f7d51ee95145148b);
$parcel$export(module.exports, "setUpsellButtonWrapperClicked", () => $bb9787aee3f3a8f5$export$b595420beb43f9ce);

var $dnU6V = parcelRequire("dnU6V");
const $bb9787aee3f3a8f5$export$c2ed3351cac403d1 = (0, $dnU6V.createLocalStorageProvider)('ai-upsell-in-editor-free');
function $bb9787aee3f3a8f5$export$f7d51ee95145148b() {
    return Boolean($bb9787aee3f3a8f5$export$c2ed3351cac403d1.get('upsellButtonWrapperClicked') ?? false);
}
function $bb9787aee3f3a8f5$export$b595420beb43f9ce(value) {
    $bb9787aee3f3a8f5$export$c2ed3351cac403d1.set('upsellButtonWrapperClicked', value);
}

});


parcelRegister("fbqHd", function(module, exports) {

$parcel$export(module.exports, "AIUpsellPremiumTrialEntryPointContext", () => $1d2e3b5497523dc6$export$77aa5ca661b0742c);
$parcel$export(module.exports, "AIUpsellPremiumTrialEntryPointContextProvider", () => $1d2e3b5497523dc6$export$dd0a751f23b19473);

var $eJOHy = parcelRequire("eJOHy");

var $bbdV2 = parcelRequire("bbdV2");

var $kuFbR = parcelRequire("kuFbR");

var $jM5Jy = parcelRequire("jM5Jy");
const $1d2e3b5497523dc6$export$77aa5ca661b0742c = (0, $kuFbR.createUseEntryPointContext)();
const $1d2e3b5497523dc6$export$dd0a751f23b19473 = ({ children: children })=>{
    const entryPointParams = {};
    const entryPointResult = (0, $bbdV2.useEntryPoint)((0, $jM5Jy.entryPointPremiumUpgradeModal), entryPointParams);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1d2e3b5497523dc6$export$77aa5ca661b0742c.Provider, {
        value: entryPointResult
    }, children);
};

});
parcelRegister("kuFbR", function(module, exports) {

$parcel$export(module.exports, "createUseEntryPointContext", () => $38dc9eb5446138c0$export$41bce2223126846b);

var $eJOHy = parcelRequire("eJOHy");
const $38dc9eb5446138c0$export$41bce2223126846b = ()=>/*#__PURE__*/ (0, $eJOHy.createContext)({
        entryPointActions: {
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            cancelPreload () {},
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            load () {},
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            preload () {},
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            unload () {}
        },
        entryPointReferenceSubject: {
            getValue: ()=>null,
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            subscribe: ()=>()=>{}
        },
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        stopMetric () {}
    });

});


parcelRegister("fgQXu", function(module, exports) {

$parcel$export(module.exports, "OptInModal", () => $0bb97ed6f363167b$export$1697f043758ae8d2);
$parcel$export(module.exports, "OptInUpsellModal", () => $0bb97ed6f363167b$export$bbf8d259a508a485);

var $eJOHy = parcelRequire("eJOHy");

var $956it = parcelRequire("956it");

var $aC4Bh = parcelRequire("aC4Bh");

var $fngc1 = parcelRequire("fngc1");

var $cBavF = parcelRequire("cBavF");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $fbqHd = parcelRequire("fbqHd");

var $7be6P = parcelRequire("7be6P");
const $0bb97ed6f363167b$export$1697f043758ae8d2 = ({ showOptInModal: showOptInModal, onCloseModal: onCloseModal, isOrgAdmin: isOrgAdmin, adminLink: adminLink })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $956it.default), null, showOptInModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aC4Bh.JiraModal), {
        messageId: "platform-react-hooks-use-ai-opt-in.ui.modal.ai-modal",
        messageType: "transactional",
        testId: "platform-react-hooks-use-ai-opt-in.ui.ai-modal-test",
        width: "fit-content",
        onClose: onCloseModal
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fngc1.default), {
        source: "jira-editor",
        product: "jira",
        isOrgAdmin: isOrgAdmin,
        onAdminClose: onCloseModal,
        adminLink: adminLink
    })));
const $0bb97ed6f363167b$export$bbf8d259a508a485 = ({ showPremiumTrialModal: showPremiumTrialModal, onCloseModal: onCloseModal })=>{
    const { entryPointReferenceSubject: entryPointReferenceSubject, entryPointActions: entryPointActions } = (0, $eJOHy.useContext)((0, $fbqHd.AIUpsellPremiumTrialEntryPointContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const runtimeProps = (0, $eJOHy.useMemo)(()=>({
            onClose: ()=>{
                entryPointActions.unload();
                const analyticsEvent = createAnalyticsEvent({
                    actionSubject: 'button',
                    action: 'clicked'
                });
                (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'closePremiumTrialModalFromIssueAiUpsell');
            }
        }), [
        entryPointActions,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $956it.default), null, showPremiumTrialModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aC4Bh.JiraModal), {
        messageId: "platform-react-hooks-use-ai-opt-in.ui.modal.ai-premium-trial-modal",
        messageType: "transactional",
        testId: "platform-react-hooks-use-ai-opt-in.ui.ai-premium-trial-modal-test",
        width: "fit-content",
        onClose: onCloseModal
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7be6P.AIOptInPremiumUpsell), {
        onClose: onCloseModal
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "platform-react-hooks-use-ai-opt-in.ui.ai-premium-trial-entry-point-container",
        packageName: "platform-react-hooks-use-ai-opt-in",
        runtimeProps: runtimeProps
    }));
};

});
parcelRegister("fngc1", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcd3db6af4700fb5$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $ftN6c = parcelRequire("ftN6c");

var $5CSKW = parcelRequire("5CSKW");
var $5bY40 = parcelRequire("5bY40");

var $eJ9f5 = parcelRequire("eJ9f5");

var $eGOwo = parcelRequire("eGOwo");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $6jnGA = parcelRequire("6jnGA");


var $h2Ydy = parcelRequire("h2Ydy");

var $cIFVp = parcelRequire("cIFVp");
const $bcd3db6af4700fb5$var$VisibleTextOrgAdminStyles = (0, $1DXK0.xcss)({
    color: 'color.text.subtlest',
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $bcd3db6af4700fb5$var$AiOptIn = ({ source: source, product: product, isOrgAdmin: isOrgAdmin, image: image, headerText: headerText, bodyText: bodyText, width: width, testId: testId, onAdminCTA: onAdminCTA, onAdminClose: onAdminClose, adminBodyText: adminBodyText, adminHeaderText: adminHeaderText, adminCTAText: adminCTAText, adminCloseCTAText: adminCloseCTAText, adminLink: adminLink, onRender: onRender })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        if (onRender) onRender();
    }, [
        onRender
    ]);
    const onLearnMoreClicked = (e)=>{
        e.stopPropagation();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: source,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'aiGlobalOptInDialogLearnMoreLink',
                attributes: {
                    product: product,
                    isOrgAdmin: !!isOrgAdmin
                },
                tags: [
                    'fabricElements'
                ]
            }
        }).fire();
    };
    const formatMessageValues = {
        a: (s)=>(0, $eGOwo.fg)('dst-a11y__replace-anchor-with-link__confluence-ai') ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJ9f5.default), {
                href: (0, $5aabc7165c5dc496$export$550fac1a4ec3d365),
                target: "_blank",
                onClick: onLearnMoreClicked,
                children: s
            }) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
            /*#__PURE__*/ (0, $gt9Am.jsx)("a", {
                href: (0, $5aabc7165c5dc496$export$550fac1a4ec3d365),
                target: "_blank",
                onClick: onLearnMoreClicked,
                children: s
            }),
        br: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)("br", {})
    };
    const defaultHeader = formatMessage((0, $h2Ydy.messages).aiOptInDialogHeaderText);
    const header = headerText ?? defaultHeader;
    const body = bodyText ?? formatMessage((0, $h2Ydy.messages).aiOptInDialogBodyText, formatMessageValues);
    const orgAdminBody = adminBodyText ?? formatMessage((0, $h2Ydy.messages).aiOptInDialogAdminBodyText, formatMessageValues);
    const orgAdminHeader = adminHeaderText ?? defaultHeader;
    (0, $eJOHy.useEffect)(()=>{
        const preloadImages = (paths)=>{
            paths.forEach((path)=>{
                const img = new Image();
                img.src = path;
            });
        };
        preloadImages([
            (0, (/*@__PURE__*/$parcel$interopDefault($6jnGA)))
        ]);
    }, []);
    (0, $eJOHy.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'aiGlobalOptInDialog',
                attributes: {
                    source: source,
                    product: product,
                    isOrgAdmin: !!isOrgAdmin
                },
                tags: [
                    'fabricElements'
                ]
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        source,
        product,
        isOrgAdmin
    ]);
    const onCloseClicked = (e)=>{
        e.stopPropagation();
        onAdminClose?.();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: source,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'aiGlobalOptInDialogAdminCloseButton',
                attributes: {
                    product: product
                },
                tags: [
                    'fabricElements'
                ]
            }
        }).fire();
    };
    const onCTAClicked = (e)=>{
        e.stopPropagation();
        onAdminCTA?.();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: source,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'aiGlobalOptInDialogAdminCTAButton',
                attributes: {
                    product: product
                },
                tags: [
                    'fabricElements'
                ]
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cIFVp.OptInBackgroundBorder), {
        width: width,
        "data-testid": testId,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $cIFVp.OptInContainer), {
            children: [
                image ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cIFVp.ImageWrapper), {
                    children: image
                }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cIFVp.ImageWrapper), {
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($6jnGA))),
                        height: "96px",
                        alt: ""
                    })
                }),
                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $cIFVp.ContentContainer), {
                    children: [
                        isOrgAdmin && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
                            xcss: $bcd3db6af4700fb5$var$VisibleTextOrgAdminStyles,
                            children: formatMessage((0, $h2Ydy.messages).aiOptInAdminOnlyVisible)
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cIFVp.HeaderWrapper), {
                            children: isOrgAdmin ? orgAdminHeader : header
                        }),
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, $cIFVp.BodyWrapper), {
                            "data-testid": "dialog-body-text",
                            children: isOrgAdmin ? orgAdminBody : body
                        }),
                        isOrgAdmin && /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $cIFVp.ButtonContainer), {
                            children: [
                                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5CSKW.default), {
                                    appearance: "subtle",
                                    onClick: onCloseClicked,
                                    testId: "admin-close-button",
                                    children: adminCloseCTAText ?? formatMessage((0, $h2Ydy.messages).aiOptInDialogAdminMaybeLaterButtonText)
                                }),
                                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5bY40.default), {
                                    appearance: "primary",
                                    onClick: onCTAClicked,
                                    href: adminLink ?? (0, $5aabc7165c5dc496$export$bae9a077d7ed5dfe),
                                    target: "_blank",
                                    testId: "admin-cta-button",
                                    children: adminCTAText ?? formatMessage((0, $h2Ydy.messages).aiOptInDialogAdminGetStartedButtonText)
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var $bcd3db6af4700fb5$export$2e2bcd8739ae039 = $bcd3db6af4700fb5$var$AiOptIn;

});
parcelRegister("6jnGA", function(module, exports) {
module.exports = new URL("global-opt-in-default-image-banner.8c1c680b.svg", import.meta.url).toString();

});

const $5aabc7165c5dc496$export$550fac1a4ec3d365 = 'https://support.atlassian.com/organization-administration/docs/understand-atlassian-intelligence-features-in-products';
const $5aabc7165c5dc496$export$bae9a077d7ed5dfe = 'http://admin.atlassian.com/';

parcelRegister("h2Ydy", function(module, exports) {

$parcel$export(module.exports, "messages", () => $86dbc07a09ec6326$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $86dbc07a09ec6326$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    /**
	 * Messages for the AI Global Opt-in component
	 */ aiOptInDialogHeaderText: {
        id: 'ai-opt-in.dialog.header.text',
        defaultMessage: 'Work smarter, not harder',
        description: 'Header text for AI Opt In Dialog'
    },
    aiOptInDialogBodyText: {
        id: 'ai-opt-in.dialog.body.text',
        defaultMessage: `Get up to speed quickly and consume information with ease using <a>Atlassian Intelligence</a> (Al). <br></br><br></br> Interested in trying Atlassian Intelligence? Your admin can activate AI features from Atlassian Administration.`,
        description: 'Body text for AI Opt In Dialog'
    },
    aiOptInDialogLearnMoreLinkText: {
        id: 'ai-opt-in.dialog.learn-more.link.text',
        defaultMessage: 'Learn more about Atlassian Intelligence',
        description: 'Learn more link text for AI Opt In Dialog'
    },
    aiOptInDialogAdminBodyText: {
        id: 'ai-opt-in.dialog.admin.body.text',
        defaultMessage: 'Get your team up to speed quickly and consume information with ease using <a>Atlassian Intelligence</a> (Al). <br></br><br></br> Activate Atlassian Intelligence features for your users from Atlassian Administration.',
        description: 'Body text for Admin version of AI Opt In Dialog'
    },
    aiOptInDialogAdminMaybeLaterButtonText: {
        id: 'ai-opt-in.dialog.admin.maybe-later.button.text',
        defaultMessage: 'Maybe later',
        description: 'Admin maybe later button text'
    },
    aiOptInDialogAdminGetStartedButtonText: {
        id: 'ai-opt-in.dialog.admin.get-started.button.text',
        defaultMessage: 'Get started',
        description: 'Admin get started button text'
    },
    aiOptInBannerBodyText: {
        id: 'ai-opt-in.banner.body.text',
        defaultMessage: "Work smarter, not harder. Express your interest in Atlassian Intelligence so your admin knows you\u2019d like them to activate it.",
        description: 'Body text for Banner version of AI Opt In Dialog'
    },
    aiOptInBannerLearnMoreText: {
        id: 'ai-opt-in.banner.learn.more.text',
        defaultMessage: 'Learn more',
        description: 'Learn more text for Banner cta of AI Opt In Dialog'
    },
    aiOptInAdminBannerBodyText: {
        id: 'ai-opt-in.banner.admin.body.text',
        defaultMessage: 'Get everyone up to speed quickly and consume information with ease. Turn on <a>Atlassian Intelligence</a> features for your users from Atlassian Administration.',
        description: 'Body text for Admin version of the Banner Ai Opt In'
    },
    aiOptInAdminOnlyVisible: {
        id: 'ai-opt-in.admin.only.visible.text',
        defaultMessage: 'This message is only visible to org admins.',
        description: 'Text message to let org admins know that the content is only visible to them.'
    }
});

});

parcelRegister("cIFVp", function(module, exports) {

$parcel$export(module.exports, "OptInBackgroundBorder", () => $122c37063a2809af$export$24c280970213bb11);
$parcel$export(module.exports, "OptInContainer", () => $122c37063a2809af$export$a0fab83bea8ccf2e);
$parcel$export(module.exports, "ImageWrapper", () => $122c37063a2809af$export$75f07c36086c2c81);
$parcel$export(module.exports, "ContentContainer", () => $122c37063a2809af$export$9d2b4227a95687cc);
$parcel$export(module.exports, "HeaderWrapper", () => $122c37063a2809af$export$960a49cc3d27a090);
$parcel$export(module.exports, "BodyWrapper", () => $122c37063a2809af$export$14966827497f4695);
$parcel$export(module.exports, "ButtonContainer", () => $122c37063a2809af$export$eddf54ea3db8d0f0);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");
const $122c37063a2809af$export$24c280970213bb11 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1vcp0mh": (0, $awdRS.default)(__cmplp.width, "px")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _2rko14y2 _11q71lxv _16qs1o46 _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o _kqswh2mm",
            __cmplp.width ? "_1bsb1efm" : "_1bsbkbql",
            __cmplp.className
        ])
    });
});
const $122c37063a2809af$export$a0fab83bea8ccf2e = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko1l7b _1e0c1txw _2lx21bp4 _bfhk1bhr",
            __cmplp.className
        ])
    });
});
const $122c37063a2809af$export$75f07c36086c2c81 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko1k7a _1e0c1txw _1biu1k7a _1jpx1dfr _mezj1osq",
            __cmplp.className
        ])
    });
});
const $122c37063a2809af$export$9d2b4227a95687cc = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_zulpu2gc _1e0c1txw _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb _2lx21bp4 _1wpz1fhb _4cvr1y6m",
            __cmplp.className
        ])
    });
});
const $122c37063a2809af$export$960a49cc3d27a090 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c8nbxd",
            __cmplp.className
        ])
    });
});
const $122c37063a2809af$export$14966827497f4695 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _11c82smr",
            __cmplp.className
        ])
    });
});
const $122c37063a2809af$export$eddf54ea3db8d0f0 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_zulp1b66 _1e0c1txw _1bsb1osq _19pku2gc _1bahesu3",
            __cmplp.className
        ])
    });
});

});


parcelRegister("7be6P", function(module, exports) {

$parcel$export(module.exports, "AIOptInPremiumUpsell", () => $ee2053d68bec851c$export$54e4ba490d2c6bb5);

var $eJOHy = parcelRequire("eJOHy");

var $Ay1uj = parcelRequire("Ay1uj");

var $806LH = parcelRequire("806LH");

var $5wxTT = parcelRequire("5wxTT");

var $bzmGg = parcelRequire("bzmGg");
var $8nu6j = parcelRequire("8nu6j");
var $3Wh6p = parcelRequire("3Wh6p");
var $dW738 = parcelRequire("dW738");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $gaoa9 = parcelRequire("gaoa9");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $40abG = parcelRequire("40abG");

var $ebJ4i = parcelRequire("ebJ4i");
const $ee2053d68bec851c$export$54e4ba490d2c6bb5 = ({ onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            actionSubject: 'screen',
            action: 'viewed'
        });
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'IssueAiUpsellDialog');
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $ee2053d68bec851c$var$containerBorderStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        alignBlock: "stretch",
        xcss: $ee2053d68bec851c$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        alignInline: "end",
        grow: "fill",
        xcss: $ee2053d68bec851c$var$headerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
        appearance: "subtle",
        onClick: onClose,
        label: formatMessage((0, $40abG.messages).closeModal),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5wxTT)))
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bzmGg.default), {
        all: "space.025"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gaoa9.default), {
        alt: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        alignInline: "stretch",
        space: "space.200",
        xcss: $ee2053d68bec851c$var$textContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "medium",
        as: "h2"
    }, formatMessage((0, $40abG.messages).title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        as: "p"
    }, formatMessage((0, $40abG.messages).body)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        alignInline: "end",
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ebJ4i.StartPremiumTrialButton), {
        onCloseParent: onClose
    })))));
};
const $ee2053d68bec851c$var$containerBorderStyles = (0, $1DXK0.xcss)({
    overflow: 'hidden',
    boxShadow: 'elevation.shadow.overlay',
    borderRadius: 'border.radius',
    width: '438px',
    position: 'relative',
    padding: 'space.025',
    background: `linear-gradient(
      112.4deg,
      ${"var(--ds-background-accent-blue-subtle, #579DFF)"} 0%,
      ${"var(--ds-background-accent-purple-subtle, #9F8FEF)"} 100%
    )`
});
const $ee2053d68bec851c$var$containerStyles = (0, $1DXK0.xcss)({
    borderRadius: 'border.radius',
    backgroundColor: 'elevation.surface.overlay',
    overflow: 'hidden'
});
const $ee2053d68bec851c$var$headerStyles = (0, $1DXK0.xcss)({
    position: 'absolute',
    padding: 'space.075',
    right: 'space.025'
});
const $ee2053d68bec851c$var$textContainerStyles = (0, $1DXK0.xcss)({
    padding: 'space.300'
});

});
parcelRegister("5wxTT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::53b9d7f39d5a7786fd5c4592782d4f82>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $405a3cd7d6c6872a$var$_react = $405a3cd7d6c6872a$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $405a3cd7d6c6872a$var$_cross = $405a3cd7d6c6872a$var$_interopRequireDefault((parcelRequire("6zhpo")));

var $405a3cd7d6c6872a$var$_close = $405a3cd7d6c6872a$var$_interopRequireDefault((parcelRequire("6OLN4")));
function $405a3cd7d6c6872a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CrossIcon.
 * This component is CrossIcon, with `UNSAFE_fallbackIcon` set to "EditorCloseIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $405a3cd7d6c6872a$var$CrossIcon = (props)=>/*#__PURE__*/ $405a3cd7d6c6872a$var$_react.default.createElement($405a3cd7d6c6872a$var$_cross.default, Object.assign({
        LEGACY_fallbackIcon: $405a3cd7d6c6872a$var$_close.default
    }, props));
$405a3cd7d6c6872a$var$CrossIcon.Name = 'CrossIconMigration';
var $405a3cd7d6c6872a$var$_default = module.exports.default = $405a3cd7d6c6872a$var$CrossIcon;

});
parcelRegister("6OLN4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4f6c7bc606f2d15e$var$_react = $4f6c7bc606f2d15e$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $4f6c7bc606f2d15e$var$_cross = $4f6c7bc606f2d15e$var$_interopRequireDefault((parcelRequire("6zhpo")));
function $4f6c7bc606f2d15e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4f6c7bc606f2d15e$var$EditorCloseIcon = (props)=>/*#__PURE__*/ $4f6c7bc606f2d15e$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m15.185 7.4-3.184 3.185-3.186-3.186a.507.507 0 0 0-.712.003l-.7.701a.496.496 0 0 0-.004.712l3.185 3.184L7.4 15.185a.507.507 0 0 0 .004.712l.7.7c.206.207.516.2.712.004l3.186-3.185 3.184 3.185a.507.507 0 0 0 .712-.004l.701-.7a.496.496 0 0 0 .003-.712l-3.186-3.186 3.186-3.184a.507.507 0 0 0-.003-.712l-.7-.7a.5.5 0 0 0-.36-.153.5.5 0 0 0-.353.15"/></svg>`
    }, props, {
        newIcon: $4f6c7bc606f2d15e$var$_cross.default
    }));
$4f6c7bc606f2d15e$var$EditorCloseIcon.displayName = 'EditorCloseIcon';
var $4f6c7bc606f2d15e$var$_default = module.exports.default = $4f6c7bc606f2d15e$var$EditorCloseIcon;

});


parcelRegister("gaoa9", function(module, exports) {

$parcel$export(module.exports, "default", () => $92f54c550714c7bd$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

var $c4huj = parcelRequire("c4huj");

var $ff2g7 = parcelRequire("ff2g7");

var $1dpos = parcelRequire("1dpos");
const $92f54c550714c7bd$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($1dpos)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($ff2g7))
});
var $92f54c550714c7bd$export$2e2bcd8739ae039 = $92f54c550714c7bd$var$Illustration;
// for advanced use only
const $92f54c550714c7bd$export$a179c88182cb9d56 = [
    0,
    0,
    438,
    96
];

});
parcelRegister("ff2g7", function(module, exports) {
module.exports = new URL("ai-chat-loading-promoted-darkmode.f2ea2011.svg", import.meta.url).toString();

});

parcelRegister("1dpos", function(module, exports) {
module.exports = new URL("ai-chat-loading-promoted.9a9a0213.svg", import.meta.url).toString();

});


parcelRegister("40abG", function(module, exports) {

$parcel$export(module.exports, "messages", () => $625df7e329ab5e65$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $625df7e329ab5e65$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    title: {
        "id": "platform-react-hooks-use-ai-opt-in.ai-opt-in-premium-upsell-modal.title",
        "defaultMessage": "Write better, work faster with Atlassian Intelligence"
    },
    body: {
        "id": "platform-react-hooks-use-ai-opt-in.ai-opt-in-premium-upsell-modal.body",
        "defaultMessage": "Use AI to brainstorm, summarize, change tone, edit and more, with Jira Premium."
    },
    closeModal: {
        "id": "platform-react-hooks-use-ai-opt-in.ai-opt-in-premium-upsell-modal.close-modal",
        "defaultMessage": "Close Modal"
    },
    tryItFreeButton: {
        "id": "platform-react-hooks-use-ai-opt-in.ai-opt-in-premium-upsell-modal.try-it-free-button",
        "defaultMessage": "Try it free"
    }
});

});

parcelRegister("ebJ4i", function(module, exports) {

$parcel$export(module.exports, "StartPremiumTrialButton", () => $d15a51af21f846e9$export$a2651a739f515dd4);

var $eJOHy = parcelRequire("eJOHy");

var $abjs4 = parcelRequire("abjs4");

var $kMmgw = parcelRequire("kMmgw");

var $4fzUT = parcelRequire("4fzUT");

var $ciFJV = parcelRequire("ciFJV");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $7jTnu = parcelRequire("7jTnu");

var $fbqHd = parcelRequire("fbqHd");

var $40abG = parcelRequire("40abG");
const $d15a51af21f846e9$export$a2651a739f515dd4 = ({ onCloseParent: onCloseParent })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { entryPointActions: entryPointActions } = (0, $eJOHy.useContext)((0, $fbqHd.AIUpsellPremiumTrialEntryPointContext));
    const triggerRef = (0, $ciFJV.useEntryPointButtonTrigger)(entryPointActions);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const onClickAnalytics = (0, $eJOHy.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            actionSubject: 'button',
            action: 'clicked'
        });
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'openPremiumTrialModalFromIssueAiUpsell');
    }, [
        createAnalyticsEvent
    ]);
    const onClick = ()=>{
        // Nb. premium trial modal open is handled by entry point via ref
        onCloseParent && onCloseParent();
        onClickAnalytics();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $abjs4.default), {
        onClick: onClick,
        ref: triggerRef,
        iconBefore: (0, $7jTnu.fg)('issue-view-sparkle-icon-replacement-fg') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fzUT))), {
            label: "",
            color: "var(--ds-text-inverse, #FFFFFF)"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kMmgw))), {
            LEGACY_size: "small",
            label: "",
            color: "var(--ds-text-inverse, #FFFFFF)"
        }),
        theme: (current, themeProps)=>({
                buttonStyles: {
                    ...current(themeProps).buttonStyles,
                    display: 'flex',
                    alignItems: 'center',
                    background: `linear-gradient(135deg, ${"var(--ds-background-discovery-bold, #6E5DC6)"}, ${"var(--ds-background-brand-bold, #0C66E4)"})`,
                    color: "var(--ds-text-inverse, #FFFFFF)",
                    outline: 'none',
                    boxSizing: 'border-box',
                    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-150, 12px)"}`,
                    borderRadius: "var(--ds-space-050, 4px)",
                    height: "var(--ds-space-400, 32px)",
                    border: 'none',
                    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
                    gap: "var(--ds-space-025, 2px)"
                },
                spinnerStyles: current(themeProps).spinnerStyles
            })
    }, formatMessage((0, $40abG.messages).tryItFreeButton));
};

});




parcelRegister("jrvsa", function(module, exports) {

$parcel$export(module.exports, "default", () => $97b6c96c8993cedc$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $97b6c96c8993cedc$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    feedBackTitle: {
        "id": "platform-utils-shared-editor-config.feed-back-title",
        "defaultMessage": "Help us make Atlassian Intelligence even better"
    },
    summaryPlaceholder: {
        "id": "platform-utils-shared-editor-config.summary-placeholder",
        "defaultMessage": "Let us know what you were trying to do and how it could be better"
    },
    userConsentCheckboxLabel: {
        "id": "platform-utils-shared-editor-config.user-consent-checkbox-label",
        "defaultMessage": "Include my last prompt and response in the feedback."
    },
    canContactText: {
        "id": "platform-utils-shared-editor-config.can-contact-text",
        "defaultMessage": "Atlassian can contact me about this feedback. See our <a>privacy policy</a>."
    },
    improveAtlassianText: {
        "id": "platform-utils-shared-editor-config.improve-atlassian-text",
        "defaultMessage": "I\u2019d like to help improve Atlassian products by joining the <a>Atlassian Research Group</a>."
    }
});

});

parcelRegister("LUGny", function(module, exports) {

$parcel$export(module.exports, "Product", () => $3ae4aaa04069ce2c$export$264ad599d7cef668);
// TODO: go/restrict-enums
var $3ae4aaa04069ce2c$export$264ad599d7cef668 = /*#__PURE__*/ function(Product) {
    Product["JSW"] = "JSW";
    Product["JWM"] = "JWM";
    Product["JSM"] = "JSM";
    Product["JPD"] = "JPD";
    return Product;
}({});

});


parcelRegister("egdl2", function(module, exports) {

$parcel$export(module.exports, "useLinkPickerEditorProps", () => $feb491738438937d$export$5057fa778edd8de9);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
parcelRequire("bn7wb");
var $aAuez = parcelRequire("aAuez");

const $feb491738438937d$var$LazyEditorLinkPickerRootComponentWithPlugins = (0, $aAuez.lazyForPaint)(()=>(parcelRequire("iWokl")));
const $feb491738438937d$var$DUMMY_PLUGIN_KEY = '__dummy_plugin__';
const $feb491738438937d$var$PLACEHOLDER_PLUGINS = [
    {
        tabKey: $feb491738438937d$var$DUMMY_PLUGIN_KEY,
        tabTitle: 'DUMMY_PLUGIN',
        resolve: ()=>Promise.resolve({
                data: []
            })
    }
];
const $feb491738438937d$export$5057fa778edd8de9 = (/**
	 * Baseline set of props to provide to the link picker
	 */ props, /**
	 * The configuration used to control what plugins/tabs are available
	 * MUST be known on the first render as it is used to dynamically create the plugins and
	 * Editor is not yet reactive to changes in the resulting plugins
	 */ config)=>{
    // TODO: When editor reactivity is fixed,
    // replace the below with useLinkPickerPlugins
    const WrapperComponent = (0, $eJOHy.useMemo)(()=>(props)=>{
            return /*#__PURE__*/ (0, $gt9Am.jsx)($feb491738438937d$var$LazyEditorLinkPickerRootComponentWithPlugins, {
                ...props,
                config: config
            });
        }, [
        config
    ]);
    return (0, $eJOHy.useMemo)(()=>{
        return {
            ...props ?? {},
            // We are providing an array of placeholder plugins
            // otherwise editor will not position the link picker correctly
            plugins: $feb491738438937d$var$PLACEHOLDER_PLUGINS,
            component: WrapperComponent
        };
    }, [
        WrapperComponent,
        props
    ]);
};

});
parcelRegister("iWokl", function(module, exports) {

let $dca083a5ac9aac19$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $dca083a5ac9aac19$var$load("98X5w").then(()=>parcelRequire('8EMyi'));

});


parcelRegister("5D4DO", function(module, exports) {

$parcel$export(module.exports, "useExtractedLinksRef", () => $86ecc7ab5cadc949$export$1f0d7afe7a287b86);

var $eJOHy = parcelRequire("eJOHy");
function $86ecc7ab5cadc949$export$ec4773b7113b75c1(adf) {
    const linksSet = new Set();
    function traverse(content) {
        if (Array.isArray(content)) for (const item of content){
            if (!item) continue;
            switch(item.type){
                case 'link':
                    if (item.attrs?.href) linksSet.add(item.attrs.href);
                    break;
                case 'blockCard':
                case 'inlineCard':
                case 'embedCard':
                    if (item.attrs?.url) linksSet.add(item.attrs.url);
                    break;
                default:
                    // If the item has a 'content' property, recursively traverse it
                    if (item.content) traverse(item.content);
                    // If the item has a 'marks' property, recursively traverse it
                    if (item.marks) traverse(item.marks);
            }
        }
    }
    if (adf.content) traverse(adf.content);
    return Array.from(linksSet);
}
function $86ecc7ab5cadc949$export$1f0d7afe7a287b86(content) {
    const ref = (0, $eJOHy.useRef)(()=>[]);
    (0, $eJOHy.useEffect)(()=>{
        if (typeof content === 'object') ref.current = ()=>$86ecc7ab5cadc949$export$ec4773b7113b75c1(content);
    }, [
        content
    ]);
    return ref;
}

});

parcelRegister("dNlYM", function(module, exports) {

$parcel$export(module.exports, "AsyncAiProactiveDescriptionCompleter", () => $797640e97726d836$export$f6d606145e3602e);

var $eJOHy = parcelRequire("eJOHy");

var $cBavF = parcelRequire("cBavF");

var $bbdV2 = parcelRequire("bbdV2");

var $5d99b = parcelRequire("5d99b");
const $797640e97726d836$var$entrypointParams = {};
const $797640e97726d836$export$f6d606145e3602e = (props)=>{
    const { editorApi: editorApi, editorExperience: editorExperience, projectType: projectType, issueType: issueType, issueSummary: issueSummary, issueDescription: issueDescription, didUserPaste: didUserPaste } = props;
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $5d99b.aiProactiveDescriptionCompleterEntryPoint), $797640e97726d836$var$entrypointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eJOHy.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    const runtimeProps = (0, $eJOHy.useMemo)(()=>({
            editorApi: editorApi,
            editorExperience: editorExperience,
            projectType: projectType,
            issueType: issueType,
            issueSummary: issueSummary,
            issueDescription: issueDescription,
            didUserPaste: didUserPaste
        }), [
        editorApi,
        editorExperience,
        issueDescription,
        issueSummary,
        issueType,
        projectType,
        didUserPaste
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "jiraAiProactiveDescriptionCompleterEntryPoint",
        packageName: "jira-ai-proactive-description-completer",
        teamName: "crocs",
        fallback: null,
        runtimeProps: runtimeProps
    });
};

});
parcelRegister("5d99b", function(module, exports) {

$parcel$export(module.exports, "aiProactiveDescriptionCompleterEntryPoint", () => $13866d5adebb7ee7$export$1c09555363edf305);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $13866d5adebb7ee7$export$1c09555363edf305 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("4iCNW")).then((module)=>module.AiProactiveDescriptionCompleterEntryPointComponent), {
        moduleId: "64fe74ed",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("4iCNW", function(module, exports) {

let $3216f1a3509b3182$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $3216f1a3509b3182$var$load("8LYwg").then(()=>parcelRequire('6VH3V'));

});



parcelRegister("7OfzM", function(module, exports) {

$parcel$export(module.exports, "sanitizeADFField", () => $3f60b6aa7c8450ca$export$28941b736a01da7b);
$parcel$export(module.exports, "mutateADFField", () => $3f60b6aa7c8450ca$export$82a40b3982cf31c4);
$parcel$export(module.exports, "validateDescriptionField", () => $3f60b6aa7c8450ca$export$78b1417f15a51a4f);

var $jFHCE = parcelRequire("jFHCE");

var $clRM1 = parcelRequire("clRM1");

var $eDBhy = parcelRequire("eDBhy");

var $3UrQk = parcelRequire("3UrQk");

const $3f60b6aa7c8450ca$var$emptyADFString = JSON.stringify((0, $clRM1.getEmptyADF)());
const $3f60b6aa7c8450ca$export$28941b736a01da7b = (adfValue)=>{
    // @ts-expect-error extra properties are not a part of ADF
    if (adfValue?.overrideRequired || adfValue?.resetRequired) (0, $eDBhy.fireIssueCreateErrorAnalytics)({
        meta: {
            id: 'adfObjectTypeErrorIssueCreate',
            packageName: 'jiraIssueCreateModal',
            teamName: 'gryffindor'
        },
        sendToPrivacyUnsafeSplunk: true
    });
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const sanitizedValue = (0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(adfValue, [
        'overrideRequired',
        'resetRequired'
    ]);
    return sanitizedValue;
};
const $3f60b6aa7c8450ca$export$82a40b3982cf31c4 = (adfValue, fieldId)=>{
    // stringify to compare with emptyADF
    const adfValueString = JSON.stringify(adfValue);
    // emptyADF is special case where input retention should not happen
    return $3f60b6aa7c8450ca$var$emptyADFString === adfValueString ? null : {
        fieldId: fieldId,
        mutationGroup: (0, $b77472367406a978$export$31fd86f8f183952c),
        richText: {
            adfValue: adfValue
        }
    };
};
const $3f60b6aa7c8450ca$export$78b1417f15a51a4f = (adfValue, isRequired)=>{
    if (!isRequired) return undefined;
    const isAdfEmptyOrUndefined = !adfValue || JSON.stringify(adfValue) === JSON.stringify((0, $clRM1.getEmptyADF)());
    if (isAdfEmptyOrUndefined) return 0, $3UrQk.REQUIRED;
    const hardBreakNodeType = 'hardBreak';
    // Users can bypass the required field validation for the description field by pressing shift + enter. shift + enter creates a 'hardBreak' block inside the value. If only hardBreaks exist then treat the description field as empty
    let isAnythingThereApartFromHardBreaks = false;
    if (adfValue?.content?.length > 0) for(let i = 0; i < adfValue.content.length; i += 1){
        const block = adfValue.content[i];
        // @ts-expect-error - TS2339 - Property 'content' does not exist on type 'BlockContent | LayoutSectionDefinition | CodeBlockWithMarksDefinition | ExpandWithBreakoutDefinition | ParagraphWithIndentationDefinition'.
        const blockContent = block.content;
        isAnythingThereApartFromHardBreaks = blockContent?.some(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (blockItem)=>blockItem.type !== hardBreakNodeType);
        if (isAnythingThereApartFromHardBreaks) break;
    }
    if (isAnythingThereApartFromHardBreaks) return undefined;
    return 0, $3UrQk.REQUIRED;
};

});
const $b77472367406a978$export$31fd86f8f183952c = 'richTextFields';


parcelRegister("hZyII", function(module, exports) {

$parcel$export(module.exports, "messages", () => $8b48523355dd3da3$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $8b48523355dd3da3$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    placeholder: {
        "id": "issue-create.common.fields.description-field.placeholder",
        "defaultMessage": "Paste a Confluence link here, and we can help generate the description from the page\u2019s contents."
    }
});

});


parcelRegister("h2Cf3", function(module, exports) {

$parcel$export(module.exports, "EpicLinkField", () => $a63ba93a9ca9e4e5$export$7929a33274a9f9f);

var $eJOHy = parcelRequire("eJOHy");

var $aS1GU = parcelRequire("aS1GU");
const $a63ba93a9ca9e4e5$export$7929a33274a9f9f = (props)=>{
    const { useFormContext: useFormContext, ...commonEpicLinkFieldProps } = props;
    // eslint-disable-next-line react-hooks/react-compiler
    const [, { setIsEpicLinkSelected: setIsEpicLinkSelected }] = useFormContext();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aS1GU.default), {
        ...commonEpicLinkFieldProps,
        setIsEpicLinkSelected: setIsEpicLinkSelected
    });
};

});
parcelRegister("aS1GU", function(module, exports) {

$parcel$export(module.exports, "default", () => $10ef0222235561a3$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $b3D89 = parcelRequire("b3D89");

var $fE4zR = parcelRequire("fE4zR");

var $2nXHu = parcelRequire("2nXHu");

var $cDYPA = parcelRequire("cDYPA");

const $10ef0222235561a3$export$7929a33274a9f9f = (props)=>{
    const { width: width } = props;
    // We are disabling the Epic Link and Parent Link fields for taking input and instead displaying that the user should
    // use the Parent field to set the Parent of the issue as part of migrating to a single way of representing Jira's hierarchy.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fE4zR.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b3D89.DisabledEpicLinkParentLinkField), null));
};
var $10ef0222235561a3$export$2e2bcd8739ae039 = (0, $2nXHu.withFormField)({
    transformDefaultValue: (0, $cDYPA.transformDefaultEpicValue)
})($10ef0222235561a3$export$7929a33274a9f9f);

});
parcelRegister("b3D89", function(module, exports) {

$parcel$export(module.exports, "DisabledEpicLinkParentLinkField", () => $88191641cfd1c65b$export$eb9d1bb510274e3);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $3cMgR = parcelRequire("3cMgR");

var $kDaaB = parcelRequire("kDaaB");

var $dPniZ = parcelRequire("dPniZ");
const $88191641cfd1c65b$export$eb9d1bb510274e3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($88191641cfd1c65b$var$DisabledEpicLinkParentLinkFieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), {
        ...(0, $dPniZ.default).replacedByParentField,
        values: {
            strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
                    as: "strong"
                }, chunks)
        }
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $88191641cfd1c65b$var$DisabledEpicLinkParentLinkFieldWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_o5721jtm _syaz131l",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dPniZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0080ec325b105cbd$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $0080ec325b105cbd$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    replacedByParentField: {
        "id": "issue-create-commons.common.fields.epic-link-parent-link-disabled.replaced-by-parent-field",
        "defaultMessage": "Replaced by <strong>Parent</strong> field"
    }
});

});




parcelRegister("eQSWD", function(module, exports) {

$parcel$export(module.exports, "default", () => $65eb2fa1f16146ac$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $iHPvF = parcelRequire("iHPvF");

var $epTsa = parcelRequire("epTsa");

var $lRq8t = parcelRequire("lRq8t");

var $coifs = parcelRequire("coifs");

var $fE4zR = parcelRequire("fE4zR");

var $2nXHu = parcelRequire("2nXHu");

var $ixdDB = parcelRequire("ixdDB");

var $cIXG9 = parcelRequire("cIXG9");

var $kDlLr = parcelRequire("kDlLr");
const $65eb2fa1f16146ac$var$IssueRestrictionField = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { fieldProps: { value: value = [], onChange: onChange, ...fieldProps }, selectedProject: selectedProject, error: error, autoFocus: autoFocus = false, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, $ixdDB.closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, isMini: isMini, description: description, fieldName: fieldName, width: width, ariaLabelledBy: ariaLabelledBy } = props;
    const [shouldShowAccessWarning, setAccessWarningDisplay] = (0, $eJOHy.useState)(false);
    const convertToFieldType = (roles)=>{
        onChange(roles.map(({ roleId: roleId })=>({
                roleId: roleId
            })));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fE4zR.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cIXG9.RolePickerEdit), {
        ...fieldProps,
        selectedProjectId: selectedProject?.value || '',
        selectedRoles: value,
        onChange: convertToFieldType,
        autoFocus: autoFocus,
        isDisabled: false,
        classNamePrefix: "issue-restriction-select",
        isInvalid: Boolean(error),
        isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
        onCloseMenuOnScroll: onCloseMenuOnScroll,
        setAccessWarningDisplay: setAccessWarningDisplay,
        "aria-labelledby": ariaLabelledBy
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $coifs.FieldMessage), {
        description: description,
        error: error,
        fieldName: fieldName,
        isMini: isMini
    }), shouldShowAccessWarning ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $65eb2fa1f16146ac$var$messageContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iHPvF.default), {
        appearance: "warning"
    }, formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $kDlLr.default).noAccessOnIssueCreatedWarningIssueTermRefresh : (0, $kDlLr.default).noAccessOnIssueCreatedWarning))) : null);
};
var $65eb2fa1f16146ac$export$2e2bcd8739ae039 = (0, $2nXHu.withFormField)({
    shouldRenderFieldMessage: false
})($65eb2fa1f16146ac$var$IssueRestrictionField);
const $65eb2fa1f16146ac$var$messageContainerStyles = (0, $1DXK0.xcss)({
    marginTop: 'space.050'
});

});
parcelRegister("cIXG9", function(module, exports) {

$parcel$export(module.exports, "RolePickerEdit", () => $7bf40943682517cc$export$61efdb1b7765b92e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $c4OV1 = parcelRequire("c4OV1");

var $lRq8t = parcelRequire("lRq8t");

var $aUMMA = parcelRequire("aUMMA");

var $7pReZ = parcelRequire("7pReZ");

var $fwJ9V = parcelRequire("fwJ9V");

var $clLhb = parcelRequire("clLhb");
const $7bf40943682517cc$export$ab4a55465dcdd21b = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { currentUserRole: currentUserRole } = props;
    return currentUserRole ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7bf40943682517cc$var$FlexRow, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7bf40943682517cc$var$CurrentUserRole, null, formatMessage((0, $fwJ9V.default).currentUserRole))) : null;
};
// @ts-expect-error - TS7031 - Binding element 'context' implicitly has an 'any' type.
const $7bf40943682517cc$var$formatOptionLabel = (option, { context: context })=>{
    if (context === 'menu') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7bf40943682517cc$var$FlexBody, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7bf40943682517cc$var$FlexColumn, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7bf40943682517cc$var$RoleName, null, option.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7bf40943682517cc$var$SelectDescription, null, option.description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7bf40943682517cc$export$ab4a55465dcdd21b, {
        currentUserRole: !!option.currentUserRole
    }));
    return option.name;
};
const $7bf40943682517cc$export$61efdb1b7765b92e = (props)=>{
    const { classNamePrefix: classNamePrefix, selectedRoles: selectedRoles, selectedProjectId: selectedProjectId, onChange: onChange, isDisabled: isDisabled, onFocus: onFocus, onBlur: onBlur, autoFocus: autoFocus, isInvalid: isInvalid, onCloseMenuOnScroll: onCloseMenuOnScroll, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, setAccessWarningDisplay: setAccessWarningDisplay, ariaLabel: ariaLabel, ...fieldProps } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { data: allRoles } = (0, $7pReZ.default)(selectedProjectId);
    const rolesWithCurrentUserAccess = (0, $eJOHy.useMemo)(()=>allRoles.filter(({ currentUserRole: currentUserRole })=>currentUserRole === true), [
        allRoles
    ]);
    const shouldShowIssueAccessWarning = (0, $eJOHy.useMemo)(()=>!(0, $clLhb.isUserRoleIncludedInRestrictedRoles)(selectedRoles, rolesWithCurrentUserAccess), [
        rolesWithCurrentUserAccess,
        selectedRoles
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (setAccessWarningDisplay) setAccessWarningDisplay(shouldShowIssueAccessWarning);
    }, [
        setAccessWarningDisplay,
        shouldShowIssueAccessWarning
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c4OV1.default), {
        ...fieldProps,
        classNamePrefix: classNamePrefix,
        // @ts-expect-error([Part of upgrade 4.9-5.4]) - Type 'Data' is not assignable to type 'readonly (SingleSelectItem | GroupBase<SingleSelectItem>)[]'.
        options: allRoles,
        isMulti: true,
        onBlur: onBlur,
        onFocus: onFocus,
        formatOptionLabel: $7bf40943682517cc$var$formatOptionLabel,
        menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
        styles: (0, $aUMMA.defaultSelectStyles),
        isSearchable: false,
        placeholder: formatMessage((0, $fwJ9V.default).placeholder),
        // @ts-expect-error([Part of upgrade 4.9-5.4]) - Type '(role: TransformedRole) => string' is not assignable to type 'GetOptionValue<SingleSelectItem>'.
        getOptionValue: (0, $clLhb.getOptionValue),
        // @ts-expect-error([Part of upgrade 4.9-5.4]) - Type '(role: TransformedRole) => string' is not assignable to type 'GetOptionLabel<SingleSelectItem>'.
        getOptionLabel: (0, $clLhb.getOptionLabel),
        // @ts-expect-error([Part of upgrade 4.9-5.4]) - Type 'TransformedRole[]' is not assignable to type 'PropsValue<SingleSelectItem> | undefined'.
        value: (0, $clLhb.convertRolesToCurrentRole)(selectedRoles, allRoles),
        onChange: (roles)=>(0, $clLhb.transformRolesToArrayIfNull)(roles, onChange),
        isDisabled: isDisabled,
        autoFocus: autoFocus,
        validationState: isInvalid === true ? 'error' : null,
        closeMenuOnScroll: onCloseMenuOnScroll,
        "aria-label": ariaLabel,
        "aria-labelledby": fieldProps['aria-labelledby']
    });
};
var $7bf40943682517cc$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $7bf40943682517cc$export$61efdb1b7765b92e;
const $7bf40943682517cc$var$SelectDescription = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c81o8v _o5724jg8 _syaz131l",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7bf40943682517cc$var$FlexBody = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7bf40943682517cc$var$FlexColumn = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2lx21bp4 _1e0c1txw _1bsb1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/design-system/no-empty-styled-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7bf40943682517cc$var$RoleName = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7bf40943682517cc$var$FlexRow = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _19bvv47k",
            __cmplp.className
        ])
    });
});
const $7bf40943682517cc$var$CurrentUserRole = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_zg8l1m30",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7pReZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $acf777282011e44d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $jGzN3 = parcelRequire("jGzN3");

var $eVuzU = parcelRequire("eVuzU");
const $acf777282011e44d$var$useFetchRoles = (projectKeyOrId)=>{
    const [data, setData] = (0, $eJOHy.useState)([]);
    const [error, setError] = (0, $eJOHy.useState)(null);
    const [loading, setLoading] = (0, $eJOHy.useState)(false);
    (0, $eJOHy.useEffect)(()=>{
        (async ()=>{
            setLoading(true);
            try {
                const response = await (0, $jGzN3.performGetRequest)((0, $eVuzU.getFetchRolesURL)(projectKeyOrId));
                setLoading(false);
                setData((0, $eVuzU.transformRoleIdToString)(response));
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (httpError) {
                setLoading(false);
                setError(httpError.message);
            }
        })();
    }, [
        projectKeyOrId
    ]);
    return {
        loading: loading,
        error: error,
        data: data
    };
};
var $acf777282011e44d$export$2e2bcd8739ae039 = $acf777282011e44d$var$useFetchRoles;

});
parcelRegister("eVuzU", function(module, exports) {

$parcel$export(module.exports, "getFetchRolesURL", () => $36a26deaee81868e$export$e39189e7b2114aa1);
$parcel$export(module.exports, "transformRoleIdToString", () => $36a26deaee81868e$export$25aa9a2b001fbb5e);
const $36a26deaee81868e$export$e39189e7b2114aa1 = (projectKeyOrId)=>`/rest/api/3/project/${projectKeyOrId}/internal/roledetails?excludeConnectAddons=true`;
const $36a26deaee81868e$export$25aa9a2b001fbb5e = (roles)=>roles.map(({ id: id, ...role })=>({
            roleId: id.toString(),
            ...role
        }));

});


parcelRegister("fwJ9V", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf5a6d77625e07b1$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $bf5a6d77625e07b1$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    currentUserRole: {
        "id": "issue-field-role-picker.edit.current-user-role",
        "defaultMessage": "You"
    },
    placeholder: {
        "id": "issue-field-role-picker.edit.placeholder",
        "defaultMessage": "Select Roles"
    }
});

});


parcelRegister("kDlLr", function(module, exports) {

$parcel$export(module.exports, "default", () => $eebee36e220cb723$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $eebee36e220cb723$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    noAccessOnIssueCreatedWarning: {
        "id": "issue-create.common.fields.issue-restriction.no-access-on-issue-created-warning",
        "defaultMessage": "Select the roles that you're a part of to avoid losing access to this issue."
    },
    noAccessOnIssueCreatedWarningIssueTermRefresh: {
        "id": "issue-create.common.fields.issue-restriction.no-access-on-issue-created-warning-issue-term-refresh",
        "defaultMessage": "Select the roles that you're a part of to avoid losing access to this work item."
    }
});

});


parcelRegister("2RNNL", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e95b1c9c8455df1$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $3UrQk = parcelRequire("3UrQk");

var $2ABCx = parcelRequire("2ABCx");

var $jQUoP = parcelRequire("jQUoP");
const $1e95b1c9c8455df1$var$LogWorkField = ({ additionalData: additionalData, ...props })=>{
    const { mediaContext: mediaContext, timeTrackingSettings: timeTrackingSettings } = additionalData;
    const [mediaUploadContext, setMediaUploadContext] = (0, $eJOHy.useState)(null);
    const [viewContext, setViewContext] = (0, $eJOHy.useState)(null);
    (0, $eJOHy.useEffect)(()=>{
        const uploadToken = mediaContext?.uploadToken;
        if (uploadToken) {
            const { clientId: clientId, endpointUrl: endpointUrl, targetCollection: targetCollection, token: token, tokenDurationInMin: tokenDurationInMin } = uploadToken;
            const tokenIssueTimestamp = Date.now();
            const tokenLifespanInMs = tokenDurationInMin * 60000;
            setMediaUploadContext({
                clientId: clientId,
                serviceHost: endpointUrl,
                collection: targetCollection,
                tokenLifespanInMs: tokenLifespanInMs,
                token: token,
                tokenIssueTimestamp: tokenIssueTimestamp
            });
            setViewContext({
                clientId: clientId,
                serviceHost: endpointUrl,
                token: token,
                tokenLifespanInMs: tokenLifespanInMs,
                areTokenPermissionsUpToDate: true,
                collection: targetCollection,
                tokenIssueTimestamp: tokenIssueTimestamp
            });
        }
    }, [
        mediaContext?.uploadToken
    ]);
    const mediaProvider = {
        userAuth: null,
        viewContext: viewContext,
        uploadContext: mediaUploadContext
    };
    const [{ timeTrackingValue: timeTrackingValue, meta: { submitFieldwiseErrors: submitFieldwiseErrors } }] = (0, $jQUoP.useFormContext)();
    const getLogWorkFieldErrors = (0, $eJOHy.useCallback)(()=>{
        if (submitFieldwiseErrors) {
            const logWorkFieldWiseErrors = {};
            [
                (0, $3UrQk.LOG_WORK_DATE_ERROR_KEY),
                (0, $3UrQk.LOG_WORK_DESCRIPTION_ERROR_KEY),
                (0, $3UrQk.LOG_WORK_TIME_REMAINING_ERROR_KEY),
                (0, $3UrQk.LOG_WORK_TIME_SPENT_ERROR_KEY)
            ].forEach((errorKey)=>{
                if (submitFieldwiseErrors[errorKey]) logWorkFieldWiseErrors[errorKey] = submitFieldwiseErrors[errorKey];
            });
            const logWorkOtherErrors = [];
            (0, $3UrQk.COMMON_LOG_WORK_ERROR_KEYS).forEach((key)=>{
                if (submitFieldwiseErrors[key]) logWorkOtherErrors.push(submitFieldwiseErrors[key]);
            });
            return {
                ...logWorkFieldWiseErrors,
                logWorkOtherErrors: logWorkOtherErrors
            };
        }
        return undefined;
    }, [
        submitFieldwiseErrors
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2ABCx.default), {
        ...props,
        additionalData: {
            timeTrackingSettings: timeTrackingSettings
        },
        mediaContext: mediaProvider,
        timeTrackingValue: timeTrackingValue,
        errors: getLogWorkFieldErrors()
    });
};
var $1e95b1c9c8455df1$export$2e2bcd8739ae039 = $1e95b1c9c8455df1$var$LogWorkField;

});
parcelRegister("2ABCx", function(module, exports) {

$parcel$export(module.exports, "default", () => $37a5509f956c5e5d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $fTjQo = parcelRequire("fTjQo");

var $1kTzc = parcelRequire("1kTzc");

var $6BxzS = parcelRequire("6BxzS");

var $goZPP = parcelRequire("goZPP");

var $kkMDK = parcelRequire("kkMDK");

var $fKXve = parcelRequire("fKXve");
var $6svxr = parcelRequire("6svxr");

var $9A8Wt = parcelRequire("9A8Wt");

var $igoRN = parcelRequire("igoRN");

var $dPMMf = parcelRequire("dPMMf");

var $lRq8t = parcelRequire("lRq8t");

var $3UrQk = parcelRequire("3UrQk");

var $bzMDD = parcelRequire("bzMDD");

var $dXU8v = parcelRequire("dXU8v");

var $ch9En = parcelRequire("ch9En");

var $dO9h7 = parcelRequire("dO9h7");

var $2cfd4 = parcelRequire("2cfd4");

var $fE4zR = parcelRequire("fE4zR");

var $2nXHu = parcelRequire("2nXHu");


var $1zMym = parcelRequire("1zMym");

var $4zIi4 = parcelRequire("4zIi4");
const $37a5509f956c5e5d$var$skeletonHeight = `${(0, $dPMMf.gridSize) * 18.75}px`;
const $37a5509f956c5e5d$export$c128706c0bbc8993 = (props)=>{
    const currentDateTime = (0, $eJOHy.useMemo)(()=>(0, $fTjQo.default)(new Date()), []);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [timeFieldInFocus, setTimeFieldInFocus] = (0, $eJOHy.useState)('');
    const isDefaultValueSetInFormStateForDateField = (0, $eJOHy.useRef)(false);
    const [areLogWorkFieldsVisible, showLogWorkFields] = (0, $eJOHy.useState)(false);
    const [estimateExceededWarning, setEstimateExceededWarning] = (0, $eJOHy.useState)('');
    const { width: width = 350, fieldProps: { value: value = {
        timeRemaining: '',
        timeSpent: '',
        dateValue: '',
        description: undefined
    }, onChange: onChange }, timeTrackingValue: timeTrackingValue = '', mediaContext: mediaContext, autoFocus: autoFocus = false, additionalData: additionalData, isRequired: isRequired, errors: errors, fieldName: fieldName } = props;
    const { description: description, timeRemaining: timeRemaining, timeSpent: timeSpent, dateValue: dateValue } = value;
    const { timeTrackingSettings: config } = additionalData;
    const locale = (0, $2cfd4.useLocale)();
    const onChangeFieldValue = (0, $eJOHy.useCallback)((partialFieldValue)=>{
        onChange({
            ...value,
            ...partialFieldValue
        });
    }, [
        onChange,
        value
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (timeTrackingValue) {
            const isTimeEstimateExceeded = (0, $4zIi4.getIsTimeEstimateExceeded)({
                config: config,
                timeRemaining: timeRemaining,
                timeSpent: timeSpent,
                timeTrackingValue: timeTrackingValue
            });
            setEstimateExceededWarning(isTimeEstimateExceeded ? formatMessage((0, $1zMym.default).originalEstimateExceededNonFinal) : '');
        } else if (estimateExceededWarning) setEstimateExceededWarning('');
    }, [
        timeRemaining,
        timeSpent,
        timeTrackingValue,
        config,
        formatMessage,
        estimateExceededWarning
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!isDefaultValueSetInFormStateForDateField.current && !dateValue && areLogWorkFieldsVisible) {
            isDefaultValueSetInFormStateForDateField.current = true;
            onChangeFieldValue({
                dateValue: currentDateTime
            });
        }
    }, [
        dateValue,
        currentDateTime,
        onChangeFieldValue,
        areLogWorkFieldsVisible
    ]);
    const onChangeTimeSpent = (0, $eJOHy.useCallback)((newTimeSpent)=>{
        let newTimeRemaining = timeRemaining;
        if (timeTrackingValue) {
            const calculatedTimeRemainingIfAny = (0, $4zIi4.getCalculatedTimeRemainingIfAny)({
                timeSpent: newTimeSpent,
                timeTrackingValue: timeTrackingValue,
                config: config
            });
            if (calculatedTimeRemainingIfAny !== null) newTimeRemaining = calculatedTimeRemainingIfAny;
        }
        setTimeFieldInFocus((0, $b0689309ab31cde3$export$81fee17d19007357));
        onChangeFieldValue({
            timeSpent: newTimeSpent,
            timeRemaining: newTimeRemaining
        });
    }, [
        config,
        onChangeFieldValue,
        timeRemaining,
        timeTrackingValue
    ]);
    const onChangeTimeRemaining = (0, $eJOHy.useCallback)((newTimeRemaining)=>{
        setTimeFieldInFocus((0, $b0689309ab31cde3$export$d7ed3a061805d786));
        onChangeFieldValue({
            timeRemaining: newTimeRemaining
        });
    }, [
        onChangeFieldValue
    ]);
    const onToggleLogWorkFieldsVisibility = (0, $eJOHy.useCallback)(()=>{
        showLogWorkFields((current)=>!current);
    }, []);
    const onChangeDatePicker = (0, $eJOHy.useCallback)((newDateValue)=>{
        onChangeFieldValue({
            dateValue: newDateValue
        });
    }, [
        onChangeFieldValue
    ]);
    const onChangeEditorValue = (0, $eJOHy.useCallback)((newEditorValue)=>{
        onChangeFieldValue({
            description: newEditorValue
        });
    }, [
        onChangeFieldValue
    ]);
    const isEstimateExceeded = estimateExceededWarning !== '';
    const weekStartDay = (0, $dO9h7.getLocale)(locale)?.options?.weekStartsOn;
    const buttonLabel = formatMessage((0, $1zMym.default).logWorkLabel);
    const dateTimeLabel = formatMessage((0, $1zMym.default).dateStarted);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($37a5509f956c5e5d$var$LogWorkHeader, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        iconBefore: areLogWorkFieldsVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6BxzS))), {
            spacing: "spacious",
            label: "",
            size: "small"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1kTzc))), {
            spacing: "spacious",
            label: "",
            size: "small"
        }),
        appearance: "subtle",
        spacing: "none",
        onClick: onToggleLogWorkFieldsVisibility,
        testId: "issue-create-commons.ui.log-work-field.next-button",
        "aria-label": buttonLabel,
        "aria-expanded": areLogWorkFieldsVisible
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", null, buttonLabel, " ", isRequired === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($37a5509f956c5e5d$var$RequiredDot, null, "*") : '')), areLogWorkFieldsVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fE4zR.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6svxr.default), {
        name: (0, $b0689309ab31cde3$export$81fee17d19007357),
        label: formatMessage((0, $1zMym.default).timeSpent),
        isRequired: isRequired
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dXU8v.TimeEstimate), {
            ...fieldProps,
            autoFocus: autoFocus,
            value: timeSpent,
            onChange: onChangeTimeSpent,
            shouldShowWarning: isEstimateExceeded && timeFieldInFocus === (0, $b0689309ab31cde3$export$81fee17d19007357),
            config: config
        }), errors && errors[0, $3UrQk.LOG_WORK_TIME_SPENT_ERROR_KEY] ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fKXve.ErrorMessage), null, errors[0, $3UrQk.LOG_WORK_TIME_SPENT_ERROR_KEY]) : null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fE4zR.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6svxr.default), {
        name: (0, $b0689309ab31cde3$export$d7ed3a061805d786),
        label: formatMessage((0, $1zMym.default).timeRemaining)
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dXU8v.TimeEstimate), {
            ...fieldProps,
            value: timeRemaining,
            onChange: onChangeTimeRemaining,
            shouldShowWarning: isEstimateExceeded && timeFieldInFocus === (0, $b0689309ab31cde3$export$d7ed3a061805d786),
            config: config
        }), errors && errors[0, $3UrQk.LOG_WORK_TIME_REMAINING_ERROR_KEY] ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fKXve.ErrorMessage), null, errors[0, $3UrQk.LOG_WORK_TIME_REMAINING_ERROR_KEY]) : null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fE4zR.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6svxr.default), {
        name: (0, $b0689309ab31cde3$export$ade7f171d00a976f),
        label: dateTimeLabel,
        isRequired: isRequired
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kkMDK.default), {
            onChange: onChangeDatePicker,
            value: dateValue,
            locale: locale,
            isClearable: !isRequired,
            datePickerProps: {
                weekStartDay: weekStartDay,
                label: dateTimeLabel,
                id: fieldProps.id,
                shouldShowCalendarButton: true
            },
            timePickerProps: {
                times: (0, $igoRN.default)
            }
        }), errors && errors[0, $3UrQk.LOG_WORK_DATE_ERROR_KEY] ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fKXve.ErrorMessage), null, errors[0, $3UrQk.LOG_WORK_DATE_ERROR_KEY]) : null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6svxr.default), {
        name: (0, $b0689309ab31cde3$export$caca24db5cb49b68),
        label: formatMessage((0, $1zMym.default).description)
    }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
            name: "rich-text-edit-view",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9A8Wt.Skeleton), {
                height: $37a5509f956c5e5d$var$skeletonHeight
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bzMDD.AsyncRichTextEditView), {
            onChange: onChangeEditorValue,
            defaultValue: description,
            mediaContext: mediaContext,
            // @ts-expect-error - TS2739 - Type '{ unsubscribe: () => void; }' is missing the following properties from type 'MentionProvider': filter, recordMentionSelection, shouldHighlightMention, isFiltering, subscribe
            mentionProvider: {
                // was throwing a console error on unmouting so added this
                // Replace with lodash/noop
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                unsubscribe: ()=>{}
            },
            assistiveLabel: fieldName
        })), errors && errors[0, $3UrQk.LOG_WORK_DESCRIPTION_ERROR_KEY] ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fKXve.ErrorMessage), null, errors[0, $3UrQk.LOG_WORK_DESCRIPTION_ERROR_KEY]) : null)), errors && errors.logWorkOtherErrors?.map((error, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fKXve.ErrorMessage), {
            key: `logwork-${index}-common-error`
        }, error))));
};
var $37a5509f956c5e5d$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $2nXHu.withFormField)({
    shouldHideLabel: true // @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element' is not assignable to parameter of type 'AbstractComponent<ComponentProps<LogWorkFieldConfig, FieldValue>, any>'.
})($37a5509f956c5e5d$export$c128706c0bbc8993);
const $37a5509f956c5e5d$var$RequiredDot = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c8dcr7 _syaz1tmw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $37a5509f956c5e5d$var$LogWorkHeader = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1kTzc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0d4724a1e5dc4e8ab6ea5bb133724929>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0f92c313e495a986$var$_react = $0f92c313e495a986$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $0f92c313e495a986$var$_chevronRight = $0f92c313e495a986$var$_interopRequireDefault((parcelRequire("cQxBL")));

var $0f92c313e495a986$var$_chevronRightLarge = $0f92c313e495a986$var$_interopRequireDefault((parcelRequire("czcci")));
function $0f92c313e495a986$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronRightIcon.
 * This component is ChevronRightIcon, with `UNSAFE_fallbackIcon` set to "ChevronRightLargeIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Next page of pagination results, collapsed tree item, expand tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0f92c313e495a986$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $0f92c313e495a986$var$_react.default.createElement($0f92c313e495a986$var$_chevronRight.default, Object.assign({
        LEGACY_fallbackIcon: $0f92c313e495a986$var$_chevronRightLarge.default
    }, props));
$0f92c313e495a986$var$ChevronRightIcon.Name = 'ChevronRightIconMigration';
var $0f92c313e495a986$var$_default = module.exports.default = $0f92c313e495a986$var$ChevronRightIcon;

});
parcelRegister("czcci", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9262370c29d80ea9$var$_react = $9262370c29d80ea9$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $9262370c29d80ea9$var$_chevronRight = $9262370c29d80ea9$var$_interopRequireDefault((parcelRequire("cQxBL")));
function $9262370c29d80ea9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9262370c29d80ea9$var$ChevronRightLargeIcon = (props)=>/*#__PURE__*/ $9262370c29d80ea9$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 0 1 0 1.414l-4.593 4.593a.99.99 0 0 1-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 0 1 1.4-1.4z"/></svg>`
    }, props, {
        newIcon: $9262370c29d80ea9$var$_chevronRight.default
    }));
$9262370c29d80ea9$var$ChevronRightLargeIcon.displayName = 'ChevronRightLargeIcon';
var $9262370c29d80ea9$var$_default = module.exports.default = $9262370c29d80ea9$var$ChevronRightLargeIcon;

});


parcelRegister("kkMDK", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ec97aa1f0f4c3e1$export$2e2bcd8739ae039);

var $eGOwo = parcelRequire("eGOwo");

var $1BRZx = parcelRequire("1BRZx");

var $dvsWI = parcelRequire("dvsWI");

var $gW6sD = parcelRequire("gW6sD");
const $3ec97aa1f0f4c3e1$var$DateTimePicker = (0, $1BRZx.componentWithCondition)(()=>(0, $eGOwo.fg)('dst-date-time-picker-use-functional-component'), (0, $gW6sD.default), (0, $dvsWI.default));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$3ec97aa1f0f4c3e1$export$2e2bcd8739ae039 = $3ec97aa1f0f4c3e1$var$DateTimePicker;

});
parcelRegister("dvsWI", function(module, exports) {

$parcel$export(module.exports, "default", () => $26ee02f66b42cef8$export$2e2bcd8739ae039);
/* date-time-picker-class.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $57raR = parcelRequire("57raR");
var $dBLX0 = parcelRequire("dBLX0");
var $kQ82p = parcelRequire("kQ82p");

var $5fWw9 = parcelRequire("5fWw9");
var $dUaMU = parcelRequire("dUaMU");
var $4J0ad = parcelRequire("4J0ad");

var $5pWSu = parcelRequire("5pWSu");

var $eGOwo = parcelRequire("eGOwo");

var $e9zKl = parcelRequire("e9zKl");

var $RoXqn = parcelRequire("RoXqn");

var $6EOrx = parcelRequire("6EOrx");

var $1BRZx = parcelRequire("1BRZx");

var $5PwWU = parcelRequire("5PwWU");

var $lLHJE = parcelRequire("lLHJE");

var $k2Uo2 = parcelRequire("k2Uo2");

var $fkh8F = parcelRequire("fkh8F");
const $26ee02f66b42cef8$var$DatePicker = (0, $1BRZx.componentWithCondition)(()=>(0, $eGOwo.fg)('dst-date-picker-use-functional-component'), (0, $k2Uo2.default), (0, $lLHJE.default));
const $26ee02f66b42cef8$var$packageName = "platform-pkg";
const $26ee02f66b42cef8$var$packageVersion = "0.0.0-use.local";
const $26ee02f66b42cef8$var$compiledStyles = {
    datePickerContainerStyles: "_i0dl1ssb _16jlkb7n _1o9zidpf",
    timePickerContainerStyles: "_i0dl1ssb _16jlkb7n",
    iconContainerStyles: "_19itglyw _v564vrg3 _1e0c1txw _4cvr1h6o _i0dl1kw7 _bfhk1kw7 _syaz131l _6rthe4h9 _1pfhe4h9 _12l2e4h9 _ahbqe4h9 _85i512x7 _1q5112x7 _y4tiu2gc _bozg1b66 _30l31gjq"
}; // react-select overrides (via @atlaskit/select).
const $26ee02f66b42cef8$var$styles = {
    control: (style)=>({
            ...style,
            backgroundColor: 'transparent',
            border: 2,
            borderRadius: 0,
            paddingLeft: 0,
            ':hover': {
                backgroundColor: 'transparent',
                cursor: 'inherit'
            }
        })
};
const $26ee02f66b42cef8$var$dateTimePickerDefaultProps = {
    // These disables are here for proper typing when used as defaults. They
    // should *not* use the `noop` function.
    /* eslint-disable @repo/internal/react/use-noop */ onBlur: (_event)=>{},
    onChange: (_value)=>{},
    onFocus: (_event)=>{} /* eslint-enable @repo/internal/react/use-noop */ 
};
const $26ee02f66b42cef8$export$3b559a1219cb3c27 = 'Date';
const $26ee02f66b42cef8$export$d82cc7e53d68a428 = 'Time'; // eslint-disable-next-line @repo/internal/react/no-class-components
class $26ee02f66b42cef8$export$732a1726f0a3523b extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    static{
        this.defaultProps = $26ee02f66b42cef8$var$dateTimePickerDefaultProps;
    }
    parseValue(value, dateValue, timeValue, zoneValue) {
        if (this.props.parseValue) {
            const parsedFromFn = this.props.parseValue(value, dateValue, timeValue, zoneValue); // This handles cases found in Jira where the parse function actually does
            // nothing and returns undefined. The previous `getSafeState` function
            // just spread the values over the state, but if it returned `undefined`,
            // it would just rely on the previous state values. Considering this is
            // what is input to this function anyway, this is a safe way to handle
            // this, colocate the behavior, and not rely on `getSafeState`.
            return parsedFromFn || {
                dateValue: dateValue,
                timeValue: timeValue,
                zoneValue: zoneValue
            };
        }
        const parsed = (0, $kQ82p.default)(value);
        return (0, $dBLX0.default)(parsed) ? {
            dateValue: (0, $57raR.default)(parsed, (0, $5PwWU.convertTokens)('YYYY-MM-DD')),
            timeValue: (0, $57raR.default)(parsed, (0, $5PwWU.convertTokens)('HH:mm')),
            zoneValue: (0, $57raR.default)(parsed, (0, $5PwWU.convertTokens)('ZZ'))
        } : {
            dateValue: dateValue,
            timeValue: timeValue,
            zoneValue: zoneValue
        };
    }
    onValueChange({ dateValue: dateValue, timeValue: timeValue, zoneValue: zoneValue }) {
        this.setState({
            dateValue: dateValue,
            timeValue: timeValue,
            zoneValue: zoneValue
        });
        if (dateValue && timeValue) {
            const value = (0, $RoXqn.formatDateTimeZoneIntoIso)(dateValue, timeValue, zoneValue);
            const { zoneValue: parsedZone } = this.parseValue(value, dateValue, timeValue, zoneValue);
            const valueWithValidZone = (0, $RoXqn.formatDateTimeZoneIntoIso)(dateValue, timeValue, parsedZone);
            this.setState({
                value: valueWithValidZone
            });
            this.props.onChange?.(valueWithValidZone); // If the date or time value was cleared when there is an existing datetime value, then clear the value.
        } else if (this.getValue()) {
            this.setState({
                value: ''
            });
            this.props.onChange?.('');
        }
    }
    render() {
        const { 'aria-describedby': ariaDescribedBy, appearance: appearance = 'default', autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'clear', datePickerProps: datePickerProps = {}, id: id = '', innerProps: innerProps = {}, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, locale: locale = 'en-US', name: name = '', spacing: spacing = 'default', testId: testId, timePickerProps: timePickerProps = {} } = this.props;
        const value = this.getValue();
        const { isFocused: isFocused } = this.state;
        const parsedValues = this.getParsedValues();
        const dateValue = parsedValues?.dateValue;
        const timeValue = parsedValues?.timeValue;
        const datePickerSelectProps = datePickerProps?.selectProps;
        const datePickerAriaDescribedBy = datePickerProps['aria-describedby'] || ariaDescribedBy;
        const datePickerLabel = datePickerProps.label || $26ee02f66b42cef8$export$3b559a1219cb3c27;
        const mergedDatePickerSelectProps = {
            ...datePickerSelectProps,
            styles: (0, $e9zKl.mergeStyles)($26ee02f66b42cef8$var$styles, datePickerSelectProps?.styles)
        };
        const timePickerSelectProps = timePickerProps?.selectProps;
        const timePickerAriaDescribedBy = timePickerProps['aria-describedby'] || ariaDescribedBy;
        const timePickerLabel = timePickerProps.label || $26ee02f66b42cef8$export$d82cc7e53d68a428;
        const mergedTimePickerSelectProps = {
            ...timePickerSelectProps,
            styles: (0, $e9zKl.mergeStyles)($26ee02f66b42cef8$var$styles, timePickerSelectProps?.styles)
        }; // Render DateTimePicker's IconContainer when a value has been filled
        // Don't use Date or TimePicker's because they can't be customised
        const isClearable = Boolean(dateValue || timeValue);
        return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6EOrx.DateTimePickerContainer), {
            appearance: appearance,
            isDisabled: isDisabled,
            isFocused: isFocused,
            isInvalid: isInvalid,
            testId: testId,
            innerProps: innerProps,
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)("input", {
                    name: name,
                    type: "hidden",
                    value: value,
                    "data-testid": testId && `${testId}--input`
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    className: (0, $hcewu.default)([
                        $26ee02f66b42cef8$var$compiledStyles.datePickerContainerStyles
                    ]),
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)($26ee02f66b42cef8$var$DatePicker, {
                        appearance: appearance,
                        "aria-describedby": datePickerAriaDescribedBy,
                        autoFocus: datePickerProps.autoFocus || autoFocus,
                        dateFormat: datePickerProps.dateFormat,
                        defaultIsOpen: datePickerProps.defaultIsOpen,
                        defaultValue: datePickerProps.defaultValue,
                        disabled: datePickerProps.disabled,
                        disabledDateFilter: datePickerProps.disabledDateFilter,
                        formatDisplayLabel: datePickerProps.formatDisplayLabel,
                        hideIcon: datePickerProps.hideIcon || true,
                        icon: datePickerProps.icon,
                        id: datePickerProps.id || id,
                        innerProps: datePickerProps.innerProps,
                        isDisabled: datePickerProps.isDisabled || isDisabled,
                        isInvalid: datePickerProps.isInvalid || isInvalid,
                        isRequired: datePickerProps.isRequired || isRequired,
                        isOpen: datePickerProps.isOpen,
                        label: datePickerLabel,
                        locale: datePickerProps.locale || locale,
                        maxDate: datePickerProps.maxDate,
                        minDate: datePickerProps.minDate,
                        name: datePickerProps.name,
                        nextMonthLabel: datePickerProps.nextMonthLabel,
                        onBlur: this.onDateBlur,
                        onChange: this.onDateChange,
                        onFocus: this.onDateFocus,
                        parseInputValue: datePickerProps.parseInputValue,
                        placeholder: datePickerProps.placeholder,
                        previousMonthLabel: datePickerProps.previousMonthLabel,
                        selectProps: mergedDatePickerSelectProps,
                        shouldShowCalendarButton: datePickerProps.shouldShowCalendarButton,
                        spacing: datePickerProps.spacing || spacing,
                        testId: testId && `${testId}--datepicker` || datePickerProps.testId,
                        value: dateValue,
                        weekStartDay: datePickerProps.weekStartDay
                    })
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    className: (0, $hcewu.default)([
                        $26ee02f66b42cef8$var$compiledStyles.timePickerContainerStyles
                    ]),
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fkh8F.default), {
                        appearance: timePickerProps.appearance || appearance,
                        "aria-describedby": timePickerAriaDescribedBy,
                        autoFocus: timePickerProps.autoFocus,
                        defaultIsOpen: timePickerProps.defaultIsOpen,
                        defaultValue: timePickerProps.defaultValue,
                        formatDisplayLabel: timePickerProps.formatDisplayLabel,
                        hideIcon: timePickerProps.hideIcon || true,
                        id: timePickerProps.id,
                        innerProps: timePickerProps.innerProps,
                        isDisabled: timePickerProps.isDisabled || isDisabled,
                        isInvalid: timePickerProps.isInvalid || isInvalid,
                        isOpen: timePickerProps.isOpen,
                        isRequired: timePickerProps.isRequired || isRequired,
                        label: timePickerLabel,
                        locale: timePickerProps.locale || locale,
                        name: timePickerProps.name,
                        onBlur: this.onTimeBlur,
                        onChange: this.onTimeChange,
                        onFocus: this.onTimeFocus,
                        parseInputValue: timePickerProps.parseInputValue,
                        placeholder: timePickerProps.placeholder,
                        selectProps: mergedTimePickerSelectProps,
                        spacing: timePickerProps.spacing || spacing,
                        testId: timePickerProps.testId || testId && `${testId}--timepicker`,
                        timeFormat: timePickerProps.timeFormat,
                        timeIsEditable: timePickerProps.timeIsEditable,
                        times: timePickerProps.times,
                        value: timeValue
                    })
                }),
                isClearable && !isDisabled ? /*#__PURE__*/ (0, $gt9Am.jsxs)("button", {
                    onClick: this.onClear,
                    "data-testid": testId && `${testId}--icon--container`,
                    tabIndex: -1,
                    type: "button",
                    className: (0, $hcewu.default)([
                        $26ee02f66b42cef8$var$compiledStyles.iconContainerStyles
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5pWSu))), {
                            LEGACY_size: "small",
                            color: "currentColor",
                            label: clearControlLabel,
                            size: "small"
                        }),
                        ' '
                    ]
                }) : null
            ]
        });
    }
    constructor(...args){
        super(...args), this.state = {
            dateValue: this.props.datePickerProps?.defaultValue || '',
            isFocused: false,
            timeValue: this.props.timePickerProps?.defaultValue || '',
            value: this.props.defaultValue || '',
            zoneValue: ''
        } // All state needs to be accessed via this function so that the state is mapped from props
        , // correctly to allow controlled/uncontrolled usage.
        this.getParsedValues = ()=>this.parseValue(this.getValue(), this.state.dateValue, this.state.timeValue, this.state.zoneValue), this.getValue = ()=>this.props.value ?? this.state.value, this.onDateBlur = (event)=>{
            this.setState({
                isFocused: false
            });
            this.props.onBlur?.(event);
            if (this.props.datePickerProps?.onBlur) this.props.datePickerProps.onBlur(event);
        }, this.onTimeBlur = (event)=>{
            this.setState({
                isFocused: false
            });
            this.props.onBlur?.(event);
            if (this.props.timePickerProps?.onBlur) this.props.timePickerProps.onBlur(event);
        }, this.onDateFocus = (event)=>{
            this.setState({
                isFocused: true
            });
            this.props.onFocus?.(event);
            if (this.props.datePickerProps?.onFocus) this.props.datePickerProps.onFocus(event);
        }, this.onTimeFocus = (event)=>{
            this.setState({
                isFocused: true
            });
            this.props.onFocus?.(event);
            if (this.props.timePickerProps?.onFocus) this.props.timePickerProps.onFocus(event);
        }, this.onDateChange = (dateValue)=>{
            const parsedValues = this.getParsedValues();
            this.onValueChange({
                dateValue: dateValue,
                timeValue: parsedValues.timeValue,
                zoneValue: parsedValues.zoneValue
            });
            if (this.props.datePickerProps?.onChange) this.props.datePickerProps.onChange(dateValue);
        }, this.onTimeChange = (timeValue)=>{
            const parsedValues = this.getParsedValues();
            this.onValueChange({
                dateValue: parsedValues.dateValue,
                timeValue: timeValue,
                zoneValue: parsedValues.zoneValue
            });
            if (this.props.timePickerProps?.onChange) this.props.timePickerProps.onChange(timeValue);
        }, this.onClear = ()=>{
            const parsedValues = this.getParsedValues();
            this.onValueChange({
                dateValue: '',
                timeValue: '',
                zoneValue: parsedValues.zoneValue
            });
            if (this.props.datePickerProps?.onChange) this.props.datePickerProps.onChange('');
            if (this.props.timePickerProps?.onChange) this.props.timePickerProps.onChange('');
        };
    }
}
const $26ee02f66b42cef8$var$DateTimePicker = (0, $dUaMU.default)({
    componentName: 'dateTimePicker',
    packageName: $26ee02f66b42cef8$var$packageName,
    packageVersion: $26ee02f66b42cef8$var$packageVersion
})((0, $4J0ad.default)({
    onChange: (0, $5fWw9.default)('atlaskit')({
        action: 'changed',
        actionSubject: 'dateTimePicker',
        attributes: {
            componentName: 'dateTimePicker',
            packageName: $26ee02f66b42cef8$var$packageName,
            packageVersion: $26ee02f66b42cef8$var$packageVersion
        }
    })
})($26ee02f66b42cef8$export$732a1726f0a3523b));
var $26ee02f66b42cef8$export$2e2bcd8739ae039 = $26ee02f66b42cef8$var$DateTimePicker;

});
parcelRegister("6EOrx", function(module, exports) {

$parcel$export(module.exports, "DateTimePickerContainer", () => $c66482dfa6b4af59$export$83034b1f07ab0b20);
/* date-time-picker-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $c66482dfa6b4af59$var$isInvalidBorderStyles = null;
const $c66482dfa6b4af59$var$isFocusedBorderStyles = null;
const $c66482dfa6b4af59$var$isFocusedStyles = null;
const $c66482dfa6b4af59$var$subtleBgStyles = null;
const $c66482dfa6b4af59$var$subtleFocusedBgStyles = null;
const $c66482dfa6b4af59$var$noBgStyles = null;
const $c66482dfa6b4af59$var$hoverStyles = null;
const $c66482dfa6b4af59$var$isInvalidHoverStyles = null;
const $c66482dfa6b4af59$var$isDisabledStyles = null;
const $c66482dfa6b4af59$var$newBorderStyles = null;
const $c66482dfa6b4af59$var$baseContainerStyles = null;
const $c66482dfa6b4af59$export$83034b1f07ab0b20 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, isDisabled: isDisabled, isFocused: isFocused, appearance: appearance, isInvalid: isInvalid, innerProps: innerProps, testId: testId }, ref)=>{
    const notFocusedOrIsDisabled = !(isFocused || isDisabled);
    // we cannot use Box or Flex primitives because these do not allow ...innerProps to be passed
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ...innerProps,
        "data-testid": testId,
        ref: ref,
        className: (0, $hcewu.default)([
            "_2rkoglpi _v564r5cv _1e0c1txw _bfhk1j9a _d0altlke",
            "_19it1k9g",
            isDisabled && "_1h6d13gt _bfhksyzs _d0al73ad",
            isFocused && "_bfhkr01l",
            appearance === 'subtle' && isFocused && "_1h6d3acm _bfhkxbh0",
            appearance === 'subtle' && !isFocused && "_1h6d3acm _bfhk18uv",
            isFocused && "_1h6d1p6i _16qsq049",
            isInvalid && "_1h6d1bqt",
            notFocusedOrIsDisabled && isInvalid && "_4cvx1bqt _irr31d5g",
            notFocusedOrIsDisabled && !isInvalid && "_4cvx1elr _irr31d5g",
            appearance === 'none' && "_1h6d3acm _bfhk18uv _4cvx3acm _irr318uv"
        ]),
        children: children
    });
});

});

parcelRegister("fkh8F", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbd2b423b4bc9ae0$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $57raR = parcelRequire("57raR");
var $dBLX0 = parcelRequire("dBLX0");

var $jrFnt = parcelRequire("jrFnt");

var $3Vuhz = parcelRequire("3Vuhz");

var $cK9J2 = parcelRequire("cK9J2");

var $kVcjU = parcelRequire("kVcjU");
var $c4OV1 = parcelRequire("c4OV1");
var $e9zKl = parcelRequire("e9zKl");

var $RoXqn = parcelRequire("RoXqn");

var $icQS1 = parcelRequire("icQS1");

var $kdGko = parcelRequire("kdGko");

var $5PwWU = parcelRequire("5PwWU");

var $7OE9J = parcelRequire("7OE9J");
const $bbd2b423b4bc9ae0$var$packageName = "platform-pkg";
const $bbd2b423b4bc9ae0$var$packageVersion = "0.0.0-use.local";
const $bbd2b423b4bc9ae0$var$menuStyles = {
    /* Need to remove default absolute positioning as that causes issues with position fixed */ position: 'static',
    /* Need to add overflow to the element with max-height, otherwise causes overflow issues in IE11 */ overflowY: 'auto',
    /* React-Popper has already offset the menu so we need to reset the margin, otherwise the offset value is doubled */ margin: 0
};
const $bbd2b423b4bc9ae0$var$analyticsAttributes = {
    componentName: 'timePicker',
    packageName: $bbd2b423b4bc9ae0$var$packageName,
    packageVersion: $bbd2b423b4bc9ae0$var$packageVersion
};
/**
 * __Time picker__
 *
 * A time picker allows the user to select a specific time.
 *
 * - [Examples](https://atlassian.design/components/datetime-picker/time-picker/examples)
 * - [Code](https://atlassian.design/components/datetime-picker/time-picker/code)
 * - [Usage](https://atlassian.design/components/datetime-picker/time-picker/usage)
 */ const $bbd2b423b4bc9ae0$var$TimePicker = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ 'aria-describedby': ariaDescribedBy, appearance: appearance = 'default', autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'clear timepicker', defaultIsOpen: defaultIsOpen = false, defaultValue: defaultValue = '', formatDisplayLabel: formatDisplayLabel, hideIcon: hideIcon = false, id: id = '', innerProps: innerProps = {}, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, isOpen: providedIsOpen, label: label = '', locale: locale = 'en-US', name: name = '', onBlur: providedOnBlur = (0, $3Vuhz.default), onChange: providedOnChange = (0, $3Vuhz.default), onFocus: providedOnFocus = (0, $3Vuhz.default), parseInputValue: parseInputValue = (time, _timeFormat)=>(0, $kdGko.default)(time), placeholder: placeholder, selectProps: selectProps = {}, spacing: spacing = 'default', testId: testId, timeFormat: timeFormat, timeIsEditable: timeIsEditable = false, times: times = (0, $RoXqn.defaultTimes), value: providedValue }, ref)=>{
    const [containerRef, setContainerRef] = (0, $eJOHy.useState)(null);
    /**
   * When being cleared from the icon the TimePicker is blurred.
   * This variable defines whether the default onMenuOpen or onMenuClose
   * events should behave as normal
   */ const [clearingFromIcon, setClearingFromIcon] = (0, $eJOHy.useState)(false);
    // TODO: Remove isFocused? Does it do anything?
    const [_, setIsFocused] = (0, $eJOHy.useState)(false);
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(defaultIsOpen);
    const [value, setValue] = (0, $eJOHy.useState)(defaultValue);
    // Hack to force update: https://legacy.reactjs.org/docs/hooks-faq.html#is-there-something-like-forceupdate
    const [, forceUpdate] = (0, $eJOHy.useReducer)((x)=>x + 1, 0);
    const providedOnChangeWithAnalytics = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: providedOnChange,
        action: 'selectedTime',
        ...$bbd2b423b4bc9ae0$var$analyticsAttributes
    });
    (0, $eJOHy.useEffect)(()=>{
        if (providedValue) setValue(providedValue);
    }, [
        providedValue
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (providedIsOpen) setIsOpen(providedIsOpen);
    }, [
        providedIsOpen
    ]);
    const onChange = (0, $eJOHy.useCallback)((newValue, action)=>{
        const rawValue = newValue ? newValue.value || newValue : '';
        const finalValue = rawValue.toString();
        setValue(finalValue);
        if (action && action.action === 'clear') setClearingFromIcon(true);
        providedOnChangeWithAnalytics(finalValue);
    }, [
        providedOnChangeWithAnalytics
    ]);
    /**
   * Only allow custom times if timeIsEditable prop is true
   */ const onCreateOption = (inputValue)=>{
        if (timeIsEditable) {
            let sanitizedInput;
            try {
                sanitizedInput = parseInputValue(inputValue, timeFormat || (0, $RoXqn.defaultTimeFormat));
            } catch (e) {
                return; // do nothing, the main validation should happen in the form
            }
            const includesSeconds = !!(timeFormat && /[:.]?(s|ss)/.test(timeFormat));
            const formatFormat = includesSeconds ? 'HH:mm:ss' : 'HH:mm';
            const formattedValue = (0, $57raR.default)(sanitizedInput, formatFormat) || '';
            setValue(formattedValue);
            providedOnChangeWithAnalytics(formattedValue);
        } else providedOnChangeWithAnalytics(inputValue);
    };
    const onMenuOpen = ()=>{
        // Don't open menu after the user has clicked clear
        if (clearingFromIcon) setClearingFromIcon(false);
        else setIsOpen(true);
    };
    const onMenuClose = ()=>{
        // Don't close menu after the user has clicked clear
        if (clearingFromIcon) setClearingFromIcon(false);
        else setIsOpen(false);
    };
    const setInternalContainerRef = (ref)=>{
        const oldRef = containerRef;
        setContainerRef(ref);
        // Cause a re-render if we're getting the container ref for the first time
        // as the layered menu requires it for dimension calculation
        if (oldRef === null && ref !== null) forceUpdate();
    };
    const onBlur = (event)=>{
        setIsFocused(false);
        providedOnBlur(event);
    };
    const onFocus = (event)=>{
        setIsFocused(true);
        providedOnFocus(event);
    };
    const onSelectKeyDown = (event)=>{
        const { key: key } = event;
        const keyPressed = key.toLowerCase();
        if (clearingFromIcon && (keyPressed === 'backspace' || keyPressed === 'delete')) // If being cleared from keyboard, don't change behaviour
        setClearingFromIcon(false);
    };
    const ICON_PADDING = 2;
    const GRID_SIZE = 8;
    const l10n = (0, $cK9J2.createLocalizationProvider)(locale);
    const { styles: selectStyles = {}, ...otherSelectProps } = selectProps;
    const SelectComponent = timeIsEditable ? (0, $kVcjU.default) : (0, $c4OV1.default);
    /**
   * There are multiple props that can change how the time is formatted.
   * The priority of props used is:
   *   1. formatDisplayLabel
   *   2. timeFormat
   *   3. locale
   */ const formatTime = (time)=>{
        if (formatDisplayLabel) return formatDisplayLabel(time, timeFormat || (0, $RoXqn.defaultTimeFormat));
        const date = (0, $kdGko.default)(time);
        if (!(date instanceof Date)) return '';
        if (!(0, $dBLX0.default)(date)) return time;
        if (timeFormat) return (0, $57raR.default)(date, (0, $5PwWU.convertTokens)(timeFormat));
        return l10n.formatTime(date);
    };
    const options = times.map((time)=>{
        return {
            label: formatTime(time),
            value: time
        };
    });
    let initialValue;
    if (providedValue !== null && providedValue !== undefined && providedValue !== '') initialValue = {
        label: formatTime(providedValue),
        value: providedValue
    };
    else if (providedValue !== '' && value) initialValue = {
        label: formatTime(value),
        value: value
    };
    else initialValue = null;
    const SingleValue = (0, $7OE9J.makeSingleValue)({
        lang: locale
    });
    const selectComponents = {
        DropdownIndicator: (0, $RoXqn.EmptyComponent),
        Menu: (0, $icQS1.FixedLayerMenu),
        SingleValue: SingleValue,
        ...hideIcon && {
            ClearIndicator: (0, $RoXqn.EmptyComponent)
        }
    };
    const renderIconContainer = Boolean(!hideIcon && value);
    // @ts-ignore -- Argument of type 'StylesConfig<OptionType, false, GroupBase<OptionType>>' is not assignable to parameter of type 'StylesConfig<OptionType, boolean, GroupBase<OptionType>>'.
    const mergedStyles = (0, $e9zKl.mergeStyles)(selectStyles, {
        control: (base)=>({
                ...base
            }),
        menu: (base)=>({
                ...base,
                ...$bbd2b423b4bc9ae0$var$menuStyles,
                // Fixed positioned elements no longer inherit width from their parent, so we must explicitly set the
                // menu width to the width of our container
                width: containerRef ? containerRef.getBoundingClientRect().width : 'auto'
            }),
        indicatorsContainer: (base)=>({
                ...base,
                paddingLeft: renderIconContainer ? ICON_PADDING : 0,
                paddingRight: renderIconContainer ? GRID_SIZE - ICON_PADDING : 0
            })
    });
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        ...innerProps,
        ref: setInternalContainerRef,
        "data-testid": testId && `${testId}--container`,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("input", {
                name: name,
                type: "hidden",
                value: value,
                "data-testid": testId && `${testId}--input`,
                onKeyDown: onSelectKeyDown
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)(SelectComponent, {
                "aria-describedby": ariaDescribedBy,
                "aria-label": label || undefined,
                appearance: appearance,
                autoFocus: autoFocus,
                clearControlLabel: clearControlLabel,
                components: selectComponents,
                inputId: id,
                isClearable: true,
                isDisabled: isDisabled,
                isRequired: isRequired,
                menuIsOpen: isOpen && !isDisabled,
                menuPlacement: "auto",
                openMenuOnFocus: true,
                onBlur: onBlur,
                onCreateOption: onCreateOption,
                onChange: onChange,
                options: options,
                onFocus: onFocus,
                onMenuOpen: onMenuOpen,
                onMenuClose: onMenuClose,
                placeholder: placeholder || l10n.formatTime((0, $RoXqn.placeholderDatetime)),
                styles: mergedStyles,
                value: initialValue,
                spacing: spacing,
                // We need this to get things to work, even though it's not supported.
                // @ts-ignore
                fixedLayerRef: containerRef,
                isInvalid: isInvalid,
                testId: testId,
                ...otherSelectProps
            })
        ]
    });
});
var $bbd2b423b4bc9ae0$export$2e2bcd8739ae039 = $bbd2b423b4bc9ae0$var$TimePicker;

});
parcelRegister("icQS1", function(module, exports) {

$parcel$export(module.exports, "FixedLayerMenu", () => $c710cd93a504ed53$export$982ad994195b4356);
/* fixed-layer-menu.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6XEne = parcelRequire("6XEne");

var $7G7nX = parcelRequire("7G7nX");
const $c710cd93a504ed53$export$982ad994195b4356 = ({ className: className, clearValue: clearValue, cx: cx, getStyles: getStyles, getValue: getValue, hasValue: hasValue, innerProps: innerProps, innerRef: innerRef, isLoading: isLoading, isMulti: isMulti, isRtl: isRtl, maxMenuHeight: maxMenuHeight, menuPlacement: menuPlacement, menuPosition: menuPosition, menuShouldScrollIntoView: menuShouldScrollIntoView, minMenuHeight: minMenuHeight, options: options, placement: placement, selectOption: selectOption, selectProps: selectProps, setValue: setValue, children: children, ...rest })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $7G7nX.default), {
        inputValue: selectProps.inputValue,
        //@ts-ignore react-select unsupported props
        containerRef: selectProps.fixedLayerRef,
        content: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6XEne.components).Menu, {
            ...rest,
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            clearValue: clearValue,
            cx: cx,
            getStyles: getStyles,
            getValue: getValue,
            hasValue: hasValue,
            innerProps: innerProps,
            innerRef: innerRef,
            isLoading: isLoading,
            isMulti: isMulti,
            isRtl: isRtl,
            maxMenuHeight: maxMenuHeight,
            menuPlacement: menuPlacement,
            menuPosition: menuPosition,
            menuShouldScrollIntoView: menuShouldScrollIntoView,
            minMenuHeight: minMenuHeight,
            options: options,
            placement: placement,
            selectOption: selectOption,
            selectProps: selectProps,
            setValue: setValue,
            children: children
        }),
        //@ts-ignore react-select unsupported props
        testId: selectProps.testId
    });

});

parcelRegister("kdGko", function(module, exports) {

$parcel$export(module.exports, "default", () => $f14a3d51f762a0dc$export$2e2bcd8739ae039);
const $f14a3d51f762a0dc$var$map24 = {
    '12': '12',
    '01': '13',
    '02': '14',
    '03': '15',
    '04': '16',
    '05': '17',
    '06': '18',
    '07': '19',
    '08': '20',
    '09': '21',
    '10': '22',
    '11': '23'
};
function $f14a3d51f762a0dc$export$1ea939691cdc45b8(timeString) {
    /**
	 * Regex match for `12:34`, `12:34:56`, `1:23:56 p`, `1:23:56PM`, and a bit more…
	 */ const time = timeString.trim().match(/([012]?[\d])(?::([0-5][\d]))?(?::([0-5][\d]))?\s*([ap]m?)?/i);
    /**
	 * Regex match for `1234`, `12:34`, `12.34`, `123456`, `12:34:56`, `12.34.56`
	 */ const time24hr = timeString.trim().match(/([012][\d])[:.]?([0-5][\d])([:.]?([0-5][\d]))?/);
    /**
	 * Convert `2:34:56 pm` down to `23456`
	 */ const num = timeString.replace(/[^0-9]/g, '');
    const includesSeconds = time && time[1] !== undefined && time[2] !== undefined && time[3] !== undefined || time24hr && time24hr[1] !== undefined && time24hr[2] !== undefined && time24hr[4] !== undefined;
    if (!time && !time24hr) return false;
    if (time && !time[1]) return false;
    if (num.length > 6) return false;
    if (num.length > 4 && !includesSeconds) return false;
    if (num.length === 2 && parseInt(num, 10) > 12) return false;
    return true;
}
function $f14a3d51f762a0dc$export$49c81d9f91c512ce(time) {
    return time.replace(/[:.]/g, '');
}
function $f14a3d51f762a0dc$var$formatSemi24(time) {
    if (time.length === 1) return `0${time}00`;
    if (time.length === 2) return `${time}00`;
    if (time.length === 3 || time.length === 5) return `0${time}`;
    return time;
}
function $f14a3d51f762a0dc$var$checkHour(hour, meridiem) {
    if (hour > '24') return null;
    if (hour === '12' && meridiem === 'a') return '00';
    if (hour < '12' && meridiem === 'p') return $f14a3d51f762a0dc$var$map24[hour];
    return hour;
}
function $f14a3d51f762a0dc$var$checkMinuteSecond(value) {
    if (value > '59') return null;
    return value;
}
function $f14a3d51f762a0dc$export$6137ce2c9c5166bb(time) {
    const timeArray = time.toLowerCase().split(/(p|a)/i);
    const meridiem = timeArray[1];
    const semi24 = $f14a3d51f762a0dc$var$formatSemi24(timeArray[0].trim());
    const hour = $f14a3d51f762a0dc$var$checkHour(semi24.substring(0, 2), meridiem);
    const minute = $f14a3d51f762a0dc$var$checkMinuteSecond(semi24.substring(2, 4));
    const seconds = semi24.length === 6 && $f14a3d51f762a0dc$var$checkMinuteSecond(semi24.substring(4, 6));
    if (!hour || !minute) return null;
    return {
        hour: parseInt(hour, 10),
        minute: parseInt(minute, 10),
        seconds: parseInt(seconds || '0', 10) || 0
    };
}
function $f14a3d51f762a0dc$var$assignToDate(time) {
    const dateTime = new Date();
    dateTime.setHours(time.hour);
    dateTime.setMinutes(time.minute);
    // milliseconds is not supported
    dateTime.setSeconds(time.seconds || 0, 0);
    return dateTime;
}
function $f14a3d51f762a0dc$export$2e2bcd8739ae039(time) {
    const trimmedTime = time.toString().trim();
    if (!$f14a3d51f762a0dc$export$1ea939691cdc45b8(trimmedTime)) throw RangeError('invalid time format');
    const time1 = $f14a3d51f762a0dc$export$49c81d9f91c512ce(trimmedTime);
    const time2 = $f14a3d51f762a0dc$export$6137ce2c9c5166bb(time1);
    if (!time2) throw RangeError('invalid time format');
    return $f14a3d51f762a0dc$var$assignToDate(time2);
}

});



parcelRegister("gW6sD", function(module, exports) {

$parcel$export(module.exports, "default", () => $16c18c467fdc0432$export$2e2bcd8739ae039);
/* date-time-picker-fc.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $57raR = parcelRequire("57raR");
var $dBLX0 = parcelRequire("dBLX0");
var $kQ82p = parcelRequire("kQ82p");

var $jrFnt = parcelRequire("jrFnt");

var $Ay1uj = parcelRequire("Ay1uj");

var $5pWSu = parcelRequire("5pWSu");

var $eGOwo = parcelRequire("eGOwo");

var $8IeH1 = parcelRequire("8IeH1");
var $6djmC = parcelRequire("6djmC");

var $e9zKl = parcelRequire("e9zKl");

var $RoXqn = parcelRequire("RoXqn");

var $6EOrx = parcelRequire("6EOrx");

var $1BRZx = parcelRequire("1BRZx");

var $5PwWU = parcelRequire("5PwWU");

var $lLHJE = parcelRequire("lLHJE");

var $k2Uo2 = parcelRequire("k2Uo2");

var $fkh8F = parcelRequire("fkh8F");
const $16c18c467fdc0432$var$DatePicker = (0, $1BRZx.componentWithCondition)(// eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
()=>(0, $eGOwo.fg)('dst-date-picker-use-functional-component'), (0, $k2Uo2.default), (0, $lLHJE.default));
const $16c18c467fdc0432$var$packageName = "platform-pkg";
const $16c18c467fdc0432$var$packageVersion = "0.0.0-use.local";
const $16c18c467fdc0432$var$analyticsAttributes = {
    componentName: 'dateTimePicker',
    packageName: $16c18c467fdc0432$var$packageName,
    packageVersion: $16c18c467fdc0432$var$packageVersion
};
const $16c18c467fdc0432$var$compiledStyles = {
    datePickerContainerStyles: "_i0dl1ssb _16jlkb7n _1o9zidpf",
    timePickerContainerStyles: "_i0dl1ssb _16jlkb7n",
    iconContainerStyles: "_1e0c1txw _4cvr1h6o _i0dl1kw7"
}; // react-select overrides (via @atlaskit/select).
const $16c18c467fdc0432$var$styles = {
    control: (style)=>({
            ...style,
            backgroundColor: 'transparent',
            border: 2,
            borderRadius: 0,
            paddingLeft: 0,
            ':hover': {
                backgroundColor: 'transparent',
                cursor: 'inherit'
            }
        })
};
const $16c18c467fdc0432$export$3b559a1219cb3c27 = 'Date';
const $16c18c467fdc0432$export$d82cc7e53d68a428 = 'Time'; /**
                                                   * __Date time picker__
                                                   *
                                                   * A date time picker allows the user to select an associated date and time.
                                                   *
                                                   * - [Examples](https://atlassian.design/components/datetime-picker/examples)
                                                   * - [Code](https://atlassian.design/components/datetime-picker/code)
                                                   * - [Usage](https://atlassian.design/components/datetime-picker/usage)
                                                   */ 
const $16c18c467fdc0432$var$DateTimePicker = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ 'aria-describedby': ariaDescribedBy, appearance: appearance = 'default', autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'clear', datePickerProps: datePickerPropsWithSelectProps = {}, defaultValue: defaultValue = '', id: id = '', innerProps: innerProps = {}, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, name: name = '', onBlur: // These disables are here for proper typing when used as defaults. They
// should *not* use the `noop` function.
/* eslint-disable @repo/internal/react/use-noop */ onBlur = (_event)=>{}, onChange: onChangeProp = (_value)=>{}, onFocus: onFocus = (_event)=>{}, /* eslint-enable @repo/internal/react/use-noop */ parseValue: providedParseValue, spacing: spacing = 'default', locale: locale = 'en-US', testId: testId, timePickerProps: timePickerPropsWithSelectProps = {}, value: providedValue }, ref)=>{
    const [dateValue, setDateValue] = (0, $eJOHy.useState)(datePickerPropsWithSelectProps?.defaultValue || '');
    const [isFocused, setIsFocused] = (0, $eJOHy.useState)(false);
    const [timeValue, setTimeValue] = (0, $eJOHy.useState)(timePickerPropsWithSelectProps?.defaultValue || '');
    const [value, setValue] = (0, $eJOHy.useState)(defaultValue || '');
    const [zoneValue, setZoneValue] = (0, $eJOHy.useState)('');
    (0, $eJOHy.useEffect)(()=>{
        if (providedValue) setValue(providedValue);
    }, [
        providedValue
    ]);
    const parseValue = (0, $eJOHy.useCallback)((value, providedDateValue, providedTimeValue, providedZoneValue)=>{
        if (providedParseValue) {
            const parsedFromFn = providedParseValue(value, providedDateValue, providedTimeValue, providedZoneValue); // This handles cases found in Jira where the parse function actually does
            // nothing and returns undefined. The previous `getSafeState` function
            // just spread the values over the state, but if it returned `undefined`,
            // it would just rely on the previous state values. Considering this is
            // what is input to this function anyway, this is a safe way to handle
            // this, colocate the behavior, and not rely on `getSafeState`.
            return parsedFromFn || {
                dateValue: providedDateValue,
                timeValue: providedTimeValue,
                zoneValue: providedZoneValue
            };
        }
        const parsed = (0, $kQ82p.default)(value);
        return (0, $dBLX0.default)(parsed) ? {
            dateValue: (0, $57raR.default)(parsed, (0, $5PwWU.convertTokens)('YYYY-MM-DD')),
            timeValue: (0, $57raR.default)(parsed, (0, $5PwWU.convertTokens)('HH:mm')),
            zoneValue: (0, $57raR.default)(parsed, (0, $5PwWU.convertTokens)('ZZ'))
        } : {
            dateValue: dateValue,
            timeValue: timeValue,
            zoneValue: zoneValue
        };
    }, [
        providedParseValue,
        dateValue,
        timeValue,
        zoneValue
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const parsedValues = parseValue(value, dateValue, timeValue, zoneValue);
        setDateValue(parsedValues.dateValue);
        setTimeValue(parsedValues.timeValue);
        setZoneValue(parsedValues.zoneValue);
    }, [
        value,
        dateValue,
        timeValue,
        zoneValue,
        parseValue
    ]);
    const onDateBlur = (event)=>{
        setIsFocused(false);
        onBlur(event);
        if (datePickerPropsWithSelectProps?.onBlur) datePickerPropsWithSelectProps.onBlur(event);
    };
    const onTimeBlur = (event)=>{
        setIsFocused(false);
        onBlur(event);
        if (timePickerPropsWithSelectProps?.onBlur) timePickerPropsWithSelectProps.onBlur(event);
    };
    const onDateFocus = (event)=>{
        setIsFocused(false);
        onFocus(event);
        if (datePickerPropsWithSelectProps?.onFocus) datePickerPropsWithSelectProps.onFocus(event);
    };
    const onTimeFocus = (event)=>{
        setIsFocused(false);
        onFocus(event);
        if (timePickerPropsWithSelectProps?.onFocus) timePickerPropsWithSelectProps.onFocus(event);
    };
    const onDateChange = (dateValue)=>{
        const parsedValues = parseValue(value, dateValue, timeValue, zoneValue);
        onValueChange({
            providedDateValue: dateValue,
            providedTimeValue: parsedValues.timeValue,
            providedZoneValue: parsedValues.zoneValue
        });
        if (datePickerPropsWithSelectProps?.onChange) datePickerPropsWithSelectProps.onChange(dateValue);
    };
    const onTimeChange = (timeValue)=>{
        const parsedValues = parseValue(value, dateValue, timeValue, zoneValue);
        onValueChange({
            providedDateValue: parsedValues.dateValue,
            providedTimeValue: timeValue,
            providedZoneValue: parsedValues.zoneValue
        });
        if (timePickerPropsWithSelectProps?.onChange) timePickerPropsWithSelectProps.onChange(timeValue);
    };
    const onClear = ()=>{
        const parsedValues = parseValue(value, dateValue, timeValue, zoneValue);
        onValueChange({
            providedDateValue: '',
            providedTimeValue: '',
            providedZoneValue: parsedValues.zoneValue
        });
        if (datePickerPropsWithSelectProps?.onChange) datePickerPropsWithSelectProps.onChange('');
        if (timePickerPropsWithSelectProps?.onChange) timePickerPropsWithSelectProps.onChange('');
    };
    const onChangePropWithAnalytics = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: onChangeProp,
        action: 'selectedDate',
        actionSubject: 'datePicker',
        ...$16c18c467fdc0432$var$analyticsAttributes
    });
    const onValueChange = ({ providedDateValue: providedDateValue, providedTimeValue: providedTimeValue, providedZoneValue: providedZoneValue })=>{
        setDateValue(providedDateValue);
        setTimeValue(providedTimeValue);
        setZoneValue(providedZoneValue);
        if (providedDateValue && providedTimeValue) {
            const value = (0, $RoXqn.formatDateTimeZoneIntoIso)(providedDateValue, providedTimeValue, providedZoneValue);
            const { zoneValue: parsedZone } = parseValue(value, providedDateValue, providedTimeValue, providedZoneValue);
            const valueWithValidZone = (0, $RoXqn.formatDateTimeZoneIntoIso)(providedDateValue, providedTimeValue, parsedZone);
            setValue(valueWithValidZone);
            onChangePropWithAnalytics(valueWithValidZone); // If the date or time value was cleared when there is an existing datetime value, then clear the value.
        } else if (value) {
            setValue('');
            onChangePropWithAnalytics('');
        }
    };
    const { selectProps: datePickerSelectProps, ...datePickerProps } = datePickerPropsWithSelectProps;
    const datePickerAriaDescribedBy = datePickerProps['aria-describedby'] || ariaDescribedBy;
    const datePickerLabel = datePickerProps.label || $16c18c467fdc0432$export$3b559a1219cb3c27;
    const mergedDatePickerSelectProps = {
        ...datePickerSelectProps,
        styles: (0, $e9zKl.mergeStyles)($16c18c467fdc0432$var$styles, datePickerSelectProps?.styles)
    };
    const { selectProps: timePickerSelectProps, ...timePickerProps } = timePickerPropsWithSelectProps;
    const timePickerAriaDescribedBy = timePickerProps['aria-describedby'] || ariaDescribedBy;
    const timePickerLabel = timePickerProps.label || $16c18c467fdc0432$export$d82cc7e53d68a428;
    const mergedTimePickerSelectProps = {
        ...timePickerSelectProps,
        styles: (0, $e9zKl.mergeStyles)($16c18c467fdc0432$var$styles, timePickerSelectProps?.styles)
    }; // Render DateTimePicker's IconContainer when a value has been filled
    // Don't use Date or TimePicker's because they can't be customised
    const isClearable = Boolean(dateValue || timeValue);
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6EOrx.DateTimePickerContainer), {
        appearance: appearance,
        isDisabled: isDisabled,
        isFocused: isFocused,
        isInvalid: isInvalid,
        testId: testId,
        innerProps: innerProps,
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("input", {
                name: name,
                type: "hidden",
                value: value,
                "data-testid": testId && `${testId}--input`
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                xcss: $16c18c467fdc0432$var$compiledStyles.datePickerContainerStyles,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)($16c18c467fdc0432$var$DatePicker, {
                    appearance: appearance,
                    "aria-describedby": datePickerAriaDescribedBy,
                    autoFocus: datePickerProps.autoFocus || autoFocus,
                    dateFormat: datePickerProps.dateFormat,
                    defaultIsOpen: datePickerProps.defaultIsOpen,
                    defaultValue: datePickerProps.defaultValue,
                    disabled: datePickerProps.disabled,
                    disabledDateFilter: datePickerProps.disabledDateFilter,
                    formatDisplayLabel: datePickerProps.formatDisplayLabel,
                    hideIcon: datePickerProps.hideIcon || true,
                    icon: datePickerProps.icon,
                    id: datePickerProps.id || id,
                    innerProps: datePickerProps.innerProps,
                    inputLabel: datePickerProps.inputLabel,
                    inputLabelId: datePickerProps.inputLabelId,
                    isDisabled: datePickerProps.isDisabled || isDisabled,
                    isInvalid: datePickerProps.isInvalid || isInvalid,
                    isOpen: datePickerProps.isOpen,
                    isRequired: datePickerProps.isRequired || isRequired,
                    label: datePickerLabel,
                    locale: datePickerProps.locale || locale,
                    maxDate: datePickerProps.maxDate,
                    minDate: datePickerProps.minDate,
                    name: datePickerProps.name,
                    nextMonthLabel: datePickerProps.nextMonthLabel,
                    onBlur: onDateBlur,
                    onChange: onDateChange,
                    onFocus: onDateFocus,
                    openCalendarLabel: datePickerProps.openCalendarLabel,
                    parseInputValue: datePickerProps.parseInputValue,
                    placeholder: datePickerProps.placeholder,
                    previousMonthLabel: datePickerProps.previousMonthLabel,
                    selectProps: mergedDatePickerSelectProps,
                    shouldShowCalendarButton: datePickerProps.shouldShowCalendarButton,
                    spacing: datePickerProps.spacing || spacing,
                    testId: testId && `${testId}--datepicker` || datePickerProps.testId,
                    value: dateValue,
                    weekStartDay: datePickerProps.weekStartDay
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                xcss: $16c18c467fdc0432$var$compiledStyles.timePickerContainerStyles,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $fkh8F.default), {
                    appearance: timePickerProps.appearance || appearance,
                    "aria-describedby": timePickerAriaDescribedBy,
                    autoFocus: timePickerProps.autoFocus,
                    defaultIsOpen: timePickerProps.defaultIsOpen,
                    defaultValue: timePickerProps.defaultValue,
                    formatDisplayLabel: timePickerProps.formatDisplayLabel,
                    hideIcon: timePickerProps.hideIcon || true,
                    id: timePickerProps.id,
                    innerProps: timePickerProps.innerProps,
                    isDisabled: timePickerProps.isDisabled || isDisabled,
                    isInvalid: timePickerProps.isInvalid || isInvalid,
                    isOpen: timePickerProps.isOpen,
                    isRequired: timePickerProps.isRequired || isRequired,
                    label: timePickerLabel,
                    locale: timePickerProps.locale || locale,
                    name: timePickerProps.name,
                    onBlur: onTimeBlur,
                    onChange: onTimeChange,
                    onFocus: onTimeFocus,
                    parseInputValue: timePickerProps.parseInputValue,
                    placeholder: timePickerProps.placeholder,
                    selectProps: mergedTimePickerSelectProps,
                    spacing: timePickerProps.spacing || spacing,
                    testId: timePickerProps.testId || testId && `${testId}--timepicker`,
                    timeFormat: timePickerProps.timeFormat,
                    timeIsEditable: timePickerProps.timeIsEditable,
                    times: timePickerProps.times,
                    value: timeValue
                })
            }),
            isClearable && !isDisabled ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6djmC.default), {
                xcss: $16c18c467fdc0432$var$compiledStyles.iconContainerStyles,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
                    appearance: "subtle",
                    label: clearControlLabel,
                    icon: (iconProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5pWSu))), {
                            ...iconProps,
                            color: "var(--ds-text-subtlest, #626F86)",
                            LEGACY_size: "small",
                            size: "small"
                        }),
                    onClick: onClear,
                    testId: testId && `${testId}--icon--container`,
                    tabIndex: -1
                })
            }) : null
        ]
    });
});
var $16c18c467fdc0432$export$2e2bcd8739ae039 = $16c18c467fdc0432$var$DateTimePicker;

});


parcelRegister("igoRN", function(module, exports) {

$parcel$export(module.exports, "default", () => $cfac6f159c013af7$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import/no-anonymous-default-export
var $cfac6f159c013af7$export$2e2bcd8739ae039 = [
    '00:00',
    '00:30',
    '01:00',
    '01:30',
    '02:00',
    '02:30',
    '03:00',
    '03:30',
    '04:00',
    '04:30',
    '05:00',
    '05:30',
    '06:00',
    '06:30',
    '07:00',
    '07:30',
    '08:00',
    '08:30',
    '09:00',
    '09:30',
    '10:00',
    '10:30',
    '11:00',
    '11:30',
    '12:00',
    '12:30',
    '13:00',
    '13:30',
    '14:00',
    '14:30',
    '15:00',
    '15:30',
    '16:00',
    '16:30',
    '17:00',
    '17:30',
    '18:00',
    '18:30',
    '19:00',
    '19:30',
    '20:00',
    '20:30',
    '21:00',
    '21:30',
    '22:00',
    '22:30',
    '23:00',
    '23:30'
];

});

parcelRegister("dXU8v", function(module, exports) {

$parcel$export(module.exports, "TimeEstimate", () => $9d4787de2fb8bbbb$export$ad441edf1beb0bda);

var $eJOHy = parcelRequire("eJOHy");

var $fKXve = parcelRequire("fKXve");

var $3Isp2 = parcelRequire("3Isp2");

var $sY9BV = parcelRequire("sY9BV");

var $k71qx = parcelRequire("k71qx");

var $lRq8t = parcelRequire("lRq8t");

var $169bb = parcelRequire("169bb");

var $fwzaq = parcelRequire("fwzaq");

var $auSvY = parcelRequire("auSvY");

var $fcf88 = parcelRequire("fcf88");
const $9d4787de2fb8bbbb$export$ad441edf1beb0bda = (props)=>{
    const { value: value, placeholder: placeholder = '2w 1d 5h 4m', onChange: onChange, config: config, shouldShowWarning: shouldShowWarning, fieldId: fieldId, ...fieldProps } = props;
    const [isIncorrectTimeFormat, setIsIncorrectTimeFormat] = (0, $eJOHy.useState)(false);
    const [debouncedIsValidTimeString] = (0, $fwzaq.default)((inputValue)=>setIsIncorrectTimeFormat(!(0, $169bb.isValidTimeString)(config)(inputValue)), 500);
    (0, $eJOHy.useEffect)(()=>{
        debouncedIsValidTimeString(value);
    }, [
        value,
        debouncedIsValidTimeString
    ]);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onValueChange = (e)=>{
        const { value: inputValue } = e.target;
        onChange(inputValue);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $sY9BV.default), {
        ...fieldProps,
        testId: (0, $fcf88.DATA_TEST_IDS).TEXT_FIELD,
        ...fieldId && {
            'aria-describedby': `${fieldId}-field-message`
        },
        type: "text",
        value: value,
        placeholder: placeholder,
        onChange: onValueChange,
        isInvalid: isIncorrectTimeFormat,
        "aria-label": formatMessage((0, $auSvY.default).ariaLabel),
        elemAfterInput: shouldShowWarning === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
            content: formatMessage((0, $auSvY.default).timeLoggedExceeded),
            testId: (0, $fcf88.DATA_TEST_IDS).TOOLTIP
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3Isp2))), {
            LEGACY_size: "medium",
            spacing: "spacious",
            label: formatMessage((0, $auSvY.default).warning),
            color: "var(--ds-icon-warning, #E56910)",
            testId: (0, $fcf88.DATA_TEST_IDS).WARNING_ICON
        })) : null
    }), isIncorrectTimeFormat && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fKXve.ErrorMessage), {
        testId: (0, $fcf88.DATA_TEST_IDS).ERROR_MESSAGE
    }, formatMessage((0, $auSvY.default).invalidDateFormat)));
};

});
parcelRegister("fwzaq", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab2d121bc64be0a3$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $3s8bj = parcelRequire("3s8bj");
function $ab2d121bc64be0a3$export$2e2bcd8739ae039(callback, delay, options) {
    const optionsRef = (0, $eJOHy.useRef)(options);
    // @ts-expect-error - TS7019 - Rest parameter 'args' implicitly has an 'any[]' type.
    const callbackRef = (0, $eJOHy.useRef)((...args)=>{
        callback(...args);
    });
    callbackRef.current = callback;
    const debouncedCallBack = (0, $eJOHy.useMemo)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ()=>(0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))((...args)=>callbackRef.current(...args), delay, optionsRef.current), [
        delay
    ]);
    (0, $eJOHy.useEffect)(()=>debouncedCallBack.cancel, [
        debouncedCallBack
    ]);
    return [
        debouncedCallBack,
        debouncedCallBack.cancel
    ];
}

});

parcelRegister("auSvY", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3d04fa1ab9fadde$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $e3d04fa1ab9fadde$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    invalidDateFormat: {
        "id": "issue-time-estimate.edit.invalid-date-format",
        "defaultMessage": "Please enter date in the correct format"
    },
    warning: {
        "id": "issue-time-estimate.edit.warning",
        "defaultMessage": "warning"
    },
    timeLoggedExceeded: {
        "id": "issue-time-estimate.edit.time-logged-exceeded",
        "defaultMessage": "Time logged has exceeded the limit"
    },
    ariaLabel: {
        "id": "issue-time-estimate.edit.aria-label",
        "defaultMessage": "Enter the estimated time"
    }
});

});

parcelRegister("fcf88", function(module, exports) {

$parcel$export(module.exports, "DATA_TEST_IDS", () => $8776ce352b6b2772$export$3e5d0cbd910e9c20);

const $8776ce352b6b2772$var$getItemDataTestId = (itemId)=>`${0, $4c8e787e6786a1be$export$7c86105e5fb6a1ce}${itemId}`;
const $8776ce352b6b2772$export$96f42c00fe93c7cb = (itemDataTestId)=>`[data-testid="${itemDataTestId}"]`;
const $8776ce352b6b2772$export$3e5d0cbd910e9c20 = {
    TEXT_FIELD: $8776ce352b6b2772$var$getItemDataTestId('text-field'),
    TOOLTIP: $8776ce352b6b2772$var$getItemDataTestId('tooltip'),
    WARNING_ICON: $8776ce352b6b2772$var$getItemDataTestId('warning_icon'),
    ERROR_MESSAGE: $8776ce352b6b2772$var$getItemDataTestId('error-message')
};

});
const $4c8e787e6786a1be$export$94514aa565518249 = '1w 1m';
const $4c8e787e6786a1be$export$38009905af1d42b = 'Invalid data';
const $4c8e787e6786a1be$export$7c86105e5fb6a1ce = 'issue-time-estimate.ui.edit.';



const $b0689309ab31cde3$export$d7ed3a061805d786 = 'log-work-time-remaining';
const $b0689309ab31cde3$export$81fee17d19007357 = 'log-work-time-spent';
const $b0689309ab31cde3$export$ade7f171d00a976f = 'log-work-date-field';
const $b0689309ab31cde3$export$caca24db5cb49b68 = 'log-work-description';

parcelRegister("1zMym", function(module, exports) {

$parcel$export(module.exports, "default", () => $3286ba9c4510b75f$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $3286ba9c4510b75f$var$messages = (0, $7qGN1.defineMessages)({
    timeSpent: {
        "id": "issue-create-commons.log-work-field.time-spent",
        "defaultMessage": "Time Spent"
    },
    timeRemaining: {
        "id": "issue-create-commons.log-work-field.time-remaining",
        "defaultMessage": "Time Remaining"
    },
    dateStarted: {
        "id": "issue-create-commons.log-work-field.date-started",
        "defaultMessage": "Date Started"
    },
    description: {
        "id": "issue-create-commons.log-work-field.description",
        "defaultMessage": "Work Description"
    },
    originalEstimateExceededNonFinal: {
        "id": "issue-create-commons.log-work-field.original-estimate-exceeded-non-final",
        "defaultMessage": "Time logged has exceeded the original estimate"
    },
    logWorkLabel: {
        "id": "issue-create-commons.log-work-field.log-work-label",
        "defaultMessage": "Log Work"
    }
});
var $3286ba9c4510b75f$export$2e2bcd8739ae039 = $3286ba9c4510b75f$var$messages;

});



parcelRegister("6zGZo", function(module, exports) {

$parcel$export(module.exports, "ParentLinkField", () => $cf2679ed3cc36f6a$export$79fe3354f3cc0f9b);

var $eJOHy = parcelRequire("eJOHy");

var $cYK8z = parcelRequire("cYK8z");
const $cf2679ed3cc36f6a$export$79fe3354f3cc0f9b = ({ useFormContext: useFormContext, ...commonParentLinkFieldProps })=>{
    // eslint-disable-next-line react-hooks/react-compiler
    const [{ isEpicLinkSelected: isEpicLinkSelected, selectedIssueType: selectedIssueType, requestBackedIssueType: requestBackedIssueType }] = useFormContext();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cYK8z.default), {
        ...commonParentLinkFieldProps,
        isEpicLinkSelected: isEpicLinkSelected,
        selectedIssueTypeLabel: requestBackedIssueType?.label ?? selectedIssueType?.label ?? '',
        selectedIssueTypeId: requestBackedIssueType?.value ?? selectedIssueType?.value ?? ''
    });
};

});
parcelRegister("cYK8z", function(module, exports) {

$parcel$export(module.exports, "default", () => $160fc59833358e2b$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $b3D89 = parcelRequire("b3D89");

var $fE4zR = parcelRequire("fE4zR");

var $2nXHu = parcelRequire("2nXHu");

var $dYGpH = parcelRequire("dYGpH");
const $160fc59833358e2b$var$ParentLinkField = (props)=>{
    const { width: width } = props;
    // We are disabling the Epic Link and Parent Link fields for taking input and instead displaying that the user should
    // use the Parent field to set the Parent of the issue as part of migrating to a single way of representing Jira's hierarchy.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fE4zR.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b3D89.DisabledEpicLinkParentLinkField), null));
};
var $160fc59833358e2b$export$2e2bcd8739ae039 = (0, $2nXHu.withFormField)({
    validator: (0, $dYGpH.validateParentLinkField)
})($160fc59833358e2b$var$ParentLinkField);

});
parcelRegister("dYGpH", function(module, exports) {

$parcel$export(module.exports, "validateParentLinkField", () => $702f34a7637c0632$export$7c8f88cf8f7b8100);

var $3UrQk = parcelRequire("3UrQk");
const $702f34a7637c0632$export$7c8f88cf8f7b8100 = (data, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
isRequired)=>{
    if (isRequired) {
        if (!data) return 0, $3UrQk.REQUIRED;
    }
    return undefined;
};

});



parcelRegister("62HU2", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c6302b18fe34060$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $c4OV1 = parcelRequire("c4OV1");

var $k71qx = parcelRequire("k71qx");

var $lRq8t = parcelRequire("lRq8t");

var $fE4zR = parcelRequire("fE4zR");

var $2nXHu = parcelRequire("2nXHu");

var $ixdDB = parcelRequire("ixdDB");

var $9QSSI = parcelRequire("9QSSI");

var $aUMMA = parcelRequire("aUMMA");

var $lwrbx = parcelRequire("lwrbx");

var $9Lt0p = parcelRequire("9Lt0p");

const $1c6302b18fe34060$var$SecurityLevelField = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { fieldId: fieldId, fieldProps: { value: value = [], onChange: onChange, ...fieldProps }, error: error, allowedValues: allowedValues, width: width, autoFocus: autoFocus = false, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, $ixdDB.closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, isEditable: isEditable = true, nonEditableReason: nonEditableReason, inputId: inputId } = props;
    const option = (0, $9Lt0p.mapOptionsToData)(allowedValues);
    const isInvalid = Boolean(error);
    const getSecurityLevelField = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c4OV1.default), {
            inputId: inputId,
            ...fieldProps,
            options: option,
            // @ts-expect-error - TS2322 - Type '(value: SecurityLevelOption) => void' is not assignable to type '(value: Option | null, action: ActionMeta<Option>) => void'.
            onChange: onChange,
            value: value,
            placeholder: formatMessage((0, $lwrbx.default).securityLevelFieldPlaceHolder),
            isClearable: true,
            formatOptionLabel: (0, $9QSSI.formatOptionLabel),
            menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides -- Ignored via go/DSP-18766
            styles: (0, $aUMMA.defaultSelectStyles),
            hideSelectedOptions: false,
            isMulti: false,
            autoFocus: autoFocus,
            // @ts-expect-error - TS2322 - Type '"error" | null' is not assignable to type 'ValidationState | undefined'.
            validationState: isInvalid === true ? 'error' : null,
            classNamePrefix: `select-${fieldId}`,
            // @ts-expect-error - TS2322 - Type '(e: ChangeEvent<HTMLElement>) => boolean' is not assignable to type 'boolean | EventListener | undefined'.
            closeMenuOnScroll: onCloseMenuOnScroll,
            isDisabled: isEditable === false
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fE4zR.FieldContainer), {
        width: width
    }, isEditable === false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: nonEditableReason?.message || ''
    }, getSecurityLevelField()) : getSecurityLevelField());
};
var $1c6302b18fe34060$export$2e2bcd8739ae039 = (0, $2nXHu.withFormField)({
    transformDefaultValue: (0, $9Lt0p.mapOptionToData)
})($1c6302b18fe34060$var$SecurityLevelField);

});
parcelRegister("lwrbx", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5397086271f9a3d$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $b5397086271f9a3d$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    securityLevelFieldPlaceHolder: {
        "id": "issue-create.common.fields.security-level-field.security-level-field-place-holder",
        "defaultMessage": "Select Security Level"
    }
});

});

parcelRegister("9Lt0p", function(module, exports) {

$parcel$export(module.exports, "transformOnSubmit", () => $821a8af6b31be419$export$33ec7c3df92f1cc6);
$parcel$export(module.exports, "mapOptionsToData", () => $821a8af6b31be419$export$ffef3a401aef987b);
$parcel$export(module.exports, "mapOptionToData", () => $821a8af6b31be419$export$fc800909123977f3);
$parcel$export(module.exports, "mutateSecurityLevelField", () => $821a8af6b31be419$export$f62a060ad7017e66);
const $821a8af6b31be419$export$33ec7c3df92f1cc6 = (option)=>{
    const { label: label, value: value } = option;
    return {
        name: label,
        id: value
    };
};
const $821a8af6b31be419$export$ffef3a401aef987b = (options)=>options.map(({ name: name, id: id, description: description })=>({
            label: name,
            value: id,
            description: description
        }));
const $821a8af6b31be419$export$fc800909123977f3 = (option)=>{
    if (option) {
        const { name: name, id: id, description: description } = option;
        return {
            label: name,
            value: id,
            description: description
        };
    }
    return null;
};
const $821a8af6b31be419$export$f62a060ad7017e66 = (selectedSecurityLevel)=>({
        security: {
            securityLevelId: selectedSecurityLevel.value
        }
    });

});


parcelRegister("7fkTS", function(module, exports) {

$parcel$export(module.exports, "default", () => $b42df6b4a79b4d70$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $fE4zR = parcelRequire("fE4zR");

var $jyoOv = parcelRequire("jyoOv");

var $jQUoP = parcelRequire("jQUoP");

var $eebhl = parcelRequire("eebhl");

var $1Baxt = parcelRequire("1Baxt");
const $b42df6b4a79b4d70$var$TimeTrackingField = (props)=>{
    // the reason we are transforming the default value here instead of options object in the with form field wrapper is because time tracking settings also need to be passed to transform the default value. Right now, there is no way to pass props to the generic transformDefaultValue invocation in with form field
    const [transformedDefaultValue, setTransformedDefaultValue] = (0, $eJOHy.useState)(undefined);
    const { defaultValue: defaultValue, additionalData: { timeTrackingSettings: timeTrackingSettings }, width: width = 350, isMini: isMini, isFieldResponsive: isFieldResponsive } = props;
    (0, $eJOHy.useEffect)(()=>{
        if (typeof defaultValue === 'string') setTransformedDefaultValue(defaultValue.trim());
        else if (defaultValue?.timeInSeconds) setTransformedDefaultValue((0, $eebhl.default)(timeTrackingSettings.daysPerWeek, timeTrackingSettings.hoursPerDay)(defaultValue.timeInSeconds));
    }, [
        defaultValue,
        timeTrackingSettings.hoursPerDay,
        timeTrackingSettings.daysPerWeek
    ]);
    const [, { setTimeTrackingValue: setTimeTrackingValue }] = (0, $jQUoP.useFormContext)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const shouldSetWidth = isMini || isFieldResponsive;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fE4zR.FieldContainer), {
        width: shouldSetWidth ? '100%' : width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jyoOv.default), {
        ...props,
        fieldName: formatMessage((0, $1Baxt.default).timeTrackingFieldName),
        defaultValue: transformedDefaultValue,
        setValueExternal: setTimeTrackingValue
    }));
};
var $b42df6b4a79b4d70$export$2e2bcd8739ae039 = $b42df6b4a79b4d70$var$TimeTrackingField;

});
parcelRegister("jyoOv", function(module, exports) {

$parcel$export(module.exports, "default", () => $869b051550ad78ae$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $dXU8v = parcelRequire("dXU8v");

var $2nXHu = parcelRequire("2nXHu");

var $2bwtl = parcelRequire("2bwtl");
const $869b051550ad78ae$export$1c882bff9d1eb3f8 = (props)=>{
    const { fieldProps: { value: value = '', onChange: onChange, ...fieldProps }, setValueExternal: setValueExternal, additionalData: { timeTrackingSettings: config }, fieldId: fieldId } = props;
    const onTimeEstimateChange = (timeEstimateValue)=>{
        onChange(timeEstimateValue);
        setValueExternal(timeEstimateValue);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dXU8v.TimeEstimate), {
        ...fieldProps,
        fieldId: fieldId,
        value: value,
        onChange: onTimeEstimateChange,
        config: config
    });
};
var $869b051550ad78ae$export$2e2bcd8739ae039 = (0, $2nXHu.withFormField)({
    validator: (0, $2bwtl.validateTimeTrackingField)
})($869b051550ad78ae$export$1c882bff9d1eb3f8);

});
parcelRegister("2bwtl", function(module, exports) {

$parcel$export(module.exports, "validateTimeTrackingField", () => $afefdaa31a312ce4$export$8efa03d1ab1ed811);

var $3UrQk = parcelRequire("3UrQk");
const $afefdaa31a312ce4$export$8efa03d1ab1ed811 = (value, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
isRequired)=>{
    if (isRequired) {
        if (value === '' || value === undefined) return 0, $3UrQk.REQUIRED;
    }
    return undefined;
};

});


parcelRegister("1Baxt", function(module, exports) {

$parcel$export(module.exports, "default", () => $f81d27390836b75d$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $f81d27390836b75d$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    timeTrackingFieldName: {
        "id": "issue-create.common.fields.time-tracking-field.time-tracking-field-name",
        "defaultMessage": "Original Estimate"
    }
});

});


parcelRegister("cRn23", function(module, exports) {

$parcel$export(module.exports, "transformTimeTrackingValueToSubmitFormat", () => $081f0d2e6b51c8e6$export$d089c9dd815e4fcf);
$parcel$export(module.exports, "mutateTimeTrackingField", () => $081f0d2e6b51c8e6$export$9b1f0b2fd734a97);
const $081f0d2e6b51c8e6$export$d089c9dd815e4fcf = (value)=>({
        originalEstimate: value
    });
const $081f0d2e6b51c8e6$export$9b1f0b2fd734a97 = (estimate)=>({
        timeTrackingField: {
            originalEstimate: estimate
        }
    });

});


parcelRegister("ka5CK", function(module, exports) {

$parcel$export(module.exports, "transformProjects", () => $60eed891546b1acd$export$227473965d2e27db);
$parcel$export(module.exports, "transformProjectField", () => $60eed891546b1acd$export$1fd74e5690ffdae3);
$parcel$export(module.exports, "transformIssueTypeField", () => $60eed891546b1acd$export$ab55267390bbb31a);
$parcel$export(module.exports, "transformRequestTypeField", () => $60eed891546b1acd$export$fdb2672a21ca2149);

var $9Dhvc = parcelRequire("9Dhvc");


var $5acEa = parcelRequire("5acEa");
const $60eed891546b1acd$export$b4c0e0af0a6f8454 = ({ id: id, name: name, avatar: avatar, projectType: projectType, simplified: simplified, key: key, classificationTags: classificationTags = [] })=>({
        label: `${name} (${key})`,
        value: id,
        iconUrl: avatar.large,
        // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'ProjectType'.
        projectType: projectType && projectType.toLowerCase(),
        projectKey: key,
        isSimplified: simplified,
        classificationTags: classificationTags
    });
const $60eed891546b1acd$export$227473965d2e27db = (projects)=>projects.map((project)=>$60eed891546b1acd$export$b4c0e0af0a6f8454(project));
const $60eed891546b1acd$export$1fd74e5690ffdae3 = (projectResponse)=>{
    const { project: project, ...rest } = projectResponse;
    return {
        ...rest,
        selectedProject: project ? $60eed891546b1acd$export$b4c0e0af0a6f8454(project) : null
    };
};
const $60eed891546b1acd$export$b1a9eea64f6538d1 = ({ id: id, name: name, avatar: avatar })=>({
        label: name,
        value: id,
        iconUrl: avatar.large,
        type: (0, $4246188a36de9908$export$ebb48b08205007c5)
    });
const $60eed891546b1acd$export$4c05e2584b34e4d8 = (issueTypes)=>issueTypes.map((issueType)=>$60eed891546b1acd$export$b1a9eea64f6538d1(issueType));
const $60eed891546b1acd$export$ab55267390bbb31a = (issueTypeResponse)=>{
    const { issueType: issueType, ...rest } = issueTypeResponse;
    const issueTypes = (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(issueTypeResponse, 'issueTypes.nodes', []);
    return {
        ...rest,
        selectedIssueType: issueType ? $60eed891546b1acd$export$b1a9eea64f6538d1(issueType) : null,
        issueTypes: $60eed891546b1acd$export$4c05e2584b34e4d8(issueTypes)
    };
};
const $60eed891546b1acd$export$566fd29819ab2bab = ({ requestTypeId: requestTypeId, name: name, description: description, helpText: helpText, key: key, avatar: avatar, issueType: { issueTypeId: issueTypeId, issueTypeName: issueTypeName }, practices: practices }, hasPractice)=>({
        label: name,
        description: description || '',
        helpText: helpText || '',
        value: `${issueTypeId}-${requestTypeId}`,
        iconUrl: (0, $5acEa.transformStargateUrl)(avatar.large || ''),
        requestTypeKey: key,
        issueTypeId: issueTypeId,
        issueTypeName: issueTypeName,
        practice: (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(practices, '0.key', hasPractice ? (0, $4246188a36de9908$export$c835df30ebbd529d) : (0, $4246188a36de9908$export$92ab80c1dc9baf44)),
        type: (0, $4246188a36de9908$export$92ab80c1dc9baf44)
    });
const $60eed891546b1acd$export$d3b8217e83b5a13c = (requestTypes)=>{
    const hasPractice = requestTypes.some((rt)=>rt.practices.length > 0);
    // sort request types alphabetically
    return requestTypes.map((requestType)=>$60eed891546b1acd$export$566fd29819ab2bab(requestType, hasPractice)).sort((a, b)=>a.label.localeCompare(b.label));
};
const $60eed891546b1acd$export$fdb2672a21ca2149 = (requestTypeResponse)=>{
    const { requestType: requestType, ...rest } = requestTypeResponse;
    const requestTypes = (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(requestTypeResponse, 'requestTypes.nodes', []);
    const hasPractice = requestTypes.some((rt)=>rt.practices.length > 0);
    return {
        ...rest,
        selectedRequestType: requestType ? $60eed891546b1acd$export$566fd29819ab2bab(requestType, hasPractice) : null,
        requestTypes: $60eed891546b1acd$export$d3b8217e83b5a13c(requestTypes)
    };
};

});

parcelRegister("TPbEE", function(module, exports) {

$parcel$export(module.exports, "getGqlUnsupportedFields", () => $13b57db15fd5695a$export$3e4be29f4f96b2d7);
$parcel$export(module.exports, "getQueryErrorMessage", () => $13b57db15fd5695a$export$778f621df988f2dc);

var $9Dhvc = parcelRequire("9Dhvc");

const $13b57db15fd5695a$export$3e4be29f4f96b2d7 = (errors)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const unsupportedFields = {};
    let isRequiredFieldTypeSupported = true;
    errors.forEach(({ identifier: identifier, extensions: extensions })=>{
        const { __typename: gqlType } = extensions[0] || {};
        if (gqlType === (0, $4246188a36de9908$export$b171488d52070cb3) && // @ts-expect-error - TS2339 - Property 'fieldName' does not exist on type '{ fieldName: string; fieldType: string; isRequiredField: boolean; isUserPreferredField: boolean; __typename: "JiraIssueFieldUnsupportedErrorExtension"; } | { errorType: string; message: string; __typename: "JiraIssueFieldValueValidationErrorExtension"; }'.
        typeof extensions[0].fieldName === 'string' && // @ts-expect-error - TS2339 - Property 'isRequiredField' does not exist on type '{ fieldName: string; fieldType: string; isRequiredField: boolean; isUserPreferredField: boolean; __typename: "JiraIssueFieldUnsupportedErrorExtension"; } | { errorType: string; message: string; __typename: "JiraIssueFieldValueValidationErrorExtension"; }'.
        typeof extensions[0].isRequiredField === 'boolean' && // @ts-expect-error - TS2339 - Property 'fieldType' does not exist on type '{ fieldName: string; fieldType: string; isRequiredField: boolean; isUserPreferredField: boolean; __typename: "JiraIssueFieldUnsupportedErrorExtension"; } | { errorType: string; message: string; __typename: "JiraIssueFieldValueValidationErrorExtension"; }'.
        typeof extensions[0].fieldType === 'string') {
            // @ts-expect-error - TS2339 - Property 'fieldName' does not exist on type '{ fieldName: string; fieldType: string; isRequiredField: boolean; isUserPreferredField: boolean; __typename: "JiraIssueFieldUnsupportedErrorExtension"; } | { errorType: string; message: string; __typename: "JiraIssueFieldValueValidationErrorExtension"; }'. | TS2339 - Property 'fieldType' does not exist on type '{ fieldName: string; fieldType: string; isRequiredField: boolean; isUserPreferredField: boolean; __typename: "JiraIssueFieldUnsupportedErrorExtension"; } | { errorType: string; message: string; __typename: "JiraIssueFieldValueValidationErrorExtension"; }'. | TS2339 - Property 'isRequiredField' does not exist on type '{ fieldName: string; fieldType: string; isRequiredField: boolean; isUserPreferredField: boolean; __typename: "JiraIssueFieldUnsupportedErrorExtension"; } | { errorType: string; message: string; __typename: "JiraIssueFieldValueValidationErrorExtension"; }'.
            const { fieldName: fieldName, fieldType: fieldType, isRequiredField: isRequiredField } = extensions[0];
            unsupportedFields[identifier] = {
                gqlType: gqlType,
                fieldId: identifier,
                fieldName: fieldName,
                fieldType: fieldType,
                isRequired: isRequiredField
            };
            if (isRequiredField) isRequiredFieldTypeSupported = false;
        }
    });
    return {
        unsupportedFields: unsupportedFields,
        isRequiredFieldTypeSupported: isRequiredFieldTypeSupported
    };
};
const $13b57db15fd5695a$export$778f621df988f2dc = (data)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const gqlIssueCreateFieldsType = (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(data, 'jiraIssueCreateFields.__typename', '');
    const queryErrorMessage = (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(data, 'jiraIssueCreateFields.message', '');
    if (gqlIssueCreateFieldsType === (0, $4246188a36de9908$export$6c8cb487d6ffc522) && Boolean(queryErrorMessage)) return queryErrorMessage;
    const gqlIssueCreateLayoutType = (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(data, 'jiraIssueCreateLayout.__typename', '');
    const issueCreateFieldsQueryErrorMessage = (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(data, 'jiraIssueCreateFields.errors[0].extensions[0].message', '');
    if (gqlIssueCreateLayoutType === (0, $4246188a36de9908$export$6c8cb487d6ffc522) && Boolean(issueCreateFieldsQueryErrorMessage)) return issueCreateFieldsQueryErrorMessage;
    return '';
};

});

parcelRegister("7igAz", function(module, exports) {

$parcel$export(module.exports, "overrideGqlTypes", () => $61b0fb44f8a10909$export$f03f31ea9e8359e8);

var $814y1 = parcelRequire("814y1");

const $61b0fb44f8a10909$export$f03f31ea9e8359e8 = (fieldData)=>{
    const { type: type, __typename: gqlType, renderer: renderer } = fieldData || {};
    if (gqlType === (0, $af620ae3ac843a8a$export$3849bb04b4eee607) && type === (0, $814y1.ASSIGNEE_TYPE)) return 0, $af620ae3ac843a8a$export$f7a08bf17a7ac661;
    if (gqlType === (0, $af620ae3ac843a8a$export$3849bb04b4eee607) && type === (0, $814y1.REPORTER_TYPE)) return 0, $af620ae3ac843a8a$export$d64150fd9c66969c;
    if (gqlType === (0, $af620ae3ac843a8a$export$1070aada56fcaec9) && type === (0, $814y1.EPIC_COLOR_TYPE)) return 0, $af620ae3ac843a8a$export$f57941b9c1949a82;
    if (gqlType === (0, $af620ae3ac843a8a$export$31a6c27df1f927b2) && type === (0, $814y1.MESSAGE_EDIT_CF_TYPE)) return 0, $af620ae3ac843a8a$export$a138d5648dda03f0;
    if (gqlType === (0, $af620ae3ac843a8a$export$31a6c27df1f927b2) || gqlType === (0, $af620ae3ac843a8a$export$7a583e2ae9052377)) return renderer === 'atlassian-wiki-renderer' ? (0, $af620ae3ac843a8a$export$31a6c27df1f927b2) : (0, $af620ae3ac843a8a$export$95433ac963f4aebe);
    // we want to keep "JiraParentIssueField" jql name for PARENT_FIELD long term when PARENT_LINK_FIELD is depricated hence this override
    if (gqlType === (0, $af620ae3ac843a8a$export$670384150af5f49e) && type === (0, $814y1.PARENT_FIELD_TYPE)) return 0, $af620ae3ac843a8a$export$bf9df74e065af482;
    return gqlType;
};

});


parcelRegister("bSxlM", function(module, exports) {

$parcel$export(module.exports, "getCreateConfigQuery", () => $283a68c93f0a2c23$export$6aa2f285b19806a5);
// eslint-disable-next-line jira/restricted/graphql-tag

var $kuAvn = parcelRequire("kuAvn");

var $7jTnu = parcelRequire("7jTnu");

var $krdGL = parcelRequire("krdGL");
const $283a68c93f0a2c23$var$skipTernaryForIssueLinksRefinementFragment = (isInContext, isCreateLinkedIssueFromIssueViewFGOn)=>{
    if ((0, $7jTnu.fg)('remove_issue_links_id_query_from_issue_create')) return isInContext && isCreateLinkedIssueFromIssueViewFGOn ? '...IssueLinksFieldFragmentWithCopyLinksAndAttachmentsRefined' : '...IssueLinksFieldFragmentRefined';
    return isInContext && isCreateLinkedIssueFromIssueViewFGOn ? '...IssueLinksFieldFragmentWithCopyLinksAndAttachments' : '...IssueLinksFieldFragment';
};
const $283a68c93f0a2c23$var$skipTernaryForIssueLinksRefinementGira = (isInContext, isCreateLinkedIssueFromIssueViewFGOn)=>{
    if ((0, $7jTnu.fg)('remove_issue_links_id_query_from_issue_create')) return isInContext && isCreateLinkedIssueFromIssueViewFGOn ? (0, $krdGL.ISSUE_LINKS_FIELD_FRAGMENT_WITH_COPY_LINKS_AND_ATTACHMENTS_REFINED) : (0, $krdGL.ISSUE_LINKS_FIELD_FRAGMENT_REFINED);
    return isInContext && isCreateLinkedIssueFromIssueViewFGOn ? (0, $krdGL.ISSUE_LINKS_FIELD_FRAGMENT_WITH_COPY_LINKS_AND_ATTACHMENTS) : (0, $krdGL.ISSUE_LINKS_FIELD_FRAGMENT);
};
const $283a68c93f0a2c23$export$6aa2f285b19806a5 = ({ isInContext: isInContext, withML: withML, isCreateLinkedIssue: isCreateLinkedIssue, isCreateLinkedIssueFromIssueViewFGOn: isCreateLinkedIssueFromIssueViewFGOn, isJsmRespondersFieldEnabled: isJsmRespondersFieldEnabled })=>(0, $kuAvn.default)`
    query ${isInContext ? `JiraGlobalIssueCreateInContext${isCreateLinkedIssue && isCreateLinkedIssueFromIssueViewFGOn ? 'WithCLI' : ''}` : 'JiraGlobalIssueCreateModalLoad'}(
        $project: JiraProjectInput
        $issueType: JiraIssueTypeInput
        $requestType: JiraRequestTypeInput
        $defaultValues: JiraIssueFieldsInput
        ${isInContext ? '' : '$issueTypes: String'}
        ${isInContext ? '' : '$requestTypes: String'}
        ${isInContext ? '$additionalContext: JiraIssueCreateContextInput!' : ''}
        ${isInContext && isCreateLinkedIssueFromIssueViewFGOn ? '$issueCreateType: IssueCreateTypeFilter' : ''}
    ) {
        jiraIssueCreateLayout${isInContext ? 'InContext' : ''}${withML ? 'WithML' : ''}(
            layoutFilter: USER_CONFIGURED_LAYOUT
            project: $project
            issueType: $issueType
            ${!isInContext ? '' : 'requestType: $requestType'}
            ${isInContext ? 'additionalContext: $additionalContext' : ''}
            ${isInContext && isCreateLinkedIssueFromIssueViewFGOn ? 'issueCreateType: $issueCreateType' : ''}
        ) {
            ...LayoutFragment
        }
        jiraIssueCreateFields${isInContext ? 'InContext' : ''}(
            fieldsFilter: USER_CONFIGURED_FIELDS
            project: $project
            issueType: $issueType
            ${isInContext ? 'additionalContext: $additionalContext' : ''}
            requestType: $requestType
            defaultValues: $defaultValues
            ${isInContext && isCreateLinkedIssueFromIssueViewFGOn ? 'issueCreateType: $issueCreateType' : ''}
        ) {
            ... on JiraIssueCreateFields {
                fields {
                    nodes {
                        ...BaseFieldFragment
                        ...ProjectFieldFragmentWithoutClassification
                        ${isInContext ? '...IssueTypeFieldFragment' : '...IssueTypeFieldSearchFragment'}
                        ${isInContext ? '...RequestTypeFieldFragment' : '...RequestTypeFieldSearchFragment'}
                        ...TextFieldFragment
                        ...RichTextFieldFragment
                        ...ComponentsFieldFragment
                        ...VersionFieldFragment
                        ...MultiVersionFieldFragment
                        ...PriorityFieldFragment
                        ...SprintFieldFragment
                        ...LabelFieldFragment
                        ...SingleUserPickerFieldFragment
                        ...MultiUserPickerFieldFragment
                        ...PeopleFieldFragment
                        ...SecurityFieldFragment
                        ...IssueRestrictionFieldFragment
                        ...ColorFieldFragment
                        ...ResolutionFieldFragment
                        ...SingleSelectFieldFragment
                        ...MultiSelectFieldFragment
                        ...NumberFieldFragment
                        ...UrlFieldFragment
                        ...EpicLinkFieldFragment
                        ...DatePickerFieldFragment
                        ...DateTimePickerFieldFragment
                        ...CascadingSelectFieldFragment
                        ...AttachmentsFieldFragment
                        ...CheckboxFieldFragment
                        ${$283a68c93f0a2c23$var$skipTernaryForIssueLinksRefinementFragment(isInContext, isCreateLinkedIssueFromIssueViewFGOn)}
                        ...SingleGroupPickerFieldFragment
                        ...MultiGroupPickerFieldFragment
                        ...TeamFieldFragment
                        ...AtlassianTeamFieldFragment
                        ...RadioSelectFieldFragment
                        ...AffectedServicesFieldFragment
                        ...CMDBFieldFragment
                        ...OrganizationsFieldFragment
                        ...ConnectTextFieldFragment
                        ...ConnectNumberFieldFragment
                        ...ConnectSingleSelectFieldFragment
                        ...ConnectMultiSelectFieldFragment
                        ...ConnectRichTextFieldFragment
                        ...AssetFieldFragment
                        ...ForgeStringFieldFragment
                        ...ForgeNumberFieldFragment
                        ...ForgeSingleUserPickerFieldFragment
                        ...ForgeMultiUserPickerFieldFragment
                        ...ForgeGroupPickerFieldFragment
                        ...ForgeMultiGroupPickerFieldFragment
                        ...ForgeStringsFieldFragment
                        ...ForgeObjectFieldFragment
                        ...ForgeDateTimePickerFieldFragment
                        ...TimeTrackingFieldFragment
                        ...WorkLogFieldFragment
                        ...JsmMultiUserPickerFieldFragment
                        ...JsmPeopleFieldFragment
                        ...ParentLinkFieldFragment
                        ${isInContext ? '' : '...DataClassificationFieldFragment'}
                        ...ParentFieldFragment
                        ...StatusFieldFragment
                        ${isJsmRespondersFieldEnabled ? '...JiraServiceManagementRespondersFieldFragment' : ''}
                    }
                }
                errors {
                    identifier
                    extensions {
                        ... on JiraIssueFieldUnsupportedErrorExtension {
                            fieldName
                            fieldType
                            isRequiredField
                        }
                        ... on JiraIssueFieldValueValidationErrorExtension {
                            errorType
                            message
                        }
                    }
                }
            }
            ... on QueryError {
                message
            }
        }
        jiraIssueCreateAdditionalServices(project: $project, issueType: $issueType, requestType: $requestType) {
            ... on JiraIssueCreateAdditionalServices {
                services {
                    edges {
                        node {
                            ...WatchersConfigFragment
                            ...ProformaConfigFragment
                        }
                    }
                }
            }
            ... on QueryError {
                message
            }
        }
    }
    ${withML ? (0, $krdGL.LAYOUT_FRAGMENT_WITH_ML) : (0, $krdGL.LAYOUT_FRAGMENT)}
    ${0, $krdGL.BASE_FIELD_FRAGMENT}
    ${0, $krdGL.PROJECT_FIELD_FRAGMENT_WITHOUT_CLASSIFICATION}
    ${isInContext ? (0, $krdGL.ISSUE_TYPE_FIELD_FRAGMENT) : (0, $krdGL.ISSUE_TYPE_FIELD_SEARCH_BY_FRAGMENT)}
    ${isInContext ? (0, $krdGL.REQUEST_TYPE_FIELD_FRAGMENT) : (0, $krdGL.REQUEST_TYPE_FIELD_SEARCH_BY_FRAGMENT)}
    ${0, $krdGL.TEXT_FIELD_FRAGMENT}
    ${0, $krdGL.RICH_TEXT_FIELD_FRAGMENT}
    ${0, $krdGL.COMPONENTS_FIELD_FRAGMENT}
    ${0, $krdGL.VERSION_FIELD_FRAGMENT}
    ${0, $krdGL.MULTI_VERSION_FIELD_FRAGMENT}
    ${0, $krdGL.PRIORITY_FIELD_FRAGMENT}
    ${0, $krdGL.SPRINT_FIELD_FRAGMENT}
    ${0, $krdGL.LABEL_FIELD_FRAGMENT}
    ${0, $krdGL.SINGLE_USER_PICKER_FIELD_FRAGMENT}
    ${0, $krdGL.MULTI_USER_PICKER_FIELD_FRAGMENT}
    ${0, $krdGL.SECURITY_FIELD_FRAGMENT}
    ${0, $krdGL.ISSUE_RESTRICTION_FIELD_FRAGMENT}
    ${0, $krdGL.COLOR_FIELD_FRAGMENT}
    ${0, $krdGL.RESOLUTION_FIELD_FRAGMENT}
    ${0, $krdGL.SINGLE_SELECT_FIELD_FRAGMENT}
    ${0, $krdGL.MULTI_SELECT_FIELD_FRAGMENT}
    ${0, $krdGL.NUMBER_FIELD_FRAGMENT}
    ${0, $krdGL.URL_FIELD_FRAGMENT}
    ${0, $krdGL.EPIC_LINK_FIELD_FRAGMENT}
    ${0, $krdGL.DATE_FIELD_FRAGMENT}
    ${0, $krdGL.DATE_TIME_FIELD_FRAGMENT}
    ${0, $krdGL.CASCADING_SELECT_FIELD_FRAGMENT}
    ${0, $krdGL.ATTACHMENTS_FIELD_FRAGMENT}
    ${0, $krdGL.CHECKBOX_FIELD_FRAGMENT}
    ${$283a68c93f0a2c23$var$skipTernaryForIssueLinksRefinementGira(isInContext, isCreateLinkedIssueFromIssueViewFGOn)}
    ${0, $krdGL.SINGLE_GROUP_PICKER_FIELD_FRAGMENT}
    ${0, $krdGL.MULTI_GROUP_PICKER_FIELD_FRAGMENT}
    ${0, $krdGL.PEOPLE_FIELD_FRAGMENT}
    ${0, $krdGL.TEAM_FIELD_FRAGMENT}
    ${0, $krdGL.ATLASSIAN_TEAM_FIELD_FRAGMENT}
    ${0, $krdGL.RADIO_SELECT_FIELD_FRAGMENT}
    ${0, $krdGL.AFFECTED_SERVICES_FIELD_FRAGMENT}
    ${0, $krdGL.CMDB_FIELD_FRAGMENT}
    ${0, $krdGL.ORGANIZATIONS_FIELD_FRAGMENT}
    ${0, $krdGL.CONNECT_TEXT_FIELD_FRAGMENT}
    ${0, $krdGL.CONNECT_NUMBER_FIELD_FRAGMENT}
    ${0, $krdGL.CONNECT_SINGLE_SELECT_FIELD_FRAGMENT}
    ${0, $krdGL.CONNECT_MULTI_SELECT_FIELD_FRAGMENT}
    ${0, $krdGL.CONNECT_RICH_TEXT_FIELD_FRAGMENT}
    ${0, $krdGL.ASSET_FIELD_FRAGMENT}
    ${0, $krdGL.FORGE_STRING_FIELD_FRAGMENT}
    ${0, $krdGL.FORGE_NUMBER_FIELD_FRAGMENT}
    ${0, $krdGL.FORGE_SINGLE_USER_PICKER_FIELD_FRAGMENT}
    ${0, $krdGL.FORGE_MULTI_USER_PICKER_FIELD_FRAGMENT}
    ${0, $krdGL.FORGE_GROUP_PICKER_FIELD_FRAGMENT}
    ${0, $krdGL.FORGE_MULTI_GROUP_PICKER_FIELD_FRAGMENT}
    ${0, $krdGL.FORGE_STRINGS_FIELD_FRAGMENT}
    ${0, $krdGL.FORGE_DATETIME_FIELD_FRAGMENT}
    ${0, $krdGL.FORGE_OBJECT_FIELD_FRAGMENT}
    ${0, $krdGL.TIME_TRACKING_FIELD_FRAGMENT}
    ${0, $krdGL.WORK_LOG_FIELD_FRAGMENT}
    ${0, $krdGL.JSM_MULTI_USER_PICKER_FIELD_FRAGMENT}
    ${0, $krdGL.JSM_PEOPLE_FIELD_FRAGMENT}
    ${0, $krdGL.PARENT_LINK_FIELD_FRAGMENT}
    ${0, $krdGL.PARENT_FIELD_FRAGMENT}
    ${0, $krdGL.PROFORMA_CONFIG_FRAGMENT}
    ${0, $krdGL.STATUS_FIELD_FRAGMENT}
    ${isJsmRespondersFieldEnabled ? (0, $krdGL.RESPONDERS_FIELD_FRAGMENT) : ''}
    ${0, $krdGL.WATCHERS_CONFIG_FRAGMENT}
    ${0, $krdGL.DATA_CLASSIFICATION_FIELD_FRAGMENT}
`;

});
parcelRegister("krdGL", function(module, exports) {

$parcel$export(module.exports, "LAYOUT_FRAGMENT", () => $6ce9f78048dc7a0d$export$f625f330d228b694);
$parcel$export(module.exports, "LAYOUT_FRAGMENT_WITH_ML", () => $6ce9f78048dc7a0d$export$c62f67b4f409a5c6);
$parcel$export(module.exports, "BASE_FIELD_FRAGMENT", () => $6ce9f78048dc7a0d$export$e61b49f54d551a76);
$parcel$export(module.exports, "PROJECT_WITHOUT_CLASSIFICATION", () => $6ce9f78048dc7a0d$export$c697769cce672aaf);
$parcel$export(module.exports, "PROJECT_FIELD_FRAGMENT_WITHOUT_CLASSIFICATION", () => $6ce9f78048dc7a0d$export$9594a6b1142bdd10);
$parcel$export(module.exports, "ISSUE_TYPE_FIELD_FRAGMENT", () => $6ce9f78048dc7a0d$export$5b50a50ed83e9899);
$parcel$export(module.exports, "ISSUE_TYPE_FIELD_SEARCH_BY_FRAGMENT", () => $6ce9f78048dc7a0d$export$410d36690ebc2ef6);
$parcel$export(module.exports, "TEXT_FIELD_FRAGMENT", () => $6ce9f78048dc7a0d$export$636915305cba61ee);
$parcel$export(module.exports, "CONNECT_TEXT_FIELD_FRAGMENT", () => $6ce9f78048dc7a0d$export$3cd5b2049171ec4c);
$parcel$export(module.exports, "FORGE_STRING_FIELD_FRAGMENT", () => $6ce9f78048dc7a0d$export$ebc024aa691e4d85);
$parcel$export(module.exports, "RICH_TEXT_FIELD_FRAGMENT", () => $6ce9f78048dc7a0d$export$5b0963f21dba94f8);
$parcel$export(module.exports, "CONNECT_RICH_TEXT_FIELD_FRAGMENT", () => $6ce9f78048dc7a0d$export$7f0a2ff1b7c9ca01);
$parcel$export(module.exports, "FORGE_OBJECT_FIELD_FRAGMENT", () => $6ce9f78048dc7a0d$export$689ca997bd170b37);
$parcel$export(module.exports, "COMPONENTS_FIELD_FRAGMENT", () => $6ce9f78048dc7a0d$export$ab0555e54f8994f9);
$parcel$export(module.exports, "SINGLE_USER_PICKER_FIELD_FRAGMENT", () => $6ce9f78048dc7a0d$export$28f68e0bae1ee7f3);
$parcel$export(module.exports, "FORGE_SINGLE_USER_PICKER_FIELD_FRAGMENT", () => $6ce9f78048dc7a0d$export$1f16b392b8d9b666);
$parcel$export(module.exports, "MULTI_USER_PICKER_FIELD_FRAGMENT", () => $6ce9f78048dc7a0d$export$b2adb4bd3df183ed);
$parcel$export(module.exports, "JSM_MULTI_USER_PICKER_FIELD_FRAGMENT", () => $6ce9f78048dc7a0d$export$fffb689cf69ab0a2);
$parcel$export(module.exports, "FORGE_MULTI_USER_PICKER_FIELD_FRAGMENT", () => $6ce9f78048dc7a0d$export$c43dfb9e201b83a2);
$parcel$export(module.exports, "PEOPLE_FIELD_FRAGMENT", () => $6ce9f78048dc7a0d$export$2b791aa6cca603ee);
$parcel$export(module.exports, "JSM_PEOPLE_FIELD_FRAGMENT", () => $6ce9f78048dc7a0d$export$b043dc06c0d2d4f8);
$parcel$export(module.exports, "NUMBER_FIELD_FRAGMENT", () => $6ce9f78048dc7a0d$export$874202730a4f96be);
$parcel$export(module.exports, "CONNECT_NUMBER_FIELD_FRAGMENT", () => $6ce9f78048dc7a0d$export$82ff38b10f06144a);
$parcel$export(module.exports, "FORGE_NUMBER_FIELD_FRAGMENT", () => $6ce9f78048dc7a0d$export$87f4b71855b27f75);
$parcel$export(module.exports, "DATE_TIME_FIELD_FRAGMENT", () => $6ce9f78048dc7a0d$export$bbf5ba5f74471361);
$parcel$export(module.exports, "ISSUE_LINKS_FIELD_FRAGMENT_WITH_COPY_LINKS_AND_ATTACHMENTS", () => $6ce9f78048dc7a0d$export$9ef617a537d543ae);
$parcel$export(module.exports, "ISSUE_LINKS_FIELD_FRAGMENT_WITH_COPY_LINKS_AND_ATTACHMENTS_REFINED", () => $6ce9f78048dc7a0d$export$34262a4d713ee65e);
$parcel$export(module.exports, "ISSUE_LINKS_FIELD_FRAGMENT", () => $6ce9f78048dc7a0d$export$dd6b1aecfb7f1473);
$parcel$export(module.exports, "ISSUE_LINKS_FIELD_FRAGMENT_REFINED", () => $6ce9f78048dc7a0d$export$94d9188aeb6b5618);
$parcel$export(module.exports, "FORGE_DATETIME_FIELD_FRAGMENT", () => $6ce9f78048dc7a0d$export$7009d41cc723dac);
$parcel$export(module.exports, "DATE_FIELD_FRAGMENT", () => $6ce9f78048dc7a0d$export$bb1ac816b515a7c);
$parcel$export(module.exports, "EPIC_LINK_FIELD_FRAGMENT", () => $6ce9f78048dc7a0d$export$47036e8bdf2c9326);
$parcel$export(module.exports, "LABEL_FIELD_FRAGMENT", () => $6ce9f78048dc7a0d$export$85cf307e24504b19);
$parcel$export(module.exports, "LABEL_WITH_COLOR_FIELD_FRAGMENT", () => $6ce9f78048dc7a0d$export$73096e5a8439e28e);
$parcel$export(module.exports, "FORGE_STRINGS_FIELD_FRAGMENT", () => $6ce9f78048dc7a0d$export$9255ce322dbd4481);
$parcel$export(module.exports, "VERSION_FIELD_FRAGMENT", () => $6ce9f78048dc7a0d$export$37deee440fbd3c5);
$parcel$export(module.exports, "MULTI_VERSION_FIELD_FRAGMENT", () => $6ce9f78048dc7a0d$export$ffdfaa2ab8110c87);
$parcel$export(module.exports, "PRIORITY_FIELD_FRAGMENT", () => $6ce9f78048dc7a0d$export$63d6d00b6349a8fd);
$parcel$export(module.exports, "ATTACHMENTS_FIELD_FRAGMENT", () => $6ce9f78048dc7a0d$export$8ca944b20979f689);
$parcel$export(module.exports, "SECURITY_FIELD_FRAGMENT", () => $6ce9f78048dc7a0d$export$e0034adc460157a3);
$parcel$export(module.exports, "ISSUE_RESTRICTION_FIELD_FRAGMENT", () => $6ce9f78048dc7a0d$export$a4e0bff5a9855a6a);
$parcel$export(module.exports, "URL_FIELD_FRAGMENT", () => $6ce9f78048dc7a0d$export$55232ce79978fe60);
$parcel$export(module.exports, "CHECKBOX_FIELD_FRAGMENT", () => $6ce9f78048dc7a0d$export$2a0a6d36d97ce992);
$parcel$export(module.exports, "SINGLE_SELECT_FIELD_FRAGMENT", () => $6ce9f78048dc7a0d$export$2bba3db49a112c62);
$parcel$export(module.exports, "CONNECT_SINGLE_SELECT_FIELD_FRAGMENT", () => $6ce9f78048dc7a0d$export$f63043138eca54b8);
$parcel$export(module.exports, "MULTI_SELECT_FIELD_FRAGMENT", () => $6ce9f78048dc7a0d$export$494028c0baaef0a5);
$parcel$export(module.exports, "CONNECT_MULTI_SELECT_FIELD_FRAGMENT", () => $6ce9f78048dc7a0d$export$a5740cd9553dc3be);
$parcel$export(module.exports, "RADIO_SELECT_FIELD_FRAGMENT", () => $6ce9f78048dc7a0d$export$8a8492487a98fdaa);
$parcel$export(module.exports, "DATA_CLASSIFICATION_FIELD_FRAGMENT", () => $6ce9f78048dc7a0d$export$c525f571cbe1dcbb);
$parcel$export(module.exports, "SINGLE_GROUP_PICKER_FIELD_FRAGMENT", () => $6ce9f78048dc7a0d$export$1507bfa8951ee68d);
$parcel$export(module.exports, "FORGE_GROUP_PICKER_FIELD_FRAGMENT", () => $6ce9f78048dc7a0d$export$51d039d4ec21f704);
$parcel$export(module.exports, "MULTI_GROUP_PICKER_FIELD_FRAGMENT", () => $6ce9f78048dc7a0d$export$4c4a76b99fc5f54e);
$parcel$export(module.exports, "FORGE_MULTI_GROUP_PICKER_FIELD_FRAGMENT", () => $6ce9f78048dc7a0d$export$ae231dc96d2638ab);
$parcel$export(module.exports, "SPRINT_FIELD_FRAGMENT", () => $6ce9f78048dc7a0d$export$aba335b21420357f);
$parcel$export(module.exports, "COLOR_FIELD_FRAGMENT", () => $6ce9f78048dc7a0d$export$585571cdf68c55a1);
$parcel$export(module.exports, "REQUEST_TYPE_FIELD_FRAGMENT", () => $6ce9f78048dc7a0d$export$201be0ff29129622);
$parcel$export(module.exports, "REQUEST_TYPE_FIELD_SEARCH_BY_FRAGMENT", () => $6ce9f78048dc7a0d$export$589a6183e9780424);
$parcel$export(module.exports, "RESOLUTION_FIELD_FRAGMENT", () => $6ce9f78048dc7a0d$export$31c88001934c2e15);
$parcel$export(module.exports, "CASCADING_SELECT_FIELD_FRAGMENT", () => $6ce9f78048dc7a0d$export$2f9cfac026740bd3);
$parcel$export(module.exports, "TEAM_FIELD_FRAGMENT", () => $6ce9f78048dc7a0d$export$cb70b12f3de3f41c);
$parcel$export(module.exports, "ATLASSIAN_TEAM_FIELD_FRAGMENT", () => $6ce9f78048dc7a0d$export$1173888d99fd7ae6);
$parcel$export(module.exports, "ASSET_FIELD_FRAGMENT", () => $6ce9f78048dc7a0d$export$97cdf1e4b8832240);
$parcel$export(module.exports, "AFFECTED_SERVICES_FIELD_FRAGMENT", () => $6ce9f78048dc7a0d$export$3480d890dca64b9e);
$parcel$export(module.exports, "CMDB_FIELD_FRAGMENT", () => $6ce9f78048dc7a0d$export$c1864cedbeda248a);
$parcel$export(module.exports, "ORGANIZATIONS_FIELD_FRAGMENT", () => $6ce9f78048dc7a0d$export$e0f3793fd890e0);
$parcel$export(module.exports, "TIME_TRACKING_FIELD_FRAGMENT", () => $6ce9f78048dc7a0d$export$f9e6189fd786f6);
$parcel$export(module.exports, "WORK_LOG_FIELD_FRAGMENT", () => $6ce9f78048dc7a0d$export$c6c1a1f3d6f49ea4);
$parcel$export(module.exports, "PARENT_LINK_FIELD_FRAGMENT", () => $6ce9f78048dc7a0d$export$fa778835050523e6);
$parcel$export(module.exports, "PARENT_FIELD_FRAGMENT", () => $6ce9f78048dc7a0d$export$f75050611ceb9d35);
$parcel$export(module.exports, "STATUS_FIELD_FRAGMENT", () => $6ce9f78048dc7a0d$export$f89396a6b77b653f);
$parcel$export(module.exports, "RESPONDERS_FIELD_FRAGMENT", () => $6ce9f78048dc7a0d$export$335dcd5b86a25a15);
$parcel$export(module.exports, "PROFORMA_CONFIG_FRAGMENT", () => $6ce9f78048dc7a0d$export$5f06542accc83cb5);
$parcel$export(module.exports, "WATCHERS_CONFIG_FRAGMENT", () => $6ce9f78048dc7a0d$export$eda8fbd7533aaac1);
// eslint-disable-next-line jira/restricted/graphql-tag

var $kuAvn = parcelRequire("kuAvn");
const $6ce9f78048dc7a0d$export$f625f330d228b694 = (0, $kuAvn.default)`
	fragment LayoutFragment on JiraIssueCreateLayout {
		contentSection {
			items {
				... on JiraTabLayout {
					id
					name
					items {
						... on JiraFieldLayoutItem {
							fieldId
						}
					}
					tabId
				}
			}
		}
	}
`;
const $6ce9f78048dc7a0d$export$c62f67b4f409a5c6 = (0, $kuAvn.default)`
	fragment LayoutFragment on JiraIssueCreateLayout {
		contentSection {
			items {
				... on JiraTabLayout {
					id
					name
					items {
						... on JiraFieldLayoutItem {
							fieldId
						}
					}
					collapsedItems {
						... on JiraFieldLayoutItem {
							fieldId
						}
					}
					tabId
				}
			}
		}
	}
`;
const $6ce9f78048dc7a0d$export$e61b49f54d551a76 = (0, $kuAvn.default)`
	fragment BaseFieldFragment on JiraIssueField {
		fieldId
		name
		type
		description
		... on JiraIssueFieldConfiguration {
			fieldConfig {
				isRequired
				isEditable
				nonEditableReason {
					message
				}
			}
		}
	}
`;
const $6ce9f78048dc7a0d$export$c697769cce672aaf = (0, $kuAvn.default)`
	fragment Project on JiraProject {
		id: projectId
		name
		avatar {
			large
		}
		projectType
		simplified
		key
	}
`;
const $6ce9f78048dc7a0d$export$9594a6b1142bdd10 = (0, $kuAvn.default)`
	fragment ProjectFieldFragmentWithoutClassification on JiraProjectField {
		project {
			...Project
		}
		searchUrl
	}
	${$6ce9f78048dc7a0d$export$c697769cce672aaf}
`;
/* issuetype field */ const $6ce9f78048dc7a0d$var$ISSUE_TYPE = (0, $kuAvn.default)`
	fragment IssueType on JiraIssueType {
		id: issueTypeId
		name
		avatar {
			large
		}
	}
`;
const $6ce9f78048dc7a0d$export$5b50a50ed83e9899 = (0, $kuAvn.default)`
	fragment IssueTypeFieldFragment on JiraIssueTypeField {
		issueType {
			...IssueType
		}
		issueTypes {
			nodes {
				...IssueType
			}
		}
	}
	${$6ce9f78048dc7a0d$var$ISSUE_TYPE}
`;
const $6ce9f78048dc7a0d$export$410d36690ebc2ef6 = (0, $kuAvn.default)`
	fragment IssueTypeFieldSearchFragment on JiraIssueTypeField {
		issueType {
			...IssueType
		}
		issueTypes(searchBy: $issueTypes) {
			nodes {
				...IssueType
			}
		}
	}
	${$6ce9f78048dc7a0d$var$ISSUE_TYPE}
`;
const $6ce9f78048dc7a0d$export$636915305cba61ee = (0, $kuAvn.default)`
	fragment TextFieldFragment on JiraSingleLineTextField {
		text
	}
`;
const $6ce9f78048dc7a0d$export$3cd5b2049171ec4c = (0, $kuAvn.default)`
	fragment ConnectTextFieldFragment on JiraConnectTextField {
		text
	}
`;
const $6ce9f78048dc7a0d$export$ebc024aa691e4d85 = (0, $kuAvn.default)`
	fragment ForgeStringFieldFragment on JiraForgeStringField {
		text
	}
`;
const $6ce9f78048dc7a0d$var$MEDIA_CONTEXT_FRAGMENT = (0, $kuAvn.default)`
	fragment JiraMediaContextFragment on JiraMediaContext {
		uploadToken {
			... on JiraMediaUploadToken {
				endpointUrl
				clientId
				targetCollection
				token
				tokenDurationInMin
			}
			... on QueryError {
				message
			}
		}
	}
`;
const $6ce9f78048dc7a0d$export$b9abb6c941d637fd = (0, $kuAvn.default)`
	fragment JiraAdminRichTextFieldConfigFragment on JiraRichTextField {
		adminRichTextConfig {
			aiEnabledByProject
		}
	}
`;
const $6ce9f78048dc7a0d$export$5b0963f21dba94f8 = (0, $kuAvn.default)`
	fragment RichTextFieldFragment on JiraRichTextField {
		richText {
			plainText
			adfValue {
				json
			}
		}
		renderer
		mediaContext {
			...JiraMediaContextFragment
		}
		...JiraAdminRichTextFieldConfigFragment
	}
	${$6ce9f78048dc7a0d$var$MEDIA_CONTEXT_FRAGMENT}
	${$6ce9f78048dc7a0d$export$b9abb6c941d637fd}
`;
const $6ce9f78048dc7a0d$export$7f0a2ff1b7c9ca01 = (0, $kuAvn.default)`
	fragment ConnectRichTextFieldFragment on JiraConnectRichTextField {
		richText {
			plainText
			adfValue {
				json
			}
		}
		renderer
		mediaContext {
			...JiraMediaContextFragment
		}
	}
	${$6ce9f78048dc7a0d$var$MEDIA_CONTEXT_FRAGMENT}
`;
const $6ce9f78048dc7a0d$export$689ca997bd170b37 = (0, $kuAvn.default)`
	fragment ForgeObjectFieldFragment on JiraForgeObjectField {
		object
	}
`;
/* components field */ const $6ce9f78048dc7a0d$var$COMPONENT = (0, $kuAvn.default)`
	fragment Component on JiraComponent {
		id: componentId
		name
	}
`;
const $6ce9f78048dc7a0d$export$ab0555e54f8994f9 = (0, $kuAvn.default)`
	fragment ComponentsFieldFragment on JiraComponentsField {
		selectedComponents {
			...Component
		}
		components {
			nodes {
				...Component
			}
		}
	}
	${$6ce9f78048dc7a0d$var$COMPONENT}
`;
const $6ce9f78048dc7a0d$export$ff09b90989b21a8 = (0, $kuAvn.default)`
	fragment UserFragment on User {
		accountId
		name
		picture
	}
`;
const $6ce9f78048dc7a0d$export$28f68e0bae1ee7f3 = (0, $kuAvn.default)`
	fragment SingleUserPickerFieldFragment on JiraSingleSelectUserPickerField {
		user {
			...UserFragment
		}
		searchUrl
	}
	${$6ce9f78048dc7a0d$export$ff09b90989b21a8}
`;
const $6ce9f78048dc7a0d$export$1f16b392b8d9b666 = (0, $kuAvn.default)`
	fragment ForgeSingleUserPickerFieldFragment on JiraForgeUserField {
		user {
			...UserFragment
		}
		searchUrl
	}
	${$6ce9f78048dc7a0d$export$ff09b90989b21a8}
`;
const $6ce9f78048dc7a0d$export$b2adb4bd3df183ed = (0, $kuAvn.default)`
	fragment MultiUserPickerFieldFragment on JiraMultipleSelectUserPickerField {
		selectedUsers {
			...UserFragment
		}
		searchUrl
	}
	${$6ce9f78048dc7a0d$export$ff09b90989b21a8}
`;
const $6ce9f78048dc7a0d$export$fffb689cf69ab0a2 = (0, $kuAvn.default)`
	fragment JsmMultiUserPickerFieldFragment on JsmMultipleSelectUserPickerField {
		selectedUsers {
			...UserFragment
		}
		searchUrl
	}
	${$6ce9f78048dc7a0d$export$ff09b90989b21a8}
`;
const $6ce9f78048dc7a0d$export$c43dfb9e201b83a2 = (0, $kuAvn.default)`
	fragment ForgeMultiUserPickerFieldFragment on JiraForgeUsersField {
		selectedUsers {
			...UserFragment
		}
		searchUrl
	}
	${$6ce9f78048dc7a0d$export$ff09b90989b21a8}
`;
const $6ce9f78048dc7a0d$export$2b791aa6cca603ee = (0, $kuAvn.default)`
	fragment PeopleFieldFragment on JiraPeopleField {
		selectedUsers {
			...UserFragment
		}
		searchUrl
		isMulti
	}
	${$6ce9f78048dc7a0d$export$ff09b90989b21a8}
`;
const $6ce9f78048dc7a0d$export$b043dc06c0d2d4f8 = (0, $kuAvn.default)`
	fragment JsmPeopleFieldFragment on JsmPeopleField {
		selectedUsers {
			...UserFragment
		}
		searchUrl
		isMulti
	}
	${$6ce9f78048dc7a0d$export$ff09b90989b21a8}
`;
const $6ce9f78048dc7a0d$export$874202730a4f96be = (0, $kuAvn.default)`
	fragment NumberFieldFragment on JiraNumberField {
		number
	}
`;
const $6ce9f78048dc7a0d$export$82ff38b10f06144a = (0, $kuAvn.default)`
	fragment ConnectNumberFieldFragment on JiraConnectNumberField {
		number
	}
`;
const $6ce9f78048dc7a0d$export$87f4b71855b27f75 = (0, $kuAvn.default)`
	fragment ForgeNumberFieldFragment on JiraForgeNumberField {
		number
	}
`;
const $6ce9f78048dc7a0d$export$bbf5ba5f74471361 = (0, $kuAvn.default)`
	fragment DateTimePickerFieldFragment on JiraDateTimePickerField {
		dateTime
	}
`;
const $6ce9f78048dc7a0d$export$9ef617a537d543ae = (0, $kuAvn.default)`
	fragment IssueLinksFieldFragmentWithCopyLinksAndAttachments on JiraIssueLinkField {
		name
		searchUrl
		issueLinks {
			id
			relatedBy {
				relationName
				linkTypeId
				linkTypeName
				direction
			}
			issue {
				id
				issueId
				key
				avatar {
					small
					medium
				}
			}
		}
		issueLinkTypeRelations {
			nodes {
				relationName
				linkTypeId
				linkTypeName
				direction
			}
		}
		copyLinksAndAttachments {
			copyLinks
			copyAttachments
		}
	}
`;
const $6ce9f78048dc7a0d$export$34262a4d713ee65e = (0, $kuAvn.default)`
	fragment IssueLinksFieldFragmentWithCopyLinksAndAttachmentsRefined on JiraIssueLinkField {
		name
		searchUrl
		issueLinks {
			relatedBy {
				relationName
				linkTypeId
				linkTypeName
				direction
			}
			issue {
				id
				issueId
				key
				avatar {
					small
					medium
				}
			}
		}
		issueLinkTypeRelations {
			nodes {
				relationName
				linkTypeId
				linkTypeName
				direction
			}
		}
		copyLinksAndAttachments {
			copyLinks
			copyAttachments
		}
	}
`;
const $6ce9f78048dc7a0d$export$dd6b1aecfb7f1473 = (0, $kuAvn.default)`
	fragment IssueLinksFieldFragment on JiraIssueLinkField {
		name
		searchUrl
		issueLinks {
			id
			relatedBy {
				relationName
				linkTypeId
				linkTypeName
				direction
			}
			issue {
				id
				issueId
				key
				avatar {
					small
					medium
				}
			}
		}
		issueLinkTypeRelations {
			nodes {
				relationName
				linkTypeId
				linkTypeName
				direction
			}
		}
	}
`;
const $6ce9f78048dc7a0d$export$94d9188aeb6b5618 = (0, $kuAvn.default)`
	fragment IssueLinksFieldFragmentRefined on JiraIssueLinkField {
		name
		searchUrl
		issueLinks {
			relatedBy {
				relationName
				linkTypeId
				linkTypeName
				direction
			}
			issue {
				id
				issueId
				key
				avatar {
					small
					medium
				}
			}
		}
		issueLinkTypeRelations {
			nodes {
				relationName
				linkTypeId
				linkTypeName
				direction
			}
		}
	}
`;
const $6ce9f78048dc7a0d$export$7009d41cc723dac = (0, $kuAvn.default)`
	fragment ForgeDateTimePickerFieldFragment on JiraForgeDatetimeField {
		dateTime
	}
`;
const $6ce9f78048dc7a0d$export$bb1ac816b515a7c = (0, $kuAvn.default)`
	fragment DatePickerFieldFragment on JiraDatePickerField {
		date
	}
`;
const $6ce9f78048dc7a0d$export$3cb4a99a332e4186 = (0, $kuAvn.default)`
	fragment Epic on JiraEpic {
		name
		key
		summary
	}
`;
const $6ce9f78048dc7a0d$export$47036e8bdf2c9326 = (0, $kuAvn.default)`
	fragment EpicLinkFieldFragment on JiraEpicLinkField {
		epic {
			...Epic
		}
		searchUrl
	}
	${$6ce9f78048dc7a0d$export$3cb4a99a332e4186}
`;
const $6ce9f78048dc7a0d$export$37aee82a3cb1e8f7 = (0, $kuAvn.default)`
	fragment Label on JiraLabel {
		id: labelId
		name
	}
`;
const $6ce9f78048dc7a0d$export$e6b80ae0bc32d1f5 = (0, $kuAvn.default)`
	fragment LabelWithColor on JiraLabel {
		id: labelId
		name
		color {
			colorKey
		}
	}
`;
const $6ce9f78048dc7a0d$export$85cf307e24504b19 = (0, $kuAvn.default)`
	fragment LabelFieldFragment on JiraLabelsField {
		selectedLabels {
			...Label
		}
		searchUrl
	}
	${$6ce9f78048dc7a0d$export$37aee82a3cb1e8f7}
`;
const $6ce9f78048dc7a0d$export$73096e5a8439e28e = (0, $kuAvn.default)`
	fragment LabelWithColorFieldFragment on JiraLabelsField {
		selectedLabels {
			...LabelWithColor
		}
		searchUrl
	}
	${$6ce9f78048dc7a0d$export$e6b80ae0bc32d1f5}
`;
const $6ce9f78048dc7a0d$export$9255ce322dbd4481 = (0, $kuAvn.default)`
	fragment ForgeStringsFieldFragment on JiraForgeStringsField {
		selectedLabels {
			...Label
		}
		searchUrl
	}
	${$6ce9f78048dc7a0d$export$37aee82a3cb1e8f7}
`;
/* versions field */ const $6ce9f78048dc7a0d$var$VERSION = (0, $kuAvn.default)`
	fragment Version on JiraVersion {
		id: versionId
		name
		status
	}
`;
const $6ce9f78048dc7a0d$export$37deee440fbd3c5 = (0, $kuAvn.default)`
	fragment VersionFieldFragment on JiraSingleVersionPickerField {
		version {
			...Version
		}
		versions {
			nodes {
				...Version
			}
		}
	}
	${$6ce9f78048dc7a0d$var$VERSION}
`;
const $6ce9f78048dc7a0d$export$ffdfaa2ab8110c87 = (0, $kuAvn.default)`
	fragment MultiVersionFieldFragment on JiraMultipleVersionPickerField {
		selectedVersions {
			...Version
		}
		versions {
			nodes {
				...Version
			}
		}
	}
	${$6ce9f78048dc7a0d$var$VERSION}
`;
/* priority field */ const $6ce9f78048dc7a0d$var$PRIORITY = (0, $kuAvn.default)`
	fragment Priority on JiraPriority {
		name
		id: priorityId
		iconUrl
	}
`;
const $6ce9f78048dc7a0d$export$63d6d00b6349a8fd = (0, $kuAvn.default)`
	fragment PriorityFieldFragment on JiraPriorityField {
		priority {
			...Priority
		}
		priorities {
			nodes {
				...Priority
			}
		}
	}
	${$6ce9f78048dc7a0d$var$PRIORITY}
`;
/* issue link field */ // schema needs to be updated
/* security field */ const $6ce9f78048dc7a0d$var$SECURITY_LEVEL = (0, $kuAvn.default)`
	fragment SecurityLevel on JiraSecurityLevel {
		id: securityId
		name
		description
	}
`;
const $6ce9f78048dc7a0d$export$8ca944b20979f689 = (0, $kuAvn.default)`
	fragment AttachmentsFieldFragment on JiraAttachmentsField {
		maxAllowedTotalAttachmentsSize
		mediaContext {
			...JiraMediaContextFragment
		}
	}
	${$6ce9f78048dc7a0d$var$MEDIA_CONTEXT_FRAGMENT}
`;
const $6ce9f78048dc7a0d$export$e0034adc460157a3 = (0, $kuAvn.default)`
	fragment SecurityFieldFragment on JiraSecurityLevelField {
		securityLevel {
			...SecurityLevel
		}
		securityLevels {
			nodes {
				...SecurityLevel
			}
		}
	}
	${$6ce9f78048dc7a0d$var$SECURITY_LEVEL}
`;
/* issue restriction field */ const $6ce9f78048dc7a0d$var$USER_ROLES = (0, $kuAvn.default)`
	fragment UserRoles on JiraRole {
		roleId
	}
`;
const $6ce9f78048dc7a0d$export$a4e0bff5a9855a6a = (0, $kuAvn.default)`
	fragment IssueRestrictionFieldFragment on JiraIssueRestrictionField {
		selectedRoles {
			...UserRoles
		}
	}
	${$6ce9f78048dc7a0d$var$USER_ROLES}
`;
const $6ce9f78048dc7a0d$export$55232ce79978fe60 = (0, $kuAvn.default)`
	fragment UrlFieldFragment on JiraUrlField {
		url
	}
`;
/* checkbox field */ const $6ce9f78048dc7a0d$var$OPTION = (0, $kuAvn.default)`
	fragment Option on JiraOption {
		id: optionId
		value
	}
`;
const $6ce9f78048dc7a0d$export$2a0a6d36d97ce992 = (0, $kuAvn.default)`
	fragment CheckboxFieldFragment on JiraCheckboxesField {
		selectedFieldOptions {
			...Option
		}
		fieldOptions {
			nodes {
				...Option
			}
		}
	}
	${$6ce9f78048dc7a0d$var$OPTION}
`;
const $6ce9f78048dc7a0d$export$2bba3db49a112c62 = (0, $kuAvn.default)`
	fragment SingleSelectFieldFragment on JiraSingleSelectField {
		fieldOption {
			...Option
		}
		fieldOptions {
			nodes {
				...Option
			}
		}
	}
	${$6ce9f78048dc7a0d$var$OPTION}
`;
const $6ce9f78048dc7a0d$export$f63043138eca54b8 = (0, $kuAvn.default)`
	fragment ConnectSingleSelectFieldFragment on JiraConnectSingleSelectField {
		fieldOption {
			...Option
		}
		fieldOptions {
			nodes {
				...Option
			}
		}
	}
	${$6ce9f78048dc7a0d$var$OPTION}
`;
const $6ce9f78048dc7a0d$export$494028c0baaef0a5 = (0, $kuAvn.default)`
	fragment MultiSelectFieldFragment on JiraMultipleSelectField {
		selectedFieldOptions {
			...Option
		}
		fieldOptions {
			nodes {
				...Option
			}
		}
		searchUrl
	}
	${$6ce9f78048dc7a0d$var$OPTION}
`;
const $6ce9f78048dc7a0d$export$a5740cd9553dc3be = (0, $kuAvn.default)`
	fragment ConnectMultiSelectFieldFragment on JiraConnectMultipleSelectField {
		selectedFieldOptions {
			...Option
		}
		fieldOptions {
			nodes {
				...Option
			}
		}
	}
	${$6ce9f78048dc7a0d$var$OPTION}
`;
const $6ce9f78048dc7a0d$export$8a8492487a98fdaa = (0, $kuAvn.default)`
	fragment RadioSelectFieldFragment on JiraRadioSelectField {
		selectedOption {
			...Option
		}
		fieldOptions {
			nodes {
				...Option
			}
		}
	}
	${$6ce9f78048dc7a0d$var$OPTION}
`;
/* data classification field */ const $6ce9f78048dc7a0d$var$CLASSIFICATION_OPTION = (0, $kuAvn.default)`
	fragment ClassificationLevel on JiraClassificationLevel {
		id
		name
		color {
			colorKey
		}
		definition
		status
	}
`;
const $6ce9f78048dc7a0d$export$c525f571cbe1dcbb = (0, $kuAvn.default)`
	fragment DataClassificationFieldFragment on JiraDataClassificationField {
		classificationLevel {
			...ClassificationLevel
		}
		defaultClassificationLevel {
			...ClassificationLevel
		}
		classificationLevels(filterByCriteria: { filterByStatus: [PUBLISHED], filterByType: [USER] }) {
			edges {
				node {
					...ClassificationLevel
				}
			}
		}
	}
	${$6ce9f78048dc7a0d$var$CLASSIFICATION_OPTION}
`;
/* group picker field fragment */ const $6ce9f78048dc7a0d$var$GROUP = (0, $kuAvn.default)`
	fragment Group on JiraGroup {
		groupId
		name
	}
`;
const $6ce9f78048dc7a0d$export$1507bfa8951ee68d = (0, $kuAvn.default)`
	fragment SingleGroupPickerFieldFragment on JiraSingleGroupPickerField {
		selectedGroup {
			...Group
		}
		searchUrl
	}
	${$6ce9f78048dc7a0d$var$GROUP}
`;
const $6ce9f78048dc7a0d$export$51d039d4ec21f704 = (0, $kuAvn.default)`
	fragment ForgeGroupPickerFieldFragment on JiraForgeGroupField {
		selectedGroup {
			...Group
		}
		searchUrl
	}
	${$6ce9f78048dc7a0d$var$GROUP}
`;
const $6ce9f78048dc7a0d$export$4c4a76b99fc5f54e = (0, $kuAvn.default)`
	fragment MultiGroupPickerFieldFragment on JiraMultipleGroupPickerField {
		selectedGroups {
			...Group
		}
		searchUrl
	}
	${$6ce9f78048dc7a0d$var$GROUP}
`;
const $6ce9f78048dc7a0d$export$ae231dc96d2638ab = (0, $kuAvn.default)`
	fragment ForgeMultiGroupPickerFieldFragment on JiraForgeGroupsField {
		selectedGroups {
			...Group
		}
		searchUrl
	}
	${$6ce9f78048dc7a0d$var$GROUP}
`;
const $6ce9f78048dc7a0d$export$d9b12eb20c31129b = (0, $kuAvn.default)`
	fragment MultiLineTextFieldFragment on JiraMultiLineTextField {
		text
	}
`;
/* sprint field */ const $6ce9f78048dc7a0d$var$SPRINT = (0, $kuAvn.default)`
	fragment Sprint on JiraSprint {
		sprintId
		name
		state
	}
`;
const $6ce9f78048dc7a0d$export$aba335b21420357f = (0, $kuAvn.default)`
	fragment SprintFieldFragment on JiraSprintField {
		selectedSprints {
			...Sprint
		}
		searchUrl
	}
	${$6ce9f78048dc7a0d$var$SPRINT}
`;
const $6ce9f78048dc7a0d$export$585571cdf68c55a1 = (0, $kuAvn.default)`
	fragment ColorFieldFragment on JiraColorField {
		color {
			colorKey
		}
	}
`;
/* request type field */ const $6ce9f78048dc7a0d$var$REQUEST_TYPE = (0, $kuAvn.default)`
	fragment RequestType on JsmRequestType {
		requestTypeId
		name
		description
		helpText
		key
		issueType {
			issueTypeId
		}
		avatar {
			large
		}
		practices {
			key
		}
	}
`;
const $6ce9f78048dc7a0d$export$201be0ff29129622 = (0, $kuAvn.default)`
	fragment RequestTypeFieldFragment on JsmRequestTypeField {
		requestType {
			...RequestType
		}
		requestTypes {
			nodes {
				...RequestType
			}
		}
	}
	${$6ce9f78048dc7a0d$var$REQUEST_TYPE}
`;
const $6ce9f78048dc7a0d$export$589a6183e9780424 = (0, $kuAvn.default)`
	fragment RequestTypeFieldSearchFragment on JsmRequestTypeField {
		requestType {
			...RequestType
		}
		requestTypes(searchBy: $requestTypes) {
			nodes {
				...RequestType
			}
		}
	}
	${$6ce9f78048dc7a0d$var$REQUEST_TYPE}
`;
/* resolution field */ const $6ce9f78048dc7a0d$var$RESOLUTION = (0, $kuAvn.default)`
	fragment Resolution on JiraResolution {
		name
		id: resolutionId
	}
`;
const $6ce9f78048dc7a0d$export$31c88001934c2e15 = (0, $kuAvn.default)`
	fragment ResolutionFieldFragment on JiraResolutionField {
		resolution {
			...Resolution
		}
		resolutions {
			nodes {
				...Resolution
			}
		}
	}
	${$6ce9f78048dc7a0d$var$RESOLUTION}
`;
const $6ce9f78048dc7a0d$export$2f9cfac026740bd3 = (0, $kuAvn.default)`
	fragment CascadingSelectFieldFragment on JiraCascadingSelectField {
		cascadingOption {
			parentOptionValue {
				...Option
			}
			childOptionValue {
				...Option
			}
		}
		cascadingOptions {
			nodes {
				parentOptionValue {
					...Option
				}
				childOptionValues {
					...Option
				}
			}
		}
	}
	${$6ce9f78048dc7a0d$var$OPTION}
`;
/* team field */ const $6ce9f78048dc7a0d$var$TEAM = (0, $kuAvn.default)`
	fragment Team on JiraTeam {
		name
		teamId
	}
`;
const $6ce9f78048dc7a0d$export$cb70b12f3de3f41c = (0, $kuAvn.default)`
	fragment TeamFieldFragment on JiraTeamField {
		selectedTeam {
			...Team
		}
		searchUrl
	}
	${$6ce9f78048dc7a0d$var$TEAM}
`;
/* Atlassian Team field */ const $6ce9f78048dc7a0d$var$ATLASSIAN_TEAM = (0, $kuAvn.default)`
	fragment AtlassianTeam on JiraAtlassianTeam {
		name
		teamId
		avatar {
			small
		}
	}
`;
const $6ce9f78048dc7a0d$export$1173888d99fd7ae6 = (0, $kuAvn.default)`
	fragment AtlassianTeamFieldFragment on JiraAtlassianTeamField {
		JiraAtlassianTeamField: selectedTeam {
			...AtlassianTeam
		}
		searchUrl
	}
	${$6ce9f78048dc7a0d$var$ATLASSIAN_TEAM}
`;
/* affected services field */ const $6ce9f78048dc7a0d$var$AFFECTED_SERVICE = (0, $kuAvn.default)`
	fragment AffectedService on JiraAffectedService {
		serviceId
	}
`;
const $6ce9f78048dc7a0d$var$ASSET = (0, $kuAvn.default)`
	fragment Asset on JiraAsset {
		serializedOrigin
		appKey
		originId
		value
	}
`;
const $6ce9f78048dc7a0d$export$97cdf1e4b8832240 = (0, $kuAvn.default)`
	fragment AssetFieldFragment on JiraAssetField {
		selectedAssets {
			...Asset
		}
		searchUrl
	}
	${$6ce9f78048dc7a0d$var$ASSET}
`;
const $6ce9f78048dc7a0d$export$3480d890dca64b9e = (0, $kuAvn.default)`
	fragment AffectedServicesFieldFragment on JiraAffectedServicesField {
		selectedAffectedServices {
			...AffectedService
		}
		searchUrl
	}
	${$6ce9f78048dc7a0d$var$AFFECTED_SERVICE}
`;
const $6ce9f78048dc7a0d$export$c1864cedbeda248a = (0, $kuAvn.default)`
	fragment CMDBFieldFragment on JiraCMDBField {
		searchUrl
		isMulti
		attributesIncludedInAutoCompleteSearch
		selectedCmdbObjects {
			id
			objectId
			workspaceId
			label
		}
	}
`;
/* organizations field */ const $6ce9f78048dc7a0d$var$ORGANIZATION = (0, $kuAvn.default)`
	fragment Organization on JsmOrganization {
		organizationId
		organizationName
		domain
		__typename
	}
`;
const $6ce9f78048dc7a0d$export$e0f3793fd890e0 = (0, $kuAvn.default)`
	fragment OrganizationsFieldFragment on JsmOrganizationField {
		selectedOrganizations {
			...Organization
		}
		searchUrl
	}
	${$6ce9f78048dc7a0d$var$ORGANIZATION}
`;
const $6ce9f78048dc7a0d$export$f9e6189fd786f6 = (0, $kuAvn.default)`
	fragment TimeTrackingFieldFragment on JiraTimeTrackingField {
		timeTrackingSettings {
			workingDaysPerWeek
			workingHoursPerDay
			defaultFormat
			defaultUnit
			isJiraConfiguredTimeTrackingEnabled
		}
		originalEstimate {
			timeInSeconds
		}
	}
`;
const $6ce9f78048dc7a0d$export$c6c1a1f3d6f49ea4 = (0, $kuAvn.default)`
	fragment WorkLogFieldFragment on JiraWorkLogField {
		timeTrackingSettings {
			workingDaysPerWeek
			workingHoursPerDay
			defaultFormat
			defaultUnit
			isJiraConfiguredTimeTrackingEnabled
		}
		mediaContext {
			...JiraMediaContextFragment
		}
	}
	${$6ce9f78048dc7a0d$var$MEDIA_CONTEXT_FRAGMENT}
`;
const $6ce9f78048dc7a0d$export$825c869f7cd85da3 = (0, $kuAvn.default)`
	fragment Issue on JiraIssue {
		key
		issueId
		avatar {
			large
		}
	}
`;
const $6ce9f78048dc7a0d$export$fa778835050523e6 = (0, $kuAvn.default)`
	fragment ParentLinkFieldFragment on JiraParentIssueField {
		searchUrl
		parentIssue {
			...Issue
		}
	}
	${$6ce9f78048dc7a0d$export$825c869f7cd85da3}
`;
const $6ce9f78048dc7a0d$export$4561a4960baf1b2b = (0, $kuAvn.default)`
	fragment ParentIssue on JiraIssue {
		key
		issueId
		avatar {
			large
		}
		issueColorField {
			color {
				colorKey
			}
		}
		fieldsById(ids: ["summary", "issuetype"]) {
			edges {
				node {
					... on JiraSingleLineTextField {
						text
					}
					... on JiraIssueTypeField {
						issueType {
							name
							avatar {
								xsmall
							}
						}
					}
				}
			}
		}
	}
`;
const $6ce9f78048dc7a0d$export$f75050611ceb9d35 = (0, $kuAvn.default)`
	fragment ParentFieldFragment on JiraParentIssueField {
		parentIssue {
			...ParentIssue
		}
	}
	${$6ce9f78048dc7a0d$export$4561a4960baf1b2b}
`;
const $6ce9f78048dc7a0d$export$f89396a6b77b653f = (0, $kuAvn.default)`
	fragment StatusFieldFragment on JiraStatusField {
		name
		description
		aliasFieldId
		__typename
	}
`;
const $6ce9f78048dc7a0d$export$335dcd5b86a25a15 = (0, $kuAvn.default)`
	fragment JiraServiceManagementRespondersFieldFragment on JiraServiceManagementRespondersField {
		searchUrl
	}
`;
const $6ce9f78048dc7a0d$export$5f06542accc83cb5 = (0, $kuAvn.default)`
	fragment ProformaConfigFragment on JiraIssueCreateProformaConfiguration {
		serviceId
		proforma {
			portalLink
			hasProformaForm
		}
	}
`;
const $6ce9f78048dc7a0d$export$eda8fbd7533aaac1 = (0, $kuAvn.default)`
	fragment WatchersConfigFragment on JiraIssueCreateWatchersConfiguration {
		serviceId
		permissions {
			canManageWatchers
			canViewWatchers
			isAutoWatchEnabled
			isWatchersEnabled
		}
		__typename
	}
`;

});


parcelRegister("fAieL", function(module, exports) {

$parcel$export(module.exports, "useModalLoadUiTaskEvents", () => $d46a7871abc828f3$export$ea127ad09302d920);

var $eJOHy = parcelRequire("eJOHy");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");
const $d46a7871abc828f3$var$MODAL_LOAD_TASK_NAME = 'viewGlobalIssueCreateModal';
const $d46a7871abc828f3$var$MODAL_LOAD_TASK_FAIL_EVENT_NAME = 'ui taskFail';
const $d46a7871abc828f3$var$MODAL_LOAD_TASK_SUCCESS_EVENT_NAME = 'ui taskSuccess';
const $d46a7871abc828f3$var$MODAL_LOAD_TASK_ABORT_EVENT_NAME = 'ui taskAbort';
const $d46a7871abc828f3$export$ea127ad09302d920 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const fireModalLoadTaskFailEvent = (0, $eJOHy.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({});
        (0, $gCeeo.fireOperationalAnalyticsDeferred)(analyticsEvent, $d46a7871abc828f3$var$MODAL_LOAD_TASK_FAIL_EVENT_NAME, {
            task: $d46a7871abc828f3$var$MODAL_LOAD_TASK_NAME
        });
    }, [
        createAnalyticsEvent
    ]);
    const fireModalLoadTaskSuccessEvent = (0, $eJOHy.useCallback)((analyticsEvent)=>{
        (0, $gCeeo.fireOperationalAnalyticsDeferred)(analyticsEvent, $d46a7871abc828f3$var$MODAL_LOAD_TASK_SUCCESS_EVENT_NAME, {
            task: $d46a7871abc828f3$var$MODAL_LOAD_TASK_NAME
        });
    }, []);
    const fireModalLoadTaskAbortEvent = (0, $eJOHy.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({});
        (0, $gCeeo.fireOperationalAnalyticsDeferred)(analyticsEvent, $d46a7871abc828f3$var$MODAL_LOAD_TASK_ABORT_EVENT_NAME, {
            task: $d46a7871abc828f3$var$MODAL_LOAD_TASK_NAME
        });
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireModalLoadTaskFailEvent: fireModalLoadTaskFailEvent,
        fireModalLoadTaskSuccessEvent: fireModalLoadTaskSuccessEvent,
        fireModalLoadTaskAbortEvent: fireModalLoadTaskAbortEvent
    };
};

});

parcelRegister("7mJUz", function(module, exports) {

$parcel$export(module.exports, "getCreateConfigUserPreferredQueryInContext", () => $d9c0a896d607f1a4$export$edf18d1585c23939);
// eslint-disable-next-line jira/restricted/graphql-tag

var $kuAvn = parcelRequire("kuAvn");

var $7jTnu = parcelRequire("7jTnu");

var $krdGL = parcelRequire("krdGL");
// eslint-disable-next-line jira/ff/inline-usage
const $d9c0a896d607f1a4$var$isJsmRespondersFieldEnabled = ()=>(0, $7jTnu.fg)('jsm-responders-field-in-gicx-ui');
const $d9c0a896d607f1a4$var$skipTernaryForIssueLinksRefinementFragment = ()=>{
    if ((0, $7jTnu.fg)('remove_issue_links_id_query_from_issue_create')) return (0, $7jTnu.fg)('create_linked_issues_trigger_point_issue_view') ? '...IssueLinksFieldFragmentWithCopyLinksAndAttachmentsRefined' : '...IssueLinksFieldFragmentRefined';
    return (0, $7jTnu.fg)('create_linked_issues_trigger_point_issue_view') ? '...IssueLinksFieldFragmentWithCopyLinksAndAttachments' : '...IssueLinksFieldFragment';
};
const $d9c0a896d607f1a4$var$skipTernaryForIssueLinksRefinementGira = ()=>{
    if ((0, $7jTnu.fg)('remove_issue_links_id_query_from_issue_create')) return (0, $7jTnu.fg)('create_linked_issues_trigger_point_issue_view') ? (0, $krdGL.ISSUE_LINKS_FIELD_FRAGMENT_WITH_COPY_LINKS_AND_ATTACHMENTS_REFINED) : (0, $krdGL.ISSUE_LINKS_FIELD_FRAGMENT_REFINED);
    return (0, $7jTnu.fg)('create_linked_issues_trigger_point_issue_view') ? (0, $krdGL.ISSUE_LINKS_FIELD_FRAGMENT_WITH_COPY_LINKS_AND_ATTACHMENTS) : (0, $krdGL.ISSUE_LINKS_FIELD_FRAGMENT);
};
const $d9c0a896d607f1a4$export$edf18d1585c23939 = (withML, isCreateLinkedIssue)=>(0, $kuAvn.default)`
    query JiraGlobalIssueCreateInContext${isCreateLinkedIssue && (0, $7jTnu.fg)('create_linked_issues_trigger_point_issue_view') ? 'WithCLI' : ''}(
        $project: JiraProjectInput
        $issueType: JiraIssueTypeInput
        $requestType: JiraRequestTypeInput
        $defaultValues: JiraIssueFieldsInput
        $additionalContext: JiraIssueCreateContextInput!
        ${(0, $7jTnu.fg)('create_linked_issues_trigger_point_issue_view') ? '$issueCreateType: IssueCreateTypeFilter' : ''}
    ) {
        ${withML ? 'jiraIssueCreateLayoutInContextWithML' : 'jiraIssueCreateLayoutInContext'}(
            layoutFilter: USER_CONFIGURED_LAYOUT
            project: $project
            issueType: $issueType
            additionalContext: $additionalContext
            ${(0, $7jTnu.fg)('create_linked_issues_trigger_point_issue_view') ? 'issueCreateType: $issueCreateType' : ''}
        ) {
            ...LayoutFragment
        }
        jiraIssueCreateFieldsInContext(
            fieldsFilter: USER_CONFIGURED_FIELDS
            project: $project
            issueType: $issueType
            additionalContext: $additionalContext
            requestType: $requestType
            defaultValues: $defaultValues
            ${(0, $7jTnu.fg)('create_linked_issues_trigger_point_issue_view') ? 'issueCreateType: $issueCreateType' : ''}
        ) {
            ... on JiraIssueCreateFields {
                fields {
                    nodes {
                        ...BaseFieldFragment
                        ...ProjectFieldFragmentWithoutClassification
                        ...IssueTypeFieldFragment
                        ...RequestTypeFieldFragment
                        ...TextFieldFragment
                        ...RichTextFieldFragment
                        ...ComponentsFieldFragment
                        ...VersionFieldFragment
                        ...MultiVersionFieldFragment
                        ...PriorityFieldFragment
                        ...SprintFieldFragment
                        ...LabelFieldFragment
                        ...SingleUserPickerFieldFragment
                        ...MultiUserPickerFieldFragment
                        ...PeopleFieldFragment
                        ...SecurityFieldFragment
                        ...IssueRestrictionFieldFragment
                        ...ColorFieldFragment
                        ...ResolutionFieldFragment
                        ...SingleSelectFieldFragment
                        ...MultiSelectFieldFragment
                        ...NumberFieldFragment
                        ...UrlFieldFragment
                        ...EpicLinkFieldFragment
                        ...DatePickerFieldFragment
                        ...DateTimePickerFieldFragment
                        ...CascadingSelectFieldFragment
                        ...AttachmentsFieldFragment
                        ...CheckboxFieldFragment
                        ${$d9c0a896d607f1a4$var$skipTernaryForIssueLinksRefinementFragment()}
                        ...SingleGroupPickerFieldFragment
                        ...MultiGroupPickerFieldFragment
                        ...TeamFieldFragment
                        ...AtlassianTeamFieldFragment
                        ...RadioSelectFieldFragment
                        ...AffectedServicesFieldFragment
                        ...CMDBFieldFragment
                        ...OrganizationsFieldFragment
                        ...ConnectTextFieldFragment
                        ...ConnectNumberFieldFragment
                        ...ConnectSingleSelectFieldFragment
                        ...ConnectMultiSelectFieldFragment
                        ...ConnectRichTextFieldFragment
                        ...AssetFieldFragment
                        ...ForgeStringFieldFragment
                        ...ForgeNumberFieldFragment
                        ...ForgeSingleUserPickerFieldFragment
                        ...ForgeMultiUserPickerFieldFragment
                        ...ForgeGroupPickerFieldFragment
                        ...ForgeMultiGroupPickerFieldFragment
                        ...ForgeStringsFieldFragment
                        ...ForgeObjectFieldFragment
                        ...ForgeDateTimePickerFieldFragment
                        ...TimeTrackingFieldFragment
                        ...WorkLogFieldFragment
                        ...JsmMultiUserPickerFieldFragment
                        ...JsmPeopleFieldFragment
                        ...ParentLinkFieldFragment
                        ...ParentFieldFragment
                        ...StatusFieldFragment
                        ${$d9c0a896d607f1a4$var$isJsmRespondersFieldEnabled() ? '...JiraServiceManagementRespondersFieldFragment' : ''}
                    }
                }
                errors {
                    identifier
                    extensions {
                        ... on JiraIssueFieldUnsupportedErrorExtension {
                            fieldName
                            fieldType
                            isRequiredField
                        }
                        ... on JiraIssueFieldValueValidationErrorExtension {
                            errorType
                            message
                        }
                    }
                }
            }
            ... on QueryError {
                message
            }
        }
        jiraIssueCreateAdditionalServices(project: $project, issueType: $issueType, requestType: $requestType) {
            ... on JiraIssueCreateAdditionalServices {
                services {
                    edges {
                        node {
                            ...WatchersConfigFragment
                            ...ProformaConfigFragment
                        }
                    }
                }
            }
            ... on QueryError {
                message
            }
        }
    }
    ${withML ? (0, $krdGL.LAYOUT_FRAGMENT_WITH_ML) : (0, $krdGL.LAYOUT_FRAGMENT)}
    ${0, $krdGL.BASE_FIELD_FRAGMENT}
    ${0, $krdGL.PROJECT_FIELD_FRAGMENT_WITHOUT_CLASSIFICATION}
    ${0, $krdGL.ISSUE_TYPE_FIELD_FRAGMENT}
    ${0, $krdGL.REQUEST_TYPE_FIELD_FRAGMENT}
    ${0, $krdGL.TEXT_FIELD_FRAGMENT}
    ${0, $krdGL.RICH_TEXT_FIELD_FRAGMENT}
    ${0, $krdGL.COMPONENTS_FIELD_FRAGMENT}
    ${0, $krdGL.VERSION_FIELD_FRAGMENT}
    ${0, $krdGL.MULTI_VERSION_FIELD_FRAGMENT}
    ${0, $krdGL.PRIORITY_FIELD_FRAGMENT}
    ${0, $krdGL.SPRINT_FIELD_FRAGMENT}
    ${0, $krdGL.LABEL_FIELD_FRAGMENT}
    ${0, $krdGL.SINGLE_USER_PICKER_FIELD_FRAGMENT}
    ${0, $krdGL.MULTI_USER_PICKER_FIELD_FRAGMENT}
    ${0, $krdGL.SECURITY_FIELD_FRAGMENT}
    ${0, $krdGL.ISSUE_RESTRICTION_FIELD_FRAGMENT}
    ${0, $krdGL.COLOR_FIELD_FRAGMENT}
    ${0, $krdGL.RESOLUTION_FIELD_FRAGMENT}
    ${0, $krdGL.SINGLE_SELECT_FIELD_FRAGMENT}
    ${0, $krdGL.MULTI_SELECT_FIELD_FRAGMENT}
    ${0, $krdGL.NUMBER_FIELD_FRAGMENT}
    ${0, $krdGL.URL_FIELD_FRAGMENT}
    ${0, $krdGL.EPIC_LINK_FIELD_FRAGMENT}
    ${0, $krdGL.DATE_FIELD_FRAGMENT}
    ${0, $krdGL.DATE_TIME_FIELD_FRAGMENT}
    ${0, $krdGL.CASCADING_SELECT_FIELD_FRAGMENT}
    ${0, $krdGL.ATTACHMENTS_FIELD_FRAGMENT}
    ${0, $krdGL.CHECKBOX_FIELD_FRAGMENT}
    ${$d9c0a896d607f1a4$var$skipTernaryForIssueLinksRefinementGira()}
    ${0, $krdGL.SINGLE_GROUP_PICKER_FIELD_FRAGMENT}
    ${0, $krdGL.MULTI_GROUP_PICKER_FIELD_FRAGMENT}
    ${0, $krdGL.PEOPLE_FIELD_FRAGMENT}
    ${0, $krdGL.TEAM_FIELD_FRAGMENT}
    ${0, $krdGL.ATLASSIAN_TEAM_FIELD_FRAGMENT}
    ${0, $krdGL.RADIO_SELECT_FIELD_FRAGMENT}
    ${0, $krdGL.AFFECTED_SERVICES_FIELD_FRAGMENT}
    ${0, $krdGL.CMDB_FIELD_FRAGMENT}
    ${0, $krdGL.ORGANIZATIONS_FIELD_FRAGMENT}
    ${0, $krdGL.CONNECT_TEXT_FIELD_FRAGMENT}
    ${0, $krdGL.CONNECT_NUMBER_FIELD_FRAGMENT}
    ${0, $krdGL.CONNECT_SINGLE_SELECT_FIELD_FRAGMENT}
    ${0, $krdGL.CONNECT_MULTI_SELECT_FIELD_FRAGMENT}
    ${0, $krdGL.CONNECT_RICH_TEXT_FIELD_FRAGMENT}
    ${0, $krdGL.ASSET_FIELD_FRAGMENT}
    ${0, $krdGL.FORGE_STRING_FIELD_FRAGMENT}
    ${0, $krdGL.FORGE_NUMBER_FIELD_FRAGMENT}
    ${0, $krdGL.FORGE_SINGLE_USER_PICKER_FIELD_FRAGMENT}
    ${0, $krdGL.FORGE_MULTI_USER_PICKER_FIELD_FRAGMENT}
    ${0, $krdGL.FORGE_GROUP_PICKER_FIELD_FRAGMENT}
    ${0, $krdGL.FORGE_MULTI_GROUP_PICKER_FIELD_FRAGMENT}
    ${0, $krdGL.FORGE_STRINGS_FIELD_FRAGMENT}
    ${0, $krdGL.FORGE_DATETIME_FIELD_FRAGMENT}
    ${0, $krdGL.FORGE_OBJECT_FIELD_FRAGMENT}
    ${0, $krdGL.TIME_TRACKING_FIELD_FRAGMENT}
    ${0, $krdGL.WORK_LOG_FIELD_FRAGMENT}
    ${0, $krdGL.JSM_MULTI_USER_PICKER_FIELD_FRAGMENT}
    ${0, $krdGL.JSM_PEOPLE_FIELD_FRAGMENT}
    ${0, $krdGL.PARENT_LINK_FIELD_FRAGMENT}
    ${0, $krdGL.PARENT_FIELD_FRAGMENT}
    ${0, $krdGL.PROFORMA_CONFIG_FRAGMENT}
    ${0, $krdGL.STATUS_FIELD_FRAGMENT}
    ${$d9c0a896d607f1a4$var$isJsmRespondersFieldEnabled() ? (0, $krdGL.RESPONDERS_FIELD_FRAGMENT) : ''}
    ${0, $krdGL.WATCHERS_CONFIG_FRAGMENT}
`;

});


parcelRegister("kIKDZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $31b343aa1c064424$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1fMqv = parcelRequire("1fMqv");

var $7jTnu = parcelRequire("7jTnu");

var $2ho4j = parcelRequire("2ho4j");

var $lz17b = parcelRequire("lz17b");

var $4CDQT = parcelRequire("4CDQT");

var $73QLY = parcelRequire("73QLY");

var $bSxlM = parcelRequire("bSxlM");

var $fAieL = parcelRequire("fAieL");

var $2kAqg = parcelRequire("2kAqg");
const $31b343aa1c064424$var$useFetchCreateConfigQuery = (props = {})=>{
    const { fireErrorAnalyticsEvent: fireErrorAnalyticsEvent } = (0, $lz17b.useIssueCreateErrorAnalyticsEvent)();
    const { fireModalLoadTaskFailEvent: fireModalLoadTaskFailEvent, fireModalLoadTaskAbortEvent: fireModalLoadTaskAbortEvent } = (0, $fAieL.useModalLoadUiTaskEvents)();
    const { displayOnlyRequiredFields: displayOnlyRequiredFields = false } = props;
    const [loading, setLoading] = (0, $eJOHy.useState)(false);
    const [fetchError, setFetchError] = (0, $eJOHy.useState)(null);
    const apiStartTime = (0, $eJOHy.useRef)(0);
    const [apiLatency, setApiLatency] = (0, $eJOHy.useState)(0);
    const [data, setData] = (0, $eJOHy.useState)({
        fieldTabs: [],
        fieldConfig: {},
        contextFields: {},
        meta: {
            areRequiredFieldsSupported: true,
            queryErrorMessage: ''
        },
        additionalServices: {}
    });
    const { withMachineLearning: withMachineLearning } = (0, $73QLY.useSmartFieldsMachineLearning)();
    const createConfigQuery = (0, $7jTnu.fg)('new-issue-create-fetch-config-query') ? (0, $bSxlM.getCreateConfigQuery)({
        isInContext: false,
        withML: withMachineLearning,
        isJsmRespondersFieldEnabled: (0, $7jTnu.fg)('jsm-responders-field-in-gicx-ui')
    }) : (0, $2kAqg.getCreateConfigUserPreferredQuery)(withMachineLearning);
    const [fetchConfig] = (0, $1fMqv.useLazyQuery)(createConfigQuery, {
        fetchPolicy: 'no-cache',
        onCompleted: (queryData)=>{
            setApiLatency(Math.floor(performance.now() - apiStartTime.current));
            setData((0, $4CDQT.transformQueryResults)((0, $4CDQT.transformQueryData)(queryData), displayOnlyRequiredFields));
            setLoading(false);
        },
        onError: (error)=>{
            setFetchError(error);
            const errorType = (0, $2ho4j.handleApolloError)(error);
            fireErrorAnalyticsEvent({
                meta: {
                    id: 'useFetchCreateConfigQuery',
                    packageName: 'jiraIssueCreate',
                    teamName: 'gryffindor'
                },
                error: error,
                errorType: // TODO: remove this from here and ensure this is moving in attibutes
                errorType
            });
            if (errorType === 'graphQLError' && (0, $7jTnu.fg)('global_issue_create_modal_view_task_fail_event')) fireModalLoadTaskFailEvent();
            else if ((0, $7jTnu.fg)('global_issue_create_modal_view_task_abort_event')) fireModalLoadTaskAbortEvent();
        }
    });
    const handleFetch = (0, $eJOHy.useRef)((queryVariables)=>{
        setLoading(true);
        apiStartTime.current = performance.now();
        fetchConfig(queryVariables);
    });
    return [
        {
            isLoading: loading,
            fieldTabs: data.fieldTabs,
            fieldConfig: data.fieldConfig,
            contextFields: data.contextFields,
            meta: data.meta,
            error: fetchError,
            apiLatency: apiLatency,
            additionalServices: data.additionalServices
        },
        handleFetch.current
    ];
};
var $31b343aa1c064424$export$2e2bcd8739ae039 = $31b343aa1c064424$var$useFetchCreateConfigQuery;

});
parcelRegister("lz17b", function(module, exports) {

$parcel$export(module.exports, "useIssueCreateErrorAnalyticsEvent", () => $41b46104c3ace023$export$a57802f0a2053450);

var $eJOHy = parcelRequire("eJOHy");

var $eDBhy = parcelRequire("eDBhy");

var $7jTnu = parcelRequire("7jTnu");

var $jQUoP = parcelRequire("jQUoP");

var $jipjz = parcelRequire("jipjz");

var $1uIew = parcelRequire("1uIew");

var $gtCj5 = parcelRequire("gtCj5");

var $73QLY = parcelRequire("73QLY");

var $6u3jg = parcelRequire("6u3jg");
const $41b46104c3ace023$export$a57802f0a2053450 = ()=>{
    const isGICPositioningEnabled = (0, $6u3jg.useIsGICPositioningEnabled)();
    const issueCreateMeta = (0, $gtCj5.getAdditionalAttributes)();
    const [{ isSubTaskCreationOpen: isSubTaskCreationOpen, isCreateLinkedIssue: isCreateLinkedIssue = false, triggerPointKey: triggerPointKey, swimlaneMode: swimlaneMode, product: product, actionSource: actionSource }] = (0, $jipjz.useTriggerIssueCreateModal)();
    const [{ selectedProject: selectedProject, canCreateAnotherIssue: canCreateAnotherIssue }] = (0, $jQUoP.useFormContext)();
    const [{ minimizableModalView: minimizableModalView }] = isGICPositioningEnabled() ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jipjz.useTriggerIssueCreateModal)() : [
        {
            minimizableModalView: undefined
        }
    ];
    const { withMachineLearning: withMachineLearning } = (0, $73QLY.useSmartFieldsMachineLearning)();
    const fireErrorAnalyticsEvent = (0, $eJOHy.useCallback)((props)=>{
        const { meta: meta, error: error, statusCode: statusCode, errorType: errorType } = props;
        (0, $eDBhy.fireIssueCreateErrorAnalytics)({
            meta: meta,
            error: error,
            attributes: {
                statusCode: statusCode,
                errorType: errorType,
                isNewGIC: true,
                isCreatingAnotherIssue: canCreateAnotherIssue,
                isSubtask: isSubTaskCreationOpen,
                triggerPointKey: triggerPointKey,
                projectType: selectedProject?.projectType,
                ...selectedProject ? {
                    nextGenProject: selectedProject.isSimplified
                } : {},
                ...isGICPositioningEnabled() ? {
                    gicViewState: minimizableModalView
                } : {},
                ...(0, $7jTnu.fg)('create_linked_issues_trigger_point_issue_view') ? {
                    isCreateLinkedIssue: isCreateLinkedIssue
                } : {},
                smartFieldsEnabled: withMachineLearning,
                swimlaneMode: swimlaneMode,
                ...product ? {
                    product: product
                } : {},
                ...actionSource ? {
                    actionSource: actionSource
                } : {},
                isValidationError: (0, $1uIew.isValidationError)(error),
                ...issueCreateMeta
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }, [
        actionSource,
        canCreateAnotherIssue,
        isCreateLinkedIssue,
        isGICPositioningEnabled,
        isSubTaskCreationOpen,
        issueCreateMeta,
        minimizableModalView,
        product,
        selectedProject,
        swimlaneMode,
        triggerPointKey,
        withMachineLearning
    ]);
    return {
        fireErrorAnalyticsEvent: fireErrorAnalyticsEvent
    };
};

});

parcelRegister("2kAqg", function(module, exports) {

$parcel$export(module.exports, "getCreateConfigUserPreferredQuery", () => $fff9e34bcad2147f$export$5181d52929b93430);
// eslint-disable-next-line jira/restricted/graphql-tag

var $kuAvn = parcelRequire("kuAvn");

var $7jTnu = parcelRequire("7jTnu");

var $epTsa = parcelRequire("epTsa");

var $krdGL = parcelRequire("krdGL");
// eslint-disable-next-line jira/ff/inline-usage
const $fff9e34bcad2147f$var$isJsmRespondersFieldEnabled = ()=>(0, $7jTnu.fg)('jsm-responders-field-in-gicx-ui');
const $fff9e34bcad2147f$export$5181d52929b93430 = (withML)=>(0, $kuAvn.default)`
    query JiraGlobalIssueCreateModalLoad(
        $project: JiraProjectInput
        $issueType: JiraIssueTypeInput
        $requestType: JiraRequestTypeInput
        $defaultValues: JiraIssueFieldsInput
        $issueTypes: String
        $requestTypes: String

    ) {
        ${withML ? 'jiraIssueCreateLayoutWithML' : 'jiraIssueCreateLayout'}(
            layoutFilter: USER_CONFIGURED_LAYOUT
            project: $project
            issueType: $issueType
            requestType: $requestType
        ) {
            ...LayoutFragment
        }
        jiraIssueCreateFields(
            fieldsFilter: USER_CONFIGURED_FIELDS
            project: $project
            issueType: $issueType
            requestType: $requestType
            defaultValues: $defaultValues
        ) {
            ... on JiraIssueCreateFields {
                fields {
                    nodes {
                        ...BaseFieldFragment
                        ...ProjectFieldFragmentWithoutClassification
                        ...IssueTypeFieldSearchFragment
                        ...RequestTypeFieldSearchFragment
                        ...TextFieldFragment
                        ...RichTextFieldFragment
                        ...ComponentsFieldFragment
                        ...VersionFieldFragment
                        ...MultiVersionFieldFragment
                        ...PriorityFieldFragment
                        ...SprintFieldFragment
                        ${(0, $epTsa.expVal)('adding-color-to-labels-field-experiment-milestone2', 'isColorfulNewLabelsEnabled', false) ? '...LabelWithColorFieldFragment' : '...LabelFieldFragment'}
                        ...SingleUserPickerFieldFragment
                        ...MultiUserPickerFieldFragment
                        ...PeopleFieldFragment
                        ...SecurityFieldFragment
                        ...IssueRestrictionFieldFragment
                        ...ColorFieldFragment
                        ...ResolutionFieldFragment
                        ...SingleSelectFieldFragment
                        ...MultiSelectFieldFragment
                        ...NumberFieldFragment
                        ...UrlFieldFragment
                        ...EpicLinkFieldFragment
                        ...DatePickerFieldFragment
                        ...DateTimePickerFieldFragment
                        ...CascadingSelectFieldFragment
                        ...AttachmentsFieldFragment
                        ...CheckboxFieldFragment
                        ${(0, $7jTnu.fg)('remove_issue_links_id_query_from_issue_create') ? '...IssueLinksFieldFragmentRefined' : '...IssueLinksFieldFragment'}
                        ...SingleGroupPickerFieldFragment
                        ...MultiGroupPickerFieldFragment
                        ...TeamFieldFragment
                        ...AtlassianTeamFieldFragment
                        ...RadioSelectFieldFragment
                        ...AffectedServicesFieldFragment
                        ...CMDBFieldFragment
                        ...OrganizationsFieldFragment
                        ...ConnectTextFieldFragment
                        ...ConnectNumberFieldFragment
                        ...ConnectSingleSelectFieldFragment
                        ...ConnectMultiSelectFieldFragment
                        ...ConnectRichTextFieldFragment
                        ...AssetFieldFragment
                        ...ForgeStringFieldFragment
                        ...ForgeNumberFieldFragment
                        ...ForgeSingleUserPickerFieldFragment
                        ...ForgeMultiUserPickerFieldFragment
                        ...ForgeGroupPickerFieldFragment
                        ...ForgeMultiGroupPickerFieldFragment
                        ...ForgeStringsFieldFragment
                        ...ForgeObjectFieldFragment
                        ...ForgeDateTimePickerFieldFragment
                        ...TimeTrackingFieldFragment
                        ...WorkLogFieldFragment
                        ...JsmMultiUserPickerFieldFragment
                        ...JsmPeopleFieldFragment
                        ...ParentLinkFieldFragment
                        ...DataClassificationFieldFragment
                        ...ParentFieldFragment
                        ...StatusFieldFragment
                        ${$fff9e34bcad2147f$var$isJsmRespondersFieldEnabled() ? '...JiraServiceManagementRespondersFieldFragment' : ''}
                    }
                }
                errors {
                    identifier
                    extensions {
                        ... on JiraIssueFieldUnsupportedErrorExtension {
                            fieldName
                            fieldType
                            isRequiredField
                        }
                        ... on JiraIssueFieldValueValidationErrorExtension {
                            errorType
                            message
                        }
                    }
                }
            }
            ... on QueryError {
                message
            }
        }
        jiraIssueCreateAdditionalServices(project: $project, issueType: $issueType, requestType: $requestType) {
            ... on JiraIssueCreateAdditionalServices {
                services {
                    edges {
                        node {
                            ...WatchersConfigFragment
                            ...ProformaConfigFragment
                        }
                    }
                }
            }
            ... on QueryError {
                message
            }
        }
    }
    ${withML ? (0, $krdGL.LAYOUT_FRAGMENT_WITH_ML) : (0, $krdGL.LAYOUT_FRAGMENT)}
    ${0, $krdGL.BASE_FIELD_FRAGMENT}
    ${0, $krdGL.PROJECT_FIELD_FRAGMENT_WITHOUT_CLASSIFICATION}
    ${0, $krdGL.ISSUE_TYPE_FIELD_SEARCH_BY_FRAGMENT}
    ${0, $krdGL.REQUEST_TYPE_FIELD_SEARCH_BY_FRAGMENT}
    ${0, $krdGL.TEXT_FIELD_FRAGMENT}
    ${0, $krdGL.RICH_TEXT_FIELD_FRAGMENT}
    ${0, $krdGL.COMPONENTS_FIELD_FRAGMENT}
    ${0, $krdGL.VERSION_FIELD_FRAGMENT}
    ${0, $krdGL.MULTI_VERSION_FIELD_FRAGMENT}
    ${0, $krdGL.PRIORITY_FIELD_FRAGMENT}
    ${0, $krdGL.SPRINT_FIELD_FRAGMENT}
    ${(0, $epTsa.expVal)('adding-color-to-labels-field-experiment-milestone2', 'isColorfulNewLabelsEnabled', false) ? (0, $krdGL.LABEL_WITH_COLOR_FIELD_FRAGMENT) : (0, $krdGL.LABEL_FIELD_FRAGMENT)}
    ${0, $krdGL.SINGLE_USER_PICKER_FIELD_FRAGMENT}
    ${0, $krdGL.MULTI_USER_PICKER_FIELD_FRAGMENT}
    ${0, $krdGL.SECURITY_FIELD_FRAGMENT}
    ${0, $krdGL.ISSUE_RESTRICTION_FIELD_FRAGMENT}
    ${0, $krdGL.COLOR_FIELD_FRAGMENT}
    ${0, $krdGL.RESOLUTION_FIELD_FRAGMENT}
    ${0, $krdGL.SINGLE_SELECT_FIELD_FRAGMENT}
    ${0, $krdGL.MULTI_SELECT_FIELD_FRAGMENT}
    ${0, $krdGL.NUMBER_FIELD_FRAGMENT}
    ${0, $krdGL.URL_FIELD_FRAGMENT}
    ${0, $krdGL.EPIC_LINK_FIELD_FRAGMENT}
    ${0, $krdGL.DATE_FIELD_FRAGMENT}
    ${0, $krdGL.DATE_TIME_FIELD_FRAGMENT}
    ${0, $krdGL.CASCADING_SELECT_FIELD_FRAGMENT}
    ${0, $krdGL.ATTACHMENTS_FIELD_FRAGMENT}
    ${0, $krdGL.CHECKBOX_FIELD_FRAGMENT}
    ${(0, $7jTnu.fg)('remove_issue_links_id_query_from_issue_create') ? (0, $krdGL.ISSUE_LINKS_FIELD_FRAGMENT_REFINED) : (0, $krdGL.ISSUE_LINKS_FIELD_FRAGMENT)}
    ${0, $krdGL.SINGLE_GROUP_PICKER_FIELD_FRAGMENT}
    ${0, $krdGL.MULTI_GROUP_PICKER_FIELD_FRAGMENT}
    ${0, $krdGL.PEOPLE_FIELD_FRAGMENT}
    ${0, $krdGL.TEAM_FIELD_FRAGMENT}
    ${0, $krdGL.ATLASSIAN_TEAM_FIELD_FRAGMENT}
    ${0, $krdGL.RADIO_SELECT_FIELD_FRAGMENT}
    ${0, $krdGL.AFFECTED_SERVICES_FIELD_FRAGMENT}
    ${0, $krdGL.CMDB_FIELD_FRAGMENT}
    ${0, $krdGL.ORGANIZATIONS_FIELD_FRAGMENT}
    ${0, $krdGL.CONNECT_TEXT_FIELD_FRAGMENT}
    ${0, $krdGL.CONNECT_NUMBER_FIELD_FRAGMENT}
    ${0, $krdGL.CONNECT_SINGLE_SELECT_FIELD_FRAGMENT}
    ${0, $krdGL.CONNECT_MULTI_SELECT_FIELD_FRAGMENT}
    ${0, $krdGL.CONNECT_RICH_TEXT_FIELD_FRAGMENT}
    ${0, $krdGL.ASSET_FIELD_FRAGMENT}
    ${0, $krdGL.FORGE_STRING_FIELD_FRAGMENT}
    ${0, $krdGL.FORGE_NUMBER_FIELD_FRAGMENT}
    ${0, $krdGL.FORGE_SINGLE_USER_PICKER_FIELD_FRAGMENT}
    ${0, $krdGL.FORGE_MULTI_USER_PICKER_FIELD_FRAGMENT}
    ${0, $krdGL.FORGE_GROUP_PICKER_FIELD_FRAGMENT}
    ${0, $krdGL.FORGE_MULTI_GROUP_PICKER_FIELD_FRAGMENT}
    ${0, $krdGL.FORGE_STRINGS_FIELD_FRAGMENT}
    ${0, $krdGL.FORGE_DATETIME_FIELD_FRAGMENT}
    ${0, $krdGL.FORGE_OBJECT_FIELD_FRAGMENT}
    ${0, $krdGL.TIME_TRACKING_FIELD_FRAGMENT}
    ${0, $krdGL.WORK_LOG_FIELD_FRAGMENT}
    ${0, $krdGL.JSM_MULTI_USER_PICKER_FIELD_FRAGMENT}
    ${0, $krdGL.JSM_PEOPLE_FIELD_FRAGMENT}
    ${0, $krdGL.PARENT_LINK_FIELD_FRAGMENT}
    ${0, $krdGL.PARENT_FIELD_FRAGMENT}
    ${0, $krdGL.PROFORMA_CONFIG_FRAGMENT}
    ${0, $krdGL.STATUS_FIELD_FRAGMENT}
    ${$fff9e34bcad2147f$var$isJsmRespondersFieldEnabled() ? (0, $krdGL.RESPONDERS_FIELD_FRAGMENT) : ''}
    ${0, $krdGL.WATCHERS_CONFIG_FRAGMENT}
    ${0, $krdGL.DATA_CLASSIFICATION_FIELD_FRAGMENT}
`;

});


parcelRegister("aPJiL", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c1adc7baa415743$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1fMqv = parcelRequire("1fMqv");

var $eDBhy = parcelRequire("eDBhy");

var $2ho4j = parcelRequire("2ho4j");

var $7jTnu = parcelRequire("7jTnu");

var $4CDQT = parcelRequire("4CDQT");

var $73QLY = parcelRequire("73QLY");

var $fAieL = parcelRequire("fAieL");

var $6wYxD = parcelRequire("6wYxD");
const $0c1adc7baa415743$var$useFetchSubtaskCreateConfigQuery = (props = {})=>{
    const { fireModalLoadTaskFailEvent: fireModalLoadTaskFailEvent, fireModalLoadTaskAbortEvent: fireModalLoadTaskAbortEvent } = (0, $fAieL.useModalLoadUiTaskEvents)();
    const { displayOnlyRequiredFields: displayOnlyRequiredFields = false, triggerPointKey: triggerPointKey } = props;
    const [loading, setLoading] = (0, $eJOHy.useState)(false);
    const [fetchError, setFetchError] = (0, $eJOHy.useState)(null);
    const apiStartTime = (0, $eJOHy.useRef)(0);
    const [apiLatency, setApiLatency] = (0, $eJOHy.useState)(0);
    const [data, setData] = (0, $eJOHy.useState)({
        fieldTabs: [],
        fieldConfig: {},
        contextFields: {},
        meta: {
            areRequiredFieldsSupported: true,
            queryErrorMessage: ''
        },
        additionalServices: {}
    });
    const { withMachineLearning: withMachineLearning } = (0, $73QLY.useSmartFieldsMachineLearning)();
    const [fetchSubtaskConfig] = (0, $1fMqv.useLazyQuery)((0, $6wYxD.getCreateSubtaskConfigUserPreferredQuery)(withMachineLearning), {
        fetchPolicy: 'no-cache',
        onCompleted: (queryData)=>{
            setApiLatency(Math.floor(performance.now() - apiStartTime.current));
            setData((0, $4CDQT.transformQueryResults)((0, $4CDQT.tranformSubtaskData)(queryData), displayOnlyRequiredFields));
            setLoading(false);
        },
        onError: (error)=>{
            setFetchError(error);
            const errorType = (0, $2ho4j.handleApolloError)(error);
            (0, $eDBhy.fireIssueCreateErrorAnalytics)({
                meta: {
                    id: 'useFetchSubtaskCreateConfigQuery',
                    packageName: 'jiraIssueCreate',
                    teamName: 'gryffindor'
                },
                error: error,
                attributes: {
                    errorType: // TODO: clean up after rollout of FG issue-create-fire-error-analytics-refactor
                    errorType,
                    triggerPointKey: // TODO: look to get this into common hook and populate it everywhere.
                    triggerPointKey
                },
                sendToPrivacyUnsafeSplunk: true
            });
            if (errorType === 'graphQLError' && (0, $7jTnu.fg)('global_issue_create_modal_view_task_fail_event')) fireModalLoadTaskFailEvent();
            else if ((0, $7jTnu.fg)('global_issue_create_modal_view_task_abort_event')) fireModalLoadTaskAbortEvent();
        }
    });
    const handleFetch = (0, $eJOHy.useRef)((queryVariables)=>{
        setLoading(true);
        apiStartTime.current = performance.now();
        fetchSubtaskConfig(queryVariables);
    });
    return [
        {
            isLoading: loading,
            fieldTabs: data.fieldTabs,
            fieldConfig: data.fieldConfig,
            contextFields: data.contextFields,
            meta: data.meta,
            error: fetchError,
            apiLatency: apiLatency,
            additionalServices: data.additionalServices
        },
        handleFetch.current
    ];
};
var $0c1adc7baa415743$export$2e2bcd8739ae039 = $0c1adc7baa415743$var$useFetchSubtaskCreateConfigQuery;

});
parcelRegister("6wYxD", function(module, exports) {

$parcel$export(module.exports, "getCreateSubtaskConfigUserPreferredQuery", () => $79c6343a8eb9ad39$export$466926765053d2bb);
// eslint-disable-next-line jira/restricted/graphql-tag

var $kuAvn = parcelRequire("kuAvn");

var $7jTnu = parcelRequire("7jTnu");

var $krdGL = parcelRequire("krdGL");
// eslint-disable-next-line jira/ff/inline-usage
const $79c6343a8eb9ad39$var$isJsmRespondersFieldEnabled = ()=>(0, $7jTnu.fg)('jsm-responders-field-in-gicx-ui');
const $79c6343a8eb9ad39$export$466926765053d2bb = (withML)=>(0, $kuAvn.default)`
    query JiraGlobalSubtaskIssueCreateModalLoad(
        $project: JiraProjectInput
        $issueType: JiraIssueTypeInput
        $requestType: JiraRequestTypeInput
        $parentId: JiraParentIdInput!
        $defaultValues: JiraIssueFieldsInput
    ) {
        ${withML ? 'jiraSubtaskCreationLayoutWithML' : 'jiraSubtaskCreationLayout'}(
            layoutFilter: USER_CONFIGURED_LAYOUT
            project: $project
            issueType: $issueType
            parentId: $parentId
        ) {
            ...LayoutFragment
        }
        jiraSubtaskCreationFields(
            fieldsFilter: USER_CONFIGURED_FIELDS
            project: $project
            issueType: $issueType
            parentId: $parentId
            requestType: $requestType
            defaultValues: $defaultValues
        ) {
            ... on JiraIssueCreateFields {
                fields {
                    nodes {
                        ...BaseFieldFragment
                        ...ProjectFieldFragmentWithoutClassification
                        ...IssueTypeFieldFragment
                        ...RequestTypeFieldFragment
                        ...TextFieldFragment
                        ...RichTextFieldFragment
                        ...ComponentsFieldFragment
                        ...VersionFieldFragment
                        ...MultiVersionFieldFragment
                        ...PriorityFieldFragment
                        ...SprintFieldFragment
                        ...LabelFieldFragment
                        ...SingleUserPickerFieldFragment
                        ...MultiUserPickerFieldFragment
                        ...PeopleFieldFragment
                        ...SecurityFieldFragment
                        ...IssueRestrictionFieldFragment
                        ...ColorFieldFragment
                        ...ResolutionFieldFragment
                        ...SingleSelectFieldFragment
                        ...MultiSelectFieldFragment
                        ...NumberFieldFragment
                        ...UrlFieldFragment
                        ...EpicLinkFieldFragment
                        ...DatePickerFieldFragment
                        ...DateTimePickerFieldFragment
                        ...CascadingSelectFieldFragment
                        ...AttachmentsFieldFragment
                        ...CheckboxFieldFragment
                        ${(0, $7jTnu.fg)('remove_issue_links_id_query_from_issue_create') ? '...IssueLinksFieldFragmentRefined' : '...IssueLinksFieldFragment'}
                        ...SingleGroupPickerFieldFragment
                        ...MultiGroupPickerFieldFragment
                        ...TeamFieldFragment
                        ...AtlassianTeamFieldFragment
                        ...RadioSelectFieldFragment
                        ...AffectedServicesFieldFragment
                        ...CMDBFieldFragment
                        ...OrganizationsFieldFragment
                        ...ConnectTextFieldFragment
                        ...ConnectNumberFieldFragment
                        ...ConnectSingleSelectFieldFragment
                        ...ConnectMultiSelectFieldFragment
                        ...ConnectRichTextFieldFragment
                        ...AssetFieldFragment
                        ...ForgeStringFieldFragment
                        ...ForgeNumberFieldFragment
                        ...ForgeSingleUserPickerFieldFragment
                        ...ForgeMultiUserPickerFieldFragment
                        ...ForgeGroupPickerFieldFragment
                        ...ForgeMultiGroupPickerFieldFragment
                        ...ForgeStringsFieldFragment
                        ...ForgeObjectFieldFragment
                        ...ForgeDateTimePickerFieldFragment
                        ...TimeTrackingFieldFragment
                        ...WorkLogFieldFragment
                        ...JsmMultiUserPickerFieldFragment
                        ...JsmPeopleFieldFragment
                        ...ParentLinkFieldFragment
                        ...ParentFieldFragment
                        ...StatusFieldFragment
                        ${$79c6343a8eb9ad39$var$isJsmRespondersFieldEnabled() ? '...JiraServiceManagementRespondersFieldFragment' : ''}
                    }
                }
                errors {
                    identifier
                    extensions {
                        ... on JiraIssueFieldUnsupportedErrorExtension {
                            fieldName
                            fieldType
                            isRequiredField
                        }
                        ... on JiraIssueFieldValueValidationErrorExtension {
                            errorType
                            message
                        }
                    }
                }
            }
            ... on QueryError {
                message
            }
        }
        jiraSubtaskCreationAdditionalServices(project: $project, issueType: $issueType, requestType: $requestType, parentId: $parentId) {
            ... on JiraIssueCreateAdditionalServices {
                services {
                    edges {
                        node {
                            ...WatchersConfigFragment
                        }
                    }
                }
            }
            ... on QueryError {
                message
            }
        }
    }
    ${withML ? (0, $krdGL.LAYOUT_FRAGMENT_WITH_ML) : (0, $krdGL.LAYOUT_FRAGMENT)}
    ${0, $krdGL.BASE_FIELD_FRAGMENT}
    ${0, $krdGL.PROJECT_FIELD_FRAGMENT_WITHOUT_CLASSIFICATION}
    ${0, $krdGL.ISSUE_TYPE_FIELD_FRAGMENT}
    ${0, $krdGL.REQUEST_TYPE_FIELD_FRAGMENT}
    ${0, $krdGL.TEXT_FIELD_FRAGMENT}
    ${0, $krdGL.RICH_TEXT_FIELD_FRAGMENT}
    ${0, $krdGL.COMPONENTS_FIELD_FRAGMENT}
    ${0, $krdGL.VERSION_FIELD_FRAGMENT}
    ${0, $krdGL.MULTI_VERSION_FIELD_FRAGMENT}
    ${0, $krdGL.PRIORITY_FIELD_FRAGMENT}
    ${0, $krdGL.SPRINT_FIELD_FRAGMENT}
    ${0, $krdGL.LABEL_FIELD_FRAGMENT}
    ${0, $krdGL.SINGLE_USER_PICKER_FIELD_FRAGMENT}
    ${0, $krdGL.MULTI_USER_PICKER_FIELD_FRAGMENT}
    ${0, $krdGL.SECURITY_FIELD_FRAGMENT}
    ${0, $krdGL.ISSUE_RESTRICTION_FIELD_FRAGMENT}
    ${0, $krdGL.COLOR_FIELD_FRAGMENT}
    ${0, $krdGL.RESOLUTION_FIELD_FRAGMENT}
    ${0, $krdGL.SINGLE_SELECT_FIELD_FRAGMENT}
    ${0, $krdGL.MULTI_SELECT_FIELD_FRAGMENT}
    ${0, $krdGL.NUMBER_FIELD_FRAGMENT}
    ${0, $krdGL.URL_FIELD_FRAGMENT}
    ${0, $krdGL.EPIC_LINK_FIELD_FRAGMENT}
    ${0, $krdGL.DATE_FIELD_FRAGMENT}
    ${0, $krdGL.DATE_TIME_FIELD_FRAGMENT}
    ${0, $krdGL.CASCADING_SELECT_FIELD_FRAGMENT}
    ${0, $krdGL.ATTACHMENTS_FIELD_FRAGMENT}
    ${0, $krdGL.CHECKBOX_FIELD_FRAGMENT}
    ${(0, $7jTnu.fg)('remove_issue_links_id_query_from_issue_create') ? (0, $krdGL.ISSUE_LINKS_FIELD_FRAGMENT_REFINED) : (0, $krdGL.ISSUE_LINKS_FIELD_FRAGMENT)}
    ${0, $krdGL.SINGLE_GROUP_PICKER_FIELD_FRAGMENT}
    ${0, $krdGL.MULTI_GROUP_PICKER_FIELD_FRAGMENT}
    ${0, $krdGL.PEOPLE_FIELD_FRAGMENT}
    ${0, $krdGL.TEAM_FIELD_FRAGMENT}
    ${0, $krdGL.ATLASSIAN_TEAM_FIELD_FRAGMENT}
    ${0, $krdGL.RADIO_SELECT_FIELD_FRAGMENT}
    ${0, $krdGL.AFFECTED_SERVICES_FIELD_FRAGMENT}
    ${0, $krdGL.CMDB_FIELD_FRAGMENT}
    ${0, $krdGL.ORGANIZATIONS_FIELD_FRAGMENT}
    ${0, $krdGL.CONNECT_TEXT_FIELD_FRAGMENT}
    ${0, $krdGL.CONNECT_NUMBER_FIELD_FRAGMENT}
    ${0, $krdGL.CONNECT_SINGLE_SELECT_FIELD_FRAGMENT}
    ${0, $krdGL.CONNECT_MULTI_SELECT_FIELD_FRAGMENT}
    ${0, $krdGL.CONNECT_RICH_TEXT_FIELD_FRAGMENT}
    ${0, $krdGL.ASSET_FIELD_FRAGMENT}
    ${0, $krdGL.FORGE_STRING_FIELD_FRAGMENT}
    ${0, $krdGL.FORGE_NUMBER_FIELD_FRAGMENT}
    ${0, $krdGL.FORGE_SINGLE_USER_PICKER_FIELD_FRAGMENT}
    ${0, $krdGL.FORGE_MULTI_USER_PICKER_FIELD_FRAGMENT}
    ${0, $krdGL.FORGE_GROUP_PICKER_FIELD_FRAGMENT}
    ${0, $krdGL.FORGE_MULTI_GROUP_PICKER_FIELD_FRAGMENT}
    ${0, $krdGL.FORGE_STRINGS_FIELD_FRAGMENT}
    ${0, $krdGL.FORGE_DATETIME_FIELD_FRAGMENT}
    ${0, $krdGL.FORGE_OBJECT_FIELD_FRAGMENT}
    ${0, $krdGL.TIME_TRACKING_FIELD_FRAGMENT}
    ${0, $krdGL.WORK_LOG_FIELD_FRAGMENT}
    ${0, $krdGL.JSM_MULTI_USER_PICKER_FIELD_FRAGMENT}
    ${0, $krdGL.JSM_PEOPLE_FIELD_FRAGMENT}
    ${0, $krdGL.PARENT_LINK_FIELD_FRAGMENT}
    ${0, $krdGL.PARENT_FIELD_FRAGMENT}
    ${0, $krdGL.STATUS_FIELD_FRAGMENT}
    ${$79c6343a8eb9ad39$var$isJsmRespondersFieldEnabled() ? (0, $krdGL.RESPONDERS_FIELD_FRAGMENT) : ''}
    ${0, $krdGL.WATCHERS_CONFIG_FRAGMENT}
`;

});


parcelRegister("e1yMd", function(module, exports) {

$parcel$export(module.exports, "usePrefillCustomFields", () => $88cd95b2a9309f5d$export$6437b2075d22652f);

var $eJOHy = parcelRequire("eJOHy");

var $8dH3d = parcelRequire("8dH3d");

var $jipjz = parcelRequire("jipjz");

var $11rjV = parcelRequire("11rjV");

var $40Rlp = parcelRequire("40Rlp");
const $88cd95b2a9309f5d$export$6437b2075d22652f = (modalFieldConfig)=>{
    const [{ prefilledCustomFields: prefilledCustomFields }] = (0, $jipjz.useTriggerIssueCreateModal)();
    const [data, setData] = (0, $eJOHy.useState)(modalFieldConfig);
    (0, $eJOHy.useEffect)(()=>{
        if (!prefilledCustomFields || Object.keys(prefilledCustomFields).length === 0 || (0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(modalFieldConfig)) {
            setData(modalFieldConfig);
            return;
        }
        const cascadingSelectFieldParentOptions = {};
        const cascadingSelectFieldChildOptions = {};
        const nextData = {
            ...modalFieldConfig
        };
        Object.keys(prefilledCustomFields).forEach((key)=>{
            if (key in modalFieldConfig) {
                const prefilledDefaultValue = (0, $40Rlp.prefillCustomFieldMap)({
                    gqlType: modalFieldConfig[key].gqlType,
                    defaultValue: prefilledCustomFields[key],
                    allowedValues: modalFieldConfig[key]?.allowedValues
                });
                if (!(prefilledDefaultValue === null || prefilledDefaultValue === undefined)) nextData[key] = {
                    ...nextData[key],
                    defaultValue: prefilledDefaultValue
                };
                if (modalFieldConfig[key].gqlType === 'JiraCascadingSelectField') cascadingSelectFieldParentOptions[key] = prefilledCustomFields[key];
            } else if (key.slice(-2) === ':1') {
                const fieldId = key.slice(0, -2);
                cascadingSelectFieldChildOptions[fieldId] = prefilledCustomFields[key];
            } else if (nextData?.worklog && (0, $40Rlp.workLogSubFieldTypes).includes(key)) {
                const objectReturned = (0, $40Rlp.getWorkLogFieldValues)(key, prefilledCustomFields[key]);
                if (objectReturned === Object(objectReturned)) {
                    if (nextData.worklog?.defaultValue) nextData.worklog.defaultValue = {
                        ...nextData.worklog.defaultValue,
                        ...objectReturned
                    };
                    else nextData.worklog.defaultValue = objectReturned;
                }
            }
        });
        Object.keys(cascadingSelectFieldParentOptions).forEach((key)=>{
            const parentOptionId = cascadingSelectFieldParentOptions[key];
            const childOptionId = cascadingSelectFieldChildOptions[key];
            const prefilledDefaultValue = (0, $11rjV.getCascadingSelectFieldValue)({
                parentOptionId: parentOptionId,
                childOptionId: childOptionId,
                allowedValues: modalFieldConfig[key]?.allowedValues
            });
            nextData[key] = {
                ...nextData[key],
                defaultValue: prefilledDefaultValue || modalFieldConfig[key].defaultValue
            };
        });
        setData(nextData);
    }, [
        modalFieldConfig,
        prefilledCustomFields
    ]);
    return data;
};

});
parcelRegister("11rjV", function(module, exports) {

$parcel$export(module.exports, "getCascadingSelectFieldValue", () => $ab84a2c07c678318$export$d59f0dcb07ca0790);
const $ab84a2c07c678318$var$getExpectedParentOption = (parentOptionId)=>{
    if (typeof parentOptionId === 'string') return parentOptionId;
    if (typeof parentOptionId === 'number') return parentOptionId.toString();
    if (Array.isArray(parentOptionId) && parentOptionId.length > 0) return parentOptionId[0].toString();
    return null;
};
const $ab84a2c07c678318$var$getExpectedParentAndChildOption = (parentOptionId, childOptionId)=>{
    const expectedParentOptionId = $ab84a2c07c678318$var$getExpectedParentOption(parentOptionId);
    if (!expectedParentOptionId) return null;
    if (typeof childOptionId === 'string') return {
        parentOptionId: expectedParentOptionId,
        childOptionId: childOptionId
    };
    if (typeof childOptionId === 'number') return {
        parentOptionId: expectedParentOptionId,
        childOptionId: childOptionId.toString()
    };
    if (Array.isArray(childOptionId) && childOptionId.length > 0) return {
        parentOptionId: expectedParentOptionId,
        childOptionId: childOptionId[0].toString()
    };
    return {
        parentOptionId: expectedParentOptionId,
        childOptionId: null
    };
};
const $ab84a2c07c678318$export$d59f0dcb07ca0790 = ({ parentOptionId: parentOptionId, childOptionId: childOptionId, allowedValues: allowedValues })=>{
    if (!Array.isArray(allowedValues)) return null;
    const expectedFieldValue = $ab84a2c07c678318$var$getExpectedParentAndChildOption(parentOptionId, childOptionId);
    if (!expectedFieldValue) return null;
    const defaultValue = {
        parentOptionValue: null,
        childOptionValue: null,
        __typename: 'JiraCascadingOption'
    };
    for (const parentValue of allowedValues)if (parentValue.parentOptionValue.id === expectedFieldValue.parentOptionId) {
        defaultValue.parentOptionValue = parentValue.parentOptionValue;
        for (const childValue of parentValue.childOptionValues)if (childValue.id === expectedFieldValue.childOptionId) {
            defaultValue.childOptionValue = childValue;
            return defaultValue;
        }
        return defaultValue;
    }
    return null;
};

});

parcelRegister("40Rlp", function(module, exports) {

$parcel$export(module.exports, "prefillCustomFieldMap", () => $05b5bebe792ae430$export$a0ff4688b4bd0aa);
$parcel$export(module.exports, "getWorkLogFieldValues", () => $05b5bebe792ae430$export$910fc0c56ee210a6);
$parcel$export(module.exports, "workLogSubFieldTypes", () => $05b5bebe792ae430$export$b94f52a1c0256fc7);

var $lQYS6 = parcelRequire("lQYS6");

var $idGNQ = parcelRequire("idGNQ");

var $eHMSr = parcelRequire("eHMSr");

var $dTG0V = parcelRequire("dTG0V");

var $ccBAA = parcelRequire("ccBAA");

var $9uL7a = parcelRequire("9uL7a");

var $jn1Jp = parcelRequire("jn1Jp");

var $2RiKL = parcelRequire("2RiKL");

var $1BONX = parcelRequire("1BONX");

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $05b5bebe792ae430$var$fieldMap = {
    JiraDateTimePickerField: (0, $lQYS6.getDateTimePickerFieldValue),
    JiraSingleVersionPickerField: (0, $2RiKL.getSingleVersionPickerValue),
    JiraRichTextField: (0, $9uL7a.getRichTextFieldValue),
    JiraConnectRichTextField: (0, $9uL7a.getRichTextFieldValue),
    JiraUrlField: (0, $1BONX.getStringFieldValue),
    JiraSingleLineTextField: (0, $1BONX.getStringFieldValue),
    JiraConnectTextField: (0, $1BONX.getStringFieldValue),
    JiraNumberField: (0, $ccBAA.getNumberFieldValue),
    JiraConnectNumberField: (0, $ccBAA.getNumberFieldValue),
    JiraSingleSelectField: (0, $jn1Jp.getSingleSelectFieldValue),
    JiraRadioSelectField: (0, $jn1Jp.getSingleSelectFieldValue),
    JiraConnectSingleSelectField: (0, $jn1Jp.getSingleSelectFieldValue),
    JiraCheckboxesField: (0, $eHMSr.getMultipleSelectFieldValue),
    JiraMultipleVersionPickerField: (0, $dTG0V.getMultipleVersionPickerFieldValue),
    JiraMultipleSelectField: (0, $eHMSr.getMultipleSelectFieldValue),
    JiraConnectMultipleSelectField: (0, $eHMSr.getMultipleSelectFieldValue),
    JiraLabelsField: (0, $idGNQ.getLabelsFieldValue),
    JiraDatePickerField: (0, $lQYS6.getDatePickerFieldValue),
    JiraTextAreaField: (0, $1BONX.getStringFieldValue),
    JiraForgeNumberField: (0, $ccBAA.getNumberFieldValue),
    JiraForgeDatetimeField: (0, $lQYS6.getDateTimePickerFieldValue),
    JiraForgeDateField: (0, $lQYS6.getDatePickerFieldValue),
    JiraForgeStringsField: (0, $idGNQ.getLabelsFieldValue),
    JiraForgeStringField: (0, $1BONX.getStringFieldValue),
    JiraForgeObjectField: (0, $1BONX.getForgeObjectFieldValue)
};
const $05b5bebe792ae430$export$a0ff4688b4bd0aa = ({ gqlType: gqlType, defaultValue: defaultValue, allowedValues: allowedValues })=>{
    if (typeof $05b5bebe792ae430$var$fieldMap[gqlType] !== 'function') return null;
    if (allowedValues) return $05b5bebe792ae430$var$fieldMap[gqlType]({
        defaultValue: defaultValue,
        allowedValues: allowedValues
    });
    return $05b5bebe792ae430$var$fieldMap[gqlType](defaultValue);
};
const $05b5bebe792ae430$export$910fc0c56ee210a6 = (key, input)=>{
    if (key === 'worklog_timeLogged') return {
        timeSpent: (0, $1BONX.getStringFieldValue)(input)
    };
    if (key === 'worklog_startDate') return {
        dateValue: (0, $lQYS6.getDateTimePickerFieldValue)(input)
    };
    if (key === 'worklog_comment') return {
        description: (0, $9uL7a.getRichTextFieldValue)(input)
    };
    if (key === 'timetracking_remainingestimate') return {
        timeRemaining: (0, $1BONX.getStringFieldValue)(input)
    };
};
const $05b5bebe792ae430$export$b94f52a1c0256fc7 = [
    'worklog_timeLogged',
    'worklog_startDate',
    'worklog_comment',
    'timetracking_remainingestimate'
];

});
parcelRegister("lQYS6", function(module, exports) {

$parcel$export(module.exports, "getDatePickerFieldValue", () => $02653404611f739b$export$ef420f815233cde0);
$parcel$export(module.exports, "getDateTimePickerFieldValue", () => $02653404611f739b$export$ec8ca4015b404669);

var $h0T48 = parcelRequire("h0T48");
const $02653404611f739b$export$ef420f815233cde0 = (defaultValue)=>{
    if (Array.isArray(defaultValue) && defaultValue.length > 0 && typeof defaultValue[0] === 'string') {
        if ((0, $h0T48.findADate)(defaultValue[0])) return (0, $h0T48.findADate)(defaultValue[0])?.slice(0, 10);
    }
    if ((0, $h0T48.findADate)(defaultValue)) return (0, $h0T48.findADate)(defaultValue)?.slice(0, 10);
    return null;
};
const $02653404611f739b$export$ec8ca4015b404669 = (defaultValue)=>{
    if (Array.isArray(defaultValue) && defaultValue.length > 0 && typeof defaultValue[0] === 'string') {
        if ((0, $h0T48.findADate)(defaultValue[0])) return (0, $h0T48.findADate)(defaultValue[0]);
    }
    return (0, $h0T48.findADate)(defaultValue);
};

});
parcelRegister("h0T48", function(module, exports) {

$parcel$export(module.exports, "findADate", () => $902aa8b3a8fdd4e7$export$3ce9cccf56f196eb);
const $902aa8b3a8fdd4e7$var$monthMap = {
    Jan: '01',
    January: '01',
    Feb: '02',
    February: '02',
    Mar: '03',
    March: '03',
    Apr: '04',
    April: '04',
    May: '05',
    Jun: '06',
    June: '06',
    Jul: '07',
    July: '07',
    Aug: '08',
    August: '08',
    Sep: '09',
    September: '09',
    Oct: '10',
    October: '10',
    Nov: '11',
    November: '11',
    Dec: '12',
    December: '12'
};
const $902aa8b3a8fdd4e7$var$formatDay = (day)=>{
    if (day.length === 1) return `0${day}`;
    return day;
};
const $902aa8b3a8fdd4e7$var$formatMonth = (month)=>{
    if ($902aa8b3a8fdd4e7$var$monthMap[month]) return $902aa8b3a8fdd4e7$var$monthMap[month];
    if (month.length === 1) return `0${month}`;
    return month;
};
const $902aa8b3a8fdd4e7$var$formatYear = (year)=>{
    const yearAsNumber = Number(year);
    if (yearAsNumber < 100) return yearAsNumber + 2000;
    return yearAsNumber;
};
const $902aa8b3a8fdd4e7$var$constructISOTime = (time)=>{
    const timeStr = time.trim();
    const time24HourPattern = /^T(\d{1,2}):(\d{2}):?(\d{2})?$/;
    const time12HourPattern = /^@?\s*(\d{1,2}):(\d{2})\s*(am|pm)?$/i;
    const match24Hour = timeStr.match(time24HourPattern);
    if (match24Hour) {
        // eslint-disable-next-line prefer-const
        let [, hours, minutes, seconds] = match24Hour;
        seconds = seconds || '00';
        return `${hours.padStart(2, '0')}:${minutes.padStart(2, '0')}:${seconds.padStart(2, '0')}`;
    }
    const match12Hour = timeStr.match(time12HourPattern);
    if (match12Hour) {
        let hours;
        let minutes;
        let ampm;
        [, hours, minutes, ampm] = match12Hour;
        hours = parseInt(hours, 10);
        minutes = parseInt(minutes, 10);
        if (ampm) {
            ampm = ampm.toLowerCase();
            if (ampm === 'pm' && hours !== 12) hours += 12;
            else if (ampm === 'am' && hours === 12) hours = 0;
        }
        return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:00`;
    }
    return '00:00:00';
};
const $902aa8b3a8fdd4e7$var$constructISODateTime = (date)=>{
    const regexForDay = /^(\d{1,2})[/\s-]([A-Za-z]+|\d{1,2})[/\s-](\d{2,4})(.*)/;
    const regexForDateWithYYYYFirst = /^(\d{2,4})[/\s-]([A-Za-z]+|\d{1,2})[/\s-](\d{1,2})(.*)/;
    const matchForDay = date.match(regexForDay);
    const matchForDayWithYYYYFirst = date.match(regexForDateWithYYYYFirst);
    if (matchForDay) {
        const [, day, month, year, time] = matchForDay;
        let formattedDay = $902aa8b3a8fdd4e7$var$formatDay(day);
        let formattedMonth = $902aa8b3a8fdd4e7$var$formatMonth(month);
        const formattedYear = $902aa8b3a8fdd4e7$var$formatYear(year);
        let skipMatchingDay = false;
        if (Number(day) < 13 && Number(month)) [formattedDay, formattedMonth] = [
            formattedMonth,
            formattedDay
        ];
        else if (Number(formattedMonth) > 12) {
            if (Number(formattedDay) < 13) [formattedDay, formattedMonth] = [
                formattedMonth,
                formattedDay
            ];
            else skipMatchingDay = true;
        }
        if (!skipMatchingDay) {
            const isoTime = $902aa8b3a8fdd4e7$var$constructISOTime(time);
            return `${formattedYear}-${formattedMonth}-${formattedDay}T${isoTime}`;
        }
    }
    if (matchForDayWithYYYYFirst) {
        const [, year, month, day, time] = matchForDayWithYYYYFirst;
        let formattedDay = $902aa8b3a8fdd4e7$var$formatDay(day);
        let formattedMonth = $902aa8b3a8fdd4e7$var$formatMonth(month);
        const formattedYear = $902aa8b3a8fdd4e7$var$formatYear(year);
        if (Number(formattedMonth) > 12) {
            if (Number(formattedDay) < 13) [formattedDay, formattedMonth] = [
                formattedMonth,
                formattedDay
            ];
            else return null;
        }
        const isoTime = $902aa8b3a8fdd4e7$var$constructISOTime(time);
        return `${formattedYear}-${formattedMonth}-${formattedDay}T${isoTime}`;
    }
    return null;
};
function $902aa8b3a8fdd4e7$var$convertUnixToISO(unixTimestamp) {
    const date = new Date(unixTimestamp * 1000);
    if (!date.getTime()) return null;
    return date.toISOString().slice(0, 19);
}
const $902aa8b3a8fdd4e7$export$3ce9cccf56f196eb = (defaultValue)=>{
    if (typeof defaultValue === 'number') return $902aa8b3a8fdd4e7$var$convertUnixToISO(defaultValue);
    if (typeof defaultValue === 'string') {
        if (Number(defaultValue)) return $902aa8b3a8fdd4e7$var$convertUnixToISO(Number(defaultValue));
        return $902aa8b3a8fdd4e7$var$constructISODateTime(defaultValue);
    }
    return null;
};

});


parcelRegister("idGNQ", function(module, exports) {

$parcel$export(module.exports, "getLabelsFieldValue", () => $04598dce10535da0$export$dc7bb12ca069dc65);

var $8dH3d = parcelRequire("8dH3d");
const $04598dce10535da0$export$dc7bb12ca069dc65 = (defaultValue)=>{
    if (typeof defaultValue === 'string' || typeof defaultValue === 'number') return [
        {
            id: null,
            name: defaultValue.toString()
        }
    ];
    const constructedLabels = [];
    if (Array.isArray(defaultValue)) {
        for (const value of defaultValue)if (typeof value === 'string' || typeof value === 'number') constructedLabels.push({
            name: value.toString(),
            id: null
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(constructedLabels) ? null : constructedLabels;
    }
    return null;
};

});

parcelRegister("eHMSr", function(module, exports) {

$parcel$export(module.exports, "getMultipleSelectFieldValue", () => $abf77d0ab94d478d$export$e9f00fd2d2b5131c);

var $8dH3d = parcelRequire("8dH3d");
const $abf77d0ab94d478d$var$constructValuesArray = ({ defaultValue: defaultValue, allowedValues: allowedValues })=>{
    const values = [];
    for (const defaultValues of defaultValue){
        for (const isValue of allowedValues)if (isValue.id === defaultValues?.toString()) values.push({
            value: isValue.value,
            id: isValue.id
        });
    }
    return values;
};
const $abf77d0ab94d478d$export$e9f00fd2d2b5131c = ({ defaultValue: defaultValue, allowedValues: allowedValues })=>{
    let values = [];
    if (Array.isArray(allowedValues)) {
        if (Array.isArray(defaultValue)) values = $abf77d0ab94d478d$var$constructValuesArray({
            defaultValue: defaultValue,
            allowedValues: allowedValues
        });
        if (typeof defaultValue === 'string' || typeof defaultValue === 'number') values = $abf77d0ab94d478d$var$constructValuesArray({
            defaultValue: [
                defaultValue
            ],
            allowedValues: allowedValues
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(values) ? null : values;
    }
    return null;
};

});

parcelRegister("dTG0V", function(module, exports) {

$parcel$export(module.exports, "getMultipleVersionPickerFieldValue", () => $b085d5603d113eca$export$949962cffa318724);

var $8dH3d = parcelRequire("8dH3d");
const $b085d5603d113eca$var$constructValuesArray = ({ defaultValue: defaultValue, allowedValues: allowedValues })=>{
    const values = [];
    for (const defaultValues of defaultValue){
        for (const isValue of allowedValues)if (isValue.id === defaultValues.toString()) values.push({
            name: isValue.name,
            id: isValue.id,
            status: isValue.status
        });
    }
    return values;
};
const $b085d5603d113eca$export$949962cffa318724 = ({ defaultValue: defaultValue, allowedValues: allowedValues })=>{
    let values = [];
    if (Array.isArray(allowedValues)) {
        if (Array.isArray(defaultValue)) values = $b085d5603d113eca$var$constructValuesArray({
            defaultValue: defaultValue,
            allowedValues: allowedValues
        });
        if (typeof defaultValue === 'string' || typeof defaultValue === 'number') values = $b085d5603d113eca$var$constructValuesArray({
            defaultValue: [
                defaultValue
            ],
            allowedValues: allowedValues
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(values) ? null : values;
    }
    return null;
};

});

parcelRegister("ccBAA", function(module, exports) {

$parcel$export(module.exports, "getNumberFieldValue", () => $e2bb2029e7d22a58$export$f01b59e00fd68f64);
const $e2bb2029e7d22a58$export$f01b59e00fd68f64 = (value)=>{
    if (Array.isArray(value) && value.length >= 1) return Number(value[0]);
    if (typeof value === 'number' || typeof value === 'string') return Number(value);
    return null;
};

});

parcelRegister("9uL7a", function(module, exports) {

$parcel$export(module.exports, "getRichTextFieldValue", () => $6027e0b419848613$export$24f9d0bf92885ed9);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $8DB98 = parcelRequire("8DB98");

var $lovmf = parcelRequire("lovmf");

var $dmYzn = parcelRequire("dmYzn");
const $6027e0b419848613$export$c442cd75d72477d0 = (wiki)=>{
    if (wiki === undefined) return {
        version: 1,
        type: 'doc',
        content: []
    };
    const adfTransformer = new (0, $lovmf.JSONTransformer)();
    const wikiMarkupTransformer = new (0, $dmYzn.WikiMarkupTransformer)((0, $8DB98.defaultSchema));
    const pmNode = wikiMarkupTransformer.parse(wiki);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return adfTransformer.encode(pmNode);
};
const $6027e0b419848613$export$9acea0de85f3957 = (field)=>{
    return field && field.type === 'doc' && Array.isArray(field.content);
};
const $6027e0b419848613$export$24f9d0bf92885ed9 = (defaultValue)=>{
    if (Array.isArray(defaultValue) && defaultValue.length > 0) {
        if (typeof defaultValue[0] === 'string' || typeof defaultValue[0] === 'number') return $6027e0b419848613$export$c442cd75d72477d0(defaultValue[0].toString());
        if ($6027e0b419848613$export$9acea0de85f3957(defaultValue[0])) return defaultValue[0];
    }
    if (typeof defaultValue === 'string' || typeof defaultValue === 'number') // for connect we expect a simple string to be passed
    return $6027e0b419848613$export$c442cd75d72477d0(defaultValue.toString());
    if ($6027e0b419848613$export$9acea0de85f3957(defaultValue)) return defaultValue;
    return null;
};

});

parcelRegister("jn1Jp", function(module, exports) {

$parcel$export(module.exports, "getSingleSelectFieldValue", () => $3217361ed1b80d40$export$6847a775f22c9956);
const $3217361ed1b80d40$var$findValueInAllowedValues = (value, allowedValues)=>{
    if (!Array.isArray(allowedValues)) return null;
    for (const isValue of allowedValues){
        if (isValue.id === value.toString()) return {
            value: isValue.value,
            id: isValue.id
        };
    }
    return null;
};
const $3217361ed1b80d40$export$6847a775f22c9956 = ({ defaultValue: defaultValue, allowedValues: allowedValues })=>{
    if (Array.isArray(defaultValue) && defaultValue.length > 0) {
        if (typeof defaultValue[0] === 'string' || typeof defaultValue[0] === 'number') return $3217361ed1b80d40$var$findValueInAllowedValues(defaultValue[0], allowedValues);
    }
    if (typeof defaultValue === 'string' || typeof defaultValue === 'number') return $3217361ed1b80d40$var$findValueInAllowedValues(defaultValue, allowedValues);
    return null;
};

});

parcelRegister("2RiKL", function(module, exports) {

$parcel$export(module.exports, "getSingleVersionPickerValue", () => $1aebe08b6d6a18b3$export$829c840f2c90595c);
const $1aebe08b6d6a18b3$var$getExpectedFieldValue = (defaultValue)=>{
    if (typeof defaultValue === 'string') return defaultValue;
    if (typeof defaultValue === 'number') return defaultValue.toString();
    if (Array.isArray(defaultValue) && defaultValue.length > 0) return defaultValue[0].toString();
    return null;
};
const $1aebe08b6d6a18b3$export$829c840f2c90595c = ({ defaultValue: defaultValue, allowedValues: allowedValues })=>{
    if (!Array.isArray(allowedValues)) return null;
    const expectedFieldValue = $1aebe08b6d6a18b3$var$getExpectedFieldValue(defaultValue);
    if (!expectedFieldValue) return null;
    for (const value of allowedValues){
        if (expectedFieldValue === value.id) return {
            id: value.id,
            status: value.status,
            name: value.name
        };
    }
    return null;
};

});

parcelRegister("1BONX", function(module, exports) {

$parcel$export(module.exports, "getStringFieldValue", () => $3a9f57bdd5442a5f$export$62ea57a19c685649);
$parcel$export(module.exports, "getForgeObjectFieldValue", () => $3a9f57bdd5442a5f$export$aef33e0e296607e6);
const $3a9f57bdd5442a5f$export$62ea57a19c685649 = (value)=>{
    if (typeof value === 'string') return value;
    if (typeof value === 'number') return value.toString();
    if (Array.isArray(value)) return value[0].toString();
    return null;
};
const $3a9f57bdd5442a5f$export$aef33e0e296607e6 = (value)=>{
    return JSON.stringify(value);
};

});




parcelRegister("lHs35", function(module, exports) {

$parcel$export(module.exports, "createIssueDismissModalEntryPoint", () => $dbcc4e525ac78a0b$export$b59b81279190875a);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $dbcc4e525ac78a0b$export$b59b81279190875a = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("eScrP")), {
        moduleId: "f800056e",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("eScrP", function(module, exports) {

let $ad3fc3b92ec1abd8$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $ad3fc3b92ec1abd8$var$load("6oEbr").then(()=>parcelRequire('dztrC'));

});


parcelRegister("9H0bo", function(module, exports) {

$parcel$export(module.exports, "default", () => $398a33d1c166d1ff$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $8dH3d = parcelRequire("8dH3d");

var $cSmYj = parcelRequire("cSmYj");

var $a7rgl = parcelRequire("a7rgl");

var $3L3Os = parcelRequire("3L3Os");
var $lP4Q7 = parcelRequire("lP4Q7");

var $8nu6j = parcelRequire("8nu6j");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $8CBYv = parcelRequire("8CBYv");

var $c1cLY = parcelRequire("c1cLY");

var $axgz1 = parcelRequire("axgz1");

var $ln6Iy = parcelRequire("ln6Iy");

var $2fNLP = parcelRequire("2fNLP");

var $li3DD = parcelRequire("li3DD");

var $epTsa = parcelRequire("epTsa");

var $7jTnu = parcelRequire("7jTnu");

var $1uIew = parcelRequire("1uIew");

var $bILK0 = parcelRequire("bILK0");

var $21Y41 = parcelRequire("21Y41");


var $6hw9S = parcelRequire("6hw9S");

var $gPU3b = parcelRequire("gPU3b");

var $lRq8t = parcelRequire("lRq8t");

var $21XCU = parcelRequire("21XCU");
var $1F8hV = parcelRequire("1F8hV");


var $3UrQk = parcelRequire("3UrQk");

var $fE4zR = parcelRequire("fE4zR");

var $4rsU2 = parcelRequire("4rsU2");

var $5vmYB = parcelRequire("5vmYB");

var $2lqpf = parcelRequire("2lqpf");

var $xMjNG = parcelRequire("xMjNG");

var $4PKlm = parcelRequire("4PKlm");

var $jQUoP = parcelRequire("jQUoP");

var $17nxE = parcelRequire("17nxE");

var $BAHbx = parcelRequire("BAHbx");

var $joycu = parcelRequire("joycu");

var $2ghht = parcelRequire("2ghht");

var $84DOT = parcelRequire("84DOT");

var $bitlK = parcelRequire("bitlK");

var $jipjz = parcelRequire("jipjz");

var $8ivLn = parcelRequire("8ivLn");

var $3MbOI = parcelRequire("3MbOI");

var $4xbv3 = parcelRequire("4xbv3");
var $gCeeo = parcelRequire("gCeeo");
var $iqtgH = parcelRequire("iqtgH");
var $8Plmb = parcelRequire("8Plmb");
var $ftN6c = parcelRequire("ftN6c");

var $bRJAs = parcelRequire("bRJAs");

var $a9ldn = parcelRequire("a9ldn");

var $RxDRv = parcelRequire("RxDRv");

var $8vyDv = parcelRequire("8vyDv");

var $6XJko = parcelRequire("6XJko");


var $6u3jg = parcelRequire("6u3jg");

var $j7mDN = parcelRequire("j7mDN");

var $dOYAq = parcelRequire("dOYAq");

var $esAgg = parcelRequire("esAgg");

var $2VetA = parcelRequire("2VetA");

var $fAieL = parcelRequire("fAieL");

var $1AeYS = parcelRequire("1AeYS");

var $fB3KX = parcelRequire("fB3KX");

var $aQ4h7 = parcelRequire("aQ4h7");

var $9uhQ0 = parcelRequire("9uhQ0");

var $jap6l = parcelRequire("jap6l");

var $l57PA = parcelRequire("l57PA");

var $jWBLD = parcelRequire("jWBLD");

var $dsfSm = parcelRequire("dsfSm");

var $dPjg7 = parcelRequire("dPjg7");

var $gG5II = parcelRequire("gG5II");

var $60nLj = parcelRequire("60nLj");

var $5IMhp = parcelRequire("5IMhp");

var $bbvEo = parcelRequire("bbvEo");
function $398a33d1c166d1ff$var$isChildIssueTriggerPoint(key) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    return (0, $84DOT.LIST_OF_CHILD_ISSUES_TRIGGER_POINTS).includes(key);
}
const $398a33d1c166d1ff$var$RequiredFieldsSummary = ({ isMini: isMini = false, showOnlyRequiredFieldsLabel: showOnlyRequiredFieldsLabel = false })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const requiredFieldsLabel = showOnlyRequiredFieldsLabel ? formatMessage((0, $9uhQ0.default).showOnlyrequiredFieldsSummary, {
        requiredAsterisk: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lP4Q7.default), null)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, formatMessage((0, $9uhQ0.default).requiredFieldsSummary), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lP4Q7.default), null));
    return !isMini && (0, $6XJko.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        as: "span",
        size: "medium",
        color: "color.text.subtlest",
        "aria-hidden": "true"
    }, requiredFieldsLabel) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($398a33d1c166d1ff$var$RequiredMessage, {
        "aria-hidden": "true",
        isMini: !!isMini,
        noMargin: showOnlyRequiredFieldsLabel
    }, requiredFieldsLabel);
};
const $398a33d1c166d1ff$var$CreateFormBase = (props)=>{
    const [{ sectionMessage: sectionMessage, payload: triggerIssueCreatePayload, alertsToBeLinked: alertsToBeLinked, isSubTaskCreationOpen: isSubTaskCreationOpen, disableProjectDropdown: disableProjectDropdown, disableIssueTypeDropdown: disableIssueTypeDropdown, displayHeaderActionContainer: displayHeaderActionContainer, displaySitePicker: displaySitePicker, context: context, triggerPointKey: triggerPointKey, isCreateLinkedIssue: isCreateLinkedIssue, isModalLoadInContext: isModalLoadInContext, wasStateRestored: wasStateRestored, minimizableModalView: minimizableModalView, submitErrorMessage: presetSubmitErrorMessage, overrideUseRequestTypeFieldsToggleState: overrideUseRequestTypeFieldsToggleState, isMiniDesignEnabled: isMiniDesignEnabled, sessionId: sessionId, ExternalControls: ExternalControls, optOutSmartFieldIds: optOutSmartFieldIds }, { clearSectionMessage: clearSectionMessage, removeAlertFromAlertsToBeLinked: removeAlertFromAlertsToBeLinked }] = (0, $jipjz.useTriggerIssueCreateModal)();
    const { onIssueCreateSuccess: onIssueCreateSuccess, canCreateAnotherIssue: canCreateAnotherIssue = false, isLoading: isLoading, fieldConfig: fieldConfig, fieldTabs: fieldTabs, contextFields: contextFields, filteredOutModules: filteredOutModules, meta: meta, error: error, apiLatency: apiLatency, onFetchConfig: fetchConfig, dirtyFieldsCurrentSession: dirtyFieldsCurrentSession, getFormState: getFormState, onFormFieldsReset: onFormFieldsReset, statusFieldProps: statusFieldProps, classificationFieldProps: classificationFieldProps, proformaConfiguration: proformaConfiguration, watchersConfigurations: watchersConfigurations, onResetApolloCache: onResetApolloCache, onStatusCreatedOrUpdated: onStatusCreatedOrUpdated, onSiteSelection: onSiteSelection, onProjectSelection: onProjectSelection } = props;
    const isEmbedded = (0, $8ivLn.useIsEmbedded)();
    const isMini = minimizableModalView === 'mini' || isMiniDesignEnabled;
    const isGICPositioningEnabled = (0, $6u3jg.useIsGICPositioningEnabled)(); // TODO Add this field with the fields on previous line when cleaning FF
    const fieldPropsExtensions = isGICPositioningEnabled() ? props.fieldPropsExtensions : undefined;
    const { data: { user: currentUser } } = (0, $3MbOI.useCurrentUser)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { showFlag: showFlag } = (0, $bILK0.useFlagsService)();
    const { publish: publish } = (0, $4PKlm.useGICLifeCycleEvents)();
    const { interactedFields: interactedFields } = (0, $j7mDN.useInteractedFields)();
    const appEditions = (0, $8vyDv.useAppEditions)();
    const [{ watchers: watchers, ecosystem: { forge: { hasFinishedLoading: hasFinishedLoading } }, isSmartFieldsToggled: isSmartFieldsToggled }, { setIsForgeFieldsDetected: setIsForgeFieldsDetected, resetExpandedCollapsedArea: resetExpandedCollapsedArea, setIsSmartFieldsToggled: setIsSmartFieldsToggled }] = (0, $jQUoP.useFormContext)();
    const uiModificationsStatus = (0, $1F8hV.useUiModificationsEnabledStatus)(hasFinishedLoading);
    const [{ selectedProject: selectedProject, selectedIssueType: selectedIssueType, meta: formMeta, areConfiguredFieldsModified: areConfiguredFieldsModified }, { setSelectedProject: setSelectedProject, setSelectedIssueType: setSelectedIssueType, setRequestBackedIssueType: setRequestBackedIssueType, setIsEpicLinkSelected: setIsEpicLinkSelected, setSubmitting: setSubmitting, setMeta: setMeta, setSubmitErrorMessage: setSubmitErrorMessage, setSubmitFieldwiseErrors: setSubmitFieldwiseErrors, setDataFetchError: setDataFetchError, setInlineErrorMessage: setInlineErrorMessage, setIsFormDirty: setIsFormDirty, setAreConfiguredFieldsModified: setAreConfiguredFieldsModified, setCurrentActiveTabIndex: setCurrentActiveTabIndex, setResetFormAction: setResetFormAction, setShouldAutoFocus: setShouldAutoFocus }] = (0, $jQUoP.useCreateFormState)();
    const [{ selectedCloudId: selectedCloudId }] = (0, $bitlK.useSitePickerContext)();
    const [createIssue] = (0, $esAgg.default)(selectedCloudId);
    const [fields, { dispatchFormSubmits: dispatchFormSubmits, resetState: resetState }] = (0, $6hw9S.useInlineFields)(); // This useRef needs to be first in order for shouldUseRequestTypeDefault tests to work
    const shouldUseRequestTypeDefault = (0, $eJOHy.useRef)(true);
    const retainedFieldsData = (0, $eJOHy.useRef)([]);
    const [forgeFieldBlockStatus, setForgeFieldBlockStatus] = (0, $eJOHy.useState)((0, $dfc00c8d0d7fbcf9$export$f86e250f1a7b07c8));
    const { formatMessage: formatMessage, formatList: formatList } = (0, $lRq8t.default)();
    const [hasCreatedAnotherIssue, setHasCreatedAnotherIssue] = (0, $eJOHy.useState)(false);
    const { initialClassification: initialClassification } = classificationFieldProps || {};
    const [selectedClassification, setSelectedClassification, onClassificationOptionChange] = (0, $2lqpf.useClassificationState)(initialClassification);
    const createFormScrollRef = (0, $eJOHy.useCallback)((node)=>{
        if (!node) return;
        if (formMeta?.submitErrorMessage || hasCreatedAnotherIssue) (0, $a7rgl.default)(node, (0, $3UrQk.DEFAULT_SCROLL_OPTIONS));
    }, [
        formMeta?.submitErrorMessage,
        hasCreatedAnotherIssue
    ]);
    const resetSummary = (0, $eJOHy.useRef)(null);
    const formRef = (0, $eJOHy.useRef)();
    const previousForgeFieldsState = (0, $eJOHy.useRef)(null);
    const isRestoring = (0, $eJOHy.useRef)(wasStateRestored);
    const [selectedTransition, setSelectedTransition] = (0, $eJOHy.useState)(null);
    const [showOnlyRequiredFields, setShowOnlyRequiredFields] = (0, $eJOHy.useState)((0, $bbvEo.getShowOnlyRequiredFieldsDefaultValue)()); // Ref to store field values when toggle is switched on
    const preservedFieldValues = (0, $eJOHy.useRef)({});
    const { fireModalLoadTaskSuccessEvent: fireModalLoadTaskSuccessEvent } = (0, $fAieL.useModalLoadUiTaskEvents)(); // Clear preserved field values when project or issue type changes
    (0, $eJOHy.useEffect)(()=>{
        preservedFieldValues.current = {};
    }, [
        selectedProject?.value,
        selectedIssueType?.value
    ]);
    const onChangeSelectedTransition = (t)=>{
        const analyticsEvent = createAnalyticsEvent({});
        setSelectedTransition(t);
        (0, $gCeeo.fireTrackAnalyticsDeferred)(analyticsEvent, 'statusInGic changed');
        publish((0, $xMjNG.GIC_LIFECYCLE_EVENTS).STATUS_FIELD_STATE_CHANGE, {
            selectedTransition: t
        });
    };
    const formSetFieldValue = (0, $eJOHy.useRef)();
    const { showEnforcementIfStorageIsFull: showEnforcementIfStorageIsFull } = (0, $RxDRv.useStorageEnforcement)();
    const isShowOnlyRequiredFieldsExperimentEnabled = (0, $bbvEo.useShowOnlyRequiredFieldsExperiment)();
    const shouldShowStatus = (0, $eJOHy.useMemo)(()=>{
        const baseShouldShow = (0, $bbvEo.shouldShowStatusField)(selectedProject?.projectType, fieldConfig); // If the experiment is enabled and toggle is on, check if status field is required
        if (isShowOnlyRequiredFieldsExperimentEnabled && showOnlyRequiredFields) {
            const statusFieldConfig = fieldConfig?.status; // Hide status field if it's not required when toggle is on
            return baseShouldShow && statusFieldConfig?.isRequired === true;
        }
        return baseShouldShow;
    }, [
        selectedProject,
        fieldConfig,
        isShowOnlyRequiredFieldsExperimentEnabled,
        showOnlyRequiredFields
    ]);
    const shouldShowLinkedAlerts = (0, $eJOHy.useMemo)(()=>(0, $bbvEo.shouldShowLinkedAlertsField)(selectedProject?.projectType, selectedIssueType, alertsToBeLinked), [
        selectedProject?.projectType,
        selectedIssueType,
        alertsToBeLinked
    ]); // NOTE: JPD has no ability to manage watchers at the time of release, this is a workaround to prevent watchers being added for JPD.
    const shouldShowWatchers = selectedProject?.projectType !== (0, $ln6Iy.PRODUCT_DISCOVERY_PROJECT);
    const isCurrentUserAdminOfProject = (0, $bbvEo.useIsCurrentUserAdminOfProject)({
        projectKey: selectedProject?.projectKey
    }) ?? false;
    const canConfigureIssueTypes = (0, $joycu.canConfigureIssueTypeForProject)({
        project: selectedProject,
        isProjectAdmin: isCurrentUserAdminOfProject
    });
    const canConfigureStatuses = (0, $2ghht.canConfigureStatusForProject)({
        project: selectedProject,
        isProjectAdmin: isCurrentUserAdminOfProject
    });
    const reloadForm = (0, $eJOHy.useCallback)((project, issueType, includeIssueTypesAndRequestTypes)=>{
        const userInputForRetentionParams = {
            formState: getFormState.current(),
            fieldConfig: fieldConfig,
            dirtyFieldsCurrentSession: dirtyFieldsCurrentSession,
            retainedFieldsData: retainedFieldsData,
            initialDefaultValues: triggerIssueCreatePayload?.defaultValues,
            selectedClassification: selectedClassification
        };
        const issueCreateTypeFilter = ()=>{
            const { issuelinks: issuelinks } = getFormState.current()?.values || {};
            return isModalLoadInContext && isCreateLinkedIssue && (0, $7jTnu.fg)('create_linked_issues_trigger_point_issue_view') ? {
                issueCreateType: isCreateLinkedIssue ? (0, $3UrQk.ISSUE_CREATE_TYPE).linkedIssue : (0, $3UrQk.ISSUE_CREATE_TYPE).standard,
                additionalContext: {
                    linkedIssue: {
                        sourceIssueId: triggerIssueCreatePayload?.additionalContext?.linkedIssue?.sourceIssueId || '',
                        includeLinks: issuelinks?.includeLinks,
                        includeAttachments: issuelinks?.includeAttachments
                    }
                }
            } : {};
        };
        fetchConfig({
            variables: {
                ...(0, $bbvEo.getQueryVariables)(project, issueType, (0, $bbvEo.getUserInputForRetention)(userInputForRetentionParams)),
                ...includeIssueTypesAndRequestTypes ? {
                    issueTypes: triggerIssueCreatePayload?.issueTypes,
                    requestTypes: triggerIssueCreatePayload?.requestTypes
                } : {},
                ...isModalLoadInContext && {
                    additionalContext: triggerIssueCreatePayload?.additionalContext
                },
                parentId: triggerIssueCreatePayload?.parentId,
                ...issueCreateTypeFilter()
            }
        });
    }, [
        getFormState,
        fieldConfig,
        dirtyFieldsCurrentSession,
        fetchConfig,
        triggerIssueCreatePayload?.issueTypes,
        triggerIssueCreatePayload?.requestTypes,
        triggerIssueCreatePayload?.additionalContext,
        triggerIssueCreatePayload?.parentId,
        triggerIssueCreatePayload?.defaultValues,
        isModalLoadInContext,
        isCreateLinkedIssue,
        selectedClassification
    ]);
    const onProjectChange = (0, $eJOHy.useCallback)((project)=>{
        setSubmitErrorMessage('');
        setSubmitFieldwiseErrors({});
        setSelectedProject(project);
        setSelectedIssueType(null);
        setSelectedTransition(null);
        setRequestBackedIssueType(null);
        setInlineErrorMessage(null);
        setShouldAutoFocus(false);
        resetExpandedCollapsedArea(); // when issue-type and request-type is null always honor request type
        shouldUseRequestTypeDefault.current = true;
        const userInputForRetentionParams = {
            formState: getFormState.current(),
            fieldConfig: fieldConfig,
            dirtyFieldsCurrentSession: dirtyFieldsCurrentSession,
            retainedFieldsData: retainedFieldsData,
            initialDefaultValues: triggerIssueCreatePayload?.defaultValues,
            selectedClassification: selectedClassification
        };
        const issueCreateTypeFilter = ()=>{
            const { issuelinks: issuelinks } = getFormState.current()?.values || {};
            return isModalLoadInContext && isCreateLinkedIssue && (0, $7jTnu.fg)('create_linked_issues_trigger_point_issue_view') ? {
                issueCreateType: isCreateLinkedIssue ? (0, $3UrQk.ISSUE_CREATE_TYPE).linkedIssue : (0, $3UrQk.ISSUE_CREATE_TYPE).standard,
                additionalContext: {
                    linkedIssue: {
                        sourceIssueId: triggerIssueCreatePayload?.additionalContext?.linkedIssue?.sourceIssueId || '',
                        includeLinks: issuelinks?.includeLinks,
                        includeAttachments: issuelinks?.includeAttachments
                    }
                }
            } : {};
        };
        fetchConfig({
            variables: {
                ...(0, $bbvEo.getQueryVariables)(project, null, (0, $bbvEo.getUserInputForRetention)(userInputForRetentionParams)),
                parentId: triggerIssueCreatePayload?.parentId,
                ...isModalLoadInContext && {
                    additionalContext: triggerIssueCreatePayload?.additionalContext
                },
                ...issueCreateTypeFilter()
            }
        });
        setIsEpicLinkSelected(false); // Reevaulate if forge fields are detected
        setIsForgeFieldsDetected(false);
        publish((0, $xMjNG.GIC_LIFECYCLE_EVENTS).PROJECT_FIELD_VALUE_CHANGE, {
            project: project
        });
    }, [
        dirtyFieldsCurrentSession,
        fetchConfig,
        fieldConfig,
        getFormState,
        isCreateLinkedIssue,
        isModalLoadInContext,
        publish,
        setInlineErrorMessage,
        setIsEpicLinkSelected,
        setIsForgeFieldsDetected,
        setRequestBackedIssueType,
        setSelectedIssueType,
        setSelectedProject,
        setSubmitErrorMessage,
        setSubmitFieldwiseErrors,
        triggerIssueCreatePayload?.additionalContext,
        triggerIssueCreatePayload?.parentId,
        triggerIssueCreatePayload?.defaultValues,
        setShouldAutoFocus,
        resetExpandedCollapsedArea,
        selectedClassification
    ]);
    const onIssueTypeSelected = (0, $eJOHy.useCallback)((issueType)=>{
        if (selectedProject && issueType) {
            setSubmitErrorMessage('');
            setSubmitFieldwiseErrors({});
            setShouldAutoFocus(false);
            setRequestBackedIssueType(null);
            setInlineErrorMessage(null);
            resetExpandedCollapsedArea(); // when issue-type is non-null always honor issue type
            shouldUseRequestTypeDefault.current = issueType.type === (0, $4246188a36de9908$export$92ab80c1dc9baf44);
            const userInputForRetentionParams = {
                formState: getFormState.current(),
                fieldConfig: fieldConfig,
                dirtyFieldsCurrentSession: dirtyFieldsCurrentSession,
                retainedFieldsData: retainedFieldsData,
                initialDefaultValues: triggerIssueCreatePayload?.defaultValues,
                selectedClassification: selectedClassification
            };
            const payloadDefaultValues = ()=>{
                const { projectType: projectType } = selectedProject || {};
                if (projectType === (0, $ln6Iy.SERVICE_DESK_PROJECT)) return (0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(getFormState.current()?.dirtyFields) ? {
                    defaultValues: triggerIssueCreatePayload?.defaultValues || {}
                } : {};
                return {};
            };
            const issueCreateTypeFilter = ()=>{
                const { issuelinks: issuelinks } = getFormState.current()?.values || {};
                return isModalLoadInContext && isCreateLinkedIssue && (0, $7jTnu.fg)('create_linked_issues_trigger_point_issue_view') ? {
                    issueCreateType: isCreateLinkedIssue ? (0, $3UrQk.ISSUE_CREATE_TYPE).linkedIssue : (0, $3UrQk.ISSUE_CREATE_TYPE).standard,
                    additionalContext: {
                        linkedIssue: {
                            sourceIssueId: triggerIssueCreatePayload?.additionalContext?.linkedIssue?.sourceIssueId || '',
                            includeLinks: issuelinks?.includeLinks,
                            includeAttachments: issuelinks?.includeAttachments
                        }
                    },
                    ...payloadDefaultValues()
                } : {};
            };
            fetchConfig({
                variables: {
                    ...(0, $bbvEo.getQueryVariables)(selectedProject, issueType, (0, $bbvEo.getUserInputForRetention)(userInputForRetentionParams)),
                    issueTypes: triggerIssueCreatePayload?.issueTypes,
                    requestTypes: triggerIssueCreatePayload?.requestTypes,
                    parentId: triggerIssueCreatePayload?.parentId,
                    ...isModalLoadInContext && {
                        additionalContext: triggerIssueCreatePayload?.additionalContext
                    },
                    ...issueCreateTypeFilter()
                }
            });
            setIsEpicLinkSelected(false); // Reevaulate if forge fields are detected
            setIsForgeFieldsDetected(false);
            publish((0, $xMjNG.GIC_LIFECYCLE_EVENTS).ISSUE_TYPE_FIELD_VALUE_CHANGE, {
                issueType: issueType
            });
        }
    }, [
        selectedProject,
        setSubmitErrorMessage,
        setSubmitFieldwiseErrors,
        setRequestBackedIssueType,
        setInlineErrorMessage,
        getFormState,
        fieldConfig,
        dirtyFieldsCurrentSession,
        fetchConfig,
        triggerIssueCreatePayload?.issueTypes,
        triggerIssueCreatePayload?.requestTypes,
        triggerIssueCreatePayload?.parentId,
        triggerIssueCreatePayload?.additionalContext,
        triggerIssueCreatePayload?.defaultValues,
        isModalLoadInContext,
        setIsEpicLinkSelected,
        setIsForgeFieldsDetected,
        publish,
        isCreateLinkedIssue,
        setShouldAutoFocus,
        resetExpandedCollapsedArea,
        selectedClassification
    ]);
    const project = contextFields.project?.selectedProject;
    const issueType = contextFields.issuetype?.selectedIssueType;
    const requestType = contextFields.requestType?.selectedRequestType;
    const inlineError = (0, $eJOHy.useMemo)(()=>(0, $bbvEo.transformInlineErrorMessage)(sectionMessage), [
        sectionMessage
    ]);
    (0, $eJOHy.useEffect)(()=>{
        publish((0, $xMjNG.GIC_LIFECYCLE_EVENTS).CREATE_FORM_FIELD_CONFIG_UPDATE, {
            fieldConfig: fieldConfig
        });
    }, [
        publish,
        fieldConfig
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (areConfiguredFieldsModified && selectedProject && selectedIssueType) {
            setAreConfiguredFieldsModified(false);
            const userInputForRetentionParams = {
                formState: getFormState.current(),
                fieldConfig: fieldConfig,
                dirtyFieldsCurrentSession: dirtyFieldsCurrentSession,
                retainedFieldsData: retainedFieldsData,
                initialDefaultValues: triggerIssueCreatePayload?.defaultValues,
                selectedClassification: selectedClassification
            };
            const issueCreateTypeFilter = ()=>{
                const { issuelinks: issuelinks } = getFormState.current()?.values || {};
                return isModalLoadInContext && isCreateLinkedIssue && (0, $7jTnu.fg)('create_linked_issues_trigger_point_issue_view') ? {
                    issueCreateType: isCreateLinkedIssue ? (0, $3UrQk.ISSUE_CREATE_TYPE).linkedIssue : (0, $3UrQk.ISSUE_CREATE_TYPE).standard,
                    additionalContext: {
                        linkedIssue: {
                            sourceIssueId: triggerIssueCreatePayload?.additionalContext?.linkedIssue?.sourceIssueId || '',
                            includeLinks: issuelinks?.includeLinks,
                            includeAttachments: issuelinks?.includeAttachments
                        }
                    }
                } : {};
            };
            fetchConfig({
                variables: {
                    ...(0, $bbvEo.getQueryVariables)(selectedProject, selectedIssueType, (0, $bbvEo.getUserInputForRetention)(userInputForRetentionParams)),
                    parentId: triggerIssueCreatePayload?.parentId,
                    ...isModalLoadInContext && {
                        additionalContext: triggerIssueCreatePayload?.additionalContext
                    },
                    ...issueCreateTypeFilter()
                }
            });
            setIsEpicLinkSelected(false);
        }
    }, [
        isModalLoadInContext,
        fetchConfig,
        fieldConfig,
        selectedProject,
        selectedIssueType,
        areConfiguredFieldsModified,
        setAreConfiguredFieldsModified,
        dirtyFieldsCurrentSession,
        retainedFieldsData,
        setIsEpicLinkSelected,
        triggerIssueCreatePayload?.parentId,
        triggerIssueCreatePayload?.additionalContext,
        triggerIssueCreatePayload?.defaultValues,
        getFormState,
        isCreateLinkedIssue,
        selectedClassification
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (isRestoring.current) {
            /**
       * Wait for the field config to load before setting isRestoring to false
       * otherwise we will set it false before the project field config loads,
       * so once the field config loads we dont skip sine isRestoring would be false
       */ if (project || issueType) isRestoring.current = false;
            return;
        }
        if (project) setSelectedProject(project);
        if (issueType) {
            setSelectedIssueType(shouldUseRequestTypeDefault.current === true && requestType ? requestType : issueType);
            setRequestBackedIssueType(shouldUseRequestTypeDefault.current === true && requestType ? issueType : null);
        }
    }, [
        issueType,
        project,
        requestType,
        setSelectedIssueType,
        setSelectedProject,
        setRequestBackedIssueType
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const newMeta = {
            ...formMeta,
            ...meta
        };
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(formMeta, newMeta)) setMeta(newMeta);
    }, [
        formMeta,
        meta,
        setMeta
    ]);
    const { initialTransition: initialTransition, preselectedTransition: preselectedTransition } = statusFieldProps || {};
    (0, $eJOHy.useEffect)(()=>{
        setSelectedTransition(preselectedTransition || initialTransition || null);
    }, [
        initialTransition,
        preselectedTransition,
        setSelectedTransition
    ]);
    (0, $eJOHy.useEffect)(()=>{
        setSelectedClassification(initialClassification || undefined);
    }, [
        initialClassification,
        setSelectedClassification
    ]); // for error handling we need to set dataFetchError in formContext
    (0, $eJOHy.useEffect)(()=>{
        setDataFetchError(error);
    }, [
        error,
        setDataFetchError
    ]);
    (0, $eJOHy.useEffect)(()=>{
        setInlineErrorMessage(inlineError);
    }, [
        inlineError,
        setInlineErrorMessage
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (presetSubmitErrorMessage) setSubmitErrorMessage(presetSubmitErrorMessage);
    }, [
        presetSubmitErrorMessage,
        setSubmitErrorMessage
    ]);
    (0, $2VetA.useDescriptionAnalytics)();
    const currentUIModificationsConsentState = (0, $21XCU.useUIModificationsConsentStatus)();
    const onUIModificationsConsentRequiredMount = (analyticsEvent)=>(0, $gCeeo.fireOperationalAnalyticsDeferred)(analyticsEvent, 'jiraUiModificationsObligatoryConsent gicHidden');
    const areForgeInlineFieldsStoredOrIdle = (0, $eJOHy.useCallback)(()=>Object.values(fields).every((fieldData)=>fieldData.status === (0, $dfc00c8d0d7fbcf9$export$9956c6a700e724c4) || fieldData.status === (0, $dfc00c8d0d7fbcf9$export$bbf78c43fa5268c8)), [
        fields
    ]);
    const isForgeInlineFieldsError = (0, $eJOHy.useCallback)(()=>Object.values(fields).some((fieldData)=>fieldData.status === (0, $dfc00c8d0d7fbcf9$export$742c877aeb0f3dbd)), [
        fields
    ]);
    const showInvitePrompt = (0, $dOYAq.useInvitePrompt)(selectedProject?.projectKey);
    const sendCrossJoinThirdPartyNudge = (0, $li3DD.useCrossJoinThirdPartyNudgeExperiment)();
    const onCreateSuccess = ({ issueCreateResponse: issueCreateResponse, issueCreateFieldsUsed: issueCreateFieldsUsed, issueCreateContextUsed: issueCreateContextUsed, telemetryAttributes: telemetryAttributes = {}, collapsedFieldsLength: collapsedFieldsLength, issueType: issueTypeName })=>{
        const { key: issueKey, id: issueId, watchers: watchersResponse } = issueCreateResponse;
        onIssueCreateSuccess({
            issueKey: issueKey,
            issueId: Number(issueId),
            issueType: issueTypeName
        }, shouldShowWatchers ? watchersResponse : undefined);
        sendCrossJoinThirdPartyNudge();
        showInvitePrompt(getFormState.current()?.values?.description);
        setSubmitting(false); // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const boardId = (0, $2fNLP.getBoardId)(window.location.href);
        const analyticsEvent = createAnalyticsEvent({});
        const attributes = {
            sessionId: sessionId,
            issueCreateFieldsUsed: issueCreateFieldsUsed,
            issueCreateContextUsed: issueCreateContextUsed,
            boardId: boardId !== null ? Number(boardId) : undefined,
            projectType: selectedProject?.projectType,
            issueType: (0, $bbvEo.getAnalyticsIssueType)(selectedIssueType),
            ...!!selectedIssueType?.value && {
                issueTypeId: selectedIssueType?.value
            },
            ...selectedIssueType?.type === (0, $4246188a36de9908$export$92ab80c1dc9baf44) ? {
                hasRequestType: true,
                requestTypeKey: selectedIssueType?.requestTypeKey
            } : {
                hasRequestType: false
            },
            triggerPointKey: triggerPointKey,
            ...shouldShowWatchers && {
                watchers: {
                    count: watchers?.length,
                    used: (0, $bbvEo.isWatchersUsed)({
                        watchers: watchers,
                        isAutoWatchEnabled: watchersConfigurations?.isAutoWatchEnabled,
                        currentUserAccountId: currentUser.accountId
                    }),
                    ...watchersConfigurations
                }
            },
            ...shouldShowLinkedAlerts && {
                linkedAlerts: alertsToBeLinked
            },
            edition: selectedProject?.projectType && (0, $a9ldn.getEditionForProject)(selectedProject.projectType, appEditions),
            collapsedFieldsLength: collapsedFieldsLength,
            ...(0, $7jTnu.fg)('default_assignee_to_issue_creator') ? {
                assignee: {
                    assigneeDefault: (0, $bbvEo.getAssigneeType)(fieldConfig?.assignee?.defaultValue?.accountId, currentUser),
                    assigneeCreated: (0, $bbvEo.getAssigneeType)(getFormState.current()?.values?.assignee?.accountId, currentUser)
                }
            } : {}
        };
        if (shouldShowStatus) {
            attributes.statusInGicEnabled = true;
            if (selectedTransition && !selectedTransition.isInitial) attributes.userChangedStatusTo = selectedTransition.to?.statusCategory?.name;
        }
        if ($398a33d1c166d1ff$var$isChildIssueTriggerPoint(triggerPointKey)) {
            const { parent: parent } = getFormState.current()?.values || {};
            attributes.parentId = parent?.key;
        }
        (0, $gCeeo.fireTrackAnalyticsDeferred)(analyticsEvent, 'issue created', attributes);
        (0, $gCeeo.fireOperationalAnalyticsDeferred)(createAnalyticsEvent({}), 'ui taskSuccess', {
            task: 'createIssue',
            isNewGIC: true,
            isCreated: true,
            triggerPointKey: triggerPointKey,
            edition: selectedProject?.projectType && (0, $a9ldn.getEditionForProject)(selectedProject.projectType, appEditions),
            application: selectedProject?.projectType && (0, $bRJAs.getApplicationForProject)(selectedProject.projectType),
            ...telemetryAttributes
        });
    };
    const findFirstTabIndexWithErrors = (0, $eJOHy.useCallback)((errors = {})=>{
        const index = fieldTabs.findIndex((tab)=>tab.items.find((item)=>errors && item === Object.keys(errors)[0]));
        return index > -1 ? index : 0;
    }, [
        fieldTabs
    ]);
    const onCreateFailure = ({ issueCreateError: err, telemetryAttributes: telemetryAttributes, issueType: issueTypeLabel })=>{
        setSubmitting(false); // on 4xx
        if ((0, $1uIew.isValidationError)(err)) {
            const { message: message } = err;
            if (message && message.length) setSubmitErrorMessage(message.split('; ').join('\r\n'));
            const errors = 'errors' in err ? (0, $bbvEo.transformValidationErrors)(err.errors) : undefined;
            setSubmitFieldwiseErrors(errors);
            setCurrentActiveTabIndex(findFirstTabIndexWithErrors(errors));
            const customFieldError = (0, $bbvEo.isDisplayConditionCFCausingError)('errors' in err ? err.errors : [], fieldConfig, filteredOutModules);
            const issueTypeName = issueTypeLabel?.label;
            const getSingleFieldErrorMsg = ()=>{
                if (issueType && (0, $epTsa.expVal)('jira-itr-work-type-exp-1', 'isEnabled', false)) return (0, $9uhQ0.default).singleRequiredCustomFieldIssueCreationBlockIssueTerminologyRefreshM4;
                return (0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $9uhQ0.default).singleRequiredCustomFieldIssueCreationBlockIssueTermRefresh : (0, $9uhQ0.default).singleRequiredCustomFieldIssueCreationBlock;
            };
            const getMultipleFieldErrorMsg = ()=>{
                if (issueType && (0, $epTsa.expVal)('jira-itr-work-type-exp-1', 'isEnabled', false)) return (0, $9uhQ0.default).multipleRequiredCustomFieldsIssueCreationBlockIssueTerminologyRefreshM4;
                return (0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $9uhQ0.default).multipleRequiredCustomFieldsIssueCreationBlockIssueTermRefresh : (0, $9uhQ0.default).multipleRequiredCustomFieldsIssueCreationBlock;
            };
            if (customFieldError) {
                const errorMessage = customFieldError.length > 1 ? formatMessage(getMultipleFieldErrorMsg(), {
                    fieldsName: formatList(customFieldError, {
                        style: 'long',
                        type: 'conjunction'
                    }),
                    issueType: issueTypeName
                }) : formatMessage(getSingleFieldErrorMsg(), {
                    fieldName: formatList(customFieldError, {
                        style: 'short',
                        type: 'conjunction'
                    }),
                    issueType: issueTypeName
                });
                setSubmitErrorMessage(String(errorMessage));
            }
            if ((0, $7jTnu.fg)('global_issue_create_task_abort_event')) (0, $gCeeo.fireOperationalAnalyticsDeferred)(createAnalyticsEvent({}), 'ui taskAbort', {
                task: 'createIssue',
                isNewGIC: true,
                isCreated: false,
                triggerPointKey: triggerPointKey,
                edition: selectedProject?.projectType && (0, $a9ldn.getEditionForProject)(selectedProject.projectType, appEditions),
                application: selectedProject?.projectType && (0, $bRJAs.getApplicationForProject)(selectedProject.projectType),
                ...telemetryAttributes
            });
            return errors;
        } // on 5xx
        let description;
        if (isEmbedded) description = (0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $9uhQ0.default).embeddedCreateErrorFlagDescriptionIssueTermRefresh : (0, $9uhQ0.default).embeddedCreateErrorFlagDescription;
        else description = (0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $9uhQ0.default).createErrorFlagDescriptionIssueTermRefresh : (0, $9uhQ0.default).createErrorFlagDescription;
        showFlag({
            type: 'error',
            title: (0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $9uhQ0.default).createErrorFlagTitleIssueTermRefresh : (0, $9uhQ0.default).createErrorFlagTitle,
            description: description,
            testId: 'jira-issue-create.modal.create-form.error-flag',
            messageId: 'issue-create.ui.modal.create-form.show-flag.error',
            messageType: 'transactional'
        });
        (0, $gCeeo.fireOperationalAnalyticsDeferred)(createAnalyticsEvent({}), 'ui taskFail', {
            task: 'createIssue',
            isNewGIC: true,
            isCreated: true,
            triggerPointKey: triggerPointKey,
            edition: selectedProject?.projectType && (0, $a9ldn.getEditionForProject)(selectedProject.projectType, appEditions),
            application: selectedProject?.projectType && (0, $bRJAs.getApplicationForProject)(selectedProject.projectType),
            ...telemetryAttributes
        });
        return undefined;
    }; // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onSubmit = async (formData, formApi)=>{
        if (selectedProject && selectedIssueType) {
            setSubmitting(true);
            setSubmitErrorMessage('');
            setSubmitFieldwiseErrors({});
            const telemetryAttributes = {
                wasIssueCreatedWithCreateAnotherIssue: hasCreatedAnotherIssue,
                view: minimizableModalView
            };
            if (isForgeInlineFieldsError()) {
                const forgeInlineError = new (0, $1uIew.ValidationError)('', Object.keys(fields).map((key)=>({
                        field: key,
                        error: formatMessage((0, $9uhQ0.default).createErrorForgeInlineField)
                    })));
                return onCreateFailure({
                    issueCreateError: forgeInlineError,
                    telemetryAttributes: telemetryAttributes,
                    issueType: selectedIssueType
                });
            }
            const isForgeFieldFocused = Object.values(fields).some((field)=>field.status === (0, $dfc00c8d0d7fbcf9$export$32bbcfb76243a487));
            const isForgeIframe = (el)=>el.dataset?.forgeIframe === 'true'; // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            const activeElement = window.document?.activeElement;
            const isForgeIframeActive = activeElement instanceof HTMLElement && isForgeIframe(activeElement); // When the user is focused on a Forge field when clicking on "submit" button in GIC
            // we need to manually trigger focus event on form button and block the form submission
            // because the fields rely on blur events to submit the value. For the UI kit fields
            // we rely on isForgeFieldFocused value, however for the custom ui fields we don't change
            // the fields state on focus events so we need to check it with isForgeIframeActive
            const shouldFocusFormButton = isForgeFieldFocused || isForgeIframeActive;
            if (shouldFocusFormButton || !areForgeInlineFieldsStoredOrIdle() && forgeFieldBlockStatus !== (0, $dfc00c8d0d7fbcf9$export$e784a07a62e2e0e5)) {
                if (shouldFocusFormButton) {
                    previousForgeFieldsState.current = fields;
                    (0, $gPU3b.focusFormButton)((0, $3838db8cf80b284d$export$2d077da71c26c1c5));
                }
                setForgeFieldBlockStatus((0, $dfc00c8d0d7fbcf9$export$30daef8830f2505d));
                const timeout = setTimeout(()=>{
                    setForgeFieldBlockStatus((0, $dfc00c8d0d7fbcf9$export$e784a07a62e2e0e5));
                    clearTimeout(timeout);
                }, (0, $dfc00c8d0d7fbcf9$export$ae7c16bdba5e2e15));
                return undefined;
            }
            try {
                // Include preserved field values when toggle is on and experiment is enabled
                let finalFormData = {
                    ...formData
                };
                if (isShowOnlyRequiredFieldsExperimentEnabled && showOnlyRequiredFields && Object.keys(preservedFieldValues.current).length > 0) // Merge preserved field values with current form data
                // This ensures that hidden non-required fields still have their values included in the submission
                finalFormData = {
                    ...formData,
                    ...preservedFieldValues.current
                };
                const payload = {
                    formData: {
                        ...(0, $bbvEo.getContextFieldsForSubmit)(selectedProject, selectedIssueType, contextFields.requestType?.fieldId),
                        ...(0, $bbvEo.getParentIdForSubmit)(triggerIssueCreatePayload?.parentId),
                        ...finalFormData
                    },
                    onSuccess: (issueCreateSuccessProps)=>onCreateSuccess({
                            ...issueCreateSuccessProps,
                            telemetryAttributes: telemetryAttributes,
                            issueType: selectedIssueType?.label
                        }),
                    fieldConfig: fieldConfig,
                    fieldTabs: fieldTabs,
                    hasIssueAdjustmentModules: uiModificationsStatus === 'enabled',
                    ...(0, $bbvEo.canSetContextForSubmit)(selectedProject, context) && {
                        context: context
                    },
                    ...(0, $7jTnu.fg)('create_linked_issues_trigger_point_issue_view') && {
                        createLinkedIssuePayload: {
                            isCreateLinkedIssue: isCreateLinkedIssue,
                            sourceIssueKey: isCreateLinkedIssue ? triggerIssueCreatePayload?.defaultValues?.issueLinks?.linkedIssueKeys[0] : null
                        }
                    },
                    isSubTaskCreationOpen: isSubTaskCreationOpen,
                    triggerPointKey: triggerPointKey,
                    sessionId: sessionId,
                    interactedFields: interactedFields,
                    shouldShowStatus: shouldShowStatus
                };
                try {
                    if (selectedClassification) payload.formData.dataclassification = {
                        id: selectedClassification?.id ? (0, $axgz1.PlatformClassificationTagAri).parse(selectedClassification.id)?.tagId : null
                    };
                } catch (e) {}
                if (shouldShowStatus && selectedTransition && !selectedTransition.isInitial) payload.transition = {
                    id: selectedTransition.id
                };
                if (shouldShowWatchers && watchersConfigurations?.canManageWatchers) {
                    payload.watchers = watchers?.map((watcher)=>watcher.accountId);
                    payload.skipAutoWatch = true;
                }
                await createIssue(payload);
                setHasCreatedAnotherIssue(false); // Clear preserved field values after successful submission
                if (isShowOnlyRequiredFieldsExperimentEnabled) preservedFieldValues.current = {};
                const issueTypeName = selectedIssueType.label;
                if (forgeFieldBlockStatus === (0, $dfc00c8d0d7fbcf9$export$e784a07a62e2e0e5)) {
                    const timedoutCFS = [];
                    Object.entries(fields).forEach(([key, value])=>{
                        if (value.status === (0, $dfc00c8d0d7fbcf9$export$f81c1d6b9217380c)) timedoutCFS.push(fieldConfig[key].fieldName);
                    });
                    const getTitle = ()=>{
                        if (issueType && (0, $epTsa.expVal)('jira-itr-work-type-exp-1', 'isEnabled', false)) return (0, $9uhQ0.default).timeoutForgeInlineFieldTitleIssueTerminologyRefreshM4;
                        return (0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $9uhQ0.default).timeoutForgeInlineFieldTitleIssueTermRefresh : (0, $9uhQ0.default).timeoutForgeInlineFieldTitle;
                    };
                    const getDesc = ()=>{
                        if (issueType && (0, $epTsa.expVal)('jira-itr-work-type-exp-1', 'isEnabled', false)) return (0, $9uhQ0.default).timeoutForgeInlineFieldDescriptionIssueTerminologyRefreshM4;
                        return (0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $9uhQ0.default).timeoutForgeInlineFieldDescriptionIssueTermRefresh : (0, $9uhQ0.default).timeoutForgeInlineFieldDescription;
                    };
                    if (timedoutCFS.length) showFlag({
                        type: 'warning',
                        title: [
                            getTitle(),
                            {
                                issueType: issueTypeName
                            }
                        ],
                        description: [
                            getDesc(),
                            {
                                fields: timedoutCFS.join(', '),
                                bold: (str)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("b", null, str),
                                issueType: issueTypeName
                            }
                        ],
                        testId: 'jira-issue-create.modal.create-form.forge-timeout-flag',
                        messageId: 'issue-create.ui.modal.create-form.show-flag.warning',
                        messageType: 'transactional'
                    });
                }
                if (canCreateAnotherIssue) {
                    setShouldAutoFocus(true);
                    sectionMessage && clearSectionMessage();
                    setTimeout(()=>{
                        // reset is used instead of setFieldValue because we want to reset the summary field to it's pristine state. setFieldValue only sets the value and the fields remains dirty causing a validation error when create another issue option is checked
                        // resetSummary.current({
                        //     ...formData,
                        //     summary: '',
                        // });
                        const fieldsReset = (0, $bbvEo.resetFormFieldsForCreateAnother)(finalFormData, fieldConfig, formApi.reset);
                        publish((0, $xMjNG.GIC_LIFECYCLE_EVENTS).RESET_FORM_FIELDS_FOR_CREATE_ANOTHER, {
                            fieldsReset: fieldsReset ?? {}
                        });
                        setSelectedTransition(statusFieldProps?.initialTransition || null);
                        setSelectedClassification(classificationFieldProps?.initialClassification || undefined);
                        onFormFieldsReset?.();
                        setHasCreatedAnotherIssue(true);
                    }, 0);
                } // Show enforcement if created JSW issue and it was a success
                const isSoftwareProjectSelected = selectedProject.projectType === 'software';
                if (isSoftwareProjectSelected) showEnforcementIfStorageIsFull({
                    delayShow: minimizableModalView === 'modal' && canCreateAnotherIssue,
                    // We only care if the issue was created for a JSW project or not
                    // rather than if the user is currently viewing a JSW project
                    shouldOnlyShowInJSWContext: false,
                    touchpoint: 'global-issue-create'
                });
                 // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (err) {
                return onCreateFailure({
                    issueCreateError: err,
                    telemetryAttributes: telemetryAttributes,
                    issueType: selectedIssueType
                });
            }
        }
        resetState();
        return undefined;
    };
    (0, $eJOHy.useEffect)(()=>{
        if (forgeFieldBlockStatus !== (0, $dfc00c8d0d7fbcf9$export$f86e250f1a7b07c8)) {
            const isTimeout = forgeFieldBlockStatus === (0, $dfc00c8d0d7fbcf9$export$e784a07a62e2e0e5); // for CustomUI inline edit we need to compare fieldState in case of forced blur effect
            const customUIFieldStateCheck = previousForgeFieldsState.current !== fields;
            if (areForgeInlineFieldsStoredOrIdle() && customUIFieldStateCheck || isTimeout) {
                previousForgeFieldsState.current = fields;
                setForgeFieldBlockStatus((0, $dfc00c8d0d7fbcf9$export$f86e250f1a7b07c8));
                (0, $21Y41.submitForgeFormField)(formRef);
            } else dispatchFormSubmits();
        } // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        areForgeInlineFieldsStoredOrIdle,
        getFormState,
        forgeFieldBlockStatus,
        selectedTransition
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (isSmartFieldsToggled === true) {
            selectedProject && reloadForm(selectedProject, selectedIssueType, false);
            setIsSmartFieldsToggled(false);
        }
    }, [
        isSmartFieldsToggled,
        reloadForm,
        selectedIssueType,
        selectedProject,
        setIsSmartFieldsToggled
    ]);
    const onIssueCreateFormMount = (0, $eJOHy.useCallback)((analyticsEvent)=>{
        (0, $gCeeo.fireOperationalAnalyticsDeferred)(analyticsEvent, 'IssueCreateForm rendered');
        if ((0, $7jTnu.fg)('global_issue_create_modal_load_task_success_event')) fireModalLoadTaskSuccessEvent(analyticsEvent);
    }, [
        fireModalLoadTaskSuccessEvent
    ]);
    const handleFormDirty = (dirty)=>{
        let isDirty = dirty;
        if (dirtyFieldsCurrentSession && dirtyFieldsCurrentSession.current && Object.keys(dirtyFieldsCurrentSession.current).length) isDirty = true;
        setIsFormDirty(isDirty);
    };
    const getForm = ()=>{
        if (currentUIModificationsConsentState === (0, $5b46c372089c1d7d$export$d67d63332ce3ce38)) {
            resetSummary.current = null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Plmb.MountEvent), {
                onMount: onUIModificationsConsentRequiredMount
            });
        }
        if (!isLoading && meta.queryErrorMessage) {
            resetSummary.current = null;
            return null;
        }
        if (isLoading || !(selectedProject && selectedIssueType)) {
            resetSummary.current = null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4rsU2.default), {
                skeletonCount: 6
            });
        }
        if (fieldConfig && !meta.queryErrorMessage) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3L3Os.default), {
            key: `${selectedProject.value}-${selectedIssueType.value}`,
            onSubmit: onSubmit,
            isDisabled: !meta.areRequiredFieldsSupported
        }, ({ formProps: formProps, getState: getState, dirty: dirty, reset: reset, setFieldValue: setFieldValue })=>{
            getFormState.current = getState;
            formSetFieldValue.current = setFieldValue; /**
                                                        * isFormDirty is the actual value we should use to tell if the form
                                                        * is dirty. isFormDirty comes from form-context, and is updated
                                                        * in handleFormDirty.
                                                        *
                                                        * We pass the AKForm's dirty so that handleFormDirty can use both
                                                        * AKForm's dirty and dirtyFieldsCurrentSession (from props) to set
                                                        * isFormDirty correctly by taking both into account.
                                                        *
                                                        * Note - we are using this isFormDirty in issue-create-restore to block nav there
                                                        * src/packages/issue-create/issue-create-restore/src/controllers/should-show-browser-warning/index.tsx
                                                        */ 
            handleFormDirty(dirty);
            if (!resetSummary.current) {
                resetSummary.current = reset;
                setResetFormAction(reset);
            }
            const getLayoutRenderer = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aQ4h7.default), {
                    fieldConfig: fieldConfig,
                    fieldTabs: filteredFieldTabs,
                    setFieldValue: setFieldValue,
                    getFormState: getState,
                    apiLatency: apiLatency,
                    fieldPropsExtensions: isGICPositioningEnabled() ? fieldPropsExtensions : undefined,
                    optOutSmartFieldIds: optOutSmartFieldIds && (0, $7jTnu.fg)('opt_out_smart_fields_in_gic') ? optOutSmartFieldIds : undefined
                });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($398a33d1c166d1ff$var$WrapperDiv, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("form", {
                ...formProps,
                id: "issue-create.ui.modal.create-form",
                ref: (ref)=>{
                    // @ts-expect-error - TS2322 - Type 'HTMLFormElement | null' is not assignable to type 'HTMLFormElement | undefined'.
                    formRef.current = ref;
                },
                noValidate: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $BAHbx.FormApiProvider), {
                getFormState: getState,
                setFieldValue: setFieldValue
            }, getLayoutRenderer()))));
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Plmb.MountEvent), {
            onMount: onIssueCreateFormMount
        }));
        return null;
    };
    const onIssueTypeCreatedOrUpdated = ()=>{
        if (selectedProject) reloadForm(selectedProject, selectedIssueType, true);
    };
    const getRequestTypeFieldsLayoutPreference = ()=>// if we have request types (JSM CMP only) then we want to show the toggle
        contextFields.requestType?.requestTypes && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jWBLD.RequestTypeFieldsLayoutPreference), {
            isRequestTypeSelected: selectedIssueType?.type === (0, $4246188a36de9908$export$92ab80c1dc9baf44),
            onChange: ()=>selectedProject && reloadForm(selectedProject, selectedIssueType, false),
            overrideIsEnabled: overrideUseRequestTypeFieldsToggleState
        });
    const getProformaBanner = ()=>!isLoading && proformaConfiguration?.hasProformaForm && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jap6l.ProformaBanner), {
            portalLink: proformaConfiguration.portalLink
        });
    const getClassificationField = ()=>classificationFieldProps?.availableClassifications?.length && classificationFieldProps.availableClassifications.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vmYB.default), {
            allowedValues: classificationFieldProps?.availableClassifications || [],
            value: selectedClassification,
            onChange: onClassificationOptionChange,
            width: isMini ? '100%' : undefined,
            nonEditableReason: classificationFieldProps.nonEditableMessage,
            ...classificationFieldProps,
            errorMessage: formMeta?.submitFieldwiseErrors?.dataclassification
        }) : null; // memoise the issueTypes value so that a new `[]` is not passed into TypePicker per render
    const issueTypes = contextFields.issuetype?.issueTypes;
    const issueTypesMemoised = (0, $eJOHy.useMemo)(()=>issueTypes || [], [
        issueTypes
    ]);
    const projectPickerIsDisabled = isSubTaskCreationOpen || disableProjectDropdown;
    const projectProps = (0, $eJOHy.useMemo)(()=>({
            projectKey: selectedProject?.projectKey ?? '',
            projectId: selectedProject?.value ?? '',
            projectType: selectedProject?.projectType ?? null
        }), [
        selectedProject
    ]);
    const inlineConfigStatusProps = (0, $eJOHy.useMemo)(()=>({
            ...projectProps,
            issueTypeId: selectedIssueType?.value,
            canConfigureStatuses: canConfigureStatuses,
            onStatusCreatedOrUpdated: onStatusCreatedOrUpdated
        }), [
        canConfigureStatuses,
        onStatusCreatedOrUpdated,
        projectProps,
        selectedIssueType?.value
    ]);
    const hasCollapsedFields = (0, $eJOHy.useMemo)(()=>fieldTabs.some((tab)=>!!tab.collapsedItems?.length), [
        fieldTabs
    ]); // Filter field tabs to show only required fields when toggle is enabled
    const filteredFieldTabs = (0, $eJOHy.useMemo)(()=>{
        if (!isShowOnlyRequiredFieldsExperimentEnabled || !showOnlyRequiredFields || !fieldTabs || !fieldConfig) return fieldTabs;
        return fieldTabs.map((tab)=>{
            const filteredItems = tab.items.filter((fieldId)=>{
                const field = fieldConfig[fieldId];
                return field?.isRequired === true;
            });
            const filteredCollapsedItems = tab.collapsedItems?.filter((fieldId)=>{
                const field = fieldConfig[fieldId];
                return field?.isRequired === true;
            }) || [];
            return {
                ...tab,
                items: filteredItems,
                collapsedItems: filteredCollapsedItems
            };
        }).filter((tab)=>tab.items.length > 0 || tab.collapsedItems && tab.collapsedItems.length > 0);
    }, [
        isShowOnlyRequiredFieldsExperimentEnabled,
        fieldTabs,
        fieldConfig,
        showOnlyRequiredFields
    ]); // Handle toggle change
    const handleToggleChange = (0, $eJOHy.useCallback)(()=>{
        const newValue = !showOnlyRequiredFields; // Only apply value preservation logic when the experiment is enabled
        if (isShowOnlyRequiredFieldsExperimentEnabled) {
            if (newValue === true) {
                // Switching to "show only required fields" - preserve current non-required field values
                const currentFormState = getFormState.current?.();
                if (currentFormState?.values && fieldConfig) {
                    const nonRequiredFieldValues = {}; // Capture values for all non-required fields
                    Object.entries(fieldConfig).forEach(([fieldId, field])=>{
                        if (field && !field.isRequired && currentFormState.values[fieldId] !== undefined) nonRequiredFieldValues[fieldId] = currentFormState.values[fieldId];
                    });
                    preservedFieldValues.current = nonRequiredFieldValues;
                }
            } else {
                // Switching to "show all fields" - restore preserved values
                const currentFormState = getFormState.current?.();
                if (currentFormState?.values && Object.keys(preservedFieldValues.current).length > 0) {
                    // Restore preserved values for non-required fields
                    Object.entries(preservedFieldValues.current).forEach(([fieldId, value])=>{
                        if (formSetFieldValue.current) formSetFieldValue.current(fieldId, value);
                    }); // Clear preserved values after restoration
                    preservedFieldValues.current = {};
                }
            }
        }
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'toggle clicked', 'showOnlyRequiredFields', {
            previousValue: showOnlyRequiredFields,
            currentValue: newValue,
            defaultValue: (0, $bbvEo.getShowOnlyRequiredFieldsDefaultValue)()
        });
        setShowOnlyRequiredFields(newValue);
    }, [
        showOnlyRequiredFields,
        isShowOnlyRequiredFieldsExperimentEnabled,
        createAnalyticsEvent,
        getFormState,
        fieldConfig
    ]);
    const oldContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $l57PA.default), {
        onChange: onProjectChange,
        value: selectedProject,
        renderOptionsLimit: 25,
        skipFetchProjects: !!meta.queryErrorMessage,
        disableFetchProject: projectPickerIsDisabled,
        isDisabled: projectPickerIsDisabled,
        width: isMini ? '100%' : undefined,
        onProjectSelection: onProjectSelection
    }), isMini && selectedProject?.projectType !== (0, $ln6Iy.SERVICE_DESK_PROJECT) && shouldShowStatus && statusFieldProps ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($398a33d1c166d1ff$var$MiniIssueTypeStatusWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5IMhp.default), {
        onIssueTypeCreatedOrUpdated: onIssueTypeCreatedOrUpdated,
        canConfigureIssueTypes: canConfigureIssueTypes,
        issueTypes: issueTypesMemoised,
        requestTypes: contextFields.requestType?.requestTypes,
        onChange: onIssueTypeSelected,
        value: selectedIssueType,
        isDisabled: disableIssueTypeDropdown,
        ...(0, $7jTnu.fg)('inline_issue_type_config_productionization_prereqs') ? {
            isMini: true
        } : {},
        ...projectProps
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $60nLj.default), {
        isLoading: !!statusFieldProps.isTransitionsLoading,
        error: statusFieldProps.transitionsError,
        transitions: statusFieldProps.availableTransitions || [],
        isMini: true,
        value: selectedTransition,
        onChange: onChangeSelectedTransition,
        ...inlineConfigStatusProps
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5IMhp.default), {
        onIssueTypeCreatedOrUpdated: onIssueTypeCreatedOrUpdated,
        canConfigureIssueTypes: canConfigureIssueTypes,
        issueTypes: issueTypesMemoised,
        requestTypes: contextFields.requestType?.requestTypes,
        onChange: onIssueTypeSelected,
        value: selectedIssueType,
        isDisabled: disableIssueTypeDropdown,
        ...projectProps,
        isMini: isMini
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fE4zR.Divider), null), shouldShowStatus && statusFieldProps && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $60nLj.default), {
        isLoading: !!statusFieldProps.isTransitionsLoading,
        error: statusFieldProps.transitionsError,
        transitions: statusFieldProps.availableTransitions || [],
        isMini: false,
        value: selectedTransition,
        onChange: onChangeSelectedTransition,
        ...inlineConfigStatusProps
    })), getRequestTypeFieldsLayoutPreference(), getClassificationField(), shouldShowLinkedAlerts && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $17nxE.LinkedAlertsField), {
        value: alertsToBeLinked || [],
        onRemoveButtonClick: removeAlertFromAlertsToBeLinked
    }), getProformaBanner(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fB3KX.ExternalControlsRenderer), {
        externalControls: ExternalControls,
        setFieldValue: formSetFieldValue.current,
        getFormState: getFormState.current
    }), getForm());
    const newContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($398a33d1c166d1ff$var$RelativeWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($398a33d1c166d1ff$var$FlexWrapper, null, isShowOnlyRequiredFieldsExperimentEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($398a33d1c166d1ff$var$LeftAlignedContent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $398a33d1c166d1ff$var$toggleWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        sourceType: (0, $466f60259c330878$export$1171103ea9083ffa),
        sourceName: "showOnlyRequiredFieldsToggle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqtgH.FireScreenAnalytics), {
        attributes: {
            defaultValue: showOnlyRequiredFields
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8CBYv.default), {
        size: "regular",
        isChecked: showOnlyRequiredFields,
        onChange: handleToggleChange
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($398a33d1c166d1ff$var$RequiredFieldsSummary, {
        isMini: isMini,
        showOnlyRequiredFieldsLabel: true
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($398a33d1c166d1ff$var$RequiredFieldsSummary, {
        isMini: isMini
    }), displayHeaderActionContainer && !(0, $6XJko.isVisualRefreshEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1AeYS.ActionsContainer), {
        watchersConfigurations: watchersConfigurations,
        fieldConfig: fieldConfig
    })), displaySitePicker && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dPjg7.default), {
        onChange: onResetApolloCache,
        width: isMini ? '100%' : undefined,
        onSiteSelection: onSiteSelection
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $l57PA.default), {
        onChange: onProjectChange,
        value: selectedProject,
        renderOptionsLimit: 25,
        skipFetchProjects: !!meta.queryErrorMessage,
        disableFetchProject: projectPickerIsDisabled,
        isDisabled: projectPickerIsDisabled,
        width: isMini ? '100%' : undefined,
        onProjectSelection: onProjectSelection
    }), minimizableModalView === 'mini' && selectedProject?.projectType !== (0, $ln6Iy.SERVICE_DESK_PROJECT) && shouldShowStatus && statusFieldProps ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($398a33d1c166d1ff$var$MiniIssueTypeStatusWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5IMhp.default), {
        onIssueTypeCreatedOrUpdated: onIssueTypeCreatedOrUpdated,
        canConfigureIssueTypes: canConfigureIssueTypes,
        issueTypes: issueTypesMemoised,
        requestTypes: contextFields.requestType?.requestTypes,
        onChange: onIssueTypeSelected,
        value: selectedIssueType,
        isDisabled: disableIssueTypeDropdown,
        ...(0, $7jTnu.fg)('inline_issue_type_config_productionization_prereqs') ? {
            isMini: true
        } : {},
        ...projectProps
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $60nLj.default), {
        isLoading: !!statusFieldProps.isTransitionsLoading,
        error: statusFieldProps.transitionsError,
        transitions: statusFieldProps.availableTransitions || [],
        isMini: true,
        value: selectedTransition,
        onChange: onChangeSelectedTransition,
        ...inlineConfigStatusProps
    })), uiModificationsStatus !== 'enabled' && hasCollapsedFields && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $398a33d1c166d1ff$var$smartFieldMessageWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fE4zR.Divider), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gG5II.SmartFieldMessage), null))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5IMhp.default), {
        onIssueTypeCreatedOrUpdated: onIssueTypeCreatedOrUpdated,
        canConfigureIssueTypes: canConfigureIssueTypes,
        issueTypes: issueTypesMemoised,
        requestTypes: contextFields.requestType?.requestTypes,
        onChange: onIssueTypeSelected,
        value: selectedIssueType,
        isDisabled: disableIssueTypeDropdown,
        ...projectProps,
        isMini: isMini
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fE4zR.Divider), null), uiModificationsStatus !== 'enabled' && hasCollapsedFields && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gG5II.SmartFieldMessage), null), shouldShowStatus && statusFieldProps && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $60nLj.default), {
        isLoading: !!statusFieldProps.isTransitionsLoading,
        error: statusFieldProps.transitionsError,
        transitions: statusFieldProps.availableTransitions || [],
        isMini: false,
        value: selectedTransition,
        onChange: onChangeSelectedTransition,
        ...inlineConfigStatusProps
    })), getRequestTypeFieldsLayoutPreference(), getClassificationField(), shouldShowLinkedAlerts && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $17nxE.LinkedAlertsField), {
        value: alertsToBeLinked || [],
        onRemoveButtonClick: removeAlertFromAlertsToBeLinked
    }), getProformaBanner(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fB3KX.ExternalControlsRenderer), {
        externalControls: ExternalControls,
        setFieldValue: formSetFieldValue.current,
        getFormState: getFormState.current
    }), getForm());
    (0, $eJOHy.useEffect)(()=>{
        let forgeCustomFieldDetected = false;
        Object.values(fieldConfig).forEach((field)=>{
            if ((0, $gPU3b.isForgeCustomField)(field.fieldType)) forgeCustomFieldDetected = true;
        });
        setIsForgeFieldsDetected(forgeCustomFieldDetected);
    }, [
        fieldConfig,
        setIsForgeFieldsDetected
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        ref: createFormScrollRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        id: (0, $3UrQk.FORM_DROPZONE_CONTAINER_ID),
        ...(0, $c1cLY.useResizingHeight)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dsfSm.default), null), isGICPositioningEnabled() ? newContent : oldContent));
};
const $398a33d1c166d1ff$var$CreateForm = /*#__PURE__*/ (0, $eJOHy.memo)($398a33d1c166d1ff$var$CreateFormBase);
var $398a33d1c166d1ff$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $398a33d1c166d1ff$var$CreateForm;
const $398a33d1c166d1ff$var$WrapperDiv = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_35md1bgi _z6i1glyw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $398a33d1c166d1ff$var$RelativeWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswh2mm",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $398a33d1c166d1ff$var$MiniIssueTypeStatusWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _2lx2vrvc _4cvr1q9y _jw0lu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $398a33d1c166d1ff$var$RequiredMessage = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isMini: isMini, noMargin: noMargin, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_syaz1gjq",
            __cmplp.isMini ? "_11c8dcr7" : "_11c82smr",
            __cmplp.noMargin && "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $398a33d1c166d1ff$var$FlexWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bah1yb4 _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $398a33d1c166d1ff$var$LeftAlignedContent = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $398a33d1c166d1ff$var$smartFieldMessageWrapperStyles = (0, $1DXK0.xcss)({
    marginBottom: 'space.300'
});
const $398a33d1c166d1ff$var$toggleWrapperStyles = (0, $1DXK0.xcss)({
    transform: 'scale(0.9)',
    transformOrigin: 'left center',
    marginLeft: 'space.negative.050'
});

});
parcelRegister("8CBYv", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b71259385cf6352$export$2e2bcd8739ae039);
/* toggle.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $4eDgu = parcelRequire("4eDgu");

var $jrFnt = parcelRequire("jrFnt");

var $3Vuhz = parcelRequire("3Vuhz");

var $gl2vi = parcelRequire("gl2vi");

var $6XkOW = parcelRequire("6XkOW");

var $82pO9 = parcelRequire("82pO9");

var $eGOwo = parcelRequire("eGOwo");

var $hqCmO = parcelRequire("hqCmO");
const $8b71259385cf6352$var$basicStyles = null;
const $8b71259385cf6352$var$borderStyles = null;
const $8b71259385cf6352$var$iconStyles = null;
const $8b71259385cf6352$var$sizeStyles = {
    regular: "_2rkopxbi _4t3ipxbi _1bsbxy5q _kfgtutpp _1mp41crf _p9c41fbe",
    large: "_2rkov47k _4t3iv47k _1bsb1jfw _kfgtpxbi _1mp47vkz _p9c4w12q"
};
const $8b71259385cf6352$var$noop = (0, $3Vuhz.default);
const $8b71259385cf6352$var$analyticsAttributes = {
    componentName: 'toggle',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $8b71259385cf6352$var$iconSizeMap = {
    regular: 'small',
    large: 'medium'
}; /**
    * __Toggle__
    *
    * A toggle is used to view or switch between enabled or disabled states.
    *
    * - [Examples](https://atlassian.design/components/toggle/examples)
    * - [Code](https://atlassian.design/components/toggle/code)
    * - [Usage](https://atlassian.design/components/toggle/usage)
    */ 
const $8b71259385cf6352$var$Toggle = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const { defaultChecked: defaultChecked = false, isDisabled: isDisabled = false, onBlur: providedOnBlur = $8b71259385cf6352$var$noop, onChange: providedChange = $8b71259385cf6352$var$noop, onFocus: providedFocus = $8b71259385cf6352$var$noop, size: size = 'regular', name: name = '', value: value = '', isChecked: isChecked, analyticsContext: analyticsContext, id: id, testId: testId, label: label, descriptionId: descriptionId } = props;
    const isControlled = typeof isChecked === 'undefined';
    const [checked, setChecked] = (0, $eJOHy.useState)(defaultChecked);
    const [isKeyboardUsed, setIsKeyboardUsed] = (0, $eJOHy.useState)(true);
    const wrapperRef = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useEffect)(()=>{
        if (id && wrapperRef.current && wrapperRef.current.parentElement) {
            /*
      	DSP-21524 Handling the click on <label> that is linked via "for" attribute.
      	By default click on the label fires absolutely same onclick event as click on the input element.
      	To differentiate keyboard click from mouse we need this additional listener.
      */ const linkedLabel = wrapperRef.current.parentElement.querySelector(`label[for="${id}"]`);
            if (linkedLabel) {
                const unbind = (0, $4eDgu.bindAll)(linkedLabel, [
                    {
                        type: 'click',
                        listener: (event)=>{
                            setIsKeyboardUsed(false);
                            if (event?.detail > 1) /*
              DSP-21524 double or triple click on label initiating the text selection for label text and adds additional step to tab order.
              So here we set the isKeyboardUsed to true, to display focus ring on next Tab press
              */ setIsKeyboardUsed(true);
                        }
                    }
                ]);
                return unbind;
            }
        }
    }, [
        id,
        wrapperRef,
        isKeyboardUsed
    ]);
    const handleBlur = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (!isKeyboardUsed) setIsKeyboardUsed(true);
            providedOnBlur(event, analyticsEvent);
        },
        action: 'blur',
        analyticsData: analyticsContext,
        ...$8b71259385cf6352$var$analyticsAttributes
    });
    const handleFocus = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: providedFocus,
        action: 'focus',
        analyticsData: analyticsContext,
        ...$8b71259385cf6352$var$analyticsAttributes
    });
    const handleChange = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (isControlled) setChecked((checked)=>!checked);
            return providedChange(event, analyticsEvent);
        },
        action: 'change',
        analyticsData: analyticsContext,
        ...$8b71259385cf6352$var$analyticsAttributes
    });
    const onLabelKeyDown = (event)=>{
        if ([
            ' ',
            'Tab',
            'Space'
        ].includes(event.key)) setIsKeyboardUsed(true);
    };
    const shouldChecked = isControlled ? checked : isChecked;
    const controlProps = {
        'data-checked': shouldChecked ? shouldChecked : undefined,
        'data-disabled': isDisabled ? isDisabled : undefined,
        'data-size': size,
        'data-testid': testId ? testId : undefined,
        // DSP-21524 Because label gets focus ring via focus-within and focus-within also triggers by mouse click we have to manually control the ring appearance.
        onKeyDown: onLabelKeyDown,
        onMouseDown: ()=>{
            setIsKeyboardUsed(false);
        }
    };
    const legacyIconSize = $8b71259385cf6352$var$iconSizeMap[size];
    const labelId = (0, $gl2vi.useId)();
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("label", {
        ...controlProps,
        ref: wrapperRef,
        className: (0, $hcewu.default)([
            "_v564kete _1h6d3acm _1dqonqa1 _189eyh40 _1e0c1o8l _vchh18uv _kqswh2mm _1y1m1ntv _bfhk76s1 _syaz5w2r _6rthv77o _1pfhv77o _12l2v77o _ahbqv77o _85i5v77o _1q51v77o _y4tiv77o _bozgv77o _1i2uidpf _1i3tidpf _se28idpf _3tunidpf _1423idpf _1hrtidpf _1bz2idpf _rqfvidpf _1yc0glyw _onsr1snc _1vgmagmp _1av610yn _1ulhidpf _rfx31q5u _pdykkete _1cs8stnw _1rus5w2r _1kt9b3bt _1fkr1y44 _z5wt1y44 _7dwzglyw _1bki1y1w _1flt1y1w _3xv21y1w _9471g4a2 _ucab5w2r _mqf815t7 _3dj215t7 _1dl915t7 _1div5w2r _1il8kb7n _y54d5w2r _irr353wy _d0altlke _19ja13gf _8muf13gf _1k1q13gf _1plud4ly _1uo853wy _178c1y1w _16rslghj _ogf41r31 _1rtbnqa1 _5gg9t94y",
            isKeyboardUsed && "_jyzf194a _1r4mnqa1 _1t9pyh40",
            size === 'large' && !(0, $eGOwo.fg)('platform-visual-refresh-icons') && "_1n82gktf _19vpgktf",
            $8b71259385cf6352$var$sizeStyles[size]
        ]),
        children: [
            label ? /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                id: labelId,
                hidden: true,
                children: label
            }) : null,
            /*#__PURE__*/ (0, $gt9Am.jsx)("input", {
                ref: ref,
                checked: shouldChecked,
                disabled: isDisabled,
                id: id,
                name: name,
                onBlur: handleBlur,
                onChange: handleChange,
                onFocus: handleFocus,
                type: "checkbox",
                value: value,
                "data-testid": testId && `${testId}--input`,
                "aria-labelledby": label ? labelId : undefined,
                "aria-describedby": descriptionId
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hqCmO.default), {
                size: size,
                isHidden: !shouldChecked,
                position: "left",
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6XkOW))), {
                    label: "",
                    color: "currentColor",
                    LEGACY_size: legacyIconSize,
                    testId: testId && `${testId}--toggle-check-icon`,
                    size: "small"
                })
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hqCmO.default), {
                size: size,
                isHidden: shouldChecked,
                position: "right",
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($82pO9))), {
                    label: "",
                    color: "currentColor",
                    LEGACY_size: legacyIconSize,
                    testId: testId && `${testId}--toggle-cross-icon`,
                    size: "small"
                })
            })
        ]
    });
}));
$8b71259385cf6352$var$Toggle.displayName = 'Toggle';
var $8b71259385cf6352$export$2e2bcd8739ae039 = $8b71259385cf6352$var$Toggle;

});
parcelRegister("82pO9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a8221850e05ac929fb26618da6db4acc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5da2878f9cf22fc5$var$_react = $5da2878f9cf22fc5$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $5da2878f9cf22fc5$var$_close = $5da2878f9cf22fc5$var$_interopRequireDefault((parcelRequire("l0U1U")));

var $5da2878f9cf22fc5$var$_close2 = $5da2878f9cf22fc5$var$_interopRequireDefault((parcelRequire("6OLN4")));
function $5da2878f9cf22fc5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CloseIcon.
 * This component is CloseIcon, with `UNSAFE_fallbackIcon` set to "EditorCloseIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5da2878f9cf22fc5$var$CloseIcon = (props)=>/*#__PURE__*/ $5da2878f9cf22fc5$var$_react.default.createElement($5da2878f9cf22fc5$var$_close.default, Object.assign({
        LEGACY_fallbackIcon: $5da2878f9cf22fc5$var$_close2.default
    }, props));
$5da2878f9cf22fc5$var$CloseIcon.Name = 'CloseIconMigration';
var $5da2878f9cf22fc5$var$_default = module.exports.default = $5da2878f9cf22fc5$var$CloseIcon;

});

parcelRegister("hqCmO", function(module, exports) {

$parcel$export(module.exports, "default", () => $d938694e808b84dc$export$2e2bcd8739ae039);
/* icon-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6qaBj = parcelRequire("6qaBj");

var $eGOwo = parcelRequire("eGOwo");

var $8IeH1 = parcelRequire("8IeH1");
const $d938694e808b84dc$var$styles = {
    iconContainer: "_v5641hrg _1e0c116y _4cvr1h6o _1bah1h6o _kqswstnw _152tv77o",
    iconContainerRegular: "_1bsb7vkz _4t3i7vkz",
    iconContainerLarge: "_1bsbgktf _4t3igktf",
    hidden: "_tzy4idpf",
    left: "_1e021l7b",
    right: "_rjxp1l7b"
};
/**
 * __Icon container__
 *
 * Positions a toggle's check and close icons.
 */ const $d938694e808b84dc$var$IconContainer = ({ children: children, size: size, isHidden: isHidden, position: position })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        as: "span",
        xcss: (0, $6qaBj.cx)($d938694e808b84dc$var$styles.iconContainer, isHidden && (0, $eGOwo.fg)('platform-visual-refresh-icons') && $d938694e808b84dc$var$styles.hidden, size === 'regular' && $d938694e808b84dc$var$styles.iconContainerRegular, size === 'large' && $d938694e808b84dc$var$styles.iconContainerLarge, position === 'left' && $d938694e808b84dc$var$styles.left, position === 'right' && $d938694e808b84dc$var$styles.right),
        children: children
    });
};
var $d938694e808b84dc$export$2e2bcd8739ae039 = $d938694e808b84dc$var$IconContainer;

});


parcelRegister("c1cLY", function(module, exports) {

$parcel$export(module.exports, "useResizingHeight", () => $a255eaffd25937a1$export$da99457d6430d83);
$parcel$export(module.exports, "ResizingHeight", () => $a255eaffd25937a1$export$204d7b6d1491a2d3);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $kk5YU = parcelRequire("kk5YU");


var $34ZNB = parcelRequire("34ZNB");

var $gcrIE = parcelRequire("gcrIE");

var $grWPV = parcelRequire("grWPV");

var $5mfrv = parcelRequire("5mfrv");

var $lumgu = parcelRequire("lumgu");
const $a255eaffd25937a1$export$da99457d6430d83 = ({ duration: calcDuration = ()=>(0, $34ZNB.durations).medium, timingFunction: calcTimingFunction = ()=>(0, $eeb70e8c0a60dc66$export$c07234257a03d5e9) } = {})=>{
    const prevDimensions = (0, $eJOHy.useRef)();
    const [element, setElementRef] = (0, $grWPV.useElementRef)();
    // We cleanup on the next effect to prevent the previous timeout being called during
    // the next motion - as now the timeout has essentially been extended!
    const setTimeout = (0, $gcrIE.useSetTimeout)({
        cleanup: 'next-effect'
    });
    const requestAnimationFrame = (0, $gcrIE.useRequestAnimationFrame)();
    (0, $lumgu.useSnapshotBeforeUpdate)(()=>{
        if ((0, $kk5YU.isReducedMotion)() || !element) return;
        prevDimensions.current = element.getBoundingClientRect();
    });
    (0, $5mfrv.useLayoutEffect)(()=>{
        if ((0, $kk5YU.isReducedMotion)() || !element || !prevDimensions.current) return;
        // We might already be animating.
        // Because of that we need to expand to the destination height first.
        element.setAttribute('style', '');
        const nextDimensions = element.getBoundingClientRect();
        if (nextDimensions.height === prevDimensions.current.height) return;
        const duration = calcDuration(prevDimensions.current.height, nextDimensions.height);
        const newStyles = {
            height: `${prevDimensions.current.height}px`,
            willChange: 'height',
            transitionProperty: 'height',
            transitionDuration: `${duration}ms`,
            boxSizing: 'border-box',
            transitionTimingFunction: calcTimingFunction(prevDimensions.current.height, nextDimensions.height, duration)
        };
        Object.assign(element.style, newStyles);
        // We split this over two animation frames so the DOM has enough time to flush the changes.
        // We are deliberately not skipping this frame if another render happens - if we do the motion doesn't finish properly.
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!element) return;
                element.style.height = `${nextDimensions.height}px`;
                setTimeout(()=>{
                    if (!element) return;
                    element.setAttribute('style', '');
                }, duration);
            });
        });
    });
    return {
        ref: setElementRef
    };
};
const $a255eaffd25937a1$export$204d7b6d1491a2d3 = ({ children: children, ...props })=>{
    const resizing = $a255eaffd25937a1$export$da99457d6430d83(props);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Fragment), {
        children: children(resizing)
    });
};

});
const $eeb70e8c0a60dc66$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
const $eeb70e8c0a60dc66$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
const $eeb70e8c0a60dc66$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';
const $eeb70e8c0a60dc66$export$45db2fc2f15997e7 = 'cubic-bezier(0,0,1,1)';

parcelRegister("grWPV", function(module, exports) {

$parcel$export(module.exports, "useElementRef", () => $d3a4ee4e08936b24$export$ff879f35a69d56b7);

var $eJOHy = parcelRequire("eJOHy");
const $d3a4ee4e08936b24$export$ff879f35a69d56b7 = ()=>{
    const elementRef = (0, $eJOHy.useRef)(null);
    const setRef = (0, $eJOHy.useCallback)((ref)=>{
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};

});

parcelRegister("lumgu", function(module, exports) {

$parcel$export(module.exports, "useSnapshotBeforeUpdate", () => $6481a9a383669445$export$9e95200239cd148b);

var $eJOHy = parcelRequire("eJOHy");

var $5mfrv = parcelRequire("5mfrv");
const $6481a9a383669445$export$9e95200239cd148b = (cb)=>{
    const isFirstRender = (0, $eJOHy.useRef)(true);
    if (!isFirstRender.current) cb();
    (0, $5mfrv.useLayoutEffect)(()=>{
        isFirstRender.current = false;
    }, []);
};

});


parcelRegister("axgz1", function(module, exports) {

$parcel$export(module.exports, "PlatformClassificationTagAri", () => $7ab9d5af058b88c3$export$1810bec01081467);

var $aCzNg = parcelRequire("aCzNg");

var $3TJ9u = parcelRequire("3TJ9u");

var $cSeYX = parcelRequire("cSeYX");
// src/platform/classification-tag/manifest.ts
var $7ab9d5af058b88c3$var$platformClassificationTagAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $aCzNg.PlatformClassificationTagAriResourceOwner),
    resourceType: (0, $aCzNg.PlatformClassificationTagAriResourceType),
    resourceIdSlug: "{tagId}",
    resourceIdSegmentFormats: {
        tagId: /[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}/
    }
};
// src/platform/classification-tag/index.ts
var $7ab9d5af058b88c3$export$1810bec01081467 = class _PlatformClassificationTagAri extends (0, $3TJ9u.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._tagId = opts.resourceIdSegmentValues.tagId;
    }
    get tagId() {
        return this._tagId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $7ab9d5af058b88c3$var$platformClassificationTagAriStaticOpts.qualifier,
            platformQualifier: $7ab9d5af058b88c3$var$platformClassificationTagAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $7ab9d5af058b88c3$var$platformClassificationTagAriStaticOpts.resourceOwner,
            resourceType: $7ab9d5af058b88c3$var$platformClassificationTagAriStaticOpts.resourceType,
            resourceId: `${opts.tagId}`,
            resourceIdSegmentValues: {
                tagId: opts.tagId
            }
        }, ariOpts = (0, $cSeYX.AriParser).fromOpts(derivedOpts, $7ab9d5af058b88c3$var$platformClassificationTagAriStaticOpts);
        return new _PlatformClassificationTagAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $cSeYX.AriParser).fromString(maybeAri, $7ab9d5af058b88c3$var$platformClassificationTagAriStaticOpts);
        return new _PlatformClassificationTagAri(opts);
    }
    getVariables() {
        return {
            tagId: this.tagId
        };
    }
};

});
parcelRegister("aCzNg", function(module, exports) {

$parcel$export(module.exports, "PlatformClassificationTagAriResourceOwner", () => $7bb937d3d50d9013$export$ee6dbd2071d3ea9f);
$parcel$export(module.exports, "PlatformClassificationTagAriResourceType", () => $7bb937d3d50d9013$export$8a038be1370dff6c);
// src/platform/classification-tag/types.ts
var $7bb937d3d50d9013$export$ee6dbd2071d3ea9f = "platform", $7bb937d3d50d9013$export$8a038be1370dff6c = "classification-tag";

});


parcelRegister("2fNLP", function(module, exports) {

$parcel$export(module.exports, "getBoardId", () => $87bb57fd652d51da$export$557c2f222778cea6);
$parcel$export(module.exports, "default", () => $87bb57fd652d51da$export$2e2bcd8739ae039);

var $3Q6BV = parcelRequire("3Q6BV");

var $jkKE1 = parcelRequire("jkKE1");

var $8L5FN = parcelRequire("8L5FN");

var $6zxj7 = parcelRequire("6zxj7");

var $kgGWj = parcelRequire("kgGWj");
const $87bb57fd652d51da$var$projectScopeDataMap = {
    routes: [
        // Query string
        /[&?]projectKey=(\w+)/i,
        // Service desk, business and some software
        /\/projects\/(\w+)/i,
        // Issue page (not root)
        /\/browse\/(\w+)-\d+\??((?!(filter=|jql=)).)*$/i,
        // Project settings
        /\/plugins\/servlet\/project-config\/(\w+)/i,
        // Service Desk project settings
        /\/servicedesk\/admin\/(\w+)/i,
        // Browse project
        /\/browse\/(\w+)\/?(\?.*)?$/i
    ],
    meta: [
        // Software
        'ghx-project-key',
        // Settings
        'projectKey',
        // Reports
        'ajs-project-key'
    ]
};
const $87bb57fd652d51da$var$getProjectId = (url)=>{
    const projectIdRoutes = [
        // Query string - reports
        /[&?]selectedProjectId=(\w+)/i,
        // Query string - edit project, delete project
        /[&?]pid=(\w+)/i,
        // Query string - release notes
        /[&?]projectId=(\w+)/i,
        // Query string - connect items
        /[&?]project\.id=(\w+)/i
    ];
    return projectIdRoutes.reduce((foundId, route)=>{
        if (foundId) return foundId;
        const match = url.match(route);
        if (match != null) {
            const [, projectId] = match;
            if (projectId) return projectId;
        }
        return null;
    }, null);
};
/**
 * Extracts certain data out of the URL that is required by other data providers.
 */ const $87bb57fd652d51da$var$getProjectKey = (url, getMeta)=>{
    let projectKey = null;
    $87bb57fd652d51da$var$projectScopeDataMap.meta.forEach((tagName)=>{
        const value = getMeta(tagName);
        if (value && projectKey == null) projectKey = value;
    });
    $87bb57fd652d51da$var$projectScopeDataMap.routes.forEach((route)=>{
        const match = url.match(route);
        if (match != null && projectKey == null) [, projectKey] = match;
    });
    return projectKey || undefined;
};
const $87bb57fd652d51da$export$557c2f222778cea6 = (url)=>{
    try {
        const parsed = (0, (/*@__PURE__*/$parcel$interopDefault($3Q6BV)))(url, true);
        let boardId = parsed.query ? parsed.query.rapidView : null;
        if (boardId == null) {
            const match = url.match(/\/boards\/(\d+)/i);
            boardId = match ? match[1] : null;
        }
        return boardId;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        return null;
    }
};
const $87bb57fd652d51da$var$isProjectSettingsConnectRoute = ({ getMeta: getMeta, url: url })=>getMeta('ajs-in-admin-mode') === 'true' && (0, $8L5FN.default).some((regex)=>regex.test(url)) || (0, $6zxj7.default).some((regex)=>regex.test(url));
const $87bb57fd652d51da$var$isProjectPage = ({ getMeta: getMeta, projectId: projectId, projectKey: projectKey, url: url })=>{
    // Project routes that have a project id in the URL
    const isProject = ()=>{
        const routes = [
            /\/secure\/ConfigureReport(!default)?\.jspa.+selectedProjectId/i,
            /\/secure\/project\/(DeleteProject|EditProject)!default\.jspa.+pid/i,
            /\/secure\/ReleaseNote.jspa.+projectId/i,
            /\/secure\/ConfigureReleaseNote.jspa.+projectId/i
        ];
        return $87bb57fd652d51da$var$isProjectSettingsConnectRoute({
            getMeta: getMeta,
            url: url
        }) || routes.some((regex)=>regex.test(url));
    };
    return projectKey || projectId && isProject();
};
const $87bb57fd652d51da$var$isProjectSettingsPage = ({ getMeta: getMeta, url: url })=>(0, $kgGWj.default).some((route)=>url.match(route)) || $87bb57fd652d51da$var$isProjectSettingsConnectRoute({
        getMeta: getMeta,
        url: url
    });
const $87bb57fd652d51da$var$getProjectPageType = (getMeta, url)=>{
    if ($87bb57fd652d51da$var$isProjectSettingsPage({
        getMeta: getMeta,
        url: url
    })) return 'settings';
    const decorator = getMeta('decorator');
    const isSettings = getMeta('is-settings-page') === 'true';
    return decorator === 'admin' || decorator === 'atl.admin' || isSettings ? 'settings' : undefined;
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$87bb57fd652d51da$export$2e2bcd8739ae039 = (url, getMeta)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const extractedData = {};
    const boardId = $87bb57fd652d51da$export$557c2f222778cea6(url);
    if (boardId) extractedData.boardId = boardId;
    const projectKey = url.includes('/plugins/servlet/ac/') || url.includes('/settings/projects/') ? undefined : $87bb57fd652d51da$var$getProjectKey(url, getMeta);
    if (projectKey) extractedData.projectKey = projectKey;
    const projectId = $87bb57fd652d51da$var$getProjectId(url);
    if (projectId) extractedData.projectId = projectId;
    const isProject = $87bb57fd652d51da$var$isProjectPage({
        getMeta: getMeta,
        projectId: projectId,
        projectKey: projectKey,
        url: url
    });
    extractedData.pageType = isProject ? $87bb57fd652d51da$var$getProjectPageType(getMeta, url) : undefined;
    const identifier = (0, $jkKE1.getScopeIdentifier)({
        boardId: boardId,
        projectKey: projectKey,
        projectId: isProject ? projectId : null
    });
    // This gets around a flow inexact type error
    return {
        ...extractedData,
        ...identifier
    };
};

});
parcelRegister("8L5FN", function(module, exports) {

$parcel$export(module.exports, "default", () => $9991dc7a3b0c4326$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import/no-anonymous-default-export
var $9991dc7a3b0c4326$export$2e2bcd8739ae039 = [
    // Regex groups: addonKey, pageKey
    /\/plugins\/servlet\/ac\/(.+)\/([^?\s]+)/i
];

});

parcelRegister("6zxj7", function(module, exports) {

$parcel$export(module.exports, "default", () => $85420e92e692d947$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import/no-anonymous-default-export
var $85420e92e692d947$export$2e2bcd8739ae039 = [
    /\/plugins\/servlet\/ac\/com\.xpandit\.plugins\.jiraxporter\/jira-xporter-manage-project/i,
    /\/plugins\/servlet\/ac\/com\.xpandit\.plugins\.xray\/xray-project-settings-all/i
];

});

parcelRegister("kgGWj", function(module, exports) {

$parcel$export(module.exports, "default", () => $270dbf4ef727859d$export$2e2bcd8739ae039);

var $6zxj7 = parcelRequire("6zxj7");
const $270dbf4ef727859d$var$commonClassicProjectSettingsRoutes = [
    /\/plugins\/servlet\/project-config/i,
    /\/jira\/software\/c\/projects\/.+\/settings\/code/i,
    /\/jira\/software\/c\/projects\/.+\/settings\/deployments/i,
    /\/plugins\/servlet\/project-config\/.+\/administer-components/i,
    /\/plugins\/servlet\/project-config\/.+\/administer-versions/i,
    /\/plugins\/servlet\/project-config\/.+\/fields/i,
    /\/plugins\/servlet\/project-config\/.+\/issuesecurity/i,
    /\/plugins\/servlet\/project-config\/.+\/issuetypes/i,
    /\/plugins\/servlet\/project-config\/.+\/notifications/i,
    /\/plugins\/servlet\/project-config\/.+\/permissions/i,
    /\/plugins\/servlet\/project-config\/.+\/screens/i,
    /\/plugins\/servlet\/project-config\/.+\/workflows/i,
    /\/project\/DeleteProject!default\.jspa/i,
    /\/secure\/project\/EditProject!default\.jspa/i,
    // Collectors
    /\/secure\/AddCollector/i,
    /\/secure\/InsertCollectorHelp/i,
    /\/ViewCollector!default\.jspa\?projectKey=/i,
    /\/ViewCollectors!default\.jspa\?projectKey=/i,
    // Development tools
    /\/secure\/ConfigureDevStatus.jspa\?projectKey=/i,
    // Hipchat
    /\/InstallHipChat\.jspa\?projectKey=/i,
    /\/secure\/ConfigureHipChat\.jspa\?projectKey=(.+)/i,
    // Forge
    /\/jira\/software\/c\/projects\/.+\/settings\/apps\/([a-z0-9-]+)\/([a-z0-9-]+)(\/*)?/i
];
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$270dbf4ef727859d$export$2e2bcd8739ae039 = [
    ...$270dbf4ef727859d$var$commonClassicProjectSettingsRoutes,
    /\/plugins\/servlet\/project-config\/.+\/issuelayout/i,
    ...(0, $6zxj7.default),
    // Service Desk project settings
    /\/servicedesk\/admin\/(\w+)/i,
    // SPA settings
    /\/projects\/\w+\/settings(\/\w+)*/i
];

});


parcelRegister("li3DD", function(module, exports) {

$parcel$export(module.exports, "useCrossJoinThirdPartyNudgeExperiment", () => $95ff1fd22aec30f4$export$5baa0011155415c5);

var $eJOHy = parcelRequire("eJOHy");

var $gYnSx = parcelRequire("gYnSx");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $8q7lT = parcelRequire("8q7lT");

var $kEUB1 = parcelRequire("kEUB1");

var $b9nqM = parcelRequire("b9nqM");

var $figsJ = parcelRequire("figsJ");

var $1ZzKc = parcelRequire("1ZzKc");

var $1s1E2 = parcelRequire("1s1E2");

var $hCEys = parcelRequire("hCEys");

var $92u6n = parcelRequire("92u6n");

var $3OEPA = parcelRequire("3OEPA");

var $fZBVW = parcelRequire("fZBVW");

var $ll8sj = parcelRequire("ll8sj");

var $bxTED = parcelRequire("bxTED");
const $95ff1fd22aec30f4$var$MAX_FEATURE_VISIT_COUNT = 50;
const $95ff1fd22aec30f4$export$5baa0011155415c5 = ()=>{
    const cloudId = (0, $kEUB1.useCloudId)();
    const fireEligibilityChecked = (0, $1s1E2.useEligibilityChecked)();
    const getRequestCapabilities = (0, $fZBVW.useConfluenceRequestCapabilities)(cloudId);
    const isSite7DaysOlder = (0, $bxTED.useSiteEligibilityCheck)(cloudId);
    const getCollaborators = (0, $hCEys.useUsersFromCollaborationGraph)(cloudId);
    const sendThirdPartyNudge = (0, $ll8sj.usePostThirdPartyNudge)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const userId = (0, $8q7lT.useAccountId)() || '';
    const licensedProducts = (0, $b9nqM.useLicensedProducts)();
    const subProduct = (0, $figsJ.useSubProduct)();
    return (0, $eJOHy.useCallback)(()=>{
        const runExperiment = async ()=>{
            try {
                if (!licensedProducts.confluence) {
                    fireEligibilityChecked('NO_CONFLUENCE_LICENSE');
                    return;
                }
                if ((0, $1ZzKc.isFeatureVisited)()) return;
                if (await (0, $3OEPA.hasConfluenceAccess)(cloudId)) {
                    fireEligibilityChecked('ALREADY_HAVE_ACCESS');
                    return;
                }
                const requestCapability = await getRequestCapabilities();
                if (!(requestCapability === 'DIRECT_ACCESS' || requestCapability === 'REQUEST_ACCESS')) {
                    fireEligibilityChecked('NOT_ELIGIBLE_FOR_REQUEST_ACCESS');
                    return;
                }
                if (!await isSite7DaysOlder()) {
                    fireEligibilityChecked('NEW_SITE_LESS_THAN_7_DAYS_OLD');
                    return;
                }
                const collaborators = await getCollaborators();
                const confluenceUsers = await (0, $92u6n.getConfluenceUsers)(collaborators, cloudId);
                if (confluenceUsers.length === 0) {
                    fireEligibilityChecked('COLLABORATORS_HAVE_NO_ACCESS');
                    return;
                }
                const featureVisitedCount = await (0, $1ZzKc.getFeatureVisitedCount)(userId);
                if (featureVisitedCount >= $95ff1fd22aec30f4$var$MAX_FEATURE_VISIT_COUNT) return;
                // fire manual exposure as it passed all common eligibility checks
                fireEligibilityChecked('ELIGIBLE');
                // send nudge to Pi Gateway service
                sendThirdPartyNudge(featureVisitedCount, subProduct, confluenceUsers, requestCapability);
                (0, $1ZzKc.increaseFeatureVisitedCount)(userId, featureVisitedCount + 1);
                (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), 'slo.crossJoinThirdPartyNudgesConfluence succeeded');
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $gYnSx.default)({
                    meta: {
                        id: 'useCrossJoinThirdPartyNudgesExperiment',
                        packageName: 'jiraCrossJoinThirdPartyNudges'
                    },
                    attributes: {
                        cloudId: cloudId
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        };
        runExperiment();
    }, [
        cloudId,
        createAnalyticsEvent,
        fireEligibilityChecked,
        getCollaborators,
        sendThirdPartyNudge,
        getRequestCapabilities,
        isSite7DaysOlder,
        userId,
        licensedProducts.confluence,
        subProduct
    ]);
};

});
parcelRegister("1ZzKc", function(module, exports) {

$parcel$export(module.exports, "isFeatureVisited", () => $51a12337e6082c9c$export$262c003deb93a450);
$parcel$export(module.exports, "getFeatureVisitedCount", () => $51a12337e6082c9c$export$64c6861c3bbd89a2);
$parcel$export(module.exports, "increaseFeatureVisitedCount", () => $51a12337e6082c9c$export$41554dcbb74e65ef);

var $dnU6V = parcelRequire("dnU6V");

var $gYnSx = parcelRequire("gYnSx");

var $gytMr = parcelRequire("gytMr");
const $51a12337e6082c9c$var$CROSS_JOIN_THIRD_PARTY_NUDGES_JIRA_VISITED_KEY = 'cross.join.third.party.nudges.jira.visited';
const $51a12337e6082c9c$var$SNOOZE_DAYS_FOR_7_DAYS = 7;
const $51a12337e6082c9c$var$ONE_DAY_IN_MILLISECONDS = 86400000;
const $51a12337e6082c9c$var$crossJoinThirdPartyNudgeVisitedCache = (0, $dnU6V.createLocalStorageProvider)('cross-join-third-party-nudges-visited');
const $51a12337e6082c9c$var$VISITED_COUNT_KEY = 'CROSS_JOIN_THIRD_PARTY_NUDGES_JIRA_VISITED_COUNT';
const $51a12337e6082c9c$export$262c003deb93a450 = ()=>{
    try {
        if ($51a12337e6082c9c$var$getFeatureVisited()) return true;
        $51a12337e6082c9c$export$7a91674e4b755c4b();
        if (!$51a12337e6082c9c$var$getFeatureVisited()) {
            (0, $gYnSx.default)({
                meta: {
                    id: 'featureVisitedLocalStorageNotAvailabe',
                    packageName: 'jiraCrossJoinThirdPartyNudges'
                }
            });
            return true;
        }
        return false;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gYnSx.default)({
            meta: {
                id: 'useFeatureVisited',
                packageName: 'jiraCrossThirdPartyJoinNudges'
            },
            error: error,
            skipSentry: true,
            sendToPrivacyUnsafeSplunk: true
        });
        return true;
    }
};
const $51a12337e6082c9c$var$getFeatureVisited = (key = $51a12337e6082c9c$var$CROSS_JOIN_THIRD_PARTY_NUDGES_JIRA_VISITED_KEY)=>{
    const snoozeUntilTimestampString = $51a12337e6082c9c$var$crossJoinThirdPartyNudgeVisitedCache.get(key);
    if (snoozeUntilTimestampString !== null) {
        const SNOOZE_UNTIL_TIMESTAMP = parseInt(snoozeUntilTimestampString, 10);
        const TIMESTAMP = new Date().getTime();
        if (!Number.isNaN(SNOOZE_UNTIL_TIMESTAMP) && TIMESTAMP < SNOOZE_UNTIL_TIMESTAMP) return true;
    }
    return false;
};
const $51a12337e6082c9c$var$setFeatureVisited = (numOfDaysSnoozed, key = $51a12337e6082c9c$var$CROSS_JOIN_THIRD_PARTY_NUDGES_JIRA_VISITED_KEY)=>{
    const SNOOZE_UNTIL_TIMESTAMP = new Date().getTime() + $51a12337e6082c9c$var$ONE_DAY_IN_MILLISECONDS * numOfDaysSnoozed;
    $51a12337e6082c9c$var$crossJoinThirdPartyNudgeVisitedCache.set(key, SNOOZE_UNTIL_TIMESTAMP);
};
const $51a12337e6082c9c$export$7a91674e4b755c4b = (key = $51a12337e6082c9c$var$CROSS_JOIN_THIRD_PARTY_NUDGES_JIRA_VISITED_KEY)=>{
    $51a12337e6082c9c$var$setFeatureVisited($51a12337e6082c9c$var$SNOOZE_DAYS_FOR_7_DAYS, key);
};
const $51a12337e6082c9c$export$64c6861c3bbd89a2 = async (accountId, propertyKey = $51a12337e6082c9c$var$VISITED_COUNT_KEY)=>{
    if (!accountId) return 0;
    const visitedCount = await (0, $gytMr.getUserProperty)({
        accountId: accountId,
        propertyKey: propertyKey,
        defaultValue: 0
    });
    return !Number.isNaN(visitedCount.value) ? visitedCount.value : 0;
};
const $51a12337e6082c9c$export$41554dcbb74e65ef = async (accountId, incrementedCount, propertyKey = $51a12337e6082c9c$var$VISITED_COUNT_KEY)=>{
    await (0, $gytMr.setUserProperty)({
        accountId: accountId,
        propertyKey: propertyKey,
        propertyValue: incrementedCount
    });
};

});
parcelRegister("gytMr", function(module, exports) {

$parcel$export(module.exports, "getUserProperty", () => $62581f846b4c1171$export$b3126db2ef6e34ed);
$parcel$export(module.exports, "setUserProperty", () => $62581f846b4c1171$export$ba821ce5e177c7ef);

var $gYnSx = parcelRequire("gYnSx");

var $jGzN3 = parcelRequire("jGzN3");
const $62581f846b4c1171$var$getUserUrl = (accountId, propertyKey)=>`/rest/api/3/user/properties/${propertyKey}?accountId=${accountId}`;
const $62581f846b4c1171$export$b3126db2ef6e34ed = async ({ accountId: accountId, propertyKey: propertyKey, defaultValue: defaultValue })=>{
    const url = $62581f846b4c1171$var$getUserUrl(accountId, propertyKey);
    try {
        const response = await (0, $jGzN3.performGetRequest)(url);
        return response;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        return {
            key: propertyKey,
            value: defaultValue
        };
    }
};
const $62581f846b4c1171$export$ba821ce5e177c7ef = async ({ accountId: accountId, propertyKey: propertyKey, propertyValue: propertyValue })=>{
    const url = $62581f846b4c1171$var$getUserUrl(accountId, propertyKey);
    try {
        await (0, $jGzN3.performPutRequest)(url, {
            body: JSON.stringify(propertyValue)
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gYnSx.default)({
            meta: {
                id: `SET_${propertyKey}`,
                packageName: 'jiraCrossJoinThirdPartyNudges'
            },
            error: error
        });
    }
};

});


parcelRegister("1s1E2", function(module, exports) {

$parcel$export(module.exports, "useEligibilityChecked", () => $d0ccfc268348c3a3$export$a751f0afaa9baa4);

var $eJOHy = parcelRequire("eJOHy");

var $gYnSx = parcelRequire("gYnSx");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");
const $d0ccfc268348c3a3$export$a751f0afaa9baa4 = ()=>{
    const flagKey = 'cross-join-third-party-nudges';
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    return (0, $eJOHy.useCallback)((ineligibilityReason)=>{
        try {
            (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'eligibility checked', {
                flagKey: flagKey,
                ineligibilityReason: ineligibilityReason,
                source: 'jira-cross-join-third-party-nudges'
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $gYnSx.default)({
                meta: {
                    id: 'useFeatureExposed',
                    packageName: 'jiraCrossJoinThirdPartyNudges'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    }, [
        createAnalyticsEvent,
        flagKey
    ]);
};

});

parcelRegister("hCEys", function(module, exports) {

$parcel$export(module.exports, "useUsersFromCollaborationGraph", () => $01bba618046f4e96$export$b05786e1a14be004);

var $eJOHy = parcelRequire("eJOHy");

var $gYnSx = parcelRequire("gYnSx");

var $jGzN3 = parcelRequire("jGzN3");

var $8q7lT = parcelRequire("8q7lT");
const $01bba618046f4e96$var$COLLABORATION_GRAPH_MAX_RESULTS = 50;
const $01bba618046f4e96$export$b05786e1a14be004 = (cloudId)=>{
    const atlassianAccountId = (0, $8q7lT.useAccountId)();
    return (0, $eJOHy.useCallback)(async ()=>{
        try {
            const payload = {
                context: {
                    contextType: 'crossJoinThirdPartyNudges',
                    principalId: atlassianAccountId,
                    siteId: cloudId
                },
                modelRequestParams: {
                    experience: 'CgUserNearbyUser'
                },
                expanded: true,
                maxNumberOfResults: $01bba618046f4e96$var$COLLABORATION_GRAPH_MAX_RESULTS,
                userId: atlassianAccountId
            };
            const options = {
                body: JSON.stringify(payload)
            };
            return (0, $jGzN3.performPostRequest)('/gateway/api/collaboration/v1/collaborationgraph/user/user', options).then((entities)=>entities.collaborationGraphEntities.filter((en)=>en.userProfile !== undefined).map((en)=>({
                        id: en.userProfile.account_id,
                        name: en.userProfile.name,
                        avatar: en.userProfile.picture
                    })));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $gYnSx.default)({
                meta: {
                    id: 'useUsersFromCollaborationGraph',
                    packageName: 'jiraCrossJoinThirdPartyNudges'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw new Error('Get collaborators error');
        }
    }, [
        atlassianAccountId,
        cloudId
    ]);
};

});

parcelRegister("92u6n", function(module, exports) {

$parcel$export(module.exports, "getConfluenceUsers", () => $f34eb1d311442171$export$71bcfe5bb11155f7);

var $gYnSx = parcelRequire("gYnSx");

var $1Ozm9 = parcelRequire("1Ozm9");
const $f34eb1d311442171$var$URL = '/gateway/api/growth/cross-join-third-party-nudges/get-permitted-users';
const $f34eb1d311442171$export$71bcfe5bb11155f7 = async (collaborators, cloudId)=>{
    try {
        const accountIds = collaborators.map((c)=>c.id);
        const confluenceUsers = await (0, $1Ozm9.default)($f34eb1d311442171$var$URL, {
            method: 'POST',
            body: JSON.stringify({
                cloudId: cloudId,
                accountIds: accountIds,
                product: 'confluence'
            })
        });
        return collaborators.filter((c)=>confluenceUsers.includes(c.id));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gYnSx.default)({
            meta: {
                id: 'getConfluenceUsers',
                packageName: 'jiraCrossJoinThirdPartyNudges'
            },
            attributes: {
                cloudId: cloudId,
                accountIds: JSON.stringify(collaborators.map((c)=>c.id)),
                errorResponse: $f34eb1d311442171$var$getErrorResponse(error)
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw new Error('Get Confluence users error');
    }
};
const $f34eb1d311442171$var$getErrorResponse = (error)=>{
    try {
        return JSON.stringify(error);
    } catch (e) {
        // Swallow error as the error is already in the analytic event.
        return undefined;
    }
};

});

parcelRegister("3OEPA", function(module, exports) {

$parcel$export(module.exports, "hasConfluenceAccess", () => $2055198bf71b9d10$export$cf2bb135927e1e46);

var $gYnSx = parcelRequire("gYnSx");

var $1Ozm9 = parcelRequire("1Ozm9");
const $2055198bf71b9d10$var$URL = '/gateway/api/permissions/permitted';
const $2055198bf71b9d10$export$cf2bb135927e1e46 = async (cloudId)=>{
    try {
        return $2055198bf71b9d10$var$fetchConfluenceAccess(cloudId);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gYnSx.default)({
            meta: {
                id: 'hasConfluenceAccess',
                packageName: 'jiraCrossJoinThirdPartyNudges'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw new Error('Confluence permission check error');
    }
};
const $2055198bf71b9d10$var$fetchConfluenceAccess = async (cloudId)=>{
    const data = {
        permissionId: 'write',
        resourceId: `ari:cloud:confluence::site/${cloudId}`
    };
    const response = await (0, $1Ozm9.default)($2055198bf71b9d10$var$URL, {
        method: 'POST',
        body: JSON.stringify(data)
    });
    return response.permitted;
};

});

parcelRegister("fZBVW", function(module, exports) {

$parcel$export(module.exports, "useConfluenceRequestCapabilities", () => $052de4c55d9d9817$export$e36a00c72925e95e);

var $eJOHy = parcelRequire("eJOHy");

var $gYnSx = parcelRequire("gYnSx");

var $1Ozm9 = parcelRequire("1Ozm9");
const $052de4c55d9d9817$export$e36a00c72925e95e = (cloudId)=>{
    const resource = `ari:cloud:confluence::site/${cloudId}`;
    return (0, $eJOHy.useCallback)(async ()=>{
        try {
            return $052de4c55d9d9817$var$fetchConfluenceRACapability(resource);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $gYnSx.default)({
                meta: {
                    id: 'useConfluenceRequestCapabilitiesCheck',
                    packageName: 'jiraCrossJoinThirdPartyNudges'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw new Error('Get request capabilities error');
        }
    }, [
        resource
    ]);
};
const $052de4c55d9d9817$var$fetchConfluenceRACapability = async (resource)=>{
    const URL = $052de4c55d9d9817$var$getConfluenceRequestCapabilitiesUrl(resource);
    const response = await (0, $1Ozm9.default)(URL, {
        credentials: 'include'
    });
    const requestCapabilities = response.results[resource];
    return requestCapabilities;
};
const $052de4c55d9d9817$var$getConfluenceRequestCapabilitiesUrl = (resource)=>{
    const params = new URLSearchParams({
        resource: resource
    });
    return `/gateway/api/invitations/v1/access-requests/capabilities?${params.toString()}`;
};

});

parcelRegister("ll8sj", function(module, exports) {

$parcel$export(module.exports, "usePostThirdPartyNudge", () => $338054022f10443f$export$f06f6b49b8907feb);

var $eJOHy = parcelRequire("eJOHy");

var $gYnSx = parcelRequire("gYnSx");

var $jGzN3 = parcelRequire("jGzN3");
const $338054022f10443f$export$f06f6b49b8907feb = ()=>{
    return (0, $eJOHy.useCallback)(async (featureVisitedCount, subProduct, collaboratorsWithConfluenceAccess, accessCapability)=>{
        try {
            const options = {
                body: JSON.stringify({
                    featureVisitedCount: featureVisitedCount,
                    subProduct: subProduct,
                    collaborators: collaboratorsWithConfluenceAccess.map((c)=>c.id),
                    accessCapability: accessCapability
                })
            };
            return (0, $jGzN3.performPostRequest)('/gateway/api/pi-gateway/webhooks/frontend/jira/cross-join-third-party-nudge', options);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $gYnSx.default)({
                meta: {
                    id: 'usePostThirdPartyNudge',
                    packageName: 'jiraCrossJoinThirdPartyNudges'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw new Error('Post third party nudge error');
        }
    }, []);
};

});

parcelRegister("bxTED", function(module, exports) {

$parcel$export(module.exports, "useSiteEligibilityCheck", () => $dccf5deaad7e70c3$export$6d7dfd5017341421);

var $eJOHy = parcelRequire("eJOHy");

var $gYnSx = parcelRequire("gYnSx");

var $lctcw = parcelRequire("lctcw");
const $dccf5deaad7e70c3$export$79555f8f9058b0b6 = 'confluence.ondemand.activationDate';
const $dccf5deaad7e70c3$export$6d7dfd5017341421 = (cloudId)=>(0, $eJOHy.useCallback)(async ()=>{
        try {
            const siteTraits = await (0, $lctcw.memoizedFetchSitePersonalization)({
                cloudId: cloudId
            });
            return $dccf5deaad7e70c3$var$isSite7DaysOlder(siteTraits);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $gYnSx.default)({
                meta: {
                    id: 'useSiteEligibilityCheck',
                    packageName: 'jiraCrossJoinThirdPartyNudges'
                },
                attributes: {
                    cloudId: cloudId,
                    errorResponse: JSON.stringify(error)
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw new Error('Site eligibility check error');
        }
    }, [
        cloudId
    ]);
const $dccf5deaad7e70c3$var$isSite7DaysOlder = (traits)=>{
    const confluenceActivation = traits.find((trait)=>trait.name === $dccf5deaad7e70c3$export$79555f8f9058b0b6);
    if (confluenceActivation?.value) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const oneWeekLaterActivation = new Date(confluenceActivation?.value);
        oneWeekLaterActivation.setDate(oneWeekLaterActivation.getDate() + 7);
        const today = new Date();
        return today >= oneWeekLaterActivation;
    }
    return false;
};

});


parcelRegister("1F8hV", function(module, exports) {

$parcel$export(module.exports, "useHasFinishedLoading", () => $be5658d51a840eee$export$282f17c8d715e155);
$parcel$export(module.exports, "useShouldLoad", () => $be5658d51a840eee$export$10b49abde6eddf71);
$parcel$export(module.exports, "useUiModificationsEnabledStatus", () => $be5658d51a840eee$export$408eb757ebd7e139);

var $gRw8I = parcelRequire("gRw8I");

var $iJq0l = parcelRequire("iJq0l");

var $i7n3g = parcelRequire("i7n3g");
const $be5658d51a840eee$export$282f17c8d715e155 = (0, $iJq0l.createStateHook)((0, $i7n3g.store), {
    selector: (state)=>state.hasFinishedLoading
});
const $be5658d51a840eee$export$10b49abde6eddf71 = (0, $iJq0l.createStateHook)((0, $i7n3g.store), {
    selector: (state)=>state.shouldUiModificationsLoad
});
const $be5658d51a840eee$export$408eb757ebd7e139 = (hasForgeFinishedLoading)=>{
    (0, $gRw8I.di)($be5658d51a840eee$export$10b49abde6eddf71, $be5658d51a840eee$export$282f17c8d715e155, (0, $i7n3g.useAdjustmentsEnabled));
    const shouldUiModificationsLoad = $be5658d51a840eee$export$10b49abde6eddf71();
    const hasFinishedLoading = $be5658d51a840eee$export$282f17c8d715e155();
    const adjustmentsAreEnabled = (0, $i7n3g.useAdjustmentsEnabled)();
    const uimIsEnabled = hasForgeFinishedLoading && shouldUiModificationsLoad === 'yes' && hasFinishedLoading && adjustmentsAreEnabled;
    const uimIsDisabled = hasForgeFinishedLoading && (shouldUiModificationsLoad === 'no' || hasFinishedLoading && !adjustmentsAreEnabled);
    if (uimIsEnabled) return 'enabled';
    if (uimIsDisabled) return 'disabled';
    return 'unknown';
};

});

parcelRegister("17nxE", function(module, exports) {

$parcel$export(module.exports, "LinkedAlertsField", () => $9b6f10d4c42fefb6$export$9fb52de2628d6fe0);

var $eJOHy = parcelRequire("eJOHy");

var $3w8oL = parcelRequire("3w8oL");

var $h47gY = parcelRequire("h47gY");

var $lGaCn = parcelRequire("lGaCn");

var $fE4zR = parcelRequire("fE4zR");

var $ch9En = parcelRequire("ch9En");

var $3NYni = parcelRequire("3NYni");
const $9b6f10d4c42fefb6$export$9fb52de2628d6fe0 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
        id: "issue.fields.linked-alerts",
        packageName: "AsyncLinkedAlertsField"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3w8oL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fE4zR.FieldContainer), {
        "data-testid": "issue-field-linked-alerts.field-container",
        width: "100%"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "linked-alerts-field",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lGaCn.FieldLoader), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3NYni.AsyncLinkedAlertsField), props)))));

});
parcelRegister("3w8oL", function(module, exports) {

$parcel$export(module.exports, "default", () => $4eba8940d92fa35b$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $aKcBs = parcelRequire("aKcBs");

var $2tftR = parcelRequire("2tftR");

var $hZbN7 = parcelRequire("hZbN7");
/**
 * Wrapper should live on the root level since it uses glocal scoped container.
 */ const $4eba8940d92fa35b$var$ResponderNamesWrapper = ({ scope: scope, isGlobal: isGlobal = true, children: children })=>{
    const flagApi = (0, $2tftR.default)();
    const intl = (0, $lRq8t.default)();
    const defaultCatch = (0, $aKcBs.useDefaultCatch)();
    if (scope) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hZbN7.ResponderNamesContainer), {
        flagApi: flagApi,
        intlApi: intl,
        scope: scope,
        defaultCatch: defaultCatch,
        displayName: "ResponderNamesWrapper",
        children: children
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $hZbN7.ResponderNamesContainer), {
        flagApi: flagApi,
        intlApi: intl,
        isGlobal: isGlobal,
        defaultCatch: defaultCatch,
        displayName: "ResponderNamesWrapper",
        children: children
    });
};
var $4eba8940d92fa35b$export$2e2bcd8739ae039 = $4eba8940d92fa35b$var$ResponderNamesWrapper;

});
parcelRegister("aKcBs", function(module, exports) {

$parcel$export(module.exports, "useDefaultCatch", () => $78eaf87ddcd8ff46$export$3ab31fcc1d7c2589);

var $eJOHy = parcelRequire("eJOHy");

var $hEkDY = parcelRequire("hEkDY");

var $fAiM2 = parcelRequire("fAiM2");
var $1boDC = parcelRequire("1boDC");
var $lLN4k = parcelRequire("lLN4k");
function $78eaf87ddcd8ff46$export$3ab31fcc1d7c2589() {
    const reportError = (0, $lLN4k.useReportError)();
    const [error, setError] = (0, $eJOHy.useState)();
    if (error) throw error;
    return (0, $eJOHy.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($hEkDY)))(({ id: id, httpErrorHandler: httpErrorHandler, reporter: customReporter, attributes: attributes }, error)=>{
            if (!(0, $1boDC.isNetworkError)(error)) return setError(new (0, $fAiM2.EocError)(id, error));
            if (customReporter !== null) {
                const reporter = customReporter ?? reportError;
                reporter(id, error, attributes);
            }
            try {
                return httpErrorHandler?.(error);
            } catch (handlerError) {
                if (!(0, $1boDC.isNetworkError)(handlerError)) setError(new (0, $fAiM2.EocError)(id, handlerError));
                throw handlerError;
            }
        }), [
        reportError
    ]);
}

});
parcelRegister("hEkDY", function(module, exports) {

var $ghJ3B = parcelRequire("ghJ3B");

var $4ZFCt = parcelRequire("4ZFCt");
/**
 * Returns a curried equivalent of the provided function. The curried function
 * has two unusual capabilities. First, its arguments needn't be provided one
 * at a time. If `f` is a ternary function and `g` is `R.curry(f)`, the
 * following are equivalent:
 *
 *   - `g(1)(2)(3)`
 *   - `g(1)(2, 3)`
 *   - `g(1, 2)(3)`
 *   - `g(1, 2, 3)`
 *
 * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
 * "gaps", allowing partial application of any combination of arguments,
 * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
 * the following are equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * Please note that default parameters don't count towards a [function arity](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/length)
 * and therefore `curry` won't work well with those:
 *
 * ```
 * const h = R.curry((a, b, c = 2) => a + b + c);
 *
 * h(40);
 * //=> function (waits for `b`)
 *
 * h(39)(1);
 * //=> 42
 *
 * h(1)(2, 3);
 * //=> 6
 *
 * h(1)(2)(7);
 * //=> Error! (`3` is not a function!)
 * ```
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (* -> a) -> (* -> a)
 * @param {Function} fn The function to curry.
 * @return {Function} A new, curried function.
 * @see R.curryN, R.partial
 * @example
 *
 *      const addFourNumbers = (a, b, c, d) => a + b + c + d;
 *
 *      const curriedAddFourNumbers = R.curry(addFourNumbers);
 *      const f = curriedAddFourNumbers(1, 2);
 *      const g = f(3);
 *      g(4); //=> 10
 */ var $cd962f826a46f81b$var$curry = /*#__PURE__*/ $ghJ3B(function curry(fn) {
    return $4ZFCt(fn.length, fn);
});
module.exports = $cd962f826a46f81b$var$curry;

});
parcelRegister("ghJ3B", function(module, exports) {

var $dZfWl = parcelRequire("dZfWl");
/**
 * Optimized internal one-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */ function $bdb12f49a22475c2$var$_curry1(fn) {
    return function f1(a) {
        if (arguments.length === 0 || $dZfWl(a)) return f1;
        else return fn.apply(this, arguments);
    };
}
module.exports = $bdb12f49a22475c2$var$_curry1;

});
parcelRegister("dZfWl", function(module, exports) {
function $a2ed5639eb68da02$var$_isPlaceholder(a) {
    return a != null && typeof a === 'object' && a['@@functional/placeholder'] === true;
}
module.exports = $a2ed5639eb68da02$var$_isPlaceholder;

});


parcelRegister("4ZFCt", function(module, exports) {

var $dAtQ5 = parcelRequire("dAtQ5");

var $ghJ3B = parcelRequire("ghJ3B");

var $lWEor = parcelRequire("lWEor");

var $gUT7N = parcelRequire("gUT7N");
/**
 * Returns a curried equivalent of the provided function, with the specified
 * arity. The curried function has two unusual capabilities. First, its
 * arguments needn't be provided one at a time. If `g` is `R.curryN(3, f)`, the
 * following are equivalent:
 *
 *   - `g(1)(2)(3)`
 *   - `g(1)(2, 3)`
 *   - `g(1, 2)(3)`
 *   - `g(1, 2, 3)`
 *
 * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
 * "gaps", allowing partial application of any combination of arguments,
 * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
 * the following are equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @func
 * @memberOf R
 * @since v0.5.0
 * @category Function
 * @sig Number -> (* -> a) -> (* -> a)
 * @param {Number} length The arity for the returned function.
 * @param {Function} fn The function to curry.
 * @return {Function} A new, curried function.
 * @see R.curry
 * @example
 *
 *      const sumArgs = (...args) => R.sum(args);
 *
 *      const curriedAddFourNumbers = R.curryN(4, sumArgs);
 *      const f = curriedAddFourNumbers(1, 2);
 *      const g = f(3);
 *      g(4); //=> 10
 */ var $3a2d24b66e3df6c2$var$curryN = /*#__PURE__*/ $lWEor(function curryN(length, fn) {
    if (length === 1) return $ghJ3B(fn);
    return $dAtQ5(length, $gUT7N(length, [], fn));
});
module.exports = $3a2d24b66e3df6c2$var$curryN;

});
parcelRegister("dAtQ5", function(module, exports) {
function $9e45c89216ef7229$var$_arity(n, fn) {
    /* eslint-disable no-unused-vars */ switch(n){
        case 0:
            return function() {
                return fn.apply(this, arguments);
            };
        case 1:
            return function(a0) {
                return fn.apply(this, arguments);
            };
        case 2:
            return function(a0, a1) {
                return fn.apply(this, arguments);
            };
        case 3:
            return function(a0, a1, a2) {
                return fn.apply(this, arguments);
            };
        case 4:
            return function(a0, a1, a2, a3) {
                return fn.apply(this, arguments);
            };
        case 5:
            return function(a0, a1, a2, a3, a4) {
                return fn.apply(this, arguments);
            };
        case 6:
            return function(a0, a1, a2, a3, a4, a5) {
                return fn.apply(this, arguments);
            };
        case 7:
            return function(a0, a1, a2, a3, a4, a5, a6) {
                return fn.apply(this, arguments);
            };
        case 8:
            return function(a0, a1, a2, a3, a4, a5, a6, a7) {
                return fn.apply(this, arguments);
            };
        case 9:
            return function(a0, a1, a2, a3, a4, a5, a6, a7, a8) {
                return fn.apply(this, arguments);
            };
        case 10:
            return function(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
                return fn.apply(this, arguments);
            };
        default:
            throw new Error('First argument to _arity must be a non-negative integer no greater than ten');
    }
}
module.exports = $9e45c89216ef7229$var$_arity;

});

parcelRegister("lWEor", function(module, exports) {

var $ghJ3B = parcelRequire("ghJ3B");

var $dZfWl = parcelRequire("dZfWl");
/**
 * Optimized internal two-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */ function $ff9e58fcc7343a97$var$_curry2(fn) {
    return function f2(a, b) {
        switch(arguments.length){
            case 0:
                return f2;
            case 1:
                return $dZfWl(a) ? f2 : $ghJ3B(function(_b) {
                    return fn(a, _b);
                });
            default:
                return $dZfWl(a) && $dZfWl(b) ? f2 : $dZfWl(a) ? $ghJ3B(function(_a) {
                    return fn(_a, b);
                }) : $dZfWl(b) ? $ghJ3B(function(_b) {
                    return fn(a, _b);
                }) : fn(a, b);
        }
    };
}
module.exports = $ff9e58fcc7343a97$var$_curry2;

});

parcelRegister("gUT7N", function(module, exports) {

var $dAtQ5 = parcelRequire("dAtQ5");

var $dZfWl = parcelRequire("dZfWl");
/**
 * Internal curryN function.
 *
 * @private
 * @category Function
 * @param {Number} length The arity of the curried function.
 * @param {Array} received An array of arguments received thus far.
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */ function $c50ca2ea92d7adb6$var$_curryN(length, received, fn) {
    return function() {
        var combined = [];
        var argsIdx = 0;
        var left = length;
        var combinedIdx = 0;
        while(combinedIdx < received.length || argsIdx < arguments.length){
            var result;
            if (combinedIdx < received.length && (!$dZfWl(received[combinedIdx]) || argsIdx >= arguments.length)) result = received[combinedIdx];
            else {
                result = arguments[argsIdx];
                argsIdx += 1;
            }
            combined[combinedIdx] = result;
            if (!$dZfWl(result)) left -= 1;
            combinedIdx += 1;
        }
        return left <= 0 ? fn.apply(this, combined) : $dAtQ5(left, $c50ca2ea92d7adb6$var$_curryN(length, combined, fn));
    };
}
module.exports = $c50ca2ea92d7adb6$var$_curryN;

});



parcelRegister("fAiM2", function(module, exports) {

$parcel$export(module.exports, "EocError", () => $37c7b39a77c29171$export$e76fc0e0bc06f4df);
function $37c7b39a77c29171$var$hasMessage(cause) {
    return typeof cause === 'object' && cause !== null && 'message' in cause;
}
class $37c7b39a77c29171$export$e76fc0e0bc06f4df extends Error {
    constructor(id, cause){
        super(`[${id}] ${$37c7b39a77c29171$var$hasMessage(cause) ? cause.message : cause}`), this.id = id, this.cause = cause;
        this.name = 'EocError';
    }
}

});

parcelRegister("lLN4k", function(module, exports) {

$parcel$export(module.exports, "useReportError", () => $12b96d346b122e4e$export$5a5695b638d078e7);

var $eJOHy = parcelRequire("eJOHy");

var $1boDC = parcelRequire("1boDC");

var $1VuG2 = parcelRequire("1VuG2");
function $12b96d346b122e4e$export$cad78388f408899e(error) {
    if (!(0, $1boDC.isNetworkError)(error)) return true;
    return !(0, $1boDC.isHTTPError)(error);
}
const $12b96d346b122e4e$export$5a5695b638d078e7 = ()=>{
    const { reporterAction: reporterAction } = (0, $1VuG2.useGlobalContextActions)();
    return (0, $eJOHy.useMemo)(()=>(id, error, attributes)=>{
            if (!$12b96d346b122e4e$export$cad78388f408899e(error)) return;
            reporterAction({
                id: id,
                error: error,
                attributes: attributes
            });
        }, [
        reporterAction
    ]);
};

});
parcelRegister("1VuG2", function(module, exports) {

$parcel$export(module.exports, "GlobalContextContainer", () => $52609762e483170a$export$8a0b5f75aa4dc446);
$parcel$export(module.exports, "useExternalFlagService", () => $52609762e483170a$export$6b9ad8a324c94098);
$parcel$export(module.exports, "useSendMessage", () => $52609762e483170a$export$fe8707b58c509543);
$parcel$export(module.exports, "useGlobalContextActions", () => $52609762e483170a$export$8a9eff51cb8da29e);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $4nehu = parcelRequire("4nehu");
var $lRq8t = parcelRequire("lRq8t");

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");
var $ht3nQ = parcelRequire("ht3nQ");

var $3A8uB = parcelRequire("3A8uB");
const $52609762e483170a$export$390f32400eaf98c9 = (0, $GtRbT.createStore)({
    name: 'global-context',
    initialState: {
        reporter: undefined
    },
    actions: $3A8uB
});
const $52609762e483170a$export$8a0b5f75aa4dc446 = ({ flagService: flagService, reporter: reporter, children: children, messages: messages, config: config })=>{
    const { locale: locale } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)($52609762e483170a$var$OriginalGlobalContextContainer, {
        config: config,
        reporter: reporter,
        isGlobal: true,
        flagService: flagService,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4nehu.default), {
            locale: locale,
            messages: messages && messages[locale],
            children: children
        })
    });
};
const $52609762e483170a$var$OriginalGlobalContextContainer = (0, $6E16M.createContainer)($52609762e483170a$export$390f32400eaf98c9, {
    onInit: ()=>async ({ getState: getState, setState: setState }, { flagService: flagService, config: config })=>{
            !getState().flagService && setState({
                flagService: flagService
            });
            if (config?.context) setState({
                config: {
                    ...getState().config,
                    context: config.context
                }
            });
            if (config?.messageHandler) setState({
                config: {
                    ...getState().config,
                    messageHandler: config.messageHandler
                }
            });
        },
    onUpdate: ()=>async ({ getState: getState, setState: setState }, { config: config })=>{
            if (config?.context) setState({
                config: {
                    ...getState().config,
                    context: config.context
                }
            });
            if (config?.messageHandler) setState({
                config: {
                    ...getState().config,
                    messageHandler: config.messageHandler
                }
            });
        }
});
const $52609762e483170a$export$2041a7a7b51b1fce = (0, $ht3nQ.createSubscriber)($52609762e483170a$export$390f32400eaf98c9);
const $52609762e483170a$export$6b9ad8a324c94098 = (0, $iJq0l.createHook)($52609762e483170a$export$390f32400eaf98c9, {
    selector: (state)=>state.flagService
});
const $52609762e483170a$export$fe8707b58c509543 = (handlerClass)=>{
    const [{ handler: handler, context: context }] = $52609762e483170a$var$useSendMessageInternal(handlerClass);
    return (params)=>{
        return handler(params, context);
    };
};
const $52609762e483170a$var$useSendMessageInternal = (0, $iJq0l.createHook)($52609762e483170a$export$390f32400eaf98c9, {
    selector: (state, arg)=>{
        if (state.config && state.config.messageHandler && state.config.messageHandler instanceof arg) return {
            handler: state.config.messageHandler.handler.bind(state.config.messageHandler),
            context: state.config.context
        };
        throw new Error(`The messageHandler provided from nearest GlobalContextContainer doesn't implement the one from the inner tree. Please make sure you have a compatible GlobalContextContainer`);
    }
});
const $52609762e483170a$export$8a9eff51cb8da29e = (0, $iJq0l.createActionsHook)($52609762e483170a$export$390f32400eaf98c9);

});
parcelRegister("3A8uB", function(module, exports) {

$parcel$export(module.exports, "reporterAction", () => $ef9b184ec54fe3e2$export$f3910000817a36c2);
$parcel$export(module.exports, "getHorizontalNav", () => $ef9b184ec54fe3e2$export$7c79a3553de2e8e7);
const $ef9b184ec54fe3e2$export$f3910000817a36c2 = ({ id: id, error: error, attributes: attributes })=>({}, { reporter: reporter })=>{
        if (reporter) {
            reporter({
                id: id,
                error: error,
                attributes: attributes
            });
            return;
        }
    };
const $ef9b184ec54fe3e2$export$7c79a3553de2e8e7 = ()=>({}, { config: config })=>{
        return config?.isNewNavigation || false;
    };

});




parcelRegister("2tftR", function(module, exports) {

$parcel$export(module.exports, "default", () => $214c8361fb6b5d26$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $aXKmr = parcelRequire("aXKmr");

var $1jLQ3 = parcelRequire("1jLQ3");
var $h0TP6 = parcelRequire("h0TP6");
var $101p7 = parcelRequire("101p7");

var $cyz90 = parcelRequire("cyz90");
var $gLoFN = parcelRequire("gLoFN");

var $1VuG2 = parcelRequire("1VuG2");
const $214c8361fb6b5d26$var$useFlags = ()=>{
    const [flagService] = (0, $1VuG2.useExternalFlagService)();
    const serviceRef = (0, $eJOHy.useRef)(flagService);
    (0, $cyz90.assert)(!serviceRef.current || !!flagService, new (0, $gLoFN.AssertionError)('GlobalContext', 'flagService was destroyed.'));
    return serviceRef.current !== undefined ? {
        showFlag: ({ isAutoDismiss: isAutoDismiss, ...props })=>{
            const Component = ({ id: id, onDismissed: onDismissed })=>{
                if (isAutoDismiss) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1jLQ3.default), {
                    ...props,
                    id: id,
                    onDismissed: (id, e)=>{
                        onDismissed(id.toString());
                        props.onDismissed?.(id, e);
                    }
                });
                return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $h0TP6.default), {
                    ...props,
                    id: id,
                    onDismissed: (id, e)=>{
                        onDismissed(id.toString());
                        props.onDismissed?.(id, e);
                    }
                });
            };
            const id = (0, $aXKmr.v4)();
            Component.id = id;
            serviceRef.current.showFlag(Component);
            return ()=>{
                serviceRef.current.dismissFlag({
                    id: id,
                    command: 'DISMISS'
                });
            };
        }
    } : //eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $101p7.useFlags)();
};
var $214c8361fb6b5d26$export$2e2bcd8739ae039 = $214c8361fb6b5d26$var$useFlags;

});

parcelRegister("hZbN7", function(module, exports) {

$parcel$export(module.exports, "ResponderNamesContainer", () => $144cd4e4033879d5$export$ae46960d51ae2b7);
$parcel$export(module.exports, "useResponderNamesStore", () => $144cd4e4033879d5$export$d2c212d52c0e4d25);

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $fKObj = parcelRequire("fKObj");

var $3FDzO = parcelRequire("3FDzO");
const $144cd4e4033879d5$export$cd391a137954b857 = (0, $GtRbT.createStore)({
    initialState: (0, $3FDzO.initialState),
    actions: $fKObj.actions,
    name: 'ResponderNamesStore'
});
const $144cd4e4033879d5$export$ae46960d51ae2b7 = (0, $6E16M.createContainer)($144cd4e4033879d5$export$cd391a137954b857);
const $144cd4e4033879d5$export$d2c212d52c0e4d25 = (0, $iJq0l.createHook)($144cd4e4033879d5$export$cd391a137954b857);

});
parcelRegister("fKObj", function(module, exports) {

$parcel$export(module.exports, "actions", () => $a951fce28f24d4df$export$e324594224ef24da);

var $cyz90 = parcelRequire("cyz90");
var $gLoFN = parcelRequire("gLoFN");
var $45MTl = parcelRequire("45MTl");

var $9pZ0c = parcelRequire("9pZ0c");

var $9LoRz = parcelRequire("9LoRz");

var $hu0sR = parcelRequire("hu0sR");
const $a951fce28f24d4df$var$fetchResponders = (missingResponders)=>({ setState: setState, getState: getState, dispatch: dispatch }, { flagApi: flagApi, intlApi: intlApi, defaultCatch: defaultCatch })=>{
        const { responders: responders } = getState();
        if (!Object.keys(missingResponders).length) return Promise.resolve();
        const errorItems = (0, $9pZ0c.mapErrorForResponder)(missingResponders);
        setState({
            responders: {
                ...responders,
                ...missingResponders
            }
        });
        //TODO: How to handle if BE returns [], what will be the behaviour?
        return (0, $9LoRz.getResponderNames)(Object.values(missingResponders).map(({ id: id, type: type })=>({
                id: id,
                type: type
            }))).then((response)=>{
            const responseMap = response.values.map((r)=>({
                    isError: false,
                    isLoading: false,
                    acknowledged: true,
                    ...r
                })).reduce((acc, r)=>{
                acc[r.id] = r;
                return acc;
            }, {});
            const responderItemMap = Object.keys(missingResponders).reduce((acc, key)=>{
                const itemByEmail = Object.values(responseMap).find((res)=>res.email === key);
                if (itemByEmail) {
                    acc[key] = {
                        ...errorItems[key],
                        ...itemByEmail
                    };
                    return acc;
                }
                const itemByAtlassianIdentifier = Object.values(responseMap).find((res)=>res.atlassianIdentifier === key);
                if (itemByAtlassianIdentifier) {
                    acc[key] = {
                        ...errorItems[key],
                        ...itemByAtlassianIdentifier
                    };
                    return acc;
                }
                acc[key] = {
                    ...errorItems[key],
                    ...responseMap[key]
                };
                return acc;
            }, {});
            setState({
                responders: {
                    ...getState().responders,
                    ...responderItemMap
                }
            });
        }).catch(defaultCatch({
            id: 'fetchResponders',
            httpErrorHandler: ()=>{
                //Retry will be shown on the toast message
                const dismiss = flagApi.showFlag({
                    ...(0, $45MTl.errorToastProps)(),
                    title: intlApi.formatMessage((0, $hu0sR.messages).fetchError),
                    isAutoDismiss: true,
                    actions: [
                        {
                            content: intlApi.formatMessage((0, $hu0sR.messages).retry),
                            onClick: ()=>{
                                dispatch($a951fce28f24d4df$var$fetchResponders(missingResponders));
                                dismiss();
                            }
                        }
                    ]
                });
                const responders = Object.assign({}, getState().responders, errorItems);
                setState({
                    responders: responders
                });
            }
        }));
    };
/**
 * It takes missingResponders and updates the store with additional parameters
 * when it is called on the useResponderNames() hook.
 * It sets isLoading to true for every responder item.
 * This function is implemented to batch requests coming from different components.
 */ const $a951fce28f24d4df$var$batchResponders = (requestedResponders)=>({ setState: setState, getState: getState, dispatch: dispatch }, { displayName: displayName })=>{
        (0, $cyz90.assert)(displayName === 'ResponderNamesWrapper', new (0, $gLoFN.AssertionError)('useResponderNames', 'Unable to find ResponderNamesWrapper'));
        const missingResponders = requestedResponders.filter((responder)=>!getState().responders[responder.id]);
        if (!missingResponders.length) return;
        const requestedRespondersMap = requestedResponders.reduce((acc, r)=>{
            acc[r.id] = {
                id: r.id,
                type: r.type,
                acknowledged: false,
                isError: false,
                isLoading: true
            };
            return acc;
        }, {});
        const existingResponders = getState().responders;
        const allResponderIds = [
            ...Object.keys(existingResponders),
            ...Object.keys(requestedRespondersMap)
        ];
        const allResponders = allResponderIds.reduce((acc, key)=>{
            acc[key] = {
                ...requestedRespondersMap[key],
                ...existingResponders[key]
            };
            return acc;
        }, {});
        setState({
            responders: allResponders
        });
        const timeoutState = getState().timeout;
        if (timeoutState !== undefined) clearTimeout(timeoutState);
        //It debounces the requested responders(batching)
        const timeout = setTimeout(()=>{
            const missingResponders = Object.fromEntries(Object.entries(getState().responders).filter(([key, value])=>(0, $9pZ0c.isNotLoaded)(value)).map(([key, value])=>[
                    key,
                    {
                        ...value,
                        acknowledged: true
                    }
                ]));
            if (Object.keys(missingResponders).length) dispatch($a951fce28f24d4df$var$fetchResponders(missingResponders));
        }, 10);
        setState({
            timeout: timeout
        });
    };
const $a951fce28f24d4df$export$e324594224ef24da = {
    fetchResponders: $a951fce28f24d4df$var$fetchResponders,
    batchResponders: $a951fce28f24d4df$var$batchResponders
};

});
parcelRegister("45MTl", function(module, exports) {

$parcel$export(module.exports, "errorToastProps", () => $1533200a48fc3bd9$export$c37f1e5051cd0bbc);
$parcel$export(module.exports, "warningToastProps", () => $1533200a48fc3bd9$export$fe81a150e4e6ac02);
$parcel$export(module.exports, "infoToastProps", () => $1533200a48fc3bd9$export$e70d6574d157a39b);
$parcel$export(module.exports, "successToastProps", () => $1533200a48fc3bd9$export$b56198a940066d8f);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6YFG2 = parcelRequire("6YFG2");

var $d3cA1 = parcelRequire("d3cA1");

var $7kJQm = parcelRequire("7kJQm");

var $Hyi04 = parcelRequire("Hyi04");

var $3Isp2 = parcelRequire("3Isp2");

var $eGOwo = parcelRequire("eGOwo");


var $aTMPB = parcelRequire("aTMPB");
const $1533200a48fc3bd9$var$ErrorWithIntl = (0, $6YFG2.default)(({ intl: intl })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d3cA1))), {
        color: `var(--ds-icon-danger, ${(0, $7bb4c1736002a04a$export$4a7404f376229999)})`,
        LEGACY_size: "medium",
        label: intl.formatMessage((0, $aTMPB.default).error),
        spacing: (0, $eGOwo.fg)('eoc-visual-refresh-phase-two') ? 'spacious' : 'none'
    }));
const $1533200a48fc3bd9$var$WarningWithIntl = (0, $6YFG2.default)(({ intl: intl })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3Isp2))), {
        color: `var(--ds-icon-warning, ${(0, $7bb4c1736002a04a$export$c6930421db9fa514)})`,
        LEGACY_size: "medium",
        label: intl.formatMessage((0, $aTMPB.default).warning),
        spacing: (0, $eGOwo.fg)('eoc-visual-refresh-phase-two') ? 'spacious' : 'none'
    }));
const $1533200a48fc3bd9$var$InfoWithIntl = (0, $6YFG2.default)(({ intl: intl })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7kJQm))), {
        color: `var(--ds-icon-discovery, ${(0, $7bb4c1736002a04a$export$b48405b95304b5a1)})`,
        LEGACY_size: "medium",
        label: intl.formatMessage((0, $aTMPB.default).info),
        spacing: (0, $eGOwo.fg)('eoc-visual-refresh-phase-two') ? 'spacious' : 'none'
    }));
const $1533200a48fc3bd9$var$SuccessWithIntl = (0, $6YFG2.default)(({ intl: intl })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($Hyi04))), {
        color: `var(--ds-icon-success, ${(0, $7bb4c1736002a04a$export$940e1f69e873f202)})`,
        LEGACY_size: "medium",
        label: intl.formatMessage((0, $aTMPB.default).success),
        spacing: (0, $eGOwo.fg)('eoc-visual-refresh-phase-two') ? 'spacious' : 'none'
    }));
const $1533200a48fc3bd9$export$c37f1e5051cd0bbc = ()=>({
        icon: /*#__PURE__*/ (0, $gt9Am.jsx)($1533200a48fc3bd9$var$ErrorWithIntl, {}),
        appearance: 'normal'
    });
const $1533200a48fc3bd9$export$fe81a150e4e6ac02 = ()=>({
        icon: /*#__PURE__*/ (0, $gt9Am.jsx)($1533200a48fc3bd9$var$WarningWithIntl, {}),
        appearance: 'normal'
    });
const $1533200a48fc3bd9$export$e70d6574d157a39b = ()=>({
        icon: /*#__PURE__*/ (0, $gt9Am.jsx)($1533200a48fc3bd9$var$InfoWithIntl, {}),
        appearance: 'normal'
    });
const $1533200a48fc3bd9$export$b56198a940066d8f = ()=>({
        icon: /*#__PURE__*/ (0, $gt9Am.jsx)($1533200a48fc3bd9$var$SuccessWithIntl, {}),
        appearance: 'normal',
        isAutoDismiss: true
    });

});
parcelRegister("aTMPB", function(module, exports) {

$parcel$export(module.exports, "default", () => $86edcbb90c3443de$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $86edcbb90c3443de$var$messages = (0, $7qGN1.defineMessages)({
    error: {
        id: 'eoc.common.toast.error',
        defaultMessage: 'Error',
        description: 'The title for an error as a single word.'
    },
    warning: {
        id: 'eoc.common.toast.warning',
        defaultMessage: 'Warning',
        description: 'The title for a warning as a single word.'
    },
    success: {
        id: 'eoc.common.toast.success',
        defaultMessage: 'Success',
        description: 'The title for success as a single word.'
    },
    info: {
        id: 'eoc.common.toast.info',
        defaultMessage: 'Information',
        description: 'The title for an information as a single word.'
    }
});
var $86edcbb90c3443de$export$2e2bcd8739ae039 = $86edcbb90c3443de$var$messages;

});


parcelRegister("9pZ0c", function(module, exports) {

$parcel$export(module.exports, "mapErrorForResponder", () => $8a94c2d90987d405$export$245cebe8a9527ff0);
$parcel$export(module.exports, "isNotLoaded", () => $8a94c2d90987d405$export$ea78f980ad0c92fe);
const $8a94c2d90987d405$export$245cebe8a9527ff0 = (requestedResponders)=>Object.entries(requestedResponders).reduce((acc, [key, value])=>{
        acc[key] = {
            id: value.id,
            type: value.type,
            isError: true,
            acknowledged: true,
            isLoading: false
        };
        return acc;
    }, {});
const $8a94c2d90987d405$export$ea78f980ad0c92fe = (responder)=>!Boolean(responder?.isError) && !Boolean(responder?.acknowledged);

});

parcelRegister("9LoRz", function(module, exports) {

$parcel$export(module.exports, "getResponderNames", () => $0db12598b61814cd$export$7345ec3bad54e226);

var $9ppkU = parcelRequire("9ppkU");
const $0db12598b61814cd$export$7345ec3bad54e226 = (requestedResponders)=>{
    const responders = requestedResponders.reduce((acc, curr)=>{
        // any is intentional here we don't want to add
        // unknown to the ResponderType because we don't want it to be public
        if (curr.type === 'unknown') return [
            ...acc,
            {
                id: curr.id,
                type: 'schedule'
            },
            {
                id: curr.id,
                type: 'user'
            },
            {
                id: curr.id,
                type: 'team'
            },
            {
                id: curr.id,
                type: 'escalation'
            }
        ];
        return [
            ...acc,
            curr
        ];
    }, []);
    return (0, $9ppkU.eocFetch)(`/v1/alerts/responders/names`, {
        method: 'POST',
        body: {
            responders: responders
        }
    });
};

});

parcelRegister("hu0sR", function(module, exports) {

$parcel$export(module.exports, "messages", () => $baca7b843ee7ebbc$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $baca7b843ee7ebbc$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    fetchError: {
        id: `eoc.responder-names-fetch-error`,
        defaultMessage: "We couldn't fetch the responder names.",
        description: 'The text will be displayed when there is error'
    },
    retry: {
        id: `eoc.responder-names-retry`,
        defaultMessage: 'Retry',
        description: 'The title for retry as a single word.'
    }
});

});


parcelRegister("3FDzO", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $36b2f2eaaa38ea2b$export$d4c72bab9d6cc13a);
const $36b2f2eaaa38ea2b$export$d4c72bab9d6cc13a = {
    responders: {}
};

});



parcelRegister("3NYni", function(module, exports) {

$parcel$export(module.exports, "AsyncLinkedAlertsField", () => $209c6c2594e3d054$export$5dd38ea4ae79439a);

var $bQWwW = parcelRequire("bQWwW");

const $209c6c2594e3d054$export$5dd38ea4ae79439a = (0, $bQWwW.lazy)(()=>(parcelRequire("3gsSs")).then((module)=>module.LinkedAlertsField), {
    moduleId: "./src/packages/issue/fields/linked-alerts/src/ui/index.tsx"
});

});
parcelRegister("3gsSs", function(module, exports) {

let $2609442633acbce8$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $2609442633acbce8$var$load("ffQaD"),
    $2609442633acbce8$var$load("kvRbA"),
    $2609442633acbce8$var$load("i3jpZ")
]).then(()=>parcelRequire('9VamR'));

});



parcelRegister("joycu", function(module, exports) {

$parcel$export(module.exports, "useCanConfigureIssueType", () => $66e38e8466133c7f$export$11eed85a03639c1c);
$parcel$export(module.exports, "shouldShowConfigureIssueTypeOption", () => $66e38e8466133c7f$export$319ba838aee47b08);
$parcel$export(module.exports, "canConfigureIssueTypeForProject", () => $66e38e8466133c7f$export$a88e153648f54474);

var $5PQOA = parcelRequire("5PQOA");

var $ln6Iy = parcelRequire("ln6Iy");

var $bNexr = parcelRequire("bNexr");

var $f5OzW = parcelRequire("f5OzW");
const $66e38e8466133c7f$export$11eed85a03639c1c = (projectKey)=>{
    const isTeamManaged = (0, $bNexr.useIsSimplifiedProject)(projectKey);
    const hasAdminPermissions = (0, $f5OzW.useCanConfigureIssue)(projectKey);
    return isTeamManaged && hasAdminPermissions;
};
const $66e38e8466133c7f$export$319ba838aee47b08 = (projectType)=>{
    return projectType === (0, $ln6Iy.CORE_PROJECT) || projectType === (0, $ln6Iy.SOFTWARE_PROJECT);
};
const $66e38e8466133c7f$export$a88e153648f54474 = (0, (/*@__PURE__*/$parcel$interopDefault($5PQOA)))(({ project: project, isProjectAdmin: isProjectAdmin })=>{
    return isProjectAdmin && (project?.isSimplified ?? false) && $66e38e8466133c7f$export$319ba838aee47b08(project?.projectType ?? null);
});

});
parcelRegister("f5OzW", function(module, exports) {

$parcel$export(module.exports, "useProjectPermissions", () => $9392c16d11e1d8d6$export$c6c6b35628cf47a8);
$parcel$export(module.exports, "useCanAdministerProject", () => $9392c16d11e1d8d6$export$f39ed5a161efa614);
$parcel$export(module.exports, "useCanAdministerJira", () => $9392c16d11e1d8d6$export$ec12ddafd19b95ac);
$parcel$export(module.exports, "useCanConfigureIssue", () => $9392c16d11e1d8d6$export$e7267b8a084eadb3);
$parcel$export(module.exports, "useCanUseServiceDeskAgentFeatures", () => $9392c16d11e1d8d6$export$756d7c97077a2f76);
$parcel$export(module.exports, "useCanUseCustomerServiceAgentFeatures", () => $9392c16d11e1d8d6$export$a9aa002e3fe96518);
$parcel$export(module.exports, "useCanDownloadAttachments", () => $9392c16d11e1d8d6$export$d47dad3a7e3265ea);
$parcel$export(module.exports, "useProjectPermissionsActions", () => $9392c16d11e1d8d6$export$86c656cdb87052cd);

var $eJOHy = parcelRequire("eJOHy");

var $lvKO5 = parcelRequire("lvKO5");

var $iW0U8 = parcelRequire("iW0U8");

var $cmy2V = parcelRequire("cmy2V");
const $9392c16d11e1d8d6$export$c6c6b35628cf47a8 = (projectKey)=>{
    const [permissions, { setProjectPermissions: setProjectPermissions }] = (0, $cmy2V.useProjectPermissionsStore)({
        projectKey: projectKey
    });
    const actions = (0, $eJOHy.useMemo)(()=>({
            setProjectPermissions: setProjectPermissions
        }), [
        setProjectPermissions
    ]);
    return [
        permissions,
        actions
    ];
};
const $9392c16d11e1d8d6$export$f39ed5a161efa614 = (projectKey)=>{
    const [permissions] = (0, $cmy2V.useProjectPermissionsStore)({
        projectKey: projectKey
    });
    return permissions.canAdministerProject;
};
const $9392c16d11e1d8d6$export$ec12ddafd19b95ac = (projectKey)=>{
    const [permissions] = (0, $cmy2V.useProjectPermissionsStore)({
        projectKey: projectKey
    });
    return permissions.canAdministerJira;
};
const $9392c16d11e1d8d6$export$e7267b8a084eadb3 = (projectKey)=>{
    const canConfigureAdministerProject = $9392c16d11e1d8d6$export$f39ed5a161efa614(projectKey);
    const canAdministerJira = $9392c16d11e1d8d6$export$ec12ddafd19b95ac(projectKey);
    return canConfigureAdministerProject || canAdministerJira;
};
const $9392c16d11e1d8d6$export$756d7c97077a2f76 = (projectKey)=>{
    const [permissions] = (0, $cmy2V.useProjectPermissionsStore)({
        projectKey: projectKey
    });
    const { appPermissions: appPermissions } = (0, $lvKO5.useTenantContext)();
    return permissions.canUseServiceDeskAgentFeatures && appPermissions?.hasServiceDeskAccess;
};
const $9392c16d11e1d8d6$export$a9aa002e3fe96518 = (projectKey)=>{
    const [permissions] = (0, $cmy2V.useProjectPermissionsStore)({
        projectKey: projectKey
    });
    const { hasCustomerServiceAccess: hasCustomerServiceAccess } = (0, $iW0U8.useApplicationPermissions)();
    return permissions.canUseServiceDeskAgentFeatures && hasCustomerServiceAccess;
};
const $9392c16d11e1d8d6$export$d47dad3a7e3265ea = (projectKey)=>{
    const [permissions] = (0, $cmy2V.useProjectPermissionsStore)({
        projectKey: projectKey
    });
    return permissions.canExportIssue;
};
const $9392c16d11e1d8d6$export$86c656cdb87052cd = ()=>{
    const [, { setProjectPermissions: setProjectPermissions }] = (0, $cmy2V.useProjectPermissionsStoreActions)();
    const actions = (0, $eJOHy.useMemo)(()=>({
            setProjectPermissions: setProjectPermissions
        }), [
        setProjectPermissions
    ]);
    return [
        null,
        actions
    ];
};

});
parcelRegister("cmy2V", function(module, exports) {

$parcel$export(module.exports, "defaultPermissions", () => $872d4887d895f20d$export$ccfee65526b322ca);
$parcel$export(module.exports, "useProjectPermissionsStore", () => $872d4887d895f20d$export$4919fa09a3d81224);
$parcel$export(module.exports, "useProjectPermissionsStoreActions", () => $872d4887d895f20d$export$e8436ef485b33bdb);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $g2Hwr = parcelRequire("g2Hwr");
const $872d4887d895f20d$export$ccfee65526b322ca = {
    canAddComments: false,
    canAdministerJira: false,
    canAdministerProject: false,
    canAssignIssues: false,
    canBeAssignedToIssues: false,
    canCloneIssue: false,
    canCreateAttachments: false,
    canCreateChildren: false,
    canCreateSubtask: false,
    canDeleteAllAttachments: false,
    canDeleteAllComments: false,
    canDeleteAllWorklogs: false,
    canDeleteIssue: false,
    canDeleteOwnAttachments: false,
    canDeleteOwnComments: false,
    canDeleteOwnWorklogs: false,
    canEditAllComments: false,
    canEditAllWorklogs: false,
    canEditIssues: false,
    canEditOwnComments: false,
    canEditOwnWorklogs: false,
    canLinkIssues: false,
    canLogWork: false,
    canManageWatchers: false,
    canMoveIssue: false,
    canModifyReporter: false,
    canScheduleIssues: false,
    canUseServiceDeskAgentFeatures: false,
    canBrowseUsers: false,
    canViewDevTools: false,
    canViewWatchers: false,
    canViewVoters: false,
    canCreateIssuesInClassicProjectEpic: false,
    canResolveIssues: false,
    canExportIssue: false,
    canArchiveIssue: false,
    canUnarchiveIssue: false
};
const $872d4887d895f20d$export$6f57813fe9f31bf9 = (0, $GtRbT.createStore)({
    name: 'project-permissions',
    initialState: {},
    actions: $g2Hwr
});
const $872d4887d895f20d$var$getProjectPermissionSelector = (state, { projectKey: projectKey })=>state[projectKey] || $872d4887d895f20d$export$ccfee65526b322ca;
const $872d4887d895f20d$export$4919fa09a3d81224 = (0, $iJq0l.createHook)($872d4887d895f20d$export$6f57813fe9f31bf9, {
    selector: $872d4887d895f20d$var$getProjectPermissionSelector
});
const $872d4887d895f20d$export$e8436ef485b33bdb = (0, $iJq0l.createHook)($872d4887d895f20d$export$6f57813fe9f31bf9, {
    selector: null
});

});
parcelRegister("g2Hwr", function(module, exports) {

$parcel$export(module.exports, "setProjectPermissions", () => $d904843c11c916e5$export$53f5cc27627e5fe3);
const $d904843c11c916e5$export$53f5cc27627e5fe3 = (projectKey, permissions)=>({ setState: setState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [projectKey]: permissions
        });
    };

});




parcelRegister("2ghht", function(module, exports) {

$parcel$export(module.exports, "useCanConfigureStatus", () => $f8c9ffd6e8d05c61$export$c330622bbe9077c2);
$parcel$export(module.exports, "shouldShowConfigureStatusOption", () => $f8c9ffd6e8d05c61$export$33aa2c7a0150a75c);
$parcel$export(module.exports, "canConfigureStatusForProject", () => $f8c9ffd6e8d05c61$export$bbae6b0cfa2349b8);

var $5PQOA = parcelRequire("5PQOA");

var $ln6Iy = parcelRequire("ln6Iy");

var $bNexr = parcelRequire("bNexr");

var $f5OzW = parcelRequire("f5OzW");
const $f8c9ffd6e8d05c61$export$c330622bbe9077c2 = (projectKey)=>{
    const isTeamManaged = (0, $bNexr.useIsSimplifiedProject)(projectKey);
    const hasAdminPermissions = (0, $f5OzW.useCanConfigureIssue)(projectKey);
    return isTeamManaged && hasAdminPermissions;
};
const $f8c9ffd6e8d05c61$export$33aa2c7a0150a75c = (projectType)=>{
    return projectType === (0, $ln6Iy.CORE_PROJECT) || projectType === (0, $ln6Iy.SOFTWARE_PROJECT);
};
const $f8c9ffd6e8d05c61$export$bbae6b0cfa2349b8 = (0, (/*@__PURE__*/$parcel$interopDefault($5PQOA)))(({ project: project, isProjectAdmin: isProjectAdmin })=>{
    return isProjectAdmin && (project?.isSimplified ?? false) && $f8c9ffd6e8d05c61$export$33aa2c7a0150a75c(project?.projectType ?? null);
});

});

const $3838db8cf80b284d$export$e5ea02c7e88c47a3 = 'issue-create.common.ui.footer.create-button';
const $3838db8cf80b284d$export$2bb7a43aba04c7df = 'issue-create.common.ui.footer.cancel-button';
const $3838db8cf80b284d$export$822eda80d997eca0 = 'issue-create.common.ui.footer.created-issue-link';
const $3838db8cf80b284d$export$9184b2de35f96256 = 'issue-create.ui.modal.header.import-issues-button';
const $3838db8cf80b284d$export$2d077da71c26c1c5 = 'issue-create.ui.modal.create-form';
const $3838db8cf80b284d$export$108d230a18c70c1b = 'issue-create.ui.modal.create-form.section-messages.required-fields-message';
const $3838db8cf80b284d$export$f0c65883f24e857a = 'issue-create.ui.modal.create-form.section-messages.query-error-message';
const $3838db8cf80b284d$export$d72a09102cf8602a = 'issue-create.ui.modal.create-form.section-messages.submit-error-message';
const $3838db8cf80b284d$export$8cdb63e5b4deba55 = 'issue-create.ui.modal.create-form.section-messages.ui-modifications-error-message';
const $3838db8cf80b284d$export$59cdc95a37abd627 = 'issue-create.common.ui.incompatible-fields-actions.learn-more';
const $3838db8cf80b284d$export$1ec63f57bc2aa892 = 'issue-create.ui.modal.create-form.section-messages.inline-create-errors';
const $3838db8cf80b284d$export$e80c59cc84dd232e = 'issue-create.common.ui.incompatible-fields-actions.switch-old-experience';
const $3838db8cf80b284d$export$565ca47ee76ce81a = 'issue-create.ui.modal.confirm-dismiss-modal.discard-issue-button';
const $3838db8cf80b284d$export$832901d9b0ce6620 = 'issue-create.ui.modal.cancel-dismiss-modal.discard-issue-button';
const $3838db8cf80b284d$export$43794d009bc9b43b = 'issue-create.ui.modal.create-form.section-messages.ui-modifications-notification-message';

parcelRegister("j7mDN", function(module, exports) {

$parcel$export(module.exports, "useInteractedFields", () => $7f52b050a6f08ed4$export$d5ae3b2773429294);

var $eJOHy = parcelRequire("eJOHy");

var $xMjNG = parcelRequire("xMjNG");

var $4PKlm = parcelRequire("4PKlm");

var $jQUoP = parcelRequire("jQUoP");
const $7f52b050a6f08ed4$export$d5ae3b2773429294 = ()=>{
    const [interactedFields, { setInteractedWithField: setInteractedWithField }] = (0, $jQUoP.useFormContextInteractedFields)();
    const { subscribe: subscribe } = (0, $4PKlm.useGICLifeCycleEvents)();
    (0, $eJOHy.useEffect)(()=>subscribe((0, $xMjNG.GIC_LIFECYCLE_EVENTS).CREATE_FORM_FIELD_VALUE_CHANGE, ({ fieldId: fieldId })=>{
            setInteractedWithField(fieldId);
        }), [
        setInteractedWithField,
        subscribe
    ]);
    return {
        interactedFields: interactedFields
    };
};

});

parcelRegister("dOYAq", function(module, exports) {

$parcel$export(module.exports, "useInvitePrompt", () => $7bea136ffe666ff7$export$2d68d3093301b7c3);

var $eJOHy = parcelRequire("eJOHy");

var $9kfy2 = parcelRequire("9kfy2");

var $eiUEa = parcelRequire("eiUEa");

var $dVmFR = parcelRequire("dVmFR");

var $2zVtv = parcelRequire("2zVtv");

var $kEUB1 = parcelRequire("kEUB1");

var $lvKO5 = parcelRequire("lvKO5");
const $7bea136ffe666ff7$export$2d68d3093301b7c3 = (projectKey)=>{
    const cloudId = (0, $kEUB1.useCloudId)();
    const { cloudName: cloudName } = (0, $lvKO5.useTenantContext)();
    const triggerInviteExperiment = (0, $dVmFR.useInvitePrompt)(projectKey);
    const { store: store } = (0, $eJOHy.useContext)((0, $9kfy2.SmartCardContext)) || {};
    return (0, $eJOHy.useCallback)(async (description)=>{
        if (description && store && projectKey) {
            const links = (0, $2zVtv.getAllProductLinks)(description, store, cloudId, cloudName);
            for (const [link, data] of Object.entries(links)){
                // https://eslint.org/docs/latest/rules/no-await-in-loop#when-not-to-use-it
                /* eslint-disable no-await-in-loop */ if (await triggerInviteExperiment(link, data, (0, $eiUEa.SOURCE).CREATE_ISSUE)) return;
            }
        }
    }, [
        cloudId,
        cloudName,
        projectKey,
        store,
        triggerInviteExperiment
    ]);
};

});
parcelRegister("eiUEa", function(module, exports) {

$parcel$export(module.exports, "SOURCE", () => $eee1c3e095cd5fb3$export$83c8d7110915321e);
const $eee1c3e095cd5fb3$export$83c8d7110915321e = {
    ISSUE_VIEW: 'issue-view',
    CREATE_ISSUE: 'create-issue',
    CREATE_LINK: 'create-link'
};

});

parcelRegister("dVmFR", function(module, exports) {

$parcel$export(module.exports, "useInvitePrompt", () => $5d141293d6abee47$export$2d68d3093301b7c3);
$parcel$export(module.exports, "useInviteOnCreateLink", () => $5d141293d6abee47$export$90eafb1d75365ab4);

var $eJOHy = parcelRequire("eJOHy");

var $gYnSx = parcelRequire("gYnSx");


var $kEUB1 = parcelRequire("kEUB1");

var $61pqN = parcelRequire("61pqN");

var $epTsa = parcelRequire("epTsa");

var $eiUEa = parcelRequire("eiUEa");

var $au5M2 = parcelRequire("au5M2");

var $3soap = parcelRequire("3soap");

var $z4hCP = parcelRequire("z4hCP");

var $8onhK = parcelRequire("8onhK");

var $aCATI = parcelRequire("aCATI");

var $2zVtv = parcelRequire("2zVtv");

var $1ikCi = parcelRequire("1ikCi");

var $ftbxH = parcelRequire("ftbxH");

var $e0JcZ = parcelRequire("e0JcZ");

var $eunhC = parcelRequire("eunhC");
const $5d141293d6abee47$export$2d68d3093301b7c3 = (createIssueProjectKey)=>{
    const canInvite = (0, $z4hCP.useCanInvite)();
    const getInvitees = (0, $au5M2.useInvitees)(createIssueProjectKey);
    const showInvitePromptFlag = (0, $e0JcZ.useInvitePromptFlag)();
    const showSuccessFlag = (0, $eunhC.useInviteSuccessFlag)();
    const showErrorFlag = (0, $ftbxH.useInviteErrorFlag)();
    const inviteUsers = (0, $8onhK.useInviteUsers)();
    const { getOptOutStatus: getOptOutStatus, setOptOutStatus: setOptOutStatus, incrementViewCount: incrementViewCount, shouldShowOptOutOption: shouldShowOptOutOption } = (0, $aCATI.useOptOut)();
    return (0, $eJOHy.useCallback)(async (continueUrl, data, source = (0, $eiUEa.SOURCE).ISSUE_VIEW)=>{
        try {
            // eslint-disable-next-line jira/ff/unsafe-no-exposure
            const [config] = (0, $epTsa.UNSAFE_noExposureExp)('persistent_invite_on_link_insert');
            if (config.get('cohort', 'not-enrolled') === 'variation') return;
            (0, $1ikCi.invitePromptOnLinkInsertExperience).start();
            const { tenantId: tenantId, product: product, name: name } = data;
            const hasOptedOut = await getOptOutStatus();
            if (hasOptedOut) return;
            const canInviteToProduct = await canInvite(tenantId, product);
            if (!canInviteToProduct) return;
            const users = await getInvitees(tenantId, product, 10);
            if (users.length === 0) return;
            const targetPageLabel = name || await (0, $3soap.getPageTitle)(continueUrl);
            const integration = 'invitePromptOnLink';
            showInvitePromptFlag({
                users: users,
                product: product,
                source: source,
                targetPageLabel: targetPageLabel,
                allowOptOut: await shouldShowOptOutOption(),
                onSubmit: async ()=>{
                    try {
                        const response = await inviteUsers({
                            continueUrl: continueUrl,
                            userIds: users.map(({ id: id })=>id),
                            tenantId: tenantId,
                            product: product,
                            integration: integration
                        });
                        showSuccessFlag({
                            userIds: users.map(({ id: id })=>id),
                            product: product,
                            requireAdminApproval: response.accessRequested.length > 0
                        });
                    } catch  {
                        showErrorFlag();
                    }
                },
                onDismiss: incrementViewCount,
                onOptOut: setOptOutStatus
            });
            (0, $1ikCi.invitePromptOnLinkInsertExperience).success();
            return true;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $gYnSx.default)({
                meta: {
                    id: 'useInvitePromptExperiment',
                    packageName: 'jiraInvitePromptOnLinkInsert'
                },
                error: error
            });
            (0, $1ikCi.invitePromptOnLinkInsertExperience).failure();
        }
    }, [
        canInvite,
        getInvitees,
        getOptOutStatus,
        incrementViewCount,
        inviteUsers,
        setOptOutStatus,
        shouldShowOptOutOption,
        showErrorFlag,
        showInvitePromptFlag,
        showSuccessFlag
    ]);
};
const $5d141293d6abee47$export$90eafb1d75365ab4 = (link)=>{
    const cloudId = (0, $kEUB1.useCloudId)();
    const cloudName = (0, $61pqN.useCloudName)();
    const triggerInviteExperiment = $5d141293d6abee47$export$2d68d3093301b7c3();
    return (0, $eJOHy.useCallback)(()=>{
        if ((0, $2zVtv.isConfluenceLink)(link, cloudName)) triggerInviteExperiment(link, {
            tenantId: cloudId,
            product: (0, $e08dff4ae358d899$export$c811f21c9ad05dc2)
        }, (0, $eiUEa.SOURCE).CREATE_LINK);
    }, [
        cloudId,
        cloudName,
        link,
        triggerInviteExperiment
    ]);
};

});
const $e08dff4ae358d899$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $e08dff4ae358d899$export$e9c56aa3b027d98f = 'jira-customer-service';
const $e08dff4ae358d899$export$1346c9aa3cbb477d = 'jira-software';
const $e08dff4ae358d899$export$202f50ee62667e32 = 'jira-product-discovery';
const $e08dff4ae358d899$export$db515c8cec1e6f79 = 'jira-core';
const $e08dff4ae358d899$export$c811f21c9ad05dc2 = 'confluence';
const $e08dff4ae358d899$export$961148c98d198270 = 'opsgenie';

parcelRegister("61pqN", function(module, exports) {

$parcel$export(module.exports, "useCloudName", () => $2768768827305e9c$export$4dd2f8d207dc8dbf);

var $lvKO5 = parcelRequire("lvKO5");
const $2768768827305e9c$export$4dd2f8d207dc8dbf = ()=>{
    const tenantContext = (0, $lvKO5.useTenantContext)();
    return tenantContext && tenantContext.cloudName;
};

});

parcelRegister("au5M2", function(module, exports) {

$parcel$export(module.exports, "useInvitees", () => $8c0c9fc68c25dc38$export$e2a3b21407d97a53);

var $eJOHy = parcelRequire("eJOHy");

var $bmoS1 = parcelRequire("bmoS1");

var $bNexr = parcelRequire("bNexr");

var $kEUB1 = parcelRequire("kEUB1");

var $2zVtv = parcelRequire("2zVtv");

var $lwX4d = parcelRequire("lwX4d");

var $dsdsy = parcelRequire("dsdsy");
const $8c0c9fc68c25dc38$export$e2a3b21407d97a53 = (createIssueProjectKey)=>{
    const issueKey = (0, $bmoS1.useIssueKey)();
    const currentProjectKey = (0, $bNexr.useProjectKey)(issueKey);
    const projectKey = createIssueProjectKey || currentProjectKey;
    const currentProduct = (0, $2zVtv.useCurrentProduct)();
    const cloudId = (0, $kEUB1.useCloudId)();
    return (0, $eJOHy.useCallback)((tenantId, destinationProduct, inviteesLimit = 10)=>$8c0c9fc68c25dc38$export$31f1797930c2d46c(tenantId, destinationProduct, currentProduct, cloudId, projectKey, inviteesLimit), [
        cloudId,
        currentProduct,
        projectKey
    ]);
};
const $8c0c9fc68c25dc38$export$31f1797930c2d46c = async (tenantId, destinationProduct, currentProduct, cloudId, projectKey, inviteesLimit = 10)=>{
    const isInvitingToCurrentProduct = tenantId === cloudId && destinationProduct === currentProduct;
    if (isInvitingToCurrentProduct) return [];
    const projectAssignees = await (0, $lwX4d.getProjectAssignees)(projectKey);
    if (projectAssignees.length === 0) return [];
    const accountIds = projectAssignees.map(({ id: id })=>id);
    const [usersWithoutAccessToCurrentProduct, usersWithoutAccessToDestinationProduct] = await Promise.all([
        (0, $dsdsy.getUsersWithoutProductAccess)(cloudId, currentProduct, accountIds),
        (0, $dsdsy.getUsersWithoutProductAccess)(tenantId, destinationProduct, accountIds)
    ]);
    const invitees = projectAssignees.filter(({ id: id })=>!usersWithoutAccessToCurrentProduct.includes(id)).filter(({ id: id })=>usersWithoutAccessToDestinationProduct.includes(id));
    return invitees.slice(0, inviteesLimit);
};

});
parcelRegister("2zVtv", function(module, exports) {

$parcel$export(module.exports, "isConfluenceLink", () => $1daf1eedbdaa21d6$export$313baaa1c3261c49);
$parcel$export(module.exports, "getAllLinks", () => $1daf1eedbdaa21d6$export$776644da31ab517e);
$parcel$export(module.exports, "getAllProductLinks", () => $1daf1eedbdaa21d6$export$577f918d7821fd77);
$parcel$export(module.exports, "generateId", () => $1daf1eedbdaa21d6$export$567fc7097e064344);
$parcel$export(module.exports, "clampString", () => $1daf1eedbdaa21d6$export$96ce25bdd1856c70);
$parcel$export(module.exports, "getProductDisplayName", () => $1daf1eedbdaa21d6$export$44fea6589b7ddc92);
$parcel$export(module.exports, "getSiteAri", () => $1daf1eedbdaa21d6$export$792aeacb7990bc6);
$parcel$export(module.exports, "useCurrentProduct", () => $1daf1eedbdaa21d6$export$495654df2a5da4a0);

var $0mclG = parcelRequire("0mclG");


var $gtr2v = parcelRequire("gtr2v");

var $2aY2d = parcelRequire("2aY2d");
const $1daf1eedbdaa21d6$export$69caceff42c0da80 = {
    [(0, $e08dff4ae358d899$export$c811f21c9ad05dc2)]: 'Confluence'
};
const $1daf1eedbdaa21d6$export$fadb677f87088e11 = (projectType)=>{
    switch(projectType){
        case 'software':
            return 0, $e08dff4ae358d899$export$1346c9aa3cbb477d;
        case 'service_desk':
            return 0, $e08dff4ae358d899$export$c8c1c8c3f8ddba61;
        case 'business':
            return 0, $e08dff4ae358d899$export$db515c8cec1e6f79;
        case 'product_discovery':
            return 0, $e08dff4ae358d899$export$202f50ee62667e32;
        default:
            return null;
    }
};
const $1daf1eedbdaa21d6$var$getProductFromSubproduct = (subproduct)=>{
    switch(subproduct){
        case 'software':
        case 'jira_software':
            return 0, $e08dff4ae358d899$export$1346c9aa3cbb477d;
        case 'servicedesk':
        case 'jira_service_management':
            return 0, $e08dff4ae358d899$export$c8c1c8c3f8ddba61;
        case 'core':
        case 'jira_work_management':
            return 0, $e08dff4ae358d899$export$db515c8cec1e6f79;
        case 'polaris':
        case 'jira_product_discovery':
            return 0, $e08dff4ae358d899$export$202f50ee62667e32;
        default:
            return null;
    }
};
const $1daf1eedbdaa21d6$export$313baaa1c3261c49 = (url, cloudName)=>{
    if (!url || !cloudName) return false;
    const regex = new RegExp(`^https?://${cloudName}.atlassian.net/wiki(?!/external)`);
    return regex.test(url);
};
const $1daf1eedbdaa21d6$export$776644da31ab517e = (doc)=>{
    const links = new Set();
    const handleLink = (link)=>{
        link && links.add(link);
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleSmartLink = (node)=>handleLink(node.attrs?.url);
    (0, $0mclG.traverse)(doc, {
        text: (node)=>{
            if ((node.marks || []).some((mark)=>mark.type === 'link')) handleLink(node.text);
        },
        inlineCard: handleSmartLink,
        blockCard: handleSmartLink,
        embedCard: handleSmartLink
    });
    return links;
};
const $1daf1eedbdaa21d6$var$getSmartLinkData = (cloudId, details)=>{
    if (!details) return;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const { name: name } = details.data;
    const { tenantId: tenantId, subproduct: subproduct } = details.meta;
    let { product: product } = details.meta;
    if (tenantId !== cloudId) return;
    product = product === 'jira' ? $1daf1eedbdaa21d6$var$getProductFromSubproduct(subproduct) : product;
    if (!Object.keys($1daf1eedbdaa21d6$export$69caceff42c0da80).includes(product)) return;
    return {
        name: name,
        tenantId: tenantId,
        product: product
    };
};
const $1daf1eedbdaa21d6$export$577f918d7821fd77 = (doc, store, cloudId, cloudName)=>{
    const links = {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleSmartLink = (node)=>{
        // Check URL is on the ADF node
        const { url: url } = node?.attrs;
        if (!url) return;
        // Check URL is in the Smart Links Store
        const details = store.getState()[url]?.details;
        const data = $1daf1eedbdaa21d6$var$getSmartLinkData(cloudId, details);
        if (data) links[url] = data;
    };
    const handleRawConfluenceLink = (url)=>{
        if ($1daf1eedbdaa21d6$export$313baaa1c3261c49(url, cloudName)) links[url] = {
            tenantId: cloudId,
            product: (0, $e08dff4ae358d899$export$c811f21c9ad05dc2)
        };
    };
    (0, $0mclG.traverse)(doc, {
        text: (node)=>{
            if ((node.marks || []).some((mark)=>mark.type === 'link')) handleRawConfluenceLink(node.text);
        },
        inlineCard: handleSmartLink,
        blockCard: handleSmartLink,
        embedCard: handleSmartLink
    });
    return links;
};
let $1daf1eedbdaa21d6$var$id = 0;
const $1daf1eedbdaa21d6$export$567fc7097e064344 = ()=>{
    $1daf1eedbdaa21d6$var$id += 1;
    return String($1daf1eedbdaa21d6$var$id);
};
const $1daf1eedbdaa21d6$export$96ce25bdd1856c70 = (string, maxLength)=>{
    if (string.length > maxLength) return string.slice(0, maxLength).concat('...');
    return string;
};
const $1daf1eedbdaa21d6$export$44fea6589b7ddc92 = (product)=>$1daf1eedbdaa21d6$export$69caceff42c0da80[product];
const $1daf1eedbdaa21d6$export$792aeacb7990bc6 = (tenantId, product)=>(0, $gtr2v.AnyAri).create({
        resourceOwner: product,
        resourceType: 'site',
        resourceId: tenantId
    }).toString();
const $1daf1eedbdaa21d6$export$495654df2a5da4a0 = ()=>{
    const { data: data } = (0, $2aY2d.useProjectContext)();
    return $1daf1eedbdaa21d6$export$fadb677f87088e11(data?.projectType) || (0, $e08dff4ae358d899$export$1346c9aa3cbb477d);
};

});

parcelRegister("lwX4d", function(module, exports) {

$parcel$export(module.exports, "getProjectAssignees", () => $9c3aa72a6fb55d78$export$b49ddf91eddfcea9);

var $1Ozm9 = parcelRequire("1Ozm9");
const $9c3aa72a6fb55d78$var$getAssigneesUrl = (projectKey)=>`/rest/api/3/user/search/query?query=is assignee of ${projectKey}&maxResults=50`;
const $9c3aa72a6fb55d78$export$b49ddf91eddfcea9 = async (projectKey)=>{
    const users = await (0, $1Ozm9.default)($9c3aa72a6fb55d78$var$getAssigneesUrl(projectKey));
    return users.values.filter(({ active: active })=>active).map(({ accountId: accountId, emailAddress: emailAddress, displayName: displayName, avatarUrls: avatarUrls })=>({
            id: accountId,
            email: emailAddress,
            name: displayName || '',
            avatar: avatarUrls['48x48'] || avatarUrls['32x32'] || avatarUrls['24x24'] || Object.values(avatarUrls).pop() || ''
        }));
};

});

parcelRegister("dsdsy", function(module, exports) {

$parcel$export(module.exports, "getUsersWithoutProductAccess", () => $3633126b138f492f$export$7121af075bd652a4);

var $1Ozm9 = parcelRequire("1Ozm9");
const $3633126b138f492f$var$getInviteesUrl = '/gateway/api/growth/invite-on-link-insert/get-invitees';
const $3633126b138f492f$export$7121af075bd652a4 = (cloudId, product, accountIds)=>(0, $1Ozm9.default)($3633126b138f492f$var$getInviteesUrl, {
        method: 'POST',
        body: JSON.stringify({
            cloudId: cloudId,
            product: product,
            accountIds: accountIds
        })
    });

});


parcelRegister("3soap", function(module, exports) {

$parcel$export(module.exports, "getPageTitle", () => $97c9a5e11d87a991$export$23286240952da4c9);

var $1Ozm9 = parcelRequire("1Ozm9");
const $97c9a5e11d87a991$var$resolverUrl = '/gateway/api/object-resolver/resolve';
const $97c9a5e11d87a991$export$23286240952da4c9 = async (resourceUrl)=>{
    try {
        const response = await (0, $1Ozm9.default)($97c9a5e11d87a991$var$resolverUrl, {
            method: 'POST',
            body: JSON.stringify({
                resourceUrl: resourceUrl
            })
        });
        return response.data?.name;
    } catch  {
        return undefined;
    }
};

});

parcelRegister("z4hCP", function(module, exports) {

$parcel$export(module.exports, "useCanInvite", () => $f0112ef2292ef4be$export$4fa512abf5d2ba5e);
$parcel$export(module.exports, "useInviteCapability", () => $f0112ef2292ef4be$export$171021d8e67014af);

var $eJOHy = parcelRequire("eJOHy");

var $1Ozm9 = parcelRequire("1Ozm9");

var $gtr2v = parcelRequire("gtr2v");

var $kEUB1 = parcelRequire("kEUB1");


var $7ZbC2 = parcelRequire("7ZbC2");
const $f0112ef2292ef4be$export$8a4a12ca67f0b223 = (cloudId)=>`/gateway/api/v3/invitations/capabilities?resource=ari:cloud:platform::site/${cloudId}`;
const $f0112ef2292ef4be$export$4fa512abf5d2ba5e = ()=>(0, $eJOHy.useCallback)((cloudId, product)=>$f0112ef2292ef4be$export$39ebdf2aa7e6d740(cloudId, product), []);
const $f0112ef2292ef4be$export$39ebdf2aa7e6d740 = async (cloudId, product)=>{
    const capabilities = await (0, $1Ozm9.default)($f0112ef2292ef4be$export$8a4a12ca67f0b223(cloudId));
    const capability = capabilities.find((cap)=>{
        const ari = (0, $gtr2v.AnyAri).parse(cap.resourceARI);
        return ari.resourceOwner === product;
    });
    if (!capability) return false;
    return capability.directInvite?.mode === 'ANYONE' || capability.invitePendingApproval?.mode === 'ANYONE';
};
const $f0112ef2292ef4be$export$171021d8e67014af = ()=>{
    const cloudId = (0, $kEUB1.useCloudId)();
    return (0, $eJOHy.useCallback)(async ()=>{
        const capabilities = await (0, $1Ozm9.default)($f0112ef2292ef4be$export$8a4a12ca67f0b223(cloudId));
        const capability = capabilities.find((cap)=>{
            const ari = (0, $gtr2v.AnyAri).parse(cap.resourceARI);
            return ari.resourceOwner === (0, $e08dff4ae358d899$export$c811f21c9ad05dc2);
        });
        if (capability?.directInvite.mode === 'ANYONE') return (0, $7ZbC2.InviteCapabilities).DIRECT_INVITE;
        if (capability?.invitePendingApproval.mode === 'ANYONE') return (0, $7ZbC2.InviteCapabilities).INVITE_PENDING_APPROVAL;
        return (0, $7ZbC2.InviteCapabilities).NONE;
    }, [
        cloudId
    ]);
};

});
parcelRegister("7ZbC2", function(module, exports) {

$parcel$export(module.exports, "InviteCapabilities", () => $c16846210b939f9c$export$631a5cf24b1fd5a1);
const $c16846210b939f9c$export$631a5cf24b1fd5a1 = {
    DIRECT_INVITE: 'directInvite',
    INVITE_PENDING_APPROVAL: 'invitePendingApproval',
    NONE: 'none'
};

});


parcelRegister("8onhK", function(module, exports) {

$parcel$export(module.exports, "useInviteUsers", () => $06126a731fbbf52b$export$6162654a9c7a7b9a);

var $eJOHy = parcelRequire("eJOHy");

var $1kFb3 = parcelRequire("1kFb3");

var $gYnSx = parcelRequire("gYnSx");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $2zVtv = parcelRequire("2zVtv");

var $hnBBA = parcelRequire("hnBBA");

var $bMq3O = parcelRequire("bMq3O");
const $06126a731fbbf52b$export$6162654a9c7a7b9a = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const currentProduct = (0, $2zVtv.useCurrentProduct)();
    return (0, $eJOHy.useCallback)(async ({ userIds: userIds, continueUrl: continueUrl, tenantId: tenantId, product: product, integration: integration })=>{
        try {
            const origin = new (0, $1kFb3.default)({
                product: (0, $bMq3O.getOriginProduct)(product)
            });
            const continueUrlWithOrigin = origin.addToUrl(continueUrl);
            const originAttributes = origin.toAnalyticsAttributes({
                hasGeneratedId: true
            });
            const inviteApiResponse = await (0, $hnBBA.inviteWithinOrg)({
                userIds: userIds,
                continueUrl: continueUrlWithOrigin,
                tenantId: tenantId,
                product: product,
                sourceProduct: currentProduct
            });
            const response = (0, $bMq3O.handleInviteUsersSuccessResponse)(inviteApiResponse);
            [
                ...response.invited,
                ...response.accessRequested
            ].forEach((invited)=>{
                const resourceAri = (0, $2zVtv.getSiteAri)(tenantId, product);
                const result = invited.results[resourceAri];
                const userId = invited.id;
                const analyticsAttributes = {
                    ...originAttributes,
                    userId: userId,
                    products: [
                        product
                    ],
                    inviteResult: [
                        {
                            resourceAri: resourceAri,
                            status: result
                        }
                    ],
                    integration: integration,
                    isInviteWithinOrg: true
                };
                if (result === 'INVITED') (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'user invited', userId, analyticsAttributes);
                else if (result === 'INVITED_PENDING_APPROVAL') (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'productAccess requested', userId, analyticsAttributes);
            });
            (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), 'promptOnLinkInvite succeeded', {
                invited: response.invited.length,
                requested: response.accessRequested.length,
                errored: response.error.length,
                integration: integration
            });
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $gYnSx.default)({
                meta: {
                    id: 'useInviteUsers',
                    packageName: 'jiraInvitePromptOnLinkInsert'
                },
                error: error,
                attributes: {
                    integration: integration
                }
            });
            throw error;
        }
    }, [
        createAnalyticsEvent,
        currentProduct
    ]);
};

});
parcelRegister("hnBBA", function(module, exports) {

$parcel$export(module.exports, "inviteWithinOrg", () => $954f2603d3acca63$export$a106ce8e40b3d224);

var $7jTnu = parcelRequire("7jTnu");

var $jGzN3 = parcelRequire("jGzN3");

var $2zVtv = parcelRequire("2zVtv");

const $954f2603d3acca63$export$a106ce8e40b3d224 = async ({ userIds: userIds, continueUrl: continueUrl, tenantId: tenantId, product: product, sourceProduct: sourceProduct })=>{
    const resources = [
        (0, $2zVtv.getSiteAri)(tenantId, product)
    ];
    const response = await (0, $jGzN3.performPostRequest)((0, $b7d337061a0b0b72$export$f87741d20d2a10fb), {
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            continueUrl: continueUrl,
            resources: resources,
            userIds: userIds,
            cloudId: tenantId,
            experience: 'invite-on-link-insert',
            sourceProduct: (0, $7jTnu.fg)('invite_prompt_send_source_product_to_iis') ? sourceProduct : undefined
        })
    });
    return response;
};

});
const $b7d337061a0b0b72$export$ff111916f5a23b5a = '/gateway/api/invitations/invite';
const $b7d337061a0b0b72$export$f87741d20d2a10fb = '/gateway/api/growth/groot-invite-within-org/invite';


parcelRegister("bMq3O", function(module, exports) {

$parcel$export(module.exports, "handleInviteUsersSuccessResponse", () => $9d614714f00a9a61$export$bf7ed6f1f1b884e);
$parcel$export(module.exports, "getOriginProduct", () => $9d614714f00a9a61$export$e4853a500db4c6bf);

const $9d614714f00a9a61$export$f6c02f8ff560b96f = (environment)=>{
    switch(environment){
        case 'prod':
            return 0, $057114af36dfa7ff$export$2c2f58a9d84da733;
        case 'staging':
            return 0, $057114af36dfa7ff$export$cd719d3567d9b31d;
        default:
            return 0, $057114af36dfa7ff$export$34c3413ecdf1b634;
    }
};
const $9d614714f00a9a61$export$bf7ed6f1f1b884e = (response)=>response.reduce((accumulator, userResponse)=>{
        const user = {
            id: userResponse.id,
            email: userResponse.email
        };
        Object.keys(userResponse.results).forEach((resource)=>{
            switch(userResponse.results[resource]){
                case 'INVITED':
                case 'USER_EXISTS':
                    accumulator.invited.push({
                        ...user,
                        results: userResponse.results
                    });
                    break;
                case 'INVITED_PENDING_APPROVAL':
                case 'PENDING_INVITE_EXISTS':
                    accumulator.accessRequested.push({
                        ...user,
                        results: userResponse.results
                    });
                    break;
                case 'NOT_INVITED':
                case 'ERROR':
                    accumulator.error.push({
                        ...user,
                        error: userResponse.errorReasons[resource]
                    });
                    break;
                default:
                    throw new Error('Unexpected return type from invite user response');
            }
        });
        return accumulator;
    }, {
        invited: [],
        accessRequested: [],
        error: []
    });
const $9d614714f00a9a61$export$e4853a500db4c6bf = (product)=>{
    product;
    return product;
};

});
const $057114af36dfa7ff$export$2c2f58a9d84da733 = '6LfOcIYhAAAAADBS5OnBllme06dW9vyW4Zgowiru';
const $057114af36dfa7ff$export$cd719d3567d9b31d = '6LebaYYhAAAAAKFQt-KH6vVkTJQqwZddT-HJCIM3';
const $057114af36dfa7ff$export$34c3413ecdf1b634 = '6Le_DxYiAAAAABV8BsFSj3AmZf3OkP9Fh9lfbZOZ';



parcelRegister("aCATI", function(module, exports) {

$parcel$export(module.exports, "useOptOut", () => $88dad524b5262b29$export$7f94797c6e99faf3);

var $eJOHy = parcelRequire("eJOHy");

var $gYnSx = parcelRequire("gYnSx");

var $8q7lT = parcelRequire("8q7lT");

var $32Odr = parcelRequire("32Odr");
const $88dad524b5262b29$var$INVITE_PROMPT_ON_LINK_INSERT_VIEW = 'invite-prompt-on-link-insert-view';
const $88dad524b5262b29$var$INVITE_PROMPT_ON_LINK_INSERT_OPT_OUT = 'invite-prompt-on-link-insert-opt-out';
const $88dad524b5262b29$var$MAX_VIEW_COUNT = 2;
const $88dad524b5262b29$var$shouldShowOptOutOption = async (accountId)=>{
    if (!accountId) return false;
    const viewCount = await $88dad524b5262b29$var$getViewCount(accountId);
    return viewCount >= $88dad524b5262b29$var$MAX_VIEW_COUNT;
};
const $88dad524b5262b29$var$incrementViewCount = async (accountId)=>{
    if (!accountId) return;
    const viewCount = await $88dad524b5262b29$var$getViewCount(accountId);
    if (viewCount < $88dad524b5262b29$var$MAX_VIEW_COUNT) try {
        await (0, $32Odr.setUserProperty)({
            accountId: accountId,
            propertyKey: $88dad524b5262b29$var$INVITE_PROMPT_ON_LINK_INSERT_VIEW,
            propertyValue: viewCount + 1
        });
    // TODO: shall we fire an event here to record the user has viewed the flag?
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gYnSx.default)({
            meta: {
                id: 'incrementViewCount',
                packageName: 'jiraInvitePromptOnLinkInsert'
            },
            error: error
        });
    }
};
const $88dad524b5262b29$var$getViewCount = async (accountId)=>(await (0, $32Odr.getUserProperty)({
        accountId: accountId,
        propertyKey: $88dad524b5262b29$var$INVITE_PROMPT_ON_LINK_INSERT_VIEW,
        defaultValue: 0
    })).value;
const $88dad524b5262b29$var$getOptOutInvitePrompt = async (accountId, propertyKey)=>{
    if (!accountId) return false;
    return (await (0, $32Odr.getUserProperty)({
        accountId: accountId,
        propertyKey: propertyKey,
        defaultValue: false
    })).value;
};
const $88dad524b5262b29$var$setOptOutInvitePrompt = async (accountId, propertyKey)=>{
    if (!accountId) return;
    try {
        await (0, $32Odr.setUserProperty)({
            accountId: accountId,
            propertyKey: propertyKey,
            propertyValue: true
        });
    // TODO: shall we fire an event here to record the user has opted out?
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gYnSx.default)({
            meta: {
                id: 'setOptOutInvitePrompt',
                packageName: 'jiraInvitePromptOnLinkInsert'
            },
            error: error
        });
    }
};
const $88dad524b5262b29$export$7f94797c6e99faf3 = (propertyKey = $88dad524b5262b29$var$INVITE_PROMPT_ON_LINK_INSERT_OPT_OUT)=>{
    const accountId = (0, $8q7lT.useAccountId)();
    return (0, $eJOHy.useMemo)(()=>({
            shouldShowOptOutOption: ()=>$88dad524b5262b29$var$shouldShowOptOutOption(accountId),
            incrementViewCount: ()=>$88dad524b5262b29$var$incrementViewCount(accountId),
            getOptOutStatus: ()=>$88dad524b5262b29$var$getOptOutInvitePrompt(accountId, propertyKey),
            setOptOutStatus: ()=>$88dad524b5262b29$var$setOptOutInvitePrompt(accountId, propertyKey)
        }), [
        accountId,
        propertyKey
    ]);
};

});
parcelRegister("32Odr", function(module, exports) {

$parcel$export(module.exports, "setUserProperty", () => $62ac03102e392dc6$export$ba821ce5e177c7ef);
$parcel$export(module.exports, "getUserProperty", () => $62ac03102e392dc6$export$b3126db2ef6e34ed);

var $jGzN3 = parcelRequire("jGzN3");
const $62ac03102e392dc6$var$getUserUrl = (accountId, propertyKey)=>`/rest/api/3/user/properties/${propertyKey}?accountId=${accountId}`;
const $62ac03102e392dc6$export$ba821ce5e177c7ef = async ({ accountId: accountId, propertyKey: propertyKey, propertyValue: propertyValue })=>{
    const url = $62ac03102e392dc6$var$getUserUrl(accountId, propertyKey);
    try {
        await (0, $jGzN3.performPutRequest)(url, {
            body: JSON.stringify(propertyValue)
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        throw new Error(`Saving ${propertyKey} user property failed. Error: ${error}`);
    }
};
const $62ac03102e392dc6$export$b3126db2ef6e34ed = async ({ accountId: accountId, propertyKey: propertyKey, defaultValue: defaultValue })=>{
    const url = $62ac03102e392dc6$var$getUserUrl(accountId, propertyKey);
    try {
        const response = await (0, $jGzN3.performGetRequest)(url);
        return response;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        return {
            key: propertyKey,
            value: defaultValue
        };
    }
};

});


parcelRegister("1ikCi", function(module, exports) {

$parcel$export(module.exports, "invitePromptOnLinkInsertExperience", () => $50f9bac05903f12b$export$adb25c37e478fcbe);

var $2lxLk = parcelRequire("2lxLk");
var $f39LL = parcelRequire("f39LL");
const $50f9bac05903f12b$export$adb25c37e478fcbe = new (0, $f39LL.UFOExperience)('invite-prompt-on-link-insert', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).PageLoad
});

});

parcelRegister("ftbxH", function(module, exports) {

$parcel$export(module.exports, "useInviteErrorFlag", () => $af54722cb85961c8$export$e6d35b1c4e81af0e);

var $eJOHy = parcelRequire("eJOHy");

var $90d5q = parcelRequire("90d5q");
var $a9cht = parcelRequire("a9cht");
var $bILK0 = parcelRequire("bILK0");

var $lRq8t = parcelRequire("lRq8t");

var $2zVtv = parcelRequire("2zVtv");

var $5P4WW = parcelRequire("5P4WW");
const $af54722cb85961c8$export$e6d35b1c4e81af0e = ()=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $bILK0.useFlagService)();
    return (0, $eJOHy.useCallback)(()=>{
        const id = `error-${(0, $2zVtv.generateId)()}`;
        const dismiss = ()=>dismissFlag((0, $90d5q.dismissFlag)(id));
        showFlag({
            id: id,
            render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($af54722cb85961c8$export$92c0939d1a977673, {
                    ...props,
                    id: id,
                    onDismiss: dismiss
                })
        });
    }, [
        dismissFlag,
        showFlag
    ]);
};
const $af54722cb85961c8$var$JIRA_SUPPORT_LINK = 'https://support.atlassian.com/contact/';
const $af54722cb85961c8$export$92c0939d1a977673 = ({ onDismiss: onDismiss, ...props })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $a9cht.ErrorFlag), {
        ...props,
        onDismissed: onDismiss,
        title: formatMessage((0, $5P4WW.messages).title),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("p", null, formatMessage((0, $5P4WW.messages).description))),
        messageId: `invite-prompt-on-link-insert.ui.invite-error-flag.error-flag.${props.id}`,
        messageType: "transactional",
        actions: [
            {
                content: formatMessage((0, $5P4WW.messages).action),
                href: $af54722cb85961c8$var$JIRA_SUPPORT_LINK,
                target: '_blank'
            }
        ]
    });
};

});
parcelRegister("5P4WW", function(module, exports) {

$parcel$export(module.exports, "messages", () => $addf2a56ecb57355$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $addf2a56ecb57355$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    title: {
        "id": "invite-prompt-on-link-insert.invite-error-flag.title",
        "defaultMessage": "Something went wrong"
    },
    description: {
        "id": "invite-prompt-on-link-insert.invite-error-flag.description",
        "defaultMessage": "Try inviting your teammates again. If the problem persists, contact support."
    },
    action: {
        "id": "invite-prompt-on-link-insert.invite-error-flag.action",
        "defaultMessage": "Contact support"
    }
});

});


parcelRegister("e0JcZ", function(module, exports) {

$parcel$export(module.exports, "useInvitePromptFlag", () => $08267520c14187f3$export$ce7c2ea6d33a7cf4);

var $eJOHy = parcelRequire("eJOHy");

var $3cMgR = parcelRequire("3cMgR");

var $22c3C = parcelRequire("22c3C");
var $90d5q = parcelRequire("90d5q");
var $bILK0 = parcelRequire("bILK0");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $2SI84 = parcelRequire("2SI84");

var $2zVtv = parcelRequire("2zVtv");

var $bq0Xz = parcelRequire("bq0Xz");
const $08267520c14187f3$export$ce7c2ea6d33a7cf4 = ()=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $bILK0.useFlagService)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    return (0, $eJOHy.useCallback)(({ targetPageLabel: targetPageLabel, product: product, source: source, users: users, allowOptOut: allowOptOut, onSubmit: onSubmit, onDismiss: onDismiss, onOptOut: onOptOut })=>{
        const id = `invite-${(0, $2zVtv.generateId)()}`;
        const dismissTheFlag = ()=>dismissFlag((0, $90d5q.dismissFlag)(id));
        const attributes = {
            invitees: users.length,
            renderedPageTitle: !!targetPageLabel,
            allowOptOut: allowOptOut,
            inviteeIds: users.map((user)=>user.id),
            source: source,
            product: product
        };
        const submit = async ()=>{
            (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'addPeopleButtonInviteOnLinkInsert', attributes);
            await onSubmit();
            dismissTheFlag();
        };
        const optOut = ()=>{
            dismissTheFlag();
            onOptOut();
            (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'optOutButtonInviteOnLinkInsert', attributes);
        };
        const dismiss = ()=>{
            dismissTheFlag();
            onDismiss();
            (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'flag dismissed', 'inviteOnLinkInsert', attributes);
        };
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'flag shown', 'inviteOnLinkInsert', attributes);
        showFlag({
            id: id,
            isLowPriority: true,
            render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($08267520c14187f3$export$d6bef3efd7271258, {
                    id: id,
                    users: users,
                    onDismiss: dismiss,
                    onSubmit: submit,
                    onOptOut: allowOptOut ? optOut : undefined,
                    product: product,
                    targetPageLabel: targetPageLabel
                })
        });
    }, [
        createAnalyticsEvent,
        dismissFlag,
        showFlag
    ]);
};
const $08267520c14187f3$export$d6bef3efd7271258 = ({ id: id, onDismiss: onDismiss, onSubmit: onSubmit, onOptOut: onOptOut, users: users, product: product, targetPageLabel: targetPageLabel })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const productDisplayName = (0, $2zVtv.getProductDisplayName)(product);
    const maxLength = 40;
    const clampedTargetPageLabel = (0, $2zVtv.clampString)(targetPageLabel || '', maxLength);
    const actions = (0, $eJOHy.useMemo)(()=>{
        const allActions = [
            {
                content: formatMessage((0, $bq0Xz.messages).addPeopleButton, {
                    inviteeCount: users.length,
                    displayName: users[0].name.split(' ')[0]
                }),
                onClick: onSubmit
            },
            {
                content: formatMessage((0, $bq0Xz.messages).dismiss, {}),
                onClick: onOptOut
            }
        ];
        return onOptOut ? allActions : allActions.slice(0, 1);
    }, [
        users,
        onSubmit,
        onOptOut,
        formatMessage
    ]);
    const description = targetPageLabel ? formatMessage((0, $bq0Xz.messages).descriptionWithPageTitleGeneric, {
        strong: (...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
                as: "strong"
            }, chunks.join('')),
        inviteeCount: users.length,
        title: clampedTargetPageLabel,
        productDisplayName: productDisplayName,
        displayName: users[0].name.split(' ')[0]
    }) : formatMessage((0, $bq0Xz.messages).descriptionWithoutPageTitleGeneric, {
        strong: (...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
                as: "strong"
            }, chunks.join('')),
        inviteeCount: users.length,
        productDisplayName: productDisplayName,
        displayName: users[0].name.split(' ')[0]
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $22c3C.default), {
        id: id,
        onDismissed: onDismiss,
        title: formatMessage((0, $bq0Xz.messages).titleGeneric, {
            inviteeCount: users.length,
            displayName: users[0].name
        }),
        description: description,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2SI84.FlagCompatibleAvatarGroup), {
            data: users.map((user)=>({
                    name: user.name,
                    src: user.avatar
                })),
            boundariesElement: "scrollParent",
            useSmallAvatars: true
        }),
        actions: actions,
        messageType: "marketing",
        messageId: "invite-prompt-on-link-insert.ui.invite-prompt-flag.ak-flag.info-flag.invite-prompt-flag"
    });
};

});
parcelRegister("2SI84", function(module, exports) {

$parcel$export(module.exports, "FlagCompatibleAvatarGroup", () => $dca124af7b5f5e51$export$29beada2d5f93289);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $12DRg = parcelRequire("12DRg");

var $iwbbq = parcelRequire("iwbbq");

var $gqBnP = parcelRequire("gqBnP");
const $dca124af7b5f5e51$var$MAX_AVATARS_FEATURED = 5;
const $dca124af7b5f5e51$var$MAX_SMALL_AVATARS_FEATURED = 2;
const $dca124af7b5f5e51$var$MAX_OVERFLOW_USER_COUNT_DISPLAYED = 99;
const $dca124af7b5f5e51$var$OVERFLOW_USER_MARKER = '$$$overflow-user-marker';
const $dca124af7b5f5e51$export$29beada2d5f93289 = ({ data: data, useSmallAvatars: useSmallAvatars, ...props })=>{
    const maxAvatarCount = useSmallAvatars ? $dca124af7b5f5e51$var$MAX_SMALL_AVATARS_FEATURED : $dca124af7b5f5e51$var$MAX_AVATARS_FEATURED;
    const { data: customData, overrides: customOverrides } = (0, $eJOHy.useMemo)(()=>$dca124af7b5f5e51$export$bc55c1ff86d63c4d({
            data: data,
            useSmallAvatars: useSmallAvatars
        }), [
        data,
        useSmallAvatars
    ]);
    const avatarGroup = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gqBnP.default), {
        maxCount: maxAvatarCount,
        data: customData,
        overrides: customOverrides,
        boundariesElement: "scrollParent",
        tooltipPosition: "top",
        onMoreClick: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
        size: useSmallAvatars ? 'small' : 'medium',
        ...props
    });
    return avatarGroup;
};
const $dca124af7b5f5e51$export$bc55c1ff86d63c4d = ({ data: users, useSmallAvatars: useSmallAvatars })=>{
    const maxAvatarCount = useSmallAvatars ? $dca124af7b5f5e51$var$MAX_SMALL_AVATARS_FEATURED : $dca124af7b5f5e51$var$MAX_AVATARS_FEATURED;
    const overflows = users.length > maxAvatarCount;
    const lastFeaturedUser = maxAvatarCount - 1;
    const featuredUsers = users.slice(0, lastFeaturedUser);
    const overflowUsers = users.slice(lastFeaturedUser);
    const overflowMarkerDummyUser = $dca124af7b5f5e51$export$1b8d8867a2d1ffbd(overflowUsers);
    const processedUsers = overflows ? [
        ...featuredUsers,
        overflowMarkerDummyUser
    ] : users;
    const overrides = {
        Avatar: {
            render: (AvatarComponent, avatarProps)=>{
                if (avatarProps.name === overflowMarkerDummyUser.name && avatarProps.key === overflowMarkerDummyUser.key) return $dca124af7b5f5e51$var$renderAvatarWithOverflowCount(AvatarComponent, avatarProps, overflowUsers.length, useSmallAvatars);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(AvatarComponent, avatarProps);
            }
        }
    };
    return {
        overrides: overrides,
        data: processedUsers
    };
};
const $dca124af7b5f5e51$export$1b8d8867a2d1ffbd = (overflowUsers)=>({
        name: overflowUsers.map((u)=>u.name).join(', '),
        key: $dca124af7b5f5e51$var$OVERFLOW_USER_MARKER
    });
const $dca124af7b5f5e51$var$renderAvatarWithOverflowCount = (AvatarComponent, avatarProps, overflowCount, useSmallAvatars)=>{
    const Container = useSmallAvatars ? $dca124af7b5f5e51$var$SmallAvatarOverflowCountContainer : $dca124af7b5f5e51$var$AvatarOverflowCountContainer;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(AvatarComponent, {
        name: avatarProps.name,
        appearance: avatarProps.appearance,
        size: avatarProps.size,
        borderColor: avatarProps.borderColor,
        stackIndex: 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iwbbq.AvatarContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Container, null, `+${Math.min(overflowCount, $dca124af7b5f5e51$var$MAX_OVERFLOW_USER_COUNT_DISPLAYED)}`)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $dca124af7b5f5e51$var$AvatarOverflowCountContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4cvr1h6o _6a6z1h6o _1bsb1osq _4t3i1osq _1e0c11p5 _bfhkm7j4 _syaz1fxt _y3gn1h6o _k48p1wq8",
            __cmplp.className
        ])
    });
});
const $dca124af7b5f5e51$var$SmallAvatarOverflowCountContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $dca124af7b5f5e51$var$AvatarOverflowCountContainer, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c81o8v",
            __cmplp.className
        ])
    });
});

});

parcelRegister("bq0Xz", function(module, exports) {

$parcel$export(module.exports, "messages", () => $ddee942c5ca6cd66$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $ddee942c5ca6cd66$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    addPeopleButton: {
        "id": "invite-prompt-on-link-insert.invite-prompt-flag.add-people-button",
        "defaultMessage": "{inviteeCount, plural, one {Add {displayName}} other {Add # people}}"
    },
    dismiss: {
        "id": "invite-prompt-on-link-insert.invite-prompt-flag.dismiss",
        "defaultMessage": "Don't show again"
    },
    titleGeneric: {
        "id": "invite-prompt-on-link-insert.invite-prompt-flag.title-generic",
        "defaultMessage": "{inviteeCount, plural, one {{displayName} may need access} other {Your team may need access}}"
    },
    descriptionWithoutPageTitleGeneric: {
        "id": "invite-prompt-on-link-insert.invite-prompt-flag.description-without-page-title-generic",
        "defaultMessage": "{inviteeCount, plural, one {Your project assignee <strong>{displayName}</strong> needs access to <strong>{productDisplayName}</strong>.} other {# project assignees need access to <strong>{productDisplayName}</strong>.}}"
    },
    descriptionWithPageTitleGeneric: {
        "id": "invite-prompt-on-link-insert.invite-prompt-flag.description-with-page-title-generic",
        "defaultMessage": "{inviteeCount, plural, one {Your project assignee <strong>{displayName}</strong> needs access to {productDisplayName} to view <strong>{title}</strong>.} other {# project assignees need access to {productDisplayName} to view <strong>{title}</strong>.}}"
    }
});

});


parcelRegister("eunhC", function(module, exports) {

$parcel$export(module.exports, "useInviteSuccessFlag", () => $3db4da82b1d8dba6$export$c323779e5ddf45d0);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $3cMgR = parcelRequire("3cMgR");

var $90d5q = parcelRequire("90d5q");
var $a9cht = parcelRequire("a9cht");
var $bILK0 = parcelRequire("bILK0");

var $lRq8t = parcelRequire("lRq8t");

var $2zVtv = parcelRequire("2zVtv");

var $5Mnj2 = parcelRequire("5Mnj2");
const $3db4da82b1d8dba6$export$c323779e5ddf45d0 = ()=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $bILK0.useFlagService)();
    return (0, $eJOHy.useCallback)(({ userIds: userIds, product: product, requireAdminApproval: requireAdminApproval })=>{
        const id = `success-${(0, $2zVtv.generateId)()}`;
        const dismiss = ()=>dismissFlag((0, $90d5q.dismissFlag)(id));
        showFlag({
            id: id,
            render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3db4da82b1d8dba6$export$6c436beee6e5593, {
                    ...props,
                    id: id,
                    userIds: userIds,
                    onDismiss: dismiss,
                    product: product,
                    requireAdminApproval: requireAdminApproval
                })
        });
    }, [
        dismissFlag,
        showFlag
    ]);
};
const $3db4da82b1d8dba6$export$6c436beee6e5593 = ({ userIds: userIds, onDismiss: onDismiss, product: product, requireAdminApproval: requireAdminApproval, ...props })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const productDisplayName = (0, $2zVtv.getProductDisplayName)(product);
    const customFlagFooterProps = (0, $eJOHy.useMemo)(()=>({
            actions: [
                {
                    content: '',
                    // Replace with lodash/noop
                    // eslint-disable-next-line @typescript-eslint/no-empty-function
                    onClick: ()=>{}
                }
            ],
            linkComponent: ()=>requireAdminApproval && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3db4da82b1d8dba6$var$FooterParagraph, null, formatMessage((0, $5Mnj2.messages).additionalInfoGeneric, {
                    strong: (...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
                            as: "strong"
                        }, chunks.join('')),
                    productDisplayName: productDisplayName
                }))
        }), [
        formatMessage,
        requireAdminApproval,
        productDisplayName
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $a9cht.SuccessFlag), {
        ...props,
        ...customFlagFooterProps,
        onDismissed: onDismiss,
        title: formatMessage((0, $5Mnj2.messages).title, {
            inviteeCount: userIds.length
        }),
        description: // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("p", null, formatMessage((0, $5Mnj2.messages).descriptionGeneric, {
            strong: (...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
                    as: "strong"
                }, chunks.join('')),
            inviteeCount: userIds.length,
            productDisplayName: productDisplayName
        }))
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3db4da82b1d8dba6$var$FooterParagraph = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_syaz1gjq _t9ec1gty",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5Mnj2", function(module, exports) {

$parcel$export(module.exports, "messages", () => $42ca704fda04df68$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $42ca704fda04df68$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    title: {
        "id": "invite-prompt-on-link-insert.invite-success-flag.title",
        "defaultMessage": "{inviteeCount, plural, one {Invite successfully sent} other {Invites successfully sent}}"
    },
    dismiss: {
        "id": "invite-prompt-on-link-insert.invite-success-flag.dismiss",
        "defaultMessage": "Ok, got it"
    },
    descriptionGeneric: {
        "id": "invite-prompt-on-link-insert.invite-success-flag.description-generic",
        "defaultMessage": "{inviteeCount, plural, one {<strong># project assignee</strong> will get an email inviting them to <strong>{productDisplayName}</strong>.} other {<strong># project assignees</strong> will get an email inviting them to <strong>{productDisplayName}</strong>.}}"
    },
    additionalInfoGeneric: {
        "id": "invite-prompt-on-link-insert.invite-success-flag.additional-info-generic",
        "defaultMessage": "Admin may need to approve some assignees before they can join <strong>{productDisplayName}</strong>."
    }
});

});




parcelRegister("esAgg", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0814308233d0721$export$2e2bcd8739ae039);

var $8dH3d = parcelRequire("8dH3d");

var $jFHCE = parcelRequire("jFHCE");

var $8sbs2 = parcelRequire("8sbs2");

var $eDBhy = parcelRequire("eDBhy");

var $7jTnu = parcelRequire("7jTnu");

var $1uIew = parcelRequire("1uIew");

var $iIqFO = parcelRequire("iIqFO");

var $5acEa = parcelRequire("5acEa");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $3PFy3 = parcelRequire("3PFy3");

var $epTsa = parcelRequire("epTsa");

var $lz17b = parcelRequire("lz17b");


var $7aB6t = parcelRequire("7aB6t");

var $03ZrM = parcelRequire("03ZrM");

var $7aC2p = parcelRequire("7aC2p");
const $d0814308233d0721$var$getLabelsField = (formData, fieldConfig)=>{
    const labelsOutput = [];
    Object.keys(formData).forEach((fieldId)=>{
        const fieldData = fieldConfig[fieldId];
        if (fieldData?.gqlType === (0, $af620ae3ac843a8a$export$64c7789e86344de5)) labelsOutput.push(fieldId);
    });
    return labelsOutput;
};
const $d0814308233d0721$var$useCreateIssueService = (selectedCloudId = '')=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { fireErrorAnalyticsEvent: fireErrorAnalyticsEvent } = (0, $lz17b.useIssueCreateErrorAnalyticsEvent)();
    const createIssue = ({ onSuccess: onSuccess, formData: formData, transition: inputTransition, watchers: watchers, skipAutoWatch: skipAutoWatch, fieldConfig: fieldConfig, fieldTabs: fieldTabs, hasIssueAdjustmentModules: hasIssueAdjustmentModules, context: context, createLinkedIssuePayload: createLinkedIssuePayload, interactedFields: interactedFields = {}, shouldShowStatus: shouldShowStatus = false })=>{
        let transformedData = (0, $03ZrM.transformData)(formData, fieldConfig);
        const additionalFields = context?.submitApiData?.additionalFields || {};
        const issueList = context?.submitApiData?.issueList || null;
        const transition = inputTransition ?? context?.submitApiData?.transition;
        const { isCreateLinkedIssue: isCreateLinkedIssue, sourceIssueKey: sourceIssueKey } = createLinkedIssuePayload || {};
        // add copy links and attachments data to issuelinks and attachment field submit payload
        if (isCreateLinkedIssue && sourceIssueKey && (0, $7jTnu.fg)('create_linked_issues_trigger_point_issue_view')) transformedData = (0, $03ZrM.handleCopyLinksAndAttachments)({
            transformedData: transformedData,
            formData: formData,
            sourceIssueKey: sourceIssueKey
        });
        const updateFields = (0, $03ZrM.getUpdateFields)(isCreateLinkedIssue && Boolean(sourceIssueKey) && (0, $7jTnu.fg)('create_linked_issues_trigger_point_issue_view'));
        const labelsFields = $d0814308233d0721$var$getLabelsField(formData, fieldConfig);
        const updateFieldsWithLabels = (0, $epTsa.expVal)('adding-color-to-labels-field-experiment-milestone2', 'isColorfulNewLabelsEnabled', false) ? [
            ...updateFields,
            ...labelsFields
        ] : updateFields;
        const payload = {
            fields: (0, $7jTnu.fg)('gic_exclude_update_fields_from_additional_fields') ? (0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))({
                ...additionalFields,
                ...transformedData
            }, updateFieldsWithLabels) : {
                ...additionalFields,
                ...(0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(transformedData, updateFieldsWithLabels)
            },
            update: (0, (/*@__PURE__*/$parcel$interopDefault($8sbs2)))(transformedData, updateFieldsWithLabels),
            ...!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(issueList) && {
                issueList: issueList
            },
            transition: undefined,
            watchers: watchers,
            externalToken: (0, $3PFy3.default)().toString()
        };
        // @ts-expect-error - TS2322 - Type '{ id: string; }' is not assignable to type 'undefined'.
        if (transition) payload.transition = transition;
        (0, $iIqFO.GlobalIssueCreateModalSubmitUFOExperience).start();
        const getCollapsedFields = ()=>!hasIssueAdjustmentModules && fieldTabs ? fieldTabs.flatMap((tab)=>tab.collapsedItems || []) : [];
        const MAX_RETRIES = 1;
        const performPostRequestRetry = (retryCount)=>{
            const analyticsEvent = createAnalyticsEvent({});
            return (0, $7aB6t.performPost)((0, $5acEa.transformCreateIssueUrl)({
                issueUrl: (0, $7aC2p.getCreateIssueUrl)({
                    isCreateLinkedIssue: isCreateLinkedIssue || false,
                    skipAutoWatch: skipAutoWatch
                }),
                selectedCloudId: selectedCloudId
            }), {
                body: JSON.stringify(payload)
            }).then((issueCreateResponse)=>{
                const statusWasSet = issueCreateResponse && issueCreateResponse.transition !== undefined;
                const collapsedFields = getCollapsedFields();
                let modifiedFieldConfig = fieldConfig;
                let modifiedFormData = formData;
                let modifiedInteractedFields = interactedFields;
                // If the form has a status field provided, the formConfig and formData
                // will be modified on `transformDataToIssueCreateFieldsUsed` to have the
                // hasDefaultValue and isPopulated attributes set to true for status. If the user
                // has modified the status field, the response of the API will return a transition props
                // which is used to modify the interactedFields to set hasInteractedWith to true for status.
                if (shouldShowStatus) {
                    modifiedFieldConfig = {
                        ...fieldConfig,
                        status: {
                            ...fieldConfig.status,
                            defaultValue: true
                        }
                    };
                    modifiedFormData = {
                        ...formData,
                        status: true
                    };
                    if (statusWasSet) modifiedInteractedFields = {
                        ...interactedFields,
                        status: true
                    };
                }
                const issueCreateFieldsUsed = (0, $03ZrM.transformDataToIssueCreateFieldsUsed)(modifiedFormData, modifiedFieldConfig, modifiedInteractedFields, collapsedFields);
                const issueCreateContextUsed = (0, $03ZrM.transformContextDataUsedForCreate)(context);
                (0, $iIqFO.CreateIssueUFOExperience).success();
                (0, $iIqFO.GlobalIssueCreateModalSubmitUFOExperience).success();
                if (issueCreateResponse?.transition?.status && issueCreateResponse.transition.status !== 200) (0, $eDBhy.fireIssueCreateErrorAnalytics)({
                    meta: {
                        id: 'useCreateIssueService',
                        packageName: 'jiraIssueCreate',
                        teamName: 'gryffindor'
                    },
                    attributes: {
                        status: issueCreateResponse.transition.status,
                        message: (issueCreateResponse.transition.errorCollection?.errorMessages || []).join('\n')
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                const collapsedFieldsLength = collapsedFields.length;
                onSuccess({
                    issueCreateResponse: issueCreateResponse,
                    issueCreateFieldsUsed: issueCreateFieldsUsed,
                    issueCreateContextUsed: issueCreateContextUsed,
                    collapsedFieldsLength: collapsedFieldsLength
                });
                const attributes = {
                    isRetry: retryCount < MAX_RETRIES,
                    statusCode: '2xx'
                };
                (0, $gCeeo.fireTrackAnalyticsDeferred)(analyticsEvent, 'issueCreate retry', attributes);
            }).catch((error)=>{
                if (String(error.statusCode).startsWith('5')) {
                    if (retryCount < MAX_RETRIES) {
                        const attributes = {
                            isRetry: true,
                            statusCode: '5xx'
                        };
                        (0, $gCeeo.fireTrackAnalyticsDeferred)(analyticsEvent, 'issueCreate retry', attributes);
                    }
                    if (retryCount > 0) return performPostRequestRetry(retryCount - 1);
                }
                let statusCode;
                if (error instanceof (0, $1uIew.default)) statusCode = error?.statusCode;
                fireErrorAnalyticsEvent({
                    meta: {
                        id: 'useCreateIssueService',
                        packageName: 'jiraIssueCreate',
                        teamName: 'gryffindor'
                    },
                    error: error,
                    statusCode: statusCode
                });
                (0, $iIqFO.CreateIssueUFOExperience).failure();
                (0, $iIqFO.GlobalIssueCreateModalSubmitUFOExperience).failure();
                throw error;
            });
        };
        return performPostRequestRetry(MAX_RETRIES);
    };
    return [
        createIssue
    ];
};
var $d0814308233d0721$export$2e2bcd8739ae039 = $d0814308233d0721$var$useCreateIssueService;

});
parcelRegister("3PFy3", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9486a34b5c48d65$export$2e2bcd8739ae039);
// code-reaper-ignore-file -- Alternative implementation of random numbers for the browser.
const $d9486a34b5c48d65$var$MAX_UINT32 = 4294967296;
function $d9486a34b5c48d65$export$2e2bcd8739ae039() {
    try {
        const buf = new Uint32Array(1);
        // buf now has a random uint32 value
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.crypto.getRandomValues(buf);
        // Turn it back into a value in [0,1)
        return buf[0] / $d9486a34b5c48d65$var$MAX_UINT32;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        return Math.random();
    }
}

});

parcelRegister("7aB6t", function(module, exports) {

$parcel$export(module.exports, "performPost", () => $51bb52bb2bb86f7c$export$8fc3e0df78e1e7f5);


var $1uIew = parcelRequire("1uIew");

var $1oMOM = parcelRequire("1oMOM");

var $jGzN3 = parcelRequire("jGzN3");

var $7AheX = parcelRequire("7AheX");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $51bb52bb2bb86f7c$var$processResponseFromServer = (response)=>{
    if (response.status === (0, $44ccf6b895337c89$export$3288b14b6745c572)) return Promise.resolve(null);
    return response.text().then((text)=>text ? JSON.parse(text) : null);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $51bb52bb2bb86f7c$var$handleNetworkErrors = (err)=>{
    if (err instanceof TypeError) throw new Error('Failed to fetch', {
        cause: err
    });
    throw err;
};
const $51bb52bb2bb86f7c$var$handleErrors = async (response)=>{
    const clone = response.clone();
    const res = await response.json();
    const traceId = (0, $7AheX.getTraceId)(response);
    // handle CONFLICT and TOO_MANY_REQUESTS using validation error handlers.
    if ([
        (0, $44ccf6b895337c89$export$9de493bcd9b1d977),
        (0, $44ccf6b895337c89$export$c09e7ea0fc79f34f),
        (0, $44ccf6b895337c89$export$6763168a631449a2),
        (0, $44ccf6b895337c89$export$67d19e9a991baa07),
        (0, $44ccf6b895337c89$export$a3269a3914b007e3),
        (0, $44ccf6b895337c89$export$a447d0a965e16776)
    ].find((i)=>i === response.status)) throw (0, $jGzN3.transformValidationErrorFromServer)(res, response.status, traceId);
    if (res?.errorMessages) throw res.errorMessages.join('\n');
    if (!response.ok) {
        if (traceId !== undefined && traceId.length > 0) throw new (0, $1uIew.default)(response.status, `Error server response: ${response.status}`, traceId);
        else throw new (0, $1uIew.default)(response.status, `Error server response: ${response.status}`);
    }
    return clone;
};
const $51bb52bb2bb86f7c$export$8fc3e0df78e1e7f5 = (url, options = {})=>{
    const defaultOptions = (0, $1oMOM.getDefaultOptions)(url);
    const mergedOpts = {
        ...defaultOptions,
        ...options,
        method: 'POST',
        headers: {
            ...defaultOptions.headers,
            ...options.headers
        }
    };
    return fetch(url, mergedOpts).then($51bb52bb2bb86f7c$var$handleErrors).then($51bb52bb2bb86f7c$var$processResponseFromServer).catch($51bb52bb2bb86f7c$var$handleNetworkErrors);
};

});

parcelRegister("03ZrM", function(module, exports) {

$parcel$export(module.exports, "transformData", () => $9ffbbbd45b6e0155$export$3ceb62baab058c6b);
$parcel$export(module.exports, "transformDataToIssueCreateFieldsUsed", () => $9ffbbbd45b6e0155$export$cd0a7e468fa77da3);
$parcel$export(module.exports, "transformContextDataUsedForCreate", () => $9ffbbbd45b6e0155$export$59dd9eec92eadfdd);
$parcel$export(module.exports, "handleCopyLinksAndAttachments", () => $9ffbbbd45b6e0155$export$16a7d356b78628b0);
$parcel$export(module.exports, "getUpdateFields", () => $9ffbbbd45b6e0155$export$3312ec73143db50);

var $8dH3d = parcelRequire("8dH3d");

var $814y1 = parcelRequire("814y1");

var $dk7W5 = parcelRequire("dk7W5");

var $1eq5t = parcelRequire("1eq5t");
const $9ffbbbd45b6e0155$export$3ceb62baab058c6b = (formData, fieldConfig)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(formData).reduce((acc, fieldId)=>{
        // context fields are not part of field config
        const fieldData = fieldConfig[fieldId];
        if (fieldData) {
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly JiraAffectedServicesField: { readonly Component: AbstractComponent<ReturnComponentProps<AffectedServicesFieldConfig>, any>; readonly defaultValueKey: "selectedAffectedServices"; readonly submitTransform: (options: AffectedServiceOption[]) => ServiceEntity[]; readonly retainUserInputTransform: (selectedAff...'.
            const transformFunction = (0, $1eq5t.getGqlFieldMap)()[fieldData.gqlType]?.submitTransform;
            const transformedData = transformFunction && formData[fieldId] !== null && formData[fieldId] !== undefined ? transformFunction(formData[fieldId]) : formData[fieldId];
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            return {
                ...acc,
                [fieldId]: transformedData
            };
        }
        // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
        return {
            ...acc,
            [fieldId]: formData[fieldId]
        };
    }, {});
const $9ffbbbd45b6e0155$export$95572daab36eec17 = (fieldValue)=>{
    if (typeof fieldValue === 'object' && fieldValue !== null) {
        // check for linked issue field
        if ('issues' in fieldValue) return fieldValue.issues.length > 0;
        // check for rich text field
        if ('content' in fieldValue && 'version' in fieldValue && 'type' in fieldValue) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return !(0, $dk7W5.isOnlyWhitespaceAdf)(fieldValue);
    }
    return typeof fieldValue === 'number' || typeof fieldValue === 'boolean' || !(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(fieldValue);
};
const $9ffbbbd45b6e0155$export$cd0a7e468fa77da3 = (formData, fieldConfig, interactedFields, collapsedFields)=>{
    const issueCreateFieldsUsed = [];
    Object.keys(fieldConfig).forEach((fieldId)=>{
        const fieldValue = formData[fieldId];
        issueCreateFieldsUsed.push({
            issueFieldId: fieldId,
            issueFieldType: fieldConfig[fieldId].fieldType,
            gqlType: fieldConfig[fieldId].gqlType,
            isPopulated: $9ffbbbd45b6e0155$export$95572daab36eec17(fieldValue),
            isRequired: !!fieldConfig[fieldId].isRequired,
            hasDefaultValue: !!fieldConfig[fieldId].defaultValue,
            wasInteractedWith: !!interactedFields?.[fieldId],
            wasCollapsed: collapsedFields.includes(fieldId)
        });
    });
    // @ts-expect-error - TS7005 - Variable 'issueCreateFieldsUsed' implicitly has an 'any[]' type.
    return issueCreateFieldsUsed;
};
const $9ffbbbd45b6e0155$export$59dd9eec92eadfdd = (context)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(context)) return {};
    return {
        wereAdditionalFieldsProvided: !(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(context?.submitApiData?.additionalFields),
        isIssueListProvided: !(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(context?.submitApiData?.issueList?.addTo)
    };
};
const $9ffbbbd45b6e0155$export$4c4230f34434cbdf = ({ attachments: attachments, issueLinksValue: issueLinksValue, sourceIssueKey: sourceIssueKey })=>[
        ...attachments ? [
            {
                set: attachments
            }
        ] : [],
        ...issueLinksValue?.includeAttachments ? [
            {
                copy: {
                    sourceIssues: [
                        {
                            key: sourceIssueKey
                        }
                    ]
                }
            }
        ] : []
    ];
const $9ffbbbd45b6e0155$export$8310c11186fc8627 = ({ issueLinksTransformedData: issueLinksTransformedData, issueLinksValue: issueLinksValue, sourceIssueKey: sourceIssueKey })=>[
        ...issueLinksTransformedData || [],
        ...issueLinksValue?.includeLinks ? [
            {
                copy: {
                    sourceIssues: [
                        {
                            key: sourceIssueKey
                        }
                    ]
                }
            }
        ] : []
    ];
const $9ffbbbd45b6e0155$export$16a7d356b78628b0 = ({ transformedData: transformedData, formData: formData, sourceIssueKey: sourceIssueKey })=>{
    const issueLinksValue = formData[0, $814y1.ISSUE_LINKS_TYPE];
    return {
        ...transformedData,
        [(0, $814y1.ATTACHMENT_TYPE)]: $9ffbbbd45b6e0155$export$4c4230f34434cbdf({
            attachments: transformedData[0, $814y1.ATTACHMENT_TYPE],
            issueLinksValue: issueLinksValue,
            sourceIssueKey: sourceIssueKey
        }),
        [(0, $814y1.ISSUE_LINKS_TYPE)]: $9ffbbbd45b6e0155$export$8310c11186fc8627({
            issueLinksTransformedData: transformedData[0, $814y1.ISSUE_LINKS_TYPE],
            issueLinksValue: issueLinksValue,
            sourceIssueKey: sourceIssueKey
        })
    };
};
const $9ffbbbd45b6e0155$export$3312ec73143db50 = (isCreateLinkedIssue = false)=>isCreateLinkedIssue ? (0, $1eq5t.UPDATE_FIELDS_CREATE_LINKED_ISSUE) : (0, $1eq5t.UPDATE_FIELDS);

});
parcelRegister("dk7W5", function(module, exports) {

$parcel$export(module.exports, "emptyAdfObject", () => $330901af3cc572d4$export$202742e99f678c60);
$parcel$export(module.exports, "removeCollectionFromAdf", () => $330901af3cc572d4$export$9e9311e676291037);
$parcel$export(module.exports, "convertAdfStringToObject", () => $330901af3cc572d4$export$ee70d4eb14697455);
$parcel$export(module.exports, "isOnlyWhitespaceAdf", () => $330901af3cc572d4$export$cf4bde415465976c);
$parcel$export(module.exports, "removeNewLineCharactersFromAdf", () => $330901af3cc572d4$export$d6ce0667c33b94ff);
$parcel$export(module.exports, "removeTrailingNewLineCharacters", () => $330901af3cc572d4$export$3688e35a300432d6);
$parcel$export(module.exports, "simplifyAdf", () => $330901af3cc572d4$export$def86d25f0c7f0bc);
$parcel$export(module.exports, "hasEmojiNode", () => $330901af3cc572d4$export$8c6c40d1455b914a);
$parcel$export(module.exports, "hasMediaFileNodes", () => $330901af3cc572d4$export$9a632b58fb9b287c);
$parcel$export(module.exports, "hasMediaFileNodesUpdated", () => $330901af3cc572d4$export$80a6e90c7b29d88c);

var $fpoq4 = parcelRequire("fpoq4");
var $0mclG = parcelRequire("0mclG");

var $eSnSE = parcelRequire("eSnSE");
const $330901af3cc572d4$export$202742e99f678c60 = {
    type: 'doc',
    version: 1,
    content: []
};
const $330901af3cc572d4$export$9e9311e676291037 = (adf)=>{
    if (adf === null || adf === undefined) return null;
    if (adf.type === 'media' && adf.attrs) return {
        ...adf,
        attrs: {
            ...adf.attrs,
            collection: ''
        }
    };
    if (adf.type === 'mediaInline' && adf.attrs) return {
        ...adf,
        attrs: {
            ...adf.attrs,
            collection: ''
        }
    };
    if (adf.content) return {
        ...adf,
        content: adf.content.map($330901af3cc572d4$export$9e9311e676291037)
    };
    return adf;
};
const $330901af3cc572d4$export$ee70d4eb14697455 = (adf)=>{
    if (typeof adf === 'string') try {
        return $330901af3cc572d4$export$9e9311e676291037(JSON.parse(adf));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $eSnSE.default).safeErrorWithoutCustomerData('rich-content.convert-adf-to-object', 'Failed to parse rich content', error);
        return null;
    }
    return $330901af3cc572d4$export$9e9311e676291037(adf);
};
const $330901af3cc572d4$export$cf4bde415465976c = (adf)=>adf && adf.content ? adf.content.every((content)=>{
        if (content.type === 'paragraph') return !content.content || content.content.length === 0 || content.content.every((innerContent)=>innerContent.type === 'text' ? (innerContent.text || '').match(/^\s*$/) !== null : false);
        return false;
    }) : false;
const $330901af3cc572d4$export$d6ce0667c33b94ff = (adf)=>{
    if (!adf || !adf.content) return $330901af3cc572d4$export$202742e99f678c60;
    let len;
    for(len = adf.content.length - 1; len >= 0 && adf.content[len].content && adf.content[len].type === 'paragraph' && adf.content[len].content.length === 0; len -= 1){
        // if the last item of the node is of type mediaGroup, we don't want to strip newline character as
        // it practically makes it unclickable. Leave a new line character so there is still some space for ppl to click
        if (len > 0 && adf.content[len - 1].type === 'mediaGroup') break;
    }
    return {
        ...adf,
        content: adf.content.slice(0, len + 1)
    };
};
const $330901af3cc572d4$export$3688e35a300432d6 = (text)=>text.replace(/[\r\n]+$/, '');
const $330901af3cc572d4$export$def86d25f0c7f0bc = (adf)=>$330901af3cc572d4$export$cf4bde415465976c(adf) ? $330901af3cc572d4$export$202742e99f678c60 : adf;
const $330901af3cc572d4$export$8c6c40d1455b914a = (doc)=>{
    let hasEmoji = false;
    (0, $0mclG.traverse)(doc, {
        emoji: ()=>{
            hasEmoji = true;
            return false; // stop traversing
        }
    });
    return hasEmoji;
};
const $330901af3cc572d4$export$9a632b58fb9b287c = (doc)=>{
    const mediaNodes = new Map();
    (0, $0mclG.traverse)(doc, {
        media: (node)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const mediaNode = node;
            if (mediaNode.attrs.type === 'external') return;
            mediaNodes.set(mediaNode.attrs.id, node);
        },
        mediaInline: (node)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const mediaInlineNode = node;
            mediaNodes.set(mediaInlineNode.attrs.id, node);
        }
    });
    return mediaNodes.size > 0;
};
const $330901af3cc572d4$export$80a6e90c7b29d88c = (currentDoc, newDoc)=>{
    const currentMediaNodes = new Set();
    const newMediaNodes = new Set();
    const updatedMediaNodes = new Set();
    if (newDoc) (0, $0mclG.traverse)(newDoc, {
        media: (node)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const mediaNode = node;
            if (mediaNode.attrs.type === 'external') return;
            newMediaNodes.add(mediaNode.attrs.id);
        },
        mediaInline: (node)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const mediaInlineNode = node;
            newMediaNodes.add(mediaInlineNode.attrs.id);
        }
    });
    if (currentDoc) (0, $0mclG.traverse)(currentDoc, {
        media: (node)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const mediaNode = node;
            if (mediaNode.attrs.type === 'external') return;
            currentMediaNodes.add(mediaNode.attrs.id);
            if (newMediaNodes.size) {
                const matchedNode = newMediaNodes.has(mediaNode.attrs.id);
                if (!matchedNode) updatedMediaNodes.add(mediaNode.attrs.id);
            }
        },
        mediaInline: (node)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const mediaInlineNode = node;
            currentMediaNodes.add(mediaInlineNode.attrs.id);
            if (newMediaNodes.size) {
                const matchedNode = newMediaNodes.has(mediaInlineNode.attrs.id);
                if (!matchedNode) updatedMediaNodes.add(mediaInlineNode.attrs.id);
            }
        }
    });
    return currentMediaNodes.size !== newMediaNodes.size || !!updatedMediaNodes.size;
};
const $330901af3cc572d4$export$ddf077301434502d = (doc)=>{
    if (doc === null || doc === undefined) return false;
    const nonSimpleTextNodes = (0, $fpoq4.filter)(doc, (node)=>node.type !== 'paragraph' && node.type !== 'doc' && node.type !== 'text');
    return nonSimpleTextNodes.length === 0;
};



const $330901af3cc572d4$export$2277e89f0b6d4ed = async (node)=>{
    // the imports here were kept async so as not to blow the bundle sizes for everyone
    const { defaultSchema: defaultSchema } = await Promise.resolve((parcelRequire("8DB98")));
    const { WikiMarkupTransformer: WikiMarkupTransformer } = await Promise.resolve((parcelRequire("dmYzn")));
    const { JSONTransformer: JSONTransformer } = await Promise.resolve((parcelRequire("lovmf")));
    const jsonTransformer = new JSONTransformer();
    const wikiMarkupTransformer = new WikiMarkupTransformer(defaultSchema);
    if (node === null || node === undefined) return '';
    const pmNode = jsonTransformer.parse(node);
    return wikiMarkupTransformer.encode(pmNode);
};

});
parcelRegister("fpoq4", function(module, exports) {

$parcel$export(module.exports, "filter", () => $01d8b182e291a8c9$export$3dea766d36a8935f);

var $0mclG = parcelRequire("0mclG");
function $01d8b182e291a8c9$export$3dea766d36a8935f(adf, callback) {
    const result = [];
    (0, $0mclG.traverse)(adf, {
        any: (node)=>{
            if (callback(node)) result.push(node);
        }
    });
    return result;
}

});



parcelRegister("7aC2p", function(module, exports) {

$parcel$export(module.exports, "getCreateIssueUrl", () => $f539b9bf761cc18f$export$a92012cc19d68266);

var $7jTnu = parcelRequire("7jTnu");
const $f539b9bf761cc18f$export$a92012cc19d68266 = ({ isCreateLinkedIssue: isCreateLinkedIssue = false, skipAutoWatch: skipAutoWatch = false })=>{
    const urlSearchParams = new URLSearchParams('updateHistory=true&applyDefaultValues=false');
    if (isCreateLinkedIssue && (0, $7jTnu.fg)('create_linked_issues_trigger_point_issue_view')) urlSearchParams.append('fromCreateLinkedIssueScreen', 'true');
    if (skipAutoWatch) urlSearchParams.append('skipAutoWatch', 'true');
    return `/rest/api/3/issue?${urlSearchParams.toString()}`;
};

});


parcelRegister("2VetA", function(module, exports) {

$parcel$export(module.exports, "useDescriptionAnalytics", () => $455dac46832aacdc$export$df0e1df705c71ad);

var $eJOHy = parcelRequire("eJOHy");

var $xMjNG = parcelRequire("xMjNG");

var $4PKlm = parcelRequire("4PKlm");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");
const $455dac46832aacdc$export$df0e1df705c71ad = ()=>{
    const { subscribe: subscribe } = (0, $4PKlm.useGICLifeCycleEvents)();
    const [hasSent, setHasSent] = (0, $eJOHy.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        const unsubscribeFromChange = subscribe((0, $xMjNG.GIC_LIFECYCLE_EVENTS).CREATE_FORM_FIELD_VALUE_CHANGE, (data)=>{
            if (!hasSent && data.fieldId === 'description') {
                const analyticsEvent = createAnalyticsEvent({
                    actionSubject: 'description',
                    action: 'editStarted'
                });
                (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'createIssueDescriptionTouched');
                setHasSent(true);
            }
        });
        const unsubscribeFromBlur = subscribe((0, $xMjNG.GIC_LIFECYCLE_EVENTS).CREATE_FORM_FIELD_BLUR, (data)=>{
            if (data.fieldId === 'description') setHasSent(false);
        });
        return ()=>{
            unsubscribeFromChange();
            unsubscribeFromBlur();
        };
    }, [
        createAnalyticsEvent,
        subscribe,
        hasSent,
        setHasSent
    ]);
};

});

parcelRegister("1AeYS", function(module, exports) {

$parcel$export(module.exports, "ActionsContainer", () => $3210a5af4ffc8891$export$48377ae1c677702b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $jQUoP = parcelRequire("jQUoP");

var $fIw44 = parcelRequire("fIw44");

var $dIu0P = parcelRequire("dIu0P");

var $fYeTG = parcelRequire("fYeTG");

var $2d7M3 = parcelRequire("2d7M3");

var $bl3Xz = parcelRequire("bl3Xz");
const $3210a5af4ffc8891$export$48377ae1c677702b = (props)=>{
    const hasWatchersInitialized = (0, $eJOHy.useRef)(false);
    const [{ dataFetchError: dataFetchError, selectedProject: selectedProject }] = (0, $jQUoP.useFormContext)();
    const { view: view, isTransitionInState: isTransitionInState } = (0, $fIw44.useMinimizableModal)();
    const shouldDisableActions = dataFetchError !== null;
    const shouldDisableHeaderDropdown = Boolean(shouldDisableActions || selectedProject === null);
    const shouldRenderActionsContainer = view === 'modal' && isTransitionInState([
        'mini'
    ], (0, $dIu0P.TransitionState).EXITED) && !(0, $fYeTG.isMobileAndInMvpOrExistingUsersExperiment)();
    if (!shouldRenderActionsContainer) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3210a5af4ffc8891$var$ActionsContainerWrapper, {
        "data-testid": "issue-create.ui.modal.create-form.actions-container.actions-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bl3Xz.default), {
        configs: props.watchersConfigurations,
        hasWatchersInitialized: hasWatchersInitialized
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $3210a5af4ffc8891$var$dropdownContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2d7M3.HeaderDropdown), {
        isDisabled: shouldDisableHeaderDropdown,
        fieldConfig: props.fieldConfig
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3210a5af4ffc8891$var$ActionsContainerWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _kqswh2mm _1pbykb7n",
            __cmplp.className
        ])
    });
});
const $3210a5af4ffc8891$var$dropdownContainerStyles = (0, $1DXK0.xcss)({
    marginLeft: 'space.100'
});

});
parcelRegister("2d7M3", function(module, exports) {

$parcel$export(module.exports, "HeaderDropdown", () => $fd7d1e91796a2121$export$e93b0271171ef3a);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $goZPP = parcelRequire("goZPP");

var $7rjYb = parcelRequire("7rjYb");
var $jYYbf = parcelRequire("jYYbf");
var $aLJ1L = parcelRequire("aLJ1L");

var $aMdh8 = parcelRequire("aMdh8");

var $2bMVP = parcelRequire("2bMVP");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $jaNQz = parcelRequire("jaNQz");

var $fRjRq = parcelRequire("fRjRq");

var $dt3aG = parcelRequire("dt3aG");

var $4NEt5 = parcelRequire("4NEt5");

var $epTsa = parcelRequire("epTsa");

var $7jTnu = parcelRequire("7jTnu");

var $lRq8t = parcelRequire("lRq8t");

var $5PjYq = parcelRequire("5PjYq");

var $jQUoP = parcelRequire("jQUoP");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $032SA = parcelRequire("032SA");

var $kEUB1 = parcelRequire("kEUB1");

var $gZTP9 = parcelRequire("gZTP9");

var $6XJko = parcelRequire("6XJko");

var $bl3Xz = parcelRequire("bl3Xz");

var $6OvPb = parcelRequire("6OvPb");

var $4azql = parcelRequire("4azql");
const $fd7d1e91796a2121$var$testId = 'issue-create.ui.modal.create-form.actions-container.dropdown-menu.dropdown-menu';
const $fd7d1e91796a2121$var$buttonTestId = 'issue-create.ui.modal.create-form.actions-container.dropdown-menu.button';
const $fd7d1e91796a2121$export$e93b0271171ef3a = (props)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const isAdmin = (0, $gZTP9.useIsAdmin)();
    const cloudId = (0, $kEUB1.useCloudId)();
    const { isDisabled: isDisabled = false, watchersConfigurations: watchersConfigurations } = props;
    const [{ selectedProject: selectedProject, selectedIssueType: selectedIssueType }, { toggleConfigureFieldsModalVisibility: toggleConfigureFieldsModalVisibility, toggleFindFieldsModalVisibility: toggleFindFieldsModalVisibility }] = (0, $jQUoP.useFormContext)();
    const [queryReference, loadQuery] = (0, $j4oe4.useQueryLoader)((0, $032SA.default));
    const showConfigureFieldsModal = ()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        toggleConfigureFieldsModalVisibility(true);
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'configureFields', {
            projectType: selectedProject ? (0, $5PjYq.transformProjectType)(selectedProject.projectType) : 'none'
        });
    };
    const showFindFieldModal = ()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        toggleFindFieldsModalVisibility(true);
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'findYourField', {
            projectType: selectedProject ? (0, $5PjYq.transformProjectType)(selectedProject.projectType) : 'none'
        });
    };
    const showFindFieldOption = ()=>Boolean(isAdmin && selectedProject && selectedIssueType && !selectedProject.isSimplified);
    const loadSmartFieldsAdminToggleQuery = (0, $eJOHy.useCallback)(()=>{
        loadQuery({
            cloudId: cloudId
        });
    }, [
        cloudId,
        loadQuery
    ]);
    // @ts-expect-error - TS7006 - Parameter 'attributes' implicitly has an 'any' type.
    const onOpenChange = (attributes)=>{
        if (attributes.isOpen) {
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button'
            });
            (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'meatballMenu');
            loadSmartFieldsAdminToggleQuery();
        }
    };
    const disableDropdown = (0, $6XJko.isVisualRefreshEnabled)() ? isDisabled && !watchersConfigurations?.canManageWatchers && !watchersConfigurations?.isWatchersEnabled : isDisabled;
    const shouldShowDropdownActions = (0, $6XJko.isVisualRefreshEnabled)() ? !isDisabled : true;
    const fieldIcon = (0, $6XJko.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fRjRq))), {
        label: ""
    }) : null;
    const findFieldsIcon = (0, $6XJko.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dt3aG))), {
        label: ""
    }) : null;
    const attributes = (0, $eJOHy.useMemo)(()=>({
            shouldShowDropdownActions: shouldShowDropdownActions,
            disableDropdown: disableDropdown,
            isDisabled: isDisabled,
            isAdmin: isAdmin
        }), [
        disableDropdown,
        isAdmin,
        isDisabled,
        shouldShowDropdownActions
    ]);
    const getAriaLabel = ()=>{
        if (selectedIssueType && (0, $epTsa.expVal)('jira-itr-work-type-exp-1', 'isEnabled', false)) return (0, $6OvPb.default).moreActionsIssueTerminologyRefreshM4;
        if ((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false)) return (0, $6OvPb.default).moreActionsIssueTermRefresh;
        return (0, $6OvPb.default).moreActions;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7rjYb.default), {
        placement: "bottom-end",
        shouldRenderToParent: true,
        trigger: ({ triggerRef: triggerRef, ...dropdownProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                ...dropdownProps,
                testId: $fd7d1e91796a2121$var$buttonTestId,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aMdh8))), {
                    spacing: "spacious",
                    label: ""
                }),
                appearance: "subtle",
                isDisabled: disableDropdown,
                ref: triggerRef,
                "aria-label": formatMessage(getAriaLabel(), {
                    issueType: selectedIssueType?.label
                })
            }),
        onOpenChange: onOpenChange,
        testId: $fd7d1e91796a2121$var$testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aLJ1L.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jaNQz.default), {
        name: "header-dropdown-smart-fields-gic-toggle",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $fd7d1e91796a2121$var$loadingPlaceholderStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2bMVP.default), {
            width: "100%",
            isShimmering: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2bMVP.default), {
            width: "100%",
            isShimmering: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2bMVP.default), {
            width: "100%",
            isShimmering: true
        }))
    }, shouldShowDropdownActions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
        elemBefore: fieldIcon,
        onClick: showConfigureFieldsModal
    }, formatMessage((0, $6OvPb.default).configureFields)), queryReference ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4NEt5.JiraIssueCreateErrorBoundary), {
        id: "smartFieldsGicToggleDropdownItem",
        packageName: "jiraIssueCreate",
        fallback: "unmount",
        sendToPrivacyUnsafeSplunk: true,
        ...(0, $7jTnu.fg)('jira-issue-create-error-boundary-enabled') ? {
            attributes: attributes
        } : {}
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4azql.SmartFieldsDropdownItem), {
        queryReference: queryReference
    })) : null, showFindFieldOption() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
        elemBefore: findFieldsIcon,
        onClick: showFindFieldModal
    }, formatMessage((0, $6OvPb.default).findField))), (0, $6XJko.isVisualRefreshEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bl3Xz.default), {
        configs: watchersConfigurations,
        shouldRenderInDropdown: true
    }))));
};
const $fd7d1e91796a2121$var$loadingPlaceholderStyles = (0, $1DXK0.xcss)({
    width: '204px'
});

});
parcelRegister("fRjRq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c1e5a4eb83a5a00b95d06a6a3097fd6b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b8bb362ff868ed95$var$_react = $b8bb362ff868ed95$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $b8bb362ff868ed95$var$_baseNew = $b8bb362ff868ed95$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $b8bb362ff868ed95$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Field".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known usages: Field suggestions provided by Atlassian Intelligence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b8bb362ff868ed95$var$FieldIcon = (props)=>/*#__PURE__*/ $b8bb362ff868ed95$var$_react.default.createElement($b8bb362ff868ed95$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 3.5H0V2h6zM0 7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5V7a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$b8bb362ff868ed95$var$FieldIcon.displayName = 'FieldIcon';
var $b8bb362ff868ed95$var$_default = module.exports.default = $b8bb362ff868ed95$var$FieldIcon;

});

parcelRegister("032SA", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a6581c925ac2eb8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<72906e81947dc5d47c9f5429e734d838>>
 * @relayHash 9e85dcc1f5052b15ad984ce04355a81b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b32a050756cd7c85fc5b8be21b06dd67137df07c58fb95dbd8b6376b34305d68
const $7a6581c925ac2eb8$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Literal",
            "name": "keys",
            "value": [
                "jira.create.smart.fields.is-enabled"
            ]
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "key"
    }, v3 = {
        "kind": "ScalarField",
        "name": "value"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "smartfieldsDropdownItemAdminToggleQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraApplicationProperty",
                            "kind": "LinkedField",
                            "name": "applicationPropertiesByKey",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "smartfieldsDropdownItemAdminToggleQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraApplicationProperty",
                            "kind": "LinkedField",
                            "name": "applicationPropertiesByKey",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b32a050756cd7c85fc5b8be21b06dd67137df07c58fb95dbd8b6376b34305d68",
            "metadata": {},
            "name": "smartfieldsDropdownItemAdminToggleQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$7a6581c925ac2eb8$var$node.hash = "dd574875cb62c2e1fc5d67c9f05f7bcf";
var $7a6581c925ac2eb8$export$2e2bcd8739ae039 = $7a6581c925ac2eb8$var$node;

});

parcelRegister("bl3Xz", function(module, exports) {

$parcel$export(module.exports, "default", () => $87e4b4a855e411dc$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $7ghp2 = parcelRequire("7ghp2");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$87e4b4a855e411dc$export$2e2bcd8739ae039 = (props)=>{
    if (!props.configs?.canManageWatchers) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ghp2.default), props);
};

});
parcelRegister("7ghp2", function(module, exports) {

$parcel$export(module.exports, "default", () => $3627d97cca609911$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2ZGUP = parcelRequire("2ZGUP");

var $ln6Iy = parcelRequire("ln6Iy");

var $jQUoP = parcelRequire("jQUoP");

var $a8pFf = parcelRequire("a8pFf");

var $6b0DX = parcelRequire("6b0DX");

var $3MbOI = parcelRequire("3MbOI");
const $3627d97cca609911$var$Watchers = ({ configs: configs, shouldRenderInDropdown: shouldRenderInDropdown, hasWatchersInitialized: hasWatchersInitializedForNewModal })=>{
    const hasWatchersInitializedForOldModal = (0, $eJOHy.useRef)(false);
    /**
	 * For new modal, the modal can be minimized due to 3-stage-create, and if it is minimized the component
	 * is completely unmounted. un-minimizing the modal would lead to the default users being added again if
	 * they have remove themselves earlier. Which means keeping track of that only within this component is
	 * impossible, so that we have to declare the ref one level up which would not be unmounted on `modal-view-change`.
	 *
	 * For old modal tho, the `hasWatchersInitializedForNewModal` would be `undefined` because the old modal is rendered from
	 * a complete different place. And for old modal, having a ref within this component is more than enough.
	 */ const hasWatchersInitialized = hasWatchersInitializedForNewModal || hasWatchersInitializedForOldModal;
    const { isAutoWatchEnabled: isAutoWatchEnabled, isWatchersEnabled: isWatchersEnabled } = configs || {};
    const { data: { user: currentUser }, loading: loading, error: error } = (0, $3MbOI.useCurrentUser)(); // eslint-disable-line @typescript-eslint/consistent-type-assertions
    const [{ watchers: watchers, selectedProject: selectedProject }, { setWatchers: setWatchers }] = (0, $jQUoP.useFormContext)();
    const shouldShowWatchers = selectedProject && configs && !currentUser.isAnonymous && !loading && !error && // NOTE: JPD has no ability to manage watchers at the time of release, this is a workaround to prevent watchers being added for JPD.
    selectedProject.projectType !== (0, $ln6Iy.PRODUCT_DISCOVERY_PROJECT);
    const isWatching = watchers.some((watcher)=>watcher.accountId === currentUser.accountId);
    /**
	 * The current user is the default user in the list because isAutoWatchEnabled is turned on
	 * so the current user would be added to the list on init.
	 */ (0, $eJOHy.useEffect)(()=>{
        if (isAutoWatchEnabled && shouldShowWatchers && currentUser && !hasWatchersInitialized.current && !isWatching) {
            setWatchers([
                ...watchers,
                currentUser
            ]);
            // eslint-disable-next-line react-hooks/react-compiler
            hasWatchersInitialized.current = true;
        }
    }, [
        currentUser,
        shouldShowWatchers,
        isAutoWatchEnabled,
        setWatchers,
        watchers,
        isWatching,
        hasWatchersInitialized
    ]);
    if (!shouldShowWatchers || !isWatchersEnabled && shouldRenderInDropdown) return null;
    if (!isWatchersEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6b0DX.default), {
        isDisabled: true
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2ZGUP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $a8pFf.default), {
        watchers: watchers,
        projectKey: selectedProject.projectKey,
        setWatchers: setWatchers,
        isWatching: isWatching,
        currentUser: currentUser,
        shouldRenderInDropdown: shouldRenderInDropdown,
        ...configs
    }));
};
var $3627d97cca609911$export$2e2bcd8739ae039 = $3627d97cca609911$var$Watchers;

});
parcelRegister("a8pFf", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc81b49307473765$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $h47gY = parcelRequire("h47gY");

var $ch9En = parcelRequire("ch9En");

var $bQWwW = parcelRequire("bQWwW");

var $4NEt5 = parcelRequire("4NEt5");

var $7jTnu = parcelRequire("7jTnu");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $bc81b49307473765$var$AsyncWatchers = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("5XDtN")), {
    ssr: false,
    moduleId: "./src/packages/issue-create/issue-create-watchers/src/ui/main.tsx"
});
const $bc81b49307473765$var$Watchers = (props)=>(0, $7jTnu.fg)('error_boundaries_to_common_package') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4NEt5.JiraIssueCreateErrorBoundary), {
        id: "async.jira-issue-create-watchers",
        packageName: "jiraIssueCreateWatchers"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "issue-create-watchers-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bc81b49307473765$var$AsyncWatchers, props))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
        id: "async.jira-issue-create-watchers",
        packageName: "jiraIssueCreateWatchers"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "issue-create-watchers-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($bc81b49307473765$var$AsyncWatchers, props)));
var $bc81b49307473765$export$2e2bcd8739ae039 = $bc81b49307473765$var$Watchers;

});
parcelRegister("5XDtN", function(module, exports) {

let $457116471fc1ad82$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $457116471fc1ad82$var$load("9VUir").then(()=>parcelRequire('iugdv'));

});


parcelRegister("6b0DX", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8d0c2368bb61898$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/react-component-props

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $dtTJ9 = parcelRequire("dtTJ9");
const $c8d0c2368bb61898$var$BaseButton = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c8d0c2368bb61898$var$Container, {
        "data-testid": "issue-create-watchers.ui.watchers-trigger-button.base-button.root"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        ...props,
        appearance: "subtle",
        spacing: "default",
        ref: ref
    }, children || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c8d0c2368bb61898$var$ButtonContent, {
        "data-testid": "issue-create-watchers.ui.watchers-trigger-button.base-button.watch-icon"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c8d0c2368bb61898$var$ButtonIcon, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dtTJ9))), {
        LEGACY_size: "medium",
        spacing: "spacious",
        label: ""
    }))))));
var $c8d0c2368bb61898$export$2e2bcd8739ae039 = $c8d0c2368bb61898$var$BaseButton;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c8d0c2368bb61898$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bahesu3 _2hwxu2gc _i1wwidpf _8ax31b66 _ake1idpf _1gqw1b66 _a7a01txw _18iz1h6o",
            __cmplp.className
        ])
    });
});
const $c8d0c2368bb61898$var$ButtonContent = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $c8d0c2368bb61898$var$ButtonIcon = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dtTJ9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a052784e02c39e1ef8b9f184efeeb6e4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9d0936107c0d5f84$var$_react = $9d0936107c0d5f84$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $9d0936107c0d5f84$var$_eyeOpen = $9d0936107c0d5f84$var$_interopRequireDefault((parcelRequire("bkdrw")));

var $9d0936107c0d5f84$var$_watch = $9d0936107c0d5f84$var$_interopRequireDefault((parcelRequire("ckYfT")));
function $9d0936107c0d5f84$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for EyeOpenIcon.
 * This component is EyeOpenIcon, with `UNSAFE_fallbackIcon` set to "WatchIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: watch page in Confluence, show password in text field, and following in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9d0936107c0d5f84$var$EyeOpenIcon = (props)=>/*#__PURE__*/ $9d0936107c0d5f84$var$_react.default.createElement($9d0936107c0d5f84$var$_eyeOpen.default, Object.assign({
        LEGACY_fallbackIcon: $9d0936107c0d5f84$var$_watch.default
    }, props));
$9d0936107c0d5f84$var$EyeOpenIcon.Name = 'EyeOpenIconMigration';
var $9d0936107c0d5f84$var$_default = module.exports.default = $9d0936107c0d5f84$var$EyeOpenIcon;

});
parcelRegister("bkdrw", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7831691c1245bdf104acebfc690a968c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $83ebfd72793ed518$var$_react = $83ebfd72793ed518$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $83ebfd72793ed518$var$_baseNew = $83ebfd72793ed518$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $83ebfd72793ed518$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "EyeOpen".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: watch page in Confluence, show password in text field, and following in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $83ebfd72793ed518$var$EyeOpenIcon = (props)=>/*#__PURE__*/ $83ebfd72793ed518$var$_react.default.createElement($83ebfd72793ed518$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 3.5c-2.943 0-5.49 1.845-6.424 4.396a.3.3 0 0 0 0 .208C2.509 10.655 5.057 12.5 8 12.5s5.49-1.845 6.424-4.396a.3.3 0 0 0 0-.208C13.491 5.345 10.943 3.5 8 3.5M.167 7.38C1.32 4.232 4.433 2 8 2c3.566 0 6.681 2.232 7.833 5.38.146.4.146.84 0 1.24C14.68 11.768 11.566 14 8 14 4.433 14 1.319 11.768.167 8.62a1.8 1.8 0 0 1 0-1.24M8 6.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M5 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0" clip-rule="evenodd"/>`
    }, props));
$83ebfd72793ed518$var$EyeOpenIcon.displayName = 'EyeOpenIcon';
var $83ebfd72793ed518$var$_default = module.exports.default = $83ebfd72793ed518$var$EyeOpenIcon;

});

parcelRegister("ckYfT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8fb617c320567a2b$var$_react = $8fb617c320567a2b$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $8fb617c320567a2b$var$_eyeOpen = $8fb617c320567a2b$var$_interopRequireDefault((parcelRequire("bkdrw")));
function $8fb617c320567a2b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8fb617c320567a2b$var$WatchIcon = (props)=>/*#__PURE__*/ $8fb617c320567a2b$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M12 18c-4.536 0-7.999-4.26-7.999-6 0-2.001 3.459-6 8-6 4.376 0 7.998 3.973 7.998 6 0 1.74-3.462 6-7.998 6m0-14C6.48 4 2 8.841 2 12c0 3.086 4.576 8 10 8 5.423 0 10-4.914 10-8 0-3.159-4.48-8-10-8"/><path d="M11.978 13.984c-1.104 0-2-.897-2-2s.896-2 2-2c1.103 0 2 .897 2 2s-.897 2-2 2m0-6c-2.206 0-4 1.794-4 4s1.793 4 4 4 4-1.794 4-4-1.794-4-4-4"/></g></svg>`
    }, props, {
        newIcon: $8fb617c320567a2b$var$_eyeOpen.default
    }));
$8fb617c320567a2b$var$WatchIcon.displayName = 'WatchIcon';
var $8fb617c320567a2b$var$_default = module.exports.default = $8fb617c320567a2b$var$WatchIcon;

});





parcelRegister("6OvPb", function(module, exports) {

$parcel$export(module.exports, "default", () => $b53f1337e24b3b6a$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $b53f1337e24b3b6a$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    configureFields: {
        "id": "issue-create.modal.create-form.actions-container.dropdown-menu.configure-fields",
        "defaultMessage": "Configure fields"
    },
    findField: {
        "id": "issue-create.modal.create-form.actions-container.dropdown-menu.find-field",
        "defaultMessage": "Find your field"
    },
    moreActions: {
        "id": "issue-create.modal.create-form.actions-container.dropdown-menu.more-actions",
        "defaultMessage": "More actions for this issue"
    },
    moreActionsIssueTermRefresh: {
        "id": "issue-create.modal.create-form.actions-container.dropdown-menu.more-actions-issue-term-refresh",
        "defaultMessage": "More actions for this work item"
    },
    moreActionsIssueTerminologyRefreshM4: {
        "id": "issue-create.modal.create-form.actions-container.dropdown-menu.more-actions-issue-terminology-refresh-m4",
        "defaultMessage": "More actions for this {issueType}"
    }
});

});

parcelRegister("4azql", function(module, exports) {

$parcel$export(module.exports, "SmartFieldsDropdownItem", () => $ffc1a652ea2bffd1$export$7e458a2926172360);

var $032SA = parcelRequire("032SA");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $jYYbf = parcelRequire("jYYbf");

var $lmgo6 = parcelRequire("lmgo6");
var $1DXK0 = parcelRequire("1DXK0");

var $8CBYv = parcelRequire("8CBYv");

var $55RJF = parcelRequire("55RJF");

var $eDBhy = parcelRequire("eDBhy");

var $lRq8t = parcelRequire("lRq8t");

var $jQUoP = parcelRequire("jQUoP");


var $ctRhd = parcelRequire("ctRhd");

var $gCeeo = parcelRequire("gCeeo");

var $7JXbP = parcelRequire("7JXbP");

var $eJrcF = parcelRequire("eJrcF");

var $6XJko = parcelRequire("6XJko");

var $f2JN3 = parcelRequire("f2JN3");

var $4UEiy = parcelRequire("4UEiy");
const $ffc1a652ea2bffd1$var$CustomToggleButton = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ isChecked: isChecked, onChange: onChange, ...props }, ref)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        alignItems: "center",
        gap: "space.100",
        xcss: $ffc1a652ea2bffd1$var$customButtonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("label", {
        htmlFor: "toggle-smart-fields"
    }, formatMessage((0, $4UEiy.default).smartFieldsLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8CBYv.default), {
        ...props,
        id: "toggle-smart-fields",
        isChecked: isChecked,
        onChange: onChange,
        ref: ref
    }));
});
const $ffc1a652ea2bffd1$var$VisuallyRefreshedCustomToggleButton = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ isChecked: isChecked, onChange: onChange, ...props }, ref)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        alignItems: "center",
        gap: "space.150",
        xcss: $ffc1a652ea2bffd1$var$customButtonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($55RJF))), {
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        gap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("label", {
        htmlFor: "toggle-smart-fields"
    }, formatMessage((0, $4UEiy.default).smartFieldsLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8CBYv.default), {
        ...props,
        id: "toggle-smart-fields",
        isChecked: isChecked,
        onChange: onChange,
        ref: ref
    })));
});
const $ffc1a652ea2bffd1$var$CustomToggleButtonComponent = (0, $f2JN3.componentWithCondition)(()=>(0, $6XJko.isVisualRefreshEnabled)(), $ffc1a652ea2bffd1$var$VisuallyRefreshedCustomToggleButton, $ffc1a652ea2bffd1$var$CustomToggleButton);
const $ffc1a652ea2bffd1$export$f66e1f764818b2e = ()=>(0, $eJrcF.useResource)((0, $7JXbP.gicSmartFieldsFeatureResource));
const $ffc1a652ea2bffd1$export$7e458a2926172360 = ({ queryReference: queryReference })=>{
    const { loading: loading, data: data, update: updateResource } = $ffc1a652ea2bffd1$export$f66e1f764818b2e();
    const { updatePreferences: updatePreferences } = (0, $ctRhd.useSmartFieldsUpdateUserPreference)();
    const { setIsSmartFieldsToggled: setIsSmartFieldsToggled } = (0, $jQUoP.useFormContextActions)();
    const adminToggleStateData = (0, $j4oe4.usePreloadedQuery)((0, $032SA.default), queryReference);
    const hasUserOptedOut = (0, $eJOHy.useMemo)(()=>typeof data?.hasUserOptedOut === 'boolean' ? data.hasUserOptedOut : false, [
        data
    ]);
    const hasUserDismissedReadMore = (0, $eJOHy.useMemo)(()=>typeof data?.hasUserDismissedReadMore === 'boolean' ? data.hasUserDismissedReadMore : false, [
        data
    ]);
    const hasUserDismissedGicOnboarding = (0, $eJOHy.useMemo)(()=>typeof data?.hasUserDismissedGicOnboarding === 'boolean' ? data.hasUserDismissedGicOnboarding : false, [
        data
    ]);
    const handleHideUnusedFieldsChange = async (_, analyticsEventUI)=>{
        const value = !hasUserOptedOut;
        updateResource(()=>({
                hasUserOptedOut: value,
                hasUserDismissedReadMore: false,
                hasUserDismissedGicOnboarding: false
            }));
        (0, $gCeeo.fireUIAnalytics)(analyticsEventUI, 'toggleGicSmartFields', {
            isSmartFieldsOptOut: value
        });
        try {
            await updatePreferences({
                hasUserOptedOut: value,
                hasUserDismissedReadMore: false,
                hasUserDismissedGicOnboarding: false
            });
            setIsSmartFieldsToggled(true);
        } catch (err) {
            updateResource(()=>({
                    hasUserOptedOut: hasUserOptedOut,
                    hasUserDismissedReadMore: hasUserDismissedReadMore,
                    hasUserDismissedGicOnboarding: hasUserDismissedGicOnboarding
                }));
            const error = err instanceof Error ? err : new Error('GIC Smart Fields: Unknown error while toggling user preference');
            (0, $eDBhy.fireIssueCreateErrorAnalytics)({
                error: error,
                meta: {
                    id: 'toggleGicSmartFields',
                    packageName: 'jiraIssueCreate',
                    teamName: 'gryffindor'
                }
            });
        }
    };
    const hasAdminDisabledSmartFields = (0, $eJOHy.useMemo)(()=>adminToggleStateData?.jira?.applicationPropertiesByKey?.filter((item)=>item.key === (0, $472425bd89caee5d$export$5781c9f38e6a61fe))[0]?.value === 'false', [
        adminToggleStateData
    ]);
    if (loading || hasAdminDisabledSmartFields) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
        // @ts-expect-error - TS2322 - Dynamic component typing is broken in the platform package
        component: $ffc1a652ea2bffd1$var$CustomToggleButtonComponent,
        isChecked: !hasUserOptedOut,
        onChange: handleHideUnusedFieldsChange
    });
};
const $ffc1a652ea2bffd1$var$customButtonStyles = (0, $1DXK0.xcss)({
    paddingInline: 'space.200',
    paddingBlock: 'space.100'
});

});
parcelRegister("55RJF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c90f995a462686dc43276b76786a54f3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3b571a2365e2cd85$var$_react = $3b571a2365e2cd85$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $3b571a2365e2cd85$var$_baseNew = $3b571a2365e2cd85$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $3b571a2365e2cd85$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "EyeOpenStrikethrough".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Intended uses: unwatch page in Confluence, hide password in text field, and unfollow in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3b571a2365e2cd85$var$EyeOpenStrikethroughIcon = (props)=>/*#__PURE__*/ $3b571a2365e2cd85$var$_react.default.createElement($3b571a2365e2cd85$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m.47 1.53 14 14 1.06-1.06-14-14zm8.74 10.86 1.24 1.24A8.5 8.5 0 0 1 8 14C4.43 14 1.32 11.77.17 8.62c-.15-.4-.15-.84 0-1.24a8 8 0 0 1 1.51-2.53l1.06 1.06a6.5 6.5 0 0 0-1.16 1.98.3.3 0 0 0 0 .21c.93 2.56 3.48 4.4 6.42 4.4q.62 0 1.21-.11M8 2a8.5 8.5 0 0 0-2.45.36L6.79 3.6q.59-.1 1.21-.1c2.94 0 5.49 1.85 6.42 4.4a.3.3 0 0 1 0 .21 6.5 6.5 0 0 1-1.16 1.98l1.06 1.06a8 8 0 0 0 1.51-2.53c.15-.4.15-.84 0-1.24C14.68 4.23 11.57 2 8 2"/>`
    }, props));
$3b571a2365e2cd85$var$EyeOpenStrikethroughIcon.displayName = 'EyeOpenStrikethroughIcon';
var $3b571a2365e2cd85$var$_default = module.exports.default = $3b571a2365e2cd85$var$EyeOpenStrikethroughIcon;

});

const $472425bd89caee5d$export$b94951a11282ae6a = 'gic-smart-fields-feature';
const $472425bd89caee5d$export$5781c9f38e6a61fe = 'jira.create.smart.fields.is-enabled';

parcelRegister("ctRhd", function(module, exports) {

$parcel$export(module.exports, "useSmartFieldsUpdateUserPreference", () => $ec0111a96a86701c$export$d7a60913673e28ef);

var $eJOHy = parcelRequire("eJOHy");

var $gYnSx = parcelRequire("gYnSx");

var $9DB7T = parcelRequire("9DB7T");

const $ec0111a96a86701c$export$d7a60913673e28ef = ()=>{
    const updatePreferences = (0, $eJOHy.useCallback)(async (payload)=>{
        try {
            await (0, $9DB7T.userPreferenceAPI).set((0, $472425bd89caee5d$export$b94951a11282ae6a), payload);
        } catch (err) {
            (0, $gYnSx.default)({
                error: err instanceof Error ? err : new Error('Unknown error'),
                meta: {
                    id: 'updateCommandPaletteOptInStatus',
                    packageName: 'jiraPersonalSettingsGicSmartFields',
                    teamName: 'gryffindor'
                }
            });
            throw err;
        }
    }, []);
    return {
        updatePreferences: updatePreferences
    };
};

});

parcelRegister("4UEiy", function(module, exports) {

$parcel$export(module.exports, "default", () => $d49487eabbe4a27e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $d49487eabbe4a27e$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    smartFieldsLabel: {
        "id": "issue-create.modal.create-form.actions-container.dropdown-menu.smartfields-dropdown-item.smart-fields-label",
        "defaultMessage": "Hide unused fields"
    }
});

});




parcelRegister("fB3KX", function(module, exports) {

$parcel$export(module.exports, "ExternalControlsRenderer", () => $f961345dd636b34f$export$1f4f83075c603162);

var $eJOHy = parcelRequire("eJOHy");

var $4NEt5 = parcelRequire("4NEt5");

var $84DOT = parcelRequire("84DOT");

var $kbtlA = parcelRequire("kbtlA");
const $f961345dd636b34f$var$Controls = ({ externalControls: externalControls, getFormState: getFormState, setFieldValue: setFieldValue })=>{
    const formAPI = (0, $eJOHy.useMemo)(()=>({
            getFormState: getFormState,
            setFieldValue: setFieldValue
        }), [
        getFormState,
        setFieldValue
    ]);
    const { fieldAPI: fieldAPI, getFormFieldValue: getFormFieldValue } = (0, $kbtlA.useExternalControlsAPI)(formAPI);
    const { Component: Component } = externalControls;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Component, {
        fieldAPI: fieldAPI,
        getFormFieldValue: getFormFieldValue
    });
};
const $f961345dd636b34f$export$1f4f83075c603162 = ({ externalControls: externalControls, getFormState: getFormState, setFieldValue: setFieldValue })=>{
    if (externalControls && getFormState && setFieldValue && (0, $84DOT.ALLOWED_EXTERNAL_CONTROLS).TRIGGER_POINTS.includes(externalControls.triggerPoint)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4NEt5.JiraIssueCreateErrorBoundary), {
        id: "externalControlsRenderer",
        packageName: "jiraIssueCreate",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f961345dd636b34f$var$Controls, {
        externalControls: externalControls,
        getFormState: getFormState,
        setFieldValue: setFieldValue
    }));
    return null;
};

});
parcelRegister("kbtlA", function(module, exports) {

$parcel$export(module.exports, "useExternalControlsAPI", () => $fd9b0499f5f42a7d$export$b6e86f46675e84e5);

var $eJOHy = parcelRequire("eJOHy");

var $84DOT = parcelRequire("84DOT");
const $fd9b0499f5f42a7d$export$b6e86f46675e84e5 = ({ getFormState: getFormState, setFieldValue: setFieldValue })=>{
    const getFormFieldValue = (0, $eJOHy.useCallback)((fieldId)=>getFormState()?.values[fieldId], [
        getFormState
    ]);
    const fieldAPI = (0, $eJOHy.useMemo)(()=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const allowedFieldAPI = {};
        (0, $84DOT.ALLOWED_EXTERNAL_CONTROLS).FIELD_IDS.forEach((fieldId)=>{
            allowedFieldAPI[fieldId] = {
                getValue: ()=>getFormFieldValue(fieldId),
                setValue: (value)=>setFieldValue(fieldId, value)
            };
        });
        return allowedFieldAPI;
    }, [
        setFieldValue,
        getFormFieldValue
    ]);
    return {
        fieldAPI: fieldAPI,
        getFormFieldValue: getFormFieldValue
    };
};

});


parcelRegister("aQ4h7", function(module, exports) {

$parcel$export(module.exports, "default", () => $3602882c1148b67b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $gRw8I = parcelRequire("gRw8I");

var $cpHe2 = parcelRequire("cpHe2");
var $41h42 = parcelRequire("41h42");
var $7oCv0 = parcelRequire("7oCv0");

var $7jTnu = parcelRequire("7jTnu");

var $1yZHf = parcelRequire("1yZHf");

var $klRjZ = parcelRequire("klRjZ");

var $jQUoP = parcelRequire("jQUoP");

var $6u3jg = parcelRequire("6u3jg");

var $fY88g = parcelRequire("fY88g");

var $en79x = parcelRequire("en79x");
const $3602882c1148b67b$export$1547cfa441087995 = (props)=>{
    // eslint-disable-next-line jira/react-magnetic-di/no-unneeded -- magnetic-di does not work automatically with ternary components. it needs to have the `di`
    (0, $gRw8I.di)((0, $fY88g.default), (0, $en79x.FieldsContainer));
    const { fieldTabs: fieldTabs, fieldConfig: fieldConfig, getFormState: getFormState, setFieldValue: setFieldValue, apiLatency: apiLatency, optOutSmartFieldIds: optOutSmartFieldIds } = props;
    const isGICPositioningEnabled = (0, $6u3jg.useIsGICPositioningEnabled)();
    // TODO Add this field with the fields on previous line when cleaning FF
    const fieldPropsExtensions = isGICPositioningEnabled() ? props.fieldPropsExtensions : undefined;
    const [{ currentActiveTabIndex: currentActiveTabIndex }, { setCurrentActiveTabIndex: setCurrentActiveTabIndex }] = (0, $jQUoP.useFormContext)();
    const tabs = (0, $eJOHy.useMemo)(()=>fieldTabs.map(({ id: id, tabId: tabId, name: name, items: items, collapsedItems: collapsedItems })=>({
                id: tabId || id,
                name: name,
                content: null,
                testId: id,
                items: items,
                collapsedItems: collapsedItems
            })), [
        fieldTabs
    ]);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onSelect = (_, selectedIndex)=>{
        setCurrentActiveTabIndex(selectedIndex);
    };
    const handleChange = (index)=>{
        onSelect(null, index);
    };
    const { hasValidationErrors: hasValidationErrors, submitFailed: submitFailed } = getFormState();
    const { controlledTabs: controlledTabs, controlledSelected: controlledSelected, controlledOnChange: controlledOnChange } = (0, $1yZHf.useScreenTabs)({
        tabs: tabs,
        viewProps: {
            shouldDisableScreenTabsControl: hasValidationErrors && submitFailed
        },
        selected: currentActiveTabIndex,
        onChange: handleChange
    });
    if (!fieldTabs.length) return null;
    if (fieldTabs.length === 1) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $en79x.FieldsContainer), {
        fieldConfig: fieldConfig,
        fields: fieldTabs[0].items,
        collapsedFields: fieldTabs[0].collapsedItems,
        FieldRenderer: (0, $fY88g.default),
        tabIndex: 0,
        optOutSmartFieldIds: optOutSmartFieldIds,
        apiLatency: apiLatency,
        getFormState: getFormState,
        setFieldValue: setFieldValue,
        fieldPropsExtensions: isGICPositioningEnabled() ? fieldPropsExtensions : undefined
    });
    const getTabsList = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cpHe2.default), {
            testId: "issue-create.ui.modal.create-form.layout-renderer.layout-rerender-tabs",
            selected: controlledSelected,
            onChange: controlledOnChange,
            id: "issue-create-modal-tabs",
            shouldUnmountTabPanelOnChange: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7oCv0.default), null, controlledTabs.map((tab)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $klRjZ.ConditionallyVisibleDiv), {
                key: tab.id,
                isVisible: tab.isVisible
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $41h42.default), {
                testId: tab.testId,
                key: tab.id
            }, tab.name))))), controlledTabs.map(({ id: id, items: items, collapsedItems: collapsedItems, testId: testId }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $klRjZ.ConditionallyVisibleDiv), {
                id: `issue-create-modal-tabs-${index}-tab`,
                role: "tabpanel",
                key: id,
                isVisible: index === controlledSelected,
                testId: `tab-content-${testId}`
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $en79x.FieldsContainer), {
                fieldConfig: fieldConfig,
                fields: items,
                collapsedFields: collapsedItems,
                FieldRenderer: (0, $fY88g.default),
                tabIndex: index,
                optOutSmartFieldIds: optOutSmartFieldIds,
                getFormState: getFormState,
                setFieldValue: setFieldValue,
                apiLatency: apiLatency,
                fieldPropsExtensions: isGICPositioningEnabled() ? fieldPropsExtensions : undefined
            }))));
    return (0, $7jTnu.fg)('show-all-tabs-in-create-and-transition-screen') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3602882c1148b67b$var$TabsWrapper, null, getTabsList()) : getTabsList();
};
var $3602882c1148b67b$export$2e2bcd8739ae039 = $3602882c1148b67b$export$1547cfa441087995;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $3602882c1148b67b$var$TabsWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswh2mm _1jwa1g80",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cpHe2", function(module, exports) {

$parcel$export(module.exports, "default", () => $03090e4bd6ee746b$export$2e2bcd8739ae039);
/* tabs.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $jrFnt = parcelRequire("jrFnt");

var $4OxCz = parcelRequire("4OxCz");
const $03090e4bd6ee746b$var$baseStyles = null;
const $03090e4bd6ee746b$var$tabsStyles = null;
const $03090e4bd6ee746b$var$analyticsAttributes = {
    componentName: 'tabs',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $03090e4bd6ee746b$var$getTabPanelWithContext = ({ tabPanel: tabPanel, index: index, isSelected: isSelected, tabsId: tabsId })=>// Ensure tabPanel exists in case it has been removed
    tabPanel && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4OxCz.TabPanelContext).Provider, {
        value: {
            role: 'tabpanel',
            id: `${tabsId}-${index}-tab`,
            hidden: isSelected ? undefined : true,
            'aria-labelledby': `${tabsId}-${index}`,
            tabIndex: isSelected ? 0 : -1
        },
        children: tabPanel
    }, index); /**
                                * __Tabs__
                                *
                                * Tabs acts as a container for all Tab components.
                                *
                                * - [Examples](https://atlassian.design/components/tabs/examples)
                                * - [Code](https://atlassian.design/components/tabs/code)
                                * - [Usage](https://atlassian.design/components/tabs/usage)
                                */ 
const $03090e4bd6ee746b$var$Tabs = (props)=>{
    const { shouldUnmountTabPanelOnChange: shouldUnmountTabPanelOnChange = false, selected: SelectedType, defaultSelected: defaultSelected, onChange: onChangeProp, id: id, analyticsContext: analyticsContext, children: children, testId: testId } = props;
    const [selectedState, setSelected] = (0, $eJOHy.useState)(SelectedType || defaultSelected || 0);
    const selected = SelectedType === undefined ? selectedState : SelectedType;
    const childrenArray = (0, $eJOHy.Children).toArray(children) // Don't include any conditional children
    .filter((child)=>Boolean(child)); // First child should be a tabList followed by tab panels
    const [tabList, ...tabPanels] = childrenArray; // Keep track of visited and add to a set
    const visited = (0, $eJOHy.useRef)(new Set([
        selected
    ]));
    if (!visited.current.has(selected)) visited.current.add(selected);
    const onChange = (0, $eJOHy.useCallback)((index, analyticsEvent)=>{
        if (onChangeProp) onChangeProp(index, analyticsEvent);
        setSelected(index);
    }, [
        onChangeProp
    ]);
    const onChangeAnalytics = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$03090e4bd6ee746b$var$analyticsAttributes
    });
    const tabPanelsWithContext = shouldUnmountTabPanelOnChange ? $03090e4bd6ee746b$var$getTabPanelWithContext({
        tabPanel: tabPanels[selected],
        index: selected,
        isSelected: true,
        tabsId: id
    }) : // If a panel has already been visited, don't unmount it
    Array.from(visited.current).map((tabIndex)=>$03090e4bd6ee746b$var$getTabPanelWithContext({
            tabPanel: tabPanels[tabIndex],
            index: tabIndex,
            isSelected: tabIndex === selected,
            tabsId: id
        }));
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        "data-testid": testId,
        className: (0, $hcewu.default)([
            "_1e0c1txw _p12f1osq _1tkeidpf _i0dl1osq _2lx21bp4 _16jlkb7n",
            "_1c3y1txw _ftfaidpf _18i0kb7n _185bglyw"
        ]),
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4OxCz.TabListContext).Provider, {
                value: {
                    selected: selected,
                    onChange: onChangeAnalytics,
                    tabsId: id
                },
                children: tabList
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Fragment), {
                children: tabPanelsWithContext
            })
        ]
    });
};
var $03090e4bd6ee746b$export$2e2bcd8739ae039 = $03090e4bd6ee746b$var$Tabs;

});
parcelRegister("4OxCz", function(module, exports) {

$parcel$export(module.exports, "TabContext", () => $079a819a44225d4e$export$5a5d356ca5f10a0a);
$parcel$export(module.exports, "TabListContext", () => $079a819a44225d4e$export$aa6907f9fd69e93b);
$parcel$export(module.exports, "TabPanelContext", () => $079a819a44225d4e$export$2054129d247c3102);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $eJOHy = parcelRequire("eJOHy");
const $079a819a44225d4e$export$5a5d356ca5f10a0a = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $079a819a44225d4e$export$aa6907f9fd69e93b = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $079a819a44225d4e$export$2054129d247c3102 = /*#__PURE__*/ (0, $eJOHy.createContext)(null);

});


parcelRegister("41h42", function(module, exports) {

$parcel$export(module.exports, "default", () => $c693230e7a8a8f94$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $g6Dmv = parcelRequire("g6Dmv");
var $3cMgR = parcelRequire("3cMgR");

var $lcHWu = parcelRequire("lcHWu");
/**
 * __Tab__
 *
 * Tab represents an indivudal Tab displayed in a TabList.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ const $c693230e7a8a8f94$var$Tab = /*#__PURE__*/ (0, $eJOHy.forwardRef)(function Tab({ children: children, testId: testId }, ref) {
    const { onClick: onClick, id: id, 'aria-controls': ariaControls, 'aria-posinset': ariaPosinset, 'aria-selected': ariaSelected, 'aria-setsize': ariaSetsize, onKeyDown: onKeyDown, role: role, tabIndex: tabIndex } = (0, $lcHWu.useTab)();
    return(// eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $g6Dmv.default), {
        as: "div",
        isInset: true,
        testId: testId,
        onClick: onClick,
        id: id,
        "aria-controls": ariaControls,
        "aria-posinset": ariaPosinset,
        "aria-selected": ariaSelected,
        "aria-setsize": ariaSetsize,
        onKeyDown: onKeyDown,
        role: role,
        tabIndex: tabIndex,
        ref: ref,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
            weight: "medium",
            color: "inherit",
            maxLines: 1,
            children: children
        })
    }));
});
var $c693230e7a8a8f94$export$2e2bcd8739ae039 = $c693230e7a8a8f94$var$Tab;

});
parcelRegister("lcHWu", function(module, exports) {

$parcel$export(module.exports, "useTab", () => $91221b4997543842$export$fdf4756d5b8ef90a);
$parcel$export(module.exports, "useTabList", () => $91221b4997543842$export$773e389e644c5874);
$parcel$export(module.exports, "useTabPanel", () => $91221b4997543842$export$fae0121b5afe572d);

var $eJOHy = parcelRequire("eJOHy");

var $4OxCz = parcelRequire("4OxCz");
const $91221b4997543842$export$fdf4756d5b8ef90a = ()=>{
    const tabData = (0, $eJOHy.useContext)((0, $4OxCz.TabContext));
    if (tabData == null || typeof tabData === 'undefined') throw Error('@atlaskit/tabs: A Tab must have a TabList parent.');
    return tabData;
};
const $91221b4997543842$export$773e389e644c5874 = ()=>{
    const tabListData = (0, $eJOHy.useContext)((0, $4OxCz.TabListContext));
    if (tabListData === null || typeof tabListData === 'undefined') throw Error('@atlaskit/tabs: A TabList must have a Tabs parent.');
    return tabListData;
};
const $91221b4997543842$export$fae0121b5afe572d = ()=>{
    const tabPanelData = (0, $eJOHy.useContext)((0, $4OxCz.TabPanelContext));
    if (tabPanelData === null || typeof tabPanelData === 'undefined') throw Error('@atlaskit/tabs:  A TabPanel must have a Tabs parent.');
    return tabPanelData;
};

});


parcelRegister("7oCv0", function(module, exports) {

$parcel$export(module.exports, "default", () => $b96e2c7b7779acd6$export$2e2bcd8739ae039);
/* tab-list.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eGOwo = parcelRequire("eGOwo");

var $lcHWu = parcelRequire("lcHWu");

var $4OxCz = parcelRequire("4OxCz");
const $b96e2c7b7779acd6$var$baseStyles = null;
const $b96e2c7b7779acd6$var$tabListStyles = null;
const $b96e2c7b7779acd6$var$tabListStylesOld = null;
/**
 * __TabList__
 *
 * A TabList groups `Tab` components together.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ const $b96e2c7b7779acd6$var$TabList = ({ children: children })=>{
    const { tabsId: tabsId, selected: selected, onChange: onChange } = (0, $lcHWu.useTabList)();
    const ref = /*#__PURE__*/ (0, $eJOHy.createRef)();
    // Don't include any conditional children
    const childrenArray = (0, $eJOHy.Children).toArray(children).filter(Boolean);
    const length = childrenArray.length;
    const selectTabByIndex = (0, $eJOHy.useCallback)((index)=>{
        const newSelectedNode = ref.current?.querySelector(`[id='${tabsId}-${index}']`);
        if (newSelectedNode) newSelectedNode.focus();
        onChange(index);
    }, [
        tabsId,
        ref,
        onChange
    ]);
    const onKeyDown = (0, $eJOHy.useCallback)((e)=>{
        if (![
            'ArrowRight',
            'ArrowLeft',
            'Home',
            'End'
        ].includes(e.key)) return;
        // preventing horizontal or vertical scroll
        e.preventDefault();
        const lastTabIndex = length - 1;
        if ([
            'Home',
            'End'
        ].includes(e.key)) {
            const newSelected = e.key === 'Home' ? 0 : lastTabIndex;
            selectTabByIndex(newSelected);
            return;
        }
        // We use aria-posinset so we don't rely on the selected variable
        // If we used the selected variable this would regenerate each time
        // and create an unstable reference
        const selectedIndex = parseInt(e.currentTarget.getAttribute('aria-posinset') || '0') - 1;
        const modifier = e.key === 'ArrowRight' ? 1 : -1;
        let newSelected = selectedIndex + modifier;
        if (newSelected < 0 || newSelected >= length) // Cycling focus to move from last to first and from first to last
        newSelected = newSelected < 0 ? lastTabIndex : 0;
        selectTabByIndex(newSelected);
    }, [
        length,
        selectTabByIndex
    ]);
    // Memoized so the function isn't recreated each time
    const getTabWithContext = (0, $eJOHy.useCallback)(({ tab: tab, isSelected: isSelected, index: index })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $4OxCz.TabContext).Provider, {
            value: {
                onClick: ()=>onChange(index),
                onKeyDown: onKeyDown,
                'aria-setsize': length,
                role: 'tab',
                id: `${tabsId}-${index}`,
                'aria-posinset': index + 1,
                'aria-selected': isSelected,
                'aria-controls': `${tabsId}-${index}-tab`,
                tabIndex: isSelected ? 0 : -1
            },
            children: tab
        }, index), [
        length,
        onKeyDown,
        onChange,
        tabsId
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        role: "tablist",
        ref: ref,
        className: (0, $hcewu.default)([
            "_1e0c1txw _kqswh2mm _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t",
            (0, $eGOwo.fg)('platform-component-visual-refresh') ? "_k48p1wq8 _ahbqx0bf _gpbcidpf _10vzidpf _1mmwidpf _15plidpf _7hip15vq _1fud15vq _bb0mh2mm _1quzjjyb _rzxytlke _1ofh12x7 _pryi12x7 _1a85u2gc _rmpau2gc _1dze1l2s _1tms1q9c _fiizidpf _1xrmidpf _xyihidpf _166qidpf _1lzu8zxi _24g71kw7 _140sidpf _lycustnw _15d8b3bt _1fztidpf _wd7eu2gc _1olcu2gc _1oazdud1 _w9ewidpf _170tidpf _y1g1idpf _1nvfidpf _1b8d8zxi _1n121kw7 _7p9oidpf _o2e1stnw _16u6b3bt _1yk1idpf _1lbou2gc _1c9uu2gc _1i201ouy _bppridpf _1mbxidpf _kn0bidpf _wsgdidpf _rsmz174y _1m0e1kw7 _93pdidpf _1sglstnw _1ksob3bt _1p9sidpf _1qa1u2gc _1jjcu2gc _fiem1ldt _pascidpf _eid3idpf _zr3eidpf _fntnidpf _1mp41kw7 _kfgte4h9 _1cs8stnw _1rushloo _1kt9b3bt _1fkridpf _1enwidpf _z5wtu2gc" : "_k48p1wq8 _ahbqx0bf _gpbcidpf _10vzidpf _1mmwidpf _15plidpf _7hip15vq _1fud15vq _bb0mh2mm _1quzjjyb _rzxytlke _1ofh12x7 _pryi12x7 _1a85u2gc _rmpau2gc _1dze1l2s _1tms1q9c _fiizidpf _1xrmidpf _xyihidpf _166qidpf _17hygqwt _1lzu1eqa _24g71kw7 _140sidpf _lycustnw _15d8b3bt _1fztidpf _wd7eu2gc _1olcu2gc _1oazdud1 _w9ewidpf _170tidpf _y1g1idpf _1nvfidpf _1jakgqwt _1b8d1eqa _1n121kw7 _7p9oidpf _o2e1stnw _16u6b3bt _1yk1idpf _1lbou2gc _1c9uu2gc _1i201ouy _bppridpf _1mbxidpf _kn0bidpf _wsgdidpf _9r9ugqwt _rsmz1gcm _1m0e1kw7 _93pdidpf _1sglstnw _1ksob3bt _1p9sidpf _1qa1u2gc _1jjcu2gc _fiem1ldt _pascidpf _eid3idpf _zr3eidpf _fntnidpf _rfx3gqwt _1mp41kw7 _kfgt1bk5 _1cs8stnw _1rushloo _1kt9b3bt _1fkridpf _1enwidpf _z5wtu2gc"
        ]),
        children: childrenArray.map((child, index)=>getTabWithContext({
                tab: child,
                index: index,
                isSelected: index === selected
            }))
    });
};
var $b96e2c7b7779acd6$export$2e2bcd8739ae039 = $b96e2c7b7779acd6$var$TabList;

});

parcelRegister("1yZHf", function(module, exports) {

$parcel$export(module.exports, "useScreenTabs", () => $d73e5ca43caa1250$export$64c8d02894d27e32);

var $eJOHy = parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");

var $ftN6c = parcelRequire("ftN6c");

var $i7n3g = parcelRequire("i7n3g");

var $hHjAX = parcelRequire("hHjAX");

var $bExMD = parcelRequire("bExMD");

var $ixrOr = parcelRequire("ixrOr");

var $aD2Xh = parcelRequire("aD2Xh");
const $d73e5ca43caa1250$export$64c8d02894d27e32 = ({ tabs: tabs, viewProps: viewProps, selected: selected, onChange: onChange })=>{
    (0, $gRw8I.di)((0, $i7n3g.useAdjustmentsEnabled), (0, $bExMD.useViewType), (0, $ixrOr.useAdjustedScreenTabs), (0, $hHjAX.useTriggerFieldInitialization));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const adjustmentsAreEnabled = (0, $i7n3g.useAdjustmentsEnabled)();
    const viewType = (0, $bExMD.useViewType)();
    const [adjustedScreenTabs, { initializeNoScreenTab: initializeNoScreenTab, initializeScreenTabs: initializeScreenTabs, updateActiveScreenTab: updateActiveScreenTab }] = (0, $ixrOr.useAdjustedScreenTabs)();
    const memoizedTabs = (0, $aD2Xh.useMemoizedTabs)(tabs);
    const [triggerFieldInitializationKey] = (0, $hHjAX.useTriggerFieldInitialization)();
    const selectedRef = (0, $eJOHy.useRef)(selected);
    // Always refreshes `selectedRef` value using their props value
    selectedRef.current = selected;
    // Initialize screen tabs once in UIM store
    (0, $eJOHy.useEffect)(()=>{
        if (!adjustmentsAreEnabled) return;
        // receiving an empty tab array and no selected need to be initialized in store
        if (!memoizedTabs.length && !selectedRef.current) {
            initializeNoScreenTab();
            return;
        }
        // receiving single tab means there's no screen tab visible on view
        if (memoizedTabs.length === 1) {
            initializeScreenTabs({
                tabs: [],
                selected: 0
            });
            return;
        }
        // receiving multiple tabs
        initializeScreenTabs({
            tabs: memoizedTabs,
            selected: selectedRef.current
        });
    /**
		 * `triggerFieldInitializationKey` changes upon subsequent view re-renderings.
		 * Typical usage is inside GIC having "Create new Issue" checkbox ticked.
		 * When this happens, we want to re-run initializeScreenTabs.
		 */ }, [
        adjustmentsAreEnabled,
        viewType,
        memoizedTabs,
        initializeNoScreenTab,
        initializeScreenTabs,
        createAnalyticsEvent,
        triggerFieldInitializationKey
    ]);
    // Controlled tabs are synced with UIM store
    const controlledTabs = (0, $eJOHy.useMemo)(()=>{
        if (adjustmentsAreEnabled && Array.isArray(adjustedScreenTabs)) {
            const adjustedVisibilityMap = {};
            for (const adjustedScreenTab of adjustedScreenTabs)adjustedVisibilityMap[adjustedScreenTab.id] = adjustedScreenTab.isVisible;
            return tabs.map((inputTab)=>({
                    ...inputTab,
                    // isVisible is determined by the UIM store, but if not, default to true
                    isVisible: adjustedVisibilityMap[inputTab.id] ?? true
                }));
        }
        // default all tabs to be visible
        return tabs.map((inputTab)=>({
                ...inputTab,
                isVisible: true
            }));
    }, [
        adjustmentsAreEnabled,
        tabs,
        adjustedScreenTabs
    ]);
    // Controlled selected is synced with UIM store unless initialization hasn't happened or activeAdjustedTab is empty
    const controlledSelected = (0, $eJOHy.useMemo)(()=>{
        if (!adjustmentsAreEnabled || !Array.isArray(adjustedScreenTabs) || !adjustedScreenTabs.length || viewProps?.shouldDisableScreenTabsControl) return selected;
        const activeAdjustedTab = adjustedScreenTabs.find((tab)=>tab.isActive);
        if (activeAdjustedTab) return memoizedTabs.findIndex((tab)=>tab.id === activeAdjustedTab.id);
        return selected;
    }, [
        adjustmentsAreEnabled,
        adjustedScreenTabs,
        viewProps?.shouldDisableScreenTabsControl,
        memoizedTabs,
        selected
    ]);
    // Controlled onChange is propagating user changing tabs to the UIM store
    const controlledOnChange = (0, $eJOHy.useCallback)((...args)=>{
        const [userNewSelected] = args;
        if (adjustmentsAreEnabled) updateActiveScreenTab({
            selected: userNewSelected
        });
        onChange?.(...args);
    }, [
        adjustmentsAreEnabled,
        onChange,
        updateActiveScreenTab
    ]);
    // Call onChange() once when controlledSelected focuses a different tab than the initially selected
    (0, $eJOHy.useEffect)(()=>{
        if (memoizedTabs.length > 0 && typeof controlledSelected === 'number' && controlledSelected !== selected) onChange?.(controlledSelected, createAnalyticsEvent({}));
    }, [
        controlledSelected,
        memoizedTabs,
        selected,
        onChange,
        createAnalyticsEvent
    ]);
    return {
        controlledTabs: controlledTabs,
        controlledSelected: controlledSelected,
        controlledOnChange: controlledOnChange
    };
};

});
parcelRegister("hHjAX", function(module, exports) {

$parcel$export(module.exports, "useTriggerFieldInitialization", () => $96e496915dc2c75e$export$1c69013aaf9112f0);

var $iJq0l = parcelRequire("iJq0l");

var $ixrOr = parcelRequire("ixrOr");
const $96e496915dc2c75e$var$selectTriggerFieldInitializationKey = (state)=>state.triggerFieldInitializationKey;
const $96e496915dc2c75e$export$1c69013aaf9112f0 = (0, $iJq0l.createHook)((0, $ixrOr.store), {
    selector: $96e496915dc2c75e$var$selectTriggerFieldInitializationKey
});

});

parcelRegister("bExMD", function(module, exports) {

$parcel$export(module.exports, "useViewType", () => $3eeb96b023c1db1c$export$1568c16ff8af07a3);

var $iJq0l = parcelRequire("iJq0l");

var $ixrOr = parcelRequire("ixrOr");
const $3eeb96b023c1db1c$export$1568c16ff8af07a3 = (0, $iJq0l.createStateHook)((0, $ixrOr.store), {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    selector: (state)=>state.viewType
});

});

parcelRegister("aD2Xh", function(module, exports) {

$parcel$export(module.exports, "useMemoizedTabs", () => $d264debc055204a3$export$df1fb9a4d15ebe6a);

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");
const $d264debc055204a3$var$mapTabKnownProps = (tabs)=>tabs.map(({ id: id })=>({
            id: id
        }));
function $d264debc055204a3$export$df1fb9a4d15ebe6a(tabs) {
    const memoizedTabsRef = (0, $eJOHy.useRef)(tabs);
    return (0, $eJOHy.useMemo)(()=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))($d264debc055204a3$var$mapTabKnownProps(memoizedTabsRef.current), $d264debc055204a3$var$mapTabKnownProps(tabs))) {
            memoizedTabsRef.current = tabs;
            return tabs;
        }
        return memoizedTabsRef.current;
    }, [
        tabs
    ]);
}

});


parcelRegister("klRjZ", function(module, exports) {

$parcel$export(module.exports, "ConditionallyVisibleDiv", () => $7e0dafd242624a36$export$f154ce6a32df6563);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $7e0dafd242624a36$var$conditionallyVisibleStyles = {
    visible: "_1e0c1ule",
    hidden: "_1e0cglyw"
};
function $7e0dafd242624a36$export$f154ce6a32df6563({ isVisible: isVisible = true, children: children, testId: testId, id: id, role: role }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        id: id,
        role: role,
        "data-testid": testId,
        className: (0, $hcewu.default)([
            $7e0dafd242624a36$var$conditionallyVisibleStyles[isVisible ? 'visible' : 'hidden']
        ]),
        children: children
    });
}

});

parcelRegister("fY88g", function(module, exports) {

$parcel$export(module.exports, "default", () => $1127dbe3008db3d3$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $9Dhvc = parcelRequire("9Dhvc");

var $aXKmr = parcelRequire("aXKmr");

var $4iJGP = parcelRequire("4iJGP");

var $4NEt5 = parcelRequire("4NEt5");

var $7jTnu = parcelRequire("7jTnu");

var $gPU3b = parcelRequire("gPU3b");

var $a1pDt = parcelRequire("a1pDt");

var $bYusI = parcelRequire("bYusI");

var $epTsa = parcelRequire("epTsa");

var $8ivLn = parcelRequire("8ivLn");

var $bVObd = parcelRequire("bVObd");

var $jQUoP = parcelRequire("jQUoP");

var $jipjz = parcelRequire("jipjz");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $Gb6hR = parcelRequire("Gb6hR");


var $gvcEL = parcelRequire("gvcEL");

var $i7n3g = parcelRequire("i7n3g");

var $6sCcV = parcelRequire("6sCcV");

var $1eq5t = parcelRequire("1eq5t");


var $faLFr = parcelRequire("faLFr");

var $c3eoY = parcelRequire("c3eoY");

var $6u3jg = parcelRequire("6u3jg");

var $fjUgP = parcelRequire("fjUgP");

var $aWufh = parcelRequire("aWufh");
/**
 * This hook memoizes getFormState function when it has a valid value
 * If we don't do this, the fields to which we pass getFormState will rerender everytime any other field changes (even for every keyboard stroke)
 */ const $1127dbe3008db3d3$var$useMemoizedGetFormState = (getFormState)=>{
    const ref = (0, $eJOHy.useRef)(getFormState); // Initialise with getFormState
    (0, $eJOHy.useMemo)(()=>{
        // If there's a valid value already, we keep using it. We can assume that getFormState doesn't get stale since it is a function which returns state
        if (ref.current) return;
        // Use new value if previous ref.current is not valid
        ref.current = getFormState;
    }, [
        getFormState
    ]);
    return ref.current;
};
const $1127dbe3008db3d3$export$90edc2cad754ca2e = (props)=>{
    const { onFieldMount: onFieldMount, onKeyDown: onKeyDown, fieldId: fieldId, componentProps: componentProps, Component: Component, apiLatency: apiLatency, isSubsequentLoad: isSubsequentLoad, wasStateRestored: wasStateRestored, getFormState: getFormState, setFieldValue: setFieldValue } = props;
    const [{ selectedProject: selectedProject }, { setIsFormLoaded: setIsFormLoaded }] = (0, $jQUoP.useFormContext)();
    const isMountEventFired = (0, $eJOHy.useRef)(false);
    (0, $eJOHy.useEffect)(()=>{
        if (isMountEventFired.current === false) {
            isMountEventFired.current = true;
            if ('requestIdleCallback' in window) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.requestIdleCallback(()=>onFieldMount(fieldId), {
                timeout: 50
            });
            else setTimeout(()=>{
                onFieldMount(fieldId);
            }, 50);
        }
    }, [
        onFieldMount,
        fieldId
    ]);
    const onLayoutDone = (0, $eJOHy.useCallback)(()=>{
        const globalIssueCreateModalLoadMetric = isSubsequentLoad ? (0, $bVObd.globalIssueCreateModalLoadSubsequent) : (0, $bVObd.globalIssueCreateModalLoad);
        // @ts-expect-error - TS2445 - Property 'state' is protected and only accessible within class 'BaseMetric' and its subclasses.
        if (globalIssueCreateModalLoadMetric.state === 'started') {
            const stopTime = Math.floor(performance.now());
            const customData = {
                apiLatency: apiLatency,
                featureFlags: Object.fromEntries((0, $4iJGP.allFeatureFlagsAccessed)),
                // TODO: Need to understand & update logic code to fix this issue, e.g. checking null and return a default value
                // @ts-expect-error - TS2531 - Object is possibly 'null'. | TS2445 - Property 'startTime' is protected and only accessible within class 'BaseMetric' and its subclasses.
                tti: Math.floor(stopTime - globalIssueCreateModalLoadMetric.startTime),
                isFirstTime: !isSubsequentLoad,
                wasStateRestored: wasStateRestored
            };
            globalIssueCreateModalLoadMetric.stop({
                customData: // @ts-expect-error - TS2322 - Type '{ apiLatency: number | null; tti: number; isFirstTime: boolean; }' is not assignable to type 'CustomValues'.
                customData
            });
            (0, $Gb6hR.markGicTti)();
        }
        setIsFormLoaded(true);
    }, [
        apiLatency,
        isSubsequentLoad,
        setIsFormLoaded,
        wasStateRestored
    ]);
    const extendedComponentProps = {
        ...componentProps,
        onLayoutDone: onLayoutDone
    };
    const isAdjustmentsEnabled = (0, $i7n3g.useAdjustmentsEnabled)();
    const isEmbedded = (0, $8ivLn.useIsEmbedded)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1127dbe3008db3d3$var$FieldContainer, {
        onKeyDown: onKeyDown,
        key: fieldId,
        id: `${fieldId}-container`,
        "data-testid": `issue-create.ui.modal.create-form.layout-renderer.field-renderer.field.${fieldId}`
    }, isAdjustmentsEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4NEt5.JiraIssueCreateErrorBoundary), {
        id: "globalIssueCreateIssueAdjustmentsAdapter",
        packageName: "issueCreateModal",
        fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bYusI.ErrorHandler), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Component, extendedComponentProps)),
        sendToPrivacyUnsafeSplunk: true,
        attributes: (error)=>({
                errorType: (0, $a1pDt.getErrorType)(error),
                viewType: (0, $6d500eb1fc6bc124$export$e615b7e9b8fb4715),
                fieldType: extendedComponentProps.fieldType,
                fieldId: fieldId
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gvcEL.FieldDecoratorAsync), {
        Component: Component,
        componentProps: extendedComponentProps
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Component, extendedComponentProps), fieldId === 'summary' && !isEmbedded && (0, $epTsa.expVal)('proactive_similar_work_items_in_gic_experiment', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4NEt5.JiraIssueCreateErrorBoundary), {
        id: "globalIssueCreateIssue-similar-work-items",
        packageName: "jiraIssueCreateModal",
        fallback: ()=>null,
        sendToPrivacyUnsafeSplunk: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6sCcV.SimilarWorkItemInGIC), {
        getFormState: getFormState,
        selectedProjectId: selectedProject?.value,
        setFieldValue: setFieldValue
    })));
};
const $1127dbe3008db3d3$var$FieldRendererBase = (props)=>{
    const isGICPositioningEnabled = (0, $6u3jg.useIsGICPositioningEnabled)();
    const [{ isSubTaskCreationOpen: isSubTaskCreationOpen, isCreateLinkedIssue: isCreateLinkedIssue, isSubsequentLoad: isSubsequentLoad, minimizableModalView: minimizableModalView, wasStateRestored: wasStateRestored, isMiniDesignEnabled: isMiniDesignEnabled, FieldWrapperComponent: FieldWrapperComponent, isModalOpen: isModalOpen }] = (0, $jipjz.useTriggerIssueCreateModal)();
    const { fieldConfig: fieldConfig, getFormState: getFormState, apiLatency: apiLatency, setFieldValue: setFieldValue, isCollapsed: isCollapsed, isFieldResponsive: isFieldResponsive } = props;
    /**
   * hiding "epic link" and "parent link fields by filtering them based on their type.
   * Note that this is a temporary frontend solution until we remove these fields in the backend,
   * which is scheduled to be done in FY25 Q3.
   */ const fields = props.fields.filter((fieldId)=>{
        // @ts-expect-error - TS2339 - Property 'gqlType' does not exist on type '(BaseField & FieldConfigValueWithoutBaseField) | {}'.
        const { gqlType: gqlType } = (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(fieldConfig, fieldId, {});
        return gqlType !== (0, $af620ae3ac843a8a$export$8723b724f0b3ac65) && gqlType !== (0, $af620ae3ac843a8a$export$670384150af5f49e);
    });
    // TODO Add this field with the fields on previous line when cleaning FF
    const fieldPropsExtensions = isGICPositioningEnabled() ? props.fieldPropsExtensions : undefined;
    const [{ selectedProject: selectedProject, selectedIssueType: selectedIssueType, shouldAutoFocus: shouldAutoFocus, ecosystem: { forge: { customFields: customFields, filteredOutModules: filteredOutModules, hasFinishedLoading: hasFinishedLoading } }, currentActiveTabIndex: currentActiveTabIndex }, { setIsOperationInProgress: setIsOperationInProgress }] = (0, $jQUoP.useFormContext)();
    const renderAllFieldsInTabStartTime = (0, $eJOHy.useRef)(0);
    // Start by rendering the first field alone to give the user some visual feedback quickly
    // should be increased to a full "batch" of ~10 fields when field rendering performance is improved
    const [fieldsToRenderCount, setFieldsToRenderCount] = (0, $eJOHy.useState)(1);
    const fieldsMountedCount = (0, $eJOHy.useRef)(0);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const isMini = minimizableModalView === 'mini' || isMiniDesignEnabled;
    const renderedAllFields = (0, $eJOHy.useRef)(false);
    const getFormStateMemoized = $1127dbe3008db3d3$var$useMemoizedGetFormState(getFormState);
    (0, $eJOHy.useEffect)(()=>{
        renderAllFieldsInTabStartTime.current = performance.now();
        setIsOperationInProgress(true);
        const analyticsEvent = createAnalyticsEvent({});
        (0, $gCeeo.fireTrackAnalyticsDeferred)(analyticsEvent, 'gic renderAllFieldsInTabStart', {});
        renderedAllFields.current = false;
    }, [
        setIsOperationInProgress,
        createAnalyticsEvent
    ]);
    const fieldsLength = fields.length;
    const fieldsRendererSessionId = (0, $eJOHy.useRef)('');
    const fieldsAlreadyFullyLoaded = (0, $eJOHy.useRef)(false);
    (0, $eJOHy.useEffect)(()=>{
        if (!isModalOpen) return;
        fieldsRendererSessionId.current = (0, $aXKmr.v4)();
        fieldsAlreadyFullyLoaded.current = false;
        const analyticsEvent = createAnalyticsEvent({});
        (0, $gCeeo.fireTrackAnalyticsDeferred)(analyticsEvent, 'gic fieldsToRenderTab', {
            fieldsLength: fieldsLength,
            fieldsRendererSessionId: fieldsRendererSessionId.current
        });
    }, [
        createAnalyticsEvent,
        fieldsLength,
        isModalOpen
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!isModalOpen || fieldsToRenderCount < fieldsLength || fieldsAlreadyFullyLoaded.current) return;
        fieldsAlreadyFullyLoaded.current = true;
        const analyticsEvent = createAnalyticsEvent({});
        (0, $gCeeo.fireTrackAnalyticsDeferred)(analyticsEvent, 'gic fieldsFullyRenderedTab', {
            fieldsLength: fieldsLength,
            fieldsRendererSessionId: fieldsRendererSessionId.current
        });
    }, [
        createAnalyticsEvent,
        fieldsLength,
        fieldsToRenderCount,
        isModalOpen
    ]);
    const onFieldMount = ()=>{
        fieldsMountedCount.current += 1;
        if (fieldsMountedCount.current >= fieldsToRenderCount) setFieldsToRenderCount((currentCount)=>currentCount + (0, $aWufh.getFieldsToRenderInOneBatch)(fields.length));
        if (fieldsMountedCount.current >= fields.length && !renderedAllFields.current) {
            setIsOperationInProgress(false);
            // send event to monitor in different browsers that the fields rendered successfully
            const analyticsEvent = createAnalyticsEvent({});
            const attributes = {
                timeToRenderAllFieldsInTabMs: Math.floor(performance.now() - renderAllFieldsInTabStartTime.current),
                fields: fields
            };
            (0, $gCeeo.fireTrackAnalyticsDeferred)(analyticsEvent, 'gic renderedAllFieldsInTab', attributes);
            renderedAllFields.current = true;
        }
        // The last call to `mark` is the time used in the final metric
        // We use this fact to obtain when the final field was mounted
        (0, $Gb6hR.globalIssueCreateTTIWithAdjustments).mark('gic-all-fields-loaded');
    };
    const fieldsToRender = fields.slice(0, fieldsToRenderCount).map((fieldId, index)=>{
        let content = null;
        // @ts-expect-error - TS2339 - Property 'gqlType' does not exist on type '(BaseField & FieldConfigValueWithoutBaseField) | {}'.
        const { gqlType: gqlType, ...rest } = (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(fieldConfig, fieldId, {});
        // @ts-expect-error - TS2339 - Property 'fieldName' does not exist on type '{ fieldId: string; fieldName: string; description?: string | undefined; isRequired?: boolean | undefined; isEditable?: boolean | undefined; nonEditableReason?: { message?: string | undefined; } | undefined; ... 6 more ...; onLayoutDone?: (() => void) | undefined; } | {}'. | TS2339 - Property 'description' does not exist on type '{ fieldId: string; fieldName: string; description?: string | undefined; isRequired?: boolean | undefined; isEditable?: boolean | undefined; nonEditableReason?: { message?: string | undefined; } | undefined; ... 6 more ...; onLayoutDone?: (() => void) | undefined; } | {}'. | TS2339 - Property 'isRequired' does not exist on type '{ fieldId: string; fieldName: string; description?: string | undefined; isRequired?: boolean | undefined; isEditable?: boolean | undefined; nonEditableReason?: { message?: string | undefined; } | undefined; ... 6 more ...; onLayoutDone?: (() => void) | undefined; } | {}'. | TS2339 - Property 'fieldType' does not exist on type '{ fieldId: string; fieldName: string; description?: string | undefined; isRequired?: boolean | undefined; isEditable?: boolean | undefined; nonEditableReason?: { message?: string | undefined; } | undefined; ... 6 more ...; onLayoutDone?: (() => void) | undefined; } | {}'.
        const { fieldName: fieldName, description: description, isRequired: isRequired, fieldType: fieldType } = rest;
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly JiraAffectedServicesField: { readonly Component: AbstractComponent<ReturnComponentProps<AffectedServicesFieldConfig>, any>; readonly defaultValueKey: "selectedAffectedServices"; readonly submitTransform: (options: AffectedServiceOption[]) => ServiceEntity[]; readonly retainUserInputTransform: (selectedAff...'.
        const FieldDetails = (0, $1eq5t.getGqlFieldMap)()[gqlType];
        const commonAttributesInfo = {
            autoFocus: index === 0 && currentActiveTabIndex === 0 && (0, $fjUgP.FIELDS_WITHOUT_DROPDOWN_MENU).includes(gqlType) && shouldAutoFocus,
            isSubTaskCreationOpen: isSubTaskCreationOpen,
            isDropdownMenuFixedAndLayered: true,
            componentKey: (0, $fjUgP.FORCE_RENDER_ON_TAB_CHANGE).includes(gqlType) ? `${fieldId}-${currentActiveTabIndex}` : undefined,
            isCreateLinkedIssue: (0, $fjUgP.FIELDS_NEEDING_CREATE_LINKED_ISSUE_INFO).includes(gqlType) && (0, $7jTnu.fg)('create_linked_issues_trigger_point_issue_view') ? isCreateLinkedIssue : false,
            isMini: isMini,
            isCollapsed: isCollapsed,
            isFieldResponsive: isFieldResponsive
        };
        const extraProps = {
            ...commonAttributesInfo,
            selectedProject: (0, $fjUgP.FIELDS_WITH_SELECTED_PROJECT).includes(gqlType) ? selectedProject : undefined,
            selectedIssueType: (0, $fjUgP.FIELDS_WITH_SELECTED_ISSUE_TYPE).includes(gqlType) ? selectedIssueType : undefined,
            // @ts-expect-error - TS2322 - Type 'HookFunction<State, BoundActions<State, { readonly setCurrentActiveTabIndex: (tabIndex: number) => Action<State, void, void | Promise<void>>; readonly setSelectedProject: (project: Project) => Action<...>; ... 20 more ...; readonly setSummaryValue: (summary: string) => Action<...>; }>, void> | undefined' is not assignable to type 'HookFunction<State, { readonly setCurrentActiveTabIndex: (tabIndex: number) => Action<State, void, void | Promise<void>>; readonly setSelectedProject: (project: Project) => Action<...>; ... 20 more ...; readonly setSummaryValue: (summary: string) => Action<...>; }, undefined> | undefined'.
            useFormContext: (0, $fjUgP.FIELDS_NEEDING_FORM_CONTEXT).includes(gqlType) ? (0, $jQUoP.useFormContext) : undefined,
            contextAndValuesOfIssueBeingCreated: (0, $fjUgP.FIELDS_NEEDING_COMPLETE_FORM_STATE).includes(gqlType) ? {
                getFormState: getFormState,
                selectedIssueType: selectedIssueType,
                fieldConfig: fieldConfig
            } : undefined,
            getFormState: (0, $fjUgP.FIELDS_NEEDING_GET_FORM_STATE).includes(gqlType) ? getFormStateMemoized : undefined,
            onInProgressChange: (0, $fjUgP.FIELDS_WITH_ON_INPROGRESS_CHANGE).includes(gqlType) ? setIsOperationInProgress : undefined,
            forge: fieldType !== undefined && (0, $gPU3b.isForgeCustomField)(fieldType) ? {
                selectedProject: selectedProject,
                selectedIssueType: selectedIssueType,
                modules: customFields,
                filteredOutModules: filteredOutModules,
                hasFinishedLoading: hasFinishedLoading
            } : undefined,
            fieldHelpTextUrl: (0, $aWufh.getHelpTextUrl)(gqlType),
            onLinkClickEvent: (0, $aWufh.getOnLinkClickEvent)(gqlType)
        };
        if (isGICPositioningEnabled() && fieldPropsExtensions?.[fieldType] && (0, $fjUgP.FIELDS_WITH_EXTENSION_PROPS).includes(gqlType)) Object.assign(extraProps, fieldPropsExtensions[fieldType]);
        if (FieldDetails) {
            const { Component: Component, defaultValueKey: defaultValueKey } = FieldDetails;
            const fieldContainerWrapperProps = {
                ...defaultValueKey === 'parentIssue' ? {} : {
                    onKeyDown: (0, $c3eoY.preventEscKeyPropagationKeyPressHandler)
                },
                fieldId: fieldId,
                componentProps: {
                    ...rest,
                    ...extraProps,
                    fieldName: fieldName,
                    description: description,
                    gqlType: gqlType,
                    fieldWrapperElement: FieldWrapperComponent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(FieldWrapperComponent, {
                        fieldId: fieldId,
                        field: (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(fieldConfig, fieldId),
                        setFieldValue: setFieldValue
                    }) : null
                },
                getFormState: getFormState,
                Component: Component,
                onFieldMount: onFieldMount,
                apiLatency: apiLatency,
                isSubsequentLoad: isSubsequentLoad,
                setFieldValue: setFieldValue,
                wasStateRestored: wasStateRestored
            };
            // @ts-expect-error - TS2322 - Type '{ onKeyDown: (e: KeyboardEvent<Element> | KeyboardEvent<EventTarget>) => void; fieldId: string; componentProps: { fieldName: any; ... 24 more ...; onLayoutDone?: (() => void) | undefined; }; ... 7 more ...; key: string; }' is not assignable to type 'FieldContainerWrapperProps'.
            content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1127dbe3008db3d3$export$90edc2cad754ca2e, {
                key: fieldId,
                ...fieldContainerWrapperProps
            });
        } else content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1127dbe3008db3d3$var$FieldContainer, {
            key: fieldId,
            "data-testid": `issue-create.ui.modal.create-form.layout-renderer.field-renderer.field.${fieldId}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $faLFr.default), {
            fieldId: fieldId,
            fieldName: fieldName,
            isRequired: isRequired,
            description: description,
            projectType: selectedProject?.projectType,
            gqlType: gqlType,
            fieldType: fieldType,
            onFieldMount: onFieldMount,
            isMini: isMini
        }));
        const errorAttributes = {
            ...commonAttributesInfo,
            isProjectSelected: (0, $fjUgP.FIELDS_WITH_SELECTED_PROJECT).includes(gqlType),
            selectedIssueType: (0, $fjUgP.FIELDS_WITH_SELECTED_ISSUE_TYPE).includes(gqlType),
            isFormContextProvided: (0, $fjUgP.FIELDS_NEEDING_FORM_CONTEXT).includes(gqlType),
            IscontextAndValuesOfIssueBeingCreatedProvided: !!(0, $fjUgP.FIELDS_NEEDING_COMPLETE_FORM_STATE).includes(gqlType),
            isGetFormStateProvided: (0, $fjUgP.FIELDS_NEEDING_GET_FORM_STATE).includes(gqlType),
            isOnInProgressChangeProvided: (0, $fjUgP.FIELDS_WITH_ON_INPROGRESS_CHANGE).includes(gqlType),
            isForgeField: fieldType !== undefined && (0, $gPU3b.isForgeCustomField)(fieldType),
            isFieldHelpTextUrlProvided: !!(0, $aWufh.getHelpTextUrl)(gqlType),
            isOnLinkClickEventProvided: !!(0, $aWufh.getOnLinkClickEvent)(gqlType),
            gqlType: gqlType,
            fieldType: fieldType
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4NEt5.JiraIssueCreateErrorBoundary), {
            id: "globalIssueCreateIssue-field-renderer",
            key: `field-renderer-${fieldId}`,
            packageName: "jiraIssueCreateModal",
            fallback: "unmount",
            onError: ()=>{
                onFieldMount();
            },
            attributes: errorAttributes,
            sendToPrivacyUnsafeSplunk: true
        }, content);
    });
    return fieldsToRender;
};
const $1127dbe3008db3d3$var$FieldRenderer = /*#__PURE__*/ (0, $eJOHy.memo)($1127dbe3008db3d3$var$FieldRendererBase);
var $1127dbe3008db3d3$export$2e2bcd8739ae039 = $1127dbe3008db3d3$var$FieldRenderer;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1127dbe3008db3d3$var$FieldContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pkv47k _1ryssyzs",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gvcEL", function(module, exports) {

$parcel$export(module.exports, "FieldDecoratorAsync", () => $3b7a46e2553ab516$export$7bf1fdc8d847e1ea);

var $eJOHy = parcelRequire("eJOHy");

var $82wKS = parcelRequire("82wKS");
var $i7n3g = parcelRequire("i7n3g");


var $coYCB = parcelRequire("coYCB");
const $3b7a46e2553ab516$var$FieldDecoratorAsyncNoMemo = ({ Component: Component, componentProps: componentProps })=>{
    const adjustmentsAreEnabled = (0, $i7n3g.useAdjustmentsEnabled)();
    const undecoratedComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Component, componentProps);
    // Render FieldDecorator only when field type is supported
    // and adjustments are enabled
    if ((0, $82wKS.isFieldTypeSupported)((0, $6d500eb1fc6bc124$export$e615b7e9b8fb4715), componentProps.fieldType) && adjustmentsAreEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $coYCB.EnabledFieldDecorator), {
        // @ts-expect-error - TS2322 - Type 'ComponentType<T>' is not assignable to type 'ComponentType<DecoratedField>'.
        Component: Component,
        componentProps: componentProps
    });
    return undecoratedComponent;
};
const $3b7a46e2553ab516$export$7bf1fdc8d847e1ea = /*#__PURE__*/ (0, $eJOHy.memo)($3b7a46e2553ab516$var$FieldDecoratorAsyncNoMemo);

});
parcelRegister("coYCB", function(module, exports) {

$parcel$export(module.exports, "EnabledFieldDecorator", () => $14e1111f25b3c5bb$export$a39682472306ffd4);

var $eJOHy = parcelRequire("eJOHy");

var $ixrOr = parcelRequire("ixrOr");
var $9X6wo = parcelRequire("9X6wo");
var $hHjAX = parcelRequire("hHjAX");

var $BAHbx = parcelRequire("BAHbx");

var $2Zk2B = parcelRequire("2Zk2B");

var $6cok7 = parcelRequire("6cok7");
const $14e1111f25b3c5bb$var$EnabledFieldDecoratorNoMemo = ({ Component: Component, componentProps: componentProps })=>{
    const { fieldId: fieldId, fieldName: fieldName, description: description, fieldType: fieldType, isRequired: isRequired = false, gqlType: fieldRenderer, allowedValues: allowedValues } = componentProps;
    const { setFieldValue: setFieldValue, getFieldValue: getFieldValue } = (0, $BAHbx.useFormApi)();
    const [state, { initializeField: initializeField, clearAppliedValue: clearAppliedValue }] = (0, $ixrOr.useAdjustedField)(fieldId);
    const [triggerFieldInitializationKey] = (0, $hHjAX.useTriggerFieldInitialization)();
    const isBusy = (0, $9X6wo.useFieldIsBusy)(fieldId);
    const isVisible = state.isVisible ?? true;
    const isReadOnly = state.isReadOnly ?? false;
    const isRequiredFromUIM = state.isRequired ?? false;
    (0, $eJOHy.useEffect)(()=>{
        const field = {
            fieldName: fieldName,
            fieldId: fieldId,
            description: description,
            isVisible: isVisible,
            fieldType: fieldType,
            isReadOnly: isReadOnly,
            isRequired: isRequired,
            allowedValues: allowedValues,
            value: getFieldValue(fieldId)
        };
        initializeField({
            field: field,
            metadata: {
                fieldRenderer: fieldRenderer
            }
        });
    /**
		 * Because of how the GIC works between subsequent modal openings, UI modifications state is persisted.
		 * That's why want to run initializeField only when triggerFieldInitializationKey change and mounting.
		 */ // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        triggerFieldInitializationKey,
        getFieldValue
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (state.value !== undefined) {
            setFieldValue(fieldId, state.value);
            // Once we have applied the value, we clear it from the state, so we don't apply it again
            // in the future and overwrite whatever the user has changed between now and then
            clearAppliedValue(fieldId);
        }
    }, [
        state.value,
        clearAppliedValue,
        fieldId,
        setFieldValue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2Zk2B.ConditionallyVisibleDiv), {
        key: fieldId,
        isVisible: isVisible,
        "data-testid": `ui-modifications-view-gic.ui.field-decorator.enabled-field-decorator.visibility-wrapper.${fieldId}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Component, {
        ...componentProps,
        ...(0, $6cok7.pickPropertiesToOverwrite)(state),
        ...isBusy ? {
            isReadOnly: true
        } : {},
        areUiModificationsBusy: isBusy,
        isRequiredFromUIM: isRequiredFromUIM
    }));
};
const $14e1111f25b3c5bb$export$a39682472306ffd4 = /*#__PURE__*/ (0, $eJOHy.memo)($14e1111f25b3c5bb$var$EnabledFieldDecoratorNoMemo);

});
parcelRegister("9X6wo", function(module, exports) {

$parcel$export(module.exports, "useFieldIsBusy", () => $ed22fd7b7db62c5e$export$b4ae28da91c35ed4);

var $gRw8I = parcelRequire("gRw8I");

var $21XCU = parcelRequire("21XCU");


var $khhSP = parcelRequire("khhSP");
const $ed22fd7b7db62c5e$export$b4ae28da91c35ed4 = (fieldId)=>{
    (0, $gRw8I.di)((0, $khhSP.useFieldIsProcessing));
    const [isBusyData] = (0, $khhSP.useFieldIsProcessing)(fieldId);
    const uimConsentMap = (0, $21XCU.useUIModificationsConsentStatusForApps)();
    const { isBusy: isBusy, appsIds: appsIds } = isBusyData;
    if (!isBusy) return false;
    return appsIds.some((appId)=>uimConsentMap[appId] !== (0, $5b46c372089c1d7d$export$d67d63332ce3ce38));
};

});
parcelRegister("khhSP", function(module, exports) {

$parcel$export(module.exports, "useFieldIsProcessing", () => $a98a2a791c9deb43$export$7fa63f8479e2806a);

var $jPROM = parcelRequire("jPROM");

var $iJq0l = parcelRequire("iJq0l");
var $4MchI = parcelRequire("4MchI");

var $ixrOr = parcelRequire("ixrOr");
const $a98a2a791c9deb43$export$9076a5ac331011bb = (0, $4MchI.createSelector)((state)=>state.registeredFields, (state)=>state.error, (_, fieldId)=>fieldId, (registeredChangesMap, error, fieldId)=>{
    if (error) return {
        isBusy: false,
        appsIds: []
    };
    const appsIds = Object.entries(registeredChangesMap).filter(([_, registeredFields])=>!(0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(registeredFields) && Object.values(registeredFields).flat().includes(fieldId)).map(([appId])=>appId);
    return {
        isBusy: appsIds.length > 0,
        appsIds: appsIds
    };
});
const $a98a2a791c9deb43$export$7fa63f8479e2806a = (0, $iJq0l.createHook)((0, $ixrOr.store), {
    selector: $a98a2a791c9deb43$export$9076a5ac331011bb
});

});


parcelRegister("2Zk2B", function(module, exports) {

$parcel$export(module.exports, "ConditionallyVisibleDiv", () => $6a50ca03364ac9d0$export$f154ce6a32df6563);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $6a50ca03364ac9d0$export$f154ce6a32df6563 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isVisible: isVisible, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "",
            __cmplp.isVisible ? "_1e0c1bgi" : "_1e0cglyw",
            __cmplp.className
        ])
    });
});

});

parcelRegister("6cok7", function(module, exports) {

$parcel$export(module.exports, "pickPropertiesToOverwrite", () => $8b1c7260bbe54479$export$7aa61edf4d7c035e);
const $8b1c7260bbe54479$export$7aa61edf4d7c035e = (field)=>{
    const overwriteProperties = [
        'fieldName',
        'description',
        'isReadOnly',
        'isRequired',
        'allowedValues'
    ];
    return overwriteProperties.reduce((acc, propertyName)=>{
        const propertyValue = field[propertyName];
        if (propertyValue !== undefined) acc[propertyName] = propertyValue;
        return acc;
    }, {});
};

});



parcelRegister("6sCcV", function(module, exports) {

$parcel$export(module.exports, "SimilarWorkItemInGIC", () => $00c00c9b21ae0186$export$165da81a8778a5f5);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $3s8bj = parcelRequire("3s8bj");

var $12DRg = parcelRequire("12DRg");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $aqZgL = parcelRequire("aqZgL");

var $3XuP5 = parcelRequire("3XuP5");

var $eNgPF = parcelRequire("eNgPF");

var $epTsa = parcelRequire("epTsa");

var $72ggt = parcelRequire("72ggt");

var $jGzN3 = parcelRequire("jGzN3");

var $gYnSx = parcelRequire("gYnSx");

var $jipjz = parcelRequire("jipjz");

var $4R60r = parcelRequire("4R60r");

var $7jTnu = parcelRequire("7jTnu");

var $a3hJj = parcelRequire("a3hJj");

var $1gw7q = parcelRequire("1gw7q");
const $00c00c9b21ae0186$var$getCustomRelatedIssueSearchPayload = (selectedProjectId, summary)=>{
    return {
        project_id: selectedProjectId,
        issue_summary: summary
    };
};
const $00c00c9b21ae0186$export$165da81a8778a5f5 = (props)=>{
    const summary = props.getFormState()?.values?.summary || '';
    const linkedWorkItems = props.getFormState()?.values?.issuelinks?.issues || [];
    const linkedWorkItemValues = linkedWorkItems.map((linkedWorkItem)=>linkedWorkItem.value);
    const selectedProjectId = props.selectedProjectId || '';
    const isLinkedWorkItemFieldPresent = props.getFormState()?.values?.issuelinks || null;
    const [showComponent, setShowComponent] = (0, $eJOHy.useState)(false);
    const [debouncedSummary, setDebouncedSummary] = (0, $eJOHy.useState)('');
    const prevSummaryRef = (0, $eJOHy.useRef)(summary);
    const productName = (0, $eNgPF.useProductName)();
    const adminHubAiProductName = (0, $a3hJj.getProductForAdminHubAi)(productName);
    const { data: isAdminHubAiEnabled, fetchAIEnablement: fetchAIEnablement } = (0, $3XuP5.default)(adminHubAiProductName);
    const getPrefilledIssueCreateProps = (0, $72ggt.useIssueCreateModalWithPrefillingForIssueCreateEmbed)();
    const openIssueCreateModal = (0, $jipjz.useOpenIssueCreateModal)();
    // check if AI is enabled for the selected project/product
    (0, $eJOHy.useEffect)(()=>{
        fetchAIEnablement();
    }, [
        fetchAIEnablement
    ]);
    const debouncedUpdate = (0, $eJOHy.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))((value)=>{
            setDebouncedSummary(value);
            if (value) setShowComponent(true);
            else setShowComponent(false);
        }, 1000), []);
    (0, $eJOHy.useEffect)(()=>{
        const trimmedSummary = String(summary).trim();
        if (trimmedSummary !== prevSummaryRef.current) {
            debouncedUpdate(trimmedSummary);
            prevSummaryRef.current = trimmedSummary;
        }
        return ()=>{
            debouncedUpdate.cancel();
        };
    }, [
        summary,
        debouncedUpdate
    ]);
    const customRelatedIssueSearchPayload = (0, $eJOHy.useMemo)(()=>{
        return $00c00c9b21ae0186$var$getCustomRelatedIssueSearchPayload(selectedProjectId, debouncedSummary);
    }, [
        selectedProjectId,
        debouncedSummary
    ]);
    const prefillIssueCreateModalWithData = async (transformedPayload)=>{
        const { issueCreatePayload: issueCreatePayload, prefilledCustomFields: prefilledCustomFields, ecosystemCallback: ecosystemCallback } = await getPrefilledIssueCreateProps(transformedPayload);
        // Open the issue creation modal with the necessary payload
        openIssueCreateModal({
            triggerPointKey: 'global-create-button',
            payload: {
                ...issueCreatePayload
            },
            prefilledCustomFields: prefilledCustomFields,
            ecosystemCallback: ecosystemCallback
        });
    };
    const onCopyButtonClick = async (issueKey)=>{
        try {
            // Fetch issue details from the API
            const response = await (0, $jGzN3.performGetRequest)(`/rest/api/2/issue/${issueKey}`);
            // Transform the response fields into a usable payload
            const transformedPayload = (0, $a3hJj.transformTheIssueDataToGICFormat)(response?.fields);
            // Get prefilled issue creation properties
            prefillIssueCreateModalWithData(transformedPayload);
        } catch (error) {
            // Log and fire error analytics
            (0, $gYnSx.default)({
                error: error instanceof Error ? error : new Error('Unknown error'),
                meta: {
                    id: 'getIssueFieldsSimilarWorkItemsInGIC',
                    packageName: '@atlassian/jira-issue-create',
                    teamName: 'gravity-ai'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
    };
    const onLinkIssueButtonClick = (relatedIssue)=>{
        const linkRelatedIssuePayload = {
            label: relatedIssue.issueKey,
            value: relatedIssue.issueKey,
            id: relatedIssue.id,
            iconUrl: relatedIssue.issueTypeIconUrl
        };
        const currentLinking = props.getFormState()?.values?.issuelinks.linkType || null;
        const currentLinkedIssues = props.getFormState()?.values?.issuelinks.issues || [];
        if (currentLinking) props.setFieldValue('issuelinks', {
            linkType: currentLinking,
            issues: [
                ...currentLinkedIssues,
                linkRelatedIssuePayload
            ]
        });
    };
    return (0, $7jTnu.fg)('similar_items_in_gic_ui_fixes') ? showComponent && isAdminHubAiEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            "_1pbyidpf _kqswh2mm"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $00c00c9b21ae0186$var$relatedIssuesContainerStylesUIFix
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4R60r.JiraIssueRelatedIssuesContainer), {
        scope: "related-issues-in-gic"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aqZgL.SuggestRelatedWorkItemsContentContainer), {
        issueKey: "",
        onIssueLinkSave: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
        existingIssues: (0, $7jTnu.fg)('similar_work_items_in_gic_link_work_items') ? linkedWorkItemValues : [
            ''
        ],
        customRelatedIssueSearchPayload: customRelatedIssueSearchPayload,
        invokedFromSource: "globalIssueCreate",
        headerTitle: (0, $1gw7q.default).similarWorkItems,
        ...(0, $epTsa.expVal)('similar_work_items_copy_field_milestone-2', 'isEnabled', false) ? {
            onCopyButtonClick: onCopyButtonClick
        } : undefined,
        ...(0, $7jTnu.fg)('similar_work_items_in_gic_link_work_items') ? {
            onSimilarIssueLinkGICButtonClick: isLinkedWorkItemFieldPresent ? onLinkIssueButtonClick : null
        } : {}
    })))) : showComponent && isAdminHubAiEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $00c00c9b21ae0186$var$relatedIssuesContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4R60r.JiraIssueRelatedIssuesContainer), {
        scope: "related-issues-in-gic"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aqZgL.SuggestRelatedWorkItemsContentContainer), {
        issueKey: "",
        onIssueLinkSave: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
        existingIssues: (0, $7jTnu.fg)('similar_work_items_in_gic_link_work_items') ? linkedWorkItemValues : [
            ''
        ],
        customRelatedIssueSearchPayload: customRelatedIssueSearchPayload,
        invokedFromSource: "globalIssueCreate",
        headerTitle: (0, $1gw7q.default).similarWorkItems,
        ...(0, $epTsa.expVal)('similar_work_items_copy_field_milestone-2', 'isEnabled', false) ? {
            onCopyButtonClick: onCopyButtonClick
        } : undefined,
        ...(0, $7jTnu.fg)('similar_work_items_in_gic_link_work_items') ? {
            onSimilarIssueLinkGICButtonClick: isLinkedWorkItemFieldPresent ? onLinkIssueButtonClick : null
        } : {}
    })));
};
const $00c00c9b21ae0186$var$relatedIssuesContainerStylesUIFix = (0, $1DXK0.xcss)({
    marginTop: 'space.050',
    borderWidth: 'border.width',
    borderStyle: 'solid',
    borderColor: 'color.border.input',
    borderRadius: 'border.radius'
});
const $00c00c9b21ae0186$var$relatedIssuesContainerStyles = (0, $1DXK0.xcss)({
    marginTop: 'space.300'
});
const $00c00c9b21ae0186$var$similarWorkItemsWrapperStyles = null;

});
parcelRegister("aqZgL", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "SuggestRelatedWorkItemsContentContainer", () => $29e5856fe7bbc6dc$export$eb52075d944dbdfb);
$parcel$export(module.exports, "default", () => $29e5856fe7bbc6dc$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $aXKmr = parcelRequire("aXKmr");

var $4xbv3 = parcelRequire("4xbv3");
var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $epTsa = parcelRequire("epTsa");

var $2Sr3y = parcelRequire("2Sr3y");

var $dOShM = parcelRequire("dOShM");

var $1uIew = parcelRequire("1uIew");

var $7jTnu = parcelRequire("7jTnu");

var $4R60r = parcelRequire("4R60r");

var $8v03d = parcelRequire("8v03d");

var $d2AGn = parcelRequire("d2AGn");

var $3bSs8 = parcelRequire("3bSs8");

var $6d9QY = parcelRequire("6d9QY");

var $czOOQ = parcelRequire("czOOQ");

var $4R60r = parcelRequire("4R60r");

var $9tyru = parcelRequire("9tyru");

var $gPgMe = parcelRequire("gPgMe");

var $dxIkO = parcelRequire("dxIkO");

var $j4Juo = parcelRequire("j4Juo");

var $xWB2Z = parcelRequire("xWB2Z");

var $7tFKB = parcelRequire("7tFKB");
const $29e5856fe7bbc6dc$var$getAiEventAttributes = (invokedFrom)=>({
        aiFeatureName: 'jiraAIRelatedIssues',
        isAIFeature: 1,
        proactiveGeneratedAI: invokedFrom === 'issueLinksAddButton' || invokedFrom === 'linkedWorkItemQuickAdd' || invokedFrom === 'connectRelatedWorkLinkWorkItem' || invokedFrom === 'globalIssueCreate' ? 1 : 0,
        userGeneratedAI: invokedFrom === 'improveIssueDropdown' ? 1 : 0
    });
const $29e5856fe7bbc6dc$var$FEEDBACK_ENTRYPOINT_ID = 'f91a821a-c7b4-47a6-bc0c-b99c234f3124';
const $29e5856fe7bbc6dc$var$FEEDBACK_COLLECTOR_ID = '043ab007-eb05-4694-9742-302b0a7f41a6';
const $29e5856fe7bbc6dc$var$UNCATEGORISED_ERROR = 'UNKNOWN ERROR';
const $29e5856fe7bbc6dc$export$eb52075d944dbdfb = (props)=>{
    const { issueKey: issueKey, existingIssues: existingIssues, onIssueLinkSave: onIssueLinkSave, invokedFromSource: invokedFromSource, onCopyButtonClick: onCopyButtonClick, onSimilarIssueLinkGICButtonClick: onSimilarIssueLinkGICButtonClick, headerTitle: headerTitle = (0, $j4Juo.default).linkSimilarWorkItems } = props;
    /**
   * We track the current and previous issue key to support issue transitions,
   * by resetting the state when the issue key changes, so as to not show the feature on issue view load
   */ const [currentIssueKey, setCurrentIssueKey] = (0, $eJOHy.useState)(issueKey);
    const prevIssueKey = (0, $6d9QY.usePreviousWithInitial)(issueKey);
    const { setInvokedFrom: setInvokedFrom } = (0, $4R60r.useRelatedIssuesActions)();
    if (invokedFromSource) setInvokedFrom(invokedFromSource);
    const singleInstrumentationId = (0, $eJOHy.useRef)((0, $aXKmr.v4)());
    const aiResultViewedSummaryLengthAnalyticsRef = (0, $eJOHy.useRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { issueLinkTypes: issueLinkTypes, relatesToIssueLinkType: relatesToIssueLinkType } = (0, $xWB2Z.useIssueLinkTypesWithRelatesTo)();
    const [{ invokedFrom: invokedFrom, resourceSuggestions: resourceSuggestions, currentStep: currentStep }, { discardAllSuggestions: discardAllSuggestions, setRelatedIssuesFetchStep: setRelatedIssuesFetchStep, setRelatedIssuesDisplayStep: setRelatedIssuesDisplayStep, setRelatedIssuesLoadedStep: setRelatedIssuesLoadedStep, setResourceSuggestion: setResourceSuggestion, resetState: resetState }] = (0, $4R60r.useRelatedIssues)();
    (0, $eJOHy.useEffect)(()=>{
        if (prevIssueKey !== issueKey && (0, $7jTnu.fg)('jira-ai-moving-similar-issues-up')) {
            setCurrentIssueKey(issueKey);
            resetState();
        }
    }, [
        currentIssueKey,
        issueKey,
        prevIssueKey,
        resetState
    ]);
    const { data: data, error: error, loading: loading, fetchSuggestion: fetchSuggestion } = (0, $czOOQ.useFetchRelatedIssue)(existingIssues);
    (0, $eJOHy.useEffect)(()=>{
        if (data && (0, $7jTnu.fg)('platformisation-of-proactive-collapsible-container')) /**
       * We want to move to local state instead of sweet state
       * But, until Similar Issues Draft List is not platformised, we need to use sweet state
       */ data && setResourceSuggestion(data);
    }, [
        data,
        setResourceSuggestion
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if ((0, $epTsa.UNSAFE_noExposureExp)('jira-ai-similar-issues-selectable-draft-list')[0].get('isEnabled', false)) return ()=>{
            (0, $d2AGn.getUpdateAnalyticsFlowHelper)().endSession((0, $3bSs8.ENTITY_FIELD_KEYS).ISSUE_LINKS);
        };
    }, []);
    const draftSuggestions = (0, $eJOHy.useMemo)(()=>{
        const filteredSuggestions = resourceSuggestions?.filter((suggestion)=>suggestion.resourceStatus === 'DRAFT');
        return filteredSuggestions;
    }, [
        resourceSuggestions
    ]);
    const shownSuggestions = (0, $eJOHy.useMemo)(()=>{
        const filteredSuggestions = resourceSuggestions?.filter((suggestion)=>suggestion.resourceStatus === 'DRAFT' || suggestion.resourceStatus === 'SELECTED');
        return filteredSuggestions;
    }, [
        resourceSuggestions
    ]);
    const selectedSuggestions = (0, $eJOHy.useMemo)(()=>{
        const filteredSuggestions = resourceSuggestions?.filter((suggestion)=>suggestion.resourceStatus === 'SELECTED');
        return filteredSuggestions;
    }, [
        resourceSuggestions
    ]);
    const getAttributes = (0, $eJOHy.useCallback)(()=>({
            ...$29e5856fe7bbc6dc$var$getAiEventAttributes(invokedFrom),
            singleInstrumentationId: singleInstrumentationId.current
        }), [
        invokedFrom
    ]);
    const { acceptAllSuggestions: acceptAllSuggestions, acceptSelectedSuggestions: acceptSelectedSuggestions } = (0, $4R60r.useRelatedIssuesActions)();
    const attributes = getAttributes();
    // Analytics callbacks
    const onAiInteractionInitiatedEvent = (0, $eJOHy.useCallback)(()=>{
        (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'aiInteraction initiated', {
            invokedFrom: invokedFrom,
            existingItemsCount: existingIssues.length,
            ...attributes
        });
    }, [
        createAnalyticsEvent,
        invokedFrom,
        existingIssues.length,
        attributes
    ]);
    // Base function for aiResult viewed events
    const onAiResultViewedEvent = (0, $eJOHy.useCallback)((doesNotMeetMAUCriteria, suggestionsExpanded, currentData)=>{
        if (!currentData) return;
        if (invokedFrom === 'globalIssueCreate' && aiResultViewedSummaryLengthAnalyticsRef && aiResultViewedSummaryLengthAnalyticsRef.current && (0, $epTsa.expVal)('proactive_similar_work_items_in_gic_experiment', 'isEnabled', false)) (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'aiResult viewed', {
            doesNotMeetMAUCriteria: doesNotMeetMAUCriteria,
            summaryLength: aiResultViewedSummaryLengthAnalyticsRef?.current?.length,
            invokedFrom: invokedFrom,
            aiSuggestedCount: currentData.length,
            suggestionsExpanded: suggestionsExpanded,
            ...attributes
        });
        else (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'aiResult viewed', {
            doesNotMeetMAUCriteria: doesNotMeetMAUCriteria,
            aiSuggestedCount: currentData.length,
            suggestionsExpanded: suggestionsExpanded,
            ...attributes
        });
    }, [
        createAnalyticsEvent,
        attributes,
        invokedFrom
    ]);
    const dataRef = (0, $eJOHy.useRef)(data);
    (0, $eJOHy.useEffect)(()=>{
        dataRef.current = data;
    }, [
        data
    ]);
    const onAiResultViewedEventWhenCollapsed = (0, $eJOHy.useCallback)(()=>{
        onAiResultViewedEvent(true, false, (0, $7jTnu.fg)('ai-related-issue-analytics-bug-fix') ? data : dataRef.current);
    }, [
        onAiResultViewedEvent,
        data
    ]);
    const onAiResultViewedEventWhenExpanded = (0, $eJOHy.useCallback)(()=>{
        onAiResultViewedEvent(false, true, (0, $7jTnu.fg)('ai-related-issue-analytics-bug-fix') ? data : dataRef.current);
        if ((0, $epTsa.UNSAFE_noExposureExp)('jira-ai-similar-issues-selectable-draft-list')[0].get('isEnabled', false)) (0, $d2AGn.getUpdateAnalyticsFlowHelper)().fireAnalyticsStart((0, $3bSs8.ENTITY_FIELD_KEYS).ISSUE_LINKS, {
            analytics: createAnalyticsEvent({}),
            attributes: {
                fieldType: (0, $3bSs8.ENTITY_FIELD_KEYS).ISSUE_LINKS
            }
        });
    }, [
        onAiResultViewedEvent,
        data,
        createAnalyticsEvent
    ]);
    const onAiResultActionedEvent = (0, $eJOHy.useCallback)(()=>{
        (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'aiResult actioned', 'aiRelatedIssuesSuggestionResultBox', {
            aiResultAction: 'suggestionsHidden',
            aiItemsCount: data?.length,
            ...attributes
        });
    }, [
        createAnalyticsEvent,
        data?.length,
        attributes
    ]);
    const onAiResultErrorEvent = (0, $eJOHy.useCallback)((errorReceived)=>{
        (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'aiResult error', 'aiRelatedIssuesSuggestionResultBox', {
            aiErrorCode: errorReceived instanceof (0, $1uIew.default) ? errorReceived.statusCode : $29e5856fe7bbc6dc$var$UNCATEGORISED_ERROR,
            ...(0, $7jTnu.fg)('ai-error-message-similar-issues') ? {
                aiErrorMessage: errorReceived instanceof (0, $1uIew.default) ? errorReceived.message : JSON.stringify(errorReceived)
            } : {},
            ...attributes
        });
    }, [
        createAnalyticsEvent,
        attributes
    ]);
    const onAiFeedbackSubmittedEvent = (0, $eJOHy.useCallback)((aiFeedbackResult)=>{
        (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'aiFeedback submitted', 'aiRelatedIssuesSuggestionResultBox', {
            aiFeedbackResult: aiFeedbackResult
        });
    }, [
        createAnalyticsEvent
    ]);
    const onDisplaySuggestions = (0, $eJOHy.useCallback)(()=>{
        setRelatedIssuesDisplayStep();
    }, [
        setRelatedIssuesDisplayStep
    ]);
    /**
   * Refactor to use local state instead of sweet state in GRAVITYAI-2715 by passing back the data from ProactiveContainer
   * and using that to set local state in the parent container here
   */ const onLoadedSuggestions = (0, $eJOHy.useCallback)(()=>{
        setRelatedIssuesLoadedStep();
    }, [
        setRelatedIssuesLoadedStep
    ]);
    const onFetchSuggestion = (0, $eJOHy.useCallback)((customRelatedIssueSearchPayload)=>{
        fetchSuggestion(customRelatedIssueSearchPayload);
        setRelatedIssuesFetchStep();
        if ((0, $epTsa.expVal)('proactive_similar_work_items_in_gic_experiment', 'isEnabled', false)) aiResultViewedSummaryLengthAnalyticsRef.current = customRelatedIssueSearchPayload?.issue_summary;
    }, [
        fetchSuggestion,
        setRelatedIssuesFetchStep
    ]);
    const [shouldReinitiate, setShouldReinitiate] = (0, $eJOHy.useState)(0);
    const setTriggerReinitiate = (0, $eJOHy.useCallback)(()=>{
        setShouldReinitiate(shouldReinitiate + 1);
    }, [
        shouldReinitiate
    ]);
    const onAcceptAllSuggestions = (0, $eJOHy.useCallback)(()=>{
        if (!draftSuggestions) return;
        for (const suggestion of draftSuggestions){
            const optimisticId = `OPTIMISTIC_LINKED_ISSUE_${Date.now()}_${suggestion.resource.id}`;
            onIssueLinkSave(optimisticId, suggestion.resource, relatesToIssueLinkType, createAnalyticsEvent({}));
        }
        acceptAllSuggestions();
        (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'aiResult actioned', 'aiRelatedIssuesSuggestionResultBox', {
            aiResultAction: 'bulkIssuesAccepted',
            aiItemsCount: draftSuggestions.length
        });
    }, [
        acceptAllSuggestions,
        createAnalyticsEvent,
        draftSuggestions,
        onIssueLinkSave,
        relatesToIssueLinkType
    ]);
    const onAcceptSelectedSuggestions = (0, $eJOHy.useCallback)((issueLinkType)=>{
        if (!selectedSuggestions) return;
        // Cycle through selected suggestions instead of draft suggestions
        for (const suggestion of selectedSuggestions){
            const optimisticId = `OPTIMISTIC_LINKED_ISSUE_${Date.now()}_${suggestion.resource.id}`;
            onIssueLinkSave(optimisticId, suggestion.resource, issueLinkType, createAnalyticsEvent({}));
            (0, $d2AGn.getUpdateAnalyticsFlowHelper)().fireAnalyticsEnd((0, $3bSs8.ENTITY_FIELD_KEYS).ISSUE_LINKS, {
                analytics: createAnalyticsEvent({}),
                attributes: {
                    fieldType: (0, $3bSs8.ENTITY_FIELD_KEYS).ISSUE_LINKS,
                    actionTaken: 'add'
                }
            });
        }
        acceptSelectedSuggestions();
        (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'aiResult actioned', 'aiRelatedIssuesSuggestionResultBox', {
            aiResultAction: 'bulkIssuesAccepted',
            aiItemsCount: selectedSuggestions.length,
            isRelatedToIssueLinkType: issueLinkType.id === relatesToIssueLinkType?.id
        });
    }, [
        selectedSuggestions,
        acceptSelectedSuggestions,
        createAnalyticsEvent,
        relatesToIssueLinkType?.id,
        onIssueLinkSave
    ]);
    const footerActionNode = (0, $eJOHy.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dxIkO.Footer), {
            // fg this (add draftSuggestions as default)
            suggestions: (0, $epTsa.UNSAFE_noExposureExp)('jira-ai-similar-issues-selectable-draft-list')[0].get('isEnabled', false) ? shownSuggestions : draftSuggestions,
            hasSelectedSuggestions: Boolean(selectedSuggestions && selectedSuggestions?.length > 0),
            onAcceptAllSuggestions: onAcceptAllSuggestions,
            onAcceptSelectedSuggestions: onAcceptSelectedSuggestions,
            invokedFrom: invokedFrom,
            relatesToIssueLinkType: relatesToIssueLinkType,
            issueLinkTypes: issueLinkTypes
        }), [
        shownSuggestions,
        draftSuggestions,
        selectedSuggestions,
        onAcceptAllSuggestions,
        onAcceptSelectedSuggestions,
        invokedFrom,
        relatesToIssueLinkType,
        issueLinkTypes
    ]);
    const isBeta = (0, $eJOHy.useMemo)(()=>{
        if (invokedFrom === 'globalIssueCreate') return true;
        /**
     * The draft list experiment determines whether we show the beta lozenge signalling GA (specificially for issue view)
     */ return !(0, $epTsa.UNSAFE_noExposureExp)('jira-ai-similar-issues-selectable-draft-list')[0].get('isEnabled', false);
    }, [
        invokedFrom
    ]);
    /**
   * We need a valid invokedFrom to show the feature, otherwise return null
   */ if (!invokedFrom && (0, $7jTnu.fg)('jira-ai-moving-similar-issues-up')) return null;
    // TODO: On cleanup of `platformisation-of-proactive-collapsible-container`, check if we can remove the
    // `./ui/proactive-collapsible-parent` folder as it will no longer be used.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        attributes: attributes
    }, (0, $7jTnu.fg)('platformisation-of-proactive-collapsible-container') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dOShM.ProactiveContainer), {
        initialStep: "FETCHING",
        data: (0, $epTsa.UNSAFE_noExposureExp)('jira-ai-similar-issues-selectable-draft-list')[0].get('isEnabled', false) ? shownSuggestions : draftSuggestions,
        error: error,
        loading: (0, $7jTnu.fg)('ai-related-issue-analytics-bug-fix') ? currentStep === 'FETCHING' : loading,
        onFetchSuggestions: onFetchSuggestion,
        resultNumber: draftSuggestions?.length,
        onDismissSuggestions: discardAllSuggestions,
        onDisplaySuggestions: onDisplaySuggestions,
        onLoadedSuggestions: onLoadedSuggestions,
        invokedFrom: invokedFrom,
        onAiInteractionInitiatedEvent: onAiInteractionInitiatedEvent,
        onAiResultErrorEvent: onAiResultErrorEvent,
        onAiResultViewedEventWhenCollapsed: onAiResultViewedEventWhenCollapsed,
        onAiResultViewedEventWhenExpanded: onAiResultViewedEventWhenExpanded,
        onAiResultActionedEvent: onAiResultActionedEvent,
        onAiFeedbackSubmittedEvent: onAiFeedbackSubmittedEvent,
        messages: {
            headerTitle: headerTitle,
            errorMessage: (0, $j4Juo.default).similarIssuesCouldNotBeGeneratedIssueTermRefresh,
            noItemsMessage: (0, $j4Juo.default).searchAgain,
            viewItemsMessage: (0, $j4Juo.default).showNumResults,
            findingResultsMessage: (0, $j4Juo.default).searchingForSimilarWorkItems
        },
        customRelatedIssueSearchPayload: props.customRelatedIssueSearchPayload,
        // Only show beta lozenge for GIC
        isBeta: isBeta,
        shouldReinitiate: shouldReinitiate,
        setTriggerReinitiate: setTriggerReinitiate,
        feedbackCollectorId: $29e5856fe7bbc6dc$var$FEEDBACK_COLLECTOR_ID,
        feedbackFormEntrypointId: $29e5856fe7bbc6dc$var$FEEDBACK_ENTRYPOINT_ID,
        aiExperience: (0, $8v03d.RELATED_ISSUES_AI_EXPERIENCE),
        footerActionNode: footerActionNode
    }, invokedFrom !== 'globalIssueCreate' && (0, $epTsa.expVal)('jira-ai-similar-issues-selectable-draft-list', 'isEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7tFKB.RelatedIssuesDraftListIssueView), {
        onIssueLinkSave: onIssueLinkSave,
        invokedFrom: invokedFrom,
        onCopyButtonClick: onCopyButtonClick,
        onSimilarIssueLinkGICButtonClick: onSimilarIssueLinkGICButtonClick
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gPgMe.RelatedIssuesDraftList), {
        onCopyButtonClick: onCopyButtonClick,
        invokedFrom: invokedFrom,
        onIssueLinkSave: onIssueLinkSave,
        onSimilarIssueLinkGICButtonClick: onSimilarIssueLinkGICButtonClick
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9tyru.ProactiveSimilarIssuesCollapsible), {
        existingIssues: existingIssues,
        customRelatedIssueSearchPayload: props.customRelatedIssueSearchPayload
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gPgMe.RelatedIssuesDraftList), {
        onCopyButtonClick: onCopyButtonClick,
        invokedFrom: invokedFrom,
        onIssueLinkSave: onIssueLinkSave,
        onSimilarIssueLinkGICButtonClick: onSimilarIssueLinkGICButtonClick
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2Sr3y.AiFooter), {
        isBeta: false
    })));
};
const $29e5856fe7bbc6dc$var$AiRelatedIssuesResourcesEntrypoint = ({ props: props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4R60r.JiraIssueRelatedIssuesContainer), {
        scope: `related-issues-${props.issueKey}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($29e5856fe7bbc6dc$export$eb52075d944dbdfb, props));
};
var $29e5856fe7bbc6dc$export$2e2bcd8739ae039 = $29e5856fe7bbc6dc$var$AiRelatedIssuesResourcesEntrypoint;

});
parcelRegister("2Sr3y", function(module, exports) {

$parcel$export(module.exports, "AiFooter", () => $dd28b5db7f51b928$export$915814a2dcce5cf0);

var $eJOHy = parcelRequire("eJOHy");

var $fOqNz = parcelRequire("fOqNz");

var $7kJQm = parcelRequire("7kJQm");

var $jdqdp = parcelRequire("jdqdp");

var $lmgo6 = parcelRequire("lmgo6");
var $3Wh6p = parcelRequire("3Wh6p");
var $1DXK0 = parcelRequire("1DXK0");

var $lL4G9 = parcelRequire("lL4G9");

var $6fs4r = parcelRequire("6fs4r");

var $lRq8t = parcelRequire("lRq8t");

var $1OHZM = parcelRequire("1OHZM");

var $lGixz = parcelRequire("lGixz");
const $dd28b5db7f51b928$var$ATLASSIAN_INTELLIGENCE_LINK = 'https://support.atlassian.com/organization-administration/docs/understand-atlassian-intelligence-features-in-products/';
const $dd28b5db7f51b928$var$AIFooterThreshold = {
    SMALL: 280,
    MEDIUM: 328,
    LARGE: 624
};
const $dd28b5db7f51b928$export$915814a2dcce5cf0 = ({ testId: testId, isBeta: isBeta = true, showDisclaimer: showDisclaimer = true })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const footerContainer = (0, $eJOHy.useRef)(null);
    const onResize = (0, $eJOHy.useCallback)(()=>{
        if (footerContainer.current) {
            const { offsetWidth: offsetWidth } = footerContainer.current;
            if (showDisclaimer) {
                if (offsetWidth > $dd28b5db7f51b928$var$AIFooterThreshold.LARGE) {
                    setDisplayedAttribution((0, $lGixz.default).longAttributionText);
                    setDisplayedDisclaimer((0, $lGixz.default).longDisclaimerText);
                } else if (offsetWidth > $dd28b5db7f51b928$var$AIFooterThreshold.MEDIUM) {
                    setDisplayedAttribution((0, $lGixz.default).shortAttributionText);
                    setDisplayedDisclaimer((0, $lGixz.default).disclaimerText);
                } else {
                    setDisplayedAttribution(null);
                    setDisplayedDisclaimer((0, $lGixz.default).disclaimerText);
                }
            } else if (offsetWidth > $dd28b5db7f51b928$var$AIFooterThreshold.SMALL) setDisplayedAttribution((0, $lGixz.default).longAttributionText);
            else setDisplayedAttribution((0, $lGixz.default).shortAttributionText);
        }
    }, [
        showDisclaimer
    ]);
    const [displayedAttribution, setDisplayedAttribution] = (0, $eJOHy.useState)(null);
    const [displayedDisclaimer, setDisplayedDisclaimer] = (0, $eJOHy.useState)(null);
    (0, $eJOHy.useEffect)(()=>{
        onResize();
    }, [
        onResize
    ]);
    (0, $1OHZM.useResizeObserver)({
        ref: footerContainer,
        onResize: onResize
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        testId: testId,
        xcss: $dd28b5db7f51b928$var$footerStyle,
        spread: "space-between",
        alignBlock: "center",
        ref: footerContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        alignItems: "center",
        gap: "space.050"
    }, isBeta && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
        testId: "atlassian-intelligence.common.ui.ai-footer.beta-lozenge",
        appearance: "default"
    }, formatMessage((0, $lGixz.default).betaLozenge)), displayedDisclaimer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7kJQm))), {
        label: formatMessage((0, $lGixz.default).infoIconLabel),
        LEGACY_size: "small",
        color: "var(--ds-icon-subtle, #626F86)",
        testId: "atlassian-intelligence.common.ui.ai-footer.info-icon"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lL4G9.default), {
        xcss: $dd28b5db7f51b928$var$linkStyle,
        href: "https://www.atlassian.com/trust/atlassian-intelligence",
        rel: "noopener",
        target: "_blank",
        testId: "atlassian-intelligence.common.ui.ai-footer.disclaimer-text"
    }, formatMessage(displayedDisclaimer)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        alignItems: "center",
        gap: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lL4G9.default), {
        xcss: $dd28b5db7f51b928$var$linkStyle,
        href: $dd28b5db7f51b928$var$ATLASSIAN_INTELLIGENCE_LINK,
        rel: "noopener",
        target: "_blank",
        testId: "atlassian-intelligence.common.ui.ai-footer.attribution-link"
    }, displayedAttribution ? formatMessage(displayedAttribution) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6fs4r.default), null, formatMessage((0, $lGixz.default).longAttributionText))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fOqNz))), {
        label: formatMessage((0, $lGixz.default).aiIconLabel),
        spacing: "spacious"
    })));
};
const $dd28b5db7f51b928$var$footerStyle = (0, $1DXK0.xcss)({
    borderTop: `1px solid ${"var(--ds-border, #091E4224)"}`,
    paddingInline: 'space.150',
    paddingBlock: 'space.050'
});
const $dd28b5db7f51b928$var$linkStyle = (0, $1DXK0.xcss)({
    textDecoration: 'none',
    color: 'color.text.subtlest',
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});

});
parcelRegister("1OHZM", function(module, exports) {

$parcel$export(module.exports, "createResizeObserverHook", () => $7c1c433db2df08f5$export$87a9d3e287304ae4);
$parcel$export(module.exports, "useResizeObserver", () => $7c1c433db2df08f5$export$683480f191c0e3ea);
$parcel$export(module.exports, "flushResizeObservers", () => $7c1c433db2df08f5$export$a181ef2a6d0a1bb6);
$parcel$export(module.exports, "useRectObserver", () => $7c1c433db2df08f5$export$e58143dc89297272);

var $eJOHy = parcelRequire("eJOHy");

var $cOhmL = parcelRequire("cOhmL");
function $7c1c433db2df08f5$export$87a9d3e287304ae4(params) {
    const group = new (0, $cOhmL.ResizeObserverGroup)(params?.debouncePeriod);
    /**
	 * This hook uses a shared ResizeObserver instance.
	 *
	 * When a resize notification comes in, a single batched React update will be
	 * dispatched after a debounce period only for the elements that have been
	 * resized.
	 *
	 * This does NOT react to updates to REF
	 */ function useResizeObserver({ ref: ref, onResize: onResize }) {
        const onResizeRef = (0, $eJOHy.useRef)(onResize);
        (0, $eJOHy.useEffect)(()=>{
            onResizeRef.current = onResize;
        });
        const stableOnResize = (0, $eJOHy.useCallback)(()=>onResizeRef.current(), []);
        (0, $eJOHy.useLayoutEffect)(()=>group.observe(ref, stableOnResize), [
            ref,
            stableOnResize
        ]);
    }
    return {
        useResizeObserver: useResizeObserver,
        flushResizeObservers: ()=>group.flush()
    };
}
const { useResizeObserver: $7c1c433db2df08f5$export$683480f191c0e3ea, flushResizeObservers: $7c1c433db2df08f5$export$a181ef2a6d0a1bb6 } = $7c1c433db2df08f5$export$87a9d3e287304ae4();
function $7c1c433db2df08f5$export$e58143dc89297272({ ref: ref, useResizeObserverDI: // eslint-disable-next-line react-hooks/react-compiler
useResizeObserverDI = $7c1c433db2df08f5$export$683480f191c0e3ea }) {
    const [rect, setRect] = (0, $eJOHy.useState)(null);
    const onResize = ()=>{
        if (ref.current) setRect(ref.current.getBoundingClientRect());
    };
    (0, $eJOHy.useLayoutEffect)(()=>{
        if (!ref.current) throw new Error([
            'useRectObserver: ref is not available on mount.',
            'This means you are attaching refs conditionally onto your elements, for example in with an early return.',
            'This will not work properly. Please update your code so that refs are always attached to components on mount.'
        ].join('\n'));
        setRect(ref.current.getBoundingClientRect());
    }, [
        ref
    ]);
    // eslint-disable-next-line react-hooks/react-compiler
    useResizeObserverDI({
        ref: ref,
        onResize: onResize
    });
    return rect;
}

});
parcelRegister("cOhmL", function(module, exports) {

$parcel$export(module.exports, "ResizeObserverGroup", () => $4b26b203cb8a861d$export$607798bbe2869c0);

var $aQK2r = parcelRequire("aQK2r");

var $3s8bj = parcelRequire("3s8bj");
class $4b26b203cb8a861d$export$607798bbe2869c0 {
    constructor(debouncePeriod = 16){
        this.subscribers = new Map();
        this.pendingUpdates = new Map();
        this.onResize = (entries)=>{
            entries.forEach((entry)=>{
                const subscriber = this.subscribers.get(entry.target);
                if (subscriber) this.pendingUpdates.set(subscriber.element, subscriber);
            });
            this.scheduleFlush();
        };
        this.observer = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(this.onResize) : null;
        this.scheduleFlush = debouncePeriod > 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(()=>{
            this.flush();
        }, debouncePeriod, {
            trailing: true,
            maxWait: 32
        }) : ()=>{
            this.flush();
        };
    }
    observe(ref, callback) {
        if (!ref.current) // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
        this.subscribers.set(ref.current, {
            element: ref.current,
            callback: callback
        });
        this.observer?.observe(ref.current);
        return ()=>{
            if (!ref.current) return;
            this.subscribers.delete(ref.current);
            this.pendingUpdates.delete(ref.current);
            this.observer?.unobserve(ref.current);
        };
    }
    flush() {
        const entries = Array.from(this.pendingUpdates.values()).filter((entry)=>this.subscribers.has(entry.element));
        this.pendingUpdates.clear();
        (0, $aQK2r.unstable_batchedUpdates)(()=>{
            entries.forEach(({ callback: callback })=>{
                callback();
            });
        });
    }
}

});


parcelRegister("lGixz", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbd7de84d815d9e9$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $fbd7de84d815d9e9$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    betaLozenge: {
        "id": "atlassian-intelligence.common.ai-footer.beta-lozenge",
        "defaultMessage": "Beta"
    },
    disclaimerText: {
        "id": "atlassian-intelligence.common.ai-footer.disclaimer-text",
        "defaultMessage": "Content quality may vary"
    },
    longDisclaimerText: {
        "id": "atlassian-intelligence.common.ai-footer.long-disclaimer-text",
        "defaultMessage": "Content is based on your permissions, and its quality may vary"
    },
    shortAttributionText: {
        "id": "atlassian-intelligence.common.ai-footer.short-attribution-text",
        "defaultMessage": "Powered by AI"
    },
    longAttributionText: {
        "id": "atlassian-intelligence.common.ai-footer.long-attribution-text",
        "defaultMessage": "Powered by Atlassian Intelligence"
    },
    infoIconLabel: {
        "id": "atlassian-intelligence.common.ai-footer.info-icon-label",
        "defaultMessage": "Info"
    },
    aiIconLabel: {
        "id": "atlassian-intelligence.common.ai-footer.ai-icon-label",
        "defaultMessage": "Atlassian Intelligence"
    }
});

});


parcelRegister("dOShM", function(module, exports) {

$parcel$export(module.exports, "ProactiveContainer", () => $00b99825f3014b1e$export$f32f66a79518bb28);

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");

var $1OQKp = parcelRequire("1OQKp");

var $8nu6j = parcelRequire("8nu6j");
var $3Wh6p = parcelRequire("3Wh6p");
var $dW738 = parcelRequire("dW738");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $5CSKW = parcelRequire("5CSKW");
var $Ay1uj = parcelRequire("Ay1uj");

var $jdqdp = parcelRequire("jdqdp");

var $gn1zL = parcelRequire("gn1zL");

var $iHPvF = parcelRequire("iHPvF");

var $9skjA = parcelRequire("9skjA");

var $lRq8t = parcelRequire("lRq8t");

var $epTsa = parcelRequire("epTsa");

var $1OHZM = parcelRequire("1OHZM");

var $7jTnu = parcelRequire("7jTnu");

var $YuSda = parcelRequire("YuSda");

var $htSaL = parcelRequire("htSaL");

var $204HS = parcelRequire("204HS");

var $9SUlM = parcelRequire("9SUlM");
const $00b99825f3014b1e$var$PROACTIVE_CONTAINER_MINIMUM_WIDTH = 650;
const $00b99825f3014b1e$var$isSimilarWorkItemsUIFixesEnabled = (invokedFrom)=>{
    return invokedFrom === 'globalIssueCreate' && (0, $7jTnu.fg)('similar_items_in_gic_ui_fixes');
};
const $00b99825f3014b1e$export$f32f66a79518bb28 = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { data: data, loading: loading, error: error, feedbackCollectorId: feedbackCollectorId, feedbackFormEntrypointId: feedbackFormEntrypointId, invokedFrom: invokedFrom, initialStep: initialStep, aiExperience: aiExperience, onFetchSuggestions: onFetchSuggestions, onDisplaySuggestions: onDisplaySuggestions, onLoadedSuggestions: onLoadedSuggestions, onDismissSuggestions: onDismissSuggestions, children: children, isBeta: isBeta, resultNumber: resultNumber, messages: customMessages, onAiInteractionInitiatedEvent: onAiInteractionInitiatedEvent, onAiResultErrorEvent: onAiResultErrorEvent, onAiResultViewedEventWhenCollapsed: onAiResultViewedEventWhenCollapsed, onAiResultViewedEventWhenExpanded: onAiResultViewedEventWhenExpanded, onAiResultActionedEvent: onAiResultActionedEvent, onAiFeedbackSubmittedEvent: onAiFeedbackSubmittedEvent, customRelatedIssueSearchPayload: customRelatedIssueSearchPayload, headerNode: headerNode, shouldReinitiate: shouldReinitiate, setTriggerReinitiate: setTriggerReinitiate, footerActionNode: footerActionNode, footerContainerStyles: footerContainerStyles } = props;
    const [currentStep, setCurrentStep] = (0, $eJOHy.useState)(initialStep);
    // Add refs to track previous states
    const prevDataRef = (0, $eJOHy.useRef)();
    const prevLoadingRef = (0, $eJOHy.useRef)(loading);
    const prevPayloadRef = (0, $eJOHy.useRef)();
    const prevShouldReinitiateRef = (0, $eJOHy.useRef)(shouldReinitiate);
    const isFetching = currentStep === 'FETCHING' || loading;
    const shouldDisplay = currentStep === 'DISPLAY';
    const prevErrorRef = (0, $eJOHy.useRef)(error);
    const prevIsDisabled = currentStep === 'INACTIVE' ? false : isFetching || !data?.length || error !== undefined && error !== null;
    // With the proactive container top nav refresh, we want to allow users to search again when there are no results or an error, and have
    // an additional button to view the error as well.
    const isError = error !== undefined && error !== null;
    const hasNoResults = (0, $7jTnu.fg)('proactive_aiwb_2_ga_targeting_gate') ? data && data.length === 0 : !data?.length;
    const isErrorOrNoResults = !isFetching && (hasNoResults || isError);
    const isNotAbortError = isError && typeof error === 'object' && 'name' in error && error.name !== 'AbortError';
    // A rectObserver is used to track whether the proactive container is below a certain width - this allows us to render the subtext and buttons on a second row
    // to avoid crowding the UI and any text overflow.
    const containerRef = (0, $eJOHy.useRef)(null);
    const containerRect = (0, $1OHZM.useRectObserver)({
        ref: containerRef
    });
    const isSmallWidth = containerRect?.width !== undefined && containerRect?.width < $00b99825f3014b1e$var$PROACTIVE_CONTAINER_MINIMUM_WIDTH;
    const isDisabled = prevIsDisabled && !isErrorOrNoResults;
    const componentState = (0, $eJOHy.useRef)({
        isInitialized: false,
        lastInvokedFrom: invokedFrom,
        // Store dismissCallback in a ref, so it can be used in the cleanup effect on unmount only
        dismissCallback: onDismissSuggestions
    });
    // Cleanup effect
    (0, $eJOHy.useEffect)(()=>{
        // Capture the current value of dismissCallback
        const currentDismissCallback = componentState.current.dismissCallback;
        return ()=>{
            currentDismissCallback?.();
        };
    }, []);
    // Component initialization effect - if inactive, don't fetch, otherwise fetch data and set current step to fetching
    (0, $eJOHy.useEffect)(()=>{
        if (shouldReinitiate !== prevShouldReinitiateRef.current) {
            componentState.current.isInitialized = false;
            prevShouldReinitiateRef.current = shouldReinitiate;
        }
        if (currentStep === 'INACTIVE') return;
        if (!componentState.current.isInitialized && invokedFrom || componentState.current.lastInvokedFrom !== invokedFrom || !(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(prevPayloadRef.current, customRelatedIssueSearchPayload) && (0, $epTsa.expVal)('proactive_similar_work_items_in_gic_experiment', 'isEnabled', false)) {
            componentState.current.isInitialized = true;
            componentState.current.lastInvokedFrom = invokedFrom;
            onFetchSuggestions(customRelatedIssueSearchPayload);
            setCurrentStep('FETCHING');
            onAiInteractionInitiatedEvent();
            if ((0, $epTsa.expVal)('proactive_similar_work_items_in_gic_experiment', 'isEnabled', false)) prevPayloadRef.current = customRelatedIssueSearchPayload;
        }
    }, [
        onFetchSuggestions,
        onAiInteractionInitiatedEvent,
        invokedFrom,
        customRelatedIssueSearchPayload,
        currentStep,
        shouldReinitiate
    ]);
    // Update the data effect to check for actual data changes and loading state changes
    (0, $eJOHy.useEffect)(()=>{
        if (error && error !== prevErrorRef.current) {
            prevErrorRef.current = error;
            onAiResultErrorEvent(error);
            // We should always fire an error event, but should allow users to enter the 'DISPLAY' step if they want to view the error section message
            // If a user receives an error while fetching, set it to the loading state. This must be conditional as we don't want the users to not be able to enter
            // the 'DISPLAY' state.
            if (isFetching) {
                setCurrentStep('LOADED');
                onLoadedSuggestions?.();
            }
            return;
        }
        /**
     * State handling for fetching to ensure we use the loading state to determine whether to show the loading state
     */ const loadingChangedToFalse = prevLoadingRef.current === true && loading === false;
        prevLoadingRef.current = loading;
        /**
     * If data has changed from before, or if loading has changed from true to false (meaning a fetch was initiated, and loading has completed)
     * this handles the case where results show with an empty [] but has been fetched again (e.g. GIC)
     */ if (data && !(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(prevDataRef.current, data) || loadingChangedToFalse) {
            if (isFetching) {
                onLoadedSuggestions?.();
                if ((0, $7jTnu.fg)('aix-1578-expand-proactive-on-improve-issue')) {
                    // If the proactive container is invoked from the improve issue dropdown, we want to show the results in the expanded state
                    // as the user is likely to want to view the results immediately.
                    if (invokedFrom === 'improveIssueDropdown' && data && data.length > 0) {
                        setCurrentStep('DISPLAY');
                        onAiResultViewedEventWhenExpanded();
                    } else {
                        setCurrentStep('LOADED');
                        onAiResultViewedEventWhenCollapsed();
                    }
                } else {
                    setCurrentStep('LOADED');
                    onAiResultViewedEventWhenCollapsed();
                }
            }
            prevDataRef.current = data;
        }
        // If current step is DISPLAY and there are now no results, set the current step to LOADED
        if (currentStep === 'DISPLAY' && !data?.length) // If there is an error (which also means there are no results), we still want users to be able to enter the 'DISPLAY' step
        // to view the error section message.
        {
            if (!isError) setCurrentStep('LOADED');
        }
    }, [
        error,
        isError,
        data,
        loading,
        currentStep,
        onLoadedSuggestions,
        onAiResultViewedEventWhenCollapsed,
        onAiResultErrorEvent,
        isFetching,
        invokedFrom,
        onAiResultViewedEventWhenExpanded
    ]);
    /**
   * Event handler for the toggle button click
   * Since we use the same button for both the Pressable and the Button click, we need to stop the event propagation to not fire the event twice
   */ const onToggleClick = (0, $eJOHy.useCallback)((e)=>{
        if (isDisabled) return;
        if (currentStep === 'LOADED') {
            onDisplaySuggestions?.();
            setCurrentStep('DISPLAY');
            if (!isError) onAiResultViewedEventWhenExpanded();
        } else if (currentStep === 'DISPLAY') {
            onLoadedSuggestions?.();
            setCurrentStep('LOADED');
            onAiResultActionedEvent();
        } else if (currentStep === 'INACTIVE') setCurrentStep('FETCHING');
        e.stopPropagation();
    }, [
        isDisabled,
        currentStep,
        onDisplaySuggestions,
        onAiResultViewedEventWhenExpanded,
        onLoadedSuggestions,
        onAiResultActionedEvent,
        isError
    ]);
    const renderActionButtons = ()=>{
        if (shouldDisplay) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
            appearance: "subtle",
            icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1OQKp))), {
                    ...iconProps,
                    size: "small"
                }),
            label: formatMessage((0, $9SUlM.default).hideSuggestions),
            isDisabled: isDisabled,
            testId: "ai-proactive-container.toggle-button-collapse",
            onClick: onToggleClick,
            isTooltipDisabled: false,
            spacing: isSmallWidth && isErrorOrNoResults ? 'compact' : 'default',
            tooltip: {
                position: 'top'
            }
        });
        if (!isFetching) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
            space: "space.050"
        }, isError && isNotAbortError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
            spacing: "compact",
            onClick: onToggleClick,
            isDisabled: isDisabled,
            appearance: "default",
            testId: "ai-proactive-container.view-error-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
            weight: "medium",
            color: "color.text"
        }, formatMessage((0, $9SUlM.default).viewError))), invokedFrom === 'globalIssueCreate' && hasNoResults && !isError && !isNotAbortError && (0, $7jTnu.fg)('similar_items_in_gic_ui_fixes') ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
            spacing: "compact",
            onClick: hasNoResults ? onReinitiateSearch : onToggleClick,
            isDisabled: isDisabled,
            appearance: "default",
            testId: "ai-proactive-container.toggle-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $204HS.ToggleButtonContent), {
            currentStep: currentStep,
            shouldDisplay: shouldDisplay,
            resultNumber: (0, $epTsa.UNSAFE_noExposureExp)('jira-ai-similar-issues-selectable-draft-list')[0].get('isEnabled', false) ? data?.length : resultNumber,
            error: error,
            formatMessage: formatMessage,
            messages: customMessages,
            invokedFrom: invokedFrom
        })));
    };
    const onReinitiateSearch = (e)=>{
        if (setTriggerReinitiate) setTriggerReinitiate();
        e.stopPropagation();
    };
    const renderHeaderSubtext = ()=>{
        if (error) return formatMessage((0, $9SUlM.default).anErrorOccurred);
        if ((0, $7jTnu.fg)('proactive_aiwb_2_ga_targeting_gate') ? data && data.length === 0 : !data?.length) return formatMessage((0, $9SUlM.default).noResultsFound);
    };
    const renderChildren = ()=>{
        if (isError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iHPvF.default), {
            appearance: "warning",
            title: customMessages.errorHeaderMessage ? formatMessage(customMessages.errorHeaderMessage) : undefined
        }, formatMessage(customMessages.errorMessage));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $YuSda.AiFooter), {
            feedbackCollectorId: feedbackCollectorId,
            feedbackFormEntrypointId: feedbackFormEntrypointId,
            onAiFeedbackSubmittedEvent: onAiFeedbackSubmittedEvent,
            aiExperience: aiExperience,
            footerActionNode: footerActionNode,
            footerContainerStyles: footerContainerStyles
        }));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9skjA.default), {
        ...$00b99825f3014b1e$var$isSimilarWorkItemsUIFixesEnabled(invokedFrom) ? {
            isBorderGrey: true
        } : undefined,
        hasNewBorderExperience: !$00b99825f3014b1e$var$isSimilarWorkItemsUIFixesEnabled(invokedFrom),
        shouldFitContainer: true,
        ...$00b99825f3014b1e$var$isSimilarWorkItemsUIFixesEnabled(invokedFrom) ? undefined : {
            isShadow: false
        },
        isLoading: $00b99825f3014b1e$var$isSimilarWorkItemsUIFixesEnabled(invokedFrom) ? false : isFetching,
        spacing: "none",
        testId: "ai-proactive-container.ai-container",
        ref: containerRef,
        zIndex: (0, $7jTnu.fg)('jira-ai-moving-similar-issues-up') ? 96 : undefined,
        ...$00b99825f3014b1e$var$isSimilarWorkItemsUIFixesEnabled(invokedFrom) ? {
            borderless: true
        } : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $00b99825f3014b1e$var$proactiveTopBarContainerStyles,
            // If we are rendering the smaller width, increase the height of the container to fit the two rows
            isSmallWidth && isErrorOrNoResults && $00b99825f3014b1e$var$proactiveTopBarContainerSmallWidthStyles
        ]
    }, isSmallWidth && isErrorOrNoResults ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        xcss: $00b99825f3014b1e$var$maxWidthStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        space: "space.050",
        testId: "ai-proactive-container.inline",
        xcss: $00b99825f3014b1e$var$headerActionsContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "span",
        xcss: $00b99825f3014b1e$var$aiIconLabelStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gn1zL))), {
        label: formatMessage(customMessages.headerTitle)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        maxLines: 1,
        color: "color.text"
    }, isFetching ? formatMessage(customMessages.findingResultsMessage || (0, $9SUlM.default).findingResults) : formatMessage(customMessages.headerTitle)), isBeta && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
        appearance: "new"
    }, formatMessage((0, $9SUlM.default).beta))), $00b99825f3014b1e$var$isSimilarWorkItemsUIFixesEnabled(invokedFrom) ? null : isFetching && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $htSaL.StreamingStatusBar), {
        hasPadding: false
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        alignBlock: "end",
        spread: "space-between",
        xcss: $00b99825f3014b1e$var$subtextButtonContainerStyles,
        testId: "ai-proactive-container.small-width-row"
    }, isErrorOrNoResults && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        as: "em",
        color: "color.text.subtlest",
        maxLines: 1
    }, renderHeaderSubtext()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        alignBlock: "center"
    }, headerNode, renderActionButtons()))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        space: "space.050",
        testId: "ai-proactive-container.inline",
        xcss: $00b99825f3014b1e$var$headerActionsContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "span",
        xcss: $00b99825f3014b1e$var$aiIconLabelStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gn1zL))), {
        label: formatMessage(customMessages.headerTitle)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        maxLines: 1,
        color: "color.text"
    }, isFetching ? formatMessage(customMessages.findingResultsMessage || (0, $9SUlM.default).findingResults) : formatMessage(customMessages.headerTitle)), isBeta && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
        appearance: "new"
    }, formatMessage((0, $9SUlM.default).beta)), isErrorOrNoResults && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        as: "em",
        color: "color.text.subtlest",
        maxLines: 1
    }, renderHeaderSubtext())), $00b99825f3014b1e$var$isSimilarWorkItemsUIFixesEnabled(invokedFrom) ? null : isFetching && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $htSaL.StreamingStatusBar), {
        hasPadding: false
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        xcss: $00b99825f3014b1e$var$toggleButtonWrapperStyles
    }, headerNode, renderActionButtons()), isFetching && $00b99825f3014b1e$var$isSimilarWorkItemsUIFixesEnabled(invokedFrom) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $htSaL.StreamingStatusBar), {
        hasPadding: false
    }) : null)), shouldDisplay && renderChildren());
};
const $00b99825f3014b1e$var$headerActionsContainerStyles = (0, $1DXK0.xcss)({
    background: 'none',
    alignItems: 'center',
    marginLeft: 'space.100'
});
const $00b99825f3014b1e$var$aiIconLabelStyles = (0, $1DXK0.xcss)({
    padding: 'space.025',
    paddingTop: '0',
    paddingBottom: '0',
    height: 'space.0',
    width: 'space.100',
    color: 'color.text.subtle',
    marginRight: 'space.100',
    gap: 'space.100',
    display: 'flex',
    minWidth: 'fit-content',
    alignItems: 'center'
});
const $00b99825f3014b1e$var$toggleButtonWrapperStyles = (0, $1DXK0.xcss)({
    minWidth: 'fit-content',
    paddingRight: 'space.150',
    flexShrink: 0,
    alignItems: 'center',
    flexWrap: 'wrap'
});
const $00b99825f3014b1e$var$proactiveTopBarContainerStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: 'size.400',
    borderRadius: '3px',
    width: '100%',
    paddingBlock: 'space.100',
    paddingInline: 'space.075'
});
const $00b99825f3014b1e$var$proactiveTopBarContainerSmallWidthStyles = (0, $1DXK0.xcss)({
    height: '4.5rem'
});
const $00b99825f3014b1e$var$maxWidthStyles = (0, $1DXK0.xcss)({
    width: '100%'
});
const $00b99825f3014b1e$var$subtextButtonContainerStyles = (0, $1DXK0.xcss)({
    height: 'size.300',
    minWidth: 'fit-content',
    paddingRight: 'space.150',
    flexShrink: 0,
    flexWrap: 'wrap',
    background: 'none',
    marginLeft: 'space.100'
});

});
parcelRegister("gn1zL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::821d8a868bec01d1b9c95a45239911fb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $beb0043b8daf977a$var$_react = $beb0043b8daf977a$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $beb0043b8daf977a$var$_baseNew = $beb0043b8daf977a$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $beb0043b8daf977a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Premium".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for premium features.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $beb0043b8daf977a$var$PremiumIcon = (props)=>/*#__PURE__*/ $beb0043b8daf977a$var$_react.default.createElement($beb0043b8daf977a$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1.5 3v1.5H3V3h1.5V1.5H3V0H1.5v1.5H0V3zM8 1c.31 0 .587.19.699.478l1.63 4.193 4.193 1.63a.75.75 0 0 1 0 1.398l-4.193 1.63-1.63 4.193a.75.75 0 0 1-1.398 0l-1.63-4.193L1.478 8.7a.75.75 0 0 1 0-1.398l4.193-1.63L7.3 1.478A.75.75 0 0 1 8 1m0 2.82L6.949 6.521a.75.75 0 0 1-.427.427L3.819 8l2.703 1.051a.75.75 0 0 1 .427.427L8 12.181l1.051-2.703a.75.75 0 0 1 .427-.427L12.181 8 9.478 6.949a.75.75 0 0 1-.427-.427zm5 10.68V16h1.5v-1.5H16V13h-1.5v-1.5H13V13h-1.5v1.5z" clip-rule="evenodd"/>`
    }, props));
$beb0043b8daf977a$var$PremiumIcon.displayName = 'PremiumIcon';
var $beb0043b8daf977a$var$_default = module.exports.default = $beb0043b8daf977a$var$PremiumIcon;

});

parcelRegister("9skjA", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c22c6f11d6c3191$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $eJOHy = parcelRequire("eJOHy");

var $58yRG = parcelRequire("58yRG");

var $dPMMf = parcelRequire("dPMMf");

var $7jTnu = parcelRequire("7jTnu");
let $7c22c6f11d6c3191$var$namespaceUUID = 0;
const $7c22c6f11d6c3191$var$newPalette = {
    dark: {
        blue: '#0468FF',
        teal: '#BF63F3',
        yellow: '#FFA900'
    },
    light: {
        blue: '#0468FF',
        teal: '#BF63F3',
        yellow: '#FFA900'
    }
};
const $7c22c6f11d6c3191$var$AFTER_LOAD_DURATION = 3000;
const $7c22c6f11d6c3191$var$AnimatedSvgContainer = ({ isLoading: isLoading, isBlurred: isBlurred, isShadow: isShadow, isBorderGrey: isBorderGrey, hasNewBorderExperience: hasNewBorderExperience })=>{
    const { colorMode: colorMode } = (0, $58yRG.default)();
    const svgRef = (0, $eJOHy.useRef)(null);
    const namespaceId = (0, $eJOHy.useRef)();
    const [showRainbowBorder, setShowRainbowBorder] = (0, $eJOHy.useState)(false);
    const paletteForTheme = colorMode === 'dark' ? $7c22c6f11d6c3191$var$newPalette.dark : $7c22c6f11d6c3191$var$newPalette.light;
    if (namespaceId.current === undefined) {
        namespaceId.current = $7c22c6f11d6c3191$var$namespaceUUID; // eslint-disable-next-line react-hooks/react-compiler
        $7c22c6f11d6c3191$var$namespaceUUID += 1;
    }
    (0, $eJOHy.useEffect)(()=>{
        if (isLoading) {
            const svg = svgRef.current;
            hasNewBorderExperience && setShowRainbowBorder(true); // Schedule animation to begin before next browser paint
            const beginReq = requestAnimationFrame(()=>{
                svg?.querySelectorAll('animate').forEach((node)=>node.beginElement());
            });
            return ()=>{
                // Ensure any pending animation frame is cancelled as the element animation does not end properly if it
                // begins in the same event tick, i.e. isLoading synchronously changes to true then false.
                cancelAnimationFrame(beginReq);
                requestAnimationFrame(()=>{
                    svg?.querySelectorAll('animate').forEach((node)=>node.endElement());
                });
            };
        }
        return undefined;
    }, [
        isLoading,
        hasNewBorderExperience
    ]);
    (0, $eJOHy.useEffect)(()=>{
        // we keep the rainbow border without animations for at 3 seconds after load. After that we show the grey border
        if (hasNewBorderExperience && !isLoading && showRainbowBorder) {
            const timeoutId = setTimeout(()=>setShowRainbowBorder(false), $7c22c6f11d6c3191$var$AFTER_LOAD_DURATION);
            return ()=>clearTimeout(timeoutId);
        }
    }, [
        hasNewBorderExperience,
        showRainbowBorder,
        isLoading
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7c22c6f11d6c3191$var$SvgContainer, {
        isBlurred: isBlurred,
        isShadow: isShadow,
        ref: svgRef,
        viewBox: "0 0 24 24",
        preserveAspectRatio: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("linearGradient", {
        id: `${namespaceId.current}_lg1`,
        gradientUnits: "userSpaceOnUse",
        x1: "0%",
        y1: "0",
        x2: "400%",
        y2: "0",
        spreadMethod: "reflect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("animate", {
        begin: "indefinite",
        attributeName: "x1",
        from: "0%",
        to: "400%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("animate", {
        begin: "indefinite",
        attributeName: "x2",
        from: "400%",
        to: "800%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0",
        stopColor: paletteForTheme.blue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0.25",
        stopColor: paletteForTheme.teal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0.5",
        stopColor: paletteForTheme.yellow
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0.75",
        stopColor: paletteForTheme.teal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "1",
        stopColor: paletteForTheme.blue
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("linearGradient", {
        id: `${namespaceId.current}_lg2`,
        gradientUnits: "userSpaceOnUse",
        x1: "0",
        y1: "-100%",
        x2: "0",
        y2: "300%",
        spreadMethod: "reflect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("animate", {
        begin: "indefinite",
        attributeName: "y1",
        from: "-100%",
        to: "300%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("animate", {
        begin: "indefinite",
        attributeName: "y2",
        from: "300%",
        to: "700%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0",
        stopColor: paletteForTheme.blue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0.25",
        stopColor: paletteForTheme.teal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0.5",
        stopColor: paletteForTheme.yellow
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0.75",
        stopColor: paletteForTheme.teal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "1",
        stopColor: paletteForTheme.blue
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("linearGradient", {
        id: `${namespaceId.current}_lg3`,
        gradientUnits: "userSpaceOnUse",
        x1: "300%",
        y1: "0",
        x2: "700%",
        y2: "0",
        spreadMethod: "reflect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("animate", {
        begin: "indefinite",
        attributeName: "x1",
        from: "300%",
        to: "-100%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("animate", {
        begin: "indefinite",
        attributeName: "x2",
        from: "700%",
        to: "300%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0",
        stopColor: paletteForTheme.blue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0.25",
        stopColor: paletteForTheme.blue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0.5",
        stopColor: paletteForTheme.yellow
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0.75",
        stopColor: paletteForTheme.blue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "1",
        stopColor: paletteForTheme.blue
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("linearGradient", {
        id: `${namespaceId.current}_lg4`,
        gradientUnits: "userSpaceOnUse",
        x1: "0",
        y1: "0",
        x2: "0",
        y2: "400%",
        spreadMethod: "reflect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("animate", {
        begin: "indefinite",
        attributeName: "y1",
        from: "0%",
        to: "-400%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("animate", {
        begin: "indefinite",
        attributeName: "y2",
        from: "400%",
        to: "0%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0",
        stopColor: paletteForTheme.blue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0.25",
        stopColor: paletteForTheme.blue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0.5",
        stopColor: paletteForTheme.yellow
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "0.75",
        stopColor: paletteForTheme.teal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("stop", {
        offset: "1",
        stopColor: paletteForTheme.blue
    }))), isBorderGrey || hasNewBorderExperience && !showRainbowBorder && !isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("g", {
        strokeWidth: "16"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        stroke: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
        d: "M0 0h24v24H0Z",
        vectorEffect: "non-scaling-stroke"
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("g", {
        strokeWidth: "16"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        stroke: `url(#${namespaceId.current}_lg1)`,
        d: "M0 0h24",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        stroke: `url(#${namespaceId.current}_lg2)`,
        d: "M24 0v24",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        stroke: `url(#${namespaceId.current}_lg3)`,
        d: "M24 24H0",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        stroke: `url(#${namespaceId.current}_lg4)`,
        d: "M0 24V0",
        vectorEffect: "non-scaling-stroke"
    }))));
};
const $7c22c6f11d6c3191$var$AIContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, isLoading: isLoading, isShadow: isShadow = false, shouldFitContainer: shouldFitContainer = false, spacing: spacing = 'default', testId: testId, isBorderGrey: isBorderGrey, components: { ContainerComponent: ContainerComponent = $7c22c6f11d6c3191$var$Container, ContentComponent: ContentComponent = $7c22c6f11d6c3191$var$Content } = {}, hasNewBorderExperience: hasNewBorderExperience = false, borderless: borderless = false, zIndex: zIndex = (0, $dPMMf.layers).card }, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ContainerComponent, {
        "data-testid": testId,
        shouldFitContainer: shouldFitContainer,
        zIndex: zIndex
    }, (!(0, $7jTnu.fg)('similar_items_in_gic_ui_fixes') || !borderless) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7c22c6f11d6c3191$var$AnimatedSvgContainer, {
        isShadow: isShadow,
        isLoading: isLoading,
        isBorderGrey: isBorderGrey,
        hasNewBorderExperience: hasNewBorderExperience
    }), isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7c22c6f11d6c3191$var$AnimatedSvgContainer, {
        isLoading: isLoading,
        isBlurred: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ContentComponent, {
        ref: ref,
        spacing: spacing
    }, children));
});
var $7c22c6f11d6c3191$export$2e2bcd8739ae039 = $7c22c6f11d6c3191$var$AIContainer;
$7c22c6f11d6c3191$var$AIContainer.displayName = 'AIContainer'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7c22c6f11d6c3191$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldFitContainer: shouldFitContainer, zIndex: zIndex, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_w1vr8s": (0, $awdRS.default)(__cmplp.zIndex || (0, $dPMMf.layers).card)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _kqswh2mm _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o _1pbypt6a",
            __cmplp.shouldFitContainer ? "_1bsb1wug" : "_1bsb1ns9",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7c22c6f11d6c3191$var$Content = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { zIndex: zIndex, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_w1vr8s": (0, $awdRS.default)(__cmplp.zIndex || (0, $dPMMf.layers).card)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkoi2wt _bfhkvuon _16jlkb7n _1pbypt6a _1bsb1osq",
            __cmplp.spacing === 'default' && "_ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $7c22c6f11d6c3191$export$71abc632aa29e6fe = {
    ContainerComponent: $7c22c6f11d6c3191$var$Container,
    ContentComponent: $7c22c6f11d6c3191$var$Content
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7c22c6f11d6c3191$var$SvgContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "svg", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isShadow: isShadow, isBlurred: isBlurred, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkoftgi _kqswstnw",
            __cmplp.isShadow ? "_16qs9g9j" : "_16qsglyw",
            __cmplp.isBlurred ? "_1bsb5cnj _4t3i5cnj _154iu2gc _1ltvu2gc _kdam7b89" : "_1ltvidpf _154iidpf _1bsb1osq _4t3i1osq",
            __cmplp.className
        ])
    });
});

});

parcelRegister("YuSda", function(module, exports) {

$parcel$export(module.exports, "AiFooter", () => $b2948315e7aa0d77$export$915814a2dcce5cf0);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $7kJQm = parcelRequire("7kJQm");

var $lmgo6 = parcelRequire("lmgo6");
var $3Wh6p = parcelRequire("3Wh6p");
var $1DXK0 = parcelRequire("1DXK0");

var $lL4G9 = parcelRequire("lL4G9");

var $lRq8t = parcelRequire("lRq8t");

var $8v03d = parcelRequire("8v03d");

var $bNexr = parcelRequire("bNexr");

var $bmoS1 = parcelRequire("bmoS1");

var $6sksU = parcelRequire("6sksU");
const $b2948315e7aa0d77$export$915814a2dcce5cf0 = ({ testId: testId, feedbackCollectorId: feedbackCollectorId, feedbackFormEntrypointId: feedbackFormEntrypointId, onFeedbackClicked: onFeedbackClicked = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), onAiFeedbackSubmittedEvent: onAiFeedbackSubmittedEvent, footerActionNode: footerActionNode, aiExperience: aiExperience, footerContainerStyles: footerContainerStyles })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const issueKey = (0, $bmoS1.useIssueKey)();
    const projectKey = (0, $bNexr.useProjectKey)(issueKey);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        testId: testId,
        xcss: [
            $b2948315e7aa0d77$var$footerStyle,
            ...footerContainerStyles ? [
                footerContainerStyles
            ] : []
        ],
        spread: "space-between",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        alignItems: "center",
        gap: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7kJQm))), {
        label: formatMessage((0, $6sksU.default).infoIconLabel),
        LEGACY_size: "small",
        color: "var(--ds-icon-subtle, #626F86)",
        testId: "ai-proactive-container.ui.footer.info-icon"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lL4G9.default), {
        xcss: $b2948315e7aa0d77$var$linkStyle,
        href: "https://www.atlassian.com/trust/atlassian-intelligence",
        rel: "noopener",
        target: "_blank",
        testId: "ai-proactive-container.ui.footer.disclaimer-text"
    }, formatMessage((0, $6sksU.default).disclaimerText)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        alignItems: "center",
        gap: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8v03d.FeedbackForm), {
        feedbackCollectorId: feedbackCollectorId,
        feedbackFormEntrypointId: feedbackFormEntrypointId,
        aiExperience: aiExperience,
        onFeedbackClicked: onFeedbackClicked,
        onFeedbackSent: onAiFeedbackSubmittedEvent,
        projectKey: projectKey
    }), footerActionNode));
};
const $b2948315e7aa0d77$var$footerStyle = (0, $1DXK0.xcss)({
    borderTop: `1px solid ${"var(--ds-border, #091E4224)"}`,
    paddingLeft: 'space.200',
    paddingRight: 'space.250',
    paddingBlock: 'space.050'
});
const $b2948315e7aa0d77$var$linkStyle = (0, $1DXK0.xcss)({
    textDecoration: 'none',
    color: 'color.text.subtlest',
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});

});
parcelRegister("8v03d", function(module, exports) {

$parcel$export(module.exports, "RELATED_RESOURCES_AI_EXPERIENCE", () => $0a5503cb312c4d4f$export$dbe5a4c348b3c6b9);
$parcel$export(module.exports, "JQL_DEBUGGER_EXPERIENCE", () => $0a5503cb312c4d4f$export$77a8bad949de7900);
$parcel$export(module.exports, "INTELLIGENT_WORK_BREAKDOWN_AI_EXPERIENCE", () => $0a5503cb312c4d4f$export$ded9f586f0db7f22);
$parcel$export(module.exports, "RELATED_ISSUES_AI_EXPERIENCE", () => $0a5503cb312c4d4f$export$e8427ec7b005ba96);
$parcel$export(module.exports, "BACKLOG_AI_WORK_CREATION_EXPERIENCE", () => $0a5503cb312c4d4f$export$f603f6b0e3eaee62);
$parcel$export(module.exports, "SPRINT_GOAL_AI_EXPERIENCE", () => $0a5503cb312c4d4f$export$f9303992d11f2666);
$parcel$export(module.exports, "FeedbackForm", () => $0a5503cb312c4d4f$export$ce859c56062f484c);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $6b4Xr = parcelRequire("6b4Xr");

var $jdqdp = parcelRequire("jdqdp");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $igGHJ = parcelRequire("igGHJ");

var $lRq8t = parcelRequire("lRq8t");

var $bNexr = parcelRequire("bNexr");

var $v7053 = parcelRequire("v7053");

var $6rjNT = parcelRequire("6rjNT");
const $0a5503cb312c4d4f$export$dbe5a4c348b3c6b9 = 'issue-ai-related-resources';
const $0a5503cb312c4d4f$export$77a8bad949de7900 = 'jql-debugger'; // TODO
const $0a5503cb312c4d4f$export$ded9f586f0db7f22 = 'issue-ai-intelligent-work-breakdown';
const $0a5503cb312c4d4f$export$e8427ec7b005ba96 = 'issue-ai-related-issues';
const $0a5503cb312c4d4f$export$f603f6b0e3eaee62 = 'backlog-ai-work-creation';
const $0a5503cb312c4d4f$export$f9303992d11f2666 = 'sprint-goal-ai-suggestion';
const $0a5503cb312c4d4f$export$ce859c56062f484c = ({ isDisabled: isDisabled = false, aiExperience: aiExperience, feedbackFormEntrypointId: feedbackFormEntrypointId, feedbackCollectorId: feedbackCollectorId, onFeedbackClicked: onFeedbackClicked, onFeedbackSent: onFeedbackSent, projectKey: projectKey })=>{
    const [isFeedbackDisabled, setIsFeedbackDisabled] = (0, $eJOHy.useState)(isDisabled);
    const [wasFeedbackSent, setWasFeedbackSent] = (0, $eJOHy.useState)(false);
    const [isLikeSelected, setIsLikeSelected] = (0, $eJOHy.useState)(false);
    const [isDisLikeSelected, setIsDisLikeSelected] = (0, $eJOHy.useState)(false);
    const projectType = (0, $bNexr.useProjectType)(projectKey);
    const { openFeedbackCollector: openFeedbackCollector } = (0, $igGHJ.useFeedbackCollectorActions)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const handleFeedbackSent = (0, $eJOHy.useCallback)((wasSent)=>{
        setWasFeedbackSent(wasSent);
        setIsFeedbackDisabled(wasSent);
    }, []);
    const getSentiment = (0, $eJOHy.useCallback)((isPositive)=>isPositive ? 'good' : 'bad', []);
    const getFeedbackContext = (0, $eJOHy.useCallback)((isPositive)=>({
            entrypointId: feedbackFormEntrypointId,
            feedbackCollectorId: feedbackCollectorId,
            feedbackContext: [
                {
                    id: 'sentiment',
                    value: getSentiment(isPositive)
                },
                {
                    id: 'product',
                    value: projectType ?? ''
                },
                {
                    id: 'ai-experience',
                    value: aiExperience
                }
            ],
            // Doing this allows for feedback to be reenabled if cancel button is clicked on feedback form
            onSubmit () {
                handleFeedbackSent(true);
                if (isPositive) setIsLikeSelected(true);
                else setIsDisLikeSelected(true);
                const aiFeedbackResult = isPositive ? 'up' : 'down';
                onFeedbackSent(aiFeedbackResult);
            },
            onClose () {
                handleFeedbackSent(false);
            }
        }), [
        feedbackFormEntrypointId,
        feedbackCollectorId,
        getSentiment,
        projectType,
        aiExperience,
        handleFeedbackSent,
        onFeedbackSent
    ]);
    const handleOnClick = (0, $eJOHy.useCallback)((isPositive)=>{
        if (!isFeedbackDisabled) {
            setIsFeedbackDisabled(true);
            openFeedbackCollector(getFeedbackContext(isPositive));
        }
        const aiFeedbackResult = isPositive ? 'up' : 'down';
        onFeedbackClicked(aiFeedbackResult); // disable hover pop-up of feedback button
        return true;
    }, [
        getFeedbackContext,
        isFeedbackDisabled,
        onFeedbackClicked,
        openFeedbackCollector
    ]);
    const likeButton = (0, $eJOHy.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6b4Xr))), {
            color: isFeedbackDisabled ? "var(--ds-icon-disabled, #091E424F)" : "var(--ds-icon-subtle, #626F86)",
            spacing: "spacious",
            label: formatMessage((0, $6rjNT.default).feedbackIconLabel)
        }), [
        formatMessage,
        isFeedbackDisabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0a5503cb312c4d4f$var$FormContainer, {
        "data-testid": "atlassian-intelligence.common.ui.feedback-form.container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0a5503cb312c4d4f$var$FeedbackGroup, null, wasFeedbackSent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $0a5503cb312c4d4f$var$feedBackStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
        testId: "atlassian-intelligence.common.ui.feedback-form.beta-lozenge",
        appearance: "success"
    }, formatMessage((0, $6rjNT.default).feedbackSentLozenge))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0a5503cb312c4d4f$var$ButtonStyle, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $v7053.FeedbackButton), {
        testId: "atlassian-intelligence.common.ui.feedback-form.like-button",
        isDisabled: isFeedbackDisabled,
        isSelected: isLikeSelected,
        isPositive: true,
        iconBefore: likeButton,
        onClick: ()=>handleOnClick(true),
        appearance: "subtle",
        tooltipContent: formatMessage((0, $6rjNT.default).tooltipLike),
        spacing: "compact"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0a5503cb312c4d4f$var$ButtonStyle, {
        isDislike: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $v7053.FeedbackButton), {
        isDisabled: isFeedbackDisabled,
        isPositive: false,
        isSelected: isDisLikeSelected,
        iconBefore: likeButton,
        onClick: ()=>handleOnClick(false),
        appearance: "subtle",
        tooltipContent: formatMessage((0, $6rjNT.default).tooltipDislike),
        spacing: "compact",
        testId: "atlassian-intelligence.common.ui.feedback-form.dislike-button"
    }))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $0a5503cb312c4d4f$var$FormContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_zulp1b66 _1e0c1txw _13lin7od _qrwqn7od _mrkb130s _1o0z130s _4cvr1h6o _1bah1yb4 _syaz1gjq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $0a5503cb312c4d4f$var$FeedbackGroup = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1n261g80 _4cvr1h6o _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $0a5503cb312c4d4f$var$ButtonStyle = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDislike: isDislike, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_c71l1ejb",
            (__cmplp.isDislike ?? false) && "_t9ec1sub",
            __cmplp.className
        ])
    });
});
const $0a5503cb312c4d4f$var$feedBackStyles = (0, $1DXK0.xcss)({
    marginRight: 'space.100'
});

});
parcelRegister("6b4Xr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b34d7d17224c47dbf743afe51a06a375>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $47f79dad4421f094$var$_react = $47f79dad4421f094$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $47f79dad4421f094$var$_thumbsUp = $47f79dad4421f094$var$_interopRequireDefault((parcelRequire("kUiRE")));

var $47f79dad4421f094$var$_like = $47f79dad4421f094$var$_interopRequireDefault((parcelRequire("1Pa7M")));
function $47f79dad4421f094$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ThumbsUpIcon.
 * This component is ThumbsUpIcon, with `UNSAFE_fallbackIcon` set to "LikeIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: voting options in Jira, like.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $47f79dad4421f094$var$ThumbsUpIcon = (props)=>/*#__PURE__*/ $47f79dad4421f094$var$_react.default.createElement($47f79dad4421f094$var$_thumbsUp.default, Object.assign({
        LEGACY_fallbackIcon: $47f79dad4421f094$var$_like.default
    }, props));
$47f79dad4421f094$var$ThumbsUpIcon.Name = 'ThumbsUpIconMigration';
var $47f79dad4421f094$var$_default = module.exports.default = $47f79dad4421f094$var$ThumbsUpIcon;

});
parcelRegister("kUiRE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a1671a6ac4d424a875e471692b3026e8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f387abafeaf82384$var$_react = $f387abafeaf82384$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $f387abafeaf82384$var$_baseNew = $f387abafeaf82384$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $f387abafeaf82384$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ThumbsUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: voting options in Jira, like.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f387abafeaf82384$var$ThumbsUpIcon = (props)=>/*#__PURE__*/ $f387abafeaf82384$var$_react.default.createElement($f387abafeaf82384$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.708 2.594a.5.5 0 0 0-.77.15L5.5 7.433V13.5h6.371c.493 0 .928-.32 1.074-.79l1.328-4.25A1.125 1.125 0 0 0 13.2 7H9.75A.75.75 0 0 1 9 6.25V3.075a.5.5 0 0 0-.175-.38zM4 13.5V8H2a.5.5 0 0 0-.5.5V13a.5.5 0 0 0 .5.5zm.295-7 2.313-4.45a2 2 0 0 1 3.076-.596l.118.101a2 2 0 0 1 .698 1.519V5.5h2.7a2.625 2.625 0 0 1 2.505 3.408l-1.328 4.25A2.625 2.625 0 0 1 11.871 15H2a2 2 0 0 1-2-2V8.5a2 2 0 0 1 2-2z" clip-rule="evenodd"/>`
    }, props));
$f387abafeaf82384$var$ThumbsUpIcon.displayName = 'ThumbsUpIcon';
var $f387abafeaf82384$var$_default = module.exports.default = $f387abafeaf82384$var$ThumbsUpIcon;

});

parcelRegister("1Pa7M", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1542685d478e8b88$var$_react = $1542685d478e8b88$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $1542685d478e8b88$var$_thumbsUp = $1542685d478e8b88$var$_interopRequireDefault((parcelRequire("kUiRE")));
function $1542685d478e8b88$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1542685d478e8b88$var$LikeIcon = (props)=>/*#__PURE__*/ $1542685d478e8b88$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4 12v7a.97.97 0 0 0 .278.704 1 1 0 0 0 .701.296H6v-9H4.98a1 1 0 0 0-.701.296A.97.97 0 0 0 4 12m15.281-.96a3.05 3.05 0 0 0-2.321-1.061h-2.634c.04-.181.08-.36.11-.532.515-2.934 0-4-.504-4.594A2.43 2.43 0 0 0 12.075 4a3.08 3.08 0 0 0-2.968 2.751c-.393 1.839-.454 2-.968 2.725l-.768 1.089a2 2 0 0 0-.363 1.141v6.273c.001.532.216 1.041.596 1.416s.896.585 1.433.584h7.247a3.014 3.014 0 0 0 2.997-2.507l.677-4a2.96 2.96 0 0 0-.677-2.432m-1.998 6.1a1.01 1.01 0 0 1-1 .835H9.038v-6.269l.767-1.089a7.6 7.6 0 0 0 1.302-3.509c.036-.543.255-1.209.969-1.108s.575 1.916.363 3.1a20 20 0 0 1-.868 2.882l5.39-.008c.297-.001.58.128.773.352a1 1 0 0 1 .226.813z"/></svg>`
    }, props, {
        newIcon: $1542685d478e8b88$var$_thumbsUp.default
    }));
$1542685d478e8b88$var$LikeIcon.displayName = 'LikeIcon';
var $1542685d478e8b88$var$_default = module.exports.default = $1542685d478e8b88$var$LikeIcon;

});


parcelRegister("v7053", function(module, exports) {

$parcel$export(module.exports, "FeedbackButton", () => $5c0a89989c060b91$export$116fedbe5e2e2bd8);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $k71qx = parcelRequire("k71qx");

var $cNe2t = parcelRequire("cNe2t");

var $4wc0I = parcelRequire("4wc0I");

var $4HYYg = parcelRequire("4HYYg");

var $71UWI = parcelRequire("71UWI");
const $5c0a89989c060b91$export$116fedbe5e2e2bd8 = ({ appearance: appearance, children: children, iconBefore: iconBefore, isErrorReport: isErrorReport, isDisabled: isDisabled, isPositive: isPositive, isSelected: isSelected, label: label, onClick: onClick, onSubmit: onSubmit, offset: offset, placement: placement, spacing: spacing, testId: testId, tooltipContent: tooltipContent })=>{
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const [submittedPrompt] = (0, $4wc0I.useSubmittedPrompt)();
    const [feedbackContext] = (0, $4wc0I.useResponseFeedbackContext)();
    const { onSubmitFeedback: onSubmitFeedback } = (0, $4HYYg.useFeedbackService)(submittedPrompt, feedbackContext);
    const handleClick = (0, $eJOHy.useCallback)(()=>{
        // Prevent opening of the popup if the click event has been explicity handled by the parent
        const handled = onClick();
        if (handled) return;
        setIsOpen(true);
    }, [
        onClick
    ]);
    const handleSubmit = (0, $eJOHy.useCallback)(async (data, isPositiveFeedback)=>{
        await onSubmitFeedback(data, isPositiveFeedback);
        onSubmit && onSubmit();
    }, [
        onSubmit,
        onSubmitFeedback
    ]);
    const handleClose = (0, $eJOHy.useCallback)(()=>{
        setIsOpen(false);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cNe2t.JiraPopup), {
        isOpen: isOpen,
        onClose: handleClose,
        placement: placement,
        offset: offset,
        content: ({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $71UWI.FeedbackPopupContent), {
                isErrorReport: isErrorReport,
                isPositive: isPositive,
                onClose: handleClose,
                onSubmit: handleSubmit,
                setInitialFocusRef: setInitialFocusRef
            }),
        messageId: "atlassian-intelligence.common.ui.feedback-button.popup",
        messageType: "transactional",
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
                content: tooltipContent ?? null
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                ...triggerProps,
                "aria-label": label,
                appearance: appearance,
                spacing: spacing,
                iconBefore: iconBefore,
                onClick: handleClick,
                isSelected: isSelected,
                isDisabled: isDisabled,
                testId: testId
            }, children))
    });
};

});
parcelRegister("4wc0I", function(module, exports) {

$parcel$export(module.exports, "PromptContainer", () => $cfea445c515e3746$export$f996e810bab47dad);
$parcel$export(module.exports, "usePromptActions", () => $cfea445c515e3746$export$b69cbf7f2fd4c7ba);
$parcel$export(module.exports, "useResponseFeedbackContext", () => $cfea445c515e3746$export$7737761958d6bb6c);
$parcel$export(module.exports, "usePromptResponse", () => $cfea445c515e3746$export$775e0e2ce513f8e7);
$parcel$export(module.exports, "usePrompt", () => $cfea445c515e3746$export$fc7731b33eb53a93);
$parcel$export(module.exports, "useSubmittedPrompt", () => $cfea445c515e3746$export$80b178470b13c8ae);
$parcel$export(module.exports, "usePromptIsLoading", () => $cfea445c515e3746$export$912d74d2ad112159);
$parcel$export(module.exports, "usePromptIsSubmitted", () => $cfea445c515e3746$export$20b39be031988e7a);
$parcel$export(module.exports, "usePromptId", () => $cfea445c515e3746$export$19f80ca0c5d6d88d);
$parcel$export(module.exports, "useScopedId", () => $cfea445c515e3746$export$1f910160e5ac22b);

var $aXKmr = parcelRequire("aXKmr");

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");

var $8eQHk = parcelRequire("8eQHk");
const $cfea445c515e3746$var$initialState = {
    idPrefix: '',
    isLoading: false,
    isSubmitted: false,
    prompt: '',
    response: undefined,
    submittedPrompt: '',
    cancellable: undefined,
    promptId: ''
};
const $cfea445c515e3746$export$390f32400eaf98c9 = (0, $GtRbT.createStore)({
    initialState: $cfea445c515e3746$var$initialState,
    actions: $8eQHk.actions
});
const $cfea445c515e3746$export$f996e810bab47dad = (0, $6E16M.createContainer)($cfea445c515e3746$export$390f32400eaf98c9, {
    onInit: ()=>({ setState: setState })=>{
            setState({
                idPrefix: (0, $aXKmr.v4)()
            });
        }
});
const $cfea445c515e3746$export$b69cbf7f2fd4c7ba = (0, $iJq0l.createActionsHook)($cfea445c515e3746$export$390f32400eaf98c9);
const $cfea445c515e3746$export$7737761958d6bb6c = (0, $iJq0l.createHook)($cfea445c515e3746$export$390f32400eaf98c9, {
    selector: (state)=>state.response?.additionalFeedbackContext
});
const $cfea445c515e3746$var$usePromptResponseGeneric = (0, $iJq0l.createHook)($cfea445c515e3746$export$390f32400eaf98c9, {
    selector: (state)=>state.response
});
function $cfea445c515e3746$export$775e0e2ce513f8e7() {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return $cfea445c515e3746$var$usePromptResponseGeneric();
}
const $cfea445c515e3746$export$fc7731b33eb53a93 = (0, $iJq0l.createHook)($cfea445c515e3746$export$390f32400eaf98c9, {
    selector: (state)=>state.prompt
});
const $cfea445c515e3746$export$80b178470b13c8ae = (0, $iJq0l.createHook)($cfea445c515e3746$export$390f32400eaf98c9, {
    selector: (state)=>state.submittedPrompt
});
const $cfea445c515e3746$export$912d74d2ad112159 = (0, $iJq0l.createHook)($cfea445c515e3746$export$390f32400eaf98c9, {
    selector: (state)=>state.isLoading
});
const $cfea445c515e3746$export$20b39be031988e7a = (0, $iJq0l.createHook)($cfea445c515e3746$export$390f32400eaf98c9, {
    selector: (state)=>state.isSubmitted
});
const $cfea445c515e3746$export$19f80ca0c5d6d88d = (0, $iJq0l.createHook)($cfea445c515e3746$export$390f32400eaf98c9, {
    selector: (state)=>state.promptId
});
const $cfea445c515e3746$var$getScopedId = (state, idSuffix)=>`${state.idPrefix}_${idSuffix}`;
const $cfea445c515e3746$export$1f910160e5ac22b = (0, $iJq0l.createHook)($cfea445c515e3746$export$390f32400eaf98c9, {
    selector: $cfea445c515e3746$var$getScopedId
});

});
parcelRegister("8eQHk", function(module, exports) {

$parcel$export(module.exports, "actions", () => $54f0760b63195fab$export$e324594224ef24da);

var $aXKmr = parcelRequire("aXKmr");
function $54f0760b63195fab$var$onHandlePrompt(nextPrompt, promptId) {
    return async (_, { onPrompt: onPrompt })=>{
        try {
            return await onPrompt(nextPrompt, promptId);
        } catch (e) {
            // Ignore errors as this is expected to be handled in the consumer
            return undefined;
        }
    };
}
const $54f0760b63195fab$export$e324594224ef24da = {
    onUpdate (prompt) {
        return ({ setState: setState })=>{
            // Update input prompt
            setState({
                prompt: prompt
            });
        };
    },
    onSubmit (nextPrompt) {
        const nextPromptId = (0, $aXKmr.v4)();
        return async ({ getState: getState, setState: setState, dispatch: dispatch }, { onPromptSuccess: onPromptSuccess })=>{
            // Set loading state
            setState({
                isLoading: true,
                isSubmitted: true,
                submittedPrompt: nextPrompt,
                promptId: nextPromptId
            });
            const { cancellable: cancellable } = getState();
            // Cancel any in-flight requests
            if (cancellable) cancellable();
            const cancellablePromise = new Promise((resolve, reject)=>{
                // Allow this request to be cancelled
                setState({
                    cancellable: reject
                });
            });
            try {
                const nextResponse = await Promise.race([
                    dispatch($54f0760b63195fab$var$onHandlePrompt(nextPrompt, nextPromptId)),
                    cancellablePromise
                ]);
                nextResponse?.type === 'success' && onPromptSuccess && onPromptSuccess(nextResponse.payload);
                // Set successful response into state
                setState({
                    isLoading: false,
                    response: nextResponse
                });
            } catch (e) {
            // Pending promise was cancelled
            }
        };
    }
};

});


parcelRegister("4HYYg", function(module, exports) {

$parcel$export(module.exports, "useFeedbackService", () => $9c1f040232c6c384$export$fdeb51de8e2ac66d);

var $eJOHy = parcelRequire("eJOHy");

var $gYnSx = parcelRequire("gYnSx");

var $hrodw = parcelRequire("hrodw");
var $bILK0 = parcelRequire("bILK0");

var $kkHo2 = parcelRequire("kkHo2");

var $c9f6v = parcelRequire("c9f6v");

var $k6bid = parcelRequire("k6bid");

var $5Ovjr = parcelRequire("5Ovjr");
var $9c1f040232c6c384$require$Buffer = $5Ovjr.Buffer;
const $9c1f040232c6c384$var$FEEDBACK_ENDPOINT = '/gateway/api/feedback-collector-api/feedback';
const $9c1f040232c6c384$var$REQUEST_TYPE = '594';
const $9c1f040232c6c384$var$EMBED_KEY = 'a64ab7a8-2ce8-4942-884d-0f3090ef971e';
const $9c1f040232c6c384$var$MAX_SUMMARY_LENGTH = 100;
// The custom fields for consent are defined in this file: src/packages/platform/ui/help-panel/src/services/feedback/index.tsx
// HOWEVER, they are not exported and as this feedback collector is expected to be a temporary solution the change hasn't been
// made to export them.
const $9c1f040232c6c384$var$CONTACT_FIELD_ID = 'customfield_10043';
const $9c1f040232c6c384$var$CONTACT_TRUE_VALUE = '10109';
const $9c1f040232c6c384$var$CONTACT_FALSE_VALUE = '10111';
const $9c1f040232c6c384$var$RESEARCH_FIELD_ID = 'customfield_10044';
const $9c1f040232c6c384$var$RESEARCH_TRUE_VALUE = '10110';
const $9c1f040232c6c384$var$RESEARCH_FALSE_VALUE = '10112';
const $9c1f040232c6c384$var$FEEDBACK_SUBMITTED_FLAG = {
    id: (0, $hrodw.toFlagId)('atlassian-intelligence.ui.prompt-response.feedback.submitted'),
    type: 'success',
    title: (0, $k6bid.default).feedbackSubmittedFlagTitle,
    description: (0, $k6bid.default).feedbackSubmittedFlagDescription,
    messageId: 'atlassian-intelligence.services.feedback.feedback-submitted-flag.success.jira-modal',
    messageType: 'transactional'
};
const $9c1f040232c6c384$var$normalizeTextForSummary = (feedbackText)=>{
    if (!feedbackText.length) return '<no summary>';
    const singleLineFeedbackText = feedbackText.replace(/\n/g, ' ');
    return singleLineFeedbackText.length > $9c1f040232c6c384$var$MAX_SUMMARY_LENGTH ? `${singleLineFeedbackText.substring(0, $9c1f040232c6c384$var$MAX_SUMMARY_LENGTH)}...` : singleLineFeedbackText;
};
const $9c1f040232c6c384$var$getFeedbackFieldsWithConsent = ({ data: data, feedbackContext: feedbackContext, isPositive: isPositive, emailAddress: emailAddress, displayName: displayName })=>{
    const { feedbackText: feedbackText, contactConsentPrompt: contactConsentPrompt, researchConsentPrompt: researchConsentPrompt } = data;
    return [
        {
            id: 'summary',
            value: `[${isPositive ? '+' : '-'}] ${$9c1f040232c6c384$var$normalizeTextForSummary(feedbackText)}`
        },
        {
            id: 'description',
            value: feedbackText
        },
        {
            id: 'email',
            value: emailAddress ?? 'do-not-reply@atlassian.com'
        },
        {
            id: 'customfield_10045',
            value: displayName ?? 'unknown'
        },
        {
            id: 'aaidOrHash',
            value: ''
        },
        {
            id: 'customfield_10047',
            value: feedbackContext
        },
        {
            id: $9c1f040232c6c384$var$CONTACT_FIELD_ID,
            value: [
                {
                    id: contactConsentPrompt ? $9c1f040232c6c384$var$CONTACT_TRUE_VALUE : $9c1f040232c6c384$var$CONTACT_FALSE_VALUE
                }
            ]
        },
        {
            id: $9c1f040232c6c384$var$RESEARCH_FIELD_ID,
            value: [
                {
                    id: researchConsentPrompt ? $9c1f040232c6c384$var$RESEARCH_TRUE_VALUE : $9c1f040232c6c384$var$RESEARCH_FALSE_VALUE
                }
            ]
        }
    ];
};
const $9c1f040232c6c384$var$normalizeFeedbackContext = (feedbackContext)=>feedbackContext.map(({ id: id, value: value })=>`${id}: ${value}`).join('\n');
const $9c1f040232c6c384$var$removeName = (prompt, name)=>prompt.replace(new RegExp(name, 'gi'), 'XXX');
const $9c1f040232c6c384$var$removeNames = (prompt, userFullname)=>userFullname.split(' ').reduce((acc, name)=>name === '' ? acc : $9c1f040232c6c384$var$removeName(acc, name), prompt);
const $9c1f040232c6c384$var$removeEmailAddresses = (prompt)=>prompt.replace(new RegExp('([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\\.[a-zA-Z0-9_-]+)', 'gi'), 'XXX@XXX.XXX');
const $9c1f040232c6c384$export$53b1bdb22c0c1228 = (prompt, userFullname)=>$9c1f040232c6c384$var$removeEmailAddresses($9c1f040232c6c384$var$removeNames(prompt, userFullname));
const $9c1f040232c6c384$export$fdeb51de8e2ac66d = (prompt, additionalFeedbackContext)=>{
    const { showFlag: showFlag } = (0, $bILK0.useFlagsService)();
    const [{ data: loggedInUser }] = (0, $c9f6v.useUserSubscriber)();
    const onSubmitFeedback = (0, $eJOHy.useCallback)(async (data, isPositive)=>{
        if (!data.feedbackText && !data.sharePrompt) {
            showFlag($9c1f040232c6c384$var$FEEDBACK_SUBMITTED_FLAG);
            // Do nothing, probably the user just wanted to send a thumbs up / thumbs down rating
            return Promise.resolve();
        }
        const feedbackContext = [
            {
                id: 'Location',
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                value: (0, $kkHo2.default)(window?.location?.href ?? '')
            },
            {
                id: 'Screen Resolution',
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                value: `${window?.screen?.width ?? 'unknown'} x ${window?.screen?.height ?? 'unknown'}`
            },
            {
                id: 'User-Agent',
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                value: `${window?.navigator?.userAgent ?? 'unknown'}`
            },
            {
                id: 'Rating',
                value: isPositive ? 'Thumbs up' : 'Thumbs down'
            }
        ];
        if (data.sharePrompt && prompt) feedbackContext.push({
            id: 'Prompt',
            value: $9c1f040232c6c384$export$53b1bdb22c0c1228(prompt, loggedInUser?.displayName ?? '')
        });
        if (additionalFeedbackContext?.length && data.sharePrompt) feedbackContext.push(...additionalFeedbackContext);
        try {
            const body = JSON.stringify({
                feedback: {
                    requestType: $9c1f040232c6c384$var$REQUEST_TYPE,
                    embedKey: $9c1f040232c6c384$var$EMBED_KEY,
                    fields: $9c1f040232c6c384$var$getFeedbackFieldsWithConsent({
                        data: data,
                        feedbackContext: $9c1f040232c6c384$var$normalizeFeedbackContext(feedbackContext),
                        isPositive: isPositive,
                        emailAddress: loggedInUser?.emailAddress,
                        displayName: loggedInUser?.displayName
                    })
                }
            });
            await fetch($9c1f040232c6c384$var$FEEDBACK_ENDPOINT, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    data: $9c1f040232c6c384$require$Buffer.from(body).toString('base64')
                })
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $gYnSx.default)({
                meta: {
                    id: 'onFeedbackSubmit',
                    packageName: 'jiraAtlassianIntelligence',
                    teamName: 'gravity-ai'
                },
                sendToPrivacyUnsafeSplunk: true,
                error: error
            });
        }
        showFlag($9c1f040232c6c384$var$FEEDBACK_SUBMITTED_FLAG);
        return Promise.resolve();
    }, [
        loggedInUser?.displayName,
        loggedInUser?.emailAddress,
        prompt,
        showFlag,
        additionalFeedbackContext
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            onSubmitFeedback: onSubmitFeedback
        }), [
        onSubmitFeedback
    ]);
};

});
parcelRegister("k6bid", function(module, exports) {

$parcel$export(module.exports, "default", () => $e33a929489e20d70$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $e33a929489e20d70$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    feedbackSubmittedFlagTitle: {
        "id": "atlassian-intelligence.services.feedback.feedback-submitted-flag-title",
        "defaultMessage": "Thank you for sharing your query"
    },
    feedbackSubmittedFlagDescription: {
        "id": "atlassian-intelligence.services.feedback.feedback-submitted-flag-description",
        "defaultMessage": "Your valuable feedback helps us continually improve our products."
    }
});

});


parcelRegister("71UWI", function(module, exports) {

$parcel$export(module.exports, "FeedbackPopupContent", () => $a4cb633294b0446f$export$9ca94f39d69b2936);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");
var $cA0Y2 = parcelRequire("cA0Y2");

var $86tBw = parcelRequire("86tBw");

var $806LH = parcelRequire("806LH");

var $6J9k6 = parcelRequire("6J9k6");

var $eJ9f5 = parcelRequire("eJ9f5");

var $8nu6j = parcelRequire("8nu6j");
var $3Wh6p = parcelRequire("3Wh6p");
var $dW738 = parcelRequire("dW738");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $dQmi3 = parcelRequire("dQmi3");

var $lRq8t = parcelRequire("lRq8t");

var $lHJTm = parcelRequire("lHJTm");
const $a4cb633294b0446f$var$FEEDBACK_TEXT_FIELD = 'feedback-text';
const $a4cb633294b0446f$var$SHARE_PROMPT_CHECKBOX = 'share-prompt';
const $a4cb633294b0446f$var$CONTACT_CONSENT_PROMPT_CHECKBOX = 'contact-consent-prompt';
const $a4cb633294b0446f$var$RESEARCH_CONSENT_PROMT_CHECKBOX = 'research-consent-prompt';
// The height of the text area should be 160px - there is a 12px combined padding and here we have 148px height
const $a4cb633294b0446f$var$MAX_TEXTAREA_HEIGHT = '148px';
const $a4cb633294b0446f$var$MIN_TEXTAREA_ROWS = 7;
const $a4cb633294b0446f$export$9ca94f39d69b2936 = ({ isErrorReport: isErrorReport, isPositive: isPositive, onClose: onClose, onSubmit: onSubmit, setInitialFocusRef: setInitialFocusRef })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [submitting, setSubmitting] = (0, $eJOHy.useState)(false);
    const handleOnSubmit = async (event)=>{
        event.preventDefault();
        if (!submitting) {
            setSubmitting(true);
            if (isErrorReport) await onSubmit({
                feedbackText: '',
                sharePrompt: true,
                contactConsentPrompt: false,
                researchConsentPrompt: false
            }, isPositive);
            else {
                const data = new FormData(event.currentTarget);
                const feedbackText = data.get($a4cb633294b0446f$var$FEEDBACK_TEXT_FIELD)?.toString() ?? '';
                const sharePrompt = data.get($a4cb633294b0446f$var$SHARE_PROMPT_CHECKBOX) === $a4cb633294b0446f$var$SHARE_PROMPT_CHECKBOX;
                const contactConsentPrompt = data.get($a4cb633294b0446f$var$CONTACT_CONSENT_PROMPT_CHECKBOX) === $a4cb633294b0446f$var$CONTACT_CONSENT_PROMPT_CHECKBOX;
                const researchConsentPrompt = data.get($a4cb633294b0446f$var$RESEARCH_CONSENT_PROMT_CHECKBOX) === $a4cb633294b0446f$var$RESEARCH_CONSENT_PROMT_CHECKBOX;
                await onSubmit({
                    feedbackText: feedbackText,
                    sharePrompt: sharePrompt,
                    contactConsentPrompt: contactConsentPrompt,
                    researchConsentPrompt: researchConsentPrompt
                }, isPositive);
            }
            setSubmitting(false);
            onClose();
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        padding: "space.300",
        xcss: $a4cb633294b0446f$var$containerStyles,
        testId: "atlassian-intelligence.common.ui.feedback-button.feedback-popup-content.feedback-popup"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("form", {
        onSubmit: handleOnSubmit
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "medium"
    }, formatMessage((0, $lHJTm.default).heading)), !isErrorReport && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        "aria-label": formatMessage((0, $lHJTm.default).close),
        appearance: "subtle",
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6J9k6))), {
            LEGACY_size: "medium",
            spacing: "spacious",
            label: formatMessage((0, $lHJTm.default).close)
        }),
        onClick: onClose,
        testId: "atlassian-intelligence.common.ui.feedback-button.feedback-popup-content.close-button"
    }))), isErrorReport ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), null, formatMessage((0, $lHJTm.default).errorReportDescription)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        paddingBlockEnd: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "xxsmall",
        as: "div"
    }, formatMessage((0, $lHJTm.default).textAreaHeader))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $a4cb633294b0446f$var$textAreaContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dQmi3.default), {
        name: $a4cb633294b0446f$var$FEEDBACK_TEXT_FIELD,
        appearance: "none",
        minimumRows: $a4cb633294b0446f$var$MIN_TEXTAREA_ROWS,
        maxHeight: $a4cb633294b0446f$var$MAX_TEXTAREA_HEIGHT // This keeps the text area at a constant height alongside min rows
        ,
        "aria-label": formatMessage((0, $lHJTm.default).textAreaHeader),
        testId: "atlassian-intelligence.common.ui.feedback-button.feedback-popup-content.text-area",
        ref: setInitialFocusRef
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86tBw.default), {
        name: $a4cb633294b0446f$var$SHARE_PROMPT_CHECKBOX,
        value: $a4cb633294b0446f$var$SHARE_PROMPT_CHECKBOX,
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
            size: "medium",
            color: "color.text.subtle"
        }, formatMessage((0, $lHJTm.default).shareQueryPromptJnlis612)),
        testId: "atlassian-intelligence.common.ui.feedback-button.feedback-popup-content.share-prompt-checkbox"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86tBw.default), {
        name: $a4cb633294b0446f$var$CONTACT_CONSENT_PROMPT_CHECKBOX,
        value: $a4cb633294b0446f$var$CONTACT_CONSENT_PROMPT_CHECKBOX,
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
            size: "medium",
            color: "color.text.subtle"
        }, formatMessage((0, $lHJTm.default).contactConsentPromptJnlis612, {
            link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
                    href: "https://www.atlassian.com/legal/privacy-policy#what-this-policy-covers",
                    target: "_blank"
                }, chunks)
        })),
        testId: "atlassian-intelligence.common.ui.feedback-button.feedback-popup-content.contact-consent-prompt-checkbox"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86tBw.default), {
        name: $a4cb633294b0446f$var$RESEARCH_CONSENT_PROMT_CHECKBOX,
        value: $a4cb633294b0446f$var$RESEARCH_CONSENT_PROMT_CHECKBOX,
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
            size: "medium",
            color: "color.text.subtle"
        }, formatMessage((0, $lHJTm.default).researchConsentPromptJnlis612)),
        testId: "atlassian-intelligence.common.ui.feedback-button.feedback-popup-content.research-consent-prompt-checkbox"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        space: "space.100",
        alignInline: "end"
    }, isErrorReport && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "subtle",
        type: "button",
        onClick: onClose
    }, formatMessage((0, $lHJTm.default).cancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cA0Y2.default), {
        type: "submit",
        appearance: "primary",
        isLoading: submitting,
        testId: "atlassian-intelligence.common.ui.feedback-button.feedback-popup-content.submit-button"
    }, formatMessage(isErrorReport ? (0, $lHJTm.default).shareQuery : (0, $lHJTm.default).sendFeedback))))));
};
const $a4cb633294b0446f$var$containerStyles = (0, $1DXK0.xcss)({
    width: '448px',
    borderRadius: 'border.radius'
});
const $a4cb633294b0446f$var$textAreaContainerStyles = (0, $1DXK0.xcss)({
    backgroundColor: 'color.background.input',
    borderRadius: 'border.radius.100',
    padding: 'space.075',
    border: `2px solid ${"var(--ds-border-input, #8590A2)"}`,
    marginBottom: 'space.200'
});

});
parcelRegister("lHJTm", function(module, exports) {

$parcel$export(module.exports, "default", () => $723744ee9dea309b$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $723744ee9dea309b$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    errorReportDescription: {
        "id": "atlassian-intelligence.common.feedback-button.feedback-popup-content.error-report-description",
        "defaultMessage": "Share your query to help us improve search results."
    },
    shareQuery: {
        "id": "atlassian-intelligence.common.feedback-button.feedback-popup-content.share-query",
        "defaultMessage": "Share Query"
    },
    cancel: {
        "id": "atlassian-intelligence.common.feedback-button.feedback-popup-content.cancel",
        "defaultMessage": "Cancel"
    },
    heading: {
        "id": "atlassian-intelligence.prompt-response.feedback.feedback-popup-content.heading",
        "defaultMessage": "Help us improve Atlassian Intelligence"
    },
    close: {
        "id": "atlassian-intelligence.prompt-response.feedback.feedback-popup-content.close",
        "defaultMessage": "Close"
    },
    sendFeedback: {
        "id": "atlassian-intelligence.prompt-response.feedback.feedback-popup-content.send-feedback",
        "defaultMessage": "Send feedback"
    },
    contactConsentPrompt: {
        "id": "atlassian-intelligence.prompt-response.feedback.feedback-popup-content.contact-consent-prompt",
        "defaultMessage": "Yes, Atlassian teams can contact me to learn about my experiences to improve Atlassian products and services. I acknowledge the <link>Atlassian Privacy Policy</link>."
    },
    researchConsentPrompt: {
        "id": "atlassian-intelligence.prompt-response.feedback.feedback-popup-content.research-consent-prompt",
        "defaultMessage": "I'd like to participate in product research."
    },
    textAreaHeader: {
        "id": "atlassian-intelligence.prompt-response.feedback.feedback-popup-content.text-area-header",
        "defaultMessage": "How was your search experience?"
    },
    shareQueryPromptJnlis612: {
        "id": "atlassian-intelligence.prompt-response.feedback.feedback-popup-content.share-query-prompt-jnlis-612",
        "defaultMessage": "Include my search query and response in my feedback"
    },
    contactConsentPromptJnlis612: {
        "id": "atlassian-intelligence.prompt-response.feedback.feedback-popup-content.contact-consent-prompt-jnlis-612",
        "defaultMessage": "Atlassian can contact me to learn more about this feedback and I acknowledge the <link>Atlassian Privacy Policy</link>"
    },
    researchConsentPromptJnlis612: {
        "id": "atlassian-intelligence.prompt-response.feedback.feedback-popup-content.research-consent-prompt-jnlis-612",
        "defaultMessage": "I want to participate in Atlassian\u2019s product research"
    }
});

});



parcelRegister("6rjNT", function(module, exports) {

$parcel$export(module.exports, "default", () => $238f2c49dac268f0$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $238f2c49dac268f0$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    feedbackSentLozenge: {
        "id": "atlassian-intelligence.common.feedback-form.feedback-sent-lozenge",
        "defaultMessage": "Feedback Sent"
    },
    feedbackIconLabel: {
        "id": "atlassian-intelligence.common.feedback-form.feedback-icon-label",
        "defaultMessage": "Feedback Icon"
    },
    tooltipLike: {
        "id": "atlassian-intelligence.common.feedback-form.tooltip-like",
        "defaultMessage": "Good response"
    },
    tooltipDislike: {
        "id": "atlassian-intelligence.common.feedback-form.tooltip-dislike",
        "defaultMessage": "Bad response"
    }
});

});


parcelRegister("6sksU", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a3ea9d4b9ad7936$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $3a3ea9d4b9ad7936$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    betaLozenge: {
        "id": "atlassian-intelligence.common.ai-footer.beta-lozenge",
        "defaultMessage": "Beta"
    },
    disclaimerText: {
        "id": "atlassian-intelligence.common.ai-footer.disclaimer-text",
        "defaultMessage": "Uses AI. Verify results."
    },
    infoIconLabel: {
        "id": "atlassian-intelligence.common.ai-footer.info-icon-label",
        "defaultMessage": "Info"
    },
    aiIconLabel: {
        "id": "atlassian-intelligence.common.ai-footer.ai-icon-label",
        "defaultMessage": "Atlassian Intelligence"
    }
});

});


parcelRegister("htSaL", function(module, exports) {

$parcel$export(module.exports, "StreamingStatusBar", () => $c4878b1d2ed0ac2c$export$1106508d35fcb0ff);

var $eJOHy = parcelRequire("eJOHy");

var $lmgo6 = parcelRequire("lmgo6");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $7N3v2 = parcelRequire("7N3v2");

var $9nb91 = parcelRequire("9nb91");
const $c4878b1d2ed0ac2c$export$1106508d35fcb0ff = ({ hasPadding: hasPadding = true })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        xcss: [
            $c4878b1d2ed0ac2c$var$baseContainerStyle,
            hasPadding ? $c4878b1d2ed0ac2c$var$withPaddingStyle : $c4878b1d2ed0ac2c$var$noPaddingStyle
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7N3v2.GeneratingAnimation), {
        alt: formatMessage((0, $9nb91.default).generatingSuggestions)
    }));
};
const $c4878b1d2ed0ac2c$var$baseContainerStyle = (0, $1DXK0.xcss)({
    alignItems: 'center',
    paddingBlockStart: 'space.150',
    paddingBlockEnd: 'space.150',
    gap: 'space.100'
});
const $c4878b1d2ed0ac2c$var$withPaddingStyle = (0, $1DXK0.xcss)({
    paddingInline: 'space.150'
});
const $c4878b1d2ed0ac2c$var$noPaddingStyle = (0, $1DXK0.xcss)({
    paddingInline: 'space.0'
});

});
parcelRegister("7N3v2", function(module, exports) {

$parcel$export(module.exports, "GeneratingAnimation", () => $6a74eeaec3ac5d78$export$483f53d5a0354a30);

var $eJOHy = parcelRequire("eJOHy");
const $6a74eeaec3ac5d78$export$483f53d5a0354a30 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("title", null, props.alt), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("circle", {
        cx: "5.5",
        cy: "12.5",
        r: "1.5",
        fill: "#0C66E4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("animate", {
        attributeName: "cy",
        values: "11;13;13;13;13;13;13;11",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0s"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("circle", {
        cx: "11.5",
        cy: "10.5",
        r: "1.5",
        fill: "#1D7AFC"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("animate", {
        attributeName: "cy",
        values: "11;13;13;13;13;13;13;11",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0.2s"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("circle", {
        cx: "17.5",
        cy: "12.5",
        r: "1.5",
        fill: "#388BFF"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("animate", {
        attributeName: "cy",
        values: "11;13;13;13;13;13;13;11",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0.4s"
    })));

});

parcelRegister("9nb91", function(module, exports) {

$parcel$export(module.exports, "default", () => $2785214a849e9303$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $2785214a849e9303$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    generatingSuggestions: {
        "id": "proactive-container.streaming-status-bar.generating-suggestions",
        "defaultMessage": "Generating suggestions"
    }
});

});


parcelRegister("204HS", function(module, exports) {

$parcel$export(module.exports, "ToggleButtonContent", () => $76c3508188e8a4ff$export$8878b5170ddcf552);

var $eJOHy = parcelRequire("eJOHy");

var $2sLVw = parcelRequire("2sLVw");
var $3cMgR = parcelRequire("3cMgR");

var $7jTnu = parcelRequire("7jTnu");

var $9SUlM = parcelRequire("9SUlM");
const $76c3508188e8a4ff$export$8878b5170ddcf552 = ({ shouldDisplay: shouldDisplay, resultNumber: resultNumber, formatMessage: formatMessage, messages: customMessages, currentStep: currentStep, invokedFrom: invokedFrom })=>{
    if (!shouldDisplay) {
        if (currentStep === 'INACTIVE') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
            weight: "medium",
            color: "color.text.subtle"
        }, formatMessage(customMessages?.inactiveMessage || (0, $9SUlM.default).inactiveMessage));
        if (!resultNumber || resultNumber === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
            weight: "medium",
            color: "color.text"
        }, formatMessage(customMessages.noItemsMessage));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sLVw.default), {
            alignItems: "center",
            gap: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
            weight: "medium",
            color: "color.text"
        }, invokedFrom === 'globalIssueCreate' && (0, $7jTnu.fg)('similar_items_in_gic_ui_fixes') ? resultNumber : formatMessage(customMessages?.viewItemsMessage || (0, $9SUlM.default).showNumResults, {
            numResults: resultNumber
        })));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        weight: "medium",
        color: "color.text"
    }, formatMessage(customMessages?.hideSuggestionsMessage || (0, $9SUlM.default).hideSuggestions));
};

});
parcelRegister("9SUlM", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f77f9a3cde5b9df$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $2f77f9a3cde5b9df$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    workItemsFound: {
        "id": "proactive-container.work-items-found",
        "defaultMessage": "{itemCount} items found"
    },
    beta: {
        "id": "proactive-container.beta",
        "defaultMessage": "BETA"
    },
    findingResults: {
        "id": "proactive-container.finding-results",
        "defaultMessage": "Finding results"
    },
    viewItems: {
        "id": "proactive-container.view-items",
        "defaultMessage": "View items"
    },
    hideSuggestions: {
        "id": "proactive-container.hide-suggestions",
        "defaultMessage": "Hide suggestions"
    },
    showNumResults: {
        "id": "proactive-container.show-results",
        "defaultMessage": "Show {numResults} {numResults, plural, one {result} other {results}}"
    },
    inactiveMessage: {
        "id": "proactive-container.inactive-message",
        "defaultMessage": "Search"
    },
    noResultsFound: {
        "id": "proactive-container.no-results-found",
        "defaultMessage": "No results found."
    },
    anErrorOccurred: {
        "id": "proactive-container.an-error-occurred",
        "defaultMessage": "An error occurred."
    },
    viewError: {
        "id": "proactive-container.view-error",
        "defaultMessage": "View error"
    },
    searchAgain: {
        "id": "proactive-container.search-again",
        "defaultMessage": "Search again"
    },
    hideError: {
        "id": "proactive-container.hide-error",
        "defaultMessage": "Hide error"
    }
});

});



parcelRegister("4R60r", function(module, exports) {

$parcel$export(module.exports, "steps", () => $7bca36eae661ec22$export$be3f796aed065412);
$parcel$export(module.exports, "JiraIssueRelatedIssuesContainer", () => $7bca36eae661ec22$export$ee022e97c9216071);
$parcel$export(module.exports, "useRelatedIssues", () => $7bca36eae661ec22$export$4237711b1720e25d);
$parcel$export(module.exports, "useRelatedIssuesState", () => $7bca36eae661ec22$export$1bcc91a46b52e814);
$parcel$export(module.exports, "useRelatedIssuesActions", () => $7bca36eae661ec22$export$9984c5e392ed1042);

var $epTsa = parcelRequire("epTsa");

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");
const $7bca36eae661ec22$export$be3f796aed065412 = {
    fetching: 'FETCHING',
    display: 'DISPLAY',
    loaded: 'LOADED'
};
const $7bca36eae661ec22$var$initialState = {
    currentStep: $7bca36eae661ec22$export$be3f796aed065412.fetching,
    resourceSuggestions: undefined,
    isLinkedIssuePanelButtonTriggered: false,
    errorMessage: null,
    invokedFrom: null
};
const $7bca36eae661ec22$var$setRelatedIssuesStep = (step)=>({ setState: setState })=>{
        setState({
            currentStep: step
        });
    };
const $7bca36eae661ec22$var$setInvokedFrom = (invokedFrom)=>({ setState: setState })=>{
        setState({
            invokedFrom: invokedFrom
        });
    };
const $7bca36eae661ec22$var$setRelatedIssuesFetchStep = ()=>({ getState: getState, setState: setState })=>{
        const { displayLinkedIssuesPanelCallback: displayLinkedIssuesPanelCallback } = getState();
        displayLinkedIssuesPanelCallback?.(true);
        setState({
            currentStep: $7bca36eae661ec22$export$be3f796aed065412.fetching
        });
    };
const $7bca36eae661ec22$var$setRelatedIssuesDisplayStep = ()=>({ setState: setState })=>{
        setState({
            currentStep: $7bca36eae661ec22$export$be3f796aed065412.display
        });
    };
const $7bca36eae661ec22$var$setRelatedIssuesLoadedStep = ()=>({ setState: setState })=>{
        setState({
            currentStep: $7bca36eae661ec22$export$be3f796aed065412.loaded
        });
    };
const $7bca36eae661ec22$var$setIsLinkedIssuePanelButtonTriggered = (linkedIssuePanel)=>({ setState: setState })=>{
        setState({
            isLinkedIssuePanelButtonTriggered: linkedIssuePanel
        });
    };
const $7bca36eae661ec22$var$setResourceSuggestion = (resources)=>({ setState: setState })=>{
        const resourceSuggestions = resources.map((resource)=>({
                resource: resource,
                resourceStatus: (0, $epTsa.expVal)('jira-ai-similar-issues-selectable-draft-list', 'isEnabled', false) ? 'SELECTED' : 'DRAFT'
            }));
        setState({
            resourceSuggestions: resourceSuggestions,
            currentStep: $7bca36eae661ec22$export$be3f796aed065412.loaded
        });
    };
const $7bca36eae661ec22$var$acceptSelectedSuggestions = ()=>({ setState: setState, getState: getState })=>{
        const { resourceSuggestions: resourceSuggestions } = getState();
        let allSelectedUpdated = true;
        const updatedSuggestions = resourceSuggestions?.map((resourceSuggestion)=>{
            if (resourceSuggestion.resourceStatus === 'SELECTED') // No need to && true since it doesn't affect the value
            return {
                ...resourceSuggestion,
                resourceStatus: 'ACCEPTED'
            };
            allSelectedUpdated = false;
            return resourceSuggestion;
        });
        setState({
            resourceSuggestions: updatedSuggestions,
            ...allSelectedUpdated && {
                currentStep: $7bca36eae661ec22$export$be3f796aed065412.loaded
            }
        });
    };
const $7bca36eae661ec22$var$setResourceSuggestionStatus = (suggestion, status)=>({ setState: setState, getState: getState })=>{
        const { resourceSuggestions: resourceSuggestions } = getState();
        const updatedSuggestions = resourceSuggestions?.map((resourceSuggestion)=>{
            if (resourceSuggestion.resource.id === suggestion.id) return {
                ...resourceSuggestion,
                resourceStatus: status
            };
            return resourceSuggestion;
        });
        setState({
            resourceSuggestions: updatedSuggestions
        });
    };
const $7bca36eae661ec22$var$setErrorMessage = (message)=>({ setState: setState })=>{
        setState({
            errorMessage: message,
            currentStep: $7bca36eae661ec22$export$be3f796aed065412.loaded
        });
    };
const $7bca36eae661ec22$var$acceptSuggestion = (suggestion)=>({ setState: setState, getState: getState })=>{
        const { resourceSuggestions: resourceSuggestions } = getState();
        const updatedSuggestions = resourceSuggestions?.map((resourceSuggestion)=>{
            if (resourceSuggestion.resource.id === suggestion.id) return {
                ...resourceSuggestion,
                resourceStatus: 'ACCEPTED'
            };
            return resourceSuggestion;
        });
        setState({
            resourceSuggestions: updatedSuggestions
        });
    };
const $7bca36eae661ec22$var$acceptAllSuggestions = ()=>({ setState: setState, getState: getState })=>{
        const { resourceSuggestions: resourceSuggestions, displayLinkedIssuesPanelCallback: displayLinkedIssuesPanelCallback } = getState();
        const updatedSuggestions = resourceSuggestions?.map((resourceSuggestion)=>{
            return {
                ...resourceSuggestion,
                resourceStatus: 'ACCEPTED'
            };
        });
        displayLinkedIssuesPanelCallback?.(false);
        setState({
            resourceSuggestions: updatedSuggestions,
            currentStep: $7bca36eae661ec22$export$be3f796aed065412.loaded
        });
    };
const $7bca36eae661ec22$var$discardSuggestion = (suggestion)=>({ setState: setState, getState: getState })=>{
        const { resourceSuggestions: resourceSuggestions } = getState();
        const updatedSuggestions = resourceSuggestions?.map((resourceSuggestion)=>{
            if (resourceSuggestion.resource.id === suggestion.id) return {
                ...resourceSuggestion,
                resourceStatus: 'DISCARDED'
            };
            return resourceSuggestion;
        });
        setState({
            resourceSuggestions: updatedSuggestions
        });
    };
const $7bca36eae661ec22$var$discardAllSuggestions = ()=>({ getState: getState, setState: setState })=>{
        const { displayLinkedIssuesPanelCallback: displayLinkedIssuesPanelCallback } = getState();
        displayLinkedIssuesPanelCallback?.(false);
        setState({
            currentStep: $7bca36eae661ec22$export$be3f796aed065412.loaded,
            resourceSuggestions: undefined
        });
    };
const $7bca36eae661ec22$var$resetState = ()=>({ getState: getState, setState: setState })=>{
        const { displayLinkedIssuesPanelCallback: displayLinkedIssuesPanelCallback } = getState();
        displayLinkedIssuesPanelCallback?.(false);
        setState($7bca36eae661ec22$var$initialState);
    };
const $7bca36eae661ec22$var$setDisplayLinkedIssuesPanelCallback = (cb)=>({ setState: setState })=>{
        setState({
            displayLinkedIssuesPanelCallback: cb
        });
    };
const $7bca36eae661ec22$var$actions = {
    acceptSuggestion: $7bca36eae661ec22$var$acceptSuggestion,
    acceptAllSuggestions: $7bca36eae661ec22$var$acceptAllSuggestions,
    discardSuggestion: $7bca36eae661ec22$var$discardSuggestion,
    discardAllSuggestions: $7bca36eae661ec22$var$discardAllSuggestions,
    setRelatedIssuesStep: $7bca36eae661ec22$var$setRelatedIssuesStep,
    setRelatedIssuesFetchStep: $7bca36eae661ec22$var$setRelatedIssuesFetchStep,
    setRelatedIssuesLoadedStep: $7bca36eae661ec22$var$setRelatedIssuesLoadedStep,
    setIsLinkedIssuePanelButtonTriggered: $7bca36eae661ec22$var$setIsLinkedIssuePanelButtonTriggered,
    resetState: $7bca36eae661ec22$var$resetState,
    setResourceSuggestion: $7bca36eae661ec22$var$setResourceSuggestion,
    setInvokedFrom: $7bca36eae661ec22$var$setInvokedFrom,
    setErrorMessage: $7bca36eae661ec22$var$setErrorMessage,
    setRelatedIssuesDisplayStep: $7bca36eae661ec22$var$setRelatedIssuesDisplayStep,
    setDisplayLinkedIssuesPanelCallback: $7bca36eae661ec22$var$setDisplayLinkedIssuesPanelCallback,
    setResourceSuggestionStatus: $7bca36eae661ec22$var$setResourceSuggestionStatus,
    acceptSelectedSuggestions: $7bca36eae661ec22$var$acceptSelectedSuggestions
};
const $7bca36eae661ec22$export$ee022e97c9216071 = (0, $6E16M.createContainer)();
const $7bca36eae661ec22$export$390f32400eaf98c9 = (0, $GtRbT.createStore)({
    initialState: $7bca36eae661ec22$var$initialState,
    actions: $7bca36eae661ec22$var$actions,
    name: 'jira-ai-related-issues',
    containedBy: $7bca36eae661ec22$export$ee022e97c9216071
});
const $7bca36eae661ec22$export$228b8fc1a8f4fa98 = (0, $6E16M.createContainer)($7bca36eae661ec22$export$390f32400eaf98c9, {
    onInit: ()=>({ setState: setState }, mockedState)=>setState(mockedState)
});
const $7bca36eae661ec22$export$4237711b1720e25d = (0, $iJq0l.createHook)($7bca36eae661ec22$export$390f32400eaf98c9);
const $7bca36eae661ec22$export$1bcc91a46b52e814 = (0, $iJq0l.createStateHook)($7bca36eae661ec22$export$390f32400eaf98c9);
const $7bca36eae661ec22$export$9984c5e392ed1042 = (0, $iJq0l.createActionsHook)($7bca36eae661ec22$export$390f32400eaf98c9);

});

parcelRegister("czOOQ", function(module, exports) {

$parcel$export(module.exports, "useFetchRelatedIssue", () => $83f572a2a0b188ba$export$f772b6e9269bd807);

var $eJOHy = parcelRequire("eJOHy");

var $jGzN3 = parcelRequire("jGzN3");

var $bmoS1 = parcelRequire("bmoS1");

var $eaTQ3 = parcelRequire("eaTQ3");

var $bNexr = parcelRequire("bNexr");


var $hOcoS = parcelRequire("hOcoS");

var $7jTnu = parcelRequire("7jTnu");
const $83f572a2a0b188ba$var$RELATED_ISSUES_API = '/gateway/api/assist/ai/v2/ai-feature/jirasimilarissues';
const $83f572a2a0b188ba$var$DEFAULT_MIN_SIM_SCORE = 0.5;
const $83f572a2a0b188ba$export$4c0e6fff2d4abe18 = (input)=>{
    return input?.ai_feature_output?.issues?.map((issue)=>({
            id: issue.issue_id,
            issueKey: issue.issue_key,
            issueLink: issue.issue_link,
            issueTypeIconUrl: issue.issue_type_icon_url,
            issueSummary: issue.issue_summary
        }));
};
const $83f572a2a0b188ba$export$f772b6e9269bd807 = (existingIssues)=>{
    const issueKey = (0, $bmoS1.useIssueKey)();
    const projectKey = (0, $bNexr.useProjectKey)(issueKey);
    const projectId = (0, $bNexr.useProjectId)(projectKey);
    const issueId = (0, $bmoS1.useIssueId)();
    const [descriptionValue] = (0, $eaTQ3.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $c78d361852e02509$export$d5bc879e3b748593)
    });
    const [summaryValue] = (0, $eaTQ3.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $c78d361852e02509$export$e7cf1830fe735d1f)
    });
    const [state, setState] = (0, $eJOHy.useState)({
        data: undefined,
        error: undefined,
        loading: false
    });
    const fetchSuggestion = (0, $eJOHy.useCallback)(async (searchPayload)=>{
        const payload = {
            ai_feature_input: {
                issue_key: issueKey,
                ...(0, $7jTnu.fg)('adding-issue-id-to-similar-issues-request') && {
                    issue_id: issueId
                },
                issue_summary: summaryValue,
                issue_description: (0, $hOcoS.convertAdfToText)(descriptionValue),
                project_id: projectId,
                existing_issues: existingIssues
            }
        };
        if (searchPayload) payload.ai_feature_input = {
            ...payload.ai_feature_input,
            issue_summary: searchPayload.issue_summary,
            issue_description: (0, $hOcoS.convertAdfToText)(searchPayload.issue_description),
            project_id: searchPayload.project_id,
            // issue_id and issue_key won't be available at the time of issue creation.
            // the similar issue api always expects issue_key so setting it to empty string
            issue_id: '',
            issue_key: '',
            minimum_sim_score: $83f572a2a0b188ba$var$DEFAULT_MIN_SIM_SCORE
        };
        try {
            setState({
                error: undefined,
                data: undefined,
                loading: true
            });
            const result = await (0, $jGzN3.performPostRequest)($83f572a2a0b188ba$var$RELATED_ISSUES_API, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-Product': 'jira',
                    'X-Experience-Id': 'jira-similar-issues'
                },
                body: JSON.stringify(payload)
            });
            setState({
                error: undefined,
                data: $83f572a2a0b188ba$export$4c0e6fff2d4abe18(result),
                loading: false
            });
            return result;
        } catch (error) {
            setState({
                error: error,
                data: undefined,
                loading: false
            });
            return undefined;
        }
    }, [
        descriptionValue,
        existingIssues,
        issueKey,
        issueId,
        projectId,
        summaryValue
    ]);
    return {
        data: state.data,
        error: state.error,
        loading: state.loading,
        fetchSuggestion: fetchSuggestion
    };
};

});
parcelRegister("eaTQ3", function(module, exports) {

$parcel$export(module.exports, "useFieldValue", () => $626f51b4fb1f2379$export$b79fae7fbe3ac392);
$parcel$export(module.exports, "useFieldsValues", () => $626f51b4fb1f2379$export$25b73e671fe7a8fa);
$parcel$export(module.exports, "useMultiFieldValuesForIssues", () => $626f51b4fb1f2379$export$915cdeec521b54f7);
$parcel$export(module.exports, "FieldValueSubscriber", () => $626f51b4fb1f2379$export$4e5f1f4ed08d155e);
$parcel$export(module.exports, "useFieldsValuesActions", () => $626f51b4fb1f2379$export$612d9bcb0c9d8976);

var $eJOHy = parcelRequire("eJOHy");

var $1O6Yz = parcelRequire("1O6Yz");

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
var $ht3nQ = parcelRequire("ht3nQ");
const $626f51b4fb1f2379$var$setIssue = (issueKey, fields)=>({ setState: setState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: fields
        });
    };
const $626f51b4fb1f2379$var$setIssues = (issues)=>({ setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newIssues = {};
        issues.forEach((issue)=>{
            Object.assign(newIssues, issue);
        });
        setState(newIssues);
    };
const $626f51b4fb1f2379$var$setFieldValue = (issueKey, fieldKey, value)=>({ setState: setState, getState: getState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: {
                ...getState()[issueKey],
                [fieldKey]: value
            }
        });
    };
const $626f51b4fb1f2379$var$getFieldValue = (issueKey, fieldKey)=>({ getState: getState })=>{
        const issueFieldValues = getState()[issueKey];
        return issueFieldValues && issueFieldValues[fieldKey];
    };
const $626f51b4fb1f2379$var$mergeIssue = (issueKey, fields)=>({ setState: setState, getState: getState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: (0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))({}, getState()[issueKey], fields)
        });
    };
const $626f51b4fb1f2379$export$11aa02e14fdf7753 = (issues)=>({ setState: setState, getState: getState })=>{
        if (issues.length === 0) return;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newIssues = {};
        issues.forEach((issue)=>{
            Object.assign(newIssues, issue);
        });
        setState((0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))({}, getState(), newIssues));
    };
const $626f51b4fb1f2379$var$actions = {
    setFieldValue: $626f51b4fb1f2379$var$setFieldValue,
    getFieldValue: $626f51b4fb1f2379$var$getFieldValue,
    setIssue: $626f51b4fb1f2379$var$setIssue,
    mergeIssue: $626f51b4fb1f2379$var$mergeIssue,
    setIssues: $626f51b4fb1f2379$var$setIssues,
    mergeIssues: $626f51b4fb1f2379$export$11aa02e14fdf7753
};
// this is a global store
const $626f51b4fb1f2379$var$store = (0, $GtRbT.createStore)({
    name: 'issue-fields',
    initialState: {},
    actions: $626f51b4fb1f2379$var$actions
});
const $626f51b4fb1f2379$var$getFieldValueSelector = (state, { issueKey: issueKey, fieldKey: fieldKey })=>{
    const issueFieldValues = state[issueKey];
    return issueFieldValues && issueFieldValues[fieldKey];
};
const $626f51b4fb1f2379$var$getFieldValuesForIssuesSelector = (state, { issueKeys: issueKeys, fieldKey: fieldKey })=>(issueKeys || []).map((issueKey)=>$626f51b4fb1f2379$var$getFieldValueSelector(state, {
            fieldKey: fieldKey,
            issueKey: issueKey
        }));
const $626f51b4fb1f2379$var$getMultiFieldValuesForIssuesSelector = (state, { issueKeys: issueKeys, fieldKeys: fieldKeys })=>(issueKeys || []).reduce((accumulator, issueKey)=>{
        if (!state[issueKey]) return accumulator;
        const fieldValue = fieldKeys.reduce((acc, fieldKey)=>{
            acc[fieldKey] = $626f51b4fb1f2379$var$getFieldValueSelector(state, {
                fieldKey: fieldKey,
                issueKey: issueKey
            });
            return acc;
        }, {});
        accumulator[issueKey] = fieldValue;
        return accumulator;
    }, {});
const $626f51b4fb1f2379$var$getAllFields = (state, issueKey)=>state[issueKey];
const $626f51b4fb1f2379$export$b79fae7fbe3ac392 = (0, $iJq0l.createHook)($626f51b4fb1f2379$var$store, {
    selector: $626f51b4fb1f2379$var$getFieldValueSelector
});
const $626f51b4fb1f2379$export$25b73e671fe7a8fa = (0, $iJq0l.createHook)($626f51b4fb1f2379$var$store, {
    selector: $626f51b4fb1f2379$var$getAllFields
});
const $626f51b4fb1f2379$export$ac289b84121829df = (0, $iJq0l.createHook)($626f51b4fb1f2379$var$store, {
    selector: $626f51b4fb1f2379$var$getFieldValuesForIssuesSelector
});
const $626f51b4fb1f2379$export$915cdeec521b54f7 = (0, $iJq0l.createHook)($626f51b4fb1f2379$var$store, {
    selector: $626f51b4fb1f2379$var$getMultiFieldValuesForIssuesSelector
});
const $626f51b4fb1f2379$export$4e5f1f4ed08d155e = (0, $ht3nQ.createSubscriber)($626f51b4fb1f2379$var$store, {
    selector: $626f51b4fb1f2379$var$getFieldValueSelector
});
const $626f51b4fb1f2379$var$useFieldValueStoreActions = (0, $iJq0l.createHook)($626f51b4fb1f2379$var$store, {
    selector: null
});
const $626f51b4fb1f2379$export$612d9bcb0c9d8976 = ()=>{
    const [, fieldValueStoreActions] = $626f51b4fb1f2379$var$useFieldValueStoreActions();
    const fieldsValuesActions = (0, $eJOHy.useMemo)(()=>{
        const setIssueAction = (issueKey, fields)=>fieldValueStoreActions.setIssue(issueKey, fields);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const setFieldValueAction = (issueKey, fieldKey, value)=>fieldValueStoreActions.setFieldValue(issueKey, fieldKey, value);
        const getFieldValueAction = (issueKey, fieldKey)=>fieldValueStoreActions.getFieldValue(issueKey, fieldKey);
        const mergeIssueAction = (issueKey, fields)=>fieldValueStoreActions.mergeIssue(issueKey, fields);
        const setIssuesAction = (issues)=>fieldValueStoreActions.setIssues(issues);
        const mergeIssuesAction = (issues)=>fieldValueStoreActions.mergeIssues(issues);
        return {
            setIssue: setIssueAction,
            setFieldValue: setFieldValueAction,
            getFieldValue: getFieldValueAction,
            mergeIssue: mergeIssueAction,
            setIssues: setIssuesAction,
            mergeIssues: mergeIssuesAction
        };
    }, [
        fieldValueStoreActions
    ]);
    return [
        null,
        fieldsValuesActions
    ];
};

});

const $c78d361852e02509$export$e18419056f3d184a = 'assignee';
const $c78d361852e02509$export$45cafdfd629c3ca1 = 'reporter';
const $c78d361852e02509$export$d5bc879e3b748593 = 'description';
const $c78d361852e02509$export$a68dbc90211df1a8 = 'fixVersions';
const $c78d361852e02509$export$93605f2a09aa8d26 = 'labels';
const $c78d361852e02509$export$4420b7468f889692 = 'status';
const $c78d361852e02509$export$e7cf1830fe735d1f = 'summary';
const $c78d361852e02509$export$5fbd3b15555b9ef2 = 'timeoriginalestimate';
const $c78d361852e02509$export$3fb78a14b7a56ff9 = 'timeestimate';
const $c78d361852e02509$export$a5fc282ab2bf9b89 = 'issuelinks';
const $c78d361852e02509$export$b52547457d714bc0 = 'epic-issues';
const $c78d361852e02509$export$3cca6e37a5823d5a = 'children-issues';
const $c78d361852e02509$export$98a935eb30de54ab = 'components';
const $c78d361852e02509$export$f7a17147527dd688 = 'flag';

parcelRegister("hOcoS", function(module, exports) {

$parcel$export(module.exports, "convertAdfToText", () => $c3163b825f5afaef$export$f36d973840b7febc);

var $8DB98 = parcelRequire("8DB98");

var $fjfmN = parcelRequire("fjfmN");

var $1LVxc = parcelRequire("1LVxc");
const $c3163b825f5afaef$var$serializer = (0, $1LVxc.default).fromSchema((0, $8DB98.defaultSchema));
const $c3163b825f5afaef$export$f36d973840b7febc = (doc)=>{
    if (!doc) return '';
    if (doc?.content?.length < 1) // renderer has a bug where empty adf returns null instead of empty string
    return '';
    const outputText = (0, $fjfmN.renderDocument)(doc, $c3163b825f5afaef$var$serializer, (0, $8DB98.defaultSchema)).result;
    return outputText;
};

});


parcelRegister("9tyru", function(module, exports) {

$parcel$export(module.exports, "ProactiveSimilarIssuesCollapsible", () => $116371780a9dd6d8$export$75174fcf49527d14);

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");

var $8nu6j = parcelRequire("8nu6j");
var $lmgo6 = parcelRequire("lmgo6");
var $3Wh6p = parcelRequire("3Wh6p");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $4cFYC = parcelRequire("4cFYC");

var $7q9BG = parcelRequire("7q9BG");

var $5CSKW = parcelRequire("5CSKW");

var $bQP4O = parcelRequire("bQP4O");

var $jdqdp = parcelRequire("jdqdp");

var $gn1zL = parcelRequire("gn1zL");

var $9skjA = parcelRequire("9skjA");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $1OHZM = parcelRequire("1OHZM");

var $1uIew = parcelRequire("1uIew");

var $7jTnu = parcelRequire("7jTnu");

var $epTsa = parcelRequire("epTsa");

var $gk8hn = parcelRequire("gk8hn");

var $4R60r = parcelRequire("4R60r");

var $czOOQ = parcelRequire("czOOQ");

var $8ZqIS = parcelRequire("8ZqIS");
/**
 * Content component for the toggle button that shows different states:
 * 1. No items found
 * 2. Error message
 * 3. View items with count
 * 4. Hide suggestions
 */ const $116371780a9dd6d8$var$ToggleButtonContent = ({ shouldDisplay: shouldDisplay, draftSuggestions: draftSuggestions, errorMessage: errorMessage, formatMessage: formatMessage })=>{
    if (!shouldDisplay) {
        if (errorMessage !== null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
            weight: "medium",
            color: "color.text.subtle"
        }, formatMessage((0, $8ZqIS.default).updateDescriptionAndRetry));
        if (!draftSuggestions || draftSuggestions.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
            weight: "medium",
            color: "color.text.subtle"
        }, formatMessage((0, $8ZqIS.default).noSimilarWorkItems));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
            alignItems: "center",
            gap: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
            weight: "medium",
            color: "color.text.subtle"
        }, formatMessage((0, $8ZqIS.default).viewItems)), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7q9BG.default), null, draftSuggestions.length));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        weight: "medium",
        color: "color.text.subtle"
    }, formatMessage((0, $8ZqIS.default).hideSuggestions));
};
const $116371780a9dd6d8$var$UNCATEGORISED_ERROR = 'UNKNOWN ERROR';
const $116371780a9dd6d8$export$75174fcf49527d14 = ({ children: children, existingIssues: existingIssues, customRelatedIssueSearchPayload: customRelatedIssueSearchPayload })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [{ currentStep: currentStep, resourceSuggestions: resourceSuggestions, errorMessage: errorMessage, invokedFrom: invokedFrom }, { setRelatedIssuesDisplayStep: setRelatedIssuesDisplayStep, setRelatedIssuesLoadedStep: setRelatedIssuesLoadedStep, discardAllSuggestions: discardAllSuggestions, setResourceSuggestion: setResourceSuggestion, setErrorMessage: setErrorMessage, setRelatedIssuesFetchStep: setRelatedIssuesFetchStep }] = (0, $4R60r.useRelatedIssues)();
    const { data: data, error: error, fetchSuggestion: fetchSuggestion } = (0, $czOOQ.useFetchRelatedIssue)(existingIssues);
    const isFetching = (0, $eJOHy.useMemo)(()=>currentStep === (0, $4R60r.steps).fetching, [
        currentStep
    ]);
    const shouldDisplay = (0, $eJOHy.useMemo)(()=>currentStep === (0, $4R60r.steps).display, [
        currentStep
    ]);
    const isLoaded = (0, $eJOHy.useMemo)(()=>currentStep === (0, $4R60r.steps).loaded, [
        currentStep
    ]);
    const [numOfSmartLinksToShow, setNumOfSmartLinksToShow] = (0, $eJOHy.useState)(0);
    /**
   * We use useResizeObserver to determine the width of the container and adjust the display of smart links
   */ const aiContainerRef = (0, $eJOHy.useRef)(null);
    const draftSuggestions = resourceSuggestions?.filter((suggestion)=>suggestion.resourceStatus === 'DRAFT');
    const isDisabled = isFetching || !draftSuggestions?.length || errorMessage !== null;
    const onDismissSuggestions = (0, $eJOHy.useCallback)(()=>{
        discardAllSuggestions();
    }, [
        discardAllSuggestions
    ]);
    const hasMounted = (0, $eJOHy.useRef)(false);
    const hasFiredInitiatedAnalytics = (0, $eJOHy.useRef)(false);
    const previousInvokedFromRef = (0, $eJOHy.useRef)(invokedFrom);
    const dismissRef = (0, $eJOHy.useRef)(onDismissSuggestions);
    const prevPayloadRef = (0, $eJOHy.useRef)();
    const aiResultViewedSummaryLengthAnalyticsRef = (0, $eJOHy.useRef)();
    // Keep the ref up to date with the latest callback
    (0, $eJOHy.useEffect)(()=>{
        dismissRef.current = onDismissSuggestions;
    }, [
        onDismissSuggestions
    ]);
    // Effect for cleanup only - using the ref allows us to avoid dependencies
    (0, $eJOHy.useEffect)(()=>{
        return ()=>{
            dismissRef.current();
            hasMounted.current = false;
            hasFiredInitiatedAnalytics.current = false;
        };
    }, []);
    // Effect for initialization only
    (0, $eJOHy.useEffect)(()=>{
        if (!hasMounted.current || !(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(prevPayloadRef.current, customRelatedIssueSearchPayload) && (0, $epTsa.expVal)('proactive_similar_work_items_in_gic_experiment', 'isEnabled', false)) {
            hasMounted.current = true;
            fetchSuggestion(customRelatedIssueSearchPayload);
            setRelatedIssuesFetchStep();
            if ((0, $epTsa.expVal)('proactive_similar_work_items_in_gic_experiment', 'isEnabled', false)) {
                prevPayloadRef.current = customRelatedIssueSearchPayload;
                aiResultViewedSummaryLengthAnalyticsRef.current = customRelatedIssueSearchPayload?.issue_summary;
            }
        }
    }, [
        fetchSuggestion,
        setRelatedIssuesFetchStep,
        customRelatedIssueSearchPayload
    ]);
    // Effect for tracking analytics when invokedFrom becomes available
    (0, $eJOHy.useEffect)(()=>{
        if (!hasFiredInitiatedAnalytics.current && invokedFrom !== null) {
            hasFiredInitiatedAnalytics.current = true;
            (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'aiInteraction initiated', {
                invokedFrom: invokedFrom,
                existingItemsCount: existingIssues.length
            });
        }
    }, [
        invokedFrom,
        existingIssues.length,
        createAnalyticsEvent
    ]);
    // Reset hasFiredInitiatedAnalytics when invokedFrom changes since its a new interaction initiated event
    (0, $eJOHy.useEffect)(()=>{
        if (previousInvokedFromRef.current !== invokedFrom) {
            hasFiredInitiatedAnalytics.current = false;
            previousInvokedFromRef.current = invokedFrom;
        }
    }, [
        invokedFrom
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (data) {
            if (errorMessage && (0, $7jTnu.fg)('proactive-collapsible-ai-related-issue-bug-fix')) setErrorMessage(null);
            setResourceSuggestion(data);
            setRelatedIssuesLoadedStep();
            if (invokedFrom === 'globalIssueCreate' && aiResultViewedSummaryLengthAnalyticsRef && aiResultViewedSummaryLengthAnalyticsRef.current && (0, $epTsa.expVal)('proactive_similar_work_items_in_gic_experiment', 'isEnabled', false)) (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'aiResult viewed', {
                // This event does not meet the MAU criteria since users are being served a proactive suggestion
                doesNotMeetMAUCriteria: true,
                aiSuggestedCount: data?.length,
                summaryLength: aiResultViewedSummaryLengthAnalyticsRef?.current?.length,
                invokedFrom: invokedFrom,
                smartCardClicked: 0,
                suggestionsExpanded: 0
            });
            else (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'aiResult viewed', {
                // This event does not meet the MAU criteria since users are being served a proactive suggestion
                doesNotMeetMAUCriteria: true,
                aiSuggestedCount: data?.length,
                smartCardClicked: 0,
                suggestionsExpanded: 0,
                invokedFrom: invokedFrom
            });
        } else if (error) {
            setErrorMessage(error);
            setRelatedIssuesLoadedStep();
            (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'aiResult error', 'aiRelatedIssuesSuggestionResultBox', {
                aiErrorCode: error instanceof (0, $1uIew.default) ? error.statusCode : $116371780a9dd6d8$var$UNCATEGORISED_ERROR,
                ...(0, $7jTnu.fg)('ai-error-message-similar-issues') ? {
                    aiErrorMessage: error instanceof (0, $1uIew.default) ? error.message : JSON.stringify(error)
                } : {}
            });
        }
    }, [
        setResourceSuggestion,
        setErrorMessage,
        data,
        error,
        createAnalyticsEvent,
        setRelatedIssuesLoadedStep,
        errorMessage,
        invokedFrom
    ]);
    /**
   * Event handler for the toggle button click
   * Since we use the same button for both the Pressable and the Button click, we need to stop the event propagation to not fire the event twice
   */ const onToggleClick = (0, $eJOHy.useCallback)((e)=>{
        if (currentStep === (0, $4R60r.steps).loaded) {
            setRelatedIssuesDisplayStep();
            (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'aiResult viewed', {
                // This event specfically meets the MAU criteria since users are proactively viewing suggestions
                doesNotMeetMAUCriteria: false,
                aiSuggestedCount: data?.length,
                smartCardClicked: 0,
                suggestionsExpanded: 1,
                invokedFrom: invokedFrom
            });
        } else if (currentStep === (0, $4R60r.steps).display) {
            setRelatedIssuesLoadedStep();
            (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'aiResult actioned', 'aiRelatedIssuesSuggestionResultBox', {
                aiResultAction: 'suggestionsHidden',
                aiItemsCount: data?.length
            });
        }
        e.stopPropagation();
    }, [
        currentStep,
        setRelatedIssuesDisplayStep,
        createAnalyticsEvent,
        data?.length,
        invokedFrom,
        setRelatedIssuesLoadedStep
    ]);
    /**
   * Static width calculated based on the manual checking of width of the lozenge and the width of Similar Items text + Icon
   * Card width is 192px since it aligns with 12 rem in styles below
   */ const onSmartLinksContainerResize = (0, $eJOHy.useCallback)(()=>{
        if (aiContainerRef.current) {
            const cardWidth = 192;
            const staticWidth = 330;
            const { offsetWidth: offsetWidth } = aiContainerRef.current;
            const availableWidth = offsetWidth - staticWidth;
            const numberOfCards = availableWidth >= cardWidth ? Math.floor(availableWidth / cardWidth) : 0;
            setNumOfSmartLinksToShow(numberOfCards);
        }
    }, []);
    const onSmartCardClick = (0, $eJOHy.useCallback)((issueLink)=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.open(issueLink, '_blank');
        (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'aiResult viewed', {
            doesNotMeetMAUCriteria: false,
            aiSuggestedCount: data?.length,
            smartCardClicked: 1,
            suggestionsExpanded: 0
        });
    }, [
        data,
        createAnalyticsEvent
    ]);
    (0, $eJOHy.useEffect)(()=>{
        onSmartLinksContainerResize();
    }, [
        onSmartLinksContainerResize
    ]);
    (0, $1OHZM.useResizeObserver)({
        ref: aiContainerRef,
        onResize: onSmartLinksContainerResize
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9skjA.default), {
        hasNewBorderExperience: true,
        shouldFitContainer: true,
        isShadow: false,
        isLoading: isFetching,
        spacing: "none",
        testId: "ai-related-issues.ui.proactive-collapsible-parent.ai-container",
        ref: aiContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bQP4O.default), {
        xcss: [
            $116371780a9dd6d8$var$pressableStyles,
            !isDisabled && $116371780a9dd6d8$var$pressableEnabledStyles
        ],
        backgroundColor: "color.background.neutral.subtle",
        onClick: (e)=>onToggleClick(e),
        isDisabled: isDisabled,
        testId: "ai-related-issues.ui.proactive-collapsible-parent.button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        space: "space.050",
        testId: "ai-related-issues.ui.proactive-collapsible-parent.inline",
        xcss: $116371780a9dd6d8$var$headerActionsContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "span",
        xcss: $116371780a9dd6d8$var$aiIconLabelStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gn1zL))), {
        label: formatMessage((0, $8ZqIS.default).similarWorkItems)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        maxLines: 1,
        color: "color.text.subtle"
    }, formatMessage((0, $8ZqIS.default).similarWorkItems)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
        appearance: "new"
    }, formatMessage((0, $8ZqIS.default).beta))), isFetching && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gk8hn.StreamingStatusBar), {
        message: formatMessage((0, $8ZqIS.default).findingResults),
        hasPadding: false
    }), isLoaded && (invokedFrom === 'globalIssueCreate' && (0, $epTsa.expVal)('proactive_similar_work_items_in_gic_experiment', 'isEnabled', false) ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $116371780a9dd6d8$var$relatedItemsContainerStyles
    }, draftSuggestions?.map((suggestion, index)=>{
        // Dynamically show the number of smart links based on the width of the container
        if (index > numOfSmartLinksToShow - 1) return;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $116371780a9dd6d8$var$relatedItemCardStyles,
            key: suggestion.resource.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4cFYC.Card), {
            appearance: "inline",
            url: suggestion.resource.issueLink,
            truncateInline: true,
            resolvingPlaceholder: "",
            placeholder: " ",
            showHoverPreview: true,
            onClick: ()=>onSmartCardClick(suggestion.resource.issueLink)
        }));
    })))), (isLoaded || shouldDisplay) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        xcss: $116371780a9dd6d8$var$toggleButtonWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
        spacing: "compact",
        onClick: (e)=>onToggleClick(e),
        isDisabled: isDisabled,
        appearance: "subtle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($116371780a9dd6d8$var$ToggleButtonContent, {
        shouldDisplay: shouldDisplay,
        draftSuggestions: draftSuggestions,
        errorMessage: errorMessage,
        formatMessage: formatMessage
    })))), shouldDisplay && children);
};
const $116371780a9dd6d8$var$headerActionsContainerStyles = (0, $1DXK0.xcss)({
    background: 'none',
    alignItems: 'center',
    marginLeft: 'space.100'
});
const $116371780a9dd6d8$var$aiIconLabelStyles = (0, $1DXK0.xcss)({
    padding: 'space.025',
    paddingTop: '0',
    paddingBottom: '0',
    height: 'space.0',
    width: 'space.100',
    color: 'color.text.subtle',
    marginRight: 'space.100',
    gap: 'space.100',
    display: 'flex',
    minWidth: 'fit-content',
    alignItems: 'center'
});
const $116371780a9dd6d8$var$relatedItemsContainerStyles = (0, $1DXK0.xcss)({
    gap: 'space.150',
    maxHeight: '100%',
    marginTop: 'space.025',
    display: 'flex',
    flexWrap: 'nowrap'
});
const $116371780a9dd6d8$var$relatedItemCardStyles = (0, $1DXK0.xcss)({
    // This is 12 rem which is 192px - used in our calculation onSmartLinksContainerResize
    maxWidth: 'size.1000',
    textAlign: 'left'
});
const $116371780a9dd6d8$var$toggleButtonWrapperStyles = (0, $1DXK0.xcss)({
    minWidth: 'fit-content',
    paddingRight: 'space.150',
    flexShrink: 0
});
const $116371780a9dd6d8$var$pressableStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: 'size.400',
    borderRadius: '3px',
    width: '100%',
    paddingBlock: 'space.100',
    transition: 'background 0.1s ease-out'
});
const $116371780a9dd6d8$var$pressableEnabledStyles = (0, $1DXK0.xcss)({
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed'
    }
});

});
parcelRegister("gk8hn", function(module, exports) {

$parcel$export(module.exports, "StreamingStatusBar", () => $4e24f54b2bf79f34$export$1106508d35fcb0ff);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $lmgo6 = parcelRequire("lmgo6");
var $1DXK0 = parcelRequire("1DXK0");

var $7jTnu = parcelRequire("7jTnu");

var $lRq8t = parcelRequire("lRq8t");

var $feHos = parcelRequire("feHos");

var $jRSW4 = parcelRequire("jRSW4");
const $4e24f54b2bf79f34$export$1106508d35fcb0ff = ({ message: message, hasPadding: hasPadding = true })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        xcss: [
            $4e24f54b2bf79f34$var$baseContainerStyle,
            hasPadding ? $4e24f54b2bf79f34$var$withPaddingStyle : $4e24f54b2bf79f34$var$noPaddingStyle
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $feHos.GeneratingAnimation), {
        alt: formatMessage((0, $7jTnu.fg)('jira-issue-terminology-refresh-m3') ? (0, $jRSW4.default).generatingIssueTermRefresh : (0, $jRSW4.default).generating)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "p",
        xcss: $4e24f54b2bf79f34$var$textStyle
    }, message));
};
const $4e24f54b2bf79f34$var$textStyle = (0, $1DXK0.xcss)({
    color: 'color.text.subtlest',
    margin: 'space.0',
    padding: 'space.0',
    display: 'flex',
    alignItems: 'center',
    gap: 'space.050'
});
const $4e24f54b2bf79f34$var$baseContainerStyle = (0, $1DXK0.xcss)({
    alignItems: 'center',
    paddingBlockStart: 'space.150',
    paddingBlockEnd: 'space.150',
    gap: 'space.100'
});
const $4e24f54b2bf79f34$var$withPaddingStyle = (0, $1DXK0.xcss)({
    paddingInline: 'space.150'
});
const $4e24f54b2bf79f34$var$noPaddingStyle = (0, $1DXK0.xcss)({
    paddingInline: 'space.0'
});

});
parcelRegister("feHos", function(module, exports) {

$parcel$export(module.exports, "GeneratingAnimation", () => $8e66608f5d08b70c$export$483f53d5a0354a30);

var $eJOHy = parcelRequire("eJOHy");
const $8e66608f5d08b70c$export$483f53d5a0354a30 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("title", null, props.alt), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("circle", {
        cx: "5.5",
        cy: "12.5",
        r: "1.5",
        fill: "#0C66E4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("animate", {
        attributeName: "cy",
        values: "11;13;13;13;13;13;13;11",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0s"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("circle", {
        cx: "11.5",
        cy: "10.5",
        r: "1.5",
        fill: "#1D7AFC"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("animate", {
        attributeName: "cy",
        values: "11;13;13;13;13;13;13;11",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0.2s"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("circle", {
        cx: "17.5",
        cy: "12.5",
        r: "1.5",
        fill: "#388BFF"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("animate", {
        attributeName: "cy",
        values: "11;13;13;13;13;13;13;11",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0.4s"
    })));

});

parcelRegister("jRSW4", function(module, exports) {

$parcel$export(module.exports, "default", () => $e273bb4ae11b2712$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $e273bb4ae11b2712$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    generating: {
        "id": "ai-related-issues.issue-breakdown-draft-list.streaming-status-bar.generating",
        "defaultMessage": "Generating issue suggestions"
    },
    generatingIssueTermRefresh: {
        "id": "ai-related-issues.issue-breakdown-draft-list.streaming-status-bar.generating-issue-term-refresh",
        "defaultMessage": "Generating suggestions"
    }
});

});


parcelRegister("8ZqIS", function(module, exports) {

$parcel$export(module.exports, "default", () => $46e7d87e0810c2fb$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $46e7d87e0810c2fb$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    workItemsFound: {
        "id": "ai-related-issues.find-similar-work-items.items-found",
        "defaultMessage": "{itemCount} items found"
    },
    noWorkItemsFound: {
        "id": "ai-related-issues.find-similar-work-items.no-items-found",
        "defaultMessage": "No similar items found"
    },
    beta: {
        "id": "ai-related-issues.find-similar-work-items.beta",
        "defaultMessage": "BETA"
    },
    findingResults: {
        "id": "ai-related-issues.find-similar-work-items.finding-results",
        "defaultMessage": "Finding results"
    },
    viewItems: {
        "id": "ai-related-issues.find-similar-work-items.view-items",
        "defaultMessage": "View items"
    },
    hideSuggestions: {
        "id": "ai-related-issues.find-similar-work-items.hide-suggestions",
        "defaultMessage": "Hide Suggestions"
    },
    updateDescriptionAndRetry: {
        "id": "ai-related-issues.find-similar-work-items.update-description-and-retry",
        "defaultMessage": "Update description and retry"
    },
    noSimilarWorkItems: {
        "id": "ai-related-issues.find-similar-work-items.no-similar-work-items",
        "defaultMessage": "No similar work items"
    },
    similarWorkItems: {
        "id": "ai-related-issues.find-similar-work-items.similar-work-items",
        "defaultMessage": "Similar work items"
    }
});

});


parcelRegister("gPgMe", function(module, exports) {

$parcel$export(module.exports, "RelatedIssuesDraftList", () => $4d4141cc1643e8b3$export$c23e65cca78b2b46);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @compiled/shorthand-property-sorting */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $9itkV = parcelRequire("9itkV");

var $5CSKW = parcelRequire("5CSKW");
var $Ay1uj = parcelRequire("Ay1uj");

var $entZ3 = parcelRequire("entZ3");

var $6J9k6 = parcelRequire("6J9k6");

var $lGr6J = parcelRequire("lGr6J");

var $8nu6j = parcelRequire("8nu6j");
var $lmgo6 = parcelRequire("lmgo6");
var $1DXK0 = parcelRequire("1DXK0");

var $4cFYC = parcelRequire("4cFYC");
var $5NtHI = parcelRequire("5NtHI");
var $fqBfo = parcelRequire("fqBfo");

var $epTsa = parcelRequire("epTsa");

var $8v03d = parcelRequire("8v03d");

var $7jTnu = parcelRequire("7jTnu");

var $lRq8t = parcelRequire("lRq8t");

var $bmoS1 = parcelRequire("bmoS1");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $bNexr = parcelRequire("bNexr");

var $4R60r = parcelRequire("4R60r");

var $xWB2Z = parcelRequire("xWB2Z");

var $k3oWT = parcelRequire("k3oWT");
const $4d4141cc1643e8b3$var$FEEDBACK_ENTRYPOINT_ID = 'f91a821a-c7b4-47a6-bc0c-b99c234f3124';
const $4d4141cc1643e8b3$var$FEEDBACK_COLLECTOR_ID = '043ab007-eb05-4694-9742-302b0a7f41a6';
const $4d4141cc1643e8b3$var$ACTION_BUTTON_COMPONENT_SELECTOR = 'ai-improve-issue-ai-related-issues-draft-list-row-action-button';
const $4d4141cc1643e8b3$export$c23e65cca78b2b46 = ({ invokedFrom: invokedFrom, onIssueLinkSave: onIssueLinkSave, onCopyButtonClick: onCopyButtonClick, onSimilarIssueLinkGICButtonClick: onSimilarIssueLinkGICButtonClick })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { resourceSuggestions: resourceSuggestions } = (0, $4R60r.useRelatedIssuesState)();
    const { acceptSuggestion: acceptSuggestion, acceptAllSuggestions: acceptAllSuggestions, discardSuggestion: discardSuggestion, discardAllSuggestions: discardAllSuggestions } = (0, $4R60r.useRelatedIssuesActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const issueKey = (0, $bmoS1.useIssueKey)();
    const projectKey = (0, $bNexr.useProjectKey)(issueKey);
    const relatedToIssueType = (0, $xWB2Z.useRelatesToIssueLinkType)();
    const isSimilarWorkItemsUIFixesEnabled = invokedFrom === 'globalIssueCreate' && (0, $7jTnu.fg)('similar_items_in_gic_ui_fixes');
    const draftSuggestions = resourceSuggestions?.filter((suggestion)=>// This deals with the case when the jira-ai-similar-issues-selectable-draft-list experiment is enabled, since the default resourceStatus is SELECTED
        suggestion.resourceStatus === 'DRAFT' || suggestion.resourceStatus === 'SELECTED');
    const onSingleSuggestionAccept = (0, $eJOHy.useCallback)((linkSuggestionsRequest)=>{
        const optimisticId = `OPTIMISTIC_LINKED_ISSUE_${Date.now()}_${linkSuggestionsRequest.id}`;
        onIssueLinkSave(optimisticId, linkSuggestionsRequest, relatedToIssueType, createAnalyticsEvent({}));
    }, [
        createAnalyticsEvent,
        onIssueLinkSave,
        relatedToIssueType
    ]);
    const onAcceptSuggestion = (0, $eJOHy.useCallback)((linkSuggestionsRequest)=>{
        /**
     * We have this condition here to handle the case
     * where there is only one suggestion and the user clicks on the accept button.
     */ if (draftSuggestions && draftSuggestions.length === 1) acceptAllSuggestions();
        else acceptSuggestion(linkSuggestionsRequest);
        onSingleSuggestionAccept(linkSuggestionsRequest);
        (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'aiResult actioned', 'aiRelatedIssuesSuggestionResultBox', {
            aiResultAction: 'inlineIssueAccepted'
        });
    }, [
        acceptAllSuggestions,
        acceptSuggestion,
        createAnalyticsEvent,
        draftSuggestions,
        onSingleSuggestionAccept
    ]);
    const onAcceptSuggestionInGIC = (0, $eJOHy.useCallback)((linkSuggestionsRequest)=>{
        acceptSuggestion(linkSuggestionsRequest);
        onSimilarIssueLinkGICButtonClick?.(linkSuggestionsRequest);
        (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'aiResult actioned', 'aiRelatedIssuesSuggestionResultBoxGIC', {
            aiResultAction: 'inlineIssueAcceptedGIC'
        });
    }, [
        acceptSuggestion,
        createAnalyticsEvent,
        onSimilarIssueLinkGICButtonClick
    ]);
    const onAcceptAllSuggestions = (0, $eJOHy.useCallback)(()=>{
        if (!draftSuggestions) return;
        for (const suggestion of draftSuggestions)onSingleSuggestionAccept(suggestion.resource);
        acceptAllSuggestions();
        (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'aiResult actioned', 'aiRelatedIssuesSuggestionResultBox', {
            aiResultAction: 'bulkIssuesAccepted',
            aiItemsCount: draftSuggestions.length
        });
    }, [
        acceptAllSuggestions,
        createAnalyticsEvent,
        draftSuggestions,
        onSingleSuggestionAccept
    ]);
    const onDiscardSuggestion = (0, $eJOHy.useCallback)((suggestionToBeDiscarded)=>{
        /**
     * We have this condition here to handle the case
     * where there is only one suggestion and the user clicks on the discard button.
     */ if (draftSuggestions && draftSuggestions.length === 1) discardAllSuggestions();
        else discardSuggestion(suggestionToBeDiscarded);
        (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'aiResult actioned', 'aiRelatedIssuesSuggestionResultBox', {
            aiResultAction: 'inlineIssueDeclined'
        });
    }, [
        createAnalyticsEvent,
        discardAllSuggestions,
        discardSuggestion,
        draftSuggestions
    ]);
    const onContainerRef = (0, $eJOHy.useCallback)((element)=>{
        if (element && typeof element.scrollIntoView === 'function') element.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
        });
    }, []);
    const cards = draftSuggestions?.map(({ resource: resource })=>{
        const handleOpenLinkInNewTab = (resourceUrl)=>{
            if (resourceUrl) {
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                window.open(resourceUrl, '_blank');
                (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'aiResult actioned', 'aiRelatedIssuesSuggestionOpenedLinkInNewTab', {
                    aiResultAction: 'openedLinkInNewTab'
                });
            }
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            key: resource.id,
            className: (0, $hcewu.default)([
                "_1e0c1txw _1bah1yb4 _1mpzidpf _1jxhkb7n _1u4v18uv _9oik18uv _1uw0glyw _1bnxglyw _1vfunqa1 _jf4cnqa1 _10j7166n _irr3166n _mh3akb7n _kimlkb7n",
                isSimilarWorkItemsUIFixesEnabled ? "_x3dozgxb _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc" : "_18zrpxbi _1rjcutpp _189ee4h9 _1h6dmuej _1dqonqa1 _bfhkvuon"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
            alignItems: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4cFYC.Card), {
            appearance: "block",
            url: resource.issueLink,
            showHoverPreview: true,
            ui: {
                size: (0, $5NtHI.SmartLinkSize).Medium,
                hideElevation: true,
                hideBackground: true,
                theme: (0, $5NtHI.SmartLinkTheme).Black,
                hidePadding: true
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fqBfo.default), {
            hideTitleTooltip: true,
            position: (0, $5NtHI.SmartLinkPosition).Center,
            testId: `ai-related-issues.ui.related-issues-draft-list.title-block-${resource.id}`
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
            xcss: $4d4141cc1643e8b3$var$actionStyles
        }, invokedFrom === 'globalIssueCreate' && (0, $epTsa.expVal)('proactive_similar_work_items_in_gic_experiment', 'isEnabled', false) ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
            testId: `ai-related-issues.ui.related-issues-draft-list.accept-suggestion-icon-button-${resource.id}`,
            "data-component-selector": `${$4d4141cc1643e8b3$var$ACTION_BUTTON_COMPONENT_SELECTOR}`,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($entZ3))),
            label: formatMessage((0, $k3oWT.default).link),
            spacing: "default",
            appearance: "subtle",
            onClick: ()=>onAcceptSuggestion(resource),
            isTooltipDisabled: false,
            tooltip: {
                testId: 'ai-related-issues.ui.issue-breakdown-draft-list.suggestion-list-item.icon-button.tooltip',
                position: 'bottom'
            }
        }), invokedFrom === 'globalIssueCreate' && onCopyButtonClick && (0, $epTsa.expVal)('similar_work_items_copy_field_milestone-2', 'isEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
            testId: `ai-related-issues.ui.related-issues-draft-list.accept-suggestion-icon-button-${resource.id}`,
            "data-component-selector": `${$4d4141cc1643e8b3$var$ACTION_BUTTON_COMPONENT_SELECTOR}`,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lGr6J))),
            label: formatMessage((0, $k3oWT.default).link),
            spacing: "default",
            appearance: "subtle",
            onClick: ()=>onCopyButtonClick(resource.issueKey),
            isTooltipDisabled: false,
            tooltip: {
                testId: 'ai-related-issues.ui.issue-breakdown-draft-list.suggestion-list-item.icon-button.tooltip',
                position: 'bottom'
            }
        }) : null, invokedFrom === 'globalIssueCreate' && onSimilarIssueLinkGICButtonClick && (0, $7jTnu.fg)('similar_work_items_in_gic_link_work_items') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
            testId: `ai-related-issues.ui.related-issues-draft-list.accept-suggestion-icon-button-${resource.id}`,
            "data-component-selector": `${$4d4141cc1643e8b3$var$ACTION_BUTTON_COMPONENT_SELECTOR}`,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($entZ3))),
            label: formatMessage((0, $k3oWT.default).link),
            spacing: "default",
            appearance: "subtle",
            onClick: ()=>onAcceptSuggestionInGIC(resource),
            isTooltipDisabled: false,
            tooltip: {
                testId: 'ai-related-issues.ui.issue-breakdown-draft-list.suggestion-list-item.icon-button.tooltip',
                position: 'bottom'
            }
        }) : null, invokedFrom === 'globalIssueCreate' && (0, $epTsa.expVal)('proactive_similar_work_items_in_gic_experiment', 'isEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
            testId: `ai-related-issues.ui.related-issues-draft-list.discard-suggestion-icon-button-${resource.id}`,
            "data-component-selector": `${$4d4141cc1643e8b3$var$ACTION_BUTTON_COMPONENT_SELECTOR}`,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($9itkV))),
            label: formatMessage((0, $k3oWT.default).openInNewTab),
            spacing: "default",
            appearance: "subtle",
            onClick: ()=>handleOpenLinkInNewTab(resource.issueLink),
            isTooltipDisabled: false,
            tooltip: {
                testId: 'ai-related-issues.ui.issue-breakdown-draft-list.suggestion-list-item.icon-button.tooltip',
                position: 'bottom'
            }
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
            testId: `ai-related-issues.ui.related-issues-draft-list.discard-suggestion-icon-button-${resource.id}`,
            "data-component-selector": `${$4d4141cc1643e8b3$var$ACTION_BUTTON_COMPONENT_SELECTOR}`,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($6J9k6))),
            label: formatMessage((0, $k3oWT.default).remove),
            spacing: "default",
            appearance: "subtle",
            onClick: ()=>onDiscardSuggestion(resource),
            isTooltipDisabled: false,
            tooltip: {
                testId: 'ai-related-issues.ui.issue-breakdown-draft-list.suggestion-list-item.icon-button.tooltip',
                position: 'bottom'
            }
        })));
    });
    const onFeedbackAction = (0, $eJOHy.useCallback)((typeOfAction, aiFeedbackResult)=>{
        (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), `aiFeedback ${typeOfAction}`, 'aiRelatedIssuesSuggestionResultBox', {
            aiFeedbackResult: aiFeedbackResult
        });
    }, [
        createAnalyticsEvent
    ]);
    const onFeedbackClicked = (0, $eJOHy.useCallback)((aiFeedbackResult)=>{
        onFeedbackAction('clicked', aiFeedbackResult);
    }, [
        onFeedbackAction
    ]);
    const onFeedbackSubmitted = (0, $eJOHy.useCallback)((aiFeedbackResult)=>{
        onFeedbackAction('submitted', aiFeedbackResult);
    }, [
        onFeedbackAction
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        ref: onContainerRef
    }, cards, draftSuggestions && draftSuggestions.length !== 0 && !(0, $7jTnu.fg)('platformisation-of-proactive-collapsible-container') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        xcss: $4d4141cc1643e8b3$var$footerActionsSectionStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8v03d.FeedbackForm), {
        feedbackCollectorId: $4d4141cc1643e8b3$var$FEEDBACK_COLLECTOR_ID,
        feedbackFormEntrypointId: $4d4141cc1643e8b3$var$FEEDBACK_ENTRYPOINT_ID,
        aiExperience: (0, $8v03d.RELATED_ISSUES_AI_EXPERIENCE),
        onFeedbackClicked: onFeedbackClicked,
        onFeedbackSent: onFeedbackSubmitted,
        projectKey: projectKey
    }), invokedFrom === 'globalIssueCreate' && (0, $epTsa.expVal)('proactive_similar_work_items_in_gic_experiment', 'isEnabled', false) ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        columnGap: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
        type: "button",
        testId: "ai-related-issues.ui.related-issues-draft-list.accept-all-loading-button",
        isDisabled: false,
        onClick: onAcceptAllSuggestions
    }, formatMessage((0, $k3oWT.default).linkAll)))));
};
const $4d4141cc1643e8b3$var$baseRowStyles = null;
const $4d4141cc1643e8b3$var$rowBorderStyles = null;
const $4d4141cc1643e8b3$var$rowStyles = null;
const $4d4141cc1643e8b3$var$actionStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    justifyContent: 'space-between',
    columnGap: 'space.150'
});
const $4d4141cc1643e8b3$var$footerActionsSectionStyles = (0, $1DXK0.xcss)({
    justifyContent: 'space-between',
    padding: 'space.150'
});

});
parcelRegister("entZ3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4eca488eebd24f6b0c74ed2566069d9c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a77a78d359015cce$var$_react = $a77a78d359015cce$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $a77a78d359015cce$var$_checkMark = $a77a78d359015cce$var$_interopRequireDefault((parcelRequire("lwpci")));

var $a77a78d359015cce$var$_check = $a77a78d359015cce$var$_interopRequireDefault((parcelRequire("2kdvq")));
function $a77a78d359015cce$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CheckMarkIcon.
 * This component is CheckMarkIcon, with `UNSAFE_fallbackIcon` set to "CheckIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a77a78d359015cce$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $a77a78d359015cce$var$_react.default.createElement($a77a78d359015cce$var$_checkMark.default, Object.assign({
        LEGACY_fallbackIcon: $a77a78d359015cce$var$_check.default
    }, props));
$a77a78d359015cce$var$CheckMarkIcon.Name = 'CheckMarkIconMigration';
var $a77a78d359015cce$var$_default = module.exports.default = $a77a78d359015cce$var$CheckMarkIcon;

});
parcelRegister("2kdvq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1b17ecff78f4ff04$var$_react = $1b17ecff78f4ff04$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $1b17ecff78f4ff04$var$_checkMark = $1b17ecff78f4ff04$var$_interopRequireDefault((parcelRequire("lwpci")));
function $1b17ecff78f4ff04$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1b17ecff78f4ff04$var$CheckIcon = (props)=>/*#__PURE__*/ $1b17ecff78f4ff04$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6.735 12.322a1 1 0 0 0-1.47 1.356l3.612 3.919c.537.526 1.337.526 1.834.03l.364-.359a2336 2336 0 0 0 3.939-3.883l.04-.04a493 493 0 0 0 3.658-3.643 1 1 0 0 0-1.424-1.404 518 518 0 0 1-3.64 3.625l-.04.04a2049 2049 0 0 1-3.775 3.722z"/></svg>`
    }, props, {
        newIcon: $1b17ecff78f4ff04$var$_checkMark.default
    }));
$1b17ecff78f4ff04$var$CheckIcon.displayName = 'CheckIcon';
var $1b17ecff78f4ff04$var$_default = module.exports.default = $1b17ecff78f4ff04$var$CheckIcon;

});


parcelRegister("xWB2Z", function(module, exports) {

$parcel$export(module.exports, "useHasRelatesToIssueLinkType", () => $cc3c835aa46f7141$export$82b827f0b1347bf9);
$parcel$export(module.exports, "useRelatesToIssueLinkType", () => $cc3c835aa46f7141$export$bcbed0291a974ca6);
$parcel$export(module.exports, "useIssueLinkTypesWithRelatesTo", () => $cc3c835aa46f7141$export$a58a0f4eb1a11b29);

var $5i7Wm = parcelRequire("5i7Wm");
const $cc3c835aa46f7141$export$82b827f0b1347bf9 = ()=>{
    const issueLinkTypes = (0, $5i7Wm.useIssueLinkTypes)()[0];
    return issueLinkTypes.some((linkType)=>linkType.label === 'relates to');
};
const $cc3c835aa46f7141$export$bcbed0291a974ca6 = ()=>{
    const issueLinkTypes = (0, $5i7Wm.useIssueLinkTypes)()[0];
    const newRelatesToIssueLinkType = issueLinkTypes.filter((linkType)=>linkType.label === 'relates to');
    return newRelatesToIssueLinkType?.[0];
};
const $cc3c835aa46f7141$export$a58a0f4eb1a11b29 = ()=>{
    const issueLinkTypes = (0, $5i7Wm.useIssueLinkTypes)()[0];
    return {
        issueLinkTypes: issueLinkTypes,
        relatesToIssueLinkType: issueLinkTypes.filter((linkType)=>linkType.label === 'relates to')?.[0]
    };
};

});
parcelRegister("5i7Wm", function(module, exports) {

$parcel$export(module.exports, "useTimeTrackingConfiguration", () => $3fba00681c98a8d4$export$57b83fc8c963078f);
$parcel$export(module.exports, "useIssueLinkTypes", () => $3fba00681c98a8d4$export$e8c8fa84fe64255f);
$parcel$export(module.exports, "useJiraSettingsActions", () => $3fba00681c98a8d4$export$6f294bed8b806bfb);

var $eJOHy = parcelRequire("eJOHy");

var $7Qzct = parcelRequire("7Qzct");
const $3fba00681c98a8d4$export$57b83fc8c963078f = ()=>{
    const [timeTrackingConfiguration] = (0, $7Qzct.useJiraSettingStoreTimeTracking)();
    return [
        timeTrackingConfiguration
    ];
};
const $3fba00681c98a8d4$export$a0b7933d1ba1359a = ()=>{
    const [subTaskConfiguration] = (0, $7Qzct.useJiraSettingStoreSubtaskConfiguration)();
    return [
        subTaskConfiguration
    ];
};
const $3fba00681c98a8d4$export$e8c8fa84fe64255f = ()=>{
    const [issueLinkTypes] = (0, $7Qzct.useJiraSettingStoreIssueLinkType)();
    return [
        issueLinkTypes
    ];
};
const $3fba00681c98a8d4$export$311fcda1c9d987e1 = ()=>{
    const [newIssueViewTransitionSetting] = (0, $7Qzct.useJiraSettingStoreNewIssueViewTransition)();
    return [
        newIssueViewTransitionSetting
    ];
};
const $3fba00681c98a8d4$export$6f294bed8b806bfb = ()=>{
    const [, { setJiraSettings: setJiraSettings }] = (0, $7Qzct.useSettingsActions)();
    const actions = (0, $eJOHy.useMemo)(()=>({
            setJiraSettings: setJiraSettings
        }), [
        setJiraSettings
    ]);
    return [
        null,
        actions
    ];
};

});
parcelRegister("7Qzct", function(module, exports) {

$parcel$export(module.exports, "useJiraSettingStoreTimeTracking", () => $fa2eb147c3bf6440$export$a02b4a407a2f26d4);
$parcel$export(module.exports, "useJiraSettingStoreNewIssueViewTransition", () => $fa2eb147c3bf6440$export$ef5d1a1edee065c3);
$parcel$export(module.exports, "useJiraSettingStoreSubtaskConfiguration", () => $fa2eb147c3bf6440$export$fb7d68c140cb341f);
$parcel$export(module.exports, "useJiraSettingStoreIssueLinkType", () => $fa2eb147c3bf6440$export$b0a0062863e9885a);
$parcel$export(module.exports, "useSettingsActions", () => $fa2eb147c3bf6440$export$346f2dc8b103b21d);

var $8RgaA = parcelRequire("8RgaA");

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $5dF4d = parcelRequire("5dF4d");
const $fa2eb147c3bf6440$export$d4c72bab9d6cc13a = {
    newIssueViewTransitionSettings: {
        newIssueViewTransitionLockingStatus: (0, $8RgaA.DEFAULT_TO_NEW_ISSUE_VIEW),
        shouldDelayChangeboarding: false
    },
    issueLinkTypes: [],
    subtasksConfiguration: {
        enabled: true
    },
    timeTrackingConfiguration: {
        isTimeTrackingEnabled: false,
        daysPerWeek: 0,
        hoursPerDay: 0,
        // Possible values for defaultUnit can be: minute, hour, day, and week.
        defaultUnit: (0, $8RgaA.MINUTE)
    }
};
const $fa2eb147c3bf6440$export$6f57813fe9f31bf9 = (0, $GtRbT.createStore)({
    name: 'jiraSettings',
    initialState: $fa2eb147c3bf6440$export$d4c72bab9d6cc13a,
    actions: $5dF4d
});
// remove undefined when we remove ff issue.details.admin-options-phase-2
const $fa2eb147c3bf6440$var$getTimeTracking = (state)=>state.timeTrackingConfiguration;
// @ts-expect-error - TS7006 - Parameter 'state' implicitly has an 'any' type.
const $fa2eb147c3bf6440$var$getNewIssueViewTransition = (state)=>state.newIssueViewTransitionSettings || undefined;
const $fa2eb147c3bf6440$var$getSubtaskConfiguration = (state)=>state.subtasksConfiguration;
const $fa2eb147c3bf6440$var$getIssueLinkType = (state)=>state.issueLinkTypes;
const $fa2eb147c3bf6440$export$a02b4a407a2f26d4 = (0, $iJq0l.createHook)($fa2eb147c3bf6440$export$6f57813fe9f31bf9, {
    selector: $fa2eb147c3bf6440$var$getTimeTracking
});
const $fa2eb147c3bf6440$export$ef5d1a1edee065c3 = (0, $iJq0l.createHook)($fa2eb147c3bf6440$export$6f57813fe9f31bf9, {
    selector: $fa2eb147c3bf6440$var$getNewIssueViewTransition
});
const $fa2eb147c3bf6440$export$fb7d68c140cb341f = (0, $iJq0l.createHook)($fa2eb147c3bf6440$export$6f57813fe9f31bf9, {
    selector: $fa2eb147c3bf6440$var$getSubtaskConfiguration
});
const $fa2eb147c3bf6440$export$b0a0062863e9885a = (0, $iJq0l.createHook)($fa2eb147c3bf6440$export$6f57813fe9f31bf9, {
    selector: $fa2eb147c3bf6440$var$getIssueLinkType
});
const $fa2eb147c3bf6440$export$346f2dc8b103b21d = (0, $iJq0l.createHook)($fa2eb147c3bf6440$export$6f57813fe9f31bf9, {
    selector: null
});

});
parcelRegister("8RgaA", function(module, exports) {

$parcel$export(module.exports, "MINUTE", () => $a72d37d3cd468918$export$f4aba04677f37907);
$parcel$export(module.exports, "HOUR", () => $a72d37d3cd468918$export$1bf939ebcf31ef0e);
$parcel$export(module.exports, "DAY", () => $a72d37d3cd468918$export$1a58b8d7f494dd72);
$parcel$export(module.exports, "WEEK", () => $a72d37d3cd468918$export$3241045aa1844a20);
$parcel$export(module.exports, "DAYS", () => $a72d37d3cd468918$export$b387b66963374517);
$parcel$export(module.exports, "HOURS", () => $a72d37d3cd468918$export$f25ebc73c10ad2c);
$parcel$export(module.exports, "PRETTY", () => $a72d37d3cd468918$export$d39e6ebabedff673);
$parcel$export(module.exports, "defaultTimeTrackingConfiguration", () => $a72d37d3cd468918$export$e17ebf14f4144ede);
$parcel$export(module.exports, "DEFAULT_TO_NEW_ISSUE_VIEW", () => $a72d37d3cd468918$export$83f9ac2d887bd06a);
const $a72d37d3cd468918$export$f4aba04677f37907 = 'minute';
const $a72d37d3cd468918$export$1bf939ebcf31ef0e = 'hour';
const $a72d37d3cd468918$export$1a58b8d7f494dd72 = 'day';
const $a72d37d3cd468918$export$3241045aa1844a20 = 'week';
const $a72d37d3cd468918$export$b387b66963374517 = 'days';
const $a72d37d3cd468918$export$f25ebc73c10ad2c = 'hours';
const $a72d37d3cd468918$export$d39e6ebabedff673 = 'pretty';
const $a72d37d3cd468918$export$e17ebf14f4144ede = {
    isTimeTrackingEnabled: false,
    daysPerWeek: 5,
    hoursPerDay: 8,
    defaultUnit: $a72d37d3cd468918$export$f4aba04677f37907,
    format: $a72d37d3cd468918$export$d39e6ebabedff673
};
const $a72d37d3cd468918$export$7a0204710d322de6 = 'LOCK_IN_NEW_ISSUE_VIEW';
const $a72d37d3cd468918$export$83f9ac2d887bd06a = 'DEFAULT_TO_NEW_ISSUE_VIEW';
const $a72d37d3cd468918$export$f269c0bf10ad77e2 = 'DEFAULT_TO_OLD_ISSUE_VIEW';

});

parcelRegister("5dF4d", function(module, exports) {

$parcel$export(module.exports, "setJiraSettings", () => $6c14199af9a36d80$export$aa595a6ada3acbb8);
const $6c14199af9a36d80$export$aa595a6ada3acbb8 = (jiraSettings)=>({ setState: setState })=>{
        setState(jiraSettings);
    };

});




parcelRegister("k3oWT", function(module, exports) {

$parcel$export(module.exports, "default", () => $8dc4b073b9abf0ca$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $8dc4b073b9abf0ca$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    close: {
        "id": "ai-related-issues.related-issues-draft-list.close",
        "defaultMessage": "Close"
    },
    giveFeedback: {
        "id": "ai-related-issues.related-issues-draft-list.give-feedback",
        "defaultMessage": "Give feedback"
    },
    link: {
        "id": "ai-related-issues.related-issues-draft-list.link",
        "defaultMessage": "Link"
    },
    linkDisabledGic: {
        "id": "ai-related-issues.related-issues-draft-list.link-disabled-gic",
        "defaultMessage": "There is no linked work items field configured hence linking is disabled"
    },
    remove: {
        "id": "ai-related-issues.related-issues-draft-list.remove",
        "defaultMessage": "Remove"
    },
    openInNewTab: {
        "id": "ai-related-issues.related-issues-draft-list.openInNewTab",
        "defaultMessage": "Open in new tab"
    },
    linkAll: {
        "id": "ai-related-issues.related-issues-draft-list.link-all",
        "defaultMessage": "Link all"
    }
});

});


parcelRegister("dxIkO", function(module, exports) {

$parcel$export(module.exports, "Footer", () => $482b898e0757ab9b$export$a06f1c675e846f6f);

var $eJOHy = parcelRequire("eJOHy");

var $5CSKW = parcelRequire("5CSKW");

var $lRq8t = parcelRequire("lRq8t");

var $epTsa = parcelRequire("epTsa");

var $9gNUh = parcelRequire("9gNUh");

var $7VgM4 = parcelRequire("7VgM4");
const $482b898e0757ab9b$export$a06f1c675e846f6f = ({ suggestions: suggestions, onAcceptAllSuggestions: onAcceptAllSuggestions, onAcceptSelectedSuggestions: onAcceptSelectedSuggestions, invokedFrom: invokedFrom, hasSelectedSuggestions: hasSelectedSuggestions })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    if (!suggestions || suggestions.length === 0) return null;
    // We don't show a CTA button in GIC
    if (invokedFrom === 'globalIssueCreate' && (0, $epTsa.expVal)('proactive_similar_work_items_in_gic_experiment', 'isEnabled', false)) return null;
    if ((0, $epTsa.expVal)('jira-ai-similar-issues-selectable-draft-list', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9gNUh.LinkSplitButton), {
        onButtonClick: onAcceptSelectedSuggestions,
        isButtonDisabled: !hasSelectedSuggestions,
        appearance: "primary"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
        type: "button",
        testId: "ai-related-issues.ui.footer.accept-all-loading-button",
        onClick: onAcceptAllSuggestions,
        spacing: "compact",
        appearance: "primary"
    }, formatMessage((0, $7VgM4.default).linkAll));
};

});
parcelRegister("9gNUh", function(module, exports) {

$parcel$export(module.exports, "LinkSplitButton", () => $d96eae877fe7bc57$export$72694cad14ad6469);

var $eJOHy = parcelRequire("eJOHy");

var $5CSKW = parcelRequire("5CSKW");
var $Ay1uj = parcelRequire("Ay1uj");
var $2ntmI = parcelRequire("2ntmI");

var $7rjYb = parcelRequire("7rjYb");
var $jYYbf = parcelRequire("jYYbf");
var $aLJ1L = parcelRequire("aLJ1L");

var $5lAAn = parcelRequire("5lAAn");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $dPMMf = parcelRequire("dPMMf");

var $xWB2Z = parcelRequire("xWB2Z");

var $eiUaj = parcelRequire("eiUaj");
const $d96eae877fe7bc57$export$72694cad14ad6469 = ({ onButtonClick: onButtonClick, isButtonDisabled: isButtonDisabled = false, appearance: appearance = 'default' })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { issueLinkTypes: issueLinkTypes, relatesToIssueLinkType: relatesToIssueLinkType } = (0, $xWB2Z.useIssueLinkTypesWithRelatesTo)();
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    if (relatesToIssueLinkType) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2ntmI.SplitButton), {
        appearance: appearance,
        spacing: "compact",
        isDisabled: isButtonDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
        onClick: (e)=>{
            e.stopPropagation();
            onButtonClick(relatesToIssueLinkType);
        },
        isDisabled: isButtonDisabled,
        testId: "ai-related-issues.ui.link-split-button.accept-all-loading-button"
    }, formatMessage((0, $eiUaj.default).linkAsRelatesTo)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7rjYb.default), {
        isOpen: isOpen,
        trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
                ref: triggerRef,
                ...triggerProps,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($5lAAn))),
                label: formatMessage((0, $eiUaj.default).dropdownLabel),
                isDisabled: isButtonDisabled
            }),
        onOpenChange: (attrs)=>{
            setIsOpen(attrs.isOpen);
        },
        placement: "right-end",
        shouldFlip: true,
        zIndex: (0, $dPMMf.layers).spotlight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $d96eae877fe7bc57$var$styles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aLJ1L.default), null, issueLinkTypes.map((issueLinkType)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
            onClick: (e)=>{
                e.stopPropagation();
                onButtonClick(issueLinkType);
                setIsOpen(false);
            },
            key: issueLinkType.id
        }, issueLinkType.label))))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7rjYb.default), {
        isOpen: isOpen,
        trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
                iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($5lAAn))),
                ref: triggerRef,
                ...triggerProps
            }, formatMessage((0, $eiUaj.default).linkAs)),
        onOpenChange: (attrs)=>{
            setIsOpen(attrs.isOpen);
        },
        placement: "right-end",
        shouldFlip: true,
        zIndex: (0, $dPMMf.layers).spotlight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $d96eae877fe7bc57$var$styles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aLJ1L.default), null, issueLinkTypes.map((issueLinkType)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
            onClick: (e)=>{
                e.stopPropagation();
                onButtonClick(issueLinkType);
                setIsOpen(false);
            },
            key: issueLinkType.id
        }, issueLinkType.label)))));
};
const $d96eae877fe7bc57$var$styles = (0, $1DXK0.xcss)({
    maxHeight: '300px',
    overflow: 'auto'
});

});
parcelRegister("2ntmI", function(module, exports) {

$parcel$export(module.exports, "SplitButton", () => $f424517b2b03f7a5$export$651ad66661acd392);
/* split-button.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eGOwo = parcelRequire("eGOwo");

var $k51XY = parcelRequire("k51XY");

var $kUUEq = parcelRequire("kUUEq");
const $f424517b2b03f7a5$var$dividerStyles = {
    baseDivider: "_1bsbe4h9 _kqswh2mm _1pbykb7n",
    dividerDisabled: "_bfhkojnm _80om13gf _tzy41uwv",
    dividerDisabledRefreshed: "_bfhk9xzm _80om13gf",
    dividerOffsetRefreshed: "_195g1n1a"
};
const $f424517b2b03f7a5$var$dividerAppearanceStyles = {
    default: "_bfhk1fxt _tzy41uwv",
    primary: "_bfhk15cr _tzy41wzo",
    navigation: "_1mouu2gc _195g1h5n _4t3i7vkz _bfhkdud1 _tzy419lr"
};
const $f424517b2b03f7a5$var$dividerRefreshedAppearanceStyles = {
    default: "_bfhkmuej",
    primary: "_bfhkveue _tzy41wzo",
    navigation: "_1mouu2gc _195g1h5n _4t3i7vkz _bfhkdud1 _tzy419lr"
};
const $f424517b2b03f7a5$var$dividerHeightStyles = {
    default: "_4t3iviql",
    compact: "_4t3i1k8s"
};
// The divider height is calculated by subtracting twice the border width from the button height.
// This ensures the divider does not intersect with the button's border, avoiding visual issues
// caused by overlapping alpha colors (color.border) at the intersection.
const $f424517b2b03f7a5$var$defaultDividerHeightStyles = {
    default: "_4t3im1ee",
    compact: "_4t3i1hvu"
};
const $f424517b2b03f7a5$export$2e0a83ec2e27ecbb = ({ appearance: appearance, spacing: spacing, isDisabled: isDisabled = false })=>{
    const isDefaultDivider = appearance === 'default' && !isDisabled && (0, $eGOwo.fg)('platform-component-visual-refresh');
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            $f424517b2b03f7a5$var$dividerStyles.baseDivider,
            isDefaultDivider && $f424517b2b03f7a5$var$defaultDividerHeightStyles[spacing],
            !isDefaultDivider && $f424517b2b03f7a5$var$dividerHeightStyles[spacing],
            isDisabled && (0, $eGOwo.fg)('platform-component-visual-refresh') && $f424517b2b03f7a5$var$dividerStyles.dividerDisabledRefreshed,
            isDisabled && !(0, $eGOwo.fg)('platform-component-visual-refresh') && $f424517b2b03f7a5$var$dividerStyles.dividerDisabled,
            !isDisabled && (0, $eGOwo.fg)('platform-component-visual-refresh') && $f424517b2b03f7a5$var$dividerRefreshedAppearanceStyles[appearance],
            !isDisabled && !(0, $eGOwo.fg)('platform-component-visual-refresh') && $f424517b2b03f7a5$var$dividerAppearanceStyles[appearance],
            (0, $eGOwo.fg)('platform-component-visual-refresh') && $f424517b2b03f7a5$var$dividerStyles.dividerOffsetRefreshed
        ])
    });
};
const $f424517b2b03f7a5$var$buttonStyles = {
    splitButton: "_1e0c116y _kqswh2mm _4cvr1h6o _o5721q9c",
    primaryButton: "_traeidpf _anlpidpf _p9ykidpf _bepvidpf",
    secondaryButton: "_1j4hidpf _1553idpf _1qgbidpf _y1n3idpf",
    defaultAppearanceContainer: "_2rko1sit _12jimuej _1cwg1n1a _1qu2nqa1 _12y3t94y"
};
const $f424517b2b03f7a5$export$994ba1b4c598f7 = ({ appearance: appearance, children: children, isDisabled: isDisabled = false })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        className: (0, $hcewu.default)([
            appearance === 'default' && !isDisabled && (0, $eGOwo.fg)('platform-component-visual-refresh') && $f424517b2b03f7a5$var$buttonStyles.defaultAppearanceContainer,
            $f424517b2b03f7a5$var$buttonStyles.splitButton
        ]),
        children: children
    });
};
const $f424517b2b03f7a5$export$651ad66661acd392 = ({ children: children, appearance: appearance = 'default', spacing: spacing = 'default', isDisabled: isDisabled = false })=>{
    const { PrimaryAction: PrimaryAction, SecondaryAction: SecondaryAction } = (0, $kUUEq.getActions)(children);
    return /*#__PURE__*/ (0, $gt9Am.jsx)($f424517b2b03f7a5$export$994ba1b4c598f7, {
        appearance: appearance,
        isDisabled: isDisabled,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $k51XY.SplitButtonContext).Provider, {
            value: {
                appearance: appearance,
                spacing: spacing,
                isDisabled: isDisabled
            },
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    className: (0, $hcewu.default)([
                        $f424517b2b03f7a5$var$buttonStyles.primaryButton
                    ]),
                    children: PrimaryAction
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)($f424517b2b03f7a5$export$2e0a83ec2e27ecbb, {
                    appearance: appearance,
                    spacing: spacing,
                    isDisabled: isDisabled
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    className: (0, $hcewu.default)([
                        $f424517b2b03f7a5$var$buttonStyles.secondaryButton
                    ]),
                    children: SecondaryAction
                })
            ]
        })
    });
};
const $f424517b2b03f7a5$export$e3ca81100b492e15 = ({ primaryAction: primaryAction, secondaryAction: secondaryAction, appearance: appearance = 'default', spacing: spacing = 'default', isDisabled: isDisabled = false })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)($f424517b2b03f7a5$export$994ba1b4c598f7, {
        appearance: appearance,
        isDisabled: isDisabled,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $k51XY.SplitButtonContext).Provider, {
            value: {
                appearance: appearance,
                spacing: spacing,
                isDisabled: isDisabled
            },
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    className: (0, $hcewu.default)([
                        $f424517b2b03f7a5$var$buttonStyles.primaryButton
                    ]),
                    children: primaryAction
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)($f424517b2b03f7a5$export$2e0a83ec2e27ecbb, {
                    appearance: appearance,
                    spacing: spacing,
                    isDisabled: isDisabled
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    className: (0, $hcewu.default)([
                        $f424517b2b03f7a5$var$buttonStyles.secondaryButton
                    ]),
                    children: secondaryAction
                })
            ]
        })
    });
};

});
parcelRegister("kUUEq", function(module, exports) {

$parcel$export(module.exports, "getActions", () => $17ccf685d98bc901$export$fe3955935f564b31);

var $eJOHy = parcelRequire("eJOHy");

var $igDjg = parcelRequire("igDjg");
const $17ccf685d98bc901$export$fe3955935f564b31 = (children)=>{
    const [PrimaryAction, SecondaryAction] = (0, $eJOHy.Children).toArray(children);
    typeof $igDjg;
    return {
        PrimaryAction: PrimaryAction,
        SecondaryAction: SecondaryAction
    };
};

});


parcelRegister("eiUaj", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ee2807ae6a5b4b2$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $4ee2807ae6a5b4b2$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    linkAs: {
        "id": "ai-related-issues.link-as",
        "defaultMessage": "Link as"
    },
    linkAsRelatesTo: {
        "id": "ai-related-issues.link-as-relates-to",
        "defaultMessage": "Link as related"
    },
    dropdownLabel: {
        "id": "ai-related-issues.link-split-button.dropdown-label",
        "defaultMessage": "More work items relationship types"
    }
});

});


parcelRegister("7VgM4", function(module, exports) {

$parcel$export(module.exports, "default", () => $44dd0c31b3125f8b$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $44dd0c31b3125f8b$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    linkAll: {
        "id": "ai-related-issues.link-all",
        "defaultMessage": "Link all"
    }
});

});


parcelRegister("j4Juo", function(module, exports) {

$parcel$export(module.exports, "default", () => $ece9e236f3928e60$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $ece9e236f3928e60$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    updateDescriptionAndRetry: {
        "id": "ai-related-issues.find-similar-work-items.update-description-and-retry",
        "defaultMessage": "Update description and retry"
    },
    noSimilarWorkItems: {
        "id": "ai-related-issues.find-similar-work-items.no-similar-work-items",
        "defaultMessage": "No similar work items"
    },
    similarWorkItems: {
        "id": "ai-related-issues.find-similar-work-items.similar-work-items",
        "defaultMessage": "Similar work items"
    },
    showNumResults: {
        "id": "ai-related-issues.find-similar-work-items.show-results",
        "defaultMessage": "Show {numResults} {numResults, plural, one {result} other {results}}"
    },
    linkSimilarWorkItems: {
        "id": "ai-related-issues.find-similar-work-items.link-similar-work-items",
        "defaultMessage": "Link similar work items"
    },
    searchingForSimilarWorkItems: {
        "id": "ai-related-issues.find-similar-work-items.searching-for-similar-work-items",
        "defaultMessage": "Searching for similar work items"
    },
    searchAgain: {
        "id": "ai-related-issues.find-similar-work-items.search-again",
        "defaultMessage": "Search again"
    },
    similarIssuesCouldNotBeGenerated: {
        "id": "ai-related-issues.page-suggestions-could-not-be-generated",
        "defaultMessage": "Atlassian Intelligence couldn't find issues similar to this one"
    },
    similarIssuesCouldNotBeGeneratedIssueTermRefresh: {
        "id": "ai-related-issues.page-suggestions-could-not-be-generated-issue-term-refresh",
        "defaultMessage": "Atlassian Intelligence couldn't find work items similar to this one"
    }
});

});

parcelRegister("7tFKB", function(module, exports) {

$parcel$export(module.exports, "RelatedIssuesDraftListIssueView", () => $606fac8d1265b827$export$82215ae80028d239);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $86tBw = parcelRequire("86tBw");

var $8nu6j = parcelRequire("8nu6j");
var $lmgo6 = parcelRequire("lmgo6");
var $1DXK0 = parcelRequire("1DXK0");

var $4cFYC = parcelRequire("4cFYC");
var $5NtHI = parcelRequire("5NtHI");
var $fqBfo = parcelRequire("fqBfo");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $3bSs8 = parcelRequire("3bSs8");

var $d2AGn = parcelRequire("d2AGn");

var $4R60r = parcelRequire("4R60r");

var $9gNUh = parcelRequire("9gNUh");

var $xWB2Z = parcelRequire("xWB2Z");

var $gQg3S = parcelRequire("gQg3S");
const $606fac8d1265b827$var$ACTION_BUTTON_COMPONENT_SELECTOR = 'ai-improve-issue-ai-related-issues-draft-list-row-action-button';
const $606fac8d1265b827$export$82215ae80028d239 = ({ onIssueLinkSave: onIssueLinkSave })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { resourceSuggestions: resourceSuggestions } = (0, $4R60r.useRelatedIssuesState)();
    const { acceptSuggestion: acceptSuggestion, setResourceSuggestionStatus: setResourceSuggestionStatus } = (0, $4R60r.useRelatedIssuesActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { relatesToIssueLinkType: relatesToIssueLinkType } = (0, $xWB2Z.useIssueLinkTypesWithRelatesTo)();
    const shownSuggestions = resourceSuggestions?.filter((suggestion)=>suggestion.resourceStatus === 'DRAFT' || suggestion.resourceStatus === 'SELECTED');
    const isAllSelected = (0, $eJOHy.useMemo)(()=>{
        return resourceSuggestions?.every((suggestion)=>suggestion.resourceStatus === 'SELECTED' || suggestion.resourceStatus === 'ACCEPTED');
    }, [
        resourceSuggestions
    ]);
    const onSelectAllChange = (0, $eJOHy.useCallback)(()=>{
        shownSuggestions?.forEach((suggestion)=>{
            setResourceSuggestionStatus(suggestion.resource, isAllSelected ? 'DRAFT' : 'SELECTED');
        });
    }, [
        shownSuggestions,
        setResourceSuggestionStatus,
        isAllSelected
    ]);
    const onSingleSuggestionAccept = (0, $eJOHy.useCallback)((linkSuggestionsRequest, issueLinkType)=>{
        const optimisticId = `OPTIMISTIC_LINKED_ISSUE_${Date.now()}_${linkSuggestionsRequest.id}`;
        acceptSuggestion(linkSuggestionsRequest);
        onIssueLinkSave(optimisticId, linkSuggestionsRequest, issueLinkType, createAnalyticsEvent({}));
        (0, $d2AGn.getUpdateAnalyticsFlowHelper)().fireAnalyticsEnd((0, $3bSs8.ENTITY_FIELD_KEYS).ISSUE_LINKS, {
            analytics: createAnalyticsEvent({}),
            attributes: {
                fieldType: (0, $3bSs8.ENTITY_FIELD_KEYS).ISSUE_LINKS,
                actionTaken: 'add'
            }
        });
        (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'aiResult actioned', 'aiRelatedIssuesSuggestionResultBox', {
            aiResultAction: 'inlineIssueAccepted',
            isRelatedToIssueLinkType: issueLinkType.id === relatesToIssueLinkType?.id
        });
    }, [
        acceptSuggestion,
        createAnalyticsEvent,
        onIssueLinkSave,
        relatesToIssueLinkType?.id
    ]);
    const cards = shownSuggestions?.map(({ resource: resource, resourceStatus: resourceStatus })=>{
        const ItemNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $606fac8d1265b827$var$baseRowStyles,
            key: resource.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
            alignItems: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4cFYC.Card), {
            appearance: "block",
            url: resource.issueLink,
            showHoverPreview: true,
            ui: {
                size: (0, $5NtHI.SmartLinkSize).Medium,
                hideElevation: true,
                hideBackground: true,
                theme: (0, $5NtHI.SmartLinkTheme).Black,
                hidePadding: true
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fqBfo.default), {
            hideTitleTooltip: true,
            position: (0, $5NtHI.SmartLinkPosition).Center,
            testId: `ai-related-issues.ui.related-issues-draft-list.title-block-${resource.id}`
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            "data-component-selector": `${$606fac8d1265b827$var$ACTION_BUTTON_COMPONENT_SELECTOR}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
            xcss: $606fac8d1265b827$var$actionStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9gNUh.LinkSplitButton), {
            onButtonClick: (issueLinkType)=>onSingleSuggestionAccept(resource, issueLinkType)
        }))));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            key: resource.id,
            className: (0, $hcewu.default)([
                "_1rjcu2gc _x3dozgxb _vchhusvi _19bvutpp _u5f3v47k _1mpzidpf _1u4v18uv _9oik18uv _1uw0glyw _1bnxglyw _1vfunqa1 _jf4cnqa1 _10j7166n _irr3166n _mh3akb7n _kimlkb7n"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86tBw.default), {
            key: resource.id,
            label: ItemNode,
            onChange: (e)=>setResourceSuggestionStatus(resource, e.target.checked ? 'SELECTED' : 'DRAFT'),
            isChecked: resourceStatus === 'SELECTED',
            "aria-label": formatMessage((0, $gQg3S.default).link),
            "aria-labelledby": `ai-related-issues.ui.related-issues-draft-list.title-block-${resource.id}`,
            xcss: $606fac8d1265b827$var$styles.checkbox
        }));
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $606fac8d1265b827$var$cardStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86tBw.default), {
        label: formatMessage(isAllSelected ? (0, $gQg3S.default).deselectAll : (0, $gQg3S.default).selectAll),
        onChange: onSelectAllChange,
        isChecked: isAllSelected,
        xcss: $606fac8d1265b827$var$styles.checkbox
    })), cards);
};
const $606fac8d1265b827$var$hoverFocusStyles = null;
const $606fac8d1265b827$var$baseRowStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    justifyContent: 'space-between'
});
const $606fac8d1265b827$var$actionStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    justifyContent: 'space-between',
    columnGap: 'space.150'
});
const $606fac8d1265b827$var$cardStyles = (0, $1DXK0.xcss)({
    paddingInline: 'space.150',
    boxSizing: 'border-box',
    borderTop: `1px solid ${"var(--ds-border, #091E4224)"}`,
    paddingBlock: 'space.100'
});
const $606fac8d1265b827$var$styles = {
    checkbox: "_4cvr1h6o"
};

});
parcelRegister("gQg3S", function(module, exports) {

$parcel$export(module.exports, "default", () => $712e106df913b10a$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $712e106df913b10a$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    link: {
        "id": "ai-related-issues.related-issues-draft-list.link",
        "defaultMessage": "Link"
    },
    selectAll: {
        "id": "ai-related-issues.related-issues-draft-list.select-all",
        "defaultMessage": "Select all"
    },
    deselectAll: {
        "id": "ai-related-issues.related-issues-draft-list.deselect-all",
        "defaultMessage": "Deselect all"
    }
});

});



parcelRegister("3XuP5", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f11b08ae1f3711e$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $gYnSx = parcelRequire("gYnSx");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $lsOEE = parcelRequire("lsOEE");
const $8f11b08ae1f3711e$var$useIsAdminHubAIEnabled = (jiraProduct, version)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [isAdminHubAiToggleEnabled, setIsAdminHubAiToggleEnabled] = (0, $eJOHy.useState)(null);
    const [loading, setLoading] = (0, $eJOHy.useState)(false);
    const [error, setError] = (0, $eJOHy.useState)(null);
    const fetchData = (0, $eJOHy.useCallback)(async ()=>{
        setLoading(true);
        setError(null);
        try {
            const response = await (0, $lsOEE.fetchAiEnablement)(jiraProduct, version);
            (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchAiEnablementStatus succeeded');
            setIsAdminHubAiToggleEnabled(response.isEnabled);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setError(err);
            (0, $gYnSx.default)({
                error: err,
                meta: {
                    id: 'fetchAiEnablementStatus failed'
                }
            });
        } finally{
            setLoading(false);
        }
    }, [
        createAnalyticsEvent,
        jiraProduct,
        version
    ]);
    return {
        data: isAdminHubAiToggleEnabled,
        loading: loading,
        error: error,
        fetchAIEnablement: fetchData
    };
};
var $8f11b08ae1f3711e$export$2e2bcd8739ae039 = $8f11b08ae1f3711e$var$useIsAdminHubAIEnabled;

});
parcelRegister("lsOEE", function(module, exports) {

$parcel$export(module.exports, "fetchAiEnablement", () => $dc8dcfb6f4d0d2bd$export$ad4105850d0ce824);

var $1Ozm9 = parcelRequire("1Ozm9");
const $dc8dcfb6f4d0d2bd$export$2171a423b572256a = (jiraProduct, version = '1')=>`/rest/api/${version}/aiconfig/ai-enabled/${jiraProduct}`;
const $dc8dcfb6f4d0d2bd$export$ad4105850d0ce824 = (jiraProduct, version = '1')=>{
    const url = $dc8dcfb6f4d0d2bd$export$2171a423b572256a(jiraProduct, version);
    return (0, $1Ozm9.default)(url, {
        method: 'GET'
    });
};

});


parcelRegister("72ggt", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $130ddf635191ef41$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useIssueCreateWithFieldPrefilling", () => $130ddf635191ef41$export$ed5d3f997a26357b);
$parcel$export(module.exports, "useIssueCreateModalWithPrefillingForIssueCreateEmbed", () => $130ddf635191ef41$export$8f837c39a3be9608);

var $eJOHy = parcelRequire("eJOHy");

var $8dH3d = parcelRequire("8dH3d");

var $12DRg = parcelRequire("12DRg");

var $jFHCE = parcelRequire("jFHCE");

var $eSnSE = parcelRequire("eSnSE");

var $ixiAQ = parcelRequire("ixiAQ");

var $iIqFO = parcelRequire("iIqFO");

var $jipjz = parcelRequire("jipjz");

var $dRfS0 = parcelRequire("dRfS0");

var $eJrcF = parcelRequire("eJrcF");

var $kbiA6 = parcelRequire("kbiA6");

var $9LtGB = parcelRequire("9LtGB");

var $jHGDp = parcelRequire("jHGDp");
const $130ddf635191ef41$var$NewIssueCreateTrigger = ()=>{
    const { data: data } = (0, $eJrcF.useResource)((0, $dRfS0.gicOptInStatusResources));
    const subscriptionHandle = (0, $eJOHy.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($12DRg))));
    const [, { openIssueCreateModal: openIssueCreateModal }] = (0, $jipjz.useTriggerIssueCreateModal)();
    const currentIssueCreateVisibility = data?.gicOptInStatus;
    const getDefaultValues = (0, $kbiA6.usePrefilledDefaultValues)();
    const openIssueCreateDialogHandler = (0, $eJOHy.useCallback)(// @ts-expect-error - TS7006 - Parameter '_payload' implicitly has an 'any' type.
    async (event, _payload)=>{
        let payload;
        if (event instanceof CustomEvent && !_payload) payload = event.detail;
        else payload = _payload;
        const actualPayload = payload?.payload;
        const triggerPointKey = payload?.triggerPointKey;
        const isPrefillingAllowed = !!actualPayload?.isPrefillingAllowed;
        const triggerPointKeySuffix = actualPayload ? actualPayload.triggerPointKeySuffix : '';
        const callback = actualPayload?.callback;
        const title = actualPayload?.title;
        // EXAMPLE of payload not to be transformed
        // {
        //     shouldNotTransform: true,
        //     payload: {
        //         customFieldsToPreserveOnFormRecreation: ['issuelinks'],
        //         defaultValues: {
        //             issueLinks: {
        //                 linkedIssueKeys: ['IC-31'],
        //             },
        //         },
        //     },
        // },
        const extractedPayload = actualPayload?.target ? (0, $9LtGB.extractEventAttributes)(actualPayload.target) : actualPayload;
        let createModalPayload = null;
        if (isPrefillingAllowed) {
            (0, $iIqFO.EcosystemAPIPrefillingUFOExperience).start();
            const { defaultValues: defaultValuesFromAPI, issueType: issueType, projectId: projectId, requestType: requestType } = await getDefaultValues({
                prefilledFieldsData: {
                    ...actualPayload?.prefilledFields
                },
                callContextAPI: true
            });
            extractedPayload.prefilledFields = {
                ...extractedPayload.prefilledFields,
                pid: projectId,
                issuetype: issueType,
                requestype: requestType
            };
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(extractedPayload)) createModalPayload = (0, $9LtGB.transformGICPayload)(extractedPayload, isPrefillingAllowed);
            const mergedDefaultValues = (0, $9LtGB.mergeDefaultValues)(defaultValuesFromAPI, createModalPayload?.defaultValues);
            if (createModalPayload) createModalPayload.defaultValues = mergedDefaultValues;
            const prefilledCustomFields = (0, $9LtGB.filterCustomFields)(extractedPayload);
            (0, $iIqFO.EcosystemAPIPrefillingUFOExperience).success();
            const constructedTriggerPointKey = triggerPointKeySuffix ? `prefilled-issue-create-${triggerPointKeySuffix}` : 'prefilled-issue-create';
            openIssueCreateModal({
                ...(0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(payload, [
                    'shouldNotTransform'
                ]),
                payload: createModalPayload,
                // Will fix the trigger point name once approach is finalised
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                triggerPointKey: constructedTriggerPointKey,
                prefilledCustomFields: prefilledCustomFields,
                ecosystemCallback: {
                    callbackFunction: callback
                },
                ...title && {
                    title: title
                }
            });
        } else if (currentIssueCreateVisibility !== null) {
            if (currentIssueCreateVisibility?.isEnabled) {
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(extractedPayload)) {
                    if (payload?.shouldNotTransform === true) createModalPayload = extractedPayload;
                    else createModalPayload = (0, $9LtGB.transformGICPayload)(extractedPayload);
                }
                openIssueCreateModal({
                    ...(0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(payload, [
                        'shouldNotTransform'
                    ]),
                    payload: createModalPayload,
                    triggerPointKey: triggerPointKey
                });
            } else (0, $ixiAQ.default)((0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(payload, [
                'shouldNotTransform'
            ]));
        } else (0, $eSnSE.default).safeErrorWithoutCustomerData('new-issue-create-trigger', 'visibility data is still getting downloaded');
    }, [
        currentIssueCreateVisibility,
        getDefaultValues,
        openIssueCreateModal
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (currentIssueCreateVisibility !== null) {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.IssueCreate = window.IssueCreate || {};
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.IssueCreate.Visibility = currentIssueCreateVisibility; // For monolith to consume the same
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.JIRA = window.JIRA || {};
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.JIRA.Forms = {
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                ...window.JIRA.Forms,
                modernIssueCreate: (0, $jHGDp.modernIssueCreateInGenericFunctions)
            };
        }
    }, [
        currentIssueCreateVisibility
    ]);
    (0, $eJOHy.useEffect)(()=>{
        // @ts-expect-error - TS2769 - No overload matches this call.
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.addEventListener('openIssueCreateDialog', openIssueCreateDialogHandler);
        subscriptionHandle.current = ()=>// @ts-expect-error - TS2769 - No overload matches this call.
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.removeEventListener('openIssueCreateDialog', openIssueCreateDialogHandler);
        return ()=>{
            subscriptionHandle.current();
            subscriptionHandle.current = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)));
        };
    }, [
        openIssueCreateDialogHandler,
        subscriptionHandle
    ]);
    return null;
};
var $130ddf635191ef41$export$2e2bcd8739ae039 = $130ddf635191ef41$var$NewIssueCreateTrigger;
const $130ddf635191ef41$export$ed5d3f997a26357b = ()=>{
    const [, { openIssueCreateModal: openIssueCreateModal }] = (0, $jipjz.useTriggerIssueCreateModal)();
    const getDefaultValues = (0, $kbiA6.usePrefilledDefaultValues)();
    const openIssueCreateModalHandler = (0, $eJOHy.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    async (triggerPointKey, fields, callback)=>{
        (0, $iIqFO.EcosystemAPIPrefillingUFOExperience).start();
        let fieldList = fields;
        const { defaultValues: defaultValuesFromAPI, issueType: issueType, projectId: projectId, requestType: requestType } = await getDefaultValues({
            prefilledFieldsData: fieldList
        });
        fieldList = {
            ...fieldList,
            pid: projectId,
            issuetype: issueType,
            requestype: requestType
        };
        let payload = null;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(fieldList)) payload = (0, $9LtGB.transformGICPayload)({
            prefilledFields: fieldList
        }, true);
        if (payload) payload.defaultValues = (0, $9LtGB.mergeDefaultValues)(defaultValuesFromAPI, payload?.defaultValues);
        const prefilledCustomFields = (0, $9LtGB.filterCustomFields)({
            prefilledFields: fieldList
        });
        (0, $iIqFO.EcosystemAPIPrefillingUFOExperience).success();
        openIssueCreateModal({
            payload: payload,
            triggerPointKey: // @ts-expect-error string is of type trigger point key, not adding this type as they are not decided yet
            triggerPointKey,
            prefilledCustomFields: prefilledCustomFields,
            ecosystemCallback: {
                callbackFunction: callback
            }
        });
    }, [
        openIssueCreateModal,
        getDefaultValues
    ]);
    return openIssueCreateModalHandler;
};
const $130ddf635191ef41$export$8f837c39a3be9608 = ()=>{
    const getDefaultValues = (0, $kbiA6.usePrefilledDefaultValues)();
    const getPrefilledIssueCreateProps = (0, $eJOHy.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    async (fields, callback)=>{
        (0, $iIqFO.EcosystemAPIPrefillingUFOExperience).start();
        let fieldList = fields;
        const { defaultValues: defaultValuesFromAPI, issueType: issueType, projectId: projectId, requestType: requestType } = await getDefaultValues({
            prefilledFieldsData: fieldList,
            callContextAPI: true
        });
        fieldList = {
            ...fieldList,
            pid: projectId,
            issuetype: issueType,
            requestype: requestType
        };
        let payload = null;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(fieldList)) payload = (0, $9LtGB.transformGICPayload)({
            prefilledFields: fieldList
        }, true);
        if (payload) payload.defaultValues = (0, $9LtGB.mergeDefaultValues)(defaultValuesFromAPI, payload?.defaultValues);
        const prefilledCustomFields = (0, $9LtGB.filterCustomFields)({
            prefilledFields: fieldList
        });
        (0, $iIqFO.EcosystemAPIPrefillingUFOExperience).success();
        return {
            issueCreatePayload: payload,
            prefilledCustomFields: prefilledCustomFields,
            ecosystemCallback: callback ? {
                callbackFunction: callback
            } : undefined
        };
    }, [
        getDefaultValues
    ]);
    return getPrefilledIssueCreateProps;
};

});
parcelRegister("kbiA6", function(module, exports) {

$parcel$export(module.exports, "usePrefilledDefaultValues", () => $58e4d4c9a6562c5d$export$38f7ab2f4d0821a4);

var $eJOHy = parcelRequire("eJOHy");

var $7jTnu = parcelRequire("7jTnu");

var $eDBhy = parcelRequire("eDBhy");

var $jGzN3 = parcelRequire("jGzN3");

var $lRq8t = parcelRequire("lRq8t");

var $hrodw = parcelRequire("hrodw");
var $bILK0 = parcelRequire("bILK0");

var $iIqFO = parcelRequire("iIqFO");

var $kMZx3 = parcelRequire("kMZx3");
const $58e4d4c9a6562c5d$var$ECOSYSTEM_API_PREFILL_DEFAULT_VALUES_API = '/rest/internal/latest/ecosystem/issue/fields';
const $58e4d4c9a6562c5d$var$ECOSYSTEM_API_PREFILL_CONTEXT_FIELDS_API = '/rest/internal/latest/ecosystem/issue/context';
const $58e4d4c9a6562c5d$var$ERROR_MESSAGE_ID = (0, $hrodw.toFlagId)('IssueCreatePrefillFailed');
const $58e4d4c9a6562c5d$var$isObject = (value)=>{
    return value !== null && typeof value === 'object' && !Array.isArray(value);
};
const $58e4d4c9a6562c5d$export$93b4eaa50e476277 = (prefilledFieldsData)=>{
    const modifiedPrefilledFieldsData = {
        fieldsInput: []
    };
    if ($58e4d4c9a6562c5d$var$isObject(prefilledFieldsData)) Object.keys(prefilledFieldsData).forEach((key)=>{
        const data = prefilledFieldsData[key];
        if (Array.isArray(data)) {
            const modifiedData = [];
            for (const value of data)if (typeof value === 'number' || typeof value === 'string') modifiedData.push(value.toString());
            modifiedPrefilledFieldsData.fieldsInput.push({
                fieldId: key,
                values: modifiedData
            });
        } else if (typeof data === 'number' || typeof data === 'string') modifiedPrefilledFieldsData.fieldsInput.push({
            fieldId: key,
            values: [
                data.toString()
            ]
        });
    });
    return modifiedPrefilledFieldsData;
};
const $58e4d4c9a6562c5d$export$fb9547a2d8fedba1 = (modifiedPrefilledFieldsData)=>{
    const options = {
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
        },
        body: JSON.stringify(modifiedPrefilledFieldsData)
    };
    return options;
};
const $58e4d4c9a6562c5d$export$109987e4e4835e7a = (modifiedPrefilledFieldsData, prefilledFieldsData)=>{
    const issueTypeProvided = $58e4d4c9a6562c5d$var$transformInputValueToNumber(prefilledFieldsData?.issuetype)?.toString();
    const projectIdProvided = $58e4d4c9a6562c5d$var$transformInputValueToNumber(prefilledFieldsData?.pid)?.toString();
    const requestData = {
        fields: modifiedPrefilledFieldsData,
        projectId: projectIdProvided,
        issueTypeId: issueTypeProvided
    };
    const options = {
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
        },
        body: JSON.stringify(requestData)
    };
    return options;
};
const $58e4d4c9a6562c5d$var$transformInputValueToNumber = (value)=>{
    let transformedValue = value;
    if (Array.isArray(value)) transformedValue = value[0];
    if ((typeof transformedValue === 'string' || typeof transformedValue === 'number') && Number(transformedValue)) return Number(transformedValue);
    return null;
};
const $58e4d4c9a6562c5d$export$38f7ab2f4d0821a4 = ()=>{
    const { showFlag: showFlag } = (0, $bILK0.useFlagService)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const getDefaultValues = (0, $eJOHy.useCallback)(({ prefilledFieldsData: prefilledFieldsData, callContextAPI: callContextAPI = false })=>{
        const modifiedPrefilledFieldsData = $58e4d4c9a6562c5d$export$93b4eaa50e476277(prefilledFieldsData);
        const fetchContextFieldsData = async ()=>{
            try {
                const inputOptions = $58e4d4c9a6562c5d$export$109987e4e4835e7a(modifiedPrefilledFieldsData, prefilledFieldsData);
                const contextFields = await (0, $jGzN3.performPostRequest)(// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                `${window.location.origin}${$58e4d4c9a6562c5d$var$ECOSYSTEM_API_PREFILL_CONTEXT_FIELDS_API}`, inputOptions);
                return contextFields;
            } catch (error) {
                (0, $iIqFO.EcosystemAPIPrefillingUFOExperience).failure();
                (0, $eDBhy.fireIssueCreateErrorAnalytics)({
                    meta: {
                        id: 'fetchEcosystemContextFieldsData',
                        packageName: 'jiraNewIssueCreateTrigger',
                        teamName: 'gryffindor'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
                showFlag({
                    key: $58e4d4c9a6562c5d$var$ERROR_MESSAGE_ID,
                    type: 'error',
                    title: formatMessage((0, $7jTnu.fg)('jira-issue-terminology-update-m4') ? (0, $kMZx3.default).errorMessageTitleNonFinalIssueTerminologyRefreshM4 : (0, $kMZx3.default).errorMessageTitleNonFinal),
                    description: formatMessage((0, $kMZx3.default).errorMessageDescriptionNonFinal),
                    messageId: 'new-issue-create-trigger.use-prefilled-default-values.show-flag.error.fetch-context-fields-data.show-flag.error',
                    messageType: 'transactional'
                });
            }
        };
        const fetchPrefilledDefaultValues = async ()=>{
            const inputOptions = $58e4d4c9a6562c5d$export$fb9547a2d8fedba1(modifiedPrefilledFieldsData);
            try {
                const defaultValues = await (0, $jGzN3.performPostRequest)($58e4d4c9a6562c5d$var$ECOSYSTEM_API_PREFILL_DEFAULT_VALUES_API, inputOptions);
                return defaultValues;
            } catch (error) {
                (0, $iIqFO.EcosystemAPIPrefillingUFOExperience).failure();
                (0, $eDBhy.fireIssueCreateErrorAnalytics)({
                    meta: {
                        id: 'ecosystemAPIPrefillDefaultValues',
                        packageName: 'jiraNewIssueCreateTrigger',
                        teamName: 'gryffindor'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
                showFlag({
                    key: $58e4d4c9a6562c5d$var$ERROR_MESSAGE_ID,
                    type: 'error',
                    title: formatMessage((0, $7jTnu.fg)('jira-issue-terminology-update-m4') ? (0, $kMZx3.default).errorMessageTitleNonFinalIssueTerminologyRefreshM4 : (0, $kMZx3.default).errorMessageTitleNonFinal),
                    description: formatMessage((0, $kMZx3.default).errorMessageDescriptionNonFinal),
                    messageId: 'new-issue-create-trigger.use-prefilled-default-values.show-flag.error.fetch-prefilled-default-values.show-flag.error',
                    messageType: 'transactional'
                });
            }
        };
        const getPrefilledData = async ()=>{
            if (!callContextAPI) {
                const defaultValues = await fetchPrefilledDefaultValues();
                const issueType = $58e4d4c9a6562c5d$var$transformInputValueToNumber(prefilledFieldsData?.issuetype);
                const projectId = $58e4d4c9a6562c5d$var$transformInputValueToNumber(prefilledFieldsData?.pid);
                const requestType = prefilledFieldsData?.requestType;
                return {
                    defaultValues: defaultValues,
                    issueType: issueType,
                    projectId: projectId,
                    requestType: requestType
                };
            }
            const [defaultValues, contextFieldsData] = await Promise.all([
                fetchPrefilledDefaultValues(),
                fetchContextFieldsData()
            ]);
            const issueType = contextFieldsData?.issueType?.issueTypeId;
            const projectId = contextFieldsData?.project?.projectId;
            const requestType = contextFieldsData?.requestType?.key;
            return {
                defaultValues: defaultValues,
                issueType: issueType,
                projectId: projectId,
                requestType: requestType
            };
        };
        return getPrefilledData();
    }, [
        formatMessage,
        showFlag
    ]);
    return getDefaultValues;
};

});
parcelRegister("kMZx3", function(module, exports) {

$parcel$export(module.exports, "default", () => $9bd3430eb5f22960$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $9bd3430eb5f22960$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    errorMessageTitleNonFinal: {
        "id": "new-issue-create-trigger.use-prefilled-default-values.error-message-title-non-final",
        "defaultMessage": "We weren't able to open the issue create modal!"
    },
    errorMessageDescriptionNonFinal: {
        "id": "new-issue-create-trigger.use-prefilled-default-values.error-message-description-non-final",
        "defaultMessage": "Please try again or contact your administrator if the problem persists."
    },
    errorMessageTitleNonFinalIssueTerminologyRefreshM4: {
        "id": "new-issue-create-trigger.use-prefilled-default-values.error-message-title-non-final-issue-terminology-refresh-m4",
        "defaultMessage": "We weren't able to open the work item create modal"
    }
});

});


parcelRegister("9LtGB", function(module, exports) {

$parcel$export(module.exports, "generateDefaultValues", () => $4964d6f513930168$export$300f392f5922240);
$parcel$export(module.exports, "extractEventAttributes", () => $4964d6f513930168$export$1e69307ca1d0a0a);
$parcel$export(module.exports, "filterCustomFields", () => $4964d6f513930168$export$3d0318b836ef9005);
$parcel$export(module.exports, "mergeDefaultValues", () => $4964d6f513930168$export$2b461e4b4c8d36cf);
$parcel$export(module.exports, "transformGICPayload", () => $4964d6f513930168$export$db3a4d24608ba186);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $8dH3d = parcelRequire("8dH3d");

var $3Q6BV = parcelRequire("3Q6BV");

var $fRoGq = parcelRequire("fRoGq");

var $eGXjT = parcelRequire("eGXjT");
const $4964d6f513930168$var$CUSTOM_FIELD_PREFIX = 'customfield';
// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-constraint
const $4964d6f513930168$var$mergePrefilled = (oldPayload, newPayload)=>{
    if (newPayload !== null && newPayload !== undefined) // @ts-expect-error - TS2698 - Spread types may only be created from object types. | TS2698 - Spread types may only be created from object types.
    return {
        ...oldPayload,
        ...newPayload
    };
    return oldPayload;
};
const $4964d6f513930168$var$returnActualValue = (value)=>{
    if (Array.isArray(value)) return value[0].toString();
    return value.toString();
};
// @ts-expect-error - TS7023 - 'mergeFormat' implicitly has return type 'any' because it does not have a return type annotation and is referenced directly or indirectly in one of its return expressions. | TS7006 - Parameter 'format' implicitly has an 'any' type.
const $4964d6f513930168$var$mergeFormat = (format, finalKey, finalValue)=>{
    // Ideally format can be object or string
    // Format will only contain 1 object having single key/value where value can be null or an object
    // go inside and wherever we find first null, replace the same with the value.
    // some of the mutation use fieldId whereas other uses like priorityId
    // so whichever key has value === ID will replace the same with the proper mutationKey
    if (typeof format === 'string') {
        if (format === 'ID') return finalKey;
        return format;
    }
    // recursively goes inside to find the null and key param and replace with the corresponding values
    // Also checks for array like labels
    return Object.keys(format).reduce((accumulator, currentKey)=>{
        const currentValue = format[currentKey];
        if (Array.isArray(currentValue)) {
            const mappedValue = Array.isArray(finalValue) ? finalValue : [
                finalValue
            ];
            return {
                // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
                ...accumulator,
                [currentKey]: mappedValue.map((val)=>$4964d6f513930168$var$mergeFormat(currentValue[0], finalKey, val))
            };
        }
        return {
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...accumulator,
            [currentKey]: currentValue === null ? $4964d6f513930168$var$returnActualValue(finalValue) : $4964d6f513930168$var$mergeFormat(format[currentKey], finalKey, finalValue)
        };
    }, {});
};
const $4964d6f513930168$var$generateDefaultValuesForEcosystemAPI = (otherFields)=>{
    const defaultValues = {};
    const fieldIds = [];
    Object.keys(otherFields).forEach((mutationKey)=>{
        const mutationValue = otherFields[mutationKey];
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly summary: "singleLineTextFields"; readonly epic: "epicLinkField"; readonly epicName: "singleLineTextFields"; readonly duedate: "datePickerFields"; readonly startdate: "datePickerFields"; ... 7 more ...; readonly components: "components"; }'.
        if ((0, $eGXjT.ECOSYSTEM_API_FIELD_MAPPER_MUTATION_GROUP)[mutationKey]) {
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly summary: "singleLineTextFields"; readonly epic: "epicLinkField"; readonly epicName: "singleLineTextFields"; readonly duedate: "datePickerFields"; readonly startdate: "datePickerFields"; ... 7 more ...; readonly components: "components"; }'.
            const mutationGroup = (0, $eGXjT.ECOSYSTEM_API_FIELD_MAPPER_MUTATION_GROUP)[mutationKey];
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly summary: "singleLineTextFields"; readonly epic: "epicLinkField"; readonly epicName: "singleLineTextFields"; readonly duedate: "datePickerFields"; readonly startdate: "datePickerFields"; ... 7 more ...; readonly components: "components"; }'.
            const formattedValue = (0, $eGXjT.ECOSYSTEM_API_FIELD_FORMATTER)[mutationGroup](mutationKey, mutationValue);
            if (formattedValue) {
                const { value: value, type: type } = formattedValue;
                fieldIds.push(mutationKey);
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(value)) {
                    if (type === 'array') (defaultValues[mutationGroup] = defaultValues[mutationGroup] || []).push(value);
                    else if (type === 'object') defaultValues[mutationGroup] = value;
                }
            }
        }
    });
    return {
        defaultValues: defaultValues,
        fieldIds: fieldIds
    };
};
const $4964d6f513930168$var$generateDefaultValuesLegacy = (otherFields)=>{
    const defaultValues = {};
    const fieldIds = [];
    Object.keys(otherFields).forEach((mutationKey)=>{
        const mutationValue = otherFields[mutationKey];
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly summary: "singleLineTextFields"; readonly epic: "epicLinkField"; readonly epicName: "singleLineTextFields"; readonly duedate: "datePickerFields"; readonly startdate: "datePickerFields"; ... 7 more ...; readonly components: "components"; }'.
        if ((0, $fRoGq.FIELD_MAPPER_MUTATION_GROUP)[mutationKey]) {
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly summary: "singleLineTextFields"; readonly epic: "epicLinkField"; readonly epicName: "singleLineTextFields"; readonly duedate: "datePickerFields"; readonly startdate: "datePickerFields"; ... 7 more ...; readonly components: "components"; }'.
            const mutationGroup = (0, $fRoGq.FIELD_MAPPER_MUTATION_GROUP)[mutationKey];
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly singleLineTextFields: { readonly value: { readonly fieldId: "ID"; readonly text: null; }; readonly type: "array"; }; readonly epicLinkField: { readonly value: { readonly fieldId: "ID"; readonly epicLink: { readonly issueKey: null; }; }; readonly type: "object"; }; ... 7 more ...; readonly components: { .....'.
            const { type: type = null, value: depth = null } = (0, $fRoGq.FORMATTER)[mutationGroup];
            let pattern = null;
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(mutationValue) && depth && type) {
                if (!Array.isArray(mutationValue) && typeof mutationValue === 'object') {
                    const { fieldId: fieldId, fieldValue: fieldValue } = mutationValue;
                    // If fieldValue is different from the key like custom fields
                    pattern = $4964d6f513930168$var$mergeFormat(depth, fieldId || mutationKey, fieldValue);
                    fieldIds.push(fieldId || mutationKey);
                } else {
                    // same as key like summary etc.
                    pattern = $4964d6f513930168$var$mergeFormat(depth, mutationKey, mutationValue);
                    fieldIds.push(mutationKey);
                }
            }
            // merge mutations based on type as some mutations are object whereas others are arrays
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(pattern)) {
                if (type === 'array') (defaultValues[mutationGroup] = defaultValues[mutationGroup] || []).push(pattern);
                else if (type === 'object') defaultValues[mutationGroup] = pattern;
            }
        }
    });
    return {
        defaultValues: defaultValues,
        fieldIds: fieldIds
    };
};
const $4964d6f513930168$export$300f392f5922240 = (otherFields, isEcosystemAPI = false)=>{
    if (isEcosystemAPI) return $4964d6f513930168$var$generateDefaultValuesForEcosystemAPI(otherFields);
    return $4964d6f513930168$var$generateDefaultValuesLegacy(otherFields);
};
const $4964d6f513930168$export$1e69307ca1d0a0a = (trigger)=>{
    const anchor = trigger.nodeName === 'A' ? trigger : trigger.querySelector('a');
    if (anchor) {
        const href = anchor.getAttribute('href');
        // @ts-expect-error - TS2769 - No overload matches this call. | TS7006 - Parameter 'qs' implicitly has an 'any' type.
        const { query: query } = (0, (/*@__PURE__*/$parcel$interopDefault($3Q6BV)))(href, (qs)=>new URLSearchParams(qs));
        const returnData = {
            prefilledFields: {}
        };
        // If data attributes exist, we will prefer those over the query params.
        // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'. | TS2349 - This expression is not callable.
        const pid = anchor.getAttribute('data-pid') || query.get('pid');
        // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'. | TS2349 - This expression is not callable.
        const issuetype = anchor.getAttribute('data-issue-type') || query.get('issuetype');
        // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'. | TS2349 - This expression is not callable.
        const requestype = anchor.getAttribute('data-itsm-category') || query.get('itsmCategory');
        if (pid) // @ts-expect-error - TS2339 - Property 'pid' does not exist on type '{}'.
        returnData.prefilledFields.pid = pid;
        if (issuetype) // @ts-expect-error - TS2339 - Property 'issuetype' does not exist on type '{}'.
        returnData.prefilledFields.issuetype = issuetype;
        if (requestype) // @ts-expect-error - TS2339 - Property 'requestype' does not exist on type '{}'.
        returnData.prefilledFields.requestype = requestype;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(returnData.prefilledFields)) return returnData;
        return {};
    }
    return {};
};
const $4964d6f513930168$export$70cb7a42e309786 = (payload = {}, isEcosystemAPI = false)=>{
    const { prefilledFields: gicPreFilledFields, target: target = null } = payload;
    let prefilledFields = gicPreFilledFields;
    if (target) {
        const newPayload = $4964d6f513930168$export$1e69307ca1d0a0a(target);
        prefilledFields = $4964d6f513930168$var$mergePrefilled(gicPreFilledFields, newPayload.prefilledFields);
    }
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(prefilledFields)) {
        const { fieldsToRetain: fieldsToRetain = [], pid: pid, issuetype: issuetype, requestype: requestype, additionalContext: additionalContext, statusId: statusId, ...otherFields } = prefilledFields;
        const outputPayload = {};
        if ((!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(pid) || typeof pid === 'number') && pid !== 'undefined') outputPayload.project = {
            projectId: $4964d6f513930168$var$returnActualValue(pid)
        };
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(issuetype) || typeof issuetype === 'number') outputPayload.issueType = {
            issueTypeId: $4964d6f513930168$var$returnActualValue(issuetype)
        };
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(requestype)) outputPayload.requestType = {
            key: $4964d6f513930168$var$returnActualValue(requestype)
        };
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(otherFields.parentId)) outputPayload.parentId = {
            parentId: $4964d6f513930168$var$returnActualValue(otherFields.parentId)
        };
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(statusId)) outputPayload.status = {
            statusId: statusId
        };
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(additionalContext)) outputPayload.additionalContext = additionalContext;
        // for other fields
        if (Object.keys(otherFields).length > 0) {
            const { parentId: parentId, ...otherFieldsWithoutParent } = otherFields;
            const { defaultValues: defaultValues, fieldIds: fieldIds } = $4964d6f513930168$export$300f392f5922240(parentId !== undefined && !(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(parentId) ? {
                parent: parentId,
                ...otherFieldsWithoutParent
            } : otherFieldsWithoutParent, isEcosystemAPI);
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(defaultValues)) outputPayload.defaultValues = defaultValues;
            outputPayload.customFieldsToPreserveOnFormRecreation = [
                ...fieldsToRetain,
                ...fieldIds
            ];
        }
        return outputPayload;
    }
    return null;
};
const $4964d6f513930168$export$3d0318b836ef9005 = (payload = {})=>{
    // customField's id's start with the name customfield https://confluence.atlassian.com/adminjiraserver/advanced-use-of-the-jira-issue-collector-938847349.html
    const fieldsToPrefill = payload?.prefilledFields;
    if (!fieldsToPrefill) return {};
    const prefilledCustomFields = {};
    const systemFieldsToBeIncluded = [
        'worklog_timeLogged',
        'worklog_startDate',
        'worklog_comment',
        'timetracking_remainingestimate',
        'description',
        'paragraph',
        'environment'
    ];
    Object.keys(fieldsToPrefill).forEach((key)=>{
        if (key.startsWith($4964d6f513930168$var$CUSTOM_FIELD_PREFIX) || systemFieldsToBeIncluded.includes(key)) prefilledCustomFields[key] = fieldsToPrefill[key];
    });
    return prefilledCustomFields;
};
const $4964d6f513930168$export$2b461e4b4c8d36cf = (defaultValuesFromAPI = {}, defaultValuesFromFE = {})=>{
    const mergedDefaultValues = JSON.parse(JSON.stringify(defaultValuesFromAPI));
    if (!defaultValuesFromFE) return mergedDefaultValues;
    Object.keys(defaultValuesFromFE).forEach((key)=>{
        if (mergedDefaultValues?.key) mergedDefaultValues[key] = {
            ...mergedDefaultValues[key],
            ...defaultValuesFromFE[key]
        };
        else mergedDefaultValues[key] = defaultValuesFromFE[key];
    });
    return mergedDefaultValues;
};
const $4964d6f513930168$export$db3a4d24608ba186 = $4964d6f513930168$export$70cb7a42e309786;

});
parcelRegister("fRoGq", function(module, exports) {

$parcel$export(module.exports, "FORMATTER", () => $5eb972acc80e3785$export$92cfe806f4f0ae2f);
$parcel$export(module.exports, "FIELD_MAPPER_MUTATION_GROUP", () => $5eb972acc80e3785$export$6669905e89f27d17);
const $5eb972acc80e3785$export$92cfe806f4f0ae2f = {
    singleLineTextFields: {
        value: {
            fieldId: 'ID',
            text: null
        },
        type: 'array'
    },
    epicLinkField: {
        value: {
            fieldId: 'ID',
            epicLink: {
                issueKey: null
            }
        },
        type: 'object'
    },
    sprintsField: {
        value: {
            fieldId: 'ID',
            sprints: [
                {
                    sprintId: null
                }
            ]
        },
        type: 'object'
    },
    priority: {
        value: {
            priorityId: 'ID'
        },
        type: 'object'
    },
    datePickerFields: {
        value: {
            fieldId: 'ID',
            date: {
                formattedDate: null
            }
        },
        type: 'array'
    },
    dateTimePickerFields: {
        value: {
            fieldId: 'ID',
            dateTime: {
                formattedDateTime: null
            }
        },
        type: 'array'
    },
    labelsFields: {
        value: {
            fieldId: 'ID',
            labels: [
                {
                    name: null
                }
            ]
        },
        type: 'array'
    },
    singleSelectUserPickerFields: {
        value: {
            fieldId: 'ID',
            user: {
                accountId: null
            }
        },
        type: 'array'
    },
    multipleVersionPickerFields: {
        value: {
            fieldId: 'ID',
            versions: [
                {
                    versionId: null
                }
            ]
        },
        type: 'array'
    },
    components: {
        value: {
            componentId: null
        },
        type: 'array'
    },
    parentField: {
        value: {
            issueId: null
        },
        type: 'object'
    }
};
const $5eb972acc80e3785$export$6669905e89f27d17 = {
    summary: 'singleLineTextFields',
    epic: 'epicLinkField',
    epicName: 'singleLineTextFields',
    duedate: 'datePickerFields',
    startdate: 'datePickerFields',
    plannedStartDate: 'dateTimePickerFields',
    plannedEndDate: 'dateTimePickerFields',
    labels: 'labelsFields',
    sprint: 'sprintsField',
    assignee: 'singleSelectUserPickerFields',
    reporter: 'singleSelectUserPickerFields',
    fixVersions: 'multipleVersionPickerFields',
    components: 'components',
    parent: 'parentField'
};

});

parcelRegister("eGXjT", function(module, exports) {

$parcel$export(module.exports, "ECOSYSTEM_API_FIELD_FORMATTER", () => $a7c52695fe4779f9$export$8ef3266ee07318b4);
$parcel$export(module.exports, "ECOSYSTEM_API_FIELD_MAPPER_MUTATION_GROUP", () => $a7c52695fe4779f9$export$343b44fa14f045e3);

var $bu7JM = parcelRequire("bu7JM");
const $a7c52695fe4779f9$export$8ef3266ee07318b4 = {
    security: (id, input)=>{
        if ((0, $bu7JM.checkIfValidId)(input)) return {
            value: {
                securityLevelId: Number(input)
            },
            type: 'object'
        };
        if (Array.isArray(input) && input.length > 0 && (0, $bu7JM.checkIfValidId)(input[0])) return {
            value: {
                securityLevelId: Number(input[0])
            },
            type: 'object'
        };
    },
    singleLineTextFields: (id, input)=>{
        if (typeof input === 'string' || typeof input === 'number') return {
            value: {
                fieldId: id,
                text: input.toString()
            },
            type: 'array'
        };
        if (Array.isArray(input) && input.length > 0) return {
            value: {
                fieldId: id,
                text: input[0].toString()
            },
            type: 'array'
        };
    },
    timeTrackingField: (id, input)=>{
        if (typeof input === 'string') return {
            value: {
                originalEstimate: input
            },
            type: 'object'
        };
        if (Array.isArray(input) && input.length > 0 && typeof input[0] === 'string') return {
            value: {
                originalEstimate: input[0]
            },
            type: 'object'
        };
    },
    priority: (id, input)=>{
        if ((0, $bu7JM.checkIfValidId)(input)) return {
            value: {
                priorityId: Number(input)
            },
            type: 'object'
        };
        if (Array.isArray(input) && input.length > 0 && (0, $bu7JM.checkIfValidId)(input[0])) return {
            value: {
                priorityId: Number(input[0])
            },
            type: 'object'
        };
    },
    resolution: (id, input)=>{
        if ((0, $bu7JM.checkIfValidId)(input)) return {
            value: {
                resolutionId: Number(input)
            },
            type: 'object'
        };
        if (Array.isArray(input) && input.length > 0 && (0, $bu7JM.checkIfValidId)(input[0])) return {
            value: {
                resolutionId: Number(input[0])
            },
            type: 'object'
        };
        return {
            value: {
                resolutionId: 10000
            },
            type: 'object'
        };
    },
    datePickerFields: (id, input)=>{
        if (typeof input === 'string') {
            const dateInISO = (0, $bu7JM.findADate)(input);
            if (dateInISO) return {
                value: {
                    fieldId: id,
                    date: {
                        formattedDate: dateInISO
                    }
                },
                type: 'array'
            };
        }
        if (Array.isArray(input) && input.length > 0 && typeof input[0] === 'string') {
            const dateInISO = (0, $bu7JM.findADate)(input[0]);
            if (dateInISO) return {
                value: {
                    fieldId: id,
                    date: {
                        formattedDate: dateInISO
                    }
                },
                type: 'array'
            };
        }
    },
    dateTimePickerFields: (id, input)=>{
        if (typeof input === 'string') {
            const dateInISO = (0, $bu7JM.findADate)(input);
            if (dateInISO) return {
                value: {
                    fieldId: id,
                    dateTime: {
                        formattedDateTime: dateInISO
                    }
                },
                type: 'array'
            };
        }
        if (Array.isArray(input) && input.length > 0 && typeof input[0] === 'string') {
            const dateInISO = (0, $bu7JM.findADate)(input[0]);
            if (dateInISO) return {
                value: {
                    fieldId: id,
                    dateTime: {
                        formattedDateTime: dateInISO
                    }
                },
                type: 'array'
            };
        }
    },
    labelsFields: (id, input)=>{
        let transformedValue = [];
        if (Array.isArray(input) && input.length > 0) {
            for (const label of input)if (typeof label === 'string' || typeof label === 'number') transformedValue.push({
                name: label.toString()
            });
        } else if (typeof input === 'string' || typeof input === 'number') transformedValue = [
            {
                name: input.toString()
            }
        ];
        return {
            value: {
                fieldId: id,
                labels: transformedValue
            },
            type: 'array'
        };
    },
    multipleVersionPickerFields: (id, input)=>{
        let transformedValue = [];
        if (Array.isArray(input) && input.length > 0) {
            for (const version of input)if ((0, $bu7JM.checkIfValidId)(version)) transformedValue.push({
                versionId: Number(version)
            });
        } else if ((0, $bu7JM.checkIfValidId)(input)) transformedValue = [
            {
                versionId: Number(input)
            }
        ];
        return {
            value: {
                fieldId: id,
                versions: transformedValue
            },
            type: 'array'
        };
    },
    components: (id, input)=>{
        let transformedValue = [];
        if (Array.isArray(input) && input.length > 0) {
            for (const component of input)if ((0, $bu7JM.checkIfValidId)(component)) transformedValue.push({
                componentId: Number(component)
            });
        } else if ((0, $bu7JM.checkIfValidId)(input)) transformedValue = [
            {
                componentId: Number(input)
            }
        ];
        return {
            value: transformedValue,
            type: 'object'
        };
    },
    parentField: (id, input)=>{
        if ((0, $bu7JM.checkIfValidId)(input)) return {
            value: {
                issueId: Number(input)
            },
            type: 'object'
        };
        if (Array.isArray(input) && input.length > 0 && (0, $bu7JM.checkIfValidId)(input[0])) return {
            value: {
                issueId: Number(input[0])
            },
            type: 'object'
        };
    }
};
const $a7c52695fe4779f9$export$343b44fa14f045e3 = {
    security: 'security',
    resolution: 'resolution',
    summary: 'singleLineTextFields',
    epicName: 'singleLineTextFields',
    duedate: 'datePickerFields',
    startdate: 'datePickerFields',
    labels: 'labelsFields',
    fixVersions: 'multipleVersionPickerFields',
    versions: 'multipleVersionPickerFields',
    components: 'components',
    parent: 'parentField',
    priority: 'priority',
    timetracking_originalestimate: 'timeTrackingField'
};

});
parcelRegister("bu7JM", function(module, exports) {

$parcel$export(module.exports, "findADate", () => $c1ccc19d7bfcb257$export$3ce9cccf56f196eb);
$parcel$export(module.exports, "checkIfValidId", () => $c1ccc19d7bfcb257$export$d65005e77da517bc);
const $c1ccc19d7bfcb257$var$monthMap = {
    Jan: '01',
    January: '01',
    Feb: '02',
    February: '02',
    Mar: '03',
    March: '03',
    Apr: '04',
    April: '04',
    May: '05',
    Jun: '06',
    June: '06',
    Jul: '07',
    July: '07',
    Aug: '08',
    August: '08',
    Sep: '09',
    September: '09',
    Oct: '10',
    October: '10',
    Nov: '11',
    November: '11',
    Dec: '12',
    December: '12'
};
const $c1ccc19d7bfcb257$var$formatDay = (day)=>{
    if (day.length === 1) return `0${day}`;
    return day;
};
const $c1ccc19d7bfcb257$var$formatMonth = (month)=>{
    if ($c1ccc19d7bfcb257$var$monthMap[month]) return $c1ccc19d7bfcb257$var$monthMap[month];
    if (month.length === 1) return `0${month}`;
    return month;
};
const $c1ccc19d7bfcb257$var$formatYear = (year)=>{
    const yearAsNumber = Number(year);
    if (yearAsNumber < 100) return yearAsNumber + 2000;
    return yearAsNumber;
};
const $c1ccc19d7bfcb257$var$constructISOTime = (time)=>{
    const timeStr = time.trim();
    const time24HourPattern = /^T(\d{1,2}):(\d{2}):?(\d{2})?$/;
    const time12HourPattern = /^@?\s*(\d{1,2}):(\d{2})\s*(am|pm)?$/i;
    const match24Hour = timeStr.match(time24HourPattern);
    if (match24Hour) {
        // eslint-disable-next-line prefer-const
        let [, hours, minutes, seconds] = match24Hour;
        seconds = seconds || '00';
        return `${hours.padStart(2, '0')}:${minutes.padStart(2, '0')}:${seconds.padStart(2, '0')}`;
    }
    const match12Hour = timeStr.match(time12HourPattern);
    if (match12Hour) {
        let hours;
        let minutes;
        let ampm;
        [, hours, minutes, ampm] = match12Hour;
        hours = parseInt(hours, 10);
        minutes = parseInt(minutes, 10);
        if (ampm) {
            ampm = ampm.toLowerCase();
            if (ampm === 'pm' && hours !== 12) hours += 12;
            else if (ampm === 'am' && hours === 12) hours = 0;
        }
        return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:00`;
    }
    return '00:00:00';
};
const $c1ccc19d7bfcb257$var$constructISODateTime = (date)=>{
    const regexForDay = /^(\d{1,2})[/\s-]([A-Za-z]+|\d{1,2})[/\s-](\d{2,4})(.*)/;
    const regexForDateWithYYYYFirst = /^(\d{2,4})[/\s-]([A-Za-z]+|\d{1,2})[/\s-](\d{1,2})(.*)/;
    const matchForDay = date.match(regexForDay);
    const matchForDayWithYYYYFirst = date.match(regexForDateWithYYYYFirst);
    if (matchForDay) {
        const [, day, month, year, time] = matchForDay;
        let formattedDay = $c1ccc19d7bfcb257$var$formatDay(day);
        let formattedMonth = $c1ccc19d7bfcb257$var$formatMonth(month);
        const formattedYear = $c1ccc19d7bfcb257$var$formatYear(year);
        let skipMatchingDay = false;
        if (Number(day) < 13 && Number(month)) [formattedDay, formattedMonth] = [
            formattedMonth,
            formattedDay
        ];
        else if (Number(formattedMonth) > 12) {
            if (Number(formattedDay) < 13) [formattedDay, formattedMonth] = [
                formattedMonth,
                formattedDay
            ];
            else skipMatchingDay = true;
        }
        if (!skipMatchingDay) {
            const isoTime = $c1ccc19d7bfcb257$var$constructISOTime(time);
            return `${formattedYear}-${formattedMonth}-${formattedDay}T${isoTime}`;
        }
    }
    if (matchForDayWithYYYYFirst) {
        const [, year, month, day, time] = matchForDayWithYYYYFirst;
        let formattedDay = $c1ccc19d7bfcb257$var$formatDay(day);
        let formattedMonth = $c1ccc19d7bfcb257$var$formatMonth(month);
        const formattedYear = $c1ccc19d7bfcb257$var$formatYear(year);
        if (Number(formattedMonth) > 12) {
            if (Number(formattedDay) < 13) [formattedDay, formattedMonth] = [
                formattedMonth,
                formattedDay
            ];
            else return null;
        }
        const isoTime = $c1ccc19d7bfcb257$var$constructISOTime(time);
        return `${formattedYear}-${formattedMonth}-${formattedDay}T${isoTime}`;
    }
    return null;
};
function $c1ccc19d7bfcb257$var$convertUnixToISO(unixTimestamp) {
    const date = new Date(unixTimestamp * 1000);
    if (!date.getTime()) return null;
    return date.toISOString().slice(0, 19);
}
const $c1ccc19d7bfcb257$export$3ce9cccf56f196eb = (defaultValue)=>{
    if (typeof defaultValue === 'number') return $c1ccc19d7bfcb257$var$convertUnixToISO(defaultValue);
    if (typeof defaultValue === 'string') {
        if (Number(defaultValue)) return $c1ccc19d7bfcb257$var$convertUnixToISO(Number(defaultValue));
        return $c1ccc19d7bfcb257$var$constructISODateTime(defaultValue);
    }
    return null;
};
const $c1ccc19d7bfcb257$export$d65005e77da517bc = (input)=>{
    if ((typeof input === 'string' || typeof input === 'number') && Number(input)) return true;
    return false;
};

});



parcelRegister("jHGDp", function(module, exports) {

$parcel$export(module.exports, "modernIssueCreateInGenericFunctions", () => $338619a372b35ad8$export$ab5024c1d22c7420);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $338619a372b35ad8$export$ab5024c1d22c7420 = (params)=>{
    const fields = params?.fields;
    const title = params?.title;
    const callback = params?.callback;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    document.dispatchEvent(new CustomEvent('openIssueCreateDialog', {
        detail: {
            payload: {
                triggerPointKeySuffix: 'generic',
                isPrefillingAllowed: true,
                callback: callback,
                title: title,
                prefilledFields: fields ? {
                    pid: fields?.pid,
                    issuetype: fields?.issueType,
                    ...fields?.fields
                } : {}
            }
        }
    }));
};

});


parcelRegister("a3hJj", function(module, exports) {

$parcel$export(module.exports, "getProductForAdminHubAi", () => $bfc659447714d899$export$a26765b70278d921);
$parcel$export(module.exports, "transformTheIssueDataToGICFormat", () => $bfc659447714d899$export$394f5c2eb5e83289);
const $bfc659447714d899$var$PRODUCT_NAME = {
    CORE: 'core',
    JIRA: 'jira',
    SERVICEDESK: 'serviceDesk',
    SOFTWARE: 'software',
    PRODUCT_DISCOVERY: 'product-discovery',
    CUSTOMER_SERVICE: 'customer-service'
};
const $bfc659447714d899$var$ADMIN_HUB_AI_PRODUCT = {
    JIRA_CORE: 'jira-core',
    JIRA_SERVICEDESK: 'jira-servicedesk',
    JIRA_CUSTOMER_SERVICE: 'jira-customer-service',
    JIRA_SOFTWARE: 'jira-software',
    JIRA_PRODUCT_DISCOVERY: 'jira-product-discovery'
};
const $bfc659447714d899$var$STRING_FIELDS = [
    'summary',
    'duedate'
];
const $bfc659447714d899$var$SINGLE_SELECT_FIELDS = [
    'assignee',
    'priority'
];
const $bfc659447714d899$var$MULTI_SELECT_FIELDS = [
    'components',
    'fixVersions',
    'versions'
];
const $bfc659447714d899$var$ARRAY_FIELDS = [
    'labels'
];
const $bfc659447714d899$export$a26765b70278d921 = (product)=>{
    switch(product){
        case $bfc659447714d899$var$PRODUCT_NAME.CORE:
            return $bfc659447714d899$var$ADMIN_HUB_AI_PRODUCT.JIRA_CORE;
        case $bfc659447714d899$var$PRODUCT_NAME.SERVICEDESK:
            return $bfc659447714d899$var$ADMIN_HUB_AI_PRODUCT.JIRA_SERVICEDESK;
        case $bfc659447714d899$var$PRODUCT_NAME.CUSTOMER_SERVICE:
            return $bfc659447714d899$var$ADMIN_HUB_AI_PRODUCT.JIRA_CUSTOMER_SERVICE;
        case $bfc659447714d899$var$PRODUCT_NAME.PRODUCT_DISCOVERY:
            return $bfc659447714d899$var$ADMIN_HUB_AI_PRODUCT.JIRA_PRODUCT_DISCOVERY;
        case $bfc659447714d899$var$PRODUCT_NAME.SOFTWARE:
        case $bfc659447714d899$var$PRODUCT_NAME.JIRA:
        default:
            return $bfc659447714d899$var$ADMIN_HUB_AI_PRODUCT.JIRA_SOFTWARE;
    }
};
const $bfc659447714d899$var$handleSingleSelect = (value)=>{
    if (value && typeof value === 'object' && 'id' in value) return value.id;
    if (value && typeof value === 'object' && 'accountId' in value) return value.accountId;
    return value;
};
const $bfc659447714d899$var$handleArray = (value)=>{
    return value.map((item)=>{
        if (typeof item === 'string') return item;
        if (item && typeof item === 'object') return $bfc659447714d899$var$handleSingleSelect(item);
        return item;
    });
};
const $bfc659447714d899$export$394f5c2eb5e83289 = (inputObject)=>{
    const outputObject = {};
    if (!inputObject) return outputObject;
    // Iterate over the entries of the input object
    for (const [key, value] of Object.entries(inputObject)){
        if (typeof value === 'string' && $bfc659447714d899$var$STRING_FIELDS.includes(key)) outputObject[key] = value;
        else if (Array.isArray(value) && ($bfc659447714d899$var$MULTI_SELECT_FIELDS.includes(key) || $bfc659447714d899$var$ARRAY_FIELDS.includes(key))) outputObject[key] = $bfc659447714d899$var$handleArray(value);
        else if (typeof value === 'object' && $bfc659447714d899$var$SINGLE_SELECT_FIELDS.includes(key)) outputObject[key] = $bfc659447714d899$var$handleSingleSelect(value);
    }
    return outputObject;
};

});

parcelRegister("1gw7q", function(module, exports) {

$parcel$export(module.exports, "default", () => $eefdb241b1695bc3$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $eefdb241b1695bc3$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    similarWorkItems: {
        "id": "ai-related-issues.find-similar-work-items.similar-work-items",
        "defaultMessage": "Similar work items"
    }
});

});


parcelRegister("faLFr", function(module, exports) {

$parcel$export(module.exports, "default", () => $45fecb16f64dd2d9$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $goZPP = parcelRequire("goZPP");

var $6svxr = parcelRequire("6svxr");

var $d3cA1 = parcelRequire("d3cA1");

var $sY9BV = parcelRequire("sY9BV");

var $6joHJ = parcelRequire("6joHJ");

var $kDaaB = parcelRequire("kDaaB");

var $coifs = parcelRequire("coifs");

var $4xbv3 = parcelRequire("4xbv3");
var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $jjTgs = parcelRequire("jjTgs");

var $lU3Cq = parcelRequire("lU3Cq");
const $45fecb16f64dd2d9$var$IncompatibleField = (props)=>{
    const isMountEventFired = (0, $eJOHy.useRef)(false);
    const [isInfoMessageOpen, setInfoMessageOpen] = (0, $eJOHy.useState)(false);
    const { fieldId: fieldId, fieldName: fieldName, isRequired: isRequired = false, description: description, projectType: projectType, gqlType: gqlType, fieldType: fieldType, onFieldMount: onFieldMount, isMini: isMini } = props;
    (0, $eJOHy.useEffect)(()=>{
        if (isMountEventFired.current === false) {
            isMountEventFired.current = true;
            onFieldMount(fieldId);
        }
    }, [
        onFieldMount,
        fieldId
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const closeInfoMessage = ()=>{
        setInfoMessageOpen(false);
    };
    const toggleInfoMessageVisibility = ()=>{
        if (isInfoMessageOpen === true) {
            closeInfoMessage();
            return;
        }
        setInfoMessageOpen(true);
        const analyticsEvent = createAnalyticsEvent({
            actionSubject: 'inlineDialog',
            action: 'viewed'
        });
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'globalIssueCreateFieldUnsupported');
    };
    (0, $eJOHy.useEffect)(()=>{
        const analyticsEvent = createAnalyticsEvent({});
        (0, $gCeeo.fireTrackAnalyticsDeferred)(analyticsEvent, 'unsupported newGicField', {
            gqlType: gqlType,
            projectType: projectType,
            fieldType: fieldType
        });
    }, [
        createAnalyticsEvent,
        projectType,
        gqlType,
        fieldType
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6svxr.default), {
        id: fieldId,
        label: fieldName,
        isRequired: isRequired,
        name: fieldId
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($45fecb16f64dd2d9$var$InlineMessageContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($45fecb16f64dd2d9$var$FieldContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $sY9BV.default), {
            isDisabled: true,
            "aria-labelledby": fieldProps['aria-labelledby']
        })), !(0, $jjTgs.UNSUPPORTED_FIELD_TYPES).includes(fieldType) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
            sourceType: (0, $466f60259c330878$export$cae2783c9279926),
            sourceName: "globalIssueCreateFieldUnsupported"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6joHJ.JiraInlineDialog), {
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($45fecb16f64dd2d9$var$MessageContainer, {
                "data-testid": (0, $jjTgs.MESSAGE_CONTAINER_TEST_ID)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), {
                ...(0, $lU3Cq.default).incompatibleFieldMessageNoOptionToSwitchToOldModal,
                values: {
                    fieldName: fieldName,
                    b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("b", null, chunks)
                }
            })),
            isOpen: isInfoMessageOpen,
            onClose: closeInfoMessage,
            messageId: "issue-create.common.ui.fields.incompatible-field.inline-dialog",
            messageType: "transactional"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            spacing: "none",
            appearance: "subtle",
            onClick: toggleInfoMessageVisibility,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d3cA1))), {
                label: "incompatible-field-info",
                LEGACY_size: "medium",
                spacing: "spacious",
                color: "var(--ds-icon-subtle, #626F86)"
            }),
            testId: (0, $jjTgs.ERROR_ICON_TEST_ID)
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $coifs.FieldMessage), {
            description: description,
            fieldName: fieldName,
            isMini: isMini
        })));
};
var $45fecb16f64dd2d9$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $45fecb16f64dd2d9$var$IncompatibleField;
const $45fecb16f64dd2d9$var$InlineMessageContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $45fecb16f64dd2d9$var$FieldContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsb1edt _2hwxu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $45fecb16f64dd2d9$var$MessageContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsb1sum",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6joHJ", function(module, exports) {

$parcel$export(module.exports, "JiraInlineDialog", () => $765bdfac52a4c302$export$7ab52478615504b3);

var $eJOHy = parcelRequire("eJOHy");

var $cwZBT = parcelRequire("cwZBT");

var $SyPNn = parcelRequire("SyPNn");

var $fYeTG = parcelRequire("fYeTG");

var $1kIuW = parcelRequire("1kIuW");
const $765bdfac52a4c302$export$7ab52478615504b3 = (props)=>{
    if ((0, $SyPNn.shouldBeChoreographed)(props)) {
        if ((0, $fYeTG.isMobileAndInViewPanelIterationExperiment)()) return null;
        const { messageType: messageType, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1kIuW.ChoreographerInlineDialog), rest);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cwZBT.default), rest);
};

});
parcelRegister("1kIuW", function(module, exports) {

$parcel$export(module.exports, "ChoreographerInlineDialog", () => $7432b934335413bd$export$44a404f218b0e66e);

var $cwZBT = parcelRequire("cwZBT");

var $gL5G0 = parcelRequire("gL5G0");
const $7432b934335413bd$export$44a404f218b0e66e = (0, $gL5G0.withChoreographedToggle)((0, $cwZBT.default), 'isOpen', 'content');

});


parcelRegister("jjTgs", function(module, exports) {

$parcel$export(module.exports, "UNSUPPORTED_FIELD_TYPES", () => $393359cde3cec2ea$export$50417837a224cc14);
$parcel$export(module.exports, "ERROR_ICON_TEST_ID", () => $393359cde3cec2ea$export$373c21cf926631ed);
$parcel$export(module.exports, "MESSAGE_CONTAINER_TEST_ID", () => $393359cde3cec2ea$export$b8c8ab4bbeae7cb);
// These fields are not supported in the old issue create modal
const $393359cde3cec2ea$export$50417837a224cc14 = [
    'com.atlassian.jira.modules.servicemanagement.major-incident-entity:major-incident-entity-field-cftype'
];
const $393359cde3cec2ea$export$373c21cf926631ed = 'issue-create.common.ui.fields.incompatible-field.error-button';
const $393359cde3cec2ea$export$b8c8ab4bbeae7cb = 'issue-create.common.ui.fields.incompatible-field.message-container';

});

parcelRegister("lU3Cq", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3d13e44d664ab89$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $b3d13e44d664ab89$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    incompatibleFieldMessageNoOptionToSwitchToOldModal: {
        "id": "issue-create.common.fields.incompatible-field.incompatible-field-message-no-option-to-switch-to-old-modal",
        "defaultMessage": "The <b>{fieldName}</b> field is not supported on this screen."
    }
});

});


parcelRegister("fjUgP", function(module, exports) {

$parcel$export(module.exports, "FIELDS_WITH_SELECTED_PROJECT", () => $11e6f769401afc6a$export$dd0837d091307e0f);
$parcel$export(module.exports, "FIELDS_WITH_SELECTED_ISSUE_TYPE", () => $11e6f769401afc6a$export$389f9f87389af956);
$parcel$export(module.exports, "FIELDS_NEEDING_FORM_CONTEXT", () => $11e6f769401afc6a$export$f6b349b9a22679bc);
$parcel$export(module.exports, "FIELDS_WITH_ON_INPROGRESS_CHANGE", () => $11e6f769401afc6a$export$f014d1ea91bf0c23);
$parcel$export(module.exports, "FORCE_RENDER_ON_TAB_CHANGE", () => $11e6f769401afc6a$export$27466286b235cb0f);
$parcel$export(module.exports, "FIELDS_NEEDING_COMPLETE_FORM_STATE", () => $11e6f769401afc6a$export$9af9321e2bc27e84);
$parcel$export(module.exports, "FIELDS_NEEDING_GET_FORM_STATE", () => $11e6f769401afc6a$export$249f6ad3f1dce1f);
$parcel$export(module.exports, "RENDER_BATCH_SIZE_DENOMINATOR", () => $11e6f769401afc6a$export$397fe8aa4d206ed5);
$parcel$export(module.exports, "FIELDS_WITH_EXTENSION_PROPS", () => $11e6f769401afc6a$export$88f0fb0471bfaaff);
$parcel$export(module.exports, "FIELDS_NEEDING_CREATE_LINKED_ISSUE_INFO", () => $11e6f769401afc6a$export$9ff19636928638c9);
$parcel$export(module.exports, "FIELDS_WITHOUT_DROPDOWN_MENU", () => $11e6f769401afc6a$export$bd64b3c9a1b1c867);

const $11e6f769401afc6a$export$dd0837d091307e0f = [
    (0, $af620ae3ac843a8a$export$8723b724f0b3ac65),
    (0, $af620ae3ac843a8a$export$31a6c27df1f927b2),
    (0, $af620ae3ac843a8a$export$30b2c2de5e3007a4),
    (0, $af620ae3ac843a8a$export$76d811609080a7aa),
    (0, $af620ae3ac843a8a$export$a9b3195cbef5c5ad),
    (0, $af620ae3ac843a8a$export$597fa240de2bfd92),
    (0, $af620ae3ac843a8a$export$3e8dded8d83b5d95),
    (0, $af620ae3ac843a8a$export$670384150af5f49e),
    (0, $af620ae3ac843a8a$export$bf9df74e065af482),
    (0, $af620ae3ac843a8a$export$d64150fd9c66969c),
    (0, $af620ae3ac843a8a$export$64238d76a1dc0703),
    (0, $af620ae3ac843a8a$export$eca94ae30cb92d8),
    (0, $af620ae3ac843a8a$export$3849bb04b4eee607),
    (0, $af620ae3ac843a8a$export$2bb9d057bad89bfa),
    (0, $af620ae3ac843a8a$export$ede7166f44cc4bd6)
];
const $11e6f769401afc6a$export$389f9f87389af956 = [
    (0, $af620ae3ac843a8a$export$3e8dded8d83b5d95),
    (0, $af620ae3ac843a8a$export$bf9df74e065af482),
    (0, $af620ae3ac843a8a$export$31a6c27df1f927b2)
];
const $11e6f769401afc6a$export$f6b349b9a22679bc = [
    (0, $af620ae3ac843a8a$export$670384150af5f49e),
    (0, $af620ae3ac843a8a$export$8723b724f0b3ac65)
];
const $11e6f769401afc6a$export$f014d1ea91bf0c23 = [
    (0, $af620ae3ac843a8a$export$a9b3195cbef5c5ad)
];
const $11e6f769401afc6a$export$27466286b235cb0f = [
    (0, $af620ae3ac843a8a$export$64c7789e86344de5),
    (0, $af620ae3ac843a8a$export$5bb498d4f2f54799),
    (0, $af620ae3ac843a8a$export$d10237d945259f96),
    (0, $af620ae3ac843a8a$export$2055419ff013de79),
    (0, $af620ae3ac843a8a$export$3a1ae3e0f2d9b1b9),
    (0, $af620ae3ac843a8a$export$eca94ae30cb92d8),
    (0, $af620ae3ac843a8a$export$30b2c2de5e3007a4),
    (0, $af620ae3ac843a8a$export$76d811609080a7aa)
];
const $11e6f769401afc6a$export$9af9321e2bc27e84 = [
    (0, $af620ae3ac843a8a$export$597fa240de2bfd92),
    (0, $af620ae3ac843a8a$export$fc69de49ba08ae77)
];
const $11e6f769401afc6a$export$249f6ad3f1dce1f = [
    (0, $af620ae3ac843a8a$export$31a6c27df1f927b2)
];
const $11e6f769401afc6a$export$397fe8aa4d206ed5 = 10;
const $11e6f769401afc6a$export$88f0fb0471bfaaff = [
    (0, $af620ae3ac843a8a$export$31a6c27df1f927b2)
];
const $11e6f769401afc6a$export$9ff19636928638c9 = [
    (0, $af620ae3ac843a8a$export$47af4d6f62c134cf)
];
const $11e6f769401afc6a$export$bd64b3c9a1b1c867 = [
    (0, $af620ae3ac843a8a$export$23ca38ad884e35f1),
    (0, $af620ae3ac843a8a$export$7e5590c7c7a403c0),
    (0, $af620ae3ac843a8a$export$8643f0b9cefed538),
    (0, $af620ae3ac843a8a$export$31a6c27df1f927b2),
    (0, $af620ae3ac843a8a$export$e4d5e04bc56680dc),
    (0, $af620ae3ac843a8a$export$d854193d90dc547d),
    (0, $af620ae3ac843a8a$export$e0ece81bd398c799),
    (0, $af620ae3ac843a8a$export$95433ac963f4aebe),
    (0, $af620ae3ac843a8a$export$a138d5648dda03f0),
    (0, $af620ae3ac843a8a$export$aecc734a7c3591d7)
];

});

parcelRegister("aWufh", function(module, exports) {

$parcel$export(module.exports, "getHelpTextUrl", () => $85d4db0cd2a35099$export$6d35186636f2563a);
$parcel$export(module.exports, "getOnLinkClickEvent", () => $85d4db0cd2a35099$export$ac33bccf00c7d438);
$parcel$export(module.exports, "getFieldsToRenderInOneBatch", () => $85d4db0cd2a35099$export$e76bcc0cbf9cc086);

var $3qIbb = parcelRequire("3qIbb");

var $1wGYs = parcelRequire("1wGYs");

var $fjUgP = parcelRequire("fjUgP");
const $85d4db0cd2a35099$var$isFieldWithLearnMoreLink = (gqlType)=>Object.keys((0, $3qIbb.FIELDS_LEARN_MORE_LINKS)).includes(gqlType);
const $85d4db0cd2a35099$export$6d35186636f2563a = (gqlType)=>{
    if ($85d4db0cd2a35099$var$isFieldWithLearnMoreLink(gqlType)) return (0, $3qIbb.FIELDS_LEARN_MORE_LINKS)[gqlType];
    return undefined;
};
const $85d4db0cd2a35099$export$ac33bccf00c7d438 = (gqlType)=>{
    if ($85d4db0cd2a35099$var$isFieldWithLearnMoreLink(gqlType)) return 0, $1wGYs.openInNewTabLinkClickEventHandler;
    return undefined;
};
const $85d4db0cd2a35099$export$e76bcc0cbf9cc086 = (totalFields)=>Math.max(Math.floor(totalFields / (0, $fjUgP.RENDER_BATCH_SIZE_DENOMINATOR)), 10);

});
parcelRegister("1wGYs", function(module, exports) {

$parcel$export(module.exports, "openInNewTabLinkClickEventHandler", () => $51ae1251e2966ea6$export$90d78a8969dab02);
const $51ae1251e2966ea6$export$90d78a8969dab02 = (event)=>{
    const eventTarget = event.target;
    if (eventTarget instanceof HTMLAnchorElement) eventTarget.target = '_blank';
};

});



parcelRegister("en79x", function(module, exports) {

$parcel$export(module.exports, "FieldsContainer", () => $0c309e526e70fc26$export$8cdf7afbd261e53d);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eJ9f5 = parcelRequire("eJ9f5");

var $8nu6j = parcelRequire("8nu6j");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $epTsa = parcelRequire("epTsa");

var $7jTnu = parcelRequire("7jTnu");

var $ecCxV = parcelRequire("ecCxV");

var $lRq8t = parcelRequire("lRq8t");

var $1F8hV = parcelRequire("1F8hV");

var $jQUoP = parcelRequire("jQUoP");

var $fIw44 = parcelRequire("fIw44");

var $gCeeo = parcelRequire("gCeeo");

var $1OHZM = parcelRequire("1OHZM");

var $eguTB = parcelRequire("eguTB");

var $el1HC = parcelRequire("el1HC");
const $0c309e526e70fc26$export$2fe52feffe568f84 = '3svLIYAFXrcqQlJXtqEc6G';
const $0c309e526e70fc26$export$8cdf7afbd261e53d = (props)=>{
    const { fields: propFields, collapsedFields: propsCollapsedFields = [], optOutSmartFieldIds: optOutSmartFieldIds, FieldRenderer: FieldRenderer, tabIndex: tabIndex, ...rest } = props;
    const [{ ecosystem: { forge: { hasFinishedLoading: hasFinishedLoading } } }] = (0, $jQUoP.useFormContext)();
    const uiModificationsStatus = (0, $1F8hV.useUiModificationsEnabledStatus)(hasFinishedLoading);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { collapsedFields: collapsedFields, fields: fields } = (0, $eJOHy.useMemo)(()=>{
        let collapsedFieldsFound = uiModificationsStatus !== 'enabled' ? propsCollapsedFields : [];
        if (optOutSmartFieldIds && (0, $7jTnu.fg)('opt_out_smart_fields_in_gic')) collapsedFieldsFound = collapsedFieldsFound.filter((field)=>!optOutSmartFieldIds.includes(field));
        let fieldsFound = propFields.filter((field)=>!collapsedFieldsFound.includes(field));
        if (!fieldsFound.length && collapsedFieldsFound.length) {
            fieldsFound = collapsedFieldsFound;
            collapsedFieldsFound = [];
        }
        return {
            collapsedFields: collapsedFieldsFound,
            fields: fieldsFound
        };
    }, [
        propFields,
        propsCollapsedFields,
        uiModificationsStatus,
        optOutSmartFieldIds
    ]);
    const [isExpanded, { setExpandedCollapsedArea: setExpandedCollapsedArea }] = (0, $jQUoP.useIsCollapsedAreaExpanded)(tabIndex); // isCollapsed is only true once. When it's false, it should never get back to true
    const isCollapsed = (0, $eJOHy.useRef)(!isExpanded);
    const { view: view, setView: setView, setShouldFocusChanger: setShouldFocusChanger } = (0, $fIw44.useMinimizableModal)();
    const openInProductHelp = (0, $ecCxV.useHelpPanelLink)();
    const handleOnReadMoreClick = (0, $eJOHy.useCallback)((event)=>{
        event.preventDefault();
        if (view === 'modal') {
            setShouldFocusChanger(true);
            setView?.('mini');
        }
        openInProductHelp?.($0c309e526e70fc26$export$2fe52feffe568f84);
    }, [
        view,
        openInProductHelp,
        setShouldFocusChanger,
        setView
    ]);
    const handleOnClick = (_, analyticsEvent)=>{
        isCollapsed.current = false;
        const isExpandedNewValue = !isExpanded;
        setExpandedCollapsedArea(tabIndex, isExpandedNewValue);
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'moreFields', {
            isExpanded: isExpandedNewValue
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $0c309e526e70fc26$var$fieldsContainerWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(FieldRenderer, {
        ...rest,
        fields: fields
    }), !!collapsedFields.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0c309e526e70fc26$var$CollapsibleWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eguTB.CollapsibleAreaHeader), {
        totalFields: collapsedFields.length,
        isExpanded: isExpanded,
        onClick: handleOnClick
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0c309e526e70fc26$var$CollapsibleArea, {
        isExpanded: isExpanded
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        as: "p"
    }, formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $el1HC.default).smartFieldsReadMoreIssueTermRefresh : (0, $el1HC.default).smartFieldsReadMore, {
        link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
                href: "https://support.atlassian.com",
                appearance: "default",
                onClick: handleOnReadMoreClick
            }, chunks)
    })), isCollapsed.current ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(FieldRenderer, {
        ...rest,
        fields: collapsedFields,
        isCollapsed: isCollapsed.current
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0c309e526e70fc26$export$b533c285325ee313, {
        ...rest,
        FieldRenderer: FieldRenderer,
        fields: collapsedFields
    }))));
};
const $0c309e526e70fc26$export$b533c285325ee313 = ({ FieldRenderer: FieldRenderer, ...rest })=>{
    const [loaded, setLoaded] = (0, $eJOHy.useState)(false);
    const [isFieldResponsive, setIsFieldResponsive] = (0, $eJOHy.useState)(false);
    const collapsibleAreaRef = (0, $eJOHy.useRef)(null);
    (0, $1OHZM.useResizeObserver)({
        ref: collapsibleAreaRef,
        onResize () {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            setIsFieldResponsive(window.innerWidth < 560);
        }
    });
    (0, $eJOHy.useEffect)(()=>{
        setLoaded(true);
    }, []);
    if (!loaded) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        ref: collapsibleAreaRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(FieldRenderer, {
        ...rest,
        isFieldResponsive: isFieldResponsive
    }));
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0c309e526e70fc26$var$CollapsibleWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko1y44 _189et94y _1dqonqa1 _1h6dmuej _19pkpxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
const $0c309e526e70fc26$var$CollapsibleArea = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isExpanded: isExpanded, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "",
            !__cmplp.isExpanded ? "_1e0cglyw" : "_1yt4u2gc _18u01f4h _otyrpxbi _u5f3pxbi _ca0qidpf",
            __cmplp.className
        ])
    });
});
const $0c309e526e70fc26$var$fieldsContainerWrapperStyles = (0, $1DXK0.xcss)({
    paddingBottom: 'space.200'
});

});
parcelRegister("ecCxV", function(module, exports) {

$parcel$export(module.exports, "useHelpPanelLink", () => $ceecb2ae691c2ef9$export$dc5c3cc39ce0d138);
$parcel$export(module.exports, "HelpPanelLink", () => $ceecb2ae691c2ef9$export$5a09250ffddd7fd1);
$parcel$export(module.exports, "default", () => $ceecb2ae691c2ef9$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $eJ9f5 = parcelRequire("eJ9f5");

var $7jTnu = parcelRequire("7jTnu");

var $hLzUY = parcelRequire("hLzUY");

var $3VPsL = parcelRequire("3VPsL");

var $dfP3D = parcelRequire("dfP3D");

var $epTsa = parcelRequire("epTsa");
const $ceecb2ae691c2ef9$export$dc5c3cc39ce0d138 = (resetHistory = false)=>{
    const { openRightSidebar: openRightSidebar } = (0, $dfP3D.useRightSidebarController)();
    const [, { setNavigationData: setNavigationData }] = (0, $3VPsL.useHelpPanelActions)();
    const handleOnClick = (id, type = 'HELP_ARTICLE')=>{
        openRightSidebar((0, $hLzUY.HELP_PANEL_ID), (0, $hLzUY.HELP_PANEL_WIDTH), false, true);
        if (resetHistory) setNavigationData({
            articleId: {
                id: id,
                type: type
            },
            history: []
        });
        else setNavigationData({
            articleId: {
                id: id,
                type: type
            }
        });
    };
    return handleOnClick;
};
const $ceecb2ae691c2ef9$export$5a09250ffddd7fd1 = ({ articleId: articleId = '', type: type = 'HELP_ARTICLE', children: children, onClick: onClick, href: href, fallbackComponent: fallbackComponent, // unused, but needs to be here so it's not passed to Link/Button in the ...props splat
...props })=>{
    const onOpenInProductHelpArticle = $ceecb2ae691c2ef9$export$dc5c3cc39ce0d138();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleOnClick = (event, analyticsEvent)=>{
        if ((0, $7jTnu.fg)('help_panel_as_link')) event.preventDefault();
        onClick?.(event, analyticsEvent);
        onOpenInProductHelpArticle(articleId, type);
    };
    if ((0, $7jTnu.fg)('help_panel_as_link')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
        ...props,
        onClick: handleOnClick,
        href: href ?? 'https://support.atlassian.com',
        appearance: "default",
        testId: props.testId
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        ...props,
        appearance: props.appearance === 'subtle-link' && (0, $epTsa.expValEquals)('m1_features_page_experiment', 'cohort', 'variation') ? 'link' : props.appearance,
        onClick: handleOnClick,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        className: (0, $hcewu.default)([
            props.appearance === 'link' && "_4bfu18uv _1hms8stv _ajmmnqa1 _9oik18uv _1bnxglyw _jf4cnqa1",
            props.appearance === 'subtle-link' && (0, $epTsa.expValEquals)('m1_features_page_experiment', 'cohort', 'variation') && "_4bfu18uv _1hmsglyw _ajmmnqa1 _9oik18uv _1bnx8stv _jf4cnqa1"
        ])
    }, children);
};
var /**
 * @deprecated Use named export instead.
 */ $ceecb2ae691c2ef9$export$2e2bcd8739ae039 = $ceecb2ae691c2ef9$export$5a09250ffddd7fd1;
const $ceecb2ae691c2ef9$var$buttonWrapperStyles = null;
const $ceecb2ae691c2ef9$var$buttonWrapperSubtleStyles = null;

});

parcelRegister("eguTB", function(module, exports) {

$parcel$export(module.exports, "CollapsibleAreaHeader", () => $5bf5b6cb20f7ff72$export$8761b26214731920);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $dB1eP = parcelRequire("dB1eP");

var $5lAAn = parcelRequire("5lAAn");

var $goZPP = parcelRequire("goZPP");

var $jdqdp = parcelRequire("jdqdp");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $3129x = parcelRequire("3129x");

var $82ipe = parcelRequire("82ipe");
const $5bf5b6cb20f7ff72$export$875f349363bf5c2a = 'issue-create.ui.modal.create-form.layout-renderer.fields-container.collapsible-area-header.collapsible-area-header';
const $5bf5b6cb20f7ff72$export$8761b26214731920 = ({ totalFields: totalFields, isExpanded: isExpanded, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const buttonAlt = isExpanded ? (0, $3129x.messages).hideMoreFields : (0, $3129x.messages).showMoreFields;
    const { isSmartFieldsNew: isSmartFieldsNew } = (0, $82ipe.useSyncNewLozenge)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $5bf5b6cb20f7ff72$var$buttonContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5bf5b6cb20f7ff72$var$HeaderButton, {
        iconBefore: isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5lAAn))), {
            color: "currentColor",
            label: "",
            size: "small"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dB1eP))), {
            color: "currentColor",
            label: "",
            size: "small"
        }),
        appearance: "subtle-link",
        title: formatMessage(buttonAlt, {
            totalFields: totalFields
        }),
        onClick: onClick,
        testId: $5bf5b6cb20f7ff72$export$875f349363bf5c2a,
        shouldFitContainer: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5bf5b6cb20f7ff72$var$HeaderButtonContent, null, formatMessage((0, $3129x.messages).moreFields, {
        totalFields: totalFields
    }), isSmartFieldsNew && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
        appearance: "new"
    }, formatMessage((0, $3129x.messages).newLozenge))))));
};
const $5bf5b6cb20f7ff72$var$buttonHeight = '40px';
const $5bf5b6cb20f7ff72$var$buttonContainerStyles = (0, $1DXK0.xcss)({
    // Button ring outline displays outside collapsible area. This padding is used to make them the same position
    padding: 'space.025'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5bf5b6cb20f7ff72$var$HeaderButton = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $goZPP.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4t3i1ylp _y3gn1e5h",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5bf5b6cb20f7ff72$var$HeaderButtonContent = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_vwz41ylp _18u012x7",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3129x", function(module, exports) {

$parcel$export(module.exports, "messages", () => $9f18daf0e8375eb6$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $9f18daf0e8375eb6$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    moreFields: {
        "id": "issue-create.modal.create-form.layout-renderer.fields-container.collapsible-area-header.more-fields",
        "defaultMessage": "More fields ({totalFields})"
    },
    showMoreFields: {
        "id": "issue-create.modal.create-form.layout-renderer.fields-container.collapsible-area-header.show-more-fields",
        "defaultMessage": "{totalFields, plural, one {Show one more field} other {Show # more fields}}"
    },
    hideMoreFields: {
        "id": "issue-create.modal.create-form.layout-renderer.fields-container.collapsible-area-header.hide-more-fields",
        "defaultMessage": "{totalFields, plural, one {Hide one more field} other {Hide # more fields}}"
    },
    newLozenge: {
        "id": "issue-create.modal.create-form.layout-renderer.fields-container.collapsible-area-header.new-lozenge",
        "defaultMessage": "New"
    }
});

});

parcelRegister("82ipe", function(module, exports) {

$parcel$export(module.exports, "useSyncNewLozenge", () => $a40b6f373271463b$export$2eb02503266aeaa2);

var $eJOHy = parcelRequire("eJOHy");

var $jQUoP = parcelRequire("jQUoP");

var $ctRhd = parcelRequire("ctRhd");

var $7JXbP = parcelRequire("7JXbP");
const $a40b6f373271463b$export$2eb02503266aeaa2 = ()=>{
    const { isSmartFieldsOptIn: isSmartFieldsOptIn, isSmartFieldDismissedReadMore: isSmartFieldDismissedReadMore, dismissReadMore: dismissReadMore, isSmartFieldsGicOnboardingDismissed: isSmartFieldsGicOnboardingDismissed } = (0, $7JXbP.useIsSmartFieldsOptIn)();
    const { updatePreferences: updatePreferences } = (0, $ctRhd.useSmartFieldsUpdateUserPreference)();
    const dismissLozenge = (0, $eJOHy.useCallback)(async ()=>{
        dismissReadMore();
        await updatePreferences({
            hasUserOptedOut: !isSmartFieldsOptIn,
            hasUserDismissedReadMore: true,
            hasUserDismissedGicOnboarding: !!isSmartFieldsGicOnboardingDismissed
        });
    }, [
        dismissReadMore,
        isSmartFieldsOptIn,
        updatePreferences,
        isSmartFieldsGicOnboardingDismissed
    ]);
    const [isSmartFieldsNew, { setIsSmartFieldsNew: setIsSmartFieldsNew }] = (0, $jQUoP.useIsSmartFieldsNew)();
    (0, $eJOHy.useEffect)(()=>{
        if (isSmartFieldsNew === undefined && !isSmartFieldDismissedReadMore) {
            setIsSmartFieldsNew(true);
            dismissLozenge();
        }
    }, [
        isSmartFieldsNew,
        isSmartFieldDismissedReadMore,
        setIsSmartFieldsNew,
        dismissLozenge
    ]);
    return {
        isSmartFieldsNew: isSmartFieldsNew
    };
};

});


parcelRegister("el1HC", function(module, exports) {

$parcel$export(module.exports, "default", () => $3423d7ef8216779f$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $3423d7ef8216779f$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    smartFieldsReadMore: {
        "id": "issue-create.modal.create-form.layout-renderer.fields-container.smart-fields-read-more",
        "defaultMessage": "Fields you don\u2019t use often are automatically listed here. <link>Read more about the fields available when creating issues</link>"
    },
    smartFieldsReadMoreIssueTermRefresh: {
        "id": "issue-create.modal.create-form.layout-renderer.fields-container.smart-fields-read-more-issue-term-refresh",
        "defaultMessage": "Fields you don\u2019t use often are automatically listed here. <link>Read more about the fields available when creating work items</link>"
    }
});

});



parcelRegister("9uhQ0", function(module, exports) {

$parcel$export(module.exports, "default", () => $6fb128a6404c0339$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $6fb128a6404c0339$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    projectFieldLabel: {
        "id": "issue-create.modal.create-form.project-field-label",
        "defaultMessage": "Projects"
    },
    createSuccessFlagTitle: {
        "id": "issue-create.modal.create-form.create-success-flag-title",
        "defaultMessage": "Issue created"
    },
    createSuccessFlagDescription: {
        "id": "issue-create.modal.create-form.create-success-flag-description",
        "defaultMessage": "Issue \"{issueKey}\" has been successfully created."
    },
    createSuccessFlagCta: {
        "id": "issue-create.modal.create-form.create-success-flag-cta",
        "defaultMessage": "View issue"
    },
    createErrorFlagTitle: {
        "id": "issue-create.modal.create-form.create-error-flag-title",
        "defaultMessage": "Couldn't create the issue"
    },
    createErrorFlagDescription: {
        "id": "issue-create.modal.create-form.create-error-flag-description",
        "defaultMessage": "We're having some trouble creating the issue. Refresh the page and try again."
    },
    embeddedCreateErrorFlagDescription: {
        "id": "issue-create.modal.create-form.embedded-create-error-flag-description",
        "defaultMessage": "We weren't able to save your issue. Please try again."
    },
    embeddedCreateErrorFlagDescriptionIssueTermRefresh: {
        "id": "issue-create.modal.create-form.embedded-create-error-flag-description-issue-term-refresh",
        "defaultMessage": "We weren't able to save your work item. Please try again."
    },
    createErrorForgeInlineField: {
        "id": "issue-create.modal.create-form.create-error-forge-inline-field",
        "defaultMessage": "Unable to save the value for this custom field."
    },
    timeoutForgeInlineFieldTitle: {
        "id": "issue-create.modal.create-form.timeout-forge-inline-field-title",
        "defaultMessage": "Issue created with exceptions"
    },
    timeoutForgeInlineFieldDescription: {
        "id": "issue-create.modal.create-form.timeout-forge-inline-field-description",
        "defaultMessage": "We created your issue but couldn't save the value of <bold>{fields}</bold>. If this happens again, contact your Jira admin"
    },
    requiredFieldsSummary: {
        "id": "issue-create.modal.create-form.required-fields-summary",
        "defaultMessage": "Required fields are marked with an asterisk"
    },
    showOnlyrequiredFieldsSummary: {
        "id": "issue-create.modal.create-form.show-only-required-fields-summary",
        "defaultMessage": "Show only required fields (marked with an asterisk {requiredAsterisk})"
    },
    singleRequiredCustomFieldIssueCreationBlock: {
        "id": "issue-create.modal.create-form.single-required-custom-field-issue-creation-block",
        "defaultMessage": "You can\u2019t create this issue because the required field {fieldName} is hidden. Contact your admin to fix this."
    },
    multipleRequiredCustomFieldsIssueCreationBlock: {
        "id": "issue-create.modal.create-form.multiple-required-custom-fields-issue-creation-block",
        "defaultMessage": "You can\u2019t create this issue because the required fields are hidden: {fieldsName}. Contact your admin to fix this."
    },
    createSuccessFlagTitleIssueTermRefresh: {
        "id": "issue-create.modal.create-form.create-success-flag-title-issue-term-refresh",
        "defaultMessage": "Work item created"
    },
    createSuccessFlagCtaIssueTermRefresh: {
        "id": "issue-create.modal.create-form.create-success-flag-cta-issue-term-refresh",
        "defaultMessage": "View"
    },
    createErrorFlagTitleIssueTermRefresh: {
        "id": "issue-create.modal.create-form.create-error-flag-title-issue-term-refresh",
        "defaultMessage": "Couldn't create the work item"
    },
    createErrorFlagTitleIssueTerminologyRefreshM4: {
        "id": "issue-create.modal.create-form.create-error-flag-title-issue-terminology-refresh-m4",
        "defaultMessage": "We can't create {issueType}"
    },
    createErrorFlagDescriptionIssueTermRefresh: {
        "id": "issue-create.modal.create-form.create-error-flag-description-issue-term-refresh",
        "defaultMessage": "We're having some trouble creating the work item. Refresh the page and try again."
    },
    createErrorFlagDescriptionIssueTerminologyRefreshM4: {
        "id": "issue-create.modal.create-form.create-error-flag-description-issue-terminology-refresh-m4",
        "defaultMessage": "Refresh the page and try again."
    },
    timeoutForgeInlineFieldTitleIssueTermRefresh: {
        "id": "issue-create.modal.create-form.timeout-forge-inline-field-title-issue-term-refresh",
        "defaultMessage": "Work item created with exceptions"
    },
    timeoutForgeInlineFieldTitleIssueTerminologyRefreshM4: {
        "id": "issue-create.modal.create-form.timeout-forge-inline-field-title-issue-terminology-refresh-m4",
        "defaultMessage": "Created {issueType} with exceptions"
    },
    timeoutForgeInlineFieldDescriptionIssueTermRefresh: {
        "id": "issue-create.modal.create-form.timeout-forge-inline-field-description-issue-term-refresh",
        "defaultMessage": "We created your work item but couldn't save the value of the <bold>{fields}</bold> field. If this happens again, notify your admin"
    },
    timeoutForgeInlineFieldDescriptionIssueTerminologyRefreshM4: {
        "id": "issue-create.modal.create-form.timeout-forge-inline-field-description-issue-terminology-refresh-m4",
        "defaultMessage": "We created your {issueType} but couldn't save the value of the <bold>{fields}</bold> field. If this happens again, notify your admin"
    },
    singleRequiredCustomFieldIssueCreationBlockIssueTermRefresh: {
        "id": "issue-create.modal.create-form.single-required-custom-field-issue-creation-block-issue-term-refresh",
        "defaultMessage": "You can\u2019t create this work item because the {fieldName} field is required but hidden. Contact your admin to fix this."
    },
    singleRequiredCustomFieldIssueCreationBlockIssueTerminologyRefreshM4: {
        "id": "issue-create.modal.create-form.single-required-custom-field-issue-creation-block-issue-terminology-refresh-m4",
        "defaultMessage": "You can\u2019t create this {issueType} because the {fieldName} field is required but hidden. Contact your admin to fix this."
    },
    multipleRequiredCustomFieldsIssueCreationBlockIssueTermRefresh: {
        "id": "issue-create.modal.create-form.multiple-required-custom-fields-issue-creation-block-issue-term-refresh",
        "defaultMessage": "You can\u2019t create this work item because the required fields are hidden: {fieldsName}. Contact your admin to fix this."
    },
    multipleRequiredCustomFieldsIssueCreationBlockIssueTerminologyRefreshM4: {
        "id": "issue-create.modal.create-form.multiple-required-custom-fields-issue-creation-block-issue-terminology-refresh-m4",
        "defaultMessage": "You can\u2019t create this {issueType} because the required fields are hidden: {fieldsName}. Contact your admin to fix this."
    },
    createSuccessFlagDescriptionIssueTermRefresh: {
        "id": "issue-create.modal.create-form.create-success-flag-description-issue-term-refresh",
        "defaultMessage": "Work item \"{issueKey}\" has been successfully created."
    }
});

});

parcelRegister("jap6l", function(module, exports) {

$parcel$export(module.exports, "ProformaBanner", () => $959e1b0bfe1ee821$export$d53a0bf1f2b6e7a6);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $goZPP = parcelRequire("goZPP");

var $8rAKL = parcelRequire("8rAKL");

var $iHPvF = parcelRequire("iHPvF");
var $akOEX = parcelRequire("akOEX");

var $epTsa = parcelRequire("epTsa");

var $lRq8t = parcelRequire("lRq8t");

var $4xbv3 = parcelRequire("4xbv3");
var $iqtgH = parcelRequire("iqtgH");
var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $lgUuI = parcelRequire("lgUuI");
const $959e1b0bfe1ee821$export$d53a0bf1f2b6e7a6 = ({ portalLink: portalLink })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const onOpenPortalLinkClick = ()=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'gicProformaBannerOpenPortalButton clicked');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        sourceName: "gicProforma",
        sourceType: (0, $466f60259c330878$export$238d30785c4bca84)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($959e1b0bfe1ee821$export$f316edcbf748c37b, {
        "data-testid": "issue-create.ui.modal.create-form.proforma-banner.banner-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iHPvF.default), {
        appearance: "information",
        title: formatMessage((0, $lgUuI.default).title),
        actions: [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $akOEX.default), {
                key: "openPortalLink"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                appearance: "link",
                href: portalLink,
                target: "_blank",
                spacing: "none",
                onClick: onOpenPortalLinkClick,
                onAuxClick: onOpenPortalLinkClick,
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($959e1b0bfe1ee821$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8rAKL))), {
                    label: formatMessage((0, $lgUuI.default).newTabIconDescription),
                    LEGACY_size: "small"
                }))
            }, formatMessage((0, $lgUuI.default).openPortal)))
        ]
    }, formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $lgUuI.default).textIssueTermRefresh : (0, $lgUuI.default).text))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqtgH.FireScreenAnalytics), null));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $959e1b0bfe1ee821$var$IconWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_18u01b66 _k48pi7a9",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $959e1b0bfe1ee821$export$f316edcbf748c37b = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pk1ejb",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lgUuI", function(module, exports) {

$parcel$export(module.exports, "default", () => $69cf3357cb20c5a4$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $69cf3357cb20c5a4$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    title: {
        "id": "issue-create.modal.create-form.proforma-banner.title",
        "defaultMessage": "This request type includes a form that can\u2019t be seen in this view"
    },
    text: {
        "id": "issue-create.modal.create-form.proforma-banner.text",
        "defaultMessage": "Create an issue using all fields on this request type and its form in the portal."
    },
    openPortal: {
        "id": "issue-create.modal.create-form.proforma-banner.open-portal",
        "defaultMessage": "Open portal"
    },
    newTabIconDescription: {
        "id": "issue-create.modal.create-form.proforma-banner.new-tab-icon-description",
        "defaultMessage": "This link will be opened in a new tab"
    },
    textIssueTermRefresh: {
        "id": "issue-create.modal.create-form.proforma-banner.text-issue-term-refresh",
        "defaultMessage": "Create a work item using all fields on this request type and its form in the portal."
    }
});

});


parcelRegister("l57PA", function(module, exports) {

$parcel$export(module.exports, "default", () => $85eea161868a6cf5$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $9Dhvc = parcelRequire("9Dhvc");

var $1fMqv = parcelRequire("1fMqv");

var $fKXve = parcelRequire("fKXve");
var $6svxr = parcelRequire("6svxr");

var $c4OV1 = parcelRequire("c4OV1");

var $lRq8t = parcelRequire("lRq8t");

var $fE4zR = parcelRequire("fE4zR");

var $5acEa = parcelRequire("5acEa");

var $jQUoP = parcelRequire("jQUoP");

var $9QSSI = parcelRequire("9QSSI");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $ka5CK = parcelRequire("ka5CK");

var $c3eoY = parcelRequire("c3eoY");


var $bfXu0 = parcelRequire("bfXu0");

var $hy3RK = parcelRequire("hy3RK");

var $hToTD = parcelRequire("hToTD");
const $85eea161868a6cf5$var$ProjectPicker = (props)=>{
    const { onChange: onChange, value: selectedProjectValue, renderOptionsLimit: renderOptionsLimit, skipFetchProjects: skipFetchProjects = false, isDisabled: isDisabled = false, disableFetchProject: disableFetchProject = false, width: width, onProjectSelection: onProjectSelection } = props;
    const [{ meta: { submitFieldwiseErrors: submitFieldwiseErrors } }] = (0, $jQUoP.useFormContext)();
    const [recentProjects, setRecentProjects] = (0, $eJOHy.useState)([]);
    const [filterQuery, setFilterQuery] = (0, $eJOHy.useState)('');
    const [allProjects, setAllProjects] = (0, $eJOHy.useState)([]);
    const [isLoading, setLoading] = (0, $eJOHy.useState)(true);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const shouldFetchProjects = (0, $eJOHy.useRef)(true);
    const [fetchProjects] = (0, $1fMqv.useLazyQuery)((0, $bfXu0.PROJECTS_LIST_QUERY_WITHOUT_CLASSIFICATION), {
        fetchPolicy: 'no-cache',
        onCompleted: (data)=>{
            setRecentProjects((0, $ka5CK.transformProjects)((0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(data, 'recentProjects.nodes', [])));
            setAllProjects((0, $ka5CK.transformProjects)((0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(data, 'allProjects.nodes', [])));
            setLoading(false);
        }
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const onProjectPickerInputChange = (query)=>{
        setFilterQuery(query);
    };
    (0, $eJOHy.useEffect)(()=>{
        if (selectedProjectValue && shouldFetchProjects.current || skipFetchProjects) {
            shouldFetchProjects.current = false;
            disableFetchProject ? setLoading(false) : fetchProjects();
        }
        if (selectedProjectValue) onProjectSelection?.(selectedProjectValue);
    }, [
        fetchProjects,
        selectedProjectValue,
        skipFetchProjects,
        disableFetchProject,
        onProjectSelection
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (submitFieldwiseErrors?.project) (0, $c3eoY.scrollToElement)((0, $1abf772bdf6d10da$export$e2b449031137335a));
    }, [
        submitFieldwiseErrors?.project
    ]);
    const onOptionSelect = (project)=>{
        if (project?.value === projectValue?.value) return;
        const analyticsEvent = createAnalyticsEvent({
            action: 'selected',
            actionSubject: 'option'
        });
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'project');
        onChange(project);
    };
    const filteredOptions = (0, $eJOHy.useMemo)(()=>{
        const { filteredAllProjects: filteredAllProjects, filteredRecentProjects: filteredRecentProjects } = (0, $hToTD.getFilteredOptions)({
            recentProjects: recentProjects,
            allProjects: allProjects,
            filterQuery: filterQuery,
            renderOptionsLimit: renderOptionsLimit
        });
        return [
            {
                label: formatMessage((0, $hy3RK.default).recentProjects),
                options: filteredRecentProjects
            },
            {
                label: formatMessage((0, $hy3RK.default).allProjects),
                options: filteredAllProjects
            }
        ];
    }, [
        recentProjects,
        allProjects,
        filterQuery,
        formatMessage,
        renderOptionsLimit
    ]);
    const projectValue = (0, $eJOHy.useMemo)(()=>selectedProjectValue && {
            ...selectedProjectValue,
            iconUrl: (0, $5acEa.transformStargateUrl)(selectedProjectValue?.iconUrl || '')
        }, [
        selectedProjectValue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fE4zR.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6svxr.default), {
        name: "project",
        label: formatMessage((0, $hy3RK.default).projectFieldLabel),
        isRequired: true
    }, ({ fieldProps: { id: id, isRequired: isRequired } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c4OV1.default), {
            inputId: id,
            required: isRequired,
            options: filteredOptions,
            onInputChange: onProjectPickerInputChange,
            filterOption: null,
            // @ts-expect-error - TS2322 - Type '(project: Project) => void' is not assignable to type '(value: Option | null, action: ActionMeta<Option>) => void'.
            onChange: onOptionSelect,
            value: projectValue,
            isClearable: false,
            formatOptionLabel: (0, $9QSSI.formatOptionLabel),
            hideSelectedOptions: false,
            placeholder: "",
            isLoading: isLoading,
            isDisabled: isDisabled,
            id: (0, $1abf772bdf6d10da$export$e2b449031137335a),
            onKeyDown: (0, $c3eoY.preventEscKeyPropagationKeyPressHandler)
        }), submitFieldwiseErrors?.project && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fKXve.ErrorMessage), null, submitFieldwiseErrors.project))));
};
var $85eea161868a6cf5$export$2e2bcd8739ae039 = $85eea161868a6cf5$var$ProjectPicker;

});
const $1abf772bdf6d10da$export$e2b449031137335a = 'issue-create.ui.modal.create-form.project-picker.project-select';

parcelRegister("bfXu0", function(module, exports) {

$parcel$export(module.exports, "PROJECTS_LIST_QUERY_WITHOUT_CLASSIFICATION", () => $019e3eac215654ce$export$19f5ac56520dbc94);
// eslint-disable-next-line jira/restricted/graphql-tag

var $kuAvn = parcelRequire("kuAvn");

var $krdGL = parcelRequire("krdGL");
const $019e3eac215654ce$export$19f5ac56520dbc94 = (0, $kuAvn.default)`
	query JiraProjects {
		recentProjects: jiraProjects(context: CREATE_ISSUE, recent: true) {
			nodes {
				...Project
			}
		}
		allProjects: jiraProjects(context: CREATE_ISSUE, recent: false) {
			nodes {
				...Project
			}
		}
	}
	${(0, $krdGL.PROJECT_WITHOUT_CLASSIFICATION)}
`;

});

parcelRegister("hy3RK", function(module, exports) {

$parcel$export(module.exports, "default", () => $e81418ce2e54c1a3$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $e81418ce2e54c1a3$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    projectFieldLabel: {
        "id": "issue-create.modal.create-form.project-picker.project-field-label",
        "defaultMessage": "Project"
    },
    recentProjects: {
        "id": "issue-create.modal.create-form.project-picker.recent-projects",
        "defaultMessage": "Recent Projects"
    },
    allProjects: {
        "id": "issue-create.modal.create-form.project-picker.all-projects",
        "defaultMessage": "All Projects"
    }
});

});

parcelRegister("hToTD", function(module, exports) {

$parcel$export(module.exports, "getFilteredOptions", () => $af444deddf65bb55$export$25a7cbafb6ed84cb);
const $af444deddf65bb55$export$25a7cbafb6ed84cb = ({ recentProjects: recentProjects, allProjects: allProjects, filterQuery: filterQuery, renderOptionsLimit: renderOptionsLimit })=>{
    const filteredRecentProjects = recentProjects.filter((project)=>project.label.toLowerCase().includes(filterQuery.toLowerCase()) || project.projectKey.toLowerCase().includes(filterQuery.toLowerCase()));
    const filteredAllProjects = allProjects.filter((project, index)=>{
        // if query string is there, don't limit options by limit
        if (filterQuery) return project.label.toLowerCase().includes(filterQuery.toLowerCase()) || project.projectKey.toLowerCase().includes(filterQuery.toLowerCase());
        return index < renderOptionsLimit;
    });
    return {
        filteredRecentProjects: filteredRecentProjects,
        filteredAllProjects: filteredAllProjects
    };
};

});


parcelRegister("jWBLD", function(module, exports) {

$parcel$export(module.exports, "RequestTypeFieldsLayoutPreference", () => $a412fd89d595a396$export$c35a954354cf6eee);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $goZPP = parcelRequire("goZPP");

var $7MiYh = parcelRequire("7MiYh");

var $3cMgR = parcelRequire("3cMgR");

var $8CBYv = parcelRequire("8CBYv");

var $cNe2t = parcelRequire("cNe2t");

var $dPMMf = parcelRequire("dPMMf");

var $epTsa = parcelRequire("epTsa");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $lvKO5 = parcelRequire("lvKO5");

var $fV6Ej = parcelRequire("fV6Ej");

var $lACIa = parcelRequire("lACIa");
const $a412fd89d595a396$export$c35a954354cf6eee = ({ isRequestTypeSelected: isRequestTypeSelected, overrideIsEnabled: overrideIsEnabled, onChange: onChangeCallback })=>{
    const { atlassianAccountId: atlassianAccountId } = (0, $lvKO5.useTenantContext)();
    const [{ data: isEnabled, isLoading: isLoading }, { setPreference: setPreference }] = (0, $fV6Ej.useRequestTypeFieldsLayoutPreference)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const [toggleWasClicked, setToggleWasClicked] = (0, $eJOHy.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const isChecked = !toggleWasClicked && overrideIsEnabled !== undefined ? !!overrideIsEnabled : isEnabled;
    const onToggleChanged = (0, $eJOHy.useCallback)(()=>{
        const newValue = !isChecked;
        setToggleWasClicked(true);
        atlassianAccountId && setPreference(atlassianAccountId, newValue, createAnalyticsEvent, onChangeCallback);
    }, [
        atlassianAccountId,
        createAnalyticsEvent,
        isChecked,
        onChangeCallback,
        setPreference
    ]);
    const togglePopup = (0, $eJOHy.useCallback)(()=>{
        if (!isOpen) (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'gicRequestTypeToggleLabelButton clicked');
        setIsOpen(!isOpen);
    }, [
        createAnalyticsEvent,
        isOpen
    ]);
    const popupContent = (0, $eJOHy.useCallback)(()=>{
        const popupTextRequestTypeSelected = (0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $lACIa.default).createFormPopupTextWhenRequestTypeSelectedIssueTermRefresh : (0, $lACIa.default).createFormPopupTextWhenRequestTypeSelected;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a412fd89d595a396$export$cca08eed9de89ba9, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
            as: "p",
            size: "UNSAFE_small"
        }, formatMessage(isRequestTypeSelected ? popupTextRequestTypeSelected : (0, $lACIa.default).createFormPopupTextWhenNoRequestTypeSelected)));
    }, [
        formatMessage,
        isRequestTypeSelected
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bah1y6m _4cvr1h6o"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8CBYv.default), {
        isDisabled: isLoading || !isRequestTypeSelected,
        onChange: onToggleChanged,
        isChecked: isChecked,
        id: "use-request-type-fields-toggle"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("label" // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    , {
        htmlFor: "use-request-type-fields-toggle",
        className: (0, $hcewu.default)([
            "_11c8dcr7 _syaz131l"
        ])
    }, formatMessage((0, $lACIa.default).toggleLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cNe2t.JiraPopup), {
        messageId: "issue-create.ui.modal.create-form.request-type-fields-layout-preference.popup.jira-popup",
        messageType: "engagement",
        placement: "right",
        shouldUseCaptureOnOutsideClick: true,
        isOpen: isOpen,
        onClose: togglePopup,
        content: popupContent,
        zIndex: (0, $dPMMf.layers).tooltip,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div" // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            , {
                className: (0, $hcewu.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1txw _2lx2vrvc _19bv1b66 _1sc11o8v"
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                ...triggerProps,
                appearance: "subtle-link",
                spacing: "none",
                onClick: togglePopup
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span" // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            , {
                className: (0, $hcewu.default)([
                    "_x5v916ni _1b3i16ni _syaz149c _30l31kum"
                ]),
                style: {
                    "--_qswcdb": (0, $awdRS.default)(isOpen ? 'var(--icon-accent-color)' : 'var(--icon-color)')
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7MiYh))), {
                label: "info",
                LEGACY_size: "small"
            }))))
    }));
};
const $a412fd89d595a396$export$cca08eed9de89ba9 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsb1178 _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lACIa", function(module, exports) {

$parcel$export(module.exports, "default", () => $cff1a93892c535f3$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $cff1a93892c535f3$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    toggleLabel: {
        "id": "issue-create.modal.create-form.request-type-fields-layout-preference.toggle-label",
        "defaultMessage": "Use request type fields"
    },
    createFormPopupTextWhenRequestTypeSelected: {
        "id": "issue-create.modal.create-form.request-type-fields-layout-preference.create-form-popup-text-when-request-type-selected",
        "defaultMessage": "When this feature is on, you\u2019ll see the fields connected to the request type you\u2019ve selected. When it\u2019s off, you\u2019ll see issue type fields instead."
    },
    createFormPopupTextWhenNoRequestTypeSelected: {
        "id": "issue-create.modal.create-form.request-type-fields-layout-preference.create-form-popup-text-when-no-request-type-selected",
        "defaultMessage": "Select a request type to enable this feature."
    },
    createFormPopupTextWhenRequestTypeSelectedIssueTermRefresh: {
        "id": "issue-create.modal.create-form.request-type-fields-layout-preference.create-form-popup-text-when-request-type-selected-issue-term-refresh",
        "defaultMessage": "When this feature is on, you\u2019ll see the fields connected to the request type you\u2019ve selected. When it\u2019s off, you\u2019ll see work type fields instead."
    }
});

});


parcelRegister("dsfSm", function(module, exports) {

$parcel$export(module.exports, "default", () => $6dca6d6084d04f87$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eJ9f5 = parcelRequire("eJ9f5");

var $d3cA1 = parcelRequire("d3cA1");

var $iHPvF = parcelRequire("iHPvF");

var $7jTnu = parcelRequire("7jTnu");

var $epTsa = parcelRequire("epTsa");

var $kDaaB = parcelRequire("kDaaB");

var $jQUoP = parcelRequire("jQUoP");

var $4xbv3 = parcelRequire("4xbv3");
var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $lvKO5 = parcelRequire("lvKO5");

var $4tMww = parcelRequire("4tMww");

var $rSgXO = parcelRequire("rSgXO");

var $5fxwa = parcelRequire("5fxwa");

var $kkZNx = parcelRequire("kkZNx");
const $6dca6d6084d04f87$var$SectionMessages = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [{ meta: meta }] = (0, $jQUoP.useFormContext)();
    const [issueAdjustmentError] = (0, $4tMww.useUiModificationsErrors)();
    const [uiModificationsNotification] = (0, $rSgXO.useUiModificationsNotifications)();
    const { isSiteAdmin: isSiteAdmin } = (0, $lvKO5.useTenantContext)();
    (0, $eJOHy.useEffect)(()=>{
        if (!meta.areRequiredFieldsSupported) {
            const analyticsEvent = createAnalyticsEvent({
                actionSubject: 'banner',
                action: 'viewed'
            });
            (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'globalIssueCreateMandatoryFieldsUnsupported');
        }
    }, [
        createAnalyticsEvent,
        meta.areRequiredFieldsSupported
    ]);
    if (meta.queryErrorMessage !== '') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iHPvF.default), {
        appearance: "error",
        testId: "issue-create.ui.modal.create-form.section-messages.query-error-message"
    }, meta.queryErrorMessage);
    if (meta.submitErrorMessage !== undefined && meta.submitErrorMessage !== '') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iHPvF.default), {
        appearance: "error",
        testId: "issue-create.ui.modal.create-form.section-messages.submit-error-message"
    }, (0, $kkZNx.getDisplayErrorString)(meta.submitErrorMessage).map((error, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6dca6d6084d04f87$var$MessageWrapper, {
            key: index
        }, error)));
    let infoMessage;
    if (isSiteAdmin) infoMessage = (0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5fxwa.default).requiredFieldsUnsupportedForAdminIssueTermRefresh : (0, $5fxwa.default).requiredFieldsUnsupportedForAdmin;
    else infoMessage = (0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5fxwa.default).requiredFieldsUnsupportedForUserIssueTermRefresh : (0, $5fxwa.default).requiredFieldsUnsupportedForUser;
    if (!meta.areRequiredFieldsSupported) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        sourceName: "globalIssueCreateMandatoryFieldsUnsupported",
        sourceType: (0, $466f60259c330878$export$238d30785c4bca84)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iHPvF.default), {
        appearance: "error",
        testId: "issue-create.ui.modal.create-form.section-messages.required-fields-message"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), {
        ...infoMessage,
        values: {
            a: (chunks)=>(0, $7jTnu.fg)('replace-anchor-with-link__gryffindor') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
                    href: "/jira/contact-administrator"
                }, chunks) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("a", {
                    href: "/jira/contact-administrator"
                }, chunks),
            button: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d3cA1))), {
                    label: "incompatible-field-error",
                    LEGACY_size: "medium",
                    spacing: "spacious",
                    color: "var(--ds-icon-subtle, #626F86)"
                })
        }
    })));
    if (meta.inlineCreateError && meta.inlineCreateError?.errors.length > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iHPvF.default), {
        appearance: "error",
        testId: "issue-create.ui.modal.create-form.section-messages.inline-create-errors",
        title: meta.inlineCreateError.title || ''
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("ul", null, meta.inlineCreateError.errors.map((error, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("li", {
            key: `inline-error-${index}`
        }, error))));
    if (issueAdjustmentError !== null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iHPvF.default), {
        appearance: "error",
        testId: "issue-create.ui.modal.create-form.section-messages.ui-modifications-error-message"
    }, issueAdjustmentError.message);
    if (uiModificationsNotification !== null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iHPvF.default), {
        appearance: uiModificationsNotification.type,
        testId: "issue-create.ui.modal.create-form.section-messages.ui-modifications-notification-message"
    }, uiModificationsNotification.message);
    return null;
};
var $6dca6d6084d04f87$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $6dca6d6084d04f87$var$SectionMessages;
const $6dca6d6084d04f87$var$MessageWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "pre", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c81kw7 _o5721jtm",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4tMww", function(module, exports) {

$parcel$export(module.exports, "useUiModificationsErrors", () => $81866720792029bd$export$72f28c8f041a8bab);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $leEOX = parcelRequire("leEOX");

var $eWXxs = parcelRequire("eWXxs");
const $81866720792029bd$export$72f28c8f041a8bab = ()=>{
    const error = (0, $leEOX.useError)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [errorMessage, setErrorMessage] = (0, $eJOHy.useState)(null);
    (0, $eJOHy.useEffect)(()=>{
        if (!error) setErrorMessage(null);
        else {
            const message = (0, $eWXxs.errorCodeToErrorMessageMap)[error.errorCode];
            const formattedMessage = formatMessage(message);
            setErrorMessage(formattedMessage);
        }
    }, [
        error,
        formatMessage
    ]);
    return errorMessage ? [
        {
            message: errorMessage
        }
    ] : [
        null
    ];
};

});
parcelRegister("leEOX", function(module, exports) {

$parcel$export(module.exports, "useError", () => $0e468e02b8b06e2d$export$5027865de34f9ec6);

var $iJq0l = parcelRequire("iJq0l");

var $ixrOr = parcelRequire("ixrOr");
const $0e468e02b8b06e2d$export$5027865de34f9ec6 = (0, $iJq0l.createStateHook)((0, $ixrOr.store), {
    selector: (state)=>state.error
});

});

parcelRegister("eWXxs", function(module, exports) {

$parcel$export(module.exports, "errorCodeToErrorMessageMap", () => $c27d933a91683918$export$c36ca6969b1c2a38);

var $e4e9B = parcelRequire("e4e9B");
const $c27d933a91683918$export$c36ca6969b1c2a38 = {
    ON_BRIDGE_ERROR_ERROR_CODE: (0, $e4e9B.default).applyingUimFailed,
    USE_REGISTER_FIELDS_ERROR_CODE: (0, $e4e9B.default).applyingUimFailed,
    USE_SUBMIT_ERROR_CODE: (0, $e4e9B.default).applyingUimFailed,
    PER_FIELD_HOOK_ERROR_CODE: (0, $e4e9B.default).applyingUimFailed,
    SCOPES_MISSING_ERROR_CODE: (0, $e4e9B.default).appDoesNotHaveRequiredScopes,
    ERROR_BOUNDARY_HANDLER_ERROR_CODE: (0, $e4e9B.default).applyingUimFailed,
    ON_INIT_FIELDS_INITIALIZATION_TIMEOUT: (0, $e4e9B.default).loadingUimFailed
};

});
parcelRegister("e4e9B", function(module, exports) {

$parcel$export(module.exports, "default", () => $a99c593c117c7fac$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $a99c593c117c7fac$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    loadingUimFailed: {
        "id": "ui-modifications-view-gic.use-ui-modifications-errors.loading-uim-failed",
        "defaultMessage": "We couldn't load the UI modifications for this form."
    },
    loadingUimDataFailed: {
        "id": "ui-modifications-view-gic.use-ui-modifications-errors.loading-uim-data-failed",
        "defaultMessage": "We couldn't load the UI modifications configuration for this form."
    },
    applyingUimFailed: {
        "id": "ui-modifications-view-gic.use-ui-modifications-errors.applying-uim-failed",
        "defaultMessage": "We encountered an error while applying UI modifications to this form."
    },
    appDoesNotHaveRequiredScopes: {
        "id": "ui-modifications-view-gic.use-ui-modifications-errors.app-does-not-have-required-scopes",
        "defaultMessage": "We couldn\u2019t load some of the UI modifications apps for this page, because they don\u2019t have required scopes."
    }
});

});



parcelRegister("rSgXO", function(module, exports) {

$parcel$export(module.exports, "useUiModificationsNotifications", () => $14caf48b7a068560$export$3a867504a28cd936);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $hQFvt = parcelRequire("hQFvt");

var $e2smy = parcelRequire("e2smy");
const $14caf48b7a068560$export$3a867504a28cd936 = ()=>{
    const notification = (0, $hQFvt.useNotification)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [notificationProperties, setNotificationProperties] = (0, $eJOHy.useState)(null);
    (0, $eJOHy.useEffect)(()=>{
        if (!notification) setNotificationProperties(null);
        else {
            const properties = (0, $e2smy.notificationTypeToNotificationProperties)[notification.type];
            const formattedMessage = formatMessage(properties.message);
            setNotificationProperties({
                message: formattedMessage,
                type: properties.type
            });
        }
    }, [
        notification,
        formatMessage
    ]);
    return notificationProperties ? [
        notificationProperties
    ] : [
        null
    ];
};

});
parcelRegister("hQFvt", function(module, exports) {

$parcel$export(module.exports, "useNotification", () => $f966b10aaaf304a1$export$9949bd9c713ba425);

var $iJq0l = parcelRequire("iJq0l");

var $ixrOr = parcelRequire("ixrOr");
const $f966b10aaaf304a1$export$9949bd9c713ba425 = (0, $iJq0l.createStateHook)((0, $ixrOr.store), {
    selector: (state)=>state.notification
});

});

parcelRegister("e2smy", function(module, exports) {

$parcel$export(module.exports, "notificationTypeToNotificationProperties", () => $b84c4e8a46d6dc87$export$3dd11dfb655fc1de);

var $USmKR = parcelRequire("USmKR");
const $b84c4e8a46d6dc87$export$3dd11dfb655fc1de = {
    MULTIPLE_APPS_CONFLICTS: {
        message: (0, $USmKR.default).multipleAppsConflicted,
        type: 'warning'
    }
};

});
parcelRegister("USmKR", function(module, exports) {

$parcel$export(module.exports, "default", () => $882c1f336c4d01db$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $882c1f336c4d01db$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    multipleAppsConflicted: {
        "id": "ui-modifications-view-gic.use-ui-modifications-notifications.multiple-apps-conflicted",
        "defaultMessage": "Multiple UI modification apps are trying to change the same field property. If you see unexpected changes to a field, report them to your Jira admin."
    }
});

});



parcelRegister("5fxwa", function(module, exports) {

$parcel$export(module.exports, "default", () => $7936ca3a10678baa$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $7936ca3a10678baa$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    requiredFieldsUnsupportedForAdmin: {
        "id": "issue-create.modal.create-form.section-messages.required-fields-unsupported-for-admin",
        "defaultMessage": "Field(s) marked with <button></button> aren't supported. To continue creating issues, make the field(s) optional and remove the field(s) from this screen."
    },
    requiredFieldsUnsupportedForUser: {
        "id": "issue-create.modal.create-form.section-messages.required-fields-unsupported-for-user",
        "defaultMessage": "Field(s) marked with <button></button> aren't supported. To continue creating issues, <a>reach out to your Jira admin</a> to make the field(s) optional and remove the field(s) from this screen."
    },
    requiredFieldsUnsupportedForAdminIssueTermRefresh: {
        "id": "issue-create.modal.create-form.section-messages.required-fields-unsupported-for-admin-issue-term-refresh",
        "defaultMessage": "Field(s) marked with <button></button> aren't supported. To continue creating work items, make the field(s) optional and remove the field(s) from this screen."
    },
    requiredFieldsUnsupportedForUserIssueTermRefresh: {
        "id": "issue-create.modal.create-form.section-messages.required-fields-unsupported-for-user-issue-term-refresh",
        "defaultMessage": "Field(s) marked with <button></button> aren't supported. To continue creating work items, <a>reach out to your admin</a> to make the field(s) optional and remove the field(s) from this screen."
    }
});

});

parcelRegister("kkZNx", function(module, exports) {

$parcel$export(module.exports, "getDisplayErrorString", () => $c374471172963fdc$export$3455fb62ca5e4ef7);
const $c374471172963fdc$export$3455fb62ca5e4ef7 = (submitErrorMessage)=>{
    try {
        // Error in json:
        // "{\"errorMessages\":[],\"errors\":{\"assignee\":\"The default assignee does NOT have ASSIGNABLE permission OR Unassigned issues are turned off.\",\"othererror\":\"xxxx.\"}}";
        const errsObj = JSON.parse(submitErrorMessage);
        if (errsObj.errors) {
            const values = Object.values(errsObj.errors).filter((value)=>typeof value === 'string');
            if (values.length > 0) return values;
        }
    } catch (error) {
    /* empty */ }
    return [
        submitErrorMessage
    ];
};

});


parcelRegister("dPjg7", function(module, exports) {

$parcel$export(module.exports, "default", () => $aaa7f25ea226033d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $fKXve = parcelRequire("fKXve");
var $6svxr = parcelRequire("6svxr");

var $c4OV1 = parcelRequire("c4OV1");

var $h47gY = parcelRequire("h47gY");

var $5kYyR = parcelRequire("5kYyR");

var $lRq8t = parcelRequire("lRq8t");

var $fE4zR = parcelRequire("fE4zR");

var $bitlK = parcelRequire("bitlK");

var $4NEt5 = parcelRequire("4NEt5");

var $7jTnu = parcelRequire("7jTnu");

var $f5v5Y = parcelRequire("f5v5Y");

var $6ogCp = parcelRequire("6ogCp");
const $aaa7f25ea226033d$var$SitePicker = (props)=>{
    const { classNamePrefix: classNamePrefix, onChange: onChange, onSiteSelection: onSiteSelection, width: width = 350 } = props;
    const [{ selectedCloudId: selectedCloudId }, { setSitePickerState: setSitePickerState }] = (0, $bitlK.useSitePickerContext)();
    const { sites: sites, error: error, isLoading: isLoading } = (0, $f5v5Y.default)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [selectedValue, setSelectedValue] = (0, $eJOHy.useState)({});
    (0, $eJOHy.useEffect)(()=>{
        if (!sites) return;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const currentSite = window.location.hostname.split('.')[0];
        const prefilledValue = sites?.filter((site)=>site.label === currentSite)?.[0] || {};
        // if there's a cloudId that doesn't match host site, change selectedValue
        if (selectedCloudId && selectedCloudId !== prefilledValue?.value) {
            const selectedSite = sites?.filter((site)=>site.value === selectedCloudId)?.[0] || {};
            // if no site is found in the list for any reason, default to host domain
            const initialValue = selectedSite || prefilledValue;
            setSelectedValue(initialValue);
            onSiteSelection?.(initialValue.value);
            return;
        }
        onSiteSelection?.(prefilledValue.value || '');
        setSitePickerState({
            siteDomain: prefilledValue.url || ''
        });
        setSelectedValue(prefilledValue);
    }, [
        onChange,
        selectedCloudId,
        onSiteSelection,
        setSitePickerState,
        sites
    ]);
    const _onChange = (0, $eJOHy.useCallback)((option)=>{
        setSitePickerState({
            siteDomain: option?.url || '',
            selectedCloudId: option?.value || ''
        });
        onChange?.();
        setSelectedValue(option || {});
        onSiteSelection?.(option?.value || '');
    }, [
        setSitePickerState,
        onChange,
        onSiteSelection
    ]);
    return (0, $7jTnu.fg)('error_boundaries_to_common_package') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4NEt5.JiraIssueCreateErrorBoundary), {
        packageName: "jiraIssueCreate",
        id: "JiraSitePickerSelect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fE4zR.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6svxr.default), {
        name: "site",
        label: formatMessage((0, $6ogCp.default).sitePickerFieldLabel)
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c4OV1.default), {
            inputId: fieldProps?.id,
            value: selectedValue,
            options: $aaa7f25ea226033d$export$4dda509356982425(sites),
            // @ts-expect-error - TS2322 - Type '(option: SelectOption | null) => void' is not assignable to type '(value: Option | null, action: ActionMeta<Option>) => void'.
            onChange: _onChange,
            classNamePrefix: classNamePrefix,
            isLoading: isLoading
        }), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fKXve.ErrorMessage), null, formatMessage((0, $6ogCp.default).sitePickerError)))))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5kYyR.default), {
        packageName: "jiraIssueCreate",
        id: "JiraSitePickerSelect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fE4zR.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6svxr.default), {
        name: "site",
        label: formatMessage((0, $6ogCp.default).sitePickerFieldLabel)
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c4OV1.default), {
            inputId: fieldProps?.id,
            value: selectedValue,
            options: $aaa7f25ea226033d$export$4dda509356982425(sites),
            // @ts-expect-error - TS2322 - Type '(option: SelectOption | null) => void' is not assignable to type '(value: Option | null, action: ActionMeta<Option>) => void'.
            onChange: _onChange,
            classNamePrefix: classNamePrefix,
            isLoading: isLoading
        }), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fKXve.ErrorMessage), null, formatMessage((0, $6ogCp.default).sitePickerError)))))));
};
const $aaa7f25ea226033d$export$4dda509356982425 = (siteOptions)=>{
    return siteOptions.sort((siteA, siteB)=>{
        return siteA?.label.localeCompare(siteB?.label);
    });
};
var $aaa7f25ea226033d$export$2e2bcd8739ae039 = $aaa7f25ea226033d$var$SitePicker;

});
parcelRegister("f5v5Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $9659b7d25c3ce507$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $hPZg4 = parcelRequire("hPZg4");

var $jGzN3 = parcelRequire("jGzN3");
const $9659b7d25c3ce507$var$AVAILABLE_SITES_ENDPOINT = '/gateway/api/available-sites';
const $9659b7d25c3ce507$export$8f93d3ef836534e6 = ()=>[
        'jira-product-discovery'
    ];
const $9659b7d25c3ce507$var$fetchJiraAppLink = async ()=>(0, $jGzN3.performPostRequest)($9659b7d25c3ce507$var$AVAILABLE_SITES_ENDPOINT, {
        body: JSON.stringify({
            products: [
                'jira-software.ondemand',
                'jira-core.ondemand',
                'jira-servicedesk.ondemand',
                ...$9659b7d25c3ce507$export$8f93d3ef836534e6()
            ]
        })
    });
const $9659b7d25c3ce507$export$9d182d381b792de6 = (item)=>({
        label: item.displayName,
        value: item.cloudId,
        url: item.url
    });
const $9659b7d25c3ce507$export$905fc72a68d660cf = (sites)=>sites.map($9659b7d25c3ce507$export$9d182d381b792de6);
const $9659b7d25c3ce507$var$useFetchJiraAvailableSites = ()=>{
    const { loading: loading, error: error, data: data, fetch: fetch } = (0, $hPZg4.useService)($9659b7d25c3ce507$var$fetchJiraAppLink);
    (0, $eJOHy.useEffect)(()=>{
        fetch();
    }, [
        fetch
    ]);
    const sites = (0, $eJOHy.useMemo)(()=>{
        if (data && data.sites && data.sites.length) return $9659b7d25c3ce507$export$905fc72a68d660cf(data.sites);
        return [];
    }, [
        data
    ]);
    return {
        isLoading: loading,
        error: error,
        sites: sites
    };
};
var $9659b7d25c3ce507$export$2e2bcd8739ae039 = $9659b7d25c3ce507$var$useFetchJiraAvailableSites;

});

parcelRegister("6ogCp", function(module, exports) {

$parcel$export(module.exports, "default", () => $8239575f7ec4bd15$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $8239575f7ec4bd15$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    sitePickerFieldLabel: {
        "id": "issue-create.modal.create-form.site-picker.site-picker-field-label",
        "defaultMessage": "Site"
    },
    sitePickerError: {
        "id": "issue-create.modal.create-form.site-picker.site-picker-error",
        "defaultMessage": "Error in fetching the site options"
    }
});

});


parcelRegister("gG5II", function(module, exports) {

$parcel$export(module.exports, "SmartFieldMessage", () => $bd2db69d61f1b95e$export$ef68b7820636cd13);

var $eJOHy = parcelRequire("eJOHy");

var $Ay1uj = parcelRequire("Ay1uj");

var $5wxTT = parcelRequire("5wxTT");

var $8nu6j = parcelRequire("8nu6j");
var $3Wh6p = parcelRequire("3Wh6p");
var $1DXK0 = parcelRequire("1DXK0");

var $ecCxV = parcelRequire("ecCxV");

var $lRq8t = parcelRequire("lRq8t");

var $4xbv3 = parcelRequire("4xbv3");
var $iqtgH = parcelRequire("iqtgH");

var $fIw44 = parcelRequire("fIw44");

var $ctRhd = parcelRequire("ctRhd");

var $7JXbP = parcelRequire("7JXbP");

var $loEDP = parcelRequire("loEDP");
const $bd2db69d61f1b95e$export$ef68b7820636cd13 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { isSmartFieldsOptIn: isSmartFieldsOptIn, isSmartFieldDismissedReadMore: isSmartFieldDismissedReadMore, isSmartFieldsGicOnboardingDismissed: isSmartFieldsGicOnboardingDismissed, dismissGicOnboarding: dismissGicOnboarding } = (0, $7JXbP.useIsSmartFieldsOptIn)();
    const { updatePreferences: updatePreferences } = (0, $ctRhd.useSmartFieldsUpdateUserPreference)();
    const handleDismissMessage = (0, $eJOHy.useCallback)(()=>{
        dismissGicOnboarding();
        updatePreferences({
            hasUserOptedOut: !isSmartFieldsOptIn,
            hasUserDismissedGicOnboarding: true,
            hasUserDismissedReadMore: !!isSmartFieldDismissedReadMore
        });
    }, [
        dismissGicOnboarding,
        isSmartFieldDismissedReadMore,
        isSmartFieldsOptIn,
        updatePreferences
    ]);
    const { view: view, setView: setView, setShouldFocusChanger: setShouldFocusChanger } = (0, $fIw44.useMinimizableModal)();
    const handleOnReadMoreClick = (0, $eJOHy.useCallback)(()=>{
        if (view === 'modal') {
            setShouldFocusChanger(true);
            setView('mini');
        }
    }, [
        view,
        setShouldFocusChanger,
        setView
    ]);
    return isSmartFieldsOptIn && isSmartFieldsGicOnboardingDismissed !== true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        sourceName: "gicSmartField",
        sourceType: (0, $466f60259c330878$export$238d30785c4bca84)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        backgroundColor: "color.background.discovery",
        padding: "space.100",
        xcss: $bd2db69d61f1b95e$var$boxStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $bd2db69d61f1b95e$var$helpTextStyles
    }, formatMessage((0, $loEDP.default).readMore, {
        link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ecCxV.HelpPanelLink), {
                articleId: "3svLIYAFXrcqQlJXtqEc6G",
                appearance: "link",
                spacing: "none",
                onClick: handleOnReadMoreClick
            }, chunks)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5wxTT))),
        label: formatMessage((0, $loEDP.default).dismissButtonLabel),
        onClick: handleDismissMessage,
        spacing: "compact"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqtgH.FireScreenAnalytics), null)) : null;
};
const $bd2db69d61f1b95e$var$boxStyles = (0, $1DXK0.xcss)({
    borderRadius: 'border.radius'
});
const $bd2db69d61f1b95e$var$helpTextStyles = (0, $1DXK0.xcss)({
    alignSelf: 'center'
});

});
parcelRegister("loEDP", function(module, exports) {

$parcel$export(module.exports, "default", () => $98a98827aeff4fa2$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $98a98827aeff4fa2$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    readMore: {
        "id": "issue-create.modal.create-form.smart-field-message.read-more",
        "defaultMessage": "We\u2019ve surfaced the fields you use often, and hidden the ones you don\u2019t. <link>More about this change</link>"
    },
    dismissButtonLabel: {
        "id": "issue-create.modal.create-form.smart-field-message.dismiss-button-label",
        "defaultMessage": "Dismiss this message"
    }
});

});


parcelRegister("60nLj", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e6779090015b8db$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $12DRg = parcelRequire("12DRg");

var $fKXve = parcelRequire("fKXve");
var $cDJ0f = parcelRequire("cDJ0f");

var $3Isp2 = parcelRequire("3Isp2");

var $9A8Wt = parcelRequire("9A8Wt");

var $dPMMf = parcelRequire("dPMMf");

var $epTsa = parcelRequire("epTsa");

var $lRq8t = parcelRequire("lRq8t");

var $fE4zR = parcelRequire("fE4zR");

var $e1mtn = parcelRequire("e1mtn");

var $47Jx0 = parcelRequire("47Jx0");


var $dSpUw = parcelRequire("dSpUw");

var $jQUoP = parcelRequire("jQUoP");

var $7jTnu = parcelRequire("7jTnu");


var $kHTL4 = parcelRequire("kHTL4");

var $g35oM = parcelRequire("g35oM");

var $ask4k = parcelRequire("ask4k");
const $3e6779090015b8db$var$statusFieldMargin = (0, $dPMMf.gridSize) * 2.25;
const $3e6779090015b8db$var$HELPER_TEXT_ID = 'issue-field-status.status-view.select-status';
const $3e6779090015b8db$var$StatusField = ({ onStatusCreatedOrUpdated: onStatusCreatedOrUpdated, ...props })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [hasCreatedStatus, setHasCreatedStatus] = (0, $eJOHy.useState)(false);
    const onStatusCreatedOrUpdatedCallback = (0, $eJOHy.useCallback)(async ()=>{
        await onStatusCreatedOrUpdated?.();
        setHasCreatedStatus(true);
    }, [
        onStatusCreatedOrUpdated
    ]);
    const defaultProps = {
        isLoading: false,
        footer: undefined,
        fieldId: 'gic-status-field'
    };
    const [inlineStatusConfigExp] = (0, $epTsa.UNSAFE_noExposureExp)('inline_status_add_and_rename_in_gic');
    const isInlineStatusConfigEnabled = inlineStatusConfigExp.get('isInlineStatusConfigEnabled', false);
    const combinedInlineConfigurationExperiment = (0, $dSpUw.useCombinedInlineConfigurationExperiment)(props.canConfigureStatuses);
    const isConfigureStatusAvailable = (isInlineStatusConfigEnabled || combinedInlineConfigurationExperiment.isEnabled) && props.canConfigureStatuses;
    const isManageWorkflowAvailable = isConfigureStatusAvailable && props.projectType && props.issueTypeId;
    const getEnabledTransitions = (transitions)=>transitions.filter((transition)=>transition.isDisabled === false);
    const nextgenWorkflowUrl = props.projectType && props.issueTypeId && (0, $47Jx0.getNextgenSettingsWorkflowUrl)(props.projectType, props.projectKey, props.issueTypeId) || '';
    const openManageWorkflow = (0, $kHTL4.useOpenManageFieldTab)({
        source: (0, $0c1224accd0013fc$export$c9f0eab6c600e941),
        url: nextgenWorkflowUrl
    });
    const onOpenManageWorkflow = isConfigureStatusAvailable ? openManageWorkflow : (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))); // used as footer with popup select component
    const manageWorkFlowButton = (0, $g35oM.ManageFieldButton)({
        url: nextgenWorkflowUrl,
        label: formatMessage((0, $ask4k.default).manageWorkflowFooter),
        source: (0, $0c1224accd0013fc$export$c9f0eab6c600e941)
    });
    const getFieldContent = ()=>{
        if (props.isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3e6779090015b8db$var$FieldSkeleton, {
            isMini: props.isMini,
            "aria-busy": true
        });
        if (!props.value?.to) // error state
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3e6779090015b8db$var$FieldErrorSkeleton, {
            isMini: props.isMini
        });
        if (props.error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3e6779090015b8db$var$FieldErrorSkeleton, {
            isMini: props.isMini
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $e1mtn.StatusView), {
            ...defaultProps,
            appearance: "button",
            value: props.value?.to,
            selectedTransition: props.value,
            transitions: getEnabledTransitions(props.transitions),
            forceNoLabels: true,
            isDefaultSelect: props.isMini,
            onChange: props.onChange,
            customNoOptionsMessage: formatMessage((0, $ask4k.default).noEnabledTransitionsMessage),
            shouldFitContainer: false,
            showConfigureStatusButtons: props.canConfigureStatuses && (0, $epTsa.expVal)('inline_status_add_and_rename_in_gic', 'isInlineStatusConfigEnabled', false),
            configureStatusDialogType: props.isMini ? 'modal' : 'popup',
            configureStatusPopupPlacement: "bottom-start",
            projectId: props.projectId,
            issueTypeId: props.issueTypeId,
            projectKey: props.projectKey,
            projectType: props.projectType,
            onStatusCreatedOrUpdated: onStatusCreatedOrUpdatedCallback,
            footer: isManageWorkflowAvailable ? manageWorkFlowButton : null,
            onOpenManageWorkflow: onOpenManageWorkflow,
            configureStatusSource: (0, $a63b79662d6e9902$export$66397ed56abea4ca),
            autofocus: hasCreatedStatus,
            configureStatusButtonsEnabled: props.canConfigureStatuses,
            ...(0, $7jTnu.fg)('jfp_a11y_issue_create_form_field_with_description') && {
                helperTextId: $3e6779090015b8db$var$HELPER_TEXT_ID
            }
        });
    };
    const [selectedIssueType] = (0, $jQUoP.useIssueType)();
    const issueType = selectedIssueType?.label;
    const getMessage = ()=>{
        if ((0, $epTsa.expVal)('jira-itr-work-type-exp-1', 'isEnabled', false)) return (0, $ask4k.default).warningMessageIssueTerminologyRefreshM4;
        return (0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $ask4k.default).warningMessageIssueTermRefresh : (0, $ask4k.default).warningMessage;
    };
    const getHelpOrWarningText = ()=>{
        if (props.error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fKXve.HelperMessage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3Isp2))), {
            LEGACY_size: "small",
            color: "var(--ds-icon-warning, #E56910)",
            label: formatMessage((0, $ask4k.default).warningIconLabel)
        }), formatMessage(getMessage(), {
            issueType: issueType
        }));
        if (props.isMini) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3e6779090015b8db$var$HelperText, {
            id: $3e6779090015b8db$var$HELPER_TEXT_ID
        }, formatMessage((0, $ask4k.default).helperText));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fE4zR.FieldContainer), {
        marginTop: $3e6779090015b8db$var$statusFieldMargin
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cDJ0f.Label), {
        htmlFor: defaultProps.fieldId,
        id: "gic-status-field-label"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3e6779090015b8db$var$LabelFlex, null, formatMessage((0, $ask4k.default).statusFieldLabel))), getFieldContent(), getHelpOrWarningText());
};
var $3e6779090015b8db$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $3e6779090015b8db$var$StatusField;
const $3e6779090015b8db$var$HelperText = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c81o8v _syaz131l _19pk12x7 _otyru2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3e6779090015b8db$var$FieldSkeleton = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $9A8Wt.Skeleton), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_otyri2wt",
            __cmplp.isMini ? "_4t3i1ylp _1bsb1osq" : "_4t3izwfg _1bsb68cl",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3e6779090015b8db$var$FieldErrorSkeleton = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isMini: isMini, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_otyr12x7 _bfhkn82g",
            __cmplp.isMini ? "_4t3i1ylp _1bsb1osq" : "_4t3izwfg _1bsb68cl",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3e6779090015b8db$var$LabelFlex = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1y6m",
            __cmplp.className
        ])
    });
});

});
parcelRegister("e1mtn", function(module, exports) {

$parcel$export(module.exports, "StatusView", () => $cd5a236a0b8ca92f$export$a11134e1462e763);
$parcel$export(module.exports, "default", () => $cd5a236a0b8ca92f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $1O6Yz = parcelRequire("1O6Yz");

var $12DRg = parcelRequire("12DRg");

var $h6i8k = parcelRequire("h6i8k");

var $8nu6j = parcelRequire("8nu6j");
var $lmgo6 = parcelRequire("lmgo6");
var $bQP4O = parcelRequire("bQP4O");
var $1DXK0 = parcelRequire("1DXK0");

var $6XEne = parcelRequire("6XEne");
var $c4OV1 = parcelRequire("c4OV1");
var $sl8jM = parcelRequire("sl8jM");

var $lLL16 = parcelRequire("lLL16");

var $f5dwt = parcelRequire("f5dwt");

var $hrKgE = parcelRequire("hrKgE");

var $fAZgY = parcelRequire("fAZgY");

var $7jTnu = parcelRequire("7jTnu");

var $lRq8t = parcelRequire("lRq8t");

var $6d9QY = parcelRequire("6d9QY");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $epTsa = parcelRequire("epTsa");

var $9ZjBG = parcelRequire("9ZjBG");

var $6rZHS = parcelRequire("6rZHS");

var $5S4to = parcelRequire("5S4to");

var $jd93d = parcelRequire("jd93d");

var $bskNA = parcelRequire("bskNA");


var $6UBwj = parcelRequire("6UBwj");

var $90zjX = parcelRequire("90zjX");

var $6ReHL = parcelRequire("6ReHL");

var $aKmI9 = parcelRequire("aKmI9");

var $aY0vM = parcelRequire("aY0vM");

var $ke54d = parcelRequire("ke54d");

var $2gPiL = parcelRequire("2gPiL");

var $dYFa5 = parcelRequire("dYFa5");

var $dSpUw = parcelRequire("dSpUw");

var $kTIpG = parcelRequire("kTIpG");

var $7Pc1n = parcelRequire("7Pc1n");

var $8X6rE = parcelRequire("8X6rE");

var $fkCrf = parcelRequire("fkCrf");

var $eCUrP = parcelRequire("eCUrP");
const $cd5a236a0b8ca92f$var$defaultPopperProps = {
    modifiers: [
        {
            name: 'offset',
            options: {
                offset: [
                    0,
                    8
                ]
            }
        },
        {
            name: 'preventOverflow',
            options: {
                padding: 5,
                rootBoundary: 'document'
            }
        }
    ],
    // makes it work inside modal-dialog
    strategy: 'fixed'
};
const $cd5a236a0b8ca92f$var$isOptionDisabled = (option)=>('transition' in option && option.transition.isDisabled) ?? false;
const $cd5a236a0b8ca92f$var$isTransitionOption = (option)=>'transition' in option;
const $cd5a236a0b8ca92f$var$FormatTransitionOptionLabel = ({ option: option })=>{
    const { forceNoLabels: forceNoLabels = false, showConfigureStatusButtons: showConfigureStatusButtons, configureStatusButtonsEnabled: configureStatusButtonsEnabled, projectId: projectId, projectKey: projectKey, filteredAndOrderedTransitions: filteredAndOrderedTransitions } = $cd5a236a0b8ca92f$var$useStatusViewContext();
    const combinedInlineConfigurationExperiment = (0, $dSpUw.useCombinedInlineConfigurationExperiment)(configureStatusButtonsEnabled);
    const isGlobalOnly = (0, $90zjX.isOnlyGlobalTransitions)(filteredAndOrderedTransitions || []);
    const showLabel = !(forceNoLabels || isGlobalOnly);
    if (!(0, $7jTnu.fg)('inline_config_a11y_improvements') && (showConfigureStatusButtons || combinedInlineConfigurationExperiment.isEnabled) && projectId && projectKey) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dYFa5.Transition), {
        transition: option.transition,
        hasLabel: showLabel,
        testId: "issue-field-status.ui.status-view.transition"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $cd5a236a0b8ca92f$var$transitionOptionStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dYFa5.Transition), {
        transition: option.transition,
        hasLabel: showLabel,
        testId: "issue-field-status.ui.status-view.transition"
    }));
};
const $cd5a236a0b8ca92f$var$FormatTransitionOptionLabelForCommandPalette = ({ option: option, transitionProps: transitionProps })=>{
    const { forceNoLabels: forceNoLabels = false, showConfigureStatusButtons: showConfigureStatusButtons, configureStatusButtonsEnabled: configureStatusButtonsEnabled, projectId: projectId, projectKey: projectKey, filteredAndOrderedTransitions: filteredAndOrderedTransitions } = $cd5a236a0b8ca92f$var$useStatusViewContext();
    const combinedInlineConfigurationExperiment = (0, $dSpUw.useCombinedInlineConfigurationExperiment)(configureStatusButtonsEnabled);
    const isGlobalOnly = (0, $90zjX.isOnlyGlobalTransitions)(filteredAndOrderedTransitions || []);
    const showLabel = !(forceNoLabels || isGlobalOnly);
    if (!(0, $7jTnu.fg)('inline_config_a11y_improvements') && (showConfigureStatusButtons || combinedInlineConfigurationExperiment.isEnabled) && projectId && projectKey) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dYFa5.Transition), {
        transition: option.transition,
        hasLabel: showLabel,
        addTransitionArrowSpacing: transitionProps?.addTransitionArrowSpacing,
        testId: "issue-field-status.ui.status-view.transition"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dYFa5.Transition), {
        transition: option.transition,
        hasLabel: showLabel,
        addTransitionArrowSpacing: transitionProps?.addTransitionArrowSpacing,
        testId: "issue-field-status.ui.status-view.transition"
    });
};
const $cd5a236a0b8ca92f$var$FormatTransitionOptionLabelWithCreateStatus = ({ option: option })=>{
    const { value: value, transitions: transitions, showConfigureStatusButtons: showConfigureStatusButtons, configureStatusButtonsEnabled: configureStatusButtonsEnabled, projectId: projectId, projectKey: projectKey, projectType: projectType, issueTypeId: issueTypeId, onClickConfigureStatus: onClickConfigureStatus, onCloseConfigureStatus: onCloseConfigureStatus, onStatusCreatedOrUpdated: onStatusCreatedOrUpdated, configureStatusSource: configureStatusSource, createStatusButtonRef: createStatusButtonRef, editStatusButtonRef: editStatusButtonRef, shouldStatusConfigTriggerModal: shouldStatusConfigTriggerModal } = $cd5a236a0b8ca92f$var$useStatusViewContext();
    const combinedInlineConfigurationExperiment = (0, $dSpUw.useCombinedInlineConfigurationExperiment)(configureStatusButtonsEnabled);
    const [inlineStatusConfigExp] = (0, $epTsa.UNSAFE_noExposureExp)('inline_status_add_and_rename_in_gic');
    const isInlineStatusExperimentEnabled = inlineStatusConfigExp.get('isInlineStatusConfigEnabled', false);
    const isConfigureStatusAvailable = isInlineStatusExperimentEnabled && showConfigureStatusButtons && projectType && projectKey;
    if ((isConfigureStatusAvailable || combinedInlineConfigurationExperiment.isEnabled) && projectKey && projectType && projectId && issueTypeId && 'value' in option) switch(option.value){
        case 0, $559e2d0f325c757f$export$bbd08ee543ba8cc3:
            return (0, $7jTnu.fg)('inline_config_a11y_improvements') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kTIpG.CreateStatusOption), {
                projectId: projectId,
                projectKey: projectKey,
                projectType: projectType,
                issueTypeId: issueTypeId,
                statusNames: transitions?.map((transition)=>transition?.to?.name),
                onClick: onClickConfigureStatus,
                onClose: onCloseConfigureStatus,
                onStatusCreated: onStatusCreatedOrUpdated,
                buttonRef: createStatusButtonRef,
                source: configureStatusSource,
                shouldTriggerModal: shouldStatusConfigTriggerModal
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aKmI9.CreateStatusButton), {
                projectId: projectId,
                projectKey: projectKey,
                projectType: projectType,
                issueTypeId: issueTypeId,
                statusNames: transitions?.map((transition)=>transition?.to?.name),
                onClick: onClickConfigureStatus,
                onClose: onCloseConfigureStatus,
                onStatusCreated: onStatusCreatedOrUpdated,
                isPressable: true,
                buttonRef: createStatusButtonRef,
                source: configureStatusSource,
                shouldTriggerModal: shouldStatusConfigTriggerModal
            });
        case 0, $559e2d0f325c757f$export$bc1622166baa0162:
            return transitions && value ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7Pc1n.EditStatusOption), {
                status: (0, $6rZHS.transformServerRestStatusToStatus)(value),
                statuses: transitions.map((transition)=>(0, $6rZHS.transformServerRestStatusToStatus)(transition?.to)).filter((status, index, self)=>index === self.findIndex((t)=>t.statusName === status.statusName)),
                projectId: projectId,
                projectKey: projectKey,
                issueTypeId: issueTypeId,
                statusNames: transitions?.map((transition)=>transition?.to?.name),
                onClick: onClickConfigureStatus,
                onClose: onCloseConfigureStatus,
                onStatusUpdated: onStatusCreatedOrUpdated,
                source: configureStatusSource,
                buttonRef: editStatusButtonRef,
                shouldTriggerModal: shouldStatusConfigTriggerModal
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null);
        case 0, $559e2d0f325c757f$export$4f9299d0cd8b6a8b:
            return (0, $7jTnu.fg)('inline_config_a11y_improvements') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                xcss: $cd5a236a0b8ca92f$var$manageWorkflowStyles
            }, option.label) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bQP4O.default), {
                xcss: $cd5a236a0b8ca92f$var$manageWorkflowStyles
            }, option.label);
        default:
            break;
    }
    if ($cd5a236a0b8ca92f$var$isTransitionOption(option)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cd5a236a0b8ca92f$var$FormatTransitionOptionLabel, {
        option: option
    });
};
const $cd5a236a0b8ca92f$var$CommandPaletteStatusViewComponent = ()=>{
    const { isLoading: isLoading, value: value, transitions: transitions, onSuccess: onSuccess, onFetch: onFetch, onUpdateStatusMutation: onUpdateStatusMutation, filteredAndOrderedTransitions: filteredAndOrderedTransitions } = $cd5a236a0b8ca92f$var$useStatusViewContext();
    const wasFetchSuccessful = transitions != null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6ReHL.CommandPaletteStatusView), {
        transitions: filteredAndOrderedTransitions,
        currentStatus: value,
        onSuccess: onSuccess,
        wasFetchSuccessful: wasFetchSuccessful,
        renderTransition: (0, $fAZgY.useCallbackWithCondition)((option, transitionProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cd5a236a0b8ca92f$var$FormatTransitionOptionLabelForCommandPalette, {
                option: option,
                transitionProps: transitionProps
            }), [], ()=>(0, $7jTnu.fg)('jfp_magma_issue-stability-phase1')),
        onFetch: onFetch,
        isLoading: isLoading,
        onUpdateStatusMutation: onUpdateStatusMutation
    });
};
const $cd5a236a0b8ca92f$var$Lozenge = ({ targetRef: targetRef, triggerProps: triggerProps })=>{
    const { isEditable: isEditable = true, isSaving: isSaving = false, error: error, value: value, statusButtonRef: statusButtonRef, isOpen: isOpen } = $cd5a236a0b8ca92f$var$useStatusViewContext();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    if (isSaving) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lLL16.default), {
        border: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6UBwj.WrappedStatusLozenge), {
        targetRef: targetRef,
        status: value,
        error: error,
        contentRef: statusButtonRef,
        triggerProps: triggerProps
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6UBwj.WrappedStatusLozenge), {
        ariaLabel: `${value.name} - ${formatMessage((0, $aY0vM.default).changeStatus)}`,
        error: error,
        hasHoverState: true,
        isEditable: isEditable,
        isOpen: isOpen,
        status: value,
        targetRef: targetRef,
        contentRef: statusButtonRef,
        triggerProps: triggerProps
    });
};
const $cd5a236a0b8ca92f$var$StatusButtonComponent = ({ targetRef: targetRef, triggerProps: triggerProps, helperTextId: helperTextId })=>{
    const { isEditable: isEditable = true, isSaving: isSaving = false, value: value, statusButtonRef: statusButtonRef, shouldFitContainer: shouldFitContainer = true, isOpen: isOpen } = $cd5a236a0b8ca92f$var$useStatusViewContext();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const statusButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2gPiL.StatusButton), {
        ariaLabel: `${value.name} - ${formatMessage((0, $aY0vM.default).changeStatus)}`,
        isEditable: isEditable,
        isOpen: isOpen,
        status: value,
        targetRef: targetRef,
        statusButtonRef: statusButtonRef,
        shouldFitContainer: shouldFitContainer,
        triggerProps: triggerProps,
        helperTextId: helperTextId
    });
    return isSaving ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lLL16.default), null, statusButton) : statusButton;
};
const $cd5a236a0b8ca92f$var$FocusWrapper = ({ children: children })=>{
    const { isSaving: isSaving = false } = $cd5a236a0b8ca92f$var$useStatusViewContext();
    const childWrapperRef = (0, $eJOHy.useRef)(null);
    const previousIsSaving = (0, $6d9QY.usePrevious)(isSaving);
    (0, $eJOHy.useEffect)(()=>{
        if (previousIsSaving === true && isSaving === false) childWrapperRef.current && // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        childWrapperRef.current.children.length > 0 && // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        childWrapperRef.current.children[0].focus();
    }, [
        isSaving,
        previousIsSaving
    ]); // @ts-expect-error - TS2322 - Type 'MutableRefObject<unknown>' is not assignable to type 'LegacyRef<HTMLDivElement> | undefined'.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        ref: childWrapperRef
    }, children);
};
const $cd5a236a0b8ca92f$var$Target = ({ targetRef: targetRef, triggerProps: triggerProps, helperTextId: helperTextId })=>{
    const { value: value, appearance: appearance, registerInCommandPalette: registerInCommandPalette } = $cd5a236a0b8ca92f$var$useStatusViewContext();
    if (value) {
        if (appearance === 'lozenge') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cd5a236a0b8ca92f$var$FocusWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cd5a236a0b8ca92f$var$Lozenge, {
            targetRef: targetRef,
            triggerProps: triggerProps
        }));
        if (appearance === 'button') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cd5a236a0b8ca92f$var$FocusWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cd5a236a0b8ca92f$var$StatusButtonComponent, {
            targetRef: targetRef,
            triggerProps: triggerProps,
            ...(0, $7jTnu.fg)('jfp_a11y_issue_create_form_field_with_description') && {
                helperTextId: helperTextId
            }
        })), registerInCommandPalette && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cd5a236a0b8ca92f$var$CommandPaletteStatusViewComponent, null));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", null);
};
const $cd5a236a0b8ca92f$var$Footer = ()=>{
    const { footer: footer, showConfigureStatusButtons: showConfigureStatusButtons, configureStatusButtonsEnabled: configureStatusButtonsEnabled, value: value, transitions: transitions, onClickConfigureStatus: onClickConfigureStatus, onCloseConfigureStatus: onCloseConfigureStatus, onStatusCreatedOrUpdated: onStatusCreatedOrUpdated, createStatusButtonRef: createStatusButtonRef, editStatusButtonRef: editStatusButtonRef, configureStatusSource: configureStatusSource, shouldStatusConfigTriggerModal: shouldStatusConfigTriggerModal, projectKey: projectKey, projectId: projectId, projectType: projectType, issueTypeId: issueTypeId } = $cd5a236a0b8ca92f$var$useStatusViewContext();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const combinedInlineConfigurationExperiment = (0, $dSpUw.useCombinedInlineConfigurationExperiment)(configureStatusButtonsEnabled);
    const showCreateStatusButton = (combinedInlineConfigurationExperiment.isEnabled || showConfigureStatusButtons) && projectKey && projectType && projectId;
    const showEditStatusButton = showCreateStatusButton && value && transitions;
    if (!footer && !showCreateStatusButton) return null;
    const footerContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, showCreateStatusButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aKmI9.CreateStatusButton), {
        projectId: projectId,
        projectKey: projectKey,
        projectType: projectType,
        // temporary empty string will trigger a loading state within the create status modal
        issueTypeId: issueTypeId ?? '',
        statusNames: transitions?.map((transition)=>transition?.to?.name),
        onClick: onClickConfigureStatus,
        onClose: onCloseConfigureStatus,
        onStatusCreated: onStatusCreatedOrUpdated,
        buttonRef: createStatusButtonRef,
        source: configureStatusSource,
        shouldTriggerModal: shouldStatusConfigTriggerModal
    }), showEditStatusButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8X6rE.EditStatusButton), {
        status: (0, $6rZHS.transformServerRestStatusToStatus)(value),
        statuses: transitions.map((transition)=>(0, $6rZHS.transformServerRestStatusToStatus)(transition?.to)).filter((status, index, self)=>index === self.findIndex((t)=>t.statusName === status.statusName)),
        projectId: projectId,
        projectKey: projectKey,
        // temporary empty string will trigger a loading state within the edit status modal
        issueTypeId: issueTypeId ?? '',
        statusNames: transitions?.map((transition)=>transition?.to?.name),
        onClick: onClickConfigureStatus,
        onClose: onCloseConfigureStatus,
        onStatusUpdated: onStatusCreatedOrUpdated,
        source: configureStatusSource,
        buttonRef: editStatusButtonRef,
        shouldTriggerModal: shouldStatusConfigTriggerModal
    }), footer);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        direction: "column",
        xcss: $cd5a236a0b8ca92f$var$statusViewFooterStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("fieldset", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("legend", {
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _ogto7mnp _4t3it94y _1bsbt94y _kqswstnw"
        ])
    }, formatMessage((0, $aY0vM.default).status)), footerContent));
};
const $cd5a236a0b8ca92f$var$StatusViewContext = /*#__PURE__*/ (0, $eJOHy.createContext)({
    isLoading: false,
    value: {
        id: '',
        name: '',
        statusCategory: {
            id: 0
        }
    },
    transitions: [],
    appearance: 'button',
    shouldStatusConfigTriggerModal: true,
    isOpen: false,
    setIsConfigureStatusModalOpen: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    onClickConfigureStatus: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    onCloseConfigureStatus: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    menuListRef: null,
    createStatusButtonRef: null,
    editStatusButtonRef: null,
    filteredAndOrderedTransitions: []
});
const $cd5a236a0b8ca92f$var$useStatusViewContext = ()=>{
    const context = (0, $eJOHy.useContext)($cd5a236a0b8ca92f$var$StatusViewContext);
    if (!context) throw new Error('useStatusViewContext must be used within a StatusViewProvider');
    return context;
};
const $cd5a236a0b8ca92f$export$a11134e1462e763 = (props)=>{
    const { isEditable: isEditable = true, isSaving: isSaving = false, isLoading: isLoading, value: value, transitions: transitions, isDefaultSelect: isDefaultSelect = false, selectedTransition: selectedTransition, onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), onOpen: onOpen = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), onClose: onClose = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), shouldCaptureEscape: shouldCaptureEscape = true, customNoOptionsMessage: customNoOptionsMessage, statusButtonRef: statusButtonRef, popperProps: popperProps, fieldId: fieldId, showConfigureStatusButtons: showConfigureStatusButtons, configureStatusDialogType: configureStatusDialogType = 'modal', configureStatusPopupPlacement: configureStatusPopupPlacement = 'bottom-end', configureStatusButtonsEnabled: configureStatusButtonsEnabled, projectKey: projectKey, projectType: projectType, defaultOpen: // for testing
    defaultOpen = false, onOpenManageWorkflow: onOpenManageWorkflow, autofocus: autofocus = false, helperTextId: helperTextId } = props;
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const selectRef = (0, $eJOHy.useRef)(null);
    const wasChanged = (0, $eJOHy.useRef)(false);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const combinedInlineConfigurationExperiment = (0, $dSpUw.useCombinedInlineConfigurationExperiment)(configureStatusButtonsEnabled);
    const wasFetchSuccessful = transitions != null;
    const filteredAndOrderedTransitions = (0, $eJOHy.useMemo)(()=>(0, $90zjX.getFilteredOrderedTransitions)(transitions, value.id), [
        transitions,
        value.id
    ]);
    const [inlineStatusConfigExp] = (0, $epTsa.UNSAFE_noExposureExp)('inline_status_add_and_rename_in_gic');
    const isInlineStatusExperimentEnabled = inlineStatusConfigExp.get('isInlineStatusConfigEnabled', false);
    const isConfigureStatusAvailable = isInlineStatusExperimentEnabled && showConfigureStatusButtons && projectType && projectKey;
    const createStatusButtonRef = (0, $eJOHy.useRef)(null);
    const editStatusButtonRef = (0, $eJOHy.useRef)(null);
    const menuListRef = (0, $eJOHy.useRef)(null);
    const [isConfigureStatusModalOpen, setIsConfigureStatusModalOpen] = (0, $eJOHy.useState)(false);
    const [isConfigureStatusPopupOpen, setIsConfigureStatusPopupOpen] = (0, $eJOHy.useState)(false);
    const [shouldRefocus, setShouldRefocus] = (0, $eJOHy.useState)(false);
    (0, $eJOHy.useEffect)(()=>{
        if (shouldRefocus) {
            statusButtonRef?.current?.focus();
            setShouldRefocus(false);
        }
    }, [
        shouldRefocus,
        statusButtonRef
    ]);
    const { Panel: ConfigureStatusPopupContent, Provider: ConfigureStatusPopupTriggerContextProvider } = (0, $5S4to.usePanelContext)((0, $eCUrP.ConfigureStatusPanel));
    const shouldRenderSelectComponent = isDefaultSelect && !!selectedTransition;
    const shouldStatusConfigTriggerModal = configureStatusDialogType === 'modal' || shouldRenderSelectComponent;
    const onCloseConfigureStatus = (0, $eJOHy.useCallback)(()=>{
        if (shouldStatusConfigTriggerModal) setIsConfigureStatusModalOpen(false);
        else setIsConfigureStatusPopupOpen(false);
        setShouldRefocus(true);
    }, [
        shouldStatusConfigTriggerModal
    ]);
    const onClickConfigureStatus = (0, $eJOHy.useCallback)(()=>{
        if (shouldStatusConfigTriggerModal) setIsConfigureStatusModalOpen(true);
        else setIsConfigureStatusPopupOpen(true);
    }, [
        shouldStatusConfigTriggerModal
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (autofocus) selectRef.current?.focus?.();
    }, [
        autofocus
    ]); // specifically for screen readers
    const getTransitionOptionLabel = (option)=>{
        if ($cd5a236a0b8ca92f$var$isTransitionOption(option)) return option.transition.isGlobal ? formatMessage((0, $aY0vM.default).transitionTo, {
            statusName: option.label
        }) : `${option.transition.name} \u{2192} ${option.transition.to.name}`;
        return option.label;
    };
    const mergedPopperProps = (0, $eJOHy.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))($cd5a236a0b8ca92f$var$defaultPopperProps, popperProps), [
        popperProps
    ]);
    const handleChangeStatus = (0, $eJOHy.useCallback)((transition)=>{
        const { hasScreen: hasScreen } = transition;
        wasChanged.current = true;
        const analyticsEvent = createAnalyticsEvent({
            action: 'transitionSelected',
            actionSubject: 'statusField'
        });
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'transitionSelectedStatusField', {
            hasScreen: hasScreen
        });
        (0, $h6i8k.default)('issue.fields.status.popup.submit');
        onChange?.(transition, analyticsEvent);
    }, [
        onChange,
        createAnalyticsEvent
    ]);
    const handleChange = (0, $eJOHy.useCallback)((option)=>{
        if ((combinedInlineConfigurationExperiment.isEnabled || isConfigureStatusAvailable) && option?.value && [
            (0, $559e2d0f325c757f$export$bbd08ee543ba8cc3),
            (0, $559e2d0f325c757f$export$4f9299d0cd8b6a8b),
            (0, $559e2d0f325c757f$export$bc1622166baa0162)
        ].includes(option.value)) {
            switch(option?.value){
                case 0, $559e2d0f325c757f$export$bbd08ee543ba8cc3:
                    createStatusButtonRef?.current?.click();
                    setIsConfigureStatusModalOpen(true);
                    break;
                case 0, $559e2d0f325c757f$export$bc1622166baa0162:
                    editStatusButtonRef?.current?.click();
                    setIsConfigureStatusModalOpen(true);
                    break;
                case 0, $559e2d0f325c757f$export$4f9299d0cd8b6a8b:
                    onOpenManageWorkflow && onOpenManageWorkflow();
                    break;
                default:
                    break;
            }
            return;
        }
        if (option && $cd5a236a0b8ca92f$var$isTransitionOption(option)) handleChangeStatus(option.transition);
    }, [
        handleChangeStatus,
        isConfigureStatusAvailable,
        onOpenManageWorkflow,
        combinedInlineConfigurationExperiment.isEnabled
    ]);
    const handleOpen = (0, $eJOHy.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'openDropdown',
            actionSubject: 'statusField'
        });
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'openDropdownStatusField');
        onOpen?.(analyticsEvent);
        setIsOpen(true);
        combinedInlineConfigurationExperiment.fireExposure();
    }, [
        onOpen,
        combinedInlineConfigurationExperiment,
        createAnalyticsEvent
    ]);
    const handleClose = (0, $eJOHy.useCallback)(()=>{
        wasChanged.current = false;
        onClose?.();
        setIsOpen(false);
        setShouldRefocus(true);
    }, [
        onClose
    ]);
    const isStatusInlineFooterEnabled = (0, $eJOHy.useMemo)(()=>combinedInlineConfigurationExperiment.isEnabled || isInlineStatusExperimentEnabled && showConfigureStatusButtons, [
        combinedInlineConfigurationExperiment.isEnabled,
        isInlineStatusExperimentEnabled,
        showConfigureStatusButtons
    ]);
    const transformedOptions = (0, $eJOHy.useMemo)(()=>(0, $90zjX.transformOptions)(filteredAndOrderedTransitions || []), [
        filteredAndOrderedTransitions
    ]);
    const selectOptions = (0, $dSpUw.useSelectOptions)(transformedOptions, isStatusInlineFooterEnabled);
    const getNoOptionsMessage = ()=>{
        if (customNoOptionsMessage) return customNoOptionsMessage;
        const noPermissionMessage = (0, $7jTnu.fg)('jira-issue-terminology-refresh-m3') ? (0, $aY0vM.default).noPermissionIssueTermRefresh : (0, $aY0vM.default).noPermission;
        return formatMessage(wasFetchSuccessful ? noPermissionMessage : (0, $aY0vM.default).cannotLoadTransitions);
    };
    const statusPopup = shouldRenderSelectComponent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c4OV1.default), {
        label: formatMessage((0, $aY0vM.default).selectStatus),
        inputId: fieldId,
        noOptionsMessage: getNoOptionsMessage,
        formatOptionLabel: (option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cd5a236a0b8ca92f$var$FormatTransitionOptionLabelWithCreateStatus, {
                option: option
            }),
        getOptionLabel: getTransitionOptionLabel,
        options: selectOptions,
        isLoading: isLoading,
        isDisabled: !isEditable,
        isOptionDisabled: $cd5a236a0b8ca92f$var$isOptionDisabled,
        onChange: handleChange,
        value: (0, $90zjX.transformOptions)([
            selectedTransition
        ])[0],
        isSearchable: false,
        onMenuOpen: handleOpen,
        closeMenuOnSelect: true,
        components: {
            LoadingMessage: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ke54d.LoadingSpinner), null),
            ...isStatusInlineFooterEnabled && {
                Group: (0, $9ZjBG.GroupComponentWithStickyFooter),
                Option: (0, $dSpUw.OptionComponent)
            },
            ...(0, $7jTnu.fg)('inline_config_a11y_improvements') && {
                MenuList: ({ children: children, ...menuListProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6XEne.components).MenuList, {
                        ...menuListProps,
                        innerRef: menuListRef
                    }, children)
            }
        },
        menuIsOpen: isConfigureStatusModalOpen ? false : undefined,
        popperProps: mergedPopperProps,
        ref: selectRef
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $sl8jM.default), {
        inputId: fieldId,
        noOptionsMessage: getNoOptionsMessage,
        formatOptionLabel: (option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cd5a236a0b8ca92f$var$FormatTransitionOptionLabel, {
                option: option
            }),
        getOptionLabel: getTransitionOptionLabel,
        options: transformedOptions,
        target: ({ ref: ref })=>(0, $7jTnu.fg)('jsc-1931_pass_custom_ref_to_status_view') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cd5a236a0b8ca92f$var$Target, {
                targetRef: statusButtonRef ? (0, $jd93d.mergeRefs)(ref, statusButtonRef) : ref,
                ...(0, $7jTnu.fg)('jfp_a11y_issue_create_form_field_with_description') && {
                    helperTextId: helperTextId
                }
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cd5a236a0b8ca92f$var$Target, {
                targetRef: ref,
                ...(0, $7jTnu.fg)('jfp_a11y_issue_create_form_field_with_description') && {
                    helperTextId: helperTextId
                }
            }),
        isLoading: isLoading,
        isDisabled: !isEditable,
        isOptionDisabled: $cd5a236a0b8ca92f$var$isOptionDisabled,
        searchThreshold: 99999,
        onChange: handleChange,
        onOpen: handleOpen,
        handleClick: handleOpen,
        onClose: handleClose,
        closeMenuOnSelect: true,
        components: {
            LoadingMessage: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ke54d.LoadingSpinner), null),
            ...(0, $7jTnu.fg)('inline_config_a11y_improvements') && {
                MenuList: ({ children: children, ...menuListProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6XEne.components).MenuList, {
                        ...menuListProps,
                        innerRef: menuListRef
                    }, children)
            }
        },
        isOpen: isConfigureStatusModalOpen ? false : undefined,
        popperProps: mergedPopperProps,
        footer: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cd5a236a0b8ca92f$var$Footer, null),
        defaultIsOpen: defaultOpen,
        label: formatMessage((0, $aY0vM.default).selectStatus),
        shouldCloseMenuOnTab: false
    });
    const stableProps = (0, $hrKgE.useShallowStableReference)(props, (0, $7jTnu.fg)('jfp_magma_issue-stability-phase1'));
    const contextValues = (0, $eJOHy.useMemo)(()=>({
            ...stableProps,
            menuListRef: menuListRef,
            shouldStatusConfigTriggerModal: shouldStatusConfigTriggerModal,
            isOpen: isOpen,
            setIsConfigureStatusModalOpen: setIsConfigureStatusModalOpen,
            onClickConfigureStatus: onClickConfigureStatus,
            onCloseConfigureStatus: onCloseConfigureStatus,
            createStatusButtonRef: createStatusButtonRef,
            editStatusButtonRef: editStatusButtonRef,
            filteredAndOrderedTransitions: filteredAndOrderedTransitions
        }), [
        stableProps,
        shouldStatusConfigTriggerModal,
        isOpen,
        setIsConfigureStatusModalOpen,
        onClickConfigureStatus,
        onCloseConfigureStatus,
        filteredAndOrderedTransitions
    ]); /* This prevents the dropdown from being accessible while saving/not editable,
                                                                                                                                                                             * because for the underlying PopupSelect, the `isDisabled` prop only prevents
                                                                                                                                                                             * the actual dropdown items from being selectable - the dropdown itself still
                                                                                                                                                                             * pops up/down.
                                                                                                                                                                             */ 
    if (isSaving || !isEditable) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cd5a236a0b8ca92f$var$StatusViewContext.Provider, {
        value: contextValues
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cd5a236a0b8ca92f$var$Target, null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cd5a236a0b8ca92f$var$StatusViewContext.Provider, {
        value: contextValues
    }, isConfigureStatusPopupOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fkCrf.ConfigureStatusPopup), {
        placement: configureStatusPopupPlacement,
        renderTarget: $cd5a236a0b8ca92f$var$Target,
        renderPopupContent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ConfigureStatusPopupContent, null),
        isTargetEditable: isEditable,
        onClose: ()=>setIsConfigureStatusPopupOpen(false)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ConfigureStatusPopupTriggerContextProvider, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bskNA.ModalContextProvider), null, !shouldCaptureEscape && ((0, $7jTnu.fg)('treegrid_keyboard_navigation') || (0, $7jTnu.fg)('nin-grid-keyboard-navigation')) ? statusPopup : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f5dwt.default), {
        onEscape: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
    }, statusPopup))));
};
const $cd5a236a0b8ca92f$var$statusViewFooterStyles = (0, $1DXK0.xcss)({
    borderTop: `2px solid ${"var(--ds-border, #091E4224)"}`
});
const $cd5a236a0b8ca92f$var$manageWorkflowStyles = (0, $1DXK0.xcss)({
    height: '100%',
    width: '100%',
    backgroundColor: 'color.background.neutral.subtle',
    alignItems: 'center',
    textAlign: 'left',
    fontWeight: 'font.weight.medium'
});
const $cd5a236a0b8ca92f$var$visuallyHiddenLegendStyles = null;
const $cd5a236a0b8ca92f$var$transitionOptionStyles = (0, $1DXK0.xcss)({
    paddingTop: 'space.025',
    paddingBottom: 'space.025'
});
var $cd5a236a0b8ca92f$export$2e2bcd8739ae039 = $cd5a236a0b8ca92f$export$a11134e1462e763;

});
parcelRegister("lLL16", function(module, exports) {

$parcel$export(module.exports, "default", () => $da1f6c4838dfb0b0$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $7ep4S = parcelRequire("7ep4S");
function $da1f6c4838dfb0b0$export$2e2bcd8739ae039(props) {
    const { border: border, children: children } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($da1f6c4838dfb0b0$var$BlanketContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($da1f6c4838dfb0b0$var$BackgroundContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($da1f6c4838dfb0b0$var$Background, {
        border: border
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($da1f6c4838dfb0b0$var$ComponentContainer, null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($da1f6c4838dfb0b0$var$SpinnerContainer, {
        role: "status",
        "aria-label": "Loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), null)));
}
$da1f6c4838dfb0b0$export$2e2bcd8739ae039.defaultProps = {
    border: true
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $da1f6c4838dfb0b0$var$BlanketContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswh2mm _1e0c116y _2lx2vrvc _4t3i1wug",
            __cmplp.className
        ])
    });
});
const $da1f6c4838dfb0b0$var$SpinnerContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswstnw _154iidpf _1ltvidpf _4t3i1osq _1bsb1osq _1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _u5f3u2gc _19bvu2gc",
            __cmplp.className
        ])
    });
});
const $da1f6c4838dfb0b0$var$BackgroundContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo1wug _18m91wug _kqswstnw _4t3i1osq _1bsb1osq _vchhusvi _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o",
            __cmplp.className
        ])
    });
});
const $da1f6c4838dfb0b0$var$Background = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { border: border, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko1l7b _kqswh2mm _4t3i1osq _1bsb1osq _vchhusvi _bfhk11bn",
            __cmplp.border ? "_19it1x87" : "_19itglyw",
            __cmplp.className
        ])
    });
});
const $da1f6c4838dfb0b0$var$ComponentContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _tzy4sxj9",
            __cmplp.className
        ])
    });
});

});

parcelRegister("9ZjBG", function(module, exports) {

$parcel$export(module.exports, "GroupComponentWithStickyFooter", () => $f299752236250846$export$a4fcc8b2698425e6);
/* GroupComponentWithStickyFooter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $6XEne = parcelRequire("6XEne");

const $f299752236250846$var$groupStyles = {
    root: "_ca0qze3t"
};
const $f299752236250846$export$a4fcc8b2698425e6 = ({ children: children, ...groupProps })=>{
    const containStickyFooterGroup = (0, $eJOHy.useMemo)(()=>{
        return groupProps.data.options.find((option)=>option.groupType === (0, $2a68cf016118f389$export$e13d614fc55c6ce9));
    }, [
        groupProps.data.options
    ]);
    if (containStickyFooterGroup) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $f299752236250846$var$stickyFooterGroupWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6XEne.components).Group, {
        ...groupProps,
        innerProps: {
            ...groupProps.innerProps ?? {},
            style: {
                ...groupProps.innerProps?.style ?? {},
                paddingTop: 0
            },
            className: (0, $2a68cf016118f389$export$1ae91d219a8713ac)
        },
        xcss: $f299752236250846$var$groupStyles.root
    }, children));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6XEne.components).Group, groupProps, children);
};
const $f299752236250846$var$stickyFooterGroupWrapper = (0, $1DXK0.xcss)({
    borderTop: `2px solid ${"var(--ds-border, #091E4224)"}`,
    backgroundColor: 'elevation.surface.overlay',
    borderBottomLeftRadius: 'border.radius.200',
    borderBottomRightRadius: 'border.radius.200',
    position: 'sticky',
    bottom: 'space.negative.100',
    marginBottom: 'space.negative.100',
    paddingTop: 'space.050'
});

});

parcelRegister("6rZHS", function(module, exports) {

$parcel$export(module.exports, "transformServerRestStatusToStatus", () => $5dae50f5253963ae$export$f8064e1f9ab3c1e0);

var $7keuM = parcelRequire("7keuM");
const $5dae50f5253963ae$export$f8064e1f9ab3c1e0 = (serverResStatus)=>{
    return {
        id: serverResStatus?.id ?? '',
        statusName: serverResStatus?.name ?? '',
        statusCategory: (0, $7keuM.statusCategoryForId)(serverResStatus?.statusCategory?.id)
    };
};

});

parcelRegister("5S4to", function(module, exports) {

$parcel$export(module.exports, "usePanelContext", () => $1a028287cf9587ef$export$2fe6b5e489926495);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
function $1a028287cf9587ef$export$2fe6b5e489926495({ Context: Context }, preloadedPanel) {
    const [panel, setPanel] = (0, $eJOHy.useState)(preloadedPanel);
    const Panel = (0, $eJOHy.useMemo)(()=>{
        const PanelComponent = ()=>panel ?? null;
        return PanelComponent;
    }, [
        panel
    ]);
    const handleSetPanel = (0, $eJOHy.useCallback)((panel)=>{
        setPanel(panel);
    }, []);
    const value = (0, $eJOHy.useMemo)(()=>({
            setPanel: handleSetPanel
        }), [
        handleSetPanel
    ]);
    const Provider = (0, $eJOHy.useMemo)(()=>({ children: children })=>{
            return /*#__PURE__*/ (0, $gt9Am.jsx)(Context.Provider, {
                value: value,
                children: children
            });
        }, [
        Context,
        value
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            Panel: Panel,
            Provider: Provider
        }), [
        Panel,
        Provider
    ]);
}

});

parcelRegister("6UBwj", function(module, exports) {

$parcel$export(module.exports, "TEST_ID_PREFIX", () => $517c92a4e3fff9f6$export$9cbc201c09a37b3f);
$parcel$export(module.exports, "StatusLozenge", () => $517c92a4e3fff9f6$export$f72db4ad1e9b3e6d);
$parcel$export(module.exports, "WrappedStatusLozenge", () => $517c92a4e3fff9f6$export$69ea4907eefa8e7b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/react-component-props

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $cdbP5 = parcelRequire("cdbP5");

var $abjs4 = parcelRequire("abjs4");

var $fL0In = parcelRequire("fL0In");

var $8nu6j = parcelRequire("8nu6j");
var $bQP4O = parcelRequire("bQP4O");
var $1DXK0 = parcelRequire("1DXK0");

var $2zOdI = parcelRequire("2zOdI");

var $f2JN3 = parcelRequire("f2JN3");

var $6XJko = parcelRequire("6XJko");

var $fWpUz = parcelRequire("fWpUz");

var $jAZ6b = parcelRequire("jAZ6b");
const $517c92a4e3fff9f6$export$9cbc201c09a37b3f = 'issue.fields.status.common.ui.status-lozenge.';
const $517c92a4e3fff9f6$var$CustomChevronDownGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        ...props,
        width: 12,
        height: 12,
        viewBox: "5 5 13 13"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M8.292 10.293a1.009 1.009 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $517c92a4e3fff9f6$var$StatusLozengeNew = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ status: { name: name, statusCategory: statusCategory }, isEditable: isEditable, hasHoverState: hasHoverState, shouldShowDropdownIndication: shouldShowDropdownIndication, isDisabled: isDisabled = false }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($517c92a4e3fff9f6$var$StatusContentWrapper, {
        "data-testid": `${$517c92a4e3fff9f6$export$9cbc201c09a37b3f}${statusCategory.id}`,
        ref: ref
    }, isEditable === true || shouldShowDropdownIndication === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fWpUz.Lozenge), {
        statusCategoryId: statusCategory.id,
        isDisabled: isDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($517c92a4e3fff9f6$var$StyledLozengeContentWrapper, null, name, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
        glyph: $517c92a4e3fff9f6$var$CustomChevronDownGlyph,
        label: ""
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fWpUz.Lozenge), {
        statusCategoryId: statusCategory.id,
        isDisabled: isDisabled
    }, name)), hasHoverState && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $517c92a4e3fff9f6$var$hoverOverlayStyles
    })));
const $517c92a4e3fff9f6$var$WrappedStatusLozengeNew = (props)=>{
    const { ariaLabel: ariaLabel, isEditable: isEditable, isOpen: isOpen, targetRef: targetRef, contentRef: contentRef, triggerProps: triggerProps = {}, ...others } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bQP4O.default), {
        xcss: $517c92a4e3fff9f6$var$pressableStyles,
        ref: targetRef,
        "aria-label": ariaLabel,
        "aria-expanded": isOpen,
        isDisabled: !isEditable,
        // the popup.
        // The logic here may look incorrect, but it turns out that when clicking this button the
        // `isOpen` toggle happens before the `onClick` handler that sends the press tracing.
        // We need to disable the `jira/ufo/valid-labels` lint rule
        // because for this particular interaction we only want to track
        // opening the status popup.
        interactionName: isOpen ? 'issue.fields.status.popup.open' : undefined,
        ...triggerProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($517c92a4e3fff9f6$var$StatusLozengeNew, {
        ...others,
        isEditable: isEditable,
        ref: contentRef
    }));
};
const $517c92a4e3fff9f6$var$EditableLozenge = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jAZ6b.LozengeOld), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($517c92a4e3fff9f6$var$StyledLozengeContentWrapper, null, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
        glyph: $517c92a4e3fff9f6$var$CustomChevronDownGlyph,
        label: ""
    })));
const $517c92a4e3fff9f6$var$StatusLozengeOld = ({ status: { name: name, statusCategory: statusCategory }, isEditable: isEditable, hasHoverState: hasHoverState, targetRef: targetRef, shouldShowDropdownIndication: shouldShowDropdownIndication, isDisabled: isDisabled = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($517c92a4e3fff9f6$var$StyledLozenge, {
        hasHoverState: hasHoverState,
        statusCategoryId: statusCategory.id,
        isDisabled: isDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($517c92a4e3fff9f6$var$StatusContentWrapper, {
        ref: targetRef,
        "data-testid": `${$517c92a4e3fff9f6$export$9cbc201c09a37b3f}${statusCategory.id}`
    }, isEditable === true || shouldShowDropdownIndication === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($517c92a4e3fff9f6$var$EditableLozenge, null, name) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jAZ6b.LozengeOld), null, name)));
const $517c92a4e3fff9f6$var$WrappedStatusLozengeOld = (props)=>{
    const { ariaLabel: ariaLabel, error: error, isEditable: isEditable, isOpen: isOpen, targetRef: targetRef, triggerProps: triggerProps = {}, ...other } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $abjs4.default), {
        ref: targetRef,
        appearance: "subtle",
        "aria-label": ariaLabel,
        "aria-expanded": isOpen,
        isDisabled: !isEditable,
        theme: (currentTheme, themeProps)=>{
            const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = currentTheme(themeProps);
            return {
                buttonStyles: {
                    ...buttonStyles,
                    backgroundColor: 'transparent',
                    margin: 0,
                    width: 'auto',
                    height: 'auto',
                    padding: 0,
                    border: `2px solid ${error ? "var(--ds-border-danger, #E2483D)" : 'transparent'}`,
                    borderRadius: '5px',
                    ...isEditable === true ? undefined : {
                        cursor: 'auto'
                    },
                    outline: 0,
                    boxShadow: `0 0 0 2px ${isOpen === true ? "var(--ds-border-focused, #388BFF)" : 'transparent'}`,
                    '& > span': {
                        margin: 0
                    },
                    '&:focus, &:focus-within': {
                        boxShadow: `0 0 0 2px ${"var(--ds-border-focused, #388BFF)"}`
                    }
                },
                spinnerStyles: spinnerStyles
            };
        },
        // the popup.
        // The logic here may look incorrect, but it turns out that when clicking this button the
        // `isOpen` toggle happens before the `onClick` handler that sends the press tracing.
        // We need to disable the `jira/ufo/valid-labels` lint rule
        // because for this particular interaction we only want to track
        // opening the status popup.
        // eslint-disable-next-line jira/ufo/valid-labels
        interactionName: isOpen ? 'issue.fields.status.popup.open' : undefined,
        ...triggerProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($517c92a4e3fff9f6$var$StatusLozengeOld, {
        ...other,
        isEditable: isEditable
    }));
};
const $517c92a4e3fff9f6$export$f72db4ad1e9b3e6d = (0, $f2JN3.componentWithCondition)((0, $6XJko.isVisualRefreshEnabled), $517c92a4e3fff9f6$var$StatusLozengeNew, $517c92a4e3fff9f6$var$StatusLozengeOld);
const $517c92a4e3fff9f6$export$69ea4907eefa8e7b = (0, $f2JN3.componentWithCondition)((0, $6XJko.isVisualRefreshEnabled), $517c92a4e3fff9f6$var$WrappedStatusLozengeNew, $517c92a4e3fff9f6$var$WrappedStatusLozengeOld); // TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $517c92a4e3fff9f6$var$StyledLozenge = /*#__PURE__*/ (0, $cdbP5.default).span.withConfig({
    componentId: "wv585u-0"
})`display:flex;align-items:center;> div{display:flex;line-height:initial;outline:0;> span{padding:${"var(--ds-space-025, 2px)"} 0;vertical-align:text-bottom;color:${(props)=>// eslint-disable-next-line no-nested-ternary
    props.isDisabled ? (0, $2zOdI.disabledColor).text : !(0, $6XJko.isVisualRefreshEnabled)() ? (0, $2zOdI.textColor)[(0, $2zOdI.statusCategoryToThemeMap)[props.statusCategoryId]] : (0, $2zOdI.textColorOld)[(0, $2zOdI.statusCategoryToThemeMap)[props.statusCategoryId]]};background-color:${(props)=>props.isDisabled ? (0, $2zOdI.disabledColor).bg : (0, $2zOdI.bgColor)[(0, $2zOdI.statusCategoryToThemeMap)[props.statusCategoryId]]};${(props)=>props.hasHoverState ? `&:hover {
                        color: ${props.isDisabled ? (0, $2zOdI.disabledColor).text : (0, $2zOdI.textHoverColor)[(0, $2zOdI.statusCategoryToThemeMap)[props.statusCategoryId]]};
                        background-color: ${props.isDisabled ? (0, $2zOdI.disabledColor).bg : (0, $2zOdI.bgHoverColor)[(0, $2zOdI.statusCategoryToThemeMap)[props.statusCategoryId]]};
                    }` : ''};${(props)=>props.isDisabled && (0, $cdbP5.css)({
        pointerEvents: 'none'
    })}}}`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $517c92a4e3fff9f6$var$StyledLozengeContentWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4cvr1h6o _1e0c1bgi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $517c92a4e3fff9f6$var$StatusContentWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $517c92a4e3fff9f6$var$pressableStyles = (0, $1DXK0.xcss)({
    border: 'none',
    padding: 'space.0',
    borderRadius: '3px',
    background: 'transparent',
    position: 'relative',
    maxWidth: '100%',
    marginLeft: 'space.025'
});
const $517c92a4e3fff9f6$var$hoverOverlayStyles = (0, $1DXK0.xcss)({
    position: 'absolute',
    inset: '0',
    borderRadius: '3px',
    marginRight: 'space.025',
    ':hover': {
        opacity: 0.3,
        backgroundColor: 'color.background.inverse.subtle'
    }
});

});
parcelRegister("2zOdI", function(module, exports) {

$parcel$export(module.exports, "statusCategoryToThemeMap", () => $576836415c331af3$export$d9e35f42afe1e488);
$parcel$export(module.exports, "bgColor", () => $576836415c331af3$export$7dcbec377a25efc6);
$parcel$export(module.exports, "textColor", () => $576836415c331af3$export$32f78bffcd82ff28);
$parcel$export(module.exports, "textColorOld", () => $576836415c331af3$export$26ac04004fa4ead4);
$parcel$export(module.exports, "bgHoverColor", () => $576836415c331af3$export$69fdf3ba928b4c77);
$parcel$export(module.exports, "textHoverColor", () => $576836415c331af3$export$99ec0cf2cf1b2082);
$parcel$export(module.exports, "disabledColor", () => $576836415c331af3$export$b70f10fc4a6ba453);
const $576836415c331af3$export$61137dce61763ec3 = 'default';
const $576836415c331af3$export$132676d06d92ad48 = 'success';
const $576836415c331af3$export$5c1f3b72419aa125 = 'inprogress';
const $576836415c331af3$export$d9e35f42afe1e488 = {
    '1': $576836415c331af3$export$61137dce61763ec3,
    '2': $576836415c331af3$export$61137dce61763ec3,
    '3': $576836415c331af3$export$132676d06d92ad48,
    '4': $576836415c331af3$export$5c1f3b72419aa125
};
const $576836415c331af3$export$7dcbec377a25efc6 = {
    [$576836415c331af3$export$61137dce61763ec3]: "var(--ds-background-neutral, #091E420F)",
    [$576836415c331af3$export$132676d06d92ad48]: "var(--ds-background-success, #DCFFF1)",
    [$576836415c331af3$export$5c1f3b72419aa125]: "var(--ds-background-information, #E9F2FF)"
};
const $576836415c331af3$export$32f78bffcd82ff28 = {
    [$576836415c331af3$export$61137dce61763ec3]: "var(--ds-text-subtle, #44546F)",
    [$576836415c331af3$export$132676d06d92ad48]: "var(--ds-text-success, #216E4E)",
    [$576836415c331af3$export$5c1f3b72419aa125]: "var(--ds-text-information, #0055CC)"
};
const $576836415c331af3$export$26ac04004fa4ead4 = {
    [$576836415c331af3$export$61137dce61763ec3]: "var(--ds-text, #172B4D)",
    [$576836415c331af3$export$132676d06d92ad48]: "var(--ds-text-success, #216E4E)",
    [$576836415c331af3$export$5c1f3b72419aa125]: "var(--ds-text-information, #0055CC)"
};
const $576836415c331af3$export$69fdf3ba928b4c77 = {
    [$576836415c331af3$export$61137dce61763ec3]: "var(--ds-background-neutral-hovered, #091E4224)",
    [$576836415c331af3$export$132676d06d92ad48]: "var(--ds-background-success-hovered, #BAF3DB)",
    [$576836415c331af3$export$5c1f3b72419aa125]: "var(--ds-background-information-hovered, #CCE0FF)"
};
const $576836415c331af3$export$99ec0cf2cf1b2082 = {
    [$576836415c331af3$export$61137dce61763ec3]: "var(--ds-text, #172B4D)",
    [$576836415c331af3$export$132676d06d92ad48]: "var(--ds-text-success, #216E4E)",
    [$576836415c331af3$export$5c1f3b72419aa125]: "var(--ds-text-information, #0055CC)"
};
const $576836415c331af3$export$b70f10fc4a6ba453 = {
    bg: "var(--ds-background-neutral, #091E420F)",
    text: "var(--ds-text-disabled, #091E424F)"
};

});

parcelRegister("fWpUz", function(module, exports) {

$parcel$export(module.exports, "Lozenge", () => $b5ac3d09b389e3b4$export$a31cbe1bf5463979);

var $eJOHy = parcelRequire("eJOHy");

var $jdqdp = parcelRequire("jdqdp");

var $2zOdI = parcelRequire("2zOdI");

const $b5ac3d09b389e3b4$export$a31cbe1bf5463979 = ({ children: children, statusCategoryId: statusCategoryId, isDisabled: isDisabled })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        appearance: (0, $2zOdI.statusCategoryToThemeMap)[statusCategoryId],
        isBold: true,
        ...isDisabled ? {
            style: {
                color: (0, $2zOdI.disabledColor).text,
                backgroundColor: (0, $2zOdI.disabledColor).bg
            }
        } : {}
    }, children);

});

parcelRegister("jAZ6b", function(module, exports) {

$parcel$export(module.exports, "LozengeOld", () => $6750667a552dd8b6$export$26089816624d22fc);
// TODO - delete this file when cleaning up visual-refresh

var $eJOHy = parcelRequire("eJOHy");
const $6750667a552dd8b6$var$containerStyles = {
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage -- The token value "4px" and fallback "3px" do not match and can't be replaced automatically.
    borderRadius: "var(--ds-border-radius, 3px)",
    boxSizing: 'border-box',
    display: 'inline-block',
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-bold, 700)",
    maxWidth: '100%',
    padding: 0,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    textTransform: 'uppercase',
    verticalAlign: 'top'
};
const $6750667a552dd8b6$var$contentStyles = {
    boxSizing: 'border-box',
    display: 'inline-block',
    maxWidth: 200,
    overflow: 'hidden',
    padding: `0 ${"var(--ds-space-050, 4px)"}`,
    textOverflow: 'ellipsis',
    verticalAlign: 'top',
    whiteSpace: 'nowrap',
    width: '100%'
};
const $6750667a552dd8b6$export$26089816624d22fc = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: $6750667a552dd8b6$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: $6750667a552dd8b6$var$contentStyles
    }, children));
$6750667a552dd8b6$export$26089816624d22fc.displayName = 'Lozenge';

});


parcelRegister("90zjX", function(module, exports) {

$parcel$export(module.exports, "isOnlyGlobalTransitions", () => $552161697b4d85d8$export$10992041bf7e444a);
$parcel$export(module.exports, "getFilteredOrderedTransitions", () => $552161697b4d85d8$export$707115549202b9e4);
$parcel$export(module.exports, "getLoopedTransitionsForStatus", () => $552161697b4d85d8$export$38146914a8d06579);
$parcel$export(module.exports, "transformOptions", () => $552161697b4d85d8$export$8f4ed8ef83bcbf04);
$parcel$export(module.exports, "getStatusShape", () => $552161697b4d85d8$export$e2dafe47b17b2cfc);

var $LFmXM = parcelRequire("LFmXM");

var $7keuM = parcelRequire("7keuM");
const $552161697b4d85d8$var$isGlobalSelfTransition = (transition, currentStatusId)=>transition.isGlobal && transition.to.id === currentStatusId;
const $552161697b4d85d8$var$isInitialSelfTransition = (transition, currentStatusId)=>transition.isInitial && transition.to.id === currentStatusId;
const $552161697b4d85d8$var$isLoopedTransitionToSelf = (transition, currentStatusId)=>transition.to.id === currentStatusId && transition.isLooped === true;
const $552161697b4d85d8$var$filterLoopedTransitionsToSelf = (0, $LFmXM.default)((transitions, currentStatusId)=>transitions.filter((transition)=>!$552161697b4d85d8$var$isLoopedTransitionToSelf(transition, currentStatusId) && !$552161697b4d85d8$var$isGlobalSelfTransition(transition, currentStatusId) && !$552161697b4d85d8$var$isInitialSelfTransition(transition, currentStatusId)));
const $552161697b4d85d8$export$10992041bf7e444a = (transitions)=>transitions.every((t)=>t.isGlobal);
const $552161697b4d85d8$export$707115549202b9e4 = (transitions, currentStatusId)=>$552161697b4d85d8$var$filterLoopedTransitionsToSelf(transitions || [], currentStatusId);
const $552161697b4d85d8$export$38146914a8d06579 = (0, $LFmXM.default)((transitions, currentStatusId)=>(transitions || []).filter((transition)=>$552161697b4d85d8$var$isLoopedTransitionToSelf(transition, currentStatusId)));
const $552161697b4d85d8$var$formatOptions = (options)=>options.map((t)=>({
            label: t.to.name,
            value: t.id,
            transition: t
        }));
const $552161697b4d85d8$var$memoizedTranformOptions = (0, $LFmXM.default)($552161697b4d85d8$var$formatOptions);
const $552161697b4d85d8$export$8f4ed8ef83bcbf04 = (options)=>$552161697b4d85d8$var$memoizedTranformOptions(options);
const $552161697b4d85d8$export$e2dafe47b17b2cfc = (id, name, category)=>{
    const statusCategoryId = (0, $7keuM.StatusCategoryIds)[category] || (0, $7keuM.StatusCategoryIds)[(0, $7keuM.StatusCategoryTypes).UNDEFINED];
    return {
        id: id,
        name: name,
        statusCategory: {
            id: statusCategoryId,
            name: name
        }
    };
};

});

parcelRegister("6ReHL", function(module, exports) {

$parcel$export(module.exports, "CommandPaletteStatusView", () => $682d49bec9a2c7ba$export$d907a4132fe8618c);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $12DRg = parcelRequire("12DRg");

var $ftN6c = parcelRequire("ftN6c");

var $3Y0kU = parcelRequire("3Y0kU");

var $jdqdp = parcelRequire("jdqdp");

var $1Zcfy = parcelRequire("1Zcfy");

var $30ysG = parcelRequire("30ysG");

var $khCvX = parcelRequire("khCvX");

var $itdlt = parcelRequire("itdlt");

var $9wM6G = parcelRequire("9wM6G");

var $fWwfy = parcelRequire("fWwfy");

var $efhOD = parcelRequire("efhOD");

var $hf4h9 = parcelRequire("hf4h9");

var $g51Bg = parcelRequire("g51Bg");

var $7jTnu = parcelRequire("7jTnu");

var $lRq8t = parcelRequire("lRq8t");

var $3bSs8 = parcelRequire("3bSs8");

var $d2AGn = parcelRequire("d2AGn");

var $bmoS1 = parcelRequire("bmoS1");

var $bOX3t = parcelRequire("bOX3t");

var $814y1 = parcelRequire("814y1");

var $gCeeo = parcelRequire("gCeeo");

var $8oKDI = parcelRequire("8oKDI");


var $dnUkW = parcelRequire("dnUkW");

var $jXut7 = parcelRequire("jXut7");

var $ku7AV = parcelRequire("ku7AV");
const $682d49bec9a2c7ba$export$d907a4132fe8618c = ({ onFetch: onFetch, wasFetchSuccessful: wasFetchSuccessful, currentStatus: currentStatus, transitions: transitions, renderTransition: renderTransition, onSuccess: onSuccess, onUpdateStatusMutation: onUpdateStatusMutation })=>{
    const issueKey = (0, $bmoS1.useIssueKey)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { getKeywords: getKeywords } = (0, $itdlt.useCommandKeywords)();
    const subscribeCommands = (0, $efhOD.useSubscribeCommands)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [{ expandedCommand: expandedCommand, isOpen: isOpen }, { setChildCommands: setChildCommands }] = (0, $g51Bg.useCommandPaletteExpandedCommand)();
    const renderHeader = (0, $eJOHy.useCallback)((base)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9wM6G.CommandFieldHeader), {
            ...base,
            issueKey: issueKey
        }), [
        issueKey
    ]);
    const issueAri = (0, $bOX3t.useIssueAri)();
    const { saveStatusField: saveStatusField } = (0, $jXut7.useSaveStatusField)(issueKey, issueAri, onUpdateStatusMutation);
    const expandedCommandId = expandedCommand?.id;
    const issueId = issueAri && (0, $8oKDI.isAri)(issueAri) && (0, $7jTnu.fg)('one_event_improvements_1') ? (0, $8oKDI.getAriConfig)(issueAri).resourceId : undefined;
    const loadTransitions = (0, $eJOHy.useCallback)(()=>{
        if (!wasFetchSuccessful) return {
            commands: []
        };
        const transitionCommands = transitions.map((transition)=>({
                id: `${0, $57e4b742849c62a3$export$5252a6a6e4e4a774}-${transition.id}`,
                name: transition.name,
                components: {
                    Name: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($682d49bec9a2c7ba$var$TransitionWrapper, null, renderTransition({
                            transition: transition
                        }, {
                            addTransitionArrowSpacing: true
                        })),
                    LeftIcon: !expandedCommandId ? ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3Y0kU))), {
                            spacing: "spacious",
                            label: ""
                        }) : undefined
                },
                keywords: (0, $ku7AV.getTransitionKeywords)(transition),
                primaryAction: {
                    type: (0, $hf4h9.CommandActionType).PERFORM,
                    perform: ()=>{
                        (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'issueStatus updated', {
                            oldValId: currentStatus.id,
                            oldStatusCategoryId: currentStatus.statusCategory.id,
                            newValId: transition.to.id,
                            newStatusCategoryId: transition.to.statusCategory.id,
                            hasScreen: transition.hasScreen,
                            isConditional: transition.isConditional
                        });
                        (0, $d2AGn.getUpdateAnalyticsFlowHelper)().fireAnalyticsEnd((0, $814y1.STATUS_TYPE), {
                            analytics: createAnalyticsEvent({}),
                            attributes: {
                                isCommandPaletteEditing: true,
                                fieldType: (0, $3bSs8.FIELD_TYPE_MAP)[0, $814y1.STATUS_TYPE],
                                oldValId: currentStatus.id,
                                oldStatusCategoryId: currentStatus.statusCategory.id,
                                newValId: transition.to.id,
                                newStatusCategoryId: transition.to.statusCategory.id,
                                ...(0, $7jTnu.fg)('one_event_improvements_1') && {
                                    issueId: issueId
                                }
                            }
                        });
                        saveStatusField(transition, ()=>{
                            onSuccess?.(transition.to, false, createAnalyticsEvent({}));
                        });
                    }
                },
                analytics: {
                    action: 'changeStatus',
                    actionCategory: (0, $1Zcfy.COMMAND_PALETTE_ISSUE_ACTIONS)
                }
            }));
        const currentCommand = expandedCommandId ? [
            {
                id: `${(0, $57e4b742849c62a3$export$5252a6a6e4e4a774)}-${currentStatus.id}-current`,
                name: currentStatus.name,
                components: {
                    LeftIcon: !expandedCommandId ? ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3Y0kU))), {
                            spacing: "spacious",
                            label: formatMessage((0, $dnUkW.messages).editStatus)
                        }) : undefined,
                    Name: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($682d49bec9a2c7ba$var$TransitionWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($682d49bec9a2c7ba$var$SelectedStatusContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
                            isBold: true
                        }, currentStatus.name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($682d49bec9a2c7ba$var$CurrentStatusContainer, null, formatMessage((0, $dnUkW.messages).current)))
                },
                primaryAction: {
                    type: (0, $hf4h9.CommandActionType).PERFORM,
                    perform: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
                }
            }
        ] : [];
        const commands = [
            ...currentCommand,
            ...transitionCommands
        ];
        return {
            commands: commands
        };
    }, [
        wasFetchSuccessful,
        transitions,
        expandedCommandId,
        currentStatus.id,
        currentStatus.name,
        currentStatus.statusCategory.id,
        renderTransition,
        createAnalyticsEvent,
        saveStatusField,
        issueId,
        onSuccess,
        formatMessage
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const { commands: commands } = loadTransitions();
        const statusCommand = {
            id: (0, $57e4b742849c62a3$export$5252a6a6e4e4a774),
            name: formatMessage((0, $dnUkW.messages).editStatus),
            shortcut: 'd',
            placeholder: formatMessage((0, $dnUkW.messages).searchTransition),
            keywords: getKeywords('changeStatusSynonyms'),
            section: (0, $khCvX.getCommandPaletteIssueActionsHeader)(issueKey),
            priority: (0, $30ysG.getCommandPaletteIssueActionsPriority)('STATUS'),
            components: {
                LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3Y0kU))), {
                        spacing: "spacious",
                        label: ""
                    })
            },
            primaryAction: {
                type: (0, $hf4h9.CommandActionType).COMMAND_LIST,
                fallback: {
                    onNoResults: {
                        label: formatMessage((0, $dnUkW.messages).fallbackNoResults)
                    }
                },
                components: {
                    Header: renderHeader
                },
                commands: commands,
                onClick: ()=>{
                    (0, $d2AGn.getUpdateAnalyticsFlowHelper)().fireAnalyticsStart((0, $814y1.STATUS_TYPE), {
                        analytics: createAnalyticsEvent({}),
                        attributes: {
                            fieldType: (0, $3bSs8.FIELD_TYPE_MAP)[0, $814y1.STATUS_TYPE],
                            isCommandPaletteEditing: true
                        }
                    });
                }
            },
            analytics: {
                action: 'changeStatusMenu'
            }
        };
        const unsubscribe = subscribeCommands((0, $fWwfy.COMMAND_PALETTE_REGISTRY_IDS).STATUS, [
            statusCommand
        ]);
        return ()=>unsubscribe();
    }, [
        formatMessage,
        getKeywords,
        issueKey,
        loadTransitions,
        renderHeader,
        subscribeCommands,
        expandedCommand?.id,
        createAnalyticsEvent
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (isOpen && onFetch) onFetch(createAnalyticsEvent({}));
    }, [
        isOpen,
        onFetch,
        createAnalyticsEvent
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (isOpen && expandedCommandId === (0, $57e4b742849c62a3$export$5252a6a6e4e4a774)) setChildCommands(loadTransitions());
    }, [
        expandedCommandId,
        isOpen,
        loadTransitions,
        setChildCommands
    ]);
    return null;
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $682d49bec9a2c7ba$var$TransitionWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bah1yb4 _18u01b66 _4t3i1tcg _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $682d49bec9a2c7ba$var$SelectedStatusContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $682d49bec9a2c7ba$var$CurrentStatusContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_syaz1gjq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3Y0kU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6235186728ffd6d81eb5818a45d0cd77>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2e373c7db9d1b7c4$var$_react = $2e373c7db9d1b7c4$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $2e373c7db9d1b7c4$var$_task = $2e373c7db9d1b7c4$var$_interopRequireDefault((parcelRequire("bwM92")));

var $2e373c7db9d1b7c4$var$_task2 = $2e373c7db9d1b7c4$var$_interopRequireDefault((parcelRequire("jgKZU")));
function $2e373c7db9d1b7c4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for TaskIcon.
 * This component is TaskIcon, with `UNSAFE_fallbackIcon` set to "TaskIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for tasks in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2e373c7db9d1b7c4$var$TaskIcon = (props)=>/*#__PURE__*/ $2e373c7db9d1b7c4$var$_react.default.createElement($2e373c7db9d1b7c4$var$_task.default, Object.assign({
        LEGACY_fallbackIcon: $2e373c7db9d1b7c4$var$_task2.default
    }, props));
$2e373c7db9d1b7c4$var$TaskIcon.Name = 'TaskIconMigration';
var $2e373c7db9d1b7c4$var$_default = module.exports.default = $2e373c7db9d1b7c4$var$TaskIcon;

});
parcelRegister("jgKZU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e073f7ae4e46a909$var$_react = $e073f7ae4e46a909$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $e073f7ae4e46a909$var$_task = $e073f7ae4e46a909$var$_interopRequireDefault((parcelRequire("bwM92")));
function $e073f7ae4e46a909$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e073f7ae4e46a909$var$TaskIcon = (props)=>/*#__PURE__*/ $e073f7ae4e46a909$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M3 3.993C3 3.445 3.445 3 3.993 3h16.014c.548 0 .993.445.993.993v16.014a.994.994 0 0 1-.993.993H3.993A.994.994 0 0 1 3 20.007zM5 5v14h14V5z"/><path fill-rule="nonzero" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props, {
        newIcon: $e073f7ae4e46a909$var$_task.default
    }));
$e073f7ae4e46a909$var$TaskIcon.displayName = 'TaskIcon';
var $e073f7ae4e46a909$var$_default = module.exports.default = $e073f7ae4e46a909$var$TaskIcon;

});


parcelRegister("30ysG", function(module, exports) {

$parcel$export(module.exports, "getCommandPaletteIssueActionsPriority", () => $bd309fb06918c099$export$5164bb42fa883371);
const $bd309fb06918c099$var$COMMAND_PALETTE_ISSUE_ACTIONS_PRIORITY = {
    STATUS: 10,
    SUMMARY: 20,
    PARENT: 30,
    LINK_ISSUE: 40,
    CONTENT_FIRST_TAB: 50,
    PINNED_FIELDS: 60,
    DETAILS: 70,
    CONTENT_OTHER_TABS: 80,
    MORE_FIELDS: 90,
    OLD_ISSUE_FIELDS: 95,
    ADD_COMMENT: 100,
    GQL_FIELDS: 105,
    SUB_HEADER_ITEMS: 110,
    ISSUE_HEADER_ITEMS: 120
};
const $bd309fb06918c099$export$5164bb42fa883371 = (key)=>$bd309fb06918c099$var$COMMAND_PALETTE_ISSUE_ACTIONS_PRIORITY[key];

});

parcelRegister("khCvX", function(module, exports) {

$parcel$export(module.exports, "getCommandPaletteIssueActionsHeader", () => $97b35cc81a92c1a8$export$cd9931655a8cfb04);

var $1Zcfy = parcelRequire("1Zcfy");
const $97b35cc81a92c1a8$export$cd9931655a8cfb04 = (issueKey)=>`${0, $1Zcfy.COMMAND_PALETTE_ISSUE_ACTIONS}-${issueKey || ''}`;

});

parcelRegister("9wM6G", function(module, exports) {

$parcel$export(module.exports, "CommandFieldHeader", () => $242246011ddb435e$export$c6444eb1c6f44b2d);

var $eJOHy = parcelRequire("eJOHy");

var $78OnL = parcelRequire("78OnL");

var $jmeeg = parcelRequire("jmeeg");

var $d9bSz = parcelRequire("d9bSz");
const $242246011ddb435e$export$c6444eb1c6f44b2d = ({ children: children, issueKey: issueKey })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jmeeg.components).Header, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d9bSz.IssueTag), {
        issueKey: issueKey
    }), children));

});
parcelRegister("jmeeg", function(module, exports) {

$parcel$export(module.exports, "components", () => $0452758bc49e816e$export$9b5ac10f59f76296);

var $eJOHy = parcelRequire("eJOHy");

var $dUOwK = parcelRequire("dUOwK");

var $2Nn1q = parcelRequire("2Nn1q");

var $lKFw0 = parcelRequire("lKFw0");

var $b4bRO = parcelRequire("b4bRO");
const $0452758bc49e816e$var$NameComponent = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
};
const $0452758bc49e816e$export$9b5ac10f59f76296 = {
    CommandRow: $2Nn1q.CommandRow,
    Name: $0452758bc49e816e$var$NameComponent,
    LeftIcon: (0, $eJOHy.Fragment),
    Wrapper: (0, $eJOHy.Fragment),
    Footer: $lKFw0.Footer,
    Body: (0, $dUOwK.CommandPaletteBody),
    Header: $b4bRO.Header
};

});
parcelRegister("dUOwK", function(module, exports) {

$parcel$export(module.exports, "NoResultsContainer", () => $3a17c57ac1b263a3$export$2ab569a6937cb4e4);
$parcel$export(module.exports, "CommandPaletteBody", () => $3a17c57ac1b263a3$export$b1023de69a8756e6);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $ftN6c = parcelRequire("ftN6c");

var $g51Bg = parcelRequire("g51Bg");

var $2OtIa = parcelRequire("2OtIa");

var $5Ywg0 = parcelRequire("5Ywg0");

var $g8Pqh = parcelRequire("g8Pqh");

var $iG2Hi = parcelRequire("iG2Hi");

var $aNkQT = parcelRequire("aNkQT");

var $OZurT = parcelRequire("OZurT");

var $6b4EO = parcelRequire("6b4EO");

var $5IbG4 = parcelRequire("5IbG4");
const $3a17c57ac1b263a3$var$CommandPaletteChildren = ({ results: results, noResultsFallback: noResultsFallback, renderAfterCommands: renderAfterCommands, resultsRefs: resultsRefs })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [{ isSearchFieldFocused: isSearchFieldFocused, loadingList: loadingList, registry: registry, activeRegistry: activeRegistry }, { setActiveIndex: setActiveIndex, removeCommandsById: removeCommandsById, executeCommand: executeCommand }] = (0, $g51Bg.useCommandPalette)();
    const onHoverCommand = (index)=>{
        if (index === undefined) return;
        setActiveIndex(index);
    };
    const onMouseDownCommand = (0, $eJOHy.useCallback)((event)=>{
        event.preventDefault();
    }, []);
    const onClickCommand = (0, $eJOHy.useCallback)((event, result)=>{
        executeCommand(result.command, {
            method: 'mouse',
            createAnalyticsEvent: createAnalyticsEvent,
            attributes: {
                ...(0, $2OtIa.getAnalyticsAttributesFromResult)(result),
                ...(0, $2OtIa.getRegistryData)(registry, activeRegistry, result?.command.id)
            }
        }, (0, $2OtIa.isSecondaryTrigger)(event));
    }, [
        activeRegistry,
        createAnalyticsEvent,
        executeCommand,
        registry
    ]);
    const localResultRefs = resultsRefs.current;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, !loadingList && noResultsFallback && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3a17c57ac1b263a3$export$2ab569a6937cb4e4, {
        "data-testid": (0, $6b4EO.NO_RESULTS_TEST_ID)
    }, noResultsFallback), results.map((result, index)=>{
        if (result.isGroup) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5Ywg0.CommandPaletteSearchResultGroupItem), {
            ref: (commandRef)=>{
                if (commandRef) // eslint-disable-next-line react-hooks/react-compiler
                localResultRefs[index] = commandRef;
            },
            group: result.group,
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3a17c57ac1b263a3$var$GroupContainerComponent, {
            as: "h2",
            "data-testid": (0, $6b4EO.GROUP_TEST_ID),
            isFirstResult: index === 0
        }, result.renderGroup ? result.renderGroup() : result.group));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aNkQT.CommandRowErrorBoundary), {
            key: index,
            teamName: typeof registry?.teamName === 'string' ? registry.teamName : 'deliveroo',
            onError: ()=>removeCommandsById([
                    result.command.id
                ]),
            attributes: (0, $2OtIa.getRegistryData)(registry, activeRegistry, result?.command.id)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $g8Pqh.CommandPaletteSearchResultListItem), {
            ref: (commandRef)=>{
                if (commandRef) localResultRefs[index] = commandRef;
            },
            id: result.command.id,
            active: result.active,
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $OZurT.CommandRow), {
            index: index,
            isSearchFieldFocused: isSearchFieldFocused,
            result: result,
            onHoverCommand: (ev)=>{
                // Safari is weird and likes to fire mouseover events when the mouse is not moving
                if (ev.movementX === 0 && ev.movementY === 0) return;
                onHoverCommand(result.index);
            },
            onClickCommand: (event)=>onClickCommand(event, result),
            onMouseDownCommand: onMouseDownCommand
        })));
    }), renderAfterCommands?.({}));
};
const $3a17c57ac1b263a3$export$b1023de69a8756e6 = ({ results: results, total: total, fallback: fallback, renderAfterCommands: renderAfterCommands })=>{
    const [{ activeIndex: activeIndex, isSearchFieldFocused: isSearchFieldFocused, expandedCommand: expandedCommand, search: search }, { setActiveIndex: setActiveIndex }] = (0, $g51Bg.useCommandPalette)();
    const [prevActiveIndex, setPrevActiveIndex] = (0, $eJOHy.useState)(activeIndex);
    const resultsRefs = (0, $eJOHy.useRef)([]);
    const modalBodyRef = (0, $eJOHy.useRef)(null);
    const onArrowScroll = (0, $eJOHy.useCallback)((newActiveIndex)=>{
        setActiveIndex(newActiveIndex);
    }, [
        setActiveIndex
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!modalBodyRef.current || prevActiveIndex === activeIndex) return;
        setPrevActiveIndex(activeIndex);
        const scrollTo = activeIndex > prevActiveIndex ? (0, $6b4EO.SCROLL_DIRECTION).END : (0, $6b4EO.SCROLL_DIRECTION).START;
        const scrollToIndex = (0, $5IbG4.getScrollToIndex)(results, activeIndex, scrollTo);
        const scrolledToResult = resultsRefs.current[scrollToIndex];
        if (scrolledToResult && !(0, $5IbG4.isElementVisibleInContainer)(scrolledToResult, modalBodyRef.current)) {
            const lastIndex = results.length - 1;
            const firstIndex = results.findIndex((result)=>!result.isGroup);
            if (lastIndex === scrollToIndex) modalBodyRef.current.scrollTo(0, modalBodyRef.current.scrollHeight);
            else if (firstIndex === scrollToIndex) modalBodyRef.current.scrollTo(0, 0);
            else (0, $5IbG4.scrollResultIntoView)({
                target: scrolledToResult,
                direction: scrollTo,
                scrollContainer: modalBodyRef.current
            });
        }
    }, [
        activeIndex,
        prevActiveIndex,
        results
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!modalBodyRef.current?.scrollTo) return;
        modalBodyRef.current.scrollTo(0, 0);
    }, [
        expandedCommand,
        search
    ]);
    (0, $eJOHy.useEffect)(()=>{
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        if (!isSearchFieldFocused) return ()=>{};
        const handleArrowScroll = (ev)=>{
            if (ev.key === 'ArrowUp') {
                ev.preventDefault();
                activeIndex > 0 && onArrowScroll(activeIndex - 1);
            }
            if (ev.key === 'ArrowDown') {
                ev.preventDefault();
                activeIndex < total - 1 && onArrowScroll(activeIndex + 1);
            }
        };
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('keydown', handleArrowScroll);
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.removeEventListener('keydown', handleArrowScroll);
        };
    }, [
        isSearchFieldFocused,
        total,
        activeIndex,
        setActiveIndex,
        onArrowScroll
    ]);
    const noResultsFallback = (0, $eJOHy.useMemo)(()=>fallback?.onNoResults?.renderLabel?.() || fallback?.onNoResults?.label, [
        fallback
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iG2Hi.CommandPaletteSearchResultListWrapper), {
        ref: modalBodyRef,
        noResultsFallback: noResultsFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3a17c57ac1b263a3$var$CommandPaletteChildren, {
        results: results,
        noResultsFallback: noResultsFallback,
        renderAfterCommands: renderAfterCommands,
        resultsRefs: resultsRefs
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3a17c57ac1b263a3$var$GroupContainerComponent = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFirstResult: isFirstResult, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_h2xaw7": (0, $awdRS.default)(`${__cmplp.isFirstResult ? "var(--ds-space-100, 8px)" : "var(--ds-space-150, 12px)"} ${"var(--ds-space-300, 24px)"} 0 ${"var(--ds-space-300, 24px)"}`)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c82smr _1yt41f6d _syaz131l",
            __cmplp.className
        ])
    });
});
const $3a17c57ac1b263a3$export$2ab569a6937cb4e4 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_y3gn1h6o _syaz131l _ca0qxy5q _u5f3pxbi _n3tdxy5q _19bvpxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5Ywg0", function(module, exports) {

$parcel$export(module.exports, "CommandPaletteSearchResultGroupItem", () => $2dc004120872e887$export$591c26128e5fd757);

var $eJOHy = parcelRequire("eJOHy");

const $2dc004120872e887$export$591c26128e5fd757 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ group: group, ...rest }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        ref: ref,
        "data-testid": (0, $19c39496d342d719$export$617744f059bfc3ba),
        id: group ? `${0, $19c39496d342d719$export$9ed1834ff36a8f29}-${group}` : undefined,
        ...rest
    }));

});
const $19c39496d342d719$export$9ffb4923f81813d9 = 'compal-menu';
const $19c39496d342d719$export$b28d6b416aaf953a = `${$19c39496d342d719$export$9ffb4923f81813d9}-item`;
const $19c39496d342d719$export$9ed1834ff36a8f29 = `${$19c39496d342d719$export$9ffb4923f81813d9}-group`;
const $19c39496d342d719$export$85eefac753ab5bdb = 'command-palette.ui.modal.body.command-body-container';
const $19c39496d342d719$export$617744f059bfc3ba = 'command-palette.ui.modal.body.command-container-row';
const $19c39496d342d719$export$d3cd230e107fbce = 'command-palette.ui.modal.header.search-input';
const $19c39496d342d719$export$9e40a0642460a944 = 'compal-menu-screen-reader';


parcelRegister("g8Pqh", function(module, exports) {

$parcel$export(module.exports, "CommandPaletteSearchResultListItem", () => $1fa300fadfc2263f$export$1f8fa9d1eef77b32);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");


var $bZFaG = parcelRequire("bZFaG");
const $1fa300fadfc2263f$export$1f8fa9d1eef77b32 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ id: id, active: active, ...rest }, ref)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        ref: ref,
        "data-testid": (0, $19c39496d342d719$export$617744f059bfc3ba),
        "aria-current": active,
        role: "menuitem",
        id: `${(0, $19c39496d342d719$export$b28d6b416aaf953a)}-${id}`,
        "aria-label": formatMessage((0, $bZFaG.messages).resultListItemAriaLabel),
        ...rest
    });
});

});
parcelRegister("bZFaG", function(module, exports) {

$parcel$export(module.exports, "messages", () => $1a66dcc5b190c609$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $1a66dcc5b190c609$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    resultListItemAriaLabel: {
        "id": "command-palette.common.command-palette-search-result-list-item",
        "defaultMessage": "Command palette action item"
    }
});

});


parcelRegister("iG2Hi", function(module, exports) {

$parcel$export(module.exports, "CommandPaletteSearchResultListWrapper", () => $6725cef9016fe1d5$export$95554f6fb39a83c2);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $lmgo6 = parcelRequire("lmgo6");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");


var $1XCAD = parcelRequire("1XCAD");

var $2pUb3 = parcelRequire("2pUb3");
const $6725cef9016fe1d5$export$95554f6fb39a83c2 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ noResultsFallback: noResultsFallback, children: children, ...props }, ref)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const resizerRef = (0, $eJOHy.useRef)(null);
    const height = (0, $2pUb3.useSmoothExpand)(resizerRef);
    (0, $eJOHy.useEffect)(()=>{
        if (ref && 'current' in ref && ref.current) {
            const currentRef = ref.current;
            currentRef.style.height = `${height}px`;
        }
    }, [
        height,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $6725cef9016fe1d5$var$wrapperStyles,
        testId: (0, $19c39496d342d719$export$85eefac753ab5bdb),
        id: (0, $19c39496d342d719$export$9ffb4923f81813d9),
        role: noResultsFallback ? 'group' : 'menu',
        ref: ref,
        "aria-label": formatMessage((0, $1XCAD.messages).commandPaletteSearchResultListBoxLabel),
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        ref: resizerRef,
        direction: "column",
        gap: "space.050"
    }, children));
});
const $6725cef9016fe1d5$var$wrapperStyles = (0, $1DXK0.xcss)({
    padding: '0',
    paddingTop: 'space.100',
    paddingBottom: 'space.100',
    transition: 'height 0.15s ease-out',
    overflowY: 'auto',
    maxHeight: '376px'
});

});
parcelRegister("1XCAD", function(module, exports) {

$parcel$export(module.exports, "messages", () => $5f9181ddee7f41b1$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $5f9181ddee7f41b1$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    commandPaletteSearchResultListBoxLabel: {
        "id": "command-palette.common.command-palette-search-dropdown.command-palette-search-result-list-wrapper.command-palette-search-result-list-box-label",
        "defaultMessage": "List of commands"
    }
});

});

parcelRegister("2pUb3", function(module, exports) {

$parcel$export(module.exports, "useSmoothExpand", () => $535f9e4bd6cd6e9a$export$674ba8b02d2bfe86);

var $eJOHy = parcelRequire("eJOHy");
const $535f9e4bd6cd6e9a$var$MAX_HEIGHT = 376;
const $535f9e4bd6cd6e9a$var$STARTING_HEIGHT = 56;
const $535f9e4bd6cd6e9a$var$ADDITIONAL_HEIGHT = 16;
const $535f9e4bd6cd6e9a$export$674ba8b02d2bfe86 = (content)=>{
    const [height, setHeight] = (0, $eJOHy.useState)($535f9e4bd6cd6e9a$var$STARTING_HEIGHT);
    const callback = (0, $eJOHy.useCallback)(()=>{
        const contentClientHeight = content.current?.clientHeight;
        if (!contentClientHeight) return;
        if (contentClientHeight > $535f9e4bd6cd6e9a$var$MAX_HEIGHT) setHeight($535f9e4bd6cd6e9a$var$MAX_HEIGHT);
        else setHeight(contentClientHeight + $535f9e4bd6cd6e9a$var$ADDITIONAL_HEIGHT);
    }, [
        content
    ]);
    (0, $eJOHy.useEffect)(()=>{
        let resizeObserver;
        if (content.current && typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(callback);
            resizeObserver.observe(content.current);
        }
        return ()=>{
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        callback,
        content
    ]);
    return height;
};

});


parcelRegister("aNkQT", function(module, exports) {

$parcel$export(module.exports, "CommandRowErrorBoundary", () => $396c9e18c0709720$export$223f3c3c93a14a83);

var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");
const $396c9e18c0709720$export$223f3c3c93a14a83 = ({ children: children, teamName: teamName, onError: onError, attributes: attributes })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "command-palette-row",
        packageName: "jiraCommandPalette",
        fallback: "unmount",
        teamName: teamName,
        onError: onError,
        attributes: attributes
    }, children);

});

parcelRegister("OZurT", function(module, exports) {

$parcel$export(module.exports, "CommandRow", () => $7150d313297e5fc3$export$3ef5d254c3c573e3);

var $eJOHy = parcelRequire("eJOHy");

var $2OtIa = parcelRequire("2OtIa");

var $2Nn1q = parcelRequire("2Nn1q");
const $7150d313297e5fc3$export$3ef5d254c3c573e3 = ({ index: index, result: result, isSearchFieldFocused: isSearchFieldFocused, onHoverCommand: onHoverCommand, onClickCommand: onClickCommand, onMouseDownCommand: onMouseDownCommand })=>{
    const { command: command } = result;
    const isActive = !!(result.active && isSearchFieldFocused);
    const isFirstCommand = result.index === 0;
    const rowProps = {
        index: index,
        isActive: isActive,
        command: command,
        isFirstCommand: isFirstCommand,
        onMouseMove: onHoverCommand,
        onClick: onClickCommand,
        onMouseDown: onMouseDownCommand,
        analyticsAttributes: (0, $2OtIa.getAnalyticsAttributesFromResult)(result)
    };
    if (command.components?.CommandRow) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(command.components.CommandRow, rowProps);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2Nn1q.CommandRow), rowProps);
};

});
parcelRegister("2Nn1q", function(module, exports) {

$parcel$export(module.exports, "CommandRow", () => $23485c420ee6846d$export$3ef5d254c3c573e3);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $lmgo6 = parcelRequire("lmgo6");
var $1DXK0 = parcelRequire("1DXK0");

var $6XJko = parcelRequire("6XJko");

var $1k1Uh = parcelRequire("1k1Uh");


var $cSwEo = parcelRequire("cSwEo");

var $gXsfJ = parcelRequire("gXsfJ");
const $23485c420ee6846d$export$3ef5d254c3c573e3 = ({ index: index, command: command, isActive: isActive, isFirstCommand: isFirstCommand, analyticsAttributes: analyticsAttributes, ...rest })=>{
    const InnerContainer = $23485c420ee6846d$var$CommandContainerInner;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($23485c420ee6846d$var$CommandContainerWrapper, {
        "data-testid": command.id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($23485c420ee6846d$var$CommandContainer, {
        index: index,
        active: isActive,
        "data-active": isActive,
        "data-testid": (0, $f844ecf9ba7020db$export$b0017db5728101cc)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(InnerContainer, {
        "data-testid": (0, $f844ecf9ba7020db$export$47c379a40b00a339),
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($23485c420ee6846d$var$CommandLeftIconAndNameContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($23485c420ee6846d$var$CommandIconsContainer, {
        "data-testid": (0, $f844ecf9ba7020db$export$d6dd1cf63aae711c)
    }, command.components?.LeftIcon && ((0, $6XJko.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        testId: (0, $f844ecf9ba7020db$export$7b41978523c7dd4a),
        alignItems: "center",
        justifyContent: "center",
        xcss: [
            $23485c420ee6846d$var$iconStyles,
            isActive && $23485c420ee6846d$var$iconActiveStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(command.components.LeftIcon, null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($23485c420ee6846d$var$CommandLeftIconContainer, {
        "data-testid": (0, $f844ecf9ba7020db$export$7b41978523c7dd4a),
        active: isActive
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(command.components.LeftIcon, null))), command.mode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1k1Uh.OutlinedLozenge), {
        "data-testid": (0, $f844ecf9ba7020db$export$72c5368f559dd523)
    }, command.mode)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cSwEo.RenderCommandName), {
        command: command,
        isActive: isActive
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gXsfJ.RightContent), {
        command: command,
        isFirstCommand: isFirstCommand,
        isActive: isActive
    }))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $23485c420ee6846d$var$CommandContainerWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsb1osq",
            __cmplp.className
        ])
    });
});
const $23485c420ee6846d$var$CommandContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { active: active, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c82smr _syaz1gjq _ca0q1b66 _u5f3idpf _n3td1b66 _19bvidpf",
            !!__cmplp.active && "_syaz1fxt _bfhkfg4m _kqswh2mm _1kt9b3bt _1cs8stnw _1aukidpf _qnecidpf _19woidpf _1mp4v77o _1rus1p6i",
            __cmplp.className
        ])
    });
});
const $23485c420ee6846d$var$CommandContainerInner = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0q1b66 _u5f3v47k _n3td1b66 _19bvv47k _1e0c1txw _4cvr1h6o _80omtlke _lcxv1wug",
            __cmplp.className
        ])
    });
});
const $23485c420ee6846d$var$CommandIconsContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_zulp1b66 _2hwx1b66 _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $23485c420ee6846d$var$iconStyles = (0, $1DXK0.xcss)({
    width: '24px',
    height: '24px',
    // @ts-expect-error ts(2322) - this color should be set directly within icon after migration, but requires bigger change in types.
    color: 'color.icon.subtle'
});
const $23485c420ee6846d$var$iconActiveStyles = (0, $1DXK0.xcss)({
    // @ts-expect-error ts(2322) - this color should be set directly within icon after migration.
    color: 'color.icon'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $23485c420ee6846d$var$CommandLeftIconContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { active: active, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _1bsb1tcg _4t3i1tcg _vwz41tcg _1bah1h6o _1wpz1y6m _1f027vkz _nbgx7vkz",
            __cmplp.active ? "_syazwdcn" : "_syaz1oju",
            __cmplp.className
        ])
    });
});
const $23485c420ee6846d$var$CommandLeftIconAndNameContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _1e0c1txw _2lx2vrvc _vwz41tcg",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1k1Uh", function(module, exports) {

$parcel$export(module.exports, "OutlinedLozenge", () => $34fe5e771f897e84$export$224f9ad7f31e0de6);
$parcel$export(module.exports, "FilledLozenge", () => $34fe5e771f897e84$export$586a428fe10f5ae0);
$parcel$export(module.exports, "SearchLozenge", () => $34fe5e771f897e84$export$2ccc7861eeb7b337);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $34fe5e771f897e84$var$Lozenge = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko1l7b _11c8dcr7 _1e0c1txw _4cvr1h6o _1bah1h6o _1o9zidpf _4t3igktf _1bsbgktf _vwz41crf _syaz1gjq",
            __cmplp.className
        ])
    });
});
const $34fe5e771f897e84$export$224f9ad7f31e0de6 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $34fe5e771f897e84$var$Lozenge, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c81u0j _19it3ju0 _k48p1pd9 _1p1dangw _bfhk1j9a _syaz131l _vchhusvi",
            __cmplp.className
        ])
    });
});
const $34fe5e771f897e84$export$586a428fe10f5ae0 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $34fe5e771f897e84$var$Lozenge, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c81u0j _kqswh2mm _1p1dangw _1pbykb7n _1s6krwve _rfx31l7b _1cs8stnw _1kt9b3bt _154psxj9 _1aukidpf _19woidpf _oounidpf _qnecidpf _1g0v1mrw",
            __cmplp.className
        ])
    });
});
const $34fe5e771f897e84$export$2ccc7861eeb7b337 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $34fe5e771f897e84$var$Lozenge, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c82smr _ca0qidpf _u5f31b66 _n3tdidpf _19bv1b66 _1bsb1ris _bfhkm7j4",
            __cmplp.className
        ])
    });
});

});

const $f844ecf9ba7020db$export$b0017db5728101cc = 'command-palette.ui.modal.body.command-container';
const $f844ecf9ba7020db$export$47c379a40b00a339 = 'command-palette.common.ui.command-palette-row-view.inner-container';
const $f844ecf9ba7020db$export$7b41978523c7dd4a = 'command-palette.ui.modal.body.command-left-icon-container';
const $f844ecf9ba7020db$export$72c5368f559dd523 = 'command-palette.ui.modal.body.command-mode';
const $f844ecf9ba7020db$export$d6dd1cf63aae711c = 'command-palette.ui.modal.body.command-icon-container';

parcelRegister("cSwEo", function(module, exports) {

$parcel$export(module.exports, "RenderCommandName", () => $d68023b12b2300be$export$931d3f1d35f6c058);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $dB1eP = parcelRequire("dB1eP");

var $lmgo6 = parcelRequire("lmgo6");
var $1DXK0 = parcelRequire("1DXK0");

var $6XJko = parcelRequire("6XJko");

var $eZyz9 = parcelRequire("eZyz9");

const $d68023b12b2300be$export$931d3f1d35f6c058 = ({ command: command, isActive: isActive })=>{
    const renderCommandName = (0, $eJOHy.useCallback)(()=>{
        if (command.components?.Name) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(command.components.Name, {
            isActive: isActive
        }, command.name);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eZyz9.TruncateWithTooltipOnActive), {
            isActive: isActive
        }, command.name);
    }, [
        command,
        isActive
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d68023b12b2300be$var$CommandNameContainer, {
        "data-testid": (0, $726ded7d34812919$export$1858c2a91b8b53ba),
        active: isActive
    }, command.breadcrumb?.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d68023b12b2300be$var$CommandBreadcrumbContainer, {
        "data-testid": (0, $726ded7d34812919$export$5e3a644e2bbe06f3)
    }, command.breadcrumb.map((BreadCrumb, index, arr)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d68023b12b2300be$var$CommandBreadcrumbItem, {
            isParent: index !== arr.length - 1,
            "data-testid": (0, $726ded7d34812919$export$fb5462105b23e3e5),
            active: isActive
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(BreadCrumb, {
            isActive: isActive
        })), index !== arr.length - 1 && ((0, $6XJko.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
            justifyContent: "center",
            xcss: $d68023b12b2300be$var$iconWrapperStyles,
            alignItems: "center",
            testId: (0, $726ded7d34812919$export$4675b4d60d9881d4)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dB1eP))), {
            color: "currentColor",
            label: "separator",
            size: "small"
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d68023b12b2300be$var$CommandChevronContainer, {
            "data-testid": (0, $726ded7d34812919$export$4675b4d60d9881d4)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dB1eP))), {
            color: "currentColor",
            label: "separator",
            size: "small"
        })))))) : renderCommandName());
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d68023b12b2300be$var$CommandNameContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { active: active, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1ul9idpf",
            __cmplp.active ? "_syaz1fxt" : "_syaz1gjq",
            __cmplp.className
        ])
    });
});
const $d68023b12b2300be$var$CommandBreadcrumbContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});
const $d68023b12b2300be$var$CommandBreadcrumbItem = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isParent: isParent, active: active, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_dm2rwo": (0, $awdRS.default)(__cmplp.active ? "var(--ds-text-subtle, #44546F)" : "var(--ds-text-subtlest, #626F86)")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "",
            !!__cmplp.isParent && "_syazalb7",
            __cmplp.className
        ])
    });
});
const $d68023b12b2300be$var$CommandChevronContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_vwz4kb7n _syaz1oju",
            __cmplp.className
        ])
    });
});
const $d68023b12b2300be$var$iconWrapperStyles = (0, $1DXK0.xcss)({
    height: '24px',
    width: '24px'
});

});
parcelRegister("eZyz9", function(module, exports) {

$parcel$export(module.exports, "TruncateWithTooltipOnActive", () => $0485cf2ed2b26536$export$4495aca3d261add0);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $IW7jS = parcelRequire("IW7jS");

var $cNe2t = parcelRequire("cNe2t");

var $i92Id = parcelRequire("i92Id");


var $fu9LY = parcelRequire("fu9LY");
const $0485cf2ed2b26536$var$TooltipRenderer = ({ children: children, shouldShowTooltip: shouldShowTooltip })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cNe2t.JiraPopup), {
        isOpen: !!shouldShowTooltip,
        autoFocus: false,
        placement: "bottom-end",
        messageId: "command-palette.common.ui.truncate-with-tooltip.truncate-with-tooltip-on-active.popup",
        messageType: "transactional",
        popupComponent: (0, $i92Id.PopupComponent),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i92Id.TooltipContent), {
                "data-testid": "command-palette.common.ui.truncate-with-tooltip.truncate-with-tooltip-on-active.tooltip-content"
            }, children),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i92Id.TriggerComponent), {
                "data-testid": "command-palette.common.ui.truncate-with-tooltip.truncate-with-tooltip-on-active.trigger-component",
                ...triggerProps
            }),
        zIndex: (0, $IW7jS.layers).tooltip()
    });
const $0485cf2ed2b26536$export$70f47de153e915ed = ()=>(0, $eJOHy.useRef)(null);
const $0485cf2ed2b26536$export$4495aca3d261add0 = ({ children: children, isActive: isActive, customTooltip: customTooltip, showTooltip: showTooltip, preventTruncate: preventTruncate })=>{
    const containerRef = $0485cf2ed2b26536$export$70f47de153e915ed();
    const { shouldShowTruncatedTooltip: shouldShowTruncatedTooltip } = (0, $fu9LY.useTruncatedTooltip)({
        containerRef: containerRef,
        tooltipDelay: (0, $4c1f11f798b8ffde$export$f9e3e7ede9ba929d)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        ref: containerRef,
        xcss: [
            $0485cf2ed2b26536$var$tooltipContainerStyles,
            !preventTruncate && $0485cf2ed2b26536$var$truncateTooltipStyles
        ]
    }, children), isActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0485cf2ed2b26536$var$TooltipRenderer, {
        shouldShowTooltip: showTooltip || shouldShowTruncatedTooltip
    }, showTooltip && customTooltip ? customTooltip : children));
};
const $0485cf2ed2b26536$var$tooltipContainerStyles = (0, $1DXK0.xcss)({
    position: 'relative',
    flexGrow: 1,
    textTransform: 'none'
});
const $0485cf2ed2b26536$var$truncateTooltipStyles = (0, $1DXK0.xcss)({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});

});
parcelRegister("i92Id", function(module, exports) {

$parcel$export(module.exports, "TooltipComponent", () => $849f6edf3f22b0d2$export$e18e2f8e82cdc428);
$parcel$export(module.exports, "TriggerComponent", () => $849f6edf3f22b0d2$export$534fc570264a52a4);
$parcel$export(module.exports, "TooltipTrigger", () => $849f6edf3f22b0d2$export$8c610744efcf8a1d);
$parcel$export(module.exports, "PopupComponent", () => $849f6edf3f22b0d2$export$9fac2d040f3ed438);
$parcel$export(module.exports, "TruncateWithTooltipContainer", () => $849f6edf3f22b0d2$export$8cae238d61c8405a);
$parcel$export(module.exports, "TooltipContent", () => $849f6edf3f22b0d2$export$e9003e2be37ec060);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $7AseU = parcelRequire("7AseU");

var $lRq8t = parcelRequire("lRq8t");

var $ccaPK = parcelRequire("ccaPK");
const $849f6edf3f22b0d2$export$e18e2f8e82cdc428 = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($849f6edf3f22b0d2$var$StyledTooltipPrimitive, {
        ...props,
        ref: ref
    }));
const $849f6edf3f22b0d2$export$534fc570264a52a4 = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($849f6edf3f22b0d2$export$8c610744efcf8a1d, {
        ...props,
        role: "button",
        ref: ref,
        "aria-label": formatMessage((0, $ccaPK.messages).tooltipTriggerAriaLabel)
    });
});
const $849f6edf3f22b0d2$export$9fac2d040f3ed438 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($849f6edf3f22b0d2$var$StyledPopupPrimitive, {
        ...props,
        ref: ref
    }, children)); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $849f6edf3f22b0d2$var$StyledTooltipPrimitive = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $7AseU.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1pbydx66 _1bsbp3fh _ca0qv77o _u5f312x7 _n3tdv77o _19bv12x7 _bfhk1j9a _16qs1cd0",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $849f6edf3f22b0d2$var$StyledPopupPrimitive = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1pbydx66 _1bsbp3fh _ca0qv77o _u5f312x7 _n3tdv77o _19bv12x7 _bfhk1j9a _16qs1cd0",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $849f6edf3f22b0d2$export$8cae238d61c8405a = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _kqswh2mm _o5721q9c _1bto1l2s _1p1dglyw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $849f6edf3f22b0d2$export$e9003e2be37ec060 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c8dcr7 _syaz1fxt",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $849f6edf3f22b0d2$export$8c610744efcf8a1d = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ccaPK", function(module, exports) {

$parcel$export(module.exports, "messages", () => $c726bd5d325f45ec$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $c726bd5d325f45ec$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    tooltipTriggerAriaLabel: {
        "id": "command-palette.common.truncate-with-tooltip.components.tooltip-trigger-aria-label",
        "defaultMessage": "Command palette tool tip"
    }
});

});


const $4c1f11f798b8ffde$export$f9e3e7ede9ba929d = 400;

parcelRegister("fu9LY", function(module, exports) {

$parcel$export(module.exports, "useTruncatedTooltip", () => $696d52b07491914e$export$94b118b3187f12c);

var $eJOHy = parcelRequire("eJOHy");

var $2OtIa = parcelRequire("2OtIa");
const $696d52b07491914e$export$22c0312879c61300 = ()=>(0, $eJOHy.useState)(false);
const $696d52b07491914e$export$1ac6e474a0163418 = ()=>(0, $eJOHy.useState)(false);
const $696d52b07491914e$export$94b118b3187f12c = ({ containerRef: containerRef, tooltipDelay: tooltipDelay })=>{
    const [shouldShowTruncatedTooltip, setShouldShowTruncatedTooltip] = $696d52b07491914e$export$22c0312879c61300();
    const [isTruncated, setIsTruncated] = $696d52b07491914e$export$1ac6e474a0163418();
    const { setTimeoutAutoClear: setTimeoutAutoClear } = (0, $2OtIa.useSetTimeoutAutoClear)();
    const setTimeoutFunc = setTimeoutAutoClear;
    (0, $eJOHy.useEffect)(()=>{
        const container = containerRef.current;
        if (!container) return;
        if (container.offsetWidth < container.scrollWidth) setIsTruncated(true);
        else setIsTruncated(false);
    }, [
        setIsTruncated,
        containerRef
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (isTruncated && tooltipDelay === 0) {
            setShouldShowTruncatedTooltip(true);
            // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            return ()=>{};
        }
        if (isTruncated && tooltipDelay > 0) {
            setTimeoutFunc(()=>setShouldShowTruncatedTooltip(true), tooltipDelay);
            // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            return ()=>{};
        }
        setShouldShowTruncatedTooltip(false);
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
    }, [
        isTruncated,
        setShouldShowTruncatedTooltip,
        tooltipDelay,
        setTimeoutFunc
    ]);
    return {
        shouldShowTruncatedTooltip: shouldShowTruncatedTooltip
    };
};

});


const $726ded7d34812919$export$1858c2a91b8b53ba = 'command-palette.ui.modal.body.command-name-container';
const $726ded7d34812919$export$5e3a644e2bbe06f3 = 'command-palette.ui.modal.modal-content.body.command-row.render-command-name.breadcrumb-container';
const $726ded7d34812919$export$fb5462105b23e3e5 = 'command-palette.ui.modal.modal-content.body.command-row.render-command-name.breadcrumb-item';
const $726ded7d34812919$export$4675b4d60d9881d4 = 'command-palette.ui.modal.modal-content.body.command-row.render-command-name.separator';


parcelRegister("gXsfJ", function(module, exports) {

$parcel$export(module.exports, "RightContent", () => $36c01c052dc4602a$export$11dbab4b39f15d6b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $1kTzc = parcelRequire("1kTzc");

var $lRq8t = parcelRequire("lRq8t");

var $2OtIa = parcelRequire("2OtIa");


var $xZyb9 = parcelRequire("xZyb9");

var $ivvUQ = parcelRequire("ivvUQ");

var $d6dCH = parcelRequire("d6dCH");

var $i7euV = parcelRequire("i7euV");
const $36c01c052dc4602a$export$11dbab4b39f15d6b = ({ command: command, isActive: isActive, isFirstCommand: isFirstCommand = false })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const transitionStep = (0, $i7euV.useHoverTransitionStep)(command, isActive, isFirstCommand);
    const commandHasChildren = (0, $eJOHy.useMemo)(()=>(0, $2OtIa.hasChildren)(command), [
        command
    ]);
    const shouldRenderRightContent = commandHasChildren || !!command.shortcut;
    if (!shouldRenderRightContent) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($36c01c052dc4602a$var$RightContentWrapper, null, commandHasChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($36c01c052dc4602a$var$CommandRightChevronContainer, {
        "data-testid": (0, $f29cb9aaec65a024$export$e3e144c17be58a44),
        transitionStep: transitionStep
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1kTzc))), {
        spacing: "spacious",
        label: formatMessage((0, $xZyb9.messages).rightChevronLabel),
        size: "small"
    })), !!command.shortcut && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($36c01c052dc4602a$var$ShortcutContainer, {
        "data-testid": (0, $f29cb9aaec65a024$export$f3036e9d26f81cd9),
        shouldHaveTransition: commandHasChildren,
        transitionStep: transitionStep
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ivvUQ.Shortcuts), {
        shortcut: command.shortcut
    })));
};
const $36c01c052dc4602a$var$animationFadeIn = null;
const $36c01c052dc4602a$var$animationFadeOut = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $36c01c052dc4602a$var$RightContentWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswh2mm _1e0c11p5 _18u01b66 _syaz1gjq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $36c01c052dc4602a$var$CommandRightChevronContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { transitionStep: transitionStep, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1ii7kb7n _yyhykb7n _4cvr1h6o _1e0c1txw _1bsb1tcg _4t3i1tcg _5sag1ttt _1pgl1ytf _1o51q7pw _tzy4idpf _syaz1oju",
            __cmplp.transitionStep === (0, $d6dCH.TRANSITION_STEP).TRANSITIONING && "",
            __cmplp.transitionStep === (0, $d6dCH.TRANSITION_STEP).TRANSITIONING && "_j7hq1wwu",
            __cmplp.transitionStep === (0, $d6dCH.TRANSITION_STEP).TRANSITIONING_FADE_OUT && "",
            __cmplp.transitionStep === (0, $d6dCH.TRANSITION_STEP).TRANSITIONING_FADE_OUT && "_j7hq1sbx",
            (__cmplp.transitionStep === (0, $d6dCH.TRANSITION_STEP).FINISHED || __cmplp.transitionStep === (0, $d6dCH.TRANSITION_STEP).DELAYING_FADE_OUT) && "_tzy4kb7n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $36c01c052dc4602a$var$ShortcutContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldHaveTransition: shouldHaveTransition, transitionStep: transitionStep, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1ii7kb7n _yyhykb7n _5sag1ttt _1pgl1ytf _1o51q7pw _1e0c1txw _1bahesu3",
            __cmplp.shouldHaveTransition && __cmplp.transitionStep === (0, $d6dCH.TRANSITION_STEP).TRANSITIONING_FADE_OUT && "",
            __cmplp.shouldHaveTransition && __cmplp.transitionStep === (0, $d6dCH.TRANSITION_STEP).TRANSITIONING_FADE_OUT && "_j7hq1wwu",
            __cmplp.shouldHaveTransition && __cmplp.transitionStep === (0, $d6dCH.TRANSITION_STEP).TRANSITIONING && "",
            __cmplp.shouldHaveTransition && __cmplp.transitionStep === (0, $d6dCH.TRANSITION_STEP).TRANSITIONING && "_j7hq1sbx",
            (__cmplp.transitionStep === (0, $d6dCH.TRANSITION_STEP).FINISHED || __cmplp.transitionStep === (0, $d6dCH.TRANSITION_STEP).DELAYING_FADE_OUT) && "_tzy4idpf",
            __cmplp.className
        ])
    });
});

});
const $f29cb9aaec65a024$export$f3036e9d26f81cd9 = 'command-palette.ui.modal.body.command-shortcut-container';
const $f29cb9aaec65a024$export$e3e144c17be58a44 = 'command-palette.ui.modal.body.command-chevron-container';

parcelRegister("xZyb9", function(module, exports) {

$parcel$export(module.exports, "messages", () => $8f4e2b0de24497ce$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $8f4e2b0de24497ce$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    rightChevronLabel: {
        "id": "command-palette.common.components.command-row.right-content.right-chevron-label",
        "defaultMessage": "Command with children icon"
    }
});

});

parcelRegister("ivvUQ", function(module, exports) {

$parcel$export(module.exports, "Shortcuts", () => $2bdae852387b780f$export$b326d77e4b8b7664);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $lRq8t = parcelRequire("lRq8t");

var $cMTOh = parcelRequire("cMTOh");

var $2OtIa = parcelRequire("2OtIa");


var $ey2FZ = parcelRequire("ey2FZ");
const $2bdae852387b780f$var$KeyElement = ({ shortcut: shortcut })=>{
    const isLongText = shortcut && shortcut.length > 1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            $2bdae852387b780f$var$styles.shortcutKeyWrapper
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        "data-testid": (0, $09f953b7673081a6$export$cd62afa4691c297),
        className: (0, $hcewu.default)([
            $2bdae852387b780f$var$styles.lozenge,
            isLongText && $2bdae852387b780f$var$styles.longLozenge
        ])
    }, shortcut));
};
const $2bdae852387b780f$var$DivisorElement = ({ divisor: divisor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2bdae852387b780f$var$ShortcutDivider, {
        "data-testid": (0, $09f953b7673081a6$export$e06ad7c09a29974b)
    }, divisor);
const $2bdae852387b780f$var$SHIFT_CHAR_MAP = {
    '?': 'shift /',
    '!': 'shift 1',
    '@': 'shift 2',
    '#': 'shift 3',
    $: 'shift 4',
    '%': 'shift 5',
    '^': 'shift 6',
    '&': 'shift 7',
    '*': 'shift 8',
    '(': 'shift 9',
    ')': 'shift 0',
    _: 'shift -',
    '+': 'shift =',
    '{': 'shift [',
    '}': 'shift ]',
    ':': 'shift ;',
    '"': "shift '",
    '<': 'shift ,',
    '>': 'shift .',
    '|': 'shift \\',
    '~': 'shift `'
};
const $2bdae852387b780f$var$shiftModifierCheck = (shortcut)=>{
    if (shortcut.length === 1) {
        if (/[A-Z]/.test(shortcut)) return `shift ${shortcut.toLowerCase()}`;
        return $2bdae852387b780f$var$SHIFT_CHAR_MAP[shortcut] || shortcut;
    }
    return shortcut;
};
const $2bdae852387b780f$var$parseShortcut = (shortcut, replacers, acc = [], types = [])=>{
    const replacer = replacers.shift();
    if (!replacer) {
        $2bdae852387b780f$var$shiftModifierCheck(shortcut).split(' ').forEach((key, index, array)=>{
            acc.push({
                type: (0, $cMTOh.SHORTCUT_ELEMENT_TYPES).KEY,
                key: key
            });
            types.push((0, $cMTOh.SHORTCUT_ELEMENT_TYPES).KEY);
            if (index < array.length - 1) {
                const separatorType = (0, $cMTOh.SHORTCUT_ELEMENT_TYPES).PLUS;
                acc.push({
                    type: separatorType
                });
                types.push(separatorType);
            }
        });
        return [
            acc,
            types
        ];
    }
    shortcut.split(replacer.char).forEach((str, index, self)=>{
        $2bdae852387b780f$var$parseShortcut(str, replacers.slice(0), acc, types);
        if (index < self.length - 1) {
            acc.push({
                type: replacer.replacement
            });
            types.push(replacer.replacement);
        }
    });
    return [
        acc,
        types
    ];
};
const $2bdae852387b780f$export$cfaeb054b183bb20 = ()=>(0, $lRq8t.default)();
const $2bdae852387b780f$export$b326d77e4b8b7664 = ({ shortcut: shortcut })=>{
    const { formatMessage: formatMessage } = $2bdae852387b780f$export$cfaeb054b183bb20();
    const [shortcuts, types] = (0, $eJOHy.useMemo)(()=>$2bdae852387b780f$var$parseShortcut(shortcut, (0, $2OtIa.getShortcutSpecialCharacters)()), [
        shortcut
    ]);
    const basicShortcutMessage = (0, $eJOHy.useMemo)(()=>{
        if (types.length === 3) {
            if (types[0] === (0, $cMTOh.SHORTCUT_ELEMENT_TYPES).KEY && types[2] === (0, $cMTOh.SHORTCUT_ELEMENT_TYPES).KEY) {
                if (types[1] === (0, $cMTOh.SHORTCUT_ELEMENT_TYPES).THEN) return (0, $ey2FZ.messages).shortcutThen;
                if (types[1] === (0, $cMTOh.SHORTCUT_ELEMENT_TYPES).OR) return (0, $ey2FZ.messages).shortcutOr;
                if (types[1] === (0, $cMTOh.SHORTCUT_ELEMENT_TYPES).PLUS) return (0, $ey2FZ.messages).shortcutPlus;
            }
        }
        return null;
    }, [
        types
    ]);
    const formatTypeToMessage = (0, $eJOHy.useCallback)((type)=>{
        switch(type){
            case (0, $cMTOh.SHORTCUT_ELEMENT_TYPES).THEN:
                return formatMessage((0, $ey2FZ.messages).divisorThen);
            case (0, $cMTOh.SHORTCUT_ELEMENT_TYPES).OR:
                return formatMessage((0, $ey2FZ.messages).divisorOr);
            default:
                return formatMessage((0, $ey2FZ.messages).divisorPlus);
        }
    }, [
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2bdae852387b780f$var$ShortcutContainer, {
        "data-testid": (0, $09f953b7673081a6$export$ec8260df4f23714c),
        "aria-hidden": true
    }, basicShortcutMessage ? formatMessage(basicShortcutMessage, {
        shortcutA: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2bdae852387b780f$var$KeyElement, {
            shortcut: shortcuts[0].key
        }),
        shortcutB: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2bdae852387b780f$var$KeyElement, {
            shortcut: shortcuts[2].key
        }),
        divisor: (chunk)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2bdae852387b780f$var$DivisorElement, {
                divisor: chunk
            })
    }) : shortcuts.map((obj, index)=>{
        if (obj.type === (0, $cMTOh.SHORTCUT_ELEMENT_TYPES).KEY) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2bdae852387b780f$var$KeyElement, {
            key: index,
            shortcut: obj.key
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2bdae852387b780f$var$DivisorElement, {
            key: index,
            divisor: formatTypeToMessage(obj.type)
        });
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2bdae852387b780f$var$ShortcutDivider = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwx1b66 _otyridpf _18u01b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2bdae852387b780f$var$ShortcutContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _16jlidpf _1o9zkb7n _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $2bdae852387b780f$var$styles = {
    lozenge: "_2rkoglpi _11c81u0j _1e0c1txw _4cvr1h6o _1bah1h6o _1o9zidpf _4t3i1tcg _syaz1fxt _1ul91tcg _1bsb1ris _kqswh2mm _1p1d1dk0 _1pbykb7n _1s6krwve _rfx3glpi _1cs8stnw _1kt9b3bt _154psxj9 _1aukidpf _19woidpf _oounidpf _qnecidpf _1g0v1mrw",
    longLozenge: "_18zr12x7",
    shortcutKeyWrapper: "_ca0qidpf _u5f31y44 _n3tdidpf _19bv1y44 _1ul91tcg _4t3i1tcg _1e0c1txw _4cvr1h6o _1bah1h6o"
};

});
const $09f953b7673081a6$export$cd62afa4691c297 = 'command-palette.ui.modal.body.shortcuts-icons.shortcut-icon';
const $09f953b7673081a6$export$e06ad7c09a29974b = 'command-palette.ui.modal.body.shortcuts-icons.shortcut-divider';
const $09f953b7673081a6$export$ec8260df4f23714c = 'command-palette.ui.modal.modal-content.body.command-row.shortcuts.shortcut-container';

parcelRegister("ey2FZ", function(module, exports) {

$parcel$export(module.exports, "messages", () => $e4fcfaa38e4e2d0e$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $e4fcfaa38e4e2d0e$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    shortcutThen: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.shortcut-then",
        "defaultMessage": "{shortcutA} <divisor>then</divisor> {shortcutB}"
    },
    shortcutOr: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.shortcut-or",
        "defaultMessage": "{shortcutA} <divisor>or</divisor> {shortcutB}"
    },
    shortcutPlus: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.shortcut-plus",
        "defaultMessage": "{shortcutA} <divisor>+</divisor> {shortcutB}"
    },
    divisorThen: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.divisor-then",
        "defaultMessage": "then"
    },
    divisorOr: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.divisor-or",
        "defaultMessage": "or"
    },
    divisorPlus: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.divisor-plus",
        "defaultMessage": "+"
    }
});

});


parcelRegister("d6dCH", function(module, exports) {

$parcel$export(module.exports, "TRANSITION_STEP", () => $b2e6d0fa9dbab6a6$export$42d8d7c94c5a11e9);
$parcel$export(module.exports, "TRANSITION_INITIAL_DELAY_TIME_MS", () => $b2e6d0fa9dbab6a6$export$82cfc253a6c33f59);
$parcel$export(module.exports, "TRANSITION_HOVER_DELAY_TIME_MS", () => $b2e6d0fa9dbab6a6$export$e092796a9af3633b);
$parcel$export(module.exports, "TRANSITION_DURATION_MS", () => $b2e6d0fa9dbab6a6$export$1cad4f611a1c0229);
// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
var $b2e6d0fa9dbab6a6$export$42d8d7c94c5a11e9 = /*#__PURE__*/ function(TRANSITION_STEP) {
    TRANSITION_STEP["INITIAL"] = "initial";
    TRANSITION_STEP["DELAYING"] = "delaying";
    TRANSITION_STEP["TRANSITIONING"] = "transitioning";
    TRANSITION_STEP["FINISHED"] = "finished";
    TRANSITION_STEP["DELAYING_FADE_OUT"] = "delaying-fade-out";
    TRANSITION_STEP["TRANSITIONING_FADE_OUT"] = "transitioning-fade-out";
    return TRANSITION_STEP;
}({});
const $b2e6d0fa9dbab6a6$export$82cfc253a6c33f59 = 600;
const $b2e6d0fa9dbab6a6$export$e092796a9af3633b = 300;
const $b2e6d0fa9dbab6a6$export$1cad4f611a1c0229 = 350;

});

parcelRegister("i7euV", function(module, exports) {

$parcel$export(module.exports, "useHoverTransitionStep", () => $f0a4c8d4492da351$export$eefd045a02bab4c6);

var $eJOHy = parcelRequire("eJOHy");

var $kk5YU = parcelRequire("kk5YU");

var $gYnSx = parcelRequire("gYnSx");

var $2OtIa = parcelRequire("2OtIa");

var $d6dCH = parcelRequire("d6dCH");
const $f0a4c8d4492da351$export$eefd045a02bab4c6 = (command, isActive, isFirstCommand)=>{
    const [hasTransitionedFirstCommand, setHasTransitionedFirstCommand] = (0, $eJOHy.useState)(false);
    const [transitionStep, setTransitionStep] = (0, $eJOHy.useState)((0, $d6dCH.TRANSITION_STEP).INITIAL);
    const timerRef = (0, $eJOHy.useRef)(null);
    const isReducedMotion = (0, $kk5YU.useIsReducedMotion)();
    const commandHasChildren = (0, $2OtIa.hasChildren)(command);
    (0, $eJOHy.useEffect)(()=>{
        setTransitionStep((0, $d6dCH.TRANSITION_STEP).INITIAL);
        if (timerRef.current) clearTimeout(timerRef.current);
    }, [
        command
    ]);
    const startTimerForNextStep = (nextStep, durationMs)=>{
        timerRef.current = setTimeout(()=>{
            setTransitionStep(nextStep);
            timerRef.current = null;
        }, durationMs);
    };
    const handleReducedMotionTransition = (0, $eJOHy.useCallback)(()=>{
        if (isActive) setTransitionStep((0, $d6dCH.TRANSITION_STEP).FINISHED);
        else setTransitionStep((0, $d6dCH.TRANSITION_STEP).INITIAL);
    }, [
        isActive
    ]);
    const handleWithMotionTransition = (0, $eJOHy.useCallback)(()=>{
        switch(transitionStep){
            case (0, $d6dCH.TRANSITION_STEP).INITIAL:
                if (isActive) {
                    setTransitionStep((0, $d6dCH.TRANSITION_STEP).DELAYING);
                    startTimerForNextStep((0, $d6dCH.TRANSITION_STEP).TRANSITIONING, isFirstCommand && !!command.shortcut && !hasTransitionedFirstCommand ? (0, $d6dCH.TRANSITION_INITIAL_DELAY_TIME_MS) : (0, $d6dCH.TRANSITION_HOVER_DELAY_TIME_MS));
                }
                break;
            case (0, $d6dCH.TRANSITION_STEP).DELAYING:
                if (!isActive) {
                    timerRef.current && clearTimeout(timerRef.current);
                    timerRef.current = null;
                    setTransitionStep((0, $d6dCH.TRANSITION_STEP).INITIAL);
                }
                break;
            case (0, $d6dCH.TRANSITION_STEP).TRANSITIONING:
                if (isActive) {
                    if (isFirstCommand && !!command.shortcut && !hasTransitionedFirstCommand) setHasTransitionedFirstCommand(true);
                    if (!timerRef.current) startTimerForNextStep((0, $d6dCH.TRANSITION_STEP).FINISHED, (0, $d6dCH.TRANSITION_DURATION_MS));
                }
                break;
            case (0, $d6dCH.TRANSITION_STEP).FINISHED:
                if (!isActive) setTransitionStep((0, $d6dCH.TRANSITION_STEP).DELAYING_FADE_OUT);
                break;
            case (0, $d6dCH.TRANSITION_STEP).DELAYING_FADE_OUT:
                if (!timerRef.current) startTimerForNextStep((0, $d6dCH.TRANSITION_STEP).TRANSITIONING_FADE_OUT, (0, $d6dCH.TRANSITION_HOVER_DELAY_TIME_MS));
                break;
            case (0, $d6dCH.TRANSITION_STEP).TRANSITIONING_FADE_OUT:
                if (!timerRef.current) startTimerForNextStep((0, $d6dCH.TRANSITION_STEP).INITIAL, (0, $d6dCH.TRANSITION_DURATION_MS));
                break;
            default:
                (0, $gYnSx.default)({
                    error: new Error('Invalid transition step for command'),
                    meta: {
                        id: 'useTransitionStep',
                        packageName: 'jiraCommandPalette',
                        teamName: 'deliveroo'
                    }
                });
        }
    }, [
        command.shortcut,
        hasTransitionedFirstCommand,
        isActive,
        isFirstCommand,
        transitionStep
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (commandHasChildren) {
            if (isReducedMotion) handleReducedMotionTransition();
            else handleWithMotionTransition();
        }
    }, [
        commandHasChildren,
        isReducedMotion,
        handleReducedMotionTransition,
        handleWithMotionTransition
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!isFirstCommand) setHasTransitionedFirstCommand(false);
    }, [
        isFirstCommand
    ]);
    (0, $eJOHy.useEffect)(()=>()=>{
            if (timerRef.current) clearTimeout(timerRef.current);
        }, []);
    return transitionStep;
};

});




parcelRegister("6b4EO", function(module, exports) {

$parcel$export(module.exports, "GROUP_TEST_ID", () => $354f8ec6615134bc$export$d83f892940e54128);
$parcel$export(module.exports, "NO_RESULTS_TEST_ID", () => $354f8ec6615134bc$export$bf182a53106ca02e);
$parcel$export(module.exports, "SCROLL_DIRECTION", () => $354f8ec6615134bc$export$a6d65a8fb7b912d6);
const $354f8ec6615134bc$export$85eefac753ab5bdb = 'command-palette.ui.modal.body.command-body-container';
const $354f8ec6615134bc$export$617744f059bfc3ba = 'command-palette.ui.modal.body.command-container-row';
const $354f8ec6615134bc$export$d83f892940e54128 = 'command-palette.ui.modal.body.group-container';
const $354f8ec6615134bc$export$707f57180c76458e = 'command-palette.ui.modal.body.spinner-container';
const $354f8ec6615134bc$export$bf182a53106ca02e = 'command-palette.ui.modal.body.no-results-container';
var $354f8ec6615134bc$export$a6d65a8fb7b912d6 = /*#__PURE__*/ function(SCROLL_DIRECTION) {
    SCROLL_DIRECTION["START"] = "start";
    SCROLL_DIRECTION["END"] = "end";
    return SCROLL_DIRECTION;
}({});

});

parcelRegister("5IbG4", function(module, exports) {

$parcel$export(module.exports, "isElementVisibleInContainer", () => $a1ee1680b73743ba$export$b9dc8b6556026098);
$parcel$export(module.exports, "getScrollToIndex", () => $a1ee1680b73743ba$export$56068eb4c4e3a63c);
$parcel$export(module.exports, "scrollResultIntoView", () => $a1ee1680b73743ba$export$6be8a7238febd54f);

var $2OtIa = parcelRequire("2OtIa");

var $6b4EO = parcelRequire("6b4EO");
const $a1ee1680b73743ba$export$b9dc8b6556026098 = (element, container)=>{
    const modalBodyRect = container.getBoundingClientRect();
    const elementRect = element.getBoundingClientRect();
    return elementRect.top >= modalBodyRect.top && elementRect.bottom <= modalBodyRect.bottom;
};
const $a1ee1680b73743ba$export$56068eb4c4e3a63c = (results, newActiveIndex, scrollTo)=>{
    const commandResultIndex = results.findIndex((result)=>!result.isGroup && result.index === newActiveIndex);
    if (scrollTo === (0, $6b4EO.SCROLL_DIRECTION).START && commandResultIndex > 0) {
        // Verify if there is any active command before this id
        const prevActiveCommandIndex = results.findIndex((result, index)=>index < commandResultIndex && !result.isGroup && (0, $2OtIa.hasAction)(result.command));
        if (prevActiveCommandIndex === -1) return 0;
    }
    if (scrollTo === (0, $6b4EO.SCROLL_DIRECTION).END) {
        // Verify if there is any active command after this id
        const afterActiveCommandIndex = results.findIndex((result, index)=>index > commandResultIndex && !result.isGroup && (0, $2OtIa.hasAction)(result.command));
        if (afterActiveCommandIndex === -1) return results.length - 1;
        // Scrolling down, so group headings don't need to be taken into account
        return commandResultIndex;
    }
    const isCommandAfterGroupHeading = commandResultIndex > 0 && results[commandResultIndex - 1].isGroup;
    return isCommandAfterGroupHeading ? commandResultIndex - 1 : commandResultIndex;
};
const $a1ee1680b73743ba$export$6be8a7238febd54f = ({ target: target, direction: direction, scrollContainer: scrollContainer })=>{
    const targetRect = target.getBoundingClientRect();
    const containerRect = scrollContainer.getBoundingClientRect();
    const gapScroll = 4;
    if (direction === (0, $6b4EO.SCROLL_DIRECTION).END) {
        const commandPosition = targetRect.bottom - containerRect.top;
        const amountToScroll = commandPosition - containerRect.height;
        const pos = amountToScroll + gapScroll + scrollContainer.scrollTop;
        scrollContainer.scrollTo({
            top: pos
        });
    } else {
        const commandPosition = containerRect.top - targetRect.top;
        const amountToScroll = scrollContainer.scrollTop - commandPosition;
        const pos = amountToScroll - gapScroll;
        scrollContainer.scrollTo({
            top: pos
        });
    }
};

});


parcelRegister("lKFw0", function(module, exports) {

$parcel$export(module.exports, "Footer", () => $0deb62bf7e6b3b6e$export$a06f1c675e846f6f);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

const $0deb62bf7e6b3b6e$export$a06f1c675e846f6f = ({ defaultFooterContent: defaultFooterContent, children: children })=>{
    const footerChildren = children || defaultFooterContent;
    if (!footerChildren) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0deb62bf7e6b3b6e$var$ModalFooter, {
        "data-testid": (0, $19b63b11e263f76d$export$aca3e1b45b29f2bb)
    }, footerChildren);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0deb62bf7e6b3b6e$var$ModalFooter = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_x3dozgxb _mrkb1kw7 _1o0z1kw7 _ca0qutpp _u5f3pxbi _n3tdutpp _19bvpxbi",
            __cmplp.className
        ])
    });
});

});
const $19b63b11e263f76d$export$aca3e1b45b29f2bb = 'command-palette.ui.modal.footer.footer';


parcelRegister("b4bRO", function(module, exports) {

$parcel$export(module.exports, "Header", () => $6a7be27086db7192$export$8b251419efc915eb);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

const $6a7be27086db7192$export$8b251419efc915eb = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $6a7be27086db7192$var$headerStyles,
        testId: (0, $dea6840b8c2241ed$export$bf5b960a2e79e6cf)
    }, children);
const $6a7be27086db7192$var$headerStyles = (0, $1DXK0.xcss)({
    borderTopLeftRadius: 'inherit',
    borderTopRightRadius: 'inherit',
    padding: 'space.200',
    borderBottom: `solid 1px ${"var(--ds-border, #091E4224)"}`
});

});
const $dea6840b8c2241ed$export$bf5b960a2e79e6cf = 'command-palette.ui.modal.header.modal-header';



parcelRegister("d9bSz", function(module, exports) {

$parcel$export(module.exports, "IssueTag", () => $8cd762bdcfb2eb4a$export$a342a0ad2c552031);

var $eJOHy = parcelRequire("eJOHy");

var $3Wh6p = parcelRequire("3Wh6p");
var $1DXK0 = parcelRequire("1DXK0");

var $6QZlQ = parcelRequire("6QZlQ");

var $fygkY = parcelRequire("fygkY");

var $7jTnu = parcelRequire("7jTnu");

var $bmoS1 = parcelRequire("bmoS1");

var $1LCJW = parcelRequire("1LCJW");

var $3EmVH = parcelRequire("3EmVH");
const $8cd762bdcfb2eb4a$export$a342a0ad2c552031 = ({ issueKey: issueKey })=>{
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const issueId = (0, $7jTnu.fg)('relay-migration-issue-fields-summary') ? (0, $bmoS1.useIssueId)() : undefined;
    const [{ value: summary }] = (0, $3EmVH.useSummaryField)({
        issueKey: issueKey,
        issueId: issueId
    });
    const [{ value: issueType }] = (0, $1LCJW.useIssueTypeField)({
        issueKey: issueKey
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        xcss: $8cd762bdcfb2eb4a$var$issueTagContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        xcss: $8cd762bdcfb2eb4a$var$issueTagStyles,
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6QZlQ.IssueLeftIcon), {
        issueTypeName: issueType?.name,
        iconUrl: issueType?.iconUrl
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fygkY.TruncateWithTooltipOnHover), null, `${issueKey} ${summary}`)));
};
const $8cd762bdcfb2eb4a$var$issueTagContainerStyles = (0, $1DXK0.xcss)({
    width: '100%',
    minWidth: '0'
});
const $8cd762bdcfb2eb4a$var$issueTagStyles = (0, $1DXK0.xcss)({
    maxWidth: '100%',
    padding: 'space.050',
    backgroundColor: 'color.background.neutral',
    borderRadius: 'border.radius.100',
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    color: 'color.text.subtle',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 1
});

});
parcelRegister("6QZlQ", function(module, exports) {

$parcel$export(module.exports, "IssueLeftIcon", () => $7c8046d8cc67e0c4$export$b1b562672a76ad84);

var $eJOHy = parcelRequire("eJOHy");

var $7jTnu = parcelRequire("7jTnu");

var $lRq8t = parcelRequire("lRq8t");

var $egRFv = parcelRequire("egRFv");
const $7c8046d8cc67e0c4$export$b1b562672a76ad84 = ({ iconUrl: iconUrl, issueTypeName: issueTypeName })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("img", {
        src: iconUrl,
        alt: formatMessage((0, $7jTnu.fg)('jira-issue-terminology-refresh-m3') ? (0, $egRFv.messages).issueIconAltTextIssueTermRefresh : (0, $egRFv.messages).issueIconAltText, {
            issueTypeName: issueTypeName
        }),
        height: "16"
    });
};

});
parcelRegister("egRFv", function(module, exports) {

$parcel$export(module.exports, "messages", () => $d752c1cd111ca5da$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $d752c1cd111ca5da$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    issueIconAltText: {
        "id": "command-palette-common.common.command.issue.issue-left-icon.issue-icon-alt-text",
        "defaultMessage": "Icon for the issue type {issueTypeName}"
    },
    issueIconAltTextIssueTermRefresh: {
        "id": "command-palette-common.common.command.issue.issue-left-icon.issue-icon-alt-text-issue-term-refresh",
        "defaultMessage": "Icon for the work type {issueTypeName}"
    }
});

});


parcelRegister("fygkY", function(module, exports) {

$parcel$export(module.exports, "TruncateWithTooltipOnHover", () => $062533dcadb4afe9$export$b2323503daaefa);

var $eJOHy = parcelRequire("eJOHy");

var $k71qx = parcelRequire("k71qx");

var $i92Id = parcelRequire("i92Id");


var $fu9LY = parcelRequire("fu9LY");
const $062533dcadb4afe9$export$70f47de153e915ed = ()=>(0, $eJOHy.useRef)(null);
const $062533dcadb4afe9$export$b2323503daaefa = ({ children: children })=>{
    const containerRef = $062533dcadb4afe9$export$70f47de153e915ed();
    const { shouldShowTruncatedTooltip: shouldShowTruncatedTooltip } = (0, $fu9LY.useTruncatedTooltip)({
        containerRef: containerRef,
        // Tooltip delay is set on the tooltip component
        tooltipDelay: 0
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: shouldShowTruncatedTooltip ? ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i92Id.TooltipContent), {
                "data-testid": "command-palette.common.ui.truncate-with-tooltip.truncate-with-tooltip-on-hover.tooltip-content"
            }, children) : '',
        component: (0, $i92Id.TooltipComponent),
        position: "bottom-end",
        delay: (0, $4c1f11f798b8ffde$export$f9e3e7ede9ba929d)
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i92Id.TooltipTrigger), {
            "data-testid": "command-palette.common.ui.truncate-with-tooltip.truncate-with-tooltip-on-hover.tooltip-trigger",
            ...tooltipProps
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i92Id.TruncateWithTooltipContainer), {
            ref: containerRef
        }, children)));
};

});

parcelRegister("1LCJW", function(module, exports) {

$parcel$export(module.exports, "useIssueTypeField", () => $bfeca37ca68a770a$export$3da96c4009e089ca);

var $9Dhvc = parcelRequire("9Dhvc");

var $2QNHW = parcelRequire("2QNHW");

var $2rHwS = parcelRequire("2rHwS");

var $814y1 = parcelRequire("814y1");
const $bfeca37ca68a770a$export$3da96c4009e089ca = ({ issueKey: issueKey, onSuccess: onSuccess, onFailure: onFailure })=>{
    const [{ value: fieldConfig }] = (0, $2rHwS.useFieldConfig)(issueKey, (0, $814y1.ISSUE_TYPE));
    const fieldType = (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(fieldConfig, 'schema.type', (0, $814y1.ISSUE_TYPE));
    const [{ value: value, error: error, loading: loading }, { saveValue: saveValue, resetError: resetError }] = (0, $2QNHW.useEditField)({
        fieldKey: (0, $814y1.ISSUE_TYPE),
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: null,
        onSuccess: onSuccess,
        onFailure: onFailure
    });
    return [
        {
            value: value,
            error: error,
            fieldConfig: fieldConfig,
            loading: loading
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};

});
parcelRegister("2QNHW", function(module, exports) {

$parcel$export(module.exports, "useContextualIssueIdForIssueKey", () => $bce61970be345088$export$76d937477b5f784a);
$parcel$export(module.exports, "useEditField", () => $bce61970be345088$export$343e962d356c0af1);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $8Z9Ld = parcelRequire("8Z9Ld");

var $eSnSE = parcelRequire("eSnSE");

var $7jTnu = parcelRequire("7jTnu");

var $1uIew = parcelRequire("1uIew");

var $8KUFq = parcelRequire("8KUFq");

var $d2AGn = parcelRequire("d2AGn");

var $eDOqM = parcelRequire("eDOqM");

var $bmoS1 = parcelRequire("bmoS1");

var $1Elll = parcelRequire("1Elll");

var $4TKh4 = parcelRequire("4TKh4");

var $4im1M = parcelRequire("4im1M");

var $gCeeo = parcelRequire("gCeeo");

var $eaTQ3 = parcelRequire("eaTQ3");

var $iaPZb = parcelRequire("iaPZb");
/**
 * Some responses contain `fields` property without `fieldKey`.
 * We must avoid changing the state of this fields by checking `fieldKey` property in the `fields`.
 * @param response
 * @param fieldKey
 */ const $bce61970be345088$var$getFieldValue = (response, fieldKey)=>{
    if (!response) return null;
    if (response.fields) {
        if (Object.hasOwnProperty.call(response.fields, fieldKey)) return response.fields[fieldKey];
        return null;
    }
    return response;
};
const $bce61970be345088$var$shouldCallSetFieldValue = (response, fieldKey)=>{
    if (!response) return false;
    if (response.fields) return !!Object.hasOwnProperty.call(response.fields, fieldKey);
    return true;
};
const $bce61970be345088$export$3796d3fdbc2e6b54 = (fieldOptions)=>{
    // di-ignore - Please fix parent-switcher examples
    const { issueKey: issueKey, issueId: issueId, fieldKey: fieldKey, fieldType: fieldType, initialValue: initialValue, analyticsFieldKeyAlias: analyticsFieldKeyAlias, analyticsFieldTypeAlias: analyticsFieldTypeAlias, mapNonOptimisticResponse: mapNonOptimisticResponse = $bce61970be345088$var$getFieldValue, saveField: saveField = (0, $iaPZb.defaultSaveField), saveFieldById: saveFieldById = (0, $iaPZb.defaultSaveFieldById), addValuesToField: addValuesToField = (0, $iaPZb.defaultAddValuesToField), removeValuesFromField: removeValuesFromField = (0, $iaPZb.defaultRemoveValuesFromField), onSubmit: onSubmit = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), onSuccess: onSuccess = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), onFailure: onFailure = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))) } = fieldOptions;
    // We need to track the mounted state as it is possible that a component
    // using this hook can be unmounted before the async edit operation is completed.
    // Causing a react warning about setting state on an unmounted component.
    const isMounted = (0, $4im1M.useIsMounted)();
    const [fieldPersistedValue, { setFieldValue: setFieldValue }] = (0, $eaTQ3.useFieldValue)({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    const fieldValue = fieldPersistedValue !== undefined ? fieldPersistedValue : initialValue;
    const [error, setError] = (0, $eJOHy.useState)(null);
    const [loading, setLoading] = (0, $eJOHy.useState)(false);
    const resetError = (0, $eJOHy.useCallback)(()=>{
        if (isMounted.current) setError(null);
    }, [
        setError,
        isMounted
    ]);
    const editFieldValue = (0, $eJOHy.useCallback)(async (editOperation, editOperationType, valuesForOperation, valuesForUI, meta, analyticsEvent, options = {
        isOptimistic: true
    })=>{
        let result;
        const actualFieldType = analyticsFieldTypeAlias ?? fieldType;
        const analyticsData = {
            editOperationType: editOperationType,
            issueId: issueId,
            fieldKey: analyticsFieldKeyAlias ?? fieldKey,
            fieldType: actualFieldType
        };
        if (isMounted.current) {
            setLoading(true);
            setError(null);
        }
        try {
            onSubmit(fieldValue, valuesForOperation, meta, analyticsEvent);
            if (options.isOptimistic) setFieldValue(issueKey, fieldKey, valuesForUI);
            result = await editOperation(issueKey, fieldKey, valuesForOperation, meta);
            const fieldValueResponse = mapNonOptimisticResponse(result, fieldKey);
            $bce61970be345088$var$shouldCallSetFieldValue(result, fieldKey) && setFieldValue(issueKey, fieldKey, fieldValueResponse);
            onSuccess(fieldValueResponse ?? valuesForOperation, analyticsEvent, meta);
            (0, $gCeeo.fireTrackAnalytics)(analyticsEvent, 'field updated', analyticsData);
            (0, $gCeeo.fireOperationalAnalytics)(analyticsEvent, 'field updateSucceeded', analyticsData);
            (0, $d2AGn.getUpdateAnalyticsFlowHelper)().fireAnalyticsEnd(fieldKey, {
                analytics: analyticsEvent,
                attributes: {
                    fieldType: actualFieldType,
                    isInlineEditing: !(0, $eDOqM.getIsEditFromIssueView)(analyticsEvent),
                    ...(0, $7jTnu.fg)('one_event_improvements_1') && {
                        issueId: issueId
                    }
                }
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (ex) {
            result = Promise.reject(ex);
            onFailure(ex, valuesForOperation);
            setFieldValue(issueKey, fieldKey, fieldValue);
            if (isMounted.current) setError(ex);
            const isValidationError = ex instanceof (0, $1uIew.ValidationError);
            if (!isValidationError) (0, $eSnSE.default).safeErrorWithoutCustomerData('issue-field.save-value', `Failed to update field ${fieldKey} of type ${fieldType}`, ex);
            (0, $gCeeo.fireOperationalAnalytics)(analyticsEvent, 'field updateFailed', {
                fieldKey: fieldKey,
                fieldType: analyticsFieldTypeAlias ?? fieldType,
                isValidationError: isValidationError,
                isClientFetchError: (0, $8KUFq.isClientFetchError)(ex)
            });
            (0, $d2AGn.getUpdateAnalyticsFlowHelper)().endSession(fieldKey);
        }
        if (isMounted.current) setLoading(false);
        return result;
    }, [
        issueId,
        analyticsFieldKeyAlias,
        fieldKey,
        analyticsFieldTypeAlias,
        fieldType,
        isMounted,
        onSubmit,
        fieldValue,
        setFieldValue,
        issueKey,
        onSuccess,
        onFailure,
        mapNonOptimisticResponse
    ]);
    const saveValue = (0, $eJOHy.useCallback)(async (newValue, meta, analyticsEvent)=>editFieldValue(saveField, 'set', newValue, newValue, meta, analyticsEvent), [
        editFieldValue,
        saveField
    ]);
    const saveById = (0, $eJOHy.useCallback)(async (newValue, meta, analyticsEvent)=>editFieldValue(saveFieldById, 'set', newValue, newValue, meta, analyticsEvent, {
            isOptimistic: false
        }), [
        editFieldValue,
        saveFieldById
    ]);
    const addValues = (0, $eJOHy.useCallback)(async (valuesToAdd, expectedValuesAfterAdding, meta, analyticsEvent)=>editFieldValue(addValuesToField, 'add', valuesToAdd, expectedValuesAfterAdding, meta, analyticsEvent), [
        editFieldValue,
        addValuesToField
    ]);
    const removeValues = (0, $eJOHy.useCallback)(async (valuesToRemove, expectedValuesAfterRemoval, meta, analyticsEvent)=>editFieldValue(removeValuesFromField, 'remove', valuesToRemove, expectedValuesAfterRemoval, meta, analyticsEvent), [
        editFieldValue,
        removeValuesFromField
    ]);
    return [
        {
            value: fieldValue,
            loading: loading,
            error: error
        },
        {
            saveById: saveById,
            saveValue: saveValue,
            addValues: addValues,
            removeValues: removeValues,
            resetError: resetError
        }
    ];
};
const $bce61970be345088$export$76d937477b5f784a = (issueKey)=>{
    const contextualIssueId = (0, $bmoS1.useIssueId)();
    const contextualIssueKey = (0, $bmoS1.useIssueKey)();
    return contextualIssueKey === issueKey ? contextualIssueId : null;
};
const $bce61970be345088$var$getAdditionalProperties = (meta, isEditFromIssueView)=>{
    if (!meta || typeof meta === 'object') return {
        ...meta ?? {},
        isEditFromIssueView: isEditFromIssueView
    };
    return meta;
};
const $bce61970be345088$export$343e962d356c0af1 = (fieldOptions)=>{
    const { fieldKey: fieldKey, issueId: issueIdFromFieldOptions, issueKey: issueKey, onSubmit: onSubmit = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), onSuccess: onSuccess = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), onFailure: onFailure = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), shouldPreventIssueViewSoftRefresh: shouldPreventIssueViewSoftRefresh = false } = fieldOptions;
    const [, { fieldChanged: fieldChanged, fieldChangeFailed: fieldChangeFailed, fieldChangeRequested: fieldChangeRequested }] = (0, $4TKh4.useIssueViewFieldUpdateEvents)();
    const contextualIssueId = $bce61970be345088$export$76d937477b5f784a(issueKey);
    const issueId = issueIdFromFieldOptions ?? contextualIssueId;
    const onSubmitFn = (0, $eJOHy.useCallback)((oldValue, newValue, meta, event)=>{
        onSubmit(oldValue, newValue, meta, event);
        issueId && fieldChangeRequested(issueId, fieldKey, newValue, meta);
    }, [
        fieldChangeRequested,
        fieldKey,
        issueId,
        onSubmit
    ]);
    const onSuccessFn = (0, $eJOHy.useCallback)(async (fieldValue, event, meta)=>{
        onSuccess(fieldValue);
        issueId && fieldChanged(issueId, fieldKey, fieldValue, undefined, $bce61970be345088$var$getAdditionalProperties(meta, (0, $eDOqM.getIsEditFromIssueView)(event)));
        if (!shouldPreventIssueViewSoftRefresh && !(0, $eDOqM.getIsEditFromIssueView)(event)) try {
            const reason = (0, $1Elll.Reason).SoftRefresh;
            await (0, $8Z9Ld.default).refreshIssuePageThrowable(issueKey, reason);
        } catch (error) {
            (0, $eSnSE.default).safeErrorWithoutCustomerData('issue.fields.use-edit-field.refresh', error instanceof Error ? error.message : 'useEditField issue refresh failed');
        }
    }, [
        fieldChanged,
        fieldKey,
        shouldPreventIssueViewSoftRefresh,
        issueId,
        issueKey,
        onSuccess
    ]);
    const onFailureFn = (0, $eJOHy.useCallback)((error, failedValue)=>{
        onFailure(error, failedValue);
        issueId && fieldChangeFailed(issueId, fieldKey);
    }, [
        fieldChangeFailed,
        fieldKey,
        issueId,
        onFailure
    ]);
    return $bce61970be345088$export$3796d3fdbc2e6b54({
        ...fieldOptions,
        onSubmit: onSubmitFn,
        onSuccess: onSuccessFn,
        onFailure: onFailureFn
    });
};

});
parcelRegister("8Z9Ld", function(module, exports) {

$parcel$export(module.exports, "default", () => $625abf3f3d5ba00e$export$2e2bcd8739ae039);
const $625abf3f3d5ba00e$var$REFRESH_ISSUE_PAGE_EVENT = 'legacy_refreshIssuePage';
const $625abf3f3d5ba00e$var$UPDATE_ISSUE_GLANCE_EVENT = 'legacy_updateIssueGlance';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $625abf3f3d5ba00e$var$addEventListener = (event, callback)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    document.addEventListener(event, callback);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $625abf3f3d5ba00e$var$removeEventListener = (event, callback)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    document.removeEventListener(event, callback);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $625abf3f3d5ba00e$var$addRefreshIssueListener = (callback)=>$625abf3f3d5ba00e$var$addEventListener($625abf3f3d5ba00e$var$REFRESH_ISSUE_PAGE_EVENT, callback);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $625abf3f3d5ba00e$var$removeRefreshIssueListener = (callback)=>$625abf3f3d5ba00e$var$removeEventListener($625abf3f3d5ba00e$var$REFRESH_ISSUE_PAGE_EVENT, callback);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $625abf3f3d5ba00e$var$addUpdateIssueGlanceListener = (callback)=>$625abf3f3d5ba00e$var$addEventListener($625abf3f3d5ba00e$var$UPDATE_ISSUE_GLANCE_EVENT, callback);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $625abf3f3d5ba00e$var$removeUpdateIssueGlanceListener = (callback)=>$625abf3f3d5ba00e$var$removeEventListener($625abf3f3d5ba00e$var$UPDATE_ISSUE_GLANCE_EVENT, callback);
const $625abf3f3d5ba00e$var$refreshIssuePageThrowable = (issueKey, reason = 'ON_DEMAND')=>{
    try {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.dispatchEvent(new CustomEvent($625abf3f3d5ba00e$var$REFRESH_ISSUE_PAGE_EVENT, {
            detail: [
                issueKey,
                {
                    mergeIntoCurrent: false,
                    reason: reason
                }
            ]
        }));
        return Promise.resolve();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        return Promise.reject(e);
    }
};
const $625abf3f3d5ba00e$var$refreshIssuePage = (issueKey)=>// Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    $625abf3f3d5ba00e$var$refreshIssuePageThrowable(issueKey).catch(()=>{});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$625abf3f3d5ba00e$export$2e2bcd8739ae039 = {
    addRefreshIssueListener: $625abf3f3d5ba00e$var$addRefreshIssueListener,
    removeRefreshIssueListener: $625abf3f3d5ba00e$var$removeRefreshIssueListener,
    addUpdateIssueGlanceListener: $625abf3f3d5ba00e$var$addUpdateIssueGlanceListener,
    removeUpdateIssueGlanceListener: $625abf3f3d5ba00e$var$removeUpdateIssueGlanceListener,
    refreshIssuePageThrowable: $625abf3f3d5ba00e$var$refreshIssuePageThrowable,
    refreshIssuePage: $625abf3f3d5ba00e$var$refreshIssuePage
};

});

parcelRegister("eDOqM", function(module, exports) {

$parcel$export(module.exports, "getIsEditFromIssueView", () => $2cf48d43ab1e3da4$export$8846558eb0b5fa3);

var $9gq2c = parcelRequire("9gq2c");

var $1WOGD = parcelRequire("1WOGD");
const $2cf48d43ab1e3da4$export$8846558eb0b5fa3 = (event)=>{
    const ISSUE_VIEW_SOURCES = [
        'fullIssueScreen',
        'boardIssueViewScreen',
        'agility-backlogScreen',
        'issueNavigatorEmbeddedIssueViewScreen',
        'globalIssueNavigatorIssueScreen',
        'mobileIssueScreen',
        'classicRoadmapScreen',
        'roadmapScreen',
        'versionDetailsIssueScreen',
        'bitbucketIssueScreen',
        'jsmQueueAgentViewSidebarScreen',
        'viewQueueIssueScreen',
        'jswModalIssueAppScreen',
        'jwmModalIssueAppScreen',
        'jswSidebarIssueAppScreen',
        'jwmSidebarIssueAppScreen'
    ];
    const { payload: { source: source } } = (0, $1WOGD.getEvent)(event);
    if (!source) return false;
    if (ISSUE_VIEW_SOURCES.includes(source)) // event originated from issue view location
    return true;
    if (source.startsWith((0, $9gq2c.PACKAGE_NAME_GASV3))) // event originated from forge app, which can only be mounted in issue view for field editing
    return true;
    return false;
};

});

parcelRegister("1Elll", function(module, exports) {

$parcel$export(module.exports, "Reason", () => $a34fa8d661c29191$export$fe867595c4640fb1);
const $a34fa8d661c29191$export$fe867595c4640fb1 = {
    /**
	 * Aka hard refresh, used by Ecosystem apps to refresh issue view on demand
	 * 1) Full issue view refresh
	 * 2) Hard Ecosystem apps refresh (causes remounting of the apps)
	 */ OnDemand: 'ON_DEMAND',
    /**
	 * Used by Jira internally to update issue view on demand without forcing Ecosystem apps to rerender
	 * 1) Full issue view refresh only
	 * 2) Ecosystem app aren't hard refreshed, however, if field's value has changed, Forge custom field will rerender
	 */ SoftRefresh: 'SOFT_REFRESH',
    /**
	 * Issue view refresh caused by Realtime service (Jirt)
	 */ Realtime: 'REALTIME'
};

});

parcelRegister("4TKh4", function(module, exports) {

$parcel$export(module.exports, "useIssueViewFieldUpdateEvents", () => $f55e0c2b65585da2$export$444af741f6d8f512);
$parcel$export(module.exports, "IssueViewFieldUpdateEventContainer", () => $f55e0c2b65585da2$export$f9eb49cc2f0e28ce);

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $bOaiQ = parcelRequire("bOaiQ");

var $4P77p = parcelRequire("4P77p");
const $f55e0c2b65585da2$var$registerEventHandler = (type, eventHandler)=>({ getState: getState, setState: setState })=>{
        if (typeof eventHandler !== 'function') // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
        const { eventHandlers: eventHandlers } = getState();
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ onChange: OnChangeHandler[]; }'.
        const typeEventHandlers = eventHandlers[type];
        setState({
            eventHandlers: {
                ...eventHandlers,
                [type]: typeEventHandlers.concat([
                    eventHandler
                ])
            }
        });
        return ()=>{
            const { eventHandlers: eventHandlersForUnregister } = getState();
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ onChange: OnChangeHandler[]; }'.
            const typeEventHandlersForUnregister = eventHandlersForUnregister[type];
            const newTypeEventHandlers = typeEventHandlersForUnregister.filter(// @ts-expect-error - TS7006 - Parameter 'handler' implicitly has an 'any' type.
            (handler)=>handler !== eventHandler);
            setState({
                eventHandlers: {
                    ...eventHandlersForUnregister,
                    [type]: newTypeEventHandlers
                }
            });
        };
    };
const $f55e0c2b65585da2$var$fieldChanged = (issueId, fieldId, fieldValue, aggFieldChangeProps, additionalProperties)=>({ getState: getState })=>{
        let value = fieldValue;
        if (aggFieldChangeProps) value = (0, $bOaiQ.transformAggToLegacy)({
            fieldValue: fieldValue,
            aggFieldChangeProps: aggFieldChangeProps
        });
        const eventHandlers = getState().eventHandlers.onChange;
        eventHandlers.forEach((eventHandler)=>{
            eventHandler({
                issueId: issueId,
                fieldId: // field id is required to be compatible with v1 onChange API
                fieldId,
                meta: {
                    fieldId: fieldId,
                    fieldValue: value,
                    additionalProperties: additionalProperties
                },
                type: (0, $4P77p.ChangeEventTypes).FIELD_CHANGED
            });
        });
    };
const $f55e0c2b65585da2$var$fieldChangeFailed = (issueId, fieldId)=>({ getState: getState })=>{
        const eventHandlers = getState().eventHandlers.onChange;
        eventHandlers.forEach((eventHandler)=>{
            eventHandler({
                issueId: issueId,
                meta: {
                    fieldId: fieldId
                },
                type: (0, $4P77p.ChangeEventTypes).FIELD_CHANGE_FAILED
            });
        });
    };
const $f55e0c2b65585da2$var$fieldChangeRequested = (issueId, fieldId, fieldValue, additionalProperties, aggFieldChangeProps)=>({ getState: getState })=>{
        let value = fieldValue;
        if (aggFieldChangeProps) value = (0, $bOaiQ.transformAggToLegacy)({
            fieldValue: fieldValue,
            aggFieldChangeProps: aggFieldChangeProps
        });
        const eventHandlers = getState().eventHandlers.onChange;
        eventHandlers.forEach((eventHandler)=>{
            eventHandler({
                issueId: issueId,
                meta: {
                    fieldId: fieldId,
                    fieldValue: value,
                    additionalProperties: additionalProperties
                },
                type: (0, $4P77p.ChangeEventTypes).FIELD_CHANGE_REQUESTED
            });
        });
    };
const $f55e0c2b65585da2$var$actions = {
    fieldChanged: $f55e0c2b65585da2$var$fieldChanged,
    fieldChangeFailed: $f55e0c2b65585da2$var$fieldChangeFailed,
    fieldChangeRequested: $f55e0c2b65585da2$var$fieldChangeRequested,
    registerEventHandler: $f55e0c2b65585da2$var$registerEventHandler
};
// this is a global state
const $f55e0c2b65585da2$var$store = (0, $GtRbT.createStore)({
    name: 'issue-view-field-update-events',
    initialState: {
        eventHandlers: {
            onChange: []
        }
    },
    actions: $f55e0c2b65585da2$var$actions
});
const $f55e0c2b65585da2$export$444af741f6d8f512 = (0, $iJq0l.createHook)($f55e0c2b65585da2$var$store, {
    selector: null
});
const $f55e0c2b65585da2$export$f9eb49cc2f0e28ce = (0, $6E16M.createContainer)($f55e0c2b65585da2$var$store);

});
parcelRegister("bOaiQ", function(module, exports) {

$parcel$export(module.exports, "transformAggToLegacy", () => $a6ba0b2822402a6d$export$d951e3c38e10736d);

var $dJvZv = parcelRequire("dJvZv");

var $814y1 = parcelRequire("814y1");

var $7QMat = parcelRequire("7QMat");

var $i6YHz = parcelRequire("i6YHz");
const $a6ba0b2822402a6d$export$d951e3c38e10736d = ({ fieldValue: fieldValue, aggFieldChangeProps: aggFieldChangeProps })=>{
    if (!aggFieldChangeProps?.__typename) throw new Error('node did not have __typename');
    switch(aggFieldChangeProps.__typename){
        // These fields require context for their transform in transformAggFieldToLegacyField so need to be manually implemented
        // This is not an exhaustive list, I did a quick check is all, so best to check the transform works as expected as you migrate fields to relay
        // These are commented out because they are not implemented and due to types can't just be added here until implemented
        // case JSM_PEOPLE_GQL_FIELD:
        // case ISSUE_RESTRICTION_GQL_FIELD:
        // otherwise we can default to the existing package
        case 0, $814y1.RADIO_GQL_FIELD:
        case 0, $814y1.TEAM_VIEW_GQL_FIELD:
        case 0, $814y1.MULTI_GROUP_PICKER_GQL_FIELD:
        case 0, $814y1.SINGLE_GROUP_PICKER_GQL_FIELD:
        case 0, $814y1.MULTI_USER_PICKER_GQL_FIELD:
        case 0, $814y1.PEOPLE_GQL_FIELD:
        case 0, $814y1.SECURITY_GQL_FIELD:
        case 0, $814y1.NUMBER_GQL_FIELD:
        case 0, $814y1.TEXT_GQL_FIELD:
        case 0, $814y1.USER_PICKER_GQL_FIELD:
        case 0, $814y1.PRIORITY_GQL_FIELD:
        case 0, $814y1.URL_GQL_FIELD:
        case 0, $814y1.DATE_PICKER_GQL_FIELD:
        case 0, $814y1.PROJECT_GQL_FIELD:
        case 0, $814y1.DATE_TIME_GQL_FIELD:
        case 0, $814y1.COLOR_GQL_FIELD:
        case 0, $814y1.ORIGINAL_ESTIMATE_GQL_FIELD:
        case 0, $814y1.ISSUE_TYPE_GQL_FIELD:
        case 0, $814y1.VOTES_GQL_FIELD:
        case 0, $814y1.WATCHES_GQL_FIELD:
        case 0, $814y1.RESOLUTION_GQL_FIELD:
        case 0, $814y1.STATUS_GQL_FIELD:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return (0, $dJvZv.transformAggFieldToLegacyField)({
                [$a6ba0b2822402a6d$var$getValueKey(aggFieldChangeProps.__typename)]: fieldValue,
                __typename: aggFieldChangeProps.__typename,
                type: aggFieldChangeProps.type
            })?.value;
        case 0, $814y1.RICH_TEXT_GQL_FIELD:
            return (0, $i6YHz.transformAggRichTextFieldValueToLegacyFieldValue)(fieldValue, aggFieldChangeProps.renderer);
        case 0, $814y1.PARENT_GQL_FIELD:
            return (0, $7QMat.transformAggParentFieldValueToLegacyFieldValue)(fieldValue);
        case 0, $814y1.SPRINT_GQL_FIELD:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return (0, $dJvZv.transformAggFieldToLegacyField)({
                __typename: aggFieldChangeProps.__typename,
                type: aggFieldChangeProps.type,
                ...fieldValue
            })?.value;
        case 0, $814y1.TIME_TRACKING_GQL_FIELD:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return (0, $dJvZv.transformAggFieldToLegacyField)({
                __typename: aggFieldChangeProps.__typename,
                type: aggFieldChangeProps.type,
                originalEstimate: fieldValue.originalEstimate,
                remainingEstimate: fieldValue.remainingEstimate,
                timeSpent: fieldValue.timeSpent
            })?.value;
        case 0, $814y1.CHECKBOX_GQL_FIELD:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return (0, $dJvZv.transformAggFieldToLegacyField)({
                __typename: aggFieldChangeProps.__typename,
                type: aggFieldChangeProps.type,
                selectedOptions: fieldValue.selectedOptions,
                checkboxesFieldOptions: fieldValue.fieldOptions
            })?.value;
        case 0, $814y1.COMPONENTS_GQL_FIELD:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return (0, $dJvZv.transformAggFieldToLegacyField)({
                __typename: aggFieldChangeProps.__typename,
                type: aggFieldChangeProps.type,
                selectedComponentsConnection: fieldValue.selectedComponentsConnection
            })?.value;
        default:
            throw new Error('__typename not implemented');
    }
};
const $a6ba0b2822402a6d$var$getValueKey = (__typename)=>{
    const VALUE_KEYS = {
        [(0, $814y1.TEXT_GQL_FIELD)]: 'text',
        [(0, $814y1.NUMBER_GQL_FIELD)]: 'number',
        [(0, $814y1.PRIORITY_GQL_FIELD)]: 'priority',
        [(0, $814y1.USER_PICKER_GQL_FIELD)]: 'user',
        [(0, $814y1.DATE_PICKER_GQL_FIELD)]: 'date',
        [(0, $814y1.PROJECT_GQL_FIELD)]: 'project',
        [(0, $814y1.DATE_TIME_GQL_FIELD)]: 'dateTime',
        [(0, $814y1.ORIGINAL_ESTIMATE_GQL_FIELD)]: 'originalEstimate',
        [(0, $814y1.URL_GQL_FIELD)]: 'uri',
        [(0, $814y1.SECURITY_GQL_FIELD)]: 'securityLevel',
        [(0, $814y1.PEOPLE_GQL_FIELD)]: 'selectedUsersConnection',
        [(0, $814y1.WATCHES_GQL_FIELD)]: 'watch',
        [(0, $814y1.VOTES_GQL_FIELD)]: 'vote',
        [(0, $814y1.COLOR_GQL_FIELD)]: 'color',
        [(0, $814y1.MULTI_USER_PICKER_GQL_FIELD)]: 'selectedUsersConnection',
        [(0, $814y1.ISSUE_TYPE_GQL_FIELD)]: 'issueType',
        [(0, $814y1.RESOLUTION_GQL_FIELD)]: 'resolution',
        [(0, $814y1.MULTI_GROUP_PICKER_GQL_FIELD)]: 'selectedGroupsConnection',
        [(0, $814y1.SINGLE_GROUP_PICKER_GQL_FIELD)]: 'selectedGroup',
        [(0, $814y1.TEAM_VIEW_GQL_FIELD)]: 'selectedTeam',
        [(0, $814y1.STATUS_GQL_FIELD)]: 'status',
        [(0, $814y1.RADIO_GQL_FIELD)]: 'selectedOption',
        [(0, $814y1.RICH_TEXT_GQL_FIELD)]: 'richText'
    };
    const value = VALUE_KEYS[__typename];
    if (value) return value;
    throw new Error(`Did you forget to implement getValueKey for your field type? Couldn't find a value in the map for ${__typename}`);
};

});
parcelRegister("dJvZv", function(module, exports) {

$parcel$export(module.exports, "transformAggFieldToLegacyField", () => $2bc37c1610784c31$export$586ba15cbf3d3031);
$parcel$export(module.exports, "transformAggFieldsToLegacyFields", () => $2bc37c1610784c31$export$ba106ff8c087e6b1);

var $LFmXM = parcelRequire("LFmXM");

var $814y1 = parcelRequire("814y1");

var $aFoDn = parcelRequire("aFoDn");

var $b8cRA = parcelRequire("b8cRA");

var $avDDJ = parcelRequire("avDDJ");

var $kHeCF = parcelRequire("kHeCF");

var $2Emz9 = parcelRequire("2Emz9");

var $3z9ZQ = parcelRequire("3z9ZQ");

var $kIiU4 = parcelRequire("kIiU4");

var $eOcuA = parcelRequire("eOcuA");

var $buly8 = parcelRequire("buly8");

var $4w7K1 = parcelRequire("4w7K1");

var $5p7Yl = parcelRequire("5p7Yl");

var $38Ayh = parcelRequire("38Ayh");

var $A0nGG = parcelRequire("A0nGG");

var $9YIgG = parcelRequire("9YIgG");

var $78GMW = parcelRequire("78GMW");

var $atdJk = parcelRequire("atdJk");

var $hWz6P = parcelRequire("hWz6P");

var $h6tdv = parcelRequire("h6tdv");

var $5IGk7 = parcelRequire("5IGk7");

var $aPcUN = parcelRequire("aPcUN");

var $1ZZyu = parcelRequire("1ZZyu");

var $dTYkW = parcelRequire("dTYkW");

var $esMH6 = parcelRequire("esMH6");

var $hqVWW = parcelRequire("hqVWW");

var $eDXnT = parcelRequire("eDXnT");

var $gmqe0 = parcelRequire("gmqe0");

var $95NMG = parcelRequire("95NMG");

var $kctB6 = parcelRequire("kctB6");

var $lBZeI = parcelRequire("lBZeI");

var $bl4cc = parcelRequire("bl4cc");

var $fj4N6 = parcelRequire("fj4N6");

var $7Elqr = parcelRequire("7Elqr");

var $eC8dc = parcelRequire("eC8dc");

var $7Qjvd = parcelRequire("7Qjvd");

var $iHCXo = parcelRequire("iHCXo");

var $2ZqHG = parcelRequire("2ZqHG");

var $kk6ni = parcelRequire("kk6ni");

var $5x8Qz = parcelRequire("5x8Qz");

var $5A5gO = parcelRequire("5A5gO");

var $fw41c = parcelRequire("fw41c");

var $8H6KM = parcelRequire("8H6KM");

var $iyjVB = parcelRequire("iyjVB");

var $lMiiC = parcelRequire("lMiiC");

var $gFEWP = parcelRequire("gFEWP");

var $a0aZw = parcelRequire("a0aZw");

var $7pxBz = parcelRequire("7pxBz");

var $dAiWn = parcelRequire("dAiWn");

var $a6vLL = parcelRequire("a6vLL");

var $gECU8 = parcelRequire("gECU8");

var $c8gRg = parcelRequire("c8gRg");

var $1exBo = parcelRequire("1exBo");

var $gtUzp = parcelRequire("gtUzp");

var $5iFQF = parcelRequire("5iFQF");

var $dSS0X = parcelRequire("dSS0X");

var $hpJ0s = parcelRequire("hpJ0s");

var $8plR2 = parcelRequire("8plR2");

var $92N3i = parcelRequire("92N3i");

var $lR2em = parcelRequire("lR2em");

var $9dsiy = parcelRequire("9dsiy");

var $2eP7x = parcelRequire("2eP7x");

var $ksE6r = parcelRequire("ksE6r");

var $dN5mk = parcelRequire("dN5mk");

var $2CpT2 = parcelRequire("2CpT2");

var $4MVer = parcelRequire("4MVer");

var $kPSkL = parcelRequire("kPSkL");

var $gpNkV = parcelRequire("gpNkV");

var $jE1Uq = parcelRequire("jE1Uq");

var $btvTF = parcelRequire("btvTF");

var $gujad = parcelRequire("gujad");
// We're memoising this just in case we FF another field
const $2bc37c1610784c31$var$getTransformersNonMemoised = ()=>({
        [(0, $814y1.AFFECTED_SERVICES_GQL_FIELD)]: (0, $aFoDn.transformAggAffectedServicesToLegacyField),
        [(0, $814y1.BOOLEAN_GQL_FIELD)]: (0, $avDDJ.transformAggBooleanToLegacyField),
        [(0, $814y1.CASCADING_SELECT_GQL_FIELD)]: (0, $kHeCF.transformAggCascadingSelectToLegacyField),
        [(0, $814y1.CHECKBOX_GQL_FIELD)]: (0, $2Emz9.transformAggCheckboxToLegacyField),
        [(0, $814y1.CMDB_GQL_FIELD)]: (0, $3z9ZQ.transformAggCMDBToLegacyField),
        [(0, $814y1.MULTI_SELECT_GQL_FIELD)]: (0, $a0aZw.transformAggMultipleSelectToLegacyField),
        [(0, $814y1.COMPONENTS_GQL_FIELD)]: (0, $eOcuA.transformAggComponentsToLegacyField),
        [(0, $814y1.CONNECT_DATE_TIME_GQL_FIELD)]: (0, $buly8.transformAggConnectDateTimeToLegacyField),
        [(0, $814y1.CONNECT_MULTI_SELECT_GQL_FIELD)]: (0, $4w7K1.transformAggConnectMultipleSelectToLegacyField),
        [(0, $814y1.CONNECT_NUMBER_GQL_FIELD)]: (0, $5p7Yl.transformAggConnectNumberToLegacyField),
        [(0, $814y1.CONNECT_RICH_TEXT_GQL_FIELD)]: (0, $38Ayh.transformAggConnectRichTextToLegacyField),
        [(0, $814y1.CONNECT_SINGLE_SELECT_GQL_FIELD)]: (0, $A0nGG.transformAggConnectSingleSelectToLegacyField),
        [(0, $814y1.CONNECT_TEXT_GQL_FIELD)]: (0, $9YIgG.transformAggConnectTextToLegacyField),
        [(0, $814y1.COLOR_GQL_FIELD)]: (0, $kIiU4.transformAggColorToLegacyField),
        [(0, $814y1.DATE_PICKER_GQL_FIELD)]: (0, $atdJk.transformAggDatePickerToLegacyField),
        [(0, $814y1.DATE_TIME_GQL_FIELD)]: (0, $hWz6P.transformAggDateTimePickerToLegacyField),
        [(0, $814y1.EPIC_LINK_GQL_FIELD)]: (0, $h6tdv.transformAggEpicLinkToLegacyField),
        [(0, $814y1.FLAG_GQL_FIELD)]: (0, $5IGk7.transformAggFlagToLegacyField),
        [(0, $814y1.FORGE_DATETIME_GQL_FIELD)]: (0, $1ZZyu.transformAggForgeDateTimeToLegacyField),
        [(0, $814y1.FORGE_DATE_GQL_FIELD)]: (0, $aPcUN.transformAggForgeDateToLegacyField),
        [(0, $814y1.FORGE_GROUP_GQL_FIELD)]: (0, $dTYkW.transformAggForgeGroupToLegacyField),
        [(0, $814y1.FORGE_GROUPS_GQL_FIELD)]: (0, $esMH6.transformAggForgeGroupsToLegacyField),
        [(0, $814y1.FORGE_NUMBER_GQL_FIELD)]: (0, $hqVWW.transformAggForgeNumberToLegacyField),
        [(0, $814y1.FORGE_OBJECT_GQL_FIELD)]: (0, $eDXnT.transformAggForgeObjectToLegacyField),
        [(0, $814y1.FORGE_STRING_GQL_FIELD)]: (0, $gmqe0.transformAggForgeStringToLegacyField),
        [(0, $814y1.FORGE_STRINGS_GQL_FIELD)]: (0, $95NMG.transformAggForgeStringsToLegacyField),
        [(0, $814y1.FORGE_USER_GQL_FIELD)]: (0, $kctB6.transformAggForgeUserToLegacyField),
        [(0, $814y1.FORGE_USERS_GQL_FIELD)]: (0, $lBZeI.transformAggForgeUsersToLegacyField),
        [(0, $814y1.ISSUE_RESTRICTION_GQL_FIELD)]: (0, $fj4N6.transformAggIssueRestrictionToLegacyField),
        [(0, $814y1.ISSUE_TYPE_GQL_FIELD)]: (0, $7Elqr.transformAggIssueTypeToLegacyField),
        [(0, $814y1.JSM_APPROVAL_GQL_FIELD)]: (0, $eC8dc.transformAggJSMApprovalsToLegacyField),
        [(0, $814y1.JSM_ASSETS_GQL_FIELD)]: (0, $b8cRA.transformAggAssetToLegacyField),
        [(0, $814y1.JSM_MAJOR_INCIDENT_FIELD)]: (0, $iHCXo.transformAggJSMMajorIncidentToLegacyField),
        [(0, $814y1.JSM_ORGANIZATION_GQL_FIELD)]: (0, $2ZqHG.transformAggJSMOrganizationToLegacyField),
        [(0, $814y1.JSM_ENTITLEMENTS_GQL_FIELD)]: (0, $7Qjvd.transformAggJSMEntitlementsToLegacyField),
        [(0, $814y1.JSM_SENTIMENT_GQL_FIELD)]: (0, $iyjVB.transformAggJSMSentimentToLegacyField),
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        [(0, $814y1.JSM_PEOPLE_GQL_FIELD)]: (0, $7pxBz.transformAggMultipleUserPickerToLegacyField),
        [(0, $814y1.JSM_REQUEST_FEEDBACK_GQL_FIELD)]: (0, $5x8Qz.transformAggJSMRequestFeedbackToLegacyField),
        [(0, $814y1.JSM_REQUEST_LANGUAGE_GQL_FIELD)]: (0, $5A5gO.transformAggJSMRequestLanguageToLegacyField),
        [(0, $814y1.JSM_REQUEST_TYPE_GQL_FIELD)]: (0, $fw41c.transformAggJSMRequestTypeToLegacyField),
        [(0, $814y1.JSM_RESPONDERS_GQL_FIELD)]: (0, $8H6KM.transformAggJSMRespondersToLegacyField),
        [(0, $814y1.LABEL_GQL_FIELD)]: (0, $lMiiC.transformAggLabelsNodeToLegacyField),
        [(0, $814y1.PRIORITY_GQL_FIELD)]: (0, $c8gRg.transformAggPriorityToLegacyField),
        [(0, $814y1.MULTI_GROUP_PICKER_GQL_FIELD)]: (0, $gFEWP.transformAggMultiGroupPickerToLegacyField),
        [(0, $814y1.MULTI_USER_PICKER_GQL_FIELD)]: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $7pxBz.transformAggMultipleUserPickerToLegacyField),
        [(0, $814y1.NUMBER_GQL_FIELD)]: (0, $a6vLL.transformAggNumberToLegacyField),
        [(0, $814y1.ORIGINAL_ESTIMATE_GQL_FIELD)]: (0, $gECU8.transformAggOriginalEstimateToLegacyField),
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        [(0, $814y1.PEOPLE_GQL_FIELD)]: (0, $7pxBz.transformAggMultipleUserPickerToLegacyField),
        [(0, $814y1.PROFORMA_FORMS_GQL_FIELD)]: (0, $1exBo.transformAggProformaFormsToLegacyField),
        [(0, $814y1.PROJECT_GQL_FIELD)]: (0, $gtUzp.transformAggProjectToLegacyField),
        [(0, $814y1.MULTI_VERSION_GQL_FIELD)]: (0, $dAiWn.transformAggMultipleVersionPickerToLegacyField),
        [(0, $814y1.RADIO_GQL_FIELD)]: (0, $5iFQF.transformAggRadioSelectToLegacyField),
        [(0, $814y1.RICH_TEXT_GQL_FIELD)]: (0, $hpJ0s.transformAggRichTextToLegacyField),
        [(0, $814y1.RESOLUTION_GQL_FIELD)]: (0, $dSS0X.transformAggResolutionToLegacyField),
        [(0, $814y1.SECURITY_GQL_FIELD)]: (0, $8plR2.transformAggSecurityLevelToLegacyField),
        [(0, $814y1.SPRINT_GQL_FIELD)]: (0, $dN5mk.transformAggSprintToLegacyField),
        [(0, $814y1.STATUS_GQL_FIELD)]: (0, $2CpT2.transformAggStatusToLegacyField),
        [(0, $814y1.SINGLE_GROUP_PICKER_GQL_FIELD)]: (0, $92N3i.transformAggSingleGroupPickerToLegacyField),
        [(0, $814y1.SINGLE_SELECT_GQL_FIELD)]: (0, $9dsiy.transformAggSingleSelectToLegacyField),
        [(0, $814y1.TEAM_GQL_FIELD)]: (0, $4MVer.transformAggTeamToLegacyField),
        [(0, $814y1.TEAM_VIEW_GQL_FIELD)]: (0, $kPSkL.transformAggTeamViewToLegacyField),
        [(0, $814y1.TEXT_GQL_FIELD)]: (0, $lR2em.transformAggSingleLineTextToLegacyField),
        [(0, $814y1.TIME_TRACKING_GQL_FIELD)]: (0, $gpNkV.transformAggTimeTrackingToLegacyField),
        [(0, $814y1.USER_PICKER_GQL_FIELD)]: (0, $2eP7x.transformAggSingleSelectUserPickerToLegacyField),
        [(0, $814y1.URL_GQL_FIELD)]: (0, $jE1Uq.transformAggUrlToLegacyField),
        [(0, $814y1.VERSION_GQL_FIELD)]: (0, $ksE6r.transformAggSingleVersionPickerToLegacyField),
        [(0, $814y1.VOTES_GQL_FIELD)]: (0, $btvTF.transformAggVotesToLegacyField),
        [(0, $814y1.WATCHES_GQL_FIELD)]: (0, $gujad.transformAggWatchesToLegacyField),
        [(0, $814y1.DATA_CLASSIFICATION_FIELD)]: (0, $78GMW.transformAggDataClassificationToLegacyField),
        [(0, $814y1.GOALS_GQL_FIELD)]: (0, $bl4cc.transformAggGoalsToLegacyField),
        [(0, $814y1.JCS_ORGANIZATION_GQL_FIELD)]: (0, $kk6ni.transformAggJCSOrganizationToLegacyField)
    });
const $2bc37c1610784c31$var$getTransformers = (0, $LFmXM.default)($2bc37c1610784c31$var$getTransformersNonMemoised);
const $2bc37c1610784c31$export$586ba15cbf3d3031 = (node, projectContext)=>{
    const typename = node.__typename;
    const transformer = $2bc37c1610784c31$var$getTransformers()[typename];
    return transformer ? transformer(node, projectContext) : undefined;
};
const $2bc37c1610784c31$export$ba106ff8c087e6b1 = (fields, projectField)=>{
    if (fields == null) return {};
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return fields.reduce((fieldsState, fieldEdge)=>{
        if (fieldEdge?.node != null) {
            const projectContext = projectField != null ? projectField : (0, $gtUzp.getProjectField)(fields)?.project;
            const transformedField = $2bc37c1610784c31$export$586ba15cbf3d3031(fieldEdge.node, projectContext);
            if (transformedField != null) {
                const fieldData = 'key' in transformedField ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                {
                    [transformedField.key]: transformedField
                } : transformedField;
                Object.assign(fieldsState, fieldData);
            }
        }
        return fieldsState;
    }, {});
};

});
parcelRegister("aFoDn", function(module, exports) {

$parcel$export(module.exports, "transformAggAffectedServicesToLegacyField", () => $fbc7a191f371631a$export$231e0419515441d4);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $fbc7a191f371631a$var$transformJiraServicesToLegacyServices = ({ serviceId: serviceId, name: name })=>({
        id: serviceId,
        name: name ?? undefined
    });
const $fbc7a191f371631a$export$231e0419515441d4 = (node)=>{
    if (node.type !== (0, $814y1.SERVICE_ENTITY_CF_TYPE)) return undefined;
    const hasValue = Boolean(node.selectedAffectedServicesConnection?.edges?.length);
    const value = hasValue ? (0, $8Tw1Q.transformAggConnection)(node.selectedAffectedServicesConnection, $fbc7a191f371631a$var$transformJiraServicesToLegacyServices) : null;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        autoCompleteUrl: node.searchUrl != null ? `${node.searchUrl}?query=` : null,
        value: value,
        schema: {
            configuration: null,
            custom: (0, $814y1.SERVICE_ENTITY_CF_TYPE),
            items: 'service-entity-field',
            renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});
const $6e3c8900fd92f5d7$export$89b8c5d86c10a68c = 'atlassian-wiki-renderer';
const $6e3c8900fd92f5d7$export$a4a240cb4053b29f = 'jira-text-renderer';
const $6e3c8900fd92f5d7$export$840ed33fa94f7693 = 'frother-control-renderer';

parcelRegister("8Tw1Q", function(module, exports) {

$parcel$export(module.exports, "transformAggNodeToLegacyField", () => $b9bdfd906e198405$export$e7ea61856a169c36);
$parcel$export(module.exports, "transformAggConnection", () => $b9bdfd906e198405$export$daf92cda81d86cdc);
$parcel$export(module.exports, "toLegacyConnectOption", () => $b9bdfd906e198405$export$b5de5f3d2de73afc);
const $b9bdfd906e198405$export$e7ea61856a169c36 = (node)=>({
        ari: 'id' in node ? node.id : undefined,
        key: 'fieldId' in node && !!node.fieldId ? node.fieldId : '',
        title: 'name' in node ? node.name : '',
        editable: Boolean('isEditableInIssueView' in node ? node.isEditableInIssueView : 'fieldConfig' in node && node.fieldConfig != null && 'isEditable' in node.fieldConfig && node.fieldConfig.isEditable),
        required: Boolean('fieldConfig' in node && node.fieldConfig != null && 'isRequired' in node.fieldConfig && node.fieldConfig.isRequired),
        autoCompleteUrl: 'searchUrl' in node ? node.searchUrl : null,
        allowedValues: [],
        value: null,
        schema: {
            type: 'type' in node ? node.type : '',
            custom: null,
            system: null
        },
        description: 'description' in node && node.description ? node.description : undefined
    });
const $b9bdfd906e198405$export$daf92cda81d86cdc = (connection, transformCallback)=>{
    const edges = connection?.edges ?? [];
    if (transformCallback) return edges.map((edge)=>edge?.node != null ? transformCallback(edge.node) : null).filter(Boolean);
    return edges.map((edge)=>edge?.node).filter(Boolean);
};
const $b9bdfd906e198405$export$b5de5f3d2de73afc = (node)=>{
    if (!node) return null;
    return {
        value: node.value ?? null,
        id: parseInt(node.optionId, 10)
    };
};

});


parcelRegister("b8cRA", function(module, exports) {

$parcel$export(module.exports, "transformAggAssetToLegacyField", () => $b693f7b60620dcc9$export$2136dcd78a2ef18f);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $b693f7b60620dcc9$export$2136dcd78a2ef18f = (node)=>{
    switch(node.type){
        case 0, $814y1.ASSETS_CF_TYPE:
            {
                const hasValue = Boolean(node.selectedAssetsConnection?.edges?.length);
                const assetValue = hasValue ? (0, $8Tw1Q.transformAggConnection)(node.selectedAssetsConnection, ({ appKey: appKey, originId: originId, serializedOrigin: serializedOrigin, value: value })=>({
                        appKey: appKey,
                        originId: originId,
                        serializedOrigin: serializedOrigin,
                        value: value
                    })) : null;
                return {
                    ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
                    autoCompleteUrl: node.searchUrl,
                    value: assetValue,
                    schema: {
                        custom: node.type,
                        system: null,
                        items: 'sd-asset',
                        type: 'array',
                        renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
                        configuration: null
                    }
                };
            }
        default:
            return undefined;
    }
};

});

parcelRegister("avDDJ", function(module, exports) {

$parcel$export(module.exports, "transformAggBooleanToLegacyField", () => $19076dc45029b83c$export$4bd89b95f0d10de9);

var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $19076dc45029b83c$export$4bd89b95f0d10de9 = (node)=>{
    switch(node.type){
        case 0, $814y1.SERVICEDESK_INCIDENT_MANAGEMENT_TYPE:
            return {
                ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
                value: {
                    alertLinking: {
                        enabled: node.value
                    }
                },
                schema: {
                    configuration: null,
                    items: null,
                    renderer: null,
                    custom: null,
                    system: (0, $814y1.SERVICEDESK_INCIDENT_MANAGEMENT_TYPE),
                    type: (0, $814y1.SERVICEDESK_INCIDENT_MANAGEMENT_TYPE)
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("kHeCF", function(module, exports) {

$parcel$export(module.exports, "transformAggCascadingSelectToLegacyField", () => $34b9c9aeef57642b$export$a8778af5ceb1017c);


var $8Tw1Q = parcelRequire("8Tw1Q");
const $34b9c9aeef57642b$export$a8778af5ceb1017c = (node)=>{
    let value = null;
    if (node.cascadingOption) {
        const { childOptionValue: childOptionValue, parentOptionValue: parentOptionValue } = node.cascadingOption;
        const child = childOptionValue ? {
            child: {
                id: childOptionValue.optionId,
                value: childOptionValue.value
            }
        } : {};
        value = {
            // assigned in the statement above
            id: parentOptionValue?.optionId,
            value: parentOptionValue?.value,
            ...child
        };
    }
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: value,
        allowedValues: [],
        schema: {
            type: 'option-with-child',
            renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
            custom: node.type,
            system: null,
            items: null,
            configuration: null
        }
    };
};

});

parcelRegister("2Emz9", function(module, exports) {

$parcel$export(module.exports, "transformAggCheckboxToLegacyField", () => $c452c87cf3235dda$export$baa5afdbd8fd12d3);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $c452c87cf3235dda$export$baa5afdbd8fd12d3 = (node)=>{
    switch(node.type){
        case 0, $814y1.MULTI_CHECKBOXES_CF_TYPE:
            {
                // We're inlining the transformers per field here so it'll be easy to remove them once we make the allowedValues async
                const value = (0, $8Tw1Q.transformAggConnection)(node.selectedOptions, (option)=>({
                        id: option.optionId,
                        value: option.value ?? null,
                        ari: option.id
                    }));
                const allowedValues = (0, $8Tw1Q.transformAggConnection)(node.checkboxesFieldOptions, (option)=>({
                        id: option.optionId,
                        value: option.value ?? null,
                        ari: option.id
                    }));
                return {
                    ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
                    value: value.length ? value : null,
                    allowedValues: allowedValues,
                    schema: {
                        type: 'array',
                        renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
                        custom: node.type,
                        system: null,
                        items: 'option',
                        configuration: null
                    }
                };
            }
        default:
            return undefined;
    }
};

});

parcelRegister("3z9ZQ", function(module, exports) {

$parcel$export(module.exports, "transformAggCMDBToLegacyField", () => $f335a71a0f3327b1$export$93506453d9bb56ae);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $f335a71a0f3327b1$var$transformObjectTypeToLegacy = (attribute, workspaceId)=>{
    if (!attribute) return null;
    return {
        workspaceId: workspaceId,
        id: `${workspaceId}:${attribute.objectTypeId}`,
        name: attribute.name,
        objectSchemaId: attribute.objectSchemaId,
        objectTypeId: attribute.objectTypeId,
        // `icon` is unused
        icon: attribute.icon
    };
};
const $f335a71a0f3327b1$var$transformCMDBConfigurationToLegacyConfiguration = (node)=>{
    if (!node.cmdbFieldConfig) return node.isInsightAvailable === false ? {
        isInsightAvailable: node.isInsightAvailable
    } : {};
    return {
        cmdbFieldConfig: {
            multiple: node.cmdbFieldConfig.multiple,
            objectSchemaId: node.cmdbFieldConfig.objectSchemaId.split('/')[2],
            attributesDisplayedOnIssue: (0, $8Tw1Q.transformAggConnection)(node.cmdbFieldConfig?.attributesDisplayedOnIssue),
            attributesIncludedInAutoCompleteSearch: (0, $8Tw1Q.transformAggConnection)(node.cmdbFieldConfig?.attributesIncludedInAutoCompleteSearch)
        },
        isInsightAvailable: node.isInsightAvailable,
        wasInsightRequestSuccessful: node.wasInsightRequestSuccessful
    };
};
const $f335a71a0f3327b1$var$transformObjectTypeAttributeToLegacy = (type)=>{
    switch(type){
        case 'REFERENCED_OBJECT':
            return 1;
        case 'USER':
            return 2;
        case 'GROUP':
            return 4;
        case 'PROJECT':
            return 6;
        case 'STATUS':
            return 7;
        case 'BITBUCKET_REPO':
            return 8;
        case 'OPSGENIE_TEAM':
            return 9;
        case 'DEFAULT':
            return 0;
        default:
            // eslint-disable-next-line no-console
            console.error(new Error(`Unknown attribute type found in transformObjectTypeAttributeToLegacy: ${type}. Mapping type to '-1'`));
            return -1;
    }
};
const $f335a71a0f3327b1$var$transformReferencedObject = (node)=>({
        id: node.objectGlobalId,
        workspaceId: node.workspaceId,
        objectKey: node.objectKey,
        label: node.label,
        avatar: node.avatar,
        objectId: node.objectId
    });
const $f335a71a0f3327b1$var$transformCmdbUser = (node)=>({
        avatarUrl: node.picture,
        displayName: node.name,
        name: node.name,
        key: node.accountId
    });
const $f335a71a0f3327b1$var$transformCmdbGroup = (node)=>({
        name: node.name
    });
const $f335a71a0f3327b1$var$transformCmdbProject = (node)=>({
        avatarUrl: node.avatar?.large,
        id: Number(node.id),
        key: node.key,
        name: node.name
    });
const $f335a71a0f3327b1$var$transformCmdbBitbucketRepo = (node)=>({
        uuid: node.uuid,
        name: node.name,
        url: node.url,
        avatarUrl: node.avatarUrl
    });
const $f335a71a0f3327b1$var$transformCmdbOpsgenieTeam = (node)=>({
        id: node.id,
        name: node.name,
        url: node.url
    });
const $f335a71a0f3327b1$var$transformCmdbStatus = (node)=>({
        id: node.id,
        name: node.name,
        category: node.category
    });
const $f335a71a0f3327b1$var$transformObjectAttributeValuesToLegacy = (node)=>{
    if (!node) return null;
    const defaultObjectValue = {
        displayValue: node.displayValue,
        searchValue: node.searchValue,
        ...node.value != null ? {
            value: node.value
        } : {}
    };
    if (node.referencedObject) return {
        ...defaultObjectValue,
        referencedObject: $f335a71a0f3327b1$var$transformReferencedObject(node.referencedObject)
    };
    if (node.user) return {
        ...defaultObjectValue,
        user: $f335a71a0f3327b1$var$transformCmdbUser(node.user)
    };
    if (node.group) return {
        ...defaultObjectValue,
        group: $f335a71a0f3327b1$var$transformCmdbGroup(node.group)
    };
    if (node.project) return {
        ...defaultObjectValue,
        project: $f335a71a0f3327b1$var$transformCmdbProject(node.project)
    };
    if (node.bitbucketRepo) return {
        ...defaultObjectValue,
        bitbucketRepo: $f335a71a0f3327b1$var$transformCmdbBitbucketRepo(node.bitbucketRepo)
    };
    if (node.opsgenieTeam) return {
        ...defaultObjectValue,
        opsgenieTeam: $f335a71a0f3327b1$var$transformCmdbOpsgenieTeam(node.opsgenieTeam)
    };
    if (node.status) return {
        ...defaultObjectValue,
        status: $f335a71a0f3327b1$var$transformCmdbStatus(node.status)
    };
    return defaultObjectValue;
};
const $f335a71a0f3327b1$var$transformObjectAttributesToLegacyObjectAttributes = (node, workspaceId)=>{
    if (!node) return null;
    const { objectTypeAttributeId: objectTypeAttributeId } = node;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const objectTypeAttribute = node.objectTypeAttribute;
    return {
        objectTypeAttributeId: objectTypeAttributeId,
        workspaceId: workspaceId,
        objectAttributeValues: (0, $8Tw1Q.transformAggConnection)(node.objectAttributeValues, $f335a71a0f3327b1$var$transformObjectAttributeValuesToLegacy),
        objectTypeAttribute: {
            id: objectTypeAttributeId,
            label: objectTypeAttribute.label,
            name: objectTypeAttribute.name,
            workspaceId: workspaceId,
            type: $f335a71a0f3327b1$var$transformObjectTypeAttributeToLegacy(objectTypeAttribute.type),
            ...objectTypeAttribute.defaultType ? {
                defaultType: {
                    id: objectTypeAttribute.defaultType.id,
                    name: objectTypeAttribute.defaultType.name
                }
            } : {}
        }
    };
};
const $f335a71a0f3327b1$var$transformJiraCMDBToLegacyCMDB = (node)=>{
    if (!node) return null;
    const { label: label, objectGlobalId: objectGlobalId, objectId: objectId, objectKey: objectKey, webUrl: webUrl, avatar: avatar } = node;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const workspaceId = node.workspaceId;
    return {
        attributes: (0, $8Tw1Q.transformAggConnection)(node.attributes, (nodeAttribute)=>$f335a71a0f3327b1$var$transformObjectAttributesToLegacyObjectAttributes(nodeAttribute, workspaceId)),
        avatar: avatar,
        label: label,
        id: objectGlobalId,
        objectId: objectId,
        objectKey: objectKey,
        workspaceId: workspaceId,
        links: {
            self: webUrl
        },
        objectType: $f335a71a0f3327b1$var$transformObjectTypeToLegacy(node.objectType, workspaceId)
    };
};
const $f335a71a0f3327b1$export$93506453d9bb56ae = (node)=>{
    if (node.type !== (0, $814y1.CMDB_OBJECT_CF_TYPE)) return undefined;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        autoCompleteUrl: node.searchUrl != null ? `${node.searchUrl}?` : null,
        configuration: $f335a71a0f3327b1$var$transformCMDBConfigurationToLegacyConfiguration(node),
        value: (0, $8Tw1Q.transformAggConnection)(node.selectedCmdbObjectsConnection, $f335a71a0f3327b1$var$transformJiraCMDBToLegacyCMDB),
        schema: {
            configuration: null,
            custom: (0, $814y1.CMDB_OBJECT_CF_TYPE),
            items: 'cmdb-object-field',
            renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("kIiU4", function(module, exports) {

$parcel$export(module.exports, "transformAggColorToLegacyField", () => $46915e9bf9032cfd$export$587c178f1b45e5e9);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $46915e9bf9032cfd$export$587c178f1b45e5e9 = (node)=>{
    const value = node.color?.colorKey ?? null;
    switch(node.type){
        case 0, $814y1.EPIC_COLOR_TYPE:
        case 0, $814y1.COLOR_CF_TYPE:
            return {
                ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
                value: value,
                schema: {
                    configuration: null,
                    type: (0, $814y1.ISSUE_FIELD_STRING_CF_TYPE),
                    renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
                    custom: node.type,
                    system: null,
                    items: null
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("eOcuA", function(module, exports) {

$parcel$export(module.exports, "transformAggComponentsToLegacyField", () => $65b417152350f194$export$97a9275777684b77);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
// @DoNotExport Flow is deriving component's type
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $65b417152350f194$var$transformJiraComponentToLegacyComponent = (component)=>{
    if (component == null) return null;
    return {
        id: component.componentId,
        name: component.name,
        ari: component.ari,
        metadata: component.metadata
    };
};
const $65b417152350f194$export$97a9275777684b77 = (node)=>{
    if (node.type !== (0, $814y1.COMPONENTS_TYPE)) return undefined;
    const value = (0, $8Tw1Q.transformAggConnection)(node.selectedComponentsConnection, $65b417152350f194$var$transformJiraComponentToLegacyComponent);
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        allowedValues: [],
        value: value,
        schema: {
            configuration: null,
            items: 'component',
            renderer: (0, $6e3c8900fd92f5d7$export$840ed33fa94f7693),
            type: (0, $814y1.ISSUE_FIELD_MULTI_SELECT_CF_TYPE),
            custom: null,
            system: (0, $814y1.COMPONENTS_TYPE)
        }
    };
};

});

parcelRegister("buly8", function(module, exports) {

$parcel$export(module.exports, "transformAggConnectDateTimeToLegacyField", () => $221506f594bc9cb4$export$e6d015aa746cbdaf);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $221506f594bc9cb4$export$e6d015aa746cbdaf = (node)=>({
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: node.dateTime ?? null,
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
            system: null,
            custom: node.type,
            type: (0, $814y1.ISSUE_FIELD_DATETIME_CF_TYPE)
        }
    });

});

parcelRegister("4w7K1", function(module, exports) {

$parcel$export(module.exports, "transformAggConnectMultipleSelectToLegacyField", () => $b8b4e3981ba17f3d$export$edf5c98d20696686);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $b8b4e3981ba17f3d$export$edf5c98d20696686 = (node)=>{
    const value = (0, $8Tw1Q.transformAggConnection)(node.selectedOptions, (0, $8Tw1Q.toLegacyConnectOption));
    const allowedValues = (0, $8Tw1Q.transformAggConnection)(node.connectMultiSelectFieldOptions, (0, $8Tw1Q.toLegacyConnectOption));
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: value.length ? value : null,
        allowedValues: allowedValues,
        schema: {
            type: (0, $814y1.ISSUE_FIELD_MULTI_SELECT_CF_TYPE),
            renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
            custom: node.type,
            system: null,
            items: (0, $814y1.ISSUE_FIELD_SINGLE_SELECT_CF_TYPE),
            configuration: null
        }
    };
};

});

parcelRegister("5p7Yl", function(module, exports) {

$parcel$export(module.exports, "transformAggConnectNumberToLegacyField", () => $d4146295cc2f8675$export$4638a5dd3285d8f2);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $d4146295cc2f8675$export$4638a5dd3285d8f2 = (node)=>({
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: node.number ?? null,
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
            system: null,
            custom: node.type,
            type: (0, $814y1.ISSUE_FIELD_NUMBER_CF_TYPE)
        }
    });

});

parcelRegister("38Ayh", function(module, exports) {

$parcel$export(module.exports, "transformAggConnectRichTextToLegacyField", () => $ccba2b4e2894a74a$export$11063e1f9210f191);

var $clRM1 = parcelRequire("clRM1");


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");

var $h9Xzk = parcelRequire("h9Xzk");
const $ccba2b4e2894a74a$var$emptyAdfObject = (0, $clRM1.getEmptyADF)();
const $ccba2b4e2894a74a$var$getPlainTextValue = (node)=>{
    if (!node.richText) return null;
    if (node.richText.plainText == null) return '';
    return node.richText.plainText;
};
const $ccba2b4e2894a74a$export$11063e1f9210f191 = (node)=>{
    const { renderer: renderer } = node;
    if ((0, $h9Xzk.default)(node)) return undefined;
    const isPlainTextRenderer = renderer === (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f);
    const values = isPlainTextRenderer ? {
        value: $ccba2b4e2894a74a$var$getPlainTextValue(node)
    } : {
        adfValue: node.richText?.adfValue?.json || $ccba2b4e2894a74a$var$emptyAdfObject
    };
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        ...values,
        schema: {
            custom: (0, $814y1.TEXT_AREA_CF_TYPE),
            renderer: renderer,
            type: (0, $814y1.ISSUE_FIELD_STRING_CF_TYPE),
            system: null,
            configuration: null,
            items: null
        }
    };
};

});
parcelRegister("h9Xzk", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7b33a46f73dd986$export$2e2bcd8739ae039);

var $eSnSE = parcelRequire("eSnSE");
const $a7b33a46f73dd986$export$c63f561360bafed1 = 'issue.agg-field-transformers.missing-renderer';
// If the renderer is missing, log an error and return true.
// This was added as part of https://jplat.atlassian.net/browse/JIV-14881 to help identify why
// fields are sometimes missing the renderer.
const $a7b33a46f73dd986$var$isFieldMissingRenderer = (field)=>{
    try {
        // Narrow the type of field to fields with a renderer
        if (!('renderer' in field)) return false;
        if (field?.renderer) return false;
        (0, $eSnSE.default).safeErrorWithoutCustomerData($a7b33a46f73dd986$export$c63f561360bafed1, `Field ${field.fieldId} of type ${field.__typename} has missing renderer: ${field.renderer}`);
        return true;
    } catch  {
        return false;
    }
};
var $a7b33a46f73dd986$export$2e2bcd8739ae039 = $a7b33a46f73dd986$var$isFieldMissingRenderer;

});


parcelRegister("A0nGG", function(module, exports) {

$parcel$export(module.exports, "transformAggConnectSingleSelectToLegacyField", () => $f44e8e94ee36a4ad$export$e44db7cf61369a28);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $f44e8e94ee36a4ad$export$e44db7cf61369a28 = (node)=>{
    let value = null;
    if (node.fieldOption != null) value = {
        id: parseInt(node.fieldOption?.optionId, 10),
        value: node.fieldOption?.value
    };
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: value,
        allowedValues: (0, $8Tw1Q.transformAggConnection)(node.connectSingleSelectFieldOptions, (0, $8Tw1Q.toLegacyConnectOption)),
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
            system: null,
            custom: node.type,
            type: (0, $814y1.ISSUE_FIELD_SINGLE_SELECT_CF_TYPE)
        }
    };
};

});

parcelRegister("9YIgG", function(module, exports) {

$parcel$export(module.exports, "transformAggConnectTextToLegacyField", () => $fb3ccbbdcae36154$export$dd05277f5aa90657);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $fb3ccbbdcae36154$export$dd05277f5aa90657 = (node)=>({
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: node.text,
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
            custom: node.type,
            system: null,
            type: (0, $814y1.ISSUE_FIELD_STRING_CF_TYPE)
        }
    });

});

parcelRegister("78GMW", function(module, exports) {

$parcel$export(module.exports, "transformAggDataClassificationToLegacyField", () => $ed99b79bb25d8ed0$export$b5edfdc89a7a2932);

var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $ed99b79bb25d8ed0$export$b5edfdc89a7a2932 = (node)=>({
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        key: (0, $814y1.DATA_CLASSIFICATION_TYPE),
        value: node,
        schema: {
            configuration: null,
            items: null,
            renderer: null,
            custom: null,
            system: null,
            type: (0, $814y1.DATA_CLASSIFICATION_TYPE)
        }
    });

});

parcelRegister("atdJk", function(module, exports) {

$parcel$export(module.exports, "transformAggDatePickerToLegacyField", () => $4b9ed7131bec6e05$export$3d6e51d37c0454a9);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $4b9ed7131bec6e05$export$3d6e51d37c0454a9 = (node)=>{
    switch(node.type){
        case 0, $814y1.DUE_DATE_TYPE:
            return {
                ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
                value: typeof node.date === 'string' ? node.date : null,
                schema: {
                    type: (0, $814y1.ISSUE_FIELD_DATE_CF_TYPE),
                    configuration: null,
                    system: node.type,
                    renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
                    custom: null,
                    items: null
                }
            };
        case 0, $814y1.DATE_CF_TYPE:
        case 0, $814y1.BASELINE_START_CF_TYPE:
        case 0, $814y1.BASELINE_END_CF_TYPE:
            return {
                ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
                value: typeof node.date === 'string' ? node.date : null,
                schema: {
                    type: (0, $814y1.ISSUE_FIELD_DATE_CF_TYPE),
                    custom: node.type,
                    configuration: null,
                    renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
                    system: null,
                    items: null
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("hWz6P", function(module, exports) {

$parcel$export(module.exports, "transformAggDateTimePickerToLegacyField", () => $1a0e6d673c934121$export$3de22f1277f0c239);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $1a0e6d673c934121$var$defaultSchema = {
    type: (0, $814y1.ISSUE_FIELD_DATETIME_CF_TYPE),
    custom: null,
    system: null,
    configuration: null,
    items: null,
    renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f)
};
const $1a0e6d673c934121$export$3de22f1277f0c239 = (node)=>{
    switch(node.type){
        case 0, $814y1.CREATED:
        case 0, $814y1.UPDATED:
            return {
                ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
                value: node.dateTime || '',
                schema: {
                    ...$1a0e6d673c934121$var$defaultSchema,
                    system: node.type,
                    renderer: null
                }
            };
        case 0, $814y1.RESOLUTION_DATE:
            return {
                ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
                value: node.dateTime ?? null,
                schema: {
                    ...$1a0e6d673c934121$var$defaultSchema,
                    system: node.type,
                    renderer: null
                }
            };
        case 0, $814y1.DATETIME_CF_TYPE:
        case 0, $814y1.FIRST_RESPONSE_DATE_CF_TYPE:
        case 0, $814y1.REQUEST_FEEDBACK_DATE_CF_TYPE:
            return {
                ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
                value: node.dateTime ?? null,
                schema: {
                    ...$1a0e6d673c934121$var$defaultSchema,
                    custom: node.type
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("h6tdv", function(module, exports) {

$parcel$export(module.exports, "transformAggEpicLinkToLegacyField", () => $e459964244aebe6e$export$1311f30c94840aa2);

var $38IWH = parcelRequire("38IWH");

var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $e459964244aebe6e$var$transformJiraEpicToLegacyEpicLink = (epic)=>{
    if (epic == null) return null;
    return {
        id: Number(epic.issueId),
        key: epic.key || '',
        done: !!epic.done,
        name: epic.name || '',
        summary: epic.summary || '',
        color: {
            key: epic.color ?? (0, $38IWH.AgileColors).AGILE_COLOR_1
        },
        // This can only be set from cache handlers
        fromCache: false
    };
};
const $e459964244aebe6e$export$1311f30c94840aa2 = (node)=>{
    if (node.type !== (0, $814y1.EPIC_TYPE)) return undefined;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        autoCompleteUrl: node.searchUrl,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        value: $e459964244aebe6e$var$transformJiraEpicToLegacyEpicLink(node.epic),
        schema: {
            configuration: null,
            items: null,
            renderer: 'jira-text-renderer',
            type: 'any',
            custom: (0, $814y1.EPIC_TYPE),
            system: null
        }
    };
};

});

parcelRegister("5IGk7", function(module, exports) {

$parcel$export(module.exports, "transformAggFlagToLegacyField", () => $a3532dc678d08ada$export$31555b6ea19f4c2);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $a3532dc678d08ada$var$transformJiraFlagToLegacyFlag = (flag)=>{
    if (flag == null || flag.isFlagged == null) return null;
    return [
        {
            value: flag.isFlagged
        }
    ];
};
const $a3532dc678d08ada$export$31555b6ea19f4c2 = (node)=>{
    // Agg flag field comes back as multichecbox CF type instead of current graphql flagged CF type
    if (node.type !== (0, $814y1.MULTI_CHECKBOXES_CF_TYPE)) return undefined;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: $a3532dc678d08ada$var$transformJiraFlagToLegacyFlag(node.flag),
        schema: {
            configuration: null,
            custom: (0, $814y1.FLAGGED_CF_TYPE),
            items: 'option',
            renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("aPcUN", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeDateToLegacyField", () => $45d2a807fecba84f$export$30fccfce22948120);

var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");

var $h9Xzk = parcelRequire("h9Xzk");
const $45d2a807fecba84f$export$30fccfce22948120 = (node)=>{
    if ((0, $h9Xzk.default)(node)) return undefined;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: node.date,
        autoCompleteUrl: null,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $814y1.ISSUE_FIELD_DATE_CF_TYPE)
        }
    };
};

});

parcelRegister("1ZZyu", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeDateTimeToLegacyField", () => $e0a4b577749ae3db$export$61b1f0cbd04c7b9c);

var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");

var $h9Xzk = parcelRequire("h9Xzk");
const $e0a4b577749ae3db$export$61b1f0cbd04c7b9c = (node)=>{
    if ((0, $h9Xzk.default)(node)) return undefined;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: node.dateTime,
        autoCompleteUrl: null,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $814y1.ISSUE_FIELD_DATETIME_CF_TYPE)
        }
    };
};

});

parcelRegister("dTYkW", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeGroupToLegacyField", () => $6c830c67e2d50cb9$export$60b03d63015cbb9f);

var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");

var $h9Xzk = parcelRequire("h9Xzk");
const $6c830c67e2d50cb9$export$60b03d63015cbb9f = (node)=>{
    if ((0, $h9Xzk.default)(node)) return undefined;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: node.selectedGroup ? {
            name: node.selectedGroup.name
        } : null,
        autoCompleteUrl: null,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $814y1.ISSUE_FIELD_SINGLE_GROUP_CF_TYPE)
        }
    };
};

});

parcelRegister("esMH6", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeGroupsToLegacyField", () => $09a4b6c46d9b3fa9$export$2dfa4944fba5d1f5);

var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");

var $h9Xzk = parcelRequire("h9Xzk");
const $09a4b6c46d9b3fa9$export$2dfa4944fba5d1f5 = (node)=>{
    if ((0, $h9Xzk.default)(node)) return undefined;
    const value = node.selectedGroupsConnection?.edges?.length ? (0, $8Tw1Q.transformAggConnection)(node.selectedGroupsConnection, ({ name: name })=>({
            name: name
        })) : null;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            configuration: null,
            items: (0, $814y1.ISSUE_FIELD_SINGLE_GROUP_CF_TYPE),
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $814y1.ISSUE_FIELD_MULTI_SELECT_CF_TYPE)
        }
    };
};

});

parcelRegister("hqVWW", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeNumberToLegacyField", () => $19fcb5a1ca2a0e66$export$5dab8986dc45db07);

var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");

var $h9Xzk = parcelRequire("h9Xzk");
const $19fcb5a1ca2a0e66$export$5dab8986dc45db07 = (node)=>{
    if ((0, $h9Xzk.default)(node)) return undefined;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: node.number,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $814y1.ISSUE_FIELD_NUMBER_CF_TYPE)
        }
    };
};

});

parcelRegister("eDXnT", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeObjectToLegacyField", () => $84e4daeebd05036a$export$fbdabdbae2a203b9);

var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");

var $h9Xzk = parcelRequire("h9Xzk");
const $84e4daeebd05036a$export$fbdabdbae2a203b9 = (node)=>{
    if ((0, $h9Xzk.default)(node)) return undefined;
    const value = (()=>{
        if (node.object == null) return null;
        try {
            return JSON.parse(node.object);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            throw new Error('Failed to transform forge object field: node.object was invalid JSON object');
        }
    })();
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $814y1.ISSUE_FIELD_OBJECT_CF_TYPE)
        }
    };
};

});

parcelRegister("gmqe0", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeStringToLegacyField", () => $ac8fda7c9b1a7eca$export$3a581fb4b3e578bd);

var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");

var $h9Xzk = parcelRequire("h9Xzk");
const $ac8fda7c9b1a7eca$export$3a581fb4b3e578bd = (node)=>{
    if ((0, $h9Xzk.default)(node)) return undefined;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: node.text,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $814y1.ISSUE_FIELD_STRING_CF_TYPE)
        }
    };
};

});

parcelRegister("95NMG", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeStringsToLegacyField", () => $8d8cd734e91ff053$export$418a06cb5dc6aba5);

var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");

var $h9Xzk = parcelRequire("h9Xzk");
const $8d8cd734e91ff053$export$418a06cb5dc6aba5 = (node)=>{
    if ((0, $h9Xzk.default)(node)) return undefined;
    const hasValue = Boolean(node.selectedLabelsConnection?.edges?.length);
    const value = hasValue ? (0, $8Tw1Q.transformAggConnection)(node.selectedLabelsConnection, ({ name: name })=>name) : null;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: value,
        autoCompleteUrl: node.searchUrl,
        schema: {
            configuration: null,
            items: (0, $814y1.ISSUE_FIELD_STRING_CF_TYPE),
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $814y1.ISSUE_FIELD_MULTI_SELECT_CF_TYPE)
        }
    };
};

});

parcelRegister("kctB6", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeUserToLegacyField", () => $0fbafb49b1bf00d7$export$bc73c7a747f907e5);

var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");

var $h9Xzk = parcelRequire("h9Xzk");

var $74RuE = parcelRequire("74RuE");
const $0fbafb49b1bf00d7$export$bc73c7a747f907e5 = (node)=>{
    if ((0, $h9Xzk.default)(node)) return undefined;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: node.user ? (0, $74RuE.transformJiraUserToLegacyServerUser)(node.user) : null,
        autoCompleteUrl: node.searchUrl,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $814y1.ISSUE_FIELD_USER_CF_TYPE)
        }
    };
};

});
parcelRegister("74RuE", function(module, exports) {

$parcel$export(module.exports, "transformJiraUserToLegacyServerUser", () => $e296ae9d66be02be$export$d7b231260a016eaf);

const $e296ae9d66be02be$var$getAccountType = (objectType)=>{
    switch(objectType){
        case 'AtlassianAccountUser':
            return 0, $2a25afeed5eb2192$export$981400c14dd99bc0;
        case 'CustomerUser':
            return 0, $2a25afeed5eb2192$export$2823897fb92cd040;
        case 'AppUser':
            return 0, $2a25afeed5eb2192$export$1973ca62b6c5abfe;
        default:
            return 0, $2a25afeed5eb2192$export$d1f5101c0939e3fe;
    }
};
const $e296ae9d66be02be$var$generateAvatarUrls = (url)=>({
        '16x16': url,
        '24x24': url,
        '32x32': url,
        '48x48': url
    });
const $e296ae9d66be02be$export$d7b231260a016eaf = (user)=>{
    if (!user) return null;
    const userOptionalKeysMap = {
        emailAddress: 'email',
        locale: 'locale',
        timeZone: 'zoneinfo'
    };
    const optionalValues = {};
    Object.entries(userOptionalKeysMap).forEach(([key, aggKey])=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const aggValue = user[aggKey];
        if (aggValue !== undefined && aggValue !== null) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        optionalValues[key] = aggValue;
    });
    const avatars = user.picture != null ? {
        avatarUrl: user.picture,
        avatarUrls: $e296ae9d66be02be$var$generateAvatarUrls(user.picture)
    } : {};
    return {
        ...avatars,
        ...optionalValues,
        accountId: user.accountId,
        accountType: $e296ae9d66be02be$var$getAccountType(user.__typename),
        active: user.accountStatus === 'active',
        displayName: user.name
    };
};

});
const $2a25afeed5eb2192$export$981400c14dd99bc0 = 'atlassian';
const $2a25afeed5eb2192$export$2823897fb92cd040 = 'customer';
const $2a25afeed5eb2192$export$1973ca62b6c5abfe = 'app';
const $2a25afeed5eb2192$export$d1f5101c0939e3fe = 'unknown';



parcelRegister("lBZeI", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeUsersToLegacyField", () => $312acaf5adbb266a$export$bbfea2e2f2c853b8);

var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");

var $h9Xzk = parcelRequire("h9Xzk");

var $74RuE = parcelRequire("74RuE");
const $312acaf5adbb266a$export$bbfea2e2f2c853b8 = (node)=>{
    if ((0, $h9Xzk.default)(node)) return undefined;
    const value = node.selectedUsersConnection?.edges?.length ? (0, $8Tw1Q.transformAggConnection)(node.selectedUsersConnection, (0, $74RuE.transformJiraUserToLegacyServerUser)) : null;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            configuration: null,
            items: (0, $814y1.ISSUE_FIELD_USER_CF_TYPE),
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $814y1.ISSUE_FIELD_MULTI_SELECT_CF_TYPE)
        }
    };
};

});

parcelRegister("bl4cc", function(module, exports) {

$parcel$export(module.exports, "transformAggGoalsToLegacyField", () => $c42fa72110704597$export$158301a02ae4cbe7);

var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $c42fa72110704597$export$158301a02ae4cbe7 = (node)=>{
    if (node.type !== (0, $814y1.GOALS_CF_TYPE)) return undefined;
    const value = node.selectedGoals ? {
        goals: node.selectedGoals?.edges?.filter((edge)=>edge?.node !== null).map((edge)=>({
                id: edge?.node?.id || '',
                name: edge?.node?.name || '',
                status: edge?.node?.status || null
            })) || [],
        totalCount: node.selectedGoals?.totalCount || 0
    } : null;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            configuration: null,
            custom: (0, $814y1.GOALS_CF_TYPE),
            items: null,
            renderer: null,
            system: null,
            type: (0, $814y1.GOALS_CF_TYPE)
        }
    };
};

});

parcelRegister("fj4N6", function(module, exports) {

$parcel$export(module.exports, "transformAggIssueRestrictionToLegacyField", () => $23256e2230655f0b$export$62db794d5816e28e);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $23256e2230655f0b$var$transformJiraRoleToRestriction = (role)=>{
    if (role == null) return null;
    return {
        restrictionValue: role.roleId
    };
};
const $23256e2230655f0b$export$62db794d5816e28e = (node, projectContext)=>{
    if (node.type !== (0, $814y1.ISSUE_RESTRICTION_TYPE)) return undefined;
    const roles = (0, $8Tw1Q.transformAggConnection)(node.selectedRolesConnection, $23256e2230655f0b$var$transformJiraRoleToRestriction);
    const restrictions = roles.length > 0 ? {
        projectrole: roles
    } : {};
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: {
            shouldDisplay: projectContext?.canSetIssueRestriction === true,
            issuerestrictions: restrictions
        },
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
            type: (0, $814y1.ISSUE_RESTRICTION_TYPE),
            custom: null,
            system: node.type
        }
    };
};

});

parcelRegister("7Elqr", function(module, exports) {

$parcel$export(module.exports, "getSystemAggJiraIssueType", () => $b196dfe2103ffd7c$export$b4644a0cc2f2935e);
$parcel$export(module.exports, "transformJiraIssueTypeToLegacyIssueType", () => $b196dfe2103ffd7c$export$2356062173546155);
$parcel$export(module.exports, "transformAggIssueTypeToLegacyField", () => $b196dfe2103ffd7c$export$de2eb3b47c7c887b);


var $hj7L9 = parcelRequire("hj7L9");

var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $b196dfe2103ffd7c$export$d95e76b2d065f98d = {
    avatarId: 0,
    self: ''
};
const $b196dfe2103ffd7c$export$b4644a0cc2f2935e = (fields)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const issueTypeField = fields?.find((edge)=>edge?.node != null && edge.node.__typename === (0, $814y1.ISSUE_TYPE_GQL_FIELD) && edge.node.type === (0, $814y1.ISSUE_TYPE))?.node;
    if (issueTypeField == null || issueTypeField.__typename !== (0, $814y1.ISSUE_TYPE_GQL_FIELD) || issueTypeField.type !== (0, $814y1.ISSUE_TYPE)) throw new Error(`Failed to get system issue type: ${(0, $814y1.ISSUE_TYPE_GQL_FIELD)} with ${(0, $814y1.ISSUE_TYPE)} 'fieldId' and 'type' not found [${JSON.stringify(fields ?? '')}]`);
    if (issueTypeField.issueType == null) throw new Error(`Failed to get system issue type: ${(0, $814y1.ISSUE_TYPE_GQL_FIELD)}.issueType is missing [${JSON.stringify(issueTypeField)}]`);
    return issueTypeField.issueType;
};
const $b196dfe2103ffd7c$export$2356062173546155 = (issueType)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const id = issueType.issueTypeId;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const hierarchyLevel = issueType.hierarchy?.level;
    return {
        ...$b196dfe2103ffd7c$export$d95e76b2d065f98d,
        id: id,
        iconUrl: issueType.avatar?.medium ?? '',
        name: issueType.name,
        description: 'description' in issueType && issueType.description != null ? issueType.description : '',
        hierarchyLevel: hierarchyLevel,
        subtask: hierarchyLevel === (0, $hj7L9.ISSUE_TYPE_HIERARCHY_LEVEL).SUBTASK_LEVEL
    };
};
const $b196dfe2103ffd7c$export$de2eb3b47c7c887b = (node)=>{
    if (node.type !== (0, $814y1.ISSUE_TYPE) || node.issueType == null) throw new Error(`Failed to transform ${(0, $814y1.ISSUE_TYPE_GQL_FIELD)}: type is not ${(0, $814y1.ISSUE_TYPE)} or 'issueType' is empty [${JSON.stringify(node)}]`);
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: $b196dfe2103ffd7c$export$2356062173546155(node.issueType),
        schema: {
            configuration: null,
            custom: null,
            items: null,
            renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
            system: (0, $814y1.ISSUE_TYPE),
            type: (0, $814y1.ISSUE_TYPE)
        }
    };
};

});
parcelRegister("hj7L9", function(module, exports) {

$parcel$export(module.exports, "ISSUE_TYPE_HIERARCHY_LEVEL", () => $a4de97c2b1c75d0a$export$2fe6880f0073407c);

var $eBWnc = parcelRequire("eBWnc");
const $a4de97c2b1c75d0a$export$2fe6880f0073407c = {
    SUBTASK_LEVEL: (0, $eBWnc.ISSUE_HIERARCHY_LEVEL_SUBTASK),
    BASE_LEVEL: (0, $eBWnc.ISSUE_HIERARCHY_LEVEL_BASE),
    LEVEL_ONE: (0, $eBWnc.ISSUE_HIERARCHY_LEVEL_EPIC),
    LEVEL_TWO: 2
};

});
parcelRegister("eBWnc", function(module, exports) {

$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_GOAL", () => $9f3e0c182d6aa29f$export$2294cfc7730248df);
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_STRATEGY", () => $9f3e0c182d6aa29f$export$961a1d6da881600c);
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_INITIATIVE", () => $9f3e0c182d6aa29f$export$e11dea67b88ee556);
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_EPIC", () => $9f3e0c182d6aa29f$export$9ad20e435294162a);
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_BASE", () => $9f3e0c182d6aa29f$export$a454b3474c5ee5f5);
$parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_SUBTASK", () => $9f3e0c182d6aa29f$export$b69c1b48ce8f83de);
$parcel$export(module.exports, "BASE_HIERARCHY_TYPE", () => $9f3e0c182d6aa29f$export$ba7c785763a2a58f);
$parcel$export(module.exports, "CHILD_HIERARCHY_TYPE", () => $9f3e0c182d6aa29f$export$e09d07f2dcff2603);
$parcel$export(module.exports, "PARENT_HIERARCHY_TYPE", () => $9f3e0c182d6aa29f$export$1165245f61159842);
$parcel$export(module.exports, "EPIC_PARENT_HIERARCHY_TYPE", () => $9f3e0c182d6aa29f$export$8a96a83b3f957e58);
$parcel$export(module.exports, "toHierarchyLevel", () => $9f3e0c182d6aa29f$export$c0c893ca5ccae9dd);
$parcel$export(module.exports, "isBaseHierarchyLevel", () => $9f3e0c182d6aa29f$export$bcf91a9d8c5b0f58);
$parcel$export(module.exports, "isEpicHierarchyLevel", () => $9f3e0c182d6aa29f$export$e415cf60723c7aae);
$parcel$export(module.exports, "isSubtaskHierarchyLevel", () => $9f3e0c182d6aa29f$export$41f00a40e2ebd6e8);
$parcel$export(module.exports, "getHierarchyLevelType", () => $9f3e0c182d6aa29f$export$556b686fea6fb229);
$parcel$export(module.exports, "getHierarchyLevelTypeSplitEpicFromCustom", () => $9f3e0c182d6aa29f$export$638ac52227e67c8);
const $9f3e0c182d6aa29f$export$2294cfc7730248df = 4;
const $9f3e0c182d6aa29f$export$961a1d6da881600c = 3;
const $9f3e0c182d6aa29f$export$e11dea67b88ee556 = 2;
const $9f3e0c182d6aa29f$export$9ad20e435294162a = 1;
const $9f3e0c182d6aa29f$export$a454b3474c5ee5f5 = 0;
const $9f3e0c182d6aa29f$export$b69c1b48ce8f83de = -1;
const $9f3e0c182d6aa29f$export$ba7c785763a2a58f = 'BASE';
const $9f3e0c182d6aa29f$export$e09d07f2dcff2603 = 'CHILD';
const $9f3e0c182d6aa29f$export$1165245f61159842 = 'PARENT';
const $9f3e0c182d6aa29f$export$8a96a83b3f957e58 = 'EPIC';
const $9f3e0c182d6aa29f$export$c0c893ca5ccae9dd = (level)=>level;
const $9f3e0c182d6aa29f$export$bcf91a9d8c5b0f58 = (level)=>{
    const numericLevel = Number(level);
    if (Number.isNaN(numericLevel)) return true;
    return numericLevel === $9f3e0c182d6aa29f$export$a454b3474c5ee5f5;
};
const $9f3e0c182d6aa29f$export$e415cf60723c7aae = (level)=>{
    const numericLevel = Number(level);
    if (Number.isNaN(numericLevel)) return false;
    return numericLevel === $9f3e0c182d6aa29f$export$9ad20e435294162a;
};
const $9f3e0c182d6aa29f$export$41f00a40e2ebd6e8 = (level)=>{
    const numericLevel = Number(level);
    if (Number.isNaN(numericLevel)) return false;
    return numericLevel === $9f3e0c182d6aa29f$export$b69c1b48ce8f83de;
};
const $9f3e0c182d6aa29f$export$556b686fea6fb229 = (hierarchyLevel)=>{
    if (Number(hierarchyLevel) > 0) return $9f3e0c182d6aa29f$export$1165245f61159842;
    if (Number(hierarchyLevel) < 0) return $9f3e0c182d6aa29f$export$e09d07f2dcff2603;
    return $9f3e0c182d6aa29f$export$ba7c785763a2a58f;
};
const $9f3e0c182d6aa29f$export$638ac52227e67c8 = (hierarchyLevel)=>{
    if (Number(hierarchyLevel) === 1) return $9f3e0c182d6aa29f$export$8a96a83b3f957e58;
    if (Number(hierarchyLevel) > 1) return $9f3e0c182d6aa29f$export$1165245f61159842;
    if (Number(hierarchyLevel) < 0) return $9f3e0c182d6aa29f$export$e09d07f2dcff2603;
    return $9f3e0c182d6aa29f$export$ba7c785763a2a58f;
};

});



parcelRegister("eC8dc", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMApprovalsToLegacyField", () => $a2eea09779371a38$export$b14d30f2a9e4c343);

var $8BAUB = parcelRequire("8BAUB");

var $814y1 = parcelRequire("814y1");

var $ljej9 = parcelRequire("ljej9");

var $8Tw1Q = parcelRequire("8Tw1Q");

var $74RuE = parcelRequire("74RuE");
const $a2eea09779371a38$var$transformApproverPrincipalsToLegacy = (approverPrincipal)=>{
    if (!approverPrincipal) return undefined;
    switch(approverPrincipal.__typename){
        case 0, $814y1.JSM_USER_APPROVER_PRINCIPAL_FIELD:
            if (!approverPrincipal.user) return undefined;
            return {
                id: (0, $ljej9.toAccountId)(approverPrincipal.user.accountId),
                name: approverPrincipal.user.name,
                meta: {
                    jiraRest: approverPrincipal.jiraRest ?? ''
                },
                type: 'user',
                avatarUrl: approverPrincipal.user.picture
            };
        case 0, $814y1.JSM_GROUP_APPROVER_PRINCIPAL_FIELD:
            if (!approverPrincipal.groupId) return undefined;
            return {
                id: (0, $8BAUB.toGroupId)(approverPrincipal.groupId),
                meta: {
                    memberCount: approverPrincipal.memberCount || 0,
                    approvedCount: approverPrincipal.approvedCount || 0
                },
                name: approverPrincipal.name || '',
                type: 'group'
            };
        default:
            return undefined;
    }
};
const $a2eea09779371a38$var$getApproverDecision = (decision)=>{
    switch(decision){
        case 0, $8BAUB.APPROVER_APPROVED:
            return 0, $8BAUB.APPROVER_APPROVED;
        case 0, $8BAUB.APPROVER_DECLINED:
            return 0, $8BAUB.APPROVER_DECLINED;
        case 0, $8BAUB.APPROVER_PENDING:
        default:
            return 0, $8BAUB.APPROVER_PENDING;
    }
};
const $a2eea09779371a38$var$transformApproverToLegacy = (approvalNode)=>{
    if (!approvalNode) return undefined;
    const approver = (0, $74RuE.transformJiraUserToLegacyServerUser)(approvalNode.approver);
    if (!approver) return undefined;
    return {
        approverDecision: $a2eea09779371a38$var$getApproverDecision(approvalNode.approverDecision),
        approver: approver
    };
};
const $a2eea09779371a38$var$transformConfigurationToLegacy = (configurations)=>{
    // This function contains a lot of null checks and default empty values to satisfy flow because
    // the AGG type coming back is in the shape of [JiraServiceManagementApprovalConfiguration]
    // Which means technically it can be an empty array. Even though we will always only ever
    // get 1 object back.
    const { approversConfigurations: approversConfigurations = [], condition: condition } = configurations?.[0] || {};
    const approverConfiguration = approversConfigurations?.[0];
    return {
        approvers: {
            type: approverConfiguration?.type ?? '',
            customFieldName: approverConfiguration?.fieldName ?? '',
            customFieldId: approverConfiguration?.fieldId ?? ''
        },
        condition: {
            type: condition?.type ?? '',
            value: condition?.value ?? ''
        }
    };
};
const $a2eea09779371a38$var$transformDateToLegacy = (date)=>({
        epochMillis: date ? new Date(date).valueOf() : -1
    });
const $a2eea09779371a38$var$transformStatusToLegacy = (status)=>({
        name: status.name || '',
        category: Number(status.categoryId)
    });
const $a2eea09779371a38$var$transformActiveApprovalToLegacy = (activeApproval)=>{
    const { id: id, configurations: configurations, status: status, createdDate: createdDate, canAnswerApproval: canAnswerApproval, pendingApprovalCount: pendingApprovalCount, name: name, finalDecision: finalDecision, approvalState: approvalState, approvedStatus: approvedStatus } = activeApproval;
    return {
        id: id,
        approvalState: approvalState,
        approvedStatus: approvedStatus,
        finalDecision: $a2eea09779371a38$var$getApproverDecision(finalDecision),
        name: name,
        pendingApprovalCount: pendingApprovalCount,
        canAnswerApproval: canAnswerApproval,
        approverPrincipals: (0, $8Tw1Q.transformAggConnection)(activeApproval.approverPrincipals, $a2eea09779371a38$var$transformApproverPrincipalsToLegacy),
        approvers: (0, $8Tw1Q.transformAggConnection)(activeApproval.approvers, $a2eea09779371a38$var$transformApproverToLegacy),
        configuration: $a2eea09779371a38$var$transformConfigurationToLegacy(configurations),
        createdDate: $a2eea09779371a38$var$transformDateToLegacy(createdDate ?? ''),
        decisions: (0, $8Tw1Q.transformAggConnection)(activeApproval.decisions, $a2eea09779371a38$var$transformApproverToLegacy),
        excludedApprovers: (0, $8Tw1Q.transformAggConnection)(activeApproval.excludedApprovers, (0, $74RuE.transformJiraUserToLegacyServerUser)),
        status: status ? $a2eea09779371a38$var$transformStatusToLegacy(status) : null
    };
};
const $a2eea09779371a38$var$transformCompletedApprovalToLegacy = (completedApproval)=>{
    if (!completedApproval) return undefined;
    const { id: id, name: name, finalDecision: finalDecision, createdDate: createdDate, completedDate: completedDate, status: status } = completedApproval;
    return {
        id: id,
        name: name,
        finalDecision: $a2eea09779371a38$var$getApproverDecision(finalDecision),
        createdDate: $a2eea09779371a38$var$transformDateToLegacy(createdDate ?? ''),
        completedDate: $a2eea09779371a38$var$transformDateToLegacy(completedDate),
        status: status ? $a2eea09779371a38$var$transformStatusToLegacy(status) : null,
        approvers: (0, $8Tw1Q.transformAggConnection)(completedApproval.approvers, $a2eea09779371a38$var$transformApproverToLegacy)
    };
};
const $a2eea09779371a38$export$b14d30f2a9e4c343 = (node)=>{
    if (node.type !== (0, $814y1.SERVICEDESK_APPROVAL_TYPE)) return undefined;
    const activeApproval = node.activeApproval ? {
        activeApproval: $a2eea09779371a38$var$transformActiveApprovalToLegacy(node.activeApproval)
    } : {};
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: {
            ...activeApproval,
            completedApprovals: (0, $8Tw1Q.transformAggConnection)(node.completedApprovalsConnection, $a2eea09779371a38$var$transformCompletedApprovalToLegacy)
        },
        schema: {
            configuration: null,
            custom: null,
            items: null,
            renderer: null,
            system: (0, $814y1.SERVICEDESK_APPROVAL_TYPE),
            type: (0, $814y1.SERVICEDESK_APPROVAL_TYPE)
        }
    };
};

});
parcelRegister("8BAUB", function(module, exports) {

$parcel$export(module.exports, "toGroupId", () => $a32e17d33af9616f$export$779c261480444a4d);
$parcel$export(module.exports, "APPROVER_PENDING", () => $a32e17d33af9616f$export$3b59c4db06f5829b);
$parcel$export(module.exports, "APPROVER_APPROVED", () => $a32e17d33af9616f$export$e17ae8ca1010e2a4);
$parcel$export(module.exports, "APPROVER_DECLINED", () => $a32e17d33af9616f$export$b5a0d270c9cd7435);
$parcel$export(module.exports, "APPROVAL_OK", () => $a32e17d33af9616f$export$2e6187b6a4348938);
const $a32e17d33af9616f$export$779c261480444a4d = (x)=>x;
const $a32e17d33af9616f$export$3b59c4db06f5829b = 'pending';
const $a32e17d33af9616f$export$e17ae8ca1010e2a4 = 'approved';
const $a32e17d33af9616f$export$b5a0d270c9cd7435 = 'declined';
const $a32e17d33af9616f$export$2e6187b6a4348938 = 'OK';
const $a32e17d33af9616f$export$b5d660d719b8009 = 'INSUFFICIENT_APPROVERS';

});


parcelRegister("7Qjvd", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMEntitlementsToLegacyField", () => $3e00182679906144$export$850fadda8a5e6f27);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $3e00182679906144$export$850fadda8a5e6f27 = (node)=>{
    if (node.type !== (0, $814y1.ENTITLEMENT_CF_TYPE)) return undefined;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: node.selectedEntitlement,
        schema: {
            configuration: null,
            custom: (0, $814y1.ENTITLEMENT_CF_TYPE),
            items: (0, $814y1.ISSUE_FIELD_STRING_CF_TYPE),
            renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("iHCXo", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMMajorIncidentToLegacyField", () => $c7ffd6a8a8025014$export$d4e0b2288fb31144);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $c7ffd6a8a8025014$export$d4e0b2288fb31144 = (node)=>({
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: node.majorIncident,
        renderedValue: null,
        configuration: {},
        schema: {
            configuration: null,
            custom: (0, $814y1.MAJOR_INCIDENT_CF_TYPE),
            items: null,
            renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
            system: null,
            type: (0, $814y1.ISSUE_FIELD_STRING_CF_TYPE)
        }
    });

});

parcelRegister("2ZqHG", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMOrganizationToLegacyField", () => $2d322beb8f2cd6d6$export$7bd14951253a7c5f);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $2d322beb8f2cd6d6$export$7bd14951253a7c5f = (node)=>{
    if (node.type !== (0, $814y1.ORGANIZATIONS_CF_TYPE)) return undefined;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: (0, $8Tw1Q.transformAggConnection)(node.selectedOrganizationsConnection, (selectedNode)=>({
                id: selectedNode.organizationId,
                name: selectedNode.organizationName
            })),
        schema: {
            configuration: null,
            custom: (0, $814y1.ORGANIZATIONS_CF_TYPE),
            items: 'sd-customerorganization',
            renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("kk6ni", function(module, exports) {

$parcel$export(module.exports, "transformAggJCSOrganizationToLegacyField", () => $3d5c3716e18b39d8$export$81bfe5b16f9be413);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $3d5c3716e18b39d8$export$81bfe5b16f9be413 = (node)=>{
    if (node.type !== (0, $814y1.ORGANIZATION_CF_TYPE)) return undefined;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: node.selectedOrganization,
        schema: {
            configuration: null,
            custom: (0, $814y1.ORGANIZATION_CF_TYPE),
            items: 'sd-customerorganization',
            renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("5x8Qz", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMRequestFeedbackToLegacyField", () => $7269440389468f87$export$c52c6988b335096);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $7269440389468f87$export$c52c6988b335096 = (node)=>{
    if (node.type !== (0, $814y1.REQUEST_FEEDBACK_CF_TYPE)) return undefined;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: node.feedback,
        schema: {
            type: 'sd-feedback',
            renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
            custom: (0, $814y1.REQUEST_FEEDBACK_CF_TYPE),
            system: null,
            items: null,
            configuration: null
        }
    };
};

});

parcelRegister("5A5gO", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMRequestLanguageToLegacyField", () => $cf1d539f2192cd8b$export$6a53240e225f742);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $cf1d539f2192cd8b$export$6a53240e225f742 = (node)=>{
    if (node.type !== (0, $814y1.REQUEST_LANGUAGE_CF_TYPE)) return undefined;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: node.language,
        allowedValues: [
            ...node.languages ?? []
        ],
        schema: {
            type: 'sd-request-lang',
            renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
            custom: (0, $814y1.REQUEST_LANGUAGE_CF_TYPE),
            system: null,
            items: null,
            configuration: null
        }
    };
};

});

parcelRegister("fw41c", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMRequestTypeToLegacyField", () => $cd769e66cd433490$export$5ffaab1383177efa);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $cd769e66cd433490$var$transformRequestTypeToLegacy = (requestType)=>{
    if (!requestType) return null;
    return {
        requestType: {
            id: parseInt(requestType.requestTypeId, 10),
            issueTypeId: requestType.issueType?.issueTypeId || '',
            name: requestType.name || '',
            icon: {
                _links: {
                    iconUrls: {
                        '48x48': requestType.avatar?.large || ''
                    }
                }
            }
        }
    };
};
const $cd769e66cd433490$export$5ffaab1383177efa = (node)=>{
    if (node.type !== (0, $814y1.REQUEST_TYPE_CF_TYPE)) return undefined;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        // @ts-expect-error - Argument of type '{ readonly avatar: { readonly large: string | null | undefined; readonly medium: string | null | undefined; readonly small: string | null | undefined; readonly xsmall: string | null | undefined; } | null | undefined; readonly id: string; readonly issueType: { ...; } | ... 1 more ... | undefined; readonly name: strin...' is not assignable to parameter of type '{ readonly avatar: { readonly large: string | null | undefined; readonly medium: string | null | undefined; readonly small: string | null | undefined; readonly xsmall: string | null | undefined; } | null | undefined; readonly id: string; readonly issueType: { ...; } | ... 1 more ... | undefined; readonly name: strin...'.
        value: $cd769e66cd433490$var$transformRequestTypeToLegacy(node.requestType),
        schema: {
            configuration: null,
            custom: (0, $814y1.REQUEST_TYPE_CF_TYPE),
            items: null,
            renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
            system: null,
            type: 'sd-customerrequesttype'
        }
    };
};

});

parcelRegister("8H6KM", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMRespondersToLegacyField", () => $eb05aff33486cf5e$export$5171c4d1ae5bcde5);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $eb05aff33486cf5e$var$transformJiraResponderToLegacyResponder = (responder)=>{
    if (responder == null) return undefined;
    switch(responder.__typename){
        case 0, $814y1.JSM_USER_RESPONDER_GQL_FIELD:
            if (responder.user === null) return undefined;
            return {
                // @ts-expect-error - 'responder.user' is possibly 'undefined'.
                ari: responder.user.canonicalAccountId,
                // @ts-expect-error - 'responder.user' is possibly 'undefined'.
                avatarUrl: responder.user.picture,
                // @ts-expect-error - 'responder.user' is possibly 'undefined'.
                name: responder.user.name,
                type: 'user'
            };
        case 0, $814y1.JSM_TEAM_RESPONDER_FIELD:
            return {
                // @ts-expect-error - Type 'string | null | undefined' is not assignable to type 'string | null'.
                ari: responder.teamId,
                // @ts-expect-error - Type 'string | null | undefined' is not assignable to type 'string | null'.
                name: responder.teamName,
                type: 'team'
            };
        default:
            return undefined;
    }
};
const $eb05aff33486cf5e$export$5171c4d1ae5bcde5 = (node)=>{
    if (node.type !== (0, $814y1.RESPONDERS_CF_TYPE)) return undefined;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        autoCompleteUrl: node.searchUrl != null ? `${node.searchUrl}?query=` : null,
        value: (0, $8Tw1Q.transformAggConnection)(node.respondersConnection, $eb05aff33486cf5e$var$transformJiraResponderToLegacyResponder),
        schema: {
            configuration: null,
            custom: (0, $814y1.RESPONDERS_CF_TYPE),
            items: (0, $814y1.ISSUE_FIELD_STRING_CF_TYPE),
            renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("iyjVB", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMSentimentToLegacyField", () => $6924b07eb4bc26b7$export$702d3754a4c7d90a);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $6924b07eb4bc26b7$export$702d3754a4c7d90a = (node)=>{
    if (node.type !== (0, $814y1.SENTIMENT_CF_TYPE)) return undefined;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: node.sentiment,
        schema: {
            configuration: null,
            custom: (0, $814y1.SENTIMENT_CF_TYPE),
            items: (0, $814y1.ISSUE_FIELD_STRING_CF_TYPE),
            renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("lMiiC", function(module, exports) {

$parcel$export(module.exports, "transformAggLabelsNodeToLegacyField", () => $b41f86ecf5e4d228$export$98e4f56e2e6c44fe);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $b41f86ecf5e4d228$var$defaultSchema = {
    configuration: null,
    items: 'string',
    type: (0, $814y1.ISSUE_FIELD_MULTI_SELECT_CF_TYPE),
    renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f)
};
const $b41f86ecf5e4d228$export$98e4f56e2e6c44fe = (node)=>{
    const selectedLabels = (0, $8Tw1Q.transformAggConnection)(node.selectedLabelsConnection, ({ name: name })=>name);
    switch(node.type){
        case 0, $814y1.LABELS_TYPE:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return {
                ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
                value: selectedLabels,
                schema: {
                    ...$b41f86ecf5e4d228$var$defaultSchema,
                    custom: null,
                    system: node.type
                }
            };
        case 0, $814y1.LABELS_CF_TYPE:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return {
                ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
                // empty value for custom labels field is null while system labels field is `[]`
                value: selectedLabels.length === 0 ? null : selectedLabels,
                schema: {
                    ...$b41f86ecf5e4d228$var$defaultSchema,
                    custom: node.type,
                    system: null
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("gFEWP", function(module, exports) {

$parcel$export(module.exports, "transformAggMultiGroupPickerToLegacyField", () => $643b7d371a35e493$export$f968da580693597d);


var $8Tw1Q = parcelRequire("8Tw1Q");
const $643b7d371a35e493$export$f968da580693597d = (node)=>{
    const value = (0, $8Tw1Q.transformAggConnection)(node.selectedGroupsConnection, (groupNode)=>({
            groupId: groupNode.groupId,
            name: groupNode.name
        }));
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: value.length > 0 ? value : null,
        schema: {
            type: 'array',
            renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
            custom: node.type,
            system: null,
            items: 'group',
            configuration: null
        }
    };
};

});

parcelRegister("a0aZw", function(module, exports) {

$parcel$export(module.exports, "transformAggMultipleSelectToLegacyField", () => $3dd5c1f07e748aa4$export$869fb8fbcb97e0ee);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $3dd5c1f07e748aa4$export$869fb8fbcb97e0ee = (node)=>{
    switch(node.type){
        case 0, $814y1.MULTI_SELECT_CF_TYPE:
            {
                const value = (0, $8Tw1Q.transformAggConnection)(node.selectedOptions, (option)=>({
                        id: option.optionId,
                        value: option.value ?? null,
                        ari: option.id
                    }));
                return {
                    ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
                    value: value.length ? value : null,
                    allowedValues: [],
                    schema: {
                        type: 'array',
                        renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
                        custom: node.type,
                        system: null,
                        items: 'option',
                        configuration: null
                    }
                };
            }
        default:
            return undefined;
    }
};

});

parcelRegister("7pxBz", function(module, exports) {

$parcel$export(module.exports, "transformAggMultipleUserPickerToLegacyField", () => $32440852381c3dc7$export$cdd9991119eb040e);

var $ln6Iy = parcelRequire("ln6Iy");


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");

var $gtUzp = parcelRequire("gtUzp");

var $74RuE = parcelRequire("74RuE");
const $32440852381c3dc7$export$cdd9991119eb040e = (node, projectContext)=>{
    const value = (0, $8Tw1Q.transformAggConnection)(node.selectedUsersConnection, (0, $74RuE.transformJiraUserToLegacyServerUser));
    const legacyFieldValues = {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: value.length > 0 ? value : null,
        schema: {
            configuration: null,
            custom: node.type,
            items: 'user',
            renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
    switch(node.type){
        case 0, $814y1.REQUEST_PARTICIPANTS_CF_TYPE:
            if (node.__typename === (0, $814y1.MULTI_USER_PICKER_GQL_FIELD)) return {
                ...legacyFieldValues,
                value: value
            };
            if ((0, $gtUzp.getProjectType)(projectContext?.projectType) !== (0, $ln6Iy.SERVICE_DESK_PROJECT)) return undefined;
            // Empty array is the expected value when there are no request
            // participants.
            return {
                ...legacyFieldValues,
                value: value
            };
        case 0, $814y1.PARTICIPANTS_CF_TYPE:
        case 0, $814y1.MULTI_USER_CF_TYPE:
            return legacyFieldValues;
        case 0, $814y1.APPROVERS_LIST_CF_TYPE:
        case 0, $814y1.PEOPLE_CF_TYPE:
            {
                const schemaConfig = 'isMulti' in node && node.isMulti != null ? [
                    {
                        key: 'isMulti',
                        value: String(node.isMulti)
                    }
                ] : null;
                return {
                    ...legacyFieldValues,
                    autoCompleteUrl: node.searchUrl,
                    schema: {
                        ...legacyFieldValues.schema,
                        configuration: schemaConfig
                    }
                };
            }
        default:
            return undefined;
    }
};

});
parcelRegister("gtUzp", function(module, exports) {

$parcel$export(module.exports, "getProjectType", () => $ccb6368d5f105ec2$export$3dd0da95519c1a33);
$parcel$export(module.exports, "getProjectField", () => $ccb6368d5f105ec2$export$b19207d974ad5e77);
$parcel$export(module.exports, "getSystemAggJiraProject", () => $ccb6368d5f105ec2$export$d100105d56da4a0a);
$parcel$export(module.exports, "isAggJiraProjectClassic", () => $ccb6368d5f105ec2$export$3502ed01c034e451);
$parcel$export(module.exports, "transformAggSystemProjectToProjectContext", () => $ccb6368d5f105ec2$export$77162d1422f22f47);
$parcel$export(module.exports, "transformAggProjectToLegacyField", () => $ccb6368d5f105ec2$export$30c14b802399f417);

var $ln6Iy = parcelRequire("ln6Iy");

var $7jTnu = parcelRequire("7jTnu");



var $814y1 = parcelRequire("814y1");

var $ljej9 = parcelRequire("ljej9");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $ccb6368d5f105ec2$var$getProjectStatus = (status)=>{
    switch(status){
        case 'ACTIVE':
            return 0, $9ac759e54cf0eba0$export$62113557945f790a;
        case 'ARCHIVED':
            return 0, $9ac759e54cf0eba0$export$4ccc35479ba9ad1;
        case 'DELETED':
            return 0, $9ac759e54cf0eba0$export$a95d71e582b8bc0;
        default:
            // Based on `getProjectStatus` from src/packages/issue/issue-view/src/common/service/issue/issue-transformer.js
            return 0, $9ac759e54cf0eba0$export$62113557945f790a;
    }
};
const $ccb6368d5f105ec2$export$3dd0da95519c1a33 = (projectType)=>{
    if (projectType === 'CUSTOMER_SERVICE' && (0, $7jTnu.fg)('jcs_project_type_m3')) return 0, $ln6Iy.CUSTOMER_SERVICE_PROJECT;
    switch(projectType){
        case 'SERVICE_DESK':
            return 0, $ln6Iy.SERVICE_DESK_PROJECT;
        case 'BUSINESS':
            return 0, $ln6Iy.CORE_PROJECT;
        case 'SOFTWARE':
            return 0, $ln6Iy.SOFTWARE_PROJECT;
        case 'PRODUCT_DISCOVERY':
            return 0, $ln6Iy.PRODUCT_DISCOVERY_PROJECT;
        default:
            return null;
    }
};
const $ccb6368d5f105ec2$export$b19207d974ad5e77 = (fields)=>{
    /**
	 * The only way to get the type to return an optional value with `AggJiraProject` type
	 * is to re-assign the type wihtout throwing an error.
	 */ // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return fields?.find((edge)=>edge?.node?.__typename === (0, $814y1.PROJECT_GQL_FIELD) && edge?.node?.type != null && edge.node.type === (0, $814y1.PROJECT_TYPE))?.node;
};
const $ccb6368d5f105ec2$export$d100105d56da4a0a = (fields)=>{
    /**
	 * We only want the system `PROJECT_TYPE` field.
	 * For custom fields, e.g., project picker, see `transformAggProjectToLegacyField`
	 */ const projectField = $ccb6368d5f105ec2$export$b19207d974ad5e77(fields);
    // Needs the `PROJECT_GQL_FIELD` refinement so we can return as `AggJiraProject`
    if (projectField == null || projectField.__typename !== (0, $814y1.PROJECT_GQL_FIELD)) throw new Error(`Failed to get system project data: ${(0, $814y1.PROJECT_GQL_FIELD)} with ${(0, $814y1.PROJECT_TYPE)} 'fieldId' and 'type' not found [${JSON.stringify(fields ?? '')}]`);
    if (projectField.project == null) throw new Error(`Failed to get system project data: ${(0, $814y1.PROJECT_GQL_FIELD)}.project is missing [${JSON.stringify(projectField)}]`);
    return projectField.project;
};
const $ccb6368d5f105ec2$export$f7d5cb97957d02e3 = (project)=>project?.projectStyle === 'TEAM_MANAGED_PROJECT';
const $ccb6368d5f105ec2$export$3502ed01c034e451 = (project)=>!$ccb6368d5f105ec2$export$f7d5cb97957d02e3(project);
const $ccb6368d5f105ec2$var$transformAggProjectToServerProjectOption = (project)=>{
    if (project == null) return null;
    const { projectId: projectId, key: key, name: name, avatar: avatar } = project;
    return {
        name: name,
        id: projectId ?? undefined,
        key: (0, $ljej9.toProjectKey)(key),
        avatarUrls: {
            '48x48': avatar?.large || ''
        }
    };
};
const $ccb6368d5f105ec2$export$77162d1422f22f47 = (project)=>{
    const { projectId: projectId, name: name, key: key, avatar: avatar, status: status, projectType: type, navigationMetadata: navigationMetadata } = project;
    const projectType = $ccb6368d5f105ec2$export$3dd0da95519c1a33(type);
    if (!projectId || !projectType) throw new Error(`Failed to transform system project: projectId ${projectId} and projectType ${String(type)} was invalid`);
    return {
        projectId: projectId,
        projectType: projectType,
        projectName: name,
        projectKey: key,
        projectStatus: $ccb6368d5f105ec2$var$getProjectStatus(status),
        avatarUrl: avatar?.medium,
        isSimplified: $ccb6368d5f105ec2$export$f7d5cb97957d02e3(project),
        boardId: navigationMetadata?.boardId
    };
};
const $ccb6368d5f105ec2$export$275f121d4e6f5165 = (fields)=>{
    const project = $ccb6368d5f105ec2$export$d100105d56da4a0a(fields);
    return $ccb6368d5f105ec2$export$77162d1422f22f47(project);
};
const $ccb6368d5f105ec2$var$transformAggProjectToLegacyProjectPickerField = (node)=>({
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        allowedValues: [],
        value: $ccb6368d5f105ec2$var$transformAggProjectToServerProjectOption(node.project),
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
            type: (0, $814y1.PROJECT_TYPE),
            custom: (0, $814y1.PROJECT_PICKER_CF_TYPE),
            system: null
        }
    });
const $ccb6368d5f105ec2$var$transformAggProjectToLegacySimilarIssuesField = (node)=>{
    // Similar issues field only exist in JSM projects
    if ($ccb6368d5f105ec2$export$3dd0da95519c1a33(node.project?.projectType) !== (0, $ln6Iy.SERVICE_DESK_PROJECT)) return undefined;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        key: (0, $814y1.SIMILAR_ISSUES_TYPE),
        title: (0, $814y1.SIMILAR_ISSUES_TYPE),
        value: node.project?.similarIssues?.featureEnabled === true,
        schema: {
            configuration: null,
            items: null,
            renderer: null,
            type: (0, $814y1.SIMILAR_ISSUES_TYPE),
            custom: null,
            system: (0, $814y1.SIMILAR_ISSUES_TYPE)
        }
    };
};
const $ccb6368d5f105ec2$var$transformAggProjectToLegacyProjectField = (node)=>{
    if (node?.__typename !== (0, $814y1.PROJECT_GQL_FIELD) || node?.type === null || node?.type !== (0, $814y1.PROJECT_TYPE)) throw new Error(`Failed to get system project data: ${(0, $814y1.PROJECT_GQL_FIELD)} with ${(0, $814y1.PROJECT_TYPE)} 'fieldId' and 'type' not found [${JSON.stringify(node)}]`);
    const projectField = node;
    if (projectField == null || projectField.__typename !== (0, $814y1.PROJECT_GQL_FIELD)) throw new Error(`Failed to get system project data: ${(0, $814y1.PROJECT_GQL_FIELD)} with ${(0, $814y1.PROJECT_TYPE)} 'fieldId' and 'type' not found [${JSON.stringify(node ?? '')}]`);
    if (projectField.project == null) throw new Error(`Failed to get system project data: ${(0, $814y1.PROJECT_GQL_FIELD)}.project is missing [${JSON.stringify(projectField)}]`);
    const project = projectField.project;
    const { projectType: type } = project;
    const projectType = $ccb6368d5f105ec2$export$3dd0da95519c1a33(type);
    if (projectType == null) throw new Error(`Failed to transform project: projectType ${String(project?.projectType)} was invalid`);
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: {
            projectType: projectType
        }
    };
};
const $ccb6368d5f105ec2$var$transformAggProjectToLegacyFieldByType = (node)=>{
    const projectType = $ccb6368d5f105ec2$export$3dd0da95519c1a33(node.project?.projectType);
    if (projectType === (0, $ln6Iy.SERVICE_DESK_PROJECT)) // Similar issues field only exist in JSM projects
    return $ccb6368d5f105ec2$var$transformAggProjectToLegacySimilarIssuesField(node);
    if (projectType === (0, $ln6Iy.PRODUCT_DISCOVERY_PROJECT)) return $ccb6368d5f105ec2$var$transformAggProjectToLegacyProjectField(node);
    return undefined;
};
const $ccb6368d5f105ec2$export$30c14b802399f417 = (node)=>{
    if ((0, $7jTnu.fg)('jpd_idea_panel_in_issue_view')) switch(node.type){
        case 0, $814y1.PROJECT_PICKER_CF_TYPE:
            return $ccb6368d5f105ec2$var$transformAggProjectToLegacyProjectPickerField(node);
        case 0, $814y1.PROJECT_TYPE:
            // For the system project, see `transformAggProjectToProjectContext`
            return $ccb6368d5f105ec2$var$transformAggProjectToLegacyFieldByType(node);
        default:
            return undefined;
    }
    else switch(node.type){
        case 0, $814y1.PROJECT_PICKER_CF_TYPE:
            return $ccb6368d5f105ec2$var$transformAggProjectToLegacyProjectPickerField(node);
        case 0, $814y1.PROJECT_TYPE:
            // For the system project, see `transformAggProjectToProjectContext`
            return $ccb6368d5f105ec2$var$transformAggProjectToLegacySimilarIssuesField(node);
        default:
            return undefined;
    }
};

});
const $9ac759e54cf0eba0$export$62113557945f790a = 'PROJECT_ACTIVE';
const $9ac759e54cf0eba0$export$4ccc35479ba9ad1 = 'PROJECT_ARCHIVED';
const $9ac759e54cf0eba0$export$a95d71e582b8bc0 = 'PROJECT_TRASHED';



parcelRegister("dAiWn", function(module, exports) {

$parcel$export(module.exports, "transformAggMultipleVersionPickerToLegacyField", () => $e7bc731374bc7784$export$6207ea60703068d8);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");

var $dVGVP = parcelRequire("dVGVP");
const $e7bc731374bc7784$var$defaultSchema = {
    configuration: null,
    custom: null,
    items: 'version',
    renderer: (0, $6e3c8900fd92f5d7$export$840ed33fa94f7693),
    system: null,
    type: 'array'
};
const $e7bc731374bc7784$export$6207ea60703068d8 = (node)=>{
    if (node.type !== (0, $814y1.MULTI_VERSION_CF_TYPE) && node.type !== (0, $814y1.AFFECTS_VERSIONS_TYPE) && node.type !== (0, $814y1.FIX_VERSIONS_TYPE)) return undefined;
    const legacyFieldValues = {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        allowedValues: [],
        value: (0, $8Tw1Q.transformAggConnection)(node.selectedVersionsConnection, (0, $dVGVP.transformAggVersionToLegacyVersion))
    };
    switch(node.type){
        case 0, $814y1.MULTI_VERSION_CF_TYPE:
            return {
                ...legacyFieldValues,
                value: legacyFieldValues.value.length === 0 ? null : legacyFieldValues.value,
                schema: {
                    ...$e7bc731374bc7784$var$defaultSchema,
                    custom: (0, $814y1.MULTI_VERSION_CF_TYPE)
                }
            };
        case 0, $814y1.AFFECTS_VERSIONS_TYPE:
        case 0, $814y1.FIX_VERSIONS_TYPE:
            return {
                ...legacyFieldValues,
                schema: {
                    ...$e7bc731374bc7784$var$defaultSchema,
                    system: node.type
                }
            };
        default:
            return undefined;
    }
};

});
parcelRegister("dVGVP", function(module, exports) {

$parcel$export(module.exports, "transformAggVersionToLegacyVersion", () => $6d5aa6e85a56b096$export$becef8d087e8b62b);

var $be4Fs = parcelRequire("be4Fs");
const $6d5aa6e85a56b096$export$becef8d087e8b62b = (version)=>({
        id: version.versionId ?? '',
        name: version.name ?? '',
        description: version.description ?? '',
        archived: version.status === (0, $be4Fs.VersionStatus).ARCHIVED,
        released: version.status === (0, $be4Fs.VersionStatus).RELEASED,
        ari: version.id
    });

});
parcelRegister("be4Fs", function(module, exports) {

$parcel$export(module.exports, "VersionStatus", () => $5bceeeaddd71111f$export$8c6e0f93bfb5c6a4);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports




var $hj7L9 = parcelRequire("hj7L9");


const $5bceeeaddd71111f$export$8c6e0f93bfb5c6a4 = {
    ARCHIVED: 'ARCHIVED',
    RELEASED: 'RELEASED',
    UNRELEASED: 'UNRELEASED'
};

});



parcelRegister("a6vLL", function(module, exports) {

$parcel$export(module.exports, "transformAggNumberToLegacyField", () => $d06856cdc1673eac$export$d754a24ed0096d2f);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $d06856cdc1673eac$export$d754a24ed0096d2f = (node)=>{
    const fieldType = node.isStoryPointField === true ? (0, $814y1.STORY_POINTS_TYPE) : node.type;
    switch(fieldType){
        case 0, $814y1.NUMBER_CF_TYPE:
        case 0, $814y1.STORY_POINT_ESTIMATE_CF_TYPE:
        case 0, $814y1.STORY_POINTS_TYPE:
            return {
                ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
                value: node.number ?? null,
                schema: {
                    configuration: null,
                    items: null,
                    renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
                    custom: fieldType,
                    system: null,
                    type: (0, $814y1.ISSUE_FIELD_NUMBER_CF_TYPE)
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("gECU8", function(module, exports) {

$parcel$export(module.exports, "transformAggOriginalEstimateToLegacyField", () => $b90b41b6702a4488$export$f08d02fdc74f920e);

var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $b90b41b6702a4488$export$f08d02fdc74f920e = (node)=>{
    if (node.type !== (0, $814y1.TIME_ESTIMATE_TYPE)) return undefined;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: node.originalEstimate?.timeInSeconds ?? null,
        schema: {
            configuration: null,
            custom: null,
            system: node.type,
            items: null,
            type: (0, $814y1.ISSUE_FIELD_NUMBER_CF_TYPE),
            renderer: null
        }
    };
};

});

parcelRegister("c8gRg", function(module, exports) {

$parcel$export(module.exports, "transformAggPriorityToLegacyField", () => $e1ebf74a07d64a5c$export$9e966ce605f800d2);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $e1ebf74a07d64a5c$var$transformJiraPriorityToLegacyPriority = (priority)=>{
    if (priority == null) return null;
    return {
        id: priority.priorityId,
        iconUrl: String(priority.iconUrl || ''),
        name: priority.name || '',
        sequence: priority.sequence || undefined
    };
};
const $e1ebf74a07d64a5c$export$9e966ce605f800d2 = (node)=>{
    if (node.type !== (0, $814y1.PRIORITY_TYPE)) return undefined;
    const allowedValues = (0, $8Tw1Q.transformAggConnection)('priorities' in node ? node.priorities : null, $e1ebf74a07d64a5c$var$transformJiraPriorityToLegacyPriority);
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        allowedValues: allowedValues,
        // @ts-expect-error - Argument of type '{ readonly color: string | null | undefined; readonly iconUrl: string | null | undefined; readonly name: string | null | undefined; readonly priorityId: string; } | { readonly iconUrl: string | ... 1 more ... | undefined; readonly name: string | ... 1 more ... | undefined; readonly priorityId: string; } | { ...; } |...' is not assignable to parameter of type 'AggJiraPriority | null'.
        value: $e1ebf74a07d64a5c$var$transformJiraPriorityToLegacyPriority(node.priority),
        schema: {
            type: (0, $814y1.PRIORITY_TYPE),
            custom: null,
            system: (0, $814y1.PRIORITY_TYPE),
            configuration: null,
            items: null,
            renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f)
        }
    };
};

});

parcelRegister("1exBo", function(module, exports) {

$parcel$export(module.exports, "transformAggProformaFormsToLegacyField", () => $8e8dae50d765b259$export$fdcdbf17b0d4e36f);

var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $8e8dae50d765b259$export$fdcdbf17b0d4e36f = (node)=>{
    if (node.type !== (0, $814y1.PROFORMA_FORMS)) return undefined;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: node.proformaForms,
        schema: {
            configuration: null,
            items: null,
            system: (0, $814y1.PROFORMA_FORMS),
            custom: null,
            renderer: null,
            type: (0, $814y1.PROFORMA_FORMS)
        }
    };
};

});

parcelRegister("5iFQF", function(module, exports) {

$parcel$export(module.exports, "transformAggRadioSelectToLegacyField", () => $c9221aeb6fc8fb91$export$f147f1eb3a15ccfc);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $c9221aeb6fc8fb91$export$f147f1eb3a15ccfc = (node)=>{
    if (node.type !== (0, $814y1.RADIO_BUTTONS_CF_TYPE)) return undefined;
    const value = node.selectedOption ? {
        id: node.selectedOption?.optionId,
        value: node.selectedOption?.value,
        isDisabled: node.selectedOption?.isDisabled
    } : null;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            type: 'option',
            renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
            custom: node.type,
            system: null,
            items: null,
            configuration: null
        }
    };
};

});

parcelRegister("dSS0X", function(module, exports) {

$parcel$export(module.exports, "transformAggResolutionToLegacyField", () => $7eee2703929d5623$export$179f600c7e1d0230);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $7eee2703929d5623$var$resolutionTransformer = (resolution)=>{
    if (resolution == null) return null;
    return {
        id: resolution.resolutionId,
        name: resolution.name || ''
    };
};
const $7eee2703929d5623$export$179f600c7e1d0230 = (node)=>{
    if (node.type !== (0, $814y1.RESOLUTION_TYPE)) return undefined;
    const value = $7eee2703929d5623$var$resolutionTransformer(node.resolution);
    const allowedValues = (0, $8Tw1Q.transformAggConnection)(node.resolutions, $7eee2703929d5623$var$resolutionTransformer);
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: value,
        allowedValues: allowedValues,
        schema: {
            type: (0, $814y1.RESOLUTION_TYPE),
            renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
            custom: null,
            system: (0, $814y1.RESOLUTION_TYPE),
            items: null,
            configuration: null
        }
    };
};

});

parcelRegister("hpJ0s", function(module, exports) {

$parcel$export(module.exports, "transformAggRichTextToLegacyField", () => $f231e7baf13c7424$export$e65ff2ce94be106e);

var $clRM1 = parcelRequire("clRM1");


var $814y1 = parcelRequire("814y1");

var $dk7W5 = parcelRequire("dk7W5");

var $8Tw1Q = parcelRequire("8Tw1Q");

var $h9Xzk = parcelRequire("h9Xzk");
const $f231e7baf13c7424$var$emptyAdfObject = (0, $clRM1.getEmptyADF)();
const $f231e7baf13c7424$var$getSchema = (aggType, renderer)=>{
    switch(aggType){
        case 0, $814y1.TEXT_AREA_CF_TYPE:
            return {
                custom: aggType,
                renderer: renderer,
                type: (0, $814y1.ISSUE_FIELD_STRING_CF_TYPE),
                system: null,
                configuration: null,
                items: null
            };
        case 0, $814y1.DESCRIPTION_TYPE:
        case 0, $814y1.ENVIRONMENT_TYPE:
        default:
            return {
                system: aggType,
                renderer: renderer,
                type: (0, $814y1.ISSUE_FIELD_STRING_CF_TYPE),
                custom: null,
                configuration: null,
                items: null
            };
    }
};
// Exactly match the legacy /graphql value, handling the case where the field is empty and has never been edited
// There's no functional difference between `null` or empty string when rendering the field in the issue view.
const $f231e7baf13c7424$var$getPlainTextValue = (node)=>{
    // When the field is empty and a value has never been set
    if (!node.richText) return null;
    // When the field has been set to a value, and then set back to empty
    if (node.richText?.plainText == null) return '';
    return node.richText?.plainText;
};
const $f231e7baf13c7424$export$e65ff2ce94be106e = (node)=>{
    // Description field always renders with ADF
    const { renderer: renderer } = node;
    if ((0, $h9Xzk.default)(node)) return undefined;
    const isPlainTextRenderer = node.type !== (0, $814y1.DESCRIPTION_TYPE) && renderer === (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f);
    if (isPlainTextRenderer) return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: $f231e7baf13c7424$var$getPlainTextValue(node),
        schema: $f231e7baf13c7424$var$getSchema(node.type, renderer)
    };
    const adfValueJson = node.richText?.adfValue?.json ?? null;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        // The usages of the collection is deprecated.
        adfValue: adfValueJson ? (0, $dk7W5.removeCollectionFromAdf)(adfValueJson) : $f231e7baf13c7424$var$emptyAdfObject,
        value: null,
        schema: $f231e7baf13c7424$var$getSchema(node.type, renderer)
    };
};

});

parcelRegister("8plR2", function(module, exports) {

$parcel$export(module.exports, "transformAggSecurityLevelToLegacyField", () => $d33aa6cc7441217e$export$45e25e2a6750ea5a);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $d33aa6cc7441217e$var$transformJiraSecurityLevel = (securityLevel)=>{
    if (securityLevel == null) return null;
    return {
        id: securityLevel.securityId,
        description: securityLevel.description || '',
        name: securityLevel.name || ''
    };
};
const $d33aa6cc7441217e$export$45e25e2a6750ea5a = (node)=>({
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: $d33aa6cc7441217e$var$transformJiraSecurityLevel(node.securityLevel),
        allowedValues: (0, $8Tw1Q.transformAggConnection)(node.securityLevels, $d33aa6cc7441217e$var$transformJiraSecurityLevel),
        schema: {
            configuration: null,
            type: (0, $814y1.SECURITY_LEVEL_TYPE_OVERRIDE),
            renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
            custom: null,
            system: (0, $814y1.SECURITY_LEVEL_TYPE),
            items: null
        }
    });

});

parcelRegister("92N3i", function(module, exports) {

$parcel$export(module.exports, "transformAggSingleGroupPickerToLegacyField", () => $8b96c0b3204c894a$export$e6697ec5bdac9ec0);


var $8Tw1Q = parcelRequire("8Tw1Q");
const $8b96c0b3204c894a$export$e6697ec5bdac9ec0 = (node)=>{
    const value = node.selectedGroup != null ? {
        groupId: node.selectedGroup.groupId,
        name: node.selectedGroup.name
    } : null;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            type: 'group',
            renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
            custom: node.type,
            system: null,
            items: null,
            configuration: null
        }
    };
};

});

parcelRegister("lR2em", function(module, exports) {

$parcel$export(module.exports, "transformAggSingleLineTextToLegacyField", () => $659d7d4b8257722d$export$31f32b3fd9e5ab6);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $659d7d4b8257722d$var$defaultSchema = {
    configuration: null,
    items: null,
    renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f)
};
const $659d7d4b8257722d$export$31f32b3fd9e5ab6 = (node)=>{
    const defaultTransformedField = {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: node.text
    };
    switch(node.type){
        case 0, $814y1.EPIC_NAME_TYPE:
        case 0, $814y1.MESSAGE_EDIT_CF_TYPE:
        case 0, $814y1.MESSAGE_VIEW_CF_TYPE:
        case 0, $814y1.READ_ONLY_CF_TYPE:
        case 0, $814y1.TEXT_CF_TYPE:
        case 0, $814y1.USER_PROPERTY_CF_TYPE:
            return {
                ...defaultTransformedField,
                schema: {
                    ...$659d7d4b8257722d$var$defaultSchema,
                    custom: node.type,
                    system: null,
                    type: (0, $814y1.ISSUE_FIELD_STRING_CF_TYPE)
                }
            };
        case 0, $814y1.RANK_CF_TYPE:
            return {
                ...defaultTransformedField,
                schema: {
                    ...$659d7d4b8257722d$var$defaultSchema,
                    custom: node.type,
                    system: null,
                    type: (0, $814y1.ISSUE_FIELD_ANY_CF_TYPE)
                }
            };
        case 0, $814y1.SUMMARY_TYPE:
            return {
                ...defaultTransformedField,
                schema: {
                    ...$659d7d4b8257722d$var$defaultSchema,
                    type: (0, $814y1.ISSUE_FIELD_STRING_CF_TYPE),
                    custom: null,
                    system: node.type
                }
            };
        case 0, $814y1.SERVICEDESK_PRACTICES_TYPE:
            // Transform field only if the practice has a value
            return node.text != null ? {
                ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
                value: [
                    node.text
                ],
                schema: {
                    ...$659d7d4b8257722d$var$defaultSchema,
                    renderer: null,
                    custom: null,
                    system: node.type,
                    type: (0, $814y1.SERVICEDESK_PRACTICES_TYPE)
                }
            } : undefined;
        default:
            return undefined;
    }
};

});

parcelRegister("9dsiy", function(module, exports) {

$parcel$export(module.exports, "transformAggSingleSelectToLegacyField", () => $1f5f63ca883225b4$export$4e113f935e09d226);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $1f5f63ca883225b4$var$getField = (node, customType)=>{
    const value = node.fieldOption != null ? {
        ari: node.fieldOption.id,
        id: node.fieldOption.optionId,
        value: node.fieldOption.value
    } : null;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            type: 'option',
            renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
            custom: customType || node.type,
            system: null,
            items: null,
            configuration: null
        }
    };
};
const $1f5f63ca883225b4$export$4e113f935e09d226 = (node)=>{
    switch(node.type){
        case 0, $814y1.EPIC_STATUS_TYPE:
        case 0, $814y1.SELECT_CF_TYPE:
            return $1f5f63ca883225b4$var$getField(node);
        case 0, $814y1.CATEGORY_TYPE:
            return $1f5f63ca883225b4$var$getField(node, (0, $814y1.SELECT_CF_TYPE));
        default:
            return undefined;
    }
};

});

parcelRegister("2eP7x", function(module, exports) {

$parcel$export(module.exports, "transformAggSingleSelectUserPickerToLegacyField", () => $b86adefd697ce3f4$export$7bf73fc06c6d71be);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");

var $74RuE = parcelRequire("74RuE");
const $b86adefd697ce3f4$export$7bf73fc06c6d71be = (node)=>{
    const legacyField = {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: node.user ? (0, $74RuE.transformJiraUserToLegacyServerUser)(node.user) : null
    };
    switch(node.type){
        case 0, $814y1.ASSIGNEE_TYPE:
        case 0, $814y1.REPORTER_TYPE:
            return {
                ...legacyField,
                schema: {
                    type: (0, $814y1.ISSUE_FIELD_USER_CF_TYPE),
                    custom: null,
                    system: node.type,
                    renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
                    configuration: null,
                    items: null
                }
            };
        case 0, $814y1.USER_CF_TYPE:
        case 0, $814y1.LAST_UPDATER_OR_COMMENTER_CF_TYPE:
            return {
                ...legacyField,
                schema: {
                    type: (0, $814y1.ISSUE_FIELD_USER_CF_TYPE),
                    custom: node.type,
                    system: null,
                    renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
                    configuration: null,
                    items: null
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("ksE6r", function(module, exports) {

$parcel$export(module.exports, "transformAggSingleVersionPickerToLegacyField", () => $fa047c4e6c9f5935$export$d03f622577260442);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");

var $dVGVP = parcelRequire("dVGVP");
const $fa047c4e6c9f5935$export$d03f622577260442 = (node)=>{
    if (node.type !== (0, $814y1.VERSION_CF_TYPE)) return undefined;
    const allowedValues = (0, $8Tw1Q.transformAggConnection)(null, (0, $dVGVP.transformAggVersionToLegacyVersion));
    const value = node.version ? (0, $dVGVP.transformAggVersionToLegacyVersion)(node.version) : null;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        allowedValues: allowedValues,
        value: value,
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
            type: (0, $814y1.ISSUE_FIELD_VERSION_CF_TYPE),
            custom: (0, $814y1.VERSION_CF_TYPE),
            system: null
        }
    };
};

});

parcelRegister("dN5mk", function(module, exports) {

$parcel$export(module.exports, "transformAggSprintToLegacyField", () => $01a8b99e170d26ed$export$9b5bb05d50970021);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $01a8b99e170d26ed$var$SprintOptionalKeyMap = {
    goal: 'goal',
    completeDate: 'completionDate',
    startDate: 'startDate',
    endDate: 'endDate'
};
const $01a8b99e170d26ed$var$transformAggSprintToLegacySprint = (sprint)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const optionalValues = {};
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    Object.keys($01a8b99e170d26ed$var$SprintOptionalKeyMap).forEach((key)=>{
        const aggKey = $01a8b99e170d26ed$var$SprintOptionalKeyMap[key];
        const aggValue = sprint[aggKey];
        if (aggValue !== undefined && aggValue !== null) optionalValues[key] = aggValue;
    });
    return {
        id: Number(sprint.sprintId),
        name: sprint?.name ?? '',
        state: sprint.state?.toLowerCase(),
        boardId: Number(sprint.boardName) || 0,
        ...optionalValues
    };
};
const $01a8b99e170d26ed$export$9b5bb05d50970021 = (node)=>{
    if (node.type !== (0, $814y1.SPRINT_TYPE)) return undefined;
    const sprints = (0, $8Tw1Q.transformAggConnection)(node.selectedSprintsConnection, $01a8b99e170d26ed$var$transformAggSprintToLegacySprint);
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: sprints,
        schema: {
            configuration: null,
            custom: (0, $814y1.SPRINT_TYPE),
            items: 'json',
            renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("2CpT2", function(module, exports) {

$parcel$export(module.exports, "getStatusesDeprecatedValue", () => $f310693121110726$export$b80ec59d806c2f94);
$parcel$export(module.exports, "transformAggStatusToLegacyField", () => $f310693121110726$export$c80e5acb1c882c48);

var $7keuM = parcelRequire("7keuM");

var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $f310693121110726$export$b80ec59d806c2f94 = (fields)=>{
    const { status: status } = fields;
    if (!status || status.value == null) return {};
    const { value: value } = status;
    return {
        [value.id]: {
            id: value.id,
            name: value.name,
            statusCategory: (0, $7keuM.statusCategoryForId)(value.statusCategory?.id)
        }
    };
};
const $f310693121110726$var$transformJiraStatusToLegacyStatus = (status)=>{
    if (!status || !status.statusCategory) return null;
    const { statusCategory: statusCategory } = status;
    return {
        id: status.statusId,
        name: status.name || '',
        statusCategory: {
            id: Number(statusCategory.statusCategoryId)
        }
    };
};
const $f310693121110726$export$c80e5acb1c882c48 = (node)=>{
    if (node.type !== (0, $814y1.STATUS_TYPE)) return undefined;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: $f310693121110726$var$transformJiraStatusToLegacyStatus(node.status),
        schema: {
            configuration: null,
            items: null,
            renderer: null,
            type: (0, $814y1.STATUS_TYPE),
            custom: null,
            system: (0, $814y1.STATUS_TYPE)
        }
    };
};

});

parcelRegister("4MVer", function(module, exports) {

$parcel$export(module.exports, "transformAggTeamToLegacyField", () => $0bbc3c7042b91d39$export$fb1b80497e96456f);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $0bbc3c7042b91d39$export$fb1b80497e96456f = (node)=>{
    if (node.type !== (0, $814y1.TEAM_CF_TYPE)) return undefined;
    const value = node.selectedTeam ? {
        id: node.selectedTeam.teamId,
        title: node.selectedTeam.name,
        isShared: node.selectedTeam.isShared,
        avatarUrl: node.selectedTeam.avatar?.medium
    } : null;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            configuration: null,
            custom: (0, $814y1.TEAM_CF_TYPE),
            items: null,
            renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
            system: null,
            type: (0, $814y1.ISSUE_FIELD_ANY_CF_TYPE)
        }
    };
};

});

parcelRegister("kPSkL", function(module, exports) {

$parcel$export(module.exports, "transformAggTeamViewToLegacyField", () => $ce17f04c98aba2c2$export$6f6aaafb49bd4769);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $ce17f04c98aba2c2$var$transformAggTeamViewToLegacyTeam = (team)=>{
    if (team == null) return null;
    return {
        id: team.jiraSuppliedTeamId,
        name: team.jiraSuppliedName || '',
        isVisible: team.jiraSuppliedVisibility || false,
        avatarUrl: team.jiraSuppliedAvatar?.xsmall || '',
        isVerified: team.jiraSuppliedIsVerified || false
    };
};
const $ce17f04c98aba2c2$export$6f6aaafb49bd4769 = (node)=>{
    if (node.type !== (0, $814y1.TEAMS_PLATFORM_CF_TYPE)) return undefined;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        // @ts-expect-error - Argument of type '{ readonly jiraSuppliedAvatar: { readonly large: string | null | undefined; readonly medium: string | null | undefined; readonly small: string | null | undefined; readonly xsmall: string | null | undefined; } | null | undefined; readonly jiraSuppliedId: string; readonly jiraSuppliedName: string | ... 1 more ... | un...' is not assignable to parameter of type '{ readonly jiraSuppliedAvatar: { readonly large: string | null | undefined; readonly medium: string | null | undefined; readonly small: string | null | undefined; readonly xsmall: string | null | undefined; } | null | undefined; readonly jiraSuppliedId: string; readonly jiraSuppliedName: string | ... 1 more ... | un...'.
        value: $ce17f04c98aba2c2$var$transformAggTeamViewToLegacyTeam(node.selectedTeam),
        schema: {
            configuration: null,
            custom: (0, $814y1.TEAMS_PLATFORM_CF_TYPE),
            items: null,
            renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
            system: null,
            type: 'team'
        }
    };
};

});

parcelRegister("gpNkV", function(module, exports) {

$parcel$export(module.exports, "transformAggTimeTrackingToLegacyField", () => $ee864f653750a614$export$874d9bd14269ec6f);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $ee864f653750a614$var$getEstimateValues = (estimate, key)=>{
    if (estimate) return {
        [key]: estimate.timeInSeconds || 0
    };
    return {};
};
const $ee864f653750a614$export$874d9bd14269ec6f = (node)=>{
    if (node.type !== (0, $814y1.TIME_TRACKING_TYPE)) return undefined;
    const originalEstimate = $ee864f653750a614$var$getEstimateValues(node.originalEstimate || null, 'originalEstimateSeconds');
    const remainingEstimate = $ee864f653750a614$var$getEstimateValues(node.remainingEstimate || null, 'remainingEstimateSeconds');
    const timeSpent = $ee864f653750a614$var$getEstimateValues(node.timeSpent || null, 'timeSpentSeconds');
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: {
            ...originalEstimate,
            ...remainingEstimate,
            ...timeSpent
        },
        schema: {
            configuration: null,
            custom: null,
            items: null,
            renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
            system: (0, $814y1.TIME_TRACKING_TYPE),
            type: (0, $814y1.TIME_TRACKING_TYPE)
        }
    };
};

});

parcelRegister("jE1Uq", function(module, exports) {

$parcel$export(module.exports, "transformAggUrlToLegacyField", () => $f61b428b363526c3$export$6e950e0ec9801f6c);


var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $f61b428b363526c3$export$6e950e0ec9801f6c = (node)=>{
    if (node.type !== (0, $814y1.URL_CF_TYPE)) return undefined;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: node.uri ?? null,
        schema: {
            configuration: null,
            custom: (0, $814y1.URL_CF_TYPE),
            items: null,
            renderer: (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f),
            system: null,
            type: (0, $814y1.ISSUE_FIELD_STRING_CF_TYPE)
        }
    };
};

});

parcelRegister("btvTF", function(module, exports) {

$parcel$export(module.exports, "transformAggVotesToLegacyField", () => $95434af0f8409f2f$export$8966614b8594736);

var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $95434af0f8409f2f$var$transformAggVoteToLegacyVote = (vote)=>({
        votes: vote.count != null ? Number(vote.count) : 0,
        hasVoted: vote.hasVoted ?? false
    });
const $95434af0f8409f2f$export$8966614b8594736 = (node)=>{
    if (node.type !== (0, $814y1.VOTES_TYPE)) return undefined;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: node.vote ? $95434af0f8409f2f$var$transformAggVoteToLegacyVote(node.vote) : null,
        schema: {
            configuration: null,
            custom: null,
            items: null,
            renderer: null,
            system: (0, $814y1.VOTES_TYPE),
            type: (0, $814y1.VOTES_TYPE)
        }
    };
};

});

parcelRegister("gujad", function(module, exports) {

$parcel$export(module.exports, "transformAggWatchesToLegacyField", () => $e1ddb36e41b722e0$export$6730cb17d10d6156);

var $814y1 = parcelRequire("814y1");

var $8Tw1Q = parcelRequire("8Tw1Q");
const $e1ddb36e41b722e0$var$transformAggWatchesToLegacyWatches = (watch)=>({
        watchCount: watch.count != null ? Number(watch.count) : 0,
        isWatching: watch.isWatching ?? false
    });
const $e1ddb36e41b722e0$export$6730cb17d10d6156 = (node)=>{
    if (node.type !== (0, $814y1.WATCHES_TYPE)) return undefined;
    return {
        ...(0, $8Tw1Q.transformAggNodeToLegacyField)(node),
        value: node.watch ? $e1ddb36e41b722e0$var$transformAggWatchesToLegacyWatches(node.watch) : null,
        schema: {
            configuration: null,
            custom: null,
            items: null,
            renderer: null,
            system: (0, $814y1.WATCHES_TYPE),
            type: (0, $814y1.WATCHES_TYPE)
        }
    };
};

});


parcelRegister("7QMat", function(module, exports) {

$parcel$export(module.exports, "transformAggParentFieldValueToLegacyFieldValue", () => $24cb110b5fbfe797$export$d8a5feb2bb0425b4);
const $24cb110b5fbfe797$export$d8a5feb2bb0425b4 = (parentIssue)=>{
    if (!parentIssue) return null;
    return {
        id: parentIssue.issueId,
        ari: parentIssue.id,
        key: parentIssue.key,
        self: parentIssue.webUrl,
        color: parentIssue.issueColorField?.color?.colorKey,
        fields: {
            summary: parentIssue.summaryField?.text,
            issuetype: {
                name: parentIssue.issueTypeField?.issueType?.name,
                iconUrl: parentIssue.issueTypeField?.issueType?.avatar?.xsmall,
                // We do not have this data
                id: '',
                self: '',
                description: '',
                subtask: false,
                avatarId: 0,
                hierarchyLevel: 0
            }
        }
    };
};

});

parcelRegister("i6YHz", function(module, exports) {

$parcel$export(module.exports, "transformAggRichTextFieldValueToLegacyFieldValue", () => $3ee48b837f83cdcc$export$b3a2c3992977726e);

var $clRM1 = parcelRequire("clRM1");


var $dk7W5 = parcelRequire("dk7W5");
const $3ee48b837f83cdcc$var$emptyAdfObject = (0, $clRM1.getEmptyADF)();
const $3ee48b837f83cdcc$export$b3a2c3992977726e = (richText, renderer)=>{
    if (!renderer) throw new Error('aggFieldChangeProps did not have renderer');
    if (renderer === (0, $6e3c8900fd92f5d7$export$a4a240cb4053b29f)) {
        if (richText.plainText !== undefined) return richText.plainText;
        return richText?.adfValue?.convertedPlainText?.plainText;
    }
    return richText?.adfValue?.json ? (0, $dk7W5.removeCollectionFromAdf)(richText?.adfValue?.json) : $3ee48b837f83cdcc$var$emptyAdfObject;
};

});


parcelRegister("4P77p", function(module, exports) {

$parcel$export(module.exports, "ChangeEventTypes", () => $5d2cfcdff3aefb29$export$8db21fc94823e1cc);
// Copied over from `src/packages/issue/issue-view/src/model/change-type.js`
const $5d2cfcdff3aefb29$var$FIELD_CHANGE_REQUESTED = 'FIELD_CHANGE_REQUESTED';
const $5d2cfcdff3aefb29$var$FIELD_CHANGED = 'FIELD_CHANGED';
const $5d2cfcdff3aefb29$var$FIELD_CHANGE_FAILED = 'FIELD_CHANGE_FAILED';
const $5d2cfcdff3aefb29$export$8db21fc94823e1cc = {
    [$5d2cfcdff3aefb29$var$FIELD_CHANGE_REQUESTED]: $5d2cfcdff3aefb29$var$FIELD_CHANGE_REQUESTED,
    [$5d2cfcdff3aefb29$var$FIELD_CHANGE_FAILED]: $5d2cfcdff3aefb29$var$FIELD_CHANGE_FAILED,
    [$5d2cfcdff3aefb29$var$FIELD_CHANGED]: $5d2cfcdff3aefb29$var$FIELD_CHANGED
};

});


parcelRegister("4im1M", function(module, exports) {

$parcel$export(module.exports, "useIsMounted", () => $bb7ff1168b248128$export$80c2a3957bcb42ea);

var $eJOHy = parcelRequire("eJOHy");
const $bb7ff1168b248128$export$80c2a3957bcb42ea = ()=>{
    const isMounted = (0, $eJOHy.useRef)(true);
    (0, $eJOHy.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, [
        isMounted
    ]);
    return isMounted;
};

});

parcelRegister("iaPZb", function(module, exports) {

$parcel$export(module.exports, "defaultSaveField", () => $21527ec442db63fe$export$b74e6b7f831f1cb2);
$parcel$export(module.exports, "defaultSaveFieldById", () => $21527ec442db63fe$export$b2c49aae5d84cced);
$parcel$export(module.exports, "defaultAddValuesToField", () => $21527ec442db63fe$export$c46c7284cd9c5d3);
$parcel$export(module.exports, "defaultRemoveValuesFromField", () => $21527ec442db63fe$export$33b78476f5d734b3);

var $jGzN3 = parcelRequire("jGzN3");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $21527ec442db63fe$var$getFieldUpdate = (fieldKey, value)=>({
        fields: {
            [fieldKey]: value
        }
    });
const $21527ec442db63fe$export$b74e6b7f831f1cb2 = async (issueKey, fieldKey, newValue)=>(0, $jGzN3.performPutRequest)(`/rest/api/3/issue/${issueKey}/`, {
        body: JSON.stringify($21527ec442db63fe$var$getFieldUpdate(fieldKey, newValue))
    });
const $21527ec442db63fe$export$b2c49aae5d84cced = async (issueKey, fieldKey, newValue)=>(0, $jGzN3.performPutRequest)(`/rest/api/3/issue/${issueKey}/?returnIssue=true`, {
        body: JSON.stringify($21527ec442db63fe$var$getFieldUpdate(fieldKey, newValue))
    });
const $21527ec442db63fe$export$c46c7284cd9c5d3 = async (issueKey, fieldKey, valuesToAdd)=>{
    const updateParam = {
        update: {
            [fieldKey]: [
                {
                    operation: 'add',
                    value: valuesToAdd
                }
            ]
        }
    };
    return (0, $jGzN3.performPutRequest)(`/rest/api/3/issue/${issueKey}/`, {
        body: JSON.stringify(updateParam)
    });
};
const $21527ec442db63fe$export$33b78476f5d734b3 = async (issueKey, fieldKey, valuesToRemove)=>{
    const updateParam = {
        update: {
            [fieldKey]: [
                {
                    operation: 'remove',
                    value: valuesToRemove
                }
            ]
        }
    };
    return (0, $jGzN3.performPutRequest)(`/rest/api/3/issue/${issueKey}/`, {
        body: JSON.stringify(updateParam)
    });
};

});


parcelRegister("2rHwS", function(module, exports) {

$parcel$export(module.exports, "useIssueFieldConfig", () => $9c87b1a177d5273e$export$5406c21e0d275680);
$parcel$export(module.exports, "useIssueFieldConfigWithoutRefetch", () => $9c87b1a177d5273e$export$217a0e2f2962f4ae);
$parcel$export(module.exports, "useIssueFieldConfigWithoutUimOverrides", () => $9c87b1a177d5273e$export$5f641a998c6dfa06);
$parcel$export(module.exports, "useFieldConfig", () => $9c87b1a177d5273e$export$70da50df1be2dbe1);
$parcel$export(module.exports, "useFieldConfigWithoutRefetch", () => $9c87b1a177d5273e$export$1eed575f8f3334eb);
$parcel$export(module.exports, "useFieldConfigActions", () => $9c87b1a177d5273e$export$28a22fd0dedf31b7);

var $eJOHy = parcelRequire("eJOHy");

var $jPROM = parcelRequire("jPROM");

var $7jTnu = parcelRequire("7jTnu");

var $fAZgY = parcelRequire("fAZgY");

var $1uIew = parcelRequire("1uIew");

var $jGzN3 = parcelRequire("jGzN3");

var $XGDec = parcelRequire("XGDec");

var $3KXZZ = parcelRequire("3KXZZ");

var $3ibpe = parcelRequire("3ibpe");

var $4im1M = parcelRequire("4im1M");

var $b1smt = parcelRequire("b1smt");
const $9c87b1a177d5273e$export$9715ac6597e498fd = ()=>`
  query fieldConfigurationQuery($issueKey: String) {
    issue(issueIdOrKey: $issueKey, latestVersion: true, screen: "view") {
      fields {
        key
        schema {
          type
          custom
          customId
          system
          renderer
        }
        autoCompleteUrl
        allowedValues
        operations
        required
        editable
        title
        description
      }
    }
  }`;
const $9c87b1a177d5273e$var$fieldConfigurationQueryExperienceDescription = ({ wasExperienceSuccessful: wasExperienceSuccessful, errorMessage: errorMessage, traceId: traceId })=>{
    const errorMessageItem = errorMessage != null ? {
        errorMessage: errorMessage
    } : {};
    const traceIdItem = traceId != null ? {
        traceId: traceId
    } : {};
    return {
        experience: (0, $3KXZZ.IssueViewFetchOperations).FIELD_CONFIGURATION,
        wasExperienceSuccesful: wasExperienceSuccessful,
        analyticsSource: 'Issue View Field Configuration Query',
        additionalAttributes: {
            method: 'GET',
            ...errorMessageItem,
            ...traceIdItem
        },
        application: null,
        edition: null
    };
};
const $9c87b1a177d5273e$var$fieldConfigurationQueryExperienceTracking = ({ wasExperienceSuccessful: wasExperienceSuccessful, error: error })=>{
    (0, $3ibpe.sendExperienceAnalytics)($9c87b1a177d5273e$var$fieldConfigurationQueryExperienceDescription({
        wasExperienceSuccessful: wasExperienceSuccessful,
        ...error?.message != null ? {
            errorMessage: error.message
        } : {},
        ...error instanceof (0, $1uIew.default) && error.traceId != null ? {
            traceId: error.traceId
        } : {}
    }));
};
const $9c87b1a177d5273e$var$fetchData = async (issueKey)=>{
    try {
        const response = await (0, $jGzN3.performPostRequest)((0, $XGDec.getGraphQlUrl)((0, $3KXZZ.IssueViewFetchOperations).FIELD_CONFIGURATION), {
            body: JSON.stringify({
                query: $9c87b1a177d5273e$export$9715ac6597e498fd(),
                variables: {
                    issueKey: issueKey
                }
            })
        });
        if (response?.data?.issue?.fields) {
            const fieldConfigData = response.data.issue.fields.reduce(// @ts-expect-error - TS7006 - Parameter 'result' implicitly has an 'any' type. | TS7006 - Parameter 'field' implicitly has an 'any' type.
            (result, field)=>({
                    // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
                    ...result,
                    [field.key]: {
                        autoCompleteUrl: field.autoCompleteUrl,
                        allowedValues: field.allowedValues,
                        isEditable: field.editable,
                        isRequired: field.required,
                        schema: field.schema,
                        title: field.title,
                        ...field.description ? {
                            description: field.description
                        } : {}
                    }
                }), {});
            $9c87b1a177d5273e$var$fieldConfigurationQueryExperienceTracking({
                wasExperienceSuccessful: true
            });
            return fieldConfigData;
        }
        $9c87b1a177d5273e$var$fieldConfigurationQueryExperienceTracking({
            wasExperienceSuccessful: false,
            error: new Error('Unexpected field configuration response')
        });
        return null;
    } catch (error) {
        $9c87b1a177d5273e$var$fieldConfigurationQueryExperienceTracking({
            wasExperienceSuccessful: false,
            error: error instanceof (0, $1uIew.default) ? error : undefined
        });
        return null;
    }
};
const $9c87b1a177d5273e$var$requestSet = new Set();
const $9c87b1a177d5273e$var$issueFieldConfigServiceDefaultOptions = {
    skipRefresh: false
};
const $9c87b1a177d5273e$var$useIssueFieldConfigRefetch = (issueKey, value, { skipRefresh: skipRefresh } = $9c87b1a177d5273e$var$issueFieldConfigServiceDefaultOptions)=>{
    const isMounted = (0, $4im1M.useIsMounted)();
    const [, { setIssueConfig: setIssueConfig }] = (0, $b1smt.useFieldConfigStoreActions)();
    const [loading, setLoading] = (0, $eJOHy.useState)(()=>!skipRefresh && value === undefined && !$9c87b1a177d5273e$var$requestSet.has(issueKey));
    const getData = (0, $eJOHy.useCallback)(async ()=>{
        setLoading(true);
        $9c87b1a177d5273e$var$requestSet.add(issueKey);
        const result = await $9c87b1a177d5273e$var$fetchData(issueKey);
        setIssueConfig(issueKey, result);
        $9c87b1a177d5273e$var$requestSet.delete(issueKey);
        if (isMounted.current) setLoading(false);
    }, [
        isMounted,
        issueKey,
        setIssueConfig
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const shouldGetData = (0, $7jTnu.fg)('jiv-19312-fix-fieldconfigurationquery-refetch') ? !skipRefresh && !$9c87b1a177d5273e$var$requestSet.has(issueKey) && value === undefined && issueKey !== '' : !skipRefresh && !$9c87b1a177d5273e$var$requestSet.has(issueKey) && value === undefined;
        if (shouldGetData) getData();
    }, [
        issueKey,
        value,
        getData,
        skipRefresh
    ]);
    return (0, $fAZgY.useMemoWithCondition)(()=>[
            {
                loading: loading
            }
        ], [
        loading
    ], ()=>(0, $7jTnu.fg)('jfp_magma_issue-stability-phase1'));
};
const $9c87b1a177d5273e$var$useIssueFieldConfigStoreWithUimOverrides = ({ issueKey: issueKey })=>{
    const [value] = (0, $b1smt.useIssueFieldConfigStore)({
        issueKey: issueKey
    });
    const [overrides] = (0, $b1smt.useIssueOverridesStore)({
        issueKey: issueKey
    });
    return (0, $eJOHy.useMemo)(()=>{
        if (// When fields configurations are not valid, we don't want overrides
        !(0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(value) && // We should not override if UI modifications is not available in general or for the field
        overrides !== undefined) {
            // Iteration over the base fields (`value`) prevents creation of partial configs with just UIM overrides.
            const issueWithOverrides = Object.entries(value).reduce((acc, [fieldKey, fieldValues])=>{
                acc[fieldKey] = {
                    ...fieldValues,
                    ...overrides[fieldKey]
                };
                return acc;
            }, {});
            return [
                issueWithOverrides
            ];
        }
        return [
            value
        ];
    }, [
        value,
        overrides
    ]);
};
const $9c87b1a177d5273e$var$useFieldConfigStoreWithUimOverrides = ({ issueKey: issueKey, fieldKey: fieldKey })=>{
    const [value] = (0, $b1smt.useFieldConfigStore)({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    const [overrides] = (0, $b1smt.useFieldOverridesStore)({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    if (// When fields configurations are not valid, we don't want overrides
    !(0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(value) && // We should not override if UI modifications is not available in general or for the field
    overrides !== undefined) return [
        {
            ...value,
            ...overrides
        }
    ];
    return [
        value
    ];
};
const $9c87b1a177d5273e$export$5406c21e0d275680 = (issueKey)=>{
    const [value] = $9c87b1a177d5273e$var$useIssueFieldConfigStoreWithUimOverrides({
        issueKey: issueKey
    });
    const [{ loading: loading }] = $9c87b1a177d5273e$var$useIssueFieldConfigRefetch(issueKey, value);
    return (0, $fAZgY.useMemoWithCondition)(()=>[
            {
                value: value,
                loading: loading
            }
        ], [
        loading,
        value
    ], ()=>(0, $7jTnu.fg)('jfp_magma_issue-stability-phase1'));
};
const $9c87b1a177d5273e$export$217a0e2f2962f4ae = (issueKey)=>{
    const [value] = $9c87b1a177d5273e$var$useIssueFieldConfigStoreWithUimOverrides({
        issueKey: issueKey
    });
    return (0, $fAZgY.useMemoWithCondition)(()=>[
            {
                value: value
            }
        ], [
        value
    ], ()=>(0, $7jTnu.fg)('jfp_magma_issue-stability-phase1'));
};
const $9c87b1a177d5273e$export$5f641a998c6dfa06 = ({ issueKey: issueKey })=>{
    const [value] = (0, $b1smt.useIssueFieldConfigStore)({
        issueKey: issueKey
    });
    const [{ loading: loading }] = $9c87b1a177d5273e$var$useIssueFieldConfigRefetch(issueKey, value);
    return (0, $fAZgY.useMemoWithCondition)(()=>[
            {
                value: value,
                loading: loading
            }
        ], [
        loading,
        value
    ], ()=>(0, $7jTnu.fg)('jfp_magma_issue-stability-phase1'));
};
const $9c87b1a177d5273e$export$70da50df1be2dbe1 = (issueKey, fieldKey, options = $9c87b1a177d5273e$var$issueFieldConfigServiceDefaultOptions)=>{
    const [value] = $9c87b1a177d5273e$var$useFieldConfigStoreWithUimOverrides({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    const [{ loading: loading }] = $9c87b1a177d5273e$var$useIssueFieldConfigRefetch(issueKey, value, options);
    return (0, $fAZgY.useMemoWithCondition)(()=>[
            {
                value: value,
                loading: loading
            }
        ], [
        loading,
        value
    ], ()=>(0, $7jTnu.fg)('jfp_magma_issue-stability-phase1'));
};
const $9c87b1a177d5273e$export$1eed575f8f3334eb = (issueKey, fieldKey)=>{
    const [value] = $9c87b1a177d5273e$var$useFieldConfigStoreWithUimOverrides({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    return (0, $fAZgY.useMemoWithCondition)(()=>[
            {
                value: value
            }
        ], [
        value
    ], ()=>(0, $7jTnu.fg)('jfp_magma_issue-stability-phase1'));
};
const $9c87b1a177d5273e$export$28a22fd0dedf31b7 = ()=>{
    const [, setIssueConfigActions] = (0, $b1smt.useFieldConfigStoreActions)();
    const actions = (0, $eJOHy.useMemo)(()=>{
        const setIssueConfig = (issueKey, issueConfig)=>setIssueConfigActions.setIssueConfig(issueKey, issueConfig);
        const setIssuesConfig = (issuesWithConfigurations)=>setIssueConfigActions.setIssuesConfig(issuesWithConfigurations);
        const mergeIssueConfig = (issueKey, issueConfig)=>setIssueConfigActions.mergeIssueConfig(issueKey, issueConfig);
        const mergeIssuesConfig = (issuesWithConfigurations)=>setIssueConfigActions.mergeIssuesConfig(issuesWithConfigurations);
        const setFieldConfigValue = (issueKey, fieldKey, fieldConfigValue)=>setIssueConfigActions.setFieldConfigValue(issueKey, fieldKey, fieldConfigValue);
        return {
            setIssueConfig: setIssueConfig,
            setIssuesConfig: setIssuesConfig,
            mergeIssueConfig: mergeIssueConfig,
            mergeIssuesConfig: mergeIssuesConfig,
            setFieldConfigValue: setFieldConfigValue
        };
    }, [
        setIssueConfigActions
    ]);
    return [
        null,
        actions
    ];
};

});
parcelRegister("XGDec", function(module, exports) {

$parcel$export(module.exports, "getGraphQlUrl", () => $d2d607861b22c2c1$export$5647e6bbf2b3526f);
$parcel$export(module.exports, "getFieldDataOptions", () => $d2d607861b22c2c1$export$f2fec0cacdfabaaf);

var $cTI7h = parcelRequire("cTI7h");

var $bcdww = parcelRequire("bcdww");

const $d2d607861b22c2c1$export$5647e6bbf2b3526f = (operation)=>`/rest/graphql/1/${(0, $cTI7h.appendOperationQuery)(operation)}`;
const $d2d607861b22c2c1$export$f2fec0cacdfabaaf = (issueKey, projectKey)=>({
        method: 'POST',
        body: JSON.stringify({
            query: (0, $bcdww.default)(issueKey, projectKey)
        })
    });

});
parcelRegister("bcdww", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8ded878d9b9c772$export$2e2bcd8739ae039);
const $c8ded878d9b9c772$export$ecc155df19ba52ff = (literals, ...substitutions)=>{
    let result = '';
    // run the loop only for the substitution count
    substitutions.forEach((key, i)=>{
        result += literals[i];
        result += key.toString();
    });
    // add the last literal
    result += literals[literals.length - 1];
    return result;
};
const $c8ded878d9b9c772$var$getIsHybridAgilityProjectQuery = ()=>`
    isHybridAgilityProject
    `;
const $c8ded878d9b9c772$var$getEnvironmentQuery = ()=>`environmentAdf {
        value
    }`;
const $c8ded878d9b9c772$var$getAgileQuery = ()=>`
    agile {
        epic {
          key
        },
    }`;
const $c8ded878d9b9c772$var$getCustomFieldSchemaConfiguration = ()=>`configuration {
        key
        value
    }
    `;
const $c8ded878d9b9c772$var$getProjectQuery = (projectKey)=>`
        project(projectIdOrKey: "${projectKey}") {
            id
            name
            key
            projectTypeKey
            simplified
            avatarUrls {
                key
                value
            }
            archived
            deleted
        }`;
var // Disable this eslint rule temporarily so we can query for configuration
// eslint-disable-next-line jira/import/no-anonymous-default-export
$c8ded878d9b9c772$export$2e2bcd8739ae039 = (issueKey, projectKey)=>$c8ded878d9b9c772$export$ecc155df19ba52ff`query issueDataQuery {
        issue(issueIdOrKey: "${issueKey}", latestVersion: true, screen: "view") {
            id
            viewScreenId
            fields {
                key
                title
                editable
                required
                autoCompleteUrl
                allowedValues
                content
                renderedContent
                schema {
                    custom
                    system
                    ${$c8ded878d9b9c772$var$getCustomFieldSchemaConfiguration()}
                    items
                    type
                    renderer
                }
                configuration
            }
            expandAssigneeInSubtasks
            expandAssigneeInIssuelinks
            expandTimeTrackingInSubtasks
            systemFields {
                descriptionAdf {
                    value
                }
                ${$c8ded878d9b9c772$var$getEnvironmentQuery()}
            }
            customFields {
                textareaAdf {
                    key
                    value
                }
            }
            ${$c8ded878d9b9c772$var$getIsHybridAgilityProjectQuery()}
            ${$c8ded878d9b9c772$var$getAgileQuery()}
        }
        ${$c8ded878d9b9c772$var$getProjectQuery(projectKey)}
    }`;

});


parcelRegister("3KXZZ", function(module, exports) {

$parcel$export(module.exports, "TIMESTAMP_DISPLAY_SETTING", () => $cc433f27aee6ba76$export$9f4ee8e6dc9a0a55);
$parcel$export(module.exports, "CHILD_ISSUES_LIMIT_BEST_PRACTICE_FLAG_DISMISSED", () => $cc433f27aee6ba76$export$e7d75f9d93dfa3df);
$parcel$export(module.exports, "IssueViewFetchOperations", () => $cc433f27aee6ba76$export$b38f30d67f730bc4);
const $cc433f27aee6ba76$export$9f4ee8e6dc9a0a55 = 'jira.user.issue.details.timestamp-display-setting';
const $cc433f27aee6ba76$export$e7d75f9d93dfa3df = 'jira.user.issue.child-issues-limit.best-practice-flag.dismissed';
const $cc433f27aee6ba76$export$b38f30d67f730bc4 = {
    EARLY_FETCH_GRAPHQL: 'earlyFetchIssueDataQuery',
    INITIAL_GRAPHQL: 'issueDataQuery',
    EARLY_FETCH_GIRA: 'earlyFetchIssueViewInteractiveQuery',
    INITIAL_GIRA: 'issueViewInteractiveQuery',
    EARLY_FETCH_AGG: 'earlyFetchMainIssueAggQuery',
    INITIAL_AGG: 'mainIssueAggQuery',
    EARLY_FETCH_NON_CRITICAL_GIRA: 'earlyFetchIssueViewNonCriticalGiraQuery',
    NON_CRITICAL_GIRA: 'issueViewNonCriticalGiraQuery',
    VIEW_SCREEN_ID: 'viewScreenIdQuery',
    FIELD_CONFIGURATION: 'fieldConfigurationQuery',
    FIELD_DESCRIPTION: 'fieldDescriptionQuery',
    ATTACHMENT: 'attachmentsQuery'
};

});

parcelRegister("3ibpe", function(module, exports) {

$parcel$export(module.exports, "sendExperienceAnalytics", () => $b05a2baea0c3ab19$export$4a95ada1b8228562);

var $1O6Yz = parcelRequire("1O6Yz");

var $4iJGP = parcelRequire("4iJGP");

var $mjinE = parcelRequire("mjinE");

var $hWeHP = parcelRequire("hWeHP");

var $7jTnu = parcelRequire("7jTnu");
const $b05a2baea0c3ab19$var$isSynthetic = ()=>(0, $hWeHP.default)('ajs-is-synthetic') === 'true';
const $b05a2baea0c3ab19$var$shouldAddConnectivityAttribute = (experienceDescription)=>{
    // Return false if feature flag is off
    if (!(0, $7jTnu.fg)('thor_refine_taskfail_offline_failed_events')) return false;
    // Return false if not a taskFail action
    if (experienceDescription.wasExperienceSuccesful) return false;
    const isKnownExperience = [
        'transitionIssue',
        'getTransitions',
        'startWatching',
        'stopWatching'
    ].includes(experienceDescription.experience);
    // Return false if not a known experience
    if (!isKnownExperience) return false;
    const hasStatusCode = !!experienceDescription.additionalAttributes?.statusCode;
    // Return false if status code is present
    return !hasStatusCode;
};
function $b05a2baea0c3ab19$export$4a95ada1b8228562(experienceDescription) {
    const additionalContext = {};
    const shard = (0, $hWeHP.default)('ajs-shard');
    const region = (0, $hWeHP.default)('ajs-region');
    Object.assign(additionalContext, {
        shard: shard,
        region: region
    });
    const enabledFeatureFlags = Object.fromEntries([
        ...(0, $4iJGP.allFeatureFlagsAccessed)
    ].filter(([, value])=>value));
    Object.assign(additionalContext, {
        enabledFeatureFlags: enabledFeatureFlags
    });
    if ($b05a2baea0c3ab19$var$shouldAddConnectivityAttribute(experienceDescription)) {
        const isOnline = typeof globalThis.window !== 'undefined' && globalThis.window?.navigator?.onLine;
        Object.assign(additionalContext, {
            isOnline: isOnline
        });
    }
    const synthetics = {
        additionalAttributes: {
            synthetic: $b05a2baea0c3ab19$var$isSynthetic(),
            ...additionalContext
        }
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))(experienceDescription, synthetics);
    (0, $mjinE.default)(experienceDescription);
}

});

parcelRegister("b1smt", function(module, exports) {

$parcel$export(module.exports, "useIssueFieldConfigStore", () => $f4887671cea7e277$export$52f51db4e2b3da57);
$parcel$export(module.exports, "useFieldConfigStore", () => $f4887671cea7e277$export$f9beb98c7488fd61);
$parcel$export(module.exports, "useFieldConfigStoreActions", () => $f4887671cea7e277$export$314199caf05d245);
$parcel$export(module.exports, "useIssueOverridesStore", () => $f4887671cea7e277$export$ff357cf5a96ec0c6);
$parcel$export(module.exports, "useFieldOverridesStore", () => $f4887671cea7e277$export$6e41e9c34587d557);
$parcel$export(module.exports, "useFieldOverridesStoreWithLabel", () => $f4887671cea7e277$export$e704d739927bd1d6);
$parcel$export(module.exports, "useOverridesStoreActions", () => $f4887671cea7e277$export$d94ae842140da412);
$parcel$export(module.exports, "useFieldOptionsOverrides", () => $f4887671cea7e277$export$bfea9bb9bad7bc8f);
$parcel$export(module.exports, "useIsFieldBusy", () => $f4887671cea7e277$export$982ff1008c2e2780);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ 
var $ahm5r = parcelRequire("ahm5r");

var $1O6Yz = parcelRequire("1O6Yz");

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $f4887671cea7e277$var$setIssueConfig = (issueKey, issueConfiguration)=>({ setState: setState })=>{
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: IssueConfiguration | null; }' is not assignable to parameter of type 'Partial<Partial<Record<string, IssueConfiguration>>>'.
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: issueConfiguration
        });
    };
const $f4887671cea7e277$var$mergeIssueConfig = (issueKey, issueConfiguration)=>({ setState: setState, getState: getState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: (0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))({}, getState()[issueKey], issueConfiguration)
        });
    };
const $f4887671cea7e277$var$setIssuesConfig = (issuesWithConfigurations)=>({ setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newIssues = issuesWithConfigurations.reduce((acc, issue)=>({
                ...acc,
                ...issue
            }), {});
        setState(newIssues);
    };
const $f4887671cea7e277$var$mergeIssuesConfig = (issuesWithConfigurations)=>({ setState: setState, getState: getState })=>{
        if (issuesWithConfigurations.length === 0) return;
        const newIssues = {};
        issuesWithConfigurations.forEach((issue)=>{
            Object.assign(newIssues, issue);
        });
        setState((0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))({}, getState(), newIssues));
    };
const $f4887671cea7e277$var$setFieldConfigValue = (issueKey, fieldKey, fieldConfiguration)=>({ setState: setState, getState: getState })=>{
        const issueKeyFieldConfiguration = getState()[issueKey];
        if (issueKeyFieldConfiguration && issueKeyFieldConfiguration[fieldKey]) setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: {
                ...getState()[issueKey],
                [fieldKey]: {
                    ...getState()[issueKey][fieldKey],
                    ...fieldConfiguration
                }
            }
        });
    };
const $f4887671cea7e277$var$actions = {
    setIssueConfig: $f4887671cea7e277$var$setIssueConfig,
    setIssuesConfig: $f4887671cea7e277$var$setIssuesConfig,
    mergeIssueConfig: $f4887671cea7e277$var$mergeIssueConfig,
    mergeIssuesConfig: $f4887671cea7e277$var$mergeIssuesConfig,
    setFieldConfigValue: $f4887671cea7e277$var$setFieldConfigValue
};
// this is a global state
const $f4887671cea7e277$var$store = (0, $GtRbT.createStore)({
    name: 'issue-field-config',
    initialState: {},
    actions: $f4887671cea7e277$var$actions
});
const $f4887671cea7e277$var$getIssueFieldConfig = (0, $ahm5r.createSelector)((state, props)=>state[props.issueKey], (issue)=>issue);
const $f4887671cea7e277$export$52f51db4e2b3da57 = (0, $iJq0l.createHook)($f4887671cea7e277$var$store, {
    selector: $f4887671cea7e277$var$getIssueFieldConfig
});
const $f4887671cea7e277$var$getFieldConfig = (0, $ahm5r.createSelector)((state, props)=>state[props.issueKey], (state, props)=>props.fieldKey, (issue, fieldKey)=>{
    // issue being undefined means we haven't fetched it yet
    // issue being null means it doesn't exist.
    // either way we just return that value
    if (issue == null) return issue;
    // if we have the field key, return it. Otherwise return null to show
    // we have done a data fetch of the issue but the field doesn't exist
    return issue[fieldKey] ? issue[fieldKey] : null;
});
const $f4887671cea7e277$var$getFieldConfigWithLabel = (0, $ahm5r.createSelector)($f4887671cea7e277$var$getFieldConfig, (fieldConfig)=>{
    if (fieldConfig?.title === undefined) return fieldConfig;
    return {
        ...fieldConfig,
        label: fieldConfig.title
    };
});
const $f4887671cea7e277$var$getFieldOptionsOverrides = (0, $ahm5r.createSelector)((state, props)=>state[props.issueKey], (state, props)=>props.fieldKey, (issue, fieldKey)=>{
    // issue being undefined means we haven't fetched it yet
    // issue being null means it doesn't exist.
    // either way we just return that value
    if (issue == null) return issue;
    // if we have the field key, return it. Otherwise return null to show
    // we have done a data fetch of the issue but the field doesn't exist
    return issue[fieldKey] ? issue[fieldKey].allowedValuesOverrides : null;
});
const $f4887671cea7e277$export$f9beb98c7488fd61 = (0, $iJq0l.createHook)($f4887671cea7e277$var$store, {
    selector: $f4887671cea7e277$var$getFieldConfig
});
const $f4887671cea7e277$export$314199caf05d245 = (0, $iJq0l.createHook)($f4887671cea7e277$var$store, {
    selector: null
});
const $f4887671cea7e277$var$setOverrides = (issueKey, fieldKey, fieldConfigOverrides)=>({ setState: setState, getState: getState })=>{
        const issueKeyFieldConfigurationWithOverrides = getState()[issueKey] ?? {};
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: {
                ...issueKeyFieldConfigurationWithOverrides,
                [fieldKey]: {
                    ...issueKeyFieldConfigurationWithOverrides[fieldKey],
                    ...fieldConfigOverrides
                }
            }
        });
    };
const $f4887671cea7e277$var$resetOverridesStore = (issueKey)=>({ setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        setState({
            [issueKey]: undefined
        });
    };
const $f4887671cea7e277$var$overridesActions = {
    setFieldConfigOverridesValue: $f4887671cea7e277$var$setOverrides,
    resetOverridesStore: $f4887671cea7e277$var$resetOverridesStore
};
// Store contains overrides to the field config. It is used by UI modifications to override field config properties by apps.
// UI modifications is a Forge extension point providing apps JS API to override field's properties: name, description, isEditable
// and limit visibility of select fields options.
const $f4887671cea7e277$var$overridesStore = (0, $GtRbT.createStore)({
    name: 'issue-field-overrides',
    initialState: {},
    actions: $f4887671cea7e277$var$overridesActions
});
const $f4887671cea7e277$export$ff357cf5a96ec0c6 = (0, $iJq0l.createHook)($f4887671cea7e277$var$overridesStore, {
    selector: $f4887671cea7e277$var$getIssueFieldConfig
});
const $f4887671cea7e277$export$6e41e9c34587d557 = (0, $iJq0l.createHook)($f4887671cea7e277$var$overridesStore, {
    selector: $f4887671cea7e277$var$getFieldConfig
});
const $f4887671cea7e277$export$e704d739927bd1d6 = (0, $iJq0l.createStateHook)($f4887671cea7e277$var$overridesStore, {
    selector: $f4887671cea7e277$var$getFieldConfigWithLabel
});
const $f4887671cea7e277$export$d94ae842140da412 = (0, $iJq0l.createActionsHook)($f4887671cea7e277$var$overridesStore);
const $f4887671cea7e277$export$bfea9bb9bad7bc8f = (0, $iJq0l.createHook)($f4887671cea7e277$var$overridesStore, {
    selector: $f4887671cea7e277$var$getFieldOptionsOverrides
});
const $f4887671cea7e277$var$getIsFieldBusySelector = (state, args)=>{
    const { fieldId: fieldId, issueKey: issueKey } = args;
    return fieldId !== undefined && !!state[issueKey]?.[fieldId]?.isBusy;
};
const $f4887671cea7e277$export$982ff1008c2e2780 = (0, $iJq0l.createStateHook)($f4887671cea7e277$var$overridesStore, {
    selector: $f4887671cea7e277$var$getIsFieldBusySelector
});

});



parcelRegister("3EmVH", function(module, exports) {

$parcel$export(module.exports, "useSummaryField", () => $6294e624de06ab59$export$a01f0885983ceff0);

var $9Dhvc = parcelRequire("9Dhvc");

var $2QNHW = parcelRequire("2QNHW");

var $2rHwS = parcelRequire("2rHwS");

var $814y1 = parcelRequire("814y1");

var $7jTnu = parcelRequire("7jTnu");

var $9kwVk = parcelRequire("9kwVk");
const $6294e624de06ab59$export$a01f0885983ceff0 = ({ issueId: issueId, issueKey: issueKey, initialValue: initialValue, onSubmit: onSubmit, onSuccess: onSuccess, onFailure: onFailure, onSaveField: onSaveField })=>{
    const [fieldConfig] = (0, $2rHwS.useFieldConfig)(issueKey, (0, $814y1.SUMMARY_TYPE));
    const fieldType = (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))(fieldConfig.value, 'schema.type', 'string');
    const saveField = (0, $7jTnu.fg)('relay-migration-issue-fields-summary') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $9kwVk.useSaveSummaryField)(issueId) : undefined;
    const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $2QNHW.useEditField)({
        fieldKey: (0, $814y1.SUMMARY_TYPE),
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: initialValue || null,
        onSubmit: onSubmit,
        onSuccess: onSuccess,
        onFailure: onFailure,
        ...(0, $7jTnu.fg)('relay-migration-issue-fields-summary') && {
            saveField: saveField
        },
        // delete this condition and keep code inside when removing the isIncrementPlanningEnabled FF
        ...onSaveField && {
            saveField: onSaveField
        }
    });
    return [
        {
            value: value,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};

});
parcelRegister("9kwVk", function(module, exports) {

$parcel$export(module.exports, "useSaveSummaryField", () => $6fe73ae90d5d1945$export$2429979662d1fc23);

var $hi3jH = parcelRequire("hi3jH");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $3pSHx = parcelRequire("3pSHx");

var $1uIew = parcelRequire("1uIew");

var $kEUB1 = parcelRequire("kEUB1");
const $6fe73ae90d5d1945$export$2429979662d1fc23 = (issueId)=>{
    const cloudId = (0, $kEUB1.useCloudId)();
    const [commit] = (0, $j4oe4.useMutation)((0, $hi3jH.default));
    return (0, $eJOHy.useCallback)(async (_issueKey, fieldId, newValue)=>new Promise((resolve, reject)=>{
            commit({
                variables: {
                    input: {
                        id: (0, $3pSHx.JiraIssuefieldvalueAri).create({
                            siteId: cloudId,
                            issueId: issueId || '',
                            fieldId: fieldId
                        }).toString(),
                        operation: {
                            operation: 'SET',
                            text: newValue
                        }
                    }
                },
                onCompleted (response) {
                    if (response.jira?.updateSingleLineTextField) {
                        const { success: success, errors: responseErrors } = response.jira?.updateSingleLineTextField;
                        if (success) {
                            resolve();
                            return;
                        }
                        if (responseErrors?.length) reject(responseErrors[0].message ? new (0, $1uIew.ValidationError)(responseErrors[0].message) : new Error('Unknown error when mutating summary'));
                    } else reject(new Error('Unknown error when mutating summary'));
                },
                onError (error) {
                    reject(error);
                }
            });
        }), [
        cloudId,
        commit,
        issueId
    ]);
};

});
parcelRegister("hi3jH", function(module, exports) {

$parcel$export(module.exports, "default", () => $52e766833f477698$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<502aa471f5d0893ece5715d9f8b2453a>>
 * @relayHash 96311ac8cd1b2e15ed7072740a91fd80
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 24e8667d902ba1fdadfcd6a7137edc6ca942d8be00bc0084996320ad25442808
const $52e766833f477698$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSaveSummaryFieldMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraSingleLineTextFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateSingleLineTextField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraSingleLineTextField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "singleLineTextHeading_issueFieldSingleLineTextInlineEditHeading_SingleLineTextHeadingInlineEditView"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSaveSummaryFieldMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraSingleLineTextFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateSingleLineTextField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraSingleLineTextField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "fieldId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isEditableInIssueView"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "text"
                                        },
                                        {
                                            "concreteType": "JiraFieldConfig",
                                            "kind": "LinkedField",
                                            "name": "fieldConfig",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isRequired"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "24e8667d902ba1fdadfcd6a7137edc6ca942d8be00bc0084996320ad25442808",
            "metadata": {},
            "name": "useSaveSummaryFieldMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$52e766833f477698$var$node.hash = "d7d58a3dc9f48f40fffb61682948b25d";
var $52e766833f477698$export$2e2bcd8739ae039 = $52e766833f477698$var$node;

});

parcelRegister("3pSHx", function(module, exports) {

$parcel$export(module.exports, "JiraIssuefieldvalueAri", () => $27ce236fe1a3184f$export$828c4931ae562af7);

var $caazz = parcelRequire("caazz");

var $3TJ9u = parcelRequire("3TJ9u");

var $cSeYX = parcelRequire("cSeYX");
// src/jira/issuefieldvalue/manifest.ts
var $27ce236fe1a3184f$var$jiraIssuefieldvalueAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $caazz.JiraIssuefieldvalueAriResourceOwner),
    resourceType: (0, $caazz.JiraIssuefieldvalueAriResourceType),
    resourceIdSlug: "{issueId}/{fieldId}",
    resourceIdSegmentFormats: {
        issueId: /[0-9]+/,
        // eslint-disable-line no-useless-escape
        fieldId: /[a-zA-Z0-9_\-]+/
    }
};
// src/jira/issuefieldvalue/index.ts
var $27ce236fe1a3184f$export$828c4931ae562af7 = class _JiraIssuefieldvalueAri extends (0, $3TJ9u.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._issueId = opts.resourceIdSegmentValues.issueId, this._fieldId = opts.resourceIdSegmentValues.fieldId;
    }
    get siteId() {
        return this._siteId;
    }
    get issueId() {
        return this._issueId;
    }
    get fieldId() {
        return this._fieldId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $27ce236fe1a3184f$var$jiraIssuefieldvalueAriStaticOpts.qualifier,
            platformQualifier: $27ce236fe1a3184f$var$jiraIssuefieldvalueAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $27ce236fe1a3184f$var$jiraIssuefieldvalueAriStaticOpts.resourceOwner,
            resourceType: $27ce236fe1a3184f$var$jiraIssuefieldvalueAriStaticOpts.resourceType,
            resourceId: `${opts.issueId}/${opts.fieldId}`,
            resourceIdSegmentValues: {
                issueId: opts.issueId,
                fieldId: opts.fieldId
            }
        }, ariOpts = (0, $cSeYX.AriParser).fromOpts(derivedOpts, $27ce236fe1a3184f$var$jiraIssuefieldvalueAriStaticOpts);
        return new _JiraIssuefieldvalueAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $cSeYX.AriParser).fromString(maybeAri, $27ce236fe1a3184f$var$jiraIssuefieldvalueAriStaticOpts);
        return new _JiraIssuefieldvalueAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            issueId: this.issueId,
            fieldId: this.fieldId
        };
    }
};

});
parcelRegister("caazz", function(module, exports) {

$parcel$export(module.exports, "JiraIssuefieldvalueAriResourceOwner", () => $8dae9ec06e7b65f0$export$39e9358142fbbc64);
$parcel$export(module.exports, "JiraIssuefieldvalueAriResourceType", () => $8dae9ec06e7b65f0$export$f9e57427271adc95);
// src/jira/issuefieldvalue/types.ts
var $8dae9ec06e7b65f0$export$39e9358142fbbc64 = "jira", $8dae9ec06e7b65f0$export$f9e57427271adc95 = "issuefieldvalue";

});






parcelRegister("efhOD", function(module, exports) {

$parcel$export(module.exports, "useSubscribeCommands", () => $69e1ecd0b4d95d40$export$c13b008422be19c7);

var $iTb6Y = parcelRequire("iTb6Y");
const $69e1ecd0b4d95d40$export$c13b008422be19c7 = (0, $iTb6Y.useSubscribeCommandsWithRegistry);

});

parcelRegister("bOX3t", function(module, exports) {

$parcel$export(module.exports, "useIssueAri", () => $06bd26a87a99a4c0$export$f56776f1b409b56d);

var $bmoS1 = parcelRequire("bmoS1");

var $8oKDI = parcelRequire("8oKDI");

var $kEUB1 = parcelRequire("kEUB1");
const $06bd26a87a99a4c0$export$f56776f1b409b56d = ()=>{
    const cloudId = (0, $kEUB1.useCloudId)();
    const issueId = (0, $bmoS1.useIssueId)();
    return (0, $8oKDI.createAri)({
        resourceOwner: 'jira',
        cloudId: cloudId,
        resourceType: 'issue',
        resourceId: issueId ?? ''
    });
};

});

const $57e4b742849c62a3$export$5252a6a6e4e4a774 = 'issue-field-status.ui.status-view.command-palette.issue-status';

parcelRegister("dnUkW", function(module, exports) {

$parcel$export(module.exports, "messages", () => $5f3068940e39da9d$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $5f3068940e39da9d$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    editStatus: {
        "id": "issue-field-status.status-view.command-palette.edit-status",
        "defaultMessage": "Edit status"
    },
    searchTransition: {
        "id": "issue-field-status.status-view.command-palette.search-transition",
        "defaultMessage": "Search a status or transition"
    },
    current: {
        "id": "issue-field-status.status-view.command-palette.current",
        "defaultMessage": "Current"
    },
    fallbackNoResults: {
        "id": "issue-field-status.status-view.command-palette.fallback-no-results",
        "defaultMessage": "No results match your search."
    },
    fallbackError: {
        "id": "issue-field-status.status-view.command-palette.fallback-error",
        "defaultMessage": "We're having trouble loading this data. Wait a few moments, then try again."
    }
});

});

parcelRegister("jXut7", function(module, exports) {

$parcel$export(module.exports, "useSaveStatusField", () => $1d9660599602eb4b$export$c6a3d42f97df89c9);

var $eJOHy = parcelRequire("eJOHy");

var $g51Bg = parcelRequire("g51Bg");

var $gYnSx = parcelRequire("gYnSx");

var $7jTnu = parcelRequire("7jTnu");

var $jGzN3 = parcelRequire("jGzN3");

var $bILK0 = parcelRequire("bILK0");

var $lRq8t = parcelRequire("lRq8t");

var $eaTQ3 = parcelRequire("eaTQ3");

var $f9jBk = parcelRequire("f9jBk");

var $5kH7D = parcelRequire("5kH7D");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");


var $ar711 = parcelRequire("ar711");
const $1d9660599602eb4b$export$c6a3d42f97df89c9 = (issueKey, issueId, onUpdateStatusMutation)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [{ commandPaletteSessionId: commandPaletteSessionId }] = (0, $g51Bg.useCommandPaletteSessionId)();
    const { showFlag: showFlag } = (0, $bILK0.useFlagsService)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [, { setFieldValue: setFieldValue }] = (0, $eaTQ3.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $c78d361852e02509$export$4420b7468f889692)
    });
    const onSaveSuccessfully = (0, $eJOHy.useCallback)((transition, callback)=>{
        const action = 'commandPalette';
        const actionSubject = 'changeStatus';
        const eventActionAndSubject = `${actionSubject} ${action}`;
        const event = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject
        });
        setFieldValue(issueKey, (0, $c78d361852e02509$export$4420b7468f889692), transition.to);
        callback?.();
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $gCeeo.fireTrackAnalytics)(event, eventActionAndSubject, {
            transitionId: transition.id,
            commandPaletteSessionId: commandPaletteSessionId
        });
        (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'statusField transitioned', 'statusField');
        !(0, $7jTnu.fg)('show-modernised-issue-transition-success-flag') && showFlag({
            messageId: 'issue-field-status.ui.status-view.command-palette.use-save-status-field.show-flag.success',
            messageType: 'transactional',
            type: 'success',
            title: formatMessage((0, $ar711.messages).successFlagMessage)
        });
    }, [
        commandPaletteSessionId,
        createAnalyticsEvent,
        formatMessage,
        issueKey,
        setFieldValue,
        showFlag
    ]);
    const onFailSave = (0, $eJOHy.useCallback)((error)=>{
        (0, $gYnSx.default)({
            error: error,
            meta: {
                id: 'commandPaletteIssueStatus',
                packageName: 'jiraIssueFieldStatus',
                teamName: 'deliveroo'
            }
        });
        showFlag({
            messageId: 'issue-field-status.ui.status-view.command-palette.use-save-status-field.show-flag.error',
            messageType: 'transactional',
            type: 'error',
            title: formatMessage((0, $ar711.messages).errorFlagTitle),
            description: formatMessage((0, $ar711.messages).errorFlagDescription)
        });
    }, [
        formatMessage,
        showFlag
    ]);
    const openIssueTransitionModal = (0, $f9jBk.useOpenIssueTransitionModal)();
    const { showIssueTransitionSuccessFlag: showIssueTransitionSuccessFlag } = (0, $5kH7D.useShowFlag)();
    const saveStatusField = (0, $eJOHy.useCallback)(async (transition, callback)=>{
        try {
            if (transition.hasScreen) {
                const handleDialogSuccess = ()=>{
                    (0, $7jTnu.fg)('show-modernised-issue-transition-success-flag') && showIssueTransitionSuccessFlag(issueKey, transition.to.name);
                    return onSaveSuccessfully(transition, callback);
                };
                const handleDialogError = (err)=>onFailSave(err instanceof Error ? err : new Error('Something went wrong trying to update the status with screen using the command palette'));
                const transitionId = transition.id;
                openIssueTransitionModal({
                    payload: {
                        issueId: issueId,
                        issueKey: issueKey,
                        transitionId: transitionId
                    },
                    triggerPointKey: 'issue-transition-command-palette-status-field-transition',
                    onDialogSuccess: handleDialogSuccess,
                    onDialogError: handleDialogError
                });
            } else {
                if (onUpdateStatusMutation && (0, $7jTnu.fg)('relay-migration-issue-fields-status')) await onUpdateStatusMutation?.({
                    transitionId: transition.id,
                    newStatus: transition.to
                });
                else await (0, $jGzN3.performPostRequest)(`/rest/api/3/issue/${issueKey}/transitions`, {
                    body: JSON.stringify({
                        transition: transition
                    })
                });
                onSaveSuccessfully(transition, callback);
                (0, $7jTnu.fg)('show-modernised-issue-transition-success-flag') && showIssueTransitionSuccessFlag(issueKey, transition.to.name);
            }
        } catch (err) {
            const error = err instanceof Error ? err : new Error('Something went wrong trying to update the status using the command palette');
            onFailSave(error);
        }
    }, [
        issueId,
        issueKey,
        onFailSave,
        onSaveSuccessfully,
        onUpdateStatusMutation,
        openIssueTransitionModal,
        showIssueTransitionSuccessFlag
    ]);
    return {
        saveStatusField: saveStatusField
    };
};

});
parcelRegister("5kH7D", function(module, exports) {

$parcel$export(module.exports, "useShowFlag", () => $9c1761bde042fa75$export$46b5557ad4264ef7);

var $eJOHy = parcelRequire("eJOHy");

var $2EgxC = parcelRequire("2EgxC");

var $bILK0 = parcelRequire("bILK0");

var $lRq8t = parcelRequire("lRq8t");

var $U4tkh = parcelRequire("U4tkh");

var $iGqCS = parcelRequire("iGqCS");
const $9c1761bde042fa75$export$46b5557ad4264ef7 = ()=>{
    const { showFlag: showFlag } = (0, $bILK0.useFlagsService)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [workType] = (0, $U4tkh.useIssueTypeName)();
    const showIssueTransitionSuccessFlag = (0, $eJOHy.useCallback)((issueKey, status)=>{
        try {
            showFlag((0, $iGqCS.getTransitionSuccessFlag)(issueKey, status, formatMessage, workType));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $2EgxC.fireIssueTransitionErrorAnalytics)({
                meta: {
                    id: 'showSuccessFlag',
                    packageName: 'jiraIssueTransitionUseShowFlag',
                    teamName: 'gryffindor'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    }, [
        formatMessage,
        showFlag,
        workType
    ]);
    const showIssueTransitionFailureFlag = (0, $eJOHy.useCallback)((issueKey, traceId)=>showFlag((0, $iGqCS.getTransitionFailureFlag)(issueKey, formatMessage, traceId, workType)), [
        formatMessage,
        showFlag,
        workType
    ]);
    return {
        showIssueTransitionSuccessFlag: showIssueTransitionSuccessFlag,
        showIssueTransitionFailureFlag: showIssueTransitionFailureFlag
    };
};

});
parcelRegister("iGqCS", function(module, exports) {

$parcel$export(module.exports, "getTransitionSuccessFlag", () => $9cda229a04c566c3$export$8cfa71b43d733669);
$parcel$export(module.exports, "getTransitionFailureFlag", () => $9cda229a04c566c3$export$d9438db72c9548f1);

var $epTsa = parcelRequire("epTsa");

var $7jTnu = parcelRequire("7jTnu");

var $hrodw = parcelRequire("hrodw");

var $eJLZa = parcelRequire("eJLZa");
const $9cda229a04c566c3$var$ISSUE_TRANSITION_SUCCESS_FLAG_ID = 'issueTransitionSuccessful';
const $9cda229a04c566c3$var$ISSUE_TRANSITION_FAILURE_FLAG_ID = 'issueTransitionFailure';
const $9cda229a04c566c3$export$8cfa71b43d733669 = (issueKey, status, formatMessage, workType)=>{
    const showLinkToIssue = Boolean(issueKey && status);
    const successFlagTitle = ()=>{
        if (workType && (0, $epTsa.expVal)('jira-itr-m4-exp-3', 'isEnabled', false)) return formatMessage((0, $eJLZa.default).issueTransitionSuccessfulIssueTerminologyRefreshM4, {
            workType: workType,
            issueKey: issueKey
        });
        return (0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? formatMessage((0, $eJLZa.default).issueTransitionSuccessfulIssueTermRefresh) : formatMessage((0, $eJLZa.default).issueTransitionSuccessful);
    };
    if (showLinkToIssue) return {
        id: (0, $hrodw.toFlagId)($9cda229a04c566c3$var$ISSUE_TRANSITION_SUCCESS_FLAG_ID),
        type: 'success',
        title: formatMessage((0, $7jTnu.fg)('jira-issue-terminology-refresh-m3') ? (0, $eJLZa.default).issueTransitionSuccessfulWithIssueKeyAndStatusIssueTermRefresh : (0, $eJLZa.default).issueTransitionSuccessfulWithIssueKeyAndStatus, {
            issueKey: issueKey,
            status: status
        }),
        description: (0, $eJLZa.default).issueTransitionSuccessfulFlagDescription,
        messageId: `issue-transition-use-show-flag.ui.use-show-flag.${$9cda229a04c566c3$var$ISSUE_TRANSITION_SUCCESS_FLAG_ID}.success.issueTransitionSuccessfulWithIssueKeyAndStatus`,
        messageType: 'transactional'
    };
    return {
        id: (0, $hrodw.toFlagId)($9cda229a04c566c3$var$ISSUE_TRANSITION_SUCCESS_FLAG_ID),
        type: 'success',
        title: successFlagTitle(),
        messageId: `issue-transition-use-show-flag.ui.use-show-flag.${$9cda229a04c566c3$var$ISSUE_TRANSITION_SUCCESS_FLAG_ID}.success.issueTransitionSuccessful`,
        messageType: 'transactional'
    };
};
const $9cda229a04c566c3$export$d9438db72c9548f1 = (issueKey, formatMessage, traceId, workType)=>{
    const failureFlagTitle = ()=>{
        if (workType && (0, $epTsa.expVal)('jira-itr-m4-exp-3', 'isEnabled', false)) return formatMessage((0, $eJLZa.default).issueTransitionFailureIssueTerminologyRefreshM4, {
            workType: workType,
            issueKey: issueKey
        });
        return (0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? formatMessage((0, $eJLZa.default).issueTransitionFailureIssueTermRefresh) : formatMessage((0, $eJLZa.default).issueTransitionFailure);
    };
    return {
        id: (0, $hrodw.toFlagId)($9cda229a04c566c3$var$ISSUE_TRANSITION_FAILURE_FLAG_ID),
        type: 'error',
        title: issueKey ? formatMessage((0, $7jTnu.fg)('jira-issue-terminology-refresh-m3') ? (0, $eJLZa.default).issueTransitionFailureWithKeyIssueTermRefresh : (0, $eJLZa.default).issueTransitionFailureWithKey, {
            issueKey: issueKey
        }) : failureFlagTitle(),
        messageId: `issue-transition-use-show-flag.ui.use-show-flag.${$9cda229a04c566c3$var$ISSUE_TRANSITION_FAILURE_FLAG_ID}.error`,
        messageType: 'transactional',
        ...traceId ? {
            traceId: traceId,
            error: new Error('TransitionFailureFlag')
        } : {}
    };
};

});
parcelRegister("eJLZa", function(module, exports) {

$parcel$export(module.exports, "default", () => $cecedba1c54ca869$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $cecedba1c54ca869$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    issueTransitionSuccessful: {
        "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-successful",
        "defaultMessage": "Issue has been updated."
    },
    issueTransitionSuccessfulWithIssueKeyAndStatus: {
        "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-successful-with-issue-key-and-status",
        "defaultMessage": "{issueKey} moved to {status}."
    },
    issueTransitionSuccessfulFlagDescription: {
        "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-successful-flag-description",
        "defaultMessage": "Kudos for keeping things up-to-date!"
    },
    issueTransitionFailure: {
        "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-failure",
        "defaultMessage": "Issue could not be updated."
    },
    issueTransitionFailureWithKey: {
        "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-failure-with-key",
        "defaultMessage": "We couldn't update {issueKey}."
    },
    viewIssue: {
        "id": "issue-transition-use-show-flag.use-show-flag.view-issue",
        "defaultMessage": "View issue"
    },
    issueTransitionSuccessfulIssueTermRefresh: {
        "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-successful-issue-term-refresh",
        "defaultMessage": "Work item has been updated."
    },
    issueTransitionSuccessfulIssueTerminologyRefreshM4: {
        "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-successful-issue-terminology-refresh-m4",
        "defaultMessage": "Updated {workType} {issueKey}."
    },
    issueTransitionFailureIssueTermRefresh: {
        "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-failure-issue-term-refresh",
        "defaultMessage": "Work item could not be updated."
    },
    issueTransitionFailureIssueTerminologyRefreshM4: {
        "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-failure-issue-terminology-refresh-m4",
        "defaultMessage": "We can\u2019t update {workType} {issueKey}."
    },
    viewIssueIssueTermRefresh: {
        "id": "issue-transition-use-show-flag.use-show-flag.view-issue-issue-term-refresh",
        "defaultMessage": "View"
    },
    issueTransitionSuccessfulWithIssueKeyAndStatusIssueTermRefresh: {
        "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-successful-with-issue-key-and-status-issue-term-refresh",
        "defaultMessage": "{issueKey} moved to {status}."
    },
    issueTransitionFailureWithKeyIssueTermRefresh: {
        "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-failure-with-key-issue-term-refresh",
        "defaultMessage": "We couldn't update {issueKey}."
    }
});

});



parcelRegister("ar711", function(module, exports) {

$parcel$export(module.exports, "messages", () => $facc571c7d7ed7b8$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $facc571c7d7ed7b8$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    successFlagMessage: {
        "id": "issue-field-status.status-view.command-palette.use-save-status-field.success-flag-message",
        "defaultMessage": "Status updated"
    },
    errorFlagTitle: {
        "id": "issue-field-status.status-view.command-palette.use-save-status-field.error-flag-title",
        "defaultMessage": "We're unable to edit status"
    },
    errorFlagDescription: {
        "id": "issue-field-status.status-view.command-palette.use-save-status-field.error-flag-description",
        "defaultMessage": "Wait a few moments, then try again."
    }
});

});


parcelRegister("ku7AV", function(module, exports) {

$parcel$export(module.exports, "getTransitionKeywords", () => $69891a65ef885154$export$258538e0d3d46460);
const $69891a65ef885154$export$258538e0d3d46460 = (transition)=>{
    if (transition.name !== transition.to.name) return `${transition.name} ${transition.to.name}`;
    return transition.name;
};

});


parcelRegister("aKmI9", function(module, exports) {

$parcel$export(module.exports, "CreateStatusButton", () => $7f2792bccbea3643$export$d2e0b4f33d77a2b8);
/* CreateStatusButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $goZPP = parcelRequire("goZPP");

var $lmgo6 = parcelRequire("lmgo6");
var $bQP4O = parcelRequire("bQP4O");
var $1DXK0 = parcelRequire("1DXK0");

var $jOPSA = parcelRequire("jOPSA");

var $lRq8t = parcelRequire("lRq8t");

var $fiJwW = parcelRequire("fiJwW");

var $f7Yza = parcelRequire("f7Yza");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $epTsa = parcelRequire("epTsa");

var $lppZM = parcelRequire("lppZM");
var $bE8VR = parcelRequire("bE8VR");


var $kEUB1 = parcelRequire("kEUB1");

var $7jTnu = parcelRequire("7jTnu");

var $aaGSX = parcelRequire("aaGSX");

var $asoyU = parcelRequire("asoyU");

var $dSpUw = parcelRequire("dSpUw");

var $8yyDM = parcelRequire("8yyDM");

var $62tn0 = parcelRequire("62tn0");

var $eCUrP = parcelRequire("eCUrP");
const $7f2792bccbea3643$export$d2e0b4f33d77a2b8 = ({ projectId: projectId, projectKey: projectKey, projectType: projectType, issueTypeId: issueTypeId, statusNames: statusNames = [], isPressable: isPressable = false, onClick: onClick, onClose: onClose, onStatusCreated: onStatusCreated, buttonRef: buttonRef = null, source: source, shouldTriggerModal: shouldTriggerModal = true })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const cloudId = (0, $kEUB1.useCloudId)();
    const combinedInlineConfigurationExperiment = (0, $dSpUw.useCombinedInlineConfigurationExperiment)();
    const [inlineStatusConfigExp] = (0, $epTsa.UNSAFE_noExposureExp)('inline_status_add_and_rename_in_gic');
    const isInlineStatusExperimentEnabled = inlineStatusConfigExp.get('isInlineStatusConfigEnabled', false);
    const trigger = (0, $bE8VR.useTriggerContext)((0, $eCUrP.ConfigureStatusPanel));
    const handleClick = (0, $eJOHy.useCallback)((_e, analyticsEvent)=>{
        onClick();
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'createStatusButton'); // Because we are triggering the click manually for keyboard users
        // this handler becomes the source-of-truth handler for both keyboard users and mouse users
        // However, we need to stopPropagation from here to prevent double modal for mouse users
        // When mouse user clicks the button, if we don't stop propagation here, handleChange
        // will be called which will trigger click manually again and cause double modal rendering
        (combinedInlineConfigurationExperiment.isEnabled || isInlineStatusExperimentEnabled) && _e.stopPropagation();
    }, [
        combinedInlineConfigurationExperiment.isEnabled,
        isInlineStatusExperimentEnabled,
        onClick
    ]);
    const onModalClose = (0, $eJOHy.useCallback)(()=>{
        onClose();
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            action: 'closed',
            actionSubject: 'inlineCreateStatusModal'
        }));
    }, [
        createAnalyticsEvent,
        onClose
    ]);
    const onMouseDown = (0, $eJOHy.useCallback)(()=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'createStatusButton');
    }, [
        createAnalyticsEvent
    ]);
    const entryPointParams = (0, $eJOHy.useMemo)(()=>({
            cloudId: cloudId,
            projectKey: projectKey
        }), [
        cloudId,
        projectKey
    ]);
    const entryPointProps = (0, $eJOHy.useMemo)(()=>({
            statusNames: statusNames,
            projectId: projectId,
            projectKey: projectKey,
            projectType: projectType,
            onClose: onModalClose,
            isNewControllerEnabled: true,
            workflowAssociatedIssueTypeId: issueTypeId,
            createStatusExperience: $8yyDM.createStatusExperience,
            source: source || (0, $a63b79662d6e9902$export$cafb161c2b21b455),
            onStatusCreated: onStatusCreated,
            isWrappedInModal: shouldTriggerModal
        }), [
        statusNames,
        projectId,
        projectKey,
        projectType,
        onModalClose,
        issueTypeId,
        source,
        onStatusCreated,
        shouldTriggerModal
    ]);
    const getClickElement = (0, $eJOHy.useCallback)((ref)=>isPressable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bQP4O.default), {
            xcss: $7f2792bccbea3643$var$pressableStyles,
            onClick: handleClick,
            "data-show-on-hover": true // ref returned from entrypoint is of Type 'RefObject<HTMLElement>' is not assignable to type 'Ref<HTMLButtonElement>
            ,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ref: ref,
            onMouseDown: (event)=>{
                if (event.button === 0) // Left mouse button was clicked
                onMouseDown();
            }
        }, formatMessage((0, $62tn0.messages).createStatus)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
            xcss: $7f2792bccbea3643$var$flexContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($7f2792bccbea3643$var$StyledButton, {
            appearance: "subtle",
            shouldFitContainer: true,
            interactionName: "issue.fields.status.create-status.popup.open",
            onClick: handleClick,
            ref: ref
        }, formatMessage((0, $62tn0.messages).createStatus))), [
        formatMessage,
        handleClick,
        isPressable,
        onMouseDown
    ]);
    const modalTrigger = (0, $7jTnu.fg)('inline_config_migrate_deprecated_modal_entrypoints') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $asoyU.ModalTrigger), {
        entryPoint: (0, $jOPSA.asyncInlineCreateStatusModal),
        entryPointProps: entryPointProps,
        entryPointParams: entryPointParams,
        modalProps: (0, $fiJwW.defaultModalProps),
        forwardedRef: buttonRef,
        Fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aaGSX.FormDialogSkeleton), {
                numFormFields: 2
            })
    }, ({ ref: ref })=>getClickElement(ref)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f7Yza.ModalEntryPointPressableTrigger), {
        entryPoint: (0, $jOPSA.asyncInlineCreateStatusModal),
        entryPointProps: entryPointProps,
        entryPointParams: entryPointParams,
        interactionName: "create-status-modal",
        modalProps: (0, $fiJwW.defaultModalProps),
        useInternalModal: true,
        forwardedRef: buttonRef,
        Fallback: (0, $7jTnu.fg)('jgfeng_new_work_type_fallback_loading_state') ? ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aaGSX.FormDialogSkeleton), {
                numFormFields: 2
            }) : undefined
    }, ({ ref: ref })=>getClickElement(ref));
    return shouldTriggerModal ? modalTrigger : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lppZM.Trigger), {
        trigger: trigger,
        entryPoint: (0, $jOPSA.asyncInlineCreateStatusModal),
        entryPointParams: entryPointParams,
        entryPointProps: entryPointProps,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aaGSX.FormDialogSkeleton), {
            numFormFields: 2
        })
    }, ({ ref: ref })=>getClickElement(ref));
};
// Move all styled/xcss/css components to the bottom
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $7f2792bccbea3643$var$StyledButton = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $goZPP.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4cvr1h6o _y3gn1e5h _syaz1fxt _ca0qpxbi _u5f3utpp _n3tdpxbi _19bvutpp _4t3i1osq",
            __cmplp.className
        ])
    });
});
const $7f2792bccbea3643$var$flexContainerStyles = (0, $1DXK0.xcss)({
    flexGrow: 1,
    height: "var(--ds-space-500, 40px)"
});
const $7f2792bccbea3643$var$pressableStyles = (0, $1DXK0.xcss)({
    height: '100%',
    width: '100%',
    backgroundColor: 'color.background.neutral.subtle',
    alignItems: 'center',
    textAlign: 'left',
    fontWeight: 'font.weight.medium'
});

});
parcelRegister("jOPSA", function(module, exports) {

$parcel$export(module.exports, "asyncInlineCreateStatusModal", () => $84cb6d9719e04136$export$64a761d25b20910a);

var $e6LaQ = parcelRequire("e6LaQ");

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $84cb6d9719e04136$export$64a761d25b20910a = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("cHaxd")), {
        moduleId: "4ce02bb0",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId, projectKey: projectKey })=>({
            queries: {
                inlineCreateStatusModal: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $e6LaQ.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        })
});

});
parcelRegister("e6LaQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e7c266e7a20f6f1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a1c9f0ca0f32a1a7d832e77365f43e75>>
 * @relayHash 0df4748cd7c393765978be5843c7a913
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a6f93e860194a5c2419c4911409b28d0ab9e3c6da5d722ecc79fae56d217265b
const $0e7c266e7a20f6f1$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "a6f93e860194a5c2419c4911409b28d0ab9e3c6da5d722ecc79fae56d217265b",
        "metadata": {},
        "name": "srcAsyncInlineCreateStatusQuery",
        "operationKind": "query",
        "text": null
    }
};
var $0e7c266e7a20f6f1$export$2e2bcd8739ae039 = $0e7c266e7a20f6f1$var$node;

});

parcelRegister("cHaxd", function(module, exports) {

let $93e1ac29aacf6c06$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $93e1ac29aacf6c06$var$load("1hxuP").then(()=>parcelRequire('4BRVO'));

});


parcelRegister("fiJwW", function(module, exports) {

$parcel$export(module.exports, "defaultModalProps", () => $1c2c3e9e62ce7fa5$export$14c11acc66fd51b3);
const $1c2c3e9e62ce7fa5$export$14c11acc66fd51b3 = {
    width: '395px'
};

});

parcelRegister("bE8VR", function(module, exports) {

$parcel$export(module.exports, "useTriggerContext", () => $ce0c3b0e8f7e0532$export$454c1d7c35958f5e);

var $eJOHy = parcelRequire("eJOHy");
function $ce0c3b0e8f7e0532$export$454c1d7c35958f5e(panel) {
    const { setPanel: setPanel } = (0, $eJOHy.useContext)(panel.Context);
    return (0, $eJOHy.useMemo)(()=>({
            setPanel: setPanel
        }), [
        setPanel
    ]);
}

});

const $a63b79662d6e9902$export$c766acff4513a976 = 'summaryView';
const $a63b79662d6e9902$export$4edb790587638895 = 'listView';
const $a63b79662d6e9902$export$7e2d75b13279a710 = 'listViewNoResults';
const $a63b79662d6e9902$export$5e4b47163db377f = 'listViewGroupByStatus';
const $a63b79662d6e9902$export$cafb161c2b21b455 = 'issueView';
const $a63b79662d6e9902$export$66397ed56abea4ca = 'gicView';
const $a63b79662d6e9902$export$46d07e67f98555aa = 'editStatusButton';
const $a63b79662d6e9902$export$415149578ef78676 = 'deleteStatusButton';

parcelRegister("aaGSX", function(module, exports) {

$parcel$export(module.exports, "FormDialogSkeleton", () => $0b33aba420d5c901$export$3e5b4585c21ca29d);

var $eJOHy = parcelRequire("eJOHy");

var $lmgo6 = parcelRequire("lmgo6");
var $dW738 = parcelRequire("dW738");
var $1DXK0 = parcelRequire("1DXK0");

var $jjS5D = parcelRequire("jjS5D");
const $0b33aba420d5c901$var$COMMON_SKELETON_PROPS = {
    borderRadius: 8,
    isShimmering: true
};
const $0b33aba420d5c901$export$3e5b4585c21ca29d = ({ numFormFields: numFormFields })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        direction: "column",
        xcss: $0b33aba420d5c901$var$modalSkeletonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        direction: "column",
        xcss: $0b33aba420d5c901$var$headerSkeletonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        space: "space.250"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
        width: "40%",
        height: 24,
        ...$0b33aba420d5c901$var$COMMON_SKELETON_PROPS,
        testId: "form-dialog-skeleton.ui.header-title"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
        width: "35%",
        height: 16,
        ...$0b33aba420d5c901$var$COMMON_SKELETON_PROPS,
        testId: "form-dialog-skeleton.ui.header-subtitle"
    }))), Array.from({
        length: numFormFields
    }).map((_, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
            space: "space.050",
            key: idx,
            xcss: $0b33aba420d5c901$var$formFieldSkeletonStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
            width: "30%",
            height: 16,
            ...$0b33aba420d5c901$var$COMMON_SKELETON_PROPS,
            testId: `form-field-label-${idx}`
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
            width: "100%",
            height: 40,
            ...$0b33aba420d5c901$var$COMMON_SKELETON_PROPS,
            testId: `form-field-input-${idx}`
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        justifyContent: "end",
        gap: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
        width: 72,
        height: 32,
        ...$0b33aba420d5c901$var$COMMON_SKELETON_PROPS,
        testId: "form-dialog-skeleton.ui.cancel-button"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jjS5D.default), {
        width: 72,
        height: 32,
        ...$0b33aba420d5c901$var$COMMON_SKELETON_PROPS,
        testId: "form-dialog-skeleton.ui.submit-button"
    }))));
const $0b33aba420d5c901$var$modalSkeletonStyles = (0, $1DXK0.xcss)({
    backgroundColor: 'elevation.surface.overlay',
    borderRadius: '12px',
    width: '394px',
    padding: 'space.300'
});
const $0b33aba420d5c901$var$headerSkeletonStyles = (0, $1DXK0.xcss)({
    marginBottom: 'space.100'
});
const $0b33aba420d5c901$var$formFieldSkeletonStyles = (0, $1DXK0.xcss)({
    marginTop: 'space.100',
    marginBottom: 'space.100'
});

});

parcelRegister("8yyDM", function(module, exports) {

$parcel$export(module.exports, "createStatusExperience", () => $6417766cf755877a$export$750cfa63c61c5008);
$parcel$export(module.exports, "editStatusExperience", () => $6417766cf755877a$export$1c3aa89ea6d8c93d);

var $2lxLk = parcelRequire("2lxLk");
var $f39LL = parcelRequire("f39LL");
const $6417766cf755877a$export$750cfa63c61c5008 = new (0, $f39LL.UFOExperience)('issue-view.create-status', {
    type: (0, $2lxLk.ExperienceTypes).Operation,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).Custom
});
const $6417766cf755877a$export$1c3aa89ea6d8c93d = new (0, $f39LL.UFOExperience)('issue-view.edit-status', {
    type: (0, $2lxLk.ExperienceTypes).Operation,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).Custom
});

});

parcelRegister("62tn0", function(module, exports) {

$parcel$export(module.exports, "messages", () => $18af944bcfc95931$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $18af944bcfc95931$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    statusNameButtonLabel: {
        "id": "issue-field-status.status-view.transition.configure-status.status-name-button-label",
        "defaultMessage": "Edit {statusName} status"
    },
    editStatusTooltip: {
        "id": "issue-field-status.status-view.transition.configure-status.edit-status-tooltip",
        "defaultMessage": "Edit status"
    },
    createStatus: {
        "id": "issue-field-status.status-view.configure-status.create-status",
        "defaultMessage": "Create status"
    },
    editStatus: {
        "id": "issue-field-status.status-view.configure-status.edit-status",
        "defaultMessage": "Edit status"
    }
});

});

parcelRegister("eCUrP", function(module, exports) {

$parcel$export(module.exports, "ConfigureStatusPanel", () => $364d049240095d21$export$3f3f3d137a7524e6);

var $5j8hU = parcelRequire("5j8hU");
const $364d049240095d21$export$3f3f3d137a7524e6 = (0, $5j8hU.createPanel)();

});
parcelRegister("5j8hU", function(module, exports) {

$parcel$export(module.exports, "createPanel", () => $10eff731f4fb221b$export$71ce2d4d67b6d9e4);

var $eJOHy = parcelRequire("eJOHy");
function $10eff731f4fb221b$export$71ce2d4d67b6d9e4() {
    const Context = /*#__PURE__*/ (0, $eJOHy.createContext)({
        setPanel: ()=>{}
    });
    return {
        Context: Context
    };
}

});



parcelRegister("ke54d", function(module, exports) {

$parcel$export(module.exports, "LoadingSpinner", () => $90c5aa8926802ca9$export$b08b517936747730);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $7ep4S = parcelRequire("7ep4S");
const $90c5aa8926802ca9$export$b08b517936747730 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($90c5aa8926802ca9$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
        interactionName: "issue.fields.status.options.loading"
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $90c5aa8926802ca9$var$Wrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _y3gn1h6o",
            __cmplp.className
        ])
    });
});

});

parcelRegister("2gPiL", function(module, exports) {

$parcel$export(module.exports, "StatusButton", () => $d92569ee3c144684$export$517b7ecb2da8e76d);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $5lAAn = parcelRequire("5lAAn");

var $goZPP = parcelRequire("goZPP");

var $k71qx = parcelRequire("k71qx");

var $f2JN3 = parcelRequire("f2JN3");

var $6XJko = parcelRequire("6XJko");

var $7jTnu = parcelRequire("7jTnu");

var $lhTT7 = parcelRequire("lhTT7");

var $g1vYr = parcelRequire("g1vYr");
const $d92569ee3c144684$var$getButton = (categoryId)=>{
    switch(categoryId){
        case 2:
            return $d92569ee3c144684$var$ToDoButton;
        case 3:
            return 0, $g1vYr.DoneButton;
        case 4:
            return $d92569ee3c144684$var$InProgressButton;
        default:
            return $d92569ee3c144684$var$DefaultButton;
    }
};
const $d92569ee3c144684$var$buttonStyle = null;
const $d92569ee3c144684$var$buttonStyleRefresh = null;
const $d92569ee3c144684$export$517b7ecb2da8e76d = (props)=>{
    const { ariaLabel: ariaLabel, isEditable: isEditable, isOpen: isOpen, status: status, targetRef: targetRef, statusButtonRef: statusButtonRef, shouldFitContainer: shouldFitContainer = true, triggerProps: triggerProps = {}, helperTextId: helperTextId } = props;
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const Button = $d92569ee3c144684$var$getButton(status.statusCategory.id);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        ref: targetRef,
        ...triggerProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        position: "top",
        content: status.name
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lhTT7.default), {
        status: status
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Button, {
        id: "issue.fields.status-view.status-button",
        ref: statusButtonRef,
        "aria-label": ariaLabel,
        "aria-expanded": isOpen,
        isDisabled: !isEditable,
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5lAAn))), {
            label: "",
            size: "small"
        }),
        testId: "issue-field-status.ui.status-view.status-button.status-button",
        shouldFitContainer: shouldFitContainer,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        // When the popup is open we don't want to track the click on this button as it solely closes
        // the popup.
        // The logic here may look incorrect, but it turns out that when clicking this button the
        // `isOpen` toggle happens before the `onClick` handler that sends the press tracing.
        // We need to disable the `jira/ufo/valid-labels` lint rule
        // because for this particular interaction we only want to track
        // opening the status popup.
        // eslint-disable-next-line jira/ufo/valid-labels
        interactionName: isOpen ? 'issue.fields.status.popup.open' : undefined,
        "data-ssr-placeholder": false && (0, $7jTnu.fg)('magma-3344_status_button_ssr_placeholder') ? 'status-button' : undefined,
        "data-ssr-placeholder-replace": !false && (0, $7jTnu.fg)('magma-3344_status_button_ssr_placeholder') ? 'status-button' : undefined,
        ...(0, $7jTnu.fg)('jfp_a11y_issue_create_form_field_with_description') && {
            'aria-describedby': helperTextId
        },
        className: (0, $hcewu.default)([
            "_12r21pd9",
            (0, $6XJko.isVisualRefreshEnabled)() && "_19bv12x7 _1n8wglyw _12r21wq8"
        ])
    }, status.name))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $d92569ee3c144684$var$InProgressComponentVisualRefresh = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $goZPP.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "",
            !__cmplp.isSelected && "_193glmqn _11a4lmqn _dntb16l4 _cp4g16l4 _5xmdlmqn _11sm16l4",
            __cmplp.className
        ])
    });
});
const $d92569ee3c144684$var$InProgressComponentCurrent = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $goZPP.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "",
            !__cmplp.isSelected && "_193g1mk5 _11a41mk5 _dntb1gfe _cp4g1gfe _5xmd4vzc _11sm1gfe",
            __cmplp.className
        ])
    });
});
const $d92569ee3c144684$var$InProgressButton = (0, $f2JN3.componentWithCondition)((0, $6XJko.isVisualRefreshEnabled), $d92569ee3c144684$var$InProgressComponentVisualRefresh, $d92569ee3c144684$var$InProgressComponentCurrent);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $d92569ee3c144684$var$ToDoButton = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $goZPP.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "",
            !__cmplp.isSelected && "_193g1d94 _11a41d94 _dntb16l4 _cp4g16l4 _5xmd1hek _11sm16l4",
            __cmplp.className
        ])
    });
});
const $d92569ee3c144684$var$DefaultButton = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $goZPP.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "",
            !__cmplp.isSelected && "_193g1d94 _11a41d94 _dntb16l4 _cp4g16l4 _5xmd1hek _11sm16l4",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lhTT7", function(module, exports) {

$parcel$export(module.exports, "default", () => $b410745bf354b3d3$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $cdbP5 = parcelRequire("cdbP5");
// TODO consolidate status id's
const $b410745bf354b3d3$var$DONE_ID = 3;
class $b410745bf354b3d3$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    componentDidUpdate(prevProps) {
        if (prevProps.status.statusCategory.id !== this.props.status.statusCategory.id) this.setState({
            shouldShow: this.props.status.statusCategory.id === $b410745bf354b3d3$var$DONE_ID
        });
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b410745bf354b3d3$var$PulseContainer, {
            shouldShow: this.state.shouldShow
        }, this.props.children);
    }
    constructor(...args){
        super(...args), this.state = {
            shouldShow: false
        };
    }
}
const $b410745bf354b3d3$var$PulseAnimation = /*#__PURE__*/ (0, $cdbP5.keyframes)({
    to: {
        boxShadow: '0 0 0 10px rgba(0, 0, 0, 0)'
    }
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $b410745bf354b3d3$var$PulseContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldShow: shouldShow, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1qbqnkm": (0, $awdRS.default)($b410745bf354b3d3$var$PulseAnimation)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko1l7b _1e0c116y _1bsb1osq _16qs1pcf",
            __cmplp.shouldShow ? "_y44v1upg" : "_y44vglyw",
            __cmplp.className
        ])
    });
});

});

parcelRegister("g1vYr", function(module, exports) {

$parcel$export(module.exports, "DoneButton", () => $c2938a2595a34a4b$export$e6559310cd173125);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $goZPP = parcelRequire("goZPP");

var $f2JN3 = parcelRequire("f2JN3");

var $6XJko = parcelRequire("6XJko");
const $c2938a2595a34a4b$export$b7c3a2f69225ecf = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $goZPP.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "",
            !__cmplp.isSelected && "_193g1d94 _11a41d94 _dntb16l4 _cp4g16l4 _5xmd1hek _11sm16l4",
            __cmplp.className
        ])
    });
});
const $c2938a2595a34a4b$export$97f73b7c6e2328e5 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $goZPP.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "",
            !__cmplp.isSelected && "_193g1d94 _11a41d94 _dntb16l4 _cp4g16l4 _5xmd1hek _11sm16l4",
            __cmplp.className
        ])
    });
});
const $c2938a2595a34a4b$var$InProgressComponentVisualRefresh = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $goZPP.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "",
            !__cmplp.isSelected && "_193glmqn _11a4lmqn _dntb16l4 _cp4g16l4 _5xmdlmqn _11sm16l4",
            __cmplp.className
        ])
    });
});
const $c2938a2595a34a4b$var$InProgressComponentCurrent = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $goZPP.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "",
            !__cmplp.isSelected && "_193g1mk5 _11a41mk5 _dntb1gfe _cp4g1gfe _5xmd4vzc _11sm1gfe",
            __cmplp.className
        ])
    });
});
const $c2938a2595a34a4b$export$8c94aeefd701630d = (0, $f2JN3.componentWithCondition)((0, $6XJko.isVisualRefreshEnabled), $c2938a2595a34a4b$var$InProgressComponentVisualRefresh, $c2938a2595a34a4b$var$InProgressComponentCurrent);
const $c2938a2595a34a4b$export$5392037c0e6ad119 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $goZPP.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "",
            !__cmplp.isSelected && "_193g1jjx _11a41jjx _dntb16l4 _cp4g16l4 _5xmd1jjx _11sm16l4",
            __cmplp.className
        ])
    });
});
const $c2938a2595a34a4b$export$5445f55445c67248 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $goZPP.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "",
            !__cmplp.isSelected && "_193g1rwo _11a41rwo _dntb1gfe _cp4g1gfe _5xmd14kv _11sm1gfe",
            __cmplp.className
        ])
    });
});
const $c2938a2595a34a4b$export$e6559310cd173125 = (0, $f2JN3.componentWithCondition)((0, $6XJko.isVisualRefreshEnabled), $c2938a2595a34a4b$export$5392037c0e6ad119, $c2938a2595a34a4b$export$5445f55445c67248);

});


parcelRegister("dYFa5", function(module, exports) {

$parcel$export(module.exports, "Transition", () => $df43a9db530a58a1$export$be58926105124dd4);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $k71qx = parcelRequire("k71qx");

var $7MiYh = parcelRequire("7MiYh");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $3J5Vz = parcelRequire("3J5Vz");

var $89H4a = parcelRequire("89H4a");
const $df43a9db530a58a1$export$be58926105124dd4 = ({ hasLabel: hasLabel, transition: transition, addTransitionArrowSpacing: addTransitionArrowSpacing, contentAfter: contentAfter, testId: testId })=>{
    if (transition.isDisabled === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($df43a9db530a58a1$var$DisabledTransition, {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $89H4a.TransitionWithoutLabel), {
        transition: transition,
        isDisabled: true
    }), transition.unavailableReasonText != null && transition.unavailableReasonText !== '' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: transition.unavailableReasonText
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($df43a9db530a58a1$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7MiYh))), {
        label: "",
        color: "var(--ds-text-disabled, #091E424F)",
        spacing: "spacious",
        testId: "issue-field-status.ui.status-view.transition.information-icon"
    }))));
    const transitionComponent = hasLabel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3J5Vz.TransitionWithLabel), {
        transition: transition,
        addTransitionArrowSpacing: addTransitionArrowSpacing
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $89H4a.TransitionWithoutLabel), {
        transition: transition
    });
    return contentAfter ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testid": testId,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _1bah1yb4 _wjvokb7n"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $df43a9db530a58a1$var$transitionComponentStyles
    }, transitionComponent), contentAfter) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testid": testId
    }, transitionComponent);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $df43a9db530a58a1$var$DisabledTransition = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _2lx2vrvc _1bah1yb4",
            __cmplp.className
        ])
    });
});
const $df43a9db530a58a1$var$IconWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reoewfl _18m9ewfl _4t3io7ao _19pkr5cr",
            __cmplp.className
        ])
    });
});
const $df43a9db530a58a1$export$7ed12d2a5241e393 = {
    IconWrapper: $df43a9db530a58a1$var$IconWrapper
};
const $df43a9db530a58a1$var$transitionWrapperStyles = null;
const $df43a9db530a58a1$var$transitionComponentStyles = (0, $1DXK0.xcss)({
    alignItems: 'center',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});

});
parcelRegister("3J5Vz", function(module, exports) {

$parcel$export(module.exports, "TransitionWithLabel", () => $9223b88f79eab721$export$20d2722b94f01359);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $bcitO = parcelRequire("bcitO");

var $2sLVw = parcelRequire("2sLVw");

var $dTocu = parcelRequire("dTocu");

var $6XJko = parcelRequire("6XJko");

var $6UBwj = parcelRequire("6UBwj");

var $5q0Ec = parcelRequire("5q0Ec");
const $9223b88f79eab721$var$getLabel = (transition, intl)=>{
    if (transition.isGlobal) {
        if (transition.name !== transition.to.name) return transition.name;
        return intl.formatMessage((0, $5q0Ec.default).globalTransition);
    }
    return transition.name;
};
const $9223b88f79eab721$export$20d2722b94f01359 = (props)=>{
    const intl = (0, $dTocu.useIntlV2)();
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9223b88f79eab721$export$147422f7450ccfac, null, $9223b88f79eab721$var$getLabel(props.transition, intl)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9223b88f79eab721$export$da4545fe0ca096cf, {
        visualRefresh: (0, $6XJko.isVisualRefreshEnabled)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9223b88f79eab721$var$VerticalCenter, {
        addTransitionArrowSpacing: props.addTransitionArrowSpacing
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bcitO))), {
        label: "",
        LEGACY_size: "small",
        testId: "issue-field-status.ui.status-view.transition.with-label.arrow-right"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6UBwj.StatusLozenge), {
        status: props.transition.to,
        isDisabled: props.isDisabled
    })));
    if ((0, $6XJko.isVisualRefreshEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sLVw.default), {
        gap: "space.100"
    }, content);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9223b88f79eab721$var$Wrapper, null, content);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9223b88f79eab721$var$Wrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $9223b88f79eab721$export$147422f7450ccfac = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n",
            __cmplp.className
        ])
    });
});
const $9223b88f79eab721$export$da4545fe0ca096cf = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { visualRefresh: visualRefresh, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1o9zidpf _1e0c1txw",
            __cmplp.visualRefresh && "_zulpu2gc _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $9223b88f79eab721$var$VerticalCenter = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { addTransitionArrowSpacing: addTransitionArrowSpacing, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c116y _4cvr1h6o",
            __cmplp.addTransitionArrowSpacing ? "_18s8s8vo" : "_19pk1kw7 _2hwx1kw7 _otyr1kw7 _18u01kw7",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bcitO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::101a51255f7076752a2af1f3fc652adc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $826f266802ea1177$var$_react = $826f266802ea1177$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $826f266802ea1177$var$_arrowRight = $826f266802ea1177$var$_interopRequireDefault((parcelRequire("ePxSL")));

var $826f266802ea1177$var$_arrowRight2 = $826f266802ea1177$var$_interopRequireDefault((parcelRequire("WCqcH")));
function $826f266802ea1177$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ArrowRightIcon.
 * This component is ArrowRightIcon, with `UNSAFE_fallbackIcon` set to "ArrowRightIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $826f266802ea1177$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $826f266802ea1177$var$_react.default.createElement($826f266802ea1177$var$_arrowRight.default, Object.assign({
        LEGACY_fallbackIcon: $826f266802ea1177$var$_arrowRight2.default
    }, props));
$826f266802ea1177$var$ArrowRightIcon.Name = 'ArrowRightIconMigration';
var $826f266802ea1177$var$_default = module.exports.default = $826f266802ea1177$var$ArrowRightIcon;

});
parcelRegister("ePxSL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::11b8e18b02050eefbe32dafc654ee453>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $acc01c6bd1fc51c7$var$_react = $acc01c6bd1fc51c7$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $acc01c6bd1fc51c7$var$_baseNew = $acc01c6bd1fc51c7$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $acc01c6bd1fc51c7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $acc01c6bd1fc51c7$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $acc01c6bd1fc51c7$var$_react.default.createElement($acc01c6bd1fc51c7$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.44 7.25 8.72 3.53l1.06-1.06 5 5a.75.75 0 0 1 0 1.06l-5 5-1.06-1.06 3.72-3.72H1v-1.5z" clip-rule="evenodd"/>`
    }, props));
$acc01c6bd1fc51c7$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $acc01c6bd1fc51c7$var$_default = module.exports.default = $acc01c6bd1fc51c7$var$ArrowRightIcon;

});

parcelRegister("WCqcH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0b0338a1f0c13ece$var$_react = $0b0338a1f0c13ece$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $0b0338a1f0c13ece$var$_arrowRight = $0b0338a1f0c13ece$var$_interopRequireDefault((parcelRequire("ePxSL")));
function $0b0338a1f0c13ece$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0b0338a1f0c13ece$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $0b0338a1f0c13ece$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.793 5.793a1 1 0 0 0 0 1.414L15.586 11H6a1 1 0 0 0 0 2h9.586l-3.793 3.793a1 1 0 0 0 0 1.414c.39.39 1.024.39 1.415 0l5.499-5.5a1 1 0 0 0 .293-.679v-.057a1 1 0 0 0-.293-.678l-5.499-5.5a1 1 0 0 0-1.415 0"/></svg>`
    }, props, {
        newIcon: $0b0338a1f0c13ece$var$_arrowRight.default
    }));
$0b0338a1f0c13ece$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $0b0338a1f0c13ece$var$_default = module.exports.default = $0b0338a1f0c13ece$var$ArrowRightIcon;

});


parcelRegister("5q0Ec", function(module, exports) {

$parcel$export(module.exports, "default", () => $fca60fa9cc35a5eb$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $fca60fa9cc35a5eb$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    globalTransition: {
        "id": "issue-field-status.status-view.transition.with-label.global-transition",
        "defaultMessage": "Transition to"
    }
});

});


parcelRegister("89H4a", function(module, exports) {

$parcel$export(module.exports, "TransitionWithoutLabel", () => $27d57fa62e13b907$export$4cf2c7e5a408120e);

var $eJOHy = parcelRequire("eJOHy");

var $6UBwj = parcelRequire("6UBwj");
const $27d57fa62e13b907$export$4cf2c7e5a408120e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6UBwj.StatusLozenge), {
        status: props.transition.to,
        isDisabled: props.isDisabled
    });

});


parcelRegister("kTIpG", function(module, exports) {

$parcel$export(module.exports, "CreateStatusOption", () => $569a891a9eea5bfd$export$be2add8d223902cf);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $jOPSA = parcelRequire("jOPSA");

var $lRq8t = parcelRequire("lRq8t");

var $fiJwW = parcelRequire("fiJwW");

var $f7Yza = parcelRequire("f7Yza");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $lppZM = parcelRequire("lppZM");
var $bE8VR = parcelRequire("bE8VR");


var $kEUB1 = parcelRequire("kEUB1");

var $7jTnu = parcelRequire("7jTnu");

var $aaGSX = parcelRequire("aaGSX");

var $asoyU = parcelRequire("asoyU");

var $8yyDM = parcelRequire("8yyDM");

var $eCUrP = parcelRequire("eCUrP");

var $62tn0 = parcelRequire("62tn0");
const $569a891a9eea5bfd$export$be2add8d223902cf = ({ projectId: projectId, projectKey: projectKey, projectType: projectType, issueTypeId: issueTypeId, statusNames: statusNames = [], onClick: onClick, onClose: onClose, onStatusCreated: onStatusCreated, buttonRef: buttonRef, source: source, shouldTriggerModal: shouldTriggerModal = true })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const cloudId = (0, $kEUB1.useCloudId)();
    const trigger = (0, $bE8VR.useTriggerContext)((0, $eCUrP.ConfigureStatusPanel));
    const handleClick = (0, $eJOHy.useCallback)((_e)=>{
        onClick();
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'createStatusButton');
        // Because we are triggering the click manually for keyboard users
        // this handler becomes the source-of-truth handler for both keyboard users and mouse users
        // However, we need to stopPropagation from here to prevent double modal for mouse users
        // When mouse user clicks the button, if we don't stop propagation here, handleChange
        // will be called which will trigger click manually again and cause double modal rendering
        _e.stopPropagation();
    }, [
        onClick,
        createAnalyticsEvent
    ]);
    const onModalClose = (0, $eJOHy.useCallback)(()=>{
        onClose();
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            action: 'closed',
            actionSubject: 'inlineCreateStatusModal'
        }));
    }, [
        createAnalyticsEvent,
        onClose
    ]);
    const onMouseDown = (0, $eJOHy.useCallback)(()=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'createStatusButton');
    }, [
        createAnalyticsEvent
    ]);
    const entryPointParams = (0, $eJOHy.useMemo)(()=>({
            cloudId: cloudId,
            projectKey: projectKey
        }), [
        cloudId,
        projectKey
    ]);
    const entryPointProps = (0, $eJOHy.useMemo)(()=>({
            statusNames: statusNames,
            projectId: projectId,
            projectKey: projectKey,
            projectType: projectType,
            onClose: onModalClose,
            isNewControllerEnabled: true,
            workflowAssociatedIssueTypeId: issueTypeId,
            createStatusExperience: $8yyDM.createStatusExperience,
            source: source || (0, $a63b79662d6e9902$export$cafb161c2b21b455),
            onStatusCreated: onStatusCreated,
            isWrappedInModal: shouldTriggerModal
        }), [
        statusNames,
        projectId,
        projectKey,
        projectType,
        onModalClose,
        issueTypeId,
        source,
        onStatusCreated,
        shouldTriggerModal
    ]);
    const getClickElement = (0, $eJOHy.useCallback)((ref)=>// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            role: "button",
            xcss: $569a891a9eea5bfd$var$optionStyles,
            onClick: handleClick,
            "data-show-on-hover": true,
            ref: ref,
            onMouseDown: (event)=>{
                if (event.button === 0) // Left mouse button was clicked
                onMouseDown();
            }
        }, formatMessage((0, $62tn0.messages).createStatus)), [
        formatMessage,
        handleClick,
        onMouseDown
    ]);
    const modalTrigger = (0, $7jTnu.fg)('inline_config_migrate_deprecated_modal_entrypoints') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $asoyU.ModalTrigger), {
        entryPoint: (0, $jOPSA.asyncInlineCreateStatusModal),
        entryPointProps: entryPointProps,
        entryPointParams: entryPointParams,
        modalProps: (0, $fiJwW.defaultModalProps),
        forwardedRef: buttonRef,
        Fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aaGSX.FormDialogSkeleton), {
                numFormFields: 2
            })
    }, ({ ref: ref })=>getClickElement(ref)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f7Yza.ModalEntryPointPressableTrigger), {
        entryPoint: (0, $jOPSA.asyncInlineCreateStatusModal),
        entryPointProps: entryPointProps,
        entryPointParams: entryPointParams,
        interactionName: "create-status-modal",
        modalProps: (0, $fiJwW.defaultModalProps),
        useInternalModal: true,
        forwardedRef: buttonRef,
        Fallback: (0, $7jTnu.fg)('jgfeng_new_work_type_fallback_loading_state') ? ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aaGSX.FormDialogSkeleton), {
                numFormFields: 2
            }) : undefined
    }, ({ ref: ref })=>getClickElement(ref));
    return shouldTriggerModal ? modalTrigger : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lppZM.Trigger), {
        trigger: trigger,
        entryPoint: (0, $jOPSA.asyncInlineCreateStatusModal),
        entryPointParams: entryPointParams,
        entryPointProps: entryPointProps,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aaGSX.FormDialogSkeleton), {
            numFormFields: 2
        })
    }, ({ ref: ref })=>getClickElement(ref));
};
const $569a891a9eea5bfd$var$optionStyles = (0, $1DXK0.xcss)({
    height: '100%',
    width: '100%',
    backgroundColor: 'color.background.neutral.subtle',
    alignItems: 'center',
    textAlign: 'left',
    fontWeight: 'font.weight.medium'
});

});

parcelRegister("7Pc1n", function(module, exports) {

$parcel$export(module.exports, "EditStatusOption", () => $2099be11c3b3c83c$export$9550e3e17c5a4a3a);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $l1viU = parcelRequire("l1viU");

var $lRq8t = parcelRequire("lRq8t");

var $fiJwW = parcelRequire("fiJwW");

var $f7Yza = parcelRequire("f7Yza");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $lppZM = parcelRequire("lppZM");
var $bE8VR = parcelRequire("bE8VR");


var $7jTnu = parcelRequire("7jTnu");

var $aaGSX = parcelRequire("aaGSX");

var $asoyU = parcelRequire("asoyU");

var $8yyDM = parcelRequire("8yyDM");

var $eCUrP = parcelRequire("eCUrP");

var $62tn0 = parcelRequire("62tn0");
const $2099be11c3b3c83c$export$9550e3e17c5a4a3a = ({ projectId: projectId, projectKey: projectKey, issueTypeId: issueTypeId, statusNames: statusNames = [], status: status, statuses: statuses, onClick: onClick, onClose: onClose, onStatusUpdated: onStatusUpdated = Promise.resolve, buttonRef: buttonRef, source: source, shouldTriggerModal: shouldTriggerModal = true })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const trigger = (0, $bE8VR.useTriggerContext)((0, $eCUrP.ConfigureStatusPanel));
    const handleClick = (0, $eJOHy.useCallback)((_e)=>{
        onClick();
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'editStatusButton');
        // Because we are triggering the click manually for keyboard users
        // this handler becomes the source-of-truth handler for both keyboard users and mouse users
        // However, we need to stopPropagation from here to prevent double modal for mouse users
        // When mouse user clicks the button, if we don't stop propagation here, handleChange
        // will be called which will trigger click manually again and cause double modal rendering
        _e.stopPropagation();
    }, [
        onClick,
        createAnalyticsEvent
    ]);
    const onModalClose = (0, $eJOHy.useCallback)(()=>{
        onClose();
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            action: 'closed',
            actionSubject: 'inlineEditStatusModal'
        }));
    }, [
        createAnalyticsEvent,
        onClose
    ]);
    const onMouseDown = (0, $eJOHy.useCallback)(()=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'editStatusButton');
    }, [
        createAnalyticsEvent
    ]);
    const entryPointProps = (0, $eJOHy.useMemo)(()=>({
            status: status,
            statuses: statuses,
            statusNames: statusNames,
            projectId: projectId,
            projectKey: projectKey,
            onClose: onModalClose,
            isNewControllerEnabled: true,
            issueTypeId: issueTypeId,
            editStatusExperience: $8yyDM.editStatusExperience,
            source: source || (0, $a63b79662d6e9902$export$cafb161c2b21b455),
            onStatusUpdated: onStatusUpdated,
            shouldShowStatusSelect: true,
            isWrappedInModal: shouldTriggerModal
        }), [
        statusNames,
        projectId,
        projectKey,
        issueTypeId,
        source,
        status,
        statuses,
        onStatusUpdated,
        onModalClose,
        shouldTriggerModal
    ]);
    const getClickElement = (0, $eJOHy.useCallback)((ref)=>// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            role: "button",
            xcss: $2099be11c3b3c83c$var$optionStyles,
            onClick: handleClick,
            "data-show-on-hover": true,
            ref: ref,
            onMouseDown: (event)=>{
                if (event.button === 0) // Left mouse button was clicked
                onMouseDown();
            }
        }, formatMessage((0, $62tn0.messages).editStatus)), [
        handleClick,
        formatMessage,
        onMouseDown
    ]);
    const modalTrigger = (0, $7jTnu.fg)('inline_config_migrate_deprecated_modal_entrypoints') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $asoyU.ModalTrigger), {
        entryPoint: (0, $l1viU.asyncInlineEditStatusModal),
        entryPointProps: entryPointProps,
        modalProps: (0, $fiJwW.defaultModalProps),
        forwardedRef: buttonRef,
        Fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aaGSX.FormDialogSkeleton), {
                numFormFields: 3
            })
    }, ({ ref: ref })=>getClickElement(ref)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f7Yza.ModalEntryPointPressableTrigger), {
        entryPoint: (0, $l1viU.asyncInlineEditStatusModal),
        entryPointProps: entryPointProps,
        interactionName: "edit-status-modal",
        modalProps: (0, $fiJwW.defaultModalProps),
        useInternalModal: true,
        forwardedRef: buttonRef,
        Fallback: (0, $7jTnu.fg)('jgfeng_new_work_type_fallback_loading_state') ? ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aaGSX.FormDialogSkeleton), {
                numFormFields: 3
            }) : undefined
    }, ({ ref: ref })=>getClickElement(ref));
    return shouldTriggerModal ? modalTrigger : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lppZM.Trigger), {
        trigger: trigger,
        entryPoint: (0, $l1viU.asyncInlineEditStatusModal),
        entryPointProps: entryPointProps,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aaGSX.FormDialogSkeleton), {
            numFormFields: 3
        })
    }, ({ ref: ref })=>getClickElement(ref));
};
const $2099be11c3b3c83c$var$optionStyles = (0, $1DXK0.xcss)({
    height: '100%',
    width: '100%',
    backgroundColor: 'color.background.neutral.subtle',
    alignItems: 'center',
    textAlign: 'left',
    fontWeight: 'font.weight.medium'
});

});
parcelRegister("l1viU", function(module, exports) {

$parcel$export(module.exports, "asyncInlineEditStatusModal", () => $b27a6b36d5d6ed96$export$c3f451c40832a786);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $b27a6b36d5d6ed96$export$c3f451c40832a786 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("d5yXX")).then((module)=>module.AsyncInlineEditStatusModal), {
        moduleId: "177d76fa",
        moduleName: "AsyncInlineEditStatusModal",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("d5yXX", function(module, exports) {

let $9876dd7fb0e2f485$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $9876dd7fb0e2f485$var$load("i6I9Z").then(()=>parcelRequire('j06kL'));

});



parcelRegister("8X6rE", function(module, exports) {

$parcel$export(module.exports, "EditStatusButton", () => $2ea55c5659695c38$export$bc1c056aa3d67f87);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $lmgo6 = parcelRequire("lmgo6");
var $bQP4O = parcelRequire("bQP4O");
var $1DXK0 = parcelRequire("1DXK0");

var $l1viU = parcelRequire("l1viU");

var $lRq8t = parcelRequire("lRq8t");

var $fiJwW = parcelRequire("fiJwW");


var $f7Yza = parcelRequire("f7Yza");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $lppZM = parcelRequire("lppZM");
var $bE8VR = parcelRequire("bE8VR");

var $7jTnu = parcelRequire("7jTnu");

var $aaGSX = parcelRequire("aaGSX");

var $asoyU = parcelRequire("asoyU");

var $8yyDM = parcelRequire("8yyDM");

var $62tn0 = parcelRequire("62tn0");

var $eCUrP = parcelRequire("eCUrP");
const $2ea55c5659695c38$export$bc1c056aa3d67f87 = ({ projectId: projectId, projectKey: projectKey, issueTypeId: issueTypeId, statusNames: statusNames = [], status: status, statuses: statuses, onClick: onClick, onClose: onClose, onStatusUpdated: onStatusUpdated = Promise.resolve, buttonRef: buttonRef, source: source, shouldTriggerModal: shouldTriggerModal = true })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const trigger = (0, $bE8VR.useTriggerContext)((0, $eCUrP.ConfigureStatusPanel));
    const handleClick = (0, $eJOHy.useCallback)((_e)=>{
        onClick();
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'editStatusButton');
        // Because we are triggering the click manually for keyboard users
        // this handler becomes the source-of-truth handler for both keyboard users and mouse users
        // However, we need to stopPropagation from here to prevent double modal for mouse users
        // When mouse user clicks the button, if we don't stop propagation here, handleChange
        // will be called which will trigger click manually again and cause double modal rendering
        _e.stopPropagation();
    }, [
        onClick,
        createAnalyticsEvent
    ]);
    const onModalClose = (0, $eJOHy.useCallback)(()=>{
        onClose();
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            action: 'closed',
            actionSubject: 'inlineEditStatusModal'
        }));
    }, [
        createAnalyticsEvent,
        onClose
    ]);
    const entryPointProps = (0, $eJOHy.useMemo)(()=>({
            status: status,
            statuses: statuses,
            statusNames: statusNames,
            projectId: projectId,
            projectKey: projectKey,
            onClose: onModalClose,
            isNewControllerEnabled: true,
            issueTypeId: issueTypeId,
            editStatusExperience: $8yyDM.editStatusExperience,
            source: source || (0, $a63b79662d6e9902$export$cafb161c2b21b455),
            onStatusUpdated: onStatusUpdated,
            shouldShowStatusSelect: true,
            isWrappedInModal: shouldTriggerModal
        }), [
        statusNames,
        projectId,
        projectKey,
        issueTypeId,
        source,
        status,
        statuses,
        onStatusUpdated,
        onModalClose,
        shouldTriggerModal
    ]);
    const getClickElement = (0, $eJOHy.useCallback)((ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
            xcss: $2ea55c5659695c38$var$flexContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bQP4O.default), {
            testId: "issue-field-status.ui.status-view.configure-status.edit-status-button",
            xcss: $2ea55c5659695c38$var$pressableStyles,
            onClick: handleClick,
            "data-show-on-hover": true,
            // ref returned from entrypoint is of Type 'RefObject<HTMLElement>' is not assignable to type 'Ref<HTMLButtonElement>
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ref: ref
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $2ea55c5659695c38$var$textWrapperStyle
        }, formatMessage((0, $62tn0.messages).editStatus)))), [
        handleClick,
        formatMessage
    ]);
    const modalTrigger = (0, $7jTnu.fg)('inline_config_migrate_deprecated_modal_entrypoints') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $asoyU.ModalTrigger), {
        entryPoint: (0, $l1viU.asyncInlineEditStatusModal),
        entryPointProps: entryPointProps,
        modalProps: (0, $fiJwW.defaultModalProps),
        forwardedRef: buttonRef,
        Fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aaGSX.FormDialogSkeleton), {
                numFormFields: 3
            })
    }, ({ ref: ref })=>getClickElement(ref)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f7Yza.ModalEntryPointPressableTrigger), {
        entryPoint: (0, $l1viU.asyncInlineEditStatusModal),
        entryPointProps: entryPointProps,
        interactionName: "edit-status-modal",
        modalProps: (0, $fiJwW.defaultModalProps),
        useInternalModal: true,
        forwardedRef: buttonRef,
        Fallback: (0, $7jTnu.fg)('jgfeng_new_work_type_fallback_loading_state') ? ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aaGSX.FormDialogSkeleton), {
                numFormFields: 3
            }) : undefined
    }, ({ ref: ref })=>getClickElement(ref));
    return shouldTriggerModal ? modalTrigger : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lppZM.Trigger), {
        trigger: trigger,
        entryPoint: (0, $l1viU.asyncInlineEditStatusModal),
        entryPointProps: entryPointProps,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aaGSX.FormDialogSkeleton), {
            numFormFields: 3
        })
    }, ({ ref: ref })=>getClickElement(ref));
};
const $2ea55c5659695c38$var$flexContainerStyles = (0, $1DXK0.xcss)({
    flexGrow: 1,
    height: "var(--ds-space-500, 40px)"
});
const $2ea55c5659695c38$var$pressableStyles = (0, $1DXK0.xcss)({
    height: '100%',
    width: '100%',
    color: 'color.text',
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    backgroundColor: 'color.background.neutral.subtle',
    alignItems: 'center',
    textAlign: 'left',
    paddingInline: 'space.150',
    fontWeight: 'font.weight.medium',
    ':hover': {
        backgroundColor: 'color.background.neutral'
    },
    ':focus-visible': {
        borderRadius: 'border.radius'
    }
});
const $2ea55c5659695c38$var$textWrapperStyle = (0, $1DXK0.xcss)({
    marginInline: 'space.025'
});

});

parcelRegister("fkCrf", function(module, exports) {

$parcel$export(module.exports, "ConfigureStatusPopup", () => $fc218b74133b5a34$export$35b5c681217bd086);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $cNe2t = parcelRequire("cNe2t");
const $fc218b74133b5a34$export$35b5c681217bd086 = ({ renderTarget: renderTarget, isTargetEditable: isTargetEditable, placement: placement, onClose: onClose, renderPopupContent: renderPopupContent })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cNe2t.JiraPopup), {
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                xcss: $fc218b74133b5a34$var$popupContentStyles,
                role: "dialog",
                "aria-modal": "false",
                "aria-labelledby": "configure-status-form-popup-header"
            }, renderPopupContent()),
        isOpen: true,
        onClose: onClose,
        placement: placement,
        messageId: "issue-field-status.ui.status-view.configure-status.popup",
        messageType: "transactional",
        trigger: (triggerProps)=>renderTarget({
                isEditable: isTargetEditable,
                isSaving: false,
                targetRef: undefined,
                triggerProps: triggerProps
            }),
        shouldRenderToParent: true
    });
};
const $fc218b74133b5a34$var$popupContentStyles = (0, $1DXK0.xcss)({
    width: '395px'
});

});


const $0c1224accd0013fc$export$c9f0eab6c600e941 = 'manageWorkflowButton';
const $0c1224accd0013fc$export$74ba9d5182d4cdae = 'manageIssueTypesButton';

parcelRegister("kHTL4", function(module, exports) {

$parcel$export(module.exports, "useOpenManageFieldTab", () => $95d3d6d8c9ee0f69$export$98ede961f3b934c0);

var $eJOHy = parcelRequire("eJOHy");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $jipjz = parcelRequire("jipjz");

var $2bdtd = parcelRequire("2bdtd");
const $95d3d6d8c9ee0f69$export$98ede961f3b934c0 = ({ source: source, url: url })=>{
    const [{ inProgressIssueID: inProgressIssueID }] = (0, $jipjz.useTriggerIssueCreateModal)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { onModalClosed: onModalClosed } = (0, $2bdtd.useInProgressIssueActions)();
    const openManageWorkTypesTab = (0, $eJOHy.useCallback)(()=>{
        if (inProgressIssueID) {
            // This will help prevent GIC modal from triggering in new tab
            onModalClosed({
                inProgressIssueID: inProgressIssueID
            });
            (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button'
            }), source);
            globalThis.window?.open(url, '_blank');
        }
    }, [
        createAnalyticsEvent,
        inProgressIssueID,
        onModalClosed,
        source,
        url
    ]);
    return openManageWorkTypesTab;
};

});

parcelRegister("g35oM", function(module, exports) {

$parcel$export(module.exports, "ManageFieldButton", () => $1a06a2512753e729$export$6bde45967ca110d);

var $eJOHy = parcelRequire("eJOHy");

var $lmgo6 = parcelRequire("lmgo6");
var $bQP4O = parcelRequire("bQP4O");
var $1DXK0 = parcelRequire("1DXK0");

var $kHTL4 = parcelRequire("kHTL4");
const $1a06a2512753e729$export$6bde45967ca110d = ({ url: url, label: label, source: source, isFooterOption: isFooterOption })=>{
    const openManageFieldTab = (0, $kHTL4.useOpenManageFieldTab)({
        source: source,
        url: url
    });
    const button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bQP4O.default), {
        xcss: isFooterOption ? $1a06a2512753e729$var$footerOptionStyles : $1a06a2512753e729$var$buttonStyles,
        onClick: openManageFieldTab
    }, label);
    return isFooterOption ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, button) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        xcss: $1a06a2512753e729$var$flexContainerStyles
    }, button);
};
const $1a06a2512753e729$var$buttonStyles = (0, $1DXK0.xcss)({
    borderRadius: 'border.radius',
    alignItems: 'center',
    textAlign: 'left',
    fontWeight: 'font.weight.medium',
    padding: 'space.150',
    height: '100%',
    width: '100%',
    color: 'color.text',
    backgroundColor: 'color.background.neutral.subtle',
    ':hover': {
        backgroundColor: 'color.background.input.hovered'
    }
});
const $1a06a2512753e729$var$footerOptionStyles = (0, $1DXK0.xcss)({
    alignItems: 'center',
    textAlign: 'left',
    fontWeight: 'font.weight.medium',
    height: '100%',
    width: '100%',
    backgroundColor: 'color.background.neutral.subtle'
});
const $1a06a2512753e729$var$flexContainerStyles = (0, $1DXK0.xcss)({
    flexGrow: 1,
    height: "var(--ds-space-500, 40px)"
});

});

parcelRegister("ask4k", function(module, exports) {

$parcel$export(module.exports, "default", () => $4623a4e42af18b6c$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $4623a4e42af18b6c$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    statusFieldLabel: {
        "id": "issue-create.modal.create-form.status-field.status-field-label",
        "defaultMessage": "Status"
    },
    unavailableStatusText: {
        "id": "issue-create.modal.create-form.status-field.unavailable-status-text",
        "defaultMessage": "Your workflow doesn't allow issues to be created in this status"
    },
    helperText: {
        "id": "issue-create.modal.create-form.status-field.helper-text",
        "defaultMessage": "This is the initial status upon creation"
    },
    noEnabledTransitionsMessage: {
        "id": "issue-create.modal.create-form.status-field.no-enabled-transitions-message",
        "defaultMessage": "There are no statuses available for you to use"
    },
    warningIconLabel: {
        "id": "issue-create.modal.create-form.status-field.warning-icon-label",
        "defaultMessage": "Warning"
    },
    warningMessage: {
        "id": "issue-create.modal.create-form.status-field.warning-message",
        "defaultMessage": "This field isn\u2019t working right now. You can still create your issue and update the status later."
    },
    unavailableStatusTextIssueTermRefresh: {
        "id": "issue-create.modal.create-form.status-field.unavailable-status-text-issue-term-refresh",
        "defaultMessage": "Your workflow doesn't allow work items to be created in this status"
    },
    warningMessageIssueTermRefresh: {
        "id": "issue-create.modal.create-form.status-field.warning-message-issue-term-refresh",
        "defaultMessage": "This field isn\u2019t working right now. You can still create your work item and update the status later."
    },
    warningMessageIssueTerminologyRefreshM4: {
        "id": "issue-create.modal.create-form.status-field.warning-message-issue-terminology-refresh-m4",
        "defaultMessage": "This field isn\u2019t working right now. You can still create the {issueType} and update the status later."
    },
    manageWorkflowFooter: {
        "id": "issue-create.modal.create-form.status-field.manage-workflow",
        "defaultMessage": "Manage workflow"
    }
});

});


parcelRegister("5IMhp", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e60f383fd4237d3$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $cdbP5 = parcelRequire("cdbP5");

var $12DRg = parcelRequire("12DRg");

var $fKXve = parcelRequire("fKXve");
var $6svxr = parcelRequire("6svxr");

var $c4OV1 = parcelRequire("c4OV1");

var $ln6Iy = parcelRequire("ln6Iy");

var $dPMMf = parcelRequire("dPMMf");

var $4NEt5 = parcelRequire("4NEt5");

var $aGmG9 = parcelRequire("aGmG9");

var $jipjz = parcelRequire("jipjz");

var $epTsa = parcelRequire("epTsa");

var $7jTnu = parcelRequire("7jTnu");

var $a1pDt = parcelRequire("a1pDt");

var $lRq8t = parcelRequire("lRq8t");

var $jMRoT = parcelRequire("jMRoT");

var $dxW4o = parcelRequire("dxW4o");
var $mWfDl = parcelRequire("mWfDl");
var $bYusI = parcelRequire("bYusI");


var $coifs = parcelRequire("coifs");

var $fE4zR = parcelRequire("fE4zR");

var $jQUoP = parcelRequire("jQUoP");

var $9QSSI = parcelRequire("9QSSI");

var $BAHbx = parcelRequire("BAHbx");

var $814y1 = parcelRequire("814y1");

var $6d9QY = parcelRequire("6d9QY");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");


var $gvcEL = parcelRequire("gvcEL");

var $enLyD = parcelRequire("enLyD");

var $caLfe = parcelRequire("caLfe");


var $iIqFO = parcelRequire("iIqFO");

var $5S4to = parcelRequire("5S4to");

var $c3eoY = parcelRequire("c3eoY");

var $1wGYs = parcelRequire("1wGYs");

var $kHTL4 = parcelRequire("kHTL4");



var $amdjq = parcelRequire("amdjq");

var $fugYy = parcelRequire("fugYy");

var $42ofz = parcelRequire("42ofz");

var $jr9QD = parcelRequire("jr9QD");

var $2TyrS = parcelRequire("2TyrS");

var $8Xb7Q = parcelRequire("8Xb7Q");

var $bg1hW = parcelRequire("bg1hW");
const $4e60f383fd4237d3$var$typePickerMargin = (0, $dPMMf.gridSize) * 2.25;
const $4e60f383fd4237d3$var$TypePicker = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { onChange: onChange, onIssueTypeCreatedOrUpdated: onIssueTypeCreatedOrUpdated, issueTypes: issueTypes, requestTypes: requestTypes, value: selectedRequestOrIssueType, isDisabled: isDisabled = false, isMini: isMini, projectType: projectType = null, projectId: projectId, projectKey: projectKey, canConfigureIssueTypes: canConfigureIssueTypes = false } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const previousSelectedRequestOrIssueType = (0, $6d9QY.usePrevious)(selectedRequestOrIssueType);
    const selectRef = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useEffect)(()=>{
        // if the default selection has request type of "none"
        // then we will change it to select the first matching request type
        if (// we have request type data
        requestTypes && // previously data was loading
        previousSelectedRequestOrIssueType === null && // an issue type is selected
        // i.e. this is the default selection
        // and it has a "none" request type
        selectedRequestOrIssueType && selectedRequestOrIssueType.type === (0, $4246188a36de9908$export$ebb48b08205007c5)) {
            const firstMatchingRequestType = (0, $fugYy.getFirstMatchingRequestType)({
                issueType: selectedRequestOrIssueType,
                allRequestTypes: requestTypes
            });
            if (firstMatchingRequestType) {
                onChange(firstMatchingRequestType);
                (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'gicRequestTypeSelect forceDefaultNotNone');
            }
        }
    }, [
        createAnalyticsEvent,
        onChange,
        previousSelectedRequestOrIssueType,
        requestTypes,
        selectedRequestOrIssueType
    ]);
    const getIssueTypeHelpText = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $coifs.FieldMessage), {
            fieldHelpTextUrl: (0, $8cd4b70a00850d28$export$4435027827ccff2d),
            fieldName: "Issue Type",
            onLinkClickEvent: (0, $1wGYs.openInNewTabLinkClickEventHandler),
            isMini: isMini
        }), [
        isMini
    ]); // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [inlineIssueTypeConfigExp, fireExposure] = (0, $epTsa.UNSAFE_noExposureExp)('jira_create_issue_type_in_gic_view'); // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [inlineCombinedImpactConfigExp, fireCombinedImpactExposure] = (0, $epTsa.UNSAFE_noExposureExp)('combined_adoption_configuration_experiment');
    const createIssueTypeButtonRef = (0, $eJOHy.useRef)(null);
    const editIssueTypeButtonRef = (0, $eJOHy.useRef)(null); // TODO: (JGFENG-1268) Remove below when cleaning up jira_gic_inline_create_work_type_refactor
    const createIssueTypeModalRef = (0, $eJOHy.useRef)(null);
    const onPreloadCreateIssueTypeModal = ()=>{
        createIssueTypeModalRef.current?.preload();
    };
    const onLoadCreateIssueTypeModal = ()=>{
        createIssueTypeModalRef.current?.load();
    };
    const [{ meta: { submitFieldwiseErrors: submitFieldwiseErrors } }] = (0, $jQUoP.useFormContext)();
    (0, $eJOHy.useEffect)(()=>{
        if (submitFieldwiseErrors?.issuetype) (0, $c3eoY.scrollToElement)((0, $8cd4b70a00850d28$export$f1623876ce3d4391));
    }, [
        submitFieldwiseErrors?.issuetype
    ]);
    const isInlineIssueTypeConfigEnabled = inlineIssueTypeConfigExp.get('isInlineIssueTypeConfigEnabled', false);
    const isInlineCombinedImpactConfigEnabled = inlineCombinedImpactConfigExp.get('isEnabled', false);
    const refocusSelectField = isInlineIssueTypeConfigEnabled || isInlineCombinedImpactConfigEnabled ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $fugYy.useRefocusSelectField)(selectRef) : (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)));
    const [isConfigureWorkTypePopupOpen, setIsConfigureWorkTypePopupOpen] = (0, $eJOHy.useState)(false); // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [inlineIssueTypeConfigProductionizationExpConfig] = (0, $epTsa.UNSAFE_noExposureExp)('inline_issue_type_config_productionization_exp'); // Whether footer actions in the type picker should trigger modals (or, if false, popups)
    const shouldTriggerModal = inlineIssueTypeConfigProductionizationExpConfig.get('isEnabled', false) && (0, $7jTnu.fg)('inline_issue_type_config_productionization_prereqs') ? Boolean(isMini) : true;
    const { Panel: ConfigureWorkTypePopupContent, Provider: ConfigureWorkTypePopupTriggerContextProvider } = (0, $5S4to.usePanelContext)((0, $8Xb7Q.ConfigureWorkTypePanel));
    const onClickCreateOrEditOption = (0, $eJOHy.useCallback)((buttonName)=>{
        if (!shouldTriggerModal) setIsConfigureWorkTypePopupOpen(true);
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, buttonName);
    }, [
        createAnalyticsEvent,
        shouldTriggerModal
    ]);
    const onCloseConfigureWorkType = (0, $eJOHy.useCallback)(()=>{
        if (!shouldTriggerModal) setIsConfigureWorkTypePopupOpen(false);
        refocusSelectField();
    }, [
        shouldTriggerModal,
        refocusSelectField
    ]);
    const openManageWorkTypesTab = isInlineIssueTypeConfigEnabled || isInlineCombinedImpactConfigEnabled ? // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $kHTL4.useOpenManageFieldTab)({
        source: (0, $0c1224accd0013fc$export$74ba9d5182d4cdae),
        url: (0, $jMRoT.getProjectSettingsIssueTypesUrl)({
            projectKey: projectKey,
            projectType: projectType ?? ''
        })
    }) : (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)));
    const [, { closeIssueCreateModal: closeIssueCreateModal }] = (0, $jipjz.useTriggerIssueCreateModal)();
    const fields = (0, $eJOHy.useMemo)(()=>{
        let fieldsNode;
        const projectTypeCheck = (0, $7jTnu.fg)('jcs_master_flag') ? projectType === (0, $ln6Iy.SERVICE_DESK_PROJECT) || projectType === (0, $ln6Iy.CUSTOMER_SERVICE_PROJECT) : projectType === (0, $ln6Iy.SERVICE_DESK_PROJECT);
        if (projectTypeCheck && requestTypes !== undefined) {
            // get the options for the 2 select fields
            const { issueTypeOptions: issueTypeOptions, requestTypeOptions: requestTypeOptions } = (0, $fugYy.getRequestAndIssueTypeOptionsGroup)(issueTypes, requestTypes, formatMessage); // extract the selected option for the 2 select fields from the aggregated value
            const { issueType: selectedIssueType, requestType: selectedRequestType } = (0, $fugYy.getIssueTypeAndRequestType)({
                allIssueTypes: issueTypeOptions,
                requestOrIssueType: selectedRequestOrIssueType,
                formatMessage: formatMessage
            }); // fire UI events when the selects are opened
            const onIssueTypeSelectOpen = ()=>(0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'gicIssueTypeSelect open');
            const onRequestTypeSelectOpen = ()=>(0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'gicRequestTypeSelect open'); // on issue type selection we want to pre-select a matching request type
            const onIssueTypeChange = (issueType)=>{
                if (issueType.value === selectedIssueType?.value) return;
                const firstMatchingRequestType = (0, $fugYy.getFirstMatchingRequestType)({
                    issueType: issueType,
                    allRequestTypes: requestTypes
                });
                onChange(firstMatchingRequestType || issueType);
                (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'gicIssueTypeSelect selected');
            }; // on request type selection we want to select the chosen request type,
            // or if 'none' is selected, we select the issue type
            const onRequestTypeChange = (requestTypeOrNone)=>{
                if (requestTypeOrNone.value === selectedRequestType?.value) return;
                let isNoneSelected = true;
                if (requestTypeOrNone.type === (0, $4246188a36de9908$export$92ab80c1dc9baf44)) {
                    onChange(requestTypeOrNone);
                    isNoneSelected = false;
                } else if (selectedIssueType !== null) onChange(selectedIssueType);
                (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'gicRequestTypeSelect selected', {
                    isNoneSelected: isNoneSelected
                });
            };
            const requestTypeHelpText = selectedRequestType && selectedRequestType.type === (0, $4246188a36de9908$export$92ab80c1dc9baf44) ? selectedRequestType.helpText : '';
            fieldsNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fE4zR.FieldContainer), {
                width: isMini ? '100%' : undefined,
                marginTop: $4e60f383fd4237d3$var$typePickerMargin
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6svxr.default), {
                name: "issue-type-picker",
                label: formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $amdjq.default).issueTypeFieldLabelIssueTermRefresh : (0, $amdjq.default).issueTypeFieldLabel),
                isRequired: true
            }, ({ fieldProps: { id: id, isRequired: isRequired } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c4OV1.default), {
                    inputId: id,
                    required: isRequired,
                    options: issueTypeOptions,
                    value: selectedIssueType,
                    onChange: onIssueTypeChange,
                    onMenuOpen: onIssueTypeSelectOpen,
                    isClearable: false,
                    formatOptionLabel: (0, $9QSSI.formatOptionLabel),
                    placeholder: "",
                    id: (0, $8cd4b70a00850d28$export$f1623876ce3d4391),
                    isDisabled: isDisabled,
                    onKeyDown: (0, $c3eoY.preventEscKeyPropagationKeyPressHandler)
                }), getIssueTypeHelpText(), submitFieldwiseErrors?.issuetype && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fKXve.ErrorMessage), null, submitFieldwiseErrors.issuetype)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fE4zR.FieldContainer), {
                width: "100%",
                marginTop: $4e60f383fd4237d3$var$typePickerMargin
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4e60f383fd4237d3$var$RequestTypeFieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6svxr.default), {
                name: "request-type-picker",
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4e60f383fd4237d3$var$RequestTypeFieldLabelWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", null, formatMessage((0, $amdjq.default).requestTypeFieldLabel), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4e60f383fd4237d3$var$RequiredIndicator, null, "*")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $42ofz.WhatsThis), null))
            }, ({ fieldProps: { id: id } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2TyrS.RequestTypeSelect), {
                    inputId: id,
                    options: requestTypeOptions,
                    value: selectedRequestType,
                    onChange: onRequestTypeChange,
                    onMenuOpen: onRequestTypeSelectOpen,
                    id: "issue-create.ui.modal.create-form.type-picker.request-type-select"
                }))), requestTypeHelpText && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jr9QD.RequestTypeHelpText), {
                helpText: requestTypeHelpText
            })));
        } else {
            // there is no request type data, just show issue type select
            const label = (0, $fugYy.getFieldLabel)(Boolean(requestTypes?.length), formatMessage);
            const onIssueTypeChange = (selectedIssueType)=>{
                if (!selectedIssueType) return; // Button Manage issue type
                if ((isInlineIssueTypeConfigEnabled || isInlineCombinedImpactConfigEnabled) && selectedIssueType.value === (0, $8cd4b70a00850d28$export$108c7e65ed44598b)) {
                    openManageWorkTypesTab();
                    return;
                } // Button Create issue type
                const isCreateIssueTypeAction = selectedIssueType.type === (0, $8cd4b70a00850d28$export$4b72a3b40a1adf13);
                if (createIssueTypeModalRef.current && isCreateIssueTypeAction && !(0, $7jTnu.fg)('jira_gic_inline_create_work_type_refactor')) {
                    const analyticsEvent = createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button'
                    });
                    (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'createIssueTypeButton');
                    createIssueTypeModalRef.current.load();
                    return;
                }
                if (createIssueTypeButtonRef.current && isCreateIssueTypeAction && (0, $7jTnu.fg)('jira_gic_inline_create_work_type_refactor')) {
                    // Needed to trigger via keyboard
                    createIssueTypeButtonRef.current.click();
                    return;
                } // Button Edit issue type
                const isEditIssueTypeAction = selectedIssueType.type === (0, $8cd4b70a00850d28$export$aaaa9d64eeea4a55);
                if (editIssueTypeButtonRef.current && isEditIssueTypeAction && !(0, $7jTnu.fg)('jira_gic_inline_create_work_type_refactor')) {
                    // Analytics event is triggered in the EditIssueTypeModalTrigger
                    editIssueTypeButtonRef.current.click();
                    return;
                }
                if (editIssueTypeButtonRef.current && isEditIssueTypeAction && (0, $7jTnu.fg)('jira_gic_inline_create_work_type_refactor')) {
                    // Needed to trigger via keyboard
                    editIssueTypeButtonRef.current.click();
                    return;
                }
                if (selectedIssueType.value === selectedRequestOrIssueType?.value || (0, $8cd4b70a00850d28$export$4b72a3b40a1adf13) === selectedIssueType.type || (0, $8cd4b70a00850d28$export$aaaa9d64eeea4a55) === selectedIssueType.type) return;
                const analyticsEvent = createAnalyticsEvent({
                    action: 'selected',
                    actionSubject: 'option'
                });
                (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'issueType');
                onChange(selectedIssueType);
            };
            const Component = ({ areUiModificationsBusy: areUiModificationsBusy, allowedValues: allowedValues, isReadOnly: isReadOnly })=>{
                const { options: options, components: components, noOptionWrapperRef: noOptionWrapperRef } = isInlineIssueTypeConfigEnabled || isInlineCombinedImpactConfigEnabled ? // eslint-disable-next-line react-hooks/react-compiler
                // eslint-disable-next-line react-hooks/rules-of-hooks
                (0, $fugYy.useCustomOptionsAndComponentsForWorkTypeConfig)({
                    options: allowedValues ?? [],
                    canConfigureIssueTypes: canConfigureIssueTypes,
                    projectId: projectId,
                    projectKey: projectKey,
                    issueTypeId: selectedRequestOrIssueType?.value ?? '',
                    onPreloadCreateIssueTypeModal: onPreloadCreateIssueTypeModal,
                    onLoadCreateIssueTypeModal: onLoadCreateIssueTypeModal,
                    onIssueTypeCreatedOrUpdated: onIssueTypeCreatedOrUpdated,
                    onCreateModalClose: onCloseConfigureWorkType,
                    onEditModalClose: onCloseConfigureWorkType,
                    createIssueTypeButtonRef: createIssueTypeButtonRef,
                    editIssueTypeButtonRef: editIssueTypeButtonRef,
                    shouldTriggerModal: shouldTriggerModal,
                    onClickCreateOrEditOption: onClickCreateOrEditOption
                }) : {
                    options: allowedValues,
                    components: undefined,
                    noOptionWrapperRef: undefined
                };
                const isFixingA11yForInlineButtons = (isInlineIssueTypeConfigEnabled || isInlineCombinedImpactConfigEnabled) && (0, $7jTnu.fg)('inline_config_a11y_improvements');
                const SelectWrapper = isFixingA11yForInlineButtons ? (0, $aGmG9.AtlaskitSelectInlineTabActivator) : (0, $eJOHy.Fragment);
                const [inputValue, setInputValue] = (0, $eJOHy.useState)('');
                const [isMenuOpen, setIsMenuOpen] = (0, $eJOHy.useState)(false);
                const handleIssueTypesDropdownOpen = ()=>{
                    (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'gicIssueTypeSelect open');
                    if (canConfigureIssueTypes) {
                        fireExposure(); // NOTE: same FG in front of the following experiments, new activated tenants pass 100% for combined_adoption_configuration_experiment and fail 100% on the other...
                        fireCombinedImpactExposure();
                    }
                }; // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                const fieldId = document.activeElement?.id;
                (0, $eJOHy.useEffect)(()=>{
                    if (fieldId?.includes('type-picker') && (0, $7jTnu.fg)('fix-gryf-a11y-issues')) selectRef?.current?.focus();
                }, [
                    fieldId
                ]);
                const attributes = (0, $eJOHy.useMemo)(()=>({
                        projectId: projectId,
                        isMenuOpen: isMenuOpen,
                        fieldId: fieldId
                    }), [
                    fieldId,
                    isMenuOpen
                ]);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4NEt5.JiraIssueCreateErrorBoundary), {
                    id: "withFormField",
                    packageName: "jiraIssueCreateModal",
                    sendToPrivacyUnsafeSplunk: true,
                    ...(0, $7jTnu.fg)('jira-issue-create-error-boundary-enabled') ? {
                        attributes: attributes
                    } : {}
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6svxr.default), {
                    name: "type-picker",
                    label: label,
                    isRequired: true,
                    elementAfterLabel: areUiModificationsBusy ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $mWfDl.FieldBusyIndicator), {
                        fieldId: (0, $814y1.ISSUE_TYPE)
                    }) : undefined
                }, ({ fieldProps: fieldProps })=>{
                    const renderFieldContent = ({ id: id, isRequired: isRequired // eslint-disable-next-line @typescript-eslint/no-explicit-any
                     })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, isConfigureWorkTypePopupOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bg1hW.ConfigureWorkTypePopup), {
                            renderPopupContent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ConfigureWorkTypePopupContent, null),
                            onClose: onCloseConfigureWorkType,
                            renderTarget: ()=>// Minimal copy of Select used for popup anchor
                                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c4OV1.default), {
                                    menuIsOpen: false,
                                    value: selectedRequestOrIssueType,
                                    formatOptionLabel: (0, $9QSSI.formatOptionLabel),
                                    components: components
                                })
                        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(SelectWrapper, {
                            setInputValue: setInputValue,
                            setIsMenuOpen: setIsMenuOpen,
                            inputValue: inputValue,
                            isMenuOpen: isMenuOpen
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c4OV1.default), {
                            ref: selectRef,
                            inputId: id,
                            menuIsOpen: isFixingA11yForInlineButtons ? isMenuOpen : undefined,
                            inputValue: isFixingA11yForInlineButtons ? inputValue : undefined,
                            required: isRequired,
                            options: options,
                            components: components,
                            onChange: onIssueTypeChange,
                            onMenuOpen: handleIssueTypesDropdownOpen,
                            value: selectedRequestOrIssueType,
                            isClearable: false,
                            formatOptionLabel: (0, $9QSSI.formatOptionLabel),
                            placeholder: "",
                            id: (0, $8cd4b70a00850d28$export$f1623876ce3d4391),
                            isDisabled: !!(isDisabled || isReadOnly),
                            onKeyDown: (e)=>{
                                (0, $c3eoY.preventEscKeyPropagationKeyPressHandler)(e);
                            },
                            onInputChange: (value, { action: action })=>{
                                if (isFixingA11yForInlineButtons && // This is to prevent the search value to be cleared when tabbing to the Create Issue Type button in Empty no results state
                                (action !== 'input-blur' && action !== 'menu-close' || !noOptionWrapperRef?.current)) setInputValue(value);
                            }
                        })), getIssueTypeHelpText(), submitFieldwiseErrors?.issuetype && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fKXve.ErrorMessage), null, submitFieldwiseErrors.issuetype));
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dxW4o.ErrorBoundaryBypassProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dxW4o.ErrorBoundaryBypassOutput), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4NEt5.JiraIssueCreateErrorBoundary), {
                        id: "issueAdjustmentsFieldValueDecorator",
                        packageName: "jiraIssueCreateModal",
                        fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bYusI.ErrorHandler), null), renderFieldContent(fieldProps)),
                        sendToPrivacyUnsafeSplunk: true,
                        attributes: (error)=>({
                                errorType: (0, $a1pDt.getErrorType)(error),
                                viewType: (0, $6d500eb1fc6bc124$export$e615b7e9b8fb4715),
                                fieldId: (0, $814y1.ISSUE_TYPE),
                                fieldType: (0, $814y1.ISSUE_TYPE)
                            })
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $enLyD.FieldValueDecoratorAsync), {
                        fieldId: (0, $814y1.ISSUE_TYPE),
                        fieldType: (0, $814y1.ISSUE_TYPE),
                        fieldProps: {
                            ...fieldProps,
                            value: selectedRequestOrIssueType
                        }
                    }, (interceptedFieldProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dxW4o.ErrorBoundaryBypassInput), null, renderFieldContent(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        interceptedFieldProps)))));
                }), (isInlineIssueTypeConfigEnabled || isInlineCombinedImpactConfigEnabled) && projectKey && !(0, $7jTnu.fg)('jira_gic_inline_create_work_type_refactor') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $caLfe.CreateIssueTypeModal), {
                    onIssueTypeCreated: onIssueTypeCreatedOrUpdated,
                    onOpenManageTypes: closeIssueCreateModal,
                    ufoExperience: (0, $iIqFO.CreateIssueTypeUFOExperience),
                    onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
                    onClose: refocusSelectField,
                    ref: createIssueTypeModalRef,
                    source: (0, $a9cbb8c64aa7f847$export$66397ed56abea4ca),
                    projectKey: projectKey,
                    shouldFetchProjectData: true
                }));
            };
            const typePickerComponentProps = {
                fieldId: (0, $814y1.ISSUE_TYPE),
                fieldName: label,
                fieldType: (0, $814y1.ISSUE_TYPE),
                isRequired: true,
                gqlType: '',
                allowedValues: issueTypes
            };
            const setFieldValue = (_, value)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                onIssueTypeChange(value);
            const getFormState = ()=>({
                    values: {
                        [typePickerComponentProps.fieldId]: selectedRequestOrIssueType
                    }
                });
            fieldsNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ConfigureWorkTypePopupTriggerContextProvider, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $BAHbx.FormApiProvider), {
                setFieldValue: setFieldValue,
                getFormState: getFormState
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fE4zR.FieldContainer), {
                width: isMini ? '100%' : undefined,
                marginTop: $4e60f383fd4237d3$var$typePickerMargin
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4NEt5.JiraIssueCreateErrorBoundary), {
                id: "globalIssueCreateIssueAdjustmentsAdapter",
                packageName: "issueCreateModal",
                fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bYusI.ErrorHandler), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Component, typePickerComponentProps)),
                sendToPrivacyUnsafeSplunk: true,
                attributes: (error)=>({
                        errorType: (0, $a1pDt.getErrorType)(error),
                        viewType: (0, $6d500eb1fc6bc124$export$e615b7e9b8fb4715),
                        fieldId: typePickerComponentProps.fieldId,
                        fieldType: typePickerComponentProps.fieldType
                    })
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gvcEL.FieldDecoratorAsync), {
                Component: Component,
                componentProps: typePickerComponentProps
            })))));
        }
        return fieldsNode;
    }, [
        projectType,
        requestTypes,
        issueTypes,
        formatMessage,
        selectedRequestOrIssueType,
        isMini,
        createAnalyticsEvent,
        onChange,
        isDisabled,
        getIssueTypeHelpText,
        submitFieldwiseErrors?.issuetype,
        isInlineIssueTypeConfigEnabled,
        isInlineCombinedImpactConfigEnabled,
        openManageWorkTypesTab,
        canConfigureIssueTypes,
        projectId,
        projectKey,
        onIssueTypeCreatedOrUpdated,
        refocusSelectField,
        closeIssueCreateModal,
        fireExposure,
        fireCombinedImpactExposure,
        isConfigureWorkTypePopupOpen,
        ConfigureWorkTypePopupTriggerContextProvider,
        ConfigureWorkTypePopupContent,
        shouldTriggerModal,
        onClickCreateOrEditOption,
        onCloseConfigureWorkType
    ]);
    return fields;
};
var $4e60f383fd4237d3$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $4e60f383fd4237d3$var$TypePicker;
const $4e60f383fd4237d3$var$RequestTypeFieldWrapper = /*#__PURE__*/ (0, $cdbP5.default).div.withConfig({
    componentId: "cz2iu2-0"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '> div': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '> label': {
            width: '100%'
        }
    }
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4e60f383fd4237d3$var$RequiredIndicator = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_syaz1tmw _19bvv77o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4e60f383fd4237d3$var$RequestTypeFieldLabelWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _2lx2vrvc _4cvr1q9y _1bah1yb4 _1bsb1osq _4t3i1osq _19pk12x7",
            __cmplp.className
        ])
    });
});

});
parcelRegister("aGmG9", function(module, exports) {

$parcel$export(module.exports, "AtlaskitSelectInlineTabActivator", () => $f5eeb8dba7c78e6d$export$db135681be6e3fdb);

var $eJOHy = parcelRequire("eJOHy");

var $ilGjL = parcelRequire("ilGjL");

var $8IeH1 = parcelRequire("8IeH1");

var $7jTnu = parcelRequire("7jTnu");
const $f5eeb8dba7c78e6d$export$db135681be6e3fdb = ({ setInputValue: setInputValue, setIsMenuOpen: setIsMenuOpen, inputValue: inputValue, isMenuOpen: isMenuOpen, children: children })=>{
    const selectWrapperRef = (0, $eJOHy.useRef)(null);
    const handleBlur = (0, $eJOHy.useCallback)((e)=>{
        // Always close the menu on outside focus and mouse events
        if (selectWrapperRef.current && e.target instanceof Node && // This is to make sure we only blur when focusing outside of the select
        // This is required to allow interacting with inline buttons inside the select dropdown
        !selectWrapperRef.current.contains(e.target)) {
            setInputValue?.('');
            setIsMenuOpen(false);
            return;
        }
        // Always toggle the menu open/closed on internal mousedown events
        if (e.type === 'mousedown') {
            // Reset the input value when closing the menu
            if (isMenuOpen) setInputValue?.('');
            setIsMenuOpen(!isMenuOpen);
        }
    }, [
        isMenuOpen,
        setInputValue,
        setIsMenuOpen
    ]);
    (0, $eJOHy.useEffect)(()=>{
        // Listen to focus and mousedown events to close the select dropdown when clicking or focusing outside of it
        globalThis?.document?.addEventListener('focusin', handleBlur);
        globalThis?.document?.addEventListener('mousedown', handleBlur);
        return ()=>{
            globalThis?.document?.removeEventListener('focusin', handleBlur);
            globalThis?.document?.removeEventListener('mousedown', handleBlur);
        };
    }, [
        handleBlur
    ]);
    (0, $eJOHy.useEffect)(()=>{
        // Open the menu when the input value changes
        if (!isMenuOpen && inputValue) setIsMenuOpen(true);
    }, [
        inputValue,
        isMenuOpen,
        setIsMenuOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        testId: "inline-config-buttons-for-select.atlaskit-select-inline-tab-activator",
        ref: selectWrapperRef,
        onKeyDown: (e)=>{
            const openMenuKeys = [
                'ArrowDown',
                'ArrowUp',
                'Enter',
                ' '
            ];
            // Only override keydown events when the menu is open or to open the menu
            if (!isMenuOpen && !openMenuKeys.includes(e.key)) return;
            switch(e.key){
                // This is to handle closing the Select menu when pressing Escape
                case 'Escape':
                    setIsMenuOpen(false);
                    setInputValue?.('');
                    break;
                // This is to allow tabbing inside the Select menu
                // if the current focus one is last tabbable element, focus the first tabbable element
                // to prevent tabbing out of the Select menu
                case 'Tab':
                    {
                        (0, $7jTnu.fg)('inline_config_a11y_improvements') && e.stopPropagation();
                        const tabbableEls = (0, (/*@__PURE__*/$parcel$interopDefault($ilGjL)))(e.currentTarget);
                        if (tabbableEls.length < 2) return;
                        const isLastTabbable = tabbableEls[tabbableEls.length - 1] === globalThis?.document?.activeElement;
                        if (isLastTabbable) {
                            e.preventDefault();
                            tabbableEls[0].focus();
                        }
                        break;
                    }
                // This is to allow navigating inside the Select menu using Arrow keys after focusing on inline buttons
                // Because users can only continue navigating using Arrow keys if the focus is on the text input of select
                case 'ArrowDown':
                case 'ArrowUp':
                    {
                        if (!isMenuOpen) {
                            setIsMenuOpen(true);
                            return;
                        }
                        const tabbableEls = (0, (/*@__PURE__*/$parcel$interopDefault($ilGjL)))(e.currentTarget);
                        if (tabbableEls.length < 2) return;
                        tabbableEls[0].focus();
                        break;
                    }
                case 'Enter':
                case ' ':
                    if (!isMenuOpen) setIsMenuOpen(true);
                    break;
                default:
                    break;
            }
        }
    }, children);
};

});

parcelRegister("jMRoT", function(module, exports) {

$parcel$export(module.exports, "getProjectSettingsIssueTypesUrl", () => $de0c8e134ff95356$export$e2e29d5bcfe97104);
const $de0c8e134ff95356$export$e2e29d5bcfe97104 = ({ projectKey: projectKey, projectType: projectType })=>{
    switch(projectType?.toLowerCase()){
        case 'customer_service':
        case 'service_desk':
            return `/plugins/servlet/project-config/${projectKey}/issueTypes`;
        case 'business':
            return `/jira/core/projects/${projectKey}/settings/issuetypes`;
        default:
            return `/jira/software/projects/${projectKey}/settings/issuetypes`;
    }
};

});

parcelRegister("caLfe", function(module, exports) {

$parcel$export(module.exports, "CreateIssueTypeModal", () => $f0c8ac055743e6de$export$dc9171633ab334ab);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $fGRYk = parcelRequire("fGRYk");

var $cystD = parcelRequire("cystD");

var $bbdV2 = parcelRequire("bbdV2");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $kEUB1 = parcelRequire("kEUB1");
const $f0c8ac055743e6de$export$dc9171633ab334ab = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ onIssueTypeCreated: onIssueTypeCreated = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), onOpenManageTypes: onOpenManageTypes = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), onOpen: onOpen, onClose: onClose, source: source, shouldFetchProjectData: shouldFetchProjectData = false, projectKey: projectKey, ufoExperience: ufoExperience }, ref)=>{
    const cloudId = (0, $kEUB1.useCloudId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $fGRYk.asyncCreateIssueTypeModalEntryPoint), {
        projectKey: projectKey,
        cloudId: cloudId,
        shouldFetchProjectData: shouldFetchProjectData
    });
    (0, $eJOHy.useImperativeHandle)(ref, ()=>({
            load: entryPointActions.load,
            preload: entryPointActions.preload
        }));
    const onCloseCreateIssueTypeModal = (0, $eJOHy.useCallback)(()=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'inlineCreateIssueTypeModal',
            action: 'closed'
        }));
        onClose();
    }, [
        createAnalyticsEvent,
        onClose
    ]);
    const entryPointProps = (0, $eJOHy.useMemo)(()=>({
            onIssueTypeCreated: onIssueTypeCreated,
            issueTypesCountLimit: 30,
            onClose: onCloseCreateIssueTypeModal,
            onOpen: onOpen,
            onOpenManageTypes: onOpenManageTypes,
            source: source,
            ufoExperience: ufoExperience
        }), [
        onIssueTypeCreated,
        onCloseCreateIssueTypeModal,
        onOpen,
        onOpenManageTypes,
        source,
        ufoExperience
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cystD.ModalEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        entryPointActions: entryPointActions,
        runtimeProps: entryPointProps,
        id: "create-issue-type-modal"
    });
});

});
parcelRegister("fGRYk", function(module, exports) {

$parcel$export(module.exports, "asyncCreateIssueTypeModalEntryPoint", () => $017dfafefc3951e5$export$7f9428aac5b01dff);

var $TgM8I = parcelRequire("TgM8I");

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $017dfafefc3951e5$export$7f9428aac5b01dff = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("b3EWv")), {
        moduleId: "0ca2b96c",
        priority: "interaction"
    }),
    getPreloadProps: ({ projectKey: projectKey, cloudId: cloudId, shouldFetchProjectData: shouldFetchProjectData })=>({
            queries: {
                createIssueTypeModal: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $TgM8I.default,
                    variables: {
                        projectKey: projectKey,
                        cloudId: cloudId,
                        shouldFetchProjectData: shouldFetchProjectData
                    }
                }
            }
        })
});

});
parcelRegister("TgM8I", function(module, exports) {

$parcel$export(module.exports, "default", () => $07adbcceea3befa7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<36277921a8012e0702a65f1227cbbd1b>>
 * @relayHash 4a7b622560b3b3e20bb696680e8560ab
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d8c35e32d8548b68e2966c6dacdbc893c0768a3dd5dc31d2dfca58cd3e11bc76
const $07adbcceea3befa7$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "shouldFetchProjectData"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "name"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "srcAsyncCreateIssueTypeQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v1 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProjectByKey",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "JiraIssueTypeConnection",
                                                "kind": "LinkedField",
                                                "name": "issueTypes",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "ui_createIssueTypeModal_CreateIssueTypeModalWrapper_createIssueTypeFragmentRef"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "jira.jiraProjectByKey.issueTypes"
                                        },
                                        {
                                            "condition": "shouldFetchProjectData",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "ui_createIssueTypeModal_CreateIssueTypeModalWrapper_projectDataFragmentRef"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.jiraProjectByKey"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "srcAsyncCreateIssueTypeQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueTypeConnection",
                                    "kind": "LinkedField",
                                    "name": "issueTypes",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "totalCount"
                                        },
                                        {
                                            "concreteType": "JiraIssueTypeEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueType",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v2 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraIssueTypeHierarchyLevel",
                                                            "kind": "LinkedField",
                                                            "name": "hierarchy",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "level"
                                                                }
                                                            ]
                                                        },
                                                        v3 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "shouldFetchProjectData",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "projectType"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "projectId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "projectStyle"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "status"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "uuid"
                                        },
                                        v2 /*: any*/ ,
                                        {
                                            "concreteType": "JiraAvatar",
                                            "kind": "LinkedField",
                                            "name": "avatar",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "medium"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v3 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "d8c35e32d8548b68e2966c6dacdbc893c0768a3dd5dc31d2dfca58cd3e11bc76",
            "metadata": {},
            "name": "srcAsyncCreateIssueTypeQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$07adbcceea3befa7$var$node.hash = "b50515a18d5488758aa762560868c40c";
var $07adbcceea3befa7$export$2e2bcd8739ae039 = $07adbcceea3befa7$var$node;

});

parcelRegister("b3EWv", function(module, exports) {

let $80cfbbe2861077ea$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $80cfbbe2861077ea$var$load("76n7a"),
    $80cfbbe2861077ea$var$load("l253H"),
    $80cfbbe2861077ea$var$load("ffQaD"),
    $80cfbbe2861077ea$var$load("kvRbA"),
    $80cfbbe2861077ea$var$load("kNFvF"),
    $80cfbbe2861077ea$var$load("f5XY9")
]).then(()=>parcelRequire('bRzMj'));

});



const $a9cbb8c64aa7f847$export$c766acff4513a976 = 'summaryView';
const $a9cbb8c64aa7f847$export$4edb790587638895 = 'listView';
const $a9cbb8c64aa7f847$export$cafb161c2b21b455 = 'issueView';
const $a9cbb8c64aa7f847$export$66397ed56abea4ca = 'gicView';
const $a9cbb8c64aa7f847$export$a1077f863a923e94 = 'gicViewNoResults';
const $a9cbb8c64aa7f847$export$7f04bd1df3763938 = 'jswBoard';
const $a9cbb8c64aa7f847$export$bd8f63529bb9357f = 'jswBacklog';
const $a9cbb8c64aa7f847$export$57eacdfdee901d4c = 'jswTimeline';
const $a9cbb8c64aa7f847$export$8f4fd516b77f8d43 = 'unknown';
const $a9cbb8c64aa7f847$export$334975a13cb19c35 = 'editIssueTypeButton';
const $a9cbb8c64aa7f847$export$e970abb363c8ec67 = 'deleteIssueTypeButton';

const $8cd4b70a00850d28$export$4435027827ccff2d = '/secure/ShowConstantsHelp.jspa?decorator=popup#IssueTypes';
const $8cd4b70a00850d28$export$f1623876ce3d4391 = 'issue-create.ui.modal.create-form.type-picker.issue-type-select';
const $8cd4b70a00850d28$export$4b72a3b40a1adf13 = 'CREATE_ISSUE_TYPE';
const $8cd4b70a00850d28$export$aaaa9d64eeea4a55 = 'EDIT_ISSUE_TYPE';
const $8cd4b70a00850d28$export$108c7e65ed44598b = 'MANAGE_ISSUE_TYPE';
const $8cd4b70a00850d28$export$34934e4a629b9612 = 500;

parcelRegister("amdjq", function(module, exports) {

$parcel$export(module.exports, "default", () => $539b6f0d6098775b$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $539b6f0d6098775b$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    issueTypeFieldLabel: {
        "id": "issue-create.modal.create-form.type-picker.issue-type-field-label",
        "defaultMessage": "Issue type"
    },
    requestTypeFieldLabel: {
        "id": "issue-create.modal.create-form.type-picker.request-type-field-label",
        "defaultMessage": "Request type"
    },
    typeFieldLabel: {
        "id": "issue-create.modal.create-form.type-picker.type-field-label",
        "defaultMessage": "Type"
    },
    issueTypeGroupLabel: {
        "id": "issue-create.modal.create-form.type-picker.issue-type-group-label",
        "defaultMessage": "Issue types"
    },
    requestTypeGroupLabel: {
        "id": "issue-create.modal.create-form.type-picker.request-type-group-label",
        "defaultMessage": "Request types"
    },
    unassignedRequestTypeGroupLabel: {
        "id": "issue-create.modal.create-form.type-picker.unassigned-request-type-group-label",
        "defaultMessage": "Unassigned"
    },
    serviceRequestGroupLabel: {
        "id": "issue-create.modal.create-form.type-picker.service-request-group-label",
        "defaultMessage": "Service requests"
    },
    incidentRequestGroupLabel: {
        "id": "issue-create.modal.create-form.type-picker.incident-request-group-label",
        "defaultMessage": "Incidents"
    },
    postIncidentReviewRequestGroupLabel: {
        "id": "issue-create.modal.create-form.type-picker.post-incident-review-request-group-label",
        "defaultMessage": "Post-incident reviews"
    },
    developerEscalationRequestGroupLabel: {
        "id": "issue-create.modal.create-form.type-picker.developer-escalation-request-group-label",
        "defaultMessage": "Developer escalations"
    },
    problemRequestGroupLabel: {
        "id": "issue-create.modal.create-form.type-picker.problem-request-group-label",
        "defaultMessage": "Problems"
    },
    changeRequestGroupLabel: {
        "id": "issue-create.modal.create-form.type-picker.change-request-group-label",
        "defaultMessage": "Changes"
    },
    noRequestTypeLabel: {
        "id": "issue-create.modal.create-form.type-picker.no-request-type-label",
        "defaultMessage": "No request type"
    },
    issueTypeHelpText: {
        "id": "issue-create.modal.create-form.type-picker.issue-type-help-text",
        "defaultMessage": "Learn more"
    },
    issueTypeFieldLabelIssueTermRefresh: {
        "id": "issue-create.modal.create-form.type-picker.issue-type-field-label-issue-term-refresh",
        "defaultMessage": "Work type"
    },
    issueTypeGroupLabelIssueTermRefresh: {
        "id": "issue-create.modal.create-form.type-picker.issue-type-group-label-issue-term-refresh",
        "defaultMessage": "Work types"
    },
    createIssueTypeButtonText: {
        "id": "issue-create.modal.create-form.type-picker.create-issue-type-button-text",
        "defaultMessage": "Create issue type"
    },
    createWorkTypeButtonTextIssueTermRefresh: {
        "id": "issue-create.modal.create-form.type-picker.create-issue-type-button-text-issue-term-refresh",
        "defaultMessage": "Create work type"
    },
    addIssueTypeButtonText: {
        "id": "issue-create.modal.create-form.type-picker.add-issue-type-button-text",
        "defaultMessage": "Add issue type"
    },
    addWorkTypeButtonText: {
        "id": "issue-create.modal.create-form.type-picker.add-work-type-button-text",
        "defaultMessage": "Add work type"
    },
    editIssueTypeButtonText: {
        "id": "issue-create.modal.create-form.type-picker.edit-issue-type-button-text",
        "defaultMessage": "Edit issue type"
    },
    editWorkTypeButtonTextIssueTermRefresh: {
        "id": "issue-create.modal.create-form.type-picker.edit-issue-type-button-text-issue-term-refresh",
        "defaultMessage": "Edit work type"
    },
    manageIssueTypesButtonText: {
        "id": "issue-create.modal.create-form.type-picker.manage-issue-types-button-text",
        "defaultMessage": "Manage issue types"
    },
    manageWorkTypesButtonTextIssueTermRefresh: {
        "id": "issue-create.modal.create-form.type-picker.manage-work-types-button-text-issue-term-refresh",
        "defaultMessage": "Manage work types"
    },
    editWorkTypeButtonText: {
        "id": "issue-create.modal.create-form.type-picker.edit-work-type-button-text",
        "defaultMessage": "Edit type"
    },
    noSearchResultsOldTerm: {
        "id": "issue-create.modal.create-form.type-picker.no-search-results-old-term",
        "defaultMessage": "It looks like we can't find any issue types that match. <button>Create issue type</button>"
    },
    noSearchResultsIssueTermRefresh: {
        "id": "issue-create.modal.create-form.type-picker.no-search-results",
        "defaultMessage": "It looks like we can't find any work types that match. <button>Create work type</button>"
    }
});

});

parcelRegister("fugYy", function(module, exports) {

$parcel$export(module.exports, "getFieldLabel", () => $7569d5986a617867$export$da6819d9a95804cf);
$parcel$export(module.exports, "getRequestAndIssueTypeOptionsGroup", () => $7569d5986a617867$export$37e41f5d9a3e8f14);
$parcel$export(module.exports, "getIssueTypeAndRequestType", () => $7569d5986a617867$export$2f84784d8e92f69c);
$parcel$export(module.exports, "getFirstMatchingRequestType", () => $7569d5986a617867$export$f0a2ba1b9d3328b);
$parcel$export(module.exports, "useCustomOptionsAndComponentsForWorkTypeConfig", () => $7569d5986a617867$export$d2eb156c53eb582e);
$parcel$export(module.exports, "useRefocusSelectField", () => $7569d5986a617867$export$edd8a0e9715caecc);

var $eJOHy = parcelRequire("eJOHy");

var $6Abnv = parcelRequire("6Abnv");

var $12DRg = parcelRequire("12DRg");

var $8nu6j = parcelRequire("8nu6j");
var $lmgo6 = parcelRequire("lmgo6");
var $bQP4O = parcelRequire("bQP4O");
var $1DXK0 = parcelRequire("1DXK0");


var $7jTnu = parcelRequire("7jTnu");

var $iIqFO = parcelRequire("iIqFO");

var $9ZjBG = parcelRequire("9ZjBG");


var $epTsa = parcelRequire("epTsa");

var $lRq8t = parcelRequire("lRq8t");

var $cfGlq = parcelRequire("cfGlq");

var $ipnsI = parcelRequire("ipnsI");

var $lXDnY = parcelRequire("lXDnY");

var $7kzWm = parcelRequire("7kzWm");

var $fGRYk = parcelRequire("fGRYk");

var $f7Yza = parcelRequire("f7Yza");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $kEUB1 = parcelRequire("kEUB1");

var $llT4J = parcelRequire("llT4J");

var $aaGSX = parcelRequire("aaGSX");

var $lppZM = parcelRequire("lppZM");
var $bE8VR = parcelRequire("bE8VR");

var $eCVV2 = parcelRequire("eCVV2");


var $amdjq = parcelRequire("amdjq");

var $iY1yb = parcelRequire("iY1yb");

var $8Xb7Q = parcelRequire("8Xb7Q");
const $7569d5986a617867$export$da6819d9a95804cf = (hasRequestTypes, formatMessage)=>hasRequestTypes ? formatMessage((0, $amdjq.default).typeFieldLabel) : formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $amdjq.default).issueTypeFieldLabelIssueTermRefresh : (0, $amdjq.default).issueTypeFieldLabel);
const $7569d5986a617867$export$8e45723e9c86b276 = (practice, formatMessage)=>{
    if (practice === (0, $4246188a36de9908$export$b92ccb6dc3cdb548)) return formatMessage((0, $amdjq.default).changeRequestGroupLabel);
    if (practice === (0, $4246188a36de9908$export$48c144830383423)) return formatMessage((0, $amdjq.default).incidentRequestGroupLabel);
    if (practice === (0, $4246188a36de9908$export$1ea6ead7bcee4494)) return formatMessage((0, $amdjq.default).problemRequestGroupLabel);
    if (practice === (0, $4246188a36de9908$export$3d1cda9bd50505e8)) return formatMessage((0, $amdjq.default).serviceRequestGroupLabel);
    if (practice === (0, $4246188a36de9908$export$a4a741b969f6509c)) return formatMessage((0, $amdjq.default).postIncidentReviewRequestGroupLabel);
    if (practice === (0, $4246188a36de9908$export$81e62964cc725098)) return formatMessage((0, $amdjq.default).developerEscalationRequestGroupLabel);
    if (practice === (0, $4246188a36de9908$export$c835df30ebbd529d)) return formatMessage((0, $amdjq.default).unassignedRequestTypeGroupLabel);
    return formatMessage((0, $amdjq.default).requestTypeGroupLabel);
};
const $7569d5986a617867$var$reorderRequestTypeGroups = (requestTypeGroupKeys)=>{
    // This is the order we have them for queues, request types and feature page
    const allPractices = [
        (0, $4246188a36de9908$export$3d1cda9bd50505e8),
        (0, $4246188a36de9908$export$48c144830383423),
        (0, $4246188a36de9908$export$1ea6ead7bcee4494),
        (0, $4246188a36de9908$export$b92ccb6dc3cdb548),
        (0, $4246188a36de9908$export$a4a741b969f6509c),
        (0, $4246188a36de9908$export$81e62964cc725098),
        (0, $4246188a36de9908$export$c835df30ebbd529d),
        (0, $4246188a36de9908$export$92ab80c1dc9baf44)
    ];
    const groupKeySet = new Set(requestTypeGroupKeys);
    return allPractices.filter((practice)=>groupKeySet.has(practice));
};
const $7569d5986a617867$var$createNoneOption = (formatMessage)=>({
        label: formatMessage((0, $amdjq.default).noRequestTypeLabel),
        value: 'none',
        type: 'NONE'
    });
const $7569d5986a617867$export$37e41f5d9a3e8f14 = (issueTypes, requestTypes, formatMessage)=>{
    // @ts-expect-error(PARTIAL_RECORD) TS2322 | TS2322 - Type 'Dictionary<RequestType[]>' is not assignable to type 'Record<RequestTypePractices, RequestType[]>'. | Type 'Dictionary<RequestType[]>' is not assignable to type 'Record<RequestTypePractices, RequestType[]>'.
    const groupedRequestTypes = (0, (/*@__PURE__*/$parcel$interopDefault($6Abnv)))(requestTypes, (o)=>o.practice);
    // @ts-expect-error - TS2345 - Argument of type 'string[]' is not assignable to parameter of type 'RequestTypePractices[]'.
    const groupKeys = $7569d5986a617867$var$reorderRequestTypeGroups(Object.keys(groupedRequestTypes));
    const requestTypesOptions = groupKeys.map((practice)=>({
            label: $7569d5986a617867$export$8e45723e9c86b276(practice, formatMessage),
            options: groupedRequestTypes[practice]
        }));
    return {
        issueTypeOptions: issueTypes,
        requestTypeOptions: [
            $7569d5986a617867$var$createNoneOption(formatMessage),
            ...requestTypesOptions
        ]
    };
};
const $7569d5986a617867$export$2f84784d8e92f69c = ({ requestOrIssueType: requestOrIssueType, allIssueTypes: allIssueTypes, formatMessage: formatMessage })=>{
    const noneOption = $7569d5986a617867$var$createNoneOption(formatMessage);
    let issueType = null;
    let requestType = null;
    if (requestOrIssueType !== null) switch(requestOrIssueType.type){
        case 0, $4246188a36de9908$export$ebb48b08205007c5:
            issueType = requestOrIssueType;
            requestType = noneOption;
            break;
        case 0, $4246188a36de9908$export$92ab80c1dc9baf44:
            issueType = allIssueTypes.find(({ value: value })=>value === requestOrIssueType.issueTypeId) || null;
            requestType = requestOrIssueType;
            break;
        default:
    }
    return {
        issueType: issueType,
        requestType: requestType
    };
};
const $7569d5986a617867$export$f0a2ba1b9d3328b = ({ issueType: issueType, allRequestTypes: allRequestTypes })=>allRequestTypes.find(({ issueTypeId: issueTypeId })=>issueTypeId === issueType.value);
const $7569d5986a617867$export$b5c5ad2ef493d247 = (targetOptions)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    // eslint-disable-next-line no-nested-ternary
    const createIssueOrWorkTypeMessage = (0, $7jTnu.fg)('jira-issue-terminology-refresh-m3') ? (0, $7jTnu.fg)('jira_rename_inline_create_work_type_button') ? (0, $amdjq.default).addWorkTypeButtonText : (0, $amdjq.default).createWorkTypeButtonTextIssueTermRefresh : (0, $7jTnu.fg)('jira_rename_inline_create_work_type_button') ? (0, $amdjq.default).addIssueTypeButtonText : (0, $amdjq.default).createIssueTypeButtonText;
    const editIssueOrWorkTypeMessage = (0, $7jTnu.fg)('jira-issue-terminology-refresh-m3') ? (0, $amdjq.default).editWorkTypeButtonTextIssueTermRefresh : (0, $amdjq.default).editIssueTypeButtonText;
    const manageIssueOrWorkTypesMessage = (0, $7jTnu.fg)('jira-issue-terminology-refresh-m3') ? (0, $amdjq.default).manageWorkTypesButtonTextIssueTermRefresh : (0, $amdjq.default).manageIssueTypesButtonText;
    const footerOptions = (0, $eJOHy.useMemo)(()=>{
        return [
            {
                label: formatMessage(createIssueOrWorkTypeMessage),
                type: (0, $8cd4b70a00850d28$export$4b72a3b40a1adf13),
                value: (0, $8cd4b70a00850d28$export$4b72a3b40a1adf13)
            },
            {
                label: formatMessage(editIssueOrWorkTypeMessage),
                type: (0, $8cd4b70a00850d28$export$aaaa9d64eeea4a55),
                value: (0, $8cd4b70a00850d28$export$aaaa9d64eeea4a55)
            },
            {
                label: formatMessage(manageIssueOrWorkTypesMessage),
                type: (0, $8cd4b70a00850d28$export$108c7e65ed44598b),
                value: (0, $8cd4b70a00850d28$export$108c7e65ed44598b)
            }
        ];
    }, [
        formatMessage,
        createIssueOrWorkTypeMessage,
        editIssueOrWorkTypeMessage,
        manageIssueOrWorkTypesMessage
    ]);
    return (0, $cfGlq.useAppendStickyFooterOptions)(targetOptions, footerOptions);
};
const $7569d5986a617867$export$f448883a1dc0781 = ({ onPreloadCreateIssueTypeModal: onPreloadCreateIssueTypeModal = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), options: options, ...queryParams })=>{
    const createPopupTrigger = (0, $bE8VR.useTriggerContext)((0, $8Xb7Q.ConfigureWorkTypePanel));
    const editPopupTrigger = (0, $bE8VR.useTriggerContext)((0, $8Xb7Q.ConfigureWorkTypePanel));
    return (0, $eJOHy.useMemo)(()=>{
        const CustomOptionForWorkTypeConfig = ({ children: children, ...props })=>{
            if ((0, $8cd4b70a00850d28$export$108c7e65ed44598b) === props.data.type) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ipnsI.OptionWithButtonStyle), {
                testId: `issue-create.ui.modal.create-form.type-picker.option-with-button-${props.data.type}`,
                onHover: !(0, $7jTnu.fg)('jira_gic_inline_create_work_type_refactor') ? onPreloadCreateIssueTypeModal : (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
                ...props,
                innerProps: {
                    ...props.innerProps,
                    role: 'button'
                }
            }, children);
            if ((0, $8cd4b70a00850d28$export$4b72a3b40a1adf13) === props.data.type) {
                if (!(0, $7jTnu.fg)('jira_gic_inline_create_work_type_refactor')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ipnsI.OptionWithButtonStyle), {
                    testId: `issue-create.ui.modal.create-form.type-picker.option-with-button-${props.data.type}`,
                    onHover: onPreloadCreateIssueTypeModal,
                    ...props,
                    innerProps: {
                        ...props.innerProps,
                        role: 'button'
                    }
                }, children);
                const { createEntryPointProps: createEntryPointProps, createEntryPointParams: createEntryPointParams, createIssueTypeButtonRef: createIssueTypeButtonRef, shouldTriggerModal: shouldTriggerModal, onClickCreateOrEditOption: onClickCreateOrEditOption } = queryParams;
                const getClickElement = (ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bQP4O.default), {
                        xcss: $7569d5986a617867$var$pressableStyles,
                        // onClick is intercepted by ModalEntryPointPressableTrigger/Trigger component via usePressablePreloadRef
                        // so we need to manually trigger a synthetic click on left mouse click
                        onMouseDown: (e)=>{
                            // Left mouse button was clicked
                            if (e.button === 0) createIssueTypeButtonRef?.current?.click();
                        },
                        onClick: ()=>onClickCreateOrEditOption('createIssueTypeButton'),
                        // ref returned from entrypoint is of Type 'RefObject<HTMLElement>' is not assignable to type 'Ref<HTMLButtonElement>
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        ref: ref
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ipnsI.OptionWithButtonStyle), {
                        testId: `issue-create.ui.modal.create-form.type-picker.option-with-button-${props.data.type}`,
                        ...props
                    }, children));
                return shouldTriggerModal ? // TODO (JGFENG-1237) Migrate deprecated ModalEntryPointPressableTrigger
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f7Yza.ModalEntryPointPressableTrigger), {
                    entryPoint: (0, $fGRYk.asyncCreateIssueTypeModalEntryPoint),
                    entryPointProps: createEntryPointProps,
                    entryPointParams: createEntryPointParams,
                    interactionName: "create-issue-type-modal",
                    modalProps: (0, $llT4J.defaultModalProps),
                    useInternalModal: true,
                    forwardedRef: createIssueTypeButtonRef,
                    Fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aaGSX.FormDialogSkeleton), {
                            numFormFields: 1
                        })
                }, ({ ref: ref })=>getClickElement(ref)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lppZM.Trigger), {
                    trigger: createPopupTrigger,
                    entryPoint: (0, $fGRYk.asyncCreateIssueTypeModalEntryPoint),
                    entryPointProps: createEntryPointProps,
                    entryPointParams: createEntryPointParams,
                    fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aaGSX.FormDialogSkeleton), {
                        numFormFields: 1
                    }),
                    forwardedRef: createIssueTypeButtonRef
                }, ({ ref: ref })=>getClickElement(ref));
            }
            if ((0, $8cd4b70a00850d28$export$aaaa9d64eeea4a55) === props.data.type) {
                const { projectId: projectId, projectKey: projectKey, issueTypeId: issueTypeId, onEditModalClose: onEditModalClose, onRefetchIssueTypesWhenIssueTypeUpdated: onRefetchIssueTypesWhenIssueTypeUpdated, editIssueTypeButtonRef: editIssueTypeButtonRef, editEntryPointProps: editEntryPointProps, editEntryPointParams: editEntryPointParams, shouldTriggerModal: shouldTriggerModal, onClickCreateOrEditOption: onClickCreateOrEditOption } = queryParams;
                const getClickElement = (ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bQP4O.default), {
                        xcss: $7569d5986a617867$var$pressableStyles,
                        // onClick is intercepted by ModalEntryPointPressableTrigger/Trigger component via usePressablePreloadRef,
                        // so we need to manually trigger a synthetic click on left mouse click
                        onMouseDown: (e)=>{
                            // Left mouse button was clicked
                            if (e.button === 0) editIssueTypeButtonRef?.current?.click();
                        },
                        onClick: ()=>onClickCreateOrEditOption('editIssueTypeButton'),
                        // ref returned from entrypoint is of Type 'RefObject<HTMLElement>' is not assignable to type 'Ref<HTMLButtonElement>
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        ref: ref
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ipnsI.OptionWithButtonStyle), {
                        testId: `issue-create.ui.modal.create-form.type-picker.option-with-button-${props.data.type}`,
                        ...props
                    }, children));
                // eslint-disable-next-line no-nested-ternary
                return shouldTriggerModal ? (0, $7jTnu.fg)('jira_gic_inline_create_work_type_refactor') ? // TODO (JGFENG-1237) Migrate deprecated ModalEntryPointPressableTrigger
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f7Yza.ModalEntryPointPressableTrigger), {
                    entryPoint: (0, $eCVV2.asyncEditIssueTypeModalEntrypoint),
                    entryPointProps: editEntryPointProps,
                    entryPointParams: editEntryPointParams,
                    interactionName: "create-issue-type-modal",
                    modalProps: (0, $llT4J.defaultModalProps),
                    useInternalModal: true,
                    Fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aaGSX.FormDialogSkeleton), {
                            numFormFields: 3
                        }),
                    forwardedRef: editIssueTypeButtonRef
                }, ({ ref: ref })=>getClickElement(ref)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7kzWm.EditIssueTypeModalTrigger), {
                    onIssueTypeUpdated: onRefetchIssueTypesWhenIssueTypeUpdated,
                    ufoExperience: (0, $iIqFO.EditIssueTypeUFOExperience),
                    onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
                    onClose: onEditModalClose,
                    projectId: projectId,
                    projectKey: projectKey,
                    calledFrom: (0, $a9cbb8c64aa7f847$export$66397ed56abea4ca),
                    issueTypeId: issueTypeId,
                    ref: editIssueTypeButtonRef,
                    relevantIssueTypeIds: options.map((option)=>option.value.toString())
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ipnsI.OptionWithButtonStyle), {
                    testId: `issue-create.ui.modal.create-form.type-picker.option-with-button-${props.data.type}`,
                    ...props
                }, children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lppZM.Trigger), {
                    trigger: editPopupTrigger,
                    entryPoint: (0, $eCVV2.asyncEditIssueTypeModalEntrypoint),
                    entryPointProps: editEntryPointProps,
                    entryPointParams: editEntryPointParams,
                    fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aaGSX.FormDialogSkeleton), {
                        numFormFields: 3
                    }),
                    forwardedRef: editIssueTypeButtonRef
                }, ({ ref: ref })=>getClickElement(ref));
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lXDnY.OptionWithAutoKeyboardScroll), props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
                xcss: $7569d5986a617867$var$optionContainerStyles
            }, children));
        };
        return CustomOptionForWorkTypeConfig;
    }, [
        onPreloadCreateIssueTypeModal,
        queryParams,
        options,
        createPopupTrigger,
        editPopupTrigger
    ]);
};
const $7569d5986a617867$export$d2eb156c53eb582e = ({ options: options, projectId: projectId, projectKey: projectKey, issueTypeId: issueTypeId, canConfigureIssueTypes: canConfigureIssueTypes, onPreloadCreateIssueTypeModal: onPreloadCreateIssueTypeModal = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), onLoadCreateIssueTypeModal: onLoadCreateIssueTypeModal = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), onIssueTypeCreatedOrUpdated: onIssueTypeCreatedOrUpdated = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), onCreateModalClose: onCreateModalClose, onEditModalClose: onEditModalClose, createIssueTypeButtonRef: createIssueTypeButtonRef, editIssueTypeButtonRef: editIssueTypeButtonRef, shouldTriggerModal: shouldTriggerModal, onClickCreateOrEditOption: onClickCreateOrEditOption })=>{
    const noOptionWrapperRef = (0, $eJOHy.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const cloudId = (0, $kEUB1.useCloudId)();
    const onCloseCreateIssueTypeModal = (0, $eJOHy.useCallback)(()=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'inlineCreateIssueTypeModal',
            action: 'closed'
        }));
        onCreateModalClose();
    }, [
        createAnalyticsEvent,
        onCreateModalClose
    ]);
    const createEntryPointParams = (0, $eJOHy.useMemo)(()=>({
            cloudId: cloudId,
            projectKey: projectKey
        }), [
        cloudId,
        projectKey
    ]);
    const createEntryPointProps = (0, $eJOHy.useMemo)(()=>({
            onIssueTypeCreated: onIssueTypeCreatedOrUpdated,
            issueTypesCountLimit: 30,
            onClose: onCloseCreateIssueTypeModal,
            onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            source: (0, $a9cbb8c64aa7f847$export$66397ed56abea4ca),
            ufoExperience: (0, $iIqFO.CreateIssueTypeUFOExperience),
            shouldFetchProjectData: true,
            showNewIssueTypeForm: (0, $7jTnu.fg)('inline_issue_type_config_productionization_prereqs'),
            isWrappedInModal: shouldTriggerModal
        }), [
        onIssueTypeCreatedOrUpdated,
        onCloseCreateIssueTypeModal,
        shouldTriggerModal
    ]);
    const editEntryPointParams = (0, $eJOHy.useMemo)(()=>({
            cloudId: cloudId,
            projectKey: projectKey
        }), [
        cloudId,
        projectKey
    ]);
    const editEntryPointProps = (0, $eJOHy.useMemo)(()=>({
            onRefetchIssueTypesWhenIssueTypeUpdated: onIssueTypeCreatedOrUpdated,
            onClose: onEditModalClose,
            onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            calledFrom: (0, $a9cbb8c64aa7f847$export$66397ed56abea4ca),
            ufoExperience: (0, $iIqFO.EditIssueTypeUFOExperience),
            shouldShowIssueTypeSelect: true,
            issueTypeId: issueTypeId,
            projectId: Number(projectId),
            projectKey: projectKey,
            relevantIssueTypeIds: options.map((option)=>option.value.toString()),
            isWrappedInModal: shouldTriggerModal
        }), [
        onIssueTypeCreatedOrUpdated,
        onEditModalClose,
        issueTypeId,
        projectId,
        projectKey,
        options,
        shouldTriggerModal
    ]);
    const CustomOptionWithInlineConfig = $7569d5986a617867$export$f448883a1dc0781({
        projectId: Number(projectId),
        ufoExperience: (0, $iIqFO.EditIssueTypeUFOExperience),
        onRefetchIssueTypesWhenIssueTypeUpdated: onIssueTypeCreatedOrUpdated,
        calledFrom: (0, $a9cbb8c64aa7f847$export$66397ed56abea4ca),
        onEditModalClose: onEditModalClose,
        projectKey: projectKey,
        issueTypeId: issueTypeId,
        onPreloadCreateIssueTypeModal: onPreloadCreateIssueTypeModal,
        createIssueTypeButtonRef: createIssueTypeButtonRef,
        editIssueTypeButtonRef: editIssueTypeButtonRef,
        options: options,
        createEntryPointProps: createEntryPointProps,
        createEntryPointParams: createEntryPointParams,
        editEntryPointProps: editEntryPointProps,
        editEntryPointParams: editEntryPointParams,
        shouldTriggerModal: shouldTriggerModal,
        onClickCreateOrEditOption: onClickCreateOrEditOption
    });
    const optionsWithActions = $7569d5986a617867$export$b5c5ad2ef493d247(options ?? []);
    const createEntryPointPropsForNoOptions = (0, $eJOHy.useMemo)(()=>({
            ...createEntryPointProps,
            source: (0, $a9cbb8c64aa7f847$export$a1077f863a923e94)
        }), [
        createEntryPointProps
    ]);
    const handleClick = (0, $eJOHy.useCallback)(()=>{
        if ((0, $7jTnu.fg)('jira_gic_inline_create_work_type_refactor')) onClickCreateOrEditOption('createIssueTypeButton');
        else onLoadCreateIssueTypeModal();
    }, [
        onClickCreateOrEditOption,
        onLoadCreateIssueTypeModal
    ]);
    if (!canConfigureIssueTypes) return {
        options: options,
        components: undefined
    };
    const NoOptionsMessage = ()=>{
        // eslint-disable-next-line react-hooks/react-compiler
        const { formatMessage: formatMessage } = (0, $lRq8t.default)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            ref: noOptionWrapperRef,
            paddingInline: "space.150",
            paddingBlock: "space.050"
        }, formatMessage((0, $7jTnu.fg)('jira-issue-terminology-refresh-m3') ? (0, $amdjq.default).noSearchResultsIssueTermRefresh : (0, $amdjq.default).noSearchResultsOldTerm, {
            button: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iY1yb.CreateWorkTypeButton), {
                    onClick: handleClick,
                    onMouseEnter: onPreloadCreateIssueTypeModal,
                    entryPointProps: createEntryPointPropsForNoOptions,
                    entryPointParams: createEntryPointParams,
                    shouldTriggerModal: shouldTriggerModal
                }, chunks)
        }));
    };
    return {
        options: optionsWithActions,
        components: {
            Group: (0, $9ZjBG.GroupComponentWithStickyFooter),
            Option: CustomOptionWithInlineConfig,
            NoOptionsMessage: NoOptionsMessage
        },
        noOptionWrapperRef: noOptionWrapperRef
    };
};
const $7569d5986a617867$export$edd8a0e9715caecc = (selectRef)=>{
    return ()=>{
        // When Create issue type or Edit issue type modal is closed, the modal will automatically return focus to the issue type field
        // The returned focus is returning fine and works well for keyboard users, however, @atlaskit/select caused some weird bug which
        // made issue type field not clickable for mouse users until it gets a refocus after a while, if we refocus immediately it also won't work
        // We tried to refocus with requestIdleCallback and requestAnimationFrame to delay the focus point based on CPU Idle and frame Idle
        // but none of that works so we need to use setTimeout temporarily before ADS team fix this issue
        setTimeout(()=>{
            // Refocusing to make issue type field clickable after focus is returned from closing modal
            selectRef.current?.blur();
            selectRef.current?.focus();
        }, (0, $8cd4b70a00850d28$export$34934e4a629b9612));
    };
};
const $7569d5986a617867$var$optionContainerStyles = (0, $1DXK0.xcss)({
    wordBreak: 'break-word'
});
const $7569d5986a617867$var$pressableStyles = (0, $1DXK0.xcss)({
    height: '100%',
    width: '100%',
    backgroundColor: 'color.background.neutral.subtle',
    alignItems: 'center',
    textAlign: 'left',
    fontWeight: 'font.weight.regular',
    padding: 'space.0',
    font: 'font.body'
});

});
parcelRegister("7kzWm", function(module, exports) {

$parcel$export(module.exports, "EditIssueTypeModalTrigger", () => $243e5862448ea46c$export$8e0c16e9bec511f3);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $8nu6j = parcelRequire("8nu6j");
var $bQP4O = parcelRequire("bQP4O");
var $1DXK0 = parcelRequire("1DXK0");

var $eCVV2 = parcelRequire("eCVV2");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $kEUB1 = parcelRequire("kEUB1");

var $f7Yza = parcelRequire("f7Yza");

var $llT4J = parcelRequire("llT4J");

var $aaGSX = parcelRequire("aaGSX");

var $7jTnu = parcelRequire("7jTnu");
const $243e5862448ea46c$export$8e0c16e9bec511f3 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ onIssueTypeUpdated: onIssueTypeUpdated = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), onOpen: onOpen, onClose: onClose, relevantIssueTypeIds: relevantIssueTypeIds, calledFrom: calledFrom, issueTypeId: issueTypeId, projectId: projectId, projectKey: projectKey, ufoExperience: ufoExperience, children: children, isPressable: isPressable = false, onClick: onClick = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), enablePressableStyles: enablePressableStyles = false }, forwardedRef)=>{
    const cloudId = (0, $kEUB1.useCloudId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const entryPointParams = (0, $eJOHy.useMemo)(()=>({
            projectKey: projectKey,
            cloudId: cloudId
        }), [
        projectKey,
        cloudId
    ]);
    const onModalClose = (0, $eJOHy.useCallback)(()=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'inlineEditIssueTypeModal',
            action: 'closed'
        }));
        onClose();
    }, [
        createAnalyticsEvent,
        onClose
    ]);
    const entryPointProps = (0, $eJOHy.useMemo)(()=>({
            onRefetchIssueTypesWhenIssueTypeUpdated: onIssueTypeUpdated,
            onClose: onModalClose,
            onOpen: onOpen,
            calledFrom: calledFrom,
            ufoExperience: ufoExperience,
            shouldShowIssueTypeSelect: true,
            issueTypeId: issueTypeId,
            projectId: projectId,
            projectKey: projectKey,
            relevantIssueTypeIds: relevantIssueTypeIds
        }), [
        onIssueTypeUpdated,
        onModalClose,
        onOpen,
        calledFrom,
        ufoExperience,
        issueTypeId,
        projectId,
        projectKey,
        relevantIssueTypeIds
    ]);
    const onWrapperClick = (0, $eJOHy.useCallback)((e)=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'editIssueTypeButton', {
            source: calledFrom
        });
        // If we triggered the click manually for keyboard users (isPressable = false)
        // this handler becomes the source-of-truth handler for both keyboard users and mouse users
        // However, we need to stopPropagation from here to prevent double modal for mouse users
        // When mouse user clicks the button, if we don't stop propagation here, option change handler
        // will be called which will trigger click manually again and cause double modal rendering
        !isPressable && e.stopPropagation();
        onClick();
    }, [
        calledFrom,
        createAnalyticsEvent,
        isPressable,
        onClick
    ]);
    const Wrapper = isPressable ? (0, $bQP4O.default) : (0, $8nu6j.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f7Yza.ModalEntryPointPressableTrigger), {
        entryPoint: (0, $eCVV2.asyncEditIssueTypeModalEntrypoint),
        entryPointParams: entryPointParams,
        entryPointProps: entryPointProps,
        interactionName: "edit-issue-type-modal",
        useInternalModal: true,
        modalProps: (0, $llT4J.defaultModalProps),
        forwardedRef: forwardedRef,
        Fallback: (0, $7jTnu.fg)('jgfeng_new_work_type_fallback_loading_state') ? ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aaGSX.FormDialogSkeleton), {
                numFormFields: 3
            }) : undefined
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Wrapper, {
            testId: "edit-issue-type-modal-trigger.wrapper",
            onClick: onWrapperClick,
            // @ts-expect-error - The reference type from ModalEntryPointPressableTrigger is incompatible with Pressable/Box,
            // but this works correctly at runtime and is a type-system limitation
            ref: ref,
            xcss: enablePressableStyles && $243e5862448ea46c$var$pressableStyles
        }, children));
});
const $243e5862448ea46c$var$pressableStyles = (0, $1DXK0.xcss)({
    paddingTop: 'space.100',
    paddingBottom: 'space.100',
    paddingLeft: 'space.150',
    paddingRight: 'space.150',
    textAlign: 'left',
    font: 'inherit',
    color: 'color.text',
    backgroundColor: 'color.background.neutral.subtle',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed'
    }
});

});
parcelRegister("eCVV2", function(module, exports) {

$parcel$export(module.exports, "asyncEditIssueTypeModalEntrypoint", () => $09686e3af1a308a2$export$77154afa25455a57);

var $fdUv7 = parcelRequire("fdUv7");

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $09686e3af1a308a2$export$77154afa25455a57 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("661zs")).then((module)=>module.AsyncEditIssueTypeModal), {
        moduleId: "22548b83",
        priority: "interaction"
    }),
    getPreloadProps: ({ projectKey: projectKey, cloudId: cloudId })=>({
            queries: {
                editIssueTypeModal: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $fdUv7.default,
                    variables: {
                        projectKey: projectKey,
                        cloudId: cloudId
                    }
                }
            }
        })
});

});
parcelRegister("fdUv7", function(module, exports) {

$parcel$export(module.exports, "default", () => $68bfd43b9dada7e5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e1192085c48690de29428a79c9d6d1b6>>
 * @relayHash e7bd81102c1dee96dbca11245e366952
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4b119f6603ebb196c870e258ef65c6302b9c0f15a6c9732a0f8d24d5c27ad696
const $68bfd43b9dada7e5$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "issueTypeId"
    }, v3 = {
        "kind": "ScalarField",
        "name": "name"
    }, v4 = {
        "kind": "ScalarField",
        "name": "description"
    }, v5 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "medium"
            }
        ]
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "srcAsyncEditIssueTypeQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v1 /*: any*/ ,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProjectByKey",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "JiraIssueTypeConnection",
                                                "kind": "LinkedField",
                                                "name": "issueTypes",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "JiraIssueTypeEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": {
                                                                        "concreteType": "JiraIssueType",
                                                                        "kind": "LinkedField",
                                                                        "name": "node",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v2 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "jira.jiraProjectByKey.issueTypes.edges.node.issueTypeId"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v3 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "jira.jiraProjectByKey.issueTypes.edges.node.name"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v4 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "jira.jiraProjectByKey.issueTypes.edges.node.description"
                                                                            },
                                                                            v5 /*: any*/ 
                                                                        ]
                                                                    },
                                                                    "action": "THROW",
                                                                    "path": "jira.jiraProjectByKey.issueTypes.edges.node"
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "jira.jiraProjectByKey.issueTypes.edges"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "jira.jiraProjectByKey.issueTypes"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.jiraProjectByKey"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "srcAsyncEditIssueTypeQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueTypeConnection",
                                    "kind": "LinkedField",
                                    "name": "issueTypes",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueTypeEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueType",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v2 /*: any*/ ,
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v6 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "4b119f6603ebb196c870e258ef65c6302b9c0f15a6c9732a0f8d24d5c27ad696",
            "metadata": {},
            "name": "srcAsyncEditIssueTypeQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$68bfd43b9dada7e5$var$node.hash = "95da41f0960685e3830143828659ecad";
var $68bfd43b9dada7e5$export$2e2bcd8739ae039 = $68bfd43b9dada7e5$var$node;

});

parcelRegister("661zs", function(module, exports) {

let $01253bf60604a2ee$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $01253bf60604a2ee$var$load("ffQaD"),
    $01253bf60604a2ee$var$load("kvRbA"),
    $01253bf60604a2ee$var$load("hvGrC")
]).then(()=>parcelRequire('d5kQ7'));

});


parcelRegister("llT4J", function(module, exports) {

$parcel$export(module.exports, "defaultModalProps", () => $38e5b01445975ac2$export$14c11acc66fd51b3);
const $38e5b01445975ac2$export$14c11acc66fd51b3 = {
    width: '395px'
};

});


parcelRegister("iY1yb", function(module, exports) {

$parcel$export(module.exports, "CreateWorkTypeButton", () => $47cc4e7d9c46a00d$export$8d68a7afe8d814ec);

var $eJOHy = parcelRequire("eJOHy");

var $bQP4O = parcelRequire("bQP4O");
var $1DXK0 = parcelRequire("1DXK0");

var $gCeeo = parcelRequire("gCeeo");

var $fGRYk = parcelRequire("fGRYk");

var $f7Yza = parcelRequire("f7Yza");


var $7jTnu = parcelRequire("7jTnu");

var $llT4J = parcelRequire("llT4J");

var $epTsa = parcelRequire("epTsa");

var $aaGSX = parcelRequire("aaGSX");

var $lppZM = parcelRequire("lppZM");
var $bE8VR = parcelRequire("bE8VR");

var $8Xb7Q = parcelRequire("8Xb7Q");
const $47cc4e7d9c46a00d$export$8d68a7afe8d814ec = ({ children: children, onClick: onClick, onMouseEnter: onMouseEnter, entryPointProps: entryPointProps, entryPointParams: entryPointParams, shouldTriggerModal: shouldTriggerModal })=>{
    const popupTrigger = (0, $bE8VR.useTriggerContext)((0, $8Xb7Q.ConfigureWorkTypePanel));
    const createWorkTypeButtonRef = (0, $eJOHy.useRef)(null);
    const handleClick = (0, $eJOHy.useCallback)((e, analyticsEvent)=>{
        onClick();
        // Will be handled in onClick when fg is on
        if (!(0, $7jTnu.fg)('jira_gic_inline_create_work_type_refactor')) (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'createIssueTypeButton', {
            calledFrom: (0, $a9cbb8c64aa7f847$export$a1077f863a923e94)
        });
    }, [
        onClick
    ]);
    if (!(0, $7jTnu.fg)('jira_gic_inline_create_work_type_refactor')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bQP4O.default), {
        onClick: handleClick,
        onMouseEnter: onMouseEnter,
        xcss: $47cc4e7d9c46a00d$var$createWorkTypeInlineNoResultStyles
    }, children);
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [inlineIssueTypeConfigProductionizationExpConfig] = (0, $epTsa.UNSAFE_noExposureExp)('inline_issue_type_config_productionization_exp');
    const getClickElement = (ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bQP4O.default), {
            // onClick is intercepted by ModalEntryPointPressableTrigger/Trigger component via usePressablePreloadRef,
            // so we need to manually trigger a synthetic click on left mouse click
            onMouseDown: (e)=>{
                // Left mouse button was clicked
                if (e.button === 0) createWorkTypeButtonRef?.current?.click();
            },
            onKeyDown: (e)=>{
                if (e.key === 'Enter' || e.key === ' ') createWorkTypeButtonRef?.current?.click();
            },
            onClick: handleClick,
            xcss: $47cc4e7d9c46a00d$var$createWorkTypeInlineNoResultStyles,
            // @ts-expect-error - The reference type from ModalEntryPointPressableTrigger is incompatible with Pressable,
            // but this works correctly at runtime and is a type-system limitation
            ref: ref
        }, children);
    return shouldTriggerModal ? // TODO (JGFENG-1237) Migrate deprecated ModalEntryPointPressableTrigger
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f7Yza.ModalEntryPointPressableTrigger), {
        entryPoint: (0, $fGRYk.asyncCreateIssueTypeModalEntryPoint),
        entryPointProps: entryPointProps,
        entryPointParams: entryPointParams,
        interactionName: "create-issue-type-modal",
        modalProps: (0, $llT4J.defaultModalProps),
        useInternalModal: inlineIssueTypeConfigProductionizationExpConfig.get('isEnabled', false),
        Fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aaGSX.FormDialogSkeleton), {
                numFormFields: 1
            })
    }, ({ ref: ref })=>getClickElement(ref)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lppZM.Trigger), {
        trigger: popupTrigger,
        entryPoint: (0, $fGRYk.asyncCreateIssueTypeModalEntryPoint),
        entryPointProps: entryPointProps,
        entryPointParams: entryPointParams,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aaGSX.FormDialogSkeleton), {
            numFormFields: 1
        }),
        forwardedRef: createWorkTypeButtonRef
    }, ({ ref: ref })=>getClickElement(ref));
};
const $47cc4e7d9c46a00d$var$createWorkTypeInlineNoResultStyles = (0, $1DXK0.xcss)({
    paddingBlockStart: 'space.0',
    paddingInline: 'space.0',
    marginTop: 'space.100',
    borderRadius: "var(--ds-space-025, 2px)",
    color: 'color.link',
    backgroundColor: 'color.background.neutral.subtle',
    display: 'block',
    fontWeight: 'font.weight.bold'
});

});
parcelRegister("8Xb7Q", function(module, exports) {

$parcel$export(module.exports, "ConfigureWorkTypePanel", () => $e28b1abc7edefb6d$export$7094eabeed135ee7);

var $5j8hU = parcelRequire("5j8hU");
const $e28b1abc7edefb6d$export$7094eabeed135ee7 = (0, $5j8hU.createPanel)();

});



parcelRegister("42ofz", function(module, exports) {

$parcel$export(module.exports, "WhatsThis", () => $a9a317f57e5acfbc$export$9fb74911aca1203);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eJ9f5 = parcelRequire("eJ9f5");

var $goZPP = parcelRequire("goZPP");

var $3cMgR = parcelRequire("3cMgR");

var $7jTnu = parcelRequire("7jTnu");

var $6joHJ = parcelRequire("6joHJ");

var $epTsa = parcelRequire("epTsa");

var $kDaaB = parcelRequire("kDaaB");

var $dTocu = parcelRequire("dTocu");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");


var $hIjWC = parcelRequire("hIjWC");
const $a9a317f57e5acfbc$export$9fb74911aca1203 = ()=>{
    const { formatMessage: formatMessage } = (0, $dTocu.useIntlV2)();
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const toggleDialog = (0, $eJOHy.useCallback)(()=>{
        if (!isOpen) (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'gicRequestTypeHelpDialogButton clicked');
        setIsOpen(!isOpen);
    }, [
        createAnalyticsEvent,
        isOpen
    ]);
    const dialogContent = (0, $eJOHy.useMemo)(()=>{
        const onClickLearnMoreLink = ()=>(0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'gicRequestTypeLearnMoreLink clicked');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a9a317f57e5acfbc$var$DialogContainer, {
            "data-testid": "issue-create.ui.modal.create-form.type-picker.request-type-changeboarding.dialog-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
            as: "p"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), {
            ...(0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $hIjWC.default).whatsThisDialogBodyIssueTermRefresh : (0, $hIjWC.default).whatsThisDialogBody,
            values: {
                learnMoreAboutRequestTypesLink: (0, $7jTnu.fg)('replace-anchor-with-link__gryffindor') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
                    href: (0, $1e95a1a772cc9117$export$2e27f6d0b2889d14),
                    target: "_blank",
                    onClick: onClickLearnMoreLink,
                    onAuxClick: onClickLearnMoreLink
                }, formatMessage((0, $hIjWC.default).learnMoreAboutRequestTypesLink)) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("a", {
                    href: (0, $1e95a1a772cc9117$export$2e27f6d0b2889d14),
                    target: "_blank",
                    onClick: onClickLearnMoreLink,
                    onAuxClick: onClickLearnMoreLink
                }, formatMessage((0, $hIjWC.default).learnMoreAboutRequestTypesLink))
            }
        })));
    }, [
        createAnalyticsEvent,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6joHJ.JiraInlineDialog), {
        messageId: "issue-create.ui.modal.create-form.type-picker.request-type-changeboarding.inline-dialog.jira-inline-dialog",
        messageType: "engagement",
        content: dialogContent,
        isOpen: isOpen,
        placement: "bottom-end",
        onClose: toggleDialog
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a9a317f57e5acfbc$var$WhatsThisButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "subtle-link",
        spacing: "none",
        onClick: toggleDialog
    }, formatMessage((0, $hIjWC.default).whatsThisDialogTrigger))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a9a317f57e5acfbc$var$WhatsThisButtonWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _11c81o8v _1e0c1txw _2lx2vrvc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a9a317f57e5acfbc$var$DialogContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsb1178",
            __cmplp.className
        ])
    });
});

});
const $1e95a1a772cc9117$export$2e27f6d0b2889d14 = 'https://support.atlassian.com/jira-service-management-cloud/docs/what-are-request-types/';

parcelRegister("hIjWC", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c5adbf4ae2f4764$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $2c5adbf4ae2f4764$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    whatsThisDialogTrigger: {
        "id": "issue-create.modal.create-form.type-picker.request-type-changeboarding.whats-this-dialog-trigger",
        "defaultMessage": "What\u2019s this?"
    },
    whatsThisDialogBody: {
        "id": "issue-create.modal.create-form.type-picker.request-type-changeboarding.whats-this-dialog-body",
        "defaultMessage": "Request types allow requests to show in the Help Center, gain additional features in the issue view, and access work categories. {learnMoreAboutRequestTypesLink}."
    },
    learnMoreAboutRequestTypesLink: {
        "id": "issue-create.modal.create-form.type-picker.request-type-changeboarding.learn-more-about-request-types-link",
        "defaultMessage": "Learn more about request types"
    },
    whatsThisDialogBodyIssueTermRefresh: {
        "id": "issue-create.modal.create-form.type-picker.request-type-changeboarding.whats-this-dialog-body-issue-term-refresh",
        "defaultMessage": "Request types allow requests to show in the Help Center, gain additional features in the detailed view of the work item, and access work categories. {learnMoreAboutRequestTypesLink}."
    }
});

});


parcelRegister("jr9QD", function(module, exports) {

$parcel$export(module.exports, "RequestTypeHelpText", () => $e2a4ff102828b3e8$export$f97ad894319e2545);

var $eJOHy = parcelRequire("eJOHy");

var $cdbP5 = parcelRequire("cdbP5");

var $goZPP = parcelRequire("goZPP");

var $lRq8t = parcelRequire("lRq8t");

var $lLcsu = parcelRequire("lLcsu");

var $dTTMA = parcelRequire("dTTMA");
const $e2a4ff102828b3e8$export$6167fae6d6ed332c = (element)=>// https://stackoverflow.com/a/52650163
    // check if the element is being line clamped
    element ? element.scrollHeight !== element.offsetHeight : false;
const $e2a4ff102828b3e8$export$f97ad894319e2545 = ({ helpText: helpText })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    // this property sets whether or not the show more button will be visible
    const [shouldCollapse, setShouldCollapse] = (0, $eJOHy.useState)(false);
    // this property sets whether the text is expanded or collapsed
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const toggleIsOpen = ()=>setIsOpen(!isOpen);
    const helpTextRef = (0, $eJOHy.useRef)(undefined);
    const [windowWidth, windowHeight] = (0, $lLcsu.useWindowSize)();
    (0, $eJOHy.useEffect)(()=>{
        // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'HTMLElement | undefined'.
        const newShouldCollapse = $e2a4ff102828b3e8$export$6167fae6d6ed332c(helpTextRef.current);
        setShouldCollapse(newShouldCollapse);
        if (!newShouldCollapse) setIsOpen(false);
    }, [
        shouldCollapse,
        helpText,
        windowWidth,
        windowHeight
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e2a4ff102828b3e8$var$Collapser, {
        isOpen: isOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e2a4ff102828b3e8$var$HelpText, {
        isOpen: isOpen,
        innerRef: helpTextRef
    }, helpText)), shouldCollapse && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e2a4ff102828b3e8$var$ButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        spacing: "none",
        appearance: "subtle-link",
        onClick: toggleIsOpen
    }, formatMessage(isOpen ? (0, $dTTMA.default).showLess : (0, $dTTMA.default).showMore))));
};
/*
    The webkit styles enable multi-line text-overflow ellipsis.
    See https://stackoverflow.com/a/13924997
    It's a bit of a hack but it works in most browsers -
    worst case, it will fall back to not having the ellipsis.
*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e2a4ff102828b3e8$var$HelpText = /*#__PURE__*/ (0, $cdbP5.default).p.withConfig({
    componentId: "jy4tmi-0"
})({
    color: "var(--ds-text-subtle, #44546F)",
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
({ isOpen: isOpen })=>!isOpen ? `
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    ` : '');
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e2a4ff102828b3e8$var$Collapser = /*#__PURE__*/ (0, $cdbP5.default).div.withConfig({
    componentId: "jy4tmi-1"
})((props)=>({
        marginTop: "var(--ds-space-100, 8px)",
        overflow: 'hidden',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxHeight: props.isOpen ? 'fit-content' : '32px'
    }));
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e2a4ff102828b3e8$var$ButtonWrapper = /*#__PURE__*/ (0, $cdbP5.default).div.withConfig({
    componentId: "jy4tmi-2"
})`font:${"var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"};color:${"var(--ds-text-subtlest, #626F86)"};padding:0;margin:0;margin-top:${"var(--ds-space-075, 6px)"};button{padding:0;margin:0;border:0;}`;

});
parcelRegister("lLcsu", function(module, exports) {

$parcel$export(module.exports, "useWindowSize", () => $dcc33c098ca0de4e$export$42c02f33970a2afa);

var $eJOHy = parcelRequire("eJOHy");

var $3s8bj = parcelRequire("3s8bj");
const $dcc33c098ca0de4e$export$42c02f33970a2afa = ()=>{
    const isClient = !false;
    const getSize = ()=>({
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            width: isClient ? window.innerWidth : undefined,
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            height: isClient ? window.innerHeight : undefined
        });
    const [windowSize, setWindowSize] = (0, $eJOHy.useState)(getSize());
    const onResize = ()=>{
        setWindowSize(getSize());
    };
    const onResizeDebounced = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(onResize, 100, {
        leading: true,
        trailing: true
    });
    (0, $eJOHy.useEffect)(()=>{
        if (!isClient) return undefined;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('resize', onResizeDebounced);
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.removeEventListener('resize', onResizeDebounced);
        };
    }, [
        onResizeDebounced,
        isClient
    ]);
    return [
        windowSize.width,
        windowSize.height
    ];
};

});

parcelRegister("dTTMA", function(module, exports) {

$parcel$export(module.exports, "default", () => $35e6d5597fb2491f$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $35e6d5597fb2491f$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    showMore: {
        "id": "issue-create.modal.create-form.type-picker.request-type-help-text.show-more",
        "defaultMessage": "Show more\u2026"
    },
    showLess: {
        "id": "issue-create.modal.create-form.type-picker.request-type-help-text.show-less",
        "defaultMessage": "Show less\u2026"
    }
});

});


parcelRegister("2TyrS", function(module, exports) {

$parcel$export(module.exports, "RequestTypeSelect", () => $265a74abec8bb129$export$3b6e21307c2d4f74);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $cdbP5 = parcelRequire("cdbP5");

var $c4OV1 = parcelRequire("c4OV1");

var $epTsa = parcelRequire("epTsa");

var $iKnai = parcelRequire("iKnai");

var $lRq8t = parcelRequire("lRq8t");

var $c3eoY = parcelRequire("c3eoY");

var $1JDJh = parcelRequire("1JDJh");
const $265a74abec8bb129$var$selectStyles = {
    // @ts-expect-error - TS7006 - Parameter 'supplied' implicitly has an 'any' type.
    control: (supplied)=>({
            ...supplied,
            paddingTop: "var(--ds-space-100, 8px)",
            paddingBottom: "var(--ds-space-100, 8px)"
        }),
    // @ts-expect-error - TS7006 - Parameter 'supplied' implicitly has an 'any' type.
    valueContainer: (supplied)=>({
            ...supplied,
            padding: '0',
            paddingLeft: "var(--ds-space-150, 12px)",
            height: '42px' // specify a static height for the container, because the text container is absolutely positioned
        }),
    // @ts-expect-error - TS7006 - Parameter 'supplied' implicitly has an 'any' type.
    menuList: (supplied)=>({
            ...supplied,
            padding: 0
        }),
    // @ts-expect-error - TS7006 - Parameter 'supplied' implicitly has an 'any' type.
    group: (supplied)=>({
            ...supplied,
            padding: 0
        }),
    // @ts-expect-error - TS7006 - Parameter 'supplied' implicitly has an 'any' type.
    groupHeading: (supplied)=>({
            ...supplied,
            margin: 0,
            paddingTop: "var(--ds-space-200, 16px)",
            paddingBottom: "var(--ds-space-100, 8px)",
            font: "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
            color: "var(--ds-text, #172B4D)",
            textTransform: 'none' // default is uppercase
        }),
    // @ts-expect-error - TS7006 - Parameter 'supplied' implicitly has an 'any' type.
    singleValue: (supplied)=>({
            ...supplied,
            top: 0,
            left: "var(--ds-space-150, 12px)",
            textOverflow: 'ellipsis',
            transform: 'none',
            // default is -50% y
            whiteSpace: 'nowrap',
            width: '100%',
            paddingRight: "var(--ds-space-400, 32px)"
        }),
    // @ts-expect-error - TS7006 - Parameter 'supplied' implicitly has an 'any' type.
    option: (supplied)=>({
            ...supplied,
            cursor: 'pointer',
            paddingLeft: "var(--ds-space-200, 16px)",
            paddingTop: "var(--ds-space-100, 8px)",
            paddingBottom: "var(--ds-space-100, 8px)",
            margin: 0
        })
};
const $265a74abec8bb129$export$3b6e21307c2d4f74 = /*#__PURE__*/ (0, $eJOHy.memo)((props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const formatOptionLabel = (0, $eJOHy.useCallback)((option, { context: context })=>{
        const description = option.type === 'NONE' ? formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $1JDJh.default).noRequestTypeOptionDescriptionIssueTermRefresh : (0, $1JDJh.default).noRequestTypeOptionDescription) : option.description;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($265a74abec8bb129$var$FlexRow, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($265a74abec8bb129$var$IconWrapper, null, option.type === 'NONE' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iKnai.default), {
            label: ""
        }) : Boolean(option.iconUrl) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($265a74abec8bb129$var$Icon, {
            src: option.iconUrl,
            alt: option.label
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($265a74abec8bb129$var$FlexColumn, {
            isMenu: context === 'menu'
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($265a74abec8bb129$var$Label, {
            "data-test-id": "issue-create.ui.modal.create-form.type-picker.request-type-select.label",
            isMenu: context === 'menu'
        }, option.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($265a74abec8bb129$var$Description, {
            "data-test-id": "issue-create.ui.modal.create-form.type-picker.request-type-select.description",
            isMenu: context === 'menu'
        }, description)));
    }, [
        formatMessage
    ]);
    return(// @ts-expect-error - TS2322 - Type '{ isClearable: false; formatOptionLabel: (option: NoneOption | RequestType, { context }: FormatOptionLabelMeta<NoneOption | RequestType>) => Element; ... 10 more ...;
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c4OV1.default), {
        ...props,
        isClearable: false,
        formatOptionLabel: formatOptionLabel,
        hideSelectedOptions: false,
        placeholder: "",
        maxMenuHeight: 256,
        styles: $265a74abec8bb129$var$selectStyles,
        onKeyDown: (0, $c3eoY.preventEscKeyPropagationKeyPressHandler),
        "aria-label": formatMessage((0, $1JDJh.default).ariaLabel)
    }));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $265a74abec8bb129$var$FlexRow = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1y6m",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $265a74abec8bb129$var$FlexColumn = /*#__PURE__*/ (0, $cdbP5.default).div.withConfig({
    componentId: "sc-1l270fi-0"
})((props)=>({
        flexDirection: 'column',
        display: 'flex',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `calc(100% - ${props.isMenu ? 40 : 14}px)`
    })); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $265a74abec8bb129$var$IconWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2hwxpxbi _1bsb1tcg _4t3i1tcg",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $265a74abec8bb129$var$Label = /*#__PURE__*/ (0, $cdbP5.default).p.withConfig({
    componentId: "sc-1l270fi-1"
})`font:${"var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"};color:${"var(--ds-text, #172B4D)"};margin-top:${"var(--ds-space-200, 16px)"};height:18px;width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $265a74abec8bb129$var$Icon = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4t3i1tcg _1bsb1tcg",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $265a74abec8bb129$var$Description = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c82smr _1reo15vq _18m915vq _4t3igktf _syaz1gjq _19pkidpf _ca0q1b66 _o5721q9c _1bto1l2s _1bsb1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("iKnai", function(module, exports) {

$parcel$export(module.exports, "default", () => $28b5bf53d9f6580c$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $fL0In = parcelRequire("fL0In");
const $28b5bf53d9f6580c$var$PresenceUnavailableSVG = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white",
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M15 12C15 11.2044 14.6839 10.4413 14.1213 9.87868C13.5587 9.31607 12.7956 9 12 9C11.2044 9 10.4413 9.31607 9.87868 9.87868C9.31607 10.4413 9 11.2044 9 12C9 12.7956 9.31607 13.5587 9.87868 14.1213C10.4413 14.6839 11.2044 15 12 15C12.7956 15 13.5587 14.6839 14.1213 14.1213C14.6839 13.5587 15 12.7956 15 12ZM6 12C6 10.4087 6.63214 8.88258 7.75736 7.75736C8.88258 6.63214 10.4087 6 12 6C13.5913 6 15.1174 6.63214 16.2426 7.75736C17.3679 8.88258 18 10.4087 18 12C18 13.5913 17.3679 15.1174 16.2426 16.2426C15.1174 17.3679 13.5913 18 12 18C10.4087 18 8.88258 17.3679 7.75736 16.2426C6.63214 15.1174 6 13.5913 6 12Z",
        fill: "#42526E"
    }));
const $28b5bf53d9f6580c$var$PresenceUnavailableIcon = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fL0In.default), {
        ...props,
        glyph: $28b5bf53d9f6580c$var$PresenceUnavailableSVG
    });
var $28b5bf53d9f6580c$export$2e2bcd8739ae039 = $28b5bf53d9f6580c$var$PresenceUnavailableIcon;

});

parcelRegister("1JDJh", function(module, exports) {

$parcel$export(module.exports, "default", () => $038ab84389a95ece$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $038ab84389a95ece$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    noRequestTypeOptionDescription: {
        "id": "issue-create.modal.create-form.type-picker.request-type-select.no-request-type-option-description",
        "defaultMessage": "Issues can\u2019t be shared with customers, and may not work as expected."
    },
    ariaLabel: {
        "id": "issue-create.modal.create-form.type-picker.request-type-select.aria-label",
        "defaultMessage": "Select request type"
    },
    noRequestTypeOptionDescriptionIssueTermRefresh: {
        "id": "issue-create.modal.create-form.type-picker.request-type-select.no-request-type-option-description-issue-term-refresh",
        "defaultMessage": "Work items can\u2019t be shared with customers, and may not work as expected."
    }
});

});


parcelRegister("bg1hW", function(module, exports) {

$parcel$export(module.exports, "ConfigureWorkTypePopup", () => $01371a4dedd33549$export$787af04f968c6fcf);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");

var $cNe2t = parcelRequire("cNe2t");
const $01371a4dedd33549$export$787af04f968c6fcf = ({ renderTarget: renderTarget, renderPopupContent: renderPopupContent, onClose: onClose })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cNe2t.JiraPopup), {
        content: renderPopupContent,
        isOpen: true,
        onClose: onClose,
        placement: "bottom-start",
        messageId: "issue-create.ui.modal.create-form.type-picker.configure-work-type.configure-work-type-popup.popup",
        messageType: "transactional",
        trigger: (triggerProps)=>// eslint-disable-next-line react/jsx-props-no-spreading
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                role: "button",
                ...triggerProps
            }, renderTarget()),
        shouldRenderToParent: true
    });
};

});


parcelRegister("bbvEo", function(module, exports) {

$parcel$export(module.exports, "transformValidationErrors", () => $2c051d499243f0af$export$8726164bd96601cc);
$parcel$export(module.exports, "getQueryVariables", () => $2c051d499243f0af$export$8c3d6ce16880e58e);
$parcel$export(module.exports, "getContextFieldsForSubmit", () => $2c051d499243f0af$export$2975feebfec7def8);
$parcel$export(module.exports, "getParentIdForSubmit", () => $2c051d499243f0af$export$b208d5bc9f5e315f);
$parcel$export(module.exports, "resetFormFieldsForCreateAnother", () => $2c051d499243f0af$export$d8f1f19cbcdc5ccf);
$parcel$export(module.exports, "getUserInputForRetention", () => $2c051d499243f0af$export$ffde08d8190479bd);
$parcel$export(module.exports, "transformInlineErrorMessage", () => $2c051d499243f0af$export$cc6683ccc73b073);
$parcel$export(module.exports, "getIssueCreateProjectForMount", () => $2c051d499243f0af$export$ce9d0b4bb614f329);
$parcel$export(module.exports, "canSetContextForSubmit", () => $2c051d499243f0af$export$fbc6cb29c318fa3a);
$parcel$export(module.exports, "shouldShowStatusField", () => $2c051d499243f0af$export$3a332740e4aa9440);
$parcel$export(module.exports, "shouldShowLinkedAlertsField", () => $2c051d499243f0af$export$d89be2967c4b3fcf);
$parcel$export(module.exports, "isWatchersUsed", () => $2c051d499243f0af$export$8625e37c02bbfb71);
$parcel$export(module.exports, "getAnalyticsIssueType", () => $2c051d499243f0af$export$385bf01e57223a7c);
$parcel$export(module.exports, "isDisplayConditionCFCausingError", () => $2c051d499243f0af$export$cbe00e1e05a1451f);
$parcel$export(module.exports, "useIsCurrentUserAdminOfProject", () => $2c051d499243f0af$export$d6fca3362baceda8);
$parcel$export(module.exports, "getAssigneeType", () => $2c051d499243f0af$export$8e1d3c5195ccd2e3);
$parcel$export(module.exports, "useShowOnlyRequiredFieldsExperiment", () => $2c051d499243f0af$export$8114879043932239);
$parcel$export(module.exports, "getShowOnlyRequiredFieldsDefaultValue", () => $2c051d499243f0af$export$b75f913e74c75ba5);

var $eJOHy = parcelRequire("eJOHy");

var $8dH3d = parcelRequire("8dH3d");

var $ln6Iy = parcelRequire("ln6Iy");

var $eDBhy = parcelRequire("eDBhy");


var $814y1 = parcelRequire("814y1");

var $6d9QY = parcelRequire("6d9QY");

var $epTsa = parcelRequire("epTsa");

var $1eq5t = parcelRequire("1eq5t");

var $bIpQn = parcelRequire("bIpQn");

var $7hAc3 = parcelRequire("7hAc3");
const $2c051d499243f0af$export$8726164bd96601cc = (errors)=>{
    let validationErrors;
    if (errors.length) {
        validationErrors = {};
        errors.forEach(({ field: field, error: error })=>{
            validationErrors = {
                ...validationErrors,
                [field]: error
            };
        });
    }
    return validationErrors;
};
const $2c051d499243f0af$export$8c3d6ce16880e58e = (selectedProject, selectedIssueType, defaultValues)=>{
    const projectId = selectedProject?.value || null;
    let issueTypeId = null;
    let requestTypeKey = null;
    if (selectedIssueType) {
        issueTypeId = selectedIssueType.type === (0, $4246188a36de9908$export$92ab80c1dc9baf44) ? selectedIssueType.issueTypeId : selectedIssueType.value;
        requestTypeKey = // @ts-expect-error - TS2339 - Property 'requestTypeKey' does not exist on type 'IssueType | RequestType'.
        selectedIssueType.requestTypeKey !== undefined ? selectedIssueType.requestTypeKey : null;
    }
    return {
        project: projectId ? {
            projectId: projectId
        } : null,
        issueType: issueTypeId !== null ? {
            issueTypeId: issueTypeId
        } : null,
        requestType: requestTypeKey !== null ? {
            key: requestTypeKey
        } : null,
        defaultValues: defaultValues || null
    };
};
const $2c051d499243f0af$export$2975feebfec7def8 = (selectedProject, selectedIssueType, requestTypeId)=>{
    const projectId = selectedProject.value;
    let issueTypeId;
    let requestTypeKey;
    if (selectedIssueType.type === (0, $4246188a36de9908$export$92ab80c1dc9baf44)) {
        issueTypeId = selectedIssueType.issueTypeId;
        requestTypeKey = selectedIssueType.requestTypeKey;
    } else issueTypeId = selectedIssueType.value;
    const requestTypePayload = requestTypeId !== undefined ? {
        [requestTypeId]: requestTypeKey
    } : {};
    return {
        project: {
            id: projectId
        },
        issuetype: {
            id: issueTypeId
        },
        ...requestTypePayload
    };
};
const $2c051d499243f0af$export$b208d5bc9f5e315f = (parentId)=>parentId && parentId.parentId ? {
        parent: {
            id: parentId.parentId
        }
    } : {};
const $2c051d499243f0af$export$d8f1f19cbcdc5ccf = (formData, fieldConfig, resetForm)=>{
    const resetFormData = {
        ...formData
    };
    (0, $7hAc3.NON_RETAINED_FIELDS_CREATE_ANOTHER).forEach((field)=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(formData[field.fieldId])) resetFormData[field.fieldId] = field.getClearedDefaultValue(fieldConfig);
    });
    const resetObject = {
        ...resetFormData,
        [(0, $814y1.SUMMARY_TYPE)]: ''
    };
    resetForm(resetObject);
    return resetObject;
};
const $2c051d499243f0af$export$77b34f1a71743196 = (fieldConfig, fieldValues)=>{
    const dirtyCheckboxFieldIds = {};
    Object.keys(fieldValues).forEach((fieldId)=>{
        const fieldData = fieldConfig[fieldId];
        const { gqlType: gqlType } = fieldData || {};
        if ((0, $7hAc3.FIELDS_TO_RETAIN_FIELD_VALUE).includes(gqlType) && !(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(fieldValues[fieldId])) dirtyCheckboxFieldIds[fieldId] = true;
    });
    return dirtyCheckboxFieldIds;
};
const $2c051d499243f0af$export$ffde08d8190479bd = ({ formState: formState, fieldConfig: fieldConfig, dirtyFieldsCurrentSession: dirtyFieldsCurrentSession, retainedFieldsData: retainedFieldsData, initialDefaultValues: initialDefaultValues = {}, selectedClassification: selectedClassification })=>{
    let classificationRetainValue = {};
    if (selectedClassification?.id) classificationRetainValue = {
        dataClassification: {
            dataClassificationId: selectedClassification.id
        }
    };
    if (!formState) return initialDefaultValues;
    if (!retainedFieldsData || !retainedFieldsData.current) return initialDefaultValues;
    const { dirtyFields: dirtyFields, values: values } = formState;
    /*
        This is a hacky solution for solving field value retention issue for Checkboxes field.

        As fieldIds of the checkboxes fields are not present in the dirtyFileds (getting from formState) even if field values are updated,
        we're fetching all the fieldIds of the Checkboxes field, which has some field values, from formState values and storing those in a variable.
        After that we are appending that data (dirtyCheckboxFields) in dirtyFieldsCurrentSession.
    */ const dirtyCheckboxFieldIds = $2c051d499243f0af$export$77b34f1a71743196(fieldConfig, values);
    // eslint-disable-next-line no-param-reassign
    dirtyFieldsCurrentSession.current = {
        ...dirtyFieldsCurrentSession.current,
        ...dirtyFields,
        ...dirtyCheckboxFieldIds
    };
    Object.keys(dirtyFieldsCurrentSession.current).forEach((fieldId)=>{
        const fieldData = fieldConfig[fieldId];
        // below condition fixes a issue where uncaught exception was throwing when fieldId was not part of fieldConfig
        if (fieldData) {
            const retainUserInputTransform = // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly JiraAffectedServicesField: { readonly Component: AbstractComponent<ReturnComponentProps<AffectedServicesFieldConfig>, any>; readonly defaultValueKey: "selectedAffectedServices"; readonly submitTransform: (options: AffectedServiceOption[]) => ServiceEntity[]; readonly retainUserInputTransform: (selectedAff...'.
            (0, $1eq5t.getGqlFieldMap)()[fieldData.gqlType]?.retainUserInputTransform || null;
            const userInput = values[fieldId];
            if (retainUserInputTransform && userInput) // consumers that want additional checks on data before deciding whether it should be retained can return null in case they don't want to retain it
            try {
                const userInputToBeRetained = retainUserInputTransform(userInput, fieldId);
                if (userInputToBeRetained) {
                    const arrWithoutStaleValues = retainedFieldsData.current.filter((itr)=>{
                        if (itr && itr.fieldId && itr.fieldId === fieldId) return false; // removing stale value
                        return true;
                    });
                    // eslint-disable-next-line no-param-reassign
                    retainedFieldsData.current = [
                        ...arrWithoutStaleValues,
                        userInputToBeRetained
                    ];
                }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $eDBhy.fireIssueCreateErrorAnalytics)({
                    meta: {
                        id: 'getUserInputForRetention',
                        packageName: 'jiraIssueCreate',
                        teamName: 'gryffindor'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        }
    });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const retVal = {};
    retainedFieldsData.current.forEach((fieldData)=>{
        const { mutationGroup: mutationGroup, ...rest } = fieldData;
        if (mutationGroup) {
            if (!retVal[mutationGroup]) retVal[mutationGroup] = [];
            retVal[mutationGroup].push(rest);
        } else Object.keys(rest).forEach((key)=>{
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ fieldId: string; }'.
            retVal[key] = rest[key];
        });
    });
    return {
        ...classificationRetainValue,
        ...initialDefaultValues,
        ...retVal
    };
};
const $2c051d499243f0af$export$cc6683ccc73b073 = (sectionMessage)=>{
    if (sectionMessage && sectionMessage.type === 'error') {
        const { title: title, displayList: errors } = sectionMessage;
        return {
            title: title,
            errors: errors
        };
    }
    return null;
};
const $2c051d499243f0af$export$ce9d0b4bb614f329 = (projectContext)=>{
    if (projectContext?.projectId) return {
        label: projectContext.projectName,
        value: projectContext.projectId.toString(),
        iconUrl: '',
        projectKey: projectContext.projectKey,
        projectType: projectContext.projectType,
        isSimplified: projectContext.simplified
    };
    return null;
};
const $2c051d499243f0af$export$fbc6cb29c318fa3a = (selectedProject, context)=>context?.projectId === selectedProject.value;
const $2c051d499243f0af$export$3a332740e4aa9440 = (projectType, fieldConfig)=>{
    if (projectType !== (0, $ln6Iy.SOFTWARE_PROJECT) && projectType !== (0, $ln6Iy.CORE_PROJECT)) return false;
    return !!fieldConfig.status;
};
const $2c051d499243f0af$export$d89be2967c4b3fcf = (projectType, selectedIssueType, alertsToBeLinked)=>{
    if (!alertsToBeLinked) return false;
    if (!projectType || projectType !== (0, $ln6Iy.SERVICE_DESK_PROJECT)) return false;
    if (selectedIssueType?.type === (0, $4246188a36de9908$export$ebb48b08205007c5)) return false;
    return selectedIssueType?.practice === (0, $4246188a36de9908$export$48c144830383423);
};
const $2c051d499243f0af$export$8625e37c02bbfb71 = ({ currentUserAccountId: currentUserAccountId, isAutoWatchEnabled: isAutoWatchEnabled = false, watchers: watchers = [] })=>{
    if (isAutoWatchEnabled) {
        if (watchers.length !== 1) return true;
        return watchers.every((watcher)=>watcher.accountId !== currentUserAccountId);
    }
    return watchers.length > 0;
};
const $2c051d499243f0af$export$385bf01e57223a7c = (selectedIssueType)=>{
    const allowedIssueTypeValues = [
        'bug',
        'story',
        'task',
        'subtask',
        'epic'
    ];
    const issueTypeLabel = selectedIssueType?.label.toLowerCase();
    if (issueTypeLabel) return allowedIssueTypeValues.includes(issueTypeLabel) ? issueTypeLabel : 'custom';
    return undefined;
};
const $2c051d499243f0af$export$cbe00e1e05a1451f = (errors, fieldConfig, filteredOutModules)=>{
    const customFieldsWithError = [];
    try {
        for (const error of errors){
            const fieldData = fieldConfig[error.field];
            if (fieldData) {
                const { isRequired: isRequired, fieldType: fieldType } = fieldData;
                if (isRequired) filteredOutModules.forEach((customField)=>{
                    if (customField.properties.displayConditions !== undefined && customField.id === fieldType) customFieldsWithError.push(fieldData.fieldName);
                });
            }
        }
        return customFieldsWithError.length !== 0 ? customFieldsWithError : null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $eDBhy.fireIssueCreateErrorAnalytics)({
            meta: {
                id: 'isDisplayConditionCFCausingError',
                packageName: 'jiraIssueCreate',
                teamName: 'gryffindor'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        return null;
    }
};
const $2c051d499243f0af$export$d6fca3362baceda8 = ({ projectKey: projectKey })=>{
    const [isCurrentUserProjectAdminOfSelectedProject, setIsCurrentUserProjectAdminOfSelectedProject] = (0, $eJOHy.useState)(null);
    const previousProjectKey = (0, $6d9QY.usePrevious)(projectKey);
    const validateIsCurrentUserProjectAdminOfSelectedProject = (0, $eJOHy.useCallback)(async ()=>{
        if (!projectKey) {
            setIsCurrentUserProjectAdminOfSelectedProject(false);
            return;
        }
        setIsCurrentUserProjectAdminOfSelectedProject(null);
        const result = await (0, $bIpQn.isCurrentUserProjectAdmin)(projectKey);
        setIsCurrentUserProjectAdminOfSelectedProject(result);
    }, [
        projectKey
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (previousProjectKey !== projectKey) validateIsCurrentUserProjectAdminOfSelectedProject();
    }, [
        projectKey,
        previousProjectKey,
        validateIsCurrentUserProjectAdminOfSelectedProject
    ]);
    return isCurrentUserProjectAdminOfSelectedProject;
};
const $2c051d499243f0af$export$8e1d3c5195ccd2e3 = (accountId, currentUser)=>{
    if (!accountId) return 'unassigned';
    if (accountId === '-1') return 'automatic';
    if (accountId === currentUser?.accountId) return 'current_user';
    return 'other';
};
const $2c051d499243f0af$export$8114879043932239 = ()=>{
    return (0, $epTsa.expValEquals)('show_required_fields_in_gic', 'showToggleValue', 'defaultTrue', 'existingBehaviour') || (0, $epTsa.expValEquals)('show_required_fields_in_gic', 'showToggleValue', 'defaultFalse', 'existingBehaviour');
};
const $2c051d499243f0af$export$b75f913e74c75ba5 = ()=>{
    if ((0, $epTsa.expValEquals)('show_required_fields_in_gic', 'showToggleValue', 'defaultTrue', 'existingBehaviour')) return false;
    if ((0, $epTsa.expValEquals)('show_required_fields_in_gic', 'showToggleValue', 'defaultFalse', 'existingBehaviour')) return true;
    // Default fallback value
    return false;
};

});
parcelRegister("bIpQn", function(module, exports) {

$parcel$export(module.exports, "isCurrentUserProjectAdmin", () => $e6e3f83b8758ad07$export$146b7031c6ad53af);

var $jUVzX = parcelRequire("jUVzX");

var $2QO3b = parcelRequire("2QO3b");

var $jGzN3 = parcelRequire("jGzN3");
const $e6e3f83b8758ad07$var$ADMINISTER_PROJECTS_PERMISSION = 'ADMINISTER_PROJECTS';
const $e6e3f83b8758ad07$var$getMyPermissionsGraphQLQuery = (projectKeyOrId)=>`query myPermissionsDataQuery {
        mypermissions(${Number.isNaN(+projectKeyOrId) ? `projectKey: "${projectKeyOrId}"` : `projectId: "${projectKeyOrId}"`}
        permissions: "${$e6e3f83b8758ad07$var$ADMINISTER_PROJECTS_PERMISSION}") {
            key
            havePermission
        }
    }`;
const $e6e3f83b8758ad07$var$fetchMyPermissions = (projectKeyOrId)=>(0, $jGzN3.performPostRequest)('/rest/graphql/1/?', {
        method: 'POST',
        body: JSON.stringify({
            query: $e6e3f83b8758ad07$var$getMyPermissionsGraphQLQuery(projectKeyOrId)
        })
    });
const $e6e3f83b8758ad07$export$146b7031c6ad53af = async (projectArg)=>{
    const fetchStartTime = performance.now();
    const { data: data, errors: errors } = await $e6e3f83b8758ad07$var$fetchMyPermissions(projectArg);
    (0, $2QO3b.addSpanToAll)('fetch', 'fetchMyPermissions', [
        {
            name: 'network'
        }
    ], fetchStartTime, performance.now());
    const hasError = errors && errors.length > 0;
    if (hasError || !data?.mypermissions) {
        const error = new Error(`Project admin permission check failed: ${hasError ? errors[0].message : 'no data'}`);
        // @ts-expect-error - TS2339 - Property 'statusCode' does not exist on type 'Error'.
        error.statusCode = hasError ? errors[0].statusCode : 500;
        // @ts-expect-error - TS2339 - Property 'skipSentry' does not exist on type 'Error'.
        error.skipSentry = hasError ? errors[0].statusCode === 404 : false;
        // We want to provide a degraded user experience if we get 4xx error and can't determine if the user is a project admin.
        if (hasError && errors[0].statusCode >= 400 && errors[0].statusCode <= 499) return false;
        throw error;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($jUVzX)))(data.mypermissions, {
        key: $e6e3f83b8758ad07$var$ADMINISTER_PROJECTS_PERMISSION,
        havePermission: true
    });
};

});

parcelRegister("7hAc3", function(module, exports) {

$parcel$export(module.exports, "FIELDS_TO_RETAIN_FIELD_VALUE", () => $4ec6408df948b6c6$export$992fccb91ee5793d);
$parcel$export(module.exports, "NON_RETAINED_FIELDS_CREATE_ANOTHER", () => $4ec6408df948b6c6$export$d36a2604491a5bc6);

var $5fZlk = parcelRequire("5fZlk");

var $cERCt = parcelRequire("cERCt");

var $814y1 = parcelRequire("814y1");

var $7jTnu = parcelRequire("7jTnu");

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $4ec6408df948b6c6$var$checkIssueLinkIds = (issueLink)=>{
    if ((0, $7jTnu.fg)('remove_issue_links_id_query_from_issue_create')) return true;
    return typeof issueLink?.id === 'string' || issueLink?.id === null;
};
const $4ec6408df948b6c6$export$992fccb91ee5793d = [
    (0, $af620ae3ac843a8a$export$d10237d945259f96)
];
const $4ec6408df948b6c6$export$d36a2604491a5bc6 = [
    {
        fieldId: (0, $814y1.DESCRIPTION_TYPE),
        getClearedDefaultValue: (fieldConfig)=>{
            if (fieldConfig) {
                const descriptionFieldData = fieldConfig[0, $814y1.DESCRIPTION_TYPE];
                return descriptionFieldData.gqlType === (0, $af620ae3ac843a8a$export$31a6c27df1f927b2) ? {
                    resetRequired: true,
                    ...(0, $cERCt.convertTextToAdf)('')
                } : descriptionFieldData.defaultValue;
            }
            return undefined;
        }
    },
    {
        fieldId: (0, $814y1.ATTACHMENT_TYPE),
        getClearedDefaultValue: ()=>({
                shouldClear: true
            })
    },
    {
        fieldId: (0, $814y1.ISSUE_LINKS_TYPE),
        getClearedDefaultValue: (fieldConfig)=>{
            if (fieldConfig) {
                const { defaultValue: defaultValue } = fieldConfig[0, $814y1.ISSUE_LINKS_TYPE];
                if (Array.isArray(defaultValue)) {
                    const issueLinks = [];
                    defaultValue.forEach((issueLink)=>{
                        if (issueLink !== undefined && issueLink !== null && $4ec6408df948b6c6$var$checkIssueLinkIds(issueLink) && issueLink.relatedBy !== null && typeof issueLink.relatedBy === 'object' && typeof issueLink.relatedBy.linkTypeName === 'string' && typeof issueLink.relatedBy.relationName === 'string' && typeof issueLink.relatedBy.linkTypeId === 'string' && (issueLink.relatedBy.direction === 'INWARD' || issueLink.relatedBy.direction === 'OUTWARD') && typeof issueLink.issue === 'object' && issueLink.issue !== null && typeof issueLink.issue.avatar === 'object' && issueLink.issue.avatar !== null && typeof issueLink.issue.avatar.small === 'string' && typeof issueLink.issue.avatar.medium === 'string' && typeof issueLink.issue.id === 'string' && typeof issueLink.issue.issueId === 'string' && typeof issueLink.issue.key === 'string') {
                            // for type refinement, cannot pass iterable 'issueLink' directly to transformDefaultIssueLinksValue
                            const issueLinkExact = {
                                ...(0, $7jTnu.fg)('remove_issue_links_id_query_from_issue_create') ? {
                                    id: issueLink.id
                                } : {},
                                relatedBy: {
                                    linkTypeName: issueLink.relatedBy.linkTypeName,
                                    relationName: issueLink.relatedBy.relationName,
                                    linkTypeId: issueLink.relatedBy.linkTypeId,
                                    direction: issueLink.relatedBy.direction
                                },
                                issue: {
                                    avatar: {
                                        medium: issueLink.issue.avatar.medium,
                                        small: issueLink.issue.avatar.small
                                    },
                                    id: issueLink.issue.id,
                                    issueId: issueLink.issue.issueId,
                                    key: issueLink.issue.key
                                }
                            };
                            issueLinks.push(issueLinkExact);
                        }
                    });
                    return (0, $5fZlk.transformDefaultIssueLinksValue)(issueLinks);
                }
            }
            return undefined;
        }
    }
];
const $4ec6408df948b6c6$export$3a6f576adb7c8374 = 'status-field';
const $4ec6408df948b6c6$export$9584b50151d0c388 = 'issueType-field';

});



parcelRegister("jQAhS", function(module, exports) {

$parcel$export(module.exports, "default", () => $01eee890e44a1b97$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $6MnLl = parcelRequire("6MnLl");

var $dymbf = parcelRequire("dymbf");

var $aTJmy = parcelRequire("aTJmy");

var $lRq8t = parcelRequire("lRq8t");

var $8Wqz3 = parcelRequire("8Wqz3");
const $01eee890e44a1b97$var$MAX_IMAGE_WIDTH_PX = 188;
const $01eee890e44a1b97$var$MAX_IMAGE_HEIGHT_PX = 250;
const $01eee890e44a1b97$var$IMAGE_WIDTH_PX = 188;
const $01eee890e44a1b97$var$renderImage = ()=>(0, $aTJmy.getAkEmptyStateRenderImageFn)((0, $dymbf.default))({
        imageWidth: $01eee890e44a1b97$var$IMAGE_WIDTH_PX,
        maxImageWidth: $01eee890e44a1b97$var$MAX_IMAGE_WIDTH_PX,
        maxImageHeight: $01eee890e44a1b97$var$MAX_IMAGE_HEIGHT_PX
    });
const $01eee890e44a1b97$var$ErrorState = /*#__PURE__*/ (0, $eJOHy.memo)(()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($01eee890e44a1b97$export$412bc65ea3f44cf1, {
        "data-test-id": "issue-create.ui.modal.error-state.fetch-error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6MnLl.default), {
        renderImage: $01eee890e44a1b97$var$renderImage,
        header: formatMessage((0, $8Wqz3.default).header),
        description: formatMessage((0, $8Wqz3.default).description),
        width: "narrow"
    }));
});
var $01eee890e44a1b97$export$2e2bcd8739ae039 // to be wrapped only for components where test-id can't be added on some components
 = $01eee890e44a1b97$var$ErrorState;
const $01eee890e44a1b97$export$412bc65ea3f44cf1 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dymbf", function(module, exports) {

$parcel$export(module.exports, "default", () => $42825a5af59db372$export$2e2bcd8739ae039);
$parcel$export(module.exports, "viewBox", () => $42825a5af59db372$export$a179c88182cb9d56);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("6FdCu")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("6GQY3")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = m5v37k2r2scm86wgmrk6
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/m5v37k2r2scm86wgmrk6

var $c4huj = parcelRequire("c4huj");

var $6GQY3 = parcelRequire("6GQY3");

var $6FdCu = parcelRequire("6FdCu");
const $42825a5af59db372$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($6FdCu)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($6GQY3))
});
var $42825a5af59db372$export$2e2bcd8739ae039 = $42825a5af59db372$var$Illustration;
// for advanced use only
const $42825a5af59db372$export$a179c88182cb9d56 = [
    0,
    0,
    164,
    218
];

});
parcelRegister("6GQY3", function(module, exports) {
module.exports = new URL("error-darkmode.9dba78cd.svg", import.meta.url).toString();

});

parcelRegister("6FdCu", function(module, exports) {
module.exports = new URL("error.b7de7f77.svg", import.meta.url).toString();

});


parcelRegister("aTJmy", function(module, exports) {

$parcel$export(module.exports, "getAkEmptyStateRenderImageFn", () => $484fdcae7d1a2fee$export$ebf64b9217c1b2a3);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $3xT3U = parcelRequire("3xT3U");
function $484fdcae7d1a2fee$export$ebf64b9217c1b2a3(JiraIllustration = (0, $3xT3U.default)) {
    return ({ maxImageWidth: // we strictly follow EmptyState's defaults
    maxImageWidth = 160, maxImageHeight: maxImageHeight = 160, imageWidth: imageWidth, imageHeight: imageHeight })=>{
        // This wrapper emulates EmptyState's private "HeaderImage" styling
        // @see platform/packages/design-system/empty-state/src/empty-state.tsx
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
        const Wrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
                ...__cmplp,
                style: {
                    ...__cmpls,
                    "--_yv3y2x": (0, $awdRS.default)(maxImageWidth, "px"),
                    "--_nq7wev": (0, $awdRS.default)(maxImageHeight, "px")
                },
                ref: __cmplr,
                className: (0, $hcewu.default)([
                    "_1e0c1ule _p12f1x6a _c71lc3ce _19pkidpf _2hwx1wug _otyr1ejb _18u01wug",
                    __cmplp.className
                ])
            });
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(JiraIllustration, {
            alt: "",
            role: "presentation",
            width: imageWidth || 'auto',
            height: imageHeight || 'auto'
        }));
    };
}

});
parcelRegister("3xT3U", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b1b1236d04dc76a$export$2e2bcd8739ae039);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("e8HDz")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("aiB9q")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = tgxxcm73mk6phg9ttfj3rvpf
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/tgxxcm73mk6phg9ttfj3rvpf

var $c4huj = parcelRequire("c4huj");

var $aiB9q = parcelRequire("aiB9q");

var $e8HDz = parcelRequire("e8HDz");
const $3b1b1236d04dc76a$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($e8HDz)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($aiB9q))
});
var $3b1b1236d04dc76a$export$2e2bcd8739ae039 = $3b1b1236d04dc76a$var$Illustration;
// for advanced use only
const $3b1b1236d04dc76a$export$a179c88182cb9d56 = [
    0,
    0,
    235,
    210
];

});
parcelRegister("aiB9q", function(module, exports) {
module.exports = new URL("generic-empty-state-darkmode.27f5dcf1.svg", import.meta.url).toString();

});

parcelRegister("e8HDz", function(module, exports) {
module.exports = new URL("generic-empty-state.1b007192.svg", import.meta.url).toString();

});



parcelRegister("8Wqz3", function(module, exports) {

$parcel$export(module.exports, "default", () => $62526c867ff02c7d$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $62526c867ff02c7d$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    header: {
        "id": "issue-create.modal.error-state.header",
        "defaultMessage": "Something's gone wrong"
    },
    description: {
        "id": "issue-create.modal.error-state.description",
        "defaultMessage": "Our team has been notified. If the problem persists, please contact Atlassian support."
    }
});

});


parcelRegister("8xFHy", function(module, exports) {

$parcel$export(module.exports, "ExistingGICWarning", () => $89908980666a1a61$export$e0cf9a7a2f315b80);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $ik0CA = parcelRequire("ik0CA");
var $kseeK = parcelRequire("kseeK");
var $2qG7I = parcelRequire("2qG7I");
var $5a9Ro = parcelRequire("5a9Ro");

var $2ZGUP = parcelRequire("2ZGUP");

var $epTsa = parcelRequire("epTsa");

var $lRq8t = parcelRequire("lRq8t");

var $5PjYq = parcelRequire("5PjYq");

var $xMjNG = parcelRequire("xMjNG");

var $4PKlm = parcelRequire("4PKlm");

var $jQUoP = parcelRequire("jQUoP");

var $aC4Bh = parcelRequire("aC4Bh");

var $jipjz = parcelRequire("jipjz");

var $4xbv3 = parcelRequire("4xbv3");
var $gCeeo = parcelRequire("gCeeo");
var $8Plmb = parcelRequire("8Plmb");

var $2WXI5 = parcelRequire("2WXI5");
const $89908980666a1a61$export$e0cf9a7a2f315b80 = ()=>{
    const [{ wasModalRetriggered: wasModalRetriggered }, { resetWasModalRetriggered: resetWasModalRetriggered }] = (0, $jipjz.useTriggerIssueCreateModal)();
    const [{ resetFormAction: resetFormAction, selectedProject: selectedProject, isFormDirty: isCreateFormDirty }] = (0, $jQUoP.useFormContext)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const projectId = selectedProject && selectedProject.value;
    const projectType = selectedProject ? (0, $5PjYq.transformProjectType)(selectedProject.projectType) : '';
    const { publish: publish } = (0, $4PKlm.useGICLifeCycleEvents)();
    // Re-initialise context values when create button is clicked and the form is clean
    (0, $eJOHy.useEffect)(()=>{
        if (wasModalRetriggered && !isCreateFormDirty) resetWasModalRetriggered(true);
    }, [
        wasModalRetriggered,
        isCreateFormDirty,
        resetWasModalRetriggered
    ]);
    const onClickDiscardButton = (0, $eJOHy.useCallback)((event, analyticsEvent)=>{
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'discardExistingGicWarning', {
            projectType: projectType
        });
        resetWasModalRetriggered(true);
        resetFormAction && resetFormAction();
        publish((0, $xMjNG.GIC_LIFECYCLE_EVENTS).MODAL_DISCARD_EXISTING_IN_PROGRESS_ISSUE, {});
    }, [
        publish,
        projectType,
        resetWasModalRetriggered,
        resetFormAction
    ]);
    const onClickKeepEditingButton = (0, $eJOHy.useCallback)(// @ts-expect-error - TS7006 - Parameter '_' implicitly has an 'any' type.
    (_, analyticsEvent)=>{
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'keepEditingExistingGicWarning', {
            projectType: projectType
        });
        resetWasModalRetriggered();
        publish((0, $xMjNG.GIC_LIFECYCLE_EVENTS).MODAL_KEEP_EDITING_EXISTING_ISSUE, {});
    }, [
        projectType,
        publish,
        resetWasModalRetriggered
    ]);
    if (!wasModalRetriggered || !isCreateFormDirty || !selectedProject) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        sourceType: (0, $466f60259c330878$export$1171103ea9083ffa),
        sourceName: "existingGicWarning",
        containerType: "project",
        containerId: projectId || '',
        attributes: {
            projectType: projectType
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Plmb.MountEvent), {
        onMount: (0, $gCeeo.fireScreenAnalyticsDeferred)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2ZGUP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aC4Bh.JiraModal), {
        onClose: ()=>resetWasModalRetriggered(),
        width: "medium",
        testId: "issue-create.ui.modal.existing-gic-warning.modal-dialog",
        messageId: "issue-create.ui.modal.existing-gic-warning.modal",
        messageType: "transactional"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2qG7I.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5a9Ro.default), {
        appearance: "warning"
    }, formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $2WXI5.default).headingIssueTermRefresh : (0, $2WXI5.default).heading))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ik0CA.default), null, formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $2WXI5.default).descriptionIssueTermRefresh : (0, $2WXI5.default).description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kseeK.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        onClick: onClickDiscardButton,
        appearance: "subtle",
        testId: "issue-create.ui.modal.existing-gic-warning.discard-button"
    }, formatMessage((0, $2WXI5.default).discardButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        onClick: onClickKeepEditingButton,
        appearance: "warning",
        testId: "issue-create.ui.modal.existing-gic-warning.keep-editing"
    }, formatMessage((0, $2WXI5.default).keepEditingButton))))));
};

});
parcelRegister("2WXI5", function(module, exports) {

$parcel$export(module.exports, "default", () => $db9659610266cb23$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $db9659610266cb23$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    heading: {
        "id": "issue-create.modal.existing-gic-warning.heading",
        "defaultMessage": "Draft issue in progress"
    },
    description: {
        "id": "issue-create.modal.existing-gic-warning.description",
        "defaultMessage": "It looks like you\u2019re already creating an issue. Creating a new issue will discard your draft and any changes you\u2019ve made won\u2019t be saved."
    },
    discardButton: {
        "id": "issue-create.modal.existing-gic-warning.discard-button",
        "defaultMessage": "Discard draft"
    },
    keepEditingButton: {
        "id": "issue-create.modal.existing-gic-warning.keep-editing-button",
        "defaultMessage": "Keep editing"
    },
    headingIssueTermRefresh: {
        "id": "issue-create.modal.existing-gic-warning.heading-issue-term-refresh",
        "defaultMessage": "Draft work item in progress"
    },
    descriptionIssueTermRefresh: {
        "id": "issue-create.modal.existing-gic-warning.description-issue-term-refresh",
        "defaultMessage": "It looks like you\u2019re already creating a work item. Creating a new one will discard your draft and any changes you\u2019ve made won\u2019t be saved."
    }
});

});


parcelRegister("cyr99", function(module, exports) {

$parcel$export(module.exports, "JsmRequestTypeFieldsChangeboarding", () => $94032f58e898be16$export$3c3f6e745ff8955);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $3cMgR = parcelRequire("3cMgR");

var $iHPvF = parcelRequire("iHPvF");

var $epTsa = parcelRequire("epTsa");

var $dTocu = parcelRequire("dTocu");

var $4xbv3 = parcelRequire("4xbv3");
var $gCeeo = parcelRequire("gCeeo");
var $8Plmb = parcelRequire("8Plmb");
var $ftN6c = parcelRequire("ftN6c");

var $fV6Ej = parcelRequire("fV6Ej");

var $c69PX = parcelRequire("c69PX");
const $94032f58e898be16$var$learnMoreLink = 'https://support.atlassian.com/jira-service-management-cloud/docs/customize-the-fields-of-a-request-type/';
const $94032f58e898be16$export$3c3f6e745ff8955 = ()=>{
    const [{ data: isRequestTypeFieldsLayoutEnabled }] = (0, $fV6Ej.useRequestTypeFieldsLayoutPreference)();
    const { formatMessage: formatMessage } = (0, $dTocu.useIntlV2)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const onClickLearnMoreLink = ()=>(0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'jsmRequestTypeFieldsChangeboardingLearnMoreLink clicked');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        sourceType: (0, $466f60259c330878$export$238d30785c4bca84),
        sourceName: "jsmRequestTypeFieldsChangeboarding"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Plmb.MountEvent), {
        onMount: (0, $gCeeo.fireScreenAnalyticsDeferred)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iHPvF.default), {
        appearance: "discovery",
        actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            appearance: "link",
            spacing: "none",
            onClick: onClickLearnMoreLink,
            onAuxClick: onClickLearnMoreLink,
            href: $94032f58e898be16$var$learnMoreLink,
            target: "_blank"
        }, !isRequestTypeFieldsLayoutEnabled ? formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $c69PX.default).sectionMessageLearnMoreWhenToggleOffIssueTermRefresh : (0, $c69PX.default).sectionMessageLearnMoreWhenToggleOff) : formatMessage((0, $c69PX.default).sectionMessageLearnMore))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        as: "p"
    }, !isRequestTypeFieldsLayoutEnabled ? formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $c69PX.default).sectionMessageBodyWhenToggleOffIssueTermRefresh : (0, $c69PX.default).sectionMessageBodyWhenToggleOff, {
        bold: (message)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("b", null, message)
    }) : formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $c69PX.default).sectionMessageBodyIssueTermRefresh : (0, $c69PX.default).sectionMessageBody))));
};

});
parcelRegister("c69PX", function(module, exports) {

$parcel$export(module.exports, "default", () => $6753ec39766d0e97$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $6753ec39766d0e97$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    sectionMessageBody: {
        "id": "issue-create.modal.jsm-request-type-fields-changeboarding.section-message-body",
        "defaultMessage": "Since a request type has been selected for this issue, these fields can\u2019t be edited here."
    },
    sectionMessageBodyWhenToggleOff: {
        "id": "issue-create.modal.jsm-request-type-fields-changeboarding.section-message-body-when-toggle-off",
        "defaultMessage": "Turn on the <bold>Use request type fields</bold> toggle to see only request type fields while creating issues."
    },
    sectionMessageLearnMore: {
        "id": "issue-create.modal.jsm-request-type-fields-changeboarding.section-message-learn-more",
        "defaultMessage": "Learn more about editing the fields of a request type"
    },
    sectionMessageLearnMoreWhenToggleOff: {
        "id": "issue-create.modal.jsm-request-type-fields-changeboarding.section-message-learn-more-when-toggle-off",
        "defaultMessage": "Learn more about using request type fields while creating issues"
    },
    sectionMessageBodyIssueTermRefresh: {
        "id": "issue-create.modal.jsm-request-type-fields-changeboarding.section-message-body-issue-term-refresh",
        "defaultMessage": "Since a request type has been selected for this work item, these fields can\u2019t be edited here."
    },
    sectionMessageBodyWhenToggleOffIssueTermRefresh: {
        "id": "issue-create.modal.jsm-request-type-fields-changeboarding.section-message-body-when-toggle-off-issue-term-refresh",
        "defaultMessage": "Turn on the <bold>Use request type fields</bold> toggle to see only request type fields while creating work items."
    },
    sectionMessageLearnMoreWhenToggleOffIssueTermRefresh: {
        "id": "issue-create.modal.jsm-request-type-fields-changeboarding.section-message-learn-more-when-toggle-off-issue-term-refresh",
        "defaultMessage": "Learn more about using request type fields while creating work items"
    }
});

});


parcelRegister("70BpF", function(module, exports) {

$parcel$export(module.exports, "ModalWrapper", () => $deb6ef42f3c6cb27$export$858bfd02c3f2fba5);

var $eJOHy = parcelRequire("eJOHy");

var $ik0CA = parcelRequire("ik0CA");

var $k8n0V = parcelRequire("k8n0V");

var $2ZGUP = parcelRequire("2ZGUP");

var $4NEt5 = parcelRequire("4NEt5");

var $6hw9S = parcelRequire("6hw9S");

var $a1pDt = parcelRequire("a1pDt");

var $ixdDB = parcelRequire("ixdDB");

var $jQUoP = parcelRequire("jQUoP");

var $fIw44 = parcelRequire("fIw44");

var $ifMPf = parcelRequire("ifMPf");

var $kqGiz = parcelRequire("kqGiz");

var $4bJFX = parcelRequire("4bJFX");

var $9vG5g = parcelRequire("9vG5g");

var $i1jdo = parcelRequire("i1jdo");

var $aC4Bh = parcelRequire("aC4Bh");

var $jipjz = parcelRequire("jipjz");

var $16sa1 = parcelRequire("16sa1");

var $cnV9A = parcelRequire("cnV9A");

var $9UgK2 = parcelRequire("9UgK2");

var $6u3jg = parcelRequire("6u3jg");

var $73XNv = parcelRequire("73XNv");

var $gO18D = parcelRequire("gO18D");

var $iz24g = parcelRequire("iz24g");

var $6VtvU = parcelRequire("6VtvU");

var $iylOl = parcelRequire("iylOl");

var $2WvWo = parcelRequire("2WvWo");

var $3AqDe = parcelRequire("3AqDe");

var $5rEj7 = parcelRequire("5rEj7");
const $deb6ef42f3c6cb27$var$ModalBodyNext = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ik0CA.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        id: (0, $ixdDB.ISSUE_CREATE_MODAL_BODY_SELECTOR),
        ref: ref,
        ...props
    })));
const $deb6ef42f3c6cb27$var$OldModal = ({ children: children, onModalCloseWithConfirm: onModalCloseWithConfirm, shouldDisableActions: shouldDisableActions, onSubmit: onSubmit, isSubmitting: isSubmitting, isOperationInProgress: isOperationInProgress, canCreateAnotherIssue: canCreateAnotherIssue, onCreateAnotherChange: onCreateAnotherChange, getShouldDisableSubmit: getShouldDisableSubmit, createdIssues: createdIssues, displayCreateAnotherIssueToggle: displayCreateAnotherIssueToggle, showIssuesCreated: showIssuesCreated, watchersConfigurations: watchersConfigurations, dismissModalEntryPointWrapper: dismissModalEntryPointWrapper })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2ZGUP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aC4Bh.JiraModal), {
        width: "large",
        height: "100vh",
        autoFocus: false,
        // @ts-expect-error - TS2322 - Type '(_: SyntheticEvent<Element, Event>, analyticsEvent: UIAnalyticsEventInterface) => void' is not assignable to type 'OnCloseHandler'.
        onClose: onModalCloseWithConfirm('issueCreateModalEscapeClick'),
        shouldCloseOnEscapePress: true,
        shouldCloseOnOverlayClick: false,
        testId: "issue-create.ui.modal.modal-wrapper.modal",
        messageId: "issue-create.ui.modal.modal-wrapper.modal-dialog",
        messageType: "transactional"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iylOl.default), {
        shouldDisableActions: shouldDisableActions,
        watchersConfigurations: watchersConfigurations
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($deb6ef42f3c6cb27$var$ModalBodyNext, null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cnV9A.default), {
        onClose: onModalCloseWithConfirm('cancel'),
        onSubmit: onSubmit,
        isSubmitting: isSubmitting,
        isOperationInProgress: isOperationInProgress,
        canCreateAnotherIssue: canCreateAnotherIssue,
        onCreateAnotherChange: onCreateAnotherChange,
        shouldDisableSubmit: getShouldDisableSubmit(),
        createdIssues: createdIssues,
        displayCreateAnotherIssueToggle: displayCreateAnotherIssueToggle,
        showIssuesCreated: showIssuesCreated,
        dismissModalEntryPointWrapper: dismissModalEntryPointWrapper
    })));
const $deb6ef42f3c6cb27$var$MinimizableModalContainer = ({ children: children })=>{
    const { initialSummaryValue: initialSummaryValue } = (0, $73XNv.useMinimizableModalWrapperProps)();
    const { view: view } = (0, $fIw44.useMinimizableModal)();
    const summaryValue = (0, $3AqDe.useSetSummary)(initialSummaryValue);
    (0, $5rEj7.useViewChangerDisabler)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i1jdo.ModalTransition), {
        renderCondition: view === 'modal'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2WvWo.MinimizableModalModal), {
        "data-testid": "issue-create.ui.modal.modal-wrapper.modal"
    }, children)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4bJFX.MiniTransition), {
        renderCondition: view === 'mini'
    }, ({ transitionProps: transitionProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iz24g.MinimizableModalMini), {
            ...transitionProps,
            summaryValue: summaryValue
        }, children)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kqGiz.FullscreenTransition), {
        renderCondition: view === 'fullscreen'
    }, ({ transitionProps: transitionProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gO18D.MinimizableFullscreen), transitionProps, children)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9vG5g.MinimizedTransition), {
        renderCondition: view === 'minimized'
    }, ({ transitionProps: transitionProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6VtvU.MinimizableModalMinimized), {
            ...transitionProps,
            summaryValue: summaryValue
        })));
};
const $deb6ef42f3c6cb27$var$OldModalWrapper = (props)=>{
    const [{ disableGICPositioning: disableGICPositioning }, { setDisableGICPositioning: setDisableGICPositioning }] = (0, $9UgK2.useGICPositioningEnabledController)();
    (0, $eJOHy.useEffect)(()=>{
        if (!disableGICPositioning) setDisableGICPositioning(true);
    }, [
        disableGICPositioning,
        setDisableGICPositioning
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($deb6ef42f3c6cb27$var$OldModal, props);
};
const $deb6ef42f3c6cb27$export$858bfd02c3f2fba5 = ({ children: children, ...rest })=>{
    const [{ minimizableModalView: minimizableModalView, displayMinimizableButtons: displayMinimizableButtons }, { setMinimizableModalView: setMinimizableModalView }] = (0, $jipjz.useTriggerIssueCreateModal)();
    const isGICPositioningEnabled = (0, $6u3jg.useIsGICPositioningEnabled)();
    const [, { dispatchFormSubmits: dispatchForgeInlineFormSubmits }] = (0, $6hw9S.useInlineFields)();
    const [{ isFormLoaded: isFormLoaded }] = (0, $jQUoP.useFormContext)();
    const renderOldModal = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($deb6ef42f3c6cb27$var$OldModalWrapper, rest, children);
    const onViewChange = (0, $eJOHy.useCallback)((newView)=>{
        setMinimizableModalView(newView);
        dispatchForgeInlineFormSubmits();
    }, [
        setMinimizableModalView,
        dispatchForgeInlineFormSubmits
    ]);
    if (isGICPositioningEnabled()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "issue-create-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4NEt5.JiraIssueCreateErrorBoundary), {
        id: isFormLoaded ? 'issue-create-app-loaded' : 'issue-create-app',
        packageName: "jiraIssueCreateModal",
        fallback: renderOldModal,
        sendToPrivacyUnsafeSplunk: true,
        attributes: (error)=>({
                errorType: (0, $a1pDt.getErrorType)(error)
            }),
        taskName: "viewGlobalIssueCreateModal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $73XNv.MinimizableModalWrapperPropsProvider), rest, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ifMPf.MinimizableModal), {
        view: minimizableModalView,
        onViewChange: onViewChange,
        Container: $deb6ef42f3c6cb27$var$MinimizableModalContainer,
        // @ts-expect-error - TS2322 - Type '(_: SyntheticEvent<Element, Event>, analyticsEvent: UIAnalyticsEventInterface) => void' is not assignable to type 'OnCloseHandler'.
        onClose: rest.onModalCloseWithConfirm('cancel'),
        displayMinimizableButtons: displayMinimizableButtons
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k8n0V.ClipboardContextBoundaryContainer), null, children)))));
    return renderOldModal();
};

});
parcelRegister("k8n0V", function(module, exports) {

$parcel$export(module.exports, "ClipboardContextBoundaryContainer", () => $cd77a2aff55ad407$export$fd0a7836bfa6a893);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $k4xkV = parcelRequire("k4xkV");
const $cd77a2aff55ad407$var$invisibleDivStyles = null;
const $cd77a2aff55ad407$var$ClipboardContextBoundaryProvider = ({ children: children })=>{
    const { setClipBoardContext: setClipBoardContext } = (0, $k4xkV.useClipboardContextActions)();
    const setRef = (0, $eJOHy.useCallback)((node)=>{
        setClipBoardContext(node);
    }, [
        setClipBoardContext
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        ref: setRef,
        "data-testid": "clipboard.controllers.boundary.clipboard-boundary",
        className: (0, $hcewu.default)([
            "_1e0c1bgi _4t3i1kw7 _1bsb1kw7"
        ])
    }, children);
};
const $cd77a2aff55ad407$export$fd0a7836bfa6a893 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k4xkV.ClipboardStoreContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cd77a2aff55ad407$var$ClipboardContextBoundaryProvider, null, children));
const $cd77a2aff55ad407$var$ClipboardContainerSetEffector = ({ container: container })=>{
    const { setClipBoardContext: setClipBoardContext } = (0, $k4xkV.useClipboardContextActions)();
    (0, $eJOHy.useEffect)(()=>setClipBoardContext(container), [
        setClipBoardContext,
        container
    ]);
    return null;
};
const $cd77a2aff55ad407$export$99c5c2d165547316 = ({ children: children, container: container, intent: intent })=>{
    const currentContainer = (0, $k4xkV.useClipboardContextBoundary)();
    if (!container || currentContainer && intent === 'support') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k4xkV.ClipboardStoreContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($cd77a2aff55ad407$var$ClipboardContainerSetEffector, {
        container: container
    }), children);
};

});

parcelRegister("ifMPf", function(module, exports) {

$parcel$export(module.exports, "MinimizableModal", () => $1c179d34a4a46127$export$fe110805c6d6ede4);

var $eJOHy = parcelRequire("eJOHy");

var $3rigy = parcelRequire("3rigy");

var $fIw44 = parcelRequire("fIw44");

var $h0SnU = parcelRequire("h0SnU");

var $bSuVk = parcelRequire("bSuVk");
const $1c179d34a4a46127$export$fe110805c6d6ede4 = ({ children: children, Container: Container = (0, $h0SnU.ModalContainer), initialView: initialView, onClose: onClose, view: view, onViewChange: onViewChange, displayMinimizableButtons: displayMinimizableButtons })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3rigy.Layering), {
        isDisabled: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fIw44.MinimizableModalProvider), {
        initialView: initialView,
        onClose: onClose,
        view: view,
        onViewChange: onViewChange,
        displayMinimizableButtons: displayMinimizableButtons
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bSuVk.ReParenter), {
        Parent: Container
    }, children)));

});
parcelRegister("h0SnU", function(module, exports) {

$parcel$export(module.exports, "ModalContainer", () => $7b816d047140eff1$export$c9554889b3e706cd);

var $eJOHy = parcelRequire("eJOHy");

var $fIw44 = parcelRequire("fIw44");

var $kqGiz = parcelRequire("kqGiz");

var $d8Md5 = parcelRequire("d8Md5");

var $4bJFX = parcelRequire("4bJFX");

var $c7o2k = parcelRequire("c7o2k");

var $9vG5g = parcelRequire("9vG5g");

var $kwvP4 = parcelRequire("kwvP4");

var $5IfL0 = parcelRequire("5IfL0");

var $i1jdo = parcelRequire("i1jdo");

var $j8z2z = parcelRequire("j8z2z");
const $7b816d047140eff1$var$DefaultHeader = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5IfL0.ModalHeader), props);
const $7b816d047140eff1$var$DefaultMiniHeader = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5IfL0.MiniHeader), props);
const $7b816d047140eff1$export$c9554889b3e706cd = ({ children: children, components: components })=>{
    const { view: view } = (0, $fIw44.useMinimizableModal)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i1jdo.ModalTransition), {
        renderCondition: view === 'modal'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j8z2z.Modal), {
        components: components || {
            Header: $7b816d047140eff1$var$DefaultHeader
        }
    }, children)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4bJFX.MiniTransition), {
        renderCondition: view === 'mini'
    }, ({ transitionProps: transitionProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c7o2k.Mini), {
            ...transitionProps,
            components: components || {
                Header: $7b816d047140eff1$var$DefaultMiniHeader
            }
        }, children)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kqGiz.FullscreenTransition), {
        renderCondition: view === 'fullscreen'
    }, ({ transitionProps: transitionProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d8Md5.Fullscreen), {
            ...transitionProps,
            components: components || {
                Header: $7b816d047140eff1$var$DefaultMiniHeader
            }
        }, children)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9vG5g.MinimizedTransition), {
        renderCondition: view === 'minimized'
    }, ({ transitionProps: transitionProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kwvP4.Minimized), transitionProps)));
};

});
parcelRegister("kqGiz", function(module, exports) {

$parcel$export(module.exports, "FullscreenTransition", () => $454a3fd2d2a08989$export$d6c32f25d5187e12);

var $eJOHy = parcelRequire("eJOHy");

var $Ys7jv = parcelRequire("Ys7jv");
var $2rPSy = parcelRequire("2rPSy");
var $kk5YU = parcelRequire("kk5YU");

var $75RwT = parcelRequire("75RwT");
const $454a3fd2d2a08989$export$d6c32f25d5187e12 = ({ children: children, renderCondition: renderCondition })=>{
    const { onFinishAnimation: onFinishAnimation, shouldRenderView: shouldRenderView } = (0, $75RwT.useTransitionView)('fullscreen', renderCondition);
    if ((0, $kk5YU.isReducedMotion)()) {
        if (renderCondition) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children({
            transitionProps: {}
        }));
        return null;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ys7jv.default), null, shouldRenderView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2rPSy.default), {
        entranceDirection: "bottom",
        exitDirection: "bottom",
        duration: "medium",
        onFinish: onFinishAnimation
    }, (fadeInProps)=>children({
            transitionProps: {
                ...fadeInProps
            }
        })));
};

});
parcelRegister("75RwT", function(module, exports) {

$parcel$export(module.exports, "useTransitionView", () => $64aae4749b82677a$export$4ebb8b85ce67f755);

var $eJOHy = parcelRequire("eJOHy");

var $fIw44 = parcelRequire("fIw44");

var $dIu0P = parcelRequire("dIu0P");
const $64aae4749b82677a$export$4ebb8b85ce67f755 = (view, renderCondition)=>{
    const { setTransitionState: setTransitionState, isTransitionInState: isTransitionInState } = (0, $fIw44.useMinimizableModal)();
    const shouldRenderView = (0, $eJOHy.useMemo)(()=>{
        if (view === 'modal') return renderCondition && isTransitionInState([
            'mini',
            'minimized'
        ], (0, $dIu0P.TransitionState).EXITED);
        if (view === 'mini') return renderCondition && isTransitionInState([
            'modal',
            'minimized'
        ], (0, $dIu0P.TransitionState).EXITED);
        if (view === 'minimized') return renderCondition && isTransitionInState([
            'mini',
            'modal'
        ], (0, $dIu0P.TransitionState).EXITED);
        if (view === 'fullscreen') return renderCondition && isTransitionInState([], (0, $dIu0P.TransitionState).EXITED);
        return false;
    }, [
        renderCondition,
        isTransitionInState,
        view
    ]);
    // SlideIn onFinish prop is sometimes called before the useEffect
    // isAnimationComplete is used to control that
    const isAnimationComplete = (0, $eJOHy.useRef)(false);
    const isInitialised = (0, $eJOHy.useRef)(false);
    (0, $eJOHy.useEffect)(()=>{
        if (isInitialised.current) isAnimationComplete.current = false;
    }, [
        shouldRenderView
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (shouldRenderView && !isAnimationComplete.current) {
            isInitialised.current = true;
            setTransitionState(view, (0, $dIu0P.TransitionState).TRANSITIONING);
        } else if (!shouldRenderView && !isAnimationComplete.current && isInitialised.current) setTransitionState(view, (0, $dIu0P.TransitionState).TRANSITIONING);
    }, [
        shouldRenderView,
        setTransitionState,
        view
    ]);
    const onFinishAnimation = (0, $eJOHy.useCallback)((state)=>{
        isAnimationComplete.current = true;
        if (state === 'entering') setTransitionState(view, (0, $dIu0P.TransitionState).ENTERED);
        if (state === 'exiting') setTransitionState(view, (0, $dIu0P.TransitionState).EXITED);
    }, [
        setTransitionState,
        view
    ]);
    return {
        onFinishAnimation: onFinishAnimation,
        shouldRenderView: shouldRenderView
    };
};

});


parcelRegister("d8Md5", function(module, exports) {

$parcel$export(module.exports, "FullscreenBody", () => $ea000d6f9e68b9ac$export$cf81465aa48f28a8);
$parcel$export(module.exports, "Fullscreen", () => $ea000d6f9e68b9ac$export$159cd03be7087f39);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $gCeeo = parcelRequire("gCeeo");
var $8Plmb = parcelRequire("8Plmb");

var $fIw44 = parcelRequire("fIw44");

var $dIu0P = parcelRequire("dIu0P");

var $kBp8F = parcelRequire("kBp8F");
const $ea000d6f9e68b9ac$export$cf81465aa48f28a8 = ({ children: children, containerStyle: containerStyle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kBp8F.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ea000d6f9e68b9ac$var$FullscreenBodyWrapper, {
        "data-testid": "minimizable-modal.ui.modal-container.fullscreen.fullscreen-body-wrapper",
        // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop
        style: containerStyle
    }, children));
const $ea000d6f9e68b9ac$export$159cd03be7087f39 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, className: className, components: components, containerStyle: containerStyle }, ref)=>{
    const { Header: Header = (0, $eJOHy.Fragment), Footer: Footer = (0, $eJOHy.Fragment) } = components || {};
    const { isTransitionInState: isTransitionInState } = (0, $fIw44.useMinimizableModal)();
    const isViewEntered = isTransitionInState([
        'fullscreen'
    ], (0, $dIu0P.TransitionState).ENTERED);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ea000d6f9e68b9ac$export$a07082e2094b8119, {
        ref: ref,
        transitionClass: className,
        "data-testid": !isViewEntered ? undefined : 'minimizable-modal.ui.modal-container.fullscreen'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Plmb.MountEvent), {
        onMount: (0, $gCeeo.fireScreenAnalyticsDeferred)
    }), components ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Header, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ea000d6f9e68b9ac$export$cf81465aa48f28a8, {
        containerStyle: containerStyle
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Footer, null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children));
});
const $ea000d6f9e68b9ac$export$a07082e2094b8119 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ea000d6f9e68b9ac$var$FullscreenWrapperExperimentStyles, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.transitionClass,
        ...props
    });
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ea000d6f9e68b9ac$var$FullscreenBodyWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0qv47k _u5f3v47k _n3tdv47k _19bvv47k",
            __cmplp.className
        ])
    });
});
const $ea000d6f9e68b9ac$var$FullscreenWrapperExperimentStyles = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _1bsb1osq _4t3i1osq _kqsw1n9t _154iidpf _1ltvidpf _bfhk1bhr _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kBp8F", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b87034043a341cf$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $k0ahr = parcelRequire("k0ahr");

var $g6Dmv = parcelRequire("g6Dmv");

var $dqFfV = parcelRequire("dqFfV");

var $gdIki = parcelRequire("gdIki");

var $2wesH = parcelRequire("2wesH");


var $dj0CM = parcelRequire("dj0CM");
const $7b87034043a341cf$var$styles = {
    scrollContainerWrapper: "_16jlkb7n _1o9zkb7n _i0dl1kw7 _1e0c1kw7 _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t _2lx21kw7 _1reo15vq _18m91wug",
    topKeyline: "_x3dov2xi",
    bottomKeyline: "_n7zlv2xi"
};
/**
 * A container that shows top and bottom keylines when the
 * content overflows into the scrollable element.
 */ const $7b87034043a341cf$var$ScrollContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const { testId: testId, children: children, disableAutoTopKeyline: disableAutoTopKeyline = true, disableAutoBottomKeyline: disableAutoBottomKeyline = true } = props;
    const [hasSiblings, setSiblings] = (0, $2wesH.default)({
        previous: false,
        next: false
    });
    const [showContentFocus, setContentFocus] = (0, $eJOHy.useState)(false);
    const [showTopKeyline, setTopKeyline] = (0, $eJOHy.useState)(false);
    const [showBottomKeyline, setBottomKeyline] = (0, $eJOHy.useState)(false);
    const scrollableRef = (0, $eJOHy.useRef)(null);
    const setLazySiblings = (0, $gdIki.default)(setSiblings);
    const setLazyContentFocus = (0, $gdIki.default)((0, $dj0CM.rafSchedule)(()=>{
        const target = scrollableRef.current;
        target && setContentFocus(target.scrollHeight > target.clientHeight);
    }));
    const setLazyKeylines = (0, $gdIki.default)((0, $dj0CM.rafSchedule)(()=>{
        const target = scrollableRef.current;
        if (target) {
            const scrollableDistance = target.scrollHeight - target.clientHeight;
            if (hasSiblings.current.previous) setTopKeyline(target.scrollTop > (0, $1a2868fb18c8f817$export$4c317248f944c2a9));
            if (hasSiblings.current.next) setBottomKeyline(target.scrollTop <= scrollableDistance - (0, $1a2868fb18c8f817$export$4c317248f944c2a9));
        }
    }));
    (0, $eJOHy.useEffect)(()=>{
        const target = scrollableRef.current;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('resize', setLazyKeylines, false);
        target?.addEventListener('scroll', setLazyKeylines, false);
        setLazyContentFocus();
        setLazyKeylines();
        setLazySiblings({
            previous: Boolean(target?.previousElementSibling),
            next: Boolean(target?.nextElementSibling)
        });
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.removeEventListener('resize', setLazyKeylines, false);
            target?.removeEventListener('scroll', setLazyKeylines, false);
        };
    }, [
        setLazyContentFocus,
        setLazyKeylines,
        setLazySiblings
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $g6Dmv.default), {
        as: "div",
        isInset: true,
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex: showContentFocus ? 0 : undefined,
        testId: testId !== null && testId !== undefined ? `${testId}--scrollable` : undefined,
        ref: (0, $dqFfV.default)([
            ref,
            scrollableRef
        ]),
        xcss: (0, $k0ahr.cx)($7b87034043a341cf$var$styles.scrollContainerWrapper, !disableAutoTopKeyline && showTopKeyline && $7b87034043a341cf$var$styles.topKeyline, !disableAutoBottomKeyline && showBottomKeyline && $7b87034043a341cf$var$styles.bottomKeyline)
    }, children);
});
$7b87034043a341cf$var$ScrollContainer.displayName = 'ScrollContainer';
var $7b87034043a341cf$export$2e2bcd8739ae039 = $7b87034043a341cf$var$ScrollContainer;

});
parcelRegister("dqFfV", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab47d881c2802a99$export$2e2bcd8739ae039);
function $ab47d881c2802a99$export$2e2bcd8739ae039(refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === 'function') ref(value);
            else if (ref !== null) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, no-param-reassign
            ref.current = value;
        });
    };
}

});

parcelRegister("gdIki", function(module, exports) {

$parcel$export(module.exports, "default", () => $a92941b6f52bc9e1$export$2e2bcd8739ae039);

var $4AKfx = parcelRequire("4AKfx");
function $a92941b6f52bc9e1$export$2e2bcd8739ae039(callback) {
    const ref = (0, $4AKfx.default)(()=>callback);
    return ref.current;
}

});
parcelRegister("4AKfx", function(module, exports) {

$parcel$export(module.exports, "default", () => $5bb6eeb932391a2b$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
const $5bb6eeb932391a2b$var$uniqueReferencedValue = {};
function $5bb6eeb932391a2b$export$2e2bcd8739ae039(initializer) {
    const ref = (0, $eJOHy.useRef)($5bb6eeb932391a2b$var$uniqueReferencedValue);
    if (ref.current === $5bb6eeb932391a2b$var$uniqueReferencedValue) ref.current = initializer();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return ref;
}

});


parcelRegister("2wesH", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9552b1716f014ae$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
function $c9552b1716f014ae$export$2e2bcd8739ae039(initialState) {
    const [value, setValue] = (0, $eJOHy.useState)(initialState);
    const valueRef = (0, $eJOHy.useRef)(value);
    valueRef.current = value;
    return [
        valueRef,
        setValue
    ];
}

});

const $1a2868fb18c8f817$export$4c317248f944c2a9 = 2;

parcelRegister("dj0CM", function(module, exports) {

$parcel$export(module.exports, "rafSchedule", () => $9f17633710257298$export$3c6851d470650c35);
// Adapted from https://github.com/alexreardon/raf-schd/blob/master/src/index.js
const $9f17633710257298$export$3c6851d470650c35 = (fn)=>{
    let frameId = null;
    const wrapperFn = ()=>{
        // There is already a frame queued
        if (frameId) return;
        // Schedule a new frame
        frameId = requestAnimationFrame(()=>{
            frameId = null;
            fn();
        });
    };
    // Adding cancel property to result function
    wrapperFn.cancel = ()=>{
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
    };
    return wrapperFn;
};

});



parcelRegister("4bJFX", function(module, exports) {

$parcel$export(module.exports, "MiniTransition", () => $e521d9ded11264b0$export$1f36cb33f56bd06e);

var $eJOHy = parcelRequire("eJOHy");

var $Ys7jv = parcelRequire("Ys7jv");
var $2rPSy = parcelRequire("2rPSy");
var $kk5YU = parcelRequire("kk5YU");

var $75RwT = parcelRequire("75RwT");
const $e521d9ded11264b0$export$1f36cb33f56bd06e = ({ children: children, renderCondition: renderCondition })=>{
    const { onFinishAnimation: onFinishAnimation, shouldRenderView: shouldRenderView } = (0, $75RwT.useTransitionView)('mini', renderCondition);
    if ((0, $kk5YU.isReducedMotion)()) {
        if (renderCondition) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children({
            transitionProps: {}
        }));
        return null;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ys7jv.default), null, shouldRenderView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2rPSy.default), {
        entranceDirection: "bottom",
        exitDirection: "bottom",
        duration: "medium",
        onFinish: onFinishAnimation
    }, (fadeInProps)=>children({
            transitionProps: {
                ...fadeInProps
            }
        })));
};

});

parcelRegister("c7o2k", function(module, exports) {

$parcel$export(module.exports, "MiniBody", () => $1d633cc46139b346$export$b7d0c8df4a39a4c7);
$parcel$export(module.exports, "Mini", () => $1d633cc46139b346$export$87d5d88f89bf43b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $2ZGUP = parcelRequire("2ZGUP");

var $elL9D = parcelRequire("elL9D");

var $gCeeo = parcelRequire("gCeeo");
var $8Plmb = parcelRequire("8Plmb");

var $fIw44 = parcelRequire("fIw44");

var $dIu0P = parcelRequire("dIu0P");

var $75mvT = parcelRequire("75mvT");
const $1d633cc46139b346$export$b7d0c8df4a39a4c7 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $75mvT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1d633cc46139b346$var$MiniBodyWrapper, null, children));
const $1d633cc46139b346$export$87d5d88f89bf43b = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, className: className, components: components }, ref)=>{
    const { Header: Header = (0, $eJOHy.Fragment), Footer: Footer = (0, $eJOHy.Fragment) } = components || {};
    const { isTransitionInState: isTransitionInState } = (0, $fIw44.useMinimizableModal)();
    const isViewEntered = isTransitionInState([
        'mini'
    ], (0, $dIu0P.TransitionState).ENTERED);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $elL9D.JiraBottomRightCornerOutlet), {
        orderFromRight: 3,
        id: "issue-create-mini-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2ZGUP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1d633cc46139b346$var$MiniWrapper, {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        "data-testid": !isViewEntered ? undefined : 'minimizable-modal.ui.modal-container.mini',
        role: "dialog",
        "aria-modal": "false",
        "aria-labelledby": "minimizable-modal.modal-container.modal-header.title"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Plmb.MountEvent), {
        onMount: (0, $gCeeo.fireScreenAnalyticsDeferred)
    }), components ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Header, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1d633cc46139b346$export$b7d0c8df4a39a4c7, null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Footer, null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children))));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1d633cc46139b346$var$MiniWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _2rkoftgi _1bsb12hx _4t3i1diq _bfhk1bhr _1e0c1txw _2lx21bp4 _16qs1cd0",
            __cmplp.className
        ])
    });
});
const $1d633cc46139b346$var$MiniBodyWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0qu2gc _u5f31ejb _n3tdu2gc _19bv1ejb",
            __cmplp.className
        ])
    });
});

});
parcelRegister("75mvT", function(module, exports) {

$parcel$export(module.exports, "default", () => $781c496c84f3d3a3$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $k0ahr = parcelRequire("k0ahr");

var $g6Dmv = parcelRequire("g6Dmv");

var $dqFfV = parcelRequire("dqFfV");

var $gdIki = parcelRequire("gdIki");

var $2wesH = parcelRequire("2wesH");


var $4cTTi = parcelRequire("4cTTi");
const $781c496c84f3d3a3$var$styles = {
    scrollContainerWrapper: "_16jlkb7n _1o9zkb7n _i0dl1kw7 _1e0c1kw7 _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t _2lx21kw7 _1reo15vq _18m91wug",
    topKeyline: "_x3dov2xi",
    bottomKeyline: "_n7zlv2xi"
};
/**
 * A container that shows top and bottom keylines when the
 * content overflows into the scrollable element.
 */ const $781c496c84f3d3a3$var$ScrollContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const { testId: testId, children: children, disableAutoTopKeyline: disableAutoTopKeyline = true, disableAutoBottomKeyline: disableAutoBottomKeyline = true } = props;
    const [hasSiblings, setSiblings] = (0, $2wesH.default)({
        previous: false,
        next: false
    });
    const [showContentFocus, setContentFocus] = (0, $eJOHy.useState)(false);
    const [showTopKeyline, setTopKeyline] = (0, $eJOHy.useState)(false);
    const [showBottomKeyline, setBottomKeyline] = (0, $eJOHy.useState)(false);
    const scrollableRef = (0, $eJOHy.useRef)(null);
    const setLazySiblings = (0, $gdIki.default)(setSiblings);
    const setLazyContentFocus = (0, $gdIki.default)((0, $4cTTi.rafSchedule)(()=>{
        const target = scrollableRef.current;
        target && setContentFocus(target.scrollHeight > target.clientHeight);
    }));
    const setLazyKeylines = (0, $gdIki.default)((0, $4cTTi.rafSchedule)(()=>{
        const target = scrollableRef.current;
        if (target) {
            const scrollableDistance = target.scrollHeight - target.clientHeight;
            if (hasSiblings.current.previous) setTopKeyline(target.scrollTop > (0, $c6c5ab8a9690038f$export$4c317248f944c2a9));
            if (hasSiblings.current.next) setBottomKeyline(target.scrollTop <= scrollableDistance - (0, $c6c5ab8a9690038f$export$4c317248f944c2a9));
        }
    }));
    (0, $eJOHy.useEffect)(()=>{
        const target = scrollableRef.current;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('resize', setLazyKeylines, false);
        target?.addEventListener('scroll', setLazyKeylines, false);
        setLazyContentFocus();
        setLazyKeylines();
        setLazySiblings({
            previous: Boolean(target?.previousElementSibling),
            next: Boolean(target?.nextElementSibling)
        });
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.removeEventListener('resize', setLazyKeylines, false);
            target?.removeEventListener('scroll', setLazyKeylines, false);
        };
    }, [
        setLazyContentFocus,
        setLazyKeylines,
        setLazySiblings
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $g6Dmv.default), {
        as: "div",
        isInset: true,
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex: showContentFocus ? 0 : undefined,
        testId: testId !== null && testId !== undefined ? `${testId}--scrollable` : undefined,
        ref: (0, $dqFfV.default)([
            ref,
            scrollableRef
        ]),
        xcss: (0, $k0ahr.cx)($781c496c84f3d3a3$var$styles.scrollContainerWrapper, !disableAutoTopKeyline && showTopKeyline && $781c496c84f3d3a3$var$styles.topKeyline, !disableAutoBottomKeyline && showBottomKeyline && $781c496c84f3d3a3$var$styles.bottomKeyline)
    }, children);
});
$781c496c84f3d3a3$var$ScrollContainer.displayName = 'ScrollContainer';
var $781c496c84f3d3a3$export$2e2bcd8739ae039 = $781c496c84f3d3a3$var$ScrollContainer;

});
const $c6c5ab8a9690038f$export$4c317248f944c2a9 = 2;

parcelRegister("4cTTi", function(module, exports) {

$parcel$export(module.exports, "rafSchedule", () => $956d8b5d0a470240$export$3c6851d470650c35);
// Adapted from https://github.com/alexreardon/raf-schd/blob/master/src/index.js
const $956d8b5d0a470240$export$3c6851d470650c35 = (fn)=>{
    let frameId = null;
    const wrapperFn = ()=>{
        // There is already a frame queued
        if (frameId) return;
        // Schedule a new frame
        frameId = requestAnimationFrame(()=>{
            frameId = null;
            fn();
        });
    };
    // Adding cancel property to result function
    wrapperFn.cancel = ()=>{
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
    };
    return wrapperFn;
};

});



parcelRegister("9vG5g", function(module, exports) {

$parcel$export(module.exports, "MinimizedTransition", () => $835f8cb3b56f5971$export$a483cc235b11f289);

var $eJOHy = parcelRequire("eJOHy");

var $Ys7jv = parcelRequire("Ys7jv");
var $2rPSy = parcelRequire("2rPSy");
var $kk5YU = parcelRequire("kk5YU");

var $75RwT = parcelRequire("75RwT");
const $835f8cb3b56f5971$export$a483cc235b11f289 = ({ children: children, renderCondition: renderCondition })=>{
    const { onFinishAnimation: onFinishAnimation, shouldRenderView: shouldRenderView } = (0, $75RwT.useTransitionView)('minimized', renderCondition);
    if ((0, $kk5YU.isReducedMotion)()) {
        if (renderCondition) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children({
            transitionProps: {}
        }));
        return null;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ys7jv.default), null, shouldRenderView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2rPSy.default), {
        entranceDirection: "bottom",
        exitDirection: "bottom",
        duration: "medium",
        onFinish: onFinishAnimation
    }, (fadeInProps)=>children({
            transitionProps: {
                ...fadeInProps
            }
        })));
};

});

parcelRegister("kwvP4", function(module, exports) {

$parcel$export(module.exports, "Minimized", () => $fbb9660f0d8d3e94$export$b41d27d203c8df67);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $g6Dmv = parcelRequire("g6Dmv");

var $lRq8t = parcelRequire("lRq8t");

var $3UrQk = parcelRequire("3UrQk");

var $elL9D = parcelRequire("elL9D");

var $gCeeo = parcelRequire("gCeeo");
var $8Plmb = parcelRequire("8Plmb");
var $ftN6c = parcelRequire("ftN6c");

var $2tjUJ = parcelRequire("2tjUJ");

var $fIw44 = parcelRequire("fIw44");

var $dIu0P = parcelRequire("dIu0P");

var $jrcpI = parcelRequire("jrcpI");
const $fbb9660f0d8d3e94$var$styles = {
    minimizedWrapper: "_19itglyw _2rkoftgi _v5649dqc _vchhusvi _bfhkhp5a _4t3ickbl _1bsb1mjv _1e0c1txw _4cvr1h6o _ca0qze3t _u5f3pxbi _n3tdze3t _19bvpxbi _80omtlke _16qs1cd0 _ymio1r31 _ypr0glyw _zcxs1o36 _1spjglyw _1dit1r31 _ksodglyw _4hz81o36 _irr3108i _1q5t1r31 _1ohyglyw _1r9x1o36 _1di61ji5",
    minimizedText: "_1reo15vq _18m915vq _11c8nbxd _1bto1l2s _o5721q9c _syaz1fxt",
    minimizedOuterWrapper: "_nt751r31 _49pcglyw _1hvw1o36"
};
const $fbb9660f0d8d3e94$export$b41d27d203c8df67 = ({ children: children, className: className })=>{
    const { unminimizeModal: unminimizeModal, previousView: previousView, isTransitionInState: isTransitionInState, setShouldFocusChanger: setShouldFocusChanger } = (0, $fIw44.useMinimizableModal)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { minimizedButtonRef: minimizedButtonRef, onKeyDown: onKeyDown, wrapperRef: wrapperRef } = (0, $2tjUJ.useEnterFocusState)();
    const isViewEntered = isTransitionInState([
        'minimized'
    ], (0, $dIu0P.TransitionState).ENTERED);
    const unminimize = ()=>{
        if (!isViewEntered) return;
        setShouldFocusChanger(true);
        unminimizeModal('modal');
        const analyticsEvent = createAnalyticsEvent({
            action: 'container clicked',
            actionSubject: 'minimized'
        });
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, {
            source: 'globalIssueCreateModal',
            previousGICViewState: previousView
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $elL9D.JiraBottomRightCornerOutlet), {
        orderFromRight: 3,
        id: "issue-create-minimised-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        id: (0, $3UrQk.MINIMISED_DROPZONE_CONTAINER_ID),
        tabIndex: -1,
        ref: wrapperRef,
        className: (0, $hcewu.default)([
            $fbb9660f0d8d3e94$var$styles.minimizedOuterWrapper,
            className
        ]),
        "data-testid": // testid should only be available when view is not transitioning
        // otherwise CY tries to click the view before its last position
        isViewEntered ? 'minimizable-modal.ui.modal-container.minimized-outer-wrapper' : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Plmb.MountEvent), {
        onMount: (0, $gCeeo.fireScreenAnalyticsDeferred)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $g6Dmv.default), {
        isInset: true,
        ref: minimizedButtonRef,
        testId: isViewEntered ? 'minimizable-modal.ui.modal-container.minimized' : undefined,
        onKeyDown: onKeyDown,
        onClick: unminimize,
        "aria-label": formatMessage((0, $jrcpI.default).ariaLabel),
        xcss: $fbb9660f0d8d3e94$var$styles.minimizedWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            $fbb9660f0d8d3e94$var$styles.minimizedText
        ])
    }, children))));
};

});
parcelRegister("2tjUJ", function(module, exports) {

$parcel$export(module.exports, "useEnterFocusState", () => $6fe94d1f86f3b95b$export$cda941d4347e19b6);

var $eJOHy = parcelRequire("eJOHy");

var $fIw44 = parcelRequire("fIw44");

var $dIu0P = parcelRequire("dIu0P");
const $6fe94d1f86f3b95b$export$cda941d4347e19b6 = ()=>{
    const { view: view, setTransitionByKeyboardFrom: setTransitionByKeyboardFrom, transitionByKeyboardFrom: transitionByKeyboardFrom, isTransitionInState: isTransitionInState, shouldFocusChanger: shouldFocusChanger, setShouldFocusChanger: setShouldFocusChanger } = (0, $fIw44.useMinimizableModal)();
    // Keep refs in this order in order not to affect the unit tests
    const minimizedButtonRef = (0, $eJOHy.useRef)(null);
    const modalButtonRef = (0, $eJOHy.useRef)(null);
    const miniButtonRef = (0, $eJOHy.useRef)(null);
    const wrapperRef = (0, $eJOHy.useRef)(null);
    const [init, setInit] = (0, $eJOHy.useState)(false);
    const isViewEntered = isTransitionInState([
        view
    ], (0, $dIu0P.TransitionState).ENTERED);
    const onKeyDown = (0, $eJOHy.useCallback)((ev)=>{
        if (!isViewEntered) return;
        // 13: Enter Key; 32: Space Key
        setTransitionByKeyboardFrom([
            13,
            32
        ].includes(ev.keyCode) ? view : null);
    }, [
        setTransitionByKeyboardFrom,
        isViewEntered,
        view
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!init && isViewEntered && shouldFocusChanger) {
            setInit(true);
            setShouldFocusChanger(false);
            const buttonRef = {
                modal: modalButtonRef.current,
                mini: miniButtonRef.current,
                minimized: minimizedButtonRef.current,
                fullscreen: null
            };
            requestAnimationFrame(()=>{
                const buttonToFocus = transitionByKeyboardFrom !== null && view === 'minimized' ? 'minimized' : transitionByKeyboardFrom;
                if (buttonToFocus && buttonRef[buttonToFocus]) {
                    // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                    buttonRef[buttonToFocus].focus();
                    setTransitionByKeyboardFrom(null);
                } else if (wrapperRef.current) wrapperRef.current.focus();
            });
        }
    }, [
        transitionByKeyboardFrom,
        setTransitionByKeyboardFrom,
        init,
        view,
        isViewEntered,
        shouldFocusChanger,
        setShouldFocusChanger
    ]);
    return {
        onKeyDown: onKeyDown,
        minimizedButtonRef: minimizedButtonRef,
        modalButtonRef: modalButtonRef,
        miniButtonRef: miniButtonRef,
        wrapperRef: wrapperRef
    };
};

});

parcelRegister("jrcpI", function(module, exports) {

$parcel$export(module.exports, "default", () => $768f003ff4b6ddfa$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $768f003ff4b6ddfa$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    ariaLabel: {
        "id": "minimizable-modal.modal-container.minimized.messaged.aria-label",
        "defaultMessage": "Minimized modal"
    }
});

});


parcelRegister("5IfL0", function(module, exports) {

$parcel$export(module.exports, "ModalHeader", () => $eb0ab867323a749f$export$f50a68e3694789ee);
$parcel$export(module.exports, "ModalTitle", () => $eb0ab867323a749f$export$b26fae16ba5468aa);
$parcel$export(module.exports, "MiniHeader", () => $eb0ab867323a749f$export$1d38987b2afcba7e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $Ay1uj = parcelRequire("Ay1uj");

var $806LH = parcelRequire("806LH");

var $6zhpo = parcelRequire("6zhpo");

var $XhTSt = parcelRequire("XhTSt");

var $kGiTR = parcelRequire("kGiTR");

var $idu5j = parcelRequire("idu5j");

var $2qG7I = parcelRequire("2qG7I");
var $5a9Ro = parcelRequire("5a9Ro");

var $8nu6j = parcelRequire("8nu6j");
var $3Wh6p = parcelRequire("3Wh6p");
var $1DXK0 = parcelRequire("1DXK0");

var $epTsa = parcelRequire("epTsa");

var $7jTnu = parcelRequire("7jTnu");

var $lRq8t = parcelRequire("lRq8t");

var $dRC5m = parcelRequire("dRC5m");

var $4xbv3 = parcelRequire("4xbv3");
var $iqtgH = parcelRequire("iqtgH");
var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $6XJko = parcelRequire("6XJko");

var $ea0Pc = parcelRequire("ea0Pc");

var $duWVD = parcelRequire("duWVD");

var $2cfd4 = parcelRequire("2cfd4");

var $ln6Iy = parcelRequire("ln6Iy");

var $2tjUJ = parcelRequire("2tjUJ");

var $fIw44 = parcelRequire("fIw44");

var $dIu0P = parcelRequire("dIu0P");

var $ikABV = parcelRequire("ikABV");

var $6y8SH = parcelRequire("6y8SH");

var $b0tMd = parcelRequire("b0tMd");
const $eb0ab867323a749f$export$b89ab188a65746a6 = ({ isMini: isMini = false, ViewChangerContainer: ViewChangerContainer, dismissModalEntryPointWrapper: dismissModalEntryPointWrapper, meatBallMenu: meatBallMenu })=>{
    const { view: view, setView: setView, onClose: onClose, isTransitionInState: isTransitionInState, setShouldFocusChanger: setShouldFocusChanger, displayMinimizableButtons: displayMinimizableButtons } = (0, $fIw44.useMinimizableModal)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { minimizedButtonRef: minimizedButtonRef, modalButtonRef: modalButtonRef, miniButtonRef: miniButtonRef, wrapperRef: wrapperRef, onKeyDown: onKeyDown } = (0, $2tjUJ.useEnterFocusState)();
    const onUpdateView = (0, $eJOHy.useCallback)((newView)=>{
        if (!isTransitionInState([
            view
        ], (0, $dIu0P.TransitionState).ENTERED)) return;
        setShouldFocusChanger(true);
        setView(newView);
        const analyticsEvent = createAnalyticsEvent({
            action: 'button clicked',
            actionSubject: newView
        });
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, {
            source: 'globalIssueCreateModal',
            previousGICViewState: view
        });
    }, [
        isTransitionInState,
        view,
        setShouldFocusChanger,
        setView,
        createAnalyticsEvent
    ]);
    const onViewChangeToMinimized = (0, $eJOHy.useCallback)(()=>onUpdateView('minimized'), [
        onUpdateView
    ]);
    const onViewChangeToMini = (0, $eJOHy.useCallback)(()=>onUpdateView('mini'), [
        onUpdateView
    ]);
    const onViewChangeToModal = (0, $eJOHy.useCallback)(()=>onUpdateView('modal'), [
        onUpdateView
    ]);
    const { shouldDisableViewChangerButtons: shouldDisableViewChangerButtons, customDisabledViewChangerButtonsMessage: customDisabledViewChangerButtonsMessage } = (0, $fIw44.useMinimizableModal)();
    (0, $eJOHy.useEffect)(()=>{
        if (shouldDisableViewChangerButtons) (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            action: 'disabled',
            actionSubject: 'view changer buttons'
        }));
    }, [
        createAnalyticsEvent,
        customDisabledViewChangerButtonsMessage,
        shouldDisableViewChangerButtons
    ]);
    (0, $ikABV.useNestedModalDetector)();
    const Wrapper = ViewChangerContainer || (0, $eJOHy.Fragment);
    const expandMessage = (0, $b0tMd.default).fullScreen;
    const dockMessage = (0, $b0tMd.default).fullScreenExit;
    const dockDisabledMessage = (0, $b0tMd.default).fullScreenExitDisabled;
    const tooltipOptions = {
        position: 'top',
        hideTooltipOnClick: true
    };
    let closeBtn;
    if (dismissModalEntryPointWrapper) {
        const DismissModalEntryPointWrapper = dismissModalEntryPointWrapper;
        closeBtn = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(DismissModalEntryPointWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
            isTooltipDisabled: false,
            tooltip: tooltipOptions,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($6zhpo))),
            label: formatMessage((0, $b0tMd.default).close),
            onClick: onClose,
            testId: "minimizable-modal.ui.modal-container.modal-header.close-button",
            appearance: isMini && (0, $6XJko.isVisualRefreshEnabled)() ? 'default' : 'subtle'
        }));
    } else closeBtn = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
        isTooltipDisabled: false,
        tooltip: tooltipOptions,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6zhpo))),
        label: formatMessage((0, $b0tMd.default).close),
        onClick: onClose,
        testId: "minimizable-modal.ui.modal-container.modal-header.close-button",
        appearance: isMini && (0, $6XJko.isVisualRefreshEnabled)() ? 'default' : 'subtle'
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($eb0ab867323a749f$var$ViewChangerWrapper, {
        tabIndex: -1,
        ref: wrapperRef,
        isMini: isMini,
        "data-testid": "minimizable-modal.ui.modal-container.modal-header.view-changer-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        space: "space.100",
        as: "ul",
        xcss: $eb0ab867323a749f$var$headerButtonsListStyles
    }, !displayMinimizableButtons ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "li",
        xcss: $eb0ab867323a749f$var$lineItemStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
        isTooltipDisabled: false,
        tooltip: tooltipOptions,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kGiTR))),
        label: shouldDisableViewChangerButtons ? customDisabledViewChangerButtonsMessage || formatMessage((0, $b0tMd.default).minimizeDisabled) : formatMessage((0, $b0tMd.default).minimize),
        onClick: onViewChangeToMinimized,
        testId: "minimizable-modal.ui.modal-container.modal-header.minimized-button",
        appearance: isMini && (0, $6XJko.isVisualRefreshEnabled)() ? 'default' : 'subtle',
        onKeyDown: onKeyDown,
        isDisabled: shouldDisableViewChangerButtons,
        ref: minimizedButtonRef
    })), !isMini && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "li",
        xcss: $eb0ab867323a749f$var$lineItemStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
        isTooltipDisabled: false,
        tooltip: tooltipOptions,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($idu5j))),
        label: shouldDisableViewChangerButtons ? customDisabledViewChangerButtonsMessage || formatMessage(dockDisabledMessage) : formatMessage(dockMessage),
        onClick: onViewChangeToMini,
        testId: "minimizable-modal.ui.modal-container.modal-header.mini-button",
        appearance: isMini && (0, $6XJko.isVisualRefreshEnabled)() ? 'default' : 'subtle',
        onKeyDown: onKeyDown,
        isDisabled: shouldDisableViewChangerButtons,
        ref: miniButtonRef
    })), isMini && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "li",
        xcss: $eb0ab867323a749f$var$lineItemStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
        isTooltipDisabled: false,
        tooltip: tooltipOptions,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($XhTSt))),
        label: formatMessage(expandMessage),
        onClick: onViewChangeToModal,
        testId: "minimizable-modal.ui.modal-container.modal-header.modal-button",
        appearance: isMini && (0, $6XJko.isVisualRefreshEnabled)() ? 'default' : 'subtle',
        onKeyDown: onKeyDown,
        ref: modalButtonRef
    })), meatBallMenu && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "li",
        xcss: $eb0ab867323a749f$var$lineItemStyles
    }, meatBallMenu), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "li",
        xcss: $eb0ab867323a749f$var$lineItemStyles
    }, closeBtn)))));
};
const $eb0ab867323a749f$export$f50a68e3694789ee = ({ children: children, ViewChangerContainer: ViewChangerContainer, dismissModalEntryPointWrapper: dismissModalEntryPointWrapper, meatBallMenu: meatBallMenu, project: project, ...rest })=>{
    const locale = (0, $2cfd4.useLocale)();
    const isEnglishLocale = locale && typeof locale === 'string' && locale.startsWith('en');
    const isSoftwareOrBusinessProject = project?.projectType === (0, $ln6Iy.SOFTWARE_PROJECT) || project?.projectType === (0, $ln6Iy.CORE_PROJECT);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($eb0ab867323a749f$var$HeaderWrapper, rest, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2qG7I.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5a9Ro.default), null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($eb0ab867323a749f$export$b89ab188a65746a6, {
        ViewChangerContainer: ViewChangerContainer,
        dismissModalEntryPointWrapper: dismissModalEntryPointWrapper,
        meatBallMenu: meatBallMenu
    })), isSoftwareOrBusinessProject && isEnglishLocale && (0, $7jTnu.fg)('jira_in_product_video_pilot_fg') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $duWVD.default // eslint-disable-next-line react-hooks/react-compiler
    ), {
        conditions: (0, $ea0Pc.composeTraitsSelectors)([
            'SITE_USER'
        ], [
            (0, $6y8SH.usePassesIPHTargetingTraitsSelector)
        ])
    }, (0, $epTsa.expVal)('jira_in_product_video_pilot_v1', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        sourceName: "gicCreateWorkItemVideo",
        sourceType: (0, $466f60259c330878$export$238d30785c4bca84)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dRC5m.CreateWorkVideoEducationModalTriggerButtonBanner), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqtgH.FireScreenAnalytics), null))));
};
const $eb0ab867323a749f$export$b26fae16ba5468aa = (props)=>{
    const { view: view } = (0, $fIw44.useMinimizableModal)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { children: children, testId: testId } = props;
    if (view === 'mini' || view === 'minimized') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "h2",
        xcss: (0, $6XJko.isVisualRefreshEnabled)() ? $eb0ab867323a749f$var$headerStyleswithVR : $eb0ab867323a749f$var$headerStyles,
        testId: testId,
        id: "minimizable-modal.modal-container.modal-header.title"
    }, children || formatMessage((0, $b0tMd.default).headerFallbackTitle));
    return (0, $6XJko.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        as: "h2",
        size: "medium",
        color: "color.text"
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", props);
};
const $eb0ab867323a749f$export$1d38987b2afcba7e = ({ children: children, dismissModalEntryPointWrapper: dismissModalEntryPointWrapper, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($eb0ab867323a749f$var$MiniHeaderWrapper, rest, children || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($eb0ab867323a749f$export$b26fae16ba5468aa, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($eb0ab867323a749f$export$b89ab188a65746a6, {
        isMini: true,
        dismissModalEntryPointWrapper: dismissModalEntryPointWrapper
    })); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $eb0ab867323a749f$var$ViewChangerWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isMini: isMini, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _2lx2vrvc _1bahesu3 _1o9zidpf _nt751r31 _49pcglyw _1hvw1o36",
            __cmplp.isMini && "_u5f31b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $eb0ab867323a749f$var$HeaderWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_otcopxbi _17ugpxbi _1eompxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $eb0ab867323a749f$var$MiniHeaderWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_n7zl1pfj _1e0c1txw _2lx2vrvc _4cvr1h6o _1bahesu3 _syaz1fxt _16qs1bc2 _19pkidpf _2hwxutpp _otyridpf _18u0utpp _ca0qv47k _u5f3u2gc _n3tdv47k _19bvu2gc",
            __cmplp.className
        ])
    });
}); // Atlaskit does not have a solution for using tooltips for disabled buttons.
const $eb0ab867323a749f$var$headerButtonsListStyles = (0, $1DXK0.xcss)({
    display: 'inline-flex',
    listStyleType: 'none',
    borderRadius: 'borderRadius.25'
});
const $eb0ab867323a749f$var$lineItemStyles = (0, $1DXK0.xcss)({
    margin: 'auto'
});
const $eb0ab867323a749f$var$headerStyles = (0, $1DXK0.xcss)({
    color: 'color.text',
    font: "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    paddingLeft: 'space.100',
    paddingRight: 'space.100',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    flexShrink: 1,
    flexGrow: 1,
    overflow: 'hidden',
    marginTop: '0'
});
const $eb0ab867323a749f$var$headerStyleswithVR = (0, $1DXK0.xcss)({
    color: 'color.text',
    font: "var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    paddingRight: 'space.100',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    flexShrink: 1,
    flexGrow: 1,
    overflow: 'hidden',
    marginTop: '0'
});

});
parcelRegister("kGiTR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4184f921700e882128556324b8090399>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f0e664030820d246$var$_react = $f0e664030820d246$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $f0e664030820d246$var$_baseNew = $f0e664030820d246$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $f0e664030820d246$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Minimize".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for minimizing or docking modals to the bottom of the viewport.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f0e664030820d246$var$MinimizeIcon = (props)=>/*#__PURE__*/ $f0e664030820d246$var$_react.default.createElement($f0e664030820d246$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14 14H2v-1.5h12z" clip-rule="evenodd"/>`
    }, props));
$f0e664030820d246$var$MinimizeIcon.displayName = 'MinimizeIcon';
var $f0e664030820d246$var$_default = module.exports.default = $f0e664030820d246$var$MinimizeIcon;

});

parcelRegister("idu5j", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b5830a86fa64b71ea84cc4eb2a6e1075>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d430c71ad3f6d10b$var$_react = $d430c71ad3f6d10b$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $d430c71ad3f6d10b$var$_baseNew = $d430c71ad3f6d10b$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $d430c71ad3f6d10b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ShrinkDiagonal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for shrinking the height and width of modals, panels, media, or objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d430c71ad3f6d10b$var$ShrinkDiagonalIcon = (props)=>/*#__PURE__*/ $d430c71ad3f6d10b$var$_react.default.createElement($d430c71ad3f6d10b$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.72 6.22 13.97.97l1.06 1.06-5.25 5.25zM7.28 9.78l-5.25 5.25-1.06-1.06 5.25-5.25z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M10 6V2H8.5v4.75c0 .414.336.75.75.75H14V6zM2 8.5h4.75a.75.75 0 0 1 .75.75V14H6v-4H2z" clip-rule="evenodd"/>`
    }, props));
$d430c71ad3f6d10b$var$ShrinkDiagonalIcon.displayName = 'ShrinkDiagonalIcon';
var $d430c71ad3f6d10b$var$_default = module.exports.default = $d430c71ad3f6d10b$var$ShrinkDiagonalIcon;

});

parcelRegister("dRC5m", function(module, exports) {

$parcel$export(module.exports, "CreateWorkVideoEducationModalTriggerButtonBanner", () => $13dfec5edd03d6e4$export$2762094c42e43d6c);

var $eJOHy = parcelRequire("eJOHy");

var $1Marh = parcelRequire("1Marh");

var $6zhpo = parcelRequire("6zhpo");

var $Ay1uj = parcelRequire("Ay1uj");

var $8nu6j = parcelRequire("8nu6j");
var $lmgo6 = parcelRequire("lmgo6");
var $1DXK0 = parcelRequire("1DXK0");

var $c8ocz = parcelRequire("c8ocz");

var $lRq8t = parcelRequire("lRq8t");

var $dThrJ = parcelRequire("dThrJ");

var $gCeeo = parcelRequire("gCeeo");

var $ftN6c = parcelRequire("ftN6c");

var $kiahK = parcelRequire("kiahK");
const $13dfec5edd03d6e4$export$2762094c42e43d6c = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [isBannerDismissed, setIsBannerDismissed] = (0, $eJOHy.useState)(false);
    const handleOpenModal = (0, $eJOHy.useCallback)(()=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'openCreateWorkVideoEducationModal');
    }, [
        createAnalyticsEvent
    ]);
    const handleDismissBanner = (0, $eJOHy.useCallback)(()=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'dismissCreateWorkVideoEducationBanner');
        setIsBannerDismissed(true);
    }, [
        createAnalyticsEvent
    ]);
    const entryPointProps = (0, $eJOHy.useMemo)(()=>({}), []);
    const modalProps = (0, $eJOHy.useMemo)(()=>({
            width: 'x-large',
            onOpenComplete: ()=>{
                (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
                    action: 'open',
                    actionSubject: 'modalDialog'
                }), 'createWorkVideoEducationModal');
            },
            onCloseComplete: ()=>{
                (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
                    action: 'close',
                    actionSubject: 'modalDialog'
                }), 'createWorkVideoEducationModal');
            }
        }), [
        createAnalyticsEvent
    ]);
    if (isBannerDismissed) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        testId: "issue-create-commons.ui.create-work-video-education-modal-trigger-button.create-work-video-education-banner",
        xcss: $13dfec5edd03d6e4$var$bannerContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        alignItems: "center",
        justifyContent: "space-between",
        xcss: $13dfec5edd03d6e4$var$bannerItemStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dThrJ.ModalEntryPointButtonTrigger), {
        appearance: "subtle",
        entryPoint: (0, $c8ocz.createWorkVideoEducationModalEntryPoint),
        entryPointProps: entryPointProps,
        interactionName: "create-work-video-education-modal",
        modalProps: modalProps,
        onClick: handleOpenModal,
        useInternalModal: true,
        testId: "issue-create-commons.ui.create-work-video-education-modal-trigger-button.create-work-video-education-modal-trigger-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $13dfec5edd03d6e4$var$openVideoModalButtonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        alignItems: "center",
        gap: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1Marh))), {
        label: formatMessage((0, $kiahK.default).videoIconLabel)
    }), formatMessage((0, $kiahK.default).openVideoModalButtonLabel)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6zhpo))),
        label: formatMessage((0, $kiahK.default).closeBannerLabel),
        onClick: handleDismissBanner
    })));
};
const $13dfec5edd03d6e4$var$bannerContainerStyles = (0, $1DXK0.xcss)({
    backgroundColor: 'color.background.discovery',
    paddingBlock: 'space.100',
    paddingInline: 'space.100',
    marginInline: 'space.200',
    marginBottom: 'space.100',
    borderRadius: 'border.radius.100'
});
const $13dfec5edd03d6e4$var$bannerItemStyles = (0, $1DXK0.xcss)({
    width: '100%',
    gap: 'space.100'
});
const $13dfec5edd03d6e4$var$openVideoModalButtonStyles = (0, $1DXK0.xcss)({
    color: 'color.link',
    fontWeight: "var(--ds-font-weight-regular, 400)"
});

});
parcelRegister("1Marh", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::11768438686ca4379c5d612b23881617>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $14b25f2052c1a408$var$_react = $14b25f2052c1a408$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $14b25f2052c1a408$var$_video = $14b25f2052c1a408$var$_interopRequireDefault((parcelRequire("bTWCd")));

var $14b25f2052c1a408$var$_vidCameraOn = $14b25f2052c1a408$var$_interopRequireDefault((parcelRequire("il93n")));
function $14b25f2052c1a408$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for VideoIcon.
 * This component is VideoIcon, with `UNSAFE_fallbackIcon` set to "VidCameraOnIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for representing video content across Atlassian and Loom.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $14b25f2052c1a408$var$VideoIcon = (props)=>/*#__PURE__*/ $14b25f2052c1a408$var$_react.default.createElement($14b25f2052c1a408$var$_video.default, Object.assign({
        LEGACY_fallbackIcon: $14b25f2052c1a408$var$_vidCameraOn.default
    }, props));
$14b25f2052c1a408$var$VideoIcon.Name = 'VideoIconMigration';
var $14b25f2052c1a408$var$_default = module.exports.default = $14b25f2052c1a408$var$VideoIcon;

});
parcelRegister("il93n", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d5a135fc7cda73fe$var$_react = $d5a135fc7cda73fe$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $d5a135fc7cda73fe$var$_video = $d5a135fc7cda73fe$var$_interopRequireDefault((parcelRequire("bTWCd")));
function $d5a135fc7cda73fe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d5a135fc7cda73fe$var$VidCameraOnIcon = (props)=>/*#__PURE__*/ $d5a135fc7cda73fe$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M19.678 8.089q.208-.09.421-.089c.472 0 .901.316.901.753v6.494c0 .437-.43.753-.9.753-.141 0-.286-.028-.424-.09l-2.611-1.416V9.499zM4.856 7h9.288C15.17 7 16 7.747 16 8.669v6.662c0 .922-.83 1.669-1.856 1.669H4.856C3.83 17 3 16.253 3 15.331V8.67C3 7.747 3.83 7 4.856 7"/></svg>`
    }, props, {
        newIcon: $d5a135fc7cda73fe$var$_video.default
    }));
$d5a135fc7cda73fe$var$VidCameraOnIcon.displayName = 'VidCameraOnIcon';
var $d5a135fc7cda73fe$var$_default = module.exports.default = $d5a135fc7cda73fe$var$VidCameraOnIcon;

});


parcelRegister("c8ocz", function(module, exports) {

$parcel$export(module.exports, "createWorkVideoEducationModalEntryPoint", () => $6ee0a75c7fa7a3d0$export$e5d252b17c45f31d);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $6ee0a75c7fa7a3d0$export$e5d252b17c45f31d = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("isOPJ")), {
        moduleId: "066770b8",
        moduleName: "CreateWorkVideoEducationModal",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("isOPJ", function(module, exports) {

let $d71245fe6eaa43b3$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $d71245fe6eaa43b3$var$load("eIZCA").then(()=>parcelRequire('ahIa8'));

});


parcelRegister("dThrJ", function(module, exports) {

$parcel$export(module.exports, "ModalEntryPointButtonTrigger", () => $f774cfbd4f4f0d5e$export$a0d6030c4f504341);

var $eJOHy = parcelRequire("eJOHy");

var $5CSKW = parcelRequire("5CSKW");

var $f7Yza = parcelRequire("f7Yza");
function $f774cfbd4f4f0d5e$export$a0d6030c4f504341({ children: children, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, errorAttributes: errorAttributes, Fallback: Fallback, modalTitle: modalTitle, modalProps: modalProps, useInternalModal: useInternalModal, ...buttonProps }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f7Yza.ModalEntryPointPressableTrigger), {
        entryPoint: entryPoint,
        entryPointParams: entryPointParams,
        entryPointProps: entryPointProps,
        errorAttributes: errorAttributes,
        Fallback: Fallback,
        modalTitle: modalTitle,
        modalProps: modalProps,
        useInternalModal: useInternalModal
    }, ({ ref: ref })=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
            ref: ref,
            ...buttonProps
        }, children));
}

});

parcelRegister("kiahK", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cbe5f1146236200$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $2cbe5f1146236200$var$messages = (0, $7qGN1.defineMessages)({
    tooltip: {
        "id": "issue-create-commons.create-work-video-education-modal-trigger-button.tooltip",
        "defaultMessage": "Watch a tutorial on how to create work"
    },
    openVideoModalButtonLabel: {
        "id": "issue-create-commons.create-work-video-education-modal-trigger-button.open-video-modal-button-label",
        "defaultMessage": "Introduction to work items"
    },
    videoIconLabel: {
        "id": "issue-create-commons.create-work-video-education-modal-trigger-button.video-icon-label",
        "defaultMessage": "Video"
    },
    closeBannerLabel: {
        "id": "issue-create-commons.create-work-video-education-modal-trigger-button.close-banner-label",
        "defaultMessage": "Close"
    }
});
var $2cbe5f1146236200$export$2e2bcd8739ae039 = $2cbe5f1146236200$var$messages;

});


parcelRegister("ea0Pc", function(module, exports) {

$parcel$export(module.exports, "useTraits", () => $e2b3b7a3a420087e$export$243330301a7ccf01);
$parcel$export(module.exports, "useTraitsActions", () => $e2b3b7a3a420087e$export$87f1d888def9d5a0);
$parcel$export(module.exports, "createTraitsSelector", () => $e2b3b7a3a420087e$export$fb8309e220d0dd3b);
$parcel$export(module.exports, "composeTraitsSelectors", () => $e2b3b7a3a420087e$export$e653f602b87eec56);

var $jGzN3 = parcelRequire("jGzN3");

var $iJq0l = parcelRequire("iJq0l");
var $4MchI = parcelRequire("4MchI");
var $GtRbT = parcelRequire("GtRbT");

var $lctcw = parcelRequire("lctcw");

var $lFovQ = parcelRequire("lFovQ");

var $58aKG = parcelRequire("58aKG");

var $19QQ8 = parcelRequire("19QQ8");
const $e2b3b7a3a420087e$var$addTrait = (traitType, trait)=>({ getState: getState, setState: setState })=>{
        const currentUserTraits = getState();
        const state = currentUserTraits[traitType];
        if (!state.attributes) {
            setState({
                ...currentUserTraits,
                [traitType]: {
                    attributes: [
                        trait
                    ]
                }
            });
            return;
        }
        if (state.attributes.some((existingTrait)=>existingTrait.name === trait.name)) setState({
            ...currentUserTraits,
            [traitType]: {
                attributes: state.attributes.map((existingTrait)=>existingTrait.name === trait.name ? trait : existingTrait)
            }
        });
        else setState({
            ...currentUserTraits,
            [traitType]: {
                attributes: [
                    ...state.attributes,
                    trait
                ]
            }
        });
    };
const $e2b3b7a3a420087e$var$fetchTraits = (traitTypes, { cloudId: cloudId, accountId: accountId, orgId: orgId })=>async ({ getState: getState, setState: setState })=>{
        const state = getState();
        await Promise.all(traitTypes.map(async (traitType)=>{
            if (state[traitType].loaded || state[traitType].loading) return;
            setState({
                ...state,
                [traitType]: {
                    ...state[traitType],
                    loading: true
                }
            });
            const traitEndpointEndingFragment = (0, $19QQ8.buildTraitEndpointEndingFragment)({
                traitType: traitType,
                accountId: accountId,
                cloudId: cloudId,
                orgId: orgId
            });
            if (!traitEndpointEndingFragment) return;
            const url = (0, $58aKG.TRAIT_ENDPOINT_STARTING_FRAGMENT) + traitEndpointEndingFragment;
            try {
                let fetchedTraits = null;
                // TODO: in the future, we will need to also memoise site user trait and user trait here
                // Thus, we need to add FG at each conditions to fetch if we should use the memoised fetcher
                if (traitType === (0, $58aKG.SITE) && cloudId) fetchedTraits = {
                    attributes: await (0, $lctcw.memoizedFetchSitePersonalization)({
                        cloudId: cloudId
                    })
                };
                else if (traitType === (0, $58aKG.SITE_USER) && cloudId && accountId) fetchedTraits = {
                    attributes: await (0, $lFovQ.memoizedFetchSiteUserPersonalization)({
                        cloudId: cloudId,
                        userId: accountId
                    })
                };
                else fetchedTraits = await (0, $jGzN3.performGetRequest)(url);
                setState({
                    ...getState(),
                    [traitType]: {
                        attributes: fetchedTraits?.attributes?.length ? fetchedTraits.attributes : null,
                        loading: false,
                        loaded: true
                    }
                });
            } catch  {
                setState({
                    ...getState(),
                    [traitType]: {
                        attributes: null,
                        loading: false,
                        loaded: true
                    }
                });
            }
        }));
    };
const $e2b3b7a3a420087e$var$actions = {
    fetchTraits: $e2b3b7a3a420087e$var$fetchTraits,
    addTrait: $e2b3b7a3a420087e$var$addTrait
};
const $e2b3b7a3a420087e$var$initialState = {
    ATLASSIAN_ACCOUNT: {
        attributes: null,
        loading: false,
        loaded: false
    },
    SITE: {
        attributes: null,
        loading: false,
        loaded: false
    },
    SITE_USER: {
        attributes: null,
        loading: false,
        loaded: false
    },
    ORG: {
        attributes: null,
        loading: false,
        loaded: false
    },
    ORG_USER: {
        attributes: null,
        loading: false,
        loaded: false
    }
};
const $e2b3b7a3a420087e$export$5b11e13f463f4eb = (0, $GtRbT.createStore)({
    initialState: $e2b3b7a3a420087e$var$initialState,
    actions: $e2b3b7a3a420087e$var$actions,
    name: 'TraitsStore'
});
const $e2b3b7a3a420087e$export$243330301a7ccf01 = (0, $iJq0l.createHook)($e2b3b7a3a420087e$export$5b11e13f463f4eb);
const $e2b3b7a3a420087e$export$87f1d888def9d5a0 = (0, $iJq0l.createActionsHook)($e2b3b7a3a420087e$export$5b11e13f463f4eb);
const $e2b3b7a3a420087e$var$defaultSelector = (traitsType, selector)=>(0, $4MchI.createSelector)((state)=>({
            loading: !!state[traitsType]?.loading,
            loaded: state[traitsType]?.loaded || false,
            attributes: state[traitsType]?.attributes,
            userCreatedAfter: (date)=>state[traitsType].loaded ? (0, $19QQ8.userCreatedAfter)(state, date) : false,
            userCreatedBefore: (date)=>state[traitsType].loaded ? (0, $19QQ8.userCreatedBefore)(state, date) : false,
            getTraitByName: (name)=>state[traitsType].loaded ? (0, $19QQ8.getTraitByName)(state, name) : null,
            hasTrait: (name)=>state[traitsType].loaded ? (0, $19QQ8.hasTrait)(state, name) : false,
            getTraitValue: (name)=>state[traitsType].loaded ? (0, $19QQ8.getTraitValue)(state, name) : null
        }), selector);
const $e2b3b7a3a420087e$export$fb8309e220d0dd3b = (traitsType, selector)=>(0, $iJq0l.createHook)($e2b3b7a3a420087e$export$5b11e13f463f4eb, {
        selector: $e2b3b7a3a420087e$var$defaultSelector(traitsType, selector)
    });
const $e2b3b7a3a420087e$export$e653f602b87eec56 = (traitTypes, hooks)=>({
        traitTypes: traitTypes,
        hooks: hooks
    });

});
parcelRegister("58aKG", function(module, exports) {

$parcel$export(module.exports, "ATLASSIAN_ACCOUNT", () => $6bc297d84ad0ac90$export$eac8289d83d13c9e);
$parcel$export(module.exports, "SITE", () => $6bc297d84ad0ac90$export$1f4740cb59ea887e);
$parcel$export(module.exports, "SITE_USER", () => $6bc297d84ad0ac90$export$2b629adc0b711448);
$parcel$export(module.exports, "ORG", () => $6bc297d84ad0ac90$export$c7bc89c720838974);
$parcel$export(module.exports, "ORG_USER", () => $6bc297d84ad0ac90$export$872e93425a929c06);
$parcel$export(module.exports, "TRAIT_ENDPOINT_STARTING_FRAGMENT", () => $6bc297d84ad0ac90$export$ff5c5bd50c21e9a4);
const $6bc297d84ad0ac90$export$eac8289d83d13c9e = 'ATLASSIAN_ACCOUNT';
const $6bc297d84ad0ac90$export$1f4740cb59ea887e = 'SITE';
const $6bc297d84ad0ac90$export$2b629adc0b711448 = 'SITE_USER';
const $6bc297d84ad0ac90$export$c7bc89c720838974 = 'ORG';
const $6bc297d84ad0ac90$export$872e93425a929c06 = 'ORG_USER';
const $6bc297d84ad0ac90$export$ff5c5bd50c21e9a4 = '/gateway/api/tap-delivery/api/v3/personalization/';
const $6bc297d84ad0ac90$export$ab3e7784d2a104d4 = [
    $6bc297d84ad0ac90$export$eac8289d83d13c9e,
    $6bc297d84ad0ac90$export$1f4740cb59ea887e,
    $6bc297d84ad0ac90$export$2b629adc0b711448,
    $6bc297d84ad0ac90$export$c7bc89c720838974,
    $6bc297d84ad0ac90$export$872e93425a929c06
];

});

parcelRegister("19QQ8", function(module, exports) {

$parcel$export(module.exports, "buildTraitEndpointEndingFragment", () => $487f20fc6a559fdc$export$118c30eb4b4c51e8);
$parcel$export(module.exports, "getTraitByName", () => $487f20fc6a559fdc$export$e5b0d140cf11f46a);
$parcel$export(module.exports, "hasTrait", () => $487f20fc6a559fdc$export$252a469687875173);
$parcel$export(module.exports, "getTraitValue", () => $487f20fc6a559fdc$export$43a43c2e6ec7b13);
$parcel$export(module.exports, "userCreatedAfter", () => $487f20fc6a559fdc$export$8388eb33623a9cff);
$parcel$export(module.exports, "userCreatedBefore", () => $487f20fc6a559fdc$export$da1e8ce191f01409);

var $58aKG = parcelRequire("58aKG");
const $487f20fc6a559fdc$export$e320a062b20fddc3 = (traitsData)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.entries(traitsData).reduce((acc, [, val])=>{
        if (val?.attributes) acc.push(...val.attributes.map((singleTrait)=>singleTrait));
        return acc;
    }, []);
const $487f20fc6a559fdc$export$118c30eb4b4c51e8 = ({ traitType: traitType, accountId: accountId, cloudId: cloudId, orgId: orgId })=>{
    switch(traitType){
        case 0, $58aKG.ATLASSIAN_ACCOUNT:
            return `user/${accountId}`;
        case 0, $58aKG.SITE:
            return `site/${cloudId}`;
        case 0, $58aKG.SITE_USER:
            return `site/${cloudId}/user/${accountId}`;
        case 0, $58aKG.ORG:
            return `org/${orgId}`;
        case 0, $58aKG.ORG_USER:
            return `org/${orgId}/user/${accountId}`;
        default:
            return null;
    }
};
function $487f20fc6a559fdc$export$e5b0d140cf11f46a(traitsData, traitName) {
    return $487f20fc6a559fdc$export$e320a062b20fddc3(traitsData)?.find((trait)=>trait.name === traitName);
}
function $487f20fc6a559fdc$export$252a469687875173(traitsData, traitName) {
    return $487f20fc6a559fdc$export$e320a062b20fddc3(traitsData)?.find((trait)=>trait.name === traitName) !== undefined;
}
function $487f20fc6a559fdc$export$43a43c2e6ec7b13(traitsData, traitName) {
    return $487f20fc6a559fdc$export$e320a062b20fddc3(traitsData)?.find((trait)=>trait.name === traitName)?.value ?? null;
}
const $487f20fc6a559fdc$export$d2a3b2f9735b6874 = (traitsData, traitNames)=>$487f20fc6a559fdc$export$e320a062b20fddc3(traitsData)?.filter((trait)=>traitNames.includes(trait.name));
const $487f20fc6a559fdc$export$8388eb33623a9cff = (traitsData, date)=>{
    const accountCreationDate = $487f20fc6a559fdc$export$e5b0d140cf11f46a(traitsData, 'jira_first_active')?.value;
    if (!accountCreationDate) return false;
    return new Date(accountCreationDate) > date;
};
const $487f20fc6a559fdc$export$da1e8ce191f01409 = (traitsData, date)=>{
    const accountCreationDate = $487f20fc6a559fdc$export$e5b0d140cf11f46a(traitsData, 'jira_first_active')?.value;
    if (!accountCreationDate) return false;
    return new Date(accountCreationDate) < date;
};

});


parcelRegister("duWVD", function(module, exports) {

$parcel$export(module.exports, "default", () => $d45d9a4d44e167d8$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $g9Vr6 = parcelRequire("g9Vr6");

var $8q7lT = parcelRequire("8q7lT");

var $kEUB1 = parcelRequire("kEUB1");

var $ea0Pc = parcelRequire("ea0Pc");
const $d45d9a4d44e167d8$var$TraitsConditionalRenderer = ({ conditions: conditions, children: children })=>{
    const accountId = (0, $8q7lT.useAccountId)();
    const cloudId = (0, $kEUB1.useCloudId)();
    const { data: orgId } = (0, $g9Vr6.useOrgId)();
    const { fetchTraits: fetchTraits } = (0, $ea0Pc.useTraitsActions)();
    (0, $eJOHy.useEffect)(()=>{
        fetchTraits(conditions.traitTypes, {
            cloudId: cloudId,
            accountId: accountId,
            orgId: orgId
        });
    }, [
        accountId,
        cloudId,
        conditions.traitTypes,
        fetchTraits,
        orgId
    ]);
    const shouldRenderChildren = conditions.hooks.map((hook)=>hook()[0]).every((result)=>Boolean(result));
    return shouldRenderChildren ? children : null;
};
var $d45d9a4d44e167d8$export$2e2bcd8739ae039 = $d45d9a4d44e167d8$var$TraitsConditionalRenderer;

});

parcelRegister("ikABV", function(module, exports) {

$parcel$export(module.exports, "useNestedModalDetector", () => $67add1309e9447b7$export$d9e46b281508f5e9);

var $eJOHy = parcelRequire("eJOHy");

var $fIw44 = parcelRequire("fIw44");
const $67add1309e9447b7$export$d9e46b281508f5e9 = ()=>{
    const { setIsNestedModal: setIsNestedModal } = (0, $fIw44.useMinimizableModal)();
    (0, $eJOHy.useEffect)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const modalElements = document.querySelectorAll('div.atlaskit-portal [aria-modal="true"]');
        if (modalElements.length > 1) setIsNestedModal(true);
    }, [
        setIsNestedModal
    ]);
};

});

parcelRegister("6y8SH", function(module, exports) {

$parcel$export(module.exports, "usePassesIPHTargetingTraitsSelector", () => $0ecd1c2b91fae928$export$dc68f83573d62eee);

var $ea0Pc = parcelRequire("ea0Pc");
const $0ecd1c2b91fae928$var$isFirstActiveWithinLast30Days = (firstActiveDate)=>{
    const date = new Date(firstActiveDate);
    if (Number.isNaN(date.getTime())) return false;
    const thirtyDaysAgo = new Date();
    thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
    return date >= thirtyDaysAgo;
};
const $0ecd1c2b91fae928$export$dc68f83573d62eee = (0, $ea0Pc.createTraitsSelector)('SITE_USER', ({ getTraitByName: getTraitByName })=>{
    // First check the most common case:
    const hasCreatedIssueInGICTrait = getTraitByName('jira-core_ui_button_clicked_createissue_createissuemodal_first_time');
    if (hasCreatedIssueInGICTrait) return false;
    const hasDismissedCreateIssueVideoBannerTrait = getTraitByName('jira-core_ui_button_clicked_dismisscreateworkvideoeducationbanner_createissuemodal_first_time');
    if (hasDismissedCreateIssueVideoBannerTrait) return false;
    const hasOpennedCreateIssueVideoModalTrait = getTraitByName('jira-core_ui_button_clicked_opencreateworkvideoeducationmodal_createissuemodal_first_time');
    if (hasOpennedCreateIssueVideoModalTrait) return false;
    // less common especially if any above traits are true
    const firstActiveTrait = getTraitByName('jira_first_active');
    if (firstActiveTrait && typeof firstActiveTrait.value === 'string' && !$0ecd1c2b91fae928$var$isFirstActiveWithinLast30Days(firstActiveTrait.value)) return false;
    return true;
});

});

parcelRegister("b0tMd", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd305bdcef602ff2$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $dd305bdcef602ff2$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    minimize: {
        "id": "minimizable-modal.modal-container.modal-header.minimize",
        "defaultMessage": "Minimize"
    },
    minimizeDisabled: {
        "id": "minimizable-modal.modal-container.modal-header.minimize-disabled",
        "defaultMessage": "Can't minimize this view"
    },
    dock: {
        "id": "minimizable-modal.modal-container.modal-header.dock",
        "defaultMessage": "Dock to bottom"
    },
    dockDisabled: {
        "id": "minimizable-modal.modal-container.modal-header.dock-disabled",
        "defaultMessage": "Can't dock this view"
    },
    fullScreenExit: {
        "id": "minimizable-modal.modal-container.modal-header.full-screen-exit",
        "defaultMessage": "Exit full screen"
    },
    fullScreenExitDisabled: {
        "id": "minimizable-modal.modal-container.modal-header.full-screen-exit-disabled",
        "defaultMessage": "Can't exit full screen"
    },
    expand: {
        "id": "minimizable-modal.modal-container.modal-header.expand",
        "defaultMessage": "Expand"
    },
    fullScreen: {
        "id": "minimizable-modal.modal-container.modal-header.full-screen",
        "defaultMessage": "Go full screen"
    },
    close: {
        "id": "minimizable-modal.modal-container.modal-header.close",
        "defaultMessage": "Close"
    },
    onboardingSpotlightTitle: {
        "id": "minimizable-modal.modal-container.modal-header.onboarding-spotlight-title",
        "defaultMessage": "Welcome to the new issue create experience"
    },
    onboardingSpotlightActionGotIt: {
        "id": "minimizable-modal.modal-container.modal-header.onboarding-spotlight-action-got-it",
        "defaultMessage": "Got it"
    },
    onboardingSpotlightActionLearnMore: {
        "id": "minimizable-modal.modal-container.modal-header.onboarding-spotlight-action-learn-more",
        "defaultMessage": "Learn more"
    },
    onboardingSpotlightDescription: {
        "id": "minimizable-modal.modal-container.modal-header.onboarding-spotlight-description",
        "defaultMessage": "A consistent, fast, and optimized way to capture work in your project."
    },
    onboardingSpotlightTitleIssueTermRefresh: {
        "id": "minimizable-modal.modal-container.modal-header.onboarding-spotlight-title-issue-term-refresh",
        "defaultMessage": "Welcome to the new create experience"
    },
    headerFallbackTitle: {
        "id": "minimizable-modal.modal-container.modal-header.title",
        "defaultMessage": "Create New Work Item"
    }
});

});


parcelRegister("i1jdo", function(module, exports) {

$parcel$export(module.exports, "ModalTransition", () => $0e0e22e9bc79424d$export$f0a3ab1cc2e7e9a6);

var $eJOHy = parcelRequire("eJOHy");

var $956it = parcelRequire("956it");

var $kk5YU = parcelRequire("kk5YU");

var $fIw44 = parcelRequire("fIw44");

var $dIu0P = parcelRequire("dIu0P");
const $0e0e22e9bc79424d$export$f0a3ab1cc2e7e9a6 = ({ children: children, renderCondition: renderCondition })=>{
    const { isTransitionInState: isTransitionInState } = (0, $fIw44.useMinimizableModal)();
    if ((0, $kk5YU.isReducedMotion)()) {
        if (renderCondition) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
        return null;
    }
    const shouldRenderModalView = renderCondition && isTransitionInState([
        'mini',
        'minimized'
    ], (0, $dIu0P.TransitionState).EXITED);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $956it.default), null, shouldRenderModalView && children);
};

});

parcelRegister("j8z2z", function(module, exports) {

$parcel$export(module.exports, "Modal", () => $23be2da876eab83e$export$2b77a92f1a5ad772);

var $eJOHy = parcelRequire("eJOHy");

var $ik0CA = parcelRequire("ik0CA");

var $kk5YU = parcelRequire("kk5YU");

var $2ZGUP = parcelRequire("2ZGUP");

var $aC4Bh = parcelRequire("aC4Bh");

var $gCeeo = parcelRequire("gCeeo");
var $8Plmb = parcelRequire("8Plmb");

var $fIw44 = parcelRequire("fIw44");

var $dIu0P = parcelRequire("dIu0P");

var $75RwT = parcelRequire("75RwT");
const $23be2da876eab83e$export$2b77a92f1a5ad772 = ({ children: children, components: components, onClose: onCloseFromProps, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick, 'data-testid': dataTestId, ...rest })=>{
    const { onClose: onClose, isTransitionInState: isTransitionInState } = (0, $fIw44.useMinimizableModal)();
    const { onFinishAnimation: onFinishAnimation } = (0, $75RwT.useTransitionView)('modal', true);
    const onOpenComplete = ()=>{
        onFinishAnimation('entering');
    };
    const onCloseComplete = ()=>{
        onFinishAnimation('exiting');
    };
    const isViewEntered = isTransitionInState([
        'modal'
    ], (0, $dIu0P.TransitionState).ENTERED);
    const { Header: Header = (0, $eJOHy.Fragment), Body: Body = (0, $ik0CA.default), Footer: Footer = (0, $eJOHy.Fragment) } = components || {};
    const onMount = (0, $eJOHy.useCallback)((event)=>{
        (0, $gCeeo.fireScreenAnalyticsDeferred)(event, {
            isReducedMotion: (0, $kk5YU.isReducedMotion)()
        });
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2ZGUP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aC4Bh.JiraModal), {
        width: "large",
        height: undefined,
        autoFocus: false,
        onClose: onCloseFromProps || onClose,
        shouldCloseOnEscapePress: true,
        shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
        testId: isViewEntered ? dataTestId || 'minimizable-modal.ui.modal-container.modal' : undefined,
        messageId: "minimizable-modal.ui.modal-container.modal.modal-dialog",
        messageType: "transactional",
        onOpenComplete: onOpenComplete,
        onCloseComplete: onCloseComplete,
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Plmb.MountEvent), {
        onMount: onMount
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Header, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Body, null, children === undefined ? null : children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Footer, null)));
};

});


parcelRegister("bSuVk", function(module, exports) {

$parcel$export(module.exports, "ReParenter", () => $fd1cd4c21893dac4$export$c74b59dc6ffb3f46);

var $eJOHy = parcelRequire("eJOHy");

var $9hr9v = parcelRequire("9hr9v");

var $3rigy = parcelRequire("3rigy");
const $fd1cd4c21893dac4$export$c74b59dc6ffb3f46 = ({ children: children, Parent: Parent })=>{
    const portalNode = (0, $eJOHy.useMemo)(()=>(0, $9hr9v.createHtmlPortalNode)(), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9hr9v.InPortal), {
        node: portalNode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3rigy.Layering), {
        isDisabled: false
    }, children)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Parent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9hr9v.OutPortal), {
        node: portalNode
    })));
};

});
parcelRegister("9hr9v", function(module, exports) {

$parcel$export(module.exports, "InPortal", () => $6c1ac37ef4f55c22$export$82590d10982cb172);
$parcel$export(module.exports, "OutPortal", () => $6c1ac37ef4f55c22$export$6677f336551ad316);
$parcel$export(module.exports, "createHtmlPortalNode", () => $6c1ac37ef4f55c22$export$c08cb61f0c65e152);

var $eJOHy = parcelRequire("eJOHy");

var $aQK2r = parcelRequire("aQK2r");
var $6c1ac37ef4f55c22$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
// Internally, the portalNode must be for either HTML or SVG elements
var $6c1ac37ef4f55c22$var$ELEMENT_TYPE_HTML = 'html';
var $6c1ac37ef4f55c22$var$ELEMENT_TYPE_SVG = 'svg';
// ReactDOM can handle several different namespaces, but they're not exported publicly
// https://github.com/facebook/react/blob/b87aabdfe1b7461e7331abb3601d9e6bb27544bc/packages/react-dom/src/shared/DOMNamespaces.js#L8-L10
var $6c1ac37ef4f55c22$var$SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
var $6c1ac37ef4f55c22$var$validateElementType = function(domElement, elementType) {
    if (elementType === $6c1ac37ef4f55c22$var$ELEMENT_TYPE_HTML) return domElement instanceof HTMLElement;
    if (elementType === $6c1ac37ef4f55c22$var$ELEMENT_TYPE_SVG) return domElement instanceof SVGElement;
    throw new Error("Unrecognized element type \"" + elementType + "\" for validateElementType.");
};
// This is the internal implementation: the public entry points set elementType to an appropriate value
var $6c1ac37ef4f55c22$var$createPortalNode = function(elementType, options) {
    var initialProps = {};
    var parent;
    var lastPlaceholder;
    var element;
    if (elementType === $6c1ac37ef4f55c22$var$ELEMENT_TYPE_HTML) element = document.createElement('div');
    else if (elementType === $6c1ac37ef4f55c22$var$ELEMENT_TYPE_SVG) element = document.createElementNS($6c1ac37ef4f55c22$var$SVG_NAMESPACE, 'g');
    else throw new Error("Invalid element type \"" + elementType + "\" for createPortalNode: must be \"html\" or \"svg\".");
    if (options && typeof options === "object") for(var _i = 0, _a = Object.entries(options.attributes); _i < _a.length; _i++){
        var _b = _a[_i], key = _b[0], value = _b[1];
        element.setAttribute(key, value);
    }
    var portalNode = {
        element: element,
        elementType: elementType,
        setPortalProps: function(props) {
            initialProps = props;
        },
        getInitialPortalProps: function() {
            return initialProps;
        },
        mount: function(newParent, newPlaceholder) {
            if (newPlaceholder === lastPlaceholder) // Already mounted - noop.
            return;
            portalNode.unmount();
            // To support SVG and other non-html elements, the portalNode's elementType needs to match
            // the elementType it's being rendered into
            if (newParent !== parent) {
                if (!$6c1ac37ef4f55c22$var$validateElementType(newParent, elementType)) throw new Error("Invalid element type for portal: \"" + elementType + "\" portalNodes must be used with " + elementType + " elements, but OutPortal is within <" + newParent.tagName + ">.");
            }
            newParent.replaceChild(portalNode.element, newPlaceholder);
            parent = newParent;
            lastPlaceholder = newPlaceholder;
        },
        unmount: function(expectedPlaceholder) {
            if (expectedPlaceholder && expectedPlaceholder !== lastPlaceholder) // Skip unmounts for placeholders that aren't currently mounted
            // They will have been automatically unmounted already by a subsequent mount()
            return;
            if (parent && lastPlaceholder) {
                parent.replaceChild(lastPlaceholder, portalNode.element);
                parent = undefined;
                lastPlaceholder = undefined;
            }
        }
    };
    return portalNode;
};
var $6c1ac37ef4f55c22$export$82590d10982cb172 = /** @class */ function(_super) {
    $6c1ac37ef4f55c22$var$__extends(InPortal, _super);
    function InPortal(props) {
        var _this = _super.call(this, props) || this;
        _this.addPropsChannel = function() {
            Object.assign(_this.props.node, {
                setPortalProps: function(props) {
                    // Rerender the child node here if/when the out portal props change
                    _this.setState({
                        nodeProps: props
                    });
                }
            });
        };
        _this.state = {
            nodeProps: _this.props.node.getInitialPortalProps()
        };
        return _this;
    }
    InPortal.prototype.componentDidMount = function() {
        this.addPropsChannel();
    };
    InPortal.prototype.componentDidUpdate = function() {
        this.addPropsChannel();
    };
    InPortal.prototype.render = function() {
        var _this = this;
        var _a = this.props, children = _a.children, node = _a.node;
        return $aQK2r.createPortal($eJOHy.Children.map(children, function(child) {
            if (!$eJOHy.isValidElement(child)) return child;
            return $eJOHy.cloneElement(child, _this.state.nodeProps);
        }), node.element);
    };
    return InPortal;
}($eJOHy.PureComponent);
var $6c1ac37ef4f55c22$export$6677f336551ad316 = /** @class */ function(_super) {
    $6c1ac37ef4f55c22$var$__extends(OutPortal, _super);
    function OutPortal(props) {
        var _this = _super.call(this, props) || this;
        _this.placeholderNode = $eJOHy.createRef();
        _this.passPropsThroughPortal();
        return _this;
    }
    OutPortal.prototype.passPropsThroughPortal = function() {
        var propsForTarget = Object.assign({}, this.props, {
            node: undefined
        });
        this.props.node.setPortalProps(propsForTarget);
    };
    OutPortal.prototype.componentDidMount = function() {
        var node = this.props.node;
        this.currentPortalNode = node;
        var placeholder = this.placeholderNode.current;
        var parent = placeholder.parentNode;
        node.mount(parent, placeholder);
        this.passPropsThroughPortal();
    };
    OutPortal.prototype.componentDidUpdate = function() {
        // We re-mount on update, just in case we were unmounted (e.g. by
        // a second OutPortal, which has now been removed)
        var node = this.props.node;
        // If we're switching portal nodes, we need to clean up the current one first.
        if (this.currentPortalNode && node !== this.currentPortalNode) {
            this.currentPortalNode.unmount(this.placeholderNode.current);
            this.currentPortalNode = node;
        }
        var placeholder = this.placeholderNode.current;
        var parent = placeholder.parentNode;
        node.mount(parent, placeholder);
        this.passPropsThroughPortal();
    };
    OutPortal.prototype.componentWillUnmount = function() {
        var node = this.props.node;
        node.unmount(this.placeholderNode.current);
    };
    OutPortal.prototype.render = function() {
        // Render a placeholder to the DOM, so we can get a reference into
        // our location in the DOM, and swap it out for the portaled node.
        // A <div> placeholder works fine even for SVG.
        return $eJOHy.createElement("div", {
            ref: this.placeholderNode
        });
    };
    return OutPortal;
}($eJOHy.PureComponent);
var $6c1ac37ef4f55c22$export$c08cb61f0c65e152 = $6c1ac37ef4f55c22$var$createPortalNode.bind(null, $6c1ac37ef4f55c22$var$ELEMENT_TYPE_HTML);
var $6c1ac37ef4f55c22$export$6ac597db63d00ad3 = $6c1ac37ef4f55c22$var$createPortalNode.bind(null, $6c1ac37ef4f55c22$var$ELEMENT_TYPE_SVG);

});



parcelRegister("cnV9A", function(module, exports) {

$parcel$export(module.exports, "default", () => $451647482cacc1cd$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $goZPP = parcelRequire("goZPP");
var $cA0Y2 = parcelRequire("cA0Y2");

var $86tBw = parcelRequire("86tBw");

var $1ozd5 = parcelRequire("1ozd5");

var $kseeK = parcelRequire("kseeK");

var $k71qx = parcelRequire("k71qx");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $epTsa = parcelRequire("epTsa");

var $lRq8t = parcelRequire("lRq8t");

var $jipjz = parcelRequire("jipjz");

var $gCeeo = parcelRequire("gCeeo");

var $6u3jg = parcelRequire("6u3jg");


var $cFxTI = parcelRequire("cFxTI");

var $fkJtk = parcelRequire("fkJtk");

var $d1P5P = parcelRequire("d1P5P");

const $451647482cacc1cd$var$PassThroughWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
const $451647482cacc1cd$var$ModalFooter = (props)=>{
    const { isMiniVariant: isMiniVariant, children: children } = props;
    if (isMiniVariant) /**
     * We need to use our own footer and not the atlaskit one since the atlaskit one
     * needs to be within ModalDialog to get context or else it crashes
     */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $451647482cacc1cd$var$miniFooterStyles,
        testId: "issue-create.common.ui.footer.footer-mini"
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kseeK.default), null, children);
};
const $451647482cacc1cd$export$a06f1c675e846f6f = (props)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { onClose: onClose, onSubmit: onSubmit, isSubmitting: isSubmitting, isOperationInProgress: isOperationInProgress = false, onCreateAnotherChange: onCreateAnotherChange, canCreateAnotherIssue: canCreateAnotherIssue, shouldDisableSubmit: shouldDisableSubmit = false, createdIssues: createdIssues, variant: variant = (0, $fkJtk.GIC_VARIANTS).DEFAULT, displayCreateAnotherIssueToggle: newDisplayCreateAnotherIssueToggle, showIssuesCreated: showIssuesCreated, showCancelButton: showCancelButton } = props;
    const numberOfIssuesCreated = createdIssues.length;
    let displayCreateAnotherIssueToggle = newDisplayCreateAnotherIssueToggle;
    const isGICPositioningEnabled = (0, $6u3jg.useIsGICPositioningEnabled)();
    const isMiniVariant = isGICPositioningEnabled() && variant === (0, $fkJtk.GIC_VARIANTS).MINI;
    if (!isGICPositioningEnabled()) {
        const [{ displayCreateAnotherIssueToggle: oldDisplayCreateAnotherIssueToggle }] = // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $jipjz.useTriggerIssueCreateModal)();
        displayCreateAnotherIssueToggle = oldDisplayCreateAnotherIssueToggle;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onViewIssuesLinkClicked = (_, analyticsEvent)=>{
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'viewIssue');
    };
    const getPrimaryButtonCopy = ()=>{
        if (isMiniVariant) return (0, $d1P5P.default).createButtonInMiniView;
        return (0, $d1P5P.default).createButton;
    };
    const IssuesCreatedTooltip = isMiniVariant ? (0, $k71qx.default) : $451647482cacc1cd$var$PassThroughWrapper;
    const showIssueCreatedTooltip = Boolean(numberOfIssuesCreated) && Boolean(showIssuesCreated);
    const cancelBtn = props?.dismissModalEntryPointWrapper ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(props.dismissModalEntryPointWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "subtle-link",
        onClick: onClose,
        isDisabled: isSubmitting,
        testId: "issue-create.common.ui.footer.cancel-button",
        interactionName: "global-issue.create-modal.cancel"
    }, formatMessage((0, $d1P5P.default).cancelButton))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "subtle-link",
        onClick: onClose,
        isDisabled: isSubmitting,
        testId: "issue-create.common.ui.footer.cancel-button",
        interactionName: "global-issue.create-modal.cancel"
    }, formatMessage((0, $d1P5P.default).cancelButton));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($451647482cacc1cd$var$ModalFooter, {
        isMiniVariant: isMiniVariant
    }, displayCreateAnotherIssueToggle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $86tBw.default), {
        onChange: onCreateAnotherChange,
        label: formatMessage((0, $d1P5P.default).createAnother),
        isChecked: canCreateAnotherIssue,
        isDisabled: shouldDisableSubmit,
        testId: "issue-create.common.ui.footer.checkbox"
    }), showIssueCreatedTooltip && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(IssuesCreatedTooltip, {
        content: formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $d1P5P.default).issuesCreatedLinkIssueTermRefresh : (0, $d1P5P.default).issuesCreatedLink, {
            issueCount: numberOfIssuesCreated
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($451647482cacc1cd$var$IssueLinkContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1ozd5))), {
        label: "",
        LEGACY_size: "medium",
        spacing: "spacious",
        color: "var(--ds-icon-success, #22A06B)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "subtle-link",
        spacing: "none",
        href: (0, $cFxTI.getIssueDiscoveryUrl)(createdIssues),
        target: "_blank",
        onClick: onViewIssuesLinkClicked,
        testId: "issue-create.common.ui.footer.created-issue-link",
        interactionName: "global-issue.create-modal.created-issue-link"
    }, isMiniVariant ? numberOfIssuesCreated : formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $d1P5P.default).issuesCreatedLinkIssueTermRefresh : (0, $d1P5P.default).issuesCreatedLink, {
        issueCount: numberOfIssuesCreated
    })))), (!isMiniVariant || showCancelButton) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($451647482cacc1cd$var$CloseButtonContainer, null, cancelBtn), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cA0Y2.default), {
        appearance: "primary",
        onClick: onSubmit,
        isLoading: isSubmitting || isOperationInProgress,
        isDisabled: isSubmitting || shouldDisableSubmit,
        type: "submit",
        form: (0, $3838db8cf80b284d$export$2d077da71c26c1c5),
        testId: "issue-create.common.ui.footer.create-button",
        interactionName: "global-issue.create-modal.submit"
    }, isGICPositioningEnabled() ? formatMessage(getPrimaryButtonCopy()) : formatMessage((0, $d1P5P.default).createButton)));
};
var $451647482cacc1cd$export$2e2bcd8739ae039 // eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
 = $451647482cacc1cd$export$a06f1c675e846f6f;
const $451647482cacc1cd$var$CloseButtonContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_18u01wug _2hwxu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $451647482cacc1cd$var$IssueLinkContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _18u0pxbi _2hwx1wug",
            __cmplp.className
        ])
    });
});
const $451647482cacc1cd$var$miniFooterStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 'space.050',
    flex: '0 0 auto',
    marginTop: 'space.0',
    marginBottom: 'space.0',
    marginLeft: 'space.150',
    marginRight: 'space.150',
    paddingTop: 'space.250',
    paddingBottom: 'space.250',
    paddingLeft: 'space.100',
    paddingRight: 'space.100',
    borderTop: `0.5px solid ${"var(--ds-border, #091E4224)"}`,
    boxShadow: 'elevation.shadow.overflow.spread'
});

});
parcelRegister("fkJtk", function(module, exports) {

$parcel$export(module.exports, "GIC_VARIANTS", () => $3735faf89f76fe35$export$409069fd677aa1c3);
const $3735faf89f76fe35$export$409069fd677aa1c3 = {
    DEFAULT: 'default',
    MINI: 'mini'
};

});

parcelRegister("d1P5P", function(module, exports) {

$parcel$export(module.exports, "default", () => $327f1f2e85fa6b68$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $327f1f2e85fa6b68$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    createButton: {
        "id": "issue-create.common.footer.create-button",
        "defaultMessage": "Create"
    },
    createButtonInMiniView: {
        "id": "issue-create.common.footer.create-button-in-mini-view",
        "defaultMessage": "Create"
    },
    cancelButton: {
        "id": "issue-create.common.footer.cancel-button",
        "defaultMessage": "Cancel"
    },
    createAnother: {
        "id": "issue-create.common.footer.create-another-fade",
        "defaultMessage": "Create another"
    },
    copyToNextIssue: {
        "id": "issue-create.common.footer.copy-to-next-issue",
        "defaultMessage": "Copy to next issue"
    },
    copyToNextIssueIssueTermRefresh: {
        "id": "issue-create.common.footer.copy-to-next-issue-issue-term-refresh",
        "defaultMessage": "Copy to next work item"
    },
    issuesCreatedLink: {
        "id": "issue-create.common.footer.issues-created-link",
        "defaultMessage": "{issueCount} {issueCount, plural, one {issue} other {issues}} created"
    },
    issuesCreatedLinkIssueTermRefresh: {
        "id": "issue-create.common.footer.issues-created-link-issue-term-refresh",
        "defaultMessage": "{issueCount} {issueCount, plural, one {work item} other {work items}} created"
    },
    createDropdownOptionCreateAnother: {
        "id": "issue-create.common.footer.create-dropdown-option-create-another",
        "defaultMessage": "Create and start another"
    },
    createDropdownOptionCopy: {
        "id": "issue-create.common.footer.create-dropdown-option-copy",
        "defaultMessage": "Create and copy"
    },
    toggleOnTooltip: {
        "id": "issue-create.common.footer.toggle-on-tooltip",
        "defaultMessage": "Toggle off to finish creating issues."
    },
    toggleOnTooltipIssueTermRefresh: {
        "id": "issue-create.common.footer.toggle-on-tooltip-issue-term-refresh",
        "defaultMessage": "Toggle off to finish"
    },
    toggleOffTooltip: {
        "id": "issue-create.common.footer.toggle-off-tooltip",
        "defaultMessage": "After selecting {createButton}, immediately start a new issue with these details and fields."
    },
    toggleOffTooltipIssueTermRefresh: {
        "id": "issue-create.common.footer.toggle-off-tooltip-issue-term-refresh",
        "defaultMessage": "After selecting {createButton}, immediately start a new work item with these details and fields."
    }
});

});


parcelRegister("73XNv", function(module, exports) {

$parcel$export(module.exports, "useMinimizableModalWrapperProps", () => $d92ebccf766be133$export$48c73e38324bf86b);
$parcel$export(module.exports, "MinimizableModalWrapperPropsProvider", () => $d92ebccf766be133$export$a81052d98ff4e3f6);

var $eJOHy = parcelRequire("eJOHy");
// Need to use this context to prevent re-render flashes in the modal wrapper
const $d92ebccf766be133$var$MinimizableModalWrapperPropsContext = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $d92ebccf766be133$export$48c73e38324bf86b = ()=>{
    const context = (0, $eJOHy.useContext)($d92ebccf766be133$var$MinimizableModalWrapperPropsContext);
    if (context === undefined || context === null) throw new Error('No provider for useMinimizableModalWrapperProps');
    return context;
};
const $d92ebccf766be133$export$a81052d98ff4e3f6 = ({ children: children, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d92ebccf766be133$var$MinimizableModalWrapperPropsContext.Provider, {
        value: rest
    }, children);

});

parcelRegister("gO18D", function(module, exports) {

$parcel$export(module.exports, "MinimizableFullscreen", () => $46ec39a4c5123c14$export$b31191b6904db55b);

var $eJOHy = parcelRequire("eJOHy");

var $d8Md5 = parcelRequire("d8Md5");

var $jipjz = parcelRequire("jipjz");

var $fkJtk = parcelRequire("fkJtk");

var $cnV9A = parcelRequire("cnV9A");

var $73XNv = parcelRequire("73XNv");
const $46ec39a4c5123c14$export$b31191b6904db55b = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, ...rest }, ref)=>{
    const { onModalCloseWithConfirm: onModalCloseWithConfirm, onSubmit: onSubmit, isSubmitting: isSubmitting, isOperationInProgress: isOperationInProgress, canCreateAnotherIssue: canCreateAnotherIssue, onCreateAnotherChange: onCreateAnotherChange, getShouldDisableSubmit: getShouldDisableSubmit, createdIssues: createdIssues, displayCreateAnotherIssueToggle: displayCreateAnotherIssueToggle, dismissModalEntryPointWrapper: dismissModalEntryPointWrapper } = (0, $73XNv.useMinimizableModalWrapperProps)();
    const [{ containerStyle: containerStyle }] = (0, $jipjz.useTriggerIssueCreateModal)();
    return(// @ts-expect-error - TS2746 - This JSX tag's 'children' prop expects a single child of type 'HTMLCollection', but multiple children were provided.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d8Md5.Fullscreen), {
        ref: ref,
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d8Md5.FullscreenBody), {
        containerStyle: containerStyle
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cnV9A.default), {
        onClose: onModalCloseWithConfirm('cancel'),
        onSubmit: onSubmit,
        isSubmitting: isSubmitting,
        isOperationInProgress: isOperationInProgress,
        canCreateAnotherIssue: canCreateAnotherIssue,
        onCreateAnotherChange: onCreateAnotherChange,
        shouldDisableSubmit: getShouldDisableSubmit(),
        createdIssues: createdIssues,
        variant: (0, $fkJtk.GIC_VARIANTS).MINI,
        displayCreateAnotherIssueToggle: displayCreateAnotherIssueToggle,
        containerStyle: containerStyle,
        showCancelButton: true,
        dismissModalEntryPointWrapper: dismissModalEntryPointWrapper
    })));
});

});

parcelRegister("iz24g", function(module, exports) {

$parcel$export(module.exports, "MinimizableModalMini", () => $7243383c4a5d62b3$export$c752bd88450266e0);

var $eJOHy = parcelRequire("eJOHy");

var $7W9z8 = parcelRequire("7W9z8");

var $ln6Iy = parcelRequire("ln6Iy");

var $eDBhy = parcelRequire("eDBhy");

var $c7o2k = parcelRequire("c7o2k");

var $jipjz = parcelRequire("jipjz");

var $hBHUL = parcelRequire("hBHUL");

var $2aY2d = parcelRequire("2aY2d");

var $80UiT = parcelRequire("80UiT");

var $fkJtk = parcelRequire("fkJtk");

var $cnV9A = parcelRequire("cnV9A");

var $cInSM = parcelRequire("cInSM");

var $91N9q = parcelRequire("91N9q");

var $73XNv = parcelRequire("73XNv");

var $8UZ3s = parcelRequire("8UZ3s");
const $7243383c4a5d62b3$export$c752bd88450266e0 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, summaryValue: summaryValue, ...rest }, ref)=>{
    const { onModalCloseWithConfirm: onModalCloseWithConfirm, onSubmit: onSubmit, isSubmitting: isSubmitting, isOperationInProgress: isOperationInProgress, canCreateAnotherIssue: canCreateAnotherIssue, onCreateAnotherChange: onCreateAnotherChange, getShouldDisableSubmit: getShouldDisableSubmit, createdIssues: createdIssues, displayCreateAnotherIssueToggle: displayCreateAnotherIssueToggle, selectedIssueType: selectedIssueType, projectType: projectType, dismissModalEntryPointWrapper: dismissModalEntryPointWrapper } = (0, $73XNv.useMinimizableModalWrapperProps)();
    const issueTypeRef = (0, $eJOHy.useRef)(selectedIssueType);
    const { parseSummaryValue: parseSummaryValue } = (0, $91N9q.useParseSummaryValue)();
    const [shouldRenderMiniModalSpotlight, setShouldRenderMiniModalSpotlight] = (0, $eJOHy.useState)(false);
    const [{ shouldShowMiniModalSpotlight: shouldShowMiniModalSpotlight, triggerPointKey: triggerPointKey }, { dismissModalSpotlight: dismissModalSpotlight }] = (0, $jipjz.useTriggerIssueCreateModal)();
    const [userTraits, { setUserTraits: setUserTraits }] = (0, $7W9z8.useUserTraits)();
    const fetchUserTraits = (0, $7W9z8.useFetchUserTraitsOld)();
    const setUserTraitsIfNotAvailable = (0, $eJOHy.useCallback)(async ()=>{
        const newTraits = await fetchUserTraits();
        // We must explicitly check for false because fetchUserTraits returns "false" when pending, and "null" when traits are empty.
        if (newTraits !== false) setUserTraits(newTraits);
    }, [
        fetchUserTraits,
        setUserTraits
    ]);
    const { updateIsDiscoPushComplete: updateIsDiscoPushComplete } = (0, $80UiT.usePersistentIssueCreateModalViewResource)();
    const { data: projectContext } = (0, $2aY2d.useProjectContext)();
    const markMiniModalAsSeen = (0, $eJOHy.useCallback)(()=>{
        try {
            const shouldDismiss = (0, $hBHUL.isPartOfDiscoverabilityTriggers)(triggerPointKey) && projectContext?.projectType !== (0, $ln6Iy.SERVICE_DESK_PROJECT);
            if (shouldDismiss) {
                updateIsDiscoPushComplete(true);
                dismissModalSpotlight();
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $eDBhy.fireIssueCreateErrorAnalytics)({
                error: error,
                meta: {
                    id: 'setMiniModalSpotlightPreference',
                    packageName: 'jiraIssueCreate'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
    }, [
        dismissModalSpotlight,
        triggerPointKey,
        updateIsDiscoPushComplete,
        projectContext?.projectType
    ]);
    (0, $eJOHy.useEffect)(()=>()=>{
            markMiniModalAsSeen();
        }, [
        markMiniModalAsSeen
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (selectedIssueType) issueTypeRef.current = selectedIssueType;
    }, [
        selectedIssueType
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!userTraits?.attributes?.length && userTraits?.attributes !== null) setUserTraitsIfNotAvailable();
        else {
            const accountCreationDate = userTraits?.attributes?.find((trait)=>trait?.name === 'jira_first_active')?.value;
            const aWeekAgo = new Date(Date.now() - 604800000);
            let isNewUser = false;
            if (accountCreationDate && typeof accountCreationDate === 'string') isNewUser = new Date(accountCreationDate) > aWeekAgo;
            setShouldRenderMiniModalSpotlight(!!shouldShowMiniModalSpotlight && !isNewUser);
        }
    }, [
        userTraits,
        shouldShowMiniModalSpotlight,
        setUserTraitsIfNotAvailable
    ]);
    return(// @ts-expect-error - TS2746 - This JSX tag's 'children' prop expects a single child of type 'HTMLCollection', but multiple children were provided.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c7o2k.Mini), {
        ref: ref,
        ...rest
    }, shouldRenderMiniModalSpotlight && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8UZ3s.SpotlightContainer), {
        shouldShowSpotlight: shouldRenderMiniModalSpotlight,
        onCloseSpotlight: markMiniModalAsSeen
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cInSM.MiniHeader), {
        title: parseSummaryValue(summaryValue, issueTypeRef.current?.label),
        isItalic: !summaryValue,
        iconUrl: issueTypeRef.current?.iconUrl,
        showHeaderIcon: projectType !== (0, $ln6Iy.SERVICE_DESK_PROJECT),
        dismissModalEntryPointWrapper: dismissModalEntryPointWrapper
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c7o2k.MiniBody), null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cnV9A.default), {
        onClose: onModalCloseWithConfirm('cancel'),
        onSubmit: onSubmit,
        isSubmitting: isSubmitting,
        isOperationInProgress: isOperationInProgress,
        canCreateAnotherIssue: canCreateAnotherIssue,
        onCreateAnotherChange: onCreateAnotherChange,
        shouldDisableSubmit: getShouldDisableSubmit(),
        createdIssues: createdIssues,
        variant: (0, $fkJtk.GIC_VARIANTS).MINI,
        displayCreateAnotherIssueToggle: displayCreateAnotherIssueToggle
    })));
});

});
parcelRegister("cInSM", function(module, exports) {

$parcel$export(module.exports, "MiniHeader", () => $c1b64d40de120caf$export$1d38987b2afcba7e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $bQyn2 = parcelRequire("bQyn2");

var $5IfL0 = parcelRequire("5IfL0");

var $6XJko = parcelRequire("6XJko");
const $c1b64d40de120caf$var$renderIcon = (iconUrl)=>{
    if ((0, $6XJko.isVisualRefreshEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        testId: "issue-create.common.ui.minimizable-modal-mini-header.icon-container",
        xcss: $c1b64d40de120caf$var$containerStylesWithVR
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bQyn2.default), {
        width: 16,
        url: iconUrl
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c1b64d40de120caf$var$IconContainer, {
        "data-testid": "issue-create.common.ui.minimizable-modal-mini-header.icon-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bQyn2.default), {
        width: 16,
        url: iconUrl
    }));
};
const $c1b64d40de120caf$export$1d38987b2afcba7e = ({ title: title, iconUrl: iconUrl, isItalic: isItalic, showHeaderIcon: showHeaderIcon, dismissModalEntryPointWrapper: dismissModalEntryPointWrapper })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5IfL0.MiniHeader), {
        dismissModalEntryPointWrapper: dismissModalEntryPointWrapper
    }, showHeaderIcon && iconUrl && $c1b64d40de120caf$var$renderIcon(iconUrl), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c1b64d40de120caf$var$MinimizableModalTitle, {
        /* eslint-disable-next-line jira/integration/test-id-by-folder-structure */ testId: "minimizable-modal.ui.modal-container-mini-header.mini-header",
        // @ts-expect-error - TS2322 - Type '{ children: string; "data-testid": string; isItalic: boolean; }' is not assignable to type 'IntrinsicAttributes & IntrinsicClassAttributes<Component<ThemedOuterStyledProps<WithOptionalTheme<{ children?: ReactNode; }, any>, any>, any, any>> & Readonly<...>'.
        isItalic: isItalic
    }, title));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c1b64d40de120caf$var$MinimizableModalTitle = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $5IfL0.ModalTitle), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c8nbxd _ca0qidpf _u5f3ftgi _n3tdidpf _19bvftgi _1reo15vq _18m915vq _1e0ccj1k _syaz1fxt _1yyjcs5v _sudp1e54 _o5724jg8 _1bto4jg8",
            __cmplp.className
        ])
    });
});
const $c1b64d40de120caf$var$IconContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsb7vkz _4t3i7vkz _2hwxu2gc",
            __cmplp.className
        ])
    });
});
const $c1b64d40de120caf$var$containerStylesWithVR = (0, $1DXK0.xcss)({
    width: "var(--ds-space-300, 24px)",
    height: "var(--ds-space-300, 24px)",
    marginRight: 'space.050',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});

});
parcelRegister("bQyn2", function(module, exports) {

$parcel$export(module.exports, "default", () => $69a57831c94bcd51$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $dPMMf = parcelRequire("dPMMf");
const $69a57831c94bcd51$var$defaultIconSize = (0, $dPMMf.gridSize) * 2;
/* Represents an asynchronous icon loader that handles loading of icons from URLs with error handling.
 * It displays the icon fetched from the provided URL. In case of an error or if the URL is undefined,
 * a fallback UI component or placeholder is displayed.
 * This component accepts various props like URL, title, alt text, dimensions, and a fallback component
 * to customize the behavior and presentation of the loaded or placeholder icon.
 * The component also includes functionality to prevent the icon from being draggable.
 */ const $69a57831c94bcd51$var$AsyncIcon = /*#__PURE__*/ (0, $eJOHy.memo)(({ url: url, title: title, alt: alt, width: width, height: height, fallback: fallback })=>{
    const [isBroken, setIsBroken] = (0, $eJOHy.useState)(false);
    const onError = (0, $eJOHy.useCallback)(()=>{
        setIsBroken(true);
    }, []);
    const convertSize = (0, $eJOHy.useCallback)((size)=>size ? `${size}px` : '0', []);
    if (isBroken && fallback) return fallback();
    const convertedWidth = convertSize(width ?? $69a57831c94bcd51$var$defaultIconSize);
    const convertedHeight = convertSize(height ?? $69a57831c94bcd51$var$defaultIconSize);
    if (url) return /*#__PURE__*/ $eJOHy.createElement($69a57831c94bcd51$var$Image, {
        src: url,
        width: convertedWidth,
        height: convertedHeight,
        title: title ?? undefined,
        alt: alt ?? '',
        onError: onError,
        /**
     * Disabling dragging so drags happen on the parent instead of this icon.
     */ draggable: false,
        "data-vc": "common-components-async-icon"
    });
    return /*#__PURE__*/ $eJOHy.createElement("div", {
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            height: convertedHeight,
            width: convertedWidth
        },
        "data-testid": "common-components-async-icon.placeholder",
        className: (0, $hcewu.default)([
            "_2rko1l7b _16jlidpf _1o9zidpf _i0dl1wug _1e0c1txw _bfhk1d5g"
        ])
    });
});
const $69a57831c94bcd51$var$placeholderStyles = null;
// Firefox displays the alt text when the image can't load, the narrow provided width
// means this alt text leaks into the summary vertically if overflow is allowed
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $69a57831c94bcd51$var$Image = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _16jlidpf _1o9zidpf _i0dl1wug",
            __cmplp.className
        ])
    });
});
$69a57831c94bcd51$var$AsyncIcon.displayName = 'AsyncIcon';
var $69a57831c94bcd51$export$2e2bcd8739ae039 = $69a57831c94bcd51$var$AsyncIcon;

});


parcelRegister("91N9q", function(module, exports) {

$parcel$export(module.exports, "useParseSummaryValue", () => $d9bf8a964ba3e1fa$export$f753c33a187faf7c);

var $epTsa = parcelRequire("epTsa");

var $lRq8t = parcelRequire("lRq8t");

var $bSiPa = parcelRequire("bSiPa");
const $d9bf8a964ba3e1fa$export$f753c33a187faf7c = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    // TODO: remove undefined prop type when cleaning up restore-mini-view-summary_y0gl1
    const parseSummaryValue = (summaryValue, issueType)=>{
        if (summaryValue === null) return issueType ? formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $bSiPa.default).noSummaryWithIssueTypeIssueTermRefresh : (0, $bSiPa.default).noSummaryWithIssueType, {
            issueType: issueType
        }) : '';
        if (summaryValue) return summaryValue;
        return issueType ? formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $bSiPa.default).noSummaryWithIssueTypeIssueTermRefresh : (0, $bSiPa.default).noSummaryWithIssueType, {
            issueType: issueType
        }) : formatMessage((0, $bSiPa.default).noSummary);
    };
    return {
        parseSummaryValue: parseSummaryValue
    };
};

});

parcelRegister("8UZ3s", function(module, exports) {

$parcel$export(module.exports, "SpotlightContainer", () => $3912fa4011c0f3af$export$d0f55839b708c0a0);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $3l2IB = parcelRequire("3l2IB");

var $kDaaB = parcelRequire("kDaaB");
var $lRq8t = parcelRequire("lRq8t");

var $bSiPa = parcelRequire("bSiPa");
const $3912fa4011c0f3af$export$d0f55839b708c0a0 = ({ shouldShowSpotlight: shouldShowSpotlight, onCloseSpotlight: onCloseSpotlight })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3912fa4011c0f3af$var$SpotlightPopoverWrapper, {
        "data-testid": "issue-create.ui.modal.modal-wrapper.minimizable-modal-mini.modal-spotlight.wrapper"
    }, shouldShowSpotlight && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3l2IB.default), {
        heading: formatMessage((0, $bSiPa.default).miniModalSpotlightHeading),
        width: 290,
        actions: [
            {
                onClick: onCloseSpotlight,
                text: formatMessage((0, $bSiPa.default).miniModalSpotlightActionMessage)
            }
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), {
        ...(0, $bSiPa.default).miniModalSpotlightMessage,
        values: {
            br: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("br", null))
        }
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3912fa4011c0f3af$var$SpotlightPopoverWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswstnw _154iidpf _1ltv1vvt",
            __cmplp.className
        ])
    });
});

});


parcelRegister("6VtvU", function(module, exports) {

$parcel$export(module.exports, "MinimizableModalMinimized", () => $63225a137d0d3e7a$export$72c64a34c513900);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $cdbP5 = parcelRequire("cdbP5");

var $bQyn2 = parcelRequire("bQyn2");

var $ln6Iy = parcelRequire("ln6Iy");

var $kwvP4 = parcelRequire("kwvP4");

var $91N9q = parcelRequire("91N9q");

var $73XNv = parcelRequire("73XNv");
const $63225a137d0d3e7a$export$72c64a34c513900 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ className: className, summaryValue: summaryValue }, ref)=>{
    const { parseSummaryValue: parseSummaryValue } = (0, $91N9q.useParseSummaryValue)();
    const { selectedIssueType: selectedIssueType, projectType: projectType } = (0, $73XNv.useMinimizableModalWrapperProps)();
    return(// @ts-expect-error - TS2322 - Type '((instance: MinimizableModalMinimizedProps | null) => void) | MutableRefObject<MinimizableModalMinimizedProps | null> | null' is not assignable to type '((string | ((instance: Component<ThemedOuterStyledProps<DiffBetween<{ className: any; }, Omit<HTMLElement & RefAttributes<MinimizedContainerProps>, "theme"> & { ...; }>, any>, any, any> | null) => void) | RefObject<...>) & (((instance: MinimizedContainerProps | null) => void) | RefObject<...>)) | null | undefined'.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($63225a137d0d3e7a$var$StyledMinimized, {
        ref: ref,
        isItalic: !summaryValue,
        transitionClass: className
    }, selectedIssueType?.iconUrl && projectType !== (0, $ln6Iy.SERVICE_DESK_PROJECT) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($63225a137d0d3e7a$var$TitleContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($63225a137d0d3e7a$var$IconContainer, {
        "data-testid": "issue-create.ui.modal.modal-wrapper.minimizable-modal-minimized.issue-type-icon"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bQyn2.default), {
        width: 16,
        url: selectedIssueType?.iconUrl
    })), parseSummaryValue(summaryValue, selectedIssueType?.label)) : parseSummaryValue(summaryValue, selectedIssueType?.label)));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $63225a137d0d3e7a$var$IconContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2hwxpxbi _1e0c116y",
            __cmplp.className
        ])
    });
});
const $63225a137d0d3e7a$var$TitleContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $63225a137d0d3e7a$var$StyledMinimized = /*#__PURE__*/ (0, $cdbP5.default)((0, $kwvP4.Minimized)).attrs({
    // @ts-expect-error - TS2339 - Property 'transitionClass' does not exist on type 'ThemedStyledProps<HTMLElement & RefAttributes<MinimizedContainerProps>, any>'.
    className: (props)=>props.transitionClass
}).withConfig({
    componentId: "sc-1pohfgc-0"
})``;

});

parcelRegister("iylOl", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6bfd201cd82f270$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $2qG7I = parcelRequire("2qG7I");
var $5a9Ro = parcelRequire("5a9Ro");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $epTsa = parcelRequire("epTsa");

var $lRq8t = parcelRequire("lRq8t");

var $jQUoP = parcelRequire("jQUoP");

var $5IfL0 = parcelRequire("5IfL0");

var $jipjz = parcelRequire("jipjz");

var $fYeTG = parcelRequire("fYeTG");

var $6XJko = parcelRequire("6XJko");

var $6u3jg = parcelRequire("6u3jg");

var $bl3Xz = parcelRequire("bl3Xz");

var $2d7M3 = parcelRequire("2d7M3");

var $gWkkD = parcelRequire("gWkkD");

var $95o1r = parcelRequire("95o1r");

var $6x1Qe = parcelRequire("6x1Qe");

var $aqlMQ = parcelRequire("aqlMQ");
const $f6bfd201cd82f270$export$a9dbcd01d58b1c3b = ({ shouldShowChangerSpotlight: shouldShowChangerSpotlight, dismissModalEntryPointWrapper: dismissModalEntryPointWrapper, watchersConfigurations: watchersConfigurations })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [{ title: title, isSubTaskCreationOpen: isSubTaskCreationOpen, isCreateLinkedIssue: isCreateLinkedIssue }] = (0, $jipjz.useTriggerIssueCreateModal)();
    const [{ dataFetchError: dataFetchError, selectedProject: selectedProject, selectedIssueType: selectedIssueType }] = (0, $jQUoP.useFormContext)();
    const issueType = selectedIssueType?.label;
    let titleMsg = issueType && (0, $epTsa.expVal)('jira-itr-work-type-exp-1', 'isEnabled', false) ? (0, $6x1Qe.default).titleIssueTerminologyRefreshM4 : (0, $6x1Qe.default).title;
    if (isSubTaskCreationOpen) titleMsg = (0, $6x1Qe.default).subtaskTitle;
    else if (isCreateLinkedIssue) titleMsg = (0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $6x1Qe.default).createLinkedIssueDialogTitleIssueTermRefresh : (0, $6x1Qe.default).createLinkedIssueDialogTitle;
    const shouldShowChangerSpotlightBoolean = !!shouldShowChangerSpotlight;
    const ViewChangerContainer = shouldShowChangerSpotlightBoolean ? (0, $aqlMQ.SpotlightContainer) : undefined;
    const shouldDisableMeatBallActions = dataFetchError !== null || selectedProject === null;
    const meatBallMenu = !(0, $fYeTG.isMobileAndInMvpOrExistingUsersExperiment)() && (0, $6XJko.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2d7M3.HeaderDropdown), {
        isDisabled: shouldDisableMeatBallActions,
        watchersConfigurations: watchersConfigurations
    }) : null;
    (0, $gWkkD.useDefaultWatchers)({
        configs: watchersConfigurations
    });
    return(// eslint-disable-next-line jira/react/no-empty-divs
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5IfL0.ModalHeader), {
        ViewChangerContainer: ViewChangerContainer,
        dismissModalEntryPointWrapper: dismissModalEntryPointWrapper,
        meatBallMenu: meatBallMenu,
        project: selectedProject || undefined
    }, title !== null && title !== '' ? title : formatMessage(titleMsg, {
        issueType: issueType
    }))));
};
const $f6bfd201cd82f270$var$OldHeader = ({ shouldDisableActions: shouldDisableActions, watchersConfigurations: watchersConfigurations })=>{
    const [{ selectedProject: selectedProject, selectedIssueType: selectedIssueType }] = (0, $jQUoP.useFormContext)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [{ title: title, isSubTaskCreationOpen: isSubTaskCreationOpen, isCreateLinkedIssue: isCreateLinkedIssue }] = (0, $jipjz.useTriggerIssueCreateModal)();
    const issueType = selectedIssueType?.label;
    let titleMsg = issueType && (0, $epTsa.expVal)('jira-itr-work-type-exp-1', 'isEnabled', false) ? (0, $6x1Qe.default).titleIssueTerminologyRefreshM4 : (0, $6x1Qe.default).title;
    const shouldDisableHeaderDropdown = ()=>Boolean(shouldDisableActions || selectedProject === null);
    if (isSubTaskCreationOpen) titleMsg = (0, $6x1Qe.default).subtaskTitle;
    else if (isCreateLinkedIssue) titleMsg = (0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $6x1Qe.default).createLinkedIssueDialogTitleIssueTermRefresh : (0, $6x1Qe.default).createLinkedIssueDialogTitle;
    return(// eslint-disable-next-line jira/react/no-empty-divs
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2qG7I.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5a9Ro.default), null, title !== null && title !== '' ? title : formatMessage(titleMsg, {
        issueType: issueType
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f6bfd201cd82f270$var$ActionsContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bl3Xz.default), {
        configs: watchersConfigurations
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $f6bfd201cd82f270$var$dropdownContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $95o1r.default), {
        isDisabled: shouldDisableHeaderDropdown()
    }))))));
};
const $f6bfd201cd82f270$export$8b251419efc915eb = (props)=>{
    const isGICPositioningEnabled = (0, $6u3jg.useIsGICPositioningEnabled)();
    if (isGICPositioningEnabled()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f6bfd201cd82f270$export$a9dbcd01d58b1c3b, {
        shouldShowChangerSpotlight: props.shouldShowChangerSpotlight,
        dismissModalEntryPointWrapper: props.dismissModalEntryPointWrapper,
        watchersConfigurations: props.watchersConfigurations
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f6bfd201cd82f270$var$OldHeader, props);
};
var $f6bfd201cd82f270$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $f6bfd201cd82f270$export$8b251419efc915eb;
const $f6bfd201cd82f270$var$ActionsContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_18u01wug _1e0c1txw",
            __cmplp.className
        ])
    });
});
const $f6bfd201cd82f270$var$dropdownContainerStyles = (0, $1DXK0.xcss)({
    marginLeft: 'space.100'
});

});
parcelRegister("gWkkD", function(module, exports) {

$parcel$export(module.exports, "useDefaultWatchers", () => $6352e7f3597a75ec$export$bb175b6e43fa210);

var $eJOHy = parcelRequire("eJOHy");

var $3MbOI = parcelRequire("3MbOI");

var $jQUoP = parcelRequire("jQUoP");


var $6XJko = parcelRequire("6XJko");

var $7jTnu = parcelRequire("7jTnu");
const $6352e7f3597a75ec$export$bb175b6e43fa210 = ({ configs: configs })=>{
    const { isAutoWatchEnabled: isAutoWatchEnabled } = configs || {};
    const [{ watchers: watchers, selectedProject: selectedProject }, { setWatchers: setWatchers }] = (0, $jQUoP.useFormContext)();
    const { data: { user: currentUser }, loading: loading, error: error } = (0, $3MbOI.useCurrentUser)(); // eslint-disable-line @typescript-eslint/consistent-type-assertions
    const shouldShowWatchers = selectedProject && configs && !currentUser.isAnonymous;
    !loading && !error && // NOTE: JPD has no ability to manage watchers at the time of release, this is a workaround to prevent watchers being added for JPD.
    selectedProject?.projectType;
    (0, $eJOHy.useEffect)(()=>{
        if (!(0, $7jTnu.fg)('default_watchers_issue_create')) return;
        if (!(0, $6XJko.isVisualRefreshEnabled)()) return;
        if (isAutoWatchEnabled && shouldShowWatchers && currentUser && watchers.length === 0) setWatchers([
            currentUser
        ]);
    }, [
        currentUser,
        isAutoWatchEnabled,
        setWatchers,
        watchers.length,
        shouldShowWatchers
    ]);
};

});

parcelRegister("95o1r", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0ab41c404ea320d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $7rjYb = parcelRequire("7rjYb");
var $jYYbf = parcelRequire("jYYbf");
var $aLJ1L = parcelRequire("aLJ1L");

var $aMdh8 = parcelRequire("aMdh8");

var $lRq8t = parcelRequire("lRq8t");

var $5PjYq = parcelRequire("5PjYq");

var $jQUoP = parcelRequire("jQUoP");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $gZTP9 = parcelRequire("gZTP9");

var $3ZX73 = parcelRequire("3ZX73");
const $e0ab41c404ea320d$var$HeaderDropdown = (props)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const isAdmin = (0, $gZTP9.useIsAdmin)();
    const { isDisabled: isDisabled = false } = props;
    const [{ selectedProject: selectedProject, selectedIssueType: selectedIssueType }, { toggleConfigureFieldsModalVisibility: toggleConfigureFieldsModalVisibility, toggleFindFieldsModalVisibility: toggleFindFieldsModalVisibility }] = (0, $jQUoP.useFormContext)();
    const showConfigureFieldsModal = ()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        toggleConfigureFieldsModalVisibility(true);
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'configureFields', {
            projectType: selectedProject ? (0, $5PjYq.transformProjectType)(selectedProject.projectType) : 'none'
        });
    };
    const showFindFieldModal = ()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        toggleFindFieldsModalVisibility(true);
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'findYourField', {
            projectType: selectedProject ? (0, $5PjYq.transformProjectType)(selectedProject.projectType) : 'none'
        });
    };
    const showFindFieldOption = ()=>Boolean(isAdmin && selectedProject && selectedIssueType && !selectedProject.isSimplified);
    // @ts-expect-error - TS7006 - Parameter 'attributes' implicitly has an 'any' type.
    const onOpenChange = (attributes)=>{
        if (attributes.isOpen) {
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button'
            });
            (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'meatballMenu');
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7rjYb.default), {
        placement: "bottom-end",
        trigger: ({ triggerRef: triggerRef, ...dropdownProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                ...dropdownProps,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aMdh8))), {
                    spacing: "spacious",
                    label: "more"
                }),
                appearance: "subtle",
                ref: triggerRef,
                isDisabled: isDisabled
            }),
        onOpenChange: onOpenChange
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aLJ1L.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
        onClick: showConfigureFieldsModal
    }, formatMessage((0, $3ZX73.default).showFields)), showFindFieldOption() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
        onClick: showFindFieldModal
    }, formatMessage((0, $3ZX73.default).findField))));
};
var $e0ab41c404ea320d$export$2e2bcd8739ae039 = $e0ab41c404ea320d$var$HeaderDropdown;

});
parcelRegister("3ZX73", function(module, exports) {

$parcel$export(module.exports, "default", () => $e63dd434cf6bef09$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $e63dd434cf6bef09$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    showFields: {
        "id": "issue-create.modal.modal-wrapper.minimizable-modal-modal.header.dropdown-menu.show-fields",
        "defaultMessage": "Show fields"
    },
    findField: {
        "id": "issue-create.modal.modal-wrapper.minimizable-modal-modal.header.dropdown-menu.find-field",
        "defaultMessage": "Find your field"
    }
});

});


parcelRegister("6x1Qe", function(module, exports) {

$parcel$export(module.exports, "default", () => $49b41e123077d612$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $49b41e123077d612$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    title: {
        "id": "issue-create.modal.modal-wrapper.minimizable-modal-modal.header.title",
        "defaultMessage": "Create"
    },
    titleIssueTerminologyRefreshM4: {
        "id": "issue-create.modal.modal-wrapper.minimizable-modal-modal.header.title-issue-terminology-refresh-m4",
        "defaultMessage": "Create {issueType}"
    },
    subtaskTitle: {
        "id": "issue-create.modal.modal-wrapper.minimizable-modal-modal.header.subtask-title",
        "defaultMessage": "Create subtask"
    },
    createLinkedIssueDialogTitle: {
        "id": "issue-create.modal.modal-wrapper.minimizable-modal-modal.header.create-linked-issue-dialog-title",
        "defaultMessage": "Create linked issue"
    },
    changerButtonsDisabledForgeFields: {
        "id": "issue-create.modal.modal-wrapper.minimizable-modal-modal.header.changer-buttons-disabled-forge-fields",
        "defaultMessage": "Some fields in this project and issue type don\u2019t allow resizing or minimizing"
    },
    createLinkedIssueDialogTitleIssueTermRefresh: {
        "id": "issue-create.modal.modal-wrapper.minimizable-modal-modal.header.create-linked-issue-dialog-title-issue-term-refresh",
        "defaultMessage": "Create linked work item"
    },
    changerButtonsDisabledForgeFieldsIssueTermRefresh: {
        "id": "issue-create.modal.modal-wrapper.minimizable-modal-modal.header.changer-buttons-disabled-forge-fields-issue-term-refresh",
        "defaultMessage": "Some fields in this project and work type don\u2019t allow resizing or minimizing"
    }
});

});

parcelRegister("aqlMQ", function(module, exports) {

$parcel$export(module.exports, "SpotlightContainer", () => $c4fa0afa6122a30c$export$d0f55839b708c0a0);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $3l2IB = parcelRequire("3l2IB");

var $epTsa = parcelRequire("epTsa");

var $lRq8t = parcelRequire("lRq8t");

var $bSiPa = parcelRequire("bSiPa");
const $c4fa0afa6122a30c$export$d0f55839b708c0a0 = ({ children: children })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    /**
   * Atlaskit Popup was not used due to technical limitations of the component in this particular use case.
   * onClose is triggered when the popup is controlled by focussing, which causes the popup to immediately close.
   */ return /*#__PURE__*/ $eJOHy.createElement("div", {
        "data-testid": "issue-create.ui.modal.modal-wrapper.minimizable-modal-modal.header.spotlight-container.wrapper",
        className: (0, $hcewu.default)([
            $c4fa0afa6122a30c$var$styles.spotlightContainerWrapper
        ])
    }, children, /*#__PURE__*/ $eJOHy.createElement("div", {
        className: (0, $hcewu.default)([
            $c4fa0afa6122a30c$var$styles.spotlightPopoverWrapper
        ])
    }, /*#__PURE__*/ $eJOHy.createElement((0, $3l2IB.default), {
        width: 275
    }, formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $bSiPa.default).resizeSpotlightMessageIssueTermRefresh : (0, $bSiPa.default).resizeSpotlightMessage))));
};
const $c4fa0afa6122a30c$var$styles = {
    spotlightPopoverWrapper: "_kqswstnw _19pk12x7 _1xi21i6y _1pby1fw0",
    spotlightContainerWrapper: "_kqswh2mm"
};

});


parcelRegister("2WvWo", function(module, exports) {

$parcel$export(module.exports, "MinimizableModalModal", () => $1374a3d44080b341$export$8b041304f822d4d4);

var $eJOHy = parcelRequire("eJOHy");

var $ik0CA = parcelRequire("ik0CA");

var $1F8hV = parcelRequire("1F8hV");

var $ixdDB = parcelRequire("ixdDB");

var $jQUoP = parcelRequire("jQUoP");

var $fIw44 = parcelRequire("fIw44");

var $j8z2z = parcelRequire("j8z2z");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $cnV9A = parcelRequire("cnV9A");

var $73XNv = parcelRequire("73XNv");

var $iylOl = parcelRequire("iylOl");
const $1374a3d44080b341$var$HeaderComponent = ()=>{
    const { shouldShowChangerSpotlight: shouldShowChangerSpotlight, dismissModalEntryPointWrapper: dismissModalEntryPointWrapper, watchersConfigurations: watchersConfigurations } = (0, $73XNv.useMinimizableModalWrapperProps)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iylOl.default), {
        shouldDisableActions: false,
        shouldShowChangerSpotlight: shouldShowChangerSpotlight,
        dismissModalEntryPointWrapper: dismissModalEntryPointWrapper,
        watchersConfigurations: watchersConfigurations
    });
};
const $1374a3d44080b341$var$ModalBodyNext = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ik0CA.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        id: (0, $ixdDB.ISSUE_CREATE_MODAL_BODY_SELECTOR),
        ref: ref,
        ...props
    })));
const $1374a3d44080b341$var$FooterComponent = ()=>{
    const { onModalCloseWithConfirm: onModalCloseWithConfirm, onSubmit: onSubmit, isSubmitting: isSubmitting, isOperationInProgress: isOperationInProgress, canCreateAnotherIssue: canCreateAnotherIssue, onCreateAnotherChange: onCreateAnotherChange, getShouldDisableSubmit: getShouldDisableSubmit, createdIssues: createdIssues, displayCreateAnotherIssueToggle: displayCreateAnotherIssueToggle, showIssuesCreated: showIssuesCreated, dismissModalEntryPointWrapper: dismissModalEntryPointWrapper } = (0, $73XNv.useMinimizableModalWrapperProps)();
    const shouldDisableSubmit = getShouldDisableSubmit();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cnV9A.default), {
        onClose: onModalCloseWithConfirm('cancel'),
        onSubmit: onSubmit,
        isSubmitting: isSubmitting,
        isOperationInProgress: isOperationInProgress,
        canCreateAnotherIssue: canCreateAnotherIssue,
        onCreateAnotherChange: onCreateAnotherChange,
        shouldDisableSubmit: shouldDisableSubmit,
        createdIssues: createdIssues,
        displayCreateAnotherIssueToggle: displayCreateAnotherIssueToggle,
        showIssuesCreated: showIssuesCreated,
        dismissModalEntryPointWrapper: dismissModalEntryPointWrapper
    });
};
const $1374a3d44080b341$export$8b041304f822d4d4 = ({ 'data-testid': dataTestId, children: children })=>{
    const [{ isFormDirty: isFormDirty, ecosystem: { forge: { hasFinishedLoading: hasFinishedLoading } } }] = (0, $jQUoP.useFormContext)();
    const uiModificationsStatus = (0, $1F8hV.useUiModificationsEnabledStatus)(hasFinishedLoading);
    const { setView: setView, shouldDisableViewChangerButtons: shouldDisableViewChangerButtons, onClose: onClose } = (0, $fIw44.useMinimizableModal)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const onModalCloseOverride = (0, $eJOHy.useCallback)((event, analyticsEvent)=>{
        const isEscapePress = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        event?.key === 'Escape' || // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        event?.key === 'Esc' || // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        event?.keyCode === 27;
        const isBlanketClick = !isEscapePress; // Assume it is a blanket click if it isn't an esc event
        if (isBlanketClick && (!hasFinishedLoading || uiModificationsStatus !== 'disabled')) return;
        if (isBlanketClick || isFormDirty) {
            setView('mini');
            const dockAnalyticsEvent = createAnalyticsEvent({
                action: 'docked',
                actionSubject: 'modalDialog'
            });
            (0, $gCeeo.fireUIAnalytics)(dockAnalyticsEvent, 'modalDialog docked', {
                isBlanketClick: isBlanketClick
            });
        } else onClose?.(event, analyticsEvent);
    }, [
        createAnalyticsEvent,
        hasFinishedLoading,
        isFormDirty,
        onClose,
        setView,
        uiModificationsStatus
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j8z2z.Modal), {
        "data-testid": dataTestId,
        components: {
            Header: $1374a3d44080b341$var$HeaderComponent,
            Footer: $1374a3d44080b341$var$FooterComponent,
            // @ts-expect-error - TS2322 - Type 'ForwardRefExoticComponent<RefAttributes<unknown>>' is not assignable to type 'ComponentType<ModalBodyProps> | undefined'.
            Body: $1374a3d44080b341$var$ModalBodyNext
        },
        onClose: !shouldDisableViewChangerButtons ? onModalCloseOverride : undefined,
        shouldCloseOnOverlayClick: !shouldDisableViewChangerButtons
    }, children);
};

});

parcelRegister("3AqDe", function(module, exports) {

$parcel$export(module.exports, "useSetSummary", () => $c70e3035f67493c4$export$2e036b125a865e82);

var $eJOHy = parcelRequire("eJOHy");

var $jPROM = parcelRequire("jPROM");

var $xMjNG = parcelRequire("xMjNG");

var $4PKlm = parcelRequire("4PKlm");
const $c70e3035f67493c4$export$2e036b125a865e82 = (initialSummaryValue)=>{
    const [summaryValue, setSummary] = (0, $eJOHy.useState)(initialSummaryValue || initialSummaryValue === null ? initialSummaryValue : '');
    const hasSetInitialValue = (0, $eJOHy.useRef)(false);
    if (!hasSetInitialValue.current && !(0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(initialSummaryValue)) {
        hasSetInitialValue.current = true;
        setSummary(initialSummaryValue);
    }
    const { subscribe: subscribe } = (0, $4PKlm.useGICLifeCycleEvents)();
    (0, $eJOHy.useEffect)(()=>{
        subscribe((0, $xMjNG.GIC_LIFECYCLE_EVENTS).CREATE_FORM_FIELD_VALUE_CHANGE, async (data)=>{
            if (data.fieldId === 'summary') setSummary(data.value.toString());
        });
        subscribe((0, $xMjNG.GIC_LIFECYCLE_EVENTS).MODAL_DISCARD_EXISTING_IN_PROGRESS_ISSUE, async ()=>{
            setSummary('');
        });
    }, [
        subscribe,
        setSummary
    ]);
    (0, $eJOHy.useEffect)(()=>subscribe((0, $xMjNG.GIC_LIFECYCLE_EVENTS).ISSUE_CREATE_SUCCESS, async ()=>{
            setSummary('');
        }), [
        subscribe,
        setSummary
    ]);
    return summaryValue;
};

});

parcelRegister("5rEj7", function(module, exports) {

$parcel$export(module.exports, "useViewChangerDisabler", () => $f5dfa032c9f640e6$export$db29ac8670837568);

var $eJOHy = parcelRequire("eJOHy");

var $epTsa = parcelRequire("epTsa");

var $lRq8t = parcelRequire("lRq8t");

var $i7n3g = parcelRequire("i7n3g");
var $1F8hV = parcelRequire("1F8hV");

var $jQUoP = parcelRequire("jQUoP");

var $fIw44 = parcelRequire("fIw44");

var $jipjz = parcelRequire("jipjz");

var $73XNv = parcelRequire("73XNv");

var $dKGvI = parcelRequire("dKGvI");
const $f5dfa032c9f640e6$export$db29ac8670837568 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    // Global opt-out of minimizable modal
    const [{ disableMinimizableModal: disableMinimizableModal }] = (0, $jipjz.useTriggerIssueCreateModal)();
    const { isNestedModal: isNestedModal, shouldDisableViewChangerButtons: shouldDisableViewChangerButtons, setShouldDisableViewChangerButtons: setShouldDisableViewChangerButtons, setView: setView, view: view } = (0, $fIw44.useMinimizableModal)();
    const [{ ecosystem: { forge: { hasFinishedLoading: hasFinishedLoading } } }] = (0, $jQUoP.useFormContext)();
    const adjustmentsAreEnabled = (0, $i7n3g.useAdjustmentsEnabled)();
    const uiModificationsStatus = (0, $1F8hV.useUiModificationsEnabledStatus)(hasFinishedLoading);
    const { setShouldRestore: setShouldRestore } = (0, $73XNv.useMinimizableModalWrapperProps)();
    const disableViewChangerButtonsHandler = (0, $eJOHy.useCallback)((disableViewChangerButtons, customDisabledViewChangerButtonsMessage)=>{
        setShouldDisableViewChangerButtons(disableViewChangerButtons, customDisabledViewChangerButtonsMessage);
        setShouldRestore?.(!disableViewChangerButtons);
    }, [
        setShouldDisableViewChangerButtons,
        setShouldRestore
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (disableMinimizableModal || isNestedModal) disableViewChangerButtonsHandler(true);
        else if (uiModificationsStatus === 'enabled' || adjustmentsAreEnabled) disableViewChangerButtonsHandler(true, formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $dKGvI.default).changerButtonsDisabledForgeFieldsIssueTermRefresh : (0, $dKGvI.default).changerButtonsDisabledForgeFields));
        else disableViewChangerButtonsHandler(false);
    }, [
        adjustmentsAreEnabled,
        disableMinimizableModal,
        disableViewChangerButtonsHandler,
        formatMessage,
        isNestedModal,
        setShouldDisableViewChangerButtons,
        uiModificationsStatus
    ]);
    (0, $eJOHy.useEffect)(()=>{
        /*
              force setView to modal view is disabled for the full screen since there will be no transitions allowed from the view.
              this will help us enable the UIM flow in the full screen view as well.
          */ if (view === 'fullscreen') return;
        if (shouldDisableViewChangerButtons) setView('modal', true);
    }, [
        setView,
        view,
        shouldDisableViewChangerButtons
    ]);
};

});
parcelRegister("dKGvI", function(module, exports) {

$parcel$export(module.exports, "default", () => $61f90b364361d922$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $61f90b364361d922$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    changerButtonsDisabledForgeFields: {
        "id": "issue-create.modal.modal-wrapper.use-view-changer-disabler.changer-buttons-disabled-forge-fields",
        "defaultMessage": "Some fields in this project and issue type don\u2019t allow resizing or minimizing"
    },
    changerButtonsDisabledForgeFieldsIssueTermRefresh: {
        "id": "issue-create.modal.modal-wrapper.use-view-changer-disabler.changer-buttons-disabled-forge-fields-issue-term-refresh",
        "defaultMessage": "Some fields in this project and work type don\u2019t allow resizing or minimizing"
    }
});

});



parcelRegister("jldA8", function(module, exports) {

$parcel$export(module.exports, "NavigateWithoutRestorePrompt", () => $67f08ccafc1a92a0$export$f92d4f53cfa676ca);

var $eJOHy = parcelRequire("eJOHy");

var $jQUoP = parcelRequire("jQUoP");

var $83DiZ = parcelRequire("83DiZ");

var $8Ltc3 = parcelRequire("8Ltc3");

var $5mlja = parcelRequire("5mlja");
const $67f08ccafc1a92a0$export$f92d4f53cfa676ca = ({ setShouldRestore: setShouldRestore, isNavigationDiscardFeatureEnabled: isNavigationDiscardFeatureEnabled = false })=>{
    const [{ deferredNavigationLink: deferredNavigationLink }, { setDeferredNavigationLink: setDeferredNavigationLink }] = (0, $5mlja.useNavigationDiscardChanges)();
    const [{ isFormDirty: isFormDirty }] = (0, $jQUoP.useFormContext)();
    const { push: push } = (0, $83DiZ.useRouterActions)();
    const onConfirmHandler = (0, $eJOHy.useCallback)(()=>{
        setShouldRestore && setShouldRestore(false);
    }, [
        setShouldRestore
    ]);
    const onCancelHandler = (0, $eJOHy.useCallback)(()=>{
        setDeferredNavigationLink('');
    }, [
        setDeferredNavigationLink
    ]);
    // If the form is then we navigate immediately without showing the prompt
    (0, $eJOHy.useEffect)(()=>{
        if (deferredNavigationLink && !isFormDirty) {
            setShouldRestore && setShouldRestore(false);
            push(deferredNavigationLink);
            setDeferredNavigationLink('');
        }
    }, [
        deferredNavigationLink,
        isFormDirty,
        push,
        setDeferredNavigationLink,
        setShouldRestore
    ]);
    if (!isNavigationDiscardFeatureEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Ltc3.NavigationDiscardChangesPrompt), {
        navigateLink: isFormDirty ? deferredNavigationLink : '',
        onConfirm: onConfirmHandler,
        onCancel: onCancelHandler
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null);
};

});

parcelRegister("ibQsy", function(module, exports) {

$parcel$export(module.exports, "default", () => $32718d67de54821e$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $Hyi04 = parcelRequire("Hyi04");


var $epTsa = parcelRequire("epTsa");

var $22c3C = parcelRequire("22c3C");
var $hrodw = parcelRequire("hrodw");
var $bILK0 = parcelRequire("bILK0");

var $lRq8t = parcelRequire("lRq8t");

var $1CdfO = parcelRequire("1CdfO");

var $m2eL4 = parcelRequire("m2eL4");


var $5ddsi = parcelRequire("5ddsi");
const $32718d67de54821e$export$93bd4963a1d00fd5 = (props)=>{
    const { flagKey: flagKey, id: id, issueList: issueList, issueDiscoveryUrl: issueDiscoveryUrl, successFlagParams: successFlagParams } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { dismissFlag: dismissFlag } = (0, $bILK0.useFlagsService)();
    const issueType = issueList[0].issueType;
    const getDynamicFlagType = ()=>{
        if (successFlagParams) {
            const { isRankable: isRankable, isWorkMode: isWorkMode, canManageSprints: canManageSprints, boardType: boardType } = successFlagParams;
            if (isRankable && isWorkMode) {
                if (boardType === (0, $26a3e969ef4db377$export$4498412e32a31fb6) && canManageSprints) return 0, $1f39b704bd4e1e17$export$407f3b8bfd90ad8d;
                if (boardType === (0, $26a3e969ef4db377$export$b4e9cdb19cfa0abb)) return 0, $1f39b704bd4e1e17$export$256b368007db542a;
            }
        }
        return 0, $1f39b704bd4e1e17$export$858ff9c1b12e1d84;
    };
    const getDefaultFlagTitle = ()=>{
        const areMultipleIssuesCreated = issueList.length > 1;
        const successTitle = ()=>{
            if (issueType && (0, $epTsa.expVal)('jira-itr-work-type-exp-1', 'isEnabled', false)) return (0, $5ddsi.default).createSuccessFlagTitleIssueTerminologyRefreshM4;
            return (0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5ddsi.default).createSuccessFlagTitleIssueTermRefresh : (0, $5ddsi.default).createSuccessFlagTitle;
        };
        return areMultipleIssuesCreated ? formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5ddsi.default).multiplesIssuesCreatedSuccessFlagTitleIssueTermRefresh : (0, $5ddsi.default).multiplesIssuesCreatedSuccessFlagTitle, {
            issueCount: issueList.length
        }) : formatMessage(successTitle(), {
            issueKey: issueList[0].issueKey,
            issueType: issueType
        });
    };
    const FlagConfigs = {
        Default: ()=>({
                flagTitle: getDefaultFlagTitle(),
                flagDescription: '',
                flagActions: (0, $m2eL4.getDefaultFlagActions)({
                    issueList: issueList,
                    issueDiscoveryUrl: issueDiscoveryUrl
                })
            }),
        IssuesNotInSprint: (issuesWithNoSprint, issuesExcludingEpics, sprints)=>({
                flagTitle: formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5ddsi.default).issueCreatedNoSprintOrInBacklogSuccessFlagTitleIssueTermRefresh : (0, $5ddsi.default).issueCreatedNoSprintOrInBacklogSuccessFlagTitle, {
                    issueCount: issuesExcludingEpics.length
                }),
                flagDescription: formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5ddsi.default).issueCreatedNoSprintSuccessFlagDescriptionIssueTermRefresh : (0, $5ddsi.default).issueCreatedNoSprintSuccessFlagDescription, {
                    issueKey: issuesWithNoSprint[0].issueKey,
                    issueCount: issuesExcludingEpics.length
                }),
                flagActions: (0, $m2eL4.getNewScrumIssuesWithNoSprintsActions)({
                    issueList: issueList,
                    issueDiscoveryUrl: issueDiscoveryUrl,
                    issuesWithNoSprint: issuesWithNoSprint,
                    sprints: sprints
                })
            }),
        IssuesNotInSprintMoreThanTwoActiveSprints: (issuesWithNoSprint, issuesExcludingEpics)=>({
                flagTitle: formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5ddsi.default).issueCreatedNoSprintOrInBacklogSuccessFlagTitleIssueTermRefresh : (0, $5ddsi.default).issueCreatedNoSprintOrInBacklogSuccessFlagTitle, {
                    issueCount: issuesExcludingEpics.length
                }),
                flagDescription: formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5ddsi.default).issueCreatedNoSprintSuccessFlagDescriptionIssueTermRefresh : (0, $5ddsi.default).issueCreatedNoSprintSuccessFlagDescription, {
                    issueKey: issuesWithNoSprint[0].issueKey,
                    issueCount: issuesExcludingEpics.length
                }),
                flagActions: (0, $m2eL4.getDefaultFlagActions)({
                    issueList: issueList,
                    issueDiscoveryUrl: issueDiscoveryUrl
                })
            }),
        MultipleIssuesSomeNoSprint: ()=>({
                flagTitle: formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5ddsi.default).multiplesIssuesCreatedSomeNoSprintSuccessFlagTitleIssueTermRefresh : (0, $5ddsi.default).multiplesIssuesCreatedSomeNoSprintSuccessFlagTitle),
                flagDescription: formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5ddsi.default).multiplesIssuesCreatedSomeNoSprintSuccessFlagDescriptionIssueTermRefresh : (0, $5ddsi.default).multiplesIssuesCreatedSomeNoSprintSuccessFlagDescription),
                flagActions: (0, $m2eL4.getDefaultFlagActions)({
                    issueList: issueList,
                    issueDiscoveryUrl: issueDiscoveryUrl
                })
            }),
        HiddenScrumIssues: (issues, isFiltered)=>({
                flagTitle: formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5ddsi.default).createdHiddenIssueSuccessFlagTitleIssueTermRefresh : (0, $5ddsi.default).createdHiddenIssueSuccessFlagTitle, {
                    issueCount: issues.length
                }),
                flagDescription: formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5ddsi.default).scrumCreatedHiddenIssueSuccessFlagDescriptionIssueTermRefresh : (0, $5ddsi.default).scrumCreatedHiddenIssueSuccessFlagDescription, {
                    issueCount: issues.length
                }),
                flagActions: (0, $m2eL4.getHiddenIssuesActions)({
                    issueList: issueList,
                    issueDiscoveryUrl: issueDiscoveryUrl,
                    isFiltered: isFiltered
                })
            }),
        IssuesInBacklog: (issues)=>({
                flagTitle: formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5ddsi.default).issueCreatedNoSprintOrInBacklogSuccessFlagTitleIssueTermRefresh : (0, $5ddsi.default).issueCreatedNoSprintOrInBacklogSuccessFlagTitle, {
                    issueCount: issues.length
                }),
                flagDescription: formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5ddsi.default).issueCreatedInBacklogSuccessFlagDescriptionIssueTermRefresh : (0, $5ddsi.default).issueCreatedInBacklogSuccessFlagDescription, {
                    issueKey: issues[0].issueKey,
                    issueCount: issues.length
                }),
                flagActions: (0, $m2eL4.getDefaultFlagActions)({
                    issueList: issueList,
                    issueDiscoveryUrl: issueDiscoveryUrl
                })
            }),
        MultipleIssuesSomeInBacklog: ()=>({
                flagTitle: formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5ddsi.default).multiplesIssuesCreatedSomeInBacklogSuccessFlagTitleIssueTermRefresh : (0, $5ddsi.default).multiplesIssuesCreatedSomeInBacklogSuccessFlagTitle),
                flagDescription: formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5ddsi.default).multiplesIssuesCreatedSomeInBacklogSuccessFlagDescriptionIssueTermRefresh : (0, $5ddsi.default).multiplesIssuesCreatedSomeInBacklogSuccessFlagDescription),
                flagActions: (0, $m2eL4.getDefaultFlagActions)({
                    issueList: issueList,
                    issueDiscoveryUrl: issueDiscoveryUrl
                })
            }),
        HiddenKanbanIssues: (issues, isFiltered)=>({
                flagTitle: formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5ddsi.default).createdHiddenIssueSuccessFlagTitleIssueTermRefresh : (0, $5ddsi.default).createdHiddenIssueSuccessFlagTitle, {
                    issueCount: issues.length
                }),
                flagDescription: formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5ddsi.default).kanbanCreatedHiddenIssueSuccessFlagDescriptionIssueTermRefresh : (0, $5ddsi.default).kanbanCreatedHiddenIssueSuccessFlagDescription, {
                    issueCount: issues.length
                }),
                flagActions: (0, $m2eL4.getHiddenIssuesActions)({
                    issueList: issueList,
                    issueDiscoveryUrl: issueDiscoveryUrl,
                    isFiltered: isFiltered
                })
            })
    };
    const getFlagContent = ()=>{
        if (successFlagParams) {
            if (getDynamicFlagType() === (0, $1f39b704bd4e1e17$export$407f3b8bfd90ad8d)) {
                const { issues: issues, isFiltered: isFiltered, invalidIssuesKeys: invalidIssuesKeys, issuesWithNoSprint: issuesWithNoSprint, issuesExcludingEpics: issuesExcludingEpics, sprints: sprints } = successFlagParams;
                if (issuesWithNoSprint.length > 0) {
                    if (issuesWithNoSprint.length === issuesExcludingEpics.length) {
                        if (sprints.length > 2) return FlagConfigs.IssuesNotInSprintMoreThanTwoActiveSprints(issuesWithNoSprint, issuesExcludingEpics);
                        return FlagConfigs.IssuesNotInSprint(issuesWithNoSprint, issuesExcludingEpics, sprints);
                    }
                    return FlagConfigs.MultipleIssuesSomeNoSprint();
                }
                if (invalidIssuesKeys.length > 0) return FlagConfigs.HiddenScrumIssues(issues, isFiltered);
            } else if (getDynamicFlagType() === (0, $1f39b704bd4e1e17$export$256b368007db542a)) {
                const { kanbanIssuesInBacklog: kanbanIssuesInBacklog, invalidIssuesKeys: invalidIssuesKeys, issues: issues, isFiltered: isFiltered } = successFlagParams;
                if (kanbanIssuesInBacklog.length > 0) {
                    if (kanbanIssuesInBacklog.length === issues.length) return FlagConfigs.IssuesInBacklog(issues);
                    return FlagConfigs.MultipleIssuesSomeInBacklog();
                }
                if (invalidIssuesKeys.length > 0) return FlagConfigs.HiddenKanbanIssues(issues, isFiltered);
            }
        }
        return FlagConfigs.Default();
    };
    const { flagTitle: flagTitle, flagDescription: flagDescription, flagActions: flagActions } = getFlagContent();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-issue-key": issueList.map((issue)=>issue.issueKey).join(','),
        "data-testid": (0, $1f39b704bd4e1e17$export$2e4c8b336846b593)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $22c3C.default), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($Hyi04))), {
            spacing: "spacious",
            color: "var(--ds-icon-success, #22A06B)",
            label: "Success"
        }),
        id: (0, $hrodw.fromFlagId)(id),
        key: flagKey,
        title: flagTitle,
        description: flagDescription,
        actions: flagActions,
        onDismissed: ()=>{
            dismissFlag(id);
        },
        messageId: `issue-create.ui.modal.success-flag.ak-flag.${id}`,
        messageType: "transactional"
    }));
};
const $32718d67de54821e$var$SuccessFlagWithContext = (props)=>{
    const { id: id } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1CdfO.AddToSprintActionStatesContainer), {
        scope: id.valueOf(),
        key: id.valueOf()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($32718d67de54821e$export$93bd4963a1d00fd5, props));
};
var $32718d67de54821e$export$2e2bcd8739ae039 = $32718d67de54821e$var$SuccessFlagWithContext;

});
// Backend types
const $26a3e969ef4db377$export$9a958daafd9a03ed = 'agility-board';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $26a3e969ef4db377$var$CORE_BOARD = 'core-board';
const $26a3e969ef4db377$export$b4e9cdb19cfa0abb = 'kanban';
const $26a3e969ef4db377$export$4498412e32a31fb6 = 'scrum';

parcelRegister("1CdfO", function(module, exports) {

$parcel$export(module.exports, "AddToSprintActionStatesContainer", () => $5ba6e4c7a5fc16dc$export$4ae31d89b87a513);
$parcel$export(module.exports, "useAddToSprintFlagActionStateController", () => $5ba6e4c7a5fc16dc$export$dc7fffa2c4559368);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $5ba6e4c7a5fc16dc$var$initialState = {
    addToSprintCTAsEnabled: true
};
const $5ba6e4c7a5fc16dc$var$actions = {
    disableOtherAddToSprintCTAs: ()=>({ setState: setState })=>{
            setState({
                addToSprintCTAsEnabled: false
            });
        }
};
const $5ba6e4c7a5fc16dc$var$Store = (0, $GtRbT.createStore)({
    initialState: $5ba6e4c7a5fc16dc$var$initialState,
    actions: $5ba6e4c7a5fc16dc$var$actions,
    name: 'SuccessFlagAddToSprintActionStateController'
});
const $5ba6e4c7a5fc16dc$export$4ae31d89b87a513 = (0, $6E16M.createContainer)($5ba6e4c7a5fc16dc$var$Store);
const $5ba6e4c7a5fc16dc$export$dc7fffa2c4559368 = (0, $iJq0l.createHook)($5ba6e4c7a5fc16dc$var$Store);

});

parcelRegister("m2eL4", function(module, exports) {

$parcel$export(module.exports, "getDefaultFlagActions", () => $6721f9cbb1d879cb$export$6de10317e135f24);
$parcel$export(module.exports, "getNewScrumIssuesWithNoSprintsActions", () => $6721f9cbb1d879cb$export$882355824d3fc905);
$parcel$export(module.exports, "getHiddenIssuesActions", () => $6721f9cbb1d879cb$export$f5c2849658ba2a03);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eDBhy = parcelRequire("eDBhy");

var $epTsa = parcelRequire("epTsa");

var $dTocu = parcelRequire("dTocu");

var $bVObd = parcelRequire("bVObd");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $zF9L8 = parcelRequire("zF9L8");

var $1CdfO = parcelRequire("1CdfO");


var $fY0Nc = parcelRequire("fY0Nc");
const $6721f9cbb1d879cb$export$f2011725fe81878a = (issueList, issueDiscoveryUrl)=>{
    const { formatMessage: formatMessage } = (0, $dTocu.useIntlV2)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const fireViewIssueAnalyticsEvent = (0, $eJOHy.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link'
        });
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, (0, $5a6210241e29c567$export$71ce489a3b20fc93), {
            isNewGIC: true
        });
    }, [
        createAnalyticsEvent
    ]);
    const issueType = issueList[0].issueType;
    const getContent = ()=>{
        if (issueType && (0, $zF9L8.isWorkTypeAvgLength)(issueType) && (0, $epTsa.expVal)('jira-itr-work-type-exp-1', 'isEnabled', false)) return (0, $fY0Nc.default).viewIssueCtaIssueTerminologyRefreshM4;
        return (0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $fY0Nc.default).viewIssueCtaIssueTermRefresh : (0, $fY0Nc.default).viewIssueCta;
    };
    return {
        content: formatMessage(getContent(), {
            issueCount: issueList.length,
            issueType: issueType
        }),
        href: issueDiscoveryUrl,
        onClick: fireViewIssueAnalyticsEvent
    };
};
const $6721f9cbb1d879cb$var$CopyLinkCta = (issueDiscoveryUrl)=>{
    const { formatMessage: formatMessage } = (0, $dTocu.useIntlV2)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [isCopied, setCopied] = (0, $eJOHy.useState)(false);
    (0, $eJOHy.useEffect)(()=>{
        let timeoutId;
        if (isCopied) timeoutId = setTimeout(()=>{
            setCopied(false);
        }, 2000);
        return ()=>{
            timeoutId && clearTimeout(timeoutId);
        };
    }, [
        isCopied
    ]);
    const copyToClipboard = (0, $eJOHy.useCallback)(async ()=>{
        try {
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'link'
            });
            await globalThis.navigator.clipboard.writeText(`${globalThis.location.origin}${issueDiscoveryUrl}`);
            setCopied(true);
            (0, $gCeeo.fireUIAnalytics)(analyticsEvent, (0, $5a6210241e29c567$export$3a43d61edae693a9)); // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $eDBhy.fireIssueCreateErrorAnalytics)({
                error: error,
                meta: {
                    id: 'copyToClipboard',
                    packageName: 'jiraIssueCreate'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
    }, [
        createAnalyticsEvent,
        issueDiscoveryUrl
    ]);
    return {
        content: isCopied ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6721f9cbb1d879cb$var$ActionSuccess, null, formatMessage((0, $fY0Nc.default).linkCopied)) : formatMessage((0, $fY0Nc.default).copyLinkCta),
        onClick: copyToClipboard
    };
};
const $6721f9cbb1d879cb$var$ClearFiltersCta = ()=>{
    const { formatMessage: formatMessage } = (0, $dTocu.useIntlV2)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(false);
    const [isCompleted, setIsCompleted] = (0, $eJOHy.useState)(false);
    const clearFiltersAction = (0, $eJOHy.useCallback)(()=>{
        (0, $bVObd.successFlagClearFiltersAction).start();
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link'
        });
        const { GH: GH } = window;
        setIsLoading(true);
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, (0, $5a6210241e29c567$export$bc715896f18417a3), {
            isNewGIC: true
        });
        GH.WorkController.clearFilters().done(()=>{
            (0, $bVObd.successFlagClearFiltersAction).stop();
            setIsCompleted(true);
            setIsLoading(false);
        }).fail(()=>{
            (0, $bVObd.successFlagClearFiltersAction).stop();
            (0, $eDBhy.fireIssueCreateErrorAnalytics)({
                meta: {
                    id: 'clearFilters',
                    packageName: 'jiraIssueCreate'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        });
    }, [
        createAnalyticsEvent
    ]);
    if (isLoading) return {
        content: formatMessage((0, $fY0Nc.default).clearFiltersCtaLoading)
    };
    if (isCompleted) return {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6721f9cbb1d879cb$var$ActionSuccess, null, formatMessage((0, $fY0Nc.default).clearFiltersCtaCompleted))
    };
    return {
        content: formatMessage((0, $fY0Nc.default).clearFiltersCta),
        onClick: clearFiltersAction
    };
};
const $6721f9cbb1d879cb$export$54ce82bbc60a8f6e = (issuesWithNoSprint, totalCreatedIssuesCount, sprint)=>{
    const { formatMessage: formatMessage } = (0, $dTocu.useIntlV2)();
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(false);
    const [isCompleted, setIsCompleted] = (0, $eJOHy.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [{ addToSprintCTAsEnabled: addToSprintCTAsEnabled }, { disableOtherAddToSprintCTAs: disableOtherAddToSprintCTAs }] = (0, $1CdfO.useAddToSprintFlagActionStateController)();
    const addToSprintAction = (0, $eJOHy.useCallback)(()=>{
        (0, $bVObd.successFlagAddToSprintAction).start();
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link'
        });
        const { GH: GH } = window;
        disableOtherAddToSprintCTAs();
        setIsLoading(true);
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, (0, $5a6210241e29c567$export$31bef7c6ffa89efa), {
            isNewGIC: true
        });
        GH.WorkController.addNewIssuesToSprintFromJFE(sprint, issuesWithNoSprint).done(()=>{
            (0, $bVObd.successFlagAddToSprintAction).stop();
            setIsCompleted(true);
            setIsLoading(false);
        }).fail(()=>{
            (0, $bVObd.successFlagAddToSprintAction).stop();
            (0, $eDBhy.fireIssueCreateErrorAnalytics)({
                meta: {
                    id: 'addToSprint',
                    packageName: 'jiraIssueCreate'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        });
    }, [
        createAnalyticsEvent,
        sprint,
        issuesWithNoSprint,
        disableOtherAddToSprintCTAs
    ]);
    if (isLoading) return [
        {
            content: formatMessage((0, $fY0Nc.default).addIssuesToSprintCtaLoading)
        }
    ];
    if (isCompleted) return [
        {
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6721f9cbb1d879cb$var$ActionSuccess, null, formatMessage((0, $fY0Nc.default).addIssuesToSprintCtaCompleted))
        }
    ];
    if (addToSprintCTAsEnabled) return [
        {
            content: formatMessage((0, $fY0Nc.default).addAllIssuesToSprintCta, {
                sprintName: sprint.name
            }),
            onClick: addToSprintAction
        }
    ];
    return [];
};
const $6721f9cbb1d879cb$var$getAddToSprintsCtas = (issuesWithNoSprint, issueList, sprints)=>{
    const editableSprints = sprints.filter((sprint)=>sprint.canUpdateSprint);
    const totalCreatedIssuesCount = issueList.length;
    let ctaList = [];
    editableSprints.forEach((sprint)=>{
        ctaList = ctaList.concat($6721f9cbb1d879cb$export$54ce82bbc60a8f6e(issuesWithNoSprint, totalCreatedIssuesCount, sprint));
    });
    return ctaList;
};
const $6721f9cbb1d879cb$export$6de10317e135f24 = ({ issueList: issueList, issueDiscoveryUrl: issueDiscoveryUrl })=>[
        $6721f9cbb1d879cb$export$f2011725fe81878a(issueList, issueDiscoveryUrl),
        $6721f9cbb1d879cb$var$CopyLinkCta(issueDiscoveryUrl)
    ];
const $6721f9cbb1d879cb$export$882355824d3fc905 = ({ issueList: issueList, issueDiscoveryUrl: issueDiscoveryUrl, issuesWithNoSprint: issuesWithNoSprint, sprints: sprints })=>{
    const ctaList = $6721f9cbb1d879cb$var$getAddToSprintsCtas(issuesWithNoSprint, issueList, sprints);
    ctaList.push($6721f9cbb1d879cb$export$f2011725fe81878a(issueList, issueDiscoveryUrl));
    return ctaList;
};
const $6721f9cbb1d879cb$export$f5c2849658ba2a03 = ({ issueList: issueList, issueDiscoveryUrl: issueDiscoveryUrl, isFiltered: isFiltered })=>{
    const ctaList = [
        $6721f9cbb1d879cb$export$f2011725fe81878a(issueList, issueDiscoveryUrl)
    ];
    if (isFiltered) ctaList.push($6721f9cbb1d879cb$var$ClearFiltersCta());
    return ctaList;
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6721f9cbb1d879cb$var$ActionSuccess = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_syazy73q",
            __cmplp.className
        ])
    });
});

});
parcelRegister("zF9L8", function(module, exports) {

$parcel$export(module.exports, "isWorkTypeAvgLength", () => $68d226678b5dc1ce$export$cc4247ae0afa23ac);
const $68d226678b5dc1ce$var$WORK_TYPE_AVG_LENGTH = 30;
const $68d226678b5dc1ce$export$cc4247ae0afa23ac = (workType)=>workType.length < $68d226678b5dc1ce$var$WORK_TYPE_AVG_LENGTH;

});

const $5a6210241e29c567$export$71ce489a3b20fc93 = 'viewIssues';
const $5a6210241e29c567$export$3a43d61edae693a9 = 'copyLink';
const $5a6210241e29c567$export$31bef7c6ffa89efa = 'addToSprint';
const $5a6210241e29c567$export$bc715896f18417a3 = 'clearFilters';

parcelRegister("fY0Nc", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ac5bd071736413f$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $3ac5bd071736413f$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    viewIssueCta: {
        "id": "issue-create.modal.success-flag.actions.view-issue-cta",
        "defaultMessage": "View {issueCount, plural, one {issue} other {issues}}"
    },
    copyLinkCta: {
        "id": "issue-create.modal.success-flag.actions.copy-link-cta",
        "defaultMessage": "Copy link"
    },
    linkCopied: {
        "id": "issue-create.modal.success-flag.actions.link-copied",
        "defaultMessage": "Copied"
    },
    addAllIssuesToSprintCta: {
        "id": "issue-create.modal.success-flag.actions.add-all-issues-to-sprint-cta",
        "defaultMessage": "Add to {sprintName}"
    },
    clearFiltersCta: {
        "id": "issue-create.modal.success-flag.actions.clear-filters-cta",
        "defaultMessage": "Clear filters"
    },
    clearFiltersCtaLoading: {
        "id": "issue-create.modal.success-flag.actions.clear-filters-cta-loading",
        "defaultMessage": "Clearing..."
    },
    clearFiltersCtaCompleted: {
        "id": "issue-create.modal.success-flag.actions.clear-filters-cta-completed",
        "defaultMessage": "Filters cleared"
    },
    addIssuesToSprintCtaLoading: {
        "id": "issue-create.modal.success-flag.actions.add-issues-to-sprint-cta-loading",
        "defaultMessage": "Adding..."
    },
    addIssuesToSprintCtaCompleted: {
        "id": "issue-create.modal.success-flag.actions.add-issues-to-sprint-cta-completed",
        "defaultMessage": "Added to sprint"
    },
    viewIssueCtaIssueTermRefresh: {
        "id": "issue-create.modal.success-flag.actions.view-issue-cta-issue-term-refresh",
        "defaultMessage": "View{issueCount, plural, one {} other { work items}}"
    },
    viewIssueCtaIssueTerminologyRefreshM4: {
        "id": "issue-create.modal.success-flag.actions.view-issue-cta-issue-terminology-refresh-m4",
        "defaultMessage": "View{issueCount, plural, one { {issueType}} other { work items}}"
    }
});

});


const $1f39b704bd4e1e17$export$2e4c8b336846b593 = 'jira-issue-create.modal.create-form.success-flag';
const $1f39b704bd4e1e17$export$407f3b8bfd90ad8d = 'cmp-scrum-flag';
const $1f39b704bd4e1e17$export$256b368007db542a = 'cmp-kanban-flag';
const $1f39b704bd4e1e17$export$858ff9c1b12e1d84 = 'default-success-flag';

parcelRegister("5ddsi", function(module, exports) {

$parcel$export(module.exports, "default", () => $cdc601f48fda8478$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $cdc601f48fda8478$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    createSuccessFlagTitle: {
        "id": "issue-create.modal.success-flag.create-success-flag-title",
        "defaultMessage": "You've created \"{issueKey}\" issue"
    },
    multiplesIssuesCreatedSuccessFlagTitle: {
        "id": "issue-create.modal.success-flag.multiples-issues-created-success-flag-title",
        "defaultMessage": "You've created {issueCount, plural, one {# issue} other {# issues}}"
    },
    issueCreatedNoSprintOrInBacklogSuccessFlagTitle: {
        "id": "issue-create.modal.success-flag.issue-created-no-sprint-or-in-backlog-success-flag-title",
        "defaultMessage": "{issueCount, plural, one {Issue} other {Issues}} added to the backlog"
    },
    issueCreatedNoSprintSuccessFlagDescription: {
        "id": "issue-create.modal.success-flag.issue-created-no-sprint-success-flag-description",
        "defaultMessage": "{issueCount, plural, one {Your issue {issueKey} has} other {Your issues have}} been created and added to the backlog."
    },
    multiplesIssuesCreatedSomeNoSprintSuccessFlagTitle: {
        "id": "issue-create.modal.success-flag.multiples-issues-created-some-no-sprint-success-flag-title",
        "defaultMessage": "Issues added to sprint(s) and backlog"
    },
    multiplesIssuesCreatedSomeNoSprintSuccessFlagDescription: {
        "id": "issue-create.modal.success-flag.multiples-issues-created-some-no-sprint-success-flag-description",
        "defaultMessage": "Some of your issues weren't added to a sprint."
    },
    createdHiddenIssueSuccessFlagTitle: {
        "id": "issue-create.modal.success-flag.created-hidden-issue-success-flag-title",
        "defaultMessage": "{issueCount, plural, one {Issue} other {Issues}} created but not visible"
    },
    scrumCreatedHiddenIssueSuccessFlagDescription: {
        "id": "issue-create.modal.success-flag.scrum-created-hidden-issue-success-flag-description",
        "defaultMessage": "{issueCount, plural, one {If the board has active filters, or the issue was added to a different sprint, it may not be visible} other {If the board has active filters, or the issues were added to a different sprint, they may not be visible}}."
    },
    issueCreatedInBacklogSuccessFlagDescription: {
        "id": "issue-create.modal.success-flag.issue-created-in-backlog-success-flag-description",
        "defaultMessage": "{issueCount, plural, one {Your issue {issueKey} has been created, but isn't on the board} other {Your issues have been created, but aren't on the board}}."
    },
    multiplesIssuesCreatedSomeInBacklogSuccessFlagTitle: {
        "id": "issue-create.modal.success-flag.multiples-issues-created-some-in-backlog-success-flag-title",
        "defaultMessage": "Issues added to board and backlog"
    },
    multiplesIssuesCreatedSomeInBacklogSuccessFlagDescription: {
        "id": "issue-create.modal.success-flag.multiples-issues-created-some-in-backlog-success-flag-description",
        "defaultMessage": "Your issues have been created, but some aren't on the board."
    },
    kanbanCreatedHiddenIssueSuccessFlagDescription: {
        "id": "issue-create.modal.success-flag.kanban-created-hidden-issue-success-flag-description",
        "defaultMessage": "{issueCount, plural, one {If the board has active filters, or the issue wasn't added to the board, it may not be visible} other {If the board has active filters, or the issues weren't added to the board, they may not be visible}}."
    },
    createSuccessFlagTitleIssueTermRefresh: {
        "id": "issue-create.modal.success-flag.create-success-flag-title-issue-term-refresh",
        "defaultMessage": "You've created \"{issueKey}\" work item"
    },
    multiplesIssuesCreatedSuccessFlagTitleIssueTermRefresh: {
        "id": "issue-create.modal.success-flag.multiples-issues-created-success-flag-title-issue-term-refresh",
        "defaultMessage": "You've created {issueCount, plural, one {# work item} other {# work items}}"
    },
    issueCreatedNoSprintOrInBacklogSuccessFlagTitleIssueTermRefresh: {
        "id": "issue-create.modal.success-flag.issue-created-no-sprint-or-in-backlog-success-flag-title-issue-term-refresh",
        "defaultMessage": "{issueCount, plural, one {Work item} other {Work items}} added to the backlog"
    },
    issueCreatedNoSprintSuccessFlagDescriptionIssueTermRefresh: {
        "id": "issue-create.modal.success-flag.issue-created-no-sprint-success-flag-description-issue-term-refresh",
        "defaultMessage": "{issueCount, plural, one {Your work item {issueKey} has} other {Your work items have}} been created and added to the backlog."
    },
    multiplesIssuesCreatedSomeNoSprintSuccessFlagTitleIssueTermRefresh: {
        "id": "issue-create.modal.success-flag.multiples-issues-created-some-no-sprint-success-flag-title-issue-term-refresh",
        "defaultMessage": "Work items added to sprint(s) and backlog"
    },
    multiplesIssuesCreatedSomeNoSprintSuccessFlagDescriptionIssueTermRefresh: {
        "id": "issue-create.modal.success-flag.multiples-issues-created-some-no-sprint-success-flag-description-issue-term-refresh",
        "defaultMessage": "Some of your work items weren't added to a sprint."
    },
    createdHiddenIssueSuccessFlagTitleIssueTermRefresh: {
        "id": "issue-create.modal.success-flag.created-hidden-issue-success-flag-title-issue-term-refresh",
        "defaultMessage": "{issueCount, plural, one {Work item} other {Work items}} created but not visible"
    },
    scrumCreatedHiddenIssueSuccessFlagDescriptionIssueTermRefresh: {
        "id": "issue-create.modal.success-flag.scrum-created-hidden-issue-success-flag-description-issue-term-refresh",
        "defaultMessage": "{issueCount, plural, one {If the board has active filters, or the work item was added to a different sprint, it may not be visible} other {If the board has active filters, or the work items were added to a different sprint, they may not be visible}}."
    },
    issueCreatedInBacklogSuccessFlagDescriptionIssueTermRefresh: {
        "id": "issue-create.modal.success-flag.issue-created-in-backlog-success-flag-description-issue-term-refresh",
        "defaultMessage": "{issueCount, plural, one {Your work item {issueKey} has been created, but isn't on the board} other {Your work items have been created, but aren't on the board}}."
    },
    multiplesIssuesCreatedSomeInBacklogSuccessFlagTitleIssueTermRefresh: {
        "id": "issue-create.modal.success-flag.multiples-issues-created-some-in-backlog-success-flag-title-issue-term-refresh",
        "defaultMessage": "Work items added to board and backlog"
    },
    multiplesIssuesCreatedSomeInBacklogSuccessFlagDescriptionIssueTermRefresh: {
        "id": "issue-create.modal.success-flag.multiples-issues-created-some-in-backlog-success-flag-description-issue-term-refresh",
        "defaultMessage": "Your work items have been created, but some aren't on the board."
    },
    kanbanCreatedHiddenIssueSuccessFlagDescriptionIssueTermRefresh: {
        "id": "issue-create.modal.success-flag.kanban-created-hidden-issue-success-flag-description-issue-term-refresh",
        "defaultMessage": "{issueCount, plural, one {If the board has active filters, or the work item wasn't added to the board, it may not be visible} other {If the board has active filters, or the work items weren't added to the board, they may not be visible}}."
    },
    createSuccessFlagTitleIssueTerminologyRefreshM4: {
        "id": "issue-create.modal.create-form.create-success-flag-title-issue-terminology-refresh-m4",
        "defaultMessage": "Created {issueType} {issueKey}"
    }
});

});


parcelRegister("7caPf", function(module, exports) {

$parcel$export(module.exports, "getFirstFieldIdWithError", () => $734e3b5798127e52$export$f15841b83bf0d927);
$parcel$export(module.exports, "publishCreatedIssues", () => $734e3b5798127e52$export$d46eb3aee2ce61a5);
$parcel$export(module.exports, "getTabIndexWithError", () => $734e3b5798127e52$export$1d81ee131c803e88);
$parcel$export(module.exports, "getWatchersFlagConfigFromResponse", () => $734e3b5798127e52$export$47ea475ac70a5697);

var $8dH3d = parcelRequire("8dH3d");

var $9g7yh = parcelRequire("9g7yh");

var $2QTvK = parcelRequire("2QTvK");

var $eDBhy = parcelRequire("eDBhy");

var $epTsa = parcelRequire("epTsa");

var $jGzN3 = parcelRequire("jGzN3");

var $3UrQk = parcelRequire("3UrQk");

var $xMjNG = parcelRequire("xMjNG");

var $7jTnu = parcelRequire("7jTnu");

var $6uEdF = parcelRequire("6uEdF");

var $bOgHx = parcelRequire("bOgHx");
const $734e3b5798127e52$export$3a8abc058f5d3f89 = '/rest/api/3/search/jql';
const $734e3b5798127e52$export$8d7a103b266a4496 = '/rest/api/3/search';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let $734e3b5798127e52$var$issueDataTillNow = {};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $734e3b5798127e52$var$issueIdsTillNow = {};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let $734e3b5798127e52$var$activePromises = {};
const $734e3b5798127e52$var$postMessageToConsumers = (createdIssues, triggerPointKey)=>{
    if (triggerPointKey === 'issue-create-embed-trigger') // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.parent?.postMessage({
        event: 'jiraIssueCreate.sessionComplete',
        payload: createdIssues,
        triggerPointKey: triggerPointKey
    }, '*');
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.postMessage({
        event: 'jiraIssueCreate.sessionComplete',
        payload: createdIssues,
        triggerPointKey: triggerPointKey
    }, '*');
};
const $734e3b5798127e52$export$f15841b83bf0d927 = ({ fields: fields, emptyRequiredFields: emptyRequiredFields })=>{
    if (emptyRequiredFields) return fields.find((fieldId)=>{
        if (emptyRequiredFields.includes(fieldId)) return true;
        // handling multi input field errors separately because it contains different error keys
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly worklog: readonly ["worklog_adjustmentAmount", "worklog_adjustEstimate", "worklog_activate", "worklog_timeLogged", "worklog_newEstimate", "worklog_startDate", "worklog_description"]; readonly issuelinks: readonly [...]; }'.
        if ((0, $3UrQk.MULTI_INPUT_FIELDS_ERROR_KEYS)[fieldId]) return emptyRequiredFields.some((key)=>// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly worklog: readonly ["worklog_adjustmentAmount", "worklog_adjustEstimate", "worklog_activate", "worklog_timeLogged", "worklog_newEstimate", "worklog_startDate", "worklog_description"]; readonly issuelinks: readonly [...]; }'.
            (0, $3UrQk.MULTI_INPUT_FIELDS_ERROR_KEYS)[fieldId].includes(key));
        return false;
    });
    return undefined;
};
const $734e3b5798127e52$var$fetchIssueListPromise = (jql, fieldsToAddInPublishedData, fetchAllFields, issueIdsToReconcileOn)=>{
    if ($734e3b5798127e52$var$activePromises[jql] === undefined) {
        if ((0, $7jTnu.fg)('replace_deprecated_issue_search_api')) {
            if (fetchAllFields) $734e3b5798127e52$var$activePromises[jql] = (0, $jGzN3.performPostRequest)($734e3b5798127e52$export$3a8abc058f5d3f89, {
                body: JSON.stringify({
                    jql: jql,
                    fields: [
                        ...new Set([
                            '*all'
                        ])
                    ],
                    reconcileIssues: issueIdsToReconcileOn
                })
            });
            else $734e3b5798127e52$var$activePromises[jql] = (0, $jGzN3.performPostRequest)($734e3b5798127e52$export$3a8abc058f5d3f89, {
                body: JSON.stringify({
                    jql: jql,
                    fields: [
                        ...new Set([
                            'summary',
                            'status',
                            'assignee',
                            'duedate',
                            'project',
                            'issuetype',
                            'priority',
                            'issuelinks',
                            ...fieldsToAddInPublishedData
                        ])
                    ],
                    reconcileIssues: issueIdsToReconcileOn
                })
            });
        } else if (fetchAllFields) $734e3b5798127e52$var$activePromises[jql] = (0, $jGzN3.performPostRequest)($734e3b5798127e52$export$8d7a103b266a4496, {
            body: JSON.stringify({
                jql: jql,
                fields: [
                    ...new Set([
                        '*all'
                    ])
                ]
            })
        });
        else $734e3b5798127e52$var$activePromises[jql] = (0, $jGzN3.performPostRequest)($734e3b5798127e52$export$8d7a103b266a4496, {
            body: JSON.stringify({
                jql: jql,
                fields: [
                    ...new Set([
                        'summary',
                        'status',
                        'assignee',
                        'duedate',
                        'project',
                        'issuetype',
                        'priority',
                        'issuelinks',
                        ...fieldsToAddInPublishedData
                    ])
                ]
            })
        });
    }
    return $734e3b5798127e52$var$activePromises[jql];
};
const $734e3b5798127e52$var$getIssueList = async (createdIssues, fieldsToAddInPublishedData, fetchAllFields)=>{
    // Get list of issues that have not been fetched before
    const issuesToFetch = createdIssues.filter(({ issueKey: issueKey })=>!$734e3b5798127e52$var$issueDataTillNow[issueKey]);
    const issueIdsToFetch = createdIssues.filter(({ issueId: issueId })=>!$734e3b5798127e52$var$issueIdsTillNow[issueId]);
    let newIssueDetails = {
        issues: []
    };
    if (issuesToFetch.length) {
        // API call is made only if there are issues that needs to be fetched
        const jql = issuesToFetch.reduce((jqlQuery, { issueKey: issueKey }, index)=>`${jqlQuery}issuekey=${issueKey}${index !== issuesToFetch.length - 1 ? ' OR ' : ''}`, '');
        const issueIdsToReconcileOn = issueIdsToFetch.map(({ issueId: issueId })=>issueId) // Extract the issueId from each object
        .filter((issueId)=>Number.isInteger(issueId)); // Check if the issueId is an integer
        try {
            newIssueDetails = await $734e3b5798127e52$var$fetchIssueListPromise(jql, fieldsToAddInPublishedData, fetchAllFields, issueIdsToReconcileOn);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $eDBhy.fireIssueCreateErrorAnalytics)({
                meta: {
                    id: 'getIssueList',
                    packageName: 'jiraIssueCreate',
                    teamName: 'gryffindor'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            $734e3b5798127e52$var$activePromises[jql] = undefined;
        }
    }
    const prefetchedIssueDetails = createdIssues.filter(({ issueKey: issueKey })=>$734e3b5798127e52$var$issueDataTillNow[issueKey]).map(({ issueKey: issueKey })=>$734e3b5798127e52$var$issueDataTillNow[issueKey].createdIssueDetails);
    return {
        issues: [
            ...prefetchedIssueDetails,
            ...newIssueDetails.issues
        ]
    };
};
const $734e3b5798127e52$var$merge = (obj, obj2)=>({
        ...obj,
        ...obj2
    });
const $734e3b5798127e52$export$d46eb3aee2ce61a5 = async ({ createdIssues: createdIssues, globalEventNamespaces: globalEventNamespaces = [
    (0, $3UrQk.GLOBAL_EVENT_NAMESPACE)
], fieldsToAddInPublishedData: fieldsToAddInPublishedData = [], alertsToBeLinked: alertsToBeLinked = [], isSessionComplete: isSessionComplete = false, onIssueCreate: onIssueCreate, siteDomain: siteDomain, selectedCloudId: selectedCloudId, onClose: onClose, triggerPointKey: triggerPointKey, publishGICLifecycle: publishGICLifecycle, isIssueCreateSuccess: isIssueCreateSuccess, callbackPayload: callbackPayload, jqlSwimlaneId: jqlSwimlaneId, ecosystemCallback: ecosystemCallback }, fireErrorAnalytics = (0, $eDBhy.fireIssueCreateErrorAnalytics))=>{
    let fetchAllFields = false;
    if (ecosystemCallback && ecosystemCallback.callbackFunction) fetchAllFields = true;
    if (createdIssues.length) {
        /**
		 * We need to unregister the SPA global issue create event handlers so that new issue create can use its
		 * default ones which render the success and error flag in a different place
		 */ let oldFlagUnbindSuccess = false;
        try {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.require('jira/common/header').unbind();
            oldFlagUnbindSuccess = true;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            oldFlagUnbindSuccess = false;
        }
        try {
            const issueSearchRequest = $734e3b5798127e52$var$getIssueList(createdIssues, fieldsToAddInPublishedData, fetchAllFields);
            const [issueList, Events] = await Promise.all([
                issueSearchRequest,
                (0, $2QTvK.apiReady)()
            ]);
            const issueData = (0, (/*@__PURE__*/$parcel$interopDefault($9g7yh)))(issueList.issues, 'key');
            const createdIssuesWithIssueData = createdIssues.map((createdIssue)=>{
                const createdIssueDetails = issueData[createdIssue.issueKey];
                const summary = createdIssueDetails?.fields?.summary;
                return {
                    ...createdIssue,
                    summary: summary,
                    createdIssueDetails: createdIssueDetails,
                    selectedCloudId: selectedCloudId,
                    jqlSwimlaneId: jqlSwimlaneId
                };
            });
            $734e3b5798127e52$var$issueDataTillNow = $734e3b5798127e52$var$merge($734e3b5798127e52$var$issueDataTillNow, (0, (/*@__PURE__*/$parcel$interopDefault($9g7yh)))(createdIssuesWithIssueData, 'issueKey'));
            if (isIssueCreateSuccess) // ideally createdIssuesWithIssueData will contain a single element
            createdIssuesWithIssueData.forEach((createdIssue)=>{
                onIssueCreate?.(siteDomain ? {
                    ...createdIssue,
                    siteDomain: siteDomain
                } : createdIssue, alertsToBeLinked);
                publishGICLifecycle?.((0, $xMjNG.GIC_LIFECYCLE_EVENTS).ISSUE_CREATE_SUCCESS, {
                    createdIssueData: createdIssue,
                    callbackPayload: callbackPayload
                });
            });
            if (isSessionComplete) {
                if (fetchAllFields) (0, $6uEdF.executeEcosystemAPICallback)(ecosystemCallback, createdIssuesWithIssueData);
                $734e3b5798127e52$var$postMessageToConsumers(createdIssuesWithIssueData, triggerPointKey);
                if ((0, $7jTnu.fg)('stop_polli_fails_due_to_load_bridge')) onClose?.(createdIssuesWithIssueData);
                globalEventNamespaces.forEach((namespace)=>{
                    if (triggerPointKey !== undefined) Events?.trigger?.(`${namespace}.sessionComplete`, [
                        createdIssuesWithIssueData,
                        triggerPointKey
                    ]);
                    else Events?.trigger?.(`${namespace}.sessionComplete`, [
                        createdIssuesWithIssueData
                    ]);
                });
                if (!(0, $7jTnu.fg)('stop_polli_fails_due_to_load_bridge')) onClose?.(createdIssuesWithIssueData);
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            fireErrorAnalytics({
                meta: {
                    id: 'publishCreatedIssues',
                    packageName: 'jiraIssueCreate',
                    teamName: 'gryffindor'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
        if (isSessionComplete) {
            $734e3b5798127e52$var$issueDataTillNow = {};
            $734e3b5798127e52$var$activePromises = {};
        }
        /**
		 * On cleanup we need to re-register the legacy issue create event handlers which will override the
		 * allow non-migrated triggers to show flag
		 */ if (oldFlagUnbindSuccess && isSessionComplete) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.require('jira/common/header').initialize();
    } else if (isSessionComplete) {
        if (fetchAllFields) (0, $6uEdF.executeEcosystemAPICallback)(ecosystemCallback, []);
        onClose && onClose([]);
    }
};
const $734e3b5798127e52$export$1d81ee131c803e88 = (fieldTabs, fieldValues, requiredFieldsData)=>{
    if (!fieldValues) return -1;
    const emptyRequiredField = Object.keys(fieldValues)?.find((id)=>requiredFieldsData[id] && Boolean(requiredFieldsData[id].isRequired) && fieldValues && (0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(fieldValues[id]));
    const tabIndex = fieldTabs?.findIndex((tab)=>tab.items.find((item)=>item === emptyRequiredField));
    return tabIndex > -1 ? tabIndex : -1;
};
const $734e3b5798127e52$export$47ea475ac70a5697 = (response, issueKey, issueType)=>{
    if (response?.errorCollection && response.errorCollection.errorMessages[0]) return {
        type: 'error',
        title: (0, $bOgHx.default).watchersErrorFlagTitle,
        description: response.errorCollection.errorMessages[0],
        messageId: 'issue-create.ui.modal.flag.error.error.watchers-error',
        messageType: 'transactional'
    };
    const getTitle = ()=>{
        if (issueType && (0, $epTsa.expVal)('jira-itr-work-type-exp-1', 'isEnabled', false)) return (0, $bOgHx.default).watchersWarningFlagTitleIssueTerminologyRefreshM4;
        if ((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false)) return (0, $bOgHx.default).watchersWarningFlagTitleIssueTermRefresh;
        return (0, $bOgHx.default).watchersWarningFlagTitle;
    };
    if (response?.warningCollection && response?.warningCollection.warnings[0]) return {
        type: 'warning',
        title: [
            getTitle(),
            {
                issueKey: issueKey,
                issueType: issueType
            }
        ],
        description: response.warningCollection.warnings[0],
        messageId: 'issue-create.ui.modal.flag.warning.warning.watchers-warning',
        messageType: 'transactional'
    };
    return undefined;
};

});
parcelRegister("9g7yh", function(module, exports) {

var $iBJlb = parcelRequire("iBJlb");

var $a9KaZ = parcelRequire("a9KaZ");
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the last element responsible for generating the key. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * var array = [
 *   { 'dir': 'left', 'code': 97 },
 *   { 'dir': 'right', 'code': 100 }
 * ];
 *
 * _.keyBy(array, function(o) {
 *   return String.fromCharCode(o.code);
 * });
 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
 *
 * _.keyBy(array, 'dir');
 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
 */ var $6bdb775087644ec3$var$keyBy = $a9KaZ(function(result, value, key) {
    $iBJlb(result, key, value);
});
module.exports = $6bdb775087644ec3$var$keyBy;

});

parcelRegister("6uEdF", function(module, exports) {

$parcel$export(module.exports, "executeEcosystemAPICallback", () => $c8a1a2224711e49c$export$352b0ab2ba913578);
/* eslint-disable @typescript-eslint/consistent-type-assertions */ /* eslint-disable @typescript-eslint/no-explicit-any */ 
var $bSMuc = parcelRequire("bSMuc");
const $c8a1a2224711e49c$var$sanitizeIssues = (issuesData)=>{
    const sanitizedIssues = [];
    for (const issueData of issuesData){
        const sanitizedIssue = {
            id: '',
            key: '',
            self: '',
            fields: {}
        };
        const issue = issueData.createdIssueDetails;
        sanitizedIssue.id = issue.id;
        sanitizedIssue.key = issue.key;
        sanitizedIssue.self = issue.self;
        // Convert ADF to Text for all rich text fields
        sanitizedIssue.fields = issue.fields;
        for(const field in sanitizedIssue.fields)if ((0, $bSMuc.isAdfObject)(sanitizedIssue.fields[field])) sanitizedIssue.fields[field] = (0, $bSMuc.convertAdfToWiki)(sanitizedIssue.fields[field]);
        sanitizedIssues.push(sanitizedIssue);
    }
    return sanitizedIssues;
};
const $c8a1a2224711e49c$export$352b0ab2ba913578 = (ecosystemCallback, issuesData)=>{
    if (ecosystemCallback && ecosystemCallback.callbackFunction) {
        const sanitizedIssues = $c8a1a2224711e49c$var$sanitizeIssues(issuesData);
        ecosystemCallback.callbackFunction.call({}, sanitizedIssues);
    }
};

});
parcelRegister("bSMuc", function(module, exports) {

$parcel$export(module.exports, "convertAdfToWiki", () => $d06c7efa8e3cf80d$export$4aa84bff5b13655f);
$parcel$export(module.exports, "isAdfObject", () => $d06c7efa8e3cf80d$export$9acea0de85f3957);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $8DB98 = parcelRequire("8DB98");

var $lovmf = parcelRequire("lovmf");

var $dmYzn = parcelRequire("dmYzn");
const $d06c7efa8e3cf80d$export$4aa84bff5b13655f = (document)=>{
    try {
        const jsonTransformer = new (0, $lovmf.JSONTransformer)();
        const wikiMarkupTransformer = new (0, $dmYzn.WikiMarkupTransformer)((0, $8DB98.defaultSchema));
        if (document === null || document === undefined) return '';
        return wikiMarkupTransformer.encode(jsonTransformer.parse(document));
    } catch (error) {
        // We handle this state by disabling the option to export to markdown.
        return '';
    }
};
const $d06c7efa8e3cf80d$export$9acea0de85f3957 = (field)=>{
    return field && field.type === 'doc' && Array.isArray(field.content);
};

});


parcelRegister("bOgHx", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1d8677712a68534$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $e1d8677712a68534$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    watchersWarningFlagTitle: {
        "id": "issue-create.modal.watchers-warning-flag-title",
        "defaultMessage": "Watchers not added to your issue"
    },
    watchersErrorFlagTitle: {
        "id": "issue-create.modal.watchers-error-flag-title",
        "defaultMessage": "Something went wrong"
    },
    watchersWarningFlagTitleIssueTermRefresh: {
        "id": "issue-create.modal.watchers-warning-flag-title-issue-term-refresh",
        "defaultMessage": "Watchers not added to your work item"
    },
    watchersWarningFlagTitleIssueTerminologyRefreshM4: {
        "id": "issue-create.modal.watchers-warning-flag-title-issue-terminology-refresh-m4",
        "defaultMessage": "Watchers not added to the {issueType} {issueKey}"
    }
});

});





//# sourceMappingURL=async-jira-issue-create.d00616db.js.map
